module.exports = {
	"type": "FeatureCollection",
	"features": [
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.24441619499999,
					28.451472,
					-81.10827338299998,
					28.568668
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.114137,
							28.471621
						],
						[
							-81.11413312699995,
							28.471611943000028
						],
						[
							-81.114069,
							28.471462
						],
						[
							-81.113838,
							28.471253
						],
						[
							-81.113807,
							28.471187
						],
						[
							-81.113832,
							28.471088
						],
						[
							-81.113994,
							28.470895
						],
						[
							-81.114106,
							28.470532
						],
						[
							-81.114242,
							28.470306
						],
						[
							-81.114491,
							28.470031
						],
						[
							-81.114603,
							28.469591
						],
						[
							-81.114808,
							28.469178
						],
						[
							-81.114908,
							28.468804
						],
						[
							-81.114914,
							28.468154
						],
						[
							-81.114933,
							28.468104
						],
						[
							-81.115125,
							28.467604
						],
						[
							-81.115144,
							28.467395
						],
						[
							-81.115044,
							28.466795
						],
						[
							-81.115074,
							28.466464
						],
						[
							-81.115087,
							28.466333
						],
						[
							-81.115149,
							28.466069
						],
						[
							-81.115243,
							28.465876
						],
						[
							-81.115629,
							28.465282
						],
						[
							-81.115647,
							28.465216
						],
						[
							-81.115697,
							28.465194
						],
						[
							-81.115821,
							28.464968
						],
						[
							-81.115843,
							28.464479
						],
						[
							-81.115846,
							28.464423
						],
						[
							-81.115952,
							28.464033
						],
						[
							-81.116107,
							28.463636
						],
						[
							-81.116107,
							28.463438
						],
						[
							-81.115995,
							28.463229
						],
						[
							-81.115877,
							28.463108
						],
						[
							-81.115553,
							28.462921
						],
						[
							-81.115179,
							28.462806000000004
						],
						[
							-81.11506,
							28.462715
						],
						[
							-81.114998,
							28.462668
						],
						[
							-81.11488702899999,
							28.46248764500007
						],
						[
							-81.114786,
							28.461981
						],
						[
							-81.11476274099994,
							28.461964301000023
						],
						[
							-81.11441407299998,
							28.46171397500007
						],
						[
							-81.11435621499999,
							28.46167243600007
						],
						[
							-81.11109258199997,
							28.459329315000048
						],
						[
							-81.11105700699994,
							28.459303774000034
						],
						[
							-81.110886,
							28.459181
						],
						[
							-81.11058662399995,
							28.458815096000023
						],
						[
							-81.11057071799996,
							28.458795655000074
						],
						[
							-81.10929352799997,
							28.457234646000074
						],
						[
							-81.10920961199997,
							28.457132081000054
						],
						[
							-81.109205,
							28.457041
						],
						[
							-81.109435,
							28.456634
						],
						[
							-81.109497,
							28.456474
						],
						[
							-81.109522,
							28.456375
						],
						[
							-81.109497,
							28.456166
						],
						[
							-81.109217,
							28.4556
						],
						[
							-81.109148,
							28.455401
						],
						[
							-81.109123,
							28.455148
						],
						[
							-81.109148,
							28.454664
						],
						[
							-81.109017,
							28.45429
						],
						[
							-81.10878000000001,
							28.45396
						],
						[
							-81.10845761099995,
							28.453610549000075
						],
						[
							-81.10827338299998,
							28.452622418000033
						],
						[
							-81.108474,
							28.452133
						],
						[
							-81.108493,
							28.451874
						],
						[
							-81.108437,
							28.451709
						],
						[
							-81.108313,
							28.451549
						],
						[
							-81.108531,
							28.451549
						],
						[
							-81.109893,
							28.451529
						],
						[
							-81.111255,
							28.451518
						],
						[
							-81.11255100000001,
							28.451517
						],
						[
							-81.112579,
							28.451517
						],
						[
							-81.114047,
							28.451526
						],
						[
							-81.121969,
							28.45157
						],
						[
							-81.121985,
							28.451561
						],
						[
							-81.122133,
							28.451472
						],
						[
							-81.122286,
							28.451474
						],
						[
							-81.125085,
							28.451487
						],
						[
							-81.125919,
							28.451492
						],
						[
							-81.127068,
							28.451501
						],
						[
							-81.13312000000002,
							28.451536
						],
						[
							-81.133942,
							28.45154
						],
						[
							-81.136895,
							28.451557
						],
						[
							-81.137621,
							28.451658
						],
						[
							-81.137856,
							28.45169
						],
						[
							-81.14074,
							28.452093
						],
						[
							-81.141702,
							28.452228
						],
						[
							-81.1417,
							28.452603000000003
						],
						[
							-81.141703,
							28.452732000000005
						],
						[
							-81.141748,
							28.454244
						],
						[
							-81.141763,
							28.454748
						],
						[
							-81.144574,
							28.455083
						],
						[
							-81.149759,
							28.4557
						],
						[
							-81.155287,
							28.456358
						],
						[
							-81.15725,
							28.456592
						],
						[
							-81.157611,
							28.456635
						],
						[
							-81.157404,
							28.456787
						],
						[
							-81.157312,
							28.456844
						],
						[
							-81.157256,
							28.456881
						],
						[
							-81.157204,
							28.45691
						],
						[
							-81.157032,
							28.456985
						],
						[
							-81.156682,
							28.457113
						],
						[
							-81.156297,
							28.457246
						],
						[
							-81.155953,
							28.457367
						],
						[
							-81.15539,
							28.457563000000004
						],
						[
							-81.155257,
							28.457617
						],
						[
							-81.155118,
							28.457674
						],
						[
							-81.15502,
							28.457728
						],
						[
							-81.154929,
							28.457793
						],
						[
							-81.154869,
							28.45785
						],
						[
							-81.154777,
							28.457953
						],
						[
							-81.15426800000002,
							28.458601
						],
						[
							-81.15405,
							28.458885
						],
						[
							-81.153973,
							28.45901
						],
						[
							-81.15391,
							28.45914
						],
						[
							-81.153859,
							28.459281
						],
						[
							-81.15384,
							28.459335
						],
						[
							-81.153798,
							28.459493000000002
						],
						[
							-81.15378,
							28.459607
						],
						[
							-81.153771,
							28.459788
						],
						[
							-81.153772,
							28.46001
						],
						[
							-81.153773,
							28.460206
						],
						[
							-81.153777,
							28.460795
						],
						[
							-81.153779,
							28.460992
						],
						[
							-81.153565,
							28.460997
						],
						[
							-81.153476,
							28.46099
						],
						[
							-81.153388,
							28.460976
						],
						[
							-81.153302,
							28.460953
						],
						[
							-81.152988,
							28.460846
						],
						[
							-81.152877,
							28.460818
						],
						[
							-81.152769,
							28.460797
						],
						[
							-81.152582,
							28.460781
						],
						[
							-81.152466,
							28.460782
						],
						[
							-81.152301,
							28.460797
						],
						[
							-81.152156,
							28.460824
						],
						[
							-81.152061,
							28.460849
						],
						[
							-81.151961,
							28.460882
						],
						[
							-81.152002,
							28.460984
						],
						[
							-81.152095,
							28.461192
						],
						[
							-81.152142,
							28.461327
						],
						[
							-81.152154,
							28.461394
						],
						[
							-81.152155,
							28.461496
						],
						[
							-81.152137,
							28.461608
						],
						[
							-81.152131,
							28.461626
						],
						[
							-81.152103,
							28.461724000000004
						],
						[
							-81.15202000000001,
							28.461925
						],
						[
							-81.151983,
							28.462062
						],
						[
							-81.151969,
							28.462153
						],
						[
							-81.151962,
							28.462289
						],
						[
							-81.15197,
							28.462424
						],
						[
							-81.151992,
							28.462554
						],
						[
							-81.152003,
							28.462597
						],
						[
							-81.152091,
							28.462946
						],
						[
							-81.15212,
							28.463047
						],
						[
							-81.151983,
							28.46308
						],
						[
							-81.151615,
							28.463219000000002
						],
						[
							-81.151523,
							28.46329
						],
						[
							-81.151201,
							28.463537
						],
						[
							-81.150887,
							28.464023
						],
						[
							-81.150676,
							28.464517000000004
						],
						[
							-81.150124,
							28.465483
						],
						[
							-81.149876,
							28.465732000000003
						],
						[
							-81.149613,
							28.465856
						],
						[
							-81.149157,
							28.465934
						],
						[
							-81.148648,
							28.465921
						],
						[
							-81.148357,
							28.465953
						],
						[
							-81.148095,
							28.466118
						],
						[
							-81.148617,
							28.466713
						],
						[
							-81.150027,
							28.46832
						],
						[
							-81.150072,
							28.469315
						],
						[
							-81.149756,
							28.470718
						],
						[
							-81.149484,
							28.472572
						],
						[
							-81.149725,
							28.473128
						],
						[
							-81.150661,
							28.47402
						],
						[
							-81.150751,
							28.474472
						],
						[
							-81.15085,
							28.475304000000005
						],
						[
							-81.150977,
							28.476372
						],
						[
							-81.151022,
							28.476779000000004
						],
						[
							-81.151972,
							28.479132
						],
						[
							-81.152108,
							28.479810000000004
						],
						[
							-81.152063,
							28.480036
						],
						[
							-81.151475,
							28.483429000000005
						],
						[
							-81.15143,
							28.484017
						],
						[
							-81.153058,
							28.489717
						],
						[
							-81.153601,
							28.491029
						],
						[
							-81.154008,
							28.491481
						],
						[
							-81.15731,
							28.492929
						],
						[
							-81.157763,
							28.493653
						],
						[
							-81.158345,
							28.494152000000003
						],
						[
							-81.158353,
							28.494341
						],
						[
							-81.158382,
							28.495036
						],
						[
							-81.15838300000001,
							28.495083000000005
						],
						[
							-81.158851,
							28.495087
						],
						[
							-81.15981,
							28.495089
						],
						[
							-81.159911,
							28.495032
						],
						[
							-81.160296,
							28.494885
						],
						[
							-81.161099,
							28.494207
						],
						[
							-81.161553,
							28.493842
						],
						[
							-81.162255,
							28.493898
						],
						[
							-81.162964,
							28.494004
						],
						[
							-81.163004,
							28.493999
						],
						[
							-81.163039,
							28.493981
						],
						[
							-81.163089,
							28.493932
						],
						[
							-81.163136,
							28.493863
						],
						[
							-81.163158,
							28.49381
						],
						[
							-81.167308,
							28.494116
						],
						[
							-81.171922,
							28.494976
						],
						[
							-81.173368,
							28.495429000000005
						],
						[
							-81.17367800000001,
							28.495526
						],
						[
							-81.174229,
							28.495699
						],
						[
							-81.184769,
							28.495745
						],
						[
							-81.185312,
							28.495519
						],
						[
							-81.187118,
							28.495525
						],
						[
							-81.187141,
							28.495565
						],
						[
							-81.187166,
							28.495589
						],
						[
							-81.18721,
							28.495611
						],
						[
							-81.187263,
							28.495617
						],
						[
							-81.189032,
							28.49559
						],
						[
							-81.190237,
							28.495581000000005
						],
						[
							-81.193158,
							28.495576
						],
						[
							-81.193859,
							28.495566
						],
						[
							-81.194688,
							28.495568
						],
						[
							-81.196422,
							28.495545
						],
						[
							-81.19681800000001,
							28.495533
						],
						[
							-81.197291,
							28.495544
						],
						[
							-81.198549,
							28.495532
						],
						[
							-81.198933,
							28.495536000000005
						],
						[
							-81.19956,
							28.49553
						],
						[
							-81.19977,
							28.495535
						],
						[
							-81.200645,
							28.495543
						],
						[
							-81.200993,
							28.49556
						],
						[
							-81.201368,
							28.495551
						],
						[
							-81.20144500000002,
							28.495537
						],
						[
							-81.201517,
							28.49551
						],
						[
							-81.20158,
							28.49547
						],
						[
							-81.202038,
							28.495046
						],
						[
							-81.202074,
							28.495018
						],
						[
							-81.202137,
							28.494985
						],
						[
							-81.202206,
							28.494963
						],
						[
							-81.202283,
							28.494953000000002
						],
						[
							-81.20237,
							28.494953000000002
						],
						[
							-81.202455,
							28.494968
						],
						[
							-81.202687,
							28.495047
						],
						[
							-81.202987,
							28.495167
						],
						[
							-81.203273,
							28.495304
						],
						[
							-81.203585,
							28.49544
						],
						[
							-81.203727,
							28.495482
						],
						[
							-81.203837,
							28.4955
						],
						[
							-81.204153,
							28.495509
						],
						[
							-81.20456,
							28.495507
						],
						[
							-81.204987,
							28.495514
						],
						[
							-81.205407,
							28.495512
						],
						[
							-81.205809,
							28.495505
						],
						[
							-81.206968,
							28.495502
						],
						[
							-81.207376,
							28.49549
						],
						[
							-81.208527,
							28.495483
						],
						[
							-81.209743,
							28.495492
						],
						[
							-81.210181,
							28.495485
						],
						[
							-81.211071,
							28.49549
						],
						[
							-81.211513,
							28.495485
						],
						[
							-81.211593,
							28.495473000000004
						],
						[
							-81.211668,
							28.495446
						],
						[
							-81.211735,
							28.495406
						],
						[
							-81.211792,
							28.495353
						],
						[
							-81.211839,
							28.495287
						],
						[
							-81.211872,
							28.495216
						],
						[
							-81.211889,
							28.49514
						],
						[
							-81.211904,
							28.494417
						],
						[
							-81.211906,
							28.494007
						],
						[
							-81.211889,
							28.493485
						],
						[
							-81.211882,
							28.491518
						],
						[
							-81.21188800000002,
							28.491152
						],
						[
							-81.211889,
							28.490271
						],
						[
							-81.211881,
							28.489488
						],
						[
							-81.21188,
							28.48935
						],
						[
							-81.211891,
							28.488681
						],
						[
							-81.21188600000002,
							28.488345
						],
						[
							-81.211884,
							28.48698
						],
						[
							-81.211876,
							28.486411
						],
						[
							-81.211887,
							28.485255
						],
						[
							-81.211875,
							28.485183000000003
						],
						[
							-81.211855,
							28.485137
						],
						[
							-81.21181,
							28.485076000000003
						],
						[
							-81.211708,
							28.484989000000002
						],
						[
							-81.211113,
							28.48453
						],
						[
							-81.21071,
							28.484206
						],
						[
							-81.210562,
							28.484092
						],
						[
							-81.210507,
							28.484033
						],
						[
							-81.210462,
							28.483967
						],
						[
							-81.210436,
							28.483894
						],
						[
							-81.210425,
							28.483818
						],
						[
							-81.210454,
							28.483502
						],
						[
							-81.21048,
							28.483351
						],
						[
							-81.210494,
							28.483224
						],
						[
							-81.210513,
							28.482942
						],
						[
							-81.210491,
							28.482204
						],
						[
							-81.210962,
							28.482053
						],
						[
							-81.21123,
							28.481969
						],
						[
							-81.21197,
							28.481734
						],
						[
							-81.211993,
							28.480964
						],
						[
							-81.211995,
							28.480911
						],
						[
							-81.212163,
							28.475479000000004
						],
						[
							-81.212288,
							28.471981
						],
						[
							-81.214889,
							28.473884
						],
						[
							-81.219764,
							28.477451000000002
						],
						[
							-81.223352,
							28.480076
						],
						[
							-81.224347,
							28.480804
						],
						[
							-81.224408,
							28.480849
						],
						[
							-81.224662,
							28.480883
						],
						[
							-81.225007,
							28.480946
						],
						[
							-81.225275,
							28.481009
						],
						[
							-81.225581,
							28.481095
						],
						[
							-81.22579700000001,
							28.481165
						],
						[
							-81.226114,
							28.481283000000005
						],
						[
							-81.226381,
							28.481398
						],
						[
							-81.226699,
							28.481556
						],
						[
							-81.226938,
							28.481691
						],
						[
							-81.227271,
							28.481904
						],
						[
							-81.227433,
							28.48202
						],
						[
							-81.227458,
							28.482037
						],
						[
							-81.227509,
							28.482074
						],
						[
							-81.227745,
							28.482263
						],
						[
							-81.22803,
							28.482516
						],
						[
							-81.228135,
							28.482618
						],
						[
							-81.228313,
							28.482808
						],
						[
							-81.228519,
							28.483059000000004
						],
						[
							-81.228712,
							28.483319000000005
						],
						[
							-81.228854,
							28.483534
						],
						[
							-81.229016,
							28.483811
						],
						[
							-81.229123,
							28.484024
						],
						[
							-81.229277,
							28.484377
						],
						[
							-81.229325,
							28.484506
						],
						[
							-81.229325,
							28.484571
						],
						[
							-81.229306,
							28.484632
						],
						[
							-81.22937,
							28.484628
						],
						[
							-81.229376,
							28.484643000000002
						],
						[
							-81.22941,
							28.484732
						],
						[
							-81.229669,
							28.485424000000002
						],
						[
							-81.230407,
							28.487398
						],
						[
							-81.230738,
							28.48828
						],
						[
							-81.230784,
							28.488405
						],
						[
							-81.23101,
							28.489007
						],
						[
							-81.231229,
							28.489593
						],
						[
							-81.231364,
							28.489952
						],
						[
							-81.231536,
							28.490403000000004
						],
						[
							-81.231591,
							28.490546
						],
						[
							-81.23177700000001,
							28.491049
						],
						[
							-81.232039,
							28.491739
						],
						[
							-81.232231,
							28.492244
						],
						[
							-81.233182,
							28.494784
						],
						[
							-81.233315,
							28.49514
						],
						[
							-81.233356,
							28.49525
						],
						[
							-81.233566,
							28.49586
						],
						[
							-81.23357,
							28.495873
						],
						[
							-81.233684,
							28.496214
						],
						[
							-81.234285,
							28.49809
						],
						[
							-81.234404,
							28.498461
						],
						[
							-81.234443,
							28.498581
						],
						[
							-81.234531,
							28.498827
						],
						[
							-81.23465,
							28.499116
						],
						[
							-81.23474,
							28.499306000000004
						],
						[
							-81.234838,
							28.499494
						],
						[
							-81.235003,
							28.499769
						],
						[
							-81.235178,
							28.500025
						],
						[
							-81.235356,
							28.500256
						],
						[
							-81.23554800000001,
							28.500476
						],
						[
							-81.235638,
							28.500568
						],
						[
							-81.235762,
							28.500695
						],
						[
							-81.235993,
							28.500909
						],
						[
							-81.236129,
							28.501023
						],
						[
							-81.236235,
							28.501112
						],
						[
							-81.236487,
							28.501297
						],
						[
							-81.237971,
							28.502312
						],
						[
							-81.238057,
							28.502375
						],
						[
							-81.238143,
							28.502438
						],
						[
							-81.238378,
							28.502622000000002
						],
						[
							-81.238531,
							28.502754
						],
						[
							-81.238866,
							28.503082
						],
						[
							-81.239048,
							28.503289
						],
						[
							-81.23922,
							28.503502
						],
						[
							-81.239341,
							28.503666
						],
						[
							-81.23949,
							28.503891
						],
						[
							-81.239628,
							28.504127
						],
						[
							-81.239738,
							28.504342
						],
						[
							-81.239841,
							28.504585
						],
						[
							-81.239923,
							28.504816
						],
						[
							-81.239993,
							28.505056
						],
						[
							-81.240047,
							28.505306000000004
						],
						[
							-81.240068,
							28.505432
						],
						[
							-81.240092,
							28.50565
						],
						[
							-81.240111,
							28.505979000000004
						],
						[
							-81.240114,
							28.506612
						],
						[
							-81.24011,
							28.506737000000005
						],
						[
							-81.240067,
							28.507163
						],
						[
							-81.240015,
							28.50744
						],
						[
							-81.239985,
							28.507555
						],
						[
							-81.23993,
							28.507777000000004
						],
						[
							-81.239896,
							28.507886000000003
						],
						[
							-81.239771,
							28.508244
						],
						[
							-81.23957700000001,
							28.508730000000003
						],
						[
							-81.23941,
							28.509192
						],
						[
							-81.239186,
							28.509787
						],
						[
							-81.23906,
							28.510142
						],
						[
							-81.238936,
							28.510461
						],
						[
							-81.238743,
							28.510939000000004
						],
						[
							-81.238595,
							28.511306
						],
						[
							-81.23848,
							28.511603
						],
						[
							-81.238431,
							28.511752
						],
						[
							-81.238199,
							28.512386
						],
						[
							-81.238046,
							28.512809
						],
						[
							-81.23803,
							28.512873
						],
						[
							-81.23802,
							28.512913
						],
						[
							-81.237992,
							28.513025
						],
						[
							-81.237959,
							28.513237
						],
						[
							-81.237946,
							28.513416
						],
						[
							-81.237944,
							28.513459
						],
						[
							-81.237944,
							28.51361
						],
						[
							-81.237953,
							28.513785
						],
						[
							-81.237975,
							28.513984
						],
						[
							-81.238114,
							28.514643
						],
						[
							-81.238175,
							28.514921
						],
						[
							-81.238267,
							28.515334
						],
						[
							-81.238296,
							28.515416
						],
						[
							-81.238324,
							28.515489000000002
						],
						[
							-81.238357,
							28.515617
						],
						[
							-81.238415,
							28.515871
						],
						[
							-81.238521,
							28.516329
						],
						[
							-81.238754,
							28.517243000000004
						],
						[
							-81.238763,
							28.517276
						],
						[
							-81.238876,
							28.517699000000004
						],
						[
							-81.23896,
							28.518013
						],
						[
							-81.239166,
							28.518935
						],
						[
							-81.239174,
							28.518966
						],
						[
							-81.239259,
							28.519281000000003
						],
						[
							-81.239339,
							28.519554
						],
						[
							-81.239353,
							28.519601
						],
						[
							-81.239545,
							28.520384000000004
						],
						[
							-81.239613,
							28.520661
						],
						[
							-81.239723,
							28.52111
						],
						[
							-81.239798,
							28.521446000000005
						],
						[
							-81.23982700000002,
							28.521571
						],
						[
							-81.239885,
							28.521879
						],
						[
							-81.239984,
							28.522537
						],
						[
							-81.240014,
							28.522801
						],
						[
							-81.24004600000002,
							28.523137000000002
						],
						[
							-81.240074,
							28.523535
						],
						[
							-81.240084,
							28.523848
						],
						[
							-81.24009300000002,
							28.524087000000005
						],
						[
							-81.240088,
							28.524656
						],
						[
							-81.240084,
							28.524818
						],
						[
							-81.240073,
							28.525307
						],
						[
							-81.24007,
							28.52547
						],
						[
							-81.240066,
							28.525629
						],
						[
							-81.240056,
							28.526107
						],
						[
							-81.240053,
							28.526267
						],
						[
							-81.24005000000001,
							28.526379
						],
						[
							-81.240042,
							28.526715
						],
						[
							-81.24004,
							28.526828
						],
						[
							-81.240022,
							28.527615
						],
						[
							-81.239993,
							28.528971
						],
						[
							-81.239971,
							28.529976
						],
						[
							-81.23996400000001,
							28.530307
						],
						[
							-81.239962,
							28.530623
						],
						[
							-81.23997,
							28.530763
						],
						[
							-81.239973,
							28.531008
						],
						[
							-81.23998,
							28.531535
						],
						[
							-81.239999,
							28.531746
						],
						[
							-81.240022,
							28.531991
						],
						[
							-81.240033,
							28.531986
						],
						[
							-81.240069,
							28.531971
						],
						[
							-81.240081,
							28.531967
						],
						[
							-81.240166,
							28.532085
						],
						[
							-81.240421,
							28.532441
						],
						[
							-81.240507,
							28.53256
						],
						[
							-81.241712,
							28.533567
						],
						[
							-81.241724,
							28.533733
						],
						[
							-81.24172,
							28.534352
						],
						[
							-81.241729,
							28.534364
						],
						[
							-81.241743,
							28.534564
						],
						[
							-81.241757,
							28.534768000000003
						],
						[
							-81.241759,
							28.5348
						],
						[
							-81.241765,
							28.534896
						],
						[
							-81.241768,
							28.534928
						],
						[
							-81.241769,
							28.534954
						],
						[
							-81.241775,
							28.535032
						],
						[
							-81.241777,
							28.535059
						],
						[
							-81.241845,
							28.535064
						],
						[
							-81.241973,
							28.535075
						],
						[
							-81.242009,
							28.535084
						],
						[
							-81.242044,
							28.535102
						],
						[
							-81.24207,
							28.535125
						],
						[
							-81.242091,
							28.535153
						],
						[
							-81.242109,
							28.53515
						],
						[
							-81.242145,
							28.535151
						],
						[
							-81.24218,
							28.53516
						],
						[
							-81.242248,
							28.535194
						],
						[
							-81.242694,
							28.535419
						],
						[
							-81.242843,
							28.535494
						],
						[
							-81.243445,
							28.535528
						],
						[
							-81.243484,
							28.535681
						],
						[
							-81.243859,
							28.537371
						],
						[
							-81.244002,
							28.538084
						],
						[
							-81.244039,
							28.538288
						],
						[
							-81.244211,
							28.539363
						],
						[
							-81.244281,
							28.540009000000005
						],
						[
							-81.244294,
							28.54204
						],
						[
							-81.244294,
							28.542455
						],
						[
							-81.244296,
							28.543228
						],
						[
							-81.244299,
							28.543663
						],
						[
							-81.244302,
							28.544098
						],
						[
							-81.244312,
							28.546398
						],
						[
							-81.244323,
							28.546726000000003
						],
						[
							-81.244324,
							28.546863
						],
						[
							-81.24433700000002,
							28.547154
						],
						[
							-81.24434,
							28.547219
						],
						[
							-81.244343,
							28.547284
						],
						[
							-81.244346,
							28.547349
						],
						[
							-81.244349,
							28.547414
						],
						[
							-81.244353,
							28.547504
						],
						[
							-81.244365,
							28.547776
						],
						[
							-81.24437,
							28.547867
						],
						[
							-81.24441619499999,
							28.548602130000063
						],
						[
							-81.242186,
							28.548611
						],
						[
							-81.24208,
							28.548611
						],
						[
							-81.239747,
							28.548619
						],
						[
							-81.235563,
							28.548657
						],
						[
							-81.231782,
							28.54868
						],
						[
							-81.231582,
							28.548681
						],
						[
							-81.230271,
							28.548722
						],
						[
							-81.22814,
							28.548998
						],
						[
							-81.226901,
							28.549372
						],
						[
							-81.225845,
							28.549831
						],
						[
							-81.225458,
							28.54994
						],
						[
							-81.22518900000001,
							28.550016
						],
						[
							-81.224643,
							28.550018000000005
						],
						[
							-81.223513,
							28.549842
						],
						[
							-81.223522,
							28.551889
						],
						[
							-81.223531,
							28.554151
						],
						[
							-81.223548,
							28.558225
						],
						[
							-81.223556,
							28.559992
						],
						[
							-81.223566,
							28.560119
						],
						[
							-81.223578,
							28.561323
						],
						[
							-81.223563,
							28.561689
						],
						[
							-81.223568,
							28.562812
						],
						[
							-81.223592,
							28.568564
						],
						[
							-81.22402771899993,
							28.56866414500007
						],
						[
							-81.224029,
							28.568668
						],
						[
							-81.223871,
							28.568663
						],
						[
							-81.222546,
							28.568516
						],
						[
							-81.220242,
							28.568242
						],
						[
							-81.21997,
							28.568203
						],
						[
							-81.218463,
							28.56805
						],
						[
							-81.216834,
							28.567884
						],
						[
							-81.21585,
							28.567773
						],
						[
							-81.214451,
							28.567598
						],
						[
							-81.212707,
							28.567409
						],
						[
							-81.212554,
							28.567388
						],
						[
							-81.212155,
							28.56734
						],
						[
							-81.211941,
							28.567314
						],
						[
							-81.211788,
							28.567292
						],
						[
							-81.211002,
							28.567203
						],
						[
							-81.209673,
							28.567011
						],
						[
							-81.208203,
							28.566816
						],
						[
							-81.207652,
							28.566757
						],
						[
							-81.206411,
							28.566672
						],
						[
							-81.205436,
							28.566557
						],
						[
							-81.203401,
							28.566324
						],
						[
							-81.20231300000002,
							28.566206
						],
						[
							-81.200869,
							28.566029
						],
						[
							-81.199148,
							28.565838
						],
						[
							-81.198657,
							28.565778
						],
						[
							-81.19722,
							28.565604
						],
						[
							-81.195547,
							28.565434
						],
						[
							-81.19488,
							28.565353000000005
						],
						[
							-81.193203,
							28.565278
						],
						[
							-81.192801,
							28.565268000000003
						],
						[
							-81.192236,
							28.565261
						],
						[
							-81.191712,
							28.565258
						],
						[
							-81.191289,
							28.56523
						],
						[
							-81.191131,
							28.565226000000003
						],
						[
							-81.190992,
							28.565213
						],
						[
							-81.190151,
							28.565259
						],
						[
							-81.18936,
							28.565259
						],
						[
							-81.188729,
							28.565236
						],
						[
							-81.187113,
							28.565233
						],
						[
							-81.186702,
							28.565276
						],
						[
							-81.184429,
							28.565276
						],
						[
							-81.182347,
							28.565283
						],
						[
							-81.182347,
							28.565423
						],
						[
							-81.180801,
							28.565402
						],
						[
							-81.179428,
							28.565423
						],
						[
							-81.17818,
							28.565408
						],
						[
							-81.176625,
							28.565426
						],
						[
							-81.176129,
							28.565427
						],
						[
							-81.175358,
							28.565447
						],
						[
							-81.175314,
							28.565443000000002
						],
						[
							-81.174986,
							28.565448
						],
						[
							-81.174745,
							28.565451
						],
						[
							-81.174136,
							28.565439
						],
						[
							-81.173829,
							28.565458
						],
						[
							-81.172504,
							28.565463000000005
						],
						[
							-81.171931,
							28.565439
						],
						[
							-81.169881,
							28.565439
						],
						[
							-81.169882,
							28.565547
						],
						[
							-81.169885,
							28.566048
						],
						[
							-81.169887,
							28.566215
						],
						[
							-81.169858,
							28.566215
						],
						[
							-81.169811,
							28.566214
						],
						[
							-81.169618,
							28.566213
						],
						[
							-81.169585,
							28.56621
						],
						[
							-81.16951,
							28.566206
						],
						[
							-81.167769,
							28.56624
						],
						[
							-81.16735000000001,
							28.566229
						],
						[
							-81.166954,
							28.566220000000005
						],
						[
							-81.166201,
							28.56623
						],
						[
							-81.16609300000002,
							28.566228
						],
						[
							-81.165828,
							28.566224
						],
						[
							-81.165675,
							28.566226
						],
						[
							-81.165681,
							28.566098
						],
						[
							-81.165681,
							28.566059
						],
						[
							-81.165683,
							28.565559
						],
						[
							-81.165684,
							28.565447
						],
						[
							-81.164926,
							28.565451
						],
						[
							-81.164723,
							28.565447
						],
						[
							-81.16269,
							28.565455
						],
						[
							-81.161624,
							28.565467
						],
						[
							-81.160266,
							28.565459
						],
						[
							-81.159436,
							28.565466
						],
						[
							-81.159439,
							28.565729
						],
						[
							-81.159447,
							28.565937
						],
						[
							-81.159458,
							28.566174
						],
						[
							-81.159382,
							28.566183
						],
						[
							-81.158787,
							28.56618
						],
						[
							-81.158782,
							28.566085
						],
						[
							-81.158776,
							28.566044
						],
						[
							-81.15877200000001,
							28.566015
						],
						[
							-81.15877200000001,
							28.565985
						],
						[
							-81.158777,
							28.565941000000002
						],
						[
							-81.158777,
							28.565924
						],
						[
							-81.15878000000001,
							28.565884
						],
						[
							-81.158768,
							28.565838
						],
						[
							-81.158755,
							28.565789000000002
						],
						[
							-81.158749,
							28.565762
						],
						[
							-81.158712,
							28.565609
						],
						[
							-81.158689,
							28.565503
						],
						[
							-81.158681,
							28.565464000000002
						],
						[
							-81.157977,
							28.565463000000005
						],
						[
							-81.157325,
							28.565462
						],
						[
							-81.156964,
							28.565459
						],
						[
							-81.156317,
							28.565482
						],
						[
							-81.156151,
							28.565343
						],
						[
							-81.154932,
							28.565355000000004
						],
						[
							-81.154194,
							28.565348
						],
						[
							-81.154179,
							28.565207
						],
						[
							-81.154142,
							28.56513
						],
						[
							-81.153905,
							28.564838
						],
						[
							-81.153768,
							28.564712
						],
						[
							-81.153601,
							28.564575000000005
						],
						[
							-81.153414,
							28.564422
						],
						[
							-81.153169,
							28.564221
						],
						[
							-81.153095,
							28.564161
						],
						[
							-81.152721,
							28.563743
						],
						[
							-81.152273,
							28.563385
						],
						[
							-81.15208,
							28.563121
						],
						[
							-81.151918,
							28.562956
						],
						[
							-81.151469,
							28.562681
						],
						[
							-81.150871,
							28.562191
						],
						[
							-81.150418,
							28.561890000000002
						],
						[
							-81.150322,
							28.561827
						],
						[
							-81.150048,
							28.561701
						],
						[
							-81.149643,
							28.561569
						],
						[
							-81.149257,
							28.561436
						],
						[
							-81.149213,
							28.561388
						],
						[
							-81.149144,
							28.561313
						],
						[
							-81.14909100199998,
							28.561254546000043
						],
						[
							-81.14912932399994,
							28.561239503000024
						],
						[
							-81.149286,
							28.561178
						],
						[
							-81.14888845399997,
							28.560868798000058
						],
						[
							-81.14878149899994,
							28.56078561000004
						],
						[
							-81.14787392099998,
							28.560079716000075
						],
						[
							-81.14783990599996,
							28.560053259000032
						],
						[
							-81.14748749199998,
							28.55977916100005
						],
						[
							-81.14746208599996,
							28.559435226000062
						],
						[
							-81.14742876599996,
							28.558957638000038
						],
						[
							-81.14741527499996,
							28.55876427100003
						],
						[
							-81.14726871399995,
							28.556663556000046
						],
						[
							-81.14722519499998,
							28.556039790000057
						],
						[
							-81.14718739399996,
							28.555497982000077
						],
						[
							-81.147186,
							28.555478
						],
						[
							-81.14703986199999,
							28.555317126000034
						],
						[
							-81.14654609699994,
							28.554774107000075
						],
						[
							-81.146498,
							28.554667
						],
						[
							-81.14643,
							28.554315
						],
						[
							-81.146336,
							28.55415
						],
						[
							-81.146218,
							28.554024
						],
						[
							-81.145832,
							28.553842
						],
						[
							-81.145651,
							28.553666
						],
						[
							-81.14557,
							28.55355
						],
						[
							-81.145477,
							28.553248
						],
						[
							-81.145427,
							28.553192
						],
						[
							-81.145402,
							28.553093000000004
						],
						[
							-81.14519,
							28.552884
						],
						[
							-81.144773,
							28.55273
						],
						[
							-81.14457586499998,
							28.552606851000064
						],
						[
							-81.144186,
							28.552178
						],
						[
							-81.14377106299997,
							28.55240432900007
						],
						[
							-81.14364185499994,
							28.552474806000077
						],
						[
							-81.143086,
							28.552778
						],
						[
							-81.14150190899994,
							28.55205793500005
						],
						[
							-81.14138907099994,
							28.552006669000036
						],
						[
							-81.14116217499998,
							28.551903534000076
						],
						[
							-81.140886,
							28.551778
						],
						[
							-81.14066628099994,
							28.551887561000058
						],
						[
							-81.14026320599999,
							28.55208939700003
						],
						[
							-81.14024419599997,
							28.55209890200007
						],
						[
							-81.13951855799996,
							28.552461721000043
						],
						[
							-81.13949163899997,
							28.552475180000044
						],
						[
							-81.139102,
							28.55231
						],
						[
							-81.138909,
							28.552172
						],
						[
							-81.138772,
							28.552035
						],
						[
							-81.138697,
							28.551842
						],
						[
							-81.138686,
							28.551694
						],
						[
							-81.138666,
							28.551407
						],
						[
							-81.138541,
							28.551187
						],
						[
							-81.138386,
							28.551072
						],
						[
							-81.138012,
							28.550884000000003
						],
						[
							-81.13761901699996,
							28.55079450900007
						],
						[
							-81.136786,
							28.550378
						],
						[
							-81.134586,
							28.550678
						],
						[
							-81.13394555099995,
							28.550179874000037
						],
						[
							-81.13393870599998,
							28.550174550000065
						],
						[
							-81.13376512999997,
							28.55003954600005
						],
						[
							-81.13366392599994,
							28.549960832000068
						],
						[
							-81.131886,
							28.548578
						],
						[
							-81.13166005699998,
							28.548239085000034
						],
						[
							-81.131619,
							28.547955
						],
						[
							-81.131495,
							28.54758
						],
						[
							-81.131343,
							28.547285
						],
						[
							-81.131177,
							28.546964000000003
						],
						[
							-81.130973,
							28.546694
						],
						[
							-81.130928,
							28.546634
						],
						[
							-81.13027377599997,
							28.546159664000076
						],
						[
							-81.130086,
							28.545878
						],
						[
							-81.13002049799996,
							28.54570332800006
						],
						[
							-81.129988,
							28.545616667000047
						],
						[
							-81.129988,
							28.545092
						],
						[
							-81.129926,
							28.544702
						],
						[
							-81.129783,
							28.544262
						],
						[
							-81.12961500000002,
							28.543959
						],
						[
							-81.129378,
							28.54375
						],
						[
							-81.12924872099997,
							28.543645255000058
						],
						[
							-81.129186,
							28.543478
						],
						[
							-81.128386,
							28.542978000000005
						],
						[
							-81.12655731999996,
							28.542020576000027
						],
						[
							-81.126285,
							28.541878
						],
						[
							-81.125996,
							28.541615272000058
						],
						[
							-81.125747,
							28.541321
						],
						[
							-81.12556,
							28.54114
						],
						[
							-81.12541000000002,
							28.541068
						],
						[
							-81.12538823499995,
							28.541062759000056
						],
						[
							-81.125185,
							28.540878000000003
						],
						[
							-81.12243167499997,
							28.540484668000033
						],
						[
							-81.12239717199998,
							28.540479739000034
						],
						[
							-81.12239,
							28.540414
						],
						[
							-81.122209,
							28.5401
						],
						[
							-81.122153,
							28.539935
						],
						[
							-81.122153,
							28.539693
						],
						[
							-81.122321,
							28.539259
						],
						[
							-81.122364,
							28.53906
						],
						[
							-81.12237,
							28.538835
						],
						[
							-81.122363,
							28.538805
						],
						[
							-81.122183,
							28.538004
						],
						[
							-81.122027,
							28.537723
						],
						[
							-81.12195200000001,
							28.537503
						],
						[
							-81.121933,
							28.537316
						],
						[
							-81.122036,
							28.537176
						],
						[
							-81.122346,
							28.536756
						],
						[
							-81.12245,
							28.536617
						],
						[
							-81.12259,
							28.536695000000005
						],
						[
							-81.122737,
							28.536777
						],
						[
							-81.122811,
							28.536793
						],
						[
							-81.123049,
							28.536769
						],
						[
							-81.12321,
							28.536754
						],
						[
							-81.123179,
							28.536589000000003
						],
						[
							-81.123391,
							28.536204
						],
						[
							-81.12349,
							28.536089000000004
						],
						[
							-81.12377000000001,
							28.535907
						],
						[
							-81.123926,
							28.535692
						],
						[
							-81.124049,
							28.535577
						],
						[
							-81.124188,
							28.53545
						],
						[
							-81.125003,
							28.534349
						],
						[
							-81.125128,
							28.534245
						],
						[
							-81.125726,
							28.533574
						],
						[
							-81.125901,
							28.533084
						],
						[
							-81.126319,
							28.532352
						],
						[
							-81.126462,
							28.532132
						],
						[
							-81.126543,
							28.531885
						],
						[
							-81.12653400000002,
							28.531809
						],
						[
							-81.1265,
							28.531505
						],
						[
							-81.126482,
							28.53079
						],
						[
							-81.126407,
							28.53047
						],
						[
							-81.126401,
							28.530294
						],
						[
							-81.126651,
							28.529497
						],
						[
							-81.126682,
							28.529029
						],
						[
							-81.126738,
							28.528578
						],
						[
							-81.126801,
							28.528339
						],
						[
							-81.12682,
							28.528270000000003
						],
						[
							-81.1271,
							28.527675
						],
						[
							-81.127524,
							28.52701
						],
						[
							-81.127624,
							28.526713
						],
						[
							-81.127602,
							28.526319000000004
						],
						[
							-81.127581,
							28.525959
						],
						[
							-81.127525,
							28.525706
						],
						[
							-81.127525,
							28.525332
						],
						[
							-81.127569,
							28.525095
						],
						[
							-81.127594,
							28.524968
						],
						[
							-81.127681,
							28.524803
						],
						[
							-81.128037,
							28.524363
						],
						[
							-81.128311,
							28.524022
						],
						[
							-81.128654,
							28.52378
						],
						[
							-81.128853,
							28.523604
						],
						[
							-81.128941,
							28.523478
						],
						[
							-81.129084,
							28.523186
						],
						[
							-81.129103,
							28.523114000000003
						],
						[
							-81.129178,
							28.522834
						],
						[
							-81.12934,
							28.522443000000003
						],
						[
							-81.130007,
							28.52147
						],
						[
							-81.130062,
							28.521372
						],
						[
							-81.130331,
							28.520887
						],
						[
							-81.130456,
							28.520617
						],
						[
							-81.13074900000001,
							28.519808
						],
						[
							-81.13096042599994,
							28.519148751000046
						],
						[
							-81.13128914399995,
							28.518387509000036
						],
						[
							-81.13204478099993,
							28.516637613000057
						],
						[
							-81.13207493799996,
							28.516567775000055
						],
						[
							-81.132321,
							28.516276
						],
						[
							-81.132726,
							28.51593
						],
						[
							-81.132976,
							28.515732
						],
						[
							-81.133213,
							28.515594
						],
						[
							-81.133705,
							28.515402000000005
						],
						[
							-81.133836,
							28.515325
						],
						[
							-81.134029,
							28.515127
						],
						[
							-81.134266,
							28.514824
						],
						[
							-81.134528,
							28.514362
						],
						[
							-81.134696,
							28.514126
						],
						[
							-81.135369,
							28.513411
						],
						[
							-81.135625,
							28.512921
						],
						[
							-81.136136,
							28.512338
						],
						[
							-81.136198,
							28.512063
						],
						[
							-81.136286,
							28.511435
						],
						[
							-81.13628589899997,
							28.511419568000065
						],
						[
							-81.136686,
							28.509179
						],
						[
							-81.13676577899997,
							28.508700330000067
						],
						[
							-81.136836,
							28.508437
						],
						[
							-81.136935,
							28.507947
						],
						[
							-81.136986,
							28.50721
						],
						[
							-81.136955,
							28.507028
						],
						[
							-81.136886,
							28.506903330000057
						],
						[
							-81.136886,
							28.506779000000005
						],
						[
							-81.13661106999996,
							28.506504070000062
						],
						[
							-81.13654729899997,
							28.506440299000076
						],
						[
							-81.134786,
							28.504679000000003
						],
						[
							-81.13477580099999,
							28.504553011000045
						],
						[
							-81.13477437399996,
							28.50453538900007
						],
						[
							-81.134565,
							28.501949
						],
						[
							-81.134486,
							28.50098
						],
						[
							-81.13437866699996,
							28.500829733000046
						],
						[
							-81.13435529699996,
							28.500797015000046
						],
						[
							-81.134543,
							28.500678
						],
						[
							-81.134572,
							28.500661
						],
						[
							-81.134796,
							28.500276
						],
						[
							-81.134809,
							28.500133
						],
						[
							-81.134809,
							28.499998
						],
						[
							-81.134722,
							28.499646
						],
						[
							-81.134604,
							28.499476
						],
						[
							-81.13428,
							28.499233
						],
						[
							-81.134,
							28.49918
						],
						[
							-81.13334,
							28.499057
						],
						[
							-81.13322366199998,
							28.499041201000068
						],
						[
							-81.133186,
							28.49898
						],
						[
							-81.13299839199993,
							28.49879239200004
						],
						[
							-81.13251868999998,
							28.498312690000034
						],
						[
							-81.132462,
							28.497934
						],
						[
							-81.132387,
							28.497681
						],
						[
							-81.132375,
							28.497659
						],
						[
							-81.132151,
							28.497252
						],
						[
							-81.13189,
							28.496976
						],
						[
							-81.131578,
							28.496756
						],
						[
							-81.131124,
							28.496503
						],
						[
							-81.130737,
							28.496354
						],
						[
							-81.13070215199997,
							28.496346867000057
						],
						[
							-81.13066119299998,
							28.496301145000075
						],
						[
							-81.12863535099996,
							28.494039740000062
						],
						[
							-81.128626,
							28.494000000000003
						],
						[
							-81.128596,
							28.493871000000002
						],
						[
							-81.128472,
							28.493635
						],
						[
							-81.128304,
							28.493398
						],
						[
							-81.12775000000002,
							28.492936
						],
						[
							-81.127681,
							28.492864
						],
						[
							-81.127619,
							28.492732
						],
						[
							-81.12747,
							28.492616
						],
						[
							-81.127451,
							28.492374000000005
						],
						[
							-81.127302,
							28.49211
						],
						[
							-81.126947,
							28.491725
						],
						[
							-81.126804,
							28.491433
						],
						[
							-81.126561,
							28.491097000000003
						],
						[
							-81.126356,
							28.49091
						],
						[
							-81.12612689799994,
							28.490775753000037
						],
						[
							-81.124786,
							28.48888
						],
						[
							-81.12431028299994,
							28.488200404000054
						],
						[
							-81.12422248699994,
							28.488074982000057
						],
						[
							-81.124204,
							28.487933000000005
						],
						[
							-81.124229,
							28.487834
						],
						[
							-81.124359,
							28.487613
						],
						[
							-81.124359,
							28.487426
						],
						[
							-81.124322,
							28.487327000000004
						],
						[
							-81.124093,
							28.487044
						],
						[
							-81.123954,
							28.486871
						],
						[
							-81.123767,
							28.486700000000003
						],
						[
							-81.123443,
							28.486475
						],
						[
							-81.1231,
							28.486326
						],
						[
							-81.122733,
							28.486266000000004
						],
						[
							-81.122621,
							28.486217
						],
						[
							-81.12249,
							28.486085
						],
						[
							-81.122328,
							28.485749
						],
						[
							-81.122241,
							28.485633
						],
						[
							-81.122016,
							28.485529
						],
						[
							-81.12168328199995,
							28.485477282000037
						],
						[
							-81.12136592999997,
							28.485159930000066
						],
						[
							-81.12129061499996,
							28.485084615000062
						],
						[
							-81.12060717599996,
							28.484401176000063
						],
						[
							-81.12017734499995,
							28.483971345000047
						],
						[
							-81.120141,
							28.483884000000003
						],
						[
							-81.120116,
							28.483697
						],
						[
							-81.12014,
							28.483307
						],
						[
							-81.120122,
							28.48312
						],
						[
							-81.120047,
							28.48285
						],
						[
							-81.119841,
							28.482443
						],
						[
							-81.119803,
							28.481827000000003
						],
						[
							-81.11973500000002,
							28.481612
						],
						[
							-81.119523,
							28.481491
						],
						[
							-81.11906312799994,
							28.48138627700007
						],
						[
							-81.11886755199998,
							28.481268931000045
						],
						[
							-81.118707,
							28.481095
						],
						[
							-81.11848200000001,
							28.480765
						],
						[
							-81.118364,
							28.48065
						],
						[
							-81.118233,
							28.4806
						],
						[
							-81.118065,
							28.4806
						],
						[
							-81.11783151799995,
							28.48064731100004
						],
						[
							-81.11759921899994,
							28.480507931000034
						],
						[
							-81.117386,
							28.48038
						],
						[
							-81.11711980399997,
							28.480163100000027
						],
						[
							-81.11707718499997,
							28.48012837400006
						],
						[
							-81.11500130999997,
							28.478436921000025
						],
						[
							-81.11492425299997,
							28.478374133000045
						],
						[
							-81.11489086299997,
							28.47834692600003
						],
						[
							-81.11488520299997,
							28.47834231400003
						],
						[
							-81.114508,
							28.477713
						],
						[
							-81.11442,
							28.477427
						],
						[
							-81.114377,
							28.477190000000004
						],
						[
							-81.114183,
							28.476937
						],
						[
							-81.114052,
							28.476662
						],
						[
							-81.113965,
							28.476304
						],
						[
							-81.113921,
							28.476216
						],
						[
							-81.113535,
							28.475991
						],
						[
							-81.113373,
							28.475837
						],
						[
							-81.113311,
							28.475699
						],
						[
							-81.113336,
							28.475441
						],
						[
							-81.113441,
							28.475154000000003
						],
						[
							-81.113815,
							28.474538
						],
						[
							-81.113983,
							28.474169
						],
						[
							-81.114014,
							28.474026
						],
						[
							-81.114014,
							28.473817
						],
						[
							-81.113808,
							28.473272
						],
						[
							-81.113708,
							28.473151
						],
						[
							-81.11354220399994,
							28.473021510000024
						],
						[
							-81.11321602399994,
							28.47220605900003
						],
						[
							-81.11319493699995,
							28.472153524000078
						],
						[
							-81.113284,
							28.471968
						],
						[
							-81.113378,
							28.47188
						],
						[
							-81.113919,
							28.471891
						],
						[
							-81.113943,
							28.471881
						],
						[
							-81.114031,
							28.471847
						],
						[
							-81.11405922399996,
							28.471807367000054
						],
						[
							-81.11406487799997,
							28.471799427000064
						],
						[
							-81.114286,
							28.471781
						],
						[
							-81.11413575499995,
							28.47163075500004
						],
						[
							-81.114137,
							28.471621
						]
					],
					[
						[
							-81.22922000000001,
							28.484637
						],
						[
							-81.229169,
							28.484523
						],
						[
							-81.228954,
							28.484037
						],
						[
							-81.228736,
							28.483587
						],
						[
							-81.22848,
							28.483234000000003
						],
						[
							-81.228301,
							28.483012
						],
						[
							-81.228098,
							28.482794
						],
						[
							-81.22774,
							28.482431
						],
						[
							-81.227467,
							28.482234
						],
						[
							-81.227483,
							28.482534
						],
						[
							-81.227593,
							28.484642000000004
						],
						[
							-81.229029,
							28.484646
						],
						[
							-81.22922000000001,
							28.484637
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Alafaya",
				"RegionID": "15046"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.19556089999992,
					25.995268000000067,
					-80.1750429999999,
					26.00312468500005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.19526899999994,
							25.995268000000067
						],
						[
							-80.19518543999993,
							25.997176033000073
						],
						[
							-80.19547097599991,
							25.998175406000087
						],
						[
							-80.19547097599991,
							25.99969826100005
						],
						[
							-80.19556089999992,
							26.00265962600008
						],
						[
							-80.18942714499991,
							26.002839150000057
						],
						[
							-80.18067072799994,
							26.003029507000065
						],
						[
							-80.17748224999991,
							26.00312468500005
						],
						[
							-80.17559296099995,
							26.00312468500005
						],
						[
							-80.17559296099995,
							25.995903706000036
						],
						[
							-80.1750429999999,
							25.995904000000053
						],
						[
							-80.17586799999992,
							25.995868000000087
						],
						[
							-80.17644899999993,
							25.995847000000083
						],
						[
							-80.17696499999994,
							25.99581900000004
						],
						[
							-80.18338899999992,
							25.99556300000006
						],
						[
							-80.1856689999999,
							25.99566800000008
						],
						[
							-80.18776899999995,
							25.995468000000074
						],
						[
							-80.1897689999999,
							25.995468000000074
						],
						[
							-80.19186899999994,
							25.99536800000004
						],
						[
							-80.19356899999991,
							25.99536800000004
						],
						[
							-80.19526899999994,
							25.995268000000067
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Hollywood",
				"Name": "Hillcrest",
				"RegionID": "25125"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.2056199999999,
					25.747631874000035,
					-80.18179367799992,
					25.770977747000074
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.19728619599994,
							25.76873157900008
						],
						[
							-80.1968075019999,
							25.76869328300006
						],
						[
							-80.19627136499992,
							25.76869328300006
						],
						[
							-80.19577352399995,
							25.76869328300006
						],
						[
							-80.19533312599994,
							25.768769874000043
						],
						[
							-80.19473954499995,
							25.76886561300006
						],
						[
							-80.1943757379999,
							25.76901879500008
						],
						[
							-80.19399278299994,
							25.76924856800008
						],
						[
							-80.19370556699994,
							25.769516637000038
						],
						[
							-80.1933417599999,
							25.76980385300004
						],
						[
							-80.1929970999999,
							25.770052774000078
						],
						[
							-80.19255670199993,
							25.77024425100007
						],
						[
							-80.19194397399991,
							25.770339990000082
						],
						[
							-80.19156101899995,
							25.77024425100007
						],
						[
							-80.19046959699995,
							25.769918739000047
						],
						[
							-80.18995260799994,
							25.769823001000077
						],
						[
							-80.18914840199996,
							25.769899592000062
						],
						[
							-80.18876544699992,
							25.76997618300004
						],
						[
							-80.18840163999994,
							25.770033626000043
						],
						[
							-80.18727192299991,
							25.77011021700008
						],
						[
							-80.18575567499994,
							25.77037225800007
						],
						[
							-80.18324006099994,
							25.770484429000078
						],
						[
							-80.18309810799991,
							25.77047953100004
						],
						[
							-80.18298410799991,
							25.770466532000057
						],
						[
							-80.18289188799992,
							25.77045112400009
						],
						[
							-80.18279688799993,
							25.770430124000086
						],
						[
							-80.18268341399994,
							25.77039708600006
						],
						[
							-80.1825536689999,
							25.77033782600006
						],
						[
							-80.18243866899991,
							25.77027382500006
						],
						[
							-80.1823409239999,
							25.77021082300007
						],
						[
							-80.18226392399993,
							25.770153823000044
						],
						[
							-80.18222092699995,
							25.77011992100006
						],
						[
							-80.18212070899995,
							25.77002150900006
						],
						[
							-80.18204139399995,
							25.769930291000037
						],
						[
							-80.18199841199993,
							25.76987591200009
						],
						[
							-80.18195974799994,
							25.769818383000086
						],
						[
							-80.18192563299993,
							25.76975804600005
						],
						[
							-80.18189626799995,
							25.76969525800007
						],
						[
							-80.18187182999992,
							25.769630395000036
						],
						[
							-80.18183982999994,
							25.76953439500005
						],
						[
							-80.18180734099991,
							25.769406165000078
						],
						[
							-80.18179367799992,
							25.769250000000056
						],
						[
							-80.18179367799992,
							25.769175000000075
						],
						[
							-80.18179654199992,
							25.76910328000008
						],
						[
							-80.1818025419999,
							25.769028280000043
						],
						[
							-80.18181306499991,
							25.76894540500007
						],
						[
							-80.18183906599995,
							25.768796406000035
						],
						[
							-80.18186518099992,
							25.768687389000036
						],
						[
							-80.18218771699992,
							25.767635477000056
						],
						[
							-80.18328506799992,
							25.764197081000077
						],
						[
							-80.1833858839999,
							25.763818453000056
						],
						[
							-80.18340503299993,
							25.763747469000066
						],
						[
							-80.18342791399994,
							25.763667414000054
						],
						[
							-80.18349416399991,
							25.76352533900007
						],
						[
							-80.1835840789999,
							25.763396927000088
						],
						[
							-80.18369492699992,
							25.763286080000057
						],
						[
							-80.1838233389999,
							25.763196165000068
						],
						[
							-80.18388985399991,
							25.763163659000043
						],
						[
							-80.18396459999991,
							25.76312819000009
						],
						[
							-80.18421298299995,
							25.763008789000082
						],
						[
							-80.18427853199995,
							25.762980954000056
						],
						[
							-80.18434607699993,
							25.762958392000087
						],
						[
							-80.18441519599992,
							25.762941246000082
						],
						[
							-80.1844854549999,
							25.762929622000062
						],
						[
							-80.18470145599991,
							25.76290262200007
						],
						[
							-80.1848129999999,
							25.762895678000064
						],
						[
							-80.18496916599992,
							25.762909341000068
						],
						[
							-80.18512058699991,
							25.762949914000046
						],
						[
							-80.18526266099991,
							25.763016164000078
						],
						[
							-80.18535770699992,
							25.763079406000088
						],
						[
							-80.18555870699993,
							25.763232406000046
						],
						[
							-80.18561315099993,
							25.76327733000005
						],
						[
							-80.1856639049999,
							25.763326386000074
						],
						[
							-80.18571065499992,
							25.763379271000076
						],
						[
							-80.18575311299992,
							25.763435660000084
						],
						[
							-80.18579101799992,
							25.763495205000083
						],
						[
							-80.18611501799995,
							25.764051205000044
						],
						[
							-80.18613375799993,
							25.764085014000045
						],
						[
							-80.18679875799995,
							25.76534801400004
						],
						[
							-80.1868398119999,
							25.76543756600006
						],
						[
							-80.18696974199992,
							25.765767607000043
						],
						[
							-80.18727082399994,
							25.766445524000062
						],
						[
							-80.18728183999991,
							25.766353817000038
						],
						[
							-80.18724592399991,
							25.76567232900004
						],
						[
							-80.1872446779999,
							25.765625000000057
						],
						[
							-80.18725242799991,
							25.76550719100004
						],
						[
							-80.18749542699993,
							25.76366819000009
						],
						[
							-80.18750836099993,
							25.763593134000075
						],
						[
							-80.18752788699994,
							25.763519517000077
						],
						[
							-80.18755385299994,
							25.763447917000065
						],
						[
							-80.18758605399995,
							25.763378896000063
						],
						[
							-80.18762423699991,
							25.76331299700007
						],
						[
							-80.1876681039999,
							25.763250735000042
						],
						[
							-80.18765867799993,
							25.76314300000007
						],
						[
							-80.18766188299992,
							25.76306714800006
						],
						[
							-80.18779088299993,
							25.761543147000054
						],
						[
							-80.1877942619999,
							25.761510377000036
						],
						[
							-80.18785456099994,
							25.76101479500005
						],
						[
							-80.18792693899991,
							25.759649395000054
						],
						[
							-80.1879334379999,
							25.759578849000036
						],
						[
							-80.18794549499995,
							25.759509037000043
						],
						[
							-80.18796303399995,
							25.759440398000038
						],
						[
							-80.18798594399993,
							25.75937335900005
						],
						[
							-80.18801408299993,
							25.759308342000054
						],
						[
							-80.18804727499992,
							25.759245754000062
						],
						[
							-80.1880293399999,
							25.759171166000048
						],
						[
							-80.18801613999995,
							25.759043819000055
						],
						[
							-80.18799513999996,
							25.75838881800007
						],
						[
							-80.18799583099991,
							25.758314467000048
						],
						[
							-80.18800266199992,
							25.75824042800008
						],
						[
							-80.18801558599995,
							25.758167206000053
						],
						[
							-80.18803451399992,
							25.758095301000083
						],
						[
							-80.18811951499993,
							25.757819302000087
						],
						[
							-80.18813000799992,
							25.75778736500007
						],
						[
							-80.18824796099995,
							25.757449889000046
						],
						[
							-80.18827799399992,
							25.757376154000042
						],
						[
							-80.18831443199991,
							25.75730536500004
						],
						[
							-80.18835698899994,
							25.75723807700007
						],
						[
							-80.18840533299993,
							25.757174818000067
						],
						[
							-80.18845908299994,
							25.757116084000074
						],
						[
							-80.18854121499993,
							25.757033952000086
						],
						[
							-80.18863024299992,
							25.756917786000088
						],
						[
							-80.18866693599995,
							25.756837433000044
						],
						[
							-80.18869730699993,
							25.756777034000038
						],
						[
							-80.18873213099994,
							25.756719088000068
						],
						[
							-80.18877121199995,
							25.756663925000055
						],
						[
							-80.18881432799992,
							25.756611854000084
						],
						[
							-80.18886123699991,
							25.756563172000085
						],
						[
							-80.1889116719999,
							25.75651815300006
						],
						[
							-80.18925341699992,
							25.756239226000048
						],
						[
							-80.18937233899993,
							25.756157164000058
						],
						[
							-80.18946374799992,
							25.756111114000078
						],
						[
							-80.1900117479999,
							25.755873115000043
						],
						[
							-80.1900624139999,
							25.75585291400006
						],
						[
							-80.19009104499992,
							25.755844961000037
						],
						[
							-80.19019292699994,
							25.75574307900007
						],
						[
							-80.1902759699999,
							25.755681183000036
						],
						[
							-80.19086596999995,
							25.75529218300005
						],
						[
							-80.19091133899992,
							25.75526416400004
						],
						[
							-80.19105341399995,
							25.755197914000064
						],
						[
							-80.1912048339999,
							25.755157341000086
						],
						[
							-80.19136099999993,
							25.75514367800008
						],
						[
							-80.19151716599993,
							25.755157341000086
						],
						[
							-80.19166858599993,
							25.755197914000064
						],
						[
							-80.19179552999992,
							25.75525710800008
						],
						[
							-80.19266158199991,
							25.75491618200005
						],
						[
							-80.19272417899992,
							25.754894171000046
						],
						[
							-80.19281931599994,
							25.75486461400004
						],
						[
							-80.1935923879999,
							25.754382115000055
						],
						[
							-80.19374734299993,
							25.754281908000053
						],
						[
							-80.19373267799995,
							25.754122000000052
						],
						[
							-80.1937463399999,
							25.753965835000088
						],
						[
							-80.19378691399993,
							25.75381441400009
						],
						[
							-80.1938531639999,
							25.753672339000047
						],
						[
							-80.19394307899996,
							25.753543927000067
						],
						[
							-80.19405392699991,
							25.753433080000036
						],
						[
							-80.19418508299992,
							25.753341593000073
						],
						[
							-80.19509862899992,
							25.752822678000086
						],
						[
							-80.19663343799994,
							25.751907804000044
						],
						[
							-80.1969824759999,
							25.75156780100008
						],
						[
							-80.1970215369999,
							25.751529274000063
						],
						[
							-80.1970637149999,
							25.751494188000038
						],
						[
							-80.19710870799992,
							25.751462794000076
						],
						[
							-80.19715619399994,
							25.751435316000084
						],
						[
							-80.19720583399993,
							25.75141195000009
						],
						[
							-80.1972407959999,
							25.75134354900007
						],
						[
							-80.1972819579999,
							25.75127868900006
						],
						[
							-80.19732896499994,
							25.751217931000042
						],
						[
							-80.19738140999993,
							25.75116180100008
						],
						[
							-80.19780440999995,
							25.75074580100005
						],
						[
							-80.1978431949999,
							25.750706989000037
						],
						[
							-80.19788515599993,
							25.75067163600005
						],
						[
							-80.1979299859999,
							25.750639999000043
						],
						[
							-80.1979773569999,
							25.750612311000054
						],
						[
							-80.19802692099995,
							25.75058877400005
						],
						[
							-80.19805940499992,
							25.750521972000058
						],
						[
							-80.19809775199991,
							25.750458355000035
						],
						[
							-80.19814165299994,
							25.75039843600007
						],
						[
							-80.19819075399994,
							25.750342697000065
						],
						[
							-80.19939175399992,
							25.749089698000095
						],
						[
							-80.19946151499994,
							25.74902426700004
						],
						[
							-80.20053163699993,
							25.748122611000042
						],
						[
							-80.20111306099994,
							25.747631874000035
						],
						[
							-80.20179799999994,
							25.74824200000006
						],
						[
							-80.20179458799993,
							25.74824481400009
						],
						[
							-80.2019159059999,
							25.748365565000086
						],
						[
							-80.20198447199994,
							25.748444024000037
						],
						[
							-80.20218999999992,
							25.748680000000036
						],
						[
							-80.20246064699995,
							25.74895895800006
						],
						[
							-80.20266365699992,
							25.749167898000053
						],
						[
							-80.20287844799992,
							25.74936216000009
						],
						[
							-80.20314399599994,
							25.74959333000004
						],
						[
							-80.20344494799991,
							25.74990494400004
						],
						[
							-80.20370386799993,
							25.750200675000087
						],
						[
							-80.20382999999993,
							25.750360000000057
						],
						[
							-80.20400939599995,
							25.75029023500008
						],
						[
							-80.20440676899995,
							25.750760118000073
						],
						[
							-80.20518600699995,
							25.751818221000065
						],
						[
							-80.2056199999999,
							25.752480000000048
						],
						[
							-80.20524383899993,
							25.752874165000037
						],
						[
							-80.20384046599992,
							25.75370857300004
						],
						[
							-80.20314051899993,
							25.754485172000045
						],
						[
							-80.20219169599994,
							25.75503380100008
						],
						[
							-80.20156171399992,
							25.75543986200006
						],
						[
							-80.2011283949999,
							25.755733900000052
						],
						[
							-80.20071268599992,
							25.75612779100004
						],
						[
							-80.2004411449999,
							25.756457139000076
						],
						[
							-80.2003162819999,
							25.757069603000048
						],
						[
							-80.20002999999991,
							25.757270000000062
						],
						[
							-80.19993849799994,
							25.757719014000088
						],
						[
							-80.1999140989999,
							25.75819402100007
						],
						[
							-80.19989340799992,
							25.758721619000085
						],
						[
							-80.19986707299996,
							25.75938082500005
						],
						[
							-80.19985025099993,
							25.76004094200005
						],
						[
							-80.19983550699995,
							25.76076833600007
						],
						[
							-80.19981776899994,
							25.761560383000074
						],
						[
							-80.19980680499992,
							25.761908150000068
						],
						[
							-80.1998099999999,
							25.761910000000057
						],
						[
							-80.20001783899994,
							25.762035488000038
						],
						[
							-80.20009609399995,
							25.76330239200007
						],
						[
							-80.20022141999993,
							25.765331382000056
						],
						[
							-80.19994652399993,
							25.768865756000082
						],
						[
							-80.19960989599991,
							25.770176837000065
						],
						[
							-80.19979250999995,
							25.77059345200007
						],
						[
							-80.19980769999995,
							25.770628106000064
						],
						[
							-80.19971893299993,
							25.770977747000074
						],
						[
							-80.1996796649999,
							25.770933570000068
						],
						[
							-80.1993924489999,
							25.770799536000084
						],
						[
							-80.19895204999995,
							25.77037828500005
						],
						[
							-80.19879886799993,
							25.770014478000064
						],
						[
							-80.19851165199992,
							25.769669819000057
						],
						[
							-80.19820528799994,
							25.76934430700004
						],
						[
							-80.1978989239999,
							25.769076238000082
						],
						[
							-80.19759255999992,
							25.76886561300006
						],
						[
							-80.19728619599994,
							25.76873157900008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami",
				"Name": "Brickell",
				"RegionID": "55477"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.71545253999994,
					28.250265884000044,
					-82.70719580999992,
					28.25954551500007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.70737964299991,
							28.259269497000048
						],
						[
							-82.70725591099995,
							28.259259979000035
						],
						[
							-82.70728446499993,
							28.25441539700006
						],
						[
							-82.70722285999994,
							28.251536090000062
						],
						[
							-82.70719580999992,
							28.25027183300006
						],
						[
							-82.71003331799994,
							28.250265884000044
						],
						[
							-82.71003331799994,
							28.250575214000037
						],
						[
							-82.71273400599995,
							28.25056331700006
						],
						[
							-82.71275185199994,
							28.251360436000084
						],
						[
							-82.71407840099995,
							28.251360436000084
						],
						[
							-82.71409624699993,
							28.253353235000077
						],
						[
							-82.71545236399993,
							28.253349092000065
						],
						[
							-82.71545253999994,
							28.258698744000075
						],
						[
							-82.71399454499993,
							28.258726980000063
						],
						[
							-82.71399454499993,
							28.259535997000057
						],
						[
							-82.71284288599992,
							28.25954551500007
						],
						[
							-82.71282384999995,
							28.25927901500006
						],
						[
							-82.71282384999995,
							28.25874601600009
						],
						[
							-82.7125002439999,
							28.25874601600009
						],
						[
							-82.7125002439999,
							28.259145765000085
						],
						[
							-82.71217663699991,
							28.259145765000085
						],
						[
							-82.71217663699991,
							28.258755533000055
						],
						[
							-82.71200531599993,
							28.258755533000055
						],
						[
							-82.71200531599993,
							28.259317086000067
						],
						[
							-82.71184351199992,
							28.259307568000054
						],
						[
							-82.71184351199992,
							28.25876505100007
						],
						[
							-82.70928321199995,
							28.25876505100007
						],
						[
							-82.70928321199995,
							28.25932660400008
						],
						[
							-82.70867406999992,
							28.259336122000036
						],
						[
							-82.70867406999992,
							28.25874601600009
						],
						[
							-82.70738916099992,
							28.25874601600009
						],
						[
							-82.70737964299991,
							28.259269497000048
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pasco",
				"City": "New Port Richey",
				"Name": "North Park",
				"RegionID": "116942"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.937325,
					28.999958000000003,
					-80.91413269599998,
					29.023588950000033
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.933719,
							29.017890000000005
						],
						[
							-80.93372059499995,
							29.018108442000024
						],
						[
							-80.933366,
							29.018143999999996
						],
						[
							-80.933211,
							29.01829
						],
						[
							-80.93314,
							29.018390000000004
						],
						[
							-80.933102,
							29.018528
						],
						[
							-80.933201,
							29.018826000000004
						],
						[
							-80.933703,
							29.019734
						],
						[
							-80.934103,
							29.019316
						],
						[
							-80.933969,
							29.020092
						],
						[
							-80.934113,
							29.019987
						],
						[
							-80.934364,
							29.019802000000002
						],
						[
							-80.93444651499993,
							29.01988403500008
						],
						[
							-80.93288775999997,
							29.02105738700004
						],
						[
							-80.93249752899999,
							29.021228708000024
						],
						[
							-80.92640512799994,
							29.023588950000033
						],
						[
							-80.92483887699996,
							29.01990588700005
						],
						[
							-80.92435156299997,
							29.019114002000038
						],
						[
							-80.92362059299995,
							29.018337346000067
						],
						[
							-80.92316944699996,
							29.01770948600006
						],
						[
							-80.92219862699996,
							29.015615560000068
						],
						[
							-80.92210344799999,
							29.015196775000046
						],
						[
							-80.92208441299994,
							29.01439727600007
						],
						[
							-80.92193212699993,
							29.013788134000038
						],
						[
							-80.91953362999999,
							29.008496213000058
						],
						[
							-80.91892448799996,
							29.007639607000044
						],
						[
							-80.91816306099997,
							29.006897215000034
						],
						[
							-80.91732549099999,
							29.00634518000004
						],
						[
							-80.91555517199998,
							29.00545050300008
						],
						[
							-80.91456531599994,
							29.004841361000047
						],
						[
							-80.91413269599998,
							29.004419292000023
						],
						[
							-80.914161,
							29.004409
						],
						[
							-80.915095,
							29.004146
						],
						[
							-80.91555,
							29.003945000000005
						],
						[
							-80.918105,
							29.003214999999997
						],
						[
							-80.921962,
							29.002157
						],
						[
							-80.923879,
							29.001557000000002
						],
						[
							-80.925741,
							29.000928000000002
						],
						[
							-80.92893219899997,
							29.00041690200004
						],
						[
							-80.929019,
							29.000403
						],
						[
							-80.930801,
							28.999958000000003
						],
						[
							-80.931315,
							29.001669
						],
						[
							-80.931526,
							29.001724
						],
						[
							-80.93177,
							29.001774
						],
						[
							-80.932129,
							29.001822
						],
						[
							-80.93218600000002,
							29.001825
						],
						[
							-80.932455,
							29.002601000000002
						],
						[
							-80.932626,
							29.00256
						],
						[
							-80.93459,
							29.002538
						],
						[
							-80.936903,
							29.003821
						],
						[
							-80.935709,
							29.005233999999998
						],
						[
							-80.937325,
							29.005952
						],
						[
							-80.934142,
							29.005995
						],
						[
							-80.933595,
							29.004559999999998
						],
						[
							-80.933172,
							29.004559999999998
						],
						[
							-80.933148,
							29.004498
						],
						[
							-80.932329,
							29.0048
						],
						[
							-80.9326,
							29.005238000000002
						],
						[
							-80.933336,
							29.004983
						],
						[
							-80.933519,
							29.005457000000003
						],
						[
							-80.933164,
							29.005549
						],
						[
							-80.933331,
							29.006224
						],
						[
							-80.93306,
							29.006314999999997
						],
						[
							-80.933352,
							29.007319
						],
						[
							-80.933018,
							29.007411
						],
						[
							-80.933122,
							29.008908000000005
						],
						[
							-80.931431,
							29.009419
						],
						[
							-80.930879,
							29.007876
						],
						[
							-80.929915,
							29.008122
						],
						[
							-80.929108,
							29.008328999999996
						],
						[
							-80.92841300000002,
							29.008530000000004
						],
						[
							-80.928955,
							29.009937
						],
						[
							-80.930113,
							29.009604999999997
						],
						[
							-80.93184,
							29.015399000000002
						],
						[
							-80.93318300000001,
							29.015022
						],
						[
							-80.93323000000001,
							29.016256
						],
						[
							-80.933462,
							29.017009
						],
						[
							-80.934085,
							29.016833
						],
						[
							-80.93414,
							29.016617000000004
						],
						[
							-80.935139,
							29.016491000000002
						],
						[
							-80.935158,
							29.017071000000005
						],
						[
							-80.934629,
							29.017241000000002
						],
						[
							-80.934074,
							29.017420000000005
						],
						[
							-80.934076,
							29.017556999999996
						],
						[
							-80.933587,
							29.017628
						],
						[
							-80.933719,
							29.017890000000005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Volusia",
				"City": "New Smyrna Beach",
				"Name": "South West",
				"RegionID": "121790"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.21476514199998,
					25.959781753000073,
					-80.20574469099995,
					25.96963173900008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.20574469099995,
							25.959781753000073
						],
						[
							-80.20657899599996,
							25.959833418000073
						],
						[
							-80.20993263899999,
							25.95997410900003
						],
						[
							-80.21362216699998,
							25.96005778300003
						],
						[
							-80.21390112899996,
							25.960064110000076
						],
						[
							-80.21393832899997,
							25.96119389300003
						],
						[
							-80.21406128199999,
							25.96380664900005
						],
						[
							-80.21412275799999,
							25.96551262500003
						],
						[
							-80.21410082099999,
							25.96568221800004
						],
						[
							-80.21399464399997,
							25.96713330800003
						],
						[
							-80.21427538799998,
							25.96793145600003
						],
						[
							-80.21469407099994,
							25.969121761000054
						],
						[
							-80.21476514199998,
							25.969323814000063
						],
						[
							-80.21413742299995,
							25.968879315000038
						],
						[
							-80.21258584299994,
							25.968899056000055
						],
						[
							-80.21187817599997,
							25.969115285000044
						],
						[
							-80.21091172999996,
							25.969117286000028
						],
						[
							-80.21003768899999,
							25.969119095000053
						],
						[
							-80.20845926599998,
							25.969122363000054
						],
						[
							-80.20750906899997,
							25.969569626000066
						],
						[
							-80.20715824999996,
							25.969588189000035
						],
						[
							-80.206787933,
							25.969607783000072
						],
						[
							-80.20605962599996,
							25.96963173900008
						],
						[
							-80.20601998999996,
							25.968819188000055
						],
						[
							-80.20598500399996,
							25.96697006200003
						],
						[
							-80.20574469099995,
							25.959781753000073
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Gardens",
				"Name": "Andover",
				"RegionID": "123443"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.64609329599995,
					30.184142918000077,
					-81.61714990699994,
					30.21662432200003
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.63420115799994,
							30.199409797000047
						],
						[
							-81.63200015699994,
							30.19720879600004
						],
						[
							-81.63052139199993,
							30.195073026000042
						],
						[
							-81.63019284699999,
							30.19326574600007
						],
						[
							-81.631014399,
							30.190472760000038
						],
						[
							-81.63249304199996,
							30.187351180000064
						],
						[
							-81.63508992299995,
							30.184142918000077
						],
						[
							-81.63586490599994,
							30.184455008000043
						],
						[
							-81.63726390499994,
							30.185046008000025
						],
						[
							-81.63822290599997,
							30.185458009000058
						],
						[
							-81.63918390599997,
							30.18588600800007
						],
						[
							-81.640616,
							30.186515000000004
						],
						[
							-81.64142098999997,
							30.18753545200008
						],
						[
							-81.64092943599996,
							30.187466814000064
						],
						[
							-81.64003325599998,
							30.18834450800006
						],
						[
							-81.63998145699998,
							30.188391437000064
						],
						[
							-81.63992616999997,
							30.188434201000067
						],
						[
							-81.63986772899995,
							30.18847254200006
						],
						[
							-81.63980648599994,
							30.18850622900004
						],
						[
							-81.63974281299996,
							30.188535058000067
						],
						[
							-81.63967709299999,
							30.188558855000053
						],
						[
							-81.63960972299998,
							30.188577476000034
						],
						[
							-81.63611901499996,
							30.18939773400007
						],
						[
							-81.63584474899994,
							30.189537115000068
						],
						[
							-81.63510154999994,
							30.191377456000055
						],
						[
							-81.635786732,
							30.195015243000057
						],
						[
							-81.64014591599994,
							30.198052077000057
						],
						[
							-81.64363722999997,
							30.197498764000045
						],
						[
							-81.643778,
							30.197487678000073
						],
						[
							-81.64393416499996,
							30.197501341000073
						],
						[
							-81.64408558599996,
							30.19754191400006
						],
						[
							-81.64422766099995,
							30.197608164000027
						],
						[
							-81.64431858599994,
							30.197668289000035
						],
						[
							-81.64570658699995,
							30.19871228800002
						],
						[
							-81.64574407299995,
							30.198742079000052
						],
						[
							-81.64585491999998,
							30.19885292700008
						],
						[
							-81.64594483599996,
							30.19898133900006
						],
						[
							-81.64601108599999,
							30.199123413000056
						],
						[
							-81.64605165899997,
							30.19927483400005
						],
						[
							-81.64606523599997,
							30.199418596000044
						],
						[
							-81.64607325299994,
							30.199999951000056
						],
						[
							-81.64609329599995,
							30.201861152000046
						],
						[
							-81.64607965999994,
							30.202022165000074
						],
						[
							-81.64603908699996,
							30.20217358600007
						],
						[
							-81.64597283599994,
							30.20231566100006
						],
						[
							-81.64588292099995,
							30.202444073000038
						],
						[
							-81.64577207299999,
							30.20255492000007
						],
						[
							-81.64564366099995,
							30.20264483500006
						],
						[
							-81.64561058399994,
							30.20266301800007
						],
						[
							-81.63398084499994,
							30.208741187000044
						],
						[
							-81.633947,
							30.20875776400004
						],
						[
							-81.63383760399995,
							30.208807442000083
						],
						[
							-81.63103678799996,
							30.209815819000028
						],
						[
							-81.63046819399995,
							30.210056406000035
						],
						[
							-81.62451400099997,
							30.216243598000062
						],
						[
							-81.62446211199995,
							30.21629337700006
						],
						[
							-81.62440640899996,
							30.216338849000067
						],
						[
							-81.62434725099996,
							30.216379724000035
						],
						[
							-81.62428501499994,
							30.21641573900007
						],
						[
							-81.62422009999995,
							30.216446666000024
						],
						[
							-81.62415292099996,
							30.216472305000025
						],
						[
							-81.62408390699994,
							30.216492493000032
						],
						[
							-81.6240135,
							30.216507100000058
						],
						[
							-81.62333283499999,
							30.216613541000076
						],
						[
							-81.623194,
							30.21662432200003
						],
						[
							-81.62312534999995,
							30.216618316000048
						],
						[
							-81.62244847999995,
							30.215899867000076
						],
						[
							-81.62218681099995,
							30.215638198000075
						],
						[
							-81.62145413899998,
							30.215690532000057
						],
						[
							-81.62030279699997,
							30.215847533000044
						],
						[
							-81.61951779099996,
							30.215742866000028
						],
						[
							-81.61888978599995,
							30.215795199000073
						],
						[
							-81.61794777899996,
							30.215899867000076
						],
						[
							-81.61746097799994,
							30.215991142000064
						],
						[
							-81.617513,
							30.215586
						],
						[
							-81.61758390699998,
							30.214918010000076
						],
						[
							-81.61759690799994,
							30.214532011000074
						],
						[
							-81.61759890699994,
							30.21447601000006
						],
						[
							-81.61760690799997,
							30.214010011000024
						],
						[
							-81.61759890699994,
							30.21385601000003
						],
						[
							-81.61755390799993,
							30.21317301000005
						],
						[
							-81.61753090799994,
							30.212662011000077
						],
						[
							-81.61746990799999,
							30.211605011000078
						],
						[
							-81.61744690699999,
							30.21080801000005
						],
						[
							-81.61738590799996,
							30.20982601000003
						],
						[
							-81.61737795999994,
							30.209196001000066
						],
						[
							-81.61736285599994,
							30.20914501900006
						],
						[
							-81.61734790699995,
							30.208540010000032
						],
						[
							-81.61730190899993,
							30.20822701000003
						],
						[
							-81.61729390799997,
							30.207914010000025
						],
						[
							-81.61729390799997,
							30.207676010000057
						],
						[
							-81.61728690699994,
							30.20748901100006
						],
						[
							-81.61727890799995,
							30.206989011000076
						],
						[
							-81.61722590799997,
							30.20636401100006
						],
						[
							-81.61720490799996,
							30.205994011000026
						],
						[
							-81.61718796599996,
							30.205700006000033
						],
						[
							-81.61717190699994,
							30.204948010000066
						],
						[
							-81.61715690799997,
							30.204586011000057
						],
						[
							-81.61714990699994,
							30.204044010000075
						],
						[
							-81.61716390799995,
							30.203827011000048
						],
						[
							-81.61717281699998,
							30.203685
						],
						[
							-81.61721590799993,
							30.20341601100006
						],
						[
							-81.61729590799996,
							30.203089010000046
						],
						[
							-81.61732150499995,
							30.202998027000035
						],
						[
							-81.61739790699995,
							30.202806011000064
						],
						[
							-81.61747190799998,
							30.20263501100004
						],
						[
							-81.61759290799995,
							30.202397011000073
						],
						[
							-81.61778590799997,
							30.202016010000083
						],
						[
							-81.61786890799993,
							30.20190001000003
						],
						[
							-81.61869490699996,
							30.20095001000004
						],
						[
							-81.61873690699997,
							30.20090601100003
						],
						[
							-81.61923986799997,
							30.200300969000068
						],
						[
							-81.62082829599996,
							30.20148034500005
						],
						[
							-81.62164983199995,
							30.202794733000076
						],
						[
							-81.62164966099994,
							30.204273423000075
						],
						[
							-81.62164966299997,
							30.20542347600008
						],
						[
							-81.62197810499998,
							30.20673793800006
						],
						[
							-81.62296401099997,
							30.20723070800005
						],
						[
							-81.62493554199995,
							30.208216655000058
						],
						[
							-81.62856914499997,
							30.205775317000075
						],
						[
							-81.62898806499999,
							30.20549385400005
						],
						[
							-81.62763242299997,
							30.203806679000024
						],
						[
							-81.62813924799997,
							30.203456898000073
						],
						[
							-81.62908865299994,
							30.202885828000035
						],
						[
							-81.62917431399995,
							30.202885828000035
						],
						[
							-81.62939560399997,
							30.20285727400005
						],
						[
							-81.63005947299996,
							30.202407556000026
						],
						[
							-81.63119447599996,
							30.201593780000056
						],
						[
							-81.63420115799994,
							30.199409797000047
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Beauclerc",
				"RegionID": "123594"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.15105416599994,
					25.788045538000066,
					-80.14537201199994,
					25.79362115200007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.14846168299994,
							25.79362115200007
						],
						[
							-80.14711217199994,
							25.79362115200007
						],
						[
							-80.14537201199994,
							25.791738939000084
						],
						[
							-80.14537201199994,
							25.790211860000056
						],
						[
							-80.14625984899993,
							25.788045538000066
						],
						[
							-80.15105416599994,
							25.788045538000066
						],
						[
							-80.15101865299994,
							25.79362115200007
						],
						[
							-80.14846168299994,
							25.79362115200007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Beach",
				"Name": "Belle Isle",
				"RegionID": "123612"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.80758408799994,
					30.408001963000057,
					-81.7352585079999,
					30.45622117600004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.76449898599992,
							30.439734989000044
						],
						[
							-81.76367597299992,
							30.438290829000042
						],
						[
							-81.76352190799992,
							30.438349010000085
						],
						[
							-81.76341989199994,
							30.43837018600004
						],
						[
							-81.7626727949999,
							30.438066142000082
						],
						[
							-81.76218902499994,
							30.437248866000058
						],
						[
							-81.76191291499993,
							30.437164925000047
						],
						[
							-81.76165687499991,
							30.437194934000047
						],
						[
							-81.7614839069999,
							30.437326010000046
						],
						[
							-81.76110290699995,
							30.437636009000073
						],
						[
							-81.76096490899994,
							30.437714008000057
						],
						[
							-81.76079891099995,
							30.437767186000087
						],
						[
							-81.76065384299994,
							30.43772612800007
						],
						[
							-81.76057080699991,
							30.437666095000054
						],
						[
							-81.7604458269999,
							30.437428029000046
						],
						[
							-81.76044582799996,
							30.437278989000053
						],
						[
							-81.76059790699992,
							30.436998010000078
						],
						[
							-81.76063283799994,
							30.43691496200006
						],
						[
							-81.76078501299992,
							30.436772095000038
						],
						[
							-81.76088190699994,
							30.43658701000004
						],
						[
							-81.76095095699992,
							30.43646802800004
						],
						[
							-81.76097209099994,
							30.436383980000073
						],
						[
							-81.76091690699991,
							30.436289013000074
						],
						[
							-81.76084699499995,
							30.43621685700009
						],
						[
							-81.76077090599995,
							30.436199012000092
						],
						[
							-81.76038390699995,
							30.43620500900005
						],
						[
							-81.76000390699994,
							30.43614001000009
						],
						[
							-81.75962990499994,
							30.436038008000086
						],
						[
							-81.75946390999992,
							30.435943012000052
						],
						[
							-81.75933980799994,
							30.43590715400006
						],
						[
							-81.75924290699993,
							30.43578201000008
						],
						[
							-81.75908371899993,
							30.435567004000063
						],
						[
							-81.7591250989999,
							30.435519024000083
						],
						[
							-81.7590009079999,
							30.435342007000088
						],
						[
							-81.75894482699994,
							30.435192017000077
						],
						[
							-81.75897975899994,
							30.435024921000032
						],
						[
							-81.75906309499993,
							30.434954057000088
						],
						[
							-81.7589040229999,
							30.434589941000073
						],
						[
							-81.75870995499992,
							30.434386940000085
						],
						[
							-81.75846789399992,
							30.434291829000074
						],
						[
							-81.75803196399994,
							30.43453713300005
						],
						[
							-81.7577209079999,
							30.43460200900006
						],
						[
							-81.75756889899992,
							30.434596062000082
						],
						[
							-81.7574029079999,
							30.434542011000072
						],
						[
							-81.7572709069999,
							30.434513010000042
						],
						[
							-81.75719487099991,
							30.434495084000048
						],
						[
							-81.75707097399993,
							30.43438089500006
						],
						[
							-81.7568079159999,
							30.434303924000066
						],
						[
							-81.75664190799995,
							30.434322009000084
						],
						[
							-81.7561578989999,
							30.434321958000055
						],
						[
							-81.7559779149999,
							30.434375096000057
						],
						[
							-81.75548690799991,
							30.434322009000084
						],
						[
							-81.75514790799991,
							30.434226010000092
						],
						[
							-81.75469085999993,
							30.43411913500006
						],
						[
							-81.75455290699995,
							30.434024011000073
						],
						[
							-81.75442189099994,
							30.433964066000044
						],
						[
							-81.7543249009999,
							30.433952101000045
						],
						[
							-81.7542238449999,
							30.433949171000055
						],
						[
							-81.75401690699994,
							30.43376801200009
						],
						[
							-81.75363090799993,
							30.433560009000075
						],
						[
							-81.75332590799991,
							30.433297010000043
						],
						[
							-81.75321394199995,
							30.43317197000005
						],
						[
							-81.75300490799992,
							30.43304801100004
						],
						[
							-81.75276393299993,
							30.43289493000009
						],
						[
							-81.75242588499992,
							30.432867880000057
						],
						[
							-81.75187990799992,
							30.43310301100007
						],
						[
							-81.75159096099992,
							30.43324213500006
						],
						[
							-81.75093184699995,
							30.43333918900004
						],
						[
							-81.75085095499992,
							30.433254940000044
						],
						[
							-81.74813590799994,
							30.432216010000044
						],
						[
							-81.74699490799992,
							30.431579011000057
						],
						[
							-81.74660884899993,
							30.43134406900009
						],
						[
							-81.7464639079999,
							30.431108011000052
						],
						[
							-81.74630396399994,
							30.43074799500005
						],
						[
							-81.74625590699992,
							30.43030501000004
						],
						[
							-81.74616190499995,
							30.42982801200009
						],
						[
							-81.74601694799992,
							30.429577976000076
						],
						[
							-81.74582494799995,
							30.42939792900006
						],
						[
							-81.74516590999993,
							30.42907901400008
						],
						[
							-81.74497290799991,
							30.42905201100007
						],
						[
							-81.74429790699992,
							30.429065011000034
						],
						[
							-81.74392790699994,
							30.429093010000088
						],
						[
							-81.74325290799993,
							30.429107010000056
						],
						[
							-81.74285088399995,
							30.429093142000053
						],
						[
							-81.74243282299994,
							30.428899113000057
						],
						[
							-81.74219190899993,
							30.42863600900006
						],
						[
							-81.7419189069999,
							30.428095010000046
						],
						[
							-81.74162890799994,
							30.42766601500006
						],
						[
							-81.7410349079999,
							30.427201010000086
						],
						[
							-81.7402639089999,
							30.426460011000074
						],
						[
							-81.73984497499993,
							30.426105895000035
						],
						[
							-81.73921890799994,
							30.42592001100007
						],
						[
							-81.73806090999994,
							30.425677009000083
						],
						[
							-81.73703177399995,
							30.425226132000034
						],
						[
							-81.73672790799992,
							30.42409200600008
						],
						[
							-81.73667298799995,
							30.423133987000085
						],
						[
							-81.73646190799991,
							30.422788010000094
						],
						[
							-81.73638490699994,
							30.422638010000075
						],
						[
							-81.7362259059999,
							30.422425010000037
						],
						[
							-81.73592799999994,
							30.422160000000076
						],
						[
							-81.73546525199993,
							30.421681539000076
						],
						[
							-81.7352585079999,
							30.42147949400004
						],
						[
							-81.73540599999991,
							30.42124200000006
						],
						[
							-81.73592890599991,
							30.42040000800006
						],
						[
							-81.73628990499992,
							30.41986600900009
						],
						[
							-81.73670590499995,
							30.419335008000076
						],
						[
							-81.7371289049999,
							30.41884000800008
						],
						[
							-81.73774690599993,
							30.41819200900005
						],
						[
							-81.73817390599993,
							30.417801008000087
						],
						[
							-81.7387539049999,
							30.41731100900006
						],
						[
							-81.73914290499994,
							30.417007008000045
						],
						[
							-81.73953990599995,
							30.41672300800008
						],
						[
							-81.73997490499994,
							30.416437009000052
						],
						[
							-81.74040190599993,
							30.416174008000045
						],
						[
							-81.74054690499992,
							30.416092008000078
						],
						[
							-81.74065190599993,
							30.41602900800007
						],
						[
							-81.7413629049999,
							30.415663008000077
						],
						[
							-81.74183290499991,
							30.41542000900006
						],
						[
							-81.7423069059999,
							30.41513500900004
						],
						[
							-81.7425779049999,
							30.414983008000036
						],
						[
							-81.74596890499993,
							30.413114009000083
						],
						[
							-81.74680590499992,
							30.412657008000057
						],
						[
							-81.74683890499995,
							30.412641008000037
						],
						[
							-81.7474879049999,
							30.412287008000074
						],
						[
							-81.74755090499991,
							30.412254008000048
						],
						[
							-81.7476169059999,
							30.412216008000087
						],
						[
							-81.7477979059999,
							30.412115008000058
						],
						[
							-81.74799090599993,
							30.412011009000082
						],
						[
							-81.74828590499993,
							30.411869009000043
						],
						[
							-81.74851290599992,
							30.41173700900004
						],
						[
							-81.74964290499992,
							30.41111100900008
						],
						[
							-81.74984590499992,
							30.410982008000076
						],
						[
							-81.75056590499992,
							30.410477008000043
						],
						[
							-81.75093990499994,
							30.41016500800004
						],
						[
							-81.75130190499993,
							30.409838009000055
						],
						[
							-81.75161690599992,
							30.409517008000076
						],
						[
							-81.75189190499992,
							30.409233009000047
						],
						[
							-81.7521199059999,
							30.40895400900007
						],
						[
							-81.7523129459999,
							30.408784042000036
						],
						[
							-81.75239309999995,
							30.40865200900004
						],
						[
							-81.75220690599991,
							30.40833501100008
						],
						[
							-81.75187685199995,
							30.408001963000057
						],
						[
							-81.7522849049999,
							30.408230006000057
						],
						[
							-81.7525930239999,
							30.408325864000062
						],
						[
							-81.75531590499992,
							30.412938008000086
						],
						[
							-81.75695880799992,
							30.41585817600009
						],
						[
							-81.7580029049999,
							30.41585000800006
						],
						[
							-81.75923190499992,
							30.415845008000073
						],
						[
							-81.76022890599995,
							30.415833008000053
						],
						[
							-81.76122990499994,
							30.415827009000058
						],
						[
							-81.7665959059999,
							30.41578400800006
						],
						[
							-81.76688090599993,
							30.41578000800007
						],
						[
							-81.76824390599995,
							30.415771008000036
						],
						[
							-81.76857990499991,
							30.41576900900009
						],
						[
							-81.77500990499993,
							30.415629008000053
						],
						[
							-81.77510390299994,
							30.415610008000048
						],
						[
							-81.77519405299995,
							30.415570131000038
						],
						[
							-81.77522390399992,
							30.415447006000083
						],
						[
							-81.77517690499991,
							30.41251700800007
						],
						[
							-81.77516303999994,
							30.41222902400005
						],
						[
							-81.77524690699994,
							30.412321011000078
						],
						[
							-81.78244290799995,
							30.41982601000007
						],
						[
							-81.78362154399991,
							30.42082284400004
						],
						[
							-81.7858919059999,
							30.422743009000044
						],
						[
							-81.78837390599995,
							30.425283008000065
						],
						[
							-81.79853890599992,
							30.43524700900008
						],
						[
							-81.80758408799994,
							30.44418401700005
						],
						[
							-81.80733690599993,
							30.44437800800006
						],
						[
							-81.80712390499991,
							30.44451300900005
						],
						[
							-81.8069679059999,
							30.444600008000066
						],
						[
							-81.80679590499994,
							30.44466400800008
						],
						[
							-81.80647590599995,
							30.444740008000053
						],
						[
							-81.80265390599993,
							30.44513900900006
						],
						[
							-81.80213390499995,
							30.445182008000078
						],
						[
							-81.8018349059999,
							30.44518800900005
						],
						[
							-81.80160490599991,
							30.445182008000078
						],
						[
							-81.8012269059999,
							30.44515500900008
						],
						[
							-81.7946549049999,
							30.444462008000073
						],
						[
							-81.79424290599991,
							30.444420008000066
						],
						[
							-81.79353290499995,
							30.44430500800007
						],
						[
							-81.79065690499993,
							30.443745009000054
						],
						[
							-81.7903059059999,
							30.443666008000037
						],
						[
							-81.79000090499994,
							30.443550009000035
						],
						[
							-81.78902390499991,
							30.443134008000072
						],
						[
							-81.78854390599992,
							30.442917009000045
						],
						[
							-81.78807090599992,
							30.44269000800006
						],
						[
							-81.78608690599992,
							30.441662009000083
						],
						[
							-81.78581190599994,
							30.44154400900004
						],
						[
							-81.77799690499995,
							30.43874100800008
						],
						[
							-81.7775859059999,
							30.438592008000057
						],
						[
							-81.7771339059999,
							30.43837000800005
						],
						[
							-81.77559290599993,
							30.437482009000068
						],
						[
							-81.77528590599992,
							30.437303008000075
						],
						[
							-81.77505090499994,
							30.437178009000036
						],
						[
							-81.77482490499995,
							30.437089008000044
						],
						[
							-81.77430590599994,
							30.43694300900006
						],
						[
							-81.77403890599993,
							30.436877009000053
						],
						[
							-81.77350590599991,
							30.436783009000063
						],
						[
							-81.77171490899993,
							30.43649301100004
						],
						[
							-81.77166281899991,
							30.436497173000074
						],
						[
							-81.77155390599995,
							30.43632700800004
						],
						[
							-81.77139290499991,
							30.43603700800009
						],
						[
							-81.77061496699991,
							30.43471282800004
						],
						[
							-81.76979090499992,
							30.435102009000047
						],
						[
							-81.76927890499991,
							30.435337008000094
						],
						[
							-81.76900190599991,
							30.435415009000057
						],
						[
							-81.76897390499994,
							30.435427008000094
						],
						[
							-81.76894690499995,
							30.435438009000052
						],
						[
							-81.7687809059999,
							30.435505008000064
						],
						[
							-81.76831373099992,
							30.435697958000052
						],
						[
							-81.76852790499993,
							30.43599400900007
						],
						[
							-81.76928390499995,
							30.43726900900009
						],
						[
							-81.76942490599994,
							30.437507009000058
						],
						[
							-81.7697309049999,
							30.438094008000064
						],
						[
							-81.77384490599991,
							30.445859009000063
						],
						[
							-81.77812690699994,
							30.45358900800005
						],
						[
							-81.77962493099994,
							30.455380945000062
						],
						[
							-81.77861790799994,
							30.455759010000065
						],
						[
							-81.77766390799991,
							30.45609300800004
						],
						[
							-81.77703890799995,
							30.456104010000047
						],
						[
							-81.7763599079999,
							30.456112010000087
						],
						[
							-81.77482590799991,
							30.456147010000052
						],
						[
							-81.77286390799992,
							30.456207010000075
						],
						[
							-81.77230590799991,
							30.45621301000006
						],
						[
							-81.77222981999995,
							30.45622117600004
						],
						[
							-81.77199390699991,
							30.45572001000005
						],
						[
							-81.77158890699991,
							30.45484501100009
						],
						[
							-81.77080390799995,
							30.453132010000047
						],
						[
							-81.77059090699993,
							30.45268901000009
						],
						[
							-81.77046890799994,
							30.452405010000067
						],
						[
							-81.76991190699994,
							30.451190010000065
						],
						[
							-81.76947690799994,
							30.450273011000036
						],
						[
							-81.76911890799994,
							30.449466011000084
						],
						[
							-81.7685299069999,
							30.44819401000007
						],
						[
							-81.76843090699992,
							30.44798301100008
						],
						[
							-81.76840090699994,
							30.44792001000007
						],
						[
							-81.76810190799995,
							30.447282011000087
						],
						[
							-81.76796090699992,
							30.44695901100005
						],
						[
							-81.76720790799993,
							30.44534401000004
						],
						[
							-81.76663090699992,
							30.44410601000004
						],
						[
							-81.76638790799991,
							30.443575011000068
						],
						[
							-81.76635190799993,
							30.443496011000033
						],
						[
							-81.76559990699991,
							30.44190801000008
						],
						[
							-81.76513590699994,
							30.44098401100007
						],
						[
							-81.7646157879999,
							30.44004376200007
						],
						[
							-81.7644958269999,
							30.43979302900004
						],
						[
							-81.76449898599992,
							30.439734989000044
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Dinsmore",
				"RegionID": "124178"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.52800150301715,
					27.97208949081223,
					-82.50531106952398,
					27.99999900030746
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.51730099989118,
							27.99999900030746
						],
						[
							-82.51721699961635,
							27.99996999986994
						],
						[
							-82.51639600044184,
							27.999984999662104
						],
						[
							-82.51549800041595,
							27.99996799977776
						],
						[
							-82.5145859997447,
							27.999963999593398
						],
						[
							-82.51355299979095,
							27.99995800021614
						],
						[
							-82.51276899962411,
							27.99995700017005
						],
						[
							-82.51186300012878,
							27.999952999985688
						],
						[
							-82.51095100035681,
							27.999948999801326
						],
						[
							-82.5100340003544,
							27.99994300042406
						],
						[
							-82.50911600030588,
							27.999937000147433
						],
						[
							-82.50871285762256,
							27.999934479347772
						],
						[
							-82.50719997583676,
							27.999890989933036
						],
						[
							-82.50634548231264,
							27.999427227548985
						],
						[
							-82.50531106952398,
							27.999264903520018
						],
						[
							-82.5053545445495,
							27.99633636475359
						],
						[
							-82.5056909116729,
							27.974145448889793
						],
						[
							-82.51345184764642,
							27.973853432731612
						],
						[
							-82.51338518899831,
							27.97208949081223
						],
						[
							-82.5276200169076,
							27.97249086183114
						],
						[
							-82.52663900406243,
							27.981536810274072
						],
						[
							-82.5255490662324,
							27.98671364691912
						],
						[
							-82.52800150301715,
							27.99265335595858
						],
						[
							-82.52740190613443,
							27.994942072966495
						],
						[
							-82.5272356556654,
							27.99557684503172
						],
						[
							-82.52688469704216,
							27.996917945518113
						],
						[
							-82.52622579796554,
							27.996908127619534
						],
						[
							-82.52608300001643,
							27.996905999823547
						],
						[
							-82.52394799962634,
							27.996930000030616
						],
						[
							-82.51948072806239,
							27.996847124807665
						],
						[
							-82.51750827023652,
							27.996816329323366
						],
						[
							-82.51735899986684,
							27.996814000079368
						],
						[
							-82.51729300042174,
							27.99979499989694
						],
						[
							-82.51730099989118,
							27.99999900030746
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Drew Park",
				"RegionID": "124197"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.31975999999989,
					25.76248300000021,
					-80.21871344599994,
					25.794219878624357
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.24146005599995,
							25.793738541000018
						],
						[
							-80.24017715699993,
							25.792991778000136
						],
						[
							-80.23973675799992,
							25.79268541400019
						],
						[
							-80.2392963599999,
							25.792493937000067
						],
						[
							-80.23866448399993,
							25.79211098200009
						],
						[
							-80.23768794899986,
							25.791555697000064
						],
						[
							-80.23705607299989,
							25.791115299000044
						],
						[
							-80.23640504999985,
							25.790636605000046
						],
						[
							-80.23569658299994,
							25.790253650000068
						],
						[
							-80.23540936699989,
							25.790196207000022
						],
						[
							-80.23466260499993,
							25.790100468000006
						],
						[
							-80.23427964999985,
							25.790004729000167
						],
						[
							-80.23349459199983,
							25.78966007000016
						],
						[
							-80.23263294299994,
							25.789315410000064
						],
						[
							-80.23194362399992,
							25.78900904600012
						],
						[
							-80.23121600999986,
							25.78870268200017
						],
						[
							-80.2306798729999,
							25.788472909000077
						],
						[
							-80.23037350899996,
							25.788281432000133
						],
						[
							-80.23016288299993,
							25.788032511000054
						],
						[
							-80.22995225799991,
							25.78784103400011
						],
						[
							-80.22937782599992,
							25.787438931000146
						],
						[
							-80.22828640399985,
							25.787075124000154
						],
						[
							-80.22755878899994,
							25.787017680000197
						],
						[
							-80.2270226519999,
							25.78684535100006
						],
						[
							-80.22616100299985,
							25.786462396000083
						],
						[
							-80.22549083199982,
							25.786156032000136
						],
						[
							-80.22518446799995,
							25.78613688400015
						],
						[
							-80.22470577399987,
							25.786232623000167
						],
						[
							-80.22390156899986,
							25.786251770000064
						],
						[
							-80.22363349999988,
							25.785926259000043
						],
						[
							-80.22303991999989,
							25.78552415600008
						],
						[
							-80.22254207899982,
							25.785256087000015
						],
						[
							-80.22185275999989,
							25.785045462000085
						],
						[
							-80.22018690499982,
							25.784528473000208
						],
						[
							-80.21921036999993,
							25.784222109000083
						],
						[
							-80.21901889299991,
							25.783934893000122
						],
						[
							-80.21873167599993,
							25.78382000600012
						],
						[
							-80.21871344599994,
							25.783817520000092
						],
						[
							-80.21917571999991,
							25.783701032000046
						],
						[
							-80.21948209199985,
							25.78356906200014
						],
						[
							-80.21983777499979,
							25.783411326000056
						],
						[
							-80.22016929599995,
							25.783268091000195
						],
						[
							-80.2203340539999,
							25.78319297300002
						],
						[
							-80.22050666299981,
							25.783106668000077
						],
						[
							-80.22064690799995,
							25.783036546000133
						],
						[
							-80.2209532639999,
							25.78289564000002
						],
						[
							-80.22129723599994,
							25.782792071000067
						],
						[
							-80.22192036299981,
							25.782638392000052
						],
						[
							-80.22238395399997,
							25.78256526900013
						],
						[
							-80.22263999999984,
							25.782530000000143
						],
						[
							-80.2228951679999,
							25.782461921000106
						],
						[
							-80.22324427099991,
							25.782478818000172
						],
						[
							-80.22375612899991,
							25.78246375300008
						],
						[
							-80.22442987399997,
							25.782446493000073
						],
						[
							-80.22483573399988,
							25.782433540000156
						],
						[
							-80.2254285059999,
							25.782411284000094
						],
						[
							-80.22588718799993,
							25.782387426000074
						],
						[
							-80.22631742999982,
							25.782363958000083
						],
						[
							-80.22682854699993,
							25.78234937500021
						],
						[
							-80.22712952699986,
							25.782327352000074
						],
						[
							-80.22761227899993,
							25.782290594000056
						],
						[
							-80.2280423439999,
							25.782264659000127
						],
						[
							-80.22839510699987,
							25.78225426900016
						],
						[
							-80.22882638299986,
							25.782242454000155
						],
						[
							-80.22933892699989,
							25.78224049600017
						],
						[
							-80.22966455999983,
							25.782258587000157
						],
						[
							-80.22993558299987,
							25.782278891000065
						],
						[
							-80.23020398199988,
							25.782302716000167
						],
						[
							-80.23039080799988,
							25.782321878000154
						],
						[
							-80.23063226999996,
							25.782357045000133
						],
						[
							-80.23081974799993,
							25.782389733000173
						],
						[
							-80.2309857679999,
							25.782422215000018
						],
						[
							-80.23122999999994,
							25.782470000000153
						],
						[
							-80.23122660099993,
							25.78226945200008
						],
						[
							-80.23122476499987,
							25.78216114500009
						],
						[
							-80.23121999999982,
							25.78188000000019
						],
						[
							-80.23121999999982,
							25.781568226000147
						],
						[
							-80.23121528399979,
							25.781244847000124
						],
						[
							-80.23120660799988,
							25.780867464000075
						],
						[
							-80.23119604499989,
							25.78040797400007
						],
						[
							-80.23118922899995,
							25.78011145900014
						],
						[
							-80.23117908719983,
							25.779710962600184
						],
						[
							-80.23132399899991,
							25.779706115000174
						],
						[
							-80.23171028499989,
							25.779695270000076
						],
						[
							-80.23189999999995,
							25.779690000000173
						],
						[
							-80.23208090799992,
							25.77968460000008
						],
						[
							-80.23228302099994,
							25.779678567000204
						],
						[
							-80.23256999999988,
							25.779670000000117
						],
						[
							-80.23273999999992,
							25.77966
						],
						[
							-80.23322838399991,
							25.779640848000014
						],
						[
							-80.23342883299989,
							25.77964000000012
						],
						[
							-80.23359999999992,
							25.77964000000012
						],
						[
							-80.23407026799994,
							25.779628668000072
						],
						[
							-80.23442999999986,
							25.779620000000065
						],
						[
							-80.23461999999995,
							25.779610000000126
						],
						[
							-80.23487884499987,
							25.779603447000028
						],
						[
							-80.2351483959999,
							25.779596623000174
						],
						[
							-80.23540999999994,
							25.77959000000007
						],
						[
							-80.23562006199991,
							25.779583998000106
						],
						[
							-80.23575999999986,
							25.779580000000134
						],
						[
							-80.23602634499987,
							25.779571677000064
						],
						[
							-80.23639999999996,
							25.779560000000075
						],
						[
							-80.23653352499991,
							25.77955374100018
						],
						[
							-80.23676901699986,
							25.779542702000064
						],
						[
							-80.2370399999999,
							25.779530000000083
						],
						[
							-80.23720590499994,
							25.779525260000046
						],
						[
							-80.2373899999999,
							25.77952000000014
						],
						[
							-80.23774480699986,
							25.77951343000013
						],
						[
							-80.2379299999999,
							25.7795100000002
						],
						[
							-80.23804820799991,
							25.779507186000146
						],
						[
							-80.23834999999993,
							25.779500000000084
						],
						[
							-80.23865575499991,
							25.779490030000147
						],
						[
							-80.2390946899999,
							25.779475717000118
						],
						[
							-80.23940999999988,
							25.77947000000009
						],
						[
							-80.23956669199988,
							25.779463285000155
						],
						[
							-80.23990322899992,
							25.779448862000116
						],
						[
							-80.24010999999989,
							25.779440000000093
						],
						[
							-80.2402733679999,
							25.779435585000172
						],
						[
							-80.24054289499992,
							25.779428300000195
						],
						[
							-80.24084999999992,
							25.779420000000037
						],
						[
							-80.24101440999993,
							25.779413911000155
						],
						[
							-80.2411503349999,
							25.779408876000005
						],
						[
							-80.24138999999992,
							25.77940000000016
						],
						[
							-80.2415206819999,
							25.779397333000205
						],
						[
							-80.24187999999988,
							25.779390000000042
						],
						[
							-80.2421271269999,
							25.77938189700017
						],
						[
							-80.24233141199993,
							25.77937520000006
						],
						[
							-80.24270186699994,
							25.77936316600013
						],
						[
							-80.24300499199988,
							25.77935338700012
						],
						[
							-80.24341999999984,
							25.77934000000017
						],
						[
							-80.24367858799992,
							25.779333986000026
						],
						[
							-80.2438499999999,
							25.77933000000005
						],
						[
							-80.24415143699979,
							25.779318696000182
						],
						[
							-80.24445571399993,
							25.77930728600013
						],
						[
							-80.24464999999992,
							25.779300000000056
						],
						[
							-80.24492704799992,
							25.779289864000106
						],
						[
							-80.24519641099992,
							25.77928000900009
						],
						[
							-80.24546999999991,
							25.77927000000006
						],
						[
							-80.24573532099993,
							25.779267527000123
						],
						[
							-80.24600481899994,
							25.779259715000187
						],
						[
							-80.24633999999986,
							25.779250000000005
						],
						[
							-80.24648999999992,
							25.779240000000065
						],
						[
							-80.24684683099987,
							25.779229607000005
						],
						[
							-80.24725303699991,
							25.77921777600018
						],
						[
							-80.24751999999988,
							25.77921000000007
						],
						[
							-80.24782698799989,
							25.779198416
						],
						[
							-80.24804999999986,
							25.779190000000195
						],
						[
							-80.24833188399991,
							25.779181543000114
						],
						[
							-80.24870343199984,
							25.77917039700008
						],
						[
							-80.24904999999991,
							25.77916000000002
						],
						[
							-80.24916999999989,
							25.77916000000002
						],
						[
							-80.24944484299989,
							25.779148305000028
						],
						[
							-80.24978138899985,
							25.779133983000087
						],
						[
							-80.25010999999995,
							25.779120000000084
						],
						[
							-80.25048870099994,
							25.779115597000164
						],
						[
							-80.25082658599992,
							25.779104870000076
						],
						[
							-80.25097999999991,
							25.779100000000206
						],
						[
							-80.25114999999994,
							25.779100000000206
						],
						[
							-80.2515014939999,
							25.779088284000125
						],
						[
							-80.25183827499978,
							25.779077057000173
						],
						[
							-80.25204999999988,
							25.779070000000033
						],
						[
							-80.25237684799993,
							25.77905217200016
						],
						[
							-80.25259999999992,
							25.77904000000004
						],
						[
							-80.25281487699995,
							25.77903552300011
						],
						[
							-80.25288227899983,
							25.779034119000173
						],
						[
							-80.25307999999984,
							25.7790300000001
						],
						[
							-80.25335580299993,
							25.779021290000088
						],
						[
							-80.25372630499994,
							25.77900959000001
						],
						[
							-80.25402999999993,
							25.779000000000103
						],
						[
							-80.25436628999996,
							25.77899078700014
						],
						[
							-80.25507364199977,
							25.77896966000008
						],
						[
							-80.25534307299995,
							25.77896077800006
						],
						[
							-80.25566942349974,
							25.778950104000064
						],
						[
							-80.25639104399988,
							25.778926573000156
						],
						[
							-80.25713003799984,
							25.778902562000034
						],
						[
							-80.25804401599987,
							25.778872866000064
						],
						[
							-80.25843999999995,
							25.778860000000066
						],
						[
							-80.25878116099994,
							25.77885025300006
						],
						[
							-80.25931366999994,
							25.778835038000132
						],
						[
							-80.25983999999988,
							25.77882000000013
						],
						[
							-80.26013939899978,
							25.77881128000012
						],
						[
							-80.26064071599988,
							25.778796678000155
						],
						[
							-80.26086999999984,
							25.778790000000136
						],
						[
							-80.26111421099989,
							25.778783216000107
						],
						[
							-80.26146810899988,
							25.778773386000182
						],
						[
							-80.26194999999986,
							25.77876000000014
						],
						[
							-80.26214636799993,
							25.778755325000198
						],
						[
							-80.26236999999988,
							25.778750000000024
						],
						[
							-80.26270675599994,
							25.778738959000087
						],
						[
							-80.2629799999999,
							25.778730000000145
						],
						[
							-80.26329715699985,
							25.77871106500009
						],
						[
							-80.2635930069999,
							25.778693403000048
						],
						[
							-80.26453649199989,
							25.77868708700006
						],
						[
							-80.26503810799993,
							25.778695049000184
						],
						[
							-80.26542169699987,
							25.778701138000066
						],
						[
							-80.26597999999987,
							25.77871000000009
						],
						[
							-80.26596803599995,
							25.77835505700012
						],
						[
							-80.26595806499992,
							25.77805925500016
						],
						[
							-80.26594999999989,
							25.777820000000172
						],
						[
							-80.26594113799986,
							25.777557088000087
						],
						[
							-80.26592921299994,
							25.777203319000037
						],
						[
							-80.26591999999988,
							25.77693000000007
						],
						[
							-80.26590965499992,
							25.77670240200007
						],
						[
							-80.26590022199993,
							25.77649488900004
						],
						[
							-80.26588817299991,
							25.776229808000046
						],
						[
							-80.26587999999987,
							25.77605000000009
						],
						[
							-80.26585850899994,
							25.775667453000146
						],
						[
							-80.2658419799999,
							25.77537323900014
						],
						[
							-80.2658299999999,
							25.77516000000017
						],
						[
							-80.26624852799989,
							25.775148228000084
						],
						[
							-80.26669121499992,
							25.775144797000067
						],
						[
							-80.26730999999997,
							25.775140000000114
						],
						[
							-80.2676355469999,
							25.77513385800014
						],
						[
							-80.2680487819999,
							25.775136075000056
						],
						[
							-80.26830999999993,
							25.77513000000018
						],
						[
							-80.2687573529999,
							25.7751247980001
						],
						[
							-80.26931999999991,
							25.77511000000012
						],
						[
							-80.26933662599987,
							25.775342767000105
						],
						[
							-80.2693499999999,
							25.7756400000001
						],
						[
							-80.27002628299991,
							25.7756100040001
						],
						[
							-80.27049758399991,
							25.775589099000058
						],
						[
							-80.27100226099992,
							25.775566714000075
						],
						[
							-80.27153378199993,
							25.775543139000163
						],
						[
							-80.27182999999985,
							25.775530000000053
						],
						[
							-80.27229964999981,
							25.775509898000166
						],
						[
							-80.27303741899992,
							25.775478321000133
						],
						[
							-80.27386356799988,
							25.775442960000134
						],
						[
							-80.27439999999986,
							25.775420000000015
						],
						[
							-80.2746001679999,
							25.775412073000155
						],
						[
							-80.27486654799992,
							25.775401523000173
						],
						[
							-80.27516122799996,
							25.775389852000004
						],
						[
							-80.27540999999987,
							25.775380000000077
						],
						[
							-80.27560446499986,
							25.775373518000073
						],
						[
							-80.27586979899988,
							25.77536467300014
						],
						[
							-80.27600999999993,
							25.77536000000002
						],
						[
							-80.27622301899989,
							25.775349132000187
						],
						[
							-80.27643208599996,
							25.775338465000104
						],
						[
							-80.27666758699989,
							25.775326450000087
						],
						[
							-80.27698999999984,
							25.775310000000147
						],
						[
							-80.2771387819999,
							25.775303989000093
						],
						[
							-80.27737332099984,
							25.77529451200011
						],
						[
							-80.27770101999988,
							25.77528127200008
						],
						[
							-80.27797999999986,
							25.775270000000035
						],
						[
							-80.27823268099989,
							25.775258907000094
						],
						[
							-80.27861562799987,
							25.775242094000035
						],
						[
							-80.27902803299989,
							25.775223989000047
						],
						[
							-80.2793802299999,
							25.7752085260001
						],
						[
							-80.27976705699984,
							25.775191544000116
						],
						[
							-80.28002999999984,
							25.77518000000005
						],
						[
							-80.28032680599988,
							25.775168417000067
						],
						[
							-80.28053309199981,
							25.77516036700011
						],
						[
							-80.2808572549999,
							25.77514771700013
						],
						[
							-80.28124035699989,
							25.775132767000137
						],
						[
							-80.28168239799987,
							25.775115516000042
						],
						[
							-80.28207999999991,
							25.77510000000018
						],
						[
							-80.28207425699988,
							25.774841567000024
						],
						[
							-80.28206999999988,
							25.774650000000072
						],
						[
							-80.28221601199988,
							25.774643014000027
						],
						[
							-80.2824544049999,
							25.77463160700006
						],
						[
							-80.28292555399987,
							25.774609064000064
						],
						[
							-80.2834261509999,
							25.774585112000032
						],
						[
							-80.28392674799994,
							25.774561160000182
						],
						[
							-80.28415999999987,
							25.774550000000147
						],
						[
							-80.28448787399991,
							25.774537226000156
						],
						[
							-80.28496053499994,
							25.774518810000053
						],
						[
							-80.28543434399988,
							25.774500350000125
						],
						[
							-80.28569999999984,
							25.774490000000156
						],
						[
							-80.2859648419999,
							25.77447835900017
						],
						[
							-80.28631833099985,
							25.774462821000128
						],
						[
							-80.28660999999981,
							25.774450000000044
						],
						[
							-80.28687815899988,
							25.77443941500015
						],
						[
							-80.28711390599995,
							25.774430109000086
						],
						[
							-80.28736999999991,
							25.77442000000005
						],
						[
							-80.28764666399988,
							25.77441034900005
						],
						[
							-80.28791196999983,
							25.774401094000083
						],
						[
							-80.28822999999991,
							25.774390000000054
						],
						[
							-80.28821558799989,
							25.77395763200016
						],
						[
							-80.28820474499987,
							25.77363235200007
						],
						[
							-80.28818410799994,
							25.773013241000093
						],
						[
							-80.28816999999992,
							25.772590000000157
						],
						[
							-80.28815944099995,
							25.772307011000102
						],
						[
							-80.28814721999991,
							25.771979506000093
						],
						[
							-80.28812962399978,
							25.771507935000066
						],
						[
							-80.28811999999988,
							25.77125000000013
						],
						[
							-80.28811662499986,
							25.77109473100016
						],
						[
							-80.28810999999985,
							25.770790000000083
						],
						[
							-80.28810578499986,
							25.770621400000167
						],
						[
							-80.28809999999991,
							25.770390000000205
						],
						[
							-80.28809259099982,
							25.770208473000196
						],
						[
							-80.28808537499994,
							25.770031682000045
						],
						[
							-80.28807999999994,
							25.769900000000163
						],
						[
							-80.28807324299991,
							25.769707430000043
						],
						[
							-80.28806389799985,
							25.76944109400003
						],
						[
							-80.2880599999998,
							25.76933000000008
						],
						[
							-80.28805505499992,
							25.769176715000093
						],
						[
							-80.28804999999994,
							25.769020000000182
						],
						[
							-80.2880451969999,
							25.768911939000034
						],
						[
							-80.2880332979999,
							25.768644216
						],
						[
							-80.28802999999989,
							25.768570000000075
						],
						[
							-80.28802371499991,
							25.768290333000117
						],
						[
							-80.28801640799992,
							25.767965177000036
						],
						[
							-80.28800999999993,
							25.767680000000155
						],
						[
							-80.2880064869999,
							25.7675816350001
						],
						[
							-80.2879999999999,
							25.76740000000008
						],
						[
							-80.28799560399989,
							25.767316477000186
						],
						[
							-80.28798999999987,
							25.76721000000017
						],
						[
							-80.28798600799989,
							25.767110200000083
						],
						[
							-80.28797999999993,
							25.76696000000009
						],
						[
							-80.28797398299987,
							25.766815582000042
						],
						[
							-80.2879678439999,
							25.76666826600011
						],
						[
							-80.28795999999996,
							25.766480000000165
						],
						[
							-80.28795999999996,
							25.766401279000135
						],
						[
							-80.28795999999996,
							25.766250000000145
						],
						[
							-80.28795578199988,
							25.766106582000177
						],
						[
							-80.28794836399989,
							25.765898546000194
						],
						[
							-80.28792999999988,
							25.765770000000217
						],
						[
							-80.28792999999988,
							25.765663422000102
						],
						[
							-80.28792999999988,
							25.76557000000019
						],
						[
							-80.28792331999995,
							25.76539966100004
						],
						[
							-80.28791629599989,
							25.76522053600005
						],
						[
							-80.28790999999991,
							25.76498459400007
						],
						[
							-80.28790589999993,
							25.764779310000137
						],
						[
							-80.28789599499991,
							25.764511862000035
						],
						[
							-80.28788572699995,
							25.76418762100012
						],
						[
							-80.28787352199991,
							25.763833960000078
						],
						[
							-80.28786791299989,
							25.763716170000105
						],
						[
							-80.287864123001,
							25.763562575034733
						],
						[
							-80.28815447000237,
							25.763552397072615
						],
						[
							-80.28993601100278,
							25.7634899460853
						],
						[
							-80.28996299999996,
							25.763489000000135
						],
						[
							-80.2905000239982,
							25.763485204777687
						],
						[
							-80.29052899999989,
							25.76348500000016
						],
						[
							-80.29126999999991,
							25.76347000000016
						],
						[
							-80.29190499999989,
							25.763441000000075
						],
						[
							-80.29264999999988,
							25.763419000000027
						],
						[
							-80.29322399999994,
							25.763403000000128
						],
						[
							-80.29332899999993,
							25.76339700000016
						],
						[
							-80.29367256799168,
							25.763385956743363
						],
						[
							-80.2938889999999,
							25.763379000000093
						],
						[
							-80.2941079999999,
							25.76338100000008
						],
						[
							-80.29425999999995,
							25.763369000000154
						],
						[
							-80.29498999999987,
							25.76334400000004
						],
						[
							-80.29587799999989,
							25.76331100000015
						],
						[
							-80.29588598599993,
							25.7633109610061
						],
						[
							-80.29690199999989,
							25.763306000000092
						],
						[
							-80.29788199999987,
							25.76325800000003
						],
						[
							-80.29804199999997,
							25.76325800000003
						],
						[
							-80.2996359999998,
							25.763221000000165
						],
						[
							-80.29989999999987,
							25.763205000000085
						],
						[
							-80.3008889999999,
							25.763193000000157
						],
						[
							-80.30092760501837,
							25.763191705551876
						],
						[
							-80.30190299999987,
							25.763159000000186
						],
						[
							-80.30286999999994,
							25.763131
						],
						[
							-80.3039009999999,
							25.763099000000196
						],
						[
							-80.30586799999993,
							25.76302900000009
						],
						[
							-80.3066648029972,
							25.763021061738662
						],
						[
							-80.30667099999994,
							25.763021000000137
						],
						[
							-80.30739944899386,
							25.762980901890415
						],
						[
							-80.30743399999983,
							25.762979000000215
						],
						[
							-80.3080059999999,
							25.762963000000138
						],
						[
							-80.3085469999999,
							25.762948000000137
						],
						[
							-80.3093799999999,
							25.762914000000166
						],
						[
							-80.30941722600254,
							25.762912456064697
						],
						[
							-80.30981399999983,
							25.762896000000097
						],
						[
							-80.31006719699707,
							25.762897275551673
						],
						[
							-80.31021099999991,
							25.762898000000085
						],
						[
							-80.31026179998831,
							25.762895260785008
						],
						[
							-80.31056054499908,
							25.76287915198556
						],
						[
							-80.31102699999992,
							25.762854000000175
						],
						[
							-80.31182711698291,
							25.762830947410116
						],
						[
							-80.31185999999992,
							25.762830000000143
						],
						[
							-80.31189059998417,
							25.762829267346383
						],
						[
							-80.3138229999999,
							25.762783000000162
						],
						[
							-80.31383427700945,
							25.762782751435083
						],
						[
							-80.3146849999999,
							25.76276400000019
						],
						[
							-80.31469373000479,
							25.76276360810887
						],
						[
							-80.31531948199991,
							25.76273551800014
						],
						[
							-80.31573199999993,
							25.76271700000003
						],
						[
							-80.3157378579807,
							25.762716813397653
						],
						[
							-80.31660356799166,
							25.762689236742204
						],
						[
							-80.31661099999992,
							25.7626890000002
						],
						[
							-80.31682720400575,
							25.76268013514344
						],
						[
							-80.31685427500672,
							25.762679025170705
						],
						[
							-80.31748899999991,
							25.762653000000064
						],
						[
							-80.31824399999995,
							25.762618000000188
						],
						[
							-80.3190689999999,
							25.762495000000136
						],
						[
							-80.31953645399915,
							25.762487150959075
						],
						[
							-80.31960499999992,
							25.762486000000102
						],
						[
							-80.3196819999999,
							25.762484000000114
						],
						[
							-80.31975999999989,
							25.76248300000021
						],
						[
							-80.31973199999987,
							25.762846000000046
						],
						[
							-80.31972899999988,
							25.76298000000012
						],
						[
							-80.31974099999991,
							25.76304500000017
						],
						[
							-80.31965542507756,
							25.76309972612158
						],
						[
							-80.31924999999978,
							25.763359000000037
						],
						[
							-80.31908499999989,
							25.763486000000064
						],
						[
							-80.3189969999999,
							25.76352400000019
						],
						[
							-80.31886099999993,
							25.763574000000062
						],
						[
							-80.31869499999995,
							25.763640000000194
						],
						[
							-80.31805340715657,
							25.76389594539325
						],
						[
							-80.31795299999993,
							25.76393600000017
						],
						[
							-80.31768399999989,
							25.764832000000055
						],
						[
							-80.31736799999993,
							25.76566400000015
						],
						[
							-80.31711299999989,
							25.766254000000117
						],
						[
							-80.31681499999992,
							25.766760000000062
						],
						[
							-80.31577399999985,
							25.768089000000067
						],
						[
							-80.31547231289203,
							25.76837179588491
						],
						[
							-80.31544367319306,
							25.768398642206165
						],
						[
							-80.31524699999996,
							25.768583000000085
						],
						[
							-80.3146729999998,
							25.769020000000182
						],
						[
							-80.31404399999988,
							25.76943900000021
						],
						[
							-80.31385253301522,
							25.76952964303249
						],
						[
							-80.31346099999988,
							25.769715000000133
						],
						[
							-80.31311999999991,
							25.770009000000123
						],
						[
							-80.31310241881079,
							25.770039942892815
						],
						[
							-80.31304499999992,
							25.77014100000021
						],
						[
							-80.31277599999987,
							25.770484000000167
						],
						[
							-80.31269399999992,
							25.770579000000033
						],
						[
							-80.31264699999986,
							25.770605000000053
						],
						[
							-80.31259899999988,
							25.77064900000014
						],
						[
							-80.31254699999992,
							25.770729000000188
						],
						[
							-80.31247399999992,
							25.770752000000137
						],
						[
							-80.3124349999999,
							25.7707580000001
						],
						[
							-80.31233799999977,
							25.77075700000002
						],
						[
							-80.31223399999988,
							25.770740000000032
						],
						[
							-80.31209099999994,
							25.770717000000083
						],
						[
							-80.31201299999988,
							25.770687000000088
						],
						[
							-80.31194649762739,
							25.77063084244113
						],
						[
							-80.3119229999999,
							25.770611000000194
						],
						[
							-80.31187099999995,
							25.77057800000013
						],
						[
							-80.31182199999989,
							25.7705660000002
						],
						[
							-80.3116599999999,
							25.77057600000014
						],
						[
							-80.31161199999993,
							25.770605000000053
						],
						[
							-80.31146699999992,
							25.77063800000012
						],
						[
							-80.31135599999989,
							25.770663000000056
						],
						[
							-80.31126699999989,
							25.770725000000212
						],
						[
							-80.31117399999992,
							25.77080500000008
						],
						[
							-80.31101199999993,
							25.770879000000164
						],
						[
							-80.31090399999988,
							25.770915000000123
						],
						[
							-80.31083699999992,
							25.770952000000165
						],
						[
							-80.31073099999986,
							25.770996000000075
						],
						[
							-80.31064199999987,
							25.771040000000163
						],
						[
							-80.3105079999998,
							25.771092000000024
						],
						[
							-80.31040599999989,
							25.77112500000009
						],
						[
							-80.31018299999981,
							25.771218000000147
						],
						[
							-80.31003799999989,
							25.771259000000168
						],
						[
							-80.30993199999992,
							25.77129400000004
						],
						[
							-80.30988999999983,
							25.771324000000035
						],
						[
							-80.30980399999982,
							25.771361000000077
						],
						[
							-80.30971899999979,
							25.771404000000086
						],
						[
							-80.30972199999987,
							25.771503000000102
						],
						[
							-80.3097316305778,
							25.771912417010086
						],
						[
							-80.3097344592011,
							25.772032667995436
						],
						[
							-80.30976299999988,
							25.77324600000008
						],
						[
							-80.3097619999998,
							25.77366000000005
						],
						[
							-80.30974199999991,
							25.773927000000114
						],
						[
							-80.30970999999994,
							25.77419200000019
						],
						[
							-80.30966999999991,
							25.774432000000154
						],
						[
							-80.30962299999995,
							25.774648000000084
						],
						[
							-80.30956599999992,
							25.774861000000122
						],
						[
							-80.30949899999989,
							25.775072000000172
						],
						[
							-80.30944293111516,
							25.77521503704549
						],
						[
							-80.30922499999987,
							25.7757710000001
						],
						[
							-80.30901299999991,
							25.77634700000015
						],
						[
							-80.30900399999987,
							25.77636900000002
						],
						[
							-80.30881799999985,
							25.776866000000105
						],
						[
							-80.30870499999992,
							25.77716700000014
						],
						[
							-80.30857399999991,
							25.776910000000015
						],
						[
							-80.30830899999992,
							25.77634300000018
						],
						[
							-80.30821399999988,
							25.772170000000045
						],
						[
							-80.3082119999999,
							25.772087000000106
						],
						[
							-80.30817581714425,
							25.77210046338838
						],
						[
							-80.30808299999988,
							25.77213500000017
						],
						[
							-80.30803921499847,
							25.772139800987155
						],
						[
							-80.30785499999985,
							25.772160000000106
						],
						[
							-80.30776099999979,
							25.772211000000063
						],
						[
							-80.30763499999993,
							25.772265000000093
						],
						[
							-80.30741299999995,
							25.772379000000107
						],
						[
							-80.30703099999988,
							25.772553000000116
						],
						[
							-80.30669399999988,
							25.77268400000012
						],
						[
							-80.30656999999992,
							25.77274300000003
						],
						[
							-80.30636299999993,
							25.77285300000007
						],
						[
							-80.30623299999984,
							25.77290300000012
						],
						[
							-80.30617936392035,
							25.772931018847807
						],
						[
							-80.30616599999989,
							25.772938000000174
						],
						[
							-80.30604203799994,
							25.772988431000172
						],
						[
							-80.3057675959999,
							25.773103167000073
						],
						[
							-80.30568399999989,
							25.773152000000117
						],
						[
							-80.30553399999991,
							25.773222000000047
						],
						[
							-80.30514799999986,
							25.773376
						],
						[
							-80.3050249999999,
							25.77343400000018
						],
						[
							-80.30487023099988,
							25.773478327000205
						],
						[
							-80.30479699599987,
							25.77350926400019
						],
						[
							-80.30450899999992,
							25.773633000000125
						],
						[
							-80.30445999999996,
							25.77365800000006
						],
						[
							-80.30429799999987,
							25.773739000000013
						],
						[
							-80.30426899999988,
							25.773740000000096
						],
						[
							-80.3041489999999,
							25.773811000000112
						],
						[
							-80.30401999999988,
							25.773867000000124
						],
						[
							-80.30399499999994,
							25.77388700000018
						],
						[
							-80.30384299999989,
							25.773953000000134
						],
						[
							-80.30384799999986,
							25.77397800000007
						],
						[
							-80.30381599999987,
							25.773989000000093
						],
						[
							-80.30376599999991,
							25.773997000000044
						],
						[
							-80.30354499999993,
							25.77407700000009
						],
						[
							-80.30347399999991,
							25.774098000000052
						],
						[
							-80.30346897699985,
							25.7740985980001
						],
						[
							-80.30338029199989,
							25.77413531800012
						],
						[
							-80.30335199999985,
							25.77415300000016
						],
						[
							-80.30333399999996,
							25.774172000000135
						],
						[
							-80.3033139999999,
							25.774177000000194
						],
						[
							-80.30329293999993,
							25.77417148500018
						],
						[
							-80.30314272699985,
							25.774233679000176
						],
						[
							-80.30314499999987,
							25.774243000000148
						],
						[
							-80.3031089999999,
							25.774269000000167
						],
						[
							-80.30307299999986,
							25.77428500000007
						],
						[
							-80.3030539999998,
							25.774274000000048
						],
						[
							-80.30304702899993,
							25.77427330300008
						],
						[
							-80.30297507799993,
							25.774303093000057
						],
						[
							-80.30297999999989,
							25.774309000000102
						],
						[
							-80.3029499999999,
							25.77433200000005
						],
						[
							-80.3028899999999,
							25.774365000000117
						],
						[
							-80.3027019999999,
							25.7744270000001
						],
						[
							-80.30265135399988,
							25.774437129000134
						],
						[
							-80.30262073599992,
							25.774449806000028
						],
						[
							-80.30251999999984,
							25.774501
						],
						[
							-80.3024851339999,
							25.77450781300012
						],
						[
							-80.30225886399991,
							25.77461608800011
						],
						[
							-80.30225699999994,
							25.7746310000001
						],
						[
							-80.30221499999992,
							25.774660000000015
						],
						[
							-80.30210099999982,
							25.77471700000011
						],
						[
							-80.30197999999984,
							25.774752000000163
						],
						[
							-80.30193450206527,
							25.77477130215417
						],
						[
							-80.30181499999986,
							25.774822000000093
						],
						[
							-80.30179099999992,
							25.77483700000009
						],
						[
							-80.30165399999989,
							25.774888000000047
						],
						[
							-80.3015449999999,
							25.774948000000037
						],
						[
							-80.3014449999999,
							25.774987000000067
						],
						[
							-80.30138999999987,
							25.775017000000062
						],
						[
							-80.30136499999993,
							25.775030000000076
						],
						[
							-80.3011229999999,
							25.77513600000014
						],
						[
							-80.30081199999992,
							25.775281000000057
						],
						[
							-80.30066199999995,
							25.775333000000096
						],
						[
							-80.3005659999999,
							25.77537300000003
						],
						[
							-80.30049199999993,
							25.775419000000106
						],
						[
							-80.30041499999994,
							25.775460000000123
						],
						[
							-80.3002039999999,
							25.775572000000153
						],
						[
							-80.3001309999999,
							25.77560000000016
						],
						[
							-80.30004599999997,
							25.775622000000027
						],
						[
							-80.30000199999996,
							25.775643000000166
						],
						[
							-80.29975599999995,
							25.775736000000045
						],
						[
							-80.29959099999988,
							25.77582100000015
						],
						[
							-80.29945199999993,
							25.775862000000167
						],
						[
							-80.29930599999993,
							25.775932000000097
						],
						[
							-80.29921099999989,
							25.776005000000097
						],
						[
							-80.29916999999996,
							25.776020000000095
						],
						[
							-80.29909699999986,
							25.77605800000004
						],
						[
							-80.29897499999981,
							25.776087000000132
						],
						[
							-80.2989309999999,
							25.7761050000002
						],
						[
							-80.29886499999985,
							25.776132000000125
						],
						[
							-80.29867699999993,
							25.776249000000035
						],
						[
							-80.29853999999996,
							25.77630500000005
						],
						[
							-80.29842099999989,
							25.77633900000002
						],
						[
							-80.2983159999999,
							25.776387000000085
						],
						[
							-80.29819599999992,
							25.776434000000066
						],
						[
							-80.29798499999987,
							25.77653200000018
						],
						[
							-80.2977169999999,
							25.77664100000014
						],
						[
							-80.29768299999994,
							25.776666000000077
						],
						[
							-80.29764699999988,
							25.77666100000002
						],
						[
							-80.29761799999989,
							25.7766770000001
						],
						[
							-80.29760999999985,
							25.776699000000143
						],
						[
							-80.29760249999994,
							25.776705500000148
						],
						[
							-80.29759499999993,
							25.776712000000153
						],
						[
							-80.2975289999999,
							25.77674700000003
						],
						[
							-80.29749999999989,
							25.776757000000146
						],
						[
							-80.29742299999992,
							25.77680000000015
						],
						[
							-80.29739199999993,
							25.776817000000136
						],
						[
							-80.29736599999991,
							25.776809000000185
						],
						[
							-80.29716699999996,
							25.776879000000115
						],
						[
							-80.29691899999996,
							25.7769840000001
						],
						[
							-80.29688899999978,
							25.77700500000006
						],
						[
							-80.2968879999998,
							25.77703100000008
						],
						[
							-80.29671799999994,
							25.777100000000104
						],
						[
							-80.29667699999992,
							25.777129000000016
						],
						[
							-80.29664099999987,
							25.777145000000097
						],
						[
							-80.29664499999984,
							25.77715350000009
						],
						[
							-80.29664899999982,
							25.777162000000082
						],
						[
							-80.2965929999999,
							25.777205000000087
						],
						[
							-80.29637499999988,
							25.777319000000105
						],
						[
							-80.29630199999988,
							25.77737000000006
						],
						[
							-80.29597399999993,
							25.777550000000033
						],
						[
							-80.29583899999996,
							25.77767000000002
						],
						[
							-80.29569099999988,
							25.77777900000015
						],
						[
							-80.29564699999987,
							25.7778020000001
						],
						[
							-80.29541899999994,
							25.777921000000177
						],
						[
							-80.29526899999986,
							25.7779630000001
						],
						[
							-80.29499299999993,
							25.778137000000108
						],
						[
							-80.29485499999988,
							25.778211000000013
						],
						[
							-80.2947529999999,
							25.778259000000077
						],
						[
							-80.29444699999988,
							25.77843600000016
						],
						[
							-80.29435399999991,
							25.77850200000011
						],
						[
							-80.29428699999988,
							25.778537000000163
						],
						[
							-80.29409799999978,
							25.77861400000014
						],
						[
							-80.29397199999993,
							25.778685000000152
						],
						[
							-80.29394999999988,
							25.778706000000113
						],
						[
							-80.29375099999994,
							25.778807000000125
						],
						[
							-80.29363899999991,
							25.778852000000114
						],
						[
							-80.29325499999993,
							25.77904000000004
						],
						[
							-80.29308799999988,
							25.779113000000038
						],
						[
							-80.29293399999993,
							25.779199000000048
						],
						[
							-80.29276799999987,
							25.77927000000006
						],
						[
							-80.29270399999992,
							25.779292000000105
						],
						[
							-80.29253199999988,
							25.779337000000098
						],
						[
							-80.29237099999989,
							25.779394000000195
						],
						[
							-80.29215799999984,
							25.77949400000012
						],
						[
							-80.29204499999993,
							25.7795410000001
						],
						[
							-80.29191899999996,
							25.779620000000065
						],
						[
							-80.29168699999987,
							25.779734000000083
						],
						[
							-80.29152699999986,
							25.779789000000015
						],
						[
							-80.2911569999999,
							25.77993700000018
						],
						[
							-80.29102399999981,
							25.780008000000194
						],
						[
							-80.29092899999995,
							25.780049000000034
						],
						[
							-80.2908079999998,
							25.78013100000007
						],
						[
							-80.29068599999991,
							25.78023000000009
						],
						[
							-80.29064699999988,
							25.780242000000015
						],
						[
							-80.29058099999993,
							25.780248000000157
						],
						[
							-80.29034899999992,
							25.78028800000009
						],
						[
							-80.28968799999986,
							25.78041800000001
						],
						[
							-80.28948299999985,
							25.78046500000017
						],
						[
							-80.28871899999987,
							25.780592000000198
						],
						[
							-80.28854599999995,
							25.780588000000044
						],
						[
							-80.28841099999988,
							25.780577000000022
						],
						[
							-80.28798699999989,
							25.78085200000004
						],
						[
							-80.2878315970611,
							25.78081062577013
						],
						[
							-80.28658599999996,
							25.78047900000009
						],
						[
							-80.28610777808963,
							25.78035183966236
						],
						[
							-80.28617436899994,
							25.780350015000515
						],
						[
							-80.28625781899972,
							25.780351603000113
						],
						[
							-80.28631638499968,
							25.780357372000147
						],
						[
							-80.28637444899987,
							25.780366958000055
						],
						[
							-80.28643176199972,
							25.780380321000184
						],
						[
							-80.28648807799976,
							25.780397405000173
						],
						[
							-80.28654472099983,
							25.780418839500214
						],
						[
							-80.28654177899976,
							25.780375513000138
						],
						[
							-80.2865120429997,
							25.78015351400051
						],
						[
							-80.28640180399975,
							25.780150394000252
						],
						[
							-80.28606105199978,
							25.780152308000055
						],
						[
							-80.28599718099974,
							25.780150397000163
						],
						[
							-80.28593861499978,
							25.780144629000397
						],
						[
							-80.28588055099986,
							25.780135042000047
						],
						[
							-80.2858232379999,
							25.780121679000096
						],
						[
							-80.28578458199982,
							25.78011038700005
						],
						[
							-80.28549578399974,
							25.78015416500012
						],
						[
							-80.2854783849998,
							25.780156628000057
						],
						[
							-80.28541981899984,
							25.78016239700009
						],
						[
							-80.28539801008748,
							25.780163110670635
						],
						[
							-80.28488287312399,
							25.780026134532825
						],
						[
							-80.28486136399964,
							25.78001275900032
						],
						[
							-80.28481352799986,
							25.77997848000006
						],
						[
							-80.28476803599983,
							25.77994114600017
						],
						[
							-80.28476301699976,
							25.77993671100007
						],
						[
							-80.28474671599983,
							25.77992219900011
						],
						[
							-80.2847430419997,
							25.77994444900053
						],
						[
							-80.28473327100636,
							25.779986354975577
						],
						[
							-80.28388199999996,
							25.779760000000103
						],
						[
							-80.28386099999983,
							25.77978800000011
						],
						[
							-80.28382699999986,
							25.779812000000142
						],
						[
							-80.28378399999986,
							25.77982400000007
						],
						[
							-80.2835599999998,
							25.779810000000154
						],
						[
							-80.28350099999989,
							25.779800000000037
						],
						[
							-80.28341199999988,
							25.779766000000066
						],
						[
							-80.28331699999984,
							25.779680000000056
						],
						[
							-80.28327199999985,
							25.779628000000017
						],
						[
							-80.28322899999993,
							25.77962400000004
						],
						[
							-80.28316499999988,
							25.77964000000012
						],
						[
							-80.28314499999992,
							25.77963200000017
						],
						[
							-80.28313899999995,
							25.779610000000126
						],
						[
							-80.28313499999989,
							25.779552000000123
						],
						[
							-80.2829450769999,
							25.779552000000123
						],
						[
							-80.28293099999988,
							25.779555000000194
						],
						[
							-80.28288109899992,
							25.779556171000202
						],
						[
							-80.28261899999991,
							25.77967900000015
						],
						[
							-80.28218499999988,
							25.779713000000122
						],
						[
							-80.28188899999991,
							25.77973600000007
						],
						[
							-80.28065599999985,
							25.7795980000002
						],
						[
							-80.2798889999999,
							25.779651000000143
						],
						[
							-80.27965599999989,
							25.779657000000107
						],
						[
							-80.27928299999985,
							25.779667000000046
						],
						[
							-80.27911986599985,
							25.779671621000162
						],
						[
							-80.27910599999986,
							25.77967600000008
						],
						[
							-80.27890699999982,
							25.77969700000004
						],
						[
							-80.27880661499995,
							25.779695538000098
						],
						[
							-80.27858821399991,
							25.77972835200015
						],
						[
							-80.2785869999999,
							25.779745000000105
						],
						[
							-80.27855599999991,
							25.77975200000015
						],
						[
							-80.27852299999994,
							25.779775000000104
						],
						[
							-80.2785129999999,
							25.77986600000017
						],
						[
							-80.27848999999988,
							25.779909000000174
						],
						[
							-80.27846899999992,
							25.779930000000135
						],
						[
							-80.27840299999987,
							25.779968000000082
						],
						[
							-80.27836599999982,
							25.779982000000178
						],
						[
							-80.27823599999982,
							25.779995000000007
						],
						[
							-80.27807899999988,
							25.780070000000176
						],
						[
							-80.27787899999994,
							25.780182000000202
						],
						[
							-80.2777989999999,
							25.78020200000008
						],
						[
							-80.27767799999992,
							25.780208000000044
						],
						[
							-80.27759099999992,
							25.7802270000002
						],
						[
							-80.27755699999996,
							25.78024100000011
						],
						[
							-80.2774929999999,
							25.78028400000012
						],
						[
							-80.27732699999983,
							25.780375000000006
						],
						[
							-80.27711499999988,
							25.78047500000011
						],
						[
							-80.27704399999986,
							25.78051700000021
						],
						[
							-80.27699853099992,
							25.780552704000144
						],
						[
							-80.27685699999994,
							25.780688000000147
						],
						[
							-80.27660999999993,
							25.780948000000166
						],
						[
							-80.27634899999991,
							25.78125100000001
						],
						[
							-80.27628099999988,
							25.781312000000085
						],
						[
							-80.2762156699999,
							25.781262639000175
						],
						[
							-80.27619999999985,
							25.781268000000175
						],
						[
							-80.27581025880862,
							25.7821352189141
						],
						[
							-80.27581337099983,
							25.782103615000125
						],
						[
							-80.27581695799995,
							25.782081893000104
						],
						[
							-80.27578136299985,
							25.78205975900005
						],
						[
							-80.2757388549997,
							25.782029537000213
						],
						[
							-80.2756488559998,
							25.781961537000093
						],
						[
							-80.2756435279998,
							25.7819574800002
						],
						[
							-80.27559803599978,
							25.781920146000132
						],
						[
							-80.27555508299979,
							25.781879916
						],
						[
							-80.27551485399982,
							25.781836964
						],
						[
							-80.27547751999984,
							25.781791472000148
						],
						[
							-80.27544324099993,
							25.781743636000094
						],
						[
							-80.27541168249977,
							25.781692824500198
						],
						[
							-80.27540514599971,
							25.78169896500022
						],
						[
							-80.27536491699985,
							25.781741917000218
						],
						[
							-80.27532196399976,
							25.781782147000172
						],
						[
							-80.27527647299972,
							25.781819481000067
						],
						[
							-80.27522863699994,
							25.781853759000057
						],
						[
							-80.2751786609998,
							25.78188483600041
						],
						[
							-80.27512584999978,
							25.78191302550021
						],
						[
							-80.27486593999969,
							25.78204047200014
						],
						[
							-80.27481415599993,
							25.78206386500039
						],
						[
							-80.27475907799982,
							25.78208459500015
						],
						[
							-80.27472203899968,
							25.78209628200014
						],
						[
							-80.27428703899974,
							25.78222328300008
						],
						[
							-80.27426776099975,
							25.78222867900035
						],
						[
							-80.27424382299972,
							25.782234742000405
						],
						[
							-80.2740912779999,
							25.782271159000132
						],
						[
							-80.27417221999984,
							25.78229130600011
						],
						[
							-80.27418776099988,
							25.78229532200009
						],
						[
							-80.27424407699992,
							25.78231240500017
						],
						[
							-80.27429960849994,
							25.782333323000124
						],
						[
							-80.2744420619997,
							25.782392511000403
						],
						[
							-80.2744947599998,
							25.78241642300025
						],
						[
							-80.27454666099973,
							25.782444164000147
						],
						[
							-80.27459663599979,
							25.78247524100032
						],
						[
							-80.2746445924999,
							25.782509612000233
						],
						[
							-80.27470071299979,
							25.782552704000068
						],
						[
							-80.27474596399962,
							25.782589854000122
						],
						[
							-80.27476974099973,
							25.78261212400019
						],
						[
							-80.27478518199985,
							25.78261060300015
						],
						[
							-80.27484399999993,
							25.78260867800008
						],
						[
							-80.2749028189998,
							25.78261060300015
						],
						[
							-80.27496138499986,
							25.782616371000096
						],
						[
							-80.2750194489996,
							25.78262595800009
						],
						[
							-80.2750767619999,
							25.782639321000218
						],
						[
							-80.27513307799967,
							25.7826564040003
						],
						[
							-80.2751881559997,
							25.78267713400006
						],
						[
							-80.27524175999979,
							25.782701422000116
						],
						[
							-80.27524666499976,
							25.78270386000014
						],
						[
							-80.2754980647945,
							25.782829744901044
						],
						[
							-80.27514199999987,
							25.783620999999997
						],
						[
							-80.27510499999993,
							25.78359600000006
						],
						[
							-80.27508499999988,
							25.78356500000016
						],
						[
							-80.2750649999999,
							25.78356300000017
						],
						[
							-80.27499699999987,
							25.783535000000164
						],
						[
							-80.27493999999986,
							25.78349700000004
						],
						[
							-80.27484999999987,
							25.783471000000198
						],
						[
							-80.27482199999987,
							25.783471000000198
						],
						[
							-80.27479999999991,
							25.78347900000015
						],
						[
							-80.27475099999985,
							25.783514000000206
						],
						[
							-80.27466699999992,
							25.78359100000018
						],
						[
							-80.27460299999979,
							25.783663000000097
						],
						[
							-80.27455799999987,
							25.78372400000017
						],
						[
							-80.27445699999987,
							25.783863000000125
						],
						[
							-80.27437199999986,
							25.78395800000017
						],
						[
							-80.27428460644488,
							25.783990404351904
						],
						[
							-80.2742329999999,
							25.783993000000045
						],
						[
							-80.27420699999988,
							25.784024000000123
						],
						[
							-80.27420216785816,
							25.784078119987548
						],
						[
							-80.2742319999999,
							25.784117000000002
						],
						[
							-80.27438299999996,
							25.784152000000056
						],
						[
							-80.27451199999989,
							25.78422300000007
						],
						[
							-80.27472899999991,
							25.784294000000084
						],
						[
							-80.27511299999988,
							25.784488000000145
						],
						[
							-80.27540699999987,
							25.7845960000002
						],
						[
							-80.27552399999986,
							25.78463200000016
						],
						[
							-80.27568799999993,
							25.784695000000042
						],
						[
							-80.27622999999993,
							25.784930000000124
						],
						[
							-80.2764979999999,
							25.78504100000007
						],
						[
							-80.27659299999995,
							25.785062000000032
						],
						[
							-80.27673299999981,
							25.785108000000108
						],
						[
							-80.27683499999989,
							25.785173000000157
						],
						[
							-80.27693399999991,
							25.785209000000116
						],
						[
							-80.27691499999985,
							25.785227000000184
						],
						[
							-80.2768059999999,
							25.78522900000017
						],
						[
							-80.27663399999997,
							25.785222000000125
						],
						[
							-80.27661199999991,
							25.785214000000174
						],
						[
							-80.2765849999999,
							25.785194000000118
						],
						[
							-80.27654899999995,
							25.785146000000054
						],
						[
							-80.27650499999994,
							25.785121000000117
						],
						[
							-80.27648099999992,
							25.785117000000145
						],
						[
							-80.27644599999986,
							25.785121000000117
						],
						[
							-80.27640599999992,
							25.785133000000044
						],
						[
							-80.27636299999993,
							25.785139000000186
						],
						[
							-80.27633199999993,
							25.785137000000198
						],
						[
							-80.27624399999985,
							25.785118000000047
						],
						[
							-80.2761629999999,
							25.785092000000205
						],
						[
							-80.27606999999992,
							25.78508300000017
						],
						[
							-80.27584299999997,
							25.78504400000014
						],
						[
							-80.2756059999999,
							25.785026000000073
						],
						[
							-80.27541799999989,
							25.784992000000102
						],
						[
							-80.27522199999993,
							25.784933000000194
						],
						[
							-80.27490999999986,
							25.784871000000038
						],
						[
							-80.27480499999989,
							25.78486000000002
						],
						[
							-80.27436699999988,
							25.784845000000196
						],
						[
							-80.27435699999994,
							25.78484300000021
						],
						[
							-80.27434699999992,
							25.784841000000046
						],
						[
							-80.27431299999995,
							25.78481700000019
						],
						[
							-80.2743049999999,
							25.784794000000062
						],
						[
							-80.27430199999992,
							25.784755000000033
						],
						[
							-80.27427099999993,
							25.784627000000103
						],
						[
							-80.2742209999999,
							25.784496000000097
						],
						[
							-80.2742019999999,
							25.784426000000167
						],
						[
							-80.2741589999999,
							25.78431000000016
						],
						[
							-80.27414999999986,
							25.784245000000112
						],
						[
							-80.27414549999985,
							25.78423650000012
						],
						[
							-80.27414099999993,
							25.784228000000127
						],
						[
							-80.27407499999988,
							25.784240000000054
						],
						[
							-80.27403899999992,
							25.784261000000193
						],
						[
							-80.27400999999992,
							25.784288000000117
						],
						[
							-80.2738809999999,
							25.78444200000007
						],
						[
							-80.27381399999977,
							25.784543000000077
						],
						[
							-80.27378399999988,
							25.784571000000085
						],
						[
							-80.27374699999991,
							25.784592000000046
						],
						[
							-80.27359799999994,
							25.784642000000098
						],
						[
							-80.27356799999986,
							25.78466300000006
						],
						[
							-80.27344899999989,
							25.784782000000135
						],
						[
							-80.27340799999985,
							25.78483800000015
						],
						[
							-80.27333706230262,
							25.784963184171623
						],
						[
							-80.27323799999982,
							25.785138000000103
						],
						[
							-80.27319899999988,
							25.785164000000123
						],
						[
							-80.27315699999987,
							25.78517100000017
						],
						[
							-80.27311099999987,
							25.785165000000028
						],
						[
							-80.27308399999987,
							25.785174000000065
						],
						[
							-80.2730069999999,
							25.785235000000135
						],
						[
							-80.27298486937474,
							25.785257745364838
						],
						[
							-80.27286299999987,
							25.785383000000124
						],
						[
							-80.27273299999986,
							25.78548600000012
						],
						[
							-80.27266299999985,
							25.785591000000103
						],
						[
							-80.27259499999991,
							25.785664000000107
						],
						[
							-80.2725369999999,
							25.78575100000002
						],
						[
							-80.27220499999987,
							25.78615800000012
						],
						[
							-80.2721409999999,
							25.786223000000174
						],
						[
							-80.27200099999988,
							25.78630600000011
						],
						[
							-80.27193299999995,
							25.78635500000008
						],
						[
							-80.27187599999992,
							25.78642800000008
						],
						[
							-80.27178599999985,
							25.7865270000001
						],
						[
							-80.27174299999984,
							25.78659800000011
						],
						[
							-80.27156999999991,
							25.786825000000064
						],
						[
							-80.27153799999985,
							25.786849000000096
						],
						[
							-80.2714999999999,
							25.786852000000167
						],
						[
							-80.27146799999993,
							25.786873000000128
						],
						[
							-80.27143599999994,
							25.78688100000008
						],
						[
							-80.27124399999985,
							25.78697700000003
						],
						[
							-80.27123199999993,
							25.787053000000103
						],
						[
							-80.27120299999984,
							25.78711800000015
						],
						[
							-80.27115399999988,
							25.787191000000153
						],
						[
							-80.27106399999988,
							25.787288000000004
						],
						[
							-80.27100599999989,
							25.787364000000075
						],
						[
							-80.2708709999999,
							25.787517000000122
						],
						[
							-80.27081999999986,
							25.787588000000135
						],
						[
							-80.27068999999993,
							25.787742000000087
						],
						[
							-80.27068149999985,
							25.787747000000145
						],
						[
							-80.27067299999995,
							25.787752000000026
						],
						[
							-80.2704179999999,
							25.788028000000125
						],
						[
							-80.27034599999989,
							25.788095000000162
						],
						[
							-80.27027999999986,
							25.788173000000043
						],
						[
							-80.27018199999992,
							25.78826400000011
						],
						[
							-80.27007399999987,
							25.788398000000186
						],
						[
							-80.27000399999993,
							25.78850100000018
						],
						[
							-80.26992999999993,
							25.788582000000133
						],
						[
							-80.26984199999994,
							25.788653000000146
						],
						[
							-80.26973099999991,
							25.788726000000146
						],
						[
							-80.26957799999985,
							25.788849000000198
						],
						[
							-80.26934499999994,
							25.789069000000104
						],
						[
							-80.26929799999986,
							25.7891410000002
						],
						[
							-80.26919199999989,
							25.789337000000074
						],
						[
							-80.26910899999986,
							25.789446000000034
						],
						[
							-80.26901099999992,
							25.789546000000136
						],
						[
							-80.26889199999994,
							25.789650000000037
						],
						[
							-80.26882199999991,
							25.789728000000096
						],
						[
							-80.26869999999987,
							25.789840000000126
						],
						[
							-80.2685981072196,
							25.78991406168491
						],
						[
							-80.26852499999985,
							25.790001000000125
						],
						[
							-80.26840305078905,
							25.790104412930788
						],
						[
							-80.26839999999991,
							25.790107000000013
						],
						[
							-80.26838174293037,
							25.79012425792648
						],
						[
							-80.26799799999986,
							25.790487000000013
						],
						[
							-80.26794599999991,
							25.790551000000157
						],
						[
							-80.26793986016594,
							25.790556628181278
						],
						[
							-80.2678019999999,
							25.790683000000065
						],
						[
							-80.26760742512165,
							25.79088435111789
						],
						[
							-80.26760099999989,
							25.790891000000045
						],
						[
							-80.26758714102236,
							25.79090378602455
						],
						[
							-80.26744599999994,
							25.791034000000153
						],
						[
							-80.26725754878245,
							25.791226092786985
						],
						[
							-80.26723899999986,
							25.79124500000003
						],
						[
							-80.2672222487124,
							25.791260370686974
						],
						[
							-80.2670569999999,
							25.791412000000165
						],
						[
							-80.26694899999984,
							25.79149100000013
						],
						[
							-80.26686099999993,
							25.79157500000015
						],
						[
							-80.2668079999999,
							25.791652000000127
						],
						[
							-80.2667509999999,
							25.79171500000019
						],
						[
							-80.26667999999997,
							25.791774000000096
						],
						[
							-80.26658499999992,
							25.791878000000175
						],
						[
							-80.2663859999999,
							25.79206800000009
						],
						[
							-80.26632399999991,
							25.792143000000074
						],
						[
							-80.26592099999988,
							25.792535
						],
						[
							-80.2658429999999,
							25.79260300000012
						],
						[
							-80.26577799999986,
							25.792674000000133
						],
						[
							-80.26565699999988,
							25.792771000000165
						],
						[
							-80.26546099999992,
							25.79294900000015
						],
						[
							-80.26545271172363,
							25.792954789604856
						],
						[
							-80.26532499999986,
							25.793044000000194
						],
						[
							-80.26518794918303,
							25.793150302236363
						],
						[
							-80.26516899999991,
							25.79316500000008
						],
						[
							-80.26497499999994,
							25.79325100000009
						],
						[
							-80.26480699999989,
							25.793365000000108
						],
						[
							-80.26468199999997,
							25.7934250000001
						],
						[
							-80.26448099999992,
							25.793504000000063
						],
						[
							-80.2642959999999,
							25.79355000000014
						],
						[
							-80.2642059999999,
							25.793564000000057
						],
						[
							-80.26350814898773,
							25.793699067938046
						],
						[
							-80.26308999999993,
							25.79378000000016
						],
						[
							-80.2628339999999,
							25.793854000000067
						],
						[
							-80.26258699999988,
							25.793820000000096
						],
						[
							-80.26233899999988,
							25.793790000000104
						],
						[
							-80.26070199999988,
							25.793563000000148
						],
						[
							-80.2584639999999,
							25.79376700000015
						],
						[
							-80.2580529999999,
							25.79377900000008
						],
						[
							-80.25616002999605,
							25.79385058289951
						],
						[
							-80.25614899999994,
							25.793851000000174
						],
						[
							-80.2560467519889,
							25.793853510554072
						],
						[
							-80.256004211002,
							25.793854555087243
						],
						[
							-80.2557009999999,
							25.79386200000002
						],
						[
							-80.25565453000281,
							25.79386309912543
						],
						[
							-80.25562653900404,
							25.793863761178777
						],
						[
							-80.25388299999986,
							25.793905000000024
						],
						[
							-80.25162999999986,
							25.793970000000073
						],
						[
							-80.25007099999992,
							25.794008000000197
						],
						[
							-80.24797699999995,
							25.79406100000014
						],
						[
							-80.24506054598886,
							25.79414288960866
						],
						[
							-80.2450209999999,
							25.79414400000008
						],
						[
							-80.24387199999987,
							25.794173000000175
						],
						[
							-80.24309965601695,
							25.79419877251194
						],
						[
							-80.24298190802222,
							25.794202701669917
						],
						[
							-80.2429429999999,
							25.79420400000007
						],
						[
							-80.24271982200196,
							25.79420681316826
						],
						[
							-80.24270499999993,
							25.794207000000142
						],
						[
							-80.24241699999982,
							25.794216000000176
						],
						[
							-80.24226228599048,
							25.794219878624357
						],
						[
							-80.24146005599995,
							25.793738541000018
						]
					],
					[
						[
							-80.2716597299997,
							25.785325584000525
						],
						[
							-80.27187533949983,
							25.78504207300025
						],
						[
							-80.27191385399986,
							25.784995036000176
						],
						[
							-80.27195408299973,
							25.784952083000086
						],
						[
							-80.2719970349999,
							25.784911854000043
						],
						[
							-80.27200537999988,
							25.784904707000074
						],
						[
							-80.27199451999978,
							25.784891473000044
						],
						[
							-80.27196024099987,
							25.784843637000172
						],
						[
							-80.27192916399962,
							25.784793661000123
						],
						[
							-80.2719014219998,
							25.78474176000054
						],
						[
							-80.27187713499984,
							25.784688156000186
						],
						[
							-80.27185640499981,
							25.78463307800007
						],
						[
							-80.27183932099982,
							25.784576762000206
						],
						[
							-80.27183454699978,
							25.784558151000176
						],
						[
							-80.27178892899974,
							25.784372088000502
						],
						[
							-80.27175371799966,
							25.78436685200007
						],
						[
							-80.27142129799978,
							25.784339379000194
						],
						[
							-80.27143764949976,
							25.784607444000258
						],
						[
							-80.27143835499986,
							25.784620322000084
						],
						[
							-80.27144638699973,
							25.784793442000193
						],
						[
							-80.27147144999975,
							25.785062628999995
						],
						[
							-80.27147339699974,
							25.785087181000073
						],
						[
							-80.2714753219999,
							25.785146000000054
						],
						[
							-80.27147339699974,
							25.785204818000125
						],
						[
							-80.27146762899962,
							25.785263385000086
						],
						[
							-80.27146262999973,
							25.785296560000077
						],
						[
							-80.27141734899963,
							25.785563212000113
						],
						[
							-80.2716597299997,
							25.785325584000525
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami",
				"Name": "Flagami",
				"RegionID": "124381"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.46212432199991,
					30.383052237000076,
					-81.40045867799995,
					30.447576322000092
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.44378551599993,
							30.44615117800004
						],
						[
							-81.44186201499991,
							30.44437147800005
						],
						[
							-81.43865047799994,
							30.44139922200009
						],
						[
							-81.43321528999991,
							30.440780552000035
						],
						[
							-81.4330684549999,
							30.44075129400005
						],
						[
							-81.43081892299995,
							30.440104396000038
						],
						[
							-81.42700117399994,
							30.439556192000058
						],
						[
							-81.42692313099992,
							30.439541442000063
						],
						[
							-81.4268466929999,
							30.439519864000093
						],
						[
							-81.42677245699991,
							30.43949162600006
						],
						[
							-81.42670100299995,
							30.439456948000043
						],
						[
							-81.42525400199992,
							30.438673948000087
						],
						[
							-81.4251878959999,
							30.43863442600008
						],
						[
							-81.42512541299993,
							30.43858939300009
						],
						[
							-81.42506701199994,
							30.438539179000085
						],
						[
							-81.42501312299993,
							30.438484152000058
						],
						[
							-81.42496413899994,
							30.438424716000043
						],
						[
							-81.42492041999992,
							30.43836130600005
						],
						[
							-81.42277529499995,
							30.43494574800008
						],
						[
							-81.4224776289999,
							30.434689011000046
						],
						[
							-81.42237607899995,
							30.434586073000048
						],
						[
							-81.4222861639999,
							30.434457661000067
						],
						[
							-81.42221991299994,
							30.43431558700007
						],
						[
							-81.4221793399999,
							30.434164166000073
						],
						[
							-81.42217155299994,
							30.43411063600007
						],
						[
							-81.42211055399991,
							30.43357963600005
						],
						[
							-81.42210493399995,
							30.43349844000005
						],
						[
							-81.42207393299992,
							30.432198439000047
						],
						[
							-81.42207367799995,
							30.43217700000008
						],
						[
							-81.42208827199994,
							30.432015725000042
						],
						[
							-81.42231707399992,
							30.43080021800006
						],
						[
							-81.42144336199993,
							30.42707002900005
						],
						[
							-81.42034185299991,
							30.422364109000057
						],
						[
							-81.41844721199993,
							30.419910670000036
						],
						[
							-81.41838016499992,
							30.419810661000046
						],
						[
							-81.41831391399995,
							30.419668586000057
						],
						[
							-81.41827334099992,
							30.419517165000062
						],
						[
							-81.41825967799993,
							30.41936100000004
						],
						[
							-81.41827334099992,
							30.419204834000084
						],
						[
							-81.41831656099993,
							30.419046328000036
						],
						[
							-81.41841905399991,
							30.41877864100007
						],
						[
							-81.41850382199993,
							30.41855676600005
						],
						[
							-81.41847911999992,
							30.41771054900005
						],
						[
							-81.41825098499993,
							30.415643418000062
						],
						[
							-81.4175910269999,
							30.41403547100009
						],
						[
							-81.41758028699991,
							30.414008032000083
						],
						[
							-81.41700802799994,
							30.41247235900005
						],
						[
							-81.41631081799994,
							30.41148478100007
						],
						[
							-81.41489459399992,
							30.410547908000073
						],
						[
							-81.41389374999994,
							30.40988496400007
						],
						[
							-81.40985340299994,
							30.40842050400005
						],
						[
							-81.4079836009999,
							30.40823111100008
						],
						[
							-81.40715334399994,
							30.408355415000074
						],
						[
							-81.40709136099991,
							30.408516168000062
						],
						[
							-81.40720573099992,
							30.40923824500004
						],
						[
							-81.40775022399993,
							30.40929684000008
						],
						[
							-81.40781016499994,
							30.40930534000006
						],
						[
							-81.40796158599994,
							30.40934591300004
						],
						[
							-81.40810366099993,
							30.409412164000063
						],
						[
							-81.40823207299991,
							30.40950207900005
						],
						[
							-81.40834291999994,
							30.40961292700007
						],
						[
							-81.40843283499993,
							30.40974133900005
						],
						[
							-81.4084458609999,
							30.40976469500004
						],
						[
							-81.40913585999994,
							30.41104101500008
						],
						[
							-81.4107929999999,
							30.411043678000055
						],
						[
							-81.41085499999993,
							30.411043678000055
						],
						[
							-81.41093434399994,
							30.41104718200006
						],
						[
							-81.41101306899992,
							30.411057675000052
						],
						[
							-81.41109056099992,
							30.41107507400005
						],
						[
							-81.41116621499992,
							30.411099244000066
						],
						[
							-81.4112394409999,
							30.41112999600006
						],
						[
							-81.4113096669999,
							30.41116709100004
						],
						[
							-81.41137634499995,
							30.41121023900007
						],
						[
							-81.41143895499994,
							30.411259103000077
						],
						[
							-81.41150583799993,
							30.411317125000036
						],
						[
							-81.41156170999994,
							30.411369995000086
						],
						[
							-81.4116128469999,
							30.41142745700006
						],
						[
							-81.41165887299991,
							30.411489088000053
						],
						[
							-81.4116994499999,
							30.411554437000063
						],
						[
							-81.41173427899992,
							30.41162302100008
						],
						[
							-81.41176310399995,
							30.411694337000082
						],
						[
							-81.41178571299992,
							30.411767861000044
						],
						[
							-81.41180194099991,
							30.411843051000062
						],
						[
							-81.41181587499995,
							30.411881281000035
						],
						[
							-81.41183972399995,
							30.41195068400009
						],
						[
							-81.41185783499992,
							30.412021800000044
						],
						[
							-81.4118700869999,
							30.412094156000084
						],
						[
							-81.41193004699994,
							30.41256400700007
						],
						[
							-81.4119908589999,
							30.41297987900009
						],
						[
							-81.41199873099993,
							30.413056516000037
						],
						[
							-81.41200001399994,
							30.413133545000047
						],
						[
							-81.41199469999994,
							30.41321040100007
						],
						[
							-81.4119828279999,
							30.413286520000042
						],
						[
							-81.41196448499994,
							30.413361344000066
						],
						[
							-81.41190248499994,
							30.413574344000043
						],
						[
							-81.41186066399992,
							30.413688581000084
						],
						[
							-81.41155366399994,
							30.41437858000006
						],
						[
							-81.41148395599993,
							30.41450629700006
						],
						[
							-81.4106829559999,
							30.41572729800004
						],
						[
							-81.41061992099993,
							30.41581207300004
						],
						[
							-81.4105090729999,
							30.41592292100006
						],
						[
							-81.41038066099992,
							30.41601283600005
						],
						[
							-81.41023858699992,
							30.41607908600008
						],
						[
							-81.41008716599993,
							30.41611965900006
						],
						[
							-81.40993099999992,
							30.416133322000068
						],
						[
							-81.40987544299992,
							30.41613160400004
						],
						[
							-81.40729044199992,
							30.415971604000053
						],
						[
							-81.40718983399995,
							30.41595965900007
						],
						[
							-81.40703841399994,
							30.415919086000084
						],
						[
							-81.40689633899991,
							30.41585283600006
						],
						[
							-81.40676792699992,
							30.415762921000066
						],
						[
							-81.4066570789999,
							30.415652073000047
						],
						[
							-81.40656716399991,
							30.415523661000066
						],
						[
							-81.40654060899993,
							30.415474156000077
						],
						[
							-81.40055260899993,
							30.403422156000094
						],
						[
							-81.40051291399993,
							30.403329586000044
						],
						[
							-81.4004723409999,
							30.40317816600009
						],
						[
							-81.40045867799995,
							30.403022000000078
						],
						[
							-81.4004723409999,
							30.402865835000057
						],
						[
							-81.40051291399993,
							30.40271441400006
						],
						[
							-81.40057916399991,
							30.402572339000073
						],
						[
							-81.4006690789999,
							30.402443927000036
						],
						[
							-81.40077992699992,
							30.402333080000066
						],
						[
							-81.4009083389999,
							30.402243164000087
						],
						[
							-81.40105041399994,
							30.40217691400005
						],
						[
							-81.40120183399995,
							30.402136341000077
						],
						[
							-81.4013579999999,
							30.40212267800007
						],
						[
							-81.40151416599991,
							30.402136341000077
						],
						[
							-81.40166558599994,
							30.40217691400005
						],
						[
							-81.4016952479999,
							30.402188307000074
						],
						[
							-81.40669368699992,
							30.404210291000084
						],
						[
							-81.41360939799995,
							30.405450778000045
						],
						[
							-81.41475876299995,
							30.40532317000009
						],
						[
							-81.41485799999992,
							30.405317678000074
						],
						[
							-81.41497869699992,
							30.405325814000037
						],
						[
							-81.41787166699993,
							30.405717663000072
						],
						[
							-81.41881924199993,
							30.40585892000007
						],
						[
							-81.4210897129999,
							30.405526701000046
						],
						[
							-81.42396980099994,
							30.40489738900004
						],
						[
							-81.42577280699993,
							30.40442431300005
						],
						[
							-81.42685559499996,
							30.403923701000053
						],
						[
							-81.42692916199991,
							30.40389355900004
						],
						[
							-81.42700510399993,
							30.40387003300009
						],
						[
							-81.42708282699994,
							30.40385330500004
						],
						[
							-81.42716172399992,
							30.403843507000087
						],
						[
							-81.4274165569999,
							30.40382324600006
						],
						[
							-81.43066668799992,
							30.40081534700005
						],
						[
							-81.43068546699993,
							30.400795907000088
						],
						[
							-81.43074511899994,
							30.400735100000077
						],
						[
							-81.4307764369999,
							30.400703967000087
						],
						[
							-81.43439984399993,
							30.396634393000056
						],
						[
							-81.4344495549999,
							30.396582934000033
						],
						[
							-81.43450319899995,
							30.396535589000052
						],
						[
							-81.4345604369999,
							30.396492659000046
						],
						[
							-81.4346209069999,
							30.396454414000058
						],
						[
							-81.43468422599994,
							30.39642109800008
						],
						[
							-81.43474999299993,
							30.39639292000004
						],
						[
							-81.43481779099994,
							30.39637006000004
						],
						[
							-81.43488719299995,
							30.396352662000087
						],
						[
							-81.43512819599994,
							30.396302343000055
						],
						[
							-81.43510521099995,
							30.395634955000045
						],
						[
							-81.4351046779999,
							30.395604000000045
						],
						[
							-81.4351183409999,
							30.39544783400004
						],
						[
							-81.43515891399994,
							30.395296414000086
						],
						[
							-81.43522516399992,
							30.395154339000047
						],
						[
							-81.4353150789999,
							30.395025927000063
						],
						[
							-81.43542592699993,
							30.394915079000043
						],
						[
							-81.43544164899993,
							30.39490218700007
						],
						[
							-81.43579615899995,
							30.394618125000083
						],
						[
							-81.4394481139999,
							30.38897819800007
						],
						[
							-81.43951407899993,
							30.38888892700004
						],
						[
							-81.4395520999999,
							30.38884642900007
						],
						[
							-81.44168009999993,
							30.386614428000087
						],
						[
							-81.44175292699992,
							30.386546079000087
						],
						[
							-81.44182404699991,
							30.386492182000044
						],
						[
							-81.44557804699991,
							30.383930181000043
						],
						[
							-81.44564516499992,
							30.383888573000032
						],
						[
							-81.44571567499992,
							30.383853012000085
						],
						[
							-81.44578903199994,
							30.383823775000057
						],
						[
							-81.44586467199991,
							30.383801085000073
						],
						[
							-81.4475346719999,
							30.38337908500006
						],
						[
							-81.44765249999995,
							30.383357538000038
						],
						[
							-81.45026749999994,
							30.383057538000063
						],
						[
							-81.45033828899994,
							30.383052237000076
						],
						[
							-81.4504092759999,
							30.38305253600004
						],
						[
							-81.45048001899994,
							30.38305843300009
						],
						[
							-81.4505500759999,
							30.38306989100005
						],
						[
							-81.4506190109999,
							30.38308683900004
						],
						[
							-81.45454401099994,
							30.384217839000087
						],
						[
							-81.45460220799993,
							30.384236776000083
						],
						[
							-81.45465898299994,
							30.384259627000063
						],
						[
							-81.45471407199994,
							30.38428628700007
						],
						[
							-81.45476722099994,
							30.384316632000036
						],
						[
							-81.45529376899992,
							30.384641505000047
						],
						[
							-81.46159266899991,
							30.38746326900008
						],
						[
							-81.4616746609999,
							30.38750516400006
						],
						[
							-81.46180307299994,
							30.387595079000047
						],
						[
							-81.46191391999993,
							30.387705927000066
						],
						[
							-81.4620038349999,
							30.387834339000054
						],
						[
							-81.46207008599993,
							30.387976414000036
						],
						[
							-81.4621106589999,
							30.388127834000045
						],
						[
							-81.46212432199991,
							30.38828400000006
						],
						[
							-81.4621106589999,
							30.38844016500008
						],
						[
							-81.46206684999993,
							30.388600201000088
						],
						[
							-81.46176884599993,
							30.389372269000035
						],
						[
							-81.4617521959999,
							30.38945719500003
						],
						[
							-81.46156006099994,
							30.39023682200008
						],
						[
							-81.46151231399995,
							30.390740819000087
						],
						[
							-81.46150278899995,
							30.390811428000063
						],
						[
							-81.46148770499991,
							30.390881062000062
						],
						[
							-81.46146715599991,
							30.390949283000054
						],
						[
							-81.4614412709999,
							30.39101566400007
						],
						[
							-81.46141021199992,
							30.39107978700008
						],
						[
							-81.46137417499995,
							30.39114125000009
						],
						[
							-81.45980917499992,
							30.393583249000073
						],
						[
							-81.45976887799992,
							30.39364101600006
						],
						[
							-81.45972418299993,
							30.393695452000085
						],
						[
							-81.45967536599994,
							30.393746224000044
						],
						[
							-81.45962272499992,
							30.39379302000009
						],
						[
							-81.4595665839999,
							30.393835552000038
						],
						[
							-81.4595072859999,
							30.393873561000078
						],
						[
							-81.45944519499994,
							30.39390681200007
						],
						[
							-81.4593806929999,
							30.393935102000057
						],
						[
							-81.45432076599991,
							30.39592190700006
						],
						[
							-81.45417233799992,
							30.39643839400009
						],
						[
							-81.4541467219999,
							30.396514537000087
						],
						[
							-81.45411441399995,
							30.39658809100007
						],
						[
							-81.45407566999995,
							30.396658468000055
						],
						[
							-81.45403079999994,
							30.39672510700007
						],
						[
							-81.45398016299993,
							30.396787475000057
						],
						[
							-81.45394016299991,
							30.396832476000043
						],
						[
							-81.45384607299991,
							30.396923921000052
						],
						[
							-81.45371766099993,
							30.397013836000045
						],
						[
							-81.45357558599994,
							30.397080087000063
						],
						[
							-81.45342416499994,
							30.39712066000004
						],
						[
							-81.45326799999992,
							30.397134322000056
						],
						[
							-81.45317670199995,
							30.39712967600008
						],
						[
							-81.45307870199991,
							30.397119676000045
						],
						[
							-81.45300666399993,
							30.397109365000066
						],
						[
							-81.45293569499995,
							30.397093263000045
						],
						[
							-81.45286625999995,
							30.397071476000065
						],
						[
							-81.45279881399995,
							30.397044147000088
						],
						[
							-81.45273379899993,
							30.39701145300006
						],
						[
							-81.45267163999995,
							30.396973610000092
						],
						[
							-81.45261274399991,
							30.39693086600005
						],
						[
							-81.45255574399994,
							30.39688586600005
						],
						[
							-81.45249831399991,
							30.39683646200007
						],
						[
							-81.45244524599991,
							30.396782399000074
						],
						[
							-81.45239691499995,
							30.39672406200009
						],
						[
							-81.45235366599991,
							30.396661864000066
						],
						[
							-81.45233924399992,
							30.396639486000083
						],
						[
							-81.45232999099994,
							30.39666351000005
						],
						[
							-81.45228399199993,
							30.396779510000044
						],
						[
							-81.45225527899993,
							30.396844335000083
						],
						[
							-81.45222154899994,
							30.396906697000077
						],
						[
							-81.45218301099995,
							30.396966208000038
						],
						[
							-81.45213990499991,
							30.39702249900006
						],
						[
							-81.4520924979999,
							30.397075218000055
						],
						[
							-81.45204108599995,
							30.397124040000048
						],
						[
							-81.4483900859999,
							30.400327040000036
						],
						[
							-81.44837507299991,
							30.400339921000068
						],
						[
							-81.44824666099993,
							30.40042983600006
						],
						[
							-81.44810458599994,
							30.40049608700008
						],
						[
							-81.44795316599993,
							30.400536660000057
						],
						[
							-81.44779699999992,
							30.400550322000072
						],
						[
							-81.44772419499992,
							30.400547371000073
						],
						[
							-81.4475271949999,
							30.40053137000007
						],
						[
							-81.4474601789999,
							30.40052339100004
						],
						[
							-81.44739395099992,
							30.40051040500003
						],
						[
							-81.44732888399994,
							30.40049248500009
						],
						[
							-81.44726534499995,
							30.40046973300008
						],
						[
							-81.44720369299995,
							30.40044227700008
						],
						[
							-81.44714427499991,
							30.400410271000055
						],
						[
							-81.4454715789999,
							30.399409394000088
						],
						[
							-81.4439108599999,
							30.402540223000074
						],
						[
							-81.44388483599994,
							30.40258866100004
						],
						[
							-81.44380061499993,
							30.402710218000042
						],
						[
							-81.44239976799992,
							30.40441364600008
						],
						[
							-81.44228607299993,
							30.404527921000067
						],
						[
							-81.44220786199992,
							30.404586609000038
						],
						[
							-81.44100986099996,
							30.405387609000062
						],
						[
							-81.44095966099991,
							30.40541883600008
						],
						[
							-81.44081758599992,
							30.405485086000056
						],
						[
							-81.44066616499993,
							30.405525659000034
						],
						[
							-81.4405099999999,
							30.405539322000042
						],
						[
							-81.44035383399995,
							30.405525659000034
						],
						[
							-81.44020241399996,
							30.405485086000056
						],
						[
							-81.4400603389999,
							30.40541883600008
						],
						[
							-81.44002080899992,
							30.405391156000068
						],
						[
							-81.44001065899994,
							30.405507165000078
						],
						[
							-81.4399700859999,
							30.405658586000072
						],
						[
							-81.43990383599993,
							30.405800661000054
						],
						[
							-81.43981391999995,
							30.405929073000042
						],
						[
							-81.43970307299992,
							30.40603992000007
						],
						[
							-81.43964752399995,
							30.406082948000062
						],
						[
							-81.43705503799993,
							30.40793367500004
						],
						[
							-81.44643069699993,
							30.415923815000042
						],
						[
							-81.44632737299992,
							30.413296338000066
						],
						[
							-81.44632997699995,
							30.41318404200007
						],
						[
							-81.44634397699991,
							30.41302104200008
						],
						[
							-81.44635341799994,
							30.412947161000087
						],
						[
							-81.4463689399999,
							30.412874315000067
						],
						[
							-81.44639043699995,
							30.41280300300008
						],
						[
							-81.4464177609999,
							30.41273371400007
						],
						[
							-81.44646873699992,
							30.412618656000063
						],
						[
							-81.44649728799995,
							30.412530345000047
						],
						[
							-81.44652496899994,
							30.412456078000044
						],
						[
							-81.44655908199991,
							30.412384536000047
						],
						[
							-81.44659936199992,
							30.412316275000077
						],
						[
							-81.44664549499993,
							30.412251826000045
						],
						[
							-81.44669712399991,
							30.412191689000053
						],
						[
							-81.44678812399991,
							30.41209468900007
						],
						[
							-81.44683983699991,
							30.412043842000063
						],
						[
							-81.44689547799993,
							30.411997326000062
						],
						[
							-81.4469546869999,
							30.41195544500005
						],
						[
							-81.44701707799993,
							30.411918471000035
						],
						[
							-81.44705600799995,
							30.411897473000067
						],
						[
							-81.44698737099992,
							30.411884371000042
						],
						[
							-81.44684841399993,
							30.411846086000082
						],
						[
							-81.44670633899995,
							30.411779836000054
						],
						[
							-81.44657792699991,
							30.41168992100006
						],
						[
							-81.44646707999995,
							30.41157907300004
						],
						[
							-81.44643795899992,
							30.41154247700007
						],
						[
							-81.44639195899993,
							30.411481477000052
						],
						[
							-81.44634749999994,
							30.411416837000047
						],
						[
							-81.44630884399993,
							30.41134856900004
						],
						[
							-81.44627628499991,
							30.411277192000057
						],
						[
							-81.4462500699999,
							30.41120324900004
						],
						[
							-81.44623039899994,
							30.411127303000058
						],
						[
							-81.4462174219999,
							30.411049931000036
						],
						[
							-81.44621123799993,
							30.410971722000056
						],
						[
							-81.44620823799994,
							30.410886722000043
						],
						[
							-81.44620767799995,
							30.410855000000083
						],
						[
							-81.4462213409999,
							30.410698834000073
						],
						[
							-81.44626191399993,
							30.410547413000074
						],
						[
							-81.44632816399991,
							30.41040533900008
						],
						[
							-81.44640931999993,
							30.410287529000072
						],
						[
							-81.44928268399991,
							30.406754857000063
						],
						[
							-81.44920901699993,
							30.405902431000072
						],
						[
							-81.44920567799994,
							30.405825000000046
						],
						[
							-81.4492193399999,
							30.405668834000043
						],
						[
							-81.44925991299993,
							30.405517414000087
						],
						[
							-81.4493261639999,
							30.40537533900004
						],
						[
							-81.44941607899995,
							30.405246927000064
						],
						[
							-81.4495330389999,
							30.40513104100006
						],
						[
							-81.4496441519999,
							30.405041004000058
						],
						[
							-81.4497659619999,
							30.40495568100005
						],
						[
							-81.44972434099992,
							30.404796166000036
						],
						[
							-81.44971067799992,
							30.40464000000009
						],
						[
							-81.44972434099992,
							30.404483834000075
						],
						[
							-81.4497649139999,
							30.404332414000063
						],
						[
							-81.44977326399993,
							30.40431037700006
						],
						[
							-81.4510732629999,
							30.401010376000045
						],
						[
							-81.45113116399995,
							30.400890339000057
						],
						[
							-81.45122704399995,
							30.40075496500009
						],
						[
							-81.45442444899993,
							30.39709900800005
						],
						[
							-81.4545289269999,
							30.396995079000078
						],
						[
							-81.45456703199994,
							30.396967093000058
						],
						[
							-81.45465533299995,
							30.396902500000067
						],
						[
							-81.4547279919999,
							30.39684360600006
						],
						[
							-81.45478722999991,
							30.396802597000086
						],
						[
							-81.45484956399991,
							30.396766467000077
						],
						[
							-81.4549145929999,
							30.396735449000065
						],
						[
							-81.4549818989999,
							30.396709741000052
						],
						[
							-81.45505104799992,
							30.396689510000044
						],
						[
							-81.45512159599991,
							30.396674885000042
						],
						[
							-81.45527135799995,
							30.396651429000087
						],
						[
							-81.45540999999992,
							30.39664067800004
						],
						[
							-81.45556616599993,
							30.396654341000048
						],
						[
							-81.45571758699992,
							30.396694914000083
						],
						[
							-81.45585966099992,
							30.396761164000058
						],
						[
							-81.45598807399995,
							30.396851080000094
						],
						[
							-81.45609281599991,
							30.396954729000075
						],
						[
							-81.45619186899995,
							30.39707032800004
						],
						[
							-81.45628483599995,
							30.397202339000046
						],
						[
							-81.45633826199992,
							30.397311235000075
						],
						[
							-81.4563902619999,
							30.397438235000035
						],
						[
							-81.45641658699992,
							30.39751140200008
						],
						[
							-81.4564364929999,
							30.397586570000044
						],
						[
							-81.45644983199993,
							30.39766317600004
						],
						[
							-81.4564565039999,
							30.397740648000077
						],
						[
							-81.45646989499994,
							30.398127318000036
						],
						[
							-81.4565010789999,
							30.398083927000073
						],
						[
							-81.45664907999992,
							30.40110907400009
						],
						[
							-81.4565971159999,
							30.401034862000078
						],
						[
							-81.45660850399992,
							30.401301648000075
						],
						[
							-81.45660847999994,
							30.40137890000005
						],
						[
							-81.45660182699993,
							30.40145586600005
						],
						[
							-81.45658859199995,
							30.401531977000047
						],
						[
							-81.4565688749999,
							30.40160667100008
						],
						[
							-81.45654281999992,
							30.40167939700007
						],
						[
							-81.4565106199999,
							30.401749619000043
						],
						[
							-81.45431061999994,
							30.40604962000009
						],
						[
							-81.45428883599993,
							30.406089661000067
						],
						[
							-81.45419892099994,
							30.406218073000044
						],
						[
							-81.45408807299992,
							30.40632892100007
						],
						[
							-81.45395966099996,
							30.406418836000057
						],
						[
							-81.4538175859999,
							30.40648508700008
						],
						[
							-81.4536845419999,
							30.406520736000065
						],
						[
							-81.45373043199993,
							30.406545005000055
						],
						[
							-81.45375966099994,
							30.406561164000042
						],
						[
							-81.45388807299992,
							30.406651079000085
						],
						[
							-81.45399892099994,
							30.40676192600006
						],
						[
							-81.45408883599993,
							30.406890339000086
						],
						[
							-81.4541550859999,
							30.40703241300008
						],
						[
							-81.45419565899994,
							30.40718383400008
						],
						[
							-81.45420633099991,
							30.40726671500005
						],
						[
							-81.45482471399993,
							30.414830016000053
						],
						[
							-81.45454874299992,
							30.41540645600009
						],
						[
							-81.45438420999994,
							30.41631138600008
						],
						[
							-81.45496007499992,
							30.420013373000074
						],
						[
							-81.45528913999993,
							30.42289269500009
						],
						[
							-81.45611180399993,
							30.427006013000035
						],
						[
							-81.45677825799993,
							30.430374057000048
						],
						[
							-81.45709671799995,
							30.432184172000067
						],
						[
							-81.4571069459999,
							30.43226215300007
						],
						[
							-81.45711032199995,
							30.432340729000092
						],
						[
							-81.45710681899993,
							30.432419300000053
						],
						[
							-81.45709646499995,
							30.432497264000062
						],
						[
							-81.45707933799991,
							30.432574025000065
						],
						[
							-81.45705556999991,
							30.432648996000072
						],
						[
							-81.45702534299994,
							30.432721604000047
						],
						[
							-81.4569888879999,
							30.432791294000083
						],
						[
							-81.45293272099991,
							30.43974901600006
						],
						[
							-81.4494268659999,
							30.445517141000042
						],
						[
							-81.44936550099993,
							30.445618104000065
						],
						[
							-81.44932651499994,
							30.44567246700007
						],
						[
							-81.4492859209999,
							30.445729073000056
						],
						[
							-81.44917507299995,
							30.445839920000083
						],
						[
							-81.4490466609999,
							30.445929835000072
						],
						[
							-81.4489045869999,
							30.44599608600004
						],
						[
							-81.4487531659999,
							30.44603665900007
						],
						[
							-81.44859699999995,
							30.446050322000076
						],
						[
							-81.44844083499993,
							30.44603665900007
						],
						[
							-81.44828941399993,
							30.44599608600004
						],
						[
							-81.44817927999992,
							30.445944730000065
						],
						[
							-81.4480945549999,
							30.446236103000047
						],
						[
							-81.44807608699995,
							30.446292587000077
						],
						[
							-81.44800983599993,
							30.446434661000072
						],
						[
							-81.44791992099994,
							30.446563073000053
						],
						[
							-81.44780907299992,
							30.44667392100007
						],
						[
							-81.44768066099994,
							30.44676383600006
						],
						[
							-81.4476296709999,
							30.446791128000086
						],
						[
							-81.44643447699991,
							30.447382205000057
						],
						[
							-81.44634429599995,
							30.447426203000074
						],
						[
							-81.44630118099991,
							30.447451998000076
						],
						[
							-81.44615258599993,
							30.44752208600005
						],
						[
							-81.44600116599992,
							30.447562659000084
						],
						[
							-81.4458449999999,
							30.447576322000092
						],
						[
							-81.44568883499994,
							30.447562659000084
						],
						[
							-81.44555234099994,
							30.44752737100004
						],
						[
							-81.44539087799991,
							30.447471729000085
						],
						[
							-81.44524390299995,
							30.44740431000008
						],
						[
							-81.44505762099993,
							30.447297573000075
						],
						[
							-81.44492792699992,
							30.447206920000042
						],
						[
							-81.44489518099994,
							30.44717806000006
						],
						[
							-81.44378551599993,
							30.44615117800004
						]
					],
					[
						[
							-81.44393590699991,
							30.43383873700009
						],
						[
							-81.44381339699993,
							30.433674875000065
						],
						[
							-81.44368801299993,
							30.434010283000074
						],
						[
							-81.44393590699991,
							30.43383873700009
						]
					],
					[
						[
							-81.44750420899993,
							30.393359106000048
						],
						[
							-81.44660760199992,
							30.39290182900004
						],
						[
							-81.44660292999993,
							30.39292722400006
						],
						[
							-81.44750420899993,
							30.393359106000048
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Fort George Island",
				"RegionID": "124432"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.56966389099995,
					30.353838013000082,
					-81.53671901899992,
					30.374919128000048
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-81.55629367199992,
								30.368556418000082
							],
							[
								-81.55192067199994,
								30.366650417000074
							],
							[
								-81.55185638299992,
								30.366619302000064
							],
							[
								-81.55179476599994,
								30.36658318400004
							],
							[
								-81.5517362089999,
								30.36654229000004
							],
							[
								-81.5516810819999,
								30.366496878000078
							],
							[
								-81.55162973299991,
								30.36644723500007
							],
							[
								-81.55159471999993,
								30.366410586000086
							],
							[
								-81.55027004299991,
								30.365816602000056
							],
							[
								-81.5502121479999,
								30.36578810500004
							],
							[
								-81.55015644499991,
								30.365755530000058
							],
							[
								-81.5501032219999,
								30.36571904400006
							],
							[
								-81.5500527509999,
								30.365678836000086
							],
							[
								-81.5500052939999,
								30.365635112000064
							],
							[
								-81.54920713199994,
								30.364844951000066
							],
							[
								-81.54368119299994,
								30.35936885500007
							],
							[
								-81.54294428799994,
								30.359321469000065
							],
							[
								-81.54284583499992,
								30.35930966000007
							],
							[
								-81.54276598699994,
								30.35929180100004
							],
							[
								-81.53781974899994,
								30.35794651300006
							],
							[
								-81.53798299999994,
								30.35705900000005
							],
							[
								-81.53792399999992,
								30.35704000000004
							],
							[
								-81.53820207799993,
								30.356645050000054
							],
							[
								-81.53812190699995,
								30.355911011000046
							],
							[
								-81.53786790899994,
								30.35526901500009
							],
							[
								-81.53738397099995,
								30.354532951000067
							],
							[
								-81.53671901899992,
								30.354085916000088
							],
							[
								-81.53741491599993,
								30.35405509900005
							],
							[
								-81.53770390999996,
								30.354027012000078
							],
							[
								-81.53897090999995,
								30.35393301300007
							],
							[
								-81.5392329089999,
								30.35390401300009
							],
							[
								-81.53963390699994,
								30.35385201300005
							],
							[
								-81.5398169099999,
								30.353866012000083
							],
							[
								-81.54052190899995,
								30.353851012000067
							],
							[
								-81.54096990999994,
								30.353838013000082
							],
							[
								-81.5414809099999,
								30.35384001300008
							],
							[
								-81.5421829089999,
								30.353931013000075
							],
							[
								-81.54244190999992,
								30.353979012000085
							],
							[
								-81.5428089099999,
								30.354067012000087
							],
							[
								-81.54309790999991,
								30.35412601300004
							],
							[
								-81.54357890999995,
								30.354259012000057
							],
							[
								-81.5439450099999,
								30.35438315600004
							],
							[
								-81.54394690999993,
								30.354297012000075
							],
							[
								-81.54395786499992,
								30.354151872000045
							],
							[
								-81.54403708699994,
								30.354247958000087
							],
							[
								-81.54402074899991,
								30.35441011400008
							],
							[
								-81.54430390899995,
								30.354511012000042
							],
							[
								-81.5449749089999,
								30.354801012000053
							],
							[
								-81.54563890899993,
								30.355152013000062
							],
							[
								-81.54632590999995,
								30.355589013000042
							],
							[
								-81.5465089089999,
								30.35569401300006
							],
							[
								-81.54681390999991,
								30.35591501500005
							],
							[
								-81.5469359089999,
								30.356054010000037
							],
							[
								-81.5470429099999,
								30.35613401500007
							],
							[
								-81.54708590999991,
								30.35618301200009
							],
							[
								-81.54714990899993,
								30.356255013000066
							],
							[
								-81.5474089089999,
								30.356504012000073
							],
							[
								-81.54791290899993,
								30.357031012000053
							],
							[
								-81.54816390899992,
								30.35731101300007
							],
							[
								-81.54871390999995,
								30.35789701300007
							],
							[
								-81.54906490999991,
								30.358250012000045
							],
							[
								-81.54956090999991,
								30.358723012000045
							],
							[
								-81.55073290999991,
								30.35975301200006
							],
							[
								-81.55094090999995,
								30.35993201200006
							],
							[
								-81.5512109089999,
								30.360135013000047
							],
							[
								-81.55187590999992,
								30.36073801300006
							],
							[
								-81.55193290999995,
								30.360796012000034
							],
							[
								-81.55228386999994,
								30.361099050000064
							],
							[
								-81.55317190999995,
								30.361893013000046
							],
							[
								-81.55335990899994,
								30.362057013000083
							],
							[
								-81.55343790899991,
								30.362127012000087
							],
							[
								-81.55394990899993,
								30.362585012000068
							],
							[
								-81.55445890999994,
								30.363039012000062
							],
							[
								-81.55577090999992,
								30.36417001200004
							],
							[
								-81.55680790999992,
								30.365082012000073
							],
							[
								-81.5578309089999,
								30.365948012000043
							],
							[
								-81.5579679089999,
								30.366074013000055
							],
							[
								-81.55817390899995,
								30.366266012000043
							],
							[
								-81.55840490999992,
								30.366449012000093
							],
							[
								-81.55856590999991,
								30.366548011000077
							],
							[
								-81.55892190899993,
								30.366709012000058
							],
							[
								-81.5591349099999,
								30.36677701200006
							],
							[
								-81.55936390999995,
								30.366823012000058
							],
							[
								-81.55953590999991,
								30.366846013000043
							],
							[
								-81.55969290999991,
								30.366855012000087
							],
							[
								-81.56104290999991,
								30.366837012000072
							],
							[
								-81.56165990999995,
								30.36683301200009
							],
							[
								-81.56213990999993,
								30.366832012000092
							],
							[
								-81.56302290999992,
								30.36681401300007
							],
							[
								-81.56339890999993,
								30.366795013000058
							],
							[
								-81.56423090899995,
								30.366780012000053
							],
							[
								-81.56488890899993,
								30.366771013000065
							],
							[
								-81.56569690999993,
								30.366768013000073
							],
							[
								-81.56619290899994,
								30.366762012000038
							],
							[
								-81.56680290899993,
								30.366760012000043
							],
							[
								-81.5671069089999,
								30.366746012000075
							],
							[
								-81.5673109089999,
								30.366736013000036
							],
							[
								-81.5675579089999,
								30.366735012000053
							],
							[
								-81.56793890999995,
								30.366733012000058
							],
							[
								-81.56887790999991,
								30.366728012000067
							],
							[
								-81.56966389099995,
								30.366702923000048
							],
							[
								-81.56951610199991,
								30.373009245000052
							],
							[
								-81.56949353899995,
								30.373972007000077
							],
							[
								-81.56879870299991,
								30.373687043000075
							],
							[
								-81.55631164899995,
								30.368564022000047
							],
							[
								-81.55629367199992,
								30.368556418000082
							]
						]
					],
					[
						[
							[
								-81.54543775299993,
								30.372844907000054
							],
							[
								-81.55154975399995,
								30.37108190800007
							],
							[
								-81.55164283399995,
								30.371060341000092
							],
							[
								-81.5517989999999,
								30.371046678000084
							],
							[
								-81.55195516599991,
								30.371060341000092
							],
							[
								-81.55210658599992,
								30.371100914000067
							],
							[
								-81.55224866099991,
								30.371167165000088
							],
							[
								-81.55234119799991,
								30.37122850400004
							],
							[
								-81.55251719799992,
								30.371361504000053
							],
							[
								-81.5525837209999,
								30.37141700400008
							],
							[
								-81.5529807289999,
								30.371782062000076
							],
							[
								-81.55316482899991,
								30.37177444600007
							],
							[
								-81.55320199999994,
								30.37177367800007
							],
							[
								-81.55335816599995,
								30.371787340000086
							],
							[
								-81.5535095859999,
								30.371827913000065
							],
							[
								-81.55365166099995,
								30.371894164000082
							],
							[
								-81.55378007299993,
								30.371984079000068
							],
							[
								-81.55389092099995,
								30.372094927000038
							],
							[
								-81.55398083599994,
								30.372223339000076
							],
							[
								-81.55404708599991,
								30.37236541300007
							],
							[
								-81.55408451699992,
								30.37249995800005
							],
							[
								-81.55419608799991,
								30.37306939700005
							],
							[
								-81.5542113219999,
								30.373234000000085
							],
							[
								-81.5541976589999,
								30.37339016600004
							],
							[
								-81.55415708599992,
								30.373541587000094
							],
							[
								-81.5540908349999,
								30.37368366100009
							],
							[
								-81.55400091999991,
								30.373812073000067
							],
							[
								-81.55389007299995,
								30.373922921000087
							],
							[
								-81.5537616609999,
								30.374012836000077
							],
							[
								-81.55361958599991,
								30.374079087000045
							],
							[
								-81.55346816499991,
								30.37411966000008
							],
							[
								-81.55337928199992,
								30.37413080200008
							],
							[
								-81.55236628199992,
								30.374206802000057
							],
							[
								-81.55230503599995,
								30.374209302000054
							],
							[
								-81.5521689059999,
								30.374210216000048
							],
							[
								-81.54915582799993,
								30.374316715000077
							],
							[
								-81.54803578999991,
								30.374802423000062
							],
							[
								-81.54794387999993,
								30.37484348000004
							],
							[
								-81.5478812039999,
								30.37486917200005
							],
							[
								-81.54781665099995,
								30.374889700000043
							],
							[
								-81.54775064799992,
								30.374904929000085
							],
							[
								-81.5476836279999,
								30.374914760000085
							],
							[
								-81.5476160309999,
								30.374919128000048
							],
							[
								-81.54754830199994,
								30.37491800400005
							],
							[
								-81.54742866999993,
								30.37491066000007
							],
							[
								-81.54569416599992,
								30.374843567000088
							],
							[
								-81.54557483399992,
								30.374830659000054
							],
							[
								-81.54542341399991,
								30.374790086000075
							],
							[
								-81.54528133899993,
								30.374723836000044
							],
							[
								-81.54515292699995,
								30.374633920000065
							],
							[
								-81.54513317199991,
								30.374616849000063
							],
							[
								-81.54501517199992,
								30.374511849000047
							],
							[
								-81.54492407899994,
								30.374418073000072
							],
							[
								-81.54483416399995,
								30.374289661000038
							],
							[
								-81.54476791399992,
								30.374147587000042
							],
							[
								-81.54472734099994,
								30.373996166000044
							],
							[
								-81.54471367799994,
								30.37384000000009
							],
							[
								-81.54472734099994,
								30.37368383500007
							],
							[
								-81.54476791399992,
								30.373532414000064
							],
							[
								-81.5448299709999,
								30.37339768200008
							],
							[
								-81.54490606699996,
								30.373263010000073
							],
							[
								-81.54499807899992,
								30.373130927000087
							],
							[
								-81.54510892699994,
								30.373020079000067
							],
							[
								-81.54523733899993,
								30.37293016400008
							],
							[
								-81.54537941399991,
								30.372863913000064
							],
							[
								-81.54543775299993,
								30.372844907000054
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Gilmore",
				"RegionID": "124532"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.13091799999995,
					26.45779200000004,
					-80.12250199999995,
					26.476095000000043
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.12254299999995,
							26.476095000000043
						],
						[
							-80.12253499999991,
							26.474747000000036
						],
						[
							-80.12252399999994,
							26.472976000000074
						],
						[
							-80.12251499999991,
							26.471589000000055
						],
						[
							-80.12250699999993,
							26.470263000000045
						],
						[
							-80.12250199999995,
							26.469449000000054
						],
						[
							-80.12250199999995,
							26.46917200000007
						],
						[
							-80.12250199999995,
							26.46905200000009
						],
						[
							-80.12250199999995,
							26.468815000000063
						],
						[
							-80.12474999999995,
							26.468817000000058
						],
						[
							-80.1247689999999,
							26.467471000000046
						],
						[
							-80.1247699999999,
							26.46737900000005
						],
						[
							-80.12381299999993,
							26.467389000000082
						],
						[
							-80.12381299999993,
							26.466950000000054
						],
						[
							-80.12381299999993,
							26.466582000000074
						],
						[
							-80.12687799999992,
							26.466582000000074
						],
						[
							-80.12687699999992,
							26.465359000000035
						],
						[
							-80.12265999999994,
							26.465354000000048
						],
						[
							-80.12266299999993,
							26.464838000000043
						],
						[
							-80.12265999999994,
							26.464559000000065
						],
						[
							-80.12265799999994,
							26.464443000000074
						],
						[
							-80.12264299999994,
							26.46365700000007
						],
						[
							-80.12556499999994,
							26.463632000000075
						],
						[
							-80.1255109999999,
							26.461501000000055
						],
						[
							-80.12260199999992,
							26.46155200000004
						],
						[
							-80.12258199999991,
							26.460475000000088
						],
						[
							-80.12253099999992,
							26.457841000000087
						],
						[
							-80.12545999999993,
							26.457824000000073
						],
						[
							-80.12648299999995,
							26.45781800000009
						],
						[
							-80.12761599999993,
							26.45781100000005
						],
						[
							-80.12783499999995,
							26.457810000000052
						],
						[
							-80.13074399999994,
							26.457793000000038
						],
						[
							-80.13091799999995,
							26.45779200000004
						],
						[
							-80.1309149999999,
							26.45906700000006
						],
						[
							-80.1309139999999,
							26.45968000000005
						],
						[
							-80.13091099999991,
							26.461357000000078
						],
						[
							-80.13090699999992,
							26.463265000000035
						],
						[
							-80.13090399999993,
							26.465223000000037
						],
						[
							-80.13089599999995,
							26.46895600000005
						],
						[
							-80.13076599999994,
							26.46895100000006
						],
						[
							-80.13072399999993,
							26.471042000000068
						],
						[
							-80.13067299999994,
							26.474000000000046
						],
						[
							-80.13058699999993,
							26.475866000000053
						],
						[
							-80.13027099999994,
							26.47581500000007
						],
						[
							-80.13005299999992,
							26.475794000000064
						],
						[
							-80.1298339999999,
							26.475787000000082
						],
						[
							-80.12961499999994,
							26.475794000000064
						],
						[
							-80.12939799999992,
							26.475816000000066
						],
						[
							-80.1288199999999,
							26.47591200000005
						],
						[
							-80.12846799999994,
							26.47596100000004
						],
						[
							-80.12827599999991,
							26.475983000000042
						],
						[
							-80.1278089999999,
							26.476024000000052
						],
						[
							-80.12743999999992,
							26.476042000000067
						],
						[
							-80.12646899999993,
							26.476056000000085
						],
						[
							-80.12490699999995,
							26.476071000000047
						],
						[
							-80.12254299999995,
							26.476095000000043
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Delray Beach",
				"Name": "High Point",
				"RegionID": "124713"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.57905791799993,
					30.286659954000076,
					-81.5583987899999,
					30.316470949000067
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.55881190799994,
							30.307168010000055
						],
						[
							-81.55881190799994,
							30.305641010000045
						],
						[
							-81.55881190799994,
							30.305556010000092
						],
						[
							-81.55879190799993,
							30.303810011000056
						],
						[
							-81.55877190799993,
							30.302256011000058
						],
						[
							-81.5587629069999,
							30.302000011000075
						],
						[
							-81.5587629069999,
							30.30197601000009
						],
						[
							-81.5587629069999,
							30.301612010000042
						],
						[
							-81.55875290799992,
							30.30013401000008
						],
						[
							-81.55872890799992,
							30.298340010000064
						],
						[
							-81.55871690799995,
							30.297450010000038
						],
						[
							-81.55870490699994,
							30.296554010000083
						],
						[
							-81.55869390799995,
							30.29566301000006
						],
						[
							-81.55868790799991,
							30.295228011000066
						],
						[
							-81.55871402899993,
							30.294677872000083
						],
						[
							-81.55855190799991,
							30.294703011000085
						],
						[
							-81.5583987899999,
							30.294736137000086
						],
						[
							-81.5584269069999,
							30.29450401000008
						],
						[
							-81.55842690799994,
							30.294463010000072
						],
						[
							-81.55843690799992,
							30.294364011000084
						],
						[
							-81.5584939069999,
							30.29384301000005
						],
						[
							-81.55861890699994,
							30.29292601100008
						],
						[
							-81.55876990799993,
							30.292018010000046
						],
						[
							-81.55892790799994,
							30.291113010000064
						],
						[
							-81.55893990699991,
							30.29089901000009
						],
						[
							-81.55894890799993,
							30.290692010000047
						],
						[
							-81.55895290799992,
							30.290502011000054
						],
						[
							-81.55895290799992,
							30.290207010000074
						],
						[
							-81.55894890699994,
							30.28929901000004
						],
						[
							-81.55888390799993,
							30.288639010000058
						],
						[
							-81.5588739079999,
							30.288273010000065
						],
						[
							-81.55885790699995,
							30.287658011000076
						],
						[
							-81.55885390799995,
							30.287268011000034
						],
						[
							-81.5588419099999,
							30.286659954000076
						],
						[
							-81.5588999069999,
							30.28666101100003
						],
						[
							-81.5590349069999,
							30.286663010000044
						],
						[
							-81.5591699069999,
							30.286666010000094
						],
						[
							-81.55928690799993,
							30.286669064000076
						],
						[
							-81.55935090999992,
							30.28666901200006
						],
						[
							-81.5594269099999,
							30.286669013000047
						],
						[
							-81.55951290999991,
							30.28668101200009
						],
						[
							-81.56010090899991,
							30.28671001200007
						],
						[
							-81.56025390999991,
							30.286721012000047
						],
						[
							-81.5606179099999,
							30.286746012000037
						],
						[
							-81.56164190999993,
							30.28681701200009
						],
						[
							-81.56223690899992,
							30.28687501200005
						],
						[
							-81.56392290999992,
							30.287023012000077
						],
						[
							-81.56410090999992,
							30.287039013000086
						],
						[
							-81.56556490999992,
							30.287193013000035
						],
						[
							-81.56605890899993,
							30.28723601300004
						],
						[
							-81.56695490999995,
							30.287324012000056
						],
						[
							-81.56740390999994,
							30.28737101200005
						],
						[
							-81.56743390999992,
							30.287371013000037
						],
						[
							-81.56834191999991,
							30.287464096000065
						],
						[
							-81.56853588499992,
							30.287392957000066
						],
						[
							-81.56852990699991,
							30.287482011000066
						],
						[
							-81.56851790799993,
							30.28760900900005
						],
						[
							-81.56853290799995,
							30.288049010000066
						],
						[
							-81.56855390899995,
							30.288170010000048
						],
						[
							-81.56883290799993,
							30.288901010000075
						],
						[
							-81.56912890799993,
							30.28962301100006
						],
						[
							-81.5692989069999,
							30.290092010000084
						],
						[
							-81.56935890799991,
							30.290468011000087
						],
						[
							-81.56945790799995,
							30.29089001000006
						],
						[
							-81.56973207599992,
							30.291731095000042
						],
						[
							-81.5663987449999,
							30.292637926000054
						],
						[
							-81.56695190799991,
							30.294412010000084
						],
						[
							-81.56889590799994,
							30.298623011000075
						],
						[
							-81.57195090699992,
							30.30387301000008
						],
						[
							-81.5728759079999,
							30.305463010000043
						],
						[
							-81.57323485099994,
							30.30603207000007
						],
						[
							-81.57410090799993,
							30.306523011000085
						],
						[
							-81.57421090799994,
							30.30658301100004
						],
						[
							-81.57427540799995,
							30.306622011000062
						],
						[
							-81.57431990799995,
							30.306647011000052
						],
						[
							-81.57453390699993,
							30.30676901000004
						],
						[
							-81.57496898999995,
							30.30701515600003
						],
						[
							-81.57498190799993,
							30.306628010000058
						],
						[
							-81.57498890799991,
							30.306400010000065
						],
						[
							-81.57516377899992,
							30.305277871000044
						],
						[
							-81.57664399299995,
							30.305158172000066
						],
						[
							-81.57734090899993,
							30.30423483000004
						],
						[
							-81.5781819849999,
							30.30538197700008
						],
						[
							-81.57841090799991,
							30.306951010000034
						],
						[
							-81.57842390499991,
							30.307149013000068
						],
						[
							-81.57818273399994,
							30.308476075000044
						],
						[
							-81.57867806899992,
							30.308869918000084
						],
						[
							-81.57869390699994,
							30.30900201100008
						],
						[
							-81.5787289079999,
							30.309533010000052
						],
						[
							-81.57878090699995,
							30.310064010000072
						],
						[
							-81.57879290699992,
							30.310253011000043
						],
						[
							-81.5787949079999,
							30.310356010000078
						],
						[
							-81.57881890699993,
							30.310593010000048
						],
						[
							-81.57905791799993,
							30.313418099000046
						],
						[
							-81.57817790799993,
							30.31346201200006
						],
						[
							-81.5775469109999,
							30.31349801200008
						],
						[
							-81.57568791099993,
							30.313617012000066
						],
						[
							-81.57529890799992,
							30.313639011000078
						],
						[
							-81.57438990899993,
							30.313693012000044
						],
						[
							-81.57245291099991,
							30.313808012000038
						],
						[
							-81.57237990799992,
							30.31381201200009
						],
						[
							-81.5723069089999,
							30.31381601200008
						],
						[
							-81.57141090899995,
							30.31386801200006
						],
						[
							-81.56904690999994,
							30.31400401200006
						],
						[
							-81.56815190999993,
							30.31406001200008
						],
						[
							-81.56569390899995,
							30.314202012000063
						],
						[
							-81.56439090899994,
							30.31427501300004
						],
						[
							-81.56369690899993,
							30.314309013000074
						],
						[
							-81.56330190799991,
							30.314349013000083
						],
						[
							-81.5631499079999,
							30.314360012000066
						],
						[
							-81.56290290899994,
							30.31439501300008
						],
						[
							-81.5627119099999,
							30.314443012000083
						],
						[
							-81.5625399079999,
							30.314491013000065
						],
						[
							-81.56240890899994,
							30.31453901200007
						],
						[
							-81.56214690899992,
							30.314639013000093
						],
						[
							-81.56198790999991,
							30.314719013000058
						],
						[
							-81.56191490899994,
							30.31475601300008
						],
						[
							-81.56163890999994,
							30.314923012000065
						],
						[
							-81.56060490899995,
							30.315531012000065
						],
						[
							-81.56000290899993,
							30.315862013000075
						],
						[
							-81.55982491099991,
							30.315955013000067
						],
						[
							-81.55966290799995,
							30.316057013000087
						],
						[
							-81.55946190799995,
							30.316171013000087
						],
						[
							-81.55920391099994,
							30.316311013000075
						],
						[
							-81.55903091099992,
							30.316409012000065
						],
						[
							-81.55892185199991,
							30.316470949000067
						],
						[
							-81.55890790799992,
							30.31564401000008
						],
						[
							-81.55889890699991,
							30.315101010000035
						],
						[
							-81.55889190799991,
							30.314702011000065
						],
						[
							-81.55887990699995,
							30.312886010000057
						],
						[
							-81.55885990699994,
							30.311411011000075
						],
						[
							-81.5588499079999,
							30.311072011000082
						],
						[
							-81.5588499079999,
							30.310733010000035
						],
						[
							-81.55883090799995,
							30.30925401000008
						],
						[
							-81.55883090799995,
							30.30854801100008
						],
						[
							-81.55882090699993,
							30.307730011000046
						],
						[
							-81.55881190799994,
							30.30745801000006
						],
						[
							-81.55881190799994,
							30.307168010000055
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Holiday Hill",
				"RegionID": "124750"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.45818887399997,
					28.347885765000058,
					-81.403993,
					28.376321236000024
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.403993,
							28.347885765000058
						],
						[
							-81.415484,
							28.347913000000002
						],
						[
							-81.41624199799998,
							28.347914669000037
						],
						[
							-81.41950378499996,
							28.347922295000046
						],
						[
							-81.42197100000001,
							28.347928
						],
						[
							-81.42224921999997,
							28.347928652000064
						],
						[
							-81.422398,
							28.347928958000068
						],
						[
							-81.42249799899997,
							28.347929171000033
						],
						[
							-81.424184,
							28.347933
						],
						[
							-81.426371,
							28.347938
						],
						[
							-81.436774,
							28.347962
						],
						[
							-81.438667,
							28.34796590600007
						],
						[
							-81.43953099699996,
							28.347967913000048
						],
						[
							-81.445398105,
							28.347981960000027
						],
						[
							-81.44603799599997,
							28.347983492000026
						],
						[
							-81.44728799799998,
							28.347986741000057
						],
						[
							-81.44729300399996,
							28.34798677400005
						],
						[
							-81.447884,
							28.347997000000003
						],
						[
							-81.45234584499997,
							28.34797807900003
						],
						[
							-81.45764322899998,
							28.347955616000036
						],
						[
							-81.45818887399997,
							28.347953302000064
						],
						[
							-81.45818887399997,
							28.371376347000023
						],
						[
							-81.45818887399997,
							28.37184547000004
						],
						[
							-81.45297570599996,
							28.37184547000004
						],
						[
							-81.44722431699995,
							28.37184547000004
						],
						[
							-81.44648192599999,
							28.369732509000073
						],
						[
							-81.44602506899997,
							28.36636319200005
						],
						[
							-81.444942,
							28.364715
						],
						[
							-81.443893,
							28.365704
						],
						[
							-81.440999,
							28.367151
						],
						[
							-81.43628926599996,
							28.371252984000023
						],
						[
							-81.43653910999996,
							28.372216666000043
						],
						[
							-81.43578957999995,
							28.373180348000062
						],
						[
							-81.43739571599997,
							28.373858494000046
						],
						[
							-81.43803817,
							28.374822176000066
						],
						[
							-81.43746709999994,
							28.376321236000024
						],
						[
							-81.42833278299997,
							28.376321236000024
						],
						[
							-81.42209727399997,
							28.376321236000024
						],
						[
							-81.404385,
							28.376321236000024
						],
						[
							-81.404385,
							28.37193
						],
						[
							-81.404365,
							28.370643
						],
						[
							-81.404348,
							28.369562
						],
						[
							-81.404249,
							28.363068
						],
						[
							-81.404248,
							28.362993
						],
						[
							-81.404202,
							28.359931
						],
						[
							-81.404145,
							28.356124
						],
						[
							-81.404093,
							28.352586
						],
						[
							-81.403993,
							28.347885765000058
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Hunters Creek",
				"RegionID": "124797"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.43743904299993,
					30.25224200000008,
					-81.42096628299993,
					30.288143200000036
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.42111099999994,
							30.28795800000006
						],
						[
							-81.42096628299993,
							30.28638370500005
						],
						[
							-81.42104555599991,
							30.286439212000065
						],
						[
							-81.42123977799992,
							30.285603615000074
						],
						[
							-81.42137625999993,
							30.283305680000066
						],
						[
							-81.42138095599995,
							30.28323874500006
						],
						[
							-81.42139183799992,
							30.283172534000073
						],
						[
							-81.42140881199992,
							30.283107618000088
						],
						[
							-81.42143173199992,
							30.28304455400007
						],
						[
							-81.42146040099995,
							30.282983888000047
						],
						[
							-81.42144240399995,
							30.282920030000074
						],
						[
							-81.42142940399992,
							30.282854970000077
						],
						[
							-81.42142147899995,
							30.28278909800008
						],
						[
							-81.42141867799995,
							30.282722811000045
						],
						[
							-81.4214210159999,
							30.28265650600008
						],
						[
							-81.42142848099991,
							30.28259058100008
						],
						[
							-81.42147115299991,
							30.282303929000076
						],
						[
							-81.42179952399994,
							30.278948234000044
						],
						[
							-81.42181671199995,
							30.27854021800005
						],
						[
							-81.42157511099992,
							30.277396942000053
						],
						[
							-81.42156934099995,
							30.27736716600009
						],
						[
							-81.42155567799995,
							30.27721100000008
						],
						[
							-81.42156934099995,
							30.277054835000058
						],
						[
							-81.42160991399993,
							30.27690341400006
						],
						[
							-81.42167616499995,
							30.276761339000075
						],
						[
							-81.42176607999994,
							30.276632927000037
						],
						[
							-81.42187692699991,
							30.276522080000067
						],
						[
							-81.42200533899995,
							30.27643216500007
						],
						[
							-81.42207276699992,
							30.27639695000005
						],
						[
							-81.4222354929999,
							30.276320543000054
						],
						[
							-81.42218633899995,
							30.27629483500004
						],
						[
							-81.42205792699991,
							30.276204920000055
						],
						[
							-81.42194707899995,
							30.276094073000085
						],
						[
							-81.4218571639999,
							30.27596566100004
						],
						[
							-81.42179091299994,
							30.27582358600006
						],
						[
							-81.4217503399999,
							30.275672165000064
						],
						[
							-81.42174080599995,
							30.27560207500005
						],
						[
							-81.42172580599994,
							30.27544607500005
						],
						[
							-81.4217217179999,
							30.275368549000063
						],
						[
							-81.42172433199994,
							30.275290960000063
						],
						[
							-81.42173362699992,
							30.275213885000085
						],
						[
							-81.42174953499995,
							30.27513789900007
						],
						[
							-81.4217719369999,
							30.275063568000064
						],
						[
							-81.4221571409999,
							30.273960235000065
						],
						[
							-81.4224724529999,
							30.270885701000054
						],
						[
							-81.42241192699993,
							30.270841920000063
						],
						[
							-81.42230107899992,
							30.270731073000036
						],
						[
							-81.42221116399992,
							30.270602661000055
						],
						[
							-81.4221449129999,
							30.27046058600007
						],
						[
							-81.42210433999992,
							30.27030916500007
						],
						[
							-81.4220906779999,
							30.27015300000005
						],
						[
							-81.42210241299995,
							30.270008191000045
						],
						[
							-81.4224743769999,
							30.267728513000066
						],
						[
							-81.42251591399992,
							30.267571414000088
						],
						[
							-81.42258216399995,
							30.267429339000042
						],
						[
							-81.42267207899995,
							30.267300927000065
						],
						[
							-81.4227829269999,
							30.267190079000045
						],
						[
							-81.42291133899994,
							30.267100164000055
						],
						[
							-81.42305341399992,
							30.26703391400008
						],
						[
							-81.42314209499995,
							30.267006727000084
						],
						[
							-81.4259711759999,
							30.26629674500009
						],
						[
							-81.42692733899992,
							30.265961367000045
						],
						[
							-81.42700283199991,
							30.265940036000078
						],
						[
							-81.42697091399992,
							30.265871587000053
						],
						[
							-81.42694403399992,
							30.265784124000053
						],
						[
							-81.42686828099994,
							30.265484051000048
						],
						[
							-81.42595804599995,
							30.264450320000034
						],
						[
							-81.42594407999991,
							30.264434073000075
						],
						[
							-81.42585416499992,
							30.264305661000037
						],
						[
							-81.4257879139999,
							30.264163586000056
						],
						[
							-81.42574734099993,
							30.264012166000043
						],
						[
							-81.42573367799992,
							30.26385600000009
						],
						[
							-81.42574734099993,
							30.263699834000075
						],
						[
							-81.4257879139999,
							30.26354841400007
						],
						[
							-81.4258449649999,
							30.263422664000075
						],
						[
							-81.4263629639999,
							30.262480664000066
						],
						[
							-81.42642845699993,
							30.262378544000057
						],
						[
							-81.42659445699991,
							30.26215454500004
						],
						[
							-81.42664472599995,
							30.262092649000067
						],
						[
							-81.42670027999992,
							30.26203544900005
						],
						[
							-81.42676068299994,
							30.261983394000083
						],
						[
							-81.4274910659999,
							30.26140835700005
						],
						[
							-81.42803065399994,
							30.260558506000056
						],
						[
							-81.42806423299993,
							30.260355669000035
						],
						[
							-81.42808287699995,
							30.259470071000067
						],
						[
							-81.4280963409999,
							30.25933283400008
						],
						[
							-81.42813318599991,
							30.25919185400005
						],
						[
							-81.42854294299993,
							30.258021364000054
						],
						[
							-81.4284616079999,
							30.257776730000042
						],
						[
							-81.4284378179999,
							30.25769132200009
						],
						[
							-81.42841181699994,
							30.257576322000034
						],
						[
							-81.42840333999993,
							30.257534166000084
						],
						[
							-81.42838967799992,
							30.25737800000007
						],
						[
							-81.42838967799992,
							30.25730400000009
						],
						[
							-81.4284038099999,
							30.257145216000083
						],
						[
							-81.42845510099995,
							30.25686402100007
						],
						[
							-81.42844539099991,
							30.256877062000058
						],
						[
							-81.43009499999994,
							30.252243000000078
						],
						[
							-81.43017199999991,
							30.252243000000078
						],
						[
							-81.43018599999994,
							30.252243000000078
						],
						[
							-81.4308069999999,
							30.25224200000008
						],
						[
							-81.43087499999992,
							30.252243981000046
						],
						[
							-81.43090999999993,
							30.252245000000073
						],
						[
							-81.43101299999996,
							30.252249000000063
						],
						[
							-81.43229999999994,
							30.252286000000083
						],
						[
							-81.43230199999994,
							30.252286000000083
						],
						[
							-81.43230300199991,
							30.252286000000083
						],
						[
							-81.43230399999993,
							30.252286000000083
						],
						[
							-81.43230599999993,
							30.252286000000083
						],
						[
							-81.43339772799993,
							30.252317597000058
						],
						[
							-81.43430999999993,
							30.25234400000005
						],
						[
							-81.43431249999992,
							30.25234400000005
						],
						[
							-81.43431499999991,
							30.25234400000005
						],
						[
							-81.4369289999999,
							30.252335000000073
						],
						[
							-81.4369289999999,
							30.252324994000052
						],
						[
							-81.43694250599992,
							30.252343219000068
						],
						[
							-81.43699490499995,
							30.253340009000055
						],
						[
							-81.43697990499993,
							30.254482009000075
						],
						[
							-81.43700190599994,
							30.25534400800007
						],
						[
							-81.4370119049999,
							30.255514008000034
						],
						[
							-81.43703890499995,
							30.25642500800007
						],
						[
							-81.43703590599995,
							30.257157009000085
						],
						[
							-81.43704589899994,
							30.257339986000094
						],
						[
							-81.4361777279999,
							30.26658107600008
						],
						[
							-81.43631090699995,
							30.26671201100004
						],
						[
							-81.43663690799993,
							30.26704901000005
						],
						[
							-81.43726608899993,
							30.267696922000088
						],
						[
							-81.43728490799992,
							30.26830201100006
						],
						[
							-81.43732490799994,
							30.27039001100007
						],
						[
							-81.43734690799994,
							30.27101701000004
						],
						[
							-81.43735490699993,
							30.271795010000062
						],
						[
							-81.43740090799992,
							30.273729011000057
						],
						[
							-81.43741590799993,
							30.27406101100007
						],
						[
							-81.43743904299993,
							30.275141142000052
						],
						[
							-81.43647790699993,
							30.27515401000005
						],
						[
							-81.43555490799992,
							30.275169011000063
						],
						[
							-81.43462390699995,
							30.275177010000053
						],
						[
							-81.43371577699992,
							30.27518788100008
						],
						[
							-81.43373090799992,
							30.27595301000008
						],
						[
							-81.43377690799993,
							30.27842501100008
						],
						[
							-81.43380190699992,
							30.279423011000066
						],
						[
							-81.43382990799995,
							30.280684010000073
						],
						[
							-81.43384590799991,
							30.281569011000045
						],
						[
							-81.43387590799995,
							30.282776011000067
						],
						[
							-81.43397490799993,
							30.287878010000043
						],
						[
							-81.43397690799992,
							30.288022065000064
						],
						[
							-81.43270790699995,
							30.288038010000033
						],
						[
							-81.43191290699991,
							30.288050010000063
						],
						[
							-81.43124590699995,
							30.288061010000035
						],
						[
							-81.42990590799991,
							30.288072010000068
						],
						[
							-81.42833690799995,
							30.28808801000008
						],
						[
							-81.42688190799993,
							30.28810401100009
						],
						[
							-81.42161299999992,
							30.288140000000055
						],
						[
							-81.4211445389999,
							30.288143200000036
						],
						[
							-81.42112299999991,
							30.288074000000055
						],
						[
							-81.42111099999994,
							30.28795800000006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Isle of Palms",
				"RegionID": "124847"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.12758181899994,
					26.24594416700006,
					-80.11356790399992,
					26.275158358000056
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.11791329199991,
							26.260494892000054
						],
						[
							-80.12196863299994,
							26.246128104000036
						],
						[
							-80.12273519199994,
							26.246029193000084
						],
						[
							-80.12706378199995,
							26.24594416700006
						],
						[
							-80.12715955099992,
							26.248365685000067
						],
						[
							-80.12721090399992,
							26.24966416400008
						],
						[
							-80.12721090399992,
							26.25114782500009
						],
						[
							-80.12755709099991,
							26.251963839000044
						],
						[
							-80.12758181899994,
							26.255722448000085
						],
						[
							-80.12726035899993,
							26.256736283000066
						],
						[
							-80.12738399799991,
							26.260643258000073
						],
						[
							-80.12315556199991,
							26.260717441000054
						],
						[
							-80.12320501799991,
							26.26566298000006
						],
						[
							-80.12285882999993,
							26.266083350000088
						],
						[
							-80.12305665199995,
							26.271597626000073
						],
						[
							-80.12530894499992,
							26.271553312000037
						],
						[
							-80.1250843219999,
							26.273056559000054
						],
						[
							-80.1248865259999,
							26.274957679000067
						],
						[
							-80.12423982999991,
							26.274957679000067
						],
						[
							-80.1241678909999,
							26.274957679000067
						],
						[
							-80.12366789099991,
							26.275057679000042
						],
						[
							-80.12359406099995,
							26.275057679000042
						],
						[
							-80.12283982999992,
							26.275057679000042
						],
						[
							-80.12276789099992,
							26.275057679000042
						],
						[
							-80.12269406099995,
							26.275057679000042
						],
						[
							-80.12263982999991,
							26.275057679000042
						],
						[
							-80.1225678909999,
							26.275057679000042
						],
						[
							-80.12249406099994,
							26.275057679000042
						],
						[
							-80.12193982999992,
							26.275057679000042
						],
						[
							-80.12186789099991,
							26.275057679000042
						],
						[
							-80.12179406099995,
							26.275057679000042
						],
						[
							-80.12043982999995,
							26.275057679000042
						],
						[
							-80.12036789099994,
							26.275057679000042
						],
						[
							-80.12029406099992,
							26.275057679000042
						],
						[
							-80.11983982999993,
							26.275057679000042
						],
						[
							-80.11976789099992,
							26.275057679000042
						],
						[
							-80.1196940609999,
							26.275057679000042
						],
						[
							-80.1170398299999,
							26.275057679000042
						],
						[
							-80.11696789099994,
							26.275057679000042
						],
						[
							-80.1139678909999,
							26.275157679000074
						],
						[
							-80.11389406099994,
							26.275157679000074
						],
						[
							-80.11373982999993,
							26.275157679000074
						],
						[
							-80.11366789099992,
							26.275157679000074
						],
						[
							-80.1136398299999,
							26.275157679000074
						],
						[
							-80.11359406199995,
							26.275158111000053
						],
						[
							-80.11356790399992,
							26.275158358000056
						],
						[
							-80.11791329199991,
							26.260494892000054
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Pompano Beach",
				"Name": "Kendall Green",
				"RegionID": "124914"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.7309330409999,
					30.31728900400009,
					-81.69667082399991,
					30.333038067000075
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.69674990699991,
							30.328592009000094
						],
						[
							-81.69675390499992,
							30.327560008000034
						],
						[
							-81.69675690699995,
							30.326753008000082
						],
						[
							-81.69676190299992,
							30.326654007000062
						],
						[
							-81.69674690699992,
							30.32654200800005
						],
						[
							-81.69673190599991,
							30.32600400900009
						],
						[
							-81.69672390699992,
							30.325504008000053
						],
						[
							-81.69671590699994,
							30.325312009000076
						],
						[
							-81.69671590699994,
							30.32500100900006
						],
						[
							-81.6966929059999,
							30.324203008000044
						],
						[
							-81.69668590599991,
							30.32375300800004
						],
						[
							-81.69667090699994,
							30.323448008000074
						],
						[
							-81.69667082399991,
							30.32325398900008
						],
						[
							-81.69702098599993,
							30.322527027000035
						],
						[
							-81.69701290699993,
							30.32233200800005
						],
						[
							-81.69700585299995,
							30.321875007000077
						],
						[
							-81.69745090499993,
							30.321870009000065
						],
						[
							-81.69756390599991,
							30.321870009000065
						],
						[
							-81.69768790599994,
							30.321865007000042
						],
						[
							-81.69800390599994,
							30.321819008000038
						],
						[
							-81.69814490599992,
							30.321793009000093
						],
						[
							-81.69825790599992,
							30.321783008000068
						],
						[
							-81.69864890599992,
							30.321724007000057
						],
						[
							-81.69893490499993,
							30.321681009000088
						],
						[
							-81.6992109059999,
							30.321640009000077
						],
						[
							-81.69930290499991,
							30.321624008000075
						],
						[
							-81.69937890499995,
							30.321611008000048
						],
						[
							-81.70005590499994,
							30.321491008000063
						],
						[
							-81.70016690599994,
							30.32147100800006
						],
						[
							-81.70055390499994,
							30.321400009000058
						],
						[
							-81.70079690499995,
							30.32135300800007
						],
						[
							-81.7009049049999,
							30.321324009000083
						],
						[
							-81.70115990499994,
							30.321269009000048
						],
						[
							-81.70125190499994,
							30.32125100800005
						],
						[
							-81.70181890499993,
							30.321122009000078
						],
						[
							-81.70234990499995,
							30.32104900900004
						],
						[
							-81.70248490499995,
							30.32104300800006
						],
						[
							-81.70341290599993,
							30.321000008000055
						],
						[
							-81.70441290499991,
							30.32100200800005
						],
						[
							-81.70475590599995,
							30.32099200900007
						],
						[
							-81.70513290499993,
							30.320995008000068
						],
						[
							-81.70544390599993,
							30.320995008000068
						],
						[
							-81.70553990599991,
							30.320993009000066
						],
						[
							-81.7065539059999,
							30.320988008000086
						],
						[
							-81.70705590599994,
							30.320974009000054
						],
						[
							-81.7076799059999,
							30.32096300800004
						],
						[
							-81.70811990599992,
							30.320959008000045
						],
						[
							-81.7091629059999,
							30.32094900800007
						],
						[
							-81.7097719059999,
							30.32093500900004
						],
						[
							-81.70987790499993,
							30.320932009000046
						],
						[
							-81.71089190499993,
							30.320943008000086
						],
						[
							-81.7115559049999,
							30.32094900800007
						],
						[
							-81.71187790599993,
							30.320948008000073
						],
						[
							-81.71314990499992,
							30.320927008000073
						],
						[
							-81.71381403599992,
							30.320927138000062
						],
						[
							-81.71381390599993,
							30.32084500800005
						],
						[
							-81.71381377299991,
							30.320756878000054
						],
						[
							-81.71411190499992,
							30.320748008000066
						],
						[
							-81.71471390499994,
							30.32074600800007
						],
						[
							-81.71595004199992,
							30.320735954000046
						],
						[
							-81.71577177199994,
							30.320906062000063
						],
						[
							-81.71611190599992,
							30.320895009000086
						],
						[
							-81.71622590599992,
							30.320895009000086
						],
						[
							-81.71655990599993,
							30.32089000800005
						],
						[
							-81.7174249059999,
							30.32088400800006
						],
						[
							-81.71783090499991,
							30.320871008000044
						],
						[
							-81.71802990499992,
							30.320864008000058
						],
						[
							-81.7183109049999,
							30.320864008000058
						],
						[
							-81.72007790499993,
							30.320858008000073
						],
						[
							-81.7214359059999,
							30.32086800800005
						],
						[
							-81.72180190599995,
							30.320847008000044
						],
						[
							-81.72222090499992,
							30.320784008000093
						],
						[
							-81.72258506499992,
							30.32070610400007
						],
						[
							-81.72256273599993,
							30.32062692400007
						],
						[
							-81.72399890499992,
							30.32003700900009
						],
						[
							-81.72427698699994,
							30.319902850000062
						],
						[
							-81.72428982999992,
							30.319979164000078
						],
						[
							-81.7245389059999,
							30.319847009000057
						],
						[
							-81.72500590599992,
							30.31959500900007
						],
						[
							-81.72573108199992,
							30.319221046000052
						],
						[
							-81.72568272699993,
							30.319156971000044
						],
						[
							-81.72684790599993,
							30.318493009000065
						],
						[
							-81.72760790599995,
							30.31813200900007
						],
						[
							-81.7283949049999,
							30.317811009000085
						],
						[
							-81.72888190499992,
							30.317680008000085
						],
						[
							-81.7290449059999,
							30.31761582200005
						],
						[
							-81.72910889299993,
							30.317640184000087
						],
						[
							-81.73010990499995,
							30.317374009000048
						],
						[
							-81.7307319969999,
							30.31728900400009
						],
						[
							-81.7307358509999,
							30.317352010000036
						],
						[
							-81.73073890699993,
							30.31768901100008
						],
						[
							-81.73073390899992,
							30.318043010000054
						],
						[
							-81.73075890699994,
							30.31858301100004
						],
						[
							-81.7307659089999,
							30.319334010000038
						],
						[
							-81.73078190699994,
							30.31963501100006
						],
						[
							-81.73078890699992,
							30.320076010000037
						],
						[
							-81.73080390699994,
							30.32082201100008
						],
						[
							-81.73082690699994,
							30.321554010000057
						],
						[
							-81.7308629069999,
							30.322770011000046
						],
						[
							-81.73086490999992,
							30.32280301000009
						],
						[
							-81.7308909059999,
							30.32292201000007
						],
						[
							-81.7309109059999,
							30.323105010000063
						],
						[
							-81.73091890899991,
							30.323702010000087
						],
						[
							-81.73091890899991,
							30.324369010000055
						],
						[
							-81.73090990799994,
							30.324691010000034
						],
						[
							-81.73089590699993,
							30.324764011000067
						],
						[
							-81.73087072599992,
							30.324838028000045
						],
						[
							-81.73090390499993,
							30.324895010000034
						],
						[
							-81.73091095899991,
							30.324917001000074
						],
						[
							-81.7309330409999,
							30.32521413900008
						],
						[
							-81.7308647719999,
							30.325213889000057
						],
						[
							-81.73092390599993,
							30.325689010000076
						],
						[
							-81.73092903799994,
							30.326457143000088
						],
						[
							-81.73077577599992,
							30.326450874000045
						],
						[
							-81.73076990899995,
							30.326967011000075
						],
						[
							-81.7307759059999,
							30.327488010000085
						],
						[
							-81.73077696199994,
							30.32759402700009
						],
						[
							-81.7287289059999,
							30.32794800800008
						],
						[
							-81.72851290599993,
							30.327981005000083
						],
						[
							-81.72842190699993,
							30.327967011000055
						],
						[
							-81.72669190499994,
							30.328264008000076
						],
						[
							-81.72381590599993,
							30.32872000900005
						],
						[
							-81.72280890499991,
							30.32888800800004
						],
						[
							-81.72245790499994,
							30.32893800900007
						],
						[
							-81.72090090499995,
							30.32917400900004
						],
						[
							-81.71922290499992,
							30.32946800800005
						],
						[
							-81.71890990499992,
							30.329508008000058
						],
						[
							-81.71820790499993,
							30.329624008000053
						],
						[
							-81.71749890599995,
							30.329746008000086
						],
						[
							-81.7164379049999,
							30.329908009000068
						],
						[
							-81.71402690499991,
							30.330301008000053
						],
						[
							-81.71295890499994,
							30.330471008000075
						],
						[
							-81.71242490599992,
							30.330566008000062
						],
						[
							-81.71197490599991,
							30.330633009000053
						],
						[
							-81.71153990599993,
							30.330709009000085
						],
						[
							-81.7109909049999,
							30.330790009000058
						],
						[
							-81.70967890599991,
							30.33100500900008
						],
						[
							-81.70934290499991,
							30.331055008000074
						],
						[
							-81.70838790599993,
							30.331215009000065
						],
						[
							-81.70699490599992,
							30.331455009000077
						],
						[
							-81.70653190599995,
							30.331532009000057
						],
						[
							-81.7055468769999,
							30.331700959000045
						],
						[
							-81.70529890599995,
							30.33174400900009
						],
						[
							-81.70480890599993,
							30.331817008000087
						],
						[
							-81.7042309059999,
							30.33191400800007
						],
						[
							-81.70318590599993,
							30.332087008000084
						],
						[
							-81.70179690599991,
							30.332319008000066
						],
						[
							-81.70123290499993,
							30.33241300900005
						],
						[
							-81.70104990599992,
							30.33244500900008
						],
						[
							-81.7005229049999,
							30.33253300800004
						],
						[
							-81.69907390599991,
							30.332760009000086
						],
						[
							-81.69860790599995,
							30.332846008000047
						],
						[
							-81.69801290599992,
							30.332941008000034
						],
						[
							-81.69740288499992,
							30.333038067000075
						],
						[
							-81.69728890599993,
							30.332790009000064
						],
						[
							-81.69715090699992,
							30.33253500900008
						],
						[
							-81.69682490799995,
							30.331857008000043
						],
						[
							-81.69677690799995,
							30.331701008000042
						],
						[
							-81.69675390599991,
							30.331547008000086
						],
						[
							-81.69675390499992,
							30.331133008000055
						],
						[
							-81.69674690699992,
							30.33062400800009
						],
						[
							-81.69675290599992,
							30.33006100800009
						],
						[
							-81.69674990699991,
							30.329525008000076
						],
						[
							-81.69674990699991,
							30.328592009000094
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Lackawanna",
				"RegionID": "124967"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.4148679999999,
					27.52065200000004,
					-80.35571099999993,
					27.55757200000005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.40226339299994,
							27.557541678000064
						],
						[
							-80.4022589999999,
							27.557533102000036
						],
						[
							-80.4022589999999,
							27.55743300000006
						],
						[
							-80.39837299999994,
							27.557363000000066
						],
						[
							-80.39799499999992,
							27.55736500000006
						],
						[
							-80.39795073099992,
							27.557521954000038
						],
						[
							-80.39793999999995,
							27.55756000000008
						],
						[
							-80.38990948899993,
							27.557503559000054
						],
						[
							-80.38982999899991,
							27.557503284000063
						],
						[
							-80.3895750019999,
							27.557503397000062
						],
						[
							-80.38597489999995,
							27.55751926000005
						],
						[
							-80.38045963499991,
							27.557542523000052
						],
						[
							-80.37631599999992,
							27.55756000000008
						],
						[
							-80.37388707499991,
							27.557330859000047
						],
						[
							-80.36976843299993,
							27.557307104000074
						],
						[
							-80.36895839499994,
							27.557302207000077
						],
						[
							-80.36915599999992,
							27.556876000000045
						],
						[
							-80.36997799999995,
							27.55490400000008
						],
						[
							-80.36997699999995,
							27.553092000000053
						],
						[
							-80.36933299999993,
							27.550778000000037
						],
						[
							-80.36910099999994,
							27.550136000000066
						],
						[
							-80.36894599999994,
							27.549700000000087
						],
						[
							-80.36881699999992,
							27.549563000000035
						],
						[
							-80.36873999999995,
							27.549081000000058
						],
						[
							-80.36840499999994,
							27.548737000000074
						],
						[
							-80.36804499999994,
							27.547522000000072
						],
						[
							-80.36791599999992,
							27.547201000000086
						],
						[
							-80.36742599999991,
							27.54573400000004
						],
						[
							-80.36696299999994,
							27.54442700000004
						],
						[
							-80.36685999999992,
							27.543899000000067
						],
						[
							-80.36667899999992,
							27.543716000000078
						],
						[
							-80.3661899999999,
							27.542730000000063
						],
						[
							-80.36611299999993,
							27.542272000000082
						],
						[
							-80.36603599999995,
							27.542203000000086
						],
						[
							-80.36603599999995,
							27.542042000000038
						],
						[
							-80.3656489999999,
							27.54112500000008
						],
						[
							-80.36562299999991,
							27.540850000000034
						],
						[
							-80.36554599999994,
							27.540804000000037
						],
						[
							-80.36526299999991,
							27.539910000000077
						],
						[
							-80.36425899999995,
							27.537686000000065
						],
						[
							-80.36394999999993,
							27.537205000000085
						],
						[
							-80.36358899999993,
							27.53637900000007
						],
						[
							-80.36271499999992,
							27.53474600000004
						],
						[
							-80.36255899999992,
							27.53445400000004
						],
						[
							-80.36253399999993,
							27.53427000000005
						],
						[
							-80.3617099999999,
							27.532711000000063
						],
						[
							-80.3611689999999,
							27.53172500000005
						],
						[
							-80.36075699999992,
							27.530785000000037
						],
						[
							-80.3606289999999,
							27.530350000000055
						],
						[
							-80.36039699999992,
							27.529937000000075
						],
						[
							-80.35980499999994,
							27.528905000000066
						],
						[
							-80.3597279999999,
							27.52860700000008
						],
						[
							-80.3595729999999,
							27.528447000000085
						],
						[
							-80.35952199999991,
							27.52824000000004
						],
						[
							-80.35841499999994,
							27.526177000000075
						],
						[
							-80.35833699999995,
							27.52565000000004
						],
						[
							-80.3579259999999,
							27.524939000000074
						],
						[
							-80.35743699999995,
							27.524182000000053
						],
						[
							-80.3574109999999,
							27.52402200000006
						],
						[
							-80.35684499999991,
							27.523014000000046
						],
						[
							-80.35571099999993,
							27.52069800000004
						],
						[
							-80.35694699999993,
							27.52065200000004
						],
						[
							-80.35728099999994,
							27.52067500000004
						],
						[
							-80.35856699999994,
							27.52067500000004
						],
						[
							-80.3617559999999,
							27.52078800000004
						],
						[
							-80.37477299999996,
							27.52078300000005
						],
						[
							-80.38043399999992,
							27.520785000000046
						],
						[
							-80.38403499999993,
							27.520786000000044
						],
						[
							-80.38443899999993,
							27.520786000000044
						],
						[
							-80.38660699999991,
							27.52078700000004
						],
						[
							-80.38997599999993,
							27.520834000000036
						],
						[
							-80.3902359999999,
							27.520834000000036
						],
						[
							-80.39059399999991,
							27.520834000000036
						],
						[
							-80.39234199999993,
							27.520834000000036
						],
						[
							-80.39329399999991,
							27.520789000000036
						],
						[
							-80.3983869999999,
							27.520859000000087
						],
						[
							-80.3987219999999,
							27.520826000000056
						],
						[
							-80.39884999999992,
							27.52081300000009
						],
						[
							-80.39998199999991,
							27.520860000000084
						],
						[
							-80.4025279999999,
							27.520906000000082
						],
						[
							-80.40247599999994,
							27.521892000000037
						],
						[
							-80.40250199999991,
							27.522718000000058
						],
						[
							-80.40247599999994,
							27.523634000000072
						],
						[
							-80.40252699999992,
							27.52468900000008
						],
						[
							-80.40635899999995,
							27.52485000000007
						],
						[
							-80.40648799999991,
							27.52494200000007
						],
						[
							-80.40643599999993,
							27.52551500000004
						],
						[
							-80.40640999999994,
							27.526455000000055
						],
						[
							-80.40640999999994,
							27.527304000000072
						],
						[
							-80.40640999999994,
							27.52833600000008
						],
						[
							-80.40640899999994,
							27.529299000000037
						],
						[
							-80.40638299999995,
							27.53017000000006
						],
						[
							-80.4063569999999,
							27.53101900000007
						],
						[
							-80.4063569999999,
							27.531959000000086
						],
						[
							-80.40638199999995,
							27.532899000000043
						],
						[
							-80.40630499999992,
							27.53377000000006
						],
						[
							-80.40630499999992,
							27.53459600000008
						],
						[
							-80.40630499999992,
							27.535697000000084
						],
						[
							-80.40632999999991,
							27.536499000000052
						],
						[
							-80.40630399999992,
							27.537370000000067
						],
						[
							-80.40625199999994,
							27.539274000000034
						],
						[
							-80.40625199999994,
							27.540145000000052
						],
						[
							-80.40622599999995,
							27.541108000000065
						],
						[
							-80.40622599999995,
							27.541980000000084
						],
						[
							-80.4061999999999,
							27.542897000000043
						],
						[
							-80.40654299999994,
							27.54294400000009
						],
						[
							-80.40686799999992,
							27.54298900000009
						],
						[
							-80.40698199999991,
							27.542991000000086
						],
						[
							-80.40936399999993,
							27.543035000000092
						],
						[
							-80.4103409999999,
							27.54308100000009
						],
						[
							-80.41049499999993,
							27.543242000000077
						],
						[
							-80.41049499999993,
							27.54405900000006
						],
						[
							-80.41049499999993,
							27.54484700000006
						],
						[
							-80.4105209999999,
							27.545649000000083
						],
						[
							-80.4105199999999,
							27.54656700000004
						],
						[
							-80.41211499999991,
							27.546705000000088
						],
						[
							-80.4148679999999,
							27.546705000000088
						],
						[
							-80.41476399999993,
							27.550420000000088
						],
						[
							-80.41473799999994,
							27.55129100000005
						],
						[
							-80.41463499999992,
							27.554088000000036
						],
						[
							-80.41463399999992,
							27.554913000000056
						],
						[
							-80.4146859999999,
							27.55583000000007
						],
						[
							-80.4146849999999,
							27.557115000000067
						],
						[
							-80.41465999999991,
							27.557480000000055
						],
						[
							-80.4146561099999,
							27.557534457000088
						],
						[
							-80.4145700009999,
							27.557535741000038
						],
						[
							-80.41332899999992,
							27.557530000000042
						],
						[
							-80.41071899999992,
							27.55757200000005
						],
						[
							-80.40787099999994,
							27.557570000000055
						],
						[
							-80.40627299999994,
							27.557548000000054
						],
						[
							-80.40317199999993,
							27.557547000000056
						],
						[
							-80.40226339299994,
							27.557541678000064
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Saint Lucie",
				"City": "Fort Pierce",
				"Name": "Lakewood Park",
				"RegionID": "125047"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.73250782199995,
					30.35803357000009,
					-81.6988578619999,
					30.378857009000058
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.70613089299991,
							30.37885504500008
						],
						[
							-81.70597790599993,
							30.378849008000092
						],
						[
							-81.70428490599994,
							30.378849008000092
						],
						[
							-81.70311690599993,
							30.378839008000057
						],
						[
							-81.70230090599995,
							30.378828008000085
						],
						[
							-81.70033990499991,
							30.378839008000057
						],
						[
							-81.69916489499991,
							30.37883800800006
						],
						[
							-81.69914190599991,
							30.378401008000083
						],
						[
							-81.6991499049999,
							30.37818500800006
						],
						[
							-81.69914190499992,
							30.37801000800005
						],
						[
							-81.69913490599993,
							30.377535008000052
						],
						[
							-81.69912690599995,
							30.37746800800005
						],
						[
							-81.69911990499992,
							30.37685200900006
						],
						[
							-81.69910890499995,
							30.376734008000085
						],
						[
							-81.6991039049999,
							30.376680009000044
						],
						[
							-81.6991009059999,
							30.37659500900008
						],
						[
							-81.69909690599991,
							30.376499009000046
						],
						[
							-81.69909390599992,
							30.376270008000063
						],
						[
							-81.69907390599991,
							30.375639009000054
						],
						[
							-81.69908090599995,
							30.37533400900008
						],
						[
							-81.69907390599991,
							30.37484900800007
						],
						[
							-81.69905090499992,
							30.374146008000082
						],
						[
							-81.69904290599993,
							30.373539009000073
						],
						[
							-81.69902790599991,
							30.373234009000043
						],
						[
							-81.69902790499992,
							30.372929009000078
						],
						[
							-81.6990129049999,
							30.372623008000065
						],
						[
							-81.69899690599993,
							30.371899009000064
						],
						[
							-81.69898990599995,
							30.37155300800003
						],
						[
							-81.69897490499994,
							30.370708009000055
						],
						[
							-81.69897490499994,
							30.37049900800008
						],
						[
							-81.69895890599992,
							30.370132008000045
						],
						[
							-81.69895890599992,
							30.369883008000045
						],
						[
							-81.69891390499993,
							30.368177008000085
						],
						[
							-81.69889090599992,
							30.36652400800006
						],
						[
							-81.69888290599994,
							30.36610600800009
						],
						[
							-81.6988578619999,
							30.36477293100006
						],
						[
							-81.70354490599993,
							30.36337500900004
						],
						[
							-81.70426890599994,
							30.363169008000057
						],
						[
							-81.70533790499991,
							30.362986008000064
						],
						[
							-81.7076139049999,
							30.362464008000075
						],
						[
							-81.7084659059999,
							30.362247008000054
						],
						[
							-81.71431890499993,
							30.360801008000067
						],
						[
							-81.71439890599993,
							30.36077700900006
						],
						[
							-81.71449690599991,
							30.360759008000063
						],
						[
							-81.7148589059999,
							30.360640009000065
						],
						[
							-81.71496490499993,
							30.360608007000053
						],
						[
							-81.71511790499996,
							30.360533008000065
						],
						[
							-81.71527190599994,
							30.360448007000063
						],
						[
							-81.71540690599994,
							30.360337008000048
						],
						[
							-81.7155179049999,
							30.360247008000048
						],
						[
							-81.7156289049999,
							30.360130008000056
						],
						[
							-81.71575190499993,
							30.35997000900005
						],
						[
							-81.71584990399992,
							30.359811008000065
						],
						[
							-81.71589890599995,
							30.359641009000086
						],
						[
							-81.71594890599994,
							30.359429008000063
						],
						[
							-81.7159669049999,
							30.35925401100008
						],
						[
							-81.71595490499993,
							30.35910000800004
						],
						[
							-81.7159239049999,
							30.35894601000007
						],
						[
							-81.71584390499993,
							30.358749009000064
						],
						[
							-81.71576990499995,
							30.358606009000084
						],
						[
							-81.7156959049999,
							30.358495009000084
						],
						[
							-81.71532738899992,
							30.35803357000009
						],
						[
							-81.71784890599992,
							30.360312007000065
						],
						[
							-81.72646390499995,
							30.36686700800004
						],
						[
							-81.72746290599991,
							30.367826008000065
						],
						[
							-81.72754190499991,
							30.367886008000088
						],
						[
							-81.72869390499994,
							30.368925009000066
						],
						[
							-81.73128690499995,
							30.37165900900004
						],
						[
							-81.73250782199995,
							30.37347088900009
						],
						[
							-81.73218099999991,
							30.373387000000033
						],
						[
							-81.7318800029999,
							30.373216362000054
						],
						[
							-81.73178066399993,
							30.373189269000076
						],
						[
							-81.73163616999994,
							30.373189269000076
						],
						[
							-81.73153683099991,
							30.373225392000055
						],
						[
							-81.7314194299999,
							30.373279578000055
						],
						[
							-81.73131105999994,
							30.373351824000054
						],
						[
							-81.73122075099991,
							30.373415040000054
						],
						[
							-81.73113947399992,
							30.373532441000066
						],
						[
							-81.73104916499994,
							30.373586626000073
						],
						[
							-81.73091370299996,
							30.373523410000075
						],
						[
							-81.73080533199993,
							30.373415040000054
						],
						[
							-81.73077823999995,
							30.373288608000053
						],
						[
							-81.73087757899992,
							30.373153146000046
						],
						[
							-81.73091370299996,
							30.37308993000005
						],
						[
							-81.73092273299994,
							30.372999621000076
						],
						[
							-81.7308956409999,
							30.37290028200005
						],
						[
							-81.73081436299994,
							30.372764819000057
						],
						[
							-81.73069696199991,
							30.37272869600008
						],
						[
							-81.73058859199995,
							30.372773850000044
						],
						[
							-81.7305073149999,
							30.37286415900007
						],
						[
							-81.73046215999995,
							30.372927375000078
						],
						[
							-81.73038088299995,
							30.37300865200007
						],
						[
							-81.73025445099995,
							30.373062837000077
						],
						[
							-81.73006480299995,
							30.373080899000055
						],
						[
							-81.72988418599994,
							30.373062837000077
						],
						[
							-81.72973066199995,
							30.372999621000076
						],
						[
							-81.72966744599997,
							30.372927375000078
						],
						[
							-81.72956810699992,
							30.37286415900007
						],
						[
							-81.72941458199995,
							30.37286415900007
						],
						[
							-81.72921590399994,
							30.37293640500008
						],
						[
							-81.72877339199994,
							30.373062837000077
						],
						[
							-81.72859277499992,
							30.373062837000077
						],
						[
							-81.72843925099994,
							30.373035745000042
						],
						[
							-81.72824960299994,
							30.372972529000034
						],
						[
							-81.72811413999995,
							30.373053806000083
						],
						[
							-81.72798770899993,
							30.373225392000055
						],
						[
							-81.72799673899993,
							30.373333763000062
						],
						[
							-81.72805092399994,
							30.373460194000074
						],
						[
							-81.72812317099994,
							30.373586626000073
						],
						[
							-81.7281592949999,
							30.37374015100005
						],
						[
							-81.72813220199993,
							30.37391173700007
						],
						[
							-81.72805995499994,
							30.374092354000084
						],
						[
							-81.72790643099995,
							30.374164600000086
						],
						[
							-81.7276445359999,
							30.374245878000067
						],
						[
							-81.72740070399993,
							30.374318125000062
						],
						[
							-81.72719299399995,
							30.374399402000055
						],
						[
							-81.7270575309999,
							30.374498742000075
						],
						[
							-81.72692206899991,
							30.374625174000073
						],
						[
							-81.72679563699995,
							30.374814821000086
						],
						[
							-81.7267703839999,
							30.374913026000062
						],
						[
							-81.72665399999994,
							30.374708000000055
						],
						[
							-81.72619590599993,
							30.373901009000065
						],
						[
							-81.7252819059999,
							30.372329008000065
						],
						[
							-81.72498690599993,
							30.371762008000076
						],
						[
							-81.72436390599995,
							30.370689008000056
						],
						[
							-81.72432597099993,
							30.37061882900008
						],
						[
							-81.72421690499993,
							30.37066500900005
						],
						[
							-81.7241129059999,
							30.370715008000047
						],
						[
							-81.72302190499994,
							30.371164008000054
						],
						[
							-81.72246590599991,
							30.371399008000086
						],
						[
							-81.72222090499992,
							30.371498008000064
						],
						[
							-81.72133790599992,
							30.371837009000046
						],
						[
							-81.72121690599994,
							30.37189600800008
						],
						[
							-81.7211409059999,
							30.371921008000076
						],
						[
							-81.72067590599995,
							30.372123008000074
						],
						[
							-81.72010290499992,
							30.372355008000056
						],
						[
							-81.71924590599991,
							30.372709008000076
						],
						[
							-81.71848290499992,
							30.373018008000088
						],
						[
							-81.71760590499991,
							30.373386009000058
						],
						[
							-81.7151789049999,
							30.37437600800007
						],
						[
							-81.7141649049999,
							30.374794008000038
						],
						[
							-81.71219590499993,
							30.375593008000067
						],
						[
							-81.71190590499992,
							30.375732008000057
						],
						[
							-81.71178390599994,
							30.375793009000066
						],
						[
							-81.71145590599991,
							30.375999009000054
						],
						[
							-81.71117390599994,
							30.376251009000043
						],
						[
							-81.7111229059999,
							30.376307008000083
						],
						[
							-81.71095290499994,
							30.376497008000058
						],
						[
							-81.7106489059999,
							30.376853009000058
						],
						[
							-81.71047190599995,
							30.377045009000085
						],
						[
							-81.7097329049999,
							30.377895008000053
						],
						[
							-81.70947490599993,
							30.378149007000047
						],
						[
							-81.70922290599992,
							30.37833200800009
						],
						[
							-81.70896290499991,
							30.37847700900005
						],
						[
							-81.70865890499994,
							30.378620008000045
						],
						[
							-81.70842990599994,
							30.37869800800007
						],
						[
							-81.70831590499995,
							30.37873500700005
						],
						[
							-81.70804890599993,
							30.378799008000044
						],
						[
							-81.70776590499992,
							30.378836009000057
						],
						[
							-81.70733790499993,
							30.378857009000058
						],
						[
							-81.70613089299991,
							30.37885504500008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Magnolia Gardens",
				"RegionID": "125181"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.67558856299992,
					30.12876804200005,
					-81.62784490599995,
					30.187544322000065
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.63128999999992,
							30.133931000000075
						],
						[
							-81.6310294669999,
							30.133064493000067
						],
						[
							-81.63102953599991,
							30.133064475000086
						],
						[
							-81.63111451299994,
							30.13304886700007
						],
						[
							-81.63121356599993,
							30.133027641000073
						],
						[
							-81.6312458349999,
							30.133021341000074
						],
						[
							-81.63137236699994,
							30.13300816600008
						],
						[
							-81.63155436599993,
							30.13300216600004
						],
						[
							-81.63158399999993,
							30.133001678000088
						],
						[
							-81.63177899999994,
							30.133001678000088
						],
						[
							-81.63186236899992,
							30.133005550000068
						],
						[
							-81.63244236899993,
							30.133059550000045
						],
						[
							-81.6324634309999,
							30.13306176200007
						],
						[
							-81.63327948099993,
							30.133157168000082
						],
						[
							-81.6333591749999,
							30.133136388000082
						],
						[
							-81.63343212099994,
							30.13307483100004
						],
						[
							-81.63384895899992,
							30.132436361000092
						],
						[
							-81.63387609099993,
							30.132397119000075
						],
						[
							-81.63392508999993,
							30.132330118000084
						],
						[
							-81.6339731729999,
							30.132269953000048
						],
						[
							-81.6340262299999,
							30.13221412500008
						],
						[
							-81.63408387099992,
							30.132163043000048
						],
						[
							-81.63414567299992,
							30.13211708200004
						],
						[
							-81.63421118199994,
							30.132076580000046
						],
						[
							-81.63427991799995,
							30.132041834000063
						],
						[
							-81.63435137499994,
							30.13201310000005
						],
						[
							-81.6344293379999,
							30.131986287000075
						],
						[
							-81.63456483499994,
							30.131951341000047
						],
						[
							-81.63472775299994,
							30.13193826900004
						],
						[
							-81.63479600499994,
							30.131896247000043
						],
						[
							-81.63486765199991,
							30.13186031600009
						],
						[
							-81.63494214999992,
							30.13183074800008
						],
						[
							-81.63501893599994,
							30.13180776700005
						],
						[
							-81.63539877699992,
							30.13171236900007
						],
						[
							-81.63583363499993,
							30.131543692000033
						],
						[
							-81.63638327199993,
							30.131337787000067
						],
						[
							-81.63650971999994,
							30.13128299300007
						],
						[
							-81.6365299009999,
							30.131266787000072
						],
						[
							-81.63656158399994,
							30.131242481000072
						],
						[
							-81.63717458499991,
							30.13079348100007
						],
						[
							-81.63725491899993,
							30.13074098600004
						],
						[
							-81.6374436289999,
							30.130631575000056
						],
						[
							-81.63758641399995,
							30.13056491400005
						],
						[
							-81.63770556499992,
							30.130530641000064
						],
						[
							-81.63801356499994,
							30.130464641000057
						],
						[
							-81.63815762899992,
							30.130445773000076
						],
						[
							-81.63970249899995,
							30.13036852000005
						],
						[
							-81.63987208299994,
							30.130207083000073
						],
						[
							-81.63992992699991,
							30.130154079000082
						],
						[
							-81.64004260899992,
							30.13007346000006
						],
						[
							-81.6402526089999,
							30.129946460000042
						],
						[
							-81.64031092099992,
							30.129914085000056
						],
						[
							-81.64075938999991,
							30.129686427000085
						],
						[
							-81.64095548299991,
							30.12953504200004
						],
						[
							-81.64128061999992,
							30.12928988600004
						],
						[
							-81.64137233899993,
							30.129229165000083
						],
						[
							-81.64152016899993,
							30.129160864000085
						],
						[
							-81.64204792299995,
							30.128976813000065
						],
						[
							-81.6421680009999,
							30.128944068000067
						],
						[
							-81.6426239999999,
							30.128853068000073
						],
						[
							-81.6427229709999,
							30.128838983000033
						],
						[
							-81.64351397199994,
							30.128770983000038
						],
						[
							-81.64361658099995,
							30.12876804200005
						],
						[
							-81.64386258099995,
							30.12877504200009
						],
						[
							-81.64399316499993,
							30.12878834100007
						],
						[
							-81.6440401939999,
							30.12879793400009
						],
						[
							-81.64430319399992,
							30.12885893400005
						],
						[
							-81.64440043299993,
							30.128887344000077
						],
						[
							-81.64464100999993,
							30.12897262900009
						],
						[
							-81.6447866609999,
							30.12904016400006
						],
						[
							-81.6448401479999,
							30.129073598000048
						],
						[
							-81.6451498799999,
							30.12928266900008
						],
						[
							-81.64564341999994,
							30.129526629000054
						],
						[
							-81.64607666599994,
							30.129657343000076
						],
						[
							-81.64648100199992,
							30.129757017000085
						],
						[
							-81.6468297479999,
							30.129840240000075
						],
						[
							-81.64692858699993,
							30.129869913000054
						],
						[
							-81.64704391099991,
							30.129921320000047
						],
						[
							-81.64772817399995,
							30.13028593000007
						],
						[
							-81.64873130599995,
							30.130818073000057
						],
						[
							-81.64981064599993,
							30.131400663000083
						],
						[
							-81.65008881999995,
							30.131475312000074
						],
						[
							-81.6506775229999,
							30.13161130400005
						],
						[
							-81.65077728099993,
							30.13162173300009
						],
						[
							-81.65084150099995,
							30.13161907100005
						],
						[
							-81.65119223999994,
							30.131554529000084
						],
						[
							-81.65131459199995,
							30.131540586000085
						],
						[
							-81.6519792229999,
							30.131510699000042
						],
						[
							-81.6526612159999,
							30.131476204000084
						],
						[
							-81.65323880999995,
							30.130928786000087
						],
						[
							-81.65326762799992,
							30.130902590000062
						],
						[
							-81.65340477699993,
							30.130783335000046
						],
						[
							-81.65353933899992,
							30.13068816400005
						],
						[
							-81.65360540299991,
							30.130653592000048
						],
						[
							-81.65378140299993,
							30.13057059100004
						],
						[
							-81.6538574139999,
							30.130538914000056
						],
						[
							-81.65395749899994,
							30.13050894400004
						],
						[
							-81.65459849899992,
							30.130356944000084
						],
						[
							-81.65468519399991,
							30.130340829000087
						],
						[
							-81.65519419399993,
							30.130271829000037
						],
						[
							-81.65534510399993,
							30.130264182000076
						],
						[
							-81.65848010399992,
							30.130369182000038
						],
						[
							-81.65855067599995,
							30.130374331000045
						],
						[
							-81.6586206259999,
							30.13038501200009
						],
						[
							-81.65868951899995,
							30.13040116000008
						],
						[
							-81.65875692899994,
							30.13042267500009
						],
						[
							-81.65882243899995,
							30.130449423000073
						],
						[
							-81.65888564399995,
							30.130481238000076
						],
						[
							-81.65913465299991,
							30.13061920100006
						],
						[
							-81.6592700729999,
							30.130713079000092
						],
						[
							-81.65936309599994,
							30.130803326000034
						],
						[
							-81.65959952799994,
							30.131068359000043
						],
						[
							-81.66039046899994,
							30.131888849000067
						],
						[
							-81.66041098399995,
							30.131910856000044
						],
						[
							-81.66185598399994,
							30.133513856000036
						],
						[
							-81.66189340999995,
							30.13355816700005
						],
						[
							-81.66208240899994,
							30.133797167000072
						],
						[
							-81.6621558359999,
							30.13390533900008
						],
						[
							-81.66218734699993,
							30.13396497800005
						],
						[
							-81.66337474199992,
							30.136432021000072
						],
						[
							-81.66364525099993,
							30.13692975800007
						],
						[
							-81.66387611999994,
							30.137146885000046
						],
						[
							-81.66390394899992,
							30.137174218000045
						],
						[
							-81.66409414099991,
							30.137369308000075
						],
						[
							-81.66432519499995,
							30.137549350000086
						],
						[
							-81.66469338199994,
							30.13779132600007
						],
						[
							-81.66513484199994,
							30.138041834000035
						],
						[
							-81.66517114899995,
							30.138063581000043
						],
						[
							-81.66579074599991,
							30.138454812000077
						],
						[
							-81.6678122859999,
							30.139198507000057
						],
						[
							-81.6683442339999,
							30.139325118000045
						],
						[
							-81.66844358599991,
							30.13935491300009
						],
						[
							-81.66853179299994,
							30.139392455000067
						],
						[
							-81.67004979299992,
							30.140136455000064
						],
						[
							-81.67010366099993,
							30.140165164000052
						],
						[
							-81.67021295299992,
							30.140239478000073
						],
						[
							-81.67104906299994,
							30.140902830000076
						],
						[
							-81.67126885599993,
							30.141039887000094
						],
						[
							-81.67133325999993,
							30.14108404300004
						],
						[
							-81.6713935919999,
							30.141133619000072
						],
						[
							-81.67144939499993,
							30.141188243000045
						],
						[
							-81.67150024899992,
							30.141247501000066
						],
						[
							-81.67154577199994,
							30.14131094700008
						],
						[
							-81.67158561799994,
							30.141378104000072
						],
						[
							-81.67187964999994,
							30.14192660200007
						],
						[
							-81.67209040499995,
							30.142028804000063
						],
						[
							-81.67214766099994,
							30.14205916400005
						],
						[
							-81.6722251729999,
							30.142109393000055
						],
						[
							-81.67302817399991,
							30.14269039300007
						],
						[
							-81.67311219999993,
							30.142759292000054
						],
						[
							-81.67331620099993,
							30.142948293000075
						],
						[
							-81.6733939209999,
							30.143029927000047
						],
						[
							-81.67348383599995,
							30.143158339000085
						],
						[
							-81.67355008699991,
							30.143300414000066
						],
						[
							-81.67359065999995,
							30.14345183500006
						],
						[
							-81.67360431999992,
							30.143606011000088
						],
						[
							-81.67360505999994,
							30.143940515000054
						],
						[
							-81.67372557599992,
							30.14438985600009
						],
						[
							-81.67395248999992,
							30.145234535000046
						],
						[
							-81.67421456799991,
							30.14620882700007
						],
						[
							-81.67437156799993,
							30.146794827000065
						],
						[
							-81.67479912499994,
							30.148384289000038
						],
						[
							-81.67524777999995,
							30.149577479000072
						],
						[
							-81.67526626799992,
							30.14963185800008
						],
						[
							-81.67555026799994,
							30.15056385800006
						],
						[
							-81.67556927099992,
							30.15063715200006
						],
						[
							-81.67558203999994,
							30.150711785000055
						],
						[
							-81.67558848599992,
							30.150787227000084
						],
						[
							-81.67558856299992,
							30.150862944000043
						],
						[
							-81.67558227099994,
							30.15093839900004
						],
						[
							-81.67556965299991,
							30.151013058000046
						],
						[
							-81.67555079999994,
							30.15108639000005
						],
						[
							-81.67424279999994,
							30.155410390000043
						],
						[
							-81.67420186499993,
							30.15551959700008
						],
						[
							-81.6726578649999,
							30.158944597000072
						],
						[
							-81.67261683599992,
							30.159024661000046
						],
						[
							-81.67252692099993,
							30.15915307300008
						],
						[
							-81.67241607299991,
							30.159263920000058
						],
						[
							-81.67228766099993,
							30.159353835000047
						],
						[
							-81.67222005299993,
							30.15938913400004
						],
						[
							-81.66662204799991,
							30.16201613700008
						],
						[
							-81.66374304399994,
							30.163367140000048
						],
						[
							-81.66366858699992,
							30.163398087000072
						],
						[
							-81.66358915099994,
							30.16342290100005
						],
						[
							-81.65527725199992,
							30.16560287400006
						],
						[
							-81.6547581079999,
							30.165739161000086
						],
						[
							-81.65321538299992,
							30.16638035600005
						],
						[
							-81.65237942499994,
							30.16672833800004
						],
						[
							-81.65057498399995,
							30.167478522000067
						],
						[
							-81.64982215499992,
							30.167790961000037
						],
						[
							-81.64808522399994,
							30.16854353900004
						],
						[
							-81.64681850399995,
							30.169873682000063
						],
						[
							-81.64601643999993,
							30.17138547900004
						],
						[
							-81.64600083499994,
							30.171413661000088
						],
						[
							-81.64592857199995,
							30.17151686400007
						],
						[
							-81.6459090859999,
							30.171589586000042
						],
						[
							-81.64587297399993,
							30.17167389600007
						],
						[
							-81.64589724199995,
							30.171853724000073
						],
						[
							-81.64589982099994,
							30.17187468600008
						],
						[
							-81.6459618209999,
							30.172432686000032
						],
						[
							-81.64596694699992,
							30.17250605000004
						],
						[
							-81.6459660619999,
							30.172579587000087
						],
						[
							-81.6459591709999,
							30.17265280600009
						],
						[
							-81.64594631999995,
							30.172725217000053
						],
						[
							-81.64592759599992,
							30.172796336000086
						],
						[
							-81.64590312399993,
							30.172865688000055
						],
						[
							-81.64444591699994,
							30.176512656000057
						],
						[
							-81.64430630999993,
							30.177021811000092
						],
						[
							-81.6442840869999,
							30.177091586000074
						],
						[
							-81.64421783599994,
							30.177233661000063
						],
						[
							-81.64412792099995,
							30.17736207300004
						],
						[
							-81.64401707299993,
							30.17747292100006
						],
						[
							-81.64393858999995,
							30.177527875000067
						],
						[
							-81.6440188389999,
							30.17778621200006
						],
						[
							-81.6440367319999,
							30.17785269500007
						],
						[
							-81.64404948599991,
							30.17792035300005
						],
						[
							-81.64405702699992,
							30.17798878800005
						],
						[
							-81.64405930999993,
							30.178057600000045
						],
						[
							-81.64405632299992,
							30.178126384000052
						],
						[
							-81.64404808199993,
							30.178194739000052
						],
						[
							-81.6438720559999,
							30.17929765200006
						],
						[
							-81.64395735299992,
							30.18058452100007
						],
						[
							-81.64395932199994,
							30.180644000000083
						],
						[
							-81.64394979299993,
							30.18077456700007
						],
						[
							-81.64389603899991,
							30.181140875000043
						],
						[
							-81.64387428299995,
							30.181293184000086
						],
						[
							-81.6438696589999,
							30.181322166000086
						],
						[
							-81.64382908599993,
							30.181473587000085
						],
						[
							-81.64376283599995,
							30.18161566100008
						],
						[
							-81.64367292099992,
							30.18174407400005
						],
						[
							-81.64356207299994,
							30.181854921000085
						],
						[
							-81.64345835299991,
							30.181930048000083
						],
						[
							-81.64292866599993,
							30.18225890000008
						],
						[
							-81.64244104999995,
							30.18674223900007
						],
						[
							-81.64243265999994,
							30.186801166000066
						],
						[
							-81.6423920869999,
							30.186952587000064
						],
						[
							-81.64232583599994,
							30.187094661000057
						],
						[
							-81.64223592099995,
							30.187223073000045
						],
						[
							-81.64212507299993,
							30.187333921000064
						],
						[
							-81.64199666099995,
							30.18742383600005
						],
						[
							-81.6418545869999,
							30.187490087000068
						],
						[
							-81.6417031659999,
							30.187530660000053
						],
						[
							-81.64154699999995,
							30.187544322000065
						],
						[
							-81.64142262999991,
							30.187535681000043
						],
						[
							-81.64142016999995,
							30.18753533800009
						],
						[
							-81.64061599999991,
							30.186515000000043
						],
						[
							-81.63918390599991,
							30.18588600800007
						],
						[
							-81.6382229059999,
							30.185458009000058
						],
						[
							-81.63726390499994,
							30.185046008000082
						],
						[
							-81.63586490599994,
							30.184455008000043
						],
						[
							-81.6350899229999,
							30.184142918000077
						],
						[
							-81.63312990499992,
							30.183392009000045
						],
						[
							-81.63237490599994,
							30.183081009000034
						],
						[
							-81.6295579049999,
							30.18203000900007
						],
						[
							-81.62887290499994,
							30.181772009000042
						],
						[
							-81.62854390399991,
							30.181648003000078
						],
						[
							-81.62850990599992,
							30.181383010000047
						],
						[
							-81.62848690499993,
							30.181257008000046
						],
						[
							-81.62837090599993,
							30.180480008000075
						],
						[
							-81.62829690599995,
							30.17997000800006
						],
						[
							-81.62824990599995,
							30.17961900800009
						],
						[
							-81.62817190599992,
							30.17906800800006
						],
						[
							-81.62804190599991,
							30.178112008000085
						],
						[
							-81.62799890499991,
							30.17779600900008
						],
						[
							-81.62798690599993,
							30.177700008000045
						],
						[
							-81.62788190499992,
							30.17694300900007
						],
						[
							-81.6278649059999,
							30.176803008000036
						],
						[
							-81.62784490599995,
							30.17638900900005
						],
						[
							-81.62786190499992,
							30.17605000800006
						],
						[
							-81.62788190499992,
							30.175853009000036
						],
						[
							-81.62791490599996,
							30.175654008000038
						],
						[
							-81.62794890599992,
							30.17543100900008
						],
						[
							-81.62797490499992,
							30.17529500900008
						],
						[
							-81.62803690499993,
							30.174988009000064
						],
						[
							-81.62812890499993,
							30.174679009000045
						],
						[
							-81.62830990599991,
							30.17409500800005
						],
						[
							-81.62883490599995,
							30.172675008000056
						],
						[
							-81.62905090499993,
							30.172120009000086
						],
						[
							-81.62922590499994,
							30.17165400900007
						],
						[
							-81.62960090599995,
							30.170660008000084
						],
						[
							-81.6296479049999,
							30.170555009000054
						],
						[
							-81.62982190499991,
							30.17009900800008
						],
						[
							-81.62999890599991,
							30.16973600900008
						],
						[
							-81.63015790599991,
							30.169468008000084
						],
						[
							-81.63025390599995,
							30.16931500800007
						],
						[
							-81.63070990499995,
							30.168694008000045
						],
						[
							-81.63176490599994,
							30.167256009000088
						],
						[
							-81.63200290599991,
							30.166881008000075
						],
						[
							-81.63213490499993,
							30.16664000900005
						],
						[
							-81.6323059049999,
							30.16627300900007
						],
						[
							-81.6324399049999,
							30.165912009000067
						],
						[
							-81.63254090499993,
							30.16553700800006
						],
						[
							-81.63260790599992,
							30.165138008000042
						],
						[
							-81.63264690599993,
							30.16486100800006
						],
						[
							-81.63265790499992,
							30.16460000800004
						],
						[
							-81.63269190599993,
							30.163564009000083
						],
						[
							-81.63271390599994,
							30.16259800800009
						],
						[
							-81.63275495999994,
							30.160850010000047
						],
						[
							-81.63276890599991,
							30.159915008000045
						],
						[
							-81.63278190599993,
							30.159011009000036
						],
						[
							-81.63280890599992,
							30.15781200800006
						],
						[
							-81.6327729059999,
							30.156367008000075
						],
						[
							-81.6327489059999,
							30.154851009000083
						],
						[
							-81.6327259059999,
							30.153692008000064
						],
						[
							-81.63271490599993,
							30.15327800900008
						],
						[
							-81.6327039059999,
							30.15262700800008
						],
						[
							-81.63269890499993,
							30.151004009000076
						],
						[
							-81.63269790599992,
							30.14962700900009
						],
						[
							-81.63269390599993,
							30.148363008000047
						],
						[
							-81.63268890599994,
							30.147042008000085
						],
						[
							-81.63268490599995,
							30.145300008000046
						],
						[
							-81.63268990599994,
							30.14415100800005
						],
						[
							-81.6326819059999,
							30.142742008000084
						],
						[
							-81.63267390599992,
							30.141424008000058
						],
						[
							-81.63266990599993,
							30.140043009000067
						],
						[
							-81.63266790599994,
							30.13876300800007
						],
						[
							-81.63266790599994,
							30.137840008000072
						],
						[
							-81.63265390599992,
							30.13710100800006
						],
						[
							-81.63265490599991,
							30.13693500800008
						],
						[
							-81.63264790599995,
							30.13667200800006
						],
						[
							-81.63259803099993,
							30.13625296300006
						],
						[
							-81.63250890799992,
							30.136099009000077
						],
						[
							-81.63234390499991,
							30.135530008000046
						],
						[
							-81.63230990499994,
							30.135394008000052
						],
						[
							-81.63227582399993,
							30.135315048000056
						],
						[
							-81.6321639059999,
							30.135109010000065
						],
						[
							-81.63193290599992,
							30.134747008000087
						],
						[
							-81.63177890499992,
							30.134475010000077
						],
						[
							-81.63128999999992,
							30.133931000000075
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Mandarin",
				"RegionID": "125198"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.84301875999995,
					30.31277312900005,
					-81.76089190599994,
					30.355096455000083
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.8067719259999,
							30.342242931000044
						],
						[
							-81.80300890899991,
							30.342176010000056
						],
						[
							-81.80062790799991,
							30.342288011000054
						],
						[
							-81.79617490699991,
							30.342838010000037
						],
						[
							-81.78986890699991,
							30.343523010000073
						],
						[
							-81.78149990799994,
							30.34434501000004
						],
						[
							-81.77970890799992,
							30.344749010000047
						],
						[
							-81.77446090699993,
							30.345236010000065
						],
						[
							-81.77320130599992,
							30.345352401000074
						],
						[
							-81.77271990499992,
							30.345397009000067
						],
						[
							-81.76460290499995,
							30.346276009000064
						],
						[
							-81.7609409179999,
							30.346755097000088
						],
						[
							-81.76091490499994,
							30.345164009000086
						],
						[
							-81.76090990599994,
							30.34271200900008
						],
						[
							-81.76089390599994,
							30.34039800800008
						],
						[
							-81.76089490599992,
							30.33984000900006
						],
						[
							-81.76089190599994,
							30.338869008000078
						],
						[
							-81.76090890599994,
							30.338517008000053
						],
						[
							-81.76096290599992,
							30.33791400800004
						],
						[
							-81.76103690599992,
							30.337308008000036
						],
						[
							-81.76120590599993,
							30.33644700900004
						],
						[
							-81.76137590499991,
							30.33576500900006
						],
						[
							-81.76138690599993,
							30.335722009000047
						],
						[
							-81.76140790599995,
							30.335651008000067
						],
						[
							-81.76152190499994,
							30.33527200900005
						],
						[
							-81.76170290599993,
							30.33474600900007
						],
						[
							-81.76188890599991,
							30.334249008000086
						],
						[
							-81.76213090599992,
							30.33368800800008
						],
						[
							-81.76255090599994,
							30.332825008000047
						],
						[
							-81.7627259059999,
							30.332508008000044
						],
						[
							-81.7628369059999,
							30.33233500900008
						],
						[
							-81.76294490499993,
							30.332174009000084
						],
						[
							-81.76319090599993,
							30.331761009000047
						],
						[
							-81.76336190599994,
							30.331497009000092
						],
						[
							-81.76388690599993,
							30.330750009000045
						],
						[
							-81.76426090599995,
							30.33027000800007
						],
						[
							-81.76482590599994,
							30.329608009000083
						],
						[
							-81.76505190499995,
							30.329364009000074
						],
						[
							-81.76528190499994,
							30.329139009000073
						],
						[
							-81.76554690499995,
							30.32886300900009
						],
						[
							-81.76580290499993,
							30.328603009000062
						],
						[
							-81.76600090499994,
							30.32839700800008
						],
						[
							-81.7679959049999,
							30.326367008000087
						],
						[
							-81.76823690599991,
							30.326121009000076
						],
						[
							-81.76842290499991,
							30.325938009000083
						],
						[
							-81.76874690599993,
							30.325576009000088
						],
						[
							-81.7689649049999,
							30.325318008000067
						],
						[
							-81.76939990499994,
							30.32471500800006
						],
						[
							-81.7697998239999,
							30.323984968000048
						],
						[
							-81.77028290599992,
							30.322868008000057
						],
						[
							-81.77033590499992,
							30.322694009000084
						],
						[
							-81.77047290499992,
							30.322131009000085
						],
						[
							-81.77052290599994,
							30.321878009000045
						],
						[
							-81.77057590599992,
							30.321444008000068
						],
						[
							-81.7705919039999,
							30.321373006000048
						],
						[
							-81.77059190499995,
							30.321304009000073
						],
						[
							-81.77061490599993,
							30.32092700900006
						],
						[
							-81.77060990599995,
							30.32022100900008
						],
						[
							-81.77059890599992,
							30.31956100900004
						],
						[
							-81.77059890699991,
							30.31909700800009
						],
						[
							-81.77061495899994,
							30.319010008000074
						],
						[
							-81.7705849059999,
							30.318708009000087
						],
						[
							-81.77057690599992,
							30.318211009000038
						],
						[
							-81.7705599059999,
							30.317019009000038
						],
						[
							-81.77055690599991,
							30.31604000900006
						],
						[
							-81.77055790599991,
							30.315346008000066
						],
						[
							-81.77055785099992,
							30.315239000000076
						],
						[
							-81.77072490699993,
							30.315224011000055
						],
						[
							-81.77160490799992,
							30.31514801100008
						],
						[
							-81.77446590799991,
							30.31513101000007
						],
						[
							-81.77536190799992,
							30.31509101100005
						],
						[
							-81.77595190699992,
							30.31508301100007
						],
						[
							-81.77690890699995,
							30.315079010000087
						],
						[
							-81.77728292199993,
							30.315077062000057
						],
						[
							-81.77804290599994,
							30.31507200800007
						],
						[
							-81.7784869059999,
							30.315069008000076
						],
						[
							-81.77863290599993,
							30.31506600800009
						],
						[
							-81.77870090599993,
							30.31506600800009
						],
						[
							-81.77925690599994,
							30.315070008000074
						],
						[
							-81.77997890599994,
							30.31505600800006
						],
						[
							-81.78108390599994,
							30.315053008000064
						],
						[
							-81.78124790599992,
							30.31503600800005
						],
						[
							-81.78147690499992,
							30.31503600800005
						],
						[
							-81.78222301699992,
							30.315022849000062
						],
						[
							-81.7822617949999,
							30.31513916600005
						],
						[
							-81.78250590599993,
							30.315135008000084
						],
						[
							-81.7829869059999,
							30.315127008000047
						],
						[
							-81.78338990499992,
							30.31512100800006
						],
						[
							-81.78362003899991,
							30.315122138000053
						],
						[
							-81.78361190599992,
							30.315001009000074
						],
						[
							-81.7835969059999,
							30.314877008000057
						],
						[
							-81.78358590499994,
							30.314274008000037
						],
						[
							-81.78357177299995,
							30.313566880000057
						],
						[
							-81.78414290599996,
							30.313548008000055
						],
						[
							-81.78545990499993,
							30.313533008000036
						],
						[
							-81.78678590499995,
							30.313504008000052
						],
						[
							-81.78800790499992,
							30.313488008000036
						],
						[
							-81.78840190499994,
							30.313479009000048
						],
						[
							-81.78959890599992,
							30.313458008000055
						],
						[
							-81.78993390499994,
							30.313460009000035
						],
						[
							-81.79178597299995,
							30.31341818200008
						],
						[
							-81.79220490599995,
							30.31303300900004
						],
						[
							-81.79241590399994,
							30.312880012000054
						],
						[
							-81.79265790599993,
							30.31280301000004
						],
						[
							-81.79287697299992,
							30.31277312900005
						],
						[
							-81.79209190699994,
							30.31343201100009
						],
						[
							-81.79192990799993,
							30.313592011000086
						],
						[
							-81.79172790799993,
							30.313771011000085
						],
						[
							-81.7915199059999,
							30.313950010000045
						],
						[
							-81.79086290599992,
							30.314484011000047
						],
						[
							-81.7905189089999,
							30.314756011000043
						],
						[
							-81.79039290899993,
							30.31488801100005
						],
						[
							-81.79028376899993,
							30.31500007200009
						],
						[
							-81.79178291399995,
							30.314978956000065
						],
						[
							-81.79179890699993,
							30.315318011000045
						],
						[
							-81.7918299079999,
							30.316125011000057
						],
						[
							-81.79189304099992,
							30.317278141000088
						],
						[
							-81.79112176699994,
							30.317267945000083
						],
						[
							-81.79213690699994,
							30.318411010000087
						],
						[
							-81.79226690799993,
							30.31856901000009
						],
						[
							-81.7929339069999,
							30.319327010000052
						],
						[
							-81.79295890799995,
							30.319355010000038
						],
						[
							-81.7929989079999,
							30.31939901000004
						],
						[
							-81.79308890699991,
							30.319498010000075
						],
						[
							-81.7932489069999,
							30.31967401000008
						],
						[
							-81.79336690799994,
							30.319804010000045
						],
						[
							-81.79355390699993,
							30.320008011000084
						],
						[
							-81.79368306299996,
							30.32017307200005
						],
						[
							-81.79324390699992,
							30.320220011000057
						],
						[
							-81.79276190799993,
							30.320308010000076
						],
						[
							-81.7924179069999,
							30.320384010000055
						],
						[
							-81.7918759069999,
							30.320529011000076
						],
						[
							-81.79168990799991,
							30.320585011000052
						],
						[
							-81.79125890699993,
							30.320733010000083
						],
						[
							-81.78837890799991,
							30.321925010000083
						],
						[
							-81.78771990699994,
							30.322189010000045
						],
						[
							-81.78744590699995,
							30.32227301000006
						],
						[
							-81.78709790699992,
							30.32236501100005
						],
						[
							-81.78694890799994,
							30.322394010000036
						],
						[
							-81.78679590799993,
							30.322430010000065
						],
						[
							-81.78659490699994,
							30.322469011000063
						],
						[
							-81.7865027499999,
							30.322485954000054
						],
						[
							-81.78661790699994,
							30.322614008000077
						],
						[
							-81.78672890699994,
							30.322695010000075
						],
						[
							-81.78681790799993,
							30.32274600900007
						],
						[
							-81.7873199419999,
							30.32292192600005
						],
						[
							-81.78767690799992,
							30.323086011000044
						],
						[
							-81.7880239079999,
							30.323274010000038
						],
						[
							-81.78819590699993,
							30.323386011000082
						],
						[
							-81.7886369069999,
							30.323734010000067
						],
						[
							-81.78870590699995,
							30.323790011000085
						],
						[
							-81.78904890699994,
							30.32417901100007
						],
						[
							-81.7892859079999,
							30.324523011000057
						],
						[
							-81.78941590799991,
							30.324747010000067
						],
						[
							-81.78947590699994,
							30.32487901000007
						],
						[
							-81.78959190699993,
							30.325179010000056
						],
						[
							-81.7896899079999,
							30.325516010000058
						],
						[
							-81.7897449059999,
							30.325691008000035
						],
						[
							-81.78978290799995,
							30.32603201100005
						],
						[
							-81.78979790799991,
							30.32643401000007
						],
						[
							-81.7898029079999,
							30.326620010000056
						],
						[
							-81.78981090799994,
							30.328116011000077
						],
						[
							-81.78981190799993,
							30.328253011000072
						],
						[
							-81.78981977899991,
							30.32986714400005
						],
						[
							-81.79017390799993,
							30.329836011000054
						],
						[
							-81.7909939079999,
							30.329801011000086
						],
						[
							-81.79202190799992,
							30.329723010000066
						],
						[
							-81.79544690799993,
							30.329509011000084
						],
						[
							-81.7958829069999,
							30.32950201100004
						],
						[
							-81.79610990799995,
							30.329508011000087
						],
						[
							-81.79664290699992,
							30.329586011000064
						],
						[
							-81.79798290699995,
							30.329805010000086
						],
						[
							-81.79818490699996,
							30.32984401000005
						],
						[
							-81.79993990699995,
							30.33014601100007
						],
						[
							-81.80249190699993,
							30.330556011000056
						],
						[
							-81.80255990799992,
							30.33056901000009
						],
						[
							-81.80340990699995,
							30.330715011000056
						],
						[
							-81.8066439079999,
							30.331253010000065
						],
						[
							-81.81079290799994,
							30.331949010000077
						],
						[
							-81.81253590799992,
							30.332221011000055
						],
						[
							-81.81432890799994,
							30.33252801100008
						],
						[
							-81.81503290799992,
							30.332588009000062
						],
						[
							-81.81561490799993,
							30.33254001000006
						],
						[
							-81.81712090799994,
							30.33240501000006
						],
						[
							-81.81829590699994,
							30.33230001000004
						],
						[
							-81.81876790799993,
							30.332241011000065
						],
						[
							-81.81924890699992,
							30.332167011000084
						],
						[
							-81.82020390799994,
							30.33199301000008
						],
						[
							-81.8271979079999,
							30.330672011000043
						],
						[
							-81.82746490699992,
							30.330630010000053
						],
						[
							-81.82780090799992,
							30.330598011000063
						],
						[
							-81.82812090899995,
							30.33059001000004
						],
						[
							-81.8284639069999,
							30.330598011000063
						],
						[
							-81.82888190799991,
							30.330642011000066
						],
						[
							-81.82914890799994,
							30.33068801000007
						],
						[
							-81.8294299069999,
							30.33075001100008
						],
						[
							-81.82975190799993,
							30.330843011000074
						],
						[
							-81.83013290799994,
							30.330985011000056
						],
						[
							-81.83085990699993,
							30.331321010000067
						],
						[
							-81.83195990799993,
							30.331843011000043
						],
						[
							-81.8332829069999,
							30.33245901000004
						],
						[
							-81.83411393099993,
							30.332856951000053
						],
						[
							-81.83276430799992,
							30.337339281000087
						],
						[
							-81.83376482199992,
							30.34071569400004
						],
						[
							-81.83626590599995,
							30.343091617000088
						],
						[
							-81.83964227299992,
							30.347093234000056
						],
						[
							-81.8428937679999,
							30.350594588000035
						],
						[
							-81.84301875999995,
							30.355096455000083
						],
						[
							-81.8398923769999,
							30.35397102600007
						],
						[
							-81.8365160269999,
							30.35309558300008
						],
						[
							-81.8303885229999,
							30.352095266000052
						],
						[
							-81.82726225699992,
							30.35172011700007
						],
						[
							-81.8232606329999,
							30.350969808000062
						],
						[
							-81.82000925599995,
							30.349219161000065
						],
						[
							-81.81838368899992,
							30.34671804600003
						],
						[
							-81.81488227099993,
							30.343966893000072
						],
						[
							-81.81113071099992,
							30.343091616000038
						],
						[
							-81.8067719259999,
							30.342242931000044
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Marietta",
				"RegionID": "125218"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.7307319969999,
					30.29199401200009,
					-81.6969158039999,
					30.321875007000077
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.69699890699991,
							30.321066008000063
						],
						[
							-81.69698990699993,
							30.320655008000074
						],
						[
							-81.69697590499993,
							30.32019600900009
						],
						[
							-81.69697590499993,
							30.320141008000064
						],
						[
							-81.69695990599992,
							30.319292008000044
						],
						[
							-81.6969559069999,
							30.31922100900005
						],
						[
							-81.69692790599993,
							30.318933008000045
						],
						[
							-81.6969158039999,
							30.318478974000072
						],
						[
							-81.69863790499994,
							30.31737400800006
						],
						[
							-81.6991279049999,
							30.317075008000078
						],
						[
							-81.7008799059999,
							30.315907009000057
						],
						[
							-81.70154090499994,
							30.315509009000042
						],
						[
							-81.70166890599995,
							30.315419009000042
						],
						[
							-81.70326090499992,
							30.314362009000035
						],
						[
							-81.7039879049999,
							30.313964008000085
						],
						[
							-81.70402890299994,
							30.313937009000085
						],
						[
							-81.70407090799995,
							30.31389700800008
						],
						[
							-81.7051169049999,
							30.31324400800008
						],
						[
							-81.70534490599994,
							30.313112009000065
						],
						[
							-81.70746490599993,
							30.31171900800007
						],
						[
							-81.71062688099994,
							30.309599135000045
						],
						[
							-81.71164890499995,
							30.30893800800004
						],
						[
							-81.71327890599991,
							30.30802400800008
						],
						[
							-81.71539190599992,
							30.30648600800004
						],
						[
							-81.71683390599992,
							30.305473008000035
						],
						[
							-81.71778090499993,
							30.304907007000057
						],
						[
							-81.7190299049999,
							30.303986009000088
						],
						[
							-81.71915990499991,
							30.30388000900007
						],
						[
							-81.71923790499994,
							30.30380700900008
						],
						[
							-81.71951690499992,
							30.30350400800006
						],
						[
							-81.71967290499992,
							30.303302008000063
						],
						[
							-81.71998690599992,
							30.30285900800004
						],
						[
							-81.72022690599994,
							30.302454008000044
						],
						[
							-81.72039290499993,
							30.302096008000035
						],
						[
							-81.72053190499992,
							30.301714008000086
						],
						[
							-81.72063290599993,
							30.301323008000058
						],
						[
							-81.72068890499992,
							30.300877008000043
						],
						[
							-81.7207189049999,
							30.300609009000087
						],
						[
							-81.7207349059999,
							30.300401008000048
						],
						[
							-81.72147990499991,
							30.295160009000085
						],
						[
							-81.72147590499992,
							30.295001011000064
						],
						[
							-81.7214479559999,
							30.294887990000063
						],
						[
							-81.72066183099992,
							30.293462902000044
						],
						[
							-81.72065590599993,
							30.293356010000082
						],
						[
							-81.72065290599994,
							30.292684009000087
						],
						[
							-81.72065884999995,
							30.292030010000076
						],
						[
							-81.72203790599991,
							30.292044008000065
						],
						[
							-81.72367990599992,
							30.29205000800005
						],
						[
							-81.72417390599992,
							30.292055008000087
						],
						[
							-81.7244949059999,
							30.29205000800005
						],
						[
							-81.72621890499994,
							30.292028008000045
						],
						[
							-81.7283249059999,
							30.292006008000048
						],
						[
							-81.7293849049999,
							30.29199700800007
						],
						[
							-81.73023990599995,
							30.29200000900005
						],
						[
							-81.73039996099993,
							30.29199401200009
						],
						[
							-81.73041490599991,
							30.292885009000088
						],
						[
							-81.73043090599992,
							30.293276008000074
						],
						[
							-81.7304229049999,
							30.29359100800008
						],
						[
							-81.73043090599992,
							30.293806008000047
						],
						[
							-81.73044590599994,
							30.295250009000085
						],
						[
							-81.73044590599994,
							30.295622008000063
						],
						[
							-81.73046090499992,
							30.296186009000053
						],
						[
							-81.73047590599992,
							30.29756900900008
						],
						[
							-81.73049890599992,
							30.29941700800003
						],
						[
							-81.73049890599992,
							30.29946700800008
						],
						[
							-81.7305069059999,
							30.30039000900007
						],
						[
							-81.73051490499995,
							30.300467009000048
						],
						[
							-81.7305069059999,
							30.300676008000043
						],
						[
							-81.73051490599994,
							30.301064008000083
						],
						[
							-81.73051490499995,
							30.30173900900007
						],
						[
							-81.73052190499993,
							30.301912009000034
						],
						[
							-81.7305299059999,
							30.302402009000048
						],
						[
							-81.73053590599994,
							30.30308000800005
						],
						[
							-81.73053690599994,
							30.30316200900006
						],
						[
							-81.73055290499991,
							30.303418009000044
						],
						[
							-81.7305519059999,
							30.304379008000073
						],
						[
							-81.73056690599992,
							30.30470800900008
						],
						[
							-81.73056790599993,
							30.30500600900007
						],
						[
							-81.73056790599993,
							30.305099009000063
						],
						[
							-81.73059790499991,
							30.306877008000072
						],
						[
							-81.73061390599992,
							30.307627009000043
						],
						[
							-81.7306209059999,
							30.30841600900004
						],
						[
							-81.73063685199992,
							30.309210009000083
						],
						[
							-81.73065190799991,
							30.309982010000056
						],
						[
							-81.73066690799993,
							30.310743010000067
						],
						[
							-81.7306819069999,
							30.31152201000009
						],
						[
							-81.73069790699992,
							30.312294011000066
						],
						[
							-81.73070490799995,
							30.313063010000068
						],
						[
							-81.73071290799993,
							30.31378601100005
						],
						[
							-81.73069790799991,
							30.31459801100004
						],
						[
							-81.73068990799993,
							30.315262011000073
						],
						[
							-81.7307239079999,
							30.316859011000076
						],
						[
							-81.73072790799995,
							30.317225010000076
						],
						[
							-81.7307319969999,
							30.31728900400009
						],
						[
							-81.73010990499995,
							30.317374009000048
						],
						[
							-81.72910889299993,
							30.317640184000087
						],
						[
							-81.7290449059999,
							30.31761582200005
						],
						[
							-81.72888190499992,
							30.317680008000085
						],
						[
							-81.7283949049999,
							30.317811009000085
						],
						[
							-81.72760790599995,
							30.31813200900007
						],
						[
							-81.72684790599993,
							30.318493009000065
						],
						[
							-81.72568272699993,
							30.319156971000044
						],
						[
							-81.72573108199992,
							30.319221046000052
						],
						[
							-81.72500590599992,
							30.31959500900007
						],
						[
							-81.7245389059999,
							30.319847009000057
						],
						[
							-81.72428982999992,
							30.319979164000078
						],
						[
							-81.72427698699994,
							30.319902850000062
						],
						[
							-81.72399890499992,
							30.32003700900009
						],
						[
							-81.72256273599993,
							30.32062692400007
						],
						[
							-81.72258506499992,
							30.32070610400007
						],
						[
							-81.72222090499992,
							30.320784008000093
						],
						[
							-81.72180190599995,
							30.320847008000044
						],
						[
							-81.7214359059999,
							30.32086800800005
						],
						[
							-81.72007790499993,
							30.320858008000073
						],
						[
							-81.7183109049999,
							30.320864008000058
						],
						[
							-81.71802990499992,
							30.320864008000058
						],
						[
							-81.71783090499991,
							30.320871008000044
						],
						[
							-81.7174249059999,
							30.32088400800006
						],
						[
							-81.71655990599993,
							30.32089000800005
						],
						[
							-81.71622590599992,
							30.320895009000086
						],
						[
							-81.71611190599992,
							30.320895009000086
						],
						[
							-81.71577177199994,
							30.320906062000063
						],
						[
							-81.71595004199992,
							30.320735954000046
						],
						[
							-81.71471390499994,
							30.32074600800007
						],
						[
							-81.71411190499992,
							30.320748008000066
						],
						[
							-81.71381377299991,
							30.320756878000054
						],
						[
							-81.71381390599993,
							30.32084500800005
						],
						[
							-81.71381403599992,
							30.320927138000062
						],
						[
							-81.71314990499992,
							30.320927008000073
						],
						[
							-81.71187790599993,
							30.320948008000073
						],
						[
							-81.7115559049999,
							30.32094900800007
						],
						[
							-81.71089190499993,
							30.320943008000086
						],
						[
							-81.70987790499993,
							30.320932009000046
						],
						[
							-81.7097719059999,
							30.32093500900004
						],
						[
							-81.7091629059999,
							30.32094900800007
						],
						[
							-81.70811990599992,
							30.320959008000045
						],
						[
							-81.7076799059999,
							30.32096300800004
						],
						[
							-81.70705590599994,
							30.320974009000054
						],
						[
							-81.7065539059999,
							30.320988008000086
						],
						[
							-81.70553990599991,
							30.320993009000066
						],
						[
							-81.70544390599993,
							30.320995008000068
						],
						[
							-81.70513290499993,
							30.320995008000068
						],
						[
							-81.70475590599995,
							30.32099200900007
						],
						[
							-81.70441290499991,
							30.32100200800005
						],
						[
							-81.70341290599993,
							30.321000008000055
						],
						[
							-81.70248490499995,
							30.32104300800006
						],
						[
							-81.70234990499995,
							30.32104900900004
						],
						[
							-81.70181890499993,
							30.321122009000078
						],
						[
							-81.70125190499994,
							30.32125100800005
						],
						[
							-81.70115990499994,
							30.321269009000048
						],
						[
							-81.7009049049999,
							30.321324009000083
						],
						[
							-81.70079690499995,
							30.32135300800007
						],
						[
							-81.70055390499994,
							30.321400009000058
						],
						[
							-81.70016690599994,
							30.32147100800006
						],
						[
							-81.70005590499994,
							30.321491008000063
						],
						[
							-81.69937890499995,
							30.321611008000048
						],
						[
							-81.69930290499991,
							30.321624008000075
						],
						[
							-81.6992109059999,
							30.321640009000077
						],
						[
							-81.69893490499993,
							30.321681009000088
						],
						[
							-81.69864890599992,
							30.321724007000057
						],
						[
							-81.69825790599992,
							30.321783008000068
						],
						[
							-81.69814490599992,
							30.321793009000093
						],
						[
							-81.69800390599994,
							30.321819008000038
						],
						[
							-81.69768790599994,
							30.321865007000042
						],
						[
							-81.69756390599991,
							30.321870009000065
						],
						[
							-81.69745090499993,
							30.321870009000065
						],
						[
							-81.69700585299995,
							30.321875007000077
						],
						[
							-81.6970059059999,
							30.32173300800008
						],
						[
							-81.6970059059999,
							30.321589008000043
						],
						[
							-81.69699890699991,
							30.321066008000063
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Murray Hill",
				"RegionID": "125385"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.77305690599991,
					30.21881101000008,
					-81.7369928199999,
					30.248445144000076
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.75960502899994,
							30.248445144000076
						],
						[
							-81.75870190599994,
							30.248353008000038
						],
						[
							-81.75760690599992,
							30.248388008000063
						],
						[
							-81.75633990599994,
							30.248363008000073
						],
						[
							-81.75515690499992,
							30.24836900800005
						],
						[
							-81.75340290499992,
							30.248379008000086
						],
						[
							-81.75290690599991,
							30.24837300800004
						],
						[
							-81.75221990599995,
							30.24838100800008
						],
						[
							-81.75181590599993,
							30.248384008000073
						],
						[
							-81.75096090499994,
							30.248388008000063
						],
						[
							-81.7499159059999,
							30.248394008000048
						],
						[
							-81.74913790599993,
							30.248390008000058
						],
						[
							-81.74726890599993,
							30.248404008000083
						],
						[
							-81.74636790599993,
							30.24840500800008
						],
						[
							-81.74406390599997,
							30.248417009000036
						],
						[
							-81.74359890599995,
							30.248411008000065
						],
						[
							-81.74318090499992,
							30.248417009000036
						],
						[
							-81.74306492399995,
							30.248419098000056
						],
						[
							-81.74307290599995,
							30.248060010000074
						],
						[
							-81.74305690599994,
							30.247456008000086
						],
						[
							-81.74306490499993,
							30.24688100900005
						],
						[
							-81.74302690499991,
							30.246319008000057
						],
						[
							-81.74302690499991,
							30.246038008000085
						],
						[
							-81.74301175999994,
							30.245892894000065
						],
						[
							-81.74312705099993,
							30.245883122000066
						],
						[
							-81.74308790599991,
							30.24550500800007
						],
						[
							-81.7429839049999,
							30.244683008000038
						],
						[
							-81.7429584059999,
							30.244465508000076
						],
						[
							-81.74281890599991,
							30.24383700800007
						],
						[
							-81.74264990499995,
							30.243217009000034
						],
						[
							-81.74258290599994,
							30.242920009000045
						],
						[
							-81.74247290599995,
							30.24261400800009
						],
						[
							-81.74241790499991,
							30.242419008000066
						],
						[
							-81.7423979049999,
							30.24234900900007
						],
						[
							-81.74231190499995,
							30.242084008000067
						],
						[
							-81.74217790599994,
							30.24175700800004
						],
						[
							-81.74214690499991,
							30.241661008000055
						],
						[
							-81.74212090599991,
							30.241579009000077
						],
						[
							-81.7420794059999,
							30.241471509000068
						],
						[
							-81.74180290599992,
							30.240681008000077
						],
						[
							-81.74179490499995,
							30.240657009000078
						],
						[
							-81.74145590599994,
							30.23968800800009
						],
						[
							-81.74119290499993,
							30.238937008000054
						],
						[
							-81.74074190499994,
							30.237650009000053
						],
						[
							-81.74060090499995,
							30.23725000800005
						],
						[
							-81.74019890599993,
							30.236109009000078
						],
						[
							-81.74008590599993,
							30.23582200800007
						],
						[
							-81.74007190599991,
							30.23578100800006
						],
						[
							-81.74000590499993,
							30.23558200900004
						],
						[
							-81.73997890499993,
							30.235518008000046
						],
						[
							-81.73970190599994,
							30.23468100900004
						],
						[
							-81.73961990499993,
							30.234434008000054
						],
						[
							-81.73961190499995,
							30.234411008000052
						],
						[
							-81.73958390599995,
							30.234337008000068
						],
						[
							-81.73944248999993,
							30.23380746700008
						],
						[
							-81.73936190599994,
							30.233464008000052
						],
						[
							-81.7392879059999,
							30.233193008000057
						],
						[
							-81.73916690599992,
							30.232638009000087
						],
						[
							-81.73914690599992,
							30.232523008000047
						],
						[
							-81.73893190599995,
							30.231269009000073
						],
						[
							-81.73878390599992,
							30.230404008000054
						],
						[
							-81.7387469059999,
							30.23022200800006
						],
						[
							-81.73872490499991,
							30.23005400800008
						],
						[
							-81.73860090599993,
							30.229273008000064
						],
						[
							-81.73850990599993,
							30.228755009000057
						],
						[
							-81.73838090499993,
							30.228013009000048
						],
						[
							-81.73828790599993,
							30.22746500900007
						],
						[
							-81.73821990599993,
							30.22706200900007
						],
						[
							-81.73815990599991,
							30.22675100800007
						],
						[
							-81.73807790599994,
							30.22625800900005
						],
						[
							-81.73795290599992,
							30.22548400900007
						],
						[
							-81.73790690599992,
							30.22527000900004
						],
						[
							-81.73772390599993,
							30.224431008000067
						],
						[
							-81.73767290599994,
							30.22422300900007
						],
						[
							-81.73749390599994,
							30.223274009000075
						],
						[
							-81.73744190499991,
							30.22295300800005
						],
						[
							-81.73736790499993,
							30.22259100900004
						],
						[
							-81.73717190499991,
							30.221532009000047
						],
						[
							-81.73711499599995,
							30.221249994000065
						],
						[
							-81.73711090599994,
							30.221213008000063
						],
						[
							-81.7369929059999,
							30.22007700800009
						],
						[
							-81.7369929059999,
							30.219419008000045
						],
						[
							-81.7369929059999,
							30.21925300800007
						],
						[
							-81.7369928199999,
							30.21909699300005
						],
						[
							-81.73747290799992,
							30.219099011000086
						],
						[
							-81.73949390799993,
							30.21906701000006
						],
						[
							-81.73998290799994,
							30.219059011000073
						],
						[
							-81.74079890799993,
							30.219051010000044
						],
						[
							-81.74207290699991,
							30.21903201000004
						],
						[
							-81.74297090699991,
							30.219022010000064
						],
						[
							-81.74469790799992,
							30.219002010000054
						],
						[
							-81.74780990699992,
							30.218967010000085
						],
						[
							-81.7499309079999,
							30.21894501000008
						],
						[
							-81.75049490799995,
							30.218935010000056
						],
						[
							-81.7512819069999,
							30.21892201100008
						],
						[
							-81.75173990799993,
							30.21891801000004
						],
						[
							-81.75389090699991,
							30.21888801000006
						],
						[
							-81.75450090699991,
							30.21888901000006
						],
						[
							-81.76008590799995,
							30.21881101000008
						],
						[
							-81.76063490799993,
							30.21881501000007
						],
						[
							-81.76132990699995,
							30.21881601000007
						],
						[
							-81.76147490799991,
							30.218814011000063
						],
						[
							-81.76177598499993,
							30.218835954000046
						],
						[
							-81.7618259059999,
							30.219051008000065
						],
						[
							-81.76213790499992,
							30.220280008000092
						],
						[
							-81.76255790599993,
							30.222172008000086
						],
						[
							-81.76267190499993,
							30.222803009000078
						],
						[
							-81.76277890599994,
							30.223436009000068
						],
						[
							-81.76285590599991,
							30.224068009000067
						],
						[
							-81.76289390599993,
							30.22429100800008
						],
						[
							-81.76290890599996,
							30.224560009000072
						],
						[
							-81.76298490499994,
							30.22551000800007
						],
						[
							-81.76301590499992,
							30.22602100900008
						],
						[
							-81.7630239049999,
							30.22623500900005
						],
						[
							-81.76303390599992,
							30.226869009000044
						],
						[
							-81.76303390599992,
							30.227943008000068
						],
						[
							-81.76303390599992,
							30.228125009000053
						],
						[
							-81.76303290599992,
							30.22906800800007
						],
						[
							-81.76303790599991,
							30.230011008000076
						],
						[
							-81.76303490599992,
							30.230613008000034
						],
						[
							-81.7630429049999,
							30.230933008000076
						],
						[
							-81.76303790599991,
							30.231203008000083
						],
						[
							-81.7630429049999,
							30.232173008000075
						],
						[
							-81.76303590599991,
							30.233278008000067
						],
						[
							-81.7630399059999,
							30.23390200900008
						],
						[
							-81.76305890599991,
							30.236372008000043
						],
						[
							-81.76302890599993,
							30.238859009000066
						],
						[
							-81.7630307739999,
							30.240408142000035
						],
						[
							-81.76456703699995,
							30.240368142000083
						],
						[
							-81.7645719059999,
							30.240267009000036
						],
						[
							-81.76452590499991,
							30.236245009000076
						],
						[
							-81.76449790599992,
							30.234691008000084
						],
						[
							-81.76449777499994,
							30.23330387900006
						],
						[
							-81.76859290599992,
							30.23325200800008
						],
						[
							-81.7695079049999,
							30.23325200800008
						],
						[
							-81.77098590599991,
							30.233219009000038
						],
						[
							-81.77301590699996,
							30.233203953000046
						],
						[
							-81.77302890599992,
							30.233931008000066
						],
						[
							-81.77302390599993,
							30.23422800800006
						],
						[
							-81.7730379059999,
							30.23453300800009
						],
						[
							-81.7730429049999,
							30.235163008000086
						],
						[
							-81.77305690599991,
							30.235324009000063
						],
						[
							-81.77302590599993,
							30.236425009000072
						],
						[
							-81.77303590599992,
							30.238288008000044
						],
						[
							-81.77302890499993,
							30.240336008000043
						],
						[
							-81.77302190599994,
							30.240495009000085
						],
						[
							-81.77304590599994,
							30.243006008000066
						],
						[
							-81.7730389059999,
							30.243317008000076
						],
						[
							-81.77304790599993,
							30.24389100900004
						],
						[
							-81.77305190499993,
							30.244645008000077
						],
						[
							-81.77304390599994,
							30.245933008000062
						],
						[
							-81.77304590599994,
							30.24626500800008
						],
						[
							-81.77304990499994,
							30.247183008000036
						],
						[
							-81.77305190499993,
							30.248165009000044
						],
						[
							-81.77305090499995,
							30.24826500900008
						],
						[
							-81.77305195899993,
							30.248347007000064
						],
						[
							-81.77271290599992,
							30.248346008000055
						],
						[
							-81.77219890599991,
							30.248334008000086
						],
						[
							-81.77168090499993,
							30.248342008000066
						],
						[
							-81.77109890499992,
							30.248346008000055
						],
						[
							-81.77072490499995,
							30.248354008000035
						],
						[
							-81.77044790499991,
							30.24835200800004
						],
						[
							-81.76947690499992,
							30.248388008000063
						],
						[
							-81.7692779059999,
							30.248388008000063
						],
						[
							-81.7690329049999,
							30.248391008000056
						],
						[
							-81.76825590599992,
							30.248399008000035
						],
						[
							-81.7678179049999,
							30.248402008000088
						],
						[
							-81.76740090599992,
							30.24840900800007
						],
						[
							-81.76715990499991,
							30.248403008000086
						],
						[
							-81.76633090599995,
							30.248397009000083
						],
						[
							-81.76540190499992,
							30.248390008000058
						],
						[
							-81.76451190599994,
							30.248384008000073
						],
						[
							-81.76428990599993,
							30.24838100800008
						],
						[
							-81.76388590599993,
							30.24838100800008
						],
						[
							-81.76338090599995,
							30.248383008000076
						],
						[
							-81.76302590599994,
							30.248392008000053
						],
						[
							-81.76274090599992,
							30.248392008000053
						],
						[
							-81.76237690499994,
							30.248383008000076
						],
						[
							-81.76190190599993,
							30.248401009000073
						],
						[
							-81.7608248969999,
							30.248396060000065
						],
						[
							-81.76079190599995,
							30.248386008000068
						],
						[
							-81.76069592899995,
							30.248342878000074
						],
						[
							-81.76060490499992,
							30.248343008000063
						],
						[
							-81.76017790599991,
							30.248346008000055
						],
						[
							-81.75981890599991,
							30.248354008000035
						],
						[
							-81.75960477299992,
							30.248351874000036
						],
						[
							-81.75960502899994,
							30.248445144000076
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Oak Hill",
				"RegionID": "125500"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.40175753806216,
					27.94472500000033,
					-82.36716282332945,
					27.967600000000306
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-82.39461299999994,
								27.944867000000176
							],
							[
								-82.3947359999999,
								27.944852000000356
							],
							[
								-82.39458665281647,
								27.944875383195114
							],
							[
								-82.39461299999994,
								27.944867000000176
							]
						]
					],
					[
						[
							[
								-82.39714745882318,
								27.94505212755435
							],
							[
								-82.39675396661548,
								27.94495778146963
							],
							[
								-82.3967999999997,
								27.944959000000328
							],
							[
								-82.3969849999999,
								27.94497500000023
							],
							[
								-82.3970449999998,
								27.94498800000024
							],
							[
								-82.39707399999989,
								27.944998000000357
							],
							[
								-82.39714745882318,
								27.94505212755435
							]
						]
					],
					[
						[
							[
								-82.39793299999982,
								27.94514000000074
							],
							[
								-82.39789390557667,
								27.945137349531027
							],
							[
								-82.39802499999989,
								27.9451390000003
							],
							[
								-82.39811599999977,
								27.945135000000324
							],
							[
								-82.3982719999999,
								27.945129000000364
							],
							[
								-82.39851899999974,
								27.94511000000021
							],
							[
								-82.39879499999984,
								27.945073000000168
							],
							[
								-82.39894899999977,
								27.9450660000003
							],
							[
								-82.3991349999998,
								27.945072000000263
							],
							[
								-82.39928899999975,
								27.945086000000355
							],
							[
								-82.39930899999972,
								27.94509000000033
							],
							[
								-82.39938414901313,
								27.945105403214324
							],
							[
								-82.3992559999997,
								27.945097000000732
							],
							[
								-82.3987729999997,
								27.945104999999973
							],
							[
								-82.39817899999984,
								27.945143000000275
							],
							[
								-82.39793299999982,
								27.94514000000074
							]
						]
					],
					[
						[
							[
								-82.3998669999998,
								27.945122000000314
							],
							[
								-82.40070799999992,
								27.945096000000294
							],
							[
								-82.40102700513255,
								27.945098282684736
							],
							[
								-82.40022499999984,
								27.945143000000275
							],
							[
								-82.40011499999962,
								27.94514900000077
							],
							[
								-82.3999269999997,
								27.94514100000011
							],
							[
								-82.39971392644384,
								27.94512702796396
							],
							[
								-82.3998669999998,
								27.945122000000314
							]
						]
					],
					[
						[
							[
								-82.3808969999997,
								27.945678000000843
							],
							[
								-82.38083853453871,
								27.945554868195824
							],
							[
								-82.38109599999983,
								27.945700000000176
							],
							[
								-82.38124050425533,
								27.945794073240574
							],
							[
								-82.38102099999985,
								27.945788000000352
							],
							[
								-82.38096299999975,
								27.945751000000666
							],
							[
								-82.3808969999997,
								27.945678000000843
							]
						]
					],
					[
						[
							[
								-82.39025699999966,
								27.94587000000003
							],
							[
								-82.39021099999997,
								27.945862000000613
							],
							[
								-82.3902064881583,
								27.945862158310604
							],
							[
								-82.39021499999984,
								27.945853000000223
							],
							[
								-82.39027399999975,
								27.945835000000333
							],
							[
								-82.3902929999998,
								27.945846000000355
							],
							[
								-82.39031299999986,
								27.945867000000316
							],
							[
								-82.39035848387067,
								27.945939774193565
							],
							[
								-82.3903089999997,
								27.94589600000076
							],
							[
								-82.39025699999966,
								27.94587000000003
							]
						]
					],
					[
						[
							[
								-82.38182799999991,
								27.94628400000018
							],
							[
								-82.38174488744485,
								27.94620741460935
							],
							[
								-82.3818989458674,
								27.946328824889225
							],
							[
								-82.38182799999991,
								27.94628400000018
							]
						]
					],
					[
						[
							[
								-82.39072699999983,
								27.94633300000068
							],
							[
								-82.39070619844095,
								27.946319203047768
							],
							[
								-82.39071599999981,
								27.94632100000022
							],
							[
								-82.39077799999988,
								27.946324000000292
							],
							[
								-82.39083999999968,
								27.946317000000246
							],
							[
								-82.39089899999985,
								27.946301000000343
							],
							[
								-82.39113199999969,
								27.9462060000003
							],
							[
								-82.39158799999966,
								27.94605500000024
							],
							[
								-82.39181399999988,
								27.945966000000336
							],
							[
								-82.3920939999997,
								27.945848000000343
							],
							[
								-82.3922789999999,
								27.94578200000021
							],
							[
								-82.39246699999984,
								27.945714000000272
							],
							[
								-82.39269899999992,
								27.94563600000021
							],
							[
								-82.39281099999987,
								27.945588000000328
							],
							[
								-82.39301499999988,
								27.945464000000367
							],
							[
								-82.39312399999991,
								27.94541200000033
							],
							[
								-82.39327399999989,
								27.94525500000031
							],
							[
								-82.39328299999993,
								27.945231000000273
							],
							[
								-82.39328299999993,
								27.94520400000035
							],
							[
								-82.39326699999985,
								27.94512100000023
							],
							[
								-82.39322699999983,
								27.945078000000226
							],
							[
								-82.39314799999987,
								27.945032000000328
							],
							[
								-82.39313399999968,
								27.94500900000038
							],
							[
								-82.39313099999978,
								27.94498000000029
							],
							[
								-82.39313899999983,
								27.94495400000027
							],
							[
								-82.39318299999982,
								27.944912000000347
							],
							[
								-82.39319099999987,
								27.944888000000315
							],
							[
								-82.39317799999988,
								27.9448320000003
							],
							[
								-82.39314799999987,
								27.944752000000253
							],
							[
								-82.3931559999999,
								27.944729000000127
							],
							[
								-82.39318599999972,
								27.94472500000033
							],
							[
								-82.39331599999993,
								27.94488100000027
							],
							[
								-82.3934029999999,
								27.944960000000055
							],
							[
								-82.39351199999969,
								27.94504000000028
							],
							[
								-82.39370799999992,
								27.945079000000312
							],
							[
								-82.39395599999993,
								27.945081000000297
							],
							[
								-82.39399300288078,
								27.945087672650818
							],
							[
								-82.39389699999957,
								27.945104999999973
							],
							[
								-82.39369899999963,
								27.94510100000089
							],
							[
								-82.39365599999962,
								27.94511000000092
							],
							[
								-82.39349399999962,
								27.94514500000044
							],
							[
								-82.39341299999994,
								27.94517400000071
							],
							[
								-82.39328099999976,
								27.945270000000125
							],
							[
								-82.3931559999999,
								27.945430999999946
							],
							[
								-82.39303199999976,
								27.945533000000747
							],
							[
								-82.39288499999968,
								27.945629000000697
							],
							[
								-82.39242499999982,
								27.94581000000075
							],
							[
								-82.39112499999963,
								27.946321000000932
							],
							[
								-82.39103199999975,
								27.94637700000006
							],
							[
								-82.39084399999983,
								27.946366000000925
							],
							[
								-82.39072699999983,
								27.94633300000068
							]
						]
					],
					[
						[
							[
								-82.38218699999969,
								27.94653000000064
							],
							[
								-82.38214480159377,
								27.94649751633528
							],
							[
								-82.38220599999993,
								27.94653400000026
							],
							[
								-82.38226033333278,
								27.946561666666728
							],
							[
								-82.38218699999969,
								27.94653000000064
							]
						]
					],
					[
						[
							[
								-82.38979499999982,
								27.94564100000027
							],
							[
								-82.38980699999983,
								27.94561800000032
							],
							[
								-82.38983799999981,
								27.94562100000004
							],
							[
								-82.38985799999988,
								27.94564100000027
							],
							[
								-82.38986799999991,
								27.945667000000288
							],
							[
								-82.3900019999998,
								27.945916000000285
							],
							[
								-82.39002299999984,
								27.945935000000258
							],
							[
								-82.39004999999969,
								27.945949000000173
							],
							[
								-82.39007899999979,
								27.945957000000302
							],
							[
								-82.39006999999992,
								27.94598800000074
							],
							[
								-82.39005499999983,
								27.946043000000667
							],
							[
								-82.39006499999968,
								27.946129000000678
							],
							[
								-82.39014599999972,
								27.946309000000117
							],
							[
								-82.39015999999974,
								27.946394000000755
							],
							[
								-82.39013299999962,
								27.946600000000746
							],
							[
								-82.39001599999972,
								27.946796000000976
							],
							[
								-82.38994999999976,
								27.946816000000144
							],
							[
								-82.3899272615743,
								27.946805414871285
							],
							[
								-82.38993499999987,
								27.946801000000328
							],
							[
								-82.39000699999968,
								27.946749000000285
							],
							[
								-82.39006699999985,
								27.946686000000224
							],
							[
								-82.39009099999979,
								27.94663600000035
							],
							[
								-82.3901039999999,
								27.946582000000323
							],
							[
								-82.39010899999987,
								27.946472000000103
							],
							[
								-82.39009999999982,
								27.946390000000246
							],
							[
								-82.39006599999985,
								27.94628400000018
							],
							[
								-82.38997499999988,
								27.94607900000027
							],
							[
								-82.38989399999983,
								27.945928000000215
							],
							[
								-82.38986499999992,
								27.9458840000003
							],
							[
								-82.38979399999982,
								27.945778000000235
							],
							[
								-82.38978699999977,
								27.94575200000022
							],
							[
								-82.38978699999977,
								27.9456960000002
							],
							[
								-82.38979499999982,
								27.94564100000027
							]
						]
					],
					[
						[
							[
								-82.37672099999978,
								27.946594000000253
							],
							[
								-82.37677763986741,
								27.946499508123527
							],
							[
								-82.37642699999998,
								27.947216000000555
							],
							[
								-82.37640299999984,
								27.947257000000395
							],
							[
								-82.3763716713439,
								27.947311046512194
							],
							[
								-82.37645499999988,
								27.947119000000345
							],
							[
								-82.37658999999978,
								27.94684100000008
							],
							[
								-82.37672099999978,
								27.946594000000253
							]
						]
					],
					[
						[
							[
								-82.3885849999998,
								27.947400000000147
							],
							[
								-82.38861399999989,
								27.947373000000045
							],
							[
								-82.38864199999972,
								27.947358000000225
							],
							[
								-82.3887009999999,
								27.94735400000025
							],
							[
								-82.38873199999988,
								27.947356000000237
							],
							[
								-82.38879099999978,
								27.947371000000235
							],
							[
								-82.38881899999988,
								27.94738300000034
							],
							[
								-82.38884999999988,
								27.947385000000327
							],
							[
								-82.38894199999984,
								27.947374000000305
							],
							[
								-82.38905699999985,
								27.94731500000022
							],
							[
								-82.38912799999979,
								27.94726100000037
							],
							[
								-82.3892109999998,
								27.94718000000024
							],
							[
								-82.38929899999981,
								27.947067000000306
							],
							[
								-82.3893439999998,
								27.947029000000008
							],
							[
								-82.38940099999989,
								27.947009000000303
							],
							[
								-82.38952199999987,
								27.94698500000027
							],
							[
								-82.38955737966067,
								27.946973206780005
							],
							[
								-82.38957199999993,
								27.947044000000535
							],
							[
								-82.38957199999993,
								27.94710900000076
							],
							[
								-82.38953899999977,
								27.9471610000008
							],
							[
								-82.38945099999977,
								27.947256000000845
							],
							[
								-82.38927699999958,
								27.947310000000694
							],
							[
								-82.38866199999995,
								27.947551999999934
							],
							[
								-82.38855826945881,
								27.947602855294132
							],
							[
								-82.38856299999985,
								27.94759300000031
							],
							[
								-82.38857399999978,
								27.94753900000028
							],
							[
								-82.38857599999994,
								27.947484000000347
							],
							[
								-82.38857199999987,
								27.947429000000238
							],
							[
								-82.3885849999998,
								27.947400000000147
							]
						]
					],
					[
						[
							[
								-82.3870369999998,
								27.948332000000345
							],
							[
								-82.38730073881094,
								27.948226743694807
							],
							[
								-82.38712699999995,
								27.948307999999958
							],
							[
								-82.38701899999973,
								27.948354000000744
							],
							[
								-82.38697098978693,
								27.948360791689023
							],
							[
								-82.3870369999998,
								27.948332000000345
							]
						]
					],
					[
						[
							[
								-82.37610399999971,
								27.94774400000019
							],
							[
								-82.37618951843835,
								27.947625286904834
							],
							[
								-82.37606099999971,
								27.947847000000717
							],
							[
								-82.37595099999974,
								27.948096000000714
							],
							[
								-82.37589199999967,
								27.948264000000584
							],
							[
								-82.37583399999993,
								27.948389000000265
							],
							[
								-82.37573799999971,
								27.94849100000018
							],
							[
								-82.37567999999999,
								27.94851800000028
							],
							[
								-82.3756639999999,
								27.948524000000244
							],
							[
								-82.37568899999984,
								27.94850800000034
							],
							[
								-82.37572999999985,
								27.948467000000324
							],
							[
								-82.37579299999992,
								27.948374000000268
							],
							[
								-82.3758099999998,
								27.94834900000033
							],
							[
								-82.3758559999997,
								27.948247000000244
							],
							[
								-82.37590799999974,
								27.948118000000225
							],
							[
								-82.37603299999988,
								27.947866000000335
							],
							[
								-82.37610399999971,
								27.94774400000019
							]
						]
					],
					[
						[
							[
								-82.37200099999977,
								27.94966300000034
							],
							[
								-82.37206918152837,
								27.94961591424176
							],
							[
								-82.37197058007897,
								27.949688311232027
							],
							[
								-82.37200099999977,
								27.94966300000034
							]
						]
					],
					[
						[
							[
								-82.37099499999977,
								27.950524000000346
							],
							[
								-82.3711799999998,
								27.950336000000068
							],
							[
								-82.37113599999996,
								27.95038500000057
							],
							[
								-82.37111299999958,
								27.950410000000506
							],
							[
								-82.37103999999975,
								27.950488000000746
							],
							[
								-82.37085499999955,
								27.950686000000605
							],
							[
								-82.37068055114933,
								27.950887346250678
							],
							[
								-82.37070199999985,
								27.9508550000002
							],
							[
								-82.3708259999999,
								27.95069700000027
							],
							[
								-82.37099499999977,
								27.950524000000346
							]
						]
					],
					[
						[
							[
								-82.37039199999978,
								27.95142000000023
							],
							[
								-82.37049153358036,
								27.951211322700434
							],
							[
								-82.37015599999971,
								27.952157000000636
							],
							[
								-82.37012199999991,
								27.95225300000023
							],
							[
								-82.37008499999979,
								27.952358000000924
							],
							[
								-82.37003858843062,
								27.95248828789926
							],
							[
								-82.37006199999985,
								27.952384000000233
							],
							[
								-82.37013699999983,
								27.952125000000297
							],
							[
								-82.37016599999991,
								27.95204700000024
							],
							[
								-82.3702429999999,
								27.951896000000357
							],
							[
								-82.3702849999999,
								27.95176400000027
							],
							[
								-82.37034199999991,
								27.951550000000328
							],
							[
								-82.37039199999978,
								27.95142000000023
							]
						]
					],
					[
						[
							[
								-82.36898299999982,
								27.956317000000226
							],
							[
								-82.368998742443,
								27.956177445369082
							],
							[
								-82.36897699999967,
								27.956505000000856
							],
							[
								-82.36898399999981,
								27.95662400000022
							],
							[
								-82.36902299999984,
								27.95667500000071
							],
							[
								-82.36911499999972,
								27.956711000000848
							],
							[
								-82.36914699999953,
								27.9567500000007
							],
							[
								-82.36913299999979,
								27.95683100000083
							],
							[
								-82.36909599999967,
								27.956937000000718
							],
							[
								-82.36908296707524,
								27.956945354439103
							],
							[
								-82.36913899999968,
								27.956773000000293
							],
							[
								-82.3691189999999,
								27.956733000000007
							],
							[
								-82.36900999999992,
								27.956703000000363
							],
							[
								-82.36898499999973,
								27.956696000000317
							],
							[
								-82.36896699999991,
								27.956674000000096
							],
							[
								-82.36896399999993,
								27.95656400000023
							],
							[
								-82.36898299999982,
								27.956317000000226
							]
						]
					],
					[
						[
							[
								-82.3684569999999,
								27.95769600000028
							],
							[
								-82.36848668193832,
								27.95763749646937
							],
							[
								-82.36839888636449,
								27.957851607612586
							],
							[
								-82.3684159999999,
								27.957800000000358
							],
							[
								-82.3684569999999,
								27.95769600000028
							]
						]
					],
					[
						[
							[
								-82.36726899999985,
								27.961198000000312
							],
							[
								-82.36794342782268,
								27.959182558715515
							],
							[
								-82.36781699999972,
								27.95957800000021
							],
							[
								-82.36726799999967,
								27.961235000000176
							],
							[
								-82.36725763739655,
								27.961345287706433
							],
							[
								-82.36725699999992,
								27.961308000000354
							],
							[
								-82.36726899999985,
								27.961198000000312
							]
						]
					],
					[
						[
							[
								-82.36723999999984,
								27.962147000000318
							],
							[
								-82.36724271844656,
								27.96211166019386
							],
							[
								-82.36723976566098,
								27.962302114847507
							],
							[
								-82.36723699999986,
								27.96225700000036
							],
							[
								-82.36723999999984,
								27.962147000000318
							]
						]
					],
					[
						[
							[
								-82.36726899999985,
								27.96277900000003
							],
							[
								-82.36726687787612,
								27.962744382858876
							],
							[
								-82.36727099999983,
								27.96277100000061
							],
							[
								-82.36726899999985,
								27.96277900000003
							]
						]
					],
					[
						[
							[
								-82.36716899999992,
								27.965165000000272
							],
							[
								-82.36718918670299,
								27.965107713410223
							],
							[
								-82.36716282332945,
								27.96520240317061
							],
							[
								-82.36716899999992,
								27.965165000000272
							]
						]
					],
					[
						[
							[
								-82.36774795499666,
								27.967580459584088
							],
							[
								-82.36770795799976,
								27.966127259000935
							],
							[
								-82.36769213399987,
								27.964639761000246
							],
							[
								-82.3677554319995,
								27.96228191900038
							],
							[
								-82.36777125599984,
								27.96149069700046
							],
							[
								-82.36807192099967,
								27.960557054000574
							],
							[
								-82.36898973799984,
								27.957692830000905
							],
							[
								-82.369184818714,
								27.95683747733985
							],
							[
								-82.36919545599982,
								27.956790837000614
							],
							[
								-82.36949611999982,
								27.956142035000045
							],
							[
								-82.37003415199966,
								27.954828605999996
							],
							[
								-82.3706829539996,
								27.95262900800061
							],
							[
								-82.37085702299981,
								27.951901084000955
							],
							[
								-82.37107856499966,
								27.95139470200009
							],
							[
								-82.37150582499974,
								27.95096744200062
							],
							[
								-82.3722179249996,
								27.95038193700005
							],
							[
								-82.37291419999984,
								27.949780609000033
							],
							[
								-82.37394278899977,
								27.949290051000123
							],
							[
								-82.37498720199977,
								27.94910015700022
							],
							[
								-82.3756993019998,
								27.94905268400011
							],
							[
								-82.37623733299982,
								27.94887861500054
							],
							[
								-82.37644305099978,
								27.948688722000906
							],
							[
								-82.3769177839998,
								27.947850026000612
							],
							[
								-82.37734504399963,
								27.94691638400099
							],
							[
								-82.37783822499976,
								27.946379169001037
							],
							[
								-82.37797307099963,
								27.94629080200021
							],
							[
								-82.3780128579999,
								27.94626618400066
							],
							[
								-82.37827859899987,
								27.94611117400098
							],
							[
								-82.37842241399969,
								27.946043914000388
							],
							[
								-82.37847969999972,
								27.946025212000972
							],
							[
								-82.37865569999971,
								27.945974212000483
							],
							[
								-82.37876573799986,
								27.94594968400094
							],
							[
								-82.37908873799948,
								27.945898683000184
							],
							[
								-82.37922883999953,
								27.945888828001056
							],
							[
								-82.37967123799973,
								27.945871971000106
							],
							[
								-82.38046245999963,
								27.946188460000446
							],
							[
								-82.38144357499982,
								27.94678978900073
							],
							[
								-82.38272568099976,
								27.94755960100083
							],
							[
								-82.38404230199971,
								27.948428364000858
							],
							[
								-82.38406772199987,
								27.9484457680007
							],
							[
								-82.3845088979997,
								27.948759080000865
							],
							[
								-82.38479925699983,
								27.948882062000916
							],
							[
								-82.38522561699948,
								27.949036860000223
							],
							[
								-82.38601683899967,
								27.949131806000445
							],
							[
								-82.38679223699988,
								27.949115982000553
							],
							[
								-82.38756763499973,
								27.948894440000696
							],
							[
								-82.38834303299949,
								27.9485621260002
							],
							[
								-82.38926084999967,
								27.948087393000623
							],
							[
								-82.39061283599972,
								27.947466157000026
							],
							[
								-82.3910337139998,
								27.947280305000636
							],
							[
								-82.39123890599964,
								27.947185400000155
							],
							[
								-82.39226749499993,
								27.946726491000465
							],
							[
								-82.39377699699968,
								27.94607699600046
							],
							[
								-82.3939513759999,
								27.94599956400045
							],
							[
								-82.39435632099975,
								27.94571372700069
							],
							[
								-82.39494182499969,
								27.945697902000536
							],
							[
								-82.39593876499984,
								27.945697902000536
							],
							[
								-82.39748956099965,
								27.945729551000582
							],
							[
								-82.39921442499971,
								27.945824498
							],
							[
								-82.40086016699972,
								27.945951093000435
							],
							[
								-82.4016360919998,
								27.94581933200046
							],
							[
								-82.40161821299984,
								27.94675691000005
							],
							[
								-82.40161734499985,
								27.946802424000442
							],
							[
								-82.40150903784097,
								27.952481819973865
							],
							[
								-82.4014090921344,
								27.96540909012865
							],
							[
								-82.40175753806216,
								27.96712425491609
							],
							[
								-82.39351211299979,
								27.967109278000027
							],
							[
								-82.39350799999981,
								27.967319000000327
							],
							[
								-82.38934199999981,
								27.96738700000027
							],
							[
								-82.38736299999977,
								27.967322000000042
							],
							[
								-82.38533599999991,
								27.967272000000168
							],
							[
								-82.3838388349941,
								27.96721696515611
							],
							[
								-82.3812009999999,
								27.96712000000038
							],
							[
								-82.38035899999987,
								27.96708200000008
							],
							[
								-82.37964499999985,
								27.967173000000326
							],
							[
								-82.3782939999999,
								27.96715600000034
							],
							[
								-82.37641299999987,
								27.967318000000244
							],
							[
								-82.37593659700985,
								27.967330462385323
							],
							[
								-82.37557199999975,
								27.96734000000011
							],
							[
								-82.37457499999985,
								27.967420000000335
							],
							[
								-82.37300599999979,
								27.967522000000248
							],
							[
								-82.37234399999983,
								27.967522000000248
							],
							[
								-82.37164599999981,
								27.96752300000033
							],
							[
								-82.37094399999971,
								27.96752000000026
							],
							[
								-82.36991199999986,
								27.967554000000234
							],
							[
								-82.36858697699698,
								27.967599215918884
							],
							[
								-82.36856399999971,
								27.967600000000306
							],
							[
								-82.36774795499666,
								27.967580459584088
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "East Side Commercial Area",
				"RegionID": "125585"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.50595148213695,
					27.9084882452984,
					-82.48442684158906,
					27.930783812568755
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.48611821901261,
							27.92890001350588
						],
						[
							-82.48865454455623,
							27.925581819188615
						],
						[
							-82.49181818138962,
							27.92140000053068
						],
						[
							-82.49291814935823,
							27.919500075724486
						],
						[
							-82.49331818218599,
							27.91909999703129
						],
						[
							-82.49821818143012,
							27.911400000017778
						],
						[
							-82.50017531930517,
							27.90849987802882
						],
						[
							-82.50215521992018,
							27.9084882452984
						],
						[
							-82.5021400123846,
							27.910519984633755
						],
						[
							-82.5021200267511,
							27.913190027671973
						],
						[
							-82.5021200267511,
							27.913970015963258
						],
						[
							-82.50211003258542,
							27.914809965651465
						],
						[
							-82.50205999250907,
							27.91560002275218
						],
						[
							-82.5020200194435,
							27.916299992966593
						],
						[
							-82.5020200194435,
							27.916979974849575
						],
						[
							-82.50198532989494,
							27.919777192814564
						],
						[
							-82.50595148213695,
							27.91979814162196
						],
						[
							-82.5059512968767,
							27.922576516991825
						],
						[
							-82.50588778225833,
							27.92563047071178
						],
						[
							-82.50506061643271,
							27.92565167492661
						],
						[
							-82.50201254787615,
							27.92569067042908
						],
						[
							-82.50049089140528,
							27.925795781389283
						],
						[
							-82.4998032050304,
							27.925161245845707
						],
						[
							-82.49813803834746,
							27.92580617755188
						],
						[
							-82.49722497108024,
							27.925268691445766
						],
						[
							-82.49588209083565,
							27.92532257612382
						],
						[
							-82.4954493622561,
							27.92533980443593
						],
						[
							-82.49443187201008,
							27.92596730728117
						],
						[
							-82.49357259769012,
							27.925899864424274
						],
						[
							-82.49348813336516,
							27.930246925411183
						],
						[
							-82.48873820488743,
							27.9305327776162
						],
						[
							-82.4861057795903,
							27.93068612461272
						],
						[
							-82.48442684158906,
							27.930783812568755
						],
						[
							-82.48611821901261,
							27.92890001350588
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Palma Ceia",
				"RegionID": "125649"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.23372660599995,
					26.092528767000033,
					-80.21740591299994,
					26.106050158000073
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-80.23371129099996,
								26.105733821000058
							],
							[
								-80.21858475599998,
								26.10604440900005
							],
							[
								-80.21830477699996,
								26.106050158000073
							],
							[
								-80.21801924099998,
								26.101481593000074
							],
							[
								-80.21741134399997,
								26.09717958300007
							],
							[
								-80.21740591299994,
								26.097141149000038
							],
							[
								-80.21742848999997,
								26.09706535400005
							],
							[
								-80.21793221999998,
								26.095374263000053
							],
							[
								-80.21842367899995,
								26.093724364000025
							],
							[
								-80.21880941699999,
								26.092528767000033
							],
							[
								-80.22132759099998,
								26.093116302000055
							],
							[
								-80.22160303299995,
								26.093182781000053
							],
							[
								-80.22554959099995,
								26.09413530200004
							],
							[
								-80.22579034599994,
								26.094183611000062
							],
							[
								-80.22599357499996,
								26.09422439100007
							],
							[
								-80.23179099299995,
								26.09561006100006
							],
							[
								-80.23298524899997,
								26.09590307900004
							],
							[
								-80.23307523599993,
								26.09712151400004
							],
							[
								-80.23371129099996,
								26.105733821000058
							]
						]
					],
					[
						[
							[
								-80.23371129099996,
								26.105733821000058
							],
							[
								-80.23372660599995,
								26.105941189000077
							],
							[
								-80.23371711399994,
								26.10594137800007
							],
							[
								-80.23371129099996,
								26.105733821000058
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Plantation",
				"Name": "Plantation Isles",
				"RegionID": "125784"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.56797194899991,
					27.882323376000045,
					-82.50970715499994,
					27.894573291000086
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.53818443699993,
							27.894562290000067
						],
						[
							-82.53803583399991,
							27.894548659000066
						],
						[
							-82.53801211099994,
							27.89454414700009
						],
						[
							-82.53772311199992,
							27.89448514700007
						],
						[
							-82.53759541399995,
							27.894449086000066
						],
						[
							-82.5375377499999,
							27.894425810000087
						],
						[
							-82.5374074049999,
							27.89436787900007
						],
						[
							-82.5373164529999,
							27.894361761000084
						],
						[
							-82.53695848699994,
							27.89435511700009
						],
						[
							-82.53680577599994,
							27.894369691000065
						],
						[
							-82.53652292099991,
							27.894420726000078
						],
						[
							-82.53636915099993,
							27.89445098100009
						],
						[
							-82.53620854999991,
							27.89446631000004
						],
						[
							-82.53561327499995,
							27.894469316000084
						],
						[
							-82.53551961099993,
							27.894461327000045
						],
						[
							-82.53542574999994,
							27.894342291000044
						],
						[
							-82.5351002029999,
							27.893993490000074
						],
						[
							-82.5349529309999,
							27.89376870700005
						],
						[
							-82.53467388999991,
							27.89368344500008
						],
						[
							-82.53443360499995,
							27.89372220000007
						],
						[
							-82.53423207599991,
							27.893791960000044
						],
						[
							-82.53386777299994,
							27.893861721000068
						],
						[
							-82.53376331599992,
							27.89360062800006
						],
						[
							-82.53281819099993,
							27.89329994900004
						],
						[
							-82.52685454499994,
							27.893227273000036
						],
						[
							-82.52081818099992,
							27.89310000200004
						],
						[
							-82.51855453299993,
							27.893499990000066
						],
						[
							-82.50970715499994,
							27.89357034200009
						],
						[
							-82.51449999899997,
							27.88590000100004
						],
						[
							-82.51463636199992,
							27.885745455000063
						],
						[
							-82.5148635239999,
							27.885363489000042
						],
						[
							-82.51542728499993,
							27.885218008000038
						],
						[
							-82.51589999599992,
							27.885400003000086
						],
						[
							-82.51649992699993,
							27.885900161000052
						],
						[
							-82.51774545599994,
							27.88601818300009
						],
						[
							-82.5182999999999,
							27.886100133000074
						],
						[
							-82.51869999899992,
							27.88600000300005
						],
						[
							-82.5197748299999,
							27.88605298400006
						],
						[
							-82.52650009099996,
							27.886199836000063
						],
						[
							-82.52681809099994,
							27.886700165000036
						],
						[
							-82.54142053299995,
							27.886901814000055
						],
						[
							-82.5423606729999,
							27.887004992000072
						],
						[
							-82.54230946199993,
							27.887130275000064
						],
						[
							-82.54227976599992,
							27.887195397000085
						],
						[
							-82.5421772389999,
							27.887398392000083
						],
						[
							-82.54210464199991,
							27.88753954400005
						],
						[
							-82.54189586199993,
							27.888212365000072
						],
						[
							-82.5419181119999,
							27.88831662000007
						],
						[
							-82.54193311099993,
							27.888420619000048
						],
						[
							-82.5419423219999,
							27.88854900000007
						],
						[
							-82.54193351099991,
							27.888674580000043
						],
						[
							-82.54192251099994,
							27.888752580000073
						],
						[
							-82.54190817199992,
							27.88882971600009
						],
						[
							-82.54188717099993,
							27.88890531000004
						],
						[
							-82.54185966999995,
							27.888978790000067
						],
						[
							-82.5418258759999,
							27.889049596000064
						],
						[
							-82.54190097799994,
							27.889075794000064
						],
						[
							-82.54197361399991,
							27.88910820500007
						],
						[
							-82.54204327299993,
							27.88914660200004
						],
						[
							-82.54211727299992,
							27.88919160200004
						],
						[
							-82.54222807299993,
							27.889271079000082
						],
						[
							-82.54230304799995,
							27.889341689000048
						],
						[
							-82.54239870299995,
							27.889442718000055
						],
						[
							-82.54440549899994,
							27.888878839000085
						],
						[
							-82.54941246499995,
							27.887444131000052
						],
						[
							-82.5527450319999,
							27.886499125000057
						],
						[
							-82.55441712899994,
							27.886034910000035
						],
						[
							-82.55502910199993,
							27.885873613000058
						],
						[
							-82.56673414099993,
							27.88265228100005
						],
						[
							-82.56741201199992,
							27.882444990000067
						],
						[
							-82.56744600899992,
							27.88243532000007
						],
						[
							-82.56778536799993,
							27.88234596500007
						],
						[
							-82.56785894299992,
							27.882323376000045
						],
						[
							-82.56789717599992,
							27.88324650000004
						],
						[
							-82.56790345999991,
							27.883398225000064
						],
						[
							-82.56791599999991,
							27.883701000000087
						],
						[
							-82.56793499999992,
							27.883890000000065
						],
						[
							-82.56797194899991,
							27.884314629000073
						],
						[
							-82.56794907599993,
							27.884321248000052
						],
						[
							-82.56732409199992,
							27.884516433000048
						],
						[
							-82.5672941599999,
							27.884525214000064
						],
						[
							-82.55551772099994,
							27.88775933400007
						],
						[
							-82.55384441899992,
							27.888217049000048
						],
						[
							-82.5524041889999,
							27.888629352000066
						],
						[
							-82.5509692629999,
							27.889017570000078
						],
						[
							-82.54953962899992,
							27.889437817000044
						],
						[
							-82.54951973599992,
							27.889443417000052
						],
						[
							-82.5480832639999,
							27.889830045000053
						],
						[
							-82.54518568999993,
							27.89070031300008
						],
						[
							-82.54516254399994,
							27.890706928000043
						],
						[
							-82.5438148689999,
							27.89107266900004
						],
						[
							-82.54325042799991,
							27.89123753800004
						],
						[
							-82.54315357199994,
							27.891425661000085
						],
						[
							-82.54307391499992,
							27.891553003000073
						],
						[
							-82.54305714499992,
							27.89171402800008
						],
						[
							-82.54302863099991,
							27.891869890000066
						],
						[
							-82.54301527699995,
							27.891937951000045
						],
						[
							-82.54299573199995,
							27.892004499000052
						],
						[
							-82.54297016099991,
							27.89206897200006
						],
						[
							-82.54293878099992,
							27.892130826000084
						],
						[
							-82.54290185499991,
							27.892189538000082
						],
						[
							-82.54294623699991,
							27.892251178000038
						],
						[
							-82.54298492399994,
							27.89231654200006
						],
						[
							-82.5430176079999,
							27.892385105000074
						],
						[
							-82.54304402499992,
							27.892456318000086
						],
						[
							-82.54306302599991,
							27.89251531800005
						],
						[
							-82.54308182699992,
							27.892582533000052
						],
						[
							-82.54309535899995,
							27.892651004000072
						],
						[
							-82.54310353999995,
							27.892720317000055
						],
						[
							-82.54310632199991,
							27.89279005700007
						],
						[
							-82.54310368699993,
							27.89285980200009
						],
						[
							-82.54309565099993,
							27.892929133000052
						],
						[
							-82.54303415499993,
							27.89332414900008
						],
						[
							-82.54299714199993,
							27.893470324000077
						],
						[
							-82.54293814199991,
							27.893641324000043
						],
						[
							-82.54287949199994,
							27.893774990000054
						],
						[
							-82.54279749199992,
							27.893926990000068
						],
						[
							-82.54275942999993,
							27.89399104200004
						],
						[
							-82.54271619699995,
							27.894051724000064
						],
						[
							-82.54266808999995,
							27.894108619000065
						],
						[
							-82.54261543799993,
							27.89416133600008
						],
						[
							-82.54255860199993,
							27.89420951400007
						],
						[
							-82.5424546019999,
							27.89429051400009
						],
						[
							-82.54235166099996,
							27.894359835000046
						],
						[
							-82.5422478939999,
							27.89441114300007
						],
						[
							-82.54210389499991,
							27.89447114300009
						],
						[
							-82.5419904819999,
							27.89450975300008
						],
						[
							-82.54191948099992,
							27.89452875300009
						],
						[
							-82.54184316499993,
							27.894545659000073
						],
						[
							-82.54171959799993,
							27.894558731000075
						],
						[
							-82.5415265979999,
							27.894565731000057
						],
						[
							-82.54145196999991,
							27.894565339000053
						],
						[
							-82.54130567199991,
							27.894558495000073
						],
						[
							-82.53949991799993,
							27.894573291000086
						],
						[
							-82.53818443699993,
							27.894562290000067
						]
					],
					[
						[
							-82.53525260599993,
							27.889790726000058
						],
						[
							-82.53522333299992,
							27.88979009700006
						],
						[
							-82.53514196099991,
							27.889796620000084
						],
						[
							-82.53516137499992,
							27.89011112900005
						],
						[
							-82.53516514499997,
							27.89013203500008
						],
						[
							-82.53520180899994,
							27.89025496800008
						],
						[
							-82.53522565999992,
							27.890355835000037
						],
						[
							-82.53523881899993,
							27.890481916000056
						],
						[
							-82.53524409599993,
							27.890639570000076
						],
						[
							-82.53535719099995,
							27.890607530000068
						],
						[
							-82.53607831799992,
							27.890411121000056
						],
						[
							-82.53525260599993,
							27.889790726000058
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Rattlesnake",
				"RegionID": "125884"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.52361899999994,
					27.27662600000008,
					-82.50582599999996,
					27.298847000000023
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.50659599999994,
							27.28224300000005
						],
						[
							-82.50654899999995,
							27.282183000000032
						],
						[
							-82.50623399999995,
							27.28182400000003
						],
						[
							-82.50592399999994,
							27.28150000000005
						],
						[
							-82.50587699999994,
							27.281442000000027
						],
						[
							-82.50585399999994,
							27.281378000000075
						],
						[
							-82.50584599999996,
							27.28131200000007
						],
						[
							-82.50586099999998,
							27.28123800000003
						],
						[
							-82.50587499999995,
							27.281060000000025
						],
						[
							-82.50589299999996,
							27.28097400000007
						],
						[
							-82.50588899999997,
							27.28088400000007
						],
						[
							-82.50589999999994,
							27.280813000000023
						],
						[
							-82.50594399999994,
							27.28073600000005
						],
						[
							-82.50594199999995,
							27.280651000000034
						],
						[
							-82.50592699999999,
							27.280605000000037
						],
						[
							-82.50590999999997,
							27.28048700000005
						],
						[
							-82.50585199999995,
							27.280349000000058
						],
						[
							-82.50583299999994,
							27.28032200000007
						],
						[
							-82.50582599999996,
							27.280296000000078
						],
						[
							-82.50584099999998,
							27.279647000000068
						],
						[
							-82.50584599999996,
							27.278912000000048
						],
						[
							-82.50584399999997,
							27.278158000000076
						],
						[
							-82.50585099999995,
							27.27741100000003
						],
						[
							-82.50585899999999,
							27.276661000000047
						],
						[
							-82.50608399999999,
							27.27665700000006
						],
						[
							-82.50672199999997,
							27.27666400000004
						],
						[
							-82.50780199999997,
							27.276672000000076
						],
						[
							-82.50855899999993,
							27.27668200000005
						],
						[
							-82.50920499999995,
							27.276683000000048
						],
						[
							-82.50934999999998,
							27.27668000000006
						],
						[
							-82.50952299999994,
							27.27668600000004
						],
						[
							-82.51100399999996,
							27.276693000000023
						],
						[
							-82.51204099999995,
							27.276703000000058
						],
						[
							-82.51299899999998,
							27.27670900000004
						],
						[
							-82.51323299999996,
							27.276728000000052
						],
						[
							-82.51395799999995,
							27.276736000000028
						],
						[
							-82.51415599999996,
							27.276726000000053
						],
						[
							-82.51435399999997,
							27.276715000000024
						],
						[
							-82.51461199999994,
							27.27671900000007
						],
						[
							-82.51496799999995,
							27.276717000000076
						],
						[
							-82.51571699999994,
							27.276714000000027
						],
						[
							-82.51646899999997,
							27.276711000000034
						],
						[
							-82.51707799999997,
							27.276710000000037
						],
						[
							-82.51725599999997,
							27.27671600000008
						],
						[
							-82.51794399999994,
							27.276725000000056
						],
						[
							-82.52073099999996,
							27.276728000000052
						],
						[
							-82.52231999999998,
							27.276745000000062
						],
						[
							-82.52236699999997,
							27.276726000000053
						],
						[
							-82.52326299999999,
							27.276633000000064
						],
						[
							-82.52361899999994,
							27.27662600000008
						],
						[
							-82.52347899999997,
							27.276766000000066
						],
						[
							-82.52284199999997,
							27.277400000000057
						],
						[
							-82.52167299999996,
							27.278296000000072
						],
						[
							-82.52242999999999,
							27.281053000000043
						],
						[
							-82.52191399999998,
							27.28258500000004
						],
						[
							-82.52154899999994,
							27.283224000000075
						],
						[
							-82.52158899999995,
							27.283334000000025
						],
						[
							-82.52157999999997,
							27.28339600000004
						],
						[
							-82.52157999999997,
							27.283554000000038
						],
						[
							-82.52158599999996,
							27.283608000000072
						],
						[
							-82.52161299999995,
							27.28367600000007
						],
						[
							-82.52163999999993,
							27.283709000000044
						],
						[
							-82.52162799999996,
							27.283890000000042
						],
						[
							-82.52170899999999,
							27.28420400000005
						],
						[
							-82.52173099999999,
							27.284289000000058
						],
						[
							-82.52182099999999,
							27.28438200000005
						],
						[
							-82.52200299999998,
							27.284571000000028
						],
						[
							-82.52221699999996,
							27.285123000000056
						],
						[
							-82.52209699999997,
							27.28510200000005
						],
						[
							-82.52189299999998,
							27.285198000000037
						],
						[
							-82.521981,
							27.285187000000068
						],
						[
							-82.52201199999996,
							27.285192000000052
						],
						[
							-82.52205299999997,
							27.285210000000067
						],
						[
							-82.52202799999999,
							27.285280000000057
						],
						[
							-82.52188399999994,
							27.28557900000004
						],
						[
							-82.52170699999994,
							27.285968000000025
						],
						[
							-82.52164699999997,
							27.28613000000007
						],
						[
							-82.52157099999994,
							27.28631800000005
						],
						[
							-82.52155799999997,
							27.28636300000005
						],
						[
							-82.52155099999999,
							27.286414000000036
						],
						[
							-82.52154899999994,
							27.286555000000078
						],
						[
							-82.52156099999998,
							27.286815000000047
						],
						[
							-82.52159099999994,
							27.287123000000065
						],
						[
							-82.52162099999998,
							27.287235000000067
						],
						[
							-82.52177799999998,
							27.287222000000042
						],
						[
							-82.52180799999996,
							27.28761300000008
						],
						[
							-82.52174299999996,
							27.28769200000005
						],
						[
							-82.52179399999996,
							27.287922000000037
						],
						[
							-82.52180999999996,
							27.288027000000056
						],
						[
							-82.52180999999996,
							27.288122000000044
						],
						[
							-82.52179599999995,
							27.28816000000006
						],
						[
							-82.52177399999994,
							27.288184000000058
						],
						[
							-82.52174399999996,
							27.288198000000023
						],
						[
							-82.52164399999998,
							27.288208000000054
						],
						[
							-82.52153799999996,
							27.288208000000054
						],
						[
							-82.52127899999994,
							27.288198000000023
						],
						[
							-82.52104299999998,
							27.288182000000063
						],
						[
							-82.52099299999998,
							27.288185000000055
						],
						[
							-82.52092199999998,
							27.288204000000064
						],
						[
							-82.52088399999997,
							27.288226000000066
						],
						[
							-82.52079099999997,
							27.28832200000005
						],
						[
							-82.52070299999997,
							27.288434000000052
						],
						[
							-82.52054199999998,
							27.288656000000064
						],
						[
							-82.52049899999997,
							27.288728000000052
						],
						[
							-82.52047099999999,
							27.288792000000058
						],
						[
							-82.52045999999996,
							27.288828000000024
						],
						[
							-82.52045499999997,
							27.288880000000063
						],
						[
							-82.52046499999994,
							27.288906000000054
						],
						[
							-82.52048699999995,
							27.28891100000004
						],
						[
							-82.52052299999997,
							27.28889900000007
						],
						[
							-82.52056499999998,
							27.28887100000003
						],
						[
							-82.52059299999996,
							27.288844000000044
						],
						[
							-82.52065299999998,
							27.288756000000035
						],
						[
							-82.52066399999995,
							27.28866000000005
						],
						[
							-82.52066999999995,
							27.28864100000004
						],
						[
							-82.52068699999995,
							27.288617000000045
						],
						[
							-82.52076899999997,
							27.28855200000004
						],
						[
							-82.52084399999995,
							27.28843500000005
						],
						[
							-82.52089099999995,
							27.288335000000075
						],
						[
							-82.52091499999995,
							27.288295000000062
						],
						[
							-82.52094299999999,
							27.288276000000053
						],
						[
							-82.52099399999999,
							27.288265000000024
						],
						[
							-82.52129299999996,
							27.288265000000024
						],
						[
							-82.52140499999996,
							27.288274000000058
						],
						[
							-82.52161599999994,
							27.288310000000024
						],
						[
							-82.52176799999995,
							27.28832600000004
						],
						[
							-82.52181499999995,
							27.288316000000066
						],
						[
							-82.52183699999995,
							27.28830300000004
						],
						[
							-82.52185799999995,
							27.288272000000063
						],
						[
							-82.52186999999998,
							27.28821400000004
						],
						[
							-82.52187699999996,
							27.28798500000005
						],
						[
							-82.52185899999995,
							27.287843000000066
						],
						[
							-82.52188299999995,
							27.287829000000045
						],
						[
							-82.52191099999999,
							27.28783500000003
						],
						[
							-82.52193999999997,
							27.287862000000075
						],
						[
							-82.52196099999998,
							27.28789900000004
						],
						[
							-82.52197299999995,
							27.287942000000044
						],
						[
							-82.52200499999998,
							27.28812000000005
						],
						[
							-82.52200599999998,
							27.288194000000033
						],
						[
							-82.52199599999994,
							27.288261000000034
						],
						[
							-82.52198599999997,
							27.288293000000067
						],
						[
							-82.52178899999996,
							27.28868600000004
						],
						[
							-82.52171099999998,
							27.289219000000063
						],
						[
							-82.52093699999995,
							27.292121000000066
						],
						[
							-82.52078199999994,
							27.292834000000028
						],
						[
							-82.52075499999995,
							27.293229000000053
						],
						[
							-82.52078699999998,
							27.293871000000024
						],
						[
							-82.52068299999996,
							27.294040000000052
						],
						[
							-82.52050299999996,
							27.294044000000042
						],
						[
							-82.52049699999998,
							27.29405500000007
						],
						[
							-82.52047699999997,
							27.294081000000062
						],
						[
							-82.52040799999997,
							27.29413900000003
						],
						[
							-82.52017799999999,
							27.294347000000073
						],
						[
							-82.52008799999999,
							27.294412000000023
						],
						[
							-82.52002199999998,
							27.294471000000044
						],
						[
							-82.51990099999995,
							27.294616000000076
						],
						[
							-82.51982499999998,
							27.294670000000053
						],
						[
							-82.51973299999997,
							27.29480200000006
						],
						[
							-82.51969399999996,
							27.29487800000004
						],
						[
							-82.51963099999995,
							27.294951000000026
						],
						[
							-82.51960699999995,
							27.29498700000005
						],
						[
							-82.51958699999994,
							27.29505600000005
						],
						[
							-82.51986999999998,
							27.29565800000006
						],
						[
							-82.52055799999994,
							27.296234000000027
						],
						[
							-82.52047199999998,
							27.296344000000037
						],
						[
							-82.52047099999999,
							27.29640900000004
						],
						[
							-82.52046199999995,
							27.296447000000057
						],
						[
							-82.52044799999999,
							27.296482000000026
						],
						[
							-82.52039499999995,
							27.296561000000054
						],
						[
							-82.52035899999998,
							27.29660100000007
						],
						[
							-82.52025899999995,
							27.29669000000007
						],
						[
							-82.52019299999995,
							27.296740000000057
						],
						[
							-82.52016299999997,
							27.296828000000062
						],
						[
							-82.51960299999996,
							27.297147000000052
						],
						[
							-82.51929899999999,
							27.29758400000003
						],
						[
							-82.51930999999996,
							27.297826000000043
						],
						[
							-82.51923299999999,
							27.297897000000034
						],
						[
							-82.51920299999995,
							27.29795800000005
						],
						[
							-82.51915499999996,
							27.29803000000004
						],
						[
							-82.51907599999998,
							27.298102000000032
						],
						[
							-82.51902899999999,
							27.298159000000055
						],
						[
							-82.51904899999994,
							27.298316000000057
						],
						[
							-82.51873499999994,
							27.29871000000003
						],
						[
							-82.51863199999997,
							27.298839000000044
						],
						[
							-82.51854099999997,
							27.298839000000044
						],
						[
							-82.51848099999995,
							27.298847000000023
						],
						[
							-82.51837099999996,
							27.298847000000023
						],
						[
							-82.51832999999993,
							27.29883700000005
						],
						[
							-82.51786099999998,
							27.298834000000056
						],
						[
							-82.51718699999998,
							27.298834000000056
						],
						[
							-82.51589899999999,
							27.298835000000054
						],
						[
							-82.51417199999997,
							27.29883300000006
						],
						[
							-82.51311599999997,
							27.298834000000056
						],
						[
							-82.51208899999995,
							27.298824000000025
						],
						[
							-82.51185499999998,
							27.29882600000008
						],
						[
							-82.51107899999994,
							27.298823000000027
						],
						[
							-82.51050099999998,
							27.298821000000032
						],
						[
							-82.51001599999995,
							27.29882200000003
						],
						[
							-82.50897899999995,
							27.29881800000004
						],
						[
							-82.50793299999998,
							27.29881400000005
						],
						[
							-82.50586699999997,
							27.298809000000062
						],
						[
							-82.50586599999997,
							27.29812700000008
						],
						[
							-82.50585999999998,
							27.29514000000006
						],
						[
							-82.50585799999999,
							27.295074000000056
						],
						[
							-82.50586099999998,
							27.29414900000006
						],
						[
							-82.50586299999998,
							27.29332500000004
						],
						[
							-82.50585799999999,
							27.291612000000043
						],
						[
							-82.50586199999998,
							27.29148200000003
						],
						[
							-82.50586599999997,
							27.291349000000025
						],
						[
							-82.50585499999994,
							27.290197000000035
						],
						[
							-82.50585599999995,
							27.289612000000034
						],
						[
							-82.50584899999996,
							27.287885000000074
						],
						[
							-82.50585299999995,
							27.287829000000045
						],
						[
							-82.50585199999995,
							27.28773700000005
						],
						[
							-82.50584899999996,
							27.286033000000035
						],
						[
							-82.50585699999993,
							27.285997000000066
						],
						[
							-82.50586499999997,
							27.285980000000052
						],
						[
							-82.50594699999994,
							27.285953000000063
						],
						[
							-82.50623199999995,
							27.285948000000076
						],
						[
							-82.50671499999999,
							27.285965000000033
						],
						[
							-82.50672599999996,
							27.285908000000063
						],
						[
							-82.50629199999997,
							27.285922000000028
						],
						[
							-82.50597999999997,
							27.28593600000005
						],
						[
							-82.50596799999994,
							27.28588700000006
						],
						[
							-82.50584799999996,
							27.28571900000003
						],
						[
							-82.50584499999997,
							27.284637000000032
						],
						[
							-82.50584699999996,
							27.28436400000004
						],
						[
							-82.50583399999994,
							27.284208000000035
						],
						[
							-82.50585399999994,
							27.28157600000003
						],
						[
							-82.50585499999994,
							27.281466000000023
						],
						[
							-82.50589799999995,
							27.281499000000053
						],
						[
							-82.50594199999995,
							27.281548000000043
						],
						[
							-82.50615699999997,
							27.281780000000026
						],
						[
							-82.50650899999994,
							27.282174000000055
						],
						[
							-82.50659599999994,
							27.28224300000005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Ridge Wood Heights",
				"RegionID": "125917"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.19266899999991,
					26.150441000000058,
					-80.16530199999994,
					26.158606000000077
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.16530199999994,
							26.158606000000077
						],
						[
							-80.1657967889999,
							26.15739916600006
						],
						[
							-80.16683699999993,
							26.154862000000037
						],
						[
							-80.16852203699995,
							26.151323613000045
						],
						[
							-80.16881980599993,
							26.15131798300007
						],
						[
							-80.17058642599994,
							26.15128693700007
						],
						[
							-80.17110920099992,
							26.15127291600004
						],
						[
							-80.17371606699993,
							26.15119780400005
						],
						[
							-80.17455330899992,
							26.151192798000068
						],
						[
							-80.17502601099994,
							26.15117877600005
						],
						[
							-80.17806151299993,
							26.151093650000064
						],
						[
							-80.17871047499995,
							26.151075623000054
						],
						[
							-80.18034389799993,
							26.15101653700009
						],
						[
							-80.18084664199995,
							26.15099450300005
						],
						[
							-80.18277750599992,
							26.150921396000058
						],
						[
							-80.18431077999992,
							26.150858301000085
						],
						[
							-80.18596423199995,
							26.150790200000074
						],
						[
							-80.18672950099995,
							26.150771300000088
						],
						[
							-80.1867213829999,
							26.150484988000073
						],
						[
							-80.18672146299993,
							26.150462359000073
						],
						[
							-80.18824399999994,
							26.150456000000077
						],
						[
							-80.18871799999994,
							26.15047100000004
						],
						[
							-80.19161099999991,
							26.150441000000058
						],
						[
							-80.19259199999993,
							26.150456000000077
						],
						[
							-80.19247799999994,
							26.151819000000046
						],
						[
							-80.19266899999991,
							26.152762000000052
						],
						[
							-80.18995599999994,
							26.15275700000007
						],
						[
							-80.18914599999994,
							26.15275700000007
						],
						[
							-80.18666799999994,
							26.152862000000084
						],
						[
							-80.18676899999993,
							26.155863000000068
						],
						[
							-80.18676799999992,
							26.157962000000058
						],
						[
							-80.18676799999992,
							26.158067000000074
						],
						[
							-80.18556799999993,
							26.158062000000086
						],
						[
							-80.18516799999992,
							26.158062000000086
						],
						[
							-80.18497799999994,
							26.158062000000086
						],
						[
							-80.18498099999994,
							26.158209000000056
						],
						[
							-80.1820679999999,
							26.158197000000087
						],
						[
							-80.18187299999994,
							26.158202000000074
						],
						[
							-80.17837099999991,
							26.15829700000006
						],
						[
							-80.17795099999995,
							26.158313000000078
						],
						[
							-80.17795699999994,
							26.15816200000006
						],
						[
							-80.17736799999994,
							26.15816200000006
						],
						[
							-80.17547999999994,
							26.15829300000007
						],
						[
							-80.17426399999994,
							26.158377000000087
						],
						[
							-80.17066799999992,
							26.158362000000068
						],
						[
							-80.1683549999999,
							26.158468000000084
						],
						[
							-80.16533076199994,
							26.15860470000007
						],
						[
							-80.16530199999994,
							26.158606000000077
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Rock Island",
				"RegionID": "125953"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.52579690099992,
					30.25120401200007,
					-81.47523892299995,
					30.287392066000052
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.4886859099999,
							30.287048012000074
						],
						[
							-81.48872391099991,
							30.286804013000054
						],
						[
							-81.4887589089999,
							30.286698012000045
						],
						[
							-81.48882291099994,
							30.28650101100004
						],
						[
							-81.4890669099999,
							30.28604701200004
						],
						[
							-81.4900430969999,
							30.284290044000045
						],
						[
							-81.48931190999991,
							30.280603012000086
						],
						[
							-81.48919990999991,
							30.280037012000037
						],
						[
							-81.48905203299995,
							30.278484967000054
						],
						[
							-81.48876578599993,
							30.278067057000047
						],
						[
							-81.48868890799992,
							30.277422011000052
						],
						[
							-81.48787890799991,
							30.275108012000086
						],
						[
							-81.4856310269999,
							30.271158869000093
						],
						[
							-81.48371990999993,
							30.27058201200009
						],
						[
							-81.48318784399993,
							30.27041012700005
						],
						[
							-81.47881690899993,
							30.266273012000056
						],
						[
							-81.47796775599994,
							30.265469094000082
						],
						[
							-81.47786290899997,
							30.264765012000055
						],
						[
							-81.47671990999994,
							30.257118012000035
						],
						[
							-81.47662590999995,
							30.256536012000087
						],
						[
							-81.47651490999993,
							30.255852012000048
						],
						[
							-81.47636590899994,
							30.254934013000078
						],
						[
							-81.47564090999992,
							30.252703012000037
						],
						[
							-81.47523892299995,
							30.251464922000082
						],
						[
							-81.47876690999993,
							30.251392013000043
						],
						[
							-81.4793859099999,
							30.25138301200008
						],
						[
							-81.48104090899994,
							30.251360012000077
						],
						[
							-81.48235290999992,
							30.251335012000087
						],
						[
							-81.48402390899992,
							30.25130301200005
						],
						[
							-81.48408090899994,
							30.251302012000053
						],
						[
							-81.48717190999992,
							30.251250012000067
						],
						[
							-81.49027990999991,
							30.25120401200007
						],
						[
							-81.49069190999991,
							30.25121301200005
						],
						[
							-81.49133290899994,
							30.25124901200007
						],
						[
							-81.49169890999991,
							30.251278013000043
						],
						[
							-81.49200390899995,
							30.251312013000078
						],
						[
							-81.49226190999991,
							30.251350013000035
						],
						[
							-81.49250790899993,
							30.25137601200004
						],
						[
							-81.49276190899991,
							30.251404013000073
						],
						[
							-81.4933019099999,
							30.251500013000058
						],
						[
							-81.49499290999995,
							30.25176401300007
						],
						[
							-81.49759901899995,
							30.252230063000074
						],
						[
							-81.49752094599995,
							30.25216393800008
						],
						[
							-81.49599380499991,
							30.25184816100005
						],
						[
							-81.49594878399995,
							30.251773925000066
						],
						[
							-81.49662495599995,
							30.251885887000075
						],
						[
							-81.49674991099994,
							30.251958010000067
						],
						[
							-81.49834090899992,
							30.25228001200008
						],
						[
							-81.49841194599992,
							30.252293938000037
						],
						[
							-81.49851587599994,
							30.252384086000063
						],
						[
							-81.49913288599993,
							30.252487061000068
						],
						[
							-81.50507490799993,
							30.253457011000084
						],
						[
							-81.50557990699991,
							30.253541010000045
						],
						[
							-81.5063519069999,
							30.25365701000004
						],
						[
							-81.5067109069999,
							30.25371201100006
						],
						[
							-81.50711490799995,
							30.25378601100005
						],
						[
							-81.50743590799993,
							30.25382501100006
						],
						[
							-81.50761890799993,
							30.253844011000066
						],
						[
							-81.50797690699994,
							30.253886010000087
						],
						[
							-81.50845490799992,
							30.253913010000073
						],
						[
							-81.50878290799994,
							30.253932010000085
						],
						[
							-81.50911190699992,
							30.253950010000043
						],
						[
							-81.5094089079999,
							30.253950010000043
						],
						[
							-81.50971090699994,
							30.253948011000034
						],
						[
							-81.50980190799994,
							30.25395401000009
						],
						[
							-81.50988690799994,
							30.25395401000009
						],
						[
							-81.50998190799993,
							30.253963010000064
						],
						[
							-81.51093490799991,
							30.253922011000043
						],
						[
							-81.5112579069999,
							30.253900010000056
						],
						[
							-81.51187490799992,
							30.253845011000063
						],
						[
							-81.51250490699994,
							30.25376801100009
						],
						[
							-81.51293790799991,
							30.253704010000035
						],
						[
							-81.51337790699995,
							30.25363001100004
						],
						[
							-81.51373890799995,
							30.253566010000043
						],
						[
							-81.5145839079999,
							30.25338101100004
						],
						[
							-81.51493890699993,
							30.25332301100008
						],
						[
							-81.51614890699996,
							30.253103011000064
						],
						[
							-81.51632590699995,
							30.253067953000087
						],
						[
							-81.51650090699991,
							30.253684010000086
						],
						[
							-81.51679390699991,
							30.25475001000007
						],
						[
							-81.51697190699991,
							30.255318011000043
						],
						[
							-81.51705190699994,
							30.25557701000008
						],
						[
							-81.51719090799992,
							30.256083010000054
						],
						[
							-81.51730590699992,
							30.256483011000057
						],
						[
							-81.5173809069999,
							30.256746010000086
						],
						[
							-81.51754190799994,
							30.25735201000009
						],
						[
							-81.51765890799993,
							30.257845011000086
						],
						[
							-81.51777590799992,
							30.258363010000043
						],
						[
							-81.51781290699995,
							30.25854001000005
						],
						[
							-81.51791490799992,
							30.259058011000036
						],
						[
							-81.51797290799993,
							30.25936001000008
						],
						[
							-81.51800290699993,
							30.259563011000065
						],
						[
							-81.51802290699993,
							30.259696011000077
						],
						[
							-81.5180799069999,
							30.260076011000084
						],
						[
							-81.51814690799996,
							30.26058501100005
						],
						[
							-81.51820390699993,
							30.261054010000066
						],
						[
							-81.51824090699995,
							30.261460011000054
						],
						[
							-81.51827190799992,
							30.261786010000034
						],
						[
							-81.51830690799994,
							30.262252011000044
						],
						[
							-81.51832890799994,
							30.26271601000008
						],
						[
							-81.51834290799991,
							30.263010010000073
						],
						[
							-81.5183689079999,
							30.26351001100005
						],
						[
							-81.51838090799993,
							30.264044010000077
						],
						[
							-81.51840490799992,
							30.26462101000004
						],
						[
							-81.51845190699993,
							30.265234010000086
						],
						[
							-81.51852290799992,
							30.26583701000004
						],
						[
							-81.51859990799994,
							30.266338011000073
						],
						[
							-81.5186879069999,
							30.266879010000086
						],
						[
							-81.51876690699993,
							30.267199011000063
						],
						[
							-81.51886190699992,
							30.26761601000004
						],
						[
							-81.51892090799993,
							30.267831011000055
						],
						[
							-81.51902390799995,
							30.26815201100004
						],
						[
							-81.51924190799991,
							30.26880801100009
						],
						[
							-81.51925690799993,
							30.268855010000042
						],
						[
							-81.51929090699993,
							30.26893201000007
						],
						[
							-81.51934790799993,
							30.269064011000072
						],
						[
							-81.51946090699994,
							30.26932601100009
						],
						[
							-81.51955590799992,
							30.269543010000064
						],
						[
							-81.5196289079999,
							30.26972901100004
						],
						[
							-81.51974290799991,
							30.269963011000076
						],
						[
							-81.51978290799991,
							30.270045010000047
						],
						[
							-81.5198379069999,
							30.270155011000046
						],
						[
							-81.52010490799995,
							30.27067001000006
						],
						[
							-81.52076990799992,
							30.271885010000062
						],
						[
							-81.52184790699994,
							30.27384101000007
						],
						[
							-81.52241190699993,
							30.27488401000005
						],
						[
							-81.52347390799991,
							30.276814010000066
						],
						[
							-81.52396190799993,
							30.27773101100007
						],
						[
							-81.52413790799994,
							30.27805401100005
						],
						[
							-81.52432090799994,
							30.278423010000044
						],
						[
							-81.52457290799993,
							30.27895101000007
						],
						[
							-81.52474890699995,
							30.27935301100007
						],
						[
							-81.52479990799992,
							30.279503010000045
						],
						[
							-81.52493290699994,
							30.279848011000073
						],
						[
							-81.52505190699992,
							30.280219010000053
						],
						[
							-81.52522990799991,
							30.280737011000046
						],
						[
							-81.52538290799993,
							30.28124401000008
						],
						[
							-81.52540690599994,
							30.28129901200009
						],
						[
							-81.5254189069999,
							30.28138101000007
						],
						[
							-81.52542390799994,
							30.281411011000042
						],
						[
							-81.52554590799991,
							30.282074011000077
						],
						[
							-81.52563790799991,
							30.28268401100007
						],
						[
							-81.52570790699991,
							30.283273010000073
						],
						[
							-81.52573790799994,
							30.28359801100004
						],
						[
							-81.52574490799992,
							30.283718011000076
						],
						[
							-81.52575390699991,
							30.283883010000068
						],
						[
							-81.52576890699993,
							30.28432001100009
						],
						[
							-81.5257769079999,
							30.284890011000073
						],
						[
							-81.52578390799994,
							30.28531501100008
						],
						[
							-81.5257749079999,
							30.286049010000056
						],
						[
							-81.52578190799994,
							30.28635501000008
						],
						[
							-81.52579290699992,
							30.286834011000057
						],
						[
							-81.52579690099992,
							30.287003016000085
						],
						[
							-81.52561690699991,
							30.287007010000078
						],
						[
							-81.52538990799991,
							30.287005010000083
						],
						[
							-81.52518390699993,
							30.28701101100006
						],
						[
							-81.52405990799991,
							30.28704301000005
						],
						[
							-81.5226019079999,
							30.287058010000067
						],
						[
							-81.52186890699996,
							30.28706501000005
						],
						[
							-81.52161990799993,
							30.28706801100009
						],
						[
							-81.52101890799992,
							30.287074010000083
						],
						[
							-81.52089890799994,
							30.28707501000008
						],
						[
							-81.52027390799992,
							30.287080010000068
						],
						[
							-81.52016890699991,
							30.28708101000007
						],
						[
							-81.51626690699993,
							30.287112010000044
						],
						[
							-81.51123990799994,
							30.28716201000009
						],
						[
							-81.5105149069999,
							30.28716901000007
						],
						[
							-81.5104659079999,
							30.28716901000007
						],
						[
							-81.5103519079999,
							30.28716901000007
						],
						[
							-81.5096789079999,
							30.28716901000007
						],
						[
							-81.50870390799992,
							30.287176010000056
						],
						[
							-81.50831790799992,
							30.287180010000046
						],
						[
							-81.5055329079999,
							30.287212010000076
						],
						[
							-81.50488296099991,
							30.287225955000054
						],
						[
							-81.50264890699994,
							30.287233010000083
						],
						[
							-81.50111190699994,
							30.287261010000066
						],
						[
							-81.49893390699992,
							30.28728901000005
						],
						[
							-81.4968019069999,
							30.287311010000053
						],
						[
							-81.49483795499992,
							30.287334956000056
						],
						[
							-81.49452090799991,
							30.287335010000046
						],
						[
							-81.49198490799995,
							30.287359010000046
						],
						[
							-81.48924090799994,
							30.287386010000034
						],
						[
							-81.48866891499995,
							30.287392066000052
						],
						[
							-81.48867590999994,
							30.287258012000052
						],
						[
							-81.4886859099999,
							30.287048012000074
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Sans Pareil",
				"RegionID": "126069"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.50672599999996,
					27.26924400000007,
					-82.48927499999996,
					27.298809000000062
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.49758399999996,
							27.276221000000078
						],
						[
							-82.49758299999996,
							27.276604000000077
						],
						[
							-82.49758299999996,
							27.27665200000007
						],
						[
							-82.50058599999994,
							27.27692200000007
						],
						[
							-82.50063899999998,
							27.276906000000054
						],
						[
							-82.50089999999994,
							27.276827000000026
						],
						[
							-82.50096399999995,
							27.276816000000053
						],
						[
							-82.50145399999997,
							27.276685000000043
						],
						[
							-82.50170899999995,
							27.276617000000044
						],
						[
							-82.50235899999996,
							27.276583000000073
						],
						[
							-82.50237599999997,
							27.276643000000035
						],
						[
							-82.50240899999994,
							27.276655000000062
						],
						[
							-82.50244499999997,
							27.276659000000052
						],
						[
							-82.50354299999998,
							27.27666700000003
						],
						[
							-82.50585899999999,
							27.276661000000047
						],
						[
							-82.50585099999995,
							27.27741100000003
						],
						[
							-82.50584399999997,
							27.278158000000076
						],
						[
							-82.50584599999996,
							27.278912000000048
						],
						[
							-82.50584099999998,
							27.279647000000068
						],
						[
							-82.50582599999996,
							27.280296000000078
						],
						[
							-82.50583299999994,
							27.28032200000007
						],
						[
							-82.50585199999995,
							27.280349000000058
						],
						[
							-82.50590999999997,
							27.28048700000005
						],
						[
							-82.50592699999999,
							27.280605000000037
						],
						[
							-82.50594199999995,
							27.280651000000034
						],
						[
							-82.50594399999994,
							27.28073600000005
						],
						[
							-82.50589999999994,
							27.280813000000023
						],
						[
							-82.50588899999997,
							27.28088400000007
						],
						[
							-82.50589299999996,
							27.28097400000007
						],
						[
							-82.50587499999995,
							27.281060000000025
						],
						[
							-82.50586099999998,
							27.28123800000003
						],
						[
							-82.50584599999996,
							27.28131200000007
						],
						[
							-82.50585399999994,
							27.281378000000075
						],
						[
							-82.50587699999994,
							27.281442000000027
						],
						[
							-82.50592399999994,
							27.28150000000005
						],
						[
							-82.50623399999995,
							27.28182400000003
						],
						[
							-82.50654899999995,
							27.282183000000032
						],
						[
							-82.50659599999994,
							27.28224300000005
						],
						[
							-82.50650899999994,
							27.282174000000055
						],
						[
							-82.50615699999997,
							27.281780000000026
						],
						[
							-82.50594199999995,
							27.281548000000043
						],
						[
							-82.50589799999995,
							27.281499000000053
						],
						[
							-82.50585499999994,
							27.281466000000023
						],
						[
							-82.50585399999994,
							27.28157600000003
						],
						[
							-82.50583399999994,
							27.284208000000035
						],
						[
							-82.50584699999996,
							27.28436400000004
						],
						[
							-82.50584499999997,
							27.284637000000032
						],
						[
							-82.50584799999996,
							27.28571900000003
						],
						[
							-82.50596799999994,
							27.28588700000006
						],
						[
							-82.50597999999997,
							27.28593600000005
						],
						[
							-82.50629199999997,
							27.285922000000028
						],
						[
							-82.50672599999996,
							27.285908000000063
						],
						[
							-82.50671499999999,
							27.285965000000033
						],
						[
							-82.50623199999995,
							27.285948000000076
						],
						[
							-82.50594699999994,
							27.285953000000063
						],
						[
							-82.50586499999997,
							27.285980000000052
						],
						[
							-82.50585699999993,
							27.285997000000066
						],
						[
							-82.50584899999996,
							27.286033000000035
						],
						[
							-82.50585199999995,
							27.28773700000005
						],
						[
							-82.50585299999995,
							27.287829000000045
						],
						[
							-82.50584899999996,
							27.287885000000074
						],
						[
							-82.50585599999995,
							27.289612000000034
						],
						[
							-82.50585499999994,
							27.290197000000035
						],
						[
							-82.50586599999997,
							27.291349000000025
						],
						[
							-82.50586199999998,
							27.29148200000003
						],
						[
							-82.50585799999999,
							27.291612000000043
						],
						[
							-82.50586299999998,
							27.29332500000004
						],
						[
							-82.50586099999998,
							27.29414900000006
						],
						[
							-82.50585799999999,
							27.295074000000056
						],
						[
							-82.50585999999998,
							27.29514000000006
						],
						[
							-82.50586599999997,
							27.29812700000008
						],
						[
							-82.50586699999997,
							27.298809000000062
						],
						[
							-82.50349799999998,
							27.29879900000003
						],
						[
							-82.50315599999999,
							27.298798000000033
						],
						[
							-82.50275199999999,
							27.29879500000004
						],
						[
							-82.50201899999996,
							27.298797000000036
						],
						[
							-82.50118899999995,
							27.29878800000006
						],
						[
							-82.49756399999995,
							27.298778000000027
						],
						[
							-82.49564399999997,
							27.29877300000004
						],
						[
							-82.49543699999998,
							27.298772000000042
						],
						[
							-82.49463799999995,
							27.298768000000052
						],
						[
							-82.49417299999999,
							27.298766000000057
						],
						[
							-82.49216799999994,
							27.298760000000073
						],
						[
							-82.49149999999997,
							27.298757000000023
						],
						[
							-82.49088899999998,
							27.298756000000026
						],
						[
							-82.49009399999994,
							27.298757000000023
						],
						[
							-82.48928699999999,
							27.29874700000005
						],
						[
							-82.48927499999996,
							27.29847200000006
						],
						[
							-82.48929699999997,
							27.296033000000023
						],
						[
							-82.48929699999997,
							27.295645000000036
						],
						[
							-82.48930099999995,
							27.295199000000025
						],
						[
							-82.48929699999997,
							27.29467100000005
						],
						[
							-82.48929999999996,
							27.29375200000004
						],
						[
							-82.48931399999998,
							27.291479000000038
						],
						[
							-82.48931599999997,
							27.291378000000066
						],
						[
							-82.48928999999998,
							27.290906000000067
						],
						[
							-82.48927799999996,
							27.290197000000035
						],
						[
							-82.48927699999996,
							27.28914000000003
						],
						[
							-82.48928399999994,
							27.288197000000025
						],
						[
							-82.48928999999998,
							27.287717000000043
						],
						[
							-82.48929499999997,
							27.28723400000007
						],
						[
							-82.48930199999995,
							27.28586400000006
						],
						[
							-82.48929399999997,
							27.28399500000006
						],
						[
							-82.48929099999998,
							27.282770000000028
						],
						[
							-82.48929799999996,
							27.28122800000006
						],
						[
							-82.48930599999994,
							27.28066300000006
						],
						[
							-82.48930999999999,
							27.27961300000004
						],
						[
							-82.48931499999998,
							27.278760000000034
						],
						[
							-82.48930199999995,
							27.27681300000006
						],
						[
							-82.48930899999993,
							27.276595000000043
						],
						[
							-82.48932199999996,
							27.27620900000005
						],
						[
							-82.48931999999996,
							27.27601500000003
						],
						[
							-82.48932899999994,
							27.27248700000007
						],
						[
							-82.48932699999995,
							27.271562000000074
						],
						[
							-82.48933299999999,
							27.26963500000005
						],
						[
							-82.48932299999996,
							27.269520000000057
						],
						[
							-82.48931799999997,
							27.26925700000004
						],
						[
							-82.48957599999994,
							27.26924400000007
						],
						[
							-82.49131099999994,
							27.26926100000003
						],
						[
							-82.49165899999997,
							27.269265000000075
						],
						[
							-82.49194699999998,
							27.269270000000063
						],
						[
							-82.49364299999996,
							27.269274000000056
						],
						[
							-82.49602099999998,
							27.269281000000035
						],
						[
							-82.49651399999993,
							27.269272000000058
						],
						[
							-82.49761199999995,
							27.269276000000048
						],
						[
							-82.49760899999995,
							27.27082800000005
						],
						[
							-82.49760199999997,
							27.271078000000045
						],
						[
							-82.49759899999998,
							27.27154700000006
						],
						[
							-82.49759099999994,
							27.273064000000034
						],
						[
							-82.49759299999994,
							27.27439000000004
						],
						[
							-82.49758399999996,
							27.27609700000005
						],
						[
							-82.49758399999996,
							27.276221000000078
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "South Gate Ridge",
				"RegionID": "126218"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.54492499999992,
					27.26972600000005,
					-82.51863199999991,
					27.29951200000005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.52233299999995,
							27.299501000000078
						],
						[
							-82.52234599999991,
							27.29884000000004
						],
						[
							-82.5217219999999,
							27.29884000000004
						],
						[
							-82.5215839999999,
							27.29883700000005
						],
						[
							-82.5206619999999,
							27.29882900000007
						],
						[
							-82.51993799999991,
							27.298839000000044
						],
						[
							-82.51902899999993,
							27.298838000000046
						],
						[
							-82.51897699999995,
							27.298828000000075
						],
						[
							-82.51887799999992,
							27.29882900000007
						],
						[
							-82.51882099999995,
							27.298838000000046
						],
						[
							-82.51871299999993,
							27.298838000000046
						],
						[
							-82.51863199999991,
							27.298839000000044
						],
						[
							-82.51873499999994,
							27.29871000000009
						],
						[
							-82.51904899999994,
							27.298316000000057
						],
						[
							-82.51902899999993,
							27.298159000000055
						],
						[
							-82.51907599999993,
							27.298102000000085
						],
						[
							-82.5191549999999,
							27.29803000000004
						],
						[
							-82.51920299999995,
							27.29795800000005
						],
						[
							-82.51923299999993,
							27.297897000000034
						],
						[
							-82.51930999999992,
							27.297826000000043
						],
						[
							-82.51929899999993,
							27.29758400000009
						],
						[
							-82.5196029999999,
							27.297147000000052
						],
						[
							-82.52016299999991,
							27.296828000000062
						],
						[
							-82.52019299999995,
							27.296740000000057
						],
						[
							-82.5202589999999,
							27.29669000000007
						],
						[
							-82.52035899999993,
							27.29660100000007
						],
						[
							-82.52039499999995,
							27.296561000000054
						],
						[
							-82.52044799999993,
							27.296482000000086
						],
						[
							-82.52046199999995,
							27.296447000000057
						],
						[
							-82.52047099999993,
							27.29640900000004
						],
						[
							-82.52047199999993,
							27.29634400000009
						],
						[
							-82.52055799999994,
							27.296234000000084
						],
						[
							-82.51986999999991,
							27.29565800000006
						],
						[
							-82.51958699999994,
							27.29505600000005
						],
						[
							-82.51960699999995,
							27.29498700000005
						],
						[
							-82.51963099999995,
							27.294951000000083
						],
						[
							-82.5196939999999,
							27.29487800000004
						],
						[
							-82.51973299999992,
							27.29480200000006
						],
						[
							-82.51982499999991,
							27.294670000000053
						],
						[
							-82.51990099999995,
							27.294616000000076
						],
						[
							-82.52002199999993,
							27.294471000000044
						],
						[
							-82.52008799999993,
							27.29441200000008
						],
						[
							-82.52017799999993,
							27.294347000000073
						],
						[
							-82.52040799999992,
							27.29413900000009
						],
						[
							-82.52047699999991,
							27.294081000000062
						],
						[
							-82.52049699999992,
							27.29405500000007
						],
						[
							-82.5205029999999,
							27.294044000000042
						],
						[
							-82.5206829999999,
							27.294040000000052
						],
						[
							-82.52078699999993,
							27.29387100000008
						],
						[
							-82.52075499999995,
							27.293229000000053
						],
						[
							-82.52078199999994,
							27.292834000000084
						],
						[
							-82.52093699999995,
							27.292121000000066
						],
						[
							-82.52171099999993,
							27.289219000000063
						],
						[
							-82.5217889999999,
							27.28868600000004
						],
						[
							-82.52198599999991,
							27.288293000000067
						],
						[
							-82.52199599999994,
							27.28826100000009
						],
						[
							-82.52200599999992,
							27.28819400000009
						],
						[
							-82.52200499999992,
							27.28812000000005
						],
						[
							-82.52197299999995,
							27.287942000000044
						],
						[
							-82.52196099999992,
							27.28789900000004
						],
						[
							-82.52193999999992,
							27.287862000000075
						],
						[
							-82.52191099999993,
							27.28783500000009
						],
						[
							-82.52188299999995,
							27.287829000000045
						],
						[
							-82.52185899999995,
							27.287843000000066
						],
						[
							-82.5218769999999,
							27.28798500000005
						],
						[
							-82.52186999999992,
							27.28821400000004
						],
						[
							-82.52185799999995,
							27.288272000000063
						],
						[
							-82.52183699999995,
							27.28830300000004
						],
						[
							-82.52181499999995,
							27.288316000000066
						],
						[
							-82.52176799999995,
							27.28832600000004
						],
						[
							-82.52161599999994,
							27.28831000000008
						],
						[
							-82.5214049999999,
							27.288274000000058
						],
						[
							-82.5212929999999,
							27.28826500000008
						],
						[
							-82.52099399999992,
							27.28826500000008
						],
						[
							-82.52094299999993,
							27.288276000000053
						],
						[
							-82.52091499999995,
							27.288295000000062
						],
						[
							-82.52089099999995,
							27.288335000000075
						],
						[
							-82.5208439999999,
							27.28843500000005
						],
						[
							-82.52076899999992,
							27.28855200000004
						],
						[
							-82.5206869999999,
							27.288617000000045
						],
						[
							-82.52066999999995,
							27.28864100000004
						],
						[
							-82.5206639999999,
							27.28866000000005
						],
						[
							-82.52065299999992,
							27.288756000000035
						],
						[
							-82.5205929999999,
							27.288844000000044
						],
						[
							-82.52056499999992,
							27.288871000000086
						],
						[
							-82.52052299999991,
							27.28889900000007
						],
						[
							-82.52048699999995,
							27.28891100000004
						],
						[
							-82.52046499999994,
							27.288906000000054
						],
						[
							-82.52045499999991,
							27.288880000000063
						],
						[
							-82.5204599999999,
							27.28882800000008
						],
						[
							-82.52047099999993,
							27.288792000000058
						],
						[
							-82.52049899999992,
							27.288728000000052
						],
						[
							-82.52054199999992,
							27.288656000000064
						],
						[
							-82.52070299999991,
							27.288434000000052
						],
						[
							-82.52079099999992,
							27.28832200000005
						],
						[
							-82.52088399999991,
							27.288226000000066
						],
						[
							-82.52092199999993,
							27.288204000000064
						],
						[
							-82.52099299999992,
							27.288185000000055
						],
						[
							-82.5210429999999,
							27.288182000000063
						],
						[
							-82.52127899999994,
							27.28819800000008
						],
						[
							-82.52153799999991,
							27.288208000000054
						],
						[
							-82.52164399999992,
							27.288208000000054
						],
						[
							-82.5217439999999,
							27.28819800000008
						],
						[
							-82.52177399999994,
							27.288184000000058
						],
						[
							-82.52179599999995,
							27.28816000000006
						],
						[
							-82.5218099999999,
							27.288122000000044
						],
						[
							-82.5218099999999,
							27.288027000000056
						],
						[
							-82.52179399999996,
							27.287922000000037
						],
						[
							-82.5217429999999,
							27.28769200000005
						],
						[
							-82.52180799999991,
							27.28761300000008
						],
						[
							-82.52177799999993,
							27.287222000000042
						],
						[
							-82.52162099999993,
							27.287235000000067
						],
						[
							-82.52159099999994,
							27.287123000000065
						],
						[
							-82.5215609999999,
							27.286815000000047
						],
						[
							-82.52154899999994,
							27.286555000000078
						],
						[
							-82.52155099999993,
							27.286414000000036
						],
						[
							-82.52155799999991,
							27.28636300000005
						],
						[
							-82.52157099999994,
							27.28631800000005
						],
						[
							-82.52164699999992,
							27.28613000000007
						],
						[
							-82.52170699999994,
							27.285968000000082
						],
						[
							-82.52188399999994,
							27.28557900000004
						],
						[
							-82.52202799999992,
							27.285280000000057
						],
						[
							-82.52205299999991,
							27.285210000000067
						],
						[
							-82.5220119999999,
							27.285192000000052
						],
						[
							-82.52198099999993,
							27.285187000000068
						],
						[
							-82.52189299999992,
							27.285198000000037
						],
						[
							-82.52209699999992,
							27.28510200000005
						],
						[
							-82.52221699999991,
							27.285123000000056
						],
						[
							-82.52200299999993,
							27.284571000000085
						],
						[
							-82.52182099999993,
							27.28438200000005
						],
						[
							-82.52173099999993,
							27.284289000000058
						],
						[
							-82.52170899999993,
							27.28420400000005
						],
						[
							-82.52162799999991,
							27.283890000000042
						],
						[
							-82.52163999999993,
							27.283709000000044
						],
						[
							-82.52161299999995,
							27.28367600000007
						],
						[
							-82.5215859999999,
							27.283608000000072
						],
						[
							-82.52157999999991,
							27.283554000000038
						],
						[
							-82.52157999999991,
							27.28339600000004
						],
						[
							-82.52158899999995,
							27.283334000000085
						],
						[
							-82.52154899999994,
							27.283224000000075
						],
						[
							-82.52191399999992,
							27.28258500000004
						],
						[
							-82.52242999999993,
							27.281053000000043
						],
						[
							-82.52167299999991,
							27.278296000000072
						],
						[
							-82.52284199999991,
							27.277400000000057
						],
						[
							-82.52347899999997,
							27.276766000000066
						],
						[
							-82.52361899999994,
							27.27662600000008
						],
						[
							-82.52426899999995,
							27.276131000000078
						],
						[
							-82.52483299999994,
							27.275607000000036
						],
						[
							-82.52567999999991,
							27.275067000000035
						],
						[
							-82.52724999999992,
							27.274497000000054
						],
						[
							-82.53047299999992,
							27.273578000000043
						],
						[
							-82.53058299999992,
							27.273524000000066
						],
						[
							-82.53069199999993,
							27.27346900000009
						],
						[
							-82.53310099999993,
							27.27227300000004
						],
						[
							-82.53493399999991,
							27.271362000000067
						],
						[
							-82.53692099999995,
							27.271303000000046
						],
						[
							-82.53803699999992,
							27.27082900000005
						],
						[
							-82.53877799999992,
							27.27051400000005
						],
						[
							-82.53951999999992,
							27.270200000000045
						],
						[
							-82.5398219999999,
							27.270057000000065
						],
						[
							-82.53992799999992,
							27.27000600000008
						],
						[
							-82.54006599999991,
							27.269971000000055
						],
						[
							-82.54023199999995,
							27.269862000000046
						],
						[
							-82.5404089999999,
							27.269783000000075
						],
						[
							-82.54046099999994,
							27.269753000000037
						],
						[
							-82.5405189999999,
							27.26972600000005
						],
						[
							-82.54150599999991,
							27.27054600000008
						],
						[
							-82.54171899999994,
							27.270726000000085
						],
						[
							-82.54221299999995,
							27.271291000000076
						],
						[
							-82.54242399999993,
							27.27154100000007
						],
						[
							-82.54412999999994,
							27.278470000000084
						],
						[
							-82.54287799999992,
							27.28120700000005
						],
						[
							-82.54368499999994,
							27.284392000000082
						],
						[
							-82.5437189999999,
							27.284525000000087
						],
						[
							-82.54376799999994,
							27.285814000000073
						],
						[
							-82.54401899999993,
							27.292425000000037
						],
						[
							-82.54397199999994,
							27.29270100000008
						],
						[
							-82.54396199999991,
							27.292814000000078
						],
						[
							-82.54393599999992,
							27.292916000000048
						],
						[
							-82.54391699999991,
							27.293027000000052
						],
						[
							-82.54438299999993,
							27.29705000000007
						],
						[
							-82.54492499999992,
							27.297642000000053
						],
						[
							-82.5449119999999,
							27.298230000000046
						],
						[
							-82.5447519999999,
							27.29882100000009
						],
						[
							-82.54450899999995,
							27.29891800000007
						],
						[
							-82.5437189999999,
							27.29900100000009
						],
						[
							-82.54326099999993,
							27.299104000000057
						],
						[
							-82.54312599999992,
							27.29900100000009
						],
						[
							-82.54310299999992,
							27.29902100000004
						],
						[
							-82.54279599999991,
							27.299003000000084
						],
						[
							-82.54253499999993,
							27.29899800000004
						],
						[
							-82.54237899999993,
							27.298977000000036
						],
						[
							-82.54230399999994,
							27.29894900000005
						],
						[
							-82.54229399999991,
							27.298943000000065
						],
						[
							-82.54190599999994,
							27.29888200000005
						],
						[
							-82.53980699999994,
							27.298874000000072
						],
						[
							-82.5393499999999,
							27.298905000000047
						],
						[
							-82.53914099999992,
							27.29889800000007
						],
						[
							-82.5391249999999,
							27.298132000000066
						],
						[
							-82.53869899999995,
							27.298128000000077
						],
						[
							-82.5386749999999,
							27.29886900000008
						],
						[
							-82.53821199999993,
							27.298867000000087
						],
						[
							-82.5374579999999,
							27.29885900000005
						],
						[
							-82.53748799999994,
							27.299329000000057
						],
						[
							-82.53681099999994,
							27.29932400000007
						],
						[
							-82.5368289999999,
							27.29906100000005
						],
						[
							-82.53627499999993,
							27.29907200000008
						],
						[
							-82.53630299999992,
							27.299325000000067
						],
						[
							-82.53561899999994,
							27.299325000000067
						],
						[
							-82.53543399999995,
							27.299325000000067
						],
						[
							-82.53543599999995,
							27.298853000000065
						],
						[
							-82.53486499999991,
							27.298852000000068
						],
						[
							-82.53485099999995,
							27.299073000000078
						],
						[
							-82.53432299999992,
							27.299122000000068
						],
						[
							-82.53430299999991,
							27.298853000000065
						],
						[
							-82.53463699999992,
							27.29872400000005
						],
						[
							-82.53462899999994,
							27.298515000000066
						],
						[
							-82.53464699999995,
							27.297845000000052
						],
						[
							-82.53453999999994,
							27.297851000000037
						],
						[
							-82.5345549999999,
							27.297829000000036
						],
						[
							-82.53455999999994,
							27.297781000000043
						],
						[
							-82.53456799999992,
							27.297015000000044
						],
						[
							-82.53408899999994,
							27.297016000000042
						],
						[
							-82.53407899999992,
							27.29757900000004
						],
						[
							-82.53369499999991,
							27.297581000000037
						],
						[
							-82.53368499999993,
							27.29701700000004
						],
						[
							-82.53294199999993,
							27.297018000000037
						],
						[
							-82.53292799999991,
							27.29633700000005
						],
						[
							-82.53359399999994,
							27.296351000000072
						],
						[
							-82.53357699999992,
							27.295169000000044
						],
						[
							-82.5327769999999,
							27.295165000000054
						],
						[
							-82.53082999999992,
							27.29516300000006
						],
						[
							-82.53055899999993,
							27.295152000000087
						],
						[
							-82.5305669999999,
							27.294381000000044
						],
						[
							-82.53058099999993,
							27.293558000000075
						],
						[
							-82.53057899999993,
							27.29345900000004
						],
						[
							-82.53057999999993,
							27.293391000000046
						],
						[
							-82.52981099999995,
							27.293405000000064
						],
						[
							-82.52985699999994,
							27.293017000000077
						],
						[
							-82.52955299999991,
							27.29301600000008
						],
						[
							-82.52952499999992,
							27.293432000000053
						],
						[
							-82.52626599999991,
							27.293341000000055
						],
						[
							-82.52616999999992,
							27.294756000000064
						],
						[
							-82.52621099999993,
							27.294763000000046
						],
						[
							-82.52620399999995,
							27.294873000000052
						],
						[
							-82.5262239999999,
							27.294937000000065
						],
						[
							-82.5264049999999,
							27.29517000000004
						],
						[
							-82.52860099999992,
							27.295198000000084
						],
						[
							-82.5288569999999,
							27.295135000000073
						],
						[
							-82.52896399999992,
							27.29513600000007
						],
						[
							-82.52933499999995,
							27.29514000000006
						],
						[
							-82.52943899999991,
							27.295138000000065
						],
						[
							-82.52950499999992,
							27.29603700000007
						],
						[
							-82.52962399999991,
							27.296039000000068
						],
						[
							-82.52965099999994,
							27.29646900000006
						],
						[
							-82.5295119999999,
							27.297074000000066
						],
						[
							-82.52946099999991,
							27.297045000000086
						],
						[
							-82.5293529999999,
							27.297022000000087
						],
						[
							-82.52926599999995,
							27.297022000000087
						],
						[
							-82.5292179999999,
							27.297415000000058
						],
						[
							-82.5295339999999,
							27.29741400000006
						],
						[
							-82.52952899999991,
							27.29762100000005
						],
						[
							-82.52952799999993,
							27.297705000000065
						],
						[
							-82.52912199999992,
							27.297704000000067
						],
						[
							-82.52912199999992,
							27.29850300000004
						],
						[
							-82.52874999999995,
							27.298502000000042
						],
						[
							-82.52875399999994,
							27.298313000000064
						],
						[
							-82.52838899999995,
							27.298338000000058
						],
						[
							-82.52837499999993,
							27.298020000000065
						],
						[
							-82.52799099999993,
							27.298047000000054
						],
						[
							-82.52799599999992,
							27.297162000000075
						],
						[
							-82.52799099999993,
							27.29702800000007
						],
						[
							-82.52765999999991,
							27.297029000000066
						],
						[
							-82.52723099999993,
							27.297030000000063
						],
						[
							-82.5266959999999,
							27.297026000000074
						],
						[
							-82.5264269999999,
							27.29701700000004
						],
						[
							-82.52643399999994,
							27.29754900000006
						],
						[
							-82.52643399999994,
							27.297706000000062
						],
						[
							-82.52497999999991,
							27.297736000000043
						],
						[
							-82.52498199999991,
							27.297880000000077
						],
						[
							-82.52498299999992,
							27.29799600000007
						],
						[
							-82.52497399999993,
							27.298056000000088
						],
						[
							-82.52495699999992,
							27.298077000000035
						],
						[
							-82.5249409999999,
							27.298088000000064
						],
						[
							-82.52487899999994,
							27.29811600000005
						],
						[
							-82.52485699999994,
							27.298148000000083
						],
						[
							-82.5248479999999,
							27.29818000000006
						],
						[
							-82.5248499999999,
							27.298425000000066
						],
						[
							-82.52486799999991,
							27.298567000000048
						],
						[
							-82.52486099999993,
							27.298842000000036
						],
						[
							-82.52403499999991,
							27.29884100000004
						],
						[
							-82.52404899999993,
							27.299083000000053
						],
						[
							-82.52404499999994,
							27.29942600000004
						],
						[
							-82.52404499999994,
							27.299510000000055
						],
						[
							-82.52252399999992,
							27.29951200000005
						],
						[
							-82.52233299999995,
							27.299501000000078
						]
					],
					[
						[
							-82.5233659999999,
							27.29790500000007
						],
						[
							-82.5239049999999,
							27.297919000000036
						],
						[
							-82.52409799999992,
							27.29726400000004
						],
						[
							-82.5233869999999,
							27.297233000000066
						],
						[
							-82.5233659999999,
							27.29790500000007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "South Sarasota",
				"RegionID": "126236"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.40152811699996,
					29.663746141000047,
					-82.38895624299995,
					29.67418372000003
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.38910260099999,
							29.666107579000027
						],
						[
							-82.38910296699999,
							29.666087479000055
						],
						[
							-82.38910632499994,
							29.665903202000038
						],
						[
							-82.38914176499998,
							29.663746141000047
						],
						[
							-82.38914176499998,
							29.663958159000057
						],
						[
							-82.38988948699995,
							29.66396194500004
						],
						[
							-82.39075991799996,
							29.66396635200005
						],
						[
							-82.39345243399998,
							29.663979985000026
						],
						[
							-82.39358206299994,
							29.66398210500006
						],
						[
							-82.40148551999994,
							29.664111353000067
						],
						[
							-82.40152811699996,
							29.67418372000003
						],
						[
							-82.38895624299995,
							29.674140067000053
						],
						[
							-82.38910260099999,
							29.666107579000027
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Alachua",
				"City": "Gainesville",
				"Name": "Suburban Heights",
				"RegionID": "126286"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.12112550599994,
					26.129097124000054,
					-80.11282852799992,
					26.13249075100009
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.1161735259999,
							26.132324226000037
						],
						[
							-80.11504915699993,
							26.132211789000053
						],
						[
							-80.11406533399992,
							26.132015025000044
						],
						[
							-80.11344693099994,
							26.131649605000064
						],
						[
							-80.11302529199992,
							26.131284185000084
						],
						[
							-80.1128847459999,
							26.13083443700009
						],
						[
							-80.11282852799992,
							26.130244143000084
						],
						[
							-80.11285663699994,
							26.129766286000063
						],
						[
							-80.11295683499992,
							26.129205178000063
						],
						[
							-80.1135419169999,
							26.129241746000048
						],
						[
							-80.11628630599996,
							26.129179776000058
						],
						[
							-80.1163439579999,
							26.12917847400007
						],
						[
							-80.11961601899992,
							26.129106163000074
						],
						[
							-80.12001740099993,
							26.129103099000076
						],
						[
							-80.12080010699992,
							26.129097124000054
						],
						[
							-80.12100800099995,
							26.129431562000036
						],
						[
							-80.1211074279999,
							26.129630416000055
						],
						[
							-80.12112550599994,
							26.129756960000066
						],
						[
							-80.12112550599994,
							26.12992869800007
						],
						[
							-80.12109994699995,
							26.130126777000044
						],
						[
							-80.12099199999994,
							26.13012000000009
						],
						[
							-80.11832099999992,
							26.131302000000062
						],
						[
							-80.11836499999993,
							26.131395000000055
						],
						[
							-80.11788345299993,
							26.13232345000006
						],
						[
							-80.11787984599994,
							26.13232078100009
						],
						[
							-80.11745904399993,
							26.132454870000064
						],
						[
							-80.11737191599991,
							26.13247789500008
						],
						[
							-80.11731106899992,
							26.13249075100009
						],
						[
							-80.1161735259999,
							26.132324226000037
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Sunrise Key",
				"RegionID": "126320"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.09626594499991,
					26.218959840000082,
					-80.09264159199995,
					26.222735708000073
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.09264159199995,
							26.220633854000088
						],
						[
							-80.09290970199993,
							26.21929448800006
						],
						[
							-80.09291542799991,
							26.219295548000048
						],
						[
							-80.09298687099994,
							26.219297856000082
						],
						[
							-80.09354665799992,
							26.219312680000087
						],
						[
							-80.09355194499994,
							26.219312840000043
						],
						[
							-80.09355082999991,
							26.21931734000009
						],
						[
							-80.09346711099994,
							26.219655138000064
						],
						[
							-80.09346594499993,
							26.219659840000077
						],
						[
							-80.09347127699994,
							26.219659840000077
						],
						[
							-80.09353882999994,
							26.219659840000077
						],
						[
							-80.09539306099992,
							26.219659840000077
						],
						[
							-80.09546594499994,
							26.219659840000077
						],
						[
							-80.09563394499992,
							26.219379840000045
						],
						[
							-80.0960239449999,
							26.219321840000077
						],
						[
							-80.09625748699995,
							26.21897249200009
						],
						[
							-80.09626594499991,
							26.218959840000082
						],
						[
							-80.09626137999993,
							26.21897753000008
						],
						[
							-80.09548527599992,
							26.222735708000073
						],
						[
							-80.09424889199994,
							26.222364793000054
						],
						[
							-80.09370488299993,
							26.222092788000054
						],
						[
							-80.09288886899994,
							26.221227319000036
						],
						[
							-80.09264159199995,
							26.220633854000088
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Pompano Beach",
				"Name": "Terra Mar",
				"RegionID": "126386"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-85.789787,
					30.129533000000002,
					-85.684692,
					30.223069000000002
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-85.75131200000001,
							30.211137
						],
						[
							-85.751258,
							30.211109
						],
						[
							-85.750775,
							30.211304000000002
						],
						[
							-85.750051,
							30.211701999999995
						],
						[
							-85.743591,
							30.216501000000004
						],
						[
							-85.733213,
							30.222562
						],
						[
							-85.73218,
							30.223069000000002
						],
						[
							-85.726065,
							30.215554
						],
						[
							-85.727001,
							30.21387
						],
						[
							-85.731445,
							30.206592
						],
						[
							-85.738228,
							30.195676
						],
						[
							-85.741118,
							30.190307000000004
						],
						[
							-85.740666,
							30.188608
						],
						[
							-85.740591,
							30.188187
						],
						[
							-85.740638,
							30.187612
						],
						[
							-85.741409,
							30.177837000000004
						],
						[
							-85.738159,
							30.175144000000003
						],
						[
							-85.73246,
							30.170808
						],
						[
							-85.729003,
							30.16986
						],
						[
							-85.716506,
							30.164295
						],
						[
							-85.693283,
							30.154755999999995
						],
						[
							-85.689155,
							30.153026
						],
						[
							-85.684692,
							30.151284999999998
						],
						[
							-85.684928,
							30.150627
						],
						[
							-85.685211,
							30.149953
						],
						[
							-85.685913,
							30.148698
						],
						[
							-85.686538,
							30.147804
						],
						[
							-85.687301,
							30.146770000000004
						],
						[
							-85.68785,
							30.145954
						],
						[
							-85.68843,
							30.145334
						],
						[
							-85.688705,
							30.144918
						],
						[
							-85.689147,
							30.144317000000004
						],
						[
							-85.689491,
							30.143709000000005
						],
						[
							-85.689865,
							30.142929
						],
						[
							-85.690292,
							30.142292
						],
						[
							-85.690742,
							30.141280999999996
						],
						[
							-85.69094,
							30.140716
						],
						[
							-85.691047,
							30.140321
						],
						[
							-85.69104,
							30.140233000000002
						],
						[
							-85.692047,
							30.136369000000002
						],
						[
							-85.692161,
							30.135624999999997
						],
						[
							-85.692276,
							30.134706000000005
						],
						[
							-85.692375,
							30.133451000000004
						],
						[
							-85.692382,
							30.132713
						],
						[
							-85.692344,
							30.13132
						],
						[
							-85.69226,
							30.130691
						],
						[
							-85.692176,
							30.130245
						],
						[
							-85.692039,
							30.129724
						],
						[
							-85.691925,
							30.129533000000002
						],
						[
							-85.692832,
							30.129680000000004
						],
						[
							-85.693183,
							30.129678000000002
						],
						[
							-85.694137,
							30.129917
						],
						[
							-85.694389,
							30.129947
						],
						[
							-85.696578,
							30.130308
						],
						[
							-85.696731,
							30.130359
						],
						[
							-85.69799,
							30.130502000000003
						],
						[
							-85.699218,
							30.130681
						],
						[
							-85.700271,
							30.13079
						],
						[
							-85.700469,
							30.130779000000004
						],
						[
							-85.702621,
							30.131126000000002
						],
						[
							-85.70408600000002,
							30.131284000000004
						],
						[
							-85.704963,
							30.131663999999997
						],
						[
							-85.7052,
							30.131828
						],
						[
							-85.706092,
							30.132282
						],
						[
							-85.706306,
							30.132318
						],
						[
							-85.707542,
							30.132311999999995
						],
						[
							-85.707885,
							30.132219
						],
						[
							-85.709228,
							30.13202
						],
						[
							-85.70954800000001,
							30.131935000000002
						],
						[
							-85.710769,
							30.131828
						],
						[
							-85.712013,
							30.131809
						],
						[
							-85.712303,
							30.131784000000003
						],
						[
							-85.713256,
							30.131801
						],
						[
							-85.713508,
							30.131776000000002
						],
						[
							-85.714576,
							30.131763000000003
						],
						[
							-85.714721,
							30.131776000000002
						],
						[
							-85.715469,
							30.131729
						],
						[
							-85.715923,
							30.131747
						],
						[
							-85.716852,
							30.131924
						],
						[
							-85.717086,
							30.131945
						],
						[
							-85.71799300000002,
							30.132080000000002
						],
						[
							-85.719061,
							30.132172000000004
						],
						[
							-85.71925000000002,
							30.13222
						],
						[
							-85.720173,
							30.132368000000003
						],
						[
							-85.720312,
							30.132372
						],
						[
							-85.721174,
							30.132527999999997
						],
						[
							-85.721284,
							30.132533
						],
						[
							-85.722,
							30.132675000000003
						],
						[
							-85.722721,
							30.132926
						],
						[
							-85.722883,
							30.132968
						],
						[
							-85.725213,
							30.133555
						],
						[
							-85.727363,
							30.134414999999997
						],
						[
							-85.732046,
							30.137562
						],
						[
							-85.737521,
							30.140924
						],
						[
							-85.742612,
							30.143817
						],
						[
							-85.746866,
							30.146418000000004
						],
						[
							-85.748428,
							30.147789
						],
						[
							-85.750144,
							30.14936
						],
						[
							-85.75083100000002,
							30.149843000000004
						],
						[
							-85.752243,
							30.150390000000005
						],
						[
							-85.753242,
							30.150741
						],
						[
							-85.754173,
							30.151365
						],
						[
							-85.755271,
							30.152287999999995
						],
						[
							-85.756011,
							30.152669000000003
						],
						[
							-85.758522,
							30.153909
						],
						[
							-85.759399,
							30.154424000000002
						],
						[
							-85.760482,
							30.154987000000002
						],
						[
							-85.761238,
							30.155477000000005
						],
						[
							-85.762123,
							30.155898999999998
						],
						[
							-85.763221,
							30.156547
						],
						[
							-85.764472,
							30.157146
						],
						[
							-85.765495,
							30.157726000000004
						],
						[
							-85.766647,
							30.157930000000004
						],
						[
							-85.767639,
							30.158668000000002
						],
						[
							-85.768058,
							30.159046
						],
						[
							-85.76876,
							30.159557
						],
						[
							-85.770057,
							30.160417000000002
						],
						[
							-85.770736,
							30.160791
						],
						[
							-85.771141,
							30.160966
						],
						[
							-85.771453,
							30.161098
						],
						[
							-85.772285,
							30.161396
						],
						[
							-85.774101,
							30.162223
						],
						[
							-85.775489,
							30.162939999999995
						],
						[
							-85.776046,
							30.163481999999995
						],
						[
							-85.777328,
							30.164014
						],
						[
							-85.778244,
							30.164361
						],
						[
							-85.779426,
							30.164913
						],
						[
							-85.780044,
							30.165319000000004
						],
						[
							-85.780586,
							30.165616
						],
						[
							-85.781867,
							30.166282
						],
						[
							-85.78298100000002,
							30.166913
						],
						[
							-85.784881,
							30.167942
						],
						[
							-85.786209,
							30.168621000000005
						],
						[
							-85.787239,
							30.169292
						],
						[
							-85.787544,
							30.169611999999997
						],
						[
							-85.789016,
							30.170306999999998
						],
						[
							-85.789421,
							30.170663
						],
						[
							-85.789512,
							30.170726000000002
						],
						[
							-85.78952200000002,
							30.170754
						],
						[
							-85.789579,
							30.170821000000004
						],
						[
							-85.789751,
							30.170969000000003
						],
						[
							-85.789779,
							30.171001
						],
						[
							-85.789779,
							30.171344
						],
						[
							-85.789779,
							30.172193
						],
						[
							-85.789779,
							30.175842000000003
						],
						[
							-85.789779,
							30.176919000000005
						],
						[
							-85.789787,
							30.177658
						],
						[
							-85.789787,
							30.178559999999997
						],
						[
							-85.789787,
							30.18118656000007
						],
						[
							-85.782379,
							30.18317
						],
						[
							-85.782379,
							30.181352
						],
						[
							-85.781908,
							30.181350000000002
						],
						[
							-85.781916,
							30.181952000000003
						],
						[
							-85.780265,
							30.181957999999998
						],
						[
							-85.780296,
							30.180221000000003
						],
						[
							-85.78038,
							30.180149000000004
						],
						[
							-85.78101,
							30.180147
						],
						[
							-85.78103600000001,
							30.178421000000004
						],
						[
							-85.7779,
							30.178392000000002
						],
						[
							-85.776817,
							30.178524000000003
						],
						[
							-85.776824,
							30.181385
						],
						[
							-85.776649,
							30.181488000000005
						],
						[
							-85.773696,
							30.181510000000003
						],
						[
							-85.773483,
							30.181421
						],
						[
							-85.773437,
							30.178586
						],
						[
							-85.77124000000002,
							30.178590000000003
						],
						[
							-85.771209,
							30.179246000000003
						],
						[
							-85.771102,
							30.17938
						],
						[
							-85.770828,
							30.179487
						],
						[
							-85.76567,
							30.179513
						],
						[
							-85.76565500000001,
							30.181253000000005
						],
						[
							-85.767814,
							30.181226
						],
						[
							-85.767807,
							30.180934000000004
						],
						[
							-85.769012,
							30.180915
						],
						[
							-85.769065,
							30.182189000000005
						],
						[
							-85.765594,
							30.182218
						],
						[
							-85.76565500000001,
							30.183056000000004
						],
						[
							-85.768847,
							30.183050000000005
						],
						[
							-85.769005,
							30.183153999999995
						],
						[
							-85.769006,
							30.183439000000003
						],
						[
							-85.76881400000002,
							30.183595000000004
						],
						[
							-85.765672,
							30.183592000000004
						],
						[
							-85.765693,
							30.185886000000004
						],
						[
							-85.765457,
							30.18769
						],
						[
							-85.764328,
							30.188011000000003
						],
						[
							-85.761734,
							30.188305999999997
						],
						[
							-85.760925,
							30.18844
						],
						[
							-85.760795,
							30.188457
						],
						[
							-85.760841,
							30.183932999999996
						],
						[
							-85.760647,
							30.183943
						],
						[
							-85.760628,
							30.182674999999996
						],
						[
							-85.760002,
							30.176781999999996
						],
						[
							-85.759765,
							30.176720999999997
						],
						[
							-85.759857,
							30.175945000000002
						],
						[
							-85.759552,
							30.175914
						],
						[
							-85.759437,
							30.174779000000004
						],
						[
							-85.759437,
							30.174438
						],
						[
							-85.759574,
							30.173973000000004
						],
						[
							-85.75954400000002,
							30.173587000000005
						],
						[
							-85.760009,
							30.173564000000002
						],
						[
							-85.759941,
							30.172985000000004
						],
						[
							-85.759063,
							30.173042
						],
						[
							-85.758728,
							30.17275
						],
						[
							-85.758728,
							30.172658000000002
						],
						[
							-85.757934,
							30.172021
						],
						[
							-85.757324,
							30.170933999999995
						],
						[
							-85.757278,
							30.170673
						],
						[
							-85.757179,
							30.170574
						],
						[
							-85.756889,
							30.170351
						],
						[
							-85.75634,
							30.170167
						],
						[
							-85.755836,
							30.170283999999995
						],
						[
							-85.755615,
							30.170185
						],
						[
							-85.755523,
							30.170351
						],
						[
							-85.753639,
							30.170481999999996
						],
						[
							-85.753509,
							30.170585
						],
						[
							-85.753387,
							30.170429
						],
						[
							-85.753143,
							30.170448000000004
						],
						[
							-85.753158,
							30.170743000000005
						],
						[
							-85.753097,
							30.170799
						],
						[
							-85.752571,
							30.170801
						],
						[
							-85.752082,
							30.170960999999995
						],
						[
							-85.752265,
							30.172569
						],
						[
							-85.752082,
							30.172687
						],
						[
							-85.752006,
							30.17284
						],
						[
							-85.751991,
							30.173683
						],
						[
							-85.751632,
							30.174074
						],
						[
							-85.751739,
							30.175088
						],
						[
							-85.752632,
							30.176059000000002
						],
						[
							-85.752861,
							30.176068999999995
						],
						[
							-85.753158,
							30.176290000000005
						],
						[
							-85.75308900000002,
							30.176618000000005
						],
						[
							-85.753517,
							30.177063999999998
						],
						[
							-85.753616,
							30.177419000000004
						],
						[
							-85.753768,
							30.177387
						],
						[
							-85.753791,
							30.177186
						],
						[
							-85.754127,
							30.177341000000002
						],
						[
							-85.75415,
							30.177427000000005
						],
						[
							-85.753952,
							30.177593000000005
						],
						[
							-85.753692,
							30.179328
						],
						[
							-85.753509,
							30.179751999999997
						],
						[
							-85.753501,
							30.180149000000004
						],
						[
							-85.7527,
							30.182128
						],
						[
							-85.752723,
							30.182273
						],
						[
							-85.752838,
							30.182336
						],
						[
							-85.75343300000002,
							30.182394999999996
						],
						[
							-85.753601,
							30.182435
						],
						[
							-85.753623,
							30.182514000000005
						],
						[
							-85.753562,
							30.182674
						],
						[
							-85.753471,
							30.182698999999996
						],
						[
							-85.752807,
							30.182565
						],
						[
							-85.752418,
							30.18297
						],
						[
							-85.752044,
							30.183622000000003
						],
						[
							-85.752037,
							30.184097000000005
						],
						[
							-85.752471,
							30.184991
						],
						[
							-85.752487,
							30.185438
						],
						[
							-85.752639,
							30.185535
						],
						[
							-85.752708,
							30.185903
						],
						[
							-85.752609,
							30.186151000000002
						],
						[
							-85.752037,
							30.186765
						],
						[
							-85.751548,
							30.186908
						],
						[
							-85.750961,
							30.186885000000004
						],
						[
							-85.749984,
							30.187492
						],
						[
							-85.749786,
							30.18754
						],
						[
							-85.747734,
							30.187501
						],
						[
							-85.747589,
							30.187742
						],
						[
							-85.747596,
							30.188179999999996
						],
						[
							-85.747741,
							30.18831
						],
						[
							-85.748138,
							30.188358
						],
						[
							-85.750228,
							30.188344000000004
						],
						[
							-85.751434,
							30.189537
						],
						[
							-85.751716,
							30.189431999999996
						],
						[
							-85.751518,
							30.189157000000005
						],
						[
							-85.751564,
							30.188947000000002
						],
						[
							-85.751815,
							30.188829
						],
						[
							-85.752334,
							30.188842
						],
						[
							-85.752273,
							30.190349000000005
						],
						[
							-85.752143,
							30.191043
						],
						[
							-85.752388,
							30.192567000000004
						],
						[
							-85.752571,
							30.192869
						],
						[
							-85.752761,
							30.192832
						],
						[
							-85.752754,
							30.192335
						],
						[
							-85.753021,
							30.191934
						],
						[
							-85.75402,
							30.191808000000005
						],
						[
							-85.755241,
							30.191823
						],
						[
							-85.755477,
							30.191706999999997
						],
						[
							-85.755584,
							30.191564
						],
						[
							-85.755607,
							30.191265
						],
						[
							-85.755073,
							30.190027000000004
						],
						[
							-85.754913,
							30.189880000000002
						],
						[
							-85.754356,
							30.189867
						],
						[
							-85.754219,
							30.189779
						],
						[
							-85.754264,
							30.189636000000004
						],
						[
							-85.754936,
							30.189649
						],
						[
							-85.75529400000002,
							30.190025000000002
						],
						[
							-85.755813,
							30.191284
						],
						[
							-85.755805,
							30.19153
						],
						[
							-85.755653,
							30.191842999999995
						],
						[
							-85.755317,
							30.192026000000002
						],
						[
							-85.755043,
							30.192357999999995
						],
						[
							-85.754486,
							30.192533
						],
						[
							-85.753776,
							30.192481
						],
						[
							-85.753189,
							30.193038
						],
						[
							-85.752311,
							30.193094
						],
						[
							-85.751976,
							30.194036000000004
						],
						[
							-85.75193,
							30.194519
						],
						[
							-85.752006,
							30.194656
						],
						[
							-85.752311,
							30.194719
						],
						[
							-85.75254,
							30.194618000000002
						],
						[
							-85.752861,
							30.19469
						],
						[
							-85.753669,
							30.195043
						],
						[
							-85.754692,
							30.194726000000003
						],
						[
							-85.755897,
							30.194839000000005
						],
						[
							-85.757293,
							30.194827999999998
						],
						[
							-85.757629,
							30.194656
						],
						[
							-85.757659,
							30.193656
						],
						[
							-85.757751,
							30.193630000000002
						],
						[
							-85.757873,
							30.193733
						],
						[
							-85.757881,
							30.19441
						],
						[
							-85.758018,
							30.194736
						],
						[
							-85.760841,
							30.194757
						],
						[
							-85.76094,
							30.194870999999996
						],
						[
							-85.760894,
							30.194932
						],
						[
							-85.754486,
							30.194957
						],
						[
							-85.754302,
							30.194986
						],
						[
							-85.753982,
							30.195219999999996
						],
						[
							-85.753738,
							30.195249000000004
						],
						[
							-85.753517,
							30.195228000000004
						],
						[
							-85.75265500000002,
							30.194816000000003
						],
						[
							-85.752342,
							30.194803
						],
						[
							-85.751541,
							30.195446
						],
						[
							-85.750419,
							30.196762
						],
						[
							-85.749465,
							30.197689
						],
						[
							-85.747985,
							30.198934
						],
						[
							-85.747398,
							30.19975
						],
						[
							-85.747406,
							30.199989
						],
						[
							-85.747787,
							30.200224999999996
						],
						[
							-85.748252,
							30.200233000000004
						],
						[
							-85.748947,
							30.200720999999998
						],
						[
							-85.749252,
							30.200708
						],
						[
							-85.749382,
							30.200447000000004
						],
						[
							-85.749748,
							30.200332
						],
						[
							-85.750167,
							30.200074999999995
						],
						[
							-85.750076,
							30.199968
						],
						[
							-85.749633,
							30.200052
						],
						[
							-85.749603,
							30.199993000000003
						],
						[
							-85.749923,
							30.199213000000004
						],
						[
							-85.749916,
							30.199045
						],
						[
							-85.749687,
							30.198923
						],
						[
							-85.749633,
							30.198792999999995
						],
						[
							-85.750045,
							30.198791
						],
						[
							-85.750297,
							30.19889
						],
						[
							-85.750175,
							30.199211000000002
						],
						[
							-85.750167,
							30.199504
						],
						[
							-85.750434,
							30.200021
						],
						[
							-85.752098,
							30.199336999999996
						],
						[
							-85.752449,
							30.199283
						],
						[
							-85.752388,
							30.199588
						],
						[
							-85.752449,
							30.200004
						],
						[
							-85.75296000000002,
							30.200637000000004
						],
						[
							-85.752716,
							30.200689
						],
						[
							-85.75196,
							30.199911000000004
						],
						[
							-85.751258,
							30.199941
						],
						[
							-85.75083100000002,
							30.200068999999996
						],
						[
							-85.750724,
							30.200176
						],
						[
							-85.750823,
							30.200511000000002
						],
						[
							-85.751235,
							30.200761
						],
						[
							-85.751243,
							30.200839000000002
						],
						[
							-85.750801,
							30.200839000000002
						],
						[
							-85.750617,
							30.200426000000004
						],
						[
							-85.750396,
							30.200338
						],
						[
							-85.749618,
							30.200813
						],
						[
							-85.749588,
							30.201162
						],
						[
							-85.749351,
							30.201333
						],
						[
							-85.74832100000002,
							30.201395000000005
						],
						[
							-85.74813,
							30.201356000000004
						],
						[
							-85.747886,
							30.200487000000003
						],
						[
							-85.747276,
							30.200168
						],
						[
							-85.747131,
							30.200193
						],
						[
							-85.746574,
							30.201196
						],
						[
							-85.745574,
							30.202062
						],
						[
							-85.745201,
							30.202461000000003
						],
						[
							-85.744842,
							30.203041
						],
						[
							-85.744834,
							30.20366
						],
						[
							-85.74501,
							30.203845000000005
						],
						[
							-85.745788,
							30.204077999999996
						],
						[
							-85.746269,
							30.204014999999995
						],
						[
							-85.746322,
							30.204114
						],
						[
							-85.74562,
							30.204216000000002
						],
						[
							-85.744796,
							30.204899999999995
						],
						[
							-85.744682,
							30.205052999999996
						],
						[
							-85.74443,
							30.205839
						],
						[
							-85.744232,
							30.206134
						],
						[
							-85.744125,
							30.206583
						],
						[
							-85.744117,
							30.207108999999996
						],
						[
							-85.743972,
							30.207411999999998
						],
						[
							-85.744071,
							30.207806999999995
						],
						[
							-85.744064,
							30.208477
						],
						[
							-85.743843,
							30.211338
						],
						[
							-85.744247,
							30.212108
						],
						[
							-85.744537,
							30.212947000000003
						],
						[
							-85.744743,
							30.213136
						],
						[
							-85.744888,
							30.213119000000003
						],
						[
							-85.744567,
							30.212329
						],
						[
							-85.744392,
							30.211526
						],
						[
							-85.744415,
							30.211233
						],
						[
							-85.744613,
							30.211013
						],
						[
							-85.744651,
							30.210767
						],
						[
							-85.745407,
							30.210323000000002
						],
						[
							-85.745483,
							30.209915
						],
						[
							-85.746315,
							30.209602
						],
						[
							-85.746986,
							30.2089
						],
						[
							-85.747558,
							30.208652000000004
						],
						[
							-85.747734,
							30.208670999999995
						],
						[
							-85.747863,
							30.208789
						],
						[
							-85.747879,
							30.209451
						],
						[
							-85.747955,
							30.209624999999996
						],
						[
							-85.748596,
							30.209836
						],
						[
							-85.748779,
							30.210039
						],
						[
							-85.748703,
							30.210266
						],
						[
							-85.748222,
							30.210721
						],
						[
							-85.74826,
							30.210889
						],
						[
							-85.748153,
							30.211460000000002
						],
						[
							-85.748222,
							30.211624
						],
						[
							-85.748329,
							30.211608000000002
						],
						[
							-85.748649,
							30.211288
						],
						[
							-85.749114,
							30.210379999999997
						],
						[
							-85.749565,
							30.210211999999995
						],
						[
							-85.749717,
							30.21034
						],
						[
							-85.749786,
							30.210699
						],
						[
							-85.750823,
							30.210685
						],
						[
							-85.75131200000001,
							30.211137
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Bay",
				"City": "Panama City",
				"Name": "Upper Grand Lagoon",
				"RegionID": "126471"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.70957932199991,
					30.232020838000043,
					-81.68004057399992,
					30.25363100800007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.6931618719999,
							30.253043028000036
						],
						[
							-81.69268890599994,
							30.25256700700004
						],
						[
							-81.6924379049999,
							30.252219009000044
						],
						[
							-81.69189790599995,
							30.251502009000035
						],
						[
							-81.69167690499997,
							30.251229009000042
						],
						[
							-81.6911399999999,
							30.250724000000044
						],
						[
							-81.68980932499994,
							30.250817557000065
						],
						[
							-81.68882898099992,
							30.250194543000077
						],
						[
							-81.68814512999995,
							30.249909943000034
						],
						[
							-81.68688027699994,
							30.249668354000047
						],
						[
							-81.68674141299994,
							30.249630087000074
						],
						[
							-81.68661504699992,
							30.24957269600009
						],
						[
							-81.6854661399999,
							30.248939748000055
						],
						[
							-81.68414221599994,
							30.248210789000044
						],
						[
							-81.68052226799995,
							30.246217307000048
						],
						[
							-81.68038592699992,
							30.24612292000006
						],
						[
							-81.6802750789999,
							30.246012073000088
						],
						[
							-81.68018516399991,
							30.24588366100005
						],
						[
							-81.68011891299994,
							30.24574158600007
						],
						[
							-81.68008676599993,
							30.245632093000044
						],
						[
							-81.68004057399992,
							30.245604186000037
						],
						[
							-81.68087899999995,
							30.245059000000083
						],
						[
							-81.68108607599993,
							30.24473404400004
						],
						[
							-81.68105082199992,
							30.244443999000058
						],
						[
							-81.68116990699991,
							30.244094009000037
						],
						[
							-81.68561279799991,
							30.234662854000078
						],
						[
							-81.68750990599995,
							30.23447900800005
						],
						[
							-81.6954079059999,
							30.23429300900005
						],
						[
							-81.69713290399996,
							30.23452400800005
						],
						[
							-81.69763390599991,
							30.23450000800005
						],
						[
							-81.69787290599993,
							30.23448900900007
						],
						[
							-81.69799001799993,
							30.23448916500007
						],
						[
							-81.6980899049999,
							30.23416600800005
						],
						[
							-81.69813890599994,
							30.233987008000042
						],
						[
							-81.69819090499993,
							30.233825008000057
						],
						[
							-81.69826190599991,
							30.233486008000057
						],
						[
							-81.69874783499995,
							30.232020838000043
						],
						[
							-81.69884090599993,
							30.232065008000063
						],
						[
							-81.69906206999991,
							30.232151982000065
						],
						[
							-81.6989078389999,
							30.232275961000084
						],
						[
							-81.69858801299995,
							30.233106163000063
						],
						[
							-81.6985117989999,
							30.233105854000087
						],
						[
							-81.69835990699994,
							30.23351400900009
						],
						[
							-81.69832690499993,
							30.233645008000057
						],
						[
							-81.6982507749999,
							30.233855985000048
						],
						[
							-81.69828584899994,
							30.234401002000087
						],
						[
							-81.69788890599995,
							30.235932009000063
						],
						[
							-81.6975297219999,
							30.237277068000086
						],
						[
							-81.69802790499995,
							30.237723009000035
						],
						[
							-81.70044683299994,
							30.240311176000038
						],
						[
							-81.7052969259999,
							30.240300089000073
						],
						[
							-81.70637690899991,
							30.239723820000048
						],
						[
							-81.7073709089999,
							30.240290201000047
						],
						[
							-81.70847399999991,
							30.239515000000043
						],
						[
							-81.70921406199994,
							30.23899491900005
						],
						[
							-81.70926097899992,
							30.23907974800005
						],
						[
							-81.70931908599994,
							30.239207414000077
						],
						[
							-81.70933999999994,
							30.239272464000067
						],
						[
							-81.70950999999991,
							30.23987946400007
						],
						[
							-81.70952743799995,
							30.23995372300004
						],
						[
							-81.70956454899994,
							30.24014877800005
						],
						[
							-81.70957932199991,
							30.24031100000008
						],
						[
							-81.70957670699994,
							30.240379541000042
						],
						[
							-81.70956470599992,
							30.24053654100004
						],
						[
							-81.70955445599992,
							30.24061957500004
						],
						[
							-81.70942880699994,
							30.24135440600008
						],
						[
							-81.70946710499993,
							30.241806006000047
						],
						[
							-81.7094703219999,
							30.24188200000009
						],
						[
							-81.70946360999994,
							30.24199167100005
						],
						[
							-81.70942760999992,
							30.24228467100005
						],
						[
							-81.70941651699991,
							30.242353065000092
						],
						[
							-81.70925304999992,
							30.243162316000053
						],
						[
							-81.70926401899993,
							30.244516935000036
						],
						[
							-81.70938759699993,
							30.245998920000087
						],
						[
							-81.70943823699992,
							30.246277480000064
						],
						[
							-81.70945232199995,
							30.246436000000074
						],
						[
							-81.70944671799992,
							30.246536238000093
						],
						[
							-81.70933982399993,
							30.247489287000064
						],
						[
							-81.70932892899992,
							30.247588337000078
						],
						[
							-81.70931673599995,
							30.24766697900009
						],
						[
							-81.7092976379999,
							30.247744235000084
						],
						[
							-81.70927178499994,
							30.247819501000034
						],
						[
							-81.70923937899995,
							30.24789218600006
						],
						[
							-81.70919011899991,
							30.247990701000052
						],
						[
							-81.70898392499994,
							30.248406931000094
						],
						[
							-81.70823932799993,
							30.250076334000088
						],
						[
							-81.7081839889999,
							30.250181211000037
						],
						[
							-81.70805593599994,
							30.250389372000086
						],
						[
							-81.70803051299993,
							30.250537320000035
						],
						[
							-81.70804898699993,
							30.250876019000092
						],
						[
							-81.70805021399991,
							30.250938923000035
						],
						[
							-81.70804703999995,
							30.251001758000086
						],
						[
							-81.7080394809999,
							30.251064218000067
						],
						[
							-81.70803399099992,
							30.251092701000058
						],
						[
							-81.7069929999999,
							30.251438000000064
						],
						[
							-81.70643384499994,
							30.251802183000052
						],
						[
							-81.70631500199994,
							30.25147984600005
						],
						[
							-81.70360785199995,
							30.251886192000082
						],
						[
							-81.70237993899991,
							30.250744819000094
						],
						[
							-81.70172390599993,
							30.251019009000064
						],
						[
							-81.70105987199992,
							30.251432968000078
						],
						[
							-81.7001909889999,
							30.252425174000052
						],
						[
							-81.70006480799992,
							30.252434845000035
						],
						[
							-81.6996079029999,
							30.25314717700007
						],
						[
							-81.69922302499992,
							30.252494864000088
						],
						[
							-81.69902985899995,
							30.252426075000077
						],
						[
							-81.69884686699993,
							30.25219822600008
						],
						[
							-81.6987609059999,
							30.25184800800008
						],
						[
							-81.6981319059999,
							30.24928200800008
						],
						[
							-81.69801790499992,
							30.248819008000055
						],
						[
							-81.69789890599992,
							30.24837300800004
						],
						[
							-81.69784390599995,
							30.24784900900005
						],
						[
							-81.69783295499991,
							30.24778499000007
						],
						[
							-81.69778290499994,
							30.247682008000083
						],
						[
							-81.69775387699991,
							30.24762189900008
						],
						[
							-81.69775390599995,
							30.247682009000076
						],
						[
							-81.69775590499995,
							30.248138008000065
						],
						[
							-81.69768381999995,
							30.24880501500007
						],
						[
							-81.6977999579999,
							30.24922399900004
						],
						[
							-81.6977919059999,
							30.24999800900008
						],
						[
							-81.6977919059999,
							30.25227700800008
						],
						[
							-81.6977920359999,
							30.252996142000086
						],
						[
							-81.6974488109999,
							30.25297617300004
						],
						[
							-81.69742700799992,
							30.252942855000075
						],
						[
							-81.69731790599991,
							30.25292201000008
						],
						[
							-81.69697189699991,
							30.252934956000043
						],
						[
							-81.69644990599994,
							30.25309901000009
						],
						[
							-81.69607090599993,
							30.253290008000075
						],
						[
							-81.69565490499991,
							30.253489008000088
						],
						[
							-81.69526991499993,
							30.253603061000035
						],
						[
							-81.69489690599995,
							30.25363100800007
						],
						[
							-81.69458990599992,
							30.253622008000033
						],
						[
							-81.6939528609999,
							30.253536134000058
						],
						[
							-81.6933819059999,
							30.253223007000088
						],
						[
							-81.6931618719999,
							30.253043028000036
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Venetia",
				"RegionID": "126488"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.74312705099993,
					30.233797008000067,
					-81.70917777099993,
					30.248425008000083
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.74267590599993,
							30.248425008000083
						],
						[
							-81.74018090599992,
							30.24839800900008
						],
						[
							-81.7396769049999,
							30.24841300800006
						],
						[
							-81.73902078599991,
							30.24840015600006
						],
						[
							-81.73899790599995,
							30.24830400900004
						],
						[
							-81.73895990599993,
							30.24820100800008
						],
						[
							-81.7388839059999,
							30.247910009000066
						],
						[
							-81.73882290599994,
							30.24760800900009
						],
						[
							-81.73875390599994,
							30.247351008000066
						],
						[
							-81.73874702699993,
							30.247275864000073
						],
						[
							-81.73850990499994,
							30.24729300800004
						],
						[
							-81.73826590499993,
							30.247295008000034
						],
						[
							-81.73687690499992,
							30.247305009000062
						],
						[
							-81.73631290499992,
							30.247311008000054
						],
						[
							-81.7353309049999,
							30.24732200900007
						],
						[
							-81.73500077099993,
							30.247323879000078
						],
						[
							-81.73503100499995,
							30.247683147000092
						],
						[
							-81.73490090599995,
							30.24762700900004
						],
						[
							-81.73468790599992,
							30.247561009000037
						],
						[
							-81.73428490499992,
							30.247481008000076
						],
						[
							-81.73390990599995,
							30.247408008000036
						],
						[
							-81.73368090499991,
							30.247381009000037
						],
						[
							-81.73329190499993,
							30.247360008000044
						],
						[
							-81.73303190599995,
							30.24734100800003
						],
						[
							-81.73257390599991,
							30.247335008000054
						],
						[
							-81.7319949059999,
							30.24734500900007
						],
						[
							-81.73156690499991,
							30.247360008000044
						],
						[
							-81.73069790499994,
							30.24736995300009
						],
						[
							-81.72940090499992,
							30.24737000800008
						],
						[
							-81.72653990499992,
							30.24740000900005
						],
						[
							-81.72622290599992,
							30.24739500800007
						],
						[
							-81.72608890499993,
							30.24739800800006
						],
						[
							-81.72598890499997,
							30.247404008000046
						],
						[
							-81.72565490599993,
							30.24740600800004
						],
						[
							-81.72552090499994,
							30.24740600800004
						],
						[
							-81.72531390599994,
							30.247408008000036
						],
						[
							-81.72484590599994,
							30.247412008000083
						],
						[
							-81.7238239049999,
							30.24742300800006
						],
						[
							-81.72223690599992,
							30.247433008000083
						],
						[
							-81.7209849059999,
							30.24743500800008
						],
						[
							-81.71936790599995,
							30.247450008000044
						],
						[
							-81.71835290599995,
							30.24745200800004
						],
						[
							-81.71673590599994,
							30.24747500800004
						],
						[
							-81.71578990499995,
							30.24746700800006
						],
						[
							-81.71532390499993,
							30.24747100800005
						],
						[
							-81.7151828829999,
							30.247468877000074
						],
						[
							-81.71500592899993,
							30.247542139000075
						],
						[
							-81.71438290499992,
							30.247535008000057
						],
						[
							-81.7140279059999,
							30.247535008000057
						],
						[
							-81.71382279499994,
							30.247542166000073
						],
						[
							-81.71379101999992,
							30.24744585700006
						],
						[
							-81.71361690599991,
							30.24743500800008
						],
						[
							-81.7127889059999,
							30.247450008000044
						],
						[
							-81.71187784999995,
							30.24746084200007
						],
						[
							-81.71174090599993,
							30.247562009000035
						],
						[
							-81.71161582899992,
							30.247654129000065
						],
						[
							-81.71163604799995,
							30.247562891000083
						],
						[
							-81.7114499999999,
							30.247567000000064
						],
						[
							-81.71055004699991,
							30.247577702000058
						],
						[
							-81.71055104999994,
							30.24754117600008
						],
						[
							-81.71055408299992,
							30.247440031000053
						],
						[
							-81.7105617169999,
							30.247347029000082
						],
						[
							-81.7105694039999,
							30.247290123000088
						],
						[
							-81.71057365299993,
							30.24726079500004
						],
						[
							-81.71057892899995,
							30.247203788000032
						],
						[
							-81.7106076099999,
							30.246924492000062
						],
						[
							-81.71060608099992,
							30.246907153000052
						],
						[
							-81.71052678799992,
							30.24598756900008
						],
						[
							-81.71037389399993,
							30.245028595000065
						],
						[
							-81.71037041699992,
							30.24500473300009
						],
						[
							-81.71027974699992,
							30.244318090000036
						],
						[
							-81.71011906299992,
							30.24360539800006
						],
						[
							-81.71008342699992,
							30.243449997000088
						],
						[
							-81.71007434099994,
							30.24340516500007
						],
						[
							-81.71006067799993,
							30.24324900000005
						],
						[
							-81.71007434099994,
							30.243092834000038
						],
						[
							-81.71011491399992,
							30.24294141300004
						],
						[
							-81.7101357549999,
							30.242889277000074
						],
						[
							-81.71031467799992,
							30.24247930400008
						],
						[
							-81.71031467799992,
							30.242269000000082
						],
						[
							-81.71031467799992,
							30.241859319000074
						],
						[
							-81.71026898199995,
							30.241611717000065
						],
						[
							-81.7102546779999,
							30.241452000000038
						],
						[
							-81.71026323299992,
							30.241328252000073
						],
						[
							-81.71046922799991,
							30.23984543900008
						],
						[
							-81.7103563949999,
							30.23968600100005
						],
						[
							-81.70993202199992,
							30.239218362000088
						],
						[
							-81.70988560199993,
							30.239162880000038
						],
						[
							-81.70984379099991,
							30.239103846000038
						],
						[
							-81.7098068599999,
							30.23904164200008
						],
						[
							-81.7094668599999,
							30.23841264200007
						],
						[
							-81.70944252099991,
							30.238364175000076
						],
						[
							-81.70936951999994,
							30.23820717500007
						],
						[
							-81.70933991299995,
							30.238135586000055
						],
						[
							-81.70931074999993,
							30.23803887200006
						],
						[
							-81.70926274999994,
							30.237839872000052
						],
						[
							-81.70925134099991,
							30.237785165000048
						],
						[
							-81.70923877099995,
							30.237673330000067
						],
						[
							-81.70917777099993,
							30.236437330000058
						],
						[
							-81.70918194399991,
							30.236295819000077
						],
						[
							-81.7092069439999,
							30.23606581900009
						],
						[
							-81.70921200499993,
							30.236027102000037
						],
						[
							-81.70923600599991,
							30.235870102000032
						],
						[
							-81.70924936999995,
							30.235800936000093
						],
						[
							-81.7092681069999,
							30.235733029000073
						],
						[
							-81.7092921009999,
							30.23566679600009
						],
						[
							-81.70954056799991,
							30.235055344000045
						],
						[
							-81.70954067799994,
							30.234957031000082
						],
						[
							-81.70939414299994,
							30.234048143000052
						],
						[
							-81.70938275099991,
							30.233916412000042
						],
						[
							-81.70938274999992,
							30.23391638600009
						],
						[
							-81.71028199999995,
							30.23390500000005
						],
						[
							-81.71233490599992,
							30.23387900800009
						],
						[
							-81.71356192699994,
							30.233871089000047
						],
						[
							-81.7136538819999,
							30.233821926000076
						],
						[
							-81.71373690599995,
							30.23381600900007
						],
						[
							-81.71430990599993,
							30.233816008000076
						],
						[
							-81.71611790499992,
							30.233807008000042
						],
						[
							-81.7185359049999,
							30.23380300900004
						],
						[
							-81.71948990599992,
							30.233799008000062
						],
						[
							-81.72041290499993,
							30.233797008000067
						],
						[
							-81.72133590599992,
							30.233805008000047
						],
						[
							-81.72225990599992,
							30.233805008000047
						],
						[
							-81.72300690499992,
							30.233805008000047
						],
						[
							-81.72416690599994,
							30.233810008000034
						],
						[
							-81.7245179059999,
							30.23382200800006
						],
						[
							-81.7246549059999,
							30.233807009000092
						],
						[
							-81.7249449059999,
							30.233809008000037
						],
						[
							-81.72545590599994,
							30.233807008000042
						],
						[
							-81.7261429049999,
							30.233805008000047
						],
						[
							-81.7306899049999,
							30.233807008000042
						],
						[
							-81.73329190499993,
							30.233812008000086
						],
						[
							-81.73422990599994,
							30.233810008000034
						],
						[
							-81.7344509049999,
							30.233810008000034
						],
						[
							-81.73868590599994,
							30.233824009000042
						],
						[
							-81.73920790599993,
							30.23381900700008
						],
						[
							-81.73932590599992,
							30.23381800800007
						],
						[
							-81.73944248999993,
							30.23380746700008
						],
						[
							-81.73958390599995,
							30.234337008000068
						],
						[
							-81.73961190499995,
							30.234411008000052
						],
						[
							-81.73961990499993,
							30.234434008000054
						],
						[
							-81.73970190599994,
							30.23468100900004
						],
						[
							-81.73997890499993,
							30.235518008000046
						],
						[
							-81.74000590499993,
							30.23558200900004
						],
						[
							-81.74007190599991,
							30.23578100800006
						],
						[
							-81.74008590599993,
							30.23582200800007
						],
						[
							-81.74019890599993,
							30.236109009000078
						],
						[
							-81.74060090499995,
							30.23725000800005
						],
						[
							-81.74074190499994,
							30.237650009000053
						],
						[
							-81.74119290499993,
							30.238937008000054
						],
						[
							-81.74145590599994,
							30.23968800800009
						],
						[
							-81.74179490499995,
							30.240657009000078
						],
						[
							-81.74180290599992,
							30.240681008000077
						],
						[
							-81.7420794059999,
							30.241471509000068
						],
						[
							-81.74212090599991,
							30.241579009000077
						],
						[
							-81.74214690499991,
							30.241661008000055
						],
						[
							-81.74217790599994,
							30.24175700800004
						],
						[
							-81.74231190499995,
							30.242084008000067
						],
						[
							-81.7423979049999,
							30.24234900900007
						],
						[
							-81.74241790499991,
							30.242419008000066
						],
						[
							-81.74247290599995,
							30.24261400800009
						],
						[
							-81.74258290599994,
							30.242920009000045
						],
						[
							-81.74264990499995,
							30.243217009000034
						],
						[
							-81.74281890599991,
							30.24383700800007
						],
						[
							-81.7429584059999,
							30.244465508000076
						],
						[
							-81.7429839049999,
							30.244683008000038
						],
						[
							-81.74308790599991,
							30.24550500800007
						],
						[
							-81.74312705099993,
							30.245883122000066
						],
						[
							-81.74301175999994,
							30.245892894000065
						],
						[
							-81.74302690499991,
							30.246038008000085
						],
						[
							-81.74302690499991,
							30.246319008000057
						],
						[
							-81.74306490499993,
							30.24688100900005
						],
						[
							-81.74305690599994,
							30.247456008000086
						],
						[
							-81.74307290599995,
							30.248060010000074
						],
						[
							-81.74306492399995,
							30.248419098000056
						],
						[
							-81.74294890399995,
							30.248420954000043
						],
						[
							-81.74267590599993,
							30.248425008000083
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Wesconnett",
				"RegionID": "126585"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.49639699999994,
					27.30626600000005,
					-82.44104299999998,
					27.357225000000028
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.44677199999995,
							27.357125000000053
						],
						[
							-82.44675899999999,
							27.349944000000054
						],
						[
							-82.44676999999996,
							27.346652000000063
						],
						[
							-82.44682299999994,
							27.34463900000003
						],
						[
							-82.44684899999999,
							27.344171000000074
						],
						[
							-82.44644599999998,
							27.344152000000065
						],
						[
							-82.44609699999995,
							27.343510000000038
						],
						[
							-82.44608499999998,
							27.344059000000076
						],
						[
							-82.44607799999994,
							27.344088000000056
						],
						[
							-82.44606199999998,
							27.344114000000047
						],
						[
							-82.44602499999996,
							27.34413500000005
						],
						[
							-82.44595499999997,
							27.344147000000078
						],
						[
							-82.44590399999998,
							27.34412800000007
						],
						[
							-82.44584799999996,
							27.344120000000032
						],
						[
							-82.44510999999996,
							27.34410900000006
						],
						[
							-82.44437199999999,
							27.34409900000003
						],
						[
							-82.44162199999994,
							27.344061000000067
						],
						[
							-82.44151299999999,
							27.343440000000044
						],
						[
							-82.44152199999996,
							27.342843000000073
						],
						[
							-82.44144999999999,
							27.342517000000043
						],
						[
							-82.44143699999995,
							27.34216300000003
						],
						[
							-82.44143099999997,
							27.342002000000036
						],
						[
							-82.44138799999996,
							27.340798000000063
						],
						[
							-82.44137899999998,
							27.340082000000052
						],
						[
							-82.44137899999998,
							27.339485000000025
						],
						[
							-82.44133399999998,
							27.339079000000027
						],
						[
							-82.44132399999995,
							27.33861900000005
						],
						[
							-82.44120399999997,
							27.33843200000007
						],
						[
							-82.44104299999998,
							27.33818400000007
						],
						[
							-82.44104599999997,
							27.337208000000032
						],
						[
							-82.44104999999996,
							27.336233000000053
						],
						[
							-82.44105899999994,
							27.335727000000077
						],
						[
							-82.44105999999994,
							27.335163000000023
						],
						[
							-82.44106799999997,
							27.334742000000062
						],
						[
							-82.44106799999997,
							27.33434100000005
						],
						[
							-82.44108099999995,
							27.33416900000003
						],
						[
							-82.44108799999998,
							27.33317900000003
						],
						[
							-82.44110599999993,
							27.33182400000004
						],
						[
							-82.44109899999995,
							27.331679000000065
						],
						[
							-82.44108799999998,
							27.331551000000047
						],
						[
							-82.44108599999998,
							27.331525000000056
						],
						[
							-82.44108399999999,
							27.331504000000052
						],
						[
							-82.44108699999998,
							27.331416000000047
						],
						[
							-82.44110199999994,
							27.331303000000048
						],
						[
							-82.44111399999997,
							27.331048000000067
						],
						[
							-82.44110799999999,
							27.330671000000052
						],
						[
							-82.44111599999997,
							27.32851800000003
						],
						[
							-82.44109999999995,
							27.327638000000036
						],
						[
							-82.44112199999995,
							27.32592500000004
						],
						[
							-82.44111599999997,
							27.325833000000046
						],
						[
							-82.44109699999996,
							27.325710000000072
						],
						[
							-82.44109899999995,
							27.325662000000023
						],
						[
							-82.44109999999995,
							27.32562000000007
						],
						[
							-82.44110099999995,
							27.32558300000005
						],
						[
							-82.44110899999998,
							27.32551200000006
						],
						[
							-82.44110299999994,
							27.325082000000066
						],
						[
							-82.44109599999996,
							27.32357200000007
						],
						[
							-82.44110899999998,
							27.323240000000055
						],
						[
							-82.44112099999995,
							27.32320800000008
						],
						[
							-82.44113799999997,
							27.323196000000053
						],
						[
							-82.44112499999994,
							27.32314400000007
						],
						[
							-82.44111099999998,
							27.32312900000005
						],
						[
							-82.44109099999997,
							27.323095000000023
						],
						[
							-82.44107999999994,
							27.322939000000076
						],
						[
							-82.44108799999998,
							27.320029000000034
						],
						[
							-82.44110299999994,
							27.31875800000006
						],
						[
							-82.44109199999997,
							27.317389000000052
						],
						[
							-82.44110599999993,
							27.31701000000004
						],
						[
							-82.44112899999999,
							27.316738000000043
						],
						[
							-82.44116899999995,
							27.316493000000037
						],
						[
							-82.44123999999994,
							27.316198000000043
						],
						[
							-82.44130399999995,
							27.315986000000066
						],
						[
							-82.44138099999998,
							27.315792000000044
						],
						[
							-82.44148599999994,
							27.31557900000007
						],
						[
							-82.44162199999994,
							27.315337000000056
						],
						[
							-82.44178099999995,
							27.315090000000055
						],
						[
							-82.44190699999996,
							27.314921000000027
						],
						[
							-82.44207399999993,
							27.314729000000057
						],
						[
							-82.44224599999995,
							27.314558000000034
						],
						[
							-82.44249699999995,
							27.314298000000065
						],
						[
							-82.44294899999994,
							27.313863000000026
						],
						[
							-82.44318699999997,
							27.313611000000037
						],
						[
							-82.44321299999996,
							27.31358400000005
						],
						[
							-82.44324599999999,
							27.313549000000023
						],
						[
							-82.44338799999997,
							27.313429000000045
						],
						[
							-82.44429199999996,
							27.312618000000043
						],
						[
							-82.44470599999994,
							27.312208000000055
						],
						[
							-82.44523099999998,
							27.311717000000044
						],
						[
							-82.44555199999996,
							27.311393000000066
						],
						[
							-82.44580299999996,
							27.311154000000045
						],
						[
							-82.44650199999995,
							27.310506000000032
						],
						[
							-82.44674399999997,
							27.310277000000042
						],
						[
							-82.44679699999996,
							27.310238000000027
						],
						[
							-82.44692099999997,
							27.310163000000045
						],
						[
							-82.44698599999998,
							27.310110000000066
						],
						[
							-82.44711399999994,
							27.30995400000006
						],
						[
							-82.44717399999996,
							27.30988700000006
						],
						[
							-82.44728299999997,
							27.309727000000066
						],
						[
							-82.44736199999996,
							27.30931000000004
						],
						[
							-82.44781499999993,
							27.30931700000008
						],
						[
							-82.44819599999994,
							27.30873500000007
						],
						[
							-82.44828899999999,
							27.308733000000075
						],
						[
							-82.44848399999997,
							27.30872400000004
						],
						[
							-82.44858699999997,
							27.30871300000007
						],
						[
							-82.44865099999998,
							27.308701000000042
						],
						[
							-82.44868199999996,
							27.308697000000052
						],
						[
							-82.44876999999997,
							27.308689000000072
						],
						[
							-82.44892099999998,
							27.308689000000072
						],
						[
							-82.44937699999997,
							27.308701000000042
						],
						[
							-82.44972199999995,
							27.30870500000003
						],
						[
							-82.44997999999998,
							27.308719000000057
						],
						[
							-82.45063699999997,
							27.30872800000003
						],
						[
							-82.45088199999998,
							27.308726000000036
						],
						[
							-82.45140799999996,
							27.308736000000067
						],
						[
							-82.45149099999998,
							27.308736000000067
						],
						[
							-82.45149399999997,
							27.30865300000005
						],
						[
							-82.45175599999999,
							27.30845000000005
						],
						[
							-82.45446899999996,
							27.30849500000005
						],
						[
							-82.45726599999995,
							27.30840500000005
						],
						[
							-82.45873199999994,
							27.30812100000003
						],
						[
							-82.45908999999995,
							27.307326000000046
						],
						[
							-82.45911299999995,
							27.30727600000006
						],
						[
							-82.45953299999996,
							27.30634900000007
						],
						[
							-82.45957099999998,
							27.30626600000005
						],
						[
							-82.45957499999997,
							27.306418000000065
						],
						[
							-82.45956599999994,
							27.30648300000007
						],
						[
							-82.45954999999998,
							27.306543000000033
						],
						[
							-82.45953299999996,
							27.306696000000045
						],
						[
							-82.45950999999997,
							27.30682500000006
						],
						[
							-82.45950299999998,
							27.30691100000007
						],
						[
							-82.45950499999998,
							27.30697900000007
						],
						[
							-82.45953599999996,
							27.307267000000028
						],
						[
							-82.45953399999996,
							27.307307000000037
						],
						[
							-82.45952099999994,
							27.307394000000045
						],
						[
							-82.45951399999996,
							27.30748600000004
						],
						[
							-82.45949499999995,
							27.307588000000067
						],
						[
							-82.45952499999999,
							27.307622000000038
						],
						[
							-82.45958699999994,
							27.30767000000003
						],
						[
							-82.45979499999999,
							27.30780600000003
						],
						[
							-82.45994099999996,
							27.30791400000004
						],
						[
							-82.46014799999995,
							27.308037000000073
						],
						[
							-82.46049599999998,
							27.308264000000065
						],
						[
							-82.46068999999994,
							27.30838600000004
						],
						[
							-82.46079199999997,
							27.308456000000035
						],
						[
							-82.46087499999999,
							27.308500000000038
						],
						[
							-82.46096899999998,
							27.308531000000073
						],
						[
							-82.46106499999996,
							27.308577000000074
						],
						[
							-82.46109599999994,
							27.30860100000007
						],
						[
							-82.46116399999994,
							27.30866400000008
						],
						[
							-82.46119799999997,
							27.308686000000023
						],
						[
							-82.46128699999997,
							27.30872800000003
						],
						[
							-82.46131699999995,
							27.308746000000042
						],
						[
							-82.46142599999996,
							27.30884400000008
						],
						[
							-82.46158999999994,
							27.308951000000036
						],
						[
							-82.46163799999994,
							27.308993000000044
						],
						[
							-82.46167399999996,
							27.30903500000005
						],
						[
							-82.46181299999995,
							27.309239000000048
						],
						[
							-82.46183999999994,
							27.309252000000072
						],
						[
							-82.46189599999997,
							27.309271000000024
						],
						[
							-82.46209499999998,
							27.309401000000037
						],
						[
							-82.46266399999996,
							27.30973700000004
						],
						[
							-82.46287599999995,
							27.30988900000006
						],
						[
							-82.46306299999999,
							27.310007000000045
						],
						[
							-82.46310999999999,
							27.31004400000006
						],
						[
							-82.46319799999998,
							27.310128000000077
						],
						[
							-82.46323699999994,
							27.310160000000053
						],
						[
							-82.46354999999994,
							27.310376000000076
						],
						[
							-82.46400499999999,
							27.310713000000078
						],
						[
							-82.46457999999996,
							27.31108000000006
						],
						[
							-82.46462499999996,
							27.311104000000057
						],
						[
							-82.46464199999997,
							27.311124000000063
						],
						[
							-82.46466399999997,
							27.311159000000032
						],
						[
							-82.46470699999998,
							27.311235000000067
						],
						[
							-82.46472299999994,
							27.311248000000035
						],
						[
							-82.46498299999998,
							27.31139100000007
						],
						[
							-82.46522399999998,
							27.311555000000055
						],
						[
							-82.46548499999994,
							27.311740000000043
						],
						[
							-82.46566599999994,
							27.31187600000004
						],
						[
							-82.46584099999995,
							27.311983000000055
						],
						[
							-82.46596299999999,
							27.31206700000007
						],
						[
							-82.46613199999996,
							27.31218400000006
						],
						[
							-82.46617699999996,
							27.312223000000074
						],
						[
							-82.46651599999996,
							27.312447000000077
						],
						[
							-82.46657699999997,
							27.312498000000062
						],
						[
							-82.46661899999998,
							27.312545000000057
						],
						[
							-82.46671399999997,
							27.312632000000068
						],
						[
							-82.46680399999997,
							27.312708000000043
						],
						[
							-82.46687799999995,
							27.312756000000036
						],
						[
							-82.46716499999997,
							27.31290000000007
						],
						[
							-82.46721799999995,
							27.312946000000068
						],
						[
							-82.46732799999995,
							27.313053000000025
						],
						[
							-82.46741799999995,
							27.31310300000007
						],
						[
							-82.46744199999995,
							27.313120000000026
						],
						[
							-82.46750799999995,
							27.313180000000045
						],
						[
							-82.46753899999999,
							27.31321500000007
						],
						[
							-82.46776699999998,
							27.313391000000024
						],
						[
							-82.46816799999993,
							27.313667000000066
						],
						[
							-82.46819599999998,
							27.31368600000008
						],
						[
							-82.46849699999996,
							27.31388700000008
						],
						[
							-82.46883099999997,
							27.314087000000033
						],
						[
							-82.46885599999996,
							27.31411100000003
						],
						[
							-82.46889499999997,
							27.31416100000007
						],
						[
							-82.46896399999997,
							27.314224000000024
						],
						[
							-82.46904699999999,
							27.314287000000036
						],
						[
							-82.46916299999998,
							27.314336000000026
						],
						[
							-82.46924399999995,
							27.314392000000055
						],
						[
							-82.46931099999995,
							27.314446000000032
						],
						[
							-82.46952899999997,
							27.314590000000067
						],
						[
							-82.46974399999993,
							27.314767000000074
						],
						[
							-82.46978499999994,
							27.314810000000023
						],
						[
							-82.46991299999996,
							27.314886000000058
						],
						[
							-82.47035899999997,
							27.31519300000008
						],
						[
							-82.47042799999997,
							27.315267000000063
						],
						[
							-82.47060299999998,
							27.315369000000032
						],
						[
							-82.47065699999996,
							27.31539600000008
						],
						[
							-82.47072699999995,
							27.315459000000033
						],
						[
							-82.47074599999998,
							27.315488000000073
						],
						[
							-82.47077699999994,
							27.31551200000007
						],
						[
							-82.47085399999997,
							27.315555000000074
						],
						[
							-82.47091399999994,
							27.31556800000004
						],
						[
							-82.47097299999996,
							27.31561000000005
						],
						[
							-82.47100199999994,
							27.31564000000003
						],
						[
							-82.47108199999997,
							27.31571400000007
						],
						[
							-82.47157799999997,
							27.316059000000052
						],
						[
							-82.47182499999998,
							27.316231000000073
						],
						[
							-82.47191099999998,
							27.316309000000047
						],
						[
							-82.47199299999994,
							27.31636400000008
						],
						[
							-82.47206199999995,
							27.31639800000005
						],
						[
							-82.47250299999996,
							27.316718000000037
						],
						[
							-82.47254699999996,
							27.31675600000006
						],
						[
							-82.47266099999996,
							27.316810000000032
						],
						[
							-82.47283599999997,
							27.316922000000037
						],
						[
							-82.47322099999997,
							27.317220000000077
						],
						[
							-82.47334699999999,
							27.317311000000075
						],
						[
							-82.47339299999999,
							27.317353000000026
						],
						[
							-82.47348299999999,
							27.317447000000072
						],
						[
							-82.47352199999995,
							27.31748200000004
						],
						[
							-82.47358499999996,
							27.31752700000004
						],
						[
							-82.47367999999994,
							27.317581000000075
						],
						[
							-82.47385799999995,
							27.317664000000036
						],
						[
							-82.47392599999995,
							27.31770300000005
						],
						[
							-82.47433299999994,
							27.31798500000008
						],
						[
							-82.47439699999995,
							27.31807800000007
						],
						[
							-82.47456299999999,
							27.31818000000004
						],
						[
							-82.47460299999995,
							27.318215000000066
						],
						[
							-82.47464899999994,
							27.318230000000028
						],
						[
							-82.47471799999994,
							27.318273000000033
						],
						[
							-82.47493199999997,
							27.318436000000077
						],
						[
							-82.47505299999995,
							27.318512000000055
						],
						[
							-82.47529699999997,
							27.318692000000055
						],
						[
							-82.475621,
							27.318924000000038
						],
						[
							-82.47567499999997,
							27.318958000000066
						],
						[
							-82.47580999999997,
							27.319031000000056
						],
						[
							-82.47587199999998,
							27.319072000000062
						],
						[
							-82.47613199999995,
							27.31928700000003
						],
						[
							-82.47616399999998,
							27.319314000000077
						],
						[
							-82.47632099999998,
							27.319448000000023
						],
						[
							-82.47742599999998,
							27.320205000000044
						],
						[
							-82.47770599999996,
							27.320390000000035
						],
						[
							-82.47789899999998,
							27.32054400000004
						],
						[
							-82.478483,
							27.320953000000035
						],
						[
							-82.47870599999999,
							27.321093000000076
						],
						[
							-82.47901899999994,
							27.32132500000006
						],
						[
							-82.47936899999996,
							27.321552000000054
						],
						[
							-82.47975899999994,
							27.321847000000048
						],
						[
							-82.48007599999994,
							27.322062000000074
						],
						[
							-82.48028999999997,
							27.322223000000065
						],
						[
							-82.48035199999998,
							27.322269000000063
						],
						[
							-82.48075399999999,
							27.32253600000007
						],
						[
							-82.48126499999995,
							27.322924000000057
						],
						[
							-82.48137199999996,
							27.322996000000046
						],
						[
							-82.48141799999996,
							27.323026000000027
						],
						[
							-82.48156599999999,
							27.32312600000006
						],
						[
							-82.48179099999999,
							27.323277000000076
						],
						[
							-82.48216999999994,
							27.323552000000067
						],
						[
							-82.48247499999997,
							27.323763000000042
						],
						[
							-82.48267199999998,
							27.323886000000073
						],
						[
							-82.48270199999997,
							27.323908000000074
						],
						[
							-82.48276599999997,
							27.323953000000074
						],
						[
							-82.48279599999996,
							27.32397400000008
						],
						[
							-82.48281399999996,
							27.323987000000045
						],
						[
							-82.48289399999999,
							27.324044000000075
						],
						[
							-82.48298699999998,
							27.324110000000076
						],
						[
							-82.48321799999998,
							27.324262000000033
						],
						[
							-82.48338199999995,
							27.32438300000007
						],
						[
							-82.48358399999995,
							27.324559000000082
						],
						[
							-82.48373799999996,
							27.32463100000007
						],
						[
							-82.48387999999994,
							27.324727000000053
						],
						[
							-82.48395799999997,
							27.324790000000064
						],
						[
							-82.48408299999994,
							27.324905000000058
						],
						[
							-82.48422799999997,
							27.32502500000004
						],
						[
							-82.48434799999995,
							27.325071000000037
						],
						[
							-82.48441299999996,
							27.32511800000003
						],
						[
							-82.48453999999998,
							27.32522400000005
						],
						[
							-82.48478299999994,
							27.325390000000027
						],
						[
							-82.48502799999994,
							27.32553100000007
						],
						[
							-82.48526799999996,
							27.325676000000044
						],
						[
							-82.48539899999997,
							27.32576700000004
						],
						[
							-82.48557199999999,
							27.325887000000023
						],
						[
							-82.48564099999999,
							27.325935000000072
						],
						[
							-82.48574999999995,
							27.325999000000024
						],
						[
							-82.48584399999999,
							27.326041000000032
						],
						[
							-82.48605299999997,
							27.32611600000007
						],
						[
							-82.48622899999998,
							27.32618800000006
						],
						[
							-82.48628799999994,
							27.326203000000078
						],
						[
							-82.48643199999998,
							27.326230000000066
						],
						[
							-82.48680099999996,
							27.32632200000006
						],
						[
							-82.48688199999998,
							27.326332000000036
						],
						[
							-82.48698499999995,
							27.326332000000036
						],
						[
							-82.48723999999999,
							27.326317000000078
						],
						[
							-82.48748699999999,
							27.326313000000027
						],
						[
							-82.48766399999994,
							27.32632600000005
						],
						[
							-82.48768099999995,
							27.32631200000003
						],
						[
							-82.48785199999998,
							27.32630800000004
						],
						[
							-82.48798399999998,
							27.326293000000078
						],
						[
							-82.48814399999998,
							27.326292000000024
						],
						[
							-82.48831799999994,
							27.326298000000065
						],
						[
							-82.48885499999994,
							27.32633500000003
						],
						[
							-82.48900799999996,
							27.326354000000038
						],
						[
							-82.48925499999996,
							27.326378000000034
						],
						[
							-82.489358,
							27.326381000000026
						],
						[
							-82.48959599999995,
							27.326374000000044
						],
						[
							-82.48970699999995,
							27.326381000000026
						],
						[
							-82.48985499999998,
							27.326406000000077
						],
						[
							-82.49002199999995,
							27.326426000000026
						],
						[
							-82.49028899999996,
							27.326438000000053
						],
						[
							-82.49042399999996,
							27.326452000000074
						],
						[
							-82.49058099999996,
							27.326451000000077
						],
						[
							-82.49071199999997,
							27.326440000000048
						],
						[
							-82.49104999999997,
							27.326435000000064
						],
						[
							-82.49121099999996,
							27.32643600000006
						],
						[
							-82.49144699999994,
							27.326455000000067
						],
						[
							-82.49157399999996,
							27.32645900000006
						],
						[
							-82.49201299999999,
							27.32643600000006
						],
						[
							-82.49217799999997,
							27.326438000000053
						],
						[
							-82.49240999999995,
							27.32645700000006
						],
						[
							-82.49254899999994,
							27.32646200000005
						],
						[
							-82.49281499999995,
							27.326471000000026
						],
						[
							-82.49305599999997,
							27.326491000000033
						],
						[
							-82.49330699999996,
							27.326504000000057
						],
						[
							-82.49344999999994,
							27.326512000000037
						],
						[
							-82.49358399999994,
							27.326512000000037
						],
						[
							-82.49371899999994,
							27.32650300000006
						],
						[
							-82.49374135399995,
							27.32649398600006
						],
						[
							-82.49378099999996,
							27.326478000000066
						],
						[
							-82.49382999999995,
							27.326474000000076
						],
						[
							-82.49388099999999,
							27.326478000000066
						],
						[
							-82.49391299999996,
							27.326603000000034
						],
						[
							-82.49393499999996,
							27.326689000000044
						],
						[
							-82.49403899999999,
							27.327162000000044
						],
						[
							-82.49408099999994,
							27.32735400000007
						],
						[
							-82.49424099999999,
							27.327973000000043
						],
						[
							-82.49430599999994,
							27.32821000000007
						],
						[
							-82.49437699999999,
							27.328400000000045
						],
						[
							-82.49445899999995,
							27.328573000000063
						],
						[
							-82.49456199999997,
							27.32875600000006
						],
						[
							-82.49467199999998,
							27.32892000000004
						],
						[
							-82.49479499999997,
							27.32907700000004
						],
						[
							-82.49494099999998,
							27.329232000000047
						],
						[
							-82.49507699999998,
							27.329357000000073
						],
						[
							-82.49523499999998,
							27.32948200000004
						],
						[
							-82.49538999999999,
							27.32959100000005
						],
						[
							-82.49556599999994,
							27.32969600000007
						],
						[
							-82.49576399999995,
							27.32979400000005
						],
						[
							-82.49597299999994,
							27.329877000000067
						],
						[
							-82.49617499999994,
							27.329942000000074
						],
						[
							-82.49639699999994,
							27.32999700000005
						],
						[
							-82.49565499999994,
							27.330116000000036
						],
						[
							-82.49267348699999,
							27.330403482000065
						],
						[
							-82.49163099999998,
							27.330504000000076
						],
						[
							-82.49141799999995,
							27.330524000000025
						],
						[
							-82.49144109899999,
							27.330403482000065
						],
						[
							-82.49146399999995,
							27.330284000000063
						],
						[
							-82.49091772399998,
							27.330279140000073
						],
						[
							-82.49090199999995,
							27.33027900000008
						],
						[
							-82.49079499999993,
							27.330280000000073
						],
						[
							-82.49061599999999,
							27.33027500000003
						],
						[
							-82.48944399999993,
							27.330273000000034
						],
						[
							-82.48943899999995,
							27.331361000000072
						],
						[
							-82.48548399999999,
							27.33148600000004
						],
						[
							-82.481949,
							27.331372000000044
						],
						[
							-82.48187499999995,
							27.33301400000005
						],
						[
							-82.48187499999995,
							27.333578000000045
						],
						[
							-82.48146399999996,
							27.333593000000064
						],
						[
							-82.48135899999994,
							27.333664000000056
						],
						[
							-82.48138899999998,
							27.334870000000024
						],
						[
							-82.48139099999997,
							27.33495400000004
						],
						[
							-82.48136899999997,
							27.33497200000005
						],
						[
							-82.481341,
							27.335011000000065
						],
						[
							-82.48133599999994,
							27.335059000000058
						],
						[
							-82.481341,
							27.335113000000035
						],
						[
							-82.48135699999995,
							27.33515200000005
						],
						[
							-82.48135999999994,
							27.335204000000033
						],
						[
							-82.48134499999998,
							27.335290000000043
						],
						[
							-82.48131999999998,
							27.335560000000044
						],
						[
							-82.48132999999996,
							27.335604000000046
						],
						[
							-82.48134699999997,
							27.335646000000057
						],
						[
							-82.48137399999996,
							27.335682000000077
						],
						[
							-82.48134499999998,
							27.33690800000005
						],
						[
							-82.48197899999997,
							27.33690800000005
						],
						[
							-82.48198183399995,
							27.337148540000044
						],
						[
							-82.48198799999994,
							27.337672000000055
						],
						[
							-82.48124899999993,
							27.337937000000068
						],
						[
							-82.48093299999994,
							27.338054000000056
						],
						[
							-82.48078,
							27.338281000000052
						],
						[
							-82.48057799999998,
							27.339347000000032
						],
						[
							-82.48107199999998,
							27.33979500000004
						],
						[
							-82.48154699999998,
							27.340121000000067
						],
						[
							-82.48178699999994,
							27.34028600000005
						],
						[
							-82.48191199999997,
							27.34037200000006
						],
						[
							-82.48191028499997,
							27.340613483000027
						],
						[
							-82.48190599999998,
							27.34121700000003
						],
						[
							-82.48183799999998,
							27.341230000000053
						],
						[
							-82.48120599999999,
							27.34123100000005
						],
						[
							-82.47912699999995,
							27.341222000000073
						],
						[
							-82.479089,
							27.342966000000047
						],
						[
							-82.47872799999999,
							27.342970000000037
						],
						[
							-82.47872499999994,
							27.34300200000007
						],
						[
							-82.47868799999998,
							27.34306900000007
						],
						[
							-82.47868199999994,
							27.345074000000068
						],
						[
							-82.47864099999998,
							27.346335000000067
						],
						[
							-82.48083999999994,
							27.346376000000078
						],
						[
							-82.48082399999998,
							27.346817000000044
						],
						[
							-82.48083199999996,
							27.34810900000008
						],
						[
							-82.48093499999999,
							27.34812000000005
						],
						[
							-82.48184999999995,
							27.348101000000042
						],
						[
							-82.48183999999998,
							27.349108000000058
						],
						[
							-82.48183999999998,
							27.351623000000075
						],
						[
							-82.48343199999994,
							27.35164700000007
						],
						[
							-82.48348499999997,
							27.35231600000003
						],
						[
							-82.48013099999997,
							27.352296000000024
						],
						[
							-82.47850499999998,
							27.352265000000045
						],
						[
							-82.47677699999997,
							27.352231000000074
						],
						[
							-82.47629399999994,
							27.35220300000003
						],
						[
							-82.47586599999994,
							27.352194000000054
						],
						[
							-82.47564599999998,
							27.352198000000044
						],
						[
							-82.47530199999994,
							27.35220400000003
						],
						[
							-82.47296599999999,
							27.352161000000024
						],
						[
							-82.46807899999999,
							27.35206500000004
						],
						[
							-82.467608,
							27.35205600000006
						],
						[
							-82.46397399999995,
							27.351988000000063
						],
						[
							-82.46397699999994,
							27.352553000000057
						],
						[
							-82.46395999999999,
							27.353309000000024
						],
						[
							-82.46396799999997,
							27.354048000000034
						],
						[
							-82.46397699999994,
							27.35438400000004
						],
						[
							-82.46400299999993,
							27.35554200000007
						],
						[
							-82.46401099999997,
							27.356051000000036
						],
						[
							-82.46402399999994,
							27.35679700000003
						],
						[
							-82.46403099999998,
							27.357225000000028
						],
						[
							-82.44677199999995,
							27.357125000000053
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Fruitville",
				"RegionID": "38625"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.25865899999991,
					25.78381752000007,
					-80.20397682499993,
					25.81243121000006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.20589124199995,
							25.812268339000074
						],
						[
							-80.20596998199994,
							25.810580024000046
						],
						[
							-80.20575984499993,
							25.809520003000046
						],
						[
							-80.20587996899991,
							25.809070010000084
						],
						[
							-80.20577996299994,
							25.803539984000054
						],
						[
							-80.20557003499994,
							25.802469966000046
						],
						[
							-80.20549353399991,
							25.797212433000084
						],
						[
							-80.20546490699991,
							25.79524508700007
						],
						[
							-80.20527702299995,
							25.79280986100008
						],
						[
							-80.20462645599991,
							25.789826297000047
						],
						[
							-80.20397682499993,
							25.78888649600009
						],
						[
							-80.20462345499993,
							25.78870128400007
						],
						[
							-80.20785513499993,
							25.788552355000036
						],
						[
							-80.21331925299995,
							25.785984974000087
						],
						[
							-80.21808688499993,
							25.78397540800006
						],
						[
							-80.21871344599992,
							25.78381752000007
						],
						[
							-80.21873167599995,
							25.78382000600004
						],
						[
							-80.21901889299994,
							25.783934893000037
						],
						[
							-80.21921036999993,
							25.78422210900004
						],
						[
							-80.22018690499993,
							25.78452847300008
						],
						[
							-80.22185275999993,
							25.785045462000085
						],
						[
							-80.22254207899994,
							25.78525608700005
						],
						[
							-80.2230399199999,
							25.785524156000065
						],
						[
							-80.22363349999995,
							25.785926259000064
						],
						[
							-80.2239015689999,
							25.786251770000035
						],
						[
							-80.22470577399991,
							25.786232623000046
						],
						[
							-80.22518446799995,
							25.786136884000086
						],
						[
							-80.22549083199993,
							25.786156032000065
						],
						[
							-80.2261610029999,
							25.786462396000047
						],
						[
							-80.2270226519999,
							25.786845351000068
						],
						[
							-80.22755878899994,
							25.787017680000076
						],
						[
							-80.2282864039999,
							25.78707512400007
						],
						[
							-80.22937782599992,
							25.787438931000054
						],
						[
							-80.22995225799991,
							25.787841034000053
						],
						[
							-80.23016288299993,
							25.78803251100004
						],
						[
							-80.23037350899995,
							25.788281432000076
						],
						[
							-80.23067987299993,
							25.788472909000063
						],
						[
							-80.23121600999991,
							25.788702682000064
						],
						[
							-80.23194362399994,
							25.789009046000047
						],
						[
							-80.23263294299994,
							25.789315410000086
						],
						[
							-80.23349459199994,
							25.789660070000085
						],
						[
							-80.2342796499999,
							25.790004729000092
						],
						[
							-80.23466260499993,
							25.79010046800005
						],
						[
							-80.23540936699993,
							25.790196207000065
						],
						[
							-80.23569658299994,
							25.790253650000068
						],
						[
							-80.23640504999992,
							25.790636605000092
						],
						[
							-80.2370560729999,
							25.79111529900007
						],
						[
							-80.2376879489999,
							25.791555697000035
						],
						[
							-80.23866448399991,
							25.792110982000054
						],
						[
							-80.23929635999991,
							25.792493937000074
						],
						[
							-80.23973675799994,
							25.792685414000065
						],
						[
							-80.24017715699995,
							25.792991778000044
						],
						[
							-80.24146005599994,
							25.79373854100004
						],
						[
							-80.24226228599991,
							25.79421987900008
						],
						[
							-80.24205799999993,
							25.79422500000004
						],
						[
							-80.24187199999994,
							25.794229000000087
						],
						[
							-80.24025599999993,
							25.79427000000004
						],
						[
							-80.2398189999999,
							25.794275000000084
						],
						[
							-80.23984399999995,
							25.795228000000066
						],
						[
							-80.23986799999994,
							25.796111000000053
						],
						[
							-80.23989999999992,
							25.79707200000007
						],
						[
							-80.23989999999992,
							25.79739200000006
						],
						[
							-80.23991399999994,
							25.79775600000005
						],
						[
							-80.23991399999994,
							25.79792000000009
						],
						[
							-80.23991699999993,
							25.79801000000009
						],
						[
							-80.23994599999992,
							25.79891200000009
						],
						[
							-80.23998399999994,
							25.799833000000035
						],
						[
							-80.24000199999995,
							25.800665000000038
						],
						[
							-80.24002499999995,
							25.801683000000082
						],
						[
							-80.24005799999992,
							25.80260000000004
						],
						[
							-80.24007599999993,
							25.80353400000007
						],
						[
							-80.2401089999999,
							25.80446100000006
						],
						[
							-80.24013599999995,
							25.805349000000035
						],
						[
							-80.24014799999992,
							25.80579400000005
						],
						[
							-80.24015899999995,
							25.806314000000043
						],
						[
							-80.2401769999999,
							25.80723100000006
						],
						[
							-80.24021499999992,
							25.808140000000037
						],
						[
							-80.24022699999995,
							25.80861800000008
						],
						[
							-80.24223199999994,
							25.808549000000085
						],
						[
							-80.24428299999994,
							25.808484000000078
						],
						[
							-80.24574599999994,
							25.808437000000083
						],
						[
							-80.24630999999994,
							25.80843800000008
						],
						[
							-80.24835599999994,
							25.80837800000006
						],
						[
							-80.2503989999999,
							25.808323000000087
						],
						[
							-80.25146899999993,
							25.808287000000067
						],
						[
							-80.25242999999995,
							25.80825400000009
						],
						[
							-80.25432799999993,
							25.80820900000009
						],
						[
							-80.25442299999992,
							25.808201000000054
						],
						[
							-80.25452899999993,
							25.808193000000077
						],
						[
							-80.25648599999994,
							25.808130000000062
						],
						[
							-80.2564759999999,
							25.807649000000083
						],
						[
							-80.25644399999993,
							25.806745000000035
						],
						[
							-80.25767460799995,
							25.806697007000082
						],
						[
							-80.25780299999991,
							25.806692000000055
						],
						[
							-80.2584609999999,
							25.807197000000087
						],
						[
							-80.25852142999992,
							25.80724074400007
						],
						[
							-80.2585949999999,
							25.80729400000007
						],
						[
							-80.25862699999993,
							25.808311000000064
						],
						[
							-80.25862899999993,
							25.80837900000006
						],
						[
							-80.25862999999993,
							25.808539000000053
						],
						[
							-80.25865449699995,
							25.80940397900008
						],
						[
							-80.25865899999991,
							25.809563000000082
						],
						[
							-80.2585059999999,
							25.80963200000008
						],
						[
							-80.25751999999994,
							25.809528000000057
						],
						[
							-80.25651199999993,
							25.80905800000005
						],
						[
							-80.2565009999999,
							25.80905850000005
						],
						[
							-80.25648999999993,
							25.809059000000047
						],
						[
							-80.25648899999993,
							25.808993000000044
						],
						[
							-80.25473299999993,
							25.80905000000007
						],
						[
							-80.25444399999992,
							25.809053000000063
						],
						[
							-80.25424199999992,
							25.809059000000047
						],
						[
							-80.25403299999994,
							25.80906500000009
						],
						[
							-80.25382799999994,
							25.809071000000074
						],
						[
							-80.25362799999994,
							25.80907700000006
						],
						[
							-80.25356435899994,
							25.80907883800006
						],
						[
							-80.25351932299992,
							25.80908013900006
						],
						[
							-80.25335099999995,
							25.809085000000042
						],
						[
							-80.25299299999995,
							25.80909500000007
						],
						[
							-80.25243499999995,
							25.809111000000087
						],
						[
							-80.25121655599992,
							25.809147595000073
						],
						[
							-80.25040399999995,
							25.809172000000046
						],
						[
							-80.25030029999994,
							25.80919455500009
						],
						[
							-80.24838099999994,
							25.809612000000072
						],
						[
							-80.24634299999991,
							25.809303000000057
						],
						[
							-80.24572001699994,
							25.809323315000086
						],
						[
							-80.2443189999999,
							25.80936900000006
						],
						[
							-80.24338099999994,
							25.809388000000073
						],
						[
							-80.24338299999994,
							25.809454000000073
						],
						[
							-80.24332728799993,
							25.809455229000037
						],
						[
							-80.2432889769999,
							25.80945607400008
						],
						[
							-80.2422949999999,
							25.80947800000007
						],
						[
							-80.24024999999996,
							25.809539000000086
						],
						[
							-80.24025476599991,
							25.809672439000053
						],
						[
							-80.2402669999999,
							25.810015000000078
						],
						[
							-80.24030299999993,
							25.810959000000086
						],
						[
							-80.2382639999999,
							25.81101300000006
						],
						[
							-80.2372739999999,
							25.811047000000087
						],
						[
							-80.2362159999999,
							25.811077000000072
						],
						[
							-80.23518499999996,
							25.811109000000044
						],
						[
							-80.23415099999994,
							25.811137000000087
						],
						[
							-80.23316199999994,
							25.811165000000074
						],
						[
							-80.23262060899992,
							25.81118182000006
						],
						[
							-80.23213199999992,
							25.81119700000005
						],
						[
							-80.23095799999993,
							25.811219000000055
						],
						[
							-80.22972980799995,
							25.81127663400008
						],
						[
							-80.22972199999992,
							25.811277000000075
						],
						[
							-80.22905099999991,
							25.811293000000035
						],
						[
							-80.22805599999992,
							25.811321000000078
						],
						[
							-80.2280889999999,
							25.81189100000006
						],
						[
							-80.22805912699994,
							25.811939445000064
						],
						[
							-80.22589247999991,
							25.812090330000046
						],
						[
							-80.22407445099992,
							25.811976704000074
						],
						[
							-80.21022180699993,
							25.812322793000078
						],
						[
							-80.20776900599992,
							25.81243121000006
						],
						[
							-80.20589124199995,
							25.812268339000074
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami",
				"Name": "Allapattah",
				"RegionID": "123423"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.67518391599998,
					28.29437825900004,
					-80.65387735299998,
					28.357431829000063
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.67518391599998,
							28.357431829000063
						],
						[
							-80.65682216199997,
							28.35734521700005
						],
						[
							-80.65387735299998,
							28.294724707000057
						],
						[
							-80.65924729899996,
							28.29437825900004
						],
						[
							-80.66383773799998,
							28.301653671000054
						],
						[
							-80.67518391599998,
							28.357431829000063
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Brevard",
				"City": "Merritt Island",
				"Name": "Angel City",
				"RegionID": "123450"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.72147990499991,
					30.286958093000067,
					-81.69698895099992,
					30.309599135000045
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.70317084499993,
							30.30341702900006
						],
						[
							-81.7031099969999,
							30.30311185100004
						],
						[
							-81.70293390499995,
							30.30317100800005
						],
						[
							-81.70221685699994,
							30.303459196000066
						],
						[
							-81.70202590699995,
							30.303234009000054
						],
						[
							-81.70153790599994,
							30.302723008000044
						],
						[
							-81.70127090499994,
							30.30243500800009
						],
						[
							-81.70085090599991,
							30.302011009000072
						],
						[
							-81.70064490499993,
							30.30177900900009
						],
						[
							-81.70014990599992,
							30.30127000900006
						],
						[
							-81.6999819049999,
							30.301111009000067
						],
						[
							-81.69930990599994,
							30.300407008000036
						],
						[
							-81.69924190599994,
							30.300344008000085
						],
						[
							-81.69895890599992,
							30.30003400800007
						],
						[
							-81.6986539049999,
							30.299723008000058
						],
						[
							-81.6979289059999,
							30.298946009000076
						],
						[
							-81.6976479999999,
							30.29867900000005
						],
						[
							-81.69698895099992,
							30.298052556000073
						],
						[
							-81.69809699799993,
							30.296473783000067
						],
						[
							-81.69870511399995,
							30.29561520000004
						],
						[
							-81.69879336499991,
							30.29550895300008
						],
						[
							-81.69959955199995,
							30.29467754300003
						],
						[
							-81.7007983119999,
							30.29288325700008
						],
						[
							-81.70224341099993,
							30.29072210800007
						],
						[
							-81.70230207899994,
							30.290643927000076
						],
						[
							-81.7024129269999,
							30.290533079000056
						],
						[
							-81.70254133899994,
							30.290443164000067
						],
						[
							-81.70268341399992,
							30.290376913000042
						],
						[
							-81.70276068399994,
							30.29035267000006
						],
						[
							-81.70355250699993,
							30.290142888000048
						],
						[
							-81.70404535199992,
							30.289282825000043
						],
						[
							-81.70441455799994,
							30.288322326000074
						],
						[
							-81.70444212699994,
							30.28825816200009
						],
						[
							-81.70447459199994,
							30.288196330000062
						],
						[
							-81.70451175699992,
							30.288137204000062
						],
						[
							-81.70455339799992,
							30.28808114000009
						],
						[
							-81.70459926399992,
							30.28802847700007
						],
						[
							-81.70464907699996,
							30.287979531000076
						],
						[
							-81.70470253899992,
							30.287934598000053
						],
						[
							-81.70546392599994,
							30.28734355900008
						],
						[
							-81.70553767099995,
							30.28726854200005
						],
						[
							-81.70559366899994,
							30.287216236000067
						],
						[
							-81.7056539159999,
							30.28716888600007
						],
						[
							-81.70571797499991,
							30.28712683700007
						],
						[
							-81.70578538099994,
							30.28709039400007
						],
						[
							-81.70585564499993,
							30.28705982100007
						],
						[
							-81.70597252899995,
							30.28701486800009
						],
						[
							-81.70604258799995,
							30.286991838000063
						],
						[
							-81.70611429999991,
							30.28697462800005
						],
						[
							-81.7061871809999,
							30.286963354000083
						],
						[
							-81.70626073999995,
							30.286958093000067
						],
						[
							-81.70633448399992,
							30.286958879000057
						],
						[
							-81.70640791499994,
							30.286965706000046
						],
						[
							-81.70648053899993,
							30.28697853000006
						],
						[
							-81.7066265389999,
							30.28701053000009
						],
						[
							-81.70674158599991,
							30.287043914000037
						],
						[
							-81.70681346799996,
							30.287073657000064
						],
						[
							-81.70740903299992,
							30.287350838000066
						],
						[
							-81.7077408529999,
							30.287466907000066
						],
						[
							-81.70791988999991,
							30.287480169000048
						],
						[
							-81.70815937799995,
							30.287440354000072
						],
						[
							-81.70916399999993,
							30.288185000000055
						],
						[
							-81.7094759069999,
							30.288236009000062
						],
						[
							-81.70968593999993,
							30.288271932000043
						],
						[
							-81.70984104999991,
							30.288392906000066
						],
						[
							-81.70993877199993,
							30.288672133000038
						],
						[
							-81.71010693799992,
							30.28874496700007
						],
						[
							-81.71030390499993,
							30.28892700900008
						],
						[
							-81.7106408599999,
							30.289314075000053
						],
						[
							-81.7109349509999,
							30.28941093900005
						],
						[
							-81.71111802099995,
							30.28960494100005
						],
						[
							-81.71115979099996,
							30.28973807400007
						],
						[
							-81.7114258169999,
							30.29001716000005
						],
						[
							-81.7119029079999,
							30.290138006000063
						],
						[
							-81.71317995399994,
							30.290126178000037
						],
						[
							-81.7133938579999,
							30.28997983800008
						],
						[
							-81.71568791699991,
							30.28998894600005
						],
						[
							-81.71809590599992,
							30.29055500900006
						],
						[
							-81.71909402199992,
							30.290982879000072
						],
						[
							-81.7199559849999,
							30.29263098800004
						],
						[
							-81.71994490599991,
							30.29279700800004
						],
						[
							-81.71994474099995,
							30.29312010700005
						],
						[
							-81.7201289059999,
							30.29320800800008
						],
						[
							-81.72033890599994,
							30.29330800900004
						],
						[
							-81.72066183099992,
							30.293462902000044
						],
						[
							-81.7214479559999,
							30.294887990000063
						],
						[
							-81.72147590499992,
							30.295001011000064
						],
						[
							-81.72147990499991,
							30.295160009000085
						],
						[
							-81.7207349059999,
							30.300401008000048
						],
						[
							-81.7207189049999,
							30.300609009000087
						],
						[
							-81.72068890499992,
							30.300877008000043
						],
						[
							-81.72063290599993,
							30.301323008000058
						],
						[
							-81.72053190499992,
							30.301714008000086
						],
						[
							-81.72039290499993,
							30.302096008000035
						],
						[
							-81.72022690599994,
							30.302454008000044
						],
						[
							-81.71998690599992,
							30.30285900800004
						],
						[
							-81.71967290499992,
							30.303302008000063
						],
						[
							-81.71951690499992,
							30.30350400800006
						],
						[
							-81.71923790499994,
							30.30380700900008
						],
						[
							-81.71915990499991,
							30.30388000900007
						],
						[
							-81.7190299049999,
							30.303986009000088
						],
						[
							-81.71778090499993,
							30.304907007000057
						],
						[
							-81.71683390599992,
							30.305473008000035
						],
						[
							-81.71539190599992,
							30.30648600800004
						],
						[
							-81.71327890599991,
							30.30802400800008
						],
						[
							-81.71164890499995,
							30.30893800800004
						],
						[
							-81.71062688099994,
							30.309599135000045
						],
						[
							-81.71030790499992,
							30.309546009000087
						],
						[
							-81.71024490699995,
							30.30953500700008
						],
						[
							-81.7100669049999,
							30.30946400900007
						],
						[
							-81.70956390599991,
							30.309266008000066
						],
						[
							-81.70932690799992,
							30.309132008000063
						],
						[
							-81.7092969059999,
							30.309105008000078
						],
						[
							-81.7089159059999,
							30.308788009000068
						],
						[
							-81.70872490499994,
							30.308640008000058
						],
						[
							-81.70807590599992,
							30.30808400800004
						],
						[
							-81.70762590599992,
							30.30771100900006
						],
						[
							-81.70754990499995,
							30.30765000900004
						],
						[
							-81.70735190499994,
							30.307541009000094
						],
						[
							-81.70674890599992,
							30.307150009000054
						],
						[
							-81.70644390599995,
							30.306955007000056
						],
						[
							-81.70616890499991,
							30.30671300800009
						],
						[
							-81.7059939049999,
							30.30654000900006
						],
						[
							-81.7054049059999,
							30.305983008000055
						],
						[
							-81.70510890599991,
							30.305710008000062
						],
						[
							-81.70458990499992,
							30.305168009000056
						],
						[
							-81.70404790599991,
							30.30463200900005
						],
						[
							-81.70385390599995,
							30.30447700900004
						],
						[
							-81.70363290599994,
							30.304326008000093
						],
						[
							-81.70350979699992,
							30.304229089000046
						],
						[
							-81.70346390599991,
							30.30416200500008
						],
						[
							-81.70334590599992,
							30.303862009000056
						],
						[
							-81.70317084499993,
							30.30341702900006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Avondale",
				"RegionID": "123507"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.14846168299994,
					25.791312777000087,
					-80.1246676639999,
					25.813934852000045
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.12491625899992,
							25.81198161100008
						],
						[
							-80.12488074499994,
							25.808572319000064
						],
						[
							-80.12612371599994,
							25.806796646000066
						],
						[
							-80.12697603899994,
							25.804701352000052
						],
						[
							-80.12690501199995,
							25.802854652000065
						],
						[
							-80.12729566099995,
							25.800581790000084
						],
						[
							-80.12993652599994,
							25.799189334000065
						],
						[
							-80.14487482399994,
							25.791312777000087
						],
						[
							-80.14537201199994,
							25.791738939000084
						],
						[
							-80.14711217199994,
							25.79362115200007
						],
						[
							-80.14846168299994,
							25.79362115200007
						],
						[
							-80.14846168299994,
							25.809850804000064
						],
						[
							-80.13798521199993,
							25.809744263000084
						],
						[
							-80.13663570099993,
							25.809495669000057
						],
						[
							-80.13517964899995,
							25.809389129000067
						],
						[
							-80.13390116399995,
							25.809921831000054
						],
						[
							-80.13329743499992,
							25.810738640000068
						],
						[
							-80.13280024699992,
							25.812159179000048
						],
						[
							-80.13269370699993,
							25.813863825000055
						],
						[
							-80.13013673699993,
							25.813934852000045
						],
						[
							-80.12825452399994,
							25.813863825000055
						],
						[
							-80.12672744499991,
							25.813792798000065
						],
						[
							-80.1246676639999,
							25.81350869000005
						],
						[
							-80.12491625899992,
							25.81198161100008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Beach",
				"Name": "Bayshore",
				"RegionID": "123575"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.48933299999999,
					27.26913600000006,
					-82.45153799999997,
					27.298879000000056
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.46594999999996,
							27.29878300000007
						],
						[
							-82.46504899999996,
							27.298785000000066
						],
						[
							-82.46449599999994,
							27.298786000000064
						],
						[
							-82.46358599999996,
							27.29878700000006
						],
						[
							-82.46308199999999,
							27.298793000000046
						],
						[
							-82.46259899999995,
							27.298798000000033
						],
						[
							-82.46233599999994,
							27.298790000000054
						],
						[
							-82.46166899999997,
							27.298782000000074
						],
						[
							-82.46144499999997,
							27.298781000000076
						],
						[
							-82.45884399999994,
							27.298775000000035
						],
						[
							-82.45818899999995,
							27.298778000000027
						],
						[
							-82.45776699999999,
							27.298782000000074
						],
						[
							-82.45682799999997,
							27.298807000000068
						],
						[
							-82.45581699999997,
							27.29884100000004
						],
						[
							-82.45517899999999,
							27.298854000000063
						],
						[
							-82.45486299999999,
							27.29886700000003
						],
						[
							-82.45457499999999,
							27.298879000000056
						],
						[
							-82.45378999999997,
							27.29887700000006
						],
						[
							-82.45350899999994,
							27.298866000000032
						],
						[
							-82.45281499999999,
							27.29883700000005
						],
						[
							-82.45251499999996,
							27.298831000000064
						],
						[
							-82.45155899999997,
							27.298831000000064
						],
						[
							-82.45153899999997,
							27.298488000000077
						],
						[
							-82.45153799999997,
							27.298344000000043
						],
						[
							-82.45157499999993,
							27.297700000000077
						],
						[
							-82.45162699999997,
							27.295589000000064
						],
						[
							-82.45165599999996,
							27.29499000000004
						],
						[
							-82.45166199999994,
							27.29479600000008
						],
						[
							-82.45168099999995,
							27.29460000000006
						],
						[
							-82.45171599999998,
							27.29446500000006
						],
						[
							-82.45183199999997,
							27.293432000000053
						],
						[
							-82.45185099999998,
							27.293217000000027
						],
						[
							-82.45189899999997,
							27.292740000000038
						],
						[
							-82.45193399999994,
							27.292588000000023
						],
						[
							-82.45202699999999,
							27.291755000000023
						],
						[
							-82.45205799999997,
							27.29137000000003
						],
						[
							-82.45208299999996,
							27.29075000000006
						],
						[
							-82.45210299999997,
							27.288925000000063
						],
						[
							-82.45212899999996,
							27.286460000000034
						],
						[
							-82.45216799999997,
							27.283878000000072
						],
						[
							-82.45629299999996,
							27.28392100000008
						],
						[
							-82.45998399999996,
							27.28396300000003
						],
						[
							-82.46196599999996,
							27.283986000000027
						],
						[
							-82.46455099999997,
							27.28401600000007
						],
						[
							-82.46453899999995,
							27.28169900000006
						],
						[
							-82.46453599999995,
							27.281246000000067
						],
						[
							-82.46455499999996,
							27.278856000000076
						],
						[
							-82.46456099999996,
							27.278053000000057
						],
						[
							-82.46456799999999,
							27.277400000000057
						],
						[
							-82.46457499999997,
							27.276726000000053
						],
						[
							-82.46458099999995,
							27.276582000000076
						],
						[
							-82.46458799999994,
							27.27642000000003
						],
						[
							-82.46458299999995,
							27.27430000000004
						],
						[
							-82.46457699999996,
							27.27245700000003
						],
						[
							-82.46458499999994,
							27.26913600000006
						],
						[
							-82.46564599999994,
							27.269139000000052
						],
						[
							-82.46673799999996,
							27.26914400000004
						],
						[
							-82.47001199999994,
							27.26915800000006
						],
						[
							-82.47241499999996,
							27.269176000000073
						],
						[
							-82.47334299999994,
							27.26916600000004
						],
						[
							-82.47606499999995,
							27.269194000000027
						],
						[
							-82.47766199999995,
							27.269201000000066
						],
						[
							-82.47884999999997,
							27.26920700000005
						],
						[
							-82.47938299999998,
							27.269229000000053
						],
						[
							-82.47991199999996,
							27.269236000000035
						],
						[
							-82.48026799999997,
							27.269225000000063
						],
						[
							-82.48107499999998,
							27.26920800000005
						],
						[
							-82.48129099999994,
							27.269204000000062
						],
						[
							-82.48208799999998,
							27.269217000000026
						],
						[
							-82.48275999999998,
							27.269232000000045
						],
						[
							-82.48286499999995,
							27.269240000000025
						],
						[
							-82.48340899999994,
							27.26922800000006
						],
						[
							-82.48388999999997,
							27.269239000000027
						],
						[
							-82.48659799999996,
							27.269251000000057
						],
						[
							-82.48875599999997,
							27.269242000000077
						],
						[
							-82.48931799999997,
							27.26925700000004
						],
						[
							-82.48932299999996,
							27.269520000000057
						],
						[
							-82.48933299999999,
							27.26963500000005
						],
						[
							-82.48932699999995,
							27.271562000000074
						],
						[
							-82.48932899999994,
							27.27248700000007
						],
						[
							-82.48931999999996,
							27.27601500000003
						],
						[
							-82.48932199999996,
							27.27620900000005
						],
						[
							-82.48930899999993,
							27.276595000000043
						],
						[
							-82.48930199999995,
							27.27681300000006
						],
						[
							-82.48931499999998,
							27.278760000000034
						],
						[
							-82.48930999999999,
							27.27961300000004
						],
						[
							-82.48930599999994,
							27.28066300000006
						],
						[
							-82.48929799999996,
							27.28122800000006
						],
						[
							-82.48929099999998,
							27.282770000000028
						],
						[
							-82.48929399999997,
							27.28399500000006
						],
						[
							-82.48930199999995,
							27.28586400000006
						],
						[
							-82.48929499999997,
							27.28723400000007
						],
						[
							-82.48928999999998,
							27.287717000000043
						],
						[
							-82.48928399999994,
							27.288197000000025
						],
						[
							-82.48927699999996,
							27.28914000000003
						],
						[
							-82.48927799999996,
							27.290197000000035
						],
						[
							-82.48928999999998,
							27.290906000000067
						],
						[
							-82.48931599999997,
							27.291378000000066
						],
						[
							-82.48931399999998,
							27.291479000000038
						],
						[
							-82.48929999999996,
							27.29375200000004
						],
						[
							-82.48929699999997,
							27.29467100000005
						],
						[
							-82.48930099999995,
							27.295199000000025
						],
						[
							-82.48929699999997,
							27.295645000000036
						],
						[
							-82.48929699999997,
							27.296033000000023
						],
						[
							-82.48927499999996,
							27.29847200000006
						],
						[
							-82.48928699999999,
							27.29874700000005
						],
						[
							-82.48728699999998,
							27.29875100000004
						],
						[
							-82.48668399999998,
							27.29875000000004
						],
						[
							-82.48609199999999,
							27.29874700000005
						],
						[
							-82.48571499999997,
							27.298748000000046
						],
						[
							-82.48485699999998,
							27.298753000000033
						],
						[
							-82.48408499999994,
							27.298744000000056
						],
						[
							-82.48357199999998,
							27.298733000000027
						],
						[
							-82.48096399999999,
							27.29873200000003
						],
						[
							-82.47701299999994,
							27.29875000000004
						],
						[
							-82.47659999999996,
							27.29874600000005
						],
						[
							-82.47571999999997,
							27.29875100000004
						],
						[
							-82.47163099999995,
							27.298771000000045
						],
						[
							-82.47141999999997,
							27.298774000000037
						],
						[
							-82.46769399999994,
							27.298780000000082
						],
						[
							-82.46594999999996,
							27.29878300000007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Bee Ridge",
				"RegionID": "123600"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.66970695599991,
					30.354923993000057,
					-81.64302290699993,
					30.377970008000094
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.65094190399992,
							30.36415201000006
						],
						[
							-81.65062887099992,
							30.36410282500009
						],
						[
							-81.65046892999993,
							30.364207087000068
						],
						[
							-81.65028690899993,
							30.36421500900008
						],
						[
							-81.65005788899992,
							30.364272958000072
						],
						[
							-81.64997390699996,
							30.36431801000009
						],
						[
							-81.64985090599994,
							30.364424008000075
						],
						[
							-81.64973490699992,
							30.364493007000075
						],
						[
							-81.64959690599994,
							30.364535008000075
						],
						[
							-81.6494719069999,
							30.364551007000046
						],
						[
							-81.64928390599994,
							30.364543008000055
						],
						[
							-81.6490479069999,
							30.364520009000046
						],
						[
							-81.64863790599992,
							30.36450100900004
						],
						[
							-81.64845890599992,
							30.364509008000088
						],
						[
							-81.64832990899993,
							30.364524010000085
						],
						[
							-81.64795490699993,
							30.364551011000064
						],
						[
							-81.6477939099999,
							30.364551009000078
						],
						[
							-81.6474019069999,
							30.364474011000084
						],
						[
							-81.64687990899995,
							30.364331011000044
						],
						[
							-81.64665190599993,
							30.364278011000064
						],
						[
							-81.64648290699995,
							30.36425101100008
						],
						[
							-81.6462689089999,
							30.36423501100006
						],
						[
							-81.64604090599994,
							30.36425401000008
						],
						[
							-81.64563390599996,
							30.36430801100005
						],
						[
							-81.64522090699995,
							30.364358010000046
						],
						[
							-81.64487590699991,
							30.36443501100007
						],
						[
							-81.6446029089999,
							30.36454301100008
						],
						[
							-81.64401190699994,
							30.364856011000086
						],
						[
							-81.64387895199991,
							30.364940089000072
						],
						[
							-81.64375991199995,
							30.36480501200009
						],
						[
							-81.6436619129999,
							30.364665009000078
						],
						[
							-81.64356090899993,
							30.36436701200006
						],
						[
							-81.6434439109999,
							30.363881013000082
						],
						[
							-81.64339391099992,
							30.363537013000045
						],
						[
							-81.6433779109999,
							30.363276013000075
						],
						[
							-81.64335590899992,
							30.363007013000075
						],
						[
							-81.6433109109999,
							30.362373012000038
						],
						[
							-81.64324991099994,
							30.361702013000073
						],
						[
							-81.64318800599995,
							30.361044073000073
						],
						[
							-81.64312690899993,
							30.360426011000076
						],
						[
							-81.64307390899995,
							30.359684011000066
						],
						[
							-81.64307390899995,
							30.359541010000044
						],
						[
							-81.64303590899993,
							30.35872301000006
						],
						[
							-81.64302790799991,
							30.35796501100009
						],
						[
							-81.64302690699992,
							30.35732001000008
						],
						[
							-81.64302290699993,
							30.35707001000009
						],
						[
							-81.64304290699994,
							30.356929010000048
						],
						[
							-81.64307090999995,
							30.356831009000075
						],
						[
							-81.64320398899991,
							30.356600035000042
						],
						[
							-81.64322090999991,
							30.356358010000065
						],
						[
							-81.64323808499995,
							30.356284996000056
						],
						[
							-81.64322394899995,
							30.356249954000077
						],
						[
							-81.64368590799995,
							30.356237010000083
						],
						[
							-81.64464690699992,
							30.35621501100007
						],
						[
							-81.64525303199991,
							30.356192865000082
						],
						[
							-81.64525778599995,
							30.356232155000043
						],
						[
							-81.64554801899993,
							30.356214168000065
						],
						[
							-81.64556380199991,
							30.35617785100004
						],
						[
							-81.64598490799995,
							30.356172011000066
						],
						[
							-81.64630590899992,
							30.356167010000036
						],
						[
							-81.6464529079999,
							30.35615801100005
						],
						[
							-81.64675590699994,
							30.35615401100006
						],
						[
							-81.64735290899995,
							30.35613401100005
						],
						[
							-81.64765690699994,
							30.35612401000009
						],
						[
							-81.64863090699993,
							30.35610401000008
						],
						[
							-81.6492340449999,
							30.356077137000057
						],
						[
							-81.64923090699995,
							30.356042008000088
						],
						[
							-81.64921590699993,
							30.35572300800004
						],
						[
							-81.64918881699992,
							30.355025023000053
						],
						[
							-81.6507339069999,
							30.354988008000078
						],
						[
							-81.65227490699993,
							30.354946008000073
						],
						[
							-81.65352290699991,
							30.354930009000046
						],
						[
							-81.65373990699993,
							30.35496400900007
						],
						[
							-81.65388890799994,
							30.354997007000065
						],
						[
							-81.65426990599991,
							30.35499200800007
						],
						[
							-81.65543690699991,
							30.35498000800004
						],
						[
							-81.65698190699993,
							30.35496500800008
						],
						[
							-81.6570379069999,
							30.35496400800008
						],
						[
							-81.65865290699992,
							30.354950008000063
						],
						[
							-81.65901190699992,
							30.35494000900007
						],
						[
							-81.6599659069999,
							30.35493500800004
						],
						[
							-81.66128199499991,
							30.354923993000057
						],
						[
							-81.6612929069999,
							30.355640009000073
						],
						[
							-81.6612969059999,
							30.35573700900005
						],
						[
							-81.66130690699993,
							30.356025008000078
						],
						[
							-81.66130690699993,
							30.35627800800006
						],
						[
							-81.66130790699992,
							30.356325009000045
						],
						[
							-81.66130677399991,
							30.35637214000008
						],
						[
							-81.66218390699993,
							30.356359008000087
						],
						[
							-81.66246490599991,
							30.356354008000043
						],
						[
							-81.6627359069999,
							30.35634300900006
						],
						[
							-81.66298790699994,
							30.356329008000046
						],
						[
							-81.66313490599993,
							30.356316008000075
						],
						[
							-81.6632289069999,
							30.356304009000038
						],
						[
							-81.6633229059999,
							30.35629700800007
						],
						[
							-81.66364290599995,
							30.356265009000083
						],
						[
							-81.66397090699991,
							30.35624100800004
						],
						[
							-81.66407990699992,
							30.35623300800006
						],
						[
							-81.66464890399993,
							30.356189009000047
						],
						[
							-81.66491390699991,
							30.356161008000072
						],
						[
							-81.66523590599991,
							30.356144008000058
						],
						[
							-81.66565290599993,
							30.35613500800008
						],
						[
							-81.66581290699992,
							30.356128009000088
						],
						[
							-81.66617690599992,
							30.35612600800005
						],
						[
							-81.66637390599993,
							30.356129009000085
						],
						[
							-81.6665169069999,
							30.35612600800005
						],
						[
							-81.66671590699991,
							30.35612600800005
						],
						[
							-81.66790490699992,
							30.356128009000088
						],
						[
							-81.66847590599991,
							30.356114008000077
						],
						[
							-81.66856890699995,
							30.35611100900007
						],
						[
							-81.66867490599992,
							30.356106011000065
						],
						[
							-81.66868790599995,
							30.356315008000085
						],
						[
							-81.66869090699993,
							30.356498009000063
						],
						[
							-81.66869090699993,
							30.357303009000077
						],
						[
							-81.66869690599992,
							30.357669009000062
						],
						[
							-81.66872590699991,
							30.35826500900004
						],
						[
							-81.6687289059999,
							30.358307008000054
						],
						[
							-81.6687409079999,
							30.35874300900008
						],
						[
							-81.6687479069999,
							30.358902009000076
						],
						[
							-81.66875790699993,
							30.359217009000076
						],
						[
							-81.66876590699991,
							30.35944500900007
						],
						[
							-81.6687679069999,
							30.359519008000063
						],
						[
							-81.66879090599991,
							30.360178008000048
						],
						[
							-81.66880090699993,
							30.36045900900007
						],
						[
							-81.66880390699993,
							30.360890009000062
						],
						[
							-81.66881190599992,
							30.361383009000065
						],
						[
							-81.66882190699994,
							30.36159300900005
						],
						[
							-81.66884590699993,
							30.362321008000034
						],
						[
							-81.66885090499994,
							30.362745008000044
						],
						[
							-81.66885090499994,
							30.36304700800008
						],
						[
							-81.66885390599992,
							30.363541009000073
						],
						[
							-81.66887490699992,
							30.364097008000048
						],
						[
							-81.6688799069999,
							30.364581008000073
						],
						[
							-81.6688859059999,
							30.364703008000053
						],
						[
							-81.66888790599995,
							30.364784008000072
						],
						[
							-81.66889381699991,
							30.364943023000084
						],
						[
							-81.66900071499992,
							30.371192006000058
						],
						[
							-81.66970695599991,
							30.373302085000034
						],
						[
							-81.66964190699991,
							30.373328008000048
						],
						[
							-81.66957893599994,
							30.373353095000084
						],
						[
							-81.6678799149999,
							30.37385290900005
						],
						[
							-81.66600790699994,
							30.37429900900008
						],
						[
							-81.66124590699991,
							30.375897009000084
						],
						[
							-81.66045690699991,
							30.376206009000043
						],
						[
							-81.65942990799994,
							30.37676000600004
						],
						[
							-81.6577879059999,
							30.37726200900005
						],
						[
							-81.65679090599993,
							30.37759100900007
						],
						[
							-81.65665290599992,
							30.377637008000082
						],
						[
							-81.6559819069999,
							30.37777300800008
						],
						[
							-81.65551690599995,
							30.377852008000048
						],
						[
							-81.65524390699994,
							30.377886009000065
						],
						[
							-81.65484990699993,
							30.377930008000074
						],
						[
							-81.65426990599991,
							30.37796500800005
						],
						[
							-81.65374590699992,
							30.377968008000042
						],
						[
							-81.65338190599994,
							30.377970008000094
						],
						[
							-81.65087582699994,
							30.377847968000086
						],
						[
							-81.6508939069999,
							30.377787009000087
						],
						[
							-81.6510769059999,
							30.377100009000063
						],
						[
							-81.65117590499995,
							30.37675100900009
						],
						[
							-81.65120690499992,
							30.376602007000088
						],
						[
							-81.65120690599991,
							30.37656000900006
						],
						[
							-81.65121890699993,
							30.37639900900007
						],
						[
							-81.65122990599991,
							30.376251008000054
						],
						[
							-81.65123690599995,
							30.375952008000073
						],
						[
							-81.65126790599993,
							30.375450008000087
						],
						[
							-81.65128790699994,
							30.37488500900008
						],
						[
							-81.6512989069999,
							30.374456009000085
						],
						[
							-81.65132890599995,
							30.373861009000052
						],
						[
							-81.65132890699994,
							30.373659008000065
						],
						[
							-81.65132890699994,
							30.373579009000082
						],
						[
							-81.6513439069999,
							30.373358009000075
						],
						[
							-81.65135990699991,
							30.373089008000083
						],
						[
							-81.65135990699991,
							30.37280500800006
						],
						[
							-81.65137490699993,
							30.372637008000083
						],
						[
							-81.65138890599991,
							30.372356008000054
						],
						[
							-81.65140090699992,
							30.37188800800004
						],
						[
							-81.65140890599992,
							30.37181500900004
						],
						[
							-81.65141490699995,
							30.371638009000037
						],
						[
							-81.65144090599995,
							30.371290009000067
						],
						[
							-81.6514539069999,
							30.371205009000047
						],
						[
							-81.65146790599994,
							30.37117000800004
						],
						[
							-81.6516569069999,
							30.37046600900004
						],
						[
							-81.6517469069999,
							30.37016300900007
						],
						[
							-81.65181690599991,
							30.36991300800008
						],
						[
							-81.65194090699994,
							30.369430008000055
						],
						[
							-81.65211990699993,
							30.368769009000058
						],
						[
							-81.65220990599994,
							30.368453008000078
						],
						[
							-81.65229590699994,
							30.368138008000074
						],
						[
							-81.65234690699992,
							30.36795100900008
						],
						[
							-81.65240790599995,
							30.367728008000086
						],
						[
							-81.65247090699995,
							30.367452009000093
						],
						[
							-81.65253190699991,
							30.36721300900007
						],
						[
							-81.65277090599994,
							30.366302008000044
						],
						[
							-81.6528119059999,
							30.366167009000037
						],
						[
							-81.65294890599995,
							30.365627008000047
						],
						[
							-81.65299490699994,
							30.365469008000048
						],
						[
							-81.65300490699991,
							30.36541500900006
						],
						[
							-81.65305105699991,
							30.365097899000034
						],
						[
							-81.65290190999991,
							30.365073007000035
						],
						[
							-81.65094190399992,
							30.36415201000006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Brentwood",
				"RegionID": "123748"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.24461407999996,
					25.91541189900005,
					-80.22810104299998,
					25.92684954400005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.22810104299998,
							25.915934907000064
						],
						[
							-80.22885290599999,
							25.915913722000028
						],
						[
							-80.24155161399995,
							25.91552729700004
						],
						[
							-80.24353703599996,
							25.915487322000047
						],
						[
							-80.24401005499999,
							25.915443095000057
						],
						[
							-80.24407442899997,
							25.915437076000046
						],
						[
							-80.24434370899996,
							25.91541189900005
						],
						[
							-80.24435316199998,
							25.91560599600007
						],
						[
							-80.24436072799995,
							25.91576135300005
						],
						[
							-80.24452594599995,
							25.919153833000053
						],
						[
							-80.24461407999996,
							25.92645929100007
						],
						[
							-80.24179623699996,
							25.926524615000062
						],
						[
							-80.23198693599994,
							25.926752017000073
						],
						[
							-80.22850822599997,
							25.926847318000057
						],
						[
							-80.22844319499995,
							25.92684954400005
						],
						[
							-80.22836904699994,
							25.92354080800004
						],
						[
							-80.22810104299998,
							25.915934907000064
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Gardens",
				"Name": "Bunche Park",
				"RegionID": "123807"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.13219336999992,
					26.186961000000053,
					-80.12246599999992,
					26.203840873000047
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.12299979899991,
							26.203840873000047
						],
						[
							-80.12288568399993,
							26.19724810000008
						],
						[
							-80.12285973499992,
							26.196471934000044
						],
						[
							-80.12261928999993,
							26.189144070000054
						],
						[
							-80.12261928799991,
							26.189091002000055
						],
						[
							-80.1225553889999,
							26.187284291000083
						],
						[
							-80.12256299599994,
							26.187284136000073
						],
						[
							-80.12255999999991,
							26.187280000000047
						],
						[
							-80.12246599999992,
							26.187061000000085
						],
						[
							-80.12376599999993,
							26.186961000000053
						],
						[
							-80.1245659999999,
							26.186961000000053
						],
						[
							-80.12466599999993,
							26.187061000000085
						],
						[
							-80.12466599999993,
							26.187861000000055
						],
						[
							-80.12476599999991,
							26.188861000000088
						],
						[
							-80.12646599999994,
							26.188861000000088
						],
						[
							-80.1270659999999,
							26.188761000000056
						],
						[
							-80.12703699999992,
							26.18886800000007
						],
						[
							-80.12702999999993,
							26.189861000000064
						],
						[
							-80.12716599999993,
							26.189861000000064
						],
						[
							-80.12806599999993,
							26.189861000000064
						],
						[
							-80.1295659999999,
							26.189861000000064
						],
						[
							-80.1295752389999,
							26.189985857000067
						],
						[
							-80.12974899999995,
							26.192334000000074
						],
						[
							-80.12979252699995,
							26.192334025000036
						],
						[
							-80.13148499999994,
							26.19233500000007
						],
						[
							-80.13183199999992,
							26.19233500000007
						],
						[
							-80.13183629299994,
							26.192473616000086
						],
						[
							-80.1318389999999,
							26.19256100000007
						],
						[
							-80.1318405479999,
							26.192609816000072
						],
						[
							-80.1319499999999,
							26.196061000000043
						],
						[
							-80.13219299999992,
							26.203535000000045
						],
						[
							-80.13219336999992,
							26.203659180000045
						],
						[
							-80.13126010299993,
							26.20360853300008
						],
						[
							-80.12733127599995,
							26.203655603000072
						],
						[
							-80.12299979899991,
							26.203840873000047
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Coral Ridge Isles",
				"RegionID": "124025"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.11791329199991,
					26.258887592000065,
					-80.0976659449999,
					26.275457887000073
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.0976659449999,
							26.27545784000006
						],
						[
							-80.09766678499994,
							26.275453079000044
						],
						[
							-80.09796594499994,
							26.273757840000087
						],
						[
							-80.09806594499992,
							26.273057840000035
						],
						[
							-80.09816594499995,
							26.27215784000009
						],
						[
							-80.09846594499993,
							26.269157840000048
						],
						[
							-80.09876594499991,
							26.267357840000045
						],
						[
							-80.09876594499991,
							26.26725784000007
						],
						[
							-80.09886594499994,
							26.266557840000075
						],
						[
							-80.09893894499993,
							26.266047840000056
						],
						[
							-80.09906594499995,
							26.265157840000086
						],
						[
							-80.0994659449999,
							26.262657840000088
						],
						[
							-80.0995559449999,
							26.26193684000009
						],
						[
							-80.09959594499992,
							26.261421840000082
						],
						[
							-80.09961150299995,
							26.261258535000085
						],
						[
							-80.09961194499994,
							26.261253890000035
						],
						[
							-80.09976316699994,
							26.258887592000065
						],
						[
							-80.10146937799995,
							26.259134869000036
						],
						[
							-80.11497069699993,
							26.258887592000065
						],
						[
							-80.11598453199991,
							26.259505785000044
						],
						[
							-80.11704782299995,
							26.260222888000044
						],
						[
							-80.11791329199991,
							26.260494892000054
						],
						[
							-80.11356790399992,
							26.275158358000056
						],
						[
							-80.1134940739999,
							26.27515867900007
						],
						[
							-80.09767098799995,
							26.275457887000073
						],
						[
							-80.0976659449999,
							26.27545784000006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Pompano Beach",
				"Name": "Cresthaven",
				"RegionID": "124068"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.45371752947723,
					27.965299868495684,
					-82.41401241961559,
					27.996363635794836
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.41419812331938,
							27.987535020211524
						],
						[
							-82.41420526483556,
							27.978168146903872
						],
						[
							-82.41420736385322,
							27.975778222892643
						],
						[
							-82.41420717139829,
							27.975675415096234
						],
						[
							-82.41421456472469,
							27.96626562793992
						],
						[
							-82.41401241961559,
							27.96536176973031
						],
						[
							-82.4169182046353,
							27.965299868495684
						],
						[
							-82.4175316915467,
							27.96552717843393
						],
						[
							-82.43467268668749,
							27.965400027788718
						],
						[
							-82.43581509815931,
							27.966045888494616
						],
						[
							-82.4428181682642,
							27.96534634545823
						],
						[
							-82.44281818175403,
							27.97076284063221
						],
						[
							-82.44281804775508,
							27.981800133562935
						],
						[
							-82.45363637645603,
							27.981800000463274
						],
						[
							-82.45365908793451,
							27.981800000463274
						],
						[
							-82.4537158567383,
							27.99585255378355
						],
						[
							-82.45371752947723,
							27.99620020200247
						],
						[
							-82.43467270377462,
							27.996275665912613
						],
						[
							-82.414190908958,
							27.996363635794836
						],
						[
							-82.41419645597631,
							27.98930694990925
						],
						[
							-82.41419751987426,
							27.9879534891409
						],
						[
							-82.41419812331938,
							27.987535020211524
						]
					],
					[
						[
							-82.43478194891813,
							27.974499869902864
						],
						[
							-82.4279077417676,
							27.974439945378144
						],
						[
							-82.42801805260771,
							27.981800131764288
						],
						[
							-82.43471830929407,
							27.98180012726762
						],
						[
							-82.43478194891813,
							27.974499869902864
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "East Tampa",
				"RegionID": "124243"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.74523666999994,
					30.315560013000038,
					-81.73073390899992,
					30.356129858000088
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.73108156399991,
							30.356129858000088
						],
						[
							-81.73102896199993,
							30.34388201300004
						],
						[
							-81.73097990799994,
							30.336423009000047
						],
						[
							-81.7309749069999,
							30.33562600900007
						],
						[
							-81.73096790699992,
							30.33517200800009
						],
						[
							-81.7309639049999,
							30.334911008000063
						],
						[
							-81.7309599049999,
							30.334413009000055
						],
						[
							-81.73095590499992,
							30.334102008000055
						],
						[
							-81.73095690699995,
							30.333957009000073
						],
						[
							-81.73091790699993,
							30.333165009000084
						],
						[
							-81.7309129059999,
							30.332690008000046
						],
						[
							-81.7308689059999,
							30.331414009000067
						],
						[
							-81.73085290499995,
							30.330966009000065
						],
						[
							-81.7308419069999,
							30.33019900900007
						],
						[
							-81.73082890599994,
							30.32978000800006
						],
						[
							-81.73080390699994,
							30.32919900900004
						],
						[
							-81.73079890699995,
							30.32881800900009
						],
						[
							-81.73077696199994,
							30.32759402700009
						],
						[
							-81.7307759059999,
							30.327488010000085
						],
						[
							-81.73076990899995,
							30.326967011000075
						],
						[
							-81.73077577599992,
							30.326450874000045
						],
						[
							-81.73092903799994,
							30.326457143000088
						],
						[
							-81.73092390599993,
							30.325689010000076
						],
						[
							-81.7308647719999,
							30.325213889000057
						],
						[
							-81.7309330409999,
							30.32521413900008
						],
						[
							-81.73091095899991,
							30.324917001000074
						],
						[
							-81.73090390499993,
							30.324895010000034
						],
						[
							-81.73087072599992,
							30.324838028000045
						],
						[
							-81.73089590699993,
							30.324764011000067
						],
						[
							-81.73090990799994,
							30.324691010000034
						],
						[
							-81.73091890899991,
							30.324369010000055
						],
						[
							-81.73091890899991,
							30.323702010000087
						],
						[
							-81.7309109059999,
							30.323105010000063
						],
						[
							-81.7308909059999,
							30.32292201000007
						],
						[
							-81.73086490999992,
							30.32280301000009
						],
						[
							-81.7308629069999,
							30.322770011000046
						],
						[
							-81.73082690699994,
							30.321554010000057
						],
						[
							-81.73080390699994,
							30.32082201100008
						],
						[
							-81.73078890699992,
							30.320076010000037
						],
						[
							-81.73078190699994,
							30.31963501100006
						],
						[
							-81.7307659089999,
							30.319334010000038
						],
						[
							-81.73075890699994,
							30.31858301100004
						],
						[
							-81.73073390899992,
							30.318043010000054
						],
						[
							-81.73073890699993,
							30.31768901100008
						],
						[
							-81.7307358509999,
							30.317352010000036
						],
						[
							-81.73460790899992,
							30.31725101200004
						],
						[
							-81.7351789089999,
							30.31722501200005
						],
						[
							-81.7360009109999,
							30.31712801200007
						],
						[
							-81.73658091099992,
							30.317036012000074
						],
						[
							-81.7368939079999,
							30.31696001200004
						],
						[
							-81.73741890999992,
							30.316806013000072
						],
						[
							-81.73797290899995,
							30.316638013000045
						],
						[
							-81.7385109089999,
							30.316455013000052
						],
						[
							-81.7394109089999,
							30.31615301200009
						],
						[
							-81.73988290799991,
							30.315995012000087
						],
						[
							-81.74033091099994,
							30.315870013000048
						],
						[
							-81.7404409099999,
							30.315851012000053
						],
						[
							-81.74074991099991,
							30.315770012000087
						],
						[
							-81.74087490799991,
							30.315748012000082
						],
						[
							-81.74118591099995,
							30.315692013000046
						],
						[
							-81.7417309089999,
							30.31562001300006
						],
						[
							-81.7419149079999,
							30.315609012000035
						],
						[
							-81.7421519099999,
							30.31558301300004
						],
						[
							-81.7423189079999,
							30.315572012000075
						],
						[
							-81.7425119099999,
							30.315560013000038
						],
						[
							-81.74341791099994,
							30.31557001200008
						],
						[
							-81.74357490999995,
							30.315576956000086
						],
						[
							-81.74357390599994,
							30.315844011000085
						],
						[
							-81.74360090699992,
							30.31779901100009
						],
						[
							-81.74362190699992,
							30.318502011000078
						],
						[
							-81.74362190699992,
							30.319212010000058
						],
						[
							-81.74362890599991,
							30.319561010000086
						],
						[
							-81.74364490799991,
							30.31980901000009
						],
						[
							-81.74363690699994,
							30.31993101000006
						],
						[
							-81.74364490799991,
							30.320635010000046
						],
						[
							-81.74356890599995,
							30.321344010000075
						],
						[
							-81.74353490699993,
							30.321471014000057
						],
						[
							-81.74351490599992,
							30.32175601100005
						],
						[
							-81.7435299089999,
							30.322700011000055
						],
						[
							-81.74352490899992,
							30.32333801100009
						],
						[
							-81.74353690599992,
							30.324972010000064
						],
						[
							-81.74353790899994,
							30.32524901100004
						],
						[
							-81.7435379069999,
							30.325397013000043
						],
						[
							-81.74352290699994,
							30.32561100800007
						],
						[
							-81.74352290699994,
							30.326624008000067
						],
						[
							-81.74351490599992,
							30.326904009000092
						],
						[
							-81.74352290699994,
							30.327469009000087
						],
						[
							-81.74351490599992,
							30.328688008000086
						],
						[
							-81.74352390699994,
							30.32910800900004
						],
						[
							-81.74351590599991,
							30.329576009000053
						],
						[
							-81.7435299039999,
							30.330683008000047
						],
						[
							-81.74352290699994,
							30.33099200800007
						],
						[
							-81.74353390499994,
							30.33190600900008
						],
						[
							-81.74352290699994,
							30.332201008000084
						],
						[
							-81.7435299039999,
							30.332308009000087
						],
						[
							-81.7435299039999,
							30.333128008000074
						],
						[
							-81.7435389069999,
							30.333405008000057
						],
						[
							-81.74353790499993,
							30.334314008000035
						],
						[
							-81.74353790499993,
							30.335958009000077
						],
						[
							-81.74355190699993,
							30.33724200900008
						],
						[
							-81.74358790399992,
							30.339700009000072
						],
						[
							-81.74362190699992,
							30.341550008000073
						],
						[
							-81.74364490399995,
							30.343260009000065
						],
						[
							-81.74365190599991,
							30.34342900900009
						],
						[
							-81.74364490399995,
							30.34364600900005
						],
						[
							-81.74365190599991,
							30.34551300800007
						],
						[
							-81.74365990699994,
							30.34577900900007
						],
						[
							-81.74365890699994,
							30.347120009000037
						],
						[
							-81.74366690599993,
							30.34738900800005
						],
						[
							-81.74365890699994,
							30.347658008000053
						],
						[
							-81.74366690699992,
							30.348678009000082
						],
						[
							-81.7436697739999,
							30.35060614200006
						],
						[
							-81.74523666999994,
							30.350538104000066
						],
						[
							-81.73777490599991,
							30.353522009000077
						],
						[
							-81.73482690599991,
							30.35496000800003
						],
						[
							-81.73122190599992,
							30.356084008000035
						],
						[
							-81.73108156399991,
							30.356129858000088
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Edgewood",
				"RegionID": "124268"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.63551190499993,
					30.265300927000055,
					-81.60195790799992,
					30.294812113000038
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.60209290599994,
							30.29104000800004
						],
						[
							-81.60218290499995,
							30.29008300800007
						],
						[
							-81.60220990599993,
							30.28975300800005
						],
						[
							-81.60227590599993,
							30.289068008000072
						],
						[
							-81.60234290499994,
							30.28833100900005
						],
						[
							-81.60238790499996,
							30.288005008000084
						],
						[
							-81.60240490599995,
							30.287638008000048
						],
						[
							-81.60252390599993,
							30.28635400900004
						],
						[
							-81.60254890499994,
							30.286052008000073
						],
						[
							-81.6026319049999,
							30.285182009000042
						],
						[
							-81.60272790599993,
							30.284214008000053
						],
						[
							-81.60273390499992,
							30.284025009000057
						],
						[
							-81.60274790499994,
							30.28385600800004
						],
						[
							-81.60274390599996,
							30.283355008000058
						],
						[
							-81.60275190499993,
							30.28300100900009
						],
						[
							-81.60271790599995,
							30.281975008000078
						],
						[
							-81.60271490499993,
							30.281745009000076
						],
						[
							-81.60270690599992,
							30.281024009000074
						],
						[
							-81.60274090599995,
							30.28018500800005
						],
						[
							-81.60281990599992,
							30.27818300800004
						],
						[
							-81.60281690699993,
							30.278058008000073
						],
						[
							-81.60284690799995,
							30.27779300700007
						],
						[
							-81.60293790599991,
							30.277562009000064
						],
						[
							-81.60301390599994,
							30.277419009000084
						],
						[
							-81.60308190599994,
							30.277315009000066
						],
						[
							-81.60322590699991,
							30.277129008000088
						],
						[
							-81.60330990499995,
							30.27705100800006
						],
						[
							-81.60553590599994,
							30.275144009000087
						],
						[
							-81.6059859049999,
							30.27475800900004
						],
						[
							-81.60644090499994,
							30.274361008000085
						],
						[
							-81.60677790599993,
							30.274076008000065
						],
						[
							-81.60743190499994,
							30.27351200800007
						],
						[
							-81.60781590599993,
							30.27319400900006
						],
						[
							-81.6082409789999,
							30.27277106500009
						],
						[
							-81.60879890799994,
							30.27220901000004
						],
						[
							-81.60953690799994,
							30.271441011000036
						],
						[
							-81.61077890799993,
							30.27016101100008
						],
						[
							-81.6109519069999,
							30.270015012000044
						],
						[
							-81.61127490699994,
							30.269840010000056
						],
						[
							-81.61169790699995,
							30.26960501000008
						],
						[
							-81.61202190799992,
							30.269433011000046
						],
						[
							-81.61210490799994,
							30.269389010000054
						],
						[
							-81.61222692899992,
							30.26932709900007
						],
						[
							-81.61259390599992,
							30.269146008000064
						],
						[
							-81.61296090599991,
							30.26897200800005
						],
						[
							-81.61370990499995,
							30.26858400800006
						],
						[
							-81.61417190599991,
							30.268344008000042
						],
						[
							-81.61468890499992,
							30.268089009000047
						],
						[
							-81.61515390599993,
							30.267852009000077
						],
						[
							-81.6166119049999,
							30.267070009000065
						],
						[
							-81.61801990599992,
							30.26635000900006
						],
						[
							-81.61827790499991,
							30.266247009000043
						],
						[
							-81.6183859329999,
							30.266205054000068
						],
						[
							-81.61847190599991,
							30.266142009000077
						],
						[
							-81.61896890499992,
							30.265867009000093
						],
						[
							-81.6198428649999,
							30.265300927000055
						],
						[
							-81.6223989049999,
							30.267946009000067
						],
						[
							-81.62407390499993,
							30.270258008000045
						],
						[
							-81.62683390599996,
							30.274331009000036
						],
						[
							-81.62906690499995,
							30.277485008000042
						],
						[
							-81.63028890599992,
							30.27924300900008
						],
						[
							-81.63106990599994,
							30.280391009000084
						],
						[
							-81.63182090599992,
							30.28138100900009
						],
						[
							-81.63390790499994,
							30.284437008000054
						],
						[
							-81.63474790599992,
							30.28562500800007
						],
						[
							-81.63551190499993,
							30.286706006000088
						],
						[
							-81.63366990599991,
							30.287667008000085
						],
						[
							-81.63356890499995,
							30.287718009000063
						],
						[
							-81.63351090599991,
							30.28774800900004
						],
						[
							-81.63332990599991,
							30.287842008000037
						],
						[
							-81.6331529059999,
							30.28794300900006
						],
						[
							-81.63294690599992,
							30.288074008000077
						],
						[
							-81.63282790599993,
							30.288150009000045
						],
						[
							-81.6327559049999,
							30.288210008000075
						],
						[
							-81.63239890599993,
							30.288486008000067
						],
						[
							-81.63208690499994,
							30.288760008000057
						],
						[
							-81.63134690599992,
							30.289461008000046
						],
						[
							-81.63118190599994,
							30.289604009000072
						],
						[
							-81.63091090599994,
							30.28983500800007
						],
						[
							-81.63077990499994,
							30.28994200900007
						],
						[
							-81.63062190499994,
							30.29008900900004
						],
						[
							-81.63048990499993,
							30.290197009000057
						],
						[
							-81.63038590499991,
							30.290283009000063
						],
						[
							-81.63024390599992,
							30.29039700800007
						],
						[
							-81.63012890599992,
							30.29047200800005
						],
						[
							-81.63005690499995,
							30.29052100900009
						],
						[
							-81.6299869049999,
							30.290561009000044
						],
						[
							-81.62995290599991,
							30.290583008000056
						],
						[
							-81.62987890599993,
							30.29062600800006
						],
						[
							-81.6297779059999,
							30.290674009000046
						],
						[
							-81.62975090599991,
							30.290688009000064
						],
						[
							-81.62972793199992,
							30.290705054000057
						],
						[
							-81.62968840499991,
							30.29072050900004
						],
						[
							-81.62948790599995,
							30.290805008000063
						],
						[
							-81.62931390499995,
							30.290881008000046
						],
						[
							-81.62913790499994,
							30.290943008000056
						],
						[
							-81.6289929049999,
							30.290989009000043
						],
						[
							-81.62888490499995,
							30.291020008000093
						],
						[
							-81.62872090499991,
							30.291063009000084
						],
						[
							-81.62850790599992,
							30.29110600900009
						],
						[
							-81.62834590499995,
							30.291137008000078
						],
						[
							-81.6281839049999,
							30.291161009000064
						],
						[
							-81.62800390599995,
							30.291179008000086
						],
						[
							-81.62774490499994,
							30.29120300900007
						],
						[
							-81.62758390499994,
							30.291207008000075
						],
						[
							-81.62737790599994,
							30.291205009000066
						],
						[
							-81.62717990499995,
							30.291195008000045
						],
						[
							-81.62701890599993,
							30.291176008000036
						],
						[
							-81.62676790499995,
							30.29114600900004
						],
						[
							-81.6262189059999,
							30.291097008000065
						],
						[
							-81.62578090599993,
							30.291067009000074
						],
						[
							-81.62556490599991,
							30.29104200800009
						],
						[
							-81.62502390599991,
							30.290979008000075
						],
						[
							-81.62459890499991,
							30.290936009000063
						],
						[
							-81.6241529049999,
							30.29089700800006
						],
						[
							-81.62261190499993,
							30.29075800900006
						],
						[
							-81.6221239059999,
							30.290712009000064
						],
						[
							-81.6216559049999,
							30.29066500900007
						],
						[
							-81.62081140599992,
							30.290595509000074
						],
						[
							-81.62032290499991,
							30.29055200800008
						],
						[
							-81.6194459049999,
							30.290489008000065
						],
						[
							-81.61895790599993,
							30.290442009000056
						],
						[
							-81.61884090499991,
							30.29044000900007
						],
						[
							-81.61873590599993,
							30.29044000900007
						],
						[
							-81.61840590599991,
							30.29044500900005
						],
						[
							-81.61826190499994,
							30.29046000900007
						],
						[
							-81.6181159059999,
							30.290486009000066
						],
						[
							-81.61794990499993,
							30.290530008000076
						],
						[
							-81.6178679059999,
							30.290557009000054
						],
						[
							-81.61780084299994,
							30.290574190000086
						],
						[
							-81.61771493999993,
							30.290472967000085
						],
						[
							-81.61762290299993,
							30.29041000800004
						],
						[
							-81.61748490499991,
							30.290355009000052
						],
						[
							-81.61736290499994,
							30.29033500900005
						],
						[
							-81.61723290599991,
							30.29033400800006
						],
						[
							-81.61704290599994,
							30.290352009000056
						],
						[
							-81.61675290599993,
							30.290422009000054
						],
						[
							-81.6165389059999,
							30.290491009000046
						],
						[
							-81.61640190599991,
							30.29055000900007
						],
						[
							-81.61614190599994,
							30.290705009000078
						],
						[
							-81.6149399059999,
							30.291511009000093
						],
						[
							-81.61395990599993,
							30.292183008000055
						],
						[
							-81.61357890499994,
							30.29238500800005
						],
						[
							-81.61305590599996,
							30.29261100900004
						],
						[
							-81.61287090599991,
							30.292688009000077
						],
						[
							-81.61256790599992,
							30.292811008000058
						],
						[
							-81.61143890599993,
							30.293270009000082
						],
						[
							-81.6108689049999,
							30.293512008000047
						],
						[
							-81.61052490599992,
							30.29366900800005
						],
						[
							-81.61026990599993,
							30.293826008000057
						],
						[
							-81.6100947459999,
							30.293959916000063
						],
						[
							-81.61004505999996,
							30.294454088000066
						],
						[
							-81.60967493699992,
							30.294812113000038
						],
						[
							-81.60941290799992,
							30.294745010000042
						],
						[
							-81.60922290799995,
							30.29469201000006
						],
						[
							-81.60883890699995,
							30.294571010000084
						],
						[
							-81.60798890799992,
							30.29433001100006
						],
						[
							-81.60752190799991,
							30.29417901100004
						],
						[
							-81.6069619079999,
							30.294019011000042
						],
						[
							-81.6062699069999,
							30.293816010000057
						],
						[
							-81.60582690799993,
							30.293682011000048
						],
						[
							-81.60567290799992,
							30.293636010000057
						],
						[
							-81.6056369069999,
							30.293625011000078
						],
						[
							-81.60513690699992,
							30.293486011000088
						],
						[
							-81.6048009079999,
							30.293385011000055
						],
						[
							-81.60401690799996,
							30.293161010000063
						],
						[
							-81.60262490799994,
							30.292728011000065
						],
						[
							-81.60195790799992,
							30.29254800500007
						],
						[
							-81.60209290599994,
							30.29104000800004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Englewood",
				"RegionID": "124309"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.60247688599992,
					30.13977703100005,
					-81.51441642499992,
					30.18472994300004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.55542590999994,
							30.181891011000065
						],
						[
							-81.55476092599991,
							30.18122482200005
						],
						[
							-81.55460389299992,
							30.18133220100009
						],
						[
							-81.55425990799995,
							30.181006011000076
						],
						[
							-81.55383090899994,
							30.18060001100008
						],
						[
							-81.55367590899994,
							30.180421011000078
						],
						[
							-81.55348990899995,
							30.180219012000066
						],
						[
							-81.55332190799993,
							30.18004301200006
						],
						[
							-81.55325990799992,
							30.17998201200004
						],
						[
							-81.55280390899992,
							30.179535012000084
						],
						[
							-81.55248474399991,
							30.17923460100008
						],
						[
							-81.54511001299994,
							30.171327105000046
						],
						[
							-81.5329753929999,
							30.15947800500004
						],
						[
							-81.52326769799993,
							30.14877098800008
						],
						[
							-81.52234557899993,
							30.147833868000077
						],
						[
							-81.51441642499992,
							30.13977703100005
						],
						[
							-81.51670072799993,
							30.13977709400007
						],
						[
							-81.51998421299993,
							30.13977709400007
						],
						[
							-81.5244097769999,
							30.139919852000048
						],
						[
							-81.53026295299993,
							30.14120469400007
						],
						[
							-81.53540231699992,
							30.14134745700005
						],
						[
							-81.54081029799995,
							30.141345301000058
						],
						[
							-81.5407939239999,
							30.141326121000077
						],
						[
							-81.54136290899993,
							30.141345010000066
						],
						[
							-81.54224890599994,
							30.141427010000086
						],
						[
							-81.54242990599994,
							30.141436010000064
						],
						[
							-81.54310290699995,
							30.141472011000076
						],
						[
							-81.54431990899991,
							30.14153701100008
						],
						[
							-81.54463590799992,
							30.14158501100007
						],
						[
							-81.54519590699994,
							30.141770010000073
						],
						[
							-81.55039790699993,
							30.142722011000046
						],
						[
							-81.5525639089999,
							30.143075011000068
						],
						[
							-81.55291790599996,
							30.14314201000008
						],
						[
							-81.55378490899994,
							30.143286010000057
						],
						[
							-81.55418892999995,
							30.14330493200004
						],
						[
							-81.55432485999995,
							30.143396135000046
						],
						[
							-81.55469690799993,
							30.143472010000043
						],
						[
							-81.55563890799993,
							30.143694011000033
						],
						[
							-81.5576089079999,
							30.14416401100004
						],
						[
							-81.55853190699992,
							30.144403011000065
						],
						[
							-81.5591289059999,
							30.144547010000057
						],
						[
							-81.56053090699993,
							30.144904011000055
						],
						[
							-81.56180790699995,
							30.14522001100005
						],
						[
							-81.56272190599992,
							30.145457011000076
						],
						[
							-81.56373390599992,
							30.14571101000007
						],
						[
							-81.56476090599995,
							30.145969010000044
						],
						[
							-81.56529490599992,
							30.14610501000004
						],
						[
							-81.56741890899991,
							30.14663001000008
						],
						[
							-81.56836090799993,
							30.146862010000063
						],
						[
							-81.56856590899993,
							30.146913011000038
						],
						[
							-81.57074690699994,
							30.147486011000073
						],
						[
							-81.57199290699992,
							30.147795010000035
						],
						[
							-81.57215890599991,
							30.147836010000052
						],
						[
							-81.57348590599992,
							30.148170010000054
						],
						[
							-81.5739359079999,
							30.148291010000037
						],
						[
							-81.57437690899991,
							30.148382011000077
						],
						[
							-81.57660090899992,
							30.148930011000065
						],
						[
							-81.57760690599991,
							30.14919701100007
						],
						[
							-81.57797690599995,
							30.149307010000086
						],
						[
							-81.57826490699995,
							30.14941701000004
						],
						[
							-81.58028590899994,
							30.150340010000036
						],
						[
							-81.5811369079999,
							30.15073601100005
						],
						[
							-81.58597190899991,
							30.15293601000008
						],
						[
							-81.58708990799994,
							30.153476010000077
						],
						[
							-81.58740490699995,
							30.15360501100008
						],
						[
							-81.58902390799994,
							30.154373010000086
						],
						[
							-81.58997190699995,
							30.154828010000074
						],
						[
							-81.5900269089999,
							30.154852011000056
						],
						[
							-81.59157490599995,
							30.155565010000092
						],
						[
							-81.59216690699992,
							30.155823010000063
						],
						[
							-81.59301690599995,
							30.156263011000078
						],
						[
							-81.59310690799992,
							30.156318011000053
						],
						[
							-81.59357190599991,
							30.15658101000008
						],
						[
							-81.59644590699993,
							30.15824701100007
						],
						[
							-81.59747488999994,
							30.15883606300008
						],
						[
							-81.5987849089999,
							30.15961101000005
						],
						[
							-81.59899090699992,
							30.159750011000085
						],
						[
							-81.5991899039999,
							30.159908011000088
						],
						[
							-81.59946290799991,
							30.16027901100006
						],
						[
							-81.59954884299992,
							30.160442096000054
						],
						[
							-81.59982190699994,
							30.161084011000067
						],
						[
							-81.60039890699994,
							30.162674010000046
						],
						[
							-81.6005309059999,
							30.16307301000006
						],
						[
							-81.60109690599995,
							30.164733010000077
						],
						[
							-81.60127990899991,
							30.165178012000073
						],
						[
							-81.60130290699993,
							30.16528400800007
						],
						[
							-81.60134790599994,
							30.165384010000082
						],
						[
							-81.60143690899991,
							30.16568001100006
						],
						[
							-81.60197190899993,
							30.16760101100004
						],
						[
							-81.6020599069999,
							30.167864011000063
						],
						[
							-81.60223990599991,
							30.168502010000058
						],
						[
							-81.60237090899994,
							30.169049010000037
						],
						[
							-81.60247688599992,
							30.169312012000038
						],
						[
							-81.60193790799991,
							30.169254010000092
						],
						[
							-81.60145490699995,
							30.169197011000048
						],
						[
							-81.6010019069999,
							30.169140010000035
						],
						[
							-81.60007290599992,
							30.169070010000045
						],
						[
							-81.59923190899991,
							30.169020010000057
						],
						[
							-81.59848690699994,
							30.168969010000072
						],
						[
							-81.59823390799994,
							30.168960011000078
						],
						[
							-81.59756390899992,
							30.16893001000005
						],
						[
							-81.5956389079999,
							30.168818010000052
						],
						[
							-81.59370790699995,
							30.168715010000085
						],
						[
							-81.58580290799995,
							30.16829301000007
						],
						[
							-81.5836329089999,
							30.16817701100007
						],
						[
							-81.58313790599993,
							30.16814401000005
						],
						[
							-81.58123090899994,
							30.168039010000083
						],
						[
							-81.5801419089999,
							30.16797901000007
						],
						[
							-81.5781319059999,
							30.167869011000054
						],
						[
							-81.57594290899993,
							30.16774901100007
						],
						[
							-81.57535590899994,
							30.167713011000046
						],
						[
							-81.57376790799992,
							30.167627010000047
						],
						[
							-81.5723609069999,
							30.167554011000046
						],
						[
							-81.57106890799992,
							30.16747801100007
						],
						[
							-81.5710289079999,
							30.167478010000078
						],
						[
							-81.5700179079999,
							30.167420011000047
						],
						[
							-81.56843290599994,
							30.16733401000005
						],
						[
							-81.56749590699991,
							30.167282011000054
						],
						[
							-81.56737590599994,
							30.167282011000054
						],
						[
							-81.56710290899991,
							30.167276010000084
						],
						[
							-81.56632390699991,
							30.16727001000004
						],
						[
							-81.56625090799992,
							30.16727001000004
						],
						[
							-81.5655389069999,
							30.167276010000084
						],
						[
							-81.56491290699995,
							30.167293010000034
						],
						[
							-81.56406790799991,
							30.16733901100008
						],
						[
							-81.56276690699991,
							30.167464010000064
						],
						[
							-81.5624549069999,
							30.167512010000056
						],
						[
							-81.56221990699993,
							30.167548010000075
						],
						[
							-81.56192190799993,
							30.16759701100006
						],
						[
							-81.56162090899994,
							30.167663010000066
						],
						[
							-81.56112690799996,
							30.167784010000048
						],
						[
							-81.56086190899993,
							30.167822010000066
						],
						[
							-81.56022090599993,
							30.16796701100009
						],
						[
							-81.55995590799996,
							30.168032011000037
						],
						[
							-81.55953490699994,
							30.16812701100008
						],
						[
							-81.5593609089999,
							30.168164010000055
						],
						[
							-81.55912090899994,
							30.16821601000004
						],
						[
							-81.55906040699995,
							30.16822951000006
						],
						[
							-81.55884890699991,
							30.16826401000009
						],
						[
							-81.55879690899991,
							30.168267010000083
						],
						[
							-81.5586509069999,
							30.168290010000078
						],
						[
							-81.55857390699992,
							30.168300011000046
						],
						[
							-81.55849990599995,
							30.16830901000009
						],
						[
							-81.55840690899993,
							30.168320010000055
						],
						[
							-81.55824390699992,
							30.16832201000005
						],
						[
							-81.55807390799993,
							30.168320010000055
						],
						[
							-81.55794490799993,
							30.168311010000085
						],
						[
							-81.5577719069999,
							30.16829701000006
						],
						[
							-81.55760790799991,
							30.16827501100005
						],
						[
							-81.55743087799993,
							30.168237826000052
						],
						[
							-81.55677890699991,
							30.168615010000053
						],
						[
							-81.55629473199993,
							30.168893946000082
						],
						[
							-81.5563809059999,
							30.169132010000055
						],
						[
							-81.55646490899994,
							30.169373010000072
						],
						[
							-81.55654090699994,
							30.16956901000009
						],
						[
							-81.5567319079999,
							30.16997501100008
						],
						[
							-81.55711790599992,
							30.17072801000006
						],
						[
							-81.5576089079999,
							30.17174801100009
						],
						[
							-81.55844690799995,
							30.173537010000075
						],
						[
							-81.55859290699993,
							30.17398701000008
						],
						[
							-81.55866490799991,
							30.17421301100006
						],
						[
							-81.55872690799993,
							30.17443601000008
						],
						[
							-81.55881590699994,
							30.174774011000064
						],
						[
							-81.55886890599994,
							30.175001010000074
						],
						[
							-81.55895290899991,
							30.17540401000008
						],
						[
							-81.5589889069999,
							30.17561101100006
						],
						[
							-81.55902890599992,
							30.175888011000044
						],
						[
							-81.55906881699991,
							30.176149019000036
						],
						[
							-81.55908190699995,
							30.176374011000064
						],
						[
							-81.55916090699992,
							30.176976011000075
						],
						[
							-81.55919390699995,
							30.177338011000078
						],
						[
							-81.55920790799992,
							30.177675010000087
						],
						[
							-81.55921190799995,
							30.178209011000035
						],
						[
							-81.55919790699994,
							30.178718011000058
						],
						[
							-81.55918490599993,
							30.17902801000008
						],
						[
							-81.55915690699993,
							30.179345010000077
						],
						[
							-81.55912390599991,
							30.17965001100003
						],
						[
							-81.55910090799995,
							30.179963011000044
						],
						[
							-81.55899890799992,
							30.18059301100004
						],
						[
							-81.55894790699995,
							30.18090201100006
						],
						[
							-81.55888690899991,
							30.18120701000004
						],
						[
							-81.5588079069999,
							30.181737011000052
						],
						[
							-81.55874290799994,
							30.182179010000088
						],
						[
							-81.5586689079999,
							30.182632010000077
						],
						[
							-81.55859684399991,
							30.18304806500004
						],
						[
							-81.55849690999992,
							30.18366001100009
						],
						[
							-81.55840790899992,
							30.18414501100005
						],
						[
							-81.55830097599994,
							30.18472994300004
						],
						[
							-81.55814691099994,
							30.18457101200005
						],
						[
							-81.55799690899994,
							30.184415012000045
						],
						[
							-81.55718491099994,
							30.183688011000072
						],
						[
							-81.55703791099995,
							30.183537012000045
						],
						[
							-81.55685590999991,
							30.183349012000065
						],
						[
							-81.55670184099995,
							30.183164073000057
						],
						[
							-81.55542590999994,
							30.181891011000065
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Greenland",
				"RegionID": "124600"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.52256199999994,
					27.23343200000005,
					-82.49755999999996,
					27.27692200000007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.49758299999996,
							27.276604000000077
						],
						[
							-82.49758399999996,
							27.276221000000078
						],
						[
							-82.49758399999996,
							27.27609700000005
						],
						[
							-82.49759299999994,
							27.27439000000004
						],
						[
							-82.49759099999994,
							27.273064000000034
						],
						[
							-82.49759899999998,
							27.27154700000006
						],
						[
							-82.49760199999997,
							27.271078000000045
						],
						[
							-82.49760899999995,
							27.27082800000005
						],
						[
							-82.49761199999995,
							27.269276000000048
						],
						[
							-82.49761999999998,
							27.26669700000008
						],
						[
							-82.49761199999995,
							27.26573400000007
						],
						[
							-82.49761499999994,
							27.263779000000056
						],
						[
							-82.49761099999995,
							27.262834000000055
						],
						[
							-82.49760899999995,
							27.26119200000005
						],
						[
							-82.49761199999995,
							27.25975600000004
						],
						[
							-82.49760399999998,
							27.25885500000004
						],
						[
							-82.49760499999996,
							27.256482000000062
						],
						[
							-82.49760899999995,
							27.25602200000003
						],
						[
							-82.49760899999995,
							27.25453300000004
						],
						[
							-82.49760899999995,
							27.254312000000027
						],
						[
							-82.49761199999995,
							27.254095000000063
						],
						[
							-82.49758699999995,
							27.251325000000065
						],
						[
							-82.49758999999995,
							27.249291000000028
						],
						[
							-82.49758799999995,
							27.247934000000043
						],
						[
							-82.49758699999995,
							27.24747900000006
						],
						[
							-82.49758599999996,
							27.247112000000072
						],
						[
							-82.49758199999997,
							27.246054000000072
						],
						[
							-82.49757999999997,
							27.245554000000027
						],
						[
							-82.49758399999996,
							27.245313000000067
						],
						[
							-82.49758699999995,
							27.245105000000024
						],
						[
							-82.49758599999996,
							27.244184000000075
						],
						[
							-82.49757899999997,
							27.243427000000054
						],
						[
							-82.49757199999993,
							27.242635000000064
						],
						[
							-82.49756999999994,
							27.24184900000006
						],
						[
							-82.49756999999994,
							27.241239000000064
						],
						[
							-82.49756999999994,
							27.241074000000026
						],
						[
							-82.49757899999997,
							27.24012700000003
						],
						[
							-82.49757599999998,
							27.239370000000065
						],
						[
							-82.49757299999999,
							27.238443000000075
						],
						[
							-82.49757199999993,
							27.238260000000025
						],
						[
							-82.49757199999993,
							27.23812700000008
						],
						[
							-82.49756899999994,
							27.236746000000043
						],
						[
							-82.49755999999996,
							27.236470000000054
						],
						[
							-82.49756699999995,
							27.23626100000007
						],
						[
							-82.49756699999995,
							27.236112000000052
						],
						[
							-82.49756699999995,
							27.23581400000006
						],
						[
							-82.49756799999994,
							27.23559400000005
						],
						[
							-82.49756799999994,
							27.235019000000023
						],
						[
							-82.49756399999995,
							27.233731000000034
						],
						[
							-82.49765399999995,
							27.23343200000005
						],
						[
							-82.49824399999994,
							27.23392800000005
						],
						[
							-82.49928799999998,
							27.23487700000004
						],
						[
							-82.49988299999995,
							27.235392000000047
						],
						[
							-82.500184,
							27.235677000000067
						],
						[
							-82.50033399999995,
							27.235820000000047
						],
						[
							-82.50045199999994,
							27.23592400000007
						],
						[
							-82.50059299999998,
							27.23604100000006
						],
						[
							-82.50086899999997,
							27.236252000000036
						],
						[
							-82.50148699999994,
							27.236833000000047
						],
						[
							-82.50180199999994,
							27.237123000000054
						],
						[
							-82.50220999999993,
							27.237490000000037
						],
						[
							-82.50351899999998,
							27.238669000000073
						],
						[
							-82.50511799999998,
							27.240102000000036
						],
						[
							-82.50560299999995,
							27.240526000000045
						],
						[
							-82.50594499999994,
							27.240819000000045
						],
						[
							-82.50622499999997,
							27.241052000000025
						],
						[
							-82.50716199999994,
							27.241720000000043
						],
						[
							-82.50792599999994,
							27.242260000000044
						],
						[
							-82.50816199999997,
							27.242455000000064
						],
						[
							-82.50844599999994,
							27.24269000000004
						],
						[
							-82.50852799999997,
							27.242758000000038
						],
						[
							-82.50899299999998,
							27.24316200000004
						],
						[
							-82.50921499999998,
							27.243393000000026
						],
						[
							-82.50966699999998,
							27.24388700000003
						],
						[
							-82.50980999999996,
							27.244068000000027
						],
						[
							-82.50999699999994,
							27.244305000000054
						],
						[
							-82.51024299999995,
							27.244643000000057
						],
						[
							-82.51071499999995,
							27.245324000000043
						],
						[
							-82.51088599999997,
							27.245607000000064
						],
						[
							-82.51111299999997,
							27.246006000000023
						],
						[
							-82.51132699999994,
							27.24633000000006
						],
						[
							-82.51172099999997,
							27.24700400000006
						],
						[
							-82.51184999999998,
							27.247201000000075
						],
						[
							-82.51215899999994,
							27.247717000000023
						],
						[
							-82.51223999999996,
							27.247861000000057
						],
						[
							-82.51232899999997,
							27.248018000000062
						],
						[
							-82.51252899999997,
							27.248373000000072
						],
						[
							-82.51297799999998,
							27.249127000000044
						],
						[
							-82.51352299999996,
							27.25004400000006
						],
						[
							-82.51356199999998,
							27.250092000000052
						],
						[
							-82.51369299999999,
							27.250319000000047
						],
						[
							-82.51407899999998,
							27.250961000000075
						],
						[
							-82.51428199999998,
							27.25130100000007
						],
						[
							-82.51443899999998,
							27.25154500000008
						],
						[
							-82.51459899999998,
							27.25177400000007
						],
						[
							-82.51481999999999,
							27.252067000000068
						],
						[
							-82.51500099999998,
							27.252307000000034
						],
						[
							-82.51571599999994,
							27.253108000000054
						],
						[
							-82.51577899999995,
							27.253165000000024
						],
						[
							-82.51603299999994,
							27.25345200000004
						],
						[
							-82.51628199999999,
							27.253707000000077
						],
						[
							-82.51637999999997,
							27.253817000000026
						],
						[
							-82.51709399999999,
							27.254619000000048
						],
						[
							-82.51769499999995,
							27.255288000000064
						],
						[
							-82.51788499999998,
							27.25552300000004
						],
						[
							-82.51800299999996,
							27.25565900000004
						],
						[
							-82.51824499999998,
							27.255908000000034
						],
						[
							-82.51875699999994,
							27.256437000000062
						],
						[
							-82.51918899999998,
							27.256930000000068
						],
						[
							-82.51945299999994,
							27.257219000000077
						],
						[
							-82.51996099999997,
							27.25775500000003
						],
						[
							-82.52014599999995,
							27.25795100000005
						],
						[
							-82.52065699999997,
							27.258428000000038
						],
						[
							-82.52081799999996,
							27.258617000000072
						],
						[
							-82.52096699999998,
							27.258531000000062
						],
						[
							-82.52100899999994,
							27.258506000000068
						],
						[
							-82.52109799999994,
							27.258440000000064
						],
						[
							-82.52238999999997,
							27.25751400000007
						],
						[
							-82.52253999999994,
							27.257683000000043
						],
						[
							-82.52197799999999,
							27.25810400000006
						],
						[
							-82.52114699999998,
							27.258710000000065
						],
						[
							-82.52100499999995,
							27.25881400000003
						],
						[
							-82.52125299999994,
							27.259075000000053
						],
						[
							-82.52158599999996,
							27.259426000000076
						],
						[
							-82.52223399999997,
							27.260144000000025
						],
						[
							-82.52256199999994,
							27.260473000000047
						],
						[
							-82.52208899999994,
							27.260878000000048
						],
						[
							-82.52202999999997,
							27.26093700000007
						],
						[
							-82.52183199999996,
							27.261158000000023
						],
						[
							-82.52150899999998,
							27.261554000000046
						],
						[
							-82.52129599999995,
							27.261779000000047
						],
						[
							-82.52105699999998,
							27.262061000000074
						],
						[
							-82.52070299999997,
							27.262446000000068
						],
						[
							-82.51999199999995,
							27.263229000000027
						],
						[
							-82.51964699999996,
							27.26360900000003
						],
						[
							-82.51787099999996,
							27.26553000000007
						],
						[
							-82.51771199999996,
							27.265708000000075
						],
						[
							-82.51703899999995,
							27.266409000000067
						],
						[
							-82.51647899999995,
							27.26701500000007
						],
						[
							-82.51635799999997,
							27.267152000000067
						],
						[
							-82.51625199999995,
							27.267265000000066
						],
						[
							-82.51553199999995,
							27.26806700000003
						],
						[
							-82.51541799999995,
							27.268174000000048
						],
						[
							-82.51530399999996,
							27.268263000000047
						],
						[
							-82.51520499999998,
							27.268328000000054
						],
						[
							-82.51497499999994,
							27.268463000000054
						],
						[
							-82.51476499999995,
							27.268602000000044
						],
						[
							-82.51458399999996,
							27.26870800000006
						],
						[
							-82.51401799999996,
							27.268977000000064
						],
						[
							-82.51379399999996,
							27.269074000000046
						],
						[
							-82.51388899999995,
							27.269280000000037
						],
						[
							-82.51398499999993,
							27.269505000000038
						],
						[
							-82.51400699999994,
							27.269556000000023
						],
						[
							-82.51405999999999,
							27.269724000000053
						],
						[
							-82.51409499999994,
							27.269899000000066
						],
						[
							-82.51410699999998,
							27.270020000000045
						],
						[
							-82.51410799999996,
							27.27055100000007
						],
						[
							-82.51410899999996,
							27.27080200000006
						],
						[
							-82.51411699999994,
							27.27094500000004
						],
						[
							-82.51415799999995,
							27.271286000000032
						],
						[
							-82.51416699999999,
							27.271413000000052
						],
						[
							-82.51417599999996,
							27.27272100000005
						],
						[
							-82.51417399999997,
							27.27334600000006
						],
						[
							-82.51416099999994,
							27.273855000000026
						],
						[
							-82.51416699999999,
							27.27484400000003
						],
						[
							-82.51416099999994,
							27.275874000000044
						],
						[
							-82.51415599999996,
							27.276726000000053
						],
						[
							-82.51395799999995,
							27.276736000000028
						],
						[
							-82.51323299999996,
							27.276728000000052
						],
						[
							-82.51299899999998,
							27.27670900000004
						],
						[
							-82.51204099999995,
							27.276703000000058
						],
						[
							-82.51100399999996,
							27.276693000000023
						],
						[
							-82.50952299999994,
							27.27668600000004
						],
						[
							-82.50934999999998,
							27.27668000000006
						],
						[
							-82.50920499999995,
							27.276683000000048
						],
						[
							-82.50855899999993,
							27.27668200000005
						],
						[
							-82.50780199999997,
							27.276672000000076
						],
						[
							-82.50672199999997,
							27.27666400000004
						],
						[
							-82.50608399999999,
							27.27665700000006
						],
						[
							-82.50585899999999,
							27.276661000000047
						],
						[
							-82.50354299999998,
							27.27666700000003
						],
						[
							-82.50244499999997,
							27.276659000000052
						],
						[
							-82.50240899999994,
							27.276655000000062
						],
						[
							-82.50237599999997,
							27.276643000000035
						],
						[
							-82.50235899999996,
							27.276583000000073
						],
						[
							-82.50170899999995,
							27.276617000000044
						],
						[
							-82.50145399999997,
							27.276685000000043
						],
						[
							-82.50096399999995,
							27.276816000000053
						],
						[
							-82.50089999999994,
							27.276827000000026
						],
						[
							-82.50063899999998,
							27.276906000000054
						],
						[
							-82.50058599999994,
							27.27692200000007
						],
						[
							-82.49758299999996,
							27.27665200000007
						],
						[
							-82.49758299999996,
							27.276604000000077
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Gulf Gate Estates",
				"RegionID": "124618"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.12032984299992,
					26.100605734000055,
					-80.10330587699991,
					26.111817322000036
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.1173682559999,
							26.111701916000072
						],
						[
							-80.11620618599994,
							26.111052074000042
						],
						[
							-80.11613683599995,
							26.111199661000057
						],
						[
							-80.11607796899995,
							26.11128373200006
						],
						[
							-80.11541457699991,
							26.111298520000048
						],
						[
							-80.1153696689999,
							26.111295879000068
						],
						[
							-80.11445886299992,
							26.11124230200005
						],
						[
							-80.11327827499991,
							26.11121419200009
						],
						[
							-80.11205997499991,
							26.111186504000045
						],
						[
							-80.1120414689999,
							26.111186083000064
						],
						[
							-80.11131062899995,
							26.11107364600008
						],
						[
							-80.1108981349999,
							26.11071000900006
						],
						[
							-80.11009336199993,
							26.11022954500004
						],
						[
							-80.10986842199992,
							26.10988141000007
						],
						[
							-80.10969284299995,
							26.109404839000035
						],
						[
							-80.10954234699994,
							26.109003516000087
						],
						[
							-80.10962363899995,
							26.108577208000042
						],
						[
							-80.1094419129999,
							26.108533247000082
						],
						[
							-80.10723651799992,
							26.107999739000036
						],
						[
							-80.10630601999992,
							26.109273597000083
						],
						[
							-80.10621194999993,
							26.110255174000088
						],
						[
							-80.10595357299991,
							26.110227042000076
						],
						[
							-80.10420099999993,
							26.110029000000054
						],
						[
							-80.10330587699991,
							26.109927850000076
						],
						[
							-80.10334603099994,
							26.109196686000075
						],
						[
							-80.10335172899994,
							26.109133605000068
						],
						[
							-80.10340072899993,
							26.108744605000084
						],
						[
							-80.10343215899991,
							26.108596747000036
						],
						[
							-80.1034845339999,
							26.10842350300004
						],
						[
							-80.10348067799993,
							26.104850970000086
						],
						[
							-80.10348187699992,
							26.104803580000066
						],
						[
							-80.10365645099995,
							26.10142596600008
						],
						[
							-80.10455626299996,
							26.101439714000037
						],
						[
							-80.10792253499994,
							26.10149114400008
						],
						[
							-80.10798642899994,
							26.101205565000043
						],
						[
							-80.10878988299993,
							26.100605734000055
						],
						[
							-80.11047327499995,
							26.10081508500008
						],
						[
							-80.11105412799992,
							26.100980381000056
						],
						[
							-80.11318329499994,
							26.100959299000067
						],
						[
							-80.11752399999995,
							26.100795000000062
						],
						[
							-80.11851631699994,
							26.100757440000052
						],
						[
							-80.11859091999992,
							26.101038650000078
						],
						[
							-80.1189001219999,
							26.10221923800009
						],
						[
							-80.1189001219999,
							26.103034406000063
						],
						[
							-80.11881579399994,
							26.103624700000072
						],
						[
							-80.11922567599993,
							26.10444580400008
						],
						[
							-80.11942107399994,
							26.10491834900006
						],
						[
							-80.1194516889999,
							26.10500456500006
						],
						[
							-80.12029268899994,
							26.107819565000057
						],
						[
							-80.12031159599991,
							26.10789443100009
						],
						[
							-80.12032401099992,
							26.10797064200006
						],
						[
							-80.12032984299992,
							26.108047638000073
						],
						[
							-80.12032904799992,
							26.10812485000008
						],
						[
							-80.12032163299995,
							26.10820170900007
						],
						[
							-80.12030765299994,
							26.10827764900006
						],
						[
							-80.1202872099999,
							26.108352110000055
						],
						[
							-80.12018920899993,
							26.10865711000008
						],
						[
							-80.12017808599991,
							26.108689586000086
						],
						[
							-80.12011710199994,
							26.10882241300004
						],
						[
							-80.11990184599995,
							26.10920563600007
						],
						[
							-80.11971964299994,
							26.10952577100005
						],
						[
							-80.1194904159999,
							26.11017415100008
						],
						[
							-80.11921456099992,
							26.11088583200007
						],
						[
							-80.11922322999993,
							26.11081371100005
						],
						[
							-80.1190310049999,
							26.111060971000086
						],
						[
							-80.11898544299993,
							26.11111505000008
						],
						[
							-80.11893577199993,
							26.111165381000035
						],
						[
							-80.11888229999994,
							26.111211654000044
						],
						[
							-80.11837029999992,
							26.111620654000035
						],
						[
							-80.11825866099991,
							26.111696835000092
						],
						[
							-80.11811658599993,
							26.111763086000053
						],
						[
							-80.11796516599992,
							26.11180365900009
						],
						[
							-80.11780899999991,
							26.111817322000036
						],
						[
							-80.1176528339999,
							26.11180365900009
						],
						[
							-80.11750141399995,
							26.111763086000053
						],
						[
							-80.1173682559999,
							26.111701916000072
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Harbor Beach",
				"RegionID": "124652"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.59114191399993,
					30.287549517000063,
					-81.57019579399991,
					30.29474921800005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.58233958099993,
							30.294462201000048
						],
						[
							-81.58108111799993,
							30.29419726100008
						],
						[
							-81.58013175199994,
							30.29395440000008
						],
						[
							-81.57957979399994,
							30.293844008000065
						],
						[
							-81.57900575899993,
							30.29393232200005
						],
						[
							-81.57840964499991,
							30.294153104000088
						],
						[
							-81.57801223599995,
							30.29432973100006
						],
						[
							-81.57748235599992,
							30.29432973100006
						],
						[
							-81.57675377299995,
							30.294042713000064
						],
						[
							-81.57547323199992,
							30.29362322500009
						],
						[
							-81.57432516099993,
							30.29302711200006
						],
						[
							-81.5735744989999,
							30.29265178100007
						],
						[
							-81.57300046299991,
							30.29216605800008
						],
						[
							-81.57233811399993,
							30.291415396000044
						],
						[
							-81.57200693999994,
							30.290907595000075
						],
						[
							-81.57171992199994,
							30.290377716000076
						],
						[
							-81.57152121699994,
							30.289891994000072
						],
						[
							-81.57156537399993,
							30.289560820000077
						],
						[
							-81.57141082599992,
							30.28931795800008
						],
						[
							-81.57092510299992,
							30.289008862000063
						],
						[
							-81.5708147119999,
							30.288766001000052
						],
						[
							-81.57074847699994,
							30.28841274800004
						],
						[
							-81.5705276939999,
							30.288037417000055
						],
						[
							-81.57021859799994,
							30.28761793000007
						],
						[
							-81.57019579399991,
							30.287549517000063
						],
						[
							-81.57050299999992,
							30.28757600000006
						],
						[
							-81.5711439079999,
							30.287630010000044
						],
						[
							-81.57247190699991,
							30.28779601100007
						],
						[
							-81.57284490699993,
							30.287827010000058
						],
						[
							-81.5730819069999,
							30.287857011000085
						],
						[
							-81.57335690699995,
							30.28790101000004
						],
						[
							-81.57372290699993,
							30.28794101000005
						],
						[
							-81.57412290799994,
							30.287989011000036
						],
						[
							-81.57445890699996,
							30.28802801100005
						],
						[
							-81.5748589069999,
							30.288076010000058
						],
						[
							-81.57524090699991,
							30.288130010000085
						],
						[
							-81.57575990799995,
							30.288202010000077
						],
						[
							-81.5758509069999,
							30.288204011000058
						],
						[
							-81.5762559069999,
							30.288233010000056
						],
						[
							-81.57697690799995,
							30.288322011000048
						],
						[
							-81.57757404799992,
							30.28840198000006
						],
						[
							-81.57744177199993,
							30.288488039000068
						],
						[
							-81.57762390799991,
							30.288507010000043
						],
						[
							-81.5777609079999,
							30.288527010000053
						],
						[
							-81.57789190799991,
							30.28854001000008
						],
						[
							-81.57810792499993,
							30.288563103000058
						],
						[
							-81.57841290599993,
							30.288601008000057
						],
						[
							-81.5793669059999,
							30.288717008000052
						],
						[
							-81.5814259039999,
							30.289012007000057
						],
						[
							-81.58155892899993,
							30.289002092000093
						],
						[
							-81.58166990599995,
							30.288948008000094
						],
						[
							-81.5817398829999,
							30.288918877000075
						],
						[
							-81.58184790599995,
							30.288923009000086
						],
						[
							-81.58286290599995,
							30.289049008000067
						],
						[
							-81.58291790699991,
							30.289053009000042
						],
						[
							-81.58302290599994,
							30.289068008000072
						],
						[
							-81.58307590599992,
							30.289082007000047
						],
						[
							-81.58314290499993,
							30.28908900800008
						],
						[
							-81.58319690499991,
							30.289095008000064
						],
						[
							-81.58335090599991,
							30.289112009000064
						],
						[
							-81.5835169049999,
							30.289132009000067
						],
						[
							-81.58371390599991,
							30.289155011000048
						],
						[
							-81.58399290499995,
							30.28927100600004
						],
						[
							-81.58427590499991,
							30.289300008000055
						],
						[
							-81.5845740179999,
							30.289335154000067
						],
						[
							-81.58458779499995,
							30.28918686200007
						],
						[
							-81.5854229059999,
							30.289291009000067
						],
						[
							-81.58568990599991,
							30.28933200800009
						],
						[
							-81.58585905699994,
							30.289350901000034
						],
						[
							-81.58584790599991,
							30.28940200800008
						],
						[
							-81.58583675499995,
							30.28945411500007
						],
						[
							-81.58586591699992,
							30.289457092000077
						],
						[
							-81.58597589699991,
							30.28941692500007
						],
						[
							-81.58605290499992,
							30.289426009000067
						],
						[
							-81.58722390499992,
							30.289567009000052
						],
						[
							-81.58755290499994,
							30.289612008000066
						],
						[
							-81.58798290499993,
							30.28966500900009
						],
						[
							-81.5886259049999,
							30.28974500800007
						],
						[
							-81.59000190599994,
							30.289908008000054
						],
						[
							-81.59011590599994,
							30.289923008000073
						],
						[
							-81.59114191399993,
							30.29005391800007
						],
						[
							-81.5908149999999,
							30.29428100000007
						],
						[
							-81.5906910569999,
							30.294666733000042
						],
						[
							-81.5898020439999,
							30.294440122000083
						],
						[
							-81.58834487699994,
							30.294241418000073
						],
						[
							-81.58693186599993,
							30.294241418000073
						],
						[
							-81.58587210799993,
							30.29450635700005
						],
						[
							-81.58505521099994,
							30.29474921800005
						],
						[
							-81.58359804399993,
							30.294727140000077
						],
						[
							-81.58233958099993,
							30.294462201000048
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Hogan",
				"RegionID": "124745"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.7718879059999,
					30.26985392100005,
					-81.73991573099995,
					30.30418007600008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.7513109059999,
							30.29477401200006
						],
						[
							-81.75084892599995,
							30.294521929000044
						],
						[
							-81.75061581599994,
							30.294527172000077
						],
						[
							-81.75055790499994,
							30.294434008000056
						],
						[
							-81.75041972999992,
							30.294267056000077
						],
						[
							-81.75043405699995,
							30.29418290200005
						],
						[
							-81.75028590599993,
							30.294156008000076
						],
						[
							-81.75014290199994,
							30.294124011000065
						],
						[
							-81.7500229179999,
							30.294136061000074
						],
						[
							-81.74999090499996,
							30.294128009000076
						],
						[
							-81.7499579059999,
							30.294120008000046
						],
						[
							-81.74982890699994,
							30.29407600700006
						],
						[
							-81.74962175699994,
							30.29394811800006
						],
						[
							-81.74955904399991,
							30.29370588000006
						],
						[
							-81.74916291099993,
							30.29358192500007
						],
						[
							-81.74886688899994,
							30.293642183000088
						],
						[
							-81.7484548889999,
							30.29345106400007
						],
						[
							-81.74675678299991,
							30.293248157000054
						],
						[
							-81.74662995099993,
							30.29289298100008
						],
						[
							-81.7460689909999,
							30.292141907000087
						],
						[
							-81.74536990399993,
							30.291814006000035
						],
						[
							-81.74431890699992,
							30.291053007000073
						],
						[
							-81.74327697799993,
							30.289997922000055
						],
						[
							-81.74274092699996,
							30.289682929000037
						],
						[
							-81.74170790599993,
							30.289683009000047
						],
						[
							-81.74132988299993,
							30.289711139000076
						],
						[
							-81.74074385799992,
							30.289483075000078
						],
						[
							-81.74053079099991,
							30.28922907500004
						],
						[
							-81.73991573099995,
							30.287097004000092
						],
						[
							-81.74011808099993,
							30.286498009000073
						],
						[
							-81.73992973299994,
							30.28589700200007
						],
						[
							-81.74049403799995,
							30.284636032000034
						],
						[
							-81.74056490499993,
							30.282880009000053
						],
						[
							-81.7406199639999,
							30.282087008000076
						],
						[
							-81.7425539059999,
							30.282076008000043
						],
						[
							-81.7433399059999,
							30.282066008000076
						],
						[
							-81.74353003499994,
							30.28206988100004
						],
						[
							-81.7435229059999,
							30.282852009000063
						],
						[
							-81.74352890599994,
							30.283524008000082
						],
						[
							-81.74353790599991,
							30.284016008000037
						],
						[
							-81.74352990599994,
							30.28459000800007
						],
						[
							-81.74353778199992,
							30.28466415200006
						],
						[
							-81.7456209049999,
							30.28465100800008
						],
						[
							-81.7477490359999,
							30.28462014300004
						],
						[
							-81.74778690499994,
							30.283911009000064
						],
						[
							-81.74780990599993,
							30.283253008000088
						],
						[
							-81.74783990499992,
							30.28257000800005
						],
						[
							-81.74786390499992,
							30.282043009000066
						],
						[
							-81.74789490599994,
							30.281196009000045
						],
						[
							-81.74790190599992,
							30.28082500800008
						],
						[
							-81.7479169049999,
							30.28074500900004
						],
						[
							-81.7479249029999,
							30.28070400600006
						],
						[
							-81.74790990599992,
							30.28059000900004
						],
						[
							-81.7478879059999,
							30.280064009000057
						],
						[
							-81.74786090499992,
							30.27940600800008
						],
						[
							-81.74784090499992,
							30.278927008000043
						],
						[
							-81.74778690499994,
							30.277765008000074
						],
						[
							-81.74775690599995,
							30.27702000900007
						],
						[
							-81.74771990499994,
							30.27636700800008
						],
						[
							-81.74771090599995,
							30.276283008000064
						],
						[
							-81.74771090599995,
							30.276087008000047
						],
						[
							-81.7476879049999,
							30.27558700800006
						],
						[
							-81.74767290599995,
							30.274973009000067
						],
						[
							-81.74765790599992,
							30.274574008000055
						],
						[
							-81.74764590599995,
							30.27383500800005
						],
						[
							-81.7476429059999,
							30.273729008000085
						],
						[
							-81.74762290599995,
							30.272825009000087
						],
						[
							-81.74761590599991,
							30.27247100900007
						],
						[
							-81.74760390599994,
							30.271803008000067
						],
						[
							-81.7475969059999,
							30.271532008000065
						],
						[
							-81.74757385099991,
							30.270254007000062
						],
						[
							-81.74851190599992,
							30.270235008000043
						],
						[
							-81.7491529049999,
							30.270226008000066
						],
						[
							-81.7513579049999,
							30.27018900900004
						],
						[
							-81.75218190399994,
							30.27017406200008
						],
						[
							-81.75282890599993,
							30.270159008000068
						],
						[
							-81.75346390499993,
							30.270145008000043
						],
						[
							-81.7549129059999,
							30.270115008000065
						],
						[
							-81.75613390499991,
							30.27009800900004
						],
						[
							-81.7564469049999,
							30.270084008000083
						],
						[
							-81.7574839049999,
							30.27007100900005
						],
						[
							-81.75815190599991,
							30.270049008000058
						],
						[
							-81.75875890499992,
							30.270037008000088
						],
						[
							-81.7588959059999,
							30.270027008000053
						],
						[
							-81.75926990599993,
							30.270008008000048
						],
						[
							-81.75968890599995,
							30.270004008000058
						],
						[
							-81.75997890499991,
							30.270010008000042
						],
						[
							-81.76016990599993,
							30.270018008000083
						],
						[
							-81.76302290499991,
							30.26995500900006
						],
						[
							-81.7640299059999,
							30.26992200800004
						],
						[
							-81.76431290399995,
							30.269926061000035
						],
						[
							-81.76466090499993,
							30.26992300800004
						],
						[
							-81.7658539059999,
							30.269897009000093
						],
						[
							-81.76597090599995,
							30.269895009000038
						],
						[
							-81.76663690599992,
							30.26988500800007
						],
						[
							-81.7669379049999,
							30.269876009000086
						],
						[
							-81.76713890499991,
							30.26987500900009
						],
						[
							-81.76742092199993,
							30.26985392100005
						],
						[
							-81.76775690599993,
							30.270781008000085
						],
						[
							-81.76876490599994,
							30.273328008000078
						],
						[
							-81.76889790599995,
							30.27374500900004
						],
						[
							-81.76908690499994,
							30.27428700900009
						],
						[
							-81.76980090599994,
							30.276162009000075
						],
						[
							-81.77000190599995,
							30.276695008000047
						],
						[
							-81.77012290599993,
							30.27701600900008
						],
						[
							-81.77113890499993,
							30.27970700800006
						],
						[
							-81.77123790499991,
							30.280016008000075
						],
						[
							-81.77140590499994,
							30.28063000900005
						],
						[
							-81.77156590599992,
							30.28124600900009
						],
						[
							-81.77174290499994,
							30.282169009000086
						],
						[
							-81.7717769059999,
							30.28245400800006
						],
						[
							-81.77184990599994,
							30.28310000800008
						],
						[
							-81.77187890499994,
							30.28372200800004
						],
						[
							-81.7718879059999,
							30.284420008000037
						],
						[
							-81.77187990499995,
							30.284983009000086
						],
						[
							-81.77180490599994,
							30.285906008000044
						],
						[
							-81.77176690599994,
							30.286535008000044
						],
						[
							-81.77163690599991,
							30.28801900900004
						],
						[
							-81.7716219049999,
							30.28833000800006
						],
						[
							-81.77156790499993,
							30.288961008000054
						],
						[
							-81.77147690599992,
							30.29021800800007
						],
						[
							-81.77142290599994,
							30.290850009000057
						],
						[
							-81.77139990599994,
							30.291378009000088
						],
						[
							-81.77136190599992,
							30.291996008000073
						],
						[
							-81.7713539049999,
							30.292252008000048
						],
						[
							-81.77127690599991,
							30.29268600800009
						],
						[
							-81.77123990599995,
							30.293285008000055
						],
						[
							-81.77118590599991,
							30.293887008000066
						],
						[
							-81.7711239059999,
							30.29481500800006
						],
						[
							-81.77099990499994,
							30.296244008000087
						],
						[
							-81.77087090599991,
							30.297544009000035
						],
						[
							-81.77085899199994,
							30.297662066000044
						],
						[
							-81.77059490599993,
							30.297799009000077
						],
						[
							-81.77023590599993,
							30.297978008000086
						],
						[
							-81.76966990499994,
							30.29825100800008
						],
						[
							-81.76932790599994,
							30.298414008000066
						],
						[
							-81.76907990599994,
							30.29853700900009
						],
						[
							-81.76885790499995,
							30.29864900800004
						],
						[
							-81.76824390599995,
							30.29894500900008
						],
						[
							-81.76729986799995,
							30.29940092900006
						],
						[
							-81.76588790799991,
							30.30011901100005
						],
						[
							-81.76502292599992,
							30.300559060000072
						],
						[
							-81.76475688999994,
							30.30060596000004
						],
						[
							-81.76434490799994,
							30.30080201100009
						],
						[
							-81.76311590699993,
							30.301389011000083
						],
						[
							-81.76288490699994,
							30.301506011000075
						],
						[
							-81.76265790699995,
							30.301612010000042
						],
						[
							-81.76218990699994,
							30.301825011000062
						],
						[
							-81.76120890699991,
							30.30224601100008
						],
						[
							-81.76114990699995,
							30.302271010000087
						],
						[
							-81.76027290699994,
							30.302641011000045
						],
						[
							-81.75928190699995,
							30.30305401100009
						],
						[
							-81.75785990799994,
							30.30364001000004
						],
						[
							-81.75654797699991,
							30.30418007600008
						],
						[
							-81.7565399579999,
							30.304078999000065
						],
						[
							-81.75638085399993,
							30.30362501700006
						],
						[
							-81.75631890299991,
							30.302521011000067
						],
						[
							-81.75607090599993,
							30.30188900800005
						],
						[
							-81.75530398199993,
							30.298779970000055
						],
						[
							-81.75500890599994,
							30.298407009000076
						],
						[
							-81.7546489049999,
							30.298053009000057
						],
						[
							-81.75382990599991,
							30.29742100800007
						],
						[
							-81.75342079199994,
							30.29699207400006
						],
						[
							-81.75317302099995,
							30.29607094200009
						],
						[
							-81.75253899499995,
							30.295335858000044
						],
						[
							-81.75173288799994,
							30.295160058000082
						],
						[
							-81.75161990499993,
							30.295100004000062
						],
						[
							-81.7513109059999,
							30.29477401200006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Hyde Park",
				"RegionID": "124802"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.12307769599994,
					26.19637481700005,
					-80.09836563099992,
					26.211659934000068
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.09846499999992,
							26.21136000000007
						],
						[
							-80.0990211539999,
							26.209031107000044
						],
						[
							-80.09942775999991,
							26.209019264000066
						],
						[
							-80.10635829299991,
							26.208817406000037
						],
						[
							-80.10748999399993,
							26.204282422000063
						],
						[
							-80.1062800819999,
							26.204214455000056
						],
						[
							-80.10578515299994,
							26.20345034500008
						],
						[
							-80.10578869099993,
							26.20331014800007
						],
						[
							-80.10598252499994,
							26.203307529000085
						],
						[
							-80.10610829899991,
							26.203303764000054
						],
						[
							-80.10632254399991,
							26.20329734900008
						],
						[
							-80.10663218999991,
							26.20328807800007
						],
						[
							-80.10690497399993,
							26.203279911000042
						],
						[
							-80.10712681199993,
							26.20327326900008
						],
						[
							-80.10745120299993,
							26.20326355700007
						],
						[
							-80.1075841199999,
							26.203260000000057
						],
						[
							-80.10770067399994,
							26.20325985000005
						],
						[
							-80.10776396099993,
							26.203245786000082
						],
						[
							-80.10779468499994,
							26.203237658000035
						],
						[
							-80.10783131499994,
							26.20321868500008
						],
						[
							-80.10786475899994,
							26.20317572400006
						],
						[
							-80.10786845599995,
							26.203104411000083
						],
						[
							-80.1078645639999,
							26.202964315000088
						],
						[
							-80.10786169699992,
							26.202861087000088
						],
						[
							-80.1078599999999,
							26.202668946000074
						],
						[
							-80.1078599999999,
							26.202388538000037
						],
						[
							-80.10785323699992,
							26.202174739000043
						],
						[
							-80.10784440399993,
							26.201998081000056
						],
						[
							-80.10783339199992,
							26.201539967000087
						],
						[
							-80.10782999999992,
							26.201350000000048
						],
						[
							-80.10782972099992,
							26.201336724000043
						],
						[
							-80.10833821099993,
							26.201324309000086
						],
						[
							-80.1104032739999,
							26.19683053500006
						],
						[
							-80.11041318799994,
							26.19637481700005
						],
						[
							-80.11081177799991,
							26.19638381900006
						],
						[
							-80.11116634899992,
							26.196434769000067
						],
						[
							-80.1113095149999,
							26.196522024000046
						],
						[
							-80.11155891399994,
							26.196693192000055
						],
						[
							-80.12285973499992,
							26.196471934000044
						],
						[
							-80.12288568399993,
							26.19724810000008
						],
						[
							-80.12299979899991,
							26.203840873000047
						],
						[
							-80.12307653499994,
							26.20826304800005
						],
						[
							-80.12307769599994,
							26.20827536200005
						],
						[
							-80.12307362699994,
							26.208276069000078
						],
						[
							-80.12300370399993,
							26.20828823000005
						],
						[
							-80.12209143399991,
							26.20844688600005
						],
						[
							-80.12112803399992,
							26.208614433000037
						],
						[
							-80.12086694499993,
							26.208659840000053
						],
						[
							-80.12036694499994,
							26.209059840000066
						],
						[
							-80.12016694499994,
							26.209659840000086
						],
						[
							-80.12016135899995,
							26.209710621000056
						],
						[
							-80.12012294499993,
							26.210059840000042
						],
						[
							-80.1200669449999,
							26.210559840000087
						],
						[
							-80.12006249099994,
							26.210559840000087
						],
						[
							-80.11999231499993,
							26.210559800000055
						],
						[
							-80.11893982999993,
							26.210559840000087
						],
						[
							-80.11886694499992,
							26.210559840000087
						],
						[
							-80.11749541699993,
							26.210625151000045
						],
						[
							-80.1146669449999,
							26.210759840000037
						],
						[
							-80.11456420799993,
							26.210764405000077
						],
						[
							-80.11068394499995,
							26.210936840000045
						],
						[
							-80.11016879099992,
							26.21095858500007
						],
						[
							-80.1101677979999,
							26.21095342400008
						],
						[
							-80.11015052499994,
							26.210849185000086
						],
						[
							-80.1100443229999,
							26.210209165000038
						],
						[
							-80.10996943599993,
							26.20976425200007
						],
						[
							-80.10996517699994,
							26.20975984000006
						],
						[
							-80.10989406099992,
							26.20975984000006
						],
						[
							-80.10943982999993,
							26.20975984000006
						],
						[
							-80.10936694499992,
							26.20975984000006
						],
						[
							-80.10929406099991,
							26.20975984000006
						],
						[
							-80.1086398299999,
							26.20975984000006
						],
						[
							-80.10856694499995,
							26.20975984000006
						],
						[
							-80.10849406099994,
							26.20975984000006
						],
						[
							-80.10743982999992,
							26.20975984000006
						],
						[
							-80.10741243899992,
							26.20976031400005
						],
						[
							-80.10736694499991,
							26.20975984000006
						],
						[
							-80.10736151099991,
							26.209760117000087
						],
						[
							-80.10733862599994,
							26.209761228000048
						],
						[
							-80.10576694499991,
							26.209859840000036
						],
						[
							-80.10569406099995,
							26.209859840000036
						],
						[
							-80.1050398299999,
							26.209859840000036
						],
						[
							-80.10496694499994,
							26.209859840000036
						],
						[
							-80.10489406099992,
							26.209859840000036
						],
						[
							-80.1043398299999,
							26.209859840000036
						],
						[
							-80.10426694499995,
							26.209859840000036
						],
						[
							-80.10426694499995,
							26.211259840000082
						],
						[
							-80.10426695299992,
							26.211427222000054
						],
						[
							-80.10419408999991,
							26.211428390000037
						],
						[
							-80.09954579899994,
							26.21152729000005
						],
						[
							-80.09947293699993,
							26.211528457000046
						],
						[
							-80.09896594499992,
							26.211559840000064
						],
						[
							-80.09891094499994,
							26.21156884000004
						],
						[
							-80.09882188699993,
							26.21158371000007
						],
						[
							-80.0984430709999,
							26.21164696200009
						],
						[
							-80.09836563099992,
							26.211659934000068
						],
						[
							-80.0983692399999,
							26.21164728000008
						],
						[
							-80.09846499999992,
							26.21136000000007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Imperial Point",
				"RegionID": "124811"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.32597199999987,
					27.314129000000097,
					-80.26220999999987,
					27.38141500000008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.27015899999988,
							27.315014000000133
						],
						[
							-80.27020499999986,
							27.315365000000043
						],
						[
							-80.27052599999986,
							27.31581200000008
						],
						[
							-80.27050999999996,
							27.315999000000097
						],
						[
							-80.2707239999999,
							27.31634600000003
						],
						[
							-80.27119699999987,
							27.316934000000188
						],
						[
							-80.27122799999995,
							27.317117000000053
						],
						[
							-80.27173099999992,
							27.31749100000009
						],
						[
							-80.27197499999994,
							27.3178840000001
						],
						[
							-80.27240299999991,
							27.317964000000146
						],
						[
							-80.27269299999993,
							27.318399000000078
						],
						[
							-80.27360899999987,
							27.31900600000003
						],
						[
							-80.27395999999987,
							27.318938000000088
						],
						[
							-80.27406699999993,
							27.31882700000014
						],
						[
							-80.27408199999992,
							27.318591000000158
						],
						[
							-80.27434099999995,
							27.318629000000104
						],
						[
							-80.27454425899981,
							27.318492855000116
						],
						[
							-80.27571499999995,
							27.32001900000018
						],
						[
							-80.27582005199984,
							27.32015890450008
						],
						[
							-80.27581999999984,
							27.32037300000016
						],
						[
							-80.27546899999993,
							27.32080000000014
						],
						[
							-80.27520799499992,
							27.320815590000187
						],
						[
							-80.27513399999992,
							27.320782000000072
						],
						[
							-80.27495596399986,
							27.32083064400019
						],
						[
							-80.2749499999999,
							27.32083100000004
						],
						[
							-80.27482799999983,
							27.321010000000108
						],
						[
							-80.2749339999999,
							27.321136000000052
						],
						[
							-80.27449199999984,
							27.32258800000011
						],
						[
							-80.27433899999987,
							27.322745000000133
						],
						[
							-80.27433959999992,
							27.322962771600174
						],
						[
							-80.27450730248755,
							27.323119749919407
						],
						[
							-80.27464396599989,
							27.32343836333346
						],
						[
							-80.27462966999985,
							27.32359905360024
						],
						[
							-80.27485799439178,
							27.323820351210877
						],
						[
							-80.2752559999999,
							27.324021000000197
						],
						[
							-80.27559299999989,
							27.324173000000158
						],
						[
							-80.27595849999986,
							27.32428250000016
						],
						[
							-80.27614199999994,
							27.324219000000056
						],
						[
							-80.27630949999984,
							27.32412650000022
						],
						[
							-80.2765999999999,
							27.32418900000006
						],
						[
							-80.27684349999988,
							27.32419450000016
						],
						[
							-80.27711749999982,
							27.324065500000145
						],
						[
							-80.2772553174999,
							27.3238937275001
						],
						[
							-80.27707199999988,
							27.32367100000001
						],
						[
							-80.27679699999995,
							27.323648000000063
						],
						[
							-80.27666110133323,
							27.323489286666742
						],
						[
							-80.27707249999973,
							27.322813500000116
						],
						[
							-80.27722442249991,
							27.322882465000053
						],
						[
							-80.27734651279984,
							27.32330511320022
						],
						[
							-80.27734983099985,
							27.32331028600001
						],
						[
							-80.27758479599994,
							27.32369581100002
						],
						[
							-80.2776369999999,
							27.323849000000173
						],
						[
							-80.27775799457666,
							27.323981514404068
						],
						[
							-80.27780399999996,
							27.324125000000095
						],
						[
							-80.27774299999989,
							27.324197000000193
						],
						[
							-80.27583599999993,
							27.324917000000077
						],
						[
							-80.27583736679986,
							27.324921442400125
						],
						[
							-80.2759129999999,
							27.325157333000156
						],
						[
							-80.2759129999999,
							27.325192000000094
						],
						[
							-80.2760347129216,
							27.3255368259327
						],
						[
							-80.27615699999986,
							27.325718000000094
						],
						[
							-80.2762639999999,
							27.32591700000004
						],
						[
							-80.27626671599995,
							27.32592013600012
						],
						[
							-80.2762929099999,
							27.325907386000132
						],
						[
							-80.2764264824998,
							27.326102284000093
						],
						[
							-80.27643022713207,
							27.326106489249575
						],
						[
							-80.27643199999994,
							27.326111000000104
						],
						[
							-80.2765999999999,
							27.32614900000005
						],
						[
							-80.27690499999983,
							27.326184000000104
						],
						[
							-80.27716399999984,
							27.326176000000153
						],
						[
							-80.2772859999999,
							27.32611500000008
						],
						[
							-80.27736299999988,
							27.32602400000019
						],
						[
							-80.27748499999986,
							27.325932000000215
						],
						[
							-80.27750535499985,
							27.325939813000062
						],
						[
							-80.27777899999992,
							27.326104000000058
						],
						[
							-80.27778760599985,
							27.326111272666793
						],
						[
							-80.27769699999989,
							27.326194000000044
						],
						[
							-80.27769929449987,
							27.326197818000182
						],
						[
							-80.27779054299991,
							27.326262718000045
						],
						[
							-80.27785331999988,
							27.32630883500004
						],
						[
							-80.27791845799983,
							27.32635797800011
						],
						[
							-80.27795699999992,
							27.32638500000004
						],
						[
							-80.27820099999985,
							27.32699500000006
						],
						[
							-80.27852499999993,
							27.327126000000067
						],
						[
							-80.2787209999999,
							27.327921000000117
						],
						[
							-80.27956199999993,
							27.3294000000001
						],
						[
							-80.27937705959987,
							27.330008405200097
						],
						[
							-80.2794378493332,
							27.330218148000114
						],
						[
							-80.27943380699989,
							27.330222124000088
						],
						[
							-80.27928499999983,
							27.330333000000024
						],
						[
							-80.27919524699978,
							27.330456773500096
						],
						[
							-80.27899499999991,
							27.330511000000186
						],
						[
							-80.2789839269999,
							27.33050280200004
						],
						[
							-80.27881199999977,
							27.330360000000127
						],
						[
							-80.27876806499998,
							27.330343001000053
						],
						[
							-80.2782503744117,
							27.329960600817422
						],
						[
							-80.27846016049985,
							27.33030089400021
						],
						[
							-80.27849199999986,
							27.33062300000004
						],
						[
							-80.27855299999993,
							27.330820500000215
						],
						[
							-80.2785557659999,
							27.33082532000008
						],
						[
							-80.2788242319999,
							27.331341677000083
						],
						[
							-80.27882699999988,
							27.33134750000012
						],
						[
							-80.27896624099984,
							27.33151211166682
						],
						[
							-80.2790559999999,
							27.33161800000012
						],
						[
							-80.27940699999989,
							27.331805000000138
						],
						[
							-80.27944660733321,
							27.331897472666817
						],
						[
							-80.2794670659999,
							27.33194506600018
						],
						[
							-80.27949908799978,
							27.332019737000053
						],
						[
							-80.27950413999984,
							27.33206217300019
						],
						[
							-80.27952565399994,
							27.332081686000116
						],
						[
							-80.27963599999993,
							27.33233900000009
						],
						[
							-80.28001799999991,
							27.332583000000028
						],
						[
							-80.28002271799986,
							27.33262705666679
						],
						[
							-80.28004794266657,
							27.332861134666796
						],
						[
							-80.27992599999993,
							27.333147000000153
						],
						[
							-80.2797119999999,
							27.332957000000064
						],
						[
							-80.27954499999994,
							27.33298000000019
						],
						[
							-80.27940699999989,
							27.33273069600017
						],
						[
							-80.27940699999989,
							27.332681759000117
						],
						[
							-80.27938899999991,
							27.332661000000087
						],
						[
							-80.27937142599988,
							27.3325731280001
						],
						[
							-80.27933099999991,
							27.332496000000113
						],
						[
							-80.2792092299059,
							27.332374292961177
						],
						[
							-80.27916374429986,
							27.332511921200293
						],
						[
							-80.27925422083315,
							27.332733377000125
						],
						[
							-80.27919413239981,
							27.33282740080007
						],
						[
							-80.27925499999994,
							27.332931000000222
						],
						[
							-80.27945284133331,
							27.333220434666856
						],
						[
							-80.27940699999989,
							27.333346000000095
						],
						[
							-80.27929999999992,
							27.333311000000045
						],
						[
							-80.27925508719996,
							27.33339543680017
						],
						[
							-80.2793309139999,
							27.33360143400009
						],
						[
							-80.27929999999992,
							27.333758000000078
						],
						[
							-80.27919399999986,
							27.3337690000001
						],
						[
							-80.27910202639983,
							27.33396854240013
						],
						[
							-80.2791329553332,
							27.334368088666775
						],
						[
							-80.2790559999999,
							27.334521000000148
						],
						[
							-80.27873599999988,
							27.33469600000006
						],
						[
							-80.2787209999999,
							27.335013000000178
						],
						[
							-80.27859899999991,
							27.335173000000093
						],
						[
							-80.27858766099978,
							27.335176219000093
						],
						[
							-80.27846099999987,
							27.335201000000104
						],
						[
							-80.27837747699989,
							27.335235878000145
						],
						[
							-80.2783699999999,
							27.335238000000142
						],
						[
							-80.27832399999991,
							27.335490500000073
						],
						[
							-80.27832399999991,
							27.33566933333346
						],
						[
							-80.27846099999987,
							27.33596400000017
						],
						[
							-80.27853699999986,
							27.336115500000098
						],
						[
							-80.27852199999994,
							27.33631500000008
						],
						[
							-80.27856799999994,
							27.33646650000018
						],
						[
							-80.27857203099991,
							27.336469776000097
						],
						[
							-80.27903721599994,
							27.336905456000085
						],
						[
							-80.27904099999989,
							27.336909500000065
						],
						[
							-80.27917799999996,
							27.337245000000113
						],
						[
							-80.2793459999999,
							27.337509000000107
						],
						[
							-80.27948399999987,
							27.337706500000106
						],
						[
							-80.27960599999993,
							27.3377785000002
						],
						[
							-80.27961831299989,
							27.337775207000018
						],
						[
							-80.27993247999987,
							27.337703933000164
						],
						[
							-80.27994099999994,
							27.33770250000013
						],
						[
							-80.27998699999992,
							27.33779800000004
						],
						[
							-80.28018499999979,
							27.337985000000057
						],
						[
							-80.28029970199987,
							27.33805996900013
						],
						[
							-80.2804299999999,
							27.338190000000143
						],
						[
							-80.28085399999989,
							27.338419000000087
						],
						[
							-80.28083299999993,
							27.3387670000001
						],
						[
							-80.2808959999999,
							27.338873000000167
						],
						[
							-80.28109899999991,
							27.338885000000094
						],
						[
							-80.28125899999992,
							27.339003000000087
						],
						[
							-80.28120799999988,
							27.33929000000003
						],
						[
							-80.28102499999991,
							27.339244000000132
						],
						[
							-80.28085699999987,
							27.339313000000157
						],
						[
							-80.28078464999994,
							27.33937107000017
						],
						[
							-80.28078115919992,
							27.339373472400045
						],
						[
							-80.28078499099986,
							27.33937983300009
						],
						[
							-80.28097430799991,
							27.339703966000176
						],
						[
							-80.28097890799992,
							27.339712489333326
						],
						[
							-80.28094804079984,
							27.339877383200243
						],
						[
							-80.28099399999984,
							27.340110000000024
						],
						[
							-80.28106999999983,
							27.340426500000095
						],
						[
							-80.28107990099993,
							27.340436739000143
						],
						[
							-80.28168564599987,
							27.34109377000006
						],
						[
							-80.28169599999984,
							27.341105500000147
						],
						[
							-80.28170618799989,
							27.341124016000077
						],
						[
							-80.28207316199978,
							27.341808969000173
						],
						[
							-80.28207799999991,
							27.341818500000162
						],
						[
							-80.28262699999995,
							27.342318500000147
						],
						[
							-80.2832219999999,
							27.342699500000048
						],
						[
							-80.28372499999995,
							27.343180500000233
						],
						[
							-80.28392399999989,
							27.343481500000095
						],
						[
							-80.28393301899992,
							27.343489795000156
						],
						[
							-80.2848967149999,
							27.34442952500011
						],
						[
							-80.28491688077145,
							27.344450096767684
						],
						[
							-80.28511399999985,
							27.34465700000001
						],
						[
							-80.2852509999999,
							27.344775500000225
						],
						[
							-80.28525143249989,
							27.344956000000234
						],
						[
							-80.28528569399994,
							27.34495700000014
						],
						[
							-80.2853119999998,
							27.34509500000019
						],
						[
							-80.28555699999991,
							27.345171000000082
						],
						[
							-80.28575499999995,
							27.345042000000067
						],
						[
							-80.28572399999979,
							27.3448010000002
						],
						[
							-80.28577060966657,
							27.34465605733344
						],
						[
							-80.28580092399993,
							27.34456143640013
						],
						[
							-80.28567899999987,
							27.344298000000148
						],
						[
							-80.28606982499988,
							27.34397428600001
						],
						[
							-80.28607499999987,
							27.34397050000023
						],
						[
							-80.28621271666657,
							27.344057488000143
						],
						[
							-80.28609099999996,
							27.34426700000007
						],
						[
							-80.28607502039982,
							27.344565221600195
						],
						[
							-80.28625799999992,
							27.34475950000014
						],
						[
							-80.28656399999991,
							27.34478300000013
						],
						[
							-80.2866859999998,
							27.34475950000014
						],
						[
							-80.28669652999987,
							27.34476900600004
						],
						[
							-80.28712431099991,
							27.34517549500001
						],
						[
							-80.2871278106666,
							27.34517943533358
						],
						[
							-80.28705199999989,
							27.345354000000125
						],
						[
							-80.28651799999993,
							27.345377000000074
						],
						[
							-80.28581599999985,
							27.34560200000004
						],
						[
							-80.28582479566653,
							27.34561545933342
						],
						[
							-80.2859689999999,
							27.345836000000038
						],
						[
							-80.28613599999994,
							27.346075500000136
						],
						[
							-80.28613831699995,
							27.346081239000167
						],
						[
							-80.28644171149988,
							27.34689847350015
						],
						[
							-80.28673099999988,
							27.34718250000025
						],
						[
							-80.2867623159999,
							27.34719009533332
						],
						[
							-80.28708199999988,
							27.34726900000012
						],
						[
							-80.28720399999993,
							27.34715900000008
						],
						[
							-80.28709799999979,
							27.346781000000068
						],
						[
							-80.28717399999994,
							27.346499000000183
						],
						[
							-80.2873419999999,
							27.346411000000007
						],
						[
							-80.28782549899994,
							27.346495588000078
						],
						[
							-80.28784499999995,
							27.346499500000224
						],
						[
							-80.28810499999987,
							27.346698000000128
						],
						[
							-80.28830299999991,
							27.346866000000173
						],
						[
							-80.28842805699988,
							27.34694300000015
						],
						[
							-80.28844395799986,
							27.34694300000015
						],
						[
							-80.2885618036666,
							27.347030480000104
						],
						[
							-80.28859072159003,
							27.347053282913617
						],
						[
							-80.28866499999994,
							27.347779000000042
						],
						[
							-80.2886657179999,
							27.347785946000084
						],
						[
							-80.28860799999984,
							27.347785000000005
						],
						[
							-80.28850099999995,
							27.347892000000154
						],
						[
							-80.2883789999999,
							27.347957000000026
						],
						[
							-80.28821199999994,
							27.34793400000008
						],
						[
							-80.28798299999983,
							27.347988000000104
						],
						[
							-80.28784499999995,
							27.34810200000012
						],
						[
							-80.28776899999978,
							27.348365000000033
						],
						[
							-80.28796699999994,
							27.34876600000017
						],
						[
							-80.28834899999991,
							27.34891100000009
						],
						[
							-80.28857799999993,
							27.349151000000052
						],
						[
							-80.28854699999995,
							27.34933000000012
						],
						[
							-80.28845599999988,
							27.34943700000009
						],
						[
							-80.28828799999992,
							27.34949400000001
						],
						[
							-80.28793699999993,
							27.349395000000168
						],
						[
							-80.28778570499993,
							27.349438126000184
						],
						[
							-80.28795799999989,
							27.34978100000013
						],
						[
							-80.28833799999988,
							27.349966000000162
						],
						[
							-80.2885314469999,
							27.350188074000062
						],
						[
							-80.28849999999987,
							27.3502830000001
						],
						[
							-80.28922803199981,
							27.35028285200009
						],
						[
							-80.29017999999988,
							27.350295000000205
						],
						[
							-80.29314655999993,
							27.350282054000022
						],
						[
							-80.31240360499987,
							27.35027813100014
						],
						[
							-80.31762499999988,
							27.35030100000017
						],
						[
							-80.3181349999998,
							27.35030300000016
						],
						[
							-80.32438856299986,
							27.35030300000016
						],
						[
							-80.32587299999994,
							27.35030900000012
						],
						[
							-80.32588999999983,
							27.352280000000132
						],
						[
							-80.32597144499991,
							27.352280000000132
						],
						[
							-80.32597199999987,
							27.352320000000066
						],
						[
							-80.32587199999995,
							27.353220000000103
						],
						[
							-80.32587199999995,
							27.354920000000075
						],
						[
							-80.32587199999995,
							27.358716000000097
						],
						[
							-80.32587199999995,
							27.361919000000082
						],
						[
							-80.32593199999985,
							27.36597700000011
						],
						[
							-80.32597199999987,
							27.368719000000144
						],
						[
							-80.32597199999987,
							27.36951900000008
						],
						[
							-80.32597199999987,
							27.373806000000048
						],
						[
							-80.32597199999987,
							27.374219000000114
						],
						[
							-80.3246689999998,
							27.374219000000114
						],
						[
							-80.3242719999999,
							27.374219000000114
						],
						[
							-80.32337199999995,
							27.374219000000114
						],
						[
							-80.32157199999996,
							27.374219000000114
						],
						[
							-80.31967199999978,
							27.374219000000114
						],
						[
							-80.31897199999987,
							27.374219000000114
						],
						[
							-80.31777199999988,
							27.374919000000123
						],
						[
							-80.31734999999986,
							27.37515300000012
						],
						[
							-80.31687199999993,
							27.375419000000104
						],
						[
							-80.31627099999986,
							27.375819000000163
						],
						[
							-80.31487099999993,
							27.376619000000094
						],
						[
							-80.31297099999992,
							27.37771900000016
						],
						[
							-80.31167099999992,
							27.378419000000168
						],
						[
							-80.31107399999992,
							27.37876800000009
						],
						[
							-80.31047099999994,
							27.379119000000177
						],
						[
							-80.30917099999992,
							27.37991900000011
						],
						[
							-80.30827099999989,
							27.380419000000092
						],
						[
							-80.30727099999984,
							27.380919000000073
						],
						[
							-80.3058589999999,
							27.381295000000097
						],
						[
							-80.3057709999999,
							27.38131900000013
						],
						[
							-80.30583499999995,
							27.38141500000008
						],
						[
							-80.30572999999988,
							27.381414000000174
						],
						[
							-80.30000699999994,
							27.38138400000018
						],
						[
							-80.29654299999994,
							27.381243000000058
						],
						[
							-80.2956119999999,
							27.381346000000054
						],
						[
							-80.2921939999999,
							27.374976000000043
						],
						[
							-80.29172099999992,
							27.37427400000005
						],
						[
							-80.29136999999993,
							27.373518000000022
						],
						[
							-80.29054599999996,
							27.372092000000162
						],
						[
							-80.29010399999981,
							27.371207000000123
						],
						[
							-80.28982899999988,
							27.37060800000012
						],
						[
							-80.2894169999999,
							27.369635000000084
						],
						[
							-80.28850099999995,
							27.36775400000006
						],
						[
							-80.28818099999995,
							27.36709100000009
						],
						[
							-80.28790599999985,
							27.366480000000166
						],
						[
							-80.28763199999992,
							27.365832000000193
						],
						[
							-80.28721999999993,
							27.364992000000147
						],
						[
							-80.28674699999988,
							27.364107000000107
						],
						[
							-80.2863349999999,
							27.363276000000095
						],
						[
							-80.28592299999991,
							27.362421000000055
						],
						[
							-80.28554099999994,
							27.36174200000018
						],
						[
							-80.28517499999992,
							27.360930000000142
						],
						[
							-80.28485499999991,
							27.36024700000012
						],
						[
							-80.28445799999993,
							27.35956000000012
						],
						[
							-80.28416799999991,
							27.359095000000192
						],
						[
							-80.2838479999999,
							27.358775000000005
						],
						[
							-80.28380199999992,
							27.358515000000164
						],
						[
							-80.2836029999998,
							27.35799300000014
						],
						[
							-80.28352699999981,
							27.357836000000116
						],
						[
							-80.28320699999989,
							27.35713400000012
						],
						[
							-80.28283999999991,
							27.356235000000165
						],
						[
							-80.28236699999985,
							27.355434000000148
						],
						[
							-80.28192499999996,
							27.354709000000202
						],
						[
							-80.28154299999989,
							27.353977000000032
						],
						[
							-80.28135999999992,
							27.353427000000178
						],
						[
							-80.28103999999992,
							27.352741000000083
						],
						[
							-80.28074999999991,
							27.352188000000158
						],
						[
							-80.28053599999987,
							27.351669000000204
						],
						[
							-80.28033799999992,
							27.351138000000145
						],
						[
							-80.2800629999999,
							27.35049800000013
						],
						[
							-80.2797429999999,
							27.350139000000087
						],
						[
							-80.2793919999999,
							27.34953300000004
						],
						[
							-80.2793919999999,
							27.349491000000118
						],
						[
							-80.2783389999999,
							27.347301000000105
						],
						[
							-80.27812599999986,
							27.346652000000052
						],
						[
							-80.2777289999998,
							27.34585500000019
						],
						[
							-80.27737799999989,
							27.34521000000011
						],
						[
							-80.2769959999999,
							27.344383000000075
						],
						[
							-80.27652299999993,
							27.343585000000132
						],
						[
							-80.27611099999986,
							27.342731000000168
						],
						[
							-80.27571499999995,
							27.34183100000013
						],
						[
							-80.27539399999995,
							27.34117500000021
						],
						[
							-80.27514899999993,
							27.340698000000177
						],
						[
							-80.27487399999991,
							27.340213000000194
						],
						[
							-80.27447799999992,
							27.3395270000001
						],
						[
							-80.2742029999999,
							27.33893100000017
						],
						[
							-80.27394399999987,
							27.338127000000082
						],
						[
							-80.27357699999989,
							27.33747000000008
						],
						[
							-80.27330299999997,
							27.336852000000103
						],
						[
							-80.27281399999991,
							27.335933000000093
						],
						[
							-80.27231099999995,
							27.33513200000008
						],
						[
							-80.27186799999988,
							27.334323000000108
						],
						[
							-80.27150199999988,
							27.33352200000009
						],
						[
							-80.27101399999992,
							27.33259900000011
						],
						[
							-80.2707239999999,
							27.3316950000001
						],
						[
							-80.27035799999992,
							27.33087900000008
						],
						[
							-80.2700529999999,
							27.33010800000006
						],
						[
							-80.26979299999988,
							27.329323000000123
						],
						[
							-80.26947299999996,
							27.328576000000133
						],
						[
							-80.26909099999989,
							27.327782000000163
						],
						[
							-80.26877099999987,
							27.32709900000014
						],
						[
							-80.26855699999993,
							27.326645000000056
						],
						[
							-80.26840499999987,
							27.326249000000153
						],
						[
							-80.26826699999992,
							27.32579800000014
						],
						[
							-80.26802299999989,
							27.325192000000094
						],
						[
							-80.26782499999985,
							27.32496700000013
						],
						[
							-80.26759599999991,
							27.324589000000117
						],
						[
							-80.26735199999989,
							27.324276000000154
						],
						[
							-80.26718399999993,
							27.323914000000045
						],
						[
							-80.2669399999999,
							27.323452000000188
						],
						[
							-80.26671099999987,
							27.322998000000105
						],
						[
							-80.26649699999984,
							27.322613000000047
						],
						[
							-80.2662379999999,
							27.32223200000014
						],
						[
							-80.26606999999986,
							27.321907000000074
						],
						[
							-80.26584099999992,
							27.321530000000145
						],
						[
							-80.26565799999987,
							27.32120600000016
						],
						[
							-80.26541399999985,
							27.320755000000148
						],
						[
							-80.2651849999999,
							27.320317000000145
						],
						[
							-80.26501699999996,
							27.319825000000115
						],
						[
							-80.2642079999999,
							27.317864000000043
						],
						[
							-80.26402499999995,
							27.317440000000133
						],
						[
							-80.26388799999988,
							27.317147000000226
						],
						[
							-80.26376599999992,
							27.316842000000037
						],
						[
							-80.26350699999989,
							27.316464000000025
						],
						[
							-80.26318599999989,
							27.31596800000002
						],
						[
							-80.26289599999987,
							27.315506000000163
						],
						[
							-80.26220999999987,
							27.314129000000097
						],
						[
							-80.26461999999988,
							27.314408000000086
						],
						[
							-80.26494099999988,
							27.314270000000214
						],
						[
							-80.26497099999996,
							27.314579000000023
						],
						[
							-80.26759599999991,
							27.314629000000075
						],
						[
							-80.26758099999991,
							27.315014000000133
						],
						[
							-80.27015899999988,
							27.315014000000133
						]
					],
					[
						[
							-80.28900299999992,
							27.354447000000018
						],
						[
							-80.28934099999992,
							27.354546000000216
						],
						[
							-80.28949499999987,
							27.354535000000016
						],
						[
							-80.28974299999987,
							27.354322000000156
						],
						[
							-80.28989799999982,
							27.354314000000027
						],
						[
							-80.29019199999989,
							27.35402100000012
						],
						[
							-80.29073699999987,
							27.3537030000001
						],
						[
							-80.29112499999991,
							27.353623000000052
						],
						[
							-80.29126199999988,
							27.353648000000167
						],
						[
							-80.29132199999987,
							27.353748000000092
						],
						[
							-80.29137999999996,
							27.35390600000002
						],
						[
							-80.29137914599988,
							27.353916455999997
						],
						[
							-80.29140099999984,
							27.353965000000105
						],
						[
							-80.29138499999993,
							27.354118000000156
						],
						[
							-80.29130899999987,
							27.35423200000017
						],
						[
							-80.2911869999998,
							27.354282000000048
						],
						[
							-80.29103399999993,
							27.35428900000009
						],
						[
							-80.29086699999988,
							27.354358000000115
						],
						[
							-80.29071399999992,
							27.35445300000016
						],
						[
							-80.29059199999996,
							27.354572000000058
						],
						[
							-80.2904999999999,
							27.354694000000027
						],
						[
							-80.2903939999999,
							27.354762000000147
						],
						[
							-80.29027099999986,
							27.35486200000007
						],
						[
							-80.29022599999986,
							27.354980000000065
						],
						[
							-80.29011899999989,
							27.355060000000112
						],
						[
							-80.28995099999985,
							27.355113000000056
						],
						[
							-80.2897529999999,
							27.35517100000006
						],
						[
							-80.28969003299993,
							27.35526095200004
						],
						[
							-80.29003299999988,
							27.3558220000001
						],
						[
							-80.29038499999987,
							27.356191000000077
						],
						[
							-80.29094399999985,
							27.356591000000133
						],
						[
							-80.29112199999993,
							27.35667800000005
						],
						[
							-80.29119399999985,
							27.356685000000095
						],
						[
							-80.2912299999998,
							27.35666800000011
						],
						[
							-80.29126399999977,
							27.356625000000104
						],
						[
							-80.29146099999991,
							27.356505000000123
						],
						[
							-80.2915079999999,
							27.356502000000052
						],
						[
							-80.2915519999999,
							27.356524000000096
						],
						[
							-80.29158499999997,
							27.35656400000003
						],
						[
							-80.29156999999987,
							27.35666800000011
						],
						[
							-80.29153699999989,
							27.35675400000012
						],
						[
							-80.29149099999991,
							27.356812000000122
						],
						[
							-80.29138923099993,
							27.35683176100007
						],
						[
							-80.29135499999984,
							27.356875000000183
						],
						[
							-80.29123299999988,
							27.356909000000154
						],
						[
							-80.29113079699995,
							27.356886381000148
						],
						[
							-80.29112099999993,
							27.356896000000148
						],
						[
							-80.29113399999994,
							27.356995000000165
						],
						[
							-80.29127899999986,
							27.35730500000006
						],
						[
							-80.2917709999998,
							27.35800400000016
						],
						[
							-80.29183199999987,
							27.358190000000096
						],
						[
							-80.29200399999989,
							27.358378000000197
						],
						[
							-80.29214836599994,
							27.35839995400006
						],
						[
							-80.2921639999999,
							27.358385000000066
						],
						[
							-80.29239199999994,
							27.358206000000177
						],
						[
							-80.29248067899981,
							27.35815163100003
						],
						[
							-80.29264919299982,
							27.357853060000107
						],
						[
							-80.29260599999988,
							27.357664000000096
						],
						[
							-80.29277099999986,
							27.35731900000015
						],
						[
							-80.29208499999994,
							27.353203000000118
						],
						[
							-80.29176090199985,
							27.353144028000212
						],
						[
							-80.29134899999981,
							27.353197000000154
						],
						[
							-80.29109799999989,
							27.353208000000176
						],
						[
							-80.29098799999986,
							27.353127000000047
						],
						[
							-80.29091502399987,
							27.353029916000185
						],
						[
							-80.29062199999994,
							27.35297700000007
						],
						[
							-80.29022599999986,
							27.352828000000176
						],
						[
							-80.28938599999991,
							27.352386000000198
						],
						[
							-80.28909699999988,
							27.352203000000156
						],
						[
							-80.28886799999987,
							27.352031000000135
						],
						[
							-80.28872999999982,
							27.351825000000144
						],
						[
							-80.2884249999999,
							27.35124100000014
						],
						[
							-80.2883339999999,
							27.350917000000155
						],
						[
							-80.28828799999992,
							27.350658000000042
						],
						[
							-80.28833188699991,
							27.35049899900012
						],
						[
							-80.28825599999993,
							27.350514000000206
						],
						[
							-80.28790499999985,
							27.350377000000062
						],
						[
							-80.28768699999993,
							27.35041000000013
						],
						[
							-80.28730715999986,
							27.350802163000157
						],
						[
							-80.2873269999999,
							27.350990000000156
						],
						[
							-80.28740299999988,
							27.35124900000009
						],
						[
							-80.28746399999996,
							27.351650000000053
						],
						[
							-80.28764699999991,
							27.351905000000013
						],
						[
							-80.28781499999987,
							27.352020000000113
						],
						[
							-80.28786099999985,
							27.352180000000207
						],
						[
							-80.28764699999991,
							27.35250000000004
						],
						[
							-80.28766199999991,
							27.35265700000006
						],
						[
							-80.28793699999993,
							27.35295400000012
						],
						[
							-80.28821199999994,
							27.35330500000003
						],
						[
							-80.28850099999995,
							27.35376300000009
						],
						[
							-80.28868988199987,
							27.35414361200014
						],
						[
							-80.28878164499991,
							27.354232523000125
						],
						[
							-80.28886799999987,
							27.35430500000017
						],
						[
							-80.2889509869999,
							27.354396603000023
						],
						[
							-80.28900299999992,
							27.354447000000018
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Saint Lucie",
				"City": "Fort Pierce",
				"Name": "Indian River Estates",
				"RegionID": "124820"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.64382303899993,
					30.260975917000053,
					-81.6198428649999,
					30.286706006000088
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.63474790599992,
							30.28562500800007
						],
						[
							-81.63390790499994,
							30.284437008000054
						],
						[
							-81.63182090599992,
							30.28138100900009
						],
						[
							-81.63106990599994,
							30.280391009000084
						],
						[
							-81.63028890599992,
							30.27924300900008
						],
						[
							-81.62906690499995,
							30.277485008000042
						],
						[
							-81.62683390599996,
							30.274331009000036
						],
						[
							-81.62407390499993,
							30.270258008000045
						],
						[
							-81.6223989049999,
							30.267946009000067
						],
						[
							-81.6198428649999,
							30.265300927000055
						],
						[
							-81.62049090599993,
							30.264890008000066
						],
						[
							-81.62096390599993,
							30.26458700800004
						],
						[
							-81.6220309059999,
							30.263913008000088
						],
						[
							-81.62221495499995,
							30.26378808500004
						],
						[
							-81.62373390599993,
							30.26277200800007
						],
						[
							-81.62538090499993,
							30.261673008000063
						],
						[
							-81.62627390599994,
							30.261106008000073
						],
						[
							-81.6264569089999,
							30.261021010000036
						],
						[
							-81.62648590499992,
							30.261016008000073
						],
						[
							-81.62654490499995,
							30.260995010000045
						],
						[
							-81.62668095299995,
							30.260975917000053
						],
						[
							-81.62680290599991,
							30.26117800800006
						],
						[
							-81.62690090499991,
							30.261302009000076
						],
						[
							-81.62708890499994,
							30.261503006000055
						],
						[
							-81.62739690599996,
							30.261726008000043
						],
						[
							-81.62783590499993,
							30.261981008000078
						],
						[
							-81.62828290499993,
							30.262216009000046
						],
						[
							-81.6284079049999,
							30.262305008000055
						],
						[
							-81.62855990499992,
							30.262437008000063
						],
						[
							-81.62888190599995,
							30.262780009000043
						],
						[
							-81.6298519049999,
							30.263777008000094
						],
						[
							-81.63019590499994,
							30.264141009000074
						],
						[
							-81.6303209049999,
							30.264272008000034
						],
						[
							-81.63068390599994,
							30.26465300800004
						],
						[
							-81.63111290499995,
							30.265103009000086
						],
						[
							-81.63125390499994,
							30.265250008000066
						],
						[
							-81.63256090499993,
							30.26660700900004
						],
						[
							-81.6334989049999,
							30.267576009000038
						],
						[
							-81.6343539049999,
							30.268463008000086
						],
						[
							-81.6347579049999,
							30.26888300900003
						],
						[
							-81.63596390499993,
							30.270128008000086
						],
						[
							-81.63609190499994,
							30.270252009000046
						],
						[
							-81.6365809049999,
							30.270767008000067
						],
						[
							-81.63701590599993,
							30.271214008000072
						],
						[
							-81.63933590599993,
							30.27361300800004
						],
						[
							-81.63953690499994,
							30.27380600900005
						],
						[
							-81.63972090599992,
							30.27401500900004
						],
						[
							-81.6403879049999,
							30.274689008000053
						],
						[
							-81.64156290599993,
							30.275879008000064
						],
						[
							-81.64233390499993,
							30.276678008000086
						],
						[
							-81.64262390599993,
							30.27698300800006
						],
						[
							-81.64300490599994,
							30.277378009000074
						],
						[
							-81.6431579049999,
							30.277565009000057
						],
						[
							-81.64330290499993,
							30.277729009000044
						],
						[
							-81.64338690499994,
							30.277849008000093
						],
						[
							-81.64354690499994,
							30.278162006000063
						],
						[
							-81.64359990499992,
							30.27833700800005
						],
						[
							-81.64363090499995,
							30.278481008000085
						],
						[
							-81.64366090499993,
							30.278748008000033
						],
						[
							-81.64368390499993,
							30.279350008000055
						],
						[
							-81.64368490499993,
							30.27953200800005
						],
						[
							-81.64369490599995,
							30.28025400900009
						],
						[
							-81.64369790599994,
							30.28073400800008
						],
						[
							-81.64369990499995,
							30.28083300800006
						],
						[
							-81.6437179049999,
							30.281520008000086
						],
						[
							-81.64375290599992,
							30.282248009000057
						],
						[
							-81.64376090499991,
							30.282438008000046
						],
						[
							-81.64377590599992,
							30.28302000800005
						],
						[
							-81.64377990499992,
							30.28338200800005
						],
						[
							-81.6437839059999,
							30.283743008000044
						],
						[
							-81.64382185099993,
							30.284761006000053
						],
						[
							-81.64382303899993,
							30.284845141000062
						],
						[
							-81.64211190599991,
							30.28482700800004
						],
						[
							-81.64093790599992,
							30.284815008000066
						],
						[
							-81.64037683799995,
							30.284886183000083
						],
						[
							-81.6403109769999,
							30.284808833000053
						],
						[
							-81.6399539059999,
							30.284843009000042
						],
						[
							-81.63944990599992,
							30.284908009000052
						],
						[
							-81.6388319049999,
							30.285067009000045
						],
						[
							-81.63853290499992,
							30.285172009000064
						],
						[
							-81.63798490499994,
							30.285383008000053
						],
						[
							-81.63716390499991,
							30.285799009000076
						],
						[
							-81.63551190499993,
							30.286706006000088
						],
						[
							-81.63474790599992,
							30.28562500800007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Larsen",
				"RegionID": "125061"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-85.7919609999999,
					30.120647000000073,
					-85.72128199999992,
					30.17104900000004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-85.78951199999995,
							30.17072600000006
						],
						[
							-85.78942099999995,
							30.170663000000044
						],
						[
							-85.78901599999995,
							30.170307000000037
						],
						[
							-85.78754399999991,
							30.16961200000009
						],
						[
							-85.78723899999994,
							30.169292000000045
						],
						[
							-85.78620899999993,
							30.168621000000087
						],
						[
							-85.78488099999993,
							30.167942000000036
						],
						[
							-85.78298099999995,
							30.166913000000076
						],
						[
							-85.78186699999992,
							30.16628200000008
						],
						[
							-85.78058599999991,
							30.165616000000057
						],
						[
							-85.78004399999992,
							30.165319000000064
						],
						[
							-85.77942599999996,
							30.16491300000007
						],
						[
							-85.77824399999992,
							30.164361000000042
						],
						[
							-85.7773279999999,
							30.164014000000066
						],
						[
							-85.77604599999995,
							30.163482000000048
						],
						[
							-85.77548899999995,
							30.16294000000005
						],
						[
							-85.77410099999992,
							30.162223000000036
						],
						[
							-85.7722849999999,
							30.16139600000008
						],
						[
							-85.77145299999995,
							30.161098000000035
						],
						[
							-85.77114099999994,
							30.160966000000087
						],
						[
							-85.77073599999994,
							30.160791000000074
						],
						[
							-85.77005699999995,
							30.160417000000052
						],
						[
							-85.76875999999993,
							30.159557000000063
						],
						[
							-85.76805799999994,
							30.159046000000046
						],
						[
							-85.76763899999992,
							30.158668000000034
						],
						[
							-85.76664699999992,
							30.15793000000008
						],
						[
							-85.76549499999993,
							30.15772600000008
						],
						[
							-85.76447199999991,
							30.157146000000072
						],
						[
							-85.76322099999993,
							30.15654700000005
						],
						[
							-85.76212299999992,
							30.15589900000009
						],
						[
							-85.76123799999995,
							30.155477000000072
						],
						[
							-85.76048199999991,
							30.154987000000062
						],
						[
							-85.75939899999992,
							30.154424000000063
						],
						[
							-85.75852199999991,
							30.153909000000056
						],
						[
							-85.75601099999994,
							30.15266900000006
						],
						[
							-85.75527099999994,
							30.152288000000052
						],
						[
							-85.75417299999992,
							30.151365000000055
						],
						[
							-85.75324199999994,
							30.150741000000036
						],
						[
							-85.75224299999991,
							30.150390000000073
						],
						[
							-85.75083099999995,
							30.149843000000093
						],
						[
							-85.75014399999992,
							30.14936000000006
						],
						[
							-85.74842799999993,
							30.147789000000042
						],
						[
							-85.7468659999999,
							30.146418000000043
						],
						[
							-85.74261199999995,
							30.14381700000007
						],
						[
							-85.7375209999999,
							30.14092400000004
						],
						[
							-85.73204599999991,
							30.137562000000063
						],
						[
							-85.72736299999991,
							30.13441500000005
						],
						[
							-85.72521299999994,
							30.133555000000058
						],
						[
							-85.72288299999991,
							30.132968000000066
						],
						[
							-85.72272099999992,
							30.132926000000058
						],
						[
							-85.72199999999992,
							30.132675000000063
						],
						[
							-85.72377799999992,
							30.129555000000035
						],
						[
							-85.72373899999991,
							30.12957300000005
						],
						[
							-85.72337299999992,
							30.129684000000058
						],
						[
							-85.72319699999991,
							30.129774000000058
						],
						[
							-85.72273199999995,
							30.130142000000035
						],
						[
							-85.7220759999999,
							30.130788000000052
						],
						[
							-85.72199199999994,
							30.130849000000072
						],
						[
							-85.72189299999991,
							30.130878000000052
						],
						[
							-85.72172499999994,
							30.13089300000007
						],
						[
							-85.7216029999999,
							30.130870000000073
						],
						[
							-85.72147299999995,
							30.130825000000073
						],
						[
							-85.72138899999993,
							30.130771000000035
						],
						[
							-85.72133599999995,
							30.130685000000085
						],
						[
							-85.72128199999992,
							30.130456000000038
						],
						[
							-85.7212899999999,
							30.130113000000055
						],
						[
							-85.72130499999992,
							30.130012000000082
						],
						[
							-85.72135099999993,
							30.12990700000006
						],
						[
							-85.72152699999992,
							30.12964600000004
						],
						[
							-85.72195399999993,
							30.129243000000088
						],
						[
							-85.72210599999994,
							30.129123000000053
						],
						[
							-85.72230499999995,
							30.129005000000063
						],
						[
							-85.72260199999994,
							30.128870000000063
						],
						[
							-85.72292299999992,
							30.128761000000054
						],
						[
							-85.7231139999999,
							30.128713000000058
						],
						[
							-85.72337299999992,
							30.128612000000093
						],
						[
							-85.7235869999999,
							30.128568000000083
						],
						[
							-85.72368599999993,
							30.12852400000008
						],
						[
							-85.72389199999992,
							30.12837400000007
						],
						[
							-85.72408999999993,
							30.12828800000005
						],
						[
							-85.72457799999995,
							30.12813300000005
						],
						[
							-85.72463687499993,
							30.128117401000054
						],
						[
							-85.72462999999993,
							30.128103000000063
						],
						[
							-85.72472399999992,
							30.127567000000056
						],
						[
							-85.72558299999992,
							30.126900000000035
						],
						[
							-85.72714999999994,
							30.126253000000077
						],
						[
							-85.7277289999999,
							30.126082000000057
						],
						[
							-85.7283329999999,
							30.126091000000088
						],
						[
							-85.72963299999992,
							30.126177000000045
						],
						[
							-85.73010999999991,
							30.126235000000065
						],
						[
							-85.73069599999991,
							30.126199000000042
						],
						[
							-85.7309045589999,
							30.126155952000094
						],
						[
							-85.73102499999993,
							30.126075000000075
						],
						[
							-85.73141399999992,
							30.125860000000046
						],
						[
							-85.73155899999995,
							30.125757000000075
						],
						[
							-85.73174999999992,
							30.125549000000035
						],
						[
							-85.73203199999995,
							30.125137000000056
						],
						[
							-85.73219999999992,
							30.124897000000093
						],
						[
							-85.73234979599994,
							30.12476506400009
						],
						[
							-85.7321629999999,
							30.12406500000009
						],
						[
							-85.73237328499994,
							30.12324413500005
						],
						[
							-85.7322539999999,
							30.123346000000083
						],
						[
							-85.73213099999992,
							30.12349100000006
						],
						[
							-85.73187999999993,
							30.12391200000008
						],
						[
							-85.73178799999994,
							30.12413500000008
						],
						[
							-85.73167399999994,
							30.124334000000093
						],
						[
							-85.73154399999993,
							30.124494000000084
						],
						[
							-85.73127699999992,
							30.124721000000083
						],
						[
							-85.7311929999999,
							30.12476100000004
						],
						[
							-85.73110099999991,
							30.124771000000063
						],
						[
							-85.73105599999991,
							30.124719000000088
						],
						[
							-85.73110899999995,
							30.12464700000004
						],
						[
							-85.7312619999999,
							30.124519000000078
						],
						[
							-85.73150599999991,
							30.12422900000007
						],
						[
							-85.73168099999992,
							30.123977000000078
						],
						[
							-85.73179599999992,
							30.12369500000005
						],
						[
							-85.73203199999995,
							30.123384000000044
						],
						[
							-85.73217699999994,
							30.123224000000047
						],
						[
							-85.73242572499993,
							30.123039430000063
						],
						[
							-85.73252599999995,
							30.122648000000087
						],
						[
							-85.73289299999993,
							30.12192900000008
						],
						[
							-85.73372999999992,
							30.121157000000043
						],
						[
							-85.73406799999992,
							30.12095000000005
						],
						[
							-85.73421337799994,
							30.120860643000068
						],
						[
							-85.73438227399993,
							30.12075744300006
						],
						[
							-85.73439671299991,
							30.120780797000066
						],
						[
							-85.73444299999994,
							30.12075400000009
						],
						[
							-85.73457999999994,
							30.12067600000006
						],
						[
							-85.73470299999991,
							30.120647000000073
						],
						[
							-85.73480199999996,
							30.12067200000007
						],
						[
							-85.73468699999995,
							30.12080300000008
						],
						[
							-85.73449520899993,
							30.120948796000054
						],
						[
							-85.73433599999993,
							30.121553000000063
						],
						[
							-85.73401318299995,
							30.121814985000068
						],
						[
							-85.73401375899994,
							30.12181551700007
						],
						[
							-85.73349734899995,
							30.12223461400004
						],
						[
							-85.73379499999993,
							30.12261300000006
						],
						[
							-85.73441999999994,
							30.123321000000086
						],
						[
							-85.73496999999992,
							30.12398100000007
						],
						[
							-85.73535099999992,
							30.124328000000048
						],
						[
							-85.73564099999993,
							30.12455700000004
						],
						[
							-85.73601499999995,
							30.124940000000038
						],
						[
							-85.73625099999992,
							30.12512200000009
						],
						[
							-85.73696099999995,
							30.12566500000008
						],
						[
							-85.73824999999994,
							30.126352000000058
						],
						[
							-85.73869299999991,
							30.12664000000007
						],
						[
							-85.73918099999992,
							30.127090000000067
						],
						[
							-85.73929499999991,
							30.127237000000036
						],
						[
							-85.7400429999999,
							30.128021000000047
						],
						[
							-85.74020299999995,
							30.12817000000007
						],
						[
							-85.74064599999991,
							30.12846700000006
						],
						[
							-85.74095899999992,
							30.12872800000008
						],
						[
							-85.74153899999993,
							30.129302000000052
						],
						[
							-85.74200399999995,
							30.129703000000063
						],
						[
							-85.74262199999993,
							30.130306000000072
						],
						[
							-85.74285099999992,
							30.130506000000082
						],
						[
							-85.7431709999999,
							30.130731000000083
						],
						[
							-85.74331599999994,
							30.130861000000042
						],
						[
							-85.74352199999993,
							30.131011000000058
						],
						[
							-85.74378899999994,
							30.131179000000092
						],
						[
							-85.74397199999993,
							30.131326000000062
						],
						[
							-85.74523099999993,
							30.13248400000009
						],
						[
							-85.74532299999993,
							30.132579000000078
						],
						[
							-85.74565799999993,
							30.13301200000007
						],
						[
							-85.74584899999991,
							30.133214000000066
						],
						[
							-85.74607150199995,
							30.133419962000062
						],
						[
							-85.74662499999994,
							30.133616000000078
						],
						[
							-85.74706299999991,
							30.133931000000075
						],
						[
							-85.74759799999993,
							30.134487000000036
						],
						[
							-85.74807599999991,
							30.134840000000057
						],
						[
							-85.7489604459999,
							30.135904930000038
						],
						[
							-85.74944299999993,
							30.13627400000007
						],
						[
							-85.74984699999995,
							30.136537000000086
						],
						[
							-85.75044199999991,
							30.13698000000005
						],
						[
							-85.75070899999992,
							30.137239000000076
						],
						[
							-85.75122799999991,
							30.137660000000043
						],
						[
							-85.75154099999992,
							30.138019000000043
						],
						[
							-85.7520899999999,
							30.138462000000057
						],
						[
							-85.75226499999991,
							30.13862000000006
						],
						[
							-85.7524939999999,
							30.138767000000087
						],
						[
							-85.75260899999995,
							30.138809000000037
						],
						[
							-85.75266999999991,
							30.13885300000004
						],
						[
							-85.7528529999999,
							30.13906000000009
						],
						[
							-85.75315799999993,
							30.13932600000004
						],
						[
							-85.7532799999999,
							30.139469000000076
						],
						[
							-85.75350899999995,
							30.139669000000087
						],
						[
							-85.75400499999995,
							30.140172000000064
						],
						[
							-85.75407399999995,
							30.14021400000007
						],
						[
							-85.75473699999992,
							30.14047200000005
						],
						[
							-85.75498099999993,
							30.14062800000005
						],
						[
							-85.75514899999992,
							30.14070800000007
						],
						[
							-85.75529399999994,
							30.140869000000066
						],
						[
							-85.75549299999994,
							30.141199000000086
						],
						[
							-85.75610299999994,
							30.14172300000007
						],
						[
							-85.75649199999992,
							30.141960000000044
						],
						[
							-85.75694199999992,
							30.142349000000078
						],
						[
							-85.75725499999993,
							30.142566000000045
						],
						[
							-85.75740799999994,
							30.142620000000083
						],
						[
							-85.75768199999993,
							30.142673000000062
						],
						[
							-85.75785799999994,
							30.142745000000048
						],
						[
							-85.75804899999991,
							30.142925000000048
						],
						[
							-85.75838399999992,
							30.143283000000057
						],
						[
							-85.75857499999995,
							30.14353900000009
						],
						[
							-85.7587729999999,
							30.143709000000054
						],
						[
							-85.75907799999993,
							30.143861000000072
						],
						[
							-85.75927699999994,
							30.143995000000075
						],
						[
							-85.7596739999999,
							30.14419900000007
						],
						[
							-85.75979599999994,
							30.14428500000008
						],
						[
							-85.76015399999994,
							30.144611000000054
						],
						[
							-85.76042899999993,
							30.144834000000056
						],
						[
							-85.7606429999999,
							30.14504000000005
						],
						[
							-85.76086399999991,
							30.145219000000054
						],
						[
							-85.7611609999999,
							30.14542900000004
						],
						[
							-85.76135199999993,
							30.145536000000046
						],
						[
							-85.7616569999999,
							30.145675000000043
						],
						[
							-85.76187799999991,
							30.14581200000004
						],
						[
							-85.76207699999992,
							30.146036000000038
						],
						[
							-85.76269499999995,
							30.146585000000073
						],
						[
							-85.76272499999993,
							30.146650000000083
						],
						[
							-85.76278599999996,
							30.146699000000073
						],
						[
							-85.76310699999993,
							30.146903000000066
						],
						[
							-85.7634349999999,
							30.147192000000075
						],
						[
							-85.7638159999999,
							30.147445000000065
						],
						[
							-85.76423599999993,
							30.14778100000007
						],
						[
							-85.76491499999992,
							30.148241000000045
						],
						[
							-85.76592999999991,
							30.149133000000067
						],
						[
							-85.76631099999992,
							30.14939300000009
						],
						[
							-85.76673099999994,
							30.14958100000007
						],
						[
							-85.76682999999991,
							30.149648000000074
						],
						[
							-85.7671729999999,
							30.149955000000034
						],
						[
							-85.76770699999993,
							30.150503000000068
						],
						[
							-85.76791299999991,
							30.15064400000006
						],
						[
							-85.7685009999999,
							30.150903000000085
						],
						[
							-85.76886699999994,
							30.15110500000009
						],
						[
							-85.76910399999991,
							30.151325000000043
						],
						[
							-85.76933999999994,
							30.151586000000062
						],
						[
							-85.76978999999994,
							30.151962000000083
						],
						[
							-85.77021699999995,
							30.152292000000045
						],
						[
							-85.7712469999999,
							30.152952000000084
						],
						[
							-85.7717659999999,
							30.153421000000037
						],
						[
							-85.77233799999993,
							30.153816000000063
						],
						[
							-85.77286499999991,
							30.154224000000056
						],
						[
							-85.77390836299992,
							30.15495329500004
						],
						[
							-85.77428999999995,
							30.15514800000005
						],
						[
							-85.77434575599995,
							30.155191747000057
						],
						[
							-85.77463499999993,
							30.155345000000068
						],
						[
							-85.77477999999991,
							30.155447000000038
						],
						[
							-85.77479179799991,
							30.15545764600006
						],
						[
							-85.77495599999992,
							30.155463000000058
						],
						[
							-85.77507899999995,
							30.155677000000082
						],
						[
							-85.77541333199991,
							30.15602449000005
						],
						[
							-85.77542799999992,
							30.156034000000087
						],
						[
							-85.77568799999995,
							30.156156000000067
						],
						[
							-85.7759999999999,
							30.15634700000004
						],
						[
							-85.7762449999999,
							30.156549000000044
						],
						[
							-85.77659599999993,
							30.156795000000045
						],
						[
							-85.77677099999994,
							30.15690900000004
						],
						[
							-85.7771909999999,
							30.157129000000054
						],
						[
							-85.7778009999999,
							30.15752900000007
						],
						[
							-85.77812099999994,
							30.157781000000057
						],
						[
							-85.77847199999991,
							30.15811300000007
						],
						[
							-85.7790599999999,
							30.15833000000004
						],
						[
							-85.77938799999993,
							30.158540000000073
						],
						[
							-85.78034899999994,
							30.15935300000007
						],
						[
							-85.78129499999994,
							30.159942000000058
						],
						[
							-85.7815389999999,
							30.16011200000008
						],
						[
							-85.78162299999991,
							30.16019400000005
						],
						[
							-85.78192899999993,
							30.160404000000085
						],
						[
							-85.7823019999999,
							30.16057300000006
						],
						[
							-85.7828669999999,
							30.160766000000084
						],
						[
							-85.78317199999992,
							30.160905000000074
						],
						[
							-85.78353099999993,
							30.16123700000008
						],
						[
							-85.7840569999999,
							30.161676000000057
						],
						[
							-85.7847359999999,
							30.16215800000009
						],
						[
							-85.78544599999992,
							30.16261200000008
						],
						[
							-85.78561399999991,
							30.16274000000004
						],
						[
							-85.78580399999993,
							30.16282400000006
						],
						[
							-85.78641499999992,
							30.163200000000078
						],
						[
							-85.7874369999999,
							30.163906000000058
						],
						[
							-85.78786399999991,
							30.164140000000092
						],
						[
							-85.7881999999999,
							30.164279000000082
						],
						[
							-85.78850499999993,
							30.164447000000052
						],
						[
							-85.7887639999999,
							30.164646000000065
						],
						[
							-85.78900099999993,
							30.164865000000077
						],
						[
							-85.7892369999999,
							30.16502300000008
						],
						[
							-85.7896189999999,
							30.165319000000064
						],
						[
							-85.79029799999995,
							30.165670000000034
						],
						[
							-85.78972899999991,
							30.16653100000008
						],
						[
							-85.78967999999992,
							30.16658200000006
						],
						[
							-85.7897979999999,
							30.16665800000004
						],
						[
							-85.78941099999992,
							30.167118000000073
						],
						[
							-85.78963199999993,
							30.167263000000048
						],
						[
							-85.78978899999993,
							30.16708700000004
						],
						[
							-85.79023399999994,
							30.167411000000076
						],
						[
							-85.7902739999999,
							30.167436000000066
						],
						[
							-85.7901799999999,
							30.167590000000075
						],
						[
							-85.79017499999992,
							30.16759800000006
						],
						[
							-85.79016099999991,
							30.167621000000054
						],
						[
							-85.79015399999992,
							30.16762900000009
						],
						[
							-85.78992799999993,
							30.168002000000058
						],
						[
							-85.78986399999991,
							30.16810600000008
						],
						[
							-85.78994699999993,
							30.168210000000048
						],
						[
							-85.7919609999999,
							30.169540000000037
						],
						[
							-85.79188199999993,
							30.17002400000007
						],
						[
							-85.79162799999995,
							30.169883000000084
						],
						[
							-85.79138099999994,
							30.169733000000065
						],
						[
							-85.79118299999993,
							30.16999200000004
						],
						[
							-85.79053999999991,
							30.170964000000083
						],
						[
							-85.79051199999992,
							30.170948000000067
						],
						[
							-85.79012999999992,
							30.17088500000006
						],
						[
							-85.79006099999992,
							30.170854000000077
						],
						[
							-85.7899779999999,
							30.17077400000005
						],
						[
							-85.78986299999991,
							30.170724000000064
						],
						[
							-85.78985799999992,
							30.17072500000006
						],
						[
							-85.78985899999992,
							30.17104900000004
						],
						[
							-85.7897789999999,
							30.171001000000047
						],
						[
							-85.78975099999991,
							30.17096900000007
						],
						[
							-85.78957899999995,
							30.170821000000046
						],
						[
							-85.78952199999992,
							30.17075400000004
						],
						[
							-85.78951199999995,
							30.17072600000006
						]
					],
					[
						[
							-85.78670199999993,
							30.168295000000057
						],
						[
							-85.78640760999991,
							30.168139278000073
						],
						[
							-85.78640399999995,
							30.16814400000004
						],
						[
							-85.78662799999995,
							30.168266000000077
						],
						[
							-85.7868719999999,
							30.168863000000044
						],
						[
							-85.78702664499991,
							30.168916992000053
						],
						[
							-85.78670199999993,
							30.168295000000057
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Bay",
				"City": "Panama City",
				"Name": "Lower Grand Lagoon",
				"RegionID": "125152"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.1324820879999,
					26.210917091000056,
					-80.12318058599993,
					26.22941060100004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.12318058599993,
							26.21111383400006
						],
						[
							-80.1324820879999,
							26.210917091000056
						],
						[
							-80.13246494999993,
							26.210975955000038
						],
						[
							-80.13163372899993,
							26.213831017000075
						],
						[
							-80.12788677499992,
							26.226797452000085
						],
						[
							-80.1270562819999,
							26.229314885000065
						],
						[
							-80.12330198199994,
							26.22941060100004
						],
						[
							-80.1232301899999,
							26.227162176000036
						],
						[
							-80.12330437299994,
							26.222711191000087
						],
						[
							-80.12337855599993,
							26.21848275600007
						],
						[
							-80.12325491699994,
							26.214823058000036
						],
						[
							-80.12318058599993,
							26.21111383400006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Pompano Beach",
				"Name": "Lyons Park",
				"RegionID": "125172"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.81775299999998,
					26.25427300000007,
					-81.80127999999996,
					26.272387000000037
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.81766799999998,
							26.270051000000024
						],
						[
							-81.81768699999998,
							26.270550000000075
						],
						[
							-81.81770999999998,
							26.271186000000057
						],
						[
							-81.81771999999995,
							26.271458000000052
						],
						[
							-81.81775299999998,
							26.272324000000026
						],
						[
							-81.81528499999996,
							26.272327000000075
						],
						[
							-81.81364999999994,
							26.272335000000055
						],
						[
							-81.81174299999998,
							26.272343000000035
						],
						[
							-81.81005799999997,
							26.272354000000067
						],
						[
							-81.80955599999999,
							26.272354000000067
						],
						[
							-81.807258,
							26.27236300000004
						],
						[
							-81.80637499999995,
							26.272358000000054
						],
						[
							-81.80546099999998,
							26.272365000000036
						],
						[
							-81.80288599999994,
							26.272387000000037
						],
						[
							-81.80163099999999,
							26.272378000000064
						],
						[
							-81.80161399999997,
							26.27150000000006
						],
						[
							-81.80159699999996,
							26.270590000000027
						],
						[
							-81.80157999999994,
							26.269693000000075
						],
						[
							-81.80156199999999,
							26.268763000000035
						],
						[
							-81.80154499999998,
							26.26786100000004
						],
						[
							-81.80152699999996,
							26.266953000000058
						],
						[
							-81.80150799999996,
							26.26604800000007
						],
						[
							-81.80148999999994,
							26.26516600000008
						],
						[
							-81.80147199999999,
							26.264290000000074
						],
						[
							-81.80145399999998,
							26.26336800000007
						],
						[
							-81.80143899999996,
							26.262464000000023
						],
						[
							-81.80142399999994,
							26.261546000000067
						],
						[
							-81.80140399999995,
							26.260654000000045
						],
						[
							-81.80138599999998,
							26.259739000000025
						],
						[
							-81.80137099999996,
							26.258832000000044
						],
						[
							-81.80136499999998,
							26.257949000000053
						],
						[
							-81.80134999999996,
							26.25757500000003
						],
						[
							-81.80134299999997,
							26.257040000000075
						],
						[
							-81.80132399999997,
							26.25612700000005
						],
						[
							-81.80129999999997,
							26.255224000000055
						],
						[
							-81.80128099999996,
							26.254533000000038
						],
						[
							-81.80127999999996,
							26.254304000000047
						],
						[
							-81.80151499999994,
							26.254292000000078
						],
						[
							-81.80223199999995,
							26.254290000000026
						],
						[
							-81.80303899999996,
							26.25427300000007
						],
						[
							-81.80502699999994,
							26.25428400000004
						],
						[
							-81.80907799999994,
							26.254287000000037
						],
						[
							-81.80957499999994,
							26.254283000000044
						],
						[
							-81.81114299999996,
							26.254291000000023
						],
						[
							-81.81309999999996,
							26.254291000000023
						],
						[
							-81.81415799999996,
							26.254291000000023
						],
						[
							-81.81532099999998,
							26.254298000000063
						],
						[
							-81.81713499999995,
							26.254296000000068
						],
						[
							-81.81714999999998,
							26.254614000000064
						],
						[
							-81.81715399999996,
							26.254785000000027
						],
						[
							-81.81716399999993,
							26.25525200000004
						],
						[
							-81.81718299999994,
							26.256159000000025
						],
						[
							-81.81718799999999,
							26.256390000000067
						],
						[
							-81.81720299999995,
							26.257070000000056
						],
						[
							-81.81721499999998,
							26.257595000000038
						],
						[
							-81.81722499999995,
							26.257976000000042
						],
						[
							-81.81724799999995,
							26.25869300000005
						],
						[
							-81.81725299999994,
							26.258838000000026
						],
						[
							-81.81730399999998,
							26.25977800000004
						],
						[
							-81.81731799999994,
							26.260658000000035
						],
						[
							-81.81732599999998,
							26.26089300000007
						],
						[
							-81.81735199999997,
							26.261563000000024
						],
						[
							-81.81736999999998,
							26.261993000000075
						],
						[
							-81.81738599999994,
							26.262471000000062
						],
						[
							-81.81741099999994,
							26.26309100000003
						],
						[
							-81.81742099999997,
							26.263377000000048
						],
						[
							-81.81745099999995,
							26.264189000000044
						],
						[
							-81.81745499999994,
							26.264287000000024
						],
						[
							-81.81748699999997,
							26.26515100000006
						],
						[
							-81.81749399999995,
							26.265293000000042
						],
						[
							-81.81752199999994,
							26.266013000000044
						],
						[
							-81.81753599999996,
							26.26638900000006
						],
						[
							-81.81755599999997,
							26.266919000000033
						],
						[
							-81.81758299999996,
							26.26781600000004
						],
						[
							-81.81762099999999,
							26.26873500000005
						],
						[
							-81.81762799999996,
							26.268921000000034
						],
						[
							-81.81765299999995,
							26.269644000000028
						],
						[
							-81.81766799999998,
							26.270051000000024
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Collier",
				"City": "Naples",
				"Name": "Naples Park",
				"RegionID": "125397"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.12001740099993,
					26.120064578000044,
					-80.11625384899992,
					26.129179776000058
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.11801045399994,
							26.120084662000068
						],
						[
							-80.11846112199993,
							26.120082660000037
						],
						[
							-80.11876156699992,
							26.120084662000068
						],
						[
							-80.1192462869999,
							26.120080656000084
						],
						[
							-80.11950667299993,
							26.12007564900006
						],
						[
							-80.11969394999994,
							26.120069640000054
						],
						[
							-80.1198702129999,
							26.120064578000044
						],
						[
							-80.12001099999992,
							26.12871000000007
						],
						[
							-80.12001740099993,
							26.129103099000076
						],
						[
							-80.11961601899992,
							26.129106163000074
						],
						[
							-80.1163439579999,
							26.12917847400007
						],
						[
							-80.11628630599996,
							26.129179776000058
						],
						[
							-80.11628499999995,
							26.12881500000009
						],
						[
							-80.11625384899992,
							26.120113651000054
						],
						[
							-80.11630993199992,
							26.120112704000064
						],
						[
							-80.11676059999992,
							26.120105693000085
						],
						[
							-80.11737751399994,
							26.12009567800004
						],
						[
							-80.11785822799995,
							26.12008866800005
						],
						[
							-80.11801045399994,
							26.120084662000068
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Nurmi Isles",
				"RegionID": "125488"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.6391119939999,
					30.432019217000065,
					-81.55640663799994,
					30.47277500900009
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.59194891899995,
							30.464356971000086
						],
						[
							-81.59149190499994,
							30.46434600900005
						],
						[
							-81.5898819059999,
							30.464363008000074
						],
						[
							-81.5875629059999,
							30.464390008000066
						],
						[
							-81.5851359049999,
							30.46440700900007
						],
						[
							-81.58457190599995,
							30.46442000700006
						],
						[
							-81.5843429059999,
							30.46440900800007
						],
						[
							-81.5840299059999,
							30.464373008000052
						],
						[
							-81.58376290599995,
							30.464319008000075
						],
						[
							-81.58338890599993,
							30.46420500700009
						],
						[
							-81.58302290599994,
							30.464037008000044
						],
						[
							-81.58270285499992,
							30.463844083000083
						],
						[
							-81.58251190499993,
							30.46370300600006
						],
						[
							-81.5824359049999,
							30.463621008000075
						],
						[
							-81.58223690599993,
							30.463444008000067
						],
						[
							-81.58130390499991,
							30.462473009000064
						],
						[
							-81.58043690599993,
							30.461578009000046
						],
						[
							-81.58017590299994,
							30.461329008000064
						],
						[
							-81.58000790599993,
							30.46122000800005
						],
						[
							-81.57984190499991,
							30.46112600800006
						],
						[
							-81.57960490599993,
							30.461023008000044
						],
						[
							-81.57944490699992,
							30.460968008000066
						],
						[
							-81.57932290499991,
							30.46093600900008
						],
						[
							-81.57922390499994,
							30.46092000900006
						],
						[
							-81.57900991199995,
							30.46091695700005
						],
						[
							-81.5786819089999,
							30.460926011000087
						],
						[
							-81.5782549079999,
							30.461020010000084
						],
						[
							-81.57691190799994,
							30.461388010000064
						],
						[
							-81.57617190799994,
							30.46159001000007
						],
						[
							-81.57575190799992,
							30.46169501000009
						],
						[
							-81.57407390799995,
							30.46214101000004
						],
						[
							-81.5722729069999,
							30.462605011000054
						],
						[
							-81.57189890799992,
							30.462687010000078
						],
						[
							-81.57149490699993,
							30.462757010000075
						],
						[
							-81.57100690699991,
							30.46281201100004
						],
						[
							-81.57067090699991,
							30.462837010000044
						],
						[
							-81.56921790699994,
							30.46287201100006
						],
						[
							-81.5690989069999,
							30.462875010000058
						],
						[
							-81.56744290699993,
							30.462893010000073
						],
						[
							-81.56639890799994,
							30.46290401000005
						],
						[
							-81.5636919079999,
							30.462932010000088
						],
						[
							-81.56280390599994,
							30.462953006000077
						],
						[
							-81.56258490699992,
							30.46288301000004
						],
						[
							-81.56240990799995,
							30.462829010000064
						],
						[
							-81.56221590699994,
							30.462732010000078
						],
						[
							-81.56205990799992,
							30.46263001000006
						],
						[
							-81.56191590899994,
							30.462506010000084
						],
						[
							-81.5617660879999,
							30.462320144000046
						],
						[
							-81.5608309079999,
							30.46094501000005
						],
						[
							-81.5604249079999,
							30.46037601100005
						],
						[
							-81.55928990699994,
							30.458735011000044
						],
						[
							-81.5591929069999,
							30.458565010000086
						],
						[
							-81.55894490799994,
							30.45814701000006
						],
						[
							-81.55866190699994,
							30.45753501100006
						],
						[
							-81.55851690799994,
							30.457157010000056
						],
						[
							-81.55840290799995,
							30.456783011000084
						],
						[
							-81.55832690799991,
							30.45652601000006
						],
						[
							-81.55820481799992,
							30.45591902400008
						],
						[
							-81.55816690699993,
							30.455564010000042
						],
						[
							-81.55813590799994,
							30.45510901100005
						],
						[
							-81.55812090799992,
							30.453896011000044
						],
						[
							-81.5581279079999,
							30.45318001000004
						],
						[
							-81.55812090799992,
							30.45109401000008
						],
						[
							-81.5581279079999,
							30.45069101000007
						],
						[
							-81.55811290799994,
							30.444082011000035
						],
						[
							-81.55811296799993,
							30.441168014000084
						],
						[
							-81.55858914099991,
							30.436047874000053
						],
						[
							-81.55691030899993,
							30.433697807000044
						],
						[
							-81.55640663799994,
							30.432019217000065
						],
						[
							-81.58210424999993,
							30.438073309000064
						],
						[
							-81.58234707799994,
							30.438131964000036
						],
						[
							-81.5826018649999,
							30.438001127000064
						],
						[
							-81.58324227599991,
							30.437760112000035
						],
						[
							-81.5836877619999,
							30.437611208000078
						],
						[
							-81.5840576359999,
							30.436924299000054
						],
						[
							-81.58421285299995,
							30.436756998000078
						],
						[
							-81.58472999999992,
							30.43716100000006
						],
						[
							-81.58695822399994,
							30.438901717000075
						],
						[
							-81.59484794399992,
							30.44007670100007
						],
						[
							-81.6049499909999,
							30.439762963000078
						],
						[
							-81.6053289059999,
							30.44138800800005
						],
						[
							-81.6054379059999,
							30.441663006000052
						],
						[
							-81.60555490599997,
							30.441846008000088
						],
						[
							-81.60563890599991,
							30.441948008000058
						],
						[
							-81.60588290699991,
							30.442168007000078
						],
						[
							-81.60647488799992,
							30.442474058000073
						],
						[
							-81.60814990599994,
							30.44280400800005
						],
						[
							-81.60986590599994,
							30.44313000800008
						],
						[
							-81.6120119059999,
							30.443556009000076
						],
						[
							-81.6130079049999,
							30.44373700800008
						],
						[
							-81.61424690599995,
							30.44399000800007
						],
						[
							-81.6145809059999,
							30.44404700800004
						],
						[
							-81.61496090499992,
							30.444124008000074
						],
						[
							-81.61629690599995,
							30.44437900800006
						],
						[
							-81.6201699049999,
							30.44512000800006
						],
						[
							-81.62125790599993,
							30.445324009000046
						],
						[
							-81.62293490699994,
							30.445613008000063
						],
						[
							-81.62349190499992,
							30.44574000800009
						],
						[
							-81.62376290499994,
							30.445783008000035
						],
						[
							-81.6275289049999,
							30.44652400800004
						],
						[
							-81.62816690499996,
							30.446645008000072
						],
						[
							-81.6292189049999,
							30.446850009000062
						],
						[
							-81.62971690599994,
							30.446938009000068
						],
						[
							-81.6328879049999,
							30.447558009000094
						],
						[
							-81.63430592599991,
							30.447822973000086
						],
						[
							-81.6349319059999,
							30.44795600800006
						],
						[
							-81.63603090499993,
							30.44816000800006
						],
						[
							-81.6363089059999,
							30.44819800700009
						],
						[
							-81.63676790599993,
							30.448195009000074
						],
						[
							-81.63702190599992,
							30.448173008000087
						],
						[
							-81.63725690599995,
							30.448129008000084
						],
						[
							-81.63784090599995,
							30.44798700800004
						],
						[
							-81.63818390499995,
							30.447861009000064
						],
						[
							-81.63839390499993,
							30.44776800900007
						],
						[
							-81.63847690599994,
							30.447740007000046
						],
						[
							-81.6386989049999,
							30.447620009000048
						],
						[
							-81.63879988199994,
							30.44757587700008
						],
						[
							-81.63895290699992,
							30.447571010000047
						],
						[
							-81.63904190599993,
							30.447587008000085
						],
						[
							-81.6391119939999,
							30.447609027000052
						],
						[
							-81.63886590499993,
							30.448358009000057
						],
						[
							-81.63859673799993,
							30.449189093000086
						],
						[
							-81.63870007299994,
							30.449216924000037
						],
						[
							-81.6381779049999,
							30.450797008000052
						],
						[
							-81.63756090599992,
							30.452662009000054
						],
						[
							-81.63732690599994,
							30.453370008000036
						],
						[
							-81.63694790599993,
							30.45451500900009
						],
						[
							-81.6365089059999,
							30.455842009000037
						],
						[
							-81.63648290599991,
							30.455915008000094
						],
						[
							-81.63602290499995,
							30.457284009000034
						],
						[
							-81.63592790599996,
							30.457557009000084
						],
						[
							-81.63588487999994,
							30.45768991300008
						],
						[
							-81.6354419079999,
							30.459059010000093
						],
						[
							-81.6354199079999,
							30.459124011000085
						],
						[
							-81.63470390799995,
							30.46123601100004
						],
						[
							-81.63458599299992,
							30.461571176000064
						],
						[
							-81.63446492599991,
							30.46153592600007
						],
						[
							-81.63421090799994,
							30.461480011000052
						],
						[
							-81.63400090599993,
							30.461468012000072
						],
						[
							-81.6338999059999,
							30.461480011000052
						],
						[
							-81.63379790699992,
							30.461511011000084
						],
						[
							-81.63366790799995,
							30.461567011000056
						],
						[
							-81.6333539069999,
							30.461737011000082
						],
						[
							-81.63208190799992,
							30.462407010000046
						],
						[
							-81.6317739079999,
							30.46256801000004
						],
						[
							-81.63124290799993,
							30.46287401000006
						],
						[
							-81.6310549079999,
							30.462995011000086
						],
						[
							-81.63072590799993,
							30.463273011000066
						],
						[
							-81.63052190799993,
							30.463477011000066
						],
						[
							-81.63010790699991,
							30.463824011000046
						],
						[
							-81.62995090699991,
							30.463974010000072
						],
						[
							-81.6297449079999,
							30.46417901000007
						],
						[
							-81.62863290799993,
							30.465267010000044
						],
						[
							-81.62834290799992,
							30.46557301000007
						],
						[
							-81.62791190699994,
							30.465994010000088
						],
						[
							-81.62777790799993,
							30.466106010000086
						],
						[
							-81.62744790699992,
							30.46632101000006
						],
						[
							-81.62733290699994,
							30.466372009000054
						],
						[
							-81.62707490799994,
							30.46644801000008
						],
						[
							-81.62603790799994,
							30.466635011000054
						],
						[
							-81.62508390799991,
							30.466782010000088
						],
						[
							-81.62180290799995,
							30.467264011000054
						],
						[
							-81.62029990799994,
							30.46749701100003
						],
						[
							-81.61958290799993,
							30.467644009000082
						],
						[
							-81.61903390799995,
							30.467772011000076
						],
						[
							-81.61785090799992,
							30.46810001100005
						],
						[
							-81.61618790799992,
							30.468559010000035
						],
						[
							-81.61548590799993,
							30.468754010000055
						],
						[
							-81.61498990699994,
							30.468901011000067
						],
						[
							-81.61465490699993,
							30.469013011000072
						],
						[
							-81.61395290699994,
							30.469301011000084
						],
						[
							-81.61364690799991,
							30.469450011000053
						],
						[
							-81.61314390799993,
							30.469725010000047
						],
						[
							-81.61293790699995,
							30.469839011000087
						],
						[
							-81.61251790699993,
							30.470119010000076
						],
						[
							-81.61226490799993,
							30.470304011000056
						],
						[
							-81.60963390699993,
							30.472221010000055
						],
						[
							-81.60935990799993,
							30.472389010000082
						],
						[
							-81.60919990799994,
							30.472467011000045
						],
						[
							-81.60915790799993,
							30.47248401000007
						],
						[
							-81.60888690799993,
							30.472591010000087
						],
						[
							-81.60859590799993,
							30.47267201000005
						],
						[
							-81.6084519069999,
							30.47271201000007
						],
						[
							-81.60816190699991,
							30.47275701000007
						],
						[
							-81.60799390799991,
							30.472771010000088
						],
						[
							-81.60756690799991,
							30.47277500900009
						],
						[
							-81.60729190799992,
							30.472750010000087
						],
						[
							-81.6069179079999,
							30.47267701000004
						],
						[
							-81.6050259079999,
							30.47219701100005
						],
						[
							-81.60473990799994,
							30.472122010000078
						],
						[
							-81.60330190699995,
							30.471746011000054
						],
						[
							-81.60308090799994,
							30.471678010000065
						],
						[
							-81.60271490799994,
							30.47152501000005
						],
						[
							-81.60234090799992,
							30.47131901000006
						],
						[
							-81.60213490799993,
							30.47118001000007
						],
						[
							-81.60146495499993,
							30.470626979000087
						],
						[
							-81.60111190599991,
							30.470341008000048
						],
						[
							-81.6008909059999,
							30.470106008000073
						],
						[
							-81.59883090499994,
							30.467680008000062
						],
						[
							-81.59842690599993,
							30.46722600800007
						],
						[
							-81.59827090599993,
							30.467075008000055
						],
						[
							-81.5979389069999,
							30.46675300900006
						],
						[
							-81.59747290599995,
							30.46636000900008
						],
						[
							-81.59700790599993,
							30.466024009000083
						],
						[
							-81.59654190599991,
							30.46572500900004
						],
						[
							-81.5961419059999,
							30.46550600800009
						],
						[
							-81.59567990499994,
							30.46527500800005
						],
						[
							-81.59520690599993,
							30.46506700800006
						],
						[
							-81.59489390599992,
							30.46494700800008
						],
						[
							-81.59452090499991,
							30.464828008000044
						],
						[
							-81.59396390599994,
							30.464668008000046
						],
						[
							-81.59364290499991,
							30.46459200800007
						],
						[
							-81.59320790499993,
							30.464502009000057
						],
						[
							-81.59256690599994,
							30.464405009000075
						],
						[
							-81.59194891899995,
							30.464356971000086
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Oceanway",
				"RegionID": "125531"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.71857032199995,
					30.250744819000094,
					-81.69884686699993,
					30.273138716000062
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.6995319049999,
							30.255079008000052
						],
						[
							-81.6991039049999,
							30.25323900800004
						],
						[
							-81.69884686699993,
							30.25219822600008
						],
						[
							-81.69902985899995,
							30.252426075000077
						],
						[
							-81.69922302499992,
							30.252494864000088
						],
						[
							-81.6996079029999,
							30.25314717700007
						],
						[
							-81.70006480799992,
							30.252434845000035
						],
						[
							-81.7001909889999,
							30.252425174000052
						],
						[
							-81.70105987199992,
							30.251432968000078
						],
						[
							-81.70172390599993,
							30.251019009000064
						],
						[
							-81.70237993899991,
							30.250744819000094
						],
						[
							-81.70360785199995,
							30.251886192000082
						],
						[
							-81.70631500199994,
							30.25147984600005
						],
						[
							-81.70643384499994,
							30.251802183000052
						],
						[
							-81.7069929999999,
							30.251438000000064
						],
						[
							-81.70803399099992,
							30.251092701000058
						],
						[
							-81.70802757299994,
							30.251125997000088
						],
						[
							-81.7079915729999,
							30.251282997000093
						],
						[
							-81.70796575199995,
							30.251373550000036
						],
						[
							-81.70795705199993,
							30.251398936000044
						],
						[
							-81.7080565579999,
							30.251605055000084
						],
						[
							-81.70829391699993,
							30.251824105000082
						],
						[
							-81.70832208399993,
							30.25185125800004
						],
						[
							-81.7084680829999,
							30.251998257000086
						],
						[
							-81.7085189199999,
							30.25205392700008
						],
						[
							-81.70859662899994,
							30.25216182900005
						],
						[
							-81.70922476999993,
							30.253186035000056
						],
						[
							-81.71011454099995,
							30.25432244700005
						],
						[
							-81.71061752199995,
							30.25482204800005
						],
						[
							-81.71068246399994,
							30.254779463000094
						],
						[
							-81.71075099299992,
							30.254742930000077
						],
						[
							-81.7108225479999,
							30.254712749000074
						],
						[
							-81.71089653999991,
							30.254689168000084
						],
						[
							-81.71097236199995,
							30.25467238000005
						],
						[
							-81.71104939299994,
							30.254662523000036
						],
						[
							-81.71112699999992,
							30.254659678000053
						],
						[
							-81.71127199999995,
							30.254659678000053
						],
						[
							-81.7114281659999,
							30.254673340000068
						],
						[
							-81.71152062799992,
							30.254694729000054
						],
						[
							-81.71157485799995,
							30.254712934000054
						],
						[
							-81.71166610599994,
							30.25473867600004
						],
						[
							-81.71173279499993,
							30.254758332000048
						],
						[
							-81.7117972229999,
							30.254784465000057
						],
						[
							-81.71185876099992,
							30.254816820000084
						],
						[
							-81.71191681199991,
							30.254855083000056
						],
						[
							-81.7119975469999,
							30.254909875000067
						],
						[
							-81.71206158599995,
							30.254949513000046
						],
						[
							-81.7128622859999,
							30.255444537000077
						],
						[
							-81.71299866299995,
							30.25553001700007
						],
						[
							-81.71305409999991,
							30.255567718000066
						],
						[
							-81.71310657299995,
							30.255609443000083
						],
						[
							-81.71315579299994,
							30.25565496200005
						],
						[
							-81.7132014849999,
							30.255704020000053
						],
						[
							-81.71324339599994,
							30.255756347000045
						],
						[
							-81.7133523949999,
							30.255903346000085
						],
						[
							-81.7134179549999,
							30.256005518000052
						],
						[
							-81.71422995599994,
							30.25748151800008
						],
						[
							-81.71425350199992,
							30.25752738600005
						],
						[
							-81.71479850199995,
							30.258668385000078
						],
						[
							-81.71484681499993,
							30.25879237300006
						],
						[
							-81.71500136299994,
							30.259296428000084
						],
						[
							-81.71503425899994,
							30.259330360000035
						],
						[
							-81.71566241799991,
							30.25938393000007
						],
						[
							-81.71574216599993,
							30.25939434000008
						],
						[
							-81.71586775299994,
							30.25942595300006
						],
						[
							-81.71596475299992,
							30.259457954000084
						],
						[
							-81.71599058699991,
							30.259466914000082
						],
						[
							-81.7161326609999,
							30.25953316500005
						],
						[
							-81.71626107299994,
							30.25962308000004
						],
						[
							-81.7163719209999,
							30.259733927000074
						],
						[
							-81.71646183599995,
							30.25986233900005
						],
						[
							-81.71652808699992,
							30.26000441400004
						],
						[
							-81.71655211099994,
							30.260080859000084
						],
						[
							-81.71657711099994,
							30.260174859000074
						],
						[
							-81.71659361799993,
							30.260249602000048
						],
						[
							-81.7166037099999,
							30.260325477000038
						],
						[
							-81.71660731199997,
							30.26040193600005
						],
						[
							-81.71660440099993,
							30.260478424000045
						],
						[
							-81.71659499499992,
							30.26055438800006
						],
						[
							-81.71657916399994,
							30.26062927700008
						],
						[
							-81.7165570219999,
							30.26070254800004
						],
						[
							-81.71653869999994,
							30.260755004000092
						],
						[
							-81.71655795399994,
							30.261427254000072
						],
						[
							-81.71655748199993,
							30.261491855000088
						],
						[
							-81.71655237499994,
							30.261556256000063
						],
						[
							-81.71654265699993,
							30.261620123000057
						],
						[
							-81.71652837999994,
							30.261683129000062
						],
						[
							-81.71650551199993,
							30.26176951900004
						],
						[
							-81.71654192099993,
							30.261805927000065
						],
						[
							-81.71661807599992,
							30.261911308000037
						],
						[
							-81.71669803999993,
							30.262040732000063
						],
						[
							-81.7167531419999,
							30.26211702800003
						],
						[
							-81.7174831239999,
							30.26224146600003
						],
						[
							-81.71762061099992,
							30.26227624600006
						],
						[
							-81.71774161099995,
							30.262317246000066
						],
						[
							-81.71780553699995,
							30.262341651000042
						],
						[
							-81.71786741999995,
							30.262370850000085
						],
						[
							-81.71792690099994,
							30.262404676000074
						],
						[
							-81.71798363399995,
							30.262442931000066
						],
						[
							-81.71803729099992,
							30.262485394000063
						],
						[
							-81.71812850899994,
							30.26256470800007
						],
						[
							-81.71818441399995,
							30.262617756000054
						],
						[
							-81.71823557199991,
							30.262675395000088
						],
						[
							-81.71828160599995,
							30.26273720300009
						],
						[
							-81.7183221809999,
							30.262802725000086
						],
						[
							-81.7183569959999,
							30.26287148000006
						],
						[
							-81.71838579699994,
							30.26294296400005
						],
						[
							-81.71840837199994,
							30.263016651000047
						],
						[
							-81.71849237099991,
							30.26333965200007
						],
						[
							-81.7185076589999,
							30.263409834000075
						],
						[
							-81.71852131499992,
							30.26356263200006
						],
						[
							-81.71852231899993,
							30.26383131600005
						],
						[
							-81.71850865899995,
							30.263989165000055
						],
						[
							-81.71849969599992,
							30.264033460000068
						],
						[
							-81.71835777399991,
							30.264654142000044
						],
						[
							-81.71837108599993,
							30.26468741400004
						],
						[
							-81.71841258799992,
							30.264844302000085
						],
						[
							-81.71844951799994,
							30.265069770000082
						],
						[
							-81.71846132199994,
							30.26521500000007
						],
						[
							-81.7184590359999,
							30.26527907200006
						],
						[
							-81.71844703699992,
							30.265447072000086
						],
						[
							-81.71843565899991,
							30.26553916600005
						],
						[
							-81.71839500099992,
							30.26569082200007
						],
						[
							-81.71824751299994,
							30.26609534100004
						],
						[
							-81.71838138899994,
							30.266737440000046
						],
						[
							-81.71839339699994,
							30.266809614000067
						],
						[
							-81.7185633979999,
							30.26817161400004
						],
						[
							-81.71857032199995,
							30.268283000000057
						],
						[
							-81.71855999499991,
							30.268418898000053
						],
						[
							-81.71853599499991,
							30.268575898000048
						],
						[
							-81.71852075499994,
							30.26865291200005
						],
						[
							-81.71849885699993,
							30.26872830400003
						],
						[
							-81.71847046799991,
							30.268801498000073
						],
						[
							-81.71843580299992,
							30.26887193700009
						],
						[
							-81.71839512699995,
							30.26893908500006
						],
						[
							-81.7183487499999,
							30.269002430000057
						],
						[
							-81.71823974999997,
							30.26913843000005
						],
						[
							-81.71819079499994,
							30.269194578000054
						],
						[
							-81.71731039899993,
							30.270123673000057
						],
						[
							-81.71729221899994,
							30.270148914000064
						],
						[
							-81.7172576779999,
							30.270238277000093
						],
						[
							-81.7172278619999,
							30.270415187000083
						],
						[
							-81.71724881099993,
							30.27103670300005
						],
						[
							-81.71724812999992,
							30.271113276000047
						],
						[
							-81.71724093799992,
							30.27118951200004
						],
						[
							-81.71722728599991,
							30.271264861000073
						],
						[
							-81.71690228599994,
							30.27270586100008
						],
						[
							-81.71688358199992,
							30.272775612000093
						],
						[
							-81.7168593429999,
							30.27284363800004
						],
						[
							-81.71682972299993,
							30.272909499000036
						],
						[
							-81.71679491399993,
							30.27297277100007
						],
						[
							-81.7167551419999,
							30.273033046000076
						],
						[
							-81.71671066099992,
							30.273089936000076
						],
						[
							-81.71666576899992,
							30.273138716000062
						],
						[
							-81.71602499999995,
							30.272508000000077
						],
						[
							-81.71493490599994,
							30.271435008000083
						],
						[
							-81.70795390599994,
							30.266094009000085
						],
						[
							-81.70641290599991,
							30.26476300800005
						],
						[
							-81.70225490599996,
							30.261154008000066
						],
						[
							-81.7018259059999,
							30.260730008000056
						],
						[
							-81.70158290599994,
							30.26045800800006
						],
						[
							-81.70143490599992,
							30.260256008000056
						],
						[
							-81.70105890699995,
							30.259742008000046
						],
						[
							-81.7004289059999,
							30.258469008000077
						],
						[
							-81.70032381899995,
							30.258185035000057
						],
						[
							-81.69998990599993,
							30.256937008000083
						],
						[
							-81.69990490599992,
							30.256643008000083
						],
						[
							-81.69972190499993,
							30.25585600900007
						],
						[
							-81.6995319049999,
							30.255079008000052
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Ortega Forest",
				"RegionID": "125595"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.90486205799994,
					30.30442444300007,
					-81.85552173199994,
					30.338141027000063
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.85607090799994,
							30.31135101100006
						],
						[
							-81.85679098899993,
							30.309520018000057
						],
						[
							-81.85664685199993,
							30.308667013000047
						],
						[
							-81.86062890799991,
							30.308366010000046
						],
						[
							-81.86182290699992,
							30.308276010000046
						],
						[
							-81.8645319069999,
							30.30806301000007
						],
						[
							-81.86522090799991,
							30.308016010000074
						],
						[
							-81.8659969069999,
							30.307949010000076
						],
						[
							-81.86662890799994,
							30.307909010000056
						],
						[
							-81.8669569079999,
							30.30788701000006
						],
						[
							-81.86769190699994,
							30.30783001000009
						],
						[
							-81.86839090699993,
							30.307773010000062
						],
						[
							-81.8688939079999,
							30.30773301100004
						],
						[
							-81.86932390799991,
							30.307693011000087
						],
						[
							-81.86951890799992,
							30.30767801000007
						],
						[
							-81.8697939079999,
							30.30765401100007
						],
						[
							-81.87338390799994,
							30.30728101100004
						],
						[
							-81.87402290799992,
							30.307208010000064
						],
						[
							-81.87467990699992,
							30.307143011000047
						],
						[
							-81.87496790799992,
							30.30711101000008
						],
						[
							-81.87585790799994,
							30.307022010000082
						],
						[
							-81.87604490699994,
							30.307007011000053
						],
						[
							-81.87702090699992,
							30.306915011000058
						],
						[
							-81.87712890799992,
							30.306898010000054
						],
						[
							-81.87763299799991,
							30.306850171000065
						],
						[
							-81.87787206899992,
							30.306562083000077
						],
						[
							-81.87792691099992,
							30.306092965000065
						],
						[
							-81.8843499059999,
							30.30550400900006
						],
						[
							-81.88894690599994,
							30.305083008000057
						],
						[
							-81.8954778179999,
							30.30442444300007
						],
						[
							-81.89546068999994,
							30.305497096000067
						],
						[
							-81.88841690599992,
							30.306160008000067
						],
						[
							-81.88437790599994,
							30.30657800800009
						],
						[
							-81.88162990599994,
							30.306886009000042
						],
						[
							-81.88145090599996,
							30.306910010000085
						],
						[
							-81.88132990499993,
							30.306947010000044
						],
						[
							-81.88118090699993,
							30.30703300900007
						],
						[
							-81.88105290499993,
							30.30713800800004
						],
						[
							-81.88098092399991,
							30.307181058000083
						],
						[
							-81.88090990599994,
							30.307199009000044
						],
						[
							-81.88083890399992,
							30.30721200800008
						],
						[
							-81.8793709059999,
							30.307365007000044
						],
						[
							-81.87792590599992,
							30.307323008000086
						],
						[
							-81.8776517949999,
							30.30731484900008
						],
						[
							-81.8765327719999,
							30.310481113000037
						],
						[
							-81.87787390599993,
							30.310344008000072
						],
						[
							-81.8843689059999,
							30.309678008000052
						],
						[
							-81.88761190499991,
							30.309346008000038
						],
						[
							-81.8949299059999,
							30.308557008000033
						],
						[
							-81.89501890499992,
							30.308548008000063
						],
						[
							-81.89541254499994,
							30.308506326000042
						],
						[
							-81.89520682599994,
							30.32135702900007
						],
						[
							-81.89558390499991,
							30.322042008000043
						],
						[
							-81.89736190499993,
							30.325438009000038
						],
						[
							-81.89780390599992,
							30.32633000800007
						],
						[
							-81.89859090499993,
							30.32792000900008
						],
						[
							-81.89863790599992,
							30.328009008000034
						],
						[
							-81.89954390499992,
							30.32971700900004
						],
						[
							-81.90050490499993,
							30.331551009000062
						],
						[
							-81.90100090599992,
							30.332446008000094
						],
						[
							-81.90117590599993,
							30.332707008000057
						],
						[
							-81.90136690599991,
							30.33295000900006
						],
						[
							-81.90165690499992,
							30.333253008000046
						],
						[
							-81.90213790599995,
							30.33368400800003
						],
						[
							-81.9029039049999,
							30.334313008000038
						],
						[
							-81.90362790499995,
							30.33489500800005
						],
						[
							-81.90395390599991,
							30.335156009000062
						],
						[
							-81.90454890599995,
							30.33570400900004
						],
						[
							-81.90486205799994,
							30.33605706500003
						],
						[
							-81.88140831899995,
							30.338140867000046
						],
						[
							-81.86447059099993,
							30.338141027000063
						],
						[
							-81.86110692099993,
							30.33055693700004
						],
						[
							-81.86139190699993,
							30.330458011000076
						],
						[
							-81.86143407599991,
							30.330443072000033
						],
						[
							-81.86135890799994,
							30.33031201000006
						],
						[
							-81.86103390699992,
							30.329742011000064
						],
						[
							-81.85993482999993,
							30.328234046000038
						],
						[
							-81.85959390699992,
							30.326812010000083
						],
						[
							-81.85909590699993,
							30.325376010000074
						],
						[
							-81.85893290999991,
							30.32506801200009
						],
						[
							-81.8585159079999,
							30.323532011000058
						],
						[
							-81.85811190499993,
							30.322196011000074
						],
						[
							-81.8579469099999,
							30.321933011000056
						],
						[
							-81.85552173199994,
							30.313507008000045
						],
						[
							-81.85562190799993,
							30.313188010000093
						],
						[
							-81.85586490599991,
							30.312542010000076
						],
						[
							-81.85607090799994,
							30.31135101100006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Otis",
				"RegionID": "125604"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.10150350299995,
					26.706125000000043,
					-80.0756522829999,
					26.719442100000037
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.07791763799992,
							26.709403846000043
						],
						[
							-80.0756522829999,
							26.706161207000036
						],
						[
							-80.07760767299993,
							26.706222208000042
						],
						[
							-80.07778599999996,
							26.706125000000043
						],
						[
							-80.07970899999992,
							26.706188000000058
						],
						[
							-80.08067499999993,
							26.706220000000087
						],
						[
							-80.08149899999995,
							26.706247000000076
						],
						[
							-80.0823079999999,
							26.706274000000064
						],
						[
							-80.08438299999995,
							26.706342000000063
						],
						[
							-80.0864029999999,
							26.706408000000067
						],
						[
							-80.08650199999994,
							26.70640300000008
						],
						[
							-80.08775899999995,
							26.70643300000006
						],
						[
							-80.09026299999994,
							26.70649300000008
						],
						[
							-80.09276699999992,
							26.706552000000045
						],
						[
							-80.09365799999995,
							26.706574000000046
						],
						[
							-80.09533199999993,
							26.70661400000006
						],
						[
							-80.09789699999993,
							26.706675000000075
						],
						[
							-80.10039599999993,
							26.70673400000004
						],
						[
							-80.10150350299995,
							26.70675703900008
						],
						[
							-80.10128128699995,
							26.70696074500006
						],
						[
							-80.09595128399991,
							26.71184674300008
						],
						[
							-80.08955516799995,
							26.719442100000037
						],
						[
							-80.07791763799992,
							26.709403846000043
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "West Palm Beach",
				"Name": "Palm Beach Lakes",
				"RegionID": "125629"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.65305105699991,
					30.36410282500009,
					-81.6314255339999,
					30.39407648400004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.64548509199994,
							30.392735948000052
						],
						[
							-81.64545157099991,
							30.392663408000093
						],
						[
							-81.64531899999992,
							30.392669322000074
						],
						[
							-81.6451628339999,
							30.39265566000006
						],
						[
							-81.64501141299992,
							30.39261508700008
						],
						[
							-81.64486933899992,
							30.392548836000064
						],
						[
							-81.64474092699993,
							30.392458921000067
						],
						[
							-81.64468875699993,
							30.392411541000058
						],
						[
							-81.64351154199994,
							30.39125505700008
						],
						[
							-81.6420599459999,
							30.390674777000072
						],
						[
							-81.64087275799994,
							30.39022237200004
						],
						[
							-81.64080060699992,
							30.39019120200004
						],
						[
							-81.64073145399993,
							30.390153852000086
						],
						[
							-81.64066582599992,
							30.390110606000068
						],
						[
							-81.64060422399992,
							30.39006179600005
						],
						[
							-81.6405471189999,
							30.390007794000038
						],
						[
							-81.64049494699992,
							30.38994901200004
						],
						[
							-81.64044810699994,
							30.389885899000035
						],
						[
							-81.64028710699995,
							30.389647899000067
						],
						[
							-81.6402476049999,
							30.389583892000076
						],
						[
							-81.6402135909999,
							30.389516809000042
						],
						[
							-81.64018530099992,
							30.38944711700009
						],
						[
							-81.64016293299994,
							30.389375306000094
						],
						[
							-81.64014664399991,
							30.389301877000037
						],
						[
							-81.64013654799993,
							30.38922734300007
						],
						[
							-81.64011017899992,
							30.38894402500006
						],
						[
							-81.63972587399991,
							30.38821780300009
						],
						[
							-81.6381636349999,
							30.38682622200008
						],
						[
							-81.63805470199992,
							30.38684010500009
						],
						[
							-81.63790319099991,
							30.386846527000046
						],
						[
							-81.63754418999991,
							30.386831421000068
						],
						[
							-81.63710715399992,
							30.38685680800006
						],
						[
							-81.63705499999992,
							30.38685832200008
						],
						[
							-81.63690643199993,
							30.386845965000077
						],
						[
							-81.63590563299994,
							30.386678312000072
						],
						[
							-81.63575041399992,
							30.386637086000064
						],
						[
							-81.63560182099991,
							30.386566999000085
						],
						[
							-81.63505530299994,
							30.38623916300008
						],
						[
							-81.63493992699995,
							30.386156921000065
						],
						[
							-81.63482907999992,
							30.386046073000045
						],
						[
							-81.63473916499993,
							30.385917661000068
						],
						[
							-81.6346729139999,
							30.385775587000072
						],
						[
							-81.63463234099993,
							30.385624166000067
						],
						[
							-81.63462301899995,
							30.385556258000065
						],
						[
							-81.6345642089999,
							30.384959886000047
						],
						[
							-81.6345457349999,
							30.384875600000047
						],
						[
							-81.63433968899994,
							30.38439404500008
						],
						[
							-81.63408713399991,
							30.38450151600006
						],
						[
							-81.63404258599991,
							30.384519087000058
						],
						[
							-81.6338911659999,
							30.384559660000036
						],
						[
							-81.63373499999994,
							30.38457332200005
						],
						[
							-81.63357883399993,
							30.384559660000036
						],
						[
							-81.63342741399993,
							30.384519087000058
						],
						[
							-81.63338719099994,
							30.384503343000063
						],
						[
							-81.6333561909999,
							30.38449034200005
						],
						[
							-81.63328738099995,
							30.384458368000082
						],
						[
							-81.63322163699992,
							30.384420489000036
						],
						[
							-81.63315946399992,
							30.384376996000075
						],
						[
							-81.63310133999994,
							30.384328223000068
						],
						[
							-81.63304771299994,
							30.38427454500004
						],
						[
							-81.63299899399993,
							30.384216376000037
						],
						[
							-81.63236232499992,
							30.383574146000058
						],
						[
							-81.63231613899991,
							30.383523876000087
						],
						[
							-81.63227389899993,
							30.383470249000084
						],
						[
							-81.63223584899993,
							30.38341357200005
						],
						[
							-81.63220220799991,
							30.383354172000058
						],
						[
							-81.63217316899994,
							30.383292391000055
						],
						[
							-81.63214889999995,
							30.383228585000044
						],
						[
							-81.63204089999994,
							30.382908586000042
						],
						[
							-81.63201947599993,
							30.382834874000082
						],
						[
							-81.63200441899994,
							30.38275960200008
						],
						[
							-81.63199583699992,
							30.382683321000062
						],
						[
							-81.63199379399992,
							30.38260658600007
						],
						[
							-81.63199830399992,
							30.382529956000045
						],
						[
							-81.63200933399992,
							30.382453990000045
						],
						[
							-81.63202680499995,
							30.38237924200007
						],
						[
							-81.63205058799991,
							30.382306257000042
						],
						[
							-81.6320745299999,
							30.382243617000086
						],
						[
							-81.63210594499992,
							30.382098156000044
						],
						[
							-81.6321220939999,
							30.38203467600005
						],
						[
							-81.63214282199993,
							30.38197254000005
						],
						[
							-81.63216801699991,
							30.381912077000035
						],
						[
							-81.63219754599993,
							30.38185360900008
						],
						[
							-81.63223125299993,
							30.381797445000075
						],
						[
							-81.63246094999994,
							30.381444511000044
						],
						[
							-81.63241421799995,
							30.38140342900005
						],
						[
							-81.6323190789999,
							30.381306073000076
						],
						[
							-81.63225270899994,
							30.38121617600007
						],
						[
							-81.63188170899991,
							30.380642176000038
						],
						[
							-81.63185816399994,
							30.380603661000066
						],
						[
							-81.63178934699994,
							30.380454344000043
						],
						[
							-81.63152478099994,
							30.379687101000062
						],
						[
							-81.6314893409999,
							30.379550166000058
						],
						[
							-81.6314756779999,
							30.379394000000048
						],
						[
							-81.6314893409999,
							30.37923783400004
						],
						[
							-81.63152991399994,
							30.379086414000085
						],
						[
							-81.63157289399993,
							30.37898729800008
						],
						[
							-81.6317888939999,
							30.378561298000083
						],
						[
							-81.63181216499993,
							30.378518339000035
						],
						[
							-81.63190207999992,
							30.378389927000057
						],
						[
							-81.63201292699995,
							30.378279080000087
						],
						[
							-81.63214133899993,
							30.378189164000048
						],
						[
							-81.63228341399991,
							30.378122914000073
						],
						[
							-81.63238623499991,
							30.378092300000052
						],
						[
							-81.63249162999995,
							30.37806765500005
						],
						[
							-81.63256415099995,
							30.37797945300008
						],
						[
							-81.63266112899993,
							30.377881877000053
						],
						[
							-81.63261889899991,
							30.377818409000042
						],
						[
							-81.63258247599993,
							30.37775143900007
						],
						[
							-81.63255214599991,
							30.377681499000065
						],
						[
							-81.63252815099992,
							30.377609140000065
						],
						[
							-81.63251067999994,
							30.377534935000085
						],
						[
							-81.63249987099994,
							30.377459471000062
						],
						[
							-81.63249580899992,
							30.377383345000055
						],
						[
							-81.63249079399992,
							30.377089384000044
						],
						[
							-81.63248792999991,
							30.376897578000072
						],
						[
							-81.63246063699995,
							30.376170344000062
						],
						[
							-81.63235720599994,
							30.375736605000046
						],
						[
							-81.63233806199992,
							30.37562626100004
						],
						[
							-81.6322967989999,
							30.37525080300009
						],
						[
							-81.6322081749999,
							30.37440164000009
						],
						[
							-81.63213978099992,
							30.37397924100009
						],
						[
							-81.63207251199992,
							30.373889885000043
						],
						[
							-81.63203023799991,
							30.373828606000075
						],
						[
							-81.63199317599992,
							30.373764040000086
						],
						[
							-81.63196158199992,
							30.37369662900005
						],
						[
							-81.63193567099995,
							30.373626837000074
						],
						[
							-81.63150267199991,
							30.372293837000083
						],
						[
							-81.63147234099996,
							30.372172166000038
						],
						[
							-81.63146434599992,
							30.372080782000072
						],
						[
							-81.6314255339999,
							30.372050306000062
						],
						[
							-81.63218599999993,
							30.371504000000076
						],
						[
							-81.63571193099995,
							30.37149614200007
						],
						[
							-81.6360059079999,
							30.37138901100008
						],
						[
							-81.63639290899994,
							30.371309011000047
						],
						[
							-81.6365159309999,
							30.37130887800004
						],
						[
							-81.63713388499991,
							30.37153614200008
						],
						[
							-81.63721193099991,
							30.371535879000078
						],
						[
							-81.63724290699992,
							30.371549010000084
						],
						[
							-81.63730390699993,
							30.37157601000007
						],
						[
							-81.63776790799996,
							30.371736014000078
						],
						[
							-81.63806190799994,
							30.37196201000006
						],
						[
							-81.63817005899995,
							30.372028906000082
						],
						[
							-81.63820076199994,
							30.372189137000074
						],
						[
							-81.63843292699994,
							30.372256194000048
						],
						[
							-81.63875690799995,
							30.37208201000004
						],
						[
							-81.63956298599993,
							30.371745843000042
						],
						[
							-81.63962090699994,
							30.371948011000086
						],
						[
							-81.63966390799993,
							30.37213901000007
						],
						[
							-81.6397269069999,
							30.37232201000006
						],
						[
							-81.63979587699993,
							30.37256117200008
						],
						[
							-81.6399469079999,
							30.37237901000009
						],
						[
							-81.6401759069999,
							30.37215001100009
						],
						[
							-81.64027690799992,
							30.372063010000094
						],
						[
							-81.6418379079999,
							30.370640010000045
						],
						[
							-81.6419299069999,
							30.370539008000037
						],
						[
							-81.64202090499992,
							30.370384012000045
						],
						[
							-81.64206695999991,
							30.370224019000087
						],
						[
							-81.64207490699994,
							30.370094008000084
						],
						[
							-81.64205190599995,
							30.369919011000036
						],
						[
							-81.64199090699992,
							30.369772011000066
						],
						[
							-81.64130290799994,
							30.36854601100003
						],
						[
							-81.64096390999993,
							30.36795801200009
						],
						[
							-81.64090877599995,
							30.36777403200006
						],
						[
							-81.64092185499993,
							30.36760000100008
						],
						[
							-81.64096990799993,
							30.367474014000038
						],
						[
							-81.64106186599992,
							30.36733997500005
						],
						[
							-81.6411409079999,
							30.367262011000037
						],
						[
							-81.64132290799995,
							30.36713301000009
						],
						[
							-81.64171990799991,
							30.366888011000075
						],
						[
							-81.64255390699992,
							30.366437010000087
						],
						[
							-81.64268090799993,
							30.366351009000084
						],
						[
							-81.64281790699994,
							30.36622501000005
						],
						[
							-81.64301890699994,
							30.365976010000058
						],
						[
							-81.64371590999991,
							30.365062010000088
						],
						[
							-81.64382290799995,
							30.364975011000073
						],
						[
							-81.64387895199991,
							30.364940089000072
						],
						[
							-81.64401190699994,
							30.364856011000086
						],
						[
							-81.6446029089999,
							30.36454301100008
						],
						[
							-81.64487590699991,
							30.36443501100007
						],
						[
							-81.64522090699995,
							30.364358010000046
						],
						[
							-81.64563390599996,
							30.36430801100005
						],
						[
							-81.64604090599994,
							30.36425401000008
						],
						[
							-81.6462689089999,
							30.36423501100006
						],
						[
							-81.64648290699995,
							30.36425101100008
						],
						[
							-81.64665190599993,
							30.364278011000064
						],
						[
							-81.64687990899995,
							30.364331011000044
						],
						[
							-81.6474019069999,
							30.364474011000084
						],
						[
							-81.6477939099999,
							30.364551009000078
						],
						[
							-81.64795490699993,
							30.364551011000064
						],
						[
							-81.64832990899993,
							30.364524010000085
						],
						[
							-81.64845890599992,
							30.364509008000088
						],
						[
							-81.64863790599992,
							30.36450100900004
						],
						[
							-81.6490479069999,
							30.364520009000046
						],
						[
							-81.64928390599994,
							30.364543008000055
						],
						[
							-81.6494719069999,
							30.364551007000046
						],
						[
							-81.64959690599994,
							30.364535008000075
						],
						[
							-81.64973490699992,
							30.364493007000075
						],
						[
							-81.64985090599994,
							30.364424008000075
						],
						[
							-81.64997390699996,
							30.36431801000009
						],
						[
							-81.65005788899992,
							30.364272958000072
						],
						[
							-81.65028690899993,
							30.36421500900008
						],
						[
							-81.65046892999993,
							30.364207087000068
						],
						[
							-81.65062887099992,
							30.36410282500009
						],
						[
							-81.65094190399992,
							30.36415201000006
						],
						[
							-81.65290190999991,
							30.365073007000035
						],
						[
							-81.65305105699991,
							30.365097899000034
						],
						[
							-81.65300490699991,
							30.36541500900006
						],
						[
							-81.65299490699994,
							30.365469008000048
						],
						[
							-81.65294890599995,
							30.365627008000047
						],
						[
							-81.6528119059999,
							30.366167009000037
						],
						[
							-81.65277090599994,
							30.366302008000044
						],
						[
							-81.65253190699991,
							30.36721300900007
						],
						[
							-81.65247090699995,
							30.367452009000093
						],
						[
							-81.65240790599995,
							30.367728008000086
						],
						[
							-81.65234690699992,
							30.36795100900008
						],
						[
							-81.65229590699994,
							30.368138008000074
						],
						[
							-81.65220990599994,
							30.368453008000078
						],
						[
							-81.65211990699993,
							30.368769009000058
						],
						[
							-81.65194090699994,
							30.369430008000055
						],
						[
							-81.65181690599991,
							30.36991300800008
						],
						[
							-81.6517469069999,
							30.37016300900007
						],
						[
							-81.6516569069999,
							30.37046600900004
						],
						[
							-81.65146790599994,
							30.37117000800004
						],
						[
							-81.6514539069999,
							30.371205009000047
						],
						[
							-81.65144090599995,
							30.371290009000067
						],
						[
							-81.65141490699995,
							30.371638009000037
						],
						[
							-81.65140890599992,
							30.37181500900004
						],
						[
							-81.65140090699992,
							30.37188800800004
						],
						[
							-81.65138890599991,
							30.372356008000054
						],
						[
							-81.65137490699993,
							30.372637008000083
						],
						[
							-81.65135990699991,
							30.37280500800006
						],
						[
							-81.65135990699991,
							30.373089008000083
						],
						[
							-81.6513439069999,
							30.373358009000075
						],
						[
							-81.65132890699994,
							30.373579009000082
						],
						[
							-81.65132890699994,
							30.373659008000065
						],
						[
							-81.65132890599995,
							30.373861009000052
						],
						[
							-81.6512989069999,
							30.374456009000085
						],
						[
							-81.65128790699994,
							30.37488500900008
						],
						[
							-81.65126790599993,
							30.375450008000087
						],
						[
							-81.65123690599995,
							30.375952008000073
						],
						[
							-81.65122990599991,
							30.376251008000054
						],
						[
							-81.65121890699993,
							30.37639900900007
						],
						[
							-81.65120690599991,
							30.37656000900006
						],
						[
							-81.65120690499992,
							30.376602007000088
						],
						[
							-81.65117590499995,
							30.37675100900009
						],
						[
							-81.6510769059999,
							30.377100009000063
						],
						[
							-81.6508939069999,
							30.377787009000087
						],
						[
							-81.65087582699994,
							30.377847968000086
						],
						[
							-81.65081790499994,
							30.37807100800006
						],
						[
							-81.65072590499994,
							30.378450008000073
						],
						[
							-81.65061590499994,
							30.378895009000072
						],
						[
							-81.6505819059999,
							30.378996009000048
						],
						[
							-81.65051790599995,
							30.379199008000057
						],
						[
							-81.6503359049999,
							30.379902008000045
						],
						[
							-81.65019990499991,
							30.380439009000046
						],
						[
							-81.6501569049999,
							30.380586008000083
						],
						[
							-81.65005590599992,
							30.380939007000055
						],
						[
							-81.64993990599993,
							30.381435009000086
						],
						[
							-81.64979590599995,
							30.38190300900004
						],
						[
							-81.6496869049999,
							30.382385008000085
						],
						[
							-81.64940690599991,
							30.38340800900005
						],
						[
							-81.64936790599995,
							30.383551009000087
						],
						[
							-81.64933790499992,
							30.383669008000084
						],
						[
							-81.6490099049999,
							30.384890009000063
						],
						[
							-81.64887990599993,
							30.38539700900009
						],
						[
							-81.64862790599994,
							30.386385008000047
						],
						[
							-81.64849090599995,
							30.386892008000075
						],
						[
							-81.64809390499994,
							30.38839500800009
						],
						[
							-81.64801790599995,
							30.388649009000062
						],
						[
							-81.64799390499992,
							30.388743008000066
						],
						[
							-81.64794190599991,
							30.38895000900004
						],
						[
							-81.64789890499992,
							30.389106008000056
						],
						[
							-81.6477919049999,
							30.389516009000094
						],
						[
							-81.64775805399995,
							30.389638105000078
						],
						[
							-81.64765675799993,
							30.389728912000066
						],
						[
							-81.64752990599993,
							30.390178008000078
						],
						[
							-81.6473679049999,
							30.390764009000065
						],
						[
							-81.64727590599995,
							30.391113008000048
						],
						[
							-81.6472539049999,
							30.391245009000045
						],
						[
							-81.64721490599993,
							30.39151800800005
						],
						[
							-81.64720690599995,
							30.391728008000086
						],
						[
							-81.64720690599995,
							30.391958008000074
						],
						[
							-81.64722090599992,
							30.39216800800006
						],
						[
							-81.64723690599993,
							30.392288009000087
						],
						[
							-81.64725190599995,
							30.39238400900007
						],
						[
							-81.6473939999999,
							30.392955000000086
						],
						[
							-81.6476253109999,
							30.39388450300004
						],
						[
							-81.6475431909999,
							30.39393318500004
						],
						[
							-81.64748014999992,
							30.39396679300006
						],
						[
							-81.64741463899992,
							30.393995290000074
						],
						[
							-81.64734707199995,
							30.394018496000058
						],
						[
							-81.64727787699991,
							30.394036264000082
						],
						[
							-81.64720748899992,
							30.394048482000073
						],
						[
							-81.64704948899993,
							30.39406948200008
						],
						[
							-81.64697098899991,
							30.394076432000077
						],
						[
							-81.64689218299992,
							30.39407648400004
						],
						[
							-81.64681367399993,
							30.394069636000044
						],
						[
							-81.6467360659999,
							30.394055941000094
						],
						[
							-81.64665995599995,
							30.394035505000087
						],
						[
							-81.64658592599994,
							30.39400848400004
						],
						[
							-81.64651454599993,
							30.393975086000072
						],
						[
							-81.64633654599993,
							30.39388208600008
						],
						[
							-81.64627323699995,
							30.393845662000047
						],
						[
							-81.64621309299991,
							30.393804222000085
						],
						[
							-81.64615650899994,
							30.39375803700005
						],
						[
							-81.64610385999993,
							30.39370741300007
						],
						[
							-81.64594085999994,
							30.393537413000047
						],
						[
							-81.64589786499994,
							30.39348922100004
						],
						[
							-81.64585843999993,
							30.393438069000073
						],
						[
							-81.64582278799992,
							30.39338421900004
						],
						[
							-81.64579109199991,
							30.39332794800003
						],
						[
							-81.64548509199994,
							30.392735948000052
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Panama Park",
				"RegionID": "125663"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.6254729499999,
					30.483680013000082,
					-81.57833887899994,
					30.54701396900009
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.57930790899991,
							30.50487301200008
						],
						[
							-81.57833887899994,
							30.503838142000063
						],
						[
							-81.58093919899994,
							30.50399447500007
						],
						[
							-81.58223366499993,
							30.503217702000086
						],
						[
							-81.58439114999993,
							30.501491714000053
						],
						[
							-81.5857719089999,
							30.50036974600005
						],
						[
							-81.58767065399991,
							30.500111070000063
						],
						[
							-81.5879294799999,
							30.499247939000043
						],
						[
							-81.58844722499992,
							30.491998780000074
						],
						[
							-81.58905116099993,
							30.48777003300006
						],
						[
							-81.59067482099994,
							30.48605885700005
						],
						[
							-81.59071394499995,
							30.48605008500005
						],
						[
							-81.59089690799993,
							30.485901010000077
						],
						[
							-81.5920179069999,
							30.484987010000058
						],
						[
							-81.59252190799992,
							30.48456401100009
						],
						[
							-81.5926439079999,
							30.484484011000063
						],
						[
							-81.59275090799991,
							30.484430011000086
						],
						[
							-81.5929789079999,
							30.484333011000047
						],
						[
							-81.59319290799995,
							30.484266010000056
						],
						[
							-81.59347490799992,
							30.484207010000034
						],
						[
							-81.59369690699992,
							30.484186011000077
						],
						[
							-81.59530590799994,
							30.48415601100004
						],
						[
							-81.5966719079999,
							30.48411801100008
						],
						[
							-81.60040990699991,
							30.484030010000083
						],
						[
							-81.60075390799994,
							30.48401601100005
						],
						[
							-81.60162390699992,
							30.48395901100008
						],
						[
							-81.6023909079999,
							30.48388010000008
						],
						[
							-81.60313390899995,
							30.48378401200006
						],
						[
							-81.60327890999993,
							30.483755013000067
						],
						[
							-81.6034879099999,
							30.483733013000062
						],
						[
							-81.60414790899995,
							30.483680013000082
						],
						[
							-81.60459190899991,
							30.48370101200004
						],
						[
							-81.60477890999994,
							30.483725012000036
						],
						[
							-81.6049299099999,
							30.483756013000065
						],
						[
							-81.60730590899993,
							30.48434301200007
						],
						[
							-81.61057990899991,
							30.48516401200004
						],
						[
							-81.61225890899993,
							30.485587013000046
						],
						[
							-81.61344090999995,
							30.485884012000046
						],
						[
							-81.61804390999994,
							30.487032012000043
						],
						[
							-81.6205139089999,
							30.48764801200008
						],
						[
							-81.62097890899992,
							30.48776201200008
						],
						[
							-81.62171890999991,
							30.487949013000048
						],
						[
							-81.62245890999992,
							30.488131012000057
						],
						[
							-81.6230969099999,
							30.48829201200004
						],
						[
							-81.62318390899992,
							30.48831401300004
						],
						[
							-81.6239319099999,
							30.488501012000086
						],
						[
							-81.62467190899991,
							30.48868801300006
						],
						[
							-81.6254729499999,
							30.488891887000076
						],
						[
							-81.62493890899992,
							30.49048001300008
						],
						[
							-81.62482490899993,
							30.49085601300004
						],
						[
							-81.6244739089999,
							30.49188201200008
						],
						[
							-81.6243819099999,
							30.49217001200009
						],
						[
							-81.62406890999995,
							30.493080012000064
						],
						[
							-81.6237099089999,
							30.494171013000088
						],
						[
							-81.62347390899993,
							30.494867012000043
						],
						[
							-81.62331390999992,
							30.495409012000042
						],
						[
							-81.62324490999993,
							30.49571601200006
						],
						[
							-81.62323790999994,
							30.495779012000074
						],
						[
							-81.6231459089999,
							30.496296013000062
						],
						[
							-81.62309290999991,
							30.49680901200009
						],
						[
							-81.62306190899994,
							30.497211013000086
						],
						[
							-81.62303890999993,
							30.49796701200006
						],
						[
							-81.62300090999992,
							30.499598012000035
						],
						[
							-81.62298590899992,
							30.499899012000075
						],
						[
							-81.62294790899995,
							30.50185201300008
						],
						[
							-81.6229399099999,
							30.50202201200005
						],
						[
							-81.62293290899993,
							30.502186013000088
						],
						[
							-81.62291090999992,
							30.503447011000045
						],
						[
							-81.62288690999992,
							30.50481601200005
						],
						[
							-81.62286390999992,
							30.506802012000033
						],
						[
							-81.6228489099999,
							30.507446012000063
						],
						[
							-81.6228329089999,
							30.507877012000055
						],
						[
							-81.62282390999991,
							30.508280012000057
						],
						[
							-81.62279290999993,
							30.509695013000055
						],
						[
							-81.62274190999995,
							30.512014012000066
						],
						[
							-81.62268790999991,
							30.514482013000077
						],
						[
							-81.62264190899992,
							30.516656012000055
						],
						[
							-81.62260890999994,
							30.51777201300007
						],
						[
							-81.62255090999992,
							30.520327012000052
						],
						[
							-81.6225129099999,
							30.521627012000067
						],
						[
							-81.62246890999995,
							30.52365001300007
						],
						[
							-81.62246690899991,
							30.523722013000054
						],
						[
							-81.6223979099999,
							30.52668001300009
						],
						[
							-81.62237890999995,
							30.527156013000084
						],
						[
							-81.6223749099999,
							30.52726001300005
						],
						[
							-81.6223599089999,
							30.52812001200005
						],
						[
							-81.62234490899993,
							30.52835701300006
						],
						[
							-81.62232190899994,
							30.528521012000056
						],
						[
							-81.62221490999991,
							30.528925012000055
						],
						[
							-81.62171190999993,
							30.530670013000076
						],
						[
							-81.62161990899995,
							30.531038012000064
						],
						[
							-81.62152890999994,
							30.53135701200006
						],
						[
							-81.62148290999994,
							30.531551012000076
						],
						[
							-81.62145990999994,
							30.531721013000034
						],
						[
							-81.6214749099999,
							30.53349501200006
						],
						[
							-81.6214979099999,
							30.53458001200005
						],
						[
							-81.62155190999994,
							30.53822701200005
						],
						[
							-81.62162990999991,
							30.542162012000063
						],
						[
							-81.62162999999993,
							30.544580016000054
						],
						[
							-81.6213990039999,
							30.54701396900009
						],
						[
							-81.61270890899993,
							30.54129401200004
						],
						[
							-81.60773390899993,
							30.538023013000043
						],
						[
							-81.60325890999991,
							30.535073012000055
						],
						[
							-81.60247790999995,
							30.534555013000045
						],
						[
							-81.60232490999994,
							30.534468013000037
						],
						[
							-81.60214990999992,
							30.534382013000087
						],
						[
							-81.60181390899993,
							30.534235012000067
						],
						[
							-81.59755790999992,
							30.53254101300007
						],
						[
							-81.59722884099995,
							30.532398127000075
						],
						[
							-81.59706090899994,
							30.532236012000055
						],
						[
							-81.5967549099999,
							30.531880013000034
						],
						[
							-81.59570290999994,
							30.530653013000062
						],
						[
							-81.59532890999992,
							30.530205012000067
						],
						[
							-81.59513090899992,
							30.529903012000094
						],
						[
							-81.59505490899994,
							30.529762012000052
						],
						[
							-81.59433690999992,
							30.528179012000063
						],
						[
							-81.59399390999994,
							30.527464012000056
						],
						[
							-81.59373490899993,
							30.526995012000047
						],
						[
							-81.59316290899994,
							30.526033013000077
						],
						[
							-81.59299090999991,
							30.52574601200007
						],
						[
							-81.59283490999991,
							30.525501013000053
						],
						[
							-81.59195090999992,
							30.524014012000066
						],
						[
							-81.59134690899992,
							30.52300101300005
						],
						[
							-81.59084290999994,
							30.522150013000047
						],
						[
							-81.59003890999992,
							30.520893012000045
						],
						[
							-81.58991990899995,
							30.520677013000068
						],
						[
							-81.58982790899995,
							30.520541010000045
						],
						[
							-81.5897489109999,
							30.520359011000043
						],
						[
							-81.58969055699993,
							30.51989712300008
						],
						[
							-81.58958390999993,
							30.51905501200008
						],
						[
							-81.58955090899991,
							30.518692013000074
						],
						[
							-81.58943490799993,
							30.51806801500004
						],
						[
							-81.58927590899992,
							30.51772701200008
						],
						[
							-81.58917190999996,
							30.517553012000064
						],
						[
							-81.58899690999993,
							30.51724101200006
						],
						[
							-81.58818790899994,
							30.515629013000083
						],
						[
							-81.58712790899995,
							30.51349601200008
						],
						[
							-81.58682990799991,
							30.512947012000037
						],
						[
							-81.5865549099999,
							30.512621012000068
						],
						[
							-81.58617390899991,
							30.512213013000068
						],
						[
							-81.58377090999994,
							30.509554012000084
						],
						[
							-81.58306090999992,
							30.508751013000047
						],
						[
							-81.58297690899991,
							30.50867501200008
						],
						[
							-81.58210790999993,
							30.50782801300005
						],
						[
							-81.58132890899992,
							30.507017012000063
						],
						[
							-81.57958991099993,
							30.505148013000053
						],
						[
							-81.57930790899991,
							30.50487301200008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Pecan Park",
				"RegionID": "125695"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.31413099799994,
					26.111667613000066,
					-80.29787201699997,
					26.16085580300006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.29790759099996,
							26.16046392100003
						],
						[
							-80.29790759099996,
							26.160078302000045
						],
						[
							-80.29790759099996,
							26.158179302000065
						],
						[
							-80.29800759099999,
							26.157279302000063
						],
						[
							-80.29810759099996,
							26.151779302000023
						],
						[
							-80.29810759099996,
							26.15067930200007
						],
						[
							-80.29790759099996,
							26.149979302000077
						],
						[
							-80.29787669499996,
							26.149979434000045
						],
						[
							-80.29787201699997,
							26.14996306100005
						],
						[
							-80.29787770399997,
							26.14867778400003
						],
						[
							-80.29787823799995,
							26.148557476000068
						],
						[
							-80.29788415799999,
							26.147223736000058
						],
						[
							-80.29788939999997,
							26.146042641000065
						],
						[
							-80.29802958399995,
							26.11445746800007
						],
						[
							-80.29803208099997,
							26.113894806000076
						],
						[
							-80.29804196599997,
							26.111667613000066
						],
						[
							-80.29807759099998,
							26.111676302000035
						],
						[
							-80.30056559099995,
							26.11228230200004
						],
						[
							-80.30364759099996,
							26.113042302000053
						],
						[
							-80.30482555499998,
							26.113338447000046
						],
						[
							-80.31005959099997,
							26.114654302000076
						],
						[
							-80.31284159099994,
							26.115329302000077
						],
						[
							-80.31379404499995,
							26.11554813500004
						],
						[
							-80.31381689599993,
							26.11964564500005
						],
						[
							-80.313835,
							26.122892
						],
						[
							-80.313835,
							26.123964
						],
						[
							-80.313835,
							26.124864
						],
						[
							-80.31385366399998,
							26.125157589000025
						],
						[
							-80.313924,
							26.126264
						],
						[
							-80.314031,
							26.127164
						],
						[
							-80.313924,
							26.128064
						],
						[
							-80.313889,
							26.129447
						],
						[
							-80.314013,
							26.131264
						],
						[
							-80.31398133799996,
							26.134186631000038
						],
						[
							-80.313974,
							26.134864
						],
						[
							-80.313969,
							26.135343000000002
						],
						[
							-80.31397707499997,
							26.135380312000052
						],
						[
							-80.31397199799994,
							26.136802053000054
						],
						[
							-80.31396684499998,
							26.138245159000064
						],
						[
							-80.31396606699997,
							26.138463
						],
						[
							-80.313924,
							26.138463
						],
						[
							-80.313924,
							26.140221
						],
						[
							-80.313924,
							26.142363
						],
						[
							-80.31394,
							26.145763000000002
						],
						[
							-80.31394606299995,
							26.14637539100005
						],
						[
							-80.31396,
							26.147783
						],
						[
							-80.313968,
							26.147837
						],
						[
							-80.313968,
							26.147952
						],
						[
							-80.31398,
							26.149277
						],
						[
							-80.313981,
							26.149423
						],
						[
							-80.31398900000002,
							26.150318
						],
						[
							-80.314004,
							26.151861
						],
						[
							-80.314022,
							26.153263
						],
						[
							-80.313986,
							26.155063
						],
						[
							-80.314,
							26.156362
						],
						[
							-80.314011,
							26.157341
						],
						[
							-80.314022,
							26.158361
						],
						[
							-80.314129,
							26.15926
						],
						[
							-80.31413099799994,
							26.16085580300006
						],
						[
							-80.309286,
							26.16068
						],
						[
							-80.308591,
							26.160654
						],
						[
							-80.307398,
							26.16061
						],
						[
							-80.306072,
							26.160562
						],
						[
							-80.30552932599994,
							26.160562
						],
						[
							-80.305472,
							26.160562
						],
						[
							-80.301008,
							26.160495
						],
						[
							-80.29877951299994,
							26.160462111000072
						],
						[
							-80.298772,
							26.160462
						],
						[
							-80.29792932599997,
							26.160463873000026
						],
						[
							-80.29790759099996,
							26.16046392100003
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Plantation",
				"Name": "Plantation Acres",
				"RegionID": "125781"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.20068299999991,
					26.08536500000008,
					-80.18656692399992,
					26.09206111700007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.18707416299992,
							26.09206111700007
						],
						[
							-80.18699924899994,
							26.090638912000088
						],
						[
							-80.18690288099992,
							26.08945037700005
						],
						[
							-80.18688146599993,
							26.08863660500009
						],
						[
							-80.18676368299994,
							26.087972739000065
						],
						[
							-80.18656692399992,
							26.08733561400004
						],
						[
							-80.18946099999994,
							26.08661500000005
						],
						[
							-80.1894519999999,
							26.087065000000056
						],
						[
							-80.19155399999994,
							26.08634200000006
						],
						[
							-80.19206899999995,
							26.08616500000005
						],
						[
							-80.1925609999999,
							26.085919000000047
						],
						[
							-80.19306899999992,
							26.085665000000063
						],
						[
							-80.19356099999993,
							26.08551700000004
						],
						[
							-80.1940689999999,
							26.08536500000008
						],
						[
							-80.19456099999991,
							26.08561100000009
						],
						[
							-80.19506899999993,
							26.08586500000007
						],
						[
							-80.1955549999999,
							26.08610800000008
						],
						[
							-80.19606899999991,
							26.086365000000058
						],
						[
							-80.19655499999993,
							26.086511000000087
						],
						[
							-80.19706899999994,
							26.08666500000004
						],
						[
							-80.19755499999991,
							26.08676200000008
						],
						[
							-80.1978959999999,
							26.08683000000008
						],
						[
							-80.19806899999992,
							26.086865000000046
						],
						[
							-80.1985499999999,
							26.087057000000073
						],
						[
							-80.19906899999995,
							26.08726500000006
						],
						[
							-80.19956899999994,
							26.08740300000005
						],
						[
							-80.20068299999991,
							26.087710000000072
						],
						[
							-80.20068299999991,
							26.088622000000043
						],
						[
							-80.20061199999992,
							26.08907600000009
						],
						[
							-80.20046899999994,
							26.08959500000009
						],
						[
							-80.20043299999992,
							26.090276000000078
						],
						[
							-80.20050499999991,
							26.09124900000006
						],
						[
							-80.20050499999991,
							26.091379000000074
						],
						[
							-80.2005059999999,
							26.091503000000046
						],
						[
							-80.2005059999999,
							26.091652069000077
						],
						[
							-80.19967756999995,
							26.091667519000055
						],
						[
							-80.1993260399999,
							26.09169150100007
						],
						[
							-80.1992709669999,
							26.091711584000052
						],
						[
							-80.19921087699993,
							26.09173161700005
						],
						[
							-80.19913576699992,
							26.091786694000064
						],
						[
							-80.19899055699995,
							26.091917075000083
						],
						[
							-80.1988303139999,
							26.091792706000035
						],
						[
							-80.19867708599992,
							26.091738624000072
						],
						[
							-80.19856291699995,
							26.09171458900005
						],
						[
							-80.19766258199991,
							26.091735619000076
						],
						[
							-80.1966540869999,
							26.091765664000036
						],
						[
							-80.19618238699991,
							26.09177868400008
						],
						[
							-80.19617612499991,
							26.09177992800005
						],
						[
							-80.19605457799992,
							26.091782412000043
						],
						[
							-80.19581535499992,
							26.091787012000054
						],
						[
							-80.1955938449999,
							26.09179245000007
						],
						[
							-80.19526125699991,
							26.091804768000088
						],
						[
							-80.19501446399994,
							26.091814491000036
						],
						[
							-80.1948269259999,
							26.091822471000057
						],
						[
							-80.19474184599994,
							26.091826092000076
						],
						[
							-80.1945539319999,
							26.091832001000057
						],
						[
							-80.19441761699994,
							26.091834841000036
						],
						[
							-80.1941277439999,
							26.091841625000086
						],
						[
							-80.19387241899994,
							26.09185144500009
						],
						[
							-80.1937270809999,
							26.09185703500009
						],
						[
							-80.19351419799995,
							26.09186315800008
						],
						[
							-80.19324159699994,
							26.09186949800005
						],
						[
							-80.19296879699993,
							26.091875842000036
						],
						[
							-80.1927894069999,
							26.09188281300004
						],
						[
							-80.19278621899991,
							26.091882705000046
						],
						[
							-80.19276515299993,
							26.091883756000072
						],
						[
							-80.19263999999993,
							26.091890000000035
						],
						[
							-80.19256831299992,
							26.09189140600006
						],
						[
							-80.19247103499993,
							26.09189331300007
						],
						[
							-80.1922137329999,
							26.091898358000037
						],
						[
							-80.19210574599992,
							26.091902205000054
						],
						[
							-80.19201999999991,
							26.09191000000004
						],
						[
							-80.19191399099992,
							26.09191265000004
						],
						[
							-80.19174250999993,
							26.091916937000065
						],
						[
							-80.19161999999994,
							26.091920000000073
						],
						[
							-80.19149639799991,
							26.091923433000094
						],
						[
							-80.19137840899992,
							26.091926711000042
						],
						[
							-80.19125999999994,
							26.091930000000048
						],
						[
							-80.19102532399995,
							26.09193625800009
						],
						[
							-80.1908642539999,
							26.091940553000086
						],
						[
							-80.19069305599993,
							26.09194511900006
						],
						[
							-80.1905099999999,
							26.091950000000054
						],
						[
							-80.19035999999994,
							26.091960000000086
						],
						[
							-80.19012609799995,
							26.091965922000043
						],
						[
							-80.18985803999993,
							26.09197270800007
						],
						[
							-80.18972963199991,
							26.09197595900008
						],
						[
							-80.18963332599992,
							26.091978397000048
						],
						[
							-80.18956999999995,
							26.091980000000035
						],
						[
							-80.18947299599995,
							26.09198431100009
						],
						[
							-80.18934523399992,
							26.09198999000006
						],
						[
							-80.18921557199991,
							26.09199575200006
						],
						[
							-80.18906580099991,
							26.09200000000004
						],
						[
							-80.18887339299994,
							26.09200281300008
						],
						[
							-80.18871285999995,
							26.09200638100009
						],
						[
							-80.18854999999992,
							26.092010000000077
						],
						[
							-80.18843463099995,
							26.092014273000075
						],
						[
							-80.18819859599995,
							26.092023015000052
						],
						[
							-80.1880061899999,
							26.092030166000086
						],
						[
							-80.18780220199994,
							26.092039035000084
						],
						[
							-80.18765257899992,
							26.092045540000072
						],
						[
							-80.18754999999993,
							26.092050000000086
						],
						[
							-80.18740590599992,
							26.092053431000068
						],
						[
							-80.18713011499995,
							26.092059820000088
						],
						[
							-80.18707416299992,
							26.09206111700007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Lauderdale Isles",
				"RegionID": "12330"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.208866,
					25.927227,
					-80.188268,
					25.941199
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.20505,
							25.931492
						],
						[
							-80.20505750999996,
							25.931457133000038
						],
						[
							-80.205064,
							25.931427
						],
						[
							-80.20513496299998,
							25.931191220000073
						],
						[
							-80.205188,
							25.931015
						],
						[
							-80.205247,
							25.930826
						],
						[
							-80.204816,
							25.93119
						],
						[
							-80.204804,
							25.930916
						],
						[
							-80.204788,
							25.930565
						],
						[
							-80.20478134399997,
							25.930574183000033
						],
						[
							-80.204709,
							25.930674
						],
						[
							-80.204241,
							25.931274
						],
						[
							-80.20362000499995,
							25.93161822600007
						],
						[
							-80.203615,
							25.931621
						],
						[
							-80.203312,
							25.93191
						],
						[
							-80.202996,
							25.932261000000004
						],
						[
							-80.202587,
							25.932582
						],
						[
							-80.202531,
							25.932529
						],
						[
							-80.2024,
							25.932367
						],
						[
							-80.202329,
							25.932294
						],
						[
							-80.20189301699997,
							25.932317620000052
						],
						[
							-80.201886,
							25.932318
						],
						[
							-80.20188503899999,
							25.932175272000052
						],
						[
							-80.201884,
							25.932021
						],
						[
							-80.20210588499998,
							25.932009063000066
						],
						[
							-80.202087,
							25.931689
						],
						[
							-80.201325,
							25.931713
						],
						[
							-80.200519,
							25.931746
						],
						[
							-80.200549,
							25.932102
						],
						[
							-80.20056151799997,
							25.932586265000054
						],
						[
							-80.200568,
							25.932837
						],
						[
							-80.200594,
							25.933548
						],
						[
							-80.20061361999996,
							25.933547533000024
						],
						[
							-80.20135100000002,
							25.93353
						],
						[
							-80.20130645999996,
							25.93356709800003
						],
						[
							-80.199693,
							25.934911
						],
						[
							-80.199435,
							25.934659
						],
						[
							-80.199256,
							25.934812
						],
						[
							-80.199507,
							25.935065
						],
						[
							-80.198666,
							25.935766
						],
						[
							-80.19770956499997,
							25.936505969000052
						],
						[
							-80.19761,
							25.936583
						],
						[
							-80.19749433799997,
							25.93664455000004
						],
						[
							-80.196708,
							25.937063
						],
						[
							-80.19651420099996,
							25.937177794000036
						],
						[
							-80.196421,
							25.937233
						],
						[
							-80.19625315099995,
							25.93729713100004
						],
						[
							-80.19606671499999,
							25.937368364000065
						],
						[
							-80.195997,
							25.937395000000002
						],
						[
							-80.19593637399998,
							25.937413152000033
						],
						[
							-80.195486,
							25.937548
						],
						[
							-80.194492,
							25.937909
						],
						[
							-80.19448200699998,
							25.937912907000054
						],
						[
							-80.19339755299995,
							25.938336847000073
						],
						[
							-80.193346,
							25.938357
						],
						[
							-80.19325544199995,
							25.938406144000055
						],
						[
							-80.19265554399999,
							25.938731693000022
						],
						[
							-80.192561,
							25.938783
						],
						[
							-80.19187,
							25.939177
						],
						[
							-80.189637,
							25.941036
						],
						[
							-80.188785,
							25.941199
						],
						[
							-80.188764,
							25.940529
						],
						[
							-80.188732,
							25.939667
						],
						[
							-80.188714,
							25.938454
						],
						[
							-80.188655,
							25.937738
						],
						[
							-80.188612,
							25.936664
						],
						[
							-80.188585,
							25.935937
						],
						[
							-80.188538,
							25.935035000000003
						],
						[
							-80.188504,
							25.934177
						],
						[
							-80.188491,
							25.933511
						],
						[
							-80.188481,
							25.933178
						],
						[
							-80.188268,
							25.928587
						],
						[
							-80.190278,
							25.928504
						],
						[
							-80.190793,
							25.928485
						],
						[
							-80.191308,
							25.928451
						],
						[
							-80.19229400000002,
							25.928432
						],
						[
							-80.193251,
							25.928386
						],
						[
							-80.194305,
							25.928326
						],
						[
							-80.196331,
							25.92825
						],
						[
							-80.19835,
							25.928173
						],
						[
							-80.20035,
							25.928102000000003
						],
						[
							-80.202359,
							25.928016000000003
						],
						[
							-80.202931,
							25.927981
						],
						[
							-80.203188,
							25.928004
						],
						[
							-80.20360300000002,
							25.927983
						],
						[
							-80.204109,
							25.927936
						],
						[
							-80.204358,
							25.927892
						],
						[
							-80.204655,
							25.927829
						],
						[
							-80.204847,
							25.927727
						],
						[
							-80.205656,
							25.92733
						],
						[
							-80.205959,
							25.927245
						],
						[
							-80.206123,
							25.927227
						],
						[
							-80.206281,
							25.927234
						],
						[
							-80.206391,
							25.927252
						],
						[
							-80.206501,
							25.92727
						],
						[
							-80.20655300000001,
							25.927288
						],
						[
							-80.206743,
							25.927347
						],
						[
							-80.207031,
							25.927445
						],
						[
							-80.207486,
							25.927568
						],
						[
							-80.207672,
							25.927577
						],
						[
							-80.208071,
							25.927472000000005
						],
						[
							-80.208419,
							25.927678
						],
						[
							-80.208614,
							25.927793
						],
						[
							-80.208666,
							25.927897
						],
						[
							-80.20886,
							25.928243
						],
						[
							-80.208866,
							25.928295
						],
						[
							-80.208789,
							25.928506
						],
						[
							-80.20845,
							25.92946
						],
						[
							-80.208507,
							25.930525
						],
						[
							-80.20854700000001,
							25.931183
						],
						[
							-80.208579,
							25.931414
						],
						[
							-80.206552,
							25.931503000000003
						],
						[
							-80.206182,
							25.931528
						],
						[
							-80.206056,
							25.931438000000004
						],
						[
							-80.205042,
							25.931529
						],
						[
							-80.20505,
							25.931492
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "North Miami Beach",
				"Name": "Uleta",
				"RegionID": "43299"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.04354311099996,
					26.781365,
					-80.030177,
					26.814939
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.03035919299998,
							26.79714774300004
						],
						[
							-80.03032002399993,
							26.793808225000078
						],
						[
							-80.030177,
							26.781614
						],
						[
							-80.030177,
							26.781365
						],
						[
							-80.032206,
							26.781674
						],
						[
							-80.033801,
							26.78177
						],
						[
							-80.035105,
							26.7817
						],
						[
							-80.03706300000002,
							26.781642
						],
						[
							-80.038977,
							26.781708
						],
						[
							-80.040323,
							26.782075
						],
						[
							-80.04035585799994,
							26.788041545000056
						],
						[
							-80.04354311099996,
							26.788041545000056
						],
						[
							-80.04354311099996,
							26.793098014000066
						],
						[
							-80.03534731699995,
							26.79276251400006
						],
						[
							-80.03520353199997,
							26.795853910000062
						],
						[
							-80.04272832399994,
							26.79606958900007
						],
						[
							-80.04277625299996,
							26.797531411000023
						],
						[
							-80.04274679799994,
							26.80364010200003
						],
						[
							-80.03784900000001,
							26.803641000000002
						],
						[
							-80.037762,
							26.806339
						],
						[
							-80.038962,
							26.808939
						],
						[
							-80.038962,
							26.814539
						],
						[
							-80.040762,
							26.814939
						],
						[
							-80.038962,
							26.814839
						],
						[
							-80.038262,
							26.814839
						],
						[
							-80.037421,
							26.814754
						],
						[
							-80.037262,
							26.814739
						],
						[
							-80.035562,
							26.814739
						],
						[
							-80.030562,
							26.814439
						],
						[
							-80.03035919299998,
							26.79714774300004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Riviera Beach",
				"Name": "Singer Island",
				"RegionID": "56772"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.7722288999999,
					30.189321000000064,
					-81.7334899999999,
					30.20410901000008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.75510703399993,
							30.20408024500006
						],
						[
							-81.75448390999992,
							30.203525011000067
						],
						[
							-81.75430190899993,
							30.20337101100006
						],
						[
							-81.75360690999992,
							30.202806012000053
						],
						[
							-81.7527749109999,
							30.202218012000063
						],
						[
							-81.75209590899993,
							30.201793012000056
						],
						[
							-81.7512279099999,
							30.201332011000094
						],
						[
							-81.75044390999994,
							30.200973011000084
						],
						[
							-81.74937190899993,
							30.200537011000055
						],
						[
							-81.74653190999993,
							30.199501011000052
						],
						[
							-81.7440689089999,
							30.198550011000066
						],
						[
							-81.7404649099999,
							30.197190012000082
						],
						[
							-81.7398999099999,
							30.196977012000048
						],
						[
							-81.73954796699991,
							30.19684397500004
						],
						[
							-81.73931690799992,
							30.196759011000037
						],
						[
							-81.73884290799992,
							30.19658501100008
						],
						[
							-81.73834590799993,
							30.196403010000036
						],
						[
							-81.73503090699995,
							30.195187011000087
						],
						[
							-81.73410794199992,
							30.194816927000094
						],
						[
							-81.7334899999999,
							30.193466000000058
						],
						[
							-81.73436499999991,
							30.19282400000009
						],
						[
							-81.7342129999999,
							30.192563000000064
						],
						[
							-81.7383079999999,
							30.189745000000073
						],
						[
							-81.73892399999994,
							30.189321000000064
						],
						[
							-81.73912499799991,
							30.18932400600005
						],
						[
							-81.73939199999995,
							30.189328000000046
						],
						[
							-81.7400189999999,
							30.189339000000075
						],
						[
							-81.76381496599993,
							30.189339000000075
						],
						[
							-81.76446890799991,
							30.18990301000008
						],
						[
							-81.7686638639999,
							30.19255018000007
						],
						[
							-81.77100595099995,
							30.192358840000054
						],
						[
							-81.77113706999995,
							30.19243591700007
						],
						[
							-81.77113707399991,
							30.192569064000054
						],
						[
							-81.76838472799994,
							30.196406966000037
						],
						[
							-81.76883483199992,
							30.199588044000052
						],
						[
							-81.77206090699991,
							30.203691011000043
						],
						[
							-81.77210590899995,
							30.203747012000065
						],
						[
							-81.7722288999999,
							30.203915024000086
						],
						[
							-81.7714069079999,
							30.203988009000057
						],
						[
							-81.7704159079999,
							30.203959011000055
						],
						[
							-81.76986690699994,
							30.20397401000008
						],
						[
							-81.76633490699993,
							30.204075011000043
						],
						[
							-81.76469390799991,
							30.20410901000008
						],
						[
							-81.75510703399993,
							30.20408024500006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Argyle Forest",
				"RegionID": "123468"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.80581670999993,
					26.092808900000115,
					-81.78627370799967,
					26.11990994300008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.79746114999993,
							26.119807842000075
						],
						[
							-81.7970399809999,
							26.11978231600009
						],
						[
							-81.79637631899988,
							26.11979507900017
						],
						[
							-81.79563608199992,
							26.11979507900017
						],
						[
							-81.79512557299995,
							26.11979507900017
						],
						[
							-81.79439809799989,
							26.11979507900017
						],
						[
							-81.79350470799996,
							26.11979507900017
						],
						[
							-81.7926496059999,
							26.11974402800012
						],
						[
							-81.79184534399988,
							26.119648302000197
						],
						[
							-81.79178530999971,
							26.1195559170001
						],
						[
							-81.79171230999962,
							26.119426918000173
						],
						[
							-81.79164991399988,
							26.119291586000166
						],
						[
							-81.7916189539998,
							26.119187282000063
						],
						[
							-81.79157695399988,
							26.119006282000008
						],
						[
							-81.79155618799976,
							26.118870144000113
						],
						[
							-81.79154801399989,
							26.11876096900005
						],
						[
							-81.79152359999983,
							26.11866449300006
						],
						[
							-81.79141897599969,
							26.118514513000086
						],
						[
							-81.79123521299994,
							26.118316114000102
						],
						[
							-81.79119472399971,
							26.118269263000222
						],
						[
							-81.79115755399982,
							26.118219737000032
						],
						[
							-81.79112388099969,
							26.118167770000085
						],
						[
							-81.79109386399988,
							26.118113610000048
						],
						[
							-81.79099017299983,
							26.117910309000187
						],
						[
							-81.79093468799985,
							26.117826649000015
						],
						[
							-81.79041786699972,
							26.117285961000043
						],
						[
							-81.79028361699972,
							26.117188424000055
						],
						[
							-81.79025273799975,
							26.117171387000155
						],
						[
							-81.79005002899976,
							26.117099912000192
						],
						[
							-81.78970028399995,
							26.11704141400015
						],
						[
							-81.7888732519999,
							26.11599697500015
						],
						[
							-81.78869745199984,
							26.115810121000145
						],
						[
							-81.78855756399972,
							26.115692616000103
						],
						[
							-81.7884908459997,
							26.11563054300003
						],
						[
							-81.78838984599979,
							26.11552654300013
						],
						[
							-81.7883224249998,
							26.115448650000523
						],
						[
							-81.78815842499965,
							26.11523565000013
						],
						[
							-81.78808508199971,
							26.115124164000143
						],
						[
							-81.78799608199972,
							26.114964164000405
						],
						[
							-81.78793721599983,
							26.114835416000055
						],
						[
							-81.78789106499984,
							26.114709001000165
						],
						[
							-81.78786964599973,
							26.114644190000046
						],
						[
							-81.78785347899974,
							26.114577874000243
						],
						[
							-81.78784266899982,
							26.114510476000525
						],
						[
							-81.78783728399972,
							26.114442430000047
						],
						[
							-81.78783735899972,
							26.114374171000172
						],
						[
							-81.78780243899968,
							26.11423635000005
						],
						[
							-81.78774325699985,
							26.11405375200004
						],
						[
							-81.78755716099964,
							26.113628651000127
						],
						[
							-81.78753811299975,
							26.113581564000405
						],
						[
							-81.78751683199985,
							26.113524359000024
						],
						[
							-81.78740537699979,
							26.11347227900051
						],
						[
							-81.7873734159998,
							26.11345372200031
						],
						[
							-81.78731247499991,
							26.11341498400048
						],
						[
							-81.78725483899976,
							26.113371482000076
						],
						[
							-81.78720087799982,
							26.113323497000458
						],
						[
							-81.78715094199968,
							26.11327133600014
						],
						[
							-81.78710535099991,
							26.11321533800048
						],
						[
							-81.78706439999972,
							26.113155862
						],
						[
							-81.78702835299985,
							26.11309329200015
						],
						[
							-81.7870063519998,
							26.11305129200005
						],
						[
							-81.78697233499983,
							26.11297863900017
						],
						[
							-81.78694492799978,
							26.112903243000147
						],
						[
							-81.78692434799977,
							26.112825705000482
						],
						[
							-81.78691075999973,
							26.11274664200007
						],
						[
							-81.7869042719997,
							26.112666682000025
						],
						[
							-81.78690227199989,
							26.112611682000093
						],
						[
							-81.78690229799972,
							26.112545604000132
						],
						[
							-81.78690717599986,
							26.11247970600001
						],
						[
							-81.78691687999968,
							26.112414343000196
						],
						[
							-81.78693135599973,
							26.11234987000028
						],
						[
							-81.78695052799982,
							26.112286634000377
						],
						[
							-81.78696422099978,
							26.11224702400012
						],
						[
							-81.78699416199969,
							26.112172996000215
						],
						[
							-81.78703055399977,
							26.112101916000192
						],
						[
							-81.78707310999982,
							26.112034347000197
						],
						[
							-81.78712149499984,
							26.111970821000448
						],
						[
							-81.78717532599967,
							26.111911840000452
						],
						[
							-81.78723417899982,
							26.111857868000072
						],
						[
							-81.78727143099971,
							26.11182665600051
						],
						[
							-81.78739933899963,
							26.111737164000214
						],
						[
							-81.78754781999976,
							26.111668636000047
						],
						[
							-81.78760322599963,
							26.11164935900014
						],
						[
							-81.78768331899977,
							26.11162480400015
						],
						[
							-81.7877180919998,
							26.11157838900013
						],
						[
							-81.7877467749996,
							26.11151302900005
						],
						[
							-81.78775517399986,
							26.11148247100001
						],
						[
							-81.7877942319999,
							26.11103440800015
						],
						[
							-81.78773794199985,
							26.11039535000021
						],
						[
							-81.78770337899992,
							26.110232587000155
						],
						[
							-81.78766056899984,
							26.11009728100015
						],
						[
							-81.78763511799978,
							26.109997170000128
						],
						[
							-81.78759572899972,
							26.109793668000346
						],
						[
							-81.78758067799981,
							26.109630000000124
						],
						[
							-81.78758067799981,
							26.109550000000077
						],
						[
							-81.7875869119997,
							26.1094442930003
						],
						[
							-81.78766035599983,
							26.108823785000475
						],
						[
							-81.78766339299972,
							26.108727893
						],
						[
							-81.78765597499982,
							26.108681900000192
						],
						[
							-81.78763044599984,
							26.108594104000034
						],
						[
							-81.7876042139998,
							26.108473617000104
						],
						[
							-81.78758821399981,
							26.10836461700014
						],
						[
							-81.78757867799983,
							26.10823400000026
						],
						[
							-81.7875933469997,
							26.10807232500047
						],
						[
							-81.78760135399983,
							26.108029816000062
						],
						[
							-81.78763991399983,
							26.10788941400017
						],
						[
							-81.78770760099982,
							26.107745287000057
						],
						[
							-81.78768883799988,
							26.107708924000512
						],
						[
							-81.78759841099985,
							26.10759305100043
						],
						[
							-81.78704223499993,
							26.107172068000146
						],
						[
							-81.7869806089999,
							26.10712095200018
						],
						[
							-81.78686160899973,
							26.10701295200013
						],
						[
							-81.78682187799981,
							26.10697460500006
						],
						[
							-81.78666987799977,
							26.10681860500012
						],
						[
							-81.78662507899979,
							26.106769073000287
						],
						[
							-81.78654960599977,
							26.106664796000096
						],
						[
							-81.78647460699986,
							26.106543796000032
						],
						[
							-81.78643704499977,
							26.1064769990001
						],
						[
							-81.78640530599972,
							26.10640724600028
						],
						[
							-81.78637962099972,
							26.10633504400017
						],
						[
							-81.78631362099986,
							26.106121044000048
						],
						[
							-81.78628733999982,
							26.1060121660001
						],
						[
							-81.78627370799967,
							26.10585081200025
						],
						[
							-81.78627673799983,
							26.105585623000245
						],
						[
							-81.78628176999972,
							26.105500435000124
						],
						[
							-81.78629576999981,
							26.10536943500012
						],
						[
							-81.78630095999988,
							26.105332734000015
						],
						[
							-81.78652531539983,
							26.104682135000274
						],
						[
							-81.78664689299973,
							26.104426656000008
						],
						[
							-81.7866766479998,
							26.104369486000074
						],
						[
							-81.78671041999984,
							26.104314594000154
						],
						[
							-81.78674803699992,
							26.104262262000084
						],
						[
							-81.78678930599987,
							26.104212758000074
						],
						[
							-81.78691030499985,
							26.104077759000184
						],
						[
							-81.78700192699988,
							26.103989079000307
						],
						[
							-81.78707937299963,
							26.1039309040002
						],
						[
							-81.78717637299984,
							26.103865904000152
						],
						[
							-81.78723460499987,
							26.103830014000202
						],
						[
							-81.78729539699974,
							26.10379865400045
						],
						[
							-81.7873583969998,
							26.103772006000376
						],
						[
							-81.78742323999984,
							26.103750222000173
						],
						[
							-81.78750581999974,
							26.10372858600016
						],
						[
							-81.78732972599983,
							26.103606979000133
						],
						[
							-81.78727131399988,
							26.103561173000074
						],
						[
							-81.78721687899973,
							26.10351070500016
						],
						[
							-81.78716679099976,
							26.103455921000425
						],
						[
							-81.78712139199982,
							26.103397192000095
						],
						[
							-81.78704339199984,
							26.103287192000053
						],
						[
							-81.78700705099986,
							26.10323171400008
						],
						[
							-81.78697489699987,
							26.103173708000433
						],
						[
							-81.78694710599979,
							26.10311349100016
						],
						[
							-81.78692382699973,
							26.10305138900017
						],
						[
							-81.78687582799975,
							26.10290738900016
						],
						[
							-81.78684540599981,
							26.102790457000076
						],
						[
							-81.78679840599983,
							26.102542456000428
						],
						[
							-81.7867828779997,
							26.102393996000046
						],
						[
							-81.7867798779998,
							26.10225199700011
						],
						[
							-81.78678397999988,
							26.10214514200006
						],
						[
							-81.78679997999978,
							26.101982142000075
						],
						[
							-81.78680934099985,
							26.101913834000463
						],
						[
							-81.78683647299987,
							26.101812710000267
						],
						[
							-81.78686543299987,
							26.1017120750002
						],
						[
							-81.78687991399983,
							26.10166241400009
						],
						[
							-81.78693381899984,
							26.101544670000116
						],
						[
							-81.78694598099979,
							26.101520241000138
						],
						[
							-81.78697907799994,
							26.101466477000308
						],
						[
							-81.78699310899968,
							26.101443355000352
						],
						[
							-81.78703160899977,
							26.101388980000202
						],
						[
							-81.78708213199977,
							26.1013083280001
						],
						[
							-81.78718118399979,
							26.10119272900004
						],
						[
							-81.78728592699984,
							26.10108908000008
						],
						[
							-81.78736217999993,
							26.10103170500004
						],
						[
							-81.78747817999985,
							26.10095370500016
						],
						[
							-81.78753033899982,
							26.10092116400022
						],
						[
							-81.78764014899984,
							26.10086736500012
						],
						[
							-81.78773814899986,
							26.100827365000008
						],
						[
							-81.78779278299987,
							26.10080980900033
						],
						[
							-81.78779602099968,
							26.10075538300009
						],
						[
							-81.78780497299971,
							26.100680934000415
						],
						[
							-81.78780892499968,
							26.1006514850002
						],
						[
							-81.78782141299983,
							26.10058099900005
						],
						[
							-81.78783946599972,
							26.10051173000027
						],
						[
							-81.78786297199972,
							26.100444116000183
						],
						[
							-81.7878917809997,
							26.10037858600009
						],
						[
							-81.78795278099977,
							26.10025358700014
						],
						[
							-81.78798462399993,
							26.10019410600028
						],
						[
							-81.78802083699973,
							26.100137179000278
						],
						[
							-81.78806121499969,
							26.10008312700007
						],
						[
							-81.7881055319998,
							26.100032255000478
						],
						[
							-81.78822953299994,
							26.099900255000037
						],
						[
							-81.78830692699977,
							26.09982708000029
						],
						[
							-81.78837587999988,
							26.099774666000215
						],
						[
							-81.7884588789999,
							26.09971766500003
						],
						[
							-81.78851262499983,
							26.0996834910004
						],
						[
							-81.78871247299995,
							26.099566141000107
						],
						[
							-81.78939045399989,
							26.099378201000007
						],
						[
							-81.78978738999979,
							26.099080498000156
						],
						[
							-81.79030340799993,
							26.09860417400018
						],
						[
							-81.79087896599987,
							26.098564481000004
						],
						[
							-81.79149421799987,
							26.0984057060001
						],
						[
							-81.79193084799994,
							26.098187391000067
						],
						[
							-81.79242701899996,
							26.097988923000166
						],
						[
							-81.79314942599979,
							26.097944153000192
						],
						[
							-81.79359384599978,
							26.098182356000272
						],
						[
							-81.79361828299976,
							26.098195946000153
						],
						[
							-81.79389496699991,
							26.0983555110003
						],
						[
							-81.79416547099991,
							26.09844827400007
						],
						[
							-81.79439525799965,
							26.098489989000058
						],
						[
							-81.79472146599983,
							26.09852782200008
						],
						[
							-81.79487486899981,
							26.098534161000163
						],
						[
							-81.79499429199984,
							26.09852440100024
						],
						[
							-81.7951753999998,
							26.09849588800028
						],
						[
							-81.79540671099994,
							26.098385866000058
						],
						[
							-81.79547192499983,
							26.098357946000412
						],
						[
							-81.79553913699971,
							26.098335252000133
						],
						[
							-81.79560792899971,
							26.098317927000032
						],
						[
							-81.79567787199981,
							26.098306077000295
						],
						[
							-81.79574853099972,
							26.09829977800004
						],
						[
							-81.79584953099983,
							26.098294778000163
						],
						[
							-81.79596946599979,
							26.09829685000033
						],
						[
							-81.79625446599974,
							26.098320850000007
						],
						[
							-81.79636903799972,
							26.098339672000147
						],
						[
							-81.79635843399973,
							26.098280851000162
						],
						[
							-81.79635230699975,
							26.098221397000216
						],
						[
							-81.7963506919998,
							26.098161650000517
						],
						[
							-81.79635359699978,
							26.09810195200037
						],
						[
							-81.79633164099982,
							26.098023630000107
						],
						[
							-81.79631498799986,
							26.097951239000068
						],
						[
							-81.79630436699988,
							26.097877720000117
						],
						[
							-81.79629984899985,
							26.097803575000107
						],
						[
							-81.79630146599982,
							26.097729311000357
						],
						[
							-81.79630746599977,
							26.097634311000316
						],
						[
							-81.79631500399987,
							26.097559855000014
						],
						[
							-81.79632893299969,
							26.097486327000148
						],
						[
							-81.79634915099976,
							26.097414273000048
						],
						[
							-81.79637550599972,
							26.09734423100047
						],
						[
							-81.79640780299972,
							26.097276722000124
						],
						[
							-81.79644579999976,
							26.09721225000012
						],
						[
							-81.7964892139998,
							26.097151294000227
						],
						[
							-81.7970711769999,
							26.09701642800008
						],
						[
							-81.79754750099988,
							26.096837806000046
						],
						[
							-81.7980436719999,
							26.096500410000196
						],
						[
							-81.79832152699989,
							26.095944699000135
						],
						[
							-81.79840091499989,
							26.09530960000008
						],
						[
							-81.79834137399985,
							26.094654655000156
						],
						[
							-81.79835339699986,
							26.094462286000137
						],
						[
							-81.79838106799993,
							26.0940195560001
						],
						[
							-81.79848030199987,
							26.093721854000158
						],
						[
							-81.79879785099986,
							26.093245530000004
						],
						[
							-81.79945279699987,
							26.093166143000097
						],
						[
							-81.80028636399992,
							26.09292798100011
						],
						[
							-81.80098100299993,
							26.092808900000115
						],
						[
							-81.80154315999981,
							26.092923405000086
						],
						[
							-81.80165391999992,
							26.093033927000526
						],
						[
							-81.80172228299989,
							26.093126920000138
						],
						[
							-81.80186128299975,
							26.09334392000033
						],
						[
							-81.80187929099974,
							26.093373254000092
						],
						[
							-81.80231429099967,
							26.094113254000035
						],
						[
							-81.80233737699972,
							26.094155026000116
						],
						[
							-81.80238888099971,
							26.094254355000256
						],
						[
							-81.80256021199976,
							26.094486931000134
						],
						[
							-81.80261441899982,
							26.094562341000156
						],
						[
							-81.80266283499974,
							26.094637339000144
						],
						[
							-81.80270501199993,
							26.09471996000014
						],
						[
							-81.80281901199986,
							26.09497496000028
						],
						[
							-81.80286833599968,
							26.095115517000096
						],
						[
							-81.8029383359997,
							26.09538451700015
						],
						[
							-81.80295463799972,
							26.09546049100004
						],
						[
							-81.80300963799975,
							26.095784490000113
						],
						[
							-81.80301776599978,
							26.09584458700038
						],
						[
							-81.80304676599961,
							26.096131587000144
						],
						[
							-81.80305097099978,
							26.096247148000202
						],
						[
							-81.8030405269999,
							26.09662047800054
						],
						[
							-81.80314620399984,
							26.097721042000117
						],
						[
							-81.80314919899973,
							26.097762088000138
						],
						[
							-81.80316514099991,
							26.09808090100014
						],
						[
							-81.80320108399977,
							26.098449787000106
						],
						[
							-81.80320378399982,
							26.09848441400004
						],
						[
							-81.80325878299993,
							26.099423414000107
						],
						[
							-81.80326005799985,
							26.099454186000166
						],
						[
							-81.8032731539998,
							26.099993970000064
						],
						[
							-81.80329188099982,
							26.100168323000013
						],
						[
							-81.80333498099992,
							26.100346013000152
						],
						[
							-81.80335381999971,
							26.10045005200032
						],
						[
							-81.80344981999983,
							26.101244052000112
						],
						[
							-81.80345326299994,
							26.101277881000158
						],
						[
							-81.80352956499969,
							26.102200738000043
						],
						[
							-81.80361157199971,
							26.103308101000096
						],
						[
							-81.80402172399981,
							26.106925174000146
						],
						[
							-81.80429976499981,
							26.108766945000035
						],
						[
							-81.80439925599978,
							26.10934035800014
						],
						[
							-81.80461122399991,
							26.110690400000287
						],
						[
							-81.80469755399977,
							26.11114533300036
						],
						[
							-81.80470900299983,
							26.11122496600029
						],
						[
							-81.80483953799988,
							26.112552065000045
						],
						[
							-81.80492888699982,
							26.113228434000142
						],
						[
							-81.80500611299964,
							26.113706900000118
						],
						[
							-81.80513671399979,
							26.114079571000133
						],
						[
							-81.80515503099979,
							26.114138175000008
						],
						[
							-81.80520103099978,
							26.11430517400006
						],
						[
							-81.8052196599998,
							26.114387834000148
						],
						[
							-81.80522988899986,
							26.114465495000267
						],
						[
							-81.80526063999991,
							26.114816420000082
						],
						[
							-81.8054053389998,
							26.115658740000143
						],
						[
							-81.80541313099974,
							26.11571451600014
						],
						[
							-81.80557413099983,
							26.117206515000046
						],
						[
							-81.80557838099993,
							26.117261878000093
						],
						[
							-81.80558732199994,
							26.11745719600009
						],
						[
							-81.80568500099967,
							26.11785201800007
						],
						[
							-81.80569765899983,
							26.117911834000047
						],
						[
							-81.80571024599965,
							26.118024022000093
						],
						[
							-81.80575027899975,
							26.118841701000513
						],
						[
							-81.80576120699976,
							26.11907202800012
						],
						[
							-81.80581670999993,
							26.11944928400007
						],
						[
							-81.80490869299983,
							26.11945598500018
						],
						[
							-81.8032809949999,
							26.11946799800002
						],
						[
							-81.80162354699989,
							26.1194990360001
						],
						[
							-81.80014612199996,
							26.11950524400008
						],
						[
							-81.79977366199995,
							26.119542490000143
						],
						[
							-81.79972028463804,
							26.11967092812126
						],
						[
							-81.79955423599984,
							26.11987165500011
						],
						[
							-81.79922240499991,
							26.11978231600009
						],
						[
							-81.79880123499987,
							26.11979507900017
						],
						[
							-81.79849492999993,
							26.11982060400006
						],
						[
							-81.79818862499991,
							26.11990994300008
						],
						[
							-81.79794613299991,
							26.11989718100009
						],
						[
							-81.79746114999993,
							26.119807842000075
						]
					],
					[
						[
							-81.79562633899991,
							26.115303835000354
						],
						[
							-81.79560860499986,
							26.11528728400014
						],
						[
							-81.79559092099973,
							26.115331464000064
						],
						[
							-81.79556372399979,
							26.115393630000057
						],
						[
							-81.79557880899971,
							26.11541801600012
						],
						[
							-81.79567980899981,
							26.11561101600028
						],
						[
							-81.7957280859998,
							26.115720413000183
						],
						[
							-81.79575691999979,
							26.115815765000256
						],
						[
							-81.79576211499986,
							26.115837157000072
						],
						[
							-81.79592286199976,
							26.116278389000165
						],
						[
							-81.79593178399986,
							26.11617131900001
						],
						[
							-81.79594656099994,
							26.116067545000128
						],
						[
							-81.79597956199983,
							26.115904546000053
						],
						[
							-81.79601682199971,
							26.115772931000087
						],
						[
							-81.79611599399992,
							26.115502931000485
						],
						[
							-81.7959934129999,
							26.11547008600052
						],
						[
							-81.79593574899984,
							26.11544681000037
						],
						[
							-81.79571074999978,
							26.11534681000009
						],
						[
							-81.79562633899991,
							26.115303835000354
						]
					],
					[
						[
							-81.79111382899985,
							26.108232393000037
						],
						[
							-81.79107283699965,
							26.108109417000165
						],
						[
							-81.79103532599991,
							26.1081644570001
						],
						[
							-81.79101132899973,
							26.10819457100046
						],
						[
							-81.79102971899981,
							26.108258934000013
						],
						[
							-81.79105065899977,
							26.108349834000073
						],
						[
							-81.79106007199992,
							26.108418672000084
						],
						[
							-81.79106748199973,
							26.10849327000022
						],
						[
							-81.79111341399981,
							26.108472913000043
						],
						[
							-81.79120936099984,
							26.108447205000225
						],
						[
							-81.79115711399969,
							26.10833897900033
						],
						[
							-81.79111382899985,
							26.108232393000037
						]
					],
					[
						[
							-81.79446945499967,
							26.103371190000075
						],
						[
							-81.79442855099965,
							26.103306283000123
						],
						[
							-81.79444030099965,
							26.10343421800014
						],
						[
							-81.79445747199973,
							26.10339582200016
						],
						[
							-81.79446945499967,
							26.103371190000075
						]
					],
					[
						[
							-81.79787430199983,
							26.10060185000009
						],
						[
							-81.79784987699985,
							26.10053701200041
						],
						[
							-81.79774224599974,
							26.10079141200014
						],
						[
							-81.79770557899973,
							26.10086782900016
						],
						[
							-81.79761802599977,
							26.10103020000036
						],
						[
							-81.79763630999967,
							26.101045284000186
						],
						[
							-81.79774468799985,
							26.101151256000428
						],
						[
							-81.7979253779997,
							26.101360520000156
						],
						[
							-81.79797083499965,
							26.101348340000037
						],
						[
							-81.79808618099977,
							26.10133560400005
						],
						[
							-81.79813018099969,
							26.10133360500015
						],
						[
							-81.79814243099972,
							26.101333569000147
						],
						[
							-81.7981390399998,
							26.10130638800012
						],
						[
							-81.79811993699991,
							26.101268523000094
						],
						[
							-81.79801621099976,
							26.10109763100052
						],
						[
							-81.79797809299963,
							26.101028092000007
						],
						[
							-81.79794624899984,
							26.100955465000304
						],
						[
							-81.79792092699978,
							26.100880316000215
						],
						[
							-81.79790232299966,
							26.10080322800041
						],
						[
							-81.79788483199991,
							26.10071319700051
						],
						[
							-81.79787430199983,
							26.10060185000009
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Collier",
				"City": "Naples",
				"Name": "Port Royal",
				"RegionID": "125840"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.17103210199997,
					26.16631834800006,
					-80.15774643399999,
					26.177311714000044
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.15930047699999,
							26.17202600400003
						],
						[
							-80.16186289299998,
							26.16631834800006
						],
						[
							-80.17018501899997,
							26.172662504000073
						],
						[
							-80.17103210199997,
							26.173308256000045
						],
						[
							-80.17102738099999,
							26.174389533000067
						],
						[
							-80.17102194299997,
							26.175634943000034
						],
						[
							-80.17102033199996,
							26.176003958000024
						],
						[
							-80.17101595999998,
							26.17700499700004
						],
						[
							-80.17100134999998,
							26.177005108000063
						],
						[
							-80.16418836699995,
							26.177056918000062
						],
						[
							-80.16252475499994,
							26.177069569000025
						],
						[
							-80.16215346599995,
							26.177311714000044
						],
						[
							-80.15911858699997,
							26.176181706000023
						],
						[
							-80.15774643399999,
							26.175487558000043
						],
						[
							-80.15829604399994,
							26.17426333000003
						],
						[
							-80.15930047699999,
							26.17202600400003
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Oakland Park",
				"Name": "Royal Palm Isles",
				"RegionID": "125990"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.52611794299992,
					30.287334956000056,
					-81.48334279799991,
					30.32472801000006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.51993990799991,
							30.324727010000064
						],
						[
							-81.5192969069999,
							30.324718010000083
						],
						[
							-81.51877890699991,
							30.32472301100006
						],
						[
							-81.51784190699993,
							30.32470901000005
						],
						[
							-81.51657290799994,
							30.32468901000004
						],
						[
							-81.51614490899993,
							30.32468901000004
						],
						[
							-81.51535490899994,
							30.324694010000087
						],
						[
							-81.51454190899995,
							30.32468901000004
						],
						[
							-81.51366790599991,
							30.324677010000077
						],
						[
							-81.51336290599994,
							30.324672010000086
						],
						[
							-81.51205890699993,
							30.32462801100007
						],
						[
							-81.51149590699993,
							30.32460701100007
						],
						[
							-81.51094890699996,
							30.32457701000004
						],
						[
							-81.51025490599994,
							30.324523010000064
						],
						[
							-81.5090639089999,
							30.324401011000077
						],
						[
							-81.5079969059999,
							30.324255010000062
						],
						[
							-81.50753990599992,
							30.324192010000047
						],
						[
							-81.50739790699993,
							30.324168010000054
						],
						[
							-81.5071559079999,
							30.324129011000082
						],
						[
							-81.50600990799991,
							30.323924011000084
						],
						[
							-81.50567490599991,
							30.323855010000045
						],
						[
							-81.50534090599992,
							30.323787011000036
						],
						[
							-81.50443290699991,
							30.323597011000057
						],
						[
							-81.5037549079999,
							30.32343701100007
						],
						[
							-81.50324390599991,
							30.323300011000075
						],
						[
							-81.50259190799994,
							30.323118010000087
						],
						[
							-81.5023129089999,
							30.323039010000063
						],
						[
							-81.5010329079999,
							30.322677011000053
						],
						[
							-81.50015590699991,
							30.32242101100007
						],
						[
							-81.49981090699993,
							30.32231801000006
						],
						[
							-81.49924590799992,
							30.32215401000008
						],
						[
							-81.49692090699995,
							30.32148701100004
						],
						[
							-81.4951989089999,
							30.320980011000074
						],
						[
							-81.49319590899995,
							30.320407010000054
						],
						[
							-81.4926789079999,
							30.32025801000009
						],
						[
							-81.49245190799991,
							30.320200010000065
						],
						[
							-81.4913459089999,
							30.319915010000045
						],
						[
							-81.49043790799993,
							30.319709011000043
						],
						[
							-81.48933090799994,
							30.319480011000053
						],
						[
							-81.48911790899992,
							30.31944001100004
						],
						[
							-81.48844890599992,
							30.31932001000007
						],
						[
							-81.48799890799995,
							30.319257010000058
						],
						[
							-81.4870549069999,
							30.319123010000055
						],
						[
							-81.48674488099994,
							30.319079098000092
						],
						[
							-81.48671190899995,
							30.318860010000037
						],
						[
							-81.48639890899994,
							30.31678001000006
						],
						[
							-81.48564505999992,
							30.312197927000053
						],
						[
							-81.48415372499994,
							30.31082506100006
						],
						[
							-81.48436990599993,
							30.310118010000053
						],
						[
							-81.48443890899995,
							30.309925010000082
						],
						[
							-81.48449890599994,
							30.309735010000058
						],
						[
							-81.48453290799995,
							30.30952601000007
						],
						[
							-81.48452990599992,
							30.30927801000007
						],
						[
							-81.48449590799993,
							30.30906901000009
						],
						[
							-81.48421490599992,
							30.308087011000055
						],
						[
							-81.48413990699993,
							30.307821010000055
						],
						[
							-81.48405790499993,
							30.30762001100004
						],
						[
							-81.48396690599992,
							30.307473010000084
						],
						[
							-81.48382490799992,
							30.307310011000084
						],
						[
							-81.48365790899993,
							30.307168011000044
						],
						[
							-81.48344690899995,
							30.307033011000048
						],
						[
							-81.48334279799991,
							30.30698098100004
						],
						[
							-81.48568903199993,
							30.307012156000045
						],
						[
							-81.48577990599995,
							30.306380010000055
						],
						[
							-81.48577990699994,
							30.306123010000082
						],
						[
							-81.48613190799996,
							30.302105009000062
						],
						[
							-81.48589590599994,
							30.294457010000084
						],
						[
							-81.48451390699995,
							30.287600011000052
						],
						[
							-81.4844719159999,
							30.28743192400009
						],
						[
							-81.48487790699994,
							30.28743501000008
						],
						[
							-81.4880869079999,
							30.28739801000006
						],
						[
							-81.48866891499995,
							30.287392066000052
						],
						[
							-81.48924090799994,
							30.287386010000034
						],
						[
							-81.49198490799995,
							30.287359010000046
						],
						[
							-81.49452090799991,
							30.287335010000046
						],
						[
							-81.49483795499992,
							30.287334956000056
						],
						[
							-81.49850864399991,
							30.29579956600008
						],
						[
							-81.50890218199993,
							30.295458729000075
						],
						[
							-81.5119750579999,
							30.295357889000062
						],
						[
							-81.52590896099991,
							30.294874011000047
						],
						[
							-81.52597990499993,
							30.29762000900007
						],
						[
							-81.5259849059999,
							30.297979009000077
						],
						[
							-81.52601890599993,
							30.301090008000077
						],
						[
							-81.52601990499994,
							30.301165008000055
						],
						[
							-81.52602190499994,
							30.301239008000042
						],
						[
							-81.5260589049999,
							30.302985009000054
						],
						[
							-81.5260759059999,
							30.304384008000053
						],
						[
							-81.52609490599991,
							30.305245008000043
						],
						[
							-81.52611590599992,
							30.306697009000064
						],
						[
							-81.52611794299992,
							30.306834021000043
						],
						[
							-81.52609490599991,
							30.30714700800007
						],
						[
							-81.52607190599991,
							30.307415009000064
						],
						[
							-81.5260119049999,
							30.307854008000046
						],
						[
							-81.52595090499995,
							30.30822000900008
						],
						[
							-81.5258299059999,
							30.308776008000056
						],
						[
							-81.52577590599992,
							30.309009008000093
						],
						[
							-81.52562190599991,
							30.309807007000074
						],
						[
							-81.5254469059999,
							30.310719008000035
						],
						[
							-81.52541790499993,
							30.310922008000034
						],
						[
							-81.5254029059999,
							30.31102300900005
						],
						[
							-81.52537290599992,
							30.311326008000034
						],
						[
							-81.52536590599993,
							30.31188300800005
						],
						[
							-81.52536590599993,
							30.31218700800008
						],
						[
							-81.52536590499994,
							30.312865009000063
						],
						[
							-81.52532890499994,
							30.313313009000073
						],
						[
							-81.52526190499992,
							30.313907008000058
						],
						[
							-81.52523090599993,
							30.31418000900004
						],
						[
							-81.52515490499991,
							30.314640008000087
						],
						[
							-81.5251079059999,
							30.314966009000045
						],
						[
							-81.52495490599995,
							30.315775008000056
						],
						[
							-81.52484790499994,
							30.31633700800006
						],
						[
							-81.52479290499991,
							30.316580008000074
						],
						[
							-81.52477990599994,
							30.316653008000063
						],
						[
							-81.5247729049999,
							30.316723008000054
						],
						[
							-81.52469290499994,
							30.317062009000043
						],
						[
							-81.52459790499995,
							30.317372009000053
						],
						[
							-81.52450290599995,
							30.317632008000093
						],
						[
							-81.52442890599991,
							30.31782500800006
						],
						[
							-81.52406190599993,
							30.318764008000077
						],
						[
							-81.52385790599993,
							30.319261009000062
						],
						[
							-81.52363790599992,
							30.319900009000037
						],
						[
							-81.52345490599993,
							30.32057100900005
						],
						[
							-81.52336690599992,
							30.320926008000075
						],
						[
							-81.5232869049999,
							30.321352008000073
						],
						[
							-81.5232639059999,
							30.321550008000088
						],
						[
							-81.5232429049999,
							30.321739009000055
						],
						[
							-81.52321390599991,
							30.322131008000042
						],
						[
							-81.52319890599995,
							30.32243500900006
						],
						[
							-81.52319190599991,
							30.322501008000074
						],
						[
							-81.52319790599996,
							30.323485008000034
						],
						[
							-81.52319290499992,
							30.323720008000066
						],
						[
							-81.52318398599994,
							30.324075030000078
						],
						[
							-81.52310282699995,
							30.32421698700006
						],
						[
							-81.5231049059999,
							30.324362008000037
						],
						[
							-81.52311190599994,
							30.324453008000035
						],
						[
							-81.52311790099992,
							30.324526012000035
						],
						[
							-81.52200490799993,
							30.324641010000054
						],
						[
							-81.52144590699993,
							30.324684011000045
						],
						[
							-81.5213689069999,
							30.324688011000035
						],
						[
							-81.52078590699995,
							30.324718010000083
						],
						[
							-81.52003590599992,
							30.32472801000006
						],
						[
							-81.51993990799991,
							30.324727010000064
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Sandalwood",
				"RegionID": "126056"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.22928684699997,
					25.92684954400005,
					-80.21213632699994,
					25.94188167200008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.21577183199997,
							25.934799140000052
						],
						[
							-80.21574865999997,
							25.93477673600006
						],
						[
							-80.21429072799998,
							25.933367134000036
						],
						[
							-80.21344947699998,
							25.932391283000072
						],
						[
							-80.21299904399996,
							25.931426827000053
						],
						[
							-80.21227344799996,
							25.930092454000032
						],
						[
							-80.21223822599995,
							25.92960541000008
						],
						[
							-80.21222267899998,
							25.929390426000055
						],
						[
							-80.21213632699994,
							25.928638453000076
						],
						[
							-80.21274660599994,
							25.92812402900006
						],
						[
							-80.21372136799994,
							25.927599156000042
						],
						[
							-80.21484182699999,
							25.92751139900003
						],
						[
							-80.21517636599998,
							25.927495109000063
						],
						[
							-80.22817856999995,
							25.926861985000073
						],
						[
							-80.22844319499995,
							25.92684954400005
						],
						[
							-80.228465837,
							25.92749911900006
						],
						[
							-80.228663,
							25.930468164000047
						],
						[
							-80.22874418499998,
							25.93264855600006
						],
						[
							-80.22895294599994,
							25.934968122000043
						],
						[
							-80.22912691299996,
							25.93827350400005
						],
						[
							-80.22928684699997,
							25.941538018000074
						],
						[
							-80.22564820499997,
							25.941743425000027
						],
						[
							-80.22435038299994,
							25.941816689000063
						],
						[
							-80.22405701599996,
							25.94183325000006
						],
						[
							-80.22366325999997,
							25.941855478000036
						],
						[
							-80.22346306299994,
							25.941861204000077
						],
						[
							-80.22346835499997,
							25.941866481000034
						],
						[
							-80.22287066199993,
							25.94188167200008
						],
						[
							-80.21650347599996,
							25.935529104000068
						],
						[
							-80.21577183199997,
							25.934799140000052
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Gardens",
				"Name": "Scott Lake",
				"RegionID": "126097"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.2306999999999,
					25.750680000000045,
					-80.21417999999994,
					25.765854044000037
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.2143299999999,
							25.76296000000008
						],
						[
							-80.21432005299994,
							25.762654954000087
						],
						[
							-80.21430842399991,
							25.762298331000068
						],
						[
							-80.21429999999992,
							25.76204000000007
						],
						[
							-80.21429999999992,
							25.76198000000005
						],
						[
							-80.21429288399992,
							25.76178253800009
						],
						[
							-80.21427542499994,
							25.761298052000086
						],
						[
							-80.21425999999991,
							25.760870000000068
						],
						[
							-80.21425685699995,
							25.760621667000066
						],
						[
							-80.21425399799995,
							25.760395859000084
						],
						[
							-80.21424999999994,
							25.760080000000073
						],
						[
							-80.2142436339999,
							25.75958981900004
						],
						[
							-80.2142399999999,
							25.759310000000085
						],
						[
							-80.21422999999993,
							25.759040000000084
						],
						[
							-80.21423251199991,
							25.758911887000068
						],
						[
							-80.2142399999999,
							25.758530000000064
						],
						[
							-80.21422999999993,
							25.75777000000005
						],
						[
							-80.21422999999993,
							25.757492367000054
						],
						[
							-80.21422999999993,
							25.75720000000007
						],
						[
							-80.21422999999993,
							25.756990000000087
						],
						[
							-80.21422427499994,
							25.756491966000056
						],
						[
							-80.2142199999999,
							25.756120000000067
						],
						[
							-80.2142199999999,
							25.755911455000046
						],
						[
							-80.2142199999999,
							25.75541000000004
						],
						[
							-80.21421609899994,
							25.755136959000083
						],
						[
							-80.21420999999992,
							25.754710000000046
						],
						[
							-80.21419999999995,
							25.75434000000007
						],
						[
							-80.21419999999995,
							25.753990000000044
						],
						[
							-80.21419484699993,
							25.753685976000043
						],
						[
							-80.21418999999993,
							25.75340000000006
						],
						[
							-80.21418999999993,
							25.753270000000043
						],
						[
							-80.21418470299994,
							25.753137567000067
						],
						[
							-80.21417999999994,
							25.75302000000005
						],
						[
							-80.21418385099992,
							25.75284668900008
						],
						[
							-80.21418999999993,
							25.75257000000005
						],
						[
							-80.21418999999993,
							25.75216888800009
						],
						[
							-80.21418999999993,
							25.75186000000008
						],
						[
							-80.21417999999994,
							25.751690000000057
						],
						[
							-80.21417999999994,
							25.75139000000007
						],
						[
							-80.2142199999999,
							25.751230000000078
						],
						[
							-80.21429999999992,
							25.751100000000065
						],
						[
							-80.21517195899992,
							25.751103731000057
						],
						[
							-80.21578513999992,
							25.75110747000008
						],
						[
							-80.2161999999999,
							25.75111000000004
						],
						[
							-80.21646230999994,
							25.75109950800004
						],
						[
							-80.21669999999995,
							25.75109000000009
						],
						[
							-80.21694564299992,
							25.75108133000009
						],
						[
							-80.21730009999993,
							25.751068820000057
						],
						[
							-80.21781567399995,
							25.751050623000086
						],
						[
							-80.21839999999992,
							25.75103000000007
						],
						[
							-80.21862458599992,
							25.75102420400009
						],
						[
							-80.2191404589999,
							25.751010891000078
						],
						[
							-80.21962492099993,
							25.750998389000074
						],
						[
							-80.21994999999993,
							25.75099000000006
						],
						[
							-80.22020563899991,
							25.750989437000044
						],
						[
							-80.22062460299992,
							25.750984264000067
						],
						[
							-80.22096999999991,
							25.750980000000084
						],
						[
							-80.22123836899993,
							25.750971949000075
						],
						[
							-80.22149624499991,
							25.75096421300009
						],
						[
							-80.22196999999996,
							25.750950000000046
						],
						[
							-80.22236645399995,
							25.750935583000057
						],
						[
							-80.22278649799995,
							25.750920309000037
						],
						[
							-80.22330212999992,
							25.75090296600007
						],
						[
							-80.22400999999991,
							25.750880000000052
						],
						[
							-80.22433335399995,
							25.750868850000074
						],
						[
							-80.22488340399991,
							25.750849883000058
						],
						[
							-80.2254956829999,
							25.750828770000055
						],
						[
							-80.2260399999999,
							25.750810000000058
						],
						[
							-80.22665667799993,
							25.750785935000067
						],
						[
							-80.2270135519999,
							25.75077200800007
						],
						[
							-80.22759341199992,
							25.75074937900007
						],
						[
							-80.22808999999995,
							25.75073000000009
						],
						[
							-80.2284323579999,
							25.750720646000048
						],
						[
							-80.22910938699994,
							25.750702148000073
						],
						[
							-80.22969057799992,
							25.750686268000038
						],
						[
							-80.23018999999994,
							25.750680000000045
						],
						[
							-80.2301947549999,
							25.75084642700006
						],
						[
							-80.23019999999991,
							25.75103000000007
						],
						[
							-80.23019999999991,
							25.751168719000077
						],
						[
							-80.23019999999991,
							25.751420000000053
						],
						[
							-80.23021566499995,
							25.751686309000036
						],
						[
							-80.23023999999992,
							25.75210000000004
						],
						[
							-80.23024653699991,
							25.75242684500006
						],
						[
							-80.23025999999993,
							25.75284000000005
						],
						[
							-80.2302749189999,
							25.75313789400008
						],
						[
							-80.23027987499995,
							25.753266757000063
						],
						[
							-80.23028999999991,
							25.75353000000007
						],
						[
							-80.23029938699995,
							25.753717744000085
						],
						[
							-80.23030666499994,
							25.75394328300007
						],
						[
							-80.23031999999995,
							25.75437000000005
						],
						[
							-80.23033283099994,
							25.75459070000005
						],
						[
							-80.23034778699991,
							25.75484793800007
						],
						[
							-80.23036999999994,
							25.75523000000004
						],
						[
							-80.23037504799993,
							25.75549251600006
						],
						[
							-80.23037999999991,
							25.755750000000035
						],
						[
							-80.2303910999999,
							25.755944246000073
						],
						[
							-80.23039999999992,
							25.756240000000048
						],
						[
							-80.23041096999992,
							25.756459403000065
						],
						[
							-80.23041999999992,
							25.75664000000006
						],
						[
							-80.23042541599995,
							25.757040775000064
						],
						[
							-80.2304299999999,
							25.75738000000007
						],
						[
							-80.23044284299993,
							25.757719181000084
						],
						[
							-80.2304499999999,
							25.758120000000076
						],
						[
							-80.2304604759999,
							25.758333021000055
						],
						[
							-80.2304699739999,
							25.758526135000068
						],
						[
							-80.2304860779999,
							25.758912330000044
						],
						[
							-80.23048999999992,
							25.759030000000052
						],
						[
							-80.23049304699992,
							25.759170158000074
						],
						[
							-80.23049999999995,
							25.759490000000085
						],
						[
							-80.2305044709999,
							25.75959060300005
						],
						[
							-80.2305101959999,
							25.759719402000087
						],
						[
							-80.2305199999999,
							25.759940000000086
						],
						[
							-80.23053044699992,
							25.760201169000084
						],
						[
							-80.2305399999999,
							25.760440000000074
						],
						[
							-80.23054925899993,
							25.76068691900008
						],
						[
							-80.23055892499991,
							25.76094466500007
						],
						[
							-80.23056999999994,
							25.761240000000043
						],
						[
							-80.23059116099995,
							25.761589961000087
						],
						[
							-80.23060225499995,
							25.761847663000086
						],
						[
							-80.23061754499992,
							25.762298815000065
						],
						[
							-80.23062647299992,
							25.76255772800005
						],
						[
							-80.23063379199994,
							25.762751002000073
						],
						[
							-80.2306444059999,
							25.76310557800008
						],
						[
							-80.23065462199992,
							25.76339672300009
						],
						[
							-80.23067340799992,
							25.76397463400008
						],
						[
							-80.23068821399994,
							25.764233739000076
						],
						[
							-80.2306999999999,
							25.764500000000055
						],
						[
							-80.23057999999992,
							25.764500000000055
						],
						[
							-80.23022530799994,
							25.764521113000058
						],
						[
							-80.22992785399992,
							25.764538818000066
						],
						[
							-80.22957999999994,
							25.764560000000074
						],
						[
							-80.22921345499992,
							25.764567481000086
						],
						[
							-80.22884621399993,
							25.764574975000073
						],
						[
							-80.2284330679999,
							25.76458340700009
						],
						[
							-80.2281099999999,
							25.764590000000055
						],
						[
							-80.2278133769999,
							25.76459626700006
						],
						[
							-80.22742319499991,
							25.764604510000087
						],
						[
							-80.22700957599994,
							25.764613248000046
						],
						[
							-80.22658999999993,
							25.764630000000068
						],
						[
							-80.22658999999993,
							25.76472000000007
						],
						[
							-80.22625136099992,
							25.764728300000062
						],
						[
							-80.22588418799995,
							25.764737299000046
						],
						[
							-80.22533342699995,
							25.76475079800008
						],
						[
							-80.2248962839999,
							25.764761513000053
						],
						[
							-80.22454999999991,
							25.764770000000055
						],
						[
							-80.22418497799993,
							25.764780632000054
						],
						[
							-80.22358846799995,
							25.76479800600004
						],
						[
							-80.22303717599993,
							25.764814063000074
						],
						[
							-80.22273758499995,
							25.76482278900005
						],
						[
							-80.22248999999994,
							25.764830000000075
						],
						[
							-80.22214103199991,
							25.76483868100007
						],
						[
							-80.22170502099993,
							25.76484952700008
						],
						[
							-80.22115427099993,
							25.764863227000035
						],
						[
							-80.22083299999991,
							25.764871219000042
						],
						[
							-80.22047999999995,
							25.764880000000062
						],
						[
							-80.22028123599995,
							25.76488795100005
						],
						[
							-80.21998320599994,
							25.764899872000058
						],
						[
							-80.21963932399991,
							25.764913627000055
						],
						[
							-80.21947999999992,
							25.764920000000075
						],
						[
							-80.21948399699994,
							25.765067899000087
						],
						[
							-80.2194975999999,
							25.76543440900008
						],
						[
							-80.21948642699994,
							25.765642881000076
						],
						[
							-80.21947967599993,
							25.765719825000076
						],
						[
							-80.21471995499991,
							25.765854044000037
						],
						[
							-80.21444077799993,
							25.765830659000073
						],
						[
							-80.21443199099991,
							25.765665782000042
						],
						[
							-80.21442253799995,
							25.76543655100005
						],
						[
							-80.21441682699992,
							25.76529806700006
						],
						[
							-80.21440642899995,
							25.765045912000062
						],
						[
							-80.2143999999999,
							25.764890000000037
						],
						[
							-80.21439730499992,
							25.76474714400007
						],
						[
							-80.2143938239999,
							25.76456264600006
						],
						[
							-80.21438999999992,
							25.764360000000067
						],
						[
							-80.21438060199995,
							25.76414853700004
						],
						[
							-80.21437453599992,
							25.76401205400009
						],
						[
							-80.21436999999992,
							25.763910000000067
						],
						[
							-80.21436753299992,
							25.76385160400008
						],
						[
							-80.21435591099993,
							25.76357654900005
						],
						[
							-80.21434913099995,
							25.763416101000075
						],
						[
							-80.21434517499995,
							25.76332247900007
						],
						[
							-80.21433999999994,
							25.76320000000004
						],
						[
							-80.21433650799992,
							25.763116188000083
						],
						[
							-80.2143299999999,
							25.76296000000008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami",
				"Name": "Shenandoah",
				"RegionID": "126149"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.61881390799994,
					30.29254800500007,
					-81.5994008529999,
					30.31400801200005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.60011190799992,
							30.309034010000058
						],
						[
							-81.60031190699993,
							30.307450010000082
						],
						[
							-81.60051090699994,
							30.30611401100009
						],
						[
							-81.60059190699991,
							30.30567601000007
						],
						[
							-81.60069390799994,
							30.304812010000038
						],
						[
							-81.60076090799993,
							30.304348010000066
						],
						[
							-81.60088790799995,
							30.30357701100007
						],
						[
							-81.6009109069999,
							30.30343301000005
						],
						[
							-81.60114490799992,
							30.301731010000083
						],
						[
							-81.6011979079999,
							30.301426011000043
						],
						[
							-81.60132590699993,
							30.300361011000064
						],
						[
							-81.60143790799992,
							30.29897201100005
						],
						[
							-81.60144590699991,
							30.298871011000074
						],
						[
							-81.60150490699995,
							30.29826501000008
						],
						[
							-81.60153690799991,
							30.29778101100004
						],
						[
							-81.6015609079999,
							30.29742501000004
						],
						[
							-81.60159490799992,
							30.297039011000038
						],
						[
							-81.60160090799991,
							30.29693101000004
						],
						[
							-81.60161490699994,
							30.29684601100007
						],
						[
							-81.60166590699993,
							30.29612401100007
						],
						[
							-81.60171590699991,
							30.295583010000083
						],
						[
							-81.60174190699992,
							30.295306011000037
						],
						[
							-81.60175290799992,
							30.29517401100009
						],
						[
							-81.60179290799994,
							30.294615010000086
						],
						[
							-81.60195790799992,
							30.29254800500007
						],
						[
							-81.60262490799994,
							30.292728011000065
						],
						[
							-81.60401690799996,
							30.293161010000063
						],
						[
							-81.6048009079999,
							30.293385011000055
						],
						[
							-81.60513690699992,
							30.293486011000088
						],
						[
							-81.6056369069999,
							30.293625011000078
						],
						[
							-81.60567290799992,
							30.293636010000057
						],
						[
							-81.60582690799993,
							30.293682011000048
						],
						[
							-81.6062699069999,
							30.293816010000057
						],
						[
							-81.6069619079999,
							30.294019011000042
						],
						[
							-81.60752190799991,
							30.29417901100004
						],
						[
							-81.60798890799992,
							30.29433001100006
						],
						[
							-81.60883890699995,
							30.294571010000084
						],
						[
							-81.60922290799995,
							30.29469201000006
						],
						[
							-81.60941290799992,
							30.294745010000042
						],
						[
							-81.60967493699992,
							30.294812113000038
						],
						[
							-81.61087090699993,
							30.295162010000066
						],
						[
							-81.61184390699992,
							30.295449010000084
						],
						[
							-81.61258990699992,
							30.29567001000004
						],
						[
							-81.61330690699992,
							30.29588201000007
						],
						[
							-81.61342090699992,
							30.295918010000037
						],
						[
							-81.61432090799991,
							30.296180011000047
						],
						[
							-81.61438990799991,
							30.296199011000056
						],
						[
							-81.61448290699991,
							30.296224011000046
						],
						[
							-81.61453590699996,
							30.29623901100007
						],
						[
							-81.61461690699991,
							30.296260011000076
						],
						[
							-81.61564790699992,
							30.296653011000046
						],
						[
							-81.61572890699995,
							30.296688011000068
						],
						[
							-81.61575090699995,
							30.29669801000006
						],
						[
							-81.61634590799991,
							30.29697301000005
						],
						[
							-81.6164459069999,
							30.297014010000055
						],
						[
							-81.61722490699992,
							30.297385010000085
						],
						[
							-81.61751190799993,
							30.297508011000048
						],
						[
							-81.61763790799995,
							30.297576010000057
						],
						[
							-81.61881390799994,
							30.298147908000093
						],
						[
							-81.61852790799992,
							30.298383011000055
						],
						[
							-81.61562390699993,
							30.300776197000065
						],
						[
							-81.61450692099993,
							30.29983881900006
						],
						[
							-81.61347690799994,
							30.300555011000085
						],
						[
							-81.61290790899996,
							30.300996010000063
						],
						[
							-81.61280490699994,
							30.301077011000075
						],
						[
							-81.61253090699995,
							30.301407011000038
						],
						[
							-81.61242897499994,
							30.301506126000053
						],
						[
							-81.61236090699992,
							30.301531011000066
						],
						[
							-81.6122299079999,
							30.30156901000004
						],
						[
							-81.61215590799992,
							30.301586010000047
						],
						[
							-81.6120669099999,
							30.301601009000077
						],
						[
							-81.6119219069999,
							30.301589010000043
						],
						[
							-81.6118130289999,
							30.30156994200007
						],
						[
							-81.61164290799991,
							30.30155201000008
						],
						[
							-81.61161490799992,
							30.301552011000073
						],
						[
							-81.61151890799994,
							30.301564011000035
						],
						[
							-81.6113779069999,
							30.301592010000036
						],
						[
							-81.61119390799992,
							30.301641011000076
						],
						[
							-81.61100090799994,
							30.30171001100007
						],
						[
							-81.61092490699991,
							30.301750010000035
						],
						[
							-81.61082690799992,
							30.301810011000043
						],
						[
							-81.61071090799993,
							30.301910010000082
						],
						[
							-81.61059490699995,
							30.302036011000038
						],
						[
							-81.61049590599993,
							30.302161010000077
						],
						[
							-81.61035690699993,
							30.30228100900007
						],
						[
							-81.61022890699991,
							30.30235600900005
						],
						[
							-81.61010090699995,
							30.302402010000037
						],
						[
							-81.60995590699991,
							30.302432010000075
						],
						[
							-81.60981690799991,
							30.302447063000045
						],
						[
							-81.60970090599994,
							30.30243200800004
						],
						[
							-81.60958490799993,
							30.302392009000076
						],
						[
							-81.60945090999991,
							30.30232100900008
						],
						[
							-81.6093519069999,
							30.302226010000087
						],
						[
							-81.6092599079999,
							30.302156011000083
						],
						[
							-81.60913192599992,
							30.302085960000056
						],
						[
							-81.60900990599993,
							30.302056013000083
						],
						[
							-81.60889390799991,
							30.302061011000035
						],
						[
							-81.60876590999995,
							30.302086011000085
						],
						[
							-81.60866188199992,
							30.302130964000074
						],
						[
							-81.60858590999993,
							30.302191011000048
						],
						[
							-81.60853382999994,
							30.302260974000035
						],
						[
							-81.6085169079999,
							30.30233601000009
						],
						[
							-81.60849290699991,
							30.302437010000062
						],
						[
							-81.6084529069999,
							30.30256201000009
						],
						[
							-81.6083829069999,
							30.30270701000006
						],
						[
							-81.60832890799992,
							30.302797010000067
						],
						[
							-81.60717890699993,
							30.304707010000076
						],
						[
							-81.60699179099993,
							30.30494994500009
						],
						[
							-81.60696882499991,
							30.305031006000032
						],
						[
							-81.60698479399991,
							30.305091076000057
						],
						[
							-81.60720990799992,
							30.305320010000063
						],
						[
							-81.60795790899994,
							30.305951010000058
						],
						[
							-81.60857290699994,
							30.306308008000084
						],
						[
							-81.6086819009999,
							30.306341095000054
						],
						[
							-81.6087908909999,
							30.30632795500009
						],
						[
							-81.60976388199992,
							30.305870878000068
						],
						[
							-81.60985693099991,
							30.305863881000054
						],
						[
							-81.60992705399991,
							30.30589488600009
						],
						[
							-81.6099430399999,
							30.30595801000004
						],
						[
							-81.60992690699993,
							30.306034010000072
						],
						[
							-81.6096859079999,
							30.30667701100009
						],
						[
							-81.60950703299994,
							30.307450058000082
						],
						[
							-81.60923398199992,
							30.307853185000056
						],
						[
							-81.60915790799993,
							30.30783887700005
						],
						[
							-81.6090559349999,
							30.30786609800009
						],
						[
							-81.60823090799994,
							30.308169010000086
						],
						[
							-81.60812989699991,
							30.308195167000065
						],
						[
							-81.60803590699993,
							30.30816201100004
						],
						[
							-81.6079349069999,
							30.308121825000057
						],
						[
							-81.60787280099993,
							30.30814786900004
						],
						[
							-81.60783371999992,
							30.30820196000008
						],
						[
							-81.60784190999993,
							30.30826901200004
						],
						[
							-81.60791195999991,
							30.30846400100006
						],
						[
							-81.60794290699994,
							30.309036011000046
						],
						[
							-81.60798190799994,
							30.309627010000042
						],
						[
							-81.60805178299995,
							30.310218056000053
						],
						[
							-81.60821580499993,
							30.310501097000042
						],
						[
							-81.60854986999993,
							30.310783085000086
						],
						[
							-81.60886090699995,
							30.310863010000045
						],
						[
							-81.60911992899993,
							30.31091092800005
						],
						[
							-81.60877490999991,
							30.310942012000055
						],
						[
							-81.60835790899995,
							30.310984012000063
						],
						[
							-81.60819190899991,
							30.310995013000078
						],
						[
							-81.60797990999993,
							30.31101401300009
						],
						[
							-81.60785690999995,
							30.311028012000065
						],
						[
							-81.60769390999991,
							30.311055013000043
						],
						[
							-81.60750590999993,
							30.31109401300006
						],
						[
							-81.60723890999992,
							30.31117101300004
						],
						[
							-81.60719190999993,
							30.31118801300005
						],
						[
							-81.60701490899993,
							30.311253013000055
						],
						[
							-81.60686890999995,
							30.311317013000068
						],
						[
							-81.60652890999995,
							30.311463013000033
						],
						[
							-81.60604890999991,
							30.311674013000072
						],
						[
							-81.60581190999996,
							30.311771013000055
						],
						[
							-81.60537090899993,
							30.311955013000045
						],
						[
							-81.6048599099999,
							30.312175012000072
						],
						[
							-81.60457490899995,
							30.312301013000084
						],
						[
							-81.6044079099999,
							30.312370012000084
						],
						[
							-81.60367390899995,
							30.312669013000065
						],
						[
							-81.60330190999991,
							30.31283201200006
						],
						[
							-81.60275990899993,
							30.31306801200009
						],
						[
							-81.60178390999994,
							30.31348201200007
						],
						[
							-81.60163890999992,
							30.313546013000064
						],
						[
							-81.60131787499995,
							30.313695928000072
						],
						[
							-81.60082990899991,
							30.313871012000046
						],
						[
							-81.60062390999991,
							30.313925012000084
						],
						[
							-81.60052490999993,
							30.31394001300004
						],
						[
							-81.60040190899991,
							30.313964012000046
						],
						[
							-81.60017190899993,
							30.313991012000088
						],
						[
							-81.59988990999994,
							30.31400801200005
						],
						[
							-81.59965190899993,
							30.31399401200008
						],
						[
							-81.5994008529999,
							30.313966995000044
						],
						[
							-81.59940890799993,
							30.313910010000082
						],
						[
							-81.59953290699991,
							30.313062011000056
						],
						[
							-81.59958690799994,
							30.31261901000005
						],
						[
							-81.59983590799993,
							30.311031011000065
						],
						[
							-81.59988790699992,
							30.310751010000047
						],
						[
							-81.60011190799992,
							30.309034010000058
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Spring Glen",
				"RegionID": "126258"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.001122,
					29.020429,
					-80.966525,
					29.057212
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.970881,
							29.05653
						],
						[
							-80.966525,
							29.053550000000005
						],
						[
							-80.967239,
							29.052563
						],
						[
							-80.968094,
							29.052196999999996
						],
						[
							-80.975141,
							29.049367000000004
						],
						[
							-80.975299,
							29.049223
						],
						[
							-80.978733,
							29.047743
						],
						[
							-80.978068,
							29.046637000000004
						],
						[
							-80.976954,
							29.044622
						],
						[
							-80.978613,
							29.043896
						],
						[
							-80.977355,
							29.041691
						],
						[
							-80.975575,
							29.042434
						],
						[
							-80.975383,
							29.042108000000002
						],
						[
							-80.972122,
							29.043505
						],
						[
							-80.970218,
							29.044418
						],
						[
							-80.969985,
							29.044022000000002
						],
						[
							-80.969535,
							29.044244
						],
						[
							-80.969747,
							29.044644000000005
						],
						[
							-80.968575,
							29.045206
						],
						[
							-80.968345,
							29.045327999999998
						],
						[
							-80.968343,
							29.045013
						],
						[
							-80.967522,
							29.045047
						],
						[
							-80.967522,
							29.042041000000005
						],
						[
							-80.971002,
							29.042093
						],
						[
							-80.971041,
							29.038251
						],
						[
							-80.978918,
							29.038182
						],
						[
							-80.979311,
							29.038980999999996
						],
						[
							-80.979878,
							29.038726
						],
						[
							-80.979431,
							29.037973
						],
						[
							-80.979759,
							29.037827000000004
						],
						[
							-80.98011,
							29.035376
						],
						[
							-80.98209400000002,
							29.035344999999996
						],
						[
							-80.982099,
							29.034825
						],
						[
							-80.980218,
							29.034317000000005
						],
						[
							-80.98015,
							29.031179
						],
						[
							-80.980133,
							29.030371
						],
						[
							-80.980052,
							29.023766000000002
						],
						[
							-80.982142,
							29.023736000000003
						],
						[
							-80.982109,
							29.022682000000003
						],
						[
							-80.982071,
							29.022465000000004
						],
						[
							-80.980061,
							29.022453
						],
						[
							-80.980119,
							29.020455000000002
						],
						[
							-80.980641,
							29.020451000000005
						],
						[
							-80.98355,
							29.020429
						],
						[
							-80.983458,
							29.023717000000005
						],
						[
							-80.983402,
							29.031921
						],
						[
							-80.984828,
							29.032600000000002
						],
						[
							-80.985637,
							29.032985000000004
						],
						[
							-80.987567,
							29.033904
						],
						[
							-80.988876,
							29.034527
						],
						[
							-80.989212,
							29.034708
						],
						[
							-80.990437,
							29.035306000000002
						],
						[
							-80.993279,
							29.036692
						],
						[
							-80.993904,
							29.036936000000004
						],
						[
							-80.994293,
							29.037051999999996
						],
						[
							-80.994324,
							29.037073
						],
						[
							-80.995819,
							29.037434
						],
						[
							-80.99604800000002,
							29.037476
						],
						[
							-80.996277,
							29.037563000000002
						],
						[
							-80.996445,
							29.037662999999995
						],
						[
							-80.996582,
							29.037777000000002
						],
						[
							-80.99922184999997,
							29.040559273000046
						],
						[
							-80.999733,
							29.041098000000005
						],
						[
							-81.00024700000002,
							29.045123000000004
						],
						[
							-81.000583,
							29.047431999999997
						],
						[
							-81.001122,
							29.048079999999995
						],
						[
							-80.999504,
							29.048637
						],
						[
							-80.999366,
							29.0487
						],
						[
							-80.999268,
							29.048744000000003
						],
						[
							-80.999138,
							29.048819999999996
						],
						[
							-80.998894,
							29.049012999999995
						],
						[
							-80.998711,
							29.049219000000004
						],
						[
							-80.998129,
							29.050161999999997
						],
						[
							-80.997057,
							29.048695
						],
						[
							-80.993164,
							29.049606
						],
						[
							-80.992921,
							29.048967999999995
						],
						[
							-80.98980400000002,
							29.050433
						],
						[
							-80.989424,
							29.050689000000002
						],
						[
							-80.98660400000001,
							29.052015000000004
						],
						[
							-80.983429,
							29.053060999999996
						],
						[
							-80.973259,
							29.057212
						],
						[
							-80.971771,
							29.055705999999997
						],
						[
							-80.971703,
							29.055594999999997
						],
						[
							-80.970881,
							29.05653
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Volusia",
				"City": "New Smyrna Beach",
				"Name": "Sugar Mill",
				"RegionID": "126288"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.60444005099993,
					30.327318011000045,
					-81.58061182599994,
					30.345686200000046
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.58534197299991,
							30.345254893000057
						],
						[
							-81.58521990299995,
							30.34522201000004
						],
						[
							-81.5823478659999,
							30.345270060000075
						],
						[
							-81.58201790699991,
							30.34434300900006
						],
						[
							-81.58195598499992,
							30.344047973000045
						],
						[
							-81.58146173699993,
							30.343350056000077
						],
						[
							-81.58144898699993,
							30.339891988000094
						],
						[
							-81.58061182599994,
							30.338280028000046
						],
						[
							-81.58086599199993,
							30.334925077000037
						],
						[
							-81.5811679059999,
							30.332029008000067
						],
						[
							-81.58132490599992,
							30.331030008000084
						],
						[
							-81.5816699049999,
							30.328834009000044
						],
						[
							-81.58181207799993,
							30.327778977000033
						],
						[
							-81.58177490599991,
							30.327709009000042
						],
						[
							-81.58170293799992,
							30.32759089200005
						],
						[
							-81.58165477099993,
							30.327545956000055
						],
						[
							-81.58210890599992,
							30.32753901000007
						],
						[
							-81.58273390599993,
							30.327534010000083
						],
						[
							-81.58349605099994,
							30.32752789400007
						],
						[
							-81.5834837669999,
							30.327577126000055
						],
						[
							-81.58382190899994,
							30.327573010000037
						],
						[
							-81.5854679059999,
							30.327554010000085
						],
						[
							-81.58578390699995,
							30.327554010000085
						],
						[
							-81.58587690899992,
							30.327553011000077
						],
						[
							-81.58603890699993,
							30.327549010000038
						],
						[
							-81.58607190599992,
							30.32754801000004
						],
						[
							-81.58614490899993,
							30.32754701000005
						],
						[
							-81.5867239179999,
							30.327546958000084
						],
						[
							-81.58736690799992,
							30.32772820100007
						],
						[
							-81.58791390699992,
							30.327534958000058
						],
						[
							-81.58862290699994,
							30.327531011000072
						],
						[
							-81.58901790699991,
							30.327536010000077
						],
						[
							-81.58905790599995,
							30.327536010000077
						],
						[
							-81.58938290599993,
							30.327529010000035
						],
						[
							-81.59006490699994,
							30.327530011000075
						],
						[
							-81.59027290799992,
							30.327517011000058
						],
						[
							-81.59065590799992,
							30.327500010000055
						],
						[
							-81.59152990699994,
							30.327496010000065
						],
						[
							-81.59316990699995,
							30.327480010000045
						],
						[
							-81.59434890699993,
							30.327468010000075
						],
						[
							-81.59470490899992,
							30.327461010000036
						],
						[
							-81.59487090899995,
							30.327454011000043
						],
						[
							-81.59537490699995,
							30.327457010000042
						],
						[
							-81.59576390599995,
							30.327447010000075
						],
						[
							-81.59636890599997,
							30.327448010000072
						],
						[
							-81.59695503799992,
							30.327449142000034
						],
						[
							-81.5969557759999,
							30.327394878000064
						],
						[
							-81.59834890899992,
							30.32737201000009
						],
						[
							-81.59963790699993,
							30.32736001000006
						],
						[
							-81.60077390899994,
							30.327355011000066
						],
						[
							-81.60147290799995,
							30.327352010000087
						],
						[
							-81.60210290899994,
							30.327334010000072
						],
						[
							-81.60257715299993,
							30.32733906100009
						],
						[
							-81.60399290799995,
							30.32731901000005
						],
						[
							-81.60405890699991,
							30.327318011000045
						],
						[
							-81.60444005099993,
							30.327324909000087
						],
						[
							-81.6044238689999,
							30.327371952000078
						],
						[
							-81.6043619049999,
							30.327551008000057
						],
						[
							-81.60410690599991,
							30.328226008000062
						],
						[
							-81.60406790499991,
							30.32836700900009
						],
						[
							-81.60396790599992,
							30.328719010000047
						],
						[
							-81.60359190499992,
							30.32976700800009
						],
						[
							-81.60341590599995,
							30.330265009000072
						],
						[
							-81.60333590599993,
							30.33055500800009
						],
						[
							-81.60321790499995,
							30.331150008000062
						],
						[
							-81.60317990499993,
							30.331415008000082
						],
						[
							-81.60317190599994,
							30.331579009000052
						],
						[
							-81.60315290599993,
							30.33175000800009
						],
						[
							-81.60306890599992,
							30.33248600900004
						],
						[
							-81.60302690499992,
							30.33281700900005
						],
						[
							-81.60300190499993,
							30.33310100800009
						],
						[
							-81.60292190599995,
							30.333621008000083
						],
						[
							-81.60291290599991,
							30.33379400800004
						],
						[
							-81.60279290499994,
							30.334741008000037
						],
						[
							-81.6027599059999,
							30.335011009000088
						],
						[
							-81.60266890499992,
							30.335781009000073
						],
						[
							-81.60266090599993,
							30.33587600900006
						],
						[
							-81.6026079049999,
							30.336349008000067
						],
						[
							-81.6025849049999,
							30.336641008000072
						],
						[
							-81.60258490599995,
							30.336758009000047
						],
						[
							-81.60257690499992,
							30.336981008000066
						],
						[
							-81.60256990599993,
							30.337667009000086
						],
						[
							-81.60256990599993,
							30.337761009000076
						],
						[
							-81.60256190599995,
							30.338232008000034
						],
						[
							-81.60254190599994,
							30.338617008000085
						],
						[
							-81.60256690499995,
							30.339592008000068
						],
						[
							-81.60257190499995,
							30.33966100900005
						],
						[
							-81.60257090599993,
							30.339755008000054
						],
						[
							-81.6025829969999,
							30.340104042000064
						],
						[
							-81.60111190499993,
							30.34093900800008
						],
						[
							-81.5997239049999,
							30.34170700800007
						],
						[
							-81.59880790599993,
							30.342188009000044
						],
						[
							-81.59862492499991,
							30.34227605700005
						],
						[
							-81.59855690499995,
							30.342287061000036
						],
						[
							-81.59847990599991,
							30.342279007000055
						],
						[
							-81.59841192899995,
							30.34225995600008
						],
						[
							-81.59836587099994,
							30.34223004900008
						],
						[
							-81.59833490599993,
							30.342197006000053
						],
						[
							-81.5982890009999,
							30.342118839000076
						],
						[
							-81.59759490599993,
							30.342142009000046
						],
						[
							-81.5973509019999,
							30.342141917000053
						],
						[
							-81.59719090499993,
							30.342157008000076
						],
						[
							-81.59635890599992,
							30.342184009000054
						],
						[
							-81.59604590599992,
							30.34219600800009
						],
						[
							-81.59585590599994,
							30.342194008000035
						],
						[
							-81.5956499049999,
							30.342207008000063
						],
						[
							-81.59546690499991,
							30.34220300900006
						],
						[
							-81.59494790499991,
							30.342224008000073
						],
						[
							-81.59455090599994,
							30.34222600900006
						],
						[
							-81.59438290499992,
							30.342239009000078
						],
						[
							-81.59365090599994,
							30.342264008000086
						],
						[
							-81.59354390499993,
							30.342255008000055
						],
						[
							-81.59307090499993,
							30.34227600900005
						],
						[
							-81.59252890499994,
							30.342285009000076
						],
						[
							-81.59234590499995,
							30.34229700900005
						],
						[
							-81.59156790499992,
							30.342316009000058
						],
						[
							-81.59053777199995,
							30.342351880000077
						],
						[
							-81.59055290599991,
							30.343172008000067
						],
						[
							-81.5905690379999,
							30.34399213600005
						],
						[
							-81.58933677399995,
							30.34401488000009
						],
						[
							-81.58935490599993,
							30.34466000900005
						],
						[
							-81.58935290599993,
							30.345048009000042
						],
						[
							-81.5893600419999,
							30.345153138000057
						],
						[
							-81.5873409049999,
							30.34519400800008
						],
						[
							-81.58645589699996,
							30.345214956000067
						],
						[
							-81.58640290599993,
							30.345230009000094
						],
						[
							-81.58633390599994,
							30.345263011000043
						],
						[
							-81.58586090699993,
							30.345686200000046
						],
						[
							-81.58534197299991,
							30.345254893000057
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Arlington",
				"RegionID": "123471"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.68390685199995,
					30.315742098000044,
					-81.66599209799995,
					30.32671900600008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.66940686199992,
							30.32584816800005
						],
						[
							-81.66844490699992,
							30.32512900800009
						],
						[
							-81.66826890599992,
							30.32499100800004
						],
						[
							-81.6681589239999,
							30.32489481500005
						],
						[
							-81.66737987199991,
							30.325365194000085
						],
						[
							-81.66719790499991,
							30.325107009000078
						],
						[
							-81.66629999999992,
							30.323802000000057
						],
						[
							-81.66599209799995,
							30.322655481000087
						],
						[
							-81.66628505099993,
							30.322822319000064
						],
						[
							-81.66671454599992,
							30.322628775000055
						],
						[
							-81.66794230199991,
							30.322053846000077
						],
						[
							-81.66824075699992,
							30.321630122000045
						],
						[
							-81.66828442899993,
							30.321573100000084
						],
						[
							-81.66833251199995,
							30.321519746000035
						],
						[
							-81.66838469999993,
							30.321470398000084
						],
						[
							-81.66844065899996,
							30.321425373000068
						],
						[
							-81.66887665899992,
							30.321102373000087
						],
						[
							-81.66900924899994,
							30.321020903000093
						],
						[
							-81.66946341399995,
							30.320793424000048
						],
						[
							-81.6697001579999,
							30.320569410000076
						],
						[
							-81.66979150499992,
							30.320482044000073
						],
						[
							-81.66981362299992,
							30.320437809000058
						],
						[
							-81.6698497619999,
							30.32037246500005
						],
						[
							-81.66989119599992,
							30.320310343000077
						],
						[
							-81.66993764199992,
							30.32025187300008
						],
						[
							-81.66998877799995,
							30.320197458000052
						],
						[
							-81.67004425199991,
							30.320147473000077
						],
						[
							-81.67010368199993,
							30.320102262000034
						],
						[
							-81.67016665799991,
							30.32006213700004
						],
						[
							-81.67116775999995,
							30.31948126300006
						],
						[
							-81.6720410179999,
							30.31890920400008
						],
						[
							-81.67208682799992,
							30.31885845300008
						],
						[
							-81.6721363609999,
							30.318811329000084
						],
						[
							-81.67218933099991,
							30.318768105000064
						],
						[
							-81.67224543299994,
							30.318729030000043
						],
						[
							-81.67230434099991,
							30.318694330000085
						],
						[
							-81.67246704299993,
							30.318606552000062
						],
						[
							-81.67250110899994,
							30.31845990100004
						],
						[
							-81.6725331479999,
							30.318360735000056
						],
						[
							-81.67274918599992,
							30.317722569000072
						],
						[
							-81.67275591399994,
							30.317703414000054
						],
						[
							-81.6728237559999,
							30.317558604000055
						],
						[
							-81.67386298399992,
							30.31578749000005
						],
						[
							-81.67388917099993,
							30.315742098000044
						],
						[
							-81.67471499999994,
							30.31611200000009
						],
						[
							-81.67494490599995,
							30.31623200900009
						],
						[
							-81.6752329059999,
							30.316361008000058
						],
						[
							-81.67563987099993,
							30.31651899900004
						],
						[
							-81.67608290499993,
							30.316734008000083
						],
						[
							-81.6764259059999,
							30.316937008000085
						],
						[
							-81.67658890599995,
							30.317007008000076
						],
						[
							-81.67675688799994,
							30.317091057000084
						],
						[
							-81.67716790599991,
							30.31716006100004
						],
						[
							-81.67731390599994,
							30.317145008000068
						],
						[
							-81.67745391399991,
							30.317124927000066
						],
						[
							-81.67777490599991,
							30.317250008000087
						],
						[
							-81.67795090599992,
							30.31731500800004
						],
						[
							-81.67814790499995,
							30.317401009000033
						],
						[
							-81.67826790499993,
							30.317455008000085
						],
						[
							-81.67853197399995,
							30.31755889300007
						],
						[
							-81.67866790599993,
							30.317683008000078
						],
						[
							-81.67879290399992,
							30.317786005000077
						],
						[
							-81.6817008029999,
							30.319149510000045
						],
						[
							-81.68390685199995,
							30.321784069000042
						],
						[
							-81.6837429069999,
							30.321809008000063
						],
						[
							-81.68355990599991,
							30.321817008000043
						],
						[
							-81.6833849059999,
							30.321811009000044
						],
						[
							-81.68332390699993,
							30.321805008000073
						],
						[
							-81.68326390699991,
							30.321799008000085
						],
						[
							-81.68319390599993,
							30.32178200800007
						],
						[
							-81.68315687599994,
							30.32177282500004
						],
						[
							-81.68305790699992,
							30.321833009000045
						],
						[
							-81.68287390599994,
							30.32194600900004
						],
						[
							-81.68229090599993,
							30.322269008000035
						],
						[
							-81.68181290699994,
							30.322560009000085
						],
						[
							-81.68143790599993,
							30.322849009000038
						],
						[
							-81.68122490699994,
							30.323042009000062
						],
						[
							-81.68101090699992,
							30.323268008000074
						],
						[
							-81.68085990899993,
							30.32345800800005
						],
						[
							-81.68077890399992,
							30.323612009000044
						],
						[
							-81.6806819059999,
							30.32379400800005
						],
						[
							-81.68056690599991,
							30.324021009000035
						],
						[
							-81.68050790699994,
							30.32412800800006
						],
						[
							-81.6800729069999,
							30.324966008000047
						],
						[
							-81.6799579069999,
							30.32521200800005
						],
						[
							-81.67983590599994,
							30.32550500800005
						],
						[
							-81.6797159059999,
							30.325806008000082
						],
						[
							-81.67968090499994,
							30.32588800900004
						],
						[
							-81.67962190599991,
							30.325990009000066
						],
						[
							-81.6795509289999,
							30.326120075000066
						],
						[
							-81.67946990699994,
							30.32611000900005
						],
						[
							-81.67943388299994,
							30.32611013900004
						],
						[
							-81.67938490699993,
							30.326088009000046
						],
						[
							-81.67915791599995,
							30.325932015000035
						],
						[
							-81.67887390699991,
							30.32585300900007
						],
						[
							-81.67841390599995,
							30.32577987500008
						],
						[
							-81.67806990399993,
							30.32586900900009
						],
						[
							-81.67770691599992,
							30.32596906100008
						],
						[
							-81.67684188299995,
							30.326020928000048
						],
						[
							-81.67616995199995,
							30.326458134000063
						],
						[
							-81.67531590699991,
							30.326647008000062
						],
						[
							-81.67414090599993,
							30.32671900600008
						],
						[
							-81.67243190499994,
							30.32633000900006
						],
						[
							-81.67146589599992,
							30.326269060000072
						],
						[
							-81.67137290699992,
							30.32624100900006
						],
						[
							-81.67034090699991,
							30.325968009000068
						],
						[
							-81.66940686199992,
							30.32584816800005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Brooklyn",
				"RegionID": "123769"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.7380030029999,
					30.37272869600008,
					-81.71997647899991,
					30.392065190000043
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.7304759299999,
							30.391753922000078
						],
						[
							-81.7286809069999,
							30.390918011000053
						],
						[
							-81.72803990799991,
							30.390632011000037
						],
						[
							-81.7272799079999,
							30.390280011000076
						],
						[
							-81.7269819089999,
							30.390160011000035
						],
						[
							-81.72677590699993,
							30.390093010000044
						],
						[
							-81.72645590799993,
							30.39001701000007
						],
						[
							-81.72627290699995,
							30.38998801100007
						],
						[
							-81.72570090799992,
							30.38991201100004
						],
						[
							-81.72449790799993,
							30.38978401000009
						],
						[
							-81.72185590799995,
							30.389471010000076
						],
						[
							-81.72110790799991,
							30.38935601100007
						],
						[
							-81.72030899999993,
							30.389187000000046
						],
						[
							-81.72001838999995,
							30.389117254000045
						],
						[
							-81.71999659099993,
							30.388689989000056
						],
						[
							-81.72001670299994,
							30.388327977000078
						],
						[
							-81.72003681399991,
							30.387945853000076
						],
						[
							-81.72003681399991,
							30.387644176000034
						],
						[
							-81.71999659099993,
							30.38710115700007
						],
						[
							-81.71997647899991,
							30.386759257000055
						],
						[
							-81.71997647899991,
							30.386437468000054
						],
						[
							-81.72001670299994,
							30.386155903000088
						],
						[
							-81.72007703799994,
							30.385874338000065
						],
						[
							-81.72021782099995,
							30.385431878000077
						],
						[
							-81.72033849099995,
							30.385110089000083
						],
						[
							-81.7204189389999,
							30.384828524000053
						],
						[
							-81.7205396089999,
							30.38450673500006
						],
						[
							-81.7206200569999,
							30.384285506000083
						],
						[
							-81.72045916199994,
							30.384044164000045
						],
						[
							-81.72033849099995,
							30.38376259900008
						],
						[
							-81.72029826799991,
							30.383521257000044
						],
						[
							-81.72035860299991,
							30.383259804000087
						],
						[
							-81.7204792739999,
							30.383098910000054
						],
						[
							-81.72070050399992,
							30.382958127000055
						],
						[
							-81.72090162199993,
							30.38277712100006
						],
						[
							-81.72102229199993,
							30.382555891000035
						],
						[
							-81.7210625159999,
							30.382294438000088
						],
						[
							-81.7210021809999,
							30.38193242500006
						],
						[
							-81.72094184499991,
							30.381550301000065
						],
						[
							-81.72090162199993,
							30.381208401000038
						],
						[
							-81.72090162199993,
							30.380926835000082
						],
						[
							-81.72096195699994,
							30.380625158000043
						],
						[
							-81.72110273999994,
							30.38032348200005
						],
						[
							-81.72132396899991,
							30.38000169300005
						],
						[
							-81.72160553499992,
							30.37959945700004
						],
						[
							-81.72194743499996,
							30.379156997000056
						],
						[
							-81.72206810599994,
							30.378895544000045
						],
						[
							-81.72212844099994,
							30.378634091000038
						],
						[
							-81.72220888899994,
							30.378432973000088
						],
						[
							-81.72243011799992,
							30.37819163100005
						],
						[
							-81.72269157199992,
							30.37805084800004
						],
						[
							-81.7230535839999,
							30.378131296000053
						],
						[
							-81.7232547019999,
							30.37827207800007
						],
						[
							-81.7234357079999,
							30.378352525000082
						],
						[
							-81.7236368259999,
							30.37837263700004
						],
						[
							-81.72397872699992,
							30.37831230200004
						],
						[
							-81.72422006799991,
							30.378211743000065
						],
						[
							-81.72448152199992,
							30.377990513000046
						],
						[
							-81.72461920299992,
							30.37784918500006
						],
						[
							-81.7247727269999,
							30.37777693900006
						],
						[
							-81.72495334399991,
							30.377713723000053
						],
						[
							-81.72513396099993,
							30.37766856900004
						],
						[
							-81.7252874859999,
							30.377650507000055
						],
						[
							-81.72543197899995,
							30.377605353000032
						],
						[
							-81.7256216269999,
							30.377533106000048
						],
						[
							-81.72572999699992,
							30.37746989000004
						],
						[
							-81.7258112749999,
							30.377352489000092
						],
						[
							-81.72596479899994,
							30.37710865600008
						],
						[
							-81.72606413799991,
							30.376937070000054
						],
						[
							-81.72623572399993,
							30.37653068200007
						],
						[
							-81.72635312499995,
							30.376295880000043
						],
						[
							-81.72638924899992,
							30.376151386000064
						],
						[
							-81.72642537199994,
							30.376006893000064
						],
						[
							-81.72664211299991,
							30.375528258000088
						],
						[
							-81.72671435899991,
							30.375130901000034
						],
						[
							-81.7267703839999,
							30.374913026000062
						],
						[
							-81.72679563699995,
							30.374814821000086
						],
						[
							-81.72692206899991,
							30.374625174000073
						],
						[
							-81.7270575309999,
							30.374498742000075
						],
						[
							-81.72719299399995,
							30.374399402000055
						],
						[
							-81.72740070399993,
							30.374318125000062
						],
						[
							-81.7276445359999,
							30.374245878000067
						],
						[
							-81.72790643099995,
							30.374164600000086
						],
						[
							-81.72805995499994,
							30.374092354000084
						],
						[
							-81.72813220199993,
							30.37391173700007
						],
						[
							-81.7281592949999,
							30.37374015100005
						],
						[
							-81.72812317099994,
							30.373586626000073
						],
						[
							-81.72805092399994,
							30.373460194000074
						],
						[
							-81.72799673899993,
							30.373333763000062
						],
						[
							-81.72798770899993,
							30.373225392000055
						],
						[
							-81.72811413999995,
							30.373053806000083
						],
						[
							-81.72824960299994,
							30.372972529000034
						],
						[
							-81.72843925099994,
							30.373035745000042
						],
						[
							-81.72859277499992,
							30.373062837000077
						],
						[
							-81.72877339199994,
							30.373062837000077
						],
						[
							-81.72921590399994,
							30.37293640500008
						],
						[
							-81.72941458199995,
							30.37286415900007
						],
						[
							-81.72956810699992,
							30.37286415900007
						],
						[
							-81.72966744599997,
							30.372927375000078
						],
						[
							-81.72973066199995,
							30.372999621000076
						],
						[
							-81.72988418599994,
							30.373062837000077
						],
						[
							-81.73006480299995,
							30.373080899000055
						],
						[
							-81.73025445099995,
							30.373062837000077
						],
						[
							-81.73038088299995,
							30.37300865200007
						],
						[
							-81.73046215999995,
							30.372927375000078
						],
						[
							-81.7305073149999,
							30.37286415900007
						],
						[
							-81.73058859199995,
							30.372773850000044
						],
						[
							-81.73069696199991,
							30.37272869600008
						],
						[
							-81.73081436299994,
							30.372764819000057
						],
						[
							-81.7308956409999,
							30.37290028200005
						],
						[
							-81.73092273299994,
							30.372999621000076
						],
						[
							-81.73091370299996,
							30.37308993000005
						],
						[
							-81.73087757899992,
							30.373153146000046
						],
						[
							-81.73077823999995,
							30.373288608000053
						],
						[
							-81.73080533199993,
							30.373415040000054
						],
						[
							-81.73091370299996,
							30.373523410000075
						],
						[
							-81.73104916499994,
							30.373586626000073
						],
						[
							-81.73113947399992,
							30.373532441000066
						],
						[
							-81.73122075099991,
							30.373415040000054
						],
						[
							-81.73131105999994,
							30.373351824000054
						],
						[
							-81.7314194299999,
							30.373279578000055
						],
						[
							-81.73153683099991,
							30.373225392000055
						],
						[
							-81.73163616999994,
							30.373189269000076
						],
						[
							-81.73178066399993,
							30.373189269000076
						],
						[
							-81.7318800029999,
							30.373216362000054
						],
						[
							-81.73218099999991,
							30.373387000000033
						],
						[
							-81.73250782199995,
							30.37347088900009
						],
						[
							-81.73467890699993,
							30.37696801100009
						],
						[
							-81.73601090799991,
							30.379127010000047
						],
						[
							-81.7380030029999,
							30.382356001000066
						],
						[
							-81.73334180199993,
							30.38678192200007
						],
						[
							-81.73329590599991,
							30.38687100900006
						],
						[
							-81.7332539059999,
							30.386953008000035
						],
						[
							-81.7331409059999,
							30.38716200800007
						],
						[
							-81.7328489059999,
							30.387703009000067
						],
						[
							-81.73261290599993,
							30.38812100800004
						],
						[
							-81.7325129059999,
							30.38831900900004
						],
						[
							-81.73205590499992,
							30.38916400900007
						],
						[
							-81.73197890499995,
							30.389315009000086
						],
						[
							-81.73162072699995,
							30.389935059000035
						],
						[
							-81.73231508299995,
							30.39026496000008
						],
						[
							-81.73215490599995,
							30.390509009000088
						],
						[
							-81.73198690599992,
							30.390795009000048
						],
						[
							-81.73187690599991,
							30.390962008000088
						],
						[
							-81.73185090599992,
							30.391002008000047
						],
						[
							-81.7317959049999,
							30.391085008000065
						],
						[
							-81.73118596599994,
							30.392065190000043
						],
						[
							-81.73111290599991,
							30.392032009000047
						],
						[
							-81.73061290499993,
							30.39182000800008
						],
						[
							-81.7304759299999,
							30.391753922000078
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Carver Manor",
				"RegionID": "123871"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-85.64999,
					30.167458,
					-85.505638,
					30.292205000000003
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-85.599174,
								30.176639000000005
							],
							[
								-85.599225,
								30.176639000000005
							],
							[
								-85.599173,
								30.176712000000002
							],
							[
								-85.599174,
								30.176639000000005
							]
						]
					],
					[
						[
							[
								-85.645759,
								30.190874
							],
							[
								-85.645277,
								30.190871
							],
							[
								-85.645267,
								30.190744000000002
							],
							[
								-85.64526000000001,
								30.190650000000005
							],
							[
								-85.645259,
								30.190442000000004
							],
							[
								-85.645759,
								30.190465
							],
							[
								-85.645759,
								30.190616
							],
							[
								-85.645759,
								30.190874
							]
						]
					],
					[
						[
							[
								-85.648712,
								30.191034
							],
							[
								-85.648887,
								30.191028
							],
							[
								-85.648887,
								30.191240000000004
							],
							[
								-85.648712,
								30.191244
							],
							[
								-85.648712,
								30.191034
							]
						]
					],
					[
						[
							[
								-85.648773,
								30.192044000000003
							],
							[
								-85.64936,
								30.192026000000002
							],
							[
								-85.649909,
								30.192076999999998
							],
							[
								-85.649988,
								30.192077999999995
							],
							[
								-85.64999,
								30.192202
							],
							[
								-85.649909,
								30.192202
							],
							[
								-85.648776,
								30.192211
							],
							[
								-85.648773,
								30.192044000000003
							]
						]
					],
					[
						[
							[
								-85.60572,
								30.197523
							],
							[
								-85.605719,
								30.19747
							],
							[
								-85.605714,
								30.197165
							],
							[
								-85.605694,
								30.19656
							],
							[
								-85.605735,
								30.196561
							],
							[
								-85.606277,
								30.196571000000002
							],
							[
								-85.606674,
								30.196577
							],
							[
								-85.607803,
								30.196596
							],
							[
								-85.607803,
								30.197100999999996
							],
							[
								-85.607803,
								30.197467
							],
							[
								-85.607803,
								30.197517
							],
							[
								-85.606763,
								30.197515
							],
							[
								-85.606751,
								30.198252999999998
							],
							[
								-85.60572,
								30.198232999999995
							],
							[
								-85.60572,
								30.197523
							]
						]
					],
					[
						[
							[
								-85.626853,
								30.209666
							],
							[
								-85.626841,
								30.209190999999997
							],
							[
								-85.626602,
								30.209163000000004
							],
							[
								-85.626808,
								30.208957
							],
							[
								-85.628254,
								30.209005
							],
							[
								-85.62823100000001,
								30.209582999999995
							],
							[
								-85.627942,
								30.209563
							],
							[
								-85.627944,
								30.210532
							],
							[
								-85.627296,
								30.210554
							],
							[
								-85.626853,
								30.209666
							]
						]
					],
					[
						[
							[
								-85.603485,
								30.225072
							],
							[
								-85.604148,
								30.225027
							],
							[
								-85.604118,
								30.225835000000004
							],
							[
								-85.603454,
								30.225822
							],
							[
								-85.603485,
								30.225072
							]
						]
					],
					[
						[
							[
								-85.568054,
								30.240804
							],
							[
								-85.569386,
								30.239860999999998
							],
							[
								-85.574264,
								30.236413
							],
							[
								-85.574273,
								30.236546999999998
							],
							[
								-85.574287,
								30.236745
							],
							[
								-85.57434,
								30.239044
							],
							[
								-85.572395,
								30.239179
							],
							[
								-85.572471,
								30.239944000000005
							],
							[
								-85.572519,
								30.240408
							],
							[
								-85.571299,
								30.240446
							],
							[
								-85.571004,
								30.240455
							],
							[
								-85.570278,
								30.241064000000005
							],
							[
								-85.570151,
								30.241181
							],
							[
								-85.569366,
								30.241901
							],
							[
								-85.569012,
								30.242163999999995
							],
							[
								-85.56891600000002,
								30.242257000000002
							],
							[
								-85.568856,
								30.242309
							],
							[
								-85.568772,
								30.24233
							],
							[
								-85.568784,
								30.240796999999997
							],
							[
								-85.568232,
								30.241191000000004
							],
							[
								-85.568225,
								30.242447000000002
							],
							[
								-85.567886,
								30.242488000000005
							],
							[
								-85.567909,
								30.242843000000004
							],
							[
								-85.56784,
								30.242918
							],
							[
								-85.567437,
								30.243179
							],
							[
								-85.567437,
								30.243097000000002
							],
							[
								-85.567437,
								30.242427
							],
							[
								-85.567447,
								30.24159
							],
							[
								-85.567452,
								30.241368000000005
							],
							[
								-85.567455,
								30.241226
							],
							[
								-85.567703,
								30.241058
							],
							[
								-85.568054,
								30.240804
							]
						]
					],
					[
						[
							[
								-85.563693,
								30.244468000000005
							],
							[
								-85.563614,
								30.244309000000005
							],
							[
								-85.563499,
								30.24439
							],
							[
								-85.56355,
								30.244126
							],
							[
								-85.563583,
								30.243956999999998
							],
							[
								-85.56575,
								30.242454
							],
							[
								-85.565871,
								30.242485
							],
							[
								-85.565859,
								30.242716000000005
							],
							[
								-85.565875,
								30.246353000000003
							],
							[
								-85.565666,
								30.246361
							],
							[
								-85.563783,
								30.246367
							],
							[
								-85.56373,
								30.246331000000005
							],
							[
								-85.563726,
								30.246217000000005
							],
							[
								-85.563725,
								30.244679000000005
							],
							[
								-85.563693,
								30.244468000000005
							]
						]
					],
					[
						[
							[
								-85.560493,
								30.246686
							],
							[
								-85.56104,
								30.246249
							],
							[
								-85.56222,
								30.246267
							],
							[
								-85.562188,
								30.247370000000004
							],
							[
								-85.562193,
								30.247573
							],
							[
								-85.56139,
								30.247461
							],
							[
								-85.560456,
								30.247377
							],
							[
								-85.560462,
								30.247108000000004
							],
							[
								-85.560508,
								30.246957
							],
							[
								-85.560505,
								30.246903
							],
							[
								-85.560493,
								30.246686
							]
						]
					],
					[
						[
							[
								-85.526428,
								30.248293
							],
							[
								-85.524836,
								30.248254
							],
							[
								-85.523676,
								30.248267999999996
							],
							[
								-85.523689,
								30.248111
							],
							[
								-85.523757,
								30.244623
							],
							[
								-85.523757,
								30.240992999999996
							],
							[
								-85.524078,
								30.241022000000005
							],
							[
								-85.52408100000001,
								30.241303000000002
							],
							[
								-85.525535,
								30.241289
							],
							[
								-85.525928,
								30.241285
							],
							[
								-85.526818,
								30.241276000000003
							],
							[
								-85.526815,
								30.241852
							],
							[
								-85.526809,
								30.242946000000003
							],
							[
								-85.526893,
								30.244531
							],
							[
								-85.526908,
								30.245157
							],
							[
								-85.526954,
								30.246689999999997
							],
							[
								-85.526977,
								30.248113
							],
							[
								-85.52697600000002,
								30.248286
							],
							[
								-85.526428,
								30.248293
							]
						]
					],
					[
						[
							[
								-85.55258,
								30.251272
							],
							[
								-85.552609,
								30.248243
							],
							[
								-85.554412,
								30.248258000000003
							],
							[
								-85.55440500000002,
								30.249904000000004
							],
							[
								-85.55258,
								30.251272
							]
						]
					],
					[
						[
							[
								-85.531549,
								30.248112
							],
							[
								-85.533119,
								30.248107000000005
							],
							[
								-85.533836,
								30.248109
							],
							[
								-85.53437,
								30.248113
							],
							[
								-85.534585,
								30.248113999999998
							],
							[
								-85.534577,
								30.250059
							],
							[
								-85.534575,
								30.250674999999998
							],
							[
								-85.534572,
								30.251338
							],
							[
								-85.534102,
								30.251342
							],
							[
								-85.532409,
								30.251351
							],
							[
								-85.531631,
								30.251349000000005
							],
							[
								-85.531603,
								30.250260999999995
							],
							[
								-85.531554,
								30.248326
							],
							[
								-85.531549,
								30.248112
							]
						]
					],
					[
						[
							[
								-85.552398,
								30.25225
							],
							[
								-85.554916,
								30.250467000000004
							],
							[
								-85.554788,
								30.250328
							],
							[
								-85.554733,
								30.250267
							],
							[
								-85.55704400000002,
								30.248601000000004
							],
							[
								-85.55708900000002,
								30.248693
							],
							[
								-85.557174,
								30.24887
							],
							[
								-85.557204,
								30.24902
							],
							[
								-85.557251,
								30.24898
							],
							[
								-85.558233,
								30.248267
							],
							[
								-85.558276,
								30.248297000000004
							],
							[
								-85.558385,
								30.248359
							],
							[
								-85.558602,
								30.248408000000005
							],
							[
								-85.558977,
								30.248416
							],
							[
								-85.558977,
								30.248860000000004
							],
							[
								-85.55925700000002,
								30.248886
							],
							[
								-85.55929,
								30.249197
							],
							[
								-85.55900100000001,
								30.249203999999995
							],
							[
								-85.559009,
								30.25012
							],
							[
								-85.558255,
								30.250135
							],
							[
								-85.557868,
								30.250148000000003
							],
							[
								-85.557851,
								30.250693
							],
							[
								-85.557842,
								30.250965
							],
							[
								-85.557838,
								30.251071
							],
							[
								-85.557182,
								30.251226000000003
							],
							[
								-85.556968,
								30.251312
							],
							[
								-85.55696200000001,
								30.251084
							],
							[
								-85.556589,
								30.251057000000003
							],
							[
								-85.55657300000001,
								30.250666000000002
							],
							[
								-85.55601200000001,
								30.251017
							],
							[
								-85.556502,
								30.251599000000002
							],
							[
								-85.556574,
								30.251654000000002
							],
							[
								-85.55657300000001,
								30.251772
							],
							[
								-85.556572,
								30.252222000000003
							],
							[
								-85.555572,
								30.252212999999998
							],
							[
								-85.552398,
								30.25225
							]
						]
					],
					[
						[
							[
								-85.544746,
								30.255842000000005
							],
							[
								-85.545631,
								30.254993
							],
							[
								-85.545944,
								30.25489
							],
							[
								-85.546051,
								30.25489
							],
							[
								-85.546127,
								30.254953
							],
							[
								-85.546272,
								30.255161
							],
							[
								-85.546417,
								30.255203
							],
							[
								-85.546951,
								30.25513
							],
							[
								-85.546752,
								30.254602
							],
							[
								-85.547088,
								30.254461
							],
							[
								-85.546752,
								30.253852
							],
							[
								-85.548469,
								30.253711
							],
							[
								-85.548667,
								30.253156
							],
							[
								-85.548896,
								30.253149000000004
							],
							[
								-85.549247,
								30.253255000000003
							],
							[
								-85.549095,
								30.251496999999997
							],
							[
								-85.550964,
								30.251563999999995
							],
							[
								-85.550964,
								30.251351
							],
							[
								-85.551962,
								30.251351
							],
							[
								-85.551967,
								30.251559
							],
							[
								-85.551972,
								30.251744000000002
							],
							[
								-85.551765,
								30.251905
							],
							[
								-85.550125,
								30.253013
							],
							[
								-85.547447,
								30.255105000000004
							],
							[
								-85.546516,
								30.255704000000005
							],
							[
								-85.545196,
								30.256547000000005
							],
							[
								-85.544944,
								30.256372
							],
							[
								-85.544853,
								30.256233000000005
							],
							[
								-85.544807,
								30.256025
							],
							[
								-85.544746,
								30.255842000000005
							]
						]
					],
					[
						[
							[
								-85.545478,
								30.257330000000003
							],
							[
								-85.546129,
								30.256833000000004
							],
							[
								-85.546516,
								30.257404000000005
							],
							[
								-85.545928,
								30.257831
							],
							[
								-85.54574500000001,
								30.257608
							],
							[
								-85.545555,
								30.257425000000005
							],
							[
								-85.545478,
								30.257330000000003
							]
						]
					],
					[
						[
							[
								-85.645759,
								30.190874
							],
							[
								-85.646453,
								30.190887
							],
							[
								-85.646736,
								30.190884999999998
							],
							[
								-85.646736,
								30.191280000000003
							],
							[
								-85.646759,
								30.191726
							],
							[
								-85.646755,
								30.192191000000005
							],
							[
								-85.646691,
								30.192194000000004
							],
							[
								-85.646287,
								30.192209999999996
							],
							[
								-85.646308,
								30.193162
							],
							[
								-85.647262,
								30.193162
							],
							[
								-85.647259,
								30.192245000000003
							],
							[
								-85.647259,
								30.192203
							],
							[
								-85.647232,
								30.192111
							],
							[
								-85.647216,
								30.191722000000002
							],
							[
								-85.647209,
								30.191276
							],
							[
								-85.647117,
								30.191278
							],
							[
								-85.647117,
								30.19108
							],
							[
								-85.647361,
								30.191076
							],
							[
								-85.647369,
								30.191273999999996
							],
							[
								-85.64768200000002,
								30.191270000000003
							],
							[
								-85.64768200000002,
								30.191705
							],
							[
								-85.6477,
								30.192195
							],
							[
								-85.647706,
								30.192244
							],
							[
								-85.647827,
								30.193162
							],
							[
								-85.64781100000002,
								30.194015000000004
							],
							[
								-85.647789,
								30.194799
							],
							[
								-85.647743,
								30.196474999999996
							],
							[
								-85.647743,
								30.196775
							],
							[
								-85.645568,
								30.196771
							],
							[
								-85.644737,
								30.196802000000005
							],
							[
								-85.643646,
								30.196865999999996
							],
							[
								-85.643638,
								30.197227
							],
							[
								-85.643632,
								30.198577999999998
							],
							[
								-85.643623,
								30.200491
							],
							[
								-85.64361600000001,
								30.202053
							],
							[
								-85.642097,
								30.202070000000003
							],
							[
								-85.642097,
								30.202192
							],
							[
								-85.641942,
								30.203862
							],
							[
								-85.641931,
								30.204019
							],
							[
								-85.64088779799994,
								30.204039668000064
							],
							[
								-85.640013,
								30.204056999999995
							],
							[
								-85.638233,
								30.204079999999998
							],
							[
								-85.63810100000002,
								30.204338
							],
							[
								-85.636754,
								30.204373
							],
							[
								-85.635808,
								30.204319
							],
							[
								-85.634678,
								30.204308000000005
							],
							[
								-85.633788,
								30.204336999999995
							],
							[
								-85.633322,
								30.204330000000002
							],
							[
								-85.633139,
								30.204317
							],
							[
								-85.632528,
								30.204112
							],
							[
								-85.63208,
								30.203971
							],
							[
								-85.628954,
								30.204020000000003
							],
							[
								-85.62895405499995,
								30.20410410300008
							],
							[
								-85.628173,
								30.204050000000002
							],
							[
								-85.626991,
								30.203987
							],
							[
								-85.626991,
								30.205115999999997
							],
							[
								-85.626979,
								30.205344000000004
							],
							[
								-85.62697600000001,
								30.2054
							],
							[
								-85.626922,
								30.206161
							],
							[
								-85.62692,
								30.206375
							],
							[
								-85.626916,
								30.206685
							],
							[
								-85.625357,
								30.20668
							],
							[
								-85.625053,
								30.206060000000004
							],
							[
								-85.62498400000001,
								30.205892000000002
							],
							[
								-85.624885,
								30.205568
							],
							[
								-85.624876,
								30.205523
							],
							[
								-85.624839,
								30.205332999999996
							],
							[
								-85.62476100000002,
								30.205334999999998
							],
							[
								-85.624485,
								30.205342
							],
							[
								-85.624457,
								30.207574000000005
							],
							[
								-85.623757,
								30.207562999999997
							],
							[
								-85.622472,
								30.207535000000004
							],
							[
								-85.622477,
								30.206369
							],
							[
								-85.620372,
								30.206388000000004
							],
							[
								-85.618053,
								30.206371
							],
							[
								-85.618067,
								30.206726000000003
							],
							[
								-85.61808,
								30.207057000000002
							],
							[
								-85.616437,
								30.206925000000002
							],
							[
								-85.61614200000001,
								30.206901000000002
							],
							[
								-85.615898,
								30.206894999999996
							],
							[
								-85.61559335899994,
								30.20656468200008
							],
							[
								-85.615348,
								30.206782999999998
							],
							[
								-85.61463075399996,
								30.207334115000037
							],
							[
								-85.614837,
								30.207645
							],
							[
								-85.61488300000002,
								30.207813
							],
							[
								-85.61488700000001,
								30.208036
							],
							[
								-85.614959,
								30.211589000000004
							],
							[
								-85.615804,
								30.211541000000004
							],
							[
								-85.615801,
								30.210697
							],
							[
								-85.615948,
								30.210699
							],
							[
								-85.618101,
								30.210736
							],
							[
								-85.618106,
								30.211546
							],
							[
								-85.618105,
								30.211556000000005
							],
							[
								-85.618252,
								30.216576999999997
							],
							[
								-85.617622,
								30.216622999999995
							],
							[
								-85.615955,
								30.216632
							],
							[
								-85.615684,
								30.216735
							],
							[
								-85.615684,
								30.216854
							],
							[
								-85.61573,
								30.217157
							],
							[
								-85.615699,
								30.21858
							],
							[
								-85.615394,
								30.218641000000005
							],
							[
								-85.615187,
								30.218624000000002
							],
							[
								-85.613109,
								30.218458
							],
							[
								-85.612223,
								30.218387
							],
							[
								-85.610893,
								30.218418
							],
							[
								-85.610851,
								30.218421
							],
							[
								-85.610755,
								30.218429
							],
							[
								-85.609725,
								30.218429
							],
							[
								-85.608551,
								30.218477
							],
							[
								-85.607513,
								30.218477
							],
							[
								-85.60735100000001,
								30.218475000000005
							],
							[
								-85.607322,
								30.2201
							],
							[
								-85.607276,
								30.222332
							],
							[
								-85.60614,
								30.222326000000002
							],
							[
								-85.60604,
								30.222276
							],
							[
								-85.60601,
								30.222186999999998
							],
							[
								-85.606018,
								30.221904
							],
							[
								-85.605453,
								30.222198
							],
							[
								-85.605842,
								30.222698000000005
							],
							[
								-85.60585,
								30.223376999999996
							],
							[
								-85.607269,
								30.223649000000005
							],
							[
								-85.607246,
								30.224363000000004
							],
							[
								-85.609062,
								30.224525
							],
							[
								-85.609054,
								30.225109
							],
							[
								-85.60860400000001,
								30.225084
							],
							[
								-85.607215,
								30.225143000000003
							],
							[
								-85.607215,
								30.225866
							],
							[
								-85.605903,
								30.225873
							],
							[
								-85.605155,
								30.225856000000004
							],
							[
								-85.605201,
								30.224479
							],
							[
								-85.605201,
								30.224332
							],
							[
								-85.60279,
								30.224323
							],
							[
								-85.602737,
								30.225809
							],
							[
								-85.602561,
								30.225804999999998
							],
							[
								-85.602447,
								30.225816
							],
							[
								-85.602378,
								30.225843
							],
							[
								-85.601406,
								30.22596
							],
							[
								-85.601226,
								30.225982
							],
							[
								-85.59967,
								30.225915
							],
							[
								-85.598968,
								30.225898000000004
							],
							[
								-85.598915,
								30.227054000000003
							],
							[
								-85.598884,
								30.228183
							],
							[
								-85.598976,
								30.228755000000003
							],
							[
								-85.598464,
								30.231743999999996
							],
							[
								-85.598281,
								30.231847
							],
							[
								-85.598106,
								30.231992000000005
							],
							[
								-85.598045,
								30.232074000000004
							],
							[
								-85.597976,
								30.232269
							],
							[
								-85.597976,
								30.232364
							],
							[
								-85.598007,
								30.232456
							],
							[
								-85.598068,
								30.232559000000002
							],
							[
								-85.598213,
								30.232711
							],
							[
								-85.598251,
								30.232770000000002
							],
							[
								-85.598304,
								30.232992000000003
							],
							[
								-85.598289,
								30.233242000000004
							],
							[
								-85.595269,
								30.233236999999995
							],
							[
								-85.594802,
								30.233235999999998
							],
							[
								-85.59478700000001,
								30.231452
							],
							[
								-85.59478700000001,
								30.231302
							],
							[
								-85.594795,
								30.230857
							],
							[
								-85.59477900000002,
								30.229936
							],
							[
								-85.594741,
								30.229573999999996
							],
							[
								-85.596224,
								30.229764
							],
							[
								-85.596287,
								30.229281000000004
							],
							[
								-85.596287,
								30.22887
							],
							[
								-85.595702,
								30.22887
							],
							[
								-85.594757,
								30.228640999999996
							],
							[
								-85.594764,
								30.228118
							],
							[
								-85.594772,
								30.227243000000005
							],
							[
								-85.59477900000002,
								30.22636
							],
							[
								-85.594795,
								30.225852
							],
							[
								-85.594795,
								30.225431000000004
							],
							[
								-85.594802,
								30.224555
							],
							[
								-85.592758,
								30.224395
							],
							[
								-85.592773,
								30.224937
							],
							[
								-85.592758,
								30.225301
							],
							[
								-85.592727,
								30.225757
							],
							[
								-85.590576,
								30.225751000000002
							],
							[
								-85.590591,
								30.226303
							],
							[
								-85.590583,
								30.227228000000004
							],
							[
								-85.590576,
								30.228107000000005
							],
							[
								-85.588845,
								30.228098
							],
							[
								-85.588847,
								30.229118
							],
							[
								-85.588844,
								30.229602
							],
							[
								-85.588478,
								30.229592
							],
							[
								-85.588372,
								30.226940000000003
							],
							[
								-85.587575,
								30.227548000000002
							],
							[
								-85.588292,
								30.229585000000004
							],
							[
								-85.587432,
								30.229681999999997
							],
							[
								-85.586982,
								30.229692
							],
							[
								-85.586859,
								30.229737
							],
							[
								-85.586354,
								30.229679
							],
							[
								-85.586353,
								30.230527999999996
							],
							[
								-85.586365,
								30.231106
							],
							[
								-85.586334,
								30.23336
							],
							[
								-85.5863,
								30.236434
							],
							[
								-85.586328,
								30.237287
							],
							[
								-85.586561,
								30.237299000000004
							],
							[
								-85.588822,
								30.237224000000005
							],
							[
								-85.590413,
								30.237188000000003
							],
							[
								-85.59040800000001,
								30.239309
							],
							[
								-85.590339,
								30.242685
							],
							[
								-85.590362,
								30.244043
							],
							[
								-85.590332,
								30.245189
							],
							[
								-85.59032400000001,
								30.248048
							],
							[
								-85.590339,
								30.249689
							],
							[
								-85.590286,
								30.253259
							],
							[
								-85.590339,
								30.257015
							],
							[
								-85.590332,
								30.257135
							],
							[
								-85.590397,
								30.258190999999997
							],
							[
								-85.590254,
								30.258365999999995
							],
							[
								-85.590155,
								30.258521
							],
							[
								-85.589835,
								30.258693000000005
							],
							[
								-85.589436,
								30.258917
							],
							[
								-85.589168,
								30.259059
							],
							[
								-85.588973,
								30.258895000000003
							],
							[
								-85.588897,
								30.258857
							],
							[
								-85.588699,
								30.258831000000004
							],
							[
								-85.58863,
								30.258876000000004
							],
							[
								-85.5886,
								30.258973999999995
							],
							[
								-85.588562,
								30.259033
							],
							[
								-85.588493,
								30.259071
							],
							[
								-85.588417,
								30.259029
							],
							[
								-85.588356,
								30.258951
							],
							[
								-85.588134,
								30.258756000000005
							],
							[
								-85.588035,
								30.258722
							],
							[
								-85.587974,
								30.258682
							],
							[
								-85.587776,
								30.258398000000003
							],
							[
								-85.587715,
								30.258343999999997
							],
							[
								-85.587615,
								30.258274999999998
							],
							[
								-85.587539,
								30.258253
							],
							[
								-85.587371,
								30.258268000000005
							],
							[
								-85.587226,
								30.258337
							],
							[
								-85.587074,
								30.258375
							],
							[
								-85.586906,
								30.25846
							],
							[
								-85.58686,
								30.258544
							],
							[
								-85.586853,
								30.258762000000004
							],
							[
								-85.586746,
								30.258829000000002
							],
							[
								-85.586717,
								30.258815
							],
							[
								-85.586692,
								30.258804000000005
							],
							[
								-85.58669465499997,
								30.258669240000074
							],
							[
								-85.585884,
								30.258060999999998
							],
							[
								-85.58448820499996,
								30.256607686000056
							],
							[
								-85.584365,
								30.256626
							],
							[
								-85.584259,
								30.256626
							],
							[
								-85.584182,
								30.256607999999996
							],
							[
								-85.584121,
								30.256568000000005
							],
							[
								-85.584045,
								30.256469000000003
							],
							[
								-85.583801,
								30.256282
							],
							[
								-85.583724,
								30.256258
							],
							[
								-85.583457,
								30.256227
							],
							[
								-85.583297,
								30.256155
							],
							[
								-85.583267,
								30.256084
							],
							[
								-85.583328,
								30.255838
							],
							[
								-85.58325900000001,
								30.255779000000004
							],
							[
								-85.583114,
								30.255848999999998
							],
							[
								-85.582962,
								30.255968
							],
							[
								-85.582672,
								30.256267000000005
							],
							[
								-85.582572,
								30.256343
							],
							[
								-85.582183,
								30.256504
							],
							[
								-85.581893,
								30.256568000000005
							],
							[
								-85.581832,
								30.256601000000003
							],
							[
								-85.581794,
								30.256715
							],
							[
								-85.578463,
								30.255448000000005
							],
							[
								-85.578422,
								30.254334
							],
							[
								-85.578287,
								30.254338000000004
							],
							[
								-85.577314,
								30.254375
							],
							[
								-85.577295,
								30.253769
							],
							[
								-85.578267,
								30.253727999999995
							],
							[
								-85.578402,
								30.253725
							],
							[
								-85.578382,
								30.253131000000003
							],
							[
								-85.578313,
								30.250084
							],
							[
								-85.578544,
								30.250083
							],
							[
								-85.578782,
								30.250060000000005
							],
							[
								-85.578862,
								30.249952000000004
							],
							[
								-85.578512,
								30.249712000000002
							],
							[
								-85.578507,
								30.249693
							],
							[
								-85.57844400000002,
								30.24947
							],
							[
								-85.578284,
								30.248881000000004
							],
							[
								-85.578258,
								30.248619000000005
							],
							[
								-85.578228,
								30.248227
							],
							[
								-85.578216,
								30.248063000000002
							],
							[
								-85.57801800000001,
								30.241441000000002
							],
							[
								-85.577888,
								30.235779000000004
							],
							[
								-85.580219,
								30.235645
							],
							[
								-85.580168,
								30.233714
							],
							[
								-85.58165,
								30.233662
							],
							[
								-85.583133,
								30.233609000000005
							],
							[
								-85.583857,
								30.233587
							],
							[
								-85.583841,
								30.233449
							],
							[
								-85.583792,
								30.231987000000004
							],
							[
								-85.581985,
								30.232043
							],
							[
								-85.581974,
								30.232806000000004
							],
							[
								-85.581619,
								30.232843
							],
							[
								-85.581643,
								30.233435000000004
							],
							[
								-85.58148,
								30.233445
							],
							[
								-85.580166,
								30.233503
							],
							[
								-85.579443,
								30.233512
							],
							[
								-85.579299,
								30.233505
							],
							[
								-85.579211,
								30.233433
							],
							[
								-85.57939,
								30.233313
							],
							[
								-85.581655,
								30.231702000000002
							],
							[
								-85.581649,
								30.231554000000003
							],
							[
								-85.581534,
								30.231408
							],
							[
								-85.58144300000001,
								30.231294
							],
							[
								-85.581336,
								30.231088
							],
							[
								-85.57801800000001,
								30.233337
							],
							[
								-85.577606,
								30.233629
							],
							[
								-85.57424900000001,
								30.235941999999998
							],
							[
								-85.572364,
								30.237308
							],
							[
								-85.569717,
								30.239086
							],
							[
								-85.567497,
								30.240758000000003
							],
							[
								-85.56450600000001,
								30.242659999999997
							],
							[
								-85.562438,
								30.244131
							],
							[
								-85.560287,
								30.246002
							],
							[
								-85.556747,
								30.248279000000004
							],
							[
								-85.555938,
								30.248745999999997
							],
							[
								-85.555915,
								30.248270999999995
							],
							[
								-85.55519100000001,
								30.248266
							],
							[
								-85.55518300000001,
								30.247735000000002
							],
							[
								-85.556724,
								30.247718
							],
							[
								-85.556732,
								30.24703
							],
							[
								-85.556739,
								30.245815
							],
							[
								-85.556724,
								30.243598
							],
							[
								-85.556755,
								30.241928000000005
							],
							[
								-85.554598,
								30.241964
							],
							[
								-85.554664,
								30.240852
							],
							[
								-85.55677,
								30.240869000000004
							],
							[
								-85.556773,
								30.240226
							],
							[
								-85.556773,
								30.239992
							],
							[
								-85.556777,
								30.239120000000003
							],
							[
								-85.556847,
								30.239120000000003
							],
							[
								-85.556838,
								30.238839
							],
							[
								-85.557894,
								30.238862
							],
							[
								-85.557885,
								30.238311000000003
							],
							[
								-85.556911,
								30.238304
							],
							[
								-85.556902,
								30.23728
							],
							[
								-85.558578,
								30.237304
							],
							[
								-85.561016,
								30.237276
							],
							[
								-85.560974,
								30.237018
							],
							[
								-85.560951,
								30.236606
							],
							[
								-85.560951,
								30.236124
							],
							[
								-85.560981,
								30.235563000000003
							],
							[
								-85.560978,
								30.23555
							],
							[
								-85.560981,
								30.23549
							],
							[
								-85.560917,
								30.23536
							],
							[
								-85.559977,
								30.235399
							],
							[
								-85.559977,
								30.234840999999996
							],
							[
								-85.559995,
								30.234038
							],
							[
								-85.561019,
								30.234036999999997
							],
							[
								-85.56216200000001,
								30.234038
							],
							[
								-85.562255,
								30.235507
							],
							[
								-85.563659,
								30.235525
							],
							[
								-85.563957,
								30.235528
							],
							[
								-85.56450600000001,
								30.235532
							],
							[
								-85.56487,
								30.235534
							],
							[
								-85.56487,
								30.234000000000005
							],
							[
								-85.565832,
								30.234026
							],
							[
								-85.565817,
								30.235541000000005
							],
							[
								-85.567276,
								30.235550999999997
							],
							[
								-85.567329,
								30.23693
							],
							[
								-85.568783,
								30.236973
							],
							[
								-85.56885,
								30.235562000000005
							],
							[
								-85.56882,
								30.234756000000004
							],
							[
								-85.567257,
								30.234743000000005
							],
							[
								-85.567192,
								30.232425
							],
							[
								-85.567131,
								30.2317
							],
							[
								-85.567108,
								30.231546
							],
							[
								-85.56723,
								30.222819999999995
							],
							[
								-85.57437800000001,
								30.223114000000002
							],
							[
								-85.590629,
								30.222944
							],
							[
								-85.591214,
								30.222916
							],
							[
								-85.591484,
								30.222916
							],
							[
								-85.591486,
								30.222227
							],
							[
								-85.591456,
								30.222180000000005
							],
							[
								-85.591335,
								30.222165999999998
							],
							[
								-85.591207,
								30.222158
							],
							[
								-85.590623,
								30.222158
							],
							[
								-85.590621,
								30.221946
							],
							[
								-85.590632,
								30.221058999999997
							],
							[
								-85.591198,
								30.221047000000002
							],
							[
								-85.592739,
								30.221013000000003
							],
							[
								-85.592742,
								30.220598000000003
							],
							[
								-85.592773,
								30.219886
							],
							[
								-85.592793,
								30.219436999999996
							],
							[
								-85.59278700000002,
								30.218524
							],
							[
								-85.592811,
								30.218524
							],
							[
								-85.593269,
								30.218523
							],
							[
								-85.593365,
								30.218535
							],
							[
								-85.593376,
								30.218536000000004
							],
							[
								-85.59404800000002,
								30.218545
							],
							[
								-85.594222,
								30.218545
							],
							[
								-85.596112,
								30.218536000000004
							],
							[
								-85.596227,
								30.218545999999996
							],
							[
								-85.596325,
								30.218554000000005
							],
							[
								-85.596614,
								30.218545
							],
							[
								-85.596857,
								30.218548999999996
							],
							[
								-85.596839,
								30.218111
							],
							[
								-85.596817,
								30.217865000000003
							],
							[
								-85.596832,
								30.217691000000002
							],
							[
								-85.596752,
								30.215800999999995
							],
							[
								-85.596692,
								30.214861000000003
							],
							[
								-85.596686,
								30.214516
							],
							[
								-85.599216,
								30.214494
							],
							[
								-85.599235,
								30.21318
							],
							[
								-85.599136,
								30.213153
							],
							[
								-85.599014,
								30.213070999999996
							],
							[
								-85.598992,
								30.213062
							],
							[
								-85.596658,
								30.213029000000002
							],
							[
								-85.594758,
								30.213051
							],
							[
								-85.594764,
								30.212110000000003
							],
							[
								-85.59379200000001,
								30.212071999999996
							],
							[
								-85.593789,
								30.211274000000003
							],
							[
								-85.592799,
								30.211254
							],
							[
								-85.592286,
								30.211251
							],
							[
								-85.590766,
								30.211232000000003
							],
							[
								-85.589049,
								30.211195000000004
							],
							[
								-85.588569,
								30.21118
							],
							[
								-85.588577,
								30.210393
							],
							[
								-85.588566,
								30.208736
							],
							[
								-85.588547,
								30.208362
							],
							[
								-85.58818,
								30.208364
							],
							[
								-85.586112,
								30.208411999999996
							],
							[
								-85.586135,
								30.21068
							],
							[
								-85.586135,
								30.211173
							],
							[
								-85.585245,
								30.211175
							],
							[
								-85.584273,
								30.211136
							],
							[
								-85.584365,
								30.205681999999996
							],
							[
								-85.584358,
								30.204639
							],
							[
								-85.588428,
								30.204618999999997
							],
							[
								-85.590724,
								30.204592
							],
							[
								-85.590732,
								30.204101999999995
							],
							[
								-85.591503,
								30.204095000000002
							],
							[
								-85.594017,
								30.204079
							],
							[
								-85.59867,
								30.204055999999998
							],
							[
								-85.602071,
								30.20404
							],
							[
								-85.603261,
								30.204034999999998
							],
							[
								-85.603183,
								30.208435000000005
							],
							[
								-85.601669,
								30.208446
							],
							[
								-85.600775,
								30.208429999999996
							],
							[
								-85.600807,
								30.20853
							],
							[
								-85.601829,
								30.208526000000003
							],
							[
								-85.603317,
								30.208555000000004
							],
							[
								-85.603324,
								30.209877000000002
							],
							[
								-85.603309,
								30.210416000000002
							],
							[
								-85.603298,
								30.210823
							],
							[
								-85.60384400000001,
								30.210834999999996
							],
							[
								-85.603976,
								30.210939000000003
							],
							[
								-85.603992,
								30.211275
							],
							[
								-85.604133,
								30.211275
							],
							[
								-85.604232,
								30.211263
							],
							[
								-85.604331,
								30.211217
							],
							[
								-85.604736,
								30.211159999999996
							],
							[
								-85.605199,
								30.211185
							],
							[
								-85.605218,
								30.211986
							],
							[
								-85.607551,
								30.212001
							],
							[
								-85.607696,
								30.207233
							],
							[
								-85.607719,
								30.205566000000005
							],
							[
								-85.607742,
								30.204084
							],
							[
								-85.607749,
								30.203117000000002
							],
							[
								-85.607757,
								30.202272
							],
							[
								-85.607765,
								30.202062
							],
							[
								-85.608337,
								30.20206
							],
							[
								-85.610252,
								30.202104
							],
							[
								-85.613906,
								30.202175000000004
							],
							[
								-85.613944,
								30.204048
							],
							[
								-85.613945,
								30.204082
							],
							[
								-85.618476,
								30.204193
							],
							[
								-85.618476,
								30.203908
							],
							[
								-85.619812,
								30.203310000000002
							],
							[
								-85.619956,
								30.203809000000003
							],
							[
								-85.62006952499996,
								30.20395143600007
							],
							[
								-85.62021600000001,
								30.203844
							],
							[
								-85.624908,
								30.200561000000004
							],
							[
								-85.625205,
								30.200347
							],
							[
								-85.62503,
								30.200283
							],
							[
								-85.625038,
								30.200189
							],
							[
								-85.625051,
								30.200098000000004
							],
							[
								-85.62506600000002,
								30.198769
							],
							[
								-85.625213,
								30.198766
							],
							[
								-85.625167,
								30.197885
							],
							[
								-85.62506600000002,
								30.19789
							],
							[
								-85.62506600000002,
								30.197656
							],
							[
								-85.625972,
								30.197656
							],
							[
								-85.62603,
								30.197658
							],
							[
								-85.626035,
								30.197036
							],
							[
								-85.627242,
								30.197039999999998
							],
							[
								-85.62826,
								30.197072
							],
							[
								-85.628281,
								30.196686
							],
							[
								-85.627126,
								30.196694999999995
							],
							[
								-85.627115,
								30.195907
							],
							[
								-85.627146,
								30.195636
							],
							[
								-85.62746,
								30.195627
							],
							[
								-85.627489,
								30.195258999999997
							],
							[
								-85.627102,
								30.195273000000004
							],
							[
								-85.625983,
								30.195294000000004
							],
							[
								-85.625417,
								30.195275
							],
							[
								-85.625188,
								30.195272
							],
							[
								-85.625089,
								30.195276000000003
							],
							[
								-85.624946,
								30.195132999999995
							],
							[
								-85.624816,
								30.195129999999995
							],
							[
								-85.624821,
								30.193495000000002
							],
							[
								-85.624954,
								30.193496
							],
							[
								-85.624954,
								30.193222
							],
							[
								-85.624832,
								30.193186
							],
							[
								-85.624832,
								30.193131
							],
							[
								-85.624817,
								30.191443
							],
							[
								-85.624817,
								30.190832
							],
							[
								-85.62419800000002,
								30.190840999999995
							],
							[
								-85.623949,
								30.190866
							],
							[
								-85.623948,
								30.190653000000005
							],
							[
								-85.623471,
								30.190653000000005
							],
							[
								-85.623491,
								30.191303000000005
							],
							[
								-85.623108,
								30.191303000000005
							],
							[
								-85.623094,
								30.189352
							],
							[
								-85.62177400000002,
								30.189325
							],
							[
								-85.619781,
								30.189285
							],
							[
								-85.616725,
								30.189241999999997
							],
							[
								-85.616018,
								30.189238
							],
							[
								-85.615486,
								30.18922
							],
							[
								-85.611636,
								30.189309
							],
							[
								-85.610314,
								30.189333
							],
							[
								-85.610282,
								30.187703999999997
							],
							[
								-85.610244,
								30.185794
							],
							[
								-85.610168,
								30.182026999999998
							],
							[
								-85.610176,
								30.180709000000004
							],
							[
								-85.610167,
								30.180576
							],
							[
								-85.610139,
								30.176683
							],
							[
								-85.612267,
								30.176691
							],
							[
								-85.612267,
								30.177765000000004
							],
							[
								-85.614797,
								30.177765000000004
							],
							[
								-85.614784,
								30.174972000000004
							],
							[
								-85.61576,
								30.174970000000002
							],
							[
								-85.616523,
								30.174968
							],
							[
								-85.616485,
								30.174827000000004
							],
							[
								-85.616455,
								30.173004000000002
							],
							[
								-85.616477,
								30.168502
							],
							[
								-85.616485,
								30.167608
							],
							[
								-85.616485,
								30.167458
							],
							[
								-85.620748,
								30.167468999999997
							],
							[
								-85.620895,
								30.167601999999995
							],
							[
								-85.623481,
								30.167608
							],
							[
								-85.625076,
								30.167615
							],
							[
								-85.627151,
								30.167627
							],
							[
								-85.628204,
								30.167633
							],
							[
								-85.629249,
								30.167642
							],
							[
								-85.63018000000001,
								30.167650000000002
							],
							[
								-85.631256,
								30.167657
							],
							[
								-85.632408,
								30.167666
							],
							[
								-85.63311,
								30.167671000000002
							],
							[
								-85.633407,
								30.168563
							],
							[
								-85.633399,
								30.171312000000004
							],
							[
								-85.633369,
								30.17494
							],
							[
								-85.635467,
								30.174963999999996
							],
							[
								-85.635772,
								30.174968
							],
							[
								-85.63755,
								30.174984999999996
							],
							[
								-85.63963,
								30.174996000000004
							],
							[
								-85.639636,
								30.176593
							],
							[
								-85.639833,
								30.178484000000005
							],
							[
								-85.639823,
								30.178541
							],
							[
								-85.63949500000001,
								30.178337000000003
							],
							[
								-85.63949500000001,
								30.178477
							],
							[
								-85.63949500000001,
								30.178713999999996
							],
							[
								-85.639543,
								30.179535999999995
							],
							[
								-85.639614,
								30.180742000000002
							],
							[
								-85.641891,
								30.18081
							],
							[
								-85.641991,
								30.180806
							],
							[
								-85.64191900000002,
								30.182373
							],
							[
								-85.641918,
								30.18251
							],
							[
								-85.641915,
								30.183270000000004
							],
							[
								-85.641845,
								30.183277
							],
							[
								-85.64005800000001,
								30.183260999999998
							],
							[
								-85.640036,
								30.183616000000004
							],
							[
								-85.64005800000001,
								30.185018
							],
							[
								-85.641784,
								30.184955
							],
							[
								-85.641781,
								30.185369
							],
							[
								-85.641778,
								30.185795
							],
							[
								-85.64289,
								30.185791
							],
							[
								-85.644607,
								30.185787
							],
							[
								-85.64447,
								30.185966
							],
							[
								-85.642379,
								30.187717
							],
							[
								-85.642097,
								30.187929000000004
							],
							[
								-85.641278,
								30.188485
							],
							[
								-85.64115,
								30.188572
							],
							[
								-85.64035,
								30.189115000000005
							],
							[
								-85.640174,
								30.189311000000004
							],
							[
								-85.63959028799997,
								30.189730979000046
							],
							[
								-85.639671,
								30.189976999999995
							],
							[
								-85.639709,
								30.190223000000003
							],
							[
								-85.639389,
								30.190562999999997
							],
							[
								-85.639488,
								30.190633000000002
							],
							[
								-85.640007,
								30.190430999999997
							],
							[
								-85.640007,
								30.190631
							],
							[
								-85.640007,
								30.19071
							],
							[
								-85.639488,
								30.191032000000003
							],
							[
								-85.639488,
								30.191280000000003
							],
							[
								-85.639457,
								30.192173000000004
							],
							[
								-85.64093,
								30.192184
							],
							[
								-85.640983,
								30.19177
							],
							[
								-85.641189,
								30.191766000000005
							],
							[
								-85.64114300000001,
								30.192184
							],
							[
								-85.64154,
								30.192184
							],
							[
								-85.641555,
								30.191307000000002
							],
							[
								-85.641563,
								30.190847
							],
							[
								-85.641563,
								30.190689
							],
							[
								-85.641564,
								30.190668999999996
							],
							[
								-85.642636,
								30.190659000000004
							],
							[
								-85.644423,
								30.190649
							],
							[
								-85.644426,
								30.190864999999995
							],
							[
								-85.644428,
								30.190983
							],
							[
								-85.644817,
								30.190974
							],
							[
								-85.644817,
								30.191285000000004
							],
							[
								-85.645751,
								30.191284
							],
							[
								-85.645759,
								30.190874
							]
						]
					],
					[
						[
							[
								-85.54675,
								30.259507
							],
							[
								-85.548794,
								30.259475
							],
							[
								-85.548812,
								30.260599000000003
							],
							[
								-85.546937,
								30.260640999999996
							],
							[
								-85.546897,
								30.260398
							],
							[
								-85.546829,
								30.260101
							],
							[
								-85.546775,
								30.259960000000003
							],
							[
								-85.546676,
								30.259830000000004
							],
							[
								-85.546684,
								30.259759000000003
							],
							[
								-85.546752,
								30.259577999999998
							],
							[
								-85.54675,
								30.259507
							]
						]
					],
					[
						[
							[
								-85.539352,
								30.261476
							],
							[
								-85.53971,
								30.26122
							],
							[
								-85.53997,
								30.261483999999996
							],
							[
								-85.539604,
								30.261718
							],
							[
								-85.539352,
								30.261476
							]
						]
					],
					[
						[
							[
								-85.530197,
								30.267965
							],
							[
								-85.531745,
								30.266866
							],
							[
								-85.532493,
								30.267532
							],
							[
								-85.533432,
								30.267902
							],
							[
								-85.532066,
								30.269207
							],
							[
								-85.530982,
								30.268789
							],
							[
								-85.530807,
								30.268655
							],
							[
								-85.530197,
								30.267965
							]
						]
					],
					[
						[
							[
								-85.5231,
								30.271479000000003
							],
							[
								-85.523115,
								30.270322999999998
							],
							[
								-85.522483,
								30.270322999999998
							],
							[
								-85.522475,
								30.270322999999998
							],
							[
								-85.522483,
								30.270074
							],
							[
								-85.522488,
								30.269483000000005
							],
							[
								-85.522491,
								30.269115
							],
							[
								-85.522491,
								30.268743000000004
							],
							[
								-85.522496,
								30.266737
							],
							[
								-85.523253,
								30.266751000000003
							],
							[
								-85.523267,
								30.262163000000005
							],
							[
								-85.523867,
								30.262163000000005
							],
							[
								-85.526791,
								30.262165
							],
							[
								-85.528816,
								30.262146
							],
							[
								-85.530563,
								30.262109
							],
							[
								-85.531586,
								30.262145000000004
							],
							[
								-85.531572,
								30.261493
							],
							[
								-85.531555,
								30.260725999999995
							],
							[
								-85.531517,
								30.259386000000003
							],
							[
								-85.53141,
								30.256961
							],
							[
								-85.531381,
								30.255494000000002
							],
							[
								-85.531315,
								30.252231999999996
							],
							[
								-85.531318,
								30.252134000000005
							],
							[
								-85.53144,
								30.252086
							],
							[
								-85.531524,
								30.252014
							],
							[
								-85.531684,
								30.251808
							],
							[
								-85.53170700000001,
								30.251661
							],
							[
								-85.531745,
								30.251604
							],
							[
								-85.531799,
								30.251548000000003
							],
							[
								-85.531867,
								30.251508000000005
							],
							[
								-85.531951,
								30.251508000000005
							],
							[
								-85.532035,
								30.251535
							],
							[
								-85.532279,
								30.251703
							],
							[
								-85.532424,
								30.251827
							],
							[
								-85.532638,
								30.252048000000002
							],
							[
								-85.532737,
								30.252082
							],
							[
								-85.533088,
								30.252077
							],
							[
								-85.533195,
								30.252056
							],
							[
								-85.533447,
								30.251927999999996
							],
							[
								-85.533531,
								30.251908999999998
							],
							[
								-85.533737,
								30.251897000000003
							],
							[
								-85.534156,
								30.251842
							],
							[
								-85.534446,
								30.251783000000003
							],
							[
								-85.534614,
								30.251678000000002
							],
							[
								-85.534667,
								30.251596000000003
							],
							[
								-85.534759,
								30.251517999999997
							],
							[
								-85.534866,
								30.251485000000002
							],
							[
								-85.53495,
								30.251541
							],
							[
								-85.535026,
								30.251567
							],
							[
								-85.53524,
								30.251533000000002
							],
							[
								-85.535438,
								30.251522
							],
							[
								-85.535316,
								30.251464000000002
							],
							[
								-85.535255,
								30.251399
							],
							[
								-85.53527,
								30.251327
							],
							[
								-85.535346,
								30.251226000000003
							],
							[
								-85.535423,
								30.251207000000004
							],
							[
								-85.535507,
								30.251213999999997
							],
							[
								-85.535583,
								30.251241000000004
							],
							[
								-85.53572,
								30.251373000000005
							],
							[
								-85.535781,
								30.251459
							],
							[
								-85.535842,
								30.251499
							],
							[
								-85.536186,
								30.251474
							],
							[
								-85.536468,
								30.25143
							],
							[
								-85.536834,
								30.251565
							],
							[
								-85.537025,
								30.251668
							],
							[
								-85.537345,
								30.251734999999996
							],
							[
								-85.537696,
								30.251764000000005
							],
							[
								-85.537994,
								30.251813000000002
							],
							[
								-85.538291,
								30.251885999999995
							],
							[
								-85.53863500000001,
								30.251943
							],
							[
								-85.539169,
								30.251945000000003
							],
							[
								-85.539329,
								30.251974
							],
							[
								-85.53955,
								30.252038
							],
							[
								-85.539924,
								30.252107
							],
							[
								-85.540084,
								30.252099
							],
							[
								-85.540245,
								30.252058
							],
							[
								-85.54036700000002,
								30.252058
							],
							[
								-85.540527,
								30.252083999999996
							],
							[
								-85.540992,
								30.252096
							],
							[
								-85.541152,
								30.252187
							],
							[
								-85.541183,
								30.252267000000003
							],
							[
								-85.541206,
								30.252664
							],
							[
								-85.54113,
								30.252874
							],
							[
								-85.541114,
								30.25304
							],
							[
								-85.541183,
								30.253058999999997
							],
							[
								-85.541458,
								30.252767000000002
							],
							[
								-85.541618,
								30.252687
							],
							[
								-85.541717,
								30.25266
							],
							[
								-85.541885,
								30.252655000000004
							],
							[
								-85.541961,
								30.252672
							],
							[
								-85.542053,
								30.252716000000003
							],
							[
								-85.542129,
								30.252784
							],
							[
								-85.542152,
								30.252902
							],
							[
								-85.542144,
								30.252975000000003
							],
							[
								-85.542106,
								30.253065000000003
							],
							[
								-85.54216,
								30.253158000000003
							],
							[
								-85.54219,
								30.253416000000005
							],
							[
								-85.542289,
								30.253555
							],
							[
								-85.542427,
								30.253489999999996
							],
							[
								-85.542472,
								30.253421
							],
							[
								-85.54261700000002,
								30.253311
							],
							[
								-85.542785,
								30.253255000000003
							],
							[
								-85.54287700000002,
								30.253265
							],
							[
								-85.542984,
								30.253313
							],
							[
								-85.543106,
								30.253389
							],
							[
								-85.543159,
								30.253442
							],
							[
								-85.543167,
								30.253510999999996
							],
							[
								-85.543136,
								30.253583000000003
							],
							[
								-85.542892,
								30.253864
							],
							[
								-85.542933,
								30.254214000000005
							],
							[
								-85.542946,
								30.254320000000003
							],
							[
								-85.54301600000001,
								30.254915999999998
							],
							[
								-85.543027,
								30.255005999999998
							],
							[
								-85.543217,
								30.255306
							],
							[
								-85.543492,
								30.255413
							],
							[
								-85.544197,
								30.25545
							],
							[
								-85.544311,
								30.255394999999996
							],
							[
								-85.544326,
								30.257139
							],
							[
								-85.543357,
								30.257829000000005
							],
							[
								-85.541,
								30.259508
							],
							[
								-85.540512,
								30.259826
							],
							[
								-85.540229,
								30.260019
							],
							[
								-85.539321,
								30.260634999999997
							],
							[
								-85.538475,
								30.261182000000005
							],
							[
								-85.538116,
								30.261441999999995
							],
							[
								-85.536712,
								30.262510000000002
							],
							[
								-85.536224,
								30.262804
							],
							[
								-85.535919,
								30.262994000000003
							],
							[
								-85.533592,
								30.264650000000003
							],
							[
								-85.532157,
								30.265586000000003
							],
							[
								-85.531982,
								30.265745000000003
							],
							[
								-85.529681,
								30.267444
							],
							[
								-85.527719,
								30.268826
							],
							[
								-85.525848,
								30.270135
							],
							[
								-85.524938,
								30.270803
							],
							[
								-85.52443,
								30.271185
							],
							[
								-85.524406,
								30.27074
							],
							[
								-85.523895,
								30.271099
							],
							[
								-85.523574,
								30.271331000000004
							],
							[
								-85.5231,
								30.271479000000003
							]
						]
					],
					[
						[
							[
								-85.54441,
								30.273605
							],
							[
								-85.544431,
								30.271770999999998
							],
							[
								-85.545054,
								30.271780000000003
							],
							[
								-85.54486,
								30.270235
							],
							[
								-85.544883,
								30.269365999999998
							],
							[
								-85.54489,
								30.269083999999996
							],
							[
								-85.543948,
								30.269029000000003
							],
							[
								-85.543945,
								30.27012
							],
							[
								-85.543945,
								30.270282
							],
							[
								-85.540313,
								30.270106999999996
							],
							[
								-85.540313,
								30.269899000000002
							],
							[
								-85.540298,
								30.269113000000004
							],
							[
								-85.540283,
								30.26814
							],
							[
								-85.540291,
								30.266636
							],
							[
								-85.536064,
								30.266654000000003
							],
							[
								-85.536064,
								30.266165
							],
							[
								-85.540294,
								30.266183
							],
							[
								-85.540306,
								30.264011000000004
							],
							[
								-85.540321,
								30.262861000000004
							],
							[
								-85.54097700000001,
								30.262856000000003
							],
							[
								-85.54097700000001,
								30.261655999999995
							],
							[
								-85.540336,
								30.261566
							],
							[
								-85.540336,
								30.261272000000005
							],
							[
								-85.540306,
								30.261050999999995
							],
							[
								-85.540268,
								30.260981
							],
							[
								-85.54115300000001,
								30.260365
							],
							[
								-85.542304,
								30.259601
							],
							[
								-85.543503,
								30.258736000000003
							],
							[
								-85.543911,
								30.258438
							],
							[
								-85.544047,
								30.258339
							],
							[
								-85.54489,
								30.257723
							],
							[
								-85.54496,
								30.257801
							],
							[
								-85.544929,
								30.257909
							],
							[
								-85.544738,
								30.258094000000003
							],
							[
								-85.544486,
								30.258281000000004
							],
							[
								-85.544349,
								30.258438
							],
							[
								-85.544311,
								30.258668
							],
							[
								-85.544342,
								30.258821
							],
							[
								-85.544441,
								30.25896
							],
							[
								-85.544692,
								30.259128
							],
							[
								-85.544944,
								30.259249999999998
							],
							[
								-85.545173,
								30.259321
							],
							[
								-85.545227,
								30.259372
							],
							[
								-85.54528,
								30.259483
							],
							[
								-85.545501,
								30.259691
							],
							[
								-85.545486,
								30.259775
							],
							[
								-85.545402,
								30.259731
							],
							[
								-85.545318,
								30.259723
							],
							[
								-85.545265,
								30.259811
							],
							[
								-85.545222,
								30.259982
							],
							[
								-85.543691,
								30.260025
							],
							[
								-85.543632,
								30.261798
							],
							[
								-85.54366300000001,
								30.262056
							],
							[
								-85.543807,
								30.262594000000004
							],
							[
								-85.544654,
								30.262569
							],
							[
								-85.544692,
								30.262758
							],
							[
								-85.544692,
								30.262843999999998
							],
							[
								-85.544776,
								30.263039999999997
							],
							[
								-85.54486,
								30.263304999999995
							],
							[
								-85.54487692699996,
								30.263508921000042
							],
							[
								-85.544868,
								30.263811
							],
							[
								-85.544898,
								30.264289
							],
							[
								-85.544944,
								30.264450999999998
							],
							[
								-85.54499,
								30.264829
							],
							[
								-85.54496,
								30.264934
							],
							[
								-85.544776,
								30.265176000000004
							],
							[
								-85.544731,
								30.265383999999997
							],
							[
								-85.544723,
								30.265497
							],
							[
								-85.544692,
								30.265588000000005
							],
							[
								-85.544616,
								30.265659
							],
							[
								-85.544502,
								30.265733000000004
							],
							[
								-85.544395,
								30.265779000000002
							],
							[
								-85.544281,
								30.26579
							],
							[
								-85.54393,
								30.265768
							],
							[
								-85.543869,
								30.265838
							],
							[
								-85.544052,
								30.266044
							],
							[
								-85.544128,
								30.266065
							],
							[
								-85.54425972899999,
								30.266079114000036
							],
							[
								-85.54438,
								30.266092
							],
							[
								-85.54442146199996,
								30.266106453000077
							],
							[
								-85.544555,
								30.266153
							],
							[
								-85.544685,
								30.266151000000004
							],
							[
								-85.544776,
								30.266082000000004
							],
							[
								-85.54491307899997,
								30.265899747000052
							],
							[
								-85.544952,
								30.265848000000002
							],
							[
								-85.545059,
								30.265739000000004
							],
							[
								-85.545356,
								30.265516000000005
							],
							[
								-85.545433,
								30.265476
							],
							[
								-85.545532,
								30.265450999999995
							],
							[
								-85.54574500000001,
								30.265444999999996
							],
							[
								-85.54586,
								30.265471999999995
							],
							[
								-85.545982,
								30.265527
							],
							[
								-85.546043,
								30.265586000000003
							],
							[
								-85.54610201,
								30.265744395000066
							],
							[
								-85.546119,
								30.26579
							],
							[
								-85.54627247199994,
								30.266053739000025
							],
							[
								-85.546455,
								30.266445
							],
							[
								-85.546836,
								30.267074
							],
							[
								-85.546951,
								30.267333
							],
							[
								-85.546981,
								30.267431000000002
							],
							[
								-85.546989,
								30.267555
							],
							[
								-85.546966,
								30.267627
							],
							[
								-85.54692,
								30.267701999999996
							],
							[
								-85.546829,
								30.267786999999995
							],
							[
								-85.546577,
								30.267887000000005
							],
							[
								-85.54644486899997,
								30.267919083000038
							],
							[
								-85.546264,
								30.267963000000005
							],
							[
								-85.546195,
								30.268005
							],
							[
								-85.546058,
								30.268152
							],
							[
								-85.545959,
								30.268348
							],
							[
								-85.545936,
								30.268444
							],
							[
								-85.546035,
								30.268430000000002
							],
							[
								-85.54612606199998,
								30.26839322000006
							],
							[
								-85.546394,
								30.268285
							],
							[
								-85.546562,
								30.268247000000002
							],
							[
								-85.546722,
								30.268234000000003
							],
							[
								-85.546936,
								30.268243
							],
							[
								-85.547683,
								30.268367
							],
							[
								-85.547775,
								30.268417
							],
							[
								-85.547988,
								30.268585
							],
							[
								-85.548347,
								30.268993000000002
							],
							[
								-85.548583,
								30.269236999999997
							],
							[
								-85.548683,
								30.269418
							],
							[
								-85.548698,
								30.269523000000003
							],
							[
								-85.548683,
								30.269588
							],
							[
								-85.548576,
								30.269704
							],
							[
								-85.5484,
								30.269757999999996
							],
							[
								-85.548103,
								30.269792
							],
							[
								-85.548217,
								30.269897
							],
							[
								-85.548324,
								30.269953999999995
							],
							[
								-85.548416,
								30.269974999999995
							],
							[
								-85.548683,
								30.269973
							],
							[
								-85.548858,
								30.269953999999995
							],
							[
								-85.548995,
								30.269920000000003
							],
							[
								-85.54906715999994,
								30.269885489000043
							],
							[
								-85.549087,
								30.269876
							],
							[
								-85.549201,
								30.269855
							],
							[
								-85.549293,
								30.269901000000004
							],
							[
								-85.549285,
								30.269981
							],
							[
								-85.549247,
								30.27005
							],
							[
								-85.549087,
								30.270221000000003
							],
							[
								-85.549049,
								30.270313000000005
							],
							[
								-85.549102,
								30.270374000000004
							],
							[
								-85.549194,
								30.27041
							],
							[
								-85.549359,
								30.270413000000005
							],
							[
								-85.549363,
								30.273605
							],
							[
								-85.54441,
								30.273605
							]
						]
					],
					[
						[
							[
								-85.505674,
								30.277132
							],
							[
								-85.505638,
								30.27651
							],
							[
								-85.511474,
								30.276762
							],
							[
								-85.512107,
								30.276773
							],
							[
								-85.515953,
								30.27676
							],
							[
								-85.516288,
								30.276514
							],
							[
								-85.516693,
								30.276992
							],
							[
								-85.516784,
								30.277061
							],
							[
								-85.523005,
								30.272725999999995
							],
							[
								-85.523384,
								30.272462
							],
							[
								-85.523384,
								30.272555
							],
							[
								-85.523384,
								30.272794000000005
							],
							[
								-85.523582,
								30.275241000000005
							],
							[
								-85.523587,
								30.27542
							],
							[
								-85.524767,
								30.275402
							],
							[
								-85.524786,
								30.277141
							],
							[
								-85.523635,
								30.277086000000004
							],
							[
								-85.523712,
								30.279769
							],
							[
								-85.523406,
								30.280708
							],
							[
								-85.523429,
								30.282774999999997
							],
							[
								-85.523406,
								30.28442
							],
							[
								-85.52340310199997,
								30.284461532000027
							],
							[
								-85.522857,
								30.291809999999998
							],
							[
								-85.508018,
								30.292205000000003
							],
							[
								-85.506889,
								30.292186000000004
							],
							[
								-85.506636,
								30.284637999999998
							],
							[
								-85.506629,
								30.284416
							],
							[
								-85.50653,
								30.284194
							],
							[
								-85.50631700000001,
								30.28206
							],
							[
								-85.50631700000001,
								30.281751000000003
							],
							[
								-85.505767,
								30.278718
							],
							[
								-85.505674,
								30.277132
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Bay",
				"City": "Panama City",
				"Name": "Cedar Grove",
				"RegionID": "123888"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.70845769999994,
					30.41788942600004,
					-81.6940919079999,
					30.438700100000062
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.6968845369999,
							30.41788942600004
						],
						[
							-81.69723927199993,
							30.417921674000073
						],
						[
							-81.69759768799992,
							30.417952048000075
						],
						[
							-81.6981286109999,
							30.41799704200008
						],
						[
							-81.69889107199992,
							30.418355083000055
						],
						[
							-81.69893165999991,
							30.41850583400009
						],
						[
							-81.69893604599991,
							30.41853316600009
						],
						[
							-81.69900146199991,
							30.41898509300006
						],
						[
							-81.69960809999992,
							30.419209570000078
						],
						[
							-81.6997393769999,
							30.41927057000004
						],
						[
							-81.6998589339999,
							30.419338319000072
						],
						[
							-81.7006490519999,
							30.419784873000083
						],
						[
							-81.7017938919999,
							30.419761771000086
						],
						[
							-81.70195916599994,
							30.419775341000044
						],
						[
							-81.70211058599995,
							30.419815914000086
						],
						[
							-81.70213301599995,
							30.419824418000076
						],
						[
							-81.70397012299992,
							30.420549123000058
						],
						[
							-81.70454304499992,
							30.42077513000004
						],
						[
							-81.70556397699994,
							30.420511285000092
						],
						[
							-81.70570489399995,
							30.420486620000077
						],
						[
							-81.70845769999994,
							30.420228040000044
						],
						[
							-81.70841113499995,
							30.42113569500009
						],
						[
							-81.70839052699995,
							30.421537412000077
						],
						[
							-81.70806701299995,
							30.427843498000072
						],
						[
							-81.70765691399993,
							30.438569065000078
						],
						[
							-81.7055739079999,
							30.438593010000087
						],
						[
							-81.7051699079999,
							30.43859701000008
						],
						[
							-81.70474990699995,
							30.438620011000065
						],
						[
							-81.70452090799995,
							30.438623010000075
						],
						[
							-81.7034839069999,
							30.438631010000055
						],
						[
							-81.70243790799992,
							30.438639011000078
						],
						[
							-81.70139290799995,
							30.438659011000087
						],
						[
							-81.70098090699992,
							30.438667010000074
						],
						[
							-81.7003329069999,
							30.438660011000085
						],
						[
							-81.69928690699993,
							30.438681010000042
						],
						[
							-81.69861190799993,
							30.438689010000076
						],
						[
							-81.69806890799993,
							30.438696011000047
						],
						[
							-81.69800587299994,
							30.438700100000062
						],
						[
							-81.69735190799992,
							30.437557010000038
						],
						[
							-81.69690890699991,
							30.43678201000006
						],
						[
							-81.69662990799992,
							30.436294010000037
						],
						[
							-81.69639790699995,
							30.43584001000005
						],
						[
							-81.69613690799991,
							30.435317010000063
						],
						[
							-81.69591990799995,
							30.43483301100008
						],
						[
							-81.6956979069999,
							30.434323010000075
						],
						[
							-81.69507990799991,
							30.43280101000005
						],
						[
							-81.69447290799991,
							30.43130701000007
						],
						[
							-81.69422090799992,
							30.43057401100009
						],
						[
							-81.69419890799992,
							30.430506010000045
						],
						[
							-81.69412190799994,
							30.430134010000074
						],
						[
							-81.6940919079999,
							30.429768010000092
						],
						[
							-81.6940989069999,
							30.42917401000005
						],
						[
							-81.69414490899993,
							30.42870501000004
						],
						[
							-81.69428990699993,
							30.42809901000004
						],
						[
							-81.69433590699992,
							30.42795201100006
						],
						[
							-81.69437390699994,
							30.42780701000004
						],
						[
							-81.69477190799995,
							30.426527011000072
						],
						[
							-81.69515790799994,
							30.42527301100006
						],
						[
							-81.6955339079999,
							30.42407601000008
						],
						[
							-81.69577790699992,
							30.42330601100008
						],
						[
							-81.69599190699995,
							30.422609010000084
						],
						[
							-81.69618190799991,
							30.421974010000042
						],
						[
							-81.69648690799994,
							30.42095901000005
						],
						[
							-81.69667081199992,
							30.420381845000062
						],
						[
							-81.69676200399994,
							30.42040017400006
						],
						[
							-81.6968909069999,
							30.41997201000004
						],
						[
							-81.69691508299991,
							30.41984699200009
						],
						[
							-81.69684773299991,
							30.419697028000083
						],
						[
							-81.69689190799994,
							30.419456010000093
						],
						[
							-81.69691490799994,
							30.41921401100006
						],
						[
							-81.69692990699991,
							30.41888201000006
						],
						[
							-81.69691399999994,
							30.41853400000008
						],
						[
							-81.6968845369999,
							30.41788942600004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "College Park",
				"RegionID": "123986"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.50567199999996,
					27.363261000000023,
					-82.48176199999996,
					27.381758000000048
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.49730499999998,
							27.363316000000054
						],
						[
							-82.49787799999996,
							27.36332200000004
						],
						[
							-82.50006999999994,
							27.36334000000005
						],
						[
							-82.50164699999993,
							27.363343000000043
						],
						[
							-82.50412999999998,
							27.36333300000007
						],
						[
							-82.50521799999996,
							27.363330000000076
						],
						[
							-82.50547299999994,
							27.363323000000037
						],
						[
							-82.50566899999995,
							27.363311000000067
						],
						[
							-82.50565999999998,
							27.363961000000074
						],
						[
							-82.50567199999996,
							27.364618000000064
						],
						[
							-82.50566399999997,
							27.36702100000008
						],
						[
							-82.50565499999999,
							27.36890100000005
						],
						[
							-82.50565599999999,
							27.369116000000076
						],
						[
							-82.50565199999994,
							27.370674000000065
						],
						[
							-82.50564899999995,
							27.37103200000007
						],
						[
							-82.50565199999994,
							27.371166000000073
						],
						[
							-82.50565199999994,
							27.37247700000006
						],
						[
							-82.50541799999996,
							27.37242200000003
						],
						[
							-82.50565299999994,
							27.372648000000027
						],
						[
							-82.50565599999999,
							27.373114000000044
						],
						[
							-82.50566399999997,
							27.374315000000024
						],
						[
							-82.50566499999996,
							27.37610600000005
						],
						[
							-82.50566499999996,
							27.377792000000056
						],
						[
							-82.50566999999997,
							27.377879000000068
						],
						[
							-82.50565499999999,
							27.379684000000058
						],
						[
							-82.50565399999994,
							27.38033900000005
						],
						[
							-82.50565199999994,
							27.381755000000055
						],
						[
							-82.50513299999994,
							27.381758000000048
						],
						[
							-82.50439399999993,
							27.38175300000006
						],
						[
							-82.50428399999998,
							27.381745000000024
						],
						[
							-82.50416299999995,
							27.381725000000074
						],
						[
							-82.50401199999999,
							27.381679000000076
						],
						[
							-82.50393899999995,
							27.38164900000004
						],
						[
							-82.50386499999996,
							27.381611000000078
						],
						[
							-82.50376099999994,
							27.38154700000007
						],
						[
							-82.50327099999998,
							27.38121600000005
						],
						[
							-82.50317799999993,
							27.38116400000007
						],
						[
							-82.50306899999998,
							27.381116000000077
						],
						[
							-82.50300899999996,
							27.381098000000065
						],
						[
							-82.50292499999995,
							27.381072000000074
						],
						[
							-82.50278199999997,
							27.381046000000026
						],
						[
							-82.50263899999999,
							27.38103700000005
						],
						[
							-82.50238299999995,
							27.381031000000064
						],
						[
							-82.50155499999994,
							27.381021000000036
						],
						[
							-82.49957199999994,
							27.38099900000003
						],
						[
							-82.49867199999994,
							27.38098000000008
						],
						[
							-82.49777099999994,
							27.380973000000044
						],
						[
							-82.49666999999995,
							27.380957000000024
						],
						[
							-82.49584299999998,
							27.38094700000005
						],
						[
							-82.49320699999998,
							27.38091600000007
						],
						[
							-82.49230099999994,
							27.380907000000036
						],
						[
							-82.49147199999999,
							27.38089800000006
						],
						[
							-82.49063999999998,
							27.380892000000074
						],
						[
							-82.49037799999996,
							27.380889000000025
						],
						[
							-82.48980199999994,
							27.38088300000004
						],
						[
							-82.48898099999998,
							27.380876000000058
						],
						[
							-82.48810899999995,
							27.380882000000042
						],
						[
							-82.48811899999998,
							27.380765000000054
						],
						[
							-82.48812499999997,
							27.38043200000004
						],
						[
							-82.48812099999998,
							27.380365000000044
						],
						[
							-82.48810499999996,
							27.380293000000055
						],
						[
							-82.48807799999997,
							27.380217000000073
						],
						[
							-82.48803999999996,
							27.38014700000008
						],
						[
							-82.48791799999998,
							27.379984000000036
						],
						[
							-82.48784899999998,
							27.379902000000072
						],
						[
							-82.48735099999999,
							27.379312000000027
						],
						[
							-82.48685299999994,
							27.378719000000046
						],
						[
							-82.48673299999997,
							27.378576000000066
						],
						[
							-82.48667999999998,
							27.378488000000065
						],
						[
							-82.48660599999994,
							27.378322000000026
						],
						[
							-82.48657099999997,
							27.378195000000062
						],
						[
							-82.48655699999995,
							27.378090000000046
						],
						[
							-82.48655599999995,
							27.37797500000005
						],
						[
							-82.48656799999998,
							27.377883000000054
						],
						[
							-82.48660599999994,
							27.377691000000027
						],
						[
							-82.48661799999996,
							27.377567000000056
						],
						[
							-82.48661799999996,
							27.37751700000007
						],
						[
							-82.48660099999995,
							27.377376000000027
						],
						[
							-82.48655999999994,
							27.377289000000076
						],
						[
							-82.48650899999996,
							27.37719500000003
						],
						[
							-82.48644399999995,
							27.377109000000075
						],
						[
							-82.48640699999999,
							27.377068000000065
						],
						[
							-82.48636899999997,
							27.37703300000004
						],
						[
							-82.48378199999996,
							27.37507000000005
						],
						[
							-82.48365999999999,
							27.375000000000057
						],
						[
							-82.48352599999998,
							27.374950000000073
						],
						[
							-82.48338499999994,
							27.374919000000034
						],
						[
							-82.48321499999997,
							27.374899000000028
						],
						[
							-82.48303099999998,
							27.374942000000033
						],
						[
							-82.48272099999997,
							27.375037000000077
						],
						[
							-82.48267099999998,
							27.375047000000052
						],
						[
							-82.48255199999994,
							27.375053000000037
						],
						[
							-82.48246199999994,
							27.375043000000066
						],
						[
							-82.48236299999996,
							27.37501700000007
						],
						[
							-82.48231199999998,
							27.37499900000006
						],
						[
							-82.48220799999996,
							27.374948000000078
						],
						[
							-82.48215299999998,
							27.37491300000005
						],
						[
							-82.48201599999999,
							27.374803000000043
						],
						[
							-82.48191099999997,
							27.374698000000024
						],
						[
							-82.48182599999996,
							27.37458600000008
						],
						[
							-82.48179699999997,
							27.374531000000047
						],
						[
							-82.48178099999996,
							27.374473000000023
						],
						[
							-82.48176599999995,
							27.374328000000048
						],
						[
							-82.48176199999996,
							27.374193000000048
						],
						[
							-82.48322099999996,
							27.374212000000057
						],
						[
							-82.48438799999997,
							27.37422400000003
						],
						[
							-82.48493099999996,
							27.37423000000007
						],
						[
							-82.48491799999994,
							27.37076600000006
						],
						[
							-82.48492899999997,
							27.370690000000025
						],
						[
							-82.48494799999999,
							27.370664000000033
						],
						[
							-82.48497299999997,
							27.370644000000027
						],
						[
							-82.48499899999997,
							27.37063500000005
						],
						[
							-82.48505099999994,
							27.37062700000007
						],
						[
							-82.48698299999995,
							27.370615000000047
						],
						[
							-82.48796099999998,
							27.370599000000027
						],
						[
							-82.48832499999997,
							27.370596000000035
						],
						[
							-82.48974799999996,
							27.37057500000003
						],
						[
							-82.49095799999998,
							27.370568000000052
						],
						[
							-82.49300299999999,
							27.370568000000052
						],
						[
							-82.49306199999995,
							27.37056300000006
						],
						[
							-82.49310999999996,
							27.37054900000004
						],
						[
							-82.49315399999995,
							27.37052700000004
						],
						[
							-82.49320399999995,
							27.370486000000028
						],
						[
							-82.49322699999999,
							27.37045900000004
						],
						[
							-82.49324899999995,
							27.370425000000072
						],
						[
							-82.49326899999994,
							27.37037600000008
						],
						[
							-82.49328399999996,
							27.370284000000026
						],
						[
							-82.49328899999995,
							27.370025000000055
						],
						[
							-82.49328999999994,
							27.369613000000072
						],
						[
							-82.49329699999998,
							27.369403000000034
						],
						[
							-82.49331799999999,
							27.36913500000003
						],
						[
							-82.49336499999998,
							27.368688000000077
						],
						[
							-82.49337399999996,
							27.36850700000008
						],
						[
							-82.49334999999996,
							27.367756000000046
						],
						[
							-82.49333399999995,
							27.36691000000008
						],
						[
							-82.49329299999994,
							27.364756000000057
						],
						[
							-82.49327899999997,
							27.363369000000034
						],
						[
							-82.49328099999997,
							27.363261000000023
						],
						[
							-82.49468699999994,
							27.36328100000003
						],
						[
							-82.49478599999998,
							27.363278000000037
						],
						[
							-82.49596199999996,
							27.363300000000038
						],
						[
							-82.49641099999997,
							27.363309000000072
						],
						[
							-82.49730499999998,
							27.363316000000054
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Desoto Lakes",
				"RegionID": "124173"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.63446492599991,
					30.461468012000072,
					-81.6004707379999,
					30.488891887000076
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.60459190899991,
							30.48370101200004
						],
						[
							-81.60414790899995,
							30.483680013000082
						],
						[
							-81.6034879099999,
							30.483733013000062
						],
						[
							-81.60327890999993,
							30.483755013000067
						],
						[
							-81.60313390899995,
							30.48378401200006
						],
						[
							-81.6023909079999,
							30.48388010000008
						],
						[
							-81.6004707379999,
							30.472275978000084
						],
						[
							-81.60146495499993,
							30.470626979000087
						],
						[
							-81.60213490799993,
							30.47118001000007
						],
						[
							-81.60234090799992,
							30.47131901000006
						],
						[
							-81.60271490799994,
							30.47152501000005
						],
						[
							-81.60308090799994,
							30.471678010000065
						],
						[
							-81.60330190699995,
							30.471746011000054
						],
						[
							-81.60473990799994,
							30.472122010000078
						],
						[
							-81.6050259079999,
							30.47219701100005
						],
						[
							-81.6069179079999,
							30.47267701000004
						],
						[
							-81.60729190799992,
							30.472750010000087
						],
						[
							-81.60756690799991,
							30.47277500900009
						],
						[
							-81.60799390799991,
							30.472771010000088
						],
						[
							-81.60816190699991,
							30.47275701000007
						],
						[
							-81.6084519069999,
							30.47271201000007
						],
						[
							-81.60859590799993,
							30.47267201000005
						],
						[
							-81.60888690799993,
							30.472591010000087
						],
						[
							-81.60915790799993,
							30.47248401000007
						],
						[
							-81.60919990799994,
							30.472467011000045
						],
						[
							-81.60935990799993,
							30.472389010000082
						],
						[
							-81.60963390699993,
							30.472221010000055
						],
						[
							-81.61226490799993,
							30.470304011000056
						],
						[
							-81.61251790699993,
							30.470119010000076
						],
						[
							-81.61293790699995,
							30.469839011000087
						],
						[
							-81.61314390799993,
							30.469725010000047
						],
						[
							-81.61364690799991,
							30.469450011000053
						],
						[
							-81.61395290699994,
							30.469301011000084
						],
						[
							-81.61465490699993,
							30.469013011000072
						],
						[
							-81.61498990699994,
							30.468901011000067
						],
						[
							-81.61548590799993,
							30.468754010000055
						],
						[
							-81.61618790799992,
							30.468559010000035
						],
						[
							-81.61785090799992,
							30.46810001100005
						],
						[
							-81.61903390799995,
							30.467772011000076
						],
						[
							-81.61958290799993,
							30.467644009000082
						],
						[
							-81.62029990799994,
							30.46749701100003
						],
						[
							-81.62180290799995,
							30.467264011000054
						],
						[
							-81.62508390799991,
							30.466782010000088
						],
						[
							-81.62603790799994,
							30.466635011000054
						],
						[
							-81.62707490799994,
							30.46644801000008
						],
						[
							-81.62733290699994,
							30.466372009000054
						],
						[
							-81.62744790699992,
							30.46632101000006
						],
						[
							-81.62777790799993,
							30.466106010000086
						],
						[
							-81.62791190699994,
							30.465994010000088
						],
						[
							-81.62834290799992,
							30.46557301000007
						],
						[
							-81.62863290799993,
							30.465267010000044
						],
						[
							-81.6297449079999,
							30.46417901000007
						],
						[
							-81.62995090699991,
							30.463974010000072
						],
						[
							-81.63010790699991,
							30.463824011000046
						],
						[
							-81.63052190799993,
							30.463477011000066
						],
						[
							-81.63072590799993,
							30.463273011000066
						],
						[
							-81.6310549079999,
							30.462995011000086
						],
						[
							-81.63124290799993,
							30.46287401000006
						],
						[
							-81.6317739079999,
							30.46256801000004
						],
						[
							-81.63208190799992,
							30.462407010000046
						],
						[
							-81.6333539069999,
							30.461737011000082
						],
						[
							-81.63366790799995,
							30.461567011000056
						],
						[
							-81.63379790699992,
							30.461511011000084
						],
						[
							-81.6338999059999,
							30.461480011000052
						],
						[
							-81.63400090599993,
							30.461468012000072
						],
						[
							-81.63421090799994,
							30.461480011000052
						],
						[
							-81.63446492599991,
							30.46153592600007
						],
						[
							-81.63426190899992,
							30.462142012000072
						],
						[
							-81.63421890899991,
							30.46227401300007
						],
						[
							-81.63418990899993,
							30.462399012000052
						],
						[
							-81.63408790999995,
							30.462773012000074
						],
						[
							-81.6340399099999,
							30.462945013000084
						],
						[
							-81.63401582599994,
							30.46303000800009
						],
						[
							-81.63404076899991,
							30.463165132000082
						],
						[
							-81.63407307699993,
							30.463175928000055
						],
						[
							-81.63391002499992,
							30.46371007900007
						],
						[
							-81.63385879399995,
							30.463771946000065
						],
						[
							-81.6338199089999,
							30.463902012000066
						],
						[
							-81.63371290999993,
							30.464226013000086
						],
						[
							-81.63365190999993,
							30.464388012000086
						],
						[
							-81.6334989099999,
							30.464891013000056
						],
						[
							-81.63344590899993,
							30.465036012000045
						],
						[
							-81.6333619099999,
							30.46527101200007
						],
						[
							-81.63278990999993,
							30.467001012000086
						],
						[
							-81.63235690999994,
							30.468337012000063
						],
						[
							-81.63234590899992,
							30.46837101200003
						],
						[
							-81.6321459099999,
							30.468969012000063
						],
						[
							-81.63161490899995,
							30.470577012000035
						],
						[
							-81.63120290899991,
							30.47182801300005
						],
						[
							-81.63040190999993,
							30.47422401200004
						],
						[
							-81.6294709089999,
							30.476997013000073
						],
						[
							-81.62918890899994,
							30.477810012000077
						],
						[
							-81.6283419099999,
							30.480356012000076
						],
						[
							-81.62789690999995,
							30.481669012000058
						],
						[
							-81.62680790999991,
							30.48489001200005
						],
						[
							-81.62646490899994,
							30.485914013000073
						],
						[
							-81.62609890999994,
							30.48703201300009
						],
						[
							-81.62583890899992,
							30.48778301200008
						],
						[
							-81.62567890899993,
							30.48828901200005
						],
						[
							-81.6254729499999,
							30.488891887000076
						],
						[
							-81.62467190899991,
							30.48868801300006
						],
						[
							-81.6239319099999,
							30.488501012000086
						],
						[
							-81.62318390899992,
							30.48831401300004
						],
						[
							-81.6230969099999,
							30.48829201200004
						],
						[
							-81.62245890999992,
							30.488131012000057
						],
						[
							-81.62171890999991,
							30.487949013000048
						],
						[
							-81.62097890899992,
							30.48776201200008
						],
						[
							-81.6205139089999,
							30.48764801200008
						],
						[
							-81.61804390999994,
							30.487032012000043
						],
						[
							-81.61344090999995,
							30.485884012000046
						],
						[
							-81.61225890899993,
							30.485587013000046
						],
						[
							-81.61057990899991,
							30.48516401200004
						],
						[
							-81.60730590899993,
							30.48434301200007
						],
						[
							-81.6049299099999,
							30.483756013000065
						],
						[
							-81.60477890999994,
							30.483725012000036
						],
						[
							-81.60459190899991,
							30.48370101200004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Duval",
				"RegionID": "124222"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.72464491799991,
					30.438256016000082,
					-81.6894229699999,
					30.455097010000088
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.68964390499991,
							30.43883500800007
						],
						[
							-81.69309990499994,
							30.438770009000052
						],
						[
							-81.69357990599991,
							30.43876400800008
						],
						[
							-81.69460790599993,
							30.43875100900004
						],
						[
							-81.69489290599996,
							30.43875100900004
						],
						[
							-81.69537390599993,
							30.438774009000042
						],
						[
							-81.69623490599992,
							30.438732008000045
						],
						[
							-81.69718190599991,
							30.43873000900004
						],
						[
							-81.6973029049999,
							30.438726008000057
						],
						[
							-81.69794390599992,
							30.43870300800006
						],
						[
							-81.69800587299994,
							30.438700100000062
						],
						[
							-81.69806890799993,
							30.438696011000047
						],
						[
							-81.69861190799993,
							30.438689010000076
						],
						[
							-81.69928690699993,
							30.438681010000042
						],
						[
							-81.7003329069999,
							30.438660011000085
						],
						[
							-81.70098090699992,
							30.438667010000074
						],
						[
							-81.70139290799995,
							30.438659011000087
						],
						[
							-81.70243790799992,
							30.438639011000078
						],
						[
							-81.7034839069999,
							30.438631010000055
						],
						[
							-81.70452090799995,
							30.438623010000075
						],
						[
							-81.70474990699995,
							30.438620011000065
						],
						[
							-81.7051699079999,
							30.43859701000008
						],
						[
							-81.7055739079999,
							30.438593010000087
						],
						[
							-81.70765691399993,
							30.438569065000078
						],
						[
							-81.70970190799994,
							30.438538010000062
						],
						[
							-81.71158190699992,
							30.438508010000078
						],
						[
							-81.71387490799992,
							30.438477010000042
						],
						[
							-81.71576390799994,
							30.438428010000052
						],
						[
							-81.71589490799994,
							30.438427010000055
						],
						[
							-81.7176809309999,
							30.438413143000048
						],
						[
							-81.71776690599997,
							30.43838201200009
						],
						[
							-81.71787190799995,
							30.438371011000076
						],
						[
							-81.71874990799995,
							30.438378010000065
						],
						[
							-81.72005590799995,
							30.43833901000005
						],
						[
							-81.72070790699992,
							30.43831201100005
						],
						[
							-81.72159790699993,
							30.43832101000004
						],
						[
							-81.72301390799993,
							30.438312010000057
						],
						[
							-81.72388990699996,
							30.43829501000005
						],
						[
							-81.72432290799992,
							30.438273010000046
						],
						[
							-81.72464491799991,
							30.438256016000082
						],
						[
							-81.72450898799991,
							30.438473055000088
						],
						[
							-81.72447790699994,
							30.438534010000073
						],
						[
							-81.72370390799995,
							30.439725010000075
						],
						[
							-81.72213990799992,
							30.442250011000056
						],
						[
							-81.72171790699991,
							30.442903010000062
						],
						[
							-81.72134190799994,
							30.443523010000035
						],
						[
							-81.72101590799991,
							30.444061011000088
						],
						[
							-81.7207959079999,
							30.44440601100007
						],
						[
							-81.72038290799992,
							30.44501601000007
						],
						[
							-81.71936490699994,
							30.44662101100005
						],
						[
							-81.7191309079999,
							30.446957011000055
						],
						[
							-81.71843890799994,
							30.447862010000055
						],
						[
							-81.71784490699991,
							30.448541011000092
						],
						[
							-81.71717190699991,
							30.449212011000046
						],
						[
							-81.71651790699991,
							30.44980501100008
						],
						[
							-81.71595890799995,
							30.45027801000009
						],
						[
							-81.71531690699993,
							30.450769010000048
						],
						[
							-81.71495090699995,
							30.451023010000085
						],
						[
							-81.71418790799993,
							30.451515011000083
						],
						[
							-81.7133709069999,
							30.45199001000009
						],
						[
							-81.71252390799992,
							30.45242901000006
						],
						[
							-81.71218390699994,
							30.45259201000005
						],
						[
							-81.71131090799993,
							30.45297401000005
						],
						[
							-81.70952590799993,
							30.453682010000076
						],
						[
							-81.70941290799993,
							30.453716010000054
						],
						[
							-81.7090899079999,
							30.45381601100007
						],
						[
							-81.70813590699993,
							30.454188011000042
						],
						[
							-81.7076469079999,
							30.45436201100006
						],
						[
							-81.70585490699995,
							30.45505501100007
						],
						[
							-81.70574990099993,
							30.455097010000088
						],
						[
							-81.70570740399995,
							30.45495846200004
						],
						[
							-81.70075919399994,
							30.451726299000086
						],
						[
							-81.69804099899994,
							30.450432062000065
						],
						[
							-81.69545240499991,
							30.446937249000086
						],
						[
							-81.69195769499993,
							30.44318366300007
						],
						[
							-81.6894229699999,
							30.43883895400006
						],
						[
							-81.68964390499991,
							30.43883500800007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Garden City",
				"RegionID": "124505"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.69800587299994,
					30.401166518000082,
					-81.65613790899994,
					30.446296022000066
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.66504990599992,
							30.44001700800004
						],
						[
							-81.6630359529999,
							30.43825482400007
						],
						[
							-81.66028578999993,
							30.43896715200009
						],
						[
							-81.66027090499995,
							30.437914009000053
						],
						[
							-81.66019390699995,
							30.43704200800005
						],
						[
							-81.66020190599994,
							30.436729009000093
						],
						[
							-81.6601939059999,
							30.43577600800006
						],
						[
							-81.66017190499991,
							30.435158011000055
						],
						[
							-81.66010995699992,
							30.43491898900004
						],
						[
							-81.65996590499992,
							30.434626008000066
						],
						[
							-81.65991190499994,
							30.434544009000035
						],
						[
							-81.65986590499995,
							30.434494008000062
						],
						[
							-81.65906490499992,
							30.433798008000057
						],
						[
							-81.65861490599993,
							30.433430008000073
						],
						[
							-81.65852390599991,
							30.433336008000083
						],
						[
							-81.65843190599992,
							30.433208008000065
						],
						[
							-81.6583709059999,
							30.433083008000043
						],
						[
							-81.65832490699995,
							30.432951008000092
						],
						[
							-81.65826390699993,
							30.432632008000038
						],
						[
							-81.65826390599995,
							30.43161600900004
						],
						[
							-81.65824890599993,
							30.43068100800008
						],
						[
							-81.65825690499992,
							30.430225009000083
						],
						[
							-81.65827903899992,
							30.429976879000034
						],
						[
							-81.65792890599994,
							30.429985008000074
						],
						[
							-81.65772690499995,
							30.42997401000008
						],
						[
							-81.65757590599992,
							30.43000600700009
						],
						[
							-81.65710190499993,
							30.430040008000052
						],
						[
							-81.65630790599994,
							30.430046008000094
						],
						[
							-81.65613790899994,
							30.430041068000037
						],
						[
							-81.65613990799996,
							30.429935011000058
						],
						[
							-81.65636190799995,
							30.426767010000052
						],
						[
							-81.65676190799991,
							30.418697010000074
						],
						[
							-81.65707590799991,
							30.414779011000064
						],
						[
							-81.65708482699995,
							30.414471988000063
						],
						[
							-81.65723598899991,
							30.414189030000045
						],
						[
							-81.6572369079999,
							30.41407501100008
						],
						[
							-81.6572609079999,
							30.413673010000082
						],
						[
							-81.65727590799992,
							30.413425010000083
						],
						[
							-81.65733490799994,
							30.412630010000044
						],
						[
							-81.65734690799991,
							30.412405011000093
						],
						[
							-81.65736105099997,
							30.412123888000053
						],
						[
							-81.65720676399991,
							30.412111132000067
						],
						[
							-81.65721890799996,
							30.411895011000073
						],
						[
							-81.6572849069999,
							30.411193011000083
						],
						[
							-81.65729090799994,
							30.411124010000034
						],
						[
							-81.65738590799992,
							30.409580010000067
						],
						[
							-81.65739183799991,
							30.40943386300006
						],
						[
							-81.6575129769999,
							30.40952415800007
						],
						[
							-81.65754090699994,
							30.408936010000048
						],
						[
							-81.65756285499992,
							30.40860900000007
						],
						[
							-81.65757396099991,
							30.408571019000075
						],
						[
							-81.6575799069999,
							30.408488010000045
						],
						[
							-81.65758190799994,
							30.40840801000007
						],
						[
							-81.65760690799993,
							30.40818501100006
						],
						[
							-81.6576429079999,
							30.407940010000058
						],
						[
							-81.65772490799992,
							30.407505010000083
						],
						[
							-81.6578229079999,
							30.407177011000044
						],
						[
							-81.65791001799994,
							30.406907897000057
						],
						[
							-81.65778979699991,
							30.406951120000084
						],
						[
							-81.6580039079999,
							30.40639401200008
						],
						[
							-81.65855390799993,
							30.405516011000092
						],
						[
							-81.65893290899993,
							30.405046011000085
						],
						[
							-81.65947790799993,
							30.40452601000004
						],
						[
							-81.6596689079999,
							30.404345011000093
						],
						[
							-81.66015090699995,
							30.40398201000005
						],
						[
							-81.66080090799994,
							30.403531010000048
						],
						[
							-81.66105190699994,
							30.403357010000036
						],
						[
							-81.66153853299994,
							30.403039666000037
						],
						[
							-81.66105380499994,
							30.40342092400004
						],
						[
							-81.6610228429999,
							30.403475085000082
						],
						[
							-81.6611819069999,
							30.403353011000036
						],
						[
							-81.6616069079999,
							30.40306601000009
						],
						[
							-81.66188390799994,
							30.402867010000083
						],
						[
							-81.66227690699992,
							30.402594011000076
						],
						[
							-81.66240090799994,
							30.40250201000003
						],
						[
							-81.66269590799993,
							30.402276010000037
						],
						[
							-81.6632049079999,
							30.40191901000009
						],
						[
							-81.66343799999993,
							30.401756000000034
						],
						[
							-81.66428091599994,
							30.401166518000082
						],
						[
							-81.6643066609999,
							30.401180164000035
						],
						[
							-81.66443507299994,
							30.40127007900009
						],
						[
							-81.6645459209999,
							30.40138092700005
						],
						[
							-81.66463583599995,
							30.401509339000086
						],
						[
							-81.66470208599992,
							30.40165141300008
						],
						[
							-81.6647426589999,
							30.40180283400008
						],
						[
							-81.6647563219999,
							30.40195900000009
						],
						[
							-81.66475539399994,
							30.401999834000037
						],
						[
							-81.66474732099994,
							30.402177446000053
						],
						[
							-81.66480630499991,
							30.402779398000067
						],
						[
							-81.6672705869999,
							30.40303445600006
						],
						[
							-81.66733416599993,
							30.403043340000067
						],
						[
							-81.66748558599994,
							30.403083913000046
						],
						[
							-81.66762766099993,
							30.403150164000067
						],
						[
							-81.66775607299991,
							30.40324007900006
						],
						[
							-81.66786692099993,
							30.40335092700008
						],
						[
							-81.6679014799999,
							30.403394811000055
						],
						[
							-81.66902747899991,
							30.404919811000074
						],
						[
							-81.66908283599992,
							30.405004339000072
						],
						[
							-81.66915192899995,
							30.405154460000062
						],
						[
							-81.66946879799991,
							30.406079044000084
						],
						[
							-81.67000024499993,
							30.406408885000076
						],
						[
							-81.67003269799994,
							30.406430007000044
						],
						[
							-81.67064269699995,
							30.406846008000063
						],
						[
							-81.67069529799994,
							30.406884752000057
						],
						[
							-81.67074494799994,
							30.406927213000078
						],
						[
							-81.67079138399993,
							30.406973166000057
						],
						[
							-81.67083436199995,
							30.407022369000064
						],
						[
							-81.67087365399995,
							30.407074562000048
						],
						[
							-81.67215965399993,
							30.408918562000057
						],
						[
							-81.67220083499991,
							30.408983339000084
						],
						[
							-81.67226708599992,
							30.409125414000073
						],
						[
							-81.6723076589999,
							30.409276834000085
						],
						[
							-81.6723213219999,
							30.409433000000032
						],
						[
							-81.6723076589999,
							30.40958916500006
						],
						[
							-81.67226708599992,
							30.40974058600006
						],
						[
							-81.67221753199995,
							30.40985241400006
						],
						[
							-81.67148141399991,
							30.41124936500006
						],
						[
							-81.67181079699992,
							30.41210265600006
						],
						[
							-81.67181935399992,
							30.41212571700004
						],
						[
							-81.67194735399994,
							30.412485717000038
						],
						[
							-81.67196833499992,
							30.41255296000008
						],
						[
							-81.6719839889999,
							30.41262163900007
						],
						[
							-81.67199421899994,
							30.41269133300006
						],
						[
							-81.6719989639999,
							30.412761613000047
						],
						[
							-81.67199819299992,
							30.412832050000077
						],
						[
							-81.67196619299995,
							30.41347005000006
						],
						[
							-81.67195365999993,
							30.413581166000085
						],
						[
							-81.67191308699995,
							30.413732587000084
						],
						[
							-81.67184683599993,
							30.41387466100008
						],
						[
							-81.67175692099994,
							30.414003073000057
						],
						[
							-81.67164607299992,
							30.414113921000077
						],
						[
							-81.67151766099994,
							30.414203836000073
						],
						[
							-81.67137558699994,
							30.414270087000034
						],
						[
							-81.67126511299995,
							30.414302455000044
						],
						[
							-81.66965811299991,
							30.41466345500004
						],
						[
							-81.66961716599991,
							30.414671659000078
						],
						[
							-81.6694609999999,
							30.41468532200008
						],
						[
							-81.66930483399995,
							30.414671659000078
						],
						[
							-81.66915341399994,
							30.414631086000043
						],
						[
							-81.66910866699993,
							30.41461343000009
						],
						[
							-81.6681385469999,
							30.41420033800006
						],
						[
							-81.66788614299992,
							30.415137350000066
						],
						[
							-81.67089830799995,
							30.41730504700007
						],
						[
							-81.67095107299991,
							30.417346079000087
						],
						[
							-81.67106192099993,
							30.417456927000046
						],
						[
							-81.67115183599992,
							30.417585339000084
						],
						[
							-81.6712180859999,
							30.41772741300008
						],
						[
							-81.6712588119999,
							30.417880576000073
						],
						[
							-81.67139199999991,
							30.417870678000043
						],
						[
							-81.67154816599992,
							30.417884341000047
						],
						[
							-81.67169958599993,
							30.417924914000082
						],
						[
							-81.67184166099992,
							30.417991165000046
						],
						[
							-81.67191170999992,
							30.41803605100006
						],
						[
							-81.67424470999993,
							30.41968805100004
						],
						[
							-81.67430307299993,
							30.419733079000085
						],
						[
							-81.67441391999995,
							30.419843927000045
						],
						[
							-81.67450383499994,
							30.419972339000083
						],
						[
							-81.6745700859999,
							30.42011441400007
						],
						[
							-81.67461065899994,
							30.420265834000077
						],
						[
							-81.67462432199994,
							30.420422000000087
						],
						[
							-81.67461065899994,
							30.420578166000045
						],
						[
							-81.6745777189999,
							30.420707743000033
						],
						[
							-81.67451179999995,
							30.420904461000074
						],
						[
							-81.67458097899993,
							30.42091769600006
						],
						[
							-81.67464833699995,
							30.420932890000074
						],
						[
							-81.67471426299996,
							30.42095342400006
						],
						[
							-81.6747783369999,
							30.420979164000073
						],
						[
							-81.67484014599995,
							30.421009947000073
						],
						[
							-81.67489929499993,
							30.42104557400006
						],
						[
							-81.67495540499993,
							30.421085819000044
						],
						[
							-81.6750081159999,
							30.42113042200009
						],
						[
							-81.67505709199992,
							30.421179098000042
						],
						[
							-81.67510454299992,
							30.42118883600006
						],
						[
							-81.6751783389999,
							30.421137164000076
						],
						[
							-81.67532041399994,
							30.42107091300005
						],
						[
							-81.67547183499994,
							30.421030340000073
						],
						[
							-81.6756279999999,
							30.421016678000058
						],
						[
							-81.67572214599994,
							30.421021619000044
						],
						[
							-81.67589661499994,
							30.42103998400006
						],
						[
							-81.6761028709999,
							30.420925953000054
						],
						[
							-81.67623041399992,
							30.42086791400004
						],
						[
							-81.67635145299994,
							30.42083323900005
						],
						[
							-81.67650626299991,
							30.420800413000048
						],
						[
							-81.67672036599993,
							30.42061482300005
						],
						[
							-81.67678342099994,
							30.420565690000046
						],
						[
							-81.67685059099995,
							30.42052235100005
						],
						[
							-81.67692134599992,
							30.42048515100004
						],
						[
							-81.6769951249999,
							30.42045438400004
						],
						[
							-81.67707134599993,
							30.420430292000052
						],
						[
							-81.6771494059999,
							30.420413066000034
						],
						[
							-81.67785968699991,
							30.420290419000082
						],
						[
							-81.67866121399993,
							30.419963338000063
						],
						[
							-81.67869341399997,
							30.419950914000086
						],
						[
							-81.6788448339999,
							30.41991034100005
						],
						[
							-81.67900099999991,
							30.419896678000043
						],
						[
							-81.67915716599992,
							30.41991034100005
						],
						[
							-81.67930858599993,
							30.419950914000086
						],
						[
							-81.67945066099992,
							30.42001716400006
						],
						[
							-81.6795790729999,
							30.420107080000033
						],
						[
							-81.67968992099992,
							30.420217927000067
						],
						[
							-81.67977983599991,
							30.420346339000048
						],
						[
							-81.67984108699994,
							30.420475011000068
						],
						[
							-81.68003777299992,
							30.420989226000078
						],
						[
							-81.68016633899992,
							30.420899165000037
						],
						[
							-81.6802327229999,
							30.42086444100005
						],
						[
							-81.6804577229999,
							30.42075844100009
						],
						[
							-81.68053341399991,
							30.420726914000056
						],
						[
							-81.68068483499992,
							30.420686341000078
						],
						[
							-81.68084099999993,
							30.420672678000077
						],
						[
							-81.68099716599994,
							30.420686341000078
						],
						[
							-81.68110547699992,
							30.420712447000085
						],
						[
							-81.68139147699992,
							30.420800446000047
						],
						[
							-81.68143458599991,
							30.420814913000076
						],
						[
							-81.68157666099995,
							30.420881164000036
						],
						[
							-81.68170507299993,
							30.42097107900008
						],
						[
							-81.68181592099995,
							30.421081926000056
						],
						[
							-81.68190583599994,
							30.421210339000087
						],
						[
							-81.68191790899994,
							30.421232444000054
						],
						[
							-81.68210208399995,
							30.42137734300007
						],
						[
							-81.6826633899999,
							30.42136010200005
						],
						[
							-81.68279393599994,
							30.421365589000064
						],
						[
							-81.68325393599991,
							30.42141858800005
						],
						[
							-81.68330716499992,
							30.421426341000085
						],
						[
							-81.6834602909999,
							30.42146753800006
						],
						[
							-81.68386899599994,
							30.421618162000073
						],
						[
							-81.6839247559999,
							30.421637955000055
						],
						[
							-81.68397859599992,
							30.42166249600007
						],
						[
							-81.68403011099991,
							30.42169160200007
						],
						[
							-81.68407891599992,
							30.421725053000042
						],
						[
							-81.68412464499994,
							30.421762601000065
						],
						[
							-81.6841669559999,
							30.42180396200007
						],
						[
							-81.6842104779999,
							30.421768932000077
						],
						[
							-81.68439710199993,
							30.421578142000044
						],
						[
							-81.68446192699992,
							30.42151807900007
						],
						[
							-81.6845903389999,
							30.421428164000073
						],
						[
							-81.68473241299995,
							30.421361913000055
						],
						[
							-81.68488383399995,
							30.421321340000077
						],
						[
							-81.68501674999993,
							30.421307978000076
						],
						[
							-81.68536475099995,
							30.42129897900008
						],
						[
							-81.68538799999993,
							30.421298678000085
						],
						[
							-81.68548622899993,
							30.42130727200004
						],
						[
							-81.6855119139999,
							30.421211414000084
						],
						[
							-81.68555137699991,
							30.421119311000044
						],
						[
							-81.68574337699994,
							30.420732311000055
						],
						[
							-81.6857701639999,
							30.420682339000052
						],
						[
							-81.68586007899995,
							30.420553927000075
						],
						[
							-81.68597092699991,
							30.42044308000004
						],
						[
							-81.68609933899995,
							30.42035316500005
						],
						[
							-81.68624141399995,
							30.420286914000084
						],
						[
							-81.68639283399995,
							30.42024634100005
						],
						[
							-81.6865489999999,
							30.420232678000048
						],
						[
							-81.68663208399994,
							30.420236524000074
						],
						[
							-81.68692308399994,
							30.42026352400006
						],
						[
							-81.68699612299991,
							30.42027316700006
						],
						[
							-81.68706809499992,
							30.420288905000064
						],
						[
							-81.6871384929999,
							30.42031062700005
						],
						[
							-81.68720681999991,
							30.42033817900006
						],
						[
							-81.68727259399992,
							30.42037136700009
						],
						[
							-81.68733535099994,
							30.420409958000054
						],
						[
							-81.68739464899994,
							30.420453678000058
						],
						[
							-81.68769571399991,
							30.42045268800007
						],
						[
							-81.68763891399993,
							30.420317586000067
						],
						[
							-81.6875983409999,
							30.42016616600006
						],
						[
							-81.68758467799995,
							30.42001000000005
						],
						[
							-81.6875983409999,
							30.419853834000037
						],
						[
							-81.68763891399993,
							30.41970241400008
						],
						[
							-81.68770516399991,
							30.419560339000043
						],
						[
							-81.68775301599993,
							30.419486127000084
						],
						[
							-81.68801101699995,
							30.419126128000077
						],
						[
							-81.68805320899992,
							30.419071773000045
						],
						[
							-81.68809943399992,
							30.41902080300008
						],
						[
							-81.68814942099993,
							30.418973517000044
						],
						[
							-81.68820287599993,
							30.418930191000072
						],
						[
							-81.68825948799991,
							30.41889107900005
						],
						[
							-81.68914764399995,
							30.41832640100006
						],
						[
							-81.68929821099994,
							30.41802067100008
						],
						[
							-81.6893261649999,
							30.417968339000087
						],
						[
							-81.68941607999994,
							30.41783992700005
						],
						[
							-81.68952692699992,
							30.417729080000072
						],
						[
							-81.6896553389999,
							30.417639165000082
						],
						[
							-81.68979741399994,
							30.417572914000058
						],
						[
							-81.68994883499994,
							30.417532341000083
						],
						[
							-81.69010920299992,
							30.417518698000038
						],
						[
							-81.6904344049999,
							30.417521718000046
						],
						[
							-81.6905057589999,
							30.41752522200005
						],
						[
							-81.69073458899993,
							30.41754559700007
						],
						[
							-81.69360697799993,
							30.41739609500007
						],
						[
							-81.69442052099993,
							30.417786013000068
						],
						[
							-81.69493302199993,
							30.41796689500006
						],
						[
							-81.69603338999991,
							30.418027189000043
						],
						[
							-81.69657603699994,
							30.41786138000009
						],
						[
							-81.6968845369999,
							30.41788942600004
						],
						[
							-81.69691399999994,
							30.41853400000008
						],
						[
							-81.69692990699991,
							30.41888201000006
						],
						[
							-81.69691490799994,
							30.41921401100006
						],
						[
							-81.69689190799994,
							30.419456010000093
						],
						[
							-81.69684773299991,
							30.419697028000083
						],
						[
							-81.69691508299991,
							30.41984699200009
						],
						[
							-81.6968909069999,
							30.41997201000004
						],
						[
							-81.69676200399994,
							30.42040017400006
						],
						[
							-81.69667081199992,
							30.420381845000062
						],
						[
							-81.69648690799994,
							30.42095901000005
						],
						[
							-81.69618190799991,
							30.421974010000042
						],
						[
							-81.69599190699995,
							30.422609010000084
						],
						[
							-81.69577790699992,
							30.42330601100008
						],
						[
							-81.6955339079999,
							30.42407601000008
						],
						[
							-81.69515790799994,
							30.42527301100006
						],
						[
							-81.69477190799995,
							30.426527011000072
						],
						[
							-81.69437390699994,
							30.42780701000004
						],
						[
							-81.69433590699992,
							30.42795201100006
						],
						[
							-81.69428990699993,
							30.42809901000004
						],
						[
							-81.69414490899993,
							30.42870501000004
						],
						[
							-81.6940989069999,
							30.42917401000005
						],
						[
							-81.6940919079999,
							30.429768010000092
						],
						[
							-81.69412190799994,
							30.430134010000074
						],
						[
							-81.69419890799992,
							30.430506010000045
						],
						[
							-81.69422090799992,
							30.43057401100009
						],
						[
							-81.69447290799991,
							30.43130701000007
						],
						[
							-81.69507990799991,
							30.43280101000005
						],
						[
							-81.6956979069999,
							30.434323010000075
						],
						[
							-81.69591990799995,
							30.43483301100008
						],
						[
							-81.69613690799991,
							30.435317010000063
						],
						[
							-81.69639790699995,
							30.43584001000005
						],
						[
							-81.69662990799992,
							30.436294010000037
						],
						[
							-81.69690890699991,
							30.43678201000006
						],
						[
							-81.69735190799992,
							30.437557010000038
						],
						[
							-81.69800587299994,
							30.438700100000062
						],
						[
							-81.69794390599992,
							30.43870300800006
						],
						[
							-81.6973029049999,
							30.438726008000057
						],
						[
							-81.69718190599991,
							30.43873000900004
						],
						[
							-81.69623490599992,
							30.438732008000045
						],
						[
							-81.69537390599993,
							30.438774009000042
						],
						[
							-81.69489290599996,
							30.43875100900004
						],
						[
							-81.69460790599993,
							30.43875100900004
						],
						[
							-81.69357990599991,
							30.43876400800008
						],
						[
							-81.69309990499994,
							30.438770009000052
						],
						[
							-81.68964390499991,
							30.43883500800007
						],
						[
							-81.6894229699999,
							30.43883895400006
						],
						[
							-81.68855290699992,
							30.438854011000043
						],
						[
							-81.68608890799993,
							30.438887010000087
						],
						[
							-81.68561590799993,
							30.43890201000005
						],
						[
							-81.6829759069999,
							30.438938010000072
						],
						[
							-81.68180790699995,
							30.43896301000007
						],
						[
							-81.6807409079999,
							30.438988011000053
						],
						[
							-81.6787669069999,
							30.439006010000075
						],
						[
							-81.67862190799991,
							30.438997010000037
						],
						[
							-81.67791790799993,
							30.43886901000008
						],
						[
							-81.67769584899992,
							30.438807830000087
						],
						[
							-81.67758399299993,
							30.438962112000073
						],
						[
							-81.67752490799995,
							30.438994007000076
						],
						[
							-81.67744990799991,
							30.43900801000007
						],
						[
							-81.67177577599995,
							30.43909588100007
						],
						[
							-81.67178190699991,
							30.44029301000006
						],
						[
							-81.6718279079999,
							30.442670010000082
						],
						[
							-81.6718249079999,
							30.443088011000043
						],
						[
							-81.67180090699992,
							30.443501010000038
						],
						[
							-81.67175590799991,
							30.443845010000075
						],
						[
							-81.67163990799992,
							30.44433501100008
						],
						[
							-81.67108379099994,
							30.446296022000066
						],
						[
							-81.66981601599991,
							30.444187930000055
						],
						[
							-81.66659690599994,
							30.44137100800009
						],
						[
							-81.66504990599992,
							30.44001700800004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Highlands",
				"RegionID": "124725"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.98991894099993,
					28.054900916000065,
					-81.97044605199994,
					28.07897875100008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.97384805099996,
							28.068946256000064
						],
						[
							-81.9738677979999,
							28.065500000000043
						],
						[
							-81.97388596799993,
							28.06232900300006
						],
						[
							-81.97392976799996,
							28.061413885000036
						],
						[
							-81.97400806099995,
							28.06140005400005
						],
						[
							-81.9736709089999,
							28.06109801100007
						],
						[
							-81.97306092499991,
							28.060543819000088
						],
						[
							-81.97301189399991,
							28.06057720000007
						],
						[
							-81.97234277199993,
							28.059932955000082
						],
						[
							-81.97242690899992,
							28.05993201000007
						],
						[
							-81.97251104499992,
							28.059932064000066
						],
						[
							-81.97225791099993,
							28.05969600900005
						],
						[
							-81.97218591099994,
							28.05960701000004
						],
						[
							-81.9721129109999,
							28.059509010000056
						],
						[
							-81.97205791099992,
							28.059416010000064
						],
						[
							-81.97201391099993,
							28.059307010000055
						],
						[
							-81.9719269119999,
							28.059116009000036
						],
						[
							-81.9718609119999,
							28.058862009000052
						],
						[
							-81.97184791099994,
							28.05871601000007
						],
						[
							-81.97184791099994,
							28.05855701100006
						],
						[
							-81.97184104299994,
							28.05769387500004
						],
						[
							-81.97178678199992,
							28.05769414000008
						],
						[
							-81.97178291099993,
							28.05682801000006
						],
						[
							-81.97178290999994,
							28.056649010000058
						],
						[
							-81.97175490899991,
							28.05643600800005
						],
						[
							-81.97163790999991,
							28.05610001100007
						],
						[
							-81.97145090999993,
							28.055761010000086
						],
						[
							-81.97135290999995,
							28.055634010000063
						],
						[
							-81.9711649109999,
							28.055452011000057
						],
						[
							-81.97070491099993,
							28.055106011000078
						],
						[
							-81.97044605199994,
							28.05491395200005
						],
						[
							-81.97054380899993,
							28.05491110400004
						],
						[
							-81.9708790119999,
							28.054900916000065
						],
						[
							-81.97206191099991,
							28.055791011000057
						],
						[
							-81.9736669099999,
							28.057029010000065
						],
						[
							-81.97465290999993,
							28.057807009000044
						],
						[
							-81.97626291099994,
							28.059037010000054
						],
						[
							-81.9765279099999,
							28.059235010000066
						],
						[
							-81.9775819109999,
							28.060024010000063
						],
						[
							-81.97845190999993,
							28.06071901000007
						],
						[
							-81.97965392499992,
							28.061618972000076
						],
						[
							-81.9804778489999,
							28.062285186000057
						],
						[
							-81.98075391099991,
							28.06228501000004
						],
						[
							-81.98143491099995,
							28.06228501000004
						],
						[
							-81.9819199879999,
							28.06228496100005
						],
						[
							-81.98220676399991,
							28.063635100000056
						],
						[
							-81.9823040469999,
							28.063710128000082
						],
						[
							-81.98230399999994,
							28.063744000000042
						],
						[
							-81.98348399999992,
							28.064655000000073
						],
						[
							-81.98369799999995,
							28.064820000000054
						],
						[
							-81.98372363599992,
							28.064809091000086
						],
						[
							-81.98384391099995,
							28.064898010000036
						],
						[
							-81.98407091199994,
							28.065073011000038
						],
						[
							-81.98439191099993,
							28.065324011000087
						],
						[
							-81.98654691199994,
							28.066994010000087
						],
						[
							-81.9877719129999,
							28.067967011000064
						],
						[
							-81.98829191099992,
							28.068430010000043
						],
						[
							-81.98872191099991,
							28.068920010000056
						],
						[
							-81.98904391199994,
							28.069344011000055
						],
						[
							-81.9892879109999,
							28.06968400900007
						],
						[
							-81.9897789119999,
							28.07041200900005
						],
						[
							-81.98991894099993,
							28.07064891400006
						],
						[
							-81.98991359799993,
							28.07065292100009
						],
						[
							-81.98917188899992,
							28.07120919500005
						],
						[
							-81.98911193499993,
							28.071130826000058
						],
						[
							-81.98893791099994,
							28.071258010000065
						],
						[
							-81.98691391299991,
							28.07273620300009
						],
						[
							-81.98678590999992,
							28.07264401100008
						],
						[
							-81.98648294499993,
							28.072424933000036
						],
						[
							-81.98643487899994,
							28.072419587000073
						],
						[
							-81.98535591199993,
							28.071652011000083
						],
						[
							-81.98501691099995,
							28.071413009000082
						],
						[
							-81.98474691099995,
							28.07122301000004
						],
						[
							-81.98421091099993,
							28.070846010000082
						],
						[
							-81.98366191199995,
							28.070354010000074
						],
						[
							-81.98294091199995,
							28.069652010000084
						],
						[
							-81.98244491199996,
							28.06916000900009
						],
						[
							-81.98236691299991,
							28.069082011000035
						],
						[
							-81.98156791199995,
							28.06837801000006
						],
						[
							-81.98147391099991,
							28.068300010000087
						],
						[
							-81.98021991199994,
							28.067223009000088
						],
						[
							-81.98005090099991,
							28.06706582600009
						],
						[
							-81.9791504559999,
							28.068036832000075
						],
						[
							-81.9791116639999,
							28.069829263000088
						],
						[
							-81.97922873099992,
							28.07657017500009
						],
						[
							-81.9775530849999,
							28.078245580000043
						],
						[
							-81.97646213199994,
							28.07894711000006
						],
						[
							-81.97379056499994,
							28.07897875100008
						],
						[
							-81.97384805099996,
							28.068946256000064
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Polk",
				"City": "Lakeland",
				"Name": "Kathleen",
				"RegionID": "124905"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.6828629709999,
					30.380186827000045,
					-81.66050222699994,
					30.40566420000005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.66757804999992,
							30.400989859000052
						],
						[
							-81.66753444599993,
							30.399474096000063
						],
						[
							-81.66750899999994,
							30.399476322000055
						],
						[
							-81.66739799999993,
							30.399476322000055
						],
						[
							-81.66726639299992,
							30.399466743000065
						],
						[
							-81.6671949229999,
							30.39946116200008
						],
						[
							-81.66706311899992,
							30.39944565600007
						],
						[
							-81.66691240999995,
							30.399435142000073
						],
						[
							-81.66681883399991,
							30.399423660000082
						],
						[
							-81.66673567099991,
							30.399404892000067
						],
						[
							-81.6667134029999,
							30.399398745000042
						],
						[
							-81.66660670599992,
							30.39939787600008
						],
						[
							-81.66638042999995,
							30.399381150000067
						],
						[
							-81.66616899799993,
							30.399367286000086
						],
						[
							-81.66537790299992,
							30.399366321000063
						],
						[
							-81.6652228339999,
							30.399352659000044
						],
						[
							-81.6650714139999,
							30.39931208600007
						],
						[
							-81.66492933899991,
							30.399245835000045
						],
						[
							-81.66480092699993,
							30.399155920000055
						],
						[
							-81.66469007899991,
							30.399045073000078
						],
						[
							-81.66460016399992,
							30.398916661000044
						],
						[
							-81.66453391399995,
							30.398774586000062
						],
						[
							-81.66449334099991,
							30.398623165000064
						],
						[
							-81.66448623699995,
							30.398575419000053
						],
						[
							-81.66442223699994,
							30.398048419000073
						],
						[
							-81.66441620499995,
							30.397970805000057
						],
						[
							-81.6644169089999,
							30.397892960000036
						],
						[
							-81.6644243419999,
							30.397815467000047
						],
						[
							-81.66443844799994,
							30.397738907000075
						],
						[
							-81.66445912299992,
							30.397663855000076
						],
						[
							-81.66460122799992,
							30.397223419000056
						],
						[
							-81.66460696299993,
							30.39719106900009
						],
						[
							-81.66455475899994,
							30.397106896000082
						],
						[
							-81.66444384199991,
							30.39703171800005
						],
						[
							-81.66305321499993,
							30.39686383900005
						],
						[
							-81.66300483499992,
							30.396856659000036
						],
						[
							-81.66285341399994,
							30.396816086000058
						],
						[
							-81.66271133899994,
							30.396749836000083
						],
						[
							-81.6625829269999,
							30.396659920000047
						],
						[
							-81.66247207999993,
							30.396549073000077
						],
						[
							-81.66238216399995,
							30.39642066100004
						],
						[
							-81.66237187299993,
							30.396402345000073
						],
						[
							-81.6621138729999,
							30.39593034500007
						],
						[
							-81.66205791399994,
							30.39580658600005
						],
						[
							-81.66204662399991,
							30.39577359000009
						],
						[
							-81.66188662299993,
							30.395274590000042
						],
						[
							-81.66185733999993,
							30.39515616600005
						],
						[
							-81.66184430099992,
							30.395033479000062
						],
						[
							-81.66182850399991,
							30.39460941300007
						],
						[
							-81.6611186479999,
							30.394089566000044
						],
						[
							-81.66106350799993,
							30.394045768000066
						],
						[
							-81.66077659099994,
							30.393798947000054
						],
						[
							-81.66053558499993,
							30.393631366000076
						],
						[
							-81.66051734699995,
							30.39361834500005
						],
						[
							-81.66050222699994,
							30.393607263000035
						],
						[
							-81.66104899999993,
							30.392893000000072
						],
						[
							-81.66293290499993,
							30.39043200900005
						],
						[
							-81.6659920809999,
							30.386116953000055
						],
						[
							-81.66511174699991,
							30.385739109000042
						],
						[
							-81.6651430789999,
							30.385343946000038
						],
						[
							-81.66464790599991,
							30.384810009000034
						],
						[
							-81.66368983799993,
							30.38395705500005
						],
						[
							-81.66356571699993,
							30.38360997100006
						],
						[
							-81.66425390599994,
							30.382906009000067
						],
						[
							-81.66548290599991,
							30.381850009000058
						],
						[
							-81.66626583499993,
							30.381043839000085
						],
						[
							-81.6677640229999,
							30.381080154000074
						],
						[
							-81.66795175999994,
							30.380203900000083
						],
						[
							-81.66798489699994,
							30.380186827000045
						],
						[
							-81.66801887299994,
							30.380203056000084
						],
						[
							-81.67013190599994,
							30.382237197000055
						],
						[
							-81.67125684899992,
							30.38116598500005
						],
						[
							-81.67345600499993,
							30.380557154000087
						],
						[
							-81.67356495299993,
							30.380418880000033
						],
						[
							-81.6735499049999,
							30.38074200800008
						],
						[
							-81.6734989059999,
							30.381001008000055
						],
						[
							-81.67348890499994,
							30.381050008000045
						],
						[
							-81.6733918139999,
							30.38135512100007
						],
						[
							-81.6735899869999,
							30.38124285800006
						],
						[
							-81.67360190599993,
							30.38140800800005
						],
						[
							-81.67360590499993,
							30.38150300800004
						],
						[
							-81.67359690599994,
							30.38163300900004
						],
						[
							-81.67356790599992,
							30.381854008000065
						],
						[
							-81.67355990599992,
							30.382001009000078
						],
						[
							-81.67355590599993,
							30.382131008000048
						],
						[
							-81.67355190599994,
							30.382237008000065
						],
						[
							-81.67355590599993,
							30.382306008000057
						],
						[
							-81.67355990699991,
							30.382381008000035
						],
						[
							-81.67357890599993,
							30.382474009000077
						],
						[
							-81.67359890599994,
							30.382574009000052
						],
						[
							-81.67364090599995,
							30.382761009000035
						],
						[
							-81.67367208799993,
							30.382893040000056
						],
						[
							-81.67361790599995,
							30.382978009000055
						],
						[
							-81.67358590499992,
							30.383030008000052
						],
						[
							-81.67352772899994,
							30.383105965000087
						],
						[
							-81.67361474699993,
							30.383549086000073
						],
						[
							-81.67414490599992,
							30.384115008000034
						],
						[
							-81.67452990599992,
							30.38457500900006
						],
						[
							-81.6748569049999,
							30.384972009000084
						],
						[
							-81.67491890499991,
							30.38504800900006
						],
						[
							-81.6753459059999,
							30.38561100900006
						],
						[
							-81.6761859049999,
							30.38665000900005
						],
						[
							-81.67720790599992,
							30.38794500800009
						],
						[
							-81.67770390599992,
							30.388552009000076
						],
						[
							-81.6779169049999,
							30.38883600800006
						],
						[
							-81.67835190599993,
							30.389465009000048
						],
						[
							-81.67851990499992,
							30.389742009000088
						],
						[
							-81.67925983799995,
							30.390945062000075
						],
						[
							-81.67948394699994,
							30.391255967000063
						],
						[
							-81.67964295899992,
							30.39136893600005
						],
						[
							-81.67977690599992,
							30.39154400900009
						],
						[
							-81.6799209049999,
							30.39175300900007
						],
						[
							-81.68019790499994,
							30.392150008000044
						],
						[
							-81.6804129059999,
							30.39243300800007
						],
						[
							-81.6807019659999,
							30.39271093900004
						],
						[
							-81.68107890499994,
							30.393012009000074
						],
						[
							-81.68109790499994,
							30.393027009000036
						],
						[
							-81.68158490599991,
							30.39347100900005
						],
						[
							-81.68176490499991,
							30.393651009000056
						],
						[
							-81.68178490499992,
							30.393676008000053
						],
						[
							-81.68209090499994,
							30.394041009000034
						],
						[
							-81.6822799059999,
							30.39427500900007
						],
						[
							-81.68237440599995,
							30.394409510000063
						],
						[
							-81.68246898599995,
							30.394568966000065
						],
						[
							-81.68263390599992,
							30.39492100800004
						],
						[
							-81.68267290599994,
							30.395013008000035
						],
						[
							-81.68271199999992,
							30.395084000000058
						],
						[
							-81.6828629709999,
							30.395440137000033
						],
						[
							-81.68276587799994,
							30.39542719100007
						],
						[
							-81.68208679199995,
							30.39545952800006
						],
						[
							-81.68124601799991,
							30.395815240000047
						],
						[
							-81.68063160699995,
							30.39594459000006
						],
						[
							-81.67969382199993,
							30.396397314000072
						],
						[
							-81.67875603599992,
							30.39678536300005
						],
						[
							-81.67878837299992,
							30.39785249800008
						],
						[
							-81.67872369899995,
							30.398725609000056
						],
						[
							-81.67846499899991,
							30.399469370000077
						],
						[
							-81.67827097499992,
							30.400374818000046
						],
						[
							-81.6784973369999,
							30.40128026600007
						],
						[
							-81.67823863699994,
							30.401862340000037
						],
						[
							-81.67791449399994,
							30.40242457000005
						],
						[
							-81.6767875779999,
							30.40399443900009
						],
						[
							-81.6767459209999,
							30.404048073000073
						],
						[
							-81.67667890199994,
							30.40411963000008
						],
						[
							-81.67569213199994,
							30.405064259000085
						],
						[
							-81.6756383629999,
							30.405114887000085
						],
						[
							-81.67558204699992,
							30.405163653000045
						],
						[
							-81.67552188899992,
							30.40520759000009
						],
						[
							-81.67545830099994,
							30.405246398000088
						],
						[
							-81.67539171899995,
							30.40527981000008
						],
						[
							-81.67493271799992,
							30.40548681000007
						],
						[
							-81.6748742719999,
							30.405510736000053
						],
						[
							-81.6748142909999,
							30.405530501000044
						],
						[
							-81.67475307099994,
							30.40554600700006
						],
						[
							-81.67469091299995,
							30.405557179000084
						],
						[
							-81.67400891299991,
							30.40565517800007
						],
						[
							-81.67393773599991,
							30.40566253000009
						],
						[
							-81.67386619899992,
							30.40566420000005
						],
						[
							-81.67379475599995,
							30.405660177000076
						],
						[
							-81.67372385999994,
							30.40565048600007
						],
						[
							-81.67365395799993,
							30.405635190000055
						],
						[
							-81.6735854929999,
							30.40561438500003
						],
						[
							-81.67250445299993,
							30.405238236000063
						],
						[
							-81.67235072299991,
							30.40516654000004
						],
						[
							-81.67165310899992,
							30.40475024300008
						],
						[
							-81.67158977199995,
							30.40470872900005
						],
						[
							-81.66994077099992,
							30.403525729000076
						],
						[
							-81.66988692699994,
							30.403483920000046
						],
						[
							-81.66977607899992,
							30.40337307300007
						],
						[
							-81.66968616399994,
							30.403244661000087
						],
						[
							-81.6696199129999,
							30.403102586000042
						],
						[
							-81.66959797099992,
							30.403033832000066
						],
						[
							-81.66939020799992,
							30.402279592000074
						],
						[
							-81.66909415399994,
							30.402038202000085
						],
						[
							-81.66826589899995,
							30.401838194000053
						],
						[
							-81.66816941299993,
							30.401809086000068
						],
						[
							-81.66802733899993,
							30.40174283500005
						],
						[
							-81.6678989269999,
							30.401652920000064
						],
						[
							-81.66778807899993,
							30.401542073000087
						],
						[
							-81.66769816399994,
							30.40141366100005
						],
						[
							-81.66763191299992,
							30.40127158600006
						],
						[
							-81.66759133999994,
							30.401120165000066
						],
						[
							-81.66757804999992,
							30.400989859000052
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Lake Forest",
				"RegionID": "124989"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.69977434799995,
					30.378837009000055,
					-81.67925983799995,
					30.401183254000046
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.69217607099995,
							30.398790284000082
						],
						[
							-81.6920829579999,
							30.397866049000072
						],
						[
							-81.69211792699991,
							30.397831080000064
						],
						[
							-81.69216695599994,
							30.397792751000054
						],
						[
							-81.6922412749999,
							30.397738686000086
						],
						[
							-81.69223867799991,
							30.39770900000008
						],
						[
							-81.69224817299994,
							30.397600469000057
						],
						[
							-81.6919520909999,
							30.39733062200008
						],
						[
							-81.69163536999991,
							30.39707800800005
						],
						[
							-81.69136075199992,
							30.396941834000074
						],
						[
							-81.6905268619999,
							30.39646198900004
						],
						[
							-81.6895567389999,
							30.395815240000047
						],
						[
							-81.68913635199993,
							30.395879915000084
						],
						[
							-81.6882632409999,
							30.396203289000088
						],
						[
							-81.68700208199994,
							30.39646198900004
						],
						[
							-81.68638766999993,
							30.39646198900004
						],
						[
							-81.68577325899992,
							30.396300302000046
						],
						[
							-81.68506183599993,
							30.39597692700005
						],
						[
							-81.6843504119999,
							30.395718228000078
						],
						[
							-81.68373600099994,
							30.395556541000076
						],
						[
							-81.6828629709999,
							30.395440137000033
						],
						[
							-81.68271199999992,
							30.395084000000058
						],
						[
							-81.68267290599994,
							30.395013008000035
						],
						[
							-81.68263390599992,
							30.39492100800004
						],
						[
							-81.68246898599995,
							30.394568966000065
						],
						[
							-81.68237440599995,
							30.394409510000063
						],
						[
							-81.6822799059999,
							30.39427500900007
						],
						[
							-81.68209090499994,
							30.394041009000034
						],
						[
							-81.68178490499992,
							30.393676008000053
						],
						[
							-81.68176490499991,
							30.393651009000056
						],
						[
							-81.68158490599991,
							30.39347100900005
						],
						[
							-81.68109790499994,
							30.393027009000036
						],
						[
							-81.68107890499994,
							30.393012009000074
						],
						[
							-81.6807019659999,
							30.39271093900004
						],
						[
							-81.6804129059999,
							30.39243300800007
						],
						[
							-81.68019790499994,
							30.392150008000044
						],
						[
							-81.6799209049999,
							30.39175300900007
						],
						[
							-81.67977690599992,
							30.39154400900009
						],
						[
							-81.67964295899992,
							30.39136893600005
						],
						[
							-81.67948394699994,
							30.391255967000063
						],
						[
							-81.67925983799995,
							30.390945062000075
						],
						[
							-81.68042590599993,
							30.390253008000062
						],
						[
							-81.68161790599993,
							30.38954400800009
						],
						[
							-81.6828499049999,
							30.388837008000056
						],
						[
							-81.68405490599991,
							30.388148009000076
						],
						[
							-81.6852359049999,
							30.387440009000045
						],
						[
							-81.68647490599994,
							30.386737009000058
						],
						[
							-81.68718690499992,
							30.386326008000083
						],
						[
							-81.68994290599994,
							30.38473300800007
						],
						[
							-81.69029390499992,
							30.384518009000086
						],
						[
							-81.69040890499991,
							30.384439008000076
						],
						[
							-81.6908659049999,
							30.384140008000088
						],
						[
							-81.69101090599992,
							30.38400801000006
						],
						[
							-81.69127790499994,
							30.383804008000084
						],
						[
							-81.69164990599995,
							30.383474008000064
						],
						[
							-81.69177190599993,
							30.383379008000077
						],
						[
							-81.69205990599994,
							30.383155009000067
						],
						[
							-81.69236390599993,
							30.38289700900009
						],
						[
							-81.69319490599992,
							30.382219009000043
						],
						[
							-81.69409290499993,
							30.381460009000083
						],
						[
							-81.69541696699991,
							30.38038207100004
						],
						[
							-81.69550890599993,
							30.380301009000046
						],
						[
							-81.69569190499993,
							30.38016800800006
						],
						[
							-81.6958369059999,
							30.38003800900009
						],
						[
							-81.69600490499994,
							30.379909009000077
						],
						[
							-81.6961509059999,
							30.37978100900006
						],
						[
							-81.69647090599994,
							30.379554008000074
						],
						[
							-81.69663890599992,
							30.37945800800009
						],
						[
							-81.69696690599994,
							30.379294009000034
						],
						[
							-81.69753190599994,
							30.37907500900008
						],
						[
							-81.6978829059999,
							30.378979008000044
						],
						[
							-81.69827290599994,
							30.378895009000072
						],
						[
							-81.69864690599992,
							30.378851008000087
						],
						[
							-81.6989589069999,
							30.378837009000055
						],
						[
							-81.69916489499991,
							30.37883800800006
						],
						[
							-81.69915786799993,
							30.379156021000085
						],
						[
							-81.69918790499992,
							30.380180008000078
						],
						[
							-81.69919590599994,
							30.38071100900004
						],
						[
							-81.69918790499992,
							30.381016008000078
						],
						[
							-81.69913490599993,
							30.381618008000093
						],
						[
							-81.69909690599991,
							30.38224000800005
						],
						[
							-81.69906582199991,
							30.382421005000086
						],
						[
							-81.69901290699994,
							30.38318801000008
						],
						[
							-81.69895190699992,
							30.383762011000044
						],
						[
							-81.69890690699994,
							30.384414011000047
						],
						[
							-81.6988689069999,
							30.384772011000052
						],
						[
							-81.69883890699992,
							30.38492701100006
						],
						[
							-81.69877095399994,
							30.385117036000054
						],
						[
							-81.69871790699995,
							30.38519101000009
						],
						[
							-81.69867890699993,
							30.38524901000005
						],
						[
							-81.69852490699992,
							30.38542401000007
						],
						[
							-81.69824190799994,
							30.385679010000047
						],
						[
							-81.69753290699992,
							30.38631801100007
						],
						[
							-81.69713590799995,
							30.38669201000005
						],
						[
							-81.6969299079999,
							30.386913010000058
						],
						[
							-81.69685390799992,
							30.387024013000083
						],
						[
							-81.6967619099999,
							30.387232012000084
						],
						[
							-81.69673890899992,
							30.387398010000087
						],
						[
							-81.69673890899992,
							30.38752401000005
						],
						[
							-81.69676190799993,
							30.387695010000073
						],
						[
							-81.69679290699992,
							30.38781701100004
						],
						[
							-81.69680790699994,
							30.387941010000077
						],
						[
							-81.69697590699991,
							30.388828010000054
						],
						[
							-81.69697590999995,
							30.38886500900009
						],
						[
							-81.69703690799992,
							30.389122011000037
						],
						[
							-81.69716590799993,
							30.389818010000056
						],
						[
							-81.69720490799995,
							30.38999601100005
						],
						[
							-81.69735690699991,
							30.390900011000046
						],
						[
							-81.69735690899995,
							30.390940009000072
						],
						[
							-81.6975859069999,
							30.39210501000008
						],
						[
							-81.69778390699992,
							30.392918010000074
						],
						[
							-81.69779590799993,
							30.39297201100004
						],
						[
							-81.69791690699992,
							30.39347401200007
						],
						[
							-81.69792907999994,
							30.393772052000088
						],
						[
							-81.69782990699993,
							30.393955010000074
						],
						[
							-81.6977689069999,
							30.394035009000046
						],
						[
							-81.69767790799995,
							30.39412101000005
						],
						[
							-81.69752490799993,
							30.39422600900008
						],
						[
							-81.69739490699993,
							30.394291010000078
						],
						[
							-81.69729990699994,
							30.394322010000053
						],
						[
							-81.6968609079999,
							30.394464010000036
						],
						[
							-81.6965709079999,
							30.394579010000083
						],
						[
							-81.6965259079999,
							30.394604011000066
						],
						[
							-81.69636490799991,
							30.39473701100008
						],
						[
							-81.69626590899992,
							30.394855010000075
						],
						[
							-81.69621990999991,
							30.394941010000085
						],
						[
							-81.69618990799995,
							30.39503501100006
						],
						[
							-81.69617490899992,
							30.39512301000008
						],
						[
							-81.69617485599991,
							30.39526001900009
						],
						[
							-81.69624290799993,
							30.39549401000005
						],
						[
							-81.69647990699991,
							30.396109011000075
						],
						[
							-81.69705990699993,
							30.39752201000005
						],
						[
							-81.69741079799991,
							30.39844317000006
						],
						[
							-81.69753290799993,
							30.398439009000068
						],
						[
							-81.69777689099993,
							30.39840292000008
						],
						[
							-81.69853990699994,
							30.398218011000036
						],
						[
							-81.6990219079999,
							30.39811001000004
						],
						[
							-81.6996420129999,
							30.397966853000074
						],
						[
							-81.6997179999999,
							30.398330000000044
						],
						[
							-81.69977434799995,
							30.398599292000082
						],
						[
							-81.69945199299991,
							30.39862859700008
						],
						[
							-81.69916095699996,
							30.39882262100008
						],
						[
							-81.6988375819999,
							30.399048984000046
						],
						[
							-81.69841719599992,
							30.399243008000045
						],
						[
							-81.6978351219999,
							30.399501708000056
						],
						[
							-81.69766153099994,
							30.399608533000052
						],
						[
							-81.69741473499994,
							30.39976040700009
						],
						[
							-81.69696201099993,
							30.40005144400004
						],
						[
							-81.69625058799994,
							30.400601180000077
						],
						[
							-81.69563617599994,
							30.401021567000043
						],
						[
							-81.69518345199992,
							30.401183254000046
						],
						[
							-81.69482773999994,
							30.401183254000046
						],
						[
							-81.69437501599992,
							30.401086242000076
						],
						[
							-81.69405164199992,
							30.400956892000064
						],
						[
							-81.69372826799992,
							30.40073053000009
						],
						[
							-81.69340489299992,
							30.400439493000082
						],
						[
							-81.69301684399994,
							30.400019107000045
						],
						[
							-81.6924671079999,
							30.39937235800005
						],
						[
							-81.69217607099995,
							30.398790284000082
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Lake Forest Hills",
				"RegionID": "124991"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.63275495999994,
					30.15867700800004,
					-81.59954884299992,
					30.181648003000078
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.6243270889999,
							30.17899001100005
						],
						[
							-81.62013584899995,
							30.175779850000083
						],
						[
							-81.6200759749999,
							30.176061165000082
						],
						[
							-81.61925490699991,
							30.175491010000083
						],
						[
							-81.6188739079999,
							30.17524101100008
						],
						[
							-81.61811790799993,
							30.17476301000005
						],
						[
							-81.61778290799992,
							30.174559011000042
						],
						[
							-81.61706490799992,
							30.17413901000009
						],
						[
							-81.61629490699994,
							30.17370401100004
						],
						[
							-81.61589090799993,
							30.173492010000075
						],
						[
							-81.61505090799994,
							30.173067010000068
						],
						[
							-81.61417390799994,
							30.172651011000088
						],
						[
							-81.61327390699995,
							30.17224901000009
						],
						[
							-81.61233490699995,
							30.171860010000046
						],
						[
							-81.6116739069999,
							30.17160201100006
						],
						[
							-81.61098690799992,
							30.17134101100004
						],
						[
							-81.6101369079999,
							30.171046010000055
						],
						[
							-81.60970190699993,
							30.17090501000007
						],
						[
							-81.60920990799991,
							30.170760010000034
						],
						[
							-81.60839590699995,
							30.170520011000065
						],
						[
							-81.60760090899993,
							30.17030601100004
						],
						[
							-81.60720290699993,
							30.170227011000062
						],
						[
							-81.60677790799991,
							30.170124010000052
						],
						[
							-81.60584790799993,
							30.169905011000083
						],
						[
							-81.60525690799994,
							30.169778011000062
						],
						[
							-81.60456190799994,
							30.169633010000037
						],
						[
							-81.60407290699993,
							30.169545011000082
						],
						[
							-81.60358290799991,
							30.169469010000057
						],
						[
							-81.60331190799991,
							30.169424010000057
						],
						[
							-81.60286590699992,
							30.169368011000078
						],
						[
							-81.60247688599992,
							30.169312012000038
						],
						[
							-81.60237090899994,
							30.169049010000037
						],
						[
							-81.60223990599991,
							30.168502010000058
						],
						[
							-81.6020599069999,
							30.167864011000063
						],
						[
							-81.60197190899993,
							30.16760101100004
						],
						[
							-81.60143690899991,
							30.16568001100006
						],
						[
							-81.60134790599994,
							30.165384010000082
						],
						[
							-81.60130290699993,
							30.16528400800007
						],
						[
							-81.60127990899991,
							30.165178012000073
						],
						[
							-81.60109690599995,
							30.164733010000077
						],
						[
							-81.6005309059999,
							30.16307301000006
						],
						[
							-81.60039890699994,
							30.162674010000046
						],
						[
							-81.59982190699994,
							30.161084011000067
						],
						[
							-81.59954884299992,
							30.160442096000054
						],
						[
							-81.60022590599993,
							30.160511009000057
						],
						[
							-81.60056690599993,
							30.160530008000077
						],
						[
							-81.60074990599992,
							30.160517007000067
						],
						[
							-81.60094390599994,
							30.160472009000046
						],
						[
							-81.60133290599993,
							30.160368009000084
						],
						[
							-81.60147090599992,
							30.160337009000045
						],
						[
							-81.60182590599993,
							30.160250008000045
						],
						[
							-81.6022189059999,
							30.160154009000053
						],
						[
							-81.60298890599995,
							30.15996600800008
						],
						[
							-81.60417190599992,
							30.159679008000072
						],
						[
							-81.60469590499991,
							30.15955100900004
						],
						[
							-81.60501790599994,
							30.15950100800006
						],
						[
							-81.60545290599993,
							30.15947700900006
						],
						[
							-81.60589590599994,
							30.159477008000067
						],
						[
							-81.60616890599994,
							30.159477008000067
						],
						[
							-81.60633090599993,
							30.159481008000057
						],
						[
							-81.60689590599992,
							30.159470008000085
						],
						[
							-81.6074449059999,
							30.15941600900004
						],
						[
							-81.60747690599995,
							30.159413009000048
						],
						[
							-81.60808890599994,
							30.15934600800006
						],
						[
							-81.6082789059999,
							30.159325008000053
						],
						[
							-81.60840990499992,
							30.159311008000085
						],
						[
							-81.6087049059999,
							30.15927300800007
						],
						[
							-81.61140390599991,
							30.15892800900008
						],
						[
							-81.61202190599995,
							30.158842008000075
						],
						[
							-81.61312990499994,
							30.15871500900005
						],
						[
							-81.61359690599994,
							30.158681009000073
						],
						[
							-81.61389090399992,
							30.15867700800004
						],
						[
							-81.61418990599992,
							30.158694009000044
						],
						[
							-81.61440290599995,
							30.158720008000046
						],
						[
							-81.61452490599993,
							30.158739008000058
						],
						[
							-81.61466290599992,
							30.158765008000046
						],
						[
							-81.61542890499993,
							30.15889500800006
						],
						[
							-81.61650790499993,
							30.159082009000088
						],
						[
							-81.61666090499995,
							30.159113009000066
						],
						[
							-81.61732490499992,
							30.159231008000063
						],
						[
							-81.61794990499993,
							30.159340008000072
						],
						[
							-81.61911790499995,
							30.159548008000055
						],
						[
							-81.61978890599994,
							30.159658008000065
						],
						[
							-81.62242090599995,
							30.159992008000074
						],
						[
							-81.62454190499994,
							30.160263008000072
						],
						[
							-81.62562190599994,
							30.160412009000087
						],
						[
							-81.62639590499992,
							30.16050500900008
						],
						[
							-81.6286999049999,
							30.160799009000073
						],
						[
							-81.62918090499994,
							30.160862009000084
						],
						[
							-81.62949390599994,
							30.16089200800008
						],
						[
							-81.62994390599994,
							30.160908008000032
						],
						[
							-81.63132490499993,
							30.160875008000062
						],
						[
							-81.63159190599993,
							30.160873008000067
						],
						[
							-81.63257290599995,
							30.160852008000067
						],
						[
							-81.63275495999994,
							30.160850010000047
						],
						[
							-81.63271390599994,
							30.16259800800009
						],
						[
							-81.63269190599993,
							30.163564009000083
						],
						[
							-81.63265790499992,
							30.16460000800004
						],
						[
							-81.63264690599993,
							30.16486100800006
						],
						[
							-81.63260790599992,
							30.165138008000042
						],
						[
							-81.63254090499993,
							30.16553700800006
						],
						[
							-81.6324399049999,
							30.165912009000067
						],
						[
							-81.6323059049999,
							30.16627300900007
						],
						[
							-81.63213490499993,
							30.16664000900005
						],
						[
							-81.63200290599991,
							30.166881008000075
						],
						[
							-81.63176490599994,
							30.167256009000088
						],
						[
							-81.63070990499995,
							30.168694008000045
						],
						[
							-81.63025390599995,
							30.16931500800007
						],
						[
							-81.63015790599991,
							30.169468008000084
						],
						[
							-81.62999890599991,
							30.16973600900008
						],
						[
							-81.62982190499991,
							30.17009900800008
						],
						[
							-81.6296479049999,
							30.170555009000054
						],
						[
							-81.62960090599995,
							30.170660008000084
						],
						[
							-81.62922590499994,
							30.17165400900007
						],
						[
							-81.62905090499993,
							30.172120009000086
						],
						[
							-81.62883490599995,
							30.172675008000056
						],
						[
							-81.62830990599991,
							30.17409500800005
						],
						[
							-81.62812890499993,
							30.174679009000045
						],
						[
							-81.62803690499993,
							30.174988009000064
						],
						[
							-81.62797490499992,
							30.17529500900008
						],
						[
							-81.62794890599992,
							30.17543100900008
						],
						[
							-81.62791490599996,
							30.175654008000038
						],
						[
							-81.62788190499992,
							30.175853009000036
						],
						[
							-81.62786190499992,
							30.17605000800006
						],
						[
							-81.62784490599995,
							30.17638900900005
						],
						[
							-81.6278649059999,
							30.176803008000036
						],
						[
							-81.62788190499992,
							30.17694300900007
						],
						[
							-81.62798690599993,
							30.177700008000045
						],
						[
							-81.62799890499991,
							30.17779600900008
						],
						[
							-81.62804190599991,
							30.178112008000085
						],
						[
							-81.62817190599992,
							30.17906800800006
						],
						[
							-81.62824990599995,
							30.17961900800009
						],
						[
							-81.62829690599995,
							30.17997000800006
						],
						[
							-81.62837090599993,
							30.180480008000075
						],
						[
							-81.62848690499993,
							30.181257008000046
						],
						[
							-81.62850990599992,
							30.181383010000047
						],
						[
							-81.62854390399991,
							30.181648003000078
						],
						[
							-81.62827790799992,
							30.181539010000048
						],
						[
							-81.62823005599995,
							30.181517062000072
						],
						[
							-81.6279669079999,
							30.181397010000065
						],
						[
							-81.62764190699994,
							30.181236010000077
						],
						[
							-81.62756590799995,
							30.18119801100005
						],
						[
							-81.62714290699996,
							30.18098301100008
						],
						[
							-81.6269539079999,
							30.18088301100005
						],
						[
							-81.62669290699995,
							30.18074601000006
						],
						[
							-81.62643690699991,
							30.180602010000083
						],
						[
							-81.62617590799994,
							30.180449011000064
						],
						[
							-81.62588090799994,
							30.180273011000054
						],
						[
							-81.62534290699995,
							30.17992801100007
						],
						[
							-81.62488990799994,
							30.179628010000044
						],
						[
							-81.62456990699991,
							30.17939801100005
						],
						[
							-81.62449790799991,
							30.179346010000074
						],
						[
							-81.62416672799992,
							30.17910801100004
						],
						[
							-81.6243270889999,
							30.17899001100005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Loretto",
				"RegionID": "125141"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.38519199999996,
					28.347886000000074,
					-81.31089099999997,
					28.400284000000056
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.31139099999996,
							28.37218500000006
						],
						[
							-81.31118199999997,
							28.37101700000005
						],
						[
							-81.31089099999997,
							28.36938500000008
						],
						[
							-81.31108399999994,
							28.368889000000024
						],
						[
							-81.31159099999996,
							28.367586000000074
						],
						[
							-81.31409099999996,
							28.36518600000005
						],
						[
							-81.31529099999995,
							28.360986000000025
						],
						[
							-81.31469099999998,
							28.360186000000056
						],
						[
							-81.31659099999996,
							28.356786000000056
						],
						[
							-81.31819099999996,
							28.355586000000073
						],
						[
							-81.31849099999994,
							28.35628600000007
						],
						[
							-81.31919099999999,
							28.35548600000004
						],
						[
							-81.31839099999996,
							28.354386000000037
						],
						[
							-81.31929099999996,
							28.353586000000064
						],
						[
							-81.31839099999996,
							28.35328600000003
						],
						[
							-81.31909099999996,
							28.352386000000024
						],
						[
							-81.31969099999998,
							28.350286000000043
						],
						[
							-81.31919099999999,
							28.349486000000073
						],
						[
							-81.32029099999994,
							28.349386000000038
						],
						[
							-81.31969099999998,
							28.34798600000005
						],
						[
							-81.32169099999999,
							28.34798600000005
						],
						[
							-81.32649099999998,
							28.34798600000005
						],
						[
							-81.32959099999994,
							28.34798600000005
						],
						[
							-81.33342899999997,
							28.34798600000005
						],
						[
							-81.33439099999998,
							28.34798600000005
						],
						[
							-81.34269099999995,
							28.34798600000005
						],
						[
							-81.34439199999997,
							28.34798600000005
						],
						[
							-81.34989199999995,
							28.34798600000005
						],
						[
							-81.36097199999995,
							28.347941000000052
						],
						[
							-81.36354999999998,
							28.347931000000074
						],
						[
							-81.37479199999996,
							28.347886000000074
						],
						[
							-81.38289199999997,
							28.347886000000074
						],
						[
							-81.38519199999996,
							28.353386000000057
						],
						[
							-81.37479199999996,
							28.365086000000076
						],
						[
							-81.37429199999998,
							28.36568600000004
						],
						[
							-81.37389199999996,
							28.366186000000027
						],
						[
							-81.37364199999996,
							28.366520000000037
						],
						[
							-81.37294299999996,
							28.368246000000056
						],
						[
							-81.37279199999995,
							28.370886000000045
						],
						[
							-81.37303999999995,
							28.37503400000003
						],
						[
							-81.37349199999994,
							28.382585000000063
						],
						[
							-81.37379199999998,
							28.386585000000025
						],
						[
							-81.37388299999998,
							28.388049000000024
						],
						[
							-81.37395399999997,
							28.389182000000062
						],
						[
							-81.37396799999995,
							28.389402000000075
						],
						[
							-81.37419199999994,
							28.39298500000007
						],
						[
							-81.37479199999996,
							28.400284000000056
						],
						[
							-81.37429199999998,
							28.400284000000056
						],
						[
							-81.37409199999996,
							28.398884000000066
						],
						[
							-81.37119199999995,
							28.395385000000033
						],
						[
							-81.36899199999993,
							28.393185000000074
						],
						[
							-81.36799199999996,
							28.39278500000006
						],
						[
							-81.36719199999999,
							28.39248500000008
						],
						[
							-81.36556199999995,
							28.392532000000074
						],
						[
							-81.36369199999996,
							28.392571000000032
						],
						[
							-81.36170099999998,
							28.392612000000046
						],
						[
							-81.35774599999998,
							28.392667000000074
						],
						[
							-81.33469099999996,
							28.39298500000007
						],
						[
							-81.33419099999998,
							28.393485000000055
						],
						[
							-81.33419099999998,
							28.396184000000062
						],
						[
							-81.33359099999996,
							28.396484000000044
						],
						[
							-81.33129099999996,
							28.396584000000075
						],
						[
							-81.32850599999995,
							28.395719000000042
						],
						[
							-81.32851099999993,
							28.395632000000035
						],
						[
							-81.32851799999997,
							28.393504000000064
						],
						[
							-81.32833699999998,
							28.393501000000075
						],
						[
							-81.32821699999994,
							28.393414000000064
						],
						[
							-81.32821499999994,
							28.393345000000068
						],
						[
							-81.32821299999995,
							28.393234000000064
						],
						[
							-81.32821999999999,
							28.38954000000007
						],
						[
							-81.32821799999995,
							28.38899900000007
						],
						[
							-81.32599899999997,
							28.389022000000068
						],
						[
							-81.32603599999999,
							28.39415100000008
						],
						[
							-81.32603499999999,
							28.39427100000006
						],
						[
							-81.32289099999997,
							28.392385000000047
						],
						[
							-81.32169099999999,
							28.391685000000052
						],
						[
							-81.32199099999997,
							28.39128500000004
						],
						[
							-81.32159099999996,
							28.390085000000056
						],
						[
							-81.32109099999997,
							28.387385000000055
						],
						[
							-81.32069099999995,
							28.383185000000026
						],
						[
							-81.31569099999996,
							28.380685000000028
						],
						[
							-81.31349099999994,
							28.37788500000005
						],
						[
							-81.31299099999995,
							28.377985000000024
						],
						[
							-81.31229099999996,
							28.375285000000076
						],
						[
							-81.31139099999996,
							28.37218500000006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Meadow Woods",
				"RegionID": "125257"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.15311,
					26.18159590100004,
					-80.13393094699995,
					26.203801983000062
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.137156,
							26.203133
						],
						[
							-80.137156,
							26.202328
						],
						[
							-80.13686926799994,
							26.202328
						],
						[
							-80.135516,
							26.202328
						],
						[
							-80.135462,
							26.20233
						],
						[
							-80.135267,
							26.202326
						],
						[
							-80.13521442399997,
							26.20168598600003
						],
						[
							-80.13509023199998,
							26.200174167000057
						],
						[
							-80.13506756099997,
							26.19989819400007
						],
						[
							-80.13428926099994,
							26.199867871000038
						],
						[
							-80.13393094699995,
							26.199853911000048
						],
						[
							-80.13394570799994,
							26.198791103000076
						],
						[
							-80.13481661999998,
							26.198761580000053
						],
						[
							-80.13480735499996,
							26.197103181000045
						],
						[
							-80.13480185899994,
							26.196119322000076
						],
						[
							-80.13903832999995,
							26.196045515000037
						],
						[
							-80.13895148099995,
							26.18889499100004
						],
						[
							-80.13894976199998,
							26.18875347200003
						],
						[
							-80.13895304499994,
							26.188407212000072
						],
						[
							-80.13898279899996,
							26.18526892400007
						],
						[
							-80.13898829699997,
							26.184689054000046
						],
						[
							-80.13898690599996,
							26.18458957100006
						],
						[
							-80.13897995999997,
							26.18409300900004
						],
						[
							-80.13897384699999,
							26.183601505000073
						],
						[
							-80.14005821299997,
							26.18359728400003
						],
						[
							-80.14038381399996,
							26.18359601900005
						],
						[
							-80.14036793799994,
							26.18314619100005
						],
						[
							-80.14026209599996,
							26.18278103600005
						],
						[
							-80.14024621999994,
							26.182500554000057
						],
						[
							-80.14025058899995,
							26.181865569000024
						],
						[
							-80.14025103599994,
							26.18180061100003
						],
						[
							-80.14406099899998,
							26.181715147000034
						],
						[
							-80.14427940299998,
							26.181709445000024
						],
						[
							-80.14454148099998,
							26.181702603000076
						],
						[
							-80.14461677799994,
							26.181734873000043
						],
						[
							-80.14485030799995,
							26.181695706000028
						],
						[
							-80.14486197199994,
							26.181855123000048
						],
						[
							-80.14486281999996,
							26.18186039400007
						],
						[
							-80.14490230699994,
							26.182105746000047
						],
						[
							-80.14649113699994,
							26.182033981000075
						],
						[
							-80.14688244199994,
							26.18204240400007
						],
						[
							-80.14822139499995,
							26.181979546000036
						],
						[
							-80.14859444199999,
							26.181983738000042
						],
						[
							-80.14891349799996,
							26.181987323000044
						],
						[
							-80.14890183399996,
							26.181602389000034
						],
						[
							-80.14957783899996,
							26.181619357000045
						],
						[
							-80.15122430399998,
							26.181611286000077
						],
						[
							-80.15165076299996,
							26.181609196000068
						],
						[
							-80.15180559499998,
							26.181608437000023
						],
						[
							-80.15235534199996,
							26.181604422000078
						],
						[
							-80.15309822199998,
							26.18159590100004
						],
						[
							-80.15270222899994,
							26.182631576000063
						],
						[
							-80.15242807999994,
							26.184337393000078
						],
						[
							-80.15212346999994,
							26.186743813000078
						],
						[
							-80.15209300899994,
							26.18826686400007
						],
						[
							-80.15311,
							26.188315
						],
						[
							-80.15304536899998,
							26.188559981000026
						],
						[
							-80.15293366099996,
							26.188983406000034
						],
						[
							-80.15224787599999,
							26.191582846000074
						],
						[
							-80.15210409399998,
							26.192127846000062
						],
						[
							-80.15199907899995,
							26.192525902000057
						],
						[
							-80.15188504999998,
							26.19295812400003
						],
						[
							-80.15146713599995,
							26.194542213000034
						],
						[
							-80.15141095699994,
							26.194755158000078
						],
						[
							-80.151139,
							26.195786
						],
						[
							-80.15099057599998,
							26.195802639000078
						],
						[
							-80.150693,
							26.195836
						],
						[
							-80.150603,
							26.196008
						],
						[
							-80.15049436199996,
							26.196264386000053
						],
						[
							-80.15041205299997,
							26.196458634000066
						],
						[
							-80.15027645699996,
							26.196759143000065
						],
						[
							-80.14952631099999,
							26.197339631000034
						],
						[
							-80.149202,
							26.197679
						],
						[
							-80.14896462699994,
							26.19767932400004
						],
						[
							-80.14867407599996,
							26.197679720000053
						],
						[
							-80.14851266899996,
							26.197679940000057
						],
						[
							-80.14807678699998,
							26.19768053400003
						],
						[
							-80.147735,
							26.197681
						],
						[
							-80.14773186099995,
							26.197491601000024
						],
						[
							-80.147729,
							26.197319000000004
						],
						[
							-80.14747950199995,
							26.197319000000004
						],
						[
							-80.147325,
							26.197319000000004
						],
						[
							-80.147331,
							26.197812
						],
						[
							-80.14741377999997,
							26.19794104700003
						],
						[
							-80.14745350399994,
							26.198002974000076
						],
						[
							-80.14751164099994,
							26.198093605000054
						],
						[
							-80.14754732899998,
							26.198149240000077
						],
						[
							-80.147628,
							26.198275
						],
						[
							-80.14767907899996,
							26.198336910000023
						],
						[
							-80.14775348299997,
							26.198427091000042
						],
						[
							-80.148076,
							26.198818
						],
						[
							-80.148057,
							26.199575
						],
						[
							-80.14717403499998,
							26.20044608300003
						],
						[
							-80.146868,
							26.200748
						],
						[
							-80.14472144199993,
							26.202614003000065
						],
						[
							-80.14362484599997,
							26.203801983000062
						],
						[
							-80.14178123699999,
							26.203239258000053
						],
						[
							-80.14040820199996,
							26.203219431000036
						],
						[
							-80.137156,
							26.203133
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Oakland Park",
				"Name": "North Andrews Gardens",
				"RegionID": "125457"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.084579,
					29.316656,
					-81.050778,
					29.373798000000004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.07197865499995,
							29.361450324000035
						],
						[
							-81.070878,
							29.359155000000005
						],
						[
							-81.07080993699998,
							29.35901177400007
						],
						[
							-81.069787,
							29.356919000000005
						],
						[
							-81.069334,
							29.355941999999995
						],
						[
							-81.068365,
							29.353995
						],
						[
							-81.06791900000002,
							29.353018
						],
						[
							-81.067455,
							29.352102
						],
						[
							-81.066487,
							29.350107000000005
						],
						[
							-81.06554200000001,
							29.348132
						],
						[
							-81.064573,
							29.346149999999998
						],
						[
							-81.064046,
							29.345036000000004
						],
						[
							-81.0625,
							29.341714000000003
						],
						[
							-81.061734,
							29.340109000000005
						],
						[
							-81.061604,
							29.339837
						],
						[
							-81.061121,
							29.338905000000004
						],
						[
							-81.060895,
							29.338393999999997
						],
						[
							-81.06069000000001,
							29.337931
						],
						[
							-81.059772,
							29.336013999999995
						],
						[
							-81.059306,
							29.334928
						],
						[
							-81.059018,
							29.334273000000003
						],
						[
							-81.058485,
							29.333122
						],
						[
							-81.058013,
							29.332154999999997
						],
						[
							-81.057561,
							29.331178
						],
						[
							-81.05716156199999,
							29.330229459000066
						],
						[
							-81.056973,
							29.329924999999996
						],
						[
							-81.05678600000002,
							29.329583
						],
						[
							-81.056646,
							29.329269
						],
						[
							-81.05649,
							29.328927
						],
						[
							-81.05603824899998,
							29.327767358000074
						],
						[
							-81.055897,
							29.327455
						],
						[
							-81.055712,
							29.327038
						],
						[
							-81.05566160199999,
							29.326922536000037
						],
						[
							-81.055554,
							29.326707000000003
						],
						[
							-81.055317,
							29.326234000000003
						],
						[
							-81.055087,
							29.325773000000005
						],
						[
							-81.054825,
							29.325250000000004
						],
						[
							-81.054378,
							29.324355999999998
						],
						[
							-81.051078,
							29.317356
						],
						[
							-81.050778,
							29.316656
						],
						[
							-81.051998,
							29.316743
						],
						[
							-81.052252,
							29.316927999999997
						],
						[
							-81.05245200000002,
							29.317335
						],
						[
							-81.052676,
							29.3178
						],
						[
							-81.052742,
							29.317932
						],
						[
							-81.053662,
							29.317939000000003
						],
						[
							-81.053633,
							29.317797
						],
						[
							-81.053579,
							29.317335
						],
						[
							-81.053378,
							29.316846000000005
						],
						[
							-81.060399,
							29.31683
						],
						[
							-81.060818,
							29.316944
						],
						[
							-81.060914,
							29.317248
						],
						[
							-81.061478,
							29.318656
						],
						[
							-81.06397800000002,
							29.322755999999995
						],
						[
							-81.064549,
							29.324121999999996
						],
						[
							-81.065533,
							29.325864000000003
						],
						[
							-81.065559,
							29.325981
						],
						[
							-81.065559,
							29.326068999999997
						],
						[
							-81.065598,
							29.326254
						],
						[
							-81.06572,
							29.326534
						],
						[
							-81.065895,
							29.326784
						],
						[
							-81.066086,
							29.327227000000004
						],
						[
							-81.066139,
							29.3274
						],
						[
							-81.0662,
							29.327700000000004
						],
						[
							-81.066254,
							29.327868
						],
						[
							-81.066223,
							29.328138
						],
						[
							-81.066269,
							29.328249
						],
						[
							-81.066338,
							29.328312
						],
						[
							-81.066383,
							29.328392000000004
						],
						[
							-81.066452,
							29.328810000000004
						],
						[
							-81.066353,
							29.329075000000003
						],
						[
							-81.066391,
							29.329151000000003
						],
						[
							-81.066528,
							29.329264
						],
						[
							-81.066597,
							29.329424
						],
						[
							-81.066673,
							29.329475
						],
						[
							-81.066681,
							29.329559
						],
						[
							-81.06665,
							29.329636
						],
						[
							-81.066467,
							29.329702
						],
						[
							-81.066437,
							29.329779
						],
						[
							-81.06688700000001,
							29.330824000000003
						],
						[
							-81.066895,
							29.330914000000003
						],
						[
							-81.066879,
							29.330997
						],
						[
							-81.066948,
							29.331253
						],
						[
							-81.06707,
							29.331583000000002
						],
						[
							-81.067245,
							29.331902000000003
						],
						[
							-81.067322,
							29.332094000000005
						],
						[
							-81.067345,
							29.332262
						],
						[
							-81.06739,
							29.332338000000004
						],
						[
							-81.067451,
							29.332621000000003
						],
						[
							-81.067596,
							29.332961999999995
						],
						[
							-81.067726,
							29.333162000000005
						],
						[
							-81.067909,
							29.333553
						],
						[
							-81.067947,
							29.333729
						],
						[
							-81.067963,
							29.333902
						],
						[
							-81.067986,
							29.333982000000002
						],
						[
							-81.068062,
							29.334044
						],
						[
							-81.068153,
							29.334286000000002
						],
						[
							-81.068367,
							29.334631000000005
						],
						[
							-81.068588,
							29.335082999999997
						],
						[
							-81.068657,
							29.335173000000005
						],
						[
							-81.068825,
							29.335534999999997
						],
						[
							-81.068886,
							29.335615000000004
						],
						[
							-81.06891600000002,
							29.335695
						],
						[
							-81.06892400000001,
							29.335783
						],
						[
							-81.069115,
							29.336163
						],
						[
							-81.069183,
							29.336422
						],
						[
							-81.06945,
							29.336891000000005
						],
						[
							-81.069481,
							29.33699
						],
						[
							-81.069481,
							29.337090000000003
						],
						[
							-81.069443,
							29.337259000000003
						],
						[
							-81.069511,
							29.337433000000004
						],
						[
							-81.069565,
							29.337506999999995
						],
						[
							-81.069656,
							29.33754
						],
						[
							-81.06971,
							29.337614
						],
						[
							-81.069778,
							29.337875
						],
						[
							-81.069946,
							29.338243
						],
						[
							-81.069931,
							29.338351999999997
						],
						[
							-81.069893,
							29.338425
						],
						[
							-81.069923,
							29.338504999999998
						],
						[
							-81.070076,
							29.338703
						],
						[
							-81.070274,
							29.339050000000004
						],
						[
							-81.070503,
							29.339682000000003
						],
						[
							-81.070496,
							29.339771
						],
						[
							-81.070633,
							29.340031000000003
						],
						[
							-81.070641,
							29.340117
						],
						[
							-81.070724,
							29.340307
						],
						[
							-81.07093,
							29.340518999999997
						],
						[
							-81.07090800000002,
							29.340706
						],
						[
							-81.07093,
							29.340788
						],
						[
							-81.071014,
							29.34083
						],
						[
							-81.071106,
							29.340853000000003
						],
						[
							-81.071358,
							29.341541
						],
						[
							-81.071365,
							29.341722000000004
						],
						[
							-81.07143400000001,
							29.341909000000005
						],
						[
							-81.071602,
							29.342176
						],
						[
							-81.07177,
							29.342546
						],
						[
							-81.071846,
							29.342756
						],
						[
							-81.071854,
							29.342842000000005
						],
						[
							-81.071915,
							29.342918
						],
						[
							-81.07193,
							29.343004
						],
						[
							-81.072212,
							29.343777
						],
						[
							-81.072258,
							29.343859
						],
						[
							-81.072456,
							29.344381000000002
						],
						[
							-81.072571,
							29.344625
						],
						[
							-81.072807,
							29.345236
						],
						[
							-81.072792,
							29.345324
						],
						[
							-81.072731,
							29.345388
						],
						[
							-81.072906,
							29.345745
						],
						[
							-81.072983,
							29.345801999999996
						],
						[
							-81.073036,
							29.345882000000003
						],
						[
							-81.073013,
							29.345968
						],
						[
							-81.073051,
							29.346050000000005
						],
						[
							-81.073143,
							29.346077000000005
						],
						[
							-81.073265,
							29.34647
						],
						[
							-81.073273,
							29.346556000000003
						],
						[
							-81.073677,
							29.347754999999996
						],
						[
							-81.073845,
							29.348187999999997
						],
						[
							-81.073952,
							29.348366000000002
						],
						[
							-81.074013,
							29.34853
						],
						[
							-81.074104,
							29.348708999999996
						],
						[
							-81.074226,
							29.349089
						],
						[
							-81.074341,
							29.349264
						],
						[
							-81.074364,
							29.349346000000004
						],
						[
							-81.074364,
							29.349451
						],
						[
							-81.074387,
							29.349545000000003
						],
						[
							-81.074478,
							29.349577
						],
						[
							-81.074593,
							29.349941
						],
						[
							-81.074623,
							29.350109
						],
						[
							-81.074768,
							29.350216000000003
						],
						[
							-81.074791,
							29.350298000000002
						],
						[
							-81.075134,
							29.351095000000004
						],
						[
							-81.07518,
							29.351269
						],
						[
							-81.075294,
							29.351557
						],
						[
							-81.075363,
							29.351618
						],
						[
							-81.075409,
							29.351692
						],
						[
							-81.075424,
							29.351778
						],
						[
							-81.075409,
							29.351865999999998
						],
						[
							-81.075508,
							29.35218
						],
						[
							-81.0756,
							29.352364
						],
						[
							-81.075836,
							29.353027000000004
						],
						[
							-81.075851,
							29.353195
						],
						[
							-81.075974,
							29.353363
						],
						[
							-81.07621,
							29.353933000000005
						],
						[
							-81.076508,
							29.354588
						],
						[
							-81.076561,
							29.354658
						],
						[
							-81.07663,
							29.354839
						],
						[
							-81.076637,
							29.354923
						],
						[
							-81.076843,
							29.355350000000005
						],
						[
							-81.076912,
							29.355684
						],
						[
							-81.076942,
							29.355764
						],
						[
							-81.077011,
							29.355864
						],
						[
							-81.077141,
							29.356184
						],
						[
							-81.077271,
							29.356405000000002
						],
						[
							-81.077255,
							29.356556
						],
						[
							-81.077377,
							29.356743
						],
						[
							-81.077469,
							29.356781
						],
						[
							-81.077499,
							29.356897
						],
						[
							-81.077499,
							29.357037000000002
						],
						[
							-81.077591,
							29.357124000000002
						],
						[
							-81.077728,
							29.357496
						],
						[
							-81.077843,
							29.357931
						],
						[
							-81.077879,
							29.357954999999997
						],
						[
							-81.077942,
							29.358015
						],
						[
							-81.078079,
							29.358038
						],
						[
							-81.078369,
							29.358776
						],
						[
							-81.078461,
							29.358974
						],
						[
							-81.078629,
							29.359434
						],
						[
							-81.078552,
							29.359501000000005
						],
						[
							-81.078537,
							29.359669
						],
						[
							-81.07858300000001,
							29.359799999999996
						],
						[
							-81.078781,
							29.359772
						],
						[
							-81.078873,
							29.360008
						],
						[
							-81.078842,
							29.360106
						],
						[
							-81.079094,
							29.360523
						],
						[
							-81.079193,
							29.360795999999997
						],
						[
							-81.079056,
							29.36084
						],
						[
							-81.079353,
							29.36154
						],
						[
							-81.07946,
							29.361614
						],
						[
							-81.079666,
							29.362117999999995
						],
						[
							-81.079842,
							29.362474
						],
						[
							-81.079956,
							29.36278
						],
						[
							-81.080109,
							29.363007
						],
						[
							-81.080185,
							29.363200999999997
						],
						[
							-81.080261,
							29.363325
						],
						[
							-81.080307,
							29.363482
						],
						[
							-81.08036,
							29.363585999999998
						],
						[
							-81.08046,
							29.363874
						],
						[
							-81.080544,
							29.364217999999997
						],
						[
							-81.080681,
							29.364538
						],
						[
							-81.08070400000001,
							29.364700000000003
						],
						[
							-81.080803,
							29.364882
						],
						[
							-81.080894,
							29.365181000000003
						],
						[
							-81.081024,
							29.365505
						],
						[
							-81.081085,
							29.365616
						],
						[
							-81.081146,
							29.365784
						],
						[
							-81.081482,
							29.366463000000003
						],
						[
							-81.081497,
							29.366583
						],
						[
							-81.081566,
							29.366762
						],
						[
							-81.081581,
							29.366899
						],
						[
							-81.081688,
							29.367174000000002
						],
						[
							-81.081871,
							29.367535000000004
						],
						[
							-81.081886,
							29.367653
						],
						[
							-81.082016,
							29.367889000000005
						],
						[
							-81.082039,
							29.367983
						],
						[
							-81.082298,
							29.368589
						],
						[
							-81.082306,
							29.368694
						],
						[
							-81.082413,
							29.368839
						],
						[
							-81.082489,
							29.369055000000003
						],
						[
							-81.082466,
							29.369136999999995
						],
						[
							-81.08255,
							29.369398000000004
						],
						[
							-81.082657,
							29.369590999999996
						],
						[
							-81.08271,
							29.369801
						],
						[
							-81.082779,
							29.369926
						],
						[
							-81.082878,
							29.370176
						],
						[
							-81.082892,
							29.370273000000005
						],
						[
							-81.083279,
							29.370355000000004
						],
						[
							-81.084399,
							29.373306
						],
						[
							-81.08454057399996,
							29.373420508000038
						],
						[
							-81.084579,
							29.373554999999996
						],
						[
							-81.084276,
							29.373665
						],
						[
							-81.083893,
							29.373674000000005
						],
						[
							-81.078201,
							29.373798000000004
						],
						[
							-81.077879,
							29.373755
						],
						[
							-81.07335451199998,
							29.364319559000027
						],
						[
							-81.073113,
							29.363855
						],
						[
							-81.07289134399997,
							29.363353660000033
						],
						[
							-81.07237050599997,
							29.362267496000072
						],
						[
							-81.072201,
							29.361933000000004
						],
						[
							-81.07197865499995,
							29.361450324000035
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Volusia",
				"City": "Ormond Beach",
				"Name": "Ormond-by-the-Sea",
				"RegionID": "125591"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.71666576899992,
					30.24762189900008,
					-81.68832068199993,
					30.283495304000038
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.69773359699991,
							30.28258633800004
						],
						[
							-81.69653659699992,
							30.28001333800006
						],
						[
							-81.6965067509999,
							30.279941140000062
						],
						[
							-81.69648328499994,
							30.279866624000082
						],
						[
							-81.69646637299991,
							30.279790353000067
						],
						[
							-81.69645614599995,
							30.279712901000043
						],
						[
							-81.6962471459999,
							30.27733990200005
						],
						[
							-81.69624367799992,
							30.277261519000035
						],
						[
							-81.69624705499992,
							30.27718313200006
						],
						[
							-81.69625725199995,
							30.277105338000066
						],
						[
							-81.69627418999994,
							30.27702872900005
						],
						[
							-81.69629774099991,
							30.27695388800004
						],
						[
							-81.69632772599994,
							30.276881384000035
						],
						[
							-81.69689672599992,
							30.27565938400005
						],
						[
							-81.69693316399992,
							30.275589339000078
						],
						[
							-81.69702707699992,
							30.275456229000042
						],
						[
							-81.69885408699992,
							30.273338515000038
						],
						[
							-81.69975986599991,
							30.272288737000054
						],
						[
							-81.70042646299993,
							30.27034947300007
						],
						[
							-81.69737779999991,
							30.26445551600006
						],
						[
							-81.69630470899995,
							30.26265830700004
						],
						[
							-81.6943852519999,
							30.25999441500005
						],
						[
							-81.6910535259999,
							30.257162204000053
						],
						[
							-81.69095175599995,
							30.257060601000035
						],
						[
							-81.69002975599994,
							30.255979601000035
						],
						[
							-81.68997543799992,
							30.25590913300005
						],
						[
							-81.6891514379999,
							30.254723132000034
						],
						[
							-81.68910990099994,
							30.254657464000047
						],
						[
							-81.68850590099993,
							30.253604464000038
						],
						[
							-81.6884409139999,
							30.253464586000067
						],
						[
							-81.68840065299992,
							30.25331492700008
						],
						[
							-81.68833449699991,
							30.25294404600004
						],
						[
							-81.68832424999994,
							30.25286707700008
						],
						[
							-81.68832068199993,
							30.25278951000007
						],
						[
							-81.68832381699991,
							30.252711925000085
						],
						[
							-81.6883336329999,
							30.252634899000043
						],
						[
							-81.68835005799991,
							30.252559007000055
						],
						[
							-81.6883729669999,
							30.25248481500006
						],
						[
							-81.68846608699994,
							30.252217746000042
						],
						[
							-81.68847492999993,
							30.25214205700007
						],
						[
							-81.68849014599994,
							30.252067387000064
						],
						[
							-81.68851162399994,
							30.25199427300004
						],
						[
							-81.6885392129999,
							30.251923238000078
						],
						[
							-81.68857271199994,
							30.251854792000078
						],
						[
							-81.68861188299991,
							30.251789426000073
						],
						[
							-81.68879888299996,
							30.251505427000044
						],
						[
							-81.68883941899992,
							30.251448769000035
						],
						[
							-81.68888421999992,
							30.251395419000062
						],
						[
							-81.6889330169999,
							30.25134569800008
						],
						[
							-81.68898551499991,
							30.25129990200008
						],
						[
							-81.68904140099994,
							30.25125830800005
						],
						[
							-81.68910033899994,
							30.251221164000075
						],
						[
							-81.68946233999992,
							30.251012163000045
						],
						[
							-81.68953911899992,
							30.25097262300005
						],
						[
							-81.68983731499992,
							30.250836755000083
						],
						[
							-81.68980932499994,
							30.250817557000065
						],
						[
							-81.6911399999999,
							30.250724000000044
						],
						[
							-81.69167690499997,
							30.251229009000042
						],
						[
							-81.69189790599995,
							30.251502009000035
						],
						[
							-81.6924379049999,
							30.252219009000044
						],
						[
							-81.69268890599994,
							30.25256700700004
						],
						[
							-81.6931618719999,
							30.253043028000036
						],
						[
							-81.6933819059999,
							30.253223007000088
						],
						[
							-81.6939528609999,
							30.253536134000058
						],
						[
							-81.69458990599992,
							30.253622008000033
						],
						[
							-81.69489690599995,
							30.25363100800007
						],
						[
							-81.69526991499993,
							30.253603061000035
						],
						[
							-81.69565490499991,
							30.253489008000088
						],
						[
							-81.69607090599993,
							30.253290008000075
						],
						[
							-81.69644990599994,
							30.25309901000009
						],
						[
							-81.69697189699991,
							30.252934956000043
						],
						[
							-81.69731790599991,
							30.25292201000008
						],
						[
							-81.69742700799992,
							30.252942855000075
						],
						[
							-81.6974488109999,
							30.25297617300004
						],
						[
							-81.6977920359999,
							30.252996142000086
						],
						[
							-81.6977919059999,
							30.25227700800008
						],
						[
							-81.6977919059999,
							30.24999800900008
						],
						[
							-81.6977999579999,
							30.24922399900004
						],
						[
							-81.69768381999995,
							30.24880501500007
						],
						[
							-81.69775590499995,
							30.248138008000065
						],
						[
							-81.69775390599995,
							30.247682009000076
						],
						[
							-81.69775387699991,
							30.24762189900008
						],
						[
							-81.69778290499994,
							30.247682008000083
						],
						[
							-81.69783295499991,
							30.24778499000007
						],
						[
							-81.69784390599995,
							30.24784900900005
						],
						[
							-81.69789890599992,
							30.24837300800004
						],
						[
							-81.69801790499992,
							30.248819008000055
						],
						[
							-81.6981319059999,
							30.24928200800008
						],
						[
							-81.6987609059999,
							30.25184800800008
						],
						[
							-81.69884686699993,
							30.25219822600008
						],
						[
							-81.6991039049999,
							30.25323900800004
						],
						[
							-81.6995319049999,
							30.255079008000052
						],
						[
							-81.69972190499993,
							30.25585600900007
						],
						[
							-81.69990490599992,
							30.256643008000083
						],
						[
							-81.69998990599993,
							30.256937008000083
						],
						[
							-81.70032381899995,
							30.258185035000057
						],
						[
							-81.7004289059999,
							30.258469008000077
						],
						[
							-81.70105890699995,
							30.259742008000046
						],
						[
							-81.70143490599992,
							30.260256008000056
						],
						[
							-81.70158290599994,
							30.26045800800006
						],
						[
							-81.7018259059999,
							30.260730008000056
						],
						[
							-81.70225490599996,
							30.261154008000066
						],
						[
							-81.70641290599991,
							30.26476300800005
						],
						[
							-81.70795390599994,
							30.266094009000085
						],
						[
							-81.71493490599994,
							30.271435008000083
						],
						[
							-81.71602499999995,
							30.272508000000077
						],
						[
							-81.71666576899992,
							30.273138716000062
						],
						[
							-81.71666175899992,
							30.273143074000075
						],
						[
							-81.71660875099991,
							30.273192117000065
						],
						[
							-81.7162747509999,
							30.27347711600004
						],
						[
							-81.71616839299992,
							30.273555152000085
						],
						[
							-81.71607739299992,
							30.27361215200006
						],
						[
							-81.71601849299992,
							30.273646017000093
						],
						[
							-81.71595720499994,
							30.27367533900008
						],
						[
							-81.71589387799992,
							30.27369995000004
						],
						[
							-81.7158288739999,
							30.273719711000073
						],
						[
							-81.71580207099993,
							30.27372676400006
						],
						[
							-81.71472363599992,
							30.27420040700008
						],
						[
							-81.71469056099994,
							30.27421415400005
						],
						[
							-81.71413256099993,
							30.274433155000054
						],
						[
							-81.71405290899992,
							30.274460190000074
						],
						[
							-81.71343490999993,
							30.274638190000076
						],
						[
							-81.71331185299994,
							30.27466447300009
						],
						[
							-81.71293685299992,
							30.274717472000077
						],
						[
							-81.71281099999995,
							30.274726322000046
						],
						[
							-81.71265175699995,
							30.274712106000038
						],
						[
							-81.71170459599995,
							30.274538308000047
						],
						[
							-81.71161566399991,
							30.274527322000043
						],
						[
							-81.71157955199993,
							30.274527322000043
						],
						[
							-81.71132744499994,
							30.27459260500007
						],
						[
							-81.7112887909999,
							30.274601709000084
						],
						[
							-81.71114279099993,
							30.274632710000052
						],
						[
							-81.71111216599991,
							30.27463866000005
						],
						[
							-81.7109559999999,
							30.274652322000065
						],
						[
							-81.71079899999995,
							30.274652322000065
						],
						[
							-81.71065049299995,
							30.274639976000064
						],
						[
							-81.71052740199991,
							30.27461936700007
						],
						[
							-81.71042466099993,
							30.274688836000053
						],
						[
							-81.71039031499993,
							30.274707680000063
						],
						[
							-81.71026931499995,
							30.274770679000085
						],
						[
							-81.71016158599991,
							30.274818086000042
						],
						[
							-81.7100336609999,
							30.274854193000067
						],
						[
							-81.70982766199995,
							30.274896193000075
						],
						[
							-81.70976318299995,
							30.27490691500009
						],
						[
							-81.70969809699994,
							30.274912925000084
						],
						[
							-81.70963274499991,
							30.27491419200004
						],
						[
							-81.70956747499991,
							30.27491070900004
						],
						[
							-81.70875547499992,
							30.274837710000043
						],
						[
							-81.70867983499994,
							30.274827659000035
						],
						[
							-81.70851997999995,
							30.27478392000006
						],
						[
							-81.70840893099995,
							30.274741060000057
						],
						[
							-81.70816744699994,
							30.274815559000047
						],
						[
							-81.70809768799995,
							30.27595317800007
						],
						[
							-81.70808565899995,
							30.27605516600005
						],
						[
							-81.70807195099991,
							30.27611918400004
						],
						[
							-81.7080469519999,
							30.276218184000076
						],
						[
							-81.70802008599992,
							30.27630558700008
						],
						[
							-81.70795383599994,
							30.276447661000077
						],
						[
							-81.7078639209999,
							30.276576073000058
						],
						[
							-81.70775307299994,
							30.276686921000078
						],
						[
							-81.7076246609999,
							30.27677683600007
						],
						[
							-81.70748258599991,
							30.27684308700009
						],
						[
							-81.7073311659999,
							30.276883660000067
						],
						[
							-81.70729289099995,
							30.27688956200006
						],
						[
							-81.70717189099992,
							30.27690556200008
						],
						[
							-81.70705399999991,
							30.276913322000045
						],
						[
							-81.70695569899993,
							30.276907934000068
						],
						[
							-81.70669475699992,
							30.27687923900004
						],
						[
							-81.70646360199993,
							30.27694971300008
						],
						[
							-81.70578171599993,
							30.27723713900008
						],
						[
							-81.70454409199994,
							30.27862627400009
						],
						[
							-81.7046679579999,
							30.278715104000074
						],
						[
							-81.70473484399992,
							30.278773130000047
						],
						[
							-81.70483392099993,
							30.278873927000063
						],
						[
							-81.70492383599992,
							30.279002339000048
						],
						[
							-81.70499008599995,
							30.279144414000086
						],
						[
							-81.70503065899993,
							30.279295835000084
						],
						[
							-81.70504432199994,
							30.279452000000045
						],
						[
							-81.70504432199994,
							30.27953500000007
						],
						[
							-81.70502925799991,
							30.279698730000067
						],
						[
							-81.70501485799991,
							30.279773296000087
						],
						[
							-81.70497708599993,
							30.27990958600009
						],
						[
							-81.7049108359999,
							30.280051661000073
						],
						[
							-81.70482092099991,
							30.28018007300005
						],
						[
							-81.70471007299994,
							30.28029092100007
						],
						[
							-81.7045816609999,
							30.280380836000067
						],
						[
							-81.70446708899993,
							30.28043656300008
						],
						[
							-81.70433508899993,
							30.28048956300006
						],
						[
							-81.7043075869999,
							30.28050008600007
						],
						[
							-81.7041561659999,
							30.280540659000057
						],
						[
							-81.70399999999997,
							30.280554322000057
						],
						[
							-81.70384383499993,
							30.280540659000057
						],
						[
							-81.70369241399993,
							30.28050008600007
						],
						[
							-81.70364491799995,
							30.28048125400005
						],
						[
							-81.70352391799992,
							30.280429255000058
						],
						[
							-81.70344559999995,
							30.280391000000062
						],
						[
							-81.70329976799991,
							30.28031079300007
						],
						[
							-81.70312734599992,
							30.28040354700005
						],
						[
							-81.70302295499994,
							30.28077024000004
						],
						[
							-81.70300308599991,
							30.280831587000083
						],
						[
							-81.70293288599993,
							30.280980367000037
						],
						[
							-81.70274693699992,
							30.281290072000047
						],
						[
							-81.7026649199999,
							30.281405073000087
						],
						[
							-81.70262169799992,
							30.281452982000076
						],
						[
							-81.70236769799993,
							30.28171498200004
						],
						[
							-81.7023493879999,
							30.28173139100005
						],
						[
							-81.70217559399993,
							30.282347980000058
						],
						[
							-81.70214827399991,
							30.282429695000076
						],
						[
							-81.70208727399995,
							30.282586695000077
						],
						[
							-81.7020278359999,
							30.28271066100007
						],
						[
							-81.70195125099991,
							30.282822805000084
						],
						[
							-81.7018672499999,
							30.282927805000046
						],
						[
							-81.7018187569999,
							30.282983561000037
						],
						[
							-81.70176585099995,
							30.283035148000067
						],
						[
							-81.70170888799993,
							30.28308221700007
						],
						[
							-81.70164825199993,
							30.28312445000006
						],
						[
							-81.70158435499991,
							30.283161564000068
						],
						[
							-81.70151762599994,
							30.283193306000044
						],
						[
							-81.70146324099994,
							30.28321648600007
						],
						[
							-81.70134427999994,
							30.283292069000087
						],
						[
							-81.70128593899994,
							30.283326130000034
						],
						[
							-81.70122520599995,
							30.283355716000074
						],
						[
							-81.70116242299991,
							30.283380659000045
						],
						[
							-81.7010979449999,
							30.283400819000065
						],
						[
							-81.70103213599992,
							30.283416082000087
						],
						[
							-81.70081413699995,
							30.28345808200004
						],
						[
							-81.70071451599995,
							30.283471554000073
						],
						[
							-81.70044751499995,
							30.28349255400008
						],
						[
							-81.70038279999994,
							30.283495304000038
						],
						[
							-81.70031805399992,
							30.283493389000057
						],
						[
							-81.7002536139999,
							30.28348681800009
						],
						[
							-81.70018981399996,
							30.28347562600004
						],
						[
							-81.69836181399997,
							30.28308662500007
						],
						[
							-81.69824141399994,
							30.283052086000055
						],
						[
							-81.69809933899995,
							30.282985835000094
						],
						[
							-81.69797092699991,
							30.282895920000044
						],
						[
							-81.69786007899995,
							30.28278507300007
						],
						[
							-81.6977701639999,
							30.282656661000093
						],
						[
							-81.69773359699991,
							30.28258633800004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Ortega",
				"RegionID": "125593"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.7307129049999,
					30.24736995300009,
					-81.71046901699992,
					30.26402532200007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.71195512199995,
							30.25180905000008
						],
						[
							-81.71166476899992,
							30.251603656000043
						],
						[
							-81.71159999999992,
							30.25160932200004
						],
						[
							-81.7115077709999,
							30.25160458000005
						],
						[
							-81.71141077099992,
							30.251594580000074
						],
						[
							-81.71134683399993,
							30.251585659000057
						],
						[
							-81.7111891319999,
							30.25154274600004
						],
						[
							-81.71109884899994,
							30.25150840700007
						],
						[
							-81.71096933899992,
							30.25144683600007
						],
						[
							-81.71084092699994,
							30.251356921000085
						],
						[
							-81.71073007899992,
							30.251246073000065
						],
						[
							-81.71064016399993,
							30.251117661000077
						],
						[
							-81.71059808099994,
							30.25103525100008
						],
						[
							-81.71054708199995,
							30.25092125100008
						],
						[
							-81.71052196799991,
							30.250858974000042
						],
						[
							-81.7105015699999,
							30.250794998000064
						],
						[
							-81.7104860039999,
							30.25072967700004
						],
						[
							-81.71047535399993,
							30.25066337700008
						],
						[
							-81.71046968099995,
							30.25059646700004
						],
						[
							-81.71046901699992,
							30.250529321000045
						],
						[
							-81.71055004699991,
							30.247577702000058
						],
						[
							-81.7114499999999,
							30.247567000000064
						],
						[
							-81.71163604799995,
							30.247562891000083
						],
						[
							-81.71161582899992,
							30.247654129000065
						],
						[
							-81.71174090599993,
							30.247562009000035
						],
						[
							-81.71187784999995,
							30.24746084200007
						],
						[
							-81.7127889059999,
							30.247450008000044
						],
						[
							-81.71361690599991,
							30.24743500800008
						],
						[
							-81.71379101999992,
							30.24744585700006
						],
						[
							-81.71382279499994,
							30.247542166000073
						],
						[
							-81.7140279059999,
							30.247535008000057
						],
						[
							-81.71438290499992,
							30.247535008000057
						],
						[
							-81.71500592899993,
							30.247542139000075
						],
						[
							-81.7151828829999,
							30.247468877000074
						],
						[
							-81.71532390499993,
							30.24747100800005
						],
						[
							-81.71578990499995,
							30.24746700800006
						],
						[
							-81.71673590599994,
							30.24747500800004
						],
						[
							-81.71835290599995,
							30.24745200800004
						],
						[
							-81.71936790599995,
							30.247450008000044
						],
						[
							-81.7209849059999,
							30.24743500800008
						],
						[
							-81.72223690599992,
							30.247433008000083
						],
						[
							-81.7238239049999,
							30.24742300800006
						],
						[
							-81.72484590599994,
							30.247412008000083
						],
						[
							-81.72531390599994,
							30.247408008000036
						],
						[
							-81.72552090499994,
							30.24740600800004
						],
						[
							-81.72565490599993,
							30.24740600800004
						],
						[
							-81.72598890499997,
							30.247404008000046
						],
						[
							-81.72608890499993,
							30.24739800800006
						],
						[
							-81.72622290599992,
							30.24739500800007
						],
						[
							-81.72653990499992,
							30.24740000900005
						],
						[
							-81.72940090499992,
							30.24737000800008
						],
						[
							-81.73069790499994,
							30.24736995300009
						],
						[
							-81.73068990599995,
							30.24793400900006
						],
						[
							-81.73069790599993,
							30.248407008000076
						],
						[
							-81.73070490599991,
							30.248566009000058
						],
						[
							-81.73069790599993,
							30.249197009000053
						],
						[
							-81.7307129049999,
							30.249828008000065
						],
						[
							-81.73069790599993,
							30.250504009000057
						],
						[
							-81.73070490599991,
							30.251093009000044
						],
						[
							-81.73069790599993,
							30.25267000900004
						],
						[
							-81.73070490599991,
							30.253563008000075
						],
						[
							-81.73069990699992,
							30.25361400800006
						],
						[
							-81.73071190499991,
							30.253939009000078
						],
						[
							-81.73068990399992,
							30.254174010000042
						],
						[
							-81.73066490499991,
							30.25425700800008
						],
						[
							-81.73058790499994,
							30.254422008000063
						],
						[
							-81.73043690199995,
							30.25464000900007
						],
						[
							-81.73021190599991,
							30.25482800700007
						],
						[
							-81.72991890599991,
							30.255016009000087
						],
						[
							-81.7290419059999,
							30.255547008000065
						],
						[
							-81.72866790499995,
							30.25577200800007
						],
						[
							-81.72819490599994,
							30.256073009000094
						],
						[
							-81.72781390599994,
							30.25637100800009
						],
						[
							-81.72766090599994,
							30.25651700900005
						],
						[
							-81.72740890599994,
							30.25682600900007
						],
						[
							-81.72731790599994,
							30.256939008000078
						],
						[
							-81.72698990499993,
							30.25747300900008
						],
						[
							-81.72678390599992,
							30.257788008000038
						],
						[
							-81.72631072599995,
							30.25860205400005
						],
						[
							-81.7268369059999,
							30.258928008000055
						],
						[
							-81.72725708599995,
							30.259166974000035
						],
						[
							-81.7244419999999,
							30.262894000000077
						],
						[
							-81.72455811999993,
							30.263959545000034
						],
						[
							-81.7244970509999,
							30.263981906000083
						],
						[
							-81.72442951999994,
							30.264000813000052
						],
						[
							-81.72436072199991,
							30.264014401000054
						],
						[
							-81.72429107399995,
							30.264022587000056
						],
						[
							-81.72422099999994,
							30.26402532200007
						],
						[
							-81.72404699999993,
							30.26402532200007
						],
						[
							-81.72389083399992,
							30.26401165900006
						],
						[
							-81.7238375899999,
							30.264000601000077
						],
						[
							-81.72355358999994,
							30.263932601000082
						],
						[
							-81.72351914399991,
							30.263923629000093
						],
						[
							-81.72284114299993,
							30.26373262900006
						],
						[
							-81.72278195799993,
							30.263713727000038
						],
						[
							-81.72258968599994,
							30.263644906000078
						],
						[
							-81.72251865099992,
							30.263615785000066
						],
						[
							-81.72245035799995,
							30.26358071100009
						],
						[
							-81.72238530599992,
							30.26353994000004
						],
						[
							-81.72232396899994,
							30.263493769000036
						],
						[
							-81.7222667929999,
							30.263442534000035
						],
						[
							-81.72214079299994,
							30.263319535000047
						],
						[
							-81.72210355499993,
							30.26328095000008
						],
						[
							-81.72165737299991,
							30.26279014800008
						],
						[
							-81.7215520019999,
							30.26274800100003
						],
						[
							-81.72148147999991,
							30.26271620900008
						],
						[
							-81.71996647999993,
							30.26195320900007
						],
						[
							-81.71988045799992,
							30.261903757000084
						],
						[
							-81.71969145799994,
							30.261780756000064
						],
						[
							-81.71960392699992,
							30.26171592100008
						],
						[
							-81.71952890699993,
							30.26164526300005
						],
						[
							-81.71938690699994,
							30.261495264000075
						],
						[
							-81.71934379999993,
							30.26144628500009
						],
						[
							-81.71930435699994,
							30.26139431100006
						],
						[
							-81.71926878699992,
							30.261339613000075
						],
						[
							-81.7192372749999,
							30.261282480000087
						],
						[
							-81.71920998999991,
							30.26122321300005
						],
						[
							-81.71891495799991,
							30.260515904000044
						],
						[
							-81.71861387799993,
							30.25991470100007
						],
						[
							-81.71857291399994,
							30.259819587000038
						],
						[
							-81.71855088599995,
							30.25975052600006
						],
						[
							-81.71838088699991,
							30.259132525000044
						],
						[
							-81.71837142699991,
							30.259094996000044
						],
						[
							-81.71833542699994,
							30.258937996000046
						],
						[
							-81.7183212409999,
							30.258860804000047
						],
						[
							-81.71831383799991,
							30.258782669000084
						],
						[
							-81.71831327699994,
							30.258704186000042
						],
						[
							-81.71831955999994,
							30.258625953000035
						],
						[
							-81.7183326409999,
							30.25854856600006
						],
						[
							-81.71835839199991,
							30.258428394000077
						],
						[
							-81.71841488599995,
							30.257878739000034
						],
						[
							-81.71733366399992,
							30.256736364000066
						],
						[
							-81.71611035399991,
							30.255628627000082
						],
						[
							-81.71603530999994,
							30.255552050000063
						],
						[
							-81.7155841949999,
							30.255033061000066
						],
						[
							-81.71548611899993,
							30.254893301000042
						],
						[
							-81.71536707799993,
							30.25468051500008
						],
						[
							-81.71531354299992,
							30.25462359200009
						],
						[
							-81.71488090799994,
							30.25424176300004
						],
						[
							-81.71413953599995,
							30.253852033000047
						],
						[
							-81.71410833899995,
							30.253834836000067
						],
						[
							-81.71398159199993,
							30.25374631500006
						],
						[
							-81.71334207799993,
							30.25321232500005
						],
						[
							-81.71288875399995,
							30.252957352000067
						],
						[
							-81.71276033399994,
							30.252868595000052
						],
						[
							-81.71265913099997,
							30.252784758000075
						],
						[
							-81.71260630299993,
							30.25273705100005
						],
						[
							-81.71255741499994,
							30.252685316000054
						],
						[
							-81.71251277099994,
							30.25262987600007
						],
						[
							-81.71247265199992,
							30.252571079000063
						],
						[
							-81.71243730799995,
							30.25250929400005
						],
						[
							-81.71240696199993,
							30.252444906000047
						],
						[
							-81.7123818039999,
							30.252378320000048
						],
						[
							-81.71236199099991,
							30.252309953000065
						],
						[
							-81.71231499099991,
							30.25211995300009
						],
						[
							-81.71230234099994,
							30.252060166000035
						],
						[
							-81.71229624699993,
							30.251983928000076
						],
						[
							-81.71223547699992,
							30.25196672800007
						],
						[
							-81.71217635399995,
							30.251944515000048
						],
						[
							-81.7121192919999,
							30.25191744500006
						],
						[
							-81.71206468899993,
							30.251885706000056
						],
						[
							-81.71201292599994,
							30.251849520000064
						],
						[
							-81.71195512199995,
							30.25180905000008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Ortega Farms",
				"RegionID": "125594"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.44303066399995,
					28.585337156000037,
					-81.4155274389999,
					28.614352000000054
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.41688299999993,
							28.611469000000056
						],
						[
							-81.41687612599992,
							28.61083831500008
						],
						[
							-81.41687499999995,
							28.61073500000009
						],
						[
							-81.41926699999993,
							28.61073500000009
						],
						[
							-81.41940299999993,
							28.610742000000073
						],
						[
							-81.4194169999999,
							28.610928000000058
						],
						[
							-81.4209928649999,
							28.61091024600006
						],
						[
							-81.42163599999994,
							28.610903000000064
						],
						[
							-81.42178999999993,
							28.61090100000007
						],
						[
							-81.4216669999999,
							28.609377000000052
						],
						[
							-81.42166399999991,
							28.609078000000068
						],
						[
							-81.42306575399994,
							28.609216265000043
						],
						[
							-81.42320499999994,
							28.609230000000082
						],
						[
							-81.42329073699995,
							28.608930313000087
						],
						[
							-81.42331399999995,
							28.608849000000077
						],
						[
							-81.42353805999996,
							28.60885566500008
						],
						[
							-81.42375099999992,
							28.608862000000045
						],
						[
							-81.42401499999994,
							28.60796000000005
						],
						[
							-81.42414799999995,
							28.60776000000004
						],
						[
							-81.42426499999993,
							28.607584000000088
						],
						[
							-81.42306599999995,
							28.60675000000009
						],
						[
							-81.42223799999994,
							28.606168000000082
						],
						[
							-81.42137099999991,
							28.605143000000055
						],
						[
							-81.42060299999991,
							28.603999000000044
						],
						[
							-81.42066999999992,
							28.603934000000038
						],
						[
							-81.42082199999993,
							28.60381700000005
						],
						[
							-81.4223179999999,
							28.60381300000006
						],
						[
							-81.42263699999995,
							28.60381300000006
						],
						[
							-81.42266999999994,
							28.60119300000008
						],
						[
							-81.42011799999995,
							28.60119300000008
						],
						[
							-81.41996299999994,
							28.60095000000007
						],
						[
							-81.41867799999994,
							28.60096200000004
						],
						[
							-81.41833199999991,
							28.600392000000056
						],
						[
							-81.41795899999994,
							28.599635000000035
						],
						[
							-81.41775299999995,
							28.599266000000057
						],
						[
							-81.41849799999996,
							28.599268000000052
						],
						[
							-81.41849699999995,
							28.598952000000054
						],
						[
							-81.41757699999994,
							28.598947000000067
						],
						[
							-81.41743899999994,
							28.59869800000007
						],
						[
							-81.4174109999999,
							28.59863000000007
						],
						[
							-81.4170079999999,
							28.59785700000009
						],
						[
							-81.41697099999993,
							28.597784000000047
						],
						[
							-81.4168929999999,
							28.59786500000007
						],
						[
							-81.41688775999995,
							28.59781827900008
						],
						[
							-81.4167966249999,
							28.59764101600007
						],
						[
							-81.4167215139999,
							28.597491795000053
						],
						[
							-81.4161465979999,
							28.596375211000066
						],
						[
							-81.4157251339999,
							28.595576788000074
						],
						[
							-81.4155274389999,
							28.59520350300005
						],
						[
							-81.41712399999994,
							28.595243000000043
						],
						[
							-81.41713399999992,
							28.595638000000065
						],
						[
							-81.41755499999994,
							28.595646000000045
						],
						[
							-81.41764099999995,
							28.595630000000085
						],
						[
							-81.41809099999995,
							28.59545300000008
						],
						[
							-81.41851199999991,
							28.59515900000008
						],
						[
							-81.41862199999991,
							28.59507300000007
						],
						[
							-81.41880099999992,
							28.59461500000009
						],
						[
							-81.41895299999993,
							28.594227000000046
						],
						[
							-81.4188299999999,
							28.593653000000074
						],
						[
							-81.41850049999994,
							28.59302100000008
						],
						[
							-81.41821799999991,
							28.59248000000008
						],
						[
							-81.41808999999995,
							28.592241000000058
						],
						[
							-81.4180209999999,
							28.59211600000009
						],
						[
							-81.41782099999995,
							28.59175300000004
						],
						[
							-81.41755992999992,
							28.59175393600009
						],
						[
							-81.41709474699991,
							28.591183038000054
						],
						[
							-81.41659498199994,
							28.590114575000086
						],
						[
							-81.41641309799991,
							28.589322080000045
						],
						[
							-81.41698388099991,
							28.589322080000045
						],
						[
							-81.41854197299995,
							28.589322080000045
						],
						[
							-81.4185004979999,
							28.585505595000086
						],
						[
							-81.4202269999999,
							28.585337156000037
						],
						[
							-81.4202269999999,
							28.58536500000008
						],
						[
							-81.4202269999999,
							28.585725000000085
						],
						[
							-81.42040799999995,
							28.585725000000085
						],
						[
							-81.42249299999992,
							28.58573300000006
						],
						[
							-81.42259199999995,
							28.58573300000006
						],
						[
							-81.4235579999999,
							28.58573300000006
						],
						[
							-81.42429099999993,
							28.58574800000008
						],
						[
							-81.42450813799991,
							28.585736572000087
						],
						[
							-81.42457599999994,
							28.58573300000006
						],
						[
							-81.42458099999993,
							28.58587300000005
						],
						[
							-81.42457899999994,
							28.586014000000034
						],
						[
							-81.42452099999991,
							28.586008000000053
						],
						[
							-81.42429099999993,
							28.58600900000005
						],
						[
							-81.42429199999992,
							28.58637800000008
						],
						[
							-81.42428299999995,
							28.586613000000057
						],
						[
							-81.42452101599991,
							28.586624192000045
						],
						[
							-81.42452563099994,
							28.588915802000088
						],
						[
							-81.42456413199994,
							28.58891607600009
						],
						[
							-81.42634678799993,
							28.58891607600009
						],
						[
							-81.44088435099991,
							28.589094284000055
						],
						[
							-81.44097335299995,
							28.59275089600004
						],
						[
							-81.4429365229999,
							28.592750631000058
						],
						[
							-81.4429994859999,
							28.59616582800004
						],
						[
							-81.44303066399995,
							28.59814689400008
						],
						[
							-81.44103544199993,
							28.598184693000064
						],
						[
							-81.44107858399991,
							28.601762128000075
						],
						[
							-81.44108064799991,
							28.60193802000009
						],
						[
							-81.44114373299993,
							28.60731341400009
						],
						[
							-81.4411464659999,
							28.607546275000065
						],
						[
							-81.43887950599992,
							28.607551690000037
						],
						[
							-81.43833099999995,
							28.607553000000053
						],
						[
							-81.43833199999995,
							28.607663000000063
						],
						[
							-81.43833199999995,
							28.609183189000078
						],
						[
							-81.43833199999995,
							28.60929100000004
						],
						[
							-81.43624799999992,
							28.60929100000004
						],
						[
							-81.4362457009999,
							28.609223366000037
						],
						[
							-81.43623599999995,
							28.60893800000008
						],
						[
							-81.4352909509999,
							28.608939370000087
						],
						[
							-81.43485699999992,
							28.608940000000075
						],
						[
							-81.43485932499993,
							28.608912098000076
						],
						[
							-81.43489899999992,
							28.60843600000004
						],
						[
							-81.43496599999992,
							28.60762200000005
						],
						[
							-81.4350389999999,
							28.606823000000077
						],
						[
							-81.43499899999995,
							28.606077000000084
						],
						[
							-81.43504899999994,
							28.605679000000066
						],
						[
							-81.4351309999999,
							28.60493100000008
						],
						[
							-81.43513899999994,
							28.603979000000038
						],
						[
							-81.43499199999991,
							28.603977000000043
						],
						[
							-81.4322909999999,
							28.60402300000004
						],
						[
							-81.4319759999999,
							28.604024000000038
						],
						[
							-81.43154699999991,
							28.606588000000045
						],
						[
							-81.43151299999994,
							28.606703000000042
						],
						[
							-81.4313459999999,
							28.60671700000006
						],
						[
							-81.43129499999993,
							28.607443000000046
						],
						[
							-81.43132199999991,
							28.60760300000004
						],
						[
							-81.43324499999994,
							28.60760300000004
						],
						[
							-81.43324499999994,
							28.608760000000075
						],
						[
							-81.43349399999995,
							28.60923900000006
						],
						[
							-81.43456199999991,
							28.609240000000057
						],
						[
							-81.43454199999991,
							28.609656000000086
						],
						[
							-81.43444499999993,
							28.61124600000005
						],
						[
							-81.43434899999994,
							28.612550000000056
						],
						[
							-81.4321293989999,
							28.61255264600004
						],
						[
							-81.43183199999993,
							28.612553000000048
						],
						[
							-81.43190299999993,
							28.612418000000048
						],
						[
							-81.43185516699992,
							28.61238607000007
						],
						[
							-81.43181709299995,
							28.61236065500009
						],
						[
							-81.43151199999994,
							28.61215700000008
						],
						[
							-81.43142899999992,
							28.612282000000054
						],
						[
							-81.43114899999995,
							28.612118000000066
						],
						[
							-81.4309209999999,
							28.611973000000035
						],
						[
							-81.4308814389999,
							28.611821843000087
						],
						[
							-81.4308539999999,
							28.611717000000056
						],
						[
							-81.43070899999992,
							28.611632000000043
						],
						[
							-81.42862999999994,
							28.61035600000008
						],
						[
							-81.42800699999992,
							28.609984000000058
						],
						[
							-81.42712463499993,
							28.60945671500008
						],
						[
							-81.42684899999995,
							28.60929200000004
						],
						[
							-81.42656399999993,
							28.609117000000083
						],
						[
							-81.42650399999991,
							28.609356000000048
						],
						[
							-81.42564799999991,
							28.610304000000042
						],
						[
							-81.42331893399995,
							28.611743354000055
						],
						[
							-81.4226139999999,
							28.612179000000083
						],
						[
							-81.42253099999994,
							28.612223000000085
						],
						[
							-81.42260499999992,
							28.612327000000054
						],
						[
							-81.42321299999992,
							28.613198000000068
						],
						[
							-81.42326999999995,
							28.61327600000004
						],
						[
							-81.42265099999992,
							28.614352000000054
						],
						[
							-81.42202299999991,
							28.614212000000066
						],
						[
							-81.42113754499991,
							28.61394245000008
						],
						[
							-81.42082399999993,
							28.613847000000078
						],
						[
							-81.42072732699995,
							28.613805470000045
						],
						[
							-81.41925513699994,
							28.613173019000044
						],
						[
							-81.41918844199995,
							28.613144367000075
						],
						[
							-81.41915499999995,
							28.61313000000007
						],
						[
							-81.41908499999994,
							28.613090000000057
						],
						[
							-81.41881844599993,
							28.612937627000065
						],
						[
							-81.41774499999991,
							28.612324000000058
						],
						[
							-81.41709858099995,
							28.611691688000064
						],
						[
							-81.41696599999995,
							28.61156200000005
						],
						[
							-81.41688299999993,
							28.611469000000056
						]
					],
					[
						[
							-81.43548328599991,
							28.59322505000006
						],
						[
							-81.4353789889999,
							28.593126914000038
						],
						[
							-81.43429266699991,
							28.593254210000055
						],
						[
							-81.4342468179999,
							28.593258397000056
						],
						[
							-81.43424044499994,
							28.593258792000086
						],
						[
							-81.43323044499994,
							28.59331779200005
						],
						[
							-81.43317799999994,
							28.59331932200007
						],
						[
							-81.43246737899995,
							28.59331932200007
						],
						[
							-81.43245935399995,
							28.593323294000076
						],
						[
							-81.4322907689999,
							28.593467472000043
						],
						[
							-81.43196093199992,
							28.593830981000053
						],
						[
							-81.43182559999991,
							28.594062277000035
						],
						[
							-81.43182714599993,
							28.594064036000077
						],
						[
							-81.43186447999994,
							28.594109527000057
						],
						[
							-81.43189875899992,
							28.59415736300008
						],
						[
							-81.43192983599994,
							28.594207339000036
						],
						[
							-81.43195757699993,
							28.594259240000042
						],
						[
							-81.4319818649999,
							28.594312844000058
						],
						[
							-81.43200259499991,
							28.59436792200006
						],
						[
							-81.4320196779999,
							28.594424238000045
						],
						[
							-81.43203304199994,
							28.594481551000058
						],
						[
							-81.43204262799992,
							28.59453961500009
						],
						[
							-81.4320483969999,
							28.59459818100004
						],
						[
							-81.43205032199995,
							28.594657000000044
						],
						[
							-81.4320483969999,
							28.594715818000054
						],
						[
							-81.43204262799992,
							28.59477438500005
						],
						[
							-81.43203781599995,
							28.594806460000086
						],
						[
							-81.43202281599991,
							28.59489546100008
						],
						[
							-81.43201804199992,
							28.594921449000083
						],
						[
							-81.43200467899993,
							28.59497876200004
						],
						[
							-81.4319875949999,
							28.59503507800008
						],
						[
							-81.43196686499994,
							28.595090156000083
						],
						[
							-81.4319425779999,
							28.59514376000004
						],
						[
							-81.43191483599992,
							28.595195661000048
						],
						[
							-81.4318837589999,
							28.595245637000062
						],
						[
							-81.43184947999993,
							28.595293473000083
						],
						[
							-81.43181214599991,
							28.595338964000067
						],
						[
							-81.43177191699994,
							28.595381917000058
						],
						[
							-81.43172896399994,
							28.59542214600009
						],
						[
							-81.43169071599993,
							28.595453863000046
						],
						[
							-81.43148271599995,
							28.59561686300009
						],
						[
							-81.43147547199993,
							28.595622480000088
						],
						[
							-81.43145576299992,
							28.59563717900005
						],
						[
							-81.4312096239999,
							28.595815574000085
						],
						[
							-81.43108434399994,
							28.59595770800007
						],
						[
							-81.4308600299999,
							28.596274596000057
						],
						[
							-81.43083947999992,
							28.596302473000037
						],
						[
							-81.43080927999995,
							28.59633972900008
						],
						[
							-81.43063128099993,
							28.59654772800008
						],
						[
							-81.4306241459999,
							28.59655596400006
						],
						[
							-81.43058391699992,
							28.59659891600006
						],
						[
							-81.43054096499992,
							28.596639146000086
						],
						[
							-81.43049547299995,
							28.596676480000042
						],
						[
							-81.43044763699994,
							28.596710759000075
						],
						[
							-81.43039766099992,
							28.596741835000046
						],
						[
							-81.43034575999991,
							28.59676957700009
						],
						[
							-81.43029215599995,
							28.596793865000052
						],
						[
							-81.43023707799996,
							28.59681459500007
						],
						[
							-81.4301807619999,
							28.59683167800006
						],
						[
							-81.43012344899995,
							28.59684504200004
						],
						[
							-81.43007187899991,
							28.596853749000047
						],
						[
							-81.42992087899995,
							28.59687474900005
						],
						[
							-81.4299143849999,
							28.596875628000078
						],
						[
							-81.42985581799991,
							28.59688139600007
						],
						[
							-81.42984174499992,
							28.596882208000068
						],
						[
							-81.42984039599992,
							28.596908819000078
						],
						[
							-81.42983462799992,
							28.596967385000085
						],
						[
							-81.42982504199995,
							28.597025449000057
						],
						[
							-81.42981901799993,
							28.597053402000085
						],
						[
							-81.42976465999993,
							28.597287514000072
						],
						[
							-81.42976557699991,
							28.59728924000007
						],
						[
							-81.42978986499992,
							28.59734284400008
						],
						[
							-81.42981059499994,
							28.597397922000088
						],
						[
							-81.42982767799992,
							28.59745423800007
						],
						[
							-81.42983005999992,
							28.597463317000063
						],
						[
							-81.43020805999993,
							28.59893531700004
						],
						[
							-81.43021904199992,
							28.59898355100006
						],
						[
							-81.43022862799995,
							28.599041614000043
						],
						[
							-81.43023439699994,
							28.59910018100004
						],
						[
							-81.43023584799995,
							28.59912980300004
						],
						[
							-81.43023962799992,
							28.59915561500009
						],
						[
							-81.43024539599992,
							28.599214182000082
						],
						[
							-81.43024654499993,
							28.599249287000077
						],
						[
							-81.43031100399992,
							28.599266922000083
						],
						[
							-81.43058868899993,
							28.599341303000074
						],
						[
							-81.4305887619999,
							28.599341322000043
						],
						[
							-81.43064507799994,
							28.59935840500009
						],
						[
							-81.43070015599994,
							28.59937913500005
						],
						[
							-81.4307537599999,
							28.59940342300007
						],
						[
							-81.43080566099991,
							28.599431165000055
						],
						[
							-81.43085563699992,
							28.599462241000083
						],
						[
							-81.43090347299994,
							28.59949652000006
						],
						[
							-81.43094896399992,
							28.599533854000075
						],
						[
							-81.43099191699991,
							28.59957408400004
						],
						[
							-81.43109591599996,
							28.59967808300007
						],
						[
							-81.43113614599991,
							28.599721036000062
						],
						[
							-81.43117347999993,
							28.599766527000043
						],
						[
							-81.4312077589999,
							28.599814363000068
						],
						[
							-81.43123883499993,
							28.599864339000078
						],
						[
							-81.43126657699993,
							28.599916240000084
						],
						[
							-81.43129086499994,
							28.599969844000043
						],
						[
							-81.43131159499991,
							28.60002492200005
						],
						[
							-81.43132867799994,
							28.600081238000087
						],
						[
							-81.43133969899992,
							28.600127161000046
						],
						[
							-81.43161235999992,
							28.601410941000044
						],
						[
							-81.43162050199993,
							28.601407394000034
						],
						[
							-81.43166849599993,
							28.60129550000005
						],
						[
							-81.43168842299991,
							28.601252240000065
						],
						[
							-81.43171616399991,
							28.60120033900006
						],
						[
							-81.43174724099993,
							28.601150364000034
						],
						[
							-81.43174971099995,
							28.60114668600005
						],
						[
							-81.43179550699996,
							28.601078874000052
						],
						[
							-81.43181750899993,
							28.601021071000048
						],
						[
							-81.43182713499993,
							28.600996845000054
						],
						[
							-81.4318514229999,
							28.60094324000005
						],
						[
							-81.43187916499996,
							28.600891339000043
						],
						[
							-81.43191024099991,
							28.600841364000075
						],
						[
							-81.43194451999994,
							28.600793528000054
						],
						[
							-81.4319818539999,
							28.600748036000084
						],
						[
							-81.43202208399993,
							28.600705084000083
						],
						[
							-81.43206503599993,
							28.60066485400006
						],
						[
							-81.43207330899992,
							28.60065768800007
						],
						[
							-81.43226730899994,
							28.60049168800009
						],
						[
							-81.43230452799993,
							28.600461520000067
						],
						[
							-81.43235236399994,
							28.60042724100009
						],
						[
							-81.4324023389999,
							28.600396164000074
						],
						[
							-81.43243263099994,
							28.600379444000055
						],
						[
							-81.43415855599994,
							28.599469640000052
						],
						[
							-81.43417708999993,
							28.59942909700004
						],
						[
							-81.43417745899991,
							28.599428291000038
						],
						[
							-81.43421423899991,
							28.599348045000056
						],
						[
							-81.4342292309999,
							28.599199621000082
						],
						[
							-81.43423237199994,
							28.599172615000043
						],
						[
							-81.43424195799992,
							28.59911455100007
						],
						[
							-81.43425532099991,
							28.599057239000047
						],
						[
							-81.43427240499994,
							28.599000923000062
						],
						[
							-81.43428946699993,
							28.598954836000075
						],
						[
							-81.43443846699995,
							28.598583836000046
						],
						[
							-81.43444213499994,
							28.59857484500009
						],
						[
							-81.43446642299995,
							28.598521240000082
						],
						[
							-81.43449416499993,
							28.598469339000076
						],
						[
							-81.43451747099995,
							28.59843119300007
						],
						[
							-81.43481447099992,
							28.597971192000045
						],
						[
							-81.43482224099995,
							28.597959363000086
						],
						[
							-81.43485651899994,
							28.59791152700007
						],
						[
							-81.43489385299995,
							28.597866035000038
						],
						[
							-81.43493408299992,
							28.59782308300004
						],
						[
							-81.43497703499992,
							28.59778285400006
						],
						[
							-81.4349852709999,
							28.597775719000083
						],
						[
							-81.43517596399994,
							28.59761253000005
						],
						[
							-81.43530562799992,
							28.59748966500007
						],
						[
							-81.43535839599991,
							28.597379638000064
						],
						[
							-81.43547340399994,
							28.59703288500009
						],
						[
							-81.43547540499992,
							28.597026922000055
						],
						[
							-81.43549613499994,
							28.596971844000052
						],
						[
							-81.4355204229999,
							28.596918240000036
						],
						[
							-81.43554816499994,
							28.596866339000087
						],
						[
							-81.43557924099991,
							28.596816363000073
						],
						[
							-81.43561351999995,
							28.59676852700005
						],
						[
							-81.4356508539999,
							28.59672303600007
						],
						[
							-81.43569108399993,
							28.59668008300008
						],
						[
							-81.43571529899992,
							28.596656757000062
						],
						[
							-81.43580408699995,
							28.596574372000077
						],
						[
							-81.43581551499994,
							28.596551592000083
						],
						[
							-81.43581643499994,
							28.59654538400008
						],
						[
							-81.4355968669999,
							28.596240058000035
						],
						[
							-81.43557924099991,
							28.59621463700006
						],
						[
							-81.43554816499994,
							28.596164661000046
						],
						[
							-81.4355204229999,
							28.59611276000004
						],
						[
							-81.43549613499994,
							28.59605915600008
						],
						[
							-81.4354763689999,
							28.596006901000067
						],
						[
							-81.43531336899991,
							28.595531901000076
						],
						[
							-81.43531240499993,
							28.595529077000037
						],
						[
							-81.43529532199994,
							28.595472761000053
						],
						[
							-81.4352819579999,
							28.595415449000086
						],
						[
							-81.43527237199993,
							28.59535738500006
						],
						[
							-81.4352706279999,
							28.595343280000066
						],
						[
							-81.43521062799994,
							28.59482428000007
						],
						[
							-81.43520660299993,
							28.594779819000053
						],
						[
							-81.43520509899992,
							28.594748517000085
						],
						[
							-81.4351900989999,
							28.59425851700007
						],
						[
							-81.4351916039999,
							28.59417218100009
						],
						[
							-81.43519737199995,
							28.594113615000083
						],
						[
							-81.43520695799992,
							28.594055551000054
						],
						[
							-81.43521988999993,
							28.59399985400006
						],
						[
							-81.43529488999991,
							28.59371785400009
						],
						[
							-81.43529532199994,
							28.59371623900006
						],
						[
							-81.43531240499993,
							28.593659923000075
						],
						[
							-81.4353265119999,
							28.593621290000044
						],
						[
							-81.43541595499994,
							28.59339271200008
						],
						[
							-81.43545840399992,
							28.593283136000082
						],
						[
							-81.4354661349999,
							28.593263844000035
						],
						[
							-81.43548301899995,
							28.593225618000076
						],
						[
							-81.43548328599991,
							28.59322505000006
						]
					],
					[
						[
							-81.42742141799994,
							28.597986249000087
						],
						[
							-81.42710741999991,
							28.59779342600007
						],
						[
							-81.42710267799993,
							28.597813761000054
						],
						[
							-81.42708559499994,
							28.59787007700004
						],
						[
							-81.42706486499993,
							28.59792515500004
						],
						[
							-81.4270405769999,
							28.59797876000005
						],
						[
							-81.42702332699992,
							28.598011979000034
						],
						[
							-81.42693432699991,
							28.598174979000078
						],
						[
							-81.4269238359999,
							28.59819366100004
						],
						[
							-81.42689275899994,
							28.598243637000053
						],
						[
							-81.4268584809999,
							28.598291473000078
						],
						[
							-81.42682114699994,
							28.598336964000055
						],
						[
							-81.42680424199995,
							28.59835570300004
						],
						[
							-81.42661124099993,
							28.59856370300008
						],
						[
							-81.4265879159999,
							28.598587916000046
						],
						[
							-81.4265449639999,
							28.598628146000067
						],
						[
							-81.42654052899991,
							28.598632009000085
						],
						[
							-81.42650799499997,
							28.598660167000048
						],
						[
							-81.4265093219999,
							28.598709000000042
						],
						[
							-81.4265083489999,
							28.598750818000042
						],
						[
							-81.42647934899992,
							28.599373818000064
						],
						[
							-81.42647839599994,
							28.599390819000064
						],
						[
							-81.42647262799994,
							28.59944938500007
						],
						[
							-81.42646304099993,
							28.599507449000043
						],
						[
							-81.42645268699994,
							28.599553228000048
						],
						[
							-81.42627509099992,
							28.60025299600005
						],
						[
							-81.42622082699995,
							28.60053413600008
						],
						[
							-81.42638329999994,
							28.600606256000052
						],
						[
							-81.42657949599993,
							28.600650614000074
						],
						[
							-81.4268347659999,
							28.600366246000082
						],
						[
							-81.42686808299995,
							28.60033108300007
						],
						[
							-81.42691103599992,
							28.600290854000036
						],
						[
							-81.42695652799995,
							28.60025352000008
						],
						[
							-81.42700436399991,
							28.600219241000048
						],
						[
							-81.42702909099995,
							28.600203298000054
						],
						[
							-81.42726709099992,
							28.60005529700004
						],
						[
							-81.4272923389999,
							28.600040164000067
						],
						[
							-81.42734423999991,
							28.600012422000077
						],
						[
							-81.42739784499992,
							28.599988134000057
						],
						[
							-81.42745292299992,
							28.599967405000086
						],
						[
							-81.4275092389999,
							28.59995032100005
						],
						[
							-81.42752215799993,
							28.59994696200005
						],
						[
							-81.42776015699991,
							28.599886962000085
						],
						[
							-81.42776806599994,
							28.599885180000058
						],
						[
							-81.42758240899991,
							28.599707377000072
						],
						[
							-81.42753736999992,
							28.599667681000085
						],
						[
							-81.42749608399993,
							28.599628917000075
						],
						[
							-81.42745585399992,
							28.599585964000084
						],
						[
							-81.42744860499994,
							28.59957759400004
						],
						[
							-81.4273776039999,
							28.59949459400008
						],
						[
							-81.4273475199999,
							28.59945747200004
						],
						[
							-81.42731324099992,
							28.599409636000075
						],
						[
							-81.4272821639999,
							28.59935966100005
						],
						[
							-81.42725442199992,
							28.599307760000045
						],
						[
							-81.4272301339999,
							28.59925415500004
						],
						[
							-81.42720940499993,
							28.59919907700004
						],
						[
							-81.42719232099995,
							28.599142761000053
						],
						[
							-81.42718021799993,
							28.599091668000085
						],
						[
							-81.4271744049999,
							28.599075078000055
						],
						[
							-81.42715732199991,
							28.599018762000075
						],
						[
							-81.42714395799993,
							28.598961449000058
						],
						[
							-81.4271343719999,
							28.598903385000085
						],
						[
							-81.42712860299991,
							28.598844819000078
						],
						[
							-81.42712667799992,
							28.598786000000075
						],
						[
							-81.42712667799992,
							28.59876500000007
						],
						[
							-81.42712860299991,
							28.598706182000058
						],
						[
							-81.4271343719999,
							28.59864761500006
						],
						[
							-81.42714395799993,
							28.59858955100009
						],
						[
							-81.42715732199991,
							28.598532239000065
						],
						[
							-81.42716628399997,
							28.598501053000064
						],
						[
							-81.42720128299993,
							28.598387054000057
						],
						[
							-81.42720940499993,
							28.598361923000084
						],
						[
							-81.4272301339999,
							28.59830684500008
						],
						[
							-81.42725442199992,
							28.598253240000076
						],
						[
							-81.4272821639999,
							28.59820133900007
						],
						[
							-81.42730883799993,
							28.59815801700006
						],
						[
							-81.42742141799994,
							28.597986249000087
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Rosemont",
				"RegionID": "125976"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.69916489499991,
					30.36477293100006,
					-81.68398683999993,
					30.38038207100004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.69541696699991,
							30.38038207100004
						],
						[
							-81.68656190299993,
							30.371717010000054
						],
						[
							-81.6857069049999,
							30.37122300800007
						],
						[
							-81.68543990599994,
							30.371058009000084
						],
						[
							-81.68494490599994,
							30.370740009000084
						],
						[
							-81.68458090599997,
							30.370480008000072
						],
						[
							-81.68398683999993,
							30.370075068000066
						],
						[
							-81.68410490799994,
							30.369780009000067
						],
						[
							-81.68437190599991,
							30.369458008000038
						],
						[
							-81.68461190599993,
							30.36921200900008
						],
						[
							-81.68487800699995,
							30.369020093000074
						],
						[
							-81.68495380399993,
							30.36886292300005
						],
						[
							-81.6850769049999,
							30.368763010000066
						],
						[
							-81.68538490499992,
							30.368609007000092
						],
						[
							-81.6857330069999,
							30.368359095000077
						],
						[
							-81.68582591599994,
							30.36821188500005
						],
						[
							-81.68759190499992,
							30.367743009000034
						],
						[
							-81.68976290499995,
							30.367221008000058
						],
						[
							-81.69133488099993,
							30.366685921000055
						],
						[
							-81.6979059059999,
							30.36512400800007
						],
						[
							-81.6988578619999,
							30.36477293100006
						],
						[
							-81.69888290599994,
							30.36610600800009
						],
						[
							-81.69889090599992,
							30.36652400800006
						],
						[
							-81.69891390499993,
							30.368177008000085
						],
						[
							-81.69895890599992,
							30.369883008000045
						],
						[
							-81.69895890599992,
							30.370132008000045
						],
						[
							-81.69897490499994,
							30.37049900800008
						],
						[
							-81.69897490499994,
							30.370708009000055
						],
						[
							-81.69898990599995,
							30.37155300800003
						],
						[
							-81.69899690599993,
							30.371899009000064
						],
						[
							-81.6990129049999,
							30.372623008000065
						],
						[
							-81.69902790499992,
							30.372929009000078
						],
						[
							-81.69902790599991,
							30.373234009000043
						],
						[
							-81.69904290599993,
							30.373539009000073
						],
						[
							-81.69905090499992,
							30.374146008000082
						],
						[
							-81.69907390599991,
							30.37484900800007
						],
						[
							-81.69908090599995,
							30.37533400900008
						],
						[
							-81.69907390599991,
							30.375639009000054
						],
						[
							-81.69909390599992,
							30.376270008000063
						],
						[
							-81.69909690599991,
							30.376499009000046
						],
						[
							-81.6991009059999,
							30.37659500900008
						],
						[
							-81.6991039049999,
							30.376680009000044
						],
						[
							-81.69910890499995,
							30.376734008000085
						],
						[
							-81.69911990499992,
							30.37685200900006
						],
						[
							-81.69912690599995,
							30.37746800800005
						],
						[
							-81.69913490599993,
							30.377535008000052
						],
						[
							-81.69914190499992,
							30.37801000800005
						],
						[
							-81.6991499049999,
							30.37818500800006
						],
						[
							-81.69914190599991,
							30.378401008000083
						],
						[
							-81.69916489499991,
							30.37883800800006
						],
						[
							-81.6989589069999,
							30.378837009000055
						],
						[
							-81.69864690599992,
							30.378851008000087
						],
						[
							-81.69827290599994,
							30.378895009000072
						],
						[
							-81.6978829059999,
							30.378979008000044
						],
						[
							-81.69753190599994,
							30.37907500900008
						],
						[
							-81.69696690599994,
							30.379294009000034
						],
						[
							-81.69663890599992,
							30.37945800800009
						],
						[
							-81.69647090599994,
							30.379554008000074
						],
						[
							-81.6961509059999,
							30.37978100900006
						],
						[
							-81.69600490499994,
							30.379909009000077
						],
						[
							-81.6958369059999,
							30.38003800900009
						],
						[
							-81.69569190499993,
							30.38016800800006
						],
						[
							-81.69550890599993,
							30.380301009000046
						],
						[
							-81.69541696699991,
							30.38038207100004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Royal Terrace",
				"RegionID": "125993"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.62668095299995,
					30.23307596700005,
					-81.60795585299991,
					30.26378808500004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.61430390599992,
							30.23489600900007
						],
						[
							-81.61512791399991,
							30.23427582100004
						],
						[
							-81.6155548989999,
							30.234690201000035
						],
						[
							-81.61592090499994,
							30.23440600800006
						],
						[
							-81.61689790499992,
							30.23369200800005
						],
						[
							-81.6177599429999,
							30.23307596700005
						],
						[
							-81.61830090699993,
							30.233706010000052
						],
						[
							-81.61897990799991,
							30.234524010000086
						],
						[
							-81.61959090699992,
							30.235214010000046
						],
						[
							-81.61994890799991,
							30.23564101100004
						],
						[
							-81.62011690799994,
							30.23584201100005
						],
						[
							-81.62063590799994,
							30.236416010000088
						],
						[
							-81.62068890799992,
							30.236469010000068
						],
						[
							-81.62093390699994,
							30.23678401100005
						],
						[
							-81.62118490799992,
							30.237078010000065
						],
						[
							-81.62125590799991,
							30.237155010000038
						],
						[
							-81.6214449069999,
							30.237357011000086
						],
						[
							-81.62180790699995,
							30.237770011000062
						],
						[
							-81.62190990699992,
							30.23788501100006
						],
						[
							-81.62230690699994,
							30.23835401100007
						],
						[
							-81.62259685999993,
							30.238665042000036
						],
						[
							-81.62261191099992,
							30.238697012000046
						],
						[
							-81.62325990699992,
							30.23947001000005
						],
						[
							-81.62383990699993,
							30.240135011000064
						],
						[
							-81.62446590699994,
							30.240864010000053
						],
						[
							-81.62471790899993,
							30.241179010000053
						],
						[
							-81.62485490699993,
							30.241333010000062
						],
						[
							-81.62532490699994,
							30.24188201000004
						],
						[
							-81.62567595799993,
							30.242291983000086
						],
						[
							-81.62552683199993,
							30.242454973000065
						],
						[
							-81.62550590799992,
							30.242559007000068
						],
						[
							-81.6256179049999,
							30.244316008000055
						],
						[
							-81.6256789059999,
							30.24540700800009
						],
						[
							-81.62575490499995,
							30.24704700800004
						],
						[
							-81.62577790599994,
							30.247343009000076
						],
						[
							-81.62582390599994,
							30.248066009000073
						],
						[
							-81.62591390599994,
							30.249640008000085
						],
						[
							-81.62599190599992,
							30.25084900800005
						],
						[
							-81.6260169059999,
							30.25141600800004
						],
						[
							-81.62603790599991,
							30.251822008000094
						],
						[
							-81.6260449049999,
							30.251940008000076
						],
						[
							-81.6261749059999,
							30.253796008000055
						],
						[
							-81.62619081699995,
							30.25415201800007
						],
						[
							-81.62621290599992,
							30.254608008000044
						],
						[
							-81.62621790599991,
							30.255138008000074
						],
						[
							-81.62623990499992,
							30.255485008000054
						],
						[
							-81.62624890599994,
							30.255733008000046
						],
						[
							-81.6261749059999,
							30.25689300800008
						],
						[
							-81.62610590499992,
							30.258099008000045
						],
						[
							-81.6260679049999,
							30.258711009000077
						],
						[
							-81.62605990499993,
							30.258886008000047
						],
						[
							-81.6259918529999,
							30.25958300800005
						],
						[
							-81.62602590699993,
							30.259852010000092
						],
						[
							-81.62608290599991,
							30.260029008000064
						],
						[
							-81.6261519059999,
							30.260166008000056
						],
						[
							-81.62668095299995,
							30.260975917000053
						],
						[
							-81.62654490499995,
							30.260995010000045
						],
						[
							-81.62648590499992,
							30.261016008000073
						],
						[
							-81.6264569089999,
							30.261021010000036
						],
						[
							-81.62627390599994,
							30.261106008000073
						],
						[
							-81.62538090499993,
							30.261673008000063
						],
						[
							-81.62373390599993,
							30.26277200800007
						],
						[
							-81.62221495499995,
							30.26378808500004
						],
						[
							-81.62213890599992,
							30.263693009000065
						],
						[
							-81.62181890599993,
							30.26324100800008
						],
						[
							-81.62144490599992,
							30.262741009000077
						],
						[
							-81.62110090499993,
							30.26220900900006
						],
						[
							-81.62067390599992,
							30.261602008000068
						],
						[
							-81.62044490499994,
							30.261299009000084
						],
						[
							-81.61993390499993,
							30.26056100800008
						],
						[
							-81.61914090499994,
							30.259453008000037
						],
						[
							-81.6189729059999,
							30.25920300800004
						],
						[
							-81.6186139049999,
							30.258715008000085
						],
						[
							-81.61825590599996,
							30.258184008000057
						],
						[
							-81.61792790599992,
							30.25772100800009
						],
						[
							-81.61780490699994,
							30.25748400700007
						],
						[
							-81.6170579059999,
							30.255306009000037
						],
						[
							-81.61685190499992,
							30.25472800800009
						],
						[
							-81.61675290599993,
							30.254477009000087
						],
						[
							-81.61664590599992,
							30.254253009000085
						],
						[
							-81.61639390499994,
							30.253832009000067
						],
						[
							-81.61577590599991,
							30.252985009000046
						],
						[
							-81.61527290499993,
							30.25227700800008
						],
						[
							-81.61512990599994,
							30.25207800800007
						],
						[
							-81.61405390599992,
							30.25058400800009
						],
						[
							-81.61360390599992,
							30.249958009000068
						],
						[
							-81.61315890599991,
							30.249317009000038
						],
						[
							-81.61294690599993,
							30.24902000900005
						],
						[
							-81.61236090599994,
							30.248200009000076
						],
						[
							-81.61168590599993,
							30.24725500800008
						],
						[
							-81.61144590599991,
							30.246920009000064
						],
						[
							-81.6111339059999,
							30.246493009000062
						],
						[
							-81.61059590499991,
							30.245724009000075
						],
						[
							-81.60995090499995,
							30.24481700800004
						],
						[
							-81.60944190499993,
							30.244085009000056
						],
						[
							-81.60926090599992,
							30.243835008000076
						],
						[
							-81.60919690599991,
							30.24371700900008
						],
						[
							-81.60912290599993,
							30.243582008000093
						],
						[
							-81.60901490499992,
							30.24331100900008
						],
						[
							-81.60880990499994,
							30.24263000800005
						],
						[
							-81.60866790599994,
							30.24213700900009
						],
						[
							-81.60860490499994,
							30.241920009000072
						],
						[
							-81.60841890599994,
							30.24131300900007
						],
						[
							-81.60834090599991,
							30.24102400900006
						],
						[
							-81.60803985399991,
							30.240011017000086
						],
						[
							-81.60803998499995,
							30.23985298700006
						],
						[
							-81.60795585299991,
							30.239702023000067
						],
						[
							-81.60891690599993,
							30.23900000500004
						],
						[
							-81.60908490599991,
							30.23881300800008
						],
						[
							-81.6093139059999,
							30.238611009000067
						],
						[
							-81.61017590599994,
							30.237951008000042
						],
						[
							-81.61116790599993,
							30.23720600900009
						],
						[
							-81.61430390599992,
							30.23489600900007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "San Jose",
				"RegionID": "126042"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.64333632199993,
					30.24094585100005,
					-81.62550590799992,
					30.255347180000058
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.63313287999995,
							30.255347180000058
						],
						[
							-81.63017894599996,
							30.253805835000037
						],
						[
							-81.62619081699995,
							30.25415201800007
						],
						[
							-81.6261749059999,
							30.253796008000055
						],
						[
							-81.6260449049999,
							30.251940008000076
						],
						[
							-81.62603790599991,
							30.251822008000094
						],
						[
							-81.6260169059999,
							30.25141600800004
						],
						[
							-81.62599190599992,
							30.25084900800005
						],
						[
							-81.62591390599994,
							30.249640008000085
						],
						[
							-81.62582390599994,
							30.248066009000073
						],
						[
							-81.62577790599994,
							30.247343009000076
						],
						[
							-81.62575490499995,
							30.24704700800004
						],
						[
							-81.6256789059999,
							30.24540700800009
						],
						[
							-81.6256179049999,
							30.244316008000055
						],
						[
							-81.62550590799992,
							30.242559007000068
						],
						[
							-81.62552683199993,
							30.242454973000065
						],
						[
							-81.62567595799993,
							30.242291983000086
						],
						[
							-81.62612990699995,
							30.242794010000072
						],
						[
							-81.62633290799994,
							30.243035011000075
						],
						[
							-81.6265338959999,
							30.24325219600007
						],
						[
							-81.6288909079999,
							30.241309010000066
						],
						[
							-81.62907284199991,
							30.24115889400008
						],
						[
							-81.62957199999994,
							30.24100500000009
						],
						[
							-81.62966299999994,
							30.241117000000088
						],
						[
							-81.63069093999991,
							30.24094585100005
						],
						[
							-81.63148825199994,
							30.241902885000062
						],
						[
							-81.63428703299991,
							30.243567501000086
						],
						[
							-81.64037907999996,
							30.245540426000044
						],
						[
							-81.64040958599992,
							30.24555091400003
						],
						[
							-81.6405516609999,
							30.245617164000066
						],
						[
							-81.64068007299994,
							30.24570707900006
						],
						[
							-81.6407909209999,
							30.24581792700008
						],
						[
							-81.6408577869999,
							30.24590859200004
						],
						[
							-81.64198378599991,
							30.247654592000057
						],
						[
							-81.64199792699992,
							30.247677251000084
						],
						[
							-81.64269693999995,
							30.248835272000065
						],
						[
							-81.64321139499992,
							30.24968781700005
						],
						[
							-81.64324895999994,
							30.249758409000037
						],
						[
							-81.64328010299994,
							30.249832060000074
						],
						[
							-81.64330457699992,
							30.249908188000063
						],
						[
							-81.64332218899995,
							30.249986190000072
						],
						[
							-81.6433327979999,
							30.250065448000043
						],
						[
							-81.64333632199993,
							30.25014533600006
						],
						[
							-81.64333532199993,
							30.25148533500004
						],
						[
							-81.64333532199993,
							30.251650000000044
						],
						[
							-81.64333532199993,
							30.25178908700008
						],
						[
							-81.64243499999992,
							30.252245000000073
						],
						[
							-81.64074998399991,
							30.25387016600007
						],
						[
							-81.63313287999995,
							30.255347180000058
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "San Jose Forest",
				"RegionID": "126043"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.66111341099992,
					30.295119961000065,
					-81.63939782599994,
					30.314248352000053
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.6455196039999,
							30.307235366000047
						],
						[
							-81.6441490659999,
							30.306230381000034
						],
						[
							-81.64277856899992,
							30.304768514000042
						],
						[
							-81.64168216999991,
							30.303032554000087
						],
						[
							-81.64067713799994,
							30.301570688000087
						],
						[
							-81.63939782599994,
							30.29946921000004
						],
						[
							-81.64327505799992,
							30.297378965000068
						],
						[
							-81.6439449049999,
							30.29831400800009
						],
						[
							-81.64453290599994,
							30.29916900800004
						],
						[
							-81.64488090599991,
							30.299606008000065
						],
						[
							-81.6449129049999,
							30.29964100800004
						],
						[
							-81.64509490599994,
							30.29988400900004
						],
						[
							-81.64520687099991,
							30.300079186000065
						],
						[
							-81.6452260069999,
							30.300064093000056
						],
						[
							-81.64540090499992,
							30.29970400800005
						],
						[
							-81.64546990999992,
							30.299582009000066
						],
						[
							-81.6455609059999,
							30.299500011000074
						],
						[
							-81.6457669049999,
							30.299404009000057
						],
						[
							-81.64665190599993,
							30.299030009000035
						],
						[
							-81.6475219049999,
							30.298658009000064
						],
						[
							-81.64846008399991,
							30.298260067000058
						],
						[
							-81.64815182599995,
							30.29775203300005
						],
						[
							-81.6481429879999,
							30.29761998400005
						],
						[
							-81.64798890599991,
							30.29733100800007
						],
						[
							-81.64789690499993,
							30.297105008000077
						],
						[
							-81.64781681799991,
							30.29684903200007
						],
						[
							-81.64780690599991,
							30.296802009000093
						],
						[
							-81.64772590599995,
							30.29643900800005
						],
						[
							-81.6476999059999,
							30.29628500800004
						],
						[
							-81.64769190599992,
							30.29611800900005
						],
						[
							-81.64769590599991,
							30.295939008000065
						],
						[
							-81.64772290499991,
							30.29567800800004
						],
						[
							-81.64779690599994,
							30.295176008000055
						],
						[
							-81.64780982499991,
							30.295119961000065
						],
						[
							-81.65005431499992,
							30.295156641000066
						],
						[
							-81.65260864099992,
							30.295724266000036
						],
						[
							-81.65482685299992,
							30.295904715000063
						],
						[
							-81.65575613999994,
							30.295563401000038
						],
						[
							-81.65573802499995,
							30.295672122000045
						],
						[
							-81.65890311699991,
							30.30087469000006
						],
						[
							-81.66102862199995,
							30.30423138700007
						],
						[
							-81.66111341099992,
							30.30436886000007
						],
						[
							-81.66026599999994,
							30.304708000000065
						],
						[
							-81.65995789199991,
							30.304845952000047
						],
						[
							-81.65988188299991,
							30.30485292300006
						],
						[
							-81.6595459049999,
							30.305012009000055
						],
						[
							-81.65915390599991,
							30.30517400900004
						],
						[
							-81.65910390599993,
							30.305205006000055
						],
						[
							-81.6590417399999,
							30.305222964000055
						],
						[
							-81.65910290599993,
							30.305286009000042
						],
						[
							-81.6591869049999,
							30.305393008000067
						],
						[
							-81.65984284399991,
							30.306498189000084
						],
						[
							-81.6598859689999,
							30.30647882800008
						],
						[
							-81.65997507599991,
							30.306632965000063
						],
						[
							-81.65996873499995,
							30.306715051000083
						],
						[
							-81.66002690599993,
							30.30681600800006
						],
						[
							-81.66030090599992,
							30.307278009000072
						],
						[
							-81.66047590499994,
							30.307565008000044
						],
						[
							-81.66052290499994,
							30.307665012000086
						],
						[
							-81.66053990499995,
							30.30776400900004
						],
						[
							-81.66052990599991,
							30.30883000800009
						],
						[
							-81.6605379049999,
							30.30961400800004
						],
						[
							-81.6605299069999,
							30.309669008000075
						],
						[
							-81.66054490599993,
							30.310482009000054
						],
						[
							-81.66053790599996,
							30.311308008000086
						],
						[
							-81.6605379049999,
							30.312130009000043
						],
						[
							-81.66054490599993,
							30.312366008000083
						],
						[
							-81.66053790599996,
							30.312925009000082
						],
						[
							-81.66053690599995,
							30.313303008000048
						],
						[
							-81.66053690599995,
							30.313704008000062
						],
						[
							-81.66055190599991,
							30.313850009000078
						],
						[
							-81.66055890599995,
							30.313915009000088
						],
						[
							-81.66056490599993,
							30.313972009000057
						],
						[
							-81.66057204499992,
							30.314040130000084
						],
						[
							-81.65975790499995,
							30.31405600800008
						],
						[
							-81.6594509059999,
							30.31406500900005
						],
						[
							-81.65909190399992,
							30.31409700800009
						],
						[
							-81.6588909059999,
							30.314104009000065
						],
						[
							-81.65635346099992,
							30.314248352000053
						],
						[
							-81.6544717029999,
							30.31424835100006
						],
						[
							-81.65251462599991,
							30.313872126000035
						],
						[
							-81.65107290899994,
							30.312872009000046
						],
						[
							-81.64912750699995,
							30.31093645300007
						],
						[
							-81.64724574899992,
							30.309054696000093
						],
						[
							-81.64631892299991,
							30.30814693900004
						],
						[
							-81.6455196039999,
							30.307235366000047
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "San Marco",
				"RegionID": "126044"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.64252099999993,
					30.416557278000088,
					-81.60060874299995,
					30.44819800700009
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.63430592599991,
							30.447822973000086
						],
						[
							-81.6328879049999,
							30.447558009000094
						],
						[
							-81.62971690599994,
							30.446938009000068
						],
						[
							-81.6292189049999,
							30.446850009000062
						],
						[
							-81.62816690499996,
							30.446645008000072
						],
						[
							-81.6275289049999,
							30.44652400800004
						],
						[
							-81.62376290499994,
							30.445783008000035
						],
						[
							-81.62349190499992,
							30.44574000800009
						],
						[
							-81.62293490699994,
							30.445613008000063
						],
						[
							-81.62125790599993,
							30.445324009000046
						],
						[
							-81.6201699049999,
							30.44512000800006
						],
						[
							-81.61629690599995,
							30.44437900800006
						],
						[
							-81.61496090499992,
							30.444124008000074
						],
						[
							-81.6145809059999,
							30.44404700800004
						],
						[
							-81.61424690599995,
							30.44399000800007
						],
						[
							-81.6130079049999,
							30.44373700800008
						],
						[
							-81.6120119059999,
							30.443556009000076
						],
						[
							-81.60986590599994,
							30.44313000800008
						],
						[
							-81.60814990599994,
							30.44280400800005
						],
						[
							-81.60647488799992,
							30.442474058000073
						],
						[
							-81.60588290699991,
							30.442168007000078
						],
						[
							-81.60563890599991,
							30.441948008000058
						],
						[
							-81.60555490599997,
							30.441846008000088
						],
						[
							-81.6054379059999,
							30.441663006000052
						],
						[
							-81.6053289059999,
							30.44138800800005
						],
						[
							-81.6049499909999,
							30.439762963000078
						],
						[
							-81.60487390799995,
							30.439413010000067
						],
						[
							-81.6037899069999,
							30.434429011000077
						],
						[
							-81.60258490799993,
							30.42899901100009
						],
						[
							-81.60256990699992,
							30.428890010000085
						],
						[
							-81.6023939079999,
							30.42808301100007
						],
						[
							-81.60234090799992,
							30.42788701100005
						],
						[
							-81.60136390799994,
							30.42336701100004
						],
						[
							-81.60127990799992,
							30.423014011000074
						],
						[
							-81.6011579069999,
							30.422409010000084
						],
						[
							-81.60100590799993,
							30.421745010000052
						],
						[
							-81.60092190699993,
							30.42132601000009
						],
						[
							-81.60080690699994,
							30.42098201100004
						],
						[
							-81.6007079069999,
							30.420822010000055
						],
						[
							-81.60060874299995,
							30.420687063000063
						],
						[
							-81.60079974399991,
							30.417777913000062
						],
						[
							-81.6009519079999,
							30.417681009000034
						],
						[
							-81.60118090799995,
							30.41748801000006
						],
						[
							-81.60153099999991,
							30.417160000000084
						],
						[
							-81.60217384899994,
							30.416557278000088
						],
						[
							-81.60225496699991,
							30.416634192000064
						],
						[
							-81.6023098359999,
							30.41671033900008
						],
						[
							-81.60237608599994,
							30.41685241400006
						],
						[
							-81.6024166599999,
							30.41700383400007
						],
						[
							-81.60243032199992,
							30.417160000000084
						],
						[
							-81.60242861699993,
							30.417215355000057
						],
						[
							-81.60237768999991,
							30.41804113600006
						],
						[
							-81.60237075299995,
							30.41815885500006
						],
						[
							-81.60262387099993,
							30.418442380000048
						],
						[
							-81.60306980799993,
							30.418666557000055
						],
						[
							-81.6046158019999,
							30.418857564000064
						],
						[
							-81.60496121099993,
							30.418881902000066
						],
						[
							-81.60503209599995,
							30.418889730000046
						],
						[
							-81.60510213899994,
							30.41890315200004
						],
						[
							-81.60517089699994,
							30.41892208200005
						],
						[
							-81.60523793899995,
							30.418946402000074
						],
						[
							-81.6053028419999,
							30.41897595900008
						],
						[
							-81.60536519899995,
							30.41901056700004
						],
						[
							-81.60542461699993,
							30.419050008000056
						],
						[
							-81.60548072199992,
							30.419094034000068
						],
						[
							-81.60575673699992,
							30.419332042000065
						],
						[
							-81.60794004199995,
							30.420100287000086
						],
						[
							-81.6080866609999,
							30.420168164000074
						],
						[
							-81.60810521099995,
							30.42017917300007
						],
						[
							-81.60888290799994,
							30.420653402000084
						],
						[
							-81.60972703899995,
							30.421111617000065
						],
						[
							-81.60974766099991,
							30.42112316400005
						],
						[
							-81.60987607299995,
							30.42121307900004
						],
						[
							-81.60998692099992,
							30.42132392700006
						],
						[
							-81.6100768359999,
							30.421452339000037
						],
						[
							-81.6101398319999,
							30.421585614000037
						],
						[
							-81.61048045899992,
							30.422492014000056
						],
						[
							-81.61050472099993,
							30.422567723000046
						],
						[
							-81.61052220099992,
							30.42264528000004
						],
						[
							-81.61053276199993,
							30.42272407800004
						],
						[
							-81.61053632199992,
							30.422803500000047
						],
						[
							-81.61053285199995,
							30.422882927000046
						],
						[
							-81.61052237899992,
							30.422961736000047
						],
						[
							-81.60999208999993,
							30.42590802100006
						],
						[
							-81.61067481299995,
							30.431529847000036
						],
						[
							-81.61121245699991,
							30.432041001000076
						],
						[
							-81.6125857369999,
							30.432609408000072
						],
						[
							-81.6128514159999,
							30.43271107600009
						],
						[
							-81.61297966099994,
							30.432772164000085
						],
						[
							-81.61310807299992,
							30.432862079000078
						],
						[
							-81.61321892099994,
							30.43297292700004
						],
						[
							-81.61330883599993,
							30.433101339000075
						],
						[
							-81.61337227199994,
							30.43323578800005
						],
						[
							-81.61368167899991,
							30.43406260100005
						],
						[
							-81.6137236589999,
							30.434217835000084
						],
						[
							-81.61373544799994,
							30.43431597500006
						],
						[
							-81.61375183199993,
							30.434569384000042
						],
						[
							-81.61383139899993,
							30.43470658600006
						],
						[
							-81.61389808599995,
							30.43484941400004
						],
						[
							-81.61393594899994,
							30.43498617800009
						],
						[
							-81.61400454799991,
							30.43534075100007
						],
						[
							-81.61529318299995,
							30.43596718200007
						],
						[
							-81.61534966099993,
							30.43599716500006
						],
						[
							-81.6154780729999,
							30.436087080000053
						],
						[
							-81.61558892099993,
							30.43619792700008
						],
						[
							-81.61567883599992,
							30.43632633900006
						],
						[
							-81.61574508699994,
							30.43646841400005
						],
						[
							-81.61578565999991,
							30.436619835000045
						],
						[
							-81.61578950099995,
							30.436643450000076
						],
						[
							-81.61583529299992,
							30.436950748000072
						],
						[
							-81.61723812499991,
							30.436548513000044
						],
						[
							-81.61730959399995,
							30.436531149000075
						],
						[
							-81.6173822419999,
							30.436519683000082
						],
						[
							-81.6174555849999,
							30.436514192000065
						],
						[
							-81.61752913099991,
							30.436514713000065
						],
						[
							-81.6176023889999,
							30.436521241000037
						],
						[
							-81.61767486799994,
							30.43653373400008
						],
						[
							-81.61855860299995,
							30.436723561000065
						],
						[
							-81.62129366199991,
							30.43591368800008
						],
						[
							-81.62136916499992,
							30.435894842000042
						],
						[
							-81.62144601299991,
							30.43588259500007
						],
						[
							-81.62152363299992,
							30.43587703600008
						],
						[
							-81.62160144299992,
							30.43587820900007
						],
						[
							-81.62167885999992,
							30.43588610300009
						],
						[
							-81.62362721599993,
							30.43617042100004
						],
						[
							-81.62650312999995,
							30.436247307000087
						],
						[
							-81.62867822899995,
							30.43618010700004
						],
						[
							-81.62870599999991,
							30.43617967800009
						],
						[
							-81.62886216599992,
							30.436193341000035
						],
						[
							-81.62895986199993,
							30.43621625200006
						],
						[
							-81.63238146299994,
							30.43722305100005
						],
						[
							-81.63278612699992,
							30.437158958000055
						],
						[
							-81.63768079199991,
							30.437827921000068
						],
						[
							-81.63986940599995,
							30.438110448000085
						],
						[
							-81.64070392199994,
							30.43824563500004
						],
						[
							-81.64074013499993,
							30.438010252000083
						],
						[
							-81.64074333999991,
							30.43799083400006
						],
						[
							-81.64077313399991,
							30.437879642000045
						],
						[
							-81.64145807999996,
							30.43732121200009
						],
						[
							-81.64252099999993,
							30.43719400000009
						],
						[
							-81.64239090599995,
							30.437593008000082
						],
						[
							-81.64154190599993,
							30.440192008000054
						],
						[
							-81.64117290599995,
							30.441320008000048
						],
						[
							-81.6404729059999,
							30.443459008000044
						],
						[
							-81.64024290599993,
							30.444161008000034
						],
						[
							-81.63998090599995,
							30.44492100800005
						],
						[
							-81.63976690599992,
							30.445588009000065
						],
						[
							-81.63968090499992,
							30.445835008000078
						],
						[
							-81.63934690499991,
							30.44688700900008
						],
						[
							-81.6391119939999,
							30.447609027000052
						],
						[
							-81.63904190599993,
							30.447587008000085
						],
						[
							-81.63895290699992,
							30.447571010000047
						],
						[
							-81.63879988199994,
							30.44757587700008
						],
						[
							-81.6386989049999,
							30.447620009000048
						],
						[
							-81.63847690599994,
							30.447740007000046
						],
						[
							-81.63839390499993,
							30.44776800900007
						],
						[
							-81.63818390499995,
							30.447861009000064
						],
						[
							-81.63784090599995,
							30.44798700800004
						],
						[
							-81.63725690599995,
							30.448129008000084
						],
						[
							-81.63702190599992,
							30.448173008000087
						],
						[
							-81.63676790599993,
							30.448195009000074
						],
						[
							-81.6363089059999,
							30.44819800700009
						],
						[
							-81.63603090499993,
							30.44816000800006
						],
						[
							-81.6349319059999,
							30.44795600800006
						],
						[
							-81.63430592599991,
							30.447822973000086
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "San Mateo",
				"RegionID": "126045"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.13082114699995,
					26.245871841000053,
					-80.12706378199995,
					26.24966416400008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.12706378199995,
							26.24594416700006
						],
						[
							-80.13074581599994,
							26.245871841000053
						],
						[
							-80.13082114699995,
							26.24956525300007
						],
						[
							-80.12721090399992,
							26.24966416400008
						],
						[
							-80.12715955099992,
							26.248365685000067
						],
						[
							-80.12706378199995,
							26.24594416700006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Pompano Beach",
				"Name": "Sanders Park",
				"RegionID": "126058"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.61657132199991,
					27.79872478200008,
					-82.5963746679999,
					27.82985000000008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.61021428899994,
							27.82985000000008
						],
						[
							-82.61016484599992,
							27.829426648000037
						],
						[
							-82.61007453299993,
							27.82902525800006
						],
						[
							-82.61000428999995,
							27.828603799000064
						],
						[
							-82.60996415099993,
							27.82828268700007
						],
						[
							-82.60996415099993,
							27.827951541000065
						],
						[
							-82.61001432499995,
							27.827138726000044
						],
						[
							-82.61002435999991,
							27.82695810100006
						],
						[
							-82.60952999999995,
							27.82695810100006
						],
						[
							-82.60952999999995,
							27.82655671100008
						],
						[
							-82.60952999999995,
							27.826295808000054
						],
						[
							-82.60952999999995,
							27.82593455700004
						],
						[
							-82.60952999999995,
							27.82561000000004
						],
						[
							-82.60912127899991,
							27.825616386000036
						],
						[
							-82.60913126699995,
							27.824569832000066
						],
						[
							-82.60912150399992,
							27.82345869100004
						],
						[
							-82.60907105899992,
							27.82294420300008
						],
						[
							-82.60907105899992,
							27.82271340400007
						],
						[
							-82.6080475149999,
							27.822703369000067
						],
						[
							-82.60750018199991,
							27.822577752000086
						],
						[
							-82.60729637599991,
							27.82266066300008
						],
						[
							-82.6070174429999,
							27.822899749000047
						],
						[
							-82.6068182059999,
							27.823059139000065
						],
						[
							-82.60677835799994,
							27.823357995000038
						],
						[
							-82.6068779769999,
							27.823577156000056
						],
						[
							-82.60693774799995,
							27.82377639400005
						],
						[
							-82.60693774799995,
							27.82401547900008
						],
						[
							-82.60689790099991,
							27.824214716000085
						],
						[
							-82.6068182059999,
							27.82437410600005
						],
						[
							-82.60651934999993,
							27.824653039000054
						],
						[
							-82.6062802639999,
							27.824812429000076
						],
						[
							-82.6056912009999,
							27.82599055500009
						],
						[
							-82.60567099999992,
							27.825992322000047
						],
						[
							-82.60552596099991,
							27.825980549000064
						],
						[
							-82.60511039799991,
							27.825912604000052
						],
						[
							-82.60495341399991,
							27.825871086000063
						],
						[
							-82.60487113199991,
							27.825836421000076
						],
						[
							-82.6044989689999,
							27.825657385000056
						],
						[
							-82.6041030419999,
							27.825552344000073
						],
						[
							-82.60390438199994,
							27.825528391000034
						],
						[
							-82.60333032999995,
							27.825486477000084
						],
						[
							-82.6029391209999,
							27.825488317000065
						],
						[
							-82.60287209699993,
							27.82548597600004
						],
						[
							-82.60280543399996,
							27.82547864600008
						],
						[
							-82.6027395019999,
							27.825466368000036
						],
						[
							-82.6026746679999,
							27.82544921100009
						],
						[
							-82.60261129399993,
							27.82542727000009
						],
						[
							-82.6025497309999,
							27.825400667000054
						],
						[
							-82.60239673099994,
							27.825327666000078
						],
						[
							-82.6023320939999,
							27.82529326300005
						],
						[
							-82.60226966099992,
							27.825333835000038
						],
						[
							-82.60222536799995,
							27.825357780000047
						],
						[
							-82.60212436799992,
							27.82540878100008
						],
						[
							-82.60206027299995,
							27.825438053000084
						],
						[
							-82.60199408299991,
							27.82546221800004
						],
						[
							-82.60192620499993,
							27.825481127000046
						],
						[
							-82.60185705399994,
							27.825494663000086
						],
						[
							-82.60178705599992,
							27.825502743000072
						],
						[
							-82.60163142499994,
							27.82551483800006
						],
						[
							-82.60155920499994,
							27.825528949000045
						],
						[
							-82.60148607299993,
							27.82553710800005
						],
						[
							-82.6014125179999,
							27.825539261000074
						],
						[
							-82.60133903399992,
							27.825535393000052
						],
						[
							-82.6012661119999,
							27.82552553100004
						],
						[
							-82.60107438999995,
							27.825491404000047
						],
						[
							-82.6010542869999,
							27.82548758900009
						],
						[
							-82.60080128699991,
							27.82543658800006
						],
						[
							-82.60067141399992,
							27.82540008600006
						],
						[
							-82.60052913999994,
							27.825333721000053
						],
						[
							-82.60035172699992,
							27.825231140000085
						],
						[
							-82.60032051199994,
							27.825212672000077
						],
						[
							-82.6002556919999,
							27.82517039000004
						],
						[
							-82.60019474699993,
							27.825122691000047
						],
						[
							-82.60013813099994,
							27.82506992800006
						],
						[
							-82.60008626099994,
							27.825012491000052
						],
						[
							-82.60003952299991,
							27.82495080700005
						],
						[
							-82.59999826099994,
							27.824885333000054
						],
						[
							-82.59987635899995,
							27.824670005000087
						],
						[
							-82.59982114999991,
							27.82455113000009
						],
						[
							-82.59975923199994,
							27.824579998000047
						],
						[
							-82.59969516299992,
							27.824603713000045
						],
						[
							-82.59962937099993,
							27.824622117000047
						],
						[
							-82.59956229699992,
							27.824635087000047
						],
						[
							-82.59942429599994,
							27.82465608700005
						],
						[
							-82.59928899999994,
							27.82466632200004
						],
						[
							-82.59923260699992,
							27.82466455200006
						],
						[
							-82.5990416059999,
							27.82465255200009
						],
						[
							-82.5989418339999,
							27.82464065900007
						],
						[
							-82.59883582799995,
							27.824615259000044
						],
						[
							-82.59862582799991,
							27.824551260000078
						],
						[
							-82.59858041399991,
							27.82453608700007
						],
						[
							-82.59843255699991,
							27.824466440000037
						],
						[
							-82.59834977499992,
							27.824417044000086
						],
						[
							-82.59829167299995,
							27.824379221000072
						],
						[
							-82.5982366579999,
							27.824337034000052
						],
						[
							-82.59818505499993,
							27.82429073500009
						],
						[
							-82.59813717299994,
							27.824240598000074
						],
						[
							-82.5980932949999,
							27.82418692200008
						],
						[
							-82.59805368199994,
							27.824130025000045
						],
						[
							-82.59803039299993,
							27.824093663000042
						],
						[
							-82.5978066969999,
							27.824176941000076
						],
						[
							-82.59765216599993,
							27.824218659000053
						],
						[
							-82.59761715999991,
							27.82422412300008
						],
						[
							-82.59738915899993,
							27.824255123000057
						],
						[
							-82.59726799999993,
							27.824263322000036
						],
						[
							-82.59717701499994,
							27.82425870700007
						],
						[
							-82.59706768799992,
							27.824247590000084
						],
						[
							-82.59702747099993,
							27.82426791800009
						],
						[
							-82.59694747099991,
							27.824302918000058
						],
						[
							-82.59687836299992,
							27.824329816000045
						],
						[
							-82.59682632699992,
							27.824345270000038
						],
						[
							-82.5968612389999,
							27.82318323900006
						],
						[
							-82.59704999999991,
							27.822940000000074
						],
						[
							-82.5970430779999,
							27.82285537900009
						],
						[
							-82.59706070699991,
							27.82271434000006
						],
						[
							-82.59707874399993,
							27.822482601000047
						],
						[
							-82.59706046199994,
							27.82236781100005
						],
						[
							-82.59702541999991,
							27.822249541000076
						],
						[
							-82.59698999999995,
							27.822130000000072
						],
						[
							-82.59710625899993,
							27.821972950000088
						],
						[
							-82.59733048299995,
							27.82186576500004
						],
						[
							-82.59757552799994,
							27.821746744000052
						],
						[
							-82.59785876199993,
							27.82159495800005
						],
						[
							-82.59807439699995,
							27.821467202000065
						],
						[
							-82.59829405999994,
							27.821307062000074
						],
						[
							-82.59847380699995,
							27.821160602000077
						],
						[
							-82.59871213999992,
							27.820966404000046
						],
						[
							-82.5990192399999,
							27.820718946000056
						],
						[
							-82.59933437599994,
							27.82044327400007
						],
						[
							-82.59953999999993,
							27.820260000000076
						],
						[
							-82.59966244899994,
							27.820145824000065
						],
						[
							-82.59979265699991,
							27.820024414000045
						],
						[
							-82.59995030499994,
							27.81987741800009
						],
						[
							-82.60014432299994,
							27.819696510000085
						],
						[
							-82.6003264659999,
							27.819536312000082
						],
						[
							-82.60051190099995,
							27.819401872000075
						],
						[
							-82.60066858099992,
							27.81928827900009
						],
						[
							-82.60084999999992,
							27.819180000000074
						],
						[
							-82.60089533299993,
							27.819084297000074
						],
						[
							-82.60098757399993,
							27.818889567000042
						],
						[
							-82.60107680899995,
							27.818662766000045
						],
						[
							-82.60112627199993,
							27.818455502000063
						],
						[
							-82.60113815999995,
							27.81825803800007
						],
						[
							-82.6011000279999,
							27.81804013900006
						],
						[
							-82.60103675699992,
							27.817779569000038
						],
						[
							-82.60095999999993,
							27.817580000000078
						],
						[
							-82.60091806499992,
							27.817483116000062
						],
						[
							-82.60085737199995,
							27.817342894000035
						],
						[
							-82.60077797399993,
							27.81715945700006
						],
						[
							-82.60066999999992,
							27.816910000000064
						],
						[
							-82.60062328099991,
							27.816788530000057
						],
						[
							-82.60058267099993,
							27.816682944000036
						],
						[
							-82.60049835399991,
							27.816501590000087
						],
						[
							-82.60043912999993,
							27.81637891200006
						],
						[
							-82.60029836699994,
							27.81619866300008
						],
						[
							-82.59981492499992,
							27.816574674000037
						],
						[
							-82.59945681899991,
							27.81628819000008
						],
						[
							-82.59884803999995,
							27.816001705000076
						],
						[
							-82.59823217199994,
							27.81551511200007
						],
						[
							-82.5982845389999,
							27.81540576900005
						],
						[
							-82.59834794599993,
							27.815268126000035
						],
						[
							-82.59839210699995,
							27.81515862100008
						],
						[
							-82.59842095999994,
							27.81500281600006
						],
						[
							-82.59843999999993,
							27.81490000000008
						],
						[
							-82.5983166659999,
							27.814779483000052
						],
						[
							-82.5980821949999,
							27.814564826000037
						],
						[
							-82.59797915999991,
							27.81447049800005
						],
						[
							-82.59783880599991,
							27.81434200600006
						],
						[
							-82.59766278199993,
							27.814180857000053
						],
						[
							-82.59753999999994,
							27.814050000000066
						],
						[
							-82.59740345299991,
							27.81391952200005
						],
						[
							-82.5972480879999,
							27.813771061000068
						],
						[
							-82.59708999999992,
							27.81362000000007
						],
						[
							-82.5969843879999,
							27.81350545400005
						],
						[
							-82.5963746679999,
							27.81284415400006
						],
						[
							-82.59653491299991,
							27.812701970000035
						],
						[
							-82.59672891199995,
							27.812471254000062
						],
						[
							-82.59761060699992,
							27.811453319000066
						],
						[
							-82.59821245699995,
							27.810560132000038
						],
						[
							-82.59891932799991,
							27.80922410800008
						],
						[
							-82.59910682799995,
							27.80866160900007
						],
						[
							-82.59916901299994,
							27.808518075000052
						],
						[
							-82.5992010299999,
							27.808458904000076
						],
						[
							-82.59957404599993,
							27.807761731000085
						],
						[
							-82.59961660399995,
							27.807690332000053
						],
						[
							-82.60022760399994,
							27.806765333000044
						],
						[
							-82.60026857499992,
							27.80670828200005
						],
						[
							-82.60098457499993,
							27.805789282000035
						],
						[
							-82.60100145099995,
							27.805768278000073
						],
						[
							-82.60178845199994,
							27.804818278000084
						],
						[
							-82.60185640899995,
							27.804744957000082
						],
						[
							-82.60280740799993,
							27.80382695600008
						],
						[
							-82.60287007499996,
							27.803771846000075
						],
						[
							-82.60356607499995,
							27.803214846000063
						],
						[
							-82.60364276399991,
							27.80315981700005
						],
						[
							-82.60417295899992,
							27.80282004500009
						],
						[
							-82.60464520399995,
							27.80244614600008
						],
						[
							-82.60479861199991,
							27.802305472000057
						],
						[
							-82.6048649949999,
							27.802208774000064
						],
						[
							-82.60496438899992,
							27.80198089600009
						],
						[
							-82.60500337899992,
							27.80182375800007
						],
						[
							-82.6051416379999,
							27.800979356000084
						],
						[
							-82.60520177199993,
							27.80035128700007
						],
						[
							-82.60521134099992,
							27.80028083500008
						],
						[
							-82.60523410399992,
							27.800183641000046
						],
						[
							-82.60530310399992,
							27.79994864100007
						],
						[
							-82.60532403399992,
							27.799885974000063
						],
						[
							-82.6053495079999,
							27.799825012000042
						],
						[
							-82.6053793879999,
							27.799766085000044
						],
						[
							-82.60541351499995,
							27.79970951000007
						],
						[
							-82.60561051499991,
							27.799408510000035
						],
						[
							-82.60567407899993,
							27.79932292700005
						],
						[
							-82.6057556689999,
							27.79923772800004
						],
						[
							-82.60583866899992,
							27.79916172800006
						],
						[
							-82.60589383599995,
							27.799114901000056
						],
						[
							-82.6059527189999,
							27.799072843000094
						],
						[
							-82.6060149079999,
							27.799035848000074
						],
						[
							-82.60639091399992,
							27.79872478200008
						],
						[
							-82.60724076199995,
							27.79907579400009
						],
						[
							-82.60838078699993,
							27.80115226800007
						],
						[
							-82.60895690599995,
							27.802541732000066
						],
						[
							-82.60924007099993,
							27.802993903000072
						],
						[
							-82.60927953099991,
							27.80333917900009
						],
						[
							-82.60927953099991,
							27.803654859000062
						],
						[
							-82.60915562699995,
							27.804040781000083
						],
						[
							-82.6088844599999,
							27.80425844800004
						],
						[
							-82.60874797999992,
							27.804387550000058
						],
						[
							-82.60875353099993,
							27.804402173000085
						],
						[
							-82.60890953099994,
							27.80482417400009
						],
						[
							-82.60891759499992,
							27.80484692300007
						],
						[
							-82.6089346789999,
							27.804903239000055
						],
						[
							-82.60893612599995,
							27.804908711000053
						],
						[
							-82.60903512599992,
							27.805287710000073
						],
						[
							-82.60904704199993,
							27.805339551000092
						],
						[
							-82.6090566279999,
							27.80539761500006
						],
						[
							-82.60906239699995,
							27.805456181000068
						],
						[
							-82.60906401799991,
							27.80549160700008
						],
						[
							-82.60906805099995,
							27.805646597000077
						],
						[
							-82.6090847719999,
							27.805705119000038
						],
						[
							-82.6092206269999,
							27.805897581000067
						],
						[
							-82.6092707599999,
							27.805920422000042
						],
						[
							-82.60932266099991,
							27.805948164000085
						],
						[
							-82.60932829899991,
							27.80595144700004
						],
						[
							-82.60952929899992,
							27.806069447000084
						],
						[
							-82.60957363599994,
							27.80609724100009
						],
						[
							-82.6096214719999,
							27.806131520000065
						],
						[
							-82.60965785099995,
							27.806161375000045
						],
						[
							-82.60944977899993,
							27.80663279000004
						],
						[
							-82.6093741059999,
							27.807018033000077
						],
						[
							-82.60936034799994,
							27.807141861000048
						],
						[
							-82.60936722699995,
							27.80761653600007
						],
						[
							-82.60936722699995,
							27.808393902000034
						],
						[
							-82.6093809859999,
							27.809123112000066
						],
						[
							-82.60942765999994,
							27.809301315000084
						],
						[
							-82.60948110999993,
							27.809742536000044
						],
						[
							-82.60959039399995,
							27.809735600000067
						],
						[
							-82.60962340599991,
							27.81053264800005
						],
						[
							-82.60963922099995,
							27.81111781700008
						],
						[
							-82.6089579209999,
							27.81113373000005
						],
						[
							-82.60897206099992,
							27.811260505000064
						],
						[
							-82.60898999999995,
							27.811470000000043
						],
						[
							-82.6090084519999,
							27.811688350000054
						],
						[
							-82.60902703099993,
							27.811908195000058
						],
						[
							-82.60904999999991,
							27.812180000000073
						],
						[
							-82.60918043099991,
							27.81217420300004
						],
						[
							-82.60936984199992,
							27.812165785000047
						],
						[
							-82.60962255499993,
							27.812150573000054
						],
						[
							-82.60978051199993,
							27.812137436000057
						],
						[
							-82.6100004669999,
							27.812109942000063
						],
						[
							-82.61014081399993,
							27.812082624000084
						],
						[
							-82.6102654259999,
							27.812022287000048
						],
						[
							-82.61056599999995,
							27.81233300000008
						],
						[
							-82.61056599999995,
							27.812291000000073
						],
						[
							-82.61074497999994,
							27.812360271000045
						],
						[
							-82.6112389189999,
							27.812844890000065
						],
						[
							-82.61141599199993,
							27.812975365000057
						],
						[
							-82.6116489819999,
							27.812854210000072
						],
						[
							-82.6119099309999,
							27.81272373500008
						],
						[
							-82.61218951899991,
							27.81245346700007
						],
						[
							-82.61241318899994,
							27.81222047700004
						],
						[
							-82.61263685999995,
							27.81190361000006
						],
						[
							-82.61301896299994,
							27.811940889000088
						],
						[
							-82.61327059299992,
							27.811810414000036
						],
						[
							-82.61361541799994,
							27.811521507000066
						],
						[
							-82.6140347999999,
							27.81127919700009
						],
						[
							-82.61464989399991,
							27.811176681000063
						],
						[
							-82.61560049299995,
							27.81114872200004
						],
						[
							-82.61608511199995,
							27.811092805000047
						],
						[
							-82.61619694799992,
							27.81146558900008
						],
						[
							-82.61606647299993,
							27.81209932200005
						],
						[
							-82.61603851399991,
							27.812658498000076
						],
						[
							-82.61607579299994,
							27.813115159000063
						],
						[
							-82.61606332199995,
							27.813707047000037
						],
						[
							-82.61603757399992,
							27.814389349000066
						],
						[
							-82.61594745899993,
							27.815058778000036
						],
						[
							-82.61587021699995,
							27.81553510200007
						],
						[
							-82.61594745899993,
							27.815972805000058
						],
						[
							-82.61594745899993,
							27.816564992000053
						],
						[
							-82.61596033299992,
							27.817182926000044
						],
						[
							-82.61599895299992,
							27.81755626100005
						],
						[
							-82.6162435519999,
							27.81795534300005
						],
						[
							-82.61651999899993,
							27.818212689000063
						],
						[
							-82.61652107899994,
							27.818259093000055
						],
						[
							-82.61652132199993,
							27.818280000000073
						],
						[
							-82.61651939599994,
							27.818338818000086
						],
						[
							-82.61651850299995,
							27.81835114800009
						],
						[
							-82.61650850299992,
							27.818477148000056
						],
						[
							-82.61650362799992,
							27.81852338500005
						],
						[
							-82.61649404199994,
							27.818581449000078
						],
						[
							-82.6164806779999,
							27.818638762000035
						],
						[
							-82.61647210599995,
							27.818668353000078
						],
						[
							-82.61647267799994,
							27.81867023800004
						],
						[
							-82.61648604099992,
							27.818727551000052
						],
						[
							-82.61649562799994,
							27.81878561500008
						],
						[
							-82.61649757099991,
							27.818801458000053
						],
						[
							-82.61651757099992,
							27.818977458000063
						],
						[
							-82.61652139599994,
							27.81902018100004
						],
						[
							-82.61652332199992,
							27.819079000000045
						],
						[
							-82.61652139599994,
							27.81913781800006
						],
						[
							-82.61652040399991,
							27.81915137900006
						],
						[
							-82.61650740499995,
							27.819312379000053
						],
						[
							-82.61650735799992,
							27.81931296000005
						],
						[
							-82.61648635799992,
							27.81957096000008
						],
						[
							-82.61648162799992,
							27.819615385000077
						],
						[
							-82.61647258199991,
							27.819670175000056
						],
						[
							-82.61648867899993,
							27.81972323800005
						],
						[
							-82.61650204199992,
							27.819780551000065
						],
						[
							-82.61651162899994,
							27.819838615000037
						],
						[
							-82.61651739699994,
							27.819897181000044
						],
						[
							-82.61651882599995,
							27.81992611600009
						],
						[
							-82.61653182499992,
							27.82031711600007
						],
						[
							-82.6165321929999,
							27.820331759000055
						],
						[
							-82.61653319299995,
							27.820390759000077
						],
						[
							-82.61653332199995,
							27.820406000000048
						],
						[
							-82.6165313969999,
							27.82046481800006
						],
						[
							-82.61652562799992,
							27.82052338500006
						],
						[
							-82.61651604199994,
							27.820581449000088
						],
						[
							-82.6165112349999,
							27.82060408800004
						],
						[
							-82.61649760199992,
							27.820664460000046
						],
						[
							-82.61651659499995,
							27.820714922000036
						],
						[
							-82.61653367799994,
							27.820771238000077
						],
						[
							-82.61654704199992,
							27.82082855100009
						],
						[
							-82.6165566279999,
							27.820886615000063
						],
						[
							-82.61656198899993,
							27.82093926500005
						],
						[
							-82.61656898899992,
							27.82103626500009
						],
						[
							-82.61656939699992,
							27.821042181000053
						],
						[
							-82.61657132199991,
							27.821101000000056
						],
						[
							-82.61656939699992,
							27.82115981800007
						],
						[
							-82.61656461599995,
							27.82121062300007
						],
						[
							-82.61656248299994,
							27.82122798900008
						],
						[
							-82.61638516199991,
							27.82153421000004
						],
						[
							-82.61611481599994,
							27.821701567000048
						],
						[
							-82.61568998599995,
							27.82172731500009
						],
						[
							-82.6152651569999,
							27.821701567000048
						],
						[
							-82.61476308599993,
							27.82171444100004
						],
						[
							-82.6144669919999,
							27.821572831000083
						],
						[
							-82.61412899999993,
							27.821477000000073
						],
						[
							-82.61406999999991,
							27.829840000000047
						],
						[
							-82.6139540129999,
							27.82985000000008
						],
						[
							-82.6137983619999,
							27.829846199000087
						],
						[
							-82.61357154099994,
							27.829840000000047
						],
						[
							-82.6133307259999,
							27.829840000000047
						],
						[
							-82.61293408799992,
							27.829840000000047
						],
						[
							-82.6125799479999,
							27.829840000000047
						],
						[
							-82.61253623099992,
							27.829840000000047
						],
						[
							-82.61228246999991,
							27.829840000000047
						],
						[
							-82.61197082599995,
							27.829840000000047
						],
						[
							-82.61174420899994,
							27.82984120200007
						],
						[
							-82.6114184249999,
							27.829844085000047
						],
						[
							-82.61121999599993,
							27.829845841000065
						],
						[
							-82.6109367059999,
							27.82984834800004
						],
						[
							-82.61074999999994,
							27.82985000000008
						],
						[
							-82.61048343599992,
							27.82985000000008
						],
						[
							-82.61021428899994,
							27.82985000000008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Shore Acres",
				"RegionID": "126162"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.39139199999994,
					28.368054000000086,
					-81.37279199999995,
					28.407684000000074
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.3747919999999,
							28.400284000000056
						],
						[
							-81.37419199999994,
							28.39298500000007
						],
						[
							-81.37396799999995,
							28.389402000000075
						],
						[
							-81.37395399999991,
							28.389182000000062
						],
						[
							-81.37388299999992,
							28.38804900000008
						],
						[
							-81.37379199999992,
							28.386585000000085
						],
						[
							-81.37349199999994,
							28.382585000000063
						],
						[
							-81.37303999999995,
							28.375034000000085
						],
						[
							-81.37279199999995,
							28.370886000000045
						],
						[
							-81.3729429999999,
							28.368246000000056
						],
						[
							-81.37526699999995,
							28.368054000000086
						],
						[
							-81.38147499999991,
							28.368303000000083
						],
						[
							-81.37719199999992,
							28.372585000000072
						],
						[
							-81.37659199999992,
							28.37368500000008
						],
						[
							-81.37809199999992,
							28.378085000000056
						],
						[
							-81.38299199999994,
							28.379785000000084
						],
						[
							-81.38539199999991,
							28.379585000000077
						],
						[
							-81.38779199999993,
							28.38108500000004
						],
						[
							-81.38959199999994,
							28.381485000000055
						],
						[
							-81.39099199999993,
							28.38308500000005
						],
						[
							-81.3912739999999,
							28.39167800000007
						],
						[
							-81.39139199999994,
							28.40668400000004
						],
						[
							-81.39069199999994,
							28.40668400000004
						],
						[
							-81.38569199999995,
							28.40698400000008
						],
						[
							-81.38329199999993,
							28.40698400000008
						],
						[
							-81.38299199999994,
							28.40698400000008
						],
						[
							-81.38039199999993,
							28.407084000000054
						],
						[
							-81.3763919999999,
							28.407184000000086
						],
						[
							-81.37549199999995,
							28.407684000000074
						],
						[
							-81.37548199999992,
							28.407566000000088
						],
						[
							-81.37489199999993,
							28.400784000000044
						],
						[
							-81.3747919999999,
							28.400284000000056
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Southchase",
				"RegionID": "126242"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.52594199999993,
					27.298778000000084,
					-82.49743399999994,
					27.32285900000005
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-82.5096059999999,
								27.320597000000078
							],
							[
								-82.5096059999999,
								27.32026200000007
							],
							[
								-82.50991199999993,
								27.320261000000073
							],
							[
								-82.50991399999992,
								27.31988300000006
							],
							[
								-82.51078699999994,
								27.31992400000007
							],
							[
								-82.51151899999991,
								27.31992400000007
							],
							[
								-82.51214499999992,
								27.31992400000007
							],
							[
								-82.51216099999994,
								27.32062400000007
							],
							[
								-82.51155599999993,
								27.32062400000007
							],
							[
								-82.51132199999995,
								27.32062400000007
							],
							[
								-82.51132199999995,
								27.320358000000056
							],
							[
								-82.51090699999992,
								27.320357000000058
							],
							[
								-82.51090699999992,
								27.32062400000007
							],
							[
								-82.50990699999994,
								27.320628000000056
							],
							[
								-82.5096059999999,
								27.320597000000078
							]
						]
					],
					[
						[
							[
								-82.5015689999999,
								27.31958300000008
							],
							[
								-82.50150799999994,
								27.31957900000009
							],
							[
								-82.50015899999994,
								27.31959500000005
							],
							[
								-82.5009189999999,
								27.318789000000038
							],
							[
								-82.49743399999994,
								27.318787000000043
							],
							[
								-82.49743499999994,
								27.31796200000008
							],
							[
								-82.49743599999994,
								27.317233000000044
							],
							[
								-82.49743799999993,
								27.316925000000083
							],
							[
								-82.49743999999993,
								27.316433000000075
							],
							[
								-82.49744199999992,
								27.315912000000086
							],
							[
								-82.49744299999992,
								27.315408000000048
							],
							[
								-82.49744599999991,
								27.31401100000005
							],
							[
								-82.49745799999994,
								27.312620000000038
							],
							[
								-82.49745799999994,
								27.311926000000085
							],
							[
								-82.49746599999993,
								27.31064400000008
							],
							[
								-82.49746699999992,
								27.310162000000048
							],
							[
								-82.49747599999995,
								27.309890000000056
							],
							[
								-82.4975159999999,
								27.30899100000005
							],
							[
								-82.49752499999994,
								27.308595000000082
							],
							[
								-82.4975189999999,
								27.308290000000056
							],
							[
								-82.49751499999992,
								27.30806300000006
							],
							[
								-82.4975379999999,
								27.30680300000006
							],
							[
								-82.49753399999992,
								27.30669000000006
							],
							[
								-82.49753599999991,
								27.306249000000037
							],
							[
								-82.4975409999999,
								27.305323000000044
							],
							[
								-82.49754799999994,
								27.304286000000047
							],
							[
								-82.49755499999992,
								27.302227000000073
							],
							[
								-82.4975609999999,
								27.300432000000058
							],
							[
								-82.4975629999999,
								27.299919000000045
							],
							[
								-82.49756399999991,
								27.298778000000084
							],
							[
								-82.5011889999999,
								27.29878800000006
							],
							[
								-82.5020189999999,
								27.298797000000036
							],
							[
								-82.50275199999993,
								27.29879500000004
							],
							[
								-82.50315599999993,
								27.29879800000009
							],
							[
								-82.50349799999992,
								27.298799000000088
							],
							[
								-82.50586699999991,
								27.298809000000062
							],
							[
								-82.50793299999992,
								27.29881400000005
							],
							[
								-82.5089789999999,
								27.29881800000004
							],
							[
								-82.51001599999995,
								27.298822000000087
							],
							[
								-82.51050099999993,
								27.29882100000009
							],
							[
								-82.51107899999994,
								27.298823000000084
							],
							[
								-82.51185499999991,
								27.29882600000008
							],
							[
								-82.51208899999995,
								27.29882400000008
							],
							[
								-82.51311599999991,
								27.298834000000056
							],
							[
								-82.51417199999992,
								27.29883300000006
							],
							[
								-82.51589899999993,
								27.298835000000054
							],
							[
								-82.51718699999992,
								27.298834000000056
							],
							[
								-82.51786099999993,
								27.298834000000056
							],
							[
								-82.51832999999993,
								27.29883700000005
							],
							[
								-82.51837099999996,
								27.29884700000008
							],
							[
								-82.51848099999995,
								27.29884700000008
							],
							[
								-82.51854099999991,
								27.298839000000044
							],
							[
								-82.51863199999991,
								27.298839000000044
							],
							[
								-82.51871299999993,
								27.298838000000046
							],
							[
								-82.51882099999995,
								27.298838000000046
							],
							[
								-82.51887799999992,
								27.29882900000007
							],
							[
								-82.51897699999995,
								27.298828000000075
							],
							[
								-82.51902899999993,
								27.298838000000046
							],
							[
								-82.51993799999991,
								27.298839000000044
							],
							[
								-82.5206619999999,
								27.29882900000007
							],
							[
								-82.5215839999999,
								27.29883700000005
							],
							[
								-82.5217219999999,
								27.29884000000004
							],
							[
								-82.52234599999991,
								27.29884000000004
							],
							[
								-82.52233299999995,
								27.299501000000078
							],
							[
								-82.52232499999991,
								27.299627000000044
							],
							[
								-82.52232399999991,
								27.299713000000054
							],
							[
								-82.5223069999999,
								27.300508000000036
							],
							[
								-82.5222829999999,
								27.301307000000065
							],
							[
								-82.52226799999994,
								27.301862000000085
							],
							[
								-82.52594199999993,
								27.301825000000065
							],
							[
								-82.52594099999993,
								27.30213400000008
							],
							[
								-82.5258849999999,
								27.302216000000044
							],
							[
								-82.5258399999999,
								27.302318000000074
							],
							[
								-82.52580599999993,
								27.303046000000055
							],
							[
								-82.52576899999991,
								27.304000000000087
							],
							[
								-82.52573599999994,
								27.304794000000072
							],
							[
								-82.52571299999994,
								27.30547000000007
							],
							[
								-82.52571799999993,
								27.30558700000006
							],
							[
								-82.52563099999992,
								27.306475000000034
							],
							[
								-82.52557999999993,
								27.30737600000009
							],
							[
								-82.5255249999999,
								27.308300000000088
							],
							[
								-82.5254799999999,
								27.309612000000072
							],
							[
								-82.52546399999994,
								27.31006300000007
							],
							[
								-82.52546299999995,
								27.31009400000005
							],
							[
								-82.52544699999993,
								27.31055100000009
							],
							[
								-82.52540999999991,
								27.311454000000083
							],
							[
								-82.52545299999991,
								27.31185800000009
							],
							[
								-82.5219889999999,
								27.31195900000006
							],
							[
								-82.52078499999993,
								27.311960000000056
							],
							[
								-82.52067599999992,
								27.311951000000082
							],
							[
								-82.52055699999994,
								27.311929000000077
							],
							[
								-82.51916899999993,
								27.31204800000006
							],
							[
								-82.51907099999994,
								27.31201200000004
							],
							[
								-82.5189289999999,
								27.311980000000062
							],
							[
								-82.51884399999994,
								27.311970000000088
							],
							[
								-82.51874599999991,
								27.31196600000004
							],
							[
								-82.5173759999999,
								27.311968000000036
							],
							[
								-82.51634799999994,
								27.311971000000085
							],
							[
								-82.51628899999992,
								27.31197500000008
							],
							[
								-82.51621799999992,
								27.311987000000045
							],
							[
								-82.51610799999992,
								27.312019000000078
							],
							[
								-82.51499299999995,
								27.31198100000006
							],
							[
								-82.51415099999991,
								27.311926000000085
							],
							[
								-82.51415299999992,
								27.311772000000076
							],
							[
								-82.51403399999992,
								27.311772000000076
							],
							[
								-82.51336399999991,
								27.311772000000076
							],
							[
								-82.5133659999999,
								27.311925000000087
							],
							[
								-82.51342499999993,
								27.314487000000042
							],
							[
								-82.5134129999999,
								27.315514000000068
							],
							[
								-82.5133909999999,
								27.31634100000008
							],
							[
								-82.51181699999995,
								27.316338000000087
							],
							[
								-82.51181899999995,
								27.316544000000082
							],
							[
								-82.51274999999993,
								27.31655500000005
							],
							[
								-82.51276399999995,
								27.31693000000007
							],
							[
								-82.51348599999994,
								27.31693400000006
							],
							[
								-82.51351899999992,
								27.317150000000083
							],
							[
								-82.51362699999993,
								27.317957000000035
							],
							[
								-82.51360199999993,
								27.31818100000004
							],
							[
								-82.51340799999993,
								27.31816900000007
							],
							[
								-82.51333999999991,
								27.31876800000009
							],
							[
								-82.51362399999994,
								27.31876800000009
							],
							[
								-82.51361899999995,
								27.31896900000004
							],
							[
								-82.51208799999995,
								27.318983000000063
							],
							[
								-82.50793899999991,
								27.319168000000047
							],
							[
								-82.50780299999991,
								27.319120000000055
							],
							[
								-82.50747599999994,
								27.319120000000055
							],
							[
								-82.50715099999991,
								27.31911800000006
							],
							[
								-82.50682899999993,
								27.319119000000057
							],
							[
								-82.50650599999994,
								27.319117000000062
							],
							[
								-82.50612099999995,
								27.319120000000055
							],
							[
								-82.50587599999994,
								27.31911800000006
							],
							[
								-82.50584399999991,
								27.31911000000008
							],
							[
								-82.50571799999994,
								27.31912400000005
							],
							[
								-82.5057359999999,
								27.322845000000086
							],
							[
								-82.50562999999994,
								27.322846000000084
							],
							[
								-82.50545999999991,
								27.322848000000082
							],
							[
								-82.50520999999992,
								27.32285100000007
							],
							[
								-82.50471699999991,
								27.32285600000006
							],
							[
								-82.50437999999991,
								27.322857000000056
							],
							[
								-82.50402699999995,
								27.32285900000005
							],
							[
								-82.5036879999999,
								27.322858000000053
							],
							[
								-82.5033499999999,
								27.322857000000056
							],
							[
								-82.50300799999991,
								27.32285500000006
							],
							[
								-82.50269099999991,
								27.322853000000066
							],
							[
								-82.50233299999991,
								27.32285200000007
							],
							[
								-82.50199299999991,
								27.32284900000008
							],
							[
								-82.50160899999992,
								27.32284700000008
							],
							[
								-82.5016169999999,
								27.32201000000009
							],
							[
								-82.50160999999991,
								27.321202000000085
							],
							[
								-82.50160999999991,
								27.32093400000008
							],
							[
								-82.50161199999991,
								27.32039300000008
							],
							[
								-82.50160899999992,
								27.319648000000086
							],
							[
								-82.50160299999993,
								27.31962100000004
							],
							[
								-82.50158899999991,
								27.319598000000042
							],
							[
								-82.5015689999999,
								27.31958300000008
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Southgate",
				"RegionID": "126244"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.45930013399993,
					28.014727668000035,
					-82.43522810499991,
					28.032900056000074
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.44284953699992,
							28.032843318000065
						],
						[
							-82.43522810499991,
							28.021758264000084
						],
						[
							-82.43623636399992,
							28.021081819000077
						],
						[
							-82.4372728429999,
							28.020618313000057
						],
						[
							-82.43791830799995,
							28.01954550100004
						],
						[
							-82.43815446999992,
							28.01829996500004
						],
						[
							-82.44122460699992,
							28.014727668000035
						],
						[
							-82.44270479799991,
							28.01599998200004
						],
						[
							-82.44365465699991,
							28.01639986500004
						],
						[
							-82.44501811899994,
							28.018463816000065
						],
						[
							-82.44633636399993,
							28.01804545500005
						],
						[
							-82.44693640499992,
							28.017936185000053
						],
						[
							-82.44829999799992,
							28.018918178000035
						],
						[
							-82.45289999199991,
							28.020409176000044
						],
						[
							-82.4551926659999,
							28.02014269000006
						],
						[
							-82.45561818099992,
							28.02270909100008
						],
						[
							-82.4556180479999,
							28.02540922500009
						],
						[
							-82.45930013399993,
							28.025399866000043
						],
						[
							-82.45927272799992,
							28.032900056000074
						],
						[
							-82.45451822099994,
							28.032899946000043
						],
						[
							-82.44284953699992,
							28.032843318000065
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Sulphur Springs",
				"RegionID": "126292"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.48780599999992,
					27.351988000000063,
					-82.45772699999992,
					27.381245000000035
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.46403099999992,
							27.357225000000085
						],
						[
							-82.46402399999994,
							27.356797000000086
						],
						[
							-82.46401099999991,
							27.356051000000036
						],
						[
							-82.46400299999993,
							27.35554200000007
						],
						[
							-82.46397699999994,
							27.35438400000004
						],
						[
							-82.46396799999991,
							27.354048000000034
						],
						[
							-82.46395999999993,
							27.35330900000008
						],
						[
							-82.46397699999994,
							27.352553000000057
						],
						[
							-82.46397399999995,
							27.351988000000063
						],
						[
							-82.46760799999993,
							27.35205600000006
						],
						[
							-82.46807899999993,
							27.35206500000004
						],
						[
							-82.47296599999993,
							27.35216100000008
						],
						[
							-82.47530199999994,
							27.352204000000086
						],
						[
							-82.47564599999993,
							27.352198000000044
						],
						[
							-82.47586599999994,
							27.352194000000054
						],
						[
							-82.47629399999994,
							27.352203000000088
						],
						[
							-82.47677699999991,
							27.352231000000074
						],
						[
							-82.47850499999993,
							27.352265000000045
						],
						[
							-82.48013099999991,
							27.35229600000008
						],
						[
							-82.48348499999992,
							27.352316000000087
						],
						[
							-82.48349599999995,
							27.35252200000008
						],
						[
							-82.48349499999995,
							27.35268700000006
						],
						[
							-82.48347299999995,
							27.35281800000007
						],
						[
							-82.48332899999991,
							27.35330300000004
						],
						[
							-82.48309899999992,
							27.354359000000045
						],
						[
							-82.48305299999993,
							27.35450300000008
						],
						[
							-82.48298799999992,
							27.35465300000004
						],
						[
							-82.48291399999994,
							27.354790000000037
						],
						[
							-82.48282399999994,
							27.35492000000005
						],
						[
							-82.48267499999992,
							27.35509200000007
						],
						[
							-82.48251299999994,
							27.35524000000004
						],
						[
							-82.4823219999999,
							27.355375000000038
						],
						[
							-82.48212199999995,
							27.355484000000047
						],
						[
							-82.48193399999991,
							27.355559000000085
						],
						[
							-82.48173199999991,
							27.35561800000005
						],
						[
							-82.48094099999992,
							27.35577100000006
						],
						[
							-82.48055199999993,
							27.35584700000004
						],
						[
							-82.48036499999995,
							27.355894000000035
						],
						[
							-82.48014899999993,
							27.355972000000065
						],
						[
							-82.47996699999993,
							27.356060000000074
						],
						[
							-82.47978899999993,
							27.356174000000067
						],
						[
							-82.47962899999993,
							27.356307000000072
						],
						[
							-82.47946499999996,
							27.356480000000094
						],
						[
							-82.4793489999999,
							27.356645000000075
						],
						[
							-82.47927599999991,
							27.356783000000064
						],
						[
							-82.47921999999994,
							27.356926000000044
						],
						[
							-82.47918499999992,
							27.35706300000004
						],
						[
							-82.47915799999993,
							27.357221000000038
						],
						[
							-82.4791459999999,
							27.357398000000046
						],
						[
							-82.47914299999992,
							27.35838700000005
						],
						[
							-82.47911899999991,
							27.358681000000047
						],
						[
							-82.47910399999995,
							27.358810000000062
						],
						[
							-82.4790549999999,
							27.35907300000008
						],
						[
							-82.4789879999999,
							27.35934400000008
						],
						[
							-82.47891699999991,
							27.35957400000007
						],
						[
							-82.47877599999993,
							27.359980000000064
						],
						[
							-82.47920599999992,
							27.360093000000063
						],
						[
							-82.47947399999993,
							27.360153000000082
						],
						[
							-82.47962299999995,
							27.36017200000009
						],
						[
							-82.47982699999994,
							27.36017300000009
						],
						[
							-82.48022399999991,
							27.36013100000008
						],
						[
							-82.48032699999993,
							27.36012700000009
						],
						[
							-82.4805169999999,
							27.36012800000009
						],
						[
							-82.48141399999992,
							27.360134000000073
						],
						[
							-82.48155199999991,
							27.36014700000004
						],
						[
							-82.48169299999995,
							27.36017700000008
						],
						[
							-82.48178399999995,
							27.360204000000067
						],
						[
							-82.48188299999993,
							27.360243000000082
						],
						[
							-82.48197799999991,
							27.36028900000008
						],
						[
							-82.48205799999994,
							27.360337000000072
						],
						[
							-82.48213299999992,
							27.360389000000055
						],
						[
							-82.48220199999992,
							27.360445000000084
						],
						[
							-82.48239499999994,
							27.36063900000005
						],
						[
							-82.48244999999991,
							27.36068800000004
						],
						[
							-82.48251899999991,
							27.360741000000075
						],
						[
							-82.4829959999999,
							27.361034000000075
						],
						[
							-82.48320699999994,
							27.36115600000005
						],
						[
							-82.48338599999994,
							27.361261000000074
						],
						[
							-82.4835129999999,
							27.36132100000009
						],
						[
							-82.48368699999992,
							27.361391000000083
						],
						[
							-82.48386699999992,
							27.361448000000053
						],
						[
							-82.48394999999994,
							27.361469000000056
						],
						[
							-82.48406399999993,
							27.361498000000044
						],
						[
							-82.48424199999994,
							27.361530000000073
						],
						[
							-82.48439799999994,
							27.361548000000084
						],
						[
							-82.48467699999992,
							27.36156600000004
						],
						[
							-82.48489499999994,
							27.361601000000064
						],
						[
							-82.48515399999991,
							27.361667000000068
						],
						[
							-82.4852919999999,
							27.361712000000068
						],
						[
							-82.48539199999993,
							27.36175200000008
						],
						[
							-82.48548699999992,
							27.361799000000076
						],
						[
							-82.4855859999999,
							27.36186100000009
						],
						[
							-82.48566699999992,
							27.361925000000042
						],
						[
							-82.48573999999991,
							27.36199600000009
						],
						[
							-82.48581799999994,
							27.36209000000008
						],
						[
							-82.48591399999992,
							27.362227000000075
						],
						[
							-82.4859669999999,
							27.36232300000006
						],
						[
							-82.48616699999991,
							27.362291000000084
						],
						[
							-82.48630899999996,
							27.36229700000007
						],
						[
							-82.48699699999992,
							27.362414000000058
						],
						[
							-82.48714199999995,
							27.36242800000008
						],
						[
							-82.48750099999995,
							27.362448000000086
						],
						[
							-82.4875899999999,
							27.362464000000045
						],
						[
							-82.48762199999993,
							27.362476000000072
						],
						[
							-82.48768999999993,
							27.362516000000085
						],
						[
							-82.48773699999992,
							27.362561000000085
						],
						[
							-82.48777499999994,
							27.36261600000006
						],
						[
							-82.48779499999995,
							27.362667000000044
						],
						[
							-82.48780599999992,
							27.362731000000053
						],
						[
							-82.48780099999993,
							27.362795000000062
						],
						[
							-82.4877889999999,
							27.36283700000007
						],
						[
							-82.48761399999995,
							27.363155000000063
						],
						[
							-82.48754599999995,
							27.363251000000048
						],
						[
							-82.48750599999994,
							27.363298000000043
						],
						[
							-82.4873879999999,
							27.363402000000065
						],
						[
							-82.48749199999992,
							27.363593000000037
						],
						[
							-82.48755099999994,
							27.363751000000036
						],
						[
							-82.4875669999999,
							27.36382400000008
						],
						[
							-82.48757699999993,
							27.363919000000067
						],
						[
							-82.48757599999995,
							27.364004000000083
						],
						[
							-82.4875669999999,
							27.364078000000063
						],
						[
							-82.48754599999995,
							27.36416200000008
						],
						[
							-82.48750999999993,
							27.364254000000074
						],
						[
							-82.48746899999992,
							27.364332000000047
						],
						[
							-82.48739699999993,
							27.36443200000008
						],
						[
							-82.48726999999991,
							27.364559000000042
						],
						[
							-82.48710499999993,
							27.364645000000053
						],
						[
							-82.48701699999994,
							27.364680000000078
						],
						[
							-82.4869149999999,
							27.364711000000057
						],
						[
							-82.48676299999994,
							27.364737000000048
						],
						[
							-82.48633899999993,
							27.364782000000048
						],
						[
							-82.48626999999993,
							27.364797000000067
						],
						[
							-82.48620299999993,
							27.36481800000007
						],
						[
							-82.48612799999995,
							27.364851000000044
						],
						[
							-82.48603899999995,
							27.36490400000008
						],
						[
							-82.48596999999995,
							27.364963000000046
						],
						[
							-82.48593899999992,
							27.364996000000076
						],
						[
							-82.48591199999993,
							27.365032000000042
						],
						[
							-82.4858779999999,
							27.36508900000007
						],
						[
							-82.48585199999991,
							27.365150000000085
						],
						[
							-82.48583599999995,
							27.365202000000068
						],
						[
							-82.48582399999992,
							27.365266000000076
						],
						[
							-82.48581999999993,
							27.365320000000054
						],
						[
							-82.48582399999992,
							27.365384000000063
						],
						[
							-82.4858329999999,
							27.36543600000005
						],
						[
							-82.48584999999991,
							27.36549800000006
						],
						[
							-82.48589099999994,
							27.365585000000067
						],
						[
							-82.48595599999993,
							27.36567000000008
						],
						[
							-82.48601899999994,
							27.36573100000004
						],
						[
							-82.48614299999991,
							27.36582700000008
						],
						[
							-82.48618499999992,
							27.36586900000009
						],
						[
							-82.4862829999999,
							27.366000000000042
						],
						[
							-82.48631699999993,
							27.366127000000063
						],
						[
							-82.48632399999991,
							27.36618400000009
						],
						[
							-82.48631399999994,
							27.366783000000055
						],
						[
							-82.4863289999999,
							27.36705500000005
						],
						[
							-82.48632399999991,
							27.367649000000085
						],
						[
							-82.48633199999995,
							27.36772300000007
						],
						[
							-82.48636299999993,
							27.367814000000067
						],
						[
							-82.48641499999991,
							27.367896000000087
						],
						[
							-82.48668199999992,
							27.368153000000067
						],
						[
							-82.48674599999993,
							27.368199000000065
						],
						[
							-82.48679799999991,
							27.368229000000042
						],
						[
							-82.48689599999994,
							27.368272000000047
						],
						[
							-82.48695399999991,
							27.368288000000064
						],
						[
							-82.48698999999993,
							27.368904000000047
						],
						[
							-82.48700599999995,
							27.370073000000048
						],
						[
							-82.48698299999995,
							27.370615000000047
						],
						[
							-82.48505099999994,
							27.37062700000007
						],
						[
							-82.4849989999999,
							27.37063500000005
						],
						[
							-82.48497299999991,
							27.370644000000084
						],
						[
							-82.48494799999992,
							27.37066400000009
						],
						[
							-82.48492899999991,
							27.37069000000008
						],
						[
							-82.48491799999994,
							27.37076600000006
						],
						[
							-82.4849309999999,
							27.37423000000007
						],
						[
							-82.48438799999991,
							27.374224000000083
						],
						[
							-82.48322099999992,
							27.374212000000057
						],
						[
							-82.48176199999996,
							27.374193000000048
						],
						[
							-82.48059399999994,
							27.37418400000007
						],
						[
							-82.48014199999994,
							27.374175000000037
						],
						[
							-82.47882199999992,
							27.374149000000045
						],
						[
							-82.47649299999995,
							27.374088000000086
						],
						[
							-82.4757889999999,
							27.37406400000009
						],
						[
							-82.47541199999995,
							27.374055000000055
						],
						[
							-82.47289499999994,
							27.374001000000078
						],
						[
							-82.47139099999993,
							27.373964000000058
						],
						[
							-82.47131199999991,
							27.37396700000005
						],
						[
							-82.4712419999999,
							27.373999000000083
						],
						[
							-82.47122299999995,
							27.374083000000045
						],
						[
							-82.4712209999999,
							27.377601000000084
						],
						[
							-82.47120699999994,
							27.380100000000084
						],
						[
							-82.47119099999992,
							27.381245000000035
						],
						[
							-82.47030699999993,
							27.381226000000083
						],
						[
							-82.47017599999992,
							27.381225000000086
						],
						[
							-82.46913499999994,
							27.38121700000005
						],
						[
							-82.46906299999996,
							27.38121300000006
						],
						[
							-82.46722699999992,
							27.381188000000066
						],
						[
							-82.46567599999992,
							27.38117200000005
						],
						[
							-82.46494299999995,
							27.381155000000035
						],
						[
							-82.46383999999995,
							27.381129000000044
						],
						[
							-82.4637009999999,
							27.381128000000047
						],
						[
							-82.46370499999995,
							27.380655000000047
						],
						[
							-82.46371399999992,
							27.380482000000086
						],
						[
							-82.46372299999992,
							27.378821000000073
						],
						[
							-82.46373699999992,
							27.37738500000006
						],
						[
							-82.46376199999992,
							27.376397000000054
						],
						[
							-82.46376099999992,
							27.375459000000035
						],
						[
							-82.4637929999999,
							27.37501700000007
						],
						[
							-82.46389199999993,
							27.374189000000058
						],
						[
							-82.46392299999991,
							27.373916000000065
						],
						[
							-82.46394199999992,
							27.373800000000077
						],
						[
							-82.46392999999995,
							27.373587000000043
						],
						[
							-82.46391299999993,
							27.373432000000037
						],
						[
							-82.46386199999995,
							27.373234000000082
						],
						[
							-82.46383299999991,
							27.373147000000074
						],
						[
							-82.46379599999995,
							27.373057000000074
						],
						[
							-82.46371999999991,
							27.372907000000055
						],
						[
							-82.46350499999994,
							27.37254800000005
						],
						[
							-82.46340199999992,
							27.372412000000054
						],
						[
							-82.46326499999992,
							27.372265000000084
						],
						[
							-82.46310399999993,
							27.372124000000042
						],
						[
							-82.46296899999993,
							27.372034000000042
						],
						[
							-82.46274499999993,
							27.371887000000072
						],
						[
							-82.46258299999994,
							27.371799000000067
						],
						[
							-82.46236599999992,
							27.371696000000043
						],
						[
							-82.4620109999999,
							27.371496000000036
						],
						[
							-82.46160099999992,
							27.37124800000004
						],
						[
							-82.46124199999991,
							27.371052000000077
						],
						[
							-82.46088899999995,
							27.37086700000009
						],
						[
							-82.4606619999999,
							27.370759000000078
						],
						[
							-82.46043099999991,
							27.370640000000037
						],
						[
							-82.45998899999995,
							27.370388000000048
						],
						[
							-82.45983699999994,
							27.37028100000009
						],
						[
							-82.45964399999991,
							27.37016200000005
						],
						[
							-82.45945699999993,
							27.370030000000042
						],
						[
							-82.45922099999991,
							27.36984300000006
						],
						[
							-82.45902399999994,
							27.369666000000052
						],
						[
							-82.45882399999994,
							27.369463000000053
						],
						[
							-82.45863799999995,
							27.369248000000084
						],
						[
							-82.45846099999994,
							27.36901400000005
						],
						[
							-82.45831199999992,
							27.36878900000005
						],
						[
							-82.45817399999993,
							27.368547000000035
						],
						[
							-82.45806399999992,
							27.36831700000005
						],
						[
							-82.45795499999991,
							27.368041000000062
						],
						[
							-82.45786499999991,
							27.36776000000009
						],
						[
							-82.4578029999999,
							27.367507000000046
						],
						[
							-82.4577559999999,
							27.36721900000009
						],
						[
							-82.45772699999992,
							27.36691600000006
						],
						[
							-82.45772899999992,
							27.366719000000046
						],
						[
							-82.4577339999999,
							27.366471000000047
						],
						[
							-82.45776299999994,
							27.366277000000085
						],
						[
							-82.45784399999991,
							27.36585600000007
						],
						[
							-82.4578929999999,
							27.36564800000008
						],
						[
							-82.4579579999999,
							27.365439000000038
						],
						[
							-82.4580729999999,
							27.36513400000007
						],
						[
							-82.45819599999993,
							27.36487200000005
						],
						[
							-82.45833399999992,
							27.36463000000009
						],
						[
							-82.45850499999995,
							27.36438100000004
						],
						[
							-82.45869399999992,
							27.364141000000075
						],
						[
							-82.4588369999999,
							27.36397900000009
						],
						[
							-82.45913999999993,
							27.36367600000006
						],
						[
							-82.4595149999999,
							27.36338500000005
						],
						[
							-82.45977599999992,
							27.363210000000038
						],
						[
							-82.46069799999992,
							27.36264900000009
						],
						[
							-82.4610909999999,
							27.362429000000077
						],
						[
							-82.46153699999991,
							27.36216100000007
						],
						[
							-82.46273899999994,
							27.36143000000004
						],
						[
							-82.46303699999993,
							27.361239000000072
						],
						[
							-82.46317399999992,
							27.361135000000047
						],
						[
							-82.46329699999991,
							27.36103200000008
						],
						[
							-82.46341399999994,
							27.360924000000068
						],
						[
							-82.46355599999993,
							27.360782000000086
						],
						[
							-82.46370899999994,
							27.36060800000007
						],
						[
							-82.46389399999993,
							27.36026700000008
						],
						[
							-82.4639709999999,
							27.360092000000066
						],
						[
							-82.4640589999999,
							27.359825000000058
						],
						[
							-82.46408699999995,
							27.359702000000084
						],
						[
							-82.46410299999991,
							27.359598000000066
						],
						[
							-82.46411099999995,
							27.35937800000005
						],
						[
							-82.46408899999994,
							27.359086000000048
						],
						[
							-82.46405499999992,
							27.358615000000047
						],
						[
							-82.46403099999992,
							27.357225000000085
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "The Meadows",
				"RegionID": "126395"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.16342599999992,
					26.453708000000063,
					-80.14701699999995,
					26.46881300000007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.14706399999994,
							26.458219000000042
						],
						[
							-80.14708399999995,
							26.45378700000009
						],
						[
							-80.15008199999994,
							26.453779000000054
						],
						[
							-80.15484599999992,
							26.45381000000009
						],
						[
							-80.15512599999994,
							26.45381000000009
						],
						[
							-80.15731999999991,
							26.453809000000035
						],
						[
							-80.15827599999994,
							26.453808000000038
						],
						[
							-80.16108099999991,
							26.45372400000008
						],
						[
							-80.16342599999992,
							26.453708000000063
						],
						[
							-80.16339499999992,
							26.45665400000007
						],
						[
							-80.16337499999992,
							26.458489000000046
						],
						[
							-80.16336899999993,
							26.459084000000075
						],
						[
							-80.16332899999992,
							26.463220000000035
						],
						[
							-80.1633359999999,
							26.46686200000005
						],
						[
							-80.16330199999993,
							26.467204000000038
						],
						[
							-80.16325899999993,
							26.468473000000074
						],
						[
							-80.16325899999993,
							26.468645000000038
						],
						[
							-80.15129999999994,
							26.468753000000053
						],
						[
							-80.14701699999995,
							26.46881300000007
						],
						[
							-80.14702399999993,
							26.466953000000046
						],
						[
							-80.14703299999991,
							26.464988000000062
						],
						[
							-80.1470349999999,
							26.464601000000073
						],
						[
							-80.1470369999999,
							26.464050000000043
						],
						[
							-80.14704999999992,
							26.461250000000064
						],
						[
							-80.14706399999994,
							26.458219000000042
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Delray Beach",
				"Name": "Villages of Oriole",
				"RegionID": "126511"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.4554413219999,
					30.368044838000063,
					-81.39205267799991,
					30.401317134000067
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.41781172999993,
							30.401315496000056
						],
						[
							-81.41318841499994,
							30.401020476000042
						],
						[
							-81.4126920999999,
							30.40098845600005
						],
						[
							-81.41259383399995,
							30.400976659000037
						],
						[
							-81.41246335799991,
							30.400943418000054
						],
						[
							-81.40627481399991,
							30.398862403000063
						],
						[
							-81.40490927999991,
							30.39859677600009
						],
						[
							-81.40477341399992,
							30.398559086000034
						],
						[
							-81.40463757099991,
							30.398496401000045
						],
						[
							-81.40387045499995,
							30.39806161800004
						],
						[
							-81.40373892699995,
							30.397969921000083
						],
						[
							-81.40362807899993,
							30.397859073000063
						],
						[
							-81.40353816399994,
							30.397730661000086
						],
						[
							-81.40347191299992,
							30.39758858600004
						],
						[
							-81.40343133999994,
							30.397437166000085
						],
						[
							-81.40341767799993,
							30.39728100000008
						],
						[
							-81.40343133999994,
							30.397124834000067
						],
						[
							-81.40347191299992,
							30.396973414000055
						],
						[
							-81.40353816399994,
							30.396831339000077
						],
						[
							-81.40362807899993,
							30.39670292700004
						],
						[
							-81.40373892699995,
							30.39659207900007
						],
						[
							-81.40386733899993,
							30.396502164000083
						],
						[
							-81.40400941299993,
							30.39643591400005
						],
						[
							-81.40416083399992,
							30.396395341000073
						],
						[
							-81.40431699999993,
							30.396381678000072
						],
						[
							-81.40443270599992,
							30.39638915200004
						],
						[
							-81.4133014919999,
							30.397539773000062
						],
						[
							-81.41490515699991,
							30.393695765000075
						],
						[
							-81.4135541249999,
							30.393379675000062
						],
						[
							-81.4135033099999,
							30.39336620800009
						],
						[
							-81.4114733099999,
							30.392764208000077
						],
						[
							-81.41142141299991,
							30.392747086000043
						],
						[
							-81.41127933899992,
							30.392680836000068
						],
						[
							-81.41115092699994,
							30.39259092100008
						],
						[
							-81.41104007899992,
							30.392480073000062
						],
						[
							-81.41095016399993,
							30.392351661000074
						],
						[
							-81.41092349799993,
							30.39230193400005
						],
						[
							-81.41035549899993,
							30.39115793300005
						],
						[
							-81.41032209499991,
							30.391082063000056
						],
						[
							-81.40997777099994,
							30.39019071100006
						],
						[
							-81.40926711599991,
							30.38900255100009
						],
						[
							-81.40923063199995,
							30.389002924000067
						],
						[
							-81.40975272499992,
							30.391342095000084
						],
						[
							-81.4097606599999,
							30.391381834000068
						],
						[
							-81.40977432199992,
							30.391538000000082
						],
						[
							-81.4097606599999,
							30.391694165000043
						],
						[
							-81.40972008599994,
							30.39184558600005
						],
						[
							-81.4096538359999,
							30.391987661000087
						],
						[
							-81.40956392099991,
							30.392116073000068
						],
						[
							-81.40945307299995,
							30.39222692000004
						],
						[
							-81.40935774699994,
							30.392296772000066
						],
						[
							-81.40553674699993,
							30.394727772000067
						],
						[
							-81.40547594399993,
							30.394763194000067
						],
						[
							-81.40541255799991,
							30.394793753000044
						],
						[
							-81.40534697599992,
							30.39481926200006
						],
						[
							-81.40527959999991,
							30.394839566000083
						],
						[
							-81.39958515199993,
							30.39631518600004
						],
						[
							-81.39866720499992,
							30.396538684000063
						],
						[
							-81.39316570699992,
							30.39788456200006
						],
						[
							-81.39310816599993,
							30.397896659000082
						],
						[
							-81.39295199999994,
							30.397910322000087
						],
						[
							-81.39279583399991,
							30.397896659000082
						],
						[
							-81.3926444139999,
							30.397856086000047
						],
						[
							-81.39250233899993,
							30.397789836000072
						],
						[
							-81.39237392699994,
							30.397699921000086
						],
						[
							-81.39226307899992,
							30.397589073000066
						],
						[
							-81.39217316399993,
							30.39746066100008
						],
						[
							-81.3921069139999,
							30.397318586000043
						],
						[
							-81.39206634099992,
							30.397167166000088
						],
						[
							-81.39205267799991,
							30.397011000000074
						],
						[
							-81.39206459399992,
							30.39686508500006
						],
						[
							-81.39221159399995,
							30.39597108500004
						],
						[
							-81.39222857399996,
							30.395890860000065
						],
						[
							-81.39548098299991,
							30.383372162000057
						],
						[
							-81.39593745799993,
							30.38157620200008
						],
						[
							-81.39597743199994,
							30.381419322000056
						],
						[
							-81.39691499999992,
							30.381382000000087
						],
						[
							-81.39700899999991,
							30.381383000000085
						],
						[
							-81.3986919059999,
							30.38131600900005
						],
						[
							-81.3995740389999,
							30.381281141000045
						],
						[
							-81.39959390599995,
							30.380757008000046
						],
						[
							-81.39960190599993,
							30.37945800800009
						],
						[
							-81.3995997749999,
							30.377686875000055
						],
						[
							-81.40013390599995,
							30.377721008000037
						],
						[
							-81.40143703399991,
							30.377718147000056
						],
						[
							-81.4015269059999,
							30.376601008000083
						],
						[
							-81.40153277999993,
							30.376489872000036
						],
						[
							-81.40490203099995,
							30.376701145000084
						],
						[
							-81.40510078099993,
							30.373619872000067
						],
						[
							-81.40585890499995,
							30.373660008000055
						],
						[
							-81.40656990699995,
							30.37364700900008
						],
						[
							-81.40816190499993,
							30.373700008000075
						],
						[
							-81.40884192899995,
							30.37370713900009
						],
						[
							-81.40890388299994,
							30.373679878000075
						],
						[
							-81.41005002199995,
							30.37369815700003
						],
						[
							-81.41069476199993,
							30.371008885000037
						],
						[
							-81.41206290499991,
							30.37044000800006
						],
						[
							-81.41248988099994,
							30.370234835000076
						],
						[
							-81.41285300099993,
							30.370295169000087
						],
						[
							-81.41300190499993,
							30.369857008000057
						],
						[
							-81.41303283699995,
							30.369750837000087
						],
						[
							-81.4131219059999,
							30.369797008000035
						],
						[
							-81.41387196799991,
							30.370186183000044
						],
						[
							-81.41426290599992,
							30.36928900600009
						],
						[
							-81.41429003799993,
							30.369176008000068
						],
						[
							-81.41426290599992,
							30.369065009000053
						],
						[
							-81.41424782299993,
							30.369015013000084
						],
						[
							-81.41427176399992,
							30.368904885000063
						],
						[
							-81.41623490399991,
							30.36816601000004
						],
						[
							-81.41668490599994,
							30.368111955000078
						],
						[
							-81.4168859049999,
							30.36814300900005
						],
						[
							-81.41702890599993,
							30.368178009000076
						],
						[
							-81.41765097199993,
							30.368370894000066
						],
						[
							-81.41796791899993,
							30.36868919400007
						],
						[
							-81.41824983399994,
							30.368351833000077
						],
						[
							-81.41895694399994,
							30.368422178000063
						],
						[
							-81.4195258609999,
							30.368044838000063
						],
						[
							-81.4224039049999,
							30.368235008000056
						],
						[
							-81.42832296199992,
							30.36820784400004
						],
						[
							-81.43236499999995,
							30.371431000000086
						],
						[
							-81.43275563999993,
							30.371737059000058
						],
						[
							-81.43274899999994,
							30.37173900000005
						],
						[
							-81.43280790599994,
							30.37177800900008
						],
						[
							-81.43387590599991,
							30.372641009000063
						],
						[
							-81.43411290499995,
							30.37285600900009
						],
						[
							-81.4345319059999,
							30.37327600900005
						],
						[
							-81.43474590599993,
							30.37351600900007
						],
						[
							-81.43508090599994,
							30.373945009000067
						],
						[
							-81.43522590599991,
							30.37414700800008
						],
						[
							-81.4353639059999,
							30.374371009000072
						],
						[
							-81.43550890499995,
							30.374596008000086
						],
						[
							-81.43637590499992,
							30.37623600800004
						],
						[
							-81.43744290599994,
							30.378300008000057
						],
						[
							-81.43814890599992,
							30.37967100900005
						],
						[
							-81.4382868639999,
							30.379996180000035
						],
						[
							-81.43877890499994,
							30.379590008000037
						],
						[
							-81.43891799999994,
							30.379459000000054
						],
						[
							-81.43954030399993,
							30.378789651000094
						],
						[
							-81.44176241699995,
							30.37718924500007
						],
						[
							-81.44182948899993,
							30.377145342000066
						],
						[
							-81.44190020299993,
							30.37710758600008
						],
						[
							-81.44197399899991,
							30.377076276000086
						],
						[
							-81.44205028999994,
							30.37705166300009
						],
						[
							-81.44212846999994,
							30.37703394100004
						],
						[
							-81.4422079169999,
							30.377023251000086
						],
						[
							-81.4422879999999,
							30.377019678000067
						],
						[
							-81.44325479799994,
							30.377019678000067
						],
						[
							-81.4441839889999,
							30.37657480100006
						],
						[
							-81.44498935799993,
							30.376199738000082
						],
						[
							-81.44506267399993,
							30.376169456000074
						],
						[
							-81.4451383729999,
							30.37614575300006
						],
						[
							-81.4452158659999,
							30.376128812000044
						],
						[
							-81.4452945509999,
							30.376118765000058
						],
						[
							-81.44537381499993,
							30.376115691000052
						],
						[
							-81.44545304099995,
							30.37611961400006
						],
						[
							-81.4481641989999,
							30.376374083000087
						],
						[
							-81.44921581199992,
							30.37618370200005
						],
						[
							-81.44937399999992,
							30.376169678000053
						],
						[
							-81.44952076999995,
							30.376181735000042
						],
						[
							-81.45112746799992,
							30.376447538000036
						],
						[
							-81.45128358599993,
							30.37648891400005
						],
						[
							-81.45135108699992,
							30.37651663300005
						],
						[
							-81.45298108599991,
							30.377264632000053
						],
						[
							-81.45300217199991,
							30.377274642000085
						],
						[
							-81.4549381729999,
							30.37822464100009
						],
						[
							-81.45499166099995,
							30.37825316400006
						],
						[
							-81.45512007299993,
							30.378343079000047
						],
						[
							-81.45523092099995,
							30.378453927000066
						],
						[
							-81.45532083599994,
							30.378582339000047
						],
						[
							-81.45538708599992,
							30.378724413000043
						],
						[
							-81.45542765899995,
							30.37887583400004
						],
						[
							-81.4554413219999,
							30.379032000000052
						],
						[
							-81.45542765899995,
							30.379188165000073
						],
						[
							-81.45538708599992,
							30.37933958600007
						],
						[
							-81.45532083599994,
							30.379481661000057
						],
						[
							-81.45523092099995,
							30.379610073000038
						],
						[
							-81.45512007299993,
							30.37972092000007
						],
						[
							-81.45509414799994,
							30.37974186800005
						],
						[
							-81.45507614799993,
							30.379755869000068
						],
						[
							-81.45501683799995,
							30.379798258000054
						],
						[
							-81.45495428999993,
							30.379835703000083
						],
						[
							-81.45488891399992,
							30.37986796000007
						],
						[
							-81.45482114099991,
							30.37989481600005
						],
						[
							-81.45475141499992,
							30.379916094000063
						],
						[
							-81.45468019499992,
							30.379931654000075
						],
						[
							-81.45460794799993,
							30.379941396000053
						],
						[
							-81.4545759479999,
							30.379944396000045
						],
						[
							-81.45444634499995,
							30.379947163000057
						],
						[
							-81.45342334499993,
							30.379895162000082
						],
						[
							-81.45336937999991,
							30.37989078700008
						],
						[
							-81.45087270999994,
							30.379612512000048
						],
						[
							-81.44873139499992,
							30.379663473000054
						],
						[
							-81.44520406999993,
							30.380278257000043
						],
						[
							-81.44234983299992,
							30.381318997000047
						],
						[
							-81.44219816599991,
							30.381359660000044
						],
						[
							-81.44215526999994,
							30.381366161000074
						],
						[
							-81.4409493629999,
							30.38151926400008
						],
						[
							-81.44065718999991,
							30.38170197300008
						],
						[
							-81.44004386599994,
							30.382073000000048
						],
						[
							-81.43983031999994,
							30.38248715000009
						],
						[
							-81.4397915369999,
							30.382554963000075
						],
						[
							-81.43974701399992,
							30.382619155000043
						],
						[
							-81.43969708799995,
							30.382679241000062
						],
						[
							-81.43676921799994,
							30.385906799000054
						],
						[
							-81.43585449499994,
							30.387250960000074
						],
						[
							-81.4358304559999,
							30.38728459500004
						],
						[
							-81.4357854559999,
							30.38734459500006
						],
						[
							-81.43575547499997,
							30.387382412000083
						],
						[
							-81.43552109399991,
							30.387662281000075
						],
						[
							-81.43345995899995,
							30.391851986000063
						],
						[
							-81.4334395059999,
							30.39189110600006
						],
						[
							-81.43153767099994,
							30.395320883000068
						],
						[
							-81.43149736899994,
							30.39538557400005
						],
						[
							-81.43145173099992,
							30.39544661800005
						],
						[
							-81.43140108599994,
							30.395503576000063
						],
						[
							-81.43134579799994,
							30.39555603900004
						],
						[
							-81.43128626399994,
							30.395603629000053
						],
						[
							-81.43044744299993,
							30.396217766000063
						],
						[
							-81.43024139799991,
							30.396612856000047
						],
						[
							-81.43020439199995,
							30.396677191000038
						],
						[
							-81.4301622079999,
							30.396738255000063
						],
						[
							-81.43011513199991,
							30.396795634000057
						],
						[
							-81.43006348399992,
							30.396848935000037
						],
						[
							-81.42940578199995,
							30.397473900000083
						],
						[
							-81.42870299799995,
							30.398163781000047
						],
						[
							-81.42865635899994,
							30.398206451000082
						],
						[
							-81.42860683799995,
							30.39824573900006
						],
						[
							-81.42855467899994,
							30.39828145100006
						],
						[
							-81.42850013999993,
							30.39831341100006
						],
						[
							-81.42764413999993,
							30.398775411000088
						],
						[
							-81.42762451199991,
							30.398785695000072
						],
						[
							-81.42720440399995,
							30.39899924000008
						],
						[
							-81.42401229599994,
							30.40063078500009
						],
						[
							-81.42391058599992,
							30.40067508600004
						],
						[
							-81.42375469399991,
							30.400716424000056
						],
						[
							-81.4205322219999,
							30.401251190000043
						],
						[
							-81.4203849999999,
							30.401263322000094
						],
						[
							-81.42031545999993,
							30.401260629000035
						],
						[
							-81.41849037499992,
							30.401119081000047
						],
						[
							-81.41825313899994,
							30.401231153000086
						],
						[
							-81.41818341099992,
							30.401260571000083
						],
						[
							-81.41811145799994,
							30.401284022000088
						],
						[
							-81.41803778699995,
							30.40130134100008
						],
						[
							-81.4179629219999,
							30.40131240400007
						],
						[
							-81.41788739099991,
							30.401317134000067
						],
						[
							-81.41781172999993,
							30.401315496000056
						]
					],
					[
						[
							-81.42492796699992,
							30.384123678000037
						],
						[
							-81.4248454239999,
							30.379645322000044
						],
						[
							-81.42117770199991,
							30.379645322000044
						],
						[
							-81.42047689099991,
							30.380820120000067
						],
						[
							-81.42420324599993,
							30.384123678000037
						],
						[
							-81.42492796699992,
							30.384123678000037
						]
					],
					[
						[
							-81.42783745899993,
							30.37974476900007
						],
						[
							-81.42975125999993,
							30.381279606000078
						],
						[
							-81.42991004399994,
							30.38114323100007
						],
						[
							-81.43326317899994,
							30.377940911000053
						],
						[
							-81.43309238199993,
							30.37689261900005
						],
						[
							-81.43308837199993,
							30.37686538500009
						],
						[
							-81.43308260399994,
							30.37680681900008
						],
						[
							-81.43308108299993,
							30.376774978000075
						],
						[
							-81.43303469799993,
							30.375229436000044
						],
						[
							-81.43300291299994,
							30.37512536500009
						],
						[
							-81.43273618099994,
							30.374823608000042
						],
						[
							-81.43273385399993,
							30.374820964000037
						],
						[
							-81.4327306539999,
							30.37481729600006
						],
						[
							-81.4323454009999,
							30.37437317300004
						],
						[
							-81.43188095599993,
							30.374017028000083
						],
						[
							-81.4295962889999,
							30.375910745000056
						],
						[
							-81.4297546169999,
							30.376091574000043
						],
						[
							-81.42979147999995,
							30.376136528000075
						],
						[
							-81.42982575899993,
							30.376184364000036
						],
						[
							-81.42985683599994,
							30.376234339000064
						],
						[
							-81.42988457699994,
							30.376286240000073
						],
						[
							-81.4299088649999,
							30.376339845000075
						],
						[
							-81.42992959499992,
							30.376394923000074
						],
						[
							-81.42994667799991,
							30.376451238000072
						],
						[
							-81.42996004199996,
							30.376508551000082
						],
						[
							-81.42996962799992,
							30.37656661500006
						],
						[
							-81.42997539599992,
							30.376625182000055
						],
						[
							-81.4299773219999,
							30.37668400000007
						],
						[
							-81.42997539599992,
							30.376742819000075
						],
						[
							-81.42996962799992,
							30.37680138500008
						],
						[
							-81.42996004199996,
							30.37685944900005
						],
						[
							-81.42994667799991,
							30.376916762000064
						],
						[
							-81.42992959499992,
							30.376973078000045
						],
						[
							-81.4299088649999,
							30.377028156000055
						],
						[
							-81.42988457699994,
							30.377081760000063
						],
						[
							-81.42985683599994,
							30.377133661000073
						],
						[
							-81.42982575899993,
							30.377183637000087
						],
						[
							-81.42979147999995,
							30.377231473000048
						],
						[
							-81.42975414599994,
							30.377276964000092
						],
						[
							-81.4297139169999,
							30.37731991700008
						],
						[
							-81.42967096399991,
							30.37736014600006
						],
						[
							-81.42962547199994,
							30.37739748000007
						],
						[
							-81.42960608099992,
							30.377411950000067
						],
						[
							-81.42781938699994,
							30.37870808200006
						],
						[
							-81.42784747999991,
							30.379357109000065
						],
						[
							-81.42784832199993,
							30.379396000000042
						],
						[
							-81.42784784699995,
							30.379425221000076
						],
						[
							-81.42783745899993,
							30.37974476900007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Mayport",
				"RegionID": "12629"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.80120799999997,
					26.211242000000027,
					-81.78775999999993,
					26.250801000000024
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.78904099999994,
							26.24722200000008
						],
						[
							-81.78880199999998,
							26.247052000000053
						],
						[
							-81.78847399999995,
							26.246826000000056
						],
						[
							-81.78819599999997,
							26.24665600000003
						],
						[
							-81.78806999999995,
							26.246571000000074
						],
						[
							-81.78789699999999,
							26.246456000000023
						],
						[
							-81.78779599999996,
							26.246377000000052
						],
						[
							-81.78775999999993,
							26.246312000000046
						],
						[
							-81.78777999999994,
							26.24619000000007
						],
						[
							-81.78779799999995,
							26.24592300000006
						],
						[
							-81.78786899999994,
							26.24534600000004
						],
						[
							-81.78794399999998,
							26.244890000000055
						],
						[
							-81.78801899999996,
							26.244522000000075
						],
						[
							-81.78804799999995,
							26.24429500000008
						],
						[
							-81.78805499999999,
							26.24419800000004
						],
						[
							-81.78806899999995,
							26.244102000000055
						],
						[
							-81.78814699999998,
							26.243712000000073
						],
						[
							-81.78819799999997,
							26.243399000000068
						],
						[
							-81.78830399999998,
							26.242636000000065
						],
						[
							-81.78849099999996,
							26.24121400000007
						],
						[
							-81.78882699999997,
							26.238376000000073
						],
						[
							-81.78892199999996,
							26.237652000000026
						],
						[
							-81.78899999999999,
							26.236970000000042
						],
						[
							-81.78909799999997,
							26.23638500000004
						],
						[
							-81.78919799999994,
							26.23494000000005
						],
						[
							-81.78923699999996,
							26.234601000000055
						],
						[
							-81.78933499999994,
							26.233962000000076
						],
						[
							-81.78936299999998,
							26.23350700000003
						],
						[
							-81.78939999999994,
							26.23322500000006
						],
						[
							-81.78959399999997,
							26.231737000000066
						],
						[
							-81.78992199999999,
							26.22922600000004
						],
						[
							-81.790057,
							26.228230000000053
						],
						[
							-81.79019699999998,
							26.22704600000003
						],
						[
							-81.79033099999998,
							26.225997000000067
						],
						[
							-81.79050799999999,
							26.224720000000048
						],
						[
							-81.79066599999999,
							26.223673000000076
						],
						[
							-81.79081599999995,
							26.22262900000004
						],
						[
							-81.79110499999996,
							26.22029200000003
						],
						[
							-81.79182499999996,
							26.214877000000058
						],
						[
							-81.79191899999995,
							26.214161000000047
						],
						[
							-81.79216399999996,
							26.212485000000072
						],
						[
							-81.79224299999998,
							26.211861000000056
						],
						[
							-81.79225899999994,
							26.21165400000007
						],
						[
							-81.79236599999996,
							26.211332000000027
						],
						[
							-81.79245399999996,
							26.21133100000003
						],
						[
							-81.79407499999996,
							26.21130900000003
						],
						[
							-81.79408899999999,
							26.211316000000068
						],
						[
							-81.79418799999996,
							26.21131900000006
						],
						[
							-81.79613599999999,
							26.21127900000005
						],
						[
							-81.79728599999999,
							26.211256000000052
						],
						[
							-81.79761199999996,
							26.211249000000066
						],
						[
							-81.79874499999994,
							26.211250000000064
						],
						[
							-81.79938099999998,
							26.211256000000052
						],
						[
							-81.79999299999997,
							26.21124800000007
						],
						[
							-81.80042099999997,
							26.211242000000027
						],
						[
							-81.80044299999997,
							26.212357000000058
						],
						[
							-81.80050299999994,
							26.215324000000066
						],
						[
							-81.80055399999998,
							26.217903000000035
						],
						[
							-81.80060499999996,
							26.22048600000005
						],
						[
							-81.80061899999998,
							26.221239000000025
						],
						[
							-81.80077599999998,
							26.229761000000053
						],
						[
							-81.80082899999996,
							26.23206800000003
						],
						[
							-81.80088399999994,
							26.23448300000007
						],
						[
							-81.80089699999996,
							26.23504900000006
						],
						[
							-81.80095899999998,
							26.238095000000044
						],
						[
							-81.80099199999995,
							26.239735000000053
						],
						[
							-81.80101899999994,
							26.241555000000062
						],
						[
							-81.80104099999994,
							26.24237000000005
						],
						[
							-81.80105799999995,
							26.242975000000058
						],
						[
							-81.80108899999999,
							26.24411800000007
						],
						[
							-81.80111499999998,
							26.245085000000074
						],
						[
							-81.80114099999997,
							26.246692000000056
						],
						[
							-81.80115299999994,
							26.247404000000074
						],
						[
							-81.80115799999999,
							26.24770600000005
						],
						[
							-81.80118099999999,
							26.24899300000004
						],
						[
							-81.80120399999998,
							26.250233000000037
						],
						[
							-81.80120799999997,
							26.250459000000035
						],
						[
							-81.80095599999999,
							26.250444000000073
						],
						[
							-81.80050899999998,
							26.250452000000053
						],
						[
							-81.79978499999999,
							26.25047200000006
						],
						[
							-81.79908799999998,
							26.250518000000056
						],
						[
							-81.79881399999994,
							26.25055400000008
						],
						[
							-81.79813899999994,
							26.250642000000028
						],
						[
							-81.79758699999996,
							26.250725000000045
						],
						[
							-81.79722799999998,
							26.250763000000063
						],
						[
							-81.79691199999996,
							26.250786000000062
						],
						[
							-81.79671499999995,
							26.250796000000037
						],
						[
							-81.79646799999995,
							26.250801000000024
						],
						[
							-81.79621099999997,
							26.250796000000037
						],
						[
							-81.795869,
							26.250779000000023
						],
						[
							-81.79553399999998,
							26.25074700000005
						],
						[
							-81.79505699999999,
							26.25067800000005
						],
						[
							-81.79464599999994,
							26.250591000000043
						],
						[
							-81.79438399999998,
							26.250523000000044
						],
						[
							-81.79413899999997,
							26.250452000000053
						],
						[
							-81.79379499999999,
							26.250342000000046
						],
						[
							-81.79343599999999,
							26.250204000000053
						],
						[
							-81.79323499999998,
							26.250116000000048
						],
						[
							-81.79300199999994,
							26.25000700000004
						],
						[
							-81.79280599999998,
							26.249906000000067
						],
						[
							-81.79238799999996,
							26.249668000000046
						],
						[
							-81.79226599999998,
							26.24959300000006
						],
						[
							-81.79214799999994,
							26.249514000000033
						],
						[
							-81.79187999999994,
							26.249321000000066
						],
						[
							-81.79144599999995,
							26.24899700000003
						],
						[
							-81.79076099999999,
							26.24849600000005
						],
						[
							-81.79014699999999,
							26.248029000000034
						],
						[
							-81.78939899999995,
							26.247478000000058
						],
						[
							-81.78904099999994,
							26.24722200000008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Collier",
				"City": "Naples",
				"Name": "Pine Ridge",
				"RegionID": "13295"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.31088999999997,
					28.51588000000004,
					-81.28538999999995,
					28.568178000000046
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.30388999999997,
							28.562178000000074
						],
						[
							-81.29878999999994,
							28.565078000000028
						],
						[
							-81.29645599999998,
							28.566063000000042
						],
						[
							-81.29560499999997,
							28.566422000000046
						],
						[
							-81.29428999999999,
							28.566978000000066
						],
						[
							-81.29391199999998,
							28.567078000000038
						],
						[
							-81.29328999999996,
							28.567241000000024
						],
						[
							-81.29238999999995,
							28.56747800000005
						],
						[
							-81.29038899999995,
							28.567878000000064
						],
						[
							-81.28778899999998,
							28.568178000000046
						],
						[
							-81.28718899999996,
							28.568178000000046
						],
						[
							-81.28628899999995,
							28.568178000000046
						],
						[
							-81.28618899999998,
							28.567278000000044
						],
						[
							-81.28618899999998,
							28.566278000000068
						],
						[
							-81.28612499999998,
							28.56209000000007
						],
						[
							-81.28608899999995,
							28.55977800000005
						],
						[
							-81.28608899999995,
							28.559278000000063
						],
						[
							-81.28598899999997,
							28.55607800000007
						],
						[
							-81.28598499999998,
							28.555693000000076
						],
						[
							-81.28597299999996,
							28.554322000000074
						],
						[
							-81.28596799999997,
							28.553779000000077
						],
						[
							-81.28595999999999,
							28.552879000000075
						],
						[
							-81.28588999999994,
							28.545579000000032
						],
						[
							-81.28588899999994,
							28.545423000000028
						],
						[
							-81.28578999999996,
							28.541079000000025
						],
						[
							-81.28578999999996,
							28.54047900000006
						],
						[
							-81.28578999999996,
							28.539972000000034
						],
						[
							-81.28578999999996,
							28.539179000000047
						],
						[
							-81.28578999999996,
							28.53817900000007
						],
						[
							-81.28578999999996,
							28.537079000000062
						],
						[
							-81.28558999999996,
							28.53547900000007
						],
						[
							-81.28568999999999,
							28.532479000000023
						],
						[
							-81.28568999999999,
							28.531779000000032
						],
						[
							-81.28568999999999,
							28.53157900000008
						],
						[
							-81.28568999999999,
							28.531179000000066
						],
						[
							-81.28568999999999,
							28.530669000000046
						],
						[
							-81.28568999999999,
							28.530179000000032
						],
						[
							-81.28568999999999,
							28.529979000000026
						],
						[
							-81.28568999999999,
							28.52927900000003
						],
						[
							-81.28558999999996,
							28.528379000000033
						],
						[
							-81.28568999999999,
							28.527479000000028
						],
						[
							-81.28568999999999,
							28.52707900000007
						],
						[
							-81.28558999999996,
							28.526379000000077
						],
						[
							-81.28538999999995,
							28.52308000000005
						],
						[
							-81.28647999999998,
							28.521648000000027
						],
						[
							-81.28738999999997,
							28.520680000000027
						],
						[
							-81.28818999999999,
							28.51968000000005
						],
						[
							-81.28898499999998,
							28.518647000000044
						],
						[
							-81.28918999999996,
							28.518380000000036
						],
						[
							-81.28968999999995,
							28.51588000000004
						],
						[
							-81.29368999999997,
							28.517280000000028
						],
						[
							-81.29403899999994,
							28.51748900000007
						],
						[
							-81.29418999999996,
							28.517580000000066
						],
						[
							-81.29428199999995,
							28.51761300000004
						],
						[
							-81.29668999999996,
							28.518480000000068
						],
						[
							-81.29698999999994,
							28.518580000000043
						],
						[
							-81.29808999999995,
							28.51898000000006
						],
						[
							-81.29808399999996,
							28.52007800000007
						],
						[
							-81.29808999999995,
							28.52422400000006
						],
						[
							-81.29808999999995,
							28.524380000000065
						],
						[
							-81.29659299999997,
							28.52444200000008
						],
						[
							-81.29659299999997,
							28.526175000000023
						],
						[
							-81.29659299999997,
							28.52639000000005
						],
						[
							-81.29514799999998,
							28.526383000000067
						],
						[
							-81.29496299999994,
							28.526207000000056
						],
						[
							-81.29462999999998,
							28.526208000000054
						],
						[
							-81.29419699999994,
							28.526208000000054
						],
						[
							-81.29392599999994,
							28.526208000000054
						],
						[
							-81.29392499999994,
							28.526587000000063
						],
						[
							-81.29391299999997,
							28.52768800000007
						],
						[
							-81.29391299999997,
							28.527931000000024
						],
						[
							-81.29388599999999,
							28.528276000000062
						],
						[
							-81.29386399999999,
							28.528354000000036
						],
						[
							-81.29384099999999,
							28.528415000000052
						],
						[
							-81.29369699999995,
							28.528530000000046
						],
						[
							-81.29361899999998,
							28.528593000000058
						],
						[
							-81.29340199999996,
							28.528720000000078
						],
						[
							-81.29319199999998,
							28.528810000000078
						],
						[
							-81.29298199999994,
							28.528895000000038
						],
						[
							-81.29286399999995,
							28.528946000000076
						],
						[
							-81.29279799999995,
							28.528884000000062
						],
						[
							-81.29278999999997,
							28.52897900000005
						],
						[
							-81.29263399999996,
							28.529057000000023
						],
						[
							-81.29224999999997,
							28.52846100000005
						],
						[
							-81.29205299999995,
							28.52769600000005
						],
						[
							-81.29177899999996,
							28.526699000000065
						],
						[
							-81.29177999999996,
							28.526647000000025
						],
						[
							-81.29170799999997,
							28.526647000000025
						],
						[
							-81.29141799999996,
							28.526651000000072
						],
						[
							-81.29122499999994,
							28.526736000000028
						],
						[
							-81.29090099999996,
							28.526745000000062
						],
						[
							-81.29034199999995,
							28.527070000000037
						],
						[
							-81.29018099999996,
							28.527097000000026
						],
						[
							-81.28999799999997,
							28.527258000000074
						],
						[
							-81.29003699999998,
							28.527307000000064
						],
						[
							-81.29023299999994,
							28.527584000000047
						],
						[
							-81.29026799999997,
							28.52763000000005
						],
						[
							-81.29035499999998,
							28.52774400000004
						],
						[
							-81.29042199999998,
							28.52788000000004
						],
						[
							-81.29044899999997,
							28.528022000000078
						],
						[
							-81.29042899999996,
							28.528170000000046
						],
						[
							-81.29035499999998,
							28.52831800000007
						],
						[
							-81.29023999999998,
							28.52844200000004
						],
						[
							-81.29010599999998,
							28.52857800000004
						],
						[
							-81.28997799999996,
							28.528679000000068
						],
						[
							-81.28988999999996,
							28.528759000000036
						],
						[
							-81.28959999999995,
							28.529034000000024
						],
						[
							-81.28951599999994,
							28.529127000000077
						],
						[
							-81.28941499999996,
							28.529251000000045
						],
						[
							-81.28928099999996,
							28.529408000000046
						],
						[
							-81.28922399999999,
							28.529580000000067
						],
						[
							-81.28920199999999,
							28.52969900000005
						],
						[
							-81.28920999999997,
							28.529944000000057
						],
						[
							-81.28967099999994,
							28.531707000000043
						],
						[
							-81.29058899999995,
							28.532971000000032
						],
						[
							-81.29184499999998,
							28.532971000000032
						],
						[
							-81.29183899999998,
							28.53762100000006
						],
						[
							-81.29183199999994,
							28.537773000000072
						],
						[
							-81.29183599999999,
							28.53788300000008
						],
						[
							-81.29266499999994,
							28.53789100000006
						],
						[
							-81.29266099999995,
							28.539079000000072
						],
						[
							-81.29266099999995,
							28.539217000000065
						],
						[
							-81.29368999999997,
							28.539218000000062
						],
						[
							-81.30077199999994,
							28.539220000000057
						],
						[
							-81.30609,
							28.53912900000006
						],
						[
							-81.30948999999998,
							28.539079000000072
						],
						[
							-81.31054499999993,
							28.53911800000003
						],
						[
							-81.31055299999997,
							28.53963600000003
						],
						[
							-81.31055199999997,
							28.540134000000023
						],
						[
							-81.31055299999997,
							28.541086000000064
						],
						[
							-81.31054599999999,
							28.542009000000064
						],
						[
							-81.31054199999994,
							28.543202000000065
						],
						[
							-81.31055299999997,
							28.545813000000066
						],
						[
							-81.31055699999996,
							28.546097000000035
						],
						[
							-81.31055399999997,
							28.546316000000047
						],
						[
							-81.30990899999995,
							28.546316000000047
						],
						[
							-81.30990899999995,
							28.54608200000007
						],
						[
							-81.30990699999995,
							28.545863000000057
						],
						[
							-81.30978899999997,
							28.54586400000005
						],
						[
							-81.30898899999994,
							28.54586400000005
						],
						[
							-81.30899099999993,
							28.546219000000065
						],
						[
							-81.30898599999995,
							28.546308000000067
						],
						[
							-81.30875499999996,
							28.546309000000065
						],
						[
							-81.30875099999997,
							28.546230000000037
						],
						[
							-81.30874899999998,
							28.54586900000004
						],
						[
							-81.30867399999994,
							28.54586800000004
						],
						[
							-81.30857899999997,
							28.54586800000004
						],
						[
							-81.30857999999995,
							28.546173000000067
						],
						[
							-81.30857999999995,
							28.546306000000076
						],
						[
							-81.30803599999996,
							28.546309000000065
						],
						[
							-81.30686499999996,
							28.546310000000062
						],
						[
							-81.30686599999996,
							28.54807900000003
						],
						[
							-81.30658999999997,
							28.54807900000003
						],
						[
							-81.30576299999996,
							28.54814300000004
						],
						[
							-81.30576299999996,
							28.548276000000048
						],
						[
							-81.30576199999996,
							28.549788000000035
						],
						[
							-81.30686699999995,
							28.549787000000038
						],
						[
							-81.30809199999999,
							28.54976700000003
						],
						[
							-81.30827699999998,
							28.549758000000054
						],
						[
							-81.30828399999996,
							28.54903900000005
						],
						[
							-81.30821599999996,
							28.549041000000045
						],
						[
							-81.30811699999998,
							28.549041000000045
						],
						[
							-81.30811699999998,
							28.548152000000073
						],
						[
							-81.30838799999998,
							28.548152000000073
						],
						[
							-81.30838499999999,
							28.548760000000073
						],
						[
							-81.30839599999996,
							28.549942000000044
						],
						[
							-81.30686599999996,
							28.549942000000044
						],
						[
							-81.30686799999995,
							28.550966000000074
						],
						[
							-81.30687899999998,
							28.55342200000007
						],
						[
							-81.30740499999996,
							28.553405000000055
						],
						[
							-81.30765499999995,
							28.553423000000066
						],
						[
							-81.30889099999996,
							28.55342200000007
						],
						[
							-81.30889099999996,
							28.553177000000062
						],
						[
							-81.30908999999997,
							28.553079000000025
						],
						[
							-81.30934099999996,
							28.55297900000005
						],
						[
							-81.30913999999997,
							28.552860000000067
						],
						[
							-81.30889099999996,
							28.552899000000025
						],
						[
							-81.30888999999996,
							28.550379000000078
						],
						[
							-81.30888999999996,
							28.549879000000033
						],
						[
							-81.30908999999997,
							28.549879000000033
						],
						[
							-81.30924699999997,
							28.54988000000003
						],
						[
							-81.30924699999997,
							28.54903900000005
						],
						[
							-81.30948999999998,
							28.54903900000005
						],
						[
							-81.30978299999998,
							28.549040000000048
						],
						[
							-81.30978299999998,
							28.548080000000027
						],
						[
							-81.30988499999995,
							28.54808200000008
						],
						[
							-81.31071699999995,
							28.548096000000044
						],
						[
							-81.31078999999994,
							28.550479000000056
						],
						[
							-81.31068999999997,
							28.553079000000025
						],
						[
							-81.31088999999997,
							28.55357900000007
						],
						[
							-81.31078999999994,
							28.55437900000004
						],
						[
							-81.31078999999994,
							28.554779000000053
						],
						[
							-81.31088999999997,
							28.55577900000003
						],
						[
							-81.31088999999997,
							28.557379000000026
						],
						[
							-81.30818999999997,
							28.559078000000056
						],
						[
							-81.30768999999998,
							28.559478000000073
						],
						[
							-81.30468999999994,
							28.56147800000008
						],
						[
							-81.30388999999997,
							28.562178000000074
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Azalea Park",
				"RegionID": "23566"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.86143407599991,
					30.308667013000047,
					-81.7865027499999,
					30.332966012000043
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.8284639069999,
							30.330598011000063
						],
						[
							-81.82812090899995,
							30.33059001000004
						],
						[
							-81.82780090799992,
							30.330598011000063
						],
						[
							-81.82746490699992,
							30.330630010000053
						],
						[
							-81.8271979079999,
							30.330672011000043
						],
						[
							-81.82020390799994,
							30.33199301000008
						],
						[
							-81.81924890699992,
							30.332167011000084
						],
						[
							-81.81876790799993,
							30.332241011000065
						],
						[
							-81.81829590699994,
							30.33230001000004
						],
						[
							-81.81712090799994,
							30.33240501000006
						],
						[
							-81.81561490799993,
							30.33254001000006
						],
						[
							-81.81503290799992,
							30.332588009000062
						],
						[
							-81.81432890799994,
							30.33252801100008
						],
						[
							-81.81253590799992,
							30.332221011000055
						],
						[
							-81.81079290799994,
							30.331949010000077
						],
						[
							-81.8066439079999,
							30.331253010000065
						],
						[
							-81.80340990699995,
							30.330715011000056
						],
						[
							-81.80255990799992,
							30.33056901000009
						],
						[
							-81.80249190699993,
							30.330556011000056
						],
						[
							-81.79993990699995,
							30.33014601100007
						],
						[
							-81.79818490699996,
							30.32984401000005
						],
						[
							-81.79798290699995,
							30.329805010000086
						],
						[
							-81.79664290699992,
							30.329586011000064
						],
						[
							-81.79610990799995,
							30.329508011000087
						],
						[
							-81.7958829069999,
							30.32950201100004
						],
						[
							-81.79544690799993,
							30.329509011000084
						],
						[
							-81.79202190799992,
							30.329723010000066
						],
						[
							-81.7909939079999,
							30.329801011000086
						],
						[
							-81.79017390799993,
							30.329836011000054
						],
						[
							-81.78981977899991,
							30.32986714400005
						],
						[
							-81.78981190799993,
							30.328253011000072
						],
						[
							-81.78981090799994,
							30.328116011000077
						],
						[
							-81.7898029079999,
							30.326620010000056
						],
						[
							-81.78979790799991,
							30.32643401000007
						],
						[
							-81.78978290799995,
							30.32603201100005
						],
						[
							-81.7897449059999,
							30.325691008000035
						],
						[
							-81.7896899079999,
							30.325516010000058
						],
						[
							-81.78959190699993,
							30.325179010000056
						],
						[
							-81.78947590699994,
							30.32487901000007
						],
						[
							-81.78941590799991,
							30.324747010000067
						],
						[
							-81.7892859079999,
							30.324523011000057
						],
						[
							-81.78904890699994,
							30.32417901100007
						],
						[
							-81.78870590699995,
							30.323790011000085
						],
						[
							-81.7886369069999,
							30.323734010000067
						],
						[
							-81.78819590699993,
							30.323386011000082
						],
						[
							-81.7880239079999,
							30.323274010000038
						],
						[
							-81.78767690799992,
							30.323086011000044
						],
						[
							-81.7873199419999,
							30.32292192600005
						],
						[
							-81.78681790799993,
							30.32274600900007
						],
						[
							-81.78672890699994,
							30.322695010000075
						],
						[
							-81.78661790699994,
							30.322614008000077
						],
						[
							-81.7865027499999,
							30.322485954000054
						],
						[
							-81.78659490699994,
							30.322469011000063
						],
						[
							-81.78679590799993,
							30.322430010000065
						],
						[
							-81.78694890799994,
							30.322394010000036
						],
						[
							-81.78709790699992,
							30.32236501100005
						],
						[
							-81.78744590699995,
							30.32227301000006
						],
						[
							-81.78771990699994,
							30.322189010000045
						],
						[
							-81.78837890799991,
							30.321925010000083
						],
						[
							-81.79125890699993,
							30.320733010000083
						],
						[
							-81.79168990799991,
							30.320585011000052
						],
						[
							-81.7918759069999,
							30.320529011000076
						],
						[
							-81.7924179069999,
							30.320384010000055
						],
						[
							-81.79276190799993,
							30.320308010000076
						],
						[
							-81.79324390699992,
							30.320220011000057
						],
						[
							-81.79368306299996,
							30.32017307200005
						],
						[
							-81.79355390699993,
							30.320008011000084
						],
						[
							-81.79336690799994,
							30.319804010000045
						],
						[
							-81.7932489069999,
							30.31967401000008
						],
						[
							-81.79308890699991,
							30.319498010000075
						],
						[
							-81.7929989079999,
							30.31939901000004
						],
						[
							-81.79295890799995,
							30.319355010000038
						],
						[
							-81.7929339069999,
							30.319327010000052
						],
						[
							-81.79226690799993,
							30.31856901000009
						],
						[
							-81.79213690699994,
							30.318411010000087
						],
						[
							-81.79112176699994,
							30.317267945000083
						],
						[
							-81.79189304099992,
							30.317278141000088
						],
						[
							-81.7918299079999,
							30.316125011000057
						],
						[
							-81.79179890699993,
							30.315318011000045
						],
						[
							-81.79178291399995,
							30.314978956000065
						],
						[
							-81.79518290999994,
							30.314928012000053
						],
						[
							-81.79607390799993,
							30.314909012000044
						],
						[
							-81.79652691099994,
							30.31490501200005
						],
						[
							-81.7974489099999,
							30.31488401200005
						],
						[
							-81.79792591099995,
							30.314863012000046
						],
						[
							-81.79837190899991,
							30.314852012000078
						],
						[
							-81.79971590899993,
							30.314793012000052
						],
						[
							-81.80133590899993,
							30.314697013000053
						],
						[
							-81.80221990899992,
							30.314627013000063
						],
						[
							-81.80372090799995,
							30.314488013000073
						],
						[
							-81.80400790899995,
							30.314463013000076
						],
						[
							-81.80525991099995,
							30.314318012000058
						],
						[
							-81.8066859079999,
							30.314137013000046
						],
						[
							-81.80967690999995,
							30.313711012000056
						],
						[
							-81.81545090799995,
							30.312873013000054
						],
						[
							-81.81600190899991,
							30.312788013000045
						],
						[
							-81.81741191099991,
							30.312586012000054
						],
						[
							-81.82243390799994,
							30.311866012000053
						],
						[
							-81.82296790899994,
							30.311789012000077
						],
						[
							-81.82750491099995,
							30.31113501200008
						],
						[
							-81.82784990899995,
							30.311087012000087
						],
						[
							-81.8279179079999,
							30.31107301300006
						],
						[
							-81.82878190899993,
							30.310956013000066
						],
						[
							-81.82931991099991,
							30.310872012000058
						],
						[
							-81.82956290899995,
							30.310842013000073
						],
						[
							-81.82989690799991,
							30.31079301200009
						],
						[
							-81.8317009079999,
							30.310571012000082
						],
						[
							-81.83283790899993,
							30.310452013000088
						],
						[
							-81.8334369079999,
							30.310402012000058
						],
						[
							-81.83369390999991,
							30.31037501300006
						],
						[
							-81.8347409079999,
							30.31029601200004
						],
						[
							-81.83501391099992,
							30.31027301200004
						],
						[
							-81.83610391099995,
							30.310191012000075
						],
						[
							-81.83847790899995,
							30.310013012000073
						],
						[
							-81.84022490799993,
							30.30988301200006
						],
						[
							-81.8443189109999,
							30.30958501200007
						],
						[
							-81.84582890999991,
							30.30946901300007
						],
						[
							-81.84765690799992,
							30.30933301200008
						],
						[
							-81.84819991099994,
							30.30929301300006
						],
						[
							-81.84854890799994,
							30.309263013000074
						],
						[
							-81.8491169109999,
							30.309239012000035
						],
						[
							-81.84956390799994,
							30.309193012000037
						],
						[
							-81.84973891099992,
							30.309172012000094
						],
						[
							-81.85110090899991,
							30.309074012000053
						],
						[
							-81.85184190899992,
							30.309022013000064
						],
						[
							-81.85233090899993,
							30.309001013000056
						],
						[
							-81.85255091099992,
							30.30898701200005
						],
						[
							-81.85270791099992,
							30.30897801200007
						],
						[
							-81.85302390999993,
							30.30895301200007
						],
						[
							-81.85374391099992,
							30.30889301200006
						],
						[
							-81.85425790999994,
							30.308855013000084
						],
						[
							-81.85430591099993,
							30.30885001300004
						],
						[
							-81.85459791099993,
							30.308825012000057
						],
						[
							-81.85465890899991,
							30.308813013000076
						],
						[
							-81.8558239109999,
							30.308720012000034
						],
						[
							-81.85664685199993,
							30.308667013000047
						],
						[
							-81.85679098899993,
							30.309520018000057
						],
						[
							-81.85607090799994,
							30.31135101100006
						],
						[
							-81.85586490599991,
							30.312542010000076
						],
						[
							-81.85562190799993,
							30.313188010000093
						],
						[
							-81.85552173199994,
							30.313507008000045
						],
						[
							-81.8579469099999,
							30.321933011000056
						],
						[
							-81.85811190499993,
							30.322196011000074
						],
						[
							-81.8585159079999,
							30.323532011000058
						],
						[
							-81.85893290999991,
							30.32506801200009
						],
						[
							-81.85909590699993,
							30.325376010000074
						],
						[
							-81.85959390699992,
							30.326812010000083
						],
						[
							-81.85993482999993,
							30.328234046000038
						],
						[
							-81.86103390699992,
							30.329742011000064
						],
						[
							-81.86135890799994,
							30.33031201000006
						],
						[
							-81.86143407599991,
							30.330443072000033
						],
						[
							-81.86139190699993,
							30.330458011000076
						],
						[
							-81.86110692099993,
							30.33055693700004
						],
						[
							-81.86003090999992,
							30.33067101300009
						],
						[
							-81.85929890999996,
							30.330729012000063
						],
						[
							-81.8580629089999,
							30.33084101200006
						],
						[
							-81.85754390999995,
							30.330914013000044
						],
						[
							-81.85714690899994,
							30.330994012000076
						],
						[
							-81.85488090899992,
							30.331526013000083
						],
						[
							-81.85446890899993,
							30.331615013000093
						],
						[
							-81.85301990999996,
							30.33195501200004
						],
						[
							-81.8512799099999,
							30.332365012000082
						],
						[
							-81.85079990899993,
							30.332458012000075
						],
						[
							-81.85011290999996,
							30.33255401200006
						],
						[
							-81.8487819099999,
							30.332596012000067
						],
						[
							-81.8486489089999,
							30.332600012000057
						],
						[
							-81.84417290899995,
							30.332720012000035
						],
						[
							-81.84363890999992,
							30.332739011000058
						],
						[
							-81.8412629099999,
							30.33277901200006
						],
						[
							-81.83999390899993,
							30.332817012000078
						],
						[
							-81.83835390899992,
							30.332858012000084
						],
						[
							-81.83748390999995,
							30.332892012000062
						],
						[
							-81.83563790999995,
							30.332945012000042
						],
						[
							-81.83544290999993,
							30.332951012000077
						],
						[
							-81.83503790899994,
							30.332961013000045
						],
						[
							-81.83459390899992,
							30.332966012000043
						],
						[
							-81.83452390899993,
							30.33295901300005
						],
						[
							-81.83444990999993,
							30.332951012000077
						],
						[
							-81.83431190899995,
							30.332920013000038
						],
						[
							-81.83411393099993,
							30.332856951000053
						],
						[
							-81.8332829069999,
							30.33245901000004
						],
						[
							-81.83195990799993,
							30.331843011000043
						],
						[
							-81.83085990699993,
							30.331321010000067
						],
						[
							-81.83013290799994,
							30.330985011000056
						],
						[
							-81.82975190799993,
							30.330843011000074
						],
						[
							-81.8294299069999,
							30.33075001100008
						],
						[
							-81.82914890799994,
							30.33068801000007
						],
						[
							-81.82888190799991,
							30.330642011000066
						],
						[
							-81.8284639069999,
							30.330598011000063
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Whitehouse",
				"RegionID": "126644"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.24199966999998,
					25.941115663000065,
					-80.22928684699997,
					25.954161593000038
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.23383015899998,
							25.95265078700004
						],
						[
							-80.23378536399997,
							25.952136171000063
						],
						[
							-80.23377954499995,
							25.95199227100005
						],
						[
							-80.23377485999998,
							25.95187640900008
						],
						[
							-80.23376988499996,
							25.95175339800005
						],
						[
							-80.23364618299996,
							25.948694602000046
						],
						[
							-80.22961625799996,
							25.94884010900006
						],
						[
							-80.22935687499995,
							25.943026135000025
						],
						[
							-80.22933156899995,
							25.942482064000046
						],
						[
							-80.22928684699997,
							25.941538018000074
						],
						[
							-80.22973606699999,
							25.941512659000068
						],
						[
							-80.23082887399994,
							25.941487893000044
						],
						[
							-80.23188911299997,
							25.94146386500006
						],
						[
							-80.23965317599999,
							25.941213167000058
						],
						[
							-80.24130438199995,
							25.941115663000065
						],
						[
							-80.24131302299998,
							25.94122179200008
						],
						[
							-80.24180563999994,
							25.947272302000044
						],
						[
							-80.24193024999994,
							25.95158022800007
						],
						[
							-80.24197960899996,
							25.953286638000066
						],
						[
							-80.24198442399995,
							25.95347522800006
						],
						[
							-80.24199463599997,
							25.95391715200003
						],
						[
							-80.24199966999998,
							25.954128386000036
						],
						[
							-80.24116372199995,
							25.95415344500003
						],
						[
							-80.23741554799994,
							25.954161593000038
						],
						[
							-80.23746443799996,
							25.952515656000063
						],
						[
							-80.23433552799997,
							25.952564546000076
						],
						[
							-80.23391996899994,
							25.952654176000067
						],
						[
							-80.23383015899998,
							25.95265078700004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Gardens",
				"Name": "Crestview",
				"RegionID": "147067"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.25288899999998,
					28.548602000000077,
					-81.22351299999997,
					28.582277000000033
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.22356599999995,
							28.560119000000043
						],
						[
							-81.22355599999997,
							28.559992000000083
						],
						[
							-81.22354799999994,
							28.55822500000005
						],
						[
							-81.22353099999998,
							28.554151000000047
						],
						[
							-81.22352199999995,
							28.551889000000074
						],
						[
							-81.22351299999997,
							28.54984200000007
						],
						[
							-81.22464299999996,
							28.550018000000023
						],
						[
							-81.22518899999994,
							28.550016000000028
						],
						[
							-81.22545799999995,
							28.549940000000053
						],
						[
							-81.22584499999994,
							28.54983100000004
						],
						[
							-81.22690099999994,
							28.549372000000062
						],
						[
							-81.22813999999994,
							28.54899800000004
						],
						[
							-81.23027099999996,
							28.54872200000006
						],
						[
							-81.23158199999995,
							28.548681000000045
						],
						[
							-81.23178199999995,
							28.548680000000047
						],
						[
							-81.23556299999996,
							28.54865700000005
						],
						[
							-81.23974699999997,
							28.54861900000003
						],
						[
							-81.24207999999999,
							28.54861100000005
						],
						[
							-81.24218599999995,
							28.54861100000005
						],
						[
							-81.24444899999997,
							28.548602000000077
						],
						[
							-81.24458899999996,
							28.550279000000046
						],
						[
							-81.24458899999996,
							28.552118000000068
						],
						[
							-81.24458899999996,
							28.552860000000067
						],
						[
							-81.24458899999996,
							28.55387200000007
						],
						[
							-81.24458899999996,
							28.55457800000005
						],
						[
							-81.24458899999996,
							28.55547800000005
						],
						[
							-81.24458899999996,
							28.556278000000077
						],
						[
							-81.24458899999996,
							28.556778000000065
						],
						[
							-81.24459399999995,
							28.55701700000003
						],
						[
							-81.24462899999997,
							28.55869000000007
						],
						[
							-81.24468799999994,
							28.561578000000054
						],
						[
							-81.24468799999994,
							28.561978000000067
						],
						[
							-81.24468799999994,
							28.562178000000074
						],
						[
							-81.24468799999994,
							28.56247800000006
						],
						[
							-81.24468799999994,
							28.56275800000003
						],
						[
							-81.24468799999994,
							28.563078000000075
						],
						[
							-81.24468799999994,
							28.563478000000032
						],
						[
							-81.24470799999995,
							28.564577000000043
						],
						[
							-81.24478799999997,
							28.569078000000047
						],
						[
							-81.24708799999996,
							28.568878000000044
						],
						[
							-81.24748899999997,
							28.568878000000044
						],
						[
							-81.24858899999998,
							28.568778000000066
						],
						[
							-81.25018999999998,
							28.568659000000025
						],
						[
							-81.25128899999999,
							28.56857800000006
						],
						[
							-81.25138899999996,
							28.569778000000042
						],
						[
							-81.25188899999995,
							28.57177800000005
						],
						[
							-81.25228899999996,
							28.572778000000028
						],
						[
							-81.25288899999998,
							28.573078000000066
						],
						[
							-81.25258899999994,
							28.573478000000023
						],
						[
							-81.25238899999994,
							28.575078000000076
						],
						[
							-81.24948799999999,
							28.577478000000045
						],
						[
							-81.24868799999996,
							28.577778000000023
						],
						[
							-81.24798799999996,
							28.577878000000055
						],
						[
							-81.24758799999995,
							28.57857800000005
						],
						[
							-81.24788799999999,
							28.578778000000057
						],
						[
							-81.24718799999994,
							28.57917800000007
						],
						[
							-81.24648799999994,
							28.57887800000003
						],
						[
							-81.24578799999995,
							28.57887800000003
						],
						[
							-81.24538799999993,
							28.579378000000077
						],
						[
							-81.24498799999998,
							28.57917800000007
						],
						[
							-81.24418799999995,
							28.578978000000067
						],
						[
							-81.24348799999996,
							28.57917800000007
						],
						[
							-81.24018799999999,
							28.579878000000065
						],
						[
							-81.23868799999998,
							28.579778000000033
						],
						[
							-81.23788799999994,
							28.580178000000046
						],
						[
							-81.23598799999996,
							28.580977000000075
						],
						[
							-81.23488799999996,
							28.580877000000047
						],
						[
							-81.23368799999997,
							28.580977000000075
						],
						[
							-81.23318799999998,
							28.581377000000032
						],
						[
							-81.23228799999998,
							28.581977000000055
						],
						[
							-81.23198799999994,
							28.582277000000033
						],
						[
							-81.23158799999999,
							28.581377000000032
						],
						[
							-81.23118799999997,
							28.58017700000005
						],
						[
							-81.22428799999994,
							28.580277000000024
						],
						[
							-81.22422999999998,
							28.57759700000003
						],
						[
							-81.22418799999997,
							28.57567800000004
						],
						[
							-81.22414799999996,
							28.572854000000063
						],
						[
							-81.22408799999994,
							28.568678000000034
						],
						[
							-81.22359199999994,
							28.568564000000038
						],
						[
							-81.22356799999994,
							28.562812000000065
						],
						[
							-81.22356299999996,
							28.561689000000058
						],
						[
							-81.22357799999997,
							28.561323000000073
						],
						[
							-81.22356599999995,
							28.560119000000043
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Union Park",
				"RegionID": "34387"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.77320130599992,
					30.345352401000074,
					-81.71532738899992,
					30.374243010000043
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.75154090799992,
							30.374243010000043
						],
						[
							-81.7489399079999,
							30.37421001000007
						],
						[
							-81.74847379999994,
							30.374216166000053
						],
						[
							-81.74832190899991,
							30.373831011000053
						],
						[
							-81.7481769069999,
							30.37351201000007
						],
						[
							-81.74804690799994,
							30.37331401100005
						],
						[
							-81.74784090799994,
							30.373045010000055
						],
						[
							-81.7475919069999,
							30.37266801000004
						],
						[
							-81.74750290799994,
							30.37253401000004
						],
						[
							-81.74706990699991,
							30.37187801100003
						],
						[
							-81.74698890699995,
							30.37176501100004
						],
						[
							-81.74683690799992,
							30.371554011000057
						],
						[
							-81.74660890799993,
							30.371217011000052
						],
						[
							-81.7464219069999,
							30.370953010000047
						],
						[
							-81.74603890799995,
							30.370355011000072
						],
						[
							-81.7457209499999,
							30.36987682800009
						],
						[
							-81.74034693099992,
							30.373082090000086
						],
						[
							-81.73555688499994,
							30.37330514100006
						],
						[
							-81.73389689099992,
							30.372657819000043
						],
						[
							-81.73250782199995,
							30.37347088900009
						],
						[
							-81.73128690499995,
							30.37165900900004
						],
						[
							-81.72869390499994,
							30.368925009000066
						],
						[
							-81.72754190499991,
							30.367886008000088
						],
						[
							-81.72746290599991,
							30.367826008000065
						],
						[
							-81.72646390499995,
							30.36686700800004
						],
						[
							-81.71784890599992,
							30.360312007000065
						],
						[
							-81.71532738899992,
							30.35803357000009
						],
						[
							-81.7177369069999,
							30.358611011000047
						],
						[
							-81.71987990799994,
							30.35905801000007
						],
						[
							-81.7202989079999,
							30.35910006300009
						],
						[
							-81.72123482399991,
							30.35895807500009
						],
						[
							-81.72239590499993,
							30.358724009000074
						],
						[
							-81.72807690499991,
							30.357203009000045
						],
						[
							-81.72905090599994,
							30.35690100800008
						],
						[
							-81.73108156399991,
							30.356129858000088
						],
						[
							-81.73122190599992,
							30.356084008000035
						],
						[
							-81.73482690599991,
							30.35496000800003
						],
						[
							-81.73777490599991,
							30.353522009000077
						],
						[
							-81.74523666999994,
							30.350538104000066
						],
						[
							-81.74828990499992,
							30.349480009000047
						],
						[
							-81.75152890499993,
							30.348261008000065
						],
						[
							-81.7521019049999,
							30.348069009000085
						],
						[
							-81.76064990599991,
							30.34678900800009
						],
						[
							-81.7609409179999,
							30.346755097000088
						],
						[
							-81.76460290499995,
							30.346276009000064
						],
						[
							-81.77271990499992,
							30.345397009000067
						],
						[
							-81.77320130599992,
							30.345352401000074
						],
						[
							-81.77314280399992,
							30.363253048000047
						],
						[
							-81.77092090899993,
							30.361756818000064
						],
						[
							-81.76447990699995,
							30.36585800800009
						],
						[
							-81.76117190799994,
							30.36685901000004
						],
						[
							-81.76086374999994,
							30.36698790600008
						],
						[
							-81.76090990699993,
							30.372087065000077
						],
						[
							-81.76028390699992,
							30.37207701000005
						],
						[
							-81.75950290799994,
							30.372067010000084
						],
						[
							-81.75730090799993,
							30.372050010000066
						],
						[
							-81.7568359089999,
							30.37204401000008
						],
						[
							-81.75665290799992,
							30.372051011000057
						],
						[
							-81.75651590799993,
							30.372080011000037
						],
						[
							-81.75635490799995,
							30.372129011000084
						],
						[
							-81.75593590699992,
							30.372332010000036
						],
						[
							-81.75261690799994,
							30.374081011000044
						],
						[
							-81.7524109069999,
							30.374174009000058
						],
						[
							-81.7522739069999,
							30.374216010000055
						],
						[
							-81.7521129079999,
							30.37423901000005
						],
						[
							-81.75154090799992,
							30.374243010000043
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Biltmore",
				"RegionID": "123667"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.69557332199992,
					27.72451480600006,
					-82.68134031099993,
					27.734581500000047
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.6918169999999,
							27.73396000000008
						],
						[
							-82.6918946269999,
							27.733940000000075
						],
						[
							-82.69096469599992,
							27.733940000000075
						],
						[
							-82.69072749199995,
							27.733940000000075
						],
						[
							-82.69043999999991,
							27.733940000000075
						],
						[
							-82.69033806099992,
							27.73393745200008
						],
						[
							-82.69016831199991,
							27.733933208000053
						],
						[
							-82.6900399999999,
							27.733930000000043
						],
						[
							-82.69002999999992,
							27.733800000000087
						],
						[
							-82.68991436699991,
							27.733792992000076
						],
						[
							-82.68972765099994,
							27.733781676000035
						],
						[
							-82.68950769299995,
							27.733774658000073
						],
						[
							-82.68932099199992,
							27.733769472000063
						],
						[
							-82.68896546099995,
							27.733759596000088
						],
						[
							-82.68877876099994,
							27.733754410000074
						],
						[
							-82.68854183199994,
							27.733750000000043
						],
						[
							-82.68826999999993,
							27.733750000000043
						],
						[
							-82.68805047899991,
							27.733744646000048
						],
						[
							-82.68785999999994,
							27.73374000000007
						],
						[
							-82.68771182499995,
							27.733736296000075
						],
						[
							-82.6875928739999,
							27.733733322000035
						],
						[
							-82.68745999999993,
							27.733730000000037
						],
						[
							-82.68708472499992,
							27.733730000000037
						],
						[
							-82.68669503299992,
							27.733730000000037
						],
						[
							-82.6864799999999,
							27.733730000000037
						],
						[
							-82.68608508099993,
							27.733730000000037
						],
						[
							-82.68574621899995,
							27.733730000000037
						],
						[
							-82.68549999999993,
							27.733730000000037
						],
						[
							-82.68530569899991,
							27.733730000000037
						],
						[
							-82.68509999999992,
							27.733730000000037
						],
						[
							-82.6849329499999,
							27.733730000000037
						],
						[
							-82.68471268999991,
							27.733730000000037
						],
						[
							-82.6844999999999,
							27.733730000000037
						],
						[
							-82.68411968099991,
							27.733730000000037
						],
						[
							-82.68379776199993,
							27.733730000000037
						],
						[
							-82.6833499999999,
							27.733730000000037
						],
						[
							-82.68333863299995,
							27.733593591000044
						],
						[
							-82.6833299999999,
							27.733490000000074
						],
						[
							-82.68331485399995,
							27.733420762000037
						],
						[
							-82.6832885469999,
							27.733300502000077
						],
						[
							-82.68324284099992,
							27.73310400300005
						],
						[
							-82.6832107379999,
							27.732980532000056
						],
						[
							-82.68316625699993,
							27.73280945100004
						],
						[
							-82.68311588899991,
							27.73262766600004
						],
						[
							-82.6830475299999,
							27.73245938900004
						],
						[
							-82.68297599599993,
							27.73232585900007
						],
						[
							-82.68288263499996,
							27.732168952000052
						],
						[
							-82.6827775559999,
							27.73203641100008
						],
						[
							-82.68268132999992,
							27.731928913000047
						],
						[
							-82.68259975399991,
							27.731842239000063
						],
						[
							-82.68251335199994,
							27.73174258800009
						],
						[
							-82.68244649699994,
							27.731660304000062
						],
						[
							-82.68232884299994,
							27.73149286200004
						],
						[
							-82.68224149399992,
							27.73134714300005
						],
						[
							-82.68218999999993,
							27.731260000000077
						],
						[
							-82.68213974899993,
							27.731159499000057
						],
						[
							-82.6820651999999,
							27.73101039900007
						],
						[
							-82.68201999999991,
							27.73087000000004
						],
						[
							-82.68198074499992,
							27.730729804000077
						],
						[
							-82.68194491499992,
							27.730591188000062
						],
						[
							-82.68191780199993,
							27.730423619000078
						],
						[
							-82.68190506499991,
							27.730270780000073
						],
						[
							-82.68189999999993,
							27.730210000000056
						],
						[
							-82.68189999999993,
							27.730101760000082
						],
						[
							-82.68189784899994,
							27.729983209000068
						],
						[
							-82.68189520599992,
							27.72986429000008
						],
						[
							-82.68189257199992,
							27.729745747000038
						],
						[
							-82.6818899999999,
							27.729630000000043
						],
						[
							-82.68188558599991,
							27.72945786100007
						],
						[
							-82.68187673299991,
							27.729221883000037
						],
						[
							-82.6818614039999,
							27.729136877000087
						],
						[
							-82.68183719799993,
							27.729002642000072
						],
						[
							-82.68180949899994,
							27.728849038000078
						],
						[
							-82.68178475899992,
							27.728711844000088
						],
						[
							-82.68175528699993,
							27.72854172100006
						],
						[
							-82.68174929799996,
							27.72840743800009
						],
						[
							-82.68174616399995,
							27.727949996000063
						],
						[
							-82.68174245099993,
							27.727407842000048
						],
						[
							-82.68174013099991,
							27.727069112000038
						],
						[
							-82.68172535299995,
							27.726951135000036
						],
						[
							-82.68170815999991,
							27.726835081000047
						],
						[
							-82.68168919599992,
							27.726749747000042
						],
						[
							-82.68165316299991,
							27.726648855000064
						],
						[
							-82.68159650299992,
							27.726559755000043
						],
						[
							-82.68152999999995,
							27.72646000000009
						],
						[
							-82.68148193299993,
							27.72638134600004
						],
						[
							-82.68146224899994,
							27.726349135000078
						],
						[
							-82.68141829799993,
							27.72627532000007
						],
						[
							-82.68137999999993,
							27.72617000000008
						],
						[
							-82.68137356499994,
							27.726086347000034
						],
						[
							-82.68136328999992,
							27.725883425000063
						],
						[
							-82.68135818499991,
							27.725764315000053
						],
						[
							-82.68135021199993,
							27.72557828300006
						],
						[
							-82.68134267799991,
							27.725402486000064
						],
						[
							-82.68134031099993,
							27.72528217300004
						],
						[
							-82.68134224999994,
							27.72492156700008
						],
						[
							-82.68134321899993,
							27.724741263000055
						],
						[
							-82.68175047199992,
							27.72474683900009
						],
						[
							-82.68174999999991,
							27.72477900000007
						],
						[
							-82.68225086799993,
							27.72451480600006
						],
						[
							-82.6840616309999,
							27.72451480600006
						],
						[
							-82.68661199999991,
							27.72451480600006
						],
						[
							-82.6911006489999,
							27.72451480600006
						],
						[
							-82.69150135799993,
							27.72451480600006
						],
						[
							-82.69451814399991,
							27.72451480600006
						],
						[
							-82.69510472899992,
							27.724693331000083
						],
						[
							-82.69555867999992,
							27.725015148000068
						],
						[
							-82.69557332199992,
							27.72517600000009
						],
						[
							-82.69557332199992,
							27.72524700000008
						],
						[
							-82.6955596599999,
							27.725403166000035
						],
						[
							-82.6955197339999,
							27.725552803000085
						],
						[
							-82.69545540999991,
							27.72573069500004
						],
						[
							-82.69542836099993,
							27.725796916000036
						],
						[
							-82.6953961339999,
							27.725860777000037
						],
						[
							-82.69535893299991,
							27.725921876000086
						],
						[
							-82.69531699399994,
							27.725979824000035
						],
						[
							-82.69527058199992,
							27.726034256000048
						],
						[
							-82.69521999099993,
							27.72608482600009
						],
						[
							-82.6950509909999,
							27.726240826000037
						],
						[
							-82.69499473799993,
							27.72628862900007
						],
						[
							-82.69493475299993,
							27.72633165700006
						],
						[
							-82.69487144199991,
							27.72636962000007
						],
						[
							-82.69480522899994,
							27.72640226200008
						],
						[
							-82.69473656299994,
							27.726429363000083
						],
						[
							-82.69466590499991,
							27.726450741000065
						],
						[
							-82.69459373199993,
							27.726466251000094
						],
						[
							-82.69429329999991,
							27.72651684300007
						],
						[
							-82.69414972899995,
							27.726529304000053
						],
						[
							-82.69390146799992,
							27.726530885000045
						],
						[
							-82.69391859799993,
							27.72705122800005
						],
						[
							-82.69395937899992,
							27.72788494200006
						],
						[
							-82.69400751199993,
							27.729017832000068
						],
						[
							-82.69400832199995,
							27.72905600000007
						],
						[
							-82.69400832199995,
							27.72910044300005
						],
						[
							-82.69405845099993,
							27.72916043200007
						],
						[
							-82.69410305999992,
							27.72922463200007
						],
						[
							-82.69414179699993,
							27.72929253700005
						],
						[
							-82.69417435699995,
							27.729363610000064
						],
						[
							-82.69420048299993,
							27.729437292000057
						],
						[
							-82.69428148299994,
							27.729700293000064
						],
						[
							-82.69430765999994,
							27.729808835000085
						],
						[
							-82.69432040499993,
							27.729924397000048
						],
						[
							-82.69432840499991,
							27.730101397000055
						],
						[
							-82.69432932199993,
							27.730142000000058
						],
						[
							-82.69432059299993,
							27.730266995000083
						],
						[
							-82.69430459299991,
							27.730380995000075
						],
						[
							-82.69429148799992,
							27.73045296400005
						],
						[
							-82.69427257699994,
							27.73052363000005
						],
						[
							-82.69424798499995,
							27.730592526000066
						],
						[
							-82.69421787399995,
							27.730659195000047
						],
						[
							-82.69418244499991,
							27.730723196000042
						],
						[
							-82.69414193199992,
							27.730784106000044
						],
						[
							-82.69395693199994,
							27.731039106000082
						],
						[
							-82.69391792099992,
							27.731089073000078
						],
						[
							-82.69383777599995,
							27.731172946000072
						],
						[
							-82.69358877499991,
							27.731401946000062
						],
						[
							-82.6935580729999,
							27.731428921000088
						],
						[
							-82.69342966099993,
							27.731518836000077
						],
						[
							-82.69328758599994,
							27.731585086000052
						],
						[
							-82.69313616499994,
							27.731625659000088
						],
						[
							-82.6930922219999,
							27.731632327000057
						],
						[
							-82.69316983599992,
							27.73174933900009
						],
						[
							-82.69321697299995,
							27.73184326200004
						],
						[
							-82.69330397199992,
							27.732045262000042
						],
						[
							-82.69335266099995,
							27.732191841000088
						],
						[
							-82.69341866199994,
							27.732467841000073
						],
						[
							-82.69342965999994,
							27.732520835000063
						],
						[
							-82.69344227399995,
							27.732633590000034
						],
						[
							-82.69345527399992,
							27.732902590000037
						],
						[
							-82.69345060099994,
							27.733047274000057
						],
						[
							-82.69343360199991,
							27.733197274000077
						],
						[
							-82.69342748899993,
							27.733241410000062
						],
						[
							-82.6933975739999,
							27.73342378800004
						],
						[
							-82.69335608599994,
							27.733580586000073
						],
						[
							-82.69334906699993,
							27.73359922700007
						],
						[
							-82.69323306699994,
							27.733897227000057
						],
						[
							-82.69320961499994,
							27.733952028000093
						],
						[
							-82.69315161499992,
							27.734076029000054
						],
						[
							-82.69311695699992,
							27.73414271300004
						],
						[
							-82.69307685299992,
							27.734206271000062
						],
						[
							-82.69303158199995,
							27.734266258000048
						],
						[
							-82.69298146099993,
							27.734322256000045
						],
						[
							-82.69292683999993,
							27.734373874000084
						],
						[
							-82.6927379569999,
							27.734537897000052
						],
						[
							-82.69267627699992,
							27.734581500000047
						],
						[
							-82.6918169999999,
							27.73396000000008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Broadwater",
				"RegionID": "123765"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.13659440299995,
					26.245757188000084,
					-80.13418534199991,
					26.249491096000042
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.1342335679999,
							26.24949107000009
						],
						[
							-80.13418534199991,
							26.245804279000083
						],
						[
							-80.13658269899992,
							26.245757188000084
						],
						[
							-80.13659440299995,
							26.249491096000042
						],
						[
							-80.1342335679999,
							26.24949107000009
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Pompano Beach",
				"Name": "Canal Point",
				"RegionID": "123840"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.77468409199992,
					30.248334008000086,
					-81.74005073399991,
					30.270254007000062
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.7473749049999,
							30.262758008000052
						],
						[
							-81.7473530339999,
							30.262191874000052
						],
						[
							-81.74385790499991,
							30.26226600800004
						],
						[
							-81.74278290599995,
							30.262283008000058
						],
						[
							-81.74134090599995,
							30.26230800900004
						],
						[
							-81.74121090499995,
							30.262300008000068
						],
						[
							-81.74107390599994,
							30.262285008000052
						],
						[
							-81.74092890599991,
							30.262255008000068
						],
						[
							-81.7403259059999,
							30.262053009000056
						],
						[
							-81.74005073399991,
							30.26194407500009
						],
						[
							-81.74031890599993,
							30.261402008000058
						],
						[
							-81.74084896799991,
							30.260302011000082
						],
						[
							-81.74095190499992,
							30.260109010000065
						],
						[
							-81.74117290499993,
							30.259624008000056
						],
						[
							-81.7414929059999,
							30.25896100800008
						],
						[
							-81.7416999049999,
							30.258483009000088
						],
						[
							-81.74204990499993,
							30.257727008000074
						],
						[
							-81.74216490499992,
							30.257418009000048
						],
						[
							-81.7422639049999,
							30.257101009000053
						],
						[
							-81.7423779049999,
							30.256794008000046
						],
						[
							-81.7425359049999,
							30.256260009000076
						],
						[
							-81.7426449059999,
							30.25585000900008
						],
						[
							-81.7427139049999,
							30.25553500800004
						],
						[
							-81.74279790499992,
							30.255219008000036
						],
						[
							-81.74283590699991,
							30.254906008000034
						],
						[
							-81.74290490499993,
							30.254595008000084
						],
						[
							-81.74294290499995,
							30.25428400800007
						],
						[
							-81.74301890499993,
							30.25365800900005
						],
						[
							-81.74303390599995,
							30.25344300800009
						],
						[
							-81.7430499059999,
							30.253033008000045
						],
						[
							-81.74305690599994,
							30.252518008000038
						],
						[
							-81.74307290599995,
							30.252047009000083
						],
						[
							-81.74306490499993,
							30.251467008000073
						],
						[
							-81.74307290599995,
							30.25115600900006
						],
						[
							-81.74305690599994,
							30.25023700800006
						],
						[
							-81.74306490499993,
							30.249325008000085
						],
						[
							-81.74305690599994,
							30.248987009000075
						],
						[
							-81.74306107599995,
							30.24867096100007
						],
						[
							-81.7429477359999,
							30.24849605500009
						],
						[
							-81.74294890399995,
							30.248420954000043
						],
						[
							-81.74306492399995,
							30.248419098000056
						],
						[
							-81.74318090499992,
							30.248417009000036
						],
						[
							-81.74359890599995,
							30.248411008000065
						],
						[
							-81.74406390599997,
							30.248417009000036
						],
						[
							-81.74636790599993,
							30.24840500800008
						],
						[
							-81.74726890599993,
							30.248404008000083
						],
						[
							-81.74913790599993,
							30.248390008000058
						],
						[
							-81.7499159059999,
							30.248394008000048
						],
						[
							-81.75096090499994,
							30.248388008000063
						],
						[
							-81.75181590599993,
							30.248384008000073
						],
						[
							-81.75221990599995,
							30.24838100800008
						],
						[
							-81.75290690599991,
							30.24837300800004
						],
						[
							-81.75340290499992,
							30.248379008000086
						],
						[
							-81.75515690499992,
							30.24836900800005
						],
						[
							-81.75633990599994,
							30.248363008000073
						],
						[
							-81.75760690599992,
							30.248388008000063
						],
						[
							-81.75870190599994,
							30.248353008000038
						],
						[
							-81.75960502899994,
							30.248445144000076
						],
						[
							-81.75960477299992,
							30.248351874000036
						],
						[
							-81.75981890599991,
							30.248354008000035
						],
						[
							-81.76017790599991,
							30.248346008000055
						],
						[
							-81.76060490499992,
							30.248343008000063
						],
						[
							-81.76069592899995,
							30.248342878000074
						],
						[
							-81.76079190599995,
							30.248386008000068
						],
						[
							-81.7608248969999,
							30.248396060000065
						],
						[
							-81.76190190599993,
							30.248401009000073
						],
						[
							-81.76237690499994,
							30.248383008000076
						],
						[
							-81.76274090599992,
							30.248392008000053
						],
						[
							-81.76302590599994,
							30.248392008000053
						],
						[
							-81.76338090599995,
							30.248383008000076
						],
						[
							-81.76388590599993,
							30.24838100800008
						],
						[
							-81.76428990599993,
							30.24838100800008
						],
						[
							-81.76451190599994,
							30.248384008000073
						],
						[
							-81.76540190499992,
							30.248390008000058
						],
						[
							-81.76633090599995,
							30.248397009000083
						],
						[
							-81.76715990499991,
							30.248403008000086
						],
						[
							-81.76740090599992,
							30.24840900800007
						],
						[
							-81.7678179049999,
							30.248402008000088
						],
						[
							-81.76825590599992,
							30.248399008000035
						],
						[
							-81.7690329049999,
							30.248391008000056
						],
						[
							-81.7692779059999,
							30.248388008000063
						],
						[
							-81.76947690499992,
							30.248388008000063
						],
						[
							-81.77044790499991,
							30.24835200800004
						],
						[
							-81.77072490499995,
							30.248354008000035
						],
						[
							-81.77109890499992,
							30.248346008000055
						],
						[
							-81.77168090499993,
							30.248342008000066
						],
						[
							-81.77219890599991,
							30.248334008000086
						],
						[
							-81.77271290599992,
							30.248346008000055
						],
						[
							-81.77305195899993,
							30.248347007000064
						],
						[
							-81.77304890599993,
							30.248840008000055
						],
						[
							-81.77305790499992,
							30.250120008000067
						],
						[
							-81.77306790499995,
							30.250245009000082
						],
						[
							-81.77309190599993,
							30.251255008000044
						],
						[
							-81.7731079049999,
							30.252252009000074
						],
						[
							-81.77312890499991,
							30.25379800800005
						],
						[
							-81.77314690499993,
							30.254575008000074
						],
						[
							-81.77315890599994,
							30.255333008000036
						],
						[
							-81.77316890499992,
							30.255926009000063
						],
						[
							-81.7731929059999,
							30.257006008000076
						],
						[
							-81.77320390599994,
							30.25766600900005
						],
						[
							-81.77320990599992,
							30.25808100800009
						],
						[
							-81.7732189059999,
							30.258532008000092
						],
						[
							-81.77323690599991,
							30.259359008000047
						],
						[
							-81.77325790599991,
							30.260483009000044
						],
						[
							-81.77327490599993,
							30.261211008000085
						],
						[
							-81.7732927269999,
							30.262487073000045
						],
						[
							-81.77468409199992,
							30.26429197400006
						],
						[
							-81.77344890599994,
							30.268358009000057
						],
						[
							-81.7733660429999,
							30.26863311400007
						],
						[
							-81.77312290499992,
							30.268791009000036
						],
						[
							-81.7728129059999,
							30.26900500800008
						],
						[
							-81.77271290599992,
							30.269079009000052
						],
						[
							-81.77250490499995,
							30.269288012000064
						],
						[
							-81.77239290599994,
							30.269468009000036
						],
						[
							-81.77232790599994,
							30.26957200900006
						],
						[
							-81.7722359679999,
							30.26976109700007
						],
						[
							-81.77191190499991,
							30.269768008000085
						],
						[
							-81.77097090599996,
							30.269793008000075
						],
						[
							-81.76960790599992,
							30.269817009000068
						],
						[
							-81.7688099049999,
							30.269814008000083
						],
						[
							-81.76792090499993,
							30.26985400800004
						],
						[
							-81.76742092199993,
							30.26985392100005
						],
						[
							-81.76713890499991,
							30.26987500900009
						],
						[
							-81.7669379049999,
							30.269876009000086
						],
						[
							-81.76663690599992,
							30.26988500800007
						],
						[
							-81.76597090599995,
							30.269895009000038
						],
						[
							-81.7658539059999,
							30.269897009000093
						],
						[
							-81.76466090499993,
							30.26992300800004
						],
						[
							-81.76431290399995,
							30.269926061000035
						],
						[
							-81.76429690599991,
							30.269077009000057
						],
						[
							-81.76429690599991,
							30.26880300800008
						],
						[
							-81.76429690599991,
							30.26825100800005
						],
						[
							-81.76428990499994,
							30.267714008000045
						],
						[
							-81.76428990499994,
							30.26742700900007
						],
						[
							-81.76428190599995,
							30.266600009000058
						],
						[
							-81.76427490599991,
							30.265785009000073
						],
						[
							-81.76427190499993,
							30.265531008000035
						],
						[
							-81.76426690599993,
							30.265345008000054
						],
						[
							-81.76424190499995,
							30.264032008000072
						],
						[
							-81.76419190399992,
							30.26364900800007
						],
						[
							-81.76417390699993,
							30.263582005000046
						],
						[
							-81.76417390499995,
							30.26354501100008
						],
						[
							-81.76413890499992,
							30.263410008000054
						],
						[
							-81.76381590499996,
							30.262497008000082
						],
						[
							-81.7636989049999,
							30.26219700800004
						],
						[
							-81.76284790599993,
							30.259817008000084
						],
						[
							-81.76278390599992,
							30.259572008000074
						],
						[
							-81.76276690599992,
							30.259394008000072
						],
						[
							-81.7627699059999,
							30.25912100800008
						],
						[
							-81.76278790599991,
							30.25901701000004
						],
						[
							-81.76280203699991,
							30.258983032000064
						],
						[
							-81.7628017749999,
							30.258949985000076
						],
						[
							-81.76281603699994,
							30.258916031000066
						],
						[
							-81.76281577399993,
							30.258881985000073
						],
						[
							-81.76290490499991,
							30.25864300900008
						],
						[
							-81.76297590699994,
							30.25849000900007
						],
						[
							-81.76317090599991,
							30.258205008000065
						],
						[
							-81.7634229059999,
							30.257877009000083
						],
						[
							-81.7635149059999,
							30.25776700900008
						],
						[
							-81.76400490599991,
							30.25723700800006
						],
						[
							-81.76417890499994,
							30.257007008000073
						],
						[
							-81.76424990499993,
							30.256876008000063
						],
						[
							-81.76435390599994,
							30.256607008000064
						],
						[
							-81.76441890599995,
							30.256348009000078
						],
						[
							-81.7644639049999,
							30.25611200800006
						],
						[
							-81.76449390599993,
							30.25587800900007
						],
						[
							-81.76450390499991,
							30.255620009000037
						],
						[
							-81.76451303699992,
							30.253325881000077
						],
						[
							-81.7585217749999,
							30.252925874000088
						],
						[
							-81.75852190599994,
							30.253962008000087
						],
						[
							-81.75852190599994,
							30.25455700800006
						],
						[
							-81.75850690599992,
							30.255106008000045
						],
						[
							-81.7584919059999,
							30.255640009000047
						],
						[
							-81.75846890499992,
							30.25741600800006
						],
						[
							-81.75849190499991,
							30.25770600800007
						],
						[
							-81.75848390599992,
							30.258047008000062
						],
						[
							-81.75847590599994,
							30.258865008000047
						],
						[
							-81.75846890499992,
							30.259697009000032
						],
						[
							-81.75846103299995,
							30.259802146000087
						],
						[
							-81.75549290599992,
							30.25977300800008
						],
						[
							-81.75482885799994,
							30.259774839000045
						],
						[
							-81.7545319059999,
							30.259983008000066
						],
						[
							-81.75414990599995,
							30.260269008000083
						],
						[
							-81.7533869049999,
							30.26082400900009
						],
						[
							-81.75264690599994,
							30.26137000900008
						],
						[
							-81.75215090599994,
							30.26174000900005
						],
						[
							-81.75202173799994,
							30.261859935000075
						],
						[
							-81.75202190499994,
							30.261972008000043
						],
						[
							-81.75196790799993,
							30.26228100700007
						],
						[
							-81.75199090599995,
							30.262915009000043
						],
						[
							-81.75207490499992,
							30.266117008000037
						],
						[
							-81.75208990599992,
							30.266579008000065
						],
						[
							-81.75208990599992,
							30.266878009000038
						],
						[
							-81.7521209059999,
							30.267735008000045
						],
						[
							-81.75213590499993,
							30.268692008000073
						],
						[
							-81.75215090599994,
							30.26896100900007
						],
						[
							-81.75215890599992,
							30.269421008000048
						],
						[
							-81.75218190399994,
							30.27017406200008
						],
						[
							-81.7513579049999,
							30.27018900900004
						],
						[
							-81.7491529049999,
							30.270226008000066
						],
						[
							-81.74851190599992,
							30.270235008000043
						],
						[
							-81.74757385099991,
							30.270254007000062
						],
						[
							-81.74751290499995,
							30.26801300900007
						],
						[
							-81.7474819059999,
							30.26692400800005
						],
						[
							-81.74740590599993,
							30.263884008000044
						],
						[
							-81.7473749049999,
							30.263002008000058
						],
						[
							-81.7473749049999,
							30.262758008000052
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Cedar Hills",
				"RegionID": "123890"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.1185410679999,
					26.137822690000064,
					-80.10415183899994,
					26.167553206000036
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.10415183899994,
							26.16749903100009
						],
						[
							-80.10425737799994,
							26.166258949000053
						],
						[
							-80.10442163899995,
							26.16464919200007
						],
						[
							-80.1044873429999,
							26.163597921000076
						],
						[
							-80.10453878399994,
							26.163014931000077
						],
						[
							-80.1045858999999,
							26.162480947000063
						],
						[
							-80.10465160399991,
							26.161232563000056
						],
						[
							-80.10478301299992,
							26.160378406000063
						],
						[
							-80.10481586499992,
							26.159294284000058
						],
						[
							-80.10494727399993,
							26.158374422000065
						],
						[
							-80.10507868299993,
							26.157553118000067
						],
						[
							-80.10530864799995,
							26.15640329100006
						],
						[
							-80.10550576199995,
							26.155286316000062
						],
						[
							-80.10567002199991,
							26.15436645500006
						],
						[
							-80.10589998799992,
							26.153709411000083
						],
						[
							-80.10619565799993,
							26.153150923000055
						],
						[
							-80.10636800399993,
							26.152886659000046
						],
						[
							-80.10668844099992,
							26.152395323000064
						],
						[
							-80.10737833699994,
							26.151311201000055
						],
						[
							-80.10793682399992,
							26.150457043000074
						],
						[
							-80.10829819799994,
							26.149800000000084
						],
						[
							-80.10790397199992,
							26.14848591200007
						],
						[
							-80.10744404099995,
							26.146777598000085
						],
						[
							-80.10701696199993,
							26.14503643100005
						],
						[
							-80.10688555399992,
							26.144313683000064
						],
						[
							-80.10688555399992,
							26.14385375200004
						],
						[
							-80.10701696199993,
							26.143032447000053
						],
						[
							-80.10756614999991,
							26.14280816700006
						],
						[
							-80.10791095499991,
							26.142666853000037
						],
						[
							-80.10797897399993,
							26.142642123000087
						],
						[
							-80.1080487609999,
							26.14262294400004
						],
						[
							-80.10811986499994,
							26.14260943800008
						],
						[
							-80.1081918239999,
							26.142601693000074
						],
						[
							-80.10826417299995,
							26.142599760000053
						],
						[
							-80.10833644299994,
							26.14260365100006
						],
						[
							-80.10840816599995,
							26.142613340000082
						],
						[
							-80.10856270399995,
							26.142655061000085
						],
						[
							-80.10895959999993,
							26.14280283700009
						],
						[
							-80.1091027199999,
							26.142810976000078
						],
						[
							-80.1092258409999,
							26.14277824800007
						],
						[
							-80.1093514129999,
							26.142698858000074
						],
						[
							-80.10940113699992,
							26.142669609000052
						],
						[
							-80.1097083489999,
							26.14250192800006
						],
						[
							-80.10974469399991,
							26.14244732900005
						],
						[
							-80.10980182999992,
							26.14228354200009
						],
						[
							-80.10982827399994,
							26.142113325000086
						],
						[
							-80.10978548299994,
							26.14214300100008
						],
						[
							-80.10972691599994,
							26.142182699000045
						],
						[
							-80.10966540899994,
							26.142217670000036
						],
						[
							-80.10960134399994,
							26.142247697000073
						],
						[
							-80.1095351159999,
							26.142272596000055
						],
						[
							-80.10946713599994,
							26.14229221100004
						],
						[
							-80.10939813599992,
							26.142309210000064
						],
						[
							-80.10933916599993,
							26.142321659000064
						],
						[
							-80.10920169799994,
							26.14233512800007
						],
						[
							-80.1080863489999,
							26.142358225000066
						],
						[
							-80.10802175999993,
							26.14235901400008
						],
						[
							-80.10795736199992,
							26.142353977000084
						],
						[
							-80.10789368099995,
							26.14234315500005
						],
						[
							-80.10783123499994,
							26.142326635000074
						],
						[
							-80.10777053299995,
							26.142304553000088
						],
						[
							-80.10754259799995,
							26.14191547300004
						],
						[
							-80.1075097449999,
							26.141291281000065
						],
						[
							-80.10787111999991,
							26.140207159000056
						],
						[
							-80.10816678899994,
							26.139681524000082
						],
						[
							-80.10855478999991,
							26.139325856000085
						],
						[
							-80.1085910779999,
							26.139315945000078
						],
						[
							-80.10855431199991,
							26.13929199300009
						],
						[
							-80.10839675499994,
							26.138630253000088
						],
						[
							-80.10835546699991,
							26.138155442000084
						],
						[
							-80.1088718339999,
							26.13813963000007
						],
						[
							-80.1090024589999,
							26.138133293000067
						],
						[
							-80.10931927099995,
							26.138117252000086
						],
						[
							-80.1096599999999,
							26.138100000000065
						],
						[
							-80.10982732299993,
							26.138095817000078
						],
						[
							-80.11004424899994,
							26.138090394000074
						],
						[
							-80.11044917599992,
							26.138080271000035
						],
						[
							-80.11085999999995,
							26.138070000000084
						],
						[
							-80.11118728399993,
							26.138067482000054
						],
						[
							-80.11159255199993,
							26.138064365000048
						],
						[
							-80.11196887999995,
							26.138061470000082
						],
						[
							-80.1121599999999,
							26.138060000000053
						],
						[
							-80.11230195999991,
							26.138055885000085
						],
						[
							-80.1125043799999,
							26.138050018000058
						],
						[
							-80.11284999999992,
							26.13804000000005
						],
						[
							-80.11305422599992,
							26.138033748000055
						],
						[
							-80.11332846999996,
							26.138025353000046
						],
						[
							-80.11361894099991,
							26.138016461000063
						],
						[
							-80.11396591399995,
							26.138005839000073
						],
						[
							-80.11451572899995,
							26.13798900800009
						],
						[
							-80.11480999999992,
							26.137980000000084
						],
						[
							-80.11493499799991,
							26.137976287000072
						],
						[
							-80.11512295099993,
							26.137970704000054
						],
						[
							-80.11547037199995,
							26.137960385000042
						],
						[
							-80.1158177929999,
							26.137950066000087
						],
						[
							-80.11617948299994,
							26.137923123000064
						],
						[
							-80.11655362999994,
							26.137895149000087
						],
						[
							-80.1168899999999,
							26.137870000000078
						],
						[
							-80.1170050049999,
							26.137865400000067
						],
						[
							-80.11723616599994,
							26.137856101000068
						],
						[
							-80.11767016199991,
							26.137838507000083
						],
						[
							-80.11788299999995,
							26.137830000000065
						],
						[
							-80.11816177299994,
							26.137822690000064
						],
						[
							-80.11797251699994,
							26.138255274000073
						],
						[
							-80.11794440799991,
							26.13864880400007
						],
						[
							-80.11788818899993,
							26.139267207000046
						],
						[
							-80.11816928199994,
							26.139773173000037
						],
						[
							-80.11828171899994,
							26.140504013000054
						],
						[
							-80.11828171899994,
							26.141347290000056
						],
						[
							-80.11814117299991,
							26.141881365000074
						],
						[
							-80.11791629899994,
							26.142527878000067
						],
						[
							-80.11752276899995,
							26.14331493600008
						],
						[
							-80.11707302199994,
							26.144101995000085
						],
						[
							-80.1167076019999,
							26.144804726000075
						],
						[
							-80.11645461899991,
							26.14539501900009
						],
						[
							-80.11622974499994,
							26.14609775000008
						],
						[
							-80.11608919899994,
							26.146659935000063
						],
						[
							-80.11608919899994,
							26.147066477000067
						],
						[
							-80.11608919899994,
							26.14713779200008
						],
						[
							-80.11622974499994,
							26.147896741000068
						],
						[
							-80.11625785399991,
							26.148571363000087
						],
						[
							-80.1161173079999,
							26.149161657000036
						],
						[
							-80.1158643249999,
							26.149836278000066
						],
						[
							-80.11547079499991,
							26.150539009000056
						],
						[
							-80.11513348499994,
							26.15146661400007
						],
						[
							-80.11488050199995,
							26.152338000000046
						],
						[
							-80.11473995499995,
							26.15287207500006
						],
						[
							-80.11468373699995,
							26.153181277000044
						],
						[
							-80.11437453499991,
							26.153518588000054
						],
						[
							-80.11406533399992,
							26.154024554000046
						],
						[
							-80.11389667799995,
							26.154502411000067
						],
						[
							-80.11381235099992,
							26.154839722000077
						],
						[
							-80.11384045999996,
							26.15514892300007
						],
						[
							-80.11412155199993,
							26.155261360000054
						],
						[
							-80.11451508099992,
							26.15531757900004
						],
						[
							-80.11479617399993,
							26.15531757900004
						],
						[
							-80.1152740309999,
							26.15517703200004
						],
						[
							-80.11530213999993,
							26.15565488900006
						],
						[
							-80.11521781199993,
							26.15602030900004
						],
						[
							-80.11504915699993,
							26.156245183000067
						],
						[
							-80.11485239199993,
							26.156441948000065
						],
						[
							-80.11459940899994,
							26.15652627600008
						],
						[
							-80.11431831699991,
							26.156694931000064
						],
						[
							-80.11420587999993,
							26.156919805000086
						],
						[
							-80.11419699999993,
							26.157124000000067
						],
						[
							-80.1145491879999,
							26.158243377000076
						],
						[
							-80.1157841779999,
							26.158769218000092
						],
						[
							-80.1160765859999,
							26.15854470000005
						],
						[
							-80.11657245999993,
							26.158203299000036
						],
						[
							-80.11687869299995,
							26.157107401000076
						],
						[
							-80.1173384569999,
							26.157265805000065
						],
						[
							-80.11752972699992,
							26.157333950000066
						],
						[
							-80.11832591099994,
							26.157961027000056
						],
						[
							-80.1185410679999,
							26.157811864000053
						],
						[
							-80.11851599999994,
							26.15786200000008
						],
						[
							-80.11826599999995,
							26.158362000000068
						],
						[
							-80.1177659999999,
							26.15956200000005
						],
						[
							-80.11786599999994,
							26.16016200000007
						],
						[
							-80.11786599999994,
							26.16076200000009
						],
						[
							-80.11801248099994,
							26.160849888000087
						],
						[
							-80.11795921499993,
							26.166960988000085
						],
						[
							-80.11716399999995,
							26.166960000000078
						],
						[
							-80.11706599999992,
							26.16696200000007
						],
						[
							-80.11684778099993,
							26.166961729000036
						],
						[
							-80.11687877499992,
							26.16701326100008
						],
						[
							-80.11692985099995,
							26.167089373000067
						],
						[
							-80.11698593299991,
							26.16716147900007
						],
						[
							-80.11705607599993,
							26.167259526000066
						],
						[
							-80.10877575799992,
							26.16747394300006
						],
						[
							-80.10792950199993,
							26.167485961000068
						],
						[
							-80.1076530929999,
							26.167488965000075
						],
						[
							-80.10753591899993,
							26.16749096800004
						],
						[
							-80.1070622169999,
							26.167488965000075
						],
						[
							-80.10682786899991,
							26.16751700700007
						],
						[
							-80.10529756099993,
							26.167553206000036
						],
						[
							-80.10516041499994,
							26.167485880000072
						],
						[
							-80.10466566199995,
							26.16749197000007
						],
						[
							-80.10456899999991,
							26.167493000000036
						],
						[
							-80.10415183899994,
							26.16749903100009
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Coral Ridge",
				"RegionID": "124024"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.93544838699995,
					28.014109927000344,
					-81.90777199999991,
					28.03516800000018
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.9131519999999,
							28.03178400000014
						],
						[
							-81.91265113117117,
							28.027549731979846
						],
						[
							-81.91263199999986,
							28.02738800000021
						],
						[
							-81.9121151419666,
							28.027423840520807
						],
						[
							-81.91208399999991,
							28.02742600000016
						],
						[
							-81.91228499999993,
							28.026902000000145
						],
						[
							-81.91388599999988,
							28.02689800000017
						],
						[
							-81.91396099999986,
							28.026891000000123
						],
						[
							-81.91398899999977,
							28.0268490000002
						],
						[
							-81.91399399999993,
							28.026438000000123
						],
						[
							-81.91399399999993,
							28.025995000000062
						],
						[
							-81.9129749999999,
							28.02600000000012
						],
						[
							-81.91285499999992,
							28.02600500000018
						],
						[
							-81.91271614407263,
							28.02602453751756
						],
						[
							-81.91265599999988,
							28.02603300000001
						],
						[
							-81.91259899999987,
							28.02596400000016
						],
						[
							-81.91244844198592,
							28.025493003004623
						],
						[
							-81.91241199999986,
							28.025379000000076
						],
						[
							-81.91241199999986,
							28.02506700000002
						],
						[
							-81.91240699999989,
							28.024916000000136
						],
						[
							-81.91238399999985,
							28.02478900000011
						],
						[
							-81.91233899999986,
							28.024652000000142
						],
						[
							-81.91226499999995,
							28.024496000000024
						],
						[
							-81.91220299999979,
							28.024381000000105
						],
						[
							-81.91203799999991,
							28.024168000000067
						],
						[
							-81.9115319999998,
							28.024173000000122
						],
						[
							-81.91153299999978,
							28.02338900000009
						],
						[
							-81.9115279999999,
							28.022750000000155
						],
						[
							-81.91150599999986,
							28.02268600000019
						],
						[
							-81.91147099999989,
							28.022656000000016
						],
						[
							-81.91143599999992,
							28.021951000000126
						],
						[
							-81.91146599999992,
							28.021919000000143
						],
						[
							-81.91148899999979,
							28.021867000000103
						],
						[
							-81.91149899999981,
							28.019832000000125
						],
						[
							-81.91149599999991,
							28.019758000000042
						],
						[
							-81.91150299999988,
							28.019426000000106
						],
						[
							-81.91149599999991,
							28.019155000000065
						],
						[
							-81.91146299999987,
							28.01908800000003
						],
						[
							-81.91154399999989,
							28.01888000000005
						],
						[
							-81.91162399999985,
							28.018671000000165
						],
						[
							-81.91169199999989,
							28.018492000000098
						],
						[
							-81.91176099999991,
							28.018314000000114
						],
						[
							-81.91177899999988,
							28.018267000000133
						],
						[
							-81.91176999499994,
							28.018267000000133
						],
						[
							-81.91176099999991,
							28.018267000000133
						],
						[
							-81.90872099999991,
							28.01834200000012
						],
						[
							-81.90877599999993,
							28.017893000000097
						],
						[
							-81.90779999999991,
							28.01796200000012
						],
						[
							-81.9078009999999,
							28.016929000000093
						],
						[
							-81.90780047671049,
							28.01689718400492
						],
						[
							-81.90780007039481,
							28.016872480009983
						],
						[
							-81.90778099999994,
							28.015713000000023
						],
						[
							-81.90777199999991,
							28.015261000000105
						],
						[
							-81.90777199999991,
							28.014995000000123
						],
						[
							-81.90777199999991,
							28.014956010000095
						],
						[
							-81.90777199999991,
							28.01430101000008
						],
						[
							-81.90777199999991,
							28.014194000000106
						],
						[
							-81.90944599999996,
							28.014188000000143
						],
						[
							-81.9111209999998,
							28.014183000000084
						],
						[
							-81.91263099999986,
							28.01418000000019
						],
						[
							-81.91290899999986,
							28.01417400000005
						],
						[
							-81.91311799999993,
							28.0141810000001
						],
						[
							-81.9132519999999,
							28.01419200000012
						],
						[
							-81.91341366407323,
							28.01416738448285
						],
						[
							-81.9137379999999,
							28.014118000000035
						],
						[
							-81.91378581399994,
							28.014109927000344
						],
						[
							-81.91412090999995,
							28.014405011000246
						],
						[
							-81.91437690999982,
							28.014655010000237
						],
						[
							-81.91598290999973,
							28.01613401000022
						],
						[
							-81.91658491099989,
							28.0166780110002
						],
						[
							-81.91713391099994,
							28.01719101000028
						],
						[
							-81.91831390999987,
							28.018256011000023
						],
						[
							-81.9186289109999,
							28.018554010000077
						],
						[
							-81.91879890999967,
							28.01871401000035
						],
						[
							-81.91922091099977,
							28.019078011000357
						],
						[
							-81.9202089099998,
							28.02000501100032
						],
						[
							-81.92128290999995,
							28.020975010000374
						],
						[
							-81.92231691099987,
							28.021928010000355
						],
						[
							-81.92343391099983,
							28.022940010000244
						],
						[
							-81.92455490999986,
							28.023976010000343
						],
						[
							-81.92644890999989,
							28.025696010000193
						],
						[
							-81.92665782399978,
							28.025898191000312
						],
						[
							-81.9266979089998,
							28.025897010000126
						],
						[
							-81.9269910249999,
							28.025889953000167
						],
						[
							-81.92706808799988,
							28.025960947000176
						],
						[
							-81.9270637359998,
							28.025989031000012
						],
						[
							-81.92714380699992,
							28.026161095000038
						],
						[
							-81.92843198099985,
							28.02739896400023
						],
						[
							-81.92849783999978,
							28.02757305600007
						],
						[
							-81.92878391099993,
							28.027845010000366
						],
						[
							-81.93180790999983,
							28.030611010000253
						],
						[
							-81.93267090999983,
							28.031385010000346
						],
						[
							-81.93370490999976,
							28.032332010000363
						],
						[
							-81.93544838699995,
							28.033948372000165
						],
						[
							-81.93127707299972,
							28.033935408000335
						],
						[
							-81.93027606199992,
							28.034050251000334
						],
						[
							-81.93024424099968,
							28.03400563600046
						],
						[
							-81.93021316499987,
							28.033955661000324
						],
						[
							-81.93018697199966,
							28.033906886000285
						],
						[
							-81.93002820299975,
							28.033588057000106
						],
						[
							-81.92995188599974,
							28.033584139000315
						],
						[
							-81.92993918199976,
							28.033583396000342
						],
						[
							-81.9298806149997,
							28.033577628000224
						],
						[
							-81.92982652099977,
							28.033568822000024
						],
						[
							-81.92968752099972,
							28.033541822000455
						],
						[
							-81.92968355099974,
							28.033541042000213
						],
						[
							-81.92962623899972,
							28.03352767900026
						],
						[
							-81.92956992299985,
							28.03351059500027
						],
						[
							-81.92953821099962,
							28.033499164000478
						],
						[
							-81.92942821099967,
							28.033457164000378
						],
						[
							-81.92940484399978,
							28.033447865000408
						],
						[
							-81.9293512399996,
							28.03342357800044
						],
						[
							-81.92929933899967,
							28.033395836000455
						],
						[
							-81.9292493629997,
							28.033364759000282
						],
						[
							-81.92920152699975,
							28.033330480000377
						],
						[
							-81.92915603599971,
							28.033293146000307
						],
						[
							-81.92913219399969,
							28.033271470000294
						],
						[
							-81.92899319399973,
							28.033140470000113
						],
						[
							-81.92897408299966,
							28.03312191600053
						],
						[
							-81.92893385399962,
							28.033078964000527
						],
						[
							-81.92889651899974,
							28.033033472000493
						],
						[
							-81.92887552699978,
							28.033004970000267
						],
						[
							-81.92875752699977,
							28.032837970000305
						],
						[
							-81.92874714299971,
							28.032822953000217
						],
						[
							-81.92803912299985,
							28.031776479000317
						],
						[
							-81.92780832299967,
							28.03153606200023
						],
						[
							-81.92740960849976,
							28.031189394000325
						],
						[
							-81.92719238199986,
							28.031000169000215
						],
						[
							-81.92703345599976,
							28.030891102000336
						],
						[
							-81.92645821599977,
							28.030501626999996
						],
						[
							-81.9262276399998,
							28.030397201000415
						],
						[
							-81.92614417899982,
							28.03036623200025
						],
						[
							-81.92611954399973,
							28.030360041000183
						],
						[
							-81.92570069599962,
							28.030513361000256
						],
						[
							-81.92555044099981,
							28.03057639500032
						],
						[
							-81.92547891399975,
							28.030651458000403
						],
						[
							-81.92539599999974,
							28.03073951400023
						],
						[
							-81.92536672299961,
							28.030781224000304
						],
						[
							-81.92535750099965,
							28.030795107000298
						],
						[
							-81.92461405468927,
							28.03160388941929
						],
						[
							-81.92460799999972,
							28.031885000000326
						],
						[
							-81.9246067186113,
							28.031897197833825
						],
						[
							-81.92457644868172,
							28.03164480003836
						],
						[
							-81.9245639999999,
							28.031541000000107
						],
						[
							-81.92445799999983,
							28.03131000000018
						],
						[
							-81.92426599999993,
							28.03112800000004
						],
						[
							-81.92403699999981,
							28.031007000000155
						],
						[
							-81.92377599999989,
							28.030941000000023
						],
						[
							-81.92363999999992,
							28.03096900000021
						],
						[
							-81.9234849999999,
							28.03107300000011
						],
						[
							-81.92334199999986,
							28.031244000000047
						],
						[
							-81.92314999999988,
							28.03150200000008
						],
						[
							-81.9229579999999,
							28.031700000000118
						],
						[
							-81.92276499999991,
							28.03184300000005
						],
						[
							-81.92271762306073,
							28.03185981117206
						],
						[
							-81.92257899999989,
							28.031909000000002
						],
						[
							-81.9222259999999,
							28.031948000000032
						],
						[
							-81.9218169999999,
							28.0318930000001
						],
						[
							-81.92153799999981,
							28.031838000000167
						],
						[
							-81.92133899999988,
							28.031821000000004
						],
						[
							-81.92058899999991,
							28.031854000000074
						],
						[
							-81.92039699999991,
							28.031827000000145
						],
						[
							-81.92018599999996,
							28.03175500000005
						],
						[
							-81.9198879999999,
							28.031595000000134
						],
						[
							-81.9198365958935,
							28.03150903106363
						],
						[
							-81.91982999999989,
							28.031498000000102
						],
						[
							-81.91989599999994,
							28.031961000000045
						],
						[
							-81.91990249999985,
							28.031964500000154
						],
						[
							-81.91990899999986,
							28.031968000000088
						],
						[
							-81.91999899999985,
							28.03203100000015
						],
						[
							-81.92006999999985,
							28.03209400000021
						],
						[
							-81.92011299999986,
							28.032165000000045
						],
						[
							-81.9201949915908,
							28.032404142140447
						],
						[
							-81.9201969999998,
							28.032410000000066
						],
						[
							-81.92018474246063,
							28.032449744142266
						],
						[
							-81.92016399999982,
							28.032517000000038
						],
						[
							-81.92016799999989,
							28.032896000000132
						],
						[
							-81.91879699999987,
							28.03314000000007
						],
						[
							-81.91853799999984,
							28.033201000000144
						],
						[
							-81.91829167392883,
							28.033259617701596
						],
						[
							-81.91816399999989,
							28.033290000000047
						],
						[
							-81.91587799999985,
							28.03377500000003
						],
						[
							-81.91556299999989,
							28.033840000000083
						],
						[
							-81.9155619999999,
							28.034209000000057
						],
						[
							-81.9155479999999,
							28.03516800000018
						],
						[
							-81.91532199999993,
							28.035167000000097
						],
						[
							-81.9145914539997,
							28.035163155021184
						],
						[
							-81.91456199999993,
							28.03516300000012
						],
						[
							-81.91343723000324,
							28.035114568923905
						],
						[
							-81.91321499999987,
							28.03510500000012
						],
						[
							-81.91323199999994,
							28.03361600000002
						],
						[
							-81.9131519999999,
							28.03178400000014
						]
					],
					[
						[
							-81.9223684159997,
							28.030999864000098
						],
						[
							-81.92248925499983,
							28.030794667000084
						],
						[
							-81.92247554699986,
							28.030778242000235
						],
						[
							-81.92245514299985,
							28.030752874000267
						],
						[
							-81.92218594099978,
							28.0304054900003
						],
						[
							-81.92180573199977,
							28.030099698000402
						],
						[
							-81.92171561199977,
							28.030139537000416
						],
						[
							-81.92169433299988,
							28.03014861550032
						],
						[
							-81.92164850999981,
							28.030167366000494
						],
						[
							-81.92159707799965,
							28.030186595000224
						],
						[
							-81.92154076199978,
							28.0302036780003
						],
						[
							-81.92150921399974,
							28.03021152300033
						],
						[
							-81.92119121299963,
							28.03028452300033
						],
						[
							-81.92116544899982,
							28.030290042000342
						],
						[
							-81.92113063999986,
							28.030296257000415
						],
						[
							-81.92101721899972,
							28.030314215000477
						],
						[
							-81.92093075299975,
							28.03032922200021
						],
						[
							-81.92053686699977,
							28.03042350800037
						],
						[
							-81.9201851189997,
							28.030529725000367
						],
						[
							-81.92017539199979,
							28.03053477600052
						],
						[
							-81.92021940599987,
							28.030588740000365
						],
						[
							-81.92032546299986,
							28.03071737400035
						],
						[
							-81.9204075309999,
							28.030736122000306
						],
						[
							-81.92050355699968,
							28.030754910000258
						],
						[
							-81.9206619519998,
							28.03077553800019
						],
						[
							-81.92085982699984,
							28.03078867800021
						],
						[
							-81.9211349999997,
							28.03078867800021
						],
						[
							-81.92119381899977,
							28.030790603000458
						],
						[
							-81.92125238499972,
							28.030796371000225
						],
						[
							-81.92126218599992,
							28.03079771700034
						],
						[
							-81.92146518499975,
							28.03082671700025
						],
						[
							-81.92151344899975,
							28.030834958000312
						],
						[
							-81.92155845199964,
							28.03084511700035
						],
						[
							-81.92195235799964,
							28.03094471400033
						],
						[
							-81.92234155399979,
							28.031001271000484
						],
						[
							-81.9223684159997,
							28.030999864000098
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Polk",
				"City": "Lakeland",
				"Name": "Crystal Lake",
				"RegionID": "124085"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.14988884099995,
					25.926213,
					-80.129872,
					25.938518
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.149401,
							25.926213
						],
						[
							-80.14967468999998,
							25.926838731000032
						],
						[
							-80.14988884099995,
							25.927695337000046
						],
						[
							-80.14969848399994,
							25.928885068000056
						],
						[
							-80.14941294899995,
							25.929932031000078
						],
						[
							-80.14838978099993,
							25.930288950000033
						],
						[
							-80.147957,
							25.931225
						],
						[
							-80.147397,
							25.931839
						],
						[
							-80.147326,
							25.931917
						],
						[
							-80.144364,
							25.935054000000004
						],
						[
							-80.143373,
							25.935997
						],
						[
							-80.143021,
							25.936414
						],
						[
							-80.141071,
							25.937843
						],
						[
							-80.140834,
							25.938085
						],
						[
							-80.140608,
							25.93829
						],
						[
							-80.140412,
							25.938411
						],
						[
							-80.140226,
							25.938478000000003
						],
						[
							-80.140061,
							25.938518
						],
						[
							-80.139707,
							25.938382
						],
						[
							-80.139323,
							25.938234
						],
						[
							-80.13815,
							25.938221
						],
						[
							-80.136601,
							25.938240000000004
						],
						[
							-80.135896,
							25.9383
						],
						[
							-80.134052,
							25.938361
						],
						[
							-80.133775,
							25.938451
						],
						[
							-80.13227,
							25.938288
						],
						[
							-80.131515,
							25.937648
						],
						[
							-80.131344,
							25.937036
						],
						[
							-80.131345,
							25.936822
						],
						[
							-80.131348,
							25.935484
						],
						[
							-80.13013,
							25.933908000000002
						],
						[
							-80.129872,
							25.933574
						],
						[
							-80.1304,
							25.931457
						],
						[
							-80.130373,
							25.931376
						],
						[
							-80.130219,
							25.930911
						],
						[
							-80.130336,
							25.930271
						],
						[
							-80.130544,
							25.93025
						],
						[
							-80.130742,
							25.930234
						],
						[
							-80.131132,
							25.930196
						],
						[
							-80.131956,
							25.93007
						],
						[
							-80.132378,
							25.929966
						],
						[
							-80.132489,
							25.929926
						],
						[
							-80.133248,
							25.92965
						],
						[
							-80.13374,
							25.929546
						],
						[
							-80.13488,
							25.928965
						],
						[
							-80.13638,
							25.928205
						],
						[
							-80.137508,
							25.927632
						],
						[
							-80.138416,
							25.927171
						],
						[
							-80.138729,
							25.927033
						],
						[
							-80.138974,
							25.92694
						],
						[
							-80.139299,
							25.926834
						],
						[
							-80.139561,
							25.926764
						],
						[
							-80.139819,
							25.926707
						],
						[
							-80.140078,
							25.926662
						],
						[
							-80.140197,
							25.926647
						],
						[
							-80.140339,
							25.926627
						],
						[
							-80.140692,
							25.9266
						],
						[
							-80.14095,
							25.926592
						],
						[
							-80.14099,
							25.926592
						],
						[
							-80.141136,
							25.926593
						],
						[
							-80.144149,
							25.92647
						],
						[
							-80.147353,
							25.926329
						],
						[
							-80.149163,
							25.926229
						],
						[
							-80.149401,
							25.926213
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "North Miami Beach",
				"Name": "Eastern Shores",
				"RegionID": "124244"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.6049499909999,
					30.411081678000073,
					-81.58271567799994,
					30.44007670100007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.58272934099995,
							30.41665083400005
						],
						[
							-81.58276991399993,
							30.416499414000043
						],
						[
							-81.5828361639999,
							30.416357339000058
						],
						[
							-81.58292607899995,
							30.416228927000077
						],
						[
							-81.58303692699991,
							30.416118079000057
						],
						[
							-81.58316533899995,
							30.41602816400007
						],
						[
							-81.58330741399995,
							30.41596191400004
						],
						[
							-81.58345883399994,
							30.415921340000068
						],
						[
							-81.58361499999995,
							30.415907678000053
						],
						[
							-81.58369384299993,
							30.415907678000053
						],
						[
							-81.58473072899994,
							30.415733153000076
						],
						[
							-81.58480639399994,
							30.41572369500005
						],
						[
							-81.58488258799991,
							30.41572068200009
						],
						[
							-81.58495876299992,
							30.415724134000072
						],
						[
							-81.58503437299993,
							30.41573402700004
						],
						[
							-81.58510887199992,
							30.415750289000076
						],
						[
							-81.58518172599992,
							30.41577280400009
						],
						[
							-81.58525241099994,
							30.415801410000086
						],
						[
							-81.58532041799992,
							30.41583590100004
						],
						[
							-81.5858952449999,
							30.416158774000053
						],
						[
							-81.58669378199994,
							30.416502854000047
						],
						[
							-81.58755432499993,
							30.41618521700008
						],
						[
							-81.58843268299995,
							30.415605785000086
						],
						[
							-81.58858302499993,
							30.41544902900006
						],
						[
							-81.58845748099992,
							30.415263618000036
						],
						[
							-81.58794106599993,
							30.41469617100006
						],
						[
							-81.58539583599992,
							30.413476734000085
						],
						[
							-81.58402424699996,
							30.413099051000074
						],
						[
							-81.58395541399994,
							30.413077087000094
						],
						[
							-81.5838133389999,
							30.41301083600007
						],
						[
							-81.58368492699992,
							30.41292092100008
						],
						[
							-81.5835740789999,
							30.41281007300006
						],
						[
							-81.58348416399993,
							30.412681661000082
						],
						[
							-81.5834702649999,
							30.41265667800008
						],
						[
							-81.58341026499994,
							30.412544677000085
						],
						[
							-81.58335791399992,
							30.41242758600003
						],
						[
							-81.58331734099994,
							30.412276165000037
						],
						[
							-81.58330367799994,
							30.412120000000073
						],
						[
							-81.58331734099994,
							30.411963834000062
						],
						[
							-81.58335791399992,
							30.411812413000064
						],
						[
							-81.58342751299995,
							30.41166463600007
						],
						[
							-81.58351386099991,
							30.411519935000058
						],
						[
							-81.58359707999995,
							30.41140292700004
						],
						[
							-81.58370792699992,
							30.411292080000063
						],
						[
							-81.5838363389999,
							30.411202165000077
						],
						[
							-81.58397841399994,
							30.41113591400006
						],
						[
							-81.58412983499994,
							30.41109534100008
						],
						[
							-81.58428599999992,
							30.411081678000073
						],
						[
							-81.58430916299994,
							30.411081977000038
						],
						[
							-81.58555116299993,
							30.41111397600008
						],
						[
							-81.58568416599991,
							30.411127341000054
						],
						[
							-81.5858084919999,
							30.41115853900004
						],
						[
							-81.58809657599994,
							30.411909642000072
						],
						[
							-81.59242949799994,
							30.41316627000009
						],
						[
							-81.59248658599995,
							30.413184914000055
						],
						[
							-81.59263165899995,
							30.41325291100009
						],
						[
							-81.5941116219999,
							30.41412264900004
						],
						[
							-81.59710580299992,
							30.414718605000076
						],
						[
							-81.59750864299991,
							30.41463183900004
						],
						[
							-81.59754183399991,
							30.41462534100009
						],
						[
							-81.59769799999992,
							30.414611678000085
						],
						[
							-81.59785416499996,
							30.41462534100009
						],
						[
							-81.59800558599994,
							30.414665914000064
						],
						[
							-81.59805340399993,
							30.414684884000057
						],
						[
							-81.6018864049999,
							30.416333884000043
						],
						[
							-81.60198066099991,
							30.416381164000086
						],
						[
							-81.60210551199992,
							30.416469314000043
						],
						[
							-81.60217384899994,
							30.416557278000088
						],
						[
							-81.60153099999991,
							30.417160000000084
						],
						[
							-81.60118090799995,
							30.41748801000006
						],
						[
							-81.6009519079999,
							30.417681009000034
						],
						[
							-81.60079974399991,
							30.417777913000062
						],
						[
							-81.60060874299995,
							30.420687063000063
						],
						[
							-81.6007079069999,
							30.420822010000055
						],
						[
							-81.60080690699994,
							30.42098201100004
						],
						[
							-81.60092190699993,
							30.42132601000009
						],
						[
							-81.60100590799993,
							30.421745010000052
						],
						[
							-81.6011579069999,
							30.422409010000084
						],
						[
							-81.60127990799992,
							30.423014011000074
						],
						[
							-81.60136390799994,
							30.42336701100004
						],
						[
							-81.60234090799992,
							30.42788701100005
						],
						[
							-81.6023939079999,
							30.42808301100007
						],
						[
							-81.60256990699992,
							30.428890010000085
						],
						[
							-81.60258490799993,
							30.42899901100009
						],
						[
							-81.6037899069999,
							30.434429011000077
						],
						[
							-81.60487390799995,
							30.439413010000067
						],
						[
							-81.6049499909999,
							30.439762963000078
						],
						[
							-81.59484794399992,
							30.44007670100007
						],
						[
							-81.58695822399994,
							30.438901717000075
						],
						[
							-81.58472999999992,
							30.43716100000006
						],
						[
							-81.58421285299995,
							30.436756998000078
						],
						[
							-81.5848577509999,
							30.436061893000044
						],
						[
							-81.58496109399994,
							30.436033158000043
						],
						[
							-81.58524920999992,
							30.435874989000073
						],
						[
							-81.58536038399991,
							30.435822476000055
						],
						[
							-81.5859928669999,
							30.43557506600007
						],
						[
							-81.58636371799993,
							30.43540435600005
						],
						[
							-81.58694263399991,
							30.435053805000052
						],
						[
							-81.58698815799994,
							30.43501452600009
						],
						[
							-81.58692501099995,
							30.434869013000085
						],
						[
							-81.58689817099992,
							30.434800511000045
						],
						[
							-81.58687738799996,
							30.434729934000078
						],
						[
							-81.58686281799993,
							30.43465781800006
						],
						[
							-81.58685457299993,
							30.434584708000045
						],
						[
							-81.5868527149999,
							30.43451115800008
						],
						[
							-81.58685725799995,
							30.434437726000056
						],
						[
							-81.58706946899991,
							30.433436913000033
						],
						[
							-81.58679564699992,
							30.43242641100005
						],
						[
							-81.58712364799993,
							30.431117412000052
						],
						[
							-81.5871426789999,
							30.43105205900008
						],
						[
							-81.5871665979999,
							30.430988333000073
						],
						[
							-81.58719526899995,
							30.43092659900009
						],
						[
							-81.58722852699992,
							30.430867210000088
						],
						[
							-81.5872661809999,
							30.43081050600006
						],
						[
							-81.58804940699991,
							30.42972274300007
						],
						[
							-81.5882790899999,
							30.42918703500004
						],
						[
							-81.58827446099991,
							30.42907395300006
						],
						[
							-81.5880513919999,
							30.428635674000077
						],
						[
							-81.5878388129999,
							30.428406503000076
						],
						[
							-81.58716556199994,
							30.428072747000048
						],
						[
							-81.58711533899992,
							30.428045836000077
						],
						[
							-81.58698692699994,
							30.427955921000034
						],
						[
							-81.58687607999991,
							30.42784507300007
						],
						[
							-81.58678616499992,
							30.42771666100009
						],
						[
							-81.5867199139999,
							30.42757458600005
						],
						[
							-81.58667934099992,
							30.427423166000043
						],
						[
							-81.58666567799992,
							30.427267000000086
						],
						[
							-81.58667934099992,
							30.427110834000075
						],
						[
							-81.5867199139999,
							30.42695941400007
						],
						[
							-81.58678643399992,
							30.426816873000064
						],
						[
							-81.58707040299994,
							30.42632638100008
						],
						[
							-81.5869754439999,
							30.426140665000048
						],
						[
							-81.58648721499993,
							30.425563421000053
						],
						[
							-81.58639616499994,
							30.42543366100006
						],
						[
							-81.58633785799992,
							30.425312591000083
						],
						[
							-81.58588685799992,
							30.42416359100008
						],
						[
							-81.58587891399992,
							30.42414258600007
						],
						[
							-81.58583834099994,
							30.423991166000064
						],
						[
							-81.58582467799994,
							30.423835000000054
						],
						[
							-81.58583834099994,
							30.42367883400004
						],
						[
							-81.58587748199994,
							30.423531377000074
						],
						[
							-81.58606219799992,
							30.423016395000047
						],
						[
							-81.5860873879999,
							30.422952475000045
						],
						[
							-81.58611770699991,
							30.422890822000056
						],
						[
							-81.58615295199992,
							30.42283184600007
						],
						[
							-81.58619288799991,
							30.422775941000054
						],
						[
							-81.5862372499999,
							30.42272347800008
						],
						[
							-81.5861911639999,
							30.422657661000073
						],
						[
							-81.58612491399992,
							30.422515586000088
						],
						[
							-81.58608434099995,
							30.42236416500009
						],
						[
							-81.58607067799994,
							30.42220800000007
						],
						[
							-81.58608434099995,
							30.422051834000058
						],
						[
							-81.58612491399992,
							30.42190041300006
						],
						[
							-81.5861911639999,
							30.421758339000064
						],
						[
							-81.5862156099999,
							30.42171843200003
						],
						[
							-81.58633853299995,
							30.421529017000072
						],
						[
							-81.58570156299993,
							30.421134617000067
						],
						[
							-81.58559692699993,
							30.421058921000053
						],
						[
							-81.5854860789999,
							30.42094807300009
						],
						[
							-81.58539616399992,
							30.420819661000053
						],
						[
							-81.58532991399994,
							30.420677587000057
						],
						[
							-81.5852893409999,
							30.42052616600006
						],
						[
							-81.5852756779999,
							30.420370000000048
						],
						[
							-81.5852815319999,
							30.42026755400008
						],
						[
							-81.5853315459999,
							30.41983137200009
						],
						[
							-81.58529613499991,
							30.419476690000064
						],
						[
							-81.58511982499994,
							30.419115504000047
						],
						[
							-81.58506726799993,
							30.418981615000064
						],
						[
							-81.58499069399994,
							30.418728714000054
						],
						[
							-81.58467699099992,
							30.41856208400009
						],
						[
							-81.5840229239999,
							30.418499193000063
						],
						[
							-81.58395283499993,
							30.41848965900005
						],
						[
							-81.58380141399994,
							30.418449086000063
						],
						[
							-81.58365933899995,
							30.418382835000045
						],
						[
							-81.58353092699991,
							30.41829292000006
						],
						[
							-81.58342004799994,
							30.418182035000086
						],
						[
							-81.58301901599992,
							30.41770399800004
						],
						[
							-81.58292916399995,
							30.417575661000058
						],
						[
							-81.5829036209999,
							30.417528188000063
						],
						[
							-81.58281062099991,
							30.41734218700009
						],
						[
							-81.58278197399994,
							30.417278891000084
						],
						[
							-81.58275829799993,
							30.417213572000037
						],
						[
							-81.5827397349999,
							30.417146621000086
						],
						[
							-81.58272639699993,
							30.417078436000054
						],
						[
							-81.58271836199992,
							30.417009425000064
						],
						[
							-81.58271567799994,
							30.416940000000068
						],
						[
							-81.58271567799994,
							30.416807000000063
						],
						[
							-81.58272934099995,
							30.41665083400005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Eastport",
				"RegionID": "124249"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.12337855599993,
					26.20827536200005,
					-80.1063410289999,
					26.231580050000048
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.10639048399992,
							26.22399696100007
						],
						[
							-80.1063410289999,
							26.22226602300009
						],
						[
							-80.10641322599992,
							26.22225482300007
						],
						[
							-80.10777538299993,
							26.222043544000087
						],
						[
							-80.10886340099995,
							26.22174681200005
						],
						[
							-80.10980305299995,
							26.22140062400007
						],
						[
							-80.11081688899992,
							26.22093079800004
						],
						[
							-80.11165762999991,
							26.220337333000092
						],
						[
							-80.11222636699995,
							26.21947186400007
						],
						[
							-80.11272092099995,
							26.21858166700008
						],
						[
							-80.11316601899995,
							26.218037658000075
						],
						[
							-80.11460022499995,
							26.21759255900008
						],
						[
							-80.11521841799994,
							26.216801273000044
						],
						[
							-80.11529260099991,
							26.216281992000063
						],
						[
							-80.11544096699993,
							26.215045607000036
						],
						[
							-80.1159107929999,
							26.214600509000036
						],
						[
							-80.11677626199992,
							26.214130683000064
						],
						[
							-80.11749336499992,
							26.213364124000066
						],
						[
							-80.11808682999992,
							26.213191030000075
						],
						[
							-80.1187792049999,
							26.212919026000066
						],
						[
							-80.12001558999992,
							26.21168264100004
						],
						[
							-80.12006624799994,
							26.210564541000053
						],
						[
							-80.1200669449999,
							26.210559840000087
						],
						[
							-80.12012294499993,
							26.210059840000042
						],
						[
							-80.12016135899995,
							26.209710621000056
						],
						[
							-80.12016694499994,
							26.209659840000086
						],
						[
							-80.12036694499994,
							26.209059840000066
						],
						[
							-80.12086694499993,
							26.208659840000053
						],
						[
							-80.12112803399992,
							26.208614433000037
						],
						[
							-80.12209143399991,
							26.20844688600005
						],
						[
							-80.12300370399993,
							26.20828823000005
						],
						[
							-80.12307362699994,
							26.208276069000078
						],
						[
							-80.12307769599994,
							26.20827536200005
						],
						[
							-80.12307707999992,
							26.208280736000063
						],
						[
							-80.12307687999993,
							26.208288639000045
						],
						[
							-80.12307784599994,
							26.208293594000054
						],
						[
							-80.12318058599993,
							26.21111383400006
						],
						[
							-80.12325491699994,
							26.214823058000036
						],
						[
							-80.12337855599993,
							26.21848275600007
						],
						[
							-80.12330437299994,
							26.222711191000087
						],
						[
							-80.1232301899999,
							26.227162176000036
						],
						[
							-80.12330198199994,
							26.22941060100004
						],
						[
							-80.12296645599992,
							26.231519132000074
						],
						[
							-80.12295679599993,
							26.231580050000048
						],
						[
							-80.12289427999991,
							26.23151886800008
						],
						[
							-80.12261199699992,
							26.23124224500009
						],
						[
							-80.10640647899993,
							26.224004105000063
						],
						[
							-80.10639048399992,
							26.22399696100007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Pompano Beach",
				"Name": "Garden Isles",
				"RegionID": "124508"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-87.21264213099994,
					30.417223303000075,
					-87.18481956899996,
					30.450413989000022
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-87.19729175199996,
								30.450413989000022
							],
							[
								-87.19610392499999,
								30.449515504000033
							],
							[
								-87.19439832699999,
								30.44893682000003
							],
							[
								-87.19116987499996,
								30.447368279000045
							],
							[
								-87.18926630599998,
								30.446743908000027
							],
							[
								-87.18740842299997,
								30.446241366000038
							],
							[
								-87.18641856699998,
								30.445556081000063
							],
							[
								-87.18634242399997,
								30.445083996000047
							],
							[
								-87.18666222399999,
								30.444246426000063
							],
							[
								-87.18798710799996,
								30.442221029000056
							],
							[
								-87.18841350699995,
								30.441124573000025
							],
							[
								-87.18851072499996,
								30.44049265900003
							],
							[
								-87.18862670699997,
								30.439738775000023
							],
							[
								-87.18845919299997,
								30.438885976000048
							],
							[
								-87.18792619399994,
								30.437789521000074
							],
							[
								-87.18678405199995,
								30.43722606400007
							],
							[
								-87.18548962499995,
								30.436495094000065
							],
							[
								-87.18481956899996,
								30.435170210000024
							],
							[
								-87.18485002599994,
								30.434104211000037
							],
							[
								-87.18510891199998,
								30.433053441000027
							],
							[
								-87.18629673899994,
								30.432139728000035
							],
							[
								-87.18964701999994,
								30.43012956000007
							],
							[
								-87.18998204799999,
								30.42961178900003
							],
							[
								-87.18990590499999,
								30.428850362000052
							],
							[
								-87.18925107699994,
								30.427845277000074
							],
							[
								-87.18823076499996,
								30.42674882200004
							],
							[
								-87.18797337699993,
								30.42574705300007
							],
							[
								-87.188307,
								30.425788999999998
							],
							[
								-87.18832,
								30.4254
							],
							[
								-87.188185,
								30.425346000000005
							],
							[
								-87.188108,
								30.424562
							],
							[
								-87.187562,
								30.422396
							],
							[
								-87.189264,
								30.421797000000005
							],
							[
								-87.192268,
								30.421697
							],
							[
								-87.192867,
								30.420698
							],
							[
								-87.192825,
								30.420536
							],
							[
								-87.193106,
								30.420514
							],
							[
								-87.19310628999995,
								30.420495733000052
							],
							[
								-87.193085,
								30.420443
							],
							[
								-87.193081,
								30.420362000000004
							],
							[
								-87.19326700000002,
								30.420070999999997
							],
							[
								-87.193351,
								30.419973
							],
							[
								-87.19357,
								30.419827
							],
							[
								-87.19358703699999,
								30.419787505000045
							],
							[
								-87.19392624199999,
								30.419758917000028
							],
							[
								-87.19438309899994,
								30.419637089000048
							],
							[
								-87.19502269799995,
								30.419210689000064
							],
							[
								-87.19546432599998,
								30.419012718000033
							],
							[
								-87.19659123899999,
								30.41879951800007
							],
							[
								-87.19733743799998,
								30.418662461000054
							],
							[
								-87.20525628399997,
								30.417307120000036
							],
							[
								-87.20570889899994,
								30.417223303000075
							],
							[
								-87.20627659699994,
								30.419880745000057
							],
							[
								-87.20795173699997,
								30.42687065000007
							],
							[
								-87.21008373399997,
								30.43631235100003
							],
							[
								-87.21264213099994,
								30.447490107000082
							],
							[
								-87.212002532,
								30.44767285000006
							],
							[
								-87.21136293299998,
								30.447931735000058
							],
							[
								-87.21066241899996,
								30.448403820000063
							],
							[
								-87.20993144899995,
								30.448830220000048
							],
							[
								-87.20930707799994,
								30.449119562000078
							],
							[
								-87.20846950799995,
								30.44937844800006
							],
							[
								-87.207114167,
								30.44963733300006
							],
							[
								-87.20335271499995,
								30.450261703000027
							],
							[
								-87.20297200099998,
								30.450155104000032
							],
							[
								-87.20239331599998,
								30.45003327500007
							],
							[
								-87.20190600299998,
								30.45000281800003
							],
							[
								-87.20126640399997,
								30.449972361000047
							],
							[
								-87.20094660399997,
								30.449835304000036
							],
							[
								-87.20079431899995,
								30.449667790000035
							],
							[
								-87.19936283499999,
								30.449911447000034
							],
							[
								-87.19761155199996,
								30.45027693200007
							],
							[
								-87.19729175199996,
								30.450413989000022
							]
						]
					],
					[
						[
							[
								-87.190585,
								30.421172
							],
							[
								-87.190077,
								30.421088999999995
							],
							[
								-87.18994065299995,
								30.42110414900003
							],
							[
								-87.18993,
								30.421107
							],
							[
								-87.189832826,
								30.421116130000026
							],
							[
								-87.189087,
								30.421198999999998
							],
							[
								-87.18859959899999,
								30.42112318200003
							],
							[
								-87.18858815499999,
								30.420782599000063
							],
							[
								-87.188668,
								30.420776
							],
							[
								-87.18929,
								30.420666000000004
							],
							[
								-87.191207,
								30.419697000000003
							],
							[
								-87.191905,
								30.419179999999997
							],
							[
								-87.192134,
								30.419504999999997
							],
							[
								-87.192267,
								30.419504999999997
							],
							[
								-87.192438,
								30.419658999999996
							],
							[
								-87.19236024899999,
								30.41970852700007
							],
							[
								-87.19229313099999,
								30.419767998000058
							],
							[
								-87.192299,
								30.419850999999998
							],
							[
								-87.19261646599995,
								30.420076589000075
							],
							[
								-87.19265,
								30.420079000000005
							],
							[
								-87.192734,
								30.420076000000005
							],
							[
								-87.19277,
								30.420083
							],
							[
								-87.192814,
								30.420115999999997
							],
							[
								-87.192818,
								30.420152
							],
							[
								-87.192803,
								30.420189
							],
							[
								-87.19275900000001,
								30.420214000000005
							],
							[
								-87.192661,
								30.420242999999996
							],
							[
								-87.192566,
								30.420254000000003
							],
							[
								-87.1923,
								30.420320000000004
							],
							[
								-87.192238,
								30.420385
							],
							[
								-87.192238,
								30.42044
							],
							[
								-87.192304,
								30.420569
							],
							[
								-87.19245,
								30.420844000000002
							],
							[
								-87.192464,
								30.420910000000003
							],
							[
								-87.19246376399997,
								30.421006093000074
							],
							[
								-87.192508,
								30.421111
							],
							[
								-87.192115,
								30.421485000000004
							],
							[
								-87.191461,
								30.421601
							],
							[
								-87.190909,
								30.421513
							],
							[
								-87.190585,
								30.421172
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Escambia",
				"City": "Pensacola",
				"Name": "Goulding",
				"RegionID": "124569"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.7159669049999,
					30.347794127000043,
					-81.68582591599994,
					30.36821188500005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.6890419049999,
							30.365878008000042
						],
						[
							-81.69012804199991,
							30.364802952000044
						],
						[
							-81.68970490499993,
							30.364813008000056
						],
						[
							-81.68900290499994,
							30.36482200800009
						],
						[
							-81.68836977599994,
							30.364824141000042
						],
						[
							-81.68833890499991,
							30.363451009000073
						],
						[
							-81.6883159059999,
							30.36277000800004
						],
						[
							-81.6882929059999,
							30.36208000800008
						],
						[
							-81.68828590599993,
							30.361616008000052
						],
						[
							-81.6882709059999,
							30.361376009000082
						],
						[
							-81.6882709059999,
							30.361055008000047
						],
						[
							-81.68825490599994,
							30.36070400900007
						],
						[
							-81.6882479059999,
							30.36002200900009
						],
						[
							-81.68823990499993,
							30.359612009000045
						],
						[
							-81.68823190599994,
							30.359335009000066
						],
						[
							-81.68820990599994,
							30.35863900800007
						],
						[
							-81.68819390599994,
							30.357948008000054
						],
						[
							-81.68817890499992,
							30.35727300800005
						],
						[
							-81.68812592599994,
							30.356985955000084
						],
						[
							-81.68882790499993,
							30.356983008000043
						],
						[
							-81.69073990499993,
							30.356948009000067
						],
						[
							-81.69260390599993,
							30.356916008000045
						],
						[
							-81.69457190599991,
							30.35690500800007
						],
						[
							-81.6971210399999,
							30.35689213900008
						],
						[
							-81.69711690499992,
							30.356810009000075
						],
						[
							-81.69711290599992,
							30.35672000800008
						],
						[
							-81.69711290599992,
							30.356459008000055
						],
						[
							-81.69711290599992,
							30.355979009000066
						],
						[
							-81.6971009049999,
							30.35523500900007
						],
						[
							-81.69710490599994,
							30.35458400800007
						],
						[
							-81.6970979059999,
							30.35392400900008
						],
						[
							-81.69708990599992,
							30.353258008000072
						],
						[
							-81.69708990599992,
							30.352608008000065
						],
						[
							-81.69708990599992,
							30.351940009000085
						],
						[
							-81.69708290599993,
							30.351463008000053
						],
						[
							-81.69708990599992,
							30.35126500800004
						],
						[
							-81.6970979059999,
							30.350611008000044
						],
						[
							-81.6970979059999,
							30.349962009000084
						],
						[
							-81.69708990599992,
							30.34919000900004
						],
						[
							-81.69709790399992,
							30.348622953000074
						],
						[
							-81.69850890599992,
							30.348610008000037
						],
						[
							-81.69994390499994,
							30.348604008000052
						],
						[
							-81.70137803999995,
							30.348602142000065
						],
						[
							-81.70137780599993,
							30.348490868000056
						],
						[
							-81.70175194299992,
							30.348621198000043
						],
						[
							-81.70230109199991,
							30.348103033000086
						],
						[
							-81.7020991199999,
							30.347794127000043
						],
						[
							-81.70348690799995,
							30.348888010000053
						],
						[
							-81.70480190699993,
							30.349938010000077
						],
						[
							-81.70495590799993,
							30.350062010000045
						],
						[
							-81.70734090699995,
							30.351974010000045
						],
						[
							-81.71033190799994,
							30.35420301000005
						],
						[
							-81.7106019069999,
							30.354364011000087
						],
						[
							-81.71404890699996,
							30.356996011000035
						],
						[
							-81.71532738899992,
							30.35803357000009
						],
						[
							-81.7156959049999,
							30.358495009000084
						],
						[
							-81.71576990499995,
							30.358606009000084
						],
						[
							-81.71584390499993,
							30.358749009000064
						],
						[
							-81.7159239049999,
							30.35894601000007
						],
						[
							-81.71595490499993,
							30.35910000800004
						],
						[
							-81.7159669049999,
							30.35925401100008
						],
						[
							-81.71594890599994,
							30.359429008000063
						],
						[
							-81.71589890599995,
							30.359641009000086
						],
						[
							-81.71584990399992,
							30.359811008000065
						],
						[
							-81.71575190499993,
							30.35997000900005
						],
						[
							-81.7156289049999,
							30.360130008000056
						],
						[
							-81.7155179049999,
							30.360247008000048
						],
						[
							-81.71540690599994,
							30.360337008000048
						],
						[
							-81.71527190599994,
							30.360448007000063
						],
						[
							-81.71511790499996,
							30.360533008000065
						],
						[
							-81.71496490499993,
							30.360608007000053
						],
						[
							-81.7148589059999,
							30.360640009000065
						],
						[
							-81.71449690599991,
							30.360759008000063
						],
						[
							-81.71439890599993,
							30.36077700900006
						],
						[
							-81.71431890499993,
							30.360801008000067
						],
						[
							-81.7084659059999,
							30.362247008000054
						],
						[
							-81.7076139049999,
							30.362464008000075
						],
						[
							-81.70533790499991,
							30.362986008000064
						],
						[
							-81.70426890599994,
							30.363169008000057
						],
						[
							-81.70354490599993,
							30.36337500900004
						],
						[
							-81.6988578619999,
							30.36477293100006
						],
						[
							-81.6979059059999,
							30.36512400800007
						],
						[
							-81.69133488099993,
							30.366685921000055
						],
						[
							-81.68976290499995,
							30.367221008000058
						],
						[
							-81.68759190499992,
							30.367743009000034
						],
						[
							-81.68582591599994,
							30.36821188500005
						],
						[
							-81.68603079099995,
							30.367869876000047
						],
						[
							-81.68761690299993,
							30.36718200600006
						],
						[
							-81.6886780719999,
							30.366255087000074
						],
						[
							-81.6886807429999,
							30.36616492800005
						],
						[
							-81.6890419049999,
							30.365878008000042
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Grand Park",
				"RegionID": "124578"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.10290358399993,
					26.231835498000066,
					-80.09204812699994,
					26.243185509000057
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.09204812699994,
							26.240737467000088
						],
						[
							-80.09392743199993,
							26.231909682000037
						],
						[
							-80.09902133599991,
							26.231860226000038
						],
						[
							-80.10285412799993,
							26.231835498000066
						],
						[
							-80.1028788559999,
							26.233764258000065
						],
						[
							-80.10290358399993,
							26.235544652000044
						],
						[
							-80.10280467299992,
							26.23737450100009
						],
						[
							-80.10196393099994,
							26.243185509000057
						],
						[
							-80.0977602239999,
							26.243160781000086
						],
						[
							-80.09768604099992,
							26.24061382900004
						],
						[
							-80.09204812699994,
							26.240737467000088
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Pompano Beach",
				"Name": "Harbor Village",
				"RegionID": "124662"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-85.648556,
					30.167682999999997,
					-85.595588,
					30.212001
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-85.637557,
								30.171504
							],
							[
								-85.637557,
								30.170667000000005
							],
							[
								-85.637817,
								30.170684
							],
							[
								-85.638107,
								30.170684
							],
							[
								-85.638397,
								30.170680000000004
							],
							[
								-85.638389,
								30.171501
							],
							[
								-85.638092,
								30.171504
							],
							[
								-85.637557,
								30.171504
							]
						]
					],
					[
						[
							[
								-85.633369,
								30.17494
							],
							[
								-85.633399,
								30.171312000000004
							],
							[
								-85.633407,
								30.168563
							],
							[
								-85.633407,
								30.168194000000003
							],
							[
								-85.63354,
								30.168194000000003
							],
							[
								-85.633807,
								30.168295
							],
							[
								-85.634038,
								30.168405000000003
							],
							[
								-85.634038,
								30.168279000000002
							],
							[
								-85.634047,
								30.167682999999997
							],
							[
								-85.63446,
								30.16769
							],
							[
								-85.635482,
								30.167697000000004
							],
							[
								-85.63654300000002,
								30.167699
							],
							[
								-85.637603,
								30.167703
							],
							[
								-85.638626,
								30.167713000000003
							],
							[
								-85.638593,
								30.168413000000005
							],
							[
								-85.639266,
								30.168432000000003
							],
							[
								-85.639266,
								30.167719
							],
							[
								-85.640151,
								30.167727999999997
							],
							[
								-85.640144,
								30.168672000000004
							],
							[
								-85.641128,
								30.168659
							],
							[
								-85.641128,
								30.168437000000004
							],
							[
								-85.641822,
								30.168440999999998
							],
							[
								-85.641822,
								30.169466
							],
							[
								-85.64178,
								30.170407
							],
							[
								-85.641757,
								30.171396000000005
							],
							[
								-85.640655,
								30.171401
							],
							[
								-85.637954,
								30.169017
							],
							[
								-85.638053,
								30.168743
							],
							[
								-85.637817,
								30.168723999999997
							],
							[
								-85.637672,
								30.168747999999997
							],
							[
								-85.63758,
								30.169046
							],
							[
								-85.637573,
								30.169538
							],
							[
								-85.637565,
								30.169883000000002
							],
							[
								-85.636352,
								30.169847
							],
							[
								-85.636314,
								30.171519999999997
							],
							[
								-85.6343,
								30.171316
							],
							[
								-85.63507,
								30.173582000000003
							],
							[
								-85.635307,
								30.174089
							],
							[
								-85.635772,
								30.174968
							],
							[
								-85.635467,
								30.174963999999996
							],
							[
								-85.633369,
								30.17494
							]
						]
					],
					[
						[
							[
								-85.603256,
								30.191314
							],
							[
								-85.603439,
								30.191215
							],
							[
								-85.60334,
								30.193712
							],
							[
								-85.603401,
								30.194086
							],
							[
								-85.602561,
								30.19433
							],
							[
								-85.599758,
								30.195179
							],
							[
								-85.599634,
								30.195216999999996
							],
							[
								-85.599571,
								30.195122000000005
							],
							[
								-85.59880800000002,
								30.195089
							],
							[
								-85.598448,
								30.195074000000005
							],
							[
								-85.598838,
								30.194845
							],
							[
								-85.599268,
								30.194623000000004
							],
							[
								-85.5998,
								30.194347
							],
							[
								-85.602508,
								30.193880000000004
							],
							[
								-85.602485,
								30.193347000000003
							],
							[
								-85.602531,
								30.193069
							],
							[
								-85.602737,
								30.192557
							],
							[
								-85.60289,
								30.192178
							],
							[
								-85.602981,
								30.191842999999995
							],
							[
								-85.60308,
								30.19157
							],
							[
								-85.603179,
								30.191404
							],
							[
								-85.603256,
								30.191314
							]
						]
					],
					[
						[
							[
								-85.608029,
								30.198046
							],
							[
								-85.608029,
								30.197528000000002
							],
							[
								-85.608442,
								30.19755
							],
							[
								-85.608455,
								30.197509000000004
							],
							[
								-85.60875,
								30.197512999999997
							],
							[
								-85.608743,
								30.197953000000002
							],
							[
								-85.608362,
								30.197955000000004
							],
							[
								-85.608362,
								30.198048000000004
							],
							[
								-85.608029,
								30.198046
							]
						]
					],
					[
						[
							[
								-85.64361600000001,
								30.202053
							],
							[
								-85.643623,
								30.200491
							],
							[
								-85.643632,
								30.198577999999998
							],
							[
								-85.643638,
								30.197227
							],
							[
								-85.643646,
								30.196865999999996
							],
							[
								-85.644737,
								30.196802000000005
							],
							[
								-85.645568,
								30.196771
							],
							[
								-85.647743,
								30.196775
							],
							[
								-85.648338,
								30.196786
							],
							[
								-85.648389,
								30.197613
							],
							[
								-85.648523,
								30.197607
							],
							[
								-85.648553,
								30.198278000000002
							],
							[
								-85.648556,
								30.198528
							],
							[
								-85.64772,
								30.198560000000004
							],
							[
								-85.647438,
								30.198566000000003
							],
							[
								-85.647459,
								30.199611
							],
							[
								-85.647464,
								30.199816000000002
							],
							[
								-85.647495,
								30.201357
							],
							[
								-85.647816,
								30.201350999999995
							],
							[
								-85.64783,
								30.202087
							],
							[
								-85.64361600000001,
								30.202053
							]
						]
					],
					[
						[
							[
								-85.613906,
								30.202175000000004
							],
							[
								-85.613922,
								30.202175000000004
							],
							[
								-85.613938,
								30.202176
							],
							[
								-85.614055,
								30.202178000000004
							],
							[
								-85.61441,
								30.202184000000003
							],
							[
								-85.616539,
								30.202224
							],
							[
								-85.617797,
								30.202249
							],
							[
								-85.617998,
								30.202253000000002
							],
							[
								-85.618124,
								30.202255
							],
							[
								-85.618133,
								30.202255
							],
							[
								-85.619468,
								30.202285
							],
							[
								-85.619842,
								30.202293
							],
							[
								-85.620223,
								30.202301999999996
							],
							[
								-85.62149,
								30.202327
							],
							[
								-85.621742,
								30.202331000000004
							],
							[
								-85.621833,
								30.202541
							],
							[
								-85.620483,
								30.203132000000004
							],
							[
								-85.620354,
								30.203297
							],
							[
								-85.619956,
								30.203809000000003
							],
							[
								-85.619812,
								30.203310000000002
							],
							[
								-85.618476,
								30.203908
							],
							[
								-85.618476,
								30.204193
							],
							[
								-85.613945,
								30.204082
							],
							[
								-85.613944,
								30.204048
							],
							[
								-85.613906,
								30.202175000000004
							]
						]
					],
					[
						[
							[
								-85.62572300000001,
								30.207633
							],
							[
								-85.625823,
								30.20763
							],
							[
								-85.626014,
								30.208022999999997
							],
							[
								-85.626327,
								30.208585
							],
							[
								-85.626602,
								30.209163000000004
							],
							[
								-85.62647,
								30.209188999999995
							],
							[
								-85.626214,
								30.208569
							],
							[
								-85.626088,
								30.208327000000004
							],
							[
								-85.62572300000001,
								30.207633
							]
						]
					],
					[
						[
							[
								-85.629046,
								30.211679999999998
							],
							[
								-85.629033,
								30.210641999999996
							],
							[
								-85.627364,
								30.210691
							],
							[
								-85.627251,
								30.21068
							],
							[
								-85.626835,
								30.209861999999998
							],
							[
								-85.626853,
								30.209666
							],
							[
								-85.627296,
								30.210554
							],
							[
								-85.627944,
								30.210532
							],
							[
								-85.627942,
								30.209563
							],
							[
								-85.62823100000001,
								30.209582999999995
							],
							[
								-85.628254,
								30.209005
							],
							[
								-85.626808,
								30.208957
							],
							[
								-85.626861,
								30.208858
							],
							[
								-85.626883,
								30.208733
							],
							[
								-85.626892,
								30.208679000000004
							],
							[
								-85.62689400000001,
								30.208522
							],
							[
								-85.628957,
								30.208577000000002
							],
							[
								-85.631506,
								30.208594000000005
							],
							[
								-85.631506,
								30.209557999999998
							],
							[
								-85.633633,
								30.209576000000002
							],
							[
								-85.633663,
								30.210895
							],
							[
								-85.633664,
								30.211676
							],
							[
								-85.629989,
								30.211677
							],
							[
								-85.629046,
								30.211679999999998
							]
						]
					],
					[
						[
							[
								-85.613906,
								30.202175000000004
							],
							[
								-85.610252,
								30.202104
							],
							[
								-85.608337,
								30.20206
							],
							[
								-85.607765,
								30.202062
							],
							[
								-85.607757,
								30.202272
							],
							[
								-85.607749,
								30.203117000000002
							],
							[
								-85.607742,
								30.204084
							],
							[
								-85.607719,
								30.205566000000005
							],
							[
								-85.607696,
								30.207233
							],
							[
								-85.607551,
								30.212001
							],
							[
								-85.605218,
								30.211986
							],
							[
								-85.605199,
								30.211185
							],
							[
								-85.604736,
								30.211159999999996
							],
							[
								-85.604331,
								30.211217
							],
							[
								-85.604232,
								30.211263
							],
							[
								-85.604133,
								30.211275
							],
							[
								-85.603992,
								30.211275
							],
							[
								-85.603976,
								30.210939000000003
							],
							[
								-85.60384400000001,
								30.210834999999996
							],
							[
								-85.603298,
								30.210823
							],
							[
								-85.603309,
								30.210416000000002
							],
							[
								-85.603324,
								30.209877000000002
							],
							[
								-85.603317,
								30.208555000000004
							],
							[
								-85.601829,
								30.208526000000003
							],
							[
								-85.600807,
								30.20853
							],
							[
								-85.600775,
								30.208429999999996
							],
							[
								-85.601669,
								30.208446
							],
							[
								-85.603183,
								30.208435000000005
							],
							[
								-85.603261,
								30.204034999999998
							],
							[
								-85.602071,
								30.20404
							],
							[
								-85.601875,
								30.203857
							],
							[
								-85.60186,
								30.203828
							],
							[
								-85.601768,
								30.203645
							],
							[
								-85.601646,
								30.203535999999996
							],
							[
								-85.6016,
								30.203376000000002
							],
							[
								-85.601432,
								30.203094
							],
							[
								-85.601371,
								30.202901
							],
							[
								-85.601287,
								30.202724
							],
							[
								-85.601196,
								30.202589
							],
							[
								-85.601158,
								30.202486
							],
							[
								-85.601074,
								30.202165000000004
							],
							[
								-85.601081,
								30.201888999999998
							],
							[
								-85.60115000000002,
								30.201630999999995
							],
							[
								-85.60115000000002,
								30.201301
							],
							[
								-85.601097,
								30.201129
							],
							[
								-85.60102,
								30.200766999999995
							],
							[
								-85.600914,
								30.200651
							],
							[
								-85.600875,
								30.200515
							],
							[
								-85.600837,
								30.200277
							],
							[
								-85.600807,
								30.200178
							],
							[
								-85.60073,
								30.200046
							],
							[
								-85.600456,
								30.199798
							],
							[
								-85.600273,
								30.199678
							],
							[
								-85.600135,
								30.199484999999996
							],
							[
								-85.599967,
								30.199354
							],
							[
								-85.599708,
								30.199188
							],
							[
								-85.599479,
								30.199077
							],
							[
								-85.59920500000001,
								30.19881
							],
							[
								-85.59909,
								30.198713000000005
							],
							[
								-85.598915,
								30.198598
							],
							[
								-85.598815,
								30.198503000000002
							],
							[
								-85.598747,
								30.198432
							],
							[
								-85.598358,
								30.198345
							],
							[
								-85.597816,
								30.198301000000004
							],
							[
								-85.597549,
								30.198123
							],
							[
								-85.597366,
								30.197952000000004
							],
							[
								-85.597274,
								30.197908
							],
							[
								-85.597175,
								30.197902
							],
							[
								-85.597099,
								30.197866
							],
							[
								-85.597091,
								30.197797
							],
							[
								-85.597045,
								30.197713
							],
							[
								-85.596954,
								30.197665999999998
							],
							[
								-85.596817,
								30.197656
							],
							[
								-85.596748,
								30.197621999999996
							],
							[
								-85.596626,
								30.197494
							],
							[
								-85.596443,
								30.197449999999996
							],
							[
								-85.596244,
								30.19725
							],
							[
								-85.596038,
								30.197172
							],
							[
								-85.595726,
								30.196895000000005
							],
							[
								-85.59568,
								30.196809000000002
							],
							[
								-85.595588,
								30.196748000000003
							],
							[
								-85.59591100000002,
								30.196558999999997
							],
							[
								-85.596043,
								30.196561999999997
							],
							[
								-85.598441,
								30.196618000000004
							],
							[
								-85.59836,
								30.197217
							],
							[
								-85.598338,
								30.198253999999995
							],
							[
								-85.601048,
								30.198218
							],
							[
								-85.60106000000002,
								30.197567000000003
							],
							[
								-85.601286,
								30.197571
							],
							[
								-85.601272,
								30.198215
							],
							[
								-85.601295,
								30.198282
							],
							[
								-85.601394,
								30.198303
							],
							[
								-85.602363,
								30.198322000000005
							],
							[
								-85.6031,
								30.198336
							],
							[
								-85.60337,
								30.198340999999996
							],
							[
								-85.603461,
								30.198343000000005
							],
							[
								-85.603445,
								30.199194
							],
							[
								-85.604806,
								30.199201
							],
							[
								-85.604798,
								30.198475
							],
							[
								-85.605076,
								30.198482000000002
							],
							[
								-85.605083,
								30.199235
							],
							[
								-85.605491,
								30.199231000000005
							],
							[
								-85.605484,
								30.198495
							],
							[
								-85.605592,
								30.198499000000005
							],
							[
								-85.605726,
								30.198503000000002
							],
							[
								-85.60675,
								30.198537
							],
							[
								-85.607801,
								30.198571
							],
							[
								-85.607792,
								30.199364000000003
							],
							[
								-85.607231,
								30.19938
							],
							[
								-85.607237,
								30.199755000000003
							],
							[
								-85.607788,
								30.199760000000005
							],
							[
								-85.607788,
								30.20009
							],
							[
								-85.607788,
								30.200120000000002
							],
							[
								-85.608126,
								30.200136999999998
							],
							[
								-85.60812300000002,
								30.200078
							],
							[
								-85.60829900000002,
								30.200074999999995
							],
							[
								-85.608304,
								30.200137999999995
							],
							[
								-85.609244,
								30.200152000000003
							],
							[
								-85.609237,
								30.198683999999997
							],
							[
								-85.609232,
								30.198683999999997
							],
							[
								-85.609235,
								30.198458000000002
							],
							[
								-85.609279,
								30.198499000000005
							],
							[
								-85.60942500000002,
								30.198632000000003
							],
							[
								-85.609771,
								30.198624000000002
							],
							[
								-85.61081700000001,
								30.198634
							],
							[
								-85.611343,
								30.198635000000003
							],
							[
								-85.612166,
								30.19864
							],
							[
								-85.612393,
								30.198628
							],
							[
								-85.612391,
								30.198732000000003
							],
							[
								-85.612382,
								30.199179
							],
							[
								-85.61287,
								30.199176000000005
							],
							[
								-85.612867,
								30.19877
							],
							[
								-85.612867,
								30.198667
							],
							[
								-85.613823,
								30.198671000000004
							],
							[
								-85.61396,
								30.198553
							],
							[
								-85.614105,
								30.198553999999998
							],
							[
								-85.614089,
								30.198813999999995
							],
							[
								-85.61406600000001,
								30.199579
							],
							[
								-85.61414,
								30.199578000000002
							],
							[
								-85.614399,
								30.199582
							],
							[
								-85.614395,
								30.199427000000004
							],
							[
								-85.6145,
								30.199431
							],
							[
								-85.615641,
								30.199454000000003
							],
							[
								-85.615679,
								30.198773
							],
							[
								-85.616555,
								30.198791
							],
							[
								-85.616561,
								30.200410000000005
							],
							[
								-85.613929,
								30.200359
							],
							[
								-85.613929,
								30.200368000000005
							],
							[
								-85.613927,
								30.200486000000005
							],
							[
								-85.613906,
								30.202175000000004
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Bay",
				"City": "Panama City",
				"Name": "Hiland Park",
				"RegionID": "124728"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.14896799999991,
					25.847583000000043,
					-80.12425154499994,
					25.862318771000048
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.12913440599993,
							25.859858704000093
						],
						[
							-80.12920895299993,
							25.859038681000076
						],
						[
							-80.12600341099994,
							25.854789474000086
						],
						[
							-80.12518338799993,
							25.85445401000004
						],
						[
							-80.12425154499994,
							25.851807574000077
						],
						[
							-80.13122173599993,
							25.85098755200005
						],
						[
							-80.13434146399993,
							25.84823128800008
						],
						[
							-80.13506093199993,
							25.847595641000055
						],
						[
							-80.14345199999991,
							25.847583000000043
						],
						[
							-80.14507999999995,
							25.849260000000072
						],
						[
							-80.14850799999994,
							25.852174000000048
						],
						[
							-80.14896799999991,
							25.852573000000064
						],
						[
							-80.14781599999993,
							25.859481000000073
						],
						[
							-80.14746799999995,
							25.861573000000078
						],
						[
							-80.14736221699991,
							25.862201218000052
						],
						[
							-80.13271268499994,
							25.862318771000048
						],
						[
							-80.13084899799992,
							25.861647843000075
						],
						[
							-80.12958169099994,
							25.86045508300009
						],
						[
							-80.12913440599993,
							25.859858704000093
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Beach",
				"Name": "Isle of Normandy",
				"RegionID": "124846"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.79745196899995,
					30.232973008000045,
					-81.7722359679999,
					30.26976109700007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.7722359679999,
							30.26976109700007
						],
						[
							-81.77232790599994,
							30.26957200900006
						],
						[
							-81.77239290599994,
							30.269468009000036
						],
						[
							-81.77250490499995,
							30.269288012000064
						],
						[
							-81.77271290599992,
							30.269079009000052
						],
						[
							-81.7728129059999,
							30.26900500800008
						],
						[
							-81.77312290499992,
							30.268791009000036
						],
						[
							-81.7733660429999,
							30.26863311400007
						],
						[
							-81.77344890599994,
							30.268358009000057
						],
						[
							-81.77468409199992,
							30.26429197400006
						],
						[
							-81.7732927269999,
							30.262487073000045
						],
						[
							-81.77327490599993,
							30.261211008000085
						],
						[
							-81.77325790599991,
							30.260483009000044
						],
						[
							-81.77323690599991,
							30.259359008000047
						],
						[
							-81.7732189059999,
							30.258532008000092
						],
						[
							-81.77320990599992,
							30.25808100800009
						],
						[
							-81.77320390599994,
							30.25766600900005
						],
						[
							-81.7731929059999,
							30.257006008000076
						],
						[
							-81.77316890499992,
							30.255926009000063
						],
						[
							-81.77315890599994,
							30.255333008000036
						],
						[
							-81.77314690499993,
							30.254575008000074
						],
						[
							-81.77312890499991,
							30.25379800800005
						],
						[
							-81.7731079049999,
							30.252252009000074
						],
						[
							-81.77309190599993,
							30.251255008000044
						],
						[
							-81.77306790499995,
							30.250245009000082
						],
						[
							-81.77305790499992,
							30.250120008000067
						],
						[
							-81.77304890599993,
							30.248840008000055
						],
						[
							-81.77305195899993,
							30.248347007000064
						],
						[
							-81.77305090499995,
							30.24826500900008
						],
						[
							-81.77305190499993,
							30.248165009000044
						],
						[
							-81.77304990499994,
							30.247183008000036
						],
						[
							-81.77304590599994,
							30.24626500800008
						],
						[
							-81.77304390599994,
							30.245933008000062
						],
						[
							-81.77305190499993,
							30.244645008000077
						],
						[
							-81.77304790599993,
							30.24389100900004
						],
						[
							-81.7730389059999,
							30.243317008000076
						],
						[
							-81.77304590599994,
							30.243006008000066
						],
						[
							-81.77302190599994,
							30.240495009000085
						],
						[
							-81.77302890499993,
							30.240336008000043
						],
						[
							-81.77303590599992,
							30.238288008000044
						],
						[
							-81.77302590599993,
							30.236425009000072
						],
						[
							-81.77305690599991,
							30.235324009000063
						],
						[
							-81.7730429049999,
							30.235163008000086
						],
						[
							-81.7730379059999,
							30.23453300800009
						],
						[
							-81.77302390599993,
							30.23422800800006
						],
						[
							-81.77302890599992,
							30.233931008000066
						],
						[
							-81.77301590699996,
							30.233203953000046
						],
						[
							-81.77540490599995,
							30.233158009000082
						],
						[
							-81.7787779059999,
							30.233109008000042
						],
						[
							-81.7809829059999,
							30.233082009000043
						],
						[
							-81.78268390599993,
							30.233059008000055
						],
						[
							-81.7830349059999,
							30.233061009000043
						],
						[
							-81.78376790599994,
							30.233046008000088
						],
						[
							-81.78514090599992,
							30.23305300800007
						],
						[
							-81.78570590499993,
							30.233046008000088
						],
						[
							-81.78684190599995,
							30.23304900800008
						],
						[
							-81.7872699049999,
							30.233044009000082
						],
						[
							-81.78758990599994,
							30.233051008000075
						],
						[
							-81.78803291499992,
							30.23304595700006
						],
						[
							-81.78808589999994,
							30.23306109300006
						],
						[
							-81.78825390599991,
							30.23303800900004
						],
						[
							-81.78873390599995,
							30.233013008000057
						],
						[
							-81.78917690499993,
							30.23300400900007
						],
						[
							-81.7905119049999,
							30.233007008000072
						],
						[
							-81.79144290499994,
							30.232992008000057
						],
						[
							-81.7920609059999,
							30.232992008000057
						],
						[
							-81.79345690399992,
							30.232973008000045
						],
						[
							-81.79387799699992,
							30.23299198600006
						],
						[
							-81.79431190499992,
							30.238215008000054
						],
						[
							-81.79412790599991,
							30.240332008000053
						],
						[
							-81.7940547739999,
							30.24116603000005
						],
						[
							-81.79443790699993,
							30.24248600800007
						],
						[
							-81.7948539059999,
							30.243347009000047
						],
						[
							-81.79524790599993,
							30.24418200900004
						],
						[
							-81.7956249049999,
							30.245023009000075
						],
						[
							-81.79603580499992,
							30.245844093000073
						],
						[
							-81.7971910519999,
							30.246735914000055
						],
						[
							-81.79740390599994,
							30.247570007000036
						],
						[
							-81.79742790599994,
							30.24766100900007
						],
						[
							-81.79745196899995,
							30.24773601000004
						],
						[
							-81.79634890699992,
							30.247773010000056
						],
						[
							-81.7960587739999,
							30.247781882000083
						],
						[
							-81.7960819079999,
							30.24858301000006
						],
						[
							-81.79611990799992,
							30.249456011000063
						],
						[
							-81.7961499079999,
							30.250332011000065
						],
						[
							-81.79616490799992,
							30.25118801000008
						],
						[
							-81.79620390799994,
							30.252050011000055
						],
						[
							-81.79624890699995,
							30.25290901100004
						],
						[
							-81.79626490699991,
							30.253769011000088
						],
						[
							-81.79628790699991,
							30.254143010000067
						],
						[
							-81.79629490799994,
							30.254602011000088
						],
						[
							-81.7962800389999,
							30.25487314500009
						],
						[
							-81.79458590799993,
							30.25491001000006
						],
						[
							-81.79424990799993,
							30.254911010000058
						],
						[
							-81.79367090799991,
							30.254917011000092
						],
						[
							-81.79219790799993,
							30.25495101000007
						],
						[
							-81.79116790799992,
							30.254967010000087
						],
						[
							-81.79010790699994,
							30.254993010000078
						],
						[
							-81.78962677599992,
							30.255006880000053
						],
						[
							-81.78961190799993,
							30.256283011000047
						],
						[
							-81.78961190799993,
							30.25750501100003
						],
						[
							-81.78959690699992,
							30.258423010000058
						],
						[
							-81.78960390799995,
							30.258734011000058
						],
						[
							-81.78958107099993,
							30.262272101000068
						],
						[
							-81.78936487399994,
							30.26240597000009
						],
						[
							-81.78908498899995,
							30.262709163000068
						],
						[
							-81.7888639059999,
							30.26273201200007
						],
						[
							-81.78864290699994,
							30.262804010000085
						],
						[
							-81.78849790699991,
							30.262833009000072
						],
						[
							-81.7878797759999,
							30.26284188100004
						],
						[
							-81.78789485599992,
							30.263393019000038
						],
						[
							-81.78796390999992,
							30.263624011000047
						],
						[
							-81.7880479079999,
							30.26376700800006
						],
						[
							-81.7882309069999,
							30.263969011000082
						],
						[
							-81.78843690799994,
							30.26420201100007
						],
						[
							-81.78852790699996,
							30.264320011000052
						],
						[
							-81.78862790699992,
							30.264471013000048
						],
						[
							-81.78868890699994,
							30.264635011000053
						],
						[
							-81.78871890699992,
							30.264765012000055
						],
						[
							-81.78872690799994,
							30.26495201100005
						],
						[
							-81.78873390899992,
							30.26513500900006
						],
						[
							-81.7887569099999,
							30.265245007000093
						],
						[
							-81.78882590799992,
							30.26536000600004
						],
						[
							-81.78887890699991,
							30.26541301100008
						],
						[
							-81.78896290799992,
							30.26549001000006
						],
						[
							-81.78909296899991,
							30.26557495100008
						],
						[
							-81.78916190599995,
							30.265688013000045
						],
						[
							-81.78919190699992,
							30.26581201300007
						],
						[
							-81.7891919079999,
							30.26610900900005
						],
						[
							-81.78920004199995,
							30.26614999800006
						],
						[
							-81.78919195899994,
							30.266222021000086
						],
						[
							-81.78916190399991,
							30.266285011000036
						],
						[
							-81.7891279079999,
							30.266326008000075
						],
						[
							-81.78903996799994,
							30.266390176000073
						],
						[
							-81.78887890699991,
							30.26640101000004
						],
						[
							-81.78825376599993,
							30.266391891000072
						],
						[
							-81.78831090799991,
							30.26666200700004
						],
						[
							-81.78936003899992,
							30.268935979000048
						],
						[
							-81.78926090599992,
							30.26892300800006
						],
						[
							-81.7890469059999,
							30.268871008000076
						],
						[
							-81.78826090599995,
							30.268555009000064
						],
						[
							-81.7881239059999,
							30.26851700900005
						],
						[
							-81.7879409059999,
							30.26849600900005
						],
						[
							-81.78768890599991,
							30.268499009000042
						],
						[
							-81.7875139059999,
							30.268528008000086
						],
						[
							-81.78737590499992,
							30.26857001000008
						],
						[
							-81.7872009059999,
							30.268661010000077
						],
						[
							-81.78713990599995,
							30.26871100900007
						],
						[
							-81.78695690699993,
							30.268902009000044
						],
						[
							-81.78685790499992,
							30.26904900800008
						],
						[
							-81.78673590499994,
							30.26919700800005
						],
						[
							-81.78666690499995,
							30.269260008000064
						],
						[
							-81.78657490499995,
							30.269339008000088
						],
						[
							-81.78646090599995,
							30.269421007000066
						],
						[
							-81.78627490799994,
							30.269514006000065
						],
						[
							-81.78605690899991,
							30.269575006000082
						],
						[
							-81.7857359059999,
							30.26960400900009
						],
						[
							-81.78487390499993,
							30.26961300800008
						],
						[
							-81.78127190599992,
							30.269675008000036
						],
						[
							-81.77972890599995,
							30.26968900800006
						],
						[
							-81.77888190499993,
							30.269675008000036
						],
						[
							-81.77878590499995,
							30.269672008000043
						],
						[
							-81.77784890499993,
							30.269656008000084
						],
						[
							-81.77728290499994,
							30.269663009000055
						],
						[
							-81.77664890599993,
							30.269674008000038
						],
						[
							-81.77469590599992,
							30.26971800800004
						],
						[
							-81.77356890599992,
							30.26973500800006
						],
						[
							-81.77305590599991,
							30.269747008000078
						],
						[
							-81.77273390499994,
							30.26975600800006
						],
						[
							-81.77250390499995,
							30.269753008000066
						],
						[
							-81.7722359679999,
							30.26976109700007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Jacksonville Heights",
				"RegionID": "124860"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.50568699999997,
					27.351714000000072,
					-82.47877599999998,
					27.370615000000047
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.49787799999996,
							27.36332200000004
						],
						[
							-82.49730499999998,
							27.363316000000054
						],
						[
							-82.49641099999997,
							27.363309000000072
						],
						[
							-82.49596199999996,
							27.363300000000038
						],
						[
							-82.49478599999998,
							27.363278000000037
						],
						[
							-82.49468699999994,
							27.36328100000003
						],
						[
							-82.49328099999997,
							27.363261000000023
						],
						[
							-82.49327899999997,
							27.363369000000034
						],
						[
							-82.49329299999994,
							27.364756000000057
						],
						[
							-82.49333399999995,
							27.36691000000008
						],
						[
							-82.49334999999996,
							27.367756000000046
						],
						[
							-82.49337399999996,
							27.36850700000008
						],
						[
							-82.49336499999998,
							27.368688000000077
						],
						[
							-82.49331799999999,
							27.36913500000003
						],
						[
							-82.49329699999998,
							27.369403000000034
						],
						[
							-82.49328999999994,
							27.369613000000072
						],
						[
							-82.49328899999995,
							27.370025000000055
						],
						[
							-82.49328399999996,
							27.370284000000026
						],
						[
							-82.49326899999994,
							27.37037600000008
						],
						[
							-82.49324899999995,
							27.370425000000072
						],
						[
							-82.49322699999999,
							27.37045900000004
						],
						[
							-82.49320399999995,
							27.370486000000028
						],
						[
							-82.49315399999995,
							27.37052700000004
						],
						[
							-82.49310999999996,
							27.37054900000004
						],
						[
							-82.49306199999995,
							27.37056300000006
						],
						[
							-82.49300299999999,
							27.370568000000052
						],
						[
							-82.49095799999998,
							27.370568000000052
						],
						[
							-82.48974799999996,
							27.37057500000003
						],
						[
							-82.48832499999997,
							27.370596000000035
						],
						[
							-82.48796099999998,
							27.370599000000027
						],
						[
							-82.48698299999995,
							27.370615000000047
						],
						[
							-82.48700599999995,
							27.370073000000048
						],
						[
							-82.48698999999993,
							27.368904000000047
						],
						[
							-82.48695399999997,
							27.368288000000064
						],
						[
							-82.48689599999994,
							27.368272000000047
						],
						[
							-82.48679799999996,
							27.368229000000042
						],
						[
							-82.48674599999998,
							27.368199000000065
						],
						[
							-82.48668199999999,
							27.368153000000067
						],
						[
							-82.48641499999997,
							27.367896000000034
						],
						[
							-82.48636299999998,
							27.367814000000067
						],
						[
							-82.48633199999995,
							27.36772300000007
						],
						[
							-82.48632399999997,
							27.36764900000003
						],
						[
							-82.48632899999996,
							27.36705500000005
						],
						[
							-82.48631399999994,
							27.366783000000055
						],
						[
							-82.48632399999997,
							27.366184000000032
						],
						[
							-82.48631699999999,
							27.366127000000063
						],
						[
							-82.48628299999996,
							27.366000000000042
						],
						[
							-82.48618499999998,
							27.365869000000032
						],
						[
							-82.48614299999997,
							27.365827000000024
						],
						[
							-82.48601899999994,
							27.36573100000004
						],
						[
							-82.48595599999999,
							27.365670000000026
						],
						[
							-82.48589099999998,
							27.365585000000067
						],
						[
							-82.48584999999997,
							27.36549800000006
						],
						[
							-82.48583299999996,
							27.36543600000005
						],
						[
							-82.48582399999998,
							27.365384000000063
						],
						[
							-82.48581999999999,
							27.365320000000054
						],
						[
							-82.48582399999998,
							27.365266000000076
						],
						[
							-82.48583599999995,
							27.365202000000068
						],
						[
							-82.48585199999997,
							27.36515000000003
						],
						[
							-82.48587799999996,
							27.36508900000007
						],
						[
							-82.48591199999998,
							27.365032000000042
						],
						[
							-82.48593899999997,
							27.364996000000076
						],
						[
							-82.48596999999995,
							27.364963000000046
						],
						[
							-82.48603899999995,
							27.364904000000024
						],
						[
							-82.48612799999995,
							27.364851000000044
						],
						[
							-82.48620299999999,
							27.36481800000007
						],
						[
							-82.48626999999999,
							27.364797000000067
						],
						[
							-82.48633899999999,
							27.364782000000048
						],
						[
							-82.48676299999994,
							27.364737000000048
						],
						[
							-82.48691499999995,
							27.364711000000057
						],
						[
							-82.48701699999998,
							27.364680000000078
						],
						[
							-82.48710499999999,
							27.364645000000053
						],
						[
							-82.48726999999997,
							27.364559000000042
						],
						[
							-82.48739699999999,
							27.36443200000008
						],
						[
							-82.48746899999998,
							27.364332000000047
						],
						[
							-82.48750999999999,
							27.364254000000074
						],
						[
							-82.48754599999995,
							27.36416200000008
						],
						[
							-82.48756699999996,
							27.364078000000063
						],
						[
							-82.48757599999999,
							27.364004000000023
						],
						[
							-82.487577,
							27.363919000000067
						],
						[
							-82.48756699999996,
							27.36382400000008
						],
						[
							-82.48755099999994,
							27.363751000000036
						],
						[
							-82.48749199999997,
							27.363593000000037
						],
						[
							-82.48738799999997,
							27.363402000000065
						],
						[
							-82.48750599999994,
							27.363298000000043
						],
						[
							-82.48754599999995,
							27.363251000000048
						],
						[
							-82.48761399999995,
							27.363155000000063
						],
						[
							-82.48778899999996,
							27.36283700000007
						],
						[
							-82.48780099999999,
							27.362795000000062
						],
						[
							-82.48780599999998,
							27.362731000000053
						],
						[
							-82.48779499999995,
							27.362667000000044
						],
						[
							-82.48777499999994,
							27.36261600000006
						],
						[
							-82.48773699999998,
							27.362561000000028
						],
						[
							-82.48768999999999,
							27.362516000000028
						],
						[
							-82.487622,
							27.362476000000072
						],
						[
							-82.48758999999995,
							27.362464000000045
						],
						[
							-82.48750099999995,
							27.36244800000003
						],
						[
							-82.48714199999995,
							27.362428000000023
						],
						[
							-82.48699699999997,
							27.362414000000058
						],
						[
							-82.48630899999996,
							27.36229700000007
						],
						[
							-82.48616699999997,
							27.362291000000027
						],
						[
							-82.48596699999996,
							27.36232300000006
						],
						[
							-82.48591399999998,
							27.362227000000075
						],
						[
							-82.48581799999994,
							27.362090000000023
						],
						[
							-82.48573999999996,
							27.361996000000033
						],
						[
							-82.48566699999998,
							27.361925000000042
						],
						[
							-82.48558599999996,
							27.361861000000033
						],
						[
							-82.48548699999998,
							27.361799000000076
						],
						[
							-82.48539199999999,
							27.361752000000024
						],
						[
							-82.48529199999996,
							27.361712000000068
						],
						[
							-82.48515399999997,
							27.361667000000068
						],
						[
							-82.48489499999994,
							27.361601000000064
						],
						[
							-82.48467699999998,
							27.36156600000004
						],
						[
							-82.48439799999994,
							27.361548000000028
						],
						[
							-82.48424199999994,
							27.361530000000073
						],
						[
							-82.48406399999999,
							27.361498000000044
						],
						[
							-82.48394999999994,
							27.361469000000056
						],
						[
							-82.48386699999998,
							27.361448000000053
						],
						[
							-82.48368699999999,
							27.361391000000026
						],
						[
							-82.48351299999996,
							27.361321000000032
						],
						[
							-82.48338599999994,
							27.361261000000074
						],
						[
							-82.48320699999994,
							27.36115600000005
						],
						[
							-82.48299599999996,
							27.361034000000075
						],
						[
							-82.48251899999997,
							27.360741000000075
						],
						[
							-82.48244999999997,
							27.36068800000004
						],
						[
							-82.48239499999994,
							27.36063900000005
						],
						[
							-82.48220199999997,
							27.36044500000003
						],
						[
							-82.48213299999998,
							27.360389000000055
						],
						[
							-82.48205799999994,
							27.360337000000072
						],
						[
							-82.48197799999997,
							27.360289000000023
						],
						[
							-82.48188299999998,
							27.360243000000025
						],
						[
							-82.48178399999995,
							27.360204000000067
						],
						[
							-82.48169299999995,
							27.36017700000008
						],
						[
							-82.48155199999997,
							27.36014700000004
						],
						[
							-82.48141399999997,
							27.360134000000073
						],
						[
							-82.48051699999996,
							27.36012800000003
						],
						[
							-82.48032699999999,
							27.360127000000034
						],
						[
							-82.48022399999996,
							27.360131000000024
						],
						[
							-82.47982699999994,
							27.36017300000003
						],
						[
							-82.47962299999995,
							27.360172000000034
						],
						[
							-82.47947399999998,
							27.360153000000025
						],
						[
							-82.47920599999998,
							27.360093000000063
						],
						[
							-82.47877599999998,
							27.359980000000064
						],
						[
							-82.47891699999997,
							27.35957400000007
						],
						[
							-82.47898799999996,
							27.35934400000008
						],
						[
							-82.47905499999996,
							27.359073000000024
						],
						[
							-82.47910399999995,
							27.358810000000062
						],
						[
							-82.47911899999997,
							27.358681000000047
						],
						[
							-82.47914299999997,
							27.35838700000005
						],
						[
							-82.47914599999996,
							27.357398000000046
						],
						[
							-82.47915799999998,
							27.357221000000038
						],
						[
							-82.47918499999999,
							27.35706300000004
						],
						[
							-82.47921999999994,
							27.356926000000044
						],
						[
							-82.47927599999997,
							27.356783000000064
						],
						[
							-82.47934899999996,
							27.356645000000075
						],
						[
							-82.47946499999996,
							27.356480000000033
						],
						[
							-82.47962899999999,
							27.356307000000072
						],
						[
							-82.47978899999998,
							27.356174000000067
						],
						[
							-82.47996699999999,
							27.356060000000074
						],
						[
							-82.48014899999998,
							27.355972000000065
						],
						[
							-82.48036499999995,
							27.355894000000035
						],
						[
							-82.48055199999999,
							27.35584700000004
						],
						[
							-82.48094099999997,
							27.35577100000006
						],
						[
							-82.48173199999997,
							27.35561800000005
						],
						[
							-82.48193399999997,
							27.355559000000028
						],
						[
							-82.48212199999995,
							27.355484000000047
						],
						[
							-82.48232199999995,
							27.355375000000038
						],
						[
							-82.48251299999998,
							27.35524000000004
						],
						[
							-82.48267499999997,
							27.35509200000007
						],
						[
							-82.48282399999994,
							27.35492000000005
						],
						[
							-82.48291399999994,
							27.354790000000037
						],
						[
							-82.48298799999998,
							27.35465300000004
						],
						[
							-82.48305299999998,
							27.35450300000008
						],
						[
							-82.48309899999998,
							27.354359000000045
						],
						[
							-82.48332899999997,
							27.35330300000004
						],
						[
							-82.48347299999995,
							27.35281800000007
						],
						[
							-82.48349499999995,
							27.35268700000006
						],
						[
							-82.48349599999995,
							27.35252200000008
						],
						[
							-82.48348499999997,
							27.35231600000003
						],
						[
							-82.48473499999994,
							27.352325000000064
						],
						[
							-82.48479399999997,
							27.352324000000067
						],
						[
							-82.48563399999995,
							27.352317000000028
						],
						[
							-82.48652299999998,
							27.352301000000068
						],
						[
							-82.48701999999997,
							27.352305000000058
						],
						[
							-82.48761699999994,
							27.352306000000056
						],
						[
							-82.48897899999999,
							27.352129000000048
						],
						[
							-82.48925399999996,
							27.352127000000053
						],
						[
							-82.48926199999994,
							27.351908000000037
						],
						[
							-82.49126899999999,
							27.35194800000005
						],
						[
							-82.49236099999996,
							27.35206100000005
						],
						[
							-82.49228199999999,
							27.35220300000003
						],
						[
							-82.49309999999997,
							27.35219300000006
						],
						[
							-82.49364899999995,
							27.35222600000003
						],
						[
							-82.49455199999994,
							27.35224500000004
						],
						[
							-82.49503799999997,
							27.352250000000026
						],
						[
							-82.49555199999998,
							27.352352000000053
						],
						[
							-82.49572099999995,
							27.35236100000003
						],
						[
							-82.49627299999997,
							27.35238300000003
						],
						[
							-82.49697199999997,
							27.352389000000073
						],
						[
							-82.49724999999995,
							27.35238400000003
						],
						[
							-82.49724099999997,
							27.35212100000007
						],
						[
							-82.49723999999998,
							27.351849000000072
						],
						[
							-82.49723999999998,
							27.35177600000003
						],
						[
							-82.50001299999997,
							27.351770000000045
						],
						[
							-82.50094499999994,
							27.351714000000072
						],
						[
							-82.50566499999996,
							27.351728000000037
						],
						[
							-82.50566399999997,
							27.351788000000056
						],
						[
							-82.50566199999997,
							27.351891000000023
						],
						[
							-82.50566299999997,
							27.352166000000068
						],
						[
							-82.50567399999994,
							27.352374000000054
						],
						[
							-82.50568199999998,
							27.35251100000005
						],
						[
							-82.50568699999997,
							27.352602000000047
						],
						[
							-82.50568599999997,
							27.352943000000042
						],
						[
							-82.50568499999997,
							27.35334100000006
						],
						[
							-82.50568399999997,
							27.353809000000073
						],
						[
							-82.50568099999998,
							27.354314000000045
						],
						[
							-82.50568199999998,
							27.354553000000067
						],
						[
							-82.50566999999997,
							27.355296000000067
						],
						[
							-82.50567699999993,
							27.356036000000078
						],
						[
							-82.50567299999994,
							27.35677700000008
						],
						[
							-82.50568499999997,
							27.357706000000064
						],
						[
							-82.50567699999993,
							27.359736000000055
						],
						[
							-82.50567599999994,
							27.36163700000003
						],
						[
							-82.50567399999994,
							27.362839000000065
						],
						[
							-82.50567299999994,
							27.36289800000003
						],
						[
							-82.50567199999996,
							27.363026000000048
						],
						[
							-82.50567099999995,
							27.36312900000007
						],
						[
							-82.50566899999995,
							27.363311000000067
						],
						[
							-82.50547299999994,
							27.363323000000037
						],
						[
							-82.50521799999996,
							27.363330000000076
						],
						[
							-82.50412999999998,
							27.36333300000007
						],
						[
							-82.50164699999993,
							27.363343000000043
						],
						[
							-82.50006999999994,
							27.36334000000005
						],
						[
							-82.49787799999996,
							27.36332200000004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Kensington Park",
				"RegionID": "124921"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.15606599999995,
					26.438982000000067,
					-80.12219199999998,
					26.453751000000068
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.15606599999995,
							26.445752000000027
						],
						[
							-80.15606599999995,
							26.445843000000025
						],
						[
							-80.15606599999995,
							26.446352000000047
						],
						[
							-80.15567099999998,
							26.446695000000034
						],
						[
							-80.15524099999999,
							26.44674100000003
						],
						[
							-80.15495099999998,
							26.446772000000067
						],
						[
							-80.15503499999996,
							26.449457000000052
						],
						[
							-80.15506599999998,
							26.45038500000004
						],
						[
							-80.15516899999994,
							26.45180300000004
						],
						[
							-80.15520699999996,
							26.45332700000006
						],
						[
							-80.15517899999998,
							26.453362000000027
						],
						[
							-80.15514699999994,
							26.453389000000072
						],
						[
							-80.15510599999999,
							26.453414000000066
						],
						[
							-80.15510499999993,
							26.453527000000065
						],
						[
							-80.15195699999998,
							26.453538000000037
						],
						[
							-80.15007399999996,
							26.453644000000054
						],
						[
							-80.14897799999994,
							26.453613000000075
						],
						[
							-80.14707599999997,
							26.453557000000046
						],
						[
							-80.14618199999995,
							26.453517000000033
						],
						[
							-80.13810799999999,
							26.453307000000052
						],
						[
							-80.13794199999995,
							26.453643000000056
						],
						[
							-80.13106899999997,
							26.453741000000036
						],
						[
							-80.13076599999994,
							26.453751000000068
						],
						[
							-80.13050399999997,
							26.44636500000007
						],
						[
							-80.12986799999999,
							26.44666200000006
						],
						[
							-80.12234299999994,
							26.44658000000004
						],
						[
							-80.12232799999998,
							26.445881000000043
						],
						[
							-80.12230299999999,
							26.44467000000003
						],
						[
							-80.12226599999997,
							26.442871000000025
						],
						[
							-80.12219199999998,
							26.439320000000066
						],
						[
							-80.12499099999997,
							26.439317000000074
						],
						[
							-80.12625399999996,
							26.43931600000008
						],
						[
							-80.12864999999994,
							26.439301000000057
						],
						[
							-80.12864399999997,
							26.43905200000006
						],
						[
							-80.13036599999998,
							26.43905200000006
						],
						[
							-80.13056399999995,
							26.439054000000056
						],
						[
							-80.13296999999994,
							26.43905200000006
						],
						[
							-80.13347799999997,
							26.43904500000008
						],
						[
							-80.13834399999998,
							26.43904200000003
						],
						[
							-80.14002699999998,
							26.43905200000006
						],
						[
							-80.14656999999994,
							26.438982000000067
						],
						[
							-80.15200999999996,
							26.439018000000033
						],
						[
							-80.15433299999995,
							26.439006000000063
						],
						[
							-80.15606599999995,
							26.43905200000006
						],
						[
							-80.15604299999995,
							26.439125000000047
						],
						[
							-80.15605399999998,
							26.44033200000007
						],
						[
							-80.15606599999995,
							26.441752000000065
						],
						[
							-80.15606599999995,
							26.443035000000066
						],
						[
							-80.15606599999995,
							26.443052000000023
						],
						[
							-80.15606599999995,
							26.443952000000024
						],
						[
							-80.15606599999995,
							26.44441000000006
						],
						[
							-80.15606599999995,
							26.444852000000026
						],
						[
							-80.15606599999995,
							26.445752000000027
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Delray Beach",
				"Name": "Kings Point",
				"RegionID": "124944"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.44851199999994,
					27.280846000000054,
					-82.42211999999995,
					27.29881000000006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.42978899999997,
							27.28170700000004
						],
						[
							-82.42931499999997,
							27.280846000000054
						],
						[
							-82.42952599999995,
							27.281110000000073
						],
						[
							-82.42991399999994,
							27.281620000000032
						],
						[
							-82.43041599999998,
							27.282263000000057
						],
						[
							-82.43056299999995,
							27.282441000000063
						],
						[
							-82.43072499999994,
							27.282625000000053
						],
						[
							-82.43093199999998,
							27.282828000000052
						],
						[
							-82.43115599999999,
							27.283010000000047
						],
						[
							-82.43141799999995,
							27.283184000000062
						],
						[
							-82.43157999999994,
							27.283278000000053
						],
						[
							-82.43175899999994,
							27.28336900000005
						],
						[
							-82.43196199999994,
							27.283458000000053
						],
						[
							-82.43214099999994,
							27.28352600000005
						],
						[
							-82.43238299999996,
							27.283603000000028
						],
						[
							-82.43254399999995,
							27.283645000000035
						],
						[
							-82.43274699999995,
							27.28368400000005
						],
						[
							-82.43293999999997,
							27.283711000000043
						],
						[
							-82.43315599999995,
							27.28372900000005
						],
						[
							-82.43337899999995,
							27.283738000000028
						],
						[
							-82.43371199999996,
							27.283742000000075
						],
						[
							-82.43475999999998,
							27.283741000000077
						],
						[
							-82.43567099999996,
							27.283730000000048
						],
						[
							-82.43766199999999,
							27.28370700000005
						],
						[
							-82.43923299999994,
							27.28373500000004
						],
						[
							-82.44070399999998,
							27.283741000000077
						],
						[
							-82.44209399999994,
							27.283746000000065
						],
						[
							-82.44352899999996,
							27.283734000000038
						],
						[
							-82.44432099999995,
							27.283759000000035
						],
						[
							-82.44591999999994,
							27.283785000000023
						],
						[
							-82.44627899999996,
							27.28380600000003
						],
						[
							-82.44851199999994,
							27.28385300000008
						],
						[
							-82.44840599999998,
							27.286393000000032
						],
						[
							-82.44814299999996,
							27.291521000000046
						],
						[
							-82.44799299999994,
							27.29340200000007
						],
						[
							-82.44798699999996,
							27.294417000000067
						],
						[
							-82.44787099999996,
							27.296782000000064
						],
						[
							-82.44783199999995,
							27.298117000000047
						],
						[
							-82.44782699999998,
							27.29879900000003
						],
						[
							-82.44718899999998,
							27.29879900000003
						],
						[
							-82.445905,
							27.298793000000046
						],
						[
							-82.44536099999993,
							27.29881000000006
						],
						[
							-82.44518699999998,
							27.298802000000023
						],
						[
							-82.44452399999994,
							27.29879500000004
						],
						[
							-82.44383899999997,
							27.29878700000006
						],
						[
							-82.44308899999999,
							27.29880600000007
						],
						[
							-82.44229199999995,
							27.29880300000008
						],
						[
							-82.44167699999997,
							27.29879200000005
						],
						[
							-82.44113999999996,
							27.298770000000047
						],
						[
							-82.44027799999998,
							27.29873800000007
						],
						[
							-82.44004299999995,
							27.29873200000003
						],
						[
							-82.43778899999995,
							27.298725000000047
						],
						[
							-82.43561999999997,
							27.298714000000075
						],
						[
							-82.43538699999993,
							27.298713000000077
						],
						[
							-82.43472999999994,
							27.298713000000077
						],
						[
							-82.43332399999997,
							27.29870100000005
						],
						[
							-82.43156,
							27.29870100000005
						],
						[
							-82.43057399999998,
							27.298699000000056
						],
						[
							-82.42989899999998,
							27.298689000000028
						],
						[
							-82.42854599999998,
							27.29869000000008
						],
						[
							-82.42829699999999,
							27.298689000000028
						],
						[
							-82.42747499999996,
							27.29869400000007
						],
						[
							-82.42663499999998,
							27.29869400000007
						],
						[
							-82.42583299999995,
							27.298691000000076
						],
						[
							-82.42532299999993,
							27.298692000000074
						],
						[
							-82.42501199999998,
							27.298689000000028
						],
						[
							-82.42501699999997,
							27.29624700000005
						],
						[
							-82.42502099999996,
							27.29617600000006
						],
						[
							-82.42419399999994,
							27.296076000000028
						],
						[
							-82.42335199999997,
							27.29597300000006
						],
						[
							-82.42287899999997,
							27.29591800000003
						],
						[
							-82.42278599999997,
							27.295898000000083
						],
						[
							-82.42272099999997,
							27.295871000000034
						],
						[
							-82.42266199999995,
							27.295835000000068
						],
						[
							-82.42260999999996,
							27.295790000000068
						],
						[
							-82.42257299999994,
							27.295745000000068
						],
						[
							-82.42254399999996,
							27.29569900000007
						],
						[
							-82.42252199999996,
							27.295652000000075
						],
						[
							-82.42250199999995,
							27.295592000000056
						],
						[
							-82.42248999999998,
							27.295530000000042
						],
						[
							-82.42230499999994,
							27.293751000000043
						],
						[
							-82.42220199999997,
							27.292812000000026
						],
						[
							-82.42218499999996,
							27.292712000000055
						],
						[
							-82.42213199999998,
							27.292468000000042
						],
						[
							-82.42211999999995,
							27.29236200000003
						],
						[
							-82.42213099999998,
							27.292271000000028
						],
						[
							-82.42215299999998,
							27.292188000000067
						],
						[
							-82.42220299999997,
							27.292081000000053
						],
						[
							-82.42222299999997,
							27.29205200000007
						],
						[
							-82.42240599999997,
							27.29183100000006
						],
						[
							-82.42252499999995,
							27.29173000000003
						],
						[
							-82.42259799999994,
							27.291658000000044
						],
						[
							-82.42272199999996,
							27.29150500000003
						],
						[
							-82.42294199999998,
							27.291205000000048
						],
						[
							-82.42301399999997,
							27.29113300000006
						],
						[
							-82.42310899999995,
							27.29118500000004
						],
						[
							-82.42335099999997,
							27.291367000000037
						],
						[
							-82.42357599999997,
							27.291548000000034
						],
						[
							-82.42374799999999,
							27.29166900000007
						],
						[
							-82.42460999999997,
							27.29221300000006
						],
						[
							-82.42479699999996,
							27.29232200000007
						],
						[
							-82.42505499999999,
							27.292422000000045
						],
						[
							-82.42519599999997,
							27.292460000000062
						],
						[
							-82.42546099999998,
							27.292516000000035
						],
						[
							-82.42562699999996,
							27.29254000000003
						],
						[
							-82.42579499999994,
							27.292552000000057
						],
						[
							-82.42587699999996,
							27.292554000000052
						],
						[
							-82.42613499999999,
							27.292531000000054
						],
						[
							-82.42611699999998,
							27.292436000000066
						],
						[
							-82.42609399999998,
							27.292368000000067
						],
						[
							-82.42608999999999,
							27.29233400000004
						],
						[
							-82.42609199999998,
							27.292230000000075
						],
						[
							-82.42610499999995,
							27.292151000000047
						],
						[
							-82.42612499999996,
							27.29208200000005
						],
						[
							-82.42620499999998,
							27.29188400000004
						],
						[
							-82.42629299999999,
							27.291743000000054
						],
						[
							-82.42650299999997,
							27.29112500000008
						],
						[
							-82.42652499999997,
							27.29108300000007
						],
						[
							-82.42655299999996,
							27.291052000000036
						],
						[
							-82.42661299999997,
							27.29100500000004
						],
						[
							-82.42663599999997,
							27.290992000000074
						],
						[
							-82.42669599999994,
							27.29096400000003
						],
						[
							-82.42678399999994,
							27.290943000000027
						],
						[
							-82.42683499999998,
							27.290939000000037
						],
						[
							-82.42734399999996,
							27.290952000000065
						],
						[
							-82.42912599999994,
							27.290980000000047
						],
						[
							-82.42915199999999,
							27.290978000000052
						],
						[
							-82.42920099999998,
							27.290963000000033
						],
						[
							-82.42925699999995,
							27.290931000000057
						],
						[
							-82.42928899999998,
							27.290902000000074
						],
						[
							-82.42931799999997,
							27.290858000000075
						],
						[
							-82.42933599999998,
							27.29081000000008
						],
						[
							-82.42934799999995,
							27.29026300000004
						],
						[
							-82.42935299999994,
							27.289792000000034
						],
						[
							-82.42934599999995,
							27.28971400000006
						],
						[
							-82.42933699999998,
							27.289676000000043
						],
						[
							-82.42930599999994,
							27.289603000000056
						],
						[
							-82.42929599999997,
							27.28956000000005
						],
						[
							-82.42929199999998,
							27.289540000000045
						],
						[
							-82.42928199999994,
							27.28782300000006
						],
						[
							-82.42927099999997,
							27.28505000000007
						],
						[
							-82.42924999999997,
							27.283957000000044
						],
						[
							-82.42922199999998,
							27.282490000000053
						],
						[
							-82.42921799999993,
							27.282279000000074
						],
						[
							-82.42924799999997,
							27.282136000000037
						],
						[
							-82.42927199999997,
							27.282087000000047
						],
						[
							-82.42929499999997,
							27.282042000000047
						],
						[
							-82.42935799999998,
							27.28197900000004
						],
						[
							-82.42967799999997,
							27.281783000000075
						],
						[
							-82.42978899999997,
							27.28170700000004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Lake Sarasota",
				"RegionID": "125021"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.65113090499995,
					30.25178908700008,
					-81.6259918529999,
					30.284761006000053
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.64382185099993,
							30.284761006000053
						],
						[
							-81.6437839059999,
							30.283743008000044
						],
						[
							-81.64377990499992,
							30.28338200800005
						],
						[
							-81.64377590599992,
							30.28302000800005
						],
						[
							-81.64376090499991,
							30.282438008000046
						],
						[
							-81.64375290599992,
							30.282248009000057
						],
						[
							-81.6437179049999,
							30.281520008000086
						],
						[
							-81.64369990499995,
							30.28083300800006
						],
						[
							-81.64369790599994,
							30.28073400800008
						],
						[
							-81.64369490599995,
							30.28025400900009
						],
						[
							-81.64368490499993,
							30.27953200800005
						],
						[
							-81.64368390499993,
							30.279350008000055
						],
						[
							-81.64366090499993,
							30.278748008000033
						],
						[
							-81.64363090499995,
							30.278481008000085
						],
						[
							-81.64359990499992,
							30.27833700800005
						],
						[
							-81.64354690499994,
							30.278162006000063
						],
						[
							-81.64338690499994,
							30.277849008000093
						],
						[
							-81.64330290499993,
							30.277729009000044
						],
						[
							-81.6431579049999,
							30.277565009000057
						],
						[
							-81.64300490599994,
							30.277378009000074
						],
						[
							-81.64262390599993,
							30.27698300800006
						],
						[
							-81.64233390499993,
							30.276678008000086
						],
						[
							-81.64156290599993,
							30.275879008000064
						],
						[
							-81.6403879049999,
							30.274689008000053
						],
						[
							-81.63972090599992,
							30.27401500900004
						],
						[
							-81.63953690499994,
							30.27380600900005
						],
						[
							-81.63933590599993,
							30.27361300800004
						],
						[
							-81.63701590599993,
							30.271214008000072
						],
						[
							-81.6365809049999,
							30.270767008000067
						],
						[
							-81.63609190499994,
							30.270252009000046
						],
						[
							-81.63596390499993,
							30.270128008000086
						],
						[
							-81.6347579049999,
							30.26888300900003
						],
						[
							-81.6343539049999,
							30.268463008000086
						],
						[
							-81.6334989049999,
							30.267576009000038
						],
						[
							-81.63256090499993,
							30.26660700900004
						],
						[
							-81.63125390499994,
							30.265250008000066
						],
						[
							-81.63111290499995,
							30.265103009000086
						],
						[
							-81.63068390599994,
							30.26465300800004
						],
						[
							-81.6303209049999,
							30.264272008000034
						],
						[
							-81.63019590499994,
							30.264141009000074
						],
						[
							-81.6298519049999,
							30.263777008000094
						],
						[
							-81.62888190599995,
							30.262780009000043
						],
						[
							-81.62855990499992,
							30.262437008000063
						],
						[
							-81.6284079049999,
							30.262305008000055
						],
						[
							-81.62828290499993,
							30.262216009000046
						],
						[
							-81.62783590499993,
							30.261981008000078
						],
						[
							-81.62739690599996,
							30.261726008000043
						],
						[
							-81.62708890499994,
							30.261503006000055
						],
						[
							-81.62690090499991,
							30.261302009000076
						],
						[
							-81.62680290599991,
							30.26117800800006
						],
						[
							-81.62668095299995,
							30.260975917000053
						],
						[
							-81.6261519059999,
							30.260166008000056
						],
						[
							-81.62608290599991,
							30.260029008000064
						],
						[
							-81.62602590699993,
							30.259852010000092
						],
						[
							-81.6259918529999,
							30.25958300800005
						],
						[
							-81.62605990499993,
							30.258886008000047
						],
						[
							-81.6260679049999,
							30.258711009000077
						],
						[
							-81.62610590499992,
							30.258099008000045
						],
						[
							-81.6261749059999,
							30.25689300800008
						],
						[
							-81.62624890599994,
							30.255733008000046
						],
						[
							-81.62623990499992,
							30.255485008000054
						],
						[
							-81.62621790599991,
							30.255138008000074
						],
						[
							-81.62621290599992,
							30.254608008000044
						],
						[
							-81.62619081699995,
							30.25415201800007
						],
						[
							-81.63017894599996,
							30.253805835000037
						],
						[
							-81.63313287999995,
							30.255347180000058
						],
						[
							-81.64074998399991,
							30.25387016600007
						],
						[
							-81.64243499999992,
							30.252245000000073
						],
						[
							-81.64333532199993,
							30.25178908700008
						],
						[
							-81.64363064199995,
							30.252004915000043
						],
						[
							-81.64366502899992,
							30.252031341000077
						],
						[
							-81.64908155099994,
							30.256405710000084
						],
						[
							-81.64919892099995,
							30.25652192700005
						],
						[
							-81.64928883599993,
							30.25665033900009
						],
						[
							-81.6493550859999,
							30.25679241300008
						],
						[
							-81.64939565999993,
							30.256943834000086
						],
						[
							-81.64940932199994,
							30.257100000000033
						],
						[
							-81.64940858499995,
							30.25713640300006
						],
						[
							-81.64931358499992,
							30.259481403000052
						],
						[
							-81.64930065999994,
							30.259601165000046
						],
						[
							-81.64925910599993,
							30.25975525300004
						],
						[
							-81.64899363099994,
							30.260470570000056
						],
						[
							-81.64902665999995,
							30.26059383400008
						],
						[
							-81.6490403219999,
							30.260750000000083
						],
						[
							-81.64902665999995,
							30.260906165000055
						],
						[
							-81.64898608699991,
							30.261057586000053
						],
						[
							-81.64891983599995,
							30.26119966100003
						],
						[
							-81.64882772899996,
							30.261330666000053
						],
						[
							-81.6481481749999,
							30.26212823800006
						],
						[
							-81.64718499999992,
							30.261872000000043
						],
						[
							-81.64599576299992,
							30.26182590600007
						],
						[
							-81.64667490599993,
							30.263657008000052
						],
						[
							-81.64675890599995,
							30.26386600900008
						],
						[
							-81.64694190499995,
							30.264280009000064
						],
						[
							-81.64743790599994,
							30.265467009000076
						],
						[
							-81.64784190599994,
							30.26643800800008
						],
						[
							-81.64794190599991,
							30.266683009000076
						],
						[
							-81.6480599059999,
							30.266932009000072
						],
						[
							-81.64809290499994,
							30.267016009000088
						],
						[
							-81.64816990499992,
							30.26725000800008
						],
						[
							-81.64818990499992,
							30.267341008000077
						],
						[
							-81.64820090599994,
							30.267431008000077
						],
						[
							-81.64826090499992,
							30.26780000800005
						],
						[
							-81.64827490599993,
							30.268093008000054
						],
						[
							-81.64831190599995,
							30.26843400800004
						],
						[
							-81.64831490599994,
							30.268723008000052
						],
						[
							-81.64831490499995,
							30.26882900900006
						],
						[
							-81.64836090599994,
							30.269449009000084
						],
						[
							-81.64838390599994,
							30.269806008000046
						],
						[
							-81.64846790599995,
							30.270266009000068
						],
						[
							-81.6485819049999,
							30.27071500900007
						],
						[
							-81.64861090599993,
							30.270829008000078
						],
						[
							-81.64865890599992,
							30.271013009000058
						],
						[
							-81.6487589059999,
							30.27130900800006
						],
						[
							-81.64887990599993,
							30.271641009000067
						],
						[
							-81.64896390599995,
							30.27183200900004
						],
						[
							-81.6492079059999,
							30.27239000800006
						],
						[
							-81.64929890499991,
							30.27255700800003
						],
						[
							-81.64952403199993,
							30.27297996400006
						],
						[
							-81.64953777999995,
							30.27309305300008
						],
						[
							-81.64958290499993,
							30.27317800900005
						],
						[
							-81.64972190599991,
							30.273604009000056
						],
						[
							-81.64980890499993,
							30.27379700900008
						],
						[
							-81.64986990599994,
							30.273930008000036
						],
						[
							-81.65004990599994,
							30.274411009000065
						],
						[
							-81.65009290599994,
							30.274593008000068
						],
						[
							-81.65013090499991,
							30.274738008000043
						],
						[
							-81.65018490599994,
							30.275055008000038
						],
						[
							-81.65030090599993,
							30.275912008000034
						],
						[
							-81.65039790599991,
							30.27663200800004
						],
						[
							-81.65045890599994,
							30.27715500900007
						],
						[
							-81.65047490599994,
							30.277323008000057
						],
						[
							-81.65057290599992,
							30.278057008000076
						],
						[
							-81.65063490599994,
							30.278524009000083
						],
						[
							-81.65068190599993,
							30.278829008000063
						],
						[
							-81.65077990599991,
							30.279472008000084
						],
						[
							-81.65078690599996,
							30.279531008000053
						],
						[
							-81.65089390599991,
							30.280418009000073
						],
						[
							-81.6509859059999,
							30.28118900800007
						],
						[
							-81.6510539059999,
							30.281681010000057
						],
						[
							-81.65110790599994,
							30.28231000900007
						],
						[
							-81.65113090499995,
							30.282942008000077
						],
						[
							-81.65111490499993,
							30.283258008000075
						],
						[
							-81.65109290599992,
							30.28338200800005
						],
						[
							-81.6510129049999,
							30.28400300900006
						],
						[
							-81.65097390599993,
							30.284259009000035
						],
						[
							-81.65091573599994,
							30.284553038000073
						],
						[
							-81.65098103699995,
							30.284664983000084
						],
						[
							-81.65081290599994,
							30.28464800900008
						],
						[
							-81.64965090499993,
							30.284655008000072
						],
						[
							-81.64748390499994,
							30.284672008000086
						],
						[
							-81.64563790599993,
							30.284712008000042
						],
						[
							-81.64476390599992,
							30.284734008000047
						],
						[
							-81.64382185099993,
							30.284761006000053
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Lakewood",
				"RegionID": "125044"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.30590259899998,
					29.637304424000032,
					-82.29731956899997,
					29.645188738000055
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.30590259899998,
							29.64114166700006
						],
						[
							-82.30357156999997,
							29.641085946000036
						],
						[
							-82.30352628499998,
							29.641082852000064
						],
						[
							-82.30353582399994,
							29.641011476000074
						],
						[
							-82.30260121999999,
							29.64101964400004
						],
						[
							-82.30252904399998,
							29.643287148000073
						],
						[
							-82.30150395999993,
							29.643342063000038
						],
						[
							-82.30148268299996,
							29.645188738000055
						],
						[
							-82.29731956899997,
							29.64512343800004
						],
						[
							-82.29747628599995,
							29.637386093000032
						],
						[
							-82.30234361699996,
							29.637392872000078
						],
						[
							-82.30292432999994,
							29.637304424000032
						],
						[
							-82.30590259899998,
							29.63732508200008
						],
						[
							-82.30590259899998,
							29.64114166700006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Alachua",
				"City": "Gainesville",
				"Name": "Lincoln Estates",
				"RegionID": "125105"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.15472723599999,
					26.165872500000035,
					-80.14655068599996,
					26.17566703800003
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.14667305499995,
							26.173875956000074
						],
						[
							-80.14663885599998,
							26.17291904900003
						],
						[
							-80.14658497399995,
							26.17146912900006
						],
						[
							-80.14655068599996,
							26.170107381000037
						],
						[
							-80.14655068599996,
							26.16973510400004
						],
						[
							-80.146720584,
							26.169728860000077
						],
						[
							-80.14983270499994,
							26.16961413200005
						],
						[
							-80.15000066299996,
							26.16960830900007
						],
						[
							-80.15098643699997,
							26.169578234000028
						],
						[
							-80.15148295999995,
							26.16956308600004
						],
						[
							-80.15147584399995,
							26.169321151000076
						],
						[
							-80.15146681699997,
							26.16901422500007
						],
						[
							-80.15153138899996,
							26.168820509000057
						],
						[
							-80.15169281899996,
							26.168626794000033
						],
						[
							-80.15182196199999,
							26.168465364000042
						],
						[
							-80.15185424799995,
							26.168368506000036
						],
						[
							-80.15182196199999,
							26.168239362000065
						],
						[
							-80.15169281899996,
							26.16791650300007
						],
						[
							-80.15170217199994,
							26.167337331000056
						],
						[
							-80.15170972999994,
							26.16686930700007
						],
						[
							-80.15171643799994,
							26.16645392500004
						],
						[
							-80.15172512899994,
							26.165915734000066
						],
						[
							-80.15431501199998,
							26.165877845000068
						],
						[
							-80.15472723599999,
							26.165872500000035
						],
						[
							-80.15472386,
							26.166625409000062
						],
						[
							-80.15470004399998,
							26.171936414000072
						],
						[
							-80.15468368199998,
							26.175585015000024
						],
						[
							-80.15338941499994,
							26.17560085300005
						],
						[
							-80.15135530999999,
							26.175625745000048
						],
						[
							-80.14681739599996,
							26.175666232000026
						],
						[
							-80.14672702699994,
							26.17566703800003
						],
						[
							-80.14667305499995,
							26.173875956000074
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Oakland Park",
				"Name": "Lloyd Estates",
				"RegionID": "125121"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.23142199999995,
					29.65739500000007,
					-81.20825699999995,
					29.70445300000006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.22439899999995,
							29.70146900000009
						],
						[
							-81.22365827299991,
							29.700193194000068
						],
						[
							-81.22365799999994,
							29.70019000000008
						],
						[
							-81.22351999999995,
							29.699953000000054
						],
						[
							-81.22321499999993,
							29.699267000000077
						],
						[
							-81.22308399999991,
							29.698893000000055
						],
						[
							-81.22287199999994,
							29.698130000000052
						],
						[
							-81.22254443799994,
							29.697039674000052
						],
						[
							-81.22174299999995,
							29.694372000000048
						],
						[
							-81.22143999999992,
							29.693446000000048
						],
						[
							-81.22076499999991,
							29.69154300000008
						],
						[
							-81.2204099999999,
							29.690576000000082
						],
						[
							-81.21985599999994,
							29.688694000000055
						],
						[
							-81.21975399999992,
							29.688424000000058
						],
						[
							-81.2195079999999,
							29.687768000000066
						],
						[
							-81.21877399999994,
							29.685875000000067
						],
						[
							-81.21801999999992,
							29.684251000000078
						],
						[
							-81.21798899999993,
							29.68413000000004
						],
						[
							-81.21801699999992,
							29.68392500000005
						],
						[
							-81.21800699999994,
							29.683874000000063
						],
						[
							-81.21783199999994,
							29.68354000000005
						],
						[
							-81.21769999999992,
							29.68318700000009
						],
						[
							-81.21764499999995,
							29.68282000000005
						],
						[
							-81.21739899999994,
							29.682104000000034
						],
						[
							-81.21528999999992,
							29.676474000000045
						],
						[
							-81.21478999999994,
							29.675283000000036
						],
						[
							-81.2131589999999,
							29.671078000000083
						],
						[
							-81.21294099999994,
							29.67068800000004
						],
						[
							-81.21293248399991,
							29.670668638000052
						],
						[
							-81.2126088139999,
							29.66993278800004
						],
						[
							-81.21260533799995,
							29.66992330400006
						],
						[
							-81.21232299999991,
							29.669282000000067
						],
						[
							-81.2121479999999,
							29.668989000000067
						],
						[
							-81.2114259999999,
							29.667232000000073
						],
						[
							-81.21135199999992,
							29.66681000000006
						],
						[
							-81.21084999999994,
							29.665640000000057
						],
						[
							-81.21067099999993,
							29.66543400000006
						],
						[
							-81.21052399999991,
							29.66499700000008
						],
						[
							-81.21007999999995,
							29.66432900000007
						],
						[
							-81.21002099999993,
							29.664073000000087
						],
						[
							-81.20985799999994,
							29.66386800000004
						],
						[
							-81.20984571799994,
							29.663664479000094
						],
						[
							-81.20902899999993,
							29.66198300000008
						],
						[
							-81.20825699999995,
							29.660048000000074
						],
						[
							-81.2083168769999,
							29.66002979400008
						],
						[
							-81.20946399999991,
							29.659681000000035
						],
						[
							-81.21628399999992,
							29.657588000000086
						],
						[
							-81.21691599999991,
							29.65739500000007
						],
						[
							-81.21686814899994,
							29.65837641400009
						],
						[
							-81.21686499999993,
							29.65844100000004
						],
						[
							-81.21693097299993,
							29.65886839700005
						],
						[
							-81.21704899999992,
							29.659633000000042
						],
						[
							-81.21701534099992,
							29.65992449900006
						],
						[
							-81.21699599999994,
							29.660092000000077
						],
						[
							-81.21683271499995,
							29.660174938000072
						],
						[
							-81.21668099999994,
							29.660252000000074
						],
						[
							-81.21670310499991,
							29.660459129000063
						],
						[
							-81.21670799999994,
							29.660505000000057
						],
						[
							-81.21705469999995,
							29.660694034000073
						],
						[
							-81.21712799999996,
							29.660734000000048
						],
						[
							-81.21723299999991,
							29.661032000000034
						],
						[
							-81.21724337199993,
							29.662159123000038
						],
						[
							-81.2172599999999,
							29.66396600000007
						],
						[
							-81.21710872099993,
							29.664129962000064
						],
						[
							-81.21696828699993,
							29.664441185000044
						],
						[
							-81.21679599999993,
							29.66482300000007
						],
						[
							-81.21632196899992,
							29.665852625000074
						],
						[
							-81.21620899999994,
							29.66609800000009
						],
						[
							-81.21620554599991,
							29.666173615000048
						],
						[
							-81.21618252299993,
							29.666677681000067
						],
						[
							-81.21621099999993,
							29.667244000000036
						],
						[
							-81.21642099999991,
							29.667749000000075
						],
						[
							-81.21639499999992,
							29.668459000000045
						],
						[
							-81.21618499999994,
							29.668712000000085
						],
						[
							-81.21612071099992,
							29.66874485400007
						],
						[
							-81.21603099999993,
							29.668864000000042
						],
						[
							-81.21593599999994,
							29.668934000000032
						],
						[
							-81.21554676999995,
							29.669038149000073
						],
						[
							-81.2151869999999,
							29.669222000000048
						],
						[
							-81.21512799999994,
							29.66934200000009
						],
						[
							-81.21519707699991,
							29.669409350000077
						],
						[
							-81.21522670199994,
							29.66943823400004
						],
						[
							-81.21526199999994,
							29.66942300000005
						],
						[
							-81.21528088499991,
							29.669406563000052
						],
						[
							-81.21531599999992,
							29.669376000000057
						],
						[
							-81.2154099999999,
							29.66937000000007
						],
						[
							-81.21552559899993,
							29.669398426000043
						],
						[
							-81.21553199999994,
							29.66940000000005
						],
						[
							-81.21567299999992,
							29.669441000000067
						],
						[
							-81.21576628999992,
							29.66947849900004
						],
						[
							-81.21594063499992,
							29.669485058000078
						],
						[
							-81.21607199999994,
							29.669490000000057
						],
						[
							-81.2160889999999,
							29.669935000000066
						],
						[
							-81.21594899999991,
							29.670203000000072
						],
						[
							-81.21558809099992,
							29.670629087000066
						],
						[
							-81.21558899999991,
							29.670638000000054
						],
						[
							-81.21558934599994,
							29.670641000000046
						],
						[
							-81.21558946099992,
							29.670642000000043
						],
						[
							-81.2155919999999,
							29.67066400000005
						],
						[
							-81.21557530899992,
							29.670696014000043
						],
						[
							-81.2155689999999,
							29.670825000000036
						],
						[
							-81.21553999999992,
							29.670854000000073
						],
						[
							-81.21549099999993,
							29.67091300000004
						],
						[
							-81.21543899999995,
							29.670960000000036
						],
						[
							-81.21541824299993,
							29.67097037800005
						],
						[
							-81.2153429999999,
							29.67105600000008
						],
						[
							-81.21510599999993,
							29.671162000000038
						],
						[
							-81.21502499999991,
							29.671174000000068
						],
						[
							-81.21476899999993,
							29.67118700000009
						],
						[
							-81.21470699999992,
							29.671197000000063
						],
						[
							-81.21467899999993,
							29.67121800000007
						],
						[
							-81.21464099999992,
							29.671273000000046
						],
						[
							-81.21460499999995,
							29.67136500000004
						],
						[
							-81.2145809999999,
							29.67152100000004
						],
						[
							-81.21459099999993,
							29.671579000000065
						],
						[
							-81.21472299999994,
							29.671808000000055
						],
						[
							-81.21477799999991,
							29.671946000000048
						],
						[
							-81.21485399999995,
							29.672029000000062
						],
						[
							-81.2148919999999,
							29.672092000000077
						],
						[
							-81.21497199999995,
							29.672337000000088
						],
						[
							-81.2150069999999,
							29.672382000000084
						],
						[
							-81.21505499999995,
							29.672413000000063
						],
						[
							-81.21510299999994,
							29.672427000000084
						],
						[
							-81.2151659999999,
							29.672469000000035
						],
						[
							-81.21519699999993,
							29.672510000000045
						],
						[
							-81.21524199999993,
							29.672604000000035
						],
						[
							-81.21528999999992,
							29.672652000000085
						],
						[
							-81.21535599999993,
							29.672690000000046
						],
						[
							-81.21543199999991,
							29.67271100000005
						],
						[
							-81.2155019999999,
							29.67271100000005
						],
						[
							-81.21558099999993,
							29.672697000000085
						],
						[
							-81.21580999999992,
							29.672607000000085
						],
						[
							-81.21587199999993,
							29.672559000000035
						],
						[
							-81.2159069999999,
							29.672486000000053
						],
						[
							-81.21590999999997,
							29.672417000000053
						],
						[
							-81.2158829999999,
							29.672351000000052
						],
						[
							-81.21580999999992,
							29.672265000000035
						],
						[
							-81.21551199999993,
							29.671966000000058
						],
						[
							-81.21535899999992,
							29.67177700000008
						],
						[
							-81.21533799999992,
							29.67173600000007
						],
						[
							-81.21534799999995,
							29.671694000000063
						],
						[
							-81.21537599999994,
							29.67166300000008
						],
						[
							-81.21549899999991,
							29.67163000000005
						],
						[
							-81.21637499999991,
							29.671551000000083
						],
						[
							-81.2165129999999,
							29.67156100000005
						],
						[
							-81.2166519999999,
							29.671582000000058
						],
						[
							-81.21675299999994,
							29.671637000000093
						],
						[
							-81.21683599999994,
							29.671710000000076
						],
						[
							-81.21691199999992,
							29.671824000000075
						],
						[
							-81.2170119999999,
							29.67203500000005
						],
						[
							-81.21710399999995,
							29.67217500000004
						],
						[
							-81.2172149999999,
							29.672294000000083
						],
						[
							-81.21738799999991,
							29.67245900000006
						],
						[
							-81.21751999999992,
							29.672611000000074
						],
						[
							-81.2175749999999,
							29.67273200000005
						],
						[
							-81.21773399999995,
							29.673186000000047
						],
						[
							-81.2179119999999,
							29.673456000000044
						],
						[
							-81.2182259999999,
							29.67393200000004
						],
						[
							-81.21899999999994,
							29.67488200000008
						],
						[
							-81.21963999999991,
							29.675723000000065
						],
						[
							-81.22010799999993,
							29.67621100000008
						],
						[
							-81.22018899999995,
							29.676334000000058
						],
						[
							-81.22024499999992,
							29.67644400000006
						],
						[
							-81.22033299999993,
							29.67678200000006
						],
						[
							-81.22037499999993,
							29.67707600000006
						],
						[
							-81.22037499999993,
							29.67732500000005
						],
						[
							-81.22035699999992,
							29.677498000000075
						],
						[
							-81.22037099999994,
							29.677564000000075
						],
						[
							-81.22042599999992,
							29.677654000000075
						],
						[
							-81.22048399999994,
							29.677728000000062
						],
						[
							-81.22080199999994,
							29.67791500000004
						],
						[
							-81.22087099999993,
							29.678012000000084
						],
						[
							-81.22092699999992,
							29.678226000000052
						],
						[
							-81.22089899999992,
							29.67846200000008
						],
						[
							-81.22064299999995,
							29.679413000000068
						],
						[
							-81.22059799999995,
							29.679586000000086
						],
						[
							-81.22037599999993,
							29.680258000000038
						],
						[
							-81.22027899999995,
							29.680403000000073
						],
						[
							-81.22015499999992,
							29.680507000000038
						],
						[
							-81.21990499999993,
							29.680680000000052
						],
						[
							-81.21971099999992,
							29.680777000000038
						],
						[
							-81.21930999999995,
							29.681130000000053
						],
						[
							-81.21898099999993,
							29.681493000000042
						],
						[
							-81.21895899999993,
							29.681528000000075
						],
						[
							-81.21886299999994,
							29.68168000000008
						],
						[
							-81.21880799999991,
							29.681822000000064
						],
						[
							-81.21874999999994,
							29.68214200000006
						],
						[
							-81.21870199999995,
							29.68295500000005
						],
						[
							-81.21870499999994,
							29.683038000000064
						],
						[
							-81.21872599999995,
							29.68309700000009
						],
						[
							-81.21877499999994,
							29.68316900000008
						],
						[
							-81.2193529999999,
							29.684775000000055
						],
						[
							-81.21947599999994,
							29.685023000000058
						],
						[
							-81.21963499999993,
							29.685587000000055
						],
						[
							-81.21994499999994,
							29.68641200000008
						],
						[
							-81.22007699999995,
							29.687059000000094
						],
						[
							-81.22028399999994,
							29.687893000000088
						],
						[
							-81.22043999999994,
							29.688173000000063
						],
						[
							-81.22050599999996,
							29.688270000000045
						],
						[
							-81.2205889999999,
							29.68854300000004
						],
						[
							-81.22061699999995,
							29.688675000000046
						],
						[
							-81.22067699999991,
							29.688832000000048
						],
						[
							-81.22092699999992,
							29.68928200000005
						],
						[
							-81.2210409999999,
							29.68941000000007
						],
						[
							-81.22114799999991,
							29.68950400000006
						],
						[
							-81.22124899999994,
							29.68956600000007
						],
						[
							-81.22135999999995,
							29.689621000000045
						],
						[
							-81.2214249999999,
							29.68970100000007
						],
						[
							-81.22147599999994,
							29.689796000000058
						],
						[
							-81.22159499999992,
							29.690212000000084
						],
						[
							-81.22161399999993,
							29.69028700000007
						],
						[
							-81.22161399999993,
							29.69045000000005
						],
						[
							-81.22158699999994,
							29.69060900000005
						],
						[
							-81.22158699999994,
							29.690758000000077
						],
						[
							-81.22175799999991,
							29.691459000000066
						],
						[
							-81.22176499999995,
							29.691559000000044
						],
						[
							-81.2218509999999,
							29.691749000000076
						],
						[
							-81.2218719999999,
							29.691839000000076
						],
						[
							-81.22188599999993,
							29.69201600000008
						],
						[
							-81.22186399999993,
							29.692346000000043
						],
						[
							-81.22188399999993,
							29.69249500000007
						],
						[
							-81.22193099999993,
							29.69264200000004
						],
						[
							-81.22231699999992,
							29.693623000000063
						],
						[
							-81.22249699999992,
							29.69393800000006
						],
						[
							-81.22254599999991,
							29.694056000000042
						],
						[
							-81.22278999999992,
							29.695006000000035
						],
						[
							-81.22281399999991,
							29.695061000000067
						],
						[
							-81.2228659999999,
							29.695123000000084
						],
						[
							-81.2230459999999,
							29.69529300000005
						],
						[
							-81.22311499999995,
							29.69540700000005
						],
						[
							-81.22315199999991,
							29.695530000000076
						],
						[
							-81.22318999999993,
							29.69596600000006
						],
						[
							-81.2231589999999,
							29.69619800000004
						],
						[
							-81.2231799999999,
							29.696277000000066
						],
						[
							-81.22321799999992,
							29.69633600000009
						],
						[
							-81.22327099999991,
							29.69645200000008
						],
						[
							-81.2234059999999,
							29.69682200000005
						],
						[
							-81.22345499999994,
							29.696912000000058
						],
						[
							-81.22353099999992,
							29.69698100000005
						],
						[
							-81.22366599999992,
							29.697044000000066
						],
						[
							-81.22429099999994,
							29.697222000000068
						],
						[
							-81.2253869999999,
							29.697480000000038
						],
						[
							-81.22561399999996,
							29.697505000000035
						],
						[
							-81.22588899999994,
							29.697535000000073
						],
						[
							-81.22670599999992,
							29.69771500000007
						],
						[
							-81.22679999999991,
							29.697753000000038
						],
						[
							-81.22689999999994,
							29.697819000000038
						],
						[
							-81.22700299999991,
							29.69791100000009
						],
						[
							-81.22779899999995,
							29.698921000000045
						],
						[
							-81.22785799999991,
							29.698963000000052
						],
						[
							-81.22800799999993,
							29.699047000000064
						],
						[
							-81.22838799999994,
							29.699232000000052
						],
						[
							-81.22852999999992,
							29.699336000000077
						],
						[
							-81.22920799999991,
							29.70002800000009
						],
						[
							-81.22936299999992,
							29.70018600000009
						],
						[
							-81.2293939999999,
							29.70023600000008
						],
						[
							-81.2293919999999,
							29.700270000000046
						],
						[
							-81.22924999999992,
							29.700447000000054
						],
						[
							-81.22919699999994,
							29.70053800000005
						],
						[
							-81.22918499999992,
							29.70059000000009
						],
						[
							-81.22918699999991,
							29.700630000000046
						],
						[
							-81.22920799999991,
							29.700694000000055
						],
						[
							-81.22924099999994,
							29.700735000000066
						],
						[
							-81.22933299999994,
							29.70080300000006
						],
						[
							-81.22951999999992,
							29.700886000000086
						],
						[
							-81.22959999999996,
							29.700900000000043
						],
						[
							-81.22980299999995,
							29.70090200000004
						],
						[
							-81.23063399999995,
							29.70072900000008
						],
						[
							-81.23073099999993,
							29.70072900000008
						],
						[
							-81.2308339999999,
							29.70076400000005
						],
						[
							-81.23131199999995,
							29.70104400000008
						],
						[
							-81.23134399999992,
							29.701089000000078
						],
						[
							-81.23135699999995,
							29.70113700000007
						],
						[
							-81.23138899999992,
							29.701392000000055
						],
						[
							-81.23142199999995,
							29.701648000000038
						],
						[
							-81.23141099999992,
							29.701788000000075
						],
						[
							-81.23138599999993,
							29.701897000000088
						],
						[
							-81.23125799999991,
							29.702115000000052
						],
						[
							-81.2309239999999,
							29.702354000000067
						],
						[
							-81.23061899999993,
							29.70254600000004
						],
						[
							-81.23026799999991,
							29.702840000000037
						],
						[
							-81.23000699999994,
							29.70301000000006
						],
						[
							-81.2298419999999,
							29.703057000000054
						],
						[
							-81.22976999999992,
							29.703078000000062
						],
						[
							-81.22953099999995,
							29.70318100000009
						],
						[
							-81.22920499999992,
							29.703271000000086
						],
						[
							-81.22908399999996,
							29.703323000000072
						],
						[
							-81.22887999999995,
							29.703489000000047
						],
						[
							-81.2286719999999,
							29.703766000000087
						],
						[
							-81.2285139999999,
							29.703941000000047
						],
						[
							-81.22814399999994,
							29.704308000000086
						],
						[
							-81.22805399999994,
							29.704374000000087
						],
						[
							-81.22794999999991,
							29.70441800000009
						],
						[
							-81.2278399999999,
							29.704441000000088
						],
						[
							-81.22768699999995,
							29.70445300000006
						],
						[
							-81.22713799999991,
							29.704341000000056
						],
						[
							-81.22687499999995,
							29.704244000000074
						],
						[
							-81.2264449999999,
							29.704036000000084
						],
						[
							-81.22580999999991,
							29.703602000000046
						],
						[
							-81.22561599999996,
							29.703415000000067
						],
						[
							-81.22528499999993,
							29.702963000000064
						],
						[
							-81.22439899999995,
							29.70146900000009
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Flagler",
				"City": "Saint Augustine",
				"Name": "Marineland",
				"RegionID": "125219"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.75196092199991,
					30.306060972000072,
					-81.73063685199992,
					30.317352010000036
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.7307239079999,
							30.316859011000076
						],
						[
							-81.73068990799993,
							30.315262011000073
						],
						[
							-81.73069790799991,
							30.31459801100004
						],
						[
							-81.73071290799993,
							30.31378601100005
						],
						[
							-81.73070490799995,
							30.313063010000068
						],
						[
							-81.73069790699992,
							30.312294011000066
						],
						[
							-81.7306819069999,
							30.31152201000009
						],
						[
							-81.73066690799993,
							30.310743010000067
						],
						[
							-81.73065190799991,
							30.309982010000056
						],
						[
							-81.73063685199992,
							30.309210009000083
						],
						[
							-81.73160590799996,
							30.309202010000035
						],
						[
							-81.73314690799992,
							30.30917401100004
						],
						[
							-81.73345890799993,
							30.309170010000063
						],
						[
							-81.7352069069999,
							30.30914301000007
						],
						[
							-81.73727390699992,
							30.309111010000038
						],
						[
							-81.73738090799992,
							30.309111010000038
						],
						[
							-81.73846390699993,
							30.30905501100006
						],
						[
							-81.73897990799992,
							30.309018010000045
						],
						[
							-81.73944890799993,
							30.30898501100006
						],
						[
							-81.7401639069999,
							30.308912010000086
						],
						[
							-81.74046290799993,
							30.308882011000037
						],
						[
							-81.74208790699993,
							30.30867801000005
						],
						[
							-81.74283590699991,
							30.308567011000036
						],
						[
							-81.74352290799993,
							30.30844501000007
						],
						[
							-81.7444789079999,
							30.308260011000076
						],
						[
							-81.74525590699994,
							30.30809401000005
						],
						[
							-81.74564790799991,
							30.308011010000087
						],
						[
							-81.74672590799992,
							30.307751011000047
						],
						[
							-81.7473829079999,
							30.307581010000032
						],
						[
							-81.74835990799994,
							30.307304011000042
						],
						[
							-81.74953790799992,
							30.30692901100008
						],
						[
							-81.75069590699991,
							30.306516010000053
						],
						[
							-81.75151590699994,
							30.306203010000047
						],
						[
							-81.7518878539999,
							30.306060972000072
						],
						[
							-81.7518999099999,
							30.306515012000087
						],
						[
							-81.75191190899994,
							30.30878701300009
						],
						[
							-81.75193790999992,
							30.309402012000078
						],
						[
							-81.7519449099999,
							30.31005701300006
						],
						[
							-81.75193790999992,
							30.31037301200007
						],
						[
							-81.7519299089999,
							30.31086501300007
						],
						[
							-81.7519299089999,
							30.311060012000038
						],
						[
							-81.75193190899995,
							30.31117101300004
						],
						[
							-81.75193790999992,
							30.31156201300007
						],
						[
							-81.75195290999994,
							30.31194901300006
						],
						[
							-81.7519449099999,
							30.31263701300008
						],
						[
							-81.75196090999994,
							30.313177013000086
						],
						[
							-81.7519449099999,
							30.31379501200007
						],
						[
							-81.75195290999994,
							30.31407401300004
						],
						[
							-81.7519519089999,
							30.31446501300007
						],
						[
							-81.7519509089999,
							30.314735012000085
						],
						[
							-81.75195290999994,
							30.315174013000046
						],
						[
							-81.75195290999994,
							30.315422013000045
						],
						[
							-81.75195690999993,
							30.315528012000073
						],
						[
							-81.75196092199991,
							30.31563409900008
						],
						[
							-81.7512609069999,
							30.31564101000004
						],
						[
							-81.7507849079999,
							30.315651011000057
						],
						[
							-81.7504049069999,
							30.315652011000054
						],
						[
							-81.74962390699996,
							30.31566501000009
						],
						[
							-81.7491689069999,
							30.31566501000009
						],
						[
							-81.74885890699994,
							30.315664010000035
						],
						[
							-81.74866478399991,
							30.31567205500005
						],
						[
							-81.74881103899992,
							30.315567965000074
						],
						[
							-81.74614590699991,
							30.315525010000044
						],
						[
							-81.74533277599994,
							30.31553988000007
						],
						[
							-81.74533304099992,
							30.315615144000052
						],
						[
							-81.74501190799992,
							30.31561401100004
						],
						[
							-81.74413390699993,
							30.31558801000006
						],
						[
							-81.74357490999995,
							30.315576956000086
						],
						[
							-81.74341791099994,
							30.31557001200008
						],
						[
							-81.7425119099999,
							30.315560013000038
						],
						[
							-81.7423189079999,
							30.315572012000075
						],
						[
							-81.7421519099999,
							30.31558301300004
						],
						[
							-81.7419149079999,
							30.315609012000035
						],
						[
							-81.7417309089999,
							30.31562001300006
						],
						[
							-81.74118591099995,
							30.315692013000046
						],
						[
							-81.74087490799991,
							30.315748012000082
						],
						[
							-81.74074991099991,
							30.315770012000087
						],
						[
							-81.7404409099999,
							30.315851012000053
						],
						[
							-81.74033091099994,
							30.315870013000048
						],
						[
							-81.73988290799991,
							30.315995012000087
						],
						[
							-81.7394109089999,
							30.31615301200009
						],
						[
							-81.7385109089999,
							30.316455013000052
						],
						[
							-81.73797290899995,
							30.316638013000045
						],
						[
							-81.73741890999992,
							30.316806013000072
						],
						[
							-81.7368939079999,
							30.31696001200004
						],
						[
							-81.73658091099992,
							30.317036012000074
						],
						[
							-81.7360009109999,
							30.31712801200007
						],
						[
							-81.7351789089999,
							30.31722501200005
						],
						[
							-81.73460790899992,
							30.31725101200004
						],
						[
							-81.7307358509999,
							30.317352010000036
						],
						[
							-81.7307319969999,
							30.31728900400009
						],
						[
							-81.73072790799995,
							30.317225010000076
						],
						[
							-81.7307239079999,
							30.316859011000076
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Normandy",
				"RegionID": "125453"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.7772970879999,
					30.29940092900006,
					-81.7518878539999,
					30.31563409900008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.75196092199991,
							30.31563409900008
						],
						[
							-81.75195690999993,
							30.315528012000073
						],
						[
							-81.75195290999994,
							30.315422013000045
						],
						[
							-81.75195290999994,
							30.315174013000046
						],
						[
							-81.7519509089999,
							30.314735012000085
						],
						[
							-81.7519519089999,
							30.31446501300007
						],
						[
							-81.75195290999994,
							30.31407401300004
						],
						[
							-81.7519449099999,
							30.31379501200007
						],
						[
							-81.75196090999994,
							30.313177013000086
						],
						[
							-81.7519449099999,
							30.31263701300008
						],
						[
							-81.75195290999994,
							30.31194901300006
						],
						[
							-81.75193790999992,
							30.31156201300007
						],
						[
							-81.75193190899995,
							30.31117101300004
						],
						[
							-81.7519299089999,
							30.311060012000038
						],
						[
							-81.7519299089999,
							30.31086501300007
						],
						[
							-81.75193790999992,
							30.31037301200007
						],
						[
							-81.7519449099999,
							30.31005701300006
						],
						[
							-81.75193790999992,
							30.309402012000078
						],
						[
							-81.75191190899994,
							30.30878701300009
						],
						[
							-81.7518999099999,
							30.306515012000087
						],
						[
							-81.7518878539999,
							30.306060972000072
						],
						[
							-81.75208490799992,
							30.30597801000005
						],
						[
							-81.75287090799992,
							30.305647011000076
						],
						[
							-81.7532599349999,
							30.305494056000043
						],
						[
							-81.7532788819999,
							30.305479964000085
						],
						[
							-81.75364190699992,
							30.305332011000075
						],
						[
							-81.75393890799995,
							30.30521301100004
						],
						[
							-81.75428790799992,
							30.305075011000046
						],
						[
							-81.75486790699995,
							30.304841011000068
						],
						[
							-81.75523290799994,
							30.304689011000054
						],
						[
							-81.75569490799995,
							30.304500011000076
						],
						[
							-81.75638690699992,
							30.304240011000047
						],
						[
							-81.75654797699991,
							30.30418007600008
						],
						[
							-81.75785990799994,
							30.30364001000004
						],
						[
							-81.75928190699995,
							30.30305401100009
						],
						[
							-81.76027290699994,
							30.302641011000045
						],
						[
							-81.76114990699995,
							30.302271010000087
						],
						[
							-81.76120890699991,
							30.30224601100008
						],
						[
							-81.76218990699994,
							30.301825011000062
						],
						[
							-81.76265790699995,
							30.301612010000042
						],
						[
							-81.76288490699994,
							30.301506011000075
						],
						[
							-81.76311590699993,
							30.301389011000083
						],
						[
							-81.76434490799994,
							30.30080201100009
						],
						[
							-81.76475688999994,
							30.30060596000004
						],
						[
							-81.76502292599992,
							30.300559060000072
						],
						[
							-81.76588790799991,
							30.30011901100005
						],
						[
							-81.76729986799995,
							30.29940092900006
						],
						[
							-81.76773490799991,
							30.300414011000044
						],
						[
							-81.7679179079999,
							30.300889011000038
						],
						[
							-81.76840790699993,
							30.302095011000063
						],
						[
							-81.76890390799991,
							30.303295010000056
						],
						[
							-81.76928490799992,
							30.30426501000005
						],
						[
							-81.7693709099999,
							30.304440011000054
						],
						[
							-81.7693939049999,
							30.304470009000056
						],
						[
							-81.76953090799994,
							30.304752010000076
						],
						[
							-81.76961490799994,
							30.30489701000005
						],
						[
							-81.76979790799993,
							30.305149010000033
						],
						[
							-81.77007290799992,
							30.305445010000085
						],
						[
							-81.7701489069999,
							30.305510010000038
						],
						[
							-81.77042390799994,
							30.305740010000083
						],
						[
							-81.77067590699994,
							30.305902010000068
						],
						[
							-81.7708919079999,
							30.306024010000048
						],
						[
							-81.77114890699994,
							30.306144010000082
						],
						[
							-81.77142490799991,
							30.306253011000077
						],
						[
							-81.77152290799995,
							30.306291010000052
						],
						[
							-81.7716120639999,
							30.306311910000094
						],
						[
							-81.77152790899993,
							30.306659011000082
						],
						[
							-81.77149090699993,
							30.307099010000062
						],
						[
							-81.77147590699991,
							30.30740501100007
						],
						[
							-81.77148290799994,
							30.307682010000065
						],
						[
							-81.77151390799992,
							30.30798901000009
						],
						[
							-81.77157490799993,
							30.30829601000005
						],
						[
							-81.77178190699993,
							30.308893010000073
						],
						[
							-81.7720179069999,
							30.309448011000086
						],
						[
							-81.77212490799991,
							30.309736010000048
						],
						[
							-81.77265190799994,
							30.311007011000072
						],
						[
							-81.77295690699992,
							30.31177101100008
						],
						[
							-81.77323890799994,
							30.312471011000074
						],
						[
							-81.77345990499992,
							30.31305701200006
						],
						[
							-81.77348278099993,
							30.313730143000043
						],
						[
							-81.77496590699991,
							30.313701011000038
						],
						[
							-81.77711404099995,
							30.313664879000044
						],
						[
							-81.7771059079999,
							30.313847010000078
						],
						[
							-81.77710690799995,
							30.314373010000057
						],
						[
							-81.77710673899992,
							30.314783081000087
						],
						[
							-81.7772970879999,
							30.314968948000057
						],
						[
							-81.77728292199993,
							30.315077062000057
						],
						[
							-81.77690890699995,
							30.315079010000087
						],
						[
							-81.77595190699992,
							30.31508301100007
						],
						[
							-81.77536190799992,
							30.31509101100005
						],
						[
							-81.77446590799991,
							30.31513101000007
						],
						[
							-81.77160490799992,
							30.31514801100008
						],
						[
							-81.77072490699993,
							30.315224011000055
						],
						[
							-81.77055785099992,
							30.315239000000076
						],
						[
							-81.77055403899993,
							30.31507687800007
						],
						[
							-81.77033990699994,
							30.31507401000005
						],
						[
							-81.76972690799994,
							30.315079010000087
						],
						[
							-81.76927790799994,
							30.315094010000053
						],
						[
							-81.7690919069999,
							30.315098010000042
						],
						[
							-81.7689339069999,
							30.315098010000042
						],
						[
							-81.76856490699993,
							30.31510901000007
						],
						[
							-81.76844690699994,
							30.31511201100005
						],
						[
							-81.76791390799991,
							30.315138010000055
						],
						[
							-81.76770290799993,
							30.31514001000005
						],
						[
							-81.76518190799993,
							30.31518501000005
						],
						[
							-81.76451590799991,
							30.315193010000087
						],
						[
							-81.76417590699992,
							30.31519501000008
						],
						[
							-81.76387790899992,
							30.315182011000047
						],
						[
							-81.75656290799992,
							30.315313010000065
						],
						[
							-81.75642390799993,
							30.315317011000047
						],
						[
							-81.7548837729999,
							30.31533988000007
						],
						[
							-81.75489490799993,
							30.31549001000008
						],
						[
							-81.75488803899992,
							30.315618145000087
						],
						[
							-81.75473390699996,
							30.315622010000084
						],
						[
							-81.7538719069999,
							30.315618010000037
						],
						[
							-81.75346490699991,
							30.315615010000045
						],
						[
							-81.75304390799994,
							30.31561701000004
						],
						[
							-81.75296690699992,
							30.315618010000037
						],
						[
							-81.7521399069999,
							30.315626010000074
						],
						[
							-81.75196092199991,
							30.31563409900008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Normandy Village",
				"RegionID": "125455"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.53301799999991,
					27.351650000000063,
					-82.5054179999999,
					27.389019000000076
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.51866699999994,
							27.38900300000006
						],
						[
							-82.51521699999995,
							27.38896200000005
						],
						[
							-82.51387099999995,
							27.388974000000076
						],
						[
							-82.51296899999994,
							27.388965000000045
						],
						[
							-82.51282199999991,
							27.388963000000047
						],
						[
							-82.50977399999994,
							27.388930000000073
						],
						[
							-82.50975399999993,
							27.388930000000073
						],
						[
							-82.50570099999993,
							27.38890500000008
						],
						[
							-82.50561799999991,
							27.388904000000082
						],
						[
							-82.50562799999994,
							27.38790700000004
						],
						[
							-82.50563599999992,
							27.38689700000009
						],
						[
							-82.5056449999999,
							27.38513800000004
						],
						[
							-82.5056469999999,
							27.383379000000048
						],
						[
							-82.50565299999994,
							27.382688000000087
						],
						[
							-82.50565199999994,
							27.381755000000055
						],
						[
							-82.50565399999994,
							27.38033900000005
						],
						[
							-82.50565499999993,
							27.379684000000058
						],
						[
							-82.50566999999997,
							27.377879000000068
						],
						[
							-82.50566499999991,
							27.377792000000056
						],
						[
							-82.50566499999991,
							27.37610600000005
						],
						[
							-82.50566399999991,
							27.374315000000085
						],
						[
							-82.50565599999993,
							27.373114000000044
						],
						[
							-82.50565299999994,
							27.372648000000083
						],
						[
							-82.5054179999999,
							27.372422000000086
						],
						[
							-82.50565199999994,
							27.37247700000006
						],
						[
							-82.50565199999994,
							27.371166000000073
						],
						[
							-82.50564899999995,
							27.37103200000007
						],
						[
							-82.50565199999994,
							27.370674000000065
						],
						[
							-82.50565599999993,
							27.369116000000076
						],
						[
							-82.50565499999993,
							27.36890100000005
						],
						[
							-82.50566399999991,
							27.36702100000008
						],
						[
							-82.50567199999996,
							27.364618000000064
						],
						[
							-82.50565999999992,
							27.363961000000074
						],
						[
							-82.5056689999999,
							27.363311000000067
						],
						[
							-82.50567099999995,
							27.36312900000007
						],
						[
							-82.50567199999996,
							27.363026000000048
						],
						[
							-82.50567299999994,
							27.362898000000087
						],
						[
							-82.50567399999994,
							27.362839000000065
						],
						[
							-82.50567599999994,
							27.36163700000009
						],
						[
							-82.50567699999993,
							27.359736000000055
						],
						[
							-82.50568499999991,
							27.357706000000064
						],
						[
							-82.50567299999994,
							27.35677700000008
						],
						[
							-82.50567699999993,
							27.356036000000078
						],
						[
							-82.50566999999997,
							27.355296000000067
						],
						[
							-82.50568199999992,
							27.354553000000067
						],
						[
							-82.50568099999992,
							27.354314000000045
						],
						[
							-82.50568399999992,
							27.353809000000073
						],
						[
							-82.50568499999991,
							27.35334100000006
						],
						[
							-82.50568599999991,
							27.352943000000042
						],
						[
							-82.50568699999991,
							27.352602000000047
						],
						[
							-82.50568199999992,
							27.35251100000005
						],
						[
							-82.50567399999994,
							27.352374000000054
						],
						[
							-82.50566299999991,
							27.352166000000068
						],
						[
							-82.50566199999992,
							27.35189100000008
						],
						[
							-82.50566399999991,
							27.351788000000056
						],
						[
							-82.50566499999991,
							27.351728000000037
						],
						[
							-82.5065459999999,
							27.351725000000048
						],
						[
							-82.50737199999992,
							27.351722000000052
						],
						[
							-82.50819799999994,
							27.351722000000052
						],
						[
							-82.50901199999993,
							27.351716000000067
						],
						[
							-82.50984899999992,
							27.351735000000076
						],
						[
							-82.51005499999991,
							27.351716000000067
						],
						[
							-82.51096099999995,
							27.351698000000056
						],
						[
							-82.5114749999999,
							27.35169300000007
						],
						[
							-82.51157199999994,
							27.35169200000007
						],
						[
							-82.51166999999994,
							27.35169200000007
						],
						[
							-82.51302599999991,
							27.351665000000082
						],
						[
							-82.51314999999994,
							27.351664000000085
						],
						[
							-82.5139509999999,
							27.351650000000063
						],
						[
							-82.51407499999993,
							27.35165900000004
						],
						[
							-82.51482199999992,
							27.351716000000067
						],
						[
							-82.51725899999991,
							27.351725000000048
						],
						[
							-82.51810499999993,
							27.35169600000006
						],
						[
							-82.52287499999994,
							27.351915000000076
						],
						[
							-82.52303699999993,
							27.35191700000007
						],
						[
							-82.52313499999991,
							27.351825000000076
						],
						[
							-82.52317699999992,
							27.351795000000042
						],
						[
							-82.52373299999994,
							27.35173000000009
						],
						[
							-82.52411199999995,
							27.35172400000005
						],
						[
							-82.52423699999991,
							27.351722000000052
						],
						[
							-82.52428999999995,
							27.35172300000005
						],
						[
							-82.52545299999991,
							27.35177800000008
						],
						[
							-82.5262909999999,
							27.35172400000005
						],
						[
							-82.52642999999995,
							27.35171100000008
						],
						[
							-82.52688799999993,
							27.351731000000086
						],
						[
							-82.52681699999994,
							27.352249000000086
						],
						[
							-82.52693299999993,
							27.353109000000075
						],
						[
							-82.52693699999992,
							27.353149000000087
						],
						[
							-82.5267649999999,
							27.353138000000058
						],
						[
							-82.52687999999995,
							27.35436800000008
						],
						[
							-82.52687199999991,
							27.354483000000073
						],
						[
							-82.5270789999999,
							27.35449000000006
						],
						[
							-82.52724699999993,
							27.355232000000058
						],
						[
							-82.52745199999993,
							27.356122000000084
						],
						[
							-82.52720899999991,
							27.35611700000004
						],
						[
							-82.52781899999991,
							27.359622000000062
						],
						[
							-82.5282949999999,
							27.359601000000055
						],
						[
							-82.52831099999992,
							27.359673000000043
						],
						[
							-82.52852299999995,
							27.360486000000037
						],
						[
							-82.52867199999991,
							27.361277000000086
						],
						[
							-82.52882199999993,
							27.362078000000054
						],
						[
							-82.52888499999995,
							27.362543000000073
						],
						[
							-82.52961899999991,
							27.367122000000055
						],
						[
							-82.53069399999993,
							27.367106000000035
						],
						[
							-82.53070699999995,
							27.367570000000057
						],
						[
							-82.53071499999993,
							27.367864000000054
						],
						[
							-82.5307269999999,
							27.36816900000008
						],
						[
							-82.53073199999994,
							27.36832300000009
						],
						[
							-82.53074799999992,
							27.368730000000085
						],
						[
							-82.53079499999991,
							27.369969000000083
						],
						[
							-82.53085399999992,
							27.372101000000043
						],
						[
							-82.53087799999992,
							27.373226000000045
						],
						[
							-82.53086999999994,
							27.373266000000058
						],
						[
							-82.53086499999995,
							27.37454800000006
						],
						[
							-82.53087499999992,
							27.374825000000044
						],
						[
							-82.53086999999994,
							27.37569300000007
						],
						[
							-82.53086699999994,
							27.376325000000065
						],
						[
							-82.53086599999995,
							27.378915000000063
						],
						[
							-82.53085699999991,
							27.37922800000007
						],
						[
							-82.53085399999992,
							27.37985800000007
						],
						[
							-82.53085599999991,
							27.38072100000005
						],
						[
							-82.5308369999999,
							27.380956000000083
						],
						[
							-82.53084399999995,
							27.381656000000078
						],
						[
							-82.53085699999991,
							27.382530000000088
						],
						[
							-82.53084299999996,
							27.38345000000004
						],
						[
							-82.5308409999999,
							27.385973000000035
						],
						[
							-82.53086899999994,
							27.386262000000045
						],
						[
							-82.5309079999999,
							27.38651800000008
						],
						[
							-82.53095999999994,
							27.38677000000007
						],
						[
							-82.53098299999994,
							27.38686000000007
						],
						[
							-82.53110099999992,
							27.38696200000004
						],
						[
							-82.53122399999995,
							27.387253000000044
						],
						[
							-82.53138399999995,
							27.38767600000006
						],
						[
							-82.53152099999994,
							27.387991000000056
						],
						[
							-82.5318749999999,
							27.38878800000009
						],
						[
							-82.53301799999991,
							27.38890100000009
						],
						[
							-82.53233299999994,
							27.38884700000006
						],
						[
							-82.53229199999994,
							27.38884700000006
						],
						[
							-82.53194999999994,
							27.38881900000007
						],
						[
							-82.53188299999994,
							27.38881400000008
						],
						[
							-82.53187099999991,
							27.388813000000084
						],
						[
							-82.5317859999999,
							27.388806000000045
						],
						[
							-82.53176499999995,
							27.38880400000005
						],
						[
							-82.53164499999991,
							27.388794000000075
						],
						[
							-82.5315829999999,
							27.38878800000009
						],
						[
							-82.5315119999999,
							27.38878200000005
						],
						[
							-82.53083599999991,
							27.388739000000044
						],
						[
							-82.53073499999994,
							27.38873200000006
						],
						[
							-82.53047099999992,
							27.388715000000047
						],
						[
							-82.53037799999993,
							27.388704000000075
						],
						[
							-82.53037199999996,
							27.388703000000078
						],
						[
							-82.53034999999994,
							27.388701000000083
						],
						[
							-82.5303189999999,
							27.388697000000036
						],
						[
							-82.53023999999994,
							27.38868800000006
						],
						[
							-82.5301639999999,
							27.38868400000007
						],
						[
							-82.53004299999992,
							27.388677000000087
						],
						[
							-82.52995699999991,
							27.388672000000042
						],
						[
							-82.52984199999992,
							27.388666000000057
						],
						[
							-82.52956099999994,
							27.388664000000063
						],
						[
							-82.52906299999995,
							27.38866100000007
						],
						[
							-82.52878199999992,
							27.388660000000076
						],
						[
							-82.52876299999991,
							27.388660000000076
						],
						[
							-82.52856899999995,
							27.38865900000008
						],
						[
							-82.5280239999999,
							27.388656000000083
						],
						[
							-82.52771399999995,
							27.388654000000088
						],
						[
							-82.52731199999994,
							27.38865100000004
						],
						[
							-82.52726999999993,
							27.38865100000004
						],
						[
							-82.52664299999992,
							27.38864700000005
						],
						[
							-82.52650999999992,
							27.38864600000005
						],
						[
							-82.52650399999993,
							27.38864600000005
						],
						[
							-82.52591799999993,
							27.38864300000006
						],
						[
							-82.52571499999993,
							27.38864200000006
						],
						[
							-82.5254119999999,
							27.388640000000066
						],
						[
							-82.5249419999999,
							27.388649000000044
						],
						[
							-82.52492599999994,
							27.388649000000044
						],
						[
							-82.52458799999994,
							27.388655000000085
						],
						[
							-82.52417899999995,
							27.388664000000063
						],
						[
							-82.5240859999999,
							27.388671000000045
						],
						[
							-82.52389199999993,
							27.388685000000066
						],
						[
							-82.52383999999995,
							27.38869100000005
						],
						[
							-82.52324599999992,
							27.388757000000055
						],
						[
							-82.52218899999991,
							27.38887600000004
						],
						[
							-82.52211199999994,
							27.388885000000073
						],
						[
							-82.52199599999994,
							27.38889600000005
						],
						[
							-82.52151399999991,
							27.38894100000005
						],
						[
							-82.52056599999992,
							27.388998000000072
						],
						[
							-82.51997999999992,
							27.389019000000076
						],
						[
							-82.5196719999999,
							27.389015000000086
						],
						[
							-82.51866699999994,
							27.38900300000006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "North Sarasota",
				"RegionID": "125478"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.18846796999992,
					26.209260078000057,
					-80.1560671549999,
					26.232166833000065
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.16694266399992,
							26.23182337500009
						],
						[
							-80.16553491699995,
							26.231386488000055
						],
						[
							-80.1654776979999,
							26.231368730000046
						],
						[
							-80.16495060599993,
							26.23120515000005
						],
						[
							-80.15670760499995,
							26.23120515000005
						],
						[
							-80.1563189279999,
							26.218618349000053
						],
						[
							-80.1563141769999,
							26.21846450000004
						],
						[
							-80.1560671549999,
							26.210465017000047
						],
						[
							-80.15606794899992,
							26.210460151000063
						],
						[
							-80.15614082999991,
							26.210459840000055
						],
						[
							-80.15697206099992,
							26.210459840000055
						],
						[
							-80.15704494499994,
							26.210459840000055
						],
						[
							-80.15711782999996,
							26.210459840000055
						],
						[
							-80.15799506099997,
							26.210459840000055
						],
						[
							-80.15806794499991,
							26.210459840000055
						],
						[
							-80.15996794499995,
							26.21035984000008
						],
						[
							-80.1600408299999,
							26.21035984000008
						],
						[
							-80.1617950609999,
							26.21035984000008
						],
						[
							-80.16186794499993,
							26.21035984000008
						],
						[
							-80.16194082999993,
							26.21035984000008
						],
						[
							-80.16379606099991,
							26.21035984000008
						],
						[
							-80.16386894499993,
							26.21035984000008
						],
						[
							-80.16516994499995,
							26.210305840000046
						],
						[
							-80.1662689449999,
							26.21025984000005
						],
						[
							-80.16634182999991,
							26.21025984000005
						],
						[
							-80.16689606099993,
							26.21025984000005
						],
						[
							-80.16696894499995,
							26.21025984000005
						],
						[
							-80.1670418299999,
							26.21025984000005
						],
						[
							-80.16773606099991,
							26.21025984000005
						],
						[
							-80.16780894499995,
							26.21025984000005
						],
						[
							-80.16788182999994,
							26.21025984000005
						],
						[
							-80.16849606099993,
							26.21025984000005
						],
						[
							-80.16856894499995,
							26.21025984000005
						],
						[
							-80.16958494499994,
							26.21020684000007
						],
						[
							-80.17046894499993,
							26.210159840000074
						],
						[
							-80.17054182999993,
							26.210159840000074
						],
						[
							-80.17159606099995,
							26.210159840000074
						],
						[
							-80.17161402999994,
							26.210159759000078
						],
						[
							-80.17166894499991,
							26.210159840000074
						],
						[
							-80.17168796399994,
							26.210155606000058
						],
						[
							-80.17196994499994,
							26.210092840000073
						],
						[
							-80.17256894499991,
							26.209959840000067
						],
						[
							-80.17269569599995,
							26.20991230800007
						],
						[
							-80.1741689449999,
							26.20935984000005
						],
						[
							-80.17526052799991,
							26.209260605000058
						],
						[
							-80.17526892899991,
							26.209260078000057
						],
						[
							-80.1753343609999,
							26.209260718000053
						],
						[
							-80.17534181999991,
							26.20926060700009
						],
						[
							-80.17538607099995,
							26.209261073000054
						],
						[
							-80.1754589439999,
							26.20926187300006
						],
						[
							-80.17553181599993,
							26.209262737000074
						],
						[
							-80.17584027099991,
							26.209266530000036
						],
						[
							-80.1758913839999,
							26.209267159000035
						],
						[
							-80.17591408599992,
							26.20926743800004
						],
						[
							-80.1759651989999,
							26.20926806700004
						],
						[
							-80.1809960729999,
							26.20932994400005
						],
						[
							-80.18106894499994,
							26.20933083600005
						],
						[
							-80.18114181599992,
							26.20933172100007
						],
						[
							-80.18339607299993,
							26.20935896000009
						],
						[
							-80.18346891099992,
							26.209359684000052
						],
						[
							-80.18476894499992,
							26.209559840000054
						],
						[
							-80.18479606099993,
							26.209559840000054
						],
						[
							-80.18484182999993,
							26.209559840000054
						],
						[
							-80.18486894499996,
							26.209559840000054
						],
						[
							-80.1849418299999,
							26.209559840000054
						],
						[
							-80.1853112199999,
							26.209559840000054
						],
						[
							-80.18538504999992,
							26.209559840000054
						],
						[
							-80.18549606099992,
							26.209559840000054
						],
						[
							-80.18556894499996,
							26.209559840000054
						],
						[
							-80.18564182999995,
							26.209559840000054
						],
						[
							-80.18649406099992,
							26.209559840000054
						],
						[
							-80.18656694499992,
							26.209559840000054
						],
						[
							-80.18663982999993,
							26.209559840000054
						],
						[
							-80.18799606099992,
							26.209559840000054
						],
						[
							-80.18802171999994,
							26.209559840000054
						],
						[
							-80.18806487799992,
							26.209559840000054
						],
						[
							-80.18806894499994,
							26.209559840000054
						],
						[
							-80.1880681909999,
							26.209564330000035
						],
						[
							-80.18846331999993,
							26.21853321900005
						],
						[
							-80.18846796999992,
							26.21861743700009
						],
						[
							-80.18807089099994,
							26.21910267900006
						],
						[
							-80.18736989099995,
							26.219959679000056
						],
						[
							-80.1848218909999,
							26.222676679000074
						],
						[
							-80.18458689099992,
							26.22292767900007
						],
						[
							-80.1843698909999,
							26.223159679000048
						],
						[
							-80.1798698909999,
							26.228559679000057
						],
						[
							-80.17806989099995,
							26.230759679000073
						],
						[
							-80.17791189099995,
							26.230960679000077
						],
						[
							-80.17727767299994,
							26.231455849000042
						],
						[
							-80.1772049569999,
							26.23145530000005
						],
						[
							-80.17388052299992,
							26.231411225000045
						],
						[
							-80.17120154799994,
							26.231548608000082
						],
						[
							-80.1694155639999,
							26.23209814100005
						],
						[
							-80.1685225729999,
							26.232166833000065
						],
						[
							-80.16694266399992,
							26.23182337500009
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Pompano Beach",
				"Name": "Palm Aire",
				"RegionID": "125623"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.0435431109999,
					26.79276251400006,
					-80.03520353199991,
					26.79606958900007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.03534731699995,
							26.79276251400006
						],
						[
							-80.0435431109999,
							26.793098014000066
						],
						[
							-80.04272832399994,
							26.79606958900007
						],
						[
							-80.03520353199991,
							26.795853910000062
						],
						[
							-80.03534731699995,
							26.79276251400006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Riviera Beach",
				"Name": "Palm Beach Isles",
				"RegionID": "125628"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.82367699999992,
					26.210757000000058,
					-81.80042099999993,
					26.25408200000004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.80060499999992,
							26.22048600000005
						],
						[
							-81.80055399999992,
							26.217903000000035
						],
						[
							-81.80050299999994,
							26.215324000000066
						],
						[
							-81.80044299999992,
							26.212357000000058
						],
						[
							-81.80042099999993,
							26.211242000000084
						],
						[
							-81.80414699999994,
							26.21117600000008
						],
						[
							-81.80677999999995,
							26.21113500000007
						],
						[
							-81.80696999999992,
							26.211213000000043
						],
						[
							-81.80760499999991,
							26.211239000000035
						],
						[
							-81.80817599999995,
							26.211224000000072
						],
						[
							-81.80935499999993,
							26.211197000000084
						],
						[
							-81.80972799999995,
							26.211055000000044
						],
						[
							-81.80993099999996,
							26.210980000000063
						],
						[
							-81.8102199999999,
							26.210953000000075
						],
						[
							-81.81236999999993,
							26.210965000000044
						],
						[
							-81.81288199999995,
							26.210892000000058
						],
						[
							-81.81405899999993,
							26.21086100000008
						],
						[
							-81.81556499999994,
							26.210784000000046
						],
						[
							-81.8169979999999,
							26.210757000000058
						],
						[
							-81.81701599999991,
							26.210829000000047
						],
						[
							-81.81710699999991,
							26.211032000000046
						],
						[
							-81.81713799999994,
							26.211175000000082
						],
						[
							-81.81711899999993,
							26.211588000000063
						],
						[
							-81.81713799999994,
							26.21170900000004
						],
						[
							-81.81721699999991,
							26.211891000000037
						],
						[
							-81.81736999999993,
							26.21213300000005
						],
						[
							-81.8173682339999,
							26.21213913400004
						],
						[
							-81.81741099999994,
							26.21247600000004
						],
						[
							-81.81748059899991,
							26.21310922200007
						],
						[
							-81.81756499999995,
							26.21370200000007
						],
						[
							-81.81756062099993,
							26.213837270000056
						],
						[
							-81.81762499999991,
							26.214423000000068
						],
						[
							-81.81777499999993,
							26.21626800000007
						],
						[
							-81.81777999999991,
							26.21652000000006
						],
						[
							-81.81778431899994,
							26.216716616000042
						],
						[
							-81.81783999999993,
							26.216900000000066
						],
						[
							-81.81788299999994,
							26.217257000000075
						],
						[
							-81.81786999999991,
							26.217802000000063
						],
						[
							-81.81788899999992,
							26.218237000000045
						],
						[
							-81.81794999999995,
							26.218446000000085
						],
						[
							-81.81796199999991,
							26.21853400000009
						],
						[
							-81.8182369999999,
							26.21933800000005
						],
						[
							-81.81819399999995,
							26.219558000000063
						],
						[
							-81.8181449999999,
							26.21963500000004
						],
						[
							-81.81812823599995,
							26.219650115000036
						],
						[
							-81.81813399999994,
							26.219668000000073
						],
						[
							-81.81816499999991,
							26.219718000000057
						],
						[
							-81.81819599999994,
							26.219741000000056
						],
						[
							-81.81825499999991,
							26.219745000000046
						],
						[
							-81.81839592699993,
							26.21972141100008
						],
						[
							-81.81844399999994,
							26.219624000000067
						],
						[
							-81.81851099999996,
							26.21969000000007
						],
						[
							-81.81851099999996,
							26.219711208000035
						],
						[
							-81.8185939999999,
							26.219730000000084
						],
						[
							-81.8186916489999,
							26.219825735000086
						],
						[
							-81.81869499999993,
							26.219831000000056
						],
						[
							-81.81869647699995,
							26.219838253000038
						],
						[
							-81.81870299999991,
							26.21995100000004
						],
						[
							-81.81867499999993,
							26.22000500000007
						],
						[
							-81.8185959999999,
							26.22005400000006
						],
						[
							-81.81851313699991,
							26.220063106000055
						],
						[
							-81.81851099999996,
							26.22006331500006
						],
						[
							-81.81851099999996,
							26.220429667000076
						],
						[
							-81.81853099999995,
							26.22043300000007
						],
						[
							-81.81856999999991,
							26.220472000000086
						],
						[
							-81.81864399999995,
							26.22054600000007
						],
						[
							-81.81869499999993,
							26.22067300000009
						],
						[
							-81.81871999999993,
							26.220852000000036
						],
						[
							-81.81877099999991,
							26.22103800000008
						],
						[
							-81.8188439999999,
							26.221187000000043
						],
						[
							-81.81885199999994,
							26.221296000000052
						],
						[
							-81.8188671289999,
							26.221360146000052
						],
						[
							-81.81887699999993,
							26.221434471000066
						],
						[
							-81.81887699999993,
							26.22144200000008
						],
						[
							-81.81885199999994,
							26.22150000000005
						],
						[
							-81.8188493589999,
							26.221535138000036
						],
						[
							-81.81880491299995,
							26.221976360000042
						],
						[
							-81.81879299999993,
							26.22205000000008
						],
						[
							-81.81877099999991,
							26.222313000000042
						],
						[
							-81.81875999999994,
							26.222848000000056
						],
						[
							-81.81876399999993,
							26.22304100000008
						],
						[
							-81.81874199999993,
							26.223271000000068
						],
						[
							-81.8187529999999,
							26.22338700000006
						],
						[
							-81.81877899999995,
							26.223478000000057
						],
						[
							-81.81879299999993,
							26.223580000000084
						],
						[
							-81.81877099999991,
							26.22367100000008
						],
						[
							-81.81876399999993,
							26.223861000000056
						],
						[
							-81.81879299999993,
							26.22418500000009
						],
						[
							-81.8188219999999,
							26.22432000000009
						],
						[
							-81.8188189999999,
							26.22502700000007
						],
						[
							-81.81882999999993,
							26.225110000000086
						],
						[
							-81.81885499999993,
							26.225176000000094
						],
						[
							-81.8188659999999,
							26.225234000000057
						],
						[
							-81.81885899999992,
							26.225318000000073
						],
						[
							-81.81889499999994,
							26.225650000000087
						],
						[
							-81.81892799999991,
							26.22581000000008
						],
						[
							-81.81892799999991,
							26.22588600000006
						],
						[
							-81.81894299999993,
							26.22599600000007
						],
						[
							-81.81896499999993,
							26.22605800000008
						],
						[
							-81.81898999999993,
							26.226076000000035
						],
						[
							-81.81899699999991,
							26.226127000000076
						],
						[
							-81.81899399999992,
							26.226251000000047
						],
						[
							-81.81906299999991,
							26.226841000000036
						],
						[
							-81.81903799999992,
							26.227085000000045
						],
						[
							-81.8190449999999,
							26.22712100000007
						],
						[
							-81.81908499999992,
							26.227129000000048
						],
						[
							-81.8191139999999,
							26.22716100000008
						],
						[
							-81.81909999999993,
							26.227231000000074
						],
						[
							-81.81909999999993,
							26.22729300000009
						],
						[
							-81.81913999999995,
							26.227460000000065
						],
						[
							-81.81914699999993,
							26.22765700000008
						],
						[
							-81.8191359999999,
							26.227730000000065
						],
						[
							-81.81921099999994,
							26.228375000000085
						],
						[
							-81.81927499999995,
							26.228568000000053
						],
						[
							-81.81928199999993,
							26.22864000000004
						],
						[
							-81.81925599999994,
							26.228786000000074
						],
						[
							-81.81925599999994,
							26.228855000000067
						],
						[
							-81.81934699999994,
							26.229427000000044
						],
						[
							-81.8193839999999,
							26.229792000000092
						],
						[
							-81.81945699999994,
							26.229926000000034
						],
						[
							-81.81944199999992,
							26.23011900000006
						],
						[
							-81.81952599999994,
							26.23064400000004
						],
						[
							-81.81952999999993,
							26.230750000000057
						],
						[
							-81.8195839999999,
							26.231096000000036
						],
						[
							-81.81958099999991,
							26.23127400000004
						],
						[
							-81.81968999999992,
							26.23187900000005
						],
						[
							-81.81968999999992,
							26.23202500000008
						],
						[
							-81.8197229999999,
							26.23229800000007
						],
						[
							-81.81976299999991,
							26.232476000000077
						],
						[
							-81.81975199999994,
							26.232582000000036
						],
						[
							-81.81980299999992,
							26.232870000000048
						],
						[
							-81.81981399999995,
							26.23302700000005
						],
						[
							-81.8198319999999,
							26.233063000000072
						],
						[
							-81.81986899999993,
							26.233103000000085
						],
						[
							-81.81989099999993,
							26.23317200000008
						],
						[
							-81.81990899999994,
							26.233376000000078
						],
						[
							-81.81992699999995,
							26.23344600000007
						],
						[
							-81.81993399999993,
							26.23352900000009
						],
						[
							-81.81992799999995,
							26.233639000000043
						],
						[
							-81.8199239999999,
							26.233777000000092
						],
						[
							-81.81994899999995,
							26.23386400000004
						],
						[
							-81.81997499999994,
							26.23391500000008
						],
						[
							-81.81998899999991,
							26.233970000000056
						],
						[
							-81.81998899999991,
							26.234119000000078
						],
						[
							-81.81999999999994,
							26.234196000000054
						],
						[
							-81.82005099999992,
							26.234331000000054
						],
						[
							-81.82004799999993,
							26.23441500000007
						],
						[
							-81.82012399999991,
							26.23462600000005
						],
						[
							-81.82017899999994,
							26.23530700000009
						],
						[
							-81.82017499999995,
							26.23539500000004
						],
						[
							-81.82018199999993,
							26.235471000000075
						],
						[
							-81.82020399999993,
							26.23550000000006
						],
						[
							-81.82025899999991,
							26.23567100000008
						],
						[
							-81.82025499999992,
							26.235824000000036
						],
						[
							-81.8202629999999,
							26.23592300000007
						],
						[
							-81.8203269999999,
							26.236281000000076
						],
						[
							-81.8203759999999,
							26.23674600000004
						],
						[
							-81.82052899999992,
							26.237704000000065
						],
						[
							-81.82057599999992,
							26.237915000000044
						],
						[
							-81.82060199999995,
							26.238211000000035
						],
						[
							-81.82065299999994,
							26.23839300000009
						],
						[
							-81.82076599999994,
							26.23901600000005
						],
						[
							-81.82082799999995,
							26.239183000000082
						],
						[
							-81.82090026399993,
							26.239707679000052
						],
						[
							-81.8210699999999,
							26.24050100000005
						],
						[
							-81.82124699999991,
							26.24112800000006
						],
						[
							-81.82153399999993,
							26.24246500000004
						],
						[
							-81.82161999999994,
							26.24312000000009
						],
						[
							-81.82176599999991,
							26.243869000000075
						],
						[
							-81.82218099999994,
							26.245828000000074
						],
						[
							-81.82226327299992,
							26.246262965000085
						],
						[
							-81.82226799999995,
							26.24627600000008
						],
						[
							-81.8223339999999,
							26.246582000000046
						],
						[
							-81.82238099999995,
							26.246695000000045
						],
						[
							-81.82241399999992,
							26.246841000000074
						],
						[
							-81.82246099999992,
							26.24699400000009
						],
						[
							-81.82250099999993,
							26.247278000000055
						],
						[
							-81.82250775699993,
							26.24746298100007
						],
						[
							-81.82258499999995,
							26.247777000000042
						],
						[
							-81.82261499999993,
							26.248371000000077
						],
						[
							-81.82276799999994,
							26.249009000000058
						],
						[
							-81.82290199999994,
							26.249741000000085
						],
						[
							-81.8229609999999,
							26.250137000000056
						],
						[
							-81.82297399999993,
							26.250368000000037
						],
						[
							-81.8229859999999,
							26.25038500000005
						],
						[
							-81.82300399999991,
							26.25064400000008
						],
						[
							-81.82304699999992,
							26.250748000000048
						],
						[
							-81.82324799999994,
							26.251871000000055
						],
						[
							-81.82327299999992,
							26.251893000000052
						],
						[
							-81.82333399999993,
							26.25219000000004
						],
						[
							-81.82338899999992,
							26.25253100000009
						],
						[
							-81.82356599999991,
							26.253318000000036
						],
						[
							-81.82367699999992,
							26.25408200000004
						],
						[
							-81.8226049999999,
							26.25373200000007
						],
						[
							-81.82185499999991,
							26.25362400000006
						],
						[
							-81.8217229999999,
							26.25361200000009
						],
						[
							-81.82135299999993,
							26.25357800000006
						],
						[
							-81.82018499999992,
							26.25339100000008
						],
						[
							-81.82002199999994,
							26.25335700000005
						],
						[
							-81.81974699999995,
							26.253299000000087
						],
						[
							-81.8182359999999,
							26.25305700000007
						],
						[
							-81.81758999999994,
							26.252953000000048
						],
						[
							-81.81732499999993,
							26.252904000000058
						],
						[
							-81.8170889999999,
							26.25286900000009
						],
						[
							-81.81642199999993,
							26.252758000000085
						],
						[
							-81.81393899999995,
							26.252380000000073
						],
						[
							-81.81345699999991,
							26.252298000000053
						],
						[
							-81.81335299999995,
							26.25228100000004
						],
						[
							-81.81286299999994,
							26.252202000000068
						],
						[
							-81.81270499999994,
							26.252177000000074
						],
						[
							-81.81251299999991,
							26.25215600000007
						],
						[
							-81.81229999999994,
							26.25213300000007
						],
						[
							-81.8111209999999,
							26.251951000000076
						],
						[
							-81.81034999999991,
							26.25183700000008
						],
						[
							-81.8098159999999,
							26.25177300000007
						],
						[
							-81.80966499999994,
							26.25175100000007
						],
						[
							-81.80884199999991,
							26.251611000000082
						],
						[
							-81.8078579999999,
							26.25145400000008
						],
						[
							-81.80676199999994,
							26.251303000000064
						],
						[
							-81.80629599999992,
							26.251230000000078
						],
						[
							-81.80438299999992,
							26.25093700000008
						],
						[
							-81.80400199999991,
							26.250886000000037
						],
						[
							-81.80120799999992,
							26.250459000000035
						],
						[
							-81.80120399999993,
							26.250233000000037
						],
						[
							-81.80118099999993,
							26.24899300000004
						],
						[
							-81.80115799999993,
							26.24770600000005
						],
						[
							-81.80115299999994,
							26.247404000000074
						],
						[
							-81.80114099999992,
							26.246692000000056
						],
						[
							-81.80111499999992,
							26.245085000000074
						],
						[
							-81.80108899999993,
							26.24411800000007
						],
						[
							-81.8010579999999,
							26.242975000000058
						],
						[
							-81.80104099999994,
							26.24237000000005
						],
						[
							-81.80101899999994,
							26.241555000000062
						],
						[
							-81.80099199999995,
							26.239735000000053
						],
						[
							-81.80095899999992,
							26.238095000000044
						],
						[
							-81.8008969999999,
							26.23504900000006
						],
						[
							-81.80088399999994,
							26.23448300000007
						],
						[
							-81.80082899999991,
							26.232068000000083
						],
						[
							-81.80077599999993,
							26.229761000000053
						],
						[
							-81.80061899999993,
							26.221239000000086
						],
						[
							-81.80060499999992,
							26.22048600000005
						]
					],
					[
						[
							-81.8180329999999,
							26.21997500000009
						],
						[
							-81.81778932499992,
							26.219887132000053
						],
						[
							-81.81766399999992,
							26.21997200000004
						],
						[
							-81.81767555599993,
							26.219979222000063
						],
						[
							-81.81769711699991,
							26.219987846000038
						],
						[
							-81.81792499999995,
							26.22000900000006
						],
						[
							-81.81815699999993,
							26.22000900000006
						],
						[
							-81.81817082599991,
							26.22000111400007
						],
						[
							-81.8180329999999,
							26.21997500000009
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Collier",
				"City": "Naples",
				"Name": "Pelican Bay",
				"RegionID": "125698"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.234675,
					26.120863960000065,
					-80.21753090099998,
					26.135553583000046
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.21808717099998,
							26.12095413300006
						],
						[
							-80.21809733899995,
							26.120896513000048
						],
						[
							-80.21894910599997,
							26.120909892000043
						],
						[
							-80.21954668099994,
							26.120909892000043
						],
						[
							-80.23413742699995,
							26.120864100000063
						],
						[
							-80.23418199499997,
							26.120863960000065
						],
						[
							-80.23465962599994,
							26.13491861700004
						],
						[
							-80.234675,
							26.135371
						],
						[
							-80.227989,
							26.135447
						],
						[
							-80.22696770099998,
							26.13545938900006
						],
						[
							-80.22667,
							26.135463
						],
						[
							-80.21915268499998,
							26.135553583000046
						],
						[
							-80.21899522999996,
							26.134946978000073
						],
						[
							-80.21851692099995,
							26.132824481000057
						],
						[
							-80.21821506299995,
							26.131484989000057
						],
						[
							-80.21792851299995,
							26.130243274000065
						],
						[
							-80.21775325799996,
							26.12948383500003
						],
						[
							-80.21770307899999,
							26.129266391000044
						],
						[
							-80.21759365499997,
							26.12819456300008
						],
						[
							-80.21753090099998,
							26.12672843200005
						],
						[
							-80.21755093999997,
							26.126342989000022
						],
						[
							-80.21757388899994,
							26.12590157300008
						],
						[
							-80.21760555799995,
							26.125292417000026
						],
						[
							-80.21797126099995,
							26.121611006000023
						],
						[
							-80.21808717099998,
							26.12095413300006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Plantation",
				"Name": "Plantation Gardens",
				"RegionID": "125782"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.18273456999992,
					25.765195678000055,
					-80.14407467799992,
					25.782114322000044
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.16341548199995,
							25.775014199000054
						],
						[
							-80.1613891799999,
							25.77412896000004
						],
						[
							-80.16132366099993,
							25.774174836000043
						],
						[
							-80.16118158699993,
							25.774241087000064
						],
						[
							-80.16103016599993,
							25.774281660000042
						],
						[
							-80.16087399999992,
							25.774295322000057
						],
						[
							-80.1607178349999,
							25.774281660000042
						],
						[
							-80.1605664139999,
							25.774241087000064
						],
						[
							-80.1605325729999,
							25.774227990000043
						],
						[
							-80.15958939399991,
							25.773840934000077
						],
						[
							-80.15952258699991,
							25.773872087000086
						],
						[
							-80.15937116599991,
							25.773912660000065
						],
						[
							-80.1592149999999,
							25.77392632200008
						],
						[
							-80.15905883499994,
							25.773912660000065
						],
						[
							-80.15890741399994,
							25.773872087000086
						],
						[
							-80.1588618259999,
							25.773854072000063
						],
						[
							-80.15825813899994,
							25.773596288000082
						],
						[
							-80.15822316499992,
							25.773605659000054
						],
						[
							-80.1580669999999,
							25.77361932200006
						],
						[
							-80.15791083399995,
							25.773605659000054
						],
						[
							-80.15775941299995,
							25.773565086000076
						],
						[
							-80.15773026799991,
							25.77355390100007
						],
						[
							-80.15683790499992,
							25.77319355900005
						],
						[
							-80.1555095409999,
							25.77266321600007
						],
						[
							-80.15546866999995,
							25.772645715000067
						],
						[
							-80.15330927499991,
							25.771657196000035
						],
						[
							-80.15273806499994,
							25.77140845300005
						],
						[
							-80.15037262699991,
							25.770377817000053
						],
						[
							-80.1487379429999,
							25.769666535000056
						],
						[
							-80.14871464799995,
							25.76965599400006
						],
						[
							-80.14518064799995,
							25.767995994000046
						],
						[
							-80.14514117099992,
							25.767976255000065
						],
						[
							-80.14472317199994,
							25.767754255000057
						],
						[
							-80.14466313299994,
							25.76771933100008
						],
						[
							-80.14460596799995,
							25.767679878000084
						],
						[
							-80.14455201899995,
							25.767636131000074
						],
						[
							-80.14450160599995,
							25.767588351000086
						],
						[
							-80.14445503199994,
							25.767536823000057
						],
						[
							-80.1444125729999,
							25.76748185300005
						],
						[
							-80.14424157299993,
							25.767241853000087
						],
						[
							-80.14419516499993,
							25.767169661000082
						],
						[
							-80.14412891399991,
							25.76702758600004
						],
						[
							-80.14408834099993,
							25.76687616600009
						],
						[
							-80.14407467799992,
							25.766720000000078
						],
						[
							-80.14408834099993,
							25.766563834000067
						],
						[
							-80.14412891399991,
							25.76641241400006
						],
						[
							-80.14416166299992,
							25.766334141000073
						],
						[
							-80.14421866299995,
							25.766214140000045
						],
						[
							-80.14425026499993,
							25.766153645000088
						],
						[
							-80.14428636399994,
							25.766095721000056
						],
						[
							-80.14432675199993,
							25.766040702000055
						],
						[
							-80.14437119599995,
							25.76598890300005
						],
						[
							-80.14441944099993,
							25.76594062500004
						],
						[
							-80.14447120799991,
							25.765896144000067
						],
						[
							-80.14464220799994,
							25.765760144000073
						],
						[
							-80.14475233899992,
							25.765685164000047
						],
						[
							-80.14477339899992,
							25.765673379000077
						],
						[
							-80.1449398019999,
							25.765582445000064
						],
						[
							-80.14498699099994,
							25.76553559300004
						],
						[
							-80.14504356899994,
							25.765481025000046
						],
						[
							-80.14510469499993,
							25.76543160600005
						],
						[
							-80.1451699029999,
							25.765387713000052
						],
						[
							-80.14523869499993,
							25.76534968200008
						],
						[
							-80.14540969599994,
							25.765264682000065
						],
						[
							-80.14547276099995,
							25.76523637100007
						],
						[
							-80.14547296799992,
							25.765236297000058
						],
						[
							-80.14667346999994,
							25.765195678000055
						],
						[
							-80.14733389199995,
							25.76521556700004
						],
						[
							-80.14735563199991,
							25.765215993000083
						],
						[
							-80.14927861299992,
							25.765236885000036
						],
						[
							-80.15532966599994,
							25.76540814100008
						],
						[
							-80.15828944899994,
							25.765513122000073
						],
						[
							-80.16005529699993,
							25.765562333000048
						],
						[
							-80.16077657999995,
							25.765595640000072
						],
						[
							-80.16089116599994,
							25.765608341000075
						],
						[
							-80.16098854299992,
							25.765631158000076
						],
						[
							-80.16228854299993,
							25.766013158000078
						],
						[
							-80.16241492099994,
							25.76606086800007
						],
						[
							-80.1640219219999,
							25.766809869000042
						],
						[
							-80.16409166099993,
							25.76684616500006
						],
						[
							-80.16422007299991,
							25.76693608000005
						],
						[
							-80.16433092099993,
							25.76704692700008
						],
						[
							-80.16442083599992,
							25.76717533900006
						],
						[
							-80.16448708699994,
							25.767317414000047
						],
						[
							-80.16452353099993,
							25.767453428000067
						],
						[
							-80.16622511999992,
							25.768179905000068
						],
						[
							-80.1662882199999,
							25.76820972900009
						],
						[
							-80.16634879799994,
							25.768244391000053
						],
						[
							-80.16640648299995,
							25.76828367900004
						],
						[
							-80.16646092199994,
							25.76832735300008
						],
						[
							-80.16651178399991,
							25.76837514500005
						],
						[
							-80.16655875799995,
							25.768426765000072
						],
						[
							-80.16771727899993,
							25.76894509400006
						],
						[
							-80.16778562799993,
							25.76897922900008
						],
						[
							-80.16782825199994,
							25.76900283000009
						],
						[
							-80.16791775199994,
							25.768995745000044
						],
						[
							-80.16798350399995,
							25.76899681200007
						],
						[
							-80.16805273699993,
							25.769000679000044
						],
						[
							-80.16812146599995,
							25.769009869000058
						],
						[
							-80.16818928299995,
							25.769024327000068
						],
						[
							-80.16825578399994,
							25.769043967000073
						],
						[
							-80.16832057499994,
							25.76906867200006
						],
						[
							-80.16878809199994,
							25.769267910000053
						],
						[
							-80.1690905669999,
							25.76939124900008
						],
						[
							-80.16912407899991,
							25.769405714000072
						],
						[
							-80.16977522799993,
							25.76970259000007
						],
						[
							-80.17269221399994,
							25.770973971000046
						],
						[
							-80.17330210299991,
							25.771241359000047
						],
						[
							-80.17337011099994,
							25.771274369000082
						],
						[
							-80.17343499799995,
							25.771313153000055
						],
						[
							-80.17349627699991,
							25.771357420000072
						],
						[
							-80.1735534849999,
							25.77140683600004
						],
						[
							-80.17360618999993,
							25.771461027000043
						],
						[
							-80.17365399599993,
							25.771519587000057
						],
						[
							-80.17369654199992,
							25.771582073000047
						],
						[
							-80.17424705099995,
							25.771839716000045
						],
						[
							-80.17455198499994,
							25.771973263000064
						],
						[
							-80.1746068349999,
							25.771960341000067
						],
						[
							-80.17476299999993,
							25.771946678000063
						],
						[
							-80.17491916599994,
							25.771960341000067
						],
						[
							-80.17507058699994,
							25.772000914000046
						],
						[
							-80.17511445999992,
							25.77201819800007
						],
						[
							-80.17761688699994,
							25.77308067000007
						],
						[
							-80.17919031399992,
							25.773764142000065
						],
						[
							-80.17928166099995,
							25.773810165000043
						],
						[
							-80.17941007299993,
							25.77390008000009
						],
						[
							-80.17952092099995,
							25.774010927000063
						],
						[
							-80.17961083599994,
							25.774139339000047
						],
						[
							-80.17965488199991,
							25.774225258000058
						],
						[
							-80.17979041599995,
							25.774308909000073
						],
						[
							-80.17985399699995,
							25.77435164200006
						],
						[
							-80.17991370999994,
							25.77439963100005
						],
						[
							-80.17996912299992,
							25.77445252900009
						],
						[
							-80.1800198329999,
							25.774509950000038
						],
						[
							-80.18006547099992,
							25.77457147800004
						],
						[
							-80.18014747199993,
							25.774692478000077
						],
						[
							-80.18021749099995,
							25.774815707000073
						],
						[
							-80.1803772639999,
							25.77515700300006
						],
						[
							-80.18042660799995,
							25.77522893400004
						],
						[
							-80.18049422099995,
							25.775251696000055
						],
						[
							-80.18055970799992,
							25.775280001000056
						],
						[
							-80.1806226139999,
							25.77531365100009
						],
						[
							-80.18068250599993,
							25.775352415000043
						],
						[
							-80.1807389679999,
							25.77539602300004
						],
						[
							-80.18079160899993,
							25.775444174000086
						],
						[
							-80.18084006499993,
							25.77549653500006
						],
						[
							-80.1819036569999,
							25.77672573700005
						],
						[
							-80.18255208399995,
							25.777493933000073
						],
						[
							-80.18259551699992,
							25.77754757000008
						],
						[
							-80.1826340959999,
							25.777604798000084
						],
						[
							-80.18266752499994,
							25.777665179000053
						],
						[
							-80.18269554999995,
							25.777728251000042
						],
						[
							-80.18271795499993,
							25.777793530000054
						],
						[
							-80.18273456999992,
							25.777860518000068
						],
						[
							-80.18254492999995,
							25.778547827000068
						],
						[
							-80.18240419099993,
							25.77909988400006
						],
						[
							-80.1823192629999,
							25.77928612900007
						],
						[
							-80.18229614799992,
							25.77933314200004
						],
						[
							-80.18220329099995,
							25.779509525000037
						],
						[
							-80.18218956899995,
							25.779572451000035
						],
						[
							-80.18215508599991,
							25.779692586000067
						],
						[
							-80.18213091799994,
							25.779752251000048
						],
						[
							-80.1820969179999,
							25.779828251000087
						],
						[
							-80.1820548359999,
							25.779910661000088
						],
						[
							-80.18196492099992,
							25.78003907300007
						],
						[
							-80.1818540729999,
							25.78014992100009
						],
						[
							-80.18172566099992,
							25.78023983600008
						],
						[
							-80.1816461379999,
							25.780280621000088
						],
						[
							-80.18161513799993,
							25.780294620000063
						],
						[
							-80.18155258599995,
							25.780320086000074
						],
						[
							-80.18147971899992,
							25.780339611000045
						],
						[
							-80.18140597799994,
							25.78048066100007
						],
						[
							-80.18138951999993,
							25.78051073200004
						],
						[
							-80.18095695099993,
							25.781266506000065
						],
						[
							-80.18077351999995,
							25.781624815000043
						],
						[
							-80.1807518359999,
							25.781664661000036
						],
						[
							-80.18066192099991,
							25.781793073000074
						],
						[
							-80.18055107299996,
							25.781903921000037
						],
						[
							-80.18042266099991,
							25.781993836000083
						],
						[
							-80.18028058699991,
							25.782060086000058
						],
						[
							-80.18012916599992,
							25.782100659000037
						],
						[
							-80.1799729999999,
							25.782114322000044
						],
						[
							-80.17981683499994,
							25.782100659000037
						],
						[
							-80.17966541399994,
							25.782060086000058
						],
						[
							-80.17960760799993,
							25.782036747000063
						],
						[
							-80.1785433039999,
							25.781563497000036
						],
						[
							-80.16996832899991,
							25.777792910000073
						],
						[
							-80.16732386399993,
							25.77669334600006
						],
						[
							-80.16341548199995,
							25.775014199000054
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami",
				"Name": "Port of Miami - Dodge Island",
				"RegionID": "125837"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-85.72111499999994,
					30.18961900000005,
					-85.67590899999993,
					30.211487000000087
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-85.68552799999992,
								30.190461000000084
							],
							[
								-85.68552799999992,
								30.189822000000053
							],
							[
								-85.68608599999993,
								30.189824000000048
							],
							[
								-85.68609299999991,
								30.190356000000065
							],
							[
								-85.68629199999992,
								30.190356000000065
							],
							[
								-85.68629199999992,
								30.19046300000008
							],
							[
								-85.68629199999992,
								30.190732000000082
							],
							[
								-85.68552899999992,
								30.190732000000082
							],
							[
								-85.68552799999992,
								30.190461000000084
							]
						]
					],
					[
						[
							[
								-85.6992909999999,
								30.190300000000033
							],
							[
								-85.69936399999996,
								30.19024300000007
							],
							[
								-85.69978099999992,
								30.19082700000007
							],
							[
								-85.69957699999992,
								30.19103000000007
							],
							[
								-85.69915299999991,
								30.190450000000055
							],
							[
								-85.6992909999999,
								30.190300000000033
							]
						]
					],
					[
						[
							[
								-85.69848999999994,
								30.190632000000047
							],
							[
								-85.69825299999991,
								30.19063100000005
							],
							[
								-85.69813899999991,
								30.190634000000045
							],
							[
								-85.69806599999993,
								30.190579000000074
							],
							[
								-85.69805699999995,
								30.190312000000063
							],
							[
								-85.69848499999995,
								30.190290000000065
							],
							[
								-85.6984799999999,
								30.190505000000087
							],
							[
								-85.69849899999991,
								30.19054200000005
							],
							[
								-85.69855399999994,
								30.19057000000004
							],
							[
								-85.69873799999993,
								30.190616000000038
							],
							[
								-85.69882999999993,
								30.190597000000082
							],
							[
								-85.69886699999995,
								30.19054200000005
							],
							[
								-85.69941199999994,
								30.191170000000056
							],
							[
								-85.69926399999991,
								30.191297000000077
							],
							[
								-85.69921699999992,
								30.19133300000004
							],
							[
								-85.69914799999992,
								30.191385000000082
							],
							[
								-85.69848999999994,
								30.190632000000047
							]
						]
					],
					[
						[
							[
								-85.69080899999994,
								30.191650000000042
							],
							[
								-85.6908029999999,
								30.191232000000074
							],
							[
								-85.69051899999994,
								30.191231000000077
							],
							[
								-85.69052499999992,
								30.191644000000057
							],
							[
								-85.68994399999993,
								30.191644000000057
							],
							[
								-85.68980799999991,
								30.191644000000057
							],
							[
								-85.6898139999999,
								30.19122900000008
							],
							[
								-85.68981699999995,
								30.191049000000074
							],
							[
								-85.68984499999993,
								30.190781000000072
							],
							[
								-85.68986999999993,
								30.190642000000082
							],
							[
								-85.68987199999992,
								30.19045900000009
							],
							[
								-85.68988499999995,
								30.189846000000045
							],
							[
								-85.69007099999993,
								30.189850000000035
							],
							[
								-85.69045099999994,
								30.189856000000077
							],
							[
								-85.69130999999993,
								30.189870000000045
							],
							[
								-85.69130999999993,
								30.19049700000005
							],
							[
								-85.6912999999999,
								30.190558000000067
							],
							[
								-85.6913009999999,
								30.190654000000052
							],
							[
								-85.69149199999994,
								30.190657000000044
							],
							[
								-85.69187199999993,
								30.190657000000044
							],
							[
								-85.69187099999994,
								30.190717000000067
							],
							[
								-85.6918639999999,
								30.191236000000057
							],
							[
								-85.69144199999994,
								30.19123400000007
							],
							[
								-85.69144299999995,
								30.191657000000074
							],
							[
								-85.69080899999994,
								30.191650000000042
							]
						]
					],
					[
						[
							[
								-85.67637599999995,
								30.194391000000053
							],
							[
								-85.67604799999992,
								30.194149000000035
							],
							[
								-85.67629699999992,
								30.194034000000045
							],
							[
								-85.67630699999995,
								30.19384900000006
							],
							[
								-85.67591799999991,
								30.193845000000067
							],
							[
								-85.67590899999993,
								30.193211000000076
							],
							[
								-85.67666099999991,
								30.19319600000006
							],
							[
								-85.67669599999994,
								30.19385300000005
							],
							[
								-85.6769559999999,
								30.193855000000045
							],
							[
								-85.67695199999991,
								30.193227000000036
							],
							[
								-85.67714599999994,
								30.19322200000005
							],
							[
								-85.6771579999999,
								30.19314300000008
							],
							[
								-85.6776799999999,
								30.193149000000066
							],
							[
								-85.67768799999993,
								30.192956000000038
							],
							[
								-85.67703599999993,
								30.19295900000009
							],
							[
								-85.67703599999993,
								30.19260600000007
							],
							[
								-85.67769299999992,
								30.19260500000007
							],
							[
								-85.67798399999992,
								30.19260600000007
							],
							[
								-85.67798599999992,
								30.19294700000006
							],
							[
								-85.67798899999991,
								30.193389000000085
							],
							[
								-85.67767299999991,
								30.19338400000004
							],
							[
								-85.67765799999995,
								30.193872000000056
							],
							[
								-85.67775699999994,
								30.193906000000087
							],
							[
								-85.67778699999991,
								30.193924000000038
							],
							[
								-85.67740999999995,
								30.194320000000065
							],
							[
								-85.67730999999992,
								30.194238000000038
							],
							[
								-85.67703999999992,
								30.19448600000004
							],
							[
								-85.67674599999992,
								30.194778000000042
							],
							[
								-85.67642499999994,
								30.19444100000004
							],
							[
								-85.67637599999995,
								30.194391000000053
							]
						]
					],
					[
						[
							[
								-85.69138299999992,
								30.206867000000045
							],
							[
								-85.6913899999999,
								30.206146000000043
							],
							[
								-85.69190399999991,
								30.20640900000007
							],
							[
								-85.6917489999999,
								30.206500000000062
							],
							[
								-85.69177199999992,
								30.206439000000046
							],
							[
								-85.69138299999992,
								30.206867000000045
							]
						]
					],
					[
						[
							[
								-85.67952999999994,
								30.19705500000003
							],
							[
								-85.67975499999994,
								30.197036000000086
							],
							[
								-85.67998699999993,
								30.19685200000004
							],
							[
								-85.6799059999999,
								30.196780000000047
							],
							[
								-85.67952999999994,
								30.19705500000003
							],
							[
								-85.67926299999993,
								30.196856000000086
							],
							[
								-85.67964099999995,
								30.19655000000006
							],
							[
								-85.67952699999995,
								30.196453000000076
							],
							[
								-85.67915999999991,
								30.196751000000063
							],
							[
								-85.67851699999994,
								30.196269000000086
							],
							[
								-85.6789159999999,
								30.195940000000064
							],
							[
								-85.67875599999991,
								30.195816000000036
							],
							[
								-85.67835999999994,
								30.19614900000005
							],
							[
								-85.6779699999999,
								30.19587100000007
							],
							[
								-85.67787699999991,
								30.19578700000005
							],
							[
								-85.67690899999991,
								30.19491400000004
							],
							[
								-85.67722999999995,
								30.194637000000057
							],
							[
								-85.67741299999994,
								30.194776000000047
							],
							[
								-85.6776549999999,
								30.194521000000062
							],
							[
								-85.6780399999999,
								30.19412600000004
							],
							[
								-85.67826799999995,
								30.19431800000007
							],
							[
								-85.67845099999994,
								30.194133000000082
							],
							[
								-85.67800699999992,
								30.193751000000077
							],
							[
								-85.67800699999992,
								30.193657000000087
							],
							[
								-85.67878699999996,
								30.193561000000045
							],
							[
								-85.67850399999992,
								30.193077000000073
							],
							[
								-85.67838999999992,
								30.192977000000038
							],
							[
								-85.67832099999993,
								30.192949000000056
							],
							[
								-85.67823699999991,
								30.192937000000086
							],
							[
								-85.67833899999994,
								30.192570000000046
							],
							[
								-85.67949699999991,
								30.192562000000066
							],
							[
								-85.67949699999991,
								30.191455000000076
							],
							[
								-85.67949699999991,
								30.190848000000077
							],
							[
								-85.67961899999995,
								30.190726000000037
							],
							[
								-85.67983599999991,
								30.19074500000005
							],
							[
								-85.6799059999999,
								30.190754000000087
							],
							[
								-85.67998199999994,
								30.19074900000004
							],
							[
								-85.67998399999993,
								30.190898000000065
							],
							[
								-85.68033999999994,
								30.19095700000008
							],
							[
								-85.68043699999993,
								30.190809000000062
							],
							[
								-85.68043699999993,
								30.190677000000047
							],
							[
								-85.6804259999999,
								30.19064300000008
							],
							[
								-85.68042099999991,
								30.190581000000062
							],
							[
								-85.6804259999999,
								30.189817000000065
							],
							[
								-85.68086199999993,
								30.18981900000006
							],
							[
								-85.68172399999992,
								30.189817000000065
							],
							[
								-85.68174699999992,
								30.18997400000006
							],
							[
								-85.68196799999993,
								30.190195000000077
							],
							[
								-85.68197299999991,
								30.19028300000008
							],
							[
								-85.68206199999992,
								30.190322000000037
							],
							[
								-85.68232399999994,
								30.190308000000073
							],
							[
								-85.68247699999995,
								30.190316000000053
							],
							[
								-85.68253699999993,
								30.19031700000005
							],
							[
								-85.68253599999991,
								30.189817000000065
							],
							[
								-85.6835089999999,
								30.189817000000065
							],
							[
								-85.68395199999992,
								30.189818000000063
							],
							[
								-85.68394199999996,
								30.190312000000063
							],
							[
								-85.68349499999994,
								30.190307000000075
							],
							[
								-85.68349399999994,
								30.190359000000058
							],
							[
								-85.68349199999994,
								30.190458000000035
							],
							[
								-85.6834859999999,
								30.19075300000009
							],
							[
								-85.68347899999993,
								30.191066000000035
							],
							[
								-85.68345599999992,
								30.19211500000006
							],
							[
								-85.68435599999992,
								30.192607000000066
							],
							[
								-85.68494399999992,
								30.192905000000053
							],
							[
								-85.68494199999992,
								30.19258900000006
							],
							[
								-85.68519499999991,
								30.19258100000008
							],
							[
								-85.68521499999991,
								30.19179700000007
							],
							[
								-85.68766799999992,
								30.191760000000045
							],
							[
								-85.68768299999994,
								30.19122500000009
							],
							[
								-85.68768599999993,
								30.191009000000065
							],
							[
								-85.68768899999992,
								30.190723000000045
							],
							[
								-85.68857999999994,
								30.190717000000067
							],
							[
								-85.68857999999994,
								30.19102600000008
							],
							[
								-85.68858099999994,
								30.191227000000087
							],
							[
								-85.68858199999994,
								30.19125800000006
							],
							[
								-85.68826599999994,
								30.19127000000009
							],
							[
								-85.68825399999992,
								30.19165300000009
							],
							[
								-85.68858199999994,
								30.191652000000094
							],
							[
								-85.68865499999993,
								30.19165300000009
							],
							[
								-85.68866099999991,
								30.19172000000009
							],
							[
								-85.6894519999999,
								30.19174400000009
							],
							[
								-85.68942299999992,
								30.192399000000083
							],
							[
								-85.68941599999994,
								30.192578000000083
							],
							[
								-85.68957499999993,
								30.192580000000078
							],
							[
								-85.68957799999993,
								30.19273200000004
							],
							[
								-85.68930599999993,
								30.19273200000004
							],
							[
								-85.68931099999992,
								30.192577000000085
							],
							[
								-85.68899499999992,
								30.19257300000004
							],
							[
								-85.68898999999993,
								30.19293900000008
							],
							[
								-85.68957799999993,
								30.19293900000008
							],
							[
								-85.6895669999999,
								30.193709000000073
							],
							[
								-85.69054599999993,
								30.193709000000073
							],
							[
								-85.69054599999993,
								30.193922000000043
							],
							[
								-85.69107899999995,
								30.193925000000036
							],
							[
								-85.69171099999994,
								30.193932000000075
							],
							[
								-85.69171399999993,
								30.193721000000043
							],
							[
								-85.69054599999993,
								30.193709000000073
							],
							[
								-85.69054099999994,
								30.193565000000035
							],
							[
								-85.6905769999999,
								30.19259200000005
							],
							[
								-85.69182499999994,
								30.192607000000066
							],
							[
								-85.69184299999995,
								30.19194400000003
							],
							[
								-85.6926949999999,
								30.191947000000084
							],
							[
								-85.69305099999991,
								30.191420000000054
							],
							[
								-85.69303999999995,
								30.19123300000007
							],
							[
								-85.69302299999993,
								30.190713000000077
							],
							[
								-85.6930539999999,
								30.189849000000038
							],
							[
								-85.69363699999991,
								30.189833000000075
							],
							[
								-85.69388099999993,
								30.18982700000004
							],
							[
								-85.69513599999993,
								30.189794000000063
							],
							[
								-85.69513699999993,
								30.18991300000005
							],
							[
								-85.69496199999993,
								30.18992000000009
							],
							[
								-85.69497499999994,
								30.19023400000009
							],
							[
								-85.69507399999992,
								30.19037600000007
							],
							[
								-85.69522199999994,
								30.19036900000009
							],
							[
								-85.69527099999993,
								30.190650000000062
							],
							[
								-85.69536499999992,
								30.19077800000008
							],
							[
								-85.69544599999995,
								30.190889000000084
							],
							[
								-85.69556199999994,
								30.19078600000006
							],
							[
								-85.6956459999999,
								30.190728000000032
							],
							[
								-85.6958939999999,
								30.19056100000006
							],
							[
								-85.6958919999999,
								30.189773000000063
							],
							[
								-85.69664699999994,
								30.18975400000005
							],
							[
								-85.69692699999992,
								30.18974600000007
							],
							[
								-85.69710199999992,
								30.190406000000053
							],
							[
								-85.6968129999999,
								30.19039900000007
							],
							[
								-85.69661899999994,
								30.190367000000037
							],
							[
								-85.69662499999993,
								30.19058700000005
							],
							[
								-85.69652699999995,
								30.190664000000087
							],
							[
								-85.69637999999992,
								30.190713000000077
							],
							[
								-85.69612699999993,
								30.19070800000009
							],
							[
								-85.69635299999993,
								30.19119400000005
							],
							[
								-85.69526399999995,
								30.19163300000008
							],
							[
								-85.69542499999996,
								30.191991000000087
							],
							[
								-85.6957999999999,
								30.191828000000044
							],
							[
								-85.69592099999994,
								30.192056000000036
							],
							[
								-85.69665499999991,
								30.191799000000056
							],
							[
								-85.69670799999994,
								30.191897000000036
							],
							[
								-85.69557999999995,
								30.192398000000086
							],
							[
								-85.6958229999999,
								30.192926000000053
							],
							[
								-85.69618899999995,
								30.192781000000085
							],
							[
								-85.69700599999993,
								30.19245900000004
							],
							[
								-85.69821899999994,
								30.19196700000009
							],
							[
								-85.6984829999999,
								30.19182100000006
							],
							[
								-85.69847299999994,
								30.191884000000076
							],
							[
								-85.69839799999994,
								30.192407000000063
							],
							[
								-85.69866499999995,
								30.19238900000005
							],
							[
								-85.69873499999994,
								30.192443000000086
							],
							[
								-85.6989329999999,
								30.192647000000076
							],
							[
								-85.6991349999999,
								30.192785000000068
							],
							[
								-85.69928199999993,
								30.192722000000064
							],
							[
								-85.69935599999991,
								30.192684000000046
							],
							[
								-85.69939299999993,
								30.19263800000005
							],
							[
								-85.69942999999995,
								30.19259200000005
							],
							[
								-85.69975299999993,
								30.19260100000008
							],
							[
								-85.69984499999993,
								30.19267500000007
							],
							[
								-85.69993499999993,
								30.192722000000064
							],
							[
								-85.70015799999993,
								30.192831000000066
							],
							[
								-85.70031499999993,
								30.192868000000093
							],
							[
								-85.70047999999991,
								30.192868000000093
							],
							[
								-85.70076699999993,
								30.192831000000066
							],
							[
								-85.7008429999999,
								30.19291800000008
							],
							[
								-85.7008889999999,
								30.192995000000053
							],
							[
								-85.7011159999999,
								30.19300000000004
							],
							[
								-85.70115299999992,
								30.19295100000005
							],
							[
								-85.7011619999999,
								30.192868000000093
							],
							[
								-85.70114399999994,
								30.192324000000042
							],
							[
								-85.70169299999992,
								30.192323000000044
							],
							[
								-85.70169799999991,
								30.19217100000009
							],
							[
								-85.7007329999999,
								30.192162000000057
							],
							[
								-85.70072399999992,
								30.191628000000037
							],
							[
								-85.7011809999999,
								30.191620000000057
							],
							[
								-85.70117199999993,
								30.191295000000082
							],
							[
								-85.7017209999999,
								30.191314000000094
							],
							[
								-85.70173599999993,
								30.19070400000004
							],
							[
								-85.70175899999994,
								30.19020200000006
							],
							[
								-85.70209499999993,
								30.190210000000032
							],
							[
								-85.70213999999993,
								30.189682000000065
							],
							[
								-85.7034139999999,
								30.189712000000043
							],
							[
								-85.7033459999999,
								30.190763000000064
							],
							[
								-85.70365099999992,
								30.190771000000037
							],
							[
								-85.70365499999991,
								30.190334000000068
							],
							[
								-85.7039059999999,
								30.190326000000084
							],
							[
								-85.70389499999993,
								30.18972500000007
							],
							[
								-85.7041539999999,
								30.189731000000055
							],
							[
								-85.7060009999999,
								30.18977800000005
							],
							[
								-85.70793099999992,
								30.189828000000038
							],
							[
								-85.7078469999999,
								30.190336000000062
							],
							[
								-85.7083659999999,
								30.190355000000068
							],
							[
								-85.70838099999992,
								30.18984000000006
							],
							[
								-85.70884699999993,
								30.189849000000038
							],
							[
								-85.7088619999999,
								30.190809000000062
							],
							[
								-85.70927399999994,
								30.190813000000052
							],
							[
								-85.7093119999999,
								30.191425000000034
							],
							[
								-85.7100979999999,
								30.191411000000077
							],
							[
								-85.71199699999994,
								30.191396000000054
							],
							[
								-85.7120109999999,
								30.190905000000047
							],
							[
								-85.7120129999999,
								30.19084700000008
							],
							[
								-85.7128439999999,
								30.190858000000052
							],
							[
								-85.71286699999992,
								30.18992900000006
							],
							[
								-85.71443899999991,
								30.189956000000052
							],
							[
								-85.71442899999994,
								30.190344000000042
							],
							[
								-85.71442399999995,
								30.19054900000009
							],
							[
								-85.7150519999999,
								30.19053200000008
							],
							[
								-85.7150529999999,
								30.190596000000085
							],
							[
								-85.71542299999993,
								30.190597000000082
							],
							[
								-85.7159969999999,
								30.19059100000004
							],
							[
								-85.7159969999999,
								30.19022300000006
							],
							[
								-85.7163359999999,
								30.190205000000052
							],
							[
								-85.71633099999991,
								30.189985000000036
							],
							[
								-85.7166509999999,
								30.18999000000008
							],
							[
								-85.7169639999999,
								30.189996000000065
							],
							[
								-85.71713999999992,
								30.18999800000006
							],
							[
								-85.71767399999993,
								30.189939000000038
							],
							[
								-85.71806299999992,
								30.18985100000009
							],
							[
								-85.71843699999994,
								30.189727000000065
							],
							[
								-85.71868099999995,
								30.18961900000005
							],
							[
								-85.71927599999992,
								30.189722000000078
							],
							[
								-85.72111499999994,
								30.189815000000067
							],
							[
								-85.72109199999994,
								30.190240000000077
							],
							[
								-85.72103799999991,
								30.19109100000009
							],
							[
								-85.72099299999991,
								30.191232000000074
							],
							[
								-85.72093199999995,
								30.191301000000067
							],
							[
								-85.7208399999999,
								30.191358000000037
							],
							[
								-85.72080899999992,
								30.19224100000008
							],
							[
								-85.72040499999991,
								30.19245300000006
							],
							[
								-85.72009999999995,
								30.192567000000054
							],
							[
								-85.7193749999999,
								30.192766000000063
							],
							[
								-85.71867299999991,
								30.192935000000034
							],
							[
								-85.7182919999999,
								30.192987000000073
							],
							[
								-85.71828589599995,
								30.192987226000074
							],
							[
								-85.7179539999999,
								30.19313100000005
							],
							[
								-85.71778808599993,
								30.19309548500007
							],
							[
								-85.71713999999992,
								30.193708000000075
							],
							[
								-85.71638890999994,
								30.194431793000035
							],
							[
								-85.71611198399997,
								30.19494397200009
							],
							[
								-85.71610199999994,
								30.194974000000062
							],
							[
								-85.7160409999999,
								30.19510000000008
							],
							[
								-85.71597476099993,
								30.195197768000074
							],
							[
								-85.71581999999997,
								30.19548400000008
							],
							[
								-85.71554799499995,
								30.195771724000057
							],
							[
								-85.71542299999993,
								30.195972000000037
							],
							[
								-85.71529299999992,
								30.19614000000007
							],
							[
								-85.7147589999999,
								30.196714000000046
							],
							[
								-85.7146219999999,
								30.196905000000076
							],
							[
								-85.71441873099991,
								30.197084097000076
							],
							[
								-85.71402199999994,
								30.19758100000007
							],
							[
								-85.71303499999993,
								30.198452000000092
							],
							[
								-85.71296547399993,
								30.198418394000043
							],
							[
								-85.71290499999992,
								30.198461000000066
							],
							[
								-85.71201999999995,
								30.198362000000085
							],
							[
								-85.71167699999995,
								30.19829100000004
							],
							[
								-85.71162442699995,
								30.198453292000067
							],
							[
								-85.71162699999991,
								30.19845800000007
							],
							[
								-85.71174099999992,
								30.198689000000055
							],
							[
								-85.71204699999993,
								30.198732000000067
							],
							[
								-85.71211299999993,
								30.198877000000042
							],
							[
								-85.71152440499992,
								30.199216922000065
							],
							[
								-85.71150199999994,
								30.199243000000084
							],
							[
								-85.71113499999991,
								30.19951000000009
							],
							[
								-85.70981499999994,
								30.200119000000086
							],
							[
								-85.7093349999999,
								30.20021600000007
							],
							[
								-85.70931744599994,
								30.20021493400009
							],
							[
								-85.70931499999995,
								30.20021600000007
							],
							[
								-85.70893499999994,
								30.200218000000064
							],
							[
								-85.70881401999992,
								30.200242155000073
							],
							[
								-85.70850299999996,
								30.200344000000086
							],
							[
								-85.70835895099992,
								30.20033301300009
							],
							[
								-85.70834899999994,
								30.20033500000005
							],
							[
								-85.70817751399994,
								30.20041405400008
							],
							[
								-85.70813699999991,
								30.200557000000064
							],
							[
								-85.70808399999993,
								30.200626000000057
							],
							[
								-85.70783199999994,
								30.20086400000008
							],
							[
								-85.70768699999991,
								30.200944000000046
							],
							[
								-85.70715999999993,
								30.201185000000066
							],
							[
								-85.70659599999993,
								30.201486000000045
							],
							[
								-85.70648899999992,
								30.201499000000073
							],
							[
								-85.70616099999997,
								30.201826000000043
							],
							[
								-85.70634399999994,
								30.20217800000006
							],
							[
								-85.70623699999993,
								30.202154000000068
							],
							[
								-85.70592399999992,
								30.202167000000088
							],
							[
								-85.70569599999995,
								30.202266000000066
							],
							[
								-85.70567999999992,
								30.202352000000076
							],
							[
								-85.70572599999991,
								30.202447000000063
							],
							[
								-85.70577199999991,
								30.20249300000006
							],
							[
								-85.70588599999991,
								30.202510000000075
							],
							[
								-85.70596299999994,
								30.202548000000036
							],
							[
								-85.7059319999999,
								30.202825000000075
							],
							[
								-85.70593099999992,
								30.203151000000048
							],
							[
								-85.70619699999992,
								30.203110000000038
							],
							[
								-85.70700799999993,
								30.20298400000007
							],
							[
								-85.70713799999993,
								30.20335300000005
							],
							[
								-85.70819199999994,
								30.20427600000005
							],
							[
								-85.70750599999991,
								30.204252000000054
							],
							[
								-85.70743799999991,
								30.204181000000062
							],
							[
								-85.7073969999999,
								30.20413700000006
							],
							[
								-85.7073049999999,
								30.20396800000009
							],
							[
								-85.7072599999999,
								30.203803000000047
							],
							[
								-85.70657099999994,
								30.203958000000057
							],
							[
								-85.7065849999999,
								30.204098000000045
							],
							[
								-85.7064049999999,
								30.20412000000005
							],
							[
								-85.70644399999992,
								30.20425000000006
							],
							[
								-85.70571799999993,
								30.20425000000006
							],
							[
								-85.70551999999992,
								30.204202000000066
							],
							[
								-85.70538999999991,
								30.20421700000009
							],
							[
								-85.70437099999992,
								30.20420500000006
							],
							[
								-85.70409999999993,
								30.20407500000005
							],
							[
								-85.7040869999999,
								30.204065000000075
							],
							[
								-85.70383399999992,
								30.203923000000092
							],
							[
								-85.70383299999992,
								30.203667000000053
							],
							[
								-85.70322899999991,
								30.20366800000005
							],
							[
								-85.7032319999999,
								30.20301900000004
							],
							[
								-85.7027379999999,
								30.203025000000082
							],
							[
								-85.70272999999992,
								30.203666000000055
							],
							[
								-85.7028929999999,
								30.203666000000055
							],
							[
								-85.70290699999993,
								30.20422500000006
							],
							[
								-85.70121599999993,
								30.204220000000074
							],
							[
								-85.70122499999991,
								30.203657000000074
							],
							[
								-85.70077599999992,
								30.20365400000009
							],
							[
								-85.70075999999995,
								30.204219000000077
							],
							[
								-85.69980599999991,
								30.20421600000009
							],
							[
								-85.69980599999991,
								30.204692000000076
							],
							[
								-85.69980599999991,
								30.206096000000056
							],
							[
								-85.69971499999991,
								30.20638500000007
							],
							[
								-85.69938799999994,
								30.206378000000083
							],
							[
								-85.69937099999993,
								30.207092000000046
							],
							[
								-85.69934399999994,
								30.207749000000035
							],
							[
								-85.69933899999995,
								30.207866000000084
							],
							[
								-85.6992909999999,
								30.209010000000035
							],
							[
								-85.6992669999999,
								30.20959700000009
							],
							[
								-85.69925199999994,
								30.211016000000082
							],
							[
								-85.69923099999994,
								30.211312000000078
							],
							[
								-85.69900999999993,
								30.211197000000087
							],
							[
								-85.69852099999991,
								30.210933000000068
							],
							[
								-85.6979179999999,
								30.210605000000044
							],
							[
								-85.6969059999999,
								30.211487000000087
							],
							[
								-85.69607899999994,
								30.210975000000072
							],
							[
								-85.69470799999993,
								30.209816000000046
							],
							[
								-85.69382299999995,
								30.208286000000047
							],
							[
								-85.69322999999991,
								30.208194000000052
							],
							[
								-85.69282099999992,
								30.207925000000042
							],
							[
								-85.69254899999993,
								30.208353000000045
							],
							[
								-85.69198499999993,
								30.207748000000038
							],
							[
								-85.69166499999994,
								30.207143000000087
							],
							[
								-85.69158099999993,
								30.206874000000084
							],
							[
								-85.69167999999992,
								30.206586000000073
							],
							[
								-85.69168599999995,
								30.20657900000009
							],
							[
								-85.69244099999992,
								30.20668500000005
							],
							[
								-85.6922909999999,
								30.20660700000008
							],
							[
								-85.6921789999999,
								30.206550000000053
							],
							[
								-85.69229199999995,
								30.205702000000088
							],
							[
								-85.69194599999992,
								30.20567300000005
							],
							[
								-85.69186699999996,
								30.20566600000007
							],
							[
								-85.69139599999995,
								30.205627000000046
							],
							[
								-85.69139799999995,
								30.20544600000005
							],
							[
								-85.69142099999993,
								30.205129000000056
							],
							[
								-85.69148199999995,
								30.20467500000007
							],
							[
								-85.6921749999999,
								30.204652000000067
							],
							[
								-85.69221899999991,
								30.20465100000007
							],
							[
								-85.69224999999994,
								30.204650000000072
							],
							[
								-85.69301899999994,
								30.204625000000078
							],
							[
								-85.69416899999993,
								30.20391200000006
							],
							[
								-85.69418699999994,
								30.203478000000075
							],
							[
								-85.69480399999992,
								30.203472000000087
							],
							[
								-85.69497599999994,
								30.203470000000042
							],
							[
								-85.69583099999994,
								30.203462000000062
							],
							[
								-85.69570099999993,
								30.20329600000008
							],
							[
								-85.69566299999991,
								30.20319900000004
							],
							[
								-85.69564799999995,
								30.203102000000058
							],
							[
								-85.69565499999993,
								30.202514000000065
							],
							[
								-85.69568599999991,
								30.20181400000007
							],
							[
								-85.69565499999993,
								30.201522000000068
							],
							[
								-85.69593199999991,
								30.20097400000009
							],
							[
								-85.69593199999991,
								30.200797000000083
							],
							[
								-85.69513599999993,
								30.20077800000007
							],
							[
								-85.69516699999991,
								30.20068400000008
							],
							[
								-85.69525199999993,
								30.200581000000057
							],
							[
								-85.6953309999999,
								30.20048900000006
							],
							[
								-85.69544699999994,
								30.20038000000005
							],
							[
								-85.6955319999999,
								30.20031300000005
							],
							[
								-85.69558699999993,
								30.20030100000008
							],
							[
								-85.69558699999993,
								30.200137000000044
							],
							[
								-85.69487099999992,
								30.200137000000044
							],
							[
								-85.6948769999999,
								30.19964500000009
							],
							[
								-85.69484699999992,
								30.199504000000047
							],
							[
								-85.69479299999995,
								30.199440000000035
							],
							[
								-85.69467099999991,
								30.199357000000077
							],
							[
								-85.69457199999994,
								30.19933500000008
							],
							[
								-85.69415199999992,
								30.199333000000085
							],
							[
								-85.69417499999992,
								30.198501000000075
							],
							[
								-85.69371699999994,
								30.19851600000004
							],
							[
								-85.69371699999994,
								30.198690000000052
							],
							[
								-85.69387799999993,
								30.198692000000047
							],
							[
								-85.69386199999991,
								30.199325000000044
							],
							[
								-85.69306099999994,
								30.199306000000036
							],
							[
								-85.69174099999992,
								30.199317000000065
							],
							[
								-85.69177199999992,
								30.198610000000087
							],
							[
								-85.69177699999995,
								30.19829400000009
							],
							[
								-85.6907579999999,
								30.198301000000075
							],
							[
								-85.6907579999999,
								30.198106000000053
							],
							[
								-85.68957899999992,
								30.198112000000037
							],
							[
								-85.68959699999994,
								30.199942000000082
							],
							[
								-85.69171399999993,
								30.199949000000064
							],
							[
								-85.69171099999994,
								30.20005400000008
							],
							[
								-85.69167999999992,
								30.200675000000047
							],
							[
								-85.69164999999992,
								30.20125100000007
							],
							[
								-85.6916369999999,
								30.201773000000063
							],
							[
								-85.68936699999995,
								30.201780000000046
							],
							[
								-85.68935399999992,
								30.20295300000004
							],
							[
								-85.68935999999991,
								30.203041000000045
							],
							[
								-85.69142699999992,
								30.203036000000058
							],
							[
								-85.6914349999999,
								30.203094000000075
							],
							[
								-85.69155099999995,
								30.204317000000056
							],
							[
								-85.68816699999992,
								30.204793000000052
							],
							[
								-85.68737699999991,
								30.204925000000056
							],
							[
								-85.68738499999995,
								30.20467300000007
							],
							[
								-85.68739999999991,
								30.20417200000008
							],
							[
								-85.68707199999994,
								30.204065000000075
							],
							[
								-85.68549599999994,
								30.20407500000005
							],
							[
								-85.68549599999994,
								30.203809000000035
							],
							[
								-85.68322699999993,
								30.20378600000004
							],
							[
								-85.68126499999994,
								30.203750000000074
							],
							[
								-85.6812569999999,
								30.204594000000046
							],
							[
								-85.6797249999999,
								30.20456800000005
							],
							[
								-85.67899999999992,
								30.204559000000074
							],
							[
								-85.67899299999993,
								30.20336100000009
							],
							[
								-85.6790279999999,
								30.200907000000086
							],
							[
								-85.6798839999999,
								30.20091400000007
							],
							[
								-85.67987599999992,
								30.20047400000004
							],
							[
								-85.67987799999992,
								30.20039500000007
							],
							[
								-85.67949699999991,
								30.20039500000007
							],
							[
								-85.67951899999991,
								30.200222000000057
							],
							[
								-85.67951599999992,
								30.19995000000006
							],
							[
								-85.6797019999999,
								30.19995100000006
							],
							[
								-85.67969499999992,
								30.198510000000056
							],
							[
								-85.67958499999993,
								30.198510000000056
							],
							[
								-85.67958599999992,
								30.198158000000035
							],
							[
								-85.67916799999995,
								30.198138000000085
							],
							[
								-85.67915999999991,
								30.197531000000083
							],
							[
								-85.67915999999991,
								30.197151000000076
							],
							[
								-85.67964099999995,
								30.197151000000076
							],
							[
								-85.67952999999994,
								30.19705500000003
							]
						],
						[
							[
								-85.68101499999995,
								30.19795600000009
							],
							[
								-85.68099999999993,
								30.19809500000008
							],
							[
								-85.68103999999994,
								30.198087000000044
							],
							[
								-85.68104399999993,
								30.198086000000043
							],
							[
								-85.68125099999992,
								30.198084000000048
							],
							[
								-85.68193099999992,
								30.198086000000043
							],
							[
								-85.68321299999991,
								30.19809100000009
							],
							[
								-85.68322599999993,
								30.197090000000063
							],
							[
								-85.68102999999991,
								30.19705900000008
							],
							[
								-85.68101599999994,
								30.197917000000075
							],
							[
								-85.68101499999995,
								30.19795600000009
							]
						],
						[
							[
								-85.68583899999993,
								30.197899000000064
							],
							[
								-85.6875369999999,
								30.197922000000062
							],
							[
								-85.68754899999993,
								30.19755200000009
							],
							[
								-85.68655699999994,
								30.197546000000045
							],
							[
								-85.6863909999999,
								30.196694000000036
							],
							[
								-85.68585999999993,
								30.196906000000073
							],
							[
								-85.68583899999993,
								30.197899000000064
							]
						],
						[
							[
								-85.68857199999991,
								30.195821000000084
							],
							[
								-85.6885739999999,
								30.196920000000034
							],
							[
								-85.6891579999999,
								30.196920000000034
							],
							[
								-85.68915399999992,
								30.19638900000007
							],
							[
								-85.68915199999992,
								30.196128000000044
							],
							[
								-85.68971199999993,
								30.19586800000008
							],
							[
								-85.68969299999992,
								30.19571600000006
							],
							[
								-85.68966299999994,
								30.195388000000037
							],
							[
								-85.68908599999992,
								30.195617000000084
							],
							[
								-85.68857199999991,
								30.195821000000084
							]
						],
						[
							[
								-85.68059199999993,
								30.195808000000056
							],
							[
								-85.67995799999996,
								30.195230000000038
							],
							[
								-85.67985499999992,
								30.19532600000008
							],
							[
								-85.67966699999994,
								30.19550000000004
							],
							[
								-85.67965599999991,
								30.19551000000007
							],
							[
								-85.67941999999994,
								30.19573200000008
							],
							[
								-85.67938299999992,
								30.19576500000005
							],
							[
								-85.67969599999992,
								30.196135000000083
							],
							[
								-85.67993399999995,
								30.196416000000056
							],
							[
								-85.68005199999995,
								30.19627900000006
							],
							[
								-85.67972399999991,
								30.19591300000008
							],
							[
								-85.67990999999995,
								30.195724000000045
							],
							[
								-85.6799509999999,
								30.19568100000004
							],
							[
								-85.68043599999993,
								30.195791000000042
							],
							[
								-85.68059199999993,
								30.195808000000056
							]
						],
						[
							[
								-85.68337699999995,
								30.196062000000044
							],
							[
								-85.68336899999991,
								30.19645100000008
							],
							[
								-85.6841609999999,
								30.19645200000008
							],
							[
								-85.68417299999993,
								30.19606300000004
							],
							[
								-85.68337699999995,
								30.196062000000044
							]
						],
						[
							[
								-85.69186699999996,
								30.195093000000043
							],
							[
								-85.69186999999994,
								30.195544000000044
							],
							[
								-85.69193199999995,
								30.19554600000004
							],
							[
								-85.69252399999995,
								30.19554200000005
							],
							[
								-85.69251999999996,
								30.195417000000077
							],
							[
								-85.69242799999996,
								30.195404000000057
							],
							[
								-85.69241299999993,
								30.195266000000064
							],
							[
								-85.69242799999996,
								30.195178000000052
							],
							[
								-85.69249699999995,
								30.195129000000062
							],
							[
								-85.69239899999991,
								30.195017000000064
							],
							[
								-85.69225899999992,
								30.194868000000042
							],
							[
								-85.69192399999991,
								30.194882000000067
							],
							[
								-85.69186699999996,
								30.194884000000062
							],
							[
								-85.69186699999996,
								30.195093000000043
							]
						],
						[
							[
								-85.68053399999991,
								30.194442000000038
							],
							[
								-85.6807859999999,
								30.194389000000058
							],
							[
								-85.68063299999994,
								30.193941000000056
							],
							[
								-85.6803809999999,
								30.193973000000085
							],
							[
								-85.68053399999991,
								30.194442000000038
							],
							[
								-85.67996199999995,
								30.19465200000008
							],
							[
								-85.67976799999991,
								30.19481200000007
							],
							[
								-85.68010599999991,
								30.195067000000055
							],
							[
								-85.68031999999994,
								30.19487700000008
							],
							[
								-85.68064099999992,
								30.194536000000085
							],
							[
								-85.68053399999991,
								30.194442000000038
							]
						],
						[
							[
								-85.67937399999994,
								30.194475000000065
							],
							[
								-85.67915599999992,
								30.194275000000065
							],
							[
								-85.6789619999999,
								30.194426000000075
							],
							[
								-85.67920599999991,
								30.194623000000036
							],
							[
								-85.67937399999994,
								30.194475000000065
							]
						],
						[
							[
								-85.68165499999992,
								30.194265000000087
							],
							[
								-85.68207999999993,
								30.194280000000052
							],
							[
								-85.68207499999994,
								30.193967000000043
							],
							[
								-85.6822499999999,
								30.193973000000085
							],
							[
								-85.68226599999991,
								30.193729000000076
							],
							[
								-85.68166699999995,
								30.193730000000073
							],
							[
								-85.6816629999999,
								30.193956000000068
							],
							[
								-85.68165499999992,
								30.194265000000087
							]
						],
						[
							[
								-85.6943819999999,
								30.193503000000078
							],
							[
								-85.69482599999992,
								30.194320000000065
							],
							[
								-85.69497199999995,
								30.194263000000035
							],
							[
								-85.69527199999993,
								30.194145000000045
							],
							[
								-85.6948569999999,
								30.193313000000046
							],
							[
								-85.6950599999999,
								30.193231000000083
							],
							[
								-85.6951939999999,
								30.19317700000005
							],
							[
								-85.69538299999994,
								30.19310200000007
							],
							[
								-85.69545699999992,
								30.193072000000086
							],
							[
								-85.69514599999992,
								30.19243000000006
							],
							[
								-85.69466799999992,
								30.19262400000008
							],
							[
								-85.69415499999991,
								30.19185500000009
							],
							[
								-85.6938419999999,
								30.192059000000086
							],
							[
								-85.6937769999999,
								30.19210000000004
							],
							[
								-85.69360199999994,
								30.191876000000036
							],
							[
								-85.69328999999993,
								30.19147600000008
							],
							[
								-85.69297799999993,
								30.19177700000006
							],
							[
								-85.69329799999991,
								30.19207500000005
							],
							[
								-85.69346599999994,
								30.192296000000056
							],
							[
								-85.69353599999994,
								30.19238900000005
							],
							[
								-85.6937539999999,
								30.19223400000004
							],
							[
								-85.69404299999991,
								30.192643000000086
							],
							[
								-85.69399199999992,
								30.192643000000086
							],
							[
								-85.69414999999992,
								30.19293600000009
							],
							[
								-85.6942949999999,
								30.193205000000038
							],
							[
								-85.69444299999992,
								30.193478000000088
							],
							[
								-85.6943819999999,
								30.193503000000078
							]
						],
						[
							[
								-85.68858899999992,
								30.19411400000007
							],
							[
								-85.6883259999999,
								30.194107000000088
							],
							[
								-85.68832199999991,
								30.194389000000058
							],
							[
								-85.6879199999999,
								30.194382000000072
							],
							[
								-85.6879239999999,
								30.19448200000005
							],
							[
								-85.68792799999996,
								30.194582000000082
							],
							[
								-85.68761999999992,
								30.194582000000082
							],
							[
								-85.68761199999994,
								30.194935000000047
							],
							[
								-85.68827499999992,
								30.194939000000087
							],
							[
								-85.68828699999995,
								30.194585000000075
							],
							[
								-85.6885729999999,
								30.194582000000082
							],
							[
								-85.6885769999999,
								30.194476000000062
							],
							[
								-85.68858899999992,
								30.19411400000007
							]
						],
						[
							[
								-85.6938879999999,
								30.19364100000007
							],
							[
								-85.69359299999991,
								30.193084000000056
							],
							[
								-85.69327099999994,
								30.19325800000007
							],
							[
								-85.69355999999993,
								30.19377700000007
							],
							[
								-85.6938879999999,
								30.19364100000007
							]
						],
						[
							[
								-85.69044099999991,
								30.19691300000005
							],
							[
								-85.69043999999991,
								30.196984000000043
							],
							[
								-85.69044099999991,
								30.197443000000078
							],
							[
								-85.69077599999991,
								30.197443000000078
							],
							[
								-85.6907809999999,
								30.196980000000053
							],
							[
								-85.69085599999994,
								30.196980000000053
							],
							[
								-85.69092799999993,
								30.196979000000056
							],
							[
								-85.69110499999994,
								30.19697700000006
							],
							[
								-85.69110399999994,
								30.19657300000006
							],
							[
								-85.69115899999991,
								30.19657300000006
							],
							[
								-85.69115899999991,
								30.196462000000054
							],
							[
								-85.69115899999991,
								30.196348000000054
							],
							[
								-85.69092699999995,
								30.196348000000054
							],
							[
								-85.6906909999999,
								30.196348000000054
							],
							[
								-85.69069699999994,
								30.19691300000005
							],
							[
								-85.69044099999991,
								30.19691300000005
							]
						],
						[
							[
								-85.68132799999995,
								30.19951000000009
							],
							[
								-85.68131499999993,
								30.200185000000094
							],
							[
								-85.68102399999992,
								30.20018800000008
							],
							[
								-85.68052299999995,
								30.20018800000008
							],
							[
								-85.68052299999995,
								30.20058700000004
							],
							[
								-85.68101999999993,
								30.20059400000008
							],
							[
								-85.68102299999993,
								30.200683000000083
							],
							[
								-85.68184599999995,
								30.200708000000073
							],
							[
								-85.68250199999994,
								30.199619000000045
							],
							[
								-85.68273899999991,
								30.199226000000067
							],
							[
								-85.68289099999993,
								30.199011000000045
							],
							[
								-85.6827229999999,
								30.199011000000045
							],
							[
								-85.68201099999993,
								30.198994000000084
							],
							[
								-85.68133899999992,
								30.19900500000006
							],
							[
								-85.68132799999995,
								30.19951000000009
							]
						],
						[
							[
								-85.68497899999994,
								30.20183100000008
							],
							[
								-85.68497599999996,
								30.201903000000073
							],
							[
								-85.68428799999992,
								30.201871000000043
							],
							[
								-85.68468699999994,
								30.20243900000008
							],
							[
								-85.68461699999995,
								30.202558000000067
							],
							[
								-85.68456299999991,
								30.202649000000065
							],
							[
								-85.68458599999991,
								30.202648000000067
							],
							[
								-85.68527799999993,
								30.202629000000055
							],
							[
								-85.68574099999995,
								30.202616000000038
							],
							[
								-85.68503099999992,
								30.20183700000007
							],
							[
								-85.68498399999993,
								30.201781000000043
							],
							[
								-85.68497899999994,
								30.20183100000008
							]
						],
						[
							[
								-85.69981299999995,
								30.203649000000045
							],
							[
								-85.70031999999992,
								30.203652000000094
							],
							[
								-85.7003039999999,
								30.202988000000065
							],
							[
								-85.69982199999993,
								30.202996000000045
							],
							[
								-85.69982099999993,
								30.203180000000092
							],
							[
								-85.69981299999995,
								30.203649000000045
							]
						],
						[
							[
								-85.69556899999992,
								30.205140000000085
							],
							[
								-85.69578199999995,
								30.20542000000006
							],
							[
								-85.69608999999991,
								30.205306000000064
							],
							[
								-85.69620199999991,
								30.205265000000054
							],
							[
								-85.69703499999991,
								30.20495600000004
							],
							[
								-85.69671899999992,
								30.20418600000005
							],
							[
								-85.69658599999991,
								30.204164000000052
							],
							[
								-85.6964109999999,
								30.20396800000009
							],
							[
								-85.6962279999999,
								30.203815000000077
							],
							[
								-85.69605999999993,
								30.203903000000082
							],
							[
								-85.69565799999992,
								30.204093000000057
							],
							[
								-85.6955319999999,
								30.20415200000008
							],
							[
								-85.69509199999993,
								30.20436000000007
							],
							[
								-85.69518599999992,
								30.204559000000074
							],
							[
								-85.69518199999993,
								30.204601000000082
							],
							[
								-85.69514099999992,
								30.204676000000067
							],
							[
								-85.69513599999993,
								30.204752000000042
							],
							[
								-85.69556899999992,
								30.205140000000085
							]
						],
						[
							[
								-85.69861999999995,
								30.204149000000086
							],
							[
								-85.69862899999993,
								30.204692000000076
							],
							[
								-85.69918699999994,
								30.204692000000076
							],
							[
								-85.69919499999992,
								30.204142000000047
							],
							[
								-85.69861999999995,
								30.204149000000086
							]
						],
						[
							[
								-85.68763999999993,
								30.193194000000066
							],
							[
								-85.68764399999992,
								30.19257300000004
							],
							[
								-85.68687499999993,
								30.192595000000043
							],
							[
								-85.68684799999994,
								30.19318100000004
							],
							[
								-85.68763999999993,
								30.193194000000066
							]
						],
						[
							[
								-85.68036599999994,
								30.19187900000009
							],
							[
								-85.68006099999991,
								30.191461000000064
							],
							[
								-85.6798169999999,
								30.191831000000036
							],
							[
								-85.6797019999999,
								30.192020000000074
							],
							[
								-85.68000699999995,
								30.19211500000006
							],
							[
								-85.68008399999991,
								30.192041000000074
							],
							[
								-85.68015999999994,
								30.19199700000007
							],
							[
								-85.68036599999994,
								30.19187900000009
							]
						],
						[
							[
								-85.6825629999999,
								30.19169200000005
							],
							[
								-85.6826089999999,
								30.19171300000005
							],
							[
								-85.68262599999991,
								30.191666000000055
							],
							[
								-85.68278099999992,
								30.191400000000044
							],
							[
								-85.68267799999991,
								30.19133700000009
							],
							[
								-85.6824489999999,
								30.19121300000006
							],
							[
								-85.68235699999991,
								30.19139000000007
							],
							[
								-85.6822919999999,
								30.19147400000008
							],
							[
								-85.6822499999999,
								30.191530000000057
							],
							[
								-85.68240299999991,
								30.19160800000009
							],
							[
								-85.6825629999999,
								30.19169200000005
							]
						],
						[
							[
								-85.68254799999994,
								30.190818000000032
							],
							[
								-85.68202899999994,
								30.190769000000042
							],
							[
								-85.68186899999995,
								30.190944000000062
							],
							[
								-85.68190699999991,
								30.190982000000076
							],
							[
								-85.68250999999992,
								30.191089000000094
							],
							[
								-85.68254799999994,
								30.190948000000052
							],
							[
								-85.68254799999994,
								30.190818000000032
							]
						],
						[
							[
								-85.68155399999995,
								30.19092500000005
							],
							[
								-85.6818419999999,
								30.190605000000062
							],
							[
								-85.68176399999993,
								30.190389000000042
							],
							[
								-85.68131599999992,
								30.190389000000042
							],
							[
								-85.68131999999991,
								30.190177000000062
							],
							[
								-85.68088499999993,
								30.190176000000065
							],
							[
								-85.68088499999993,
								30.190271000000052
							],
							[
								-85.68082399999992,
								30.190458000000035
							],
							[
								-85.68067899999994,
								30.190715000000072
							],
							[
								-85.68093199999993,
								30.19084700000008
							],
							[
								-85.68106799999993,
								30.19068800000008
							],
							[
								-85.68133299999994,
								30.190699000000052
							],
							[
								-85.6813269999999,
								30.190771000000037
							],
							[
								-85.68155399999995,
								30.19092500000005
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Bay",
				"City": "Panama City",
				"Name": "Pretty Bayou",
				"RegionID": "125855"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.71062688099994,
					30.298052556000073,
					-81.67388917099993,
					30.321784069000042
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.68390685199995,
							30.321784069000042
						],
						[
							-81.6817008029999,
							30.319149510000045
						],
						[
							-81.67879290399992,
							30.317786005000077
						],
						[
							-81.67866790599993,
							30.317683008000078
						],
						[
							-81.67853197399995,
							30.31755889300007
						],
						[
							-81.67826790499993,
							30.317455008000085
						],
						[
							-81.67814790499995,
							30.317401009000033
						],
						[
							-81.67795090599992,
							30.31731500800004
						],
						[
							-81.67777490599991,
							30.317250008000087
						],
						[
							-81.67745391399991,
							30.317124927000066
						],
						[
							-81.67731390599994,
							30.317145008000068
						],
						[
							-81.67716790599991,
							30.31716006100004
						],
						[
							-81.67675688799994,
							30.317091057000084
						],
						[
							-81.67658890599995,
							30.317007008000076
						],
						[
							-81.6764259059999,
							30.316937008000085
						],
						[
							-81.67608290499993,
							30.316734008000083
						],
						[
							-81.67563987099993,
							30.31651899900004
						],
						[
							-81.6752329059999,
							30.316361008000058
						],
						[
							-81.67494490599995,
							30.31623200900009
						],
						[
							-81.67471499999994,
							30.31611200000009
						],
						[
							-81.67388917099993,
							30.315742098000044
						],
						[
							-81.67391690699992,
							30.31569402100007
						],
						[
							-81.67394282299995,
							30.315634420000038
						],
						[
							-81.67397254799994,
							30.315570816000047
						],
						[
							-81.67400762499994,
							30.315510000000074
						],
						[
							-81.67404779399993,
							30.315452419000056
						],
						[
							-81.6740927589999,
							30.315398501000065
						],
						[
							-81.67499318299991,
							30.313316213000068
						],
						[
							-81.67528306399993,
							30.312631524000043
						],
						[
							-81.67542710099991,
							30.31193090100004
						],
						[
							-81.67546291399992,
							30.311804414000047
						],
						[
							-81.67549321699994,
							30.31173133200008
						],
						[
							-81.67624821699991,
							30.310115331000077
						],
						[
							-81.67628416399992,
							30.310046339000053
						],
						[
							-81.67637407899991,
							30.309917927000072
						],
						[
							-81.67648492699993,
							30.309807079000052
						],
						[
							-81.67661333899991,
							30.309717164000066
						],
						[
							-81.6767554139999,
							30.30965091300004
						],
						[
							-81.67679915799994,
							30.309636251000086
						],
						[
							-81.67803415899994,
							30.309257251000073
						],
						[
							-81.67806294299993,
							30.30924894000009
						],
						[
							-81.67974695099991,
							30.30879293800007
						],
						[
							-81.68100642399992,
							30.30845198300005
						],
						[
							-81.6816323029999,
							30.30829392600009
						],
						[
							-81.6833905069999,
							30.30785187400005
						],
						[
							-81.68507329699992,
							30.30742792700005
						],
						[
							-81.6851003669999,
							30.30742155100006
						],
						[
							-81.6858430549999,
							30.307258689000037
						],
						[
							-81.6866075879999,
							30.307064729000047
						],
						[
							-81.68729071799993,
							30.30671126400006
						],
						[
							-81.68735150699992,
							30.306682637000048
						],
						[
							-81.68781484199991,
							30.306485236000068
						],
						[
							-81.68932043899991,
							30.304990735000047
						],
						[
							-81.68936785699992,
							30.304946932000064
						],
						[
							-81.68941829499994,
							30.304906642000045
						],
						[
							-81.68947149299993,
							30.304870075000053
						],
						[
							-81.68952717699995,
							30.304837418000087
						],
						[
							-81.69021408899994,
							30.304467033000037
						],
						[
							-81.69129100999993,
							30.303737028000054
						],
						[
							-81.69139528499994,
							30.303645541000037
						],
						[
							-81.69170934699991,
							30.30323848400008
						],
						[
							-81.6921892229999,
							30.30252641000004
						],
						[
							-81.6922460799999,
							30.30245092700005
						],
						[
							-81.69235174199991,
							30.302344463000054
						],
						[
							-81.69309061699994,
							30.301714907000076
						],
						[
							-81.6956402809999,
							30.299298246000035
						],
						[
							-81.69633622899995,
							30.298630203000073
						],
						[
							-81.6963683969999,
							30.29860079000008
						],
						[
							-81.6969748009999,
							30.298072717000082
						],
						[
							-81.69698895099992,
							30.298052556000073
						],
						[
							-81.6976479999999,
							30.29867900000005
						],
						[
							-81.6979289059999,
							30.298946009000076
						],
						[
							-81.6986539049999,
							30.299723008000058
						],
						[
							-81.69895890599992,
							30.30003400800007
						],
						[
							-81.69924190599994,
							30.300344008000085
						],
						[
							-81.69930990599994,
							30.300407008000036
						],
						[
							-81.6999819049999,
							30.301111009000067
						],
						[
							-81.70014990599992,
							30.30127000900006
						],
						[
							-81.70064490499993,
							30.30177900900009
						],
						[
							-81.70085090599991,
							30.302011009000072
						],
						[
							-81.70127090499994,
							30.30243500800009
						],
						[
							-81.70153790599994,
							30.302723008000044
						],
						[
							-81.70202590699995,
							30.303234009000054
						],
						[
							-81.70221685699994,
							30.303459196000066
						],
						[
							-81.70293390499995,
							30.30317100800005
						],
						[
							-81.7031099969999,
							30.30311185100004
						],
						[
							-81.70317084499993,
							30.30341702900006
						],
						[
							-81.70334590599992,
							30.303862009000056
						],
						[
							-81.70346390599991,
							30.30416200500008
						],
						[
							-81.70350979699992,
							30.304229089000046
						],
						[
							-81.70363290599994,
							30.304326008000093
						],
						[
							-81.70385390599995,
							30.30447700900004
						],
						[
							-81.70404790599991,
							30.30463200900005
						],
						[
							-81.70458990499992,
							30.305168009000056
						],
						[
							-81.70510890599991,
							30.305710008000062
						],
						[
							-81.7054049059999,
							30.305983008000055
						],
						[
							-81.7059939049999,
							30.30654000900006
						],
						[
							-81.70616890499991,
							30.30671300800009
						],
						[
							-81.70644390599995,
							30.306955007000056
						],
						[
							-81.70674890599992,
							30.307150009000054
						],
						[
							-81.70735190499994,
							30.307541009000094
						],
						[
							-81.70754990499995,
							30.30765000900004
						],
						[
							-81.70762590599992,
							30.30771100900006
						],
						[
							-81.70807590599992,
							30.30808400800004
						],
						[
							-81.70872490499994,
							30.308640008000058
						],
						[
							-81.7089159059999,
							30.308788009000068
						],
						[
							-81.7092969059999,
							30.309105008000078
						],
						[
							-81.70932690799992,
							30.309132008000063
						],
						[
							-81.70956390599991,
							30.309266008000066
						],
						[
							-81.7100669049999,
							30.30946400900007
						],
						[
							-81.71024490699995,
							30.30953500700008
						],
						[
							-81.71030790499992,
							30.309546009000087
						],
						[
							-81.71062688099994,
							30.309599135000045
						],
						[
							-81.70746490599993,
							30.31171900800007
						],
						[
							-81.70534490599994,
							30.313112009000065
						],
						[
							-81.7051169049999,
							30.31324400800008
						],
						[
							-81.70407090799995,
							30.31389700800008
						],
						[
							-81.70402890299994,
							30.313937009000085
						],
						[
							-81.7039879049999,
							30.313964008000085
						],
						[
							-81.70326090499992,
							30.314362009000035
						],
						[
							-81.70166890599995,
							30.315419009000042
						],
						[
							-81.70154090499994,
							30.315509009000042
						],
						[
							-81.7008799059999,
							30.315907009000057
						],
						[
							-81.6991279049999,
							30.317075008000078
						],
						[
							-81.69863790499994,
							30.31737400800006
						],
						[
							-81.6969158039999,
							30.318478974000072
						],
						[
							-81.69577190699994,
							30.319304008000074
						],
						[
							-81.69422790699991,
							30.320185008000067
						],
						[
							-81.6932339039999,
							30.320850008000036
						],
						[
							-81.69313590599995,
							30.32091700800004
						],
						[
							-81.69301892199991,
							30.320980191000046
						],
						[
							-81.69272390499992,
							30.320882008000066
						],
						[
							-81.6921199059999,
							30.320709009000044
						],
						[
							-81.69186490699991,
							30.32065300800008
						],
						[
							-81.69136290499995,
							30.32059800800005
						],
						[
							-81.69102490599994,
							30.320581009000076
						],
						[
							-81.6908139059999,
							30.320577008000043
						],
						[
							-81.69037190499995,
							30.320584008000083
						],
						[
							-81.6901789069999,
							30.320581009000076
						],
						[
							-81.69005190399992,
							30.320581009000076
						],
						[
							-81.68933490699993,
							30.32058400900007
						],
						[
							-81.68911190699993,
							30.32059500800006
						],
						[
							-81.68875190499995,
							30.32059900800005
						],
						[
							-81.68794690599992,
							30.32061100800007
						],
						[
							-81.68735490699993,
							30.32062900900007
						],
						[
							-81.68686990599991,
							30.32067100800009
						],
						[
							-81.68666090699992,
							30.320688009000037
						],
						[
							-81.6864039049999,
							30.320728009000046
						],
						[
							-81.68622690599994,
							30.32076500800008
						],
						[
							-81.68589890499993,
							30.32084800800004
						],
						[
							-81.68562090699993,
							30.320948008000073
						],
						[
							-81.68519490499995,
							30.321147009000068
						],
						[
							-81.68501090699993,
							30.321250008000053
						],
						[
							-81.68481590699992,
							30.32134900800008
						],
						[
							-81.68476390399991,
							30.321379008000065
						],
						[
							-81.68468390699991,
							30.321424009000058
						],
						[
							-81.68449690599994,
							30.321533008000078
						],
						[
							-81.68437690399992,
							30.32159900900007
						],
						[
							-81.68418890599992,
							30.32169400900006
						],
						[
							-81.68409490699993,
							30.32173300900007
						],
						[
							-81.68403190299995,
							30.321759007000082
						],
						[
							-81.68390685199995,
							30.321784069000042
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Riverside",
				"RegionID": "125932"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.69766153099994,
					30.39542719100007,
					-81.67430967799993,
					30.42002732200007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.67756418199991,
							30.417762926000083
						],
						[
							-81.6761441729999,
							30.415376794000053
						],
						[
							-81.67607491399991,
							30.41522958600007
						],
						[
							-81.67603434099993,
							30.415078166000058
						],
						[
							-81.67602067799993,
							30.414922000000047
						],
						[
							-81.67603434099993,
							30.41476583400004
						],
						[
							-81.6760646329999,
							30.414644284000076
						],
						[
							-81.67616394399994,
							30.414338405000077
						],
						[
							-81.67600324799992,
							30.41420949100007
						],
						[
							-81.6759481709999,
							30.41416150300006
						],
						[
							-81.67589717099992,
							30.414109204000056
						],
						[
							-81.67585058299994,
							30.414052938000054
						],
						[
							-81.67580871599995,
							30.413993077000043
						],
						[
							-81.67537422999993,
							30.41331477400007
						],
						[
							-81.67464903399991,
							30.412737718000074
						],
						[
							-81.6746309269999,
							30.412722921000068
						],
						[
							-81.67452007899993,
							30.412612073000048
						],
						[
							-81.67443016399994,
							30.412483661000067
						],
						[
							-81.67436391299992,
							30.412341586000082
						],
						[
							-81.67432333999994,
							30.412190166000077
						],
						[
							-81.67430967799993,
							30.412034000000062
						],
						[
							-81.67432333999994,
							30.41187783400005
						],
						[
							-81.67436391299992,
							30.411726414000047
						],
						[
							-81.67442546199993,
							30.41159258300007
						],
						[
							-81.6748161989999,
							30.41089900500009
						],
						[
							-81.67486820399995,
							30.41020663900008
						],
						[
							-81.6748766259999,
							30.410134100000047
						],
						[
							-81.67489090599992,
							30.410062483000047
						],
						[
							-81.67491094899992,
							30.409992261000067
						],
						[
							-81.67493662399994,
							30.40992389600007
						],
						[
							-81.67496776099995,
							30.409857840000086
						],
						[
							-81.67583375999993,
							30.40819884000007
						],
						[
							-81.67586548199995,
							30.408143832000068
						],
						[
							-81.6758231849999,
							30.407414034000055
						],
						[
							-81.67582167799992,
							30.407362000000038
						],
						[
							-81.6758326929999,
							30.407221674000084
						],
						[
							-81.67605369299991,
							30.405822674000035
						],
						[
							-81.67606425499991,
							30.405767181000044
						],
						[
							-81.6761782559999,
							30.405256181000087
						],
						[
							-81.67619681699995,
							30.405186324000056
						],
						[
							-81.67622092699992,
							30.405118184000063
						],
						[
							-81.6762504319999,
							30.405052199000068
						],
						[
							-81.67628514099994,
							30.40498879800009
						],
						[
							-81.67632482899995,
							30.40492838800009
						],
						[
							-81.67636924099992,
							30.404871361000065
						],
						[
							-81.67641808799993,
							30.40481808500005
						],
						[
							-81.67752808799992,
							30.40370108600007
						],
						[
							-81.67758792699993,
							30.403646080000048
						],
						[
							-81.67769259199991,
							30.403570367000043
						],
						[
							-81.67807238399992,
							30.40333522600008
						],
						[
							-81.67799216499992,
							30.403220661000038
						],
						[
							-81.6779259139999,
							30.403078587000042
						],
						[
							-81.67788534099992,
							30.40292716600004
						],
						[
							-81.67787167799992,
							30.40277100000009
						],
						[
							-81.6778821989999,
							30.40263384100007
						],
						[
							-81.67791449399994,
							30.40242457000005
						],
						[
							-81.67823863699994,
							30.401862340000037
						],
						[
							-81.6784973369999,
							30.40128026600007
						],
						[
							-81.67827097499992,
							30.400374818000046
						],
						[
							-81.67846499899991,
							30.399469370000077
						],
						[
							-81.67872369899995,
							30.398725609000056
						],
						[
							-81.67878837299992,
							30.39785249800008
						],
						[
							-81.67875603599992,
							30.39678536300005
						],
						[
							-81.67969382199993,
							30.396397314000072
						],
						[
							-81.68063160699995,
							30.39594459000006
						],
						[
							-81.68124601799991,
							30.395815240000047
						],
						[
							-81.68208679199995,
							30.39545952800006
						],
						[
							-81.68276587799994,
							30.39542719100007
						],
						[
							-81.6828629709999,
							30.395440137000033
						],
						[
							-81.68373600099994,
							30.395556541000076
						],
						[
							-81.6843504119999,
							30.395718228000078
						],
						[
							-81.68506183599993,
							30.39597692700005
						],
						[
							-81.68577325899992,
							30.396300302000046
						],
						[
							-81.68638766999993,
							30.39646198900004
						],
						[
							-81.68700208199994,
							30.39646198900004
						],
						[
							-81.6882632409999,
							30.396203289000088
						],
						[
							-81.68913635199993,
							30.395879915000084
						],
						[
							-81.6895567389999,
							30.395815240000047
						],
						[
							-81.6905268619999,
							30.39646198900004
						],
						[
							-81.69136075199992,
							30.396941834000074
						],
						[
							-81.69200923699992,
							30.39776964300006
						],
						[
							-81.6920829579999,
							30.397866049000072
						],
						[
							-81.69217607099995,
							30.398790284000082
						],
						[
							-81.6924671079999,
							30.39937235800005
						],
						[
							-81.69301684399994,
							30.400019107000045
						],
						[
							-81.69340489299992,
							30.400439493000082
						],
						[
							-81.69372826799992,
							30.40073053000009
						],
						[
							-81.69405164199992,
							30.400956892000064
						],
						[
							-81.69437501599992,
							30.401086242000076
						],
						[
							-81.69482773999994,
							30.401183254000046
						],
						[
							-81.69518345199992,
							30.401183254000046
						],
						[
							-81.69563617599994,
							30.401021567000043
						],
						[
							-81.69625058799994,
							30.400601180000077
						],
						[
							-81.69696201099993,
							30.40005144400004
						],
						[
							-81.69741473499994,
							30.39976040700009
						],
						[
							-81.69766153099994,
							30.399608533000052
						],
						[
							-81.69765499999994,
							30.399979000000087
						],
						[
							-81.69763003999992,
							30.40139503400008
						],
						[
							-81.6973877289999,
							30.40197795800009
						],
						[
							-81.69736290799995,
							30.403767010000077
						],
						[
							-81.69735690699991,
							30.404316010000063
						],
						[
							-81.69734190799994,
							30.405315011000084
						],
						[
							-81.69732482199993,
							30.405763946000036
						],
						[
							-81.6973189069999,
							30.406761010000086
						],
						[
							-81.6973109079999,
							30.40774701000004
						],
						[
							-81.69730390799992,
							30.408337010000082
						],
						[
							-81.69729590799996,
							30.408443010000045
						],
						[
							-81.69728090699994,
							30.409824011000072
						],
						[
							-81.6972889079999,
							30.41021201100006
						],
						[
							-81.69730390799992,
							30.411121011000034
						],
						[
							-81.69732690799992,
							30.412846011000056
						],
						[
							-81.6973339079999,
							30.413155010000082
						],
						[
							-81.69734990799992,
							30.41393101000006
						],
						[
							-81.69734190799994,
							30.41412900900008
						],
						[
							-81.69735290799991,
							30.41446901000006
						],
						[
							-81.69735690699991,
							30.41512701000005
						],
						[
							-81.69737190799992,
							30.41569901100007
						],
						[
							-81.69736490899993,
							30.41610901000007
						],
						[
							-81.69737190699993,
							30.41617401000008
						],
						[
							-81.6973799079999,
							30.41628601000008
						],
						[
							-81.6973799079999,
							30.416708011000082
						],
						[
							-81.69738790799995,
							30.416862010000045
						],
						[
							-81.69737990999994,
							30.417120009000087
						],
						[
							-81.69745999999992,
							30.417426000000034
						],
						[
							-81.69759768799992,
							30.417952048000075
						],
						[
							-81.69723927199993,
							30.417921674000073
						],
						[
							-81.6968845369999,
							30.41788942600004
						],
						[
							-81.69657603699994,
							30.41786138000009
						],
						[
							-81.69603338999991,
							30.418027189000043
						],
						[
							-81.69493302199993,
							30.41796689500006
						],
						[
							-81.69442052099993,
							30.417786013000068
						],
						[
							-81.69360697799993,
							30.41739609500007
						],
						[
							-81.69280176899991,
							30.416796073000057
						],
						[
							-81.69048633099993,
							30.41578735900004
						],
						[
							-81.69041993299993,
							30.415832830000053
						],
						[
							-81.69029369799995,
							30.41591867300008
						],
						[
							-81.69023766099991,
							30.41595383600008
						],
						[
							-81.69009558599993,
							30.41602008600006
						],
						[
							-81.68994416599992,
							30.416060659000035
						],
						[
							-81.68978799999991,
							30.416074322000043
						],
						[
							-81.68975325699995,
							30.416071283000065
						],
						[
							-81.68969172599992,
							30.416102383000062
						],
						[
							-81.6896279259999,
							30.41612851600007
						],
						[
							-81.6895622589999,
							30.416149518000058
						],
						[
							-81.6894951349999,
							30.416165257000046
						],
						[
							-81.68942697599994,
							30.41617563500006
						],
						[
							-81.68920348599994,
							30.41620088800005
						],
						[
							-81.68916932799993,
							30.416215433000044
						],
						[
							-81.68914843999994,
							30.416224019000083
						],
						[
							-81.68897943999991,
							30.416291019000088
						],
						[
							-81.68890739499994,
							30.416316101000064
						],
						[
							-81.68883348399993,
							30.416334987000084
						],
						[
							-81.68875823799993,
							30.416347540000064
						],
						[
							-81.68868219799992,
							30.41635367200007
						],
						[
							-81.68860591299995,
							30.41635333700009
						],
						[
							-81.68852993099995,
							30.416346538000088
						],
						[
							-81.68741993099991,
							30.41619953800006
						],
						[
							-81.6873464279999,
							30.416186681000056
						],
						[
							-81.68727424299993,
							30.41616777500008
						],
						[
							-81.68720387499991,
							30.41614294900006
						],
						[
							-81.68713580699995,
							30.416112376000058
						],
						[
							-81.68707050699993,
							30.416076265000072
						],
						[
							-81.68700842599993,
							30.416034865000086
						],
						[
							-81.68686959099995,
							30.415933710000047
						],
						[
							-81.68676780399994,
							30.41586183300007
						],
						[
							-81.68678923099992,
							30.415982127000063
						],
						[
							-81.68680024199995,
							30.41606065500008
						],
						[
							-81.68680428899995,
							30.41613984800006
						],
						[
							-81.68680134199991,
							30.41621909000008
						],
						[
							-81.68679142399992,
							30.41629776300005
						],
						[
							-81.68677461099992,
							30.416375257000084
						],
						[
							-81.68675103499993,
							30.416450967000063
						],
						[
							-81.68668903499992,
							30.41662296700008
						],
						[
							-81.68665869299991,
							30.416696714000068
						],
						[
							-81.6864116939999,
							30.41722871400009
						],
						[
							-81.68636988899993,
							30.41730812200007
						],
						[
							-81.68601588899992,
							30.41790612200009
						],
						[
							-81.68593092099991,
							30.41802607300008
						],
						[
							-81.68590794199991,
							30.418052402000054
						],
						[
							-81.68563294199993,
							30.41835540200009
						],
						[
							-81.6855450729999,
							30.418439921000072
						],
						[
							-81.68545428099992,
							30.418506869000055
						],
						[
							-81.68331828099991,
							30.41988386900005
						],
						[
							-81.68328066099991,
							30.41990683500006
						],
						[
							-81.68313858699992,
							30.419973086000084
						],
						[
							-81.68298716599992,
							30.420013659000062
						],
						[
							-81.68283099999991,
							30.42002732200007
						],
						[
							-81.68267483499994,
							30.420013659000062
						],
						[
							-81.68252341399995,
							30.419973086000084
						],
						[
							-81.68249262599994,
							30.419961236000066
						],
						[
							-81.67799862499993,
							30.418136236000063
						],
						[
							-81.67793229499995,
							30.418106115000054
						],
						[
							-81.67786861999991,
							30.418070724000074
						],
						[
							-81.67780801799995,
							30.418030295000055
						],
						[
							-81.67775088799993,
							30.417985094000073
						],
						[
							-81.6776976029999,
							30.41793541700008
						],
						[
							-81.67764851399994,
							30.417881591000082
						],
						[
							-81.67760394299995,
							30.41782396800005
						],
						[
							-81.67756418199991,
							30.417762926000083
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Riverview",
				"RegionID": "125937"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.10736694499991,
					26.20975984000006,
					-80.09548527599992,
					26.223007713000076
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.09988680499993,
							26.222710980000045
						],
						[
							-80.09921915799993,
							26.222488431000045
						],
						[
							-80.09842787199995,
							26.222661525000035
						],
						[
							-80.09719148699992,
							26.222982985000044
						],
						[
							-80.09548527599992,
							26.222735708000073
						],
						[
							-80.09626137999993,
							26.21897753000008
						],
						[
							-80.09626594499991,
							26.218959840000082
						],
						[
							-80.09716594499992,
							26.21515984000007
						],
						[
							-80.09796594499994,
							26.21175984000007
						],
						[
							-80.09799094499994,
							26.21166079200009
						],
						[
							-80.0980638289999,
							26.211660649000066
						],
						[
							-80.09829306199993,
							26.211660059000053
						],
						[
							-80.09836563099992,
							26.211659934000068
						],
						[
							-80.0984430709999,
							26.21164696200009
						],
						[
							-80.09882188699993,
							26.21158371000007
						],
						[
							-80.09891094499994,
							26.21156884000004
						],
						[
							-80.09896594499992,
							26.211559840000064
						],
						[
							-80.09947293699993,
							26.211528457000046
						],
						[
							-80.09954579899994,
							26.21152729000005
						],
						[
							-80.10419408999991,
							26.211428390000037
						],
						[
							-80.10426695299992,
							26.211427222000054
						],
						[
							-80.10426694499995,
							26.211259840000082
						],
						[
							-80.10426694499995,
							26.209859840000036
						],
						[
							-80.1043398299999,
							26.209859840000036
						],
						[
							-80.10489406099992,
							26.209859840000036
						],
						[
							-80.10496694499994,
							26.209859840000036
						],
						[
							-80.1050398299999,
							26.209859840000036
						],
						[
							-80.10569406099995,
							26.209859840000036
						],
						[
							-80.10576694499991,
							26.209859840000036
						],
						[
							-80.10733862599994,
							26.209761228000048
						],
						[
							-80.10736151099991,
							26.209760117000087
						],
						[
							-80.10736694499991,
							26.20975984000006
						],
						[
							-80.1073648229999,
							26.209764729000085
						],
						[
							-80.10611818299994,
							26.21477339200004
						],
						[
							-80.10537635299994,
							26.217542893000086
						],
						[
							-80.10493125399995,
							26.219100738000066
						],
						[
							-80.10396687399992,
							26.221672417000036
						],
						[
							-80.10342286499991,
							26.221449868000036
						],
						[
							-80.10300249399995,
							26.221375685000055
						],
						[
							-80.10250794099994,
							26.221598234000055
						],
						[
							-80.10231011899992,
							26.222142244000054
						],
						[
							-80.1021617529999,
							26.222735708000073
						],
						[
							-80.10174138199994,
							26.22288407400004
						],
						[
							-80.1009500959999,
							26.223007713000076
						],
						[
							-80.09988680499993,
							26.222710980000045
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Pompano Beach",
				"Name": "Santa Barbara Shores",
				"RegionID": "126071"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.49756399999995,
					27.29873200000003,
					-82.45149399999997,
					27.326512000000037
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.45149399999997,
							27.30865300000005
						],
						[
							-82.45150699999994,
							27.308309000000065
						],
						[
							-82.45150899999999,
							27.307979000000046
						],
						[
							-82.45152199999995,
							27.305840000000046
						],
						[
							-82.45153399999998,
							27.304650000000038
						],
						[
							-82.45154499999995,
							27.303552000000025
						],
						[
							-82.45155599999998,
							27.302527000000055
						],
						[
							-82.45154599999995,
							27.302061000000037
						],
						[
							-82.45155799999998,
							27.30175700000007
						],
						[
							-82.45155399999999,
							27.30156100000005
						],
						[
							-82.45156099999997,
							27.30116000000004
						],
						[
							-82.45154599999995,
							27.30088200000006
						],
						[
							-82.45153199999999,
							27.300603000000024
						],
						[
							-82.45154799999995,
							27.30021400000004
						],
						[
							-82.45157099999994,
							27.29976400000004
						],
						[
							-82.45159499999994,
							27.29957200000007
						],
						[
							-82.45157899999998,
							27.299173000000053
						],
						[
							-82.45155899999997,
							27.298831000000064
						],
						[
							-82.45251499999996,
							27.298831000000064
						],
						[
							-82.45281499999999,
							27.29883700000005
						],
						[
							-82.45350899999994,
							27.298866000000032
						],
						[
							-82.45378999999997,
							27.29887700000006
						],
						[
							-82.45457499999999,
							27.298879000000056
						],
						[
							-82.45486299999999,
							27.29886700000003
						],
						[
							-82.45517899999999,
							27.298854000000063
						],
						[
							-82.45581699999997,
							27.29884100000004
						],
						[
							-82.45682799999997,
							27.298807000000068
						],
						[
							-82.45776699999999,
							27.298782000000074
						],
						[
							-82.45818899999995,
							27.298778000000027
						],
						[
							-82.45884399999994,
							27.298775000000035
						],
						[
							-82.46144499999997,
							27.298781000000076
						],
						[
							-82.46166899999997,
							27.298782000000074
						],
						[
							-82.46233599999994,
							27.298790000000054
						],
						[
							-82.46259899999995,
							27.298798000000033
						],
						[
							-82.46308199999999,
							27.298793000000046
						],
						[
							-82.46358599999996,
							27.29878700000006
						],
						[
							-82.46449599999994,
							27.298786000000064
						],
						[
							-82.46504899999996,
							27.298785000000066
						],
						[
							-82.46594999999996,
							27.29878300000007
						],
						[
							-82.46769399999994,
							27.298780000000082
						],
						[
							-82.47141999999997,
							27.298774000000037
						],
						[
							-82.47163099999995,
							27.298771000000045
						],
						[
							-82.47571999999997,
							27.29875100000004
						],
						[
							-82.47659999999996,
							27.29874600000005
						],
						[
							-82.47701299999994,
							27.29875000000004
						],
						[
							-82.48096399999999,
							27.29873200000003
						],
						[
							-82.48357199999998,
							27.298733000000027
						],
						[
							-82.48408499999994,
							27.298744000000056
						],
						[
							-82.48485699999998,
							27.298753000000033
						],
						[
							-82.48571499999997,
							27.298748000000046
						],
						[
							-82.48609199999999,
							27.29874700000005
						],
						[
							-82.48668399999998,
							27.29875000000004
						],
						[
							-82.48728699999998,
							27.29875100000004
						],
						[
							-82.48928699999999,
							27.29874700000005
						],
						[
							-82.49009399999994,
							27.298757000000023
						],
						[
							-82.49088899999998,
							27.298756000000026
						],
						[
							-82.49149999999997,
							27.298757000000023
						],
						[
							-82.49216799999994,
							27.298760000000073
						],
						[
							-82.49417299999999,
							27.298766000000057
						],
						[
							-82.49463799999995,
							27.298768000000052
						],
						[
							-82.49543699999998,
							27.298772000000042
						],
						[
							-82.49564399999997,
							27.29877300000004
						],
						[
							-82.49756399999995,
							27.298778000000027
						],
						[
							-82.49756299999996,
							27.299919000000045
						],
						[
							-82.49756099999998,
							27.300432000000058
						],
						[
							-82.49755499999998,
							27.302227000000073
						],
						[
							-82.49754799999994,
							27.304286000000047
						],
						[
							-82.49754099999996,
							27.305323000000044
						],
						[
							-82.49753599999997,
							27.306249000000037
						],
						[
							-82.49753399999997,
							27.30669000000006
						],
						[
							-82.49753799999996,
							27.30680300000006
						],
						[
							-82.49751499999996,
							27.30806300000006
						],
						[
							-82.49751899999995,
							27.308290000000056
						],
						[
							-82.49752499999994,
							27.308595000000025
						],
						[
							-82.49751599999996,
							27.30899100000005
						],
						[
							-82.49747599999995,
							27.309890000000056
						],
						[
							-82.49746699999999,
							27.310162000000048
						],
						[
							-82.49746599999997,
							27.310644000000025
						],
						[
							-82.49745799999994,
							27.311926000000028
						],
						[
							-82.49745799999994,
							27.312620000000038
						],
						[
							-82.49744599999997,
							27.31401100000005
						],
						[
							-82.49744299999998,
							27.315408000000048
						],
						[
							-82.49744199999998,
							27.315912000000026
						],
						[
							-82.49743999999998,
							27.316433000000075
						],
						[
							-82.49743799999999,
							27.316925000000026
						],
						[
							-82.49743599999994,
							27.317233000000044
						],
						[
							-82.49743499999994,
							27.317962000000023
						],
						[
							-82.49743399999994,
							27.318787000000043
						],
						[
							-82.49718799999995,
							27.318785000000048
						],
						[
							-82.49713899999996,
							27.31879200000003
						],
						[
							-82.49709999999999,
							27.318802000000062
						],
						[
							-82.49703499999998,
							27.31882600000006
						],
						[
							-82.49696399999993,
							27.318866000000074
						],
						[
							-82.49691999999999,
							27.31890100000004
						],
						[
							-82.49687499999999,
							27.318949000000032
						],
						[
							-82.49684899999994,
							27.31898400000006
						],
						[
							-82.49681899999996,
							27.31904300000008
						],
						[
							-82.49679999999995,
							27.319093000000066
						],
						[
							-82.49678799999998,
							27.319146000000046
						],
						[
							-82.49678099999994,
							27.319237000000044
						],
						[
							-82.49678799999998,
							27.319476000000066
						],
						[
							-82.49677399999996,
							27.31956500000007
						],
						[
							-82.49675099999996,
							27.319641000000047
						],
						[
							-82.49670599999996,
							27.319729000000052
						],
						[
							-82.49665299999998,
							27.31979700000005
						],
						[
							-82.49659899999995,
							27.31984300000005
						],
						[
							-82.49653599999994,
							27.319878000000074
						],
						[
							-82.49642499999999,
							27.319907000000057
						],
						[
							-82.49637699999994,
							27.31991400000004
						],
						[
							-82.49577099999993,
							27.319916000000035
						],
						[
							-82.49525399999999,
							27.31991400000004
						],
						[
							-82.49468299999995,
							27.319907000000057
						],
						[
							-82.49467599999997,
							27.32001800000006
						],
						[
							-82.49464199999994,
							27.32028900000006
						],
						[
							-82.49463599999996,
							27.320417000000077
						],
						[
							-82.49462699999998,
							27.32059300000003
						],
						[
							-82.49461799999995,
							27.321763000000033
						],
						[
							-82.49462699999998,
							27.321841000000067
						],
						[
							-82.49466099999995,
							27.32202200000006
						],
						[
							-82.49469399999998,
							27.322114000000056
						],
						[
							-82.49478499999998,
							27.32247200000006
						],
						[
							-82.49479299999997,
							27.322550000000035
						],
						[
							-82.49479399999996,
							27.322868000000028
						],
						[
							-82.49406799999997,
							27.322877000000062
						],
						[
							-82.49354799999998,
							27.32288600000004
						],
						[
							-82.49302899999998,
							27.322894000000076
						],
						[
							-82.49383499999999,
							27.32628900000003
						],
						[
							-82.49388099999999,
							27.326478000000066
						],
						[
							-82.49382999999995,
							27.326474000000076
						],
						[
							-82.49378099999996,
							27.326478000000066
						],
						[
							-82.49374135399995,
							27.32649398600006
						],
						[
							-82.49371899999994,
							27.32650300000006
						],
						[
							-82.49358399999994,
							27.326512000000037
						],
						[
							-82.49344999999994,
							27.326512000000037
						],
						[
							-82.49330699999996,
							27.326504000000057
						],
						[
							-82.49305599999997,
							27.326491000000033
						],
						[
							-82.49281499999995,
							27.326471000000026
						],
						[
							-82.49254899999994,
							27.32646200000005
						],
						[
							-82.49240999999995,
							27.32645700000006
						],
						[
							-82.49217799999997,
							27.326438000000053
						],
						[
							-82.49201299999999,
							27.32643600000006
						],
						[
							-82.49157399999996,
							27.32645900000006
						],
						[
							-82.49144699999994,
							27.326455000000067
						],
						[
							-82.49121099999996,
							27.32643600000006
						],
						[
							-82.49104999999997,
							27.326435000000064
						],
						[
							-82.49071199999997,
							27.326440000000048
						],
						[
							-82.49058099999996,
							27.326451000000077
						],
						[
							-82.49042399999996,
							27.326452000000074
						],
						[
							-82.49028899999996,
							27.326438000000053
						],
						[
							-82.49002199999995,
							27.326426000000026
						],
						[
							-82.48985499999998,
							27.326406000000077
						],
						[
							-82.48970699999995,
							27.326381000000026
						],
						[
							-82.48959599999995,
							27.326374000000044
						],
						[
							-82.489358,
							27.326381000000026
						],
						[
							-82.48925499999996,
							27.326378000000034
						],
						[
							-82.48900799999996,
							27.326354000000038
						],
						[
							-82.48885499999994,
							27.32633500000003
						],
						[
							-82.48831799999994,
							27.326298000000065
						],
						[
							-82.48814399999998,
							27.326292000000024
						],
						[
							-82.48798399999998,
							27.326293000000078
						],
						[
							-82.48785199999998,
							27.32630800000004
						],
						[
							-82.48768099999995,
							27.32631200000003
						],
						[
							-82.48766399999994,
							27.32632600000005
						],
						[
							-82.48748699999999,
							27.326313000000027
						],
						[
							-82.48723999999999,
							27.326317000000078
						],
						[
							-82.48698499999995,
							27.326332000000036
						],
						[
							-82.48688199999998,
							27.326332000000036
						],
						[
							-82.48680099999996,
							27.32632200000006
						],
						[
							-82.48643199999998,
							27.326230000000066
						],
						[
							-82.48628799999994,
							27.326203000000078
						],
						[
							-82.48622899999998,
							27.32618800000006
						],
						[
							-82.48605299999997,
							27.32611600000007
						],
						[
							-82.48584399999999,
							27.326041000000032
						],
						[
							-82.48574999999995,
							27.325999000000024
						],
						[
							-82.48564099999999,
							27.325935000000072
						],
						[
							-82.48557199999999,
							27.325887000000023
						],
						[
							-82.48539899999997,
							27.32576700000004
						],
						[
							-82.48526799999996,
							27.325676000000044
						],
						[
							-82.48502799999994,
							27.32553100000007
						],
						[
							-82.48478299999994,
							27.325390000000027
						],
						[
							-82.48453999999998,
							27.32522400000005
						],
						[
							-82.48441299999996,
							27.32511800000003
						],
						[
							-82.48434799999995,
							27.325071000000037
						],
						[
							-82.48422799999997,
							27.32502500000004
						],
						[
							-82.48408299999994,
							27.324905000000058
						],
						[
							-82.48395799999997,
							27.324790000000064
						],
						[
							-82.48387999999994,
							27.324727000000053
						],
						[
							-82.48373799999996,
							27.32463100000007
						],
						[
							-82.48358399999995,
							27.324559000000082
						],
						[
							-82.48338199999995,
							27.32438300000007
						],
						[
							-82.48321799999998,
							27.324262000000033
						],
						[
							-82.48298699999998,
							27.324110000000076
						],
						[
							-82.48289399999999,
							27.324044000000075
						],
						[
							-82.48281399999996,
							27.323987000000045
						],
						[
							-82.48279599999996,
							27.32397400000008
						],
						[
							-82.48276599999997,
							27.323953000000074
						],
						[
							-82.48270199999997,
							27.323908000000074
						],
						[
							-82.48267199999998,
							27.323886000000073
						],
						[
							-82.48247499999997,
							27.323763000000042
						],
						[
							-82.48216999999994,
							27.323552000000067
						],
						[
							-82.48179099999999,
							27.323277000000076
						],
						[
							-82.48156599999999,
							27.32312600000006
						],
						[
							-82.48141799999996,
							27.323026000000027
						],
						[
							-82.48137199999996,
							27.322996000000046
						],
						[
							-82.48126499999995,
							27.322924000000057
						],
						[
							-82.48075399999999,
							27.32253600000007
						],
						[
							-82.48035199999998,
							27.322269000000063
						],
						[
							-82.48028999999997,
							27.322223000000065
						],
						[
							-82.48007599999994,
							27.322062000000074
						],
						[
							-82.47975899999994,
							27.321847000000048
						],
						[
							-82.47936899999996,
							27.321552000000054
						],
						[
							-82.47901899999994,
							27.32132500000006
						],
						[
							-82.47870599999999,
							27.321093000000076
						],
						[
							-82.478483,
							27.320953000000035
						],
						[
							-82.47789899999998,
							27.32054400000004
						],
						[
							-82.47770599999996,
							27.320390000000035
						],
						[
							-82.47742599999998,
							27.320205000000044
						],
						[
							-82.47632099999998,
							27.319448000000023
						],
						[
							-82.47616399999998,
							27.319314000000077
						],
						[
							-82.47613199999995,
							27.31928700000003
						],
						[
							-82.47587199999998,
							27.319072000000062
						],
						[
							-82.47580999999997,
							27.319031000000056
						],
						[
							-82.47567499999997,
							27.318958000000066
						],
						[
							-82.475621,
							27.318924000000038
						],
						[
							-82.47529699999997,
							27.318692000000055
						],
						[
							-82.47505299999995,
							27.318512000000055
						],
						[
							-82.47493199999997,
							27.318436000000077
						],
						[
							-82.47471799999994,
							27.318273000000033
						],
						[
							-82.47464899999994,
							27.318230000000028
						],
						[
							-82.47460299999995,
							27.318215000000066
						],
						[
							-82.47456299999999,
							27.31818000000004
						],
						[
							-82.47439699999995,
							27.31807800000007
						],
						[
							-82.47433299999994,
							27.31798500000008
						],
						[
							-82.47392599999995,
							27.31770300000005
						],
						[
							-82.47385799999995,
							27.317664000000036
						],
						[
							-82.47367999999994,
							27.317581000000075
						],
						[
							-82.47358499999996,
							27.31752700000004
						],
						[
							-82.47352199999995,
							27.31748200000004
						],
						[
							-82.47348299999999,
							27.317447000000072
						],
						[
							-82.47339299999999,
							27.317353000000026
						],
						[
							-82.47334699999999,
							27.317311000000075
						],
						[
							-82.47322099999997,
							27.317220000000077
						],
						[
							-82.47283599999997,
							27.316922000000037
						],
						[
							-82.47266099999996,
							27.316810000000032
						],
						[
							-82.47254699999996,
							27.31675600000006
						],
						[
							-82.47250299999996,
							27.316718000000037
						],
						[
							-82.47206199999995,
							27.31639800000005
						],
						[
							-82.47199299999994,
							27.31636400000008
						],
						[
							-82.47191099999998,
							27.316309000000047
						],
						[
							-82.47182499999998,
							27.316231000000073
						],
						[
							-82.47157799999997,
							27.316059000000052
						],
						[
							-82.47108199999997,
							27.31571400000007
						],
						[
							-82.47100199999994,
							27.31564000000003
						],
						[
							-82.47097299999996,
							27.31561000000005
						],
						[
							-82.47091399999994,
							27.31556800000004
						],
						[
							-82.47085399999997,
							27.315555000000074
						],
						[
							-82.47077699999994,
							27.31551200000007
						],
						[
							-82.47074599999998,
							27.315488000000073
						],
						[
							-82.47072699999995,
							27.315459000000033
						],
						[
							-82.47065699999996,
							27.31539600000008
						],
						[
							-82.47060299999998,
							27.315369000000032
						],
						[
							-82.47042799999997,
							27.315267000000063
						],
						[
							-82.47035899999997,
							27.31519300000008
						],
						[
							-82.46991299999996,
							27.314886000000058
						],
						[
							-82.46978499999994,
							27.314810000000023
						],
						[
							-82.46974399999993,
							27.314767000000074
						],
						[
							-82.46952899999997,
							27.314590000000067
						],
						[
							-82.46931099999995,
							27.314446000000032
						],
						[
							-82.46924399999995,
							27.314392000000055
						],
						[
							-82.46916299999998,
							27.314336000000026
						],
						[
							-82.46904699999999,
							27.314287000000036
						],
						[
							-82.46896399999997,
							27.314224000000024
						],
						[
							-82.46889499999997,
							27.31416100000007
						],
						[
							-82.46885599999996,
							27.31411100000003
						],
						[
							-82.46883099999997,
							27.314087000000033
						],
						[
							-82.46849699999996,
							27.31388700000008
						],
						[
							-82.46819599999998,
							27.31368600000008
						],
						[
							-82.46816799999993,
							27.313667000000066
						],
						[
							-82.46776699999998,
							27.313391000000024
						],
						[
							-82.46753899999999,
							27.31321500000007
						],
						[
							-82.46750799999995,
							27.313180000000045
						],
						[
							-82.46744199999995,
							27.313120000000026
						],
						[
							-82.46741799999995,
							27.31310300000007
						],
						[
							-82.46732799999995,
							27.313053000000025
						],
						[
							-82.46721799999995,
							27.312946000000068
						],
						[
							-82.46716499999997,
							27.31290000000007
						],
						[
							-82.46687799999995,
							27.312756000000036
						],
						[
							-82.46680399999997,
							27.312708000000043
						],
						[
							-82.46671399999997,
							27.312632000000068
						],
						[
							-82.46661899999998,
							27.312545000000057
						],
						[
							-82.46657699999997,
							27.312498000000062
						],
						[
							-82.46651599999996,
							27.312447000000077
						],
						[
							-82.46617699999996,
							27.312223000000074
						],
						[
							-82.46613199999996,
							27.31218400000006
						],
						[
							-82.46596299999999,
							27.31206700000007
						],
						[
							-82.46584099999995,
							27.311983000000055
						],
						[
							-82.46566599999994,
							27.31187600000004
						],
						[
							-82.46548499999994,
							27.311740000000043
						],
						[
							-82.46522399999998,
							27.311555000000055
						],
						[
							-82.46498299999998,
							27.31139100000007
						],
						[
							-82.46472299999994,
							27.311248000000035
						],
						[
							-82.46470699999998,
							27.311235000000067
						],
						[
							-82.46466399999997,
							27.311159000000032
						],
						[
							-82.46464199999997,
							27.311124000000063
						],
						[
							-82.46462499999996,
							27.311104000000057
						],
						[
							-82.46457999999996,
							27.31108000000006
						],
						[
							-82.46400499999999,
							27.310713000000078
						],
						[
							-82.46354999999994,
							27.310376000000076
						],
						[
							-82.46323699999994,
							27.310160000000053
						],
						[
							-82.46319799999998,
							27.310128000000077
						],
						[
							-82.46310999999999,
							27.31004400000006
						],
						[
							-82.46306299999999,
							27.310007000000045
						],
						[
							-82.46287599999995,
							27.30988900000006
						],
						[
							-82.46266399999996,
							27.30973700000004
						],
						[
							-82.46209499999998,
							27.309401000000037
						],
						[
							-82.46189599999997,
							27.309271000000024
						],
						[
							-82.46183999999994,
							27.309252000000072
						],
						[
							-82.46181299999995,
							27.309239000000048
						],
						[
							-82.46167399999996,
							27.30903500000005
						],
						[
							-82.46163799999994,
							27.308993000000044
						],
						[
							-82.46158999999994,
							27.308951000000036
						],
						[
							-82.46142599999996,
							27.30884400000008
						],
						[
							-82.46131699999995,
							27.308746000000042
						],
						[
							-82.46128699999997,
							27.30872800000003
						],
						[
							-82.46119799999997,
							27.308686000000023
						],
						[
							-82.46116399999994,
							27.30866400000008
						],
						[
							-82.46109599999994,
							27.30860100000007
						],
						[
							-82.46106499999996,
							27.308577000000074
						],
						[
							-82.46096899999998,
							27.308531000000073
						],
						[
							-82.46087499999999,
							27.308500000000038
						],
						[
							-82.46079199999997,
							27.308456000000035
						],
						[
							-82.46068999999994,
							27.30838600000004
						],
						[
							-82.46049599999998,
							27.308264000000065
						],
						[
							-82.46014799999995,
							27.308037000000073
						],
						[
							-82.45994099999996,
							27.30791400000004
						],
						[
							-82.45979499999999,
							27.30780600000003
						],
						[
							-82.45958699999994,
							27.30767000000003
						],
						[
							-82.45952499999999,
							27.307622000000038
						],
						[
							-82.45949499999995,
							27.307588000000067
						],
						[
							-82.45951399999996,
							27.30748600000004
						],
						[
							-82.45952099999994,
							27.307394000000045
						],
						[
							-82.45953399999996,
							27.307307000000037
						],
						[
							-82.45953599999996,
							27.307267000000028
						],
						[
							-82.45950499999998,
							27.30697900000007
						],
						[
							-82.45950299999998,
							27.30691100000007
						],
						[
							-82.45950999999997,
							27.30682500000006
						],
						[
							-82.45953299999996,
							27.306696000000045
						],
						[
							-82.45954999999998,
							27.306543000000033
						],
						[
							-82.45956599999994,
							27.30648300000007
						],
						[
							-82.45957499999997,
							27.306418000000065
						],
						[
							-82.45957099999998,
							27.30626600000005
						],
						[
							-82.45953299999996,
							27.30634900000007
						],
						[
							-82.45911299999995,
							27.30727600000006
						],
						[
							-82.45908999999995,
							27.307326000000046
						],
						[
							-82.45873199999994,
							27.30812100000003
						],
						[
							-82.45726599999995,
							27.30840500000005
						],
						[
							-82.45446899999996,
							27.30849500000005
						],
						[
							-82.45175599999999,
							27.30845000000005
						],
						[
							-82.45149399999997,
							27.30865300000005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Sarasota Springs",
				"RegionID": "126082"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.7340730489999,
					30.398360822000086,
					-81.71339095999991,
					30.421466672000065
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.72707008799995,
							30.41849690200007
						],
						[
							-81.72637944399993,
							30.418481555000085
						],
						[
							-81.72505187199994,
							30.41856596700006
						],
						[
							-81.7238163859999,
							30.418481555000085
						],
						[
							-81.72161399899994,
							30.418235992000067
						],
						[
							-81.7206164019999,
							30.418374121000053
						],
						[
							-81.72060278899994,
							30.418378792000055
						],
						[
							-81.72080099999994,
							30.417903000000084
						],
						[
							-81.72117805099992,
							30.416997911000067
						],
						[
							-81.72017690799993,
							30.417009010000072
						],
						[
							-81.71919290799991,
							30.417017010000055
						],
						[
							-81.71886389899993,
							30.417000063000042
						],
						[
							-81.71865090799992,
							30.416935009000042
						],
						[
							-81.71850590799994,
							30.416866011000085
						],
						[
							-81.71819290699995,
							30.41674401100005
						],
						[
							-81.71805590699995,
							30.416710011000077
						],
						[
							-81.71791090799991,
							30.41669801100005
						],
						[
							-81.7162699079999,
							30.416723010000055
						],
						[
							-81.7136077799999,
							30.416746143000065
						],
						[
							-81.71359990799994,
							30.416456011000037
						],
						[
							-81.71359990799994,
							30.415342011000064
						],
						[
							-81.71358490699993,
							30.415052011000057
						],
						[
							-81.71356190799992,
							30.413845010000042
						],
						[
							-81.71355390799994,
							30.413540010000077
						],
						[
							-81.71356190799992,
							30.413240011000084
						],
						[
							-81.7135239079999,
							30.41072801000007
						],
						[
							-81.71350890699995,
							30.40892201000008
						],
						[
							-81.71349290699993,
							30.408623011000085
						],
						[
							-81.71348590799994,
							30.407946010000046
						],
						[
							-81.71349290699993,
							30.407719011000044
						],
						[
							-81.71348590799994,
							30.406200010000074
						],
						[
							-81.71346990799992,
							30.405630011000085
						],
						[
							-81.7134459909999,
							30.404431990000035
						],
						[
							-81.71339095999991,
							30.404320954000067
						],
						[
							-81.71468790799992,
							30.404264011000063
						],
						[
							-81.7165389079999,
							30.404232010000047
						],
						[
							-81.71804290799992,
							30.404221010000075
						],
						[
							-81.71916890699993,
							30.404184010000055
						],
						[
							-81.71944290699992,
							30.404140010000045
						],
						[
							-81.71975688299995,
							30.40406692200008
						],
						[
							-81.7199899069999,
							30.40398901100008
						],
						[
							-81.72025690699991,
							30.403876011000083
						],
						[
							-81.72050790799995,
							30.40375801000005
						],
						[
							-81.72076090699994,
							30.40360001100004
						],
						[
							-81.72093690699995,
							30.40346801000004
						],
						[
							-81.72125690699994,
							30.403161010000076
						],
						[
							-81.72135590699992,
							30.403052011000057
						],
						[
							-81.7213859069999,
							30.403015011000036
						],
						[
							-81.72225090699993,
							30.40193401000005
						],
						[
							-81.72293090699992,
							30.40111001000008
						],
						[
							-81.72350290799994,
							30.40039301000007
						],
						[
							-81.72373990799991,
							30.400089011000038
						],
						[
							-81.72407490799992,
							30.399683011000036
						],
						[
							-81.72443390699993,
							30.39924201000008
						],
						[
							-81.72463990799992,
							30.398989010000033
						],
						[
							-81.72492690699994,
							30.398629011000086
						],
						[
							-81.7251428749999,
							30.398360822000086
						],
						[
							-81.7265819079999,
							30.399247010000067
						],
						[
							-81.7268769069999,
							30.399387010000055
						],
						[
							-81.72702490799992,
							30.399437010000046
						],
						[
							-81.72717690799993,
							30.399473010000065
						],
						[
							-81.72731390799993,
							30.39949501000007
						],
						[
							-81.72747090799993,
							30.39950801100008
						],
						[
							-81.72769890799992,
							30.39950601000004
						],
						[
							-81.72810990799991,
							30.39946101000004
						],
						[
							-81.72998890799994,
							30.399222010000074
						],
						[
							-81.73016795899991,
							30.399198995000067
						],
						[
							-81.73029790499993,
							30.399970008000082
						],
						[
							-81.73081890599991,
							30.40294000800009
						],
						[
							-81.73105590599994,
							30.40409600900006
						],
						[
							-81.73113290599991,
							30.404632009000068
						],
						[
							-81.73119090599994,
							30.405159009000045
						],
						[
							-81.73135490599992,
							30.406667008000056
						],
						[
							-81.73141390599994,
							30.40724700800007
						],
						[
							-81.73148690599993,
							30.407915009000078
						],
						[
							-81.73190390499991,
							30.411892008000052
						],
						[
							-81.73213990499994,
							30.414465009000086
						],
						[
							-81.73230879999994,
							30.416103159000045
						],
						[
							-81.7325609049999,
							30.41604200900008
						],
						[
							-81.7326709059999,
							30.41602400900007
						],
						[
							-81.7340730489999,
							30.416036894000058
						],
						[
							-81.73381100199992,
							30.416994171000056
						],
						[
							-81.73367890599991,
							30.416967875000072
						],
						[
							-81.73358384799991,
							30.416989185000034
						],
						[
							-81.73346774599992,
							30.416863082000077
						],
						[
							-81.73343806699995,
							30.416567903000043
						],
						[
							-81.7331199269999,
							30.416367929000046
						],
						[
							-81.73272690599993,
							30.416363010000058
						],
						[
							-81.73266090699991,
							30.416377011000066
						],
						[
							-81.7326307479999,
							30.41639390200004
						],
						[
							-81.73259090599993,
							30.416816008000072
						],
						[
							-81.73260077499992,
							30.41701103300005
						],
						[
							-81.73301890499995,
							30.417933009000084
						],
						[
							-81.73314995599992,
							30.41817199100007
						],
						[
							-81.73331190499994,
							30.418854011000064
						],
						[
							-81.7333109999999,
							30.419445000000053
						],
						[
							-81.73331023499992,
							30.41994439700005
						],
						[
							-81.73322449499994,
							30.419947255000064
						],
						[
							-81.73288684699992,
							30.420093058000077
						],
						[
							-81.73244943899994,
							30.42040768500004
						],
						[
							-81.73193529299994,
							30.420883462000067
						],
						[
							-81.7314518419999,
							30.42122111000009
						],
						[
							-81.7309146739999,
							30.421451325000078
						],
						[
							-81.73029309399993,
							30.421466672000065
						],
						[
							-81.7299324249999,
							30.421328544000062
						],
						[
							-81.72965616699992,
							30.42114437200007
						],
						[
							-81.72907295599992,
							30.420346294000073
						],
						[
							-81.72858183099993,
							30.419770757000038
						],
						[
							-81.72743075799991,
							30.41862735700005
						],
						[
							-81.72707008799995,
							30.41849690200007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Sherwood Forest",
				"RegionID": "126155"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.63354290199999,
					28.18669,
					-80.595374,
					28.212689
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.597774,
							28.212689
						],
						[
							-80.597674,
							28.212189
						],
						[
							-80.597174,
							28.208389
						],
						[
							-80.596799,
							28.206289
						],
						[
							-80.596674,
							28.205589
						],
						[
							-80.596374,
							28.20329
						],
						[
							-80.596266,
							28.202663
						],
						[
							-80.59611700000002,
							28.201799000000005
						],
						[
							-80.595874,
							28.20039
						],
						[
							-80.595479,
							28.198414
						],
						[
							-80.595374,
							28.19789
						],
						[
							-80.600075,
							28.19779
						],
						[
							-80.606175,
							28.19779
						],
						[
							-80.606175,
							28.196844
						],
						[
							-80.606175,
							28.195757
						],
						[
							-80.606175,
							28.19539
						],
						[
							-80.606175,
							28.19399
						],
						[
							-80.606175,
							28.19239
						],
						[
							-80.606175,
							28.18999
						],
						[
							-80.606175,
							28.189684
						],
						[
							-80.602243,
							28.189693
						],
						[
							-80.602152,
							28.187946
						],
						[
							-80.602079,
							28.186790000000002
						],
						[
							-80.604602,
							28.186790000000002
						],
						[
							-80.606075,
							28.186790000000002
						],
						[
							-80.606383,
							28.186756
						],
						[
							-80.60686249999999,
							28.186703
						],
						[
							-80.606975,
							28.18669
						],
						[
							-80.607775,
							28.186790000000002
						],
						[
							-80.608041,
							28.186781
						],
						[
							-80.608722,
							28.186758
						],
						[
							-80.609536,
							28.186731
						],
						[
							-80.610775,
							28.18669
						],
						[
							-80.61137500000001,
							28.18959
						],
						[
							-80.612247,
							28.189615
						],
						[
							-80.612706,
							28.189629
						],
						[
							-80.613411,
							28.189649
						],
						[
							-80.613656,
							28.189657
						],
						[
							-80.61413,
							28.189671
						],
						[
							-80.614775,
							28.18969
						],
						[
							-80.624775,
							28.18969
						],
						[
							-80.63354290199999,
							28.20818918300006
						],
						[
							-80.633288,
							28.208667000000002
						],
						[
							-80.632878,
							28.208827
						],
						[
							-80.631263,
							28.209156
						],
						[
							-80.630872,
							28.209305
						],
						[
							-80.630257,
							28.209316000000005
						],
						[
							-80.630033,
							28.209514
						],
						[
							-80.629486,
							28.209607
						],
						[
							-80.629356,
							28.209788
						],
						[
							-80.62938266699996,
							28.20988729800007
						],
						[
							-80.629375,
							28.209889
						],
						[
							-80.627075,
							28.210489
						],
						[
							-80.62682741099997,
							28.210547029000054
						],
						[
							-80.626836,
							28.210562
						],
						[
							-80.62693,
							28.210725000000004
						],
						[
							-80.626696,
							28.211567
						],
						[
							-80.621067,
							28.212233
						],
						[
							-80.62072700000002,
							28.212124
						],
						[
							-80.62071854899995,
							28.21197879300007
						],
						[
							-80.620675,
							28.211989
						],
						[
							-80.620075,
							28.212089
						],
						[
							-80.618075,
							28.212489
						],
						[
							-80.616881,
							28.212511
						],
						[
							-80.616136,
							28.212525
						],
						[
							-80.611661,
							28.212608
						],
						[
							-80.609993,
							28.21264
						],
						[
							-80.607375,
							28.212689
						],
						[
							-80.606375,
							28.212689
						],
						[
							-80.605775,
							28.212589
						],
						[
							-80.605375,
							28.212589
						],
						[
							-80.597774,
							28.212689
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Brevard",
				"City": "Satellite Beach",
				"Name": "South Patrick Shores",
				"RegionID": "126230"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.6627169599999,
					30.329398951000087,
					-81.6450497589999,
					30.355025023000053
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.64918881699992,
							30.355025023000053
						],
						[
							-81.64916190499991,
							30.354305008000036
						],
						[
							-81.64913190599992,
							30.353592009000067
						],
						[
							-81.64910890599992,
							30.35287900800006
						],
						[
							-81.64908090499995,
							30.352161008000053
						],
						[
							-81.64905290599997,
							30.35176700900007
						],
						[
							-81.64903603499994,
							30.351212871000087
						],
						[
							-81.6474988949999,
							30.35130294400005
						],
						[
							-81.64710490599992,
							30.35139700900004
						],
						[
							-81.64653383799993,
							30.351617892000036
						],
						[
							-81.64626790599993,
							30.351854008000092
						],
						[
							-81.64614384999993,
							30.35194193600006
						],
						[
							-81.6460299069999,
							30.352040008000078
						],
						[
							-81.64583790599994,
							30.352254008000045
						],
						[
							-81.64567990599994,
							30.352459009000082
						],
						[
							-81.64556690599994,
							30.352635009000043
						],
						[
							-81.64547590599994,
							30.352810009000052
						],
						[
							-81.64544190599992,
							30.352907008000045
						],
						[
							-81.64540885399992,
							30.353023999000072
						],
						[
							-81.6453969069999,
							30.353238868000062
						],
						[
							-81.64537473199994,
							30.352545944000042
						],
						[
							-81.64549006699991,
							30.35242007100004
						],
						[
							-81.64557290499994,
							30.349315008000076
						],
						[
							-81.64557690599992,
							30.34915101100006
						],
						[
							-81.64572690299991,
							30.348536007000064
						],
						[
							-81.64559096199993,
							30.34505200500007
						],
						[
							-81.64557990599991,
							30.343968008000047
						],
						[
							-81.64553190599992,
							30.342448008000076
						],
						[
							-81.64552290599994,
							30.339719008000092
						],
						[
							-81.64538804099993,
							30.33837487400007
						],
						[
							-81.6450497589999,
							30.338337117000034
						],
						[
							-81.6451769059999,
							30.337430008000066
						],
						[
							-81.64531590699994,
							30.336424009000044
						],
						[
							-81.64550790499993,
							30.335823008000094
						],
						[
							-81.64569790599995,
							30.33483800800008
						],
						[
							-81.64576390499991,
							30.334325008000068
						],
						[
							-81.6457629059999,
							30.333521009000034
						],
						[
							-81.64574590799992,
							30.332763011000054
						],
						[
							-81.64594490499991,
							30.331994009000084
						],
						[
							-81.64608185599992,
							30.331201990000068
						],
						[
							-81.6464179059999,
							30.33052200800006
						],
						[
							-81.64660065099991,
							30.330058362000045
						],
						[
							-81.64670390499992,
							30.329796009000063
						],
						[
							-81.6467779059999,
							30.329622008000058
						],
						[
							-81.6468798329999,
							30.329398951000087
						],
						[
							-81.64755990399993,
							30.329563009000083
						],
						[
							-81.64773390699992,
							30.329608008000037
						],
						[
							-81.64791390599993,
							30.32965800800008
						],
						[
							-81.64804201999995,
							30.32969911400005
						],
						[
							-81.64801479999994,
							30.329641904000084
						],
						[
							-81.64814390399994,
							30.32969200900004
						],
						[
							-81.6484859059999,
							30.32985400900009
						],
						[
							-81.64877290599992,
							30.330040008000083
						],
						[
							-81.6488929059999,
							30.330141009000048
						],
						[
							-81.6489829059999,
							30.330218009000077
						],
						[
							-81.64908690699991,
							30.33031100800008
						],
						[
							-81.64920990699994,
							30.33041700900009
						],
						[
							-81.64927458599993,
							30.330478017000075
						],
						[
							-81.64922973599994,
							30.33050892400007
						],
						[
							-81.6492269069999,
							30.33101300800007
						],
						[
							-81.64923377999992,
							30.33108515100008
						],
						[
							-81.64927490699995,
							30.331086009000042
						],
						[
							-81.64934093999995,
							30.331095933000086
						],
						[
							-81.64935890599992,
							30.331110008000053
						],
						[
							-81.64942590099993,
							30.33115819600005
						],
						[
							-81.64973208899994,
							30.33094201100005
						],
						[
							-81.64963190399993,
							30.330859008000065
						],
						[
							-81.64948872699995,
							30.330736006000052
						],
						[
							-81.64953390599993,
							30.330699008000067
						],
						[
							-81.64958791499993,
							30.330659818000072
						],
						[
							-81.64961790599996,
							30.33068600900009
						],
						[
							-81.64963890699994,
							30.330707008000047
						],
						[
							-81.6496989069999,
							30.33075100800005
						],
						[
							-81.64974690399994,
							30.330782008000085
						],
						[
							-81.64981290499992,
							30.330820008000043
						],
						[
							-81.6499229069999,
							30.33088200800006
						],
						[
							-81.65002190599995,
							30.330924009000057
						],
						[
							-81.65005190399995,
							30.330934008000042
						],
						[
							-81.65012390599992,
							30.330957008000045
						],
						[
							-81.6501929069999,
							30.330981009000087
						],
						[
							-81.6503389049999,
							30.331027008000035
						],
						[
							-81.65063790699992,
							30.331079009000067
						],
						[
							-81.65082890699995,
							30.33110200800007
						],
						[
							-81.6510549859999,
							30.331104052000057
						],
						[
							-81.65095390599993,
							30.331464008000072
						],
						[
							-81.65088590599993,
							30.331809008000047
						],
						[
							-81.65066590599992,
							30.332788008000076
						],
						[
							-81.65064190499993,
							30.333092009000044
						],
						[
							-81.65060390599992,
							30.333357008000064
						],
						[
							-81.65058890499995,
							30.33354001000004
						],
						[
							-81.65057390599992,
							30.333637009000086
						],
						[
							-81.6505359059999,
							30.33419800900009
						],
						[
							-81.65040590599995,
							30.33534800800004
						],
						[
							-81.65034190599994,
							30.335888009000087
						],
						[
							-81.6503267629999,
							30.33608712900008
						],
						[
							-81.65115390599993,
							30.336159008000042
						],
						[
							-81.65185490499994,
							30.33621200800007
						],
						[
							-81.65338890599992,
							30.33633400800005
						],
						[
							-81.65496790599991,
							30.33646600800006
						],
						[
							-81.65583790499994,
							30.33653500800006
						],
						[
							-81.65655490499995,
							30.336592008000082
						],
						[
							-81.65698990499993,
							30.336613008000086
						],
						[
							-81.65715790599995,
							30.336607008000044
						],
						[
							-81.65729398599991,
							30.33660183500007
						],
						[
							-81.65812390699995,
							30.33765300800008
						],
						[
							-81.65864390599995,
							30.338075008000093
						],
						[
							-81.65968400799994,
							30.338917922000064
						],
						[
							-81.66007590599992,
							30.339634008000072
						],
						[
							-81.66023480099994,
							30.339950094000073
						],
						[
							-81.6605369049999,
							30.34023800800009
						],
						[
							-81.66097390599992,
							30.340608008000064
						],
						[
							-81.66149887899991,
							30.34103505400009
						],
						[
							-81.66168101999996,
							30.341108877000067
						],
						[
							-81.6620229049999,
							30.341726008000084
						],
						[
							-81.66241290499994,
							30.34271400800009
						],
						[
							-81.66255590499992,
							30.343243008000055
						],
						[
							-81.66261990599992,
							30.343826009000058
						],
						[
							-81.66265190599995,
							30.344025008000077
						],
						[
							-81.6627169599999,
							30.344708008000055
						],
						[
							-81.66267706699995,
							30.345036082000036
						],
						[
							-81.66256490599994,
							30.34516700900008
						],
						[
							-81.66246990999991,
							30.345294007000064
						],
						[
							-81.66243790699991,
							30.34539000800004
						],
						[
							-81.66239777299995,
							30.345624008000076
						],
						[
							-81.66244190499992,
							30.34583401000009
						],
						[
							-81.66244590499991,
							30.34610500900004
						],
						[
							-81.66245803499993,
							30.34639414000009
						],
						[
							-81.66151390499994,
							30.34630500900005
						],
						[
							-81.66125478799995,
							30.34629986300007
						],
						[
							-81.66122290599992,
							30.346459009000053
						],
						[
							-81.66109190599991,
							30.34765900800005
						],
						[
							-81.66097890499992,
							30.348618009000063
						],
						[
							-81.66094990499994,
							30.348971009000085
						],
						[
							-81.66094990499994,
							30.349998008000057
						],
						[
							-81.66095790599991,
							30.35063900800009
						],
						[
							-81.6609659049999,
							30.35072800900008
						],
						[
							-81.6609739079999,
							30.35082201000006
						],
						[
							-81.66116290499991,
							30.351360008000086
						],
						[
							-81.66118190499992,
							30.351440008000058
						],
						[
							-81.66120890499991,
							30.35170500900006
						],
						[
							-81.6612319059999,
							30.352906008000048
						],
						[
							-81.66124690599992,
							30.35349700900008
						],
						[
							-81.66126090499995,
							30.35390000800004
						],
						[
							-81.66126090499995,
							30.354206009000052
						],
						[
							-81.66128199499991,
							30.354923993000057
						],
						[
							-81.6599659069999,
							30.35493500800004
						],
						[
							-81.65901190699992,
							30.35494000900007
						],
						[
							-81.65865290699992,
							30.354950008000063
						],
						[
							-81.6570379069999,
							30.35496400800008
						],
						[
							-81.65698190699993,
							30.35496500800008
						],
						[
							-81.65543690699991,
							30.35498000800004
						],
						[
							-81.65426990599991,
							30.35499200800007
						],
						[
							-81.65388890799994,
							30.354997007000065
						],
						[
							-81.65373990699993,
							30.35496400900007
						],
						[
							-81.65352290699991,
							30.354930009000046
						],
						[
							-81.65227490699993,
							30.354946008000073
						],
						[
							-81.6507339069999,
							30.354988008000078
						],
						[
							-81.64918881699992,
							30.355025023000053
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Springfield",
				"RegionID": "126264"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.76451303699992,
					30.252925874000088,
					-81.75196790799993,
					30.27017406200008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.75218190399994,
							30.27017406200008
						],
						[
							-81.75215890599992,
							30.269421008000048
						],
						[
							-81.75215090599994,
							30.26896100900007
						],
						[
							-81.75213590499993,
							30.268692008000073
						],
						[
							-81.7521209059999,
							30.267735008000045
						],
						[
							-81.75208990599992,
							30.266878009000038
						],
						[
							-81.75208990599992,
							30.266579008000065
						],
						[
							-81.75207490499992,
							30.266117008000037
						],
						[
							-81.75199090599995,
							30.262915009000043
						],
						[
							-81.75196790799993,
							30.26228100700007
						],
						[
							-81.75202190499994,
							30.261972008000043
						],
						[
							-81.75202173799994,
							30.261859935000075
						],
						[
							-81.75215090599994,
							30.26174000900005
						],
						[
							-81.75264690599994,
							30.26137000900008
						],
						[
							-81.7533869049999,
							30.26082400900009
						],
						[
							-81.75414990599995,
							30.260269008000083
						],
						[
							-81.7545319059999,
							30.259983008000066
						],
						[
							-81.75482885799994,
							30.259774839000045
						],
						[
							-81.75549290599992,
							30.25977300800008
						],
						[
							-81.75846103299995,
							30.259802146000087
						],
						[
							-81.75846890499992,
							30.259697009000032
						],
						[
							-81.75847590599994,
							30.258865008000047
						],
						[
							-81.75848390599992,
							30.258047008000062
						],
						[
							-81.75849190499991,
							30.25770600800007
						],
						[
							-81.75846890499992,
							30.25741600800006
						],
						[
							-81.7584919059999,
							30.255640009000047
						],
						[
							-81.75850690599992,
							30.255106008000045
						],
						[
							-81.75852190599994,
							30.25455700800006
						],
						[
							-81.75852190599994,
							30.253962008000087
						],
						[
							-81.7585217749999,
							30.252925874000088
						],
						[
							-81.76451303699992,
							30.253325881000077
						],
						[
							-81.76450390499991,
							30.255620009000037
						],
						[
							-81.76449390599993,
							30.25587800900007
						],
						[
							-81.7644639049999,
							30.25611200800006
						],
						[
							-81.76441890599995,
							30.256348009000078
						],
						[
							-81.76435390599994,
							30.256607008000064
						],
						[
							-81.76424990499993,
							30.256876008000063
						],
						[
							-81.76417890499994,
							30.257007008000073
						],
						[
							-81.76400490599991,
							30.25723700800006
						],
						[
							-81.7635149059999,
							30.25776700900008
						],
						[
							-81.7634229059999,
							30.257877009000083
						],
						[
							-81.76317090599991,
							30.258205008000065
						],
						[
							-81.76297590699994,
							30.25849000900007
						],
						[
							-81.76290490499991,
							30.25864300900008
						],
						[
							-81.76281577399993,
							30.258881985000073
						],
						[
							-81.76281603699994,
							30.258916031000066
						],
						[
							-81.7628017749999,
							30.258949985000076
						],
						[
							-81.76280203699991,
							30.258983032000064
						],
						[
							-81.76278790599991,
							30.25901701000004
						],
						[
							-81.7627699059999,
							30.25912100800008
						],
						[
							-81.76276690599992,
							30.259394008000072
						],
						[
							-81.76278390599992,
							30.259572008000074
						],
						[
							-81.76284790599993,
							30.259817008000084
						],
						[
							-81.7636989049999,
							30.26219700800004
						],
						[
							-81.76381590499996,
							30.262497008000082
						],
						[
							-81.76413890499992,
							30.263410008000054
						],
						[
							-81.76417390499995,
							30.26354501100008
						],
						[
							-81.76417390699993,
							30.263582005000046
						],
						[
							-81.76419190399992,
							30.26364900800007
						],
						[
							-81.76424190499995,
							30.264032008000072
						],
						[
							-81.76426690599993,
							30.265345008000054
						],
						[
							-81.76427190499993,
							30.265531008000035
						],
						[
							-81.76427490599991,
							30.265785009000073
						],
						[
							-81.76428190599995,
							30.266600009000058
						],
						[
							-81.76428990499994,
							30.26742700900007
						],
						[
							-81.76428990499994,
							30.267714008000045
						],
						[
							-81.76429690599991,
							30.26825100800005
						],
						[
							-81.76429690599991,
							30.26880300800008
						],
						[
							-81.76429690599991,
							30.269077009000057
						],
						[
							-81.76431290399995,
							30.269926061000035
						],
						[
							-81.7640299059999,
							30.26992200800004
						],
						[
							-81.76302290499991,
							30.26995500900006
						],
						[
							-81.76016990599993,
							30.270018008000083
						],
						[
							-81.75997890499991,
							30.270010008000042
						],
						[
							-81.75968890599995,
							30.270004008000058
						],
						[
							-81.75926990599993,
							30.270008008000048
						],
						[
							-81.7588959059999,
							30.270027008000053
						],
						[
							-81.75875890499992,
							30.270037008000088
						],
						[
							-81.75815190599991,
							30.270049008000058
						],
						[
							-81.7574839049999,
							30.27007100900005
						],
						[
							-81.7564469049999,
							30.270084008000083
						],
						[
							-81.75613390499991,
							30.27009800900004
						],
						[
							-81.7549129059999,
							30.270115008000065
						],
						[
							-81.75346390499993,
							30.270145008000043
						],
						[
							-81.75282890599993,
							30.270159008000068
						],
						[
							-81.75218190399994,
							30.27017406200008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Sweetwater",
				"RegionID": "126341"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.37579199999993,
					28.420559000000083,
					-81.35069299999992,
					28.436115000000086
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.3650219999999,
							28.436115000000086
						],
						[
							-81.3650209999999,
							28.433377000000064
						],
						[
							-81.36358699999994,
							28.43337900000006
						],
						[
							-81.36359199999993,
							28.432383000000073
						],
						[
							-81.36340699999994,
							28.432383000000073
						],
						[
							-81.36340699999994,
							28.432518000000073
						],
						[
							-81.36269099999993,
							28.432518000000073
						],
						[
							-81.36176699999993,
							28.432506000000046
						],
						[
							-81.36093699999994,
							28.432495000000074
						],
						[
							-81.36010399999992,
							28.432484000000045
						],
						[
							-81.35920799999991,
							28.432471000000078
						],
						[
							-81.35920699999991,
							28.432337000000075
						],
						[
							-81.35920699999991,
							28.432251000000065
						],
						[
							-81.35920399999992,
							28.431504000000075
						],
						[
							-81.35919999999993,
							28.430494000000067
						],
						[
							-81.35919599999994,
							28.429459000000065
						],
						[
							-81.35919399999995,
							28.42898200000008
						],
						[
							-81.35919199999995,
							28.42858300000006
						],
						[
							-81.35888399999993,
							28.42859100000004
						],
						[
							-81.35848499999992,
							28.42860100000007
						],
						[
							-81.35716799999994,
							28.428635000000043
						],
						[
							-81.3570509999999,
							28.428632000000054
						],
						[
							-81.3570509999999,
							28.428484000000083
						],
						[
							-81.3570509999999,
							28.426744000000042
						],
						[
							-81.3580199999999,
							28.426744000000042
						],
						[
							-81.3580199999999,
							28.42312400000009
						],
						[
							-81.35901999999993,
							28.42312400000009
						],
						[
							-81.35901999999993,
							28.422971000000075
						],
						[
							-81.35901999999993,
							28.42257600000005
						],
						[
							-81.35901999999993,
							28.42215500000009
						],
						[
							-81.3590069999999,
							28.42199000000005
						],
						[
							-81.35900499999991,
							28.42191500000007
						],
						[
							-81.35900499999991,
							28.421849000000066
						],
						[
							-81.35899999999992,
							28.421306000000072
						],
						[
							-81.35693099999992,
							28.421300000000087
						],
						[
							-81.35693099999992,
							28.422693000000038
						],
						[
							-81.35721299999994,
							28.422573000000057
						],
						[
							-81.35721299999994,
							28.42272200000008
						],
						[
							-81.35721299999994,
							28.422880000000077
						],
						[
							-81.35692199999994,
							28.422971000000075
						],
						[
							-81.35692199999994,
							28.423113000000058
						],
						[
							-81.35292599999991,
							28.423113000000058
						],
						[
							-81.35292299999992,
							28.42334500000004
						],
						[
							-81.35292299999992,
							28.423985000000073
						],
						[
							-81.35113799999993,
							28.42398600000007
						],
						[
							-81.35113599999994,
							28.424041000000045
						],
						[
							-81.3510149999999,
							28.424041000000045
						],
						[
							-81.3509949999999,
							28.422971000000075
						],
						[
							-81.35099099999991,
							28.422784000000036
						],
						[
							-81.35099099999991,
							28.421584000000053
						],
						[
							-81.35095899999993,
							28.421539000000053
						],
						[
							-81.35069299999992,
							28.421167000000082
						],
						[
							-81.35249999999992,
							28.42120200000005
						],
						[
							-81.3539859999999,
							28.421160000000043
						],
						[
							-81.3539859999999,
							28.421274000000043
						],
						[
							-81.35681999999991,
							28.42129900000009
						],
						[
							-81.35681999999991,
							28.421183000000042
						],
						[
							-81.35742399999994,
							28.421174000000065
						],
						[
							-81.35942499999993,
							28.421175000000062
						],
						[
							-81.35942799999992,
							28.42110400000007
						],
						[
							-81.3595499999999,
							28.42110500000007
						],
						[
							-81.3655379999999,
							28.421106000000066
						],
						[
							-81.3655379999999,
							28.42070700000005
						],
						[
							-81.36563099999995,
							28.420597000000043
						],
						[
							-81.36566699999992,
							28.420559000000083
						],
						[
							-81.36613199999994,
							28.420559000000083
						],
						[
							-81.36613199999994,
							28.42110400000007
						],
						[
							-81.36683599999992,
							28.42110100000008
						],
						[
							-81.3683989999999,
							28.42110100000008
						],
						[
							-81.3683989999999,
							28.42133800000005
						],
						[
							-81.37117499999994,
							28.42133800000005
						],
						[
							-81.37130499999995,
							28.421308000000067
						],
						[
							-81.3712999999999,
							28.42138600000004
						],
						[
							-81.37144999999992,
							28.421388000000036
						],
						[
							-81.37237699999993,
							28.421372000000076
						],
						[
							-81.37256799999994,
							28.42137900000006
						],
						[
							-81.3727219999999,
							28.42137800000006
						],
						[
							-81.37339199999991,
							28.421384000000046
						],
						[
							-81.37578999999994,
							28.421384000000046
						],
						[
							-81.37579199999993,
							28.42488300000008
						],
						[
							-81.37579199999993,
							28.42528300000004
						],
						[
							-81.37579199999993,
							28.425684000000047
						],
						[
							-81.37579199999993,
							28.42648100000008
						],
						[
							-81.37579199999993,
							28.427383000000077
						],
						[
							-81.37579199999993,
							28.428383000000053
						],
						[
							-81.37579199999993,
							28.428682000000038
						],
						[
							-81.37579199999993,
							28.429383000000087
						],
						[
							-81.37579199999993,
							28.430383000000063
						],
						[
							-81.37579199999993,
							28.43138300000004
						],
						[
							-81.37579199999993,
							28.43228300000004
						],
						[
							-81.37579199999993,
							28.433183000000042
						],
						[
							-81.37579199999993,
							28.43398300000007
						],
						[
							-81.37579199999993,
							28.434483000000057
						],
						[
							-81.37579199999993,
							28.43600100000009
						],
						[
							-81.37330099999991,
							28.43605800000006
						],
						[
							-81.37239099999994,
							28.436070000000086
						],
						[
							-81.37139199999991,
							28.436083000000053
						],
						[
							-81.36819199999991,
							28.436083000000053
						],
						[
							-81.36749199999991,
							28.436083000000053
						],
						[
							-81.3650219999999,
							28.436115000000086
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Taft",
				"RegionID": "126350"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.16306267199978,
					26.173959000000053,
					-80.15459099999987,
					26.188340000000316
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-80.15459099999987,
								26.178741000000123
							],
							[
								-80.15463799999993,
								26.17695900000012
							],
							[
								-80.15500599999991,
								26.17641800000012
							],
							[
								-80.15489899999994,
								26.176367000000162
							],
							[
								-80.15585099999994,
								26.174652000000016
							],
							[
								-80.1562369999999,
								26.174811000000204
							],
							[
								-80.1561209999998,
								26.173959000000053
							],
							[
								-80.15718299999992,
								26.174090000000056
							],
							[
								-80.1578869999999,
								26.17421400000019
							],
							[
								-80.1563669999999,
								26.177761000000217
							],
							[
								-80.15646699999992,
								26.177861000000142
							],
							[
								-80.15759099999993,
								26.17816700000006
							],
							[
								-80.15736699999987,
								26.17876100000018
							],
							[
								-80.1562669999999,
								26.178361000000123
							],
							[
								-80.15526699999994,
								26.18096100000013
							],
							[
								-80.15486699999978,
								26.18096100000013
							],
							[
								-80.15459499999993,
								26.180893000000193
							],
							[
								-80.15469899999992,
								26.180473000000077
							],
							[
								-80.15466299999987,
								26.179939000000125
							],
							[
								-80.15459799999991,
								26.178993000000013
							],
							[
								-80.15459099999987,
								26.178741000000123
							]
						]
					],
					[
						[
							[
								-80.15561699999994,
								26.183632000000152
							],
							[
								-80.15558799999985,
								26.183232000000096
							],
							[
								-80.15520999999984,
								26.18324600000001
							],
							[
								-80.15517499999989,
								26.182839000000087
							],
							[
								-80.1563669999999,
								26.182759000000217
							],
							[
								-80.1563669999999,
								26.182661000000103
							],
							[
								-80.15647699999995,
								26.182661000000103
							],
							[
								-80.1564699999999,
								26.181961000000094
							],
							[
								-80.15645999999988,
								26.18096100000013
							],
							[
								-80.15656699999994,
								26.18096100000013
							],
							[
								-80.15731599999991,
								26.18096100000013
							],
							[
								-80.15806699999987,
								26.18096100000013
							],
							[
								-80.15856699999995,
								26.181061000000057
							],
							[
								-80.15896699999992,
								26.181261000000084
							],
							[
								-80.1600669999999,
								26.181261000000084
							],
							[
								-80.16276799999991,
								26.18166100000014
							],
							[
								-80.1629601349999,
								26.18169942700021
							],
							[
								-80.1629707229998,
								26.182980631000348
							],
							[
								-80.1629707229998,
								26.183762193000355
							],
							[
								-80.16306267199978,
								26.184589729000262
							],
							[
								-80.16220065499986,
								26.184670183000165
							],
							[
								-80.15916635699972,
								26.184796613000323
							],
							[
								-80.15920083799982,
								26.186037916000267
							],
							[
								-80.15920083799982,
								26.18608389100025
							],
							[
								-80.15824687299992,
								26.186095384000225
							],
							[
								-80.1582583659999,
								26.186543633000277
							],
							[
								-80.15816641799994,
								26.18664707500013
							],
							[
								-80.15820166499974,
								26.1883140440003
							],
							[
								-80.15784461799977,
								26.188325750000203
							],
							[
								-80.15759203199984,
								26.188334032000355
							],
							[
								-80.15740999999979,
								26.188340000000316
							],
							[
								-80.15705154299988,
								26.188340000000316
							],
							[
								-80.1568906329998,
								26.188340000000316
							],
							[
								-80.15675999999984,
								26.188340000000316
							],
							[
								-80.15636192999993,
								26.188340000000316
							],
							[
								-80.15581023899993,
								26.188340000000316
							],
							[
								-80.15556887399987,
								26.188340000000316
							],
							[
								-80.15533999999984,
								26.188340000000316
							],
							[
								-80.1553351709998,
								26.188175830000056
							],
							[
								-80.15532528399979,
								26.187899254000264
							],
							[
								-80.15532176512632,
								26.187846470476757
							],
							[
								-80.1554629999999,
								26.18780900000008
							],
							[
								-80.15546699999987,
								26.187361000000138
							],
							[
								-80.15536699999986,
								26.18546100000014
							],
							[
								-80.15536699999986,
								26.184661000000027
							],
							[
								-80.15526699999994,
								26.183761000000167
							],
							[
								-80.1552569999999,
								26.183662000000147
							],
							[
								-80.15561699999994,
								26.183632000000152
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Twinlakes",
				"RegionID": "126457"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.3673149999999,
					27.345898220000038,
					-80.30577099999994,
					27.40427500000004
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-80.36041799999992,
								27.39985400000006
							],
							[
								-80.36104399999994,
								27.399686000000088
							],
							[
								-80.36194399999994,
								27.399354000000073
							],
							[
								-80.36269199999992,
								27.39904100000007
							],
							[
								-80.3633779999999,
								27.39877400000006
							],
							[
								-80.36429399999992,
								27.398355000000038
							],
							[
								-80.36510299999992,
								27.397924000000046
							],
							[
								-80.36572799999995,
								27.39755800000006
							],
							[
								-80.3661249999999,
								27.397279000000083
							],
							[
								-80.3661249999999,
								27.397729000000087
							],
							[
								-80.36611899999991,
								27.397979000000078
							],
							[
								-80.36598399999991,
								27.397977000000083
							],
							[
								-80.36563899999993,
								27.397941000000063
							],
							[
								-80.3654009999999,
								27.39788200000004
							],
							[
								-80.3648169999999,
								27.398232000000064
							],
							[
								-80.36371699999995,
								27.398728000000062
							],
							[
								-80.36268999999993,
								27.399107000000072
							],
							[
								-80.36268999999993,
								27.39945000000006
							],
							[
								-80.36596999999995,
								27.399428000000057
							],
							[
								-80.36610599999995,
								27.399429000000055
							],
							[
								-80.3661249999999,
								27.399919000000068
							],
							[
								-80.3661249999999,
								27.400049000000084
							],
							[
								-80.3661249999999,
								27.40054400000008
							],
							[
								-80.36629299999994,
								27.40101700000008
							],
							[
								-80.36649099999994,
								27.401563000000067
							],
							[
								-80.36651299999994,
								27.40158800000006
							],
							[
								-80.36685699999992,
								27.40197900000004
							],
							[
								-80.36713199999991,
								27.402330000000063
							],
							[
								-80.36720799999995,
								27.402540000000045
							],
							[
								-80.3673149999999,
								27.402852000000053
							],
							[
								-80.36718799999994,
								27.402897000000053
							],
							[
								-80.36708099999993,
								27.402584000000047
							],
							[
								-80.36701499999992,
								27.402394000000076
							],
							[
								-80.3667529999999,
								27.402065000000054
							],
							[
								-80.36639899999994,
								27.401655000000062
							],
							[
								-80.36586699999994,
								27.402006000000085
							],
							[
								-80.36577599999993,
								27.400104000000056
							],
							[
								-80.36246299999993,
								27.400074000000075
							],
							[
								-80.36250799999993,
								27.401774000000046
							],
							[
								-80.3641189999999,
								27.40291200000007
							],
							[
								-80.3642559999999,
								27.40306300000009
							],
							[
								-80.36465299999993,
								27.403163000000063
							],
							[
								-80.36500499999994,
								27.403405000000078
							],
							[
								-80.36554899999993,
								27.403616000000056
							],
							[
								-80.36630999999994,
								27.40398900000008
							],
							[
								-80.36665899999991,
								27.404045000000053
							],
							[
								-80.36653699999994,
								27.40427500000004
							],
							[
								-80.36617099999995,
								27.404123000000084
							],
							[
								-80.36577399999993,
								27.403898000000083
							],
							[
								-80.36543799999993,
								27.40374500000007
							],
							[
								-80.36491899999993,
								27.40352800000005
							],
							[
								-80.3645229999999,
								27.403306000000043
							],
							[
								-80.36417199999994,
								27.403199000000086
							],
							[
								-80.36389699999995,
								27.40297800000008
							],
							[
								-80.36345499999993,
								27.40269600000005
							],
							[
								-80.3628599999999,
								27.402253000000087
							],
							[
								-80.36188299999993,
								27.40147500000006
							],
							[
								-80.36137899999994,
								27.40104400000007
							],
							[
								-80.3610129999999,
								27.40054400000008
							],
							[
								-80.36069299999991,
								27.400159000000087
							],
							[
								-80.36041799999992,
								27.39985400000006
							]
						]
					],
					[
						[
							[
								-80.3212049999999,
								27.400997000000075
							],
							[
								-80.32122299999992,
								27.400263000000052
							],
							[
								-80.32122499999991,
								27.400205000000085
							],
							[
								-80.32178799999991,
								27.400208000000077
							],
							[
								-80.32179799999994,
								27.400623000000053
							],
							[
								-80.32255299999991,
								27.40062000000006
							],
							[
								-80.32256599999994,
								27.400202000000036
							],
							[
								-80.32236999999992,
								27.400194000000056
							],
							[
								-80.32237099999993,
								27.40012500000006
							],
							[
								-80.32239099999993,
								27.399551000000088
							],
							[
								-80.32202999999993,
								27.399516000000062
							],
							[
								-80.32202999999993,
								27.400036000000057
							],
							[
								-80.32178699999992,
								27.400037000000054
							],
							[
								-80.3212289999999,
								27.400040000000047
							],
							[
								-80.32130499999994,
								27.39747300000005
							],
							[
								-80.3213209999999,
								27.39691100000005
							],
							[
								-80.32131399999992,
								27.39663100000007
							],
							[
								-80.32133199999993,
								27.39590300000009
							],
							[
								-80.3217679999999,
								27.39590700000008
							],
							[
								-80.32441599999993,
								27.395935000000065
							],
							[
								-80.3244259999999,
								27.396158000000074
							],
							[
								-80.3244259999999,
								27.396780000000035
							],
							[
								-80.32573599999995,
								27.396810000000073
							],
							[
								-80.32572899999991,
								27.396915000000035
							],
							[
								-80.32571899999994,
								27.39700600000009
							],
							[
								-80.3256879999999,
								27.397631000000047
							],
							[
								-80.32295499999992,
								27.39761100000004
							],
							[
								-80.32294299999995,
								27.39949900000005
							],
							[
								-80.32378199999994,
								27.399508000000083
							],
							[
								-80.3237949999999,
								27.39966300000009
							],
							[
								-80.3237949999999,
								27.40004300000004
							],
							[
								-80.32408599999991,
								27.400041000000044
							],
							[
								-80.3240879999999,
								27.400123000000065
							],
							[
								-80.32409899999993,
								27.400204000000087
							],
							[
								-80.32365199999992,
								27.40020000000004
							],
							[
								-80.32312499999995,
								27.400227000000086
							],
							[
								-80.32312499999995,
								27.40096900000009
							],
							[
								-80.3212049999999,
								27.400997000000075
							]
						]
					],
					[
						[
							[
								-80.33387199999993,
								27.39701800000006
							],
							[
								-80.3332969999999,
								27.397023000000047
							],
							[
								-80.33330299999994,
								27.39689800000008
							],
							[
								-80.33387199999993,
								27.396888000000047
							],
							[
								-80.33387199999993,
								27.39701800000006
							]
						]
					],
					[
						[
							[
								-80.32599499999992,
								27.39701400000007
							],
							[
								-80.32599999999991,
								27.39689100000004
							],
							[
								-80.3285449999999,
								27.396882000000062
							],
							[
								-80.3285449999999,
								27.397017000000062
							],
							[
								-80.32599499999992,
								27.39701400000007
							]
						]
					],
					[
						[
							[
								-80.34337199999995,
								27.396718000000078
							],
							[
								-80.34291499999995,
								27.396694000000082
							],
							[
								-80.33757199999991,
								27.396418000000043
							],
							[
								-80.33754399999992,
								27.392524000000037
							],
							[
								-80.33511399999992,
								27.392520000000047
							],
							[
								-80.33509499999991,
								27.39222600000005
							],
							[
								-80.33503799999994,
								27.392277000000036
							],
							[
								-80.33419499999991,
								27.39226000000008
							],
							[
								-80.33418599999993,
								27.39251900000005
							],
							[
								-80.33387199999993,
								27.392518000000052
							],
							[
								-80.33375399999994,
								27.392517000000055
							],
							[
								-80.33373399999994,
								27.393439000000058
							],
							[
								-80.33303799999993,
								27.39342300000004
							],
							[
								-80.33303799999993,
								27.39429300000006
							],
							[
								-80.33387199999993,
								27.394393000000036
							],
							[
								-80.33373899999992,
								27.394503000000043
							],
							[
								-80.33373299999994,
								27.394769000000053
							],
							[
								-80.32968599999992,
								27.394769000000053
							],
							[
								-80.32968099999994,
								27.39435500000008
							],
							[
								-80.32967999999995,
								27.394238000000087
							],
							[
								-80.32968699999992,
								27.393335000000036
							],
							[
								-80.3296939999999,
								27.39246600000007
							],
							[
								-80.3294909999999,
								27.392463000000077
							],
							[
								-80.32947899999994,
								27.391771000000062
							],
							[
								-80.32986199999993,
								27.391771000000062
							],
							[
								-80.32986899999992,
								27.391537000000085
							],
							[
								-80.3339069999999,
								27.391598000000045
							],
							[
								-80.33391999999992,
								27.39125800000005
							],
							[
								-80.33379899999994,
								27.39125800000005
							],
							[
								-80.33382499999993,
								27.390495000000044
							],
							[
								-80.33383199999992,
								27.39000400000009
							],
							[
								-80.33384199999995,
								27.38984300000004
							],
							[
								-80.33383999999995,
								27.389657000000057
							],
							[
								-80.33355799999993,
								27.389669000000083
							],
							[
								-80.33343699999995,
								27.389597000000037
							],
							[
								-80.33343899999994,
								27.389452000000063
							],
							[
								-80.33321699999993,
								27.389465000000087
							],
							[
								-80.33295299999992,
								27.389480000000052
							],
							[
								-80.33295399999992,
								27.389307000000088
							],
							[
								-80.33295599999991,
								27.389068000000066
							],
							[
								-80.33383499999991,
								27.389068000000066
							],
							[
								-80.3338369999999,
								27.387923000000058
							],
							[
								-80.3339719999999,
								27.387923000000058
							],
							[
								-80.33597199999991,
								27.38791800000007
							],
							[
								-80.33596899999992,
								27.387117000000046
							],
							[
								-80.33597199999991,
								27.386355000000037
							],
							[
								-80.33632699999993,
								27.386353000000042
							],
							[
								-80.33632699999993,
								27.386218000000042
							],
							[
								-80.33632699999993,
								27.385962000000063
							],
							[
								-80.33597199999991,
								27.385958000000073
							],
							[
								-80.33597199999991,
								27.386218000000042
							],
							[
								-80.33557399999995,
								27.386220000000037
							],
							[
								-80.33557399999995,
								27.385692000000063
							],
							[
								-80.33597199999991,
								27.385698000000048
							],
							[
								-80.33597199999991,
								27.38511800000009
							],
							[
								-80.33743499999991,
								27.38511800000009
							],
							[
								-80.33742599999994,
								27.38559000000004
							],
							[
								-80.33751499999994,
								27.385592000000088
							],
							[
								-80.33751899999993,
								27.385481000000084
							],
							[
								-80.33769199999995,
								27.385493000000054
							],
							[
								-80.3379109999999,
								27.38545300000004
							],
							[
								-80.33797199999992,
								27.38511800000009
							],
							[
								-80.3382949999999,
								27.38512000000009
							],
							[
								-80.33828799999992,
								27.385592000000088
							],
							[
								-80.33837599999993,
								27.38557700000007
							],
							[
								-80.33846199999994,
								27.38558100000006
							],
							[
								-80.33852799999994,
								27.385612000000037
							],
							[
								-80.33864599999993,
								27.385608000000047
							],
							[
								-80.33873499999993,
								27.385571000000084
							],
							[
								-80.33876199999992,
								27.38512300000008
							],
							[
								-80.33911199999994,
								27.385125000000073
							],
							[
								-80.3395109999999,
								27.384360000000072
							],
							[
								-80.33818599999995,
								27.384360000000072
							],
							[
								-80.33805499999994,
								27.384329000000037
							],
							[
								-80.33853699999992,
								27.38231600000006
							],
							[
								-80.33871299999993,
								27.38164900000004
							],
							[
								-80.33887199999994,
								27.381519000000083
							],
							[
								-80.3389019999999,
								27.380802000000074
							],
							[
								-80.33875999999992,
								27.380691000000073
							],
							[
								-80.33862399999992,
								27.380574000000085
							],
							[
								-80.33821399999994,
								27.380448000000058
							],
							[
								-80.33789499999995,
								27.380431000000044
							],
							[
								-80.33774299999993,
								27.380386000000044
							],
							[
								-80.33749999999992,
								27.38028200000008
							],
							[
								-80.33716599999991,
								27.38005300000009
							],
							[
								-80.3367869999999,
								27.379739000000086
							],
							[
								-80.33652299999994,
								27.379604000000086
							],
							[
								-80.33622999999994,
								27.37946500000004
							],
							[
								-80.33607299999994,
								27.37942400000009
							],
							[
								-80.33580099999995,
								27.37942000000004
							],
							[
								-80.33577799999995,
								27.381114000000082
							],
							[
								-80.33564899999993,
								27.381114000000082
							],
							[
								-80.33539699999994,
								27.381114000000082
							],
							[
								-80.33539699999994,
								27.380973000000044
							],
							[
								-80.3340869999999,
								27.380973000000044
							],
							[
								-80.3334089999999,
								27.380973000000044
							],
							[
								-80.33340599999991,
								27.380459000000087
							],
							[
								-80.33395999999993,
								27.380464000000075
							],
							[
								-80.3339729999999,
								27.38021400000008
							],
							[
								-80.3341079999999,
								27.380217000000073
							],
							[
								-80.33516299999991,
								27.38022300000006
							],
							[
								-80.33516799999991,
								27.379255000000057
							],
							[
								-80.33413599999994,
								27.379229000000066
							],
							[
								-80.33400099999994,
								27.379226000000074
							],
							[
								-80.33400699999993,
								27.37889800000005
							],
							[
								-80.33317199999993,
								27.37887100000006
							],
							[
								-80.33316599999995,
								27.37913400000008
							],
							[
								-80.33186899999993,
								27.379103000000043
							],
							[
								-80.33190399999995,
								27.378025000000036
							],
							[
								-80.33236599999992,
								27.378019000000055
							],
							[
								-80.3323959999999,
								27.37689400000005
							],
							[
								-80.3341999999999,
								27.37690500000008
							],
							[
								-80.3343349999999,
								27.37690800000007
							],
							[
								-80.33434199999994,
								27.37666500000006
							],
							[
								-80.33434999999992,
								27.37634600000007
							],
							[
								-80.33506799999992,
								27.376369000000068
							],
							[
								-80.33506799999992,
								27.37598600000007
							],
							[
								-80.33422599999994,
								27.375969000000055
							],
							[
								-80.33427199999994,
								27.37431900000007
							],
							[
								-80.33269399999995,
								27.374281000000053
							],
							[
								-80.3327329999999,
								27.375939000000074
							],
							[
								-80.33241199999992,
								27.375932000000034
							],
							[
								-80.33241599999991,
								27.37603500000006
							],
							[
								-80.32959699999992,
								27.375978000000092
							],
							[
								-80.32971499999991,
								27.37421900000004
							],
							[
								-80.32662399999992,
								27.37421900000004
							],
							[
								-80.32661299999995,
								27.373750000000086
							],
							[
								-80.32597199999992,
								27.37380600000006
							],
							[
								-80.32597199999992,
								27.369519000000082
							],
							[
								-80.32597199999992,
								27.368719000000056
							],
							[
								-80.32593199999991,
								27.365977000000044
							],
							[
								-80.32587199999995,
								27.36191900000006
							],
							[
								-80.32587199999995,
								27.358716000000072
							],
							[
								-80.32587199999995,
								27.35492000000005
							],
							[
								-80.32587199999995,
								27.35322000000008
							],
							[
								-80.32597199999992,
								27.352320000000077
							],
							[
								-80.3337719999999,
								27.352320000000077
							],
							[
								-80.33407199999994,
								27.352320000000077
							],
							[
								-80.33407199999994,
								27.352280000000064
							],
							[
								-80.3341299999999,
								27.352280000000064
							],
							[
								-80.33412599999991,
								27.35185000000007
							],
							[
								-80.33465599999994,
								27.35087100000004
							],
							[
								-80.33498299999991,
								27.350452000000075
							],
							[
								-80.3359989999999,
								27.349500000000035
							],
							[
								-80.33602899999994,
								27.348365000000058
							],
							[
								-80.33616699999993,
								27.347616000000073
							],
							[
								-80.3370339999999,
								27.34738600000009
							],
							[
								-80.33943199999993,
								27.34613900000005
							],
							[
								-80.33949799999994,
								27.346104000000082
							],
							[
								-80.3393969999999,
								27.345913000000056
							],
							[
								-80.33974785099991,
								27.345898220000038
							],
							[
								-80.34203359999992,
								27.34593499400006
							],
							[
								-80.34206699999993,
								27.348711000000037
							],
							[
								-80.3420682009999,
								27.348711561000073
							],
							[
								-80.34207199999992,
								27.349020000000053
							],
							[
								-80.34207199999992,
								27.350254000000064
							],
							[
								-80.34207199999992,
								27.352320000000077
							],
							[
								-80.34437199999991,
								27.352320000000077
							],
							[
								-80.34527199999991,
								27.352420000000052
							],
							[
								-80.3457719999999,
								27.352320000000077
							],
							[
								-80.3459719999999,
								27.352920000000044
							],
							[
								-80.34598899999992,
								27.35302800000005
							],
							[
								-80.34627199999994,
								27.354820000000075
							],
							[
								-80.3468719999999,
								27.358219000000076
							],
							[
								-80.34695899999991,
								27.358313000000066
							],
							[
								-80.34709114999994,
								27.359090301000037
							],
							[
								-80.3469839999999,
								27.359952000000078
							],
							[
								-80.34691399999991,
								27.360001000000068
							],
							[
								-80.34715599999993,
								27.36164000000008
							],
							[
								-80.34707199999991,
								27.362104000000045
							],
							[
								-80.34686599999992,
								27.36249900000007
							],
							[
								-80.34695942199994,
								27.362510907000058
							],
							[
								-80.34688399999993,
								27.36306200000007
							],
							[
								-80.34694690099991,
								27.363061928000036
							],
							[
								-80.34679099999995,
								27.36374900000004
							],
							[
								-80.34657699999991,
								27.364920000000044
							],
							[
								-80.34979699999991,
								27.365057000000036
							],
							[
								-80.34979699999991,
								27.366232000000082
							],
							[
								-80.34979699999991,
								27.366957000000074
							],
							[
								-80.35019399999993,
								27.367045000000076
							],
							[
								-80.35066699999993,
								27.36703300000005
							],
							[
								-80.35629299999994,
								27.36697500000008
							],
							[
								-80.35765111099994,
								27.366960695000046
							],
							[
								-80.35942509199992,
								27.366968986000074
							],
							[
								-80.35931999999991,
								27.370093000000054
							],
							[
								-80.3594389829999,
								27.37009727600008
							],
							[
								-80.35943899999995,
								27.370102000000088
							],
							[
								-80.36026599399992,
								27.37012736800006
							],
							[
								-80.36023499999993,
								27.372111000000075
							],
							[
								-80.3601129999999,
								27.37402600000007
							],
							[
								-80.36090599999994,
								27.373961000000065
							],
							[
								-80.36097220399995,
								27.373961492000035
							],
							[
								-80.36099499999996,
								27.374044000000083
							],
							[
								-80.3623869999999,
								27.374056557000074
							],
							[
								-80.3623869999999,
								27.374426000000085
							],
							[
								-80.36363799999992,
								27.37436100000008
							],
							[
								-80.3640959999999,
								27.37436900000006
							],
							[
								-80.3646139999999,
								27.37435400000004
							],
							[
								-80.3651789999999,
								27.37442200000004
							],
							[
								-80.3655599999999,
								27.374426000000085
							],
							[
								-80.3658959999999,
								27.374438000000055
							],
							[
								-80.3661249999999,
								27.374457000000067
							],
							[
								-80.36629299999994,
								27.37456700000007
							],
							[
								-80.36633299999994,
								27.37615500000004
							],
							[
								-80.36647599999992,
								27.381758000000048
							],
							[
								-80.36645499999992,
								27.385050000000035
							],
							[
								-80.3664379999999,
								27.38766300000009
							],
							[
								-80.36629299999994,
								27.387661000000037
							],
							[
								-80.36631899999992,
								27.385289000000057
							],
							[
								-80.36635199999995,
								27.385052000000087
							],
							[
								-80.36383999999993,
								27.38511200000005
							],
							[
								-80.36381699999993,
								27.384555000000034
							],
							[
								-80.36383999999993,
								27.383275000000083
							],
							[
								-80.36225899999994,
								27.383275000000083
							],
							[
								-80.36232099999995,
								27.382017000000076
							],
							[
								-80.35945599999991,
								27.381973000000073
							],
							[
								-80.35911699999991,
								27.38196700000009
							],
							[
								-80.35872499999994,
								27.382041000000072
							],
							[
								-80.35854599999993,
								27.382127000000082
							],
							[
								-80.35852399999993,
								27.388334000000043
							],
							[
								-80.35851999999994,
								27.388970000000086
							],
							[
								-80.35850999999991,
								27.38921000000005
							],
							[
								-80.3537869999999,
								27.38917300000009
							],
							[
								-80.35096199999992,
								27.38915000000009
							],
							[
								-80.3509479999999,
								27.38967800000006
							],
							[
								-80.35043499999995,
								27.38968600000004
							],
							[
								-80.35020999999996,
								27.39317900000009
							],
							[
								-80.35008999999991,
								27.39476300000007
							],
							[
								-80.34997199999992,
								27.39471800000007
							],
							[
								-80.34997199999992,
								27.395439000000067
							],
							[
								-80.34997199999992,
								27.396818000000053
							],
							[
								-80.34937199999992,
								27.396718000000078
							],
							[
								-80.34787199999994,
								27.396718000000078
							],
							[
								-80.34499399999993,
								27.396718000000078
							],
							[
								-80.34337199999995,
								27.396718000000078
							]
						]
					],
					[
						[
							[
								-80.36595099999994,
								27.394255000000044
							],
							[
								-80.36610499999995,
								27.393804000000046
							],
							[
								-80.36641099999991,
								27.39383100000009
							],
							[
								-80.3663689999999,
								27.39393700000005
							],
							[
								-80.36629299999994,
								27.394197000000077
							],
							[
								-80.36627499999992,
								27.394261000000085
							],
							[
								-80.36595099999994,
								27.394255000000044
							]
						]
					],
					[
						[
							[
								-80.32141499999994,
								27.392585000000054
							],
							[
								-80.32142899999991,
								27.39201200000008
							],
							[
								-80.3214309999999,
								27.391942000000085
							],
							[
								-80.3214109999999,
								27.391608000000076
							],
							[
								-80.32185499999993,
								27.391617000000053
							],
							[
								-80.3218599999999,
								27.392090000000053
							],
							[
								-80.32220599999994,
								27.392116000000044
							],
							[
								-80.3222209999999,
								27.391744000000074
							],
							[
								-80.32220599999994,
								27.39142400000009
							],
							[
								-80.3224229999999,
								27.391437000000053
							],
							[
								-80.3224229999999,
								27.391334000000086
							],
							[
								-80.32252999999992,
								27.391334000000086
							],
							[
								-80.32319499999994,
								27.39130900000004
							],
							[
								-80.32322399999993,
								27.39000800000008
							],
							[
								-80.3234819999999,
								27.389997000000054
							],
							[
								-80.32381499999991,
								27.389983000000086
							],
							[
								-80.32408599999991,
								27.38993700000009
							],
							[
								-80.3244259999999,
								27.38993700000009
							],
							[
								-80.32573599999995,
								27.389939000000084
							],
							[
								-80.32587699999993,
								27.389939000000084
							],
							[
								-80.32601599999992,
								27.389939000000084
							],
							[
								-80.32602899999995,
								27.390442000000064
							],
							[
								-80.32735599999995,
								27.390440000000073
							],
							[
								-80.32735599999995,
								27.390662000000077
							],
							[
								-80.32608599999992,
								27.390662000000077
							],
							[
								-80.32607399999995,
								27.391113000000075
							],
							[
								-80.32592199999993,
								27.391112000000078
							],
							[
								-80.32568299999991,
								27.39111100000008
							],
							[
								-80.32567299999994,
								27.391343000000063
							],
							[
								-80.32442199999991,
								27.391443000000038
							],
							[
								-80.32442199999991,
								27.391583000000082
							],
							[
								-80.32442199999991,
								27.391864000000055
							],
							[
								-80.3251699999999,
								27.391868000000045
							],
							[
								-80.32581899999991,
								27.39186600000005
							],
							[
								-80.32579099999992,
								27.39202300000005
							],
							[
								-80.3255069999999,
								27.39206400000006
							],
							[
								-80.3254849999999,
								27.392225000000053
							],
							[
								-80.32582499999995,
								27.392235000000085
							],
							[
								-80.32581999999991,
								27.392415000000085
							],
							[
								-80.32581999999991,
								27.39257100000009
							],
							[
								-80.32567399999994,
								27.392576000000076
							],
							[
								-80.32442199999991,
								27.39257900000007
							],
							[
								-80.32347699999991,
								27.392581000000064
							],
							[
								-80.3225149999999,
								27.39258300000006
							],
							[
								-80.32141499999994,
								27.392585000000054
							]
						]
					],
					[
						[
							[
								-80.36642999999994,
								27.39105900000004
							],
							[
								-80.36642999999994,
								27.391822000000047
							],
							[
								-80.36620399999993,
								27.391819000000055
							],
							[
								-80.36622699999992,
								27.391057000000046
							],
							[
								-80.36642999999994,
								27.39105900000004
							]
						]
					],
					[
						[
							[
								-80.36642999999994,
								27.389005000000054
							],
							[
								-80.36642999999994,
								27.389405000000068
							],
							[
								-80.36642999999994,
								27.38970500000005
							],
							[
								-80.36642999999994,
								27.389883000000054
							],
							[
								-80.36642999999994,
								27.39060100000006
							],
							[
								-80.3661699999999,
								27.39060100000006
							],
							[
								-80.36532799999992,
								27.39057500000007
							],
							[
								-80.3653139999999,
								27.39019600000006
							],
							[
								-80.36457199999995,
								27.390183000000036
							],
							[
								-80.36455999999993,
								27.389257000000043
							],
							[
								-80.36455699999995,
								27.388997000000074
							],
							[
								-80.36455699999995,
								27.388862000000074
							],
							[
								-80.3662809999999,
								27.38887600000004
							],
							[
								-80.36642999999994,
								27.389005000000054
							]
						]
					],
					[
						[
							[
								-80.33257399999991,
								27.390505000000076
							],
							[
								-80.33193699999993,
								27.389957000000038
							],
							[
								-80.33256099999994,
								27.38997200000006
							],
							[
								-80.33256099999994,
								27.38965200000007
							],
							[
								-80.33294999999993,
								27.389628000000073
							],
							[
								-80.33294599999994,
								27.389675000000068
							],
							[
								-80.33294399999994,
								27.38998200000009
							],
							[
								-80.3329349999999,
								27.390490000000057
							],
							[
								-80.33257399999991,
								27.390505000000076
							]
						]
					],
					[
						[
							[
								-80.32580499999995,
								27.38808700000004
							],
							[
								-80.32578599999994,
								27.38759900000008
							],
							[
								-80.32686899999995,
								27.387721000000056
							],
							[
								-80.32686999999993,
								27.38805300000007
							],
							[
								-80.32671899999991,
								27.38805300000007
							],
							[
								-80.32672799999996,
								27.388486000000057
							],
							[
								-80.32581699999992,
								27.38839100000007
							],
							[
								-80.32580499999995,
								27.38808700000004
							]
						]
					],
					[
						[
							[
								-80.31047099999995,
								27.37911900000006
							],
							[
								-80.31107399999992,
								27.378768000000036
							],
							[
								-80.31167099999993,
								27.378419000000065
							],
							[
								-80.31297099999995,
								27.37771900000007
							],
							[
								-80.31487099999993,
								27.376619000000062
							],
							[
								-80.31627099999992,
								27.375819000000035
							],
							[
								-80.31687199999993,
								27.37541900000008
							],
							[
								-80.31734999999992,
								27.37515300000007
							],
							[
								-80.31777199999993,
								27.37491900000009
							],
							[
								-80.31897199999992,
								27.37421900000004
							],
							[
								-80.31967199999991,
								27.37421900000004
							],
							[
								-80.32157199999995,
								27.37421900000004
							],
							[
								-80.32337199999995,
								27.37421900000004
							],
							[
								-80.32427199999995,
								27.37421900000004
							],
							[
								-80.32466899999991,
								27.37421900000004
							],
							[
								-80.32468799999992,
								27.374438000000055
							],
							[
								-80.32465799999994,
								27.375784000000067
							],
							[
								-80.32576099999994,
								27.37578700000006
							],
							[
								-80.32573999999994,
								27.376547000000073
							],
							[
								-80.3239519999999,
								27.376607000000035
							],
							[
								-80.32391899999995,
								27.37815900000004
							],
							[
								-80.32205599999992,
								27.37823300000008
							],
							[
								-80.32205199999993,
								27.38151400000004
							],
							[
								-80.32217199999991,
								27.381519000000083
							],
							[
								-80.32307199999991,
								27.381519000000083
							],
							[
								-80.3256189999999,
								27.381425000000036
							],
							[
								-80.3256439999999,
								27.380657000000042
							],
							[
								-80.32579299999992,
								27.38066100000009
							],
							[
								-80.32670499999995,
								27.38070600000009
							],
							[
								-80.32771899999995,
								27.38065000000006
							],
							[
								-80.3276679999999,
								27.379446000000087
							],
							[
								-80.3323069999999,
								27.379538000000082
							],
							[
								-80.33228699999995,
								27.380325000000084
							],
							[
								-80.33228699999995,
								27.38135900000009
							],
							[
								-80.3334089999999,
								27.381376000000046
							],
							[
								-80.33407599999992,
								27.381384000000082
							],
							[
								-80.33421299999992,
								27.381384000000082
							],
							[
								-80.33421299999992,
								27.381519000000083
							],
							[
								-80.3341769999999,
								27.382210000000043
							],
							[
								-80.33412799999991,
								27.382927000000052
							],
							[
								-80.3339939999999,
								27.38292000000007
							],
							[
								-80.3331179999999,
								27.382914000000085
							],
							[
								-80.33313299999992,
								27.382215000000087
							],
							[
								-80.3323059999999,
								27.382209000000046
							],
							[
								-80.33228699999995,
								27.38149800000008
							],
							[
								-80.33182899999991,
								27.381492000000037
							],
							[
								-80.3318559999999,
								27.383249000000035
							],
							[
								-80.33174799999995,
								27.383251000000087
							],
							[
								-80.33107399999994,
								27.383226000000036
							],
							[
								-80.33112499999993,
								27.381484000000057
							],
							[
								-80.32888899999995,
								27.38145700000007
							],
							[
								-80.32783799999993,
								27.381444000000045
							],
							[
								-80.32783899999993,
								27.381538000000035
							],
							[
								-80.32585599999993,
								27.381522000000075
							],
							[
								-80.32585199999994,
								27.38162200000005
							],
							[
								-80.32587599999994,
								27.38303300000007
							],
							[
								-80.32689199999993,
								27.38302800000008
							],
							[
								-80.32688599999994,
								27.38320500000009
							],
							[
								-80.32736699999992,
								27.383210000000076
							],
							[
								-80.32736099999994,
								27.383247000000043
							],
							[
								-80.32768499999992,
								27.383236000000068
							],
							[
								-80.32768599999991,
								27.385167000000084
							],
							[
								-80.32763499999993,
								27.385170000000073
							],
							[
								-80.32762599999995,
								27.385592000000088
							],
							[
								-80.3278039999999,
								27.385592000000088
							],
							[
								-80.32781299999994,
								27.385159000000044
							],
							[
								-80.32817599999993,
								27.385136000000045
							],
							[
								-80.32817599999993,
								27.385343000000034
							],
							[
								-80.32847199999992,
								27.385343000000034
							],
							[
								-80.3285899999999,
								27.385343000000034
							],
							[
								-80.32857699999994,
								27.385852000000057
							],
							[
								-80.3286609999999,
								27.385849000000064
							],
							[
								-80.32873999999993,
								27.385853000000054
							],
							[
								-80.32873999999993,
								27.38743000000005
							],
							[
								-80.32847199999992,
								27.387411000000043
							],
							[
								-80.32577199999992,
								27.387218000000075
							],
							[
								-80.32577199999992,
								27.386494000000084
							],
							[
								-80.32527399999992,
								27.38643300000007
							],
							[
								-80.32398199999994,
								27.386449000000084
							],
							[
								-80.32392199999992,
								27.386137000000076
							],
							[
								-80.3239309999999,
								27.385355000000065
							],
							[
								-80.32392199999992,
								27.38511800000009
							],
							[
								-80.32293799999991,
								27.38511800000009
							],
							[
								-80.3230059999999,
								27.385559000000057
							],
							[
								-80.32298099999993,
								27.385878000000048
							],
							[
								-80.32298899999995,
								27.386493000000087
							],
							[
								-80.32156099999992,
								27.38650800000005
							],
							[
								-80.3215439999999,
								27.388431000000082
							],
							[
								-80.32004199999994,
								27.388402000000045
							],
							[
								-80.3174229999999,
								27.388386000000082
							],
							[
								-80.31739299999992,
								27.388386000000082
							],
							[
								-80.31725799999992,
								27.388386000000082
							],
							[
								-80.31729299999995,
								27.385197000000062
							],
							[
								-80.31728399999992,
								27.38474700000006
							],
							[
								-80.31729799999994,
								27.383181000000036
							],
							[
								-80.31743299999994,
								27.38318200000009
							],
							[
								-80.31960299999992,
								27.38318200000009
							],
							[
								-80.31960299999992,
								27.382043000000067
							],
							[
								-80.31912799999992,
								27.382043000000067
							],
							[
								-80.31912799999992,
								27.381559000000042
							],
							[
								-80.31853699999994,
								27.38155400000005
							],
							[
								-80.31853699999994,
								27.381419000000054
							],
							[
								-80.31854399999992,
								27.381124000000057
							],
							[
								-80.31824899999992,
								27.381124000000057
							],
							[
								-80.31824899999992,
								27.381419000000054
							],
							[
								-80.31824899999992,
								27.38155400000005
							],
							[
								-80.31777199999993,
								27.38155400000005
							],
							[
								-80.31745499999994,
								27.38156000000004
							],
							[
								-80.3167719999999,
								27.38155400000005
							],
							[
								-80.3163429999999,
								27.38155400000005
							],
							[
								-80.3163429999999,
								27.381419000000054
							],
							[
								-80.3163429999999,
								27.38074400000005
							],
							[
								-80.31593399999991,
								27.38073600000007
							],
							[
								-80.31527099999994,
								27.380723000000046
							],
							[
								-80.31527099999994,
								27.38053300000007
							],
							[
								-80.31513799999993,
								27.380532000000073
							],
							[
								-80.3144309999999,
								27.380525000000095
							],
							[
								-80.3144309999999,
								27.380753000000084
							],
							[
								-80.31480299999993,
								27.380753000000084
							],
							[
								-80.31480299999993,
								27.381419000000054
							],
							[
								-80.31468999999993,
								27.381419000000054
							],
							[
								-80.31430199999994,
								27.381419000000054
							],
							[
								-80.31377099999992,
								27.381419000000054
							],
							[
								-80.31297199999995,
								27.381419000000054
							],
							[
								-80.31294099999991,
								27.380653000000052
							],
							[
								-80.31251399999991,
								27.380668000000075
							],
							[
								-80.31254999999993,
								27.381419000000054
							],
							[
								-80.3122709999999,
								27.381419000000054
							],
							[
								-80.31213699999995,
								27.381419000000054
							],
							[
								-80.31210699999991,
								27.380757000000074
							],
							[
								-80.3118839999999,
								27.38077100000004
							],
							[
								-80.3114819999999,
								27.38077100000004
							],
							[
								-80.3114819999999,
								27.379328000000044
							],
							[
								-80.31115899999992,
								27.378884000000085
							],
							[
								-80.3106019999999,
								27.379196000000036
							],
							[
								-80.31047099999995,
								27.37911900000006
							]
						],
						[
							[
								-80.31957199999994,
								27.380602000000067
							],
							[
								-80.31957199999994,
								27.381419000000054
							],
							[
								-80.32141499999994,
								27.381490000000046
							],
							[
								-80.32143299999991,
								27.379819000000055
							],
							[
								-80.31957199999994,
								27.379819000000055
							],
							[
								-80.31777199999993,
								27.37979500000006
							],
							[
								-80.31777199999993,
								27.379928000000064
							],
							[
								-80.31777199999993,
								27.38056400000005
							],
							[
								-80.31777199999993,
								27.38066400000008
							],
							[
								-80.31848999999994,
								27.38057800000007
							],
							[
								-80.31957199999994,
								27.380602000000067
							]
						]
					],
					[
						[
							[
								-80.33353999999991,
								27.38554600000009
							],
							[
								-80.33354099999991,
								27.38567400000005
							],
							[
								-80.3339719999999,
								27.38567400000005
							],
							[
								-80.3339719999999,
								27.386123000000055
							],
							[
								-80.3338369999999,
								27.386123000000055
							],
							[
								-80.33384799999993,
								27.386400000000037
							],
							[
								-80.3336369999999,
								27.386400000000037
							],
							[
								-80.3336369999999,
								27.386703000000068
							],
							[
								-80.33297099999993,
								27.386709000000053
							],
							[
								-80.33297199999993,
								27.386618000000055
							],
							[
								-80.33297199999993,
								27.38554600000009
							],
							[
								-80.33353999999991,
								27.38554600000009
							]
						]
					],
					[
						[
							[
								-80.33436599999993,
								27.386120000000062
							],
							[
								-80.33438099999995,
								27.38567400000005
							],
							[
								-80.3345369999999,
								27.38567400000005
							],
							[
								-80.3345369999999,
								27.38525800000008
							],
							[
								-80.33484399999992,
								27.38525800000008
							],
							[
								-80.33484399999992,
								27.385529000000076
							],
							[
								-80.3350549999999,
								27.385529000000076
							],
							[
								-80.3350549999999,
								27.385717000000056
							],
							[
								-80.33524599999993,
								27.385717000000056
							],
							[
								-80.3352329999999,
								27.386114000000077
							],
							[
								-80.33436599999993,
								27.386120000000062
							]
						]
					],
					[
						[
							[
								-80.33144099999993,
								27.385605000000055
							],
							[
								-80.33141299999994,
								27.38525300000009
							],
							[
								-80.33175199999994,
								27.385256000000084
							],
							[
								-80.33175099999994,
								27.38557300000008
							],
							[
								-80.33144099999993,
								27.385605000000055
							]
						]
					],
					[
						[
							[
								-80.33353999999991,
								27.38554600000009
							],
							[
								-80.33353699999992,
								27.385260000000077
							],
							[
								-80.33297199999993,
								27.38525700000008
							],
							[
								-80.33297199999993,
								27.38511800000009
							],
							[
								-80.33353499999993,
								27.38511800000009
							],
							[
								-80.3339719999999,
								27.38511800000009
							],
							[
								-80.3339719999999,
								27.385538000000054
							],
							[
								-80.33353999999991,
								27.38554600000009
							]
						]
					],
					[
						[
							[
								-80.3290629999999,
								27.383229000000085
							],
							[
								-80.32977799999993,
								27.383191000000068
							],
							[
								-80.3297619999999,
								27.38387800000004
							],
							[
								-80.3297639999999,
								27.38511800000009
							],
							[
								-80.32976499999995,
								27.385249000000044
							],
							[
								-80.3290629999999,
								27.38525300000009
							],
							[
								-80.3290629999999,
								27.38511800000009
							],
							[
								-80.3290629999999,
								27.383229000000085
							]
						]
					],
					[
						[
							[
								-80.33033999999992,
								27.384605000000082
							],
							[
								-80.33029499999992,
								27.38387800000004
							],
							[
								-80.33000199999992,
								27.38387800000004
							],
							[
								-80.33005099999991,
								27.383236000000068
							],
							[
								-80.33075699999995,
								27.383229000000085
							],
							[
								-80.33075799999995,
								27.38358700000009
							],
							[
								-80.33027599999991,
								27.383598000000067
							],
							[
								-80.3302809999999,
								27.383667000000063
							],
							[
								-80.33075899999996,
								27.383651000000043
							],
							[
								-80.33076299999995,
								27.38421800000009
							],
							[
								-80.3308879999999,
								27.38422200000008
							],
							[
								-80.33089899999993,
								27.38452300000006
							],
							[
								-80.33055599999994,
								27.384512000000086
							],
							[
								-80.33055599999994,
								27.384603000000087
							],
							[
								-80.33033999999992,
								27.384605000000082
							]
						]
					],
					[
						[
							[
								-80.30583499999995,
								27.38141500000006
							],
							[
								-80.30577099999994,
								27.381319000000076
							],
							[
								-80.30585899999994,
								27.38129500000008
							],
							[
								-80.3072709999999,
								27.380919000000063
							],
							[
								-80.30827099999993,
								27.380419000000074
							],
							[
								-80.30917099999994,
								27.379919000000086
							],
							[
								-80.31047099999995,
								27.37911900000006
							],
							[
								-80.31034799999992,
								27.37932500000005
							],
							[
								-80.30923599999994,
								27.380037000000073
							],
							[
								-80.30833099999995,
								27.380539000000056
							],
							[
								-80.30746599999992,
								27.380993000000046
							],
							[
								-80.30764299999993,
								27.381310000000042
							],
							[
								-80.30757099999994,
								27.381419000000054
							],
							[
								-80.30682899999994,
								27.381379000000038
							],
							[
								-80.30583499999995,
								27.38141500000006
							]
						]
					],
					[
						[
							[
								-80.32508399999995,
								27.37752900000004
							],
							[
								-80.32572499999992,
								27.37751700000007
							],
							[
								-80.32572499999992,
								27.37818100000004
							],
							[
								-80.32506699999993,
								27.37818100000004
							],
							[
								-80.32508399999995,
								27.37752900000004
							]
						]
					],
					[
						[
							[
								-80.33369299999993,
								27.376647000000048
							],
							[
								-80.33369299999993,
								27.376325000000065
							],
							[
								-80.33407199999994,
								27.376337000000035
							],
							[
								-80.3340839999999,
								27.376658000000077
							],
							[
								-80.33369299999993,
								27.376647000000048
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Saint Lucie",
				"City": "Fort Pierce",
				"Name": "White City",
				"RegionID": "126639"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.579339,
					27.392719,
					-82.554947,
					27.42524
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.559569,
							27.425155
						],
						[
							-82.559589,
							27.422264
						],
						[
							-82.559576,
							27.422128
						],
						[
							-82.559557,
							27.422079
						],
						[
							-82.559528,
							27.422036
						],
						[
							-82.559475,
							27.421995
						],
						[
							-82.559413,
							27.421967
						],
						[
							-82.559232,
							27.421947
						],
						[
							-82.558628,
							27.421938
						],
						[
							-82.554967,
							27.421918
						],
						[
							-82.55496289899997,
							27.420772274000058
						],
						[
							-82.554962,
							27.420521
						],
						[
							-82.554959,
							27.420294
						],
						[
							-82.554957,
							27.419356
						],
						[
							-82.554955,
							27.418395
						],
						[
							-82.55498700000001,
							27.417932
						],
						[
							-82.554965,
							27.417356
						],
						[
							-82.554947,
							27.415937
						],
						[
							-82.554968,
							27.414958
						],
						[
							-82.55498700000001,
							27.414697
						],
						[
							-82.555022,
							27.414422
						],
						[
							-82.555038,
							27.4143
						],
						[
							-82.555038,
							27.414223
						],
						[
							-82.555045,
							27.413303
						],
						[
							-82.55505,
							27.412974
						],
						[
							-82.555045,
							27.4124
						],
						[
							-82.555047,
							27.411493
						],
						[
							-82.555049,
							27.41063
						],
						[
							-82.555047,
							27.409808
						],
						[
							-82.555053,
							27.409123
						],
						[
							-82.558572,
							27.409239
						],
						[
							-82.559541,
							27.409318
						],
						[
							-82.560121,
							27.409262
						],
						[
							-82.560729,
							27.409174
						],
						[
							-82.561001,
							27.409139
						],
						[
							-82.561145,
							27.409003
						],
						[
							-82.56148,
							27.408608
						],
						[
							-82.561909,
							27.407981
						],
						[
							-82.562251,
							27.407674
						],
						[
							-82.562332,
							27.407623000000005
						],
						[
							-82.563163,
							27.407625000000003
						],
						[
							-82.566789,
							27.40762
						],
						[
							-82.566918,
							27.407614
						],
						[
							-82.567438,
							27.407562
						],
						[
							-82.567614,
							27.407552
						],
						[
							-82.567817,
							27.407547
						],
						[
							-82.567816,
							27.407423
						],
						[
							-82.567827,
							27.406534
						],
						[
							-82.567834,
							27.406311
						],
						[
							-82.56785,
							27.40616
						],
						[
							-82.567873,
							27.406024
						],
						[
							-82.567908,
							27.405878
						],
						[
							-82.567962,
							27.405699
						],
						[
							-82.567995,
							27.405608000000004
						],
						[
							-82.568042,
							27.405515
						],
						[
							-82.568095,
							27.405428
						],
						[
							-82.56818,
							27.405303
						],
						[
							-82.567352,
							27.403893
						],
						[
							-82.5672,
							27.403669
						],
						[
							-82.567011,
							27.403394
						],
						[
							-82.566821,
							27.40312
						],
						[
							-82.566386,
							27.402488000000005
						],
						[
							-82.56567800000002,
							27.401465
						],
						[
							-82.564816,
							27.400213
						],
						[
							-82.564593,
							27.399878
						],
						[
							-82.564262,
							27.399418
						],
						[
							-82.564104,
							27.399167
						],
						[
							-82.563986,
							27.398952
						],
						[
							-82.563849,
							27.398663
						],
						[
							-82.563738,
							27.398386
						],
						[
							-82.563633,
							27.398056
						],
						[
							-82.563549,
							27.397726000000002
						],
						[
							-82.563505,
							27.397514
						],
						[
							-82.56345,
							27.397201
						],
						[
							-82.563345,
							27.396772000000002
						],
						[
							-82.563261,
							27.396496
						],
						[
							-82.56771500000002,
							27.396484
						],
						[
							-82.567606,
							27.396116
						],
						[
							-82.567219,
							27.394991
						],
						[
							-82.567149,
							27.394748
						],
						[
							-82.566769,
							27.393645
						],
						[
							-82.566649,
							27.393346
						],
						[
							-82.566623,
							27.3933
						],
						[
							-82.566555,
							27.392964
						],
						[
							-82.568234,
							27.392719
						],
						[
							-82.568315,
							27.392936
						],
						[
							-82.56821306099994,
							27.39320824500004
						],
						[
							-82.56816685299998,
							27.393444420000037
						],
						[
							-82.568534,
							27.39466
						],
						[
							-82.568556,
							27.394751
						],
						[
							-82.568941,
							27.395805
						],
						[
							-82.569124,
							27.396364
						],
						[
							-82.569103,
							27.396462
						],
						[
							-82.569232,
							27.397201
						],
						[
							-82.569377,
							27.397537
						],
						[
							-82.569483,
							27.397816
						],
						[
							-82.569871,
							27.398513
						],
						[
							-82.570063,
							27.398982
						],
						[
							-82.570068,
							27.39915
						],
						[
							-82.570211,
							27.3997
						],
						[
							-82.57024069599998,
							27.399873934000027
						],
						[
							-82.57037980899997,
							27.400204372000076
						],
						[
							-82.570526,
							27.400344000000004
						],
						[
							-82.570783,
							27.400941
						],
						[
							-82.570828,
							27.401023
						],
						[
							-82.571161,
							27.401724
						],
						[
							-82.571613,
							27.402602
						],
						[
							-82.57187262999997,
							27.403087396000046
						],
						[
							-82.57213256599994,
							27.40343693800003
						],
						[
							-82.57213956399994,
							27.403446349000035
						],
						[
							-82.572171842,
							27.403489754000077
						],
						[
							-82.572429,
							27.403699
						],
						[
							-82.57248538299996,
							27.403912897000055
						],
						[
							-82.57251310499998,
							27.403950311000074
						],
						[
							-82.57266025799998,
							27.404035823000072
						],
						[
							-82.57309161599994,
							27.404664577000062
						],
						[
							-82.57330655799996,
							27.404976745000056
						],
						[
							-82.573349,
							27.404983
						],
						[
							-82.57362853299998,
							27.40537921500004
						],
						[
							-82.574319,
							27.406159
						],
						[
							-82.57495400000002,
							27.406827
						],
						[
							-82.575461,
							27.407223
						],
						[
							-82.575581,
							27.407317
						],
						[
							-82.576539,
							27.408232
						],
						[
							-82.576642,
							27.40833
						],
						[
							-82.57676439999994,
							27.40848184500004
						],
						[
							-82.57699769699997,
							27.408616124000048
						],
						[
							-82.577028,
							27.408621000000004
						],
						[
							-82.577309,
							27.408754
						],
						[
							-82.577626,
							27.408931
						],
						[
							-82.577714524,
							27.40902076200007
						],
						[
							-82.577746,
							27.409051
						],
						[
							-82.57813,
							27.409421
						],
						[
							-82.57815455099995,
							27.409468410000045
						],
						[
							-82.578163,
							27.409477
						],
						[
							-82.578329,
							27.409792
						],
						[
							-82.578464,
							27.410006
						],
						[
							-82.578658,
							27.410242
						],
						[
							-82.57871900000002,
							27.410377
						],
						[
							-82.57881300000001,
							27.410582
						],
						[
							-82.57886716299998,
							27.410792795000077
						],
						[
							-82.578887,
							27.41087
						],
						[
							-82.57890533999995,
							27.410907128000076
						],
						[
							-82.57892398899997,
							27.410942440000042
						],
						[
							-82.578994,
							27.411075
						],
						[
							-82.579044,
							27.411328000000005
						],
						[
							-82.579053,
							27.411374
						],
						[
							-82.57904893799997,
							27.41148975700003
						],
						[
							-82.57909,
							27.411672
						],
						[
							-82.57915515799993,
							27.411966092000057
						],
						[
							-82.57916403499996,
							27.412005992000047
						],
						[
							-82.579158,
							27.412507
						],
						[
							-82.579223,
							27.412651
						],
						[
							-82.579199,
							27.412711
						],
						[
							-82.579339,
							27.412786
						],
						[
							-82.578829,
							27.413037
						],
						[
							-82.57873135299997,
							27.413041650000025
						],
						[
							-82.578724,
							27.413042
						],
						[
							-82.57724352499997,
							27.413667450000048
						],
						[
							-82.57679,
							27.41368
						],
						[
							-82.576688,
							27.413812
						],
						[
							-82.576395,
							27.413918
						],
						[
							-82.576368,
							27.41413
						],
						[
							-82.576148,
							27.414255
						],
						[
							-82.57625600000001,
							27.414617
						],
						[
							-82.576028,
							27.414629
						],
						[
							-82.575885,
							27.414363
						],
						[
							-82.575745,
							27.414446000000005
						],
						[
							-82.57599800000001,
							27.414905
						],
						[
							-82.57595,
							27.415075000000005
						],
						[
							-82.574643,
							27.416212
						],
						[
							-82.574559,
							27.416284
						],
						[
							-82.574529,
							27.416313
						],
						[
							-82.57448623399995,
							27.41634135000004
						],
						[
							-82.572521,
							27.417656
						],
						[
							-82.572213,
							27.417621
						],
						[
							-82.571468,
							27.41754
						],
						[
							-82.57122891899996,
							27.417536878000078
						],
						[
							-82.56984797099994,
							27.417410317000076
						],
						[
							-82.569821,
							27.417408
						],
						[
							-82.56900254199996,
							27.41785779500003
						],
						[
							-82.56888313799999,
							27.417923251000047
						],
						[
							-82.56876039799994,
							27.41799086900005
						],
						[
							-82.56798500000001,
							27.418417
						],
						[
							-82.56702,
							27.41882
						],
						[
							-82.566055,
							27.418433000000004
						],
						[
							-82.565461,
							27.418422
						],
						[
							-82.565119,
							27.418519000000003
						],
						[
							-82.564677,
							27.418751
						],
						[
							-82.564795,
							27.419271
						],
						[
							-82.564782,
							27.419603000000002
						],
						[
							-82.564403,
							27.420472
						],
						[
							-82.56359997399994,
							27.421598646000064
						],
						[
							-82.563492,
							27.421737
						],
						[
							-82.563441,
							27.421811000000005
						],
						[
							-82.563403,
							27.421875
						],
						[
							-82.563378,
							27.421935
						],
						[
							-82.563362,
							27.422008
						],
						[
							-82.56328885499994,
							27.42231344700008
						],
						[
							-82.562611,
							27.422298
						],
						[
							-82.562592,
							27.422653
						],
						[
							-82.56131,
							27.425091
						],
						[
							-82.561272,
							27.425148000000004
						],
						[
							-82.561217,
							27.425197
						],
						[
							-82.561159,
							27.425225
						],
						[
							-82.561072,
							27.425239
						],
						[
							-82.559666,
							27.42524
						],
						[
							-82.559569,
							27.425155
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Manatee",
				"City": "Sarasota",
				"Name": "Whitfield",
				"RegionID": "126648"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.45365908793451,
					27.965300075339734,
					-82.44281804775508,
					27.981800133562935
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.4428181682642,
							27.96534634545823
						],
						[
							-82.44931836446993,
							27.965300075339734
						],
						[
							-82.45113636553589,
							27.965490910575085
						],
						[
							-82.45251824847766,
							27.96589988536183
						],
						[
							-82.4532183311073,
							27.966499909422488
						],
						[
							-82.45360452516768,
							27.968159985043457
						],
						[
							-82.45365908793451,
							27.981800000463274
						],
						[
							-82.45363637645603,
							27.981800000463274
						],
						[
							-82.44281804775508,
							27.981800133562935
						],
						[
							-82.44281818175403,
							27.97076284063221
						],
						[
							-82.4428181682642,
							27.96534634545823
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Ybor City",
				"RegionID": "126709"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.24525870099997,
					25.92645929100007,
					-80.22844319499995,
					25.941538018000074
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.22844319499995,
							25.92684954400005
						],
						[
							-80.22850822599997,
							25.926847318000057
						],
						[
							-80.23198693599994,
							25.926752017000073
						],
						[
							-80.24179623699996,
							25.926524615000062
						],
						[
							-80.24461407999996,
							25.92645929100007
						],
						[
							-80.24476957699994,
							25.93115583100007
						],
						[
							-80.24493632399998,
							25.933534749000046
						],
						[
							-80.24491409099994,
							25.93369920700008
						],
						[
							-80.24520311899994,
							25.937258757000052
						],
						[
							-80.24525870099997,
							25.939737723000064
						],
						[
							-80.24525795299996,
							25.940557239000043
						],
						[
							-80.24525771499998,
							25.940817448000075
						],
						[
							-80.24525768499996,
							25.940850478000073
						],
						[
							-80.24525765999994,
							25.940877768000068
						],
						[
							-80.24479337099997,
							25.940916853000033
						],
						[
							-80.24461572699994,
							25.940927603000038
						],
						[
							-80.24446190399993,
							25.940932350000026
						],
						[
							-80.24337985099999,
							25.941007697000032
						],
						[
							-80.24130438199995,
							25.941115663000065
						],
						[
							-80.23965317599999,
							25.941213167000058
						],
						[
							-80.23188911299997,
							25.94146386500006
						],
						[
							-80.23082887399994,
							25.941487893000044
						],
						[
							-80.22973606699999,
							25.941512659000068
						],
						[
							-80.22928684699997,
							25.941538018000074
						],
						[
							-80.22912691299996,
							25.93827350400005
						],
						[
							-80.22895294599994,
							25.934968122000043
						],
						[
							-80.22874418499998,
							25.93264855600006
						],
						[
							-80.228663,
							25.930468164000047
						],
						[
							-80.228465837,
							25.92749911900006
						],
						[
							-80.22844319499995,
							25.92684954400005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Gardens",
				"Name": "Parkview",
				"RegionID": "135204"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.33793391799998,
					28.832943845000045,
					-82.32055996699995,
					28.84261576100005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.33791882099996,
							28.836064576000073
						],
						[
							-82.33787353599996,
							28.837777097000075
						],
						[
							-82.33793391799998,
							28.83809398300008
						],
						[
							-82.33786236299994,
							28.838199618000033
						],
						[
							-82.33786051599998,
							28.838735963000037
						],
						[
							-82.33785957499998,
							28.83900935300005
						],
						[
							-82.33785388899997,
							28.84066067900005
						],
						[
							-82.33718763999997,
							28.840622608000047
						],
						[
							-82.33684975699998,
							28.840751099000045
						],
						[
							-82.33669271199994,
							28.84088434900008
						],
						[
							-82.33633579299999,
							28.84098904500007
						],
						[
							-82.33594080299999,
							28.840898625000076
						],
						[
							-82.33491547799999,
							28.84148411800004
						],
						[
							-82.33447505499998,
							28.84171716000003
						],
						[
							-82.33408378799999,
							28.84186587700003
						],
						[
							-82.33404970299995,
							28.841961317000028
						],
						[
							-82.33345661299995,
							28.842206734000058
						],
						[
							-82.33328618399997,
							28.84224763700007
						],
						[
							-82.33329300199995,
							28.84241124800008
						],
						[
							-82.33327254999995,
							28.84261576100005
						],
						[
							-82.33018439099999,
							28.84047518300002
						],
						[
							-82.32849308999994,
							28.839309145000072
						],
						[
							-82.32687981499998,
							28.839623234000047
						],
						[
							-82.32609459299994,
							28.838823735000066
						],
						[
							-82.32549972799995,
							28.83859054800007
						],
						[
							-82.32512377299997,
							28.83847157500003
						],
						[
							-82.32504287099995,
							28.838052790000066
						],
						[
							-82.32504762999997,
							28.837971888000027
						],
						[
							-82.32495721099997,
							28.837581657000047
						],
						[
							-82.32406729199994,
							28.837362746000057
						],
						[
							-82.32326779299996,
							28.837058175000035
						],
						[
							-82.32278238299996,
							28.83693920200005
						],
						[
							-82.32232076799994,
							28.836839265000037
						],
						[
							-82.32184963499998,
							28.836772640000053
						],
						[
							-82.32110248399994,
							28.836986791000072
						],
						[
							-82.32055996699995,
							28.836101632000066
						],
						[
							-82.32081123799998,
							28.835021357000077
						],
						[
							-82.32136136899999,
							28.834360818000054
						],
						[
							-82.32183787099996,
							28.834110219000024
						],
						[
							-82.32187452899996,
							28.83368365900003
						],
						[
							-82.32346270199997,
							28.83338536900004
						],
						[
							-82.32577370899998,
							28.83296952500007
						],
						[
							-82.32595183999996,
							28.832943845000045
						],
						[
							-82.32618844699994,
							28.83296550600005
						],
						[
							-82.32637839899998,
							28.833000497000057
						],
						[
							-82.32673492399994,
							28.833133136000068
						],
						[
							-82.33001396299994,
							28.83532825100008
						],
						[
							-82.33038739399996,
							28.835474877000028
						],
						[
							-82.33081156699996,
							28.835512313000034
						],
						[
							-82.33140880399998,
							28.83554319300004
						],
						[
							-82.33182371599997,
							28.835618856000053
						],
						[
							-82.33247187099994,
							28.835968086000033
						],
						[
							-82.33280845299998,
							28.836046400000043
						],
						[
							-82.33791882099996,
							28.836064576000073
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Citrus",
				"City": "Inverness",
				"Name": "Tompkinsville",
				"RegionID": "150162"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.93396207099994,
					29.025814564000026,
					-80.92182552699995,
					29.04233579700008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.92741440499998,
							29.03578926500006
						],
						[
							-80.92675957799997,
							29.034205496000027
						],
						[
							-80.92583063599996,
							29.032743555000025
						],
						[
							-80.92477986599994,
							29.031738470000054
						],
						[
							-80.92420118099994,
							29.031190243000026
						],
						[
							-80.92372909599999,
							29.030428815000054
						],
						[
							-80.92316563999998,
							29.029652159000083
						],
						[
							-80.92229761199997,
							29.028647075000038
						],
						[
							-80.92182552699995,
							29.02815976100004
						],
						[
							-80.92214342299997,
							29.027855190000025
						],
						[
							-80.92735158699998,
							29.025814564000026
						],
						[
							-80.92826786199998,
							29.02800097200003
						],
						[
							-80.92834019799994,
							29.029356503000034
						],
						[
							-80.92853055499995,
							29.03021691600003
						],
						[
							-80.92885796899998,
							29.03095550100005
						],
						[
							-80.93365496199993,
							29.040077403000055
						],
						[
							-80.93393668999994,
							29.040861673000055
						],
						[
							-80.93396207099994,
							29.04168096900003
						],
						[
							-80.93228693099996,
							29.04233579700008
						],
						[
							-80.93153990699994,
							29.04138553500007
						],
						[
							-80.93111731399995,
							29.040437558000068
						],
						[
							-80.93064903699997,
							29.039843644000033
						],
						[
							-80.92954115999999,
							29.03895277400005
						],
						[
							-80.92868455399997,
							29.037959111000077
						],
						[
							-80.92823911799996,
							29.03693118400003
						],
						[
							-80.92780510499995,
							29.036280164000058
						],
						[
							-80.92741440499998,
							29.03578926500006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Volusia",
				"City": "New Smyrna Beach",
				"Name": "Faulkner",
				"RegionID": "158466"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.79322546499998,
					24.55616412100005,
					-81.78813094899994,
					24.56089879900003
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.78813094899994,
							24.558061641000055
						],
						[
							-81.79121442,
							24.55616412100005
						],
						[
							-81.79292948599993,
							24.55849040800007
						],
						[
							-81.79315234099994,
							24.558802744000047
						],
						[
							-81.79322546499998,
							24.55890522900006
						],
						[
							-81.79276527799999,
							24.559201978000033
						],
						[
							-81.78990987499998,
							24.56089879900003
						],
						[
							-81.78813094899994,
							24.558061641000055
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Monroe",
				"City": "Key West",
				"Name": "The Meadows",
				"RegionID": "163197"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.188792,
					25.941449,
					-80.178805,
					25.947327
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.180906,
							25.943494
						],
						[
							-80.18168216799995,
							25.942572193000046
						],
						[
							-80.18209857399995,
							25.942060609000066
						],
						[
							-80.182219,
							25.941776
						],
						[
							-80.183045,
							25.941663000000002
						],
						[
							-80.183383,
							25.941668
						],
						[
							-80.18424,
							25.941621
						],
						[
							-80.184751,
							25.941606
						],
						[
							-80.185906,
							25.941557
						],
						[
							-80.18731300000002,
							25.941498
						],
						[
							-80.188792,
							25.941449
						],
						[
							-80.188758,
							25.942053
						],
						[
							-80.18869987699998,
							25.94297904700005
						],
						[
							-80.188684,
							25.943232
						],
						[
							-80.18867376899993,
							25.943232531000035
						],
						[
							-80.187527,
							25.943292
						],
						[
							-80.18623,
							25.945569
						],
						[
							-80.185988,
							25.945961
						],
						[
							-80.185638,
							25.946571
						],
						[
							-80.18519400000001,
							25.947185000000005
						],
						[
							-80.185057,
							25.947327
						],
						[
							-80.185,
							25.94728
						],
						[
							-80.184983,
							25.947238
						],
						[
							-80.184858,
							25.947103
						],
						[
							-80.184701,
							25.946946
						],
						[
							-80.184619,
							25.946864
						],
						[
							-80.184534,
							25.946797
						],
						[
							-80.184435,
							25.946706
						],
						[
							-80.184398,
							25.946699
						],
						[
							-80.18427900000002,
							25.946606
						],
						[
							-80.184141,
							25.946517
						],
						[
							-80.184112,
							25.946493000000004
						],
						[
							-80.183999,
							25.946424
						],
						[
							-80.183837,
							25.946301
						],
						[
							-80.183764,
							25.946253
						],
						[
							-80.183616,
							25.946143
						],
						[
							-80.183547,
							25.946085
						],
						[
							-80.183427,
							25.946012
						],
						[
							-80.183299,
							25.945913
						],
						[
							-80.18323700000002,
							25.945878
						],
						[
							-80.183224,
							25.945855
						],
						[
							-80.183083,
							25.945771
						],
						[
							-80.183034,
							25.945719
						],
						[
							-80.18298,
							25.945679
						],
						[
							-80.182902,
							25.945633
						],
						[
							-80.182759,
							25.945534
						],
						[
							-80.18253,
							25.945375
						],
						[
							-80.182366,
							25.945284
						],
						[
							-80.182274,
							25.945208
						],
						[
							-80.182085,
							25.945093
						],
						[
							-80.181799,
							25.944903
						],
						[
							-80.181718,
							25.944833
						],
						[
							-80.181523,
							25.94471
						],
						[
							-80.181461,
							25.944658
						],
						[
							-80.18133900000001,
							25.944578
						],
						[
							-80.18120800000001,
							25.944472
						],
						[
							-80.181102,
							25.9444
						],
						[
							-80.181052,
							25.944359
						],
						[
							-80.181727,
							25.945393
						],
						[
							-80.181089,
							25.945416
						],
						[
							-80.18097,
							25.945448
						],
						[
							-80.17990800000001,
							25.94548
						],
						[
							-80.179902,
							25.945443
						],
						[
							-80.179867,
							25.945241
						],
						[
							-80.179591,
							25.945239
						],
						[
							-80.179313,
							25.945504
						],
						[
							-80.178933,
							25.945503
						],
						[
							-80.178805,
							25.945511
						],
						[
							-80.179159,
							25.945134
						],
						[
							-80.180021,
							25.944361
						],
						[
							-80.180244,
							25.944149
						],
						[
							-80.180489,
							25.943917
						],
						[
							-80.1807,
							25.943716
						],
						[
							-80.180906,
							25.943494
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "North Miami Beach",
				"Name": "Pickwick",
				"RegionID": "177568"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.14646545599999,
					26.62092079200005,
					-80.13806760299997,
					26.626761957000042
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.13830301099995,
							26.621834505000038
						],
						[
							-80.13834108299994,
							26.62092079200005
						],
						[
							-80.14032079399999,
							26.62095886400005
						],
						[
							-80.14024465099999,
							26.62281674700006
						],
						[
							-80.14245733799999,
							26.62287389000005
						],
						[
							-80.14335848499996,
							26.622897162000072
						],
						[
							-80.14503749199997,
							26.62294052200008
						],
						[
							-80.14646545599999,
							26.622977399000035
						],
						[
							-80.14636798499998,
							26.624942058000045
						],
						[
							-80.14627769599997,
							26.626761957000042
						],
						[
							-80.14423516599999,
							26.626684545000046
						],
						[
							-80.13806760299997,
							26.626465635000045
						],
						[
							-80.13818738299994,
							26.624109230000045
						],
						[
							-80.13830301099995,
							26.621834505000038
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Greenacres",
				"Name": "Woodlake",
				"RegionID": "187129"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.27069837199997,
					25.96190106100005,
					-80.26224518099997,
					25.971295000000005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.26233299099994,
							25.96372738200006
						],
						[
							-80.26224518099997,
							25.96190106100005
						],
						[
							-80.267508272,
							25.962036971000032
						],
						[
							-80.26968430799997,
							25.963247467000034
						],
						[
							-80.26922595199994,
							25.965467055000033
						],
						[
							-80.26970448799995,
							25.967510039000047
						],
						[
							-80.27034867299994,
							25.968356681000046
						],
						[
							-80.27069837199997,
							25.96953461700008
						],
						[
							-80.27060909099998,
							25.970075724000026
						],
						[
							-80.26974306799997,
							25.971149421000064
						],
						[
							-80.26911218199996,
							25.971162225000057
						],
						[
							-80.26749490299994,
							25.971195048000027
						],
						[
							-80.262915,
							25.971288
						],
						[
							-80.262558,
							25.971295000000005
						],
						[
							-80.26247435599998,
							25.969929196000066
						],
						[
							-80.26243441099997,
							25.969276944000057
						],
						[
							-80.26233299099994,
							25.96372738200006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Gardens",
				"Name": "Vista Verde",
				"RegionID": "219550"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.36333569799996,
					28.756159930000024,
					-81.34712109899993,
					28.76709161800005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.34712109899993,
							28.75986046800006
						],
						[
							-81.34714394199995,
							28.756159930000024
						],
						[
							-81.35768102599997,
							28.75621286700005
						],
						[
							-81.36333569799996,
							28.756241276000026
						],
						[
							-81.36082298799994,
							28.763379659000066
						],
						[
							-81.35480770999999,
							28.763379659000066
						],
						[
							-81.35473156699999,
							28.767053547000042
						],
						[
							-81.34715536399995,
							28.76709161800005
						],
						[
							-81.34712109899993,
							28.75986046800006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Seminole",
				"City": "Lake Mary",
				"Name": "Primera",
				"RegionID": "236797"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.184244,
					25.914138,
					-80.16767091,
					25.92875942200004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.170022,
							25.925656
						],
						[
							-80.16802509299998,
							25.92575845600004
						],
						[
							-80.16767091,
							25.91833964400007
						],
						[
							-80.17171599399995,
							25.91817308100008
						],
						[
							-80.171495,
							25.914468
						],
						[
							-80.17349800000001,
							25.914396
						],
						[
							-80.17553500000001,
							25.914314
						],
						[
							-80.176301,
							25.914280000000005
						],
						[
							-80.176523,
							25.914285
						],
						[
							-80.177464,
							25.914232
						],
						[
							-80.178533,
							25.914187
						],
						[
							-80.179518,
							25.914138
						],
						[
							-80.179543,
							25.914874
						],
						[
							-80.179582,
							25.915092
						],
						[
							-80.179616,
							25.916054
						],
						[
							-80.179653,
							25.916933
						],
						[
							-80.181674,
							25.91685
						],
						[
							-80.18167900000002,
							25.917124
						],
						[
							-80.181706,
							25.917555
						],
						[
							-80.18172,
							25.91777
						],
						[
							-80.182695,
							25.917735
						],
						[
							-80.182715,
							25.918049
						],
						[
							-80.182727,
							25.918287
						],
						[
							-80.182762,
							25.918642
						],
						[
							-80.183754,
							25.918618
						],
						[
							-80.18377,
							25.919055
						],
						[
							-80.18380800000001,
							25.919738
						],
						[
							-80.183854,
							25.920457
						],
						[
							-80.183902,
							25.921365
						],
						[
							-80.18393700000001,
							25.92213
						],
						[
							-80.183971,
							25.922864
						],
						[
							-80.18401,
							25.923541
						],
						[
							-80.184041,
							25.924296
						],
						[
							-80.184072,
							25.924972
						],
						[
							-80.184077,
							25.925062
						],
						[
							-80.184097,
							25.925709
						],
						[
							-80.184143,
							25.926418
						],
						[
							-80.184161,
							25.927125
						],
						[
							-80.184201,
							25.927839
						],
						[
							-80.184244,
							25.928755
						],
						[
							-80.183669018,
							25.92875942200004
						],
						[
							-80.18246738999994,
							25.92852147600007
						],
						[
							-80.18145611899996,
							25.92803368700004
						],
						[
							-80.18044484799998,
							25.92728415600004
						],
						[
							-80.17914804199995,
							25.926308577000043
						],
						[
							-80.17851748499999,
							25.925963556000056
						],
						[
							-80.17735154899998,
							25.925511458000074
						],
						[
							-80.17635217499998,
							25.92539248500003
						],
						[
							-80.176038,
							25.925418
						],
						[
							-80.175352,
							25.925428
						],
						[
							-80.175027,
							25.925446
						],
						[
							-80.174009,
							25.925483
						],
						[
							-80.172,
							25.925566
						],
						[
							-80.170022,
							25.925656
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "North Miami Beach",
				"Name": "Oakgrove",
				"RegionID": "253943"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.7244973469999,
					28.258660672000076,
					-82.71910072999992,
					28.266016000000036
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.71964278399992,
							28.26600058000008
						],
						[
							-82.71955758599995,
							28.26589137800005
						],
						[
							-82.71955758599995,
							28.264463702000057
						],
						[
							-82.71910786799992,
							28.264456563000067
						],
						[
							-82.71910072999992,
							28.264278104000084
						],
						[
							-82.71955044799995,
							28.264270965000037
						],
						[
							-82.71955044799995,
							28.261843915000043
						],
						[
							-82.71957186299994,
							28.26167259400006
						],
						[
							-82.71957218999995,
							28.258667176000074
						],
						[
							-82.71959365799995,
							28.258667011000057
						],
						[
							-82.72042085499993,
							28.258660672000076
						],
						[
							-82.72039991499992,
							28.259545356000046
						],
						[
							-82.72044274599995,
							28.259945105000043
						],
						[
							-82.72052126799991,
							28.26049476100008
						],
						[
							-82.72057123599991,
							28.260644667000065
						],
						[
							-82.7206997269999,
							28.260844542000086
						],
						[
							-82.72075683399993,
							28.260980171000085
						],
						[
							-82.72079252599991,
							28.261158630000068
						],
						[
							-82.7209352939999,
							28.261529826000075
						],
						[
							-82.72165627099992,
							28.26229363300007
						],
						[
							-82.72167768599991,
							28.264278104000084
						],
						[
							-82.7218133149999,
							28.265034772000035
						],
						[
							-82.72192752899991,
							28.265041911000083
						],
						[
							-82.7219489439999,
							28.265191817000073
						],
						[
							-82.72214881899993,
							28.26527033900004
						],
						[
							-82.72228444799993,
							28.26540596800004
						],
						[
							-82.72276985799994,
							28.26532744600007
						],
						[
							-82.72293404099992,
							28.26527747700004
						],
						[
							-82.72329095999993,
							28.26523464700006
						],
						[
							-82.72356935699992,
							28.26526320100004
						],
						[
							-82.7237335399999,
							28.26527747700004
						],
						[
							-82.72399052199995,
							28.26530603100008
						],
						[
							-82.72420467299992,
							28.265384553000047
						],
						[
							-82.7243617179999,
							28.26544879900007
						],
						[
							-82.72445451699991,
							28.265584428000068
						],
						[
							-82.7244973469999,
							28.26569864200008
						],
						[
							-82.72449025599991,
							28.265927051000062
						],
						[
							-82.72406399999994,
							28.26579400000009
						],
						[
							-82.72400999999991,
							28.265906000000086
						],
						[
							-82.72381299999995,
							28.26587500000005
						],
						[
							-82.7238099999999,
							28.265951000000086
						],
						[
							-82.72225999999995,
							28.265990000000045
						],
						[
							-82.72175199999992,
							28.26585300000005
						],
						[
							-82.72066499999994,
							28.266016000000036
						],
						[
							-82.71964278399992,
							28.26600058000008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pasco",
				"City": "New Port Richey",
				"Name": "Big Bend",
				"RegionID": "255080"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.61732150499995,
					30.183592024000063,
					-81.58183372099995,
					30.20606401100008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.5896409099999,
							30.206043011000077
						],
						[
							-81.58545690999995,
							30.20600101100007
						],
						[
							-81.58537290899994,
							30.20600501100006
						],
						[
							-81.58470190999992,
							30.20599601100008
						],
						[
							-81.5838549099999,
							30.205990012000086
						],
						[
							-81.58338190899991,
							30.20599906400008
						],
						[
							-81.58334308399992,
							30.201917095000052
						],
						[
							-81.58334308299993,
							30.194556814000062
						],
						[
							-81.58310192199991,
							30.192988151000065
						],
						[
							-81.58183372099995,
							30.19170200000008
						],
						[
							-81.58202690799993,
							30.191531011000052
						],
						[
							-81.58231690799994,
							30.19130301000007
						],
						[
							-81.5824199079999,
							30.191197011000042
						],
						[
							-81.58261590799992,
							30.191050011000073
						],
						[
							-81.58306590799992,
							30.19080601100006
						],
						[
							-81.58341490799995,
							30.190686010000036
						],
						[
							-81.58364690799993,
							30.19063801100009
						],
						[
							-81.58398390499991,
							30.190596012000068
						],
						[
							-81.58419690799991,
							30.190616010000042
						],
						[
							-81.5848319079999,
							30.190598010000087
						],
						[
							-81.58555590799995,
							30.190598010000087
						],
						[
							-81.58669290799992,
							30.190603010000075
						],
						[
							-81.58689890699992,
							30.19060101000008
						],
						[
							-81.58722690699994,
							30.190582010000075
						],
						[
							-81.58772290699996,
							30.190525010000048
						],
						[
							-81.58808090699995,
							30.190453010000056
						],
						[
							-81.58834090699992,
							30.19037601000008
						],
						[
							-81.58875290799995,
							30.19021001000004
						],
						[
							-81.5909349069999,
							30.188982011000064
						],
						[
							-81.59106390799991,
							30.18890201100004
						],
						[
							-81.59149190699992,
							30.188654010000054
						],
						[
							-81.59371190799993,
							30.187403010000082
						],
						[
							-81.59413890799993,
							30.187149011000088
						],
						[
							-81.5951249069999,
							30.186610011000084
						],
						[
							-81.59532990899994,
							30.18651901100009
						],
						[
							-81.59550090699992,
							30.18646201100006
						],
						[
							-81.59719790699995,
							30.185984010000087
						],
						[
							-81.59853390699993,
							30.18558501100006
						],
						[
							-81.5995789079999,
							30.18527801000005
						],
						[
							-81.5999149079999,
							30.18518801000005
						],
						[
							-81.60088090699992,
							30.18490601000008
						],
						[
							-81.6018110569999,
							30.184731132000085
						],
						[
							-81.6018067519999,
							30.18464090000009
						],
						[
							-81.60285190699994,
							30.184345010000076
						],
						[
							-81.60340090699992,
							30.184193010000058
						],
						[
							-81.60368290799994,
							30.18414101100007
						],
						[
							-81.60387390799991,
							30.184105010000057
						],
						[
							-81.60425590799993,
							30.184052010000073
						],
						[
							-81.6075819269999,
							30.183592024000063
						],
						[
							-81.60770090999995,
							30.183837011000037
						],
						[
							-81.6078489599999,
							30.184142993000084
						],
						[
							-81.60796390799993,
							30.184595014000084
						],
						[
							-81.6079709089999,
							30.18512301100009
						],
						[
							-81.60798590899994,
							30.185400011000073
						],
						[
							-81.60798590999991,
							30.18587901100005
						],
						[
							-81.60798590999991,
							30.18621401100006
						],
						[
							-81.60800190899994,
							30.18649101200009
						],
						[
							-81.60799390999995,
							30.187130012000065
						],
						[
							-81.60801690999995,
							30.187664011000034
						],
						[
							-81.60802490899994,
							30.188227011000034
						],
						[
							-81.60804690899994,
							30.188784012000042
						],
						[
							-81.6080399089999,
							30.189100011000054
						],
						[
							-81.60804690899994,
							30.189240011000038
						],
						[
							-81.6080779099999,
							30.18973901200008
						],
						[
							-81.60808590999994,
							30.189833011000076
						],
						[
							-81.60813090999994,
							30.190012012000068
						],
						[
							-81.6081919099999,
							30.190201011000056
						],
						[
							-81.60826890999994,
							30.190395011000078
						],
						[
							-81.60835290999995,
							30.190573011000083
						],
						[
							-81.60844390999995,
							30.19072501100004
						],
						[
							-81.6084819109999,
							30.19079401100004
						],
						[
							-81.60865790999992,
							30.191031011000067
						],
						[
							-81.60906990899991,
							30.191549011000067
						],
						[
							-81.60914590999994,
							30.191677012000067
						],
						[
							-81.6091839099999,
							30.191738009000062
						],
						[
							-81.6095199099999,
							30.192106012000067
						],
						[
							-81.60968790899994,
							30.192337012000053
						],
						[
							-81.61013790999993,
							30.192913011000083
						],
						[
							-81.61035890999996,
							30.193214011000066
						],
						[
							-81.61060290899991,
							30.193520011000086
						],
						[
							-81.61082490999992,
							30.193827011000053
						],
						[
							-81.6113049089999,
							30.194445011000088
						],
						[
							-81.6122669099999,
							30.195723011000037
						],
						[
							-81.6127169099999,
							30.196306011000047
						],
						[
							-81.61365490999992,
							30.197577011000078
						],
						[
							-81.6145169099999,
							30.198730011000066
						],
						[
							-81.61475390899994,
							30.199060011000086
						],
						[
							-81.6156459099999,
							30.200258011000077
						],
						[
							-81.61579890999991,
							30.20047801200008
						],
						[
							-81.61629490999991,
							30.201174013000067
						],
						[
							-81.61647790899991,
							30.201471012000066
						],
						[
							-81.61664590899994,
							30.20177101100006
						],
						[
							-81.61671390999993,
							30.20195201200005
						],
						[
							-81.61688890999994,
							30.202474011000046
						],
						[
							-81.61690991099994,
							30.20253801100006
						],
						[
							-81.61698391199991,
							30.202693013000044
						],
						[
							-81.6170769119999,
							30.20282101300006
						],
						[
							-81.61717491299993,
							30.202914011000075
						],
						[
							-81.61732150499995,
							30.202998027000035
						],
						[
							-81.6172959079999,
							30.203089010000046
						],
						[
							-81.61721590799993,
							30.20341601100006
						],
						[
							-81.61717281699994,
							30.203685000000064
						],
						[
							-81.61716390799995,
							30.203827011000048
						],
						[
							-81.61714990699994,
							30.204044010000075
						],
						[
							-81.61715690799991,
							30.204586011000057
						],
						[
							-81.61717190699994,
							30.204948010000066
						],
						[
							-81.6171879659999,
							30.20570000600009
						],
						[
							-81.61676290999992,
							30.20568901100006
						],
						[
							-81.61611390999991,
							30.205672011000047
						],
						[
							-81.61459390999994,
							30.20570701100007
						],
						[
							-81.61396690999993,
							30.205721011000037
						],
						[
							-81.61277790999992,
							30.205748011000086
						],
						[
							-81.6114119099999,
							30.20577201100008
						],
						[
							-81.61063390999993,
							30.205778012000057
						],
						[
							-81.6099469099999,
							30.20580101100006
						],
						[
							-81.60961890999994,
							30.20581401200008
						],
						[
							-81.60795590999993,
							30.205822011000066
						],
						[
							-81.60703290899994,
							30.20583301200008
						],
						[
							-81.60633090899995,
							30.20584901100005
						],
						[
							-81.60465990999995,
							30.20586201100008
						],
						[
							-81.60375990999995,
							30.205880011000094
						],
						[
							-81.60271490899993,
							30.205887011000076
						],
						[
							-81.60227990999994,
							30.20588901100007
						],
						[
							-81.60023490999994,
							30.205929011000084
						],
						[
							-81.59825890999991,
							30.205954011000074
						],
						[
							-81.59533690899991,
							30.20601301100004
						],
						[
							-81.59439090899991,
							30.206028012000047
						],
						[
							-81.59428390999994,
							30.206032012000037
						],
						[
							-81.59332590999992,
							30.20605401100005
						],
						[
							-81.5921399099999,
							30.20606401100008
						],
						[
							-81.5896409099999,
							30.206043011000077
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Sunbeam",
				"RegionID": "126306"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.5119269999999,
					27.211088000000075,
					-82.47649399999995,
					27.236729000000082
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-82.4901769999999,
								27.214713000000078
							],
							[
								-82.49039499999992,
								27.214708000000087
							],
							[
								-82.49039099999995,
								27.217392000000075
							],
							[
								-82.4904909999999,
								27.218314000000078
							],
							[
								-82.49245899999994,
								27.21830600000004
							],
							[
								-82.49699399999992,
								27.218293000000074
							],
							[
								-82.4974069999999,
								27.21852800000005
							],
							[
								-82.49754499999995,
								27.218946000000074
							],
							[
								-82.50135899999992,
								27.21892900000006
							],
							[
								-82.50168999999994,
								27.218855000000076
							],
							[
								-82.50143199999991,
								27.218286000000035
							],
							[
								-82.50095099999993,
								27.218243000000086
							],
							[
								-82.50077299999992,
								27.218153000000086
							],
							[
								-82.50049299999995,
								27.217702000000088
							],
							[
								-82.50038999999992,
								27.217227000000037
							],
							[
								-82.5004899999999,
								27.21713600000004
							],
							[
								-82.50076899999993,
								27.21713500000004
							],
							[
								-82.50084399999993,
								27.216977000000043
							],
							[
								-82.50082299999991,
								27.21645600000005
							],
							[
								-82.50025399999993,
								27.21615600000007
							],
							[
								-82.49957499999995,
								27.216167000000045
							],
							[
								-82.49934599999995,
								27.215908000000073
							],
							[
								-82.49947099999991,
								27.215455000000077
							],
							[
								-82.49942799999991,
								27.215193000000056
							],
							[
								-82.4996359999999,
								27.213870000000046
							],
							[
								-82.49994199999992,
								27.21465100000006
							],
							[
								-82.50052399999993,
								27.215248000000088
							],
							[
								-82.50111099999992,
								27.214946000000054
							],
							[
								-82.50169199999993,
								27.214642000000087
							],
							[
								-82.50192399999992,
								27.21453900000006
							],
							[
								-82.5019549999999,
								27.214585000000056
							],
							[
								-82.50199199999992,
								27.214640000000088
							],
							[
								-82.50298199999992,
								27.215999000000068
							],
							[
								-82.5116099999999,
								27.227902000000086
							],
							[
								-82.5119269999999,
								27.228342000000055
							],
							[
								-82.51123599999994,
								27.22846300000009
							],
							[
								-82.50500299999993,
								27.229309000000057
							],
							[
								-82.50495599999994,
								27.229321000000084
							],
							[
								-82.5037299999999,
								27.229689000000068
							],
							[
								-82.5032379999999,
								27.22989000000007
							],
							[
								-82.50257199999993,
								27.22997500000008
							],
							[
								-82.50219499999992,
								27.23034800000005
							],
							[
								-82.50087799999994,
								27.230935000000045
							],
							[
								-82.50049999999993,
								27.23103000000009
							],
							[
								-82.4997899999999,
								27.231202000000053
							],
							[
								-82.49902899999995,
								27.231422000000066
							],
							[
								-82.49756699999995,
								27.23172100000005
							],
							[
								-82.4964159999999,
								27.23197600000009
							],
							[
								-82.49618099999992,
								27.23202800000007
							],
							[
								-82.49631399999993,
								27.23216400000007
							],
							[
								-82.49646299999995,
								27.232305000000053
							],
							[
								-82.4972479999999,
								27.233013000000085
							],
							[
								-82.4976539999999,
								27.23343200000005
							],
							[
								-82.49756399999991,
								27.23373100000009
							],
							[
								-82.49756799999994,
								27.23501900000008
							],
							[
								-82.49756799999994,
								27.23559400000005
							],
							[
								-82.49756699999995,
								27.23581400000006
							],
							[
								-82.49756699999995,
								27.236112000000052
							],
							[
								-82.49756699999995,
								27.23626100000007
							],
							[
								-82.49755999999992,
								27.236470000000054
							],
							[
								-82.49725199999995,
								27.236486000000074
							],
							[
								-82.49696499999993,
								27.23650100000009
							],
							[
								-82.49689399999994,
								27.236509000000073
							],
							[
								-82.49672699999991,
								27.236536000000058
							],
							[
								-82.49660399999993,
								27.23656800000009
							],
							[
								-82.4964349999999,
								27.236619000000076
							],
							[
								-82.49633499999993,
								27.236641000000077
							],
							[
								-82.49619999999993,
								27.23666200000008
							],
							[
								-82.49605799999996,
								27.236674000000054
							],
							[
								-82.49339299999991,
								27.23669800000005
							],
							[
								-82.4924059999999,
								27.236706000000083
							],
							[
								-82.49119999999994,
								27.236712000000068
							],
							[
								-82.48950799999994,
								27.236729000000082
							],
							[
								-82.48923599999995,
								27.236717000000056
							],
							[
								-82.4890089999999,
								27.236695000000054
							],
							[
								-82.48881699999993,
								27.236671000000058
							],
							[
								-82.48861599999992,
								27.23663600000009
							],
							[
								-82.48839399999991,
								27.236587000000043
							],
							[
								-82.48824999999994,
								27.236548000000084
							],
							[
								-82.48805799999991,
								27.23648700000007
							],
							[
								-82.48772799999995,
								27.236360000000047
							],
							[
								-82.48746299999993,
								27.236237000000074
							],
							[
								-82.48715699999991,
								27.236069000000043
							],
							[
								-82.48612099999991,
								27.235408000000067
							],
							[
								-82.48584499999993,
								27.23523000000006
							],
							[
								-82.48553299999992,
								27.235061000000087
							],
							[
								-82.48556099999992,
								27.234789000000035
							],
							[
								-82.48385399999995,
								27.23434300000008
							],
							[
								-82.48334199999994,
								27.234095000000085
							],
							[
								-82.48296199999993,
								27.233997000000045
							],
							[
								-82.48289799999992,
								27.233980000000088
							],
							[
								-82.48283499999991,
								27.23396500000007
							],
							[
								-82.48270899999994,
								27.233932000000042
							],
							[
								-82.48248999999993,
								27.23387400000007
							],
							[
								-82.48184199999992,
								27.233708000000036
							],
							[
								-82.48131599999994,
								27.233572000000038
							],
							[
								-82.48112099999992,
								27.23352200000005
							],
							[
								-82.48077499999994,
								27.233445000000074
							],
							[
								-82.4806779999999,
								27.233411000000046
							],
							[
								-82.48051399999991,
								27.233355000000074
							],
							[
								-82.47949199999994,
								27.23300100000006
							],
							[
								-82.47929199999993,
								27.232932000000062
							],
							[
								-82.4790989999999,
								27.232882000000075
							],
							[
								-82.47855599999991,
								27.23267700000008
							],
							[
								-82.47780799999992,
								27.232058000000055
							],
							[
								-82.47753799999992,
								27.231835000000046
							],
							[
								-82.47691999999995,
								27.231324000000086
							],
							[
								-82.47680699999995,
								27.23122900000004
							],
							[
								-82.4766929999999,
								27.23113500000005
							],
							[
								-82.47649399999995,
								27.230971000000068
							],
							[
								-82.47680099999991,
								27.230581000000086
							],
							[
								-82.47713599999992,
								27.229624000000058
							],
							[
								-82.47722299999992,
								27.22937500000006
							],
							[
								-82.4773909999999,
								27.229258000000073
							],
							[
								-82.48078399999991,
								27.22688100000005
							],
							[
								-82.48085999999995,
								27.226866000000086
							],
							[
								-82.48092899999995,
								27.226860000000045
							],
							[
								-82.48120299999995,
								27.22678600000006
							],
							[
								-82.48124399999995,
								27.226757000000077
							],
							[
								-82.48127899999992,
								27.226755000000082
							],
							[
								-82.48135899999994,
								27.22674900000004
							],
							[
								-82.48146999999994,
								27.22674900000004
							],
							[
								-82.4817349999999,
								27.22676800000005
							],
							[
								-82.4818019999999,
								27.226769000000047
							],
							[
								-82.4818939999999,
								27.226757000000077
							],
							[
								-82.48257099999995,
								27.226612000000046
							],
							[
								-82.48265199999992,
								27.226589000000047
							],
							[
								-82.48286699999994,
								27.226518000000056
							],
							[
								-82.48294099999993,
								27.226500000000044
							],
							[
								-82.4829959999999,
								27.226492000000064
							],
							[
								-82.48306599999995,
								27.226487000000077
							],
							[
								-82.48311199999995,
								27.226489000000072
							],
							[
								-82.48314799999991,
								27.226499000000047
							],
							[
								-82.4831769999999,
								27.22652000000005
							],
							[
								-82.48319099999992,
								27.22656500000005
							],
							[
								-82.48321799999991,
								27.22659900000008
							],
							[
								-82.48323499999992,
								27.226609000000053
							],
							[
								-82.48325599999993,
								27.226590000000044
							],
							[
								-82.48327599999993,
								27.226523000000043
							],
							[
								-82.48328099999992,
								27.22646300000008
							],
							[
								-82.48329199999995,
								27.22644100000008
							],
							[
								-82.4833329999999,
								27.226402000000064
							],
							[
								-82.48337399999991,
								27.226379000000065
							],
							[
								-82.48342999999994,
								27.226357000000064
							],
							[
								-82.48354099999995,
								27.226331000000073
							],
							[
								-82.4838059999999,
								27.226247000000058
							],
							[
								-82.48393399999992,
								27.22622300000006
							],
							[
								-82.48408699999993,
								27.226207000000045
							],
							[
								-82.48423799999995,
								27.226197000000074
							],
							[
								-82.4845699999999,
								27.226185000000044
							],
							[
								-82.48473799999994,
								27.22618300000005
							],
							[
								-82.48482299999995,
								27.226173000000077
							],
							[
								-82.48500199999995,
								27.22613700000005
							],
							[
								-82.48506399999991,
								27.22613000000007
							],
							[
								-82.48523499999993,
								27.226126000000082
							],
							[
								-82.48554399999995,
								27.22610400000008
							],
							[
								-82.48560499999991,
								27.22609300000005
							],
							[
								-82.48566999999991,
								27.226075000000037
							],
							[
								-82.48582099999993,
								27.226019000000065
							],
							[
								-82.48595899999992,
								27.225956000000053
							],
							[
								-82.48618999999991,
								27.225836000000072
							],
							[
								-82.4862619999999,
								27.225805000000037
							],
							[
								-82.48629499999993,
								27.22577300000006
							],
							[
								-82.48631099999996,
								27.225741000000085
							],
							[
								-82.48634399999992,
								27.22562000000005
							],
							[
								-82.4864199999999,
								27.225371000000052
							],
							[
								-82.48643399999992,
								27.225333000000038
							],
							[
								-82.48697699999991,
								27.225204000000076
							],
							[
								-82.48858699999994,
								27.223408000000067
							],
							[
								-82.48887599999995,
								27.22302700000006
							],
							[
								-82.48909299999991,
								27.22231400000004
							],
							[
								-82.4891849999999,
								27.22189700000007
							],
							[
								-82.48929099999992,
								27.221736000000078
							],
							[
								-82.4895229999999,
								27.221710000000087
							],
							[
								-82.48982999999994,
								27.221682000000044
							],
							[
								-82.49011299999995,
								27.22164100000009
							],
							[
								-82.49025399999994,
								27.22158900000005
							],
							[
								-82.49081799999993,
								27.22130800000008
							],
							[
								-82.49096299999991,
								27.22123000000005
							],
							[
								-82.49115999999992,
								27.221206000000056
							],
							[
								-82.49122099999994,
								27.221279000000038
							],
							[
								-82.49109199999992,
								27.221251000000052
							],
							[
								-82.49102599999992,
								27.221273000000053
							],
							[
								-82.49063399999994,
								27.22148400000009
							],
							[
								-82.49029299999997,
								27.221681000000046
							],
							[
								-82.49024899999995,
								27.22169900000006
							],
							[
								-82.4901339999999,
								27.22173500000008
							],
							[
								-82.49004799999994,
								27.22175100000004
							],
							[
								-82.48994199999993,
								27.221755000000087
							],
							[
								-82.48963999999997,
								27.221749000000045
							],
							[
								-82.48942999999991,
								27.221761000000072
							],
							[
								-82.48934899999995,
								27.22177600000009
							],
							[
								-82.48931499999992,
								27.22179900000009
							],
							[
								-82.48924899999992,
								27.221890000000087
							],
							[
								-82.48923599999995,
								27.221918000000073
							],
							[
								-82.48925799999995,
								27.222147000000064
							],
							[
								-82.4892559999999,
								27.22217500000005
							],
							[
								-82.48921799999995,
								27.22234300000008
							],
							[
								-82.48917199999994,
								27.22272600000008
							],
							[
								-82.48915199999993,
								27.222785000000044
							],
							[
								-82.48914799999994,
								27.22282200000007
							],
							[
								-82.4891649999999,
								27.222885000000076
							],
							[
								-82.4891889999999,
								27.222875000000045
							],
							[
								-82.48922199999993,
								27.222840000000076
							],
							[
								-82.48925099999991,
								27.222768000000087
							],
							[
								-82.48926999999992,
								27.222698000000037
							],
							[
								-82.4893009999999,
								27.22249700000009
							],
							[
								-82.48933199999993,
								27.222222000000045
							],
							[
								-82.48935799999992,
								27.222086000000047
							],
							[
								-82.48942999999991,
								27.221863000000045
							],
							[
								-82.48945499999992,
								27.221834000000058
							],
							[
								-82.48948799999994,
								27.22181600000005
							],
							[
								-82.48959199999992,
								27.221802000000082
							],
							[
								-82.48968899999994,
								27.221798000000035
							],
							[
								-82.48993299999995,
								27.221800000000087
							],
							[
								-82.49006299999992,
								27.22179600000004
							],
							[
								-82.49014299999993,
								27.221787000000063
							],
							[
								-82.49021599999992,
								27.221772000000044
							],
							[
								-82.49025399999994,
								27.221760000000074
							],
							[
								-82.49049799999995,
								27.22163900000004
							],
							[
								-82.4906949999999,
								27.221524000000045
							],
							[
								-82.49089299999991,
								27.221422000000075
							],
							[
								-82.49098499999991,
								27.221359000000064
							],
							[
								-82.4910789999999,
								27.22130800000008
							],
							[
								-82.49111199999993,
								27.221299000000045
							],
							[
								-82.49114299999991,
								27.221298000000047
							],
							[
								-82.49123999999995,
								27.221322000000043
							],
							[
								-82.49128599999995,
								27.221331000000077
							],
							[
								-82.49126799999993,
								27.221288000000072
							],
							[
								-82.49080099999992,
								27.220146000000057
							],
							[
								-82.49068399999993,
								27.219872000000066
							],
							[
								-82.49060999999995,
								27.219665000000077
							],
							[
								-82.49045199999995,
								27.21916800000008
							],
							[
								-82.49034399999995,
								27.21875700000004
							],
							[
								-82.4903149999999,
								27.21861300000006
							],
							[
								-82.49027699999994,
								27.21831700000007
							],
							[
								-82.49023899999992,
								27.21801300000004
							],
							[
								-82.49020399999995,
								27.217430000000036
							],
							[
								-82.49018799999993,
								27.21697400000005
							],
							[
								-82.49018699999993,
								27.215539000000035
							],
							[
								-82.49016799999993,
								27.215021000000036
							],
							[
								-82.4901769999999,
								27.214713000000078
							]
						]
					],
					[
						[
							[
								-82.49020199999991,
								27.211088000000075
							],
							[
								-82.4901947059999,
								27.212145647000057
							],
							[
								-82.49019499999991,
								27.211568000000057
							],
							[
								-82.49020199999991,
								27.211088000000075
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Vamo",
				"RegionID": "126481"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.16825670399993,
					26.03331169800009,
					-80.15576799999991,
					26.04826600000007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.1643117349999,
							26.033380908000083
						],
						[
							-80.16541909499995,
							26.03331169800009
						],
						[
							-80.16652645499994,
							26.033450118000076
						],
						[
							-80.16735697399992,
							26.033553933000064
						],
						[
							-80.16815288899994,
							26.03358853800006
						],
						[
							-80.16825670399993,
							26.040371116000074
						],
						[
							-80.16825670399993,
							26.04248202000008
						],
						[
							-80.16776799999991,
							26.047966000000088
						],
						[
							-80.16726799999992,
							26.047866000000056
						],
						[
							-80.16636799999992,
							26.047966000000088
						],
						[
							-80.16243999999996,
							26.04805500000009
						],
						[
							-80.16196799999994,
							26.048066000000066
						],
						[
							-80.16176799999994,
							26.047966000000088
						],
						[
							-80.16156799999993,
							26.048066000000066
						],
						[
							-80.16095599999994,
							26.048087000000066
						],
						[
							-80.1601369999999,
							26.04811600000005
						],
						[
							-80.15586799999994,
							26.04826600000007
						],
						[
							-80.15586799999994,
							26.047066000000086
						],
						[
							-80.15576799999991,
							26.046366000000035
						],
						[
							-80.15974387699993,
							26.04075177100009
						],
						[
							-80.16036676699991,
							26.038121792000084
						],
						[
							-80.16154205999993,
							26.033399617000043
						],
						[
							-80.1643117349999,
							26.033380908000083
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Hollywood",
				"Name": "Oakwood Hills",
				"RegionID": "139733"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.20741586999992,
					25.99506800000006,
					-80.19518543999993,
					26.002696382000067
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.1991829349999,
							26.00255361500007
						],
						[
							-80.19556089999992,
							26.00265962600008
						],
						[
							-80.19547097599991,
							25.99969826100005
						],
						[
							-80.19547097599991,
							25.998175406000087
						],
						[
							-80.19518543999993,
							25.997176033000073
						],
						[
							-80.19526899999994,
							25.995268000000067
						],
						[
							-80.19736899999992,
							25.995268000000067
						],
						[
							-80.19896899999992,
							25.995168000000035
						],
						[
							-80.2010689999999,
							25.99506800000006
						],
						[
							-80.20306899999991,
							25.99506800000006
						],
						[
							-80.20716899999991,
							25.995268000000067
						],
						[
							-80.20741586999992,
							26.002696382000067
						],
						[
							-80.1991829349999,
							26.00255361500007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Hollywood",
				"Name": "Washington Park",
				"RegionID": "190514"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.11753690499995,
					26.03429344400007,
					-80.10829917199999,
					26.053155419000063
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.11046929099996,
							26.03429344400007
						],
						[
							-80.11753690499995,
							26.03429344400007
						],
						[
							-80.11726680499999,
							26.037174509000067
						],
						[
							-80.11681663899998,
							26.03978547400004
						],
						[
							-80.11641148899997,
							26.04293664000005
						],
						[
							-80.11582627199994,
							26.045817705000047
						],
						[
							-80.11519603899995,
							26.053155419000063
						],
						[
							-80.11398977499994,
							26.053114177000054
						],
						[
							-80.113266,
							26.053066
						],
						[
							-80.11316594799996,
							26.053086010000076
						],
						[
							-80.10829917199999,
							26.052919616000054
						],
						[
							-80.11046929099996,
							26.03429344400007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Hollywood",
				"Name": "North Beach",
				"RegionID": "196691"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.14627769599997,
					26.626465635000045,
					-80.13780110399995,
					26.63192054600006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.13780110399995,
							26.631709967000063
						],
						[
							-80.13782013899998,
							26.631100825000033
						],
						[
							-80.13793497699999,
							26.628949825000063
						],
						[
							-80.13796436499996,
							26.62839935900007
						],
						[
							-80.13806760299997,
							26.626465635000045
						],
						[
							-80.14423516599999,
							26.626684545000046
						],
						[
							-80.14627769599997,
							26.626761957000042
						],
						[
							-80.14603096699994,
							26.63192054600006
						],
						[
							-80.14406384499995,
							26.631852734000063
						],
						[
							-80.14353084599998,
							26.631852734000063
						],
						[
							-80.13996165399999,
							26.63177659200005
						],
						[
							-80.13780110399995,
							26.631709967000063
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Greenacres",
				"Name": "Buttonwood",
				"RegionID": "208857"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.12045037199994,
					26.905517489000033,
					-80.11188933999995,
					26.911174954000046
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.11218867699995,
							26.905517489000033
						],
						[
							-80.12000136699999,
							26.905517489000033
						],
						[
							-80.12045037199994,
							26.905517489000033
						],
						[
							-80.12039050399996,
							26.905996428000037
						],
						[
							-80.12018096899999,
							26.906235897000045
						],
						[
							-80.12006123399993,
							26.906684902000052
						],
						[
							-80.11997143299999,
							26.910576280000043
						],
						[
							-80.11970203,
							26.91093548400005
						],
						[
							-80.11790600899997,
							26.911174954000046
						],
						[
							-80.11491264199998,
							26.910965418000046
						],
						[
							-80.11401463099997,
							26.910546347000036
						],
						[
							-80.11383502899997,
							26.910127275000036
						],
						[
							-80.11281728399996,
							26.90976807100003
						],
						[
							-80.11188933999995,
							26.90901972900008
						],
						[
							-80.11218867699995,
							26.905517489000033
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Jupiter",
				"Name": "Windsor Park",
				"RegionID": "217238"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.14603096699994,
					26.631709967000063,
					-80.13768688999994,
					26.63416557000005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.13768688999994,
							26.633975213000042
						],
						[
							-80.13768771599996,
							26.633958688000064
						],
						[
							-80.13771544299993,
							26.633404143000064
						],
						[
							-80.13775187599998,
							26.632683591000045
						],
						[
							-80.13780110399995,
							26.631709967000063
						],
						[
							-80.13996165399999,
							26.63177659200005
						],
						[
							-80.14353084599998,
							26.631852734000063
						],
						[
							-80.14406384499995,
							26.631852734000063
						],
						[
							-80.14603096699994,
							26.63192054600006
						],
						[
							-80.14599305399997,
							26.63250692500003
						],
						[
							-80.14591030699995,
							26.63416557000005
						],
						[
							-80.14407236499994,
							26.634123025000065
						],
						[
							-80.13983765099994,
							26.634024999000076
						],
						[
							-80.13768688999994,
							26.633975213000042
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Greenacres",
				"Name": "Seven Springs",
				"RegionID": "184083"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.33941749499996,
					29.623871415000057,
					-82.32878145099994,
					29.636662351000044
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.33941749499996,
							29.627197706000064
						],
						[
							-82.33937356299998,
							29.632854059000067
						],
						[
							-82.33700250399994,
							29.63272934200006
						],
						[
							-82.33681754999998,
							29.634466334000024
						],
						[
							-82.33422852699994,
							29.63432845800003
						],
						[
							-82.33416447199994,
							29.636662351000044
						],
						[
							-82.33039079899999,
							29.636373415000037
						],
						[
							-82.33011651499999,
							29.633789980000074
						],
						[
							-82.33099611799997,
							29.633537614000037
						],
						[
							-82.33103480199998,
							29.63338287800008
						],
						[
							-82.33089975599997,
							29.633153597000046
						],
						[
							-82.32878145099994,
							29.632536662000064
						],
						[
							-82.32978240299997,
							29.629495122000037
						],
						[
							-82.33066246699997,
							29.626352035000025
						],
						[
							-82.33120404499994,
							29.623871415000057
						],
						[
							-82.33373900199996,
							29.624505317000057
						],
						[
							-82.33447328999996,
							29.62502747800005
						],
						[
							-82.33532180099996,
							29.626267608000035
						],
						[
							-82.33564815099999,
							29.626398148000078
						],
						[
							-82.33589291299995,
							29.627931994000054
						],
						[
							-82.33613767599996,
							29.628029899000072
						],
						[
							-82.33643139099996,
							29.627768819000035
						],
						[
							-82.33830790499997,
							29.62731192900003
						],
						[
							-82.33941749499996,
							29.627197706000064
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Alachua",
				"City": "Gainesville",
				"Name": "Kirkwood",
				"RegionID": "221812"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-87.23032525399998,
					30.466654477000077,
					-87.192610163,
					30.496385017000083
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-87.19530581699996,
							30.489958641000044
						],
						[
							-87.19487160199998,
							30.489680045000057
						],
						[
							-87.19474596699996,
							30.489497302000075
						],
						[
							-87.19474596699996,
							30.489234610000036
						],
						[
							-87.19481449499995,
							30.48891481000004
						],
						[
							-87.19474596699996,
							30.488617853000054
						],
						[
							-87.19455180299997,
							30.487955412000076
						],
						[
							-87.19414063199997,
							30.48737291900005
						],
						[
							-87.19322691899998,
							30.486253621000063
						],
						[
							-87.19299849099997,
							30.485773922000078
						],
						[
							-87.19270153399998,
							30.484574673000054
						],
						[
							-87.192610163,
							30.48428913800006
						],
						[
							-87.19263300499995,
							30.48321552500005
						],
						[
							-87.19269011199998,
							30.48194774800004
						],
						[
							-87.19335255399994,
							30.48200485500007
						],
						[
							-87.19335255399994,
							30.48102261400004
						],
						[
							-87.19435763899997,
							30.48119393500008
						],
						[
							-87.19474596699996,
							30.48056575700008
						],
						[
							-87.19543125199993,
							30.48081702800005
						],
						[
							-87.19705309199999,
							30.481547999000043
						],
						[
							-87.19716730599998,
							30.478658381000063
						],
						[
							-87.19725867799997,
							30.478212946000042
						],
						[
							-87.19738431299999,
							30.47781319700005
						],
						[
							-87.19921173899996,
							30.474809365000056
						],
						[
							-87.20544783099997,
							30.477698983000042
						],
						[
							-87.20593895099995,
							30.478018782000046
						],
						[
							-87.20685266399994,
							30.479160924000045
						],
						[
							-87.20716104199994,
							30.47944645900003
						],
						[
							-87.21025624499998,
							30.476648213000033
						],
						[
							-87.21058746599994,
							30.476191356000072
						],
						[
							-87.21225499299999,
							30.473336003000043
						],
						[
							-87.21340855499994,
							30.471325834000027
						],
						[
							-87.21370551199999,
							30.470423543000038
						],
						[
							-87.21388825499997,
							30.468995866000057
						],
						[
							-87.21769158499995,
							30.469052973000032
						],
						[
							-87.21829691999994,
							30.468961602000036
						],
						[
							-87.21931342599999,
							30.468653224000033
						],
						[
							-87.22443021899994,
							30.466654477000077
						],
						[
							-87.22469068999999,
							30.468486313000028
						],
						[
							-87.22529983199998,
							30.473405134000075
						],
						[
							-87.22540643199994,
							30.474486361000057
						],
						[
							-87.22536074699998,
							30.47540007400005
						],
						[
							-87.22522369,
							30.47605490200004
						],
						[
							-87.22504094699997,
							30.47684678700006
						],
						[
							-87.22325920699996,
							30.48140012300007
						],
						[
							-87.22604603099995,
							30.48140012300007
						],
						[
							-87.22610694599996,
							30.48522248900002
						],
						[
							-87.22628968799995,
							30.485846860000038
						],
						[
							-87.22749274399996,
							30.48700423000003
						],
						[
							-87.22863488499996,
							30.487506772000074
						],
						[
							-87.23032525399998,
							30.487537229000058
						],
						[
							-87.23029479699994,
							30.48934942700004
						],
						[
							-87.22328966399994,
							30.489151456000055
						],
						[
							-87.22336580599995,
							30.48947125500007
						],
						[
							-87.22353332099999,
							30.49036974000006
						],
						[
							-87.22357900599997,
							30.491039796000052
						],
						[
							-87.22347240599998,
							30.491907823000076
						],
						[
							-87.22313737799999,
							30.49291290700006
						],
						[
							-87.22242163599999,
							30.494435763000073
						],
						[
							-87.22207137999999,
							30.49528856100005
						],
						[
							-87.22190386599999,
							30.496110903000044
						],
						[
							-87.21613224499998,
							30.496385017000083
						],
						[
							-87.21509670399996,
							30.496385017000083
						],
						[
							-87.21412207599997,
							30.49632410300006
						],
						[
							-87.21167027999996,
							30.495852018000054
						],
						[
							-87.21092408099997,
							30.495714961000033
						],
						[
							-87.20981239699995,
							30.49566927500007
						],
						[
							-87.20775654199997,
							30.49559313200007
						],
						[
							-87.20502461999996,
							30.495531235000048
						],
						[
							-87.20524638499995,
							30.488251988000062
						],
						[
							-87.19746840299996,
							30.488034981000055
						],
						[
							-87.19530581699996,
							30.489958641000044
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Escambia",
				"City": "Pensacola",
				"Name": "Walden",
				"RegionID": "249797"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.27840728999996,
					25.947246534000044,
					-80.26175212699997,
					25.971149421000064
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.26224518099997,
							25.96190106100005
						],
						[
							-80.26225784599995,
							25.961586950000026
						],
						[
							-80.26201108999999,
							25.954865625000025
						],
						[
							-80.26200977299999,
							25.954778738000073
						],
						[
							-80.26199268399995,
							25.95365087800008
						],
						[
							-80.26188979599993,
							25.952244736000072
						],
						[
							-80.26175212699997,
							25.947585663000044
						],
						[
							-80.26919682099998,
							25.947246534000044
						],
						[
							-80.26931426999994,
							25.947253527000044
						],
						[
							-80.26978013299998,
							25.94728126600006
						],
						[
							-80.26991335999998,
							25.951132587000078
						],
						[
							-80.26992148599999,
							25.951367504000075
						],
						[
							-80.27212583399995,
							25.95134321100005
						],
						[
							-80.27653558199995,
							25.95114087500008
						],
						[
							-80.27807902899997,
							25.951087181000048
						],
						[
							-80.27809051899999,
							25.951277028000053
						],
						[
							-80.278111,
							25.951627000000002
						],
						[
							-80.278094,
							25.951915
						],
						[
							-80.27817605299998,
							25.951961065000035
						],
						[
							-80.278265,
							25.952011
						],
						[
							-80.27829589199996,
							25.952629005000063
						],
						[
							-80.27829636399997,
							25.952642703000038
						],
						[
							-80.278322,
							25.953609
						],
						[
							-80.278357,
							25.953864
						],
						[
							-80.278206,
							25.953925
						],
						[
							-80.278209,
							25.954172
						],
						[
							-80.278217,
							25.95433
						],
						[
							-80.27822156699995,
							25.954425110000045
						],
						[
							-80.27829776799996,
							25.956873144000042
						],
						[
							-80.27831422099996,
							25.957401729000026
						],
						[
							-80.278312,
							25.957758000000002
						],
						[
							-80.278331,
							25.958445
						],
						[
							-80.27840728999996,
							25.960334872000033
						],
						[
							-80.27835436099997,
							25.96187351100008
						],
						[
							-80.27830384699996,
							25.963341960000037
						],
						[
							-80.278256,
							25.96373
						],
						[
							-80.278261,
							25.964194
						],
						[
							-80.27826475999996,
							25.964478236000048
						],
						[
							-80.278266,
							25.964572
						],
						[
							-80.27827,
							25.964843
						],
						[
							-80.278278,
							25.965435
						],
						[
							-80.27831683999995,
							25.967562160000057
						],
						[
							-80.278323,
							25.970977
						],
						[
							-80.277943,
							25.970983
						],
						[
							-80.26974306799997,
							25.971149421000064
						],
						[
							-80.27060909099998,
							25.970075724000026
						],
						[
							-80.27069837199997,
							25.96953461700008
						],
						[
							-80.27034867299994,
							25.968356681000046
						],
						[
							-80.26970448799995,
							25.967510039000047
						],
						[
							-80.26922595199994,
							25.965467055000033
						],
						[
							-80.26968430799997,
							25.963247467000034
						],
						[
							-80.267508272,
							25.962036971000032
						],
						[
							-80.26224518099997,
							25.96190106100005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Gardens",
				"Name": "Skyway",
				"RegionID": "251935"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.16802509299998,
					25.914647,
					-80.15424801399996,
					25.926172482000027
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.1576,
							25.915458
						],
						[
							-80.157727,
							25.915035
						],
						[
							-80.158636,
							25.914998
						],
						[
							-80.159398,
							25.91496
						],
						[
							-80.161862,
							25.914866000000004
						],
						[
							-80.163474,
							25.914804
						],
						[
							-80.164146,
							25.914777
						],
						[
							-80.167479,
							25.914647
						],
						[
							-80.16767091,
							25.91833964400007
						],
						[
							-80.16802509299998,
							25.92575845600004
						],
						[
							-80.15424801399996,
							25.926172482000027
						],
						[
							-80.155794,
							25.921213
						],
						[
							-80.156156,
							25.920057
						],
						[
							-80.15652,
							25.918897
						],
						[
							-80.156644,
							25.9185
						],
						[
							-80.156787,
							25.918044
						],
						[
							-80.1576,
							25.915458
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "North Miami Beach",
				"Name": "Allen Park",
				"RegionID": "262679"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.10299903799995,
					26.886928675000036,
					-80.09509654699997,
					26.897465330000045
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.10294913899997,
							26.896971723000036
						],
						[
							-80.10293917099995,
							26.897285728000043
						],
						[
							-80.09647349599999,
							26.897465330000045
						],
						[
							-80.09647620099997,
							26.89740906700007
						],
						[
							-80.09509654699997,
							26.89743539600005
						],
						[
							-80.09510834899999,
							26.89679915800008
						],
						[
							-80.09516033499995,
							26.89399673400004
						],
						[
							-80.09606975999998,
							26.89417824800006
						],
						[
							-80.09606978499995,
							26.894043029000045
						],
						[
							-80.09637625899995,
							26.89168117400004
						],
						[
							-80.09599188299995,
							26.890113873000075
						],
						[
							-80.09628472299994,
							26.88923535200007
						],
						[
							-80.09826951699995,
							26.889263502000063
						],
						[
							-80.09988593599996,
							26.888515160000054
						],
						[
							-80.10162208899999,
							26.88803622200004
						],
						[
							-80.10165202299999,
							26.886928675000036
						],
						[
							-80.10156423799998,
							26.895274905000065
						],
						[
							-80.10234049699994,
							26.895429840000077
						],
						[
							-80.10299903799995,
							26.895399906000023
						],
						[
							-80.10294913899997,
							26.896971723000036
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Jupiter",
				"Name": "New Haven",
				"RegionID": "263499"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.25778360299995,
					27.19122016800003,
					-80.25277483699995,
					27.20171121100003
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.25277483699995,
							27.197573329000083
						],
						[
							-80.25285097999995,
							27.19266212100007
						],
						[
							-80.25287477399996,
							27.192229059000056
						],
						[
							-80.25306513099997,
							27.19122016800003
						],
						[
							-80.25406450499997,
							27.19162943500004
						],
						[
							-80.25556356499999,
							27.19231947900005
						],
						[
							-80.25632499299996,
							27.19292862100008
						],
						[
							-80.25678184899994,
							27.193575834000058
						],
						[
							-80.25689130499995,
							27.193861370000036
						],
						[
							-80.25697220599994,
							27.194413405000034
						],
						[
							-80.25698172399996,
							27.196388357000046
						],
						[
							-80.25697028599996,
							27.196859234000044
						],
						[
							-80.25696028799996,
							27.197270827000068
						],
						[
							-80.25695317099996,
							27.197563811000066
						],
						[
							-80.25694841199999,
							27.19837758700004
						],
						[
							-80.25698648299993,
							27.199039077000066
						],
						[
							-80.25718635799996,
							27.199900442000057
						],
						[
							-80.25760080899994,
							27.20115700200006
						],
						[
							-80.25778360299995,
							27.20171121100003
						],
						[
							-80.25665097899997,
							27.200773704000028
						],
						[
							-80.25592762299993,
							27.20020263300006
						],
						[
							-80.25501866899998,
							27.19949355400007
						],
						[
							-80.25471647799998,
							27.19921991600006
						],
						[
							-80.25295458499994,
							27.197591196000076
						],
						[
							-80.25285573899998,
							27.197601882000072
						],
						[
							-80.25277483699995,
							27.197573329000083
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Martin",
				"City": "Stuart",
				"Name": "Potsdam",
				"RegionID": "264626"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.36896821599998,
					29.662836645000027,
					-82.36448806299995,
					29.666639797000077
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.36460753299998,
							29.662896381000053
						],
						[
							-82.36896821599998,
							29.662836645000027
						],
						[
							-82.36894830399997,
							29.66661988500005
						],
						[
							-82.36448806299995,
							29.666639797000077
						],
						[
							-82.36460753299998,
							29.662896381000053
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Alachua",
				"City": "Gainesville",
				"Name": "Ridgewood",
				"RegionID": "264637"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-84.31058389799995,
					30.420391622000064,
					-84.30223198899996,
					30.427910719000067
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-84.31056010299994,
							30.427910719000067
						],
						[
							-84.30963211299996,
							30.427767951000074
						],
						[
							-84.30801407999996,
							30.427648978000033
						],
						[
							-84.30584876999995,
							30.42743482700007
						],
						[
							-84.30420694199995,
							30.427268265000066
						],
						[
							-84.30361207699997,
							30.427220675000058
						],
						[
							-84.30258890899995,
							30.427315854000028
						],
						[
							-84.30223198899996,
							30.427339648000043
						],
						[
							-84.30230337299997,
							30.420391622000064
						],
						[
							-84.30656260799998,
							30.420391622000064
						],
						[
							-84.30756198199998,
							30.421938272000034
						],
						[
							-84.30765715999996,
							30.423342154000064
						],
						[
							-84.31058389799995,
							30.423365949000072
						],
						[
							-84.31056010299994,
							30.427910719000067
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Leon",
				"City": "Tallahassee",
				"Name": "Providence",
				"RegionID": "266207"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.13818738299994,
					26.623856096000054,
					-80.12972045399994,
					26.62886432700003
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.12972045399994,
							26.628778471000032
						],
						[
							-80.12981563199997,
							26.626370456000075
						],
						[
							-80.12993872999995,
							26.623856096000054
						],
						[
							-80.13405043899996,
							26.62393604500005
						],
						[
							-80.13818738299994,
							26.624109230000045
						],
						[
							-80.13806760299997,
							26.626465635000045
						],
						[
							-80.13646860499995,
							26.626456117000032
						],
						[
							-80.13393610799994,
							26.626423510000052
						],
						[
							-80.13383628199996,
							26.62886432700003
						],
						[
							-80.12972045399994,
							26.628778471000032
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Greenacres",
				"Name": "Pine Ridge",
				"RegionID": "266389"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.17035220599996,
					25.925656,
					-80.15153542799999,
					25.93476709500004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.16802509299998,
							25.92575845600004
						],
						[
							-80.170022,
							25.925656
						],
						[
							-80.170061,
							25.926624
						],
						[
							-80.17012,
							25.927486
						],
						[
							-80.170117,
							25.928054
						],
						[
							-80.170127,
							25.928432
						],
						[
							-80.170153,
							25.929337000000004
						],
						[
							-80.170178,
							25.929818
						],
						[
							-80.170175,
							25.930243
						],
						[
							-80.170188,
							25.930608
						],
						[
							-80.17020600000001,
							25.931215
						],
						[
							-80.17030834399998,
							25.93264984100006
						],
						[
							-80.17035220599996,
							25.93305388300007
						],
						[
							-80.16235721699996,
							25.93333941900005
						],
						[
							-80.15757449999995,
							25.933553570000072
						],
						[
							-80.15621820699994,
							25.934081811000055
						],
						[
							-80.15510461999999,
							25.934510114000034
						],
						[
							-80.15426228999998,
							25.934638604000043
						],
						[
							-80.15153542799999,
							25.93476709500004
						],
						[
							-80.15424801399996,
							25.926172482000027
						],
						[
							-80.16802509299998,
							25.92575845600004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "North Miami Beach",
				"Name": "City Center",
				"RegionID": "268068"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.6801219109999,
					30.35567695300006,
					-81.66867490599992,
					30.365682008000082
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.67400390599994,
							30.36490100800006
						],
						[
							-81.67373390599994,
							30.36489600800007
						],
						[
							-81.67268690499992,
							30.364913008000087
						],
						[
							-81.6721279059999,
							30.36492000800007
						],
						[
							-81.67143590599994,
							30.364928009000035
						],
						[
							-81.67075190599991,
							30.364931008000045
						],
						[
							-81.67065090499995,
							30.364931008000045
						],
						[
							-81.66981190599995,
							30.364928009000035
						],
						[
							-81.66889381699991,
							30.364943023000084
						],
						[
							-81.66888790599995,
							30.364784008000072
						],
						[
							-81.6688859059999,
							30.364703008000053
						],
						[
							-81.6688799069999,
							30.364581008000073
						],
						[
							-81.66887490699992,
							30.364097008000048
						],
						[
							-81.66885390599992,
							30.363541009000073
						],
						[
							-81.66885090499994,
							30.36304700800008
						],
						[
							-81.66885090499994,
							30.362745008000044
						],
						[
							-81.66884590699993,
							30.362321008000034
						],
						[
							-81.66882190699994,
							30.36159300900005
						],
						[
							-81.66881190599992,
							30.361383009000065
						],
						[
							-81.66880390699993,
							30.360890009000062
						],
						[
							-81.66880090699993,
							30.36045900900007
						],
						[
							-81.66879090599991,
							30.360178008000048
						],
						[
							-81.6687679069999,
							30.359519008000063
						],
						[
							-81.66876590699991,
							30.35944500900007
						],
						[
							-81.66875790699993,
							30.359217009000076
						],
						[
							-81.6687479069999,
							30.358902009000076
						],
						[
							-81.6687409079999,
							30.35874300900008
						],
						[
							-81.6687289059999,
							30.358307008000054
						],
						[
							-81.66872590699991,
							30.35826500900004
						],
						[
							-81.66869690599992,
							30.357669009000062
						],
						[
							-81.66869090699993,
							30.357303009000077
						],
						[
							-81.66869090699993,
							30.356498009000063
						],
						[
							-81.66868790599995,
							30.356315008000085
						],
						[
							-81.66867490599992,
							30.356106011000065
						],
						[
							-81.66895790599995,
							30.356099008000058
						],
						[
							-81.66954990599993,
							30.356087008000085
						],
						[
							-81.67012790599995,
							30.35607200900006
						],
						[
							-81.67158804499991,
							30.35604406200008
						],
						[
							-81.6715007599999,
							30.35595996100005
						],
						[
							-81.67191990499992,
							30.355925008000042
						],
						[
							-81.67311698399993,
							30.355763833000086
						],
						[
							-81.6731638249999,
							30.355833184000062
						],
						[
							-81.67381990599995,
							30.355759009000053
						],
						[
							-81.67441590599992,
							30.355712008000065
						],
						[
							-81.67492690599994,
							30.355692008000062
						],
						[
							-81.67517890599993,
							30.35568200900008
						],
						[
							-81.67591090699995,
							30.35567695300006
						],
						[
							-81.67591890599994,
							30.356091008000078
						],
						[
							-81.67594090599994,
							30.356760009000087
						],
						[
							-81.67594890599992,
							30.357271008000055
						],
						[
							-81.67596390499995,
							30.357450008000058
						],
						[
							-81.6759569059999,
							30.357584008000057
						],
						[
							-81.67597190499993,
							30.358131008000043
						],
						[
							-81.67597990599995,
							30.358826009000044
						],
						[
							-81.67600290599997,
							30.35951200900007
						],
						[
							-81.67600973499992,
							30.359911057000094
						],
						[
							-81.6762009059999,
							30.360210008000077
						],
						[
							-81.6766969059999,
							30.36088600800008
						],
						[
							-81.6771699059999,
							30.361574009000037
						],
						[
							-81.67739890599995,
							30.36191200900004
						],
						[
							-81.67764290499991,
							30.362251008000044
						],
						[
							-81.67768390599991,
							30.36231000800007
						],
						[
							-81.67812290599994,
							30.362940009000056
						],
						[
							-81.67850790499995,
							30.36348000800007
						],
						[
							-81.67860390499993,
							30.36362300800005
						],
						[
							-81.67894690599991,
							30.364107009000065
						],
						[
							-81.67908490499991,
							30.364290008000065
						],
						[
							-81.67934390499994,
							30.364637009000038
						],
						[
							-81.67959590499993,
							30.364960008000082
						],
						[
							-81.6801219109999,
							30.365640925000037
						],
						[
							-81.67997690599992,
							30.36566700800006
						],
						[
							-81.67979390499994,
							30.365677009000077
						],
						[
							-81.6792689049999,
							30.365681008000085
						],
						[
							-81.67783290599995,
							30.365682008000082
						],
						[
							-81.67776690499994,
							30.365681008000085
						],
						[
							-81.67725290599992,
							30.365672008000047
						],
						[
							-81.67695990499993,
							30.365635009000073
						],
						[
							-81.67662290599992,
							30.36556900800008
						],
						[
							-81.67610890599991,
							30.365433009000075
						],
						[
							-81.67524690499994,
							30.36517300800006
						],
						[
							-81.67481990599993,
							30.365046009000082
						],
						[
							-81.67432390499994,
							30.36494100800007
						],
						[
							-81.67400390599994,
							30.36490100800006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "29th and Chase",
				"RegionID": "268865"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.5781609089999,
					30.352039010000055,
					-81.55228386999994,
					30.366855012000087
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.55892190899993,
							30.366709012000058
						],
						[
							-81.55856590999991,
							30.366548011000077
						],
						[
							-81.55840490999992,
							30.366449012000093
						],
						[
							-81.55817390899995,
							30.366266012000043
						],
						[
							-81.5579679089999,
							30.366074013000055
						],
						[
							-81.5578309089999,
							30.365948012000043
						],
						[
							-81.55680790999992,
							30.365082012000073
						],
						[
							-81.55577090999992,
							30.36417001200004
						],
						[
							-81.55445890999994,
							30.363039012000062
						],
						[
							-81.55394990899993,
							30.362585012000068
						],
						[
							-81.55343790899991,
							30.362127012000087
						],
						[
							-81.55335990899994,
							30.362057013000083
						],
						[
							-81.55317190999995,
							30.361893013000046
						],
						[
							-81.55228386999994,
							30.361099050000064
						],
						[
							-81.55233490899991,
							30.361030012000068
						],
						[
							-81.55237599299994,
							30.360949036000083
						],
						[
							-81.55239890899992,
							30.36067401200006
						],
						[
							-81.5523849089999,
							30.36040101200007
						],
						[
							-81.5523759109999,
							30.36023501300008
						],
						[
							-81.55239090999993,
							30.359945013000072
						],
						[
							-81.55239090999993,
							30.359749013000055
						],
						[
							-81.55238690899995,
							30.358979012000077
						],
						[
							-81.5523559099999,
							30.358556013000058
						],
						[
							-81.55235190999991,
							30.35788401200006
						],
						[
							-81.55234490999993,
							30.357512012000083
						],
						[
							-81.55234977799995,
							30.35711198800004
						],
						[
							-81.5526710389999,
							30.356367035000062
						],
						[
							-81.55261690999993,
							30.355782012000077
						],
						[
							-81.5526279099999,
							30.354841012000062
						],
						[
							-81.55263490899995,
							30.354134013000078
						],
						[
							-81.55258990999994,
							30.353822013000073
						],
						[
							-81.55256990999993,
							30.353670012000062
						],
						[
							-81.55256790999994,
							30.352955012000056
						],
						[
							-81.5525668539999,
							30.352427012000078
						],
						[
							-81.55324790799995,
							30.352428010000043
						],
						[
							-81.55446290799995,
							30.352418010000065
						],
						[
							-81.55476790799992,
							30.35241601000007
						],
						[
							-81.5550709069999,
							30.35241201000008
						],
						[
							-81.5557649079999,
							30.352404010000043
						],
						[
							-81.55673090699992,
							30.352393010000068
						],
						[
							-81.55760790699992,
							30.35237501000006
						],
						[
							-81.5578859069999,
							30.35237601000006
						],
						[
							-81.55864290699992,
							30.35237501000006
						],
						[
							-81.5600449069999,
							30.35236801100007
						],
						[
							-81.5600899069999,
							30.35236801100007
						],
						[
							-81.56052890799992,
							30.352366011000075
						],
						[
							-81.56082190699995,
							30.352358010000046
						],
						[
							-81.56522390799995,
							30.352257010000073
						],
						[
							-81.56599390799994,
							30.35223401100006
						],
						[
							-81.56705490699994,
							30.35220901000008
						],
						[
							-81.56880990699995,
							30.35217301100005
						],
						[
							-81.57089190799991,
							30.35213301100004
						],
						[
							-81.57134990799995,
							30.352121010000076
						],
						[
							-81.57384490699991,
							30.352089010000043
						],
						[
							-81.57586690799991,
							30.352060010000063
						],
						[
							-81.57756591499992,
							30.352039010000055
						],
						[
							-81.57758790999992,
							30.35237101300004
						],
						[
							-81.57761885999993,
							30.35252703100008
						],
						[
							-81.57768591199994,
							30.35266001300005
						],
						[
							-81.5779619079999,
							30.352988012000083
						],
						[
							-81.57805290699991,
							30.353153011000074
						],
						[
							-81.57808890899992,
							30.353280012000088
						],
						[
							-81.57811390899991,
							30.353486012000076
						],
						[
							-81.57812390999993,
							30.354468013000087
						],
						[
							-81.5781349099999,
							30.35499401300007
						],
						[
							-81.57815190999992,
							30.356109012000044
						],
						[
							-81.5781609089999,
							30.356419012000064
						],
						[
							-81.57814596299994,
							30.35666302200008
						],
						[
							-81.57804890999995,
							30.35700001200007
						],
						[
							-81.57797790899991,
							30.35724201300008
						],
						[
							-81.5777959099999,
							30.357810012000073
						],
						[
							-81.57753990999993,
							30.358633012000045
						],
						[
							-81.57744990899994,
							30.358971013000087
						],
						[
							-81.57733890999992,
							30.359339013000067
						],
						[
							-81.57729990999991,
							30.35951901200008
						],
						[
							-81.5772609089999,
							30.360297012000046
						],
						[
							-81.57723990899991,
							30.360996013000094
						],
						[
							-81.57722490999993,
							30.361232013000066
						],
						[
							-81.57717790899994,
							30.362198012000075
						],
						[
							-81.57715490999993,
							30.362882012000057
						],
						[
							-81.57710790999994,
							30.363880012000042
						],
						[
							-81.57707990999995,
							30.36466701200004
						],
						[
							-81.57706490899994,
							30.36508901200006
						],
						[
							-81.57703894699995,
							30.365619080000045
						],
						[
							-81.57436393299992,
							30.36664214400008
						],
						[
							-81.57303890899993,
							30.366664012000058
						],
						[
							-81.57195990999992,
							30.36666301200006
						],
						[
							-81.57044390999994,
							30.36669201300009
						],
						[
							-81.57036790899991,
							30.36669201300009
						],
						[
							-81.57009990899991,
							30.366698012000082
						],
						[
							-81.56966389099995,
							30.366702923000048
						],
						[
							-81.56887790999991,
							30.366728012000067
						],
						[
							-81.56793890999995,
							30.366733012000058
						],
						[
							-81.5675579089999,
							30.366735012000053
						],
						[
							-81.5673109089999,
							30.366736013000036
						],
						[
							-81.5671069089999,
							30.366746012000075
						],
						[
							-81.56680290899993,
							30.366760012000043
						],
						[
							-81.56619290899994,
							30.366762012000038
						],
						[
							-81.56569690999993,
							30.366768013000073
						],
						[
							-81.56488890899993,
							30.366771013000065
						],
						[
							-81.56423090899995,
							30.366780012000053
						],
						[
							-81.56339890999993,
							30.366795013000058
						],
						[
							-81.56302290999992,
							30.36681401300007
						],
						[
							-81.56213990999993,
							30.366832012000092
						],
						[
							-81.56165990999995,
							30.36683301200009
						],
						[
							-81.56104290999991,
							30.366837012000072
						],
						[
							-81.55969290999991,
							30.366855012000087
						],
						[
							-81.55953590999991,
							30.366846013000043
						],
						[
							-81.55936390999995,
							30.366823012000058
						],
						[
							-81.5591349099999,
							30.36677701200006
						],
						[
							-81.55892190899993,
							30.366709012000058
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Arlington Hills",
				"RegionID": "268872"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.5823478659999,
					30.334925077000037,
					-81.55232577499993,
					30.352428010000043
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.5525668539999,
							30.352427012000078
						],
						[
							-81.55252590799995,
							30.350161011000072
						],
						[
							-81.55252090699992,
							30.34980201000008
						],
						[
							-81.55250790799994,
							30.349111011000048
						],
						[
							-81.55249790699992,
							30.348768010000075
						],
						[
							-81.5524769079999,
							30.347574011000063
						],
						[
							-81.55247290799991,
							30.346961010000086
						],
						[
							-81.5524549079999,
							30.346192010000042
						],
						[
							-81.55241790799994,
							30.343780010000046
						],
						[
							-81.55238090799992,
							30.341701011000055
						],
						[
							-81.55237590799993,
							30.340790010000035
						],
						[
							-81.55236090699992,
							30.34031501000004
						],
						[
							-81.55232790799994,
							30.337927010000044
						],
						[
							-81.55232577499993,
							30.337733877000062
						],
						[
							-81.5525699069999,
							30.33773801100006
						],
						[
							-81.5527539069999,
							30.33774501000005
						],
						[
							-81.55306190699991,
							30.33775501100007
						],
						[
							-81.55338590799994,
							30.33775201000009
						],
						[
							-81.55725890699995,
							30.337849010000074
						],
						[
							-81.5584489069999,
							30.337893010000077
						],
						[
							-81.55888390799993,
							30.33789601000007
						],
						[
							-81.55943290899995,
							30.337934010000083
						],
						[
							-81.56002291599992,
							30.337931062000056
						],
						[
							-81.5603869059999,
							30.33792100800008
						],
						[
							-81.56083690499992,
							30.33791400800004
						],
						[
							-81.56249190599993,
							30.33785800800007
						],
						[
							-81.56310290599993,
							30.337831009000066
						],
						[
							-81.56341590499994,
							30.33782800900008
						],
						[
							-81.56386590499994,
							30.337805008000085
						],
						[
							-81.56415590599994,
							30.33779900800005
						],
						[
							-81.56471990599994,
							30.33778000800004
						],
						[
							-81.56526190599993,
							30.33778800800008
						],
						[
							-81.5654979059999,
							30.33775300900004
						],
						[
							-81.56600190599994,
							30.337744008000076
						],
						[
							-81.56684090599994,
							30.33771100900009
						],
						[
							-81.5673039049999,
							30.337708008000053
						],
						[
							-81.5684739049999,
							30.337667008000036
						],
						[
							-81.56894690599995,
							30.33765600800007
						],
						[
							-81.56904390599995,
							30.337655008000073
						],
						[
							-81.57008490599992,
							30.337650008000086
						],
						[
							-81.57105990599992,
							30.337645008000038
						],
						[
							-81.57204790599991,
							30.337645008000038
						],
						[
							-81.57318890599993,
							30.337646008000036
						],
						[
							-81.57402990599991,
							30.337645008000038
						],
						[
							-81.57498190599995,
							30.337645008000038
						],
						[
							-81.57539190599994,
							30.337643008000043
						],
						[
							-81.57555090499994,
							30.337642008000046
						],
						[
							-81.57609190599993,
							30.337643009000086
						],
						[
							-81.57625790499992,
							30.337630008000076
						],
						[
							-81.57639890599995,
							30.337600008000038
						],
						[
							-81.57653690599994,
							30.337552008000046
						],
						[
							-81.57666990599995,
							30.337484009000036
						],
						[
							-81.57703190599995,
							30.337263009000086
						],
						[
							-81.5771449049999,
							30.337195008000034
						],
						[
							-81.57719190499995,
							30.33716500900005
						],
						[
							-81.57789090599994,
							30.336716009000043
						],
						[
							-81.5779529049999,
							30.336686008000072
						],
						[
							-81.57807090499995,
							30.33662800800005
						],
						[
							-81.57868190599993,
							30.336254008000086
						],
						[
							-81.57874890599993,
							30.336213009000062
						],
						[
							-81.57887290499991,
							30.33613600800004
						],
						[
							-81.57915790499993,
							30.335979009000084
						],
						[
							-81.57947090499994,
							30.335785009000062
						],
						[
							-81.58061990599992,
							30.335067008000067
						],
						[
							-81.58086599199993,
							30.334925077000037
						],
						[
							-81.58061182599994,
							30.338280028000046
						],
						[
							-81.58144898699993,
							30.339891988000094
						],
						[
							-81.58146173699993,
							30.343350056000077
						],
						[
							-81.58195598499992,
							30.344047973000045
						],
						[
							-81.58201790699991,
							30.34434300900006
						],
						[
							-81.5823478659999,
							30.345270060000075
						],
						[
							-81.58222190599992,
							30.345268010000037
						],
						[
							-81.58208490599992,
							30.34529500900004
						],
						[
							-81.58203890699991,
							30.345312009000054
						],
						[
							-81.5816189059999,
							30.345577009000067
						],
						[
							-81.58127590599993,
							30.34578300800007
						],
						[
							-81.5807649059999,
							30.346109009000088
						],
						[
							-81.58044990499991,
							30.34630100900006
						],
						[
							-81.57986490499991,
							30.34666300800006
						],
						[
							-81.57916290399993,
							30.347094008000056
						],
						[
							-81.57907890599995,
							30.347126007000043
						],
						[
							-81.57892590499995,
							30.347157007000078
						],
						[
							-81.57836890599994,
							30.347151008000083
						],
						[
							-81.57747677499992,
							30.34715987900006
						],
						[
							-81.57749190599992,
							30.347992009000055
						],
						[
							-81.5775049049999,
							30.348803009000047
						],
						[
							-81.57750690499995,
							30.34890600800009
						],
						[
							-81.57755590599993,
							30.351177009000086
						],
						[
							-81.57756591499992,
							30.352039010000055
						],
						[
							-81.57586690799991,
							30.352060010000063
						],
						[
							-81.57384490699991,
							30.352089010000043
						],
						[
							-81.57134990799995,
							30.352121010000076
						],
						[
							-81.57089190799991,
							30.35213301100004
						],
						[
							-81.56880990699995,
							30.35217301100005
						],
						[
							-81.56705490699994,
							30.35220901000008
						],
						[
							-81.56599390799994,
							30.35223401100006
						],
						[
							-81.56522390799995,
							30.352257010000073
						],
						[
							-81.56082190699995,
							30.352358010000046
						],
						[
							-81.56052890799992,
							30.352366011000075
						],
						[
							-81.5600899069999,
							30.35236801100007
						],
						[
							-81.5600449069999,
							30.35236801100007
						],
						[
							-81.55864290699992,
							30.35237501000006
						],
						[
							-81.5578859069999,
							30.35237601000006
						],
						[
							-81.55760790699992,
							30.35237501000006
						],
						[
							-81.55673090699992,
							30.352393010000068
						],
						[
							-81.5557649079999,
							30.352404010000043
						],
						[
							-81.5550709069999,
							30.35241201000008
						],
						[
							-81.55476790799992,
							30.35241601000007
						],
						[
							-81.55446290799995,
							30.352418010000065
						],
						[
							-81.55324790799995,
							30.352428010000043
						],
						[
							-81.5525668539999,
							30.352427012000078
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Arlingwood",
				"RegionID": "268874"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.34002099999992,
					28.556985546000078,
					-81.31496299999992,
					28.581790000000073
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.3154429999999,
							28.578338000000088
						],
						[
							-81.31528999999995,
							28.575278000000083
						],
						[
							-81.3152121359999,
							28.57528203700008
						],
						[
							-81.31515499999995,
							28.575285000000065
						],
						[
							-81.31515499999995,
							28.57347800000008
						],
						[
							-81.3151553969999,
							28.573319077000065
						],
						[
							-81.31515799999994,
							28.57227800000004
						],
						[
							-81.31507299999993,
							28.570478000000037
						],
						[
							-81.3150849999999,
							28.569878000000074
						],
						[
							-81.3150609999999,
							28.569278000000054
						],
						[
							-81.31506531399992,
							28.569248445000085
						],
						[
							-81.3151749999999,
							28.568497000000036
						],
						[
							-81.31503967099991,
							28.56624002500007
						],
						[
							-81.31496399999992,
							28.564978000000053
						],
						[
							-81.31496345999994,
							28.564761970000067
						],
						[
							-81.31496317999995,
							28.56464996300008
						],
						[
							-81.31496299999992,
							28.56457800000004
						],
						[
							-81.31508999999994,
							28.56457800000004
						],
						[
							-81.3151177929999,
							28.56457800000004
						],
						[
							-81.31514599999991,
							28.56457800000004
						],
						[
							-81.31514599999991,
							28.564410000000066
						],
						[
							-81.31514599999991,
							28.56397800000008
						],
						[
							-81.31514299999992,
							28.563608000000045
						],
						[
							-81.31514699999991,
							28.562880000000064
						],
						[
							-81.31528999999995,
							28.56287800000007
						],
						[
							-81.31539199999992,
							28.562876000000077
						],
						[
							-81.31539199999992,
							28.562775000000045
						],
						[
							-81.31538999999992,
							28.562659000000053
						],
						[
							-81.31550299999992,
							28.562659000000053
						],
						[
							-81.31550299999992,
							28.56247800000006
						],
						[
							-81.31561499999992,
							28.56247800000006
						],
						[
							-81.31561499999992,
							28.561929000000077
						],
						[
							-81.31579199999993,
							28.561926000000085
						],
						[
							-81.31605799999994,
							28.561920000000043
						],
						[
							-81.31605999999994,
							28.561752000000073
						],
						[
							-81.31610699999993,
							28.561745000000087
						],
						[
							-81.3163199999999,
							28.56171100000006
						],
						[
							-81.31631799999991,
							28.56157200000007
						],
						[
							-81.31646599999993,
							28.56157200000007
						],
						[
							-81.3164693619999,
							28.56138979700006
						],
						[
							-81.31647099999992,
							28.56130100000007
						],
						[
							-81.31658399999992,
							28.56126500000005
						],
						[
							-81.31663213999991,
							28.561243843000057
						],
						[
							-81.31721199999993,
							28.560989000000063
						],
						[
							-81.31723599999992,
							28.560966000000064
						],
						[
							-81.31736699999993,
							28.56083600000005
						],
						[
							-81.3174109489999,
							28.56076954000008
						],
						[
							-81.3174338359999,
							28.56073493100007
						],
						[
							-81.3174489999999,
							28.56071200000008
						],
						[
							-81.3177660639999,
							28.560300718000065
						],
						[
							-81.31783599999994,
							28.56021000000004
						],
						[
							-81.31790099999995,
							28.56011600000005
						],
						[
							-81.31808199999995,
							28.559885000000065
						],
						[
							-81.31821699999995,
							28.559705000000065
						],
						[
							-81.31845499999991,
							28.55890000000005
						],
						[
							-81.3185519999999,
							28.558659000000038
						],
						[
							-81.31979688399991,
							28.55866254700004
						],
						[
							-81.31995599999993,
							28.55866300000008
						],
						[
							-81.32015424799994,
							28.558661981000057
						],
						[
							-81.32034499999992,
							28.558661000000086
						],
						[
							-81.32034699999991,
							28.55856400000005
						],
						[
							-81.32034599999993,
							28.558500000000038
						],
						[
							-81.32034699999991,
							28.558380000000056
						],
						[
							-81.32078999999993,
							28.55837900000006
						],
						[
							-81.32083899999992,
							28.558377000000068
						],
						[
							-81.32083999999992,
							28.558279000000084
						],
						[
							-81.32083699999993,
							28.558122000000083
						],
						[
							-81.3208709999999,
							28.558122000000083
						],
						[
							-81.3210279999999,
							28.558122000000083
						],
						[
							-81.32124799999991,
							28.558122000000083
						],
						[
							-81.32124599999992,
							28.55798100000004
						],
						[
							-81.32178999999991,
							28.55797900000005
						],
						[
							-81.32196299999993,
							28.55797900000005
						],
						[
							-81.32196299999993,
							28.55785300000008
						],
						[
							-81.32265283099991,
							28.55785300000008
						],
						[
							-81.32278599999995,
							28.55785300000008
						],
						[
							-81.32363218099994,
							28.557861424000066
						],
						[
							-81.32368999999994,
							28.55786200000006
						],
						[
							-81.32369586199991,
							28.55786200000006
						],
						[
							-81.32465666199994,
							28.55786200000006
						],
						[
							-81.32469099999992,
							28.55786200000006
						],
						[
							-81.3252839999999,
							28.55786200000006
						],
						[
							-81.32548999999995,
							28.557858000000067
						],
						[
							-81.32585099999994,
							28.557858000000067
						],
						[
							-81.32668999999993,
							28.557858000000067
						],
						[
							-81.3273079999999,
							28.557859000000064
						],
						[
							-81.32730399999991,
							28.557744000000074
						],
						[
							-81.32729899999993,
							28.557633000000067
						],
						[
							-81.32729799999993,
							28.55755300000004
						],
						[
							-81.32745699999992,
							28.55754900000005
						],
						[
							-81.32941599999992,
							28.557530000000042
						],
						[
							-81.32965754199995,
							28.55700808000006
						],
						[
							-81.33027483299992,
							28.557023146000063
						],
						[
							-81.3304355489999,
							28.557088874000044
						],
						[
							-81.33055572599994,
							28.557112909000068
						],
						[
							-81.33088020799994,
							28.557108904000074
						],
						[
							-81.33123777999992,
							28.557063963000076
						],
						[
							-81.33134287299993,
							28.557008705000044
						],
						[
							-81.33144810599993,
							28.556985546000078
						],
						[
							-81.33159018399994,
							28.55713811700008
						],
						[
							-81.33241648599994,
							28.55715297000006
						],
						[
							-81.33337590799995,
							28.557170998000064
						],
						[
							-81.33347205099994,
							28.55717199800006
						],
						[
							-81.33356031199992,
							28.55716785700008
						],
						[
							-81.33356632399995,
							28.558291789000066
						],
						[
							-81.33348293299991,
							28.558294536000062
						],
						[
							-81.33348607199991,
							28.558693255000037
						],
						[
							-81.33349207899994,
							28.559256090000076
						],
						[
							-81.33350009199995,
							28.56022252300005
						],
						[
							-81.33351906599995,
							28.560884499000053
						],
						[
							-81.33353314199991,
							28.56214938100004
						],
						[
							-81.33355417199994,
							28.56250290400004
						],
						[
							-81.33356018099994,
							28.562824380000052
						],
						[
							-81.33357420199991,
							28.56332612600005
						],
						[
							-81.33361325899995,
							28.56422245500005
						],
						[
							-81.33362627899993,
							28.564562961000036
						],
						[
							-81.33369337799991,
							28.566255469000055
						],
						[
							-81.33371741399992,
							28.566968528000075
						],
						[
							-81.33372843099994,
							28.567581437000058
						],
						[
							-81.3337454569999,
							28.56774968800005
						],
						[
							-81.33376966999992,
							28.567817855000044
						],
						[
							-81.33368720399994,
							28.567855749000046
						],
						[
							-81.33368921099992,
							28.56788096600008
						],
						[
							-81.33374338999994,
							28.56792107800004
						],
						[
							-81.33383659399993,
							28.567944974000056
						],
						[
							-81.33465580599994,
							28.567944976000035
						],
						[
							-81.33504137699992,
							28.567942973000072
						],
						[
							-81.3357844809999,
							28.567937965000056
						],
						[
							-81.33786456299993,
							28.56790992300006
						],
						[
							-81.33841437899991,
							28.567912927000066
						],
						[
							-81.33929768899992,
							28.56790992300006
						],
						[
							-81.33974336799992,
							28.56790992300006
						],
						[
							-81.33990159099994,
							28.567909649000057
						],
						[
							-81.33990399999993,
							28.568096000000082
						],
						[
							-81.33991099999992,
							28.568614000000082
						],
						[
							-81.33993399999991,
							28.57087400000006
						],
						[
							-81.33994599999994,
							28.571555000000046
						],
						[
							-81.33995699999991,
							28.572178000000065
						],
						[
							-81.33998999999994,
							28.573978000000068
						],
						[
							-81.34000199999991,
							28.57496000000009
						],
						[
							-81.34002099999992,
							28.57858000000005
						],
						[
							-81.33992410499991,
							28.57858155000008
						],
						[
							-81.33977099999993,
							28.578584000000035
						],
						[
							-81.33562799999993,
							28.578635000000077
						],
						[
							-81.33439799999991,
							28.57865100000004
						],
						[
							-81.3331389999999,
							28.578665000000058
						],
						[
							-81.33312499999994,
							28.57827800000007
						],
						[
							-81.33312599999994,
							28.576988000000085
						],
						[
							-81.33312599999994,
							28.57688500000006
						],
						[
							-81.33299099999994,
							28.57688500000006
						],
						[
							-81.33298699999995,
							28.576992000000075
						],
						[
							-81.3318809999999,
							28.576989000000083
						],
						[
							-81.33175699999993,
							28.57699400000007
						],
						[
							-81.33176399999991,
							28.57687400000009
						],
						[
							-81.33173954599994,
							28.576565065000068
						],
						[
							-81.33173399999993,
							28.57649500000008
						],
						[
							-81.33170899999993,
							28.576275000000066
						],
						[
							-81.33167999999995,
							28.57556800000009
						],
						[
							-81.33166899999992,
							28.575312000000054
						],
						[
							-81.32840599999993,
							28.57535400000006
						],
						[
							-81.32852099999991,
							28.575254000000086
						],
						[
							-81.32758999999993,
							28.575278000000083
						],
						[
							-81.3265899999999,
							28.575278000000083
						],
						[
							-81.32644610299991,
							28.575278000000083
						],
						[
							-81.32509354599995,
							28.575278000000083
						],
						[
							-81.3253604439999,
							28.575096983000037
						],
						[
							-81.32548980899992,
							28.574949949000086
						],
						[
							-81.32552908299994,
							28.574908083000082
						],
						[
							-81.32554687299995,
							28.574890778000057
						],
						[
							-81.32600692299991,
							28.57445544400008
						],
						[
							-81.32618821599993,
							28.574088310000036
						],
						[
							-81.32660309799991,
							28.572861828000043
						],
						[
							-81.3266034049999,
							28.572860923000064
						],
						[
							-81.32661503199995,
							28.57282869900007
						],
						[
							-81.32668503299993,
							28.572645699000077
						],
						[
							-81.32668793199991,
							28.572638219000055
						],
						[
							-81.32684078999995,
							28.57224904600008
						],
						[
							-81.32688193999991,
							28.57208504400006
						],
						[
							-81.32688537599995,
							28.572056571000076
						],
						[
							-81.32686582799994,
							28.571999866000056
						],
						[
							-81.32583716499994,
							28.57037099900009
						],
						[
							-81.32565084399994,
							28.570184677000043
						],
						[
							-81.3254135169999,
							28.570038731000068
						],
						[
							-81.3252235619999,
							28.569943754000064
						],
						[
							-81.32439097299994,
							28.56971470500008
						],
						[
							-81.32342839299992,
							28.569539863000045
						],
						[
							-81.32256073399992,
							28.569404680000048
						],
						[
							-81.32160002099994,
							28.569312505000084
						],
						[
							-81.32065402099994,
							28.569272519000037
						],
						[
							-81.32063318199994,
							28.56927139600009
						],
						[
							-81.32058285999994,
							28.56926667500005
						],
						[
							-81.32003485999991,
							28.56919967500005
						],
						[
							-81.3200266149999,
							28.569198628000038
						],
						[
							-81.31996855099993,
							28.569189042000062
						],
						[
							-81.31993697099996,
							28.569182168000054
						],
						[
							-81.31975096999992,
							28.569138168000052
						],
						[
							-81.31974940499992,
							28.569137796000064
						],
						[
							-81.31965854899995,
							28.569156486000058
						],
						[
							-81.31953168699994,
							28.569189059000053
						],
						[
							-81.31921865999993,
							28.56939774300008
						],
						[
							-81.3188824049999,
							28.56971614400004
						],
						[
							-81.31846370099994,
							28.57029133900005
						],
						[
							-81.31847704099994,
							28.570348551000052
						],
						[
							-81.3184866279999,
							28.57040661500008
						],
						[
							-81.3184923959999,
							28.57046518100009
						],
						[
							-81.31849432199994,
							28.570524000000034
						],
						[
							-81.3184923959999,
							28.570582818000048
						],
						[
							-81.31849023799992,
							28.57060961000008
						],
						[
							-81.3184552379999,
							28.570975609000072
						],
						[
							-81.31845162799993,
							28.571007385000087
						],
						[
							-81.3184420419999,
							28.57106544900006
						],
						[
							-81.31842867799992,
							28.571122761000087
						],
						[
							-81.31841159499993,
							28.571179077000068
						],
						[
							-81.31840402499995,
							28.571200486000066
						],
						[
							-81.31828926299995,
							28.57151245400007
						],
						[
							-81.31830175899995,
							28.572021319000044
						],
						[
							-81.31838134199995,
							28.572580224000035
						],
						[
							-81.31838262799994,
							28.572589615000084
						],
						[
							-81.3183869909999,
							28.572629668000047
						],
						[
							-81.31845707199994,
							28.57344164700004
						],
						[
							-81.31865484699995,
							28.573789597000086
						],
						[
							-81.31867957699991,
							28.57383624000005
						],
						[
							-81.3186986209999,
							28.573877448000076
						],
						[
							-81.31892544899995,
							28.574402683000073
						],
						[
							-81.31918201099995,
							28.574867974000085
						],
						[
							-81.31941702499995,
							28.575223122000068
						],
						[
							-81.31952579699993,
							28.575325208000038
						],
						[
							-81.31977060399993,
							28.57548396100009
						],
						[
							-81.31986645599994,
							28.575539913000057
						],
						[
							-81.32012599099994,
							28.575615996000067
						],
						[
							-81.3201620779999,
							28.575627405000034
						],
						[
							-81.3202171559999,
							28.57564813500005
						],
						[
							-81.32027075999991,
							28.57567242300007
						],
						[
							-81.3203208509999,
							28.57569912200006
						],
						[
							-81.3208091489999,
							28.575979531000087
						],
						[
							-81.32108705199994,
							28.57612366300009
						],
						[
							-81.32110737699992,
							28.576134537000087
						],
						[
							-81.3211629239999,
							28.576165178000053
						],
						[
							-81.3212774509999,
							28.576151253000035
						],
						[
							-81.3213271809999,
							28.57614660300004
						],
						[
							-81.3213859999999,
							28.57614467800005
						],
						[
							-81.32144481799992,
							28.57614660300004
						],
						[
							-81.32150338499991,
							28.57615237200008
						],
						[
							-81.32156144899994,
							28.57616195800006
						],
						[
							-81.3216187619999,
							28.57617532200004
						],
						[
							-81.32167507699995,
							28.576192405000086
						],
						[
							-81.3217301549999,
							28.576213135000046
						],
						[
							-81.3217837599999,
							28.576237423000066
						],
						[
							-81.32183566099991,
							28.576265164000063
						],
						[
							-81.32187010799993,
							28.576286095000057
						],
						[
							-81.3220611079999,
							28.57640809600008
						],
						[
							-81.3220766359999,
							28.576418241000056
						],
						[
							-81.32212447199993,
							28.576452520000093
						],
						[
							-81.3221699639999,
							28.576489854000044
						],
						[
							-81.32217085399992,
							28.576490636000074
						],
						[
							-81.32221080699992,
							28.576525767000078
						],
						[
							-81.3223017979999,
							28.576556872000083
						],
						[
							-81.32251239499993,
							28.576600603000088
						],
						[
							-81.32270409699993,
							28.57659630200004
						],
						[
							-81.32292716599994,
							28.576582484000085
						],
						[
							-81.32292924099994,
							28.576579363000064
						],
						[
							-81.32296351999992,
							28.576531527000043
						],
						[
							-81.32300085399993,
							28.576486036000063
						],
						[
							-81.3230410839999,
							28.576443083000072
						],
						[
							-81.3230840359999,
							28.576402854000037
						],
						[
							-81.32312952799992,
							28.57636552000008
						],
						[
							-81.32317736399995,
							28.576331241000048
						],
						[
							-81.32322733899993,
							28.576300164000088
						],
						[
							-81.32327923999992,
							28.576272422000045
						],
						[
							-81.3233232209999,
							28.576252187000083
						],
						[
							-81.32353121999996,
							28.576163187000077
						],
						[
							-81.32354084399992,
							28.57615913500007
						],
						[
							-81.32359592199992,
							28.57613840500005
						],
						[
							-81.3236501479999,
							28.576121885000077
						],
						[
							-81.32376313799995,
							28.576091317000078
						],
						[
							-81.32376518699994,
							28.57609025000005
						],
						[
							-81.32379461499994,
							28.57606906300009
						],
						[
							-81.32385062399993,
							28.576017770000078
						],
						[
							-81.32386503599992,
							28.57600485400008
						],
						[
							-81.32386843699994,
							28.576001886000086
						],
						[
							-81.32395943699993,
							28.575922886000058
						],
						[
							-81.32400152699995,
							28.575888520000035
						],
						[
							-81.32404936299993,
							28.57585424100006
						],
						[
							-81.32409933899993,
							28.575823165000088
						],
						[
							-81.32415123999995,
							28.57579542300005
						],
						[
							-81.32415526999995,
							28.57579344800007
						],
						[
							-81.32468999999992,
							28.575533058000076
						],
						[
							-81.32468999999992,
							28.576533339000036
						],
						[
							-81.32468999999992,
							28.57687800000008
						],
						[
							-81.32468999999992,
							28.57857800000005
						],
						[
							-81.32468999999992,
							28.57947800000005
						],
						[
							-81.32468999999992,
							28.579878000000065
						],
						[
							-81.3246949999999,
							28.580372000000068
						],
						[
							-81.3246922809999,
							28.58068632700008
						],
						[
							-81.3246902809999,
							28.580917500000055
						],
						[
							-81.32468299999994,
							28.58175900000009
						],
						[
							-81.32445616199993,
							28.581760935000094
						],
						[
							-81.32327599999991,
							28.58177100000006
						],
						[
							-81.32209299999994,
							28.58178600000008
						],
						[
							-81.32029599999993,
							28.581790000000073
						],
						[
							-81.31988599999994,
							28.581790000000073
						],
						[
							-81.31563599999993,
							28.581706000000054
						],
						[
							-81.3154429999999,
							28.578338000000088
						]
					],
					[
						[
							-81.32511738199992,
							28.560674037000073
						],
						[
							-81.32504028599995,
							28.560672098000055
						],
						[
							-81.32417094499993,
							28.560809315000085
						],
						[
							-81.32377088399994,
							28.560884270000088
						],
						[
							-81.32355769599991,
							28.56093954100004
						],
						[
							-81.32350744899993,
							28.560951042000056
						],
						[
							-81.32344938499995,
							28.56096062800009
						],
						[
							-81.3233960739999,
							28.56096603600008
						],
						[
							-81.32306007499994,
							28.560990037000067
						],
						[
							-81.32305481899994,
							28.560990397000072
						],
						[
							-81.32299599999993,
							28.56099232200006
						],
						[
							-81.32294479799992,
							28.560990863000086
						],
						[
							-81.32254778299995,
							28.560968223000092
						],
						[
							-81.3221598579999,
							28.56102749900009
						],
						[
							-81.32199577999995,
							28.561095606000038
						],
						[
							-81.3219951559999,
							28.561095865000084
						],
						[
							-81.32199341699993,
							28.56109658300005
						],
						[
							-81.3218914169999,
							28.56113858300006
						],
						[
							-81.32183807799993,
							28.561158595000055
						],
						[
							-81.32182713299994,
							28.561162232000072
						],
						[
							-81.32107006099994,
							28.561408442000076
						],
						[
							-81.32089954899993,
							28.561493697000063
						],
						[
							-81.32080023899994,
							28.56156849900009
						],
						[
							-81.32078408299992,
							28.56159664400008
						],
						[
							-81.32072699499992,
							28.56178539600006
						],
						[
							-81.32068907699994,
							28.562133621000044
						],
						[
							-81.32066440299991,
							28.56250373200004
						],
						[
							-81.32068435799994,
							28.56269751100007
						],
						[
							-81.32085826499991,
							28.562901424000074
						],
						[
							-81.3208874799999,
							28.562937527000088
						],
						[
							-81.32092175899993,
							28.562985363000053
						],
						[
							-81.3209528349999,
							28.563035339000066
						],
						[
							-81.32095432999995,
							28.563037937000047
						],
						[
							-81.32100932899993,
							28.56313393700009
						],
						[
							-81.32103557699992,
							28.563183240000058
						],
						[
							-81.32105986499994,
							28.563236844000073
						],
						[
							-81.3210805949999,
							28.563291922000076
						],
						[
							-81.32109767799994,
							28.56334823800006
						],
						[
							-81.32110583699995,
							28.563381161000052
						],
						[
							-81.32114291699992,
							28.56354385600008
						],
						[
							-81.32118005899991,
							28.563647781000043
						],
						[
							-81.3211971419999,
							28.563669657000048
						],
						[
							-81.32129574399994,
							28.563629907000063
						],
						[
							-81.32134292299992,
							28.56361240500007
						],
						[
							-81.3213992389999,
							28.563595322000083
						],
						[
							-81.32145655099993,
							28.563581958000043
						],
						[
							-81.32150931699994,
							28.56357308600008
						],
						[
							-81.32181431599992,
							28.56353108500008
						],
						[
							-81.32181961499992,
							28.56353037200006
						],
						[
							-81.32187818199992,
							28.563524603000076
						],
						[
							-81.32193699999995,
							28.563522678000083
						],
						[
							-81.32199581899994,
							28.563524603000076
						],
						[
							-81.32203329299995,
							28.563527848000035
						],
						[
							-81.32235829299992,
							28.56356284800006
						],
						[
							-81.32237938499992,
							28.563565372000085
						],
						[
							-81.3224159319999,
							28.56357095000004
						],
						[
							-81.32265193299992,
							28.563611950000052
						],
						[
							-81.32267344899992,
							28.56361595800007
						],
						[
							-81.32273076199994,
							28.563629322000054
						],
						[
							-81.32278707699993,
							28.563646405000043
						],
						[
							-81.32284215499993,
							28.56366713500006
						],
						[
							-81.3228714999999,
							28.56367990600006
						],
						[
							-81.32290084399995,
							28.56366713500006
						],
						[
							-81.32295592299994,
							28.563646405000043
						],
						[
							-81.32299124199994,
							28.563635221000084
						],
						[
							-81.32317824199993,
							28.563580221000052
						],
						[
							-81.32319923799992,
							28.56357432200008
						],
						[
							-81.32325655099993,
							28.56356095800004
						],
						[
							-81.3233146149999,
							28.563551372000063
						],
						[
							-81.3233626469999,
							28.563546356000078
						],
						[
							-81.3234516089999,
							28.563539475000084
						],
						[
							-81.32346865499994,
							28.563529997000046
						],
						[
							-81.32367820299993,
							28.56335222200005
						],
						[
							-81.32371252799993,
							28.563324520000037
						],
						[
							-81.32376036399995,
							28.56329024100006
						],
						[
							-81.32376299599991,
							28.563288489000062
						],
						[
							-81.32394999499991,
							28.563164489000087
						],
						[
							-81.3239973389999,
							28.563135164000073
						],
						[
							-81.32403427899993,
							28.563114974000086
						],
						[
							-81.32427627999994,
							28.56298997400006
						],
						[
							-81.32429123999992,
							28.56298242200006
						],
						[
							-81.32434484399994,
							28.56295813400004
						],
						[
							-81.32439992299993,
							28.56293740400008
						],
						[
							-81.32443336099993,
							28.562926777000087
						],
						[
							-81.32518639099993,
							28.562703512000045
						],
						[
							-81.32564577399995,
							28.56254858500006
						],
						[
							-81.32565627799995,
							28.56254129100006
						],
						[
							-81.32574316699993,
							28.562263913000038
						],
						[
							-81.32581276099995,
							28.56196927200006
						],
						[
							-81.32581932099993,
							28.561943238000083
						],
						[
							-81.3258364049999,
							28.561886922000042
						],
						[
							-81.32585456399994,
							28.561838117000036
						],
						[
							-81.32594456399995,
							28.561616118000074
						],
						[
							-81.32594713499992,
							28.561609845000078
						],
						[
							-81.32595807799993,
							28.561585294000054
						],
						[
							-81.32591958199993,
							28.56142634200006
						],
						[
							-81.3257916359999,
							28.561039160000064
						],
						[
							-81.32574367199993,
							28.560930317000043
						],
						[
							-81.32571775299994,
							28.560894567000048
						],
						[
							-81.3256242519999,
							28.56081477400005
						],
						[
							-81.32555754599991,
							28.56076305000005
						],
						[
							-81.32552744499992,
							28.560751375000052
						],
						[
							-81.32528913999994,
							28.560697281000046
						],
						[
							-81.3251586689999,
							28.560674847000087
						],
						[
							-81.32512270799992,
							28.560674156000065
						],
						[
							-81.32511738199992,
							28.560674037000073
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Baldwin Park",
				"RegionID": "268881"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.52590896099991,
					30.287003016000085,
					-81.50488296099991,
					30.295458729000075
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.52518390699993,
							30.28701101100006
						],
						[
							-81.52538990799991,
							30.287005010000083
						],
						[
							-81.52561690699991,
							30.287007010000078
						],
						[
							-81.52579690099992,
							30.287003016000085
						],
						[
							-81.52579490599993,
							30.287107008000078
						],
						[
							-81.52579790599992,
							30.28740800800006
						],
						[
							-81.52580290599991,
							30.287858008000057
						],
						[
							-81.52580490499992,
							30.28807800900006
						],
						[
							-81.5258299059999,
							30.28923400900004
						],
						[
							-81.52583390599995,
							30.289308009000084
						],
						[
							-81.52585490599995,
							30.289735008000036
						],
						[
							-81.52588190599994,
							30.292322008000045
						],
						[
							-81.52590896099991,
							30.294874011000047
						],
						[
							-81.5119750579999,
							30.295357889000062
						],
						[
							-81.50890218199993,
							30.295458729000075
						],
						[
							-81.50488296099991,
							30.287225955000054
						],
						[
							-81.5055329079999,
							30.287212010000076
						],
						[
							-81.50831790799992,
							30.287180010000046
						],
						[
							-81.50870390799992,
							30.287176010000056
						],
						[
							-81.5096789079999,
							30.28716901000007
						],
						[
							-81.5103519079999,
							30.28716901000007
						],
						[
							-81.5104659079999,
							30.28716901000007
						],
						[
							-81.5105149069999,
							30.28716901000007
						],
						[
							-81.51123990799994,
							30.28716201000009
						],
						[
							-81.51626690699993,
							30.287112010000044
						],
						[
							-81.52016890699991,
							30.28708101000007
						],
						[
							-81.52027390799992,
							30.287080010000068
						],
						[
							-81.52089890799994,
							30.28707501000008
						],
						[
							-81.52101890799992,
							30.287074010000083
						],
						[
							-81.52161990799993,
							30.28706801100009
						],
						[
							-81.52186890699996,
							30.28706501000005
						],
						[
							-81.5226019079999,
							30.287058010000067
						],
						[
							-81.52405990799991,
							30.28704301000005
						],
						[
							-81.52518390699993,
							30.28701101100006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Beachwood",
				"RegionID": "268888"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.35996734387238,
					28.521660000124555,
					-81.35360677820356,
					28.531368671561395
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.35372695550572,
							28.531267714569736
						],
						[
							-81.35360677820356,
							28.529399679722665
						],
						[
							-81.35469265559468,
							28.529399944123256
						],
						[
							-81.35469452438583,
							28.528617650869613
						],
						[
							-81.35466648712222,
							28.527530984773215
						],
						[
							-81.35476863481634,
							28.527531038732455
						],
						[
							-81.35567311625604,
							28.527394964114926
						],
						[
							-81.35568900008177,
							28.52730999976692
						],
						[
							-81.35568900008177,
							28.526669999942676
						],
						[
							-81.35568800003567,
							28.52631099958186
						],
						[
							-81.3556473461833,
							28.52631090065637
						],
						[
							-81.35527900006791,
							28.52631000043505
						],
						[
							-81.35528200020619,
							28.526271000435905
						],
						[
							-81.355280000114,
							28.526200999907154
						],
						[
							-81.35564550527117,
							28.526200999907154
						],
						[
							-81.35568900008177,
							28.526200999907154
						],
						[
							-81.35567899962076,
							28.52607100020984
						],
						[
							-81.35567700042796,
							28.5259789995662
						],
						[
							-81.3556791336198,
							28.52555307255929
						],
						[
							-81.35567999966686,
							28.525379999833362
						],
						[
							-81.3556830447713,
							28.524909123811987
						],
						[
							-81.35568900008177,
							28.523988000418072
						],
						[
							-81.35567700042796,
							28.52391499975105
						],
						[
							-81.35552850977032,
							28.523911458220873
						],
						[
							-81.35513199958697,
							28.523902000051066
						],
						[
							-81.35512738336703,
							28.523572928228035
						],
						[
							-81.35512679610976,
							28.523531037807835
						],
						[
							-81.35512500016361,
							28.523403000431223
						],
						[
							-81.35499100028194,
							28.523403000431223
						],
						[
							-81.35499100028194,
							28.522770000030413
						],
						[
							-81.35576509081929,
							28.522781219072733
						],
						[
							-81.35581899977907,
							28.52278199968422
						],
						[
							-81.35581999982517,
							28.52273200007736
						],
						[
							-81.35581999982517,
							28.522526999620844
						],
						[
							-81.35583043016203,
							28.522053641470656
						],
						[
							-81.35583300042444,
							28.52193700030282
						],
						[
							-81.35611700002605,
							28.52194699986444
						],
						[
							-81.35610500037215,
							28.521660000124555
						],
						[
							-81.3565059999711,
							28.521682000239352
						],
						[
							-81.35650199978674,
							28.52183700018974
						],
						[
							-81.35797700033005,
							28.521862000442894
						],
						[
							-81.35799100007613,
							28.52277999959204
						],
						[
							-81.35802499984472,
							28.52344399962326
						],
						[
							-81.35829447629486,
							28.52345048283572
						],
						[
							-81.3598539996191,
							28.523487999852854
						],
						[
							-81.3598545562995,
							28.523402387992945
						],
						[
							-81.35991126215063,
							28.523400905910222
						],
						[
							-81.35991326494083,
							28.523606218431517
						],
						[
							-81.3599152686303,
							28.523994794796025
						],
						[
							-81.35995332344197,
							28.524285225449418
						],
						[
							-81.35996434013681,
							28.524368347985913
						],
						[
							-81.35996734387238,
							28.524511562321152
						],
						[
							-81.3599182714666,
							28.52481701435042
						],
						[
							-81.35990019149645,
							28.524934176225734
						],
						[
							-81.35986218884548,
							28.525173543374418
						],
						[
							-81.35982513587855,
							28.52539086274411
						],
						[
							-81.3598350176291,
							28.525521083674683
						],
						[
							-81.35986419163568,
							28.52558214943913
						],
						[
							-81.35990632487275,
							28.52567036303769
						],
						[
							-81.35996247224502,
							28.527693405928943
						],
						[
							-81.3599391690126,
							28.527694150567605
						],
						[
							-81.35988622682402,
							28.531343747750647
						],
						[
							-81.35887772889902,
							28.531353708641426
						],
						[
							-81.35585925163444,
							28.53136472443699
						],
						[
							-81.35537454224173,
							28.531368671561395
						],
						[
							-81.35372695550572,
							28.531267714569736
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Bel Air",
				"RegionID": "268890"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.51926532199991,
					30.44173967800009,
					-81.4484116779999,
					30.567001322000067
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-81.49404240399991,
								30.54723632100007
							],
							[
								-81.49272732599991,
								30.54552172600006
							],
							[
								-81.49220980699994,
								30.54497309900006
							],
							[
								-81.49219509499994,
								30.54495712000005
							],
							[
								-81.4891710949999,
								30.541592120000075
							],
							[
								-81.4890948769999,
								30.541494559000053
							],
							[
								-81.48803431699992,
								30.539925236000045
							],
							[
								-81.48744145799994,
								30.539333211000045
							],
							[
								-81.48648357199994,
								30.538669052000046
							],
							[
								-81.48638213599992,
								30.538587230000076
							],
							[
								-81.48570013599993,
								30.537950229000046
							],
							[
								-81.48563576399994,
								30.53788357200005
							],
							[
								-81.48517259499994,
								30.537351652000037
							],
							[
								-81.4845469739999,
								30.53683594900008
							],
							[
								-81.48448888599995,
								30.536783666000076
							],
							[
								-81.48326688599991,
								30.535583667000083
							],
							[
								-81.48316931099993,
								30.535470440000044
							],
							[
								-81.48233766699991,
								30.53432522500009
							],
							[
								-81.48152458399994,
								30.53338431000009
							],
							[
								-81.48108159999992,
								30.533124117000057
							],
							[
								-81.48025849399994,
								30.53262931300009
							],
							[
								-81.4796428269999,
								30.53232331700008
							],
							[
								-81.4787894879999,
								30.53195606900005
							],
							[
								-81.47875344499994,
								30.53193960700008
							],
							[
								-81.47792844499992,
								30.53154060800006
							],
							[
								-81.47780904399991,
								30.531471071000055
							],
							[
								-81.47706266499995,
								30.53095575900005
							],
							[
								-81.47632399999992,
								30.530517933000052
							],
							[
								-81.47572110599992,
								30.530276151000066
							],
							[
								-81.47531264299994,
								30.530223079000056
							],
							[
								-81.47484408499992,
								30.53015632200004
							],
							[
								-81.4747157409999,
								30.530128336000075
							],
							[
								-81.4738137409999,
								30.529861336000067
							],
							[
								-81.47374743499995,
								30.529838867000084
							],
							[
								-81.47368307799991,
								30.529811309000078
							],
							[
								-81.47362105999991,
								30.52977882700009
							],
							[
								-81.47356175599992,
								30.52974162000004
							],
							[
								-81.47350552699993,
								30.529699913000062
							],
							[
								-81.47345271199993,
								30.529653957000047
							],
							[
								-81.47293067199992,
								30.529162740000064
							],
							[
								-81.4722371979999,
								30.528585646000067
							],
							[
								-81.47185675499992,
								30.52828089700006
							],
							[
								-81.47181390899993,
								30.528244315000055
							],
							[
								-81.4713977799999,
								30.527865854000083
							],
							[
								-81.47120203999994,
								30.527733553000076
							],
							[
								-81.4708929009999,
								30.52763897600005
							],
							[
								-81.47082036099994,
								30.52761368900008
							],
							[
								-81.4707504029999,
								30.52758195000007
							],
							[
								-81.47068359899993,
								30.52754401900006
							],
							[
								-81.47062049699991,
								30.527500205000077
							],
							[
								-81.47055084699991,
								30.527500274000086
							],
							[
								-81.47048141199991,
								30.527494813000093
							],
							[
								-81.47041262899995,
								30.527483858000036
							],
							[
								-81.47007762999993,
								30.527416858000038
							],
							[
								-81.46994641399993,
								30.527380086000054
							],
							[
								-81.4698952469999,
								30.527359667000045
							],
							[
								-81.46936424699993,
								30.527128668000046
							],
							[
								-81.46934157999993,
								30.52711843200007
							],
							[
								-81.46889957999991,
								30.52691143100009
							],
							[
								-81.4688313389999,
								30.52687583500005
							],
							[
								-81.4687216019999,
								30.526801169000063
							],
							[
								-81.46842693499991,
								30.52656708200004
							],
							[
								-81.46818710199994,
								30.52654271600005
							],
							[
								-81.46815638599992,
								30.52653906100005
							],
							[
								-81.46777538599991,
								30.52648706100007
							],
							[
								-81.46769636699992,
								30.52647265700006
							],
							[
								-81.46761894899993,
								30.52645125900006
							],
							[
								-81.4675437489999,
								30.526423039000065
							],
							[
								-81.46747136699992,
								30.526388223000083
							],
							[
								-81.4674023799999,
								30.52634708700009
							],
							[
								-81.46733733799994,
								30.526299959000085
							],
							[
								-81.46689770199993,
								30.52595044000009
							],
							[
								-81.4646413829999,
								30.52489164100007
							],
							[
								-81.4619544119999,
								30.52393516600006
							],
							[
								-81.4618093389999,
								30.52386783600008
							],
							[
								-81.46168092699992,
								30.52377792100009
							],
							[
								-81.4615700789999,
								30.523667073000073
							],
							[
								-81.46148016399991,
								30.523538661000092
							],
							[
								-81.46141391299994,
								30.52339658700004
							],
							[
								-81.46137333999991,
								30.523245166000034
							],
							[
								-81.46135967799995,
								30.523089000000088
							],
							[
								-81.46137333999991,
								30.522932835000066
							],
							[
								-81.46141391299994,
								30.522781414000065
							],
							[
								-81.46145194699994,
								30.52269220600005
							],
							[
								-81.46188680799992,
								30.521807729000045
							],
							[
								-81.46342191799994,
								30.51933518200008
							],
							[
								-81.46433952799993,
								30.518067639000037
							],
							[
								-81.46436487999995,
								30.518034284000063
							],
							[
								-81.46475432799991,
								30.51754592800006
							],
							[
								-81.46514291699992,
								30.516817105000083
							],
							[
								-81.46547130499994,
								30.516084251000052
							],
							[
								-81.46550229299993,
								30.516021717000058
							],
							[
								-81.46566127299991,
								30.515729939000042
							],
							[
								-81.46602185299992,
								30.51506815900007
							],
							[
								-81.4661270819999,
								30.51487503000004
							],
							[
								-81.46907731699991,
								30.51045730300007
							],
							[
								-81.46934147699994,
								30.510069081000044
							],
							[
								-81.46939798999995,
								30.50999465700005
							],
							[
								-81.46960495899992,
								30.509749647000035
							],
							[
								-81.46964667799995,
								30.509620914000042
							],
							[
								-81.46964667799995,
								30.50946900000008
							],
							[
								-81.46966034099995,
								30.50931283500006
							],
							[
								-81.46970091399993,
								30.50916141400006
							],
							[
								-81.46976716499995,
								30.509019339000076
							],
							[
								-81.46985707999995,
								30.50889092700004
							],
							[
								-81.46987531899993,
								30.50886986200004
							],
							[
								-81.47007631899993,
								30.50864486100005
							],
							[
								-81.47012945899992,
								30.50858929700007
							],
							[
								-81.4701874729999,
								30.508538844000043
							],
							[
								-81.47024987299994,
								30.508493927000078
							],
							[
								-81.47031613099995,
								30.508454926000073
							],
							[
								-81.47038568799991,
								30.50842216900008
							],
							[
								-81.47039712999992,
								30.50839814700004
							],
							[
								-81.47056652899994,
								30.50792146400005
							],
							[
								-81.47093240399994,
								30.50653206600009
							],
							[
								-81.4707799919999,
								30.50506282100008
							],
							[
								-81.47072178099995,
								30.504542264000065
							],
							[
								-81.47009069199993,
								30.503642363000044
							],
							[
								-81.47004816399993,
								30.503575661000074
							],
							[
								-81.46999725099994,
								30.50347284000009
							],
							[
								-81.46989662699991,
								30.50323211500006
							],
							[
								-81.46945901299995,
								30.503181066000085
							],
							[
								-81.46851101699991,
								30.502552361000088
							],
							[
								-81.46787349399995,
								30.501630613000092
							],
							[
								-81.46777874199995,
								30.50067860700005
							],
							[
								-81.46706807299995,
								30.499679151000066
							],
							[
								-81.46702774499994,
								30.499617191000088
							],
							[
								-81.46699264099993,
								30.499552128000065
							],
							[
								-81.4669630009999,
								30.499484402000064
							],
							[
								-81.46693902299995,
								30.49941447000009
							],
							[
								-81.46692086999991,
								30.499342804000037
							],
							[
								-81.4669087229999,
								30.49928495400007
							],
							[
								-81.46653056199995,
								30.498991420000042
							],
							[
								-81.46647770999994,
								30.498947043000044
							],
							[
								-81.46642841599993,
								30.498898744000087
							],
							[
								-81.46638296999993,
								30.498846807000064
							],
							[
								-81.46634164199992,
								30.49879153900008
							],
							[
								-81.46630467299991,
								30.498733264000066
							],
							[
								-81.4660479179999,
								30.498291963000042
							],
							[
								-81.46601602399994,
								30.498236620000053
							],
							[
								-81.46598909099993,
								30.498178700000036
							],
							[
								-81.46596732599994,
								30.498118647000066
							],
							[
								-81.46595089399996,
								30.498056922000046
							],
							[
								-81.46593992299995,
								30.49799399500006
							],
							[
								-81.46593449499994,
								30.497930351000036
							],
							[
								-81.46586917799993,
								30.497946829000057
							],
							[
								-81.46580265599994,
								30.497957445000054
							],
							[
								-81.46573545399991,
								30.497962115000067
							],
							[
								-81.46566810299993,
								30.49796080200008
							],
							[
								-81.46560113499993,
								30.497953517000045
							],
							[
								-81.46553507699991,
								30.497940318000076
							],
							[
								-81.46547045099993,
								30.49792130800006
							],
							[
								-81.4654033509999,
								30.49790388400004
							],
							[
								-81.4653840439999,
								30.49789709400005
							],
							[
								-81.46532037099992,
								30.497876197000043
							],
							[
								-81.46530140499993,
								30.49786803300009
							],
							[
								-81.46523605399994,
								30.497840134000057
							],
							[
								-81.46517322099993,
								30.497806951000086
							],
							[
								-81.46511333199993,
								30.49776871000006
							],
							[
								-81.46505679299992,
								30.49772566900009
							],
							[
								-81.46500398899991,
								30.49767812100004
							],
							[
								-81.46495527699994,
								30.49762638800007
							],
							[
								-81.46491098799993,
								30.49757082200006
							],
							[
								-81.46484650899993,
								30.49748266000006
							],
							[
								-81.46286949799992,
								30.49486186500008
							],
							[
								-81.46278669299994,
								30.494729275000054
							],
							[
								-81.46217069399995,
								30.493520275000037
							],
							[
								-81.46214113199994,
								30.493456148000064
							],
							[
								-81.46211669199994,
								30.493389899000082
							],
							[
								-81.46209752499993,
								30.493321938000065
							],
							[
								-81.46208374999992,
								30.49325268200005
							],
							[
								-81.46207544999993,
								30.49318255800006
							],
							[
								-81.46207267799991,
								30.493112000000053
							],
							[
								-81.46207267799991,
								30.493009000000082
							],
							[
								-81.46208634099992,
								30.49285283400008
							],
							[
								-81.46212773699995,
								30.492699171000083
							],
							[
								-81.4621655599999,
								30.49259692800007
							],
							[
								-81.46219590599992,
								30.492524735000075
							],
							[
								-81.46223241699994,
								30.492455457000066
							],
							[
								-81.46227481799991,
								30.49238961700007
							],
							[
								-81.4623227859999,
								30.49232771600009
							],
							[
								-81.46237595699995,
								30.492270223000048
							],
							[
								-81.46243392899993,
								30.49221757400005
							],
							[
								-81.46249626199995,
								30.492170169000076
							],
							[
								-81.4625624819999,
								30.492128366000088
							],
							[
								-81.46268562599994,
								30.492058568000065
							],
							[
								-81.46274672599992,
								30.492026969000047
							],
							[
								-81.4628100619999,
								30.492000132000044
							],
							[
								-81.46287526399993,
								30.491978215000074
							],
							[
								-81.46294195099995,
								30.49196134500005
							],
							[
								-81.46300973199993,
								30.49194962200005
							],
							[
								-81.46315173199991,
								30.49193062200004
							],
							[
								-81.46327189499993,
								30.49192267800004
							],
							[
								-81.46531637399994,
								30.49192471200007
							],
							[
								-81.46505830599996,
								30.49175800700004
							],
							[
								-81.46139617299991,
								30.49015920000005
							],
							[
								-81.46132662199994,
								30.490125200000083
							],
							[
								-81.46126025299992,
								30.49008534400008
							],
							[
								-81.46119755799992,
								30.490039928000044
							],
							[
								-81.46113900099994,
								30.48998928800006
							],
							[
								-81.46108501599991,
								30.489933800000074
							],
							[
								-81.46103600399994,
								30.489873875000058
							],
							[
								-81.46099232699993,
								30.489809956000045
							],
							[
								-81.45822142999992,
								30.485354682000036
							],
							[
								-81.45793842699993,
								30.484667662000053
							],
							[
								-81.45788097499991,
								30.483913251000047
							],
							[
								-81.45911059499991,
								30.47578446700004
							],
							[
								-81.45890402899994,
								30.474795333000092
							],
							[
								-81.45852942099992,
								30.473001539000055
							],
							[
								-81.4582979079999,
								30.471892946000082
							],
							[
								-81.45818543199994,
								30.47173406100006
							],
							[
								-81.45796139399994,
								30.47141758300006
							],
							[
								-81.45486998399991,
								30.46705061600005
							],
							[
								-81.45482516499993,
								30.466980661000036
							],
							[
								-81.45475891399991,
								30.46683858700004
							],
							[
								-81.45471834099993,
								30.466687166000042
							],
							[
								-81.45470467799993,
								30.46653100000009
							],
							[
								-81.45470726999991,
								30.46646277700006
							],
							[
								-81.45471426899991,
								30.466370776000076
							],
							[
								-81.45472534099991,
								30.46628283400008
							],
							[
								-81.45476591399995,
								30.466131414000074
							],
							[
								-81.45483216399992,
								30.46598933900009
							],
							[
								-81.45492207899993,
								30.46586092700005
							],
							[
								-81.45503292699993,
								30.465750079000088
							],
							[
								-81.4551088529999,
								30.46569691500008
							],
							[
								-81.4550351659999,
								30.46571666000006
							],
							[
								-81.45487899999995,
								30.465730322000066
							],
							[
								-81.45476599999995,
								30.465730322000066
							],
							[
								-81.4546935429999,
								30.465727399000055
							],
							[
								-81.45462155699994,
								30.465718647000077
							],
							[
								-81.45455050999993,
								30.46570412300008
							],
							[
								-81.45448086399995,
								30.465683923000082
							],
							[
								-81.45441307199991,
								30.465658177000083
							],
							[
								-81.45430815399993,
								30.465612694000075
							],
							[
								-81.45426377399991,
								30.46559267000003
							],
							[
								-81.45416633899993,
								30.465545836000043
							],
							[
								-81.45415147299991,
								30.46553601100004
							],
							[
								-81.45294595599995,
								30.464808749000042
							],
							[
								-81.45283292699993,
								30.464727920000087
							],
							[
								-81.4527220789999,
								30.46461707300006
							],
							[
								-81.45263216399991,
								30.464488661000072
							],
							[
								-81.45256591399993,
								30.464346586000094
							],
							[
								-81.4525253409999,
								30.46419516500004
							],
							[
								-81.45251167799995,
								30.464039000000067
							],
							[
								-81.4525253409999,
								30.463882834000064
							],
							[
								-81.45256591399993,
								30.46373141400005
							],
							[
								-81.45263216399991,
								30.463589339000062
							],
							[
								-81.45264557299993,
								30.46356687500008
							],
							[
								-81.4528560569999,
								30.463225631000057
							],
							[
								-81.45278510999992,
								30.463234666000062
							],
							[
								-81.4527136669999,
								30.46323797400004
							],
							[
								-81.4526421889999,
								30.463235533000045
							],
							[
								-81.45257113799994,
								30.46322735800004
							],
							[
								-81.45250097299993,
								30.46321350200009
							],
							[
								-81.4524321479999,
								30.463194055000088
							],
							[
								-81.45236510699993,
								30.463169143000073
							],
							[
								-81.45116510699995,
								30.46266914400007
							],
							[
								-81.45106133899992,
								30.46261783600005
							],
							[
								-81.45093292699994,
								30.462527921000063
							],
							[
								-81.45082207899992,
								30.462417073000044
							],
							[
								-81.45073216399993,
								30.46228866100006
							],
							[
								-81.45066591299991,
								30.462146586000078
							],
							[
								-81.45062533999993,
								30.461995166000065
							],
							[
								-81.45061167799992,
								30.46183900000005
							],
							[
								-81.45062533999993,
								30.461682834000047
							],
							[
								-81.45065188999992,
								30.461573085000055
							],
							[
								-81.45178610499994,
								30.45790870000008
							],
							[
								-81.44869405299995,
								30.45499333700008
							],
							[
								-81.4486220789999,
								30.45491707300005
							],
							[
								-81.44853216399991,
								30.454788661000066
							],
							[
								-81.44846591399994,
								30.454646586000084
							],
							[
								-81.4484253409999,
								30.454495165000086
							],
							[
								-81.4484116779999,
								30.454339000000058
							],
							[
								-81.44841241599994,
								30.45430257000004
							],
							[
								-81.44871241599992,
								30.44690257100007
							],
							[
								-81.44871809099993,
								30.44683179200007
							],
							[
								-81.44872933199991,
								30.44676168100006
							],
							[
								-81.44874606999991,
								30.44669267500007
							],
							[
								-81.4487681999999,
								30.446625206000075
							],
							[
								-81.44879558299994,
								30.44655969200005
							],
							[
								-81.44882804999992,
								30.446496543000077
							],
							[
								-81.4488653969999,
								30.44643615200005
							],
							[
								-81.45176539699992,
								30.44213615100006
							],
							[
								-81.4518220789999,
								30.442060927000057
							],
							[
								-81.45193292699992,
								30.441950079000037
							],
							[
								-81.4520613389999,
								30.44186016400005
							],
							[
								-81.45220341399995,
								30.441793914000076
							],
							[
								-81.45235483399995,
								30.44175334100004
							],
							[
								-81.4525109999999,
								30.44173967800009
							],
							[
								-81.45266716599991,
								30.44175334100004
							],
							[
								-81.45269305099993,
								30.441760277000068
							],
							[
								-81.45312184699992,
								30.442148194000087
							],
							[
								-81.45403764199995,
								30.442975363000073
							],
							[
								-81.45557381399993,
								30.443891158000046
							],
							[
								-81.45793715499991,
								30.44442291000007
							],
							[
								-81.45922117399994,
								30.44451547500006
							],
							[
								-81.45936986399994,
								30.444645142000073
							],
							[
								-81.45942839899993,
								30.444598796000037
							],
							[
								-81.4594906129999,
								30.44455752000005
							],
							[
								-81.45955606799993,
								30.444521605000034
							],
							[
								-81.45962430299994,
								30.444491303000063
							],
							[
								-81.45969483899995,
								30.444466829000078
							],
							[
								-81.45997212799995,
								30.444383381000083
							],
							[
								-81.4620799999999,
								30.44488700000005
							],
							[
								-81.46383702799994,
								30.444735862000073
							],
							[
								-81.4641269089999,
								30.446171012000036
							],
							[
								-81.46505690999993,
								30.45075001200007
							],
							[
								-81.46521790999992,
								30.451424012000075
							],
							[
								-81.46527090899991,
								30.451567012000055
							],
							[
								-81.46530891099991,
								30.45172501200005
							],
							[
								-81.46547690999995,
								30.45216201300008
							],
							[
								-81.46556090999991,
								30.452358012000047
							],
							[
								-81.46563690999994,
								30.45249601300009
							],
							[
								-81.46571390999992,
								30.452677012000038
							],
							[
								-81.46578190899993,
								30.45279701200008
							],
							[
								-81.46584290899995,
								30.452927013000075
							],
							[
								-81.46591890899992,
								30.453058012000042
							],
							[
								-81.46724690899993,
								30.45550301300005
							],
							[
								-81.46742990999991,
								30.455822012000056
							],
							[
								-81.46766690999993,
								30.456198012000073
							],
							[
								-81.46786490999995,
								30.456491012000075
							],
							[
								-81.4681549089999,
								30.45686501300008
							],
							[
								-81.46829190999995,
								30.457016012000057
							],
							[
								-81.4686739089999,
								30.457424012000047
							],
							[
								-81.46888790899993,
								30.457621012000065
							],
							[
								-81.46916990999995,
								30.457890012000064
							],
							[
								-81.4693449099999,
								30.458025012000064
							],
							[
								-81.46963490999991,
								30.458256013000042
							],
							[
								-81.47007790899994,
								30.45856301300006
							],
							[
								-81.4705659089999,
								30.45886001200006
							],
							[
								-81.47097790999993,
								30.45908401200006
							],
							[
								-81.47123691099995,
								30.45920601300008
							],
							[
								-81.47133590999994,
								30.459261012000074
							],
							[
								-81.47186290999991,
								30.459473012000046
							],
							[
								-81.47244990999991,
								30.459677012000043
							],
							[
								-81.47286990999993,
								30.459803012000066
							],
							[
								-81.47325090999993,
								30.459890013000063
							],
							[
								-81.47411290899993,
								30.460051012000065
							],
							[
								-81.4743269089999,
								30.46007901200005
							],
							[
								-81.47450890999994,
								30.460106013000086
							],
							[
								-81.47635693799992,
								30.460390018000055
							],
							[
								-81.47622007299992,
								30.463598231000052
							],
							[
								-81.47743399899993,
								30.46548593700004
							],
							[
								-81.47743390999995,
								30.46656474700006
							],
							[
								-81.47689455599993,
								30.46764363500006
							],
							[
								-81.47568074399993,
								30.467643330000048
							],
							[
								-81.47554589999993,
								30.469261713000037
							],
							[
								-81.4771642199999,
								30.46912656600006
							],
							[
								-81.47783830699991,
								30.469935864000036
							],
							[
								-81.4790519419999,
								30.470475170000046
							],
							[
								-81.48026566099992,
								30.47101441600006
							],
							[
								-81.4806700549999,
								30.472228125000072
							],
							[
								-81.48107443299995,
								30.47384633000007
							],
							[
								-81.4822881309999,
								30.474925056000075
							],
							[
								-81.4833670619999,
								30.47519455400004
							],
							[
								-81.4832322179999,
								30.477217426000042
							],
							[
								-81.48188348399992,
								30.477621730000067
							],
							[
								-81.48201834799994,
								30.47910524300005
							],
							[
								-81.48309722599993,
								30.479239952000057
							],
							[
								-81.48485031099995,
								30.479374657000047
							],
							[
								-81.48496661999991,
								30.480425206000064
							],
							[
								-81.4852121639999,
								30.48095547800006
							],
							[
								-81.48556211999994,
								30.481585398000053
							],
							[
								-81.48566710599994,
								30.48218032300008
							],
							[
								-81.48594711299995,
								30.48306349600006
							],
							[
								-81.4855787919999,
								30.48369246400006
							],
							[
								-81.48528402699992,
								30.48420064700008
							],
							[
								-81.48508432199992,
								30.484596166000074
							],
							[
								-81.48508432199992,
								30.484696477000057
							],
							[
								-81.4850997179999,
								30.48474601500004
							],
							[
								-81.4853817469999,
								30.485019446000077
							],
							[
								-81.48610770499994,
								30.48554873400008
							],
							[
								-81.48695293499993,
								30.48608294800005
							],
							[
								-81.48819840199991,
								30.486643637000043
							],
							[
								-81.48839554599994,
								30.486703953000074
							],
							[
								-81.4885717379999,
								30.486869727000055
							],
							[
								-81.48909667099991,
								30.487359665000042
							],
							[
								-81.48927164899993,
								30.487814607000075
							],
							[
								-81.48913166699992,
								30.48816456300006
							],
							[
								-81.4885717379999,
								30.48851451800005
							],
							[
								-81.4879068219999,
								30.488829478000074
							],
							[
								-81.48753667799993,
								30.489398000000048
							],
							[
								-81.48753819799992,
								30.48938062600007
							],
							[
								-81.48724831699991,
								30.489616991000048
							],
							[
								-81.48715342799994,
								30.489684622000084
							],
							[
								-81.4859534279999,
								30.490427622000084
							],
							[
								-81.4858565319999,
								30.49047970300006
							],
							[
								-81.48560121399993,
								30.490597414000035
							],
							[
								-81.4854989129999,
								30.490733939000055
							],
							[
								-81.4850681499999,
								30.491526469000068
							],
							[
								-81.48504803299994,
								30.491561575000045
							],
							[
								-81.48469696299992,
								30.492143473000056
							],
							[
								-81.48467653299991,
								30.49220254100004
							],
							[
								-81.48465278799995,
								30.492608512000064
							],
							[
								-81.48464499199991,
								30.49268520700008
							],
							[
								-81.48463065699991,
								30.49276095200008
							],
							[
								-81.48460988799991,
								30.492835192000086
							],
							[
								-81.48458283699995,
								30.492907380000077
							],
							[
								-81.48454970199992,
								30.49297698600009
							],
							[
								-81.48451072899991,
								30.493043498000077
							],
							[
								-81.48446620199991,
								30.493106429000083
							],
							[
								-81.4839732019999,
								30.493743429000062
							],
							[
								-81.48392420699992,
								30.493801492000046
							],
							[
								-81.48387048599994,
								30.49385521200008
							],
							[
								-81.48381242199991,
								30.49390420700007
							],
							[
								-81.48375043099992,
								30.493948126000078
							],
							[
								-81.48309252299993,
								30.49437367400009
							],
							[
								-81.48289363099991,
								30.49457364100004
							],
							[
								-81.48213827199993,
								30.496095597000078
							],
							[
								-81.48217224899992,
								30.496364406000055
							],
							[
								-81.48235508699992,
								30.496916638000076
							],
							[
								-81.48248788899991,
								30.49712351000005
							],
							[
								-81.48373890699992,
								30.497906150000063
							],
							[
								-81.4851300599999,
								30.49862614800009
							],
							[
								-81.48516381099995,
								30.498632754000088
							],
							[
								-81.48540696299995,
								30.498613488000046
							],
							[
								-81.48554345299993,
								30.49861306300005
							],
							[
								-81.48591345299991,
								30.498640063000042
							],
							[
								-81.48600416499994,
								30.498651341000087
							],
							[
								-81.48609598899992,
								30.49867254600008
							],
							[
								-81.4868302189999,
								30.49888317700004
							],
							[
								-81.48759643499994,
								30.499093862000056
							],
							[
								-81.48766558599993,
								30.499115914000075
							],
							[
								-81.48781528099994,
								30.499186664000035
							],
							[
								-81.4879702149999,
								30.499280126000087
							],
							[
								-81.48814667199991,
								30.499303507000036
							],
							[
								-81.48919647699995,
								30.499353678000034
							],
							[
								-81.49005493399994,
								30.499353678000034
							],
							[
								-81.49082715599991,
								30.49932951700003
							],
							[
								-81.49154949899992,
								30.499234568000073
							],
							[
								-81.4924212489999,
								30.499573114000043
							],
							[
								-81.4926662179999,
								30.499923070000083
							],
							[
								-81.49287619099994,
								30.500482999000038
							],
							[
								-81.4928590689999,
								30.501002810000045
							],
							[
								-81.49236277999995,
								30.501539123000043
							],
							[
								-81.4921746679999,
								30.50273252500006
							],
							[
								-81.49226875099993,
								30.503974044000074
							],
							[
								-81.49227002999993,
								30.503993819000073
							],
							[
								-81.4923442349999,
								30.505376883000054
							],
							[
								-81.4926170839999,
								30.505996629000034
							],
							[
								-81.49263293699994,
								30.50603501500007
							],
							[
								-81.4928789359999,
								30.50667201500005
							],
							[
								-81.49289508699991,
								30.50671741900004
							],
							[
								-81.49306016899993,
								30.507224132000086
							],
							[
								-81.49323425999995,
								30.507440960000054
							],
							[
								-81.4932889769999,
								30.507516886000072
							],
							[
								-81.49344297699992,
								30.507755887000087
							],
							[
								-81.49347843599992,
								30.50781589700006
							],
							[
								-81.49350913699993,
								30.507878475000037
							],
							[
								-81.49353489399994,
								30.507943244000042
							],
							[
								-81.4935555539999,
								30.50800981500004
							],
							[
								-81.4935709909999,
								30.508077788000037
							],
							[
								-81.4935811119999,
								30.50814675200007
							],
							[
								-81.49361909499993,
								30.50815495300009
							],
							[
								-81.49411506899992,
								30.50822972800006
							],
							[
								-81.49419366699993,
								30.508245185000078
							],
							[
								-81.49427057799994,
								30.50826757600004
							],
							[
								-81.49434519199991,
								30.50829672100008
							],
							[
								-81.49441691599992,
								30.508332389000085
							],
							[
								-81.49448518199995,
								30.508374299000085
							],
							[
								-81.49454944699994,
								30.508422116000077
							],
							[
								-81.49509686699992,
								30.50886864600005
							],
							[
								-81.49626779099992,
								30.509625184000072
							],
							[
								-81.49633992499992,
								30.50966674000006
							],
							[
								-81.49645607799994,
								30.50974638100007
							],
							[
								-81.4969565749999,
								30.510150730000078
							],
							[
								-81.49701390099995,
								30.51020218000008
							],
							[
								-81.49706661099992,
								30.510258349000082
							],
							[
								-81.49711431999992,
								30.51031882400008
							],
							[
								-81.49715667599992,
								30.510383161000053
							],
							[
								-81.49719336899994,
								30.510450888000037
							],
							[
								-81.49722412899992,
								30.510521508000068
							],
							[
								-81.4972487309999,
								30.51059450200006
							],
							[
								-81.49740272999992,
								30.511125502000088
							],
							[
								-81.49742465899993,
								30.51121983400009
							],
							[
								-81.49743832199994,
								30.511376000000045
							],
							[
								-81.49742465899993,
								30.511532166000052
							],
							[
								-81.4973840859999,
								30.51168358600006
							],
							[
								-81.49731783499993,
								30.51182566100005
							],
							[
								-81.49722791999994,
								30.511954073000087
							],
							[
								-81.49711707299991,
								30.51206492100005
							],
							[
								-81.49698866099995,
								30.512154836000036
							],
							[
								-81.49686265799994,
								30.51221506200005
							],
							[
								-81.4962621009999,
								30.51244672000007
							],
							[
								-81.49532461699994,
								30.512851218000037
							],
							[
								-81.49480749299994,
								30.51312254400006
							],
							[
								-81.49457136199993,
								30.51341036900004
							],
							[
								-81.49403400999995,
								30.514157229000038
							],
							[
								-81.49399291999993,
								30.514210073000076
							],
							[
								-81.49391643599995,
								30.51429056000006
							],
							[
								-81.49320170399994,
								30.51495523500006
							],
							[
								-81.49259306099992,
								30.515753862000054
							],
							[
								-81.4921995759999,
								30.516551763000052
							],
							[
								-81.4921718359999,
								30.516603661000094
							],
							[
								-81.49213286499992,
								30.516659316000073
							],
							[
								-81.4921661699999,
								30.51673234900005
							],
							[
								-81.49224907699994,
								30.51755866900004
							],
							[
								-81.4930387789999,
								30.518664252000068
							],
							[
								-81.49426281699994,
								30.520164687000086
							],
							[
								-81.49480490099995,
								30.521083582000074
							],
							[
								-81.49537089199993,
								30.52314984100008
							],
							[
								-81.49581513599992,
								30.523892510000053
							],
							[
								-81.4968006339999,
								30.525299058000087
							],
							[
								-81.49781575499992,
								30.526105582000074
							],
							[
								-81.49807661299991,
								30.52622584700004
							],
							[
								-81.4983961399999,
								30.526284415000077
							],
							[
								-81.49854158599993,
								30.52632391300006
							],
							[
								-81.49868366099992,
								30.526390164000077
							],
							[
								-81.49881207299991,
								30.526480079000063
							],
							[
								-81.49892291999993,
								30.526590927000083
							],
							[
								-81.49893930499991,
								30.526611035000087
							],
							[
								-81.49934180199995,
								30.52711981900006
							],
							[
								-81.49997992399994,
								30.527645462000066
							],
							[
								-81.50009391999993,
								30.52775892700004
							],
							[
								-81.50015420799991,
								30.52783954000006
							],
							[
								-81.5002653379999,
								30.528006909000055
							],
							[
								-81.5005373109999,
								30.528138758000072
							],
							[
								-81.5005735769999,
								30.52815736600007
							],
							[
								-81.5014055769999,
								30.528608366000075
							],
							[
								-81.50142666099993,
								30.528620164000078
							],
							[
								-81.5015550729999,
								30.528710079000064
							],
							[
								-81.50166592099993,
								30.528820927000083
							],
							[
								-81.50175583599992,
								30.528949339000064
							],
							[
								-81.50182208599995,
								30.529091414000053
							],
							[
								-81.50186265899993,
								30.52924283400006
							],
							[
								-81.50187632199993,
								30.52939900000007
							],
							[
								-81.50186265899993,
								30.529555166000083
							],
							[
								-81.50182208599995,
								30.52970658600009
							],
							[
								-81.50175583599992,
								30.529848661000074
							],
							[
								-81.50166592099993,
								30.529977073000055
							],
							[
								-81.5016274429999,
								30.530020051000065
							],
							[
								-81.50048644299994,
								30.531215051000057
							],
							[
								-81.50040777399994,
								30.531288157000063
							],
							[
								-81.4997515089999,
								30.53182872000008
							],
							[
								-81.49785053499994,
								30.533952374000084
							],
							[
								-81.4971694269999,
								30.53485714300007
							],
							[
								-81.4967218999999,
								30.53565234300004
							],
							[
								-81.49624474299992,
								30.536663365000035
							],
							[
								-81.49621050899992,
								30.536740485000056
							],
							[
								-81.49617803599995,
								30.53680523600008
							],
							[
								-81.49607456399991,
								30.537024362000068
							],
							[
								-81.49605533099992,
								30.53760326400004
							],
							[
								-81.49609154099994,
								30.53773603600007
							],
							[
								-81.49627570599995,
								30.537958469000046
							],
							[
								-81.49633758199991,
								30.53804745900004
							],
							[
								-81.4964756999999,
								30.538423069000093
							],
							[
								-81.4965763859999,
								30.539248198000056
							],
							[
								-81.49685396299992,
								30.539726831000053
							],
							[
								-81.49690341199994,
								30.53982562300007
							],
							[
								-81.4975226489999,
								30.541279643000053
							],
							[
								-81.4989760059999,
								30.54289357700009
							],
							[
								-81.50033778799991,
								30.54398934100004
							],
							[
								-81.50039073699992,
								30.544035464000043
							],
							[
								-81.50131934399991,
								30.544910445000085
							],
							[
								-81.50225537499995,
								30.545520659000086
							],
							[
								-81.5034412089999,
								30.54623341200005
							],
							[
								-81.50454269699992,
								30.54647615500005
							],
							[
								-81.5066221049999,
								30.54655015200007
							],
							[
								-81.50808999799995,
								30.546409890000064
							],
							[
								-81.50952897699995,
								30.545801548000043
							],
							[
								-81.51066887499991,
								30.544819946000075
							],
							[
								-81.51113191399992,
								30.544186360000086
							],
							[
								-81.51117849699995,
								30.544127886000066
							],
							[
								-81.51122977499995,
								30.54407348300009
							],
							[
								-81.5112853949999,
								30.544023527000036
							],
							[
								-81.5113449719999,
								30.543978364000058
							],
							[
								-81.51230097199993,
								30.543314364000082
							],
							[
								-81.51236792599991,
								30.54327209800005
							],
							[
								-81.5124383399999,
								30.543235890000062
							],
							[
								-81.51251166799995,
								30.54320602100006
							],
							[
								-81.51258733999993,
								30.54318272100005
							],
							[
								-81.5126647699999,
								30.543166174000078
							],
							[
								-81.5129455469999,
								30.54312112500008
							],
							[
								-81.51347689499994,
								30.542723177000088
							],
							[
								-81.51353046199995,
								30.542686011000058
							],
							[
								-81.51358658099991,
								30.54265282300008
							],
							[
								-81.51364495599995,
								30.542623789000057
							],
							[
								-81.51370528199993,
								30.542599060000043
							],
							[
								-81.51376724099993,
								30.542578767000066
							],
							[
								-81.51450724099993,
								30.54236576700004
							],
							[
								-81.5145548889999,
								30.542353453000093
							],
							[
								-81.51485597499993,
								30.542284373000086
							],
							[
								-81.51645692699992,
								30.542884880000088
							],
							[
								-81.51733303999993,
								30.544524406000054
							],
							[
								-81.51775975099991,
								30.54528674300008
							],
							[
								-81.5177800269999,
								30.545325112000054
							],
							[
								-81.5181261319999,
								30.54602012700008
							],
							[
								-81.51842770499991,
								30.546479320000063
							],
							[
								-81.5184625949999,
								30.546537054000055
							],
							[
								-81.51849305899992,
								30.546597241000086
							],
							[
								-81.5185189259999,
								30.546659542000043
							],
							[
								-81.51854005099995,
								30.546723607000047
							],
							[
								-81.51855631399991,
								30.546789075000053
							],
							[
								-81.51893059999992,
								30.548580513000047
							],
							[
								-81.5190457359999,
								30.549018223000076
							],
							[
								-81.51906165899993,
								30.54909083500007
							],
							[
								-81.51907347999992,
								30.549189481000045
							],
							[
								-81.51919448099994,
								30.551077481000053
							],
							[
								-81.51919606399991,
								30.551113482000062
							],
							[
								-81.5192650649999,
								30.55399648200006
							],
							[
								-81.51926532199991,
								30.554018000000042
							],
							[
								-81.51925421899995,
								30.554158885000053
							],
							[
								-81.51863893899991,
								30.558037526000074
							],
							[
								-81.5186237289999,
								30.558109972000064
							],
							[
								-81.51860261099995,
								30.558180921000087
							],
							[
								-81.51857572699993,
								30.558249893000035
							],
							[
								-81.5185432589999,
								30.55831641900005
							],
							[
								-81.5185054289999,
								30.55838004800006
							],
							[
								-81.51846249199993,
								30.55844034900008
							],
							[
								-81.51841473899992,
								30.55849691200007
							],
							[
								-81.51778273799994,
								30.55918591200009
							],
							[
								-81.51773172899993,
								30.559237216000042
							],
							[
								-81.5176767609999,
								30.559284255000083
							],
							[
								-81.51761818999995,
								30.559326723000083
							],
							[
								-81.51755639499993,
								30.559364345000063
							],
							[
								-81.51749177499994,
								30.559396879000072
							],
							[
								-81.51742474999992,
								30.559424113000034
							],
							[
								-81.5173557519999,
								30.559445871000033
							],
							[
								-81.51609675299994,
								30.559787871000083
							],
							[
								-81.51601716599993,
								30.559805659000066
							],
							[
								-81.51590391899992,
								30.55981829700005
							],
							[
								-81.51471091899994,
								30.55987529700008
							],
							[
								-81.51464424799991,
								30.559876008000064
							],
							[
								-81.51457770799993,
								30.559871778000062
							],
							[
								-81.51451166399994,
								30.559862629000065
							],
							[
								-81.5144464789999,
								30.559848613000046
							],
							[
								-81.51438251099995,
								30.55982980500005
							],
							[
								-81.51298451199996,
								30.559361805000037
							],
							[
								-81.5129139579999,
								30.559334842000055
							],
							[
								-81.51284591599995,
								30.559302053000064
							],
							[
								-81.51278086599991,
								30.559263670000064
							],
							[
								-81.51271926499993,
								30.55921996500007
							],
							[
								-81.51266154899992,
								30.55917124400008
							],
							[
								-81.51119654899992,
								30.55782524400007
							],
							[
								-81.51112293199992,
								30.557749142000038
							],
							[
								-81.5103048279999,
								30.556797151000065
							],
							[
								-81.50951647999995,
								30.55595751100009
							],
							[
								-81.50802258099992,
								30.55463227700005
							],
							[
								-81.50680374899991,
								30.554017271000077
							],
							[
								-81.50602702599991,
								30.553831706000043
							],
							[
								-81.50596089499993,
								30.553813211000094
							],
							[
								-81.50316447999997,
								30.552914710000042
							],
							[
								-81.50215777499994,
								30.552801859000056
							],
							[
								-81.50047587599994,
								30.552719239000055
							],
							[
								-81.50040257899991,
								30.55271262400004
							],
							[
								-81.50033006899992,
								30.552700037000076
							],
							[
								-81.50025883099994,
								30.552681565000054
							],
							[
								-81.50018934199994,
								30.552657329000056
							],
							[
								-81.50012206699995,
								30.552627492000056
							],
							[
								-81.49943906699991,
								30.552290492000054
							],
							[
								-81.49938733899995,
								30.552262836000065
							],
							[
								-81.49928128199991,
								30.552191077000092
							],
							[
								-81.4970342819999,
								30.550425077000053
							],
							[
								-81.49693329599995,
								30.55033242700006
							],
							[
								-81.49409929599994,
								30.547303427000088
							],
							[
								-81.49404240399991,
								30.54723632100007
							]
						],
						[
							[
								-81.45662516399995,
								30.46326166100005
							],
							[
								-81.4566126759999,
								30.463234880000076
							],
							[
								-81.4564209269999,
								30.46346926800004
							],
							[
								-81.4560035149999,
								30.464863014000056
							],
							[
								-81.4559796769999,
								30.464932225000037
							],
							[
								-81.45595028999992,
								30.464999268000042
							],
							[
								-81.4559155469999,
								30.46506369900004
							],
							[
								-81.45587567899992,
								30.465125091000065
							],
							[
								-81.45583094999995,
								30.46518303700009
							],
							[
								-81.45578165699993,
								30.465237154000082
							],
							[
								-81.45572812599994,
								30.465287082000092
							],
							[
								-81.45546109999992,
								30.465516502000074
							],
							[
								-81.45538060299992,
								30.46557323100006
							],
							[
								-81.45545483399991,
								30.465553340000042
							],
							[
								-81.45559444999992,
								30.46553983000007
							],
							[
								-81.45574090199995,
								30.465537134000044
							],
							[
								-81.45896337599993,
								30.465359049000085
							],
							[
								-81.45901299999991,
								30.46535767800009
							],
							[
								-81.45916916599992,
								30.46537134100004
							],
							[
								-81.45932058599993,
								30.465411914000075
							],
							[
								-81.45943487199992,
								30.46546276900005
							],
							[
								-81.46014607699993,
								30.465840539000055
							],
							[
								-81.45912781599992,
								30.464538381000068
							],
							[
								-81.4590195429999,
								30.46445645400007
							],
							[
								-81.45712309299995,
								30.463708625000038
							],
							[
								-81.45705409999994,
								30.463678019000046
							],
							[
								-81.45698791799992,
								30.463641733000088
							],
							[
								-81.45692501299993,
								30.463600022000037
							],
							[
								-81.45686582899992,
								30.463553181000066
							],
							[
								-81.45681078299992,
								30.46350154100008
							],
							[
								-81.45676026399991,
								30.463445464000078
							],
							[
								-81.45670744799992,
								30.463380855000082
							],
							[
								-81.45662516399995,
								30.46326166100005
							]
						],
						[
							[
								-81.45878121599992,
								30.46125223000007
							],
							[
								-81.45867077999992,
								30.459043518000048
							],
							[
								-81.45807176899991,
								30.459230567000077
							],
							[
								-81.45665202799995,
								30.460275335000066
							],
							[
								-81.45659338399992,
								30.460315028000082
							],
							[
								-81.45653179899995,
								30.46034998500005
							],
							[
								-81.45646765399994,
								30.46037998700007
							],
							[
								-81.45640134799993,
								30.460404850000092
							],
							[
								-81.45633329099992,
								30.46042441800006
							],
							[
								-81.4562639049999,
								30.460438571000054
							],
							[
								-81.4561936209999,
								30.46044722100004
							],
							[
								-81.45614331799993,
								30.460451409000086
							],
							[
								-81.45620845899994,
								30.46049067900009
							],
							[
								-81.45626990499994,
								30.46053551000006
							],
							[
								-81.45632718299993,
								30.460585556000073
							],
							[
								-81.45637985299993,
								30.460640432000048
							],
							[
								-81.45698085399994,
								30.46132043200004
							],
							[
								-81.45701845999992,
								30.461365904000047
							],
							[
								-81.4570934589999,
								30.461462904000086
							],
							[
								-81.45713675399992,
								30.46152089400005
							],
							[
								-81.45717424499992,
								30.461582795000083
							],
							[
								-81.45720558199992,
								30.46164802700008
							],
							[
								-81.45723047299992,
								30.46171598100005
							],
							[
								-81.45724868499991,
								30.46178602100008
							],
							[
								-81.45878121599992,
								30.46125223000007
							]
						],
						[
							[
								-81.4542349699999,
								30.461291333000077
							],
							[
								-81.45510738199994,
								30.460564197000057
							],
							[
								-81.45445065399991,
								30.460856765000074
							],
							[
								-81.4542349699999,
								30.461291333000077
							]
						]
					],
					[
						[
							[
								-81.49096199999993,
								30.55462300000005
							],
							[
								-81.49052999999992,
								30.551150000000064
							],
							[
								-81.49030171999993,
								30.550386596000067
							],
							[
								-81.49033460599992,
								30.550299452000043
							],
							[
								-81.49035800599995,
								30.55024328100006
							],
							[
								-81.49151800599992,
								30.547704281000055
							],
							[
								-81.49154902099991,
								30.54764274900009
							],
							[
								-81.49158465499994,
								30.547583773000042
							],
							[
								-81.49162470099992,
								30.547527698000064
							],
							[
								-81.49166892199992,
								30.54747485300004
							],
							[
								-81.49171705899994,
								30.547425550000067
							],
							[
								-81.4920480589999,
								30.547111550000068
							],
							[
								-81.49208892699994,
								30.547075080000074
							],
							[
								-81.49221733899992,
								30.546985164000038
							],
							[
								-81.4923594139999,
								30.54691891400006
							],
							[
								-81.4925108349999,
								30.546878341000085
							],
							[
								-81.49266699999993,
								30.546864678000077
							],
							[
								-81.49282316599994,
								30.546878341000085
							],
							[
								-81.49297458599995,
								30.54691891400006
							],
							[
								-81.49311666099993,
								30.546985164000038
							],
							[
								-81.49318475399991,
								30.54702867000009
							],
							[
								-81.49354975399991,
								30.54728567000006
							],
							[
								-81.49360959299992,
								30.54733167800003
							],
							[
								-81.49366536399992,
								30.547382541000047
							],
							[
								-81.49371667299994,
								30.54743790300006
							],
							[
								-81.49376315899991,
								30.547497372000063
							],
							[
								-81.4938044939999,
								30.54756053000005
							],
							[
								-81.49384038699992,
								30.54762693100008
							],
							[
								-81.49387058499991,
								30.54769610900007
							],
							[
								-81.49413883599993,
								30.54838876200006
							],
							[
								-81.49416120099994,
								30.548456242000043
							],
							[
								-81.4941781629999,
								30.548525278000056
							],
							[
								-81.49418961599991,
								30.54859544000004
							],
							[
								-81.4941954869999,
								30.548666287000064
							],
							[
								-81.49419573999995,
								30.548737376000073
							],
							[
								-81.49419037399991,
								30.54880826300007
							],
							[
								-81.49414423999991,
								30.54920738900006
							],
							[
								-81.49443632899994,
								30.550283466000053
							],
							[
								-81.49489642099991,
								30.551146444000043
							],
							[
								-81.4955171119999,
								30.551813920000086
							],
							[
								-81.49696746599994,
								30.55262980100008
							],
							[
								-81.49952111099994,
								30.553661153000068
							],
							[
								-81.50049140499993,
								30.55385831100006
							],
							[
								-81.50130604399993,
								30.553882072000082
							],
							[
								-81.5021717059999,
								30.553775762000043
							],
							[
								-81.50346906599992,
								30.55363213600009
							],
							[
								-81.50356799999992,
								30.553626678000057
							],
							[
								-81.5036825059999,
								30.553633997000077
							],
							[
								-81.50524050599995,
								30.553833998000076
							],
							[
								-81.50531199199992,
								30.553846117000038
							],
							[
								-81.50538226799995,
								30.55386396000006
							],
							[
								-81.50545087699993,
								30.553887411000062
							],
							[
								-81.50551737299992,
								30.55391631600008
							],
							[
								-81.50558132099991,
								30.55395048800005
							],
							[
								-81.50644798199994,
								30.554467811000052
							],
							[
								-81.50650338999993,
								30.55450371100005
							],
							[
								-81.50739738999994,
								30.55513071100006
							],
							[
								-81.50745907299995,
								30.555178079000086
							],
							[
								-81.5075625099999,
								30.55528020800006
							],
							[
								-81.50832450999991,
								30.556165208000042
							],
							[
								-81.50839676499993,
								30.55626147200007
							],
							[
								-81.50886076499995,
								30.556974472000036
							],
							[
								-81.50890058999994,
								30.55704192300004
							],
							[
								-81.50893439499993,
								30.55711258300005
							],
							[
								-81.50896192199991,
								30.557185917000087
							],
							[
								-81.50898296399993,
								30.557261368000074
							],
							[
								-81.5092149649999,
								30.558259368000048
							],
							[
								-81.50922944799993,
								30.558336974000042
							],
							[
								-81.50923706999993,
								30.558415552000042
							],
							[
								-81.5092377709999,
								30.55849449500005
							],
							[
								-81.50923154599991,
								30.55857319500006
							],
							[
								-81.50921844299995,
								30.558651047000073
							],
							[
								-81.50898983099995,
								30.559720197000047
							],
							[
								-81.50886199099995,
								30.56044488200007
							],
							[
								-81.5089349189999,
								30.560708038000087
							],
							[
								-81.50923569199995,
								30.561157080000044
							],
							[
								-81.51032474199991,
								30.561790784000035
							],
							[
								-81.51117645799991,
								30.562132670000043
							],
							[
								-81.5123813319999,
								30.562360523000052
							],
							[
								-81.51314039399995,
								30.562386192000076
							],
							[
								-81.51326616599994,
								30.56239934000007
							],
							[
								-81.51331723099992,
								30.562409879000086
							],
							[
								-81.51464300799995,
								30.562723827000074
							],
							[
								-81.51500678499991,
								30.562809775000062
							],
							[
								-81.51510758599994,
								30.56283991400005
							],
							[
								-81.51524966099993,
								30.562906165000076
							],
							[
								-81.51537807299991,
								30.56299608000006
							],
							[
								-81.51548891999995,
								30.56310692700003
							],
							[
								-81.51552703699991,
								30.563155664000078
							],
							[
								-81.51569303699995,
								30.563383664000067
							],
							[
								-81.51573479799993,
								30.56344638400009
							],
							[
								-81.51577116099992,
								30.563512381000066
							],
							[
								-81.51580187199994,
								30.56358119000004
							],
							[
								-81.51582671499996,
								30.563652328000046
							],
							[
								-81.5158455159999,
								30.563725296000086
							],
							[
								-81.5158581419999,
								30.563799582000062
							],
							[
								-81.51586450499991,
								30.563874664000082
							],
							[
								-81.51588050499994,
								30.564249664000045
							],
							[
								-81.5158808889999,
								30.564315890000046
							],
							[
								-81.51587639999991,
								30.564381964000066
							],
							[
								-81.51586705999995,
								30.56444752900006
							],
							[
								-81.51585291999993,
								30.564512228000073
							],
							[
								-81.51578391999993,
								30.564780228000075
							],
							[
								-81.5157630359999,
								30.56484963300005
							],
							[
								-81.51573662999994,
								30.56491713000008
							],
							[
								-81.51570487399994,
								30.564982282000077
							],
							[
								-81.51566797499993,
								30.565044665000077
							],
							[
								-81.51528997399993,
								30.565628665000077
							],
							[
								-81.51522392099992,
								30.565718073000088
							],
							[
								-81.51513199599992,
								30.565812589000075
							],
							[
								-81.5147925469999,
								30.566113887000085
							],
							[
								-81.51457594499993,
								30.56631501700008
							],
							[
								-81.51454207299992,
								30.566344921000056
							],
							[
								-81.51442467299995,
								30.566428373000065
							],
							[
								-81.51374516699991,
								30.566833604000067
							],
							[
								-81.51359758599996,
								30.56690308600008
							],
							[
								-81.51353558999995,
								30.56692313900004
							],
							[
								-81.51338058999994,
								30.56696713900004
							],
							[
								-81.51329116599993,
								30.56698765900006
							],
							[
								-81.51313499999992,
								30.567001322000067
							],
							[
								-81.51282399999991,
								30.567001322000067
							],
							[
								-81.51278493699994,
								30.567000473000064
							],
							[
								-81.51253126199992,
								30.566989444000054
							],
							[
								-81.51205017699994,
								30.56687667700004
							],
							[
								-81.51202441099993,
								30.566862949000043
							],
							[
								-81.51198967399995,
								30.566842343000076
							],
							[
								-81.50407455899995,
								30.564857758000073
							],
							[
								-81.50401274599994,
								30.564842018000036
							],
							[
								-81.50393079399993,
								30.56481855800007
							],
							[
								-81.50177675499992,
								30.56407668700007
							],
							[
								-81.50164015599995,
								30.56401509700004
							],
							[
								-81.49775651099992,
								30.561856910000078
							],
							[
								-81.4952995079999,
								30.559241013000076
							],
							[
								-81.49495399999995,
								30.55897800000008
							],
							[
								-81.49329699999993,
								30.557152000000087
							],
							[
								-81.49316741199993,
								30.55697103500006
							],
							[
								-81.49096199999993,
								30.55462300000005
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Nassau",
				"City": "Jacksonville",
				"Name": "Black Hammock Island",
				"RegionID": "268897"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.51926532199991,
					30.44173967800009,
					-81.4484116779999,
					30.567001322000067
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-81.49404240399991,
								30.54723632100007
							],
							[
								-81.49272732599991,
								30.54552172600006
							],
							[
								-81.49220980699994,
								30.54497309900006
							],
							[
								-81.49219509499994,
								30.54495712000005
							],
							[
								-81.4891710949999,
								30.541592120000075
							],
							[
								-81.4890948769999,
								30.541494559000053
							],
							[
								-81.48803431699992,
								30.539925236000045
							],
							[
								-81.48744145799994,
								30.539333211000045
							],
							[
								-81.48648357199994,
								30.538669052000046
							],
							[
								-81.48638213599992,
								30.538587230000076
							],
							[
								-81.48570013599993,
								30.537950229000046
							],
							[
								-81.48563576399994,
								30.53788357200005
							],
							[
								-81.48517259499994,
								30.537351652000037
							],
							[
								-81.4845469739999,
								30.53683594900008
							],
							[
								-81.48448888599995,
								30.536783666000076
							],
							[
								-81.48326688599991,
								30.535583667000083
							],
							[
								-81.48316931099993,
								30.535470440000044
							],
							[
								-81.48233766699991,
								30.53432522500009
							],
							[
								-81.48152458399994,
								30.53338431000009
							],
							[
								-81.48108159999992,
								30.533124117000057
							],
							[
								-81.48025849399994,
								30.53262931300009
							],
							[
								-81.4796428269999,
								30.53232331700008
							],
							[
								-81.4787894879999,
								30.53195606900005
							],
							[
								-81.47875344499994,
								30.53193960700008
							],
							[
								-81.47792844499992,
								30.53154060800006
							],
							[
								-81.47780904399991,
								30.531471071000055
							],
							[
								-81.47706266499995,
								30.53095575900005
							],
							[
								-81.47632399999992,
								30.530517933000052
							],
							[
								-81.47572110599992,
								30.530276151000066
							],
							[
								-81.47531264299994,
								30.530223079000056
							],
							[
								-81.47484408499992,
								30.53015632200004
							],
							[
								-81.4747157409999,
								30.530128336000075
							],
							[
								-81.4738137409999,
								30.529861336000067
							],
							[
								-81.47374743499995,
								30.529838867000084
							],
							[
								-81.47368307799991,
								30.529811309000078
							],
							[
								-81.47362105999991,
								30.52977882700009
							],
							[
								-81.47356175599992,
								30.52974162000004
							],
							[
								-81.47350552699993,
								30.529699913000062
							],
							[
								-81.47345271199993,
								30.529653957000047
							],
							[
								-81.47293067199992,
								30.529162740000064
							],
							[
								-81.4722371979999,
								30.528585646000067
							],
							[
								-81.47185675499992,
								30.52828089700006
							],
							[
								-81.47181390899993,
								30.528244315000055
							],
							[
								-81.4713977799999,
								30.527865854000083
							],
							[
								-81.47120203999994,
								30.527733553000076
							],
							[
								-81.4708929009999,
								30.52763897600005
							],
							[
								-81.47082036099994,
								30.52761368900008
							],
							[
								-81.4707504029999,
								30.52758195000007
							],
							[
								-81.47068359899993,
								30.52754401900006
							],
							[
								-81.47062049699991,
								30.527500205000077
							],
							[
								-81.47055084699991,
								30.527500274000086
							],
							[
								-81.47048141199991,
								30.527494813000093
							],
							[
								-81.47041262899995,
								30.527483858000036
							],
							[
								-81.47007762999993,
								30.527416858000038
							],
							[
								-81.46994641399993,
								30.527380086000054
							],
							[
								-81.4698952469999,
								30.527359667000045
							],
							[
								-81.46936424699993,
								30.527128668000046
							],
							[
								-81.46934157999993,
								30.52711843200007
							],
							[
								-81.46889957999991,
								30.52691143100009
							],
							[
								-81.4688313389999,
								30.52687583500005
							],
							[
								-81.4687216019999,
								30.526801169000063
							],
							[
								-81.46842693499991,
								30.52656708200004
							],
							[
								-81.46818710199994,
								30.52654271600005
							],
							[
								-81.46815638599992,
								30.52653906100005
							],
							[
								-81.46777538599991,
								30.52648706100007
							],
							[
								-81.46769636699992,
								30.52647265700006
							],
							[
								-81.46761894899993,
								30.52645125900006
							],
							[
								-81.4675437489999,
								30.526423039000065
							],
							[
								-81.46747136699992,
								30.526388223000083
							],
							[
								-81.4674023799999,
								30.52634708700009
							],
							[
								-81.46733733799994,
								30.526299959000085
							],
							[
								-81.46689770199993,
								30.52595044000009
							],
							[
								-81.4646413829999,
								30.52489164100007
							],
							[
								-81.4619544119999,
								30.52393516600006
							],
							[
								-81.4618093389999,
								30.52386783600008
							],
							[
								-81.46168092699992,
								30.52377792100009
							],
							[
								-81.4615700789999,
								30.523667073000073
							],
							[
								-81.46148016399991,
								30.523538661000092
							],
							[
								-81.46141391299994,
								30.52339658700004
							],
							[
								-81.46137333999991,
								30.523245166000034
							],
							[
								-81.46135967799995,
								30.523089000000088
							],
							[
								-81.46137333999991,
								30.522932835000066
							],
							[
								-81.46141391299994,
								30.522781414000065
							],
							[
								-81.46145194699994,
								30.52269220600005
							],
							[
								-81.46188680799992,
								30.521807729000045
							],
							[
								-81.46342191799994,
								30.51933518200008
							],
							[
								-81.46433952799993,
								30.518067639000037
							],
							[
								-81.46436487999995,
								30.518034284000063
							],
							[
								-81.46475432799991,
								30.51754592800006
							],
							[
								-81.46514291699992,
								30.516817105000083
							],
							[
								-81.46547130499994,
								30.516084251000052
							],
							[
								-81.46550229299993,
								30.516021717000058
							],
							[
								-81.46566127299991,
								30.515729939000042
							],
							[
								-81.46602185299992,
								30.51506815900007
							],
							[
								-81.4661270819999,
								30.51487503000004
							],
							[
								-81.46907731699991,
								30.51045730300007
							],
							[
								-81.46934147699994,
								30.510069081000044
							],
							[
								-81.46939798999995,
								30.50999465700005
							],
							[
								-81.46960495899992,
								30.509749647000035
							],
							[
								-81.46964667799995,
								30.509620914000042
							],
							[
								-81.46964667799995,
								30.50946900000008
							],
							[
								-81.46966034099995,
								30.50931283500006
							],
							[
								-81.46970091399993,
								30.50916141400006
							],
							[
								-81.46976716499995,
								30.509019339000076
							],
							[
								-81.46985707999995,
								30.50889092700004
							],
							[
								-81.46987531899993,
								30.50886986200004
							],
							[
								-81.47007631899993,
								30.50864486100005
							],
							[
								-81.47012945899992,
								30.50858929700007
							],
							[
								-81.4701874729999,
								30.508538844000043
							],
							[
								-81.47024987299994,
								30.508493927000078
							],
							[
								-81.47031613099995,
								30.508454926000073
							],
							[
								-81.47038568799991,
								30.50842216900008
							],
							[
								-81.47039712999992,
								30.50839814700004
							],
							[
								-81.47056652899994,
								30.50792146400005
							],
							[
								-81.47093240399994,
								30.50653206600009
							],
							[
								-81.4707799919999,
								30.50506282100008
							],
							[
								-81.47072178099995,
								30.504542264000065
							],
							[
								-81.47009069199993,
								30.503642363000044
							],
							[
								-81.47004816399993,
								30.503575661000074
							],
							[
								-81.46999725099994,
								30.50347284000009
							],
							[
								-81.46989662699991,
								30.50323211500006
							],
							[
								-81.46945901299995,
								30.503181066000085
							],
							[
								-81.46851101699991,
								30.502552361000088
							],
							[
								-81.46787349399995,
								30.501630613000092
							],
							[
								-81.46777874199995,
								30.50067860700005
							],
							[
								-81.46706807299995,
								30.499679151000066
							],
							[
								-81.46702774499994,
								30.499617191000088
							],
							[
								-81.46699264099993,
								30.499552128000065
							],
							[
								-81.4669630009999,
								30.499484402000064
							],
							[
								-81.46693902299995,
								30.49941447000009
							],
							[
								-81.46692086999991,
								30.499342804000037
							],
							[
								-81.4669087229999,
								30.49928495400007
							],
							[
								-81.46653056199995,
								30.498991420000042
							],
							[
								-81.46647770999994,
								30.498947043000044
							],
							[
								-81.46642841599993,
								30.498898744000087
							],
							[
								-81.46638296999993,
								30.498846807000064
							],
							[
								-81.46634164199992,
								30.49879153900008
							],
							[
								-81.46630467299991,
								30.498733264000066
							],
							[
								-81.4660479179999,
								30.498291963000042
							],
							[
								-81.46601602399994,
								30.498236620000053
							],
							[
								-81.46598909099993,
								30.498178700000036
							],
							[
								-81.46596732599994,
								30.498118647000066
							],
							[
								-81.46595089399996,
								30.498056922000046
							],
							[
								-81.46593992299995,
								30.49799399500006
							],
							[
								-81.46593449499994,
								30.497930351000036
							],
							[
								-81.46586917799993,
								30.497946829000057
							],
							[
								-81.46580265599994,
								30.497957445000054
							],
							[
								-81.46573545399991,
								30.497962115000067
							],
							[
								-81.46566810299993,
								30.49796080200008
							],
							[
								-81.46560113499993,
								30.497953517000045
							],
							[
								-81.46553507699991,
								30.497940318000076
							],
							[
								-81.46547045099993,
								30.49792130800006
							],
							[
								-81.4654033509999,
								30.49790388400004
							],
							[
								-81.4653840439999,
								30.49789709400005
							],
							[
								-81.46532037099992,
								30.497876197000043
							],
							[
								-81.46530140499993,
								30.49786803300009
							],
							[
								-81.46523605399994,
								30.497840134000057
							],
							[
								-81.46517322099993,
								30.497806951000086
							],
							[
								-81.46511333199993,
								30.49776871000006
							],
							[
								-81.46505679299992,
								30.49772566900009
							],
							[
								-81.46500398899991,
								30.49767812100004
							],
							[
								-81.46495527699994,
								30.49762638800007
							],
							[
								-81.46491098799993,
								30.49757082200006
							],
							[
								-81.46484650899993,
								30.49748266000006
							],
							[
								-81.46286949799992,
								30.49486186500008
							],
							[
								-81.46278669299994,
								30.494729275000054
							],
							[
								-81.46217069399995,
								30.493520275000037
							],
							[
								-81.46214113199994,
								30.493456148000064
							],
							[
								-81.46211669199994,
								30.493389899000082
							],
							[
								-81.46209752499993,
								30.493321938000065
							],
							[
								-81.46208374999992,
								30.49325268200005
							],
							[
								-81.46207544999993,
								30.49318255800006
							],
							[
								-81.46207267799991,
								30.493112000000053
							],
							[
								-81.46207267799991,
								30.493009000000082
							],
							[
								-81.46208634099992,
								30.49285283400008
							],
							[
								-81.46212773699995,
								30.492699171000083
							],
							[
								-81.4621655599999,
								30.49259692800007
							],
							[
								-81.46219590599992,
								30.492524735000075
							],
							[
								-81.46223241699994,
								30.492455457000066
							],
							[
								-81.46227481799991,
								30.49238961700007
							],
							[
								-81.4623227859999,
								30.49232771600009
							],
							[
								-81.46237595699995,
								30.492270223000048
							],
							[
								-81.46243392899993,
								30.49221757400005
							],
							[
								-81.46249626199995,
								30.492170169000076
							],
							[
								-81.4625624819999,
								30.492128366000088
							],
							[
								-81.46268562599994,
								30.492058568000065
							],
							[
								-81.46274672599992,
								30.492026969000047
							],
							[
								-81.4628100619999,
								30.492000132000044
							],
							[
								-81.46287526399993,
								30.491978215000074
							],
							[
								-81.46294195099995,
								30.49196134500005
							],
							[
								-81.46300973199993,
								30.49194962200005
							],
							[
								-81.46315173199991,
								30.49193062200004
							],
							[
								-81.46327189499993,
								30.49192267800004
							],
							[
								-81.46531637399994,
								30.49192471200007
							],
							[
								-81.46505830599996,
								30.49175800700004
							],
							[
								-81.46139617299991,
								30.49015920000005
							],
							[
								-81.46132662199994,
								30.490125200000083
							],
							[
								-81.46126025299992,
								30.49008534400008
							],
							[
								-81.46119755799992,
								30.490039928000044
							],
							[
								-81.46113900099994,
								30.48998928800006
							],
							[
								-81.46108501599991,
								30.489933800000074
							],
							[
								-81.46103600399994,
								30.489873875000058
							],
							[
								-81.46099232699993,
								30.489809956000045
							],
							[
								-81.45822142999992,
								30.485354682000036
							],
							[
								-81.45793842699993,
								30.484667662000053
							],
							[
								-81.45788097499991,
								30.483913251000047
							],
							[
								-81.45911059499991,
								30.47578446700004
							],
							[
								-81.45890402899994,
								30.474795333000092
							],
							[
								-81.45852942099992,
								30.473001539000055
							],
							[
								-81.4582979079999,
								30.471892946000082
							],
							[
								-81.45818543199994,
								30.47173406100006
							],
							[
								-81.45796139399994,
								30.47141758300006
							],
							[
								-81.45486998399991,
								30.46705061600005
							],
							[
								-81.45482516499993,
								30.466980661000036
							],
							[
								-81.45475891399991,
								30.46683858700004
							],
							[
								-81.45471834099993,
								30.466687166000042
							],
							[
								-81.45470467799993,
								30.46653100000009
							],
							[
								-81.45470726999991,
								30.46646277700006
							],
							[
								-81.45471426899991,
								30.466370776000076
							],
							[
								-81.45472534099991,
								30.46628283400008
							],
							[
								-81.45476591399995,
								30.466131414000074
							],
							[
								-81.45483216399992,
								30.46598933900009
							],
							[
								-81.45492207899993,
								30.46586092700005
							],
							[
								-81.45503292699993,
								30.465750079000088
							],
							[
								-81.4551088529999,
								30.46569691500008
							],
							[
								-81.4550351659999,
								30.46571666000006
							],
							[
								-81.45487899999995,
								30.465730322000066
							],
							[
								-81.45476599999995,
								30.465730322000066
							],
							[
								-81.4546935429999,
								30.465727399000055
							],
							[
								-81.45462155699994,
								30.465718647000077
							],
							[
								-81.45455050999993,
								30.46570412300008
							],
							[
								-81.45448086399995,
								30.465683923000082
							],
							[
								-81.45441307199991,
								30.465658177000083
							],
							[
								-81.45430815399993,
								30.465612694000075
							],
							[
								-81.45426377399991,
								30.46559267000003
							],
							[
								-81.45416633899993,
								30.465545836000043
							],
							[
								-81.45415147299991,
								30.46553601100004
							],
							[
								-81.45294595599995,
								30.464808749000042
							],
							[
								-81.45283292699993,
								30.464727920000087
							],
							[
								-81.4527220789999,
								30.46461707300006
							],
							[
								-81.45263216399991,
								30.464488661000072
							],
							[
								-81.45256591399993,
								30.464346586000094
							],
							[
								-81.4525253409999,
								30.46419516500004
							],
							[
								-81.45251167799995,
								30.464039000000067
							],
							[
								-81.4525253409999,
								30.463882834000064
							],
							[
								-81.45256591399993,
								30.46373141400005
							],
							[
								-81.45263216399991,
								30.463589339000062
							],
							[
								-81.45264557299993,
								30.46356687500008
							],
							[
								-81.4528560569999,
								30.463225631000057
							],
							[
								-81.45278510999992,
								30.463234666000062
							],
							[
								-81.4527136669999,
								30.46323797400004
							],
							[
								-81.4526421889999,
								30.463235533000045
							],
							[
								-81.45257113799994,
								30.46322735800004
							],
							[
								-81.45250097299993,
								30.46321350200009
							],
							[
								-81.4524321479999,
								30.463194055000088
							],
							[
								-81.45236510699993,
								30.463169143000073
							],
							[
								-81.45116510699995,
								30.46266914400007
							],
							[
								-81.45106133899992,
								30.46261783600005
							],
							[
								-81.45093292699994,
								30.462527921000063
							],
							[
								-81.45082207899992,
								30.462417073000044
							],
							[
								-81.45073216399993,
								30.46228866100006
							],
							[
								-81.45066591299991,
								30.462146586000078
							],
							[
								-81.45062533999993,
								30.461995166000065
							],
							[
								-81.45061167799992,
								30.46183900000005
							],
							[
								-81.45062533999993,
								30.461682834000047
							],
							[
								-81.45065188999992,
								30.461573085000055
							],
							[
								-81.45178610499994,
								30.45790870000008
							],
							[
								-81.44869405299995,
								30.45499333700008
							],
							[
								-81.4486220789999,
								30.45491707300005
							],
							[
								-81.44853216399991,
								30.454788661000066
							],
							[
								-81.44846591399994,
								30.454646586000084
							],
							[
								-81.4484253409999,
								30.454495165000086
							],
							[
								-81.4484116779999,
								30.454339000000058
							],
							[
								-81.44841241599994,
								30.45430257000004
							],
							[
								-81.44871241599992,
								30.44690257100007
							],
							[
								-81.44871809099993,
								30.44683179200007
							],
							[
								-81.44872933199991,
								30.44676168100006
							],
							[
								-81.44874606999991,
								30.44669267500007
							],
							[
								-81.4487681999999,
								30.446625206000075
							],
							[
								-81.44879558299994,
								30.44655969200005
							],
							[
								-81.44882804999992,
								30.446496543000077
							],
							[
								-81.4488653969999,
								30.44643615200005
							],
							[
								-81.45176539699992,
								30.44213615100006
							],
							[
								-81.4518220789999,
								30.442060927000057
							],
							[
								-81.45193292699992,
								30.441950079000037
							],
							[
								-81.4520613389999,
								30.44186016400005
							],
							[
								-81.45220341399995,
								30.441793914000076
							],
							[
								-81.45235483399995,
								30.44175334100004
							],
							[
								-81.4525109999999,
								30.44173967800009
							],
							[
								-81.45266716599991,
								30.44175334100004
							],
							[
								-81.45269305099993,
								30.441760277000068
							],
							[
								-81.45312184699992,
								30.442148194000087
							],
							[
								-81.45403764199995,
								30.442975363000073
							],
							[
								-81.45557381399993,
								30.443891158000046
							],
							[
								-81.45793715499991,
								30.44442291000007
							],
							[
								-81.45922117399994,
								30.44451547500006
							],
							[
								-81.45936986399994,
								30.444645142000073
							],
							[
								-81.45942839899993,
								30.444598796000037
							],
							[
								-81.4594906129999,
								30.44455752000005
							],
							[
								-81.45955606799993,
								30.444521605000034
							],
							[
								-81.45962430299994,
								30.444491303000063
							],
							[
								-81.45969483899995,
								30.444466829000078
							],
							[
								-81.45997212799995,
								30.444383381000083
							],
							[
								-81.4620799999999,
								30.44488700000005
							],
							[
								-81.46383702799994,
								30.444735862000073
							],
							[
								-81.4641269089999,
								30.446171012000036
							],
							[
								-81.46505690999993,
								30.45075001200007
							],
							[
								-81.46521790999992,
								30.451424012000075
							],
							[
								-81.46527090899991,
								30.451567012000055
							],
							[
								-81.46530891099991,
								30.45172501200005
							],
							[
								-81.46547690999995,
								30.45216201300008
							],
							[
								-81.46556090999991,
								30.452358012000047
							],
							[
								-81.46563690999994,
								30.45249601300009
							],
							[
								-81.46571390999992,
								30.452677012000038
							],
							[
								-81.46578190899993,
								30.45279701200008
							],
							[
								-81.46584290899995,
								30.452927013000075
							],
							[
								-81.46591890899992,
								30.453058012000042
							],
							[
								-81.46724690899993,
								30.45550301300005
							],
							[
								-81.46742990999991,
								30.455822012000056
							],
							[
								-81.46766690999993,
								30.456198012000073
							],
							[
								-81.46786490999995,
								30.456491012000075
							],
							[
								-81.4681549089999,
								30.45686501300008
							],
							[
								-81.46829190999995,
								30.457016012000057
							],
							[
								-81.4686739089999,
								30.457424012000047
							],
							[
								-81.46888790899993,
								30.457621012000065
							],
							[
								-81.46916990999995,
								30.457890012000064
							],
							[
								-81.4693449099999,
								30.458025012000064
							],
							[
								-81.46963490999991,
								30.458256013000042
							],
							[
								-81.47007790899994,
								30.45856301300006
							],
							[
								-81.4705659089999,
								30.45886001200006
							],
							[
								-81.47097790999993,
								30.45908401200006
							],
							[
								-81.47123691099995,
								30.45920601300008
							],
							[
								-81.47133590999994,
								30.459261012000074
							],
							[
								-81.47186290999991,
								30.459473012000046
							],
							[
								-81.47244990999991,
								30.459677012000043
							],
							[
								-81.47286990999993,
								30.459803012000066
							],
							[
								-81.47325090999993,
								30.459890013000063
							],
							[
								-81.47411290899993,
								30.460051012000065
							],
							[
								-81.4743269089999,
								30.46007901200005
							],
							[
								-81.47450890999994,
								30.460106013000086
							],
							[
								-81.47635693799992,
								30.460390018000055
							],
							[
								-81.47622007299992,
								30.463598231000052
							],
							[
								-81.47743399899993,
								30.46548593700004
							],
							[
								-81.47743390999995,
								30.46656474700006
							],
							[
								-81.47689455599993,
								30.46764363500006
							],
							[
								-81.47568074399993,
								30.467643330000048
							],
							[
								-81.47554589999993,
								30.469261713000037
							],
							[
								-81.4771642199999,
								30.46912656600006
							],
							[
								-81.47783830699991,
								30.469935864000036
							],
							[
								-81.4790519419999,
								30.470475170000046
							],
							[
								-81.48026566099992,
								30.47101441600006
							],
							[
								-81.4806700549999,
								30.472228125000072
							],
							[
								-81.48107443299995,
								30.47384633000007
							],
							[
								-81.4822881309999,
								30.474925056000075
							],
							[
								-81.4833670619999,
								30.47519455400004
							],
							[
								-81.4832322179999,
								30.477217426000042
							],
							[
								-81.48188348399992,
								30.477621730000067
							],
							[
								-81.48201834799994,
								30.47910524300005
							],
							[
								-81.48309722599993,
								30.479239952000057
							],
							[
								-81.48485031099995,
								30.479374657000047
							],
							[
								-81.48496661999991,
								30.480425206000064
							],
							[
								-81.4852121639999,
								30.48095547800006
							],
							[
								-81.48556211999994,
								30.481585398000053
							],
							[
								-81.48566710599994,
								30.48218032300008
							],
							[
								-81.48594711299995,
								30.48306349600006
							],
							[
								-81.4855787919999,
								30.48369246400006
							],
							[
								-81.48528402699992,
								30.48420064700008
							],
							[
								-81.48508432199992,
								30.484596166000074
							],
							[
								-81.48508432199992,
								30.484696477000057
							],
							[
								-81.4850997179999,
								30.48474601500004
							],
							[
								-81.4853817469999,
								30.485019446000077
							],
							[
								-81.48610770499994,
								30.48554873400008
							],
							[
								-81.48695293499993,
								30.48608294800005
							],
							[
								-81.48819840199991,
								30.486643637000043
							],
							[
								-81.48839554599994,
								30.486703953000074
							],
							[
								-81.4885717379999,
								30.486869727000055
							],
							[
								-81.48909667099991,
								30.487359665000042
							],
							[
								-81.48927164899993,
								30.487814607000075
							],
							[
								-81.48913166699992,
								30.48816456300006
							],
							[
								-81.4885717379999,
								30.48851451800005
							],
							[
								-81.4879068219999,
								30.488829478000074
							],
							[
								-81.48753667799993,
								30.489398000000048
							],
							[
								-81.48753819799992,
								30.48938062600007
							],
							[
								-81.48724831699991,
								30.489616991000048
							],
							[
								-81.48715342799994,
								30.489684622000084
							],
							[
								-81.4859534279999,
								30.490427622000084
							],
							[
								-81.4858565319999,
								30.49047970300006
							],
							[
								-81.48560121399993,
								30.490597414000035
							],
							[
								-81.4854989129999,
								30.490733939000055
							],
							[
								-81.4850681499999,
								30.491526469000068
							],
							[
								-81.48504803299994,
								30.491561575000045
							],
							[
								-81.48469696299992,
								30.492143473000056
							],
							[
								-81.48467653299991,
								30.49220254100004
							],
							[
								-81.48465278799995,
								30.492608512000064
							],
							[
								-81.48464499199991,
								30.49268520700008
							],
							[
								-81.48463065699991,
								30.49276095200008
							],
							[
								-81.48460988799991,
								30.492835192000086
							],
							[
								-81.48458283699995,
								30.492907380000077
							],
							[
								-81.48454970199992,
								30.49297698600009
							],
							[
								-81.48451072899991,
								30.493043498000077
							],
							[
								-81.48446620199991,
								30.493106429000083
							],
							[
								-81.4839732019999,
								30.493743429000062
							],
							[
								-81.48392420699992,
								30.493801492000046
							],
							[
								-81.48387048599994,
								30.49385521200008
							],
							[
								-81.48381242199991,
								30.49390420700007
							],
							[
								-81.48375043099992,
								30.493948126000078
							],
							[
								-81.48309252299993,
								30.49437367400009
							],
							[
								-81.48289363099991,
								30.49457364100004
							],
							[
								-81.48213827199993,
								30.496095597000078
							],
							[
								-81.48217224899992,
								30.496364406000055
							],
							[
								-81.48235508699992,
								30.496916638000076
							],
							[
								-81.48248788899991,
								30.49712351000005
							],
							[
								-81.48373890699992,
								30.497906150000063
							],
							[
								-81.4851300599999,
								30.49862614800009
							],
							[
								-81.48516381099995,
								30.498632754000088
							],
							[
								-81.48540696299995,
								30.498613488000046
							],
							[
								-81.48554345299993,
								30.49861306300005
							],
							[
								-81.48591345299991,
								30.498640063000042
							],
							[
								-81.48600416499994,
								30.498651341000087
							],
							[
								-81.48609598899992,
								30.49867254600008
							],
							[
								-81.4868302189999,
								30.49888317700004
							],
							[
								-81.48759643499994,
								30.499093862000056
							],
							[
								-81.48766558599993,
								30.499115914000075
							],
							[
								-81.48781528099994,
								30.499186664000035
							],
							[
								-81.4879702149999,
								30.499280126000087
							],
							[
								-81.48814667199991,
								30.499303507000036
							],
							[
								-81.48919647699995,
								30.499353678000034
							],
							[
								-81.49005493399994,
								30.499353678000034
							],
							[
								-81.49082715599991,
								30.49932951700003
							],
							[
								-81.49154949899992,
								30.499234568000073
							],
							[
								-81.4924212489999,
								30.499573114000043
							],
							[
								-81.4926662179999,
								30.499923070000083
							],
							[
								-81.49287619099994,
								30.500482999000038
							],
							[
								-81.4928590689999,
								30.501002810000045
							],
							[
								-81.49236277999995,
								30.501539123000043
							],
							[
								-81.4921746679999,
								30.50273252500006
							],
							[
								-81.49226875099993,
								30.503974044000074
							],
							[
								-81.49227002999993,
								30.503993819000073
							],
							[
								-81.4923442349999,
								30.505376883000054
							],
							[
								-81.4926170839999,
								30.505996629000034
							],
							[
								-81.49263293699994,
								30.50603501500007
							],
							[
								-81.4928789359999,
								30.50667201500005
							],
							[
								-81.49289508699991,
								30.50671741900004
							],
							[
								-81.49306016899993,
								30.507224132000086
							],
							[
								-81.49323425999995,
								30.507440960000054
							],
							[
								-81.4932889769999,
								30.507516886000072
							],
							[
								-81.49344297699992,
								30.507755887000087
							],
							[
								-81.49347843599992,
								30.50781589700006
							],
							[
								-81.49350913699993,
								30.507878475000037
							],
							[
								-81.49353489399994,
								30.507943244000042
							],
							[
								-81.4935555539999,
								30.50800981500004
							],
							[
								-81.4935709909999,
								30.508077788000037
							],
							[
								-81.4935811119999,
								30.50814675200007
							],
							[
								-81.49361909499993,
								30.50815495300009
							],
							[
								-81.49411506899992,
								30.50822972800006
							],
							[
								-81.49419366699993,
								30.508245185000078
							],
							[
								-81.49427057799994,
								30.50826757600004
							],
							[
								-81.49434519199991,
								30.50829672100008
							],
							[
								-81.49441691599992,
								30.508332389000085
							],
							[
								-81.49448518199995,
								30.508374299000085
							],
							[
								-81.49454944699994,
								30.508422116000077
							],
							[
								-81.49509686699992,
								30.50886864600005
							],
							[
								-81.49626779099992,
								30.509625184000072
							],
							[
								-81.49633992499992,
								30.50966674000006
							],
							[
								-81.49645607799994,
								30.50974638100007
							],
							[
								-81.4969565749999,
								30.510150730000078
							],
							[
								-81.49701390099995,
								30.51020218000008
							],
							[
								-81.49706661099992,
								30.510258349000082
							],
							[
								-81.49711431999992,
								30.51031882400008
							],
							[
								-81.49715667599992,
								30.510383161000053
							],
							[
								-81.49719336899994,
								30.510450888000037
							],
							[
								-81.49722412899992,
								30.510521508000068
							],
							[
								-81.4972487309999,
								30.51059450200006
							],
							[
								-81.49740272999992,
								30.511125502000088
							],
							[
								-81.49742465899993,
								30.51121983400009
							],
							[
								-81.49743832199994,
								30.511376000000045
							],
							[
								-81.49742465899993,
								30.511532166000052
							],
							[
								-81.4973840859999,
								30.51168358600006
							],
							[
								-81.49731783499993,
								30.51182566100005
							],
							[
								-81.49722791999994,
								30.511954073000087
							],
							[
								-81.49711707299991,
								30.51206492100005
							],
							[
								-81.49698866099995,
								30.512154836000036
							],
							[
								-81.49686265799994,
								30.51221506200005
							],
							[
								-81.4962621009999,
								30.51244672000007
							],
							[
								-81.49532461699994,
								30.512851218000037
							],
							[
								-81.49480749299994,
								30.51312254400006
							],
							[
								-81.49457136199993,
								30.51341036900004
							],
							[
								-81.49403400999995,
								30.514157229000038
							],
							[
								-81.49399291999993,
								30.514210073000076
							],
							[
								-81.49391643599995,
								30.51429056000006
							],
							[
								-81.49320170399994,
								30.51495523500006
							],
							[
								-81.49259306099992,
								30.515753862000054
							],
							[
								-81.4921995759999,
								30.516551763000052
							],
							[
								-81.4921718359999,
								30.516603661000094
							],
							[
								-81.49213286499992,
								30.516659316000073
							],
							[
								-81.4921661699999,
								30.51673234900005
							],
							[
								-81.49224907699994,
								30.51755866900004
							],
							[
								-81.4930387789999,
								30.518664252000068
							],
							[
								-81.49426281699994,
								30.520164687000086
							],
							[
								-81.49480490099995,
								30.521083582000074
							],
							[
								-81.49537089199993,
								30.52314984100008
							],
							[
								-81.49581513599992,
								30.523892510000053
							],
							[
								-81.4968006339999,
								30.525299058000087
							],
							[
								-81.49781575499992,
								30.526105582000074
							],
							[
								-81.49807661299991,
								30.52622584700004
							],
							[
								-81.4983961399999,
								30.526284415000077
							],
							[
								-81.49854158599993,
								30.52632391300006
							],
							[
								-81.49868366099992,
								30.526390164000077
							],
							[
								-81.49881207299991,
								30.526480079000063
							],
							[
								-81.49892291999993,
								30.526590927000083
							],
							[
								-81.49893930499991,
								30.526611035000087
							],
							[
								-81.49934180199995,
								30.52711981900006
							],
							[
								-81.49997992399994,
								30.527645462000066
							],
							[
								-81.50009391999993,
								30.52775892700004
							],
							[
								-81.50015420799991,
								30.52783954000006
							],
							[
								-81.5002653379999,
								30.528006909000055
							],
							[
								-81.5005373109999,
								30.528138758000072
							],
							[
								-81.5005735769999,
								30.52815736600007
							],
							[
								-81.5014055769999,
								30.528608366000075
							],
							[
								-81.50142666099993,
								30.528620164000078
							],
							[
								-81.5015550729999,
								30.528710079000064
							],
							[
								-81.50166592099993,
								30.528820927000083
							],
							[
								-81.50175583599992,
								30.528949339000064
							],
							[
								-81.50182208599995,
								30.529091414000053
							],
							[
								-81.50186265899993,
								30.52924283400006
							],
							[
								-81.50187632199993,
								30.52939900000007
							],
							[
								-81.50186265899993,
								30.529555166000083
							],
							[
								-81.50182208599995,
								30.52970658600009
							],
							[
								-81.50175583599992,
								30.529848661000074
							],
							[
								-81.50166592099993,
								30.529977073000055
							],
							[
								-81.5016274429999,
								30.530020051000065
							],
							[
								-81.50048644299994,
								30.531215051000057
							],
							[
								-81.50040777399994,
								30.531288157000063
							],
							[
								-81.4997515089999,
								30.53182872000008
							],
							[
								-81.49785053499994,
								30.533952374000084
							],
							[
								-81.4971694269999,
								30.53485714300007
							],
							[
								-81.4967218999999,
								30.53565234300004
							],
							[
								-81.49624474299992,
								30.536663365000035
							],
							[
								-81.49621050899992,
								30.536740485000056
							],
							[
								-81.49617803599995,
								30.53680523600008
							],
							[
								-81.49607456399991,
								30.537024362000068
							],
							[
								-81.49605533099992,
								30.53760326400004
							],
							[
								-81.49609154099994,
								30.53773603600007
							],
							[
								-81.49627570599995,
								30.537958469000046
							],
							[
								-81.49633758199991,
								30.53804745900004
							],
							[
								-81.4964756999999,
								30.538423069000093
							],
							[
								-81.4965763859999,
								30.539248198000056
							],
							[
								-81.49685396299992,
								30.539726831000053
							],
							[
								-81.49690341199994,
								30.53982562300007
							],
							[
								-81.4975226489999,
								30.541279643000053
							],
							[
								-81.4989760059999,
								30.54289357700009
							],
							[
								-81.50033778799991,
								30.54398934100004
							],
							[
								-81.50039073699992,
								30.544035464000043
							],
							[
								-81.50131934399991,
								30.544910445000085
							],
							[
								-81.50225537499995,
								30.545520659000086
							],
							[
								-81.5034412089999,
								30.54623341200005
							],
							[
								-81.50454269699992,
								30.54647615500005
							],
							[
								-81.5066221049999,
								30.54655015200007
							],
							[
								-81.50808999799995,
								30.546409890000064
							],
							[
								-81.50952897699995,
								30.545801548000043
							],
							[
								-81.51066887499991,
								30.544819946000075
							],
							[
								-81.51113191399992,
								30.544186360000086
							],
							[
								-81.51117849699995,
								30.544127886000066
							],
							[
								-81.51122977499995,
								30.54407348300009
							],
							[
								-81.5112853949999,
								30.544023527000036
							],
							[
								-81.5113449719999,
								30.543978364000058
							],
							[
								-81.51230097199993,
								30.543314364000082
							],
							[
								-81.51236792599991,
								30.54327209800005
							],
							[
								-81.5124383399999,
								30.543235890000062
							],
							[
								-81.51251166799995,
								30.54320602100006
							],
							[
								-81.51258733999993,
								30.54318272100005
							],
							[
								-81.5126647699999,
								30.543166174000078
							],
							[
								-81.5129455469999,
								30.54312112500008
							],
							[
								-81.51347689499994,
								30.542723177000088
							],
							[
								-81.51353046199995,
								30.542686011000058
							],
							[
								-81.51358658099991,
								30.54265282300008
							],
							[
								-81.51364495599995,
								30.542623789000057
							],
							[
								-81.51370528199993,
								30.542599060000043
							],
							[
								-81.51376724099993,
								30.542578767000066
							],
							[
								-81.51450724099993,
								30.54236576700004
							],
							[
								-81.5145548889999,
								30.542353453000093
							],
							[
								-81.51485597499993,
								30.542284373000086
							],
							[
								-81.51645692699992,
								30.542884880000088
							],
							[
								-81.51733303999993,
								30.544524406000054
							],
							[
								-81.51775975099991,
								30.54528674300008
							],
							[
								-81.5177800269999,
								30.545325112000054
							],
							[
								-81.5181261319999,
								30.54602012700008
							],
							[
								-81.51842770499991,
								30.546479320000063
							],
							[
								-81.5184625949999,
								30.546537054000055
							],
							[
								-81.51849305899992,
								30.546597241000086
							],
							[
								-81.5185189259999,
								30.546659542000043
							],
							[
								-81.51854005099995,
								30.546723607000047
							],
							[
								-81.51855631399991,
								30.546789075000053
							],
							[
								-81.51893059999992,
								30.548580513000047
							],
							[
								-81.5190457359999,
								30.549018223000076
							],
							[
								-81.51906165899993,
								30.54909083500007
							],
							[
								-81.51907347999992,
								30.549189481000045
							],
							[
								-81.51919448099994,
								30.551077481000053
							],
							[
								-81.51919606399991,
								30.551113482000062
							],
							[
								-81.5192650649999,
								30.55399648200006
							],
							[
								-81.51926532199991,
								30.554018000000042
							],
							[
								-81.51925421899995,
								30.554158885000053
							],
							[
								-81.51863893899991,
								30.558037526000074
							],
							[
								-81.5186237289999,
								30.558109972000064
							],
							[
								-81.51860261099995,
								30.558180921000087
							],
							[
								-81.51857572699993,
								30.558249893000035
							],
							[
								-81.5185432589999,
								30.55831641900005
							],
							[
								-81.5185054289999,
								30.55838004800006
							],
							[
								-81.51846249199993,
								30.55844034900008
							],
							[
								-81.51841473899992,
								30.55849691200007
							],
							[
								-81.51778273799994,
								30.55918591200009
							],
							[
								-81.51773172899993,
								30.559237216000042
							],
							[
								-81.5176767609999,
								30.559284255000083
							],
							[
								-81.51761818999995,
								30.559326723000083
							],
							[
								-81.51755639499993,
								30.559364345000063
							],
							[
								-81.51749177499994,
								30.559396879000072
							],
							[
								-81.51742474999992,
								30.559424113000034
							],
							[
								-81.5173557519999,
								30.559445871000033
							],
							[
								-81.51609675299994,
								30.559787871000083
							],
							[
								-81.51601716599993,
								30.559805659000066
							],
							[
								-81.51590391899992,
								30.55981829700005
							],
							[
								-81.51471091899994,
								30.55987529700008
							],
							[
								-81.51464424799991,
								30.559876008000064
							],
							[
								-81.51457770799993,
								30.559871778000062
							],
							[
								-81.51451166399994,
								30.559862629000065
							],
							[
								-81.5144464789999,
								30.559848613000046
							],
							[
								-81.51438251099995,
								30.55982980500005
							],
							[
								-81.51298451199996,
								30.559361805000037
							],
							[
								-81.5129139579999,
								30.559334842000055
							],
							[
								-81.51284591599995,
								30.559302053000064
							],
							[
								-81.51278086599991,
								30.559263670000064
							],
							[
								-81.51271926499993,
								30.55921996500007
							],
							[
								-81.51266154899992,
								30.55917124400008
							],
							[
								-81.51119654899992,
								30.55782524400007
							],
							[
								-81.51112293199992,
								30.557749142000038
							],
							[
								-81.5103048279999,
								30.556797151000065
							],
							[
								-81.50951647999995,
								30.55595751100009
							],
							[
								-81.50802258099992,
								30.55463227700005
							],
							[
								-81.50680374899991,
								30.554017271000077
							],
							[
								-81.50602702599991,
								30.553831706000043
							],
							[
								-81.50596089499993,
								30.553813211000094
							],
							[
								-81.50316447999997,
								30.552914710000042
							],
							[
								-81.50215777499994,
								30.552801859000056
							],
							[
								-81.50047587599994,
								30.552719239000055
							],
							[
								-81.50040257899991,
								30.55271262400004
							],
							[
								-81.50033006899992,
								30.552700037000076
							],
							[
								-81.50025883099994,
								30.552681565000054
							],
							[
								-81.50018934199994,
								30.552657329000056
							],
							[
								-81.50012206699995,
								30.552627492000056
							],
							[
								-81.49943906699991,
								30.552290492000054
							],
							[
								-81.49938733899995,
								30.552262836000065
							],
							[
								-81.49928128199991,
								30.552191077000092
							],
							[
								-81.4970342819999,
								30.550425077000053
							],
							[
								-81.49693329599995,
								30.55033242700006
							],
							[
								-81.49409929599994,
								30.547303427000088
							],
							[
								-81.49404240399991,
								30.54723632100007
							]
						],
						[
							[
								-81.45662516399995,
								30.46326166100005
							],
							[
								-81.4566126759999,
								30.463234880000076
							],
							[
								-81.4564209269999,
								30.46346926800004
							],
							[
								-81.4560035149999,
								30.464863014000056
							],
							[
								-81.4559796769999,
								30.464932225000037
							],
							[
								-81.45595028999992,
								30.464999268000042
							],
							[
								-81.4559155469999,
								30.46506369900004
							],
							[
								-81.45587567899992,
								30.465125091000065
							],
							[
								-81.45583094999995,
								30.46518303700009
							],
							[
								-81.45578165699993,
								30.465237154000082
							],
							[
								-81.45572812599994,
								30.465287082000092
							],
							[
								-81.45546109999992,
								30.465516502000074
							],
							[
								-81.45538060299992,
								30.46557323100006
							],
							[
								-81.45545483399991,
								30.465553340000042
							],
							[
								-81.45559444999992,
								30.46553983000007
							],
							[
								-81.45574090199995,
								30.465537134000044
							],
							[
								-81.45896337599993,
								30.465359049000085
							],
							[
								-81.45901299999991,
								30.46535767800009
							],
							[
								-81.45916916599992,
								30.46537134100004
							],
							[
								-81.45932058599993,
								30.465411914000075
							],
							[
								-81.45943487199992,
								30.46546276900005
							],
							[
								-81.46014607699993,
								30.465840539000055
							],
							[
								-81.45912781599992,
								30.464538381000068
							],
							[
								-81.4590195429999,
								30.46445645400007
							],
							[
								-81.45712309299995,
								30.463708625000038
							],
							[
								-81.45705409999994,
								30.463678019000046
							],
							[
								-81.45698791799992,
								30.463641733000088
							],
							[
								-81.45692501299993,
								30.463600022000037
							],
							[
								-81.45686582899992,
								30.463553181000066
							],
							[
								-81.45681078299992,
								30.46350154100008
							],
							[
								-81.45676026399991,
								30.463445464000078
							],
							[
								-81.45670744799992,
								30.463380855000082
							],
							[
								-81.45662516399995,
								30.46326166100005
							]
						],
						[
							[
								-81.45878121599992,
								30.46125223000007
							],
							[
								-81.45867077999992,
								30.459043518000048
							],
							[
								-81.45807176899991,
								30.459230567000077
							],
							[
								-81.45665202799995,
								30.460275335000066
							],
							[
								-81.45659338399992,
								30.460315028000082
							],
							[
								-81.45653179899995,
								30.46034998500005
							],
							[
								-81.45646765399994,
								30.46037998700007
							],
							[
								-81.45640134799993,
								30.460404850000092
							],
							[
								-81.45633329099992,
								30.46042441800006
							],
							[
								-81.4562639049999,
								30.460438571000054
							],
							[
								-81.4561936209999,
								30.46044722100004
							],
							[
								-81.45614331799993,
								30.460451409000086
							],
							[
								-81.45620845899994,
								30.46049067900009
							],
							[
								-81.45626990499994,
								30.46053551000006
							],
							[
								-81.45632718299993,
								30.460585556000073
							],
							[
								-81.45637985299993,
								30.460640432000048
							],
							[
								-81.45698085399994,
								30.46132043200004
							],
							[
								-81.45701845999992,
								30.461365904000047
							],
							[
								-81.4570934589999,
								30.461462904000086
							],
							[
								-81.45713675399992,
								30.46152089400005
							],
							[
								-81.45717424499992,
								30.461582795000083
							],
							[
								-81.45720558199992,
								30.46164802700008
							],
							[
								-81.45723047299992,
								30.46171598100005
							],
							[
								-81.45724868499991,
								30.46178602100008
							],
							[
								-81.45878121599992,
								30.46125223000007
							]
						],
						[
							[
								-81.4542349699999,
								30.461291333000077
							],
							[
								-81.45510738199994,
								30.460564197000057
							],
							[
								-81.45445065399991,
								30.460856765000074
							],
							[
								-81.4542349699999,
								30.461291333000077
							]
						]
					],
					[
						[
							[
								-81.49096199999993,
								30.55462300000005
							],
							[
								-81.49052999999992,
								30.551150000000064
							],
							[
								-81.49030171999993,
								30.550386596000067
							],
							[
								-81.49033460599992,
								30.550299452000043
							],
							[
								-81.49035800599995,
								30.55024328100006
							],
							[
								-81.49151800599992,
								30.547704281000055
							],
							[
								-81.49154902099991,
								30.54764274900009
							],
							[
								-81.49158465499994,
								30.547583773000042
							],
							[
								-81.49162470099992,
								30.547527698000064
							],
							[
								-81.49166892199992,
								30.54747485300004
							],
							[
								-81.49171705899994,
								30.547425550000067
							],
							[
								-81.4920480589999,
								30.547111550000068
							],
							[
								-81.49208892699994,
								30.547075080000074
							],
							[
								-81.49221733899992,
								30.546985164000038
							],
							[
								-81.4923594139999,
								30.54691891400006
							],
							[
								-81.4925108349999,
								30.546878341000085
							],
							[
								-81.49266699999993,
								30.546864678000077
							],
							[
								-81.49282316599994,
								30.546878341000085
							],
							[
								-81.49297458599995,
								30.54691891400006
							],
							[
								-81.49311666099993,
								30.546985164000038
							],
							[
								-81.49318475399991,
								30.54702867000009
							],
							[
								-81.49354975399991,
								30.54728567000006
							],
							[
								-81.49360959299992,
								30.54733167800003
							],
							[
								-81.49366536399992,
								30.547382541000047
							],
							[
								-81.49371667299994,
								30.54743790300006
							],
							[
								-81.49376315899991,
								30.547497372000063
							],
							[
								-81.4938044939999,
								30.54756053000005
							],
							[
								-81.49384038699992,
								30.54762693100008
							],
							[
								-81.49387058499991,
								30.54769610900007
							],
							[
								-81.49413883599993,
								30.54838876200006
							],
							[
								-81.49416120099994,
								30.548456242000043
							],
							[
								-81.4941781629999,
								30.548525278000056
							],
							[
								-81.49418961599991,
								30.54859544000004
							],
							[
								-81.4941954869999,
								30.548666287000064
							],
							[
								-81.49419573999995,
								30.548737376000073
							],
							[
								-81.49419037399991,
								30.54880826300007
							],
							[
								-81.49414423999991,
								30.54920738900006
							],
							[
								-81.49443632899994,
								30.550283466000053
							],
							[
								-81.49489642099991,
								30.551146444000043
							],
							[
								-81.4955171119999,
								30.551813920000086
							],
							[
								-81.49696746599994,
								30.55262980100008
							],
							[
								-81.49952111099994,
								30.553661153000068
							],
							[
								-81.50049140499993,
								30.55385831100006
							],
							[
								-81.50130604399993,
								30.553882072000082
							],
							[
								-81.5021717059999,
								30.553775762000043
							],
							[
								-81.50346906599992,
								30.55363213600009
							],
							[
								-81.50356799999992,
								30.553626678000057
							],
							[
								-81.5036825059999,
								30.553633997000077
							],
							[
								-81.50524050599995,
								30.553833998000076
							],
							[
								-81.50531199199992,
								30.553846117000038
							],
							[
								-81.50538226799995,
								30.55386396000006
							],
							[
								-81.50545087699993,
								30.553887411000062
							],
							[
								-81.50551737299992,
								30.55391631600008
							],
							[
								-81.50558132099991,
								30.55395048800005
							],
							[
								-81.50644798199994,
								30.554467811000052
							],
							[
								-81.50650338999993,
								30.55450371100005
							],
							[
								-81.50739738999994,
								30.55513071100006
							],
							[
								-81.50745907299995,
								30.555178079000086
							],
							[
								-81.5075625099999,
								30.55528020800006
							],
							[
								-81.50832450999991,
								30.556165208000042
							],
							[
								-81.50839676499993,
								30.55626147200007
							],
							[
								-81.50886076499995,
								30.556974472000036
							],
							[
								-81.50890058999994,
								30.55704192300004
							],
							[
								-81.50893439499993,
								30.55711258300005
							],
							[
								-81.50896192199991,
								30.557185917000087
							],
							[
								-81.50898296399993,
								30.557261368000074
							],
							[
								-81.5092149649999,
								30.558259368000048
							],
							[
								-81.50922944799993,
								30.558336974000042
							],
							[
								-81.50923706999993,
								30.558415552000042
							],
							[
								-81.5092377709999,
								30.55849449500005
							],
							[
								-81.50923154599991,
								30.55857319500006
							],
							[
								-81.50921844299995,
								30.558651047000073
							],
							[
								-81.50898983099995,
								30.559720197000047
							],
							[
								-81.50886199099995,
								30.56044488200007
							],
							[
								-81.5089349189999,
								30.560708038000087
							],
							[
								-81.50923569199995,
								30.561157080000044
							],
							[
								-81.51032474199991,
								30.561790784000035
							],
							[
								-81.51117645799991,
								30.562132670000043
							],
							[
								-81.5123813319999,
								30.562360523000052
							],
							[
								-81.51314039399995,
								30.562386192000076
							],
							[
								-81.51326616599994,
								30.56239934000007
							],
							[
								-81.51331723099992,
								30.562409879000086
							],
							[
								-81.51464300799995,
								30.562723827000074
							],
							[
								-81.51500678499991,
								30.562809775000062
							],
							[
								-81.51510758599994,
								30.56283991400005
							],
							[
								-81.51524966099993,
								30.562906165000076
							],
							[
								-81.51537807299991,
								30.56299608000006
							],
							[
								-81.51548891999995,
								30.56310692700003
							],
							[
								-81.51552703699991,
								30.563155664000078
							],
							[
								-81.51569303699995,
								30.563383664000067
							],
							[
								-81.51573479799993,
								30.56344638400009
							],
							[
								-81.51577116099992,
								30.563512381000066
							],
							[
								-81.51580187199994,
								30.56358119000004
							],
							[
								-81.51582671499996,
								30.563652328000046
							],
							[
								-81.5158455159999,
								30.563725296000086
							],
							[
								-81.5158581419999,
								30.563799582000062
							],
							[
								-81.51586450499991,
								30.563874664000082
							],
							[
								-81.51588050499994,
								30.564249664000045
							],
							[
								-81.5158808889999,
								30.564315890000046
							],
							[
								-81.51587639999991,
								30.564381964000066
							],
							[
								-81.51586705999995,
								30.56444752900006
							],
							[
								-81.51585291999993,
								30.564512228000073
							],
							[
								-81.51578391999993,
								30.564780228000075
							],
							[
								-81.5157630359999,
								30.56484963300005
							],
							[
								-81.51573662999994,
								30.56491713000008
							],
							[
								-81.51570487399994,
								30.564982282000077
							],
							[
								-81.51566797499993,
								30.565044665000077
							],
							[
								-81.51528997399993,
								30.565628665000077
							],
							[
								-81.51522392099992,
								30.565718073000088
							],
							[
								-81.51513199599992,
								30.565812589000075
							],
							[
								-81.5147925469999,
								30.566113887000085
							],
							[
								-81.51457594499993,
								30.56631501700008
							],
							[
								-81.51454207299992,
								30.566344921000056
							],
							[
								-81.51442467299995,
								30.566428373000065
							],
							[
								-81.51374516699991,
								30.566833604000067
							],
							[
								-81.51359758599996,
								30.56690308600008
							],
							[
								-81.51353558999995,
								30.56692313900004
							],
							[
								-81.51338058999994,
								30.56696713900004
							],
							[
								-81.51329116599993,
								30.56698765900006
							],
							[
								-81.51313499999992,
								30.567001322000067
							],
							[
								-81.51282399999991,
								30.567001322000067
							],
							[
								-81.51278493699994,
								30.567000473000064
							],
							[
								-81.51253126199992,
								30.566989444000054
							],
							[
								-81.51205017699994,
								30.56687667700004
							],
							[
								-81.51202441099993,
								30.566862949000043
							],
							[
								-81.51198967399995,
								30.566842343000076
							],
							[
								-81.50407455899995,
								30.564857758000073
							],
							[
								-81.50401274599994,
								30.564842018000036
							],
							[
								-81.50393079399993,
								30.56481855800007
							],
							[
								-81.50177675499992,
								30.56407668700007
							],
							[
								-81.50164015599995,
								30.56401509700004
							],
							[
								-81.49775651099992,
								30.561856910000078
							],
							[
								-81.4952995079999,
								30.559241013000076
							],
							[
								-81.49495399999995,
								30.55897800000008
							],
							[
								-81.49329699999993,
								30.557152000000087
							],
							[
								-81.49316741199993,
								30.55697103500006
							],
							[
								-81.49096199999993,
								30.55462300000005
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Black Hammock Island",
				"RegionID": "268897"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.24246999999991,
					26.00956800000006,
					-80.2127458619999,
					26.024825370000087
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.21312657599992,
							26.024825370000087
						],
						[
							-80.2127458619999,
							26.014070206000042
						],
						[
							-80.2127458619999,
							26.01226181600009
						],
						[
							-80.21336899999994,
							26.00986800000004
						],
						[
							-80.2137689999999,
							26.01016800000008
						],
						[
							-80.21446899999997,
							26.010068000000047
						],
						[
							-80.21586999999994,
							26.00996800000007
						],
						[
							-80.2171699999999,
							26.00986800000004
						],
						[
							-80.21956999999992,
							26.00986800000004
						],
						[
							-80.22026999999991,
							26.009768000000065
						],
						[
							-80.2214699999999,
							26.00966800000009
						],
						[
							-80.2223699999999,
							26.00966800000009
						],
						[
							-80.22336999999993,
							26.00966800000009
						],
						[
							-80.22426999999993,
							26.00966800000009
						],
						[
							-80.22786999999994,
							26.00956800000006
						],
						[
							-80.2293699999999,
							26.00966800000009
						],
						[
							-80.22947099999993,
							26.00966800000009
						],
						[
							-80.23166999999997,
							26.00966800000009
						],
						[
							-80.23169499999995,
							26.009768000000065
						],
						[
							-80.23176999999993,
							26.010068000000047
						],
						[
							-80.2318699999999,
							26.010668000000067
						],
						[
							-80.2318699999999,
							26.01136800000006
						],
						[
							-80.2327699999999,
							26.01136800000006
						],
						[
							-80.23376999999994,
							26.011268000000086
						],
						[
							-80.23466999999994,
							26.01136800000006
						],
						[
							-80.23516999999993,
							26.011268000000086
						],
						[
							-80.23586999999992,
							26.011268000000086
						],
						[
							-80.23786999999993,
							26.011268000000086
						],
						[
							-80.23986999999994,
							26.01106800000008
						],
						[
							-80.23986999999994,
							26.011568000000068
						],
						[
							-80.23986999999994,
							26.01186800000005
						],
						[
							-80.23986999999994,
							26.012268000000063
						],
						[
							-80.23996999999991,
							26.012968000000058
						],
						[
							-80.23996999999991,
							26.013668000000052
						],
						[
							-80.23996999999991,
							26.01446800000008
						],
						[
							-80.24006999999995,
							26.015168000000074
						],
						[
							-80.24006999999995,
							26.01586800000007
						],
						[
							-80.24006999999995,
							26.016568000000067
						],
						[
							-80.2411699999999,
							26.016568000000067
						],
						[
							-80.24119399999995,
							26.01656600000007
						],
						[
							-80.24246999999991,
							26.01646800000009
						],
						[
							-80.24246999999991,
							26.01736800000009
						],
						[
							-80.24126999999993,
							26.017468000000065
						],
						[
							-80.24126999999993,
							26.01816800000006
						],
						[
							-80.2413699999999,
							26.018868000000055
						],
						[
							-80.2413699999999,
							26.019568000000053
						],
						[
							-80.2413699999999,
							26.02016800000007
						],
						[
							-80.24016999999992,
							26.020268000000044
						],
						[
							-80.24016999999992,
							26.02096800000004
						],
						[
							-80.24026999999995,
							26.02166800000009
						],
						[
							-80.24016999999992,
							26.02246800000006
						],
						[
							-80.24026999999995,
							26.02326700000009
						],
						[
							-80.24026999999995,
							26.023967000000084
						],
						[
							-80.24017499999991,
							26.023970000000077
						],
						[
							-80.23676999999992,
							26.02406700000006
						],
						[
							-80.2361699999999,
							26.02406700000006
						],
						[
							-80.23516999999993,
							26.02406700000006
						],
						[
							-80.23426999999992,
							26.02406700000006
						],
						[
							-80.23300299999994,
							26.02406700000006
						],
						[
							-80.23236999999995,
							26.02406700000006
						],
						[
							-80.2316863719999,
							26.024301888000082
						],
						[
							-80.22397691799995,
							26.02449224500009
						],
						[
							-80.22069326199994,
							26.02463501300008
						],
						[
							-80.21312657599992,
							26.024825370000087
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Hollywood",
				"Name": "Boulevard Heights",
				"RegionID": "268899"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.55858914099991,
					30.40465867800009,
					-81.50277203999991,
					30.44129404800009
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.53607889599994,
							30.44129404800009
						],
						[
							-81.53565990999994,
							30.44125601300004
						],
						[
							-81.53546890899992,
							30.44123101200006
						],
						[
							-81.53538690999994,
							30.441213012000052
						],
						[
							-81.53511790899995,
							30.441154012000084
						],
						[
							-81.53487390999993,
							30.441088012000076
						],
						[
							-81.53435490999993,
							30.44088901300006
						],
						[
							-81.53357690899992,
							30.44053801300004
						],
						[
							-81.53338590899995,
							30.440462013000054
						],
						[
							-81.5330889089999,
							30.440329013000053
						],
						[
							-81.53266890999993,
							30.440128013000052
						],
						[
							-81.53228790899993,
							30.439964012000072
						],
						[
							-81.53195190999992,
							30.439802012000087
						],
						[
							-81.53148690899991,
							30.439598013000083
						],
						[
							-81.53104390899995,
							30.439390013000036
						],
						[
							-81.53045690999994,
							30.439144012000042
						],
						[
							-81.53008290999992,
							30.438959012000055
						],
						[
							-81.52773290999994,
							30.43792201300005
						],
						[
							-81.5273209099999,
							30.437712012000073
						],
						[
							-81.5260159099999,
							30.43685701200008
						],
						[
							-81.52476490999994,
							30.43614201200006
						],
						[
							-81.52452090999992,
							30.436012013000038
						],
						[
							-81.52422291099992,
							30.435823012000075
						],
						[
							-81.5240549099999,
							30.43568601200008
						],
						[
							-81.52391790999991,
							30.435549011000035
						],
						[
							-81.52377291099992,
							30.435360011000057
						],
						[
							-81.52368891099991,
							30.435209013000073
						],
						[
							-81.52355190899993,
							30.434788012000073
						],
						[
							-81.5234509089999,
							30.43442801300006
						],
						[
							-81.52315490899991,
							30.433369013000064
						],
						[
							-81.52299490999991,
							30.433006013000064
						],
						[
							-81.52292590899992,
							30.43286301200004
						],
						[
							-81.52283490999991,
							30.43271401300007
						],
						[
							-81.52270490999992,
							30.432539014000042
						],
						[
							-81.5225979089999,
							30.43240901300004
						],
						[
							-81.52239191099994,
							30.432194013000075
						],
						[
							-81.52221690899995,
							30.43203701300007
						],
						[
							-81.5220109089999,
							30.431881013000062
						],
						[
							-81.52176690999994,
							30.431723013000067
						],
						[
							-81.52159090899994,
							30.431625013000087
						],
						[
							-81.52136990999992,
							30.431520013000068
						],
						[
							-81.52120990999993,
							30.43145601200007
						],
						[
							-81.52088890999994,
							30.43134301200007
						],
						[
							-81.5192409089999,
							30.43080101300006
						],
						[
							-81.51856990999994,
							30.43060501300005
						],
						[
							-81.51814290999994,
							30.430500013000085
						],
						[
							-81.51805090999994,
							30.43048501200008
						],
						[
							-81.51794390999993,
							30.43047901300008
						],
						[
							-81.51788290699996,
							30.430485014000055
						],
						[
							-81.51747090899995,
							30.430611013000092
						],
						[
							-81.51733390999993,
							30.430643013000065
						],
						[
							-81.51708990899994,
							30.430679012000038
						],
						[
							-81.5169659099999,
							30.43068601300007
						],
						[
							-81.51684590999993,
							30.430693011000077
						],
						[
							-81.51663190999994,
							30.430672012000063
						],
						[
							-81.51579291099995,
							30.430542013000036
						],
						[
							-81.51570091199994,
							30.430546013000082
						],
						[
							-81.5155939089999,
							30.430571013000073
						],
						[
							-81.51399188399996,
							30.43111792500008
						],
						[
							-81.51376290899992,
							30.431173013000038
						],
						[
							-81.51357290899995,
							30.43120401200008
						],
						[
							-81.51336691599994,
							30.43122710200004
						],
						[
							-81.5131379099999,
							30.43123101300006
						],
						[
							-81.51296990199995,
							30.43122310200005
						],
						[
							-81.51184090999993,
							30.43106301200004
						],
						[
							-81.5114749089999,
							30.430981012000075
						],
						[
							-81.51111590799992,
							30.430876010000077
						],
						[
							-81.51106990999995,
							30.430851012000062
						],
						[
							-81.51097090999991,
							30.430777012000075
						],
						[
							-81.51038390899993,
							30.430269013000043
						],
						[
							-81.51020790899992,
							30.430162013000086
						],
						[
							-81.51007090899992,
							30.43010301300006
						],
						[
							-81.50917790999995,
							30.42978501300007
						],
						[
							-81.50903290999992,
							30.429726013000046
						],
						[
							-81.50880390899994,
							30.42960901300006
						],
						[
							-81.50863590999995,
							30.42950601200005
						],
						[
							-81.5084759099999,
							30.429390012000056
						],
						[
							-81.50700390999992,
							30.428202012000042
						],
						[
							-81.50689691899993,
							30.428093020000066
						],
						[
							-81.50685091399993,
							30.427996016000066
						],
						[
							-81.50684390999993,
							30.427938012000084
						],
						[
							-81.50685090799993,
							30.427605013000065
						],
						[
							-81.50684407099993,
							30.42755892000008
						],
						[
							-81.50677492799991,
							30.42750196200007
						],
						[
							-81.50672090899991,
							30.42748101300009
						],
						[
							-81.50650790999993,
							30.42744101200009
						],
						[
							-81.50570691099995,
							30.427320013000045
						],
						[
							-81.50556188999991,
							30.42732592900006
						],
						[
							-81.50547790899992,
							30.427366015000075
						],
						[
							-81.50498190999991,
							30.427792012000054
						],
						[
							-81.50469190799993,
							30.42806201100007
						],
						[
							-81.50465391099993,
							30.428083016000073
						],
						[
							-81.50380690899993,
							30.429003012000067
						],
						[
							-81.50370084899993,
							30.42910914500004
						],
						[
							-81.50411208299994,
							30.421938933000035
						],
						[
							-81.50351199999994,
							30.421439000000078
						],
						[
							-81.50277203999991,
							30.42082253500007
						],
						[
							-81.50280033599995,
							30.42075906100007
						],
						[
							-81.50448901199991,
							30.417590186000044
						],
						[
							-81.50466305099991,
							30.414444323000055
						],
						[
							-81.50466978899993,
							30.41437349100005
						],
						[
							-81.50468210499992,
							30.414303414000077
						],
						[
							-81.50469992199993,
							30.414234529000055
						],
						[
							-81.50472312999995,
							30.414167269000075
						],
						[
							-81.50475158199993,
							30.41410205300008
						],
						[
							-81.50478509999995,
							30.41403929200004
						],
						[
							-81.5048234759999,
							30.41397937600004
						],
						[
							-81.50546197599995,
							30.413064321000032
						],
						[
							-81.50621360499991,
							30.411791686000072
						],
						[
							-81.5062223409999,
							30.411691834000067
						],
						[
							-81.50625463499995,
							30.411564189000046
						],
						[
							-81.50742863499994,
							30.40803418900003
						],
						[
							-81.50743691299994,
							30.408010413000056
						],
						[
							-81.50750466499994,
							30.407865758000067
						],
						[
							-81.5088181669999,
							30.405625177000044
						],
						[
							-81.50890507899993,
							30.405501927000046
						],
						[
							-81.50895503099993,
							30.405447150000043
						],
						[
							-81.50947203099992,
							30.404925151000047
						],
						[
							-81.50953292699995,
							30.40486908000008
						],
						[
							-81.50966133899993,
							30.40477916400005
						],
						[
							-81.50980341399992,
							30.404712914000076
						],
						[
							-81.50995483499992,
							30.40467234100004
						],
						[
							-81.51011099999994,
							30.40465867800009
						],
						[
							-81.51026716599995,
							30.40467234100004
						],
						[
							-81.51041858699995,
							30.404712914000076
						],
						[
							-81.51055430199995,
							30.404775527000087
						],
						[
							-81.51995338299992,
							30.410100475000032
						],
						[
							-81.52980635199992,
							30.41538962600004
						],
						[
							-81.52987367999994,
							30.415429639000084
						],
						[
							-81.52993727099994,
							30.41547535800004
						],
						[
							-81.52999664399994,
							30.415526437000043
						],
						[
							-81.53005134699993,
							30.41558248700005
						],
						[
							-81.53010096499992,
							30.415643084000067
						],
						[
							-81.53014512399994,
							30.41570776900005
						],
						[
							-81.53076512399991,
							30.41670676900009
						],
						[
							-81.53080818799992,
							30.416784480000047
						],
						[
							-81.53129896299993,
							30.41778354300004
						],
						[
							-81.53129567799994,
							30.41774600000008
						],
						[
							-81.53130934099994,
							30.41758983400007
						],
						[
							-81.53134991399993,
							30.417438414000063
						],
						[
							-81.53141616499994,
							30.417296339000075
						],
						[
							-81.53150607999993,
							30.417167927000037
						],
						[
							-81.5316169269999,
							30.417057079000074
						],
						[
							-81.53174533899994,
							30.416967164000088
						],
						[
							-81.5318820729999,
							30.416904096000057
						],
						[
							-81.53246172899992,
							30.417653712000064
						],
						[
							-81.53307337699994,
							30.417750563000084
						],
						[
							-81.53626282699992,
							30.41775056400007
						],
						[
							-81.53844510199991,
							30.417750695000052
						],
						[
							-81.54213815999992,
							30.416239586000074
						],
						[
							-81.54532765499995,
							30.419429150000045
						],
						[
							-81.54667043899991,
							30.421611536000057
						],
						[
							-81.54902060899991,
							30.42312232100005
						],
						[
							-81.55170651599991,
							30.423793607000054
						],
						[
							-81.55388886199995,
							30.42530441800005
						],
						[
							-81.5547280479999,
							30.427486774000048
						],
						[
							-81.55573524099992,
							30.429501162000065
						],
						[
							-81.55640663799994,
							30.432019217000065
						],
						[
							-81.55691030899993,
							30.433697807000044
						],
						[
							-81.55858914099991,
							30.436047874000053
						],
						[
							-81.55811296799993,
							30.441168014000084
						],
						[
							-81.55632790899996,
							30.44117501200009
						],
						[
							-81.55076590899995,
							30.441223012000084
						],
						[
							-81.55026190899991,
							30.441212012000054
						],
						[
							-81.54899590999992,
							30.441212013000037
						],
						[
							-81.54861490899992,
							30.44124201200009
						],
						[
							-81.54800390999992,
							30.44125401200006
						],
						[
							-81.54785190899992,
							30.441248012000074
						],
						[
							-81.54701190999992,
							30.44125901200005
						],
						[
							-81.54448690899994,
							30.441248012000074
						],
						[
							-81.54369390999994,
							30.441267012000086
						],
						[
							-81.54316690999991,
							30.441292012000076
						],
						[
							-81.54279290999995,
							30.44128401200004
						],
						[
							-81.54255690999992,
							30.441257013000037
						],
						[
							-81.54112990899995,
							30.441275013000052
						],
						[
							-81.5366439089999,
							30.441278013000044
						],
						[
							-81.53607889599994,
							30.44129404800009
						]
					],
					[
						[
							-81.5383868529999,
							30.426407665000056
						],
						[
							-81.53780555599991,
							30.425979270000084
						],
						[
							-81.53775378499995,
							30.42627948400008
						],
						[
							-81.53771208599996,
							30.42643758600008
						],
						[
							-81.53764583499992,
							30.426579661000062
						],
						[
							-81.53755591999993,
							30.426708073000043
						],
						[
							-81.5374450729999,
							30.426818920000077
						],
						[
							-81.53731666099992,
							30.426908835000063
						],
						[
							-81.53717458599994,
							30.426975086000088
						],
						[
							-81.53704337199991,
							30.427011857000082
						],
						[
							-81.53693413899992,
							30.427033704000056
						],
						[
							-81.53611146599991,
							30.427941205000078
						],
						[
							-81.53662362599994,
							30.42813039500004
						],
						[
							-81.53675431599993,
							30.42819097000006
						],
						[
							-81.53765198899993,
							30.428698067000084
						],
						[
							-81.5377840729999,
							30.428790080000056
						],
						[
							-81.53789492099992,
							30.42890092700009
						],
						[
							-81.53798483599992,
							30.429029339000067
						],
						[
							-81.53805108599994,
							30.42917141400005
						],
						[
							-81.53808453399995,
							30.429286757000057
						],
						[
							-81.53817753399994,
							30.429711756000074
						],
						[
							-81.53818465899991,
							30.429747834000068
						],
						[
							-81.5381958239999,
							30.42987545000005
						],
						[
							-81.53852983899992,
							30.429669902000057
						],
						[
							-81.53988275299992,
							30.42834525200004
						],
						[
							-81.5398409039999,
							30.42821198500008
						],
						[
							-81.53982409999992,
							30.428201837000078
						],
						[
							-81.53971092699993,
							30.428120921000076
						],
						[
							-81.53959658999992,
							30.42800586300007
						],
						[
							-81.53946360899994,
							30.427843464000034
						],
						[
							-81.53922590799993,
							30.427823012000086
						],
						[
							-81.53914683399995,
							30.427812660000086
						],
						[
							-81.53899541299995,
							30.42777208700005
						],
						[
							-81.5388533389999,
							30.42770583600009
						],
						[
							-81.53872492699992,
							30.427615921000037
						],
						[
							-81.5386140789999,
							30.427505073000077
						],
						[
							-81.53852416399991,
							30.42737666100004
						],
						[
							-81.53845791299995,
							30.427234587000044
						],
						[
							-81.53841733999991,
							30.427083166000045
						],
						[
							-81.5384041239999,
							30.426955347000046
						],
						[
							-81.5383868529999,
							30.426407665000056
						]
					],
					[
						[
							-81.51625893599993,
							30.424189648000038
						],
						[
							-81.51636109099991,
							30.424123055000056
						],
						[
							-81.51802608999992,
							30.42319205500007
						],
						[
							-81.51815741299993,
							30.42313191400007
						],
						[
							-81.51830883399992,
							30.42309134100009
						],
						[
							-81.51846499999994,
							30.423077678000084
						],
						[
							-81.5186211649999,
							30.42309134100009
						],
						[
							-81.5187725859999,
							30.42313191400007
						],
						[
							-81.51891466099994,
							30.423198165000088
						],
						[
							-81.5189995799999,
							30.423253810000062
						],
						[
							-81.51953655599995,
							30.42365074100007
						],
						[
							-81.52003191799992,
							30.423821462000035
						],
						[
							-81.52053441899994,
							30.422712080000053
						],
						[
							-81.5205761599999,
							30.42251482200004
						],
						[
							-81.5205962039999,
							30.422437312000056
						],
						[
							-81.52062306199991,
							30.422361892000083
						],
						[
							-81.52065651999993,
							30.42228916000005
						],
						[
							-81.5206963139999,
							30.422219691000063
						],
						[
							-81.52088131499994,
							30.421927691000068
						],
						[
							-81.52095340299991,
							30.42182935400007
						],
						[
							-81.52120040199992,
							30.42153635400007
						],
						[
							-81.52130992699995,
							30.421427079000072
						],
						[
							-81.52138644899992,
							30.421373498000037
						],
						[
							-81.52125092099993,
							30.421238750000043
						],
						[
							-81.52119607899994,
							30.421179073000076
						],
						[
							-81.52110616399995,
							30.421050661000038
						],
						[
							-81.52103991399993,
							30.42090858600005
						],
						[
							-81.52099934099994,
							30.420757166000044
						],
						[
							-81.52098567799993,
							30.42060100000009
						],
						[
							-81.52099934099994,
							30.42044483500007
						],
						[
							-81.52103991399993,
							30.42029341400007
						],
						[
							-81.52110616399995,
							30.420151339000085
						],
						[
							-81.52119607899994,
							30.420022927000048
						],
						[
							-81.5213069269999,
							30.419912080000078
						],
						[
							-81.52136985099992,
							30.419863842000044
						],
						[
							-81.5217118519999,
							30.41962484200008
						],
						[
							-81.52177189199995,
							30.41958592400005
						],
						[
							-81.52183498099993,
							30.419552175000035
						],
						[
							-81.5219006769999,
							30.41952383100005
						],
						[
							-81.52196851699995,
							30.41950109200008
						],
						[
							-81.52203802299994,
							30.41948411800007
						],
						[
							-81.5221087079999,
							30.41947302700004
						],
						[
							-81.52170356499994,
							30.419223874000068
						],
						[
							-81.52124240599994,
							30.41912879700004
						],
						[
							-81.5211268729999,
							30.419096820000053
						],
						[
							-81.5194373139999,
							30.41850539400008
						],
						[
							-81.51872204499995,
							30.418946477000077
						],
						[
							-81.51865535799993,
							30.41898378600007
						],
						[
							-81.51858574499994,
							30.419015300000073
						],
						[
							-81.5185137069999,
							30.419040790000057
						],
						[
							-81.51843976599991,
							30.41906007300008
						],
						[
							-81.51615373699991,
							30.419553559000065
						],
						[
							-81.51564278199993,
							30.419736783000072
						],
						[
							-81.51559035699997,
							30.41978520300006
						],
						[
							-81.5153504459999,
							30.42187363600004
						],
						[
							-81.51534265899994,
							30.421927166000046
						],
						[
							-81.5153020859999,
							30.422078586000058
						],
						[
							-81.51523583599993,
							30.42222066100004
						],
						[
							-81.51514592099994,
							30.422349073000078
						],
						[
							-81.51503507299992,
							30.422459921000037
						],
						[
							-81.51490666099994,
							30.42254983600009
						],
						[
							-81.5147616289999,
							30.422616932000043
						],
						[
							-81.5147883379999,
							30.422688838000056
						],
						[
							-81.51480885399991,
							30.42276275000006
						],
						[
							-81.5148230289999,
							30.422838135000067
						],
						[
							-81.5148307629999,
							30.422914450000064
						],
						[
							-81.51483199799992,
							30.422991146000072
						],
						[
							-81.51480845399993,
							30.423867747000084
						],
						[
							-81.51512506099994,
							30.424453211000067
						],
						[
							-81.51515878099991,
							30.424521439000046
						],
						[
							-81.51518633099994,
							30.42459238300006
						],
						[
							-81.51520749299995,
							30.424665487000084
						],
						[
							-81.51522210199994,
							30.42474017700005
						],
						[
							-81.51523004199993,
							30.424815867000063
						],
						[
							-81.51523125199992,
							30.42489196300005
						],
						[
							-81.51522572199991,
							30.424967867000078
						],
						[
							-81.51625893599993,
							30.424189648000038
						]
					],
					[
						[
							-81.5322580859999,
							30.420238586000043
						],
						[
							-81.53219183599992,
							30.420380661000078
						],
						[
							-81.53210192099993,
							30.420509073000066
						],
						[
							-81.53199107299992,
							30.420619921000085
						],
						[
							-81.53186266099993,
							30.42070983600007
						],
						[
							-81.53171938399993,
							30.42077652200004
						],
						[
							-81.5307091819999,
							30.42114095700003
						],
						[
							-81.53063511999994,
							30.421164116000057
						],
						[
							-81.5305593359999,
							30.421180805000063
						],
						[
							-81.5304823969999,
							30.421190898000074
						],
						[
							-81.53040487299995,
							30.421194321000087
						],
						[
							-81.5303273429999,
							30.42119104900007
						],
						[
							-81.52981786299995,
							30.421147463000064
						],
						[
							-81.52865942499994,
							30.42109126600008
						],
						[
							-81.5285873279999,
							30.421084858000086
						],
						[
							-81.52851597999995,
							30.421072669000072
						],
						[
							-81.52844584499991,
							30.421054777000055
						],
						[
							-81.5283773779999,
							30.421031300000042
						],
						[
							-81.52831102099992,
							30.42100238800009
						],
						[
							-81.52824720699994,
							30.42096823000008
						],
						[
							-81.52818251299993,
							30.420929568000076
						],
						[
							-81.52814497599991,
							30.420917494000037
						],
						[
							-81.52804166099992,
							30.420989836000047
						],
						[
							-81.52789372799992,
							30.421058173000066
						],
						[
							-81.52773286999991,
							30.421114259000035
						],
						[
							-81.52766427299991,
							30.42113513100009
						],
						[
							-81.52759423099991,
							30.42115047100009
						],
						[
							-81.52752318899991,
							30.42116018200005
						],
						[
							-81.52745159999995,
							30.421164204000032
						],
						[
							-81.52737991799995,
							30.421162509000055
						],
						[
							-81.52730859799993,
							30.42115510800005
						],
						[
							-81.52567259799991,
							30.420919108000078
						],
						[
							-81.52555281399992,
							30.42089339800009
						],
						[
							-81.52452896699992,
							30.420599373000073
						],
						[
							-81.52364112999993,
							30.42032918400008
						],
						[
							-81.52729966999993,
							30.423338252000065
						],
						[
							-81.52735903799993,
							30.423392213000056
						],
						[
							-81.52741335799993,
							30.423451252000064
						],
						[
							-81.52746219699992,
							30.423514900000043
						],
						[
							-81.52750516499992,
							30.423582650000068
						],
						[
							-81.52754192099991,
							30.42365396200006
						],
						[
							-81.52757217099992,
							30.423728267000058
						],
						[
							-81.52771874599995,
							30.42414884600004
						],
						[
							-81.52779168399991,
							30.424050893000068
						],
						[
							-81.52782407899991,
							30.424009927000043
						],
						[
							-81.52793492699993,
							30.42389907900008
						],
						[
							-81.52806333899993,
							30.423809164000094
						],
						[
							-81.52820541299992,
							30.42374291300007
						],
						[
							-81.52835683399991,
							30.42370234000009
						],
						[
							-81.52851299999992,
							30.423688678000076
						],
						[
							-81.53005399999995,
							30.423688678000076
						],
						[
							-81.53021016499991,
							30.42370234000009
						],
						[
							-81.53033529499993,
							30.423735869000044
						],
						[
							-81.53071318799994,
							30.42304191100004
						],
						[
							-81.53074050299995,
							30.42299515800005
						],
						[
							-81.53243650299993,
							30.420283158000075
						],
						[
							-81.5325100789999,
							30.420181927000048
						],
						[
							-81.53262092699993,
							30.42007108000007
						],
						[
							-81.53274933899992,
							30.41998116500008
						],
						[
							-81.53289141399995,
							30.419914914000056
						],
						[
							-81.5330428339999,
							30.41987434100008
						],
						[
							-81.53319899999991,
							30.419860678000077
						],
						[
							-81.53326042899994,
							30.419866053000078
						],
						[
							-81.53235063799991,
							30.41950923300004
						],
						[
							-81.53222933899991,
							30.419450836000067
						],
						[
							-81.53212804099991,
							30.419379906000074
						],
						[
							-81.53217050699993,
							30.41944626900005
						],
						[
							-81.53219183599992,
							30.419481339000075
						],
						[
							-81.5322580859999,
							30.419623414000057
						],
						[
							-81.53229865899993,
							30.41977483400007
						],
						[
							-81.53231232199994,
							30.419931000000073
						],
						[
							-81.53229865899993,
							30.420087166000087
						],
						[
							-81.5322580859999,
							30.420238586000043
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Brown Island",
				"RegionID": "268904"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.33101048899994,
					28.506075000000067,
					-81.31435965799994,
					28.51712000000009
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.31608914899994,
							28.517111707000083
						],
						[
							-81.3157166499999,
							28.517104000000078
						],
						[
							-81.31567599999994,
							28.517104000000078
						],
						[
							-81.31511499999993,
							28.517112000000054
						],
						[
							-81.3147019999999,
							28.517112000000054
						],
						[
							-81.31470130499991,
							28.517101679000064
						],
						[
							-81.31466029599994,
							28.51710309300006
						],
						[
							-81.31458773499992,
							28.51710559500009
						],
						[
							-81.31445999999994,
							28.51711000000006
						],
						[
							-81.31445705199991,
							28.517074629000035
						],
						[
							-81.31445334999995,
							28.517030205000083
						],
						[
							-81.31444964799994,
							28.516985781000074
						],
						[
							-81.31444525099994,
							28.516933007000034
						],
						[
							-81.31443999999995,
							28.516860590000082
						],
						[
							-81.31443999999995,
							28.516755654000065
						],
						[
							-81.31443999999995,
							28.516606322000086
						],
						[
							-81.31443999999995,
							28.51647313400008
						],
						[
							-81.31443999999995,
							28.516400000000093
						],
						[
							-81.31443959699993,
							28.516376250000064
						],
						[
							-81.31443720399994,
							28.516235031000065
						],
						[
							-81.31443474199996,
							28.516089777000047
						],
						[
							-81.31443200599995,
							28.515928383000073
						],
						[
							-81.31442970599994,
							28.515782985000044
						],
						[
							-81.31442904999994,
							28.515722573000062
						],
						[
							-81.31442865399993,
							28.515686133000088
						],
						[
							-81.31442751299994,
							28.51558120900006
						],
						[
							-81.31442531899995,
							28.51537938900009
						],
						[
							-81.31442290699994,
							28.515157436000038
						],
						[
							-81.31442106299994,
							28.514987812000072
						],
						[
							-81.31441919399992,
							28.51486663500009
						],
						[
							-81.31441609399991,
							28.51477672100009
						],
						[
							-81.31440999999995,
							28.514600000000087
						],
						[
							-81.31439999999992,
							28.514500000000055
						],
						[
							-81.31439999999992,
							28.51431314900009
						],
						[
							-81.31439999999992,
							28.51409815800008
						],
						[
							-81.31439999999992,
							28.513833554000087
						],
						[
							-81.31439999999992,
							28.51346972400006
						],
						[
							-81.31439999999992,
							28.513155507000082
						],
						[
							-81.31439999999992,
							28.512841289000054
						],
						[
							-81.31439999999992,
							28.51254361000008
						],
						[
							-81.31439999999992,
							28.51239477000007
						],
						[
							-81.31439999999992,
							28.511964789000046
						],
						[
							-81.31439525299994,
							28.511666577000085
						],
						[
							-81.31439144199993,
							28.511567497000044
						],
						[
							-81.31438636099995,
							28.511435390000088
						],
						[
							-81.31438000999992,
							28.51127025700004
						],
						[
							-81.31437236399995,
							28.511071462000075
						],
						[
							-81.31437182999991,
							28.51092305700007
						],
						[
							-81.31437567299992,
							28.510740526000063
						],
						[
							-81.31437984899992,
							28.510542161000046
						],
						[
							-81.3143847209999,
							28.510310735000076
						],
						[
							-81.31438785299991,
							28.510161962000044
						],
						[
							-81.31439272599994,
							28.509930536000073
						],
						[
							-81.3143986419999,
							28.509649518000064
						],
						[
							-81.3144031729999,
							28.509434275000046
						],
						[
							-81.31440804499995,
							28.509202849000076
						],
						[
							-81.31440999999995,
							28.508921843000056
						],
						[
							-81.31440796499993,
							28.508707103000063
						],
						[
							-81.31440285999992,
							28.508574361000058
						],
						[
							-81.31439174799993,
							28.50831021500005
						],
						[
							-81.31438648299991,
							28.508078324000053
						],
						[
							-81.31438405599994,
							28.507946067000034
						],
						[
							-81.31437859599993,
							28.507648488000086
						],
						[
							-81.31437495599994,
							28.507450101000074
						],
						[
							-81.31437179599993,
							28.50711894500006
						],
						[
							-81.31437909999994,
							28.506870607000057
						],
						[
							-81.31437103699996,
							28.506539729000053
						],
						[
							-81.31435999999991,
							28.506170000000054
						],
						[
							-81.31435965799994,
							28.506169412000077
						],
						[
							-81.31436070799992,
							28.50616935900007
						],
						[
							-81.31472324499993,
							28.506170360000056
						],
						[
							-81.31542929299991,
							28.50615233300005
						],
						[
							-81.31675225499993,
							28.506141317000072
						],
						[
							-81.31732410199993,
							28.506138313000065
						],
						[
							-81.31825648499995,
							28.506135309000058
						],
						[
							-81.31830957399991,
							28.506131363000065
						],
						[
							-81.3183088699999,
							28.506107366000037
						],
						[
							-81.31843199999992,
							28.506109000000038
						],
						[
							-81.31875590499993,
							28.506113704000086
						],
						[
							-81.31891399999995,
							28.506115999000087
						],
						[
							-81.31892030699993,
							28.506116090000035
						],
						[
							-81.32044899999994,
							28.506138000000078
						],
						[
							-81.32096199999995,
							28.506147000000055
						],
						[
							-81.32209399999994,
							28.50616700000006
						],
						[
							-81.32229099999995,
							28.506170000000054
						],
						[
							-81.32362799999994,
							28.506191000000058
						],
						[
							-81.32388099999991,
							28.506189000000063
						],
						[
							-81.32659699999994,
							28.50616800000006
						],
						[
							-81.32700299999993,
							28.506174000000044
						],
						[
							-81.3285909999999,
							28.506195000000048
						],
						[
							-81.3299669999999,
							28.506212000000062
						],
						[
							-81.33054399999992,
							28.50621600000005
						],
						[
							-81.33069099999994,
							28.506080000000054
						],
						[
							-81.33082899999994,
							28.506075000000067
						],
						[
							-81.33081799999991,
							28.506580000000042
						],
						[
							-81.3307979999999,
							28.507476000000054
						],
						[
							-81.33079299999991,
							28.507678000000055
						],
						[
							-81.33096818799993,
							28.507674292000047
						],
						[
							-81.3309716579999,
							28.507935100000054
						],
						[
							-81.33097534699994,
							28.508212388000064
						],
						[
							-81.33099027899993,
							28.508369626000047
						],
						[
							-81.33099337399995,
							28.509554378000075
						],
						[
							-81.33100138599991,
							28.509818771000084
						],
						[
							-81.3310023869999,
							28.509919921000062
						],
						[
							-81.33100338999992,
							28.50999102600008
						],
						[
							-81.33101048899994,
							28.510476730000054
						],
						[
							-81.32672090499995,
							28.51047761600006
						],
						[
							-81.32679328099994,
							28.513154845000088
						],
						[
							-81.32505644399993,
							28.513225959000067
						],
						[
							-81.32494853799994,
							28.511417005000055
						],
						[
							-81.31840056499993,
							28.51141700800008
						],
						[
							-81.31843575099992,
							28.51482519500007
						],
						[
							-81.31842728499993,
							28.51536006300006
						],
						[
							-81.31864599999994,
							28.51535800000005
						],
						[
							-81.31870118899991,
							28.515357443000084
						],
						[
							-81.31869938799991,
							28.515467352000087
						],
						[
							-81.3186958089999,
							28.51568565900004
						],
						[
							-81.31869330499991,
							28.515838391000045
						],
						[
							-81.3186906819999,
							28.515998395000054
						],
						[
							-81.31868999999995,
							28.516187678000055
						],
						[
							-81.31868797699991,
							28.51633640700004
						],
						[
							-81.3186796729999,
							28.51648588900008
						],
						[
							-81.31867159199993,
							28.516631343000086
						],
						[
							-81.31865617999995,
							28.51673946300008
						],
						[
							-81.31864726399995,
							28.51679073400004
						],
						[
							-81.31863676199993,
							28.516858798000044
						],
						[
							-81.31862748499994,
							28.51691891900009
						],
						[
							-81.31862294799993,
							28.516971092000063
						],
						[
							-81.31862243499995,
							28.51697699500005
						],
						[
							-81.31861578799993,
							28.517053436000083
						],
						[
							-81.31861322899994,
							28.517082861000063
						],
						[
							-81.31840097299995,
							28.517091255000082
						],
						[
							-81.31810399999995,
							28.51710300000008
						],
						[
							-81.31749372799993,
							28.517111595000074
						],
						[
							-81.31718099999995,
							28.517116000000044
						],
						[
							-81.3165709999999,
							28.51711000000006
						],
						[
							-81.31649040399992,
							28.517106797000054
						],
						[
							-81.31648999999993,
							28.51712000000009
						],
						[
							-81.31646046899994,
							28.517119389000072
						],
						[
							-81.31630296499992,
							28.51711613000009
						],
						[
							-81.31608914899994,
							28.517111707000083
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Bryn Mawr",
				"RegionID": "268906"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.11019637299995,
					26.109927850000076,
					-80.09881882899992,
					26.167540041000052
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.10106231899994,
							26.16205791100009
						],
						[
							-80.1012145439999,
							26.160216179000088
						],
						[
							-80.10114256799994,
							26.157859551000058
						],
						[
							-80.1002120579999,
							26.157843660000083
						],
						[
							-80.10006684099994,
							26.15782363200009
						],
						[
							-80.0997309999999,
							26.157764000000043
						],
						[
							-80.09881882899992,
							26.157748422000054
						],
						[
							-80.09884718699993,
							26.157597705000057
						],
						[
							-80.09885229399993,
							26.15757254600004
						],
						[
							-80.0991327879999,
							26.156285172000082
						],
						[
							-80.0992883099999,
							26.15494246600008
						],
						[
							-80.1000469889999,
							26.14799240800005
						],
						[
							-80.1000586749999,
							26.147915985000054
						],
						[
							-80.10080385999993,
							26.14413760800005
						],
						[
							-80.10145278199991,
							26.137978340000075
						],
						[
							-80.10149986199991,
							26.13754478000004
						],
						[
							-80.1015620089999,
							26.13682467400008
						],
						[
							-80.10156538099994,
							26.13679240500005
						],
						[
							-80.10164138099992,
							26.13617340500008
						],
						[
							-80.1016491069999,
							26.136122551000085
						],
						[
							-80.10169041899991,
							26.13589470800008
						],
						[
							-80.10167836099993,
							26.135799373000054
						],
						[
							-80.10165991799994,
							26.13564375800007
						],
						[
							-80.10165367799993,
							26.135538000000054
						],
						[
							-80.10165367799993,
							26.13546100000008
						],
						[
							-80.10165367799993,
							26.135368000000085
						],
						[
							-80.10165435099992,
							26.135333220000064
						],
						[
							-80.10169005599994,
							26.13441066300004
						],
						[
							-80.10159725199992,
							26.131813110000053
						],
						[
							-80.10159674899995,
							26.13179227300009
						],
						[
							-80.10155774899995,
							26.12868127300004
						],
						[
							-80.10156287699994,
							26.128573439000036
						],
						[
							-80.10171595499992,
							26.127155977000086
						],
						[
							-80.10185119599994,
							26.12563152900009
						],
						[
							-80.10186554699993,
							26.12553261800008
						],
						[
							-80.10212872999995,
							26.124232128000077
						],
						[
							-80.10219194299992,
							26.123529445000088
						],
						[
							-80.10231009599994,
							26.12142850400005
						],
						[
							-80.10232233999994,
							26.12132283400007
						],
						[
							-80.10235303799995,
							26.12120003700005
						],
						[
							-80.10269749699995,
							26.12014434300005
						],
						[
							-80.10275248099992,
							26.11991952200009
						],
						[
							-80.1027448769999,
							26.119230988000083
						],
						[
							-80.1026513999999,
							26.11690003600006
						],
						[
							-80.10265435199994,
							26.116782794000073
						],
						[
							-80.10282535199991,
							26.11489679300007
						],
						[
							-80.10284281799994,
							26.114784154000063
						],
						[
							-80.10297473599991,
							26.114186525000036
						],
						[
							-80.10313358399992,
							26.11346399100006
						],
						[
							-80.10318065399991,
							26.11252998200007
						],
						[
							-80.10326651399993,
							26.110540230000083
						],
						[
							-80.10326759799995,
							26.11052026100009
						],
						[
							-80.10330328899994,
							26.10997497200009
						],
						[
							-80.10330587699991,
							26.109927850000076
						],
						[
							-80.10420099999993,
							26.110029000000054
						],
						[
							-80.10595357299991,
							26.110227042000076
						],
						[
							-80.10621194999993,
							26.110255174000088
						],
						[
							-80.10702816899993,
							26.110341214000073
						],
						[
							-80.10806699999996,
							26.110651000000075
						],
						[
							-80.10871461799991,
							26.110759305000045
						],
						[
							-80.10941693299992,
							26.110909801000048
						],
						[
							-80.10992542899993,
							26.110944232000065
						],
						[
							-80.10995727099993,
							26.11097303300005
						],
						[
							-80.11000865799991,
							26.111023212000077
						],
						[
							-80.1100558139999,
							26.11107738700008
						],
						[
							-80.11009842599992,
							26.11113520400005
						],
						[
							-80.11013621699995,
							26.111196281000048
						],
						[
							-80.1101689379999,
							26.11126021800004
						],
						[
							-80.11019637299995,
							26.111326595000037
						],
						[
							-80.10990516699991,
							26.111973142000068
						],
						[
							-80.10948352899993,
							26.112535326000057
						],
						[
							-80.10914621799992,
							26.113266166000074
						],
						[
							-80.10889323499993,
							26.114306208000077
						],
						[
							-80.10864025199993,
							26.114784065000038
						],
						[
							-80.10838726899995,
							26.115290031000086
						],
						[
							-80.10869646999993,
							26.11576788800005
						],
						[
							-80.10875268899991,
							26.11658305600008
						],
						[
							-80.10871069899993,
							26.11729424400005
						],
						[
							-80.10870541399993,
							26.117282130000035
						],
						[
							-80.10862009399995,
							26.117363355000066
						],
						[
							-80.10857634599995,
							26.117402130000073
						],
						[
							-80.1086183239999,
							26.11746419600007
						],
						[
							-80.10865472499997,
							26.117529690000083
						],
						[
							-80.10868526999991,
							26.117598111000063
						],
						[
							-80.1087097269999,
							26.117668937000076
						],
						[
							-80.10872790899992,
							26.117741627000044
						],
						[
							-80.10873967799995,
							26.117815627000084
						],
						[
							-80.10874494199993,
							26.11789037200009
						],
						[
							-80.10882307299994,
							26.117945079000037
						],
						[
							-80.10893391999991,
							26.118055927000057
						],
						[
							-80.10902383599995,
							26.118184339000038
						],
						[
							-80.10909008599992,
							26.11832641400008
						],
						[
							-80.10910802699993,
							26.11838108900008
						],
						[
							-80.10920502699992,
							26.11871208900004
						],
						[
							-80.10922245299992,
							26.11878174700007
						],
						[
							-80.10923426699992,
							26.118852574000073
						],
						[
							-80.10924039199995,
							26.118924117000063
						],
						[
							-80.10924078999996,
							26.118995921000078
						],
						[
							-80.10923545799994,
							26.119067528000073
						],
						[
							-80.10915845799991,
							26.119738528000084
						],
						[
							-80.10915220699991,
							26.119783118000043
						],
						[
							-80.1088233939999,
							26.121765913000047
						],
						[
							-80.10856507599993,
							26.122413918000063
						],
						[
							-80.10848307299995,
							26.122495920000063
						],
						[
							-80.10842697899994,
							26.122539338000085
						],
						[
							-80.1083676369999,
							26.12257819900009
						],
						[
							-80.10830541699994,
							26.122612262000075
						],
						[
							-80.1082407049999,
							26.122641315000067
						],
						[
							-80.10817390499994,
							26.12266517800009
						],
						[
							-80.10810543299993,
							26.122683702000074
						],
						[
							-80.10769131199993,
							26.122778379000067
						],
						[
							-80.10756670199993,
							26.123096402000044
						],
						[
							-80.10712847299993,
							26.124332326000058
						],
						[
							-80.10715333299993,
							26.124470004000045
						],
						[
							-80.10716334599995,
							26.124543533000065
						],
						[
							-80.1071672619999,
							26.124617638000075
						],
						[
							-80.10716505499994,
							26.124691813000084
						],
						[
							-80.10715674099993,
							26.12476555300009
						],
						[
							-80.10714237499991,
							26.124838357000044
						],
						[
							-80.10712205499993,
							26.12490972900008
						],
						[
							-80.10709592099994,
							26.12497918200006
						],
						[
							-80.10706414899994,
							26.12504624400009
						],
						[
							-80.10699043699992,
							26.125186557000063
						],
						[
							-80.10704353099993,
							26.125777527000082
						],
						[
							-80.10708613499992,
							26.12622910500005
						],
						[
							-80.10726289899992,
							26.12687103500008
						],
						[
							-80.10785319299993,
							26.12737700100007
						],
						[
							-80.1087552429999,
							26.127858900000035
						],
						[
							-80.10966282499993,
							26.12864768600008
						],
						[
							-80.10977654699991,
							26.12946449100008
						],
						[
							-80.10977654699991,
							26.13081143100004
						],
						[
							-80.10980939899991,
							26.13176414500009
						],
						[
							-80.10977654699991,
							26.132191223000063
						],
						[
							-80.1095794339999,
							26.13268400600009
						],
						[
							-80.10921805999993,
							26.13343960700007
						],
						[
							-80.10895524199992,
							26.13426091100007
						],
						[
							-80.10846245899995,
							26.135509295000077
						],
						[
							-80.10829819799994,
							26.136396304000073
						],
						[
							-80.10836390199997,
							26.137053348000055
						],
						[
							-80.10833104999995,
							26.13787465300004
						],
						[
							-80.10835546699991,
							26.138155442000084
						],
						[
							-80.10797799999995,
							26.138167000000067
						],
						[
							-80.10658851399995,
							26.138189513000043
						],
						[
							-80.10540175499995,
							26.138206538000077
						],
						[
							-80.10459105199993,
							26.13818550700006
						],
						[
							-80.1039245639999,
							26.138207540000053
						],
						[
							-80.10356903699994,
							26.13821254600009
						],
						[
							-80.10320136799993,
							26.138209395000047
						],
						[
							-80.10275583399994,
							26.141003665000085
						],
						[
							-80.10220594899995,
							26.144450394000046
						],
						[
							-80.10218813099993,
							26.144449345000055
						],
						[
							-80.10218050399993,
							26.144487481000056
						],
						[
							-80.10216580799995,
							26.14455676700004
						],
						[
							-80.10214228699994,
							26.14465085200004
						],
						[
							-80.10212029599995,
							26.144738818000064
						],
						[
							-80.10210525299993,
							26.14479898600007
						],
						[
							-80.1020761609999,
							26.144915355000084
						],
						[
							-80.10203931399991,
							26.145022615000073
						],
						[
							-80.10199994999994,
							26.145128596000063
						],
						[
							-80.10196669899995,
							26.14521811700007
						],
						[
							-80.1019195419999,
							26.145342605000053
						],
						[
							-80.1018809059999,
							26.14544195600007
						],
						[
							-80.10185006199993,
							26.145589630000075
						],
						[
							-80.10181999999992,
							26.145770000000084
						],
						[
							-80.10179356599991,
							26.145923318000087
						],
						[
							-80.10175179599992,
							26.14616558100005
						],
						[
							-80.10171112499995,
							26.146394375000057
						],
						[
							-80.10167999999993,
							26.146550000000047
						],
						[
							-80.10166276899992,
							26.14668354400004
						],
						[
							-80.10164506299992,
							26.14682076200006
						],
						[
							-80.10162132999994,
							26.147004693000042
						],
						[
							-80.10159507899994,
							26.14719952300004
						],
						[
							-80.10156999999992,
							26.147350000000074
						],
						[
							-80.10155301399993,
							26.147453221000035
						],
						[
							-80.10152446299992,
							26.147626724000077
						],
						[
							-80.1014679669999,
							26.14797004500008
						],
						[
							-80.10143999999991,
							26.148140000000073
						],
						[
							-80.10141972499991,
							26.148245432000067
						],
						[
							-80.10138649999995,
							26.148418201000084
						],
						[
							-80.10134646599994,
							26.148626378000074
						],
						[
							-80.10128999999995,
							26.14892000000009
						],
						[
							-80.10127608999994,
							26.14899418600004
						],
						[
							-80.10126072599991,
							26.149076129000036
						],
						[
							-80.10122869499992,
							26.14924695900004
						],
						[
							-80.10119379999992,
							26.149433068000064
						],
						[
							-80.1011655449999,
							26.14958376000004
						],
						[
							-80.10113999999993,
							26.14972000000006
						],
						[
							-80.10113098699992,
							26.149800114000076
						],
						[
							-80.10111664399994,
							26.149927606000062
						],
						[
							-80.10110131099992,
							26.150063899000088
						],
						[
							-80.10108327899991,
							26.15022418700005
						],
						[
							-80.10106368099991,
							26.150398387000052
						],
						[
							-80.10104999999993,
							26.150520000000085
						],
						[
							-80.10103768699992,
							26.150628080000047
						],
						[
							-80.10103107199991,
							26.150686144000076
						],
						[
							-80.10101425599993,
							26.15083374900007
						],
						[
							-80.10099829199993,
							26.15097388000004
						],
						[
							-80.1009761549999,
							26.151168195000082
						],
						[
							-80.10095999999993,
							26.15131000000008
						],
						[
							-80.10094990399995,
							26.151421053000035
						],
						[
							-80.10093821399994,
							26.151549645000046
						],
						[
							-80.10092162199993,
							26.15173216100004
						],
						[
							-80.1009112509999,
							26.15184623400006
						],
						[
							-80.10091998399992,
							26.15193987400005
						],
						[
							-80.10092999999995,
							26.152042905000087
						],
						[
							-80.10092999999995,
							26.15210000000008
						],
						[
							-80.10094171299994,
							26.152170278000085
						],
						[
							-80.10094917399994,
							26.152215041000094
						],
						[
							-80.1009606749999,
							26.15228405000005
						],
						[
							-80.10097994799992,
							26.15239968800006
						],
						[
							-80.1010078189999,
							26.152505095000038
						],
						[
							-80.10132639999995,
							26.15251446900004
						],
						[
							-80.10167144699994,
							26.15254897400007
						],
						[
							-80.10236812999995,
							26.152626790000056
						],
						[
							-80.10249544299995,
							26.15615014900004
						],
						[
							-80.10252936299992,
							26.16026939300008
						],
						[
							-80.10300332899993,
							26.160252099000047
						],
						[
							-80.10299605799992,
							26.16298441100008
						],
						[
							-80.10411070699992,
							26.163006463000045
						],
						[
							-80.10453878399994,
							26.163014931000077
						],
						[
							-80.1044873429999,
							26.163597921000076
						],
						[
							-80.10442163899995,
							26.16464919200007
						],
						[
							-80.10425737799994,
							26.166258949000053
						],
						[
							-80.10415183899994,
							26.16749903100009
						],
						[
							-80.1037389999999,
							26.167505000000062
						],
						[
							-80.1036151049999,
							26.16750899500005
						],
						[
							-80.10327560099995,
							26.16750899500005
						],
						[
							-80.10195964999991,
							26.167528023000045
						],
						[
							-80.10158509199994,
							26.167533030000072
						],
						[
							-80.1011734839999,
							26.167540041000052
						],
						[
							-80.10048447399993,
							26.167528079000082
						],
						[
							-80.10090909099995,
							26.163795488000062
						],
						[
							-80.10106231899994,
							26.16205791100009
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Central Beach Alliance",
				"RegionID": "268915"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.41843316799992,
					28.520656717000065,
					-81.40123228099992,
					28.532042730000057
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.40468871999991,
							28.531339614000046
						],
						[
							-81.40408078899992,
							28.53096805800004
						],
						[
							-81.40296711599991,
							28.53096813600007
						],
						[
							-81.4013617249999,
							28.53096813800005
						],
						[
							-81.40137575599994,
							28.52973931400004
						],
						[
							-81.40136386699993,
							28.529203387000052
						],
						[
							-81.4012904999999,
							28.52920365300008
						],
						[
							-81.40128361899991,
							28.528999216000045
						],
						[
							-81.40126459099992,
							28.528524513000036
						],
						[
							-81.40124155699993,
							28.52789858400007
						],
						[
							-81.40123228099992,
							28.52738003400009
						],
						[
							-81.4012919999999,
							28.52738000000005
						],
						[
							-81.4012919999999,
							28.527525000000082
						],
						[
							-81.40479199999993,
							28.52751500000005
						],
						[
							-81.40479199999993,
							28.52738000000005
						],
						[
							-81.40609199999994,
							28.52737000000008
						],
						[
							-81.40627599999993,
							28.527373501000056
						],
						[
							-81.40716001899995,
							28.527057526000082
						],
						[
							-81.40716762799991,
							28.527103615000044
						],
						[
							-81.40717339699995,
							28.52716218200004
						],
						[
							-81.40717532199994,
							28.527221000000054
						],
						[
							-81.40717532199994,
							28.52747000000005
						],
						[
							-81.40717339699995,
							28.527528818000064
						],
						[
							-81.40716762799991,
							28.52758738500006
						],
						[
							-81.40715804199993,
							28.52764544900009
						],
						[
							-81.40714467799995,
							28.52770276200005
						],
						[
							-81.40713828699995,
							28.52772542400004
						],
						[
							-81.40719020699993,
							28.52781303800009
						],
						[
							-81.40720996199991,
							28.527845893000062
						],
						[
							-81.40724436399995,
							28.527821241000083
						],
						[
							-81.40728221299992,
							28.52779729300005
						],
						[
							-81.40750345799995,
							28.527664900000048
						],
						[
							-81.4078009669999,
							28.527456460000053
						],
						[
							-81.40781736299994,
							28.527445241000066
						],
						[
							-81.40786733899995,
							28.52741416400005
						],
						[
							-81.4079192399999,
							28.527386423000053
						],
						[
							-81.40797284399991,
							28.52736213500009
						],
						[
							-81.40802792199992,
							28.527341405000072
						],
						[
							-81.4080842379999,
							28.527324322000084
						],
						[
							-81.40812065699993,
							28.52731537300008
						],
						[
							-81.4084916569999,
							28.52723237300006
						],
						[
							-81.40851255099994,
							28.527227958000083
						],
						[
							-81.40857061499992,
							28.52721837200005
						],
						[
							-81.40862918099992,
							28.527212603000066
						],
						[
							-81.40863146099991,
							28.527212457000076
						],
						[
							-81.40892597399994,
							28.527193905000047
						],
						[
							-81.40899732999992,
							28.527175301000057
						],
						[
							-81.40916371299994,
							28.527075592000074
						],
						[
							-81.40917633899994,
							28.52706816500006
						],
						[
							-81.40922823999995,
							28.527040423000074
						],
						[
							-81.4092818439999,
							28.527016135000054
						],
						[
							-81.40933692199991,
							28.526995405000036
						],
						[
							-81.40939323799995,
							28.526978322000048
						],
						[
							-81.40941179799995,
							28.526973560000048
						],
						[
							-81.41025179799993,
							28.526767559000064
						],
						[
							-81.41029024699992,
							28.526759018000067
						],
						[
							-81.41109623699992,
							28.52659840900009
						],
						[
							-81.41134463399993,
							28.526538867000056
						],
						[
							-81.41150614399993,
							28.526499475000037
						],
						[
							-81.41215822999993,
							28.526339232000055
						],
						[
							-81.41220409099992,
							28.526322075000053
						],
						[
							-81.4123750839999,
							28.52615108300006
						],
						[
							-81.4124180359999,
							28.52611085400008
						],
						[
							-81.41242776699994,
							28.52610244200008
						],
						[
							-81.41269346899992,
							28.52587606800006
						],
						[
							-81.41358442099994,
							28.52506475000007
						],
						[
							-81.41421943899991,
							28.52428715600007
						],
						[
							-81.4142398539999,
							28.524263036000036
						],
						[
							-81.41428008299994,
							28.524220083000046
						],
						[
							-81.41455191699993,
							28.523948250000046
						],
						[
							-81.41478494899991,
							28.523655182000084
						],
						[
							-81.41488228299994,
							28.523501370000076
						],
						[
							-81.41527282699991,
							28.522586062000073
						],
						[
							-81.41529342199993,
							28.522541240000066
						],
						[
							-81.41532116399992,
							28.52248933900006
						],
						[
							-81.41532264299991,
							28.52248678600006
						],
						[
							-81.4154146539999,
							28.522328620000053
						],
						[
							-81.41551026399992,
							28.52210174700008
						],
						[
							-81.4155324219999,
							28.522053240000048
						],
						[
							-81.41554571799992,
							28.52202734400004
						],
						[
							-81.4158907179999,
							28.521381343000087
						],
						[
							-81.41590516399992,
							28.52135533900008
						],
						[
							-81.41591490199994,
							28.52133887800005
						],
						[
							-81.41609490199994,
							28.52104187900005
						],
						[
							-81.41611624099994,
							28.521008364000068
						],
						[
							-81.41615051999992,
							28.520960528000046
						],
						[
							-81.41618785399993,
							28.520915036000076
						],
						[
							-81.41622808299992,
							28.520872084000075
						],
						[
							-81.4162710359999,
							28.52083185400005
						],
						[
							-81.41627314199991,
							28.52083001300008
						],
						[
							-81.41647199299992,
							28.520656717000065
						],
						[
							-81.4178367049999,
							28.52086899200009
						],
						[
							-81.41805645499994,
							28.521003981000035
						],
						[
							-81.41816005099992,
							28.521069906000037
						],
						[
							-81.41825736899995,
							28.521126413000047
						],
						[
							-81.41829817899992,
							28.52114838800009
						],
						[
							-81.41834840799993,
							28.521182920000058
						],
						[
							-81.41843316799992,
							28.52126140200005
						],
						[
							-81.4183829399999,
							28.52134616300009
						],
						[
							-81.41821655799993,
							28.52160044400006
						],
						[
							-81.4181192399999,
							28.52176054800009
						],
						[
							-81.41800622599993,
							28.52185158700007
						],
						[
							-81.41790488499993,
							28.521890622000058
						],
						[
							-81.41787522499993,
							28.522935223000047
						],
						[
							-81.41787425799993,
							28.526901128000077
						],
						[
							-81.41787118199994,
							28.527332758000057
						],
						[
							-81.4179042689999,
							28.528424364000045
						],
						[
							-81.41791428399995,
							28.528898067000057
						],
						[
							-81.41793831899992,
							28.530047772000046
						],
						[
							-81.41795233999994,
							28.53078085800007
						],
						[
							-81.41796741399992,
							28.53171524700008
						],
						[
							-81.4159503699999,
							28.53177233000008
						],
						[
							-81.41558482799991,
							28.531783345000065
						],
						[
							-81.41552774299993,
							28.531785348000085
						],
						[
							-81.41542959799995,
							28.531787351000048
						],
						[
							-81.41401950599993,
							28.531835422000086
						],
						[
							-81.41390633899994,
							28.53183942800007
						],
						[
							-81.41381219999994,
							28.531842434000055
						],
						[
							-81.41361991499991,
							28.53188048900006
						],
						[
							-81.41319228099991,
							28.531922552000086
						],
						[
							-81.41262243499995,
							28.53194057800005
						],
						[
							-81.41226089799994,
							28.531958605000057
						],
						[
							-81.41154884299993,
							28.53197162400005
						],
						[
							-81.41054936099994,
							28.53198965200005
						],
						[
							-81.4104492109999,
							28.53199165400008
						],
						[
							-81.4094427199999,
							28.53200968100009
						],
						[
							-81.40870963299994,
							28.532020697000064
						],
						[
							-81.40794349599992,
							28.532024704000037
						],
						[
							-81.40740870199994,
							28.532028709000087
						],
						[
							-81.40651137099991,
							28.532040727000037
						],
						[
							-81.40570918299994,
							28.532042730000057
						],
						[
							-81.40547283199993,
							28.532010681000088
						],
						[
							-81.40537763599991,
							28.53198367400006
						],
						[
							-81.40537685399995,
							28.531920471000035
						],
						[
							-81.40468871999991,
							28.531339614000046
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Clear Lake",
				"RegionID": "268924"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.58185332199992,
					30.36559101200004,
					-81.56949353899995,
					30.377850322000086
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.57475634099991,
							30.37478283400009
						],
						[
							-81.5747832589999,
							30.37468237600007
						],
						[
							-81.57143264399991,
							30.374777957000052
						],
						[
							-81.57136334699995,
							30.374777262000066
						],
						[
							-81.57129430999993,
							30.374771234000033
						],
						[
							-81.57122594099991,
							30.374759908000044
						],
						[
							-81.57115864799994,
							30.374743351000063
						],
						[
							-81.57109282999994,
							30.374721661000084
						],
						[
							-81.5710288759999,
							30.374694968000085
						],
						[
							-81.57096716899991,
							30.374663429000062
						],
						[
							-81.57038900999993,
							30.374339254000063
						],
						[
							-81.56949353899995,
							30.373972007000077
						],
						[
							-81.56951610199991,
							30.373009245000052
						],
						[
							-81.56966389099995,
							30.366702923000048
						],
						[
							-81.57009990899991,
							30.366698012000082
						],
						[
							-81.57036790899991,
							30.36669201300009
						],
						[
							-81.57044390999994,
							30.36669201300009
						],
						[
							-81.57195990999992,
							30.36666301200006
						],
						[
							-81.57303890899993,
							30.366664012000058
						],
						[
							-81.57436393299992,
							30.36664214400008
						],
						[
							-81.57703894699995,
							30.365619080000045
						],
						[
							-81.57751190899995,
							30.365604012000066
						],
						[
							-81.57860590999991,
							30.36559301200009
						],
						[
							-81.57913990999994,
							30.36559101200004
						],
						[
							-81.57930791199993,
							30.36560801500008
						],
						[
							-81.57951390699992,
							30.365675011000068
						],
						[
							-81.5797119099999,
							30.365694012000063
						],
						[
							-81.58019986799991,
							30.36567292600006
						],
						[
							-81.57995873399994,
							30.366556023000044
						],
						[
							-81.58114204099991,
							30.36988397800008
						],
						[
							-81.5812729999999,
							30.373502000000087
						],
						[
							-81.58167360399995,
							30.37475218800006
						],
						[
							-81.58173283499993,
							30.374841339000056
						],
						[
							-81.58179908599993,
							30.374983414000045
						],
						[
							-81.58183965899991,
							30.37513483400005
						],
						[
							-81.58185332199992,
							30.37529100000006
						],
						[
							-81.58183965899991,
							30.375447165000082
						],
						[
							-81.58181916099994,
							30.375536510000074
						],
						[
							-81.58179816199993,
							30.37561050900007
						],
						[
							-81.58177808699992,
							30.375672586000068
						],
						[
							-81.5817118359999,
							30.37581466100005
						],
						[
							-81.58162192099991,
							30.375943073000087
						],
						[
							-81.58151107299994,
							30.37605392000006
						],
						[
							-81.5813826609999,
							30.37614383500005
						],
						[
							-81.5812385349999,
							30.37621082700008
						],
						[
							-81.5811834829999,
							30.376230568000043
						],
						[
							-81.58107450999995,
							30.37625948400006
						],
						[
							-81.5809640729999,
							30.37636992000006
						],
						[
							-81.5809040709999,
							30.376415600000087
						],
						[
							-81.58067846799992,
							30.376710488000075
						],
						[
							-81.58063003199993,
							30.376768605000056
						],
						[
							-81.58057675999993,
							30.37682232700007
						],
						[
							-81.58051905199996,
							30.37687125100007
						],
						[
							-81.58045733799992,
							30.376915013000087
						],
						[
							-81.58039207799993,
							30.376953286000063
						],
						[
							-81.58037151999991,
							30.376972498000043
						],
						[
							-81.5803529559999,
							30.376995195000063
						],
						[
							-81.58023807299992,
							30.377110920000064
						],
						[
							-81.58010439499992,
							30.377203829000052
						],
						[
							-81.58001512899995,
							30.37725382200006
						],
						[
							-81.57999110399993,
							30.377264829000072
						],
						[
							-81.57994891999994,
							30.377325073000065
						],
						[
							-81.57992333199991,
							30.377350662000083
						],
						[
							-81.57988525799993,
							30.377409259000043
						],
						[
							-81.57984268099995,
							30.377464673000077
						],
						[
							-81.5797958679999,
							30.377516556000046
						],
						[
							-81.57974510999992,
							30.37756458700005
						],
						[
							-81.57969072299994,
							30.377608467000076
						],
						[
							-81.57963304499992,
							30.377647921000058
						],
						[
							-81.57957243599992,
							30.37768270500004
						],
						[
							-81.57950927299993,
							30.37771260100004
						],
						[
							-81.57946727299992,
							30.37773060200004
						],
						[
							-81.5794059939999,
							30.377755761000063
						],
						[
							-81.57934262999993,
							30.377775074000056
						],
						[
							-81.57927773599994,
							30.377788372000055
						],
						[
							-81.57921188299991,
							30.377795539000093
						],
						[
							-81.57905916599992,
							30.37783665900008
						],
						[
							-81.57890299999991,
							30.377850322000086
						],
						[
							-81.5788402949999,
							30.377846956000045
						],
						[
							-81.57874659499993,
							30.37783939400003
						],
						[
							-81.57868383499994,
							30.37783665900008
						],
						[
							-81.57853241399994,
							30.37779608600005
						],
						[
							-81.57839033899995,
							30.37772983600007
						],
						[
							-81.57826192699991,
							30.377639921000085
						],
						[
							-81.57815107899997,
							30.377529073000066
						],
						[
							-81.57812774299992,
							30.377495745000086
						],
						[
							-81.57807957099993,
							30.377464646000078
						],
						[
							-81.57799572899995,
							30.37743420100008
						],
						[
							-81.57785333899994,
							30.37736783600008
						],
						[
							-81.57772370599992,
							30.37727686800008
						],
						[
							-81.57758541299995,
							30.377239087000078
						],
						[
							-81.57752294099993,
							30.377209955000065
						],
						[
							-81.57747383399993,
							30.377205659000083
						],
						[
							-81.57744992299992,
							30.377201108000065
						],
						[
							-81.57731292299991,
							30.37717310900007
						],
						[
							-81.57724135299992,
							30.377155397000084
						],
						[
							-81.57717147499994,
							30.377131882000075
						],
						[
							-81.57710375799991,
							30.37710272300006
						],
						[
							-81.57703865799994,
							30.377068114000053
						],
						[
							-81.57697660999992,
							30.37702828900007
						],
						[
							-81.5769180339999,
							30.376983516000053
						],
						[
							-81.57685752499992,
							30.37693320500006
						],
						[
							-81.57680067199995,
							30.376912962000063
						],
						[
							-81.57674579399992,
							30.37688785100005
						],
						[
							-81.57669330899995,
							30.37685806400009
						],
						[
							-81.57664361199994,
							30.37682382500009
						],
						[
							-81.57659708099993,
							30.37678539400008
						],
						[
							-81.57655406899995,
							30.376743062000063
						],
						[
							-81.57645784599993,
							30.37670640600004
						],
						[
							-81.57635301699992,
							30.376656568000048
						],
						[
							-81.57633211199993,
							30.376649201000077
						],
						[
							-81.57619138099994,
							30.376585548000037
						],
						[
							-81.5760703599999,
							30.376517691000057
						],
						[
							-81.57593692699993,
							30.37642492000009
						],
						[
							-81.57591879199992,
							30.376409291000073
						],
						[
							-81.57584540499994,
							30.376380906000065
						],
						[
							-81.57577903999993,
							30.37636686800005
						],
						[
							-81.57571394199994,
							30.376347799000087
						],
						[
							-81.57565049199991,
							30.37632381100008
						],
						[
							-81.57558905999991,
							30.376295044000074
						],
						[
							-81.57553000699994,
							30.37626166700005
						],
						[
							-81.57545918099993,
							30.37624439700005
						],
						[
							-81.57539003199992,
							30.376221315000066
						],
						[
							-81.57532303499994,
							30.37619257800009
						],
						[
							-81.5752586509999,
							30.37615838600004
						],
						[
							-81.57519732299994,
							30.376118972000086
						],
						[
							-81.5751394749999,
							30.376074609000057
						],
						[
							-81.57508550499995,
							30.37602560300007
						],
						[
							-81.57503578399991,
							30.37597229000005
						],
						[
							-81.57499943199991,
							30.375930182000047
						],
						[
							-81.57495498799994,
							30.37587358400009
						],
						[
							-81.57491521299994,
							30.375813613000048
						],
						[
							-81.57488036099994,
							30.37575065200008
						],
						[
							-81.5748506569999,
							30.37568510700004
						],
						[
							-81.57482628899993,
							30.37561739500006
						],
						[
							-81.57480741599994,
							30.37554795200009
						],
						[
							-81.57479415599994,
							30.375477221000036
						],
						[
							-81.57475215599993,
							30.37519022200007
						],
						[
							-81.57474267799995,
							30.37506000000008
						],
						[
							-81.57474267799995,
							30.37493900000004
						],
						[
							-81.57475634099991,
							30.37478283400009
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Colony Cove",
				"RegionID": "268931"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.25816799999983,
					25.731191407983296,
					-80.19980840249985,
					25.764580000000166
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.23069999999989,
							25.76450000000012
						],
						[
							-80.23068821399988,
							25.764233739000208
						],
						[
							-80.2306734079999,
							25.763974634000174
						],
						[
							-80.23065462199986,
							25.76339672300005
						],
						[
							-80.2306444059999,
							25.76310557800021
						],
						[
							-80.23063379199992,
							25.76275100200018
						],
						[
							-80.23062647299993,
							25.762557728000175
						],
						[
							-80.2306175449999,
							25.76229881500016
						],
						[
							-80.23060225499997,
							25.761847663000133
						],
						[
							-80.23059116099994,
							25.761589961000126
						],
						[
							-80.23056999999996,
							25.761240000000036
						],
						[
							-80.23055892499993,
							25.760944665000025
						],
						[
							-80.23054925899993,
							25.760686919000193
						],
						[
							-80.23053999999979,
							25.760440000000102
						],
						[
							-80.23053044699988,
							25.760201169000148
						],
						[
							-80.23051999999991,
							25.75994000000012
						],
						[
							-80.2305101959999,
							25.759719402000165
						],
						[
							-80.23050447099986,
							25.759590603000078
						],
						[
							-80.23049999999994,
							25.75949000000019
						],
						[
							-80.2304930469999,
							25.759170158000195
						],
						[
							-80.23048999999992,
							25.759030000000145
						],
						[
							-80.23048607799986,
							25.75891233
						],
						[
							-80.23046997399986,
							25.75852613500011
						],
						[
							-80.23046047599986,
							25.75833302100012
						],
						[
							-80.23044999999989,
							25.75812000000017
						],
						[
							-80.23044284299992,
							25.757719181000134
						],
						[
							-80.23042999999983,
							25.757380000000047
						],
						[
							-80.2304254159999,
							25.757040775000135
						],
						[
							-80.23041999999981,
							25.756640000000104
						],
						[
							-80.23041096999985,
							25.75645940300017
						],
						[
							-80.23039999999993,
							25.756240000000048
						],
						[
							-80.2303910999999,
							25.75594424600009
						],
						[
							-80.23037999999987,
							25.755750000000006
						],
						[
							-80.2303750479999,
							25.755492516000018
						],
						[
							-80.23036999999994,
							25.755230000000147
						],
						[
							-80.23034778699987,
							25.754847938000154
						],
						[
							-80.23033283099987,
							25.75459070000001
						],
						[
							-80.23031999999996,
							25.754370000000044
						],
						[
							-80.23030666499993,
							25.75394328300018
						],
						[
							-80.23029938699995,
							25.753717744000078
						],
						[
							-80.23028999999988,
							25.753530000000175
						],
						[
							-80.23027987499994,
							25.753266757000155
						],
						[
							-80.23027491899988,
							25.753137894000062
						],
						[
							-80.23025999999989,
							25.752840000000106
						],
						[
							-80.23024653699993,
							25.752426845000116
						],
						[
							-80.23023999999992,
							25.752100000000162
						],
						[
							-80.23021566499995,
							25.751686309000128
						],
						[
							-80.2301999999999,
							25.75142000000003
						],
						[
							-80.2301999999999,
							25.751168719000113
						],
						[
							-80.2301999999999,
							25.751030000000092
						],
						[
							-80.23019475499991,
							25.75084642700009
						],
						[
							-80.23018999999987,
							25.750680000000088
						],
						[
							-80.22969057799993,
							25.750686268000074
						],
						[
							-80.2291093869999,
							25.750702148000144
						],
						[
							-80.22843235799992,
							25.750720646000076
						],
						[
							-80.22808999999994,
							25.75073000000014
						],
						[
							-80.22759341199988,
							25.750749379000055
						],
						[
							-80.22701355199986,
							25.750772008000062
						],
						[
							-80.22665667799991,
							25.75078593500006
						],
						[
							-80.22603999999978,
							25.750810000000186
						],
						[
							-80.22549568299986,
							25.75082877000014
						],
						[
							-80.22488340399991,
							25.750849883000022
						],
						[
							-80.22433335399997,
							25.75086885000008
						],
						[
							-80.22400999999986,
							25.750880000000116
						],
						[
							-80.22330212999991,
							25.750902966000062
						],
						[
							-80.22278649799996,
							25.750920309000165
						],
						[
							-80.22236645399995,
							25.750935583000185
						],
						[
							-80.22196999999983,
							25.750950000000046
						],
						[
							-80.2214962449998,
							25.750964213000067
						],
						[
							-80.22123836899995,
							25.750971949000174
						],
						[
							-80.22096999999987,
							25.75098000000004
						],
						[
							-80.22062460299988,
							25.75098426400004
						],
						[
							-80.22020563899986,
							25.750989437000023
						],
						[
							-80.21994999999993,
							25.750990000000158
						],
						[
							-80.21962492099995,
							25.750998389000053
						],
						[
							-80.21914045899992,
							25.7510108910002
						],
						[
							-80.21862458599986,
							25.751024204000146
						],
						[
							-80.21839999999993,
							25.751030000000092
						],
						[
							-80.21781567399991,
							25.75105062300011
						],
						[
							-80.21730009999987,
							25.751068820000107
						],
						[
							-80.21694564299986,
							25.751081330000076
						],
						[
							-80.21669999999996,
							25.751090000000083
						],
						[
							-80.21646230999993,
							25.75109950800016
						],
						[
							-80.2161999999999,
							25.751110000000143
						],
						[
							-80.21578513999994,
							25.751107470000107
						],
						[
							-80.21517195899992,
							25.751103731000065
						],
						[
							-80.2142999999999,
							25.751100000000022
						],
						[
							-80.21421999999986,
							25.75123000000012
						],
						[
							-80.21417999999991,
							25.751390000000036
						],
						[
							-80.21417999999991,
							25.751690000000167
						],
						[
							-80.21418999999986,
							25.7518600000002
						],
						[
							-80.21418999999986,
							25.752168888000178
						],
						[
							-80.21418999999986,
							25.752570000000148
						],
						[
							-80.21418385099987,
							25.752846689000037
						],
						[
							-80.21417999999991,
							25.753020000000078
						],
						[
							-80.21418470299994,
							25.753137567000124
						],
						[
							-80.21418999999986,
							25.753270000000157
						],
						[
							-80.21418999999986,
							25.753400000000077
						],
						[
							-80.21419484699982,
							25.753685976000114
						],
						[
							-80.21419999999988,
							25.753990000000044
						],
						[
							-80.21419999999988,
							25.75434000000005
						],
						[
							-80.21420999999991,
							25.75471000000011
						],
						[
							-80.21421609899988,
							25.755136959000176
						],
						[
							-80.21421999999986,
							25.75541000000012
						],
						[
							-80.21421999999986,
							25.75591145500013
						],
						[
							-80.21421999999986,
							25.756120000000067
						],
						[
							-80.21422427499994,
							25.756491966000112
						],
						[
							-80.21422999999987,
							25.75699000000011
						],
						[
							-80.21422999999987,
							25.757200000000076
						],
						[
							-80.21422999999987,
							25.75749236700002
						],
						[
							-80.21422999999987,
							25.757770000000164
						],
						[
							-80.2142399999999,
							25.758530000000164
						],
						[
							-80.21423251199991,
							25.758911887000053
						],
						[
							-80.21422999999987,
							25.759040000000084
						],
						[
							-80.2142399999999,
							25.759310000000042
						],
						[
							-80.21424363399986,
							25.759589819000013
						],
						[
							-80.21424999999994,
							25.76008000000016
						],
						[
							-80.2142539979999,
							25.76039585900009
						],
						[
							-80.21425685699997,
							25.760621667000123
						],
						[
							-80.21425999999987,
							25.760870000000157
						],
						[
							-80.21427542499991,
							25.761298052000043
						],
						[
							-80.21429288399993,
							25.761782538000162
						],
						[
							-80.2142999999999,
							25.761980000000158
						],
						[
							-80.2142999999999,
							25.762040000000148
						],
						[
							-80.21430842399988,
							25.762298331000117
						],
						[
							-80.21432005299995,
							25.76265495400005
						],
						[
							-80.21432999999989,
							25.762960000000064
						],
						[
							-80.21421723199988,
							25.762962014000053
						],
						[
							-80.21396629299981,
							25.76296649500016
						],
						[
							-80.21359901599989,
							25.762973053000167
						],
						[
							-80.21316287499987,
							25.76298084200001
						],
						[
							-80.21274968799989,
							25.76298822000009
						],
						[
							-80.21264999999988,
							25.76299000000006
						],
						[
							-80.21231383699987,
							25.762999605000058
						],
						[
							-80.2118310659999,
							25.76300493600005
						],
						[
							-80.21162442999986,
							25.763007111000142
						],
						[
							-80.21134999999988,
							25.763010000000115
						],
						[
							-80.2113452364998,
							25.763008414500206
						],
						[
							-80.21077649099995,
							25.763014695000063
						],
						[
							-80.20928738199984,
							25.763055151000035
						],
						[
							-80.20779864499985,
							25.76309127400009
						],
						[
							-80.20665975799994,
							25.76310092500009
						],
						[
							-80.20499659799991,
							25.76315125200008
						],
						[
							-80.20306871699982,
							25.763210434000182
						],
						[
							-80.20114460399988,
							25.76329331600011
						],
						[
							-80.20035664899987,
							25.763305752000072
						],
						[
							-80.2000960939999,
							25.76330239200015
						],
						[
							-80.20001783899981,
							25.762035488000134
						],
						[
							-80.19980840249985,
							25.761909075000062
						],
						[
							-80.19981776899988,
							25.761560383000166
						],
						[
							-80.19983550699992,
							25.76076833600009
						],
						[
							-80.1998502509998,
							25.760040942000124
						],
						[
							-80.19986707299996,
							25.75938082500013
						],
						[
							-80.19989340799991,
							25.758721619000124
						],
						[
							-80.19991409899986,
							25.758194021000165
						],
						[
							-80.19993849799991,
							25.75771901400021
						],
						[
							-80.20002999999984,
							25.757270000000183
						],
						[
							-80.2003162819999,
							25.757069603000033
						],
						[
							-80.20044114499984,
							25.75645713900016
						],
						[
							-80.20071268599993,
							25.75612779100009
						],
						[
							-80.20112839499978,
							25.7557339000001
						],
						[
							-80.20156171399992,
							25.755439862000102
						],
						[
							-80.20219169599991,
							25.755033801000167
						],
						[
							-80.2031405189999,
							25.75448517200016
						],
						[
							-80.20384046599992,
							25.753708573000118
						],
						[
							-80.20524383899995,
							25.752874165
						],
						[
							-80.2056199999999,
							25.752480000000165
						],
						[
							-80.20518600699995,
							25.75181822100003
						],
						[
							-80.20440676899996,
							25.750760118000144
						],
						[
							-80.20400963759992,
							25.75029014100007
						],
						[
							-80.2041935619999,
							25.750262466000002
						],
						[
							-80.20458442999993,
							25.750345110000094
						],
						[
							-80.20487649699993,
							25.750315000000086
						],
						[
							-80.20537092599989,
							25.75026402800013
						],
						[
							-80.20598124099985,
							25.750220409000164
						],
						[
							-80.20641999999991,
							25.750190000000046
						],
						[
							-80.20653778799989,
							25.750182147000196
						],
						[
							-80.2070380789999,
							25.7501487950001
						],
						[
							-80.20756168899989,
							25.750114730000035
						],
						[
							-80.20816679399985,
							25.75012145600006
						],
						[
							-80.20949512499989,
							25.749891340000204
						],
						[
							-80.20972420899993,
							25.749851654000118
						],
						[
							-80.2099815009999,
							25.749796651000096
						],
						[
							-80.21033648999988,
							25.74974830100018
						],
						[
							-80.2115637379999,
							25.749327307000165
						],
						[
							-80.21322367299983,
							25.748757883000124
						],
						[
							-80.21888753299986,
							25.746814955000126
						],
						[
							-80.23729914999984,
							25.740067601000156
						],
						[
							-80.23775537599994,
							25.739900407000178
						],
						[
							-80.23778384799989,
							25.73988899100012
						],
						[
							-80.23780985099991,
							25.73987856400006
						],
						[
							-80.2405330509999,
							25.738870567000056
						],
						[
							-80.24108772499996,
							25.738667862000074
						],
						[
							-80.24139499199981,
							25.73855360300012
						],
						[
							-80.24167253699994,
							25.738449986000163
						],
						[
							-80.2419982929999,
							25.738330519000137
						],
						[
							-80.24243723499988,
							25.73817346700011
						],
						[
							-80.24275789799987,
							25.73805873400012
						],
						[
							-80.24288639699992,
							25.738012757000135
						],
						[
							-80.24294999999995,
							25.737990000000117
						],
						[
							-80.24313768899994,
							25.737922803000153
						],
						[
							-80.24354929399989,
							25.737775438000128
						],
						[
							-80.24375999999991,
							25.737700000000103
						],
						[
							-80.24394471999992,
							25.737632985000154
						],
						[
							-80.24418551099986,
							25.73754562900003
						],
						[
							-80.24442489999986,
							25.73745878100013
						],
						[
							-80.24476664099988,
							25.737334800000085
						],
						[
							-80.24525833199989,
							25.737156419000158
						],
						[
							-80.24563756099992,
							25.737018838000054
						],
						[
							-80.24590823199985,
							25.736920641500056
						],
						[
							-80.24635773799992,
							25.736754682000047
						],
						[
							-80.24687427399992,
							25.736563960000076
						],
						[
							-80.24731594399988,
							25.736400882000083
						],
						[
							-80.24758794599991,
							25.73630045100021
						],
						[
							-80.24785999999995,
							25.73620000000016
						],
						[
							-80.2481427369999,
							25.73609800800007
						],
						[
							-80.24853809099993,
							25.73595539200017
						],
						[
							-80.24891755899996,
							25.735818506000037
						],
						[
							-80.24925952199993,
							25.735695150000133
						],
						[
							-80.2495798669998,
							25.735579591000075
						],
						[
							-80.2498366659999,
							25.735486956000138
						],
						[
							-80.2499752209999,
							25.73543697500018
						],
						[
							-80.25004999999987,
							25.735410000000165
						],
						[
							-80.25020446199996,
							25.735336395000026
						],
						[
							-80.25038244499984,
							25.735263042000085
						],
						[
							-80.25047729899988,
							25.73522052100021
						],
						[
							-80.25058999999987,
							25.735170000000025
						],
						[
							-80.25093825299992,
							25.73494293000007
						],
						[
							-80.25113574699992,
							25.73481725200015
						],
						[
							-80.25127974399993,
							25.734721274000023
						],
						[
							-80.25143884899985,
							25.734610119000152
						],
						[
							-80.25184890699985,
							25.734435793000117
						],
						[
							-80.25386330899983,
							25.732658644000068
						],
						[
							-80.25498665399995,
							25.731667604000137
						],
						[
							-80.25521505299993,
							25.73153620100001
						],
						[
							-80.2554797799999,
							25.731401516000147
						],
						[
							-80.2556374149999,
							25.731321315000173
						],
						[
							-80.25575807299992,
							25.73125326300005
						],
						[
							-80.25585903027535,
							25.731191407983296
						],
						[
							-80.2558649999998,
							25.731289000000075
						],
						[
							-80.25586799999986,
							25.7318840000001
						],
						[
							-80.25586999999986,
							25.73201100000013
						],
						[
							-80.25587162471417,
							25.73212473000421
						],
						[
							-80.25587299999992,
							25.732221000000095
						],
						[
							-80.25689799999991,
							25.732210000000073
						],
						[
							-80.25791799999985,
							25.732180000000078
						],
						[
							-80.25793291175442,
							25.732436032014512
						],
						[
							-80.25797099999987,
							25.733090000000054
						],
						[
							-80.25800278054997,
							25.734076813014646
						],
						[
							-80.25800351795293,
							25.734099710001708
						],
						[
							-80.25802999999978,
							25.73492200000011
						],
						[
							-80.25806882977491,
							25.73589536800924
						],
						[
							-80.25810399999996,
							25.736777000000117
						],
						[
							-80.25816378840653,
							25.73850712702061
						],
						[
							-80.25816799999983,
							25.738629000000056
						],
						[
							-80.25794770399698,
							25.738637656926784
						],
						[
							-80.25720099999994,
							25.738667000000177
						],
						[
							-80.25617599999987,
							25.738703000000136
						],
						[
							-80.25618799999997,
							25.739051000000153
						],
						[
							-80.25622099999994,
							25.739812000000057
						],
						[
							-80.25624499999988,
							25.74054400000005
						],
						[
							-80.25620342647251,
							25.741308161025884
						],
						[
							-80.25620299999989,
							25.741316000000154
						],
						[
							-80.25621905678743,
							25.741742740008107
						],
						[
							-80.25622899999989,
							25.74200700000013
						],
						[
							-80.25624355938088,
							25.742318408982285
						],
						[
							-80.25624699999987,
							25.74239200000001
						],
						[
							-80.25443799999994,
							25.74247500000013
						],
						[
							-80.2543129999999,
							25.742469000000163
						],
						[
							-80.25432199999993,
							25.742552000000103
						],
						[
							-80.2543269999999,
							25.742756000000107
						],
						[
							-80.25433199999988,
							25.74298600000013
						],
						[
							-80.25436899999991,
							25.743813000000166
						],
						[
							-80.25438499999991,
							25.744214000000127
						],
						[
							-80.2543989999999,
							25.744565000000037
						],
						[
							-80.25441499999981,
							25.74502900000006
						],
						[
							-80.2544319999999,
							25.745367000000137
						],
						[
							-80.2544479999998,
							25.745807000000127
						],
						[
							-80.25446199999989,
							25.746135000000088
						],
						[
							-80.25448099999994,
							25.746571000000102
						],
						[
							-80.25450099999982,
							25.747072000000166
						],
						[
							-80.25451199999993,
							25.747339000000053
						],
						[
							-80.25453999999985,
							25.748058000000036
						],
						[
							-80.25457299999992,
							25.74890500000013
						],
						[
							-80.25461599999993,
							25.749860000000098
						],
						[
							-80.25461758826056,
							25.749907017991376
						],
						[
							-80.25467399999992,
							25.751577000000054
						],
						[
							-80.25470599999983,
							25.75244300000012
						],
						[
							-80.25473799999989,
							25.7533230000001
						],
						[
							-80.2547170733378,
							25.753877169012824
						],
						[
							-80.25471099999989,
							25.754038000000108
						],
						[
							-80.25475799999987,
							25.755224000000183
						],
						[
							-80.25479999999988,
							25.756034000000056
						],
						[
							-80.2547991447695,
							25.756189936998837
						],
						[
							-80.2547969999999,
							25.75658100000002
						],
						[
							-80.25481199999989,
							25.75673000000009
						],
						[
							-80.25482730073239,
							25.757127054010386
						],
						[
							-80.25483199999985,
							25.757249000000044
						],
						[
							-80.25483264875017,
							25.757256405021884
						],
						[
							-80.2548343324246,
							25.7572756229629
						],
						[
							-80.25460228099986,
							25.757277061000146
						],
						[
							-80.25402862099992,
							25.757294100000045
						],
						[
							-80.2534896479999,
							25.757310109000038
						],
						[
							-80.25308341699986,
							25.757322176000063
						],
						[
							-80.25281999999991,
							25.757330000000174
						],
						[
							-80.25227596399994,
							25.757346321000014
						],
						[
							-80.25163594499992,
							25.757365522000093
						],
						[
							-80.25102961099992,
							25.757383712
						],
						[
							-80.2508199999999,
							25.757390000000164
						],
						[
							-80.25065868899988,
							25.75739375100003
						],
						[
							-80.25055524599993,
							25.757396157000056
						],
						[
							-80.25038999999994,
							25.757400000000104
						],
						[
							-80.25004962899995,
							25.757410085000142
						],
						[
							-80.24944328099986,
							25.757428051000204
						],
						[
							-80.24887999999989,
							25.7574300000001
						],
						[
							-80.24839854099993,
							25.757442931000192
						],
						[
							-80.24775868099992,
							25.757464621000032
						],
						[
							-80.2472872059999,
							25.757480603000115
						],
						[
							-80.24688347099989,
							25.75750100200011
						],
						[
							-80.24677999999994,
							25.757510000000146
						],
						[
							-80.24630766599994,
							25.757532143000116
						],
						[
							-80.24549965799989,
							25.757565011000167
						],
						[
							-80.24512914899987,
							25.75757658900006
						],
						[
							-80.24471999999984,
							25.757580000000075
						],
						[
							-80.24425100099995,
							25.75759601500007
						],
						[
							-80.24371217999995,
							25.75761441300017
						],
						[
							-80.24307233099995,
							25.757636262000116
						],
						[
							-80.24266999999988,
							25.757650000000183
						],
						[
							-80.24223040099992,
							25.75766486600017
						],
						[
							-80.24148836799989,
							25.757689959000025
						],
						[
							-80.24091358099986,
							25.757709396000124
						],
						[
							-80.24059999999993,
							25.757720000000113
						],
						[
							-80.23997044899988,
							25.757738981000173
						],
						[
							-80.23895990099994,
							25.75776945000012
						],
						[
							-80.23860999999995,
							25.757780000000103
						],
						[
							-80.23861989199987,
							25.758083347000067
						],
						[
							-80.23863420499991,
							25.758522282000058
						],
						[
							-80.23863999999985,
							25.758700000000196
						],
						[
							-80.23865575999992,
							25.759062482000168
						],
						[
							-80.23867039099979,
							25.759399002000123
						],
						[
							-80.23867999999987,
							25.759620000000115
						],
						[
							-80.23869226799991,
							25.759905235000176
						],
						[
							-80.23870963799993,
							25.760309075000194
						],
						[
							-80.2387199999999,
							25.760550000000148
						],
						[
							-80.23873266099979,
							25.76084753800007
						],
						[
							-80.23874847499985,
							25.761219171000178
						],
						[
							-80.23875999999983,
							25.761490000000116
						],
						[
							-80.23876486599988,
							25.761657874000154
						],
						[
							-80.23877560699988,
							25.76202843400008
						],
						[
							-80.23877999999989,
							25.762180000000185
						],
						[
							-80.23877999999989,
							25.762390000000153
						],
						[
							-80.23879814299988,
							25.76260045700007
						],
						[
							-80.2388154529999,
							25.762801258000074
						],
						[
							-80.23882999999994,
							25.76297000000018
						],
						[
							-80.23883859399986,
							25.76327507300011
						],
						[
							-80.2388433389999,
							25.763443517000013
						],
						[
							-80.23884999999991,
							25.76368000000013
						],
						[
							-80.23886534099994,
							25.76401637000007
						],
						[
							-80.2388799269999,
							25.764418687000052
						],
						[
							-80.23838529199992,
							25.76443081400008
						],
						[
							-80.23787900099985,
							25.764446250000113
						],
						[
							-80.23723900099994,
							25.76446576200013
						],
						[
							-80.23676999999994,
							25.76450000000012
						],
						[
							-80.23646671399989,
							25.76452757100018
						],
						[
							-80.23606135899992,
							25.76454761100006
						],
						[
							-80.23585637299993,
							25.76455714500014
						],
						[
							-80.23557999999989,
							25.76457000000005
						],
						[
							-80.23555999999992,
							25.764460000000007
						],
						[
							-80.23514785999993,
							25.76446993100003
						],
						[
							-80.2347299999999,
							25.764480000000063
						],
						[
							-80.23427185599992,
							25.764493744000134
						],
						[
							-80.23373289199992,
							25.76450991300014
						],
						[
							-80.23316024399988,
							25.76452709300014
						],
						[
							-80.23272999999989,
							25.764540000000054
						],
						[
							-80.23235042199993,
							25.764547516000142
						],
						[
							-80.2316426729999,
							25.764561531000147
						],
						[
							-80.23116950499991,
							25.764570901000035
						],
						[
							-80.23083829899987,
							25.764577459000044
						],
						[
							-80.2307099999999,
							25.764580000000166
						],
						[
							-80.23069999999989,
							25.76450000000012
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami",
				"Name": "Coral Way",
				"RegionID": "268938"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.3103906144153,
					28.4806191911047,
					-81.30204500041222,
					28.487875044949746
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.30204511822349,
							28.483799645259946
						],
						[
							-81.30204500041222,
							28.483760999593628
						],
						[
							-81.3021899999018,
							28.483760999593628
						],
						[
							-81.30247300035651,
							28.483760999593628
						],
						[
							-81.3029899999067,
							28.483756000262545
						],
						[
							-81.30322099976328,
							28.483755000216455
						],
						[
							-81.30596678909873,
							28.483735217829707
						],
						[
							-81.30599700002362,
							28.48373500019384
						],
						[
							-81.30600600043842,
							28.4837950002616
						],
						[
							-81.30619849042628,
							28.483724959263355
						],
						[
							-81.30639899966873,
							28.48365199996502
						],
						[
							-81.30636699999214,
							28.483549999759845
						],
						[
							-81.30634800001579,
							28.48337499978667
						],
						[
							-81.30634900006189,
							28.48153699959747
						],
						[
							-81.30626299969478,
							28.481540999781917
						],
						[
							-81.30625600027135,
							28.48067400028563
						],
						[
							-81.30648700012792,
							28.48067300023954
						],
						[
							-81.30658549117854,
							28.480671271742636
						],
						[
							-81.3067654536106,
							28.480668115122427
						],
						[
							-81.3068859996346,
							28.48066599991691
						],
						[
							-81.30697800027824,
							28.480662999778723
						],
						[
							-81.30918799962896,
							28.480645999894378
						],
						[
							-81.30918826402964,
							28.480620161473198
						],
						[
							-81.30932924624763,
							28.480621469087303
						],
						[
							-81.309985218031,
							28.480619466297107
						],
						[
							-81.31009337859214,
							28.480619466297107
						],
						[
							-81.31018753041403,
							28.480619466297107
						],
						[
							-81.3103906144153,
							28.4806191911047
						],
						[
							-81.31033200020279,
							28.48360000026598
						],
						[
							-81.31031400027236,
							28.484664999896072
						],
						[
							-81.31031500031852,
							28.484880999960566
						],
						[
							-81.31032399983407,
							28.487507999647598
						],
						[
							-81.3102383241223,
							28.487802550994644
						],
						[
							-81.31021906258886,
							28.48786877052148
						],
						[
							-81.3059273536592,
							28.487875044949746
						],
						[
							-81.30388599992027,
							28.487755000120917
						],
						[
							-81.30389000002495,
							28.487381000088725
						],
						[
							-81.3038859998405,
							28.486136000255186
						],
						[
							-81.30388799993268,
							28.48605900030291
						],
						[
							-81.30241100019649,
							28.486055000118633
						],
						[
							-81.30205399992785,
							28.486054000072542
						],
						[
							-81.30204599955913,
							28.484089000324204
						],
						[
							-81.30204511822349,
							28.483799645259946
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Countryside",
				"RegionID": "268940"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.60416724099991,
					30.220636010000078,
					-81.57146590399992,
					30.248390095000047
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.57266290799994,
							30.220919010000046
						],
						[
							-81.57317890699994,
							30.220909010000074
						],
						[
							-81.57440090699993,
							30.220914011000048
						],
						[
							-81.5745469069999,
							30.220911011000055
						],
						[
							-81.57493203899992,
							30.220904139000083
						],
						[
							-81.5749307399999,
							30.220844938000084
						],
						[
							-81.5750188419999,
							30.220762836000066
						],
						[
							-81.57514190799992,
							30.220762010000048
						],
						[
							-81.57646090799994,
							30.220746010000084
						],
						[
							-81.5786209069999,
							30.220736011000042
						],
						[
							-81.57946290699994,
							30.220732010000063
						],
						[
							-81.5804919069999,
							30.220727010000072
						],
						[
							-81.58127190699992,
							30.220723010000082
						],
						[
							-81.5829629079999,
							30.220715010000053
						],
						[
							-81.5844029079999,
							30.220680010000077
						],
						[
							-81.58514690699992,
							30.220682010000072
						],
						[
							-81.5853489079999,
							30.220678010000082
						],
						[
							-81.5856199079999,
							30.220678010000082
						],
						[
							-81.58574190699994,
							30.22067501000004
						],
						[
							-81.58587590699995,
							30.220667011000046
						],
						[
							-81.58650890799993,
							30.22066101000007
						],
						[
							-81.58898090299994,
							30.220636010000078
						],
						[
							-81.59082754699995,
							30.223443155000044
						],
						[
							-81.59356854599991,
							30.22764601500006
						],
						[
							-81.5962584639999,
							30.231639023000074
						],
						[
							-81.59941600499991,
							30.236325837000038
						],
						[
							-81.60416724099991,
							30.24263016500004
						],
						[
							-81.6006037709999,
							30.244548828000063
						],
						[
							-81.59349686199994,
							30.248390095000047
						],
						[
							-81.59274490699994,
							30.247654010000076
						],
						[
							-81.59212190799991,
							30.247050010000066
						],
						[
							-81.59079190699993,
							30.245764010000073
						],
						[
							-81.59036290699993,
							30.24532901100008
						],
						[
							-81.58962990799995,
							30.24464401000006
						],
						[
							-81.5886789079999,
							30.243757011000074
						],
						[
							-81.58816790799995,
							30.24326401000008
						],
						[
							-81.58798390699991,
							30.24310201100008
						],
						[
							-81.58735990699995,
							30.242480010000065
						],
						[
							-81.58667790699991,
							30.241828011000052
						],
						[
							-81.58637990699992,
							30.241534011000056
						],
						[
							-81.58614590699995,
							30.241313010000056
						],
						[
							-81.58588190799993,
							30.24104301100005
						],
						[
							-81.58578390699995,
							30.240955011000043
						],
						[
							-81.58504590799993,
							30.24022001000009
						],
						[
							-81.58491090799993,
							30.240070011000054
						],
						[
							-81.58466890699992,
							30.239824011000056
						],
						[
							-81.58461790799993,
							30.239770010000086
						],
						[
							-81.58432690799992,
							30.239461010000074
						],
						[
							-81.58400090799996,
							30.239096011000072
						],
						[
							-81.58384690799994,
							30.238934010000037
						],
						[
							-81.58354290799991,
							30.23859501000004
						],
						[
							-81.58331690799992,
							30.238338011000053
						],
						[
							-81.58310590699995,
							30.238082011000078
						],
						[
							-81.58301690799993,
							30.237980010000058
						],
						[
							-81.58286890799991,
							30.237797010000065
						],
						[
							-81.58232490799992,
							30.23715001000005
						],
						[
							-81.58222590799994,
							30.237015011000043
						],
						[
							-81.58171290799993,
							30.23637801000007
						],
						[
							-81.58152790699995,
							30.236127010000075
						],
						[
							-81.58148990799992,
							30.236087010000066
						],
						[
							-81.58105390799994,
							30.23550201000006
						],
						[
							-81.58099290699994,
							30.235407011000063
						],
						[
							-81.58083990799992,
							30.235207010000064
						],
						[
							-81.58057890799995,
							30.234844011000064
						],
						[
							-81.58036890799991,
							30.23454401000004
						],
						[
							-81.58007190799992,
							30.234098010000082
						],
						[
							-81.57989090699994,
							30.233848011000077
						],
						[
							-81.5795389079999,
							30.23330101100004
						],
						[
							-81.57942390699992,
							30.233139010000063
						],
						[
							-81.57905590799993,
							30.232564011000076
						],
						[
							-81.57842790699993,
							30.23163501000005
						],
						[
							-81.57793890699992,
							30.23086901000005
						],
						[
							-81.57751890799994,
							30.23023501000006
						],
						[
							-81.57732690799992,
							30.229921010000055
						],
						[
							-81.57711190799996,
							30.229603011000055
						],
						[
							-81.57641790699995,
							30.22853401000009
						],
						[
							-81.5756679079999,
							30.22739401100006
						],
						[
							-81.57543690699993,
							30.22704401100009
						],
						[
							-81.57523090799992,
							30.22672301000006
						],
						[
							-81.57504490799994,
							30.22645201100005
						],
						[
							-81.57485190799991,
							30.22613701000006
						],
						[
							-81.57462490699993,
							30.225787010000086
						],
						[
							-81.57443190799995,
							30.225510010000047
						],
						[
							-81.57423790899992,
							30.225201010000035
						],
						[
							-81.5740939069999,
							30.224994011000035
						],
						[
							-81.57395290799991,
							30.224783010000067
						],
						[
							-81.57368690699991,
							30.224365011000085
						],
						[
							-81.57331690699993,
							30.22374701100006
						],
						[
							-81.5731929069999,
							30.22355901100008
						],
						[
							-81.57297290799994,
							30.22327801100005
						],
						[
							-81.5728739079999,
							30.22312401000005
						],
						[
							-81.5725839079999,
							30.22265701100008
						],
						[
							-81.57235290799991,
							30.222322011000074
						],
						[
							-81.5722219079999,
							30.222117010000094
						],
						[
							-81.5721389069999,
							30.221975011000037
						],
						[
							-81.57198490699994,
							30.221756010000032
						],
						[
							-81.57165790699992,
							30.221248011000057
						],
						[
							-81.57155890699994,
							30.221090011000058
						],
						[
							-81.57146590399992,
							30.220936016000056
						],
						[
							-81.57211990799993,
							30.220927010000082
						],
						[
							-81.57266290799994,
							30.220919010000046
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Deerwood Center",
				"RegionID": "268947"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.17816799999991,
					26.136567975000048,
					-80.16990037399995,
					26.147435166000037
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.17018382799996,
							26.14624445800007
						],
						[
							-80.17023089899993,
							26.144633070000054
						],
						[
							-80.16996751399995,
							26.136674264000078
						],
						[
							-80.17021187099994,
							26.13667326400008
						],
						[
							-80.17035508299995,
							26.13667426500007
						],
						[
							-80.17041116699994,
							26.13667326400008
						],
						[
							-80.17099703499991,
							26.13666425000008
						],
						[
							-80.17126643399992,
							26.136654236000084
						],
						[
							-80.17128946999992,
							26.136654236000084
						],
						[
							-80.17246020499994,
							26.136600156000043
						],
						[
							-80.17255234299995,
							26.136599155000056
						],
						[
							-80.17262544999994,
							26.136592144000076
						],
						[
							-80.17275864699991,
							26.13658713600006
						],
						[
							-80.17286280299993,
							26.13658513300004
						],
						[
							-80.1732483749999,
							26.136580127000062
						],
						[
							-80.17354080699994,
							26.136568108000063
						],
						[
							-80.17439320199992,
							26.136567975000048
						],
						[
							-80.17439325299995,
							26.136570000000063
						],
						[
							-80.17456953999994,
							26.136570000000063
						],
						[
							-80.17456799999991,
							26.136663000000055
						],
						[
							-80.17766799999993,
							26.136663000000055
						],
						[
							-80.17767385899992,
							26.136750895000095
						],
						[
							-80.17771399999992,
							26.137353000000076
						],
						[
							-80.17781399999991,
							26.138266000000044
						],
						[
							-80.17806799999994,
							26.13826300000005
						],
						[
							-80.17806799999994,
							26.13876300000004
						],
						[
							-80.17816799999991,
							26.138963000000047
						],
						[
							-80.17816299999993,
							26.139272000000062
						],
						[
							-80.17816799999991,
							26.13956300000007
						],
						[
							-80.17816499999992,
							26.14006100000006
						],
						[
							-80.17816299999993,
							26.140467000000058
						],
						[
							-80.17801899999995,
							26.14047400000004
						],
						[
							-80.17803299999991,
							26.140963000000056
						],
						[
							-80.17803299999991,
							26.141563000000076
						],
						[
							-80.17803299999991,
							26.142133000000058
						],
						[
							-80.17546799999991,
							26.142133000000058
						],
						[
							-80.17546799999991,
							26.14226300000007
						],
						[
							-80.1750449999999,
							26.14226400000007
						],
						[
							-80.17504899999996,
							26.14213200000006
						],
						[
							-80.17487354799994,
							26.142134352000088
						],
						[
							-80.17467599999993,
							26.142137000000048
						],
						[
							-80.17467699999992,
							26.14226400000007
						],
						[
							-80.17466799999994,
							26.142963000000066
						],
						[
							-80.17476799999993,
							26.14506300000005
						],
						[
							-80.17486799999995,
							26.145863000000077
						],
						[
							-80.17499611299992,
							26.145864181000036
						],
						[
							-80.17500311099991,
							26.145968174000075
						],
						[
							-80.1749278659999,
							26.14597105300004
						],
						[
							-80.17453529399997,
							26.146004041000083
						],
						[
							-80.17415658899995,
							26.145996963000073
						],
						[
							-80.17417875399991,
							26.146252471000082
						],
						[
							-80.17418676599993,
							26.146697130000064
						],
						[
							-80.17419377599992,
							26.14689442200006
						],
						[
							-80.17417875199993,
							26.14707569400008
						],
						[
							-80.17407971699993,
							26.14736427100007
						],
						[
							-80.16990037399995,
							26.147435166000037
						],
						[
							-80.16997151399994,
							26.147242939000083
						],
						[
							-80.17011272199994,
							26.146797279000054
						],
						[
							-80.17018382799996,
							26.14624445800007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Dillard Park",
				"RegionID": "268949"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.32491541522319,
					28.52436133867012,
					-81.31745916955315,
					28.531558009425538
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.31868999787027,
							28.531485032140786
						],
						[
							-81.31869026317023,
							28.530218891044818
						],
						[
							-81.31745916955315,
							28.53021915814352
						],
						[
							-81.31749621082886,
							28.526057728914665
						],
						[
							-81.31771382697494,
							28.526021925106036
						],
						[
							-81.31771366239903,
							28.52444537401849
						],
						[
							-81.31842875651193,
							28.524400486158036
						],
						[
							-81.31863704938644,
							28.524387377640124
						],
						[
							-81.3198348258204,
							28.524371353520223
						],
						[
							-81.32120185376074,
							28.52436133867012
						],
						[
							-81.3222253586725,
							28.524401434043455
						],
						[
							-81.32325690082527,
							28.524385373950643
						],
						[
							-81.32367852637493,
							28.52438337116044
						],
						[
							-81.32423735429204,
							28.524376360045906
						],
						[
							-81.3248066997804,
							28.52436829402668
						],
						[
							-81.32491541522319,
							28.531558009425538
						],
						[
							-81.32064395304464,
							28.531506880270136
						],
						[
							-81.31868999787027,
							28.531485032140786
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Dover Manor",
				"RegionID": "268956"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.76177598499993,
					30.19684397500004,
					-81.7369928199999,
					30.219099011000086
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.7369928199999,
							30.21909699300005
						],
						[
							-81.7370509079999,
							30.217760010000067
						],
						[
							-81.7370759069999,
							30.217179010000052
						],
						[
							-81.73710490799994,
							30.216636010000062
						],
						[
							-81.73714690799994,
							30.21585401000004
						],
						[
							-81.73720490799991,
							30.215284010000065
						],
						[
							-81.7372249089999,
							30.21492001000007
						],
						[
							-81.73726390799993,
							30.214201011000057
						],
						[
							-81.73732190899995,
							30.213123010000064
						],
						[
							-81.7373429079999,
							30.21297501100008
						],
						[
							-81.73754990799995,
							30.211952010000065
						],
						[
							-81.73769190799993,
							30.211524010000065
						],
						[
							-81.73784790799994,
							30.211120011000048
						],
						[
							-81.73797190699992,
							30.21082801000006
						],
						[
							-81.73801390699992,
							30.210727011000074
						],
						[
							-81.73812890799991,
							30.210441010000068
						],
						[
							-81.7386519069999,
							30.20919801000008
						],
						[
							-81.73880090799992,
							30.208855011000082
						],
						[
							-81.73902290799992,
							30.20828001100006
						],
						[
							-81.7391259069999,
							30.207999011000087
						],
						[
							-81.73924390699995,
							30.207718010000065
						],
						[
							-81.73927490699992,
							30.207629010000062
						],
						[
							-81.7393479079999,
							30.207424010000068
						],
						[
							-81.73948090699992,
							30.206849010000045
						],
						[
							-81.7395939079999,
							30.20600201000008
						],
						[
							-81.7395989069999,
							30.20596701000005
						],
						[
							-81.73959890799995,
							30.205392010000086
						],
						[
							-81.73958490799993,
							30.205098010000086
						],
						[
							-81.73958490799993,
							30.204804011000082
						],
						[
							-81.73961390699992,
							30.204382011000067
						],
						[
							-81.73961390799991,
							30.203871010000057
						],
						[
							-81.73961390799991,
							30.203271010000037
						],
						[
							-81.73961390799991,
							30.202978010000038
						],
						[
							-81.73961190799992,
							30.202524011000033
						],
						[
							-81.73959190799991,
							30.20111701100006
						],
						[
							-81.73958690799992,
							30.200797011000077
						],
						[
							-81.73960690799993,
							30.199607011000072
						],
						[
							-81.73958390799993,
							30.198131011000044
						],
						[
							-81.73956490799992,
							30.197722010000064
						],
						[
							-81.73954390799992,
							30.19720501000006
						],
						[
							-81.7395489079999,
							30.196899011000085
						],
						[
							-81.73954796699991,
							30.19684397500004
						],
						[
							-81.7398999099999,
							30.196977012000048
						],
						[
							-81.7404649099999,
							30.197190012000082
						],
						[
							-81.7440689089999,
							30.198550011000066
						],
						[
							-81.74653190999993,
							30.199501011000052
						],
						[
							-81.74937190899993,
							30.200537011000055
						],
						[
							-81.75044390999994,
							30.200973011000084
						],
						[
							-81.7512279099999,
							30.201332011000094
						],
						[
							-81.75209590899993,
							30.201793012000056
						],
						[
							-81.7527749109999,
							30.202218012000063
						],
						[
							-81.75360690999992,
							30.202806012000053
						],
						[
							-81.75430190899993,
							30.20337101100006
						],
						[
							-81.75448390999992,
							30.203525011000067
						],
						[
							-81.75510703399993,
							30.20408024500006
						],
						[
							-81.75524484499994,
							30.204203185000043
						],
						[
							-81.75561797799992,
							30.20418484100008
						],
						[
							-81.75636190799992,
							30.20496001100008
						],
						[
							-81.75660990699993,
							30.20526201000007
						],
						[
							-81.75687890699993,
							30.205569010000094
						],
						[
							-81.75713490699991,
							30.205883010000036
						],
						[
							-81.75761190799994,
							30.20651101100009
						],
						[
							-81.75820690799992,
							30.20740801100004
						],
						[
							-81.7583939079999,
							30.207722011000048
						],
						[
							-81.75855690799995,
							30.208039011000043
						],
						[
							-81.75873590799995,
							30.208353011000042
						],
						[
							-81.7588919069999,
							30.208666010000062
						],
						[
							-81.75918890799994,
							30.209294011000054
						],
						[
							-81.75953890799991,
							30.21018801000008
						],
						[
							-81.75963190699991,
							30.210493011000036
						],
						[
							-81.7597249079999,
							30.21075601100006
						],
						[
							-81.75988590799994,
							30.21131901100006
						],
						[
							-81.76019990799996,
							30.212527010000088
						],
						[
							-81.76050590699992,
							30.213702010000077
						],
						[
							-81.76057390799993,
							30.21401201100008
						],
						[
							-81.7607349079999,
							30.21463601100004
						],
						[
							-81.76079590799992,
							30.21494501100005
						],
						[
							-81.7610319069999,
							30.215881011000075
						],
						[
							-81.76142090699994,
							30.217453010000042
						],
						[
							-81.76177598499993,
							30.218835954000046
						],
						[
							-81.76147490799991,
							30.218814011000063
						],
						[
							-81.76132990699995,
							30.21881601000007
						],
						[
							-81.76063490799993,
							30.21881501000007
						],
						[
							-81.76008590799995,
							30.21881101000008
						],
						[
							-81.75450090699991,
							30.21888901000006
						],
						[
							-81.75389090699991,
							30.21888801000006
						],
						[
							-81.75173990799993,
							30.21891801000004
						],
						[
							-81.7512819069999,
							30.21892201100008
						],
						[
							-81.75049490799995,
							30.218935010000056
						],
						[
							-81.7499309079999,
							30.21894501000008
						],
						[
							-81.74780990699992,
							30.218967010000085
						],
						[
							-81.74469790799992,
							30.219002010000054
						],
						[
							-81.74297090699991,
							30.219022010000064
						],
						[
							-81.74207290699991,
							30.21903201000004
						],
						[
							-81.74079890799993,
							30.219051010000044
						],
						[
							-81.73998290799994,
							30.219059011000073
						],
						[
							-81.73949390799993,
							30.21906701000006
						],
						[
							-81.73747290799992,
							30.219099011000086
						],
						[
							-81.7369928199999,
							30.21909699300005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Duclay",
				"RegionID": "268965"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.64660065099991,
					30.326800620000085,
					-81.62074324899993,
					30.345534000000047
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.62077216499995,
							30.34546433900005
						],
						[
							-81.62086207999994,
							30.34533592700006
						],
						[
							-81.62090581399991,
							30.34528749100008
						],
						[
							-81.6212157789999,
							30.34496828500005
						],
						[
							-81.62374627799994,
							30.34112950000008
						],
						[
							-81.6243025469999,
							30.339370792000064
						],
						[
							-81.62431491399991,
							30.33933441300007
						],
						[
							-81.62438295999993,
							30.339189257000047
						],
						[
							-81.6246487549999,
							30.338737177000038
						],
						[
							-81.62473507899995,
							30.338614927000037
						],
						[
							-81.62484592699991,
							30.33850408000006
						],
						[
							-81.62497433899995,
							30.338414165000074
						],
						[
							-81.62511641399993,
							30.338347914000057
						],
						[
							-81.62526783399994,
							30.33830734100007
						],
						[
							-81.62542399999995,
							30.33829367800007
						],
						[
							-81.62554529099994,
							30.338301895000086
						],
						[
							-81.62561788799991,
							30.338311777000058
						],
						[
							-81.62631227199995,
							30.33481828100008
						],
						[
							-81.6264864069999,
							30.332801308000057
						],
						[
							-81.62665806099994,
							30.33101508700008
						],
						[
							-81.62563901399994,
							30.33011059800009
						],
						[
							-81.62555388099992,
							30.330024084000062
						],
						[
							-81.62513548099992,
							30.32953707800004
						],
						[
							-81.62504216499991,
							30.32940466100007
						],
						[
							-81.62497591399995,
							30.329262586000088
						],
						[
							-81.62493534099991,
							30.329111165000082
						],
						[
							-81.62492167799992,
							30.32895500000006
						],
						[
							-81.62493535199991,
							30.328798772000084
						],
						[
							-81.62501636299993,
							30.328339711000066
						],
						[
							-81.62502275599991,
							30.328307029000086
						],
						[
							-81.6250947559999,
							30.32797202900008
						],
						[
							-81.6251289139999,
							30.32785341400006
						],
						[
							-81.62519516399993,
							30.327711339000075
						],
						[
							-81.62528507899992,
							30.327582927000037
						],
						[
							-81.62539592699994,
							30.327472079000074
						],
						[
							-81.62543882999995,
							30.327438246000046
						],
						[
							-81.62570082999993,
							30.32724424600008
						],
						[
							-81.62574147999993,
							30.327215847000048
						],
						[
							-81.62637219099992,
							30.326800620000085
						],
						[
							-81.62715315899993,
							30.327363191000078
						],
						[
							-81.63016998499995,
							30.327363465000072
						],
						[
							-81.63345918099992,
							30.327363465000072
						],
						[
							-81.6361088079999,
							30.32736346700006
						],
						[
							-81.64660065099991,
							30.330058362000045
						],
						[
							-81.6464179059999,
							30.33052200800006
						],
						[
							-81.64608185599992,
							30.331201990000068
						],
						[
							-81.64594490499991,
							30.331994009000084
						],
						[
							-81.64574590799992,
							30.332763011000054
						],
						[
							-81.6457629059999,
							30.333521009000034
						],
						[
							-81.64576390499991,
							30.334325008000068
						],
						[
							-81.64569790599995,
							30.33483800800008
						],
						[
							-81.64550790499993,
							30.335823008000094
						],
						[
							-81.64531590699994,
							30.336424009000044
						],
						[
							-81.6451769059999,
							30.337430008000066
						],
						[
							-81.6450497589999,
							30.338337117000034
						],
						[
							-81.64538804099993,
							30.33837487400007
						],
						[
							-81.64552290599994,
							30.339719008000092
						],
						[
							-81.64553190599992,
							30.342448008000076
						],
						[
							-81.64557990599991,
							30.343968008000047
						],
						[
							-81.64559096199993,
							30.34505200500007
						],
						[
							-81.64536690599994,
							30.345048009000042
						],
						[
							-81.6450479049999,
							30.34504200700007
						],
						[
							-81.64431290599993,
							30.34505600800009
						],
						[
							-81.6438939059999,
							30.34505600800009
						],
						[
							-81.64327590599993,
							30.34506000800008
						],
						[
							-81.64311990599992,
							30.345068009000045
						],
						[
							-81.6429749049999,
							30.345078008000087
						],
						[
							-81.6422959059999,
							30.345085009000062
						],
						[
							-81.64113390599995,
							30.345236008000086
						],
						[
							-81.64100490599992,
							30.34524100900006
						],
						[
							-81.63942690499994,
							30.345274008000047
						],
						[
							-81.63884390499993,
							30.34528400800008
						],
						[
							-81.63703690599993,
							30.345303008000084
						],
						[
							-81.63682790599995,
							30.345306008000076
						],
						[
							-81.63679190699992,
							30.34530595500007
						],
						[
							-81.63674590599993,
							30.345307008000074
						],
						[
							-81.63603990599995,
							30.345308008000075
						],
						[
							-81.63524590599991,
							30.34530400800008
						],
						[
							-81.6349109059999,
							30.345306008000076
						],
						[
							-81.63459790699994,
							30.34529700800005
						],
						[
							-81.63445290499993,
							30.34530100900008
						],
						[
							-81.63365890599994,
							30.345299009000087
						],
						[
							-81.6328659049999,
							30.34529300800006
						],
						[
							-81.63207990599994,
							30.345291008000064
						],
						[
							-81.63128690499991,
							30.34528900800007
						],
						[
							-81.63050790599993,
							30.34528400800008
						],
						[
							-81.62974490599994,
							30.34528400800008
						],
						[
							-81.62898290599992,
							30.34528000900008
						],
						[
							-81.62843990499994,
							30.34528400800008
						],
						[
							-81.6281327879999,
							30.34528086200004
						],
						[
							-81.62811203099994,
							30.34537815300007
						],
						[
							-81.62793690599995,
							30.345389008000044
						],
						[
							-81.62716790699994,
							30.34535300800007
						],
						[
							-81.62667790599994,
							30.345362008000052
						],
						[
							-81.62589690599992,
							30.345375008000076
						],
						[
							-81.62540090499995,
							30.345384008000057
						],
						[
							-81.62479690499993,
							30.34535900900005
						],
						[
							-81.62436990599991,
							30.34535900900005
						],
						[
							-81.62214688199992,
							30.345431877000067
						],
						[
							-81.62191999999993,
							30.345534000000047
						],
						[
							-81.62074324899993,
							30.345526349000064
						],
						[
							-81.62077216499995,
							30.34546433900005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "East Jacksonville",
				"RegionID": "268972"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.24402444828864,
					28.414559223444364,
					-81.22976999987065,
					28.432850556681394
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.23049500001574,
							28.417594000021424
						],
						[
							-81.23220100041553,
							28.41468299983324
						],
						[
							-81.23432500029853,
							28.414690000155957
						],
						[
							-81.24281000022297,
							28.414716999601836
						],
						[
							-81.24278900015426,
							28.41458399976634
						],
						[
							-81.24292300003594,
							28.414597000365603
						],
						[
							-81.24292673492036,
							28.414559223444364
						],
						[
							-81.24302491390627,
							28.41457048385555
						],
						[
							-81.24304894918689,
							28.41579733267266
						],
						[
							-81.24310503180791,
							28.416311092864916
						],
						[
							-81.24325925924069,
							28.416910983825915
						],
						[
							-81.24343652280727,
							28.417412727277323
						],
						[
							-81.24365384577428,
							28.41792348553257
						],
						[
							-81.24369791165438,
							28.418027638714733
						],
						[
							-81.2438462818028,
							28.418267067916627
						],
						[
							-81.24402444828864,
							28.432850556681394
						],
						[
							-81.2396919698084,
							28.43028481791142
						],
						[
							-81.23591036114468,
							28.42862135094707
						],
						[
							-81.2334897819435,
							28.428015401253532
						],
						[
							-81.2309179583607,
							28.427713003321863
						],
						[
							-81.23066214890744,
							28.427712729928018
						],
						[
							-81.22976999987065,
							28.419557999723587
						],
						[
							-81.23049500001574,
							28.417594000021424
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "East Park",
				"RegionID": "268974"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.2008689999999,
					26.032342759000073,
					-80.17535072699991,
					26.04966600000006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.1992239999999,
							26.046781000000067
						],
						[
							-80.19868799999995,
							26.046799000000078
						],
						[
							-80.1967689999999,
							26.04686600000008
						],
						[
							-80.19667299999992,
							26.04686600000008
						],
						[
							-80.19669299999993,
							26.047376000000042
						],
						[
							-80.19619599999993,
							26.047370000000058
						],
						[
							-80.19601699999993,
							26.047333000000037
						],
						[
							-80.19598999999994,
							26.04688400000009
						],
						[
							-80.19516899999991,
							26.046966000000058
						],
						[
							-80.19466499999993,
							26.046966000000058
						],
						[
							-80.19426999999992,
							26.046966000000058
						],
						[
							-80.1928089999999,
							26.046966000000058
						],
						[
							-80.19154586099995,
							26.047188298000037
						],
						[
							-80.18809548799993,
							26.047273844000074
						],
						[
							-80.1880408529999,
							26.04727519900007
						],
						[
							-80.18735865699995,
							26.047292113000083
						],
						[
							-80.18609457899993,
							26.047317871000075
						],
						[
							-80.18206399999991,
							26.04740000000004
						],
						[
							-80.18140399999993,
							26.04743400000007
						],
						[
							-80.17906799999992,
							26.047566000000074
						],
						[
							-80.1781749999999,
							26.047598000000054
						],
						[
							-80.17635427099992,
							26.047707373000037
						],
						[
							-80.17631966599993,
							26.045388839000054
						],
						[
							-80.17621585099994,
							26.04289728000009
						],
						[
							-80.1760774309999,
							26.040959401000066
						],
						[
							-80.1760774309999,
							26.040371116000074
						],
						[
							-80.17597361599991,
							26.037879557000053
						],
						[
							-80.17580059099993,
							26.036218517000066
						],
						[
							-80.1754891459999,
							26.03479971300004
						],
						[
							-80.17535072699991,
							26.033138673000053
						],
						[
							-80.18414039299995,
							26.032827228000087
						],
						[
							-80.19012705599994,
							26.032758018000038
						],
						[
							-80.19459109999993,
							26.03265420300005
						],
						[
							-80.19870909299993,
							26.032584993000057
						],
						[
							-80.20033552799993,
							26.032342759000073
						],
						[
							-80.20037013299992,
							26.033242488000045
						],
						[
							-80.20043934299991,
							26.03514576300006
						],
						[
							-80.20047394799991,
							26.037568112000088
						],
						[
							-80.20061236799995,
							26.039955856000063
						],
						[
							-80.20064697299995,
							26.04237820500009
						],
						[
							-80.20071618299994,
							26.044869764000058
						],
						[
							-80.2008689999999,
							26.04686600000008
						],
						[
							-80.19991899999991,
							26.04684800000007
						],
						[
							-80.19982399999992,
							26.046779000000072
						],
						[
							-80.1998319999999,
							26.047089000000085
						],
						[
							-80.1998979999999,
							26.04960900000009
						],
						[
							-80.19932799999992,
							26.04966600000006
						],
						[
							-80.19923399999993,
							26.04712100000006
						],
						[
							-80.1992229999999,
							26.046831000000054
						],
						[
							-80.1992239999999,
							26.046781000000067
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Hollywood",
				"Name": "Emerald Hills",
				"RegionID": "268979"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.45908447388679,
					28.46804487594358,
					-81.42644191611043,
					28.50148162847638
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.43238973085197,
							28.494668267823112
						],
						[
							-81.43346935220552,
							28.49348554783077
						],
						[
							-81.43357951588122,
							28.493353350960252
						],
						[
							-81.43597506881501,
							28.490469074993033
						],
						[
							-81.43687940893807,
							28.489481609752612
						],
						[
							-81.4369435042283,
							28.489409502882094
						],
						[
							-81.43720088596245,
							28.489143108145424
						],
						[
							-81.43747429220605,
							28.488825637860874
						],
						[
							-81.43861097795033,
							28.48777207488499
						],
						[
							-81.43933805618946,
							28.487157162216473
						],
						[
							-81.43974365790434,
							28.48681365389673
						],
						[
							-81.44095345194147,
							28.485823184788575
						],
						[
							-81.4411287109303,
							28.485686983077688
						],
						[
							-81.44133000985387,
							28.485506714976797
						],
						[
							-81.44216825319101,
							28.48481869401553
						],
						[
							-81.44261709220817,
							28.48446124595007
						],
						[
							-81.44246181808643,
							28.472087681921213
						],
						[
							-81.44232348377949,
							28.47208881499405
						],
						[
							-81.442266398097,
							28.472090818838787
						],
						[
							-81.44217626477139,
							28.472090817889143
						],
						[
							-81.4419559388697,
							28.47209181981142
						],
						[
							-81.44149024810454,
							28.472094824128927
						],
						[
							-81.44069006012289,
							28.472099830891754
						],
						[
							-81.44038761292565,
							28.47210083376385
						],
						[
							-81.43991577997569,
							28.47210496975478
						],
						[
							-81.43992266400096,
							28.471981258429327
						],
						[
							-81.44028899999991,
							28.471982000000047
						],
						[
							-81.44028899999991,
							28.471886000000094
						],
						[
							-81.4401449999999,
							28.47188500000001
						],
						[
							-81.43992813753538,
							28.47188500000001
						],
						[
							-81.43993293001112,
							28.471805518828145
						],
						[
							-81.44014231813549,
							28.46804487594358
						],
						[
							-81.440423665886,
							28.468281168126733
						],
						[
							-81.44141416813164,
							28.46915764585233
						],
						[
							-81.44145219179933,
							28.469075346023867
						],
						[
							-81.4414892049977,
							28.468977034930912
						],
						[
							-81.44198498122257,
							28.4694108437635
						],
						[
							-81.44294540510585,
							28.47036726280631
						],
						[
							-81.44386677311057,
							28.47134671506694
						],
						[
							-81.44418724776281,
							28.47172828019186
						],
						[
							-81.44437853081168,
							28.471976648923306
						],
						[
							-81.44444362707463,
							28.472059773090944
						],
						[
							-81.4444656612191,
							28.472095825101743
						],
						[
							-81.44512163311076,
							28.47292205111877
						],
						[
							-81.44519273900863,
							28.47301118302187
						],
						[
							-81.44556228681334,
							28.473514931041883
						],
						[
							-81.44596388223817,
							28.474057735890238
						],
						[
							-81.44608305891647,
							28.47421997608627
						],
						[
							-81.44618420813978,
							28.474361185009762
						],
						[
							-81.44635063690717,
							28.47461360591367
						],
						[
							-81.44632524187932,
							28.47462754515952
						],
						[
							-81.44636064378534,
							28.47467269304175
						],
						[
							-81.4463382639709,
							28.474681611829947
						],
						[
							-81.44696236292653,
							28.475521906843962
						],
						[
							-81.44819619210394,
							28.477087227970546
						],
						[
							-81.44868091219627,
							28.47773218586386
						],
						[
							-81.44891025110057,
							28.478083706213578
						],
						[
							-81.44918866505672,
							28.478472282895876
						],
						[
							-81.44930683886321,
							28.478626511061936
						],
						[
							-81.44948209975132,
							28.478868870158287
						],
						[
							-81.44964634379208,
							28.479087195064352
						],
						[
							-81.45028729494548,
							28.48015577922826
						],
						[
							-81.45073495780603,
							28.480770691896602
						],
						[
							-81.45217909985926,
							28.482861791889317
						],
						[
							-81.45222516724482,
							28.48292588717928
						],
						[
							-81.45226923318488,
							28.482983973834767
						],
						[
							-81.45346400508443,
							28.48460938401171
						],
						[
							-81.45443945205481,
							28.485898295026963
						],
						[
							-81.45526066990978,
							28.4868446991447
						],
						[
							-81.45560017388902,
							28.487191213231636
						],
						[
							-81.45638734022896,
							28.487934315081024
						],
						[
							-81.45730970875682,
							28.488688432828116
						],
						[
							-81.45875685417775,
							28.489705942843738
						],
						[
							-81.45890607703058,
							28.489805089171863
						],
						[
							-81.45904828088958,
							28.48989972402542
						],
						[
							-81.45904428208632,
							28.490010394835355
						],
						[
							-81.45907432591189,
							28.49213754778834
						],
						[
							-81.45908434083695,
							28.492603239952988
						],
						[
							-81.45908434083695,
							28.492961771859907
						],
						[
							-81.45908333891458,
							28.493831059995426
						],
						[
							-81.45908434083695,
							28.493906172132913
						],
						[
							-81.45908447388679,
							28.493983415017535
						],
						[
							-81.45894613483146,
							28.49398729295586
						],
						[
							-81.4588169427785,
							28.493991298246005
						],
						[
							-81.45784350105198,
							28.49402334496666
						],
						[
							-81.45778241007935,
							28.494025347861754
						],
						[
							-81.45768426377414,
							28.494028351229442
						],
						[
							-81.45626502523366,
							28.494079553229593
						],
						[
							-81.45627130286755,
							28.494017211778484
						],
						[
							-81.45553107088641,
							28.494057396931286
						],
						[
							-81.4553758407979,
							28.494064406089162
						],
						[
							-81.45473876093517,
							28.4940993302251
						],
						[
							-81.454890172842,
							28.501067792948223
						],
						[
							-81.43081040795302,
							28.501382259838973
						],
						[
							-81.42949646082485,
							28.50141230316449
						],
						[
							-81.42644191611043,
							28.50148162847638
						],
						[
							-81.42731822897511,
							28.500489936086307
						],
						[
							-81.42745543305814,
							28.500354734898284
						],
						[
							-81.42870028003261,
							28.498904584159952
						],
						[
							-81.42904579124746,
							28.498511000765276
						],
						[
							-81.43238973085197,
							28.494668267823112
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Florida Center North",
				"RegionID": "268988"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.49878490299996,
					30.34679629100009,
					-81.46233297499992,
					30.39190232200008
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-81.46340449999991,
								30.376135583000064
							],
							[
								-81.46346973299991,
								30.37613370300005
							],
							[
								-81.46353492999992,
								30.376136559000088
							],
							[
								-81.46359974899991,
								30.376144136000047
							],
							[
								-81.46384674799992,
								30.37618213600007
							],
							[
								-81.4639135939999,
								30.376195026000058
							],
							[
								-81.4639792719999,
								30.376212937000048
							],
							[
								-81.46404340799995,
								30.376235764000057
							],
							[
								-81.4641056339999,
								30.376263377000047
							],
							[
								-81.4680066329999,
								30.37817437700005
							],
							[
								-81.46810515399994,
								30.378230607000035
							],
							[
								-81.46939915399992,
								30.379081606000057
							],
							[
								-81.46945326299993,
								30.379120127000075
							],
							[
								-81.46950438099992,
								30.379162535000034
							],
							[
								-81.46955222999992,
								30.379208601000073
							],
							[
								-81.4695965489999,
								30.379258073000077
							],
							[
								-81.46963709499994,
								30.37931068000006
							],
							[
								-81.4711160949999,
								30.38138368100005
							],
							[
								-81.47116279699992,
								30.381456271000047
							],
							[
								-81.47128581599992,
								30.381669305000056
							],
							[
								-81.47135303099992,
								30.381814034000055
							],
							[
								-81.47209397599994,
								30.383889655000075
							],
							[
								-81.47211482999995,
								30.38395609400004
							],
							[
								-81.47213048099991,
								30.38402394800005
							],
							[
								-81.47214083499995,
								30.38409280900004
							],
							[
								-81.47214583099992,
								30.384162266000093
							],
							[
								-81.47214543699994,
								30.38423190000009
							],
							[
								-81.47213965599991,
								30.384301295000057
							],
							[
								-81.47212852399993,
								30.38437003500007
							],
							[
								-81.47188152299992,
								30.385593035000056
							],
							[
								-81.47186433999991,
								30.385663385000043
							],
							[
								-81.47184155299993,
								30.385732124000075
							],
							[
								-81.47181330899991,
								30.38579880700007
							],
							[
								-81.47177979099992,
								30.385863001000075
							],
							[
								-81.47174121699993,
								30.38592429000005
							],
							[
								-81.47120321699992,
								30.386707291000054
							],
							[
								-81.47115092099995,
								30.386776073000078
							],
							[
								-81.47104007299993,
								30.386886920000055
							],
							[
								-81.47091166099995,
								30.38697683600009
							],
							[
								-81.4707695859999,
								30.38704308600006
							],
							[
								-81.47061816599995,
								30.387083659000044
							],
							[
								-81.47046199999994,
								30.387097322000045
							],
							[
								-81.47030583399993,
								30.387083659000044
							],
							[
								-81.47022871799993,
								30.38706654000003
							],
							[
								-81.47015340299993,
								30.38704271900008
							],
							[
								-81.47008046799994,
								30.387012380000044
							],
							[
								-81.4700104769999,
								30.386975758000062
							],
							[
								-81.4699439709999,
								30.386933133000067
							],
							[
								-81.46988146199993,
								30.386884837000082
							],
							[
								-81.46513950799994,
								30.382847522000073
							],
							[
								-81.46428052599992,
								30.38264800100006
							],
							[
								-81.4641764129999,
								30.38261708600004
							],
							[
								-81.46403433899991,
								30.382550836000064
							],
							[
								-81.46390592699993,
								30.382460921000078
							],
							[
								-81.46379507899991,
								30.382350073000058
							],
							[
								-81.46370516399992,
								30.382221661000077
							],
							[
								-81.46363891299991,
								30.38207958600009
							],
							[
								-81.4636056729999,
								30.381965191000067
							],
							[
								-81.4628755409999,
								30.37864570300007
							],
							[
								-81.46246410099991,
								30.377820144000058
							],
							[
								-81.46242391399994,
								30.377726586000055
							],
							[
								-81.46240166399991,
								30.377656714000068
							],
							[
								-81.46236466399995,
								30.377521714000068
							],
							[
								-81.46234833999995,
								30.377451105000038
							],
							[
								-81.46233775399992,
								30.377379411000053
							],
							[
								-81.46233297499992,
								30.377307097000084
							],
							[
								-81.46233403399992,
								30.377234634000043
							],
							[
								-81.46234092499994,
								30.377162491000036
							],
							[
								-81.46235592499994,
								30.377052491000086
							],
							[
								-81.46236851099991,
								30.376981551000085
							],
							[
								-81.46238673599993,
								30.376911846000038
							],
							[
								-81.46241048199994,
								30.37684382300006
							],
							[
								-81.4624395969999,
								30.376777919000066
							],
							[
								-81.46249159699995,
								30.376671919000046
							],
							[
								-81.4625201639999,
								30.37661833900006
							],
							[
								-81.46261007899996,
								30.376489927000083
							],
							[
								-81.4627209269999,
								30.376379079000063
							],
							[
								-81.46284933899994,
								30.376289164000067
							],
							[
								-81.46299141399993,
								30.376222914000042
							],
							[
								-81.46311129999992,
								30.376188484000064
							],
							[
								-81.4632752999999,
								30.376153484000042
							],
							[
								-81.4633395749999,
								30.376142188000074
							],
							[
								-81.46340449999991,
								30.376135583000064
							]
						]
					],
					[
						[
							[
								-81.47353204199993,
								30.38625655000004
							],
							[
								-81.47402504199994,
								30.38569855000009
							],
							[
								-81.4740700779999,
								30.385651164000084
							],
							[
								-81.47433847699995,
								30.38538857500004
							],
							[
								-81.47442658299991,
								30.384977796000044
							],
							[
								-81.47451361099992,
								30.384223873000053
							],
							[
								-81.47452649799993,
								30.38415640800008
							],
							[
								-81.47392974199994,
								30.383298571000072
							],
							[
								-81.47390107299992,
								30.383254685000054
							],
							[
								-81.47245207399995,
								30.380888685000063
							],
							[
								-81.47244016499991,
								30.38086866100008
							],
							[
								-81.47237391399995,
								30.38072658600004
							],
							[
								-81.47233334099991,
								30.380575165000042
							],
							[
								-81.4723196779999,
								30.38041900000007
							],
							[
								-81.47233334099991,
								30.380262834000067
							],
							[
								-81.47237391399995,
								30.38011141300007
							],
							[
								-81.4724012129999,
								30.380052870000043
							],
							[
								-81.46964500399991,
								30.377618686000062
							],
							[
								-81.4690774309999,
								30.377227097000063
							],
							[
								-81.46659751199991,
								30.37555680700007
							],
							[
								-81.46610094499994,
								30.375299657000088
							],
							[
								-81.46390015799994,
								30.37463266300006
							],
							[
								-81.46385341399991,
								30.37461708600006
							],
							[
								-81.46371133899993,
								30.374550836000086
							],
							[
								-81.46358292699995,
								30.374460921000033
							],
							[
								-81.46347207899993,
								30.374350073000073
							],
							[
								-81.46338216399994,
								30.374221661000036
							],
							[
								-81.46332134999994,
								30.374094130000064
							],
							[
								-81.46325763199992,
								30.373927858000055
							],
							[
								-81.46321434099991,
								30.37376916500006
							],
							[
								-81.46320544399993,
								30.373667474000058
							],
							[
								-81.46326690799992,
								30.373472597000045
							],
							[
								-81.4634817729999,
								30.37317715800009
							],
							[
								-81.46405922299994,
								30.372922005000074
							],
							[
								-81.46506640199993,
								30.372733998000058
							],
							[
								-81.46604672399991,
								30.372572850000036
							],
							[
								-81.4669196129999,
								30.372344556000087
							],
							[
								-81.46737620199991,
								30.372129691000055
							],
							[
								-81.46803422599993,
								30.371605957000043
							],
							[
								-81.46867882099991,
								30.371001649000053
							],
							[
								-81.46909512199994,
								30.37042419900007
							],
							[
								-81.4698874369999,
								30.369712459000084
							],
							[
								-81.46979343299995,
								30.36934987400008
							],
							[
								-81.46961885499991,
								30.36896043100006
							],
							[
								-81.4691891249999,
								30.368597846000057
							],
							[
								-81.4686519629999,
								30.368396410000063
							],
							[
								-81.4680879419999,
								30.368114400000085
							],
							[
								-81.46773878599993,
								30.367859248000055
							],
							[
								-81.46728219799991,
								30.367362372000063
							],
							[
								-81.46663760299992,
								30.36654320000008
							],
							[
								-81.46690956799996,
								30.366342488000043
							],
							[
								-81.46708410999992,
								30.366168564000077
							],
							[
								-81.46693933499995,
								30.364866384000038
							],
							[
								-81.46592634599995,
								30.363564370000063
							],
							[
								-81.46621579999993,
								30.36211752500009
							],
							[
								-81.46751815699992,
								30.360381421000056
							],
							[
								-81.46546103199995,
								30.35847193500007
							],
							[
								-81.46577704799995,
								30.35850009600006
							],
							[
								-81.4637562929999,
								30.355042891000036
							],
							[
								-81.46361169699992,
								30.35243868400005
							],
							[
								-81.46332216699994,
								30.349689770000055
							],
							[
								-81.46534773199994,
								30.347374845000047
							],
							[
								-81.46853070299994,
								30.34679629100009
							],
							[
								-81.47200295599993,
								30.346940916000055
							],
							[
								-81.4756199979999,
								30.347953567000044
							],
							[
								-81.47619845699995,
								30.34954521400004
							],
							[
								-81.47807937599993,
								30.351425946000063
							],
							[
								-81.48082837499993,
								30.353017281000064
							],
							[
								-81.48140711699995,
								30.35533225000006
							],
							[
								-81.48010495799991,
								30.35750250400008
							],
							[
								-81.47637180399994,
								30.358997030000072
							],
							[
								-81.47693892099994,
								30.35902295900007
							],
							[
								-81.47707689799995,
								30.35906206500005
							],
							[
								-81.47781491199993,
								30.359087013000075
							],
							[
								-81.47818791299994,
								30.359108013000082
							],
							[
								-81.4784559119999,
								30.359139012000075
							],
							[
								-81.4790189119999,
								30.359253012000067
							],
							[
								-81.47926091999994,
								30.359315112000047
							],
							[
								-81.47989491099992,
								30.35952201300006
							],
							[
								-81.48053290999991,
								30.35981901200006
							],
							[
								-81.48063290899995,
								30.359874013000084
							],
							[
								-81.4808449109999,
								30.360015012000076
							],
							[
								-81.48101190799991,
								30.36011201200006
							],
							[
								-81.48112990899995,
								30.360197013000064
							],
							[
								-81.48133791099991,
								30.36034701200009
							],
							[
								-81.48165090999993,
								30.360605013000054
							],
							[
								-81.48192490899993,
								30.360872013000062
							],
							[
								-81.48225590899995,
								30.361236013000056
							],
							[
								-81.48250790899995,
								30.361547013000063
							],
							[
								-81.48265190899991,
								30.361769012000085
							],
							[
								-81.48271190999992,
								30.361855013000078
							],
							[
								-81.48291790899992,
								30.362223013000065
							],
							[
								-81.4830089909999,
								30.362430972000084
							],
							[
								-81.4830779099999,
								30.36255601300007
							],
							[
								-81.48316890899991,
								30.36280301200009
							],
							[
								-81.48361590999991,
								30.363869013000052
							],
							[
								-81.48410690899993,
								30.36500101300004
							],
							[
								-81.4845069079999,
								30.36597601200009
							],
							[
								-81.48524091099995,
								30.367732012000086
							],
							[
								-81.48595790899992,
								30.36938001200008
							],
							[
								-81.48614491099994,
								30.36982301200004
							],
							[
								-81.4865949089999,
								30.370888013000073
							],
							[
								-81.4892649119999,
								30.377220012000066
							],
							[
								-81.48939490999993,
								30.37745101100006
							],
							[
								-81.48956290899991,
								30.37767001100008
							],
							[
								-81.48966990899993,
								30.377783012000066
							],
							[
								-81.48986790999993,
								30.377966011000066
							],
							[
								-81.49012790799992,
								30.378134012000086
							],
							[
								-81.4902559109999,
								30.378206012000078
							],
							[
								-81.4903779089999,
								30.37826001300004
							],
							[
								-81.49064490899991,
								30.378356012000044
							],
							[
								-81.4909199089999,
								30.378421012000043
							],
							[
								-81.49121690899995,
								30.378457012000073
							],
							[
								-81.49287191099995,
								30.378477012000076
							],
							[
								-81.49348190899991,
								30.37847501300007
							],
							[
								-81.49369590799995,
								30.37849101200004
							],
							[
								-81.4939029109999,
								30.37852001300007
							],
							[
								-81.49407890899994,
								30.37856101200003
							],
							[
								-81.49430790899993,
								30.37863801200007
							],
							[
								-81.49439990899992,
								30.378674013000083
							],
							[
								-81.49491090999993,
								30.378933012000058
							],
							[
								-81.4951549079999,
								30.379070013000046
							],
							[
								-81.49564391099995,
								30.37931301200007
							],
							[
								-81.4958949089999,
								30.379404012000062
							],
							[
								-81.49603291099993,
								30.379440012000092
							],
							[
								-81.4962159079999,
								30.379469013000065
							],
							[
								-81.49655191099993,
								30.37949901200005
							],
							[
								-81.49675790999993,
								30.37950101200005
							],
							[
								-81.49789690999995,
								30.37947901200005
							],
							[
								-81.49878490299996,
								30.379463957000045
							],
							[
								-81.4987759629999,
								30.379601021000045
							],
							[
								-81.49875502599991,
								30.379668078000066
							],
							[
								-81.49871491099992,
								30.379714010000047
							],
							[
								-81.49849191099992,
								30.379885013000038
							],
							[
								-81.49838191099991,
								30.379983013000075
							],
							[
								-81.49828791099992,
								30.38009601300007
							],
							[
								-81.49817890899993,
								30.380243012000054
							],
							[
								-81.49803290999995,
								30.380505013000064
							],
							[
								-81.49742090899991,
								30.381878012000076
							],
							[
								-81.49685691099997,
								30.383142012000068
							],
							[
								-81.49641390799991,
								30.384136012000052
							],
							[
								-81.49626190899994,
								30.384405012000062
							],
							[
								-81.49617790999991,
								30.38452101200005
							],
							[
								-81.4959559109999,
								30.384756012000082
							],
							[
								-81.49587990799995,
								30.384817012000042
							],
							[
								-81.49576291099993,
								30.384889012000087
							],
							[
								-81.49565090999994,
								30.38495801300007
							],
							[
								-81.49551390799991,
								30.38502901200007
							],
							[
								-81.49530790799992,
								30.38509901200007
							],
							[
								-81.49321690999994,
								30.385689012000057
							],
							[
								-81.49067690899994,
								30.38638901200005
							],
							[
								-81.49040190699992,
								30.38644201200009
							],
							[
								-81.49030290799993,
								30.38645401200006
							],
							[
								-81.49013490899995,
								30.386452012000063
							],
							[
								-81.49002790899993,
								30.386440012000037
							],
							[
								-81.48987590899992,
								30.38640001200008
							],
							[
								-81.48970790899995,
								30.386335012000078
							],
							[
								-81.48954790899995,
								30.38625101000008
							],
							[
								-81.48929591099994,
								30.38604501200007
							],
							[
								-81.48858590899994,
								30.38507501200007
							],
							[
								-81.48772391099993,
								30.383915012000045
							],
							[
								-81.48764790799993,
								30.383799012000058
							],
							[
								-81.48753394499994,
								30.383676972000046
							],
							[
								-81.4874649109999,
								30.38363601300006
							],
							[
								-81.4871139089999,
								30.383495013000076
							],
							[
								-81.48690790799992,
								30.383446013000086
							],
							[
								-81.4868009089999,
								30.383430013000066
							],
							[
								-81.48657191099994,
								30.383417013000038
							],
							[
								-81.48643490899991,
								30.383425012000092
							],
							[
								-81.48622090899994,
								30.38346101300004
							],
							[
								-81.48596990899995,
								30.383543012000075
							],
							[
								-81.48588591099991,
								30.383581012000036
							],
							[
								-81.48575590899992,
								30.38365701300006
							],
							[
								-81.48540491099993,
								30.383924013000073
							],
							[
								-81.48525191399995,
								30.384058012000082
							],
							[
								-81.48508490899992,
								30.384285012000078
							],
							[
								-81.48472590999995,
								30.38481501300004
							],
							[
								-81.48400958499991,
								30.385762430000057
							],
							[
								-81.48552295699994,
								30.385405828000046
							],
							[
								-81.48816691099995,
								30.38766301300007
							],
							[
								-81.4893919079999,
								30.38907101400008
							],
							[
								-81.48965599999991,
								30.38953500000008
							],
							[
								-81.49012380799992,
								30.39035689600007
							],
							[
								-81.48988073499993,
								30.390406922000068
							],
							[
								-81.48938315999993,
								30.390561724000065
							],
							[
								-81.48924777999991,
								30.39059261500006
							],
							[
								-81.4804717799999,
								30.391892615000074
							],
							[
								-81.4803399999999,
								30.39190232200008
							],
							[
								-81.48028980999993,
								30.391900921000058
							],
							[
								-81.47637180899994,
								30.39168192000005
							],
							[
								-81.47630454299991,
								30.39167561900007
							],
							[
								-81.47623793899993,
								30.391664285000047
							],
							[
								-81.47617237399993,
								30.391647983000045
							],
							[
								-81.47610821799992,
								30.391626805000048
							],
							[
								-81.47604583199991,
								30.391600871000037
							],
							[
								-81.47419783299995,
								30.39074987100008
							],
							[
								-81.47412932599991,
								30.39071469400005
							],
							[
								-81.47406407999995,
								30.39067378500005
							],
							[
								-81.47400257299995,
								30.39062744300008
							],
							[
								-81.47394525599994,
								30.390576010000075
							],
							[
								-81.47209725599993,
								30.388769009000047
							],
							[
								-81.4720370789999,
								30.388704073000042
							],
							[
								-81.47194716399991,
								30.38857566100006
							],
							[
								-81.47188091399994,
								30.388433586000076
							],
							[
								-81.4718403409999,
								30.388282165000078
							],
							[
								-81.4718266779999,
								30.388126000000057
							],
							[
								-81.4718403409999,
								30.387969834000046
							],
							[
								-81.47188091399994,
								30.387818413000048
							],
							[
								-81.47194716399991,
								30.387676339000052
							],
							[
								-81.4720370789999,
								30.38754792700007
							],
							[
								-81.47214792699992,
								30.38743707900005
							],
							[
								-81.4722763389999,
								30.387347164000058
							],
							[
								-81.47237232899995,
								30.38729914000004
							],
							[
								-81.47284597299996,
								30.387096549000034
							],
							[
								-81.47313898199991,
								30.38673571900006
							],
							[
								-81.47351010099993,
								30.38628234700008
							],
							[
								-81.47353204199993,
								30.38625655000004
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Fort Caroline Shores",
				"RegionID": "268990"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.61222692899992,
					30.261309869000062,
					-81.59160485699994,
					30.27277106500009
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.59202376299993,
							30.26666913300005
						],
						[
							-81.59202790699993,
							30.266505011000046
						],
						[
							-81.59203100199996,
							30.266397948000076
						],
						[
							-81.59209778799993,
							30.265409867000074
						],
						[
							-81.59231802099993,
							30.265433160000043
						],
						[
							-81.59240790699994,
							30.264937011000086
						],
						[
							-81.59244690799994,
							30.26462201000004
						],
						[
							-81.5924889069999,
							30.26439901100008
						],
						[
							-81.59253779199992,
							30.26418286300009
						],
						[
							-81.59305990699994,
							30.264206011000052
						],
						[
							-81.5943789079999,
							30.26424301100008
						],
						[
							-81.59583490799992,
							30.264302011000037
						],
						[
							-81.5959769079999,
							30.264302011000037
						],
						[
							-81.59666902399994,
							30.264330156000085
						],
						[
							-81.59682290699993,
							30.263567011000077
						],
						[
							-81.59699890699994,
							30.262569011000036
						],
						[
							-81.59715690699994,
							30.261783010000048
						],
						[
							-81.59717990799993,
							30.261565011000076
						],
						[
							-81.5971887959999,
							30.261309869000062
						],
						[
							-81.59987288399992,
							30.26189921000008
						],
						[
							-81.60188290399992,
							30.263269831000063
						],
						[
							-81.60371023199991,
							30.264457597000046
						],
						[
							-81.6048979979999,
							30.265371265000056
						],
						[
							-81.60599433999994,
							30.26655920500008
						],
						[
							-81.60956597199993,
							30.26559683100004
						],
						[
							-81.6098689069999,
							30.26601301000005
						],
						[
							-81.61022190799991,
							30.266526011000053
						],
						[
							-81.61174090799994,
							30.268665010000067
						],
						[
							-81.61200590699991,
							30.269016010000087
						],
						[
							-81.61222692899992,
							30.26932709900007
						],
						[
							-81.61210490799994,
							30.269389010000054
						],
						[
							-81.61202190799992,
							30.269433011000046
						],
						[
							-81.61169790699995,
							30.26960501000008
						],
						[
							-81.61127490699994,
							30.269840010000056
						],
						[
							-81.6109519069999,
							30.270015012000044
						],
						[
							-81.61077890799993,
							30.27016101100008
						],
						[
							-81.60953690799994,
							30.271441011000036
						],
						[
							-81.60879890799994,
							30.27220901000004
						],
						[
							-81.6082409789999,
							30.27277106500009
						],
						[
							-81.60790590699992,
							30.27231301000006
						],
						[
							-81.6077269079999,
							30.272069010000052
						],
						[
							-81.6071259069999,
							30.27124701100007
						],
						[
							-81.60698190699992,
							30.271073011000055
						],
						[
							-81.60686790699992,
							30.270963010000063
						],
						[
							-81.60673790699991,
							30.27085901100008
						],
						[
							-81.60656590799994,
							30.270755010000073
						],
						[
							-81.60641390799992,
							30.27067301100004
						],
						[
							-81.6062479069999,
							30.270598010000068
						],
						[
							-81.6059289079999,
							30.270499011000084
						],
						[
							-81.60568690799994,
							30.270459010000078
						],
						[
							-81.60541990799993,
							30.27044901100004
						],
						[
							-81.60499690699993,
							30.27042801100004
						],
						[
							-81.60443790799991,
							30.27040601000005
						],
						[
							-81.60408690799994,
							30.27039401100006
						],
						[
							-81.60353090799993,
							30.270368011000073
						],
						[
							-81.6031639069999,
							30.27035601000006
						],
						[
							-81.60224790699993,
							30.270327010000074
						],
						[
							-81.60130490699993,
							30.270291011000044
						],
						[
							-81.60104390799995,
							30.27028001000008
						],
						[
							-81.60080890799992,
							30.270270011000036
						],
						[
							-81.60051990799991,
							30.270260010000076
						],
						[
							-81.60043690799995,
							30.270257010000083
						],
						[
							-81.60032890699995,
							30.270253011000076
						],
						[
							-81.59980990699995,
							30.270233011000073
						],
						[
							-81.59873190699994,
							30.270199010000056
						],
						[
							-81.59778990799992,
							30.27016501000009
						],
						[
							-81.5966949079999,
							30.270131010000053
						],
						[
							-81.59627290799995,
							30.270116011000084
						],
						[
							-81.59568590799995,
							30.270094011000086
						],
						[
							-81.59512090699991,
							30.270073010000093
						],
						[
							-81.59449290799995,
							30.270049010000037
						],
						[
							-81.59160485699994,
							30.269963985000064
						],
						[
							-81.59169490699992,
							30.26940901000006
						],
						[
							-81.59172790699995,
							30.269208010000057
						],
						[
							-81.59184590799993,
							30.268346011000062
						],
						[
							-81.59199290799995,
							30.26730101000004
						],
						[
							-81.59201690799995,
							30.267112011000048
						],
						[
							-81.59203874799994,
							30.266948937000052
						],
						[
							-81.59210306799991,
							30.266876084000046
						],
						[
							-81.59213005999993,
							30.266680896000086
						],
						[
							-81.59207690799991,
							30.266675010000085
						],
						[
							-81.59202376299993,
							30.26666913300005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Greenfield Manor",
				"RegionID": "268997"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.13697858499995,
					26.09271807600004,
					-80.11840775099995,
					26.107723459000056
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.13294141799992,
							26.107701226000074
						],
						[
							-80.13291949199993,
							26.10767931500004
						],
						[
							-80.1328953979999,
							26.107628211000076
						],
						[
							-80.13288050699992,
							26.10681898900009
						],
						[
							-80.13285847299994,
							26.10588961100007
						],
						[
							-80.1328284299999,
							26.104969245000063
						],
						[
							-80.13281240599991,
							26.104047878000074
						],
						[
							-80.1328105309999,
							26.103918556000053
						],
						[
							-80.12059542899993,
							26.104189824000063
						],
						[
							-80.1196008419999,
							26.104607394000084
						],
						[
							-80.11929304299991,
							26.10447911700004
						],
						[
							-80.11922567599993,
							26.10444580400008
						],
						[
							-80.11881579399994,
							26.103624700000072
						],
						[
							-80.1189001219999,
							26.103034406000063
						],
						[
							-80.1189001219999,
							26.10221923800009
						],
						[
							-80.11859091999992,
							26.101038650000078
						],
						[
							-80.11851631699994,
							26.100757440000052
						],
						[
							-80.11841445099992,
							26.10037346900009
						],
						[
							-80.11840775099995,
							26.099999119000074
						],
						[
							-80.11842134099993,
							26.09983483400004
						],
						[
							-80.11846191399991,
							26.099683413000037
						],
						[
							-80.11852816399994,
							26.09954133900004
						],
						[
							-80.11861807899994,
							26.09941292700006
						],
						[
							-80.11872892699995,
							26.09930207900004
						],
						[
							-80.11885733899993,
							26.09921216400005
						],
						[
							-80.11899941399992,
							26.099145913000086
						],
						[
							-80.11913764799993,
							26.099107767000078
						],
						[
							-80.11984897299993,
							26.098971377000055
						],
						[
							-80.12065266199994,
							26.097954464000054
						],
						[
							-80.1207595859999,
							26.09709675000005
						],
						[
							-80.12078712199991,
							26.096961494000084
						],
						[
							-80.12119906499993,
							26.09551617200009
						],
						[
							-80.12088943599993,
							26.093707522000045
						],
						[
							-80.11967058199991,
							26.09301312200006
						],
						[
							-80.11953992699995,
							26.092921921000084
						],
						[
							-80.11948300699993,
							26.092865000000074
						],
						[
							-80.11996599999992,
							26.092865000000074
						],
						[
							-80.12122733899992,
							26.092865000000074
						],
						[
							-80.12406599999991,
							26.092865000000074
						],
						[
							-80.1245659999999,
							26.092865000000074
						],
						[
							-80.12476599999991,
							26.092865000000074
						],
						[
							-80.12716699999993,
							26.092765000000043
						],
						[
							-80.12936699999995,
							26.092765000000043
						],
						[
							-80.12966899999992,
							26.092775000000074
						],
						[
							-80.1319079999999,
							26.092850000000055
						],
						[
							-80.13236699999993,
							26.092865000000074
						],
						[
							-80.13510044999992,
							26.092788718000065
						],
						[
							-80.13516199999994,
							26.092787000000044
						],
						[
							-80.1356877739999,
							26.092772631000063
						],
						[
							-80.13596699999994,
							26.092765000000043
						],
						[
							-80.13595752899994,
							26.09279341200005
						],
						[
							-80.1362475219999,
							26.09278525600007
						],
						[
							-80.13636465199994,
							26.09272099900005
						],
						[
							-80.13648184999994,
							26.09271807600004
						],
						[
							-80.13662619099995,
							26.092722954000067
						],
						[
							-80.13663006799995,
							26.09284726700008
						],
						[
							-80.13674623999992,
							26.09659182100006
						],
						[
							-80.1368664179999,
							26.100193163000085
						],
						[
							-80.13684438599995,
							26.104880114000082
						],
						[
							-80.13697858499995,
							26.107655228000056
						],
						[
							-80.13360958699991,
							26.10771531800009
						],
						[
							-80.13298864399991,
							26.107723459000056
						],
						[
							-80.13294141799992,
							26.107701226000074
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Harbordale",
				"RegionID": "268999"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.83529633999991,
					30.24773601000004,
					-81.7878797759999,
					30.284285010000072
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.78974177399994,
							30.284283143000042
						],
						[
							-81.78977190799992,
							30.280283011000048
						],
						[
							-81.78978690799994,
							30.27941701000009
						],
						[
							-81.78980307499995,
							30.27687493500008
						],
						[
							-81.78934483899991,
							30.276466059000086
						],
						[
							-81.78922290799994,
							30.27617301000004
						],
						[
							-81.78913890799993,
							30.275898011000038
						],
						[
							-81.7889858559999,
							30.27536401900005
						],
						[
							-81.78898590799992,
							30.275066010000046
						],
						[
							-81.78896277599996,
							30.27455298700005
						],
						[
							-81.78919190599993,
							30.273977010000063
						],
						[
							-81.78921490799992,
							30.273830011000086
						],
						[
							-81.78922990599995,
							30.27374301200007
						],
						[
							-81.78920007199991,
							30.273265947000084
						],
						[
							-81.78914590699992,
							30.27319701100004
						],
						[
							-81.78912373399993,
							30.273174076000092
						],
						[
							-81.78912574399993,
							30.272349952000074
						],
						[
							-81.78916902499992,
							30.272297077000076
						],
						[
							-81.78919995699994,
							30.272209028000077
						],
						[
							-81.78919990799994,
							30.27170201000007
						],
						[
							-81.78918490699995,
							30.26958101000008
						],
						[
							-81.7891919079999,
							30.269482010000047
						],
						[
							-81.78921490899995,
							30.269352010000034
						],
						[
							-81.78936003899992,
							30.268935979000048
						],
						[
							-81.78831090799991,
							30.26666200700004
						],
						[
							-81.78825376599993,
							30.266391891000072
						],
						[
							-81.78887890699991,
							30.26640101000004
						],
						[
							-81.78903996799994,
							30.266390176000073
						],
						[
							-81.7891279079999,
							30.266326008000075
						],
						[
							-81.78916190399991,
							30.266285011000036
						],
						[
							-81.78919195899994,
							30.266222021000086
						],
						[
							-81.78920004199995,
							30.26614999800006
						],
						[
							-81.7891919079999,
							30.26610900900005
						],
						[
							-81.78919190699992,
							30.26581201300007
						],
						[
							-81.78916190599995,
							30.265688013000045
						],
						[
							-81.78909296899991,
							30.26557495100008
						],
						[
							-81.78896290799992,
							30.26549001000006
						],
						[
							-81.78887890699991,
							30.26541301100008
						],
						[
							-81.78882590799992,
							30.26536000600004
						],
						[
							-81.7887569099999,
							30.265245007000093
						],
						[
							-81.78873390899992,
							30.26513500900006
						],
						[
							-81.78872690799994,
							30.26495201100005
						],
						[
							-81.78871890699992,
							30.264765012000055
						],
						[
							-81.78868890699994,
							30.264635011000053
						],
						[
							-81.78862790699992,
							30.264471013000048
						],
						[
							-81.78852790699996,
							30.264320011000052
						],
						[
							-81.78843690799994,
							30.26420201100007
						],
						[
							-81.7882309069999,
							30.263969011000082
						],
						[
							-81.7880479079999,
							30.26376700800006
						],
						[
							-81.78796390999992,
							30.263624011000047
						],
						[
							-81.78789485599992,
							30.263393019000038
						],
						[
							-81.7878797759999,
							30.26284188100004
						],
						[
							-81.78849790699991,
							30.262833009000072
						],
						[
							-81.78864290699994,
							30.262804010000085
						],
						[
							-81.7888639059999,
							30.26273201200007
						],
						[
							-81.78908498899995,
							30.262709163000068
						],
						[
							-81.78936487399994,
							30.26240597000009
						],
						[
							-81.78958107099993,
							30.262272101000068
						],
						[
							-81.78960390799995,
							30.258734011000058
						],
						[
							-81.78959690699992,
							30.258423010000058
						],
						[
							-81.78961190799993,
							30.25750501100003
						],
						[
							-81.78961190799993,
							30.256283011000047
						],
						[
							-81.78962677599992,
							30.255006880000053
						],
						[
							-81.79010790699994,
							30.254993010000078
						],
						[
							-81.79116790799992,
							30.254967010000087
						],
						[
							-81.79219790799993,
							30.25495101000007
						],
						[
							-81.79367090799991,
							30.254917011000092
						],
						[
							-81.79424990799993,
							30.254911010000058
						],
						[
							-81.79458590799993,
							30.25491001000006
						],
						[
							-81.7962800389999,
							30.25487314500009
						],
						[
							-81.79629490799994,
							30.254602011000088
						],
						[
							-81.79628790699991,
							30.254143010000067
						],
						[
							-81.79626490699991,
							30.253769011000088
						],
						[
							-81.79624890699995,
							30.25290901100004
						],
						[
							-81.79620390799994,
							30.252050011000055
						],
						[
							-81.79616490799992,
							30.25118801000008
						],
						[
							-81.7961499079999,
							30.250332011000065
						],
						[
							-81.79611990799992,
							30.249456011000063
						],
						[
							-81.7960819079999,
							30.24858301000006
						],
						[
							-81.7960587739999,
							30.247781882000083
						],
						[
							-81.79634890699992,
							30.247773010000056
						],
						[
							-81.79745196899995,
							30.24773601000004
						],
						[
							-81.79805791199993,
							30.24852001200009
						],
						[
							-81.79873790999994,
							30.24907001200006
						],
						[
							-81.79885890999992,
							30.24914901300008
						],
						[
							-81.80039891199993,
							30.250164013000074
						],
						[
							-81.8018169099999,
							30.25074101200005
						],
						[
							-81.8055599089999,
							30.25226401200007
						],
						[
							-81.81092899499993,
							30.254937909000034
						],
						[
							-81.81498686399993,
							30.259360081000064
						],
						[
							-81.81948190999992,
							30.26103701200009
						],
						[
							-81.82033299499994,
							30.261354890000067
						],
						[
							-81.82315691399992,
							30.264944012000058
						],
						[
							-81.82440090499995,
							30.265787205000038
						],
						[
							-81.82625989099995,
							30.264744830000044
						],
						[
							-81.82695192999995,
							30.26496496400006
						],
						[
							-81.82768690899991,
							30.26551401300009
						],
						[
							-81.83360090999992,
							30.271726012000048
						],
						[
							-81.83521590899994,
							30.273422013000072
						],
						[
							-81.83529633999991,
							30.273536146000087
						],
						[
							-81.83427790799993,
							30.273977011000056
						],
						[
							-81.83317090799994,
							30.274525011000037
						],
						[
							-81.83279490799993,
							30.274693010000078
						],
						[
							-81.83202390799994,
							30.275017011000045
						],
						[
							-81.83178090799993,
							30.275131010000056
						],
						[
							-81.83103990799992,
							30.275423011000044
						],
						[
							-81.8301989069999,
							30.275782010000057
						],
						[
							-81.82977490799993,
							30.27595401100007
						],
						[
							-81.82937790699992,
							30.27610401100009
						],
						[
							-81.82893490799995,
							30.276265011000078
						],
						[
							-81.82858290799993,
							30.276394010000047
						],
						[
							-81.82831590799992,
							30.276484010000047
						],
						[
							-81.82769690799995,
							30.276707010000052
						],
						[
							-81.82759790699993,
							30.276744010000073
						],
						[
							-81.82730690799991,
							30.276850011000082
						],
						[
							-81.82624990699992,
							30.277254011000082
						],
						[
							-81.82585090799995,
							30.277409010000042
						],
						[
							-81.82463290699991,
							30.277872010000067
						],
						[
							-81.82443290799995,
							30.277942011000047
						],
						[
							-81.82422190699992,
							30.27801401000005
						],
						[
							-81.8234169079999,
							30.278321010000074
						],
						[
							-81.82234690799993,
							30.278712010000046
						],
						[
							-81.82219190699993,
							30.278769010000076
						],
						[
							-81.8217959079999,
							30.27890601000007
						],
						[
							-81.82095790799991,
							30.279216011000074
						],
						[
							-81.82082090799992,
							30.279268011000056
						],
						[
							-81.82002990799992,
							30.27955401000008
						],
						[
							-81.81958490699992,
							30.279737011000066
						],
						[
							-81.8179029069999,
							30.280368010000075
						],
						[
							-81.81778890699991,
							30.28041101000008
						],
						[
							-81.81630890699995,
							30.280932010000072
						],
						[
							-81.81589290699992,
							30.281094010000064
						],
						[
							-81.81471690799992,
							30.28151001100008
						],
						[
							-81.81461890799994,
							30.281549011000035
						],
						[
							-81.81228590699993,
							30.282416010000077
						],
						[
							-81.8114209069999,
							30.282733010000076
						],
						[
							-81.81103290699991,
							30.28287101000007
						],
						[
							-81.81064490699993,
							30.28302601000007
						],
						[
							-81.81023690799992,
							30.283171010000046
						],
						[
							-81.80859090799993,
							30.283795011000056
						],
						[
							-81.80848090699993,
							30.283840010000063
						],
						[
							-81.8082359089999,
							30.283935067000076
						],
						[
							-81.80817698699991,
							30.283832834000066
						],
						[
							-81.80788690799994,
							30.283905010000073
						],
						[
							-81.80761390999993,
							30.283993009000085
						],
						[
							-81.80730190799994,
							30.284030010000038
						],
						[
							-81.8057429079999,
							30.284033011000073
						],
						[
							-81.80533290699992,
							30.284076010000035
						],
						[
							-81.80516090799995,
							30.28408201000008
						],
						[
							-81.79445590699993,
							30.284224010000063
						],
						[
							-81.79340390699993,
							30.28423701000008
						],
						[
							-81.79290090799992,
							30.284244010000066
						],
						[
							-81.7923509069999,
							30.284252010000046
						],
						[
							-81.79162590699991,
							30.284262010000077
						],
						[
							-81.79031390799992,
							30.284285010000072
						],
						[
							-81.78974177399994,
							30.284283143000042
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Herlong",
				"RegionID": "269004"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.52056646399991,
					30.35593813400004,
					-81.50117673799991,
					30.379373066000085
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.50219172499995,
							30.37159005200004
						],
						[
							-81.50271280599992,
							30.370388853000065
						],
						[
							-81.50286104299994,
							30.370390145000048
						],
						[
							-81.50284290999991,
							30.36933001300008
						],
						[
							-81.50283690999993,
							30.36901901200008
						],
						[
							-81.5028239099999,
							30.36838401200004
						],
						[
							-81.5028239099999,
							30.36807401200008
						],
						[
							-81.50281390899994,
							30.36780001200009
						],
						[
							-81.50279090999993,
							30.366918012000045
						],
						[
							-81.50280990999994,
							30.36612401200006
						],
						[
							-81.5028019099999,
							30.364802013000084
						],
						[
							-81.50279990999991,
							30.36475701200004
						],
						[
							-81.5027589099999,
							30.36351801300009
						],
						[
							-81.50272590999992,
							30.36208501200008
						],
						[
							-81.5027227409999,
							30.361147964000057
						],
						[
							-81.50280198699994,
							30.36103503200007
						],
						[
							-81.50280690999995,
							30.36032101300009
						],
						[
							-81.50280892699993,
							30.360274005000065
						],
						[
							-81.50288990899992,
							30.360274013000037
						],
						[
							-81.50423490799994,
							30.36033801300005
						],
						[
							-81.50460691099994,
							30.36035301300006
						],
						[
							-81.50501390999995,
							30.360372013000074
						],
						[
							-81.5052619089999,
							30.360379012000067
						],
						[
							-81.50546690999994,
							30.36037801200007
						],
						[
							-81.5059509109999,
							30.36036301100006
						],
						[
							-81.50708090899991,
							30.36021801200008
						],
						[
							-81.50756090899995,
							30.360102012000084
						],
						[
							-81.50773390899991,
							30.36007001200005
						],
						[
							-81.5081209089999,
							30.35996501300008
						],
						[
							-81.50972691099992,
							30.359453013000067
						],
						[
							-81.51057391099994,
							30.359182013000062
						],
						[
							-81.51122990899995,
							30.35896701300004
						],
						[
							-81.51176690799991,
							30.35879101300009
						],
						[
							-81.51248191099995,
							30.358557013000055
						],
						[
							-81.51336491099994,
							30.358268013000043
						],
						[
							-81.5142029079999,
							30.358011013000063
						],
						[
							-81.5143279099999,
							30.35797301300005
						],
						[
							-81.5153459089999,
							30.35764401200004
						],
						[
							-81.51545990899992,
							30.357607013000063
						],
						[
							-81.51699191099993,
							30.357096013000046
						],
						[
							-81.51863290999995,
							30.35653601200005
						],
						[
							-81.51952391099991,
							30.35622501200004
						],
						[
							-81.51980890999994,
							30.356145012000074
						],
						[
							-81.52056646399991,
							30.35593813400004
						],
						[
							-81.51988790999991,
							30.356276013000066
						],
						[
							-81.51956690899993,
							30.356457012000078
						],
						[
							-81.51931490899995,
							30.356619012000063
						],
						[
							-81.51887290999991,
							30.356932012000076
						],
						[
							-81.5182239099999,
							30.35737901200008
						],
						[
							-81.51791291099994,
							30.35765701300005
						],
						[
							-81.51778390899995,
							30.35782101300003
						],
						[
							-81.51748690999995,
							30.358150013000053
						],
						[
							-81.51697490999993,
							30.35876501300004
						],
						[
							-81.51675390899993,
							30.359074012000065
						],
						[
							-81.51641790999992,
							30.35963101300007
						],
						[
							-81.5162429099999,
							30.359940013000084
						],
						[
							-81.5161589089999,
							30.360113012000056
						],
						[
							-81.51600990999992,
							30.36049901200005
						],
						[
							-81.51594891099995,
							30.36061801200009
						],
						[
							-81.51580990999992,
							30.36097301200005
						],
						[
							-81.51578690899993,
							30.36106901200009
						],
						[
							-81.51571290999993,
							30.361301012000073
						],
						[
							-81.51567790999991,
							30.361531013000047
						],
						[
							-81.51558790999991,
							30.362112013000058
						],
						[
							-81.51552790999995,
							30.362807012000072
						],
						[
							-81.51553690999992,
							30.36314301300007
						],
						[
							-81.51553490899994,
							30.363949012000035
						],
						[
							-81.51553890999992,
							30.364202013000067
						],
						[
							-81.5155469099999,
							30.364805013000076
						],
						[
							-81.51554890999995,
							30.36493301200005
						],
						[
							-81.51556390999991,
							30.365913013000068
						],
						[
							-81.51558690899992,
							30.366301013000058
						],
						[
							-81.51557890999995,
							30.36674901300006
						],
						[
							-81.51555590999993,
							30.367111013000056
						],
						[
							-81.5155029089999,
							30.367615012000044
						],
						[
							-81.51544190999994,
							30.367941013000067
						],
						[
							-81.51530490999994,
							30.36851901200004
						],
						[
							-81.5152589089999,
							30.36868901200006
						],
						[
							-81.51500690899991,
							30.36932401300004
						],
						[
							-81.5148009099999,
							30.36975901300008
						],
						[
							-81.51444590999995,
							30.370447013000046
						],
						[
							-81.51423590999991,
							30.37086301200009
						],
						[
							-81.51354190899991,
							30.37217501300006
						],
						[
							-81.5123289089999,
							30.374569012000055
						],
						[
							-81.51150290999995,
							30.37617501300008
						],
						[
							-81.51126890999991,
							30.37663101200008
						],
						[
							-81.5108409099999,
							30.377470012000064
						],
						[
							-81.51071890999992,
							30.37767601200005
						],
						[
							-81.51045690899991,
							30.378009013000057
						],
						[
							-81.51038777699995,
							30.378084013000034
						],
						[
							-81.51015090899995,
							30.378314012000093
						],
						[
							-81.5099599099999,
							30.37847601300007
						],
						[
							-81.50965590899995,
							30.378684011000075
						],
						[
							-81.50925890999991,
							30.37889201200005
						],
						[
							-81.50896990999992,
							30.379008013000085
						],
						[
							-81.50868790899995,
							30.379106012000083
						],
						[
							-81.50823790899996,
							30.379207012000055
						],
						[
							-81.50783390999993,
							30.379258013000083
						],
						[
							-81.50743790899992,
							30.379272012000058
						],
						[
							-81.50734690999991,
							30.37928201200009
						],
						[
							-81.50521090899991,
							30.379313013000058
						],
						[
							-81.5042449099999,
							30.37934401200005
						],
						[
							-81.50319390999994,
							30.37936101200006
						],
						[
							-81.50269290999995,
							30.37936901200004
						],
						[
							-81.50252292699992,
							30.379373066000085
						],
						[
							-81.50262890999994,
							30.37864601200005
						],
						[
							-81.5026659099999,
							30.378364013000066
						],
						[
							-81.50273490899991,
							30.377879013000044
						],
						[
							-81.50278990899994,
							30.37743901200008
						],
						[
							-81.50282208699993,
							30.377112943000043
						],
						[
							-81.50197072999993,
							30.37634900800009
						],
						[
							-81.50284307999993,
							30.375657000000047
						],
						[
							-81.50198574199993,
							30.375144014000053
						],
						[
							-81.50282308999994,
							30.374628032000086
						],
						[
							-81.50117673799991,
							30.373011987000044
						],
						[
							-81.5028290809999,
							30.372208036000078
						],
						[
							-81.50219172499995,
							30.37159005200004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Hidden Hills",
				"RegionID": "269006"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.66428091599994,
					30.393591678000064,
					-81.64489083099994,
					30.430194965000055
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.64489083099994,
							30.430194965000055
						],
						[
							-81.6449419089999,
							30.430045013000043
						],
						[
							-81.64507490999995,
							30.429660012000056
						],
						[
							-81.64553690899993,
							30.42822201200005
						],
						[
							-81.64567390999991,
							30.427841012000044
						],
						[
							-81.64590090999991,
							30.427163012000047
						],
						[
							-81.64613390999995,
							30.426502012000075
						],
						[
							-81.6461999089999,
							30.426316013000076
						],
						[
							-81.64659690899992,
							30.425307012000076
						],
						[
							-81.64689190899993,
							30.42457701400008
						],
						[
							-81.64699390999994,
							30.42427401200007
						],
						[
							-81.64712790999994,
							30.423883012000086
						],
						[
							-81.6473659099999,
							30.42318901200008
						],
						[
							-81.64761190899992,
							30.42246601200009
						],
						[
							-81.64783690999991,
							30.421799012000065
						],
						[
							-81.64810490999992,
							30.42100101200009
						],
						[
							-81.64839890999991,
							30.420077013000082
						],
						[
							-81.64843690999993,
							30.41996901200008
						],
						[
							-81.64857790999991,
							30.41952001200008
						],
						[
							-81.6487869099999,
							30.418884013000085
						],
						[
							-81.6488569089999,
							30.418651013000048
						],
						[
							-81.64889090899993,
							30.418511012000067
						],
						[
							-81.64891790999991,
							30.418338013000035
						],
						[
							-81.64899490999994,
							30.417586012000076
						],
						[
							-81.64907290999992,
							30.416908013000068
						],
						[
							-81.64914190999991,
							30.416588011000048
						],
						[
							-81.64922690999992,
							30.41628901300004
						],
						[
							-81.64934090899993,
							30.415962012000076
						],
						[
							-81.64944190999995,
							30.41573201200003
						],
						[
							-81.6495499099999,
							30.41552601300009
						],
						[
							-81.64981290899993,
							30.415065012000074
						],
						[
							-81.65019890999992,
							30.41442001200005
						],
						[
							-81.65035590899994,
							30.414074012000075
						],
						[
							-81.65037790899993,
							30.41400301300007
						],
						[
							-81.65042590999991,
							30.41388601300008
						],
						[
							-81.65046790999992,
							30.41373901300005
						],
						[
							-81.65052090899991,
							30.413557013000055
						],
						[
							-81.65054499799993,
							30.413479035000076
						],
						[
							-81.6506109099999,
							30.41316301300009
						],
						[
							-81.6506559099999,
							30.412909013000046
						],
						[
							-81.65068190999995,
							30.412714013000084
						],
						[
							-81.6507059089999,
							30.41250801300004
						],
						[
							-81.65071490899993,
							30.41238401300006
						],
						[
							-81.6507239099999,
							30.41223401300005
						],
						[
							-81.65073290899996,
							30.411932012000076
						],
						[
							-81.65073290899996,
							30.411704013000076
						],
						[
							-81.65071890999991,
							30.41149201300004
						],
						[
							-81.65070590999994,
							30.411345012000083
						],
						[
							-81.65058090999992,
							30.410374012000094
						],
						[
							-81.65048190899995,
							30.409644012000058
						],
						[
							-81.65043890899994,
							30.409252012000085
						],
						[
							-81.65035990899993,
							30.408720013000053
						],
						[
							-81.65035490999992,
							30.408673012000065
						],
						[
							-81.65032390899995,
							30.40836701300009
						],
						[
							-81.65025390999995,
							30.40778301200004
						],
						[
							-81.65024390899993,
							30.407715012000036
						],
						[
							-81.65019690999992,
							30.407351013000042
						],
						[
							-81.65012890999992,
							30.406835012000045
						],
						[
							-81.64986490899992,
							30.404902012000033
						],
						[
							-81.64978198299991,
							30.40436697800004
						],
						[
							-81.64964483699993,
							30.404209046000062
						],
						[
							-81.64945890999991,
							30.402880013000072
						],
						[
							-81.64931690999992,
							30.401870013000067
						],
						[
							-81.64918290999992,
							30.40082401200004
						],
						[
							-81.6489449099999,
							30.398984013000074
						],
						[
							-81.64892890999994,
							30.39880701400006
						],
						[
							-81.6487429089999,
							30.39752101300007
						],
						[
							-81.64857890899994,
							30.396527012000035
						],
						[
							-81.64829899999995,
							30.39560100000006
						],
						[
							-81.6480396469999,
							30.394742990000058
						],
						[
							-81.64814283499993,
							30.39471534100005
						],
						[
							-81.64829899999995,
							30.39470167800005
						],
						[
							-81.64832351899992,
							30.39470201200004
						],
						[
							-81.64835680599994,
							30.394702920000043
						],
						[
							-81.64879484799991,
							30.394639856000083
						],
						[
							-81.64892299999991,
							30.394630678000055
						],
						[
							-81.6490809629999,
							30.394644662000076
						],
						[
							-81.64922293199993,
							30.394670285000075
						],
						[
							-81.64983774199993,
							30.394490262000094
						],
						[
							-81.65099045599993,
							30.39373789600006
						],
						[
							-81.65103233899993,
							30.393712164000082
						],
						[
							-81.65117441299992,
							30.393645914000047
						],
						[
							-81.65132583399992,
							30.39360534100007
						],
						[
							-81.65148199999993,
							30.393591678000064
						],
						[
							-81.6516475759999,
							30.393607104000065
						],
						[
							-81.65202498799994,
							30.393681866000065
						],
						[
							-81.65208852699993,
							30.39369688700009
						],
						[
							-81.65215080999991,
							30.393716477000055
						],
						[
							-81.6522115059999,
							30.393740535000063
						],
						[
							-81.6522702979999,
							30.393768933000047
						],
						[
							-81.65232687399993,
							30.393801522000047
						],
						[
							-81.6540350699999,
							30.394869873000065
						],
						[
							-81.65528507399995,
							30.395425111000065
						],
						[
							-81.65536966099995,
							30.39546816400008
						],
						[
							-81.65542424299991,
							30.395502340000068
						],
						[
							-81.65742824299991,
							30.396859340000052
						],
						[
							-81.6574868589999,
							30.396902595000086
						],
						[
							-81.6575417819999,
							30.396950452000056
						],
						[
							-81.6575926509999,
							30.39700259800009
						],
						[
							-81.65763913299992,
							30.397058689000062
						],
						[
							-81.65768092199994,
							30.397118358000057
						],
						[
							-81.65845579899991,
							30.398326083000086
						],
						[
							-81.65893860599994,
							30.398920652000076
						],
						[
							-81.65929080299992,
							30.399080522000077
						],
						[
							-81.66011123699991,
							30.39935812000004
						],
						[
							-81.66013058599992,
							30.399364914000046
						],
						[
							-81.66027266099991,
							30.39943116400008
						],
						[
							-81.66040107299995,
							30.399521079000067
						],
						[
							-81.66051192099991,
							30.399631927000087
						],
						[
							-81.6606018359999,
							30.399760339000068
						],
						[
							-81.6606321299999,
							30.399817459000076
						],
						[
							-81.66117835499995,
							30.400943372000086
						],
						[
							-81.66216766299993,
							30.40051785500009
						],
						[
							-81.66221541399995,
							30.400498914000085
						],
						[
							-81.66236683499994,
							30.40045834100005
						],
						[
							-81.66252299999991,
							30.400444678000042
						],
						[
							-81.66267916599992,
							30.40045834100005
						],
						[
							-81.66283058699992,
							30.400498914000085
						],
						[
							-81.66287428099992,
							30.400516122000056
						],
						[
							-81.6637132809999,
							30.400872122000063
						],
						[
							-81.6638116609999,
							30.40092116500006
						],
						[
							-81.66390300899991,
							30.40098160400004
						],
						[
							-81.66424911299993,
							30.40114966200008
						],
						[
							-81.66428091599994,
							30.401166518000082
						],
						[
							-81.66343799999993,
							30.401756000000034
						],
						[
							-81.6632049079999,
							30.40191901000009
						],
						[
							-81.66269590799993,
							30.402276010000037
						],
						[
							-81.66240090799994,
							30.40250201000003
						],
						[
							-81.66227690699992,
							30.402594011000076
						],
						[
							-81.66188390799994,
							30.402867010000083
						],
						[
							-81.6616069079999,
							30.40306601000009
						],
						[
							-81.6611819069999,
							30.403353011000036
						],
						[
							-81.6610228429999,
							30.403475085000082
						],
						[
							-81.66105380499994,
							30.40342092400004
						],
						[
							-81.66153853299994,
							30.403039666000037
						],
						[
							-81.66105190699994,
							30.403357010000036
						],
						[
							-81.66080090799994,
							30.403531010000048
						],
						[
							-81.66015090699995,
							30.40398201000005
						],
						[
							-81.6596689079999,
							30.404345011000093
						],
						[
							-81.65947790799993,
							30.40452601000004
						],
						[
							-81.65893290899993,
							30.405046011000085
						],
						[
							-81.65855390799993,
							30.405516011000092
						],
						[
							-81.6580039079999,
							30.40639401200008
						],
						[
							-81.65778979699991,
							30.406951120000084
						],
						[
							-81.65791001799994,
							30.406907897000057
						],
						[
							-81.6578229079999,
							30.407177011000044
						],
						[
							-81.65772490799992,
							30.407505010000083
						],
						[
							-81.6576429079999,
							30.407940010000058
						],
						[
							-81.65760690799993,
							30.40818501100006
						],
						[
							-81.65758190799994,
							30.40840801000007
						],
						[
							-81.6575799069999,
							30.408488010000045
						],
						[
							-81.65757396099991,
							30.408571019000075
						],
						[
							-81.65756285499992,
							30.40860900000007
						],
						[
							-81.65754090699994,
							30.408936010000048
						],
						[
							-81.6575129769999,
							30.40952415800007
						],
						[
							-81.65739183799991,
							30.40943386300006
						],
						[
							-81.65738590799992,
							30.409580010000067
						],
						[
							-81.65729090799994,
							30.411124010000034
						],
						[
							-81.6572849069999,
							30.411193011000083
						],
						[
							-81.65721890799996,
							30.411895011000073
						],
						[
							-81.65720676399991,
							30.412111132000067
						],
						[
							-81.65736105099997,
							30.412123888000053
						],
						[
							-81.65734690799991,
							30.412405011000093
						],
						[
							-81.65733490799994,
							30.412630010000044
						],
						[
							-81.65727590799992,
							30.413425010000083
						],
						[
							-81.6572609079999,
							30.413673010000082
						],
						[
							-81.6572369079999,
							30.41407501100008
						],
						[
							-81.65723598899991,
							30.414189030000045
						],
						[
							-81.65708482699995,
							30.414471988000063
						],
						[
							-81.65707590799991,
							30.414779011000064
						],
						[
							-81.65676190799991,
							30.418697010000074
						],
						[
							-81.65636190799995,
							30.426767010000052
						],
						[
							-81.65613990799996,
							30.429935011000058
						],
						[
							-81.65613790899994,
							30.430041068000037
						],
						[
							-81.65601590699993,
							30.430046010000073
						],
						[
							-81.65570390699992,
							30.430058011000085
						],
						[
							-81.6552339079999,
							30.430081010000038
						],
						[
							-81.65490690699994,
							30.430078010000045
						],
						[
							-81.65472390799994,
							30.430078011000038
						],
						[
							-81.65459890499994,
							30.430088009000087
						],
						[
							-81.65444790799995,
							30.43007201100005
						],
						[
							-81.65410290699992,
							30.430084010000087
						],
						[
							-81.65281890699993,
							30.43012801000009
						],
						[
							-81.65245390799993,
							30.43012501000004
						],
						[
							-81.65166990799992,
							30.430124010000043
						],
						[
							-81.6505489079999,
							30.430130010000084
						],
						[
							-81.64882790799993,
							30.430140010000063
						],
						[
							-81.64844990799992,
							30.43015001100008
						],
						[
							-81.6468399069999,
							30.430178010000077
						],
						[
							-81.64558190799994,
							30.430188010000055
						],
						[
							-81.64536090699994,
							30.43019401000004
						],
						[
							-81.64489083099994,
							30.430194965000055
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Hollyford",
				"RegionID": "269013"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.14346699999993,
					25.996668000000057,
					-80.11753690499995,
					26.03429344400007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.13116699999995,
							26.033867000000043
						],
						[
							-80.11753690499995,
							26.03429344400007
						],
						[
							-80.11785202099993,
							26.021328649000054
						],
						[
							-80.11771697099994,
							26.01858263400004
						],
						[
							-80.11807710499994,
							26.01534143500004
						],
						[
							-80.1188874039999,
							26.00561783900008
						],
						[
							-80.11976599999991,
							25.997168000000045
						],
						[
							-80.12016599999993,
							25.997168000000045
						],
						[
							-80.1212559999999,
							25.997168000000045
						],
						[
							-80.1220669999999,
							25.997168000000045
						],
						[
							-80.12246699999992,
							25.997168000000045
						],
						[
							-80.12306699999995,
							25.997068000000073
						],
						[
							-80.12396699999994,
							25.997068000000073
						],
						[
							-80.12456699999991,
							25.997068000000073
						],
						[
							-80.12586699999991,
							25.997168000000045
						],
						[
							-80.1263669999999,
							25.997168000000045
						],
						[
							-80.12686699999995,
							25.997168000000045
						],
						[
							-80.12732299999993,
							25.997169000000042
						],
						[
							-80.12756699999996,
							25.997168000000045
						],
						[
							-80.12919999999991,
							25.99709400000006
						],
						[
							-80.1297669999999,
							25.997068000000073
						],
						[
							-80.1306669999999,
							25.997068000000073
						],
						[
							-80.13486699999993,
							25.996968000000038
						],
						[
							-80.1367669999999,
							25.996868000000063
						],
						[
							-80.13876699999992,
							25.99676800000009
						],
						[
							-80.1408669999999,
							25.99676800000009
						],
						[
							-80.14286699999991,
							25.996668000000057
						],
						[
							-80.14268501799995,
							25.99674579200007
						],
						[
							-80.1430965969999,
							26.011644926000088
						],
						[
							-80.14346699999993,
							26.033567000000062
						],
						[
							-80.14126699999991,
							26.033667000000037
						],
						[
							-80.13516699999991,
							26.033867000000043
						],
						[
							-80.1321309999999,
							26.033867000000043
						],
						[
							-80.13146699999993,
							26.033867000000043
						],
						[
							-80.13116699999995,
							26.033867000000043
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Hollywood",
				"Name": "Hollywood Lakes",
				"RegionID": "269015"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.8490500289999,
					30.246949104000066,
					-81.79745196899995,
					30.273536146000087
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.82695192999995,
							30.26496496400006
						],
						[
							-81.82625989099995,
							30.264744830000044
						],
						[
							-81.82440090499995,
							30.265787205000038
						],
						[
							-81.82315691399992,
							30.264944012000058
						],
						[
							-81.82033299499994,
							30.261354890000067
						],
						[
							-81.81948190999992,
							30.26103701200009
						],
						[
							-81.81498686399993,
							30.259360081000064
						],
						[
							-81.81092899499993,
							30.254937909000034
						],
						[
							-81.8055599089999,
							30.25226401200007
						],
						[
							-81.8018169099999,
							30.25074101200005
						],
						[
							-81.80039891199993,
							30.250164013000074
						],
						[
							-81.79885890999992,
							30.24914901300008
						],
						[
							-81.79873790999994,
							30.24907001200006
						],
						[
							-81.79805791199993,
							30.24852001200009
						],
						[
							-81.79745196899995,
							30.24773601000004
						],
						[
							-81.79807690799993,
							30.24772101000008
						],
						[
							-81.79890490699995,
							30.247708010000053
						],
						[
							-81.7992369079999,
							30.247708010000053
						],
						[
							-81.79983590699993,
							30.247708010000053
						],
						[
							-81.8005449069999,
							30.247714010000042
						],
						[
							-81.8012869069999,
							30.247717011000077
						],
						[
							-81.8016499069999,
							30.247728010000056
						],
						[
							-81.80269390799992,
							30.247748010000066
						],
						[
							-81.8032709069999,
							30.24775101000006
						],
						[
							-81.80383490799994,
							30.247744010000076
						],
						[
							-81.80388690699994,
							30.247744010000076
						],
						[
							-81.8040569069999,
							30.247749010000064
						],
						[
							-81.80559890699993,
							30.24775101000006
						],
						[
							-81.80578490799991,
							30.247752010000056
						],
						[
							-81.80677390799991,
							30.247764010000086
						],
						[
							-81.80694890799992,
							30.247761010000094
						],
						[
							-81.80785340799991,
							30.24776101100008
						],
						[
							-81.80902190799992,
							30.247799011000037
						],
						[
							-81.80956090799992,
							30.247799011000037
						],
						[
							-81.8100429079999,
							30.24781201000008
						],
						[
							-81.81059190699995,
							30.247816011000054
						],
						[
							-81.81115690699994,
							30.247823011000037
						],
						[
							-81.81135890799993,
							30.247836011000064
						],
						[
							-81.81160790799993,
							30.247835011000067
						],
						[
							-81.8124289079999,
							30.24786101000007
						],
						[
							-81.8136899079999,
							30.24788601000006
						],
						[
							-81.81403990699994,
							30.247888010000054
						],
						[
							-81.81480690699993,
							30.24788101000007
						],
						[
							-81.81536390799994,
							30.24789501100008
						],
						[
							-81.81621390799995,
							30.24786101000007
						],
						[
							-81.8163689079999,
							30.247856011000067
						],
						[
							-81.81652990799995,
							30.24785001000004
						],
						[
							-81.81679390699993,
							30.24783301000008
						],
						[
							-81.81743790699994,
							30.247817011000052
						],
						[
							-81.8184419079999,
							30.247790010000074
						],
						[
							-81.81973290799993,
							30.247729010000057
						],
						[
							-81.81994290799992,
							30.247722011000064
						],
						[
							-81.82122590699993,
							30.247674010000086
						],
						[
							-81.82232790799992,
							30.24762601100008
						],
						[
							-81.82281690699995,
							30.247602011000087
						],
						[
							-81.82340090699996,
							30.24757501000005
						],
						[
							-81.82351190799994,
							30.247574010000054
						],
						[
							-81.8238229079999,
							30.24756501100006
						],
						[
							-81.82449590699991,
							30.24753800900004
						],
						[
							-81.82456190699992,
							30.247536009000044
						],
						[
							-81.82571490799995,
							30.24750401100005
						],
						[
							-81.82602290699992,
							30.24749501000008
						],
						[
							-81.82627490699991,
							30.247475010000077
						],
						[
							-81.8268219069999,
							30.247448011000074
						],
						[
							-81.82738190799995,
							30.24743201000007
						],
						[
							-81.8279869079999,
							30.24741001100006
						],
						[
							-81.82850190699992,
							30.247388011000055
						],
						[
							-81.82917890699991,
							30.24737601000004
						],
						[
							-81.83050390699992,
							30.247333011000077
						],
						[
							-81.83160890799991,
							30.247273011000065
						],
						[
							-81.83180490799992,
							30.24726601000009
						],
						[
							-81.83300190799991,
							30.247229011000062
						],
						[
							-81.83419890699992,
							30.247211011000047
						],
						[
							-81.83457290799993,
							30.24719701000004
						],
						[
							-81.8349009069999,
							30.247186010000064
						],
						[
							-81.83575290699991,
							30.24718701000006
						],
						[
							-81.83660490799993,
							30.247168010000053
						],
						[
							-81.83781990699993,
							30.247158011000067
						],
						[
							-81.83895190699991,
							30.24710701000004
						],
						[
							-81.83954290699995,
							30.247081011000034
						],
						[
							-81.84016290699992,
							30.24707901000005
						],
						[
							-81.84030190699991,
							30.247077010000055
						],
						[
							-81.84060190799994,
							30.247072010000068
						],
						[
							-81.84105090799994,
							30.247067010000077
						],
						[
							-81.84141890799992,
							30.24706501000008
						],
						[
							-81.84172590799994,
							30.247067010000077
						],
						[
							-81.8425549079999,
							30.247040010000035
						],
						[
							-81.84289790699995,
							30.247040010000035
						],
						[
							-81.84393690799993,
							30.247028010000065
						],
						[
							-81.84406990699995,
							30.247025010000073
						],
						[
							-81.84458589399992,
							30.247025010000073
						],
						[
							-81.84530490899994,
							30.247025012000055
						],
						[
							-81.84588190999995,
							30.24701401200008
						],
						[
							-81.8463539089999,
							30.247005012000045
						],
						[
							-81.84739390999995,
							30.246988012000088
						],
						[
							-81.84784390999994,
							30.24697401200007
						],
						[
							-81.84834290899994,
							30.246976012000065
						],
						[
							-81.84860890999994,
							30.246966013000073
						],
						[
							-81.84904985299995,
							30.246949104000066
						],
						[
							-81.8490500289999,
							30.267432704000047
						],
						[
							-81.83529633999991,
							30.273536146000087
						],
						[
							-81.83521590899994,
							30.273422013000072
						],
						[
							-81.83360090999992,
							30.271726012000048
						],
						[
							-81.82768690899991,
							30.26551401300009
						],
						[
							-81.82695192999995,
							30.26496496400006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Jacksonville Heights West",
				"RegionID": "269022"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.12285973499992,
					26.189144070000054,
					-80.11155891399994,
					26.196693192000055
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.11830088399996,
							26.189196158000073
						],
						[
							-80.12261928999993,
							26.189144070000054
						],
						[
							-80.12285973499992,
							26.196471934000044
						],
						[
							-80.11155891399994,
							26.196693192000055
						],
						[
							-80.1118242789999,
							26.19613144500005
						],
						[
							-80.11195146699993,
							26.19587005700004
						],
						[
							-80.1120896729999,
							26.195598654000037
						],
						[
							-80.11227094199995,
							26.195216087000063
						],
						[
							-80.11238410999994,
							26.194978734000074
						],
						[
							-80.11253533299993,
							26.194650248000073
						],
						[
							-80.11261244799994,
							26.194478993000075
						],
						[
							-80.11282876899992,
							26.193996278000043
						],
						[
							-80.11294493999992,
							26.193775951000077
						],
						[
							-80.11325039299993,
							26.19312097900007
						],
						[
							-80.1132924559999,
							26.19303184800009
						],
						[
							-80.11338459199993,
							26.19283555600009
						],
						[
							-80.11371107699995,
							26.19214953800008
						],
						[
							-80.11412368999994,
							26.19126222200009
						],
						[
							-80.1143970949999,
							26.190663335000067
						],
						[
							-80.11444015899991,
							26.190579209000077
						],
						[
							-80.11490685099994,
							26.18966184900006
						],
						[
							-80.11493590599991,
							26.18960475800009
						],
						[
							-80.11596355099994,
							26.189568845000053
						],
						[
							-80.11596626499994,
							26.189506510000058
						],
						[
							-80.11639105199993,
							26.189325350000047
						],
						[
							-80.11655529599994,
							26.18927427500006
						],
						[
							-80.1167175359999,
							26.189245232000076
						],
						[
							-80.11714116399992,
							26.189228206000053
						],
						[
							-80.11830088399996,
							26.189196158000073
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Knoll Ridge",
				"RegionID": "269029"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.37650500724614,
					28.522514503024993,
					-81.3722305642393,
					28.53122967144926
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.3722305642393,
							28.52252420106257
						],
						[
							-81.37639587138526,
							28.522514503024993
						],
						[
							-81.37640071556844,
							28.522962263389246
						],
						[
							-81.37641173136383,
							28.523896649084996
						],
						[
							-81.37641273500722,
							28.523941716810018
						],
						[
							-81.37642975827393,
							28.524599692282877
						],
						[
							-81.37644978977288,
							28.52517053963893
						],
						[
							-81.37645980282441,
							28.526381333759183
						],
						[
							-81.37646381020338,
							28.5268830781097
						],
						[
							-81.3764658129934,
							28.527921618786444
						],
						[
							-81.37646781668289,
							28.52868775482061
						],
						[
							-81.37647482509958,
							28.529044282945147
						],
						[
							-81.3764658129934,
							28.52918849732656
						],
						[
							-81.37647182136402,
							28.530530488141743
						],
						[
							-81.37649285290895,
							28.530933084936493
						],
						[
							-81.37650500724614,
							28.531189595861083
						],
						[
							-81.37644378859696,
							28.53119041154602
						],
						[
							-81.37551039575261,
							28.5312114970503
						],
						[
							-81.37476516805644,
							28.53122967144926
						],
						[
							-81.37464126036646,
							28.530484319646497
						],
						[
							-81.37355549629004,
							28.529760345627807
						],
						[
							-81.37279847758268,
							28.529184456672525
						],
						[
							-81.37228944782433,
							28.528795998119378
						],
						[
							-81.37228961959484,
							28.52783248608087
						],
						[
							-81.37224355092454,
							28.523919683420242
						],
						[
							-81.3722305642393,
							28.52252420106257
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Lake Copeland",
				"RegionID": "269033"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.41753799999992,
					28.595532823000042,
					-81.40360599999991,
					28.605744000000072
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.40901006099995,
							28.603923687000076
						],
						[
							-81.40900999999991,
							28.60391800000008
						],
						[
							-81.40825236899991,
							28.603922287000046
						],
						[
							-81.40820988099995,
							28.603922527000066
						],
						[
							-81.4075959999999,
							28.603926000000058
						],
						[
							-81.4075959999999,
							28.603921193000076
						],
						[
							-81.4075959999999,
							28.603791000000058
						],
						[
							-81.40742399999993,
							28.60368200000005
						],
						[
							-81.40754099999992,
							28.603558000000078
						],
						[
							-81.40756699999991,
							28.603517000000068
						],
						[
							-81.40747799999991,
							28.60346300000009
						],
						[
							-81.40743999999995,
							28.603503000000046
						],
						[
							-81.40732999999994,
							28.603613000000053
						],
						[
							-81.4072799999999,
							28.603575000000035
						],
						[
							-81.40717799999993,
							28.603488000000084
						],
						[
							-81.4070979999999,
							28.603432000000055
						],
						[
							-81.4070539999999,
							28.60346100000004
						],
						[
							-81.4067389999999,
							28.603258000000043
						],
						[
							-81.4066709999999,
							28.603342000000055
						],
						[
							-81.40580799999992,
							28.602788000000093
						],
						[
							-81.40574604499994,
							28.60275657600005
						],
						[
							-81.40539199999995,
							28.602577000000053
						],
						[
							-81.40443192599993,
							28.601904948000083
						],
						[
							-81.40439199999992,
							28.60187700000006
						],
						[
							-81.40360599999991,
							28.601249000000053
						],
						[
							-81.40392910799994,
							28.60092502400005
						],
						[
							-81.40397799999994,
							28.600876000000085
						],
						[
							-81.40439199999992,
							28.601177000000064
						],
						[
							-81.4045539999999,
							28.601072000000045
						],
						[
							-81.4045824129999,
							28.600284337000062
						],
						[
							-81.40459847999995,
							28.60029555600005
						],
						[
							-81.40465711199994,
							28.600326170000073
						],
						[
							-81.40466601899993,
							28.600330731000042
						],
						[
							-81.4046675269999,
							28.60032952000006
						],
						[
							-81.40471536299992,
							28.600295241000083
						],
						[
							-81.40476341999994,
							28.600265275000083
						],
						[
							-81.40482838299994,
							28.60022755500006
						],
						[
							-81.4048545199999,
							28.600206523000054
						],
						[
							-81.40485872799991,
							28.60020204600005
						],
						[
							-81.40487808299991,
							28.60018208300005
						],
						[
							-81.4049206279999,
							28.60014221100005
						],
						[
							-81.40493970899992,
							28.600125457000047
						],
						[
							-81.40496008299993,
							28.600105083000074
						],
						[
							-81.40497682299991,
							28.60008877300004
						],
						[
							-81.4049773239999,
							28.600086828000087
						],
						[
							-81.40499232299993,
							28.600028828000063
						],
						[
							-81.40499432199994,
							28.60002123800007
						],
						[
							-81.40501140499993,
							28.599964922000083
						],
						[
							-81.40503213499994,
							28.59990984400008
						],
						[
							-81.40503933799994,
							28.59989294400009
						],
						[
							-81.40504337099993,
							28.59985661500008
						],
						[
							-81.40505295799994,
							28.59979855100005
						],
						[
							-81.40506632099995,
							28.599741239000082
						],
						[
							-81.40506736599991,
							28.59973737200005
						],
						[
							-81.4050883669999,
							28.599660372000073
						],
						[
							-81.40510440499992,
							28.599607923000065
						],
						[
							-81.40511470199993,
							28.59957919900006
						],
						[
							-81.40511611599993,
							28.599533917000088
						],
						[
							-81.40511760299995,
							28.599503182000035
						],
						[
							-81.4051227189999,
							28.599449686000074
						],
						[
							-81.40514071899992,
							28.599306685000045
						],
						[
							-81.4051413709999,
							28.59930161500006
						],
						[
							-81.40515095799992,
							28.599243551000086
						],
						[
							-81.40516432099993,
							28.599186238000073
						],
						[
							-81.4051814039999,
							28.59912992200009
						],
						[
							-81.40518652199995,
							28.599115263000044
						],
						[
							-81.40524752199991,
							28.598945263000076
						],
						[
							-81.40526313499993,
							28.59890484400006
						],
						[
							-81.4052874219999,
							28.598851240000045
						],
						[
							-81.40531516399994,
							28.59879933900004
						],
						[
							-81.4053462409999,
							28.59874936400007
						],
						[
							-81.40538051999994,
							28.59870152800005
						],
						[
							-81.4053872479999,
							28.598692869000047
						],
						[
							-81.40548324799994,
							28.59857086900007
						],
						[
							-81.40550861499992,
							28.59854006300009
						],
						[
							-81.40555105199991,
							28.598490797000068
						],
						[
							-81.4055768099999,
							28.598449667000068
						],
						[
							-81.40559124099991,
							28.59842736300004
						],
						[
							-81.40562551999994,
							28.59837952700008
						],
						[
							-81.4056628539999,
							28.59833403500005
						],
						[
							-81.40570308399992,
							28.598291083000053
						],
						[
							-81.40574603599994,
							28.59825085400007
						],
						[
							-81.40579152799995,
							28.59821352000006
						],
						[
							-81.4058176129999,
							28.598194241000044
						],
						[
							-81.40592161199993,
							28.59812024100006
						],
						[
							-81.40594336299995,
							28.59810524100004
						],
						[
							-81.4059933389999,
							28.59807416400008
						],
						[
							-81.40604523999991,
							28.59804642200004
						],
						[
							-81.40605064999994,
							28.598043777000044
						],
						[
							-81.40618264999995,
							28.597979777000035
						],
						[
							-81.40623084499993,
							28.597958134000066
						],
						[
							-81.40628592299993,
							28.59793740400005
						],
						[
							-81.40634223899991,
							28.59792032100006
						],
						[
							-81.40639955099994,
							28.597906958000067
						],
						[
							-81.40645761499991,
							28.597897371000045
						],
						[
							-81.4065161819999,
							28.59789160300005
						],
						[
							-81.40657499999992,
							28.597889678000058
						],
						[
							-81.40663381899992,
							28.59789160300005
						],
						[
							-81.40667288599991,
							28.597895021000056
						],
						[
							-81.4068098859999,
							28.597910021000075
						],
						[
							-81.40682938499992,
							28.597912372000053
						],
						[
							-81.4068874489999,
							28.597921958000086
						],
						[
							-81.40692075099992,
							28.597929241000088
						],
						[
							-81.40700875099992,
							28.597950241000035
						],
						[
							-81.40703276199991,
							28.597956322000073
						],
						[
							-81.40708907699991,
							28.59797340500006
						],
						[
							-81.4071441559999,
							28.597994135000082
						],
						[
							-81.40715985199995,
							28.598000812000066
						],
						[
							-81.40721171399991,
							28.59802345500009
						],
						[
							-81.40724341799995,
							28.598029678000046
						],
						[
							-81.40724531199993,
							28.598029678000046
						],
						[
							-81.40729102499995,
							28.598020887000075
						],
						[
							-81.40751297599991,
							28.59795029500009
						],
						[
							-81.40751731199992,
							28.597948005000035
						],
						[
							-81.40758843899994,
							28.59782864200008
						],
						[
							-81.40761324099994,
							28.59778936300006
						],
						[
							-81.4076475199999,
							28.59774152700004
						],
						[
							-81.40768485399991,
							28.59769603600006
						],
						[
							-81.40772508299995,
							28.59765308300007
						],
						[
							-81.40776803599994,
							28.597612854000094
						],
						[
							-81.40781352699992,
							28.597575520000078
						],
						[
							-81.40782574699995,
							28.59756630700008
						],
						[
							-81.40784551999991,
							28.597539527000038
						],
						[
							-81.40788285399992,
							28.597494035000068
						],
						[
							-81.4079230829999,
							28.597451083000067
						],
						[
							-81.40796603599995,
							28.59741085400009
						],
						[
							-81.40801152699993,
							28.597373519000087
						],
						[
							-81.40802086699995,
							28.59736644900005
						],
						[
							-81.40809793999995,
							28.597308888000043
						],
						[
							-81.40806499999991,
							28.59861200000006
						],
						[
							-81.4080633449999,
							28.598676672000067
						],
						[
							-81.40804999999995,
							28.599198000000058
						],
						[
							-81.40859799999993,
							28.599226000000044
						],
						[
							-81.40853199999992,
							28.60021500000005
						],
						[
							-81.40852199999995,
							28.60036000000008
						],
						[
							-81.40992299999994,
							28.600380000000087
						],
						[
							-81.4099159999999,
							28.600258000000057
						],
						[
							-81.40999599999992,
							28.600227000000075
						],
						[
							-81.4107909999999,
							28.600058000000047
						],
						[
							-81.41088699999995,
							28.600042000000087
						],
						[
							-81.41109199999994,
							28.600036000000046
						],
						[
							-81.41127199999994,
							28.600031000000058
						],
						[
							-81.4114879999999,
							28.600025000000073
						],
						[
							-81.41159199999993,
							28.600033000000053
						],
						[
							-81.41170599999992,
							28.600022000000084
						],
						[
							-81.4117589999999,
							28.600022000000084
						],
						[
							-81.41203999999993,
							28.599945000000048
						],
						[
							-81.41228899999993,
							28.59988400000009
						],
						[
							-81.41264799999993,
							28.599757000000068
						],
						[
							-81.41262899999992,
							28.598854000000074
						],
						[
							-81.41260099999994,
							28.597511000000054
						],
						[
							-81.4125919999999,
							28.59737700000005
						],
						[
							-81.41256141599992,
							28.59633234800009
						],
						[
							-81.4125769449999,
							28.596329618000084
						],
						[
							-81.41258445699992,
							28.596326699000088
						],
						[
							-81.4127109769999,
							28.596252615000083
						],
						[
							-81.41275449599993,
							28.596214340000074
						],
						[
							-81.41275060299995,
							28.596174818000065
						],
						[
							-81.4127486779999,
							28.596116000000052
						],
						[
							-81.41275060299995,
							28.59605718100005
						],
						[
							-81.41275637199993,
							28.595998614000052
						],
						[
							-81.41276595799991,
							28.59594055100007
						],
						[
							-81.41277932199995,
							28.595883238000056
						],
						[
							-81.41279640499994,
							28.595826922000075
						],
						[
							-81.4128171349999,
							28.59577184400007
						],
						[
							-81.4128180859999,
							28.59576955600005
						],
						[
							-81.41291690899993,
							28.595532823000042
						],
						[
							-81.41389099999992,
							28.595552000000055
						],
						[
							-81.41391887999993,
							28.59555253900004
						],
						[
							-81.41508099999993,
							28.595575000000053
						],
						[
							-81.41524399999992,
							28.595578000000046
						],
						[
							-81.41550762799994,
							28.595577956000056
						],
						[
							-81.4157251339999,
							28.595576788000074
						],
						[
							-81.4161465979999,
							28.596375211000066
						],
						[
							-81.4167215139999,
							28.597491795000053
						],
						[
							-81.4167966249999,
							28.59764101600007
						],
						[
							-81.41688775999995,
							28.59781827900008
						],
						[
							-81.4168929999999,
							28.59786500000007
						],
						[
							-81.41685799999995,
							28.597909000000072
						],
						[
							-81.4165549999999,
							28.59829600000006
						],
						[
							-81.41646299999991,
							28.598343000000057
						],
						[
							-81.41720860399994,
							28.59976240900005
						],
						[
							-81.41721206199992,
							28.599768992000065
						],
						[
							-81.41727299999991,
							28.599885000000086
						],
						[
							-81.41726795099993,
							28.59989351100006
						],
						[
							-81.41720299999992,
							28.600003000000072
						],
						[
							-81.41710799999993,
							28.600272000000075
						],
						[
							-81.41722499999992,
							28.60094200000009
						],
						[
							-81.41751399999993,
							28.60179000000005
						],
						[
							-81.41753799999992,
							28.601828000000072
						],
						[
							-81.41746499999994,
							28.601829000000066
						],
						[
							-81.41714999999994,
							28.601825000000076
						],
						[
							-81.41683199999994,
							28.60182000000009
						],
						[
							-81.41695631099992,
							28.602602667000042
						],
						[
							-81.4169839999999,
							28.60277700000006
						],
						[
							-81.41700999999995,
							28.60293800000005
						],
						[
							-81.41706715299995,
							28.60326253300008
						],
						[
							-81.41715299999993,
							28.60375000000005
						],
						[
							-81.4167129999999,
							28.603752000000043
						],
						[
							-81.41659599999991,
							28.603755000000035
						],
						[
							-81.41480899999993,
							28.603755000000035
						],
						[
							-81.41480458399991,
							28.60403853300005
						],
						[
							-81.41480399999995,
							28.60407600000008
						],
						[
							-81.41459199999991,
							28.60407700000008
						],
						[
							-81.41456199999993,
							28.604401000000053
						],
						[
							-81.41431309799994,
							28.604401000000053
						],
						[
							-81.41412899999995,
							28.604401000000053
						],
						[
							-81.41399299999995,
							28.604401000000053
						],
						[
							-81.41399199999995,
							28.604877000000045
						],
						[
							-81.41299199999992,
							28.604877000000045
						],
						[
							-81.41241042999991,
							28.604877000000045
						],
						[
							-81.41229199999992,
							28.604877000000045
						],
						[
							-81.4114919999999,
							28.604877000000045
						],
						[
							-81.41059199999995,
							28.604877000000045
						],
						[
							-81.41045699999995,
							28.604877000000045
						],
						[
							-81.41045699999995,
							28.60391700000008
						],
						[
							-81.41000185799993,
							28.60391297200005
						],
						[
							-81.4098919999999,
							28.603912000000037
						],
						[
							-81.40976099999995,
							28.603913000000095
						],
						[
							-81.40976599999993,
							28.605744000000072
						],
						[
							-81.40960199999995,
							28.60561000000007
						],
						[
							-81.40902299999993,
							28.60513000000009
						],
						[
							-81.40901006099995,
							28.603923687000076
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Lake Fairview",
				"RegionID": "269038"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.13852187499992,
					26.13693952600005,
					-80.12013460399993,
					26.14279934700005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.13624749999991,
							26.137004755000078
						],
						[
							-80.13633981399994,
							26.136977624000053
						],
						[
							-80.13741523099992,
							26.136952678000057
						],
						[
							-80.13794403899993,
							26.13693952600005
						],
						[
							-80.13812325899994,
							26.137000881000063
						],
						[
							-80.13826048599992,
							26.136993739000047
						],
						[
							-80.13852187499992,
							26.136989864000043
						],
						[
							-80.13846679099993,
							26.137047819000088
						],
						[
							-80.13658800499991,
							26.138998713000035
						],
						[
							-80.13598920299995,
							26.13962279100008
						],
						[
							-80.13566864199993,
							26.13969274200008
						],
						[
							-80.13541612199992,
							26.139760719000037
						],
						[
							-80.13538504899994,
							26.139985205000073
						],
						[
							-80.13542646899992,
							26.14006531600006
						],
						[
							-80.13332716499991,
							26.142447961000073
						],
						[
							-80.12886755599993,
							26.142574016000086
						],
						[
							-80.12789811699992,
							26.142599053000087
						],
						[
							-80.12695371699994,
							26.142626093000047
						],
						[
							-80.12600731299995,
							26.142653132000078
						],
						[
							-80.12506090999995,
							26.142679171000054
						],
						[
							-80.12023169299994,
							26.14279934700005
						],
						[
							-80.12019569499995,
							26.14151945100008
						],
						[
							-80.12015663699992,
							26.14011637100009
						],
						[
							-80.12013460399993,
							26.13936025000004
						],
						[
							-80.12013860899992,
							26.13923406300006
						],
						[
							-80.12013660799994,
							26.139166961000058
						],
						[
							-80.12015162999995,
							26.13907983300004
						],
						[
							-80.1201796709999,
							26.138973675000045
						],
						[
							-80.12022373499991,
							26.138863513000047
						],
						[
							-80.12026078999993,
							26.13878539700005
						],
						[
							-80.12034191299995,
							26.138629165000054
						],
						[
							-80.12057116699992,
							26.13831059100005
						],
						[
							-80.12141149799993,
							26.13787805100009
						],
						[
							-80.12206617599992,
							26.137507458000073
						],
						[
							-80.12265534199992,
							26.13749648600009
						],
						[
							-80.1229938429999,
							26.137489474000063
						],
						[
							-80.12393123499993,
							26.137455424000052
						],
						[
							-80.12487964099995,
							26.13742838400009
						],
						[
							-80.1252501909999,
							26.137416366000082
						],
						[
							-80.12580200899993,
							26.13739834000006
						],
						[
							-80.12588312799994,
							26.137393332000048
						],
						[
							-80.12661821899991,
							26.137376306000082
						],
						[
							-80.12678546799992,
							26.137375306000084
						],
						[
							-80.12771584699993,
							26.13733224100008
						],
						[
							-80.12868027699994,
							26.137319222000087
						],
						[
							-80.12967975899994,
							26.13728917700007
						],
						[
							-80.1305901099999,
							26.137270150000063
						],
						[
							-80.13156856099994,
							26.137247115000037
						],
						[
							-80.13180591199995,
							26.13724110600009
						],
						[
							-80.13249994199992,
							26.137224081000056
						],
						[
							-80.13289352499993,
							26.137222078000036
						],
						[
							-80.13292056599994,
							26.137222078000036
						],
						[
							-80.13317093699993,
							26.13721206300005
						],
						[
							-80.1334373329999,
							26.13720505200007
						],
						[
							-80.13409130299993,
							26.137188027000036
						],
						[
							-80.13439274899991,
							26.13718001500007
						],
						[
							-80.13533815199992,
							26.137159986000086
						],
						[
							-80.13552743299994,
							26.137143962000042
						],
						[
							-80.13592502199992,
							26.13708487400004
						],
						[
							-80.1361042879999,
							26.137045816000068
						],
						[
							-80.13624749999991,
							26.137004755000078
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Lake Ridge",
				"RegionID": "269049"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.74152266199991,
					30.265445683000053,
					-81.71728583399994,
					30.292055008000087
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.72065884999995,
							30.292030010000076
						],
						[
							-81.72063490699992,
							30.290941007000075
						],
						[
							-81.72077195899993,
							30.290091008000044
						],
						[
							-81.72066190599992,
							30.28924400800008
						],
						[
							-81.72061490599992,
							30.288525008000082
						],
						[
							-81.72058190599996,
							30.28748900800008
						],
						[
							-81.7205989059999,
							30.286631008000086
						],
						[
							-81.72060690599994,
							30.285780009000064
						],
						[
							-81.72068190499994,
							30.284769009000062
						],
						[
							-81.72070590499993,
							30.284041008000084
						],
						[
							-81.7207119059999,
							30.283088009000036
						],
						[
							-81.72072590499994,
							30.28218800900004
						],
						[
							-81.72067290599995,
							30.280516008000067
						],
						[
							-81.72063190599994,
							30.27972900900005
						],
						[
							-81.72055090499993,
							30.278827008000068
						],
						[
							-81.7204479049999,
							30.27798400900008
						],
						[
							-81.72031590499996,
							30.277369008000054
						],
						[
							-81.72026990599994,
							30.277227008000068
						],
						[
							-81.72019590499991,
							30.27705700900009
						],
						[
							-81.72008090499992,
							30.27679400800008
						],
						[
							-81.71998290499994,
							30.276574009000058
						],
						[
							-81.71985090599992,
							30.276347008000076
						],
						[
							-81.71971090599993,
							30.27613500900009
						],
						[
							-81.71955490499994,
							30.27592200800007
						],
						[
							-81.71949790499991,
							30.275858008000057
						],
						[
							-81.71920190499992,
							30.27551000800008
						],
						[
							-81.7189809059999,
							30.275297008000052
						],
						[
							-81.71795999999995,
							30.27439600000008
						],
						[
							-81.71728583399994,
							30.273801010000057
						],
						[
							-81.71733023299993,
							30.273753993000074
						],
						[
							-81.71738114399994,
							30.273707737000052
						],
						[
							-81.7180735359999,
							30.27312540900005
						],
						[
							-81.71813108599991,
							30.273080906000075
						],
						[
							-81.71819204399993,
							30.27304120000008
						],
						[
							-81.71825601299992,
							30.27300655100004
						],
						[
							-81.71832257299991,
							30.27297718600005
						],
						[
							-81.7183912879999,
							30.272953298000065
						],
						[
							-81.71846170999993,
							30.272935041000043
						],
						[
							-81.71855870999991,
							30.272914041000035
						],
						[
							-81.71859283499992,
							30.272907341000067
						],
						[
							-81.71874899999995,
							30.27289367800006
						],
						[
							-81.7189051659999,
							30.272907341000067
						],
						[
							-81.7190565869999,
							30.272947914000042
						],
						[
							-81.71911123899991,
							30.27296483100008
						],
						[
							-81.71911384899994,
							30.27288473300007
						],
						[
							-81.71912361199992,
							30.272805190000042
						],
						[
							-81.71914045099993,
							30.272726839000086
						],
						[
							-81.71916422899994,
							30.27265030800004
						],
						[
							-81.71919475599992,
							30.272576210000068
						],
						[
							-81.71923178899993,
							30.27250513900009
						],
						[
							-81.7192750289999,
							30.27243766600009
						],
						[
							-81.71932413099995,
							30.272374330000044
						],
						[
							-81.7193991819999,
							30.27228673100007
						],
						[
							-81.7194189359999,
							30.272264443000044
						],
						[
							-81.72042593599991,
							30.271165442000036
						],
						[
							-81.72047066499994,
							30.27111997400004
						],
						[
							-81.72181982299992,
							30.269842487000062
						],
						[
							-81.72198848699992,
							30.269633320000082
						],
						[
							-81.72205022799994,
							30.26949063800004
						],
						[
							-81.72201056199994,
							30.26934527600008
						],
						[
							-81.72198545099991,
							30.269213221000083
						],
						[
							-81.72197067799993,
							30.269051000000044
						],
						[
							-81.7219741589999,
							30.268971952000072
						],
						[
							-81.72198615899993,
							30.268835952000078
						],
						[
							-81.72200079599992,
							30.268735392000053
						],
						[
							-81.7220967959999,
							30.26826439200005
						],
						[
							-81.72212651799992,
							30.268154591000037
						],
						[
							-81.7222507159999,
							30.267789502000085
						],
						[
							-81.72232016499993,
							30.267638339000086
						],
						[
							-81.72237865799991,
							30.267549589000055
						],
						[
							-81.72259765699994,
							30.267256589000052
						],
						[
							-81.7226278569999,
							30.26721838700007
						],
						[
							-81.72282146799995,
							30.26698665700008
						],
						[
							-81.72293292699993,
							30.266875079000044
						],
						[
							-81.72306768099992,
							30.266781571000084
						],
						[
							-81.7239590239999,
							30.26628597700005
						],
						[
							-81.72404437299991,
							30.266244269000083
						],
						[
							-81.7252213729999,
							30.26574426900004
						],
						[
							-81.72530958199991,
							30.26571212200008
						],
						[
							-81.72605058199991,
							30.26548512100004
						],
						[
							-81.72611588299993,
							30.26546777100009
						],
						[
							-81.72618230199993,
							30.265455373000066
						],
						[
							-81.72624946499991,
							30.265447996000034
						],
						[
							-81.72631699199991,
							30.265445683000053
						],
						[
							-81.72638450199992,
							30.26544844500006
						],
						[
							-81.72705850099993,
							30.26550144600009
						],
						[
							-81.7271324319999,
							30.265510352000035
						],
						[
							-81.7272053719999,
							30.265525344000082
						],
						[
							-81.72727682199992,
							30.26554631800008
						],
						[
							-81.72734629199994,
							30.265573132000043
						],
						[
							-81.72741330499991,
							30.265605602000054
						],
						[
							-81.72747740299991,
							30.26564350400008
						],
						[
							-81.72810640299991,
							30.266051504000075
						],
						[
							-81.7281654869999,
							30.26609330000008
						],
						[
							-81.72822101899993,
							30.266139711000047
						],
						[
							-81.7282726389999,
							30.26619043800008
						],
						[
							-81.72832001299992,
							30.266245151000078
						],
						[
							-81.72932601299993,
							30.26750615000009
						],
						[
							-81.7293668069999,
							30.267561499000067
						],
						[
							-81.72992680799992,
							30.268385499000086
						],
						[
							-81.72999103599994,
							30.26849621200006
						],
						[
							-81.73089355299994,
							30.270325417000038
						],
						[
							-81.7309408889999,
							30.27032808000007
						],
						[
							-81.73228358499995,
							30.272133264000043
						],
						[
							-81.73307756799994,
							30.273143788000084
						],
						[
							-81.73372718999991,
							30.274027997000076
						],
						[
							-81.73430463299991,
							30.274533259000066
						],
						[
							-81.73508057099991,
							30.274749800000052
						],
						[
							-81.73573019399993,
							30.27473175500006
						],
						[
							-81.73628959099995,
							30.275020476000066
						],
						[
							-81.73746252099994,
							30.275706189000058
						],
						[
							-81.73890612699995,
							30.276536262000036
						],
						[
							-81.73970010999994,
							30.277023479000036
						],
						[
							-81.7406564989999,
							30.27751069600004
						],
						[
							-81.7411256709999,
							30.277871598000043
						],
						[
							-81.74137830199993,
							30.278376860000037
						],
						[
							-81.74152266199991,
							30.278846032000047
						],
						[
							-81.74152266199991,
							30.279531745000046
						],
						[
							-81.74145048199995,
							30.279910691000058
						],
						[
							-81.7411256709999,
							30.28059640400005
						],
						[
							-81.74089108499993,
							30.280921215000035
						],
						[
							-81.74089108499993,
							30.28110166600004
						],
						[
							-81.74096326499995,
							30.281318207000087
						],
						[
							-81.74081890499991,
							30.28166106300006
						],
						[
							-81.74068399999993,
							30.28195500000004
						],
						[
							-81.7406199639999,
							30.282087008000076
						],
						[
							-81.7381439049999,
							30.282095008000056
						],
						[
							-81.73783090599994,
							30.28210100800004
						],
						[
							-81.73732790499992,
							30.282095008000056
						],
						[
							-81.7366099059999,
							30.282103007000046
						],
						[
							-81.73532090499992,
							30.282103007000046
						],
						[
							-81.73452790599993,
							30.282110009000064
						],
						[
							-81.7328029059999,
							30.282116008000063
						],
						[
							-81.73244490499991,
							30.282129009000073
						],
						[
							-81.73128490599993,
							30.28212200800004
						],
						[
							-81.73034677599992,
							30.282126876000063
						],
						[
							-81.73033890599993,
							30.282589008000055
						],
						[
							-81.73036190499994,
							30.283075008000083
						],
						[
							-81.73037690599995,
							30.283707008000082
						],
						[
							-81.7303769049999,
							30.283806008000052
						],
						[
							-81.73036190499994,
							30.28395800800007
						],
						[
							-81.73035490599995,
							30.284124008000052
						],
						[
							-81.73035790599994,
							30.28555600800007
						],
						[
							-81.73034690599991,
							30.286526008000063
						],
						[
							-81.73035390599995,
							30.286823008000056
						],
						[
							-81.73036990599991,
							30.28841600800007
						],
						[
							-81.73036190499994,
							30.288685008000073
						],
						[
							-81.73036990599991,
							30.289028009000052
						],
						[
							-81.73036990599991,
							30.289310008000086
						],
						[
							-81.73037690699994,
							30.290163008000036
						],
						[
							-81.73038490499994,
							30.290213008000084
						],
						[
							-81.73039190599991,
							30.29102700900006
						],
						[
							-81.73039996099993,
							30.29199401200009
						],
						[
							-81.73023990599995,
							30.29200000900005
						],
						[
							-81.7293849049999,
							30.29199700800007
						],
						[
							-81.7283249059999,
							30.292006008000048
						],
						[
							-81.72621890499994,
							30.292028008000045
						],
						[
							-81.7244949059999,
							30.29205000800005
						],
						[
							-81.72417390599992,
							30.292055008000087
						],
						[
							-81.72367990599992,
							30.29205000800005
						],
						[
							-81.72203790599991,
							30.292044008000065
						],
						[
							-81.72065884999995,
							30.292030010000076
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Lakeshore",
				"RegionID": "269056"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.11053937399994,
					26.189703855000065,
					-80.10099451799994,
					26.201976112000068
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.10919938699993,
							26.189740966000045
						],
						[
							-80.11050432299993,
							26.189703855000065
						],
						[
							-80.11052935899994,
							26.19064430600008
						],
						[
							-80.11053937399994,
							26.19205840300009
						],
						[
							-80.11041318799994,
							26.19637481700005
						],
						[
							-80.1104032739999,
							26.19683053500006
						],
						[
							-80.11025194799993,
							26.19683548800009
						],
						[
							-80.10570707399995,
							26.196961547000058
						],
						[
							-80.10580134799994,
							26.201386247000073
						],
						[
							-80.1058134779999,
							26.201962092000088
						],
						[
							-80.10440928299994,
							26.201976112000068
						],
						[
							-80.1032996369999,
							26.20194606700005
						],
						[
							-80.1026085929999,
							26.201835994000078
						],
						[
							-80.1016762289999,
							26.201597550000088
						],
						[
							-80.10155399999992,
							26.201572000000056
						],
						[
							-80.10099451799994,
							26.20142891800009
						],
						[
							-80.10230199999997,
							26.19688400000007
						],
						[
							-80.1023659999999,
							26.196661000000063
						],
						[
							-80.10294575299991,
							26.189897212000062
						],
						[
							-80.10331599999995,
							26.18989300000004
						],
						[
							-80.10382741799994,
							26.189887182000064
						],
						[
							-80.10395060399992,
							26.18985814100006
						],
						[
							-80.10537771799994,
							26.189828096000042
						],
						[
							-80.10691800299992,
							26.189795046000086
						],
						[
							-80.10874871699991,
							26.18975098100009
						],
						[
							-80.10919938699993,
							26.189740966000045
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Landings",
				"RegionID": "269058"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.20146899999992,
					26.104469238000036,
					-80.18582903599992,
					26.106744878000086
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.18584005799994,
							26.10669783700007
						],
						[
							-80.18585206599994,
							26.106345286000078
						],
						[
							-80.18585206599994,
							26.10619906900007
						],
						[
							-80.18582903599992,
							26.10560618900007
						],
						[
							-80.19056705899993,
							26.10472087900007
						],
						[
							-80.19226657999991,
							26.10467781400007
						],
						[
							-80.20078320999994,
							26.10448953300005
						],
						[
							-80.2013660749999,
							26.104472508000075
						],
						[
							-80.20146899999992,
							26.104469238000036
						],
						[
							-80.20146899999992,
							26.105064000000088
						],
						[
							-80.20146899999992,
							26.105864000000054
						],
						[
							-80.20146899999992,
							26.10591504000007
						],
						[
							-80.20146899999992,
							26.106264000000067
						],
						[
							-80.20146899999992,
							26.106464000000074
						],
						[
							-80.20116899999994,
							26.106464000000074
						],
						[
							-80.20097199999992,
							26.106453000000045
						],
						[
							-80.20054717199992,
							26.106431288000067
						],
						[
							-80.19771806799992,
							26.106454477000057
						],
						[
							-80.19757614399992,
							26.10646078500008
						],
						[
							-80.19615278499992,
							26.10652404500007
						],
						[
							-80.19411211999994,
							26.106558829000054
						],
						[
							-80.19342347199995,
							26.106520195000087
						],
						[
							-80.19342342199991,
							26.106518410000035
						],
						[
							-80.18681849899991,
							26.106744878000086
						],
						[
							-80.18584005799994,
							26.10669783700007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Lauderdale West",
				"RegionID": "269063"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.23122999999994,
					25.762960000000064,
					-80.1996098959999,
					25.783817520000092
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.21448087599994,
							25.782517959000124
						],
						[
							-80.21375326099987,
							25.782269038000045
						],
						[
							-80.21262354399992,
							25.78186693600017
						],
						[
							-80.21168530399991,
							25.78146483300021
						],
						[
							-80.21116831499995,
							25.781196764000143
						],
						[
							-80.21072791699993,
							25.780890400000196
						],
						[
							-80.21036410999993,
							25.78050744500004
						],
						[
							-80.20986626799987,
							25.780067047000017
						],
						[
							-80.20923439199981,
							25.779569206000126
						],
						[
							-80.20877484599988,
							25.77930113700006
						],
						[
							-80.20814297099992,
							25.7790139210001
						],
						[
							-80.20726217399988,
							25.778611818000137
						],
						[
							-80.20697495799992,
							25.778362897000058
						],
						[
							-80.20692552699991,
							25.77831964600012
						],
						[
							-80.20682177599986,
							25.77822886300016
						],
						[
							-80.20643882099996,
							25.778075681000097
						],
						[
							-80.2056920589999,
							25.77765443100006
						],
						[
							-80.20527080799987,
							25.77752039600007
						],
						[
							-80.2043900119999,
							25.77730977100014
						],
						[
							-80.20414109099991,
							25.777175737000064
						],
						[
							-80.2038155789999,
							25.77673533900004
						],
						[
							-80.20331773799991,
							25.77602687200013
						],
						[
							-80.20293478299993,
							25.7758162470002
						],
						[
							-80.20247523699993,
							25.775394996000074
						],
						[
							-80.20186250799986,
							25.774763120000017
						],
						[
							-80.20132637099982,
							25.774226983000155
						],
						[
							-80.2008859729998,
							25.7735759600002
						],
						[
							-80.20063705199989,
							25.773135562000178
						],
						[
							-80.20044557499995,
							25.772924936000162
						],
						[
							-80.2002732449999,
							25.772676016000172
						],
						[
							-80.2001583589999,
							25.77235050400006
						],
						[
							-80.20013921099991,
							25.771833514000093
						],
						[
							-80.20004347199989,
							25.771603741
						],
						[
							-80.19983284699988,
							25.77110590000011
						],
						[
							-80.19971893299987,
							25.770977747000074
						],
						[
							-80.19980769999992,
							25.77062810600019
						],
						[
							-80.19979250999991,
							25.770593452000163
						],
						[
							-80.1996098959999,
							25.770176837000065
						],
						[
							-80.19994652399987,
							25.76886575600021
						],
						[
							-80.20022141999988,
							25.765331382000163
						],
						[
							-80.2000960939999,
							25.76330239200015
						],
						[
							-80.20035664899987,
							25.763305752000072
						],
						[
							-80.20114460399988,
							25.76329331600011
						],
						[
							-80.20306871699982,
							25.763210434000182
						],
						[
							-80.20499659799991,
							25.76315125200008
						],
						[
							-80.20665975799994,
							25.76310092500009
						],
						[
							-80.20779864499985,
							25.76309127400009
						],
						[
							-80.20928738199984,
							25.763055151000035
						],
						[
							-80.21077649099995,
							25.763014695000063
						],
						[
							-80.2113452364998,
							25.763008414500206
						],
						[
							-80.21134999999988,
							25.763010000000115
						],
						[
							-80.21162442999986,
							25.763007111000142
						],
						[
							-80.2118310659999,
							25.76300493600005
						],
						[
							-80.21231383699987,
							25.762999605000058
						],
						[
							-80.21264999999988,
							25.76299000000006
						],
						[
							-80.21274968799989,
							25.76298822000009
						],
						[
							-80.21316287499987,
							25.76298084200001
						],
						[
							-80.21359901599989,
							25.762973053000167
						],
						[
							-80.21396629299981,
							25.76296649500016
						],
						[
							-80.21421723199988,
							25.762962014000053
						],
						[
							-80.21432999999989,
							25.762960000000064
						],
						[
							-80.2143365079999,
							25.763116188000197
						],
						[
							-80.21433999999992,
							25.763200000000026
						],
						[
							-80.2143451749999,
							25.763322479000124
						],
						[
							-80.21434913099996,
							25.763416101000054
						],
						[
							-80.2143559109999,
							25.763576549000007
						],
						[
							-80.21436753299989,
							25.763851604000116
						],
						[
							-80.21436999999992,
							25.763910000000152
						],
						[
							-80.21437453599994,
							25.76401205400007
						],
						[
							-80.2143806019999,
							25.764148537000082
						],
						[
							-80.2143899999999,
							25.76436000000008
						],
						[
							-80.21439382399984,
							25.76456264600015
						],
						[
							-80.21439730499986,
							25.76474714400014
						],
						[
							-80.21439999999991,
							25.764890000000058
						],
						[
							-80.21440642899991,
							25.76504591200017
						],
						[
							-80.21441682699988,
							25.76529806700016
						],
						[
							-80.21442253799991,
							25.76543655100007
						],
						[
							-80.2144319909999,
							25.76566578200012
						],
						[
							-80.21444077799991,
							25.765830659000173
						],
						[
							-80.21471995499992,
							25.765854044000065
						],
						[
							-80.21947967599992,
							25.765719825000062
						],
						[
							-80.21948642699995,
							25.76564288100009
						],
						[
							-80.2194975999999,
							25.765434409000072
						],
						[
							-80.21948399699993,
							25.765067899000123
						],
						[
							-80.21947999999986,
							25.764920000000053
						],
						[
							-80.21963932399991,
							25.764913627000148
						],
						[
							-80.21998320599992,
							25.764899872000164
						],
						[
							-80.22028123599989,
							25.764887951000155
						],
						[
							-80.22047999999991,
							25.764880000000122
						],
						[
							-80.22083299999991,
							25.764871219000014
						],
						[
							-80.22115427099992,
							25.764863227000063
						],
						[
							-80.22170502099992,
							25.764849527000173
						],
						[
							-80.22214103199985,
							25.764838681000164
						],
						[
							-80.22248999999995,
							25.76483000000007
						],
						[
							-80.22273758499983,
							25.764822789000096
						],
						[
							-80.22303717599992,
							25.76481406300008
						],
						[
							-80.22358846799989,
							25.764798006000085
						],
						[
							-80.22418497799985,
							25.76478063200007
						],
						[
							-80.22454999999987,
							25.764770000000077
						],
						[
							-80.22489628399991,
							25.764761513000177
						],
						[
							-80.22533342699994,
							25.764750798000087
						],
						[
							-80.22588418799994,
							25.764737299000128
						],
						[
							-80.22625136099985,
							25.764728300000183
						],
						[
							-80.22658999999982,
							25.764720000000025
						],
						[
							-80.22658999999982,
							25.76463000000004
						],
						[
							-80.22700957599989,
							25.764613248000074
						],
						[
							-80.22742319499991,
							25.764604510000062
						],
						[
							-80.22781337699978,
							25.76459626700018
						],
						[
							-80.2281099999999,
							25.764590000000105
						],
						[
							-80.2284330679999,
							25.76458340700018
						],
						[
							-80.22884621399989,
							25.764574975000194
						],
						[
							-80.2292134549999,
							25.76456748100011
						],
						[
							-80.22957999999994,
							25.76456000000011
						],
						[
							-80.22992785399994,
							25.764538818000133
						],
						[
							-80.23022530799994,
							25.76452111300018
						],
						[
							-80.2305799999999,
							25.76450000000012
						],
						[
							-80.23069999999989,
							25.76450000000012
						],
						[
							-80.2307099999999,
							25.764580000000166
						],
						[
							-80.23071596599986,
							25.764827607000136
						],
						[
							-80.23072406599992,
							25.76516375500006
						],
						[
							-80.23073269399993,
							25.76541528500009
						],
						[
							-80.23070281899986,
							25.7654160795002
						],
						[
							-80.23060092799994,
							25.765418698000104
						],
						[
							-80.2306015489999,
							25.765522219000054
						],
						[
							-80.23060382799993,
							25.765672621000064
						],
						[
							-80.23060773399989,
							25.76593045400017
						],
						[
							-80.2306100399998,
							25.766080999000103
						],
						[
							-80.23061999999992,
							25.76633000000001
						],
						[
							-80.23062348499985,
							25.766381120000155
						],
						[
							-80.23063535199987,
							25.76655516900008
						],
						[
							-80.2306484789998,
							25.76674769200011
						],
						[
							-80.23066763899986,
							25.76702869800009
						],
						[
							-80.23067999999991,
							25.76721000000017
						],
						[
							-80.23068474899986,
							25.76734931400015
						],
						[
							-80.23068840799989,
							25.76745664400015
						],
						[
							-80.23069279899981,
							25.767585440000147
						],
						[
							-80.23070011699988,
							25.767800100000144
						],
						[
							-80.2307099999999,
							25.76809000000015
						],
						[
							-80.23071664399993,
							25.768231186000108
						],
						[
							-80.23072370799989,
							25.768381290000093
						],
						[
							-80.23073077099986,
							25.768531394000078
						],
						[
							-80.23074187199988,
							25.768767272000055
						],
						[
							-80.23074999999993,
							25.76897000000013
						],
						[
							-80.23074999999993,
							25.76908949900016
						],
						[
							-80.23074999999993,
							25.76919695300017
						],
						[
							-80.23074999999993,
							25.76936000000007
						],
						[
							-80.2307699999999,
							25.769580000000154
						],
						[
							-80.23077335999982,
							25.76973454000015
						],
						[
							-80.23077616099988,
							25.769863425000068
						],
						[
							-80.23077999999992,
							25.770040000000023
						],
						[
							-80.23078693599987,
							25.770144043000194
						],
						[
							-80.23079977399988,
							25.77033660600005
						],
						[
							-80.23082184999993,
							25.77061477000015
						],
						[
							-80.23082999999988,
							25.770790000000083
						],
						[
							-80.2308407639999,
							25.771023221000107
						],
						[
							-80.23085075299991,
							25.771239654000162
						],
						[
							-80.23085999999988,
							25.77144000000004
						],
						[
							-80.23086397599985,
							25.77156127700004
						],
						[
							-80.23086890299992,
							25.771711552000127
						],
						[
							-80.2308773499999,
							25.771969166000126
						],
						[
							-80.23088942499992,
							25.772247920000098
						],
						[
							-80.23089759299988,
							25.772419458000083
						],
						[
							-80.2309599999999,
							25.772600000000097
						],
						[
							-80.23096999999984,
							25.772871904000034
						],
						[
							-80.23096999999984,
							25.77306532300014
						],
						[
							-80.23096999999984,
							25.773190000000064
						],
						[
							-80.23097270999989,
							25.773344477000148
						],
						[
							-80.23097647899993,
							25.773559320000068
						],
						[
							-80.23097999999986,
							25.773760000000152
						],
						[
							-80.2309858799999,
							25.77398931300003
						],
						[
							-80.23098999999989,
							25.77415000000009
						],
						[
							-80.23099572199992,
							25.774270170000086
						],
						[
							-80.23099999999992,
							25.77436000000006
						],
						[
							-80.23100345299986,
							25.77448430000004
						],
						[
							-80.23100583899988,
							25.774570198000042
						],
						[
							-80.23100999999986,
							25.77472000000018
						],
						[
							-80.23101675299989,
							25.77482804300015
						],
						[
							-80.23102611799995,
							25.774977895000116
						],
						[
							-80.23102999999992,
							25.77504000000001
						],
						[
							-80.23102999999992,
							25.775192926000052
						],
						[
							-80.23102999999992,
							25.775321871000155
						],
						[
							-80.23102999999992,
							25.775430000000128
						],
						[
							-80.23103708599989,
							25.775557554000024
						],
						[
							-80.23104303799992,
							25.775664678000187
						],
						[
							-80.23104999999988,
							25.77579000000007
						],
						[
							-80.2310555109999,
							25.77598841400015
						],
						[
							-80.23105731799978,
							25.776053433000108
						],
						[
							-80.23105999999991,
							25.776150000000193
						],
						[
							-80.23106608399988,
							25.77626863000006
						],
						[
							-80.2310705369999,
							25.77635546700005
						],
						[
							-80.23107999999988,
							25.776540000000132
						],
						[
							-80.23108375999992,
							25.776697919000142
						],
						[
							-80.2310931139999,
							25.77708455400007
						],
						[
							-80.23109999999984,
							25.777360000000122
						],
						[
							-80.23110527199992,
							25.777491791000102
						],
						[
							-80.2311199999999,
							25.777900784000103
						],
						[
							-80.2311199999999,
							25.778110000000183
						],
						[
							-80.23113023199997,
							25.778352153000057
						],
						[
							-80.23114201599986,
							25.778631037000043
						],
						[
							-80.2311499999999,
							25.77882000000013
						],
						[
							-80.23116102199992,
							25.77914699200001
						],
						[
							-80.23116900599979,
							25.779383848000066
						],
						[
							-80.23117841299994,
							25.779662913000152
						],
						[
							-80.23117908719983,
							25.779710962600184
						],
						[
							-80.23118922899995,
							25.78011145900014
						],
						[
							-80.23119604499989,
							25.78040797400007
						],
						[
							-80.23120660799988,
							25.780867464000075
						],
						[
							-80.23121528399979,
							25.781244847000124
						],
						[
							-80.23121999999982,
							25.781568226000147
						],
						[
							-80.23121999999982,
							25.78188000000019
						],
						[
							-80.23122476499987,
							25.78216114500009
						],
						[
							-80.23122660099993,
							25.78226945200008
						],
						[
							-80.23122999999994,
							25.782470000000153
						],
						[
							-80.2309857679999,
							25.782422215000018
						],
						[
							-80.23081974799993,
							25.782389733000173
						],
						[
							-80.23063226999996,
							25.782357045000133
						],
						[
							-80.23039080799988,
							25.782321878000154
						],
						[
							-80.23020398199988,
							25.782302716000167
						],
						[
							-80.22993558299987,
							25.782278891000065
						],
						[
							-80.22966455999983,
							25.782258587000157
						],
						[
							-80.22933892699989,
							25.78224049600017
						],
						[
							-80.22882638299986,
							25.782242454000155
						],
						[
							-80.22839510699987,
							25.78225426900016
						],
						[
							-80.2280423439999,
							25.782264659000127
						],
						[
							-80.22761227899993,
							25.782290594000056
						],
						[
							-80.22712952699986,
							25.782327352000074
						],
						[
							-80.22682854699993,
							25.78234937500021
						],
						[
							-80.22631742999982,
							25.782363958000083
						],
						[
							-80.22588718799993,
							25.782387426000074
						],
						[
							-80.2254285059999,
							25.782411284000094
						],
						[
							-80.22483573399988,
							25.782433540000156
						],
						[
							-80.22442987399997,
							25.782446493000073
						],
						[
							-80.22375612899991,
							25.78246375300008
						],
						[
							-80.22324427099991,
							25.782478818000172
						],
						[
							-80.2228951679999,
							25.782461921000106
						],
						[
							-80.22263999999984,
							25.782530000000143
						],
						[
							-80.22238395399997,
							25.78256526900013
						],
						[
							-80.22192036299981,
							25.782638392000052
						],
						[
							-80.22129723599994,
							25.782792071000067
						],
						[
							-80.2209532639999,
							25.78289564000002
						],
						[
							-80.22064690799995,
							25.783036546000133
						],
						[
							-80.22050666299981,
							25.783106668000077
						],
						[
							-80.2203340539999,
							25.78319297300002
						],
						[
							-80.22016929599995,
							25.783268091000195
						],
						[
							-80.21983777499979,
							25.783411326000056
						],
						[
							-80.21948209199985,
							25.78356906200014
						],
						[
							-80.21917571999991,
							25.783701032000046
						],
						[
							-80.21871344599994,
							25.783817520000092
						],
						[
							-80.2183104259999,
							25.783762563000074
						],
						[
							-80.21773599299989,
							25.783666824000058
						],
						[
							-80.21658712799986,
							25.783264721000094
						],
						[
							-80.21448087599994,
							25.782517959000124
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami",
				"Name": "Little Havana",
				"RegionID": "269072"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.1408693539999,
					26.13686302600007,
					-80.13084148299993,
					26.153662000000054
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.13190199999991,
							26.15357900000004
						],
						[
							-80.13126699999992,
							26.152762000000052
						],
						[
							-80.13095995599991,
							26.152794320000055
						],
						[
							-80.13089151899993,
							26.151292960000035
						],
						[
							-80.13087553299994,
							26.150295467000035
						],
						[
							-80.13084148299993,
							26.148024098000064
						],
						[
							-80.13085049599994,
							26.147649543000057
						],
						[
							-80.13087252799994,
							26.147363118000044
						],
						[
							-80.1308925589999,
							26.146992568000087
						],
						[
							-80.13095064399994,
							26.14662502300007
						],
						[
							-80.1309676699999,
							26.146498836000035
						],
						[
							-80.13102275199992,
							26.14621842100007
						],
						[
							-80.13110186799992,
							26.145909962000076
						],
						[
							-80.13120702499992,
							26.145602507000035
						],
						[
							-80.13132620199991,
							26.145236965000038
						],
						[
							-80.13150346499992,
							26.144853396000087
						],
						[
							-80.13168773799993,
							26.144479842000067
						],
						[
							-80.13191807999993,
							26.144079248000082
						],
						[
							-80.13219849599994,
							26.143676651000078
						],
						[
							-80.13257004699994,
							26.143245010000044
						],
						[
							-80.13332716499991,
							26.142447961000073
						],
						[
							-80.13542646899992,
							26.14006531600006
						],
						[
							-80.13538504899994,
							26.139985205000073
						],
						[
							-80.13541612199992,
							26.139760719000037
						],
						[
							-80.13566864199993,
							26.13969274200008
						],
						[
							-80.13598920299995,
							26.13962279100008
						],
						[
							-80.13658800499991,
							26.138998713000035
						],
						[
							-80.13846679099993,
							26.137047819000088
						],
						[
							-80.13852187499992,
							26.136989864000043
						],
						[
							-80.13859889299994,
							26.13691842600008
						],
						[
							-80.1390643929999,
							26.136906321000083
						],
						[
							-80.13972156299991,
							26.13688856600004
						],
						[
							-80.14006415499995,
							26.136874141000078
						],
						[
							-80.14040269499992,
							26.13686302600007
						],
						[
							-80.14040739799992,
							26.13693279200004
						],
						[
							-80.14060195799993,
							26.142256544000077
						],
						[
							-80.14065603899991,
							26.14401815800005
						],
						[
							-80.14071612799995,
							26.14577075600005
						],
						[
							-80.14078522999996,
							26.147547391000046
						],
						[
							-80.14079924999993,
							26.148572913000066
						],
						[
							-80.14082328699993,
							26.149125731000083
						],
						[
							-80.14085132699995,
							26.15008615700009
						],
						[
							-80.1408693539999,
							26.150833264000084
						],
						[
							-80.14085065499995,
							26.151016721000076
						],
						[
							-80.14084844899992,
							26.151039246000042
						],
						[
							-80.13976699999995,
							26.15096200000005
						],
						[
							-80.1394227479999,
							26.150996425000073
						],
						[
							-80.13927137699994,
							26.151011563000054
						],
						[
							-80.13846699999993,
							26.151092000000062
						],
						[
							-80.13776699999994,
							26.151162000000056
						],
						[
							-80.13736699999993,
							26.151262000000088
						],
						[
							-80.13718015799992,
							26.15130871000008
						],
						[
							-80.13696699999991,
							26.151362000000063
						],
						[
							-80.13657099999995,
							26.15147500000006
						],
						[
							-80.13646699999993,
							26.151505000000043
						],
						[
							-80.13626699999992,
							26.151562000000073
						],
						[
							-80.1361790439999,
							26.15159620500009
						],
						[
							-80.13446699999992,
							26.152262000000064
						],
						[
							-80.13401999999991,
							26.15253000000007
						],
						[
							-80.13396699999993,
							26.152562000000046
						],
						[
							-80.13393542999995,
							26.152625140000055
						],
						[
							-80.13386699999995,
							26.152762000000052
						],
						[
							-80.13286699999992,
							26.15346200000005
						],
						[
							-80.13277497699994,
							26.153482375000067
						],
						[
							-80.13231599999995,
							26.15358400000008
						],
						[
							-80.13196699999992,
							26.153662000000054
						],
						[
							-80.13190199999991,
							26.15357900000004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Middle River Terrace",
				"RegionID": "269088"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.6971210399999,
					30.33772700900005,
					-81.66821676599994,
					30.35701414300007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.68128090599993,
							30.35575500800007
						],
						[
							-81.68117882399991,
							30.355705854000067
						],
						[
							-81.6811680109999,
							30.35581415900009
						],
						[
							-81.68087090699993,
							30.355738009000046
						],
						[
							-81.68064190599995,
							30.355696008000056
						],
						[
							-81.6805279049999,
							30.355680008000036
						],
						[
							-81.68030690599994,
							30.355650009000044
						],
						[
							-81.68023690599995,
							30.355645008000067
						],
						[
							-81.68001290599994,
							30.355627008000056
						],
						[
							-81.67948890699995,
							30.35560100900005
						],
						[
							-81.6780749049999,
							30.355618008000075
						],
						[
							-81.67704690599993,
							30.355640009000073
						],
						[
							-81.67591090699995,
							30.35567695300006
						],
						[
							-81.67517890599993,
							30.35568200900008
						],
						[
							-81.67492690599994,
							30.355692008000062
						],
						[
							-81.67441590599992,
							30.355712008000065
						],
						[
							-81.67381990599995,
							30.355759009000053
						],
						[
							-81.6731638249999,
							30.355833184000062
						],
						[
							-81.67311698399993,
							30.355763833000086
						],
						[
							-81.67191990499992,
							30.355925008000042
						],
						[
							-81.6715007599999,
							30.35595996100005
						],
						[
							-81.67158804499991,
							30.35604406200008
						],
						[
							-81.67012790599995,
							30.35607200900006
						],
						[
							-81.66954990599993,
							30.356087008000085
						],
						[
							-81.66895790599995,
							30.356099008000058
						],
						[
							-81.66867490599992,
							30.356106011000065
						],
						[
							-81.66867090599993,
							30.356040008000033
						],
						[
							-81.66866590599994,
							30.355962008000063
						],
						[
							-81.66866690599994,
							30.35573100900007
						],
						[
							-81.6686619059999,
							30.35562500900005
						],
						[
							-81.66864090599995,
							30.354687009000088
						],
						[
							-81.6686399059999,
							30.35457300800005
						],
						[
							-81.66863390599991,
							30.35423500900004
						],
						[
							-81.66863490499992,
							30.354097008000053
						],
						[
							-81.66863290599991,
							30.353978008000066
						],
						[
							-81.66863390499992,
							30.353766009000086
						],
						[
							-81.66863090599992,
							30.353620008000064
						],
						[
							-81.66862790599993,
							30.353462009000054
						],
						[
							-81.66862490599993,
							30.353272008000086
						],
						[
							-81.66862090599994,
							30.353045009000084
						],
						[
							-81.66861790499992,
							30.352881008000054
						],
						[
							-81.66860290599993,
							30.352528009000082
						],
						[
							-81.66856790599991,
							30.351758009000033
						],
						[
							-81.66856190599992,
							30.351680009000063
						],
						[
							-81.66855890499994,
							30.35149300800003
						],
						[
							-81.66855790499994,
							30.351437008000065
						],
						[
							-81.6685539049999,
							30.351314009000077
						],
						[
							-81.66854490599991,
							30.351060009000037
						],
						[
							-81.66854090599992,
							30.35089900900005
						],
						[
							-81.66853690499994,
							30.350780008000076
						],
						[
							-81.66853681499992,
							30.35070201200006
						],
						[
							-81.66853290499995,
							30.350660009000084
						],
						[
							-81.66852290599991,
							30.350552008000076
						],
						[
							-81.66852290599991,
							30.35051000900006
						],
						[
							-81.66851890499993,
							30.35041700900007
						],
						[
							-81.66851890499993,
							30.350366008000034
						],
						[
							-81.66851590699991,
							30.350252009000084
						],
						[
							-81.66856090499994,
							30.350049008000042
						],
						[
							-81.66857990599993,
							30.34990600800006
						],
						[
							-81.66859390499991,
							30.349513009000077
						],
						[
							-81.66860790599992,
							30.349362009000057
						],
						[
							-81.66864090699994,
							30.349173008000037
						],
						[
							-81.66884990499996,
							30.348470009000042
						],
						[
							-81.6692140799999,
							30.34732000500009
						],
						[
							-81.66878390599993,
							30.34617000800006
						],
						[
							-81.66874890499992,
							30.34607900800006
						],
						[
							-81.6685707229999,
							30.345562994000087
						],
						[
							-81.66869409399993,
							30.345332970000076
						],
						[
							-81.66863974699993,
							30.345293105000056
						],
						[
							-81.66860190699992,
							30.34510800800007
						],
						[
							-81.6685637729999,
							30.34422888100005
						],
						[
							-81.66873303499995,
							30.344223043000056
						],
						[
							-81.66855774199992,
							30.344109101000075
						],
						[
							-81.66851790499993,
							30.342949008000065
						],
						[
							-81.6684569059999,
							30.341885009000066
						],
						[
							-81.6684569059999,
							30.341682009000067
						],
						[
							-81.66842690699991,
							30.34038901100007
						],
						[
							-81.66844904999994,
							30.340302895000036
						],
						[
							-81.66821676599994,
							30.34029512700005
						],
						[
							-81.66824290599993,
							30.340092009000045
						],
						[
							-81.6683249049999,
							30.339736008000045
						],
						[
							-81.6683869069999,
							30.339518008000084
						],
						[
							-81.6685949049999,
							30.339052008000067
						],
						[
							-81.66873490499995,
							30.338753008000083
						],
						[
							-81.66887490599993,
							30.338489008000067
						],
						[
							-81.66917395199994,
							30.337914043000065
						],
						[
							-81.6692249059999,
							30.337863008000056
						],
						[
							-81.66928090899995,
							30.33780800800008
						],
						[
							-81.66934490699992,
							30.337769009000056
						],
						[
							-81.66946190699991,
							30.33772901100008
						],
						[
							-81.66959590599993,
							30.33772700900005
						],
						[
							-81.66966990499992,
							30.337741009000066
						],
						[
							-81.66973990499991,
							30.337769009000056
						],
						[
							-81.66982290499993,
							30.33781700900005
						],
						[
							-81.66997690999996,
							30.337923008000075
						],
						[
							-81.67003870299993,
							30.337945897000054
						],
						[
							-81.67020390699992,
							30.338051008000036
						],
						[
							-81.67045490699991,
							30.33821500800008
						],
						[
							-81.67086590499991,
							30.33845000900004
						],
						[
							-81.67102090699991,
							30.338556009000058
						],
						[
							-81.67123090599995,
							30.338708009000076
						],
						[
							-81.67228690999991,
							30.33944300800005
						],
						[
							-81.6730269059999,
							30.33974600900007
						],
						[
							-81.67373690699992,
							30.340034009000075
						],
						[
							-81.67429390599995,
							30.340260008000087
						],
						[
							-81.6744689059999,
							30.340328009000075
						],
						[
							-81.67539990799992,
							30.340704009000035
						],
						[
							-81.67552890699994,
							30.340765008000062
						],
						[
							-81.67590290699991,
							30.340935009000077
						],
						[
							-81.67663590599994,
							30.34121700800006
						],
						[
							-81.67727690599992,
							30.341461008000064
						],
						[
							-81.67775690499991,
							30.341642009000054
						],
						[
							-81.6782529059999,
							30.341837009000074
						],
						[
							-81.67938190599995,
							30.34229000800008
						],
						[
							-81.67977090599993,
							30.34243200900005
						],
						[
							-81.68060290699992,
							30.342762008000083
						],
						[
							-81.68202190599993,
							30.343319008000037
						],
						[
							-81.6821669069999,
							30.343376008000067
						],
						[
							-81.6829379049999,
							30.343660009000075
						],
						[
							-81.68320190599991,
							30.34378300800006
						],
						[
							-81.68393990699991,
							30.344056008000052
						],
						[
							-81.68415790599994,
							30.344145008000055
						],
						[
							-81.6848229069999,
							30.344408009000063
						],
						[
							-81.68549990699996,
							30.34466900800004
						],
						[
							-81.68597290399993,
							30.344856009000072
						],
						[
							-81.68645085999992,
							30.345043048000033
						],
						[
							-81.68659990499992,
							30.345103008000084
						],
						[
							-81.68693890599991,
							30.34523800800008
						],
						[
							-81.68855090499994,
							30.345858008000054
						],
						[
							-81.68945590599992,
							30.346222009000083
						],
						[
							-81.68984190499992,
							30.346371008000066
						],
						[
							-81.69055190599994,
							30.346657008000083
						],
						[
							-81.69127690499994,
							30.346937008000058
						],
						[
							-81.69200890499991,
							30.34721100900003
						],
						[
							-81.6926879049999,
							30.34746700900007
						],
						[
							-81.6929589049999,
							30.34757300900009
						],
						[
							-81.69414490499992,
							30.348043008000047
						],
						[
							-81.69538890599995,
							30.34852000900008
						],
						[
							-81.69564790399994,
							30.34861800600004
						],
						[
							-81.69581590599995,
							30.348633008000032
						],
						[
							-81.69629090599994,
							30.34862900800005
						],
						[
							-81.69709790399992,
							30.348622953000074
						],
						[
							-81.69708990599992,
							30.34919000900004
						],
						[
							-81.6970979059999,
							30.349962009000084
						],
						[
							-81.6970979059999,
							30.350611008000044
						],
						[
							-81.69708990599992,
							30.35126500800004
						],
						[
							-81.69708290599993,
							30.351463008000053
						],
						[
							-81.69708990599992,
							30.351940009000085
						],
						[
							-81.69708990599992,
							30.352608008000065
						],
						[
							-81.69708990599992,
							30.353258008000072
						],
						[
							-81.6970979059999,
							30.35392400900008
						],
						[
							-81.69710490599994,
							30.35458400800007
						],
						[
							-81.6971009049999,
							30.35523500900007
						],
						[
							-81.69711290599992,
							30.355979009000066
						],
						[
							-81.69711290599992,
							30.356459008000055
						],
						[
							-81.69711290599992,
							30.35672000800008
						],
						[
							-81.69711690499992,
							30.356810009000075
						],
						[
							-81.6971210399999,
							30.35689213900008
						],
						[
							-81.69457190599991,
							30.35690500800007
						],
						[
							-81.69260390599993,
							30.356916008000045
						],
						[
							-81.69073990499993,
							30.356948009000067
						],
						[
							-81.68882790499993,
							30.356983008000043
						],
						[
							-81.68812592599994,
							30.356985955000084
						],
						[
							-81.68642377799995,
							30.35701414300007
						],
						[
							-81.68642003799994,
							30.356931874000058
						],
						[
							-81.68458589699992,
							30.356864060000074
						],
						[
							-81.68293890599995,
							30.356339008000077
						],
						[
							-81.68280590599994,
							30.356273009000063
						],
						[
							-81.68128090599993,
							30.35575500800007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Mid-Westside",
				"RegionID": "269090"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.32313991072037,
					28.523640410655148,
					-81.31038411141778,
					28.539972489912323
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.31759850960907,
							28.539714107498725
						],
						[
							-81.31696442732381,
							28.539683962224267
						],
						[
							-81.31701276948021,
							28.53980635095924
						],
						[
							-81.31650288446654,
							28.539714108398
						],
						[
							-81.31579871172029,
							28.53971397619771
						],
						[
							-81.31579796798101,
							28.539813389053435
						],
						[
							-81.31480937295179,
							28.539734137198934
						],
						[
							-81.31455301311345,
							28.539714018465855
						],
						[
							-81.3144909005381,
							28.539709100073672
						],
						[
							-81.31423051443511,
							28.53968706758326
						],
						[
							-81.31393507635657,
							28.53966203045791
						],
						[
							-81.31364564664855,
							28.53963699333265
						],
						[
							-81.31326908882372,
							28.539627979428005
						],
						[
							-81.31249594167511,
							28.539615960888327
						],
						[
							-81.3116336627202,
							28.539613958098215
						],
						[
							-81.31154252722445,
							28.539612957152755
						],
						[
							-81.3106341804986,
							28.53959993856708
						],
						[
							-81.31055242223354,
							28.539598618362334
						],
						[
							-81.31055112720982,
							28.53951476467701
						],
						[
							-81.31054982858878,
							28.539430643892977
						],
						[
							-81.3105457303784,
							28.539165267451978
						],
						[
							-81.31054500012884,
							28.539117999985507
						],
						[
							-81.31054204495666,
							28.539040107006507
						],
						[
							-81.31054204495666,
							28.539017073570726
						],
						[
							-81.31054104311191,
							28.538905908374744
						],
						[
							-81.31053903942242,
							28.53847026239456
						],
						[
							-81.310533031052,
							28.53766206416987
						],
						[
							-81.31052602083676,
							28.537176343039793
						],
						[
							-81.31052501899201,
							28.536330088204785
						],
						[
							-81.31050499019108,
							28.535462802724197
						],
						[
							-81.3105109976623,
							28.534944033308236
						],
						[
							-81.31048996701664,
							28.533138355652042
						],
						[
							-81.31046192615571,
							28.531639130970483
						],
						[
							-81.31045090856159,
							28.531112350393904
						],
						[
							-81.31043989276603,
							28.530329189294463
						],
						[
							-81.31044189555614,
							28.529782379017583
						],
						[
							-81.31044189555614,
							28.529741317772427
						],
						[
							-81.31044089461076,
							28.529706265796968
						],
						[
							-81.31043688903047,
							28.52941984072389
						],
						[
							-81.31043087976066,
							28.527595134312858
						],
						[
							-81.31039983336552,
							28.52491215542659
						],
						[
							-81.31039182220489,
							28.52420811128343
						],
						[
							-81.31039182220489,
							28.52416705003818
						],
						[
							-81.31038881667067,
							28.523946723335612
						],
						[
							-81.31038411141778,
							28.523640410655148
						],
						[
							-81.31041485564067,
							28.523654288992738
						],
						[
							-81.31046492989128,
							28.523673318646857
						],
						[
							-81.31086452205128,
							28.523809520068816
						],
						[
							-81.31095966312735,
							28.52384357019953
						],
						[
							-81.31161163022979,
							28.524094943297158
						],
						[
							-81.31169074808535,
							28.524123986902104
						],
						[
							-81.31180792165193,
							28.524166048193443
						],
						[
							-81.31204827805473,
							28.524246166994367
						],
						[
							-81.3122656010217,
							28.52429724398909
						],
						[
							-81.31240080059902,
							28.524326285795297
						],
						[
							-81.31273329344315,
							28.52437535910054
						],
						[
							-81.31302072036095,
							28.524395388800748
						],
						[
							-81.31351946007669,
							28.52440740644105
						],
						[
							-81.31357954827804,
							28.524408408285794
						],
						[
							-81.3140592610376,
							28.524420426825383
						],
						[
							-81.31445683601837,
							28.52447554267522
						],
						[
							-81.31450692465809,
							28.524474506656304
						],
						[
							-81.31525803931629,
							28.52446449090683
						],
						[
							-81.3155364514301,
							28.52446549185229
						],
						[
							-81.31590399624957,
							28.52446549185229
						],
						[
							-81.31657098562717,
							28.52446649459631
						],
						[
							-81.31663307751808,
							28.52446649459631
						],
						[
							-81.31744828685731,
							28.524461486271974
						],
						[
							-81.31771366239903,
							28.52444537401849
						],
						[
							-81.31771382697494,
							28.526021925106036
						],
						[
							-81.31749621082886,
							28.526057728914665
						],
						[
							-81.31745916955315,
							28.53021915814352
						],
						[
							-81.31869026317023,
							28.530218891044818
						],
						[
							-81.31868999787027,
							28.531485032140786
						],
						[
							-81.32064395304464,
							28.531506880270136
						],
						[
							-81.31963034247396,
							28.53300413093981
						],
						[
							-81.31970263267667,
							28.533256531962557
						],
						[
							-81.32060687040013,
							28.534849051412024
						],
						[
							-81.32274213788881,
							28.534993105714022
						],
						[
							-81.3230677545167,
							28.535065074858707
						],
						[
							-81.32313991072037,
							28.535355672786036
						],
						[
							-81.32299461985063,
							28.535608174532918
						],
						[
							-81.32266988635705,
							28.535644947810674
						],
						[
							-81.32269506737386,
							28.53894396498496
						],
						[
							-81.32271411951106,
							28.53965907708445
						],
						[
							-81.32192893133978,
							28.53976418174925
						],
						[
							-81.32094847697364,
							28.53985832187996
						],
						[
							-81.32055589502882,
							28.539894374800873
						],
						[
							-81.31965455851824,
							28.539950458321282
						],
						[
							-81.3192579709931,
							28.539962475062126
						],
						[
							-81.3189294837294,
							28.539972489912323
						],
						[
							-81.3185307603144,
							28.539963604610673
						],
						[
							-81.31853289440564,
							28.53990338870552
						],
						[
							-81.31853703398497,
							28.539738015075528
						],
						[
							-81.31759850960907,
							28.539714107498725
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Monterey",
				"RegionID": "269097"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.44283123448159,
					28.527816408001648,
					-81.43928700006877,
					28.534480000228186
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.44046500041138,
							28.533580000110113
						],
						[
							-81.44046500041138,
							28.532679999992034
						],
						[
							-81.44039299979035,
							28.532679999992034
						],
						[
							-81.44039299979035,
							28.53254500006418
						],
						[
							-81.43929000020712,
							28.53254900024845
						],
						[
							-81.43928975109493,
							28.53233279423953
						],
						[
							-81.43928954245231,
							28.5321511266931
						],
						[
							-81.43928900016104,
							28.531678999714615
						],
						[
							-81.43928800011494,
							28.530777999550622
						],
						[
							-81.43928746771628,
							28.53030731238689
						],
						[
							-81.43928700006877,
							28.529894000169996
						],
						[
							-81.43928917193155,
							28.529428639690686
						],
						[
							-81.43929503461193,
							28.528172865979094
						],
						[
							-81.43929599979222,
							28.527966000164305
						],
						[
							-81.43945261768013,
							28.527836842333116
						],
						[
							-81.43966005640029,
							28.527833441698498
						],
						[
							-81.44014320003738,
							28.527825521310866
						],
						[
							-81.44078735542277,
							28.527819999999995
						],
						[
							-81.44152377215366,
							28.527819999999995
						],
						[
							-81.44223717586168,
							28.527819999999995
						],
						[
							-81.44283123448159,
							28.527816408001648
						],
						[
							-81.44282558583993,
							28.528082000280037
						],
						[
							-81.44238599992994,
							28.528082000280037
						],
						[
							-81.44229551374464,
							28.534307083984373
						],
						[
							-81.44229300013959,
							28.534480000228186
						],
						[
							-81.44089300035549,
							28.534480000228186
						],
						[
							-81.44046500041138,
							28.534480000228186
						],
						[
							-81.44046500041138,
							28.533580000110113
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "New Malibu",
				"RegionID": "269099"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.11493590599991,
					26.18960475800009,
					-80.11041318799994,
					26.196693192000055
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.1147726509999,
							26.18960476400008
						],
						[
							-80.11493590599991,
							26.18960475800009
						],
						[
							-80.11490685099994,
							26.18966184900006
						],
						[
							-80.11444015899991,
							26.190579209000077
						],
						[
							-80.1143970949999,
							26.190663335000067
						],
						[
							-80.11412368999994,
							26.19126222200009
						],
						[
							-80.11371107699995,
							26.19214953800008
						],
						[
							-80.11338459199993,
							26.19283555600009
						],
						[
							-80.1132924559999,
							26.19303184800009
						],
						[
							-80.11325039299993,
							26.19312097900007
						],
						[
							-80.11294493999992,
							26.193775951000077
						],
						[
							-80.11282876899992,
							26.193996278000043
						],
						[
							-80.11261244799994,
							26.194478993000075
						],
						[
							-80.11253533299993,
							26.194650248000073
						],
						[
							-80.11238410999994,
							26.194978734000074
						],
						[
							-80.11227094199995,
							26.195216087000063
						],
						[
							-80.1120896729999,
							26.195598654000037
						],
						[
							-80.11195146699993,
							26.19587005700004
						],
						[
							-80.1118242789999,
							26.19613144500005
						],
						[
							-80.11155891399994,
							26.196693192000055
						],
						[
							-80.1113095149999,
							26.196522024000046
						],
						[
							-80.11116634899992,
							26.196434769000067
						],
						[
							-80.11081177799991,
							26.19638381900006
						],
						[
							-80.11041318799994,
							26.19637481700005
						],
						[
							-80.11053937399994,
							26.19205840300009
						],
						[
							-80.11052935899994,
							26.19064430600008
						],
						[
							-80.11050432299993,
							26.189703855000065
						],
						[
							-80.11149278799991,
							26.189657843000077
						],
						[
							-80.11300703299992,
							26.189637813000047
						],
						[
							-80.1147726509999,
							26.18960476400008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "North Golf Estates",
				"RegionID": "269106"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.37819256299991,
					28.558914439000034,
					-81.36573672899993,
					28.591457000000048
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.3764559999999,
							28.591457000000048
						],
						[
							-81.3764369999999,
							28.591214000000036
						],
						[
							-81.37685099999993,
							28.59120900000005
						],
						[
							-81.37685499999992,
							28.59107800000004
						],
						[
							-81.37642699999992,
							28.59107800000004
						],
						[
							-81.37642999999991,
							28.59093900000005
						],
						[
							-81.3764339999999,
							28.590770000000077
						],
						[
							-81.37624799999992,
							28.590760000000046
						],
						[
							-81.3762529999999,
							28.590953000000074
						],
						[
							-81.37603299999995,
							28.590958000000057
						],
						[
							-81.37603499999994,
							28.590760000000046
						],
						[
							-81.37596899999994,
							28.590760000000046
						],
						[
							-81.37421199999994,
							28.590783000000044
						],
						[
							-81.3742279999999,
							28.590953000000074
						],
						[
							-81.37349099999994,
							28.590958000000057
						],
						[
							-81.37349099999994,
							28.590078000000062
						],
						[
							-81.37349099999994,
							28.589488652000057
						],
						[
							-81.37349099999994,
							28.58917800000006
						],
						[
							-81.37328511899995,
							28.58917800000006
						],
						[
							-81.3731909999999,
							28.58917800000006
						],
						[
							-81.37326431799994,
							28.58851813300004
						],
						[
							-81.37329099999994,
							28.58827800000006
						],
						[
							-81.37329099999994,
							28.587378000000058
						],
						[
							-81.37329099999994,
							28.58647800000006
						],
						[
							-81.37320599999993,
							28.58571100000006
						],
						[
							-81.3731909999999,
							28.585578000000055
						],
						[
							-81.37331499999993,
							28.585582000000045
						],
						[
							-81.37333899999993,
							28.58509100000009
						],
						[
							-81.37334699999991,
							28.58493200000004
						],
						[
							-81.37383099999994,
							28.58492700000005
						],
						[
							-81.37388299999992,
							28.585010000000068
						],
						[
							-81.37408799999992,
							28.58499100000006
						],
						[
							-81.37408799999992,
							28.584812000000056
						],
						[
							-81.3740929999999,
							28.584677000000056
						],
						[
							-81.37359299999993,
							28.584669000000076
						],
						[
							-81.37358599999993,
							28.58455900000007
						],
						[
							-81.37378499999994,
							28.58455900000007
						],
						[
							-81.37377199999992,
							28.584408000000053
						],
						[
							-81.37406199999994,
							28.584385000000054
						],
						[
							-81.3740479999999,
							28.58407800000009
						],
						[
							-81.37431199999992,
							28.58407800000009
						],
						[
							-81.37431199999992,
							28.583668000000046
						],
						[
							-81.3745229999999,
							28.583645000000047
						],
						[
							-81.37452799999994,
							28.583232000000066
						],
						[
							-81.3745219999999,
							28.583158000000083
						],
						[
							-81.37396399999994,
							28.58313700000008
						],
						[
							-81.37396499999994,
							28.58274300000005
						],
						[
							-81.37396299999995,
							28.582691000000068
						],
						[
							-81.3738929999999,
							28.582692000000065
						],
						[
							-81.3738899999999,
							28.582542000000046
						],
						[
							-81.3738899999999,
							28.58240200000006
						],
						[
							-81.37410999999992,
							28.58240200000006
						],
						[
							-81.37410999999992,
							28.582179000000053
						],
						[
							-81.37410799999992,
							28.582028000000037
						],
						[
							-81.3731929999999,
							28.582028000000037
						],
						[
							-81.37306458599994,
							28.582031207000057
						],
						[
							-81.37279849999993,
							28.578850009000064
						],
						[
							-81.37112088599991,
							28.578890207000086
						],
						[
							-81.3704447529999,
							28.578923390000057
						],
						[
							-81.37044501699995,
							28.578480466000087
						],
						[
							-81.36897368099994,
							28.57848067900005
						],
						[
							-81.36772284599994,
							28.57774551100005
						],
						[
							-81.3661044509999,
							28.57678909200007
						],
						[
							-81.36573672899993,
							28.576421612000047
						],
						[
							-81.3657367479999,
							28.575906676000045
						],
						[
							-81.36654607899993,
							28.57561321500009
						],
						[
							-81.3674294089999,
							28.575613347000058
						],
						[
							-81.36801739499992,
							28.575466276000046
						],
						[
							-81.36831272199993,
							28.574950365000063
						],
						[
							-81.36860615699995,
							28.574582820000046
						],
						[
							-81.36882666999992,
							28.574288413000094
						],
						[
							-81.36875337499993,
							28.57406805700009
						],
						[
							-81.36853313799992,
							28.573626361000038
						],
						[
							-81.36934124599992,
							28.573773619000068
						],
						[
							-81.36985600899993,
							28.57384772900008
						],
						[
							-81.37037177499991,
							28.57392083700006
						],
						[
							-81.37126422599994,
							28.573950015000037
						],
						[
							-81.37126819699995,
							28.573852744000078
						],
						[
							-81.37130415799994,
							28.57359034700005
						],
						[
							-81.37141131699991,
							28.573057557000087
						],
						[
							-81.37175081999993,
							28.571377065000036
						],
						[
							-81.37176283699995,
							28.571312971000054
						],
						[
							-81.37177285299992,
							28.57126189400009
						],
						[
							-81.3722175129999,
							28.569078656000045
						],
						[
							-81.37251495399994,
							28.567532364000044
						],
						[
							-81.37255300899994,
							28.567320048000056
						],
						[
							-81.37257604299992,
							28.567155805000084
						],
						[
							-81.37258205199993,
							28.566796272000094
						],
						[
							-81.3725480029999,
							28.566231434000088
						],
						[
							-81.37250894399995,
							28.565385180000078
						],
						[
							-81.37243593199992,
							28.564066223000054
						],
						[
							-81.37247889999992,
							28.56334915900004
						],
						[
							-81.37260108299995,
							28.562571007000088
						],
						[
							-81.37288950999994,
							28.56191603500008
						],
						[
							-81.37319396099991,
							28.561413291000065
						],
						[
							-81.37372592199995,
							28.56086153600006
						],
						[
							-81.37372274499995,
							28.560577048000084
						],
						[
							-81.37372268899992,
							28.56051690000004
						],
						[
							-81.37671426699991,
							28.558914439000034
						],
						[
							-81.37670499699993,
							28.560042337000084
						],
						[
							-81.37704967699995,
							28.56031666100006
						],
						[
							-81.37747631099995,
							28.560773340000082
						],
						[
							-81.37802519299993,
							28.56122996700009
						],
						[
							-81.37819256299991,
							28.56164259600007
						],
						[
							-81.37817735099993,
							28.56206825900006
						],
						[
							-81.37802931399995,
							28.56302958300006
						],
						[
							-81.37747999999993,
							28.563816000000088
						],
						[
							-81.37727199999995,
							28.564119000000066
						],
						[
							-81.37705668899991,
							28.56443376900006
						],
						[
							-81.37650386999991,
							28.565363147000085
						],
						[
							-81.37639370499994,
							28.56559048400004
						],
						[
							-81.37629355799993,
							28.565844861000077
						],
						[
							-81.37625049399992,
							28.56595302100004
						],
						[
							-81.37605620699992,
							28.566441747000056
						],
						[
							-81.37596206599994,
							28.566841338000074
						],
						[
							-81.3759430369999,
							28.566955507000046
						],
						[
							-81.37589797099992,
							28.567217897000035
						],
						[
							-81.3758739349999,
							28.567641525000056
						],
						[
							-81.3758519029999,
							28.568133255000077
						],
						[
							-81.37585590899994,
							28.56899453200009
						],
						[
							-81.3758488979999,
							28.56990287900004
						],
						[
							-81.37585290299995,
							28.570557850000057
						],
						[
							-81.37586191699995,
							28.571207815000037
						],
						[
							-81.37586291899993,
							28.571280922000085
						],
						[
							-81.3758639209999,
							28.571375062000072
						],
						[
							-81.37587593799992,
							28.571914862000085
						],
						[
							-81.37586992899992,
							28.572530777000054
						],
						[
							-81.3758639209999,
							28.573196764000045
						],
						[
							-81.37586091599991,
							28.573562306000042
						],
						[
							-81.3758589119999,
							28.573790645000088
						],
						[
							-81.3758118419999,
							28.57434747000008
						],
						[
							-81.37575575999995,
							28.57494435600006
						],
						[
							-81.37573973499991,
							28.575081560000058
						],
						[
							-81.37566963199993,
							28.57561735300004
						],
						[
							-81.37549637399991,
							28.57650166600007
						],
						[
							-81.37529808099994,
							28.577578262000088
						],
						[
							-81.3752740459999,
							28.577763536000077
						],
						[
							-81.37519292399992,
							28.578425519000064
						],
						[
							-81.3751839119999,
							28.578511647000084
						],
						[
							-81.37517890499993,
							28.578623813000036
						],
						[
							-81.37516888999994,
							28.579690394000067
						],
						[
							-81.3751658839999,
							28.580120031000035
						],
						[
							-81.3751708929999,
							28.58098531500008
						],
						[
							-81.37517890499993,
							28.582007831000055
						],
						[
							-81.37518090799995,
							28.582243180000038
						],
						[
							-81.3751839119999,
							28.582458500000087
						],
						[
							-81.3751959299999,
							28.583056387000056
						],
						[
							-81.37520694599993,
							28.583503049000058
						],
						[
							-81.37522697499992,
							28.58427519500009
						],
						[
							-81.37526002399994,
							28.58493016600005
						],
						[
							-81.37528105599995,
							28.585397860000057
						],
						[
							-81.37531210199995,
							28.585681279000084
						],
						[
							-81.37536518099995,
							28.58596269600008
						],
						[
							-81.37550438599993,
							28.586422378000066
						],
						[
							-81.37561555199996,
							28.586709804000066
						],
						[
							-81.3757177039999,
							28.586949159000085
						],
						[
							-81.37592200599995,
							28.58732371600007
						],
						[
							-81.37607641299991,
							28.587579144000074
						],
						[
							-81.37594085699993,
							28.587642117000087
						],
						[
							-81.37602704699992,
							28.587895630000048
						],
						[
							-81.37669515299991,
							28.58871778300005
						],
						[
							-81.37732007999995,
							28.589425832000074
						],
						[
							-81.37735706599995,
							28.589469463000057
						],
						[
							-81.37754404799995,
							28.589681315000064
						],
						[
							-81.3774909999999,
							28.58967800000005
						],
						[
							-81.3774909999999,
							28.590178000000037
						],
						[
							-81.3774909999999,
							28.590948000000083
						],
						[
							-81.3774909999999,
							28.59107800000004
						],
						[
							-81.37723499999993,
							28.59107800000004
						],
						[
							-81.37723499999993,
							28.59144600000008
						],
						[
							-81.37684399999995,
							28.591442000000086
						],
						[
							-81.3764559999999,
							28.591457000000048
						]
					],
					[
						[
							-81.37652549799992,
							28.561112242000036
						],
						[
							-81.37651329599993,
							28.561102980000044
						],
						[
							-81.3760018019999,
							28.561331452000047
						],
						[
							-81.37580617399993,
							28.561484069000073
						],
						[
							-81.37580047199992,
							28.561488480000037
						],
						[
							-81.3757526359999,
							28.56152275900007
						],
						[
							-81.37570266099993,
							28.561553836000087
						],
						[
							-81.37565075999993,
							28.561581577000087
						],
						[
							-81.37564715199994,
							28.561583347000067
						],
						[
							-81.3755261519999,
							28.561642347000088
						],
						[
							-81.37551167399994,
							28.561649247000048
						],
						[
							-81.3755066789999,
							28.561668762000068
						],
						[
							-81.37548959499992,
							28.561725078000052
						],
						[
							-81.37546886599995,
							28.561780156000054
						],
						[
							-81.37544457799993,
							28.56183376000007
						],
						[
							-81.37541683599994,
							28.561885661000076
						],
						[
							-81.37538575899994,
							28.561935636000044
						],
						[
							-81.37535147999995,
							28.561983473000055
						],
						[
							-81.37531414599994,
							28.562028964000035
						],
						[
							-81.3752739169999,
							28.562071917000083
						],
						[
							-81.3752309649999,
							28.56211214600006
						],
						[
							-81.37520748199995,
							28.562132039000062
						],
						[
							-81.37514148199995,
							28.562186039000043
						],
						[
							-81.37511947299993,
							28.56220348000005
						],
						[
							-81.3750716369999,
							28.562237759000084
						],
						[
							-81.37502166099996,
							28.562268835000058
						],
						[
							-81.37501601499991,
							28.562272068000084
						],
						[
							-81.37486101499991,
							28.56236006800009
						],
						[
							-81.37483438599992,
							28.56237459900007
						],
						[
							-81.37467082099995,
							28.562460300000055
						],
						[
							-81.3745713809999,
							28.56259157700004
						],
						[
							-81.37453921299993,
							28.56269296700009
						],
						[
							-81.37453359499995,
							28.562710078000066
						],
						[
							-81.37451286599992,
							28.56276515600007
						],
						[
							-81.37449769299991,
							28.562799716000086
						],
						[
							-81.37436848899995,
							28.563078001000065
						],
						[
							-81.37437058699993,
							28.563129226000058
						],
						[
							-81.37440132899991,
							28.563454340000078
						],
						[
							-81.37440339699992,
							28.563480181000045
						],
						[
							-81.3744048929999,
							28.563511212000037
						],
						[
							-81.37442789199991,
							28.564255212000035
						],
						[
							-81.37442639599993,
							28.56434181800006
						],
						[
							-81.37442062799994,
							28.564400385000056
						],
						[
							-81.37442045599994,
							28.564401683000085
						],
						[
							-81.37440960899994,
							28.564483159000076
						],
						[
							-81.37447466599991,
							28.56450649700008
						],
						[
							-81.37451515599992,
							28.56452213500006
						],
						[
							-81.37456875999995,
							28.564546422000035
						],
						[
							-81.37462066099994,
							28.564574164000078
						],
						[
							-81.37467063699995,
							28.564605241000038
						],
						[
							-81.37468826999992,
							28.564617328000054
						],
						[
							-81.37486246599991,
							28.56473981000005
						],
						[
							-81.37503808899993,
							28.564851004000047
						],
						[
							-81.37528397599993,
							28.564251656000067
						],
						[
							-81.3752851349999,
							28.564248844000076
						],
						[
							-81.37530255399992,
							28.56420948300007
						],
						[
							-81.37545955399992,
							28.563876483000058
						],
						[
							-81.37546642299992,
							28.56386224000005
						],
						[
							-81.37549416399992,
							28.563810339000042
						],
						[
							-81.37552524099993,
							28.563760363000085
						],
						[
							-81.37555951999991,
							28.563712527000064
						],
						[
							-81.37559685399992,
							28.563667036000083
						],
						[
							-81.37563708299992,
							28.563624083000036
						],
						[
							-81.37568003599995,
							28.56358385400006
						],
						[
							-81.37572552799992,
							28.563546520000045
						],
						[
							-81.37577336399994,
							28.56351224100007
						],
						[
							-81.37582333899991,
							28.563481164000056
						],
						[
							-81.37583503999991,
							28.56347452500006
						],
						[
							-81.37614093099995,
							28.56330396800007
						],
						[
							-81.37614640499993,
							28.56328592200009
						],
						[
							-81.37616713499995,
							28.56323084400009
						],
						[
							-81.37618688399995,
							28.563186580000036
						],
						[
							-81.37628888299992,
							28.56297358000006
						],
						[
							-81.37629342199995,
							28.562964240000042
						],
						[
							-81.37632116399993,
							28.562912339000036
						],
						[
							-81.37632537399992,
							28.562905124000054
						],
						[
							-81.37659137399993,
							28.562454124000055
						],
						[
							-81.3766182409999,
							28.56241136300008
						],
						[
							-81.37664168399994,
							28.562377946000083
						],
						[
							-81.37691203499992,
							28.562010591000046
						],
						[
							-81.37703111799993,
							28.561802406000083
						],
						[
							-81.3769337629999,
							28.561670161000052
						],
						[
							-81.37691024099992,
							28.56163663600006
						],
						[
							-81.3769092249999,
							28.56163511200009
						],
						[
							-81.37664326399994,
							28.56123531200007
						],
						[
							-81.37652549799992,
							28.561112242000036
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "North Orange",
				"RegionID": "269108"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.07262999999995,
					26.734570000000076,
					-80.05800011899993,
					26.753229038000086
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.06858999999992,
							26.753201000000047
						],
						[
							-80.06836299999992,
							26.753199000000052
						],
						[
							-80.06836163999992,
							26.753215856000057
						],
						[
							-80.06834299199994,
							26.75319948600009
						],
						[
							-80.06634034899992,
							26.753136269000038
						],
						[
							-80.06538106999994,
							26.75313935300005
						],
						[
							-80.06517999999994,
							26.753140000000087
						],
						[
							-80.06473118799994,
							26.753136502000075
						],
						[
							-80.06437533199994,
							26.753133380000065
						],
						[
							-80.06398999999993,
							26.753130000000056
						],
						[
							-80.0632761789999,
							26.75310580300004
						],
						[
							-80.06299798099992,
							26.753096372000073
						],
						[
							-80.0628099999999,
							26.753090000000043
						],
						[
							-80.06262565299994,
							26.753078911000046
						],
						[
							-80.06217761999994,
							26.753051962000086
						],
						[
							-80.06172865999991,
							26.753024957000036
						],
						[
							-80.06135831099994,
							26.753005408000035
						],
						[
							-80.06114199399991,
							26.752997245000074
						],
						[
							-80.06093459899995,
							26.752994813000043
						],
						[
							-80.06080244399993,
							26.753048169000067
						],
						[
							-80.06080272999992,
							26.75303425600004
						],
						[
							-80.0608060479999,
							26.752872644000036
						],
						[
							-80.06082074999995,
							26.752719322000075
						],
						[
							-80.06084014499993,
							26.752517063000084
						],
						[
							-80.06085999999993,
							26.752310000000083
						],
						[
							-80.06086905699993,
							26.75203829600008
						],
						[
							-80.0608727149999,
							26.75189869400009
						],
						[
							-80.06087610899993,
							26.751759518000085
						],
						[
							-80.06087999999994,
							26.751600000000053
						],
						[
							-80.06087763799991,
							26.751434646000064
						],
						[
							-80.0608747579999,
							26.751233093000053
						],
						[
							-80.06087255199994,
							26.75107861400005
						],
						[
							-80.06086999999991,
							26.75090000000006
						],
						[
							-80.06086487399995,
							26.750784672000066
						],
						[
							-80.06086006999993,
							26.750676573000078
						],
						[
							-80.06085251999993,
							26.750506704000088
						],
						[
							-80.0608385889999,
							26.750290248000056
						],
						[
							-80.0608299999999,
							26.750170000000082
						],
						[
							-80.06080552199995,
							26.74995044700006
						],
						[
							-80.06078264699994,
							26.749748381000074
						],
						[
							-80.06076881099995,
							26.749626162000084
						],
						[
							-80.06074999999993,
							26.749460000000056
						],
						[
							-80.06072201799994,
							26.74928411600007
						],
						[
							-80.06070242899995,
							26.74916098500006
						],
						[
							-80.06067999999993,
							26.749020000000087
						],
						[
							-80.06064681399994,
							26.74877110700004
						],
						[
							-80.0606204629999,
							26.748573469000064
						],
						[
							-80.06060167899994,
							26.74843258900006
						],
						[
							-80.0605799999999,
							26.748270000000048
						],
						[
							-80.06052112899994,
							26.747906963000048
						],
						[
							-80.06045999999992,
							26.74753000000004
						],
						[
							-80.06041865999993,
							26.747271624000064
						],
						[
							-80.06037646499993,
							26.747007904000043
						],
						[
							-80.06033999999994,
							26.74678000000006
						],
						[
							-80.0603093009999,
							26.746546685000055
						],
						[
							-80.06027648999992,
							26.746297323000082
						],
						[
							-80.0602479449999,
							26.74608038200006
						],
						[
							-80.06022999999993,
							26.745940000000076
						],
						[
							-80.05998453399991,
							26.745935976000055
						],
						[
							-80.05982350499994,
							26.745933277000063
						],
						[
							-80.05962128699991,
							26.745929889000085
						],
						[
							-80.05827800999992,
							26.736482170000045
						],
						[
							-80.05830999999995,
							26.736480001000075
						],
						[
							-80.05829184299995,
							26.736376913000072
						],
						[
							-80.05800011899993,
							26.734720678000087
						],
						[
							-80.05800473199992,
							26.734720731000042
						],
						[
							-80.05818866399994,
							26.734722859000044
						],
						[
							-80.0583406149999,
							26.734725161000085
						],
						[
							-80.05839266299995,
							26.73472594900005
						],
						[
							-80.05849168299994,
							26.734727450000037
						],
						[
							-80.0586556909999,
							26.73474090600007
						],
						[
							-80.05866230199992,
							26.734744858000056
						],
						[
							-80.05865999999992,
							26.73473000000007
						],
						[
							-80.05900584099993,
							26.73474503700004
						],
						[
							-80.05917639699993,
							26.734752452000066
						],
						[
							-80.05934999999994,
							26.73476000000005
						],
						[
							-80.05943935099992,
							26.73476000000005
						],
						[
							-80.0595199999999,
							26.73476000000005
						],
						[
							-80.05965614299993,
							26.73476349100008
						],
						[
							-80.05996541099995,
							26.73477125900007
						],
						[
							-80.0601664589999,
							26.734775829000057
						],
						[
							-80.06034999999991,
							26.73478000000006
						],
						[
							-80.06057010699993,
							26.734790159000056
						],
						[
							-80.06078627099993,
							26.734800136000047
						],
						[
							-80.06099999999992,
							26.73481000000004
						],
						[
							-80.06125010199992,
							26.734816119000072
						],
						[
							-80.06193051499991,
							26.73483276500008
						],
						[
							-80.06255058599993,
							26.734847935000065
						],
						[
							-80.0630763609999,
							26.734860798000057
						],
						[
							-80.06343165299995,
							26.73486949000005
						],
						[
							-80.06395742699993,
							26.734882353000046
						],
						[
							-80.06426999999991,
							26.734890000000064
						],
						[
							-80.06449586899993,
							26.734865582000054
						],
						[
							-80.0649137979999,
							26.734820400000046
						],
						[
							-80.06722999999994,
							26.734570000000076
						],
						[
							-80.0672855649999,
							26.734740920000036
						],
						[
							-80.06738454499992,
							26.73514984400009
						],
						[
							-80.06745103499992,
							26.73544018700005
						],
						[
							-80.0675142579999,
							26.73571625900007
						],
						[
							-80.0675986729999,
							26.736084874000085
						],
						[
							-80.06762772299994,
							26.736211722000064
						],
						[
							-80.06767999999994,
							26.736440000000073
						],
						[
							-80.06772359899992,
							26.736608582000088
						],
						[
							-80.06775909399994,
							26.736745831000064
						],
						[
							-80.06782886399992,
							26.737015608000036
						],
						[
							-80.06790366699995,
							26.737216446000048
						],
						[
							-80.06802239399991,
							26.737491831000057
						],
						[
							-80.06811581499994,
							26.73768517700006
						],
						[
							-80.06820999999991,
							26.737850000000037
						],
						[
							-80.06828253299994,
							26.737956616000076
						],
						[
							-80.06844263499994,
							26.738184708000063
						],
						[
							-80.06860035799993,
							26.738398957000072
						],
						[
							-80.06874139399991,
							26.738594237000086
						],
						[
							-80.0688386089999,
							26.738734890000046
						],
						[
							-80.06895939399993,
							26.738917246000085
						],
						[
							-80.06908209399995,
							26.739133480000078
						],
						[
							-80.0691502709999,
							26.739260942000044
						],
						[
							-80.06923212099991,
							26.739414713000087
						],
						[
							-80.06929980299992,
							26.73956511700004
						],
						[
							-80.06937066599994,
							26.73972259100009
						],
						[
							-80.06944413199994,
							26.739885849000075
						],
						[
							-80.0695139739999,
							26.740049927000086
						],
						[
							-80.06958193499992,
							26.74024410000004
						],
						[
							-80.06963832799994,
							26.74040522300004
						],
						[
							-80.06969910599992,
							26.740596425000035
						],
						[
							-80.06974988199994,
							26.74081543300008
						],
						[
							-80.0697847319999,
							26.740980110000066
						],
						[
							-80.06983557199995,
							26.74120007600004
						],
						[
							-80.06986023899992,
							26.74138679100008
						],
						[
							-80.06987595599993,
							26.741528490000064
						],
						[
							-80.06989272599992,
							26.741758161000064
						],
						[
							-80.06990075199991,
							26.741958796000063
						],
						[
							-80.06990630799993,
							26.742097697000077
						],
						[
							-80.06990999999995,
							26.74219000000005
						],
						[
							-80.06990674499991,
							26.742422203000046
						],
						[
							-80.06990349499995,
							26.74265403000004
						],
						[
							-80.06990045899994,
							26.74287061800004
						],
						[
							-80.06989720899992,
							26.743102444000044
						],
						[
							-80.06989135899994,
							26.74351973200004
						],
						[
							-80.06988810599996,
							26.743751775000078
						],
						[
							-80.06988355599992,
							26.744076332000077
						],
						[
							-80.0698799999999,
							26.744330000000048
						],
						[
							-80.0698799999999,
							26.744601826000068
						],
						[
							-80.0698799999999,
							26.74491098900006
						],
						[
							-80.0698841009999,
							26.745513743000064
						],
						[
							-80.06988999999993,
							26.745850000000075
						],
						[
							-80.06988999999993,
							26.745960000000082
						],
						[
							-80.06992229799994,
							26.746129563000068
						],
						[
							-80.06998331599993,
							26.746426607000046
						],
						[
							-80.07006113299991,
							26.74666783200007
						],
						[
							-80.07015605299995,
							26.74692048500009
						],
						[
							-80.07027946699992,
							26.74719882800008
						],
						[
							-80.0703696409999,
							26.74737401300007
						],
						[
							-80.07046721299992,
							26.747557447000077
						],
						[
							-80.07062999999994,
							26.747790000000066
						],
						[
							-80.07069492599993,
							26.747885224000072
						],
						[
							-80.07080796699995,
							26.748043928000072
						],
						[
							-80.07095529999992,
							26.74822265800009
						],
						[
							-80.07116425099991,
							26.748476140000037
						],
						[
							-80.07136694799993,
							26.74872203500007
						],
						[
							-80.07161835199992,
							26.749073498000087
						],
						[
							-80.0717699999999,
							26.749290000000087
						],
						[
							-80.07185159799991,
							26.74943601700005
						],
						[
							-80.07195633999993,
							26.74962345000006
						],
						[
							-80.07208043399993,
							26.74986160300006
						],
						[
							-80.07222309299993,
							26.750153114000057
						],
						[
							-80.07232593499992,
							26.75039339700004
						],
						[
							-80.07240736099993,
							26.750595771000064
						],
						[
							-80.07248566399994,
							26.75080220600006
						],
						[
							-80.07252022699993,
							26.750907425000037
						],
						[
							-80.0725698309999,
							26.751098984000066
						],
						[
							-80.07260492499995,
							26.75130954900004
						],
						[
							-80.07262125899992,
							26.75143392700005
						],
						[
							-80.07262999999995,
							26.751600000000053
						],
						[
							-80.07256012999994,
							26.752039977000038
						],
						[
							-80.07244478799993,
							26.753229038000086
						],
						[
							-80.07243899999992,
							26.753228999000044
						],
						[
							-80.06908399999992,
							26.75320600000009
						],
						[
							-80.06858999999992,
							26.753201000000047
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "West Palm Beach",
				"Name": "Northwood Hills",
				"RegionID": "269113"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.05275999999992,
					26.73643000000004,
					-80.04740438499994,
					26.74662770900005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.0509193449999,
							26.74659539000004
						],
						[
							-80.04973729199992,
							26.74643461700009
						],
						[
							-80.0488514779999,
							26.746595665000086
						],
						[
							-80.04882880899993,
							26.74649765600009
						],
						[
							-80.0488193409999,
							26.746451166000043
						],
						[
							-80.04880632099992,
							26.746329006000053
						],
						[
							-80.04879232099995,
							26.745959006000078
						],
						[
							-80.04879195199993,
							26.745921860000067
						],
						[
							-80.0487641009999,
							26.745859874000075
						],
						[
							-80.04861159799992,
							26.745542909000054
						],
						[
							-80.04858572099994,
							26.745489950000035
						],
						[
							-80.04856469099991,
							26.745434885000066
						],
						[
							-80.04854867799992,
							26.74537815800005
						],
						[
							-80.04853780999991,
							26.745320225000057
						],
						[
							-80.04853217499993,
							26.745261552000045
						],
						[
							-80.04834403599995,
							26.745028533000042
						],
						[
							-80.0479953869999,
							26.744733781000036
						],
						[
							-80.04793854399992,
							26.74468137300005
						],
						[
							-80.04788641199991,
							26.74462427600008
						],
						[
							-80.04783937699995,
							26.74456291200005
						],
						[
							-80.04779778599993,
							26.74449773500004
						],
						[
							-80.04776194699991,
							26.74442922700007
						],
						[
							-80.0476309469999,
							26.74415022700009
						],
						[
							-80.04761775099992,
							26.744120759000054
						],
						[
							-80.04747575099992,
							26.743787759000043
						],
						[
							-80.04744779799995,
							26.74371322500008
						],
						[
							-80.04742654599994,
							26.74363651200008
						],
						[
							-80.04741215999991,
							26.743558220000068
						],
						[
							-80.0474047539999,
							26.743478963000086
						],
						[
							-80.04740438499994,
							26.743399361000062
						],
						[
							-80.04741105599993,
							26.743320039000082
						],
						[
							-80.04749805599994,
							26.74264503900008
						],
						[
							-80.04752673399992,
							26.742507905000082
						],
						[
							-80.04776033099995,
							26.741707984000072
						],
						[
							-80.04797892499994,
							26.74084901000009
						],
						[
							-80.04808944199993,
							26.740326250000066
						],
						[
							-80.04811176599992,
							26.740057543000034
						],
						[
							-80.04811990399992,
							26.739990351000074
						],
						[
							-80.0482095989999,
							26.73942812100006
						],
						[
							-80.04831056799992,
							26.738831562000087
						],
						[
							-80.0482490789999,
							26.73877007300007
						],
						[
							-80.04815916399991,
							26.738641661000088
						],
						[
							-80.04809291399994,
							26.738499586000046
						],
						[
							-80.0480523409999,
							26.73834816600004
						],
						[
							-80.0480386779999,
							26.738192000000083
						],
						[
							-80.04805225399991,
							26.738036323000074
						],
						[
							-80.04811025399994,
							26.737706324000044
						],
						[
							-80.04811699999995,
							26.737671899000077
						],
						[
							-80.04837437799995,
							26.73648182000005
						],
						[
							-80.04930165299993,
							26.736448703000065
						],
						[
							-80.05068999999992,
							26.73643000000004
						],
						[
							-80.05087188699991,
							26.73643000000004
						],
						[
							-80.05112463399992,
							26.73643337200008
						],
						[
							-80.0513499999999,
							26.736440000000073
						],
						[
							-80.0514957979999,
							26.736448436000046
						],
						[
							-80.05159267199991,
							26.736460855000075
						],
						[
							-80.05181999999992,
							26.73649000000006
						],
						[
							-80.0519389559999,
							26.736519739000073
						],
						[
							-80.05202774799994,
							26.736542627000063
						],
						[
							-80.0522345139999,
							26.73661271700007
						],
						[
							-80.05248783499991,
							26.73669858800008
						],
						[
							-80.05265983299995,
							26.736764916000087
						],
						[
							-80.05274983399995,
							26.736809917000073
						],
						[
							-80.05274006499992,
							26.73688996700008
						],
						[
							-80.05275999999992,
							26.73744000100004
						],
						[
							-80.05273999999991,
							26.738240000000076
						],
						[
							-80.05271999999991,
							26.73914000000008
						],
						[
							-80.05271999999991,
							26.739340001000073
						],
						[
							-80.0526999999999,
							26.74007000100005
						],
						[
							-80.05267999999995,
							26.740920001000063
						],
						[
							-80.05265999999996,
							26.74165000000005
						],
						[
							-80.05264999999991,
							26.742040000000088
						],
						[
							-80.05263999999994,
							26.742540001000066
						],
						[
							-80.05261999999993,
							26.743490000000065
						],
						[
							-80.05259999999993,
							26.744240000000048
						],
						[
							-80.05258999999995,
							26.744540001000075
						],
						[
							-80.05257999999992,
							26.745160001000045
						],
						[
							-80.05256353099992,
							26.745769341000084
						],
						[
							-80.05255999999991,
							26.745900000000063
						],
						[
							-80.0525199999999,
							26.74656000100009
						],
						[
							-80.05251488199991,
							26.74662770900005
						],
						[
							-80.0509193449999,
							26.74659539000004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "West Palm Beach",
				"Name": "Northwood Shores",
				"RegionID": "269115"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.34397275799994,
					28.37476142023096,
					-81.25627155985826,
					28.451565379000346
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-81.32599899999987,
								28.3890220000001
							],
							[
								-81.32821799999988,
								28.38899900000015
							],
							[
								-81.32821999999986,
								28.38954000000015
							],
							[
								-81.3282129999999,
								28.393234000000085
							],
							[
								-81.3282149999999,
								28.39334500000003
							],
							[
								-81.32683899999991,
								28.39337700000001
							],
							[
								-81.32671999999992,
								28.39337700000001
							],
							[
								-81.32671299999987,
								28.394521000000164
							],
							[
								-81.32619199999993,
								28.394237000000114
							],
							[
								-81.3260359999999,
								28.394151000000107
							],
							[
								-81.32599899999987,
								28.3890220000001
							]
						]
					],
					[
						[
							[
								-81.32775999999991,
								28.39515500000004
							],
							[
								-81.3277619999999,
								28.39461600000003
							],
							[
								-81.32751799999996,
								28.39461600000003
							],
							[
								-81.32751799999996,
								28.395015000000182
							],
							[
								-81.32742799999988,
								28.394966000000036
							],
							[
								-81.32703399999978,
								28.39471500000005
							],
							[
								-81.32695499999991,
								28.394667000000165
							],
							[
								-81.32685599999989,
								28.394602000000116
							],
							[
								-81.32683799999991,
								28.393504000000043
							],
							[
								-81.32833699999986,
								28.393501000000146
							],
							[
								-81.3283459999999,
								28.395531000000066
							],
							[
								-81.32783099999992,
								28.39519700000014
							],
							[
								-81.32775999999991,
								28.39515500000004
							]
						]
					],
					[
						[
							[
								-81.30254318099979,
								28.451560371000287
							],
							[
								-81.30147101066649,
								28.4515495273337
							],
							[
								-81.2891875419999,
								28.4515090070003
							],
							[
								-81.28921514499989,
								28.449797609000274
							],
							[
								-81.2884833289999,
								28.44970061400033
							],
							[
								-81.28677279299977,
								28.449431213000157
							],
							[
								-81.28656949199981,
								28.449395161000194
							],
							[
								-81.28499415399978,
								28.449152801000213
							],
							[
								-81.28432115599969,
								28.449039634000354
							],
							[
								-81.2827338019998,
								28.448811293000023
							],
							[
								-81.28174032999975,
								28.448707138000376
							],
							[
								-81.28142686499966,
								28.44868210200026
							],
							[
								-81.28070379299979,
								28.448643045000317
							],
							[
								-81.27999173499975,
								28.44862201200026
							],
							[
								-81.27993164699976,
								28.44862201200026
							],
							[
								-81.27931373099989,
								28.44862501800033
							],
							[
								-81.27894918899992,
								28.44862702000032
							],
							[
								-81.27847248299992,
								28.44862702000032
							],
							[
								-81.2781610199999,
								28.448617006000024
							],
							[
								-81.27702733999989,
								28.448629024000308
							],
							[
								-81.2766367589999,
								28.448633028000284
							],
							[
								-81.2735471779997,
								28.448615001000302
							],
							[
								-81.2702172399998,
								28.448618007000196
							],
							[
								-81.26955425699991,
								28.448618007000196
							],
							[
								-81.26861786899988,
								28.448629024000308
							],
							[
								-81.26764342299991,
								28.448640039000246
							],
							[
								-81.26660654401972,
								28.44863302208768
							],
							[
								-81.26819799999987,
								28.44827300000016
							],
							[
								-81.2688809999999,
								28.448282000000194
							],
							[
								-81.26888049999985,
								28.448277500000177
							],
							[
								-81.2688799999999,
								28.44827300000016
							],
							[
								-81.26888399999987,
								28.44809800000007
							],
							[
								-81.26888799999995,
								28.447888000000102
							],
							[
								-81.26889699999988,
								28.44748700000014
							],
							[
								-81.26858999999989,
								28.447482000000083
							],
							[
								-81.2657829999999,
								28.447082000000204
							],
							[
								-81.26406699999984,
								28.446837000000183
							],
							[
								-81.26347999999986,
								28.44678400000006
							],
							[
								-81.26331299999981,
								28.44682500000008
							],
							[
								-81.26262798488237,
								28.445726718773404
							],
							[
								-81.26198102599352,
								28.444727236162596
							],
							[
								-81.26071314580122,
								28.442767330168476
							],
							[
								-81.25937215681584,
								28.440735316854063
							],
							[
								-81.25851488410126,
								28.43942837888395
							],
							[
								-81.25818239212899,
								28.438896588983834
							],
							[
								-81.25794103305564,
								28.438456937203608
							],
							[
								-81.25771569994134,
								28.437956194000794
							],
							[
								-81.25756046985309,
								28.437478486865256
							],
							[
								-81.25736117382444,
								28.436754411993906
							],
							[
								-81.25733222431542,
								28.436637208828692
							],
							[
								-81.25724900775377,
								28.43582102806838
							],
							[
								-81.2572259740359,
								28.435484529855973
							],
							[
								-81.25718491291315,
								28.434998808791004
							],
							[
								-81.25719092109856,
								28.43474643476959
							],
							[
								-81.2571608768233,
								28.434089460955395
							],
							[
								-81.2571378421558,
								28.43344149919435
							],
							[
								-81.25709578101012,
								28.43315307081308
							],
							[
								-81.25708376224024,
								28.432868649121193
							],
							[
								-81.25707374781521,
								28.43233585919808
							],
							[
								-81.25707274684258,
								28.432275770147722
							],
							[
								-81.25706974107547,
								28.43220266280461
							],
							[
								-81.25702167079491,
								28.43122020477661
							],
							[
								-81.25693554275936,
								28.43052417178537
							],
							[
								-81.25689948979903,
								28.43037995899397
							],
							[
								-81.25675327221333,
								28.429911262961763
							],
							[
								-81.256486877027,
								28.429282331977316
							],
							[
								-81.25627155985826,
								28.428948944095037
							],
							[
								-81.2685889589998,
								28.429075156000142
							],
							[
								-81.26843746699988,
								28.421963344000215
							],
							[
								-81.2767580699999,
								28.421963607000325
							],
							[
								-81.27682792499974,
								28.415276700000295
							],
							[
								-81.27660627199968,
								28.4144049950002
							],
							[
								-81.27795649699985,
								28.414085181000207
							],
							[
								-81.27812778999963,
								28.414044102000272
							],
							[
								-81.27843847399976,
								28.413932052000238
							],
							[
								-81.27848462799976,
								28.413896816000168
							],
							[
								-81.27894623299977,
								28.413479578500148
							],
							[
								-81.2796443549997,
								28.412849613000294
							],
							[
								-81.28039190899966,
								28.4120928980003
							],
							[
								-81.28071500699974,
								28.41164073400019
							],
							[
								-81.28087881499971,
								28.411395425000414
							],
							[
								-81.28105699299971,
								28.411039070000147
							],
							[
								-81.2811694629997,
								28.41071222700037
							],
							[
								-81.28117193599971,
								28.410700860000407
							],
							[
								-81.28114971099983,
								28.409915547000356
							],
							[
								-81.28101310799963,
								28.409066924000218
							],
							[
								-81.28100937199984,
								28.409041385000325
							],
							[
								-81.28100360299963,
								28.408982818000364
							],
							[
								-81.28100167799965,
								28.408924000000294
							],
							[
								-81.2810022899997,
								28.408890816000213
							],
							[
								-81.28102311699985,
								28.40832675400026
							],
							[
								-81.28101011299975,
								28.408242843000334
							],
							[
								-81.28092250399976,
								28.408025109000437
							],
							[
								-81.28081301699977,
								28.407793170000346
							],
							[
								-81.28070749799991,
								28.407640135000026
							],
							[
								-81.28148160099992,
								28.40717853600029
							],
							[
								-81.28220515399994,
								28.407137618000284
							],
							[
								-81.28220707999992,
								28.40700508700024
							],
							[
								-81.28265863392875,
								28.378695267085977
							],
							[
								-81.29022391078074,
								28.37582104492188
							],
							[
								-81.29264450077709,
								28.3750649238301
							],
							[
								-81.29445919300717,
								28.37476142023096
							],
							[
								-81.29597248114695,
								28.374913574028785
							],
							[
								-81.29793935321537,
								28.375972269220387
							],
							[
								-81.30954719216372,
								28.384007129919123
							],
							[
								-81.30955499999988,
								28.384262000000074
							],
							[
								-81.30958499999987,
								28.384324000000053
							],
							[
								-81.30959899999988,
								28.384871000000192
							],
							[
								-81.30959299999982,
								28.38534700000014
							],
							[
								-81.30959349999986,
								28.385351000000117
							],
							[
								-81.3095939999999,
								28.385355000000093
							],
							[
								-81.3097279999999,
								28.3853400000001
							],
							[
								-81.31034969200275,
								28.385343502490304
							],
							[
								-81.31043799999993,
								28.38534400000007
							],
							[
								-81.31061499999993,
								28.385452000000125
							],
							[
								-81.3113949999999,
								28.385736000000175
							],
							[
								-81.31169897607948,
								28.385825404729484
							],
							[
								-81.31175199999986,
								28.38584100000016
							],
							[
								-81.31205699999987,
								28.385907000000113
							],
							[
								-81.31240999999994,
								28.385977000000043
							],
							[
								-81.31269299999991,
								28.386012000000097
							],
							[
								-81.3130019999998,
								28.386059000000078
							],
							[
								-81.31327999999989,
								28.38611300000011
							],
							[
								-81.31349999999979,
								28.38614000000003
							],
							[
								-81.31357599999978,
								28.386160000000086
							],
							[
								-81.32162299999982,
								28.391800000000092
							],
							[
								-81.3260349999999,
								28.39442300000005
							],
							[
								-81.32673299999993,
								28.394838000000103
							],
							[
								-81.32686699999992,
								28.394918000000153
							],
							[
								-81.32751699999996,
								28.395304000000113
							],
							[
								-81.32775999999991,
								28.39547500000005
							],
							[
								-81.32782399999978,
								28.395523000000114
							],
							[
								-81.32818999999996,
								28.39573800000014
							],
							[
								-81.32835399999993,
								28.395794000000155
							],
							[
								-81.32850299999983,
								28.39584500000011
							],
							[
								-81.32868315503232,
								28.395896167885862
							],
							[
								-81.33111033712532,
								28.39658553955832
							],
							[
								-81.33111899999992,
								28.396588000000126
							],
							[
								-81.33257299999978,
								28.39775900000003
							],
							[
								-81.33313699999991,
								28.401247000000144
							],
							[
								-81.3334469999999,
								28.401823000000018
							],
							[
								-81.33498999999993,
								28.40469500000015
							],
							[
								-81.3370699999999,
								28.406721000000097
							],
							[
								-81.3379489999998,
								28.407528000000074
							],
							[
								-81.33994699999991,
								28.409281000000167
							],
							[
								-81.34281599999989,
								28.411784000000143
							],
							[
								-81.34284359399994,
								28.411784000000143
							],
							[
								-81.3428749959998,
								28.41181142100019
							],
							[
								-81.34320648799978,
								28.41209584200019
							],
							[
								-81.34324454299991,
								28.412127389000222
							],
							[
								-81.34332566299977,
								28.41219799400029
							],
							[
								-81.34353297199971,
								28.412376260000297
							],
							[
								-81.34389864499985,
								28.412725776000084
							],
							[
								-81.34397275799994,
								28.42010585500027
							],
							[
								-81.34153895499973,
								28.420105882000364
							],
							[
								-81.34036533799988,
								28.419021940000206
							],
							[
								-81.33792952899988,
								28.419113119000375
							],
							[
								-81.33788759899987,
								28.42229496900021
							],
							[
								-81.33785254799982,
								28.423587886000337
							],
							[
								-81.33786456599984,
								28.426776612000385
							],
							[
								-81.33792064799968,
								28.427009963000064
							],
							[
								-81.33796871999992,
								28.428863710000233
							],
							[
								-81.33810692299981,
								28.429694942000264
							],
							[
								-81.33809891299977,
								28.43055722100029
							],
							[
								-81.33814806799992,
								28.430917765000277
							],
							[
								-81.33796362999986,
								28.431382437000355
							],
							[
								-81.33809799199979,
								28.432217692000275
							],
							[
								-81.33785936899993,
								28.432782538000296
							],
							[
								-81.33838152199988,
								28.433544680000296
							],
							[
								-81.33675794299992,
								28.434987978000343
							],
							[
								-81.33565420999992,
								28.43437572900022
							],
							[
								-81.3356482779998,
								28.43444598900017
							],
							[
								-81.33563926499991,
								28.434666316000193
							],
							[
								-81.33563625999993,
								28.43476145600025
							],
							[
								-81.33563125299979,
								28.43485760000021
							],
							[
								-81.3356123109999,
								28.435394543000317
							],
							[
								-81.33482596599985,
								28.43498165300026
							],
							[
								-81.33519961199987,
								28.43743642300033
							],
							[
								-81.3352204839999,
								28.437573702000236
							],
							[
								-81.33579166499992,
								28.438195483000253
							],
							[
								-81.33580350699994,
								28.43975586300022
							],
							[
								-81.33572725799982,
								28.440186617000332
							],
							[
								-81.33639546099987,
								28.44019334600027
							],
							[
								-81.33645746299985,
								28.44026280200033
							],
							[
								-81.3372085789999,
								28.439678560000306
							],
							[
								-81.33883216799978,
								28.44058099000019
							],
							[
								-81.33874200099979,
								28.44815745200037
							],
							[
								-81.3372084579999,
								28.44824832800025
							],
							[
								-81.33718167909512,
								28.449984580549273
							],
							[
								-81.33689099999992,
								28.450035000000113
							],
							[
								-81.33529099999988,
								28.45031300000002
							],
							[
								-81.33505899999996,
								28.45035300000013
							],
							[
								-81.33505799999996,
								28.450495000000156
							],
							[
								-81.3350623843595,
								28.451097411004614
							],
							[
								-81.33506299999993,
								28.451182000000156
							],
							[
								-81.33506299999993,
								28.4514230000002
							],
							[
								-81.33506299999993,
								28.45155500000011
							],
							[
								-81.33369199999993,
								28.45155800000018
							],
							[
								-81.33153999999985,
								28.451559000000085
							],
							[
								-81.33048699999995,
								28.451559000000085
							],
							[
								-81.3304844319999,
								28.45143017000026
							],
							[
								-81.33024127099968,
								28.4514421950001
							],
							[
								-81.32937898099992,
								28.451481254000225
							],
							[
								-81.32921974299971,
								28.45149026700035
							],
							[
								-81.32892831199976,
								28.451488263000005
							],
							[
								-81.3267861339998,
								28.4515133010003
							],
							[
								-81.32300452799974,
								28.45153533300017
							],
							[
								-81.32211220299988,
								28.45154634900037
							],
							[
								-81.32034057599984,
								28.451544347000205
							],
							[
								-81.31751338199977,
								28.451545348000376
							],
							[
								-81.31518893499992,
								28.45154634900037
							],
							[
								-81.31492754699978,
								28.45154634900037
							],
							[
								-81.31214341799982,
								28.451542345000217
							],
							[
								-81.31179890799983,
								28.45154034000014
							],
							[
								-81.30991310999984,
								28.45153633600034
							],
							[
								-81.30972583399972,
								28.4515583670003
							],
							[
								-81.30937831799974,
								28.4515583670003
							],
							[
								-81.30917701899988,
								28.451562372000364
							],
							[
								-81.30835780499977,
								28.451559368000293
							],
							[
								-81.3082326179998,
								28.4515583670003
							],
							[
								-81.30783903499983,
								28.451560371000287
							],
							[
								-81.3076347319998,
								28.45156137200028
							],
							[
								-81.30593721499969,
								28.451565379000346
							],
							[
								-81.30254318099979,
								28.451560371000287
							]
						],
						[
							[
								-81.31033805899966,
								28.416252916000243
							],
							[
								-81.31016237899978,
								28.41624874800043
							],
							[
								-81.31014419999978,
								28.4163158580003
							],
							[
								-81.31002998399974,
								28.417102259999997
							],
							[
								-81.31002204199989,
								28.417148449000354
							],
							[
								-81.31000867799985,
								28.41720576200021
							],
							[
								-81.30999159499986,
								28.417262078000253
							],
							[
								-81.30997086499983,
								28.41731715600037
							],
							[
								-81.30994764599977,
								28.417368585000094
							],
							[
								-81.3098991114998,
								28.417467672500255
							],
							[
								-81.30987083499973,
								28.417520661000243
							],
							[
								-81.30983975899981,
								28.417570637000114
							],
							[
								-81.30980547999974,
								28.417618473000342
							],
							[
								-81.30976814599967,
								28.417663964000287
							],
							[
								-81.3097279159998,
								28.417706917000377
							],
							[
								-81.3096849639998,
								28.417747146000245
							],
							[
								-81.30963947199967,
								28.41778448000031
							],
							[
								-81.30959813199989,
								28.417814378000298
							],
							[
								-81.30950413199984,
								28.417878378000086
							],
							[
								-81.30949763599968,
								28.41788275900036
							],
							[
								-81.3094476609998,
								28.417913836000356
							],
							[
								-81.30939575999967,
								28.41794157800034
							],
							[
								-81.30934215599969,
								28.41796586600022
							],
							[
								-81.30928707699974,
								28.417986596000336
							],
							[
								-81.30923076199979,
								28.418003679000417
							],
							[
								-81.3092265929997,
								28.41800478500033
							],
							[
								-81.30907059299977,
								28.41804578400026
							],
							[
								-81.30901744899981,
								28.418058041000297
							],
							[
								-81.30895938499962,
								28.41806762800029
							],
							[
								-81.30890081799984,
								28.418073396000235
							],
							[
								-81.30884199999977,
								28.418075322000217
							],
							[
								-81.30881668099981,
								28.418074965000454
							],
							[
								-81.3086746809996,
								28.418070966000034
							],
							[
								-81.30864118099986,
								28.418069397000348
							],
							[
								-81.30858261499962,
								28.418063629000404
							],
							[
								-81.30852455099989,
								28.418054042000232
							],
							[
								-81.30846723799976,
								28.41804067900028
							],
							[
								-81.30841092199972,
								28.418023595000466
							],
							[
								-81.30835584399978,
								28.41800286600044
							],
							[
								-81.3083022399997,
								28.417978578000383
							],
							[
								-81.30825033899984,
								28.41795083600022
							],
							[
								-81.30820036299961,
								28.417919759000046
							],
							[
								-81.30816413499973,
								28.417894239000244
							],
							[
								-81.30813313499965,
								28.417871239000295
							],
							[
								-81.30812152699967,
								28.417862480000014
							],
							[
								-81.30807603599963,
								28.417825146000478
							],
							[
								-81.30803308299981,
								28.41778491700008
							],
							[
								-81.30799285399968,
								28.417741964000346
							],
							[
								-81.30795551999988,
								28.417696473000227
							],
							[
								-81.30792124099979,
								28.41764863700035
							],
							[
								-81.30791061199972,
								28.417631543000358
							],
							[
								-81.3079436379997,
								28.41779288500021
							],
							[
								-81.30806743799972,
								28.418156300000526
							],
							[
								-81.30842116849982,
								28.41810856500057
							],
							[
								-81.30846437699988,
								28.418103863000358
							],
							[
								-81.30870137599986,
								28.418083863000124
							],
							[
								-81.30871818099983,
								28.418082604000286
							],
							[
								-81.30877699999972,
								28.418080678000305
							],
							[
								-81.30891099999963,
								28.418080678000305
							],
							[
								-81.30891720299978,
								28.418080699000217
							],
							[
								-81.30935220199989,
								28.418083700000203
							],
							[
								-81.3094048179997,
								28.418085604000357
							],
							[
								-81.30946484249968,
								28.41809156650054
							],
							[
								-81.31051829999983,
								28.418233761000447
							],
							[
								-81.31053956099983,
								28.41823689000044
							],
							[
								-81.31173156099986,
								28.418426889999996
							],
							[
								-81.31174791299969,
								28.41842965100049
							],
							[
								-81.31184385999981,
								28.4184467640004
							],
							[
								-81.31193063099971,
								28.417713566000305
							],
							[
								-81.31195667799965,
								28.417365407000364
							],
							[
								-81.31195667799965,
								28.417266000000225
							],
							[
								-81.31195860299971,
								28.41720718200033
							],
							[
								-81.31196437099993,
								28.417148615000368
							],
							[
								-81.31197395799983,
								28.41709055100036
							],
							[
								-81.31198327999981,
								28.417048883000287
							],
							[
								-81.31203427999985,
								28.41684388200047
							],
							[
								-81.31203832199992,
								28.41682823800024
							],
							[
								-81.31205540499973,
								28.416771922000198
							],
							[
								-81.31207626499967,
								28.41671653000041
							],
							[
								-81.31209744699993,
								28.41645211000038
							],
							[
								-81.31204894899973,
								28.416446232000073
							],
							[
								-81.3114872029997,
								28.416403763000023
							],
							[
								-81.31143723499983,
								28.416398578000216
							],
							[
								-81.31033805899966,
								28.416252916000243
							]
						],
						[
							[
								-81.3078861199999,
								28.41666106700035
							],
							[
								-81.30803795299977,
								28.41605114100016
							],
							[
								-81.30783524999978,
								28.41603473200031
							],
							[
								-81.3078460129996,
								28.416445440000363
							],
							[
								-81.30784439599984,
								28.416527819000343
							],
							[
								-81.30783862799989,
								28.416586385000034
							],
							[
								-81.30783757499991,
								28.41659412200023
							],
							[
								-81.30783342199983,
								28.416623686000367
							],
							[
								-81.30784174399979,
								28.41675146400046
							],
							[
								-81.30786042199973,
								28.416710240000423
							],
							[
								-81.30787330099973,
								28.41668512700021
							],
							[
								-81.3078861199999,
								28.41666106700035
							]
						],
						[
							[
								-81.29376485099964,
								28.38553770800029
							],
							[
								-81.29345814899976,
								28.38533194600014
							],
							[
								-81.29344743899985,
								28.38532767300023
							],
							[
								-81.29270230899975,
								28.38522832200027
							],
							[
								-81.29242200199974,
								28.38522832200027
							],
							[
								-81.29228728599978,
								28.38524607500023
							],
							[
								-81.29214801099971,
								28.385285537000296
							],
							[
								-81.2912902709998,
								28.385611860000207
							],
							[
								-81.29061345499984,
								28.385959104000342
							],
							[
								-81.28963330499965,
								28.386610022000372
							],
							[
								-81.28923504599992,
								28.38690102100038
							],
							[
								-81.28910982299986,
								28.38699929100034
							],
							[
								-81.28900694599979,
								28.38713061100037
							],
							[
								-81.28897514599973,
								28.387168964000256
							],
							[
								-81.28894410199983,
								28.387202597000286
							],
							[
								-81.28870710199985,
								28.387446596000313
							],
							[
								-81.2886979159998,
								28.387455916000373
							],
							[
								-81.2886549639997,
								28.387496146000327
							],
							[
								-81.28860947199968,
								28.38753348000022
							],
							[
								-81.2885616359998,
								28.38756775900048
							],
							[
								-81.28854065999984,
								28.387581357000006
							],
							[
								-81.28830365999987,
								28.387730357000255
							],
							[
								-81.28827466099978,
								28.38774783600037
							],
							[
								-81.28822275999966,
								28.387775578000358
							],
							[
								-81.28816915499975,
								28.38779986500032
							],
							[
								-81.2881140769998,
								28.387820595000438
							],
							[
								-81.28805776099976,
								28.387837679000253
							],
							[
								-81.28800044899991,
								28.38785104200038
							],
							[
								-81.28794238499981,
								28.387860628000286
							],
							[
								-81.28793654699977,
								28.387861378000526
							],
							[
								-81.28724963499978,
								28.38794724100008
							],
							[
								-81.28705457899963,
								28.388001219000284
							],
							[
								-81.28679647299985,
								28.388112655000267
							],
							[
								-81.28678415499972,
								28.38811786500052
							],
							[
								-81.2867582639999,
								28.388128123000303
							],
							[
								-81.28624207999972,
								28.388323436000388
							],
							[
								-81.28594737899977,
								28.388467236000384
							],
							[
								-81.28589715599979,
								28.388489865000214
							],
							[
								-81.28584207799985,
								28.38851059500051
							],
							[
								-81.28580531999965,
								28.388522200000313
							],
							[
								-81.28549332199987,
								28.38861340000022
							],
							[
								-81.28525900099974,
								28.38868962500022
							],
							[
								-81.28505096299976,
								28.388808702000393
							],
							[
								-81.28506981699991,
								28.388822325000366
							],
							[
								-81.28521831199986,
								28.38886687400041
							],
							[
								-81.28539068199973,
								28.388906126000283
							],
							[
								-81.28542376099988,
								28.388914321000517
							],
							[
								-81.28548007699975,
								28.388931404000246
							],
							[
								-81.28553515499976,
								28.38895213400036
							],
							[
								-81.28558875999977,
								28.38897642200006
							],
							[
								-81.28564066099989,
								28.389004164000045
							],
							[
								-81.28569063599984,
								28.38903524100022
							],
							[
								-81.2857384719998,
								28.38906951900039
							],
							[
								-81.28578396399983,
								28.389106853000282
							],
							[
								-81.28582691599966,
								28.389147083000235
							],
							[
								-81.28585268799984,
								28.389173944000238
							],
							[
								-81.28601468799974,
								28.389349944000234
							],
							[
								-81.28602914599979,
								28.38936603500041
							],
							[
								-81.28606647999976,
								28.389411527000266
							],
							[
								-81.28610075899967,
								28.389459363000316
							],
							[
								-81.28612338899977,
								28.389495016000517
							],
							[
								-81.28651723799985,
								28.39014895500053
							],
							[
								-81.28669904599961,
								28.39037755700026
							],
							[
								-81.28682627199974,
								28.390517153000264
							],
							[
								-81.2871908459998,
								28.39077023800051
							],
							[
								-81.28722547199965,
								28.390795520000115
							],
							[
								-81.28723862599985,
								28.390805809000522
							],
							[
								-81.28760362599968,
								28.391096809000263
							],
							[
								-81.28763596399978,
								28.391123854000284
							],
							[
								-81.28767891599986,
								28.391164083000323
							],
							[
								-81.28771914599973,
								28.391207036000413
							],
							[
								-81.2877564799998,
								28.391252527000358
							],
							[
								-81.28777237599978,
								28.391273891000527
							],
							[
								-81.28808037599968,
								28.39170089100033
							],
							[
								-81.28809875899978,
								28.39172736300039
							],
							[
								-81.28812402499966,
								28.391767421000328
							],
							[
								-81.28830199499964,
								28.392066772000316
							],
							[
								-81.28866525899967,
								28.392492990000232
							],
							[
								-81.2888389254997,
								28.392677743500375
							],
							[
								-81.28890849899982,
								28.39275207300044
							],
							[
								-81.28906348499976,
								28.39287292800005
							],
							[
								-81.28936725199985,
								28.39302922800037
							],
							[
								-81.28981082099978,
								28.393168885000467
							],
							[
								-81.29042693199979,
								28.393298000000403
							],
							[
								-81.29098689699993,
								28.39334832400048
							],
							[
								-81.29157760399977,
								28.393401943000033
							],
							[
								-81.29167931799975,
								28.393395117000356
							],
							[
								-81.2919289519998,
								28.39330544800031
							],
							[
								-81.2925333019998,
								28.392942838000504
							],
							[
								-81.29254633899971,
								28.392935164000225
							],
							[
								-81.29259823999983,
								28.392907423000327
							],
							[
								-81.2926385399998,
								28.392888771000383
							],
							[
								-81.29322873599978,
								28.39263311900037
							],
							[
								-81.29328514199965,
								28.39260855600038
							],
							[
								-81.29410395049976,
								28.39208098300016
							],
							[
								-81.29449904399972,
								28.39182648500024
							],
							[
								-81.2948414379998,
								28.391537175000284
							],
							[
								-81.29522805299985,
								28.391210251000235
							],
							[
								-81.29577233999974,
								28.390648010000344
							],
							[
								-81.29597306799982,
								28.390439983000096
							],
							[
								-81.29616188999982,
								28.390119475000223
							],
							[
								-81.29626249499971,
								28.389887205000367
							],
							[
								-81.2963743749999,
								28.389470041000315
							],
							[
								-81.29638113899975,
								28.389446142000377
							],
							[
								-81.29647492399988,
								28.389131458000456
							],
							[
								-81.2964856789997,
								28.388994786000513
							],
							[
								-81.29647405199971,
								28.388857855000467
							],
							[
								-81.29646730199987,
								28.38878191200031
							],
							[
								-81.29635462799978,
								28.38843734700031
							],
							[
								-81.29621892599965,
								28.388107671000387
							],
							[
								-81.29596707099978,
								28.387663927000442
							],
							[
								-81.29568538199975,
								28.387311629000248
							],
							[
								-81.29517353399967,
								28.386872649000342
							],
							[
								-81.29516603599967,
								28.386866146000425
							],
							[
								-81.29516156799974,
								28.386862201000366
							],
							[
								-81.29421756699979,
								28.386023201000224
							],
							[
								-81.2941790829999,
								28.385986917000242
							],
							[
								-81.29415277399977,
								28.38595947200037
							],
							[
								-81.29387034299984,
								28.385652090000338
							],
							[
								-81.29376485099964,
								28.38553770800029
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Orlando International Airport",
				"RegionID": "269122"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.37306458599994,
					28.573096674000055,
					-81.35694755799994,
					28.58207800000008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.36089099999992,
							28.58207800000008
						],
						[
							-81.35819099999992,
							28.581878000000074
						],
						[
							-81.35799099999991,
							28.581578000000036
						],
						[
							-81.35789099999995,
							28.581378000000086
						],
						[
							-81.35739099999995,
							28.580978000000073
						],
						[
							-81.3573435159999,
							28.581025484000065
						],
						[
							-81.35699099999994,
							28.581378000000086
						],
						[
							-81.35699099999994,
							28.580688338000073
						],
						[
							-81.35699099999994,
							28.580635000000086
						],
						[
							-81.35699099999994,
							28.58040961100005
						],
						[
							-81.35699099999994,
							28.580178000000046
						],
						[
							-81.35694755799994,
							28.579396039000073
						],
						[
							-81.35737520499993,
							28.579171031000044
						],
						[
							-81.35757703299993,
							28.57904171100006
						],
						[
							-81.3579905709999,
							28.578717913000048
						],
						[
							-81.35799752799994,
							28.578712520000067
						],
						[
							-81.3580453639999,
							28.578678241000034
						],
						[
							-81.35809533899993,
							28.578647164000074
						],
						[
							-81.35812456899993,
							28.57863100500009
						],
						[
							-81.3582285679999,
							28.57857600500006
						],
						[
							-81.3582512399999,
							28.578564423000046
						],
						[
							-81.35830484399992,
							28.578540135000086
						],
						[
							-81.35835992199992,
							28.578519405000065
						],
						[
							-81.3584162379999,
							28.578502322000077
						],
						[
							-81.35847355099992,
							28.578488958000037
						],
						[
							-81.35848109299992,
							28.57848749200008
						],
						[
							-81.35859935099995,
							28.578465017000042
						],
						[
							-81.3586409479999,
							28.578430711000067
						],
						[
							-81.35868053399992,
							28.578389117000086
						],
						[
							-81.35901473699994,
							28.57786130100004
						],
						[
							-81.35903591599993,
							28.57781406600009
						],
						[
							-81.35897927299993,
							28.577732095000044
						],
						[
							-81.35980045799994,
							28.57733852300004
						],
						[
							-81.36440405499991,
							28.57739311800009
						],
						[
							-81.3644239539999,
							28.575209750000056
						],
						[
							-81.36442495599994,
							28.575079557000038
						],
						[
							-81.3644429279999,
							28.573096674000055
						],
						[
							-81.36500181199995,
							28.57340507100008
						],
						[
							-81.36573689999994,
							28.573552292000045
						],
						[
							-81.3661044239999,
							28.573699641000076
						],
						[
							-81.36676742999992,
							28.57369950900005
						],
						[
							-81.36728219299994,
							28.57362640100007
						],
						[
							-81.36787006499992,
							28.57347905000006
						],
						[
							-81.36853313799992,
							28.573626361000038
						],
						[
							-81.36875337499993,
							28.57406805700009
						],
						[
							-81.36882666999992,
							28.574288413000094
						],
						[
							-81.36860615699995,
							28.574582820000046
						],
						[
							-81.36831272199993,
							28.574950365000063
						],
						[
							-81.36801739499992,
							28.575466276000046
						],
						[
							-81.3674294089999,
							28.575613347000058
						],
						[
							-81.36654607899993,
							28.57561321500009
						],
						[
							-81.3657367479999,
							28.575906676000045
						],
						[
							-81.36573672899993,
							28.576421612000047
						],
						[
							-81.3661044509999,
							28.57678909200007
						],
						[
							-81.36772284599994,
							28.57774551100005
						],
						[
							-81.36897368099994,
							28.57848067900005
						],
						[
							-81.37044501699995,
							28.578480466000087
						],
						[
							-81.3704447529999,
							28.578923390000057
						],
						[
							-81.37112088599991,
							28.578890207000086
						],
						[
							-81.37279849999993,
							28.578850009000064
						],
						[
							-81.37306458599994,
							28.582031207000057
						],
						[
							-81.3711909999999,
							28.58207800000008
						],
						[
							-81.3704219999999,
							28.58203300000008
						],
						[
							-81.37005399999993,
							28.581556000000038
						],
						[
							-81.36949099999993,
							28.581978000000053
						],
						[
							-81.36899099999994,
							28.581978000000053
						],
						[
							-81.3670909999999,
							28.581978000000053
						],
						[
							-81.36498699999993,
							28.58199600000006
						],
						[
							-81.36419099999995,
							28.581978000000053
						],
						[
							-81.36089099999992,
							28.58207800000008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Orwin Manor",
				"RegionID": "269124"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.40657699999991,
					28.57539500000007,
					-81.39175333499992,
					28.590831000000037
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.39829199999991,
							28.590078000000062
						],
						[
							-81.39829199999991,
							28.58957900000007
						],
						[
							-81.39829199999991,
							28.58935849900007
						],
						[
							-81.39829199999991,
							28.589278000000036
						],
						[
							-81.39829199999991,
							28.589148000000083
						],
						[
							-81.39814499999994,
							28.589147000000086
						],
						[
							-81.39814499999994,
							28.588677000000075
						],
						[
							-81.39814499999994,
							28.588242000000037
						],
						[
							-81.39675069299996,
							28.58824265800007
						],
						[
							-81.39602699999995,
							28.58824300000009
						],
						[
							-81.39589199999995,
							28.58824300000009
						],
						[
							-81.3952569999999,
							28.588250000000073
						],
						[
							-81.3952569999999,
							28.587808000000052
						],
						[
							-81.3952569999999,
							28.58770300000009
						],
						[
							-81.39505099999991,
							28.58768800000007
						],
						[
							-81.39504999999991,
							28.58732400000008
						],
						[
							-81.3957519999999,
							28.587319000000036
						],
						[
							-81.39575699999995,
							28.587458000000083
						],
						[
							-81.39576999999991,
							28.587597000000073
						],
						[
							-81.39589199999995,
							28.587600000000066
						],
						[
							-81.39602699999995,
							28.58759900000007
						],
						[
							-81.39623199999996,
							28.58759800000007
						],
						[
							-81.39623199999996,
							28.58750871500007
						],
						[
							-81.39623199999996,
							28.587458000000083
						],
						[
							-81.39630496199993,
							28.587458114000075
						],
						[
							-81.39814499999994,
							28.58746100000008
						],
						[
							-81.39814499999994,
							28.587114059000044
						],
						[
							-81.39814499999994,
							28.586861000000056
						],
						[
							-81.39814499999994,
							28.58626981000009
						],
						[
							-81.39814499999994,
							28.585998000000075
						],
						[
							-81.39814599999994,
							28.58576700000009
						],
						[
							-81.39806147399992,
							28.58576700000009
						],
						[
							-81.39718399999992,
							28.58576700000009
						],
						[
							-81.39679699999994,
							28.585759000000053
						],
						[
							-81.39679699999994,
							28.585275843000094
						],
						[
							-81.39679699999994,
							28.585217000000057
						],
						[
							-81.39629899999994,
							28.585236000000066
						],
						[
							-81.39626399999992,
							28.584826000000078
						],
						[
							-81.39623295099994,
							28.584829020000086
						],
						[
							-81.3958629999999,
							28.584865000000036
						],
						[
							-81.39448399999992,
							28.584971000000053
						],
						[
							-81.39444999999995,
							28.58497600000004
						],
						[
							-81.39436199999994,
							28.58497600000004
						],
						[
							-81.39434499999993,
							28.58469500000007
						],
						[
							-81.39434499999993,
							28.58460000000008
						],
						[
							-81.39421399999992,
							28.584726000000046
						],
						[
							-81.39352999999994,
							28.58542600000004
						],
						[
							-81.39348281899993,
							28.585475107000036
						],
						[
							-81.3934500009999,
							28.58539685700004
						],
						[
							-81.39342095799992,
							28.585345782000047
						],
						[
							-81.3932236629999,
							28.58507638100008
						],
						[
							-81.39277199499992,
							28.58467478600005
						],
						[
							-81.39271090499994,
							28.584623711000063
						],
						[
							-81.39268694099991,
							28.584602740000037
						],
						[
							-81.39208297399995,
							28.58408591400007
						],
						[
							-81.39175333499992,
							28.583804455000063
						],
						[
							-81.39229428699991,
							28.583699340000067
						],
						[
							-81.39326873199991,
							28.58351206200007
						],
						[
							-81.39372240499995,
							28.58342493300006
						],
						[
							-81.3943212929999,
							28.58331977800009
						],
						[
							-81.39487911999993,
							28.58322964300004
						],
						[
							-81.39517756399994,
							28.583170556000084
						],
						[
							-81.3953928819999,
							28.58312348700008
						],
						[
							-81.39542793399994,
							28.58311547500006
						],
						[
							-81.39565026499992,
							28.583066402000043
						],
						[
							-81.39610694099991,
							28.58295523600009
						],
						[
							-81.39642140699993,
							28.58284807800004
						],
						[
							-81.39661870099991,
							28.582792995000094
						],
						[
							-81.39675990899991,
							28.582753938000053
						],
						[
							-81.39688309199994,
							28.582719887000053
						],
						[
							-81.39720256699991,
							28.582591697000055
						],
						[
							-81.39764522299993,
							28.582414434000047
						],
						[
							-81.3981149199999,
							28.582226155000058
						],
						[
							-81.39827515799993,
							28.582162061000076
						],
						[
							-81.39837530499996,
							28.58212300200006
						],
						[
							-81.39848446699995,
							28.58207993900004
						],
						[
							-81.39854956499994,
							28.582053899000073
						],
						[
							-81.39879092199993,
							28.58196176300004
						],
						[
							-81.39891811099994,
							28.58189266100004
						],
						[
							-81.39897920099992,
							28.581854605000046
						],
						[
							-81.39905932099992,
							28.581802526000047
						],
						[
							-81.39907934999991,
							28.581788506000066
						],
						[
							-81.39914644899994,
							28.58174544100007
						],
						[
							-81.39956306699992,
							28.581479047000073
						],
						[
							-81.39963016699994,
							28.581435984000052
						],
						[
							-81.39967723599995,
							28.58140493700006
						],
						[
							-81.39974333499993,
							28.58136087200006
						],
						[
							-81.39984648799992,
							28.581291770000064
						],
						[
							-81.4001349159999,
							28.581091472000082
						],
						[
							-81.40038728999991,
							28.58091621300008
						],
						[
							-81.40051247499991,
							28.580838097000083
						],
						[
							-81.40056555399991,
							28.58080504800006
						],
						[
							-81.4007157769999,
							28.580741955000065
						],
						[
							-81.40090105199995,
							28.580687874000034
						],
						[
							-81.40112738699992,
							28.580662836000045
						],
						[
							-81.40135772799995,
							28.580625780000048
						],
						[
							-81.40162712499996,
							28.580522628000043
						],
						[
							-81.40165416799994,
							28.580503600000043
						],
						[
							-81.4016932269999,
							28.58047656000008
						],
						[
							-81.40174734099993,
							28.58044054700008
						],
						[
							-81.40179838299991,
							28.58037841400005
						],
						[
							-81.4018159069999,
							28.580354379000084
						],
						[
							-81.40183944299991,
							28.58031632300009
						],
						[
							-81.4018724899999,
							28.580259239000043
						],
						[
							-81.40188341299995,
							28.58022430400007
						],
						[
							-81.40209199999993,
							28.580078000000075
						],
						[
							-81.40209199999993,
							28.57977800000009
						],
						[
							-81.40209199999993,
							28.579378000000077
						],
						[
							-81.40207599999991,
							28.57878100000005
						],
						[
							-81.40207199999992,
							28.578594000000066
						],
						[
							-81.40229599999992,
							28.57858200000004
						],
						[
							-81.4029139999999,
							28.57858200000004
						],
						[
							-81.40339699999993,
							28.578565000000083
						],
						[
							-81.40339899999992,
							28.578423000000043
						],
						[
							-81.40274699999992,
							28.578422000000046
						],
						[
							-81.40229599999992,
							28.578422000000046
						],
						[
							-81.40206899999993,
							28.578422000000046
						],
						[
							-81.40206632899992,
							28.578252413000087
						],
						[
							-81.40206499999994,
							28.578168000000062
						],
						[
							-81.4020549999999,
							28.578014000000053
						],
						[
							-81.40205999999995,
							28.577892000000077
						],
						[
							-81.40203999999994,
							28.577619000000084
						],
						[
							-81.40204299999994,
							28.57737300000008
						],
						[
							-81.40205899999995,
							28.576272000000074
						],
						[
							-81.40206299999994,
							28.57601600000004
						],
						[
							-81.40229799999992,
							28.57601600000004
						],
						[
							-81.40262399999995,
							28.57601600000004
						],
						[
							-81.40281799999991,
							28.576014000000043
						],
						[
							-81.40281799999991,
							28.57586400000008
						],
						[
							-81.40262399999995,
							28.57586500000008
						],
						[
							-81.40242399999994,
							28.57586500000008
						],
						[
							-81.40241399999991,
							28.575668000000064
						],
						[
							-81.40262899999993,
							28.575667000000067
						],
						[
							-81.40281799999991,
							28.575665000000072
						],
						[
							-81.40281799999991,
							28.575582000000054
						],
						[
							-81.4033609999999,
							28.575586000000044
						],
						[
							-81.40342399999992,
							28.575586000000044
						],
						[
							-81.40342399999992,
							28.576005000000066
						],
						[
							-81.40380699999992,
							28.57600300000007
						],
						[
							-81.40380799999991,
							28.57627300000007
						],
						[
							-81.40453999999994,
							28.576282000000052
						],
						[
							-81.40454099999994,
							28.576002000000074
						],
						[
							-81.4047589999999,
							28.576002000000074
						],
						[
							-81.40451299999995,
							28.575397000000066
						],
						[
							-81.40459599999991,
							28.575397000000066
						],
						[
							-81.40468599999991,
							28.57539500000007
						],
						[
							-81.40485899999995,
							28.57586800000007
						],
						[
							-81.40603271299995,
							28.580181466000056
						],
						[
							-81.40625523199992,
							28.58099923500004
						],
						[
							-81.40619499999991,
							28.581003000000067
						],
						[
							-81.40610599999991,
							28.58101400000004
						],
						[
							-81.40602699999994,
							28.581068000000073
						],
						[
							-81.40595399999995,
							28.581115000000068
						],
						[
							-81.40587799999992,
							28.58121600000004
						],
						[
							-81.4057689999999,
							28.58138400000007
						],
						[
							-81.40573399999994,
							28.58151200000009
						],
						[
							-81.40566899999993,
							28.581720000000075
						],
						[
							-81.40562999999992,
							28.58178200000009
						],
						[
							-81.40558099999993,
							28.58200400000004
						],
						[
							-81.40551599999993,
							28.582061000000067
						],
						[
							-81.40548099999995,
							28.582100000000082
						],
						[
							-81.40542199999993,
							28.582157000000052
						],
						[
							-81.40538199999992,
							28.582200000000057
						],
						[
							-81.4053429999999,
							28.58230500000008
						],
						[
							-81.40526299999993,
							28.582431000000042
						],
						[
							-81.40522399999992,
							28.582501000000036
						],
						[
							-81.40507999999994,
							28.58276600000005
						],
						[
							-81.40497899999991,
							28.58294600000005
						],
						[
							-81.40490699999992,
							28.583158000000083
						],
						[
							-81.40486099999993,
							28.58336600000007
						],
						[
							-81.40483199999994,
							28.58351900000008
						],
						[
							-81.40479299999993,
							28.583837000000074
						],
						[
							-81.40478299999995,
							28.583950000000073
						],
						[
							-81.40484199999992,
							28.58415000000008
						],
						[
							-81.40488199999993,
							28.584277000000043
						],
						[
							-81.40489699999995,
							28.584377000000075
						],
						[
							-81.4049169999999,
							28.584490000000073
						],
						[
							-81.40503099999995,
							28.584660000000042
						],
						[
							-81.40511499999991,
							28.58474700000005
						],
						[
							-81.40524899999991,
							28.584921000000065
						],
						[
							-81.40538299999992,
							28.585060000000055
						],
						[
							-81.4055009999999,
							28.58513700000009
						],
						[
							-81.40568499999995,
							28.585198000000048
						],
						[
							-81.4057689999999,
							28.58523900000006
						],
						[
							-81.40582899999993,
							28.585289000000046
						],
						[
							-81.4059969999999,
							28.585372000000064
						],
						[
							-81.40609599999993,
							28.58540700000009
						],
						[
							-81.40623499999992,
							28.58542400000005
						],
						[
							-81.40632899999991,
							28.585394000000065
						],
						[
							-81.40645299999994,
							28.58542900000009
						],
						[
							-81.4064929999999,
							28.58544600000005
						],
						[
							-81.40657699999991,
							28.58550000000008
						],
						[
							-81.40657699999991,
							28.585987000000046
						],
						[
							-81.40645899999993,
							28.586239000000035
						],
						[
							-81.40605499999992,
							28.586525000000055
						],
						[
							-81.40590399999991,
							28.586693000000082
						],
						[
							-81.40580299999993,
							28.586894000000086
						],
						[
							-81.40580299999993,
							28.587096000000088
						],
						[
							-81.40586999999994,
							28.587348000000077
						],
						[
							-81.40654299999994,
							28.58844000000005
						],
						[
							-81.40654299999994,
							28.58872600000007
						],
						[
							-81.40640799999994,
							28.58909600000004
						],
						[
							-81.40621799999992,
							28.58935800000006
						],
						[
							-81.40604399999995,
							28.589465000000075
						],
						[
							-81.40599999999995,
							28.589492000000064
						],
						[
							-81.40566399999994,
							28.589593000000036
						],
						[
							-81.4050749999999,
							28.589694000000065
						],
						[
							-81.40468799999991,
							28.589711000000083
						],
						[
							-81.40436899999992,
							28.589660000000038
						],
						[
							-81.40404899999993,
							28.589509000000078
						],
						[
							-81.40351099999992,
							28.589139000000046
						],
						[
							-81.40324199999992,
							28.589055000000087
						],
						[
							-81.40297299999992,
							28.58903900000007
						],
						[
							-81.40225854699992,
							28.588957900000082
						],
						[
							-81.4022761999999,
							28.589865002000067
						],
						[
							-81.4022222939999,
							28.58985888300009
						],
						[
							-81.40215537899991,
							28.589864812000087
						],
						[
							-81.40213481799992,
							28.58986639700004
						],
						[
							-81.40209857799994,
							28.589868039000066
						],
						[
							-81.40128592999991,
							28.589888448000067
						],
						[
							-81.40090774099991,
							28.589951736000046
						],
						[
							-81.40047570299993,
							28.59007451000008
						],
						[
							-81.40012018499993,
							28.590247052000052
						],
						[
							-81.39945217299993,
							28.59060566000005
						],
						[
							-81.39941391599992,
							28.59064391700008
						],
						[
							-81.3993709639999,
							28.590684147000047
						],
						[
							-81.39935773199994,
							28.590695525000058
						],
						[
							-81.39919706799992,
							28.590831000000037
						],
						[
							-81.39828799999992,
							28.590831000000037
						],
						[
							-81.39829199999991,
							28.590578000000054
						],
						[
							-81.39829199999991,
							28.59040714300005
						],
						[
							-81.39829199999991,
							28.590078000000062
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Palomar",
				"RegionID": "269131"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.17573138099993,
					25.995903706000036,
					-80.1643117349999,
					26.03358853800006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.1643117349999,
							26.033380908000083
						],
						[
							-80.1648308099999,
							26.03099316400005
						],
						[
							-80.16562672499992,
							26.028640025000072
						],
						[
							-80.16624961499991,
							26.027048195000077
						],
						[
							-80.16711473899994,
							26.024729661000038
						],
						[
							-80.16721855399993,
							26.023518487000047
						],
						[
							-80.16735697399992,
							26.022307312000066
						],
						[
							-80.16725315899993,
							26.01874299800005
						],
						[
							-80.16711473899994,
							26.01607841400005
						],
						[
							-80.16695476199993,
							26.014318666000065
						],
						[
							-80.16690710899991,
							26.013794485000062
						],
						[
							-80.16673408499992,
							26.012652520000074
						],
						[
							-80.1668378999999,
							26.010887666000087
						],
						[
							-80.16676868999991,
							26.008638342000044
						],
						[
							-80.16680329499991,
							26.007115722000037
						],
						[
							-80.1669417139999,
							26.005385473000047
						],
						[
							-80.1670109239999,
							26.00379364300005
						],
						[
							-80.1669763189999,
							26.002444049000076
						],
						[
							-80.16680329499991,
							26.001336689000084
						],
						[
							-80.16649184999994,
							25.999779465000074
						],
						[
							-80.16618040499992,
							25.99853368500004
						],
						[
							-80.16607658999993,
							25.997530141000087
						],
						[
							-80.1659679999999,
							25.99616800000007
						],
						[
							-80.16624799999994,
							25.99616800000007
						],
						[
							-80.16636799999992,
							25.99616800000007
						],
						[
							-80.16686799999991,
							25.99616800000007
						],
						[
							-80.1670959999999,
							25.99616800000007
						],
						[
							-80.1673679999999,
							25.99616800000007
						],
						[
							-80.1688499999999,
							25.996107000000052
						],
						[
							-80.17137699999995,
							25.996046000000035
						],
						[
							-80.17347799999993,
							25.995962000000077
						],
						[
							-80.1750429999999,
							25.995904000000053
						],
						[
							-80.17559296099995,
							25.995903706000036
						],
						[
							-80.17559296099995,
							26.00312468500005
						],
						[
							-80.17559296099995,
							26.00441653300004
						],
						[
							-80.17559296099995,
							26.01071464100005
						],
						[
							-80.17562756599995,
							26.012133446000064
						],
						[
							-80.17562756599995,
							26.014486585000043
						],
						[
							-80.17573138099993,
							26.01701274900006
						],
						[
							-80.17566217099996,
							26.019400493000035
						],
						[
							-80.1754545419999,
							26.021822842000063
						],
						[
							-80.17528151699992,
							26.024210586000038
						],
						[
							-80.17521230699992,
							26.026390701000082
						],
						[
							-80.17521230699992,
							26.02867463000007
						],
						[
							-80.17524691199992,
							26.03082013900007
						],
						[
							-80.17535072699991,
							26.033138673000053
						],
						[
							-80.17216706799991,
							26.033138673000053
						],
						[
							-80.17050602799993,
							26.033242488000045
						],
						[
							-80.16915643399996,
							26.033553933000064
						],
						[
							-80.16815288899994,
							26.03358853800006
						],
						[
							-80.16735697399992,
							26.033553933000064
						],
						[
							-80.16652645499994,
							26.033450118000076
						],
						[
							-80.16541909499995,
							26.03331169800009
						],
						[
							-80.1643117349999,
							26.033380908000083
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Hollywood",
				"Name": "Park East",
				"RegionID": "269133"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.13332716499991,
					26.142447961000073,
					-80.11752972699992,
					26.157961027000056
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.11822677599991,
							26.154745062000075
						],
						[
							-80.1186904619999,
							26.15300949100009
						],
						[
							-80.11902996499992,
							26.15174862200007
						],
						[
							-80.11928634499992,
							26.151013532000036
						],
						[
							-80.11959780699993,
							26.149933931000078
						],
						[
							-80.11997035999991,
							26.14834958000006
						],
						[
							-80.12013969399993,
							26.147157826000072
						],
						[
							-80.1201546339999,
							26.145102765000047
						],
						[
							-80.12021672499992,
							26.144568974000038
						],
						[
							-80.12023475299992,
							26.143593527000064
						],
						[
							-80.12023475299992,
							26.143143861000055
						],
						[
							-80.12023169299994,
							26.14279934700005
						],
						[
							-80.12506090999995,
							26.142679171000054
						],
						[
							-80.12600731299995,
							26.142653132000078
						],
						[
							-80.12695371699994,
							26.142626093000047
						],
						[
							-80.12789811699992,
							26.142599053000087
						],
						[
							-80.12886755599993,
							26.142574016000086
						],
						[
							-80.13332716499991,
							26.142447961000073
						],
						[
							-80.13257004699994,
							26.143245010000044
						],
						[
							-80.13219849599994,
							26.143676651000078
						],
						[
							-80.13191807999993,
							26.144079248000082
						],
						[
							-80.13168773799993,
							26.144479842000067
						],
						[
							-80.13150346499992,
							26.144853396000087
						],
						[
							-80.13132620199991,
							26.145236965000038
						],
						[
							-80.13120702499992,
							26.145602507000035
						],
						[
							-80.13110186799992,
							26.145909962000076
						],
						[
							-80.13102275199992,
							26.14621842100007
						],
						[
							-80.1309676699999,
							26.146498836000035
						],
						[
							-80.13095064399994,
							26.14662502300007
						],
						[
							-80.1308925589999,
							26.146992568000087
						],
						[
							-80.13087252799994,
							26.147363118000044
						],
						[
							-80.13085049599994,
							26.147649543000057
						],
						[
							-80.13084148299993,
							26.148024098000064
						],
						[
							-80.13087553299994,
							26.150295467000035
						],
						[
							-80.13089151899993,
							26.151292960000035
						],
						[
							-80.13095995599991,
							26.152794320000055
						],
						[
							-80.13052668899991,
							26.15283992800005
						],
						[
							-80.13012975999993,
							26.15288170900004
						],
						[
							-80.12936699999995,
							26.15296200000006
						],
						[
							-80.12716599999993,
							26.154262000000074
						],
						[
							-80.12676599999992,
							26.154195000000072
						],
						[
							-80.12656599999991,
							26.154162000000042
						],
						[
							-80.1259409999999,
							26.15407900000008
						],
						[
							-80.12506599999995,
							26.153962000000035
						],
						[
							-80.12466599999993,
							26.154019000000062
						],
						[
							-80.12436599999995,
							26.154062000000067
						],
						[
							-80.12406599999991,
							26.154062000000067
						],
						[
							-80.12392499999993,
							26.154097000000036
						],
						[
							-80.1236659999999,
							26.154162000000042
						],
						[
							-80.1228569999999,
							26.154210000000035
						],
						[
							-80.12196599999993,
							26.154262000000074
						],
						[
							-80.1218659999999,
							26.154512000000068
						],
						[
							-80.12156599999993,
							26.15526200000005
						],
						[
							-80.12148749399995,
							26.155192052000075
						],
						[
							-80.12114399999992,
							26.15488600000009
						],
						[
							-80.12066599999991,
							26.15446200000008
						],
						[
							-80.1205506629999,
							26.154577337000035
						],
						[
							-80.11926599999993,
							26.15586200000007
						],
						[
							-80.11926599999993,
							26.156522000000052
						],
						[
							-80.11926599999993,
							26.15676200000007
						],
						[
							-80.11906199999993,
							26.157054000000073
						],
						[
							-80.11889666099995,
							26.157290008000075
						],
						[
							-80.11856599999993,
							26.157762000000048
						],
						[
							-80.1185410679999,
							26.157811864000053
						],
						[
							-80.11832591099994,
							26.157961027000056
						],
						[
							-80.11752972699992,
							26.157333950000066
						],
						[
							-80.11794635899992,
							26.155792619000067
						],
						[
							-80.11822677599991,
							26.154745062000075
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Poinsettia Heights",
				"RegionID": "269147"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.15384328499995,
					26.122182774000066,
					-80.13859889299994,
					26.13693279200004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.14040739799992,
							26.13693279200004
						],
						[
							-80.14040269499992,
							26.13686302600007
						],
						[
							-80.14006415499995,
							26.136874141000078
						],
						[
							-80.13972156299991,
							26.13688856600004
						],
						[
							-80.1390643929999,
							26.136906321000083
						],
						[
							-80.13859889299994,
							26.13691842600008
						],
						[
							-80.13860299399994,
							26.136914622000063
						],
						[
							-80.13865006299994,
							26.136873561000076
						],
						[
							-80.1394141959999,
							26.136205570000072
						],
						[
							-80.14095337899994,
							26.134425969000063
						],
						[
							-80.1428923549999,
							26.132428970000035
						],
						[
							-80.14325889799994,
							26.132093473000054
						],
						[
							-80.14393783199995,
							26.13141144800005
						],
						[
							-80.14436461399993,
							26.130830650000064
						],
						[
							-80.1448132029999,
							26.130081489000077
						],
						[
							-80.14501052999992,
							26.129711861000093
						],
						[
							-80.1452849019999,
							26.129097026000068
						],
						[
							-80.14541309299995,
							26.12853719900005
						],
						[
							-80.14554128399993,
							26.127973361000045
						],
						[
							-80.14560938299991,
							26.12767792200009
						],
						[
							-80.14562540799994,
							26.12680462900005
						],
						[
							-80.14563341999991,
							26.126373990000047
						],
						[
							-80.14564037199995,
							26.12595637000004
						],
						[
							-80.14814113799991,
							26.12592432300005
						],
						[
							-80.14866605799995,
							26.12591242000008
						],
						[
							-80.14860495699993,
							26.124026375000085
						],
						[
							-80.14551725199993,
							26.123993451000047
						],
						[
							-80.14549020699991,
							26.12222584700004
						],
						[
							-80.14554829299993,
							26.122228842000084
						],
						[
							-80.14572155099995,
							26.12222283400007
						],
						[
							-80.14616220399995,
							26.12223885800006
						],
						[
							-80.1464205879999,
							26.12225287800004
						],
						[
							-80.14720875599994,
							26.12227991800006
						],
						[
							-80.1475071989999,
							26.122275913000067
						],
						[
							-80.14855975899991,
							26.12224987400009
						],
						[
							-80.14952919799994,
							26.12222083100005
						],
						[
							-80.15030634999995,
							26.122182774000066
						],
						[
							-80.15049663299993,
							26.122182774000066
						],
						[
							-80.15050345899994,
							26.12218281400004
						],
						[
							-80.15051478099991,
							26.122422590000046
						],
						[
							-80.1505272739999,
							26.122683666000057
						],
						[
							-80.15053999999992,
							26.123040000000064
						],
						[
							-80.15054306899992,
							26.123181156000047
						],
						[
							-80.15055133499993,
							26.123561411000082
						],
						[
							-80.15055999999993,
							26.123960000000068
						],
						[
							-80.15056874899994,
							26.12420496900006
						],
						[
							-80.1505836369999,
							26.124672735000047
						],
						[
							-80.15058999999991,
							26.12494000000004
						],
						[
							-80.15059611399994,
							26.12511118100008
						],
						[
							-80.15060763299994,
							26.125433721000036
						],
						[
							-80.15059999999994,
							26.125860000000046
						],
						[
							-80.15060692999992,
							26.12625314400009
						],
						[
							-80.1506196979999,
							26.126664264000055
						],
						[
							-80.15063604099993,
							26.127190512000084
						],
						[
							-80.15064999999993,
							26.127640000000042
						],
						[
							-80.15066434999994,
							26.128096823000078
						],
						[
							-80.1506827469999,
							26.128682449000053
						],
						[
							-80.15069468599995,
							26.12906250800006
						],
						[
							-80.15070999999995,
							26.12955000000005
						],
						[
							-80.15116309399991,
							26.129535987000057
						],
						[
							-80.15167999999994,
							26.12952000000007
						],
						[
							-80.15218797199992,
							26.12950907600009
						],
						[
							-80.15274380999995,
							26.129496655000082
						],
						[
							-80.15300021699994,
							26.12948974200009
						],
						[
							-80.15359522799992,
							26.12947258500009
						],
						[
							-80.1536007229999,
							26.129472469000063
						],
						[
							-80.15360137199991,
							26.129735214000053
						],
						[
							-80.15362536799995,
							26.13035110700008
						],
						[
							-80.15364809199991,
							26.130934366000076
						],
						[
							-80.15366858499993,
							26.131491813000082
						],
						[
							-80.1536755599999,
							26.131696425000086
						],
						[
							-80.15368851399995,
							26.132076418000054
						],
						[
							-80.1537104709999,
							26.132720479000056
						],
						[
							-80.15372943799991,
							26.133276850000072
						],
						[
							-80.15374136199996,
							26.13362661700006
						],
						[
							-80.1537564109999,
							26.13406805900007
						],
						[
							-80.15377335099993,
							26.134564973000067
						],
						[
							-80.15378656899992,
							26.13491577500008
						],
						[
							-80.1537989389999,
							26.13520912900009
						],
						[
							-80.15381495299994,
							26.135588889000076
						],
						[
							-80.15384328499995,
							26.136260770000035
						],
						[
							-80.15383511199991,
							26.136606517000075
						],
						[
							-80.15097622299993,
							26.136791584000036
						],
						[
							-80.15096532799993,
							26.136701305000088
						],
						[
							-80.15096244999995,
							26.136639078000087
						],
						[
							-80.14999388599995,
							26.13666425000008
						],
						[
							-80.14898740799993,
							26.13669137900007
						],
						[
							-80.14800293399992,
							26.136720335000064
						],
						[
							-80.14705653099992,
							26.136747375000084
						],
						[
							-80.14611012599994,
							26.136772411000038
						],
						[
							-80.14517173599995,
							26.136796446000062
						],
						[
							-80.14422531699995,
							26.13682749200007
						],
						[
							-80.14233352499991,
							26.13687856900009
						],
						[
							-80.14138812399995,
							26.136905609000053
						],
						[
							-80.14091041599994,
							26.136918628000046
						],
						[
							-80.14040739799992,
							26.13693279200004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Progresso Village",
				"RegionID": "269149"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.41399560699995,
					28.50658100000004,
					-81.4010669999999,
					28.517596594000054
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.40619208999993,
							28.51673481000006
						],
						[
							-81.40619399999991,
							28.515780000000063
						],
						[
							-81.40609199999994,
							28.515780000000063
						],
						[
							-81.40566780699993,
							28.515780000000063
						],
						[
							-81.40542199999993,
							28.515780000000063
						],
						[
							-81.40542199999993,
							28.515708482000036
						],
						[
							-81.40542199999993,
							28.512913000000083
						],
						[
							-81.40526499999993,
							28.512911000000088
						],
						[
							-81.40492899999992,
							28.512911000000088
						],
						[
							-81.4029559999999,
							28.512911000000088
						],
						[
							-81.40296399999994,
							28.512751000000037
						],
						[
							-81.40297099999992,
							28.512600000000077
						],
						[
							-81.40174399999995,
							28.512601000000075
						],
						[
							-81.40174399999995,
							28.51235926600009
						],
						[
							-81.40174399999995,
							28.512254000000045
						],
						[
							-81.40133199999991,
							28.512254000000045
						],
						[
							-81.40132799999992,
							28.510778000000073
						],
						[
							-81.40120199999991,
							28.510778000000073
						],
						[
							-81.4011089999999,
							28.510778000000073
						],
						[
							-81.40110199999992,
							28.510481000000084
						],
						[
							-81.4010669999999,
							28.510481000000084
						],
						[
							-81.4010669999999,
							28.510417000000075
						],
						[
							-81.40106999999995,
							28.510166172000083
						],
						[
							-81.40106999999995,
							28.50986127200008
						],
						[
							-81.40106999999995,
							28.509652561000053
						],
						[
							-81.40106999999995,
							28.509509465000065
						],
						[
							-81.40107699999993,
							28.509374000000037
						],
						[
							-81.40119199999992,
							28.509374000000037
						],
						[
							-81.40132399999993,
							28.509374000000037
						],
						[
							-81.40132699999992,
							28.509078000000045
						],
						[
							-81.40132799999992,
							28.50894500000004
						],
						[
							-81.4013579999999,
							28.506836000000078
						],
						[
							-81.40135299999992,
							28.50659200000007
						],
						[
							-81.40939199999991,
							28.50658100000004
						],
						[
							-81.40869199999992,
							28.507880000000057
						],
						[
							-81.40854699999994,
							28.50819800000005
						],
						[
							-81.40825199999995,
							28.508849000000055
						],
						[
							-81.40819199999993,
							28.508980000000065
						],
						[
							-81.40814599999993,
							28.50933000000009
						],
						[
							-81.41395429999994,
							28.509278866000045
						],
						[
							-81.41395741499991,
							28.50955432300009
						],
						[
							-81.41399560699995,
							28.512931520000052
						],
						[
							-81.41254732399995,
							28.51294440600009
						],
						[
							-81.41153181699991,
							28.512954421000074
						],
						[
							-81.41033903999994,
							28.512947462000056
						],
						[
							-81.41024484299993,
							28.512919486000044
						],
						[
							-81.41004761599993,
							28.512766142000093
						],
						[
							-81.40986334199994,
							28.512644962000085
						],
						[
							-81.40975618499994,
							28.512600898000073
						],
						[
							-81.40964201399993,
							28.512568850000036
						],
						[
							-81.40950280899995,
							28.51255382700009
						],
						[
							-81.40944760499991,
							28.512547682000047
						],
						[
							-81.40943661199992,
							28.514378933000046
						],
						[
							-81.40952247099995,
							28.51527594500004
						],
						[
							-81.40948597499994,
							28.51528177700004
						],
						[
							-81.40947318699995,
							28.51529239900009
						],
						[
							-81.40924142699993,
							28.51551450100004
						],
						[
							-81.40921727099993,
							28.515553211000054
						],
						[
							-81.40915740799994,
							28.515802215000065
						],
						[
							-81.40915167799994,
							28.51582476200008
						],
						[
							-81.4091345949999,
							28.515881078000064
						],
						[
							-81.40911386499994,
							28.515936156000066
						],
						[
							-81.40908957699992,
							28.515989760000082
						],
						[
							-81.40907882599993,
							28.516010857000083
						],
						[
							-81.40897882599995,
							28.516200857000058
						],
						[
							-81.40896183599995,
							28.516231661000063
						],
						[
							-81.40895069699991,
							28.516250423000088
						],
						[
							-81.40884269799996,
							28.516427424000085
						],
						[
							-81.40882275899992,
							28.51645863600004
						],
						[
							-81.40878847999994,
							28.51650647200006
						],
						[
							-81.40875114599993,
							28.516551964000087
						],
						[
							-81.40871091699995,
							28.516594917000077
						],
						[
							-81.4086679639999,
							28.516635146000056
						],
						[
							-81.40862247299992,
							28.516672480000068
						],
						[
							-81.4085746369999,
							28.516706759000044
						],
						[
							-81.4085415159999,
							28.51672785800008
						],
						[
							-81.4080708219999,
							28.517013459000058
						],
						[
							-81.40787311899993,
							28.517135046000078
						],
						[
							-81.40785166099994,
							28.51714783600005
						],
						[
							-81.40781370799994,
							28.517168548000086
						],
						[
							-81.40754570799993,
							28.51730654800008
						],
						[
							-81.40754143299995,
							28.517308735000086
						],
						[
							-81.40748043299993,
							28.51733973400008
						],
						[
							-81.40747075999991,
							28.517344577000074
						],
						[
							-81.40741715599995,
							28.517368865000037
						],
						[
							-81.4073620769999,
							28.517389595000054
						],
						[
							-81.40730576199991,
							28.517406678000047
						],
						[
							-81.40729736599991,
							28.517408884000076
						],
						[
							-81.40700236599992,
							28.517484885000044
						],
						[
							-81.4069534489999,
							28.51749604200006
						],
						[
							-81.40690964899994,
							28.517503634000036
						],
						[
							-81.40656481499991,
							28.517554663000055
						],
						[
							-81.40655506299993,
							28.517558484000062
						],
						[
							-81.40655176599995,
							28.51756066900009
						],
						[
							-81.40654601299991,
							28.517564449000076
						],
						[
							-81.40651411899995,
							28.51758523400008
						],
						[
							-81.4065013959999,
							28.517596594000054
						],
						[
							-81.40619208999993,
							28.51673481000006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Rio Grande Park",
				"RegionID": "269156"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.32274680399996,
					29.631995029000052,
					-82.31576620399994,
					29.638106550000032
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.32220685999994,
							29.63202886600004
						],
						[
							-82.32264067799997,
							29.63204006900003
						],
						[
							-82.32270303899998,
							29.633708115000047
						],
						[
							-82.32274680399996,
							29.635075788000055
						],
						[
							-82.32171831499994,
							29.636169926000036
						],
						[
							-82.31961756999993,
							29.637734543000082
						],
						[
							-82.31819519099997,
							29.637920546000036
						],
						[
							-82.31687128399994,
							29.638106550000032
						],
						[
							-82.31576620399994,
							29.636574757000066
						],
						[
							-82.31826876999997,
							29.634726985000043
						],
						[
							-82.31881884899997,
							29.63432083300006
						],
						[
							-82.31933945399999,
							29.633848363000027
						],
						[
							-82.31969981499998,
							29.63341946500003
						],
						[
							-82.32045332999996,
							29.632668502000058
						],
						[
							-82.320503,
							29.632619000000002
						],
						[
							-82.32089662799996,
							29.631995029000052
						],
						[
							-82.32220685999994,
							29.63202886600004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Alachua",
				"City": "Gainesville",
				"Name": "Sugar Hill",
				"RegionID": "132033"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.95736415899995,
					29.024088000000003,
					-80.93152296499994,
					29.046374
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.94610220799996,
							29.044532134000065
						],
						[
							-80.93982043099999,
							29.03971229800004
						],
						[
							-80.93392698199995,
							29.035212261000027
						],
						[
							-80.93275057699998,
							29.034230020000056
						],
						[
							-80.93217950599995,
							29.03359042100004
						],
						[
							-80.93152296499994,
							29.03232968700007
						],
						[
							-80.93492654599999,
							29.030993382000077
						],
						[
							-80.93745067799995,
							29.030365204000077
						],
						[
							-80.94254462799995,
							29.02910884900007
						],
						[
							-80.94254300000001,
							29.026543
						],
						[
							-80.942541,
							29.025741
						],
						[
							-80.942826,
							29.025710000000004
						],
						[
							-80.942574,
							29.025417
						],
						[
							-80.942575,
							29.025029999999997
						],
						[
							-80.942576,
							29.024353
						],
						[
							-80.943002,
							29.024349000000004
						],
						[
							-80.943002,
							29.024091000000002
						],
						[
							-80.944246,
							29.024088000000003
						],
						[
							-80.944247,
							29.025001
						],
						[
							-80.944247,
							29.025179
						],
						[
							-80.944247,
							29.025400999999995
						],
						[
							-80.944446,
							29.025396999999998
						],
						[
							-80.944725,
							29.025399999999998
						],
						[
							-80.944946,
							29.025408
						],
						[
							-80.94522900000001,
							29.025389
						],
						[
							-80.94535600000002,
							29.025369000000005
						],
						[
							-80.945457,
							29.025349000000002
						],
						[
							-80.94566300000001,
							29.025291
						],
						[
							-80.946365,
							29.025152
						],
						[
							-80.946709,
							29.025110000000005
						],
						[
							-80.947044,
							29.025087000000003
						],
						[
							-80.948738,
							29.025173
						],
						[
							-80.948964,
							29.025185
						],
						[
							-80.948992,
							29.026508000000003
						],
						[
							-80.949055,
							29.027557000000005
						],
						[
							-80.949026,
							29.028117000000005
						],
						[
							-80.95432353899997,
							29.027851901000076
						],
						[
							-80.95522693299995,
							29.028513476000057
						],
						[
							-80.95630816099998,
							29.028894190000074
						],
						[
							-80.95736415899995,
							29.028963855000026
						],
						[
							-80.957276,
							29.029263
						],
						[
							-80.955176,
							29.033363000000005
						],
						[
							-80.954704,
							29.033815000000004
						],
						[
							-80.954384,
							29.034103
						],
						[
							-80.95408,
							29.034311
						],
						[
							-80.953952,
							29.034487000000002
						],
						[
							-80.953638,
							29.034739
						],
						[
							-80.953722,
							29.034945
						],
						[
							-80.953774,
							29.035070000000005
						],
						[
							-80.953998,
							29.035618000000003
						],
						[
							-80.953911,
							29.035714
						],
						[
							-80.953984,
							29.035927
						],
						[
							-80.95475,
							29.037602000000003
						],
						[
							-80.954896,
							29.037894
						],
						[
							-80.955021,
							29.038193
						],
						[
							-80.954736,
							29.038182999999997
						],
						[
							-80.953469,
							29.038207000000003
						],
						[
							-80.953939,
							29.038796000000005
						],
						[
							-80.953566,
							29.040753000000002
						],
						[
							-80.95406300000002,
							29.040712
						],
						[
							-80.954592,
							29.041095
						],
						[
							-80.955462,
							29.041839
						],
						[
							-80.95558600000001,
							29.042627
						],
						[
							-80.955044,
							29.042627
						],
						[
							-80.951264,
							29.042598999999996
						],
						[
							-80.949188,
							29.042799
						],
						[
							-80.948712,
							29.04253
						],
						[
							-80.948807,
							29.046038000000003
						],
						[
							-80.948457,
							29.046374
						],
						[
							-80.94610220799996,
							29.044532134000065
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Volusia",
				"City": "New Smyrna Beach",
				"Name": "Fairway",
				"RegionID": "144985"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.26135770099995,
					25.92568891600007,
					-80.24461407999996,
					25.94068122500005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.25330975899999,
							25.93933932500005
						],
						[
							-80.25318502699997,
							25.937017351000065
						],
						[
							-80.25191997699996,
							25.937044267000033
						],
						[
							-80.24892588499995,
							25.93715211400007
						],
						[
							-80.24889585899996,
							25.93715319100005
						],
						[
							-80.24615055599998,
							25.937251348000075
						],
						[
							-80.24596811199996,
							25.933685337000046
						],
						[
							-80.24553711199997,
							25.933693625000046
						],
						[
							-80.24524685799997,
							25.93369920700008
						],
						[
							-80.24508480599997,
							25.93369920700008
						],
						[
							-80.24491409099994,
							25.93369920700008
						],
						[
							-80.24493632399998,
							25.933534749000046
						],
						[
							-80.24476957699994,
							25.93115583100007
						],
						[
							-80.24461407999996,
							25.92645929100007
						],
						[
							-80.24487328699996,
							25.926449390000073
						],
						[
							-80.24560276599993,
							25.926421524000034
						],
						[
							-80.25196282899998,
							25.92616554600005
						],
						[
							-80.25266317099994,
							25.926036839000062
						],
						[
							-80.25270743099998,
							25.92602870500008
						],
						[
							-80.25403061699996,
							25.925969398000063
						],
						[
							-80.25622296299997,
							25.925845683000034
						],
						[
							-80.26064851499996,
							25.92568891600007
						],
						[
							-80.26095254899997,
							25.93231611400006
						],
						[
							-80.26104730399999,
							25.93420743100006
						],
						[
							-80.26117110399997,
							25.936678473000033
						],
						[
							-80.26135770099995,
							25.940342158000078
						],
						[
							-80.25466010299994,
							25.94056177400006
						],
						[
							-80.25372199699996,
							25.940662960000054
						],
						[
							-80.25339226199998,
							25.94068122500005
						],
						[
							-80.25330975899999,
							25.93933932500005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Gardens",
				"Name": "Myrtle Grove",
				"RegionID": "152707"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.91914244699996,
					29.04586629800008,
					-80.89875485499995,
					29.075285999999995
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.89875485499995,
							29.045923389000055
						],
						[
							-80.90369688999994,
							29.045923389000055
						],
						[
							-80.90423354699999,
							29.04586629800008
						],
						[
							-80.90457062799999,
							29.046905631000072
						],
						[
							-80.90465628799996,
							29.047590916000047
						],
						[
							-80.90488471699996,
							29.04821909300006
						],
						[
							-80.90519880499994,
							29.048733057000053
						],
						[
							-80.90605541099995,
							29.05021784100006
						],
						[
							-80.90696912399994,
							29.051702624000033
						],
						[
							-80.90782572999996,
							29.05284476500003
						],
						[
							-80.90925340699994,
							29.05504338700007
						],
						[
							-80.91019567399997,
							29.056242636000036
						],
						[
							-80.91102372599994,
							29.056985028000042
						],
						[
							-80.91213731399995,
							29.057813080000074
						],
						[
							-80.91327945499995,
							29.058926668000026
						],
						[
							-80.91430738199995,
							29.060411451000046
						],
						[
							-80.91479279199996,
							29.06123950400007
						],
						[
							-80.91516398799996,
							29.062096110000027
						],
						[
							-80.91562084499999,
							29.06340005500005
						],
						[
							-80.91609673699998,
							29.064542196000048
						],
						[
							-80.91719128899996,
							29.065684337000054
						],
						[
							-80.91814307299995,
							29.067207192000073
						],
						[
							-80.91828584099994,
							29.068111387000044
						],
						[
							-80.918238252,
							29.069491475000063
						],
						[
							-80.91895208999995,
							29.070728794000047
						],
						[
							-80.91914244699996,
							29.071918525000058
						],
						[
							-80.91867664899996,
							29.073243399000035
						],
						[
							-80.916703,
							29.074566
						],
						[
							-80.915615,
							29.075285999999995
						],
						[
							-80.915516,
							29.075173000000003
						],
						[
							-80.91371485299999,
							29.073107698000058
						],
						[
							-80.913511,
							29.073067
						],
						[
							-80.913013,
							29.072933
						],
						[
							-80.912514,
							29.072663999999996
						],
						[
							-80.912245,
							29.072463
						],
						[
							-80.912098,
							29.072306
						],
						[
							-80.911899,
							29.072127999999996
						],
						[
							-80.911016,
							29.070583
						],
						[
							-80.91091116199993,
							29.070370929000035
						],
						[
							-80.908775,
							29.068662
						],
						[
							-80.908191,
							29.067314999999997
						],
						[
							-80.907475,
							29.065662000000003
						],
						[
							-80.907275,
							29.064262
						],
						[
							-80.906791,
							29.063140000000004
						],
						[
							-80.904175,
							29.056662
						],
						[
							-80.902975,
							29.054062
						],
						[
							-80.898775,
							29.045962
						],
						[
							-80.89875485499995,
							29.045923389000055
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Volusia",
				"City": "New Smyrna Beach",
				"Name": "North Beach",
				"RegionID": "189693"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.78813094899994,
					24.54978338500007,
					-81.77789764099998,
					24.559741835000068
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.77789764099998,
							24.552269466000045
						],
						[
							-81.78183864499994,
							24.54978338500007
						],
						[
							-81.78624403099997,
							24.55557918200003
						],
						[
							-81.78813094899994,
							24.558061641000055
						],
						[
							-81.78740415699997,
							24.558540152000038
						],
						[
							-81.78724012699996,
							24.558648147000042
						],
						[
							-81.78648185299994,
							24.558875361000048
						],
						[
							-81.78359020199998,
							24.559741835000068
						],
						[
							-81.78056026899998,
							24.555758258000026
						],
						[
							-81.78004471099996,
							24.555080433000057
						],
						[
							-81.77789764099998,
							24.552269466000045
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Monroe",
				"City": "Key West",
				"Name": "Midtown",
				"RegionID": "228232"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.38914176499998,
					29.659613012000083,
					-82.38078234199997,
					29.666254962000036
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.38914176499998,
							29.66281779800005
						],
						[
							-82.38914176499998,
							29.66350255800006
						],
						[
							-82.38914176499998,
							29.663746141000047
						],
						[
							-82.38910632499994,
							29.665903202000038
						],
						[
							-82.38910296699999,
							29.666087479000055
						],
						[
							-82.38910260099999,
							29.666107579000027
						],
						[
							-82.38891082599999,
							29.666114302000043
						],
						[
							-82.38571505599998,
							29.666226341000026
						],
						[
							-82.38556699099996,
							29.666254962000036
						],
						[
							-82.38080416799994,
							29.66624816800004
						],
						[
							-82.38078234199997,
							29.659613012000083
						],
						[
							-82.38710648799997,
							29.659613123000042
						],
						[
							-82.38707002099996,
							29.662534667000045
						],
						[
							-82.38914112099997,
							29.66263675400006
						],
						[
							-82.38914176499998,
							29.66272324100004
						],
						[
							-82.38914176499998,
							29.66281779800005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Alachua",
				"City": "Gainesville",
				"Name": "Westmoreland",
				"RegionID": "230503"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.196344,
					26.179212,
					-80.183142,
					26.186530000000005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.192587,
							26.186419
						],
						[
							-80.19210329299995,
							26.186395898000058
						],
						[
							-80.192096,
							26.186395
						],
						[
							-80.191917,
							26.186387
						],
						[
							-80.19106600499998,
							26.186351883000043
						],
						[
							-80.19066602399994,
							26.18633527800006
						],
						[
							-80.18997434899995,
							26.186306360000064
						],
						[
							-80.189296,
							26.186278
						],
						[
							-80.189268,
							26.185861
						],
						[
							-80.189268,
							26.184161
						],
						[
							-80.189268,
							26.183761
						],
						[
							-80.18897994699995,
							26.183761
						],
						[
							-80.187068,
							26.183761
						],
						[
							-80.18548037499994,
							26.183753317000026
						],
						[
							-80.183142,
							26.183742
						],
						[
							-80.18314901499997,
							26.183155780000053
						],
						[
							-80.18317161999994,
							26.181266743000037
						],
						[
							-80.183268,
							26.180361
						],
						[
							-80.183635,
							26.180361
						],
						[
							-80.185268,
							26.180361
						],
						[
							-80.18596800000002,
							26.180261
						],
						[
							-80.186156,
							26.180241
						],
						[
							-80.186138,
							26.180059
						],
						[
							-80.186154,
							26.179242
						],
						[
							-80.18655212199997,
							26.179239893000045
						],
						[
							-80.18703700199995,
							26.179237423000075
						],
						[
							-80.18796800399997,
							26.179232907000028
						],
						[
							-80.193052,
							26.179212
						],
						[
							-80.19306085299996,
							26.17969782300003
						],
						[
							-80.193068,
							26.18009
						],
						[
							-80.194669,
							26.180096
						],
						[
							-80.19502421099997,
							26.180056748000027
						],
						[
							-80.195583,
							26.179995
						],
						[
							-80.19589220699999,
							26.179993326000048
						],
						[
							-80.196322,
							26.179991
						],
						[
							-80.19632075899995,
							26.180086319000054
						],
						[
							-80.196316,
							26.180452
						],
						[
							-80.196344,
							26.182268
						],
						[
							-80.196217,
							26.182271
						],
						[
							-80.19623300000002,
							26.182561
						],
						[
							-80.196209,
							26.183091
						],
						[
							-80.196169,
							26.183261
						],
						[
							-80.196169,
							26.183861
						],
						[
							-80.196161,
							26.183875
						],
						[
							-80.196145,
							26.184199
						],
						[
							-80.196137,
							26.184413
						],
						[
							-80.19615752599998,
							26.184798657000044
						],
						[
							-80.196189,
							26.18539
						],
						[
							-80.19613902799995,
							26.18589864300003
						],
						[
							-80.196077,
							26.186530000000005
						],
						[
							-80.195699,
							26.186479
						],
						[
							-80.19554155199995,
							26.18648700600005
						],
						[
							-80.194873,
							26.186521
						],
						[
							-80.19442073,
							26.186508523000047
						],
						[
							-80.19435289699999,
							26.18650665200005
						],
						[
							-80.193568,
							26.186485
						],
						[
							-80.192587,
							26.186419
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Oakland Park",
				"Name": "Three Lakes",
				"RegionID": "254519"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.1693877379999,
					26.088200314000066,
					-80.15285713899993,
					26.10733664600008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.15309047999995,
							26.098812114000054
						],
						[
							-80.15306944699995,
							26.09810606600007
						],
						[
							-80.15306043399994,
							26.097983886000065
						],
						[
							-80.15303745299991,
							26.097181687000045
						],
						[
							-80.15303033799995,
							26.097156668000085
						],
						[
							-80.15299133199994,
							26.096321420000038
						],
						[
							-80.1529913309999,
							26.096273349000057
						],
						[
							-80.15285713899993,
							26.092609853000056
						],
						[
							-80.15306043399994,
							26.092586881000045
						],
						[
							-80.15327875799994,
							26.09255783900005
						],
						[
							-80.1539457479999,
							26.092444671000067
						],
						[
							-80.15463276699995,
							26.09230546400005
						],
						[
							-80.15489715799993,
							26.092242371000058
						],
						[
							-80.15555613599992,
							26.092081131000043
						],
						[
							-80.15582853899991,
							26.09200802400005
						],
						[
							-80.15594771699995,
							26.09197898000008
						],
						[
							-80.15667980299992,
							26.091802718000054
						],
						[
							-80.15686106999993,
							26.091763660000083
						],
						[
							-80.15778944699991,
							26.091514291000067
						],
						[
							-80.15845743799991,
							26.091319001000045
						],
						[
							-80.15887505799992,
							26.091220855000074
						],
						[
							-80.15988755899991,
							26.090958466000075
						],
						[
							-80.16065970499994,
							26.090755166000065
						],
						[
							-80.16088904399993,
							26.090689067000085
						],
						[
							-80.16896799999995,
							26.088200314000066
						],
						[
							-80.16896799999995,
							26.088465000000042
						],
						[
							-80.16896899999995,
							26.08853000000005
						],
						[
							-80.16915051399991,
							26.08848856300006
						],
						[
							-80.16917533399993,
							26.08901458400004
						],
						[
							-80.16919436099994,
							26.09296444200004
						],
						[
							-80.1693877379999,
							26.096308487000044
						],
						[
							-80.1690410189999,
							26.096705924000048
						],
						[
							-80.1688379759999,
							26.09730598300007
						],
						[
							-80.16872266299993,
							26.097386999000037
						],
						[
							-80.1685874609999,
							26.09745610500005
						],
						[
							-80.1683621279999,
							26.097640377000065
						],
						[
							-80.16739268899994,
							26.09861682400009
						],
						[
							-80.16704323699992,
							26.09888033200008
						],
						[
							-80.16633511499992,
							26.099082690000046
						],
						[
							-80.16567814899992,
							26.09884216000006
						],
						[
							-80.1649270339999,
							26.098739955000042
						],
						[
							-80.16409479799995,
							26.098875208000038
						],
						[
							-80.16328559899995,
							26.099048463000088
						],
						[
							-80.16149894999995,
							26.09912557800004
						],
						[
							-80.16113425799995,
							26.099153537000063
						],
						[
							-80.16153018699993,
							26.099881689000085
						],
						[
							-80.16136274799993,
							26.100260261000074
						],
						[
							-80.16130566299995,
							26.100390453000045
						],
						[
							-80.16099720699992,
							26.10109450100009
						],
						[
							-80.16086801299991,
							26.10175247500007
						],
						[
							-80.1605805879999,
							26.10273793600004
						],
						[
							-80.16045840599992,
							26.10357117300009
						],
						[
							-80.16044338299992,
							26.103612232000046
						],
						[
							-80.16011790199991,
							26.10450255300009
						],
						[
							-80.15984149099995,
							26.105002294000087
						],
						[
							-80.1596792499999,
							26.10530274000007
						],
						[
							-80.15959207299994,
							26.10546095600006
						],
						[
							-80.15950511799991,
							26.105872632000057
						],
						[
							-80.15909926599994,
							26.106470425000055
						],
						[
							-80.15902828799994,
							26.10684202100009
						],
						[
							-80.15904236199992,
							26.107195552000064
						],
						[
							-80.15893214199991,
							26.107198550000078
						],
						[
							-80.15360924799995,
							26.107317729000044
						],
						[
							-80.1532489299999,
							26.10733664600008
						],
						[
							-80.15322968599992,
							26.10653656900007
						],
						[
							-80.15323569399995,
							26.106424403000062
						],
						[
							-80.15322968699991,
							26.106230115000074
						],
						[
							-80.15325171799992,
							26.105986754000075
						],
						[
							-80.15324470799993,
							26.105484009000065
						],
						[
							-80.15323569499992,
							26.105083414000035
						],
						[
							-80.15322968599992,
							26.10455963700008
						],
						[
							-80.15322067299991,
							26.10420210700005
						],
						[
							-80.1532146639999,
							26.10365930300009
						],
						[
							-80.1532146639999,
							26.103312789000086
						],
						[
							-80.15320765199995,
							26.102848099000084
						],
						[
							-80.1532056499999,
							26.102727922000042
						],
						[
							-80.1531906269999,
							26.102437490000057
						],
						[
							-80.15316759399991,
							26.101754477000043
						],
						[
							-80.15316058299994,
							26.10088318600009
						],
						[
							-80.15315156999992,
							26.100537674000066
						],
						[
							-80.15314556099992,
							26.09995080300007
						],
						[
							-80.15313053799991,
							26.09963433300004
						],
						[
							-80.1531065019999,
							26.099023428000066
						],
						[
							-80.15309047999995,
							26.098812114000054
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "River Oaks",
				"RegionID": "269158"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.16904373999995,
					26.106783937000046,
					-80.15355016199993,
					26.12191246100008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.16312436299995,
							26.121811223000066
						],
						[
							-80.16312435899995,
							26.121578879000083
						],
						[
							-80.16316842499992,
							26.12103907700009
						],
						[
							-80.16322870999994,
							26.12017474700008
						],
						[
							-80.16268370799992,
							26.119505803000038
						],
						[
							-80.16234720799991,
							26.118930952000085
						],
						[
							-80.16207179799994,
							26.118527353000047
						],
						[
							-80.16065970499994,
							26.116846860000066
						],
						[
							-80.16017180299991,
							26.116266972000062
						],
						[
							-80.16037828799995,
							26.11613680700009
						],
						[
							-80.16044554899992,
							26.116094733000068
						],
						[
							-80.1598495099999,
							26.115832183000066
						],
						[
							-80.15970729299994,
							26.115875420000066
						],
						[
							-80.1596221659999,
							26.11589945600008
						],
						[
							-80.15858659499992,
							26.116210101000036
						],
						[
							-80.15708542499995,
							26.115028973000054
						],
						[
							-80.15591450999995,
							26.115598910000074
						],
						[
							-80.1558887839999,
							26.11607983400006
						],
						[
							-80.15359318199995,
							26.116983247000064
						],
						[
							-80.1535770399999,
							26.116966100000074
						],
						[
							-80.1535611779999,
							26.116507357000046
						],
						[
							-80.15355016199993,
							26.11624396600007
						],
						[
							-80.15363129399992,
							26.11558901300009
						],
						[
							-80.1539158839999,
							26.11482985400005
						],
						[
							-80.15356700299992,
							26.11420696500005
						],
						[
							-80.1535745729999,
							26.114181762000044
						],
						[
							-80.15534590699991,
							26.11394370700009
						],
						[
							-80.15579649199992,
							26.113449823000053
						],
						[
							-80.15614300599994,
							26.113019184000052
						],
						[
							-80.1587089269999,
							26.110206077000043
						],
						[
							-80.15876708199994,
							26.110027698000067
						],
						[
							-80.15844141399992,
							26.10973331100007
						],
						[
							-80.1583360759999,
							26.109639166000083
						],
						[
							-80.15921756499995,
							26.10898319800009
						],
						[
							-80.15936492899993,
							26.108873135000067
						],
						[
							-80.15948714299992,
							26.10846844300005
						],
						[
							-80.15931871499993,
							26.107817469000054
						],
						[
							-80.15904236199992,
							26.107195552000064
						],
						[
							-80.15916448699994,
							26.107196548000047
						],
						[
							-80.15945091099991,
							26.10719755000008
						],
						[
							-80.16146089299991,
							26.107173514000067
						],
						[
							-80.16230013699993,
							26.10715548700006
						],
						[
							-80.16281089499995,
							26.107144471000083
						],
						[
							-80.1633316679999,
							26.10712744600005
						],
						[
							-80.16358703999992,
							26.107121346000042
						],
						[
							-80.16374928699992,
							26.10710240900005
						],
						[
							-80.16387648299991,
							26.107082296000044
						],
						[
							-80.1639886339999,
							26.10712051900009
						],
						[
							-80.1643932419999,
							26.107064352000066
						],
						[
							-80.1649771079999,
							26.10693516100008
						],
						[
							-80.16516238199995,
							26.106898107000063
						],
						[
							-80.16546382999992,
							26.106859049000036
						],
						[
							-80.16553493499993,
							26.10685804600007
						],
						[
							-80.16582035899995,
							26.10683501300008
						],
						[
							-80.16608775399993,
							26.106831006000053
						],
						[
							-80.1665043719999,
							26.10683501300008
						],
						[
							-80.16691698499994,
							26.106805969000053
						],
						[
							-80.16725248199992,
							26.10679895800007
						],
						[
							-80.16755993799991,
							26.106795954000063
						],
						[
							-80.1678283359999,
							26.10679895800007
						],
						[
							-80.16837314499992,
							26.10679395200009
						],
						[
							-80.1685063409999,
							26.10678794200004
						],
						[
							-80.1685994799999,
							26.106783937000046
						],
						[
							-80.1687336789999,
							26.10679194900007
						],
						[
							-80.1687405959999,
							26.10679207900006
						],
						[
							-80.16870717599994,
							26.107260170000075
						],
						[
							-80.16867782199995,
							26.10799207100007
						],
						[
							-80.16867175999994,
							26.108470923000084
						],
						[
							-80.16866645899995,
							26.10912847500009
						],
						[
							-80.16867999999994,
							26.109833176000052
						],
						[
							-80.16871039099993,
							26.110616649000065
						],
						[
							-80.16874300799992,
							26.111171132000038
						],
						[
							-80.16880836999991,
							26.111798166000085
						],
						[
							-80.16886115699992,
							26.112257716000045
						],
						[
							-80.16890723799992,
							26.112658896000084
						],
						[
							-80.16896572299993,
							26.11321469300009
						],
						[
							-80.16900134999992,
							26.113741980000043
						],
						[
							-80.1690249909999,
							26.11419979100009
						],
						[
							-80.16903999999994,
							26.11467609400006
						],
						[
							-80.16904373999995,
							26.115811284000074
						],
						[
							-80.16902502799991,
							26.11644281300005
						],
						[
							-80.1689894889999,
							26.117401276000066
						],
						[
							-80.16896509299994,
							26.11800768800009
						],
						[
							-80.16893368699994,
							26.11878835400006
						],
						[
							-80.16891670599995,
							26.119292114000075
						],
						[
							-80.1689066699999,
							26.119796398000062
						],
						[
							-80.16890270199991,
							26.12014948300009
						],
						[
							-80.16890445899992,
							26.12052823600004
						],
						[
							-80.16891199899993,
							26.12093190300004
						],
						[
							-80.1689191019999,
							26.121436273000086
						],
						[
							-80.1689513309999,
							26.121712138000078
						],
						[
							-80.16894499299993,
							26.121712075000065
						],
						[
							-80.1687186559999,
							26.121708070000068
						],
						[
							-80.16855741699993,
							26.121708070000068
						],
						[
							-80.1679875719999,
							26.12171508000006
						],
						[
							-80.16739268899994,
							26.12169805500008
						],
						[
							-80.1672254419999,
							26.12169605200006
						],
						[
							-80.1667968079999,
							26.12169605200006
						],
						[
							-80.16635915799992,
							26.121718085000058
						],
						[
							-80.1657332289999,
							26.121752136000055
						],
						[
							-80.16512532799993,
							26.121784182000056
						],
						[
							-80.16462859099994,
							26.12183325600006
						],
						[
							-80.1644533299999,
							26.12184727600004
						],
						[
							-80.1639876399999,
							26.12188533300008
						],
						[
							-80.16331464199993,
							26.121902359000046
						],
						[
							-80.16315739599992,
							26.12191246100008
						],
						[
							-80.16312436299995,
							26.121811223000066
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Riverside Park",
				"RegionID": "269163"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.7055468769999,
					30.331700959000045,
					-81.68587901399991,
					30.340370009000083
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.69586190699994,
							30.338579010000046
						],
						[
							-81.69580101799994,
							30.33835385500004
						],
						[
							-81.69425576399993,
							30.338449900000057
						],
						[
							-81.69429804899994,
							30.338625127000054
						],
						[
							-81.69422891099993,
							30.338623009000063
						],
						[
							-81.69415991099993,
							30.33860601000004
						],
						[
							-81.69406082199993,
							30.338560112000042
						],
						[
							-81.69342790699994,
							30.337807010000066
						],
						[
							-81.69294690699991,
							30.33725201100009
						],
						[
							-81.69284090799995,
							30.337122011000076
						],
						[
							-81.69246690799991,
							30.336704011000055
						],
						[
							-81.69227590799994,
							30.336489011000083
						],
						[
							-81.69199393899993,
							30.336144822000055
						],
						[
							-81.69120790699992,
							30.336670010000034
						],
						[
							-81.69064293299994,
							30.337025056000073
						],
						[
							-81.69060490499993,
							30.337033953000056
						],
						[
							-81.69055890599992,
							30.337030008000056
						],
						[
							-81.69051386099994,
							30.33701307900009
						],
						[
							-81.69022390799995,
							30.336687011000038
						],
						[
							-81.69010892799992,
							30.336537828000075
						],
						[
							-81.69005590799992,
							30.336580009000045
						],
						[
							-81.68965090799992,
							30.33683601100006
						],
						[
							-81.68957490799994,
							30.33689301100009
						],
						[
							-81.6895289069999,
							30.336941013000057
						],
						[
							-81.68947090699993,
							30.337036010000077
						],
						[
							-81.68935395699992,
							30.337241031000072
						],
						[
							-81.68587901399991,
							30.334982934000042
						],
						[
							-81.68617090599992,
							30.334933008000068
						],
						[
							-81.68842290499992,
							30.334547008000072
						],
						[
							-81.68924690699993,
							30.33439600900005
						],
						[
							-81.6897349059999,
							30.33432400800007
						],
						[
							-81.6902009069999,
							30.33423000800008
						],
						[
							-81.6903379069999,
							30.334208008000076
						],
						[
							-81.69098790699992,
							30.334058008000053
						],
						[
							-81.6916869069999,
							30.333943008000062
						],
						[
							-81.69219190599995,
							30.333866008000083
						],
						[
							-81.69262690699992,
							30.33380100800008
						],
						[
							-81.69316090599996,
							30.33374200800006
						],
						[
							-81.69391590599992,
							30.333624008000076
						],
						[
							-81.69430490699995,
							30.333551008000086
						],
						[
							-81.69662490699994,
							30.33316600900008
						],
						[
							-81.69740288499992,
							30.333038067000075
						],
						[
							-81.69801290599992,
							30.332941008000034
						],
						[
							-81.69860790599995,
							30.332846008000047
						],
						[
							-81.69907390599991,
							30.332760009000086
						],
						[
							-81.7005229049999,
							30.33253300800004
						],
						[
							-81.70104990599992,
							30.33244500900008
						],
						[
							-81.70123290499993,
							30.33241300900005
						],
						[
							-81.70179690599991,
							30.332319008000066
						],
						[
							-81.70318590599993,
							30.332087008000084
						],
						[
							-81.7042309059999,
							30.33191400800007
						],
						[
							-81.70480890599993,
							30.331817008000087
						],
						[
							-81.70529890599995,
							30.33174400900009
						],
						[
							-81.7055468769999,
							30.331700959000045
						],
						[
							-81.70551290799995,
							30.33661106500006
						],
						[
							-81.70437590699993,
							30.336597010000045
						],
						[
							-81.70320890699992,
							30.33657801000004
						],
						[
							-81.70275890699992,
							30.33657801000004
						],
						[
							-81.70136290799991,
							30.336576010000044
						],
						[
							-81.70035577499993,
							30.336566877000053
						],
						[
							-81.70036290699996,
							30.337097011000083
						],
						[
							-81.70037090799991,
							30.337870011000064
						],
						[
							-81.70037790799995,
							30.33870901100005
						],
						[
							-81.70037790799995,
							30.33952701000004
						],
						[
							-81.7004010419999,
							30.34034914200004
						],
						[
							-81.69930290699995,
							30.340357010000048
						],
						[
							-81.6981959069999,
							30.340366010000082
						],
						[
							-81.69736490999992,
							30.340370009000083
						],
						[
							-81.6972959069999,
							30.340353010000058
						],
						[
							-81.69604076799993,
							30.339920136000046
						],
						[
							-81.69595190699994,
							30.339561010000068
						],
						[
							-81.69587685399995,
							30.339275033000035
						],
						[
							-81.69584673899995,
							30.339230056000076
						],
						[
							-81.69586890699992,
							30.338652010000093
						],
						[
							-81.69586190699994,
							30.338579010000046
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Robinson's Addition",
				"RegionID": "269165"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.57146590399992,
					30.17874082800006,
					-81.55177590999995,
					30.220980011000055
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.56647590999995,
							30.220980011000055
						],
						[
							-81.56626690999991,
							30.220976011000065
						],
						[
							-81.56532990999995,
							30.220976011000065
						],
						[
							-81.56469188699992,
							30.220976143000087
						],
						[
							-81.56442590899991,
							30.22087201100004
						],
						[
							-81.5642719189999,
							30.22082196000008
						],
						[
							-81.56223590899994,
							30.220800011000048
						],
						[
							-81.5621949099999,
							30.220800011000048
						],
						[
							-81.56147890999995,
							30.220805011000035
						],
						[
							-81.56143390999995,
							30.220805011000035
						],
						[
							-81.56058990899993,
							30.220805011000035
						],
						[
							-81.56026990899994,
							30.220787011000088
						],
						[
							-81.56005290899992,
							30.220755011000048
						],
						[
							-81.55979090999995,
							30.22071701100009
						],
						[
							-81.55943990999992,
							30.220656011000077
						],
						[
							-81.55918390999994,
							30.220595011000057
						],
						[
							-81.5590048389999,
							30.22053483300005
						],
						[
							-81.55897590899991,
							30.220597010000063
						],
						[
							-81.55893490999995,
							30.220656011000077
						],
						[
							-81.55886186999993,
							30.220755969000038
						],
						[
							-81.5587219119999,
							30.22085500700007
						],
						[
							-81.55856290999994,
							30.220905010000084
						],
						[
							-81.55850191199994,
							30.220915010000052
						],
						[
							-81.55783790999993,
							30.22088201200006
						],
						[
							-81.55734990999991,
							30.22087701200007
						],
						[
							-81.55652590999995,
							30.220858012000065
						],
						[
							-81.5550379089999,
							30.220833011000085
						],
						[
							-81.55448190999994,
							30.22082301100005
						],
						[
							-81.55261190999994,
							30.22078301200008
						],
						[
							-81.55232990899992,
							30.220800011000048
						],
						[
							-81.55203085399995,
							30.22079001400005
						],
						[
							-81.55199090799994,
							30.21859501100005
						],
						[
							-81.5519919059999,
							30.21843498700008
						],
						[
							-81.55198990999992,
							30.218153011000084
						],
						[
							-81.55198590999993,
							30.217451011000037
						],
						[
							-81.5519749099999,
							30.215707012000056
						],
						[
							-81.55196690999992,
							30.21417301100007
						],
						[
							-81.5519509099999,
							30.21380401100004
						],
						[
							-81.55196690999992,
							30.212113011000042
						],
						[
							-81.55195890899995,
							30.21118201200005
						],
						[
							-81.5519519099999,
							30.20992401100006
						],
						[
							-81.5519279099999,
							30.20800801200005
						],
						[
							-81.55193490999994,
							30.20770401100009
						],
						[
							-81.5519269099999,
							30.20702901100009
						],
						[
							-81.55193590999994,
							30.205862012000072
						],
						[
							-81.5519299099999,
							30.205500011000083
						],
						[
							-81.55193190999995,
							30.205237012000055
						],
						[
							-81.55192290999992,
							30.20483401100006
						],
						[
							-81.5519249109999,
							30.204580011000072
						],
						[
							-81.55193190999995,
							30.203838012000062
						],
						[
							-81.55192390999991,
							30.202572011000086
						],
						[
							-81.55191690999993,
							30.20197901100005
						],
						[
							-81.55191490999994,
							30.201590011000064
						],
						[
							-81.55189590999993,
							30.200772011000087
						],
						[
							-81.55188890999995,
							30.19904301200006
						],
						[
							-81.55189590899994,
							30.198819011000065
						],
						[
							-81.55187890899994,
							30.197608011000057
						],
						[
							-81.55187890999991,
							30.196017011000038
						],
						[
							-81.5518839099999,
							30.19519901100006
						],
						[
							-81.55187890999991,
							30.19373801100005
						],
						[
							-81.55186690999994,
							30.190560022000057
						],
						[
							-81.55186390999995,
							30.189174012000084
						],
						[
							-81.55183990899991,
							30.188203012000084
						],
						[
							-81.55183290899993,
							30.18760001100009
						],
						[
							-81.55182490999994,
							30.187458011000047
						],
						[
							-81.55183090999992,
							30.187288011000074
						],
						[
							-81.5518369099999,
							30.18709401100006
						],
						[
							-81.55181990999995,
							30.18516201100005
						],
						[
							-81.55181890999995,
							30.181614011000075
						],
						[
							-81.55179690999995,
							30.180349011000086
						],
						[
							-81.55178190899994,
							30.17986201100007
						],
						[
							-81.55178090999993,
							30.179527012000054
						],
						[
							-81.55178090899996,
							30.179406011000086
						],
						[
							-81.55177590999995,
							30.17928301200004
						],
						[
							-81.55177590999995,
							30.179183011000077
						],
						[
							-81.55178490999992,
							30.179110011000034
						],
						[
							-81.55180285999995,
							30.17903299300008
						],
						[
							-81.5518389099999,
							30.178964011000062
						],
						[
							-81.55189690899994,
							30.178875012000052
						],
						[
							-81.55199489499996,
							30.17874082800006
						],
						[
							-81.55248474399991,
							30.17923460100008
						],
						[
							-81.55280390899992,
							30.179535012000084
						],
						[
							-81.55325990799992,
							30.17998201200004
						],
						[
							-81.55332190799993,
							30.18004301200006
						],
						[
							-81.55348990899995,
							30.180219012000066
						],
						[
							-81.55367590899994,
							30.180421011000078
						],
						[
							-81.55383090899994,
							30.18060001100008
						],
						[
							-81.55425990799995,
							30.181006011000076
						],
						[
							-81.55460389299992,
							30.18133220100009
						],
						[
							-81.55476092599991,
							30.18122482200005
						],
						[
							-81.55542590999994,
							30.181891011000065
						],
						[
							-81.55670184099995,
							30.183164073000057
						],
						[
							-81.55685590999991,
							30.183349012000065
						],
						[
							-81.55703791099995,
							30.183537012000045
						],
						[
							-81.55718491099994,
							30.183688011000072
						],
						[
							-81.55799690899994,
							30.184415012000045
						],
						[
							-81.55814691099994,
							30.18457101200005
						],
						[
							-81.55830097599994,
							30.18472994300004
						],
						[
							-81.55825590899993,
							30.184948011000074
						],
						[
							-81.55818290899992,
							30.185433011000043
						],
						[
							-81.55808890999992,
							30.18596201200006
						],
						[
							-81.55803590999994,
							30.186157011000038
						],
						[
							-81.55798890999995,
							30.186406012000077
						],
						[
							-81.55765890999993,
							30.188258012000063
						],
						[
							-81.55765198699993,
							30.188399157000052
						],
						[
							-81.5574958389999,
							30.188294851000077
						],
						[
							-81.55745690899994,
							30.18849701100004
						],
						[
							-81.55664690999993,
							30.193156011000042
						],
						[
							-81.55639600799992,
							30.19465516600008
						],
						[
							-81.5562138119999,
							30.19460485600007
						],
						[
							-81.55615690999991,
							30.194920011000082
						],
						[
							-81.55612490999995,
							30.195152011000065
						],
						[
							-81.5561159099999,
							30.195398012000055
						],
						[
							-81.55611190899992,
							30.195625011000065
						],
						[
							-81.55610290999994,
							30.195917011000063
						],
						[
							-81.55611190899992,
							30.196145011000052
						],
						[
							-81.55612190999994,
							30.19651401200008
						],
						[
							-81.55612491099993,
							30.196679009000036
						],
						[
							-81.55617590999992,
							30.196876011000086
						],
						[
							-81.5562729099999,
							30.19735201100008
						],
						[
							-81.5563469089999,
							30.19767001100007
						],
						[
							-81.55641290999995,
							30.197915012000067
						],
						[
							-81.55652990999994,
							30.198262012000043
						],
						[
							-81.55674090999992,
							30.198769011000078
						],
						[
							-81.5569109089999,
							30.199129012000068
						],
						[
							-81.55703891199994,
							30.19939301200009
						],
						[
							-81.55711190999995,
							30.199491011000077
						],
						[
							-81.55719190999991,
							30.199616011000042
						],
						[
							-81.5576679099999,
							30.20034701100008
						],
						[
							-81.5577789109999,
							30.200498012000082
						],
						[
							-81.5610269089999,
							30.205488011000057
						],
						[
							-81.56297790899993,
							30.208482011000058
						],
						[
							-81.56370190899992,
							30.20957901200006
						],
						[
							-81.56405290899994,
							30.21013501100009
						],
						[
							-81.56461090999996,
							30.210983012000046
						],
						[
							-81.56596390899995,
							30.21303701100004
						],
						[
							-81.56696590999991,
							30.214579012000062
						],
						[
							-81.5688389099999,
							30.21744601100005
						],
						[
							-81.56912187699993,
							30.217902191000064
						],
						[
							-81.5692498549999,
							30.21780284700009
						],
						[
							-81.56941300599993,
							30.21780784300006
						],
						[
							-81.57111090899991,
							30.22041701200004
						],
						[
							-81.57127590999994,
							30.22066501100005
						],
						[
							-81.57136790899995,
							30.22079001100008
						],
						[
							-81.57146590399992,
							30.220936016000056
						],
						[
							-81.57130290999993,
							30.220944011000082
						],
						[
							-81.57111790899995,
							30.220951011000068
						],
						[
							-81.57091190999995,
							30.22094601100008
						],
						[
							-81.5706379099999,
							30.22095001100007
						],
						[
							-81.57044590999993,
							30.220956012000048
						],
						[
							-81.57041390899991,
							30.220957012000046
						],
						[
							-81.56989190999991,
							30.220966011000087
						],
						[
							-81.5695589099999,
							30.220963011000038
						],
						[
							-81.56865790899992,
							30.220945011000083
						],
						[
							-81.56742690899995,
							30.220960011000045
						],
						[
							-81.56688990999993,
							30.220973012000055
						],
						[
							-81.56647590999995,
							30.220980011000055
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Royal Lakes",
				"RegionID": "269172"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.16322870999994,
					26.115028973000054,
					-80.14539413299991,
					26.12227991800006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.14616220399995,
							26.12223885800006
						],
						[
							-80.14572155099995,
							26.12222283400007
						],
						[
							-80.14554829299993,
							26.122228842000084
						],
						[
							-80.14549020699991,
							26.12222584700004
						],
						[
							-80.14539413299991,
							26.118628407000074
						],
						[
							-80.14558134299995,
							26.118701612000052
						],
						[
							-80.14589580799992,
							26.118821789000037
						],
						[
							-80.1475282319999,
							26.119425870000043
						],
						[
							-80.14802510699991,
							26.11919246000008
						],
						[
							-80.14868282799995,
							26.117365563000078
						],
						[
							-80.1500771229999,
							26.115971628000068
						],
						[
							-80.1501831679999,
							26.115580984000076
						],
						[
							-80.15026116999991,
							26.115287393000074
						],
						[
							-80.15127178199992,
							26.11528354300009
						],
						[
							-80.15363129399992,
							26.11558901300009
						],
						[
							-80.15355016199993,
							26.11624396600007
						],
						[
							-80.1535611779999,
							26.116507357000046
						],
						[
							-80.1535770399999,
							26.116966100000074
						],
						[
							-80.15359318199995,
							26.116983247000064
						],
						[
							-80.1558887839999,
							26.11607983400006
						],
						[
							-80.15591450999995,
							26.115598910000074
						],
						[
							-80.15708542499995,
							26.115028973000054
						],
						[
							-80.15858659499992,
							26.116210101000036
						],
						[
							-80.1596221659999,
							26.11589945600008
						],
						[
							-80.15970729299994,
							26.115875420000066
						],
						[
							-80.1598495099999,
							26.115832183000066
						],
						[
							-80.16044554899992,
							26.116094733000068
						],
						[
							-80.16037828799995,
							26.11613680700009
						],
						[
							-80.16017180299991,
							26.116266972000062
						],
						[
							-80.16065970499994,
							26.116846860000066
						],
						[
							-80.16207179799994,
							26.118527353000047
						],
						[
							-80.16234720799991,
							26.118930952000085
						],
						[
							-80.16268370799992,
							26.119505803000038
						],
						[
							-80.16322870999994,
							26.12017474700008
						],
						[
							-80.16316842499992,
							26.12103907700009
						],
						[
							-80.16312435899995,
							26.121578879000083
						],
						[
							-80.16312436299995,
							26.121811223000066
						],
						[
							-80.16315739599992,
							26.12191246100008
						],
						[
							-80.16268470699993,
							26.12191537700005
						],
						[
							-80.1624453519999,
							26.12191938400008
						],
						[
							-80.16221601299992,
							26.121921386000054
						],
						[
							-80.1616211299999,
							26.121917381000063
						],
						[
							-80.16146089299991,
							26.12191037100007
						],
						[
							-80.16047743399992,
							26.121934405000047
						],
						[
							-80.15944690599991,
							26.12196144500007
						],
						[
							-80.15879293699993,
							26.121977469000058
						],
						[
							-80.15861266899992,
							26.12198347800006
						],
						[
							-80.15757813399995,
							26.12200851500006
						],
						[
							-80.15742490699995,
							26.122015527000087
						],
						[
							-80.15666177599991,
							26.122037558000045
						],
						[
							-80.15621210799992,
							26.12204456900008
						],
						[
							-80.15488514099991,
							26.12207962100007
						],
						[
							-80.1534810579999,
							26.122117677000066
						],
						[
							-80.15319062599991,
							26.122124687000053
						],
						[
							-80.15203591599993,
							26.12215473300006
						],
						[
							-80.15185664899992,
							26.12216174200006
						],
						[
							-80.1517104319999,
							26.122167751000063
						],
						[
							-80.15084114399991,
							26.122184777000086
						],
						[
							-80.15050345899994,
							26.12218281400004
						],
						[
							-80.15049663299993,
							26.122182774000066
						],
						[
							-80.15030634999995,
							26.122182774000066
						],
						[
							-80.14952919799994,
							26.12222083100005
						],
						[
							-80.14855975899991,
							26.12224987400009
						],
						[
							-80.1475071989999,
							26.122275913000067
						],
						[
							-80.14720875599994,
							26.12227991800006
						],
						[
							-80.1464205879999,
							26.12225287800004
						],
						[
							-80.14616220399995,
							26.12223885800006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Sailboat Bend",
				"RegionID": "269174"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.199039,
					25.88436,
					-80.157727,
					25.915035
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.158707,
							25.907935000000002
						],
						[
							-80.15881669599997,
							25.90704959900006
						],
						[
							-80.159433,
							25.904762
						],
						[
							-80.160252,
							25.903368
						],
						[
							-80.161023,
							25.902468
						],
						[
							-80.16218383499996,
							25.901293974000055
						],
						[
							-80.16243108899994,
							25.901044089000038
						],
						[
							-80.16251638999995,
							25.900957387000062
						],
						[
							-80.162772,
							25.9007
						],
						[
							-80.163046,
							25.900427
						],
						[
							-80.163128,
							25.900344
						],
						[
							-80.162922,
							25.900314
						],
						[
							-80.16243908499996,
							25.90017769900004
						],
						[
							-80.162151,
							25.900096
						],
						[
							-80.160385,
							25.900519
						],
						[
							-80.16048605599997,
							25.90020327800005
						],
						[
							-80.16082521299995,
							25.899143667000033
						],
						[
							-80.16094763199999,
							25.89876120100007
						],
						[
							-80.16163507799996,
							25.89639333100007
						],
						[
							-80.164309,
							25.887533
						],
						[
							-80.16616492699997,
							25.887457659000063
						],
						[
							-80.166251,
							25.887502
						],
						[
							-80.166416,
							25.887504
						],
						[
							-80.167023,
							25.887478
						],
						[
							-80.16977200000001,
							25.88736
						],
						[
							-80.16979208999999,
							25.887310416000048
						],
						[
							-80.17812832099997,
							25.88697201100007
						],
						[
							-80.17828,
							25.886968
						],
						[
							-80.17889300199994,
							25.88694097000007
						],
						[
							-80.18080295499999,
							25.886860823000063
						],
						[
							-80.18227,
							25.886807
						],
						[
							-80.184285,
							25.886735
						],
						[
							-80.186311,
							25.886647
						],
						[
							-80.187421,
							25.886607
						],
						[
							-80.187709,
							25.8866
						],
						[
							-80.189084,
							25.886551
						],
						[
							-80.190244,
							25.886501
						],
						[
							-80.191003,
							25.886515
						],
						[
							-80.191328,
							25.886495
						],
						[
							-80.192738,
							25.88636
						],
						[
							-80.19267744999996,
							25.885059390000038
						],
						[
							-80.192882,
							25.884903
						],
						[
							-80.193114,
							25.884897
						],
						[
							-80.193785,
							25.884495000000005
						],
						[
							-80.194271,
							25.884475000000002
						],
						[
							-80.19540030899998,
							25.884410495000054
						],
						[
							-80.19547901099997,
							25.884406212000044
						],
						[
							-80.19576604899999,
							25.88439136100004
						],
						[
							-80.196381,
							25.88436
						],
						[
							-80.196395,
							25.885247
						],
						[
							-80.196431,
							25.886034000000002
						],
						[
							-80.196905,
							25.886042
						],
						[
							-80.19728067799997,
							25.886007939000024
						],
						[
							-80.198501,
							25.885949
						],
						[
							-80.198891,
							25.89516
						],
						[
							-80.19824795199997,
							25.89519666600006
						],
						[
							-80.19829887299994,
							25.895654963000027
						],
						[
							-80.198917,
							25.895642
						],
						[
							-80.199039,
							25.89884
						],
						[
							-80.19479,
							25.898889
						],
						[
							-80.19468815699997,
							25.896176426000068
						],
						[
							-80.194689,
							25.896159
						],
						[
							-80.19467500000002,
							25.895826000000003
						],
						[
							-80.194664,
							25.895583
						],
						[
							-80.194573,
							25.895571
						],
						[
							-80.194555,
							25.895553
						],
						[
							-80.194538,
							25.895498
						],
						[
							-80.194542,
							25.895480000000003
						],
						[
							-80.194573,
							25.895448
						],
						[
							-80.194596,
							25.895398
						],
						[
							-80.193849,
							25.895421
						],
						[
							-80.19348373499997,
							25.89543821700005
						],
						[
							-80.19232890099994,
							25.895487677000062
						],
						[
							-80.19173300000001,
							25.895509
						],
						[
							-80.190897,
							25.895549
						],
						[
							-80.19101843499999,
							25.898139618000073
						],
						[
							-80.191026,
							25.898337000000005
						],
						[
							-80.191068,
							25.899197
						],
						[
							-80.191911,
							25.89916
						],
						[
							-80.192976,
							25.899113
						],
						[
							-80.193002859,
							25.89960000800005
						],
						[
							-80.19301644099994,
							25.89985090600004
						],
						[
							-80.193027,
							25.900048000000005
						],
						[
							-80.193179,
							25.902817
						],
						[
							-80.192086,
							25.902839
						],
						[
							-80.191035,
							25.902899
						],
						[
							-80.19108799899999,
							25.903802058000053
						],
						[
							-80.19114,
							25.904711
						],
						[
							-80.191218,
							25.906433
						],
						[
							-80.188168,
							25.906677
						],
						[
							-80.188205,
							25.907373
						],
						[
							-80.188269,
							25.908476000000004
						],
						[
							-80.18839082699998,
							25.909974469000076
						],
						[
							-80.188411,
							25.910273000000004
						],
						[
							-80.18699997599998,
							25.91033039100006
						],
						[
							-80.18692388499994,
							25.910332320000066
						],
						[
							-80.184521,
							25.910374
						],
						[
							-80.18432374999998,
							25.910436038000057
						],
						[
							-80.179361,
							25.910634
						],
						[
							-80.179448,
							25.912359
						],
						[
							-80.17844,
							25.912408
						],
						[
							-80.178336,
							25.910647
						],
						[
							-80.177333,
							25.910681
						],
						[
							-80.177433,
							25.912441
						],
						[
							-80.177199,
							25.912444
						],
						[
							-80.176513,
							25.912473
						],
						[
							-80.176436,
							25.912476
						],
						[
							-80.176384,
							25.912478
						],
						[
							-80.175417,
							25.912523
						],
						[
							-80.175372,
							25.911619
						],
						[
							-80.17536429999996,
							25.911493516000064
						],
						[
							-80.17519058199997,
							25.908099979000042
						],
						[
							-80.175189,
							25.908062
						],
						[
							-80.175144,
							25.90719
						],
						[
							-80.16713496399996,
							25.907462949000035
						],
						[
							-80.16402499899993,
							25.907567979000078
						],
						[
							-80.163112,
							25.907599
						],
						[
							-80.16324785799998,
							25.910300007000046
						],
						[
							-80.16335638699996,
							25.91246311200007
						],
						[
							-80.163365,
							25.912973
						],
						[
							-80.163412,
							25.913866
						],
						[
							-80.163474,
							25.914804
						],
						[
							-80.161862,
							25.914866000000004
						],
						[
							-80.159398,
							25.91496
						],
						[
							-80.158636,
							25.914998
						],
						[
							-80.157727,
							25.915035
						],
						[
							-80.157817,
							25.914709
						],
						[
							-80.157891,
							25.914357
						],
						[
							-80.157938,
							25.914095
						],
						[
							-80.158065,
							25.913114
						],
						[
							-80.158307,
							25.911159
						],
						[
							-80.158395,
							25.910447000000005
						],
						[
							-80.158707,
							25.907935000000002
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "North Miami",
				"Name": "Central",
				"RegionID": "220532"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.22941866899998,
					25.960064110000076,
					-80.21390112899996,
					25.96570345400005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.21513433199995,
							25.960096118000024
						],
						[
							-80.22152548799994,
							25.960287169000026
						],
						[
							-80.22930317199996,
							25.96061813500006
						],
						[
							-80.229348385,
							25.961175312000023
						],
						[
							-80.22939325199997,
							25.96432495600004
						],
						[
							-80.22941866899998,
							25.965158410000072
						],
						[
							-80.22911888299996,
							25.965170166000064
						],
						[
							-80.22650944299994,
							25.965272497000058
						],
						[
							-80.22616964299995,
							25.965285823000045
						],
						[
							-80.21524753599994,
							25.96568929700004
						],
						[
							-80.21508326099996,
							25.965695061000076
						],
						[
							-80.21484406199994,
							25.96570345400005
						],
						[
							-80.21410082099999,
							25.96568221800004
						],
						[
							-80.21412275799999,
							25.96551262500003
						],
						[
							-80.21406128199999,
							25.96380664900005
						],
						[
							-80.21393832899997,
							25.96119389300003
						],
						[
							-80.21390112899996,
							25.960064110000076
						],
						[
							-80.21457418399996,
							25.96007937400003
						],
						[
							-80.21513433199995,
							25.960096118000024
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Gardens",
				"Name": "Country Club Estates",
				"RegionID": "220732"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.77343944599995,
					27.771061303000067,
					-82.75610117299999,
					27.781744263000068
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.76898103299999,
							27.771212070000047
						],
						[
							-82.76930410599994,
							27.771061303000067
						],
						[
							-82.76977794699997,
							27.771233608000045
						],
						[
							-82.77343944599995,
							27.774248960000023
						],
						[
							-82.77341376899994,
							27.775162226000077
						],
						[
							-82.77295322199996,
							27.776041259000067
						],
						[
							-82.76092573599999,
							27.781744263000068
						],
						[
							-82.75610117299999,
							27.777544309000064
						],
						[
							-82.76898103299999,
							27.771212070000047
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Treasure Island",
				"Name": "Isle of Palms",
				"RegionID": "221684"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.163128,
					25.900096,
					-80.147886,
					25.938267
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-80.149603,
								25.938145
							],
							[
								-80.149568,
								25.938134
							],
							[
								-80.14955,
								25.938179
							],
							[
								-80.149139,
								25.937902
							],
							[
								-80.149196,
								25.937897
							],
							[
								-80.149195,
								25.937836
							],
							[
								-80.149061,
								25.937851000000002
							],
							[
								-80.148826,
								25.937725
							],
							[
								-80.14878,
								25.937691
							],
							[
								-80.148651,
								25.937688
							],
							[
								-80.148292,
								25.937658
							],
							[
								-80.14815,
								25.937652
							],
							[
								-80.14814900000002,
								25.93761
							],
							[
								-80.147886,
								25.933641
							],
							[
								-80.147947,
								25.93156
							],
							[
								-80.147957,
								25.931225
							],
							[
								-80.14838978099993,
								25.930288950000033
							],
							[
								-80.14941294899995,
								25.929932031000078
							],
							[
								-80.14969848399994,
								25.928885068000056
							],
							[
								-80.14988884099995,
								25.927695337000046
							],
							[
								-80.14967468999998,
								25.926838731000032
							],
							[
								-80.149401,
								25.926213
							],
							[
								-80.149669,
								25.926201
							],
							[
								-80.15031700000002,
								25.926153000000003
							],
							[
								-80.151948,
								25.926134
							],
							[
								-80.153705,
								25.926204
							],
							[
								-80.153823,
								25.926205
							],
							[
								-80.153848,
								25.926119
							],
							[
								-80.154001,
								25.925679
							],
							[
								-80.153873,
								25.925674
							],
							[
								-80.153683,
								25.92566
							],
							[
								-80.153462,
								25.925548
							],
							[
								-80.153254,
								25.925443
							],
							[
								-80.152824,
								25.925464
							],
							[
								-80.152791,
								25.924915
							],
							[
								-80.154128,
								25.924853000000002
							],
							[
								-80.154152,
								25.924851
							],
							[
								-80.154601,
								25.923433
							],
							[
								-80.154569,
								25.923434
							],
							[
								-80.153764,
								25.923451
							],
							[
								-80.153629,
								25.920701
							],
							[
								-80.15544,
								25.920635
							],
							[
								-80.155644,
								25.920629
							],
							[
								-80.155794,
								25.921213
							],
							[
								-80.15424801399996,
								25.926172482000027
							],
							[
								-80.15153542799999,
								25.93476709500004
							],
							[
								-80.150599,
								25.937734
							],
							[
								-80.149937,
								25.937769
							],
							[
								-80.14983,
								25.937758
							],
							[
								-80.149718,
								25.938182
							],
							[
								-80.149778,
								25.938267
							],
							[
								-80.149596,
								25.938214
							],
							[
								-80.149583,
								25.9382
							],
							[
								-80.149603,
								25.938145
							]
						]
					],
					[
						[
							[
								-80.156874,
								25.914691
							],
							[
								-80.157104,
								25.913212
							],
							[
								-80.156933,
								25.913214
							],
							[
								-80.155266,
								25.913269
							],
							[
								-80.155147,
								25.910806
							],
							[
								-80.154992,
								25.907964
							],
							[
								-80.158007,
								25.907853
							],
							[
								-80.158062,
								25.90769
							],
							[
								-80.15824000000002,
								25.907556
							],
							[
								-80.158337,
								25.907254
							],
							[
								-80.155492,
								25.907309
							],
							[
								-80.155905,
								25.90609
							],
							[
								-80.155868,
								25.905184000000002
							],
							[
								-80.15681300000001,
								25.905128
							],
							[
								-80.15677600000001,
								25.90431
							],
							[
								-80.157261,
								25.902557
							],
							[
								-80.152508,
								25.902672000000003
							],
							[
								-80.150573,
								25.902722
							],
							[
								-80.150533,
								25.901487
							],
							[
								-80.150512,
								25.900836
							],
							[
								-80.150961,
								25.900821
							],
							[
								-80.152772,
								25.900762
							],
							[
								-80.154772,
								25.900698
							],
							[
								-80.153052,
								25.900728
							],
							[
								-80.151751,
								25.900733
							],
							[
								-80.151605,
								25.900698
							],
							[
								-80.152364,
								25.90069
							],
							[
								-80.153561,
								25.900633
							],
							[
								-80.154311,
								25.900664
							],
							[
								-80.155057,
								25.900627
							],
							[
								-80.155839,
								25.900603
							],
							[
								-80.15663,
								25.900637
							],
							[
								-80.156699,
								25.900636000000002
							],
							[
								-80.1575,
								25.900609
							],
							[
								-80.15824000000002,
								25.900585
							],
							[
								-80.158678,
								25.900573
							],
							[
								-80.15871617199997,
								25.900571972000023
							],
							[
								-80.15897498199996,
								25.90056443900005
							],
							[
								-80.160385,
								25.900519
							],
							[
								-80.162151,
								25.900096
							],
							[
								-80.16243908499996,
								25.90017769900004
							],
							[
								-80.162922,
								25.900314
							],
							[
								-80.163128,
								25.900344
							],
							[
								-80.163046,
								25.900427
							],
							[
								-80.162772,
								25.9007
							],
							[
								-80.16251638999995,
								25.900957387000062
							],
							[
								-80.16243108899994,
								25.901044089000038
							],
							[
								-80.16218383499996,
								25.901293974000055
							],
							[
								-80.161023,
								25.902468
							],
							[
								-80.160683,
								25.902832
							],
							[
								-80.160424,
								25.903143
							],
							[
								-80.160252,
								25.903368
							],
							[
								-80.160086,
								25.903604
							],
							[
								-80.15994,
								25.903824
							],
							[
								-80.159713,
								25.904206
							],
							[
								-80.159603,
								25.904412
							],
							[
								-80.159433,
								25.904762
							],
							[
								-80.159262,
								25.905176
							],
							[
								-80.159171,
								25.905431
							],
							[
								-80.159073,
								25.905733
							],
							[
								-80.158976,
								25.906111
							],
							[
								-80.15889,
								25.906533
							],
							[
								-80.158847,
								25.906805
							],
							[
								-80.15881669599997,
								25.90704959900006
							],
							[
								-80.158707,
								25.907935000000002
							],
							[
								-80.158395,
								25.910447000000005
							],
							[
								-80.158307,
								25.911159
							],
							[
								-80.158065,
								25.913114
							],
							[
								-80.157938,
								25.914095
							],
							[
								-80.157891,
								25.914357
							],
							[
								-80.157817,
								25.914709
							],
							[
								-80.157727,
								25.915035
							],
							[
								-80.1576,
								25.915458
							],
							[
								-80.156738,
								25.915485
							],
							[
								-80.156791,
								25.915197
							],
							[
								-80.156801,
								25.91518
							],
							[
								-80.156814,
								25.915072
							],
							[
								-80.156846,
								25.914910000000003
							],
							[
								-80.156874,
								25.914691
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "North Miami Beach",
				"Name": "Highland Village",
				"RegionID": "234036"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.12295679599993,
					26.22390685000005,
					-80.1026068509999,
					26.231835498000066
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.1026068509999,
							26.22565357600007
						],
						[
							-80.1032035579999,
							26.22390685000005
						],
						[
							-80.10456033899993,
							26.22421937000007
						],
						[
							-80.10633364599994,
							26.22400369700006
						],
						[
							-80.10639048399992,
							26.22399696100007
						],
						[
							-80.10640647899993,
							26.224004105000063
						],
						[
							-80.12261199699992,
							26.23124224500009
						],
						[
							-80.12289427999991,
							26.23151886800008
						],
						[
							-80.12295679599993,
							26.231580050000048
						],
						[
							-80.1228846429999,
							26.231580532000066
						],
						[
							-80.12162286799992,
							26.23159671700006
						],
						[
							-80.12157310599991,
							26.231597350000072
						],
						[
							-80.10285412799993,
							26.231835498000066
						],
						[
							-80.1026068509999,
							26.22595030800005
						],
						[
							-80.1026068509999,
							26.22565357600007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Pompano Beach",
				"Name": "Snug Harbor",
				"RegionID": "251950"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.33921594799995,
					29.661171729000046,
					-82.33084389799996,
					29.666768606000065
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.33084389799996,
							29.66672980900006
						],
						[
							-82.33093151599996,
							29.66121187500005
						],
						[
							-82.33602627999994,
							29.661171729000046
						],
						[
							-82.33921594799995,
							29.661231793000074
						],
						[
							-82.33921492899998,
							29.661285495000072
						],
						[
							-82.33920739499996,
							29.661533398000078
						],
						[
							-82.33916280299997,
							29.666721086000052
						],
						[
							-82.33520217999995,
							29.666768606000065
						],
						[
							-82.33084389799996,
							29.66672980900006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Alachua",
				"City": "Gainesville",
				"Name": "Oakview",
				"RegionID": "259626"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.44307294299995,
					27.101022126000032,
					-82.38680793299996,
					27.134121
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.40741906699998,
							27.13372336200007
						],
						[
							-82.40593334699997,
							27.132108913000025
						],
						[
							-82.40223956399996,
							27.128095087000077
						],
						[
							-82.39757835799999,
							27.123030017000076
						],
						[
							-82.39317137899997,
							27.118241201000046
						],
						[
							-82.38680793299996,
							27.11203013200003
						],
						[
							-82.38843813699998,
							27.111131857000032
						],
						[
							-82.38858996,
							27.111048199000038
						],
						[
							-82.38859064199994,
							27.101822539000068
						],
						[
							-82.39296940499997,
							27.10403467900005
						],
						[
							-82.39755754699996,
							27.106201301000056
						],
						[
							-82.39881382399994,
							27.10408019600004
						],
						[
							-82.39887737399994,
							27.10394371900003
						],
						[
							-82.39891418099995,
							27.103864672000043
						],
						[
							-82.39924575199996,
							27.103810989000067
						],
						[
							-82.40091867499996,
							27.103701885000078
						],
						[
							-82.40696283599995,
							27.103539400000045
						],
						[
							-82.40700442299999,
							27.103538282000045
						],
						[
							-82.40708744699998,
							27.103023535000034
						],
						[
							-82.407101217,
							27.102938159000075
						],
						[
							-82.40840300899998,
							27.103047940000067
						],
						[
							-82.40844528099996,
							27.103051505000053
						],
						[
							-82.40856362599999,
							27.102232194000067
						],
						[
							-82.40858481699996,
							27.101949029000025
						],
						[
							-82.40933752999996,
							27.10194931500007
						],
						[
							-82.40946980799998,
							27.101949365000053
						],
						[
							-82.41111259299998,
							27.10194998700007
						],
						[
							-82.41186817999994,
							27.102605436000033
						],
						[
							-82.41267254,
							27.101827135000065
						],
						[
							-82.41279272299994,
							27.10171084600006
						],
						[
							-82.41281631899994,
							27.101658935000046
						],
						[
							-82.41293807899996,
							27.10139106200006
						],
						[
							-82.41297456199999,
							27.101310799000036
						],
						[
							-82.41302235599994,
							27.101243888000056
						],
						[
							-82.41315640199997,
							27.101056224000047
						],
						[
							-82.41330093999994,
							27.10105679000003
						],
						[
							-82.42499221899999,
							27.101102549000075
						],
						[
							-82.42504851999996,
							27.10110276900008
						],
						[
							-82.42543222199998,
							27.101104271000054
						],
						[
							-82.42543222199998,
							27.101022126000032
						],
						[
							-82.43179501599997,
							27.10104702900003
						],
						[
							-82.43255874099998,
							27.10130160400007
						],
						[
							-82.43364235299998,
							27.101539313000046
						],
						[
							-82.43369941999998,
							27.10155183200004
						],
						[
							-82.43370018099995,
							27.10158913600003
						],
						[
							-82.43372146799999,
							27.10221707900007
						],
						[
							-82.43361340999996,
							27.102865424000072
						],
						[
							-82.43361348599996,
							27.102902105000055
						],
						[
							-82.43361692599996,
							27.103739923000035
						],
						[
							-82.433628437,
							27.10646293600007
						],
						[
							-82.43363469099995,
							27.10793389500003
						],
						[
							-82.43363646899996,
							27.10835748900007
						],
						[
							-82.43970167699996,
							27.10851013300004
						],
						[
							-82.43996634799998,
							27.108060693000027
						],
						[
							-82.44012012499996,
							27.107799562000025
						],
						[
							-82.44111080899997,
							27.108208171000058
						],
						[
							-82.44214920099995,
							27.108636457000046
						],
						[
							-82.44302076299994,
							27.11230149100004
						],
						[
							-82.44307294299995,
							27.112520914000072
						],
						[
							-82.44306536999996,
							27.11252620600004
						],
						[
							-82.44106882799997,
							27.11392126300007
						],
						[
							-82.44085,
							27.115795
						],
						[
							-82.437774,
							27.116113
						],
						[
							-82.438071,
							27.116647
						],
						[
							-82.438242,
							27.116809000000003
						],
						[
							-82.438082,
							27.11678
						],
						[
							-82.43813600000001,
							27.117021
						],
						[
							-82.43800500000002,
							27.117133
						],
						[
							-82.437227,
							27.117425
						],
						[
							-82.436964,
							27.117461000000002
						],
						[
							-82.436292,
							27.117111
						],
						[
							-82.435926,
							27.117196
						],
						[
							-82.43569123399999,
							27.11719942800005
						],
						[
							-82.43500039099996,
							27.11720951700005
						],
						[
							-82.43474480799995,
							27.117213250000077
						],
						[
							-82.43460447999996,
							27.117215299000065
						],
						[
							-82.434488,
							27.117217
						],
						[
							-82.43447334699994,
							27.117294893000064
						],
						[
							-82.43445,
							27.117419
						],
						[
							-82.43406,
							27.11752
						],
						[
							-82.433675,
							27.117535
						],
						[
							-82.43365034299995,
							27.117535385000053
						],
						[
							-82.431628,
							27.117567000000005
						],
						[
							-82.42983296299997,
							27.117597154000066
						],
						[
							-82.42827251099999,
							27.117582226000025
						],
						[
							-82.427681,
							27.117549
						],
						[
							-82.42615958099998,
							27.117562012000064
						],
						[
							-82.42590773599994,
							27.11756416600008
						],
						[
							-82.424524,
							27.117576
						],
						[
							-82.423458,
							27.116822
						],
						[
							-82.423253,
							27.116027
						],
						[
							-82.422997,
							27.115561
						],
						[
							-82.422533,
							27.115193
						],
						[
							-82.422224,
							27.115058
						],
						[
							-82.420551,
							27.114426000000005
						],
						[
							-82.41726200000001,
							27.113602
						],
						[
							-82.41724514799995,
							27.114989259000026
						],
						[
							-82.417167,
							27.115431
						],
						[
							-82.417149,
							27.122904
						],
						[
							-82.417185,
							27.126232000000005
						],
						[
							-82.417247,
							27.126552
						],
						[
							-82.417169,
							27.126743
						],
						[
							-82.417132,
							27.128216
						],
						[
							-82.41630117799998,
							27.128205551000065
						],
						[
							-82.413395,
							27.128169
						],
						[
							-82.413347,
							27.130019
						],
						[
							-82.412855,
							27.129998
						],
						[
							-82.412843,
							27.130384
						],
						[
							-82.41115205099999,
							27.130373570000074
						],
						[
							-82.410087,
							27.130367
						],
						[
							-82.409957,
							27.132044
						],
						[
							-82.410043,
							27.133619
						],
						[
							-82.409388,
							27.133608
						],
						[
							-82.409394,
							27.133243
						],
						[
							-82.40916,
							27.132823
						],
						[
							-82.407785,
							27.134121
						],
						[
							-82.40741906699998,
							27.13372336200007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Venice",
				"Name": "Pinebrook",
				"RegionID": "264122"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.36418752699996,
					29.650172746000067,
					-82.33916280299997,
					29.66677918000005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.33916280299997,
							29.666721086000052
						],
						[
							-82.33920739499996,
							29.661533398000078
						],
						[
							-82.33921492899998,
							29.661285495000072
						],
						[
							-82.33921594799995,
							29.661231793000074
						],
						[
							-82.33921636499997,
							29.65919236800005
						],
						[
							-82.33919842599995,
							29.65581088200003
						],
						[
							-82.33924327299997,
							29.652815082000075
						],
						[
							-82.33925270399999,
							29.65204718200005
						],
						[
							-82.34147548899995,
							29.65203429500008
						],
						[
							-82.35170469299999,
							29.65198471900004
						],
						[
							-82.35576669799997,
							29.650172746000067
						],
						[
							-82.35587516899994,
							29.651860008000032
						],
						[
							-82.35588965399995,
							29.652085326000073
						],
						[
							-82.35652345199998,
							29.652088511000045
						],
						[
							-82.35652538399995,
							29.65289401600006
						],
						[
							-82.35668599799999,
							29.653114116000044
						],
						[
							-82.35682281699997,
							29.653459138000077
						],
						[
							-82.35667757499994,
							29.65611000800004
						],
						[
							-82.35719153899998,
							29.656167115000077
						],
						[
							-82.35935081999997,
							29.656225931000055
						],
						[
							-82.35991840099996,
							29.655900615000064
						],
						[
							-82.36123186399999,
							29.655843508000032
						],
						[
							-82.36405152499998,
							29.65581495400005
						],
						[
							-82.36418752699996,
							29.655800447000047
						],
						[
							-82.36414517899999,
							29.658355429000036
						],
						[
							-82.36410592099998,
							29.65945231700005
						],
						[
							-82.36051576099999,
							29.65943960100003
						],
						[
							-82.36061591899994,
							29.661246181000028
						],
						[
							-82.35777778899995,
							29.661960526000033
						],
						[
							-82.35787734799999,
							29.66247823300006
						],
						[
							-82.35592599199998,
							29.663095498000075
						],
						[
							-82.35379543099998,
							29.66361320500005
						],
						[
							-82.35367595999998,
							29.663852147000057
						],
						[
							-82.35234186999998,
							29.663971617000072
						],
						[
							-82.35186398699994,
							29.66490747100005
						],
						[
							-82.35064936799995,
							29.665007030000023
						],
						[
							-82.35070910299999,
							29.66566412000003
						],
						[
							-82.35009183799997,
							29.665883149000024
						],
						[
							-82.34931527799995,
							29.66677918000005
						],
						[
							-82.33916280299997,
							29.666721086000052
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Alachua",
				"City": "Gainesville",
				"Name": "University Park",
				"RegionID": "266011"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.454890172842,
					28.501067792948223,
					-81.41900251799974,
					28.510521810152337
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.41900251799974,
							28.507284206895736
						],
						[
							-81.41989199999989,
							28.50728300000018
						],
						[
							-81.42007299999995,
							28.50728100000001
						],
						[
							-81.4202979999999,
							28.50725300000018
						],
						[
							-81.4209869999999,
							28.50705700000013
						],
						[
							-81.42118099999986,
							28.506981000000057
						],
						[
							-81.42133399999983,
							28.50690900000014
						],
						[
							-81.42151799999995,
							28.506802000000167
						],
						[
							-81.42168599999991,
							28.506708000000028
						],
						[
							-81.42187499999983,
							28.506582000000083
						],
						[
							-81.42204899999992,
							28.50644300000013
						],
						[
							-81.42218099999992,
							28.506299000000116
						],
						[
							-81.42318499999995,
							28.505136000000167
						],
						[
							-81.42362699999984,
							28.50455400000015
						],
						[
							-81.4229988161786,
							28.50455164871956
						],
						[
							-81.42328702999986,
							28.504211968000096
						],
						[
							-81.42559065999986,
							28.501496976000166
						],
						[
							-81.42644191611043,
							28.50148162847638
						],
						[
							-81.42949646082485,
							28.50141230316449
						],
						[
							-81.43081040795302,
							28.501382259838973
						],
						[
							-81.454890172842,
							28.501067792948223
						],
						[
							-81.45485106587678,
							28.504712196110763
						],
						[
							-81.45458466799995,
							28.504712196000096
						],
						[
							-81.4532797309999,
							28.504721211000042
						],
						[
							-81.4524434909999,
							28.50473022400017
						],
						[
							-81.45150910699995,
							28.50474324300009
						],
						[
							-81.44886818999993,
							28.50474324300009
						],
						[
							-81.44607504799986,
							28.504757265000187
						],
						[
							-81.4458847649999,
							28.50477428900017
						],
						[
							-81.44526684899994,
							28.504851404000068
						],
						[
							-81.44495138099987,
							28.504922509
						],
						[
							-81.44469500099979,
							28.50501364500008
						],
						[
							-81.44447767799991,
							28.505120803000064
						],
						[
							-81.44418724799986,
							28.50526101200003
						],
						[
							-81.44382971799986,
							28.505502370000105
						],
						[
							-81.44355931699987,
							28.50570567100014
						],
						[
							-81.4430786039999,
							28.506115278000014
						],
						[
							-81.44277799199989,
							28.506377592000046
						],
						[
							-81.44282227707798,
							28.509867842121142
						],
						[
							-81.4388241639931,
							28.50986871580236
						],
						[
							-81.4388244248949,
							28.51026356392047
						],
						[
							-81.43637669597064,
							28.51011810673089
						],
						[
							-81.4342054439473,
							28.510303489121217
						],
						[
							-81.42602926495329,
							28.510521810152337
						],
						[
							-81.42602230799987,
							28.509762687000087
						],
						[
							-81.42599827199983,
							28.509267954000098
						],
						[
							-81.42598433099992,
							28.50895346400019
						],
						[
							-81.42593109399978,
							28.508870386000066
						],
						[
							-81.42592829699991,
							28.508753057000042
						],
						[
							-81.42487460599995,
							28.508780230000067
						],
						[
							-81.42450505799992,
							28.508789244000106
						],
						[
							-81.42406840899986,
							28.508800260000125
						],
						[
							-81.42382504999998,
							28.508807270000172
						],
						[
							-81.42295662999987,
							28.50883344300012
						],
						[
							-81.42295703599993,
							28.508735086000065
						],
						[
							-81.42269799999988,
							28.50874100000002
						],
						[
							-81.42246599999987,
							28.508775000000167
						],
						[
							-81.42246599999987,
							28.508356000000138
						],
						[
							-81.42275199999982,
							28.508357000000043
						],
						[
							-81.42286799999992,
							28.508360000000113
						],
						[
							-81.42295648799978,
							28.50835899900012
						],
						[
							-81.42313299999991,
							28.508357000000043
						],
						[
							-81.42313599999989,
							28.508181000000047
						],
						[
							-81.42313199999991,
							28.507936000000207
						],
						[
							-81.42295703599993,
							28.507936926000102
						],
						[
							-81.4227539999999,
							28.50793800000019
						],
						[
							-81.42201899999992,
							28.507943000000076
						],
						[
							-81.42202599999989,
							28.50838500000005
						],
						[
							-81.42192599999987,
							28.508382000000157
						],
						[
							-81.42162199999986,
							28.508384000000145
						],
						[
							-81.42138699999985,
							28.508384000000145
						],
						[
							-81.42157109199991,
							28.508212114000134
						],
						[
							-81.42062728399988,
							28.508212520000168
						],
						[
							-81.42024750749985,
							28.508058170000186
						],
						[
							-81.41900251799974,
							28.507284206895736
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "33rd St. Industrial",
				"RegionID": "268866"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.26161499999995,
					25.709042000000068,
					-80.24219128499993,
					25.73692052800004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.24548652699991,
							25.728103592000082
						],
						[
							-80.24547999999993,
							25.727960000000053
						],
						[
							-80.24532060099995,
							25.727964830000076
						],
						[
							-80.24514999999991,
							25.727970000000088
						],
						[
							-80.24492667399994,
							25.727773909000064
						],
						[
							-80.24445080699991,
							25.727352618000054
						],
						[
							-80.24410900499993,
							25.72704841400008
						],
						[
							-80.24373999999995,
							25.726720000000057
						],
						[
							-80.24397140299995,
							25.726504024000064
						],
						[
							-80.24410108899991,
							25.726382984000054
						],
						[
							-80.24418999999995,
							25.726300000000037
						],
						[
							-80.24430833699995,
							25.726194120000063
						],
						[
							-80.24447417899995,
							25.725969896000038
						],
						[
							-80.24454334199993,
							25.725853985000075
						],
						[
							-80.24463999999995,
							25.725680000000068
						],
						[
							-80.24471634999992,
							25.725532072000078
						],
						[
							-80.24479999999994,
							25.72537000000006
						],
						[
							-80.2448904339999,
							25.725217393000037
						],
						[
							-80.24500999999992,
							25.72503000000006
						],
						[
							-80.24512861599995,
							25.72488914300004
						],
						[
							-80.24516999999992,
							25.724840000000086
						],
						[
							-80.24531437699994,
							25.724681651000083
						],
						[
							-80.24539688199991,
							25.724591161000035
						],
						[
							-80.24552665199991,
							25.72444392200009
						],
						[
							-80.24576735099994,
							25.724211523000065
						],
						[
							-80.24597335199991,
							25.723995091000063
						],
						[
							-80.24616418799991,
							25.72378868000004
						],
						[
							-80.2462799999999,
							25.723660000000056
						],
						[
							-80.24601453399993,
							25.72341681900008
						],
						[
							-80.24566446799992,
							25.72312374100005
						],
						[
							-80.24522896099997,
							25.722759110000084
						],
						[
							-80.24474648299991,
							25.72234555600005
						],
						[
							-80.2440874369999,
							25.721780661000082
						],
						[
							-80.24344276399995,
							25.721228083000085
						],
						[
							-80.24316148899993,
							25.72098699100008
						],
						[
							-80.24287521799994,
							25.720741615000065
						],
						[
							-80.24219128499993,
							25.72015538700009
						],
						[
							-80.24219486499993,
							25.72015069100007
						],
						[
							-80.24225717099995,
							25.72007745800005
						],
						[
							-80.24270817099995,
							25.71960145800006
						],
						[
							-80.24278292699995,
							25.719531079000035
						],
						[
							-80.24286097999993,
							25.719472497000083
						],
						[
							-80.24291888499995,
							25.71943376300004
						],
						[
							-80.24309178599992,
							25.71924491200008
						],
						[
							-80.24371019299991,
							25.718447061000063
						],
						[
							-80.2437424389999,
							25.718409851000047
						],
						[
							-80.24372967799991,
							25.71826400000009
						],
						[
							-80.24372967799991,
							25.71801400000004
						],
						[
							-80.24373267899995,
							25.717940595000073
						],
						[
							-80.24374166099996,
							25.71786768000004
						],
						[
							-80.2437565649999,
							25.717795742000078
						],
						[
							-80.24377729099992,
							25.717725260000066
						],
						[
							-80.24380369999994,
							25.71765670500008
						],
						[
							-80.24387469999994,
							25.717492706000087
						],
						[
							-80.24393036199992,
							25.717384772000063
						],
						[
							-80.2441104319999,
							25.717086877000042
						],
						[
							-80.24414142199994,
							25.71697695900008
						],
						[
							-80.24416508299994,
							25.716904842000076
						],
						[
							-80.2441947399999,
							25.716834977000076
						],
						[
							-80.2442301829999,
							25.71676786100005
						],
						[
							-80.24427115799995,
							25.71670397200006
						],
						[
							-80.24431737499992,
							25.71664376700005
						],
						[
							-80.24484672699992,
							25.716011347000062
						],
						[
							-80.24495792699992,
							25.71590007900005
						],
						[
							-80.24501841099993,
							25.71585693800006
						],
						[
							-80.2452717669999,
							25.715574058000072
						],
						[
							-80.24530707699996,
							25.715508078000084
						],
						[
							-80.24534798399992,
							25.715445413000054
						],
						[
							-80.2453941789999,
							25.715386538000075
						],
						[
							-80.2454453119999,
							25.715331897000056
						],
						[
							-80.24600080499994,
							25.714785435000067
						],
						[
							-80.24643629799994,
							25.714360974000044
						],
						[
							-80.24648592699992,
							25.71431608000006
						],
						[
							-80.2466143389999,
							25.71422616500007
						],
						[
							-80.24675641399995,
							25.71415991400005
						],
						[
							-80.24690783499994,
							25.71411934100007
						],
						[
							-80.24704972899991,
							25.714106927000046
						],
						[
							-80.24713428099994,
							25.713985655000045
						],
						[
							-80.24718307899991,
							25.713921927000058
						],
						[
							-80.24729392699993,
							25.713811080000085
						],
						[
							-80.24742233899991,
							25.71372116500004
						],
						[
							-80.2475644129999,
							25.713654914000074
						],
						[
							-80.24761800699991,
							25.713638243000048
						],
						[
							-80.24763591399996,
							25.713571413000068
						],
						[
							-80.24770216399992,
							25.713429339000072
						],
						[
							-80.24779207899991,
							25.713300927000095
						],
						[
							-80.24790292699993,
							25.71319007900007
						],
						[
							-80.24803133899991,
							25.713100164000082
						],
						[
							-80.24817341399995,
							25.71303391300006
						],
						[
							-80.24822034599993,
							25.71302133800009
						],
						[
							-80.24821172799994,
							25.712857607000046
						],
						[
							-80.2480578599999,
							25.71226805400005
						],
						[
							-80.24796733599995,
							25.711992316000078
						],
						[
							-80.24792754799995,
							25.71193271700008
						],
						[
							-80.24789300399993,
							25.71186993300006
						],
						[
							-80.24786395599995,
							25.711804424000036
						],
						[
							-80.24784061699995,
							25.711736672000086
						],
						[
							-80.24782315899995,
							25.711667171000048
						],
						[
							-80.24775015799992,
							25.711322171000063
						],
						[
							-80.24773366199992,
							25.711209203000067
						],
						[
							-80.24771190099995,
							25.710942756000065
						],
						[
							-80.24699301399994,
							25.710082801000055
						],
						[
							-80.24690416399994,
							25.709955661000038
						],
						[
							-80.2468485949999,
							25.70984148200006
						],
						[
							-80.24677808699994,
							25.70966611700004
						],
						[
							-80.24660789299992,
							25.70952579200008
						],
						[
							-80.2476957529999,
							25.709521255000084
						],
						[
							-80.24775699999992,
							25.709521000000052
						],
						[
							-80.24786999199995,
							25.709517109000046
						],
						[
							-80.24845399999992,
							25.709497000000056
						],
						[
							-80.24857277799993,
							25.709492364000084
						],
						[
							-80.24864539999993,
							25.709489529000052
						],
						[
							-80.24869113999995,
							25.709487743000068
						],
						[
							-80.2497001129999,
							25.709448357000042
						],
						[
							-80.25123797899994,
							25.709388326000067
						],
						[
							-80.2528089999999,
							25.709327000000087
						],
						[
							-80.25286596099994,
							25.70935631000009
						],
						[
							-80.25291199999992,
							25.709380000000067
						],
						[
							-80.25299227799991,
							25.709377561000053
						],
						[
							-80.25363599999991,
							25.709358000000066
						],
						[
							-80.25437593399994,
							25.709333822000076
						],
						[
							-80.2567269999999,
							25.709257000000036
						],
						[
							-80.25683199999992,
							25.70923300000004
						],
						[
							-80.2568568449999,
							25.709226114000046
						],
						[
							-80.25709899999993,
							25.709159000000056
						],
						[
							-80.2595639999999,
							25.709083000000078
						],
						[
							-80.26066544799994,
							25.709051617000057
						],
						[
							-80.2609641009999,
							25.70904310800006
						],
						[
							-80.2610029999999,
							25.709042000000068
						],
						[
							-80.26101099999995,
							25.70948300000009
						],
						[
							-80.26102099999991,
							25.709733000000085
						],
						[
							-80.26103599999993,
							25.71039200000007
						],
						[
							-80.2610369109999,
							25.71042702200009
						],
						[
							-80.26105157799992,
							25.71099098600007
						],
						[
							-80.26105599999994,
							25.71116100000006
						],
						[
							-80.26105631999992,
							25.711171928000056
						],
						[
							-80.26107799999994,
							25.71191200000004
						],
						[
							-80.26110499999993,
							25.712671000000057
						],
						[
							-80.26113399999991,
							25.71338300000008
						],
						[
							-80.2611355009999,
							25.713426992000052
						],
						[
							-80.2611599999999,
							25.714145000000087
						],
						[
							-80.2611849999999,
							25.71490700000004
						],
						[
							-80.26120499999992,
							25.71538400000009
						],
						[
							-80.26121099999995,
							25.715633000000082
						],
						[
							-80.2612529999999,
							25.716485000000095
						],
						[
							-80.26125612099992,
							25.71667255000006
						],
						[
							-80.26126299999993,
							25.71708600000005
						],
						[
							-80.2612749999999,
							25.71733400000005
						],
						[
							-80.26128276599991,
							25.717554191000094
						],
						[
							-80.26130599999993,
							25.71821300000005
						],
						[
							-80.26134199999991,
							25.719054000000085
						],
						[
							-80.26136999999994,
							25.71993800000007
						],
						[
							-80.26141399999995,
							25.720792000000074
						],
						[
							-80.26144899999991,
							25.721481000000043
						],
						[
							-80.26146099999994,
							25.721771000000047
						],
						[
							-80.26147999999996,
							25.72221200000007
						],
						[
							-80.2614989999999,
							25.722680000000082
						],
						[
							-80.26151699999991,
							25.72290600000008
						],
						[
							-80.26155199999994,
							25.723607000000072
						],
						[
							-80.2615909999999,
							25.72435100000007
						],
						[
							-80.26161499999995,
							25.724829000000057
						],
						[
							-80.25948799999992,
							25.724926000000043
						],
						[
							-80.25928699999992,
							25.724789000000044
						],
						[
							-80.25850199999991,
							25.724983000000066
						],
						[
							-80.25866499999995,
							25.727449000000036
						],
						[
							-80.25850528399991,
							25.727454524000052
						],
						[
							-80.25768199999993,
							25.727483000000063
						],
						[
							-80.25753395299995,
							25.727487935000056
						],
						[
							-80.25567199999995,
							25.727550000000065
						],
						[
							-80.2556909999999,
							25.728187000000048
						],
						[
							-80.25572299999993,
							25.728795000000048
						],
						[
							-80.25574399999994,
							25.729396000000065
						],
						[
							-80.25577599999991,
							25.730075000000056
						],
						[
							-80.25581799999992,
							25.730616000000055
						],
						[
							-80.25584199999992,
							25.730913000000044
						],
						[
							-80.2558590299999,
							25.731191408000086
						],
						[
							-80.25575807299992,
							25.731253263000042
						],
						[
							-80.25563741499991,
							25.73132131500006
						],
						[
							-80.25547977999992,
							25.731401516000062
						],
						[
							-80.25521505299992,
							25.73153620100004
						],
						[
							-80.25498665399994,
							25.731667604000055
						],
						[
							-80.25386330899994,
							25.732658644000082
						],
						[
							-80.2518489069999,
							25.734435793000046
						],
						[
							-80.2514388489999,
							25.73461011900008
						],
						[
							-80.25127974399993,
							25.734721274000037
						],
						[
							-80.25113574699992,
							25.734817252000084
						],
						[
							-80.2509382529999,
							25.734942930000045
						],
						[
							-80.25058999999993,
							25.73517000000004
						],
						[
							-80.2504772989999,
							25.735220521000088
						],
						[
							-80.2503824449999,
							25.735263042000042
						],
						[
							-80.25020446199994,
							25.735336395000047
						],
						[
							-80.25004999999993,
							25.73541000000006
						],
						[
							-80.24997522099994,
							25.735436975000084
						],
						[
							-80.24983666599991,
							25.735486956000045
						],
						[
							-80.24957986699992,
							25.73557959100009
						],
						[
							-80.24925952199993,
							25.735695150000083
						],
						[
							-80.24891755899995,
							25.735818506000044
						],
						[
							-80.24853809099994,
							25.73595539200005
						],
						[
							-80.24814273699991,
							25.73609800800006
						],
						[
							-80.24785999999995,
							25.736200000000053
						],
						[
							-80.2475879459999,
							25.73630045100009
						],
						[
							-80.24731594399992,
							25.736400882000055
						],
						[
							-80.24687427399994,
							25.73656396000007
						],
						[
							-80.24635773799992,
							25.736754682000083
						],
						[
							-80.2459085239999,
							25.73692052800004
						],
						[
							-80.24590313499993,
							25.736679740000056
						],
						[
							-80.2458981129999,
							25.73650394500004
						],
						[
							-80.24588999999992,
							25.736220000000063
						],
						[
							-80.24588677299994,
							25.73600654100005
						],
						[
							-80.24587160099992,
							25.735708147000082
						],
						[
							-80.24586022099993,
							25.735484351000082
						],
						[
							-80.24583999999993,
							25.73533000000009
						],
						[
							-80.24582583999995,
							25.735160075000067
						],
						[
							-80.2458091119999,
							25.73483593800006
						],
						[
							-80.24579835499992,
							25.73458495700004
						],
						[
							-80.24578999999994,
							25.734390000000076
						],
						[
							-80.24577778799994,
							25.73411217800009
						],
						[
							-80.2457657089999,
							25.733837377000043
						],
						[
							-80.24575805299992,
							25.73366320000008
						],
						[
							-80.24574999999993,
							25.733480000000046
						],
						[
							-80.24573855299991,
							25.733215286000075
						],
						[
							-80.24572989799992,
							25.73301513800004
						],
						[
							-80.2457115119999,
							25.732589958000062
						],
						[
							-80.2457007509999,
							25.73234111900007
						],
						[
							-80.2456899899999,
							25.732092279000085
						],
						[
							-80.24567810699995,
							25.731817479000085
						],
						[
							-80.2456699999999,
							25.731630000000052
						],
						[
							-80.24566892999991,
							25.73144394500008
						],
						[
							-80.24565238299995,
							25.731195743000058
						],
						[
							-80.24564399899992,
							25.73106998700007
						],
						[
							-80.24561999999992,
							25.730710000000045
						],
						[
							-80.24561515699992,
							25.730622828000037
						],
						[
							-80.24560999999994,
							25.730530000000044
						],
						[
							-80.24560085099995,
							25.730374462000043
						],
						[
							-80.24559190999992,
							25.730222472000037
						],
						[
							-80.2455799999999,
							25.73002000000008
						],
						[
							-80.24557208699991,
							25.72992504000007
						],
						[
							-80.24556999999993,
							25.729820000000075
						],
						[
							-80.24557639199992,
							25.729672985000036
						],
						[
							-80.24557470999991,
							25.729523870000037
						],
						[
							-80.2455599999999,
							25.729340000000036
						],
						[
							-80.24555492199994,
							25.72922574000006
						],
						[
							-80.24554607499994,
							25.72902668900008
						],
						[
							-80.24553999999995,
							25.728890000000035
						],
						[
							-80.24552873699992,
							25.728754841000068
						],
						[
							-80.24551999999994,
							25.728650000000076
						],
						[
							-80.24551205599994,
							25.728427579000083
						],
						[
							-80.24550050499994,
							25.728279797000084
						],
						[
							-80.24548652699991,
							25.728103592000082
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami",
				"Name": "South-West Coconut Grove",
				"RegionID": "269181"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.38286528872922,
					28.498565000321406,
					-81.37619900016752,
					28.53611783111883
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.37764056138742,
							28.53611783111883
						],
						[
							-81.37699154226267,
							28.534823873093302
						],
						[
							-81.37681032437709,
							28.53391851211645
						],
						[
							-81.37656996707503,
							28.53259354726599
						],
						[
							-81.37644378859696,
							28.53119041154602
						],
						[
							-81.37650500724614,
							28.531189595861083
						],
						[
							-81.37649285290895,
							28.530933084936493
						],
						[
							-81.37647182136402,
							28.530530488141743
						],
						[
							-81.3764658129934,
							28.52918849732656
						],
						[
							-81.37647482509958,
							28.529044282945147
						],
						[
							-81.37646781668289,
							28.52868775482061
						],
						[
							-81.3764658129934,
							28.527921618786444
						],
						[
							-81.37646381020338,
							28.5268830781097
						],
						[
							-81.37645980282441,
							28.526381333759183
						],
						[
							-81.37644978977288,
							28.52517053963893
						],
						[
							-81.37642975827393,
							28.524599692282877
						],
						[
							-81.37641273500722,
							28.523941716810018
						],
						[
							-81.37641173136383,
							28.523896649084996
						],
						[
							-81.37640071556844,
							28.522962263389246
						],
						[
							-81.37639079065049,
							28.522044877577663
						],
						[
							-81.37638769698268,
							28.521955770952296
						],
						[
							-81.37638068586814,
							28.521150575563887
						],
						[
							-81.37637067191731,
							28.520243231581986
						],
						[
							-81.37635865337782,
							28.519316857046682
						],
						[
							-81.37634563389277,
							28.518415520536095
						],
						[
							-81.37633862367753,
							28.51748914690016
						],
						[
							-81.37634863762834,
							28.516563774209686
						],
						[
							-81.37635064131783,
							28.515726532380043
						],
						[
							-81.3763286097267,
							28.51476009934369
						],
						[
							-81.37630156891188,
							28.513885802748483
						],
						[
							-81.37628058952768,
							28.512961403124258
						],
						[
							-81.3762796545071,
							28.512902985156284
						],
						[
							-81.37730104269471,
							28.512902985156284
						],
						[
							-81.37729049966036,
							28.512611492188206
						],
						[
							-81.3772789928112,
							28.512246762772648
						],
						[
							-81.37726907200222,
							28.5119175200783
						],
						[
							-81.37725538117908,
							28.511498385940946
						],
						[
							-81.37677188085317,
							28.51149796923223
						],
						[
							-81.37677188085317,
							28.510658609069615
						],
						[
							-81.37624373169135,
							28.510658609069615
						],
						[
							-81.37622245105639,
							28.50932904324675
						],
						[
							-81.3762130000812,
							28.5089949999714
						],
						[
							-81.37620896931988,
							28.507915769469456
						],
						[
							-81.37620499971247,
							28.50697999971684
						],
						[
							-81.37620399966639,
							28.506841999650973
						],
						[
							-81.37620299962029,
							28.50645099961365
						],
						[
							-81.37619900016752,
							28.50548199995625
						],
						[
							-81.37625063272603,
							28.505257221859406
						],
						[
							-81.37626126857937,
							28.504874331138673
						],
						[
							-81.37626999999993,
							28.504399901771677
						],
						[
							-81.37627208556445,
							28.504181074753397
						],
						[
							-81.37629200012557,
							28.504181000194905
						],
						[
							-81.37628599984903,
							28.50414200019585
						],
						[
							-81.37638499991593,
							28.50414300024194
						],
						[
							-81.37639699956983,
							28.503287000353545
						],
						[
							-81.37799200024872,
							28.50338100018982
						],
						[
							-81.37789200013574,
							28.5020809996196
						],
						[
							-81.3777889998843,
							28.501721000111978
						],
						[
							-81.37703500020099,
							28.5017169999277
						],
						[
							-81.37701800031674,
							28.502330000305804
						],
						[
							-81.37702599978617,
							28.502469000418024
						],
						[
							-81.37646199986803,
							28.50245399972667
						],
						[
							-81.37643400037607,
							28.501332000166922
						],
						[
							-81.3764300001916,
							28.5008969999
						],
						[
							-81.37666700032464,
							28.50089199966955
						],
						[
							-81.37663299965666,
							28.50051000004695
						],
						[
							-81.37641899968453,
							28.50050399977041
						],
						[
							-81.37640800007672,
							28.5000569998496
						],
						[
							-81.37648399998291,
							28.50003699982707
						],
						[
							-81.3767590000689,
							28.500076999872213
						],
						[
							-81.37673599990794,
							28.499926000106278
						],
						[
							-81.37640399989245,
							28.499918999783553
						],
						[
							-81.37640900012282,
							28.49860500036655
						],
						[
							-81.37678200022988,
							28.498565000321406
						],
						[
							-81.37689199990459,
							28.498581000159483
						],
						[
							-81.37730900024107,
							28.500039999965253
						],
						[
							-81.37804499999386,
							28.499968000243513
						],
						[
							-81.3780920003618,
							28.500181000169658
						],
						[
							-81.37869200014065,
							28.503281000077003
						],
						[
							-81.37876800004683,
							28.503668999976057
						],
						[
							-81.37901999997186,
							28.503639000391647
						],
						[
							-81.37989920686546,
							28.50538569960988
						],
						[
							-81.38016377661458,
							28.50591131376573
						],
						[
							-81.3803710001952,
							28.506323000008337
						],
						[
							-81.38194120476716,
							28.506258984467735
						],
						[
							-81.38194106627164,
							28.507393185129303
						],
						[
							-81.38158340230315,
							28.50852885708187
						],
						[
							-81.38129608150533,
							28.509230054870855
						],
						[
							-81.38047575862113,
							28.509221886328838
						],
						[
							-81.37962134693528,
							28.509233804144372
						],
						[
							-81.37969860679148,
							28.509579415398917
						],
						[
							-81.37989089173394,
							28.510375597781966
						],
						[
							-81.38004211722979,
							28.51100553149471
						],
						[
							-81.38047075119599,
							28.512778160864933
						],
						[
							-81.3804857743706,
							28.512843257390706
						],
						[
							-81.38049754199933,
							28.51291038458553
						],
						[
							-81.38078822356358,
							28.514694000973094
						],
						[
							-81.38108967001254,
							28.516923308767815
						],
						[
							-81.38126988605339,
							28.519273802004747
						],
						[
							-81.38157138106563,
							28.520118042358284
						],
						[
							-81.38163152682361,
							28.520659848807412
						],
						[
							-81.38157138376364,
							28.521202652604615
						],
						[
							-81.38157138376364,
							28.52204590370396
						],
						[
							-81.38163147376373,
							28.52301033484966
						],
						[
							-81.38193392205734,
							28.526386342083605
						],
						[
							-81.3824306580836,
							28.53109432438326
						],
						[
							-81.38286528872922,
							28.535177436153198
						],
						[
							-81.38261984126429,
							28.53517020200676
						],
						[
							-81.38254793417289,
							28.535324763088028
						],
						[
							-81.3824236496671,
							28.53532559855821
						],
						[
							-81.38197298141168,
							28.535330605983262
						],
						[
							-81.38135606358676,
							28.535338617143886
						],
						[
							-81.38126379404595,
							28.53533975298766
						],
						[
							-81.38126806672479,
							28.535199277987232
						],
						[
							-81.38056189028914,
							28.535230458381406
						],
						[
							-81.37979475420897,
							28.53542574615998
						],
						[
							-81.37955339146478,
							28.535534909465042
						],
						[
							-81.37934508420116,
							28.535590992086345
						],
						[
							-81.378876387237,
							28.535717180456764
						],
						[
							-81.37867308739844,
							28.535778270502853
						],
						[
							-81.37843373194112,
							28.535856387413034
						],
						[
							-81.37829652867431,
							28.535903457028795
						],
						[
							-81.37811826236363,
							28.535964547074883
						],
						[
							-81.37797104424683,
							28.5360146213255
						],
						[
							-81.3778448567755,
							28.5360566844154
						],
						[
							-81.37764056138742,
							28.53611783111883
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "South Orange",
				"RegionID": "269188"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.31830957399991,
					28.48775500000005,
					-81.30347999999992,
					28.51576506500004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.31033870599992,
							28.507297045000087
						],
						[
							-81.31035076099994,
							28.50582184400008
						],
						[
							-81.31035076099994,
							28.505778779000085
						],
						[
							-81.31035075999996,
							28.50570867600004
						],
						[
							-81.31033473699995,
							28.505406227000037
						],
						[
							-81.3103277269999,
							28.504909491000035
						],
						[
							-81.31032271899994,
							28.504525922000084
						],
						[
							-81.3103277269999,
							28.504043205000077
						],
						[
							-81.3103587729999,
							28.502572023000084
						],
						[
							-81.31035890599992,
							28.50245571700009
						],
						[
							-81.30961882399993,
							28.50246268400008
						],
						[
							-81.30961799999994,
							28.502379000000076
						],
						[
							-81.3094779999999,
							28.502375000000086
						],
						[
							-81.30897199999993,
							28.502369000000044
						],
						[
							-81.30830199999991,
							28.502362000000062
						],
						[
							-81.30784999999992,
							28.50236700000005
						],
						[
							-81.30598169199993,
							28.50235666100008
						],
						[
							-81.30550099999994,
							28.502354000000082
						],
						[
							-81.30550599999992,
							28.502482000000047
						],
						[
							-81.3050893489999,
							28.50248386700008
						],
						[
							-81.30507947699994,
							28.502167958000086
						],
						[
							-81.30548299999992,
							28.502158000000065
						],
						[
							-81.3054711229999,
							28.498977732000075
						],
						[
							-81.3054699999999,
							28.498677000000043
						],
						[
							-81.30548157099992,
							28.49518362100008
						],
						[
							-81.30548199999993,
							28.49505400000004
						],
						[
							-81.30532299999993,
							28.49504900000005
						],
						[
							-81.3035329999999,
							28.495043000000067
						],
						[
							-81.3035319999999,
							28.494881000000078
						],
						[
							-81.30353052899994,
							28.49466042000006
						],
						[
							-81.30352799999991,
							28.494281000000058
						],
						[
							-81.30352323799991,
							28.493647684000056
						],
						[
							-81.30352099999993,
							28.493350000000078
						],
						[
							-81.30351480099995,
							28.49250412300006
						],
						[
							-81.30351157299992,
							28.49206352400006
						],
						[
							-81.3034811949999,
							28.487918101000048
						],
						[
							-81.30347999999992,
							28.48775500000005
						],
						[
							-81.30388599999992,
							28.48775500000005
						],
						[
							-81.30592735399995,
							28.48787504500007
						],
						[
							-81.31021906299992,
							28.48786877100008
						],
						[
							-81.31019721399991,
							28.48794388300007
						],
						[
							-81.31018699999993,
							28.487979000000053
						],
						[
							-81.31428811699993,
							28.487885620000043
						],
						[
							-81.31431670499991,
							28.487884969000053
						],
						[
							-81.31449099999992,
							28.487881000000073
						],
						[
							-81.3144759999999,
							28.48842600000006
						],
						[
							-81.3143419999999,
							28.49324500000006
						],
						[
							-81.31429099999991,
							28.495081000000084
						],
						[
							-81.31429099999991,
							28.49627100000004
						],
						[
							-81.31796899999995,
							28.49623900000006
						],
						[
							-81.31796736399991,
							28.496778264000056
						],
						[
							-81.31795931799991,
							28.49943031400005
						],
						[
							-81.31795899999992,
							28.499535000000037
						],
						[
							-81.31795699999994,
							28.500180000000057
						],
						[
							-81.31795610999991,
							28.500339308000036
						],
						[
							-81.31759097699995,
							28.500284279000084
						],
						[
							-81.31755828799993,
							28.50027873500005
						],
						[
							-81.31713356199992,
							28.500198612000077
						],
						[
							-81.31688029599991,
							28.500220524000042
						],
						[
							-81.31648701099995,
							28.500269444000082
						],
						[
							-81.31643481799995,
							28.500274396000066
						],
						[
							-81.31637599999993,
							28.500276322000047
						],
						[
							-81.3161365599999,
							28.500276322000047
						],
						[
							-81.31584543899993,
							28.500309160000086
						],
						[
							-81.31584408499992,
							28.50030969800008
						],
						[
							-81.31580665699994,
							28.500358134000066
						],
						[
							-81.31580552899995,
							28.500367606000054
						],
						[
							-81.31586443599991,
							28.500971408000055
						],
						[
							-81.31589723199994,
							28.501057960000082
						],
						[
							-81.31605178699994,
							28.50134191000007
						],
						[
							-81.31677983299994,
							28.50231384400007
						],
						[
							-81.31693791999994,
							28.50247138700007
						],
						[
							-81.31697063599995,
							28.502492241000088
						],
						[
							-81.31701847199992,
							28.50252652000006
						],
						[
							-81.3170340819999,
							28.502538773000087
						],
						[
							-81.31704780199993,
							28.50253907800004
						],
						[
							-81.31748380199991,
							28.502552077000075
						],
						[
							-81.31751581899994,
							28.50255360300008
						],
						[
							-81.31757438499994,
							28.502559372000064
						],
						[
							-81.31763244899992,
							28.50256895800004
						],
						[
							-81.31768976199993,
							28.50258232100009
						],
						[
							-81.31771565699995,
							28.50258967700006
						],
						[
							-81.31796580499991,
							28.50266479700008
						],
						[
							-81.31796899999995,
							28.503416000000072
						],
						[
							-81.31796979799992,
							28.50360398600009
						],
						[
							-81.31797999999992,
							28.506008000000065
						],
						[
							-81.31797999999992,
							28.506103000000053
						],
						[
							-81.3183088699999,
							28.506107366000037
						],
						[
							-81.31830957399991,
							28.506131363000065
						],
						[
							-81.31825648499995,
							28.506135309000058
						],
						[
							-81.31732410199993,
							28.506138313000065
						],
						[
							-81.31675225499993,
							28.506141317000072
						],
						[
							-81.31542929299991,
							28.50615233300005
						],
						[
							-81.31472324499993,
							28.506170360000056
						],
						[
							-81.31436070799992,
							28.50616935900007
						],
						[
							-81.31435965799994,
							28.506169412000077
						],
						[
							-81.31435999999991,
							28.506170000000054
						],
						[
							-81.31437103699996,
							28.506539729000053
						],
						[
							-81.31437909999994,
							28.506870607000057
						],
						[
							-81.31437179599993,
							28.50711894500006
						],
						[
							-81.31437495599994,
							28.507450101000074
						],
						[
							-81.31437859599993,
							28.507648488000086
						],
						[
							-81.31438405599994,
							28.507946067000034
						],
						[
							-81.31438648299991,
							28.508078324000053
						],
						[
							-81.31439174799993,
							28.50831021500005
						],
						[
							-81.31440285999992,
							28.508574361000058
						],
						[
							-81.31440796499993,
							28.508707103000063
						],
						[
							-81.31440999999995,
							28.508921843000056
						],
						[
							-81.31440804499995,
							28.509202849000076
						],
						[
							-81.3144031729999,
							28.509434275000046
						],
						[
							-81.3143986419999,
							28.509649518000064
						],
						[
							-81.31439272599994,
							28.509930536000073
						],
						[
							-81.31438785299991,
							28.510161962000044
						],
						[
							-81.3143847209999,
							28.510310735000076
						],
						[
							-81.31437984899992,
							28.510542161000046
						],
						[
							-81.31437567299992,
							28.510740526000063
						],
						[
							-81.31437182999991,
							28.51092305700007
						],
						[
							-81.31437236399995,
							28.511071462000075
						],
						[
							-81.31438000999992,
							28.51127025700004
						],
						[
							-81.31438636099995,
							28.511435390000088
						],
						[
							-81.31439144199993,
							28.511567497000044
						],
						[
							-81.31439525299994,
							28.511666577000085
						],
						[
							-81.31439999999992,
							28.511964789000046
						],
						[
							-81.31439999999992,
							28.51239477000007
						],
						[
							-81.31439999999992,
							28.51254361000008
						],
						[
							-81.31439999999992,
							28.512841289000054
						],
						[
							-81.31439999999992,
							28.513155507000082
						],
						[
							-81.31439999999992,
							28.51346972400006
						],
						[
							-81.31439999999992,
							28.513833554000087
						],
						[
							-81.31439999999992,
							28.51409815800008
						],
						[
							-81.31439999999992,
							28.51431314900009
						],
						[
							-81.31439999999992,
							28.514500000000055
						],
						[
							-81.31440999999995,
							28.514600000000087
						],
						[
							-81.31441609399991,
							28.51477672100009
						],
						[
							-81.31441919399992,
							28.51486663500009
						],
						[
							-81.31442106299994,
							28.514987812000072
						],
						[
							-81.31442290699994,
							28.515157436000038
						],
						[
							-81.31442531899995,
							28.51537938900009
						],
						[
							-81.31442751299994,
							28.51558120900006
						],
						[
							-81.31442865399993,
							28.515686133000088
						],
						[
							-81.31442904999994,
							28.515722573000062
						],
						[
							-81.31433359099992,
							28.51572358900006
						],
						[
							-81.31043488299991,
							28.51576506500004
						],
						[
							-81.31042086499991,
							28.51463891900005
						],
						[
							-81.31041986299994,
							28.514586842000085
						],
						[
							-81.31041980899994,
							28.514535765000062
						],
						[
							-81.31041485599991,
							28.513116661000083
						],
						[
							-81.31041285299995,
							28.512545816000056
						],
						[
							-81.3103938239999,
							28.512186283000062
						],
						[
							-81.31036878799995,
							28.511084648000065
						],
						[
							-81.31039182199993,
							28.509693585000036
						],
						[
							-81.31038080499991,
							28.509104712000067
						],
						[
							-81.31038481099995,
							28.508900409000034
						],
						[
							-81.31035075999996,
							28.507523366000044
						],
						[
							-81.31033870599992,
							28.507297045000087
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "South Semoran",
				"RegionID": "269190"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.07160813199994,
					26.664740522000045,
					-80.05830290999995,
					26.676240052000082
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.06287513399991,
							26.675957220000043
						],
						[
							-80.0628099999999,
							26.675920000000076
						],
						[
							-80.0627975619999,
							26.67600017600006
						],
						[
							-80.06280163999992,
							26.676057035000042
						],
						[
							-80.06099999899993,
							26.676010001000066
						],
						[
							-80.06081432099995,
							26.676005632000056
						],
						[
							-80.06014999999991,
							26.67599000100006
						],
						[
							-80.05975999999993,
							26.675980001000084
						],
						[
							-80.05955999899993,
							26.675970000000063
						],
						[
							-80.0588699999999,
							26.67596000000009
						],
						[
							-80.05839386999992,
							26.67594391500006
						],
						[
							-80.05850104199993,
							26.675501636000035
						],
						[
							-80.05830290999995,
							26.67419663700008
						],
						[
							-80.05850090799993,
							26.66900363600007
						],
						[
							-80.0585999079999,
							26.668202636000046
						],
						[
							-80.0585999079999,
							26.667302636000045
						],
						[
							-80.0585999079999,
							26.666726636000078
						],
						[
							-80.0585999079999,
							26.665898636000065
						],
						[
							-80.05866842899991,
							26.664931852000052
						],
						[
							-80.05868204699993,
							26.664740522000045
						],
						[
							-80.05874880899995,
							26.664745181000058
						],
						[
							-80.05884999999995,
							26.664750000000083
						],
						[
							-80.0591179619999,
							26.664759007000043
						],
						[
							-80.0594457439999,
							26.664770025000053
						],
						[
							-80.0600399999999,
							26.66479000000004
						],
						[
							-80.06041500899994,
							26.66479955400007
						],
						[
							-80.0608516499999,
							26.664810679000084
						],
						[
							-80.06160999999992,
							26.66483000000005
						],
						[
							-80.06182108699994,
							26.664837539000075
						],
						[
							-80.06213375199991,
							26.664848705000054
						],
						[
							-80.0626266139999,
							26.664866308000057
						],
						[
							-80.06328999999994,
							26.66489000000007
						],
						[
							-80.06354140099995,
							26.664895587000046
						],
						[
							-80.06373999999994,
							26.664900000000046
						],
						[
							-80.06373253899994,
							26.66498766600006
						],
						[
							-80.06372504099996,
							26.665075767000076
						],
						[
							-80.06371167499992,
							26.665232822000064
						],
						[
							-80.06369417299993,
							26.66543846500008
						],
						[
							-80.0636720569999,
							26.665698331000044
						],
						[
							-80.06365999999991,
							26.66584000000006
						],
						[
							-80.06373284499995,
							26.665844047000064
						],
						[
							-80.06382059399994,
							26.66584079900008
						],
						[
							-80.06414282899993,
							26.665828872000077
						],
						[
							-80.06430588199993,
							26.665817497000038
						],
						[
							-80.0646999999999,
							26.665790000000072
						],
						[
							-80.06492035699995,
							26.665785409000083
						],
						[
							-80.06517995299993,
							26.665780001000087
						],
						[
							-80.06571999999994,
							26.665790000000072
						],
						[
							-80.06590397699995,
							26.66579698600009
						],
						[
							-80.06619029599995,
							26.66580785900004
						],
						[
							-80.06650999999994,
							26.665820000000053
						],
						[
							-80.0666407569999,
							26.665824772000065
						],
						[
							-80.0667776109999,
							26.665829767000048
						],
						[
							-80.06729676399993,
							26.66584871400005
						],
						[
							-80.06819773099994,
							26.665879929000084
						],
						[
							-80.06851999999992,
							26.665890000000047
						],
						[
							-80.06871648999993,
							26.665897590000043
						],
						[
							-80.06934415899993,
							26.665921834000073
						],
						[
							-80.07051875099995,
							26.665967205000072
						],
						[
							-80.07160802499995,
							26.666006072000073
						],
						[
							-80.07160813199994,
							26.66600607600009
						],
						[
							-80.07160799999991,
							26.66600800000009
						],
						[
							-80.0716073779999,
							26.66601548700004
						],
						[
							-80.07160737599992,
							26.666015517000062
						],
						[
							-80.07131799999992,
							26.66949800000009
						],
						[
							-80.07126199999993,
							26.670030000000054
						],
						[
							-80.07112099999995,
							26.67174700000004
						],
						[
							-80.07104399999992,
							26.67258600000008
						],
						[
							-80.07071499999995,
							26.675065000000075
						],
						[
							-80.07065699999993,
							26.67605400000008
						],
						[
							-80.07065199999994,
							26.676131000000055
						],
						[
							-80.0706513419999,
							26.676185640000085
						],
						[
							-80.07046000999992,
							26.676240052000082
						],
						[
							-80.06948004999992,
							26.67621994700005
						],
						[
							-80.06947748099992,
							26.676158606000058
						],
						[
							-80.06910339199995,
							26.67614634100005
						],
						[
							-80.06868982099991,
							26.676132781000035
						],
						[
							-80.06845906099994,
							26.67612521500007
						],
						[
							-80.06829999999991,
							26.676120000000083
						],
						[
							-80.0678543489999,
							26.67611372300007
						],
						[
							-80.06743260899992,
							26.67610781400009
						],
						[
							-80.06711428699992,
							26.676103393000062
						],
						[
							-80.06697120299992,
							26.676101406000043
						],
						[
							-80.06686999999994,
							26.676100000000076
						],
						[
							-80.06659716599995,
							26.676092820000065
						],
						[
							-80.06633456399993,
							26.67608591000004
						],
						[
							-80.0662150849999,
							26.676082765000046
						],
						[
							-80.06610999999992,
							26.67608000000007
						],
						[
							-80.06542735699992,
							26.676058499000078
						],
						[
							-80.06515684399994,
							26.676049979000084
						],
						[
							-80.06499836599994,
							26.676044988000058
						],
						[
							-80.06483999999995,
							26.676040000000057
						],
						[
							-80.06436127199993,
							26.67602986800006
						],
						[
							-80.06388390899991,
							26.676019765000035
						],
						[
							-80.06353396599991,
							26.676012359000083
						],
						[
							-80.06330298499995,
							26.676007471000048
						],
						[
							-80.06300854599993,
							26.676001239000072
						],
						[
							-80.0629428279999,
							26.675995902000068
						],
						[
							-80.06287513399991,
							26.675957220000043
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "West Palm Beach",
				"Name": "Southwest",
				"RegionID": "269197"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.09836377499994,
					26.749516335000067,
					-80.09010999999992,
					26.759027562000085
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.09028913999992,
							26.74984721900006
						],
						[
							-80.09031224499995,
							26.749516335000067
						],
						[
							-80.09196716799994,
							26.74958306600007
						],
						[
							-80.09816517799993,
							26.749832986000058
						],
						[
							-80.09817229899994,
							26.750134613000057
						],
						[
							-80.09836377499994,
							26.754442855000036
						],
						[
							-80.09825390299994,
							26.754542507000053
						],
						[
							-80.09818124599991,
							26.754608405000056
						],
						[
							-80.09808340399992,
							26.75469714500008
						],
						[
							-80.09796999999992,
							26.754800000000046
						],
						[
							-80.09787328399995,
							26.754898444000048
						],
						[
							-80.09769135699992,
							26.75508361800007
						],
						[
							-80.09740999999991,
							26.755370000000084
						],
						[
							-80.09712632599991,
							26.755653674000087
						],
						[
							-80.0968299999999,
							26.75595000000004
						],
						[
							-80.09654827499992,
							26.756226782000056
						],
						[
							-80.09625999999992,
							26.75651000000005
						],
						[
							-80.09611590899993,
							26.756654091000087
						],
						[
							-80.09589698799994,
							26.756873012000085
						],
						[
							-80.09571999999991,
							26.75707000000006
						],
						[
							-80.09471230699995,
							26.758019051000076
						],
						[
							-80.09364148199995,
							26.759027562000085
						],
						[
							-80.0933659399999,
							26.759014265000076
						],
						[
							-80.09294291999993,
							26.758988471000066
						],
						[
							-80.0922599999999,
							26.75896000000006
						],
						[
							-80.09218231099993,
							26.758956585000078
						],
						[
							-80.09205433099993,
							26.758950960000053
						],
						[
							-80.09169462299991,
							26.758935148000035
						],
						[
							-80.09130999999991,
							26.75892000000005
						],
						[
							-80.09117959199995,
							26.758572246000085
						],
						[
							-80.0910366519999,
							26.75818796200008
						],
						[
							-80.09085473099992,
							26.757696775000056
						],
						[
							-80.0906963249999,
							26.757257619000086
						],
						[
							-80.09058353699994,
							26.756943425000088
						],
						[
							-80.09048857199991,
							26.756613062000046
						],
						[
							-80.09038099299994,
							26.756173666000052
						],
						[
							-80.0903014189999,
							26.755784222000045
						],
						[
							-80.09027184799993,
							26.755492173000054
						],
						[
							-80.09023217099991,
							26.755164629000035
						],
						[
							-80.09015870099995,
							26.754569264000054
						],
						[
							-80.09011336299994,
							26.75398407600005
						],
						[
							-80.09010999999992,
							26.75364384100004
						],
						[
							-80.09011252499994,
							26.753027243000076
						],
						[
							-80.09013732799991,
							26.752410712000085
						],
						[
							-80.09017317699994,
							26.75151960000005
						],
						[
							-80.09021013599994,
							26.750935047000045
						],
						[
							-80.09025139599993,
							26.750366936000034
						],
						[
							-80.09027548099994,
							26.75003529500009
						],
						[
							-80.09028913999992,
							26.74984721900006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "West Palm Beach",
				"Name": "Spencer Lakes",
				"RegionID": "269199"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.46805184899995,
					27.956661636000035,
					-82.44931836399991,
					27.981800054000075
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.45391818299993,
							27.960800000000063
						],
						[
							-82.45481814199991,
							27.959199966000085
						],
						[
							-82.45713611499991,
							27.95699982700006
						],
						[
							-82.45801818199993,
							27.95700000000005
						],
						[
							-82.46016363199993,
							27.957000002000086
						],
						[
							-82.46091825399992,
							27.957191083000055
						],
						[
							-82.46101244899995,
							27.957046148000074
						],
						[
							-82.4621890219999,
							27.956912612000057
						],
						[
							-82.46398351699992,
							27.956708415000037
						],
						[
							-82.4644017139999,
							27.956661636000035
						],
						[
							-82.46426172199995,
							27.957361594000076
						],
						[
							-82.46411874499995,
							27.958076478000066
						],
						[
							-82.46402342699992,
							27.95876753300007
						],
						[
							-82.46407108599993,
							27.95926795300005
						],
						[
							-82.46426172199995,
							27.95960156500007
						],
						[
							-82.46461916499993,
							27.959887519000063
						],
						[
							-82.46504809499993,
							27.959959008000055
						],
						[
							-82.46559617299994,
							27.959887519000063
						],
						[
							-82.46614425099995,
							27.959911349000038
						],
						[
							-82.46645403499991,
							27.959959008000055
						],
						[
							-82.4670259419999,
							27.960125814000037
						],
						[
							-82.46783614499992,
							27.96019730200004
						],
						[
							-82.46805184899995,
							27.96024991300004
						],
						[
							-82.46796837799991,
							27.96073715600005
						],
						[
							-82.46790880599991,
							27.961084901000053
						],
						[
							-82.46766363599994,
							27.962516036000068
						],
						[
							-82.46766363499995,
							27.963429959000052
						],
						[
							-82.46766363499995,
							27.967034639000076
						],
						[
							-82.4676635809999,
							27.967109911000083
						],
						[
							-82.46766363499995,
							27.973722382000062
						],
						[
							-82.46766363599994,
							27.981800054000075
						],
						[
							-82.45365908799994,
							27.981800000000078
						],
						[
							-82.45360452499995,
							27.968159985000057
						],
						[
							-82.4532183309999,
							27.96649990900005
						],
						[
							-82.45251824799995,
							27.96589988500006
						],
						[
							-82.4511363659999,
							27.965490911000074
						],
						[
							-82.44931836399991,
							27.965300075000076
						],
						[
							-82.45112738699993,
							27.96440006200004
						],
						[
							-82.45291817899994,
							27.962700001000087
						],
						[
							-82.45361827799991,
							27.961700059000066
						],
						[
							-82.45391818299993,
							27.960800000000063
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Tampa Heights",
				"RegionID": "269206"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.15948714299992,
					26.107195552000064,
					-80.14300449599995,
					26.119425870000043
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.14331498099995,
							26.11623695600008
						],
						[
							-80.14325689599991,
							26.11474774700008
						],
						[
							-80.1432038179999,
							26.11319242500008
						],
						[
							-80.14320381699991,
							26.11299514800004
						],
						[
							-80.14318178399992,
							26.112115844000073
						],
						[
							-80.1431427249999,
							26.111232535000056
						],
						[
							-80.1431046699999,
							26.110683721000044
						],
						[
							-80.14309765899992,
							26.11042032900008
						],
						[
							-80.14309765899992,
							26.11030616000005
						],
						[
							-80.14308163499993,
							26.109821441000065
						],
						[
							-80.1430666139999,
							26.10935475000008
						],
						[
							-80.1430666139999,
							26.109328711000046
						],
						[
							-80.1430515909999,
							26.108592619000035
						],
						[
							-80.14304057499994,
							26.108400333000077
						],
						[
							-80.14302755499995,
							26.10813093500008
						],
						[
							-80.14300449599995,
							26.10754601300005
						],
						[
							-80.14399599099995,
							26.107529041000078
						],
						[
							-80.1446379439999,
							26.107513017000088
						],
						[
							-80.14488330699993,
							26.107490986000073
						],
						[
							-80.14505055799992,
							26.107473051000056
						],
						[
							-80.14528390099991,
							26.107458937000047
						],
						[
							-80.14608208599992,
							26.10744691900004
						],
						[
							-80.14714065599992,
							26.107449924000036
						],
						[
							-80.14755126499995,
							26.107453930000077
						],
						[
							-80.1481321249999,
							26.107440911000083
						],
						[
							-80.14916966399994,
							26.10743289900006
						],
						[
							-80.15013109099995,
							26.107415873000036
						],
						[
							-80.15079507399992,
							26.107406860000083
						],
						[
							-80.15122170699993,
							26.10739684500004
						],
						[
							-80.15294626499991,
							26.107354783000066
						],
						[
							-80.1532489299999,
							26.10733664600008
						],
						[
							-80.15360924799995,
							26.107317729000044
						],
						[
							-80.15893214199991,
							26.107198550000078
						],
						[
							-80.15904236199992,
							26.107195552000064
						],
						[
							-80.15931871499993,
							26.107817469000054
						],
						[
							-80.15948714299992,
							26.10846844300005
						],
						[
							-80.15936492899993,
							26.108873135000067
						],
						[
							-80.15921756499995,
							26.10898319800009
						],
						[
							-80.1583360759999,
							26.109639166000083
						],
						[
							-80.15844141399992,
							26.10973331100007
						],
						[
							-80.15876708199994,
							26.110027698000067
						],
						[
							-80.1587089269999,
							26.110206077000043
						],
						[
							-80.15614300599994,
							26.113019184000052
						],
						[
							-80.15579649199992,
							26.113449823000053
						],
						[
							-80.15534590699991,
							26.11394370700009
						],
						[
							-80.1535745729999,
							26.114181762000044
						],
						[
							-80.15356700299992,
							26.11420696500005
						],
						[
							-80.1539158839999,
							26.11482985400005
						],
						[
							-80.15363129399992,
							26.11558901300009
						],
						[
							-80.15127178199992,
							26.11528354300009
						],
						[
							-80.15026116999991,
							26.115287393000074
						],
						[
							-80.1501831679999,
							26.115580984000076
						],
						[
							-80.1500771229999,
							26.115971628000068
						],
						[
							-80.14868282799995,
							26.117365563000078
						],
						[
							-80.14802510699991,
							26.11919246000008
						],
						[
							-80.1475282319999,
							26.119425870000043
						],
						[
							-80.14589580799992,
							26.118821789000037
						],
						[
							-80.14558134299995,
							26.118701612000052
						],
						[
							-80.14539413299991,
							26.118628407000074
						],
						[
							-80.14384276599992,
							26.11812075000006
						],
						[
							-80.1433689079999,
							26.11799267500004
						],
						[
							-80.14336505599994,
							26.11782230700004
						],
						[
							-80.14336405499995,
							26.117727167000055
						],
						[
							-80.14331498099995,
							26.116494337000063
						],
						[
							-80.14331498099995,
							26.11623695600008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Tarpon River",
				"RegionID": "269208"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.67898087599991,
					30.42997401000008,
					-81.63588487999994,
					30.46020006400005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.67851393099994,
							30.460193921000037
						],
						[
							-81.67744690799992,
							30.460178011000043
						],
						[
							-81.67683390699995,
							30.460183010000037
						],
						[
							-81.67468190699992,
							30.46016001000004
						],
						[
							-81.67425490699992,
							30.460165010000082
						],
						[
							-81.66944090699991,
							30.46012501000007
						],
						[
							-81.6665419069999,
							30.460108010000052
						],
						[
							-81.6651179079999,
							30.46009301000004
						],
						[
							-81.65892090699992,
							30.46004401000005
						],
						[
							-81.65669290799991,
							30.460032010000077
						],
						[
							-81.65622590699991,
							30.46003501000007
						],
						[
							-81.65570690699991,
							30.460029011000078
						],
						[
							-81.65528490799994,
							30.460073009000045
						],
						[
							-81.65476890799994,
							30.460044011000033
						],
						[
							-81.65429890699994,
							30.460063011000045
						],
						[
							-81.6533409079999,
							30.460104011000055
						],
						[
							-81.6528529069999,
							30.460115010000038
						],
						[
							-81.65233490799994,
							30.460145011000066
						],
						[
							-81.65202590699994,
							30.460156011000038
						],
						[
							-81.65141290699995,
							30.460168010000075
						],
						[
							-81.65093790799996,
							30.460156011000038
						],
						[
							-81.65045890699992,
							30.46014901000007
						],
						[
							-81.65027590699992,
							30.460141011000076
						],
						[
							-81.65013690799992,
							30.460130010000057
						],
						[
							-81.64980590699992,
							30.460115010000038
						],
						[
							-81.64954890799993,
							30.460089010000047
						],
						[
							-81.64952290799994,
							30.46008501100005
						],
						[
							-81.64946690799991,
							30.460085010000057
						],
						[
							-81.64930390699993,
							30.460068010000043
						],
						[
							-81.64913890799994,
							30.46005101000009
						],
						[
							-81.64904790899995,
							30.460033010000075
						],
						[
							-81.6483469069999,
							30.459943011000068
						],
						[
							-81.6473979079999,
							30.45979101000006
						],
						[
							-81.64689990799991,
							30.459691011000075
						],
						[
							-81.64584990799995,
							30.459459011000035
						],
						[
							-81.64450390799993,
							30.459150010000087
						],
						[
							-81.64385190799993,
							30.45901901000008
						],
						[
							-81.64331090799993,
							30.45891101100006
						],
						[
							-81.64272190799994,
							30.45878001000006
						],
						[
							-81.64212590699992,
							30.45865701100007
						],
						[
							-81.63944490799992,
							30.458173011000042
						],
						[
							-81.63889890699994,
							30.45808201000006
						],
						[
							-81.6369579069999,
							30.457740010000066
						],
						[
							-81.6361669019999,
							30.457599927000043
						],
						[
							-81.63588487999994,
							30.45768991300008
						],
						[
							-81.63592790599996,
							30.457557009000084
						],
						[
							-81.63602290499995,
							30.457284009000034
						],
						[
							-81.63648290599991,
							30.455915008000094
						],
						[
							-81.6365089059999,
							30.455842009000037
						],
						[
							-81.63694790599993,
							30.45451500900009
						],
						[
							-81.63732690599994,
							30.453370008000036
						],
						[
							-81.63756090599992,
							30.452662009000054
						],
						[
							-81.6381779049999,
							30.450797008000052
						],
						[
							-81.63870007299994,
							30.449216924000037
						],
						[
							-81.63859673799993,
							30.449189093000086
						],
						[
							-81.63886590499993,
							30.448358009000057
						],
						[
							-81.6391119939999,
							30.447609027000052
						],
						[
							-81.63934690499991,
							30.44688700900008
						],
						[
							-81.63968090499992,
							30.445835008000078
						],
						[
							-81.63976690599992,
							30.445588009000065
						],
						[
							-81.63998090599995,
							30.44492100800005
						],
						[
							-81.64024290599993,
							30.444161008000034
						],
						[
							-81.6404729059999,
							30.443459008000044
						],
						[
							-81.64117290599995,
							30.441320008000048
						],
						[
							-81.64154190599993,
							30.440192008000054
						],
						[
							-81.64239090599995,
							30.437593008000082
						],
						[
							-81.64252099999993,
							30.43719400000009
						],
						[
							-81.6426239079999,
							30.436881011000086
						],
						[
							-81.6428509079999,
							30.43619701000006
						],
						[
							-81.64294290699992,
							30.43586401000005
						],
						[
							-81.64296290699991,
							30.435796010000047
						],
						[
							-81.6430529079999,
							30.435499011000047
						],
						[
							-81.64315390699994,
							30.435127010000087
						],
						[
							-81.64324590799993,
							30.43477001000008
						],
						[
							-81.64334690699991,
							30.434421010000047
						],
						[
							-81.64354390799991,
							30.433815010000043
						],
						[
							-81.64418279599994,
							30.431955852000044
						],
						[
							-81.64432101999995,
							30.43195616700007
						],
						[
							-81.64489083099994,
							30.430194965000055
						],
						[
							-81.64536090699994,
							30.43019401000004
						],
						[
							-81.64558190799994,
							30.430188010000055
						],
						[
							-81.6468399069999,
							30.430178010000077
						],
						[
							-81.64844990799992,
							30.43015001100008
						],
						[
							-81.64882790799993,
							30.430140010000063
						],
						[
							-81.6505489079999,
							30.430130010000084
						],
						[
							-81.65166990799992,
							30.430124010000043
						],
						[
							-81.65245390799993,
							30.43012501000004
						],
						[
							-81.65281890699993,
							30.43012801000009
						],
						[
							-81.65410290699992,
							30.430084010000087
						],
						[
							-81.65444790799995,
							30.43007201100005
						],
						[
							-81.65459890499994,
							30.430088009000087
						],
						[
							-81.65472390799994,
							30.430078011000038
						],
						[
							-81.65490690699994,
							30.430078010000045
						],
						[
							-81.6552339079999,
							30.430081010000038
						],
						[
							-81.65570390699992,
							30.430058011000085
						],
						[
							-81.65601590699993,
							30.430046010000073
						],
						[
							-81.65613790899994,
							30.430041068000037
						],
						[
							-81.65630790599994,
							30.430046008000094
						],
						[
							-81.65710190499993,
							30.430040008000052
						],
						[
							-81.65757590599992,
							30.43000600700009
						],
						[
							-81.65772690499995,
							30.42997401000008
						],
						[
							-81.65792890599994,
							30.429985008000074
						],
						[
							-81.65827903899992,
							30.429976879000034
						],
						[
							-81.65825690499992,
							30.430225009000083
						],
						[
							-81.65824890599993,
							30.43068100800008
						],
						[
							-81.65826390599995,
							30.43161600900004
						],
						[
							-81.65826390699993,
							30.432632008000038
						],
						[
							-81.65832490699995,
							30.432951008000092
						],
						[
							-81.6583709059999,
							30.433083008000043
						],
						[
							-81.65843190599992,
							30.433208008000065
						],
						[
							-81.65852390599991,
							30.433336008000083
						],
						[
							-81.65861490599993,
							30.433430008000073
						],
						[
							-81.65906490499992,
							30.433798008000057
						],
						[
							-81.65986590499995,
							30.434494008000062
						],
						[
							-81.65991190499994,
							30.434544009000035
						],
						[
							-81.65996590499992,
							30.434626008000066
						],
						[
							-81.66010995699992,
							30.43491898900004
						],
						[
							-81.66017190499991,
							30.435158011000055
						],
						[
							-81.6601939059999,
							30.43577600800006
						],
						[
							-81.66020190599994,
							30.436729009000093
						],
						[
							-81.66019390699995,
							30.43704200800005
						],
						[
							-81.66027090499995,
							30.437914009000053
						],
						[
							-81.66028578999993,
							30.43896715200009
						],
						[
							-81.6630359529999,
							30.43825482400007
						],
						[
							-81.66504990599992,
							30.44001700800004
						],
						[
							-81.66659690599994,
							30.44137100800009
						],
						[
							-81.66981601599991,
							30.444187930000055
						],
						[
							-81.67108379099994,
							30.446296022000066
						],
						[
							-81.67396643799992,
							30.44900815400007
						],
						[
							-81.67616677099994,
							30.452761767000084
						],
						[
							-81.67759054299995,
							30.455479876000087
						],
						[
							-81.67898087599991,
							30.46020006400005
						],
						[
							-81.67865490499992,
							30.460198008000077
						],
						[
							-81.67851393099994,
							30.460193921000037
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Turtle Creek",
				"RegionID": "269215"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.26055356450581,
					28.448017000374676,
					-81.23227200009109,
					28.473601194052677
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.24091765400351,
							28.47337466562537
						],
						[
							-81.2409020004043,
							28.47308700038716
						],
						[
							-81.24033700044006,
							28.473088000433254
						],
						[
							-81.23900800033161,
							28.46990600034344
						],
						[
							-81.23957300029586,
							28.46973000032434
						],
						[
							-81.23867600031595,
							28.4679199996272
						],
						[
							-81.23830999963242,
							28.468094999600197
						],
						[
							-81.23381800031004,
							28.459978999598277
						],
						[
							-81.23364599957594,
							28.459633999882726
						],
						[
							-81.23388099961679,
							28.45955099965399
						],
						[
							-81.23274300021887,
							28.456956999689297
						],
						[
							-81.23252299997019,
							28.45703999991803
						],
						[
							-81.23228799992934,
							28.45633599984157
						],
						[
							-81.23227200009109,
							28.456018999618166
						],
						[
							-81.23239799960405,
							28.455743000385368
						],
						[
							-81.2327739998492,
							28.4552049998671
						],
						[
							-81.23321400034658,
							28.455508000344516
						],
						[
							-81.23370000026652,
							28.45473599983149
						],
						[
							-81.23330800018311,
							28.454417999561905
						],
						[
							-81.23440699958188,
							28.4528730002885
						],
						[
							-81.23539500015923,
							28.45227999993293
						],
						[
							-81.23570900024437,
							28.452790000059768
						],
						[
							-81.23616200044172,
							28.452518000111958
						],
						[
							-81.23666700033812,
							28.452099999729384
						],
						[
							-81.23644700008943,
							28.451645000339127
						],
						[
							-81.23679480928696,
							28.451448931049615
						],
						[
							-81.23705900042152,
							28.4512999997243
						],
						[
							-81.2374359998135,
							28.45117600030361
						],
						[
							-81.23794399984816,
							28.451187999957416
						],
						[
							-81.24044500002249,
							28.451150000004453
						],
						[
							-81.24221942713751,
							28.451186194118826
						],
						[
							-81.24235700002562,
							28.451189000003506
						],
						[
							-81.24425005760884,
							28.45129241034575
						],
						[
							-81.24438900016443,
							28.4512999997243
						],
						[
							-81.24459199962942,
							28.451284999932135
						],
						[
							-81.24634699958996,
							28.451153000142725
						],
						[
							-81.2494810001651,
							28.45067899987667
						],
						[
							-81.2501399999658,
							28.450432000182012
						],
						[
							-81.25289900034196,
							28.449372999929096
						],
						[
							-81.25426999968845,
							28.4488809997326
						],
						[
							-81.25908799964922,
							28.448017000374676
						],
						[
							-81.259569000238,
							28.44805600037382
						],
						[
							-81.2597899996335,
							28.448181999886685
						],
						[
							-81.26049000042478,
							28.448382000112844
						],
						[
							-81.26049000042478,
							28.448624466325107
						],
						[
							-81.26049000042478,
							28.450970999847
						],
						[
							-81.26055356450581,
							28.450970999847
						],
						[
							-81.26039881096969,
							28.473601194052677
						],
						[
							-81.24091765400351,
							28.47337466562537
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Vista Park",
				"RegionID": "269222"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.4264195639999,
					28.526901128000077,
					-81.41787118199994,
					28.53435199200004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.41787118199994,
							28.527332758000057
						],
						[
							-81.41787425799993,
							28.526901128000077
						],
						[
							-81.41800241399994,
							28.526933151000037
						],
						[
							-81.41843705899993,
							28.526974214000063
						],
						[
							-81.41966487999993,
							28.527010266000048
						],
						[
							-81.42002341099993,
							28.52700926600005
						],
						[
							-81.42092875399993,
							28.52700425800009
						],
						[
							-81.4219142149999,
							28.527003256000057
						],
						[
							-81.42350257099993,
							28.52700926600005
						],
						[
							-81.42402935299994,
							28.527012269000068
						],
						[
							-81.42512297299993,
							28.52701827900006
						],
						[
							-81.42607538699993,
							28.52702628500009
						],
						[
							-81.42607673299995,
							28.52734991200009
						],
						[
							-81.4263049999999,
							28.527351000000067
						],
						[
							-81.42629799999992,
							28.528080000000045
						],
						[
							-81.42628999999994,
							28.528980000000047
						],
						[
							-81.42627899999992,
							28.530196000000046
						],
						[
							-81.42627698699994,
							28.530380526000044
						],
						[
							-81.4264195639999,
							28.531278372000088
						],
						[
							-81.42595688799992,
							28.531285186000048
						],
						[
							-81.42591574199992,
							28.53128603400006
						],
						[
							-81.42560345099992,
							28.531329670000048
						],
						[
							-81.42559961199993,
							28.531330198000035
						],
						[
							-81.42559212799995,
							28.53133121100007
						],
						[
							-81.42553593899993,
							28.531356214000084
						],
						[
							-81.42546336099991,
							28.53141913400009
						],
						[
							-81.42528686599991,
							28.53167972600005
						],
						[
							-81.42518442499994,
							28.532016628000065
						],
						[
							-81.42517559499993,
							28.53204407700008
						],
						[
							-81.42515693299993,
							28.532094121000057
						],
						[
							-81.42496736299996,
							28.53255973200004
						],
						[
							-81.4249206959999,
							28.53284713700009
						],
						[
							-81.42491504199995,
							28.532878449000066
						],
						[
							-81.42490865999991,
							28.532907941000076
						],
						[
							-81.42485365999994,
							28.53314294100005
						],
						[
							-81.42484667899993,
							28.533170762000054
						],
						[
							-81.42482959499995,
							28.53322707800004
						],
						[
							-81.42480886599992,
							28.53328215600004
						],
						[
							-81.4247845779999,
							28.533335760000057
						],
						[
							-81.42475683599991,
							28.533387661000063
						],
						[
							-81.42475248799991,
							28.533395109000082
						],
						[
							-81.42458128999994,
							28.533685174000084
						],
						[
							-81.42450647899994,
							28.533943760000056
						],
						[
							-81.42449891199993,
							28.53419416400004
						],
						[
							-81.42449739699993,
							28.53422581900009
						],
						[
							-81.42449647899991,
							28.534238459000054
						],
						[
							-81.4244874289999,
							28.53435199200004
						],
						[
							-81.42358621499994,
							28.53433993200008
						],
						[
							-81.41798930499994,
							28.534338151000043
						],
						[
							-81.41797437299994,
							28.533942547000038
						],
						[
							-81.41796035199991,
							28.533513913000036
						],
						[
							-81.41795834899996,
							28.533028191000085
						],
						[
							-81.41795834899996,
							28.532416284000078
						],
						[
							-81.41796741399992,
							28.53171524700008
						],
						[
							-81.41795233999994,
							28.53078085800007
						],
						[
							-81.41793831899992,
							28.530047772000046
						],
						[
							-81.41791428399995,
							28.528898067000057
						],
						[
							-81.4179042689999,
							28.528424364000045
						],
						[
							-81.41787118199994,
							28.527332758000057
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Washington Shores",
				"RegionID": "269224"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.69541696699991,
					30.368930935000037,
					-81.6678799149999,
					30.390945062000075
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.67360190599993,
							30.38140800800005
						],
						[
							-81.6735899869999,
							30.38124285800006
						],
						[
							-81.6733918139999,
							30.38135512100007
						],
						[
							-81.67348890499994,
							30.381050008000045
						],
						[
							-81.6734989059999,
							30.381001008000055
						],
						[
							-81.6735499049999,
							30.38074200800008
						],
						[
							-81.67356495299993,
							30.380418880000033
						],
						[
							-81.67345600499993,
							30.380557154000087
						],
						[
							-81.67125684899992,
							30.38116598500005
						],
						[
							-81.6710939049999,
							30.381001008000055
						],
						[
							-81.6707779059999,
							30.380670009000088
						],
						[
							-81.67063773199993,
							30.380537987000082
						],
						[
							-81.67076790599992,
							30.380467009000085
						],
						[
							-81.67164590599994,
							30.380138008000074
						],
						[
							-81.67224907999992,
							30.379898058000038
						],
						[
							-81.67198890499992,
							30.379538009000047
						],
						[
							-81.67153890499992,
							30.378927008000062
						],
						[
							-81.67108890499992,
							30.378321008000057
						],
						[
							-81.67065390599993,
							30.37771600800005
						],
						[
							-81.67021190499992,
							30.377110008000045
						],
						[
							-81.66976190499992,
							30.37650500900008
						],
						[
							-81.66930390599994,
							30.375895009000086
						],
						[
							-81.66893790499995,
							30.37538900900006
						],
						[
							-81.66885390599992,
							30.375307008000046
						],
						[
							-81.66882290899991,
							30.375280006000086
						],
						[
							-81.66844190499995,
							30.37461900800008
						],
						[
							-81.66798390499991,
							30.373994008000068
						],
						[
							-81.6678799149999,
							30.37385290900005
						],
						[
							-81.66957893599994,
							30.373353095000084
						],
						[
							-81.66964190699991,
							30.373328008000048
						],
						[
							-81.66970695599991,
							30.373302085000034
						],
						[
							-81.6715189059999,
							30.372570008000086
						],
						[
							-81.67245590499994,
							30.372192009000056
						],
						[
							-81.6728239059999,
							30.37202000900004
						],
						[
							-81.6747159059999,
							30.371493008000076
						],
						[
							-81.68198190499993,
							30.369132008000065
						],
						[
							-81.68269391899992,
							30.368930935000037
						],
						[
							-81.68296490599994,
							30.369258009000077
						],
						[
							-81.6830899059999,
							30.36938700800005
						],
						[
							-81.68349390499992,
							30.369707009000077
						],
						[
							-81.68398683999993,
							30.370075068000066
						],
						[
							-81.68458090599997,
							30.370480008000072
						],
						[
							-81.68494490599994,
							30.370740009000084
						],
						[
							-81.68543990599994,
							30.371058009000084
						],
						[
							-81.6857069049999,
							30.37122300800007
						],
						[
							-81.68656190299993,
							30.371717010000054
						],
						[
							-81.69541696699991,
							30.38038207100004
						],
						[
							-81.69409290499993,
							30.381460009000083
						],
						[
							-81.69319490599992,
							30.382219009000043
						],
						[
							-81.69236390599993,
							30.38289700900009
						],
						[
							-81.69205990599994,
							30.383155009000067
						],
						[
							-81.69177190599993,
							30.383379008000077
						],
						[
							-81.69164990599995,
							30.383474008000064
						],
						[
							-81.69127790499994,
							30.383804008000084
						],
						[
							-81.69101090599992,
							30.38400801000006
						],
						[
							-81.6908659049999,
							30.384140008000088
						],
						[
							-81.69040890499991,
							30.384439008000076
						],
						[
							-81.69029390499992,
							30.384518009000086
						],
						[
							-81.68994290599994,
							30.38473300800007
						],
						[
							-81.68718690499992,
							30.386326008000083
						],
						[
							-81.68647490599994,
							30.386737009000058
						],
						[
							-81.6852359049999,
							30.387440009000045
						],
						[
							-81.68405490599991,
							30.388148009000076
						],
						[
							-81.6828499049999,
							30.388837008000056
						],
						[
							-81.68161790599993,
							30.38954400800009
						],
						[
							-81.68042590599993,
							30.390253008000062
						],
						[
							-81.67925983799995,
							30.390945062000075
						],
						[
							-81.67851990499992,
							30.389742009000088
						],
						[
							-81.67835190599993,
							30.389465009000048
						],
						[
							-81.6779169049999,
							30.38883600800006
						],
						[
							-81.67770390599992,
							30.388552009000076
						],
						[
							-81.67720790599992,
							30.38794500800009
						],
						[
							-81.6761859049999,
							30.38665000900005
						],
						[
							-81.6753459059999,
							30.38561100900006
						],
						[
							-81.67491890499991,
							30.38504800900006
						],
						[
							-81.6748569049999,
							30.384972009000084
						],
						[
							-81.67452990599992,
							30.38457500900006
						],
						[
							-81.67414490599992,
							30.384115008000034
						],
						[
							-81.67361474699993,
							30.383549086000073
						],
						[
							-81.67352772899994,
							30.383105965000087
						],
						[
							-81.67358590499992,
							30.383030008000052
						],
						[
							-81.67361790599995,
							30.382978009000055
						],
						[
							-81.67367208799993,
							30.382893040000056
						],
						[
							-81.67364090599995,
							30.382761009000035
						],
						[
							-81.67359890599994,
							30.382574009000052
						],
						[
							-81.67357890599993,
							30.382474009000077
						],
						[
							-81.67355990699991,
							30.382381008000035
						],
						[
							-81.67355590599993,
							30.382306008000057
						],
						[
							-81.67355190599994,
							30.382237008000065
						],
						[
							-81.67355590599993,
							30.382131008000048
						],
						[
							-81.67355990599992,
							30.382001009000078
						],
						[
							-81.67356790599992,
							30.381854008000065
						],
						[
							-81.67359690599994,
							30.38163300900004
						],
						[
							-81.67360590499993,
							30.38150300800004
						],
						[
							-81.67360190599993,
							30.38140800800005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "45th and Moncrief",
				"RegionID": "268867"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.33188499999994,
					28.448615001000064,
					-81.26478099999991,
					28.482259000000056
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.29183799999993,
							28.48224300000004
						],
						[
							-81.29185199999995,
							28.481823000000077
						],
						[
							-81.29074999999995,
							28.481771000000037
						],
						[
							-81.29072399999991,
							28.48101300000008
						],
						[
							-81.29073496599995,
							28.480642499000055
						],
						[
							-81.29073799999992,
							28.480540000000076
						],
						[
							-81.2918939999999,
							28.480560000000082
						],
						[
							-81.29189799999995,
							28.480431000000067
						],
						[
							-81.29189799999995,
							28.480296000000067
						],
						[
							-81.29195199999992,
							28.476964000000066
						],
						[
							-81.29146099999991,
							28.476958000000085
						],
						[
							-81.28976399999993,
							28.476958000000085
						],
						[
							-81.28976699999993,
							28.478920000000073
						],
						[
							-81.28976499999993,
							28.479277000000085
						],
						[
							-81.28975899999995,
							28.480158000000074
						],
						[
							-81.28975099999991,
							28.48025300000006
						],
						[
							-81.28928999999994,
							28.48008100000004
						],
						[
							-81.28854599999994,
							28.479456000000084
						],
						[
							-81.28842299999992,
							28.479526000000078
						],
						[
							-81.28854099999995,
							28.47963400000009
						],
						[
							-81.28916073699992,
							28.480107479000086
						],
						[
							-81.28929099999993,
							28.480207000000064
						],
						[
							-81.28974199999993,
							28.48038900000006
						],
						[
							-81.28990099999993,
							28.480453000000068
						],
						[
							-81.28989999999993,
							28.480582000000084
						],
						[
							-81.28989899999993,
							28.48065100000008
						],
						[
							-81.28929299999993,
							28.48065100000008
						],
						[
							-81.28874799999994,
							28.48065100000008
						],
						[
							-81.28773099999995,
							28.480645000000038
						],
						[
							-81.28773099999995,
							28.48057300000005
						],
						[
							-81.28773099999995,
							28.480277000000058
						],
						[
							-81.28773099999995,
							28.479090000000042
						],
						[
							-81.28641099999994,
							28.47797600000007
						],
						[
							-81.28647299999994,
							28.47794500000009
						],
						[
							-81.2863574559999,
							28.47784375000009
						],
						[
							-81.28616061399993,
							28.47767126000008
						],
						[
							-81.28598799999992,
							28.477520000000087
						],
						[
							-81.2854519999999,
							28.478177000000077
						],
						[
							-81.28589999999991,
							28.478556000000083
						],
						[
							-81.28533699999991,
							28.478562000000068
						],
						[
							-81.28532199999995,
							28.477508000000057
						],
						[
							-81.28532437699994,
							28.47694146100008
						],
						[
							-81.28532499999994,
							28.476793000000043
						],
						[
							-81.28518999999994,
							28.476681000000042
						],
						[
							-81.28509099999991,
							28.47478300000006
						],
						[
							-81.28501899999992,
							28.47375500000004
						],
						[
							-81.28209899999992,
							28.47374300000007
						],
						[
							-81.28170399999993,
							28.473344000000054
						],
						[
							-81.2814229999999,
							28.473061000000087
						],
						[
							-81.28127599999993,
							28.47291400000006
						],
						[
							-81.28518799999995,
							28.47294500000004
						],
						[
							-81.28516599999995,
							28.472317000000093
						],
						[
							-81.28053899999992,
							28.47232800000006
						],
						[
							-81.27874099999991,
							28.469645000000074
						],
						[
							-81.28123099999993,
							28.469644000000073
						],
						[
							-81.28123099999993,
							28.469769000000042
						],
						[
							-81.2837899999999,
							28.469782000000066
						],
						[
							-81.28509599999991,
							28.46978400000006
						],
						[
							-81.28509599999991,
							28.468304000000046
						],
						[
							-81.28509599999991,
							28.466912000000036
						],
						[
							-81.2850929999999,
							28.46611400000006
						],
						[
							-81.28465399999993,
							28.46611400000006
						],
						[
							-81.28154599999993,
							28.46611400000006
						],
						[
							-81.27697999999992,
							28.46611400000006
						],
						[
							-81.27611299999995,
							28.466117000000054
						],
						[
							-81.27602499999995,
							28.465981000000056
						],
						[
							-81.2758869999999,
							28.465768000000082
						],
						[
							-81.2755469999999,
							28.465243000000044
						],
						[
							-81.27522799999991,
							28.46470000000005
						],
						[
							-81.27689699999992,
							28.46471500000007
						],
						[
							-81.27690599999994,
							28.45532700000007
						],
						[
							-81.27409599999993,
							28.455365000000086
						],
						[
							-81.27098899999994,
							28.45181800000006
						],
						[
							-81.2666559999999,
							28.451805000000036
						],
						[
							-81.26609799999994,
							28.45087200000006
						],
						[
							-81.26589899999993,
							28.45053800000005
						],
						[
							-81.2658419999999,
							28.450511000000063
						],
						[
							-81.26581299999992,
							28.450496000000044
						],
						[
							-81.26564699999994,
							28.45035500000006
						],
						[
							-81.26478099999991,
							28.44904600000007
						],
						[
							-81.2666065439999,
							28.44863302200008
						],
						[
							-81.26764342299994,
							28.448640039000054
						],
						[
							-81.26861786899991,
							28.448629024000073
						],
						[
							-81.26955425699992,
							28.44861800700005
						],
						[
							-81.27021723999991,
							28.44861800700005
						],
						[
							-81.27354717799994,
							28.448615001000064
						],
						[
							-81.27663675899993,
							28.448633028000074
						],
						[
							-81.2770273399999,
							28.448629024000073
						],
						[
							-81.27816101999991,
							28.448617006000063
						],
						[
							-81.27847248299992,
							28.44862702000006
						],
						[
							-81.27894918899995,
							28.44862702000006
						],
						[
							-81.27931373099995,
							28.448625018000087
						],
						[
							-81.2799316469999,
							28.448622012000044
						],
						[
							-81.2799917349999,
							28.448622012000044
						],
						[
							-81.28070379299993,
							28.448643045000043
						],
						[
							-81.2814268649999,
							28.448682102000078
						],
						[
							-81.28174032999993,
							28.44870713800009
						],
						[
							-81.28273380199994,
							28.448811293000063
						],
						[
							-81.28432115599992,
							28.449039634000087
						],
						[
							-81.28499415399995,
							28.449152801000086
						],
						[
							-81.2865694919999,
							28.44939516100004
						],
						[
							-81.2867727929999,
							28.449431213000082
						],
						[
							-81.28848332899992,
							28.44970061400005
						],
						[
							-81.2892151449999,
							28.449797609000086
						],
						[
							-81.28918754199992,
							28.451509007000084
						],
						[
							-81.30146999999994,
							28.451550000000054
						],
						[
							-81.30147043799991,
							28.451549226000054
						],
						[
							-81.3014725939999,
							28.451549356000044
						],
						[
							-81.30254318099992,
							28.451560371000085
						],
						[
							-81.30593721499991,
							28.451565379000044
						],
						[
							-81.30763473199994,
							28.45156137200007
						],
						[
							-81.30783903499992,
							28.451560371000085
						],
						[
							-81.30823261799992,
							28.451558367000075
						],
						[
							-81.3083578049999,
							28.451559368000066
						],
						[
							-81.30917701899995,
							28.45156237200007
						],
						[
							-81.30937831799991,
							28.451558367000075
						],
						[
							-81.30972583399995,
							28.451558367000075
						],
						[
							-81.30991310999991,
							28.451536336000064
						],
						[
							-81.3117989079999,
							28.451540340000065
						],
						[
							-81.31214341799995,
							28.451542345000064
						],
						[
							-81.31492754699991,
							28.45154634900007
						],
						[
							-81.31518893499992,
							28.45154634900007
						],
						[
							-81.3175133819999,
							28.45154534800008
						],
						[
							-81.32034057599992,
							28.451544347000038
						],
						[
							-81.3221122029999,
							28.45154634900007
						],
						[
							-81.3230045279999,
							28.451535333000038
						],
						[
							-81.32678613399992,
							28.45151330100009
						],
						[
							-81.3289283119999,
							28.451488263000044
						],
						[
							-81.3292197429999,
							28.451490267000054
						],
						[
							-81.32937898099993,
							28.451481254000043
						],
						[
							-81.33024127099992,
							28.451442195000084
						],
						[
							-81.33048443199993,
							28.451430170000037
						],
						[
							-81.33048699999995,
							28.45155900000009
						],
						[
							-81.33048699999995,
							28.452229000000045
						],
						[
							-81.33048699999995,
							28.452740000000063
						],
						[
							-81.3304839999999,
							28.453168000000062
						],
						[
							-81.33188499999994,
							28.454029000000048
						],
						[
							-81.3311369999999,
							28.45470000000006
						],
						[
							-81.33078799999993,
							28.455077000000074
						],
						[
							-81.33062899999993,
							28.455425000000048
						],
						[
							-81.33047499999992,
							28.455886000000078
						],
						[
							-81.33049099999994,
							28.45648200000005
						],
						[
							-81.33046699999994,
							28.457381000000055
						],
						[
							-81.3304399999999,
							28.458417000000054
						],
						[
							-81.33044054399994,
							28.458530454000083
						],
						[
							-81.33044799999993,
							28.460085000000053
						],
						[
							-81.3304369999999,
							28.460191000000066
						],
						[
							-81.33045599999991,
							28.46212500000007
						],
						[
							-81.33047199999993,
							28.465782000000047
						],
						[
							-81.33034399999991,
							28.466558000000077
						],
						[
							-81.33034199999992,
							28.467219000000057
						],
						[
							-81.33034299999991,
							28.46722150000005
						],
						[
							-81.33034399999991,
							28.467224000000044
						],
						[
							-81.32779699999992,
							28.467224000000044
						],
						[
							-81.32779699999992,
							28.46801000000005
						],
						[
							-81.33038599999992,
							28.46801000000005
						],
						[
							-81.3303929999999,
							28.46801000000005
						],
						[
							-81.33039999999994,
							28.46801000000005
						],
						[
							-81.33038999999991,
							28.470976000000064
						],
						[
							-81.3303919999999,
							28.471081000000083
						],
						[
							-81.3264519999999,
							28.471087000000068
						],
						[
							-81.3264519999999,
							28.471527000000037
						],
						[
							-81.3271979999999,
							28.471523000000047
						],
						[
							-81.33024599999993,
							28.471531000000084
						],
						[
							-81.33035199999995,
							28.471527000000037
						],
						[
							-81.33035599999994,
							28.471642000000088
						],
						[
							-81.3303479999999,
							28.471730000000036
						],
						[
							-81.32992499999995,
							28.471730000000036
						],
						[
							-81.3299179999999,
							28.47186300000004
						],
						[
							-81.3303689999999,
							28.471854000000064
						],
						[
							-81.3303469999999,
							28.472458000000078
						],
						[
							-81.33034499999991,
							28.47256100000004
						],
						[
							-81.32958699999995,
							28.47256100000004
						],
						[
							-81.32958699999995,
							28.473182000000065
						],
						[
							-81.3303269999999,
							28.473182000000065
						],
						[
							-81.3303259999999,
							28.473242000000084
						],
						[
							-81.33040599999993,
							28.477403000000038
						],
						[
							-81.33042899999992,
							28.478627000000074
						],
						[
							-81.32896999999991,
							28.478627000000074
						],
						[
							-81.3288829999999,
							28.47862500000008
						],
						[
							-81.32826299999994,
							28.47862500000008
						],
						[
							-81.32828799999993,
							28.476708000000087
						],
						[
							-81.3244499999999,
							28.476708000000087
						],
						[
							-81.32443999999992,
							28.479861000000085
						],
						[
							-81.32409799999994,
							28.479861000000085
						],
						[
							-81.32410799999991,
							28.47996100000006
						],
						[
							-81.32392199999992,
							28.479952000000083
						],
						[
							-81.3239109999999,
							28.48035100000004
						],
						[
							-81.3239109999999,
							28.480451000000073
						],
						[
							-81.32337799999993,
							28.480443000000037
						],
						[
							-81.3233689999999,
							28.476708000000087
						],
						[
							-81.32288899999992,
							28.476708000000087
						],
						[
							-81.32272799999993,
							28.476716000000067
						],
						[
							-81.32280199999991,
							28.480288000000087
						],
						[
							-81.32280099999991,
							28.480435000000057
						],
						[
							-81.3223119999999,
							28.480417000000045
						],
						[
							-81.32231299999995,
							28.48025000000007
						],
						[
							-81.32229499999994,
							28.479888000000077
						],
						[
							-81.32194299999992,
							28.479888000000077
						],
						[
							-81.32196399999992,
							28.478439000000037
						],
						[
							-81.3217469999999,
							28.478439000000037
						],
						[
							-81.32175999999993,
							28.476714000000072
						],
						[
							-81.32144999999991,
							28.476714000000072
						],
						[
							-81.32144999999991,
							28.48041500000005
						],
						[
							-81.32090099999994,
							28.48039900000009
						],
						[
							-81.32040799999993,
							28.480386000000067
						],
						[
							-81.32040199999994,
							28.478721000000064
						],
						[
							-81.32090399999993,
							28.478721000000064
						],
						[
							-81.32090699999993,
							28.476713000000075
						],
						[
							-81.32025099999993,
							28.47672400000005
						],
						[
							-81.31846699999996,
							28.476755000000082
						],
						[
							-81.31847199999993,
							28.473630000000075
						],
						[
							-81.31847299999993,
							28.47317600000008
						],
						[
							-81.31787899999995,
							28.473175000000083
						],
						[
							-81.31287999999995,
							28.47316500000005
						],
						[
							-81.3125619999999,
							28.473164000000054
						],
						[
							-81.31224299999991,
							28.473161000000065
						],
						[
							-81.31195599999995,
							28.47315800000007
						],
						[
							-81.31195599999995,
							28.47504900000007
						],
						[
							-81.31073099999992,
							28.475050000000067
						],
						[
							-81.31024499999995,
							28.475050000000067
						],
						[
							-81.31024899999994,
							28.475601000000044
						],
						[
							-81.31025799999992,
							28.476781000000074
						],
						[
							-81.31025799999992,
							28.476856000000055
						],
						[
							-81.31258899999995,
							28.476857000000052
						],
						[
							-81.31267799999995,
							28.476861000000042
						],
						[
							-81.31267799999995,
							28.477031000000068
						],
						[
							-81.31268399999993,
							28.480297000000064
						],
						[
							-81.31258999999994,
							28.480301000000054
						],
						[
							-81.3110969999999,
							28.48030300000005
						],
						[
							-81.31108799999993,
							28.47982200000007
						],
						[
							-81.31088599999993,
							28.479823000000067
						],
						[
							-81.3104019999999,
							28.479823000000067
						],
						[
							-81.31040399999995,
							28.47998100000007
						],
						[
							-81.31039399999992,
							28.480447000000083
						],
						[
							-81.31039061399991,
							28.480619191000073
						],
						[
							-81.31018752999995,
							28.480619466000064
						],
						[
							-81.31009337899991,
							28.480619466000064
						],
						[
							-81.30998521799995,
							28.480619466000064
						],
						[
							-81.30932924599995,
							28.480621469000084
						],
						[
							-81.30918826399994,
							28.480620161000047
						],
						[
							-81.30918899999996,
							28.480548000000056
						],
						[
							-81.30919199999994,
							28.48048700000004
						],
						[
							-81.30918999999994,
							28.478181000000063
						],
						[
							-81.30916599999995,
							28.47688400000004
						],
						[
							-81.3070919999999,
							28.476890000000083
						],
						[
							-81.30613399999993,
							28.476893000000075
						],
						[
							-81.30230999999992,
							28.476904000000047
						],
						[
							-81.30196999999994,
							28.47690300000005
						],
						[
							-81.30196999999994,
							28.475073000000066
						],
						[
							-81.29890399999994,
							28.475073000000066
						],
						[
							-81.29890399999994,
							28.474106000000063
						],
						[
							-81.2988709999999,
							28.473253000000057
						],
						[
							-81.29759599999994,
							28.47324700000007
						],
						[
							-81.2960379999999,
							28.47324000000009
						],
						[
							-81.2959929999999,
							28.473468000000082
						],
						[
							-81.2959909999999,
							28.476781000000074
						],
						[
							-81.2959909999999,
							28.476990000000058
						],
						[
							-81.29555199999993,
							28.476981000000084
						],
						[
							-81.2947959999999,
							28.476981000000084
						],
						[
							-81.29368699999992,
							28.476981000000084
						],
						[
							-81.29348999999992,
							28.476981000000084
						],
						[
							-81.29308999999995,
							28.476981000000084
						],
						[
							-81.29297399999992,
							28.476981000000084
						],
						[
							-81.29297399999992,
							28.477167000000065
						],
						[
							-81.29296499999992,
							28.48029500000007
						],
						[
							-81.29296499999992,
							28.480461000000048
						],
						[
							-81.29296199999993,
							28.480589000000066
						],
						[
							-81.2935579999999,
							28.480604000000085
						],
						[
							-81.2935580649999,
							28.48068528500005
						],
						[
							-81.2935589999999,
							28.48185800000005
						],
						[
							-81.29292099999992,
							28.481850000000065
						],
						[
							-81.29293799999994,
							28.482259000000056
						],
						[
							-81.2927029999999,
							28.482247000000086
						],
						[
							-81.29183799999993,
							28.48224300000004
						]
					],
					[
						[
							-81.32170023799995,
							28.461491321000043
						],
						[
							-81.3217575509999,
							28.461477958000046
						],
						[
							-81.32175905399993,
							28.46147766000007
						],
						[
							-81.32210905399995,
							28.461408661000064
						],
						[
							-81.3221656149999,
							28.461399372000074
						],
						[
							-81.32222418099991,
							28.46139360400008
						],
						[
							-81.32228299999991,
							28.461391678000044
						],
						[
							-81.32231801099994,
							28.461392360000048
						],
						[
							-81.3226260109999,
							28.461404359000085
						],
						[
							-81.32264981799995,
							28.46140560300006
						],
						[
							-81.32270838499996,
							28.461411372000043
						],
						[
							-81.32273429999992,
							28.461415168000087
						],
						[
							-81.32320131699993,
							28.46149054700004
						],
						[
							-81.32339223799994,
							28.461392584000066
						],
						[
							-81.32354004699994,
							28.46131239400006
						],
						[
							-81.3235451349999,
							28.461299844000052
						],
						[
							-81.32356942299992,
							28.461246240000037
						],
						[
							-81.32359716399992,
							28.461194339000087
						],
						[
							-81.32362824099994,
							28.461144363000074
						],
						[
							-81.32366251999991,
							28.461096527000052
						],
						[
							-81.32369985399993,
							28.46105103600007
						],
						[
							-81.3237023239999,
							28.461048231000063
						],
						[
							-81.32383232299992,
							28.460901232000083
						],
						[
							-81.32387008299992,
							28.460861084000044
						],
						[
							-81.32391303599991,
							28.460820854000076
						],
						[
							-81.32395852699995,
							28.460783520000064
						],
						[
							-81.32400636299992,
							28.460749241000087
						],
						[
							-81.32405633899992,
							28.46071816500006
						],
						[
							-81.32410823999993,
							28.460690423000074
						],
						[
							-81.32416184399995,
							28.460666135000054
						],
						[
							-81.32419714399992,
							28.460652377000088
						],
						[
							-81.32456395799994,
							28.46051824300008
						],
						[
							-81.32479244399991,
							28.46041239200008
						],
						[
							-81.32496658899993,
							28.46027801200006
						],
						[
							-81.3249685269999,
							28.460276520000036
						],
						[
							-81.32500344199991,
							28.46025103800008
						],
						[
							-81.3250533929999,
							28.460216391000074
						],
						[
							-81.32505167799991,
							28.460164000000077
						],
						[
							-81.3250536029999,
							28.460105182000063
						],
						[
							-81.3250570699999,
							28.46006566300008
						],
						[
							-81.32506807099992,
							28.459965663000048
						],
						[
							-81.32507037199991,
							28.45994661500004
						],
						[
							-81.32507995899995,
							28.459888551000063
						],
						[
							-81.32508969899993,
							28.45984520500008
						],
						[
							-81.32516569899991,
							28.459542205000048
						],
						[
							-81.32516932199991,
							28.459528239000065
						],
						[
							-81.3251864049999,
							28.45947192300008
						],
						[
							-81.32520713499991,
							28.459416845000078
						],
						[
							-81.32523142299993,
							28.459363240000076
						],
						[
							-81.32525916499992,
							28.459311339000067
						],
						[
							-81.3252886709999,
							28.45926372200006
						],
						[
							-81.32536167099994,
							28.459153722000053
						],
						[
							-81.32536324099993,
							28.45915136300005
						],
						[
							-81.32536834199993,
							28.459143813000082
						],
						[
							-81.32539634199992,
							28.459102812000083
						],
						[
							-81.3254255199999,
							28.45906252700007
						],
						[
							-81.32546285399991,
							28.459017035000045
						],
						[
							-81.32550308399993,
							28.458974083000044
						],
						[
							-81.32554603599993,
							28.458933854000065
						],
						[
							-81.3255915279999,
							28.458896520000057
						],
						[
							-81.32563936399993,
							28.458862241000077
						],
						[
							-81.32568933899995,
							28.45883116400006
						],
						[
							-81.3257412399999,
							28.458803422000074
						],
						[
							-81.3257948449999,
							28.458779134000054
						],
						[
							-81.32584992299991,
							28.458758405000083
						],
						[
							-81.32585348299995,
							28.45875720400005
						],
						[
							-81.32608048299994,
							28.458681204000072
						],
						[
							-81.3261332379999,
							28.45866532100007
						],
						[
							-81.32619055099991,
							28.458651958000075
						],
						[
							-81.32624861499994,
							28.458642372000043
						],
						[
							-81.32630718199994,
							28.45863660300006
						],
						[
							-81.32636599999995,
							28.458634678000067
						],
						[
							-81.32661956999993,
							28.458634678000067
						],
						[
							-81.32693691499992,
							28.45858178700007
						],
						[
							-81.32728255299992,
							28.458505393000056
						],
						[
							-81.32745292699991,
							28.45846677500009
						],
						[
							-81.32770382199993,
							28.458377473000045
						],
						[
							-81.32782493099995,
							28.458316564000086
						],
						[
							-81.32782874199995,
							28.458314659000052
						],
						[
							-81.3281627419999,
							28.458148659000074
						],
						[
							-81.32816523999992,
							28.45814742300007
						],
						[
							-81.32819741399993,
							28.458132339000088
						],
						[
							-81.32840864799994,
							28.458038353000063
						],
						[
							-81.32838486299994,
							28.457910567000056
						],
						[
							-81.32838456899992,
							28.45790897900008
						],
						[
							-81.32832845199994,
							28.457604452000055
						],
						[
							-81.32823870999994,
							28.457399617000082
						],
						[
							-81.32805258399992,
							28.45729255400005
						],
						[
							-81.3280513389999,
							28.45729183600008
						],
						[
							-81.32802946899994,
							28.457278793000057
						],
						[
							-81.32784728799993,
							28.457166617000045
						],
						[
							-81.32780249699994,
							28.45714422100008
						],
						[
							-81.32748173399995,
							28.457091348000063
						],
						[
							-81.32745255099991,
							28.457086042000075
						],
						[
							-81.32740285699992,
							28.457074684000077
						],
						[
							-81.32696585799994,
							28.456961684000078
						],
						[
							-81.32695823899991,
							28.45695967900008
						],
						[
							-81.32690192299992,
							28.456942595000044
						],
						[
							-81.32687896099992,
							28.456934452000045
						],
						[
							-81.32654522699995,
							28.45681098600005
						],
						[
							-81.32642664399992,
							28.45680032200005
						],
						[
							-81.32598699999994,
							28.45680032200005
						],
						[
							-81.32592818099994,
							28.456798396000067
						],
						[
							-81.32586961499993,
							28.456792628000073
						],
						[
							-81.32581155099992,
							28.45678304100005
						],
						[
							-81.32575423799994,
							28.456769678000057
						],
						[
							-81.32574585899994,
							28.45676738900005
						],
						[
							-81.32527990299991,
							28.45663770100009
						],
						[
							-81.32527402799991,
							28.456756385000062
						],
						[
							-81.3253208729999,
							28.457036224000035
						],
						[
							-81.32542025399994,
							28.45731543500006
						],
						[
							-81.3254245949999,
							28.457327923000037
						],
						[
							-81.32544167899994,
							28.457384239000078
						],
						[
							-81.32545504199993,
							28.457441551000045
						],
						[
							-81.3254646279999,
							28.457499615000074
						],
						[
							-81.3254692559999,
							28.45754280600005
						],
						[
							-81.32549425699995,
							28.457844806000082
						],
						[
							-81.32549539699994,
							28.457860181000058
						],
						[
							-81.32549732199993,
							28.45791900000006
						],
						[
							-81.32549539699994,
							28.457977818000074
						],
						[
							-81.32548962899995,
							28.45803638500007
						],
						[
							-81.32548004199994,
							28.458094449000043
						],
						[
							-81.32547626899992,
							28.45811245300007
						],
						[
							-81.32542626899993,
							28.458339453000065
						],
						[
							-81.3254166779999,
							28.458378761000063
						],
						[
							-81.32539959499991,
							28.458435077000047
						],
						[
							-81.32537886499995,
							28.45849015500005
						],
						[
							-81.32535457699993,
							28.458543760000055
						],
						[
							-81.32532683599993,
							28.45859566100006
						],
						[
							-81.32529575899991,
							28.45864563600009
						],
						[
							-81.32526147999994,
							28.45869347200005
						],
						[
							-81.32522414599993,
							28.458738964000077
						],
						[
							-81.32518391699995,
							28.458781916000078
						],
						[
							-81.3251409639999,
							28.458822146000045
						],
						[
							-81.32509547199993,
							28.458859480000058
						],
						[
							-81.32504763599991,
							28.45889375900009
						],
						[
							-81.32499766099994,
							28.45892483500006
						],
						[
							-81.32495018999992,
							28.458950377000065
						],
						[
							-81.3246598049999,
							28.459095570000045
						],
						[
							-81.32442424099992,
							28.459312518000047
						],
						[
							-81.32440796499992,
							28.459327147000067
						],
						[
							-81.32436247299995,
							28.45936448100008
						],
						[
							-81.32433190099994,
							28.45938693100004
						],
						[
							-81.32407990099995,
							28.45956393000006
						],
						[
							-81.32406263699994,
							28.459575759000074
						],
						[
							-81.32401266099993,
							28.459606835000045
						],
						[
							-81.32396075999992,
							28.459634577000088
						],
						[
							-81.3239071559999,
							28.45965886500005
						],
						[
							-81.3238520779999,
							28.45967959500007
						],
						[
							-81.32379576199992,
							28.459696678000057
						],
						[
							-81.3237384489999,
							28.45971004100005
						],
						[
							-81.32368038499993,
							28.459719628000073
						],
						[
							-81.32362181899992,
							28.459725396000067
						],
						[
							-81.32356299999992,
							28.45972732200005
						],
						[
							-81.3234369999999,
							28.45972732200005
						],
						[
							-81.3233781809999,
							28.459725396000067
						],
						[
							-81.32331961499996,
							28.459719628000073
						],
						[
							-81.32326155099992,
							28.45971004100005
						],
						[
							-81.3232042379999,
							28.459696678000057
						],
						[
							-81.32314792199992,
							28.45967959500007
						],
						[
							-81.32309284399992,
							28.45965886500005
						],
						[
							-81.32309169099995,
							28.459658386000058
						],
						[
							-81.32280563699993,
							28.45953943300009
						],
						[
							-81.3223934909999,
							28.45938745400008
						],
						[
							-81.32191599499993,
							28.459273936000045
						],
						[
							-81.32189123799994,
							28.45926767800006
						],
						[
							-81.32183492199994,
							28.45925059500007
						],
						[
							-81.32177984399993,
							28.459229865000058
						],
						[
							-81.32172623999992,
							28.459205577000034
						],
						[
							-81.32167433899991,
							28.459177835000048
						],
						[
							-81.32166191699991,
							28.45917011100005
						],
						[
							-81.32164757699991,
							28.45920176000004
						],
						[
							-81.32161983599991,
							28.459253661000048
						],
						[
							-81.32158875899995,
							28.459303637000062
						],
						[
							-81.32157149299991,
							28.45932855700005
						],
						[
							-81.32143649299992,
							28.459516557000086
						],
						[
							-81.3214339619999,
							28.459520064000063
						],
						[
							-81.3211169619999,
							28.459957064000037
						],
						[
							-81.32110247999992,
							28.45997647300004
						],
						[
							-81.32106514599991,
							28.46002196500007
						],
						[
							-81.32104302199991,
							28.460046280000086
						],
						[
							-81.32079102199992,
							28.460313280000037
						],
						[
							-81.32077291699994,
							28.460331917000076
						],
						[
							-81.32072996399995,
							28.460372146000054
						],
						[
							-81.32068447199993,
							28.460409480000067
						],
						[
							-81.3206366359999,
							28.460443759000043
						],
						[
							-81.32058666099994,
							28.46047483600006
						],
						[
							-81.32053475999993,
							28.460502577000057
						],
						[
							-81.32053051699995,
							28.460504656000072
						],
						[
							-81.32015651699993,
							28.460686656000064
						],
						[
							-81.3201071549999,
							28.46070886600006
						],
						[
							-81.3200520769999,
							28.46072959500009
						],
						[
							-81.32000595799991,
							28.460743882000088
						],
						[
							-81.31961392799991,
							28.460853882000038
						],
						[
							-81.31950182399993,
							28.460909749000052
						],
						[
							-81.31949361099993,
							28.460917330000086
						],
						[
							-81.31945991999993,
							28.460998262000093
						],
						[
							-81.3194700979999,
							28.461016777000054
						],
						[
							-81.31948857799995,
							28.461052240000075
						],
						[
							-81.31951286499992,
							28.461105844000087
						],
						[
							-81.31953359499994,
							28.461160922000094
						],
						[
							-81.3195338029999,
							28.461161535000087
						],
						[
							-81.31971974599992,
							28.46171060200004
						],
						[
							-81.31990516799993,
							28.46220085500005
						],
						[
							-81.31991559499994,
							28.462229922000063
						],
						[
							-81.31993267799993,
							28.462286238000047
						],
						[
							-81.31994604199991,
							28.46234355100006
						],
						[
							-81.31995562799995,
							28.46240161500009
						],
						[
							-81.31996139599994,
							28.46246018100004
						],
						[
							-81.31996254199993,
							28.462481559000082
						],
						[
							-81.31996603099992,
							28.462565277000067
						],
						[
							-81.3200023629999,
							28.46253924100006
						],
						[
							-81.32005233899991,
							28.46250816400004
						],
						[
							-81.32010423999992,
							28.46248042300005
						],
						[
							-81.32015784399995,
							28.46245613500008
						],
						[
							-81.32021292199994,
							28.462435405000065
						],
						[
							-81.32026923799992,
							28.462418322000076
						],
						[
							-81.32032655099994,
							28.462404958000036
						],
						[
							-81.32038461399992,
							28.46239537200006
						],
						[
							-81.32044318099992,
							28.462389604000066
						],
						[
							-81.32046730999991,
							28.462388347000058
						],
						[
							-81.3204836939999,
							28.462376488000075
						],
						[
							-81.32051136299992,
							28.462357241000063
						],
						[
							-81.32056133899994,
							28.462326164000046
						],
						[
							-81.32061323999994,
							28.46229842200006
						],
						[
							-81.32064264799993,
							28.46228457500007
						],
						[
							-81.32080011599993,
							28.46221387500009
						],
						[
							-81.32080040499994,
							28.46221292200005
						],
						[
							-81.3208211349999,
							28.462157844000046
						],
						[
							-81.32084542299992,
							28.462104240000087
						],
						[
							-81.32087316499991,
							28.46205233900008
						],
						[
							-81.32090424099994,
							28.462002363000067
						],
						[
							-81.32093851999991,
							28.461954527000046
						],
						[
							-81.32097585399993,
							28.46190903600007
						],
						[
							-81.32101608399995,
							28.46186608300008
						],
						[
							-81.32105903599995,
							28.46182585400004
						],
						[
							-81.32110452799992,
							28.461788520000084
						],
						[
							-81.32115236399994,
							28.46175424100005
						],
						[
							-81.32120233899991,
							28.46172316400009
						],
						[
							-81.32124638599993,
							28.461699344000067
						],
						[
							-81.3215273859999,
							28.46155734300004
						],
						[
							-81.32153523999995,
							28.461553422000065
						],
						[
							-81.3215888439999,
							28.461529134000045
						],
						[
							-81.32164392199991,
							28.461508405000075
						],
						[
							-81.32170023799995,
							28.461491321000043
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Airport North",
				"RegionID": "268868"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.194939,
					26.062594,
					-80.174607,
					26.08569198200007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.194939,
							26.062627
						],
						[
							-80.194903,
							26.06765
						],
						[
							-80.194888,
							26.069702
						],
						[
							-80.194884,
							26.070291000000005
						],
						[
							-80.192669,
							26.070366
						],
						[
							-80.191769,
							26.070266
						],
						[
							-80.191769,
							26.070768000000005
						],
						[
							-80.189248,
							26.070759
						],
						[
							-80.189273,
							26.071866
						],
						[
							-80.188569,
							26.071866
						],
						[
							-80.187668,
							26.071965
						],
						[
							-80.186831,
							26.071937
						],
						[
							-80.186184,
							26.072502000000004
						],
						[
							-80.185768,
							26.072765
						],
						[
							-80.185768,
							26.074065
						],
						[
							-80.185737,
							26.075333
						],
						[
							-80.18536800000001,
							26.075265
						],
						[
							-80.185385,
							26.075471
						],
						[
							-80.185418,
							26.076909
						],
						[
							-80.185393,
							26.077137000000004
						],
						[
							-80.18492,
							26.077141
						],
						[
							-80.18273,
							26.077162
						],
						[
							-80.182368,
							26.077165
						],
						[
							-80.181413,
							26.077165
						],
						[
							-80.181368,
							26.082365
						],
						[
							-80.18131757699996,
							26.08402721500005
						],
						[
							-80.182691,
							26.083848
						],
						[
							-80.181868,
							26.084865
						],
						[
							-80.18196438099994,
							26.08485539900005
						],
						[
							-80.181498,
							26.085502
						],
						[
							-80.18101800599999,
							26.085583946000042
						],
						[
							-80.18038519299995,
							26.08569198200007
						],
						[
							-80.18038519299995,
							26.08478778700004
						],
						[
							-80.18093440699994,
							26.083983533000037
						],
						[
							-80.181039,
							26.080283
						],
						[
							-80.181039,
							26.079313
						],
						[
							-80.180825,
							26.079313
						],
						[
							-80.180841,
							26.077388
						],
						[
							-80.18107,
							26.077388
						],
						[
							-80.18107,
							26.077165
						],
						[
							-80.180668,
							26.077165
						],
						[
							-80.178101,
							26.077223000000004
						],
						[
							-80.178121,
							26.074838
						],
						[
							-80.175166,
							26.074901
						],
						[
							-80.175148,
							26.077304
						],
						[
							-80.174607,
							26.077322
						],
						[
							-80.174631,
							26.073735
						],
						[
							-80.175896,
							26.073741
						],
						[
							-80.175868,
							26.073365
						],
						[
							-80.175896,
							26.071995
						],
						[
							-80.179633,
							26.072076
						],
						[
							-80.179652,
							26.069866
						],
						[
							-80.179668,
							26.068066
						],
						[
							-80.182832,
							26.067989
						],
						[
							-80.183768,
							26.067966
						],
						[
							-80.192569,
							26.067666
						],
						[
							-80.193469,
							26.067566
						],
						[
							-80.193676,
							26.067578
						],
						[
							-80.193708,
							26.063266
						],
						[
							-80.193713,
							26.062594
						],
						[
							-80.194939,
							26.062627
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Hollywood",
				"Name": "Alandco",
				"RegionID": "268869"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.58181207799993,
					30.323864936000064,
					-81.56002291599992,
					30.337931062000056
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.56002291599992,
							30.337931062000056
						],
						[
							-81.5602709069999,
							30.334587010000064
						],
						[
							-81.56025690799993,
							30.33420801000005
						],
						[
							-81.56021890699992,
							30.33315901000009
						],
						[
							-81.5602039069999,
							30.33289101000008
						],
						[
							-81.56018790699994,
							30.332220011000057
						],
						[
							-81.5601119079999,
							30.331083011000093
						],
						[
							-81.56008790699991,
							30.330523011000086
						],
						[
							-81.56008790699991,
							30.329421010000086
						],
						[
							-81.56007790799993,
							30.329190011000037
						],
						[
							-81.56007790799993,
							30.328941010000054
						],
						[
							-81.56007790799993,
							30.32864801000005
						],
						[
							-81.56008790699991,
							30.328141011000067
						],
						[
							-81.56010390799992,
							30.327159010000063
						],
						[
							-81.5601109079999,
							30.32666701000005
						],
						[
							-81.56018090799995,
							30.32618701100006
						],
						[
							-81.56021190799993,
							30.325959010000076
						],
						[
							-81.56025990799992,
							30.325720011000044
						],
						[
							-81.56029890799994,
							30.325478010000044
						],
						[
							-81.56039590699993,
							30.32500401100009
						],
						[
							-81.56042990799995,
							30.324772010000064
						],
						[
							-81.56057690699993,
							30.324013010000044
						],
						[
							-81.56061496399991,
							30.323864936000064
						],
						[
							-81.56222690899995,
							30.324502010000057
						],
						[
							-81.56254090699991,
							30.32464501200008
						],
						[
							-81.5625639079999,
							30.324657010000067
						],
						[
							-81.5627229079999,
							30.32472901000006
						],
						[
							-81.56276090799992,
							30.32474601100006
						],
						[
							-81.56296490699992,
							30.32483201100007
						],
						[
							-81.56348190599994,
							30.325055011000075
						],
						[
							-81.56361590799993,
							30.325111011000047
						],
						[
							-81.56392590699994,
							30.32524201000007
						],
						[
							-81.5640929089999,
							30.32531701000005
						],
						[
							-81.56451190899992,
							30.325491010000064
						],
						[
							-81.56499190599993,
							30.325671010000068
						],
						[
							-81.56648290699991,
							30.32631101000004
						],
						[
							-81.56675790799994,
							30.32641301000007
						],
						[
							-81.5677679069999,
							30.326760010000044
						],
						[
							-81.56840390699995,
							30.326949011000067
						],
						[
							-81.56859290599994,
							30.327002010000058
						],
						[
							-81.56892190699995,
							30.327089010000066
						],
						[
							-81.5690789059999,
							30.327125011000078
						],
						[
							-81.56933290599994,
							30.327188010000043
						],
						[
							-81.56951890699992,
							30.327228010000056
						],
						[
							-81.56965890599992,
							30.32725901100008
						],
						[
							-81.56982490799993,
							30.327295010000057
						],
						[
							-81.57018490699994,
							30.327364011000043
						],
						[
							-81.57041490699993,
							30.327406010000065
						],
						[
							-81.57060090599992,
							30.327437011000082
						],
						[
							-81.57105290599992,
							30.327502011000036
						],
						[
							-81.57134190799991,
							30.327533011000067
						],
						[
							-81.57167190899992,
							30.327575011000075
						],
						[
							-81.57185790699992,
							30.327594011000087
						],
						[
							-81.57250790599996,
							30.327651011000057
						],
						[
							-81.5728369059999,
							30.327673010000073
						],
						[
							-81.57292790699995,
							30.32767401000007
						],
						[
							-81.57330990699995,
							30.327684010000045
						],
						[
							-81.5736889069999,
							30.327691010000077
						],
						[
							-81.57438290699992,
							30.32769501000007
						],
						[
							-81.57505690699992,
							30.327700010000058
						],
						[
							-81.57545790899991,
							30.327700010000058
						],
						[
							-81.57588990799991,
							30.327683009000054
						],
						[
							-81.57622090599995,
							30.327675010000068
						],
						[
							-81.57686890799994,
							30.32767201000007
						],
						[
							-81.57769490899994,
							30.327666010000087
						],
						[
							-81.5781029069999,
							30.327669011000065
						],
						[
							-81.57876490699994,
							30.327661010000043
						],
						[
							-81.5790439079999,
							30.32765801000005
						],
						[
							-81.57979490699995,
							30.32765801000005
						],
						[
							-81.58056890899991,
							30.327644010000082
						],
						[
							-81.58077590599993,
							30.327642010000087
						],
						[
							-81.5810759069999,
							30.327623009000035
						],
						[
							-81.5814389059999,
							30.327603010000075
						],
						[
							-81.58170293799992,
							30.32759089200005
						],
						[
							-81.58177490599991,
							30.327709009000042
						],
						[
							-81.58181207799993,
							30.327778977000033
						],
						[
							-81.5816699049999,
							30.328834009000044
						],
						[
							-81.58132490599992,
							30.331030008000084
						],
						[
							-81.5811679059999,
							30.332029008000067
						],
						[
							-81.58086599199993,
							30.334925077000037
						],
						[
							-81.58061990599992,
							30.335067008000067
						],
						[
							-81.57947090499994,
							30.335785009000062
						],
						[
							-81.57915790499993,
							30.335979009000084
						],
						[
							-81.57887290499991,
							30.33613600800004
						],
						[
							-81.57874890599993,
							30.336213009000062
						],
						[
							-81.57868190599993,
							30.336254008000086
						],
						[
							-81.57807090499995,
							30.33662800800005
						],
						[
							-81.5779529049999,
							30.336686008000072
						],
						[
							-81.57789090599994,
							30.336716009000043
						],
						[
							-81.57719190499995,
							30.33716500900005
						],
						[
							-81.5771449049999,
							30.337195008000034
						],
						[
							-81.57703190599995,
							30.337263009000086
						],
						[
							-81.57666990599995,
							30.337484009000036
						],
						[
							-81.57653690599994,
							30.337552008000046
						],
						[
							-81.57639890599995,
							30.337600008000038
						],
						[
							-81.57625790499992,
							30.337630008000076
						],
						[
							-81.57609190599993,
							30.337643009000086
						],
						[
							-81.57555090499994,
							30.337642008000046
						],
						[
							-81.57539190599994,
							30.337643008000043
						],
						[
							-81.57498190599995,
							30.337645008000038
						],
						[
							-81.57402990599991,
							30.337645008000038
						],
						[
							-81.57318890599993,
							30.337646008000036
						],
						[
							-81.57204790599991,
							30.337645008000038
						],
						[
							-81.57105990599992,
							30.337645008000038
						],
						[
							-81.57008490599992,
							30.337650008000086
						],
						[
							-81.56904390599995,
							30.337655008000073
						],
						[
							-81.56894690599995,
							30.33765600800007
						],
						[
							-81.5684739049999,
							30.337667008000036
						],
						[
							-81.5673039049999,
							30.337708008000053
						],
						[
							-81.56684090599994,
							30.33771100900009
						],
						[
							-81.56600190599994,
							30.337744008000076
						],
						[
							-81.5654979059999,
							30.33775300900004
						],
						[
							-81.56526190599993,
							30.33778800800008
						],
						[
							-81.56471990599994,
							30.33778000800004
						],
						[
							-81.56415590599994,
							30.33779900800005
						],
						[
							-81.56386590499994,
							30.337805008000085
						],
						[
							-81.56341590499994,
							30.33782800900008
						],
						[
							-81.56310290599993,
							30.337831009000066
						],
						[
							-81.56249190599993,
							30.33785800800007
						],
						[
							-81.56083690499992,
							30.33791400800004
						],
						[
							-81.5603869059999,
							30.33792100800008
						],
						[
							-81.56002291599992,
							30.337931062000056
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Alderman Park",
				"RegionID": "268870"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.1062800819999,
					26.20142891800009,
					-80.0992891379999,
					26.20790892200006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.10006499999992,
							26.204660000000047
						],
						[
							-80.10099451799994,
							26.20142891800009
						],
						[
							-80.10155399999992,
							26.201572000000056
						],
						[
							-80.1016762289999,
							26.201597550000088
						],
						[
							-80.1026085929999,
							26.201835994000078
						],
						[
							-80.1032996369999,
							26.20194606700005
						],
						[
							-80.10440928299994,
							26.201976112000068
						],
						[
							-80.1058134779999,
							26.201962092000088
						],
						[
							-80.10578781899994,
							26.203310246000058
						],
						[
							-80.10578515299994,
							26.20345034500008
						],
						[
							-80.1062800819999,
							26.204214455000056
						],
						[
							-80.10542590899992,
							26.207801895000046
						],
						[
							-80.09961521799994,
							26.20790323500006
						],
						[
							-80.0992891379999,
							26.20790892200006
						],
						[
							-80.10006499999992,
							26.204660000000047
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Bay Colony",
				"RegionID": "268883"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.59356708799993,
					30.22053483300005,
					-81.55203085399995,
					30.251787010000047
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.57047290899993,
							30.25009101300009
						],
						[
							-81.57015790899993,
							30.250080012000065
						],
						[
							-81.56984290999992,
							30.250080012000065
						],
						[
							-81.5693569099999,
							30.250080012000065
						],
						[
							-81.56527890899991,
							30.250082013000053
						],
						[
							-81.56371790899993,
							30.25008401300005
						],
						[
							-81.56347190999992,
							30.25008401300005
						],
						[
							-81.56193890899993,
							30.25008801200005
						],
						[
							-81.56096690899994,
							30.25008801200005
						],
						[
							-81.56060790999993,
							30.25009101200004
						],
						[
							-81.5599929089999,
							30.25009201200004
						],
						[
							-81.55892390899993,
							30.25009401200009
						],
						[
							-81.5579409099999,
							30.250096012000085
						],
						[
							-81.55686890899995,
							30.250101013000066
						],
						[
							-81.55671690899993,
							30.250101013000066
						],
						[
							-81.55625490999995,
							30.250093012000036
						],
						[
							-81.5548839089999,
							30.250099012000078
						],
						[
							-81.5538899089999,
							30.250093012000036
						],
						[
							-81.55338590999992,
							30.25011101200005
						],
						[
							-81.5531919099999,
							30.250108012000055
						],
						[
							-81.55268090099993,
							30.250102013000063
						],
						[
							-81.5526379069999,
							30.24988001000008
						],
						[
							-81.55257090799995,
							30.249526010000068
						],
						[
							-81.55248290799994,
							30.24906901000009
						],
						[
							-81.55230890799993,
							30.24753501000004
						],
						[
							-81.55224390799992,
							30.246716010000057
						],
						[
							-81.55220890699991,
							30.246138011000085
						],
						[
							-81.5521849079999,
							30.244850011000036
						],
						[
							-81.55219690799993,
							30.24361201100004
						],
						[
							-81.55216890699995,
							30.242223011000075
						],
						[
							-81.55215590799992,
							30.24140101000006
						],
						[
							-81.5521389079999,
							30.240303011000034
						],
						[
							-81.55214290799995,
							30.240139010000064
						],
						[
							-81.55214690799994,
							30.23984801100005
						],
						[
							-81.55214590799994,
							30.239598010000066
						],
						[
							-81.55212990699994,
							30.238225010000065
						],
						[
							-81.55212190799995,
							30.23572001100007
						],
						[
							-81.55211490799991,
							30.23496601100004
						],
						[
							-81.55211490799991,
							30.234011010000074
						],
						[
							-81.55212590799994,
							30.23322901100005
						],
						[
							-81.55209890799995,
							30.231966010000068
						],
						[
							-81.55208990699992,
							30.231690010000083
						],
						[
							-81.55208990699992,
							30.23139501000009
						],
						[
							-81.55208990699992,
							30.230202011000074
						],
						[
							-81.55208090799994,
							30.229599011000065
						],
						[
							-81.55207890799994,
							30.228957010000045
						],
						[
							-81.5520739079999,
							30.228350011000085
						],
						[
							-81.5520739079999,
							30.22810601000009
						],
						[
							-81.55206990699992,
							30.227963010000053
						],
						[
							-81.55206990699992,
							30.227247010000042
						],
						[
							-81.5520519069999,
							30.226770011000042
						],
						[
							-81.55205490799995,
							30.225310010000047
						],
						[
							-81.55203990799993,
							30.22446201100007
						],
						[
							-81.55203590799994,
							30.222777010000076
						],
						[
							-81.55203085399995,
							30.22079001400005
						],
						[
							-81.55232990899992,
							30.220800011000048
						],
						[
							-81.55261190999994,
							30.22078301200008
						],
						[
							-81.55448190999994,
							30.22082301100005
						],
						[
							-81.5550379089999,
							30.220833011000085
						],
						[
							-81.55652590999995,
							30.220858012000065
						],
						[
							-81.55734990999991,
							30.22087701200007
						],
						[
							-81.55783790999993,
							30.22088201200006
						],
						[
							-81.55850191199994,
							30.220915010000052
						],
						[
							-81.55856290999994,
							30.220905010000084
						],
						[
							-81.5587219119999,
							30.22085500700007
						],
						[
							-81.55886186999993,
							30.220755969000038
						],
						[
							-81.55893490999995,
							30.220656011000077
						],
						[
							-81.55897590899991,
							30.220597010000063
						],
						[
							-81.5590048389999,
							30.22053483300005
						],
						[
							-81.55918390999994,
							30.220595011000057
						],
						[
							-81.55943990999992,
							30.220656011000077
						],
						[
							-81.55979090999995,
							30.22071701100009
						],
						[
							-81.56005290899992,
							30.220755011000048
						],
						[
							-81.56026990899994,
							30.220787011000088
						],
						[
							-81.56058990899993,
							30.220805011000035
						],
						[
							-81.56143390999995,
							30.220805011000035
						],
						[
							-81.56147890999995,
							30.220805011000035
						],
						[
							-81.5621949099999,
							30.220800011000048
						],
						[
							-81.56223590899994,
							30.220800011000048
						],
						[
							-81.5642719189999,
							30.22082196000008
						],
						[
							-81.56442590899991,
							30.22087201100004
						],
						[
							-81.56469188699992,
							30.220976143000087
						],
						[
							-81.56532990999995,
							30.220976011000065
						],
						[
							-81.56626690999991,
							30.220976011000065
						],
						[
							-81.56647590999995,
							30.220980011000055
						],
						[
							-81.56688990999993,
							30.220973012000055
						],
						[
							-81.56742690899995,
							30.220960011000045
						],
						[
							-81.56865790899992,
							30.220945011000083
						],
						[
							-81.5695589099999,
							30.220963011000038
						],
						[
							-81.56989190999991,
							30.220966011000087
						],
						[
							-81.57041390899991,
							30.220957012000046
						],
						[
							-81.57044590999993,
							30.220956012000048
						],
						[
							-81.5706379099999,
							30.22095001100007
						],
						[
							-81.57091190999995,
							30.22094601100008
						],
						[
							-81.57111790899995,
							30.220951011000068
						],
						[
							-81.57130290999993,
							30.220944011000082
						],
						[
							-81.57146590399992,
							30.220936016000056
						],
						[
							-81.57155890699994,
							30.221090011000058
						],
						[
							-81.57165790699992,
							30.221248011000057
						],
						[
							-81.57198490699994,
							30.221756010000032
						],
						[
							-81.5721389069999,
							30.221975011000037
						],
						[
							-81.5722219079999,
							30.222117010000094
						],
						[
							-81.57235290799991,
							30.222322011000074
						],
						[
							-81.5725839079999,
							30.22265701100008
						],
						[
							-81.5728739079999,
							30.22312401000005
						],
						[
							-81.57297290799994,
							30.22327801100005
						],
						[
							-81.5731929069999,
							30.22355901100008
						],
						[
							-81.57331690699993,
							30.22374701100006
						],
						[
							-81.57368690699991,
							30.224365011000085
						],
						[
							-81.57395290799991,
							30.224783010000067
						],
						[
							-81.5740939069999,
							30.224994011000035
						],
						[
							-81.57423790899992,
							30.225201010000035
						],
						[
							-81.57443190799995,
							30.225510010000047
						],
						[
							-81.57462490699993,
							30.225787010000086
						],
						[
							-81.57485190799991,
							30.22613701000006
						],
						[
							-81.57504490799994,
							30.22645201100005
						],
						[
							-81.57523090799992,
							30.22672301000006
						],
						[
							-81.57543690699993,
							30.22704401100009
						],
						[
							-81.5756679079999,
							30.22739401100006
						],
						[
							-81.57641790699995,
							30.22853401000009
						],
						[
							-81.57711190799996,
							30.229603011000055
						],
						[
							-81.57732690799992,
							30.229921010000055
						],
						[
							-81.57751890799994,
							30.23023501000006
						],
						[
							-81.57793890699992,
							30.23086901000005
						],
						[
							-81.57842790699993,
							30.23163501000005
						],
						[
							-81.57905590799993,
							30.232564011000076
						],
						[
							-81.57942390699992,
							30.233139010000063
						],
						[
							-81.5795389079999,
							30.23330101100004
						],
						[
							-81.57989090699994,
							30.233848011000077
						],
						[
							-81.58007190799992,
							30.234098010000082
						],
						[
							-81.58036890799991,
							30.23454401000004
						],
						[
							-81.58057890799995,
							30.234844011000064
						],
						[
							-81.58083990799992,
							30.235207010000064
						],
						[
							-81.58099290699994,
							30.235407011000063
						],
						[
							-81.58105390799994,
							30.23550201000006
						],
						[
							-81.58148990799992,
							30.236087010000066
						],
						[
							-81.58152790699995,
							30.236127010000075
						],
						[
							-81.58171290799993,
							30.23637801000007
						],
						[
							-81.58222590799994,
							30.237015011000043
						],
						[
							-81.58232490799992,
							30.23715001000005
						],
						[
							-81.58286890799991,
							30.237797010000065
						],
						[
							-81.58301690799993,
							30.237980010000058
						],
						[
							-81.58310590699995,
							30.238082011000078
						],
						[
							-81.58331690799992,
							30.238338011000053
						],
						[
							-81.58354290799991,
							30.23859501000004
						],
						[
							-81.58384690799994,
							30.238934010000037
						],
						[
							-81.58400090799996,
							30.239096011000072
						],
						[
							-81.58432690799992,
							30.239461010000074
						],
						[
							-81.58461790799993,
							30.239770010000086
						],
						[
							-81.58466890699992,
							30.239824011000056
						],
						[
							-81.58491090799993,
							30.240070011000054
						],
						[
							-81.58504590799993,
							30.24022001000009
						],
						[
							-81.58578390699995,
							30.240955011000043
						],
						[
							-81.58588190799993,
							30.24104301100005
						],
						[
							-81.58614590699995,
							30.241313010000056
						],
						[
							-81.58637990699992,
							30.241534011000056
						],
						[
							-81.58667790699991,
							30.241828011000052
						],
						[
							-81.58735990699995,
							30.242480010000065
						],
						[
							-81.58798390699991,
							30.24310201100008
						],
						[
							-81.58816790799995,
							30.24326401000008
						],
						[
							-81.5886789079999,
							30.243757011000074
						],
						[
							-81.58962990799995,
							30.24464401000006
						],
						[
							-81.59036290699993,
							30.24532901100008
						],
						[
							-81.59079190699993,
							30.245764010000073
						],
						[
							-81.59212190799991,
							30.247050010000066
						],
						[
							-81.59274490699994,
							30.247654010000076
						],
						[
							-81.59349686199994,
							30.248390095000047
						],
						[
							-81.59356708799993,
							30.248464033000065
						],
						[
							-81.59346190699995,
							30.24853501000007
						],
						[
							-81.59340390699992,
							30.248574010000084
						],
						[
							-81.59333190699994,
							30.248615011000084
						],
						[
							-81.59308090699994,
							30.24879001100004
						],
						[
							-81.59286390699992,
							30.248929011000087
						],
						[
							-81.59241390699992,
							30.249219011000037
						],
						[
							-81.5920349079999,
							30.249478010000075
						],
						[
							-81.59133490799991,
							30.24991701000005
						],
						[
							-81.59117390799992,
							30.25000801100003
						],
						[
							-81.59078190799994,
							30.25025301100004
						],
						[
							-81.59042890799994,
							30.25048401000004
						],
						[
							-81.59018690699992,
							30.25063501000005
						],
						[
							-81.59014090799991,
							30.250666011000078
						],
						[
							-81.59008890699994,
							30.250704011000042
						],
						[
							-81.58981690799995,
							30.25087201000008
						],
						[
							-81.58961390799993,
							30.250981011000082
						],
						[
							-81.5895119079999,
							30.251038010000062
						],
						[
							-81.58930090799994,
							30.251142010000084
						],
						[
							-81.58906190699992,
							30.251249011000084
						],
						[
							-81.58884690699995,
							30.251338010000037
						],
						[
							-81.58858890699992,
							30.251433010000085
						],
						[
							-81.58826890799993,
							30.25152901100006
						],
						[
							-81.58809890799995,
							30.25157200900009
						],
						[
							-81.5878239079999,
							30.251626010000052
						],
						[
							-81.58751990699994,
							30.25169701100009
						],
						[
							-81.5873339069999,
							30.251725010000087
						],
						[
							-81.5869469079999,
							30.25175801100005
						],
						[
							-81.58652190799995,
							30.251780011000054
						],
						[
							-81.58631090699993,
							30.251787010000047
						],
						[
							-81.58560290799994,
							30.251756011000055
						],
						[
							-81.58525190699993,
							30.251719011000034
						],
						[
							-81.5850279089999,
							30.25167601000004
						],
						[
							-81.58492690799994,
							30.25166401100006
						],
						[
							-81.58468590699994,
							30.251641011000064
						],
						[
							-81.58428991199992,
							30.251601921000084
						],
						[
							-81.58395090999994,
							30.25156301200008
						],
						[
							-81.58377790899993,
							30.25154301200007
						],
						[
							-81.58348090899995,
							30.25151801200008
						],
						[
							-81.58303890999991,
							30.251464012000042
						],
						[
							-81.58239190899991,
							30.25140001200009
						],
						[
							-81.58205190899992,
							30.251357013000078
						],
						[
							-81.58182390899992,
							30.251329012000046
						],
						[
							-81.58140790999994,
							30.251279012000055
						],
						[
							-81.58013490999991,
							30.25114301200006
						],
						[
							-81.57869490999991,
							30.250981013000057
						],
						[
							-81.57831890999995,
							30.250946013000092
						],
						[
							-81.57731790899993,
							30.250836012000036
						],
						[
							-81.5769479089999,
							30.250793012000088
						],
						[
							-81.5764449099999,
							30.25074401200004
						],
						[
							-81.5759079099999,
							30.250683012000085
						],
						[
							-81.5754889079999,
							30.25063901100009
						],
						[
							-81.57543891199992,
							30.25062401400004
						],
						[
							-81.5750049099999,
							30.250579012000063
						],
						[
							-81.5744929089999,
							30.25052201200009
						],
						[
							-81.57428290999991,
							30.250488012000066
						],
						[
							-81.57400690999992,
							30.25045401300008
						],
						[
							-81.57380990899992,
							30.250443012000066
						],
						[
							-81.57362590999992,
							30.250420013000056
						],
						[
							-81.57333690899992,
							30.250386012000035
						],
						[
							-81.57183890899995,
							30.25021601200007
						],
						[
							-81.57109090999995,
							30.250148012000068
						],
						[
							-81.57097190999991,
							30.25012501300006
						],
						[
							-81.57047290899993,
							30.25009101300009
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Baymeadows",
				"RegionID": "268885"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.13220022999991,
					26.20360853300008,
					-80.12299979899991,
					26.208275522000065
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.12733127599995,
							26.203655603000072
						],
						[
							-80.13126010299993,
							26.20360853300008
						],
						[
							-80.13219336999992,
							26.203659180000045
						],
						[
							-80.13219499999991,
							26.204206000000056
						],
						[
							-80.13220022999991,
							26.20596000000006
						],
						[
							-80.13164599999993,
							26.20596000000006
						],
						[
							-80.13146599999993,
							26.20596000000006
						],
						[
							-80.13118799999995,
							26.205985000000055
						],
						[
							-80.13036599999992,
							26.206060000000036
						],
						[
							-80.1297659999999,
							26.206160000000068
						],
						[
							-80.12971583199993,
							26.20617567700009
						],
						[
							-80.1271257269999,
							26.206985085000042
						],
						[
							-80.12709787199994,
							26.206993790000073
						],
						[
							-80.12656599999991,
							26.207160000000044
						],
						[
							-80.12498099999993,
							26.207673000000057
						],
						[
							-80.12416599999995,
							26.207937000000072
						],
						[
							-80.12316599999991,
							26.208260000000053
						],
						[
							-80.12307675099993,
							26.208275522000065
						],
						[
							-80.12299979899991,
							26.203840873000047
						],
						[
							-80.12733127599995,
							26.203655603000072
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Boulevard Park Isles",
				"RegionID": "268900"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.61210599999993,
					30.21844400000009,
					-81.58898090299994,
					30.23168212800005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.59770990599992,
							30.23109200900007
						],
						[
							-81.59761795799994,
							30.230908832000072
						],
						[
							-81.5962584639999,
							30.231639023000074
						],
						[
							-81.59356854599991,
							30.22764601500006
						],
						[
							-81.59082754699995,
							30.223443155000044
						],
						[
							-81.58898090299994,
							30.220636010000078
						],
						[
							-81.59286290699993,
							30.220604010000045
						],
						[
							-81.59416890799992,
							30.22057701000006
						],
						[
							-81.59473190799991,
							30.22056901000008
						],
						[
							-81.5957529069999,
							30.220556010000053
						],
						[
							-81.59679690699994,
							30.22053201000006
						],
						[
							-81.5969539269999,
							30.220528928000082
						],
						[
							-81.59704988899995,
							30.22057509200005
						],
						[
							-81.59765590699993,
							30.22057301000007
						],
						[
							-81.59812190699995,
							30.220570010000078
						],
						[
							-81.5983419069999,
							30.220554010000058
						],
						[
							-81.59864790899991,
							30.220533011000043
						],
						[
							-81.59883090699992,
							30.220533010000057
						],
						[
							-81.59921290799991,
							30.220530010000065
						],
						[
							-81.59950290799992,
							30.220517010000037
						],
						[
							-81.59986890699993,
							30.220495010000032
						],
						[
							-81.60044090799994,
							30.220421010000052
						],
						[
							-81.60074590699992,
							30.220383010000038
						],
						[
							-81.60172990799992,
							30.220218010000053
						],
						[
							-81.6025539069999,
							30.220081010000058
						],
						[
							-81.60362990699991,
							30.219913010000088
						],
						[
							-81.60441590699992,
							30.21978301100006
						],
						[
							-81.60462990699995,
							30.21974901100009
						],
						[
							-81.60635090799991,
							30.21943301100004
						],
						[
							-81.60688790699993,
							30.219347010000035
						],
						[
							-81.60792190699993,
							30.219164010000046
						],
						[
							-81.60905390799991,
							30.21896701100008
						],
						[
							-81.60990390799992,
							30.21882501100004
						],
						[
							-81.61018390699991,
							30.218777010000053
						],
						[
							-81.6110609079999,
							30.218624010000042
						],
						[
							-81.61210599999993,
							30.21844400000009
						],
						[
							-81.61065418899994,
							30.22115915700005
						],
						[
							-81.60818706399994,
							30.22115886000006
						],
						[
							-81.60818719399992,
							30.222894954000083
						],
						[
							-81.60809598799995,
							30.224448283000072
						],
						[
							-81.60608580899992,
							30.22563607700005
						],
						[
							-81.60462389999992,
							30.22591005100009
						],
						[
							-81.60371007599991,
							30.226275412000064
						],
						[
							-81.60380177699994,
							30.227920174000076
						],
						[
							-81.60307074799994,
							30.228833943000044
						],
						[
							-81.60106049199993,
							30.228924991000042
						],
						[
							-81.60042116799991,
							30.23056985800008
						],
						[
							-81.59825090099991,
							30.23168212800005
						],
						[
							-81.59806090599994,
							30.23153100800005
						],
						[
							-81.5979389069999,
							30.231419007000053
						],
						[
							-81.59781590599994,
							30.231272008000076
						],
						[
							-81.59770990599992,
							30.23109200900007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Brierwood",
				"RegionID": "268903"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.05474458499992,
					26.67573999700005,
					-80.04734467799994,
					26.67972000000009
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.04734679699993,
							26.67580169000007
						],
						[
							-80.04734499999995,
							26.67573999700005
						],
						[
							-80.0482439999999,
							26.675740000000076
						],
						[
							-80.04836425199994,
							26.675739999000086
						],
						[
							-80.04865999999993,
							26.675740000000076
						],
						[
							-80.05015999999995,
							26.675740001000065
						],
						[
							-80.05239999899995,
							26.675800000000038
						],
						[
							-80.05474458499992,
							26.67585431500004
						],
						[
							-80.05474238999994,
							26.67591689300008
						],
						[
							-80.0547376429999,
							26.676052188000085
						],
						[
							-80.05473093099994,
							26.676243470000088
						],
						[
							-80.05472999999995,
							26.67643000000004
						],
						[
							-80.05472999999995,
							26.676506518000053
						],
						[
							-80.05472999999995,
							26.676600000000064
						],
						[
							-80.05472460599992,
							26.676737557000084
						],
						[
							-80.05471898999991,
							26.676880766000068
						],
						[
							-80.05470999999994,
							26.677110000000084
						],
						[
							-80.0547043869999,
							26.67725594400008
						],
						[
							-80.05469704199993,
							26.677446901000053
						],
						[
							-80.05468999999994,
							26.67763000000008
						],
						[
							-80.05468804599991,
							26.677741361000074
						],
						[
							-80.05468385099994,
							26.677980476000073
						],
						[
							-80.05467999999992,
							26.67820000000006
						],
						[
							-80.05467999999992,
							26.678291413000068
						],
						[
							-80.05467999999992,
							26.678400000000067
						],
						[
							-80.0546637249999,
							26.67892893100009
						],
						[
							-80.0546526949999,
							26.679287410000086
						],
						[
							-80.05464289699997,
							26.67960584000008
						],
						[
							-80.05463999999995,
							26.679700000000082
						],
						[
							-80.05460261199994,
							26.67970623100007
						],
						[
							-80.05453419699995,
							26.679717634000042
						],
						[
							-80.05439595399992,
							26.67972000000009
						],
						[
							-80.05422853399995,
							26.67972000000009
						],
						[
							-80.05417999999992,
							26.67972000000009
						],
						[
							-80.05402099199995,
							26.679716168000084
						],
						[
							-80.05346515999992,
							26.67970277500007
						],
						[
							-80.05300302899991,
							26.679691639000055
						],
						[
							-80.05268160899993,
							26.67968389400005
						],
						[
							-80.05260113299994,
							26.679681955000035
						],
						[
							-80.0525199999999,
							26.67968000000008
						],
						[
							-80.05240686999991,
							26.679676890000053
						],
						[
							-80.05195852499992,
							26.679664564000063
						],
						[
							-80.05133545899992,
							26.67964743500005
						],
						[
							-80.0507930629999,
							26.679632524000056
						],
						[
							-80.05033096599995,
							26.679619820000084
						],
						[
							-80.0498688699999,
							26.679607117000046
						],
						[
							-80.04967462599991,
							26.679601777000073
						],
						[
							-80.04960999999992,
							26.67960000000005
						],
						[
							-80.04942684899993,
							26.679594912000084
						],
						[
							-80.04915230799992,
							26.67958728600007
						],
						[
							-80.04889784099993,
							26.67958021800007
						],
						[
							-80.04868999999991,
							26.679580000000044
						],
						[
							-80.04854527399993,
							26.679578608000046
						],
						[
							-80.0476354409999,
							26.67957765500006
						],
						[
							-80.0476689599999,
							26.679360577000068
						],
						[
							-80.04759671199992,
							26.677523673000053
						],
						[
							-80.04755561199994,
							26.677382675000047
						],
						[
							-80.0475333409999,
							26.677287166000042
						],
						[
							-80.04752212099993,
							26.677197237000087
						],
						[
							-80.04750897399992,
							26.677019228000063
						],
						[
							-80.04746516499995,
							26.676956661000077
						],
						[
							-80.04739891399993,
							26.676814586000035
						],
						[
							-80.04735834099995,
							26.676663166000083
						],
						[
							-80.04734467799994,
							26.676507000000072
						],
						[
							-80.04734597899994,
							26.676458649000043
						],
						[
							-80.04735297799994,
							26.676328649000084
						],
						[
							-80.0473621349999,
							26.67624025200007
						],
						[
							-80.04737510099994,
							26.676155976000075
						],
						[
							-80.04737855499991,
							26.675989219000087
						],
						[
							-80.0473677089999,
							26.67594222000008
						],
						[
							-80.04735447299993,
							26.67587236900005
						],
						[
							-80.04734679699993,
							26.67580169000007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "West Palm Beach",
				"Name": "Central Park",
				"RegionID": "268917"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.62374774599994,
					30.37431501700007,
					-81.59452095599994,
					30.400778322000065
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-81.60788398599995,
								30.38992529500007
							],
							[
								-81.60782994599992,
								30.389880163000043
							],
							[
								-81.60777960199994,
								30.389830941000074
							],
							[
								-81.60770232699991,
								30.38974923300009
							],
							[
								-81.6075585669999,
								30.38963562400005
							],
							[
								-81.60701278699992,
								30.389361865000065
							],
							[
								-81.60696633899994,
								30.38933683600004
							],
							[
								-81.6068460969999,
								30.38925369400005
							],
							[
								-81.60669006699993,
								30.389125877000087
							],
							[
								-81.60628926599992,
								30.388975576000067
							],
							[
								-81.60602858199991,
								30.38893355400006
							],
							[
								-81.6057603779999,
								30.38890061600006
							],
							[
								-81.60568301399991,
								30.388887668000056
							],
							[
								-81.60560707199994,
								30.388868028000047
							],
							[
								-81.6055331309999,
								30.388841846000048
							],
							[
								-81.60546175199994,
								30.388809320000064
							],
							[
								-81.60493375199991,
								30.38854032000006
							],
							[
								-81.60490205199994,
								30.38852336300005
							],
							[
								-81.60458519499991,
								30.38834560000004
							],
							[
								-81.60444770899994,
								30.38824933700005
							],
							[
								-81.60430749099993,
								30.38812875300005
							],
							[
								-81.60425808299993,
								30.388082917000077
							],
							[
								-81.60418803999994,
								30.388012873000037
							],
							[
								-81.60413262799996,
								30.387985751000087
							],
							[
								-81.6040783389999,
								30.38795683600006
							],
							[
								-81.60395298399993,
								30.38786947400007
							],
							[
								-81.60360825399994,
								30.38758280400009
							],
							[
								-81.60317481399994,
								30.38729147500004
							],
							[
								-81.60066477399995,
								30.385760818000055
							],
							[
								-81.6005549269999,
								30.38568192100007
							],
							[
								-81.60052060799991,
								30.385651601000067
							],
							[
								-81.59923239999995,
								30.38445377800008
							],
							[
								-81.59602208599996,
								30.38317003400004
							],
							[
								-81.59595636299991,
								30.383140649000044
							],
							[
								-81.5958932019999,
								30.383106102000056
							],
							[
								-81.5958330059999,
								30.38306661300004
							],
							[
								-81.59577616199994,
								30.383022436000086
							],
							[
								-81.59572303399995,
								30.382973853000063
							],
							[
								-81.59567396099993,
								30.38292117700007
							],
							[
								-81.59452095599994,
								30.38157961200005
							],
							[
								-81.59507799999994,
								30.38084800000007
							],
							[
								-81.59771004399994,
								30.38081714400005
							],
							[
								-81.59768690899995,
								30.380064012000048
							],
							[
								-81.59767190699995,
								30.379961011000034
							],
							[
								-81.59765590699993,
								30.379929012000048
							],
							[
								-81.59761790899995,
								30.379885013000038
							],
							[
								-81.59719790999992,
								30.379532013000073
							],
							[
								-81.5970918399999,
								30.379431059000066
							],
							[
								-81.59706891099995,
								30.379374011000035
							],
							[
								-81.59706091099991,
								30.379328012000087
							],
							[
								-81.59706090899994,
								30.379005013000043
							],
							[
								-81.59704590899992,
								30.378695013000083
							],
							[
								-81.59702291199994,
								30.37797201400008
							],
							[
								-81.5970479099999,
								30.37786901300007
							],
							[
								-81.59707790899995,
								30.377793012000044
							],
							[
								-81.59711504299992,
								30.37763601300009
							],
							[
								-81.59705390999994,
								30.377247013000044
							],
							[
								-81.59703791099992,
								30.37715001200007
							],
							[
								-81.59703790999993,
								30.37696501200008
							],
							[
								-81.59705390999994,
								30.37682301200004
							],
							[
								-81.59712190999994,
								30.376518012000076
							],
							[
								-81.59716791099994,
								30.376377012000034
							],
							[
								-81.5972289099999,
								30.37624401200009
							],
							[
								-81.59739690999993,
								30.375940013000047
							],
							[
								-81.59764909099994,
								30.375607978000065
							],
							[
								-81.5975489089999,
								30.375546013000076
							],
							[
								-81.5974959099999,
								30.375523011000045
							],
							[
								-81.59730490999993,
								30.37540401200005
							],
							[
								-81.5972059099999,
								30.375330012000063
							],
							[
								-81.59709891099993,
								30.375235012000076
							],
							[
								-81.5970309089999,
								30.37514701500004
							],
							[
								-81.59698473799995,
								30.37511309500007
							],
							[
								-81.59698504099993,
								30.375064989000066
							],
							[
								-81.59693090999991,
								30.37494501000009
							],
							[
								-81.59689291099994,
								30.37477701000006
							],
							[
								-81.59688585399994,
								30.37431501700007
							],
							[
								-81.60732840299994,
								30.374755315000073
							],
							[
								-81.60696280099997,
								30.377770398000052
							],
							[
								-81.60805915799996,
								30.380237421000064
							],
							[
								-81.61271897199993,
								30.381607781000074
							],
							[
								-81.62243872399995,
								30.381190275000048
							],
							[
								-81.6233372179999,
								30.381151681000066
							],
							[
								-81.62344575799995,
								30.38377040100005
							],
							[
								-81.62351785699991,
								30.384143150000057
							],
							[
								-81.62369118999995,
								30.38459367900009
							],
							[
								-81.62371341399995,
								30.38466096400009
							],
							[
								-81.6237302689999,
								30.38472979100004
							],
							[
								-81.62374165099993,
								30.384799732000094
							],
							[
								-81.62374748899994,
								30.384870352000064
							],
							[
								-81.62374774599994,
								30.384941212000058
							],
							[
								-81.6237424219999,
								30.38501187200006
							],
							[
								-81.6237315489999,
								30.38508189400005
							],
							[
								-81.62371519399996,
								30.385150841000044
							],
							[
								-81.62336619399991,
								30.386400841000068
							],
							[
								-81.62334508599992,
								30.38646658600004
							],
							[
								-81.62330338099991,
								30.386563178000078
							],
							[
								-81.62265337999992,
								30.387855178000052
							],
							[
								-81.6226106339999,
								30.38793080800008
							],
							[
								-81.6223116349999,
								30.388404808000075
							],
							[
								-81.6222399209999,
								30.388503073000035
							],
							[
								-81.62221029799991,
								30.388536643000066
							],
							[
								-81.62081129699993,
								30.39004464300007
							],
							[
								-81.62073007299995,
								30.390121920000073
							],
							[
								-81.62060166099991,
								30.39021183500006
							],
							[
								-81.62045958599992,
								30.390278086000077
							],
							[
								-81.62030816499994,
								30.390318659000062
							],
							[
								-81.6201519999999,
								30.390332322000063
							],
							[
								-81.61999583399995,
								30.390318659000062
							],
							[
								-81.61997499599994,
								30.39031473100005
							],
							[
								-81.6179396309999,
								30.38990614100004
							],
							[
								-81.6173203109999,
								30.389939471000048
							],
							[
								-81.61577737099992,
								30.39025296700004
							],
							[
								-81.61476707799994,
								30.39068568600004
							],
							[
								-81.61470074899995,
								30.390711045000046
							],
							[
								-81.61463262599995,
								30.390731092000063
							],
							[
								-81.61456313299993,
								30.390745702000064
							],
							[
								-81.61449270499992,
								30.390754783000038
							],
							[
								-81.61275070499994,
								30.390909783000037
							],
							[
								-81.61267099999992,
								30.390913322000078
							],
							[
								-81.61250940799994,
								30.390898668000094
							],
							[
								-81.60826598099993,
								30.390096677000088
							],
							[
								-81.60819736299993,
								30.39008090300007
							],
							[
								-81.60813018899995,
								30.390059810000082
							],
							[
								-81.6080648709999,
								30.390033525000035
							],
							[
								-81.6080018099999,
								30.39000221200007
							],
							[
								-81.60794139099994,
								30.389966061000052
							],
							[
								-81.60788398599995,
								30.38992529500007
							]
						]
					],
					[
						[
							[
								-81.6110773389999,
								30.396023165000088
							],
							[
								-81.61121941299992,
								30.39595691400007
							],
							[
								-81.6113708339999,
								30.395916341000085
							],
							[
								-81.61152699999991,
								30.395902678000084
							],
							[
								-81.6115554829999,
								30.395903129000093
							],
							[
								-81.61175634099993,
								30.395907929000092
							],
							[
								-81.61191599999995,
								30.39589367800005
							],
							[
								-81.61200999999994,
								30.39589367800005
							],
							[
								-81.61216616599995,
								30.395907341000058
							],
							[
								-81.61230859599993,
								30.395945505000046
							],
							[
								-81.61239816599993,
								30.395953341000055
							],
							[
								-81.61254893199992,
								30.395993739000062
							],
							[
								-81.6125865329999,
								30.395989064000048
							],
							[
								-81.61260932599993,
								30.39598740000008
							],
							[
								-81.61263685199994,
								30.395978090000085
							],
							[
								-81.61275170199991,
								30.395948722000075
							],
							[
								-81.61282507999994,
								30.395843927000044
							],
							[
								-81.61292229599991,
								30.395744751000052
							],
							[
								-81.61302411199995,
								30.39565591500008
							],
							[
								-81.61307021899995,
								30.39562218100008
							],
							[
								-81.6131166159999,
								30.39556093400006
							],
							[
								-81.61316813699995,
								30.395503929000085
							],
							[
								-81.61322439499992,
								30.39545159400006
							],
							[
								-81.61328496999994,
								30.395404321000058
							],
							[
								-81.61334940599994,
								30.395362464000073
							],
							[
								-81.6134172209999,
								30.395326338000075
							],
							[
								-81.61348790599993,
								30.395296212000062
							],
							[
								-81.61352014999994,
								30.395274717000063
							],
							[
								-81.6135723889999,
								30.39524246500008
							],
							[
								-81.61362668999993,
								30.395213820000038
							],
							[
								-81.61368280399995,
								30.395188913000084
							],
							[
								-81.61374047399994,
								30.39516785700005
							],
							[
								-81.61382708299993,
								30.39510452100006
							],
							[
								-81.61384367699992,
								30.395086829000032
							],
							[
								-81.6138758219999,
								30.395060184000045
							],
							[
								-81.61391523399993,
								30.39500371800006
							],
							[
								-81.6139591139999,
								30.39495064900007
							],
							[
								-81.6140071719999,
								30.394901331000085
							],
							[
								-81.61405908699993,
								30.39485609200005
							],
							[
								-81.61411451499993,
								30.394815233000088
							],
							[
								-81.61417308699993,
								30.394779024000062
							],
							[
								-81.61426330099994,
								30.394728063000063
							],
							[
								-81.61430373999991,
								30.394696138000086
							],
							[
								-81.61435971799995,
								30.39465534300007
							],
							[
								-81.6144186699999,
								30.394618977000047
							],
							[
								-81.61448024599991,
								30.394587257000072
							],
							[
								-81.61454407999992,
								30.394560369000086
							],
							[
								-81.61460979499992,
								30.394538474000058
							],
							[
								-81.6147441789999,
								30.39449938100006
							],
							[
								-81.6148971209999,
								30.394419614000075
							],
							[
								-81.6149572249999,
								30.394391043000045
							],
							[
								-81.61501927799992,
								30.394366996000084
							],
							[
								-81.61508293899993,
								30.39434760300008
							],
							[
								-81.61514785999992,
								30.39433297000005
							],
							[
								-81.6152136849999,
								30.394323179000086
							],
							[
								-81.6153727649999,
								30.394304883000075
							],
							[
								-81.61552575099995,
								30.394237189000084
							],
							[
								-81.6155834139999,
								30.394213914000094
							],
							[
								-81.61574248399995,
								30.39417220200005
							],
							[
								-81.6157830009999,
								30.394159064000064
							],
							[
								-81.61593406899993,
								30.394118476000074
							],
							[
								-81.61598402399994,
								30.39410962300008
							],
							[
								-81.61600975199991,
								30.394098188000044
							],
							[
								-81.61615102999991,
								30.39404901300009
							],
							[
								-81.61625602999993,
								30.39402201300004
							],
							[
								-81.61632383499996,
								30.39400734000009
							],
							[
								-81.6164142849999,
								30.393999427000043
							],
							[
								-81.61648995099995,
								30.393981645000054
							],
							[
								-81.61662310999992,
								30.393934723000086
							],
							[
								-81.61678299099992,
								30.39386488100007
							],
							[
								-81.61692209899991,
								30.393817230000085
							],
							[
								-81.6169716679999,
								30.393802136000094
							],
							[
								-81.61711941399994,
								30.393731914000057
							],
							[
								-81.61715155899992,
								30.393720897000037
							],
							[
								-81.61726655899992,
								30.393683897000077
							],
							[
								-81.6173670899999,
								30.393657852000047
							],
							[
								-81.61747061799991,
								30.393637324000057
							],
							[
								-81.61749472499991,
								30.39362535800007
							],
							[
								-81.61778872499991,
								30.393504358000087
							],
							[
								-81.61785389799991,
								30.393480433000033
							],
							[
								-81.61792072299994,
								30.393461607000063
							],
							[
								-81.61798880099991,
								30.393447991000073
							],
							[
								-81.6180577259999,
								30.39343966800004
							],
							[
								-81.61812708799994,
								30.393436686000083
							],
							[
								-81.6181964729999,
								30.393439064000066
							],
							[
								-81.61833347299995,
								30.393449065000084
							],
							[
								-81.6184241659999,
								30.393460341000036
							],
							[
								-81.6185755859999,
								30.39350091400007
							],
							[
								-81.61871766099995,
								30.393567165000032
							],
							[
								-81.61884607299993,
								30.393657080000086
							],
							[
								-81.61895692099995,
								30.393767927000056
							],
							[
								-81.61898275099992,
								30.393800188000053
							],
							[
								-81.61902475099993,
								30.393855187000046
							],
							[
								-81.61908883599995,
								30.39395133900007
							],
							[
								-81.61915508699991,
								30.394093414000054
							],
							[
								-81.61919565999995,
								30.394244835000052
							],
							[
								-81.6192093219999,
								30.394401000000073
							],
							[
								-81.61919565999995,
								30.394557166000084
							],
							[
								-81.61915508699991,
								30.394708587000082
							],
							[
								-81.6191006379999,
								30.39482957000007
							],
							[
								-81.61898463799992,
								30.395043570000045
							],
							[
								-81.61894850699991,
								30.39510438700006
							],
							[
								-81.61890770799994,
								30.395162176000042
							],
							[
								-81.61886249399993,
								30.395216579000078
							],
							[
								-81.6188131429999,
								30.395267260000082
							],
							[
								-81.61875996099991,
								30.395313906000066
							],
							[
								-81.61870327799994,
								30.395356227000036
							],
							[
								-81.61855627699993,
								30.395457227000065
							],
							[
								-81.61849744299992,
								30.39549558900006
							],
							[
								-81.6184353559999,
								30.395528428000038
							],
							[
								-81.61837053399996,
								30.395555470000094
							],
							[
								-81.6183035169999,
								30.395576491000043
							],
							[
								-81.61825466099992,
								30.395606836000074
							],
							[
								-81.61822230299992,
								30.395622264000053
							],
							[
								-81.61816706099995,
								30.395670758000055
							],
							[
								-81.61805809499992,
								30.395809678000035
							],
							[
								-81.61800247899993,
								30.395904373000064
							],
							[
								-81.61793896499995,
								30.395993972000042
							],
							[
								-81.61790749299992,
								30.396052401000077
							],
							[
								-81.6178717979999,
								30.396108350000077
							],
							[
								-81.61783207399992,
								30.396161514000088
							],
							[
								-81.6177885379999,
								30.396211604000086
							],
							[
								-81.61774142599995,
								30.39625834700007
							],
							[
								-81.61749942599994,
								30.396481347000076
							],
							[
								-81.61746807299994,
								30.396508921000077
							],
							[
								-81.61733471799994,
								30.396601648000058
							],
							[
								-81.61686777299991,
								30.396863461000066
							],
							[
								-81.61673558599995,
								30.39692408700006
							],
							[
								-81.61670833199992,
								30.396933514000068
							],
							[
								-81.61650144899994,
								30.397001384000074
							],
							[
								-81.61646166999992,
								30.397019380000078
							],
							[
								-81.61640354799994,
								30.39704407100004
							],
							[
								-81.61634364899993,
								30.397064067000088
							],
							[
								-81.61628234999995,
								30.397079242000075
							],
							[
								-81.61622003999992,
								30.397089499000064
							],
							[
								-81.61617136399991,
								30.39710769200008
							],
							[
								-81.6160641159999,
								30.397136811000056
							],
							[
								-81.61604058599994,
								30.397147086000075
							],
							[
								-81.6159286379999,
								30.39717952600006
							],
							[
								-81.61566103799993,
								30.39736903700009
							],
							[
								-81.61557047999992,
								30.397448814000086
							],
							[
								-81.61553117099993,
								30.397484123000083
							],
							[
								-81.6154888069999,
								30.397515701000092
							],
							[
								-81.61544373999993,
								30.397543286000086
							],
							[
								-81.6153963459999,
								30.397566648000065
							],
							[
								-81.61533307299993,
								30.39762992100009
							],
							[
								-81.61523502199992,
								30.397698577000085
							],
							[
								-81.61510711699992,
								30.39781113400005
							],
							[
								-81.61505259099994,
								30.397855460000077
							],
							[
								-81.61497121699995,
								30.397916489000067
							],
							[
								-81.61492307299994,
								30.39796392000005
							],
							[
								-81.61486636799992,
								30.39800362600005
							],
							[
								-81.6148165159999,
								30.398054933000083
							],
							[
								-81.6147625719999,
								30.398101919000055
							],
							[
								-81.6147049089999,
								30.39814425900005
							],
							[
								-81.61464392599993,
								30.398181658000055
							],
							[
								-81.61458004499991,
								30.398213859000066
							],
							[
								-81.61451370799995,
								30.398240638000065
							],
							[
								-81.6144861759999,
								30.398259327000062
							],
							[
								-81.61441885399995,
								30.398302566000044
							],
							[
								-81.61434795499991,
								30.398339650000082
							],
							[
								-81.61427403999994,
								30.398370285000055
							],
							[
								-81.61419769499992,
								30.398394230000065
							],
							[
								-81.61413280699992,
								30.398411451000072
							],
							[
								-81.61411166099992,
								30.398424835000075
							],
							[
								-81.6140777789999,
								30.398440635000046
							],
							[
								-81.61401700699993,
								30.398494578000054
							],
							[
								-81.61399807299995,
								30.39851092000004
							],
							[
								-81.61392645699993,
								30.398561066000074
							],
							[
								-81.61388719999991,
								30.398609597000075
							],
							[
								-81.61387462399995,
								30.398624369000064
							],
							[
								-81.61385512599992,
								30.398663912000078
							],
							[
								-81.61381148099991,
								30.398740786000076
							],
							[
								-81.61371991999994,
								30.398872073000064
							],
							[
								-81.61368018899994,
								30.398916361000094
							],
							[
								-81.61356418899993,
								30.399037362000062
							],
							[
								-81.61349307299992,
								30.399103921000066
							],
							[
								-81.61344886699993,
								30.39913487400008
							],
							[
								-81.61340544099994,
								30.399189438000068
							],
							[
								-81.61335764199993,
								30.399240214000088
							],
							[
								-81.61330579999992,
								30.39928685400008
							],
							[
								-81.61325026999992,
								30.39932903700009
							],
							[
								-81.61319143599991,
								30.399366473000043
							],
							[
								-81.61299954799995,
								30.399479154000066
							],
							[
								-81.61285458599991,
								30.399547086000045
							],
							[
								-81.61280341699995,
								30.399563992000083
							],
							[
								-81.61264541699991,
								30.399610992000078
							],
							[
								-81.61254071799993,
								30.399635289000056
							],
							[
								-81.61248658599993,
								30.39965908700009
							],
							[
								-81.61236225899995,
								30.399694453000052
							],
							[
								-81.61225941399994,
								30.399715859000082
							],
							[
								-81.61218158699995,
								30.399751086000034
							],
							[
								-81.61215954699992,
								30.39975878600006
							],
							[
								-81.61206605099994,
								30.399792061000085
							],
							[
								-81.61191858599994,
								30.39986208600004
							],
							[
								-81.61181491799994,
								30.399891374000052
							],
							[
								-81.61169758599993,
								30.399946086000057
							],
							[
								-81.61160253799994,
								30.39997155400005
							],
							[
								-81.61151108399991,
								30.400016760000085
							],
							[
								-81.6114186829999,
								30.400080874000082
							],
							[
								-81.61135566099995,
								30.400120835000056
							],
							[
								-81.6112668799999,
								30.40016573800006
							],
							[
								-81.61121058499992,
								30.400190401000092
							],
							[
								-81.61106743399995,
								30.40027447300008
							],
							[
								-81.61094220399991,
								30.40033550700008
							],
							[
								-81.61080784599994,
								30.40038854400007
							],
							[
								-81.61066108799992,
								30.400470404000092
							],
							[
								-81.61051865299994,
								30.40053433500009
							],
							[
								-81.61036065299993,
								30.400589335000063
							],
							[
								-81.61021552599993,
								30.400626452000044
							],
							[
								-81.61018668899993,
								30.400637502000052
							],
							[
								-81.61013058599991,
								30.400660086000073
							],
							[
								-81.61000151699994,
								30.40069642600008
							],
							[
								-81.60968551699996,
								30.40076042600009
							],
							[
								-81.6096631659999,
								30.400764659000064
							],
							[
								-81.60950699999995,
								30.400778322000065
							],
							[
								-81.6092549999999,
								30.400778322000065
							],
							[
								-81.60916501999992,
								30.400773809000043
							],
							[
								-81.60898601999992,
								30.40075580900009
							],
							[
								-81.60891240199993,
								30.40074531700009
							],
							[
								-81.60871240199992,
								30.40070831700007
							],
							[
								-81.60863241599992,
								30.400689706000037
							],
							[
								-81.60810641599994,
								30.40054170600007
							],
							[
								-81.6080262289999,
								30.400515019000068
							],
							[
								-81.60778522999993,
								30.400422019000075
							],
							[
								-81.60771223099994,
								30.400390065000067
							],
							[
								-81.60735423099993,
								30.40021406500006
							],
							[
								-81.60730133899995,
								30.40018583600005
							],
							[
								-81.60720906799992,
								30.40012469800007
							],
							[
								-81.60706206799995,
								30.400013698000063
							],
							[
								-81.6069680789999,
								30.399931913000046
							],
							[
								-81.60688407999993,
								30.399847913000087
							],
							[
								-81.6068398409999,
								30.399800356000075
							],
							[
								-81.60679914899993,
								30.399749730000057
							],
							[
								-81.60676221799991,
								30.399696299000084
							],
							[
								-81.60672923899995,
								30.39964034200006
							],
							[
								-81.6067003849999,
								30.399582151000065
							],
							[
								-81.60665838499995,
								30.399489151000072
							],
							[
								-81.60662998399994,
								30.39941841500007
							],
							[
								-81.6066076749999,
								30.39934552700004
							],
							[
								-81.60659161799992,
								30.39927101300009
							],
							[
								-81.60658192999995,
								30.399195406000047
							],
							[
								-81.60657092999993,
								30.399066406000088
							],
							[
								-81.60656767799992,
								30.398990000000083
							],
							[
								-81.60658134099994,
								30.39883383400007
							],
							[
								-81.6066219139999,
								30.398682413000074
							],
							[
								-81.60668816499992,
								30.39854033900008
							],
							[
								-81.60678292199992,
								30.39840625300008
							],
							[
								-81.60683020499994,
								30.39835166900008
							],
							[
								-81.60694666899992,
								30.39814031100008
							],
							[
								-81.60704107899994,
								30.398003927000047
							],
							[
								-81.6071519269999,
								30.397893079000088
							],
							[
								-81.60728033899994,
								30.397803164000035
							],
							[
								-81.60742241399993,
								30.397736913000074
							],
							[
								-81.60753491399993,
								30.397704092000087
							],
							[
								-81.60755901999994,
								30.39769873500006
							],
							[
								-81.60758102099993,
								30.397688114000058
							],
							[
								-81.60766441399994,
								30.397652914000044
							],
							[
								-81.60772365799994,
								30.39763704000006
							],
							[
								-81.6077926399999,
								30.397594337000044
							],
							[
								-81.60785312899992,
								30.397560053000063
							],
							[
								-81.60791608499994,
								30.397530544000066
							],
							[
								-81.6079811329999,
								30.397505988000038
							],
							[
								-81.60804788299993,
								30.397486530000037
							],
							[
								-81.6084158829999,
								30.397394530000042
							],
							[
								-81.60847783499992,
								30.397381341000084
							],
							[
								-81.60860831799994,
								30.397369925000078
							],
							[
								-81.60864460699993,
								30.397357829000043
							],
							[
								-81.60877283499991,
								30.39732534000007
							],
							[
								-81.60879345099994,
								30.397323537000094
							],
							[
								-81.60888251499995,
								30.397295006000036
							],
							[
								-81.60896615699994,
								30.39725812400008
							],
							[
								-81.6090296289999,
								30.39723084200006
							],
							[
								-81.6090955869999,
								30.39721028400004
							],
							[
								-81.60916331999994,
								30.397196673000053
							],
							[
								-81.60923209999993,
								30.397190156000082
							],
							[
								-81.60935083399994,
								30.39715834100008
							],
							[
								-81.60951429199991,
								30.39714467800007
							],
							[
								-81.60954641399991,
								30.39713391300006
							],
							[
								-81.6096389839999,
								30.397109109000045
							],
							[
								-81.60973321099993,
								30.397038439000085
							],
							[
								-81.60977254799992,
								30.39698681700008
							],
							[
								-81.60981579399993,
								30.396938422000062
							],
							[
								-81.60986268399995,
								30.396893550000073
							],
							[
								-81.60991293299992,
								30.39685247300008
							],
							[
								-81.60996623499994,
								30.396815443000033
							],
							[
								-81.61005669499991,
								30.396757045000072
							],
							[
								-81.61016595899991,
								30.39665493500007
							],
							[
								-81.61020192699993,
								30.39662307900005
							],
							[
								-81.61029633099992,
								30.39655381400007
							],
							[
								-81.61032353199994,
								30.396536462000086
							],
							[
								-81.61037622499992,
								30.396482096000057
							],
							[
								-81.61042427799993,
								30.396436048000055
							],
							[
								-81.61047560799994,
								30.396393683000046
							],
							[
								-81.61052993299995,
								30.396355233000065
							],
							[
								-81.61058695399993,
								30.396320909000057
							],
							[
								-81.61064194799991,
								30.39627616800004
							],
							[
								-81.61070042499995,
								30.396236084000066
							],
							[
								-81.61076198899991,
								30.39620092800004
							],
							[
								-81.61082622799995,
								30.396170935000043
							],
							[
								-81.61089270799994,
								30.39614630800008
							],
							[
								-81.61101916699994,
								30.39605978300006
							],
							[
								-81.6110773389999,
								30.396023165000088
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Charter Point",
				"RegionID": "268918"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.8694950389999,
					30.18801799900007,
					-81.76381496599993,
					30.232699151000077
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.81852978799992,
							30.232699151000077
						],
						[
							-81.81756303799995,
							30.22802187200006
						],
						[
							-81.8082229119999,
							30.226343024000073
						],
						[
							-81.8084869079999,
							30.224348010000085
						],
						[
							-81.80850790799991,
							30.224265010000067
						],
						[
							-81.80858490799994,
							30.224075011000085
						],
						[
							-81.80862290799992,
							30.224009011000078
						],
						[
							-81.8087579079999,
							30.22385101100008
						],
						[
							-81.80908090799994,
							30.22357901000004
						],
						[
							-81.80925590699991,
							30.223432011000057
						],
						[
							-81.80956990699991,
							30.223188010000058
						],
						[
							-81.81117690699995,
							30.221930011000037
						],
						[
							-81.8147029079999,
							30.21919901100006
						],
						[
							-81.81544908899991,
							30.218631019000046
						],
						[
							-81.81284868799992,
							30.21610509600003
						],
						[
							-81.81284902999994,
							30.214810621000087
						],
						[
							-81.81038969499991,
							30.212221856000042
						],
						[
							-81.8067653249999,
							30.21183383800007
						],
						[
							-81.8066361679999,
							30.20743283000007
						],
						[
							-81.80443552199995,
							30.20730365300005
						],
						[
							-81.80443582899994,
							30.204585333000065
						],
						[
							-81.80352967699991,
							30.203938082000032
						],
						[
							-81.7722288999999,
							30.203915024000086
						],
						[
							-81.77210590899995,
							30.203747012000065
						],
						[
							-81.77206090699991,
							30.203691011000043
						],
						[
							-81.76883483199992,
							30.199588044000052
						],
						[
							-81.76838472799994,
							30.196406966000037
						],
						[
							-81.77113707399991,
							30.192569064000054
						],
						[
							-81.77113706999995,
							30.19243591700007
						],
						[
							-81.77100595099995,
							30.192358840000054
						],
						[
							-81.7686638639999,
							30.19255018000007
						],
						[
							-81.76446890799991,
							30.18990301000008
						],
						[
							-81.76381496599993,
							30.189339000000075
						],
						[
							-81.76451999999995,
							30.189339000000075
						],
						[
							-81.7721249999999,
							30.18925300000007
						],
						[
							-81.77276899999993,
							30.189246000000082
						],
						[
							-81.77341999999994,
							30.189239000000043
						],
						[
							-81.7872769999999,
							30.189140000000066
						],
						[
							-81.79185199999995,
							30.189096000000063
						],
						[
							-81.7923649999999,
							30.189091000000076
						],
						[
							-81.79244899999993,
							30.189091000000076
						],
						[
							-81.7940539999999,
							30.189092000000073
						],
						[
							-81.7941219999999,
							30.189092000000073
						],
						[
							-81.79419399999995,
							30.189091000000076
						],
						[
							-81.79424999999992,
							30.189091000000076
						],
						[
							-81.79431699999992,
							30.18909000000008
						],
						[
							-81.79773899999992,
							30.189066000000086
						],
						[
							-81.79816299999993,
							30.189071000000073
						],
						[
							-81.79896688299993,
							30.189083048000047
						],
						[
							-81.79907907599994,
							30.189084730000047
						],
						[
							-81.79910442399995,
							30.18908511000006
						],
						[
							-81.80223299999994,
							30.189132000000086
						],
						[
							-81.80282299999993,
							30.189141000000063
						],
						[
							-81.80311099999994,
							30.18913500000008
						],
						[
							-81.80405999999994,
							30.189118000000068
						],
						[
							-81.80500799999993,
							30.189102000000048
						],
						[
							-81.80526299999991,
							30.18909700000006
						],
						[
							-81.80551899999995,
							30.18909300000007
						],
						[
							-81.8153118489999,
							30.18892779500004
						],
						[
							-81.81550191799994,
							30.188924588000077
						],
						[
							-81.82650299999995,
							30.18873900000006
						],
						[
							-81.82653299999993,
							30.18873900000006
						],
						[
							-81.82969099999991,
							30.188706000000078
						],
						[
							-81.8375979999999,
							30.18862400000006
						],
						[
							-81.84104428699993,
							30.188588362000072
						],
						[
							-81.8410785509999,
							30.188588008000067
						],
						[
							-81.85161999999991,
							30.188479000000086
						],
						[
							-81.8517579999999,
							30.18847800000009
						],
						[
							-81.8524119999999,
							30.188471000000053
						],
						[
							-81.85318999999993,
							30.188368000000086
						],
						[
							-81.85331139499993,
							30.18836514100008
						],
						[
							-81.86804799999993,
							30.188018000000056
						],
						[
							-81.86804805199995,
							30.18801799900007
						],
						[
							-81.8680520339999,
							30.18805087400006
						],
						[
							-81.8682227779999,
							30.192770141000043
						],
						[
							-81.8694950389999,
							30.19275287400006
						],
						[
							-81.86940603999994,
							30.202499138000064
						],
						[
							-81.86542076099994,
							30.202686913000036
						],
						[
							-81.8654809549999,
							30.202837990000035
						],
						[
							-81.86549990599991,
							30.203314009000053
						],
						[
							-81.86547890599991,
							30.20512900900008
						],
						[
							-81.86548704099994,
							30.20638913600004
						],
						[
							-81.86009877199992,
							30.206676875000085
						],
						[
							-81.85996904199993,
							30.20974314100005
						],
						[
							-81.85309976899993,
							30.210239878000042
						],
						[
							-81.85302898499992,
							30.21424103000004
						],
						[
							-81.8529609069999,
							30.214353009000035
						],
						[
							-81.85292685399992,
							30.214452999000063
						],
						[
							-81.8529199059999,
							30.214582008000036
						],
						[
							-81.85291703599995,
							30.215821142000035
						],
						[
							-81.8527669049999,
							30.215813008000055
						],
						[
							-81.84977190599994,
							30.215895009000064
						],
						[
							-81.84472490499991,
							30.216018009000038
						],
						[
							-81.8446167699999,
							30.216034870000044
						],
						[
							-81.84460290699991,
							30.216112009000085
						],
						[
							-81.84454590599995,
							30.224097009000047
						],
						[
							-81.84441090599995,
							30.228707009000065
						],
						[
							-81.84440199599993,
							30.22893506400004
						],
						[
							-81.84435385699993,
							30.22895594200008
						],
						[
							-81.84429182899993,
							30.229037971000082
						],
						[
							-81.84414090599995,
							30.229653009000057
						],
						[
							-81.84389890599994,
							30.230911008000078
						],
						[
							-81.84380890499995,
							30.232204009000043
						],
						[
							-81.84379003099991,
							30.232303055000045
						],
						[
							-81.84372801599994,
							30.232400144000053
						],
						[
							-81.8436739039999,
							30.23242000500005
						],
						[
							-81.84295690599993,
							30.232435008000035
						],
						[
							-81.84250590499994,
							30.23242800800006
						],
						[
							-81.8405839049999,
							30.232443008000075
						],
						[
							-81.83768490499995,
							30.232450008000058
						],
						[
							-81.83622690599992,
							30.232479009000087
						],
						[
							-81.83457190599995,
							30.232525008000042
						],
						[
							-81.83188390499993,
							30.23256300800006
						],
						[
							-81.83161890499991,
							30.23256700800005
						],
						[
							-81.8303379059999,
							30.232582008000065
						],
						[
							-81.82998690599993,
							30.232578008000075
						],
						[
							-81.8277679059999,
							30.232573009000077
						],
						[
							-81.82360090499992,
							30.232645008000077
						],
						[
							-81.8233339059999,
							30.232643008000082
						],
						[
							-81.81852978799992,
							30.232699151000077
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Chimney Lakes",
				"RegionID": "268919"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.18579571599992,
					26.09582180400008,
					-80.17950416199994,
					26.10306644900004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.18291279599993,
							26.09582180400008
						],
						[
							-80.18380756299992,
							26.09582180400008
						],
						[
							-80.18567999999993,
							26.09584230500008
						],
						[
							-80.18567999999993,
							26.09615480700006
						],
						[
							-80.18567999999993,
							26.096520000000055
						],
						[
							-80.18569686399991,
							26.096933180000065
						],
						[
							-80.18569999999994,
							26.097240000000056
						],
						[
							-80.18570809599993,
							26.09784717100007
						],
						[
							-80.18571417699991,
							26.098286560000076
						],
						[
							-80.18573031299991,
							26.099066122000067
						],
						[
							-80.18574343599994,
							26.09967456000004
						],
						[
							-80.1857473959999,
							26.099979518000055
						],
						[
							-80.18575472799995,
							26.10052045000009
						],
						[
							-80.18575754799991,
							26.100723457000072
						],
						[
							-80.18576999999993,
							26.10106176100004
						],
						[
							-80.1857773509999,
							26.10150139900009
						],
						[
							-80.18577999999991,
							26.101840105000065
						],
						[
							-80.18577999999991,
							26.102110834000086
						],
						[
							-80.18578908099994,
							26.102618800000073
						],
						[
							-80.18579571599992,
							26.102933187000076
						],
						[
							-80.18525900299994,
							26.103024409000056
						],
						[
							-80.17967462699994,
							26.10306644900004
						],
						[
							-80.1796738779999,
							26.10115933600008
						],
						[
							-80.17962082499992,
							26.09953118100009
						],
						[
							-80.17961781999992,
							26.099409000000037
						],
						[
							-80.17970910399993,
							26.09634833800004
						],
						[
							-80.17951498399994,
							26.096313162000058
						],
						[
							-80.17950416199994,
							26.09599933700008
						],
						[
							-80.1809457299999,
							26.09594252700009
						],
						[
							-80.18172687599991,
							26.095878615000064
						],
						[
							-80.18291279599993,
							26.09582180400008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Chula Vista",
				"RegionID": "268920"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.74307290599995,
					30.247275864000073,
					-81.7244419999999,
					30.268053009000084
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.72982849199991,
							30.266634470000042
						],
						[
							-81.72981867999994,
							30.266568322000065
						],
						[
							-81.72966899999994,
							30.266568322000065
						],
						[
							-81.72959351599991,
							30.266565148000044
						],
						[
							-81.72951856399993,
							30.26655565000004
						],
						[
							-81.72944467399992,
							30.26653989500005
						],
						[
							-81.72937236799993,
							30.266517993000036
						],
						[
							-81.72930215399994,
							30.266490099000066
						],
						[
							-81.72923452999993,
							30.266456411000036
						],
						[
							-81.72916997199992,
							30.266417165000064
						],
						[
							-81.72910893599993,
							30.266372639000057
						],
						[
							-81.72678593599994,
							30.26452363900006
						],
						[
							-81.72673997699991,
							30.264484467000045
						],
						[
							-81.7266967509999,
							30.264442299000056
						],
						[
							-81.72665645199993,
							30.264397325000065
						],
						[
							-81.72661926199993,
							30.264349747000043
						],
						[
							-81.72653211399995,
							30.26423019200007
						],
						[
							-81.72615382999993,
							30.26401121400005
						],
						[
							-81.7254392449999,
							30.263938731000056
						],
						[
							-81.72540717399994,
							30.263934895000038
						],
						[
							-81.72476690399992,
							30.263846622000074
						],
						[
							-81.72468798199992,
							30.263894575000055
						],
						[
							-81.7246266759999,
							30.263928625000062
						],
						[
							-81.72456290299993,
							30.26395779400008
						],
						[
							-81.72455811999993,
							30.263959545000034
						],
						[
							-81.7244419999999,
							30.262894000000077
						],
						[
							-81.72725708599995,
							30.259166974000035
						],
						[
							-81.7268369059999,
							30.258928008000055
						],
						[
							-81.72631072599995,
							30.25860205400005
						],
						[
							-81.72678390599992,
							30.257788008000038
						],
						[
							-81.72698990499993,
							30.25747300900008
						],
						[
							-81.72731790599994,
							30.256939008000078
						],
						[
							-81.72740890599994,
							30.25682600900007
						],
						[
							-81.72766090599994,
							30.25651700900005
						],
						[
							-81.72781390599994,
							30.25637100800009
						],
						[
							-81.72819490599994,
							30.256073009000094
						],
						[
							-81.72866790499995,
							30.25577200800007
						],
						[
							-81.7290419059999,
							30.255547008000065
						],
						[
							-81.72991890599991,
							30.255016009000087
						],
						[
							-81.73021190599991,
							30.25482800700007
						],
						[
							-81.73043690199995,
							30.25464000900007
						],
						[
							-81.73058790499994,
							30.254422008000063
						],
						[
							-81.73066490499991,
							30.25425700800008
						],
						[
							-81.73068990399992,
							30.254174010000042
						],
						[
							-81.73071190499991,
							30.253939009000078
						],
						[
							-81.73069990699992,
							30.25361400800006
						],
						[
							-81.73070490599991,
							30.253563008000075
						],
						[
							-81.73069790599993,
							30.25267000900004
						],
						[
							-81.73070490599991,
							30.251093009000044
						],
						[
							-81.73069790599993,
							30.250504009000057
						],
						[
							-81.7307129049999,
							30.249828008000065
						],
						[
							-81.73069790599993,
							30.249197009000053
						],
						[
							-81.73070490599991,
							30.248566009000058
						],
						[
							-81.73069790599993,
							30.248407008000076
						],
						[
							-81.73068990599995,
							30.24793400900006
						],
						[
							-81.73069790499994,
							30.24736995300009
						],
						[
							-81.73156690499991,
							30.247360008000044
						],
						[
							-81.7319949059999,
							30.24734500900007
						],
						[
							-81.73257390599991,
							30.247335008000054
						],
						[
							-81.73303190599995,
							30.24734100800003
						],
						[
							-81.73329190499993,
							30.247360008000044
						],
						[
							-81.73368090499991,
							30.247381009000037
						],
						[
							-81.73390990599995,
							30.247408008000036
						],
						[
							-81.73428490499992,
							30.247481008000076
						],
						[
							-81.73468790599992,
							30.247561009000037
						],
						[
							-81.73490090599995,
							30.24762700900004
						],
						[
							-81.73503100499995,
							30.247683147000092
						],
						[
							-81.73500077099993,
							30.247323879000078
						],
						[
							-81.7353309049999,
							30.24732200900007
						],
						[
							-81.73631290499992,
							30.247311008000054
						],
						[
							-81.73687690499992,
							30.247305009000062
						],
						[
							-81.73826590499993,
							30.247295008000034
						],
						[
							-81.73850990499994,
							30.24729300800004
						],
						[
							-81.73874702699993,
							30.247275864000073
						],
						[
							-81.73875390599994,
							30.247351008000066
						],
						[
							-81.73882290599994,
							30.24760800900009
						],
						[
							-81.7388839059999,
							30.247910009000066
						],
						[
							-81.73895990599993,
							30.24820100800008
						],
						[
							-81.73899790599995,
							30.24830400900004
						],
						[
							-81.73902078599991,
							30.24840015600006
						],
						[
							-81.7396769049999,
							30.24841300800006
						],
						[
							-81.74018090599992,
							30.24839800900008
						],
						[
							-81.74267590599993,
							30.248425008000083
						],
						[
							-81.74294890399995,
							30.248420954000043
						],
						[
							-81.7429477359999,
							30.24849605500009
						],
						[
							-81.74306107599995,
							30.24867096100007
						],
						[
							-81.74305690599994,
							30.248987009000075
						],
						[
							-81.74306490499993,
							30.249325008000085
						],
						[
							-81.74305690599994,
							30.25023700800006
						],
						[
							-81.74307290599995,
							30.25115600900006
						],
						[
							-81.74306490499993,
							30.251467008000073
						],
						[
							-81.74307290599995,
							30.252047009000083
						],
						[
							-81.74305690599994,
							30.252518008000038
						],
						[
							-81.7430499059999,
							30.253033008000045
						],
						[
							-81.74303390599995,
							30.25344300800009
						],
						[
							-81.74301890499993,
							30.25365800900005
						],
						[
							-81.74294290499995,
							30.25428400800007
						],
						[
							-81.74290490499993,
							30.254595008000084
						],
						[
							-81.74283590699991,
							30.254906008000034
						],
						[
							-81.74279790499992,
							30.255219008000036
						],
						[
							-81.7427139049999,
							30.25553500800004
						],
						[
							-81.7426449059999,
							30.25585000900008
						],
						[
							-81.7425359049999,
							30.256260009000076
						],
						[
							-81.7423779049999,
							30.256794008000046
						],
						[
							-81.7422639049999,
							30.257101009000053
						],
						[
							-81.74216490499992,
							30.257418009000048
						],
						[
							-81.74204990499993,
							30.257727008000074
						],
						[
							-81.7416999049999,
							30.258483009000088
						],
						[
							-81.7414929059999,
							30.25896100800008
						],
						[
							-81.74117290499993,
							30.259624008000056
						],
						[
							-81.74095190499992,
							30.260109010000065
						],
						[
							-81.74084896799991,
							30.260302011000082
						],
						[
							-81.74004391099993,
							30.259541815000038
						],
						[
							-81.73762872499992,
							30.26144895600004
						],
						[
							-81.73809503699994,
							30.26286998600006
						],
						[
							-81.73802905499991,
							30.263643130000048
						],
						[
							-81.73468385899992,
							30.26482494000004
						],
						[
							-81.73430490599992,
							30.265259009000093
						],
						[
							-81.7338909469999,
							30.26589804200006
						],
						[
							-81.73339590499997,
							30.26633700800005
						],
						[
							-81.73305794399995,
							30.266572051000082
						],
						[
							-81.73221099999995,
							30.267657000000042
						],
						[
							-81.73116167199993,
							30.268053009000084
						],
						[
							-81.7306860889999,
							30.26782778800009
						],
						[
							-81.73062301099992,
							30.26779479900006
						],
						[
							-81.73056273999993,
							30.267756924000086
						],
						[
							-81.73050565299991,
							30.267714402000085
						],
						[
							-81.73045210799995,
							30.26766749700005
						],
						[
							-81.73040243999992,
							30.26761650500004
						],
						[
							-81.73035696099993,
							30.26756174400009
						],
						[
							-81.73031595599991,
							30.267503558000044
						],
						[
							-81.72995295599992,
							30.26694255800004
						],
						[
							-81.72991847599992,
							30.266885261000088
						],
						[
							-81.72988861899995,
							30.26682542500004
						],
						[
							-81.72986357099991,
							30.266763422000054
						],
						[
							-81.72984348699993,
							30.266699638000034
						],
						[
							-81.72982849199991,
							30.266634470000042
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Confederate Point",
				"RegionID": "268933"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.7646157879999,
					30.42146870400006,
					-81.72464491799991,
					30.44004376200007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.72464491799991,
							30.438256016000082
						],
						[
							-81.72827845199993,
							30.433179331000073
						],
						[
							-81.73005700699991,
							30.429137029000064
						],
						[
							-81.73215899299994,
							30.426064895000085
						],
						[
							-81.73409928599995,
							30.423477836000075
						],
						[
							-81.7351129999999,
							30.421704000000094
						],
						[
							-81.73524746699991,
							30.42146870400006
						],
						[
							-81.7352585079999,
							30.42147949400004
						],
						[
							-81.73546525199993,
							30.421681539000076
						],
						[
							-81.73592799999994,
							30.422160000000076
						],
						[
							-81.7362259059999,
							30.422425010000037
						],
						[
							-81.73638490699994,
							30.422638010000075
						],
						[
							-81.73646190799991,
							30.422788010000094
						],
						[
							-81.73667298799995,
							30.423133987000085
						],
						[
							-81.73672790799992,
							30.42409200600008
						],
						[
							-81.73703177399995,
							30.425226132000034
						],
						[
							-81.73806090999994,
							30.425677009000083
						],
						[
							-81.73921890799994,
							30.42592001100007
						],
						[
							-81.73984497499993,
							30.426105895000035
						],
						[
							-81.7402639089999,
							30.426460011000074
						],
						[
							-81.7410349079999,
							30.427201010000086
						],
						[
							-81.74162890799994,
							30.42766601500006
						],
						[
							-81.7419189069999,
							30.428095010000046
						],
						[
							-81.74219190899993,
							30.42863600900006
						],
						[
							-81.74243282299994,
							30.428899113000057
						],
						[
							-81.74285088399995,
							30.429093142000053
						],
						[
							-81.74325290799993,
							30.429107010000056
						],
						[
							-81.74392790699994,
							30.429093010000088
						],
						[
							-81.74429790699992,
							30.429065011000034
						],
						[
							-81.74497290799991,
							30.42905201100007
						],
						[
							-81.74516590999993,
							30.42907901400008
						],
						[
							-81.74582494799995,
							30.42939792900006
						],
						[
							-81.74601694799992,
							30.429577976000076
						],
						[
							-81.74616190499995,
							30.42982801200009
						],
						[
							-81.74625590699992,
							30.43030501000004
						],
						[
							-81.74630396399994,
							30.43074799500005
						],
						[
							-81.7464639079999,
							30.431108011000052
						],
						[
							-81.74660884899993,
							30.43134406900009
						],
						[
							-81.74699490799992,
							30.431579011000057
						],
						[
							-81.74813590799994,
							30.432216010000044
						],
						[
							-81.75085095499992,
							30.433254940000044
						],
						[
							-81.75093184699995,
							30.43333918900004
						],
						[
							-81.75159096099992,
							30.43324213500006
						],
						[
							-81.75187990799992,
							30.43310301100007
						],
						[
							-81.75242588499992,
							30.432867880000057
						],
						[
							-81.75276393299993,
							30.43289493000009
						],
						[
							-81.75300490799992,
							30.43304801100004
						],
						[
							-81.75321394199995,
							30.43317197000005
						],
						[
							-81.75332590799991,
							30.433297010000043
						],
						[
							-81.75363090799993,
							30.433560009000075
						],
						[
							-81.75401690699994,
							30.43376801200009
						],
						[
							-81.7542238449999,
							30.433949171000055
						],
						[
							-81.7543249009999,
							30.433952101000045
						],
						[
							-81.75442189099994,
							30.433964066000044
						],
						[
							-81.75455290699995,
							30.434024011000073
						],
						[
							-81.75469085999993,
							30.43411913500006
						],
						[
							-81.75514790799991,
							30.434226010000092
						],
						[
							-81.75548690799991,
							30.434322009000084
						],
						[
							-81.7559779149999,
							30.434375096000057
						],
						[
							-81.7561578989999,
							30.434321958000055
						],
						[
							-81.75664190799995,
							30.434322009000084
						],
						[
							-81.7568079159999,
							30.434303924000066
						],
						[
							-81.75707097399993,
							30.43438089500006
						],
						[
							-81.75719487099991,
							30.434495084000048
						],
						[
							-81.7572709069999,
							30.434513010000042
						],
						[
							-81.7574029079999,
							30.434542011000072
						],
						[
							-81.75756889899992,
							30.434596062000082
						],
						[
							-81.7577209079999,
							30.43460200900006
						],
						[
							-81.75803196399994,
							30.43453713300005
						],
						[
							-81.75846789399992,
							30.434291829000074
						],
						[
							-81.75870995499992,
							30.434386940000085
						],
						[
							-81.7589040229999,
							30.434589941000073
						],
						[
							-81.75906309499993,
							30.434954057000088
						],
						[
							-81.75897975899994,
							30.435024921000032
						],
						[
							-81.75894482699994,
							30.435192017000077
						],
						[
							-81.7590009079999,
							30.435342007000088
						],
						[
							-81.7591250989999,
							30.435519024000083
						],
						[
							-81.75908371899993,
							30.435567004000063
						],
						[
							-81.75924290699993,
							30.43578201000008
						],
						[
							-81.75933980799994,
							30.43590715400006
						],
						[
							-81.75946390999992,
							30.435943012000052
						],
						[
							-81.75962990499994,
							30.436038008000086
						],
						[
							-81.76000390699994,
							30.43614001000009
						],
						[
							-81.76038390699995,
							30.43620500900005
						],
						[
							-81.76077090599995,
							30.436199012000092
						],
						[
							-81.76084699499995,
							30.43621685700009
						],
						[
							-81.76091690699991,
							30.436289013000074
						],
						[
							-81.76097209099994,
							30.436383980000073
						],
						[
							-81.76095095699992,
							30.43646802800004
						],
						[
							-81.76088190699994,
							30.43658701000004
						],
						[
							-81.76078501299992,
							30.436772095000038
						],
						[
							-81.76063283799994,
							30.43691496200006
						],
						[
							-81.76059790699992,
							30.436998010000078
						],
						[
							-81.76044582799996,
							30.437278989000053
						],
						[
							-81.7604458269999,
							30.437428029000046
						],
						[
							-81.76057080699991,
							30.437666095000054
						],
						[
							-81.76065384299994,
							30.43772612800007
						],
						[
							-81.76079891099995,
							30.437767186000087
						],
						[
							-81.76096490899994,
							30.437714008000057
						],
						[
							-81.76110290699995,
							30.437636009000073
						],
						[
							-81.7614839069999,
							30.437326010000046
						],
						[
							-81.76165687499991,
							30.437194934000047
						],
						[
							-81.76191291499993,
							30.437164925000047
						],
						[
							-81.76218902499994,
							30.437248866000058
						],
						[
							-81.7626727949999,
							30.438066142000082
						],
						[
							-81.76341989199994,
							30.43837018600004
						],
						[
							-81.76352190799992,
							30.438349010000085
						],
						[
							-81.76367597299992,
							30.438290829000042
						],
						[
							-81.76449898599992,
							30.439734989000044
						],
						[
							-81.7644958269999,
							30.43979302900004
						],
						[
							-81.7646157879999,
							30.44004376200007
						],
						[
							-81.76439996599993,
							30.439778830000076
						],
						[
							-81.76428790999996,
							30.439811012000067
						],
						[
							-81.76418790999992,
							30.43982601100004
						],
						[
							-81.76410490999992,
							30.43982601100004
						],
						[
							-81.76402990999992,
							30.439815011000064
						],
						[
							-81.76397390999995,
							30.439796013000038
						],
						[
							-81.76381490999995,
							30.439741011000084
						],
						[
							-81.76170390899995,
							30.43862401300004
						],
						[
							-81.76114490999993,
							30.438339012000085
						],
						[
							-81.76087090999994,
							30.438216013000044
						],
						[
							-81.76044390999994,
							30.43805701300005
						],
						[
							-81.76001590899995,
							30.43792601300004
						],
						[
							-81.75952890899993,
							30.437818012000037
						],
						[
							-81.75917790999996,
							30.43776301200006
						],
						[
							-81.7587969089999,
							30.43771901200006
						],
						[
							-81.75860590999991,
							30.43771001300007
						],
						[
							-81.7584079099999,
							30.437700012000054
						],
						[
							-81.75759090999992,
							30.437708013000076
						],
						[
							-81.75669090899993,
							30.437735012000076
						],
						[
							-81.75576790899993,
							30.437740012000063
						],
						[
							-81.75440990899995,
							30.437769012000047
						],
						[
							-81.75296190899991,
							30.43779601200004
						],
						[
							-81.75020590999992,
							30.43784701200008
						],
						[
							-81.74799290999994,
							30.437887012000093
						],
						[
							-81.74600990899995,
							30.43791401200008
						],
						[
							-81.74267590999995,
							30.437965012000063
						],
						[
							-81.74182090999994,
							30.437984012000076
						],
						[
							-81.74121390999994,
							30.437998013000083
						],
						[
							-81.74021090999992,
							30.43801501200005
						],
						[
							-81.73982390999993,
							30.438017012000046
						],
						[
							-81.73871590899995,
							30.438043012000033
						],
						[
							-81.73835690999994,
							30.438043012000033
						],
						[
							-81.73763990999993,
							30.438063012000043
						],
						[
							-81.73342890899994,
							30.43812901200005
						],
						[
							-81.7322919099999,
							30.438152012000046
						],
						[
							-81.7320199099999,
							30.43814301200007
						],
						[
							-81.73161591199994,
							30.438148010000077
						],
						[
							-81.7315569079999,
							30.438133014000076
						],
						[
							-81.73087290899991,
							30.438153012000043
						],
						[
							-81.72998691099991,
							30.438148012000056
						],
						[
							-81.72918290899992,
							30.43818801200007
						],
						[
							-81.72831490999994,
							30.438195013000044
						],
						[
							-81.72804390999994,
							30.43819101200006
						],
						[
							-81.72742290899993,
							30.438198012000043
						],
						[
							-81.72643090999992,
							30.43822701200008
						],
						[
							-81.72568290899996,
							30.438239012000054
						],
						[
							-81.7253809099999,
							30.438243012000044
						],
						[
							-81.72464491799991,
							30.438256016000082
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Copper Hill",
				"RegionID": "268934"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.13903832999995,
					26.18889499100004,
					-80.12703,
					26.20356
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.132193,
							26.203535
						],
						[
							-80.1320906,
							26.20038547400003
						],
						[
							-80.13195072099995,
							26.19606097700006
						],
						[
							-80.13184054799996,
							26.192609816000072
						],
						[
							-80.13183901299999,
							26.192560999000023
						],
						[
							-80.13183629299994,
							26.19247361600003
						],
						[
							-80.131832,
							26.192335
						],
						[
							-80.131485,
							26.192334905000052
						],
						[
							-80.12979252699995,
							26.192334025000036
						],
						[
							-80.12956600000001,
							26.189861
						],
						[
							-80.128066,
							26.189861
						],
						[
							-80.127166,
							26.189861
						],
						[
							-80.12703,
							26.189861
						],
						[
							-80.12703239099994,
							26.18952174800006
						],
						[
							-80.12703579399994,
							26.18903906500003
						],
						[
							-80.13189295499996,
							26.188952650000033
						],
						[
							-80.13534540099994,
							26.18891429000007
						],
						[
							-80.13895148099995,
							26.18889499100004
						],
						[
							-80.13903832999995,
							26.196045515000037
						],
						[
							-80.13480185899994,
							26.196119322000076
						],
						[
							-80.13480735499996,
							26.197103181000045
						],
						[
							-80.13481661999998,
							26.198761580000053
						],
						[
							-80.13394570799994,
							26.198791103000076
						],
						[
							-80.13393094699995,
							26.199853911000048
						],
						[
							-80.13428926099994,
							26.199867871000038
						],
						[
							-80.13506756099997,
							26.19989819400007
						],
						[
							-80.13509023199998,
							26.200174167000057
						],
						[
							-80.13521442399997,
							26.20168598600003
						],
						[
							-80.135267,
							26.202326
						],
						[
							-80.135267,
							26.20346
						],
						[
							-80.133709529,
							26.20346
						],
						[
							-80.13307479599996,
							26.20346
						],
						[
							-80.132667,
							26.20346
						],
						[
							-80.13251277499995,
							26.203511408000054
						],
						[
							-80.132367,
							26.20356
						],
						[
							-80.132193,
							26.203535
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Oakland Park",
				"Name": "North Ridge",
				"RegionID": "259622"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.80222706199999,
					24.550506236000047,
					-81.78906258499995,
					24.56093529000003
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.79428125199996,
							24.56038493500006
						],
						[
							-81.79322546499998,
							24.55890522900006
						],
						[
							-81.79315234099994,
							24.558802744000047
						],
						[
							-81.79292948599993,
							24.55849040800007
						],
						[
							-81.79121442,
							24.55616412100005
						],
						[
							-81.78906258499995,
							24.55331350700004
						],
						[
							-81.79346319899997,
							24.550612347000026
						],
						[
							-81.79363135599993,
							24.550509216000023
						],
						[
							-81.79363592699997,
							24.550506236000047
						],
						[
							-81.79467203099995,
							24.55191515200005
						],
						[
							-81.79429616199997,
							24.552117544000055
						],
						[
							-81.79541413299995,
							24.553495733000034
						],
						[
							-81.79859354699995,
							24.551564735000056
						],
						[
							-81.79993392999995,
							24.55328282100004
						],
						[
							-81.80060181899995,
							24.554273138000045
						],
						[
							-81.80117248399995,
							24.55500734800006
						],
						[
							-81.80216256899996,
							24.556386127000053
						],
						[
							-81.80222706199999,
							24.556475712000065
						],
						[
							-81.79484525199996,
							24.56093529000003
						],
						[
							-81.79428125199996,
							24.56038493500006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Monroe",
				"City": "Key West",
				"Name": "Old Town",
				"RegionID": "260910"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.09548527599992,
					26.214930252000045,
					-80.0837148949999,
					26.254584974000068
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.0893775369999,
							26.221721873000035
						],
						[
							-80.0903646079999,
							26.216571212000076
						],
						[
							-80.09036567699992,
							26.216566078000085
						],
						[
							-80.0903907849999,
							26.21656568700007
						],
						[
							-80.09043949399995,
							26.216564928000082
						],
						[
							-80.09046460199994,
							26.216564537000068
						],
						[
							-80.09069307599992,
							26.216560977000086
						],
						[
							-80.09076594999993,
							26.216560121000043
						],
						[
							-80.0908779419999,
							26.216575616000057
						],
						[
							-80.09095081999993,
							26.21657493400005
						],
						[
							-80.09209306899993,
							26.216560745000038
						],
						[
							-80.09216594799994,
							26.216560063000088
						],
						[
							-80.09226594499995,
							26.216359840000052
						],
						[
							-80.09236594499993,
							26.21605984000007
						],
						[
							-80.09236594499993,
							26.21575984000009
						],
						[
							-80.0924659449999,
							26.21515984000007
						],
						[
							-80.09256593599991,
							26.214959428000043
						],
						[
							-80.09263879499991,
							26.214958169000056
						],
						[
							-80.09380109499995,
							26.21493151100009
						],
						[
							-80.09386826799994,
							26.214930355000035
						],
						[
							-80.09387395499994,
							26.214930252000045
						],
						[
							-80.09387251699991,
							26.21493556300004
						],
						[
							-80.09386594499995,
							26.214959840000063
						],
						[
							-80.09386594499995,
							26.21515984000007
						],
						[
							-80.09366594499994,
							26.215859840000064
						],
						[
							-80.09346594499993,
							26.216159840000046
						],
						[
							-80.09346594499993,
							26.216459840000088
						],
						[
							-80.0933659449999,
							26.216759840000066
						],
						[
							-80.09326594499993,
							26.217259840000054
						],
						[
							-80.09306594499992,
							26.21805984000008
						],
						[
							-80.09291114899992,
							26.219290776000037
						],
						[
							-80.09290970199993,
							26.21929448800006
						],
						[
							-80.09264159199995,
							26.220633854000088
						],
						[
							-80.09288886899994,
							26.221227319000036
						],
						[
							-80.09370488299993,
							26.222092788000054
						],
						[
							-80.09424889199994,
							26.222364793000054
						],
						[
							-80.09548527599992,
							26.222735708000073
						],
						[
							-80.09392743199993,
							26.231909682000037
						],
						[
							-80.09204812699994,
							26.240737467000088
						],
						[
							-80.09006991199993,
							26.25023290100006
						],
						[
							-80.08927862599995,
							26.25433769700004
						],
						[
							-80.0837148949999,
							26.254584974000068
						],
						[
							-80.08415999399995,
							26.25010926200008
						],
						[
							-80.08502546299991,
							26.246276470000055
						],
						[
							-80.0859156599999,
							26.243358602000058
						],
						[
							-80.08702840599994,
							26.23947635500008
						],
						[
							-80.08752295999994,
							26.236682126000062
						],
						[
							-80.08786914799992,
							26.235791929000072
						],
						[
							-80.08796805799994,
							26.234654455000054
						],
						[
							-80.08824006299994,
							26.232775151000055
						],
						[
							-80.08868516099994,
							26.230722752000077
						],
						[
							-80.08863570599993,
							26.228892903000087
						],
						[
							-80.0891055319999,
							26.226247040000093
						],
						[
							-80.0893775369999,
							26.221721873000035
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Pompano Beach",
				"Name": "Beach",
				"RegionID": "265170"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.78845121799999,
					24.555080433000057,
					-81.74956178099995,
					24.57266812100005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.75059385599997,
							24.57220257700004
						],
						[
							-81.75040978799996,
							24.571724387000074
						],
						[
							-81.75024816699994,
							24.57130451000006
						],
						[
							-81.75016030099994,
							24.57107624400004
						],
						[
							-81.750094,
							24.570904
						],
						[
							-81.750034,
							24.570734
						],
						[
							-81.74998779299995,
							24.570669590000023
						],
						[
							-81.749943,
							24.570564
						],
						[
							-81.75100404999995,
							24.570073654000055
						],
						[
							-81.75160084999999,
							24.569290353000042
						],
						[
							-81.75145164999998,
							24.56916601900008
						],
						[
							-81.75096674999998,
							24.569688220000046
						],
						[
							-81.75035751499996,
							24.569986620000066
						],
						[
							-81.75003424799996,
							24.56993688700004
						],
						[
							-81.74956178099995,
							24.569476853000026
						],
						[
							-81.74982288099994,
							24.56822108500006
						],
						[
							-81.74990991499999,
							24.567624284000033
						],
						[
							-81.749812,
							24.567407
						],
						[
							-81.749812,
							24.566517716000078
						],
						[
							-81.75013371499995,
							24.566306349000058
						],
						[
							-81.75045698199995,
							24.566169582000043
						],
						[
							-81.75120298299998,
							24.565821449000058
						],
						[
							-81.77200397599995,
							24.559194474000037
						],
						[
							-81.77526151299998,
							24.55813763900005
						],
						[
							-81.78004471099996,
							24.555080433000057
						],
						[
							-81.78056026899998,
							24.555758258000026
						],
						[
							-81.78359020199998,
							24.559741835000068
						],
						[
							-81.78648185299994,
							24.558875361000048
						],
						[
							-81.78724012699996,
							24.558648147000042
						],
						[
							-81.78748386099994,
							24.559361870000032
						],
						[
							-81.78845121799999,
							24.56058407000006
						],
						[
							-81.78722515499999,
							24.56058917400003
						],
						[
							-81.78700690099998,
							24.561557674000028
						],
						[
							-81.78705962099997,
							24.56177334700004
						],
						[
							-81.77907855199999,
							24.561146509000025
						],
						[
							-81.78014555499999,
							24.562048745000027
						],
						[
							-81.77965448499998,
							24.562335202000043
						],
						[
							-81.78222141599997,
							24.56249123500004
						],
						[
							-81.78251555799994,
							24.563017697000078
						],
						[
							-81.782198,
							24.564125000000004
						],
						[
							-81.78107313299995,
							24.56379477300004
						],
						[
							-81.78086851999996,
							24.563399188000062
						],
						[
							-81.78026832299997,
							24.563672005000058
						],
						[
							-81.77906792799996,
							24.563699287000077
						],
						[
							-81.77859049899996,
							24.563890259000065
						],
						[
							-81.77803122399997,
							24.564108512000075
						],
						[
							-81.77697731599994,
							24.56521221400004
						],
						[
							-81.77721277299997,
							24.565677210000047
						],
						[
							-81.77541218199997,
							24.566686632000028
						],
						[
							-81.77500295599998,
							24.56690488600003
						],
						[
							-81.77185192099995,
							24.56889645000007
						],
						[
							-81.77114259699994,
							24.56830989300005
						],
						[
							-81.77058332199994,
							24.568637274000025
						],
						[
							-81.77022600699996,
							24.568134051000072
						],
						[
							-81.76998977299996,
							24.568320552000046
						],
						[
							-81.76960433999994,
							24.56850705200003
						],
						[
							-81.76998977299996,
							24.56916601900008
						],
						[
							-81.76997733999997,
							24.569402253000078
						],
						[
							-81.76935567299995,
							24.569427120000057
						],
						[
							-81.76901997199997,
							24.56930278600004
						],
						[
							-81.76864697199994,
							24.568967086000043
						],
						[
							-81.76884590499998,
							24.568581652000034
						],
						[
							-81.76491696699998,
							24.570633155000053
						],
						[
							-81.76277843099996,
							24.57175215600006
						],
						[
							-81.76124912899996,
							24.572100290000037
						],
						[
							-81.75871272599994,
							24.572187323000037
						],
						[
							-81.75620118899997,
							24.572361390000026
						],
						[
							-81.75523138799997,
							24.572311657000057
						],
						[
							-81.75365235299995,
							24.571801889000028
						],
						[
							-81.75334151899995,
							24.57190135600007
						],
						[
							-81.75084157299995,
							24.57266812100005
						],
						[
							-81.75079279699997,
							24.572549312000035
						],
						[
							-81.75077611299997,
							24.572545099000024
						],
						[
							-81.75059385599997,
							24.57220257700004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Monroe",
				"City": "Key West",
				"Name": "New Town",
				"RegionID": "265929"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.11075185999994,
					26.897465330000045,
					-80.10398684899997,
					26.902134983000053
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.11075185999994,
							26.897465330000045
						],
						[
							-80.11072192699999,
							26.90174584600004
						],
						[
							-80.11069199299999,
							26.902134983000053
						],
						[
							-80.10662101299994,
							26.901985315000047
						],
						[
							-80.10593253799993,
							26.90120703900004
						],
						[
							-80.10398684899997,
							26.900967570000034
						],
						[
							-80.10428618599997,
							26.900039626000023
						],
						[
							-80.10617200799999,
							26.89923141700007
						],
						[
							-80.10709995199994,
							26.89824360500006
						],
						[
							-80.10751902299995,
							26.897674866000045
						],
						[
							-80.11075185999994,
							26.897465330000045
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Jupiter",
				"Name": "Valencia",
				"RegionID": "266015"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.25367064099999,
					25.94068122500005,
					-80.24735928599995,
					25.948083568000072
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.24783146499999,
							25.94325503600004
						],
						[
							-80.24779252199994,
							25.942855875000078
						],
						[
							-80.24765622299998,
							25.942661162000036
						],
						[
							-80.24754913099997,
							25.94163405100005
						],
						[
							-80.24735928599995,
							25.94147828100006
						],
						[
							-80.24736415399997,
							25.940825993000033
						],
						[
							-80.24794949999995,
							25.940821863000053
						],
						[
							-80.25244251799995,
							25.94070440300004
						],
						[
							-80.25339226199998,
							25.94068122500005
						],
						[
							-80.25341774699997,
							25.941292626000063
						],
						[
							-80.25367064099999,
							25.947595738000075
						],
						[
							-80.25366641699998,
							25.947885057000068
						],
						[
							-80.25288590999997,
							25.947912654000053
						],
						[
							-80.25259947099994,
							25.947922782000035
						],
						[
							-80.24805215499998,
							25.948083568000072
						],
						[
							-80.24802766399995,
							25.947511834000068
						],
						[
							-80.24800376299999,
							25.94698601600004
						],
						[
							-80.24794949999995,
							25.945792226000037
						],
						[
							-80.24794356299998,
							25.945661419000032
						],
						[
							-80.24790537999998,
							25.94512387900005
						],
						[
							-80.24784521999999,
							25.943602803000033
						],
						[
							-80.24783146499999,
							25.94325503600004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Gardens",
				"Name": "Brentwood",
				"RegionID": "266406"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.39301277299995,
					29.703286349000052,
					-82.38896932799997,
					29.70876256100007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.39301277299995,
							29.703286349000052
						],
						[
							-82.39286557299994,
							29.70874873000003
						],
						[
							-82.38900671499994,
							29.70876256100007
						],
						[
							-82.38896932799997,
							29.706457606000072
						],
						[
							-82.39001637999996,
							29.706411285000055
						],
						[
							-82.38999693399995,
							29.703309548000053
						],
						[
							-82.39301277299995,
							29.703286349000052
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Alachua",
				"City": "Gainesville",
				"Name": "Ashton",
				"RegionID": "254905"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.22971945299997,
					25.965158410000072,
					-80.20605962599996,
					25.972700022000026
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.20605962599996,
							25.96963173900008
						],
						[
							-80.206787933,
							25.969607783000072
						],
						[
							-80.20715824999996,
							25.969588189000035
						],
						[
							-80.20750906899997,
							25.969569626000066
						],
						[
							-80.20845926599998,
							25.969122363000054
						],
						[
							-80.21003768899999,
							25.969119095000053
						],
						[
							-80.21091172999996,
							25.969117286000028
						],
						[
							-80.21187817599997,
							25.969115285000044
						],
						[
							-80.21258584299994,
							25.968899056000055
						],
						[
							-80.21413742299995,
							25.968879315000038
						],
						[
							-80.21476514199998,
							25.969323814000063
						],
						[
							-80.21469407099994,
							25.969121761000054
						],
						[
							-80.21427538799998,
							25.96793145600003
						],
						[
							-80.21399464399997,
							25.96713330800003
						],
						[
							-80.21410082099999,
							25.96568221800004
						],
						[
							-80.21484406199994,
							25.96570345400005
						],
						[
							-80.21508326099996,
							25.965695061000076
						],
						[
							-80.21524753599994,
							25.96568929700004
						],
						[
							-80.22616964299995,
							25.965285823000045
						],
						[
							-80.22650944299994,
							25.965272497000058
						],
						[
							-80.22911888299996,
							25.965170166000064
						],
						[
							-80.22941866899998,
							25.965158410000072
						],
						[
							-80.22946208099995,
							25.966922656000065
						],
						[
							-80.22949071099998,
							25.96808614200006
						],
						[
							-80.22949789799998,
							25.96837820500008
						],
						[
							-80.22964450599994,
							25.971530552000047
						],
						[
							-80.22970731899994,
							25.97197024600007
						],
						[
							-80.22971945299997,
							25.972307171000068
						],
						[
							-80.228648,
							25.972308
						],
						[
							-80.22816,
							25.972295
						],
						[
							-80.227798,
							25.972308
						],
						[
							-80.226964,
							25.972307
						],
						[
							-80.225556,
							25.972305
						],
						[
							-80.224476,
							25.972303
						],
						[
							-80.22396900000001,
							25.972302
						],
						[
							-80.22282,
							25.972301
						],
						[
							-80.22233877399998,
							25.97230569100003
						],
						[
							-80.219537,
							25.972333
						],
						[
							-80.214848,
							25.972379000000004
						],
						[
							-80.214256,
							25.972396
						],
						[
							-80.212418,
							25.972449
						],
						[
							-80.209961,
							25.972548
						],
						[
							-80.20757122899994,
							25.972642991000043
						],
						[
							-80.206707055,
							25.972677341000065
						],
						[
							-80.20613680699995,
							25.972700022000026
						],
						[
							-80.20607445399997,
							25.971890404000078
						],
						[
							-80.20606955599999,
							25.970980248000046
						],
						[
							-80.20605962599996,
							25.96963173900008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Gardens",
				"Name": "Walden",
				"RegionID": "260084"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.07788468299998,
					26.89116194500008,
					-80.05844517999998,
					26.91199600500005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.06637057099994,
							26.89116194500008
						],
						[
							-80.072672,
							26.891279
						],
						[
							-80.073168,
							26.891282
						],
						[
							-80.07341003999994,
							26.89164144600005
						],
						[
							-80.07478799699999,
							26.893687810000074
						],
						[
							-80.07426353599999,
							26.895370737000064
						],
						[
							-80.07387356999999,
							26.89698639100004
						],
						[
							-80.07429264199999,
							26.897585065000044
						],
						[
							-80.07432257499994,
							26.899770223000075
						],
						[
							-80.07492124899994,
							26.902554055000053
						],
						[
							-80.07723139499996,
							26.905492809000066
						],
						[
							-80.07788468299998,
							26.906146096000043
						],
						[
							-80.07734587699997,
							26.906774703000053
						],
						[
							-80.07701660599997,
							26.907702647000065
						],
						[
							-80.07657001599995,
							26.908041341000057
						],
						[
							-80.06993357099998,
							26.907799536000027
						],
						[
							-80.06994009099998,
							26.90829830900003
						],
						[
							-80.06998842699994,
							26.91199600500005
						],
						[
							-80.06526214099995,
							26.90422085700004
						],
						[
							-80.06091375299997,
							26.90423811100004
						],
						[
							-80.06029660999997,
							26.902841418000037
						],
						[
							-80.06451364099996,
							26.902292356000032
						],
						[
							-80.06285651299999,
							26.899355221000068
						],
						[
							-80.05925721099999,
							26.899658258000045
						],
						[
							-80.05844517999998,
							26.896410136000043
						],
						[
							-80.06639797699995,
							26.896831595000037
						],
						[
							-80.06637057099994,
							26.89116194500008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Jupiter",
				"Name": "Bluffs",
				"RegionID": "261257"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-87.20775654199997,
					30.488034981000055,
					-87.17908118199995,
					30.511065340000073
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-87.17959895199994,
							30.502248009000027
						],
						[
							-87.18383123599995,
							30.502391697000068
						],
						[
							-87.18403682199994,
							30.50154651200006
						],
						[
							-87.184413728,
							30.500781277000044
						],
						[
							-87.18500764199996,
							30.499993200000063
						],
						[
							-87.18666374699995,
							30.49851983800005
						],
						[
							-87.18738329599995,
							30.49791450300006
						],
						[
							-87.18771451699997,
							30.497514753000075
						],
						[
							-87.18884523699995,
							30.49598428400003
						],
						[
							-87.18978179199996,
							30.494956357000035
						],
						[
							-87.19093535499997,
							30.493848480000054
						],
						[
							-87.19235160999995,
							30.49261496700007
						],
						[
							-87.192478968,
							30.492498334000064
						],
						[
							-87.19343664499996,
							30.491621304000034
						],
						[
							-87.19530581699996,
							30.489958641000044
						],
						[
							-87.19746840299996,
							30.488034981000055
						],
						[
							-87.20524638499995,
							30.488251988000062
						],
						[
							-87.20502461999996,
							30.495531235000048
						],
						[
							-87.20775654199997,
							30.49559313200007
						],
						[
							-87.20761948499995,
							30.50109063900004
						],
						[
							-87.20751288499997,
							30.502872379000056
						],
						[
							-87.20481743199997,
							30.502857151000057
						],
						[
							-87.19484273099994,
							30.502659180000023
						],
						[
							-87.19016756599996,
							30.502552580000042
						],
						[
							-87.18998482399996,
							30.509801370000044
						],
						[
							-87.18891882499997,
							30.509801370000044
						],
						[
							-87.18826399799997,
							30.509862284000064
						],
						[
							-87.18763962699995,
							30.509968884000045
						],
						[
							-87.18706094199996,
							30.51013639800004
						],
						[
							-87.18616245799996,
							30.510562797000034
						],
						[
							-87.18535534499995,
							30.511065340000073
						],
						[
							-87.18498985899998,
							30.51051711200006
						],
						[
							-87.18471574499995,
							30.509953655000064
						],
						[
							-87.18457868799999,
							30.50934451300003
						],
						[
							-87.18447208899994,
							30.508522172000028
						],
						[
							-87.18086292199996,
							30.508659229000045
						],
						[
							-87.18078677899996,
							30.50718205900006
						],
						[
							-87.18072586499994,
							30.50664906000003
						],
						[
							-87.18042129399998,
							30.505278490000023
						],
						[
							-87.18020809499995,
							30.50495869100007
						],
						[
							-87.17908118199995,
							30.50448660600006
						],
						[
							-87.17950758099994,
							30.503496750000064
						],
						[
							-87.17959895199994,
							30.502248009000027
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Escambia",
				"City": "Pensacola",
				"Name": "Kensington",
				"RegionID": "262277"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.98298614399995,
					28.98760958600008,
					-80.96682411799998,
					29.005668395000043
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.97144924099996,
							28.98760958600008
						],
						[
							-80.98298614399995,
							29.005408700000036
						],
						[
							-80.97505999199996,
							29.005668395000043
						],
						[
							-80.974961,
							29.001929000000004
						],
						[
							-80.97177,
							29.001926000000005
						],
						[
							-80.971498,
							29.001922
						],
						[
							-80.97151280699995,
							28.994746736000025
						],
						[
							-80.96684292899994,
							28.99479939500003
						],
						[
							-80.96682950399997,
							28.994454883000063
						],
						[
							-80.96682411799998,
							28.99431667700003
						],
						[
							-80.97151380199995,
							28.994264629000043
						],
						[
							-80.971522,
							28.990292
						],
						[
							-80.971505,
							28.988068
						],
						[
							-80.97144924099996,
							28.98760958600008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Volusia",
				"City": "New Smyrna Beach",
				"Name": "Glencoe",
				"RegionID": "263095"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.22930351799995,
					25.942233016000046,
					-80.201086,
					25.96061813500006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.21513433199995,
							25.960096118000024
						],
						[
							-80.21457418399996,
							25.96007937400003
						],
						[
							-80.21390112899996,
							25.960064110000076
						],
						[
							-80.21362216699998,
							25.96005778300003
						],
						[
							-80.20993263899999,
							25.95997410900003
						],
						[
							-80.20657899599996,
							25.959833418000073
						],
						[
							-80.20574469099995,
							25.959781753000073
						],
						[
							-80.20573622599994,
							25.95964637800006
						],
						[
							-80.20568530099996,
							25.958831968000027
						],
						[
							-80.20564321699999,
							25.957124687000032
						],
						[
							-80.20441373099999,
							25.95723386900005
						],
						[
							-80.20308455799994,
							25.957290834000048
						],
						[
							-80.20251016599997,
							25.95731456900006
						],
						[
							-80.20185981999998,
							25.957371533000074
						],
						[
							-80.201559,
							25.957364
						],
						[
							-80.20155659499994,
							25.957234520000043
						],
						[
							-80.20155349199996,
							25.957067505000055
						],
						[
							-80.20152900000001,
							25.955749
						],
						[
							-80.201492,
							25.955050000000004
						],
						[
							-80.201497,
							25.954358
						],
						[
							-80.201476,
							25.953625
						],
						[
							-80.201453,
							25.952915
						],
						[
							-80.201448,
							25.952229
						],
						[
							-80.201436,
							25.951497000000003
						],
						[
							-80.201403,
							25.949982000000002
						],
						[
							-80.201394,
							25.949237
						],
						[
							-80.201361,
							25.948535
						],
						[
							-80.20130600000002,
							25.94778
						],
						[
							-80.201274,
							25.947077000000004
						],
						[
							-80.201232,
							25.94634
						],
						[
							-80.201215,
							25.945621
						],
						[
							-80.20117,
							25.944911000000005
						],
						[
							-80.201152,
							25.944193
						],
						[
							-80.201137,
							25.944101
						],
						[
							-80.201113,
							25.943491
						],
						[
							-80.201086,
							25.942697
						],
						[
							-80.202017,
							25.942665
						],
						[
							-80.20251133199997,
							25.942651407000028
						],
						[
							-80.20330605999999,
							25.942629554000064
						],
						[
							-80.20522298699996,
							25.94257684300004
						],
						[
							-80.20599599299999,
							25.94251994600006
						],
						[
							-80.20900767099994,
							25.94243582100006
						],
						[
							-80.21320442499996,
							25.942233016000046
						],
						[
							-80.21329584899996,
							25.94444257400005
						],
						[
							-80.21350436299997,
							25.949481993000063
						],
						[
							-80.21778330899997,
							25.94928875000005
						],
						[
							-80.21977094799996,
							25.94920593200004
						],
						[
							-80.22629979199996,
							25.94895747700008
						],
						[
							-80.22685075199996,
							25.94876381000006
						],
						[
							-80.22762682699994,
							25.948731631000044
						],
						[
							-80.22782660299998,
							25.94922527500006
						],
						[
							-80.22837926399995,
							25.950891859000023
						],
						[
							-80.22876511799996,
							25.952381434000074
						],
						[
							-80.22882005699995,
							25.95271106900003
						],
						[
							-80.22896575399994,
							25.95358525000006
						],
						[
							-80.22899842499999,
							25.95378127600003
						],
						[
							-80.22901637099994,
							25.954310703000033
						],
						[
							-80.22909713199994,
							25.955575945000078
						],
						[
							-80.22909973499998,
							25.955660971000043
						],
						[
							-80.22910485799997,
							25.955828335000035
						],
						[
							-80.2291135899999,
							25.956113567000045
						],
						[
							-80.22912045799995,
							25.956337919000077
						],
						[
							-80.22915097199996,
							25.957334720000063
						],
						[
							-80.22930351799995,
							25.959703683000043
						],
						[
							-80.22930317199996,
							25.96061813500006
						],
						[
							-80.22152548799994,
							25.960287169000026
						],
						[
							-80.21513433199995,
							25.960096118000024
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Gardens",
				"Name": "Norwood",
				"RegionID": "264098"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.57712344099997,
					27.509647287000064,
					-82.56484922999994,
					27.514024105000033
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-82.56484922999994,
								27.513804681000067
							],
							[
								-82.56484922999994,
								27.513363053000035
							],
							[
								-82.56503197199999,
								27.513317367000074
							],
							[
								-82.56533654299994,
								27.513515338000047
							],
							[
								-82.56526040099999,
								27.513256453000054
							],
							[
								-82.56519948599998,
								27.513012796000055
							],
							[
								-82.56510811499999,
								27.512814825000078
							],
							[
								-82.56515380099995,
								27.512555940000027
							],
							[
								-82.56538222899997,
								27.512403654000025
							],
							[
								-82.56568680000001,
								27.512479797000026
							],
							[
								-82.56597614299994,
								27.51257116800008
							],
							[
								-82.56606751399994,
								27.512495025000078
							],
							[
								-82.56606751399994,
								27.511276741000074
							],
							[
								-82.56623502799994,
								27.511200599000063
							],
							[
								-82.56653959899995,
								27.51121582700006
							],
							[
								-82.56681371299999,
								27.511413798000035
							],
							[
								-82.56716396899998,
								27.51180974100004
							],
							[
								-82.56743808299996,
								27.512205683000047
							],
							[
								-82.56746853999994,
								27.512418883000066
							],
							[
								-82.56737716899994,
								27.51270822500004
							],
							[
								-82.56742285499996,
								27.51289096800008
							],
							[
								-82.56786448299994,
								27.513012796000055
							],
							[
								-82.56812336799999,
								27.513317367000074
							],
							[
								-82.56827565399999,
								27.513819909000063
							],
							[
								-82.56527372599999,
								27.513832854000043
							],
							[
								-82.56484922999994,
								27.513804681000067
							]
						]
					],
					[
						[
							[
								-82.56885433899998,
								27.511824969000035
							],
							[
								-82.56880865299996,
								27.51139857000004
							],
							[
								-82.57292036199993,
								27.511109227000077
							],
							[
								-82.57296604699997,
								27.511596541000074
							],
							[
								-82.57398635999994,
								27.511566084000037
							],
							[
								-82.57401681699997,
								27.509647287000064
							],
							[
								-82.57674272799994,
								27.509677744000044
							],
							[
								-82.57712344099997,
								27.509967086000074
							],
							[
								-82.57712344099997,
								27.51147471300004
							],
							[
								-82.57707585199995,
								27.51205111300004
							],
							[
								-82.57706374799994,
								27.514024105000033
							],
							[
								-82.56976234099994,
								27.513912804000032
							],
							[
								-82.56887717599994,
								27.51385749500003
							],
							[
								-82.56885433899998,
								27.511824969000035
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Manatee",
				"City": "Palmetto",
				"Name": "Waterfront",
				"RegionID": "268575"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.62868190699993,
					30.181517062000072,
					-81.6075819269999,
					30.202998027000035
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.6078489599999,
							30.184142993000084
						],
						[
							-81.60770090999995,
							30.183837011000037
						],
						[
							-81.6075819269999,
							30.183592024000063
						],
						[
							-81.61037999099995,
							30.18350455200005
						],
						[
							-81.61414886099993,
							30.18350455200005
						],
						[
							-81.61711827399995,
							30.183732969000065
						],
						[
							-81.62111555999991,
							30.183847175000043
						],
						[
							-81.62408501599992,
							30.183504679000066
						],
						[
							-81.62823005599995,
							30.181517062000072
						],
						[
							-81.62827790799992,
							30.181539010000048
						],
						[
							-81.62854390399991,
							30.181648003000078
						],
						[
							-81.62859290799992,
							30.182076011000053
						],
						[
							-81.62862090699991,
							30.182380011000078
						],
						[
							-81.62868190499995,
							30.183160012000087
						],
						[
							-81.62867390899993,
							30.18320201000006
						],
						[
							-81.62868190699993,
							30.183653010000054
						],
						[
							-81.62863190799993,
							30.184346010000073
						],
						[
							-81.62858790699994,
							30.18468301100006
						],
						[
							-81.62847990799992,
							30.18518801000005
						],
						[
							-81.62837590799995,
							30.185609010000068
						],
						[
							-81.62832490799991,
							30.185788010000067
						],
						[
							-81.62829590799993,
							30.18588101000006
						],
						[
							-81.6282819079999,
							30.18593801000009
						],
						[
							-81.62823390699992,
							30.18615901000004
						],
						[
							-81.62820190799994,
							30.186347010000077
						],
						[
							-81.6280279849999,
							30.187075047000064
						],
						[
							-81.62795479099992,
							30.187168944000064
						],
						[
							-81.62789990699991,
							30.187365010000065
						],
						[
							-81.62781790699995,
							30.18770001000007
						],
						[
							-81.62754790799995,
							30.188626011000053
						],
						[
							-81.62746890699992,
							30.18893101100008
						],
						[
							-81.6272289069999,
							30.189694010000043
						],
						[
							-81.62708490699993,
							30.19000201100005
						],
						[
							-81.62701590799992,
							30.190126011000075
						],
						[
							-81.62679190699993,
							30.19050701000009
						],
						[
							-81.62657290699991,
							30.190844010000035
						],
						[
							-81.62635690799993,
							30.19112001100007
						],
						[
							-81.62579290699995,
							30.191807011000037
						],
						[
							-81.6251769079999,
							30.192607010000074
						],
						[
							-81.62501490799991,
							30.19280001000004
						],
						[
							-81.62467690799991,
							30.19326201000007
						],
						[
							-81.6238939079999,
							30.194259010000053
						],
						[
							-81.62365390799994,
							30.19455301000005
						],
						[
							-81.62272490999993,
							30.19576501000006
						],
						[
							-81.62270990499991,
							30.195795011000087
						],
						[
							-81.62147290799993,
							30.197395010000037
						],
						[
							-81.62028190799994,
							30.198972010000038
						],
						[
							-81.61994090799993,
							30.199394011000038
						],
						[
							-81.61969290799993,
							30.199722010000077
						],
						[
							-81.61923986799991,
							30.200300969000068
						],
						[
							-81.61873690699991,
							30.200906011000086
						],
						[
							-81.6186949069999,
							30.20095001000004
						],
						[
							-81.61786890799993,
							30.201900010000088
						],
						[
							-81.61778590799992,
							30.202016010000083
						],
						[
							-81.61759290799995,
							30.202397011000073
						],
						[
							-81.61747190799991,
							30.20263501100004
						],
						[
							-81.61739790699995,
							30.202806011000064
						],
						[
							-81.61732150499995,
							30.202998027000035
						],
						[
							-81.61717491299993,
							30.202914011000075
						],
						[
							-81.6170769119999,
							30.20282101300006
						],
						[
							-81.61698391199991,
							30.202693013000044
						],
						[
							-81.61690991099994,
							30.20253801100006
						],
						[
							-81.61688890999994,
							30.202474011000046
						],
						[
							-81.61671390999993,
							30.20195201200005
						],
						[
							-81.61664590899994,
							30.20177101100006
						],
						[
							-81.61647790899991,
							30.201471012000066
						],
						[
							-81.61629490999991,
							30.201174013000067
						],
						[
							-81.61579890999991,
							30.20047801200008
						],
						[
							-81.6156459099999,
							30.200258011000077
						],
						[
							-81.61475390899994,
							30.199060011000086
						],
						[
							-81.6145169099999,
							30.198730011000066
						],
						[
							-81.61365490999992,
							30.197577011000078
						],
						[
							-81.6127169099999,
							30.196306011000047
						],
						[
							-81.6122669099999,
							30.195723011000037
						],
						[
							-81.6113049089999,
							30.194445011000088
						],
						[
							-81.61082490999992,
							30.193827011000053
						],
						[
							-81.61060290899991,
							30.193520011000086
						],
						[
							-81.61035890999996,
							30.193214011000066
						],
						[
							-81.61013790999993,
							30.192913011000083
						],
						[
							-81.60968790899994,
							30.192337012000053
						],
						[
							-81.6095199099999,
							30.192106012000067
						],
						[
							-81.6091839099999,
							30.191738009000062
						],
						[
							-81.60914590999994,
							30.191677012000067
						],
						[
							-81.60906990899991,
							30.191549011000067
						],
						[
							-81.60865790999992,
							30.191031011000067
						],
						[
							-81.6084819109999,
							30.19079401100004
						],
						[
							-81.60844390999995,
							30.19072501100004
						],
						[
							-81.60835290999995,
							30.190573011000083
						],
						[
							-81.60826890999994,
							30.190395011000078
						],
						[
							-81.6081919099999,
							30.190201011000056
						],
						[
							-81.60813090999994,
							30.190012012000068
						],
						[
							-81.60808590999994,
							30.189833011000076
						],
						[
							-81.6080779099999,
							30.18973901200008
						],
						[
							-81.60804690899994,
							30.189240011000038
						],
						[
							-81.6080399089999,
							30.189100011000054
						],
						[
							-81.60804690899994,
							30.188784012000042
						],
						[
							-81.60802490899994,
							30.188227011000034
						],
						[
							-81.60801690999995,
							30.187664011000034
						],
						[
							-81.60799390999995,
							30.187130012000065
						],
						[
							-81.60800190899994,
							30.18649101200009
						],
						[
							-81.60798590999991,
							30.18621401100006
						],
						[
							-81.60798590999991,
							30.18587901100005
						],
						[
							-81.60798590899994,
							30.185400011000073
						],
						[
							-81.6079709089999,
							30.18512301100009
						],
						[
							-81.60796390799993,
							30.184595014000084
						],
						[
							-81.6078489599999,
							30.184142993000084
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Arrowhead",
				"RegionID": "268875"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.53799828599995,
					30.323188920000067,
					-81.52311790099992,
					30.347898857000075
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.53515590699993,
							30.323250010000038
						],
						[
							-81.53577391999994,
							30.323188920000067
						],
						[
							-81.53700915199994,
							30.32781391000009
						],
						[
							-81.53757429799992,
							30.33290020000004
						],
						[
							-81.53799815399992,
							30.337280063000037
						],
						[
							-81.53799815399992,
							30.338834208000037
						],
						[
							-81.53799828599995,
							30.341518664000038
						],
						[
							-81.53738881399994,
							30.34310308000005
						],
						[
							-81.53081312599994,
							30.34567814800005
						],
						[
							-81.5235672099999,
							30.347898857000075
						],
						[
							-81.52351190799993,
							30.34575501200004
						],
						[
							-81.52350590799995,
							30.344913012000063
						],
						[
							-81.52349890799991,
							30.344460013000063
						],
						[
							-81.52349890799991,
							30.34420001300009
						],
						[
							-81.52346791199994,
							30.343559013000064
						],
						[
							-81.52347591099993,
							30.34331501300005
						],
						[
							-81.52346791199994,
							30.34285001300009
						],
						[
							-81.52344490799995,
							30.34174901200004
						],
						[
							-81.5234219109999,
							30.340792012000065
						],
						[
							-81.52341491199991,
							30.340359013000068
						],
						[
							-81.52338390799991,
							30.338711012000093
						],
						[
							-81.52336891199991,
							30.337915013000043
						],
						[
							-81.52335890799992,
							30.336879012000058
						],
						[
							-81.52335390699994,
							30.336288012000068
						],
						[
							-81.52333090699995,
							30.335281013000042
						],
						[
							-81.52332690799994,
							30.335119012000064
						],
						[
							-81.52333090799993,
							30.33461001200004
						],
						[
							-81.5233229079999,
							30.333712012000035
						],
						[
							-81.52330890799993,
							30.332807013000036
						],
						[
							-81.52326991199993,
							30.330172013000038
						],
						[
							-81.5232619109999,
							30.32959601200008
						],
						[
							-81.52323190699992,
							30.328932012000053
						],
						[
							-81.52319591199995,
							30.32763201300008
						],
						[
							-81.52317290799994,
							30.32673301200009
						],
						[
							-81.52311790099992,
							30.324526012000035
						],
						[
							-81.5247139089999,
							30.32438101000008
						],
						[
							-81.52536290799992,
							30.324313011000072
						],
						[
							-81.5255449089999,
							30.324289010000086
						],
						[
							-81.52562490699995,
							30.324280010000052
						],
						[
							-81.52620090599994,
							30.32421501000005
						],
						[
							-81.5266149069999,
							30.32417001000005
						],
						[
							-81.52694790699991,
							30.324141010000062
						],
						[
							-81.52711490799993,
							30.324129010000032
						],
						[
							-81.5272479059999,
							30.324119010000064
						],
						[
							-81.52739990699992,
							30.324108011000074
						],
						[
							-81.52751890899992,
							30.324096010000062
						],
						[
							-81.52764290599993,
							30.324083011000084
						],
						[
							-81.52777090699993,
							30.32407201000007
						],
						[
							-81.52796190899994,
							30.324055010000052
						],
						[
							-81.52840890599992,
							30.32401401000004
						],
						[
							-81.52879690799995,
							30.323960010000064
						],
						[
							-81.52888694299992,
							30.323947085000043
						],
						[
							-81.52898183799994,
							30.323868849000064
						],
						[
							-81.5295639069999,
							30.32381901000008
						],
						[
							-81.53009790699991,
							30.32376701100009
						],
						[
							-81.53053990899991,
							30.323717010000053
						],
						[
							-81.53199790699995,
							30.323578011000055
						],
						[
							-81.53276790599995,
							30.32351501100004
						],
						[
							-81.53400390599995,
							30.323378010000052
						],
						[
							-81.53515590699993,
							30.323250010000038
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Atlantic Boulevard Estates",
				"RegionID": "268876"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.45051389499993,
					30.305268977000086,
					-81.42594828199992,
					30.323679000000084
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.43680899999993,
							30.323679000000084
						],
						[
							-81.4368429999999,
							30.323414000000074
						],
						[
							-81.43725299999994,
							30.323530000000062
						],
						[
							-81.43786999999992,
							30.32340000000005
						],
						[
							-81.43807099999992,
							30.32326000000006
						],
						[
							-81.43856999999991,
							30.323214000000064
						],
						[
							-81.43809378999993,
							30.322049169000085
						],
						[
							-81.4380875629999,
							30.32166705800006
						],
						[
							-81.4378669219999,
							30.321575066000037
						],
						[
							-81.43780758499992,
							30.321547757000072
						],
						[
							-81.43775038699994,
							30.321516213000056
						],
						[
							-81.43769562999995,
							30.321480601000076
						],
						[
							-81.43764360199992,
							30.32144110800004
						],
						[
							-81.4375945779999,
							30.32139794200009
						],
						[
							-81.43321575899995,
							30.317250625000046
						],
						[
							-81.43197646399996,
							30.31648015100006
						],
						[
							-81.43031859299992,
							30.31551038800006
						],
						[
							-81.43000699999993,
							30.315240000000074
						],
						[
							-81.42610699999994,
							30.313841000000085
						],
						[
							-81.42594828199992,
							30.313264945000075
						],
						[
							-81.42630795499991,
							30.313145148000046
						],
						[
							-81.43221697399991,
							30.311177009000062
						],
						[
							-81.43279554599991,
							30.309585432000066
						],
						[
							-81.43424220299994,
							30.30741514100004
						],
						[
							-81.43568908099991,
							30.30683657200007
						],
						[
							-81.43930599999995,
							30.30640248700007
						],
						[
							-81.44060812599993,
							30.306547388000073
						],
						[
							-81.44191018299995,
							30.30582383600006
						],
						[
							-81.44470195699995,
							30.305268977000086
						],
						[
							-81.44483890799997,
							30.305622012000068
						],
						[
							-81.44493090999993,
							30.305830012000058
						],
						[
							-81.44499990799994,
							30.306026012000075
						],
						[
							-81.44547290799994,
							30.307337012000062
						],
						[
							-81.44552090899992,
							30.30747701200005
						],
						[
							-81.4461289109999,
							30.30911301200007
						],
						[
							-81.44631990799991,
							30.30955101300009
						],
						[
							-81.44663990799995,
							30.310503013000073
						],
						[
							-81.44697590999994,
							30.311399012000038
						],
						[
							-81.4472349099999,
							30.312112012000057
						],
						[
							-81.44730391099995,
							30.31230201200009
						],
						[
							-81.44846290899994,
							30.315430013000082
						],
						[
							-81.44913190799991,
							30.317289012000064
						],
						[
							-81.44939890899991,
							30.317979013000066
						],
						[
							-81.44942790899995,
							30.318058013000044
						],
						[
							-81.44971490899991,
							30.31884501200005
						],
						[
							-81.44980090999991,
							30.319069013000046
						],
						[
							-81.44995090799995,
							30.31947901300003
						],
						[
							-81.4502129089999,
							30.320171013000053
						],
						[
							-81.45043990799991,
							30.320802012000062
						],
						[
							-81.45051389499993,
							30.321014104000085
						],
						[
							-81.45014591099994,
							30.32104501300006
						],
						[
							-81.44976190799993,
							30.32109301200006
						],
						[
							-81.44924491099994,
							30.321189012000044
						],
						[
							-81.44885390999991,
							30.321280013000035
						],
						[
							-81.44794690799995,
							30.321496012000072
						],
						[
							-81.4469489089999,
							30.321738012000086
						],
						[
							-81.44606290999991,
							30.32193301200005
						],
						[
							-81.44532991099993,
							30.322078013000066
						],
						[
							-81.44439090899994,
							30.322339012000043
						],
						[
							-81.44422190799992,
							30.32238601300008
						],
						[
							-81.44349090899993,
							30.322540013000037
						],
						[
							-81.4418129089999,
							30.322897012000055
						],
						[
							-81.44165190899992,
							30.32292501200004
						],
						[
							-81.44093690799991,
							30.32304801300006
						],
						[
							-81.44064791099993,
							30.32309901200006
						],
						[
							-81.43906450399993,
							30.323424548000048
						],
						[
							-81.43851483899994,
							30.323537555000087
						],
						[
							-81.43852099999992,
							30.32343300000008
						],
						[
							-81.43852599999991,
							30.32334300000008
						],
						[
							-81.43814399999991,
							30.323418000000057
						],
						[
							-81.43680899999993,
							30.323679000000084
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Atlantic Highlands",
				"RegionID": "268877"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.35270413899997,
					28.558537028000046,
					-81.33351906599995,
					28.569373
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.345712,
							28.568605
						],
						[
							-81.34570480299999,
							28.568441988000075
						],
						[
							-81.345693,
							28.568103
						],
						[
							-81.34469775899998,
							28.56802610300008
						],
						[
							-81.344696,
							28.567844
						],
						[
							-81.34462,
							28.567845
						],
						[
							-81.344077,
							28.567848
						],
						[
							-81.34346658599998,
							28.567848
						],
						[
							-81.343442,
							28.567848
						],
						[
							-81.34341058199999,
							28.567848
						],
						[
							-81.343183,
							28.567848
						],
						[
							-81.343168,
							28.567979
						],
						[
							-81.342938,
							28.567993
						],
						[
							-81.342931,
							28.568096
						],
						[
							-81.339904,
							28.568096
						],
						[
							-81.33990159099994,
							28.567909649000057
						],
						[
							-81.33974336799997,
							28.56790992300006
						],
						[
							-81.33929768899998,
							28.56790992300006
						],
						[
							-81.33841437899997,
							28.567912927000066
						],
						[
							-81.337864563,
							28.56790992300006
						],
						[
							-81.33578448099996,
							28.567937965000056
						],
						[
							-81.335041377,
							28.567942973000072
						],
						[
							-81.33465580599994,
							28.567944976000035
						],
						[
							-81.33383659399999,
							28.567944974000056
						],
						[
							-81.33374338999994,
							28.56792107800004
						],
						[
							-81.33368921099998,
							28.56788096600008
						],
						[
							-81.33368720399994,
							28.567855749000046
						],
						[
							-81.33376966999998,
							28.567817855000044
						],
						[
							-81.33374545699996,
							28.56774968800005
						],
						[
							-81.33372843099994,
							28.567581437000058
						],
						[
							-81.33371741399998,
							28.566968528000075
						],
						[
							-81.33369337799996,
							28.566255469000055
						],
						[
							-81.33362627899999,
							28.564562961000036
						],
						[
							-81.33361325899995,
							28.56422245500005
						],
						[
							-81.33357420199997,
							28.56332612600005
						],
						[
							-81.33356018099994,
							28.562824380000052
						],
						[
							-81.33355417199994,
							28.56250290400004
						],
						[
							-81.33353314199996,
							28.56214938100004
						],
						[
							-81.33351906599995,
							28.560884499000053
						],
						[
							-81.33360124199999,
							28.56087949700003
						],
						[
							-81.34290103499995,
							28.560800380000046
						],
						[
							-81.34459267199998,
							28.56086535000003
						],
						[
							-81.34459240999996,
							28.561117979000073
						],
						[
							-81.34789657499994,
							28.56121212200003
						],
						[
							-81.34786426299998,
							28.56036259900003
						],
						[
							-81.34987850699997,
							28.56036287300003
						],
						[
							-81.35003555399999,
							28.558537028000046
						],
						[
							-81.35210774299998,
							28.558584089000078
						],
						[
							-81.35210969199994,
							28.558684242000027
						],
						[
							-81.35211473599998,
							28.55931619200004
						],
						[
							-81.35209666899995,
							28.55947741800003
						],
						[
							-81.35200653799996,
							28.559709760000032
						],
						[
							-81.35178320799997,
							28.560067292000042
						],
						[
							-81.35169407499995,
							28.560259581000025
						],
						[
							-81.35165601899996,
							28.56043483800005
						],
						[
							-81.35164509399993,
							28.560584060000053
						],
						[
							-81.35165101099994,
							28.560884504000057
						],
						[
							-81.35165701999995,
							28.561699714000042
						],
						[
							-81.35165701999995,
							28.56173676800006
						],
						[
							-81.35167604899993,
							28.56284340900004
						],
						[
							-81.35167604899993,
							28.56304571000004
						],
						[
							-81.35171009899994,
							28.565255987000057
						],
						[
							-81.35176518099996,
							28.56699556700005
						],
						[
							-81.35178721199998,
							28.56769560500004
						],
						[
							-81.35179021799996,
							28.56774768200006
						],
						[
							-81.35179221799996,
							28.56780482100004
						],
						[
							-81.35224889699998,
							28.56779775700005
						],
						[
							-81.35270254599999,
							28.567788690000043
						],
						[
							-81.35270413899997,
							28.567842789000053
						],
						[
							-81.352514,
							28.567845
						],
						[
							-81.351885,
							28.567845
						],
						[
							-81.350996,
							28.567846000000003
						],
						[
							-81.350344,
							28.567837
						],
						[
							-81.350291,
							28.567778
						],
						[
							-81.35018166299994,
							28.567831887000068
						],
						[
							-81.350151,
							28.567847
						],
						[
							-81.350111,
							28.568142
						],
						[
							-81.349442,
							28.568143
						],
						[
							-81.349442,
							28.567848
						],
						[
							-81.34918435099996,
							28.567848345000076
						],
						[
							-81.348695,
							28.567849
						],
						[
							-81.348563,
							28.567779000000005
						],
						[
							-81.34856012699998,
							28.56785904000003
						],
						[
							-81.348556,
							28.567974
						],
						[
							-81.348556,
							28.568236000000002
						],
						[
							-81.348166,
							28.568236000000002
						],
						[
							-81.348166,
							28.568195
						],
						[
							-81.348075,
							28.568197
						],
						[
							-81.348074,
							28.568029
						],
						[
							-81.34807242999995,
							28.567865718000064
						],
						[
							-81.348072,
							28.567821
						],
						[
							-81.348,
							28.567821
						],
						[
							-81.347693,
							28.567818
						],
						[
							-81.34763979299998,
							28.567818209000052
						],
						[
							-81.346676,
							28.567822
						],
						[
							-81.346672,
							28.568093
						],
						[
							-81.346697,
							28.568093
						],
						[
							-81.346699,
							28.568141
						],
						[
							-81.346698,
							28.568635
						],
						[
							-81.346188,
							28.568636
						],
						[
							-81.346188,
							28.568604000000004
						],
						[
							-81.346049,
							28.568604000000004
						],
						[
							-81.346054,
							28.568672
						],
						[
							-81.346049,
							28.569373
						],
						[
							-81.34573454399998,
							28.569370079000066
						],
						[
							-81.34571796199998,
							28.568864345000065
						],
						[
							-81.345715,
							28.568678
						],
						[
							-81.345712,
							28.568605
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Audubon Park",
				"RegionID": "268878"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.13734512699995,
					26.11725294900009,
					-80.1303577509999,
					26.122599446000038
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.13146938099993,
							26.118883246000056
						],
						[
							-80.13135660699993,
							26.118689920000065
						],
						[
							-80.13114716899992,
							26.118561035000084
						],
						[
							-80.13085717899992,
							26.118480482000052
						],
						[
							-80.13058329899991,
							26.118303266000055
						],
						[
							-80.13040608299991,
							26.118142160000048
						],
						[
							-80.1303577509999,
							26.11798105400004
						],
						[
							-80.13045441499992,
							26.117787727000064
						],
						[
							-80.13085717899992,
							26.11744940500006
						],
						[
							-80.13092651699992,
							26.11725294900009
						],
						[
							-80.13114293099994,
							26.117303537000055
						],
						[
							-80.13373377199991,
							26.11742972500008
						],
						[
							-80.13427658499995,
							26.117518939000036
						],
						[
							-80.13493555699996,
							26.117268300000035
						],
						[
							-80.13614234599993,
							26.117791262000086
						],
						[
							-80.13712780999992,
							26.118010583000057
						],
						[
							-80.1372450689999,
							26.11799956200008
						],
						[
							-80.13726413899991,
							26.118512353000085
						],
						[
							-80.13717373199995,
							26.118746780000038
						],
						[
							-80.13725913099995,
							26.118741535000087
						],
						[
							-80.13726601099995,
							26.11920335600007
						],
						[
							-80.13726603499993,
							26.11920613300009
						],
						[
							-80.13726701199994,
							26.119321530000036
						],
						[
							-80.13727302099994,
							26.119923423000046
						],
						[
							-80.13727307599993,
							26.120001537000064
						],
						[
							-80.13728303599993,
							26.120662520000053
						],
						[
							-80.1372840379999,
							26.120736629000078
						],
						[
							-80.13729805799994,
							26.121088151000038
						],
						[
							-80.13731207899991,
							26.121569866000073
						],
						[
							-80.13733010599992,
							26.12204557000007
						],
						[
							-80.13734512699995,
							26.122421129000088
						],
						[
							-80.13330112999995,
							26.122555327000047
						],
						[
							-80.13228562499995,
							26.122577359000047
						],
						[
							-80.13137126799995,
							26.122599446000038
						],
						[
							-80.13135424299992,
							26.12170306200005
						],
						[
							-80.1313392209999,
							26.120815746000062
						],
						[
							-80.1313170549999,
							26.120069512000043
						],
						[
							-80.1313128349999,
							26.11991237500007
						],
						[
							-80.13130232499992,
							26.11968115800005
						],
						[
							-80.13129531899995,
							26.119527013000038
						],
						[
							-80.13129024099993,
							26.119415297000046
						],
						[
							-80.13128999999992,
							26.11931000000004
						],
						[
							-80.13158215499993,
							26.119304881000062
						],
						[
							-80.13158215499993,
							26.119205458000067
						],
						[
							-80.1315660439999,
							26.119092684000066
						],
						[
							-80.13146938099993,
							26.118883246000056
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Beverly Heights",
				"RegionID": "268892"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.22046999999992,
					25.995268000000067,
					-80.20716899999991,
					26.010167890000048
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.20741586999992,
							26.002696382000067
						],
						[
							-80.20716899999991,
							25.995268000000067
						],
						[
							-80.20816899999994,
							25.99536800000004
						],
						[
							-80.20926899999995,
							25.995268000000067
						],
						[
							-80.2112689999999,
							25.99536800000004
						],
						[
							-80.21346899999992,
							25.99536800000004
						],
						[
							-80.21536999999995,
							25.99536800000004
						],
						[
							-80.21796999999992,
							25.995268000000067
						],
						[
							-80.21946999999994,
							25.995268000000067
						],
						[
							-80.22046999999992,
							25.995268000000067
						],
						[
							-80.22046999999992,
							25.995968000000065
						],
						[
							-80.22046999999992,
							25.996668000000057
						],
						[
							-80.22046999999992,
							25.99736800000005
						],
						[
							-80.22046999999992,
							25.997868000000043
						],
						[
							-80.22046999999992,
							25.99896800000005
						],
						[
							-80.22036999999995,
							25.999088000000086
						],
						[
							-80.21996999999993,
							25.999568000000068
						],
						[
							-80.21913799999993,
							26.000308000000075
						],
						[
							-80.21826699999991,
							26.001082000000054
						],
						[
							-80.21816999999994,
							26.001168000000064
						],
						[
							-80.2177749999999,
							26.00172100000009
						],
						[
							-80.21766999999994,
							26.00186800000006
						],
						[
							-80.21705799999995,
							26.002568000000053
						],
						[
							-80.21696999999995,
							26.002668000000085
						],
						[
							-80.21566999999993,
							26.004468000000088
						],
						[
							-80.21526899999992,
							26.005168000000083
						],
						[
							-80.21616999999992,
							26.005968000000053
						],
						[
							-80.2164699999999,
							26.007168000000036
						],
						[
							-80.2137689999999,
							26.00846800000005
						],
						[
							-80.21336899999994,
							26.00986800000004
						],
						[
							-80.21269827299996,
							26.01002512200006
						],
						[
							-80.20760622699993,
							26.010167890000048
						],
						[
							-80.20741586999992,
							26.002696382000067
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Hollywood",
				"Name": "Beverly Park",
				"RegionID": "268893"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.70574990099993,
					30.438807830000087,
					-81.67108379099994,
					30.46024301200004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.67744990799991,
							30.43900801000007
						],
						[
							-81.67752490799995,
							30.438994007000076
						],
						[
							-81.67758399299993,
							30.438962112000073
						],
						[
							-81.67769584899992,
							30.438807830000087
						],
						[
							-81.67791790799993,
							30.43886901000008
						],
						[
							-81.67862190799991,
							30.438997010000037
						],
						[
							-81.6787669069999,
							30.439006010000075
						],
						[
							-81.6807409079999,
							30.438988011000053
						],
						[
							-81.68180790699995,
							30.43896301000007
						],
						[
							-81.6829759069999,
							30.438938010000072
						],
						[
							-81.68561590799993,
							30.43890201000005
						],
						[
							-81.68608890799993,
							30.438887010000087
						],
						[
							-81.68855290699992,
							30.438854011000043
						],
						[
							-81.6894229699999,
							30.43883895400006
						],
						[
							-81.69195769499993,
							30.44318366300007
						],
						[
							-81.69545240499991,
							30.446937249000086
						],
						[
							-81.69804099899994,
							30.450432062000065
						],
						[
							-81.70075919399994,
							30.451726299000086
						],
						[
							-81.70570740399995,
							30.45495846200004
						],
						[
							-81.70574990099993,
							30.455097010000088
						],
						[
							-81.70565090999992,
							30.455134013000077
						],
						[
							-81.70441490899992,
							30.45561801300005
						],
						[
							-81.70333490999991,
							30.45602601300004
						],
						[
							-81.7022609089999,
							30.456443013000065
						],
						[
							-81.70193590999992,
							30.45659101200005
						],
						[
							-81.70172590999994,
							30.456659012000046
						],
						[
							-81.70063490899992,
							30.457055012000072
						],
						[
							-81.69897590999994,
							30.457691013000044
						],
						[
							-81.6975989099999,
							30.45817301300008
						],
						[
							-81.6972579099999,
							30.458285012000086
						],
						[
							-81.69715490999994,
							30.458326012000047
						],
						[
							-81.69641390999993,
							30.458547012000054
						],
						[
							-81.6952359089999,
							30.45887501300007
						],
						[
							-81.69443790899993,
							30.459074013000077
						],
						[
							-81.69301990899993,
							30.45940001300005
						],
						[
							-81.69115190899993,
							30.459730012000083
						],
						[
							-81.69019790899996,
							30.459870013000057
						],
						[
							-81.68917990999995,
							30.45999301200004
						],
						[
							-81.6879439089999,
							30.460111013000073
						],
						[
							-81.68647990999996,
							30.46020701300006
						],
						[
							-81.68551090999995,
							30.460238013000033
						],
						[
							-81.68450690899994,
							30.46024301200004
						],
						[
							-81.68378690999992,
							30.460224012000083
						],
						[
							-81.68180290999993,
							30.460222012000088
						],
						[
							-81.68057290999992,
							30.46021301200005
						],
						[
							-81.67898087599991,
							30.46020006400005
						],
						[
							-81.67759054299995,
							30.455479876000087
						],
						[
							-81.67616677099994,
							30.452761767000084
						],
						[
							-81.67396643799992,
							30.44900815400007
						],
						[
							-81.67108379099994,
							30.446296022000066
						],
						[
							-81.67163990799992,
							30.44433501100008
						],
						[
							-81.67175590799991,
							30.443845010000075
						],
						[
							-81.67180090699992,
							30.443501010000038
						],
						[
							-81.6718249079999,
							30.443088011000043
						],
						[
							-81.6718279079999,
							30.442670010000082
						],
						[
							-81.67178190699991,
							30.44029301000006
						],
						[
							-81.67177577599995,
							30.43909588100007
						],
						[
							-81.67744990799991,
							30.43900801000007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Biscayne",
				"RegionID": "268895"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.63791779999991,
					27.71920768600006,
					-82.62396667799993,
					27.74270203800006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.62759813699995,
							27.719452998000065
						],
						[
							-82.62765866899991,
							27.71940870600008
						],
						[
							-82.62772268099991,
							27.719369613000083
						],
						[
							-82.62778972699994,
							27.719335990000047
						],
						[
							-82.6278593429999,
							27.71930807000007
						],
						[
							-82.62793104199994,
							27.71928604900006
						],
						[
							-82.62811804199993,
							27.71923704900007
						],
						[
							-82.62819437099996,
							27.71922055200008
						],
						[
							-82.62827184299994,
							27.71921074000005
						],
						[
							-82.62834987399992,
							27.71920768600006
						],
						[
							-82.62842787599993,
							27.719211415000075
						],
						[
							-82.62850525999994,
							27.719221898000058
						],
						[
							-82.62866727999995,
							27.719251626000073
						],
						[
							-82.62873820499993,
							27.71926479600006
						],
						[
							-82.62887822599993,
							27.719302698000035
						],
						[
							-82.6290329059999,
							27.71935830600006
						],
						[
							-82.62915895099991,
							27.71941690600005
						],
						[
							-82.62922389199991,
							27.71938363000004
						],
						[
							-82.62932641399993,
							27.719338914000048
						],
						[
							-82.6293749649999,
							27.71932279100008
						],
						[
							-82.62963096499993,
							27.71924579100005
						],
						[
							-82.62969991699993,
							27.719227996000086
						],
						[
							-82.62977005999996,
							27.71921571200005
						],
						[
							-82.6298409559999,
							27.719209016000036
						],
						[
							-82.6299121589999,
							27.719207951000044
						],
						[
							-82.63048015899994,
							27.719221951000065
						],
						[
							-82.6305518339999,
							27.71922658600005
						],
						[
							-82.63057725999994,
							27.719229254000084
						],
						[
							-82.63168739399993,
							27.71962540000004
						],
						[
							-82.63173792099991,
							27.719675927000083
						],
						[
							-82.6318278359999,
							27.719804339000063
						],
						[
							-82.63189408699992,
							27.71994641400005
						],
						[
							-82.6319346599999,
							27.720097835000047
						],
						[
							-82.63193819999992,
							27.720119449000038
						],
						[
							-82.63196119999992,
							27.72027144900005
						],
						[
							-82.63197132199991,
							27.720406000000082
						],
						[
							-82.63196304899992,
							27.72052770600004
						],
						[
							-82.63193897199994,
							27.720703985000057
						],
						[
							-82.6319300369999,
							27.720829071000082
						],
						[
							-82.63191865999994,
							27.72092116500005
						],
						[
							-82.63187541199994,
							27.721079743000075
						],
						[
							-82.6318590539999,
							27.72112259800008
						],
						[
							-82.6318780869999,
							27.721163414000046
						],
						[
							-82.63189335999994,
							27.721209156000043
						],
						[
							-82.6319353589999,
							27.721347156000036
						],
						[
							-82.6319606589999,
							27.721452834000047
						],
						[
							-82.63197316399993,
							27.72156338800005
						],
						[
							-82.63198616499994,
							27.721819388000085
						],
						[
							-82.63198568099995,
							27.721919308000054
						],
						[
							-82.63196868099993,
							27.722200308000083
						],
						[
							-82.6319566599999,
							27.722302166000077
						],
						[
							-82.63191582699994,
							27.72245429800006
						],
						[
							-82.63190960299994,
							27.72247131100005
						],
						[
							-82.63192423399995,
							27.722524956000086
						],
						[
							-82.63196594699991,
							27.722749895000053
						],
						[
							-82.63198032199995,
							27.722910000000073
						],
						[
							-82.63197875299994,
							27.722963091000054
						],
						[
							-82.6319675979999,
							27.72315160100004
						],
						[
							-82.63196210899991,
							27.723236479000036
						],
						[
							-82.63224236999991,
							27.72338287000008
						],
						[
							-82.6323095059999,
							27.72342171100007
						],
						[
							-82.63237304499995,
							27.723466192000046
						],
						[
							-82.63243251599994,
							27.723515983000084
						],
						[
							-82.6329175159999,
							27.723958983000045
						],
						[
							-82.63299992099991,
							27.72404492700008
						],
						[
							-82.63302665799995,
							27.72407837800006
						],
						[
							-82.63322944599992,
							27.72434485100007
						],
						[
							-82.6334467879999,
							27.72485155600009
						],
						[
							-82.63385489099994,
							27.725241915000087
						],
						[
							-82.63444042899995,
							27.725596787000086
						],
						[
							-82.63497273699994,
							27.72588068400006
						],
						[
							-82.63516791599994,
							27.72602263300007
						],
						[
							-82.6353098649999,
							27.72614683800009
						],
						[
							-82.63541632599993,
							27.726288787000044
						],
						[
							-82.63545181299992,
							27.726448479000055
						],
						[
							-82.63546955699991,
							27.726661402000047
						],
						[
							-82.6354873009999,
							27.72699853000006
						],
						[
							-82.6355050439999,
							27.727796991000048
						],
						[
							-82.6355050439999,
							27.728364786000043
						],
						[
							-82.63561150599993,
							27.72911001700004
						],
						[
							-82.63584217199991,
							27.729642324000054
						],
						[
							-82.63607283899995,
							27.730174632000057
						],
						[
							-82.63623253099992,
							27.730919862000064
						],
						[
							-82.6362147879999,
							27.73168283700005
						],
						[
							-82.63632124899993,
							27.732534529000077
						],
						[
							-82.63649868499994,
							27.733315246000075
						],
						[
							-82.63655191599992,
							27.733652375000077
						],
						[
							-82.6366228899999,
							27.73398950300009
						],
						[
							-82.63683581299995,
							27.734415349000074
						],
						[
							-82.63719068499995,
							27.73505411800005
						],
						[
							-82.6375632999999,
							27.735391246000063
						],
						[
							-82.63791779999991,
							27.735553356000082
						],
						[
							-82.6379123559999,
							27.73604871200007
						],
						[
							-82.63789537199995,
							27.736278198000036
						],
						[
							-82.63787753999992,
							27.736390735000043
						],
						[
							-82.63780153999994,
							27.73672973400005
						],
						[
							-82.6377735339999,
							27.736828081000056
						],
						[
							-82.6376160669999,
							27.73728141800007
						],
						[
							-82.63759384299993,
							27.737344671000074
						],
						[
							-82.63752583599995,
							27.73749166100004
						],
						[
							-82.63751351099995,
							27.737512363000064
						],
						[
							-82.63748395399995,
							27.73756048000007
						],
						[
							-82.6374333409999,
							27.737640930000055
						],
						[
							-82.63741792399993,
							27.737664685000084
						],
						[
							-82.63732047899992,
							27.737819053000067
						],
						[
							-82.63724891999993,
							27.737917073000062
						],
						[
							-82.6372090449999,
							27.737961511000037
						],
						[
							-82.63690404599993,
							27.738279511000087
						],
						[
							-82.63683307299993,
							27.738345921000075
						],
						[
							-82.6367253219999,
							27.738423536000084
						],
						[
							-82.63638632199991,
							27.73863153600007
						],
						[
							-82.63625216799994,
							27.738699129000054
						],
						[
							-82.63578816799992,
							27.738886129000036
						],
						[
							-82.63575958599995,
							27.738897086000065
						],
						[
							-82.63560615199992,
							27.738938009000037
						],
						[
							-82.6352021379999,
							27.739007360000073
						],
						[
							-82.63507879899993,
							27.739019861000088
						],
						[
							-82.63311817199991,
							27.739082677000056
						],
						[
							-82.63310489499992,
							27.739139364000042
						],
						[
							-82.63303589499992,
							27.73937436300008
						],
						[
							-82.63301808599994,
							27.739428586000088
						],
						[
							-82.6329518359999,
							27.739570661000073
						],
						[
							-82.63286192099991,
							27.739699073000054
						],
						[
							-82.63275107299995,
							27.739809920000084
						],
						[
							-82.63270361699995,
							27.739847103000045
						],
						[
							-82.6324956169999,
							27.73999910300006
						],
						[
							-82.63243763799996,
							27.740038111000047
						],
						[
							-82.63237680499992,
							27.740072498000075
						],
						[
							-82.63231348499994,
							27.740102059000037
						],
						[
							-82.63224806099993,
							27.740126614000076
						],
						[
							-82.6321809289999,
							27.74014601500005
						],
						[
							-82.63211249199992,
							27.74016014500006
						],
						[
							-82.63204316499991,
							27.740168919000045
						],
						[
							-82.63189579199991,
							27.740181774000064
						],
						[
							-82.63176541799993,
							27.74019362900009
						],
						[
							-82.63172162599996,
							27.74019406800005
						],
						[
							-82.63179183599993,
							27.74029433900006
						],
						[
							-82.6318193159999,
							27.740345708000063
						],
						[
							-82.63186031499993,
							27.74042870900007
						],
						[
							-82.63188897799995,
							27.740492947000064
						],
						[
							-82.63191253299993,
							27.740559230000088
						],
						[
							-82.63193083499993,
							27.740627151000073
						],
						[
							-82.63194377299993,
							27.740696294000088
						],
						[
							-82.63195126699992,
							27.74076623700006
						],
						[
							-82.63195327099993,
							27.740836552000076
						],
						[
							-82.63194977299992,
							27.74090680900008
						],
						[
							-82.63194079499993,
							27.740976577000083
						],
						[
							-82.63192622699995,
							27.741062871000054
						],
						[
							-82.6318850859999,
							27.74121758600006
						],
						[
							-82.63181883599992,
							27.74135966100005
						],
						[
							-82.63172891999994,
							27.741488073000085
						],
						[
							-82.63161807299991,
							27.741598921000048
						],
						[
							-82.63153275999991,
							27.74166230800006
						],
						[
							-82.63148821499993,
							27.741691485000047
						],
						[
							-82.63146323699993,
							27.74174816400006
						],
						[
							-82.63138023799992,
							27.741907164000054
						],
						[
							-82.63134668599992,
							27.741965936000042
						],
						[
							-82.63130880999995,
							27.742022019000046
						],
						[
							-82.63126682299992,
							27.742075094000086
						],
						[
							-82.6312209649999,
							27.742124862000082
						],
						[
							-82.6311714929999,
							27.742171041000063
						],
						[
							-82.63106228299995,
							27.74226548100006
						],
						[
							-82.63100831299994,
							27.742308033000086
						],
						[
							-82.6309512499999,
							27.742346337000072
						],
						[
							-82.63089142799993,
							27.742380171000036
						],
						[
							-82.63082919599992,
							27.742409336000037
						],
						[
							-82.6307649179999,
							27.742433661000064
						],
						[
							-82.63069896899992,
							27.742453005000073
						],
						[
							-82.63058796899992,
							27.742481006000048
						],
						[
							-82.63050430299995,
							27.74249793300004
						],
						[
							-82.63007418299992,
							27.74256377000006
						],
						[
							-82.63005426099994,
							27.742566623000073
						],
						[
							-82.62999874299993,
							27.742572428000074
						],
						[
							-82.62991816399995,
							27.742579135000085
						],
						[
							-82.62861383799992,
							27.742698681000036
						],
						[
							-82.62851039899994,
							27.74270203800006
						],
						[
							-82.62779439799993,
							27.74268403800005
						],
						[
							-82.62771722899993,
							27.742678771000044
						],
						[
							-82.6275024599999,
							27.742654796000068
						],
						[
							-82.62741268999993,
							27.742644822000045
						],
						[
							-82.62727063599993,
							27.74261732800005
						],
						[
							-82.62706963599993,
							27.742561328000082
						],
						[
							-82.62700242699992,
							27.742539727000068
						],
						[
							-82.62693711999992,
							27.74251292100007
						],
						[
							-82.62687411699994,
							27.742481075000057
						],
						[
							-82.62681380499993,
							27.742444385000056
						],
						[
							-82.62670980599995,
							27.74237538500006
						],
						[
							-82.6266529959999,
							27.742334420000077
						],
						[
							-82.6265995469999,
							27.74228915900005
						],
						[
							-82.62654978199993,
							27.742239876000042
						],
						[
							-82.62650400299994,
							27.74218686900008
						],
						[
							-82.6264624879999,
							27.742130461000045
						],
						[
							-82.62631748699994,
							27.741916461000073
						],
						[
							-82.62627852999992,
							27.741853537000054
						],
						[
							-82.62624487799991,
							27.74178762300005
						],
						[
							-82.62621675999992,
							27.741719165000063
						],
						[
							-82.62619436699993,
							27.741648627000075
						],
						[
							-82.62604136699991,
							27.74108762700007
						],
						[
							-82.6260337619999,
							27.741057734000037
						],
						[
							-82.6258277039999,
							27.74018535800008
						],
						[
							-82.62523220299994,
							27.73831827400005
						],
						[
							-82.62520776999992,
							27.738224483000067
						],
						[
							-82.62508576999994,
							27.737625482000055
						],
						[
							-82.62507439399991,
							27.737555701000076
						],
						[
							-82.62506853399994,
							27.737485243000037
						],
						[
							-82.62506822799992,
							27.737414541000078
						],
						[
							-82.62507100699992,
							27.73733516300007
						],
						[
							-82.6250470999999,
							27.737302387000057
						],
						[
							-82.62481209999993,
							27.73692938700009
						],
						[
							-82.62479416399992,
							27.736899661000052
						],
						[
							-82.62472588599991,
							27.73675189800008
						],
						[
							-82.62455885999992,
							27.73627321200007
						],
						[
							-82.62454012899991,
							27.736212754000064
						],
						[
							-82.62412912899993,
							27.734699753000086
						],
						[
							-82.62411134099995,
							27.73462016500008
						],
						[
							-82.62409969499993,
							27.734524194000073
						],
						[
							-82.62405669499992,
							27.733883194000043
						],
						[
							-82.6240546809999,
							27.733825197000044
						],
						[
							-82.62405172099994,
							27.732613649000086
						],
						[
							-82.62401675699994,
							27.73171817700006
						],
						[
							-82.62396837699993,
							27.730932255000084
						],
						[
							-82.62396667799993,
							27.730877000000078
						],
						[
							-82.62396667799993,
							27.730676000000074
						],
						[
							-82.62398034099994,
							27.730519834000063
						],
						[
							-82.62399399299994,
							27.730456037000067
						],
						[
							-82.62402199299993,
							27.730345038000053
						],
						[
							-82.6240489139999,
							27.73025741400005
						],
						[
							-82.62409988799993,
							27.730142903000058
						],
						[
							-82.62410721799996,
							27.73012860600005
						],
						[
							-82.6240951559999,
							27.73004621700005
						],
						[
							-82.62408567799991,
							27.72991600000006
						],
						[
							-82.62408676399993,
							27.72987182500009
						],
						[
							-82.62409876399994,
							27.72962782600007
						],
						[
							-82.62411134099995,
							27.729515835000086
						],
						[
							-82.6241319369999,
							27.72942614100009
						],
						[
							-82.62418610899994,
							27.729235539000058
						],
						[
							-82.62427228099995,
							27.72893393700008
						],
						[
							-82.62429191399991,
							27.728873414000077
						],
						[
							-82.62436005699993,
							27.728728231000048
						],
						[
							-82.62435084299995,
							27.72856536800009
						],
						[
							-82.62434867799995,
							27.728503000000046
						],
						[
							-82.62435724699992,
							27.72837915100007
						],
						[
							-82.62438301299994,
							27.728193858000054
						],
						[
							-82.62439777899993,
							27.728084566000064
						],
						[
							-82.62443027599994,
							27.727937842000074
						],
						[
							-82.62448627599991,
							27.727757842000074
						],
						[
							-82.62451582999996,
							27.727678952000076
						],
						[
							-82.62455153399992,
							27.72760264900006
						],
						[
							-82.62459316299993,
							27.727529409000056
						],
						[
							-82.62464045599995,
							27.727459693000075
						],
						[
							-82.62462134099992,
							27.72737516600006
						],
						[
							-82.6246076779999,
							27.727219000000048
						],
						[
							-82.6246076779999,
							27.727081000000055
						],
						[
							-82.62461098999995,
							27.727003893000077
						],
						[
							-82.62462090099991,
							27.726927353000065
						],
						[
							-82.62463733699991,
							27.726851945000078
						],
						[
							-82.62466017899993,
							27.726778224000043
						],
						[
							-82.62468925699994,
							27.726706732000082
						],
						[
							-82.62472435799992,
							27.72663799700007
						],
						[
							-82.62481626099992,
							27.726475668000035
						],
						[
							-82.62490807899991,
							27.726343927000073
						],
						[
							-82.62502518699995,
							27.726227922000078
						],
						[
							-82.62509635999993,
							27.72617026200004
						],
						[
							-82.62511871399994,
							27.72615185300009
						],
						[
							-82.62511067799994,
							27.726060000000075
						],
						[
							-82.62512241399992,
							27.725915185000076
						],
						[
							-82.6251534139999,
							27.725725185000044
						],
						[
							-82.62518634599991,
							27.725590095000086
						],
						[
							-82.62561734799995,
							27.724274088000076
						],
						[
							-82.62623975899994,
							27.72237393200004
						],
						[
							-82.6270065409999,
							27.720159098000067
						],
						[
							-82.62707516499995,
							27.720010339000055
						],
						[
							-82.62711824999991,
							27.71994284300007
						],
						[
							-82.62721524999995,
							27.719804843000077
						],
						[
							-82.6272537019999,
							27.71975406000007
						],
						[
							-82.62729565299992,
							27.71970612700005
						],
						[
							-82.62734088999991,
							27.71966128400004
						],
						[
							-82.62738918899993,
							27.719619755000053
						],
						[
							-82.62741466299991,
							27.719599376000076
						],
						[
							-82.62759813699995,
							27.719452998000065
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Coquina Key",
				"RegionID": "268935"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.11976599999991,
					26.166961729000036,
					-80.10294575299991,
					26.189897212000062
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.10316599999993,
							26.18196100000006
						],
						[
							-80.10333751699994,
							26.18189659400008
						],
						[
							-80.10333751699994,
							26.181140993000042
						],
						[
							-80.10350177799995,
							26.17844711300006
						],
						[
							-80.10363318599991,
							26.175983199000086
						],
						[
							-80.10369889099991,
							26.17407777200009
						],
						[
							-80.10376459499992,
							26.172993649000095
						],
						[
							-80.10379712399993,
							26.172494878000066
						],
						[
							-80.10386315199992,
							26.171482448000063
						],
						[
							-80.10402741299993,
							26.16977413400008
						],
						[
							-80.10409311699995,
							26.169018534000088
						],
						[
							-80.10402741299993,
							26.168558603000065
						],
						[
							-80.10412596899994,
							26.167803002000085
						],
						[
							-80.10415183899994,
							26.16749903100009
						],
						[
							-80.10456899999991,
							26.167493000000036
						],
						[
							-80.10466566199995,
							26.16749197000007
						],
						[
							-80.10516041499994,
							26.167485880000072
						],
						[
							-80.10529756099993,
							26.167553206000036
						],
						[
							-80.10682786899991,
							26.16751700700007
						],
						[
							-80.1070622169999,
							26.167488965000075
						],
						[
							-80.10753591899993,
							26.16749096800004
						],
						[
							-80.1076530929999,
							26.167488965000075
						],
						[
							-80.10792950199993,
							26.167485961000068
						],
						[
							-80.10877575799992,
							26.16747394300006
						],
						[
							-80.11705607599993,
							26.167259526000066
						],
						[
							-80.11698593299991,
							26.16716147900007
						],
						[
							-80.11692985099995,
							26.167089373000067
						],
						[
							-80.11687877499992,
							26.16701326100008
						],
						[
							-80.11684778099993,
							26.166961729000036
						],
						[
							-80.11706599999992,
							26.16696200000007
						],
						[
							-80.11906599999992,
							26.169462000000067
						],
						[
							-80.11946599999993,
							26.17036200000007
						],
						[
							-80.11958499999992,
							26.171910000000082
						],
						[
							-80.11966599999994,
							26.172962000000044
						],
						[
							-80.11966599999994,
							26.173662000000036
						],
						[
							-80.11966599999994,
							26.17416200000008
						],
						[
							-80.11966599999994,
							26.17656100000005
						],
						[
							-80.11976599999991,
							26.18046100000004
						],
						[
							-80.11966191499994,
							26.18118823100008
						],
						[
							-80.1196148919999,
							26.181516776000084
						],
						[
							-80.11957462299995,
							26.18179813000006
						],
						[
							-80.11953699999992,
							26.18206100000009
						],
						[
							-80.1193659999999,
							26.183261000000073
						],
						[
							-80.11899975199992,
							26.183261000000073
						],
						[
							-80.1189628649999,
							26.183333464000043
						],
						[
							-80.11891479399992,
							26.183441624000068
						],
						[
							-80.11873252499993,
							26.183718034000037
						],
						[
							-80.11839302099992,
							26.18424181100005
						],
						[
							-80.11793033499993,
							26.184908801000063
						],
						[
							-80.11791531199992,
							26.184932836000087
						],
						[
							-80.11777410199996,
							26.185170188000086
						],
						[
							-80.11744761799991,
							26.18565090000004
						],
						[
							-80.1168297019999,
							26.18659229600007
						],
						[
							-80.1167085219999,
							26.18677957500006
						],
						[
							-80.11625685299992,
							26.18748361900009
						],
						[
							-80.11562090899992,
							26.18847609100004
						],
						[
							-80.11550473699992,
							26.188650350000046
						],
						[
							-80.11519928399991,
							26.189161106000086
						],
						[
							-80.1149869699999,
							26.189515632000052
						],
						[
							-80.11493590599991,
							26.18960475800009
						],
						[
							-80.1147726509999,
							26.18960476400008
						],
						[
							-80.11300703299992,
							26.189637813000047
						],
						[
							-80.11149278799991,
							26.189657843000077
						],
						[
							-80.11050432299993,
							26.189703855000065
						],
						[
							-80.10919938699993,
							26.189740966000045
						],
						[
							-80.10874871699991,
							26.18975098100009
						],
						[
							-80.10691800299992,
							26.189795046000086
						],
						[
							-80.10537771799994,
							26.189828096000042
						],
						[
							-80.10395060399992,
							26.18985814100006
						],
						[
							-80.10382741799994,
							26.189887182000064
						],
						[
							-80.10331599999995,
							26.18989300000004
						],
						[
							-80.10294575299991,
							26.189897212000062
						],
						[
							-80.10296599999992,
							26.189661000000058
						],
						[
							-80.10316599999993,
							26.18196100000006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Coral Ridge Country Club",
				"RegionID": "268936"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.12196599999993,
					26.160849888000087,
					-80.11795921499993,
					26.16696200000007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.11795921499993,
							26.166960988000085
						],
						[
							-80.11801248099994,
							26.160849888000087
						],
						[
							-80.11803773499992,
							26.160865041000083
						],
						[
							-80.11886599999991,
							26.161362000000054
						],
						[
							-80.12127099999992,
							26.162132000000042
						],
						[
							-80.12136599999991,
							26.16216200000008
						],
						[
							-80.12086599999994,
							26.163462000000038
						],
						[
							-80.1218659999999,
							26.164262000000065
						],
						[
							-80.12187640399992,
							26.16453252000008
						],
						[
							-80.12196599999993,
							26.166862000000037
						],
						[
							-80.12181152899991,
							26.166862000000037
						],
						[
							-80.12176599999992,
							26.166862000000037
						],
						[
							-80.1211659999999,
							26.166862000000037
						],
						[
							-80.11986599999994,
							26.16696200000007
						],
						[
							-80.11966599999994,
							26.16696200000007
						],
						[
							-80.11946599999993,
							26.16696200000007
						],
						[
							-80.11877399999992,
							26.16696200000007
						],
						[
							-80.11795921499993,
							26.166960988000085
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Coral Shores",
				"RegionID": "268937"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.32154850599994,
					28.515722573000062,
					-81.3103841109999,
					28.52447554300005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.3103841109999,
							28.523640411000088
						],
						[
							-81.31061624699993,
							28.52362941800004
						],
						[
							-81.31067442599993,
							28.52354310000004
						],
						[
							-81.31059111899992,
							28.523466011000043
						],
						[
							-81.3104557659999,
							28.523272768000083
						],
						[
							-81.31041986299994,
							28.52176949400007
						],
						[
							-81.31045090899994,
							28.520713930000056
						],
						[
							-81.31047093799992,
							28.520132066000087
						],
						[
							-81.3104749449999,
							28.519932770000082
						],
						[
							-81.31047294199993,
							28.519590263000055
						],
						[
							-81.3104689349999,
							28.519240745000047
						],
						[
							-81.31046693299993,
							28.519095528000037
						],
						[
							-81.31045791999992,
							28.51714263300005
						],
						[
							-81.31045691799996,
							28.517069524000078
						],
						[
							-81.31043889199992,
							28.51608706700006
						],
						[
							-81.31043488299991,
							28.51576506500004
						],
						[
							-81.31433359099992,
							28.51572358900006
						],
						[
							-81.31442904999994,
							28.515722573000062
						],
						[
							-81.31442970599994,
							28.515782985000044
						],
						[
							-81.31443200599995,
							28.515928383000073
						],
						[
							-81.31443474199996,
							28.516089777000047
						],
						[
							-81.31443720399994,
							28.516235031000065
						],
						[
							-81.31443959699993,
							28.516376250000064
						],
						[
							-81.31443999999995,
							28.516400000000093
						],
						[
							-81.31443999999995,
							28.51647313400008
						],
						[
							-81.31443999999995,
							28.516606322000086
						],
						[
							-81.31443999999995,
							28.516755654000065
						],
						[
							-81.31443999999995,
							28.516860590000082
						],
						[
							-81.31444525099994,
							28.516933007000034
						],
						[
							-81.31444964799994,
							28.516985781000074
						],
						[
							-81.31445334999995,
							28.517030205000083
						],
						[
							-81.31445705199991,
							28.517074629000035
						],
						[
							-81.31445999999994,
							28.51711000000006
						],
						[
							-81.31458773499992,
							28.51710559500009
						],
						[
							-81.31466029599994,
							28.51710309300006
						],
						[
							-81.31470130499991,
							28.517101679000064
						],
						[
							-81.3147019999999,
							28.517112000000054
						],
						[
							-81.31511499999993,
							28.517112000000054
						],
						[
							-81.31567599999994,
							28.517104000000078
						],
						[
							-81.3157166499999,
							28.517104000000078
						],
						[
							-81.31608914899994,
							28.517111707000083
						],
						[
							-81.31630296499992,
							28.51711613000009
						],
						[
							-81.31646046899994,
							28.517119389000072
						],
						[
							-81.31648999999993,
							28.51712000000009
						],
						[
							-81.31649040399992,
							28.517106797000054
						],
						[
							-81.3165709999999,
							28.51711000000006
						],
						[
							-81.31718099999995,
							28.517116000000044
						],
						[
							-81.31749372799993,
							28.517111595000074
						],
						[
							-81.31810399999995,
							28.51710300000008
						],
						[
							-81.31840097299995,
							28.517091255000082
						],
						[
							-81.31840056499993,
							28.52047971500008
						],
						[
							-81.32154850199993,
							28.52047944800006
						],
						[
							-81.32154850599994,
							28.522144178000076
						],
						[
							-81.31840055599992,
							28.522396300000082
						],
						[
							-81.31842875699994,
							28.524400486000047
						],
						[
							-81.3177136619999,
							28.524445374000038
						],
						[
							-81.31744828699993,
							28.524461486000064
						],
						[
							-81.31663307799994,
							28.52446649500007
						],
						[
							-81.31657098599993,
							28.52446649500007
						],
						[
							-81.31590399599992,
							28.524465492000047
						],
						[
							-81.3155364509999,
							28.524465492000047
						],
						[
							-81.3152580389999,
							28.524464491000064
						],
						[
							-81.31450692499993,
							28.524474507000036
						],
						[
							-81.31445683599992,
							28.52447554300005
						],
						[
							-81.3140592609999,
							28.524420427000056
						],
						[
							-81.31357954799995,
							28.524408408000056
						],
						[
							-81.31351945999995,
							28.52440740600008
						],
						[
							-81.31302071999994,
							28.524395389000063
						],
						[
							-81.31273329299995,
							28.524375359000093
						],
						[
							-81.31240080099991,
							28.524326286000075
						],
						[
							-81.31226560099992,
							28.52429724400008
						],
						[
							-81.3120482779999,
							28.524246167000058
						],
						[
							-81.3118079219999,
							28.52416604800004
						],
						[
							-81.31169074799993,
							28.524123987000053
						],
						[
							-81.31161162999992,
							28.52409494300008
						],
						[
							-81.31095966299995,
							28.523843570000054
						],
						[
							-81.31086452199992,
							28.523809520000043
						],
						[
							-81.31046492999991,
							28.523673319000068
						],
						[
							-81.31041485599991,
							28.523654289000035
						],
						[
							-81.3103841109999,
							28.523640411000088
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Dixie Belle",
				"RegionID": "268950"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.97344008499994,
					28.02416755900009,
					-81.95710191099994,
					28.038781440000037
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.95716491099995,
							28.035851010000044
						],
						[
							-81.9571619109999,
							28.035298010000076
						],
						[
							-81.9571599109999,
							28.035024010000086
						],
						[
							-81.95715691099991,
							28.034255010000038
						],
						[
							-81.95714990999994,
							28.034098009000047
						],
						[
							-81.95713890999991,
							28.033258010000054
						],
						[
							-81.9571379109999,
							28.03229201000005
						],
						[
							-81.9571369109999,
							28.03204301100004
						],
						[
							-81.9571369109999,
							28.031358010000076
						],
						[
							-81.95712491099994,
							28.03046001100006
						],
						[
							-81.95711091099992,
							28.029476011000042
						],
						[
							-81.95711291099991,
							28.028608011000074
						],
						[
							-81.95710391099995,
							28.02763401100009
						],
						[
							-81.95710291099994,
							28.027239010000077
						],
						[
							-81.95710191099994,
							28.02669001000004
						],
						[
							-81.95710496499993,
							28.026335009000036
						],
						[
							-81.95710491099993,
							28.025833010000046
						],
						[
							-81.95710791099994,
							28.025442010000063
						],
						[
							-81.95710891099992,
							28.025002011000083
						],
						[
							-81.95710891099992,
							28.024566010000058
						],
						[
							-81.95710800099994,
							28.02416769100006
						],
						[
							-81.96122944899992,
							28.024167746000046
						],
						[
							-81.96334544199993,
							28.02416755900009
						],
						[
							-81.96338178199994,
							28.02586914200009
						],
						[
							-81.9643669109999,
							28.025865010000075
						],
						[
							-81.9653809109999,
							28.025861010000085
						],
						[
							-81.9663689109999,
							28.025857011000085
						],
						[
							-81.96649190999995,
							28.02585601000004
						],
						[
							-81.96698191099995,
							28.02583801100008
						],
						[
							-81.96712390999994,
							28.025855010000043
						],
						[
							-81.96780690999992,
							28.025851010000054
						],
						[
							-81.96866091099992,
							28.025851010000054
						],
						[
							-81.96886491099991,
							28.025851010000054
						],
						[
							-81.97003890999991,
							28.025851010000054
						],
						[
							-81.97133590999994,
							28.025854010000046
						],
						[
							-81.97255890999992,
							28.02586701000007
						],
						[
							-81.97326591099994,
							28.02587101000006
						],
						[
							-81.97332991099995,
							28.02587101000006
						],
						[
							-81.97341901199991,
							28.02587101100005
						],
						[
							-81.97344008499994,
							28.025956026000074
						],
						[
							-81.97307893899995,
							28.026714061000064
						],
						[
							-81.97235334099992,
							28.027321630000074
						],
						[
							-81.97134727299994,
							28.02814138800005
						],
						[
							-81.97052751399991,
							28.028812101000085
						],
						[
							-81.96978221099994,
							28.029520024000078
						],
						[
							-81.96940966299991,
							28.03037709700004
						],
						[
							-81.96918609199992,
							28.03156947100007
						],
						[
							-81.96903704499994,
							28.032799108000063
						],
						[
							-81.96877626299994,
							28.034028763000038
						],
						[
							-81.96814286799992,
							28.035258468000052
						],
						[
							-81.96709197999992,
							28.036229853000066
						],
						[
							-81.96628116799991,
							28.036682973000044
						],
						[
							-81.96535111199995,
							28.036945298000035
						],
						[
							-81.96420643199991,
							28.037159925000083
						],
						[
							-81.96260864699991,
							28.037446096000053
						],
						[
							-81.96134466299992,
							28.037779846000035
						],
						[
							-81.96077238899994,
							28.03835230100009
						],
						[
							-81.9604269159999,
							28.038781440000037
						],
						[
							-81.95718178099992,
							28.038780140000085
						],
						[
							-81.9571819109999,
							28.038651010000084
						],
						[
							-81.95717590999993,
							28.037742010000045
						],
						[
							-81.95717091099993,
							28.036845010000036
						],
						[
							-81.95716996599992,
							28.03669401700006
						],
						[
							-81.95716491099995,
							28.035851010000044
						]
					],
					[
						[
							-81.9681723349999,
							28.030035827000063
						],
						[
							-81.96817660799991,
							28.03001670900005
						],
						[
							-81.96729553599994,
							28.03051920300004
						],
						[
							-81.9672477599999,
							28.030544577000057
						],
						[
							-81.96719415599995,
							28.030568865000077
						],
						[
							-81.96719252299994,
							28.030569539000055
						],
						[
							-81.96640352299994,
							28.030894540000077
						],
						[
							-81.96635007799995,
							28.03091459500007
						],
						[
							-81.96630367299991,
							28.030928962000075
						],
						[
							-81.9660038429999,
							28.031012985000075
						],
						[
							-81.96466553199991,
							28.031522287000087
						],
						[
							-81.96454134499993,
							28.03159254400009
						],
						[
							-81.96412550399992,
							28.03193361800004
						],
						[
							-81.96384612399993,
							28.03218978700005
						],
						[
							-81.96376173499993,
							28.032281053000077
						],
						[
							-81.96369220699995,
							28.032370082000057
						],
						[
							-81.96359825299993,
							28.03258840400008
						],
						[
							-81.96349859199995,
							28.033033500000045
						],
						[
							-81.96349773999992,
							28.033037267000054
						],
						[
							-81.96346516299991,
							28.03317988300006
						],
						[
							-81.96342894799994,
							28.033538409000073
						],
						[
							-81.96343311899994,
							28.033590555000046
						],
						[
							-81.96343645199994,
							28.03360001100009
						],
						[
							-81.96355648399992,
							28.033795593000036
						],
						[
							-81.96356883599992,
							28.033816339000055
						],
						[
							-81.96359657799991,
							28.03386824000006
						],
						[
							-81.9636138269999,
							28.033905320000088
						],
						[
							-81.96385710099992,
							28.034460981000052
						],
						[
							-81.96388921599993,
							28.034516112000063
						],
						[
							-81.96402256199991,
							28.034605192000072
						],
						[
							-81.96402263599992,
							28.03460524100007
						],
						[
							-81.96407047199996,
							28.03463952000004
						],
						[
							-81.96411596399992,
							28.034676854000054
						],
						[
							-81.9641390569999,
							28.03469782600007
						],
						[
							-81.96427305699991,
							28.034823826000036
						],
						[
							-81.9642745509999,
							28.03482523300005
						],
						[
							-81.96459777299992,
							28.035130551000066
						],
						[
							-81.96485201399992,
							28.035343149000084
						],
						[
							-81.96556092999992,
							28.035527499000068
						],
						[
							-81.9656893149999,
							28.035552384000084
						],
						[
							-81.96581808399992,
							28.035556426000085
						],
						[
							-81.96596619499992,
							28.03555378100009
						],
						[
							-81.96610543899993,
							28.035481892000064
						],
						[
							-81.96610680899994,
							28.035481186000084
						],
						[
							-81.96628681999994,
							28.035388641000054
						],
						[
							-81.96678286699995,
							28.03474434900005
						],
						[
							-81.9668953549999,
							28.034571766000056
						],
						[
							-81.96733441299995,
							28.033804386000043
						],
						[
							-81.96733566299991,
							28.033802209000044
						],
						[
							-81.96761677099994,
							28.033314058000087
						],
						[
							-81.9678388129999,
							28.03202526700005
						],
						[
							-81.96796354299994,
							28.03108832500004
						],
						[
							-81.9679729579999,
							28.03103155100007
						],
						[
							-81.96797314199995,
							28.031030628000057
						],
						[
							-81.96816814199991,
							28.03005562800007
						],
						[
							-81.9681723349999,
							28.030035827000063
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Polk",
				"City": "Lakeland",
				"Name": "Dixieland",
				"RegionID": "268951"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.50286104299994,
					30.35912987900008,
					-81.47926091999994,
					30.37950101200005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.49369590799995,
							30.37849101200004
						],
						[
							-81.49348190899991,
							30.37847501300007
						],
						[
							-81.49287191099995,
							30.378477012000076
						],
						[
							-81.49121690899995,
							30.378457012000073
						],
						[
							-81.4909199089999,
							30.378421012000043
						],
						[
							-81.49064490899991,
							30.378356012000044
						],
						[
							-81.4903779089999,
							30.37826001300004
						],
						[
							-81.4902559109999,
							30.378206012000078
						],
						[
							-81.49012790799992,
							30.378134012000086
						],
						[
							-81.48986790999993,
							30.377966011000066
						],
						[
							-81.48966990899993,
							30.377783012000066
						],
						[
							-81.48956290899991,
							30.37767001100008
						],
						[
							-81.48939490999993,
							30.37745101100006
						],
						[
							-81.4892649119999,
							30.377220012000066
						],
						[
							-81.4865949089999,
							30.370888013000073
						],
						[
							-81.48614491099994,
							30.36982301200004
						],
						[
							-81.48595790899992,
							30.36938001200008
						],
						[
							-81.48524091099995,
							30.367732012000086
						],
						[
							-81.4845069079999,
							30.36597601200009
						],
						[
							-81.48410690899993,
							30.36500101300004
						],
						[
							-81.48361590999991,
							30.363869013000052
						],
						[
							-81.48316890899991,
							30.36280301200009
						],
						[
							-81.4830779099999,
							30.36255601300007
						],
						[
							-81.4830089909999,
							30.362430972000084
						],
						[
							-81.48291790899992,
							30.362223013000065
						],
						[
							-81.48271190999992,
							30.361855013000078
						],
						[
							-81.48265190899991,
							30.361769012000085
						],
						[
							-81.48250790899995,
							30.361547013000063
						],
						[
							-81.48225590899995,
							30.361236013000056
						],
						[
							-81.48192490899993,
							30.360872013000062
						],
						[
							-81.48165090999993,
							30.360605013000054
						],
						[
							-81.48133791099991,
							30.36034701200009
						],
						[
							-81.48112990899995,
							30.360197013000064
						],
						[
							-81.48101190799991,
							30.36011201200006
						],
						[
							-81.4808449109999,
							30.360015012000076
						],
						[
							-81.48063290899995,
							30.359874013000084
						],
						[
							-81.48053290999991,
							30.35981901200006
						],
						[
							-81.47989491099992,
							30.35952201300006
						],
						[
							-81.47926091999994,
							30.359315112000047
						],
						[
							-81.47935382199995,
							30.35919391000004
						],
						[
							-81.4794279109999,
							30.35914701400009
						],
						[
							-81.47947788699992,
							30.35912987900008
						],
						[
							-81.47965790899991,
							30.359133013000072
						],
						[
							-81.48032790799994,
							30.359188012000065
						],
						[
							-81.48090191099993,
							30.359230012000072
						],
						[
							-81.48147890899992,
							30.359260013000043
						],
						[
							-81.48200590899995,
							30.35928501300009
						],
						[
							-81.48367890899995,
							30.35935801300008
						],
						[
							-81.48376490899994,
							30.359355013000087
						],
						[
							-81.48463790799991,
							30.35940301300008
						],
						[
							-81.48794990999994,
							30.359531013000037
						],
						[
							-81.48946190799991,
							30.359599012000047
						],
						[
							-81.49021440999991,
							30.35963101300007
						],
						[
							-81.49135190899995,
							30.359695013000074
						],
						[
							-81.4915429109999,
							30.359698013000067
						],
						[
							-81.4917519089999,
							30.359718012000087
						],
						[
							-81.49539090899992,
							30.35984801300009
						],
						[
							-81.49554690899993,
							30.35985801200007
						],
						[
							-81.49587391099995,
							30.35987501200009
						],
						[
							-81.49797890999992,
							30.359967013000077
						],
						[
							-81.49842490899994,
							30.359991012000084
						],
						[
							-81.49944890799992,
							30.36007101200005
						],
						[
							-81.50040491099992,
							30.360113012000056
						],
						[
							-81.50272890799994,
							30.360269012000064
						],
						[
							-81.50280892699993,
							30.360274005000065
						],
						[
							-81.50280690999995,
							30.36032101300009
						],
						[
							-81.50280198699994,
							30.36103503200007
						],
						[
							-81.5027227409999,
							30.361147964000057
						],
						[
							-81.50272590999992,
							30.36208501200008
						],
						[
							-81.5027589099999,
							30.36351801300009
						],
						[
							-81.50279990999991,
							30.36475701200004
						],
						[
							-81.5028019099999,
							30.364802013000084
						],
						[
							-81.50280990999994,
							30.36612401200006
						],
						[
							-81.50279090999993,
							30.366918012000045
						],
						[
							-81.50281390899994,
							30.36780001200009
						],
						[
							-81.5028239099999,
							30.36807401200008
						],
						[
							-81.5028239099999,
							30.36838401200004
						],
						[
							-81.50283690999993,
							30.36901901200008
						],
						[
							-81.50284290999991,
							30.36933001300008
						],
						[
							-81.50286104299994,
							30.370390145000048
						],
						[
							-81.50271280599992,
							30.370388853000065
						],
						[
							-81.50219172499995,
							30.37159005200004
						],
						[
							-81.5028290809999,
							30.372208036000078
						],
						[
							-81.50117673799991,
							30.373011987000044
						],
						[
							-81.50282308999994,
							30.374628032000086
						],
						[
							-81.50198574199993,
							30.375144014000053
						],
						[
							-81.50284307999993,
							30.375657000000047
						],
						[
							-81.50197072999993,
							30.37634900800009
						],
						[
							-81.50282208699993,
							30.377112943000043
						],
						[
							-81.50278990899994,
							30.37743901200008
						],
						[
							-81.50273490899991,
							30.377879013000044
						],
						[
							-81.5026659099999,
							30.378364013000066
						],
						[
							-81.50262890999994,
							30.37864601200005
						],
						[
							-81.50252292699992,
							30.379373066000085
						],
						[
							-81.49951690899991,
							30.37944101200009
						],
						[
							-81.49878490299996,
							30.379463957000045
						],
						[
							-81.49789690999995,
							30.37947901200005
						],
						[
							-81.49675790999993,
							30.37950101200005
						],
						[
							-81.49655191099993,
							30.37949901200005
						],
						[
							-81.4962159079999,
							30.379469013000065
						],
						[
							-81.49603291099993,
							30.379440012000092
						],
						[
							-81.4958949089999,
							30.379404012000062
						],
						[
							-81.49564391099995,
							30.37931301200007
						],
						[
							-81.4951549079999,
							30.379070013000046
						],
						[
							-81.49491090999993,
							30.378933012000058
						],
						[
							-81.49439990899992,
							30.378674013000083
						],
						[
							-81.49430790899993,
							30.37863801200007
						],
						[
							-81.49407890899994,
							30.37856101200003
						],
						[
							-81.4939029109999,
							30.37852001300007
						],
						[
							-81.49369590799995,
							30.37849101200004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Cobblestone",
				"RegionID": "268925"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.13158215499993,
					26.115607981000043,
					-80.1237894329999,
					26.122721811000076
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.1237894329999,
							26.122721811000076
						],
						[
							-80.12429977999994,
							26.120928914000046
						],
						[
							-80.1243830759999,
							26.12024786900008
						],
						[
							-80.12432769499992,
							26.120155749000048
						],
						[
							-80.12482254699995,
							26.119427804000054
						],
						[
							-80.12552860199992,
							26.118562404000045
						],
						[
							-80.12648309999993,
							26.116817841000056
						],
						[
							-80.12656924399994,
							26.115607981000043
						],
						[
							-80.1282075929999,
							26.116663780000067
						],
						[
							-80.12900477599993,
							26.11596236300005
						],
						[
							-80.12980685699995,
							26.116991221000035
						],
						[
							-80.13092651699992,
							26.11725294900009
						],
						[
							-80.13085717899992,
							26.11744940500006
						],
						[
							-80.13045441499992,
							26.117787727000064
						],
						[
							-80.1303577509999,
							26.11798105400004
						],
						[
							-80.13040608299991,
							26.118142160000048
						],
						[
							-80.13058329899991,
							26.118303266000055
						],
						[
							-80.13085717899992,
							26.118480482000052
						],
						[
							-80.13114716899992,
							26.118561035000084
						],
						[
							-80.13135660699993,
							26.118689920000065
						],
						[
							-80.13146938099993,
							26.118883246000056
						],
						[
							-80.1315660439999,
							26.119092684000066
						],
						[
							-80.13158215499993,
							26.119205458000067
						],
						[
							-80.13158215499993,
							26.119304881000062
						],
						[
							-80.13128999999992,
							26.11931000000004
						],
						[
							-80.13129024099993,
							26.119415297000046
						],
						[
							-80.13129531899995,
							26.119527013000038
						],
						[
							-80.13130232499992,
							26.11968115800005
						],
						[
							-80.1313128349999,
							26.11991237500007
						],
						[
							-80.1313170549999,
							26.120069512000043
						],
						[
							-80.1313392209999,
							26.120815746000062
						],
						[
							-80.13135424299992,
							26.12170306200005
						],
						[
							-80.13137126799995,
							26.122599446000038
						],
						[
							-80.13125609699995,
							26.122602396000048
						],
						[
							-80.13025661499995,
							26.122621424000044
						],
						[
							-80.13000524299993,
							26.122627433000048
						],
						[
							-80.12923409899992,
							26.122641455000064
						],
						[
							-80.12863220499992,
							26.12264946600004
						],
						[
							-80.12751054299991,
							26.12266048200007
						],
						[
							-80.12725816799991,
							26.122664488000055
						],
						[
							-80.12588399799995,
							26.122683650000056
						],
						[
							-80.12574174299994,
							26.122682765000036
						],
						[
							-80.12539464999992,
							26.122689707000063
						],
						[
							-80.1251030169999,
							26.122695540000052
						],
						[
							-80.1237894329999,
							26.122721811000076
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Colee Hammock",
				"RegionID": "268926"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.70230109199991,
					30.337397997000036,
					-81.68645085999992,
					30.348633008000032
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.69538890599995,
							30.34852000900008
						],
						[
							-81.69414490499992,
							30.348043008000047
						],
						[
							-81.6929589049999,
							30.34757300900009
						],
						[
							-81.6926879049999,
							30.34746700900007
						],
						[
							-81.69200890499991,
							30.34721100900003
						],
						[
							-81.69127690499994,
							30.346937008000058
						],
						[
							-81.69055190599994,
							30.346657008000083
						],
						[
							-81.68984190499992,
							30.346371008000066
						],
						[
							-81.68945590599992,
							30.346222009000083
						],
						[
							-81.68855090499994,
							30.345858008000054
						],
						[
							-81.68693890599991,
							30.34523800800008
						],
						[
							-81.68659990499992,
							30.345103008000084
						],
						[
							-81.68645085999992,
							30.345043048000033
						],
						[
							-81.6867258769999,
							30.341799380000058
						],
						[
							-81.6868170759999,
							30.339697873000034
						],
						[
							-81.6892578959999,
							30.337397997000036
						],
						[
							-81.68993290799995,
							30.337927010000044
						],
						[
							-81.69106290799994,
							30.33881301000008
						],
						[
							-81.69276090799991,
							30.340143009000087
						],
						[
							-81.69308790799994,
							30.34033301100004
						],
						[
							-81.69466990799992,
							30.341370011000038
						],
						[
							-81.69612890899992,
							30.342437013000055
						],
						[
							-81.69703590799992,
							30.343460010000058
						],
						[
							-81.69786290699994,
							30.34417401100006
						],
						[
							-81.7020991199999,
							30.347794127000043
						],
						[
							-81.70230109199991,
							30.348103033000086
						],
						[
							-81.70175194299992,
							30.348621198000043
						],
						[
							-81.70137780599993,
							30.348490868000056
						],
						[
							-81.70137803999995,
							30.348602142000065
						],
						[
							-81.69994390499994,
							30.348604008000052
						],
						[
							-81.69850890599992,
							30.348610008000037
						],
						[
							-81.69709790399992,
							30.348622953000074
						],
						[
							-81.69629090599994,
							30.34862900800005
						],
						[
							-81.69581590599995,
							30.348633008000032
						],
						[
							-81.69564790399994,
							30.34861800600004
						],
						[
							-81.69538890599995,
							30.34852000900008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "College Gardens",
				"RegionID": "268927"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.35200602799995,
					28.547659878000047,
					-81.31442762099994,
					28.561212122000086
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.34459267199993,
							28.560865350000086
						],
						[
							-81.3429010349999,
							28.560800380000046
						],
						[
							-81.33360124199993,
							28.560879497000087
						],
						[
							-81.33351906599995,
							28.560884499000053
						],
						[
							-81.33350009199995,
							28.56022252300005
						],
						[
							-81.33349207899994,
							28.559256090000076
						],
						[
							-81.33348607199991,
							28.558693255000037
						],
						[
							-81.33348293299991,
							28.558294536000062
						],
						[
							-81.33356632399995,
							28.558291789000066
						],
						[
							-81.33356031199992,
							28.55716785700008
						],
						[
							-81.33347205099994,
							28.55717199800006
						],
						[
							-81.33337590799995,
							28.557170998000064
						],
						[
							-81.33241648599994,
							28.55715297000006
						],
						[
							-81.33159018399994,
							28.55713811700008
						],
						[
							-81.33144810599993,
							28.556985546000078
						],
						[
							-81.33134287299993,
							28.557008705000044
						],
						[
							-81.33123777999992,
							28.557063963000076
						],
						[
							-81.33088020799994,
							28.557108904000074
						],
						[
							-81.33055572599994,
							28.557112909000068
						],
						[
							-81.3304355489999,
							28.557088874000044
						],
						[
							-81.33027483299992,
							28.557023146000063
						],
						[
							-81.32965754199995,
							28.55700808000006
						],
						[
							-81.3296709999999,
							28.55697900000007
						],
						[
							-81.3296709999999,
							28.556564000000037
						],
						[
							-81.3296719999999,
							28.556178000000045
						],
						[
							-81.32947029199994,
							28.55617834700007
						],
						[
							-81.32908999999995,
							28.556179000000043
						],
						[
							-81.32761299999993,
							28.556179000000043
						],
						[
							-81.32761899999991,
							28.556426000000044
						],
						[
							-81.32741699999991,
							28.556423000000052
						],
						[
							-81.3274199999999,
							28.556188000000077
						],
						[
							-81.32728999999995,
							28.556179000000043
						],
						[
							-81.32584099999991,
							28.55617600000005
						],
						[
							-81.32584099999991,
							28.555934000000036
						],
						[
							-81.32662899999993,
							28.55593200000004
						],
						[
							-81.32662899999993,
							28.55579700000004
						],
						[
							-81.32662499999994,
							28.555670000000077
						],
						[
							-81.32661999999993,
							28.555374000000086
						],
						[
							-81.32729799999993,
							28.55536500000005
						],
						[
							-81.32729603999991,
							28.55526307100007
						],
						[
							-81.32728999999995,
							28.55494900000008
						],
						[
							-81.32752299999993,
							28.55494900000008
						],
						[
							-81.32751699999994,
							28.554565000000082
						],
						[
							-81.32751803399992,
							28.554417110000088
						],
						[
							-81.32751899999994,
							28.554279000000065
						],
						[
							-81.32743499999992,
							28.554279000000065
						],
						[
							-81.32744098799992,
							28.553991600000074
						],
						[
							-81.32744799999995,
							28.55365500000005
						],
						[
							-81.32735060399995,
							28.55365500000005
						],
						[
							-81.32728999999995,
							28.55365500000005
						],
						[
							-81.32549675899992,
							28.553624592000062
						],
						[
							-81.32543314999992,
							28.553623513000048
						],
						[
							-81.32516699999991,
							28.553619000000086
						],
						[
							-81.32459999999992,
							28.55362400000007
						],
						[
							-81.32422686699994,
							28.55362195000004
						],
						[
							-81.32368999999994,
							28.553619000000086
						],
						[
							-81.32279599999993,
							28.55361300000004
						],
						[
							-81.3225153489999,
							28.553609178000045
						],
						[
							-81.32228199999992,
							28.55360600000006
						],
						[
							-81.32184180399992,
							28.55360600000006
						],
						[
							-81.32162699999992,
							28.55360600000006
						],
						[
							-81.32151499999993,
							28.553604000000064
						],
						[
							-81.32116599999995,
							28.55359700000008
						],
						[
							-81.31976099999991,
							28.55355600000007
						],
						[
							-81.31945399999996,
							28.553550000000087
						],
						[
							-81.31862899999993,
							28.55357200000009
						],
						[
							-81.31716007699993,
							28.55357200000009
						],
						[
							-81.31702899999993,
							28.55357200000009
						],
						[
							-81.31442762099994,
							28.553575411000054
						],
						[
							-81.31444928399992,
							28.55356518900004
						],
						[
							-81.31460228299994,
							28.553496189000043
						],
						[
							-81.31462784399993,
							28.553485135000074
						],
						[
							-81.31468292199992,
							28.553464405000057
						],
						[
							-81.3147392379999,
							28.553447322000068
						],
						[
							-81.31479655099992,
							28.553433958000085
						],
						[
							-81.31485461499994,
							28.553424372000052
						],
						[
							-81.31485896099991,
							28.553423810000083
						],
						[
							-81.31495580099994,
							28.55341154100006
						],
						[
							-81.3150392419999,
							28.553345954000065
						],
						[
							-81.31504752699993,
							28.55333951900008
						],
						[
							-81.3150953629999,
							28.55330524100009
						],
						[
							-81.31514440899993,
							28.553274701000078
						],
						[
							-81.31525840899991,
							28.553208702000063
						],
						[
							-81.31525933899992,
							28.55320816400007
						],
						[
							-81.31531123999991,
							28.55318042300007
						],
						[
							-81.31536484399993,
							28.55315613500005
						],
						[
							-81.31541992199993,
							28.553135405000038
						],
						[
							-81.31547623799992,
							28.553118322000046
						],
						[
							-81.31553355099993,
							28.553104958000063
						],
						[
							-81.3155755919999,
							28.553097628000046
						],
						[
							-81.31575559299996,
							28.553070628000057
						],
						[
							-81.3157716149999,
							28.55306837200004
						],
						[
							-81.31580646299994,
							28.553064473000063
						],
						[
							-81.31632646799994,
							28.552837672000067
						],
						[
							-81.31634184399991,
							28.55283113500008
						],
						[
							-81.31639692199991,
							28.55281040500006
						],
						[
							-81.31645323799995,
							28.55279332200007
						],
						[
							-81.31648313399995,
							28.55278585800005
						],
						[
							-81.31678113399994,
							28.552716858000053
						],
						[
							-81.31680855099997,
							28.552710958000034
						],
						[
							-81.31686661499992,
							28.552701372000058
						],
						[
							-81.3168774959999,
							28.552700007000055
						],
						[
							-81.31774949599992,
							28.552596006000048
						],
						[
							-81.31776670699992,
							28.552594121000084
						],
						[
							-81.31822770699995,
							28.552548122000076
						],
						[
							-81.31825818099992,
							28.552545604000045
						],
						[
							-81.31831699999992,
							28.552543678000063
						],
						[
							-81.31837260299994,
							28.552545399000053
						],
						[
							-81.31872947999994,
							28.55256750600006
						],
						[
							-81.3188010419999,
							28.55252566100006
						],
						[
							-81.31880533899994,
							28.552523164000036
						],
						[
							-81.31885723799991,
							28.552495424000085
						],
						[
							-81.31895164299993,
							28.552448868000056
						],
						[
							-81.31904839599991,
							28.552356044000078
						],
						[
							-81.31907803599995,
							28.552328854000052
						],
						[
							-81.31912352699993,
							28.55229152000004
						],
						[
							-81.31914950299995,
							28.552272319000057
						],
						[
							-81.31915439199992,
							28.552257931000042
						],
						[
							-81.31915313499991,
							28.552255155000072
						],
						[
							-81.31913240499995,
							28.552200077000066
						],
						[
							-81.3191153219999,
							28.55214376100008
						],
						[
							-81.31910195799993,
							28.552086449000058
						],
						[
							-81.31909237199994,
							28.552028385000085
						],
						[
							-81.3190866029999,
							28.55196981800009
						],
						[
							-81.31908467799991,
							28.551911000000075
						],
						[
							-81.3190866029999,
							28.551852181000072
						],
						[
							-81.3190904949999,
							28.551808880000067
						],
						[
							-81.31909449499994,
							28.55177388000004
						],
						[
							-81.31909637199993,
							28.55175861500004
						],
						[
							-81.31910595799991,
							28.55170055100007
						],
						[
							-81.31911932199995,
							28.551643238000054
						],
						[
							-81.31913640499994,
							28.55158692200007
						],
						[
							-81.3191571349999,
							28.55153184400007
						],
						[
							-81.31918142299992,
							28.55147824000005
						],
						[
							-81.31920916399991,
							28.551426339000045
						],
						[
							-81.31921568299992,
							28.55141526400007
						],
						[
							-81.32037593799993,
							28.551410763000035
						],
						[
							-81.33804896299995,
							28.55134220800005
						],
						[
							-81.33815086599992,
							28.552466163000076
						],
						[
							-81.3393098329999,
							28.552466162000087
						],
						[
							-81.33947883399992,
							28.55056004900007
						],
						[
							-81.34346500399994,
							28.550490959000058
						],
						[
							-81.34343068599992,
							28.551309435000064
						],
						[
							-81.34452054199994,
							28.551309459000038
						],
						[
							-81.3447247389999,
							28.55079754500008
						],
						[
							-81.34537177999994,
							28.54967390300004
						],
						[
							-81.34538462899991,
							28.54950260600009
						],
						[
							-81.34785150599993,
							28.54950075000005
						],
						[
							-81.34783922499992,
							28.547799970000085
						],
						[
							-81.35194153099991,
							28.547659878000047
						],
						[
							-81.35200602799995,
							28.55318709000005
						],
						[
							-81.35156488399991,
							28.553188090000052
						],
						[
							-81.34996951799991,
							28.553225145000056
						],
						[
							-81.34787841499991,
							28.553248179000036
						],
						[
							-81.34777513199992,
							28.55324905200007
						],
						[
							-81.34780143599994,
							28.555926284000066
						],
						[
							-81.34569304199994,
							28.555926016000058
						],
						[
							-81.34569304599995,
							28.55768689100006
						],
						[
							-81.3500046989999,
							28.55771967700008
						],
						[
							-81.35003555399993,
							28.558537028000046
						],
						[
							-81.34987850699991,
							28.560362873000088
						],
						[
							-81.3478642629999,
							28.560362599000086
						],
						[
							-81.34789657499994,
							28.561212122000086
						],
						[
							-81.3445924099999,
							28.561117979000073
						],
						[
							-81.34459267199993,
							28.560865350000086
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Colonial Town Center",
				"RegionID": "268928"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.10636800399993,
					26.152626790000056,
					-80.10236812999995,
					26.163014931000077
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.10299605799992,
							26.16298441100008
						],
						[
							-80.10300332899993,
							26.160252099000047
						],
						[
							-80.10252936299992,
							26.16026939300008
						],
						[
							-80.10249544299995,
							26.15615014900004
						],
						[
							-80.10236812999995,
							26.152626790000056
						],
						[
							-80.1027207859999,
							26.152661029000058
						],
						[
							-80.10304325599992,
							26.15269302200005
						],
						[
							-80.10600599999992,
							26.152662000000078
						],
						[
							-80.10636800399993,
							26.152886659000046
						],
						[
							-80.10619565799993,
							26.153150923000055
						],
						[
							-80.10589998799992,
							26.153709411000083
						],
						[
							-80.10567002199991,
							26.15436645500006
						],
						[
							-80.10550576199995,
							26.155286316000062
						],
						[
							-80.10530864799995,
							26.15640329100006
						],
						[
							-80.10507868299993,
							26.157553118000067
						],
						[
							-80.10494727399993,
							26.158374422000065
						],
						[
							-80.10481586499992,
							26.159294284000058
						],
						[
							-80.10478301299992,
							26.160378406000063
						],
						[
							-80.10465160399991,
							26.161232563000056
						],
						[
							-80.1045858999999,
							26.162480947000063
						],
						[
							-80.10453878399994,
							26.163014931000077
						],
						[
							-80.10411070699992,
							26.163006463000045
						],
						[
							-80.10299605799992,
							26.16298441100008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Dolphin Isles",
				"RegionID": "268952"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.62139900399987,
					30.510996577000174,
					-81.5407049509999,
					30.574892574811514
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.60742957800096,
							30.574455690997763
						],
						[
							-81.60685999999993,
							30.574200000000143
						],
						[
							-81.60497199999986,
							30.57349800000015
						],
						[
							-81.60441990428022,
							30.57319217286213
						],
						[
							-81.60397389450249,
							30.57294519052018
						],
						[
							-81.60332499999991,
							30.572586000000182
						],
						[
							-81.60274199999992,
							30.571962000000067
						],
						[
							-81.6021569999999,
							30.57113000000015
						],
						[
							-81.60186399999994,
							30.57058800000007
						],
						[
							-81.60156799999994,
							30.569545000000105
						],
						[
							-81.6014159999998,
							30.568417000000025
						],
						[
							-81.60145999999979,
							30.567665000000158
						],
						[
							-81.6019389999999,
							30.567120000000006
						],
						[
							-81.60237299999993,
							30.566985000000024
						],
						[
							-81.60275899999989,
							30.566865000000046
						],
						[
							-81.60357799999989,
							30.566736000000034
						],
						[
							-81.60439899999996,
							30.56669100000004
						],
						[
							-81.60512299999992,
							30.566687000000062
						],
						[
							-81.60589499999993,
							30.566600000000143
						],
						[
							-81.60656999999992,
							30.566513000000054
						],
						[
							-81.6077279999999,
							30.566341000000214
						],
						[
							-81.60869199999989,
							30.56600200000005
						],
						[
							-81.6097029999998,
							30.56566300000007
						],
						[
							-81.61076299999992,
							30.565240000000067
						],
						[
							-81.61101099999992,
							30.565124000000058
						],
						[
							-81.61148499999989,
							30.56490300000007
						],
						[
							-81.61190651303325,
							30.56471797207624
						],
						[
							-81.61225499999982,
							30.56456500000017
						],
						[
							-81.61307399999991,
							30.56418500000017
						],
						[
							-81.61324575529407,
							30.564045698823534
						],
						[
							-81.61374599999992,
							30.563639000000116
						],
						[
							-81.61417699999987,
							30.56305200000022
						],
						[
							-81.61426899999994,
							30.56238300000011
						],
						[
							-81.61407199999988,
							30.56167400000006
						],
						[
							-81.6137779999999,
							30.560964000000116
						],
						[
							-81.6134839999999,
							30.560339000000095
						],
						[
							-81.61299699999994,
							30.559673000000057
						],
						[
							-81.61250999999987,
							30.559048000000036
						],
						[
							-81.61207199999987,
							30.55834000000008
						],
						[
							-81.61167899999987,
							30.55733900000003
						],
						[
							-81.6115712480954,
							30.556997147970144
						],
						[
							-81.61148199999991,
							30.556714000000188
						],
						[
							-81.61133270968897,
							30.55633272212194
						],
						[
							-81.61133310599985,
							30.556325113000074
						],
						[
							-81.61130972999977,
							30.556172421000053
						],
						[
							-81.61125686899993,
							30.55599792300018
						],
						[
							-81.61096358199983,
							30.55540475900013
						],
						[
							-81.61052524399979,
							30.55477512900008
						],
						[
							-81.61037207697308,
							30.55460790001902
						],
						[
							-81.61021199999989,
							30.554380000000165
						],
						[
							-81.60962868550995,
							30.55396460437755
						],
						[
							-81.60961178199989,
							30.553944442000002
						],
						[
							-81.60957379799976,
							30.553888407000432
						],
						[
							-81.6094389349997,
							30.553903640000005
						],
						[
							-81.60942838793204,
							30.553904332063833
						],
						[
							-81.60914891439128,
							30.553820284900297
						],
						[
							-81.6088079999999,
							30.553718000000096
						],
						[
							-81.60861799999991,
							30.553696000000055
						],
						[
							-81.60813199999984,
							30.553638000000056
						],
						[
							-81.60731099999994,
							30.55360000000011
						],
						[
							-81.60644399999988,
							30.553855000000066
						],
						[
							-81.60592129206064,
							30.554250837080332
						],
						[
							-81.60596990099974,
							30.554193860000215
						],
						[
							-81.60589170067601,
							30.554273246090098
						],
						[
							-81.60572299999993,
							30.554401000000126
						],
						[
							-81.60529399999986,
							30.555322000000125
						],
						[
							-81.60444099999988,
							30.557958000000088
						],
						[
							-81.60420399999991,
							30.55858600000018
						],
						[
							-81.60377399999994,
							30.559298000000112
						],
						[
							-81.60286099999989,
							30.56005400000014
						],
						[
							-81.60175399999987,
							30.560561000000163
						],
						[
							-81.60016299999995,
							30.560861000000124
						],
						[
							-81.59969876399155,
							30.5609340319479
						],
						[
							-81.5997286019998,
							30.560924265000118
						],
						[
							-81.59954169305335,
							30.560958741961137
						],
						[
							-81.59953469790915,
							30.560959842424857
						],
						[
							-81.59934299999988,
							30.560990000000135
						],
						[
							-81.5986679999998,
							30.56111900000015
						],
						[
							-81.5979929999999,
							30.56137200000012
						],
						[
							-81.59722399999987,
							30.561835000000062
						],
						[
							-81.5970960762801,
							30.561931515548324
						],
						[
							-81.59683694699973,
							30.562041049000147
						],
						[
							-81.59639454099981,
							30.562237194000474
						],
						[
							-81.59572613399983,
							30.56266596100016
						],
						[
							-81.59242169099973,
							30.564804958000128
						],
						[
							-81.59237711399985,
							30.56483201200006
						],
						[
							-81.59015415617093,
							30.566094456869944
						],
						[
							-81.5897669999999,
							30.566215000000092
						],
						[
							-81.58889899999993,
							30.566428000000126
						],
						[
							-81.58788599999987,
							30.566599000000064
						],
						[
							-81.5877169360294,
							30.566610137448897
						],
						[
							-81.58696253699985,
							30.566460437000057
						],
						[
							-81.58689267499975,
							30.566443358000157
						],
						[
							-81.58620074999989,
							30.56624457300014
						],
						[
							-81.5846657909998,
							30.565921265000036
						],
						[
							-81.58510672699968,
							30.56611525600001
						],
						[
							-81.58520294699974,
							30.566145781000493
						],
						[
							-81.58528525799989,
							30.566176392000088
						],
						[
							-81.5853902579996,
							30.566221391000173
						],
						[
							-81.58543376699991,
							30.56624317800011
						],
						[
							-81.5855729509997,
							30.566248282000178
						],
						[
							-81.58569616499977,
							30.566261340000374
						],
						[
							-81.58575484199974,
							30.56627706300016
						],
						[
							-81.58577799999989,
							30.566275678000135
						],
						[
							-81.58593416499984,
							30.566289341000292
						],
						[
							-81.5860014189999,
							30.566307361
						],
						[
							-81.58602743099992,
							30.566308416000357
						],
						[
							-81.5861471649997,
							30.566321341000094
						],
						[
							-81.58621827199981,
							30.566336869000136
						],
						[
							-81.58627534599974,
							30.566351776000218
						],
						[
							-81.5864230879997,
							30.56636349200012
						],
						[
							-81.58653832299983,
							30.56638019000008
						],
						[
							-81.58662332199975,
							30.566398191000236
						],
						[
							-81.58669509799984,
							30.566416508000422
						],
						[
							-81.58676512299985,
							30.566440671000198
						],
						[
							-81.58683292099987,
							30.56647051600009
						],
						[
							-81.58689803199984,
							30.566505842000527
						],
						[
							-81.58696001299981,
							30.566546408000157
						],
						[
							-81.58701844499976,
							30.566591938000013
						],
						[
							-81.58704190899992,
							30.566611994000077
						],
						[
							-81.58706299799972,
							30.566616733000373
						],
						[
							-81.58713993199977,
							30.56662533400011
						],
						[
							-81.58735157043287,
							30.5666342066851
						],
						[
							-81.58653499999991,
							30.56668800000014
						],
						[
							-81.58576099999982,
							30.56652500000016
						],
						[
							-81.58508399999994,
							30.566319000000167
						],
						[
							-81.58440599999987,
							30.565988000000136
						],
						[
							-81.58353299999995,
							30.56519800000014
						],
						[
							-81.58323899999995,
							30.564489000000098
						],
						[
							-81.58323499999989,
							30.56386200000009
						],
						[
							-81.58332699999995,
							30.56311000000004
						],
						[
							-81.58356299999986,
							30.562273000000065
						],
						[
							-81.5836559999999,
							30.561688000000157
						],
						[
							-81.58389399999989,
							30.561019000000048
						],
						[
							-81.58424162371698,
							30.560099626748563
						],
						[
							-81.58430072404997,
							30.559979523038827
						],
						[
							-81.58518399999986,
							30.558840000000057
						],
						[
							-81.58570999999995,
							30.557919000000062
						],
						[
							-81.58585099999989,
							30.55729100000015
						],
						[
							-81.58585817257487,
							30.557242719936998
						],
						[
							-81.58618968499967,
							30.556613074000012
						],
						[
							-81.58720613499983,
							30.55467012200019
						],
						[
							-81.58724305399987,
							30.55460610300013
						],
						[
							-81.58773295099991,
							30.553831934000293
						],
						[
							-81.58796640199976,
							30.553350608000077
						],
						[
							-81.58812946199986,
							30.552998893000016
						],
						[
							-81.5884712829997,
							30.552200050000092
						],
						[
							-81.58870035999983,
							30.551509018000115
						],
						[
							-81.58870717699978,
							30.551489229000165
						],
						[
							-81.5890970449997,
							30.550398822000094
						],
						[
							-81.58916416499993,
							30.550254339000126
						],
						[
							-81.58919813599981,
							30.550200057000257
						],
						[
							-81.58932524399975,
							30.550012183000163
						],
						[
							-81.58933911399993,
							30.54994363000009
						],
						[
							-81.58931420399982,
							30.549829044000024
						],
						[
							-81.58930379999975,
							30.5497725500005
						],
						[
							-81.58921192499962,
							30.54916536500009
						],
						[
							-81.58915635999982,
							30.548802662000192
						],
						[
							-81.58895682899993,
							30.548317858000043
						],
						[
							-81.5884401579998,
							30.547220158000346
						],
						[
							-81.58789113699976,
							30.54652420300005
						],
						[
							-81.58591425499979,
							30.544215610000087
						],
						[
							-81.58352242399978,
							30.542603787000033
						],
						[
							-81.58346247799989,
							30.542559676000383
						],
						[
							-81.58340638399986,
							30.542510759000155
						],
						[
							-81.58335452699974,
							30.542457371000182
						],
						[
							-81.58330726199983,
							30.54239987900004
						],
						[
							-81.58326491299988,
							30.54233867400039
						],
						[
							-81.58322776899973,
							30.542274178000035
						],
						[
							-81.58289368899982,
							30.541634213000282
						],
						[
							-81.58200127599977,
							30.540681949000362
						],
						[
							-81.58115930899974,
							30.53990578800018
						],
						[
							-81.58052146099963,
							30.539523257000056
						],
						[
							-81.58041771299985,
							30.539450641000094
						],
						[
							-81.5797171419997,
							30.538882789000183
						],
						[
							-81.57819439399974,
							30.5379040810002
						],
						[
							-81.57747214499976,
							30.537598058000196
						],
						[
							-81.5773361929998,
							30.53752617400011
						],
						[
							-81.57696369099988,
							30.537286366000163
						],
						[
							-81.57656903299981,
							30.53715297100023
						],
						[
							-81.57654941299988,
							30.53714608600028
						],
						[
							-81.57640543899969,
							30.537078733000122
						],
						[
							-81.57592597399972,
							30.5367987880005
						],
						[
							-81.5755091289998,
							30.536716156000058
						],
						[
							-81.57537641399982,
							30.53667908600001
						],
						[
							-81.57526720699984,
							30.53663090900002
						],
						[
							-81.57474037999985,
							30.536355371000138
						],
						[
							-81.57360020999975,
							30.53634003900011
						],
						[
							-81.57130816799973,
							30.536264755000104
						],
						[
							-81.56940259899972,
							30.53619243500016
						],
						[
							-81.56792111799973,
							30.53637636800001
						],
						[
							-81.5655249999997,
							30.537084744000357
						],
						[
							-81.56238648599981,
							30.538449922000158
						],
						[
							-81.56145700899972,
							30.53948111700048
						],
						[
							-81.5614438859999,
							30.53949536300006
						],
						[
							-81.56064622999979,
							30.540342873000373
						],
						[
							-81.56041184199977,
							30.540782851000188
						],
						[
							-81.56019192499977,
							30.54120584500037
						],
						[
							-81.5601577479997,
							30.54126583700036
						],
						[
							-81.5601190689997,
							30.541323029000118
						],
						[
							-81.56007611699987,
							30.541377086000058
						],
						[
							-81.5600291439998,
							30.54142768900007
						],
						[
							-81.55961714399982,
							30.54183868900015
						],
						[
							-81.5595600729998,
							30.541890921000025
						],
						[
							-81.55943364199973,
							30.54197968900009
						],
						[
							-81.55849864199973,
							30.542522689000076
						],
						[
							-81.55847188999984,
							30.542537621000065
						],
						[
							-81.55732088999973,
							30.54315462200005
						],
						[
							-81.55719141699967,
							30.543211417000396
						],
						[
							-81.5560614169998,
							30.543604417000054
						],
						[
							-81.55597422399977,
							30.543629885000204
						],
						[
							-81.55495322399985,
							30.54387288400033
						],
						[
							-81.55487562899972,
							30.543887784000493
						],
						[
							-81.5547970259997,
							30.54389581600009
						],
						[
							-81.55471802199975,
							30.543896917000097
						],
						[
							-81.5532619080982,
							30.543853216709774
						],
						[
							-81.55158399999986,
							30.543284000000092
						],
						[
							-81.55110000605752,
							30.543094962852383
						],
						[
							-81.55107791399985,
							30.54304758600008
						],
						[
							-81.55103734099984,
							30.54289616500007
						],
						[
							-81.55102367799978,
							30.54274000000003
						],
						[
							-81.55102367799978,
							30.54264167900015
						],
						[
							-81.55094703799983,
							30.54233214200021
						],
						[
							-81.55093342299986,
							30.54226759700011
						],
						[
							-81.55092467999985,
							30.542202212000113
						],
						[
							-81.5509208589998,
							30.54213635700009
						],
						[
							-81.55092198199982,
							30.542070401000494
						],
						[
							-81.55091771071159,
							30.542064061002634
						],
						[
							-81.5509079999999,
							30.540936000000155
						],
						[
							-81.55083504855048,
							30.540553668085938
						],
						[
							-81.55089045799977,
							30.540018399000346
						],
						[
							-81.55089740299991,
							30.53996625800021
						],
						[
							-81.5510107509997,
							30.539271174000074
						],
						[
							-81.55104167799985,
							30.53871979800011
						],
						[
							-81.55104167799985,
							30.538223664000085
						],
						[
							-81.55102403499973,
							30.537597323000046
						],
						[
							-81.55102469799986,
							30.537529178000185
						],
						[
							-81.55103051999981,
							30.53746128000007
						],
						[
							-81.55104146599983,
							30.5373940170001
						],
						[
							-81.5513179879998,
							30.53602446700011
						],
						[
							-81.55148497599984,
							30.53522135000019
						],
						[
							-81.55160319499986,
							30.53434203600044
						],
						[
							-81.55149825899979,
							30.533367173000162
						],
						[
							-81.55125084399992,
							30.53278936400005
						],
						[
							-81.55082162999985,
							30.5320782250001
						],
						[
							-81.55081262130757,
							30.53205916197871
						],
						[
							-81.55077799999988,
							30.531562000000104
						],
						[
							-81.5491099999998,
							30.528420000000015
						],
						[
							-81.5476093400356,
							30.52669392796893
						],
						[
							-81.54758234099988,
							30.526593166000385
						],
						[
							-81.54756867799982,
							30.52643700000043
						],
						[
							-81.54758234099988,
							30.526280834000477
						],
						[
							-81.54760006499976,
							30.526214687000067
						],
						[
							-81.54753297099988,
							30.52618060600036
						],
						[
							-81.54746926099995,
							30.526140554000065
						],
						[
							-81.54740946499979,
							30.52609486400019
						],
						[
							-81.54735408099974,
							30.526043915000507
						],
						[
							-81.54722308099974,
							30.525912914000052
						],
						[
							-81.5471700789997,
							30.525855073000333
						],
						[
							-81.5470801639999,
							30.52572666100019
						],
						[
							-81.54701391399975,
							30.525584586000424
						],
						[
							-81.54697334099977,
							30.525433165000063
						],
						[
							-81.54695984399972,
							30.525275108000045
						],
						[
							-81.54665503699981,
							30.524866586000165
						],
						[
							-81.54651150999983,
							30.52474288800006
						],
						[
							-81.54631005999987,
							30.52464348800001
						],
						[
							-81.54625101999986,
							30.524611564000388
						],
						[
							-81.5461945259999,
							30.524575325000143
						],
						[
							-81.54614089199981,
							30.524534975000176
						],
						[
							-81.54609041699972,
							30.524490736000157
						],
						[
							-81.54587341699971,
							30.524285736000074
						],
						[
							-81.54580207899993,
							30.52421007300012
						],
						[
							-81.54571216399995,
							30.524081661000153
						],
						[
							-81.5456459139998,
							30.523939587000473
						],
						[
							-81.54560534099981,
							30.523788166000116
						],
						[
							-81.54559167799994,
							30.52363200000016
						],
						[
							-81.5455921429998,
							30.523603083000342
						],
						[
							-81.54560409299971,
							30.523231729000166
						],
						[
							-81.5456117439999,
							30.522963250000075
						],
						[
							-81.54587970799987,
							30.52218401500017
						],
						[
							-81.54588078999979,
							30.522205350000426
						],
						[
							-81.54593859099985,
							30.52214769000027
						],
						[
							-81.54601967799964,
							30.522080306000202
						],
						[
							-81.54601967799964,
							30.52191461300008
						],
						[
							-81.54584802399982,
							30.520828276000174
						],
						[
							-81.54576764399992,
							30.52070619500011
						],
						[
							-81.54545646799994,
							30.51999238600011
						],
						[
							-81.54447871899986,
							30.519254786000186
						],
						[
							-81.54327797399989,
							30.518654414000075
						],
						[
							-81.54161408599981,
							30.518242730000114
						],
						[
							-81.54109948099995,
							30.517968274000147
						],
						[
							-81.5407392579999,
							30.5174536700002
						],
						[
							-81.5407049509999,
							30.516904758000077
						],
						[
							-81.54114846599991,
							30.516421465000146
						],
						[
							-81.5412457459997,
							30.51634983100008
						],
						[
							-81.54127292499973,
							30.51633058300009
						],
						[
							-81.54375689499965,
							30.514639641000155
						],
						[
							-81.5439639729999,
							30.514453546000126
						],
						[
							-81.54446156499995,
							30.513920051000127
						],
						[
							-81.54480463499992,
							30.513182451000024
						],
						[
							-81.5447451659999,
							30.512503116000214
						],
						[
							-81.54473875799988,
							30.512159464000028
						],
						[
							-81.54474201099988,
							30.512112912000084
						],
						[
							-81.54492625799985,
							30.511891898000094
						],
						[
							-81.54551016199984,
							30.511502628000034
						],
						[
							-81.5466390449999,
							30.51111335800016
						],
						[
							-81.54745651099995,
							30.510996577000174
						],
						[
							-81.5481182699999,
							30.51103550400011
						],
						[
							-81.54858539299993,
							30.511307993000184
						],
						[
							-81.54885788199982,
							30.511619409000012
						],
						[
							-81.5492860789999,
							30.51235902100011
						],
						[
							-81.54979212999984,
							30.51325434200002
						],
						[
							-81.55014247299988,
							30.514149662000204
						],
						[
							-81.5501813999999,
							30.51469464000018
						],
						[
							-81.5501813999999,
							30.5151617640001
						],
						[
							-81.5504538879999,
							30.515551034000154
						],
						[
							-81.55084315799985,
							30.51582352200014
						],
						[
							-81.55146598999987,
							30.515901376000013
						],
						[
							-81.55267272599988,
							30.515706741000162
						],
						[
							-81.55368482799987,
							30.51520069100004
						],
						[
							-81.55434658599982,
							30.514461078000036
						],
						[
							-81.55450229399992,
							30.51387717400004
						],
						[
							-81.55473585599988,
							30.513215415000086
						],
						[
							-81.55539761499993,
							30.512592583000067
						],
						[
							-81.55613722699992,
							30.512203313000015
						],
						[
							-81.55722718299998,
							30.511852971000156
						],
						[
							-81.55831713799991,
							30.511463701000096
						],
						[
							-81.55886211599987,
							30.511502628000034
						],
						[
							-81.55929031199987,
							30.51193082500003
						],
						[
							-81.55940709299993,
							30.51274829100016
						],
						[
							-81.55956280099986,
							30.51364361200008
						],
						[
							-81.56002992499987,
							30.51411073500009
						],
						[
							-81.56084739099992,
							30.514344297000054
						],
						[
							-81.56162593099994,
							30.514538932000086
						],
						[
							-81.5624044709999,
							30.5148892750002
						],
						[
							-81.5630273019999,
							30.5151617640001
						],
						[
							-81.56365013399983,
							30.515278545000083
						],
						[
							-81.56431189299987,
							30.51520069100004
						],
						[
							-81.56489579699986,
							30.514967129000073
						],
						[
							-81.56544077499983,
							30.514577859000013
						],
						[
							-81.5661414599999,
							30.51387717400004
						],
						[
							-81.5668810729998,
							30.513721466000124
						],
						[
							-81.56750390499992,
							30.51387717400004
						],
						[
							-81.56793210099983,
							30.514149662000204
						],
						[
							-81.56824351699991,
							30.514538932000086
						],
						[
							-81.5683602979999,
							30.514967129000073
						],
						[
							-81.5683602979999,
							30.51547318000011
						],
						[
							-81.56824351699991,
							30.51613493800015
						],
						[
							-81.56804888199989,
							30.51664098900001
						],
						[
							-81.56765961299992,
							30.517185967000163
						],
						[
							-81.56738712399995,
							30.517692017000115
						],
						[
							-81.56738712399995,
							30.518431630000112
						],
						[
							-81.56793210099983,
							30.518626265000144
						],
						[
							-81.56843815199994,
							30.51905446200013
						],
						[
							-81.56851600599991,
							30.519443731000095
						],
						[
							-81.56832137099978,
							30.519716220000177
						],
						[
							-81.56832137099978,
							30.52006656300012
						],
						[
							-81.56863278699988,
							30.52037797900013
						],
						[
							-81.56898312999992,
							30.520533687000047
						],
						[
							-81.56952810799989,
							30.52030012500008
						],
						[
							-81.56995630399989,
							30.51998870900007
						],
						[
							-81.57046235499992,
							30.519910855000028
						],
						[
							-81.57089055199991,
							30.519871928000093
						],
						[
							-81.57139660199995,
							30.519910855000028
						],
						[
							-81.57182479899986,
							30.520144417000164
						],
						[
							-81.57233084999989,
							30.519833001000155
						],
						[
							-81.5726422659999,
							30.520105490000052
						],
						[
							-81.57326509699992,
							30.52037797900013
						],
						[
							-81.57392685599979,
							30.520455833000174
						],
						[
							-81.57431612599993,
							30.52061154100009
						],
						[
							-81.57462754199993,
							30.5209229570001
						],
						[
							-81.57482217699987,
							30.52135115300018
						],
						[
							-81.57513359199989,
							30.521701496000123
						],
						[
							-81.57563964299992,
							30.521779350000173
						],
						[
							-81.57598998599987,
							30.521584715000145
						],
						[
							-81.5763403289999,
							30.52142900700005
						],
						[
							-81.57669067099994,
							30.521506861000095
						],
						[
							-81.57700208699994,
							30.521740423000058
						],
						[
							-81.57758899999992,
							30.52208700000004
						],
						[
							-81.57749347899993,
							30.522160165000148
						],
						[
							-81.57765983599982,
							30.52229005100006
						],
						[
							-81.57817746999984,
							30.521254153000143
						],
						[
							-81.57947208599985,
							30.520563882000143
						],
						[
							-81.5815432699999,
							30.51970089100006
						],
						[
							-81.58335555899991,
							30.519528290000075
						],
						[
							-81.58559934099993,
							30.519528290000075
						],
						[
							-81.5874979319999,
							30.519959785000164
						],
						[
							-81.5887924189999,
							30.51995978600008
						],
						[
							-81.58969055699988,
							30.51989712300013
						],
						[
							-81.5897489109999,
							30.520359011000156
						],
						[
							-81.58982790899996,
							30.520541010000027
						],
						[
							-81.58991990899993,
							30.520677013000178
						],
						[
							-81.59003890999992,
							30.52089301200002
						],
						[
							-81.59084290999992,
							30.522150013000022
						],
						[
							-81.59134690899988,
							30.52300101300009
						],
						[
							-81.59195090999994,
							30.524014012000148
						],
						[
							-81.5928349099999,
							30.525501013000174
						],
						[
							-81.59299090999993,
							30.525746012000102
						],
						[
							-81.59316290899994,
							30.526033013000134
						],
						[
							-81.59373490899993,
							30.526995012000057
						],
						[
							-81.59399390999995,
							30.527464012000145
						],
						[
							-81.59433690999991,
							30.528179012000148
						],
						[
							-81.5950549089999,
							30.52976201200003
						],
						[
							-81.59513090899988,
							30.52990301200015
						],
						[
							-81.59532890999992,
							30.530205012000092
						],
						[
							-81.59570290999996,
							30.530653013000126
						],
						[
							-81.59675490999979,
							30.53188001300004
						],
						[
							-81.59706090899988,
							30.532236012000094
						],
						[
							-81.59722884099983,
							30.532398127000096
						],
						[
							-81.59755790999988,
							30.53254101300019
						],
						[
							-81.60181390899994,
							30.53423501200011
						],
						[
							-81.60214990999985,
							30.534382013000112
						],
						[
							-81.60232490999995,
							30.534468013000122
						],
						[
							-81.6024779099999,
							30.534555013000034
						],
						[
							-81.60325890999987,
							30.535073012000176
						],
						[
							-81.60773390899993,
							30.538023013000092
						],
						[
							-81.6127089089998,
							30.54129401200011
						],
						[
							-81.62139900399987,
							30.547013969000076
						],
						[
							-81.62133790999987,
							30.54762501300018
						],
						[
							-81.62059190899987,
							30.555820013000204
						],
						[
							-81.62049190899994,
							30.556752013000047
						],
						[
							-81.62013690899988,
							30.5581150130002
						],
						[
							-81.62004890999988,
							30.558393013000114
						],
						[
							-81.61988090999992,
							30.558857012000225
						],
						[
							-81.61971290899987,
							30.559273013000094
						],
						[
							-81.61935390899993,
							30.560032014000097
						],
						[
							-81.61908690999987,
							30.560516012000175
						],
						[
							-81.61865990899979,
							30.561205013000073
						],
						[
							-81.61833190999992,
							30.561689013000155
						],
						[
							-81.61770390899991,
							30.562551013000064
						],
						[
							-81.61648673399993,
							30.564219052000144
						],
						[
							-81.6167340909999,
							30.564339976000024
						],
						[
							-81.61471192299992,
							30.566822197000146
						],
						[
							-81.6146388939999,
							30.56674982900002
						],
						[
							-81.60901399999989,
							30.57448900000007
						],
						[
							-81.60871863109998,
							30.574892574811514
						],
						[
							-81.60868099999988,
							30.574887000000146
						],
						[
							-81.60844399999989,
							30.574851000000187
						],
						[
							-81.60777999999993,
							30.574613000000035
						],
						[
							-81.60742957800096,
							30.574455690997763
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Eagle Bend",
				"RegionID": "268968"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.4550875459999,
					28.50471219600007,
					-81.44277799199995,
					28.523203452000075
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.44720086399991,
							28.51703804300007
						],
						[
							-81.44705002599994,
							28.51702694700009
						],
						[
							-81.44704231799994,
							28.51702920000008
						],
						[
							-81.44702276099991,
							28.517034678000073
						],
						[
							-81.44696544899995,
							28.517048041000066
						],
						[
							-81.44690738499992,
							28.51705762800009
						],
						[
							-81.44688275199991,
							28.51706052600008
						],
						[
							-81.44686875999992,
							28.51706757800008
						],
						[
							-81.4468151559999,
							28.517091866000044
						],
						[
							-81.4467600779999,
							28.51711259500007
						],
						[
							-81.44670376199991,
							28.517129679000053
						],
						[
							-81.4466464489999,
							28.517143042000043
						],
						[
							-81.44658838499993,
							28.517152629000066
						],
						[
							-81.4465814859999,
							28.517153308000047
						],
						[
							-81.44658123599993,
							28.517155449000086
						],
						[
							-81.44657962799994,
							28.517168385000048
						],
						[
							-81.4465700419999,
							28.517226449000077
						],
						[
							-81.44655667899991,
							28.51728376200009
						],
						[
							-81.44653959499993,
							28.517340077000085
						],
						[
							-81.44651886499992,
							28.517395156000077
						],
						[
							-81.44649457799994,
							28.517448760000036
						],
						[
							-81.4464668359999,
							28.517500661000042
						],
						[
							-81.44645429199994,
							28.517521720000047
						],
						[
							-81.44641129099995,
							28.517591721000088
						],
						[
							-81.44639275899993,
							28.51762063700005
						],
						[
							-81.44635847999992,
							28.517668473000075
						],
						[
							-81.44632114599995,
							28.51771396500004
						],
						[
							-81.44628091699991,
							28.517756917000042
						],
						[
							-81.44623796399992,
							28.517797147000067
						],
						[
							-81.44619247299994,
							28.51783448100008
						],
						[
							-81.44618628899991,
							28.517839183000035
						],
						[
							-81.44605505499993,
							28.517938093000055
						],
						[
							-81.44605866099994,
							28.517940165000084
						],
						[
							-81.44610863699995,
							28.517971241000055
						],
						[
							-81.44615647299992,
							28.518005520000088
						],
						[
							-81.44620196399991,
							28.518042854000043
						],
						[
							-81.44624491699994,
							28.518083084000068
						],
						[
							-81.44628514599992,
							28.51812603600007
						],
						[
							-81.44632247999994,
							28.51817152800004
						],
						[
							-81.44635675899991,
							28.51821936400006
						],
						[
							-81.44638783599993,
							28.518269339000085
						],
						[
							-81.44641557799991,
							28.518321240000034
						],
						[
							-81.44643476599992,
							28.518362783000043
						],
						[
							-81.44645676599994,
							28.518413783000085
						],
						[
							-81.44646186499995,
							28.518425844000035
						],
						[
							-81.4464825949999,
							28.518480922000037
						],
						[
							-81.44649967899994,
							28.51853723800008
						],
						[
							-81.44651304199994,
							28.518594551000035
						],
						[
							-81.44651939799991,
							28.518630254000072
						],
						[
							-81.44653339799993,
							28.518719254000075
						],
						[
							-81.44653662799993,
							28.518741615000067
						],
						[
							-81.44654156599995,
							28.518788648000054
						],
						[
							-81.4465845659999,
							28.519336648000035
						],
						[
							-81.44658539699992,
							28.519348181000055
						],
						[
							-81.44658731299995,
							28.51940294900004
						],
						[
							-81.44658831299995,
							28.519624949000047
						],
						[
							-81.44658639699992,
							28.51968781900007
						],
						[
							-81.44658062799994,
							28.519746385000076
						],
						[
							-81.4465710419999,
							28.51980444900005
						],
						[
							-81.44655767899991,
							28.519861762000062
						],
						[
							-81.44654059499993,
							28.51991807800005
						],
						[
							-81.44651986499993,
							28.51997315600005
						],
						[
							-81.44649557799994,
							28.520026760000068
						],
						[
							-81.4464678359999,
							28.52007866100007
						],
						[
							-81.44643675899994,
							28.520128637000084
						],
						[
							-81.4464024799999,
							28.52017647300005
						],
						[
							-81.44636514599995,
							28.520221964000086
						],
						[
							-81.44632491699991,
							28.52026491700008
						],
						[
							-81.44628196399992,
							28.520305146000055
						],
						[
							-81.44623647299994,
							28.520342480000068
						],
						[
							-81.44618863699992,
							28.520376759000044
						],
						[
							-81.4461386609999,
							28.52040783600006
						],
						[
							-81.4460867599999,
							28.520435577000057
						],
						[
							-81.44603315599994,
							28.520459865000078
						],
						[
							-81.44597807799994,
							28.520480595000038
						],
						[
							-81.4459217619999,
							28.520497678000087
						],
						[
							-81.44586444899994,
							28.520511042000066
						],
						[
							-81.4458252089999,
							28.520517947000087
						],
						[
							-81.44570120899994,
							28.52053694700004
						],
						[
							-81.44568238499994,
							28.52053962800005
						],
						[
							-81.44564037899994,
							28.520544157000074
						],
						[
							-81.4453193789999,
							28.520571158000052
						],
						[
							-81.44530281899995,
							28.52057239700008
						],
						[
							-81.44525944399993,
							28.520574190000048
						],
						[
							-81.4442912159999,
							28.520590819000063
						],
						[
							-81.44426625799991,
							28.52065177200007
						],
						[
							-81.44426486499992,
							28.52065515600009
						],
						[
							-81.4442405769999,
							28.520708760000048
						],
						[
							-81.44421283499992,
							28.520760661000054
						],
						[
							-81.44418175899995,
							28.520810637000068
						],
						[
							-81.44414747999991,
							28.52085847300009
						],
						[
							-81.4441101459999,
							28.520903964000073
						],
						[
							-81.44406991599993,
							28.520946917000064
						],
						[
							-81.44402696399993,
							28.52098714600004
						],
						[
							-81.4439814719999,
							28.52102448000005
						],
						[
							-81.44393363599994,
							28.521058759000084
						],
						[
							-81.44388366099992,
							28.521089836000044
						],
						[
							-81.44383175999991,
							28.52111757700004
						],
						[
							-81.4437781549999,
							28.52114186500006
						],
						[
							-81.44377700899992,
							28.52114233900005
						],
						[
							-81.4437481459999,
							28.521176964000063
						],
						[
							-81.44374044499995,
							28.52118518700007
						],
						[
							-81.44295799999992,
							28.52062000000007
						],
						[
							-81.44289041299993,
							28.515276850000078
						],
						[
							-81.44282227699995,
							28.509867842000062
						],
						[
							-81.44277799199995,
							28.506377592000035
						],
						[
							-81.44307860399994,
							28.50611527800004
						],
						[
							-81.44355931699994,
							28.505705671000044
						],
						[
							-81.4438297179999,
							28.505502370000045
						],
						[
							-81.44418724799993,
							28.505261012000066
						],
						[
							-81.44447767799994,
							28.505120803000068
						],
						[
							-81.4446950009999,
							28.505013645000076
						],
						[
							-81.4449513809999,
							28.50492250900004
						],
						[
							-81.44526684899995,
							28.504851404000078
						],
						[
							-81.4458847649999,
							28.504774289000068
						],
						[
							-81.4460750479999,
							28.50475726500008
						],
						[
							-81.44886818999993,
							28.504743243000064
						],
						[
							-81.45150910699994,
							28.504743243000064
						],
						[
							-81.45244349099994,
							28.50473022400007
						],
						[
							-81.45327973099995,
							28.50472121100006
						],
						[
							-81.45458466799994,
							28.50471219600007
						],
						[
							-81.45485106599995,
							28.50471219600007
						],
						[
							-81.4550875459999,
							28.522579718000088
						],
						[
							-81.45492924799993,
							28.523053428000082
						],
						[
							-81.44735376799991,
							28.523203452000075
						],
						[
							-81.44667282799992,
							28.522578301000067
						],
						[
							-81.44668352799994,
							28.522569520000047
						],
						[
							-81.4467313639999,
							28.52253524100007
						],
						[
							-81.44674196199992,
							28.52252826700004
						],
						[
							-81.44678981999994,
							28.522497257000058
						],
						[
							-81.44677632199995,
							28.522452762000057
						],
						[
							-81.44677301199994,
							28.52244003800007
						],
						[
							-81.44674601199995,
							28.522333038000056
						],
						[
							-81.44673595799993,
							28.522288449000087
						],
						[
							-81.44672637199994,
							28.522230385000057
						],
						[
							-81.44672060399995,
							28.52217181900005
						],
						[
							-81.44671867799991,
							28.522113000000047
						],
						[
							-81.44672060399995,
							28.52205418200009
						],
						[
							-81.44672147599994,
							28.522042113000058
						],
						[
							-81.44673753299992,
							28.521839035000085
						],
						[
							-81.4467469089999,
							28.52165997700007
						],
						[
							-81.44674760399994,
							28.521648181000046
						],
						[
							-81.44675337199993,
							28.52158961500004
						],
						[
							-81.4467629589999,
							28.521531551000066
						],
						[
							-81.44677632199995,
							28.521474238000053
						],
						[
							-81.44679340499994,
							28.521417922000072
						],
						[
							-81.4468141349999,
							28.521362844000066
						],
						[
							-81.44683842299992,
							28.521309240000054
						],
						[
							-81.44684888099994,
							28.52128870100006
						],
						[
							-81.4469108799999,
							28.521170702000063
						],
						[
							-81.44692816399993,
							28.521139339000058
						],
						[
							-81.44695924099994,
							28.52108936400009
						],
						[
							-81.44699351999992,
							28.52104152800007
						],
						[
							-81.44700474599995,
							28.521027199000063
						],
						[
							-81.44707061799994,
							28.520944860000043
						],
						[
							-81.44713470999994,
							28.520818226000074
						],
						[
							-81.44718199899995,
							28.520700004000048
						],
						[
							-81.44718613399994,
							28.520689844000064
						],
						[
							-81.4472104219999,
							28.520636240000044
						],
						[
							-81.44723816399994,
							28.520584339000038
						],
						[
							-81.4472692409999,
							28.52053436300008
						],
						[
							-81.44730351899995,
							28.52048652700006
						],
						[
							-81.4473408529999,
							28.52044103600008
						],
						[
							-81.44737601599991,
							28.52040319100007
						],
						[
							-81.44743801599992,
							28.52034019100006
						],
						[
							-81.44744308299995,
							28.520335083000077
						],
						[
							-81.44748603599993,
							28.520294854000042
						],
						[
							-81.44753152699991,
							28.520257520000087
						],
						[
							-81.44757936299993,
							28.520223241000053
						],
						[
							-81.44762933899995,
							28.520192164000036
						],
						[
							-81.44768123999995,
							28.52016442200005
						],
						[
							-81.44773484399991,
							28.520140135000076
						],
						[
							-81.44778992199991,
							28.52011940500006
						],
						[
							-81.4478462379999,
							28.520102321000085
						],
						[
							-81.44790355099991,
							28.520088958000088
						],
						[
							-81.44796161499994,
							28.520079372000055
						],
						[
							-81.44798047799992,
							28.520077514000036
						],
						[
							-81.44797551999994,
							28.52007147200004
						],
						[
							-81.4479695419999,
							28.520063593000092
						],
						[
							-81.44780154299991,
							28.519839593000086
						],
						[
							-81.44777324099994,
							28.519799637000062
						],
						[
							-81.44774216499991,
							28.51974966100005
						],
						[
							-81.44771442299992,
							28.519697760000042
						],
						[
							-81.4476901349999,
							28.519644156000084
						],
						[
							-81.44766940499994,
							28.519589078000084
						],
						[
							-81.4476523219999,
							28.51953276200004
						],
						[
							-81.4476389589999,
							28.519475449000083
						],
						[
							-81.44762937199994,
							28.519417385000054
						],
						[
							-81.44762360399994,
							28.519358819000047
						],
						[
							-81.4476216779999,
							28.519300000000044
						],
						[
							-81.44762178099995,
							28.519286428000044
						],
						[
							-81.44762358299994,
							28.519167029000073
						],
						[
							-81.44759885399992,
							28.51913996400009
						],
						[
							-81.44756151999991,
							28.519094472000067
						],
						[
							-81.44755779199994,
							28.51908958000007
						],
						[
							-81.44748112399992,
							28.51898823600004
						],
						[
							-81.44745596699994,
							28.51895748900006
						],
						[
							-81.44743851999993,
							28.51893547300006
						],
						[
							-81.4474042409999,
							28.518887637000034
						],
						[
							-81.44737316499993,
							28.518837661000077
						],
						[
							-81.44734542299994,
							28.51878576000007
						],
						[
							-81.44732113499992,
							28.518732156000056
						],
						[
							-81.44730394999993,
							28.518687318000048
						],
						[
							-81.44726794899992,
							28.518585318000078
						],
						[
							-81.44726440499994,
							28.518575078000083
						],
						[
							-81.4472473209999,
							28.518518762000042
						],
						[
							-81.44723395799991,
							28.51846144900009
						],
						[
							-81.44722437099995,
							28.518403385000056
						],
						[
							-81.4472186029999,
							28.51834481900005
						],
						[
							-81.44721701599993,
							28.518310652000082
						],
						[
							-81.44720201599995,
							28.517763652000042
						],
						[
							-81.44720178499995,
							28.51775289400007
						],
						[
							-81.4471947859999,
							28.517299894000075
						],
						[
							-81.4471946779999,
							28.51728600000007
						],
						[
							-81.44719498699993,
							28.517262455000036
						],
						[
							-81.44720086399991,
							28.51703804300007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Eagles Nest",
				"RegionID": "268969"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.5235672099999,
					30.317737012000066,
					-81.46054791299991,
					30.360274005000065
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.48463790799991,
							30.35940301300008
						],
						[
							-81.48376490899994,
							30.359355013000087
						],
						[
							-81.48367890899995,
							30.35935801300008
						],
						[
							-81.48200590899995,
							30.35928501300009
						],
						[
							-81.48147890899992,
							30.359260013000043
						],
						[
							-81.48090191099993,
							30.359230012000072
						],
						[
							-81.48032790799994,
							30.359188012000065
						],
						[
							-81.47965790899991,
							30.359133013000072
						],
						[
							-81.47947788699992,
							30.35912987900008
						],
						[
							-81.4794279109999,
							30.35914701400009
						],
						[
							-81.47935382199995,
							30.35919391000004
						],
						[
							-81.47926091999994,
							30.359315112000047
						],
						[
							-81.4790189119999,
							30.359253012000067
						],
						[
							-81.4784559119999,
							30.359139012000075
						],
						[
							-81.47818791299994,
							30.359108013000082
						],
						[
							-81.47781491199993,
							30.359087013000075
						],
						[
							-81.47707689799995,
							30.35906206500005
						],
						[
							-81.47693892099994,
							30.35902295900007
						],
						[
							-81.47637180399994,
							30.358997030000072
						],
						[
							-81.48010495799991,
							30.35750250400008
						],
						[
							-81.48140711699995,
							30.35533225000006
						],
						[
							-81.48082837499993,
							30.353017281000064
						],
						[
							-81.47807937599993,
							30.351425946000063
						],
						[
							-81.47619845699995,
							30.34954521400004
						],
						[
							-81.4756199979999,
							30.347953567000044
						],
						[
							-81.47200295599993,
							30.346940916000055
						],
						[
							-81.46853070299994,
							30.34679629100009
						],
						[
							-81.46534773199994,
							30.347374845000047
						],
						[
							-81.46332216699994,
							30.349689770000055
						],
						[
							-81.46361169699992,
							30.35243868400005
						],
						[
							-81.4637562929999,
							30.355042891000036
						],
						[
							-81.46577704799995,
							30.35850009600006
						],
						[
							-81.46546103199995,
							30.35847193500007
						],
						[
							-81.46538791199994,
							30.358473012000047
						],
						[
							-81.46510190799995,
							30.35845601200009
						],
						[
							-81.46478190699992,
							30.358417012000075
						],
						[
							-81.46467087199994,
							30.358394088000068
						],
						[
							-81.4646059069999,
							30.35834201200004
						],
						[
							-81.46443193399995,
							30.35819996600009
						],
						[
							-81.46430390799992,
							30.358143012000085
						],
						[
							-81.46381890799996,
							30.357839013000046
						],
						[
							-81.4636589079999,
							30.357732012000046
						],
						[
							-81.46328791299993,
							30.357437015000073
						],
						[
							-81.46290990799992,
							30.35725701300004
						],
						[
							-81.46282176799991,
							30.35720613100005
						],
						[
							-81.46278695399991,
							30.35710398500004
						],
						[
							-81.46258490499991,
							30.356823011000078
						],
						[
							-81.46247990699995,
							30.35672701300007
						],
						[
							-81.46209690799992,
							30.356447012000046
						],
						[
							-81.46204390799994,
							30.356403012000044
						],
						[
							-81.46180691099994,
							30.356165012000076
						],
						[
							-81.46163891199991,
							30.355963013000064
						],
						[
							-81.46151690799991,
							30.35579301200005
						],
						[
							-81.46130390799993,
							30.355406012000056
						],
						[
							-81.4612699079999,
							30.355323013000092
						],
						[
							-81.4612049079999,
							30.355165012000047
						],
						[
							-81.4611209119999,
							30.35488101200008
						],
						[
							-81.4606699069999,
							30.353084012000068
						],
						[
							-81.46057090799991,
							30.352633012000073
						],
						[
							-81.46054791299991,
							30.35234101200007
						],
						[
							-81.46056390699994,
							30.352081013000088
						],
						[
							-81.46060890699994,
							30.351667012000064
						],
						[
							-81.46073490799995,
							30.350330013000075
						],
						[
							-81.4608039119999,
							30.349748012000077
						],
						[
							-81.4608889079999,
							30.348883012000048
						],
						[
							-81.46101190799995,
							30.347901012000076
						],
						[
							-81.46102891099991,
							30.347635013000062
						],
						[
							-81.46116591099991,
							30.346466013000057
						],
						[
							-81.46121990799992,
							30.34585201200008
						],
						[
							-81.46144690799991,
							30.343713013000066
						],
						[
							-81.46148991199993,
							30.343325013000086
						],
						[
							-81.46153690799991,
							30.342898012000035
						],
						[
							-81.46166190799994,
							30.34181001200005
						],
						[
							-81.4617919069999,
							30.340567013000058
						],
						[
							-81.46183790999993,
							30.340221011000043
						],
						[
							-81.4619059129999,
							30.34002501300006
						],
						[
							-81.4620209119999,
							30.339813013000086
						],
						[
							-81.46207391199994,
							30.339735013000052
						],
						[
							-81.46223391199993,
							30.339542012000038
						],
						[
							-81.46232590699992,
							30.33945701300007
						],
						[
							-81.4624939119999,
							30.339325013000064
						],
						[
							-81.4626689079999,
							30.33922201300004
						],
						[
							-81.46404990799994,
							30.338589012000057
						],
						[
							-81.46451591099994,
							30.33836701200005
						],
						[
							-81.46481290899993,
							30.338175013000072
						],
						[
							-81.46493490699993,
							30.338055012000044
						],
						[
							-81.46506490799993,
							30.337898013000082
						],
						[
							-81.46543090699993,
							30.337376013000043
						],
						[
							-81.46572091199994,
							30.33693101200004
						],
						[
							-81.46842191099995,
							30.332979013000053
						],
						[
							-81.4685439079999,
							30.332764013000087
						],
						[
							-81.46876490699992,
							30.332462012000065
						],
						[
							-81.46992490699995,
							30.33076101200004
						],
						[
							-81.4703059119999,
							30.330223012000094
						],
						[
							-81.47052990799995,
							30.32989701300005
						],
						[
							-81.47091990799993,
							30.32933401300005
						],
						[
							-81.4713819079999,
							30.32867101200009
						],
						[
							-81.4715879069999,
							30.32830001200006
						],
						[
							-81.4717249119999,
							30.327999012000078
						],
						[
							-81.47177890699993,
							30.327841012000075
						],
						[
							-81.47185490699991,
							30.327532012000063
						],
						[
							-81.47190091199991,
							30.32724801200004
						],
						[
							-81.4721529119999,
							30.325085012000045
						],
						[
							-81.47217590699995,
							30.32482901200007
						],
						[
							-81.47222890799992,
							30.324420012000072
						],
						[
							-81.4722669109999,
							30.324127013000066
						],
						[
							-81.47233490699995,
							30.323637013000056
						],
						[
							-81.47244791199995,
							30.322543013000086
						],
						[
							-81.47250591199992,
							30.322070012000044
						],
						[
							-81.47260190799994,
							30.320983013000042
						],
						[
							-81.47270391199993,
							30.320199013000035
						],
						[
							-81.47291890699995,
							30.318725012000073
						],
						[
							-81.47292990999995,
							30.31855401000007
						],
						[
							-81.4729189059999,
							30.31848301200006
						],
						[
							-81.47288286299994,
							30.318383935000043
						],
						[
							-81.47311791099992,
							30.318297012000073
						],
						[
							-81.47328590699993,
							30.31823901300004
						],
						[
							-81.47390090799992,
							30.318046012000078
						],
						[
							-81.47412390699992,
							30.317988013000047
						],
						[
							-81.4745159119999,
							30.317892012000076
						],
						[
							-81.47473891099992,
							30.31785301200006
						],
						[
							-81.47510791199994,
							30.317795012000094
						],
						[
							-81.47545490699991,
							30.317766012000046
						],
						[
							-81.47599191099994,
							30.317737012000066
						],
						[
							-81.4764949129999,
							30.317737012000066
						],
						[
							-81.47690891099995,
							30.31776601300004
						],
						[
							-81.47743390799991,
							30.317824013000067
						],
						[
							-81.47825091099993,
							30.31793001200009
						],
						[
							-81.4794919119999,
							30.31810401200005
						],
						[
							-81.48075491199995,
							30.318259012000055
						],
						[
							-81.48087791199993,
							30.318278013000054
						],
						[
							-81.48114690699992,
							30.318313012000093
						],
						[
							-81.48123390799992,
							30.31832401200006
						],
						[
							-81.48132091199994,
							30.318338012000083
						],
						[
							-81.4816979069999,
							30.318396013000044
						],
						[
							-81.48234290699992,
							30.318480012000066
						],
						[
							-81.48495790699991,
							30.318838012000075
						],
						[
							-81.4851849069999,
							30.31886901200005
						],
						[
							-81.48586891199994,
							30.318965012000035
						],
						[
							-81.48619391099993,
							30.319005012000048
						],
						[
							-81.48674488099994,
							30.319079098000092
						],
						[
							-81.4870549069999,
							30.319123010000055
						],
						[
							-81.48799890799995,
							30.319257010000058
						],
						[
							-81.48844890599992,
							30.31932001000007
						],
						[
							-81.48911790899992,
							30.31944001100004
						],
						[
							-81.48933090799994,
							30.319480011000053
						],
						[
							-81.49043790799993,
							30.319709011000043
						],
						[
							-81.4913459089999,
							30.319915010000045
						],
						[
							-81.49245190799991,
							30.320200010000065
						],
						[
							-81.4926789079999,
							30.32025801000009
						],
						[
							-81.49319590899995,
							30.320407010000054
						],
						[
							-81.4951989089999,
							30.320980011000074
						],
						[
							-81.49692090699995,
							30.32148701100004
						],
						[
							-81.49924590799992,
							30.32215401000008
						],
						[
							-81.49981090699993,
							30.32231801000006
						],
						[
							-81.50015590699991,
							30.32242101100007
						],
						[
							-81.5010329079999,
							30.322677011000053
						],
						[
							-81.5023129089999,
							30.323039010000063
						],
						[
							-81.50259190799994,
							30.323118010000087
						],
						[
							-81.50324390599991,
							30.323300011000075
						],
						[
							-81.5037549079999,
							30.32343701100007
						],
						[
							-81.50443290699991,
							30.323597011000057
						],
						[
							-81.50534090599992,
							30.323787011000036
						],
						[
							-81.50567490599991,
							30.323855010000045
						],
						[
							-81.50600990799991,
							30.323924011000084
						],
						[
							-81.5071559079999,
							30.324129011000082
						],
						[
							-81.50739790699993,
							30.324168010000054
						],
						[
							-81.50753990599992,
							30.324192010000047
						],
						[
							-81.5079969059999,
							30.324255010000062
						],
						[
							-81.5090639089999,
							30.324401011000077
						],
						[
							-81.51025490599994,
							30.324523010000064
						],
						[
							-81.51094890699996,
							30.32457701000004
						],
						[
							-81.51149590699993,
							30.32460701100007
						],
						[
							-81.51205890699993,
							30.32462801100007
						],
						[
							-81.51336290599994,
							30.324672010000086
						],
						[
							-81.51366790599991,
							30.324677010000077
						],
						[
							-81.51454190899995,
							30.32468901000004
						],
						[
							-81.51535490899994,
							30.324694010000087
						],
						[
							-81.51614490899993,
							30.32468901000004
						],
						[
							-81.51657290799994,
							30.32468901000004
						],
						[
							-81.51784190699993,
							30.32470901000005
						],
						[
							-81.51877890699991,
							30.32472301100006
						],
						[
							-81.5192969069999,
							30.324718010000083
						],
						[
							-81.51993990799991,
							30.324727010000064
						],
						[
							-81.52003590599992,
							30.32472801000006
						],
						[
							-81.52078590699995,
							30.324718010000083
						],
						[
							-81.5213689069999,
							30.324688011000035
						],
						[
							-81.52144590699993,
							30.324684011000045
						],
						[
							-81.52200490799993,
							30.324641010000054
						],
						[
							-81.52311790099992,
							30.324526012000035
						],
						[
							-81.52317290799994,
							30.32673301200009
						],
						[
							-81.52319591199995,
							30.32763201300008
						],
						[
							-81.52323190699992,
							30.328932012000053
						],
						[
							-81.5232619109999,
							30.32959601200008
						],
						[
							-81.52326991199993,
							30.330172013000038
						],
						[
							-81.52330890799993,
							30.332807013000036
						],
						[
							-81.5233229079999,
							30.333712012000035
						],
						[
							-81.52333090799993,
							30.33461001200004
						],
						[
							-81.52332690799994,
							30.335119012000064
						],
						[
							-81.52333090699995,
							30.335281013000042
						],
						[
							-81.52335390699994,
							30.336288012000068
						],
						[
							-81.52335890799992,
							30.336879012000058
						],
						[
							-81.52336891199991,
							30.337915013000043
						],
						[
							-81.52338390799991,
							30.338711012000093
						],
						[
							-81.52341491199991,
							30.340359013000068
						],
						[
							-81.5234219109999,
							30.340792012000065
						],
						[
							-81.52344490799995,
							30.34174901200004
						],
						[
							-81.52346791199994,
							30.34285001300009
						],
						[
							-81.52347591099993,
							30.34331501300005
						],
						[
							-81.52346791199994,
							30.343559013000064
						],
						[
							-81.52349890799991,
							30.34420001300009
						],
						[
							-81.52349890799991,
							30.344460013000063
						],
						[
							-81.52350590799995,
							30.344913012000063
						],
						[
							-81.52351190799993,
							30.34575501200004
						],
						[
							-81.5235672099999,
							30.347898857000075
						],
						[
							-81.52335790799992,
							30.347972013000064
						],
						[
							-81.52262891099991,
							30.348249012000053
						],
						[
							-81.52213890799993,
							30.348425012000064
						],
						[
							-81.51933891099992,
							30.349471013000088
						],
						[
							-81.51780991099993,
							30.350049013000046
						],
						[
							-81.5157379119999,
							30.350825012000087
						],
						[
							-81.51478990699991,
							30.35118401300008
						],
						[
							-81.5126539119999,
							30.351982013000054
						],
						[
							-81.5119279079999,
							30.352255013000047
						],
						[
							-81.51156990699991,
							30.352397013000086
						],
						[
							-81.5107569079999,
							30.35269301200009
						],
						[
							-81.51037490699991,
							30.35284001300005
						],
						[
							-81.50941590799994,
							30.353175013000058
						],
						[
							-81.50890391099995,
							30.353392013000075
						],
						[
							-81.50786490799993,
							30.35379501300008
						],
						[
							-81.50768291199995,
							30.353884012000037
						],
						[
							-81.50707990699993,
							30.35417001300004
						],
						[
							-81.50683591099994,
							30.35430501300004
						],
						[
							-81.50636291199993,
							30.35459301200007
						],
						[
							-81.50577491199994,
							30.355036012000085
						],
						[
							-81.50540891199995,
							30.355333012000074
						],
						[
							-81.50497390699991,
							30.355738013000064
						],
						[
							-81.5046689109999,
							30.356070013000082
						],
						[
							-81.5040739069999,
							30.35683801300007
						],
						[
							-81.50385990699993,
							30.357170013000086
						],
						[
							-81.50340291199991,
							30.358007012000087
						],
						[
							-81.50318091199995,
							30.358583012000057
						],
						[
							-81.50307391199995,
							30.358945013000035
						],
						[
							-81.50300391199994,
							30.359175012000037
						],
						[
							-81.50294191199993,
							30.35945901200006
						],
						[
							-81.50283590799995,
							30.36006401300006
						],
						[
							-81.50281791099991,
							30.360222014000044
						],
						[
							-81.50280892699993,
							30.360274005000065
						],
						[
							-81.50272890799994,
							30.360269012000064
						],
						[
							-81.50040491099992,
							30.360113012000056
						],
						[
							-81.49944890799992,
							30.36007101200005
						],
						[
							-81.49842490899994,
							30.359991012000084
						],
						[
							-81.49797890999992,
							30.359967013000077
						],
						[
							-81.49587391099995,
							30.35987501200009
						],
						[
							-81.49554690899993,
							30.35985801200007
						],
						[
							-81.49539090899992,
							30.35984801300009
						],
						[
							-81.4917519089999,
							30.359718012000087
						],
						[
							-81.4915429109999,
							30.359698013000067
						],
						[
							-81.49135190899995,
							30.359695013000074
						],
						[
							-81.49021440999991,
							30.35963101300007
						],
						[
							-81.48946190799991,
							30.359599012000047
						],
						[
							-81.48794990999994,
							30.359531013000037
						],
						[
							-81.48463790799991,
							30.35940301300008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "East Arlington",
				"RegionID": "268970"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.58975790599995,
					30.35185892000004,
					-81.57703894699995,
					30.366514178000042
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.58040590999991,
							30.365675012000054
						],
						[
							-81.58019986799991,
							30.36567292600006
						],
						[
							-81.5797119099999,
							30.365694012000063
						],
						[
							-81.57951390699992,
							30.365675011000068
						],
						[
							-81.57930791199993,
							30.36560801500008
						],
						[
							-81.57913990999994,
							30.36559101200004
						],
						[
							-81.57860590999991,
							30.36559301200009
						],
						[
							-81.57751190899995,
							30.365604012000066
						],
						[
							-81.57703894699995,
							30.365619080000045
						],
						[
							-81.57706490899994,
							30.36508901200006
						],
						[
							-81.57707990999995,
							30.36466701200004
						],
						[
							-81.57710790999994,
							30.363880012000042
						],
						[
							-81.57715490999993,
							30.362882012000057
						],
						[
							-81.57717790899994,
							30.362198012000075
						],
						[
							-81.57722490999993,
							30.361232013000066
						],
						[
							-81.57723990899991,
							30.360996013000094
						],
						[
							-81.5772609089999,
							30.360297012000046
						],
						[
							-81.57729990999991,
							30.35951901200008
						],
						[
							-81.57733890999992,
							30.359339013000067
						],
						[
							-81.57744990899994,
							30.358971013000087
						],
						[
							-81.57753990999993,
							30.358633012000045
						],
						[
							-81.5777959099999,
							30.357810012000073
						],
						[
							-81.57797790899991,
							30.35724201300008
						],
						[
							-81.57804890999995,
							30.35700001200007
						],
						[
							-81.57814596299994,
							30.35666302200008
						],
						[
							-81.5781609089999,
							30.356419012000064
						],
						[
							-81.57815190999992,
							30.356109012000044
						],
						[
							-81.5781349099999,
							30.35499401300007
						],
						[
							-81.57812390999993,
							30.354468013000087
						],
						[
							-81.57811390899991,
							30.353486012000076
						],
						[
							-81.57808890899992,
							30.353280012000088
						],
						[
							-81.57805290699991,
							30.353153011000074
						],
						[
							-81.5779619079999,
							30.352988012000083
						],
						[
							-81.57768591199994,
							30.35266001300005
						],
						[
							-81.57761885999993,
							30.35252703100008
						],
						[
							-81.57758790999992,
							30.35237101300004
						],
						[
							-81.57756591499992,
							30.352039010000055
						],
						[
							-81.57858290699994,
							30.352024010000036
						],
						[
							-81.57959690699994,
							30.352013010000068
						],
						[
							-81.5803299079999,
							30.352001010000038
						],
						[
							-81.58162190799993,
							30.351981010000088
						],
						[
							-81.58222990799993,
							30.351971010000053
						],
						[
							-81.5832819069999,
							30.351961010000085
						],
						[
							-81.58429690699995,
							30.351942010000073
						],
						[
							-81.58534190699993,
							30.351925010000055
						],
						[
							-81.58583690799992,
							30.351915010000088
						],
						[
							-81.58649390799991,
							30.35191201000004
						],
						[
							-81.58801690799993,
							30.351891010000088
						],
						[
							-81.58953489499993,
							30.35185892000004
						],
						[
							-81.5895639069999,
							30.352423010000056
						],
						[
							-81.58955390799991,
							30.35293601100005
						],
						[
							-81.58957090799993,
							30.353633010000067
						],
						[
							-81.5895799079999,
							30.35410901000006
						],
						[
							-81.58958590799995,
							30.35460801000005
						],
						[
							-81.58960190699993,
							30.354872011000054
						],
						[
							-81.5896019079999,
							30.355026011000064
						],
						[
							-81.58962190699992,
							30.355846010000054
						],
						[
							-81.58964390699992,
							30.356437010000036
						],
						[
							-81.58969890799995,
							30.358574011000087
						],
						[
							-81.58972690799993,
							30.359483010000076
						],
						[
							-81.58974890799993,
							30.360248011000063
						],
						[
							-81.58975790599995,
							30.360612010000068
						],
						[
							-81.58967490799995,
							30.36117001000008
						],
						[
							-81.58960490699991,
							30.361421010000072
						],
						[
							-81.5894719069999,
							30.36177001100009
						],
						[
							-81.58914290799993,
							30.362577010000052
						],
						[
							-81.58891190799994,
							30.363192010000034
						],
						[
							-81.58832090699991,
							30.364700010000035
						],
						[
							-81.58799390899992,
							30.36557301000005
						],
						[
							-81.5879149079999,
							30.36606901000005
						],
						[
							-81.58789690899994,
							30.366283010000075
						],
						[
							-81.58790590399991,
							30.366447064000052
						],
						[
							-81.58702090999992,
							30.366449012000093
						],
						[
							-81.5861329089999,
							30.36646001300005
						],
						[
							-81.58589490899993,
							30.366470012000036
						],
						[
							-81.58524390999992,
							30.366470012000036
						],
						[
							-81.5848269089999,
							30.366478013000066
						],
						[
							-81.5843509099999,
							30.366489012000045
						],
						[
							-81.58358090899992,
							30.366505012000065
						],
						[
							-81.5834749089999,
							30.366506012000062
						],
						[
							-81.58240490899993,
							30.36651201200004
						],
						[
							-81.58231185599993,
							30.366514178000042
						],
						[
							-81.58146594199991,
							30.365896935000084
						],
						[
							-81.58135990999995,
							30.36588301200004
						],
						[
							-81.58119190999992,
							30.365837012000043
						],
						[
							-81.58064990999992,
							30.36570501200004
						],
						[
							-81.58040590999991,
							30.365675012000054
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Fairways Forest",
				"RegionID": "268983"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.14564037199995,
					26.12222584700004,
					-80.13633981399994,
					26.137000881000063
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.13812325899994,
							26.137000881000063
						],
						[
							-80.13794403899993,
							26.13693952600005
						],
						[
							-80.13741523099992,
							26.136952678000057
						],
						[
							-80.13633981399994,
							26.136977624000053
						],
						[
							-80.13660603099993,
							26.136846521000052
						],
						[
							-80.13676226399991,
							26.136759391000055
						],
						[
							-80.13685740499994,
							26.136692293000067
						],
						[
							-80.13692350299993,
							26.136647225000047
						],
						[
							-80.13697357699994,
							26.13661217300006
						],
						[
							-80.13705469699994,
							26.136552085000066
						],
						[
							-80.13711078099993,
							26.13650501500007
						],
						[
							-80.13717387399993,
							26.13645794200005
						],
						[
							-80.13722094299993,
							26.13640186100008
						],
						[
							-80.13727201899991,
							26.136347782000087
						],
						[
							-80.13730707099995,
							26.136304718000076
						],
						[
							-80.1374002089999,
							26.13618153500005
						],
						[
							-80.13748533599995,
							26.13604633400007
						],
						[
							-80.1375784729999,
							26.13589410800006
						],
						[
							-80.13762654499993,
							26.13577593300005
						],
						[
							-80.1376816259999,
							26.13560668200006
						],
						[
							-80.13771968299994,
							26.13536232100006
						],
						[
							-80.13772969899992,
							26.135209091000036
						],
						[
							-80.1377216869999,
							26.134962728000065
						],
						[
							-80.13771567799995,
							26.13442492900009
						],
						[
							-80.1376816259999,
							26.13355864500005
						],
						[
							-80.1376816259999,
							26.13344046900005
						],
						[
							-80.1376816259999,
							26.13334833300007
						],
						[
							-80.13763355599991,
							26.13194625300008
						],
						[
							-80.13762854799995,
							26.131681861000065
						],
						[
							-80.1376185339999,
							26.131414465000095
						],
						[
							-80.1375624499999,
							26.130478076000088
						],
						[
							-80.13755543999991,
							26.12991924700009
						],
						[
							-80.13754943099991,
							26.129452555000057
						],
						[
							-80.1375163809999,
							26.12841902200006
						],
						[
							-80.13751938699994,
							26.12800541000007
						],
						[
							-80.13745729499993,
							26.126207743000066
						],
						[
							-80.1374382649999,
							26.12522428400007
						],
						[
							-80.13741222699991,
							26.124292903000082
						],
						[
							-80.13738017999992,
							26.12336352600005
						],
						[
							-80.13734512699995,
							26.122421129000088
						],
						[
							-80.14549020699991,
							26.12222584700004
						],
						[
							-80.14551725199993,
							26.123993451000047
						],
						[
							-80.14564037199995,
							26.12595637000004
						],
						[
							-80.14563341999991,
							26.126373990000047
						],
						[
							-80.14562540799994,
							26.12680462900005
						],
						[
							-80.14560938299991,
							26.12767792200009
						],
						[
							-80.14554128399993,
							26.127973361000045
						],
						[
							-80.14541309299995,
							26.12853719900005
						],
						[
							-80.1452849019999,
							26.129097026000068
						],
						[
							-80.14501052999992,
							26.129711861000093
						],
						[
							-80.1448132029999,
							26.130081489000077
						],
						[
							-80.14436461399993,
							26.130830650000064
						],
						[
							-80.14393783199995,
							26.13141144800005
						],
						[
							-80.14325889799994,
							26.132093473000054
						],
						[
							-80.1428923549999,
							26.132428970000035
						],
						[
							-80.14095337899994,
							26.134425969000063
						],
						[
							-80.1394141959999,
							26.136205570000072
						],
						[
							-80.13865006299994,
							26.136873561000076
						],
						[
							-80.13860299399994,
							26.136914622000063
						],
						[
							-80.13859889299994,
							26.13691842600008
						],
						[
							-80.13852187499992,
							26.136989864000043
						],
						[
							-80.13826048599992,
							26.136993739000047
						],
						[
							-80.13812325899994,
							26.137000881000063
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Flagler Heights",
				"RegionID": "268984"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.17777308699993,
					26.099885696000058,
					-80.16943972599995,
					26.10677892600006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.1695499029999,
							26.10677892600006
						],
						[
							-80.16953887299991,
							26.106562608000047
						],
						[
							-80.16943972599995,
							26.099885696000058
						],
						[
							-80.17368791299992,
							26.09993290600005
						],
						[
							-80.17439707799991,
							26.099940787000037
						],
						[
							-80.17515319899991,
							26.09994279100005
						],
						[
							-80.17620781999995,
							26.09992072500006
						],
						[
							-80.1762548339999,
							26.100147090000064
						],
						[
							-80.17626985499993,
							26.100179145000087
						],
						[
							-80.17629188899991,
							26.100282295000056
						],
						[
							-80.17642208199993,
							26.10062379900006
						],
						[
							-80.17652122899995,
							26.100798059000056
						],
						[
							-80.17666644299993,
							26.101021391000074
						],
						[
							-80.1768647369999,
							26.10132984700005
						],
						[
							-80.17694085099993,
							26.101433000000046
						],
						[
							-80.17713213499991,
							26.101713416000052
						],
						[
							-80.17736848499993,
							26.10208296500008
						],
						[
							-80.17745260899994,
							26.102261230000067
						],
						[
							-80.17749767599992,
							26.10236338100009
						],
						[
							-80.17760483499991,
							26.102706890000036
						],
						[
							-80.17766592499993,
							26.10304338900005
						],
						[
							-80.1776729369999,
							26.103236675000062
						],
						[
							-80.1777109919999,
							26.104522583000062
						],
						[
							-80.1777230109999,
							26.10474591400009
						],
						[
							-80.1777450429999,
							26.10557213900006
						],
						[
							-80.17777308699993,
							26.106404369000074
						],
						[
							-80.1768266819999,
							26.106457452000086
						],
						[
							-80.17616970599994,
							26.10650352000005
						],
						[
							-80.17588328099993,
							26.10652755600006
						],
						[
							-80.17515820599994,
							26.106589648000067
						],
						[
							-80.17504800699993,
							26.10660083500005
						],
						[
							-80.17493489899994,
							26.106533485000057
						],
						[
							-80.1748727829999,
							26.106530561000056
						],
						[
							-80.1745132499999,
							26.106494507000036
						],
						[
							-80.17377114999994,
							26.106426407000072
						],
						[
							-80.17312006399993,
							26.106379192000077
						],
						[
							-80.17310628899992,
							26.106504661000088
						],
						[
							-80.1726895459999,
							26.106525554000086
						],
						[
							-80.17220182299991,
							26.106581636000048
						],
						[
							-80.1720465919999,
							26.106598661000078
						],
						[
							-80.17162696999992,
							26.10665274300004
						],
						[
							-80.1712003369999,
							26.106702816000055
						],
						[
							-80.17046023899991,
							26.106767913000056
						],
						[
							-80.17009870299995,
							26.106767913000056
						],
						[
							-80.16985033499992,
							26.106761904000052
						],
						[
							-80.1695499029999,
							26.10677892600006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Flamingo Park",
				"RegionID": "268985"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.06257938999994,
					26.690420000000074,
					-80.05405999999994,
					26.698050940000087
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.05554999999993,
							26.69790000000006
						],
						[
							-80.05465816999993,
							26.69789000000009
						],
						[
							-80.05426551199992,
							26.69789197600005
						],
						[
							-80.05418136999992,
							26.69790345000007
						],
						[
							-80.05411424399995,
							26.697912603000077
						],
						[
							-80.05405999999994,
							26.697920000000067
						],
						[
							-80.05406973299995,
							26.697817798000074
						],
						[
							-80.05408045999991,
							26.69769112700004
						],
						[
							-80.05408491599991,
							26.697508436000078
						],
						[
							-80.05408801599992,
							26.69738134700009
						],
						[
							-80.05408999999992,
							26.69730000000004
						],
						[
							-80.05409310599994,
							26.697222344000068
						],
						[
							-80.05409999999995,
							26.697050000000047
						],
						[
							-80.05410999999992,
							26.69694000000004
						],
						[
							-80.0541184139999,
							26.69672963800008
						],
						[
							-80.05412382299995,
							26.69659442300008
						],
						[
							-80.05412764499994,
							26.69649888500004
						],
						[
							-80.05412999999993,
							26.696440000000056
						],
						[
							-80.05413000199991,
							26.696439944000076
						],
						[
							-80.05413330399995,
							26.696364005000078
						],
						[
							-80.05413675299991,
							26.69628467700005
						],
						[
							-80.0541399999999,
							26.696210000000065
						],
						[
							-80.05414528999997,
							26.69612536300008
						],
						[
							-80.05414999999994,
							26.69605000000007
						],
						[
							-80.05415268399992,
							26.695958742000073
						],
						[
							-80.05415596799992,
							26.695847101000084
						],
						[
							-80.05415853699992,
							26.695759751000082
						],
						[
							-80.05416297399995,
							26.695608873000083
						],
						[
							-80.05416648499994,
							26.695489525000085
						],
						[
							-80.0541680529999,
							26.69543618700004
						],
						[
							-80.05416900599994,
							26.695403791000047
						],
						[
							-80.05416999999994,
							26.695370000000082
						],
						[
							-80.05417255899994,
							26.695341849000044
						],
						[
							-80.0541766739999,
							26.695296587000087
						],
						[
							-80.05417999999992,
							26.695260000000076
						],
						[
							-80.05418469299991,
							26.695169664000048
						],
						[
							-80.05419230599995,
							26.695023116000073
						],
						[
							-80.05420036399994,
							26.694867985000087
						],
						[
							-80.05420666999993,
							26.694746605000095
						],
						[
							-80.05421222199993,
							26.694639726000048
						],
						[
							-80.05421691299995,
							26.69454943100004
						],
						[
							-80.05421999999993,
							26.694490000000087
						],
						[
							-80.05422312799993,
							26.69437428200007
						],
						[
							-80.05422739099993,
							26.694216542000053
						],
						[
							-80.05423211499993,
							26.694041742000085
						],
						[
							-80.0542357029999,
							26.693908985000064
						],
						[
							-80.05423760499991,
							26.69383860800008
						],
						[
							-80.0542392829999,
							26.69377653300006
						],
						[
							-80.0542391749999,
							26.69374932800008
						],
						[
							-80.0542994409999,
							26.69375106800004
						],
						[
							-80.05439515499995,
							26.693753831000038
						],
						[
							-80.05483479599991,
							26.69376606500009
						],
						[
							-80.05534636399994,
							26.693773987000043
						],
						[
							-80.05583849399994,
							26.693785523000088
						],
						[
							-80.05621254399995,
							26.693803057000082
						],
						[
							-80.05631757099991,
							26.693807745000072
						],
						[
							-80.05639999999994,
							26.693810000000042
						],
						[
							-80.0567440829999,
							26.693819733000055
						],
						[
							-80.05700644899991,
							26.693822905000047
						],
						[
							-80.05712436699991,
							26.69382756600004
						],
						[
							-80.05721999999992,
							26.693830000000048
						],
						[
							-80.05735407299994,
							26.693833690000076
						],
						[
							-80.05755752399995,
							26.693838733000064
						],
						[
							-80.05770179699994,
							26.69384200400009
						],
						[
							-80.0578987849999,
							26.693848682000066
						],
						[
							-80.0581021239999,
							26.693851081000048
						],
						[
							-80.05824639699995,
							26.693854352000077
						],
						[
							-80.05832510199991,
							26.69385824200009
						],
						[
							-80.0583299999999,
							26.693740000000048
						],
						[
							-80.05833856699991,
							26.69360686300007
						],
						[
							-80.05834501499993,
							26.69335753300004
						],
						[
							-80.05835105999995,
							26.693166816000087
						],
						[
							-80.05835859699994,
							26.69305575100009
						],
						[
							-80.05836834399992,
							26.692912117000052
						],
						[
							-80.05837255599994,
							26.69278018600005
						],
						[
							-80.05838218499991,
							26.692589798000085
						],
						[
							-80.05838563099991,
							26.692481912000062
						],
						[
							-80.05839970499994,
							26.69235383700004
						],
						[
							-80.05840977799994,
							26.692222883000056
						],
						[
							-80.0584199999999,
							26.692090000000064
						],
						[
							-80.0584114689999,
							26.691946623000035
						],
						[
							-80.05842999999993,
							26.691790000000083
						],
						[
							-80.05843497699993,
							26.691658102000076
						],
						[
							-80.05844016899994,
							26.691520512000068
						],
						[
							-80.0584441439999,
							26.691415187000075
						],
						[
							-80.05844760499991,
							26.691323460000035
						],
						[
							-80.05844999999994,
							26.69126000000006
						],
						[
							-80.05844999999994,
							26.691166077000048
						],
						[
							-80.05844999999994,
							26.691110000000037
						],
						[
							-80.05844967999991,
							26.691028283000037
						],
						[
							-80.05845845899995,
							26.690890077000063
						],
						[
							-80.05848012599995,
							26.690824830000054
						],
						[
							-80.05848364499991,
							26.69068056800006
						],
						[
							-80.05848617299995,
							26.690576924000084
						],
						[
							-80.05848829099995,
							26.690490086000068
						],
						[
							-80.05848999999995,
							26.690420000000074
						],
						[
							-80.0586696819999,
							26.69042442600005
						],
						[
							-80.05897117099994,
							26.690431852000078
						],
						[
							-80.05938583499994,
							26.690442065000074
						],
						[
							-80.0599588689999,
							26.69045617900008
						],
						[
							-80.06051708799994,
							26.690469928000084
						],
						[
							-80.06051999999994,
							26.69047000000006
						],
						[
							-80.0607652089999,
							26.690476940000053
						],
						[
							-80.06115725399991,
							26.690488035000044
						],
						[
							-80.06166981199993,
							26.69050309700009
						],
						[
							-80.0622877269999,
							26.690521767000064
						],
						[
							-80.06257938999994,
							26.690529653000056
						],
						[
							-80.06257938899995,
							26.69052977800004
						],
						[
							-80.0625778509999,
							26.690741742000057
						],
						[
							-80.06253000099991,
							26.690740000000062
						],
						[
							-80.06249999999994,
							26.691490000000044
						],
						[
							-80.0624699999999,
							26.69228000000004
						],
						[
							-80.06243999999992,
							26.693080000000066
						],
						[
							-80.0624099989999,
							26.693920001000038
						],
						[
							-80.06239999899992,
							26.69444000100009
						],
						[
							-80.0623799999999,
							26.694840001000046
						],
						[
							-80.06234999899993,
							26.695640001000072
						],
						[
							-80.06231999999994,
							26.696540001000074
						],
						[
							-80.06228999899993,
							26.697340001000043
						],
						[
							-80.0622633399999,
							26.698050940000087
						],
						[
							-80.06222999999994,
							26.69805000000008
						],
						[
							-80.06155318799995,
							26.698033885000086
						],
						[
							-80.0609294439999,
							26.698019034000083
						],
						[
							-80.06051648999994,
							26.698009202000037
						],
						[
							-80.06031528199992,
							26.698004411000056
						],
						[
							-80.0601299999999,
							26.698000000000036
						],
						[
							-80.05917776299992,
							26.697987366000064
						],
						[
							-80.05869506399995,
							26.69797782200004
						],
						[
							-80.0583732039999,
							26.697967901000084
						],
						[
							-80.05814999999991,
							26.697940000000074
						],
						[
							-80.05763776599991,
							26.69793085300006
						],
						[
							-80.05728556499992,
							26.69792456400006
						],
						[
							-80.05702999999994,
							26.697920000000067
						],
						[
							-80.05635937899991,
							26.69790984800005
						],
						[
							-80.05589990999994,
							26.697903284000063
						],
						[
							-80.05573856299992,
							26.697900979000057
						],
						[
							-80.05572520099992,
							26.697900789000073
						],
						[
							-80.05554999999993,
							26.69790000000006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "West Palm Beach",
				"Name": "Flamingo Park",
				"RegionID": "268986"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.4815549999999,
					28.447885000000042,
					-81.41763399999991,
					28.489899724000054
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.45217909999991,
							28.48286179200005
						],
						[
							-81.45073495799994,
							28.48077069200008
						],
						[
							-81.4502872949999,
							28.480155779000086
						],
						[
							-81.44964634399993,
							28.47908719500009
						],
						[
							-81.4494820999999,
							28.478868870000042
						],
						[
							-81.44930683899992,
							28.478626511000073
						],
						[
							-81.44918866499995,
							28.47847228300009
						],
						[
							-81.44891025099993,
							28.478083706000064
						],
						[
							-81.44868091199993,
							28.477732186000082
						],
						[
							-81.4481961919999,
							28.477087228000073
						],
						[
							-81.4469623629999,
							28.47552190700009
						],
						[
							-81.4463382639999,
							28.47468161200004
						],
						[
							-81.44636064399992,
							28.47467269300006
						],
						[
							-81.44632524199994,
							28.47462754500009
						],
						[
							-81.44635063699991,
							28.474613606000048
						],
						[
							-81.44618420799993,
							28.474361185000078
						],
						[
							-81.44608305899993,
							28.474219976000086
						],
						[
							-81.44596388199994,
							28.474057736000077
						],
						[
							-81.44556228699992,
							28.473514931000068
						],
						[
							-81.44519273899994,
							28.47301118300004
						],
						[
							-81.44512163299993,
							28.47292205100007
						],
						[
							-81.44446566099992,
							28.472095825000054
						],
						[
							-81.44444362699994,
							28.47205977300007
						],
						[
							-81.44437853099993,
							28.471976649000055
						],
						[
							-81.44418724799993,
							28.471728280000036
						],
						[
							-81.44386677299991,
							28.47134671500004
						],
						[
							-81.44294540499995,
							28.47036726300007
						],
						[
							-81.4419849809999,
							28.469410844000038
						],
						[
							-81.44148920499993,
							28.46897703500008
						],
						[
							-81.44145219199993,
							28.469075346000068
						],
						[
							-81.44141416799994,
							28.469157646000042
						],
						[
							-81.4404236659999,
							28.46828116800009
						],
						[
							-81.44014231799991,
							28.46804487600008
						],
						[
							-81.43993292999996,
							28.471805519000046
						],
						[
							-81.43992813799991,
							28.471885000000043
						],
						[
							-81.43984581099994,
							28.471885000000043
						],
						[
							-81.43930299999994,
							28.471885000000043
						],
						[
							-81.43930599999995,
							28.471678000000054
						],
						[
							-81.4393159999999,
							28.47097800000006
						],
						[
							-81.43945299999992,
							28.470980000000054
						],
						[
							-81.43946799999992,
							28.469797000000085
						],
						[
							-81.43953399999992,
							28.467808000000048
						],
						[
							-81.4394309999999,
							28.467719000000045
						],
						[
							-81.43944699999992,
							28.46767600000004
						],
						[
							-81.43946499999993,
							28.467652000000044
						],
						[
							-81.43842199999995,
							28.466729000000043
						],
						[
							-81.43836599999992,
							28.46667800000006
						],
						[
							-81.43618692299992,
							28.46477798500007
						],
						[
							-81.4352659999999,
							28.463975000000065
						],
						[
							-81.43087899999995,
							28.464030000000037
						],
						[
							-81.42972999999995,
							28.46404500000006
						],
						[
							-81.42800999999992,
							28.46413300000006
						],
						[
							-81.42800999999992,
							28.463992000000076
						],
						[
							-81.42113599999993,
							28.46417900000006
						],
						[
							-81.42112850099996,
							28.464180000000056
						],
						[
							-81.42112099999991,
							28.464181000000053
						],
						[
							-81.41969730599993,
							28.464231130000087
						],
						[
							-81.41913299999993,
							28.464251000000047
						],
						[
							-81.4189179999999,
							28.46423800000008
						],
						[
							-81.41763399999991,
							28.464229000000046
						],
						[
							-81.4181999999999,
							28.463535000000036
						],
						[
							-81.42056299999992,
							28.459277000000043
						],
						[
							-81.42116599999991,
							28.459628000000066
						],
						[
							-81.42123299999992,
							28.459512000000075
						],
						[
							-81.4215559999999,
							28.45898800000009
						],
						[
							-81.42107299999994,
							28.45863600000007
						],
						[
							-81.42392499999994,
							28.455400000000054
						],
						[
							-81.42430399999995,
							28.455880000000036
						],
						[
							-81.42649181299993,
							28.45728822400008
						],
						[
							-81.43082599999993,
							28.460078000000067
						],
						[
							-81.43089541299993,
							28.46002247000007
						],
						[
							-81.43093099999993,
							28.45999400000005
						],
						[
							-81.4312579999999,
							28.459781000000078
						],
						[
							-81.43132199999991,
							28.459800000000087
						],
						[
							-81.4315949999999,
							28.45971300000008
						],
						[
							-81.43163099999992,
							28.459663000000038
						],
						[
							-81.43170399999991,
							28.459528000000034
						],
						[
							-81.43172199999992,
							28.459415000000035
						],
						[
							-81.4316859999999,
							28.459324000000038
						],
						[
							-81.43208599999991,
							28.45896300000004
						],
						[
							-81.43221299999993,
							28.458761000000038
						],
						[
							-81.43223199999994,
							28.458604000000037
						],
						[
							-81.43221299999993,
							28.458483000000058
						],
						[
							-81.43186799999995,
							28.45810000000006
						],
						[
							-81.43172199999992,
							28.45778400000006
						],
						[
							-81.4315949999999,
							28.457403000000056
						],
						[
							-81.43155799999994,
							28.457134000000053
						],
						[
							-81.4315949999999,
							28.45682000000005
						],
						[
							-81.43153999999993,
							28.45657300000005
						],
						[
							-81.43147899999991,
							28.456530000000043
						],
						[
							-81.43158399999993,
							28.456100000000053
						],
						[
							-81.43151299999994,
							28.45587100000006
						],
						[
							-81.4313939999999,
							28.455684000000076
						],
						[
							-81.43141799999995,
							28.45543500000008
						],
						[
							-81.43120499999992,
							28.45499800000005
						],
						[
							-81.43127599999991,
							28.454769000000056
						],
						[
							-81.43167799999992,
							28.454457000000048
						],
						[
							-81.4317969999999,
							28.45412500000009
						],
						[
							-81.43205699999993,
							28.453813000000082
						],
						[
							-81.43234099999995,
							28.453563000000088
						],
						[
							-81.43245899999994,
							28.453126000000054
						],
						[
							-81.43267199999991,
							28.45210700000007
						],
						[
							-81.4323169999999,
							28.45179500000006
						],
						[
							-81.43256199999992,
							28.450097000000085
						],
						[
							-81.4374719999999,
							28.450147000000076
						],
						[
							-81.43934994699993,
							28.45017321100005
						],
						[
							-81.43990799999995,
							28.450181000000043
						],
						[
							-81.4415720959999,
							28.45020452400007
						],
						[
							-81.44210099999992,
							28.45021200000008
						],
						[
							-81.44210099999992,
							28.450376000000063
						],
						[
							-81.4415726439999,
							28.450368230000038
						],
						[
							-81.44087699999994,
							28.450358000000055
						],
						[
							-81.44079199999993,
							28.45175800000004
						],
						[
							-81.44208199999991,
							28.451808000000085
						],
						[
							-81.44198699999993,
							28.45369100000005
						],
						[
							-81.44215699999995,
							28.456806000000086
						],
						[
							-81.44225999999993,
							28.459701000000052
						],
						[
							-81.44229299999995,
							28.461024000000066
						],
						[
							-81.44239299999992,
							28.461007000000052
						],
						[
							-81.4426929999999,
							28.46100800000005
						],
						[
							-81.4426929999999,
							28.46108200000009
						],
						[
							-81.44267599999995,
							28.461193000000037
						],
						[
							-81.44505229899994,
							28.461208987000077
						],
						[
							-81.44639199999995,
							28.461218000000088
						],
						[
							-81.44648699999993,
							28.46120300000007
						],
						[
							-81.45028999999994,
							28.461220000000083
						],
						[
							-81.45051199999995,
							28.461232000000056
						],
						[
							-81.45051288799993,
							28.46116714300007
						],
						[
							-81.45051399999994,
							28.46108600000008
						],
						[
							-81.4505265869999,
							28.46055061400006
						],
						[
							-81.4505289999999,
							28.460448000000042
						],
						[
							-81.45053399999995,
							28.45958200000007
						],
						[
							-81.45053699999994,
							28.459175000000073
						],
						[
							-81.45055899999994,
							28.455692000000056
						],
						[
							-81.4505509999999,
							28.453985000000046
						],
						[
							-81.45053599999994,
							28.452179000000058
						],
						[
							-81.45053599999994,
							28.450183000000038
						],
						[
							-81.45053599999994,
							28.449762000000078
						],
						[
							-81.4512791709999,
							28.449763215000075
						],
						[
							-81.45604299999991,
							28.44977100000006
						],
						[
							-81.45694899999995,
							28.449772000000056
						],
						[
							-81.45990999999992,
							28.449772000000056
						],
						[
							-81.45996811599991,
							28.449772000000056
						],
						[
							-81.46152099999995,
							28.449772000000056
						],
						[
							-81.4621489999999,
							28.449772000000056
						],
						[
							-81.4621489999999,
							28.44988868900009
						],
						[
							-81.4621489999999,
							28.449928000000057
						],
						[
							-81.46417699999995,
							28.44993100000005
						],
						[
							-81.46417699999995,
							28.44988950800007
						],
						[
							-81.46417699999995,
							28.447885000000042
						],
						[
							-81.46453546599992,
							28.447886593000078
						],
						[
							-81.46552699999995,
							28.447891000000084
						],
						[
							-81.4653669999999,
							28.449249000000066
						],
						[
							-81.46527899999995,
							28.44993800000009
						],
						[
							-81.46545399999991,
							28.449932000000047
						],
						[
							-81.46579899999995,
							28.449932000000047
						],
						[
							-81.46586599999995,
							28.449932000000047
						],
						[
							-81.46586599999995,
							28.450083000000063
						],
						[
							-81.46586699999995,
							28.452537000000067
						],
						[
							-81.46586599999995,
							28.45648600000004
						],
						[
							-81.46586599999995,
							28.457129000000066
						],
						[
							-81.47080415799991,
							28.457128037000075
						],
						[
							-81.4709939999999,
							28.45712800000007
						],
						[
							-81.47307499999994,
							28.45712700000007
						],
						[
							-81.4736039199999,
							28.45712700000007
						],
						[
							-81.47366399999993,
							28.45712700000007
						],
						[
							-81.47384499999993,
							28.45712700000007
						],
						[
							-81.47422899999992,
							28.454541000000063
						],
						[
							-81.47435233399995,
							28.454565260000038
						],
						[
							-81.47451026099992,
							28.45459632300009
						],
						[
							-81.47634899999991,
							28.45495800000009
						],
						[
							-81.4764449999999,
							28.45483900000005
						],
						[
							-81.47660399999995,
							28.454642000000035
						],
						[
							-81.47660399999995,
							28.45455542500008
						],
						[
							-81.47660399999995,
							28.453620000000058
						],
						[
							-81.47658899999993,
							28.453321000000074
						],
						[
							-81.47676199999995,
							28.453321000000074
						],
						[
							-81.4793039999999,
							28.453321000000074
						],
						[
							-81.47969177699991,
							28.453321000000074
						],
						[
							-81.47983599999992,
							28.453321000000074
						],
						[
							-81.4805885749999,
							28.453530343000068
						],
						[
							-81.48053455599997,
							28.453636043000074
						],
						[
							-81.4804989129999,
							28.453741019000063
						],
						[
							-81.48046092999994,
							28.453915432000088
						],
						[
							-81.48041601499995,
							28.454681183000048
						],
						[
							-81.48057810599994,
							28.455226965000065
						],
						[
							-81.48058467899995,
							28.455250238000076
						],
						[
							-81.48059804199994,
							28.45530755100009
						],
						[
							-81.48060539899991,
							28.455349771000044
						],
						[
							-81.48064239899992,
							28.455596770000056
						],
						[
							-81.48064462799994,
							28.455612615000064
						],
						[
							-81.48065039699992,
							28.45567118100007
						],
						[
							-81.48065232199991,
							28.455730000000074
						],
						[
							-81.48065039699992,
							28.455788818000087
						],
						[
							-81.48064462799994,
							28.455847385000084
						],
						[
							-81.4806386699999,
							28.455886108000072
						],
						[
							-81.48059651499995,
							28.456125270000086
						],
						[
							-81.48076181099992,
							28.45604262200004
						],
						[
							-81.48076623999992,
							28.456040423000047
						],
						[
							-81.48081984399994,
							28.456016135000084
						],
						[
							-81.48087492199994,
							28.455995405000067
						],
						[
							-81.48090100099995,
							28.455986993000067
						],
						[
							-81.4812276639999,
							28.455887096000087
						],
						[
							-81.48137732599992,
							28.455841200000066
						],
						[
							-81.48140823799991,
							28.45583232100006
						],
						[
							-81.48146555099993,
							28.455818958000066
						],
						[
							-81.4815236149999,
							28.455809371000043
						],
						[
							-81.4815418089999,
							28.455807579000066
						],
						[
							-81.48154299999995,
							28.456504000000052
						],
						[
							-81.48154199999993,
							28.456734000000043
						],
						[
							-81.48154199999993,
							28.456968000000074
						],
						[
							-81.48112999999995,
							28.45697000000007
						],
						[
							-81.48076299999991,
							28.45696700000008
						],
						[
							-81.4803149999999,
							28.45696700000008
						],
						[
							-81.48002124999994,
							28.45696700000008
						],
						[
							-81.47947399999993,
							28.45696700000008
						],
						[
							-81.47947342399993,
							28.45719094900005
						],
						[
							-81.47947299999993,
							28.45735600000006
						],
						[
							-81.47947299999993,
							28.457701000000043
						],
						[
							-81.47947199999993,
							28.46068400000007
						],
						[
							-81.48049999999995,
							28.460679000000084
						],
						[
							-81.4813289999999,
							28.460678000000087
						],
						[
							-81.4815549999999,
							28.460678000000087
						],
						[
							-81.4815549999999,
							28.460717713000065
						],
						[
							-81.4815549999999,
							28.460763000000043
						],
						[
							-81.4815549999999,
							28.463176000000093
						],
						[
							-81.47998199999995,
							28.463176000000093
						],
						[
							-81.47944999999993,
							28.463175000000035
						],
						[
							-81.47945099999993,
							28.463099000000057
						],
						[
							-81.47772299999991,
							28.46309400000007
						],
						[
							-81.47772299999991,
							28.462434000000087
						],
						[
							-81.4771859999999,
							28.462435000000085
						],
						[
							-81.47686099999993,
							28.462435000000085
						],
						[
							-81.47672599999993,
							28.462435000000085
						],
						[
							-81.47672399999993,
							28.46214000000009
						],
						[
							-81.47604099999995,
							28.46213300000005
						],
						[
							-81.4759049999999,
							28.462132000000054
						],
						[
							-81.4759049999999,
							28.462436000000082
						],
						[
							-81.4751839999999,
							28.46243700000008
						],
						[
							-81.47518799999995,
							28.462935000000073
						],
						[
							-81.47519599999993,
							28.463047000000074
						],
						[
							-81.47519899999992,
							28.463380000000086
						],
						[
							-81.47600599999993,
							28.463419000000044
						],
						[
							-81.47599699999995,
							28.463872000000038
						],
						[
							-81.47542199999992,
							28.46384400000005
						],
						[
							-81.47520299999991,
							28.463833000000083
						],
						[
							-81.4752039999999,
							28.464000000000055
						],
						[
							-81.47521499999995,
							28.467738000000054
						],
						[
							-81.47526899999991,
							28.46773600000006
						],
						[
							-81.47941099999991,
							28.46773600000006
						],
						[
							-81.47940799999992,
							28.47136800000004
						],
						[
							-81.47940899999992,
							28.471392000000037
						],
						[
							-81.47925499999991,
							28.471392000000037
						],
						[
							-81.47925162199994,
							28.472041421000085
						],
						[
							-81.47925099999992,
							28.472161000000085
						],
						[
							-81.47958599999993,
							28.472205000000088
						],
						[
							-81.4797235659999,
							28.472226995000085
						],
						[
							-81.47992999999991,
							28.472260000000063
						],
						[
							-81.48098699999991,
							28.47224800000004
						],
						[
							-81.48092801799993,
							28.472365144000037
						],
						[
							-81.48069899999992,
							28.47282000000007
						],
						[
							-81.48048899999992,
							28.473139000000064
						],
						[
							-81.48018299999991,
							28.473434000000054
						],
						[
							-81.47986199999991,
							28.47359300000005
						],
						[
							-81.47908699999994,
							28.473805000000084
						],
						[
							-81.47859841299993,
							28.474104998000087
						],
						[
							-81.4783589999999,
							28.474252000000035
						],
						[
							-81.47777799999994,
							28.474616000000083
						],
						[
							-81.47695699999991,
							28.47524100000004
						],
						[
							-81.4767579999999,
							28.47529400000008
						],
						[
							-81.47641099999993,
							28.475290000000086
						],
						[
							-81.47538899999995,
							28.47527800000006
						],
						[
							-81.47523799999993,
							28.47522500000008
						],
						[
							-81.47523799999993,
							28.475318000000076
						],
						[
							-81.47524299999992,
							28.47640000000007
						],
						[
							-81.47520899999995,
							28.478997000000053
						],
						[
							-81.4752269999999,
							28.479066000000046
						],
						[
							-81.47542799999991,
							28.480041000000085
						],
						[
							-81.47568199999996,
							28.48047200000008
						],
						[
							-81.47582099999995,
							28.48070000000007
						],
						[
							-81.47571599999992,
							28.480742000000077
						],
						[
							-81.47557999999992,
							28.480784000000085
						],
						[
							-81.47533399999992,
							28.480686000000052
						],
						[
							-81.47524190699994,
							28.480657619000056
						],
						[
							-81.47517499999992,
							28.480637000000062
						],
						[
							-81.47488099999993,
							28.480676000000074
						],
						[
							-81.4736539999999,
							28.481048000000044
						],
						[
							-81.47337148199995,
							28.481149910000056
						],
						[
							-81.47238300899994,
							28.48150647400007
						],
						[
							-81.46966199999991,
							28.482488000000046
						],
						[
							-81.46945899999992,
							28.48267700000008
						],
						[
							-81.46939299999991,
							28.482758000000047
						],
						[
							-81.4693150889999,
							28.482778349000057
						],
						[
							-81.4688339999999,
							28.482904000000076
						],
						[
							-81.46776299999993,
							28.483084000000076
						],
						[
							-81.46694037299994,
							28.483063222000055
						],
						[
							-81.46693911999995,
							28.48279356100005
						],
						[
							-81.45901710699991,
							28.482793558000083
						],
						[
							-81.45904828099994,
							28.489899724000054
						],
						[
							-81.45890607699994,
							28.489805089000072
						],
						[
							-81.45875685399994,
							28.489705943000047
						],
						[
							-81.4573097089999,
							28.48868843300005
						],
						[
							-81.45638733999994,
							28.487934315000075
						],
						[
							-81.45560017399993,
							28.487191213000074
						],
						[
							-81.45526066999992,
							28.486844699000073
						],
						[
							-81.45443945199992,
							28.485898295000084
						],
						[
							-81.45346400499996,
							28.484609384000066
						],
						[
							-81.45226923299992,
							28.482983974000035
						],
						[
							-81.45222516699994,
							28.48292588700008
						],
						[
							-81.45217909999991,
							28.48286179200005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Florida Center",
				"RegionID": "268987"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.11851631699994,
					26.093804694000085,
					-80.10878988299993,
					26.100980381000056
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.11239529499994,
							26.09383947400005
						],
						[
							-80.11644914099992,
							26.093804694000085
						],
						[
							-80.11660916499994,
							26.093818340000045
						],
						[
							-80.11676058599994,
							26.093858913000076
						],
						[
							-80.11690266099993,
							26.09392516400004
						],
						[
							-80.11703107299991,
							26.094015079000087
						],
						[
							-80.11714191999994,
							26.09412592700005
						],
						[
							-80.11723183499994,
							26.094254339000088
						],
						[
							-80.11729808599995,
							26.094396413000084
						],
						[
							-80.1173400859999,
							26.094556414000067
						],
						[
							-80.11805326099994,
							26.099114413000052
						],
						[
							-80.1183349669999,
							26.10031353700009
						],
						[
							-80.11841445099992,
							26.10037346900009
						],
						[
							-80.11851631699994,
							26.100757440000052
						],
						[
							-80.11752399999995,
							26.100795000000062
						],
						[
							-80.11318329499994,
							26.100959299000067
						],
						[
							-80.11105412799992,
							26.100980381000056
						],
						[
							-80.11047327499995,
							26.10081508500008
						],
						[
							-80.10878988299993,
							26.100605734000055
						],
						[
							-80.10924657999993,
							26.099819654000044
						],
						[
							-80.10933759199992,
							26.099025431000086
						],
						[
							-80.10943682499993,
							26.09767442900005
						],
						[
							-80.1094396119999,
							26.097063390000073
						],
						[
							-80.11105527099994,
							26.097038613000052
						],
						[
							-80.11104298899994,
							26.095621253000047
						],
						[
							-80.1126185949999,
							26.095594461000076
						],
						[
							-80.11250960099994,
							26.094737841000043
						],
						[
							-80.11239529499994,
							26.09383947400005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Harbour Inlet",
				"RegionID": "269001"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.10943682499993,
					26.093890985000087,
					-80.10365645099995,
					26.10149114400008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.1047067319999,
							26.09453850700004
						],
						[
							-80.10473792699992,
							26.094511079000085
						],
						[
							-80.1048663389999,
							26.09442116400004
						],
						[
							-80.10500841299995,
							26.094354914000064
						],
						[
							-80.10515983399995,
							26.09431434100009
						],
						[
							-80.1053159999999,
							26.094300678000085
						],
						[
							-80.10547216499992,
							26.09431434100009
						],
						[
							-80.10562358599992,
							26.094354914000064
						],
						[
							-80.10565556799992,
							26.094367249000072
						],
						[
							-80.10576573399993,
							26.094412171000045
						],
						[
							-80.10629651499994,
							26.09449675500008
						],
						[
							-80.10692533299994,
							26.09452398500008
						],
						[
							-80.1074122469999,
							26.094173140000066
						],
						[
							-80.10746496299993,
							26.094135965000078
						],
						[
							-80.10752469499994,
							26.094095189000086
						],
						[
							-80.1075876619999,
							26.09405961400006
						],
						[
							-80.10765341299992,
							26.09402949400004
						],
						[
							-80.10772147699993,
							26.094005045000074
						],
						[
							-80.1077913659999,
							26.093986443000063
						],
						[
							-80.10786257799992,
							26.093973821000077
						],
						[
							-80.10793460199994,
							26.093967270000064
						],
						[
							-80.10799094399994,
							26.093962789000045
						],
						[
							-80.1091200379999,
							26.093890985000087
						],
						[
							-80.10911352199992,
							26.09479226800005
						],
						[
							-80.1090930819999,
							26.09761946900005
						],
						[
							-80.10943682499993,
							26.09767442900005
						],
						[
							-80.10933759199992,
							26.099025431000086
						],
						[
							-80.10924657999993,
							26.099819654000044
						],
						[
							-80.10878988299993,
							26.100605734000055
						],
						[
							-80.10798642899994,
							26.101205565000043
						],
						[
							-80.10792253499994,
							26.10149114400008
						],
						[
							-80.10455626299996,
							26.101439714000037
						],
						[
							-80.10365645099995,
							26.10142596600008
						],
						[
							-80.10385287699997,
							26.097625580000056
						],
						[
							-80.10387348199994,
							26.097475167000084
						],
						[
							-80.10416807699994,
							26.09616180800009
						],
						[
							-80.10435455499993,
							26.09511262400008
						],
						[
							-80.10437026499994,
							26.095041218000063
						],
						[
							-80.10439172399992,
							26.09497132300004
						],
						[
							-80.10441878899991,
							26.094903403000046
						],
						[
							-80.1044512819999,
							26.094837906000066
						],
						[
							-80.10448898899995,
							26.094775265000067
						],
						[
							-80.10453165899992,
							26.094715894000046
						],
						[
							-80.10457901099994,
							26.094660185000066
						],
						[
							-80.10463073199992,
							26.094608506000043
						],
						[
							-80.1047067319999,
							26.09453850700004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Harbour Isles",
				"RegionID": "269002"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.15763019399992,
					26.129392412000072,
					-80.1536007229999,
					26.136606517000075
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.15383511199991,
							26.136606517000075
						],
						[
							-80.15384328499995,
							26.136260770000035
						],
						[
							-80.15381495299994,
							26.135588889000076
						],
						[
							-80.1537989389999,
							26.13520912900009
						],
						[
							-80.15378656899992,
							26.13491577500008
						],
						[
							-80.15377335099993,
							26.134564973000067
						],
						[
							-80.1537564109999,
							26.13406805900007
						],
						[
							-80.15374136199996,
							26.13362661700006
						],
						[
							-80.15372943799991,
							26.133276850000072
						],
						[
							-80.1537104709999,
							26.132720479000056
						],
						[
							-80.15368851399995,
							26.132076418000054
						],
						[
							-80.1536755599999,
							26.131696425000086
						],
						[
							-80.15366858499993,
							26.131491813000082
						],
						[
							-80.15364809199991,
							26.130934366000076
						],
						[
							-80.15362536799995,
							26.13035110700008
						],
						[
							-80.15360137199991,
							26.129735214000053
						],
						[
							-80.1536007229999,
							26.129472469000063
						],
						[
							-80.15383157899993,
							26.12946757700007
						],
						[
							-80.15454861599994,
							26.12945250200005
						],
						[
							-80.1546858449999,
							26.129448549000074
						],
						[
							-80.1555010539999,
							26.12943553000008
						],
						[
							-80.15605888199991,
							26.129423513000063
						],
						[
							-80.15646949099994,
							26.129405486000053
						],
						[
							-80.15738585299994,
							26.129392412000072
						],
						[
							-80.1575652059999,
							26.13467728800009
						],
						[
							-80.15763019399992,
							26.13660316100004
						],
						[
							-80.15668981699991,
							26.136597151000046
						],
						[
							-80.15612497899991,
							26.136597151000046
						],
						[
							-80.15575342799991,
							26.136601157000086
						],
						[
							-80.15483706999993,
							26.136600156000043
						],
						[
							-80.1546357709999,
							26.136600156000043
						],
						[
							-80.15431028899991,
							26.136600156000043
						],
						[
							-80.15393472099993,
							26.136600069000053
						],
						[
							-80.15383511199991,
							26.136606517000075
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Home Beautiful Park",
				"RegionID": "269017"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.11553987699996,
					26.110710009000044,
					-80.10838726899995,
					26.120180000000133
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.11045800199986,
							26.120052258000044
						],
						[
							-80.11032358399983,
							26.12002987050019
						],
						[
							-80.1094356159999,
							26.11989154800007
						],
						[
							-80.10943734099988,
							26.119871834000037
						],
						[
							-80.10947791399985,
							26.11972041300003
						],
						[
							-80.10954416499973,
							26.119578339
						],
						[
							-80.10963407999981,
							26.119449927000034
						],
						[
							-80.10971107099988,
							26.119372935000058
						],
						[
							-80.10966116499992,
							26.119301661000023
						],
						[
							-80.10960041299995,
							26.119174293000142
						],
						[
							-80.10937969799971,
							26.118599321000175
						],
						[
							-80.10871069899987,
							26.117294244000107
						],
						[
							-80.10875268899989,
							26.116583056000064
						],
						[
							-80.10869646999994,
							26.115767888000118
						],
						[
							-80.10838726899995,
							26.1152900310001
						],
						[
							-80.10864025199993,
							26.11478406500016
						],
						[
							-80.10889323499988,
							26.114306208000144
						],
						[
							-80.10914621799994,
							26.11326616600007
						],
						[
							-80.10948352899987,
							26.11253532600017
						],
						[
							-80.10990516699985,
							26.111973142000195
						],
						[
							-80.11019637299997,
							26.111326595000083
						],
						[
							-80.11075140699988,
							26.110817969000095
						],
						[
							-80.11078092699984,
							26.11079207900009
						],
						[
							-80.11089813499986,
							26.110710009000044
						],
						[
							-80.11131062899987,
							26.1110736460002
						],
						[
							-80.11204146899986,
							26.111186083000177
						],
						[
							-80.11205997499988,
							26.111186504000123
						],
						[
							-80.11205999999989,
							26.11149600000015
						],
						[
							-80.11206044499993,
							26.117099841000098
						],
						[
							-80.11271309799993,
							26.117089643000142
						],
						[
							-80.1127074559999,
							26.11790329300014
						],
						[
							-80.11327548499992,
							26.117907600000052
						],
						[
							-80.1145633099999,
							26.11699500400004
						],
						[
							-80.11553987699996,
							26.116896927000184
						],
						[
							-80.11551675639986,
							26.120121097600197
						],
						[
							-80.11529072199994,
							26.12012128900016
						],
						[
							-80.11485746899989,
							26.120126916000185
						],
						[
							-80.11461999999996,
							26.12013000000008
						],
						[
							-80.11434921499993,
							26.120132912000145
						],
						[
							-80.11399083999987,
							26.120136765000023
						],
						[
							-80.11363258599988,
							26.120141137000203
						],
						[
							-80.11339101799989,
							26.120145920000155
						],
						[
							-80.11318260499986,
							26.120150047000052
						],
						[
							-80.11301567599992,
							26.12015335300015
						],
						[
							-80.11283258299996,
							26.120156979000093
						],
						[
							-80.11267999999986,
							26.120160000000077
						],
						[
							-80.11243241399988,
							26.120165268000157
						],
						[
							-80.11210721199988,
							26.120172187000108
						],
						[
							-80.11184102499989,
							26.120177851000044
						],
						[
							-80.11164922699992,
							26.120180000000133
						],
						[
							-80.11155756199979,
							26.120180000000133
						],
						[
							-80.11149999999992,
							26.120180000000133
						],
						[
							-80.11134898499995,
							26.12016584200003
						],
						[
							-80.11114931899995,
							26.120145909000065
						],
						[
							-80.11098938699986,
							26.120124585000077
						],
						[
							-80.11082343999989,
							26.12010321300009
						],
						[
							-80.11064895499993,
							26.120082275000133
						],
						[
							-80.11045800199986,
							26.120052258000044
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Idlewyld",
				"RegionID": "269018"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.65073290899996,
					30.39342167800004,
					-81.60122467799994,
					30.438110448000085
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.6161629959999,
							30.432700810000085
						],
						[
							-81.61551599599994,
							30.43187781000006
						],
						[
							-81.61547186899992,
							30.431816553000093
						],
						[
							-81.6154330359999,
							30.43175181000004
						],
						[
							-81.6153997699999,
							30.431684039000057
						],
						[
							-81.61537230499994,
							30.431613716000072
						],
						[
							-81.61535083599995,
							30.431541337000056
						],
						[
							-81.61533551199994,
							30.431467413000064
						],
						[
							-81.6153264429999,
							30.43139246400006
						],
						[
							-81.6152199149999,
							30.43003705200005
						],
						[
							-81.61435508999995,
							30.428586831000075
						],
						[
							-81.61357703499993,
							30.428200486000037
						],
						[
							-81.61352733899992,
							30.428173836000045
						],
						[
							-81.61339892699993,
							30.42808392100005
						],
						[
							-81.6132880799999,
							30.42797307300009
						],
						[
							-81.61319816399993,
							30.42784466100005
						],
						[
							-81.61315928099992,
							30.427769322000074
						],
						[
							-81.61275828099991,
							30.426893321000076
						],
						[
							-81.61273091299995,
							30.42682658600006
						],
						[
							-81.61269033999992,
							30.426675165000063
						],
						[
							-81.6126766779999,
							30.42651900000004
						],
						[
							-81.61269033999992,
							30.426362834000088
						],
						[
							-81.61273091299995,
							30.42621141300009
						],
						[
							-81.61279716399991,
							30.426069339000037
						],
						[
							-81.6128870789999,
							30.42594092700006
						],
						[
							-81.61293421999994,
							30.425889001000087
						],
						[
							-81.61378560499992,
							30.42502169400007
						],
						[
							-81.61389313599994,
							30.424625423000066
						],
						[
							-81.61375321999992,
							30.423547916000075
						],
						[
							-81.6136408509999,
							30.423402298000042
						],
						[
							-81.6128219329999,
							30.422595729000083
						],
						[
							-81.61276407999992,
							30.422533073000064
						],
						[
							-81.61267416499993,
							30.422404661000087
						],
						[
							-81.61260791399991,
							30.42226258600005
						],
						[
							-81.61256734099993,
							30.422111165000043
						],
						[
							-81.61255367799993,
							30.421955000000082
						],
						[
							-81.61255567899991,
							30.421895049000053
						],
						[
							-81.61259437599995,
							30.42131583700007
						],
						[
							-81.61219674699993,
							30.420818802000042
						],
						[
							-81.61212016399992,
							30.42070666100005
						],
						[
							-81.61205391399994,
							30.42056458600007
						],
						[
							-81.61201334099991,
							30.420413165000074
						],
						[
							-81.6119996779999,
							30.420257000000053
						],
						[
							-81.61200004299991,
							30.42023138600007
						],
						[
							-81.61202313699994,
							30.419420853000076
						],
						[
							-81.61116149599991,
							30.418487209000038
						],
						[
							-81.61071488999994,
							30.418688733000067
						],
						[
							-81.6106525859999,
							30.418714086000083
						],
						[
							-81.61054910699994,
							30.418744854000067
						],
						[
							-81.61021010699994,
							30.41882385400004
						],
						[
							-81.61013937199995,
							30.41883737700004
						],
						[
							-81.61006778199993,
							30.418845198000042
						],
						[
							-81.60999579599991,
							30.418847264000078
						],
						[
							-81.60992387499994,
							30.418843565000092
						],
						[
							-81.60985247999992,
							30.418834122000078
						],
						[
							-81.60978206999994,
							30.418818997000074
						],
						[
							-81.60971309699994,
							30.41879828700007
						],
						[
							-81.60862875599992,
							30.418424687000083
						],
						[
							-81.6085604029999,
							30.418397291000073
						],
						[
							-81.6084945209999,
							30.41836439200006
						],
						[
							-81.60843155399994,
							30.41832621100008
						],
						[
							-81.60837192299994,
							30.41828300500004
						],
						[
							-81.60831602799993,
							30.418235063000054
						],
						[
							-81.60826424499993,
							30.418182707000085
						],
						[
							-81.60758724399994,
							30.417439707000085
						],
						[
							-81.6075380819999,
							30.417380902000048
						],
						[
							-81.60749410599993,
							30.417318125000065
						],
						[
							-81.60745563499995,
							30.417251831000048
						],
						[
							-81.60742294799991,
							30.41718250200006
						],
						[
							-81.60739628399995,
							30.417110642000072
						],
						[
							-81.6073758359999,
							30.417036772000074
						],
						[
							-81.60726582399991,
							30.416561419000065
						],
						[
							-81.60719031499991,
							30.416530570000077
						],
						[
							-81.60687300299993,
							30.416466258000067
						],
						[
							-81.60676303299994,
							30.41647469200007
						],
						[
							-81.6065469859999,
							30.41654343400006
						],
						[
							-81.60556256299994,
							30.417285976000073
						],
						[
							-81.60547066099991,
							30.417346835000046
						],
						[
							-81.60532858599994,
							30.41741308600007
						],
						[
							-81.60517716599992,
							30.41745365900005
						],
						[
							-81.60502099999991,
							30.41746732200005
						],
						[
							-81.6048648339999,
							30.41745365900005
						],
						[
							-81.60471341399995,
							30.41741308600007
						],
						[
							-81.6045713389999,
							30.417346835000046
						],
						[
							-81.60444292699992,
							30.41725692000006
						],
						[
							-81.6043320789999,
							30.417146073000083
						],
						[
							-81.60429052399991,
							30.417092580000087
						],
						[
							-81.60408170699992,
							30.416801803000055
						],
						[
							-81.6039854409999,
							30.416777322000087
						],
						[
							-81.60355778799993,
							30.416777322000087
						],
						[
							-81.60292135499992,
							30.416840872000076
						],
						[
							-81.60283199999992,
							30.416845322000082
						],
						[
							-81.60267583399991,
							30.41683165900008
						],
						[
							-81.6025244139999,
							30.416791086000046
						],
						[
							-81.60238233899992,
							30.416724835000082
						],
						[
							-81.60225496699991,
							30.416634192000064
						],
						[
							-81.60217384899994,
							30.416557278000088
						],
						[
							-81.60210551199992,
							30.416469314000043
						],
						[
							-81.60206200399995,
							30.416406176000066
						],
						[
							-81.6020243939999,
							30.416339358000073
						],
						[
							-81.60199298899994,
							30.416269408000062
						],
						[
							-81.60196804799995,
							30.416196901000035
						],
						[
							-81.6019497769999,
							30.416122434000044
						],
						[
							-81.60193832399995,
							30.416046618000056
						],
						[
							-81.60170568799992,
							30.413980373000076
						],
						[
							-81.60124238899994,
							30.411680604000082
						],
						[
							-81.60123833999995,
							30.41165916600005
						],
						[
							-81.60122467799994,
							30.41150300000004
						],
						[
							-81.60123833999995,
							30.41134683400008
						],
						[
							-81.60127891299993,
							30.411195414000076
						],
						[
							-81.60134516399995,
							30.411053339000034
						],
						[
							-81.60143430499994,
							30.41092585000007
						],
						[
							-81.60223469199991,
							30.409969388000036
						],
						[
							-81.60234592699993,
							30.409858079000056
						],
						[
							-81.60247433899991,
							30.40976816400007
						],
						[
							-81.60261641299991,
							30.40970191400004
						],
						[
							-81.6027678339999,
							30.40966134100006
						],
						[
							-81.60281016199991,
							30.409654912000065
						],
						[
							-81.60521795799991,
							30.40934765700007
						],
						[
							-81.60622499899995,
							30.40901935100004
						],
						[
							-81.60697975399995,
							30.40867086800006
						],
						[
							-81.60855506799993,
							30.407644497000035
						],
						[
							-81.60859799399992,
							30.40761821100006
						],
						[
							-81.61053699299993,
							30.40650421100008
						],
						[
							-81.61067741399995,
							30.406438913000045
						],
						[
							-81.61072756999994,
							30.40642230900005
						],
						[
							-81.61223142499995,
							30.405973033000066
						],
						[
							-81.61317223799995,
							30.405443634000054
						],
						[
							-81.6136256179999,
							30.404719168000042
						],
						[
							-81.6136236779999,
							30.404697000000052
						],
						[
							-81.6136373409999,
							30.40454083400005
						],
						[
							-81.61367791399994,
							30.404389414000036
						],
						[
							-81.61374416399991,
							30.404247339000054
						],
						[
							-81.6138340789999,
							30.40411892700007
						],
						[
							-81.61394492699992,
							30.40400807900005
						],
						[
							-81.6140081929999,
							30.40395960400008
						],
						[
							-81.61465419299992,
							30.403508604000084
						],
						[
							-81.6147167119999,
							30.403468687000043
						],
						[
							-81.61478230699993,
							30.403434059000062
						],
						[
							-81.61485053399991,
							30.40340495300006
						],
						[
							-81.61492092599991,
							30.403381570000082
						],
						[
							-81.6149930069999,
							30.403364067000044
						],
						[
							-81.61506628399991,
							30.403352563000055
						],
						[
							-81.61552728399994,
							30.403299563000076
						],
						[
							-81.6156299999999,
							30.403293678000068
						],
						[
							-81.61568416999995,
							30.403295311000083
						],
						[
							-81.61632595299994,
							30.40333403900007
						],
						[
							-81.61724961099992,
							30.403033562000076
						],
						[
							-81.61779351199995,
							30.402804198000066
						],
						[
							-81.61850570999991,
							30.402134045000086
						],
						[
							-81.61855917899993,
							30.40208756400006
						],
						[
							-81.6186161409999,
							30.402045437000083
						],
						[
							-81.61867624199994,
							30.402007924000092
						],
						[
							-81.61873910899993,
							30.40197525900004
						],
						[
							-81.61975710999991,
							30.401496258000066
						],
						[
							-81.6197887479999,
							30.401482110000074
						],
						[
							-81.62063250699993,
							30.401124125000084
						],
						[
							-81.62099424599995,
							30.400825741000062
						],
						[
							-81.62105957799992,
							30.400745649000044
						],
						[
							-81.62108722599993,
							30.400587487000056
						],
						[
							-81.62112791399994,
							30.400435414000075
						],
						[
							-81.62119416399992,
							30.400293339000086
						],
						[
							-81.6212840789999,
							30.400164927000052
						],
						[
							-81.62139492699993,
							30.400054080000075
						],
						[
							-81.6215233389999,
							30.399964165000085
						],
						[
							-81.62166541399995,
							30.39989791400006
						],
						[
							-81.6217537249999,
							30.399870820000046
						],
						[
							-81.62300007699993,
							30.39955750900009
						],
						[
							-81.62372323299991,
							30.399385060000043
						],
						[
							-81.62482172999995,
							30.399079768000036
						],
						[
							-81.6256800299999,
							30.398668224000065
						],
						[
							-81.62615224199993,
							30.397894340000054
						],
						[
							-81.62684604399993,
							30.39595382300007
						],
						[
							-81.62687331799992,
							30.39588679700006
						],
						[
							-81.62690589199993,
							30.395822180000035
						],
						[
							-81.6269435559999,
							30.395760391000067
						],
						[
							-81.62698606599992,
							30.39570183100005
						],
						[
							-81.6270331469999,
							30.395646878000036
						],
						[
							-81.62708449399992,
							30.395595888000056
						],
						[
							-81.62788349399995,
							30.39486388900008
						],
						[
							-81.6279308309999,
							30.394823444000057
						],
						[
							-81.62798085299994,
							30.394786372000052
						],
						[
							-81.62803331999993,
							30.39475285000009
						],
						[
							-81.62808797999992,
							30.39472303800005
						],
						[
							-81.6288619799999,
							30.39433503800007
						],
						[
							-81.62892799999992,
							30.39430520700006
						],
						[
							-81.62899620699994,
							30.39428078600008
						],
						[
							-81.62906615899993,
							30.394261936000078
						],
						[
							-81.62913739999993,
							30.39424877600004
						],
						[
							-81.62973739999991,
							30.39416277600009
						],
						[
							-81.62986499999994,
							30.394153678000066
						],
						[
							-81.6306889999999,
							30.394153678000066
						],
						[
							-81.63081034299995,
							30.394161902000068
						],
						[
							-81.63287857499995,
							30.394443537000086
						],
						[
							-81.63298679099995,
							30.394381328000065
						],
						[
							-81.63304948799993,
							30.39434849800006
						],
						[
							-81.6340484879999,
							30.39387449700007
						],
						[
							-81.63410860099992,
							30.393848611000067
						],
						[
							-81.6341704379999,
							30.39382716500006
						],
						[
							-81.63423367099995,
							30.393810274000092
						],
						[
							-81.63429796499992,
							30.39379802600007
						],
						[
							-81.63542474399992,
							30.393625610000072
						],
						[
							-81.63675052199994,
							30.393431194000073
						],
						[
							-81.6368809999999,
							30.39342167800004
						],
						[
							-81.63703716599991,
							30.39343534100004
						],
						[
							-81.63718858599992,
							30.393475914000074
						],
						[
							-81.63733066099991,
							30.393542164000053
						],
						[
							-81.63745907299996,
							30.39363208000009
						],
						[
							-81.63756992099991,
							30.393742927000066
						],
						[
							-81.6376598359999,
							30.393871339000043
						],
						[
							-81.63772608599993,
							30.39401341400008
						],
						[
							-81.63775159199992,
							30.394095502000084
						],
						[
							-81.63784261299992,
							30.394446911000045
						],
						[
							-81.63905732899991,
							30.395555812000055
						],
						[
							-81.63913991999993,
							30.395641927000042
						],
						[
							-81.63922983499992,
							30.39577033900008
						],
						[
							-81.63929608599994,
							30.395912413000072
						],
						[
							-81.63933665899992,
							30.396063834000078
						],
						[
							-81.63934714399994,
							30.39614446300004
						],
						[
							-81.63943785799995,
							30.397220665000077
						],
						[
							-81.64052343899994,
							30.397320772000057
						],
						[
							-81.64087919299993,
							30.397078082000064
						],
						[
							-81.64093097999995,
							30.397045283000068
						],
						[
							-81.6409848799999,
							30.397016088000044
						],
						[
							-81.64104064399993,
							30.396990633000087
						],
						[
							-81.64109801299992,
							30.396969035000044
						],
						[
							-81.64187901299994,
							30.39670503600007
						],
						[
							-81.64195116099995,
							30.396683963000044
						],
						[
							-81.64202481699994,
							30.39666898900009
						],
						[
							-81.64209946599993,
							30.39666021700009
						],
						[
							-81.64217458699994,
							30.396657710000053
						],
						[
							-81.64224965499994,
							30.396661484000052
						],
						[
							-81.64232414599991,
							30.39667151400005
						],
						[
							-81.64239753899994,
							30.396687729000064
						],
						[
							-81.6424693219999,
							30.396710016000046
						],
						[
							-81.64282495399993,
							30.396836964000045
						],
						[
							-81.64296966099994,
							30.396904164000038
						],
						[
							-81.64299942299995,
							30.39692212300008
						],
						[
							-81.6447688149999,
							30.39803700400006
						],
						[
							-81.6453606579999,
							30.39826968400007
						],
						[
							-81.64733306999995,
							30.397530224000036
						],
						[
							-81.6473433409999,
							30.397412834000082
						],
						[
							-81.6473544509999,
							30.397359369000075
						],
						[
							-81.6474320929999,
							30.39703546100009
						],
						[
							-81.64717666099995,
							30.39597450200006
						],
						[
							-81.6471653399999,
							30.395920166000053
						],
						[
							-81.64715167799994,
							30.395764000000042
						],
						[
							-81.6471653399999,
							30.395607835000078
						],
						[
							-81.64720591299994,
							30.395456414000083
						],
						[
							-81.6472721639999,
							30.395314339000038
						],
						[
							-81.64736207899995,
							30.395185927000057
						],
						[
							-81.64747292699991,
							30.395075079000037
						],
						[
							-81.64755705199991,
							30.395012471000086
						],
						[
							-81.64780505199991,
							30.39484947100004
						],
						[
							-81.64784933899995,
							30.39482216400006
						],
						[
							-81.64799141399993,
							30.394755914000086
						],
						[
							-81.6480396469999,
							30.394742990000058
						],
						[
							-81.64829899999995,
							30.39560100000006
						],
						[
							-81.64857890899994,
							30.396527012000035
						],
						[
							-81.6487429089999,
							30.39752101300007
						],
						[
							-81.64892890999994,
							30.39880701400006
						],
						[
							-81.6489449099999,
							30.398984013000074
						],
						[
							-81.64918290999992,
							30.40082401200004
						],
						[
							-81.64931690999992,
							30.401870013000067
						],
						[
							-81.64945890999991,
							30.402880013000072
						],
						[
							-81.64964483699993,
							30.404209046000062
						],
						[
							-81.64978198299991,
							30.40436697800004
						],
						[
							-81.64986490899992,
							30.404902012000033
						],
						[
							-81.65012890999992,
							30.406835012000045
						],
						[
							-81.65019690999992,
							30.407351013000042
						],
						[
							-81.65024390899993,
							30.407715012000036
						],
						[
							-81.65025390999995,
							30.40778301200004
						],
						[
							-81.65032390899995,
							30.40836701300009
						],
						[
							-81.65035490999992,
							30.408673012000065
						],
						[
							-81.65035990899993,
							30.408720013000053
						],
						[
							-81.65043890899994,
							30.409252012000085
						],
						[
							-81.65048190899995,
							30.409644012000058
						],
						[
							-81.65058090999992,
							30.410374012000094
						],
						[
							-81.65070590999994,
							30.411345012000083
						],
						[
							-81.65071890999991,
							30.41149201300004
						],
						[
							-81.65073290899996,
							30.411704013000076
						],
						[
							-81.65073290899996,
							30.411932012000076
						],
						[
							-81.6507239099999,
							30.41223401300005
						],
						[
							-81.65071490899993,
							30.41238401300006
						],
						[
							-81.6507059089999,
							30.41250801300004
						],
						[
							-81.65068190999995,
							30.412714013000084
						],
						[
							-81.6506559099999,
							30.412909013000046
						],
						[
							-81.6506109099999,
							30.41316301300009
						],
						[
							-81.65054499799993,
							30.413479035000076
						],
						[
							-81.65052090899991,
							30.413557013000055
						],
						[
							-81.65046790999992,
							30.41373901300005
						],
						[
							-81.65042590999991,
							30.41388601300008
						],
						[
							-81.65037790899993,
							30.41400301300007
						],
						[
							-81.65035590899994,
							30.414074012000075
						],
						[
							-81.65019890999992,
							30.41442001200005
						],
						[
							-81.64981290899993,
							30.415065012000074
						],
						[
							-81.6495499099999,
							30.41552601300009
						],
						[
							-81.64944190999995,
							30.41573201200003
						],
						[
							-81.64934090899993,
							30.415962012000076
						],
						[
							-81.64922690999992,
							30.41628901300004
						],
						[
							-81.64914190999991,
							30.416588011000048
						],
						[
							-81.64907290999992,
							30.416908013000068
						],
						[
							-81.64899490999994,
							30.417586012000076
						],
						[
							-81.64891790999991,
							30.418338013000035
						],
						[
							-81.64889090899993,
							30.418511012000067
						],
						[
							-81.6488569089999,
							30.418651013000048
						],
						[
							-81.6487869099999,
							30.418884013000085
						],
						[
							-81.64857790999991,
							30.41952001200008
						],
						[
							-81.64843690999993,
							30.41996901200008
						],
						[
							-81.64839890999991,
							30.420077013000082
						],
						[
							-81.64810490999992,
							30.42100101200009
						],
						[
							-81.64783690999991,
							30.421799012000065
						],
						[
							-81.64761190899992,
							30.42246601200009
						],
						[
							-81.6473659099999,
							30.42318901200008
						],
						[
							-81.64712790999994,
							30.423883012000086
						],
						[
							-81.64699390999994,
							30.42427401200007
						],
						[
							-81.64689190899993,
							30.42457701400008
						],
						[
							-81.64659690899992,
							30.425307012000076
						],
						[
							-81.6461999089999,
							30.426316013000076
						],
						[
							-81.64613390999995,
							30.426502012000075
						],
						[
							-81.64590090999991,
							30.427163012000047
						],
						[
							-81.64567390999991,
							30.427841012000044
						],
						[
							-81.64553690899993,
							30.42822201200005
						],
						[
							-81.64507490999995,
							30.429660012000056
						],
						[
							-81.6449419089999,
							30.430045013000043
						],
						[
							-81.64489083099994,
							30.430194965000055
						],
						[
							-81.64432101999995,
							30.43195616700007
						],
						[
							-81.64418279599994,
							30.431955852000044
						],
						[
							-81.64354390799991,
							30.433815010000043
						],
						[
							-81.64334690699991,
							30.434421010000047
						],
						[
							-81.64324590799993,
							30.43477001000008
						],
						[
							-81.64315390699994,
							30.435127010000087
						],
						[
							-81.6430529079999,
							30.435499011000047
						],
						[
							-81.64296290699991,
							30.435796010000047
						],
						[
							-81.64294290699992,
							30.43586401000005
						],
						[
							-81.6428509079999,
							30.43619701000006
						],
						[
							-81.6426239079999,
							30.436881011000086
						],
						[
							-81.64252099999993,
							30.43719400000009
						],
						[
							-81.64145807999996,
							30.43732121200009
						],
						[
							-81.64077313399991,
							30.437879642000045
						],
						[
							-81.63986940599995,
							30.438110448000085
						],
						[
							-81.63768079199991,
							30.437827921000068
						],
						[
							-81.63278612699992,
							30.437158958000055
						],
						[
							-81.63217155199993,
							30.43637797000008
						],
						[
							-81.63180660899991,
							30.436144984000066
						],
						[
							-81.63049110899993,
							30.436123199000065
						],
						[
							-81.63040057599994,
							30.436117121000052
						],
						[
							-81.62860457599993,
							30.435905121000076
						],
						[
							-81.62855383499993,
							30.43589765900009
						],
						[
							-81.62840208699993,
							30.435856967000067
						],
						[
							-81.6277454019999,
							30.435617378000074
						],
						[
							-81.62099333799995,
							30.43475711100007
						],
						[
							-81.62091686799994,
							30.43474399400009
						],
						[
							-81.62084181299991,
							30.434724335000055
						],
						[
							-81.62076873199993,
							30.434698280000077
						],
						[
							-81.61653173199994,
							30.432978280000047
						],
						[
							-81.61646101699995,
							30.432945945000085
						],
						[
							-81.61639335899991,
							30.43290762200007
						],
						[
							-81.61632926399994,
							30.432863599000086
						],
						[
							-81.6162692119999,
							30.432814203000078
						],
						[
							-81.6162136499999,
							30.432759805000046
						],
						[
							-81.6161629959999,
							30.432700810000085
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Imeson Park",
				"RegionID": "269019"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.39736686454566,
					28.549287306863597,
					-81.38250668856668,
					28.55306791098465
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.38250668856668,
							28.553067862421273
						],
						[
							-81.38251678705379,
							28.55302384780257
						],
						[
							-81.38259991048957,
							28.552665315089094
						],
						[
							-81.38264898199607,
							28.552421953152006
						],
						[
							-81.38267301727669,
							28.552270730354167
						],
						[
							-81.38275013234204,
							28.551620766041836
						],
						[
							-81.38275013234204,
							28.551255223113206
						],
						[
							-81.38265790686793,
							28.54940348847797
						],
						[
							-81.38464594634719,
							28.549287306863597
						],
						[
							-81.3851277041651,
							28.54934827010534
						],
						[
							-81.38554928295005,
							28.549588750614625
						],
						[
							-81.38609208674734,
							28.549769017017496
						],
						[
							-81.38663392737065,
							28.549830281532117
						],
						[
							-81.38717667990653,
							28.5495286138499
						],
						[
							-81.38801994989176,
							28.549348396909778
						],
						[
							-81.39736686454566,
							28.54933537652545
						],
						[
							-81.39736180226191,
							28.54954668932338
						],
						[
							-81.39733782004134,
							28.549868175365077
						],
						[
							-81.39727467324573,
							28.55008048101449
						],
						[
							-81.39705835212347,
							28.550544168754875
						],
						[
							-81.39694017761151,
							28.550742462967037
						],
						[
							-81.39691814422174,
							28.550779516833323
						],
						[
							-81.39673186854917,
							28.55099183327455
						],
						[
							-81.39631625226929,
							28.55139042358988
						],
						[
							-81.39616602951753,
							28.55154565736398
						],
						[
							-81.39610493857208,
							28.551652813382443
						],
						[
							-81.3960638782262,
							28.551705891368535
						],
						[
							-81.39587760165425,
							28.552024364681504
						],
						[
							-81.39580849954818,
							28.55216857906283
						],
						[
							-81.39571226939303,
							28.552468999385315
						],
						[
							-81.39564926289168,
							28.552760455265897
						],
						[
							-81.39562322482097,
							28.552924700246805
						],
						[
							-81.39561921294542,
							28.552961752314356
						],
						[
							-81.39555612460572,
							28.552961754113
						],
						[
							-81.39545897984006,
							28.552962755058378
						],
						[
							-81.39536884618903,
							28.552962755058378
						],
						[
							-81.39505337930966,
							28.552967763382796
						],
						[
							-81.39467381684987,
							28.552969766172993
						],
						[
							-81.39328075083871,
							28.552980781968472
						],
						[
							-81.39152314374356,
							28.552989795873202
						],
						[
							-81.39101238638759,
							28.5529938023528
						],
						[
							-81.38988972132961,
							28.55300181351342
						],
						[
							-81.38917766602573,
							28.55300581909382
						],
						[
							-81.38910155280512,
							28.553003816303622
						],
						[
							-81.38903445258988,
							28.553003816303622
						],
						[
							-81.38881713052224,
							28.553002815358163
						],
						[
							-81.38842554952288,
							28.552996806088366
						],
						[
							-81.38765040048345,
							28.55298178381321
						],
						[
							-81.38713363385759,
							28.55297577544279
						],
						[
							-81.38610010060589,
							28.552972769908564
						],
						[
							-81.38467598819967,
							28.55300181351342
						],
						[
							-81.3841712401134,
							28.553010827418156
						],
						[
							-81.38381571203487,
							28.55301583484321
						],
						[
							-81.38349223399487,
							28.553037867333614
						],
						[
							-81.38311166879109,
							28.553061903513512
						],
						[
							-81.38301652771491,
							28.5530609007694
						],
						[
							-81.38255083718441,
							28.55306791098465
						],
						[
							-81.38250668856668,
							28.553067862421273
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Lake Dot",
				"RegionID": "269035"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.37686353726158,
					28.54570298876874,
					-81.36434784165246,
					28.55319510030062
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.36651004743318,
							28.553188090085364
						],
						[
							-81.36548853272116,
							28.553165054850936
						],
						[
							-81.36443798879331,
							28.55315403995474
						],
						[
							-81.36444398367391,
							28.553103964804755
						],
						[
							-81.36444398367391,
							28.55226171644943
						],
						[
							-81.36441394002296,
							28.55129928809402
						],
						[
							-81.36440091963854,
							28.550438011883138
						],
						[
							-81.36439390942338,
							28.549494612282565
						],
						[
							-81.36436887229813,
							28.548590271137037
						],
						[
							-81.36434784165246,
							28.547644869645545
						],
						[
							-81.36434984354328,
							28.546746536870536
						],
						[
							-81.36435084538802,
							28.54614163938377
						],
						[
							-81.3643608611374,
							28.545969384141607
						],
						[
							-81.36439288779357,
							28.545793068460537
						],
						[
							-81.36487261943883,
							28.545787114049347
						],
						[
							-81.36618556664907,
							28.5457760973545
						],
						[
							-81.36643293416647,
							28.545773093618926
						],
						[
							-81.36849498964742,
							28.54574710860816
						],
						[
							-81.37591304830542,
							28.54570298876874
						],
						[
							-81.37593301954982,
							28.54630988994499
						],
						[
							-81.37590598233228,
							28.54643507557138
						],
						[
							-81.37587693962662,
							28.546642383688365
						],
						[
							-81.37589283244559,
							28.547572893306345
						],
						[
							-81.37672332396399,
							28.54757763723
						],
						[
							-81.3767382158375,
							28.548097539791712
						],
						[
							-81.37677627334718,
							28.549413492536267
						],
						[
							-81.37680731884286,
							28.550954778509073
						],
						[
							-81.37683736339326,
							28.552239683959023
						],
						[
							-81.37686239961926,
							28.553084937848567
						],
						[
							-81.37686353726158,
							28.553127132239574
						],
						[
							-81.37514785745891,
							28.55314001952432
						],
						[
							-81.37372675058683,
							28.553135959085317
						],
						[
							-81.37275330643585,
							28.553147028840115
						],
						[
							-81.3713191800788,
							28.553186087295252
						],
						[
							-81.37106380140078,
							28.55318107897083
						],
						[
							-81.37058709417535,
							28.553191093821027
						],
						[
							-81.36860515479741,
							28.55319510030062
						],
						[
							-81.3678540401392,
							28.553194099355245
						],
						[
							-81.36651004743318,
							28.553188090085364
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Lake Eola Heights",
				"RegionID": "269036"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.1104032739999,
					26.19683053500006,
					-80.10570707399995,
					26.203310246000058
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.11025194799993,
							26.19683548800009
						],
						[
							-80.1104032739999,
							26.19683053500006
						],
						[
							-80.10833821099993,
							26.201324309000086
						],
						[
							-80.10782972099992,
							26.201336724000043
						],
						[
							-80.10782999999992,
							26.201350000000048
						],
						[
							-80.10783339199992,
							26.201539967000087
						],
						[
							-80.10784440399993,
							26.201998081000056
						],
						[
							-80.10785323699992,
							26.202174739000043
						],
						[
							-80.1078599999999,
							26.202388538000037
						],
						[
							-80.1078599999999,
							26.202668946000074
						],
						[
							-80.10786169699992,
							26.202861087000088
						],
						[
							-80.1078645639999,
							26.202964315000088
						],
						[
							-80.10786845599995,
							26.203104411000083
						],
						[
							-80.10786475899994,
							26.20317572400006
						],
						[
							-80.10783131499994,
							26.20321868500008
						],
						[
							-80.10779468499994,
							26.203237658000035
						],
						[
							-80.10776396099993,
							26.203245786000082
						],
						[
							-80.10770067399994,
							26.20325985000005
						],
						[
							-80.1075841199999,
							26.203260000000057
						],
						[
							-80.10745120299993,
							26.20326355700007
						],
						[
							-80.10712681199993,
							26.20327326900008
						],
						[
							-80.10690497399993,
							26.203279911000042
						],
						[
							-80.10663218999991,
							26.20328807800007
						],
						[
							-80.10632254399991,
							26.20329734900008
						],
						[
							-80.10610829899991,
							26.203303764000054
						],
						[
							-80.10598252499994,
							26.203307529000085
						],
						[
							-80.1057899999999,
							26.203310000000045
						],
						[
							-80.10578781899994,
							26.203310246000058
						],
						[
							-80.1058134779999,
							26.201962092000088
						],
						[
							-80.10580134799994,
							26.201386247000073
						],
						[
							-80.10570707399995,
							26.196961547000058
						],
						[
							-80.11025194799993,
							26.19683548800009
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Lake Estates",
				"RegionID": "269037"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.4157251339999,
					28.579831091000074,
					-81.40603271299995,
					28.595578000000046
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.40704151999996,
							28.589820472000042
						],
						[
							-81.40701766699993,
							28.58978718600008
						],
						[
							-81.40694603499992,
							28.589885963000086
						],
						[
							-81.40693147999991,
							28.589905473000044
						],
						[
							-81.4068941459999,
							28.58995096400008
						],
						[
							-81.40685391699992,
							28.589993917000072
						],
						[
							-81.40681096399993,
							28.59003414600005
						],
						[
							-81.40676547299995,
							28.590071480000063
						],
						[
							-81.40671763699993,
							28.59010575900004
						],
						[
							-81.40668908499993,
							28.59012406700009
						],
						[
							-81.40651508499991,
							28.590231067000047
						],
						[
							-81.40651436299993,
							28.59023151100007
						],
						[
							-81.40647036199995,
							28.59025851100006
						],
						[
							-81.4064496609999,
							28.59027083600006
						],
						[
							-81.40640218499993,
							28.590296212000055
						],
						[
							-81.40639899999991,
							28.589376000000073
						],
						[
							-81.40701299999996,
							28.589376000000073
						],
						[
							-81.40701299999996,
							28.587570000000085
						],
						[
							-81.40681899999993,
							28.587566000000038
						],
						[
							-81.4068116659999,
							28.58716183900009
						],
						[
							-81.40730860199994,
							28.58796816000006
						],
						[
							-81.40732183499995,
							28.587990339000044
						],
						[
							-81.40734957699993,
							28.58804224000005
						],
						[
							-81.4073738649999,
							28.588095844000065
						],
						[
							-81.40739459499991,
							28.588150922000068
						],
						[
							-81.4074101779999,
							28.58820229300005
						],
						[
							-81.4076771259999,
							28.588015349000045
						],
						[
							-81.4076933639999,
							28.58800424100008
						],
						[
							-81.40773631399992,
							28.587977263000084
						],
						[
							-81.40802131299995,
							28.587809263000054
						],
						[
							-81.40802833899994,
							28.587805165000077
						],
						[
							-81.40808023999995,
							28.58777742300009
						],
						[
							-81.4081338439999,
							28.587753135000074
						],
						[
							-81.40818892199991,
							28.587732405000054
						],
						[
							-81.40824523799995,
							28.587715322000065
						],
						[
							-81.4083025509999,
							28.58770195900007
						],
						[
							-81.40836061499994,
							28.58769237200005
						],
						[
							-81.40836863899995,
							28.587691582000048
						],
						[
							-81.40835914699994,
							28.587684661000083
						],
						[
							-81.40834152699995,
							28.58767148000004
						],
						[
							-81.40829603599991,
							28.587634146000084
						],
						[
							-81.4082558909999,
							28.58759671200005
						],
						[
							-81.40818557199992,
							28.587527010000088
						],
						[
							-81.40806173999994,
							28.587433957000087
						],
						[
							-81.40805452799992,
							28.58742848000009
						],
						[
							-81.40803860799991,
							28.58741597700004
						],
						[
							-81.40785051299991,
							28.587364944000058
						],
						[
							-81.40783715899994,
							28.58736121000004
						],
						[
							-81.40759288699991,
							28.587290874000075
						],
						[
							-81.40739373899993,
							28.58723983200008
						],
						[
							-81.40717211099991,
							28.587196937000044
						],
						[
							-81.40716755099993,
							28.587196042000073
						],
						[
							-81.40711023799992,
							28.58718267800009
						],
						[
							-81.40710717099995,
							28.587181851000082
						],
						[
							-81.40683117099992,
							28.587106851000044
						],
						[
							-81.40681055399995,
							28.587100557000042
						],
						[
							-81.40679199999994,
							28.586078000000043
						],
						[
							-81.40679199999994,
							28.58550500000007
						],
						[
							-81.40679199999994,
							28.58547800000008
						],
						[
							-81.4071006179999,
							28.585477437000065
						],
						[
							-81.40717199999995,
							28.58546300000006
						],
						[
							-81.40735099999995,
							28.585346000000072
						],
						[
							-81.40758899999992,
							28.58518500000008
						],
						[
							-81.40771299999996,
							28.58513700000009
						],
						[
							-81.40790599999991,
							28.584993000000054
						],
						[
							-81.4079999999999,
							28.584906000000046
						],
						[
							-81.40807399999994,
							28.584928000000048
						],
						[
							-81.40821099999994,
							28.58477400000004
						],
						[
							-81.40828999999991,
							28.584643000000085
						],
						[
							-81.40835499999991,
							28.58446900000007
						],
						[
							-81.40838699999995,
							28.584232000000043
						],
						[
							-81.40845599999994,
							28.583980000000054
						],
						[
							-81.40848199999994,
							28.583866000000057
						],
						[
							-81.40849199999991,
							28.583814000000075
						],
						[
							-81.40846199999993,
							28.58373500000005
						],
						[
							-81.40841699999994,
							28.583674000000087
						],
						[
							-81.40835699999991,
							28.58363600000007
						],
						[
							-81.40834699999994,
							28.583566000000076
						],
						[
							-81.4082929999999,
							28.583461000000057
						],
						[
							-81.4082489999999,
							28.58336100000008
						],
						[
							-81.40825999999993,
							28.58311400000008
						],
						[
							-81.40824099999992,
							28.583030000000065
						],
						[
							-81.4081819999999,
							28.582966000000056
						],
						[
							-81.40803899999992,
							28.582812000000047
						],
						[
							-81.40793699999995,
							28.582751000000087
						],
						[
							-81.40782799999994,
							28.58269000000007
						],
						[
							-81.40766899999994,
							28.58261000000005
						],
						[
							-81.4074609999999,
							28.582464000000073
						],
						[
							-81.40735699999993,
							28.582421000000068
						],
						[
							-81.40719799999994,
							28.582325000000083
						],
						[
							-81.40709399999992,
							28.58225900000008
						],
						[
							-81.40695999999991,
							28.582111000000054
						],
						[
							-81.40684099999993,
							28.582003000000043
						],
						[
							-81.4067619999999,
							28.58193300000005
						],
						[
							-81.40675199999993,
							28.58184600000004
						],
						[
							-81.40678199999991,
							28.58175900000009
						],
						[
							-81.40682599999992,
							28.581615000000056
						],
						[
							-81.40682599999992,
							28.58151500000008
						],
						[
							-81.40679999999992,
							28.58143400000006
						],
						[
							-81.40673599999991,
							28.581373000000042
						],
						[
							-81.40669099999991,
							28.581334000000084
						],
						[
							-81.40668099999994,
							28.581260000000043
						],
						[
							-81.40668099999994,
							28.581195000000037
						],
						[
							-81.40666599999992,
							28.58112900000009
						],
						[
							-81.40667599999995,
							28.581064000000083
						],
						[
							-81.40670599999993,
							28.58099400000009
						],
						[
							-81.40666099999993,
							28.58096000000006
						],
						[
							-81.40658699999994,
							28.58096000000006
						],
						[
							-81.40648799999991,
							28.580986000000053
						],
						[
							-81.40639899999991,
							28.581003000000067
						],
						[
							-81.4062909999999,
							28.58099700000008
						],
						[
							-81.40625523199992,
							28.58099923500004
						],
						[
							-81.40603271299995,
							28.580181466000056
						],
						[
							-81.40723955999994,
							28.579831091000074
						],
						[
							-81.40802249199993,
							28.58158657900009
						],
						[
							-81.40837099999993,
							28.582368000000088
						],
						[
							-81.40900410699993,
							28.583486357000083
						],
						[
							-81.40909613199995,
							28.583648916000072
						],
						[
							-81.40981399999993,
							28.584917000000075
						],
						[
							-81.4098459999999,
							28.58497600000004
						],
						[
							-81.41006499999992,
							28.585380000000043
						],
						[
							-81.41011199999991,
							28.585466000000054
						],
						[
							-81.41028999999992,
							28.58546000000007
						],
						[
							-81.4105720259999,
							28.585945241000047
						],
						[
							-81.41072060399995,
							28.58618172900009
						],
						[
							-81.41090920999994,
							28.586481564000053
						],
						[
							-81.41105885199994,
							28.586721884000042
						],
						[
							-81.41117146999994,
							28.586932817000047
						],
						[
							-81.41135024499994,
							28.58727045900008
						],
						[
							-81.41154799999993,
							28.58769200000006
						],
						[
							-81.41185799999994,
							28.58828600000004
						],
						[
							-81.41240399999992,
							28.589394000000084
						],
						[
							-81.41267899999991,
							28.58995200000004
						],
						[
							-81.4131190729999,
							28.590845066000043
						],
						[
							-81.4132239999999,
							28.59105800000009
						],
						[
							-81.41351999999995,
							28.59165900000005
						],
						[
							-81.4141308639999,
							28.592898863000073
						],
						[
							-81.41415999999992,
							28.592958000000067
						],
						[
							-81.41430099999991,
							28.59324500000008
						],
						[
							-81.41443907099995,
							28.593520665000085
						],
						[
							-81.4148579859999,
							28.594357051000088
						],
						[
							-81.41517099999994,
							28.594982000000073
						],
						[
							-81.41521999999992,
							28.595061000000044
						],
						[
							-81.41523201399991,
							28.595080363000083
						],
						[
							-81.41530499999993,
							28.59519800000004
						],
						[
							-81.4155274389999,
							28.59520350300005
						],
						[
							-81.4157251339999,
							28.595576788000074
						],
						[
							-81.41550762799994,
							28.595577956000056
						],
						[
							-81.41524399999992,
							28.595578000000046
						],
						[
							-81.41508099999993,
							28.595575000000053
						],
						[
							-81.41391887999993,
							28.59555253900004
						],
						[
							-81.4139659999999,
							28.59502800000007
						],
						[
							-81.4139659999999,
							28.59451400000006
						],
						[
							-81.41394799999995,
							28.594314000000054
						],
						[
							-81.41389399999991,
							28.594114000000047
						],
						[
							-81.41382099999993,
							28.593964000000085
						],
						[
							-81.41361999999992,
							28.59374200000008
						],
						[
							-81.41334499999994,
							28.59351900000007
						],
						[
							-81.41297099999991,
							28.59325400000006
						],
						[
							-81.41274373499994,
							28.592912132000038
						],
						[
							-81.41155749399991,
							28.592874440000063
						],
						[
							-81.41114893199995,
							28.59235699700008
						],
						[
							-81.41052030499992,
							28.59164214100008
						],
						[
							-81.4101950569999,
							28.591347358000064
						],
						[
							-81.41019435399994,
							28.591346721000036
						],
						[
							-81.41006897199992,
							28.59123284100008
						],
						[
							-81.4100360349999,
							28.591216486000064
						],
						[
							-81.4100012099999,
							28.591198234000046
						],
						[
							-81.40958921299995,
							28.590970687000038
						],
						[
							-81.40854836499994,
							28.59060564200007
						],
						[
							-81.40853136899995,
							28.590599489000056
						],
						[
							-81.4076423699999,
							28.59026748900004
						],
						[
							-81.4076128449999,
							28.590255865000074
						],
						[
							-81.4075592399999,
							28.590231577000054
						],
						[
							-81.40750733899995,
							28.59020383500007
						],
						[
							-81.40745736399992,
							28.59017275900004
						],
						[
							-81.40741626999994,
							28.59014360300006
						],
						[
							-81.40721426999994,
							28.589991603000044
						],
						[
							-81.40720752699991,
							28.58998648000005
						],
						[
							-81.40716203599993,
							28.589949146000038
						],
						[
							-81.40711908299994,
							28.58990891700006
						],
						[
							-81.4070788539999,
							28.58986596400007
						],
						[
							-81.40704151999996,
							28.589820472000042
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Lake Shore Village",
				"RegionID": "269050"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.41800555238557,
					28.53171524688903,
					-81.40532361080388,
					28.540628000343506
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.412726999721,
							28.54062500020523
						],
						[
							-81.41248600030288,
							28.54062100002087
						],
						[
							-81.41235899984456,
							28.54062300011305
						],
						[
							-81.41235899984456,
							28.54032199972781
						],
						[
							-81.41174300022737,
							28.5403229997739
						],
						[
							-81.41074700018058,
							28.540319999635628
						],
						[
							-81.41057600039194,
							28.5403229997739
						],
						[
							-81.41032903397227,
							28.540127720089124
						],
						[
							-81.41027089100432,
							28.540084510363553
						],
						[
							-81.40943771141234,
							28.53950980491605
						],
						[
							-81.40889490671586,
							28.53911121370144
						],
						[
							-81.40789842822973,
							28.538365106468284
						],
						[
							-81.40657346337927,
							28.5372764924403
						],
						[
							-81.40611172626832,
							28.536913027844896
						],
						[
							-81.40570918253346,
							28.536653568942803
						],
						[
							-81.40532544721943,
							28.53645236902119
						],
						[
							-81.40532361080388,
							28.536315066828905
						],
						[
							-81.40532361080388,
							28.536221927643652
						],
						[
							-81.40532361080388,
							28.5359685526552
						],
						[
							-81.40539671849027,
							28.534886947943093
						],
						[
							-81.4054037296049,
							28.53470167411517
						],
						[
							-81.4053937147547,
							28.53392752602118
						],
						[
							-81.40537769063481,
							28.53298112268495
						],
						[
							-81.40537769063481,
							28.53203872402984
						],
						[
							-81.40537763577619,
							28.531983673830418
						],
						[
							-81.40547283171098,
							28.532010681370352
						],
						[
							-81.40570918253346,
							28.532042729610147
						],
						[
							-81.40651137148835,
							28.532040726819954
						],
						[
							-81.40740870241862,
							28.532028709179734
						],
						[
							-81.40794349595457,
							28.532024703599333
						],
						[
							-81.40870963288793,
							28.53202069711974
						],
						[
							-81.40944271973676,
							28.532009681324176
						],
						[
							-81.41044921127424,
							28.531991654414163
						],
						[
							-81.41054936067475,
							28.531989651623967
						],
						[
							-81.41154884289645,
							28.531971623814584
						],
						[
							-81.41226089820033,
							28.531958605228823
						],
						[
							-81.41262243464928,
							28.53194057831881
						],
						[
							-81.41319228105996,
							28.531922552307996
						],
						[
							-81.41361991498015,
							28.531880489218096
						],
						[
							-81.41381219992252,
							28.531842433507066
						],
						[
							-81.41390633915395,
							28.531839427972848
						],
						[
							-81.41401950624076,
							28.531835422392533
						],
						[
							-81.41542959821666,
							28.53178735093212
						],
						[
							-81.4155277430283,
							28.53178534814201
						],
						[
							-81.41558482839346,
							28.531783345351812
						],
						[
							-81.41595037042282,
							28.531772329556247
						],
						[
							-81.41796741393689,
							28.53171524688903
						],
						[
							-81.41795834877078,
							28.532416283699412
						],
						[
							-81.41795834877078,
							28.533028191401343
						],
						[
							-81.41796035156096,
							28.53351391253141
						],
						[
							-81.41797437289075,
							28.533942547397064
						],
						[
							-81.41798930523376,
							28.534338151063864
						],
						[
							-81.41800555238557,
							28.53475488430165
						],
						[
							-81.4170970716606,
							28.5347477418861
						],
						[
							-81.41623178807085,
							28.53474874283156
						],
						[
							-81.41522829936957,
							28.53474774278547
						],
						[
							-81.41425372027417,
							28.534788675427635
						],
						[
							-81.41426386912322,
							28.535006125199068
						],
						[
							-81.41426487006868,
							28.535037672516538
						],
						[
							-81.41424984869289,
							28.535268514092262
						],
						[
							-81.41424984869289,
							28.535328603192973
						],
						[
							-81.41424984779353,
							28.53542374516843
						],
						[
							-81.41421980324313,
							28.535834353123974
						],
						[
							-81.41414719647915,
							28.536179365429987
						],
						[
							-81.4139093437888,
							28.537107240933707
						],
						[
							-81.41390433636376,
							28.537131277113602
						],
						[
							-81.41370504030685,
							28.537884393662637
						],
						[
							-81.41363293356582,
							28.538170818735715
						],
						[
							-81.41357184262037,
							28.53853135334002
						],
						[
							-81.41354880918459,
							28.53880876450846
						],
						[
							-81.41355481755501,
							28.53896399558454
						],
						[
							-81.41355982587943,
							28.539079165461644
						],
						[
							-81.41355982587943,
							28.539937437936864
						],
						[
							-81.41355991761023,
							28.54003758284079
						],
						[
							-81.413570841675,
							28.540155762748697
						],
						[
							-81.41358648268366,
							28.540324648231188
						],
						[
							-81.41303000019842,
							28.54032399981999
						],
						[
							-81.41298399987654,
							28.54032199972781
						],
						[
							-81.41298499992264,
							28.540628000343506
						],
						[
							-81.412726999721,
							28.54062500020523
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Lake Sunset",
				"RegionID": "269051"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.14299043099999,
					26.911264755000047,
					-80.12721538299996,
					26.919227113000034
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.13484893799995,
							26.919197006000047
						],
						[
							-80.12721538299996,
							26.91916724600003
						],
						[
							-80.12751471999997,
							26.91177362700006
						],
						[
							-80.14020534199994,
							26.91131943700003
						],
						[
							-80.14173321599998,
							26.911264755000047
						],
						[
							-80.14299043099999,
							26.91365944900008
						],
						[
							-80.14257135899999,
							26.919227113000034
						],
						[
							-80.13484893799995,
							26.919197006000047
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Jupiter",
				"Name": "Indian Creek",
				"RegionID": "268682"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.73108156399991,
					30.34385300800005,
					-81.7141108539999,
					30.35895807500009
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.71411890799993,
							30.34478801100005
						],
						[
							-81.7141108539999,
							30.34387400900005
						],
						[
							-81.71601090599995,
							30.343866008000077
						],
						[
							-81.71626990599994,
							30.343866008000077
						],
						[
							-81.71843690599991,
							30.34385300800005
						],
						[
							-81.7215269049999,
							30.34385700900009
						],
						[
							-81.72276290499991,
							30.343866008000077
						],
						[
							-81.72361890499991,
							30.34386900800007
						],
						[
							-81.7236919049999,
							30.34386900800007
						],
						[
							-81.7239379049999,
							30.343870008000067
						],
						[
							-81.7244109049999,
							30.343864008000082
						],
						[
							-81.7267529049999,
							30.343868008000072
						],
						[
							-81.7269959059999,
							30.34388100800004
						],
						[
							-81.72747790499994,
							30.343908008000085
						],
						[
							-81.72926290499993,
							30.343908008000085
						],
						[
							-81.73074890599992,
							30.343894009000053
						],
						[
							-81.73102896199993,
							30.34388201300004
						],
						[
							-81.73108156399991,
							30.356129858000088
						],
						[
							-81.72905090599994,
							30.35690100800008
						],
						[
							-81.72807690499991,
							30.357203009000045
						],
						[
							-81.72239590499993,
							30.358724009000074
						],
						[
							-81.72123482399991,
							30.35895807500009
						],
						[
							-81.71706785399994,
							30.355427556000052
						],
						[
							-81.71423291199994,
							30.351536011000064
						],
						[
							-81.71419490799991,
							30.351423010000076
						],
						[
							-81.71414190899992,
							30.35117500900009
						],
						[
							-81.71413390799995,
							30.35024801100008
						],
						[
							-81.71412690799991,
							30.349907010000035
						],
						[
							-81.7141339069999,
							30.349596011000077
						],
						[
							-81.71412690799991,
							30.349331010000075
						],
						[
							-81.71412690799991,
							30.34841201000006
						],
						[
							-81.71412690799991,
							30.347517011000036
						],
						[
							-81.71411890799993,
							30.346586010000067
						],
						[
							-81.71411890799993,
							30.345695010000043
						],
						[
							-81.71411890799993,
							30.34478801100005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Allendale",
				"RegionID": "268871"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.60684489899995,
					30.35097887700005,
					-81.58789690899994,
					30.366447064000052
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.58958590799995,
							30.35460801000005
						],
						[
							-81.5895799079999,
							30.35410901000006
						],
						[
							-81.58957090799993,
							30.353633010000067
						],
						[
							-81.58955390799991,
							30.35293601100005
						],
						[
							-81.5895639069999,
							30.352423010000056
						],
						[
							-81.58953489499993,
							30.35185892000004
						],
						[
							-81.59045390599994,
							30.35184300800006
						],
						[
							-81.5915069049999,
							30.351826008000046
						],
						[
							-81.59281190599995,
							30.35179900900005
						],
						[
							-81.59390290599993,
							30.35178600800009
						],
						[
							-81.59479490599995,
							30.351763008000038
						],
						[
							-81.5967929059999,
							30.35172500800007
						],
						[
							-81.59809090499994,
							30.351709008000057
						],
						[
							-81.59921290599993,
							30.35169000800005
						],
						[
							-81.60038890499993,
							30.351678008000075
						],
						[
							-81.60046390499991,
							30.351677008000078
						],
						[
							-81.60155990599992,
							30.351652008000087
						],
						[
							-81.60226790599995,
							30.351641009000048
						],
						[
							-81.60262605199995,
							30.35161512100007
						],
						[
							-81.6026009069999,
							30.351490008000038
						],
						[
							-81.60261385099994,
							30.350981005000055
						],
						[
							-81.60268692999995,
							30.35097887700005
						],
						[
							-81.60283290699994,
							30.351027011000042
						],
						[
							-81.6029219099999,
							30.35106901300008
						],
						[
							-81.60303290799993,
							30.351152012000057
						],
						[
							-81.60332286199991,
							30.351486077000065
						],
						[
							-81.60349300799993,
							30.35153786500007
						],
						[
							-81.60359285599992,
							30.351665190000066
						],
						[
							-81.60405590699992,
							30.35151000900004
						],
						[
							-81.60436196799992,
							30.351346835000072
						],
						[
							-81.60447690799992,
							30.351603010000076
						],
						[
							-81.6049419069999,
							30.352816011000073
						],
						[
							-81.6050489079999,
							30.353123010000047
						],
						[
							-81.60517890799991,
							30.353430010000068
						],
						[
							-81.60523190799995,
							30.35360701000008
						],
						[
							-81.60529286199994,
							30.35374303600008
						],
						[
							-81.6055219079999,
							30.35401001000008
						],
						[
							-81.60557590799993,
							30.35405901000007
						],
						[
							-81.60572803699995,
							30.35423307900004
						],
						[
							-81.60514785999993,
							30.35417183000004
						],
						[
							-81.60508690799992,
							30.354216009000083
						],
						[
							-81.60497993099995,
							30.354269070000043
						],
						[
							-81.60462190699991,
							30.354380010000057
						],
						[
							-81.60350374299992,
							30.354730914000072
						],
						[
							-81.60351190799992,
							30.354770008000063
						],
						[
							-81.6041319069999,
							30.35627701100009
						],
						[
							-81.60420907299994,
							30.356451088000085
						],
						[
							-81.60407074099993,
							30.356487929000085
						],
						[
							-81.60684489899995,
							30.363942069000075
						],
						[
							-81.60454990599993,
							30.364501008000047
						],
						[
							-81.60223290599993,
							30.36506700800004
						],
						[
							-81.60102090599992,
							30.365366008000077
						],
						[
							-81.59937890499992,
							30.365710009000058
						],
						[
							-81.59871690599994,
							30.365872009000043
						],
						[
							-81.59793590599992,
							30.366074008000055
						],
						[
							-81.5972729049999,
							30.366216008000038
						],
						[
							-81.59670988099992,
							30.366305948000047
						],
						[
							-81.59510790699994,
							30.366344010000034
						],
						[
							-81.59386990799993,
							30.36636301000004
						],
						[
							-81.59250990699991,
							30.36638301000005
						],
						[
							-81.59167490699991,
							30.366397010000075
						],
						[
							-81.59028790699995,
							30.36639901000007
						],
						[
							-81.5896049079999,
							30.36641201000009
						],
						[
							-81.58877590799995,
							30.36642801000005
						],
						[
							-81.58790590399991,
							30.366447064000052
						],
						[
							-81.58789690899994,
							30.366283010000075
						],
						[
							-81.5879149079999,
							30.36606901000005
						],
						[
							-81.58799390899992,
							30.36557301000005
						],
						[
							-81.58832090699991,
							30.364700010000035
						],
						[
							-81.58891190799994,
							30.363192010000034
						],
						[
							-81.58914290799993,
							30.362577010000052
						],
						[
							-81.5894719069999,
							30.36177001100009
						],
						[
							-81.58960490699991,
							30.361421010000072
						],
						[
							-81.58967490799995,
							30.36117001000008
						],
						[
							-81.58975790599995,
							30.360612010000068
						],
						[
							-81.58974890799993,
							30.360248011000063
						],
						[
							-81.58972690799993,
							30.359483010000076
						],
						[
							-81.58969890799995,
							30.358574011000087
						],
						[
							-81.58964390699992,
							30.356437010000036
						],
						[
							-81.58962190699992,
							30.355846010000054
						],
						[
							-81.5896019079999,
							30.355026011000064
						],
						[
							-81.58960190699993,
							30.354872011000054
						],
						[
							-81.58958590799995,
							30.35460801000005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Arlington Manor",
				"RegionID": "268873"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.49441471499995,
					27.864020223000068,
					-82.47795867799994,
					27.89360005500004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.48462876899993,
							27.89276442700009
						],
						[
							-82.48445173899995,
							27.892481820000057
						],
						[
							-82.48433299999994,
							27.892482322000035
						],
						[
							-82.48417683399992,
							27.892468660000077
						],
						[
							-82.4840809609999,
							27.892446282000037
						],
						[
							-82.48366920699993,
							27.892326069000035
						],
						[
							-82.48356478499994,
							27.89230159500005
						],
						[
							-82.48349010599992,
							27.89228065800006
						],
						[
							-82.48341750999992,
							27.892253364000055
						],
						[
							-82.4833475339999,
							27.892219916000045
						],
						[
							-82.4832807009999,
							27.892180564000057
						],
						[
							-82.48321750799994,
							27.892135600000074
						],
						[
							-82.4829774829999,
							27.891948717000048
						],
						[
							-82.48280532099994,
							27.891837319000047
						],
						[
							-82.48257401299992,
							27.891727752000065
						],
						[
							-82.48247681599992,
							27.89167413000007
						],
						[
							-82.48220212299992,
							27.891499175000035
						],
						[
							-82.48217183299994,
							27.89148040400005
						],
						[
							-82.48207166899994,
							27.89141251800004
						],
						[
							-82.48185972399995,
							27.89128448200006
						],
						[
							-82.48129770999992,
							27.890937551000036
						],
						[
							-82.4812178059999,
							27.89088883800008
						],
						[
							-82.48110792699993,
							27.890809921000084
						],
						[
							-82.48103131699992,
							27.890737579000074
						],
						[
							-82.48092736199993,
							27.89062720000004
						],
						[
							-82.48057578399994,
							27.890469934000066
						],
						[
							-82.4804933389999,
							27.89042783600007
						],
						[
							-82.48042572999992,
							27.89038467100005
						],
						[
							-82.4802977299999,
							27.89029467100005
						],
						[
							-82.48023528499994,
							27.89024654100007
						],
						[
							-82.48017729599991,
							27.890193126000042
						],
						[
							-82.48012420999993,
							27.890134837000062
						],
						[
							-82.48007643299991,
							27.89007212100006
						],
						[
							-82.48003433499991,
							27.890005462000094
						],
						[
							-82.4799345049999,
							27.88982926300008
						],
						[
							-82.4798990029999,
							27.889759712000057
						],
						[
							-82.47986966799994,
							27.88968734400004
						],
						[
							-82.47984672099996,
							27.889612704000058
						],
						[
							-82.4798303359999,
							27.889536355000075
						],
						[
							-82.4798206349999,
							27.889458872000034
						],
						[
							-82.47981131099993,
							27.889344188000052
						],
						[
							-82.47980714099992,
							27.88930248900005
						],
						[
							-82.47980267799994,
							27.88921300000004
						],
						[
							-82.47981285399993,
							27.88907809500006
						],
						[
							-82.4798212789999,
							27.889022564000072
						],
						[
							-82.47911683299992,
							27.889038103000075
						],
						[
							-82.4789919239999,
							27.889032162000035
						],
						[
							-82.47887292399992,
							27.88901816200007
						],
						[
							-82.47882183399992,
							27.889010659000064
						],
						[
							-82.47867041299992,
							27.888970086000086
						],
						[
							-82.47852833899992,
							27.888903836000054
						],
						[
							-82.47839992699994,
							27.888813921000068
						],
						[
							-82.47837103699993,
							27.888788608000084
						],
						[
							-82.47828903699991,
							27.888713608000046
						],
						[
							-82.4782371089999,
							27.888662081000064
						],
						[
							-82.47818954099995,
							27.888606503000062
						],
						[
							-82.4781466469999,
							27.888547243000062
						],
						[
							-82.47810871199994,
							27.888484692000077
						],
						[
							-82.47807598599991,
							27.88841926500004
						],
						[
							-82.47804868599991,
							27.88835139500009
						],
						[
							-82.4780269929999,
							27.888281531000075
						],
						[
							-82.4780110499999,
							27.888210134000076
						],
						[
							-82.47797269499995,
							27.887998150000044
						],
						[
							-82.47795867799994,
							27.88784000000004
						],
						[
							-82.47795867799994,
							27.887510000000077
						],
						[
							-82.47797234099994,
							27.887353835000056
						],
						[
							-82.47797796899994,
							27.88732473200008
						],
						[
							-82.47804596799995,
							27.887001732000044
						],
						[
							-82.47806553899994,
							27.886925490000067
						],
						[
							-82.47809170199992,
							27.886851251000053
						],
						[
							-82.47812425599994,
							27.886779585000056
						],
						[
							-82.47816295199993,
							27.88671104000008
						],
						[
							-82.47820749399995,
							27.886646141000085
						],
						[
							-82.47825753899991,
							27.886585385000046
						],
						[
							-82.47839253899991,
							27.886435385000084
						],
						[
							-82.4784829269999,
							27.88634808000006
						],
						[
							-82.47858436099995,
							27.886274376000074
						],
						[
							-82.47870436099993,
							27.886199376000036
						],
						[
							-82.47876469199991,
							27.88616483700008
						],
						[
							-82.47882751199995,
							27.886135062000054
						],
						[
							-82.47889244299995,
							27.886110229000053
						],
						[
							-82.47895909899995,
							27.886090486000057
						],
						[
							-82.47902708099991,
							27.886075951000066
						],
						[
							-82.47929232799993,
							27.88603056000005
						],
						[
							-82.47944399999994,
							27.886017678000087
						],
						[
							-82.48009458999992,
							27.886017678000087
						],
						[
							-82.48010271399994,
							27.88583720200006
						],
						[
							-82.48007275099991,
							27.885208886000044
						],
						[
							-82.48002997899994,
							27.884912704000044
						],
						[
							-82.47998787099993,
							27.884711880000054
						],
						[
							-82.47991776799995,
							27.884438011000043
						],
						[
							-82.47990427799995,
							27.884376391000046
						],
						[
							-82.47989514099993,
							27.884313976000048
						],
						[
							-82.47989040199991,
							27.884251075000066
						],
						[
							-82.47989008399992,
							27.884187996000037
						],
						[
							-82.47989708299991,
							27.883954996000057
						],
						[
							-82.4799025769999,
							27.88387915800007
						],
						[
							-82.47991445799994,
							27.883804056000088
						],
						[
							-82.4799326399999,
							27.88373022600007
						],
						[
							-82.47995699399992,
							27.883658196000056
						],
						[
							-82.47998734499993,
							27.88358848000007
						],
						[
							-82.48007834599991,
							27.88340148000009
						],
						[
							-82.4801078889999,
							27.883345816000087
						],
						[
							-82.48014125799995,
							27.883292358000062
						],
						[
							-82.48017828899992,
							27.883241368000085
						],
						[
							-82.48021879999993,
							27.88319309600007
						],
						[
							-82.48051902499992,
							27.882859803000088
						],
						[
							-82.48053942799993,
							27.882828981000046
						],
						[
							-82.48066004799995,
							27.882570946000044
						],
						[
							-82.48076005099995,
							27.882326771000066
						],
						[
							-82.48085295099992,
							27.88204641200008
						],
						[
							-82.48117136399992,
							27.880818527000088
						],
						[
							-82.48122512899994,
							27.880602492000037
						],
						[
							-82.48134144999995,
							27.880131956000074
						],
						[
							-82.48124326599992,
							27.879948678000062
						],
						[
							-82.48118646299991,
							27.879819070000053
						],
						[
							-82.48109546199993,
							27.87955707000009
						],
						[
							-82.48106556599993,
							27.879450086000077
						],
						[
							-82.4810285659999,
							27.87927708600006
						],
						[
							-82.48101564599995,
							27.879200738000065
						],
						[
							-82.48100934199994,
							27.879123562000075
						],
						[
							-82.4810096999999,
							27.879046129000074
						],
						[
							-82.48101671799992,
							27.878969014000063
						],
						[
							-82.48103057599991,
							27.878866083000048
						],
						[
							-82.4810534319999,
							27.878693153000086
						],
						[
							-82.48105933999994,
							27.878654834000088
						],
						[
							-82.4810898369999,
							27.878532652000047
						],
						[
							-82.48117283799992,
							27.878277652000065
						],
						[
							-82.48119785699994,
							27.87821010600004
						],
						[
							-82.48127285699991,
							27.878030107000086
						],
						[
							-82.48132065899995,
							27.87793246600006
						],
						[
							-82.48139441199993,
							27.877802402000043
						],
						[
							-82.48149213599993,
							27.87766385900005
						],
						[
							-82.48161019199995,
							27.877528792000078
						],
						[
							-82.48170892699994,
							27.877432080000062
						],
						[
							-82.48177659099991,
							27.87738055200009
						],
						[
							-82.48187959199993,
							27.877309552000042
						],
						[
							-82.48193713599994,
							27.877273022000054
						],
						[
							-82.4821121359999,
							27.877171023000077
						],
						[
							-82.48215553599994,
							27.877147301000036
						],
						[
							-82.48272653499993,
							27.876855301000035
						],
						[
							-82.48276385499992,
							27.876837289000036
						],
						[
							-82.48292885599994,
							27.876762288000066
						],
						[
							-82.48299341399992,
							27.87673591300006
						],
						[
							-82.48312982899995,
							27.876698118000036
						],
						[
							-82.48333333199992,
							27.87665872900004
						],
						[
							-82.48349699999994,
							27.87664367800005
						],
						[
							-82.48358784499993,
							27.87664827800006
						],
						[
							-82.4838941729999,
							27.87667938000004
						],
						[
							-82.48399587799992,
							27.876622171000065
						],
						[
							-82.4840798919999,
							27.876555499000066
						],
						[
							-82.48417433599991,
							27.87643852800005
						],
						[
							-82.48440216699993,
							27.87598362300008
						],
						[
							-82.48454647799991,
							27.87554369100008
						],
						[
							-82.48456862899991,
							27.875483503000055
						],
						[
							-82.48459501199994,
							27.87542504700008
						],
						[
							-82.48462549499993,
							27.875368619000085
						],
						[
							-82.48465992099995,
							27.875314508000088
						],
						[
							-82.48482492099993,
							27.87507450800007
						],
						[
							-82.48489383899994,
							27.874986523000075
						],
						[
							-82.48501383899992,
							27.874851523000075
						],
						[
							-82.48510792699994,
							27.874760080000044
						],
						[
							-82.48516833199994,
							27.87471361000007
						],
						[
							-82.48564916499993,
							27.874375133000058
						],
						[
							-82.48571856599995,
							27.874260435000057
						],
						[
							-82.48579907999994,
							27.874147927000084
						],
						[
							-82.48581192499995,
							27.87413295500005
						],
						[
							-82.48587590699992,
							27.874060016000044
						],
						[
							-82.4864851239999,
							27.873167133000038
						],
						[
							-82.48651019499994,
							27.87313221100004
						],
						[
							-82.4866523259999,
							27.872943904000067
						],
						[
							-82.48669695399991,
							27.87285025400007
						],
						[
							-82.4867412239999,
							27.87262825800008
						],
						[
							-82.48681259999995,
							27.872199158000058
						],
						[
							-82.48685391299995,
							27.87204341400008
						],
						[
							-82.48686812199992,
							27.872006876000057
						],
						[
							-82.48702012199993,
							27.871639875000085
						],
						[
							-82.48707216499992,
							27.87153433900005
						],
						[
							-82.48710271899996,
							27.871485146000055
						],
						[
							-82.48726300099992,
							27.871244723000075
						],
						[
							-82.4873734169999,
							27.87098156500008
						],
						[
							-82.48742475499996,
							27.870713712000054
						],
						[
							-82.48743191599995,
							27.87067988000007
						],
						[
							-82.48760991599994,
							27.869912146000047
						],
						[
							-82.48761119799991,
							27.86987149500004
						],
						[
							-82.48759930699993,
							27.869803973000046
						],
						[
							-82.4875866299999,
							27.86968936900007
						],
						[
							-82.48757962999991,
							27.869537369000057
						],
						[
							-82.48757948999992,
							27.86945779100006
						],
						[
							-82.48758638599992,
							27.869378512000086
						],
						[
							-82.48760026299993,
							27.869300152000054
						],
						[
							-82.48762101199992,
							27.869223326000053
						],
						[
							-82.48766301099994,
							27.869091327000035
						],
						[
							-82.48772071199994,
							27.86895178800006
						],
						[
							-82.48778570299993,
							27.86882576900007
						],
						[
							-82.48807168499991,
							27.868137234000073
						],
						[
							-82.48794634799992,
							27.86790469300007
						],
						[
							-82.48789291399993,
							27.867785586000082
						],
						[
							-82.48786908999995,
							27.86770989600007
						],
						[
							-82.48778608999993,
							27.867398896000054
						],
						[
							-82.48776933999996,
							27.867323165000073
						],
						[
							-82.48775569499992,
							27.867163067000035
						],
						[
							-82.48775721399994,
							27.86698741400005
						],
						[
							-82.4877147819999,
							27.86687725300004
						],
						[
							-82.48769546799991,
							27.866821774000073
						],
						[
							-82.48759846799993,
							27.866510774000062
						],
						[
							-82.48757025899994,
							27.866392898000072
						],
						[
							-82.48748725799994,
							27.86590189800006
						],
						[
							-82.4874746779999,
							27.865752000000043
						],
						[
							-82.48747543999991,
							27.865715001000073
						],
						[
							-82.48748943899994,
							27.865375001000075
						],
						[
							-82.4874936359999,
							27.865317695000044
						],
						[
							-82.48751863699994,
							27.865080593000073
						],
						[
							-82.48751406699995,
							27.86487297800005
						],
						[
							-82.48749845299994,
							27.864762324000086
						],
						[
							-82.48747482699991,
							27.864593986000045
						],
						[
							-82.48739700199991,
							27.86440574800008
						],
						[
							-82.4873920309999,
							27.86439868000008
						],
						[
							-82.4882793999999,
							27.86418623600008
						],
						[
							-82.49441471499995,
							27.864020223000068
						],
						[
							-82.49439090899995,
							27.86430000000007
						],
						[
							-82.49421083499995,
							27.866414990000067
						],
						[
							-82.49411812799991,
							27.88019994700005
						],
						[
							-82.4940862439999,
							27.88424786700006
						],
						[
							-82.49407272799994,
							27.885000001000037
						],
						[
							-82.49391818399994,
							27.89360005500004
						],
						[
							-82.48721818199994,
							27.89360000100004
						],
						[
							-82.48573544499993,
							27.893599687000062
						],
						[
							-82.48481844699995,
							27.893599493000067
						],
						[
							-82.48472932899995,
							27.893117029000052
						],
						[
							-82.48465435999992,
							27.892853338000066
						],
						[
							-82.48462876899993,
							27.89276442700009
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Ballast Point",
				"RegionID": "268882"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.5449823219999,
					27.932567921000043,
					-82.51401128399993,
					27.94800004600006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.51420477799991,
							27.943175328000052
						],
						[
							-82.51423759999994,
							27.93387621000005
						],
						[
							-82.51852006599995,
							27.93390015300008
						],
						[
							-82.51909244799992,
							27.933507473000077
						],
						[
							-82.51981128299991,
							27.933651586000053
						],
						[
							-82.52045083999991,
							27.933397079000088
						],
						[
							-82.5245044049999,
							27.93347599100008
						],
						[
							-82.52451674399994,
							27.932826504000047
						],
						[
							-82.52722130199993,
							27.932879109000055
						],
						[
							-82.52790140099995,
							27.93289203200004
						],
						[
							-82.52805591499992,
							27.932871609000074
						],
						[
							-82.52813654499994,
							27.933014951000075
						],
						[
							-82.52827092799993,
							27.93306870400005
						],
						[
							-82.52875470599992,
							27.933077663000063
						],
						[
							-82.53103025699994,
							27.933104539000055
						],
						[
							-82.5330549599999,
							27.933086621000086
						],
						[
							-82.53352082099991,
							27.93295223800004
						],
						[
							-82.53397772299991,
							27.932746185000042
						],
						[
							-82.53428751599995,
							27.932567921000043
						],
						[
							-82.53434805899991,
							27.932612220000067
						],
						[
							-82.53440238799993,
							27.932655284000077
						],
						[
							-82.5344532389999,
							27.932702406000093
						],
						[
							-82.53450030899995,
							27.932753304000073
						],
						[
							-82.53454331799992,
							27.932807677000085
						],
						[
							-82.53458201099994,
							27.932865201000084
						],
						[
							-82.53461615799995,
							27.932925535000038
						],
						[
							-82.53466415699995,
							27.933018535000087
						],
						[
							-82.53469537599995,
							27.933085667000057
						],
						[
							-82.53472096799993,
							27.933155140000054
						],
						[
							-82.53474075799994,
							27.933226482000066
						],
						[
							-82.5347546129999,
							27.933299210000087
						],
						[
							-82.53476661299993,
							27.933380210000053
						],
						[
							-82.53477474099992,
							27.933458701000063
						],
						[
							-82.53477595699991,
							27.933537602000058
						],
						[
							-82.53477025199993,
							27.933616305000044
						],
						[
							-82.53475766999992,
							27.93369420600004
						],
						[
							-82.53472767099993,
							27.933839206000073
						],
						[
							-82.53469892499994,
							27.933945105000078
						],
						[
							-82.53460592499994,
							27.934220105000065
						],
						[
							-82.5345990859999,
							27.934239586000047
						],
						[
							-82.53453949199991,
							27.93436993100005
						],
						[
							-82.5344101629999,
							27.934601796000038
						],
						[
							-82.53431662999992,
							27.934736419000046
						],
						[
							-82.53411033999993,
							27.934981765000092
						],
						[
							-82.53403716899993,
							27.935059009000046
						],
						[
							-82.53378016799991,
							27.93530000900006
						],
						[
							-82.53374903699995,
							27.935327873000062
						],
						[
							-82.5334750369999,
							27.93556187300004
						],
						[
							-82.53335098699995,
							27.935650783000085
						],
						[
							-82.53318071299992,
							27.935752126000068
						],
						[
							-82.53305243799991,
							27.93582747200009
						],
						[
							-82.5329318599999,
							27.935886655000047
						],
						[
							-82.53276485999993,
							27.93595365500005
						],
						[
							-82.53270746899994,
							27.93597444800008
						],
						[
							-82.5326487989999,
							27.93599130000007
						],
						[
							-82.53258912199993,
							27.93600413300004
						],
						[
							-82.53252871099996,
							27.93601288800005
						],
						[
							-82.53245932399994,
							27.93602055000008
						],
						[
							-82.53259246699992,
							27.93624798400009
						],
						[
							-82.53266008599991,
							27.936392414000068
						],
						[
							-82.53267717199992,
							27.936444189000042
						],
						[
							-82.53270417199992,
							27.936535190000086
						],
						[
							-82.53272765899993,
							27.936634835000064
						],
						[
							-82.53274035099992,
							27.936749221000074
						],
						[
							-82.5327463509999,
							27.936878221000086
						],
						[
							-82.53274732199992,
							27.936920000000043
						],
						[
							-82.53273330799993,
							27.937078129000046
						],
						[
							-82.5327129769999,
							27.937190539000085
						],
						[
							-82.53274829599991,
							27.93719591300004
						],
						[
							-82.53276916499993,
							27.937199341000056
						],
						[
							-82.53291030499992,
							27.93723624200004
						],
						[
							-82.5330924459999,
							27.937300078000078
						],
						[
							-82.53323966099993,
							27.937368164000077
						],
						[
							-82.53329965599995,
							27.93740603400005
						],
						[
							-82.53348865699991,
							27.93753603400006
						],
						[
							-82.53356510299994,
							27.937594897000054
						],
						[
							-82.53382445099993,
							27.937817745000075
						],
						[
							-82.53422151899991,
							27.93813793000004
						],
						[
							-82.53426647599991,
							27.938176699000053
						],
						[
							-82.53451717099995,
							27.93840774800009
						],
						[
							-82.53453316399992,
							27.938374339000063
						],
						[
							-82.53460858499994,
							27.93826365400008
						],
						[
							-82.53470258499993,
							27.93814565400004
						],
						[
							-82.53475527699993,
							27.938085242000056
						],
						[
							-82.53490027799995,
							27.937933242000042
						],
						[
							-82.53499514099991,
							27.93784703400007
						],
						[
							-82.53525714099993,
							27.93764103400008
						],
						[
							-82.53536333899991,
							27.93756916500007
						],
						[
							-82.53543508899992,
							27.93753193400005
						],
						[
							-82.53558408899995,
							27.937462934000052
						],
						[
							-82.53569849599995,
							27.93741914800006
						],
						[
							-82.53582249599992,
							27.937381148000043
						],
						[
							-82.5359625239999,
							27.93735019500008
						],
						[
							-82.53606352399993,
							27.937336195000057
						],
						[
							-82.53620069399994,
							27.937327782000068
						],
						[
							-82.5363976939999,
							27.93733078200006
						],
						[
							-82.53648094799992,
							27.937335919000077
						],
						[
							-82.53664694799994,
							27.93735391900009
						],
						[
							-82.53672216599995,
							27.937365312000054
						],
						[
							-82.53679615099992,
							27.937383021000073
						],
						[
							-82.53686837599992,
							27.93740691900007
						],
						[
							-82.53693832199991,
							27.937436837000067
						],
						[
							-82.53703232299995,
							27.937481837000064
						],
						[
							-82.53709037699991,
							27.937512278000046
						],
						[
							-82.53714606099993,
							27.937546867000037
						],
						[
							-82.53719907699991,
							27.93758542000006
						],
						[
							-82.53724914299994,
							27.93762773200007
						],
						[
							-82.53729599499991,
							27.93767357900009
						],
						[
							-82.53731468899991,
							27.937693256000045
						],
						[
							-82.53741338299994,
							27.937796935000055
						],
						[
							-82.53748931499992,
							27.93788804500008
						],
						[
							-82.5376013149999,
							27.938042044000042
						],
						[
							-82.53767918599993,
							27.938170430000074
						],
						[
							-82.53787718599995,
							27.93856843000009
						],
						[
							-82.53791708699993,
							27.93866141400008
						],
						[
							-82.53793726799995,
							27.938723865000043
						],
						[
							-82.53809032399994,
							27.93926411600006
						],
						[
							-82.53823508399995,
							27.93960857400009
						],
						[
							-82.53825884899993,
							27.939668837000056
						],
						[
							-82.53827740499993,
							27.939730902000065
						],
						[
							-82.5382906179999,
							27.93979432000009
						],
						[
							-82.53829839199994,
							27.939858632000043
						],
						[
							-82.5383139999999,
							27.93985767800007
						],
						[
							-82.53836594199993,
							27.939859179000052
						],
						[
							-82.5384869419999,
							27.939866179000038
						],
						[
							-82.5386120789999,
							27.939882284000078
						],
						[
							-82.53885107899993,
							27.939930284000074
						],
						[
							-82.53894763499994,
							27.939955317000056
						],
						[
							-82.53928709899992,
							27.94006374600008
						],
						[
							-82.5393634209999,
							27.940075424000042
						],
						[
							-82.53948962799991,
							27.94008421500007
						],
						[
							-82.53969209099995,
							27.940081215000077
						],
						[
							-82.53987018799995,
							27.940066830000035
						],
						[
							-82.54030862899992,
							27.939979142000087
						],
						[
							-82.54034019099993,
							27.939973413000075
						],
						[
							-82.54157219099994,
							27.93977241300007
						],
						[
							-82.54166875999994,
							27.93976197300009
						],
						[
							-82.54215275999991,
							27.93973597300004
						],
						[
							-82.54217585399994,
							27.93973503000007
						],
						[
							-82.54301394699992,
							27.93971158700009
						],
						[
							-82.54314608399994,
							27.93970202400004
						],
						[
							-82.54321477399992,
							27.93969968600004
						],
						[
							-82.5432834419999,
							27.93970260000009
						],
						[
							-82.54335168699993,
							27.939710750000078
						],
						[
							-82.54341910999995,
							27.939724088000048
						],
						[
							-82.54383110999993,
							27.939822088000085
						],
						[
							-82.54396573999992,
							27.939865550000036
						],
						[
							-82.54409673999993,
							27.93991955000007
						],
						[
							-82.54420831699991,
							27.93997487100006
						],
						[
							-82.54433131699994,
							27.94004687100005
						],
						[
							-82.54445507299994,
							27.940134079000075
						],
						[
							-82.5445518869999,
							27.940228603000037
						],
						[
							-82.54464788699994,
							27.940337603000046
						],
						[
							-82.54466192099996,
							27.940353927000046
						],
						[
							-82.54474161499992,
							27.94046508400004
						],
						[
							-82.5448066159999,
							27.940572084000053
						],
						[
							-82.54484364199993,
							27.940639348000047
						],
						[
							-82.54487479599993,
							27.940709525000045
						],
						[
							-82.54489984999992,
							27.94078210400005
						],
						[
							-82.54493084899991,
							27.940886104000075
						],
						[
							-82.54495465899993,
							27.940986834000057
						],
						[
							-82.54496239399992,
							27.941039912000065
						],
						[
							-82.54496780599993,
							27.941086812000037
						],
						[
							-82.54497515799994,
							27.94114471800009
						],
						[
							-82.5449823219999,
							27.94125800000006
						],
						[
							-82.54497488299995,
							27.94134302200007
						],
						[
							-82.5446570929999,
							27.941789458000073
						],
						[
							-82.5442874929999,
							27.942003437000043
						],
						[
							-82.54381090299995,
							27.942032616000063
						],
						[
							-82.54333431399994,
							27.941935353000076
						],
						[
							-82.54302307099994,
							27.94181863700004
						],
						[
							-82.54279936599994,
							27.94182836400006
						],
						[
							-82.54254648199992,
							27.941915900000083
						],
						[
							-82.54211852399993,
							27.942470300000082
						],
						[
							-82.5415318609999,
							27.94258438500009
						],
						[
							-82.54149061899994,
							27.942587856000046
						],
						[
							-82.54083712599993,
							27.94270097800006
						],
						[
							-82.53965973599992,
							27.942923260000043
						],
						[
							-82.53976709199992,
							27.943192675000034
						],
						[
							-82.53979393399993,
							27.943618006000065
						],
						[
							-82.53995036099991,
							27.94408075200005
						],
						[
							-82.5401454339999,
							27.944562658000056
						],
						[
							-82.54031356699994,
							27.944977045000087
						],
						[
							-82.53433138399993,
							27.947129758000074
						],
						[
							-82.53292003299993,
							27.947600030000046
						],
						[
							-82.53231999499991,
							27.947799968000083
						],
						[
							-82.53210998799995,
							27.94787998700008
						],
						[
							-82.53159996399995,
							27.94800004600006
						],
						[
							-82.53062003699995,
							27.946500039000057
						],
						[
							-82.52912008699991,
							27.944999843000062
						],
						[
							-82.52731997699993,
							27.94492998800007
						],
						[
							-82.51401128399993,
							27.944741045000058
						],
						[
							-82.51420477799991,
							27.943175328000052
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Beach Park",
				"RegionID": "268887"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.61760690799991,
					30.205672011000047,
					-81.57876385999992,
					30.220636010000078
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.58898090299994,
							30.220636010000078
						],
						[
							-81.58409090899994,
							30.213630011000074
						],
						[
							-81.58134490999994,
							30.209730011000094
						],
						[
							-81.57876385999992,
							30.206107097000086
						],
						[
							-81.57885390799993,
							30.206093011000064
						],
						[
							-81.57904790999994,
							30.20608101100004
						],
						[
							-81.57913990599991,
							30.206093009000085
						],
						[
							-81.58011590799993,
							30.20604101000004
						],
						[
							-81.58151190699994,
							30.20602001000009
						],
						[
							-81.58225390699994,
							30.206019010000034
						],
						[
							-81.58338190899991,
							30.20599906400008
						],
						[
							-81.5838549099999,
							30.205990012000086
						],
						[
							-81.58470190999992,
							30.20599601100008
						],
						[
							-81.58537290899994,
							30.20600501100006
						],
						[
							-81.58545690999995,
							30.20600101100007
						],
						[
							-81.5896409099999,
							30.206043011000077
						],
						[
							-81.5921399099999,
							30.20606401100008
						],
						[
							-81.59332590999992,
							30.20605401100005
						],
						[
							-81.59428390999994,
							30.206032012000037
						],
						[
							-81.59439090899991,
							30.206028012000047
						],
						[
							-81.59533690899991,
							30.20601301100004
						],
						[
							-81.59825890999991,
							30.205954011000074
						],
						[
							-81.60023490999994,
							30.205929011000084
						],
						[
							-81.60227990999994,
							30.20588901100007
						],
						[
							-81.60271490899993,
							30.205887011000076
						],
						[
							-81.60375990999995,
							30.205880011000094
						],
						[
							-81.60465990999995,
							30.20586201100008
						],
						[
							-81.60633090899995,
							30.20584901100005
						],
						[
							-81.60703290899994,
							30.20583301200008
						],
						[
							-81.60795590999993,
							30.205822011000066
						],
						[
							-81.60961890999994,
							30.20581401200008
						],
						[
							-81.6099469099999,
							30.20580101100006
						],
						[
							-81.61063390999993,
							30.205778012000057
						],
						[
							-81.6114119099999,
							30.20577201100008
						],
						[
							-81.61277790999992,
							30.205748011000086
						],
						[
							-81.61396690999993,
							30.205721011000037
						],
						[
							-81.61459390999994,
							30.20570701100007
						],
						[
							-81.61611390999991,
							30.205672011000047
						],
						[
							-81.61676290999992,
							30.20568901100006
						],
						[
							-81.6171879659999,
							30.20570000600009
						],
						[
							-81.6172049079999,
							30.205994011000087
						],
						[
							-81.61722590799991,
							30.20636401100006
						],
						[
							-81.61727890799995,
							30.206989011000076
						],
						[
							-81.61728690699994,
							30.20748901100006
						],
						[
							-81.61729390799991,
							30.207676010000057
						],
						[
							-81.61729390799991,
							30.207914010000085
						],
						[
							-81.61730190899993,
							30.208227010000087
						],
						[
							-81.6173479069999,
							30.208540010000032
						],
						[
							-81.61736285599994,
							30.20914501900006
						],
						[
							-81.61737795999994,
							30.209196001000066
						],
						[
							-81.6173859079999,
							30.209826010000086
						],
						[
							-81.61744690699993,
							30.21080801000005
						],
						[
							-81.61746990799992,
							30.211605011000078
						],
						[
							-81.61753090799994,
							30.212662011000077
						],
						[
							-81.61755390799993,
							30.21317301000005
						],
						[
							-81.61759890699994,
							30.213856010000086
						],
						[
							-81.61760690799991,
							30.214010011000084
						],
						[
							-81.61759890699994,
							30.21447601000006
						],
						[
							-81.61759690799994,
							30.214532011000074
						],
						[
							-81.61758390699994,
							30.214918010000076
						],
						[
							-81.61751299999992,
							30.215586000000087
						],
						[
							-81.61746097799994,
							30.215991142000064
						],
						[
							-81.61711043899993,
							30.21605686800007
						],
						[
							-81.61632543299993,
							30.215952201000054
						],
						[
							-81.6155927609999,
							30.215899867000076
						],
						[
							-81.6148077549999,
							30.215899867000076
						],
						[
							-81.6140227489999,
							30.21605686800007
						],
						[
							-81.61360407899991,
							30.215899867000076
						],
						[
							-81.61329007699993,
							30.215742866000085
						],
						[
							-81.61302840799993,
							30.215795199000073
						],
						[
							-81.61271440599995,
							30.216004534000035
						],
						[
							-81.61255740399992,
							30.216527872000086
						],
						[
							-81.61234806999995,
							30.21720821000008
						],
						[
							-81.6121910679999,
							30.217888549000065
						],
						[
							-81.61213873499992,
							30.21825488500008
						],
						[
							-81.61210599999993,
							30.21844400000009
						],
						[
							-81.6110609079999,
							30.218624010000042
						],
						[
							-81.61018390699991,
							30.218777010000053
						],
						[
							-81.60990390799992,
							30.21882501100004
						],
						[
							-81.60905390799991,
							30.21896701100008
						],
						[
							-81.60792190699993,
							30.219164010000046
						],
						[
							-81.60688790699993,
							30.219347010000035
						],
						[
							-81.60635090799991,
							30.21943301100004
						],
						[
							-81.60462990699995,
							30.21974901100009
						],
						[
							-81.60441590699992,
							30.21978301100006
						],
						[
							-81.60362990699991,
							30.219913010000088
						],
						[
							-81.6025539069999,
							30.220081010000058
						],
						[
							-81.60172990799992,
							30.220218010000053
						],
						[
							-81.60074590699992,
							30.220383010000038
						],
						[
							-81.60044090799994,
							30.220421010000052
						],
						[
							-81.59986890699993,
							30.220495010000032
						],
						[
							-81.59950290799992,
							30.220517010000037
						],
						[
							-81.59921290799991,
							30.220530010000065
						],
						[
							-81.59883090699992,
							30.220533010000057
						],
						[
							-81.59864790899991,
							30.220533011000043
						],
						[
							-81.5983419069999,
							30.220554010000058
						],
						[
							-81.59812190699995,
							30.220570010000078
						],
						[
							-81.59765590699993,
							30.22057301000007
						],
						[
							-81.59704988899995,
							30.22057509200005
						],
						[
							-81.5969539269999,
							30.220528928000082
						],
						[
							-81.59679690699994,
							30.22053201000006
						],
						[
							-81.5957529069999,
							30.220556010000053
						],
						[
							-81.59473190799991,
							30.22056901000008
						],
						[
							-81.59416890799992,
							30.22057701000006
						],
						[
							-81.59286290699993,
							30.220604010000045
						],
						[
							-81.58898090299994,
							30.220636010000078
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Craven",
				"RegionID": "268942"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.33869299993378,
					28.458486000023903,
					-81.33066899967613,
					28.46555600037209
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.33857399984419,
							28.458486000023903
						],
						[
							-81.33862300030422,
							28.458486000023903
						],
						[
							-81.33862353000495,
							28.458532376262312
						],
						[
							-81.33864599956584,
							28.4605000002322
						],
						[
							-81.33867900018771,
							28.46295500008476
						],
						[
							-81.33869299993378,
							28.464016000429766
						],
						[
							-81.33869299993378,
							28.46404099978364
						],
						[
							-81.33831100031128,
							28.46524799966422
						],
						[
							-81.3364910000525,
							28.46532200037742
						],
						[
							-81.33429200030942,
							28.465412000029417
						],
						[
							-81.33076000027368,
							28.46555600037209
						],
						[
							-81.33075299995096,
							28.462654999745617
						],
						[
							-81.33073399997444,
							28.462125999642165
						],
						[
							-81.33070200029802,
							28.460181999962614
						],
						[
							-81.33070000020584,
							28.460070000195735
						],
						[
							-81.33068599956049,
							28.459208000030706
						],
						[
							-81.33066899967613,
							28.45858900027517
						],
						[
							-81.33482191412402,
							28.45853189332631
						],
						[
							-81.33485132285378,
							28.45853148863145
						],
						[
							-81.33590500001948,
							28.45851699965424
						],
						[
							-81.33727400017317,
							28.45849799967771
						],
						[
							-81.33857399984419,
							28.458486000023903
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Crescent Park",
				"RegionID": "268943"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.15325171799992,
					26.09258487900007,
					-80.14201797599992,
					26.107473051000056
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.14505055799992,
							26.107473051000056
						],
						[
							-80.1442193229999,
							26.103019353000036
						],
						[
							-80.14361142099995,
							26.10026326700006
						],
						[
							-80.14270407599992,
							26.096439596000042
						],
						[
							-80.14265099799992,
							26.09621826700004
						],
						[
							-80.14256987599992,
							26.09550420900007
						],
						[
							-80.14241364399993,
							26.09459686200006
						],
						[
							-80.14228244999993,
							26.094057062000047
						],
						[
							-80.14220633799994,
							26.093660473000057
						],
						[
							-80.14201797599992,
							26.092768195000076
						],
						[
							-80.14678212299992,
							26.09258487900007
						],
						[
							-80.15285713899993,
							26.092609853000056
						],
						[
							-80.1529913309999,
							26.096273349000057
						],
						[
							-80.15299133199994,
							26.096321420000038
						],
						[
							-80.15303033799995,
							26.097156668000085
						],
						[
							-80.15303745299991,
							26.097181687000045
						],
						[
							-80.15306043399994,
							26.097983886000065
						],
						[
							-80.15306944699995,
							26.09810606600007
						],
						[
							-80.15309047999995,
							26.098812114000054
						],
						[
							-80.1531065019999,
							26.099023428000066
						],
						[
							-80.15313053799991,
							26.09963433300004
						],
						[
							-80.15314556099992,
							26.09995080300007
						],
						[
							-80.15315156999992,
							26.100537674000066
						],
						[
							-80.15316058299994,
							26.10088318600009
						],
						[
							-80.15316759399991,
							26.101754477000043
						],
						[
							-80.1531906269999,
							26.102437490000057
						],
						[
							-80.1532056499999,
							26.102727922000042
						],
						[
							-80.15320765199995,
							26.102848099000084
						],
						[
							-80.1532146639999,
							26.103312789000086
						],
						[
							-80.1532146639999,
							26.10365930300009
						],
						[
							-80.15322067299991,
							26.10420210700005
						],
						[
							-80.15322968599992,
							26.10455963700008
						],
						[
							-80.15323569499992,
							26.105083414000035
						],
						[
							-80.15324470799993,
							26.105484009000065
						],
						[
							-80.15325171799992,
							26.105986754000075
						],
						[
							-80.15322968699991,
							26.106230115000074
						],
						[
							-80.15323569399995,
							26.106424403000062
						],
						[
							-80.15322968599992,
							26.10653656900007
						],
						[
							-80.1532489299999,
							26.10733664600008
						],
						[
							-80.15294626499991,
							26.107354783000066
						],
						[
							-80.15122170699993,
							26.10739684500004
						],
						[
							-80.15079507399992,
							26.107406860000083
						],
						[
							-80.15013109099995,
							26.107415873000036
						],
						[
							-80.14916966399994,
							26.10743289900006
						],
						[
							-80.1481321249999,
							26.107440911000083
						],
						[
							-80.14755126499995,
							26.107453930000077
						],
						[
							-80.14714065599992,
							26.107449924000036
						],
						[
							-80.14608208599992,
							26.10744691900004
						],
						[
							-80.14528390099991,
							26.107458937000047
						],
						[
							-80.14505055799992,
							26.107473051000056
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Croissant Park",
				"RegionID": "268944"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.55248474399991,
					30.147833868000077,
					-81.49642877699995,
					30.190560022000057
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.49699968599994,
							30.19002882700005
						],
						[
							-81.49642877699995,
							30.174896112000056
						],
						[
							-81.49814182199992,
							30.167472542000045
						],
						[
							-81.50271022599992,
							30.161619409000078
						],
						[
							-81.50813511699994,
							30.156194518000067
						],
						[
							-81.51670072799993,
							30.15048411100008
						],
						[
							-81.52234557899993,
							30.147833868000077
						],
						[
							-81.52326769799993,
							30.14877098800008
						],
						[
							-81.5329753929999,
							30.15947800500004
						],
						[
							-81.54511001299994,
							30.171327105000046
						],
						[
							-81.55248474399991,
							30.17923460100008
						],
						[
							-81.55199489499996,
							30.17874082800006
						],
						[
							-81.55189690899994,
							30.178875012000052
						],
						[
							-81.5518389099999,
							30.178964011000062
						],
						[
							-81.55180285999995,
							30.17903299300008
						],
						[
							-81.55178490999992,
							30.179110011000034
						],
						[
							-81.55177590999995,
							30.179183011000077
						],
						[
							-81.55177590999995,
							30.17928301200004
						],
						[
							-81.55178090899996,
							30.179406011000086
						],
						[
							-81.55178090999993,
							30.179527012000054
						],
						[
							-81.55178190899994,
							30.17986201100007
						],
						[
							-81.55179690999995,
							30.180349011000086
						],
						[
							-81.55181890999995,
							30.181614011000075
						],
						[
							-81.55181990999995,
							30.18516201100005
						],
						[
							-81.5518369099999,
							30.18709401100006
						],
						[
							-81.55183090999992,
							30.187288011000074
						],
						[
							-81.55182490999994,
							30.187458011000047
						],
						[
							-81.55183290899993,
							30.18760001100009
						],
						[
							-81.55183990899991,
							30.188203012000084
						],
						[
							-81.55186390999995,
							30.189174012000084
						],
						[
							-81.55186690999994,
							30.190560022000057
						],
						[
							-81.49699968599994,
							30.19002882700005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Deercreek",
				"RegionID": "268945"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.35179297199994,
					28.51487800000007,
					-81.3392645109999,
					28.524173112000085
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-81.35147462999993,
								28.514878955000086
							],
							[
								-81.35155099999992,
								28.51487800000007
							],
							[
								-81.35179297199994,
								28.514889380000056
							],
							[
								-81.35178999999994,
								28.51588400000009
							],
							[
								-81.35178799999994,
								28.516680000000065
							],
							[
								-81.3516909999999,
								28.516680000000065
							],
							[
								-81.34882499999992,
								28.516681000000062
							],
							[
								-81.34879899999994,
								28.515787000000046
							],
							[
								-81.34880299999992,
								28.51578500000005
							],
							[
								-81.34880699999991,
								28.515783000000056
							],
							[
								-81.34911499999993,
								28.515780000000063
							],
							[
								-81.34911499999993,
								28.515379000000053
							],
							[
								-81.34911499999993,
								28.514880000000062
							],
							[
								-81.34959099999992,
								28.514880000000062
							],
							[
								-81.35139099999992,
								28.514880000000062
							],
							[
								-81.35147462999993,
								28.514878955000086
							]
						]
					],
					[
						[
							[
								-81.33928166599992,
								28.524173112000085
							],
							[
								-81.33927665999995,
								28.523666308000088
							],
							[
								-81.33926564299992,
								28.522481551000055
							],
							[
								-81.3392645109999,
								28.521914579000057
							],
							[
								-81.33952599999992,
								28.521911853000063
							],
							[
								-81.33952599999992,
								28.52218000000005
							],
							[
								-81.33954099999994,
								28.523945000000083
							],
							[
								-81.33976399999995,
								28.523945000000083
							],
							[
								-81.33976399999995,
								28.52373300000005
							],
							[
								-81.3400499999999,
								28.52373300000005
							],
							[
								-81.34013699999991,
								28.523736000000042
							],
							[
								-81.34013699999991,
								28.523945000000083
							],
							[
								-81.34049099999993,
								28.523945000000083
							],
							[
								-81.34048199999995,
								28.522192000000075
							],
							[
								-81.34108499999991,
								28.522195000000067
							],
							[
								-81.34109099999995,
								28.522380000000055
							],
							[
								-81.34109999999993,
								28.52302700000007
							],
							[
								-81.34145899999993,
								28.523029000000065
							],
							[
								-81.34158599999995,
								28.523035000000053
							],
							[
								-81.3433839999999,
								28.523060000000044
							],
							[
								-81.34351499999991,
								28.52306100000004
							],
							[
								-81.34352799999994,
								28.522378000000064
							],
							[
								-81.34352764899995,
								28.52223585900009
							],
							[
								-81.34352699999994,
								28.52197300000006
							],
							[
								-81.34352499999994,
								28.52147700000006
							],
							[
								-81.34352199999995,
								28.520570000000077
							],
							[
								-81.3435179999999,
								28.519584000000066
							],
							[
								-81.3435179999999,
								28.519475000000057
							],
							[
								-81.34352228699993,
								28.519300673000092
							],
							[
								-81.34352999999993,
								28.51898700000004
							],
							[
								-81.34352999999993,
								28.518852000000038
							],
							[
								-81.3473479999999,
								28.518852000000038
							],
							[
								-81.34735699999993,
								28.51898700000004
							],
							[
								-81.3473669999999,
								28.51948100000004
							],
							[
								-81.34738599999991,
								28.520274000000086
							],
							[
								-81.34739499999995,
								28.52045000000004
							],
							[
								-81.34742199999994,
								28.521458000000052
							],
							[
								-81.34742299999994,
								28.521978000000047
							],
							[
								-81.34749699999992,
								28.521978000000047
							],
							[
								-81.3475499999999,
								28.521978000000047
							],
							[
								-81.3475499999999,
								28.521779000000038
							],
							[
								-81.3475499999999,
								28.52152700000005
							],
							[
								-81.34754199999992,
								28.520456000000085
							],
							[
								-81.34754399999991,
								28.520331000000056
							],
							[
								-81.34810599999992,
								28.520330000000058
							],
							[
								-81.34881799999994,
								28.520331000000056
							],
							[
								-81.35017599999992,
								28.52036600000008
							],
							[
								-81.3501369999999,
								28.521783000000084
							],
							[
								-81.35012999999992,
								28.52378800000008
							],
							[
								-81.35001243799991,
								28.523791590000087
							],
							[
								-81.34960599999994,
								28.52380400000004
							],
							[
								-81.34876099999991,
								28.523830000000093
							],
							[
								-81.34806999999995,
								28.523851000000036
							],
							[
								-81.34749499999992,
								28.52386800000005
							],
							[
								-81.34707199999991,
								28.523874000000035
							],
							[
								-81.34675099999993,
								28.52387900000008
							],
							[
								-81.34614499999992,
								28.523881000000074
							],
							[
								-81.34586699999994,
								28.523881000000074
							],
							[
								-81.34545099999991,
								28.52388300000007
							],
							[
								-81.3453889999999,
								28.52388700000006
							],
							[
								-81.34424199999995,
								28.52388300000007
							],
							[
								-81.34417899999994,
								28.52388300000007
							],
							[
								-81.34408899999994,
								28.52388200000007
							],
							[
								-81.34391199999993,
								28.52388200000007
							],
							[
								-81.34391599999992,
								28.523779000000047
							],
							[
								-81.34391099999993,
								28.52369800000008
							],
							[
								-81.34391199999993,
								28.52357900000004
							],
							[
								-81.34352399999995,
								28.523581000000036
							],
							[
								-81.34352399999995,
								28.523700000000076
							],
							[
								-81.34352699999994,
								28.524023000000057
							],
							[
								-81.34352499999994,
								28.524049000000048
							],
							[
								-81.34352699999994,
								28.52414200000004
							],
							[
								-81.34339678499992,
								28.52413591700008
							],
							[
								-81.34179339199994,
								28.524148022000077
							],
							[
								-81.34137677399991,
								28.52415903800005
							],
							[
								-81.34052751399992,
								28.524160039000037
							],
							[
								-81.34019101599995,
								28.52416304400009
							],
							[
								-81.33983949299994,
								28.524167050000074
							],
							[
								-81.33928166599992,
								28.524173112000085
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Lake Terrace",
				"RegionID": "269052"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.34355700799995,
					28.530868990000045,
					-81.33112751899996,
					28.53847542500006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.3418673939999,
							28.53847542500006
						],
						[
							-81.34184055399993,
							28.53840400100006
						],
						[
							-81.34171721199993,
							28.538426379000043
						],
						[
							-81.3416922429999,
							28.538395152000078
						],
						[
							-81.3416322519999,
							28.538277819000086
						],
						[
							-81.34137376799993,
							28.538263957000083
						],
						[
							-81.33994399999995,
							28.538280000000043
						],
						[
							-81.33902963499992,
							28.538297259000046
						],
						[
							-81.33903352399994,
							28.538274413000067
						],
						[
							-81.33904168399994,
							28.538222733000055
						],
						[
							-81.33904320399995,
							28.53821342300006
						],
						[
							-81.33905720399991,
							28.53813042300004
						],
						[
							-81.33906195799995,
							28.53810455100006
						],
						[
							-81.33907532199993,
							28.538047238000047
						],
						[
							-81.33909240499992,
							28.537990922000063
						],
						[
							-81.33910087099991,
							28.537967087000084
						],
						[
							-81.33913687099994,
							28.537870087000048
						],
						[
							-81.3391491349999,
							28.537838844000078
						],
						[
							-81.33916785399992,
							28.537796737000065
						],
						[
							-81.33920685399994,
							28.537714736000055
						],
						[
							-81.33921242199995,
							28.53770324000004
						],
						[
							-81.33924016399993,
							28.537651339000035
						],
						[
							-81.33927124099995,
							28.53760136300008
						],
						[
							-81.33928012899992,
							28.537588311000036
						],
						[
							-81.33938212899994,
							28.537441312000055
						],
						[
							-81.33940751999995,
							28.537406528000076
						],
						[
							-81.33944485399991,
							28.53736103600005
						],
						[
							-81.33948508299994,
							28.53731808400005
						],
						[
							-81.33952803599993,
							28.53727785400008
						],
						[
							-81.3395735279999,
							28.53724052000007
						],
						[
							-81.33962136399992,
							28.537206241000035
						],
						[
							-81.33967133899995,
							28.537175165000065
						],
						[
							-81.3397232399999,
							28.537147423000082
						],
						[
							-81.33977684399991,
							28.53712313500006
						],
						[
							-81.3398319229999,
							28.53710240500004
						],
						[
							-81.33985275599991,
							28.537095615000055
						],
						[
							-81.33989385799993,
							28.537082771000087
						],
						[
							-81.33991437399993,
							28.537075137000045
						],
						[
							-81.33993892199993,
							28.537066405000076
						],
						[
							-81.33999523799991,
							28.537049322000087
						],
						[
							-81.34005255099993,
							28.537035959000036
						],
						[
							-81.34007841999994,
							28.537031205000062
						],
						[
							-81.34029756099994,
							28.53699424100006
						],
						[
							-81.3404535709999,
							28.536956985000074
						],
						[
							-81.34043555599993,
							28.536559328000067
						],
						[
							-81.34038802799995,
							28.536537920000058
						],
						[
							-81.33979545199992,
							28.53636214000005
						],
						[
							-81.33904209299993,
							28.536144753000087
						],
						[
							-81.33877273299993,
							28.536098165000055
						],
						[
							-81.33875055099992,
							28.53609404200006
						],
						[
							-81.33869414899993,
							28.536080922000053
						],
						[
							-81.3383138179999,
							28.535979439000073
						],
						[
							-81.3377985059999,
							28.535886362000042
						],
						[
							-81.33735944699993,
							28.535864718000088
						],
						[
							-81.33683067299995,
							28.535921994000034
						],
						[
							-81.33630082899992,
							28.536025247000055
						],
						[
							-81.33606642599996,
							28.536080827000035
						],
						[
							-81.33586835099993,
							28.53614685200006
						],
						[
							-81.33572592099995,
							28.53622454100008
						],
						[
							-81.33543640199991,
							28.536411539000085
						],
						[
							-81.33523897799995,
							28.53656708500006
						],
						[
							-81.33500353799991,
							28.536791682000057
						],
						[
							-81.33473754199993,
							28.537112027000035
						],
						[
							-81.33477738499994,
							28.53711637200007
						],
						[
							-81.33483544899991,
							28.537125958000047
						],
						[
							-81.33483768799994,
							28.537126407000073
						],
						[
							-81.3349637739999,
							28.537151820000076
						],
						[
							-81.33507385599997,
							28.53717325100007
						],
						[
							-81.33507744899993,
							28.53717395800004
						],
						[
							-81.33513476099995,
							28.537187321000093
						],
						[
							-81.33519107699993,
							28.53720440400008
						],
						[
							-81.33524615499994,
							28.53722513400004
						],
						[
							-81.33529975999994,
							28.53724942200006
						],
						[
							-81.33535166099995,
							28.537277164000045
						],
						[
							-81.33540163599992,
							28.537308241000062
						],
						[
							-81.33544947199994,
							28.53734251900005
						],
						[
							-81.3354949639999,
							28.53737985300006
						],
						[
							-81.33553791599991,
							28.537420083000086
						],
						[
							-81.33557814599993,
							28.537463035000087
						],
						[
							-81.33561547999994,
							28.537508527000057
						],
						[
							-81.3356260029999,
							28.537522521000085
						],
						[
							-81.33568200399992,
							28.537598522000053
						],
						[
							-81.33570575899995,
							28.537632364000046
						],
						[
							-81.33573683599991,
							28.53768233900007
						],
						[
							-81.3357645779999,
							28.537734240000077
						],
						[
							-81.33578886599992,
							28.537787845000082
						],
						[
							-81.33580959599995,
							28.537842923000085
						],
						[
							-81.33582667899992,
							28.53789923900007
						],
						[
							-81.3358360769999,
							28.53793767500008
						],
						[
							-81.33584664499995,
							28.53798543000005
						],
						[
							-81.3358529809999,
							28.538000999000076
						],
						[
							-81.3358715949999,
							28.53805092300007
						],
						[
							-81.33588867799995,
							28.538107238000066
						],
						[
							-81.33590204199993,
							28.53816455100008
						],
						[
							-81.3359116279999,
							28.538222615000056
						],
						[
							-81.3359173959999,
							28.53828118200005
						],
						[
							-81.33591932199994,
							28.538340000000062
						],
						[
							-81.3359187989999,
							28.538355978000084
						],
						[
							-81.33501699999995,
							28.538373000000036
						],
						[
							-81.33440843999995,
							28.53837512100006
						],
						[
							-81.33401886099995,
							28.538376123000035
						],
						[
							-81.33386363199992,
							28.538376123000035
						],
						[
							-81.3312016079999,
							28.538382179000052
						],
						[
							-81.3311686369999,
							28.538245928000038
						],
						[
							-81.33116362699992,
							28.53797552900005
						],
						[
							-81.33116562999993,
							28.537828310000066
						],
						[
							-81.33120568899994,
							28.53750483400006
						],
						[
							-81.3311736419999,
							28.537064178000037
						],
						[
							-81.33117464299994,
							28.53651436300004
						],
						[
							-81.33116462899994,
							28.535676118000083
						],
						[
							-81.33116362699992,
							28.534804826000084
						],
						[
							-81.33115261099994,
							28.533988616000045
						],
						[
							-81.33114560099995,
							28.53313234600006
						],
						[
							-81.33113758899992,
							28.532333162000043
						],
						[
							-81.33112751899996,
							28.531566007000038
						],
						[
							-81.33572839699991,
							28.530868990000045
						],
						[
							-81.33923760099994,
							28.530906044000062
						],
						[
							-81.3434769779999,
							28.53098213900006
						],
						[
							-81.34348790399991,
							28.531949592000046
						],
						[
							-81.34350392899995,
							28.532809868000072
						],
						[
							-81.34351093899994,
							28.53355397200005
						],
						[
							-81.34351194099992,
							28.53374826000004
						],
						[
							-81.34351494499992,
							28.534303082000065
						],
						[
							-81.34351694799994,
							28.53463457500004
						],
						[
							-81.34352495999991,
							28.53509325400006
						],
						[
							-81.34353196899991,
							28.535483833000058
						],
						[
							-81.34353697799992,
							28.536801789000037
						],
						[
							-81.34353397299992,
							28.537035134000064
						],
						[
							-81.34355300199991,
							28.53751484500009
						],
						[
							-81.34355500499993,
							28.537972524000054
						],
						[
							-81.34355600599991,
							28.53825093800009
						],
						[
							-81.3435570069999,
							28.538342072000034
						],
						[
							-81.34355700799995,
							28.53846224900008
						],
						[
							-81.3418673939999,
							28.53847542500006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Lake Underhill",
				"RegionID": "269053"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.34347697764288,
					28.524135917308186,
					-81.330943300989,
					28.53156600709624
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.33112557108126,
							28.531478894267913
						],
						[
							-81.3311135525417,
							28.530682713683518
						],
						[
							-81.331100533956,
							28.529848476488816
						],
						[
							-81.33109552563158,
							28.529583082061315
						],
						[
							-81.33108450983602,
							28.52900322259918
						],
						[
							-81.3310724921957,
							28.528161975189313
						],
						[
							-81.33106848571612,
							28.52794365127685
						],
						[
							-81.33106147550095,
							28.52733074262946
						],
						[
							-81.33105146065076,
							28.526531557410216
						],
						[
							-81.3310364383756,
							28.525679293305323
						],
						[
							-81.33103560020749,
							28.52560011609458
						],
						[
							-81.3309591605329,
							28.525507096519075
						],
						[
							-81.33095231399427,
							28.525006294657935
						],
						[
							-81.330943300989,
							28.52432628669467
						],
						[
							-81.33094530108117,
							28.524255126939778
						],
						[
							-81.33101841236487,
							28.524255180899104
						],
						[
							-81.33109252189603,
							28.524255180899104
						],
						[
							-81.33185164681547,
							28.52425017347405
						],
						[
							-81.33249760554747,
							28.524244164204255
						],
						[
							-81.33299634526323,
							28.524238154934466
						],
						[
							-81.33393273374926,
							28.524225136348697
						],
						[
							-81.3348611101754,
							28.524214120553225
						],
						[
							-81.3351956067089,
							28.52420911222889
						],
						[
							-81.3358085153563,
							28.524201100168895
						],
						[
							-81.33672287135201,
							28.524196092743843
						],
						[
							-81.33770132202866,
							28.52419008437333
						],
						[
							-81.33787658280504,
							28.52418708063776
						],
						[
							-81.33833526312029,
							28.52418307415808
						],
						[
							-81.33844442462687,
							28.524182072313337
						],
						[
							-81.33858763716337,
							28.524179068577766
						],
						[
							-81.33928166645651,
							28.524173112368018
						],
						[
							-81.33983949342816,
							28.52416705003818
						],
						[
							-81.34019101592646,
							28.52416304445787
						],
						[
							-81.34052751435078,
							28.524160038923647
						],
						[
							-81.34137677382064,
							28.524159037978187
						],
						[
							-81.34179339194536,
							28.524148022182715
						],
						[
							-81.34339678509747,
							28.524135917308186
						],
						[
							-81.34339576796425,
							28.524229141929098
						],
						[
							-81.343379745643,
							28.52513849139896
						],
						[
							-81.34339476611952,
							28.52547799445822
						],
						[
							-81.34339476701888,
							28.526433411699188
						],
						[
							-81.34339777075445,
							28.52735277422059
						],
						[
							-81.34341379487435,
							28.5282531097858
						],
						[
							-81.34342781620414,
							28.529114386895973
						],
						[
							-81.34343182178436,
							28.529171472261027
						],
						[
							-81.34345986264528,
							28.53005878834128
						],
						[
							-81.34347697764288,
							28.530982139355864
						],
						[
							-81.3392376014757,
							28.53090604412175
						],
						[
							-81.33572839655535,
							28.530868990255463
						],
						[
							-81.33112751901277,
							28.53156600709624
						],
						[
							-81.33112557108126,
							28.531478894267913
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Dover Shores West",
				"RegionID": "268958"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.46538170799994,
					27.943300002000058,
					-82.44551831299992,
					27.96440006200004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.44551831299992,
							27.956381927000052
						],
						[
							-82.44915449799993,
							27.954045330000042
						],
						[
							-82.44926478699995,
							27.954020297000056
						],
						[
							-82.4493272709999,
							27.953936363000082
						],
						[
							-82.44946363399993,
							27.953718182000046
						],
						[
							-82.44951813599994,
							27.95356361000006
						],
						[
							-82.45042734999993,
							27.952300034000075
						],
						[
							-82.45059987199994,
							27.95148177200008
						],
						[
							-82.45089103299995,
							27.95103640900004
						],
						[
							-82.45105441899995,
							27.950290862000088
						],
						[
							-82.45126371299995,
							27.949981840000078
						],
						[
							-82.45129090899991,
							27.94861818600009
						],
						[
							-82.45153636499992,
							27.94758182000004
						],
						[
							-82.45185462599994,
							27.946827281000083
						],
						[
							-82.45179999899995,
							27.94642727300004
						],
						[
							-82.45180074399991,
							27.94634214200005
						],
						[
							-82.45221828299992,
							27.946027361000063
						],
						[
							-82.45276363399995,
							27.945163639000043
						],
						[
							-82.45346363499993,
							27.94446363600008
						],
						[
							-82.45363711499994,
							27.944290158000058
						],
						[
							-82.4538124199999,
							27.94411467300006
						],
						[
							-82.45411818199995,
							27.944000001000063
						],
						[
							-82.4579181819999,
							27.943300002000058
						],
						[
							-82.4585009999999,
							27.943317000000036
						],
						[
							-82.45894832199991,
							27.943330046000085
						],
						[
							-82.45899540599994,
							27.943659641000067
						],
						[
							-82.4590907239999,
							27.944350696000072
						],
						[
							-82.45918604199994,
							27.94468430900008
						],
						[
							-82.45932901899994,
							27.945017922000094
						],
						[
							-82.45954348499993,
							27.945351534000054
						],
						[
							-82.4598532679999,
							27.945661318000077
						],
						[
							-82.46040134599991,
							27.94611407800005
						],
						[
							-82.4609732539999,
							27.946685985000045
						],
						[
							-82.46204557999994,
							27.947567676000062
						],
						[
							-82.46280812399993,
							27.948306390000084
						],
						[
							-82.46338003099993,
							27.948759150000058
						],
						[
							-82.46404725699995,
							27.949235740000063
						],
						[
							-82.46454767599994,
							27.949712330000068
						],
						[
							-82.46485745899992,
							27.95016509000004
						],
						[
							-82.46503574099995,
							27.950561272000073
						],
						[
							-82.4650719249999,
							27.950641680000047
						],
						[
							-82.46523873099994,
							27.951237417000073
						],
						[
							-82.46538170799994,
							27.951904642000045
						],
						[
							-82.4652863899999,
							27.952667186000042
						],
						[
							-82.4650719249999,
							27.953620365000063
						],
						[
							-82.46469065299995,
							27.95531225800005
						],
						[
							-82.46440469899996,
							27.95664670900004
						],
						[
							-82.4644017139999,
							27.956661636000035
						],
						[
							-82.46398351699992,
							27.956708415000037
						],
						[
							-82.4621890219999,
							27.956912612000057
						],
						[
							-82.46101244899995,
							27.957046148000074
						],
						[
							-82.46091825399992,
							27.957191083000055
						],
						[
							-82.46016363199993,
							27.957000002000086
						],
						[
							-82.45801818199993,
							27.95700000000005
						],
						[
							-82.45713611499991,
							27.95699982700006
						],
						[
							-82.45481814199991,
							27.959199966000085
						],
						[
							-82.45391818299993,
							27.960800000000063
						],
						[
							-82.45361827799991,
							27.961700059000066
						],
						[
							-82.45291817899994,
							27.962700001000087
						],
						[
							-82.45112738699993,
							27.96440006200004
						],
						[
							-82.4511274059999,
							27.95667220100006
						],
						[
							-82.45024428399995,
							27.956672204000085
						],
						[
							-82.4497198059999,
							27.956878890000045
						],
						[
							-82.4491383909999,
							27.956240731000037
						],
						[
							-82.44551831299992,
							27.956381927000052
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Downtown",
				"RegionID": "268959"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.2069255269999,
					25.76869328300006,
					-80.18240419099993,
					25.79260000000005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.19072999999992,
							25.792440213000077
						],
						[
							-80.19072999999992,
							25.792290000000037
						],
						[
							-80.19045321599992,
							25.79229643700006
						],
						[
							-80.19019700599995,
							25.792302395000036
						],
						[
							-80.19000222999995,
							25.792306925000048
						],
						[
							-80.18986999999993,
							25.792310000000043
						],
						[
							-80.18969830599991,
							25.792315660000042
						],
						[
							-80.18933329999994,
							25.79232769300006
						],
						[
							-80.18911349399991,
							25.792334940000046
						],
						[
							-80.18895999999995,
							25.79234000000008
						],
						[
							-80.18872366599993,
							25.792345908000073
						],
						[
							-80.18840718099995,
							25.792353820000073
						],
						[
							-80.18815999999993,
							25.792360000000087
						],
						[
							-80.18801714199992,
							25.792360000000087
						],
						[
							-80.18788071999995,
							25.792383123000036
						],
						[
							-80.18779886999994,
							25.792406996000068
						],
						[
							-80.1877199999999,
							25.79243000000008
						],
						[
							-80.1876105209999,
							25.792356028000086
						],
						[
							-80.18745095799994,
							25.792248215000086
						],
						[
							-80.18715826499995,
							25.792064959000072
						],
						[
							-80.18709999999993,
							25.792030000000068
						],
						[
							-80.18699598199993,
							25.79210201300009
						],
						[
							-80.18688767599991,
							25.792176993000055
						],
						[
							-80.18682017099991,
							25.792229829000064
						],
						[
							-80.18674099999993,
							25.792309000000046
						],
						[
							-80.18528917599991,
							25.792351385000075
						],
						[
							-80.18438806099994,
							25.792377693000052
						],
						[
							-80.18439640799994,
							25.792170771000087
						],
						[
							-80.1844603589999,
							25.790583817000083
						],
						[
							-80.18444481799992,
							25.78970286300006
						],
						[
							-80.18444557999993,
							25.78964671700004
						],
						[
							-80.18455458099993,
							25.787215717000038
						],
						[
							-80.18455688099993,
							25.78718017400007
						],
						[
							-80.18457390299994,
							25.786979005000035
						],
						[
							-80.18456673299994,
							25.78682551600008
						],
						[
							-80.18450280699994,
							25.785551051000084
						],
						[
							-80.18449973399993,
							25.785488462000046
						],
						[
							-80.18450291199991,
							25.78542587900006
						],
						[
							-80.1845123089999,
							25.78536392400008
						],
						[
							-80.1845278319999,
							25.785303214000066
						],
						[
							-80.18449287899995,
							25.78523233700008
						],
						[
							-80.18446449999993,
							25.785158581000076
						],
						[
							-80.18444292899994,
							25.785082555000088
						],
						[
							-80.18442834499992,
							25.785004885000035
						],
						[
							-80.18442086599993,
							25.784926213000062
						],
						[
							-80.18439786599993,
							25.784479213000054
						],
						[
							-80.18439667799993,
							25.784433000000035
						],
						[
							-80.18439667799993,
							25.784275000000036
						],
						[
							-80.18441034099993,
							25.784118834000086
						],
						[
							-80.18443682299994,
							25.784020000000055
						],
						[
							-80.18441034099993,
							25.783921165000038
						],
						[
							-80.18439675799993,
							25.783777008000072
						],
						[
							-80.18438771799994,
							25.78309700400007
						],
						[
							-80.1843888919999,
							25.783026695000046
						],
						[
							-80.18439616499995,
							25.782956752000075
						],
						[
							-80.18440948099993,
							25.782887705000064
						],
						[
							-80.18442874099992,
							25.782820074000085
						],
						[
							-80.18445379799994,
							25.782754370000077
						],
						[
							-80.18448446399992,
							25.78269109000007
						],
						[
							-80.18445191799992,
							25.78262942400005
						],
						[
							-80.18442424999995,
							25.782565421000072
						],
						[
							-80.18440162799993,
							25.78249946600005
						],
						[
							-80.18438418599993,
							25.78243195500005
						],
						[
							-80.18437203099995,
							25.782363296000085
						],
						[
							-80.18436523499992,
							25.78229390100006
						],
						[
							-80.18429723499992,
							25.781139901000074
						],
						[
							-80.18429635699994,
							25.781052053000053
						],
						[
							-80.18431645099993,
							25.780535358000066
						],
						[
							-80.1843157159999,
							25.780475839000076
						],
						[
							-80.1843156779999,
							25.780384513000058
						],
						[
							-80.1843147969999,
							25.780271751000043
						],
						[
							-80.18430826499991,
							25.780079079000075
						],
						[
							-80.18429555499995,
							25.77995753600004
						],
						[
							-80.18429067799991,
							25.77986400000009
						],
						[
							-80.1842944839999,
							25.779820490000077
						],
						[
							-80.18415909899994,
							25.779909771000064
						],
						[
							-80.18411366099991,
							25.779937835000055
						],
						[
							-80.18397158599993,
							25.780004086000076
						],
						[
							-80.18382016499993,
							25.780044659000055
						],
						[
							-80.18366399999991,
							25.78005832200006
						],
						[
							-80.18363843899994,
							25.780057958000043
						],
						[
							-80.18342743999995,
							25.780051959000048
						],
						[
							-80.18335229799993,
							25.78004666700008
						],
						[
							-80.18327786299994,
							25.780035104000035
						],
						[
							-80.18320465599993,
							25.780017353000062
						],
						[
							-80.1831331919999,
							25.779993538000042
						],
						[
							-80.1830639719999,
							25.77996382500004
						],
						[
							-80.18299748099992,
							25.779928424000047
						],
						[
							-80.18293418499991,
							25.77988758300006
						],
						[
							-80.18287452999994,
							25.779841588000068
						],
						[
							-80.1827231339999,
							25.779714254000055
						],
						[
							-80.1826130789999,
							25.779604073000087
						],
						[
							-80.18252316399992,
							25.77947566100005
						],
						[
							-80.18245691399994,
							25.779333586000064
						],
						[
							-80.18241634099991,
							25.779182165000066
						],
						[
							-80.18241150799992,
							25.779151716000058
						],
						[
							-80.18240419099993,
							25.77909988400006
						],
						[
							-80.18254492999995,
							25.778547827000068
						],
						[
							-80.18273456999992,
							25.777860518000068
						],
						[
							-80.1832593179999,
							25.77688493700009
						],
						[
							-80.1835952159999,
							25.77624129700007
						],
						[
							-80.18387903999991,
							25.775646161000054
						],
						[
							-80.18413157099992,
							25.77513533700005
						],
						[
							-80.18407466999992,
							25.77428182200009
						],
						[
							-80.18407276999994,
							25.774209117000055
						],
						[
							-80.1840767509999,
							25.77413649600004
						],
						[
							-80.1840865879999,
							25.77406443500007
						],
						[
							-80.18410221599993,
							25.773993404000066
						],
						[
							-80.18412353199994,
							25.773923868000054
						],
						[
							-80.18415039699994,
							25.773856282000054
						],
						[
							-80.1842198949999,
							25.77370015200006
						],
						[
							-80.1841963299999,
							25.77364511400009
						],
						[
							-80.18412739299993,
							25.773484262000068
						],
						[
							-80.18410102699994,
							25.773414999000067
						],
						[
							-80.18408045799993,
							25.773343800000077
						],
						[
							-80.18406582499995,
							25.77327114700006
						],
						[
							-80.18405722799992,
							25.773197536000055
						],
						[
							-80.1840547249999,
							25.77312346700006
						],
						[
							-80.18406060799994,
							25.772715290000068
						],
						[
							-80.1840487039999,
							25.77160282200009
						],
						[
							-80.1840623409999,
							25.771441834000086
						],
						[
							-80.18410291399994,
							25.771290414000077
						],
						[
							-80.1841691649999,
							25.771148339000035
						],
						[
							-80.18425907999995,
							25.771019927000054
						],
						[
							-80.18436992699992,
							25.770909079000035
						],
						[
							-80.1844983389999,
							25.770819164000045
						],
						[
							-80.18464901399994,
							25.770749882000075
						],
						[
							-80.18575567499994,
							25.77037225800007
						],
						[
							-80.18727192299991,
							25.77011021700008
						],
						[
							-80.18840163999994,
							25.770033626000043
						],
						[
							-80.18876544699992,
							25.76997618300004
						],
						[
							-80.18914840199996,
							25.769899592000062
						],
						[
							-80.18995260799994,
							25.769823001000077
						],
						[
							-80.19046959699995,
							25.769918739000047
						],
						[
							-80.19156101899995,
							25.77024425100007
						],
						[
							-80.19194397399991,
							25.770339990000082
						],
						[
							-80.19255670199993,
							25.77024425100007
						],
						[
							-80.1929970999999,
							25.770052774000078
						],
						[
							-80.1933417599999,
							25.76980385300004
						],
						[
							-80.19370556699994,
							25.769516637000038
						],
						[
							-80.19399278299994,
							25.76924856800008
						],
						[
							-80.1943757379999,
							25.76901879500008
						],
						[
							-80.19473954499995,
							25.76886561300006
						],
						[
							-80.19533312599994,
							25.768769874000043
						],
						[
							-80.19577352399995,
							25.76869328300006
						],
						[
							-80.19627136499992,
							25.76869328300006
						],
						[
							-80.1968075019999,
							25.76869328300006
						],
						[
							-80.19728619599994,
							25.76873157900008
						],
						[
							-80.19759255999992,
							25.76886561300006
						],
						[
							-80.1978989239999,
							25.769076238000082
						],
						[
							-80.19820528799994,
							25.76934430700004
						],
						[
							-80.19851165199992,
							25.769669819000057
						],
						[
							-80.19879886799993,
							25.770014478000064
						],
						[
							-80.19895204999995,
							25.77037828500005
						],
						[
							-80.1993924489999,
							25.770799536000084
						],
						[
							-80.1996796649999,
							25.770933570000068
						],
						[
							-80.19971893299993,
							25.770977747000074
						],
						[
							-80.19983284699993,
							25.771105900000066
						],
						[
							-80.20004347199995,
							25.771603741000035
						],
						[
							-80.20013921099991,
							25.771833514000036
						],
						[
							-80.20015835899994,
							25.772350504000087
						],
						[
							-80.20027324499996,
							25.77267601600005
						],
						[
							-80.20044557499995,
							25.77292493600004
						],
						[
							-80.20063705199993,
							25.77313556200005
						],
						[
							-80.20088597299991,
							25.773575960000073
						],
						[
							-80.20132637099994,
							25.774226983000062
						],
						[
							-80.20186250799992,
							25.774763120000046
						],
						[
							-80.20247523699993,
							25.775394996000045
						],
						[
							-80.20293478299993,
							25.77581624700008
						],
						[
							-80.2033177379999,
							25.776026872000045
						],
						[
							-80.20381557899992,
							25.776735339000084
						],
						[
							-80.20414109099994,
							25.77717573700005
						],
						[
							-80.20439001199992,
							25.77730977100009
						],
						[
							-80.20527080799991,
							25.777520396000057
						],
						[
							-80.20569205899994,
							25.77765443100009
						],
						[
							-80.20643882099995,
							25.778075681000075
						],
						[
							-80.20682177599991,
							25.778228863000038
						],
						[
							-80.2069255269999,
							25.778319646000057
						],
						[
							-80.20681480899994,
							25.778406646000064
						],
						[
							-80.20670741499993,
							25.77849103400007
						],
						[
							-80.20654841999993,
							25.77854473700006
						],
						[
							-80.20645964499994,
							25.778566071000057
						],
						[
							-80.20638999999994,
							25.77858000000009
						],
						[
							-80.20628554799993,
							25.778590405000045
						],
						[
							-80.20619228499993,
							25.778598883000086
						],
						[
							-80.20604999999995,
							25.77861000000007
						],
						[
							-80.20583111299993,
							25.77861422400008
						],
						[
							-80.20559577499995,
							25.77862090000008
						],
						[
							-80.20526692399994,
							25.778630229000044
						],
						[
							-80.20504724599994,
							25.778636461000076
						],
						[
							-80.20481235199992,
							25.778643125000087
						],
						[
							-80.20456999999993,
							25.778650000000084
						],
						[
							-80.20438864699992,
							25.77865539700008
						],
						[
							-80.2040911389999,
							25.778664252000056
						],
						[
							-80.20382494799992,
							25.778672174000064
						],
						[
							-80.20355875699994,
							25.778680097000063
						],
						[
							-80.2032607829999,
							25.77868896500007
						],
						[
							-80.20310373399991,
							25.77869363900004
						],
						[
							-80.20288999999991,
							25.77870000000007
						],
						[
							-80.20269653999993,
							25.778704606000076
						],
						[
							-80.2023206209999,
							25.77871355700006
						],
						[
							-80.2019137559999,
							25.778724924000073
						],
						[
							-80.2016308929999,
							25.778735148000067
						],
						[
							-80.20136481399993,
							25.778744766000045
						],
						[
							-80.20121999999992,
							25.77875000000006
						],
						[
							-80.20091057999991,
							25.778758675000063
						],
						[
							-80.20072134399993,
							25.778763981000054
						],
						[
							-80.20047210399993,
							25.77877096900005
						],
						[
							-80.2003146269999,
							25.778775384000085
						],
						[
							-80.2000320969999,
							25.77878000000004
						],
						[
							-80.1998273289999,
							25.778782872000082
						],
						[
							-80.19963999899994,
							25.778785500000083
						],
						[
							-80.19940529899992,
							25.778794332000075
						],
						[
							-80.19899818699992,
							25.778806521000035
						],
						[
							-80.19876284599991,
							25.778813567000043
						],
						[
							-80.19835526599991,
							25.778825770000083
						],
						[
							-80.1980738879999,
							25.77883419500006
						],
						[
							-80.19787999999994,
							25.77884000000006
						],
						[
							-80.19775978799993,
							25.778843606000066
						],
						[
							-80.19754057499995,
							25.77885018300009
						],
						[
							-80.19727438699994,
							25.778858168000056
						],
						[
							-80.19707036199992,
							25.77886428900007
						],
						[
							-80.19689812299993,
							25.778869456000052
						],
						[
							-80.19680999999991,
							25.77887000000004
						],
						[
							-80.1966953669999,
							25.77887716500004
						],
						[
							-80.19650803299993,
							25.778888873000085
						],
						[
							-80.19630385399995,
							25.778897446000087
						],
						[
							-80.19618865399991,
							25.778901083000054
						],
						[
							-80.19619843899994,
							25.77924353900005
						],
						[
							-80.19622683499995,
							25.78035099300007
						],
						[
							-80.19629782599992,
							25.78218255200005
						],
						[
							-80.19618424099991,
							25.78370175300006
						],
						[
							-80.19624103299994,
							25.785263548000046
						],
						[
							-80.1962836269999,
							25.786229021000054
						],
						[
							-80.19631202399995,
							25.786583974000052
						],
						[
							-80.19631202399995,
							25.787068523000073
						],
						[
							-80.19631202399995,
							25.787336475000075
						],
						[
							-80.19627268099993,
							25.78799114700007
						],
						[
							-80.19614407399992,
							25.788669909000077
						],
						[
							-80.19593687199995,
							25.789584452000042
						],
						[
							-80.19569394699994,
							25.79065618200008
						],
						[
							-80.19547135999994,
							25.79162414600006
						],
						[
							-80.19533999999993,
							25.79162000000008
						],
						[
							-80.19517907099993,
							25.791625191000037
						],
						[
							-80.19502050199992,
							25.79163030600006
						],
						[
							-80.19488705299995,
							25.791634611000063
						],
						[
							-80.1947199999999,
							25.791640000000086
						],
						[
							-80.19473664899994,
							25.791781514000036
						],
						[
							-80.19474207499991,
							25.791879519000076
						],
						[
							-80.19474682999993,
							25.792038809000076
						],
						[
							-80.19475227899994,
							25.792221348000055
						],
						[
							-80.19475663799994,
							25.792367379000044
						],
						[
							-80.19475999999992,
							25.79248000000007
						],
						[
							-80.19455777299993,
							25.79248252800005
						],
						[
							-80.19420460499992,
							25.79248694200004
						],
						[
							-80.19395999999995,
							25.792490000000043
						],
						[
							-80.19380249099993,
							25.792495625000072
						],
						[
							-80.19351054099991,
							25.79250605200008
						],
						[
							-80.19331605999992,
							25.792513815000063
						],
						[
							-80.19317999999993,
							25.79252000000008
						],
						[
							-80.1930475019999,
							25.792524969000056
						],
						[
							-80.19282856799992,
							25.79253317900009
						],
						[
							-80.19260963399995,
							25.792541389000064
						],
						[
							-80.1924866359999,
							25.792546001000062
						],
						[
							-80.1923799999999,
							25.792550000000062
						],
						[
							-80.19223155599992,
							25.792553806000058
						],
						[
							-80.19207269499992,
							25.792557880000064
						],
						[
							-80.19184142499995,
							25.792563810000047
						],
						[
							-80.19170753199995,
							25.792567243000065
						],
						[
							-80.19159999999994,
							25.79257000000007
						],
						[
							-80.19141546299994,
							25.79257636300008
						],
						[
							-80.19129296799991,
							25.79258058700009
						],
						[
							-80.19108615199991,
							25.79258771900004
						],
						[
							-80.19087933599991,
							25.792594850000057
						],
						[
							-80.19072999999992,
							25.79260000000005
						],
						[
							-80.19072999999992,
							25.792440213000077
						]
					],
					[
						[
							-80.1850963569999,
							25.778951244000044
						],
						[
							-80.18516199099992,
							25.77894388500005
						],
						[
							-80.18522799999994,
							25.77894167800008
						],
						[
							-80.18534099999994,
							25.77894167800008
						],
						[
							-80.18541442799994,
							25.778944667000076
						],
						[
							-80.18540757199992,
							25.778541317000077
						],
						[
							-80.18524271599995,
							25.778475278000087
						],
						[
							-80.1851106609999,
							25.77856883600009
						],
						[
							-80.1850490569999,
							25.778597563000062
						],
						[
							-80.18484550999995,
							25.779030841000065
						],
						[
							-80.18490568999994,
							25.77900363200007
						],
						[
							-80.1849678129999,
							25.77898121000004
						],
						[
							-80.18503149899993,
							25.778963711000074
						],
						[
							-80.1850963569999,
							25.778951244000044
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami",
				"Name": "Downtown",
				"RegionID": "268962"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.08911077999994,
					26.745248641000046,
					-80.08128738099992,
					26.755480317000035
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.08205231599993,
							26.749493597000082
						],
						[
							-80.08128738099992,
							26.748668027000065
						],
						[
							-80.08365711999994,
							26.746842359000084
						],
						[
							-80.08320579399992,
							26.74648108300005
						],
						[
							-80.08310883799993,
							26.746403473000044
						],
						[
							-80.08245054499992,
							26.74577729100008
						],
						[
							-80.0824791949999,
							26.745760534000055
						],
						[
							-80.08268019799993,
							26.74557733200004
						],
						[
							-80.08269303599991,
							26.745565854000066
						],
						[
							-80.08273852799994,
							26.74552852000005
						],
						[
							-80.08278636399992,
							26.745494241000074
						],
						[
							-80.08283633899993,
							26.745463165000047
						],
						[
							-80.0828762619999,
							26.745441441000082
						],
						[
							-80.08300326199992,
							26.74537644100008
						],
						[
							-80.08301523999995,
							26.745370423000054
						],
						[
							-80.08306884399991,
							26.74534613500009
						],
						[
							-80.08312392199991,
							26.745325405000074
						],
						[
							-80.0831349639999,
							26.74532173600005
						],
						[
							-80.08328895999995,
							26.745271674000037
						],
						[
							-80.08332165599995,
							26.745248641000046
						],
						[
							-80.08396681699992,
							26.745894216000067
						],
						[
							-80.08431553299994,
							26.746255847000043
						],
						[
							-80.08542851899996,
							26.74738429100006
						],
						[
							-80.08660333799992,
							26.748574568000038
						],
						[
							-80.08728349599994,
							26.749100145000057
						],
						[
							-80.0879636539999,
							26.74937839100005
						],
						[
							-80.08867472899993,
							26.749471140000082
						],
						[
							-80.0888911429999,
							26.749471140000082
						],
						[
							-80.08911077999994,
							26.749517627000046
						],
						[
							-80.08909974399995,
							26.74968700900007
						],
						[
							-80.08908123999993,
							26.749952229000087
						],
						[
							-80.08907812899992,
							26.74999682100008
						],
						[
							-80.08905988399994,
							26.75025833600006
						],
						[
							-80.08904999999993,
							26.75040000000007
						],
						[
							-80.08903616599991,
							26.750614426000084
						],
						[
							-80.08900617899991,
							26.751079227000048
						],
						[
							-80.0889753909999,
							26.751556443000084
						],
						[
							-80.08894434599995,
							26.752037632000054
						],
						[
							-80.08890999999994,
							26.752578226000082
						],
						[
							-80.08886696699994,
							26.75300971300004
						],
						[
							-80.08879465199993,
							26.753388673000075
						],
						[
							-80.08866072299992,
							26.75388274000005
						],
						[
							-80.08853089799993,
							26.75422384500007
						],
						[
							-80.08835947599994,
							26.754568943000038
						],
						[
							-80.08818171199994,
							26.754877432000058
						],
						[
							-80.08800035799993,
							26.75514228500009
						],
						[
							-80.08785380299992,
							26.75535082500005
						],
						[
							-80.0877530869999,
							26.755480317000035
						],
						[
							-80.08728349599994,
							26.754896948000066
						],
						[
							-80.08641783999991,
							26.754154957000083
						],
						[
							-80.08562947499992,
							26.753722129000042
						],
						[
							-80.08490294299992,
							26.753258385000038
						],
						[
							-80.08399481599992,
							26.753011893000064
						],
						[
							-80.08382087299992,
							26.752964680000048
						],
						[
							-80.0836326829999,
							26.752528083000072
						],
						[
							-80.08376288199992,
							26.752399152000066
						],
						[
							-80.08380748299993,
							26.752323364000063
						],
						[
							-80.0838599999999,
							26.752230000000054
						],
						[
							-80.0839774719999,
							26.752022878000048
						],
						[
							-80.08410796399994,
							26.75179280100008
						],
						[
							-80.08423999999991,
							26.75156000000004
						],
						[
							-80.0841123539999,
							26.75148445500008
						],
						[
							-80.08392965099995,
							26.751376324000034
						],
						[
							-80.08373387299991,
							26.751257098000053
						],
						[
							-80.0835774059999,
							26.751131925000042
						],
						[
							-80.08345792799992,
							26.751010630000053
						],
						[
							-80.08333087799991,
							26.75087350800004
						],
						[
							-80.08318240499995,
							26.750713267000037
						],
						[
							-80.08298882499992,
							26.750504342000056
						],
						[
							-80.08281836499992,
							26.750320369000065
						],
						[
							-80.08246817499992,
							26.74994242100007
						],
						[
							-80.08216338799991,
							26.749613473000068
						],
						[
							-80.08205231599993,
							26.749493597000082
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "West Palm Beach",
				"Name": "Echo Lake",
				"RegionID": "268975"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.6981053689999,
					27.708761678000087,
					-82.67854999999992,
					27.71905000000004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.67854999999992,
							27.71905000000004
						],
						[
							-82.6786444089999,
							27.718743172000075
						],
						[
							-82.67873934499994,
							27.718458267000074
						],
						[
							-82.67890471099992,
							27.71796365000006
						],
						[
							-82.67909716199995,
							27.71731284400005
						],
						[
							-82.67924688199992,
							27.716615953000087
						],
						[
							-82.67926769299993,
							27.716331522000075
						],
						[
							-82.67929873599992,
							27.715918226000042
						],
						[
							-82.67933397999991,
							27.715020864000053
						],
						[
							-82.6793199999999,
							27.713926877000063
						],
						[
							-82.67998199999994,
							27.713782000000037
						],
						[
							-82.68020344799993,
							27.713545517000057
						],
						[
							-82.68030015599993,
							27.713492767000048
						],
						[
							-82.68069578099994,
							27.71356310100009
						],
						[
							-82.68128482199995,
							27.713659809000035
						],
						[
							-82.6815309879999,
							27.71367739200008
						],
						[
							-82.68175957199992,
							27.71367739200008
						],
						[
							-82.68196177999995,
							27.713642226000047
						],
						[
							-82.68215519599994,
							27.71351035100008
						],
						[
							-82.68251565399993,
							27.713246601000037
						],
						[
							-82.68287611199992,
							27.71289493400008
						],
						[
							-82.6833860289999,
							27.712428976000073
						],
						[
							-82.68365856999992,
							27.71218281000006
						],
						[
							-82.68407177799992,
							27.71201576800007
						],
						[
							-82.68444102799992,
							27.711804769000082
						],
						[
							-82.68470477799991,
							27.711567394000046
						],
						[
							-82.68495094399992,
							27.711303644000054
						],
						[
							-82.6851883189999,
							27.710995936000074
						],
						[
							-82.68532019399993,
							27.710679436000078
						],
						[
							-82.68541690199993,
							27.71032777000005
						],
						[
							-82.68545206899995,
							27.710072812000078
						],
						[
							-82.68549146999993,
							27.709708215000035
						],
						[
							-82.68554008899991,
							27.709665812000082
						],
						[
							-82.68559736299994,
							27.709615324000083
						],
						[
							-82.68564642599995,
							27.70957506600007
						],
						[
							-82.68569820599993,
							27.70953836900009
						],
						[
							-82.68575244499993,
							27.70950541600007
						],
						[
							-82.68580887399992,
							27.709476369000072
						],
						[
							-82.68620387399994,
							27.709290370000076
						],
						[
							-82.68625334199993,
							27.70926886400008
						],
						[
							-82.6870943429999,
							27.708932864000076
						],
						[
							-82.68722789499992,
							27.70889122300008
						],
						[
							-82.68756089499993,
							27.708815223000045
						],
						[
							-82.68768591499992,
							27.708795818000056
						],
						[
							-82.68805591499995,
							27.708764818000077
						],
						[
							-82.68813099999994,
							27.708761678000087
						],
						[
							-82.68822234699991,
							27.70876633000006
						],
						[
							-82.68855534699992,
							27.70880032900004
						],
						[
							-82.68864145999993,
							27.708813361000068
						],
						[
							-82.68910845999994,
							27.70890736100006
						],
						[
							-82.68922390699993,
							27.708938715000045
						],
						[
							-82.68979661199995,
							27.709136000000058
						],
						[
							-82.69012184299993,
							27.70922680600006
						],
						[
							-82.69018577799994,
							27.70924725800006
						],
						[
							-82.6902480089999,
							27.709272421000037
						],
						[
							-82.69030818999994,
							27.709302156000035
						],
						[
							-82.6903659859999,
							27.70933629800004
						],
						[
							-82.69082998499994,
							27.709634298000083
						],
						[
							-82.69092079099994,
							27.70970100600005
						],
						[
							-82.69117679099992,
							27.709915006000074
						],
						[
							-82.6912478129999,
							27.709981206000066
						],
						[
							-82.6916233739999,
							27.71037122900009
						],
						[
							-82.69162560899991,
							27.710349320000034
						],
						[
							-82.69182420999994,
							27.710990749000075
						],
						[
							-82.69235245999994,
							27.711651062000048
						],
						[
							-82.6940252519999,
							27.713367875000074
						],
						[
							-82.69578608599994,
							27.715216751000074
						],
						[
							-82.69737083699994,
							27.716977584000063
						],
						[
							-82.6981053689999,
							27.717712117000076
						],
						[
							-82.6977369999999,
							27.717937000000063
						],
						[
							-82.69773591699993,
							27.717935896000085
						],
						[
							-82.69737115399995,
							27.718093253000063
						],
						[
							-82.6967331859999,
							27.718358324000064
						],
						[
							-82.69634918399993,
							27.718517874000046
						],
						[
							-82.69585798499992,
							27.71864420600008
						],
						[
							-82.69530279499992,
							27.71877678000004
						],
						[
							-82.6947563789999,
							27.71888262500005
						],
						[
							-82.69425554799994,
							27.71893827200006
						],
						[
							-82.69385131599995,
							27.71897439600008
						],
						[
							-82.69315294699993,
							27.718988723000056
						],
						[
							-82.69193239899994,
							27.71898309900007
						],
						[
							-82.6912658039999,
							27.718982280000034
						],
						[
							-82.69076975399992,
							27.718981670000062
						],
						[
							-82.68920032799991,
							27.718990000000076
						],
						[
							-82.68818316399995,
							27.718977278000068
						],
						[
							-82.68786316299992,
							27.718973600000083
						],
						[
							-82.68716597799994,
							27.718973623000068
						],
						[
							-82.68681696099992,
							27.71897691500004
						],
						[
							-82.68626481699994,
							27.71898536200007
						],
						[
							-82.68577074899991,
							27.71898457500004
						],
						[
							-82.68527740199995,
							27.718965353000044
						],
						[
							-82.67854999999992,
							27.71905000000004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Eckerd College",
				"RegionID": "268976"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.08423999999991,
					26.748636919000035,
					-80.07799999999992,
					26.75328996400009
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.08390436799993,
							26.75328996400009
						],
						[
							-80.07824799999992,
							26.753269000000046
						],
						[
							-80.07801499999994,
							26.75327100000004
						],
						[
							-80.07800809199995,
							26.75327092100008
						],
						[
							-80.07800392899992,
							26.753229289000046
						],
						[
							-80.07799999999992,
							26.753190000000075
						],
						[
							-80.07800911499993,
							26.753076066000062
						],
						[
							-80.07802455299992,
							26.75288308800009
						],
						[
							-80.0780393359999,
							26.752698295000073
						],
						[
							-80.0780561659999,
							26.752549891000058
						],
						[
							-80.07808114699992,
							26.75238680600006
						],
						[
							-80.07810732599995,
							26.752285361000077
						],
						[
							-80.07813588999994,
							26.75217467600004
						],
						[
							-80.07815865599991,
							26.75208217800008
						],
						[
							-80.07817556199991,
							26.75201349400004
						],
						[
							-80.07819624099996,
							26.75192732800008
						],
						[
							-80.0782099999999,
							26.751870000000054
						],
						[
							-80.07823019799991,
							26.75180814500004
						],
						[
							-80.07825627599993,
							26.751728281000055
						],
						[
							-80.07829279299995,
							26.75161644700006
						],
						[
							-80.07832407099994,
							26.75152065900005
						],
						[
							-80.0783664679999,
							26.75139081800006
						],
						[
							-80.07840492399993,
							26.751315141000077
						],
						[
							-80.07845061099994,
							26.75123408400009
						],
						[
							-80.0785037469999,
							26.751154379000074
						],
						[
							-80.07855483899993,
							26.751077741000074
						],
						[
							-80.07860184399993,
							26.751007233000053
						],
						[
							-80.0786447619999,
							26.75094285700004
						],
						[
							-80.0786599999999,
							26.750890816000037
						],
						[
							-80.07866432399993,
							26.750856087000045
						],
						[
							-80.07868519499993,
							26.75083720500004
						],
						[
							-80.07876206599991,
							26.75076765400007
						],
						[
							-80.07882206799991,
							26.75071336700006
						],
						[
							-80.07888321899992,
							26.750650171000075
						],
						[
							-80.07895781399992,
							26.750538279000068
						],
						[
							-80.07903138699993,
							26.75042791900006
						],
						[
							-80.07909121199992,
							26.75033886400007
						],
						[
							-80.0791663309999,
							26.75026843900008
						],
						[
							-80.07928983699992,
							26.750152653000043
						],
						[
							-80.07939257399994,
							26.750056337000046
						],
						[
							-80.07948139199993,
							26.74997307000007
						],
						[
							-80.07956999999993,
							26.74989000000005
						],
						[
							-80.07964478699995,
							26.749835156000074
						],
						[
							-80.07972829199991,
							26.749773919000063
						],
						[
							-80.0798932859999,
							26.749652923000042
						],
						[
							-80.08010953599995,
							26.74949434000007
						],
						[
							-80.08031426699995,
							26.749344204000067
						],
						[
							-80.08048674799994,
							26.749217718000068
						],
						[
							-80.08080211299995,
							26.748978415000067
						],
						[
							-80.0811071139999,
							26.74874966400006
						],
						[
							-80.08125744099993,
							26.748636919000035
						],
						[
							-80.08128738099992,
							26.748668027000065
						],
						[
							-80.08205231599993,
							26.749493597000082
						],
						[
							-80.08216338799991,
							26.749613473000068
						],
						[
							-80.08246817499992,
							26.74994242100007
						],
						[
							-80.08281836499992,
							26.750320369000065
						],
						[
							-80.08298882499992,
							26.750504342000056
						],
						[
							-80.08318240499995,
							26.750713267000037
						],
						[
							-80.08333087799991,
							26.75087350800004
						],
						[
							-80.08345792799992,
							26.751010630000053
						],
						[
							-80.0835774059999,
							26.751131925000042
						],
						[
							-80.08373387299991,
							26.751257098000053
						],
						[
							-80.08392965099995,
							26.751376324000034
						],
						[
							-80.0841123539999,
							26.75148445500008
						],
						[
							-80.08423999999991,
							26.75156000000004
						],
						[
							-80.08410796399994,
							26.75179280100008
						],
						[
							-80.0839774719999,
							26.752022878000048
						],
						[
							-80.0838599999999,
							26.752230000000054
						],
						[
							-80.08380748299993,
							26.752323364000063
						],
						[
							-80.08376288199992,
							26.752399152000066
						],
						[
							-80.0836326829999,
							26.752528083000072
						],
						[
							-80.08382087299992,
							26.752964680000048
						],
						[
							-80.08399481599992,
							26.753011893000064
						],
						[
							-80.08390436799993,
							26.75328996400009
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "West Palm Beach",
				"Name": "Westfield",
				"RegionID": "269231"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.46749999999992,
					28.482793558000083,
					-81.45901710699991,
					28.493732084000044
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.46477678299993,
							28.493513591000067
						],
						[
							-81.46415285699993,
							28.493078945000036
						],
						[
							-81.46384840799993,
							28.492875645000083
						],
						[
							-81.46310826199993,
							28.492378729000055
						],
						[
							-81.46306023599995,
							28.492477052000083
						],
						[
							-81.46303225699995,
							28.49256034800004
						],
						[
							-81.4623211409999,
							28.49208146600006
						],
						[
							-81.46145084799991,
							28.49149059100006
						],
						[
							-81.45904828099994,
							28.489899724000054
						],
						[
							-81.45901710699991,
							28.482793558000083
						],
						[
							-81.46693911999995,
							28.48279356100005
						],
						[
							-81.46694037299994,
							28.483063222000055
						],
						[
							-81.46689199999992,
							28.483062000000075
						],
						[
							-81.46689263399992,
							28.483290218000036
						],
						[
							-81.46689399999991,
							28.483782000000076
						],
						[
							-81.46688499999993,
							28.485032000000047
						],
						[
							-81.46689299999991,
							28.486766000000046
						],
						[
							-81.46685521599994,
							28.491810000000044
						],
						[
							-81.46749999999992,
							28.491810000000044
						],
						[
							-81.46749999999992,
							28.49345500000004
						],
						[
							-81.46709399999992,
							28.493481000000088
						],
						[
							-81.4669419999999,
							28.493472000000054
						],
						[
							-81.4669209999999,
							28.49345800000009
						],
						[
							-81.46684285899994,
							28.49345955800004
						],
						[
							-81.46684121599992,
							28.493678918000057
						],
						[
							-81.46538868899995,
							28.493726906000067
						],
						[
							-81.46511824499993,
							28.493732084000044
						],
						[
							-81.46497006699991,
							28.493636774000038
						],
						[
							-81.46477678299993,
							28.493513591000067
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Windhover",
				"RegionID": "269233"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.72746442099992,
					28.246598262000077,
					-82.70719580999992,
					28.253353235000077
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.70719580999992,
							28.25027183300006
						],
						[
							-82.70720756899993,
							28.249753428000076
						],
						[
							-82.70877220299991,
							28.249748000000068
						],
						[
							-82.71134083099992,
							28.24973908900006
						],
						[
							-82.7126946059999,
							28.24973439200005
						],
						[
							-82.71270623399994,
							28.248457187000042
						],
						[
							-82.71272315899995,
							28.246598262000077
						],
						[
							-82.71544526299994,
							28.246612539000072
						],
						[
							-82.71958296299994,
							28.24659961800006
						],
						[
							-82.71961074699993,
							28.246599531000072
						],
						[
							-82.71964971099993,
							28.246599531000072
						],
						[
							-82.72100986999993,
							28.246599531000072
						],
						[
							-82.72100986999993,
							28.247132531000094
						],
						[
							-82.7234274029999,
							28.247132531000094
						],
						[
							-82.7233512599999,
							28.247322888000042
						],
						[
							-82.72320849199991,
							28.247665530000063
						],
						[
							-82.72296102799993,
							28.248150940000073
						],
						[
							-82.72270404699992,
							28.24848406500007
						],
						[
							-82.72236140399991,
							28.248836225000048
						],
						[
							-82.7221329759999,
							28.249026582000056
						],
						[
							-82.72184744099991,
							28.249245492000057
						],
						[
							-82.7225422429999,
							28.249245492000057
						],
						[
							-82.72267549299994,
							28.249083689000088
						],
						[
							-82.72275163599994,
							28.249026582000056
						],
						[
							-82.72317993899992,
							28.248836225000048
						],
						[
							-82.72338933099991,
							28.248874296000054
						],
						[
							-82.72343586599993,
							28.24885373400008
						],
						[
							-82.7237844309999,
							28.249024063000036
						],
						[
							-82.72523114299992,
							28.24958561600005
						],
						[
							-82.7266588199999,
							28.24957609800009
						],
						[
							-82.72666833799991,
							28.249709348000067
						],
						[
							-82.7274269099999,
							28.249672348000047
						],
						[
							-82.72746260199995,
							28.250148240000048
						],
						[
							-82.72746442099992,
							28.25087764300008
						],
						[
							-82.72516668999992,
							28.250896441000066
						],
						[
							-82.72516074099991,
							28.251449666000042
						],
						[
							-82.7253451489999,
							28.25168166400005
						],
						[
							-82.72535704599994,
							28.251794688000075
						],
						[
							-82.72532730299991,
							28.251854175000066
						],
						[
							-82.72482761599991,
							28.25218729900007
						],
						[
							-82.72389367799991,
							28.25098567100008
						],
						[
							-82.72383419099994,
							28.25086669800004
						],
						[
							-82.72283481799991,
							28.250884544000087
						],
						[
							-82.72284076599993,
							28.251295001000074
						],
						[
							-82.72297758499991,
							28.251538896000056
						],
						[
							-82.72306681499992,
							28.251592434000088
						],
						[
							-82.72316199399995,
							28.25168166400005
						],
						[
							-82.72336424799994,
							28.25175304700008
						],
						[
							-82.72362598899991,
							28.25197909600007
						],
						[
							-82.7233880419999,
							28.252312221000068
						],
						[
							-82.72087176199994,
							28.252318169000034
						],
						[
							-82.7206933029999,
							28.252466886000036
						],
						[
							-82.72050889499991,
							28.252597756000057
						],
						[
							-82.7203185379999,
							28.25266914000008
						],
						[
							-82.72016387299993,
							28.25269888300005
						],
						[
							-82.71993782399994,
							28.25269888300005
						],
						[
							-82.71993782399994,
							28.253335389000085
						],
						[
							-82.71545236399993,
							28.253349092000065
						],
						[
							-82.71409624699993,
							28.253353235000077
						],
						[
							-82.71407840099995,
							28.251360436000084
						],
						[
							-82.71275185199994,
							28.251360436000084
						],
						[
							-82.71273400599995,
							28.25056331700006
						],
						[
							-82.71003331799994,
							28.250575214000037
						],
						[
							-82.71003331799994,
							28.250265884000044
						],
						[
							-82.70719580999992,
							28.25027183300006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pasco",
				"City": "New Port Richey",
				"Name": "Downtown",
				"RegionID": "270826"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.71537493999995,
					28.21927568500007,
					-82.69900118499993,
					28.23684800500007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.71537493999995,
							28.23169314000006
						],
						[
							-82.71535855199994,
							28.236502836000057
						],
						[
							-82.71499116199993,
							28.236514880000072
						],
						[
							-82.71498521399991,
							28.236211499000035
						],
						[
							-82.71464019199993,
							28.236199601000067
						],
						[
							-82.71461639699993,
							28.23650893100006
						],
						[
							-82.71338502599991,
							28.236514880000072
						],
						[
							-82.71339097499992,
							28.236842056000057
						],
						[
							-82.71291508299993,
							28.23684800500007
						],
						[
							-82.71282585299991,
							28.236824210000066
						],
						[
							-82.7122607309999,
							28.236836107000048
						],
						[
							-82.71227262799994,
							28.23650893100006
						],
						[
							-82.7120763229999,
							28.23650893100006
						],
						[
							-82.7120763229999,
							28.236199601000067
						],
						[
							-82.7114100739999,
							28.23620555000008
						],
						[
							-82.7114100739999,
							28.236824210000066
						],
						[
							-82.7109936679999,
							28.236812313000087
						],
						[
							-82.71045828899992,
							28.23657436700006
						],
						[
							-82.71047018699994,
							28.236199601000067
						],
						[
							-82.70991696199991,
							28.236181755000075
						],
						[
							-82.70991696199991,
							28.236134166000056
						],
						[
							-82.7093518399999,
							28.236122269000077
						],
						[
							-82.70931614799991,
							28.23484330900004
						],
						[
							-82.7093934799999,
							28.23472433600006
						],
						[
							-82.7093934799999,
							28.23432577600005
						],
						[
							-82.7072341199999,
							28.23431387900007
						],
						[
							-82.7072341199999,
							28.23521212500009
						],
						[
							-82.70450963699994,
							28.23522997100008
						],
						[
							-82.70447989299993,
							28.23431387900007
						],
						[
							-82.70446799599995,
							28.231512063000082
						],
						[
							-82.70174946199995,
							28.231541807000042
						],
						[
							-82.70171971899993,
							28.230976685000087
						],
						[
							-82.7011248529999,
							28.23092314700006
						],
						[
							-82.70110105899994,
							28.230375871000035
						],
						[
							-82.70319498499993,
							28.23036992200008
						],
						[
							-82.70319498499993,
							28.23000110600009
						],
						[
							-82.7044501499999,
							28.23001895100009
						],
						[
							-82.7044739449999,
							28.228900605000035
						],
						[
							-82.70391477099992,
							28.22889465600008
						],
						[
							-82.70392666899994,
							28.228448507000053
						],
						[
							-82.70319498499993,
							28.22842471300004
						],
						[
							-82.70317713899993,
							28.22800830700004
						],
						[
							-82.70721032499995,
							28.227978564000068
						],
						[
							-82.70720437599994,
							28.226188019000062
						],
						[
							-82.70296893599993,
							28.226193968000075
						],
						[
							-82.70309385699996,
							28.225729973000057
						],
						[
							-82.70308790899992,
							28.225551513000084
						],
						[
							-82.70252278699991,
							28.225539616000052
						],
						[
							-82.70254658099992,
							28.226205865000054
						],
						[
							-82.70209448399993,
							28.226193968000075
						],
						[
							-82.70209448399993,
							28.22687211400006
						],
						[
							-82.70296298699992,
							28.22687211400006
						],
						[
							-82.70299272999995,
							28.22799641000006
						],
						[
							-82.69900713299995,
							28.22799641000006
						],
						[
							-82.69900118499993,
							28.21927568500007
						],
						[
							-82.70013737699992,
							28.219281634000083
						],
						[
							-82.7001492739999,
							28.21999547200005
						],
						[
							-82.70175541099992,
							28.21997762600006
						],
						[
							-82.70177920499992,
							28.22256529000009
						],
						[
							-82.70309385699996,
							28.22255934100008
						],
						[
							-82.70310575499991,
							28.224379629000055
						],
						[
							-82.70455127699995,
							28.224373680000042
						],
						[
							-82.70497957999993,
							28.224296348000053
						],
						[
							-82.70907225299993,
							28.224266604000036
						],
						[
							-82.7091674319999,
							28.224296348000053
						],
						[
							-82.70916148299995,
							28.22505777500004
						],
						[
							-82.70960763199992,
							28.22504587800006
						],
						[
							-82.70974445099995,
							28.225075621000087
						],
						[
							-82.70989911599992,
							28.22506372400005
						],
						[
							-82.70990506499993,
							28.22708626600007
						],
						[
							-82.70760293599994,
							28.227074368000046
						],
						[
							-82.70762078199994,
							28.227984512000038
						],
						[
							-82.70922096999993,
							28.227984512000038
						],
						[
							-82.70925353799993,
							28.231664944000045
						],
						[
							-82.70962830399992,
							28.23166851300005
						],
						[
							-82.7096925489999,
							28.231689928000037
						],
						[
							-82.70991740799991,
							28.231686359000037
						],
						[
							-82.70992097699991,
							28.23160069800008
						],
						[
							-82.71127607999995,
							28.23160069800008
						],
						[
							-82.71127607999995,
							28.228012471000056
						],
						[
							-82.71534971699992,
							28.228012471000056
						],
						[
							-82.71537493999995,
							28.23169314000006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pasco",
				"City": "New Port Richey",
				"Name": "Southeast",
				"RegionID": "271578"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.7267703839999,
					30.37061882900008,
					-81.69906582199991,
					30.389117254000045
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.69915786799993,
							30.379156021000085
						],
						[
							-81.69916489499991,
							30.37883800800006
						],
						[
							-81.70033990499991,
							30.378839008000057
						],
						[
							-81.70230090599995,
							30.378828008000085
						],
						[
							-81.70311690599993,
							30.378839008000057
						],
						[
							-81.70428490599994,
							30.378849008000092
						],
						[
							-81.70597790599993,
							30.378849008000092
						],
						[
							-81.70613089299991,
							30.37885504500008
						],
						[
							-81.70733790499993,
							30.378857009000058
						],
						[
							-81.70776590499992,
							30.378836009000057
						],
						[
							-81.70804890599993,
							30.378799008000044
						],
						[
							-81.70831590499995,
							30.37873500700005
						],
						[
							-81.70842990599994,
							30.37869800800007
						],
						[
							-81.70865890499994,
							30.378620008000045
						],
						[
							-81.70896290499991,
							30.37847700900005
						],
						[
							-81.70922290599992,
							30.37833200800009
						],
						[
							-81.70947490599993,
							30.378149007000047
						],
						[
							-81.7097329049999,
							30.377895008000053
						],
						[
							-81.71047190599995,
							30.377045009000085
						],
						[
							-81.7106489059999,
							30.376853009000058
						],
						[
							-81.71095290499994,
							30.376497008000058
						],
						[
							-81.7111229059999,
							30.376307008000083
						],
						[
							-81.71117390599994,
							30.376251009000043
						],
						[
							-81.71145590599991,
							30.375999009000054
						],
						[
							-81.71178390599994,
							30.375793009000066
						],
						[
							-81.71190590499992,
							30.375732008000057
						],
						[
							-81.71219590499993,
							30.375593008000067
						],
						[
							-81.7141649049999,
							30.374794008000038
						],
						[
							-81.7151789049999,
							30.37437600800007
						],
						[
							-81.71760590499991,
							30.373386009000058
						],
						[
							-81.71848290499992,
							30.373018008000088
						],
						[
							-81.71924590599991,
							30.372709008000076
						],
						[
							-81.72010290499992,
							30.372355008000056
						],
						[
							-81.72067590599995,
							30.372123008000074
						],
						[
							-81.7211409059999,
							30.371921008000076
						],
						[
							-81.72121690599994,
							30.37189600800008
						],
						[
							-81.72133790599992,
							30.371837009000046
						],
						[
							-81.72222090499992,
							30.371498008000064
						],
						[
							-81.72246590599991,
							30.371399008000086
						],
						[
							-81.72302190499994,
							30.371164008000054
						],
						[
							-81.7241129059999,
							30.370715008000047
						],
						[
							-81.72421690499993,
							30.37066500900005
						],
						[
							-81.72432597099993,
							30.37061882900008
						],
						[
							-81.72436390599995,
							30.370689008000056
						],
						[
							-81.72498690599993,
							30.371762008000076
						],
						[
							-81.7252819059999,
							30.372329008000065
						],
						[
							-81.72619590599993,
							30.373901009000065
						],
						[
							-81.72665399999994,
							30.374708000000055
						],
						[
							-81.7267703839999,
							30.374913026000062
						],
						[
							-81.72671435899991,
							30.375130901000034
						],
						[
							-81.72664211299991,
							30.375528258000088
						],
						[
							-81.72642537199994,
							30.376006893000064
						],
						[
							-81.72638924899992,
							30.376151386000064
						],
						[
							-81.72635312499995,
							30.376295880000043
						],
						[
							-81.72623572399993,
							30.37653068200007
						],
						[
							-81.72606413799991,
							30.376937070000054
						],
						[
							-81.72596479899994,
							30.37710865600008
						],
						[
							-81.7258112749999,
							30.377352489000092
						],
						[
							-81.72572999699992,
							30.37746989000004
						],
						[
							-81.7256216269999,
							30.377533106000048
						],
						[
							-81.72543197899995,
							30.377605353000032
						],
						[
							-81.7252874859999,
							30.377650507000055
						],
						[
							-81.72513396099993,
							30.37766856900004
						],
						[
							-81.72495334399991,
							30.377713723000053
						],
						[
							-81.7247727269999,
							30.37777693900006
						],
						[
							-81.72461920299992,
							30.37784918500006
						],
						[
							-81.72448152199992,
							30.377990513000046
						],
						[
							-81.72422006799991,
							30.378211743000065
						],
						[
							-81.72397872699992,
							30.37831230200004
						],
						[
							-81.7236368259999,
							30.37837263700004
						],
						[
							-81.7234357079999,
							30.378352525000082
						],
						[
							-81.7232547019999,
							30.37827207800007
						],
						[
							-81.7230535839999,
							30.378131296000053
						],
						[
							-81.72269157199992,
							30.37805084800004
						],
						[
							-81.72243011799992,
							30.37819163100005
						],
						[
							-81.72220888899994,
							30.378432973000088
						],
						[
							-81.72212844099994,
							30.378634091000038
						],
						[
							-81.72206810599994,
							30.378895544000045
						],
						[
							-81.72194743499996,
							30.379156997000056
						],
						[
							-81.72160553499992,
							30.37959945700004
						],
						[
							-81.72132396899991,
							30.38000169300005
						],
						[
							-81.72110273999994,
							30.38032348200005
						],
						[
							-81.72096195699994,
							30.380625158000043
						],
						[
							-81.72090162199993,
							30.380926835000082
						],
						[
							-81.72090162199993,
							30.381208401000038
						],
						[
							-81.72094184499991,
							30.381550301000065
						],
						[
							-81.7210021809999,
							30.38193242500006
						],
						[
							-81.7210625159999,
							30.382294438000088
						],
						[
							-81.72102229199993,
							30.382555891000035
						],
						[
							-81.72090162199993,
							30.38277712100006
						],
						[
							-81.72070050399992,
							30.382958127000055
						],
						[
							-81.7204792739999,
							30.383098910000054
						],
						[
							-81.72035860299991,
							30.383259804000087
						],
						[
							-81.72029826799991,
							30.383521257000044
						],
						[
							-81.72033849099995,
							30.38376259900008
						],
						[
							-81.72045916199994,
							30.384044164000045
						],
						[
							-81.7206200569999,
							30.384285506000083
						],
						[
							-81.7205396089999,
							30.38450673500006
						],
						[
							-81.7204189389999,
							30.384828524000053
						],
						[
							-81.72033849099995,
							30.385110089000083
						],
						[
							-81.72021782099995,
							30.385431878000077
						],
						[
							-81.72007703799994,
							30.385874338000065
						],
						[
							-81.72001670299994,
							30.386155903000088
						],
						[
							-81.71997647899991,
							30.386437468000054
						],
						[
							-81.71997647899991,
							30.386759257000055
						],
						[
							-81.71999659099993,
							30.38710115700007
						],
						[
							-81.72003681399991,
							30.387644176000034
						],
						[
							-81.72003681399991,
							30.387945853000076
						],
						[
							-81.72001670299994,
							30.388327977000078
						],
						[
							-81.71999659099993,
							30.388689989000056
						],
						[
							-81.72001838999995,
							30.389117254000045
						],
						[
							-81.7197589999999,
							30.38905500000004
						],
						[
							-81.7193529079999,
							30.388958010000067
						],
						[
							-81.71921490799991,
							30.38892401000004
						],
						[
							-81.71821590799993,
							30.388617011000065
						],
						[
							-81.71724690799994,
							30.38826801100004
						],
						[
							-81.7167429079999,
							30.388062010000052
						],
						[
							-81.71646890799991,
							30.387939010000082
						],
						[
							-81.71563690699992,
							30.387564011000055
						],
						[
							-81.7154619069999,
							30.387478010000052
						],
						[
							-81.71362290699994,
							30.386650011000086
						],
						[
							-81.71233390799995,
							30.386076010000068
						],
						[
							-81.7115019069999,
							30.385704010000044
						],
						[
							-81.71097590699992,
							30.385466010000073
						],
						[
							-81.7098769079999,
							30.384977010000057
						],
						[
							-81.70907590799993,
							30.38462101100004
						],
						[
							-81.7088389079999,
							30.384521011000064
						],
						[
							-81.70834390699991,
							30.38428901000009
						],
						[
							-81.70706890699995,
							30.383718011000045
						],
						[
							-81.70682090699995,
							30.383619010000075
						],
						[
							-81.70645890799995,
							30.383481010000082
						],
						[
							-81.70626390899992,
							30.383420011000055
						],
						[
							-81.70602190699992,
							30.38335801000005
						],
						[
							-81.7058259069999,
							30.38331901000004
						],
						[
							-81.70556790799992,
							30.38326901100004
						],
						[
							-81.70483490799995,
							30.383183011000085
						],
						[
							-81.70428490699993,
							30.383104011000057
						],
						[
							-81.70411790799994,
							30.383085010000062
						],
						[
							-81.70374290799992,
							30.383041011000046
						],
						[
							-81.7019739079999,
							30.382805010000087
						],
						[
							-81.70158390799992,
							30.382751010000053
						],
						[
							-81.70065290699995,
							30.382633010000063
						],
						[
							-81.70005290799992,
							30.382553010000038
						],
						[
							-81.69906582199991,
							30.382421005000086
						],
						[
							-81.69909690599991,
							30.38224000800005
						],
						[
							-81.69913490599993,
							30.381618008000093
						],
						[
							-81.69918790499992,
							30.381016008000078
						],
						[
							-81.69919590599994,
							30.38071100900004
						],
						[
							-81.69918790499992,
							30.380180008000078
						],
						[
							-81.69915786799993,
							30.379156021000085
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Edgewood Manor",
				"RegionID": "268977"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.05444005599992,
					26.68819079700006,
					-80.04856667799993,
					26.696617666000066
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.04902093999993,
							26.696617666000066
						],
						[
							-80.04891512299992,
							26.695850954000036
						],
						[
							-80.04890667799994,
							26.695728000000088
						],
						[
							-80.04890667799994,
							26.695130000000063
						],
						[
							-80.04891138399995,
							26.69503812000005
						],
						[
							-80.04894938399991,
							26.694668120000074
						],
						[
							-80.04895799099995,
							26.69460583500006
						],
						[
							-80.04904498999991,
							26.694105835000073
						],
						[
							-80.04905903999992,
							26.69403985000008
						],
						[
							-80.0490949519999,
							26.693893950000074
						],
						[
							-80.04909259499993,
							26.693819123000083
						],
						[
							-80.04907929299992,
							26.693729675000043
						],
						[
							-80.04906784199994,
							26.693689997000035
						],
						[
							-80.04895803499994,
							26.693430521000042
						],
						[
							-80.04885235499995,
							26.693231092000076
						],
						[
							-80.04880191399992,
							26.693117586000085
						],
						[
							-80.04878861599991,
							26.693078246000084
						],
						[
							-80.04873087899995,
							26.692893491000063
						],
						[
							-80.04869115199995,
							26.69278694700006
						],
						[
							-80.0486484569999,
							26.692626978000078
						],
						[
							-80.04857857399992,
							26.69220179100006
						],
						[
							-80.04856667799993,
							26.692056000000036
						],
						[
							-80.04857990199991,
							26.69190234100006
						],
						[
							-80.0487001219999,
							26.69120908700006
						],
						[
							-80.04874053099991,
							26.691057467000064
						],
						[
							-80.04887809899994,
							26.690678030000072
						],
						[
							-80.04895371499993,
							26.690378424000077
						],
						[
							-80.04904424799992,
							26.68912693100009
						],
						[
							-80.04894531699995,
							26.68819079700006
						],
						[
							-80.04985222699992,
							26.68821521400008
						],
						[
							-80.05012318199994,
							26.68822250900007
						],
						[
							-80.05035014499992,
							26.688228619000085
						],
						[
							-80.05083044499992,
							26.688241550000043
						],
						[
							-80.05142693399995,
							26.68825761000005
						],
						[
							-80.0517804939999,
							26.688267129000053
						],
						[
							-80.05224511099993,
							26.68827963800004
						],
						[
							-80.05262999999991,
							26.688290000000052
						],
						[
							-80.05285745899994,
							26.688295055000083
						],
						[
							-80.05306873899991,
							26.688299750000056
						],
						[
							-80.05325867899995,
							26.68830397100004
						],
						[
							-80.05354370599991,
							26.688310305000073
						],
						[
							-80.05381290499992,
							26.688316287000077
						],
						[
							-80.05397999999991,
							26.68832000000009
						],
						[
							-80.05416626999994,
							26.688328099000046
						],
						[
							-80.05439351399991,
							26.68833797900004
						],
						[
							-80.05443379699994,
							26.688339640000038
						],
						[
							-80.05443168799991,
							26.68843981000009
						],
						[
							-80.05444005599992,
							26.688439998000035
						],
						[
							-80.05443999999994,
							26.688650000000052
						],
						[
							-80.05441999999994,
							26.689240001000087
						],
						[
							-80.05439224299994,
							26.690310329000056
						],
						[
							-80.05437999999992,
							26.690310000000068
						],
						[
							-80.05437497699995,
							26.69050591100006
						],
						[
							-80.05437119899995,
							26.69065325400004
						],
						[
							-80.05436642799992,
							26.69081073700005
						],
						[
							-80.05436085699995,
							26.690983430000074
						],
						[
							-80.05435057799993,
							26.691176458000086
						],
						[
							-80.05433965399993,
							26.691369442000052
						],
						[
							-80.05433302999995,
							26.69148647500009
						],
						[
							-80.05432999999994,
							26.69154000000009
						],
						[
							-80.05432999999994,
							26.691623459000084
						],
						[
							-80.05432869099991,
							26.691735171000065
						],
						[
							-80.05432692499994,
							26.69179607600006
						],
						[
							-80.05432265499991,
							26.69194341000008
						],
						[
							-80.05431838899995,
							26.69209059700006
						],
						[
							-80.05431440799993,
							26.69222792700009
						],
						[
							-80.05431190299993,
							26.692314356000054
						],
						[
							-80.05430999999993,
							26.69238000000007
						],
						[
							-80.05430326599993,
							26.69247203200007
						],
						[
							-80.0542958449999,
							26.69257345400007
						],
						[
							-80.0542854659999,
							26.692715297000063
						],
						[
							-80.05427999999995,
							26.69279000000006
						],
						[
							-80.05427653699991,
							26.69288349100009
						],
						[
							-80.0542724039999,
							26.692995091000057
						],
						[
							-80.05426999999992,
							26.69306000000006
						],
						[
							-80.05426424599995,
							26.69316741700004
						],
						[
							-80.05425497599992,
							26.693340445000047
						],
						[
							-80.05424924899995,
							26.693447356000036
						],
						[
							-80.05424272199993,
							26.693569190000062
						],
						[
							-80.05423999999994,
							26.693620000000067
						],
						[
							-80.05423999999994,
							26.69367564500004
						],
						[
							-80.0542391749999,
							26.69374932800008
						],
						[
							-80.0542392829999,
							26.69377653300006
						],
						[
							-80.05423760499991,
							26.69383860800008
						],
						[
							-80.0542357029999,
							26.693908985000064
						],
						[
							-80.05423211499993,
							26.694041742000085
						],
						[
							-80.05422739099993,
							26.694216542000053
						],
						[
							-80.05422312799993,
							26.69437428200007
						],
						[
							-80.05421999999993,
							26.694490000000087
						],
						[
							-80.05421691299995,
							26.69454943100004
						],
						[
							-80.05421222199993,
							26.694639726000048
						],
						[
							-80.05420666999993,
							26.694746605000095
						],
						[
							-80.05420036399994,
							26.694867985000087
						],
						[
							-80.05419230599995,
							26.695023116000073
						],
						[
							-80.05418469299991,
							26.695169664000048
						],
						[
							-80.05417999999992,
							26.695260000000076
						],
						[
							-80.0541766739999,
							26.695296587000087
						],
						[
							-80.05417255899994,
							26.695341849000044
						],
						[
							-80.05416999999994,
							26.695370000000082
						],
						[
							-80.05416900599994,
							26.695403791000047
						],
						[
							-80.0541680529999,
							26.69543618700004
						],
						[
							-80.05416648499994,
							26.695489525000085
						],
						[
							-80.05416297399995,
							26.695608873000083
						],
						[
							-80.05415853699992,
							26.695759751000082
						],
						[
							-80.05415596799992,
							26.695847101000084
						],
						[
							-80.05415268399992,
							26.695958742000073
						],
						[
							-80.05414999999994,
							26.69605000000007
						],
						[
							-80.05414528999997,
							26.69612536300008
						],
						[
							-80.0541399999999,
							26.696210000000065
						],
						[
							-80.05413675299991,
							26.69628467700005
						],
						[
							-80.05413330399995,
							26.696364005000078
						],
						[
							-80.05413000199991,
							26.696439944000076
						],
						[
							-80.05407083099995,
							26.696438218000083
						],
						[
							-80.0535940119999,
							26.69642385600008
						],
						[
							-80.0531938119999,
							26.69641180200006
						],
						[
							-80.05285846899994,
							26.69640170100007
						],
						[
							-80.0526113279999,
							26.696394257000065
						],
						[
							-80.05246999999991,
							26.696390000000065
						],
						[
							-80.05229343099995,
							26.696385414000076
						],
						[
							-80.05176967499995,
							26.696371810000073
						],
						[
							-80.05132830899993,
							26.696359887000085
						],
						[
							-80.05112205899991,
							26.696346137000035
						],
						[
							-80.05102999999991,
							26.696340000000077
						],
						[
							-80.05043954799993,
							26.696313719000045
						],
						[
							-80.05013350599995,
							26.69632549000005
						],
						[
							-80.04989775899992,
							26.696392846000037
						],
						[
							-80.04902093999993,
							26.696617666000066
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "West Palm Beach",
				"Name": "El Cid",
				"RegionID": "268978"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.53820207799993,
					30.353447013000054,
					-81.50705349799995,
					30.39152611600008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.51038390899993,
							30.381468013000074
						],
						[
							-81.51038390899993,
							30.37957001300003
						],
						[
							-81.51037590999994,
							30.378752013000053
						],
						[
							-81.51037390999994,
							30.378404012000093
						],
						[
							-81.51038777699995,
							30.378084013000034
						],
						[
							-81.51045690899991,
							30.378009013000057
						],
						[
							-81.51071890999992,
							30.37767601200005
						],
						[
							-81.5108409099999,
							30.377470012000064
						],
						[
							-81.51126890999991,
							30.37663101200008
						],
						[
							-81.51150290999995,
							30.37617501300008
						],
						[
							-81.5123289089999,
							30.374569012000055
						],
						[
							-81.51354190899991,
							30.37217501300006
						],
						[
							-81.51423590999991,
							30.37086301200009
						],
						[
							-81.51444590999995,
							30.370447013000046
						],
						[
							-81.5148009099999,
							30.36975901300008
						],
						[
							-81.51500690899991,
							30.36932401300004
						],
						[
							-81.5152589089999,
							30.36868901200006
						],
						[
							-81.51530490999994,
							30.36851901200004
						],
						[
							-81.51544190999994,
							30.367941013000067
						],
						[
							-81.5155029089999,
							30.367615012000044
						],
						[
							-81.51555590999993,
							30.367111013000056
						],
						[
							-81.51557890999995,
							30.36674901300006
						],
						[
							-81.51558690899992,
							30.366301013000058
						],
						[
							-81.51556390999991,
							30.365913013000068
						],
						[
							-81.51554890999995,
							30.36493301200005
						],
						[
							-81.5155469099999,
							30.364805013000076
						],
						[
							-81.51553890999992,
							30.364202013000067
						],
						[
							-81.51553490899994,
							30.363949012000035
						],
						[
							-81.51553690999992,
							30.36314301300007
						],
						[
							-81.51552790999995,
							30.362807012000072
						],
						[
							-81.51558790999991,
							30.362112013000058
						],
						[
							-81.51567790999991,
							30.361531013000047
						],
						[
							-81.51571290999993,
							30.361301012000073
						],
						[
							-81.51578690899993,
							30.36106901200009
						],
						[
							-81.51580990999992,
							30.36097301200005
						],
						[
							-81.51594891099995,
							30.36061801200009
						],
						[
							-81.51600990999992,
							30.36049901200005
						],
						[
							-81.5161589089999,
							30.360113012000056
						],
						[
							-81.5162429099999,
							30.359940013000084
						],
						[
							-81.51641790999992,
							30.35963101300007
						],
						[
							-81.51675390899993,
							30.359074012000065
						],
						[
							-81.51697490999993,
							30.35876501300004
						],
						[
							-81.51748690999995,
							30.358150013000053
						],
						[
							-81.51778390899995,
							30.35782101300003
						],
						[
							-81.51791291099994,
							30.35765701300005
						],
						[
							-81.5182239099999,
							30.35737901200008
						],
						[
							-81.51887290999991,
							30.356932012000076
						],
						[
							-81.51931490899995,
							30.356619012000063
						],
						[
							-81.51956690899993,
							30.356457012000078
						],
						[
							-81.51988790999991,
							30.356276013000066
						],
						[
							-81.52056646399991,
							30.35593813400004
						],
						[
							-81.5207489089999,
							30.355873013000064
						],
						[
							-81.52102390899995,
							30.355761012000077
						],
						[
							-81.52146991099994,
							30.35560801200006
						],
						[
							-81.52282591099994,
							30.355194012000084
						],
						[
							-81.52305191099992,
							30.35511501200006
						],
						[
							-81.5238559089999,
							30.35483601200008
						],
						[
							-81.52698690999995,
							30.35381601400007
						],
						[
							-81.5280019089999,
							30.353575012000075
						],
						[
							-81.52842090899992,
							30.353506013000068
						],
						[
							-81.52897090899995,
							30.353459012000087
						],
						[
							-81.5295559089999,
							30.353447013000054
						],
						[
							-81.52987690999994,
							30.353460012000085
						],
						[
							-81.53053090799995,
							30.353518012000055
						],
						[
							-81.5329359079999,
							30.35377101200004
						],
						[
							-81.53359990999991,
							30.353834013000043
						],
						[
							-81.53440091099992,
							30.35392401200005
						],
						[
							-81.53586590999993,
							30.354078012000063
						],
						[
							-81.53643790799993,
							30.354095012000073
						],
						[
							-81.53671901899992,
							30.354085916000088
						],
						[
							-81.53738397099995,
							30.354532951000067
						],
						[
							-81.53786790899994,
							30.35526901500009
						],
						[
							-81.53812190699995,
							30.355911011000046
						],
						[
							-81.53820207799993,
							30.356645050000054
						],
						[
							-81.53792399999992,
							30.35704000000004
						],
						[
							-81.53798299999994,
							30.35705900000005
						],
						[
							-81.53781974899994,
							30.35794651300006
						],
						[
							-81.53774385299994,
							30.357925870000088
						],
						[
							-81.53018440599993,
							30.357124601000063
						],
						[
							-81.52666301599993,
							30.35876420700004
						],
						[
							-81.52407417899991,
							30.36749578700005
						],
						[
							-81.52141113399995,
							30.376466564000054
						],
						[
							-81.5214357509999,
							30.37824380600006
						],
						[
							-81.52155616599993,
							30.37825434100006
						],
						[
							-81.52168310799993,
							30.378286402000075
						],
						[
							-81.52943535599992,
							30.380857545000083
						],
						[
							-81.52983625799993,
							30.380284827000082
						],
						[
							-81.52912072599992,
							30.37825268300009
						],
						[
							-81.52908334099993,
							30.37811016600006
						],
						[
							-81.52906967799993,
							30.377954000000045
						],
						[
							-81.52908334099993,
							30.37779783500008
						],
						[
							-81.52912391399991,
							30.377646414000086
						],
						[
							-81.52919016399994,
							30.37750433900004
						],
						[
							-81.52928007999992,
							30.37737592700006
						],
						[
							-81.5293821649999,
							30.37727252800005
						],
						[
							-81.52942254599994,
							30.37723780300007
						],
						[
							-81.5295553389999,
							30.37714416400007
						],
						[
							-81.52969741399994,
							30.377077913000054
						],
						[
							-81.52984883399995,
							30.377037340000076
						],
						[
							-81.5300049999999,
							30.37702367800006
						],
						[
							-81.53016116599991,
							30.377037340000076
						],
						[
							-81.53031933299991,
							30.37708043000004
						],
						[
							-81.53670207999994,
							30.379519947000063
						],
						[
							-81.5368306609999,
							30.379581164000058
						],
						[
							-81.53695907299993,
							30.37967107900005
						],
						[
							-81.53706991999991,
							30.37978192700007
						],
						[
							-81.53715983599994,
							30.379910339000052
						],
						[
							-81.53722608599992,
							30.380052413000048
						],
						[
							-81.5372666589999,
							30.380203834000042
						],
						[
							-81.5372803219999,
							30.380360000000056
						],
						[
							-81.5372650569999,
							30.380524764000082
						],
						[
							-81.53686445499994,
							30.38256436200004
						],
						[
							-81.53682708699995,
							30.382698586000064
						],
						[
							-81.5368151159999,
							30.382729672000035
						],
						[
							-81.53615541699992,
							30.384352493000055
						],
						[
							-81.5361522689999,
							30.38464275400008
						],
						[
							-81.5361386589999,
							30.38478916500009
						],
						[
							-81.53609808599992,
							30.384940586000084
						],
						[
							-81.53603183599995,
							30.385082661000066
						],
						[
							-81.5359419209999,
							30.385211073000054
						],
						[
							-81.53583107299994,
							30.38532192000008
						],
						[
							-81.5357026609999,
							30.385411835000067
						],
						[
							-81.53568575499992,
							30.385421354000073
						],
						[
							-81.53221175499993,
							30.38732835500008
						],
						[
							-81.53208658599993,
							30.38738508700004
						],
						[
							-81.53199564399995,
							30.38741283800005
						],
						[
							-81.52572264399993,
							30.388969838000033
						],
						[
							-81.52562044699994,
							30.38898901000005
						],
						[
							-81.52351971099995,
							30.38925853800004
						],
						[
							-81.51541585299992,
							30.390656237000087
						],
						[
							-81.51539602699995,
							30.39065942900004
						],
						[
							-81.50966602599993,
							30.391516429000035
						],
						[
							-81.50959003399993,
							30.391524514000086
						],
						[
							-81.50951362899991,
							30.39152611600008
						],
						[
							-81.50943736499994,
							30.39152122500008
						],
						[
							-81.50936179199994,
							30.391509874000064
						],
						[
							-81.50928745499994,
							30.391492146000076
						],
						[
							-81.50921489199993,
							30.391468170000053
						],
						[
							-81.50914462799994,
							30.391438118000053
						],
						[
							-81.5090771699999,
							30.39140220800005
						],
						[
							-81.50744600099995,
							30.39042558100005
						],
						[
							-81.50738486699993,
							30.39038551300007
						],
						[
							-81.50732718899992,
							30.390340613000035
						],
						[
							-81.50727334699991,
							30.39029117800004
						],
						[
							-81.5072236979999,
							30.390237533000064
						],
						[
							-81.5071785689999,
							30.390180033000036
						],
						[
							-81.50705349799995,
							30.39000660100004
						],
						[
							-81.5077186069999,
							30.389391375000056
						],
						[
							-81.5078283769999,
							30.389289838000078
						],
						[
							-81.50783407499995,
							30.38924006700006
						],
						[
							-81.50779790999991,
							30.388212013000043
						],
						[
							-81.50780490999995,
							30.387659012000086
						],
						[
							-81.50779690999991,
							30.38703201200008
						],
						[
							-81.50780490999995,
							30.38638101300006
						],
						[
							-81.50782791099995,
							30.38615801100008
						],
						[
							-81.5078889099999,
							30.38597701200007
						],
						[
							-81.50795691199994,
							30.385834010000053
						],
						[
							-81.50817090999993,
							30.385542013000077
						],
						[
							-81.50829290999991,
							30.38541001200008
						],
						[
							-81.50842290999992,
							30.38529801200008
						],
						[
							-81.50916290999993,
							30.384743013000048
						],
						[
							-81.50930790899992,
							30.384645013000068
						],
						[
							-81.50955790899991,
							30.38443501200004
						],
						[
							-81.50994890899995,
							30.384109011000074
						],
						[
							-81.5101239089999,
							30.383919012000035
						],
						[
							-81.51020090899993,
							30.38380601200004
						],
						[
							-81.51031490799994,
							30.38359501300005
						],
						[
							-81.51032990899995,
							30.383547012000065
						],
						[
							-81.51037590899995,
							30.38331601200008
						],
						[
							-81.51039090899991,
							30.383108013000083
						],
						[
							-81.51038390899993,
							30.381468013000074
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Beacon Hills and Harbour",
				"RegionID": "268889"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.10379712399993,
					26.172494878000066,
					-80.09754945599991,
					26.18206100000009
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.10236224699992,
							26.172505405000038
						],
						[
							-80.10335471899992,
							26.17249739300007
						],
						[
							-80.10339847499995,
							26.172498096000083
						],
						[
							-80.10379712399993,
							26.172494878000066
						],
						[
							-80.10376459499992,
							26.172993649000095
						],
						[
							-80.10369889099991,
							26.17407777200009
						],
						[
							-80.10363318599991,
							26.175983199000086
						],
						[
							-80.10350177799995,
							26.17844711300006
						],
						[
							-80.10333751699994,
							26.181140993000042
						],
						[
							-80.10333751699994,
							26.18189659400008
						],
						[
							-80.10316599999993,
							26.18196100000006
						],
						[
							-80.10287599999992,
							26.182057667000038
						],
						[
							-80.10286599999995,
							26.18206100000009
						],
						[
							-80.09816499999994,
							26.18206100000009
						],
						[
							-80.09776499999992,
							26.18206100000009
						],
						[
							-80.09754945599991,
							26.18204047200004
						],
						[
							-80.0976732929999,
							26.181305456000075
						],
						[
							-80.0978886119999,
							26.180487242000083
						],
						[
							-80.09822911599991,
							26.179562872000076
						],
						[
							-80.09859966699992,
							26.178501297000082
						],
						[
							-80.09881698899994,
							26.177850332000048
						],
						[
							-80.09908839099995,
							26.176964017000046
						],
						[
							-80.09930571399991,
							26.176051665000045
						],
						[
							-80.09943991199992,
							26.175250478000066
						],
						[
							-80.09956810299991,
							26.17413081500007
						],
						[
							-80.09964221299992,
							26.17341675600005
						],
						[
							-80.09977328499991,
							26.17254231900006
						],
						[
							-80.1008149509999,
							26.172521429000085
						],
						[
							-80.10236224699992,
							26.172505405000038
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Bermuda Riviera",
				"RegionID": "268891"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.73524746699991,
					30.41811083800008,
					-81.70765691399993,
					30.438569065000078
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.70845769999994,
							30.420228040000044
						],
						[
							-81.70871142499993,
							30.420204207000044
						],
						[
							-81.7096628729999,
							30.419527244000054
						],
						[
							-81.71051731599994,
							30.41822519400006
						],
						[
							-81.71170744599993,
							30.41811083800008
						],
						[
							-81.71337483999991,
							30.41863487600006
						],
						[
							-81.71364353599995,
							30.418754384000064
						],
						[
							-81.71476375399993,
							30.419420009000078
						],
						[
							-81.71784158299994,
							30.41930013900009
						],
						[
							-81.71800885599993,
							30.41920202500006
						],
						[
							-81.71983367099995,
							30.41864270500008
						],
						[
							-81.72060278899994,
							30.418378792000055
						],
						[
							-81.7206164019999,
							30.418374121000053
						],
						[
							-81.72161399899994,
							30.418235992000067
						],
						[
							-81.7238163859999,
							30.418481555000085
						],
						[
							-81.72505187199994,
							30.41856596700006
						],
						[
							-81.72637944399993,
							30.418481555000085
						],
						[
							-81.72707008799995,
							30.41849690200007
						],
						[
							-81.72743075799991,
							30.41862735700005
						],
						[
							-81.72858183099993,
							30.419770757000038
						],
						[
							-81.72907295599992,
							30.420346294000073
						],
						[
							-81.72965616699992,
							30.42114437200007
						],
						[
							-81.7299324249999,
							30.421328544000062
						],
						[
							-81.73029309399993,
							30.421466672000065
						],
						[
							-81.7309146739999,
							30.421451325000078
						],
						[
							-81.7314518419999,
							30.42122111000009
						],
						[
							-81.73193529299994,
							30.420883462000067
						],
						[
							-81.73244943899994,
							30.42040768500004
						],
						[
							-81.73288684699992,
							30.420093058000077
						],
						[
							-81.73322449499994,
							30.419947255000064
						],
						[
							-81.73331023499992,
							30.41994439700005
						],
						[
							-81.73345470999995,
							30.41993958100005
						],
						[
							-81.73366957699994,
							30.420146775000035
						],
						[
							-81.73389211799991,
							30.42044605400008
						],
						[
							-81.73417604999992,
							30.420691616000052
						],
						[
							-81.73460578399994,
							30.42098322100009
						],
						[
							-81.7351276039999,
							30.421351565000066
						],
						[
							-81.73524746699991,
							30.42146870400006
						],
						[
							-81.7351129999999,
							30.421704000000094
						],
						[
							-81.73409928599995,
							30.423477836000075
						],
						[
							-81.73215899299994,
							30.426064895000085
						],
						[
							-81.73005700699991,
							30.429137029000064
						],
						[
							-81.72827845199993,
							30.433179331000073
						],
						[
							-81.72464491799991,
							30.438256016000082
						],
						[
							-81.72432290799992,
							30.438273010000046
						],
						[
							-81.72388990699996,
							30.43829501000005
						],
						[
							-81.72301390799993,
							30.438312010000057
						],
						[
							-81.72159790699993,
							30.43832101000004
						],
						[
							-81.72070790699992,
							30.43831201100005
						],
						[
							-81.72005590799995,
							30.43833901000005
						],
						[
							-81.71874990799995,
							30.438378010000065
						],
						[
							-81.71787190799995,
							30.438371011000076
						],
						[
							-81.71776690599997,
							30.43838201200009
						],
						[
							-81.7176809309999,
							30.438413143000048
						],
						[
							-81.71589490799994,
							30.438427010000055
						],
						[
							-81.71576390799994,
							30.438428010000052
						],
						[
							-81.71387490799992,
							30.438477010000042
						],
						[
							-81.71158190699992,
							30.438508010000078
						],
						[
							-81.70970190799994,
							30.438538010000062
						],
						[
							-81.70765691399993,
							30.438569065000078
						],
						[
							-81.70806701299995,
							30.427843498000072
						],
						[
							-81.70839052699995,
							30.421537412000077
						],
						[
							-81.70841113499995,
							30.42113569500009
						],
						[
							-81.70845769999994,
							30.420228040000044
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Biscayne Terrace",
				"RegionID": "268896"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.36451506069115,
					28.52567036303769,
					-81.35988622682402,
					28.531343747750647
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.35988622682402,
							28.531343747750647
						],
						[
							-81.3599391690126,
							28.527694150567605
						],
						[
							-81.35996247224502,
							28.527693405928943
						],
						[
							-81.35990632487275,
							28.52567036303769
						],
						[
							-81.36035692208164,
							28.525843536487578
						],
						[
							-81.36089979422727,
							28.52602368957585
						],
						[
							-81.36150262507208,
							28.526626697586927
						],
						[
							-81.36204542707061,
							28.52692814583454
						],
						[
							-81.36282758722459,
							28.52740985868637
						],
						[
							-81.36367181588703,
							28.52777252828108
						],
						[
							-81.36451506069115,
							28.527772312443776
						],
						[
							-81.3641534217195,
							28.528555534697052
						],
						[
							-81.36415355302053,
							28.530181970278285
						],
						[
							-81.36411662685802,
							28.531331808351396
						],
						[
							-81.3628476169248,
							28.531326667826683
						],
						[
							-81.36225573892308,
							28.53132065945617
						],
						[
							-81.3606293267243,
							28.531336683576157
						],
						[
							-81.36009353134361,
							28.531342691946577
						],
						[
							-81.35988622682402,
							28.531343747750647
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Lake Weldona",
				"RegionID": "269054"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.20760622699993,
					26.00255361500007,
					-80.1991829349999,
					26.010263068000086
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.1995160589999,
							26.010263068000086
						],
						[
							-80.1991829349999,
							26.00255361500007
						],
						[
							-80.20741586999992,
							26.002696382000067
						],
						[
							-80.20760622699993,
							26.010167890000048
						],
						[
							-80.1995160589999,
							26.010263068000086
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Hollywood",
				"Name": "Lawnacres",
				"RegionID": "269067"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.16154205999993,
					26.033399617000043,
					-80.15156699999996,
					26.04656600000004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.16154205999993,
							26.033399617000043
						],
						[
							-80.16036676699991,
							26.038121792000084
						],
						[
							-80.15974387699993,
							26.04075177100009
						],
						[
							-80.15576799999991,
							26.046366000000035
						],
						[
							-80.1544669999999,
							26.046466000000066
						],
						[
							-80.15368799999993,
							26.046467000000064
						],
						[
							-80.15355399999993,
							26.046467000000064
						],
						[
							-80.15197099999995,
							26.046561000000054
						],
						[
							-80.15186699999992,
							26.04656600000004
						],
						[
							-80.15186699999992,
							26.045966000000078
						],
						[
							-80.15186699999992,
							26.045266000000083
						],
						[
							-80.15186699999992,
							26.044666000000063
						],
						[
							-80.1518299999999,
							26.043864000000042
						],
						[
							-80.15182199999992,
							26.04316300000005
						],
						[
							-80.15176699999995,
							26.042366000000072
						],
						[
							-80.15176699999995,
							26.041967000000056
						],
						[
							-80.15176699999995,
							26.041667000000075
						],
						[
							-80.15166699999992,
							26.04086700000005
						],
						[
							-80.15166699999992,
							26.04006700000008
						],
						[
							-80.15166699999992,
							26.03946700000006
						],
						[
							-80.15156699999996,
							26.038767000000064
						],
						[
							-80.15176699999995,
							26.03796700000004
						],
						[
							-80.15156699999996,
							26.037167000000068
						],
						[
							-80.15166699999992,
							26.036467000000073
						],
						[
							-80.15166699999992,
							26.035767000000078
						],
						[
							-80.15161499999994,
							26.03535000000005
						],
						[
							-80.15156699999996,
							26.034967000000055
						],
						[
							-80.15156699999996,
							26.034467000000063
						],
						[
							-80.15156699999996,
							26.034267000000057
						],
						[
							-80.15156699999996,
							26.033687000000043
						],
						[
							-80.15156699999996,
							26.033467000000087
						],
						[
							-80.16154205999993,
							26.033399617000043
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Hollywood",
				"Name": "Liberia",
				"RegionID": "269069"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.77522390399992,
					30.382356001000066,
					-81.72920973199992,
					30.42147949400004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.73524746699991,
							30.42146870400006
						],
						[
							-81.7351276039999,
							30.421351565000066
						],
						[
							-81.73460578399994,
							30.42098322100009
						],
						[
							-81.73417604999992,
							30.420691616000052
						],
						[
							-81.73389211799991,
							30.42044605400008
						],
						[
							-81.73366957699994,
							30.420146775000035
						],
						[
							-81.73345470999995,
							30.41993958100005
						],
						[
							-81.73331023499992,
							30.41994439700005
						],
						[
							-81.7333109999999,
							30.419445000000053
						],
						[
							-81.73331190499994,
							30.418854011000064
						],
						[
							-81.73314995599992,
							30.41817199100007
						],
						[
							-81.73301890499995,
							30.417933009000084
						],
						[
							-81.73260077499992,
							30.41701103300005
						],
						[
							-81.73259090599993,
							30.416816008000072
						],
						[
							-81.7326307479999,
							30.41639390200004
						],
						[
							-81.73266090699991,
							30.416377011000066
						],
						[
							-81.73272690599993,
							30.416363010000058
						],
						[
							-81.7331199269999,
							30.416367929000046
						],
						[
							-81.73343806699995,
							30.416567903000043
						],
						[
							-81.73346774599992,
							30.416863082000077
						],
						[
							-81.73358384799991,
							30.416989185000034
						],
						[
							-81.73367890599991,
							30.416967875000072
						],
						[
							-81.73381100199992,
							30.416994171000056
						],
						[
							-81.7340730489999,
							30.416036894000058
						],
						[
							-81.7326709059999,
							30.41602400900007
						],
						[
							-81.7325609049999,
							30.41604200900008
						],
						[
							-81.73230879999994,
							30.416103159000045
						],
						[
							-81.73213990499994,
							30.414465009000086
						],
						[
							-81.73190390499991,
							30.411892008000052
						],
						[
							-81.73148690599993,
							30.407915009000078
						],
						[
							-81.73141390599994,
							30.40724700800007
						],
						[
							-81.73135490599992,
							30.406667008000056
						],
						[
							-81.73119090599994,
							30.405159009000045
						],
						[
							-81.73113290599991,
							30.404632009000068
						],
						[
							-81.73105590599994,
							30.40409600900006
						],
						[
							-81.73081890599991,
							30.40294000800009
						],
						[
							-81.73029790499993,
							30.399970008000082
						],
						[
							-81.73016795899991,
							30.399198995000067
						],
						[
							-81.72981990699992,
							30.397194011000067
						],
						[
							-81.72962190699991,
							30.39597501000009
						],
						[
							-81.72952990699991,
							30.39547501000004
						],
						[
							-81.72950990699991,
							30.395362010000046
						],
						[
							-81.72920973199992,
							30.393342961000087
						],
						[
							-81.73001090799995,
							30.39235701000007
						],
						[
							-81.73042290699993,
							30.391834011000075
						],
						[
							-81.7304759299999,
							30.391753922000078
						],
						[
							-81.73061290499993,
							30.39182000800008
						],
						[
							-81.73111290599991,
							30.392032009000047
						],
						[
							-81.73118596599994,
							30.392065190000043
						],
						[
							-81.7317959049999,
							30.391085008000065
						],
						[
							-81.73185090599992,
							30.391002008000047
						],
						[
							-81.73187690599991,
							30.390962008000088
						],
						[
							-81.73198690599992,
							30.390795009000048
						],
						[
							-81.73215490599995,
							30.390509009000088
						],
						[
							-81.73231508299995,
							30.39026496000008
						],
						[
							-81.73162072699995,
							30.389935059000035
						],
						[
							-81.73197890499995,
							30.389315009000086
						],
						[
							-81.73205590499992,
							30.38916400900007
						],
						[
							-81.7325129059999,
							30.38831900900004
						],
						[
							-81.73261290599993,
							30.38812100800004
						],
						[
							-81.7328489059999,
							30.387703009000067
						],
						[
							-81.7331409059999,
							30.38716200800007
						],
						[
							-81.7332539059999,
							30.386953008000035
						],
						[
							-81.73329590599991,
							30.38687100900006
						],
						[
							-81.73334180199993,
							30.38678192200007
						],
						[
							-81.7380030029999,
							30.382356001000066
						],
						[
							-81.74361209999995,
							30.39269199800009
						],
						[
							-81.74346871699993,
							30.393028024000046
						],
						[
							-81.74381980499993,
							30.393650096000048
						],
						[
							-81.74459084499995,
							30.39430518600005
						],
						[
							-81.7479709079999,
							30.394209010000054
						],
						[
							-81.74845090699996,
							30.394203010000066
						],
						[
							-81.75007590799994,
							30.39415701100006
						],
						[
							-81.7507859079999,
							30.39413501000007
						],
						[
							-81.75126590799994,
							30.394119011000043
						],
						[
							-81.75145190699995,
							30.394114010000067
						],
						[
							-81.75170790699991,
							30.394105010000093
						],
						[
							-81.75191490799995,
							30.394100011000035
						],
						[
							-81.75289190799992,
							30.39409001000007
						],
						[
							-81.75366190699992,
							30.394083010000088
						],
						[
							-81.75468490799994,
							30.394073010000056
						],
						[
							-81.75663800799992,
							30.394054176000058
						],
						[
							-81.75667691099994,
							30.39397300900004
						],
						[
							-81.75730387599992,
							30.393205822000084
						],
						[
							-81.7575570379999,
							30.393369008000036
						],
						[
							-81.75718172299992,
							30.394492057000036
						],
						[
							-81.75987890699992,
							30.39701601000007
						],
						[
							-81.76751090699992,
							30.404728010000042
						],
						[
							-81.77024690699994,
							30.40741001000004
						],
						[
							-81.77516303999994,
							30.41222902400005
						],
						[
							-81.77517690499991,
							30.41251700800007
						],
						[
							-81.77522390399992,
							30.415447006000083
						],
						[
							-81.77519405299995,
							30.415570131000038
						],
						[
							-81.77510390299994,
							30.415610008000048
						],
						[
							-81.77500990499993,
							30.415629008000053
						],
						[
							-81.76857990499991,
							30.41576900900009
						],
						[
							-81.76824390599995,
							30.415771008000036
						],
						[
							-81.76688090599993,
							30.41578000800007
						],
						[
							-81.7665959059999,
							30.41578400800006
						],
						[
							-81.76122990499994,
							30.415827009000058
						],
						[
							-81.76022890599995,
							30.415833008000053
						],
						[
							-81.75923190499992,
							30.415845008000073
						],
						[
							-81.7580029049999,
							30.41585000800006
						],
						[
							-81.75695880799992,
							30.41585817600009
						],
						[
							-81.75531590499992,
							30.412938008000086
						],
						[
							-81.7525930239999,
							30.408325864000062
						],
						[
							-81.7522849049999,
							30.408230006000057
						],
						[
							-81.75187685199995,
							30.408001963000057
						],
						[
							-81.75220690599991,
							30.40833501100008
						],
						[
							-81.75239309999995,
							30.40865200900004
						],
						[
							-81.7523129459999,
							30.408784042000036
						],
						[
							-81.7521199059999,
							30.40895400900007
						],
						[
							-81.75189190499992,
							30.409233009000047
						],
						[
							-81.75161690599992,
							30.409517008000076
						],
						[
							-81.75130190499993,
							30.409838009000055
						],
						[
							-81.75093990499994,
							30.41016500800004
						],
						[
							-81.75056590499992,
							30.410477008000043
						],
						[
							-81.74984590499992,
							30.410982008000076
						],
						[
							-81.74964290499992,
							30.41111100900008
						],
						[
							-81.74851290599992,
							30.41173700900004
						],
						[
							-81.74828590499993,
							30.411869009000043
						],
						[
							-81.74799090599993,
							30.412011009000082
						],
						[
							-81.7477979059999,
							30.412115008000058
						],
						[
							-81.7476169059999,
							30.412216008000087
						],
						[
							-81.74755090499991,
							30.412254008000048
						],
						[
							-81.7474879049999,
							30.412287008000074
						],
						[
							-81.74683890499995,
							30.412641008000037
						],
						[
							-81.74680590499992,
							30.412657008000057
						],
						[
							-81.74596890499993,
							30.413114009000083
						],
						[
							-81.7425779049999,
							30.414983008000036
						],
						[
							-81.7423069059999,
							30.41513500900004
						],
						[
							-81.74183290499991,
							30.41542000900006
						],
						[
							-81.7413629049999,
							30.415663008000077
						],
						[
							-81.74065190599993,
							30.41602900800007
						],
						[
							-81.74054690499992,
							30.416092008000078
						],
						[
							-81.74040190599993,
							30.416174008000045
						],
						[
							-81.73997490499994,
							30.416437009000052
						],
						[
							-81.73953990599995,
							30.41672300800008
						],
						[
							-81.73914290499994,
							30.417007008000045
						],
						[
							-81.7387539049999,
							30.41731100900006
						],
						[
							-81.73817390599993,
							30.417801008000087
						],
						[
							-81.73774690599993,
							30.41819200900005
						],
						[
							-81.7371289049999,
							30.41884000800008
						],
						[
							-81.73670590499995,
							30.419335008000076
						],
						[
							-81.73628990499992,
							30.41986600900009
						],
						[
							-81.73592890599991,
							30.42040000800006
						],
						[
							-81.73540599999991,
							30.42124200000006
						],
						[
							-81.7352585079999,
							30.42147949400004
						],
						[
							-81.73524746699991,
							30.42146870400006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Lincoln Villas",
				"RegionID": "269070"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.79387799699992,
					30.203915024000086,
					-81.75510703399993,
					30.240408142000035
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.76303590599991,
							30.233278008000067
						],
						[
							-81.7630429049999,
							30.232173008000075
						],
						[
							-81.76303790599991,
							30.231203008000083
						],
						[
							-81.7630429049999,
							30.230933008000076
						],
						[
							-81.76303490599992,
							30.230613008000034
						],
						[
							-81.76303790599991,
							30.230011008000076
						],
						[
							-81.76303290599992,
							30.22906800800007
						],
						[
							-81.76303390599992,
							30.228125009000053
						],
						[
							-81.76303390599992,
							30.227943008000068
						],
						[
							-81.76303390599992,
							30.226869009000044
						],
						[
							-81.7630239049999,
							30.22623500900005
						],
						[
							-81.76301590499992,
							30.22602100900008
						],
						[
							-81.76298490499994,
							30.22551000800007
						],
						[
							-81.76290890599996,
							30.224560009000072
						],
						[
							-81.76289390599993,
							30.22429100800008
						],
						[
							-81.76285590599991,
							30.224068009000067
						],
						[
							-81.76277890599994,
							30.223436009000068
						],
						[
							-81.76267190499993,
							30.222803009000078
						],
						[
							-81.76255790599993,
							30.222172008000086
						],
						[
							-81.76213790499992,
							30.220280008000092
						],
						[
							-81.7618259059999,
							30.219051008000065
						],
						[
							-81.76177598499993,
							30.218835954000046
						],
						[
							-81.76142090699994,
							30.217453010000042
						],
						[
							-81.7610319069999,
							30.215881011000075
						],
						[
							-81.76079590799992,
							30.21494501100005
						],
						[
							-81.7607349079999,
							30.21463601100004
						],
						[
							-81.76057390799993,
							30.21401201100008
						],
						[
							-81.76050590699992,
							30.213702010000077
						],
						[
							-81.76019990799996,
							30.212527010000088
						],
						[
							-81.75988590799994,
							30.21131901100006
						],
						[
							-81.7597249079999,
							30.21075601100006
						],
						[
							-81.75963190699991,
							30.210493011000036
						],
						[
							-81.75953890799991,
							30.21018801000008
						],
						[
							-81.75918890799994,
							30.209294011000054
						],
						[
							-81.7588919069999,
							30.208666010000062
						],
						[
							-81.75873590799995,
							30.208353011000042
						],
						[
							-81.75855690799995,
							30.208039011000043
						],
						[
							-81.7583939079999,
							30.207722011000048
						],
						[
							-81.75820690799992,
							30.20740801100004
						],
						[
							-81.75761190799994,
							30.20651101100009
						],
						[
							-81.75713490699991,
							30.205883010000036
						],
						[
							-81.75687890699993,
							30.205569010000094
						],
						[
							-81.75660990699993,
							30.20526201000007
						],
						[
							-81.75636190799992,
							30.20496001100008
						],
						[
							-81.75561797799992,
							30.20418484100008
						],
						[
							-81.75524484499994,
							30.204203185000043
						],
						[
							-81.75510703399993,
							30.20408024500006
						],
						[
							-81.76469390799991,
							30.20410901000008
						],
						[
							-81.76633490699993,
							30.204075011000043
						],
						[
							-81.76986690699994,
							30.20397401000008
						],
						[
							-81.7704159079999,
							30.203959011000055
						],
						[
							-81.7714069079999,
							30.203988009000057
						],
						[
							-81.7722288999999,
							30.203915024000086
						],
						[
							-81.77665490799991,
							30.211332011000078
						],
						[
							-81.7810209079999,
							30.218533011000094
						],
						[
							-81.7814718219999,
							30.21916511200004
						],
						[
							-81.79348596199992,
							30.225478010000074
						],
						[
							-81.79387799699992,
							30.23299198600006
						],
						[
							-81.79345690399992,
							30.232973008000045
						],
						[
							-81.7920609059999,
							30.232992008000057
						],
						[
							-81.79144290499994,
							30.232992008000057
						],
						[
							-81.7905119049999,
							30.233007008000072
						],
						[
							-81.78917690499993,
							30.23300400900007
						],
						[
							-81.78873390599995,
							30.233013008000057
						],
						[
							-81.78825390599991,
							30.23303800900004
						],
						[
							-81.78808589999994,
							30.23306109300006
						],
						[
							-81.78803291499992,
							30.23304595700006
						],
						[
							-81.78758990599994,
							30.233051008000075
						],
						[
							-81.7872699049999,
							30.233044009000082
						],
						[
							-81.78684190599995,
							30.23304900800008
						],
						[
							-81.78570590499993,
							30.233046008000088
						],
						[
							-81.78514090599992,
							30.23305300800007
						],
						[
							-81.78376790599994,
							30.233046008000088
						],
						[
							-81.7830349059999,
							30.233061009000043
						],
						[
							-81.78268390599993,
							30.233059008000055
						],
						[
							-81.7809829059999,
							30.233082009000043
						],
						[
							-81.7787779059999,
							30.233109008000042
						],
						[
							-81.77540490599995,
							30.233158009000082
						],
						[
							-81.77301590699996,
							30.233203953000046
						],
						[
							-81.77098590599991,
							30.233219009000038
						],
						[
							-81.7695079049999,
							30.23325200800008
						],
						[
							-81.76859290599992,
							30.23325200800008
						],
						[
							-81.76449777499994,
							30.23330387900006
						],
						[
							-81.76449790599992,
							30.234691008000084
						],
						[
							-81.76452590499991,
							30.236245009000076
						],
						[
							-81.7645719059999,
							30.240267009000036
						],
						[
							-81.76456703699995,
							30.240368142000083
						],
						[
							-81.7630307739999,
							30.240408142000035
						],
						[
							-81.76302890599993,
							30.238859009000066
						],
						[
							-81.76305890599991,
							30.236372008000043
						],
						[
							-81.7630399059999,
							30.23390200900008
						],
						[
							-81.76303590599991,
							30.233278008000067
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "McGirts Creek",
				"RegionID": "269084"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.18617455299994,
					26.10560618900007,
					-80.17777308699993,
					26.12146400000006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.17803802599991,
							26.12146400000006
						],
						[
							-80.17797037699995,
							26.11652237900006
						],
						[
							-80.1779633669999,
							26.116079722000052
						],
						[
							-80.17796336599991,
							26.115873416000056
						],
						[
							-80.17795936099992,
							26.11578628700005
						],
						[
							-80.17795535399995,
							26.115686139000047
						],
						[
							-80.17792531099992,
							26.113814363000074
						],
						[
							-80.17792531099992,
							26.11364911800007
						],
						[
							-80.1779203019999,
							26.11337971800009
						],
						[
							-80.17791028799991,
							26.112965104000068
						],
						[
							-80.17791028799991,
							26.112758798000073
						],
						[
							-80.17789526599995,
							26.112071779000075
						],
						[
							-80.17788825499991,
							26.111367735000044
						],
						[
							-80.17788424899993,
							26.11131165100005
						],
						[
							-80.17787123099993,
							26.11068672500005
						],
						[
							-80.17786421999995,
							26.11048843000009
						],
						[
							-80.17786421999995,
							26.110352228000067
						],
						[
							-80.17786421999995,
							26.110203007000052
						],
						[
							-80.17786421999995,
							26.109896552000066
						],
						[
							-80.17786421999995,
							26.109667213000083
						],
						[
							-80.17783417599992,
							26.108010757000045
						],
						[
							-80.17781114199994,
							26.107175518000076
						],
						[
							-80.17777308699993,
							26.106404369000074
						],
						[
							-80.17798239599995,
							26.10638634700007
						],
						[
							-80.17859630599992,
							26.106318246000058
						],
						[
							-80.17948161899994,
							26.106241131000047
						],
						[
							-80.17981711599992,
							26.106211088000066
						],
						[
							-80.1814044699999,
							26.106087905000038
						],
						[
							-80.18228076899995,
							26.10600978900004
						],
						[
							-80.18232183099991,
							26.106005782000068
						],
						[
							-80.1831590729999,
							26.105937681000057
						],
						[
							-80.18406641799993,
							26.105858564000073
						],
						[
							-80.18493670799995,
							26.105753408000055
						],
						[
							-80.18537134699994,
							26.10569135600008
						],
						[
							-80.18582903599992,
							26.10560618900007
						],
						[
							-80.18585206599994,
							26.10619906900007
						],
						[
							-80.18585206599994,
							26.106345286000078
						],
						[
							-80.18584005799994,
							26.10669783700007
						],
						[
							-80.18586708899994,
							26.10717752100004
						],
						[
							-80.18588311299993,
							26.10789959200008
						],
						[
							-80.1859041429999,
							26.10871680400004
						],
						[
							-80.1859281799999,
							26.10954503100004
						],
						[
							-80.18593518999995,
							26.109862502000055
						],
						[
							-80.18595021199991,
							26.110370255000078
						],
						[
							-80.18597424699993,
							26.111198483000067
						],
						[
							-80.18598926999994,
							26.111620109000057
						],
						[
							-80.18600429199995,
							26.11202470900008
						],
						[
							-80.18604935899992,
							26.114030685000046
						],
						[
							-80.18606538299991,
							26.11463457900004
						],
						[
							-80.18608040499993,
							26.115352645000087
						],
						[
							-80.18610443999995,
							26.11677775900006
						],
						[
							-80.18613348399992,
							26.11817783400005
						],
						[
							-80.18614249699993,
							26.118871864000084
						],
						[
							-80.18615151099993,
							26.119665040000086
						],
						[
							-80.18615251199992,
							26.119727133000083
						],
						[
							-80.1861725409999,
							26.120495272000085
						],
						[
							-80.18617455299994,
							26.121064347000072
						],
						[
							-80.18606799999992,
							26.121064000000047
						],
						[
							-80.18486799999994,
							26.121264000000053
						],
						[
							-80.1847679999999,
							26.121264000000053
						],
						[
							-80.18446799999994,
							26.121264000000053
						],
						[
							-80.18326799999994,
							26.121264000000053
						],
						[
							-80.1827679999999,
							26.121264000000053
						],
						[
							-80.18236799999994,
							26.121264000000053
						],
						[
							-80.18224299999991,
							26.121289000000047
						],
						[
							-80.18186799999995,
							26.121364000000085
						],
						[
							-80.18036799999993,
							26.121364000000085
						],
						[
							-80.17996799999992,
							26.121364000000085
						],
						[
							-80.17986799999994,
							26.12146400000006
						],
						[
							-80.17926799999994,
							26.12146400000006
						],
						[
							-80.17803802599991,
							26.12146400000006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Melrose Manors",
				"RegionID": "269085"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.43879299999992,
					28.556019155000058,
					-81.4251270929999,
					28.57794300000006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.43369899999993,
							28.57447800000006
						],
						[
							-81.43343299999992,
							28.574445000000082
						],
						[
							-81.4334619999999,
							28.573998000000074
						],
						[
							-81.4334179999999,
							28.573397000000057
						],
						[
							-81.4333309999999,
							28.573052000000075
						],
						[
							-81.43321399999991,
							28.572770000000048
						],
						[
							-81.4330569999999,
							28.572771000000046
						],
						[
							-81.43078099999993,
							28.572772000000043
						],
						[
							-81.43067799999994,
							28.57277300000004
						],
						[
							-81.43067599999995,
							28.57266000000004
						],
						[
							-81.43067499999995,
							28.571379000000036
						],
						[
							-81.43067499999995,
							28.571076000000062
						],
						[
							-81.43067499999995,
							28.570974000000035
						],
						[
							-81.43064329799995,
							28.570975669000063
						],
						[
							-81.4305799999999,
							28.57097900000008
						],
						[
							-81.42857199999992,
							28.571008000000067
						],
						[
							-81.4275639999999,
							28.57090400000004
						],
						[
							-81.42670399999992,
							28.570797000000088
						],
						[
							-81.42670399999992,
							28.57047752200009
						],
						[
							-81.42670399999992,
							28.57036700000009
						],
						[
							-81.42668299999991,
							28.56955700000009
						],
						[
							-81.4275889999999,
							28.56955700000009
						],
						[
							-81.42849199999995,
							28.569559000000083
						],
						[
							-81.42863999999992,
							28.569562000000076
						],
						[
							-81.42863999999992,
							28.569378000000086
						],
						[
							-81.4286219999999,
							28.567432000000053
						],
						[
							-81.42906199999993,
							28.56741100000005
						],
						[
							-81.42962199999994,
							28.56740700000006
						],
						[
							-81.42962549899994,
							28.56740700000006
						],
						[
							-81.42962899999992,
							28.56740700000006
						],
						[
							-81.43056499999994,
							28.56742300000008
						],
						[
							-81.4306489999999,
							28.56740700000006
						],
						[
							-81.43061399999993,
							28.56694900000008
						],
						[
							-81.43058899999996,
							28.566576000000055
						],
						[
							-81.4296119999999,
							28.566563000000087
						],
						[
							-81.4296119999999,
							28.56714200000005
						],
						[
							-81.42906199999993,
							28.567134000000067
						],
						[
							-81.4286219999999,
							28.567136000000062
						],
						[
							-81.42697099999992,
							28.567136000000062
						],
						[
							-81.42656899999992,
							28.56714000000005
						],
						[
							-81.42630906099993,
							28.56713784300007
						],
						[
							-81.42628251799994,
							28.560974737000038
						],
						[
							-81.42606599999993,
							28.560974000000044
						],
						[
							-81.4260809999999,
							28.560179000000062
						],
						[
							-81.42524699999991,
							28.560179000000062
						],
						[
							-81.42524699999991,
							28.56008700000007
						],
						[
							-81.4262793179999,
							28.560085643000036
						],
						[
							-81.42627781999994,
							28.559763712000066
						],
						[
							-81.42518092599994,
							28.559718906000057
						],
						[
							-81.4251270929999,
							28.556550249000054
						],
						[
							-81.42525899999993,
							28.556550000000072
						],
						[
							-81.42526221199995,
							28.556206303000067
						],
						[
							-81.42689629299991,
							28.55618326300004
						],
						[
							-81.42690199999993,
							28.556550000000072
						],
						[
							-81.4272059999999,
							28.556552000000067
						],
						[
							-81.42995899999994,
							28.55654900000008
						],
						[
							-81.4299404919999,
							28.556140337000045
						],
						[
							-81.4304478709999,
							28.55613345800009
						],
						[
							-81.43066499999992,
							28.556129182000063
						],
						[
							-81.43066499999992,
							28.556178000000045
						],
						[
							-81.43068099999995,
							28.55654800000008
						],
						[
							-81.43152499999991,
							28.55654900000008
						],
						[
							-81.43152499999991,
							28.556476000000092
						],
						[
							-81.43152299999991,
							28.556171000000063
						],
						[
							-81.43152327899993,
							28.556113362000076
						],
						[
							-81.43664218899995,
							28.556019155000058
						],
						[
							-81.43664179099994,
							28.557936402000053
						],
						[
							-81.43662079699993,
							28.558471685000086
						],
						[
							-81.43731318399995,
							28.558336453000038
						],
						[
							-81.43796974199995,
							28.55856059900009
						],
						[
							-81.4380019159999,
							28.558591083000067
						],
						[
							-81.43804214599993,
							28.558634036000058
						],
						[
							-81.43807947999994,
							28.55867952700004
						],
						[
							-81.43811375899992,
							28.55872736300006
						],
						[
							-81.43814483499995,
							28.558777339000073
						],
						[
							-81.43815184899995,
							28.558789711000088
						],
						[
							-81.43822084899995,
							28.55891371100006
						],
						[
							-81.43824157799992,
							28.55895324000005
						],
						[
							-81.43826586499996,
							28.559006844000066
						],
						[
							-81.43828659499991,
							28.55906192200007
						],
						[
							-81.43830367899994,
							28.559118238000053
						],
						[
							-81.43831483799994,
							28.559164812000063
						],
						[
							-81.43836583699994,
							28.55940581200008
						],
						[
							-81.43836804199992,
							28.559416551000083
						],
						[
							-81.4383776279999,
							28.559474615000056
						],
						[
							-81.43838339599995,
							28.559533182000052
						],
						[
							-81.43838532199993,
							28.559592000000066
						],
						[
							-81.43838530399995,
							28.55959760400009
						],
						[
							-81.43838330999995,
							28.55991774000006
						],
						[
							-81.43838239299993,
							28.56013039000004
						],
						[
							-81.43879299999992,
							28.560279000000037
						],
						[
							-81.43788199999995,
							28.562929000000054
						],
						[
							-81.43789099999992,
							28.563443000000063
						],
						[
							-81.43788699999993,
							28.563878000000045
						],
						[
							-81.43788699999993,
							28.564315354000087
						],
						[
							-81.43785385399991,
							28.564279965000082
						],
						[
							-81.4378165199999,
							28.564234473000056
						],
						[
							-81.43778224099992,
							28.564186637000038
						],
						[
							-81.43775116499995,
							28.564136661000077
						],
						[
							-81.43772342299991,
							28.56408476000007
						],
						[
							-81.43770787599993,
							28.564050448000046
						],
						[
							-81.4376956779999,
							28.564102761000072
						],
						[
							-81.43767859499991,
							28.564159077000056
						],
						[
							-81.43765786499996,
							28.56421415500006
						],
						[
							-81.43763357699993,
							28.564267760000064
						],
						[
							-81.43760583599993,
							28.56431966100007
						],
						[
							-81.43757475899992,
							28.56436963600004
						],
						[
							-81.4375407089999,
							28.564417174000084
						],
						[
							-81.43742570899992,
							28.564567175000036
						],
						[
							-81.43742547999994,
							28.564567473000068
						],
						[
							-81.43742482399996,
							28.564568327000075
						],
						[
							-81.43736482399993,
							28.564646327000048
						],
						[
							-81.43732814599991,
							28.564690965000068
						],
						[
							-81.43728791699994,
							28.56473391700007
						],
						[
							-81.43724496399994,
							28.564774146000047
						],
						[
							-81.43719947299991,
							28.56481148000006
						],
						[
							-81.43718018699991,
							28.564825873000075
						],
						[
							-81.4370867909999,
							28.564893647000076
						],
						[
							-81.4370979169999,
							28.56490408400009
						],
						[
							-81.43713814599994,
							28.564947036000035
						],
						[
							-81.43717547999995,
							28.56499252800006
						],
						[
							-81.43720975899993,
							28.565040364000087
						],
						[
							-81.43724083599994,
							28.56509033900005
						],
						[
							-81.43726092199995,
							28.56512707800005
						],
						[
							-81.4373069209999,
							28.56521607800005
						],
						[
							-81.43731457699994,
							28.56523124000006
						],
						[
							-81.4373388649999,
							28.565284844000075
						],
						[
							-81.43735959499993,
							28.565339922000078
						],
						[
							-81.43737667799991,
							28.565396238000062
						],
						[
							-81.4373900409999,
							28.565453551000076
						],
						[
							-81.43739962799992,
							28.565511615000048
						],
						[
							-81.43740539599992,
							28.565570181000055
						],
						[
							-81.4374073219999,
							28.565629000000058
						],
						[
							-81.43740539599992,
							28.56568781800007
						],
						[
							-81.43739962799992,
							28.565746385000068
						],
						[
							-81.43739309099993,
							28.565788353000073
						],
						[
							-81.43737281099993,
							28.56590099100004
						],
						[
							-81.4373964799999,
							28.56593052800008
						],
						[
							-81.43743075899994,
							28.56597836400005
						],
						[
							-81.43746183499991,
							28.56602833900007
						],
						[
							-81.43748957699995,
							28.566080240000076
						],
						[
							-81.43751386499991,
							28.56613384500008
						],
						[
							-81.43753459499993,
							28.566188923000084
						],
						[
							-81.43755167799992,
							28.566245239000068
						],
						[
							-81.43756504099991,
							28.56630255100004
						],
						[
							-81.43757462799994,
							28.566360615000065
						],
						[
							-81.43758039599993,
							28.56641918200006
						],
						[
							-81.43758232199993,
							28.566478000000075
						],
						[
							-81.43758232199993,
							28.566648000000043
						],
						[
							-81.43758039599993,
							28.566706819000046
						],
						[
							-81.43757462799994,
							28.566765385000057
						],
						[
							-81.43756504099991,
							28.566823449000083
						],
						[
							-81.43755167799992,
							28.56688076200004
						],
						[
							-81.4375361729999,
							28.566932387000065
						],
						[
							-81.43753246799992,
							28.566943501000083
						],
						[
							-81.43752700699991,
							28.56714979800006
						],
						[
							-81.4375253959999,
							28.567184818000044
						],
						[
							-81.4375196279999,
							28.56724338500004
						],
						[
							-81.43751373499992,
							28.567281732000083
						],
						[
							-81.43748960099992,
							28.567419000000086
						],
						[
							-81.43676999999991,
							28.567419000000086
						],
						[
							-81.43645499999991,
							28.56872100000004
						],
						[
							-81.43645499999991,
							28.56901300000004
						],
						[
							-81.4363929999999,
							28.568978000000072
						],
						[
							-81.43633399999993,
							28.56909100000007
						],
						[
							-81.4363454459999,
							28.570233974000075
						],
						[
							-81.43634799999995,
							28.570489000000066
						],
						[
							-81.43512476799994,
							28.571562375000042
						],
						[
							-81.4349929999999,
							28.571678000000077
						],
						[
							-81.4346349999999,
							28.572042000000067
						],
						[
							-81.4344999999999,
							28.572164000000043
						],
						[
							-81.4344999999999,
							28.57447800000006
						],
						[
							-81.43439299999994,
							28.57447800000006
						],
						[
							-81.43421899999993,
							28.574475000000064
						],
						[
							-81.43423199999995,
							28.575034000000073
						],
						[
							-81.43422549999991,
							28.575041500000058
						],
						[
							-81.43421899999993,
							28.575049000000035
						],
						[
							-81.43415199999993,
							28.575104000000067
						],
						[
							-81.43408099999994,
							28.57516700000008
						],
						[
							-81.43403199999995,
							28.575233000000082
						],
						[
							-81.43400899999995,
							28.575288000000057
						],
						[
							-81.43402299999991,
							28.57684000000006
						],
						[
							-81.43397399999992,
							28.57688900000005
						],
						[
							-81.43381699999992,
							28.577001000000052
						],
						[
							-81.43376999999992,
							28.57711500000005
						],
						[
							-81.43381499999992,
							28.57750800000008
						],
						[
							-81.4338679999999,
							28.577942000000064
						],
						[
							-81.43169199999994,
							28.57794300000006
						],
						[
							-81.43169199999994,
							28.574546000000055
						],
						[
							-81.43208099999993,
							28.574546000000055
						],
						[
							-81.43307799999992,
							28.574546000000055
						],
						[
							-81.4331949999999,
							28.574546000000055
						],
						[
							-81.43369899999993,
							28.574546000000055
						],
						[
							-81.43369899999993,
							28.57447800000006
						]
					],
					[
						[
							-81.43534824099993,
							28.56456063700006
						],
						[
							-81.4353210569999,
							28.564516922000056
						],
						[
							-81.43530214599991,
							28.564539964000062
						],
						[
							-81.43529739399992,
							28.564545340000052
						],
						[
							-81.4351253939999,
							28.564738340000076
						],
						[
							-81.43508991699991,
							28.564775916000087
						],
						[
							-81.43504696499991,
							28.564816146000055
						],
						[
							-81.43504058199994,
							28.564821690000088
						],
						[
							-81.43499892799991,
							28.564857532000076
						],
						[
							-81.4347212699999,
							28.565098368000065
						],
						[
							-81.43467947199991,
							28.565132480000045
						],
						[
							-81.43463879099994,
							28.56516192900006
						],
						[
							-81.43459432299994,
							28.565192263000085
						],
						[
							-81.4346845739999,
							28.56517540100009
						],
						[
							-81.43476840999995,
							28.565118575000042
						],
						[
							-81.43477336399991,
							28.56511524100006
						],
						[
							-81.43482333899993,
							28.56508416400004
						],
						[
							-81.43487523999994,
							28.56505642200006
						],
						[
							-81.43492884499996,
							28.56503213500008
						],
						[
							-81.43498392299995,
							28.565011405000064
						],
						[
							-81.43501736499991,
							28.56500077600009
						],
						[
							-81.43510595299995,
							28.56497451100006
						],
						[
							-81.43526685999991,
							28.564877412000044
						],
						[
							-81.43538991699995,
							28.56478916700007
						],
						[
							-81.43541436399994,
							28.56477224100007
						],
						[
							-81.4354643389999,
							28.564741165000044
						],
						[
							-81.43548732099993,
							28.564728880000075
						],
						[
							-81.43542826299995,
							28.564663419000055
						],
						[
							-81.43541985299993,
							28.564653965000048
						],
						[
							-81.43538251899992,
							28.564608473000078
						],
						[
							-81.43534824099993,
							28.56456063700006
						]
					],
					[
						[
							-81.43763216399992,
							28.56216433900005
						],
						[
							-81.43764514499992,
							28.562143465000077
						],
						[
							-81.4376111549999,
							28.56215886600006
						],
						[
							-81.4375560769999,
							28.56217959500009
						],
						[
							-81.43752294599994,
							28.562190132000072
						],
						[
							-81.43739494599993,
							28.562228132000087
						],
						[
							-81.43738880399991,
							28.562229932000037
						],
						[
							-81.4373058029999,
							28.562253931000043
						],
						[
							-81.43728876099993,
							28.562258678000035
						],
						[
							-81.43723144899991,
							28.562272041000085
						],
						[
							-81.43717338499994,
							28.56228162800005
						],
						[
							-81.43712029199992,
							28.56228702100009
						],
						[
							-81.43683016999995,
							28.562307814000064
						],
						[
							-81.43651941699994,
							28.562332092000076
						],
						[
							-81.43648772499995,
							28.562344585000062
						],
						[
							-81.4359923419999,
							28.562665914000036
						],
						[
							-81.43602292199995,
							28.562654405000046
						],
						[
							-81.43607923799993,
							28.562637322000057
						],
						[
							-81.43613655099995,
							28.562623958000074
						],
						[
							-81.43619461499993,
							28.56261437200004
						],
						[
							-81.43621447099991,
							28.562611982000078
						],
						[
							-81.43637947099995,
							28.562593982000067
						],
						[
							-81.4364181819999,
							28.562590604000036
						],
						[
							-81.43647699999991,
							28.562588678000054
						],
						[
							-81.43653581899991,
							28.562590604000036
						],
						[
							-81.43659438499992,
							28.56259637200009
						],
						[
							-81.43665244899995,
							28.562605958000063
						],
						[
							-81.43670976199991,
							28.562619322000046
						],
						[
							-81.43676607799995,
							28.562636405000035
						],
						[
							-81.43682115599997,
							28.56265713500005
						],
						[
							-81.43687475999991,
							28.562681423000072
						],
						[
							-81.43690966299994,
							28.562699595000083
						],
						[
							-81.4369916629999,
							28.562744595000083
						],
						[
							-81.43700866099994,
							28.562754165000058
						],
						[
							-81.43705863699995,
							28.562785241000086
						],
						[
							-81.43710647299993,
							28.562819520000062
						],
						[
							-81.43713045299995,
							28.562838578000083
						],
						[
							-81.43722508199994,
							28.562916450000046
						],
						[
							-81.43727270599993,
							28.562955326000065
						],
						[
							-81.43729696399994,
							28.56297585300007
						],
						[
							-81.43733991599993,
							28.563016083000036
						],
						[
							-81.43738014599997,
							28.563059035000038
						],
						[
							-81.43741747999991,
							28.563104527000064
						],
						[
							-81.43742638599991,
							28.563116472000047
						],
						[
							-81.43742637199995,
							28.563116385000058
						],
						[
							-81.4374206039999,
							28.56305781900005
						],
						[
							-81.43742006299993,
							28.563048888000083
						],
						[
							-81.4374110629999,
							28.56288688700005
						],
						[
							-81.43740967799994,
							28.56283700000006
						],
						[
							-81.43741160299993,
							28.562778181000056
						],
						[
							-81.43741737199991,
							28.56271961500005
						],
						[
							-81.43742695799995,
							28.562661551000076
						],
						[
							-81.43744032199993,
							28.562604238000063
						],
						[
							-81.43745740499992,
							28.562547922000082
						],
						[
							-81.43747813499994,
							28.562492844000076
						],
						[
							-81.43749116899994,
							28.562462923000055
						],
						[
							-81.4375931699999,
							28.56223992400004
						],
						[
							-81.43760442299994,
							28.562216240000055
						],
						[
							-81.43763216399992,
							28.56216433900005
						]
					],
					[
						[
							-81.4357064269999,
							28.56283174400005
						],
						[
							-81.43570750299995,
							28.56283099500007
						],
						[
							-81.43552914899993,
							28.562903301000063
						],
						[
							-81.43552747899992,
							28.562996988000066
						],
						[
							-81.43554385399995,
							28.562977036000063
						],
						[
							-81.43558408299992,
							28.562934084000062
						],
						[
							-81.43562703599991,
							28.562893854000038
						],
						[
							-81.43567252699995,
							28.562856520000082
						],
						[
							-81.4357064269999,
							28.56283174400005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Mercy Drive",
				"RegionID": "269086"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.50772999999992,
					28.49749384500007,
					-81.45897203399994,
					28.534084000000064
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-81.47129080899992,
								28.534080224000036
							],
							[
								-81.47085499999991,
								28.53407800000008
							],
							[
								-81.46639347299993,
								28.53407954900007
							],
							[
								-81.46509299999991,
								28.534080000000074
							],
							[
								-81.46389558699993,
								28.53404884100007
							],
							[
								-81.46385885799992,
								28.534047885000067
							],
							[
								-81.4637479999999,
								28.53404500000005
							],
							[
								-81.4637479999999,
								28.53311000000008
							],
							[
								-81.4637479999999,
								28.532480000000078
							],
							[
								-81.46227699999992,
								28.53247700000009
							],
							[
								-81.46228099199993,
								28.532201529000076
							],
							[
								-81.4622839999999,
								28.531994000000054
							],
							[
								-81.46228599999995,
								28.53185600000006
							],
							[
								-81.46109299999995,
								28.53185600000006
							],
							[
								-81.46103299999993,
								28.53185600000006
							],
							[
								-81.46103299999993,
								28.53297900000007
							],
							[
								-81.46095099999991,
								28.53297900000007
							],
							[
								-81.46095640699993,
								28.533080965000067
							],
							[
								-81.45897203399994,
								28.533101401000067
							],
							[
								-81.45918649099993,
								28.532478378000064
							],
							[
								-81.45929465299992,
								28.53155400600008
							],
							[
								-81.45938077999995,
								28.52979339600006
							],
							[
								-81.45940681899994,
								28.52808085500004
							],
							[
								-81.45941082399992,
								28.528025775000064
							],
							[
								-81.45941282899993,
								28.52793263500007
							],
							[
								-81.45934773099992,
								28.524310263000075
							],
							[
								-81.45934773099992,
								28.524242161000075
							],
							[
								-81.45934873199991,
								28.524176063000088
							],
							[
								-81.45935073599992,
								28.52352309600008
							],
							[
								-81.45933771699993,
								28.52304438400006
							],
							[
								-81.45932469699994,
								28.52253563000005
							],
							[
								-81.45931367999992,
								28.520837111000052
							],
							[
								-81.4593116769999,
								28.52068388500004
							],
							[
								-81.45929565299991,
								28.519195677000084
							],
							[
								-81.45928864299992,
								28.518533695000087
							],
							[
								-81.45927862999991,
								28.51742505100009
							],
							[
								-81.45928363699994,
								28.51676106700006
							],
							[
								-81.45922755099991,
								28.51396191500004
							],
							[
								-81.45922855499994,
								28.513886805000084
							],
							[
								-81.45922855499994,
								28.513790661000087
							],
							[
								-81.45923356199995,
								28.512998486000072
							],
							[
								-81.45920251599995,
								28.510521813000082
							],
							[
								-81.45920051199994,
								28.510163280000086
							],
							[
								-81.45919149999992,
								28.509884868000086
							],
							[
								-81.4591594499999,
								28.50906565300005
							],
							[
								-81.45914042399994,
								28.50817833700006
							],
							[
								-81.45914042399994,
								28.50724595400004
							],
							[
								-81.45914042399994,
								28.50712477500008
							],
							[
								-81.45913741999993,
								28.505306078000046
							],
							[
								-81.45913741999993,
								28.505122806000088
							],
							[
								-81.45914042299995,
								28.504635030000088
							],
							[
								-81.46229982099993,
								28.504682332000073
							],
							[
								-81.46324522399993,
								28.504609179000056
							],
							[
								-81.46364400599992,
								28.504582659000054
							],
							[
								-81.46422235999995,
								28.504361162000066
							],
							[
								-81.46425492199995,
								28.504349405000085
							],
							[
								-81.4642845429999,
								28.504339918000085
							],
							[
								-81.46626254299991,
								28.503743918000055
							],
							[
								-81.46628923799994,
								28.503736322000066
							],
							[
								-81.4663457179999,
								28.503723124000093
							],
							[
								-81.46824213399992,
								28.503344041000048
							],
							[
								-81.4682598469999,
								28.50334069300004
							],
							[
								-81.46977684699993,
								28.503069693000047
							],
							[
								-81.4698176149999,
								28.503063371000056
							],
							[
								-81.46987618199995,
								28.50305760300006
							],
							[
								-81.46993499999991,
								28.503055678000067
							],
							[
								-81.46999381799992,
								28.50305760300006
							],
							[
								-81.47002415899993,
								28.503060108000057
							],
							[
								-81.47083715899993,
								28.50314110800008
							],
							[
								-81.47086538499991,
								28.503144372000065
							],
							[
								-81.47092344899994,
								28.50315395800004
							],
							[
								-81.47093217699995,
								28.50315573900008
							],
							[
								-81.4715821769999,
								28.503291739000076
							],
							[
								-81.4716307619999,
								28.50330332100009
							],
							[
								-81.47165544299992,
								28.503310313000043
							],
							[
								-81.47206064199992,
								28.503431374000062
							],
							[
								-81.4721978419999,
								28.50347243300007
							],
							[
								-81.47222907699995,
								28.503482405000057
							],
							[
								-81.4722841549999,
								28.503503135000074
							],
							[
								-81.4723377599999,
								28.503527423000037
							],
							[
								-81.47238966099991,
								28.50355516400009
							],
							[
								-81.47243963599993,
								28.50358624100005
							],
							[
								-81.4724874719999,
								28.503620520000084
							],
							[
								-81.47253296399992,
								28.503657854000043
							],
							[
								-81.4725450599999,
								28.50366865600006
							],
							[
								-81.47284305999995,
								28.503939656000057
							],
							[
								-81.4728739169999,
								28.503969083000072
							],
							[
								-81.47291414599995,
								28.504012036000063
							],
							[
								-81.47295147999995,
								28.504057527000043
							],
							[
								-81.47298575899993,
								28.504105363000065
							],
							[
								-81.47299144999994,
								28.504113988000086
							],
							[
								-81.47326250299994,
								28.504529914000045
							],
							[
								-81.47392222099995,
								28.504854158000057
							],
							[
								-81.47397466099994,
								28.504882164000037
							],
							[
								-81.4740246369999,
								28.504913241000054
							],
							[
								-81.47407247299992,
								28.50494752000009
							],
							[
								-81.4741179639999,
								28.504984854000043
							],
							[
								-81.47416091699995,
								28.505025083000078
							],
							[
								-81.47420114599993,
								28.50506803600007
							],
							[
								-81.4742202189999,
								28.505090517000042
							],
							[
								-81.47444821099992,
								28.50536836000009
							],
							[
								-81.4747198199999,
								28.505552053000088
							],
							[
								-81.47476347299994,
								28.505583520000073
							],
							[
								-81.47478310699995,
								28.50559902400005
							],
							[
								-81.47521510599995,
								28.50595002400007
							],
							[
								-81.47524096399991,
								28.50597185400005
							],
							[
								-81.47525079799993,
								28.505980606000037
							],
							[
								-81.4757125459999,
								28.50585681800004
							],
							[
								-81.47598366299991,
								28.50576255500005
							],
							[
								-81.47598992299993,
								28.505760405000046
							],
							[
								-81.47604623799992,
								28.505743321000068
							],
							[
								-81.47610470199993,
								28.505729731000088
							],
							[
								-81.47626385399991,
								28.505698503000076
							],
							[
								-81.47631961499991,
								28.505689372000063
							],
							[
								-81.47637818199992,
								28.505683604000073
							],
							[
								-81.47643699999992,
								28.505681678000087
							],
							[
								-81.47649581899992,
								28.505683604000073
							],
							[
								-81.47654955699994,
								28.505688896000038
							],
							[
								-81.4765208849999,
								28.505628218000084
							],
							[
								-81.47650313499992,
								28.505588155000055
							],
							[
								-81.4764824049999,
								28.505533077000052
							],
							[
								-81.47646532199991,
								28.50547676100007
							],
							[
								-81.47645195799994,
								28.505419449000044
							],
							[
								-81.47644237199995,
								28.505361385000075
							],
							[
								-81.4764366039999,
								28.505302818000075
							],
							[
								-81.4764354369999,
								28.505280929000037
							],
							[
								-81.47642943599993,
								28.505134929000064
							],
							[
								-81.47642867799995,
								28.505097986000067
							],
							[
								-81.47640852699993,
								28.505091037000057
							],
							[
								-81.4760151289999,
								28.504981186000066
							],
							[
								-81.47596792199994,
								28.50496659500004
							],
							[
								-81.47591284399994,
								28.50494586500008
							],
							[
								-81.47588200399991,
								28.504932409000048
							],
							[
								-81.47568800399995,
								28.504843410000035
							],
							[
								-81.4756652399999,
								28.504832578000048
							],
							[
								-81.47561333899995,
								28.504804836000062
							],
							[
								-81.47556336399992,
								28.504773759000045
							],
							[
								-81.4755143889999,
								28.504738604000067
							],
							[
								-81.47522325099993,
								28.504513727000074
							],
							[
								-81.4751982009999,
								28.50449365500009
							],
							[
								-81.47479667899995,
								28.504159970000046
							],
							[
								-81.47473369399995,
								28.504117980000046
							],
							[
								-81.47466473199995,
								28.504086421000068
							],
							[
								-81.4745862179999,
								28.504060033000087
							],
							[
								-81.47452984499995,
								28.504038866000087
							],
							[
								-81.47447623999994,
								28.504014578000067
							],
							[
								-81.47442433899994,
								28.50398683600008
							],
							[
								-81.47437436399991,
								28.503955759000064
							],
							[
								-81.47432652799995,
								28.503921480000088
							],
							[
								-81.4743010549999,
								28.503901192000058
							],
							[
								-81.47428312699992,
								28.503886373000057
							],
							[
								-81.47411023399991,
								28.50384863900007
							],
							[
								-81.47406923799991,
								28.50383867900007
							],
							[
								-81.47403492299992,
								28.503828749000036
							],
							[
								-81.47382592299994,
								28.503763749000086
							],
							[
								-81.47380392299993,
								28.503756595000084
							],
							[
								-81.47378688099991,
								28.503750619000073
							],
							[
								-81.47343500599993,
								28.50381055300005
							],
							[
								-81.47340138499993,
								28.503815628000044
							],
							[
								-81.47334281799994,
								28.503821396000035
							],
							[
								-81.47328399999992,
								28.503823322000073
							],
							[
								-81.47322518099992,
								28.503821396000035
							],
							[
								-81.47316661499991,
								28.503815628000044
							],
							[
								-81.47310855099994,
								28.503806042000065
							],
							[
								-81.47305123799993,
								28.50379267800008
							],
							[
								-81.47299961199991,
								28.50377717300006
							],
							[
								-81.47291561199995,
								28.503749173000074
							],
							[
								-81.47291092299992,
								28.50374759500005
							],
							[
								-81.47285584499991,
								28.50372686600008
							],
							[
								-81.47280223999991,
								28.50370257800006
							],
							[
								-81.47275033899992,
								28.503674836000073
							],
							[
								-81.47270036399993,
								28.503643759000056
							],
							[
								-81.47265252799991,
								28.50360948000008
							],
							[
								-81.47260703599994,
								28.503572146000067
							],
							[
								-81.47256408399994,
								28.503531917000092
							],
							[
								-81.47252385399992,
								28.503488965000088
							],
							[
								-81.47251522699992,
								28.50347898000007
							],
							[
								-81.47245222599992,
								28.50340497900004
							],
							[
								-81.47242351999995,
								28.503369472000088
							],
							[
								-81.47238924099992,
								28.503321636000067
							],
							[
								-81.4723581639999,
								28.503271661000042
							],
							[
								-81.4723304229999,
								28.503219760000036
							],
							[
								-81.47230613499994,
								28.503166155000088
							],
							[
								-81.47228540499992,
								28.503111077000085
							],
							[
								-81.47226832199993,
								28.503054761000044
							],
							[
								-81.47225495799995,
								28.502997449000077
							],
							[
								-81.47224537199992,
								28.502939385000047
							],
							[
								-81.47223960399992,
								28.50288081800005
							],
							[
								-81.47223767799994,
								28.502822000000037
							],
							[
								-81.47223960399992,
								28.502763181000034
							],
							[
								-81.47224537199992,
								28.502704615000084
							],
							[
								-81.4722467169999,
								28.50269481500004
							],
							[
								-81.47226771699991,
								28.502547816000064
							],
							[
								-81.4722759579999,
								28.502499551000085
							],
							[
								-81.47228932199994,
								28.50244223800007
							],
							[
								-81.47230640499993,
								28.50238592200009
							],
							[
								-81.47232713499994,
								28.502330844000085
							],
							[
								-81.4723514229999,
								28.502277240000073
							],
							[
								-81.4723791639999,
								28.502225339000063
							],
							[
								-81.47241024099992,
								28.50217536300005
							],
							[
								-81.47244087399991,
								28.50213231200007
							],
							[
								-81.47253528199991,
								28.50200755900005
							],
							[
								-81.47269281699994,
								28.501611118000085
							],
							[
								-81.4726987169999,
								28.501569817000075
							],
							[
								-81.47270695799995,
								28.501521551000053
							],
							[
								-81.47272032199993,
								28.50146423800004
							],
							[
								-81.47273740499992,
								28.501407922000055
							],
							[
								-81.47275813499994,
								28.501352844000053
							],
							[
								-81.4727824229999,
								28.501299240000037
							],
							[
								-81.47281016499994,
								28.501247339000088
							],
							[
								-81.47284124099991,
								28.501197363000074
							],
							[
								-81.47285552099993,
								28.501176627000063
							],
							[
								-81.4729605199999,
								28.501028628000086
							],
							[
								-81.47296314199991,
								28.50102495200008
							],
							[
								-81.47291208699994,
								28.500980192000043
							],
							[
								-81.47286908299992,
								28.50093991700004
							],
							[
								-81.47282885399994,
								28.50089696500004
							],
							[
								-81.47279151999993,
								28.50085147300007
							],
							[
								-81.4727572409999,
								28.500803637000047
							],
							[
								-81.47272616399994,
								28.50075366100009
							],
							[
								-81.47269910699993,
								28.500703145000045
							],
							[
								-81.4725937639999,
								28.500490453000054
							],
							[
								-81.47256913399991,
								28.500436155000045
							],
							[
								-81.47254840499994,
								28.500381077000043
							],
							[
								-81.4725313209999,
								28.50032476100006
							],
							[
								-81.47251795799991,
								28.500267449000035
							],
							[
								-81.47250837099995,
								28.500209385000062
							],
							[
								-81.47250260299995,
								28.500150818000066
							],
							[
								-81.4725006779999,
								28.500092000000052
							],
							[
								-81.47250230499992,
								28.50003791900008
							],
							[
								-81.47251230599996,
								28.499871919000043
							],
							[
								-81.47251260399992,
								28.49986718200006
							],
							[
								-81.47251837199991,
								28.499808615000063
							],
							[
								-81.47252795799994,
								28.49975055100009
							],
							[
								-81.47254132199993,
								28.499693238000077
							],
							[
								-81.47255840499992,
								28.499636923000082
							],
							[
								-81.47257913499993,
								28.49958184400009
							],
							[
								-81.4726034229999,
								28.499528240000075
							],
							[
								-81.47263116399995,
								28.49947633900007
							],
							[
								-81.47266224099991,
								28.499426364000044
							],
							[
								-81.47269651999994,
								28.49937852800008
							],
							[
								-81.47270218199992,
								28.499371226000054
							],
							[
								-81.47274779399993,
								28.49931303200009
							],
							[
								-81.47273389599991,
								28.499304334000044
							],
							[
								-81.47271136299992,
								28.499289759000078
							],
							[
								-81.47266352699995,
								28.499255480000045
							],
							[
								-81.47261803599991,
								28.499218146000093
							],
							[
								-81.47257508299992,
								28.499177917000054
							],
							[
								-81.47253485399995,
								28.499134964000064
							],
							[
								-81.47249702999994,
								28.499088834000077
							],
							[
								-81.47214197699992,
								28.498624401000086
							],
							[
								-81.47197952399995,
								28.49848208700007
							],
							[
								-81.4719499169999,
								28.498477411000067
							],
							[
								-81.47166791799992,
								28.498425412000074
							],
							[
								-81.47165555099991,
								28.49842304200007
							],
							[
								-81.4715982379999,
								28.498409678000087
							],
							[
								-81.4715419229999,
								28.49839259500004
							],
							[
								-81.47153349099995,
								28.498389686000053
							],
							[
								-81.47139213799994,
								28.498340134000046
							],
							[
								-81.47169648399995,
								28.49749384500007
							],
							[
								-81.47371497199993,
								28.49750575300004
							],
							[
								-81.47443545999994,
								28.497510004000052
							],
							[
								-81.47507399999996,
								28.497728000000052
							],
							[
								-81.47741599999996,
								28.49868500000008
							],
							[
								-81.47869858599995,
								28.499574644000063
							],
							[
								-81.48159399999992,
								28.50158300000004
							],
							[
								-81.48322899999994,
								28.502715000000084
							],
							[
								-81.48318599999993,
								28.50368300000008
							],
							[
								-81.48323099999993,
								28.50386400000008
							],
							[
								-81.4831089999999,
								28.50387100000006
							],
							[
								-81.4831089999999,
								28.503971000000035
							],
							[
								-81.4831099999999,
								28.503978500000073
							],
							[
								-81.48311099999995,
								28.503986000000054
							],
							[
								-81.48326299999991,
								28.503977000000077
							],
							[
								-81.4832869999999,
								28.504086000000086
							],
							[
								-81.4832904989999,
								28.504093999000077
							],
							[
								-81.48329399999994,
								28.504102000000046
							],
							[
								-81.48329399999994,
								28.504954000000055
							],
							[
								-81.4836259999999,
								28.504954000000055
							],
							[
								-81.4837599999999,
								28.505130000000065
							],
							[
								-81.48487099999994,
								28.50696000000005
							],
							[
								-81.48560299999991,
								28.508222000000046
							],
							[
								-81.48570799999993,
								28.508402000000046
							],
							[
								-81.48570799999993,
								28.50849100000005
							],
							[
								-81.4857629999999,
								28.509793000000062
							],
							[
								-81.48585399999992,
								28.51110200000005
							],
							[
								-81.48590799999994,
								28.51198100000005
							],
							[
								-81.4859449999999,
								28.512555000000077
							],
							[
								-81.48602499999993,
								28.51342100000005
							],
							[
								-81.48602799999992,
								28.513519000000088
							],
							[
								-81.48602999999991,
								28.513678000000084
							],
							[
								-81.48598399999992,
								28.513757000000055
							],
							[
								-81.48584899999992,
								28.513987000000043
							],
							[
								-81.48580199999992,
								28.51407400000005
							],
							[
								-81.48574799999994,
								28.51416400000005
							],
							[
								-81.48562399999992,
								28.514354000000083
							],
							[
								-81.48549999999994,
								28.514548000000048
							],
							[
								-81.4854699999999,
								28.51461100000006
							],
							[
								-81.48509899999993,
								28.51518800000008
							],
							[
								-81.48514099999994,
								28.515189000000078
							],
							[
								-81.48563652699994,
								28.51519202900005
							],
							[
								-81.4867769999999,
								28.515199000000052
							],
							[
								-81.48895399999992,
								28.515209000000084
							],
							[
								-81.48950899999996,
								28.51519200000007
							],
							[
								-81.49175599999995,
								28.51519200000007
							],
							[
								-81.4917779999999,
								28.50918500000006
							],
							[
								-81.49246199999993,
								28.509642000000042
							],
							[
								-81.49247999999994,
								28.50970200000006
							],
							[
								-81.49653799999993,
								28.512649000000067
							],
							[
								-81.49808399999995,
								28.513903000000084
							],
							[
								-81.49901599999993,
								28.51470000000006
							],
							[
								-81.50004399999995,
								28.51551900000004
							],
							[
								-81.50116699999995,
								28.516338000000076
							],
							[
								-81.50281499999994,
								28.517555000000073
							],
							[
								-81.5042729999999,
								28.518521000000078
							],
							[
								-81.50570599999992,
								28.519444000000078
							],
							[
								-81.50577799999992,
								28.519360000000063
							],
							[
								-81.50772999999992,
								28.520826000000056
							],
							[
								-81.50714299999993,
								28.521650000000083
							],
							[
								-81.50713721999995,
								28.52182761000006
							],
							[
								-81.50710099999992,
								28.521921000000077
							],
							[
								-81.50723499999992,
								28.52231500000005
							],
							[
								-81.50732763999991,
								28.522382677000053
							],
							[
								-81.50741999999991,
								28.52256900000009
							],
							[
								-81.50261899999992,
								28.522683000000086
							],
							[
								-81.49436999999995,
								28.52278300000006
							],
							[
								-81.49237099999995,
								28.522807000000057
							],
							[
								-81.49231127199994,
								28.522805875000074
							],
							[
								-81.49178699999993,
								28.522796000000085
							],
							[
								-81.49178699999993,
								28.51947009400004
							],
							[
								-81.49178699999993,
								28.519309000000078
							],
							[
								-81.48814099999993,
								28.519307000000087
							],
							[
								-81.48805199999993,
								28.519310000000075
							],
							[
								-81.48805199999993,
								28.520740000000046
							],
							[
								-81.48805199999993,
								28.52115500000008
							],
							[
								-81.48250499999995,
								28.52115500000008
							],
							[
								-81.48214899999995,
								28.521157000000073
							],
							[
								-81.48191099999991,
								28.521159000000072
							],
							[
								-81.48068699999993,
								28.521606000000077
							],
							[
								-81.47989899999995,
								28.52189300000009
							],
							[
								-81.47989899999995,
								28.52233100000007
							],
							[
								-81.47989902099994,
								28.52244014100006
							],
							[
								-81.47982970499993,
								28.522546153000064
							],
							[
								-81.47982475899994,
								28.522553637000044
							],
							[
								-81.4798099109999,
								28.522575173000064
							],
							[
								-81.47980859599994,
								28.522579078000035
							],
							[
								-81.47978786599992,
								28.522634156000038
							],
							[
								-81.47976357799992,
								28.522687760000053
							],
							[
								-81.47973583599992,
								28.52273966100006
							],
							[
								-81.4797047589999,
								28.522789637000074
							],
							[
								-81.47969733299993,
								28.522800577000055
							],
							[
								-81.4795973329999,
								28.52294557600004
							],
							[
								-81.4795719039999,
								28.522980613000072
							],
							[
								-81.47959157699995,
								28.52301824000006
							],
							[
								-81.47961586499991,
								28.52307184400007
							],
							[
								-81.47962761999992,
								28.523101722000035
							],
							[
								-81.4796966209999,
								28.52328672200008
							],
							[
								-81.47970559499993,
								28.52331192200006
							],
							[
								-81.4797226789999,
								28.523368238000046
							],
							[
								-81.4797360419999,
								28.52342555100006
							],
							[
								-81.47974562799993,
								28.52348361500009
							],
							[
								-81.47974980099993,
								28.523521492000043
							],
							[
								-81.47976480099993,
								28.52369049300006
							],
							[
								-81.47976639599995,
								28.523711182000056
							],
							[
								-81.47976832199993,
								28.52377000000007
							],
							[
								-81.47976639599995,
								28.523828819000073
							],
							[
								-81.47976062799995,
								28.52388738500008
							],
							[
								-81.47975882499992,
								28.523900349000087
							],
							[
								-81.47966082499994,
								28.524569348000057
							],
							[
								-81.47965304199994,
								28.52461444900007
							],
							[
								-81.47964214099994,
								28.52466236900006
							],
							[
								-81.47960214099993,
								28.52481836900006
							],
							[
								-81.47959967799994,
								28.52482776100004
							],
							[
								-81.4795825949999,
								28.52488407700008
							],
							[
								-81.47956186499994,
								28.524939155000084
							],
							[
								-81.47953757699992,
								28.52499276000009
							],
							[
								-81.47950983599992,
								28.525044661000038
							],
							[
								-81.4794787589999,
								28.525094636000063
							],
							[
								-81.47944447999994,
								28.525142472000084
							],
							[
								-81.47940714599991,
								28.525187964000054
							],
							[
								-81.47938947199992,
								28.525207530000046
							],
							[
								-81.47931852399995,
								28.525283800000068
							],
							[
								-81.47924196899993,
								28.525482752000073
							],
							[
								-81.47920908299994,
								28.525778125000045
							],
							[
								-81.4792159079999,
								28.525868736000064
							],
							[
								-81.47922500999994,
								28.52589521100009
							],
							[
								-81.47923051599992,
								28.525911846000042
							],
							[
								-81.47942147299995,
								28.526210217000084
							],
							[
								-81.47944283599992,
								28.52624533900007
							],
							[
								-81.4794705779999,
								28.526297240000076
							],
							[
								-81.47949486599992,
								28.52635084500008
							],
							[
								-81.47949701499994,
								28.526356080000085
							],
							[
								-81.47958001399991,
								28.526560079000035
							],
							[
								-81.47959859499991,
								28.526609922000034
							],
							[
								-81.47961567799992,
								28.526666238000075
							],
							[
								-81.47962904199994,
								28.52672355100009
							],
							[
								-81.47963862799993,
								28.52678161500006
							],
							[
								-81.47964439599991,
								28.52684018100007
							],
							[
								-81.47964632199995,
								28.52689900000007
							],
							[
								-81.47964476999994,
								28.52695181200005
							],
							[
								-81.47964176999994,
								28.527002812000035
							],
							[
								-81.47964139599992,
								28.527008819000063
							],
							[
								-81.47963562799993,
								28.527067385000066
							],
							[
								-81.4796260409999,
								28.52712544900004
							],
							[
								-81.47961267799991,
								28.527182762000052
							],
							[
								-81.47959559499992,
								28.527239078000036
							],
							[
								-81.4795748649999,
								28.52729415600004
							],
							[
								-81.4795648299999,
								28.527316303000077
							],
							[
								-81.47957155799992,
								28.52733096700007
							],
							[
								-81.47964990499992,
								28.52734285400004
							],
							[
								-81.47969044899992,
								28.52734995800006
							],
							[
								-81.47974776199993,
								28.527363322000042
							],
							[
								-81.47980407799992,
								28.527380405000088
							],
							[
								-81.47985915599992,
								28.527401135000048
							],
							[
								-81.4798999649999,
								28.52741962500005
							],
							[
								-81.47989999999993,
								28.527606000000052
							],
							[
								-81.47848199999993,
								28.527512000000062
							],
							[
								-81.47813307899992,
								28.527529875000084
							],
							[
								-81.47799399999991,
								28.527537000000052
							],
							[
								-81.47799499999991,
								28.527592000000084
							],
							[
								-81.47782999999993,
								28.52759400000008
							],
							[
								-81.47775237499991,
								28.52762617700006
							],
							[
								-81.47679825099995,
								28.528021676000037
							],
							[
								-81.47577699999994,
								28.52844500000009
							],
							[
								-81.47556199999991,
								28.528448000000086
							],
							[
								-81.47542799999991,
								28.528458000000057
							],
							[
								-81.47543299999995,
								28.52853200000004
							],
							[
								-81.47543575399993,
								28.528702082000052
							],
							[
								-81.47543699999994,
								28.528779000000043
							],
							[
								-81.4755199999999,
								28.530271000000084
							],
							[
								-81.47551758699991,
								28.530334939000056
							],
							[
								-81.47551399999992,
								28.53043000000008
							],
							[
								-81.47553399999993,
								28.531376000000083
							],
							[
								-81.47555899999992,
								28.531784000000073
							],
							[
								-81.47555999999992,
								28.533441000000042
							],
							[
								-81.47555899999992,
								28.534038000000066
							],
							[
								-81.47479399999992,
								28.534080000000074
							],
							[
								-81.47420142999994,
								28.534080000000074
							],
							[
								-81.47389399999992,
								28.534080000000074
							],
							[
								-81.4721257249999,
								28.53408379700005
							],
							[
								-81.47209886399992,
								28.534083855000063
							],
							[
								-81.4720309999999,
								28.534084000000064
							],
							[
								-81.47129080899992,
								28.534080224000036
							]
						],
						[
							[
								-81.47995918099993,
								28.50951460300007
							],
							[
								-81.48001799999992,
								28.50951267800008
							],
							[
								-81.48006710999994,
								28.50951402000004
							],
							[
								-81.48008040199994,
								28.509514567000053
							],
							[
								-81.48007460299993,
								28.50945581800005
							],
							[
								-81.48007267799994,
								28.509397000000035
							],
							[
								-81.4800742299999,
								28.509344187000067
							],
							[
								-81.48007722999995,
								28.509293187000086
							],
							[
								-81.48007760299993,
								28.509287181000047
							],
							[
								-81.48008337199991,
								28.50922861500004
							],
							[
								-81.48009295799994,
								28.509170551000068
							],
							[
								-81.48009794699993,
								28.509147108000036
							],
							[
								-81.48007939299993,
								28.509139721000054
							],
							[
								-81.47989087999991,
								28.509073942000043
							],
							[
								-81.47965163799995,
								28.50900788300004
							],
							[
								-81.4796019229999,
								28.508992595000052
							],
							[
								-81.47955114899992,
								28.508973635000075
							],
							[
								-81.47937943499994,
								28.508903548000035
							],
							[
								-81.4791232579999,
								28.50881602800007
							],
							[
								-81.47907593699995,
								28.50879836300004
							],
							[
								-81.47875793599991,
								28.508669362000035
							],
							[
								-81.47875184399993,
								28.508666865000066
							],
							[
								-81.47869823999991,
								28.508642577000046
							],
							[
								-81.47864633899991,
								28.50861483500006
							],
							[
								-81.47859636299995,
								28.508583759000093
							],
							[
								-81.47854865399995,
								28.508549577000053
							],
							[
								-81.47837258999994,
								28.50841452900005
							],
							[
								-81.47833046799991,
								28.508380141000092
							],
							[
								-81.47818646799993,
								28.508255141000063
							],
							[
								-81.4781830359999,
								28.508252146000075
							],
							[
								-81.47814008299991,
								28.50821191700004
							],
							[
								-81.47809985399994,
								28.50816896400005
							],
							[
								-81.47806251999992,
								28.50812347300007
							],
							[
								-81.47802824099995,
								28.508075637000047
							],
							[
								-81.47799716399993,
								28.50802566100009
							],
							[
								-81.47796942299993,
								28.507973760000084
							],
							[
								-81.47796071199993,
								28.507955586000037
							],
							[
								-81.47784571199992,
								28.507708586000035
							],
							[
								-81.47783013499992,
								28.507673155000077
							],
							[
								-81.4778094049999,
								28.507618077000075
							],
							[
								-81.47779232199991,
								28.507561761000094
							],
							[
								-81.47777895799993,
								28.507504449000066
							],
							[
								-81.47776937199991,
								28.507446385000037
							],
							[
								-81.4777636039999,
								28.507387818000044
							],
							[
								-81.47776167799992,
								28.507329000000084
							],
							[
								-81.4777620989999,
								28.50730148100007
							],
							[
								-81.4777650989999,
								28.50720348100009
							],
							[
								-81.4777666039999,
								28.507172181000044
							],
							[
								-81.47777237199995,
								28.507113615000037
							],
							[
								-81.47778195899991,
								28.507055551000064
							],
							[
								-81.4777953219999,
								28.50699823800005
							],
							[
								-81.47781240499995,
								28.506941922000067
							],
							[
								-81.47783313499991,
								28.506886844000068
							],
							[
								-81.47785268899992,
								28.506842986000038
							],
							[
								-81.47789668899992,
								28.506750986000043
							],
							[
								-81.47790142199995,
								28.506741240000053
							],
							[
								-81.47792916399993,
								28.506689339000047
							],
							[
								-81.47796024099995,
								28.50663936300009
							],
							[
								-81.47799451999992,
								28.50659152700007
							],
							[
								-81.47803185399995,
								28.50654603600009
							],
							[
								-81.47807208299992,
								28.50650308300004
							],
							[
								-81.47808349099995,
								28.506492398000034
							],
							[
								-81.47779358799994,
								28.506393243000048
							],
							[
								-81.47769428499993,
								28.50637200500006
							],
							[
								-81.4774960279999,
								28.506339582000066
							],
							[
								-81.47749886499993,
								28.506345844000066
							],
							[
								-81.47751959499993,
								28.50640092200007
							],
							[
								-81.47753667799992,
								28.506457238000053
							],
							[
								-81.4775500419999,
								28.50651455100007
							],
							[
								-81.47755962799994,
								28.50657261500004
							],
							[
								-81.47756539699992,
								28.506631181000046
							],
							[
								-81.47756732199991,
								28.50669000000005
							],
							[
								-81.47756539699992,
								28.506748818000062
							],
							[
								-81.47755962799994,
								28.50680738500006
							],
							[
								-81.47755816999995,
								28.506817974000057
							],
							[
								-81.47749016999991,
								28.507290975000046
							],
							[
								-81.47748204099992,
								28.507338449000088
							],
							[
								-81.47746867799992,
								28.507395762000044
							],
							[
								-81.47746018099991,
								28.507425427000044
							],
							[
								-81.4773180919999,
								28.507891166000036
							],
							[
								-81.47719304899994,
								28.508323484000073
							],
							[
								-81.47707314399992,
								28.508766291000086
							],
							[
								-81.47723104199991,
								28.508824920000052
							],
							[
								-81.47726215599994,
								28.50883713500008
							],
							[
								-81.47731575999991,
								28.508861423000045
							],
							[
								-81.4773676609999,
								28.508889165000085
							],
							[
								-81.47740782699992,
								28.508913779000068
							],
							[
								-81.47756771799993,
								28.509017620000066
							],
							[
								-81.47767051999995,
								28.50904756600005
							],
							[
								-81.47770807699993,
								28.509059405000073
							],
							[
								-81.47776315499993,
								28.50908013500009
							],
							[
								-81.47781675999994,
								28.509104423000053
							],
							[
								-81.47786866099995,
								28.509132164000054
							],
							[
								-81.47791863599991,
								28.509163241000067
							],
							[
								-81.47796647199993,
								28.509197520000043
							],
							[
								-81.4780119639999,
								28.50923485400006
							],
							[
								-81.47803014399994,
								28.509251240000083
							],
							[
								-81.47817699299992,
								28.50938726800007
							],
							[
								-81.47827143599994,
								28.50945420000005
							],
							[
								-81.47851072499992,
								28.509549492000076
							],
							[
								-81.47852215499995,
								28.509554135000087
							],
							[
								-81.4785757599999,
								28.50957842300005
							],
							[
								-81.4786276609999,
								28.509606164000047
							],
							[
								-81.47867763599993,
								28.509637241000064
							],
							[
								-81.47871901099991,
								28.50966660800009
							],
							[
								-81.47888101099994,
								28.509788609000058
							],
							[
								-81.47888747199995,
								28.509793520000073
							],
							[
								-81.47893296399991,
								28.509830854000086
							],
							[
								-81.47897052499991,
								28.509866034000083
							],
							[
								-81.47899108299994,
								28.509844083000075
							],
							[
								-81.47903403599992,
								28.50980385400004
							],
							[
								-81.4790795269999,
								28.509766520000085
							],
							[
								-81.47908316899992,
								28.50976374000004
							],
							[
								-81.4791371689999,
								28.509722740000086
							],
							[
								-81.47918136299995,
								28.50969124100004
							],
							[
								-81.47923133899991,
								28.50966016400008
							],
							[
								-81.47928323999992,
								28.509632423000088
							],
							[
								-81.47933684399993,
								28.509608135000065
							],
							[
								-81.47939192199993,
								28.509587405000048
							],
							[
								-81.47944823799992,
								28.50957032200006
							],
							[
								-81.47950555099995,
								28.509556958000076
							],
							[
								-81.4795636149999,
								28.509547372000043
							],
							[
								-81.47960917599994,
								28.509542551000038
							],
							[
								-81.47994617699993,
								28.50951555000006
							],
							[
								-81.47995918099993,
								28.50951460300007
							]
						]
					],
					[
						[
							[
								-81.48424599999993,
								28.50490700000006
							],
							[
								-81.4856069999999,
								28.50446000000005
							],
							[
								-81.48967499999992,
								28.507595000000038
							],
							[
								-81.4878339999999,
								28.507596000000035
							],
							[
								-81.48775199999994,
								28.51171500000004
							],
							[
								-81.48724499999992,
								28.511851000000036
							],
							[
								-81.48721599999993,
								28.511850000000038
							],
							[
								-81.48613499999995,
								28.51182300000005
							],
							[
								-81.48592799999994,
								28.508977000000073
							],
							[
								-81.48591999999991,
								28.50834700000007
							],
							[
								-81.48582799999991,
								28.50820500000009
							],
							[
								-81.48533799999991,
								28.50734300000005
							],
							[
								-81.48469399999993,
								28.506147000000055
							],
							[
								-81.4841899999999,
								28.505324000000087
							],
							[
								-81.48401499999994,
								28.505021000000056
							],
							[
								-81.48424599999993,
								28.50490700000006
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Metro West",
				"RegionID": "269087"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.68935395699992,
					30.33441810100004,
					-81.66884083799994,
					30.345043048000033
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.6690232329999,
							30.336571727000038
						],
						[
							-81.66983294699992,
							30.335170302000055
						],
						[
							-81.67040593599995,
							30.33441810100004
						],
						[
							-81.67143190699994,
							30.33478100800005
						],
						[
							-81.6715789079999,
							30.334817008000073
						],
						[
							-81.67168390699993,
							30.334843009000053
						],
						[
							-81.67185190799995,
							30.334883009000063
						],
						[
							-81.6720959079999,
							30.334963009000038
						],
						[
							-81.67235590799993,
							30.335052008000048
						],
						[
							-81.67279790399994,
							30.335218008000087
						],
						[
							-81.67339090799993,
							30.33545600900004
						],
						[
							-81.67346290799992,
							30.335484008000037
						],
						[
							-81.67349690399993,
							30.335494009000058
						],
						[
							-81.67353090799993,
							30.335506009000085
						],
						[
							-81.67425490699992,
							30.33577300800005
						],
						[
							-81.67498790799993,
							30.33604200800005
						],
						[
							-81.67545290799991,
							30.336224008000045
						],
						[
							-81.67572790799994,
							30.336321008000084
						],
						[
							-81.67604790699994,
							30.33641600800007
						],
						[
							-81.67645390699994,
							30.336509009000057
						],
						[
							-81.6765609069999,
							30.336528008000077
						],
						[
							-81.67664090799991,
							30.336538008000044
						],
						[
							-81.67672790799992,
							30.336538008000044
						],
						[
							-81.6768459079999,
							30.33653800700006
						],
						[
							-81.6770059079999,
							30.33651200900005
						],
						[
							-81.67784490699995,
							30.336359008000045
						],
						[
							-81.67835190699992,
							30.33627500900008
						],
						[
							-81.67898090699993,
							30.33616700800007
						],
						[
							-81.67923690299995,
							30.336123008000072
						],
						[
							-81.68004590699991,
							30.33598100800009
						],
						[
							-81.68089290699993,
							30.33582300900008
						],
						[
							-81.68192290699994,
							30.33565500800006
						],
						[
							-81.68315890799994,
							30.335440008000035
						],
						[
							-81.6856079069999,
							30.33502300900005
						],
						[
							-81.68587901399991,
							30.334982934000042
						],
						[
							-81.68935395699992,
							30.337241031000072
						],
						[
							-81.6892578959999,
							30.337397997000036
						],
						[
							-81.6868170759999,
							30.339697873000034
						],
						[
							-81.6867258769999,
							30.341799380000058
						],
						[
							-81.68645085999992,
							30.345043048000033
						],
						[
							-81.68597290399993,
							30.344856009000072
						],
						[
							-81.68549990699996,
							30.34466900800004
						],
						[
							-81.6848229069999,
							30.344408009000063
						],
						[
							-81.68415790599994,
							30.344145008000055
						],
						[
							-81.68393990699991,
							30.344056008000052
						],
						[
							-81.68320190599991,
							30.34378300800006
						],
						[
							-81.6829379049999,
							30.343660009000075
						],
						[
							-81.6821669069999,
							30.343376008000067
						],
						[
							-81.68202190599993,
							30.343319008000037
						],
						[
							-81.68060290699992,
							30.342762008000083
						],
						[
							-81.67977090599993,
							30.34243200900005
						],
						[
							-81.67938190599995,
							30.34229000800008
						],
						[
							-81.6782529059999,
							30.341837009000074
						],
						[
							-81.67775690499991,
							30.341642009000054
						],
						[
							-81.67727690599992,
							30.341461008000064
						],
						[
							-81.67663590599994,
							30.34121700800006
						],
						[
							-81.67590290699991,
							30.340935009000077
						],
						[
							-81.67552890699994,
							30.340765008000062
						],
						[
							-81.67539990799992,
							30.340704009000035
						],
						[
							-81.6744689059999,
							30.340328009000075
						],
						[
							-81.67429390599995,
							30.340260008000087
						],
						[
							-81.67373690699992,
							30.340034009000075
						],
						[
							-81.6730269059999,
							30.33974600900007
						],
						[
							-81.67228690999991,
							30.33944300800005
						],
						[
							-81.67123090599995,
							30.338708009000076
						],
						[
							-81.67102090699991,
							30.338556009000058
						],
						[
							-81.67086590499991,
							30.33845000900004
						],
						[
							-81.67045490699991,
							30.33821500800008
						],
						[
							-81.67020390699992,
							30.338051008000036
						],
						[
							-81.67003870299993,
							30.337945897000054
						],
						[
							-81.66973990699995,
							30.337709008000044
						],
						[
							-81.66945692299993,
							30.337503475000062
						],
						[
							-81.66938090499991,
							30.33744500800009
						],
						[
							-81.66928990699995,
							30.337374008000044
						],
						[
							-81.6691589049999,
							30.337279008000056
						],
						[
							-81.66907890599992,
							30.337221008000085
						],
						[
							-81.66884083799994,
							30.337044070000044
						],
						[
							-81.6690232329999,
							30.336571727000038
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "New Town",
				"RegionID": "269101"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.47292990999995,
					30.318383935000043,
					-81.43787005599995,
					30.373983322000072
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.4515674559999,
							30.372676918000085
						],
						[
							-81.45099743499992,
							30.372241940000038
						],
						[
							-81.45088355599995,
							30.372138485000047
						],
						[
							-81.44976155599994,
							30.370928485000036
						],
						[
							-81.44971468499995,
							30.37087368500005
						],
						[
							-81.44967235399992,
							30.370815307000044
						],
						[
							-81.44963483799995,
							30.370753725000043
						],
						[
							-81.44960237499993,
							30.37068933600006
						],
						[
							-81.44957517599994,
							30.370622552000047
						],
						[
							-81.44955341499991,
							30.370553804000057
						],
						[
							-81.44952880199992,
							30.37046363000007
						],
						[
							-81.44861605499995,
							30.36985266700009
						],
						[
							-81.44811845399994,
							30.36938034100007
						],
						[
							-81.44753033799992,
							30.36876791100008
						],
						[
							-81.44744655499994,
							30.36866682800007
						],
						[
							-81.44611855499994,
							30.36680282800006
						],
						[
							-81.44608543899994,
							30.36675290800008
						],
						[
							-81.44528443899992,
							30.365453473000063
						],
						[
							-81.44511878599991,
							30.365184740000075
						],
						[
							-81.44503443999992,
							30.365047908000065
						],
						[
							-81.44502116399991,
							30.365025661000058
						],
						[
							-81.44495491399994,
							30.36488358600008
						],
						[
							-81.4449143409999,
							30.36473216500008
						],
						[
							-81.4449006779999,
							30.364576000000053
						],
						[
							-81.44490711599991,
							30.36446858400006
						],
						[
							-81.44494791099993,
							30.364129476000073
						],
						[
							-81.44493523599994,
							30.364089328000038
						],
						[
							-81.44474753699991,
							30.363994227000035
						],
						[
							-81.44470433899994,
							30.36397083500009
						],
						[
							-81.4445759269999,
							30.363880920000046
						],
						[
							-81.44446507899994,
							30.36377007300007
						],
						[
							-81.44437516399995,
							30.363641661000088
						],
						[
							-81.44430891399993,
							30.363499586000046
						],
						[
							-81.44429014299993,
							30.363442064000086
						],
						[
							-81.44414341999993,
							30.362935203000063
						],
						[
							-81.44363079599992,
							30.361485840000057
						],
						[
							-81.44232987099993,
							30.35945632100004
						],
						[
							-81.44227780699993,
							30.35936341100006
						],
						[
							-81.44116647099992,
							30.357071717000053
						],
						[
							-81.43969013599991,
							30.354014024000033
						],
						[
							-81.43966253299993,
							30.35395076300006
						],
						[
							-81.43963986299991,
							30.35388557200008
						],
						[
							-81.43962225899993,
							30.35381883500008
						],
						[
							-81.43960982599992,
							30.35375094400007
						],
						[
							-81.43960263499991,
							30.35368229900007
						],
						[
							-81.43960072999994,
							30.353613305000067
						],
						[
							-81.43960412199995,
							30.353544368000087
						],
						[
							-81.43969312199994,
							30.352530368000085
						],
						[
							-81.43970792399995,
							30.352428765000067
						],
						[
							-81.43998592399993,
							30.351069765000087
						],
						[
							-81.44002191399994,
							30.350942414000084
						],
						[
							-81.44007246399991,
							30.35083400900004
						],
						[
							-81.4400048729999,
							30.349827429000072
						],
						[
							-81.43953013499993,
							30.34754887300005
						],
						[
							-81.43883891099995,
							30.345115765000056
						],
						[
							-81.43883300499994,
							30.345093937000062
						],
						[
							-81.43845300499993,
							30.343615936000052
						],
						[
							-81.43843864299993,
							30.343549868000085
						],
						[
							-81.43842928399994,
							30.34348290700007
						],
						[
							-81.43842498299995,
							30.343415432000086
						],
						[
							-81.43842576399993,
							30.343347824000034
						],
						[
							-81.43851535099992,
							30.34152621400006
						],
						[
							-81.43787363599995,
							30.335440304000088
						],
						[
							-81.43787005599995,
							30.33529624900007
						],
						[
							-81.43793205499992,
							30.33417724800006
						],
						[
							-81.4379477249999,
							30.334052728000074
						],
						[
							-81.43841072499993,
							30.33170872800008
						],
						[
							-81.43844791399995,
							30.331575414000046
						],
						[
							-81.43846428599994,
							30.331533696000065
						],
						[
							-81.4386408819999,
							30.331114729000035
						],
						[
							-81.43864167899994,
							30.330402993000064
						],
						[
							-81.4386553409999,
							30.330247834000094
						],
						[
							-81.43868700799993,
							30.330122082000056
						],
						[
							-81.43899500799995,
							30.329189082000084
						],
						[
							-81.4390039139999,
							30.32916341400005
						],
						[
							-81.4390729619999,
							30.329016561000063
						],
						[
							-81.43961812299995,
							30.328098540000045
						],
						[
							-81.43953764999992,
							30.326368794000075
						],
						[
							-81.43954045099991,
							30.326244702000057
						],
						[
							-81.4396334509999,
							30.32523270200005
						],
						[
							-81.43964322699992,
							30.325158203000058
						],
						[
							-81.43965939399993,
							30.32508482600008
						],
						[
							-81.4396818319999,
							30.325013117000086
						],
						[
							-81.4397103739999,
							30.324943611000037
						],
						[
							-81.4397448069999,
							30.324876828000075
						],
						[
							-81.43973346899992,
							30.32486063600004
						],
						[
							-81.43962152499995,
							30.32489523000004
						],
						[
							-81.43951216499994,
							30.324921659000044
						],
						[
							-81.4393561949999,
							30.324935305000054
						],
						[
							-81.43933428999992,
							30.325030225000035
						],
						[
							-81.43931560999994,
							30.32509871100007
						],
						[
							-81.4392915869999,
							30.325165509000044
						],
						[
							-81.43926236999994,
							30.325230205000086
						],
						[
							-81.43922814099994,
							30.325292394000083
						],
						[
							-81.43918911399993,
							30.325351691000037
						],
						[
							-81.43914553199994,
							30.32540772400006
						],
						[
							-81.43909766599995,
							30.32546014500008
						],
						[
							-81.43904581399994,
							30.32550862800008
						],
						[
							-81.43886494299994,
							30.325664774000074
						],
						[
							-81.4387316609999,
							30.325758836000038
						],
						[
							-81.43862725899993,
							30.325810407000063
						],
						[
							-81.43837449499995,
							30.325915499000075
						],
						[
							-81.43842199999995,
							30.325113000000044
						],
						[
							-81.43851483899994,
							30.323537555000087
						],
						[
							-81.43906450399993,
							30.323424548000048
						],
						[
							-81.44064791099993,
							30.32309901200006
						],
						[
							-81.44093690799991,
							30.32304801300006
						],
						[
							-81.44165190899992,
							30.32292501200004
						],
						[
							-81.4418129089999,
							30.322897012000055
						],
						[
							-81.44349090899993,
							30.322540013000037
						],
						[
							-81.44422190799992,
							30.32238601300008
						],
						[
							-81.44439090899994,
							30.322339012000043
						],
						[
							-81.44532991099993,
							30.322078013000066
						],
						[
							-81.44606290999991,
							30.32193301200005
						],
						[
							-81.4469489089999,
							30.321738012000086
						],
						[
							-81.44794690799995,
							30.321496012000072
						],
						[
							-81.44885390999991,
							30.321280013000035
						],
						[
							-81.44924491099994,
							30.321189012000044
						],
						[
							-81.44976190799993,
							30.32109301200006
						],
						[
							-81.45014591099994,
							30.32104501300006
						],
						[
							-81.45051389499993,
							30.321014104000085
						],
						[
							-81.45206390699991,
							30.320886012000074
						],
						[
							-81.45259991099994,
							30.320845012000067
						],
						[
							-81.45346490799994,
							30.320781012000054
						],
						[
							-81.45517091099993,
							30.320655012000092
						],
						[
							-81.45650291099993,
							30.320543012000087
						],
						[
							-81.4566839119999,
							30.32053001200006
						],
						[
							-81.45859991099991,
							30.32039101200007
						],
						[
							-81.4593629069999,
							30.320343012000077
						],
						[
							-81.46036990699992,
							30.320259013000054
						],
						[
							-81.46065390799993,
							30.320238012000065
						],
						[
							-81.46283990799994,
							30.320079012000065
						],
						[
							-81.46479691199994,
							30.319926013000043
						],
						[
							-81.46557391099992,
							30.319866012000038
						],
						[
							-81.46736490799992,
							30.319734013000073
						],
						[
							-81.46777490799991,
							30.31969801200006
						],
						[
							-81.46812890799993,
							30.319674013000053
						],
						[
							-81.46835090699994,
							30.319662012000038
						],
						[
							-81.46857990799992,
							30.319650012000068
						],
						[
							-81.46891291199995,
							30.319620013000073
						],
						[
							-81.4691629109999,
							30.319590012000045
						],
						[
							-81.4693779079999,
							30.31956301200006
						],
						[
							-81.4699679119999,
							30.319449013000053
						],
						[
							-81.47026590699994,
							30.319377012000075
						],
						[
							-81.47050890799994,
							30.319306013000073
						],
						[
							-81.47075891199995,
							30.319228012000053
						],
						[
							-81.4712939069999,
							30.319036012000083
						],
						[
							-81.47193190799995,
							30.31877801300004
						],
						[
							-81.47288286299994,
							30.318383935000043
						],
						[
							-81.4729189059999,
							30.31848301200006
						],
						[
							-81.47292990999995,
							30.31855401000007
						],
						[
							-81.47291890699995,
							30.318725012000073
						],
						[
							-81.47270391199993,
							30.320199013000035
						],
						[
							-81.47260190799994,
							30.320983013000042
						],
						[
							-81.47250591199992,
							30.322070012000044
						],
						[
							-81.47244791199995,
							30.322543013000086
						],
						[
							-81.47233490699995,
							30.323637013000056
						],
						[
							-81.4722669109999,
							30.324127013000066
						],
						[
							-81.47222890799992,
							30.324420012000072
						],
						[
							-81.47217590699995,
							30.32482901200007
						],
						[
							-81.4721529119999,
							30.325085012000045
						],
						[
							-81.47190091199991,
							30.32724801200004
						],
						[
							-81.47185490699991,
							30.327532012000063
						],
						[
							-81.47177890699993,
							30.327841012000075
						],
						[
							-81.4717249119999,
							30.327999012000078
						],
						[
							-81.4715879069999,
							30.32830001200006
						],
						[
							-81.4713819079999,
							30.32867101200009
						],
						[
							-81.47091990799993,
							30.32933401300005
						],
						[
							-81.47052990799995,
							30.32989701300005
						],
						[
							-81.4703059119999,
							30.330223012000094
						],
						[
							-81.46992490699995,
							30.33076101200004
						],
						[
							-81.46876490699992,
							30.332462012000065
						],
						[
							-81.4685439079999,
							30.332764013000087
						],
						[
							-81.46842191099995,
							30.332979013000053
						],
						[
							-81.46572091199994,
							30.33693101200004
						],
						[
							-81.46543090699993,
							30.337376013000043
						],
						[
							-81.46506490799993,
							30.337898013000082
						],
						[
							-81.46493490699993,
							30.338055012000044
						],
						[
							-81.46481290899993,
							30.338175013000072
						],
						[
							-81.46451591099994,
							30.33836701200005
						],
						[
							-81.46404990799994,
							30.338589012000057
						],
						[
							-81.4626689079999,
							30.33922201300004
						],
						[
							-81.4624939119999,
							30.339325013000064
						],
						[
							-81.46232590699992,
							30.33945701300007
						],
						[
							-81.46223391199993,
							30.339542012000038
						],
						[
							-81.46207391199994,
							30.339735013000052
						],
						[
							-81.4620209119999,
							30.339813013000086
						],
						[
							-81.4619059129999,
							30.34002501300006
						],
						[
							-81.46183790999993,
							30.340221011000043
						],
						[
							-81.4617919069999,
							30.340567013000058
						],
						[
							-81.46166190799994,
							30.34181001200005
						],
						[
							-81.46153690799991,
							30.342898012000035
						],
						[
							-81.46148991199993,
							30.343325013000086
						],
						[
							-81.46144690799991,
							30.343713013000066
						],
						[
							-81.46121990799992,
							30.34585201200008
						],
						[
							-81.46116591099991,
							30.346466013000057
						],
						[
							-81.46102891099991,
							30.347635013000062
						],
						[
							-81.46101190799995,
							30.347901012000076
						],
						[
							-81.4608889079999,
							30.348883012000048
						],
						[
							-81.4608039119999,
							30.349748012000077
						],
						[
							-81.46073490799995,
							30.350330013000075
						],
						[
							-81.46060890699994,
							30.351667012000064
						],
						[
							-81.46056390699994,
							30.352081013000088
						],
						[
							-81.46054791299991,
							30.35234101200007
						],
						[
							-81.46057090799991,
							30.352633012000073
						],
						[
							-81.4606699069999,
							30.353084012000068
						],
						[
							-81.4611209119999,
							30.35488101200008
						],
						[
							-81.4612049079999,
							30.355165012000047
						],
						[
							-81.4612699079999,
							30.355323013000092
						],
						[
							-81.46130390799993,
							30.355406012000056
						],
						[
							-81.46151690799991,
							30.35579301200005
						],
						[
							-81.46163891199991,
							30.355963013000064
						],
						[
							-81.46180691099994,
							30.356165012000076
						],
						[
							-81.46204390799994,
							30.356403012000044
						],
						[
							-81.46209690799992,
							30.356447012000046
						],
						[
							-81.46247990699995,
							30.35672701300007
						],
						[
							-81.46258490499991,
							30.356823011000078
						],
						[
							-81.46278695399991,
							30.35710398500004
						],
						[
							-81.46282176799991,
							30.35720613100005
						],
						[
							-81.46290990799992,
							30.35725701300004
						],
						[
							-81.46328791299993,
							30.357437015000073
						],
						[
							-81.4636589079999,
							30.357732012000046
						],
						[
							-81.46381890799996,
							30.357839013000046
						],
						[
							-81.46430390799992,
							30.358143012000085
						],
						[
							-81.46443193399995,
							30.35819996600009
						],
						[
							-81.4646059069999,
							30.35834201200004
						],
						[
							-81.46467087199994,
							30.358394088000068
						],
						[
							-81.46478190699992,
							30.358417012000075
						],
						[
							-81.46510190799995,
							30.35845601200009
						],
						[
							-81.46538791199994,
							30.358473012000047
						],
						[
							-81.46546103199995,
							30.35847193500007
						],
						[
							-81.46751815699992,
							30.360381421000056
						],
						[
							-81.46621579999993,
							30.36211752500009
						],
						[
							-81.46592634599995,
							30.363564370000063
						],
						[
							-81.46693933499995,
							30.364866384000038
						],
						[
							-81.46708410999992,
							30.366168564000077
						],
						[
							-81.46690956799996,
							30.366342488000043
						],
						[
							-81.46663760299992,
							30.36654320000008
						],
						[
							-81.46728219799991,
							30.367362372000063
						],
						[
							-81.46773878599993,
							30.367859248000055
						],
						[
							-81.4680879419999,
							30.368114400000085
						],
						[
							-81.4686519629999,
							30.368396410000063
						],
						[
							-81.4691891249999,
							30.368597846000057
						],
						[
							-81.46961885499991,
							30.36896043100006
						],
						[
							-81.46979343299995,
							30.36934987400008
						],
						[
							-81.4698874369999,
							30.369712459000084
						],
						[
							-81.46909512199994,
							30.37042419900007
						],
						[
							-81.46867882099991,
							30.371001649000053
						],
						[
							-81.46803422599993,
							30.371605957000043
						],
						[
							-81.46737620199991,
							30.372129691000055
						],
						[
							-81.4669196129999,
							30.372344556000087
						],
						[
							-81.46604672399991,
							30.372572850000036
						],
						[
							-81.46506640199993,
							30.372733998000058
						],
						[
							-81.46405922299994,
							30.372922005000074
						],
						[
							-81.4634817729999,
							30.37317715800009
						],
						[
							-81.46326690799992,
							30.373472597000045
						],
						[
							-81.46320544399993,
							30.373667474000058
						],
						[
							-81.46316101499991,
							30.373677209000054
						],
						[
							-81.46177101399991,
							30.373917209000066
						],
						[
							-81.46169802799994,
							30.37392675400008
						],
						[
							-81.46162450399993,
							30.37393029800006
						],
						[
							-81.4615509379999,
							30.373927818000084
						],
						[
							-81.46147782099992,
							30.373919330000035
						],
						[
							-81.46140564199993,
							30.37390489000006
						],
						[
							-81.46133488699991,
							30.37388459700008
						],
						[
							-81.4609338869999,
							30.37375159700008
						],
						[
							-81.46086084699995,
							30.373723794000057
						],
						[
							-81.46079049699995,
							30.373689755000047
						],
						[
							-81.46072336799995,
							30.37364973600006
						],
						[
							-81.46065996699991,
							30.373604041000082
						],
						[
							-81.4606007719999,
							30.373553014000034
						],
						[
							-81.46054623099991,
							30.37349704000007
						],
						[
							-81.46039699699992,
							30.373329936000065
						],
						[
							-81.45867457299994,
							30.372758085000047
						],
						[
							-81.45726233999994,
							30.372486990000088
						],
						[
							-81.45649638399993,
							30.37268176100008
						],
						[
							-81.45401760099992,
							30.37389212700009
						],
						[
							-81.4539305859999,
							30.37392908600009
						],
						[
							-81.45377916599995,
							30.373969659000068
						],
						[
							-81.45362299999994,
							30.373983322000072
						],
						[
							-81.45346683399993,
							30.373969659000068
						],
						[
							-81.45333445799992,
							30.373935776000053
						],
						[
							-81.45222745799992,
							30.37356077700008
						],
						[
							-81.45220841399993,
							30.37355408700006
						],
						[
							-81.45206633899994,
							30.373487836000034
						],
						[
							-81.4519379269999,
							30.37339792100005
						],
						[
							-81.45182707899995,
							30.373287073000085
						],
						[
							-81.45173716399995,
							30.373158661000048
						],
						[
							-81.45167091399992,
							30.373016587000052
						],
						[
							-81.45165460599992,
							30.372967418000087
						],
						[
							-81.4515674559999,
							30.372676918000085
						]
					],
					[
						[
							-81.45950504899992,
							30.357189114000047
						],
						[
							-81.45947770099991,
							30.357153803000077
						],
						[
							-81.45945897599995,
							30.357175892000047
						],
						[
							-81.45950504899992,
							30.357189114000047
						]
					],
					[
						[
							-81.45807454399994,
							30.349658846000068
						],
						[
							-81.45802737199995,
							30.34956947900008
						],
						[
							-81.45774596699994,
							30.349812398000044
						],
						[
							-81.45810275499991,
							30.35005098000005
						],
						[
							-81.45807454399994,
							30.349658846000068
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Girvin",
				"RegionID": "268992"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.1808114719999,
					26.145863000000077,
					-80.17453529399997,
					26.147514477000072
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.17500311099991,
							26.145968174000075
						],
						[
							-80.17499611299992,
							26.145864181000036
						],
						[
							-80.17508499999991,
							26.14586500000007
						],
						[
							-80.17546799999991,
							26.145863000000077
						],
						[
							-80.17626799999994,
							26.145863000000077
						],
						[
							-80.17736799999994,
							26.145863000000077
						],
						[
							-80.17786799999993,
							26.145863000000077
						],
						[
							-80.17846799999997,
							26.145868000000068
						],
						[
							-80.17976799999991,
							26.14588000000009
						],
						[
							-80.18016099999994,
							26.14588400000008
						],
						[
							-80.18053299999993,
							26.145887000000073
						],
						[
							-80.18081107899991,
							26.145889243000056
						],
						[
							-80.1808114719999,
							26.14734000100009
						],
						[
							-80.18066337199991,
							26.147346092000078
						],
						[
							-80.17461126799992,
							26.147514477000072
						],
						[
							-80.17453529399997,
							26.146004041000083
						],
						[
							-80.1749278659999,
							26.14597105300004
						],
						[
							-80.17500311099991,
							26.145968174000075
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Golden Heights",
				"RegionID": "268994"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.6177599429999,
					30.215742866000085,
					-81.59825090099991,
					30.239702023000067
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.6055069059999,
							30.23442300800008
						],
						[
							-81.6054379059999,
							30.234255009000037
						],
						[
							-81.60538990499992,
							30.234138009000052
						],
						[
							-81.6052879049999,
							30.23396900800009
						],
						[
							-81.60520790299995,
							30.233862008000074
						],
						[
							-81.60513690599993,
							30.233798508000064
						],
						[
							-81.60500790499992,
							30.23367800900007
						],
						[
							-81.60466990499992,
							30.23343300900007
						],
						[
							-81.60453990499991,
							30.233362009000075
						],
						[
							-81.6041159049999,
							30.233214008000065
						],
						[
							-81.60345490499992,
							30.233067009000084
						],
						[
							-81.60292790499994,
							30.232924009000048
						],
						[
							-81.60144790599992,
							30.232573009000077
						],
						[
							-81.60096690599994,
							30.23244500900006
						],
						[
							-81.60037190499992,
							30.232296008000045
						],
						[
							-81.59982290499994,
							30.232162008000046
						],
						[
							-81.59887690599993,
							30.231924007000092
						],
						[
							-81.59880790599993,
							30.231911008000058
						],
						[
							-81.59856390599992,
							30.23183300800008
						],
						[
							-81.59830290499991,
							30.231709008000053
						],
						[
							-81.59825090099991,
							30.23168212800005
						],
						[
							-81.60042116799991,
							30.23056985800008
						],
						[
							-81.60106049199993,
							30.228924991000042
						],
						[
							-81.60307074799994,
							30.228833943000044
						],
						[
							-81.60380177699994,
							30.227920174000076
						],
						[
							-81.60371007599991,
							30.226275412000064
						],
						[
							-81.60462389999992,
							30.22591005100009
						],
						[
							-81.60608580899992,
							30.22563607700005
						],
						[
							-81.60809598799995,
							30.224448283000072
						],
						[
							-81.60818719399992,
							30.222894954000083
						],
						[
							-81.60818706399994,
							30.22115886000006
						],
						[
							-81.61065418899994,
							30.22115915700005
						],
						[
							-81.61210599999993,
							30.21844400000009
						],
						[
							-81.61213873499992,
							30.21825488500008
						],
						[
							-81.6121910679999,
							30.217888549000065
						],
						[
							-81.61234806999995,
							30.21720821000008
						],
						[
							-81.61255740399992,
							30.216527872000086
						],
						[
							-81.61271440599995,
							30.216004534000035
						],
						[
							-81.61302840799993,
							30.215795199000073
						],
						[
							-81.61329007699993,
							30.215742866000085
						],
						[
							-81.61360407899991,
							30.215899867000076
						],
						[
							-81.6140227489999,
							30.21605686800007
						],
						[
							-81.6148077549999,
							30.215899867000076
						],
						[
							-81.6155927609999,
							30.215899867000076
						],
						[
							-81.61632543299993,
							30.215952201000054
						],
						[
							-81.61711043899993,
							30.21605686800007
						],
						[
							-81.61746097799994,
							30.215991142000064
						],
						[
							-81.61738099999991,
							30.21661400000005
						],
						[
							-81.61730690799993,
							30.21719101000008
						],
						[
							-81.61725690799994,
							30.217576011000062
						],
						[
							-81.61722990699991,
							30.21777901100006
						],
						[
							-81.6172049079999,
							30.217915010000066
						],
						[
							-81.61715890799991,
							30.21816401100006
						],
						[
							-81.61694290799994,
							30.218903011000066
						],
						[
							-81.61684390699992,
							30.21920001100006
						],
						[
							-81.61663090799993,
							30.219725011000033
						],
						[
							-81.61627990699992,
							30.22062101100005
						],
						[
							-81.61623390699992,
							30.220720011000083
						],
						[
							-81.61611890699993,
							30.22103101100004
						],
						[
							-81.61587490799991,
							30.221632010000064
						],
						[
							-81.61575490799993,
							30.221946011000057
						],
						[
							-81.61569290699993,
							30.22214701000007
						],
						[
							-81.61566490799993,
							30.222235010000077
						],
						[
							-81.6156039089999,
							30.22247301300007
						],
						[
							-81.61559290699995,
							30.222673011000044
						],
						[
							-81.61557790799992,
							30.22301301000005
						],
						[
							-81.61556990799994,
							30.223211010000053
						],
						[
							-81.61557790799992,
							30.223520010000072
						],
						[
							-81.61559290699995,
							30.223616011000043
						],
						[
							-81.61575290799993,
							30.224295011000038
						],
						[
							-81.61579890699994,
							30.22457501000008
						],
						[
							-81.61593590699994,
							30.22519901000004
						],
						[
							-81.61597390799994,
							30.225361011000075
						],
						[
							-81.61622590799993,
							30.22650501000004
						],
						[
							-81.61625690699992,
							30.226631011000052
						],
						[
							-81.61630990799995,
							30.226927010000054
						],
						[
							-81.61656990699993,
							30.22814401000005
						],
						[
							-81.61668390699992,
							30.228693010000082
						],
						[
							-81.6167149069999,
							30.22888801000005
						],
						[
							-81.61672090799993,
							30.228922011000066
						],
						[
							-81.61672990699992,
							30.228964010000087
						],
						[
							-81.61677690699992,
							30.22930701000007
						],
						[
							-81.61682090699992,
							30.22975501000008
						],
						[
							-81.61688990699992,
							30.230276011000058
						],
						[
							-81.6169609069999,
							30.230893011000035
						],
						[
							-81.61709690799997,
							30.23174201000006
						],
						[
							-81.6171399079999,
							30.23190101100005
						],
						[
							-81.61720090999997,
							30.23212301200005
						],
						[
							-81.6173359579999,
							30.232397991000084
						],
						[
							-81.61734485799991,
							30.232436028000055
						],
						[
							-81.61742790799993,
							30.23260901000009
						],
						[
							-81.61765390799991,
							30.232948011000076
						],
						[
							-81.6177599429999,
							30.23307596700005
						],
						[
							-81.61689790499992,
							30.23369200800005
						],
						[
							-81.61592090499994,
							30.23440600800006
						],
						[
							-81.6155548989999,
							30.234690201000035
						],
						[
							-81.61512791399991,
							30.23427582100004
						],
						[
							-81.61430390599992,
							30.23489600900007
						],
						[
							-81.61116790599993,
							30.23720600900009
						],
						[
							-81.61017590599994,
							30.237951008000042
						],
						[
							-81.6093139059999,
							30.238611009000067
						],
						[
							-81.60908490599991,
							30.23881300800008
						],
						[
							-81.60891690599993,
							30.23900000500004
						],
						[
							-81.60795585299991,
							30.239702023000067
						],
						[
							-81.60770390599993,
							30.239244009000064
						],
						[
							-81.60760490599995,
							30.239086008000076
						],
						[
							-81.60752890499992,
							30.238930008000068
						],
						[
							-81.6074219059999,
							30.23876000900009
						],
						[
							-81.60716990599991,
							30.238298008000072
						],
						[
							-81.60703290599992,
							30.238005009000062
						],
						[
							-81.60676590599991,
							30.237354009000057
						],
						[
							-81.60608690499993,
							30.235777009000063
						],
						[
							-81.60594190599994,
							30.235462009000056
						],
						[
							-81.60581990599991,
							30.235146008000076
						],
						[
							-81.6055069059999,
							30.23442300800008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Goodby's Creek",
				"RegionID": "268995"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.67003870299993,
					30.329608845000052,
					-81.6503267629999,
					30.35637214000008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.66130690699993,
							30.35627800800006
						],
						[
							-81.66130690699993,
							30.356025008000078
						],
						[
							-81.6612969059999,
							30.35573700900005
						],
						[
							-81.6612929069999,
							30.355640009000073
						],
						[
							-81.66128199499991,
							30.354923993000057
						],
						[
							-81.66126090499995,
							30.354206009000052
						],
						[
							-81.66126090499995,
							30.35390000800004
						],
						[
							-81.66124690599992,
							30.35349700900008
						],
						[
							-81.6612319059999,
							30.352906008000048
						],
						[
							-81.66120890499991,
							30.35170500900006
						],
						[
							-81.66118190499992,
							30.351440008000058
						],
						[
							-81.66116290499991,
							30.351360008000086
						],
						[
							-81.6609739079999,
							30.35082201000006
						],
						[
							-81.6609659049999,
							30.35072800900008
						],
						[
							-81.66095790599991,
							30.35063900800009
						],
						[
							-81.66094990499994,
							30.349998008000057
						],
						[
							-81.66094990499994,
							30.348971009000085
						],
						[
							-81.66097890499992,
							30.348618009000063
						],
						[
							-81.66109190599991,
							30.34765900800005
						],
						[
							-81.66122290599992,
							30.346459009000053
						],
						[
							-81.66125478799995,
							30.34629986300007
						],
						[
							-81.66151390499994,
							30.34630500900005
						],
						[
							-81.66245803499993,
							30.34639414000009
						],
						[
							-81.66244590499991,
							30.34610500900004
						],
						[
							-81.66244190499992,
							30.34583401000009
						],
						[
							-81.66239777299995,
							30.345624008000076
						],
						[
							-81.66243790699991,
							30.34539000800004
						],
						[
							-81.66246990999991,
							30.345294007000064
						],
						[
							-81.66256490599994,
							30.34516700900008
						],
						[
							-81.66267706699995,
							30.345036082000036
						],
						[
							-81.6627169599999,
							30.344708008000055
						],
						[
							-81.66265190599995,
							30.344025008000077
						],
						[
							-81.66261990599992,
							30.343826009000058
						],
						[
							-81.66255590499992,
							30.343243008000055
						],
						[
							-81.66241290499994,
							30.34271400800009
						],
						[
							-81.6620229049999,
							30.341726008000084
						],
						[
							-81.66168101999996,
							30.341108877000067
						],
						[
							-81.66149887899991,
							30.34103505400009
						],
						[
							-81.66097390599992,
							30.340608008000064
						],
						[
							-81.6605369049999,
							30.34023800800009
						],
						[
							-81.66023480099994,
							30.339950094000073
						],
						[
							-81.66007590599992,
							30.339634008000072
						],
						[
							-81.65968400799994,
							30.338917922000064
						],
						[
							-81.65864390599995,
							30.338075008000093
						],
						[
							-81.65812390699995,
							30.33765300800008
						],
						[
							-81.65729398599991,
							30.33660183500007
						],
						[
							-81.65715790599995,
							30.336607008000044
						],
						[
							-81.65698990499993,
							30.336613008000086
						],
						[
							-81.65655490499995,
							30.336592008000082
						],
						[
							-81.65583790499994,
							30.33653500800006
						],
						[
							-81.65496790599991,
							30.33646600800006
						],
						[
							-81.65338890599992,
							30.33633400800005
						],
						[
							-81.65185490499994,
							30.33621200800007
						],
						[
							-81.65115390599993,
							30.336159008000042
						],
						[
							-81.6503267629999,
							30.33608712900008
						],
						[
							-81.65034190599994,
							30.335888009000087
						],
						[
							-81.65040590599995,
							30.33534800800004
						],
						[
							-81.6505359059999,
							30.33419800900009
						],
						[
							-81.65057390599992,
							30.333637009000086
						],
						[
							-81.65058890499995,
							30.33354001000004
						],
						[
							-81.65060390599992,
							30.333357008000064
						],
						[
							-81.65064190499993,
							30.333092009000044
						],
						[
							-81.65066590599992,
							30.332788008000076
						],
						[
							-81.65088590599993,
							30.331809008000047
						],
						[
							-81.65095390599993,
							30.331464008000072
						],
						[
							-81.6510549859999,
							30.331104052000057
						],
						[
							-81.65127690499992,
							30.330349008000045
						],
						[
							-81.65150181199994,
							30.329608845000052
						],
						[
							-81.65303690499991,
							30.32995100800008
						],
						[
							-81.65426790599992,
							30.330219009000075
						],
						[
							-81.65453190599993,
							30.330272008000065
						],
						[
							-81.65509790599992,
							30.33039700900008
						],
						[
							-81.6554560649999,
							30.330473905000076
						],
						[
							-81.65540390599995,
							30.330671008000085
						],
						[
							-81.65531890699994,
							30.330952009000043
						],
						[
							-81.65523490599992,
							30.33124900900009
						],
						[
							-81.65518190699993,
							30.33146100800008
						],
						[
							-81.65502874799995,
							30.331985103000076
						],
						[
							-81.6562149049999,
							30.332246008000084
						],
						[
							-81.6569239069999,
							30.332404009000072
						],
						[
							-81.65771390599991,
							30.33257500800005
						],
						[
							-81.65788090599995,
							30.332619009000044
						],
						[
							-81.65890090599993,
							30.33282700800004
						],
						[
							-81.66009190599993,
							30.33307300900009
						],
						[
							-81.6612690629999,
							30.33331591200005
						],
						[
							-81.6611599069999,
							30.333698008000056
						],
						[
							-81.66103974899994,
							30.33407810100005
						],
						[
							-81.66133090699992,
							30.334138008000085
						],
						[
							-81.66182790499994,
							30.334252008000078
						],
						[
							-81.66206490699996,
							30.33429200800003
						],
						[
							-81.66220190699994,
							30.334325008000068
						],
						[
							-81.66308690699992,
							30.334515008000043
						],
						[
							-81.6633479059999,
							30.334571009000058
						],
						[
							-81.6635899069999,
							30.334625008000046
						],
						[
							-81.66366490599995,
							30.334641008000062
						],
						[
							-81.66450990699991,
							30.33482300900005
						],
						[
							-81.66477790699992,
							30.33487800800009
						],
						[
							-81.66527390399995,
							30.334990008000087
						],
						[
							-81.66603900199993,
							30.335136848000047
						],
						[
							-81.66649881399991,
							30.335717169000077
						],
						[
							-81.66702893699994,
							30.33576793200007
						],
						[
							-81.66727390599993,
							30.335942009000068
						],
						[
							-81.66796590699994,
							30.33643100900008
						],
						[
							-81.66805990699993,
							30.336493008000044
						],
						[
							-81.6681969039999,
							30.336583009000037
						],
						[
							-81.6683469059999,
							30.33669100800006
						],
						[
							-81.66851090699993,
							30.33680500800006
						],
						[
							-81.6686799069999,
							30.336925008000037
						],
						[
							-81.66884083799994,
							30.337044070000044
						],
						[
							-81.66907890599992,
							30.337221008000085
						],
						[
							-81.6691589049999,
							30.337279008000056
						],
						[
							-81.66928990699995,
							30.337374008000044
						],
						[
							-81.66938090499991,
							30.33744500800009
						],
						[
							-81.66945692299993,
							30.337503475000062
						],
						[
							-81.66973990699995,
							30.337709008000044
						],
						[
							-81.67003870299993,
							30.337945897000054
						],
						[
							-81.66997690999996,
							30.337923008000075
						],
						[
							-81.66982290499993,
							30.33781700900005
						],
						[
							-81.66973990499991,
							30.337769009000056
						],
						[
							-81.66966990499992,
							30.337741009000066
						],
						[
							-81.66959590599993,
							30.33772700900005
						],
						[
							-81.66946190699991,
							30.33772901100008
						],
						[
							-81.66934490699992,
							30.337769009000056
						],
						[
							-81.66928090899995,
							30.33780800800008
						],
						[
							-81.6692249059999,
							30.337863008000056
						],
						[
							-81.66917395199994,
							30.337914043000065
						],
						[
							-81.66887490599993,
							30.338489008000067
						],
						[
							-81.66873490499995,
							30.338753008000083
						],
						[
							-81.6685949049999,
							30.339052008000067
						],
						[
							-81.6683869069999,
							30.339518008000084
						],
						[
							-81.6683249049999,
							30.339736008000045
						],
						[
							-81.66824290599993,
							30.340092009000045
						],
						[
							-81.66821676599994,
							30.34029512700005
						],
						[
							-81.66844904999994,
							30.340302895000036
						],
						[
							-81.66842690699991,
							30.34038901100007
						],
						[
							-81.6684569059999,
							30.341682009000067
						],
						[
							-81.6684569059999,
							30.341885009000066
						],
						[
							-81.66851790499993,
							30.342949008000065
						],
						[
							-81.66855774199992,
							30.344109101000075
						],
						[
							-81.66873303499995,
							30.344223043000056
						],
						[
							-81.6685637729999,
							30.34422888100005
						],
						[
							-81.66860190699992,
							30.34510800800007
						],
						[
							-81.66863974699993,
							30.345293105000056
						],
						[
							-81.66869409399993,
							30.345332970000076
						],
						[
							-81.6685707229999,
							30.345562994000087
						],
						[
							-81.66874890499992,
							30.34607900800006
						],
						[
							-81.66878390599993,
							30.34617000800006
						],
						[
							-81.6692140799999,
							30.34732000500009
						],
						[
							-81.66884990499996,
							30.348470009000042
						],
						[
							-81.66864090699994,
							30.349173008000037
						],
						[
							-81.66860790599992,
							30.349362009000057
						],
						[
							-81.66859390499991,
							30.349513009000077
						],
						[
							-81.66857990599993,
							30.34990600800006
						],
						[
							-81.66856090499994,
							30.350049008000042
						],
						[
							-81.66851590699991,
							30.350252009000084
						],
						[
							-81.66851890499993,
							30.350366008000034
						],
						[
							-81.66851890499993,
							30.35041700900007
						],
						[
							-81.66852290599991,
							30.35051000900006
						],
						[
							-81.66852290599991,
							30.350552008000076
						],
						[
							-81.66853290499995,
							30.350660009000084
						],
						[
							-81.66853681499992,
							30.35070201200006
						],
						[
							-81.66853690499994,
							30.350780008000076
						],
						[
							-81.66854090599992,
							30.35089900900005
						],
						[
							-81.66854490599991,
							30.351060009000037
						],
						[
							-81.6685539049999,
							30.351314009000077
						],
						[
							-81.66855790499994,
							30.351437008000065
						],
						[
							-81.66855890499994,
							30.35149300800003
						],
						[
							-81.66856190599992,
							30.351680009000063
						],
						[
							-81.66856790599991,
							30.351758009000033
						],
						[
							-81.66860290599993,
							30.352528009000082
						],
						[
							-81.66861790499992,
							30.352881008000054
						],
						[
							-81.66862090599994,
							30.353045009000084
						],
						[
							-81.66862490599993,
							30.353272008000086
						],
						[
							-81.66862790599993,
							30.353462009000054
						],
						[
							-81.66863090599992,
							30.353620008000064
						],
						[
							-81.66863390499992,
							30.353766009000086
						],
						[
							-81.66863290599991,
							30.353978008000066
						],
						[
							-81.66863490499992,
							30.354097008000053
						],
						[
							-81.66863390599991,
							30.35423500900004
						],
						[
							-81.6686399059999,
							30.35457300800005
						],
						[
							-81.66864090599995,
							30.354687009000088
						],
						[
							-81.6686619059999,
							30.35562500900005
						],
						[
							-81.66866690599994,
							30.35573100900007
						],
						[
							-81.66866590599994,
							30.355962008000063
						],
						[
							-81.66867090599993,
							30.356040008000033
						],
						[
							-81.66867490599992,
							30.356106011000065
						],
						[
							-81.66856890699995,
							30.35611100900007
						],
						[
							-81.66847590599991,
							30.356114008000077
						],
						[
							-81.66790490699992,
							30.356128009000088
						],
						[
							-81.66671590699991,
							30.35612600800005
						],
						[
							-81.6665169069999,
							30.35612600800005
						],
						[
							-81.66637390599993,
							30.356129009000085
						],
						[
							-81.66617690599992,
							30.35612600800005
						],
						[
							-81.66581290699992,
							30.356128009000088
						],
						[
							-81.66565290599993,
							30.35613500800008
						],
						[
							-81.66523590599991,
							30.356144008000058
						],
						[
							-81.66491390699991,
							30.356161008000072
						],
						[
							-81.66464890399993,
							30.356189009000047
						],
						[
							-81.66407990699992,
							30.35623300800006
						],
						[
							-81.66397090699991,
							30.35624100800004
						],
						[
							-81.66364290599995,
							30.356265009000083
						],
						[
							-81.6633229059999,
							30.35629700800007
						],
						[
							-81.6632289069999,
							30.356304009000038
						],
						[
							-81.66313490599993,
							30.356316008000075
						],
						[
							-81.66298790699994,
							30.356329008000046
						],
						[
							-81.6627359069999,
							30.35634300900006
						],
						[
							-81.66246490599991,
							30.356354008000043
						],
						[
							-81.66218390699993,
							30.356359008000087
						],
						[
							-81.66130677399991,
							30.35637214000008
						],
						[
							-81.66130790699992,
							30.356325009000045
						],
						[
							-81.66130690699993,
							30.35627800800006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Hogan's Creek",
				"RegionID": "269009"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.44470195699995,
					30.287986958000094,
					-81.4211445389999,
					30.313264945000075
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.42481506099995,
							30.306438738000054
						],
						[
							-81.42508791099993,
							30.302932598000044
						],
						[
							-81.42494547799993,
							30.30113333800006
						],
						[
							-81.42470251799995,
							30.301037002000044
						],
						[
							-81.42458433899992,
							30.300979836000067
						],
						[
							-81.42445592699994,
							30.300889921000078
						],
						[
							-81.42434507899992,
							30.300779073000058
						],
						[
							-81.42425516399994,
							30.30065066100008
						],
						[
							-81.42418878099994,
							30.300508223000065
						],
						[
							-81.42409697699992,
							30.300255317000055
						],
						[
							-81.42381499999993,
							30.296559000000062
						],
						[
							-81.42358767799993,
							30.295842744000083
						],
						[
							-81.42358767799993,
							30.295522000000066
						],
						[
							-81.42360134099994,
							30.29536583400005
						],
						[
							-81.42364191399992,
							30.295214414000043
						],
						[
							-81.42370816499994,
							30.29507233900006
						],
						[
							-81.42379807999993,
							30.294943927000073
						],
						[
							-81.4239089269999,
							30.294833079000053
						],
						[
							-81.42392725899992,
							30.294818104000058
						],
						[
							-81.42402579499992,
							30.29473974800004
						],
						[
							-81.42396147499994,
							30.294696053000056
						],
						[
							-81.42390132199995,
							30.29464677800007
						],
						[
							-81.42384581999994,
							30.294592319000063
						],
						[
							-81.42379541199995,
							30.29453311300006
						],
						[
							-81.42375050399994,
							30.294469634000052
						],
						[
							-81.42371145599992,
							30.294402391000066
						],
						[
							-81.42349576299996,
							30.293993243000045
						],
						[
							-81.42310906599994,
							30.29364696900007
						],
						[
							-81.42305578899993,
							30.293595139000043
						],
						[
							-81.42278278499992,
							30.293306646000076
						],
						[
							-81.42224295999995,
							30.291605737000054
						],
						[
							-81.42224300299995,
							30.291604741000068
						],
						[
							-81.42225295299994,
							30.291528054000086
						],
						[
							-81.4222694529999,
							30.291452505000052
						],
						[
							-81.42229238399995,
							30.29137865200005
						],
						[
							-81.42232157299992,
							30.291307042000085
						],
						[
							-81.42235680699991,
							30.29123820500007
						],
						[
							-81.4225184849999,
							30.290953272000085
						],
						[
							-81.42261007899992,
							30.290821927000078
						],
						[
							-81.42271081799993,
							30.290719689000074
						],
						[
							-81.4228002879999,
							30.290642336000076
						],
						[
							-81.42270899999994,
							30.290650322000094
						],
						[
							-81.42262505699995,
							30.290646396000056
						],
						[
							-81.42220905699992,
							30.290607396000045
						],
						[
							-81.4221368339999,
							30.290597660000063
						],
						[
							-81.42198541399995,
							30.290557086000035
						],
						[
							-81.42189707099993,
							30.29051589100004
						],
						[
							-81.4211699999999,
							30.288225000000068
						],
						[
							-81.4211445389999,
							30.288143200000036
						],
						[
							-81.42161299999992,
							30.288140000000055
						],
						[
							-81.42688190799993,
							30.28810401100009
						],
						[
							-81.42833690799995,
							30.28808801000008
						],
						[
							-81.42990590799991,
							30.288072010000068
						],
						[
							-81.43124590699995,
							30.288061010000035
						],
						[
							-81.43191290699991,
							30.288050010000063
						],
						[
							-81.43270790699995,
							30.288038010000033
						],
						[
							-81.43397690799992,
							30.288022065000064
						],
						[
							-81.43597190999992,
							30.288002012000046
						],
						[
							-81.43723390999992,
							30.28799001300007
						],
						[
							-81.43755290899992,
							30.28798701200009
						],
						[
							-81.43762490899991,
							30.28798701200009
						],
						[
							-81.43768090999993,
							30.28798901300007
						],
						[
							-81.4377689069999,
							30.287986958000094
						],
						[
							-81.43775991099994,
							30.28828701300006
						],
						[
							-81.43775898699994,
							30.288313035000048
						],
						[
							-81.4376847389999,
							30.288422965000056
						],
						[
							-81.43769190899991,
							30.28931401200009
						],
						[
							-81.43769891099993,
							30.28959201300006
						],
						[
							-81.43770490799994,
							30.289776012000065
						],
						[
							-81.43775190999992,
							30.29119501300005
						],
						[
							-81.43775490899992,
							30.291535012000054
						],
						[
							-81.43775890899991,
							30.29208001200004
						],
						[
							-81.43777490899993,
							30.29306801300004
						],
						[
							-81.43780090899992,
							30.29402401200008
						],
						[
							-81.43780591099994,
							30.294270012000087
						],
						[
							-81.43783590899994,
							30.29549801200005
						],
						[
							-81.43783790899994,
							30.295910013000082
						],
						[
							-81.43783990899993,
							30.29622801300007
						],
						[
							-81.4378479099999,
							30.29656501200009
						],
						[
							-81.43786590799994,
							30.29759401200005
						],
						[
							-81.4378889109999,
							30.297853012000076
						],
						[
							-81.43796991099993,
							30.298233013000075
						],
						[
							-81.43804190899994,
							30.29847101200005
						],
						[
							-81.43810990999992,
							30.298641013000065
						],
						[
							-81.43829290899993,
							30.299002012000077
						],
						[
							-81.43855990999992,
							30.29938901200006
						],
						[
							-81.43864390999994,
							30.29947701200007
						],
						[
							-81.43898790899993,
							30.299799012000054
						],
						[
							-81.43923190999993,
							30.299982012000044
						],
						[
							-81.4395219079999,
							30.30016501300008
						],
						[
							-81.43985691099994,
							30.30033901200005
						],
						[
							-81.4408649099999,
							30.30078301200007
						],
						[
							-81.44134490899995,
							30.30099301300004
						],
						[
							-81.44172690799991,
							30.301180013000078
						],
						[
							-81.4419019099999,
							30.301254012000076
						],
						[
							-81.44245090799991,
							30.30151201300004
						],
						[
							-81.44282490899991,
							30.30176201200004
						],
						[
							-81.44302391199994,
							30.301929013000063
						],
						[
							-81.44330590899995,
							30.30220001300006
						],
						[
							-81.44347390799993,
							30.302389013000038
						],
						[
							-81.44369490999992,
							30.30269201200008
						],
						[
							-81.44390890799991,
							30.303085012000057
						],
						[
							-81.44421390799994,
							30.30390901300007
						],
						[
							-81.44470195699995,
							30.305268977000086
						],
						[
							-81.44191018299995,
							30.30582383600006
						],
						[
							-81.44060812599993,
							30.306547388000073
						],
						[
							-81.43930599999995,
							30.30640248700007
						],
						[
							-81.43568908099991,
							30.30683657200007
						],
						[
							-81.43424220299994,
							30.30741514100004
						],
						[
							-81.43279554599991,
							30.309585432000066
						],
						[
							-81.43221697399991,
							30.311177009000062
						],
						[
							-81.42630795499991,
							30.313145148000046
						],
						[
							-81.42594828199992,
							30.313264945000075
						],
						[
							-81.42525699999993,
							30.310756000000087
						],
						[
							-81.42473154999993,
							30.30767201500004
						],
						[
							-81.42481506099995,
							30.306438738000054
						]
					],
					[
						[
							-81.43099555499992,
							30.290720978000085
						],
						[
							-81.43055844899993,
							30.29068444100005
						],
						[
							-81.42920720699993,
							30.292395671000065
						],
						[
							-81.42955111299995,
							30.29226882500006
						],
						[
							-81.43119285699993,
							30.290738598000075
						],
						[
							-81.43099555499992,
							30.290720978000085
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Holiday Harbors",
				"RegionID": "269011"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.3741629999999,
					28.401807000000076,
					-81.3337709999999,
					28.440370000000087
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-81.3683989999999,
								28.42133800000005
							],
							[
								-81.3683989999999,
								28.42110100000008
							],
							[
								-81.36683599999992,
								28.42110100000008
							],
							[
								-81.36613199999994,
								28.42110400000007
							],
							[
								-81.36613199999994,
								28.420559000000083
							],
							[
								-81.36566699999992,
								28.420559000000083
							],
							[
								-81.36563099999995,
								28.420597000000043
							],
							[
								-81.3655379999999,
								28.42070700000005
							],
							[
								-81.3655379999999,
								28.421106000000066
							],
							[
								-81.3595499999999,
								28.42110500000007
							],
							[
								-81.35942799999992,
								28.42110400000007
							],
							[
								-81.35942499999993,
								28.421175000000062
							],
							[
								-81.35742399999994,
								28.421174000000065
							],
							[
								-81.35681999999991,
								28.421183000000042
							],
							[
								-81.35681999999991,
								28.42129900000009
							],
							[
								-81.3539859999999,
								28.421274000000043
							],
							[
								-81.3539859999999,
								28.421160000000043
							],
							[
								-81.35249999999992,
								28.42120200000005
							],
							[
								-81.35079780699994,
								28.421169030000048
							],
							[
								-81.35069299999992,
								28.421167000000082
							],
							[
								-81.3504969999999,
								28.42111000000006
							],
							[
								-81.34753199999996,
								28.416971000000046
							],
							[
								-81.34626265299994,
								28.41536820400006
							],
							[
								-81.34565378699995,
								28.41464149300009
							],
							[
								-81.34502528099995,
								28.413973705000046
							],
							[
								-81.3440825209999,
								28.413050586000054
							],
							[
								-81.34389864499991,
								28.41272577600006
							],
							[
								-81.34353297199993,
								28.412376260000087
							],
							[
								-81.34332566299992,
								28.412197994000053
							],
							[
								-81.34324454299991,
								28.412127389000094
							],
							[
								-81.34320648799991,
								28.412095842000042
							],
							[
								-81.34287499599992,
								28.41181142100004
							],
							[
								-81.34284359399993,
								28.41178400000007
							],
							[
								-81.34299099999993,
								28.41178400000007
							],
							[
								-81.34299299999992,
								28.411437000000035
							],
							[
								-81.34012499999996,
								28.409079000000077
							],
							[
								-81.33816699999994,
								28.40735300000006
							],
							[
								-81.33717999999993,
								28.406483000000037
							],
							[
								-81.33710999999994,
								28.40641700000009
							],
							[
								-81.33550451699995,
								28.40489222000008
							],
							[
								-81.33523999999994,
								28.404641000000083
							],
							[
								-81.33518399999991,
								28.404587000000053
							],
							[
								-81.3343612459999,
								28.40297759400005
							],
							[
								-81.3337709999999,
								28.40182300000004
							],
							[
								-81.35396099999991,
								28.401807000000076
							],
							[
								-81.3538519999999,
								28.403814000000068
							],
							[
								-81.35385799999996,
								28.40759500000007
							],
							[
								-81.3741629999999,
								28.40756900000008
							],
							[
								-81.37408799999992,
								28.40902900000009
							],
							[
								-81.37405499999994,
								28.409782000000064
							],
							[
								-81.37394599999993,
								28.411725000000047
							],
							[
								-81.3716179999999,
								28.41686500000009
							],
							[
								-81.37145599999991,
								28.417223000000035
							],
							[
								-81.37143399999991,
								28.41738600000008
							],
							[
								-81.37141699999995,
								28.417703000000074
							],
							[
								-81.37156199999993,
								28.417702000000077
							],
							[
								-81.37169399999993,
								28.41770400000007
							],
							[
								-81.3735079999999,
								28.417726000000073
							],
							[
								-81.37299799999994,
								28.419396000000063
							],
							[
								-81.37243299999994,
								28.421211000000085
							],
							[
								-81.37240999999995,
								28.42128900000006
							],
							[
								-81.37184788799995,
								28.421288375000074
							],
							[
								-81.37181834299992,
								28.421288342000082
							],
							[
								-81.37151099999994,
								28.42128800000006
							],
							[
								-81.37144899999993,
								28.421286000000066
							],
							[
								-81.37136863199993,
								28.42129827900004
							],
							[
								-81.37130499999995,
								28.421308000000067
							],
							[
								-81.37117499999994,
								28.42133800000005
							],
							[
								-81.3683989999999,
								28.42133800000005
							]
						]
					],
					[
						[
							[
								-81.3538959999999,
								28.428548000000035
							],
							[
								-81.3538959999999,
								28.426650000000052
							],
							[
								-81.35297899999995,
								28.426646000000062
							],
							[
								-81.35301799999992,
								28.42493900000005
							],
							[
								-81.35249399999992,
								28.424934000000064
							],
							[
								-81.3511509999999,
								28.424931000000072
							],
							[
								-81.35113799999993,
								28.424229000000082
							],
							[
								-81.35113199999995,
								28.424173000000053
							],
							[
								-81.35113599999994,
								28.424041000000045
							],
							[
								-81.35113799999993,
								28.42398600000007
							],
							[
								-81.35292299999992,
								28.423985000000073
							],
							[
								-81.35292299999992,
								28.42334500000004
							],
							[
								-81.35292599999991,
								28.423113000000058
							],
							[
								-81.35692199999994,
								28.423113000000058
							],
							[
								-81.35692199999994,
								28.422971000000075
							],
							[
								-81.35721299999994,
								28.422880000000077
							],
							[
								-81.35721299999994,
								28.42272200000008
							],
							[
								-81.35721299999994,
								28.422573000000057
							],
							[
								-81.35693099999992,
								28.422693000000038
							],
							[
								-81.35693099999992,
								28.421300000000087
							],
							[
								-81.35899999999992,
								28.421306000000072
							],
							[
								-81.35900499999991,
								28.421849000000066
							],
							[
								-81.35900499999991,
								28.42191500000007
							],
							[
								-81.3590069999999,
								28.42199000000005
							],
							[
								-81.35901999999993,
								28.42215500000009
							],
							[
								-81.35901999999993,
								28.42257600000005
							],
							[
								-81.35901999999993,
								28.422971000000075
							],
							[
								-81.35901999999993,
								28.42312400000009
							],
							[
								-81.3580199999999,
								28.42312400000009
							],
							[
								-81.3580199999999,
								28.426744000000042
							],
							[
								-81.3570509999999,
								28.426744000000042
							],
							[
								-81.3570509999999,
								28.428484000000083
							],
							[
								-81.35666099999992,
								28.428488000000073
							],
							[
								-81.35544199999993,
								28.428545000000042
							],
							[
								-81.35516799999994,
								28.428532000000075
							],
							[
								-81.35472199999992,
								28.428548000000035
							],
							[
								-81.3538959999999,
								28.428548000000035
							]
						]
					],
					[
						[
							[
								-81.35075299999994,
								28.440370000000087
							],
							[
								-81.34765099999993,
								28.440351000000078
							],
							[
								-81.34724352899991,
								28.440366405000077
							],
							[
								-81.34722031099994,
								28.42705089100008
							],
							[
								-81.34905748199992,
								28.427050747000067
							],
							[
								-81.34907899999992,
								28.428630000000055
							],
							[
								-81.34907299999992,
								28.42874500000005
							],
							[
								-81.34907899999992,
								28.43053400000008
							],
							[
								-81.34923099999992,
								28.430545000000052
							],
							[
								-81.34956299999993,
								28.430551000000037
							],
							[
								-81.34958699999993,
								28.42877400000009
							],
							[
								-81.35012599999993,
								28.42879000000005
							],
							[
								-81.3502729999999,
								28.428791000000047
							],
							[
								-81.35123099999993,
								28.428806000000066
							],
							[
								-81.3514889999999,
								28.428818000000035
							],
							[
								-81.35218299999991,
								28.428818000000035
							],
							[
								-81.3521659999999,
								28.430499000000054
							],
							[
								-81.3521649999999,
								28.430592000000047
							],
							[
								-81.35237999999993,
								28.43059100000005
							],
							[
								-81.35307299999994,
								28.43057200000004
							],
							[
								-81.35308299999991,
								28.43226700000008
							],
							[
								-81.35308299999991,
								28.43240200000008
							],
							[
								-81.35340499999995,
								28.43240700000007
							],
							[
								-81.35351899999995,
								28.432409000000064
							],
							[
								-81.35435799999993,
								28.43240200000008
							],
							[
								-81.35519399999993,
								28.432406000000075
							],
							[
								-81.35614499999991,
								28.432391000000052
							],
							[
								-81.35614499999991,
								28.432265000000086
							],
							[
								-81.35612999999995,
								28.43057200000004
							],
							[
								-81.35742799999991,
								28.430558000000076
							],
							[
								-81.35742799999991,
								28.42951700000009
							],
							[
								-81.3584469999999,
								28.42948300000006
							],
							[
								-81.35847999999993,
								28.428708000000086
							],
							[
								-81.35888299999993,
								28.428721000000053
							],
							[
								-81.35887799999995,
								28.42945700000007
							],
							[
								-81.35919599999994,
								28.429459000000065
							],
							[
								-81.35919999999993,
								28.430494000000067
							],
							[
								-81.35920399999992,
								28.431504000000075
							],
							[
								-81.35920699999991,
								28.432251000000065
							],
							[
								-81.35920699999991,
								28.432337000000075
							],
							[
								-81.35920799999991,
								28.432471000000078
							],
							[
								-81.36010399999992,
								28.432484000000045
							],
							[
								-81.36093699999994,
								28.432495000000074
							],
							[
								-81.36176699999993,
								28.432506000000046
							],
							[
								-81.36269099999993,
								28.432518000000073
							],
							[
								-81.36340699999994,
								28.432518000000073
							],
							[
								-81.36340699999994,
								28.433774000000085
							],
							[
								-81.36433699999992,
								28.433774000000085
							],
							[
								-81.36433899999992,
								28.43602100000004
							],
							[
								-81.36433899999992,
								28.436124000000063
							],
							[
								-81.36433999999991,
								28.436259000000064
							],
							[
								-81.36502299999995,
								28.436250000000086
							],
							[
								-81.36734999999993,
								28.436225000000036
							],
							[
								-81.36717799999991,
								28.43752900000004
							],
							[
								-81.36654299999992,
								28.437764000000072
							],
							[
								-81.3663939999999,
								28.43782000000005
							],
							[
								-81.36618199999992,
								28.437801000000036
							],
							[
								-81.36376599999994,
								28.436851000000047
							],
							[
								-81.36345899999992,
								28.436785000000043
							],
							[
								-81.36345899999992,
								28.43613600000009
							],
							[
								-81.36345899999992,
								28.43602100000004
							],
							[
								-81.36282499999993,
								28.43602100000004
							],
							[
								-81.36264999999992,
								28.43601400000006
							],
							[
								-81.36264599999993,
								28.434705000000065
							],
							[
								-81.36264999999992,
								28.434567000000072
							],
							[
								-81.36264899999992,
								28.434462000000053
							],
							[
								-81.36176399999994,
								28.434466000000043
							],
							[
								-81.36092999999994,
								28.434447000000034
							],
							[
								-81.36010699999991,
								28.434447000000034
							],
							[
								-81.35922099999993,
								28.434438000000057
							],
							[
								-81.35915399999995,
								28.434438000000057
							],
							[
								-81.35915799999994,
								28.434691000000043
							],
							[
								-81.35915099999994,
								28.43603500000006
							],
							[
								-81.35901599999994,
								28.436038000000057
							],
							[
								-81.35857699999991,
								28.436040000000048
							],
							[
								-81.35518699999994,
								28.436048000000085
							],
							[
								-81.35075299999994,
								28.436048000000085
							],
							[
								-81.35075299999994,
								28.436183000000085
							],
							[
								-81.35075299999994,
								28.440370000000087
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Boggy Creek",
				"RegionID": "268898"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.80694590799993,
					30.342176010000056,
					-81.77314280399992,
					30.369515203000052
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.78429392499993,
							30.369515203000052
						],
						[
							-81.77640790899994,
							30.365391010000053
						],
						[
							-81.77627290899994,
							30.36527701300008
						],
						[
							-81.77314280399992,
							30.363253048000047
						],
						[
							-81.77320130599992,
							30.345352401000074
						],
						[
							-81.77446090699993,
							30.345236010000065
						],
						[
							-81.77970890799992,
							30.344749010000047
						],
						[
							-81.78149990799994,
							30.34434501000004
						],
						[
							-81.78986890699991,
							30.343523010000073
						],
						[
							-81.79617490699991,
							30.342838010000037
						],
						[
							-81.80062790799991,
							30.342288011000054
						],
						[
							-81.80300890899991,
							30.342176010000056
						],
						[
							-81.8067719259999,
							30.342242931000044
						],
						[
							-81.80683990999995,
							30.345776013000087
						],
						[
							-81.8068389099999,
							30.346065012000057
						],
						[
							-81.80685390999992,
							30.346413013000074
						],
						[
							-81.80688390899991,
							30.348857013000046
						],
						[
							-81.80687690999991,
							30.349040012000046
						],
						[
							-81.8068839099999,
							30.349310012000043
						],
						[
							-81.80689190999993,
							30.350471012000074
						],
						[
							-81.8069089089999,
							30.35201801200009
						],
						[
							-81.80694590799993,
							30.352425012000083
						],
						[
							-81.80691490999993,
							30.35283201200008
						],
						[
							-81.8069099089999,
							30.353675012000053
						],
						[
							-81.80690690999995,
							30.354796013000055
						],
						[
							-81.80691390999993,
							30.35564601300007
						],
						[
							-81.8069069089999,
							30.355799012000034
						],
						[
							-81.80691490999993,
							30.35605301200008
						],
						[
							-81.80691490999993,
							30.356983013000047
						],
						[
							-81.80692290999991,
							30.357939013000077
						],
						[
							-81.80692790899991,
							30.358838012000035
						],
						[
							-81.80691390999993,
							30.36061001300004
						],
						[
							-81.80691890999992,
							30.363199013000045
						],
						[
							-81.8069079089999,
							30.36352201200009
						],
						[
							-81.80692305799994,
							30.36439313500006
						],
						[
							-81.80111989199992,
							30.365410963000045
						],
						[
							-81.79553193399995,
							30.368225184000043
						],
						[
							-81.78993991099992,
							30.36687187800004
						],
						[
							-81.78732487699995,
							30.367232936000054
						],
						[
							-81.78429392499993,
							30.369515203000052
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Bulls Bay",
				"RegionID": "268907"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.45492924799993,
					28.522410678000085,
					-81.43803498999995,
					28.52796600000005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.43840012299995,
							28.527849237000055
						],
						[
							-81.43838499999993,
							28.527246000000048
						],
						[
							-81.43825699999991,
							28.527247000000045
						],
						[
							-81.43819699999995,
							28.527240000000063
						],
						[
							-81.43807929199994,
							28.52724048200008
						],
						[
							-81.43807503999994,
							28.526863173000038
						],
						[
							-81.43803498999995,
							28.52330964500004
						],
						[
							-81.44254399999994,
							28.523310000000038
						],
						[
							-81.44363311299992,
							28.52276380500007
						],
						[
							-81.44370471899992,
							28.522720415000038
						],
						[
							-81.44373452799994,
							28.522696520000068
						],
						[
							-81.4437823639999,
							28.522662241000035
						],
						[
							-81.44383233899993,
							28.522631164000074
						],
						[
							-81.44388423999993,
							28.52260342200009
						],
						[
							-81.44393784399995,
							28.522579135000058
						],
						[
							-81.44399292299994,
							28.52255840500004
						],
						[
							-81.44400680099994,
							28.522553819000052
						],
						[
							-81.44428680099992,
							28.52246382000004
						],
						[
							-81.4443292389999,
							28.52245132200005
						],
						[
							-81.44438655099992,
							28.52243795800007
						],
						[
							-81.44444461499995,
							28.52242837200004
						],
						[
							-81.44450318199996,
							28.52242260400004
						],
						[
							-81.44452716699993,
							28.522421353000084
						],
						[
							-81.4447851669999,
							28.522411353000052
						],
						[
							-81.44481999999994,
							28.522410678000085
						],
						[
							-81.44495499999994,
							28.522410678000085
						],
						[
							-81.44501381799995,
							28.52241260300008
						],
						[
							-81.44507238499995,
							28.52241837200006
						],
						[
							-81.44513044899992,
							28.522427958000037
						],
						[
							-81.44518776099994,
							28.522441321000088
						],
						[
							-81.4452142689999,
							28.522448861000044
						],
						[
							-81.44524330299993,
							28.52245760300008
						],
						[
							-81.44530119299992,
							28.52246600600006
						],
						[
							-81.44534744899994,
							28.522473958000035
						],
						[
							-81.4454047609999,
							28.522487322000075
						],
						[
							-81.44546107699995,
							28.522504405000063
						],
						[
							-81.44546115999992,
							28.522504433000055
						],
						[
							-81.44578215999991,
							28.52261343300006
						],
						[
							-81.44578560899993,
							28.52261461100005
						],
						[
							-81.44597160799992,
							28.52267861200005
						],
						[
							-81.44602315499992,
							28.52269813500004
						],
						[
							-81.44607675999993,
							28.52272242300006
						],
						[
							-81.44612866099995,
							28.52275016400006
						],
						[
							-81.4461708259999,
							28.522776081000075
						],
						[
							-81.44629482599994,
							28.52285708100004
						],
						[
							-81.44630263699992,
							28.52286224100004
						],
						[
							-81.44635047299994,
							28.522896520000074
						],
						[
							-81.44636361499995,
							28.522906800000044
						],
						[
							-81.44637425099995,
							28.522915279000074
						],
						[
							-81.4463826189999,
							28.522904611000058
						],
						[
							-81.44652761999993,
							28.522722611000063
						],
						[
							-81.44655485399994,
							28.522690036000085
						],
						[
							-81.44659508399991,
							28.522647084000084
						],
						[
							-81.44663803599991,
							28.52260685400006
						],
						[
							-81.44667282799992,
							28.522578301000067
						],
						[
							-81.44735376799991,
							28.523203452000075
						],
						[
							-81.45492924799993,
							28.523053428000082
						],
						[
							-81.45489017599994,
							28.527687271000048
						],
						[
							-81.45475191499992,
							28.527687271000048
						],
						[
							-81.45415503099991,
							28.52768426600005
						],
						[
							-81.45238340199995,
							28.527724326000058
						],
						[
							-81.45232731999994,
							28.52772532700004
						],
						[
							-81.45227824599993,
							28.527726328000085
						],
						[
							-81.4508501279999,
							28.52774135100009
						],
						[
							-81.44907149099993,
							28.527734340000052
						],
						[
							-81.44665690999994,
							28.527768391000052
						],
						[
							-81.44554526199994,
							28.527777404000062
						],
						[
							-81.4448101719999,
							28.527785416000086
						],
						[
							-81.44365145199993,
							28.527806447000046
						],
						[
							-81.4435432919999,
							28.527808450000066
						],
						[
							-81.44330794399991,
							28.52781445900007
						],
						[
							-81.44324184499993,
							28.52781445900007
						],
						[
							-81.44283123399993,
							28.52781640800004
						],
						[
							-81.44223717599994,
							28.527820000000077
						],
						[
							-81.44152377199993,
							28.527820000000077
						],
						[
							-81.44078735499994,
							28.527820000000077
						],
						[
							-81.44014319999991,
							28.527825521000068
						],
						[
							-81.43966005599992,
							28.527833442000087
						],
						[
							-81.4394526179999,
							28.527836842000056
						],
						[
							-81.4392959999999,
							28.52796600000005
						],
						[
							-81.4392723819999,
							28.52796594700004
						],
						[
							-81.43840299999994,
							28.527964000000054
						],
						[
							-81.43840012299995,
							28.527849237000055
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Carver Shores",
				"RegionID": "268912"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.4260613649999,
					28.507013000000086,
					-81.40943661199992,
					28.52086899200009
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.40965661099995,
							28.51527487000004
						],
						[
							-81.4095428359999,
							28.515272690000074
						],
						[
							-81.40952247099995,
							28.51527594500004
						],
						[
							-81.40943661199992,
							28.514378933000046
						],
						[
							-81.40944760499991,
							28.512547682000047
						],
						[
							-81.40950280899995,
							28.51255382700009
						],
						[
							-81.40964201399993,
							28.512568850000036
						],
						[
							-81.40975618499994,
							28.512600898000073
						],
						[
							-81.40986334199994,
							28.512644962000085
						],
						[
							-81.41004761599993,
							28.512766142000093
						],
						[
							-81.41024484299993,
							28.512919486000044
						],
						[
							-81.41033903999994,
							28.512947462000056
						],
						[
							-81.41153181699991,
							28.512954421000074
						],
						[
							-81.41254732399995,
							28.51294440600009
						],
						[
							-81.41399560699995,
							28.512931520000052
						],
						[
							-81.41395741499991,
							28.50955432300009
						],
						[
							-81.41395429999994,
							28.509278866000045
						],
						[
							-81.4145069999999,
							28.50927400000006
						],
						[
							-81.41591499999993,
							28.50887900000004
						],
						[
							-81.4151589999999,
							28.50887700000004
						],
						[
							-81.41459199999991,
							28.50888000000009
						],
						[
							-81.41532799999993,
							28.508484000000067
						],
						[
							-81.41731699999991,
							28.50743700000004
						],
						[
							-81.41748399999994,
							28.507340000000056
						],
						[
							-81.41755199999994,
							28.507243000000074
						],
						[
							-81.4175459999999,
							28.507174000000077
						],
						[
							-81.4175459999999,
							28.507020000000068
						],
						[
							-81.41762199999994,
							28.507020000000068
						],
						[
							-81.4177959999999,
							28.507013000000086
						],
						[
							-81.41793499999996,
							28.507013000000086
						],
						[
							-81.41796899999991,
							28.507175000000075
						],
						[
							-81.41798999999992,
							28.507213000000036
						],
						[
							-81.41801499999991,
							28.507243000000074
						],
						[
							-81.41806899999995,
							28.50728300000009
						],
						[
							-81.41841799999992,
							28.507285000000085
						],
						[
							-81.4190025179999,
							28.507284207000055
						],
						[
							-81.42024726299991,
							28.50805829800004
						],
						[
							-81.42024775199991,
							28.508058042000073
						],
						[
							-81.42062728399992,
							28.508212520000086
						],
						[
							-81.42157109199991,
							28.50821211400006
						],
						[
							-81.42138699999992,
							28.508384000000035
						],
						[
							-81.4216219999999,
							28.508384000000035
						],
						[
							-81.42192599999993,
							28.50838200000004
						],
						[
							-81.4220259999999,
							28.508385000000093
						],
						[
							-81.42201899999992,
							28.50794300000007
						],
						[
							-81.42275399999994,
							28.50793800000008
						],
						[
							-81.4229570359999,
							28.507936926000074
						],
						[
							-81.4231319999999,
							28.507936000000086
						],
						[
							-81.42313599999994,
							28.508181000000036
						],
						[
							-81.42313299999995,
							28.508357000000046
						],
						[
							-81.4229564879999,
							28.508358999000055
						],
						[
							-81.42286799999994,
							28.50836000000004
						],
						[
							-81.42275199999995,
							28.508357000000046
						],
						[
							-81.42246599999993,
							28.50835600000005
						],
						[
							-81.42246599999993,
							28.50877500000007
						],
						[
							-81.42269799999991,
							28.508741000000043
						],
						[
							-81.4229570359999,
							28.50873508600006
						],
						[
							-81.42295662999993,
							28.50883344300007
						],
						[
							-81.42382504999995,
							28.50880727000009
						],
						[
							-81.42406840899991,
							28.508800260000044
						],
						[
							-81.42450505799991,
							28.508789244000074
						],
						[
							-81.42487460599995,
							28.50878023000007
						],
						[
							-81.42592829699993,
							28.508753057000035
						],
						[
							-81.4259310939999,
							28.50887038600007
						],
						[
							-81.42598433099994,
							28.50895346400006
						],
						[
							-81.4259982719999,
							28.50926795400005
						],
						[
							-81.42602230799993,
							28.509762687000094
						],
						[
							-81.4260292649999,
							28.510521810000057
						],
						[
							-81.42603031999994,
							28.510688060000064
						],
						[
							-81.42602430999995,
							28.511162764000062
						],
						[
							-81.42602130699993,
							28.51162845400006
						],
						[
							-81.42602931899995,
							28.51225538400007
						],
						[
							-81.42603031999994,
							28.512302455000054
						],
						[
							-81.42602931899995,
							28.51234652000005
						],
						[
							-81.42602030499995,
							28.513323969000055
						],
						[
							-81.42601830199993,
							28.51352526700009
						],
						[
							-81.4260613649999,
							28.514477681000074
						],
						[
							-81.4260603649999,
							28.514547785000047
						],
						[
							-81.42606041899995,
							28.51460086300006
						],
						[
							-81.42185098899995,
							28.514566680000087
						],
						[
							-81.42189718999992,
							28.51585672500005
						],
						[
							-81.42192936899994,
							28.519540317000065
						],
						[
							-81.41837786599991,
							28.519579087000068
						],
						[
							-81.41800302599995,
							28.520424845000036
						],
						[
							-81.41790890899995,
							28.520539368000072
						],
						[
							-81.41783984399991,
							28.520712028000048
						],
						[
							-81.4178367049999,
							28.52086899200009
						],
						[
							-81.41647199299992,
							28.520656717000065
						],
						[
							-81.41644192199993,
							28.52064759500007
						],
						[
							-81.4163993869999,
							28.520631950000052
						],
						[
							-81.41627838699992,
							28.52058395100005
						],
						[
							-81.41626584399995,
							28.52057886500006
						],
						[
							-81.41621223999994,
							28.520554578000088
						],
						[
							-81.41616033899993,
							28.520526836000045
						],
						[
							-81.41611036299993,
							28.520495759000084
						],
						[
							-81.41606252699995,
							28.52046148000005
						],
						[
							-81.41601703599991,
							28.52042414600004
						],
						[
							-81.41597408299992,
							28.520383917000064
						],
						[
							-81.41593385399995,
							28.52034096400007
						],
						[
							-81.41592169299992,
							28.520326803000046
						],
						[
							-81.41590776699991,
							28.520310244000086
						],
						[
							-81.41582546399991,
							28.520271437000076
						],
						[
							-81.41582443199991,
							28.520270950000057
						],
						[
							-81.41565743199993,
							28.520191950000083
						],
						[
							-81.41564423999995,
							28.520185578000053
						],
						[
							-81.41559233899994,
							28.52015783600007
						],
						[
							-81.41554236299993,
							28.52012675900005
						],
						[
							-81.41549452699992,
							28.520092480000073
						],
						[
							-81.41544903499994,
							28.520055146000065
						],
						[
							-81.41540608299994,
							28.520014917000083
						],
						[
							-81.41540298799993,
							28.52001180700006
						],
						[
							-81.4150485639999,
							28.519653908000066
						],
						[
							-81.41485347199995,
							28.519514231000073
						],
						[
							-81.41485283199995,
							28.51951377200004
						],
						[
							-81.41447083299994,
							28.51923977200005
						],
						[
							-81.41444752699994,
							28.519222480000053
						],
						[
							-81.4144020359999,
							28.51918514600004
						],
						[
							-81.41435908299991,
							28.519144916000073
						],
						[
							-81.41431885399993,
							28.519101964000072
						],
						[
							-81.41428151999992,
							28.519056472000045
						],
						[
							-81.41427215199991,
							28.519044043000065
						],
						[
							-81.41392651299992,
							28.518577082000036
						],
						[
							-81.41382508299995,
							28.518515826000055
						],
						[
							-81.41379036299992,
							28.51849375900008
						],
						[
							-81.4137425269999,
							28.518459480000047
						],
						[
							-81.41371339999995,
							28.518436154000085
						],
						[
							-81.41316694099993,
							28.51797960600004
						],
						[
							-81.41288901899992,
							28.517748150000045
						],
						[
							-81.41269888599993,
							28.51762276100004
						],
						[
							-81.4126943629999,
							28.51761975900007
						],
						[
							-81.41264652699994,
							28.517585480000037
						],
						[
							-81.41260103499991,
							28.51754814600008
						],
						[
							-81.41255808299991,
							28.517507916000056
						],
						[
							-81.41252884499994,
							28.51747726800005
						],
						[
							-81.41224711299992,
							28.517167661000087
						],
						[
							-81.41224008799992,
							28.51716000500005
						],
						[
							-81.41192616699993,
							28.516945218000046
						],
						[
							-81.41188652699992,
							28.516916481000067
						],
						[
							-81.41184103499995,
							28.516879146000065
						],
						[
							-81.41183183499993,
							28.516870966000056
						],
						[
							-81.4116271119999,
							28.516773799000077
						],
						[
							-81.41124683799991,
							28.516594142000088
						],
						[
							-81.41123323999994,
							28.516587577000053
						],
						[
							-81.41118133899994,
							28.516559836000056
						],
						[
							-81.41113136299992,
							28.51652875900004
						],
						[
							-81.4111252109999,
							28.51652461100008
						],
						[
							-81.41068121099994,
							28.516222611000046
						],
						[
							-81.41063952699994,
							28.516192480000086
						],
						[
							-81.4105940359999,
							28.516155146000074
						],
						[
							-81.41055108299992,
							28.51611491700004
						],
						[
							-81.41051085399994,
							28.516071965000037
						],
						[
							-81.41050348499994,
							28.51606345500005
						],
						[
							-81.41038548499995,
							28.51592545500006
						],
						[
							-81.41035551999994,
							28.51588847300008
						],
						[
							-81.4103212409999,
							28.515840637000053
						],
						[
							-81.41029016399995,
							28.51579066100004
						],
						[
							-81.4102624219999,
							28.51573876000009
						],
						[
							-81.41025343699994,
							28.515719996000087
						],
						[
							-81.4102177179999,
							28.51564313100005
						],
						[
							-81.4102162069999,
							28.51564116800006
						],
						[
							-81.40996004199991,
							28.51543595600009
						],
						[
							-81.40974779199992,
							28.51529060200005
						],
						[
							-81.40965661099995,
							28.51527487000004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Catalina",
				"RegionID": "268914"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.5379983329999,
					30.34310308000005,
					-81.50280892699993,
					30.360379012000067
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.50786490799993,
							30.35379501300008
						],
						[
							-81.50890391099995,
							30.353392013000075
						],
						[
							-81.50941590799994,
							30.353175013000058
						],
						[
							-81.51037490699991,
							30.35284001300005
						],
						[
							-81.5107569079999,
							30.35269301200009
						],
						[
							-81.51156990699991,
							30.352397013000086
						],
						[
							-81.5119279079999,
							30.352255013000047
						],
						[
							-81.5126539119999,
							30.351982013000054
						],
						[
							-81.51478990699991,
							30.35118401300008
						],
						[
							-81.5157379119999,
							30.350825012000087
						],
						[
							-81.51780991099993,
							30.350049013000046
						],
						[
							-81.51933891099992,
							30.349471013000088
						],
						[
							-81.52213890799993,
							30.348425012000064
						],
						[
							-81.52262891099991,
							30.348249012000053
						],
						[
							-81.52335790799992,
							30.347972013000064
						],
						[
							-81.5235672099999,
							30.347898857000075
						],
						[
							-81.53081312599994,
							30.34567814800005
						],
						[
							-81.53738881399994,
							30.34310308000005
						],
						[
							-81.53729172299991,
							30.343355357000068
						],
						[
							-81.53672658099993,
							30.344909503000054
						],
						[
							-81.53616144099993,
							30.346604933000037
						],
						[
							-81.53616135699991,
							30.348724241000067
						],
						[
							-81.53715037899991,
							30.350702281000057
						],
						[
							-81.5379983329999,
							30.351267311000075
						],
						[
							-81.5372916419999,
							30.35282150200004
						],
						[
							-81.53741491599993,
							30.35405509900005
						],
						[
							-81.53671901899992,
							30.354085916000088
						],
						[
							-81.53643790799993,
							30.354095012000073
						],
						[
							-81.53586590999993,
							30.354078012000063
						],
						[
							-81.53440091099992,
							30.35392401200005
						],
						[
							-81.53359990999991,
							30.353834013000043
						],
						[
							-81.5329359079999,
							30.35377101200004
						],
						[
							-81.53053090799995,
							30.353518012000055
						],
						[
							-81.52987690999994,
							30.353460012000085
						],
						[
							-81.5295559089999,
							30.353447013000054
						],
						[
							-81.52897090899995,
							30.353459012000087
						],
						[
							-81.52842090899992,
							30.353506013000068
						],
						[
							-81.5280019089999,
							30.353575012000075
						],
						[
							-81.52698690999995,
							30.35381601400007
						],
						[
							-81.5238559089999,
							30.35483601200008
						],
						[
							-81.52305191099992,
							30.35511501200006
						],
						[
							-81.52282591099994,
							30.355194012000084
						],
						[
							-81.52146991099994,
							30.35560801200006
						],
						[
							-81.52102390899995,
							30.355761012000077
						],
						[
							-81.5207489089999,
							30.355873013000064
						],
						[
							-81.52056646399991,
							30.35593813400004
						],
						[
							-81.51980890999994,
							30.356145012000074
						],
						[
							-81.51952391099991,
							30.35622501200004
						],
						[
							-81.51863290999995,
							30.35653601200005
						],
						[
							-81.51699191099993,
							30.357096013000046
						],
						[
							-81.51545990899992,
							30.357607013000063
						],
						[
							-81.5153459089999,
							30.35764401200004
						],
						[
							-81.5143279099999,
							30.35797301300005
						],
						[
							-81.5142029079999,
							30.358011013000063
						],
						[
							-81.51336491099994,
							30.358268013000043
						],
						[
							-81.51248191099995,
							30.358557013000055
						],
						[
							-81.51176690799991,
							30.35879101300009
						],
						[
							-81.51122990899995,
							30.35896701300004
						],
						[
							-81.51057391099994,
							30.359182013000062
						],
						[
							-81.50972691099992,
							30.359453013000067
						],
						[
							-81.5081209089999,
							30.35996501300008
						],
						[
							-81.50773390899991,
							30.36007001200005
						],
						[
							-81.50756090899995,
							30.360102012000084
						],
						[
							-81.50708090899991,
							30.36021801200008
						],
						[
							-81.5059509109999,
							30.36036301100006
						],
						[
							-81.50546690999994,
							30.36037801200007
						],
						[
							-81.5052619089999,
							30.360379012000067
						],
						[
							-81.50501390999995,
							30.360372013000074
						],
						[
							-81.50460691099994,
							30.36035301300006
						],
						[
							-81.50423490799994,
							30.36033801300005
						],
						[
							-81.50288990899992,
							30.360274013000037
						],
						[
							-81.50280892699993,
							30.360274005000065
						],
						[
							-81.50281791099991,
							30.360222014000044
						],
						[
							-81.50283590799995,
							30.36006401300006
						],
						[
							-81.50294191199993,
							30.35945901200006
						],
						[
							-81.50300391199994,
							30.359175012000037
						],
						[
							-81.50307391199995,
							30.358945013000035
						],
						[
							-81.50318091199995,
							30.358583012000057
						],
						[
							-81.50340291199991,
							30.358007012000087
						],
						[
							-81.50385990699993,
							30.357170013000086
						],
						[
							-81.5040739069999,
							30.35683801300007
						],
						[
							-81.5046689109999,
							30.356070013000082
						],
						[
							-81.50497390699991,
							30.355738013000064
						],
						[
							-81.50540891199995,
							30.355333012000074
						],
						[
							-81.50577491199994,
							30.355036012000085
						],
						[
							-81.50636291199993,
							30.35459301200007
						],
						[
							-81.50683591099994,
							30.35430501300004
						],
						[
							-81.50707990699993,
							30.35417001300004
						],
						[
							-81.50768291199995,
							30.353884012000037
						],
						[
							-81.50786490799993,
							30.35379501300008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Holly Oaks",
				"RegionID": "269012"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.42611544599993,
					28.514566680000087,
					-81.4178367049999,
					28.52702628500009
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.42350257099993,
							28.52700926600005
						],
						[
							-81.4219142149999,
							28.527003256000057
						],
						[
							-81.42092875399993,
							28.52700425800009
						],
						[
							-81.42002341099993,
							28.52700926600005
						],
						[
							-81.41966487999993,
							28.527010266000048
						],
						[
							-81.41843705899993,
							28.526974214000063
						],
						[
							-81.41800241399994,
							28.526933151000037
						],
						[
							-81.41787425799993,
							28.526901128000077
						],
						[
							-81.41787522499993,
							28.522935223000047
						],
						[
							-81.41790488499993,
							28.521890622000058
						],
						[
							-81.41800622599993,
							28.52185158700007
						],
						[
							-81.4181192399999,
							28.52176054800009
						],
						[
							-81.41821655799993,
							28.52160044400006
						],
						[
							-81.4183829399999,
							28.52134616300009
						],
						[
							-81.41843316799992,
							28.52126140200005
						],
						[
							-81.41834840799993,
							28.521182920000058
						],
						[
							-81.41829817899992,
							28.52114838800009
						],
						[
							-81.41825736899995,
							28.521126413000047
						],
						[
							-81.41816005099992,
							28.521069906000037
						],
						[
							-81.41805645499994,
							28.521003981000035
						],
						[
							-81.4178367049999,
							28.52086899200009
						],
						[
							-81.41783984399991,
							28.520712028000048
						],
						[
							-81.41790890899995,
							28.520539368000072
						],
						[
							-81.41800302599995,
							28.520424845000036
						],
						[
							-81.41837786599991,
							28.519579087000068
						],
						[
							-81.42192936899994,
							28.519540317000065
						],
						[
							-81.42189718999992,
							28.51585672500005
						],
						[
							-81.42185098899995,
							28.514566680000087
						],
						[
							-81.42606041899995,
							28.51460086300006
						],
						[
							-81.42604934799994,
							28.515404054000044
						],
						[
							-81.42606030999991,
							28.515844706000053
						],
						[
							-81.42606537199993,
							28.516107097000088
						],
						[
							-81.42607338399995,
							28.51646963400009
						],
						[
							-81.42607839099992,
							28.51701243900004
						],
						[
							-81.42606937799991,
							28.51798287800006
						],
						[
							-81.42606737499995,
							28.518197196000074
						],
						[
							-81.42607438499994,
							28.518507657000043
						],
						[
							-81.42609441399993,
							28.51935891900007
						],
						[
							-81.42611544599993,
							28.52007698500006
						],
						[
							-81.42611157099992,
							28.520776044000062
						],
						[
							-81.42605021899993,
							28.52090719200004
						],
						[
							-81.42605335399992,
							28.52153514700007
						],
						[
							-81.42605235299993,
							28.52199683100008
						],
						[
							-81.42605134999991,
							28.52247654300004
						],
						[
							-81.42605134999991,
							28.522919199000057
						],
						[
							-81.42605029599991,
							28.523297762000084
						],
						[
							-81.42605034899992,
							28.523395907000065
						],
						[
							-81.4260503779999,
							28.523400966000057
						],
						[
							-81.42605335399992,
							28.52393470600009
						],
						[
							-81.42606136599994,
							28.52471987000007
						],
						[
							-81.42606236799992,
							28.524844054000084
						],
						[
							-81.42605936199993,
							28.525205591000088
						],
						[
							-81.42606937799991,
							28.526097913000058
						],
						[
							-81.42607538699993,
							28.52702628500009
						],
						[
							-81.42512297299993,
							28.52701827900006
						],
						[
							-81.42402935299994,
							28.527012269000068
						],
						[
							-81.42350257099993,
							28.52700926600005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Johnson Village",
				"RegionID": "269025"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.63280890599992,
					30.130724723000075,
					-81.5955119059999,
					30.160908008000032
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.61418990599992,
							30.158694009000044
						],
						[
							-81.61389090399992,
							30.15867700800004
						],
						[
							-81.61359690599994,
							30.158681009000073
						],
						[
							-81.61312990499994,
							30.15871500900005
						],
						[
							-81.61202190599995,
							30.158842008000075
						],
						[
							-81.61140390599991,
							30.15892800900008
						],
						[
							-81.6087049059999,
							30.15927300800007
						],
						[
							-81.60840990499992,
							30.159311008000085
						],
						[
							-81.6082789059999,
							30.159325008000053
						],
						[
							-81.60808890599994,
							30.15934600800006
						],
						[
							-81.60747690599995,
							30.159413009000048
						],
						[
							-81.6074449059999,
							30.15941600900004
						],
						[
							-81.60689590599992,
							30.159470008000085
						],
						[
							-81.60633090599993,
							30.159481008000057
						],
						[
							-81.60616890599994,
							30.159477008000067
						],
						[
							-81.60589590599994,
							30.159477008000067
						],
						[
							-81.60545290599993,
							30.15947700900006
						],
						[
							-81.60501790599994,
							30.15950100800006
						],
						[
							-81.60469590499991,
							30.15955100900004
						],
						[
							-81.60417190599992,
							30.159679008000072
						],
						[
							-81.60298890599995,
							30.15996600800008
						],
						[
							-81.6022189059999,
							30.160154009000053
						],
						[
							-81.60182590599993,
							30.160250008000045
						],
						[
							-81.60147090599992,
							30.160337009000045
						],
						[
							-81.60133290599993,
							30.160368009000084
						],
						[
							-81.60094390599994,
							30.160472009000046
						],
						[
							-81.60074990599992,
							30.160517007000067
						],
						[
							-81.60056690599993,
							30.160530008000077
						],
						[
							-81.60022590599993,
							30.160511009000057
						],
						[
							-81.59954884299992,
							30.160442096000054
						],
						[
							-81.59946290799991,
							30.16027901100006
						],
						[
							-81.5991899039999,
							30.159908011000088
						],
						[
							-81.59899090699992,
							30.159750011000085
						],
						[
							-81.5987849089999,
							30.15961101000005
						],
						[
							-81.59747488999994,
							30.15883606300008
						],
						[
							-81.59761290599994,
							30.158649008000058
						],
						[
							-81.59865390499994,
							30.157566008000064
						],
						[
							-81.59886990599995,
							30.157341008000056
						],
						[
							-81.59913594699992,
							30.157089043000042
						],
						[
							-81.59923790399995,
							30.156937006000078
						],
						[
							-81.59929695799991,
							30.15675901800006
						],
						[
							-81.59931103799994,
							30.15658498700009
						],
						[
							-81.5991409049999,
							30.156027008000084
						],
						[
							-81.59896790499994,
							30.155524008000043
						],
						[
							-81.59882990499995,
							30.15510500900007
						],
						[
							-81.59861090499993,
							30.154519010000058
						],
						[
							-81.59847290599993,
							30.154214009000043
						],
						[
							-81.59754690599993,
							30.152435009000047
						],
						[
							-81.59743190599994,
							30.15220800800006
						],
						[
							-81.59721690599991,
							30.151795009000065
						],
						[
							-81.59705490499994,
							30.151492009000037
						],
						[
							-81.59686990499995,
							30.15114000900007
						],
						[
							-81.5965039049999,
							30.15040600900005
						],
						[
							-81.59605990499996,
							30.14953600800004
						],
						[
							-81.59578990599994,
							30.14886900600004
						],
						[
							-81.59575090599992,
							30.148669008000066
						],
						[
							-81.59572890499993,
							30.148286008000074
						],
						[
							-81.59567290599995,
							30.146416008000077
						],
						[
							-81.59566490599991,
							30.146021008000048
						],
						[
							-81.59563390599993,
							30.14448700800006
						],
						[
							-81.59563390599993,
							30.144135008000035
						],
						[
							-81.59563390599993,
							30.143139008000045
						],
						[
							-81.59564190599991,
							30.142658010000048
						],
						[
							-81.59558090599995,
							30.14116300800004
						],
						[
							-81.59551990599994,
							30.139786009000094
						],
						[
							-81.5955119059999,
							30.13951900800004
						],
						[
							-81.59553490699994,
							30.139292006000062
						],
						[
							-81.59568790499992,
							30.13877100900004
						],
						[
							-81.5957409049999,
							30.138489009000068
						],
						[
							-81.59576390399991,
							30.138248008000062
						],
						[
							-81.59575690699995,
							30.138159008000063
						],
						[
							-81.59576390399991,
							30.138023008000065
						],
						[
							-81.59573390599991,
							30.137697008000092
						],
						[
							-81.59565690699992,
							30.136902008000053
						],
						[
							-81.59565690699992,
							30.136837008000043
						],
						[
							-81.59567990699992,
							30.136650009000054
						],
						[
							-81.59571790699994,
							30.136518008000056
						],
						[
							-81.59578690599994,
							30.136356009000053
						],
						[
							-81.5958709059999,
							30.136221009000057
						],
						[
							-81.59597790499993,
							30.136078008000084
						],
						[
							-81.59621390399991,
							30.135792009000056
						],
						[
							-81.59627490499992,
							30.135677008000076
						],
						[
							-81.59632090399992,
							30.13553801000006
						],
						[
							-81.59644299999991,
							30.134449000000075
						],
						[
							-81.59649219799991,
							30.133955509000085
						],
						[
							-81.59693814899993,
							30.134024116000038
						],
						[
							-81.59735837199992,
							30.134024116000038
						],
						[
							-81.59770141099995,
							30.13396408500006
						],
						[
							-81.59802729899991,
							30.13386117300007
						],
						[
							-81.59830172999995,
							30.133723957000086
						],
						[
							-81.59861904099995,
							30.133535286000043
						],
						[
							-81.59897065599995,
							30.133278006000072
						],
						[
							-81.59925366399995,
							30.132960695000065
						],
						[
							-81.5994509109999,
							30.13259192800007
						],
						[
							-81.59956494499994,
							30.13224082200009
						],
						[
							-81.59959007899994,
							30.132204927000085
						],
						[
							-81.59967835899994,
							30.132113664000087
						],
						[
							-81.60005069899995,
							30.13177953800005
						],
						[
							-81.60021364799991,
							30.13162643800007
						],
						[
							-81.60056748499996,
							30.131269692000046
						],
						[
							-81.60062792699995,
							30.131214080000067
						],
						[
							-81.60073346399992,
							30.13113782700009
						],
						[
							-81.6010524639999,
							30.13094082700007
						],
						[
							-81.6011129069999,
							30.130906647000078
						],
						[
							-81.60117580899993,
							30.13087723600006
						],
						[
							-81.60124079399992,
							30.130852769000057
						],
						[
							-81.60130747499994,
							30.130833394000035
						],
						[
							-81.6013754519999,
							30.130819225000035
						],
						[
							-81.60179206999993,
							30.130752108000085
						],
						[
							-81.60184989099992,
							30.13074471400006
						],
						[
							-81.60206018399992,
							30.130724723000075
						],
						[
							-81.60563399999995,
							30.13149700000008
						],
						[
							-81.6071012029999,
							30.131814269000074
						],
						[
							-81.60712007299992,
							30.131829079000056
						],
						[
							-81.6072143799999,
							30.131920768000047
						],
						[
							-81.60736857699993,
							30.13209454200006
						],
						[
							-81.60744947799994,
							30.132136676000073
						],
						[
							-81.60763047899991,
							30.132193375000046
						],
						[
							-81.60790359499993,
							30.132222880000082
						],
						[
							-81.60799856299992,
							30.132238317000088
						],
						[
							-81.60842056199994,
							30.132330317000083
						],
						[
							-81.6085365859999,
							30.132363914000052
						],
						[
							-81.60865795899991,
							30.13241857400004
						],
						[
							-81.60918495899995,
							30.132704574000062
						],
						[
							-81.6092607679999,
							30.132750696000073
						],
						[
							-81.61247675699991,
							30.134931696000084
						],
						[
							-81.61252120099995,
							30.134934629000046
						],
						[
							-81.61266197499992,
							30.134955193000057
						],
						[
							-81.61288997499992,
							30.13500719400008
						],
						[
							-81.61295972999994,
							30.135026074000056
						],
						[
							-81.61302774199993,
							30.135050499000045
						],
						[
							-81.61309357199991,
							30.135080310000035
						],
						[
							-81.61315679299993,
							30.135115314000075
						],
						[
							-81.61321699799993,
							30.135155284000064
						],
						[
							-81.61327379599993,
							30.135199964000037
						],
						[
							-81.61347454899993,
							30.135374148000036
						],
						[
							-81.61353413599994,
							30.135425259000044
						],
						[
							-81.61382404799991,
							30.135533362000047
						],
						[
							-81.61398467399994,
							30.13555622500007
						],
						[
							-81.61460553799992,
							30.13562045200007
						],
						[
							-81.61474809599991,
							30.13564695000008
						],
						[
							-81.61503609699992,
							30.135724950000053
						],
						[
							-81.61510858699995,
							30.135747914000035
						],
						[
							-81.6152349429999,
							30.13580529800004
						],
						[
							-81.6153199339999,
							30.135852119000052
						],
						[
							-81.6153412029999,
							30.13585860700005
						],
						[
							-81.61543442899995,
							30.13585439900004
						],
						[
							-81.61568372799991,
							30.135820757000094
						],
						[
							-81.61577831599993,
							30.135813045000077
						],
						[
							-81.61623271099995,
							30.135800063000094
						],
						[
							-81.6175691059999,
							30.135760080000072
						],
						[
							-81.61762981699991,
							30.135760314000038
						],
						[
							-81.6186928169999,
							30.135800314000047
						],
						[
							-81.61878735499994,
							30.135808885000074
						],
						[
							-81.61942535499992,
							30.13590088500007
						],
						[
							-81.61949751199995,
							30.135914316000083
						],
						[
							-81.6195683329999,
							30.13593358600008
						],
						[
							-81.61963734799991,
							30.13595856800004
						],
						[
							-81.61970409499992,
							30.135989094000077
						],
						[
							-81.61976813099994,
							30.136024961000093
						],
						[
							-81.61998113099992,
							30.136155961000043
						],
						[
							-81.62008807299992,
							30.13623307900008
						],
						[
							-81.62019739499993,
							30.136342401000036
						],
						[
							-81.62040723899993,
							30.136350450000062
						],
						[
							-81.62110209699995,
							30.13630095100007
						],
						[
							-81.62119521199992,
							30.13629915200005
						],
						[
							-81.62239521299995,
							30.136338152000064
						],
						[
							-81.6225221659999,
							30.13635134100008
						],
						[
							-81.62259882299992,
							30.136368338000068
						],
						[
							-81.62317766099994,
							30.136523481000044
						],
						[
							-81.62327497799993,
							30.136494088000063
						],
						[
							-81.62337883399994,
							30.13646934100007
						],
						[
							-81.62343512399991,
							30.136461241000063
						],
						[
							-81.62378412399994,
							30.13642224100005
						],
						[
							-81.62380514799992,
							30.13642014100009
						],
						[
							-81.62510621199993,
							30.136305625000034
						],
						[
							-81.62549845299992,
							30.136225548000084
						],
						[
							-81.62567357899991,
							30.136128301000046
						],
						[
							-81.6258623189999,
							30.13592121200009
						],
						[
							-81.62595931899995,
							30.135829492000084
						],
						[
							-81.62617036599994,
							30.13565772700008
						],
						[
							-81.62633060299993,
							30.13547040700007
						],
						[
							-81.6263761219999,
							30.135421051000037
						],
						[
							-81.62642519699996,
							30.135375228000044
						],
						[
							-81.62647755299992,
							30.135333194000054
						],
						[
							-81.62653289899993,
							30.135295183000036
						],
						[
							-81.62659092699994,
							30.135261408000076
						],
						[
							-81.62665131299991,
							30.135232055000078
						],
						[
							-81.62743140499992,
							30.13488825400009
						],
						[
							-81.62842081199994,
							30.134283985000078
						],
						[
							-81.62920076099994,
							30.133828331000075
						],
						[
							-81.62923368999992,
							30.13379200500009
						],
						[
							-81.62932192699992,
							30.133707080000082
						],
						[
							-81.62936713199991,
							30.133671547000066
						],
						[
							-81.6294881309999,
							30.133582547000064
						],
						[
							-81.62954668399993,
							30.13354292800005
						],
						[
							-81.62960816799995,
							30.133508031000076
						],
						[
							-81.62967220299993,
							30.133478072000063
						],
						[
							-81.6297383939999,
							30.133453235000044
						],
						[
							-81.62980633099994,
							30.13343367400006
						],
						[
							-81.62998533099994,
							30.13338967500005
						],
						[
							-81.63004787699992,
							30.13337666300004
						],
						[
							-81.63011118599991,
							30.133368104000052
						],
						[
							-81.63017494199994,
							30.133364040000064
						],
						[
							-81.63023882499994,
							30.13336449200006
						],
						[
							-81.6303244369999,
							30.133339909000085
						],
						[
							-81.63061099299995,
							30.133203732000084
						],
						[
							-81.63070477199994,
							30.133165480000063
						],
						[
							-81.6308997719999,
							30.13309848100005
						],
						[
							-81.6310294669999,
							30.133064493000067
						],
						[
							-81.63128999999992,
							30.133931000000075
						],
						[
							-81.63177890499992,
							30.134475010000077
						],
						[
							-81.63193290599992,
							30.134747008000087
						],
						[
							-81.6321639059999,
							30.135109010000065
						],
						[
							-81.63227582399993,
							30.135315048000056
						],
						[
							-81.63230990499994,
							30.135394008000052
						],
						[
							-81.63234390499991,
							30.135530008000046
						],
						[
							-81.63250890799992,
							30.136099009000077
						],
						[
							-81.63259803099993,
							30.13625296300006
						],
						[
							-81.63264790599995,
							30.13667200800006
						],
						[
							-81.63265490599991,
							30.13693500800008
						],
						[
							-81.63265390599992,
							30.13710100800006
						],
						[
							-81.63266790599994,
							30.137840008000072
						],
						[
							-81.63266790599994,
							30.13876300800007
						],
						[
							-81.63266990599993,
							30.140043009000067
						],
						[
							-81.63267390599992,
							30.141424008000058
						],
						[
							-81.6326819059999,
							30.142742008000084
						],
						[
							-81.63268990599994,
							30.14415100800005
						],
						[
							-81.63268490599995,
							30.145300008000046
						],
						[
							-81.63268890599994,
							30.147042008000085
						],
						[
							-81.63269390599993,
							30.148363008000047
						],
						[
							-81.63269790599992,
							30.14962700900009
						],
						[
							-81.63269890499993,
							30.151004009000076
						],
						[
							-81.6327039059999,
							30.15262700800008
						],
						[
							-81.63271490599993,
							30.15327800900008
						],
						[
							-81.6327259059999,
							30.153692008000064
						],
						[
							-81.6327489059999,
							30.154851009000083
						],
						[
							-81.6327729059999,
							30.156367008000075
						],
						[
							-81.63280890599992,
							30.15781200800006
						],
						[
							-81.63278190599993,
							30.159011009000036
						],
						[
							-81.63276890599991,
							30.159915008000045
						],
						[
							-81.63275495999994,
							30.160850010000047
						],
						[
							-81.63257290599995,
							30.160852008000067
						],
						[
							-81.63159190599993,
							30.160873008000067
						],
						[
							-81.63132490499993,
							30.160875008000062
						],
						[
							-81.62994390599994,
							30.160908008000032
						],
						[
							-81.62949390599994,
							30.16089200800008
						],
						[
							-81.62918090499994,
							30.160862009000084
						],
						[
							-81.6286999049999,
							30.160799009000073
						],
						[
							-81.62639590499992,
							30.16050500900008
						],
						[
							-81.62562190599994,
							30.160412009000087
						],
						[
							-81.62454190499994,
							30.160263008000072
						],
						[
							-81.62242090599995,
							30.159992008000074
						],
						[
							-81.61978890599994,
							30.159658008000065
						],
						[
							-81.61911790499995,
							30.159548008000055
						],
						[
							-81.61794990499993,
							30.159340008000072
						],
						[
							-81.61732490499992,
							30.159231008000063
						],
						[
							-81.61666090499995,
							30.159113009000066
						],
						[
							-81.61650790499993,
							30.159082009000088
						],
						[
							-81.61542890499993,
							30.15889500800006
						],
						[
							-81.61466290599992,
							30.158765008000046
						],
						[
							-81.61452490599993,
							30.158739008000058
						],
						[
							-81.61440290599995,
							30.158720008000046
						],
						[
							-81.61418990599992,
							30.158694009000044
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Julington Creek",
				"RegionID": "269026"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.46102000004113,
					28.504635030116027,
					-81.45189300020034,
					28.538355999933472
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.457724602638,
							28.538144684437526
						],
						[
							-81.45773999993051,
							28.53611500005305
						],
						[
							-81.45771436025942,
							28.53611570602087
						],
						[
							-81.45737700028452,
							28.53612499961467
						],
						[
							-81.45736040059855,
							28.535851103896036
						],
						[
							-81.45733300005493,
							28.53539900032279
						],
						[
							-81.45709123171652,
							28.53539531490113
						],
						[
							-81.45549599991173,
							28.53537099993136
						],
						[
							-81.45550200018836,
							28.53615099991383
						],
						[
							-81.45525200035543,
							28.53615099991383
						],
						[
							-81.45406000026694,
							28.536161000374825
						],
						[
							-81.45291000031584,
							28.536155000098194
						],
						[
							-81.45189300020034,
							28.536144999637287
						],
						[
							-81.45189300020034,
							28.535288999748808
						],
						[
							-81.45209570288911,
							28.53528957981147
						],
						[
							-81.45294199999226,
							28.53529199988708
						],
						[
							-81.45297899989923,
							28.534280000002028
						],
						[
							-81.45291122968906,
							28.534280000002028
						],
						[
							-81.45290717284736,
							28.534175893584674
						],
						[
							-81.45489025076711,
							28.53417602398632
						],
						[
							-81.45489017612336,
							28.527687270754086
						],
						[
							-81.45492924806823,
							28.523053427663243
						],
						[
							-81.45508754583246,
							28.52257971787816
						],
						[
							-81.45485106550763,
							28.50471219644278
						],
						[
							-81.45578344571543,
							28.504709193606487
						],
						[
							-81.45670381008156,
							28.50469417133133
						],
						[
							-81.45681898085795,
							28.504693169486593
						],
						[
							-81.45884798985156,
							28.504643095235977
						],
						[
							-81.45899520886783,
							28.504639090554946
						],
						[
							-81.45914042329515,
							28.504635030116027
						],
						[
							-81.45913741955958,
							28.50512280619698
						],
						[
							-81.45913741955958,
							28.505306078133984
						],
						[
							-81.45914042419453,
							28.50712477527514
						],
						[
							-81.45914042419453,
							28.507245954422032
						],
						[
							-81.45914042419453,
							28.508178337327756
						],
						[
							-81.45915945025135,
							28.509065653407923
						],
						[
							-81.45919150028979,
							28.509884868327468
						],
						[
							-81.45920051239588,
							28.51016328044128
						],
						[
							-81.45920251608536,
							28.510521813154753
						],
						[
							-81.4592335624804,
							28.512998485768854
						],
						[
							-81.45922855505536,
							28.51379066077294
						],
						[
							-81.45922855505536,
							28.513886805492504
						],
						[
							-81.45922755141206,
							28.513961915069636
						],
						[
							-81.45928363673103,
							28.516761067476388
						],
						[
							-81.45927863020535,
							28.517425051319766
						],
						[
							-81.4592886432568,
							28.51853369504805
						],
						[
							-81.45929565347195,
							28.519195677000504
						],
						[
							-81.45931167669258,
							28.520683884987214
						],
						[
							-81.45931368038205,
							28.520837110575165
						],
						[
							-81.459324697077,
							28.522535630414346
						],
						[
							-81.45933771656195,
							28.52304438408092
						],
						[
							-81.459350736047,
							28.523523095895015
						],
						[
							-81.45934873235751,
							28.524176063043548
						],
						[
							-81.45934773141205,
							28.524242161414058
						],
						[
							-81.45934773141205,
							28.52431026257477
						],
						[
							-81.45941282883719,
							28.527932634582008
						],
						[
							-81.45941082424834,
							28.52802577466663
						],
						[
							-81.45940681866803,
							28.528080855442923
						],
						[
							-81.45938077969802,
							28.529793395712517
						],
						[
							-81.4592946525266,
							28.531554005643788
						],
						[
							-81.45918649106609,
							28.53247837828826
						],
						[
							-81.45897203423841,
							28.533101400711153
						],
						[
							-81.4609564071818,
							28.533080964517353
						],
						[
							-81.4609579998811,
							28.533111000074506
						],
						[
							-81.4609579998811,
							28.533379999883955
						],
						[
							-81.46095099955848,
							28.53370699966907
						],
						[
							-81.4604669997308,
							28.533695000015264
						],
						[
							-81.4604669997308,
							28.533941999709917
						],
						[
							-81.4609579998811,
							28.53394499984819
						],
						[
							-81.4609579998811,
							28.53407999977596
						],
						[
							-81.46098400018026,
							28.53517800002801
						],
						[
							-81.46099599983415,
							28.53617900030526
						],
						[
							-81.46102000004113,
							28.537148000006717
						],
						[
							-81.4607500001856,
							28.537149000052807
						],
						[
							-81.46077939722409,
							28.537949843621952
						],
						[
							-81.4607829999081,
							28.53804800012479
						],
						[
							-81.46029299980388,
							28.53804800012479
						],
						[
							-81.46029299980388,
							28.53795799417756
						],
						[
							-81.46029299980388,
							28.537692999948334
						],
						[
							-81.4591849999902,
							28.537692999948334
						],
						[
							-81.45918991748302,
							28.53797822262786
						],
						[
							-81.45919100026684,
							28.53804099980216
						],
						[
							-81.45810000033741,
							28.538166000168307
						],
						[
							-81.45772300004616,
							28.538355999933472
						],
						[
							-81.457724602638,
							28.538144684437526
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Kirkman North",
				"RegionID": "269027"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.48034699999994,
					28.486766000000046,
					-81.45473876099993,
					28.50471219600007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.45485106599995,
							28.50471219600007
						],
						[
							-81.45489017299992,
							28.50106779300006
						],
						[
							-81.45473876099993,
							28.49409933000004
						],
						[
							-81.45537584099992,
							28.494064406000064
						],
						[
							-81.45553107099994,
							28.494057397000063
						],
						[
							-81.45627130299994,
							28.494017212000074
						],
						[
							-81.45626502499994,
							28.494079553000066
						],
						[
							-81.45768426399991,
							28.494028351000054
						],
						[
							-81.45778240999994,
							28.494025348000037
						],
						[
							-81.4578435009999,
							28.494023345000077
						],
						[
							-81.45881694299993,
							28.493991298000083
						],
						[
							-81.4589461349999,
							28.49398729300009
						],
						[
							-81.45908447399995,
							28.493983415000063
						],
						[
							-81.45908434099994,
							28.493906172000038
						],
						[
							-81.4590833389999,
							28.493831060000048
						],
						[
							-81.45908434099994,
							28.492961772000058
						],
						[
							-81.45908434099994,
							28.49260324000005
						],
						[
							-81.45907432599995,
							28.492137548000073
						],
						[
							-81.45904428199992,
							28.49001039500007
						],
						[
							-81.45904828099994,
							28.489899724000054
						],
						[
							-81.46145084799991,
							28.49149059100006
						],
						[
							-81.4623211409999,
							28.49208146600006
						],
						[
							-81.46303225699995,
							28.49256034800004
						],
						[
							-81.46306023599995,
							28.492477052000083
						],
						[
							-81.46310826199993,
							28.492378729000055
						],
						[
							-81.46384840799993,
							28.492875645000083
						],
						[
							-81.46415285699993,
							28.493078945000036
						],
						[
							-81.46477678299993,
							28.493513591000067
						],
						[
							-81.46497006699991,
							28.493636774000038
						],
						[
							-81.46511824499993,
							28.493732084000044
						],
						[
							-81.46538868899995,
							28.493726906000067
						],
						[
							-81.46684121599992,
							28.493678918000057
						],
						[
							-81.46684285899994,
							28.49345955800004
						],
						[
							-81.4669209999999,
							28.49345800000009
						],
						[
							-81.4669419999999,
							28.493472000000054
						],
						[
							-81.46709399999992,
							28.493481000000088
						],
						[
							-81.46749999999992,
							28.49345500000004
						],
						[
							-81.46749999999992,
							28.491810000000044
						],
						[
							-81.46685521599994,
							28.491810000000044
						],
						[
							-81.46689299999991,
							28.486766000000046
						],
						[
							-81.47020082599995,
							28.486766826000064
						],
						[
							-81.47089899999992,
							28.486767000000043
						],
						[
							-81.47104899999994,
							28.486767000000043
						],
						[
							-81.47104599999994,
							28.486845000000073
						],
						[
							-81.47105499999992,
							28.48916100000008
						],
						[
							-81.47106269499994,
							28.49001512800004
						],
						[
							-81.47106599999995,
							28.490382000000068
						],
						[
							-81.4747040659999,
							28.490383782000038
						],
						[
							-81.47514999999993,
							28.490384000000063
						],
						[
							-81.47520999999995,
							28.490383000000065
						],
						[
							-81.47522399999991,
							28.491479000000083
						],
						[
							-81.47523099999995,
							28.491917000000058
						],
						[
							-81.47525499999995,
							28.493675000000053
						],
						[
							-81.47546899999992,
							28.493666000000076
						],
						[
							-81.4754714149999,
							28.493909560000077
						],
						[
							-81.47548299999994,
							28.495078000000035
						],
						[
							-81.4754979999999,
							28.496678000000088
						],
						[
							-81.47549791099993,
							28.496684416000054
						],
						[
							-81.47549399999991,
							28.496966000000043
						],
						[
							-81.4762399999999,
							28.496966000000043
						],
						[
							-81.48034699999994,
							28.49696700000004
						],
						[
							-81.48034599999994,
							28.50033200000007
						],
						[
							-81.48011797099991,
							28.50017232800008
						],
						[
							-81.47725699999995,
							28.498169000000075
						],
						[
							-81.47718199999993,
							28.498131000000058
						],
						[
							-81.47643699999992,
							28.497754000000043
						],
						[
							-81.47575708199992,
							28.497410253000055
						],
						[
							-81.47571899999991,
							28.49739100000005
						],
						[
							-81.47546764799995,
							28.497293142000046
						],
						[
							-81.47508199999993,
							28.49714300000005
						],
						[
							-81.47462899999994,
							28.496966000000043
						],
						[
							-81.47368599999993,
							28.496953000000076
						],
						[
							-81.47343899999993,
							28.496962000000053
						],
						[
							-81.4728419999999,
							28.496966000000043
						],
						[
							-81.47443545999994,
							28.497510004000052
						],
						[
							-81.47371497199993,
							28.49750575300004
						],
						[
							-81.47169648399995,
							28.49749384500007
						],
						[
							-81.47139213799994,
							28.498340134000046
						],
						[
							-81.47126249099995,
							28.498294686000065
						],
						[
							-81.4712158449999,
							28.49827686500004
						],
						[
							-81.4711622399999,
							28.498252577000073
						],
						[
							-81.47111033899995,
							28.498224836000077
						],
						[
							-81.47111024799995,
							28.49822478300007
						],
						[
							-81.47078124799992,
							28.498034783000037
						],
						[
							-81.47078100499994,
							28.49803464300004
						],
						[
							-81.4706588979999,
							28.497964074000038
						],
						[
							-81.47017397199994,
							28.49773450400005
						],
						[
							-81.46991279299995,
							28.497658524000087
						],
						[
							-81.46991024399995,
							28.497657779000065
						],
						[
							-81.46975724499993,
							28.497612780000054
						],
						[
							-81.4697219219999,
							28.49760159500005
						],
						[
							-81.4696668439999,
							28.497580866000078
						],
						[
							-81.46966231999994,
							28.497578977000046
						],
						[
							-81.46933233599992,
							28.49744018100006
						],
						[
							-81.46801113299995,
							28.49699032700005
						],
						[
							-81.46795684499995,
							28.49696986500004
						],
						[
							-81.46795562599993,
							28.496969359000047
						],
						[
							-81.46784262599994,
							28.496922359000052
						],
						[
							-81.46784136199994,
							28.496921832000055
						],
						[
							-81.46742484999993,
							28.496747846000066
						],
						[
							-81.46736419299994,
							28.49674361400008
						],
						[
							-81.4673170559999,
							28.496745558000043
						],
						[
							-81.46731429899995,
							28.496745668000074
						],
						[
							-81.46705229899993,
							28.49675566700006
						],
						[
							-81.46695918199993,
							28.496754396000085
						],
						[
							-81.46690061499993,
							28.496748628000034
						],
						[
							-81.46687976899995,
							28.49674563500008
						],
						[
							-81.46663081299994,
							28.49670690800008
						],
						[
							-81.46651284699993,
							28.496718067000074
						],
						[
							-81.46636525199995,
							28.496754471000088
						],
						[
							-81.46618504299994,
							28.496879422000067
						],
						[
							-81.4656667509999,
							28.497574100000065
						],
						[
							-81.46541170699993,
							28.497955714000057
						],
						[
							-81.46538821599995,
							28.497989189000066
						],
						[
							-81.46514448499994,
							28.49832024200009
						],
						[
							-81.46459712399991,
							28.499127025000064
						],
						[
							-81.46433894699993,
							28.499666698000055
						],
						[
							-81.4642499499999,
							28.499926971000036
						],
						[
							-81.46422986499994,
							28.49998015600005
						],
						[
							-81.46420557699992,
							28.500033760000065
						],
						[
							-81.46418242999994,
							28.500077608000087
						],
						[
							-81.46402031499991,
							28.500365207000073
						],
						[
							-81.46369848499997,
							28.501383111000056
						],
						[
							-81.46369571299994,
							28.501391724000086
						],
						[
							-81.46369448899992,
							28.501395465000087
						],
						[
							-81.46353704199993,
							28.50218644800009
						],
						[
							-81.46344006599992,
							28.502674329000058
						],
						[
							-81.46344004199995,
							28.50267444900004
						],
						[
							-81.4634266779999,
							28.502731762000053
						],
						[
							-81.46340959499992,
							28.502788078000037
						],
						[
							-81.46340158999993,
							28.502810667000062
						],
						[
							-81.46311261599993,
							28.50359283100005
						],
						[
							-81.46319113699991,
							28.50454804600008
						],
						[
							-81.46321168899993,
							28.504589339000063
						],
						[
							-81.46324522399993,
							28.504609179000056
						],
						[
							-81.46229982099993,
							28.504682332000073
						],
						[
							-81.45914042299995,
							28.504635030000088
						],
						[
							-81.45899520899991,
							28.504639091000058
						],
						[
							-81.45884798999992,
							28.504643095000063
						],
						[
							-81.45681898099991,
							28.504693169000063
						],
						[
							-81.45670380999991,
							28.50469417100004
						],
						[
							-81.45578344599994,
							28.504709194000043
						],
						[
							-81.45485106599995,
							28.50471219600007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Kirkman South",
				"RegionID": "269028"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.97370387099994,
					28.026714061000064,
					-81.96709197999992,
					28.03684701000009
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.97357804699993,
							28.03684701000009
						],
						[
							-81.9723028109999,
							28.036837770000094
						],
						[
							-81.9713596549999,
							28.036837770000094
						],
						[
							-81.9696273269999,
							28.03682814600006
						],
						[
							-81.96733053999992,
							28.03679168900004
						],
						[
							-81.9673306329999,
							28.036515979000058
						],
						[
							-81.96709197999992,
							28.036229853000066
						],
						[
							-81.96814286799992,
							28.035258468000052
						],
						[
							-81.96877626299994,
							28.034028763000038
						],
						[
							-81.96903704499994,
							28.032799108000063
						],
						[
							-81.96918609199992,
							28.03156947100007
						],
						[
							-81.96940966299991,
							28.03037709700004
						],
						[
							-81.96978221099994,
							28.029520024000078
						],
						[
							-81.97052751399991,
							28.028812101000085
						],
						[
							-81.97134727299994,
							28.02814138800005
						],
						[
							-81.97235334099992,
							28.027321630000074
						],
						[
							-81.97307893899995,
							28.026714061000064
						],
						[
							-81.97326882399994,
							28.026917163000064
						],
						[
							-81.97370387099994,
							28.027008383000066
						],
						[
							-81.9736398629999,
							28.02703294400004
						],
						[
							-81.97360686499991,
							28.02707698200004
						],
						[
							-81.97357691299993,
							28.02716201000004
						],
						[
							-81.97357590999992,
							28.02725600900004
						],
						[
							-81.97357390899992,
							28.027460011000073
						],
						[
							-81.97358790999994,
							28.027859010000043
						],
						[
							-81.97357790899991,
							28.028682010000068
						],
						[
							-81.97356890999993,
							28.029485011000077
						],
						[
							-81.97356290999994,
							28.030251011000075
						],
						[
							-81.9735559099999,
							28.031764010000074
						],
						[
							-81.97355390999991,
							28.03268901100006
						],
						[
							-81.9735589089999,
							28.033602011000085
						],
						[
							-81.97356490999994,
							28.03451601000006
						],
						[
							-81.97357290999992,
							28.03544001100005
						],
						[
							-81.9735769099999,
							28.036334011000065
						],
						[
							-81.97357804699993,
							28.03684701000009
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Polk",
				"City": "Lakeland",
				"Name": "Lake Hunter Terrace",
				"RegionID": "269042"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.60275990799994,
					30.340104042000064,
					-81.57747677499992,
					30.352039010000055
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.57747677499992,
							30.34715987900006
						],
						[
							-81.57836890599994,
							30.347151008000083
						],
						[
							-81.57892590499995,
							30.347157007000078
						],
						[
							-81.57907890599995,
							30.347126007000043
						],
						[
							-81.57916290399993,
							30.347094008000056
						],
						[
							-81.57986490499991,
							30.34666300800006
						],
						[
							-81.58044990499991,
							30.34630100900006
						],
						[
							-81.5807649059999,
							30.346109009000088
						],
						[
							-81.58127590599993,
							30.34578300800007
						],
						[
							-81.5816189059999,
							30.345577009000067
						],
						[
							-81.58203890699991,
							30.345312009000054
						],
						[
							-81.58208490599992,
							30.34529500900004
						],
						[
							-81.58222190599992,
							30.345268010000037
						],
						[
							-81.5823478659999,
							30.345270060000075
						],
						[
							-81.58521990299995,
							30.34522201000004
						],
						[
							-81.58534197299991,
							30.345254893000057
						],
						[
							-81.58586090699993,
							30.345686200000046
						],
						[
							-81.58633390599994,
							30.345263011000043
						],
						[
							-81.58640290599993,
							30.345230009000094
						],
						[
							-81.58645589699996,
							30.345214956000067
						],
						[
							-81.5873409049999,
							30.34519400800008
						],
						[
							-81.5893600419999,
							30.345153138000057
						],
						[
							-81.58935290599993,
							30.345048009000042
						],
						[
							-81.58935490599993,
							30.34466000900005
						],
						[
							-81.58933677399995,
							30.34401488000009
						],
						[
							-81.5905690379999,
							30.34399213600005
						],
						[
							-81.59055290599991,
							30.343172008000067
						],
						[
							-81.59053777199995,
							30.342351880000077
						],
						[
							-81.59156790499992,
							30.342316009000058
						],
						[
							-81.59234590499995,
							30.34229700900005
						],
						[
							-81.59252890499994,
							30.342285009000076
						],
						[
							-81.59307090499993,
							30.34227600900005
						],
						[
							-81.59354390499993,
							30.342255008000055
						],
						[
							-81.59365090599994,
							30.342264008000086
						],
						[
							-81.59438290499992,
							30.342239009000078
						],
						[
							-81.59455090599994,
							30.34222600900006
						],
						[
							-81.59494790499991,
							30.342224008000073
						],
						[
							-81.59546690499991,
							30.34220300900006
						],
						[
							-81.5956499049999,
							30.342207008000063
						],
						[
							-81.59585590599994,
							30.342194008000035
						],
						[
							-81.59604590599992,
							30.34219600800009
						],
						[
							-81.59635890599992,
							30.342184009000054
						],
						[
							-81.59719090499993,
							30.342157008000076
						],
						[
							-81.5973509019999,
							30.342141917000053
						],
						[
							-81.59759490599993,
							30.342142009000046
						],
						[
							-81.5982890009999,
							30.342118839000076
						],
						[
							-81.59833490599993,
							30.342197006000053
						],
						[
							-81.59836587099994,
							30.34223004900008
						],
						[
							-81.59841192899995,
							30.34225995600008
						],
						[
							-81.59847990599991,
							30.342279007000055
						],
						[
							-81.59855690499995,
							30.342287061000036
						],
						[
							-81.59862492499991,
							30.34227605700005
						],
						[
							-81.59880790599993,
							30.342188009000044
						],
						[
							-81.5997239049999,
							30.34170700800007
						],
						[
							-81.60111190499993,
							30.34093900800008
						],
						[
							-81.6025829969999,
							30.340104042000064
						],
						[
							-81.60261390499994,
							30.341188008000074
						],
						[
							-81.60261490499994,
							30.34155200800006
						],
						[
							-81.6026289049999,
							30.342663008000045
						],
						[
							-81.60264390599991,
							30.343000009000036
						],
						[
							-81.6026749049999,
							30.343870008000067
						],
						[
							-81.60268090599993,
							30.344251009000065
						],
						[
							-81.60269290499991,
							30.344570008000062
						],
						[
							-81.6026989049999,
							30.344704008000065
						],
						[
							-81.60269190699995,
							30.34477200900005
						],
						[
							-81.60270690599992,
							30.34502400800005
						],
						[
							-81.60272290599994,
							30.345324009000084
						],
						[
							-81.60273081799994,
							30.346070024000085
						],
						[
							-81.60274790799991,
							30.34664801000008
						],
						[
							-81.60274390799992,
							30.346990010000074
						],
						[
							-81.60275990799994,
							30.347504010000083
						],
						[
							-81.60275990699995,
							30.34798001100006
						],
						[
							-81.60272190799992,
							30.348415010000053
						],
						[
							-81.60267590699995,
							30.349300010000032
						],
						[
							-81.60266090799992,
							30.349438010000082
						],
						[
							-81.60263090799992,
							30.35010501100004
						],
						[
							-81.60261490799991,
							30.350702011000067
						],
						[
							-81.60261385099994,
							30.350981005000055
						],
						[
							-81.6026009069999,
							30.351490008000038
						],
						[
							-81.60262605199995,
							30.35161512100007
						],
						[
							-81.60226790599995,
							30.351641009000048
						],
						[
							-81.60155990599992,
							30.351652008000087
						],
						[
							-81.60046390499991,
							30.351677008000078
						],
						[
							-81.60038890499993,
							30.351678008000075
						],
						[
							-81.59921290599993,
							30.35169000800005
						],
						[
							-81.59809090499994,
							30.351709008000057
						],
						[
							-81.5967929059999,
							30.35172500800007
						],
						[
							-81.59479490599995,
							30.351763008000038
						],
						[
							-81.59390290599993,
							30.35178600800009
						],
						[
							-81.59281190599995,
							30.35179900900005
						],
						[
							-81.5915069049999,
							30.351826008000046
						],
						[
							-81.59045390599994,
							30.35184300800006
						],
						[
							-81.58953489499993,
							30.35185892000004
						],
						[
							-81.58801690799993,
							30.351891010000088
						],
						[
							-81.58649390799991,
							30.35191201000004
						],
						[
							-81.58583690799992,
							30.351915010000088
						],
						[
							-81.58534190699993,
							30.351925010000055
						],
						[
							-81.58429690699995,
							30.351942010000073
						],
						[
							-81.5832819069999,
							30.351961010000085
						],
						[
							-81.58222990799993,
							30.351971010000053
						],
						[
							-81.58162190799993,
							30.351981010000088
						],
						[
							-81.5803299079999,
							30.352001010000038
						],
						[
							-81.57959690699994,
							30.352013010000068
						],
						[
							-81.57858290699994,
							30.352024010000036
						],
						[
							-81.57756591499992,
							30.352039010000055
						],
						[
							-81.57755590599993,
							30.351177009000086
						],
						[
							-81.57750690499995,
							30.34890600800009
						],
						[
							-81.5775049049999,
							30.348803009000047
						],
						[
							-81.57749190599992,
							30.347992009000055
						],
						[
							-81.57747677499992,
							30.34715987900006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Lake Lucina",
				"RegionID": "269043"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.07741125699994,
					26.72491703500009,
					-80.06607987299992,
					26.732032322000066
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.07000061399994,
							26.730633628000078
						],
						[
							-80.06997087399994,
							26.73062920600006
						],
						[
							-80.06993264899995,
							26.73064286600004
						],
						[
							-80.06991907699995,
							26.73064759500005
						],
						[
							-80.06986276099991,
							26.73066467800004
						],
						[
							-80.06980544899994,
							26.73067804100009
						],
						[
							-80.06974738499993,
							26.730687628000055
						],
						[
							-80.0697210969999,
							26.730690696000067
						],
						[
							-80.06954879599994,
							26.73070823900008
						],
						[
							-80.06945073199995,
							26.73074183300008
						],
						[
							-80.06944921599995,
							26.730743378000057
						],
						[
							-80.06936167599991,
							26.730878334000067
						],
						[
							-80.0685786169999,
							26.73043296600008
						],
						[
							-80.06607987299992,
							26.729750634000084
						],
						[
							-80.06619999999992,
							26.729270000000042
						],
						[
							-80.06624013399994,
							26.729102331000036
						],
						[
							-80.06631069199994,
							26.728825138000047
						],
						[
							-80.06637100099994,
							26.728554993000046
						],
						[
							-80.0663899999999,
							26.72840000000008
						],
						[
							-80.0664028569999,
							26.72831771400007
						],
						[
							-80.06643376999995,
							26.728119872000036
						],
						[
							-80.06645653499993,
							26.727844383000047
						],
						[
							-80.0664799999999,
							26.727510000000052
						],
						[
							-80.06648392699992,
							26.727335260000075
						],
						[
							-80.06648746799993,
							26.727177673000085
						],
						[
							-80.06650291799991,
							26.72649016300005
						],
						[
							-80.06651999999991,
							26.725730000000055
						],
						[
							-80.06652471699994,
							26.725291340000073
						],
						[
							-80.06652869899995,
							26.724920998000073
						],
						[
							-80.0671599989999,
							26.72494000100005
						],
						[
							-80.06827004699994,
							26.72494017000008
						],
						[
							-80.0683034729999,
							26.72491703500009
						],
						[
							-80.07064908099994,
							26.72494000100005
						],
						[
							-80.07115999699994,
							26.72494000200004
						],
						[
							-80.0715600019999,
							26.725039999000046
						],
						[
							-80.07427999999993,
							26.725040000000035
						],
						[
							-80.07546214399991,
							26.72504915400009
						],
						[
							-80.0761622409999,
							26.72508681700009
						],
						[
							-80.07691999999992,
							26.725104000000044
						],
						[
							-80.0772911119999,
							26.72510364900006
						],
						[
							-80.07741125699994,
							26.72567332600005
						],
						[
							-80.07741125699994,
							26.726730856000074
						],
						[
							-80.07733462399995,
							26.72775773300009
						],
						[
							-80.07713537899991,
							26.729121794000037
						],
						[
							-80.07682884899992,
							26.729842140000073
						],
						[
							-80.07674061599994,
							26.730114106000087
						],
						[
							-80.0766410299999,
							26.73038217900006
						],
						[
							-80.07662886499992,
							26.730413156000054
						],
						[
							-80.0766045769999,
							26.73046676000007
						],
						[
							-80.07657683499991,
							26.730518661000076
						],
						[
							-80.07654575899994,
							26.73056863700009
						],
						[
							-80.07651147999991,
							26.730616473000055
						],
						[
							-80.07647414599995,
							26.73066196500008
						],
						[
							-80.07643391599993,
							26.730704917000082
						],
						[
							-80.07639096399993,
							26.73074514700005
						],
						[
							-80.0763454719999,
							26.730782481000062
						],
						[
							-80.07629763599994,
							26.73081675900005
						],
						[
							-80.07624766099991,
							26.73084783600007
						],
						[
							-80.0761957599999,
							26.730875578000052
						],
						[
							-80.07616449499994,
							26.73089025700006
						],
						[
							-80.07593558899993,
							26.730992408000077
						],
						[
							-80.07591889399993,
							26.731013250000046
						],
						[
							-80.07589314599994,
							26.731043964000037
						],
						[
							-80.0758529169999,
							26.731086917000084
						],
						[
							-80.07580996399992,
							26.731127146000063
						],
						[
							-80.07576447199995,
							26.731164480000075
						],
						[
							-80.07571663599992,
							26.73119875900005
						],
						[
							-80.0756666609999,
							26.731229836000068
						],
						[
							-80.07561475999995,
							26.731257577000065
						],
						[
							-80.07557040699993,
							26.731277972000044
						],
						[
							-80.07486840699994,
							26.73157797300007
						],
						[
							-80.07485915599995,
							26.731581866000056
						],
						[
							-80.07480407799994,
							26.731602596000073
						],
						[
							-80.07477531699993,
							26.731611823000037
						],
						[
							-80.07421428399994,
							26.73178148200009
						],
						[
							-80.07365691799993,
							26.73198012800009
						],
						[
							-80.07364407799992,
							26.73198459500009
						],
						[
							-80.07358776199993,
							26.732001678000074
						],
						[
							-80.07353044899992,
							26.732015042000057
						],
						[
							-80.07347238499995,
							26.73202462800009
						],
						[
							-80.07341381899994,
							26.732030397000074
						],
						[
							-80.07335499999994,
							26.732032322000066
						],
						[
							-80.07329618199992,
							26.732030397000074
						],
						[
							-80.07323761499993,
							26.73202462800009
						],
						[
							-80.0731795509999,
							26.732015042000057
						],
						[
							-80.07315889699993,
							26.732010681000077
						],
						[
							-80.07286698099995,
							26.73194545700005
						],
						[
							-80.07239482599994,
							26.73192223700005
						],
						[
							-80.0723801819999,
							26.731921397000065
						],
						[
							-80.07232161499991,
							26.73191562900007
						],
						[
							-80.07226355099993,
							26.73190604200005
						],
						[
							-80.07220623899991,
							26.731892679000055
						],
						[
							-80.07214992299993,
							26.731875596000066
						],
						[
							-80.07209484499992,
							26.73185486600005
						],
						[
							-80.07204123999992,
							26.731830578000086
						],
						[
							-80.07198933899991,
							26.731802836000043
						],
						[
							-80.07193936399995,
							26.731771759000083
						],
						[
							-80.07189152799992,
							26.73173748100004
						],
						[
							-80.0718460359999,
							26.731700147000083
						],
						[
							-80.07180308399995,
							26.73165991700006
						],
						[
							-80.07176285399993,
							26.731616965000057
						],
						[
							-80.07172551999993,
							26.73157147300009
						],
						[
							-80.07169124199993,
							26.731523637000066
						],
						[
							-80.07166016499991,
							26.731473661000052
						],
						[
							-80.07163597699991,
							26.73142888700005
						],
						[
							-80.07146913499992,
							26.731097984000087
						],
						[
							-80.07068692399992,
							26.730702301000065
						],
						[
							-80.07002905099995,
							26.73063691200008
						],
						[
							-80.07000061399994,
							26.730633628000078
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "West Palm Beach",
				"Name": "Lake Mangonia",
				"RegionID": "269044"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.4244874289999,
					28.534338151000043,
					-81.4135488089999,
					28.54192100000006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.41459199999991,
							28.540650000000085
						],
						[
							-81.41459199999991,
							28.540325000000053
						],
						[
							-81.41388799999993,
							28.540325000000053
						],
						[
							-81.4135864829999,
							28.54032464800008
						],
						[
							-81.4135708419999,
							28.540155763000087
						],
						[
							-81.41355991799992,
							28.54003758300007
						],
						[
							-81.41355982599993,
							28.539937438000038
						],
						[
							-81.41355982599993,
							28.53907916500009
						],
						[
							-81.41355481799991,
							28.538963996000064
						],
						[
							-81.4135488089999,
							28.538808765000056
						],
						[
							-81.41357184299994,
							28.538531353000053
						],
						[
							-81.4136329339999,
							28.538170819000072
						],
						[
							-81.41370503999991,
							28.53788439400006
						],
						[
							-81.41390433599992,
							28.53713127700007
						],
						[
							-81.41390934399993,
							28.537107241000058
						],
						[
							-81.41414719599993,
							28.536179365000066
						],
						[
							-81.41421980299992,
							28.53583435300004
						],
						[
							-81.41424984799994,
							28.53542374500006
						],
						[
							-81.41424984899993,
							28.53532860300004
						],
						[
							-81.41424984899993,
							28.53526851400005
						],
						[
							-81.4142648699999,
							28.53503767300009
						],
						[
							-81.41426386899991,
							28.535006125000052
						],
						[
							-81.41425371999992,
							28.534788675000073
						],
						[
							-81.41522829899992,
							28.534747743000082
						],
						[
							-81.41623178799995,
							28.53474874300008
						],
						[
							-81.41709707199993,
							28.53474774200004
						],
						[
							-81.4180055519999,
							28.53475488400005
						],
						[
							-81.41798930499994,
							28.534338151000043
						],
						[
							-81.42358621499994,
							28.53433993200008
						],
						[
							-81.4244874289999,
							28.53435199200004
						],
						[
							-81.42445247799992,
							28.53479045800009
						],
						[
							-81.42445226199993,
							28.534793123000043
						],
						[
							-81.4244412619999,
							28.534926124000037
						],
						[
							-81.42443662799991,
							28.534969385000068
						],
						[
							-81.42442704199993,
							28.53502744900004
						],
						[
							-81.42441367899994,
							28.535084762000057
						],
						[
							-81.4244062219999,
							28.53511099200006
						],
						[
							-81.42432322199994,
							28.535386992000042
						],
						[
							-81.42431359499994,
							28.53541707800008
						],
						[
							-81.42429286499993,
							28.535472156000083
						],
						[
							-81.4242685769999,
							28.53552576000004
						],
						[
							-81.42424146799993,
							28.535576565000042
						],
						[
							-81.42418054799992,
							28.535682425000065
						],
						[
							-81.4236516279999,
							28.53660228600006
						],
						[
							-81.42365083499993,
							28.536603661000072
						],
						[
							-81.4236197589999,
							28.536653637000086
						],
						[
							-81.42358547999993,
							28.536701473000054
						],
						[
							-81.42354814599992,
							28.53674696400009
						],
						[
							-81.42350791599995,
							28.53678991700008
						],
						[
							-81.42346496399995,
							28.536830146000057
						],
						[
							-81.42341947199992,
							28.53686748000007
						],
						[
							-81.4233716359999,
							28.536901759000045
						],
						[
							-81.42332166099993,
							28.536932836000062
						],
						[
							-81.42326975999993,
							28.53696057700006
						],
						[
							-81.42321615499992,
							28.53698486500008
						],
						[
							-81.42316107699992,
							28.53700559500004
						],
						[
							-81.42310476099993,
							28.537022678000085
						],
						[
							-81.42304744899991,
							28.537036042000068
						],
						[
							-81.42303288399995,
							28.537038814000084
						],
						[
							-81.42299988399992,
							28.53704481500006
						],
						[
							-81.42299368499994,
							28.537045920000082
						],
						[
							-81.42286768399993,
							28.537067920000084
						],
						[
							-81.42283038499994,
							28.537073629000076
						],
						[
							-81.42277181799994,
							28.53707939700007
						],
						[
							-81.42271299999994,
							28.537081322000063
						],
						[
							-81.42265418099993,
							28.53707939700007
						],
						[
							-81.42264325899993,
							28.537078614000052
						],
						[
							-81.42246325999992,
							28.537064614000087
						],
						[
							-81.42241561499992,
							28.537059628000065
						],
						[
							-81.42235755099995,
							28.53705004200009
						],
						[
							-81.42230892399994,
							28.537038959000085
						],
						[
							-81.42166549199993,
							28.536873420000063
						],
						[
							-81.42166384899991,
							28.536901458000045
						],
						[
							-81.42165520999993,
							28.537055638000083
						],
						[
							-81.42172738699992,
							28.537683818000062
						],
						[
							-81.4217889439999,
							28.537876182000048
						],
						[
							-81.42193744899994,
							28.538205754000046
						],
						[
							-81.42221038799994,
							28.538684789000058
						],
						[
							-81.42223557699992,
							28.53873224000006
						],
						[
							-81.42225986499994,
							28.538785844000074
						],
						[
							-81.4222805949999,
							28.538840922000077
						],
						[
							-81.42229767799995,
							28.538897238000065
						],
						[
							-81.42230795899991,
							28.53893970900009
						],
						[
							-81.42234995899992,
							28.539133709000055
						],
						[
							-81.42235304199994,
							28.53914855100004
						],
						[
							-81.42236262799993,
							28.539206615000072
						],
						[
							-81.42236839599991,
							28.539265181000076
						],
						[
							-81.42237032199995,
							28.53932400000008
						],
						[
							-81.4223702889999,
							28.53933171400007
						],
						[
							-81.42236520299991,
							28.53992451700009
						],
						[
							-81.42239454999992,
							28.539981168000054
						],
						[
							-81.4224088009999,
							28.539984754000045
						],
						[
							-81.42239461699995,
							28.54090855700008
						],
						[
							-81.42239199999995,
							28.541079000000085
						],
						[
							-81.42239199999995,
							28.54157900000007
						],
						[
							-81.42239677299995,
							28.541692744000045
						],
						[
							-81.42240399999991,
							28.541865000000087
						],
						[
							-81.4218919999999,
							28.541879000000055
						],
						[
							-81.42009199999991,
							28.541879000000055
						],
						[
							-81.41809199999994,
							28.541879000000055
						],
						[
							-81.41599999999994,
							28.541891000000078
						],
						[
							-81.4159239999999,
							28.541892000000075
						],
						[
							-81.41406499999994,
							28.54192100000006
						],
						[
							-81.41403699999995,
							28.541701000000046
						],
						[
							-81.41404299999995,
							28.54138400000005
						],
						[
							-81.41404011199995,
							28.54127135600004
						],
						[
							-81.41403699999995,
							28.541150000000076
						],
						[
							-81.41402999999991,
							28.540650000000085
						],
						[
							-81.41459199999991,
							28.540650000000085
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Lake Mann Estates",
				"RegionID": "269045"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.84301875999995,
					30.342242931000044,
					-81.75718172299992,
					30.42082284400004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.76751090699992,
							30.404728010000042
						],
						[
							-81.75987890699992,
							30.39701601000007
						],
						[
							-81.75718172299992,
							30.394492057000036
						],
						[
							-81.7575570379999,
							30.393369008000036
						],
						[
							-81.7577288729999,
							30.394135164000094
						],
						[
							-81.75778980799993,
							30.394059868000056
						],
						[
							-81.75785790999993,
							30.394037015000038
						],
						[
							-81.76361790899995,
							30.393953012000054
						],
						[
							-81.76438891099991,
							30.39394801300006
						],
						[
							-81.76454190899996,
							30.39395501200005
						],
						[
							-81.76464790999995,
							30.39396301200009
						],
						[
							-81.7650299099999,
							30.393967013000065
						],
						[
							-81.76551090899994,
							30.39395501200005
						],
						[
							-81.7659989089999,
							30.393953012000054
						],
						[
							-81.76793690999995,
							30.39392101200008
						],
						[
							-81.77266390999995,
							30.393837013000052
						],
						[
							-81.77315502499994,
							30.393924149000043
						],
						[
							-81.7731549099999,
							30.393826012000094
						],
						[
							-81.7731549099999,
							30.393152012000087
						],
						[
							-81.77309390999994,
							30.388903012000075
						],
						[
							-81.77309390999994,
							30.388304012000052
						],
						[
							-81.77304990999994,
							30.385465013000047
						],
						[
							-81.77305590999994,
							30.385048012000084
						],
						[
							-81.77301790999991,
							30.382647012000064
						],
						[
							-81.77300990999993,
							30.381406012000074
						],
						[
							-81.77299390999991,
							30.380797012000077
						],
						[
							-81.77298590999993,
							30.37959701200009
						],
						[
							-81.77294690999992,
							30.37674701300006
						],
						[
							-81.77293190899991,
							30.376507013000037
						],
						[
							-81.77292390899993,
							30.376059013000088
						],
						[
							-81.7729319099999,
							30.375614013000074
						],
						[
							-81.77291690899995,
							30.373795013000066
						],
						[
							-81.77289990999992,
							30.373488013000042
						],
						[
							-81.7729079099999,
							30.37318101200009
						],
						[
							-81.77289304099992,
							30.37183787700008
						],
						[
							-81.77068790999994,
							30.371920013000082
						],
						[
							-81.76950790899993,
							30.371964013000085
						],
						[
							-81.7687249089999,
							30.371987012000094
						],
						[
							-81.76847790999994,
							30.371990012000087
						],
						[
							-81.7660449089999,
							30.372080013000073
						],
						[
							-81.7648009099999,
							30.37211201200006
						],
						[
							-81.76467590999994,
							30.37211201200006
						],
						[
							-81.76370290999995,
							30.37211201200006
						],
						[
							-81.76323290999994,
							30.37209901300008
						],
						[
							-81.76288290999993,
							30.37210401200008
						],
						[
							-81.7621009099999,
							30.372103012000082
						],
						[
							-81.7612019099999,
							30.372091012000052
						],
						[
							-81.76090990699993,
							30.372087065000077
						],
						[
							-81.76086374999994,
							30.36698790600008
						],
						[
							-81.76117190799994,
							30.36685901000004
						],
						[
							-81.76447990699995,
							30.36585800800009
						],
						[
							-81.77092090899993,
							30.361756818000064
						],
						[
							-81.77314280399992,
							30.363253048000047
						],
						[
							-81.77627290899994,
							30.36527701300008
						],
						[
							-81.77640790899994,
							30.365391010000053
						],
						[
							-81.78429392499993,
							30.369515203000052
						],
						[
							-81.78732487699995,
							30.367232936000054
						],
						[
							-81.78993991099992,
							30.36687187800004
						],
						[
							-81.79553193399995,
							30.368225184000043
						],
						[
							-81.80111989199992,
							30.365410963000045
						],
						[
							-81.80692305799994,
							30.36439313500006
						],
						[
							-81.8069079089999,
							30.36352201200009
						],
						[
							-81.80691890999992,
							30.363199013000045
						],
						[
							-81.80691390999993,
							30.36061001300004
						],
						[
							-81.80692790899991,
							30.358838012000035
						],
						[
							-81.80692290999991,
							30.357939013000077
						],
						[
							-81.80691490999993,
							30.356983013000047
						],
						[
							-81.80691490999993,
							30.35605301200008
						],
						[
							-81.8069069089999,
							30.355799012000034
						],
						[
							-81.80691390999993,
							30.35564601300007
						],
						[
							-81.80690690999995,
							30.354796013000055
						],
						[
							-81.8069099089999,
							30.353675012000053
						],
						[
							-81.80691490999993,
							30.35283201200008
						],
						[
							-81.80694590799993,
							30.352425012000083
						],
						[
							-81.8069089089999,
							30.35201801200009
						],
						[
							-81.80689190999993,
							30.350471012000074
						],
						[
							-81.8068839099999,
							30.349310012000043
						],
						[
							-81.80687690999991,
							30.349040012000046
						],
						[
							-81.80688390899991,
							30.348857013000046
						],
						[
							-81.80685390999992,
							30.346413013000074
						],
						[
							-81.8068389099999,
							30.346065012000057
						],
						[
							-81.80683990999995,
							30.345776013000087
						],
						[
							-81.8067719259999,
							30.342242931000044
						],
						[
							-81.81113071099992,
							30.343091616000038
						],
						[
							-81.81488227099993,
							30.343966893000072
						],
						[
							-81.81838368899992,
							30.34671804600003
						],
						[
							-81.82000925599995,
							30.349219161000065
						],
						[
							-81.8232606329999,
							30.350969808000062
						],
						[
							-81.82726225699992,
							30.35172011700007
						],
						[
							-81.8303885229999,
							30.352095266000052
						],
						[
							-81.8365160269999,
							30.35309558300008
						],
						[
							-81.8398923769999,
							30.35397102600007
						],
						[
							-81.84301875999995,
							30.355096455000083
						],
						[
							-81.84289359499991,
							30.360098513000082
						],
						[
							-81.84239354199991,
							30.36422530800007
						],
						[
							-81.83901697699991,
							30.36547562600003
						],
						[
							-81.83614085999994,
							30.368977112000042
						],
						[
							-81.8342650969999,
							30.37297873700004
						],
						[
							-81.83338988399993,
							30.375604921000047
						],
						[
							-81.8306386459999,
							30.37710549000008
						],
						[
							-81.82588669799992,
							30.377105410000073
						],
						[
							-81.8213848719999,
							30.377105410000073
						],
						[
							-81.81750829999993,
							30.377105410000073
						],
						[
							-81.81663281499993,
							30.37710527800004
						],
						[
							-81.81625762499993,
							30.390360882000035
						],
						[
							-81.81875897599991,
							30.391736337000054
						],
						[
							-81.81175580099995,
							30.396488183000088
						],
						[
							-81.81175613599993,
							30.40086514300009
						],
						[
							-81.80712913499991,
							30.403616332000073
						],
						[
							-81.79850045899991,
							30.403240878000076
						],
						[
							-81.79875084899993,
							30.409243556000035
						],
						[
							-81.79462395199994,
							30.41049383700005
						],
						[
							-81.78362154399991,
							30.42082284400004
						],
						[
							-81.78244290799995,
							30.41982601000007
						],
						[
							-81.77524690699994,
							30.412321011000078
						],
						[
							-81.77516303999994,
							30.41222902400005
						],
						[
							-81.77024690699994,
							30.40741001000004
						],
						[
							-81.76751090699992,
							30.404728010000042
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Cisco Gardens",
				"RegionID": "268921"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.77061495899994,
					30.31507401000005,
					-81.74351490599992,
					30.35060614200006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.74357390599994,
							30.315844011000085
						],
						[
							-81.74357490999995,
							30.315576956000086
						],
						[
							-81.74413390699993,
							30.31558801000006
						],
						[
							-81.74501190799992,
							30.31561401100004
						],
						[
							-81.74533304099992,
							30.315615144000052
						],
						[
							-81.74533277599994,
							30.31553988000007
						],
						[
							-81.74614590699991,
							30.315525010000044
						],
						[
							-81.74881103899992,
							30.315567965000074
						],
						[
							-81.74866478399991,
							30.31567205500005
						],
						[
							-81.74885890699994,
							30.315664010000035
						],
						[
							-81.7491689069999,
							30.31566501000009
						],
						[
							-81.74962390699996,
							30.31566501000009
						],
						[
							-81.7504049069999,
							30.315652011000054
						],
						[
							-81.7507849079999,
							30.315651011000057
						],
						[
							-81.7512609069999,
							30.31564101000004
						],
						[
							-81.75196092199991,
							30.31563409900008
						],
						[
							-81.7521399069999,
							30.315626010000074
						],
						[
							-81.75296690699992,
							30.315618010000037
						],
						[
							-81.75304390799994,
							30.31561701000004
						],
						[
							-81.75346490699991,
							30.315615010000045
						],
						[
							-81.7538719069999,
							30.315618010000037
						],
						[
							-81.75473390699996,
							30.315622010000084
						],
						[
							-81.75488803899992,
							30.315618145000087
						],
						[
							-81.75489490799993,
							30.31549001000008
						],
						[
							-81.7548837729999,
							30.31533988000007
						],
						[
							-81.75642390799993,
							30.315317011000047
						],
						[
							-81.75656290799992,
							30.315313010000065
						],
						[
							-81.76387790899992,
							30.315182011000047
						],
						[
							-81.76417590699992,
							30.31519501000008
						],
						[
							-81.76451590799991,
							30.315193010000087
						],
						[
							-81.76518190799993,
							30.31518501000005
						],
						[
							-81.76770290799993,
							30.31514001000005
						],
						[
							-81.76791390799991,
							30.315138010000055
						],
						[
							-81.76844690699994,
							30.31511201100005
						],
						[
							-81.76856490699993,
							30.31510901000007
						],
						[
							-81.7689339069999,
							30.315098010000042
						],
						[
							-81.7690919069999,
							30.315098010000042
						],
						[
							-81.76927790799994,
							30.315094010000053
						],
						[
							-81.76972690799994,
							30.315079010000087
						],
						[
							-81.77033990699994,
							30.31507401000005
						],
						[
							-81.77055403899993,
							30.31507687800007
						],
						[
							-81.77055785099992,
							30.315239000000076
						],
						[
							-81.77055790599991,
							30.315346008000066
						],
						[
							-81.77055690599991,
							30.31604000900006
						],
						[
							-81.7705599059999,
							30.317019009000038
						],
						[
							-81.77057690599992,
							30.318211009000038
						],
						[
							-81.7705849059999,
							30.318708009000087
						],
						[
							-81.77061495899994,
							30.319010008000074
						],
						[
							-81.77059890699991,
							30.31909700800009
						],
						[
							-81.77059890599992,
							30.31956100900004
						],
						[
							-81.77060990599995,
							30.32022100900008
						],
						[
							-81.77061490599993,
							30.32092700900006
						],
						[
							-81.77059190499995,
							30.321304009000073
						],
						[
							-81.7705919039999,
							30.321373006000048
						],
						[
							-81.77057590599992,
							30.321444008000068
						],
						[
							-81.77052290599994,
							30.321878009000045
						],
						[
							-81.77047290499992,
							30.322131009000085
						],
						[
							-81.77033590499992,
							30.322694009000084
						],
						[
							-81.77028290599992,
							30.322868008000057
						],
						[
							-81.7697998239999,
							30.323984968000048
						],
						[
							-81.76939990499994,
							30.32471500800006
						],
						[
							-81.7689649049999,
							30.325318008000067
						],
						[
							-81.76874690599993,
							30.325576009000088
						],
						[
							-81.76842290499991,
							30.325938009000083
						],
						[
							-81.76823690599991,
							30.326121009000076
						],
						[
							-81.7679959049999,
							30.326367008000087
						],
						[
							-81.76600090499994,
							30.32839700800008
						],
						[
							-81.76580290499993,
							30.328603009000062
						],
						[
							-81.76554690499995,
							30.32886300900009
						],
						[
							-81.76528190499994,
							30.329139009000073
						],
						[
							-81.76505190499995,
							30.329364009000074
						],
						[
							-81.76482590599994,
							30.329608009000083
						],
						[
							-81.76426090599995,
							30.33027000800007
						],
						[
							-81.76388690599993,
							30.330750009000045
						],
						[
							-81.76336190599994,
							30.331497009000092
						],
						[
							-81.76319090599993,
							30.331761009000047
						],
						[
							-81.76294490499993,
							30.332174009000084
						],
						[
							-81.7628369059999,
							30.33233500900008
						],
						[
							-81.7627259059999,
							30.332508008000044
						],
						[
							-81.76255090599994,
							30.332825008000047
						],
						[
							-81.76213090599992,
							30.33368800800008
						],
						[
							-81.76188890599991,
							30.334249008000086
						],
						[
							-81.76170290599993,
							30.33474600900007
						],
						[
							-81.76152190499994,
							30.33527200900005
						],
						[
							-81.76140790599995,
							30.335651008000067
						],
						[
							-81.76138690599993,
							30.335722009000047
						],
						[
							-81.76137590499991,
							30.33576500900006
						],
						[
							-81.76120590599993,
							30.33644700900004
						],
						[
							-81.76103690599992,
							30.337308008000036
						],
						[
							-81.76096290599992,
							30.33791400800004
						],
						[
							-81.76090890599994,
							30.338517008000053
						],
						[
							-81.76089190599994,
							30.338869008000078
						],
						[
							-81.76089490599992,
							30.33984000900006
						],
						[
							-81.76089390599994,
							30.34039800800008
						],
						[
							-81.76090990599994,
							30.34271200900008
						],
						[
							-81.76091490499994,
							30.345164009000086
						],
						[
							-81.7609409179999,
							30.346755097000088
						],
						[
							-81.76064990599991,
							30.34678900800009
						],
						[
							-81.7521019049999,
							30.348069009000085
						],
						[
							-81.75152890499993,
							30.348261008000065
						],
						[
							-81.74828990499992,
							30.349480009000047
						],
						[
							-81.74523666999994,
							30.350538104000066
						],
						[
							-81.7436697739999,
							30.35060614200006
						],
						[
							-81.74366690699992,
							30.348678009000082
						],
						[
							-81.74365890699994,
							30.347658008000053
						],
						[
							-81.74366690599993,
							30.34738900800005
						],
						[
							-81.74365890699994,
							30.347120009000037
						],
						[
							-81.74365990699994,
							30.34577900900007
						],
						[
							-81.74365190599991,
							30.34551300800007
						],
						[
							-81.74364490399995,
							30.34364600900005
						],
						[
							-81.74365190599991,
							30.34342900900009
						],
						[
							-81.74364490399995,
							30.343260009000065
						],
						[
							-81.74362190699992,
							30.341550008000073
						],
						[
							-81.74358790399992,
							30.339700009000072
						],
						[
							-81.74355190699993,
							30.33724200900008
						],
						[
							-81.74353790499993,
							30.335958009000077
						],
						[
							-81.74353790499993,
							30.334314008000035
						],
						[
							-81.7435389069999,
							30.333405008000057
						],
						[
							-81.7435299039999,
							30.333128008000074
						],
						[
							-81.7435299039999,
							30.332308009000087
						],
						[
							-81.74352290699994,
							30.332201008000084
						],
						[
							-81.74353390499994,
							30.33190600900008
						],
						[
							-81.74352290699994,
							30.33099200800007
						],
						[
							-81.7435299039999,
							30.330683008000047
						],
						[
							-81.74351590599991,
							30.329576009000053
						],
						[
							-81.74352390699994,
							30.32910800900004
						],
						[
							-81.74351490599992,
							30.328688008000086
						],
						[
							-81.74352290699994,
							30.327469009000087
						],
						[
							-81.74351490599992,
							30.326904009000092
						],
						[
							-81.74352290699994,
							30.326624008000067
						],
						[
							-81.74352290699994,
							30.32561100800007
						],
						[
							-81.7435379069999,
							30.325397013000043
						],
						[
							-81.74353790899994,
							30.32524901100004
						],
						[
							-81.74353690599992,
							30.324972010000064
						],
						[
							-81.74352490899992,
							30.32333801100009
						],
						[
							-81.7435299089999,
							30.322700011000055
						],
						[
							-81.74351490599992,
							30.32175601100005
						],
						[
							-81.74353490699993,
							30.321471014000057
						],
						[
							-81.74356890599995,
							30.321344010000075
						],
						[
							-81.74364490799991,
							30.320635010000046
						],
						[
							-81.74363690699994,
							30.31993101000006
						],
						[
							-81.74364490799991,
							30.31980901000009
						],
						[
							-81.74362890599991,
							30.319561010000086
						],
						[
							-81.74362190699992,
							30.319212010000058
						],
						[
							-81.74362190699992,
							30.318502011000078
						],
						[
							-81.74360090699992,
							30.31779901100009
						],
						[
							-81.74357390599994,
							30.315844011000085
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Commonwealth",
				"RegionID": "268932"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.35210774327909,
					28.553187090039273,
					-81.34569304202137,
					28.55858408881099
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.34569304561867,
							28.557686890980378
						],
						[
							-81.34569304202137,
							28.555926015749066
						],
						[
							-81.34780143596916,
							28.555926283747045
						],
						[
							-81.3477751316992,
							28.55324905152846
						],
						[
							-81.34787841523692,
							28.553248179186085
						],
						[
							-81.34996951792019,
							28.553225144850938
						],
						[
							-81.35156488372384,
							28.553188090085364
						],
						[
							-81.35200602815885,
							28.553187090039273
						],
						[
							-81.3520024416626,
							28.553247176442063
						],
						[
							-81.35203357888926,
							28.55411346277593
						],
						[
							-81.35204359373937,
							28.554975741730836
						],
						[
							-81.3520636225403,
							28.555820994721103
						],
						[
							-81.35207664292463,
							28.55641387456756
						],
						[
							-81.3520816494504,
							28.556869549348587
						],
						[
							-81.35208565593,
							28.55724610897207
						],
						[
							-81.3520996763605,
							28.557992214406568
						],
						[
							-81.35210268099534,
							28.558250598618812
						],
						[
							-81.35210774327909,
							28.55858408881099
						],
						[
							-81.35003555423741,
							28.558537028188567
						],
						[
							-81.35000469939793,
							28.557719676664234
						],
						[
							-81.34569304561867,
							28.557686890980378
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Coytown",
				"RegionID": "268941"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.55268090099993,
					30.215433008000048,
					-81.49913288599993,
					30.253963010000064
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.50998190799993,
							30.253963010000064
						],
						[
							-81.50988690799994,
							30.25395401000009
						],
						[
							-81.50980190799994,
							30.25395401000009
						],
						[
							-81.50971090699994,
							30.253948011000034
						],
						[
							-81.5094089079999,
							30.253950010000043
						],
						[
							-81.50911190699992,
							30.253950010000043
						],
						[
							-81.50878290799994,
							30.253932010000085
						],
						[
							-81.50845490799992,
							30.253913010000073
						],
						[
							-81.50797690699994,
							30.253886010000087
						],
						[
							-81.50761890799993,
							30.253844011000066
						],
						[
							-81.50743590799993,
							30.25382501100006
						],
						[
							-81.50711490799995,
							30.25378601100005
						],
						[
							-81.5067109069999,
							30.25371201100006
						],
						[
							-81.5063519069999,
							30.25365701000004
						],
						[
							-81.50557990699991,
							30.253541010000045
						],
						[
							-81.50507490799993,
							30.253457011000084
						],
						[
							-81.49913288599993,
							30.252487061000068
						],
						[
							-81.49999778099993,
							30.236597078000045
						],
						[
							-81.49942660999994,
							30.216467762000036
						],
						[
							-81.52096591499992,
							30.216166060000035
						],
						[
							-81.5217799049999,
							30.21590900800004
						],
						[
							-81.52194589699991,
							30.215856957000085
						],
						[
							-81.52391890599995,
							30.21579500900009
						],
						[
							-81.5277209059999,
							30.21566300900008
						],
						[
							-81.52783990599994,
							30.215658009000038
						],
						[
							-81.53004390599996,
							30.215596008000038
						],
						[
							-81.53222090499992,
							30.215521008000053
						],
						[
							-81.5323139059999,
							30.215519008000058
						],
						[
							-81.53381590599992,
							30.21549700800006
						],
						[
							-81.53687790499993,
							30.21546800800007
						],
						[
							-81.53935590499992,
							30.215454008000055
						],
						[
							-81.53970290599995,
							30.21544400900007
						],
						[
							-81.54104290499993,
							30.215433008000048
						],
						[
							-81.54171290499994,
							30.21544400900007
						],
						[
							-81.54250290599992,
							30.21545400900004
						],
						[
							-81.54296890599994,
							30.21548500900008
						],
						[
							-81.54339990599995,
							30.215537009000062
						],
						[
							-81.54371090699995,
							30.215599008000087
						],
						[
							-81.5439749059999,
							30.215671008000072
						],
						[
							-81.54446490599992,
							30.215826008000082
						],
						[
							-81.54482290499993,
							30.215940009000064
						],
						[
							-81.5453019059999,
							30.216147009000057
						],
						[
							-81.54539690599995,
							30.216188009000067
						],
						[
							-81.54574390599994,
							30.216395009000053
						],
						[
							-81.5461389059999,
							30.216664009000052
						],
						[
							-81.54720390599994,
							30.21745000800007
						],
						[
							-81.54757390599993,
							30.217677008000067
						],
						[
							-81.54782590499993,
							30.217811008000066
						],
						[
							-81.54818390499992,
							30.217977008000048
						],
						[
							-81.54845990599995,
							30.218101009000065
						],
						[
							-81.54874690599992,
							30.218215008000076
						],
						[
							-81.54888990599994,
							30.218256009000076
						],
						[
							-81.5492009059999,
							30.218339009000093
						],
						[
							-81.54945190599994,
							30.218411008000093
						],
						[
							-81.54970390499994,
							30.21845200900009
						],
						[
							-81.54976290499991,
							30.218463008000068
						],
						[
							-81.5501499049999,
							30.21850800900006
						],
						[
							-81.55069990499993,
							30.218558008000056
						],
						[
							-81.55074590599992,
							30.218562008000045
						],
						[
							-81.55127892799993,
							30.21858214100007
						],
						[
							-81.5517878839999,
							30.218418877000094
						],
						[
							-81.5519919059999,
							30.21843498700008
						],
						[
							-81.55199090799994,
							30.21859501100005
						],
						[
							-81.55203085399995,
							30.22079001400005
						],
						[
							-81.55203590799994,
							30.222777010000076
						],
						[
							-81.55203990799993,
							30.22446201100007
						],
						[
							-81.55205490799995,
							30.225310010000047
						],
						[
							-81.5520519069999,
							30.226770011000042
						],
						[
							-81.55206990699992,
							30.227247010000042
						],
						[
							-81.55206990699992,
							30.227963010000053
						],
						[
							-81.5520739079999,
							30.22810601000009
						],
						[
							-81.5520739079999,
							30.228350011000085
						],
						[
							-81.55207890799994,
							30.228957010000045
						],
						[
							-81.55208090799994,
							30.229599011000065
						],
						[
							-81.55208990699992,
							30.230202011000074
						],
						[
							-81.55208990699992,
							30.23139501000009
						],
						[
							-81.55208990699992,
							30.231690010000083
						],
						[
							-81.55209890799995,
							30.231966010000068
						],
						[
							-81.55212590799994,
							30.23322901100005
						],
						[
							-81.55211490799991,
							30.234011010000074
						],
						[
							-81.55211490799991,
							30.23496601100004
						],
						[
							-81.55212190799995,
							30.23572001100007
						],
						[
							-81.55212990699994,
							30.238225010000065
						],
						[
							-81.55214590799994,
							30.239598010000066
						],
						[
							-81.55214690799994,
							30.23984801100005
						],
						[
							-81.55214290799995,
							30.240139010000064
						],
						[
							-81.5521389079999,
							30.240303011000034
						],
						[
							-81.55215590799992,
							30.24140101000006
						],
						[
							-81.55216890699995,
							30.242223011000075
						],
						[
							-81.55219690799993,
							30.24361201100004
						],
						[
							-81.5521849079999,
							30.244850011000036
						],
						[
							-81.55220890699991,
							30.246138011000085
						],
						[
							-81.55224390799992,
							30.246716010000057
						],
						[
							-81.55230890799993,
							30.24753501000004
						],
						[
							-81.55248290799994,
							30.24906901000009
						],
						[
							-81.55257090799995,
							30.249526010000068
						],
						[
							-81.5526379069999,
							30.24988001000008
						],
						[
							-81.55268090099993,
							30.250102013000063
						],
						[
							-81.55241590599991,
							30.25010300800005
						],
						[
							-81.55216290599992,
							30.250104008000047
						],
						[
							-81.55156690599995,
							30.25011400900007
						],
						[
							-81.5508629059999,
							30.250099008000067
						],
						[
							-81.55007090499993,
							30.250097008000072
						],
						[
							-81.54865290499993,
							30.250095009000063
						],
						[
							-81.54763590499994,
							30.25010300800005
						],
						[
							-81.5468129059999,
							30.250105008000045
						],
						[
							-81.5465219049999,
							30.25010200800006
						],
						[
							-81.54624590499992,
							30.250100008000064
						],
						[
							-81.54308690499994,
							30.25011100800009
						],
						[
							-81.54271090599991,
							30.25010300800005
						],
						[
							-81.54221690599991,
							30.25009800800007
						],
						[
							-81.54006490499995,
							30.250140008000077
						],
						[
							-81.5369539049999,
							30.250232009000058
						],
						[
							-81.53647090499993,
							30.250245008000032
						],
						[
							-81.53624690599992,
							30.250249009000072
						],
						[
							-81.53617882599991,
							30.250254179000077
						],
						[
							-81.53610571399992,
							30.250152024000045
						],
						[
							-81.53615604799997,
							30.25005091800006
						],
						[
							-81.53609190599991,
							30.25005300800007
						],
						[
							-81.53600390499992,
							30.250057009000045
						],
						[
							-81.53587690599994,
							30.250060008000045
						],
						[
							-81.53580776099994,
							30.250060928000043
						],
						[
							-81.53587609699991,
							30.250162023000087
						],
						[
							-81.53578698399991,
							30.25026417400005
						],
						[
							-81.53540490499995,
							30.250274008000076
						],
						[
							-81.53472990599995,
							30.250284008000055
						],
						[
							-81.53426890599991,
							30.250295008000077
						],
						[
							-81.53384490499991,
							30.250302008000062
						],
						[
							-81.53177290499991,
							30.250320008000074
						],
						[
							-81.5314129059999,
							30.250325008000065
						],
						[
							-81.52975690599993,
							30.250411009000064
						],
						[
							-81.5297019059999,
							30.25041600800006
						],
						[
							-81.52961890599994,
							30.250422008000047
						],
						[
							-81.52933190499994,
							30.250444009000034
						],
						[
							-81.52898990599994,
							30.25048200800006
						],
						[
							-81.52855390499991,
							30.250537008000038
						],
						[
							-81.52824790599993,
							30.250577008000047
						],
						[
							-81.5279439059999,
							30.25062600800004
						],
						[
							-81.52756990599994,
							30.25068500800006
						],
						[
							-81.5272939059999,
							30.250741008000034
						],
						[
							-81.52663590599991,
							30.25087400900009
						],
						[
							-81.52457090599995,
							30.251305009000074
						],
						[
							-81.52346590499991,
							30.251535008000076
						],
						[
							-81.5227239049999,
							30.25168500800004
						],
						[
							-81.52252290599995,
							30.25173200900008
						],
						[
							-81.5218429059999,
							30.251895008000076
						],
						[
							-81.52124390599994,
							30.252022008000043
						],
						[
							-81.51751090499994,
							30.25282900900004
						],
						[
							-81.51632590699995,
							30.253067953000087
						],
						[
							-81.51614890699996,
							30.253103011000064
						],
						[
							-81.51493890699993,
							30.25332301100008
						],
						[
							-81.5145839079999,
							30.25338101100004
						],
						[
							-81.51373890799995,
							30.253566010000043
						],
						[
							-81.51337790699995,
							30.25363001100004
						],
						[
							-81.51293790799991,
							30.253704010000035
						],
						[
							-81.51250490699994,
							30.25376801100009
						],
						[
							-81.51187490799992,
							30.253845011000063
						],
						[
							-81.5112579069999,
							30.253900010000056
						],
						[
							-81.51093490799991,
							30.253922011000043
						],
						[
							-81.50998190799993,
							30.253963010000064
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Deerwood",
				"RegionID": "268946"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.32896349799995,
					28.516971092000063,
					-81.31840055599992,
					28.524401434000083
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.31842875699994,
							28.524400486000047
						],
						[
							-81.31840055599992,
							28.522396300000082
						],
						[
							-81.32154850599994,
							28.522144178000076
						],
						[
							-81.32154850199993,
							28.52047944800006
						],
						[
							-81.31840056499993,
							28.52047971500008
						],
						[
							-81.31840097299995,
							28.517091255000082
						],
						[
							-81.31861322899994,
							28.517082861000063
						],
						[
							-81.31861578799993,
							28.517053436000083
						],
						[
							-81.31862243499995,
							28.51697699500005
						],
						[
							-81.31862294799993,
							28.516971092000063
						],
						[
							-81.31863587499993,
							28.516971150000074
						],
						[
							-81.3267211729999,
							28.517007298000067
						],
						[
							-81.32672090499995,
							28.51863497800008
						],
						[
							-81.32896339199993,
							28.518634793000047
						],
						[
							-81.32896349799995,
							28.520515768000053
						],
						[
							-81.32809594399993,
							28.52051550100009
						],
						[
							-81.32809608999992,
							28.524254178000035
						],
						[
							-81.3278897479999,
							28.524254048000046
						],
						[
							-81.3277125329999,
							28.524330424000084
						],
						[
							-81.32758532099992,
							28.524333296000066
						],
						[
							-81.3248066999999,
							28.524368294000055
						],
						[
							-81.32423735399993,
							28.524376360000076
						],
						[
							-81.32367852599992,
							28.524383371000056
						],
						[
							-81.32325690099992,
							28.524385374000076
						],
						[
							-81.3222253589999,
							28.524401434000083
						],
						[
							-81.32120185399992,
							28.524361339000052
						],
						[
							-81.31983482599992,
							28.52437135400004
						],
						[
							-81.3186370489999,
							28.524387378000085
						],
						[
							-81.31842875699994,
							28.524400486000047
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Dover Estates",
				"RegionID": "268955"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.53692732199994,
					27.89310000200004,
					-82.5185084389999,
					27.90877279700004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.51865827699993,
							27.904769136000088
						],
						[
							-82.51855453299993,
							27.893499990000066
						],
						[
							-82.52081818099992,
							27.89310000200004
						],
						[
							-82.52685454499994,
							27.893227273000036
						],
						[
							-82.53281819099993,
							27.89329994900004
						],
						[
							-82.53376331599992,
							27.89360062800006
						],
						[
							-82.53386777299994,
							27.893861721000068
						],
						[
							-82.53423207599991,
							27.893791960000044
						],
						[
							-82.53443360499995,
							27.89372220000007
						],
						[
							-82.53467388999991,
							27.89368344500008
						],
						[
							-82.5349529309999,
							27.89376870700005
						],
						[
							-82.5351002029999,
							27.893993490000074
						],
						[
							-82.53542574999994,
							27.894342291000044
						],
						[
							-82.53551961099993,
							27.894461327000045
						],
						[
							-82.53549408599991,
							27.89455658600008
						],
						[
							-82.53545870199991,
							27.894640361000086
						],
						[
							-82.53542970099996,
							27.894700361000048
						],
						[
							-82.53539599699992,
							27.894764829000056
						],
						[
							-82.53535666399995,
							27.89482602600009
						],
						[
							-82.53531201699992,
							27.894883460000074
						],
						[
							-82.53526241199995,
							27.89493667100004
						],
						[
							-82.53525737799994,
							27.89501753600007
						],
						[
							-82.53525037899993,
							27.895073537000087
						],
						[
							-82.53524365899995,
							27.89511816600009
						],
						[
							-82.53520308599991,
							27.895269587000087
						],
						[
							-82.53513683599994,
							27.895411661000082
						],
						[
							-82.53504692099995,
							27.895540073000063
						],
						[
							-82.53495659999993,
							27.89563316200008
						],
						[
							-82.53493779399992,
							27.895646500000055
						],
						[
							-82.53490618199993,
							27.895718800000058
						],
						[
							-82.53486885699995,
							27.89578832500007
						],
						[
							-82.53482606099993,
							27.89585462100007
						],
						[
							-82.53477807299993,
							27.89591726200007
						],
						[
							-82.53474222299991,
							27.895959451000067
						],
						[
							-82.53469026999994,
							27.89601555200005
						],
						[
							-82.53463373799991,
							27.896067038000073
						],
						[
							-82.53457303699992,
							27.896113536000087
						],
						[
							-82.53450860599992,
							27.896154709000086
						],
						[
							-82.53444090999994,
							27.896190260000083
						],
						[
							-82.53437043899993,
							27.896219933000054
						],
						[
							-82.53429770199995,
							27.89624351100008
						],
						[
							-82.53418970299992,
							27.89627351200005
						],
						[
							-82.5341051659999,
							27.896292660000086
						],
						[
							-82.53394679899992,
							27.89630631700004
						],
						[
							-82.53319874999994,
							27.89630266000006
						],
						[
							-82.53301872599991,
							27.896440573000064
						],
						[
							-82.53302346699991,
							27.89651427000007
						],
						[
							-82.53302526999994,
							27.89656237400004
						],
						[
							-82.53303229599993,
							27.89722118700007
						],
						[
							-82.53303232199994,
							27.89730300000008
						],
						[
							-82.53303030099994,
							27.897326099000054
						],
						[
							-82.53435674499991,
							27.89741887000008
						],
						[
							-82.53439428999991,
							27.897422288000087
						],
						[
							-82.5347254209999,
							27.897459447000074
						],
						[
							-82.5347862289999,
							27.897435981000058
						],
						[
							-82.53486011099994,
							27.897411093000073
						],
						[
							-82.53498111099992,
							27.897376093000048
						],
						[
							-82.53506584399992,
							27.89735597400005
						],
						[
							-82.5351613389999,
							27.897338157000036
						],
						[
							-82.53532199999995,
							27.897323678000078
						],
						[
							-82.53536064599992,
							27.897324508000054
						],
						[
							-82.53545364699994,
							27.89732850900009
						],
						[
							-82.53553200199991,
							27.89733532100007
						],
						[
							-82.5356094629999,
							27.897348954000055
						],
						[
							-82.53568543699993,
							27.897369303000062
						],
						[
							-82.53575934199995,
							27.897396212000046
						],
						[
							-82.53583061299992,
							27.89742947500008
						],
						[
							-82.53590161299991,
							27.897466475000044
						],
						[
							-82.53596844799995,
							27.897505037000087
						],
						[
							-82.53603173099992,
							27.89754918700004
						],
						[
							-82.53609099699992,
							27.89759859900005
						],
						[
							-82.53614580899995,
							27.897652909000044
						],
						[
							-82.5361957639999,
							27.89771171800004
						],
						[
							-82.53624049399991,
							27.897774593000065
						],
						[
							-82.5362884939999,
							27.897848593000052
						],
						[
							-82.53632743899993,
							27.897914637000042
						],
						[
							-82.53636061599991,
							27.897983759000056
						],
						[
							-82.53638778599992,
							27.898055456000066
						],
						[
							-82.53640874899992,
							27.89812920600008
						],
						[
							-82.5364233549999,
							27.898204474000067
						],
						[
							-82.53643149599992,
							27.898280713000077
						],
						[
							-82.5364854959999,
							27.899126713000044
						],
						[
							-82.53648732199991,
							27.899184000000048
						],
						[
							-82.53648732199991,
							27.89935500000007
						],
						[
							-82.5364760949999,
							27.899496660000068
						],
						[
							-82.53645126399994,
							27.899652330000038
						],
						[
							-82.53650730299995,
							27.899708032000035
						],
						[
							-82.53655811599992,
							27.899768539000036
						],
						[
							-82.53660329299993,
							27.899833364000074
						],
						[
							-82.53664246699992,
							27.899901982000074
						],
						[
							-82.53667532399993,
							27.899973840000087
						],
						[
							-82.5367313239999,
							27.90011184000008
						],
						[
							-82.5367649399999,
							27.90021084600005
						],
						[
							-82.53681293999996,
							27.900384846000065
						],
						[
							-82.53682569899992,
							27.90043716000008
						],
						[
							-82.5368736989999,
							27.90066316000008
						],
						[
							-82.53687965899991,
							27.900693835000084
						],
						[
							-82.53689291699993,
							27.900823001000052
						],
						[
							-82.53692691599991,
							27.90195500100009
						],
						[
							-82.53692732199994,
							27.90198200000009
						],
						[
							-82.53691508599991,
							27.902129845000047
						],
						[
							-82.5368883729999,
							27.902290005000054
						],
						[
							-82.5368470869999,
							27.902445586000056
						],
						[
							-82.53680637699995,
							27.90254019100007
						],
						[
							-82.53673937699995,
							27.902674191000074
						],
						[
							-82.53671383599993,
							27.902721661000044
						],
						[
							-82.53663240899994,
							27.902839804000056
						],
						[
							-82.53658851299991,
							27.902893719000076
						],
						[
							-82.53653948699991,
							27.90313621300004
						],
						[
							-82.53649637899991,
							27.90328342400005
						],
						[
							-82.53643737899995,
							27.903435424000065
						],
						[
							-82.53637531999993,
							27.903563990000066
						],
						[
							-82.5362753199999,
							27.90373499000009
						],
						[
							-82.53618791999992,
							27.903859073000035
						],
						[
							-82.53614278299995,
							27.90390895200005
						],
						[
							-82.5360237829999,
							27.904030952000085
						],
						[
							-82.53596632399992,
							27.904084912000087
						],
						[
							-82.53590436099995,
							27.90413363400006
						],
						[
							-82.53583836999991,
							27.90417674200006
						],
						[
							-82.53576885699994,
							27.90421390700004
						],
						[
							-82.53559785699991,
							27.904295907000062
						],
						[
							-82.53554541499994,
							27.904319030000067
						],
						[
							-82.53530741399993,
							27.904415030000052
						],
						[
							-82.53516462499994,
							27.90445923100009
						],
						[
							-82.53491062499995,
							27.90451523100006
						],
						[
							-82.53483175699995,
							27.904528970000058
						],
						[
							-82.53466075699993,
							27.90455097000006
						],
						[
							-82.53457995499991,
							27.904557681000085
						],
						[
							-82.53418295499995,
							27.904572681000047
						],
						[
							-82.53411443699991,
							27.904572658000063
						],
						[
							-82.53375175799994,
							27.90455870900007
						],
						[
							-82.53366017399992,
							27.90456075500009
						],
						[
							-82.53352761399992,
							27.904581575000066
						],
						[
							-82.53336982999991,
							27.904606021000063
						],
						[
							-82.53325743199991,
							27.904638327000043
						],
						[
							-82.53312943599991,
							27.904665221000077
						],
						[
							-82.53268543599995,
							27.904725221000035
						],
						[
							-82.53263040199994,
							27.904730941000082
						],
						[
							-82.53233668799993,
							27.904752321000046
						],
						[
							-82.53219399099993,
							27.904761462000067
						],
						[
							-82.53215908599992,
							27.90488358600004
						],
						[
							-82.53213840599994,
							27.904935354000088
						],
						[
							-82.53210442999995,
							27.905013300000064
						],
						[
							-82.5319970619999,
							27.905259704000063
						],
						[
							-82.53213632599994,
							27.90553473300008
						],
						[
							-82.53217908599993,
							27.90563341400008
						],
						[
							-82.53221404999994,
							27.90576177300005
						],
						[
							-82.53243472199995,
							27.90588144500009
						],
						[
							-82.53249057399995,
							27.905914393000046
						],
						[
							-82.5325439049999,
							27.90595128000007
						],
						[
							-82.5325944409999,
							27.905991913000037
						],
						[
							-82.53264191599993,
							27.90603608300006
						],
						[
							-82.53281291699994,
							27.906207084000073
						],
						[
							-82.53290334899992,
							27.906312719000084
						],
						[
							-82.5330223489999,
							27.90647571900007
						],
						[
							-82.53306219099994,
							27.906535115000054
						],
						[
							-82.5330971869999,
							27.906597489000035
						],
						[
							-82.5331271149999,
							27.90666244700009
						],
						[
							-82.53315178699997,
							27.906729578000068
						],
						[
							-82.53317104699994,
							27.906798457000036
						],
						[
							-82.5332080469999,
							27.90695445700004
						],
						[
							-82.53322296599993,
							27.90703261300007
						],
						[
							-82.53323091899995,
							27.907111782000072
						],
						[
							-82.5332318429999,
							27.907191344000072
						],
						[
							-82.53322573199995,
							27.907270677000042
						],
						[
							-82.5332126319999,
							27.907349158000045
						],
						[
							-82.53318263199992,
							27.907490158000087
						],
						[
							-82.53316300799992,
							27.907565994000038
						],
						[
							-82.5331368599999,
							27.907639835000058
						],
						[
							-82.53310438499994,
							27.907711120000045
						],
						[
							-82.53306583099993,
							27.907779308000045
						],
						[
							-82.53302148799992,
							27.907843883000055
						],
						[
							-82.53297248599995,
							27.907908976000044
						],
						[
							-82.53298425799994,
							27.907969500000036
						],
						[
							-82.53301325699994,
							27.90819949900009
						],
						[
							-82.53301985399992,
							27.908340991000046
						],
						[
							-82.53301485499992,
							27.908495991000052
						],
						[
							-82.5330056979999,
							27.908598220000048
						],
						[
							-82.53297994899992,
							27.90877279700004
						],
						[
							-82.53207243399994,
							27.90876238100009
						],
						[
							-82.52700511499995,
							27.908704222000043
						],
						[
							-82.52633731999994,
							27.908696495000072
						],
						[
							-82.52245595499994,
							27.908651581000072
						],
						[
							-82.5185084389999,
							27.908605901000044
						],
						[
							-82.51862806399993,
							27.905541293000056
						],
						[
							-82.51865827699993,
							27.904769136000088
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Bayside West",
				"RegionID": "272884"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.40197729499994,
					27.967109278000066,
					-82.39313499999992,
					27.975001370000086
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.39350799999994,
							27.96731900000009
						],
						[
							-82.39351211299993,
							27.967109278000066
						],
						[
							-82.40175753799991,
							27.967124255000044
						],
						[
							-82.40197729499994,
							27.96820603900005
						],
						[
							-82.39915495499991,
							27.97034573800005
						],
						[
							-82.39366482799994,
							27.97450815600007
						],
						[
							-82.39368194799994,
							27.974763659000075
						],
						[
							-82.39357795799992,
							27.975001370000086
						],
						[
							-82.39357699999994,
							27.974815000000035
						],
						[
							-82.39357499999994,
							27.974439000000075
						],
						[
							-82.39337999999992,
							27.974246000000054
						],
						[
							-82.39313499999992,
							27.97399800000005
						],
						[
							-82.39313997399995,
							27.973909002000084
						],
						[
							-82.39315399999992,
							27.97365800000006
						],
						[
							-82.39354762999994,
							27.970476808000058
						],
						[
							-82.39355799999993,
							27.97039300000006
						],
						[
							-82.39355998299993,
							27.969512436000063
						],
						[
							-82.39355999999992,
							27.969505000000083
						],
						[
							-82.39355922099992,
							27.96946354800008
						],
						[
							-82.39354299999991,
							27.968601000000035
						],
						[
							-82.39354230799995,
							27.968563694000068
						],
						[
							-82.39352599999995,
							27.967685000000074
						],
						[
							-82.39352406299992,
							27.96764561400005
						],
						[
							-82.39350799999994,
							27.96731900000009
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Beasley",
				"RegionID": "272893"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.12656924399994,
					26.11128373200006,
					-80.1153696689999,
					26.120122717000072
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.11551676399995,
							26.12012001800008
						],
						[
							-80.11553987699995,
							26.116896927000084
						],
						[
							-80.11538899999994,
							26.11193200000008
						],
						[
							-80.1153696689999,
							26.111295879000068
						],
						[
							-80.11541457699991,
							26.111298520000048
						],
						[
							-80.11607796899995,
							26.11128373200006
						],
						[
							-80.11665233799994,
							26.111597776000053
						],
						[
							-80.1172242959999,
							26.11192366000006
						],
						[
							-80.11726327999992,
							26.111947205000035
						],
						[
							-80.11773427999992,
							26.11224820500007
						],
						[
							-80.11777433399993,
							26.11227534700004
						],
						[
							-80.11824533399994,
							26.112613347000035
						],
						[
							-80.11832174699992,
							26.112674760000065
						],
						[
							-80.1188763099999,
							26.11317256700005
						],
						[
							-80.1197499999999,
							26.113973000000044
						],
						[
							-80.12131134899995,
							26.114268037000045
						],
						[
							-80.12200938399991,
							26.114456315000044
						],
						[
							-80.12381811199992,
							26.114652479000085
						],
						[
							-80.12453911799992,
							26.115023205000057
						],
						[
							-80.1259782699999,
							26.115315588000044
						],
						[
							-80.12607744099995,
							26.11531851500007
						],
						[
							-80.12656924399994,
							26.115607981000043
						],
						[
							-80.12648309999993,
							26.116817841000056
						],
						[
							-80.12552860199992,
							26.118562404000045
						],
						[
							-80.12482254699995,
							26.119427804000054
						],
						[
							-80.12445801599996,
							26.119448720000037
						],
						[
							-80.1242446999999,
							26.119494787000065
						],
						[
							-80.1238330889999,
							26.11958291800005
						],
						[
							-80.12353464599994,
							26.11964901600004
						],
						[
							-80.12293976399992,
							26.119751168000054
						],
						[
							-80.12225673799992,
							26.11987029100004
						],
						[
							-80.12180207699993,
							26.119948461000035
						],
						[
							-80.12173497799996,
							26.11996147900004
						],
						[
							-80.12155871399996,
							26.11999052200008
						],
						[
							-80.12106298099991,
							26.12003859400005
						],
						[
							-80.12061331399991,
							26.120036592000076
						],
						[
							-80.12049914399995,
							26.12004560400004
						],
						[
							-80.1198702129999,
							26.120064578000044
						],
						[
							-80.11969394999994,
							26.120069640000054
						],
						[
							-80.11950667299993,
							26.12007564900006
						],
						[
							-80.1192462869999,
							26.120080656000084
						],
						[
							-80.11876156699992,
							26.120084662000068
						],
						[
							-80.11846112199993,
							26.120082660000037
						],
						[
							-80.11801045399994,
							26.120084662000068
						],
						[
							-80.11785822799995,
							26.12008866800005
						],
						[
							-80.11737751399994,
							26.12009567800004
						],
						[
							-80.11676059999992,
							26.120105693000085
						],
						[
							-80.11630993199992,
							26.120112704000064
						],
						[
							-80.11625384899992,
							26.120113651000054
						],
						[
							-80.11551674499992,
							26.120122717000072
						],
						[
							-80.11551676399995,
							26.12012001800008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Las Olas Isles",
				"RegionID": "269059"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.1012145439999,
					26.157748422000054,
					-80.09665234999994,
					26.16760713900004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.09801880399995,
							26.16760713900004
						],
						[
							-80.09756299999992,
							26.16753200000005
						],
						[
							-80.09665234999994,
							26.167564119000076
						],
						[
							-80.09667086399992,
							26.167418539000042
						],
						[
							-80.09667928499994,
							26.167365183000072
						],
						[
							-80.09716416499992,
							26.16479664700006
						],
						[
							-80.0974450029999,
							26.163388326000074
						],
						[
							-80.09788895999992,
							26.161156540000036
						],
						[
							-80.09792591399993,
							26.161024414000053
						],
						[
							-80.09799542999991,
							26.160876776000066
						],
						[
							-80.09834219899994,
							26.16029548100005
						],
						[
							-80.09854199199992,
							26.15921974300005
						],
						[
							-80.09881882899992,
							26.157748422000054
						],
						[
							-80.0997309999999,
							26.157764000000043
						],
						[
							-80.10006684099994,
							26.15782363200009
						],
						[
							-80.1002120579999,
							26.157843660000083
						],
						[
							-80.10114256799994,
							26.157859551000058
						],
						[
							-80.1012145439999,
							26.160216179000088
						],
						[
							-80.10106231899994,
							26.16205791100009
						],
						[
							-80.10090909099995,
							26.163795488000062
						],
						[
							-80.10048447399993,
							26.167528079000082
						],
						[
							-80.10036428399991,
							26.167528024000035
						],
						[
							-80.0994599419999,
							26.167558068000062
						],
						[
							-80.09858664599994,
							26.167587111000046
						],
						[
							-80.09801880399995,
							26.16760713900004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Lauderdale Beach",
				"RegionID": "269060"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.17023089899993,
					26.136597151000046,
					-80.15393472099993,
					26.163803000000087
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.15446451699997,
							26.151563347000035
						],
						[
							-80.15444649099993,
							26.15067503000006
						],
						[
							-80.1544204519999,
							26.14996798100009
						],
						[
							-80.15438840399992,
							26.148910412000077
						],
						[
							-80.15432430899995,
							26.147148800000082
						],
						[
							-80.15430127499991,
							26.146382663000054
						],
						[
							-80.15427924099993,
							26.145797796000068
						],
						[
							-80.15427723899995,
							26.145395200000053
						],
						[
							-80.15424519099992,
							26.144683143000066
						],
						[
							-80.1542211549999,
							26.144227468000057
						],
						[
							-80.15419812199991,
							26.143623571000035
						],
						[
							-80.15417909399991,
							26.142629097000054
						],
						[
							-80.15415305499994,
							26.142029207000064
						],
						[
							-80.15415005099993,
							26.141906024000036
						],
						[
							-80.15414504299991,
							26.141720750000047
						],
						[
							-80.15411700199991,
							26.140708249000056
						],
						[
							-80.15410197999995,
							26.140104352000037
						],
						[
							-80.15407293599992,
							26.139664701000072
						],
						[
							-80.15405691299992,
							26.13888053800008
						],
						[
							-80.15403487899994,
							26.13835676000008
						],
						[
							-80.15402887099992,
							26.138015254000038
						],
						[
							-80.15399982699995,
							26.137319223000077
						],
						[
							-80.15397478999995,
							26.13702478500005
						],
						[
							-80.15395271899992,
							26.13684851800008
						],
						[
							-80.15393472099993,
							26.136600069000053
						],
						[
							-80.15431028899991,
							26.136600156000043
						],
						[
							-80.1546357709999,
							26.136600156000043
						],
						[
							-80.15483706999993,
							26.136600156000043
						],
						[
							-80.15575342799991,
							26.136601157000086
						],
						[
							-80.15612497899991,
							26.136597151000046
						],
						[
							-80.15668981699991,
							26.136597151000046
						],
						[
							-80.15763019399992,
							26.13660316100004
						],
						[
							-80.15815599099994,
							26.136615178000056
						],
						[
							-80.1588820689999,
							26.136615178000056
						],
						[
							-80.15959111899991,
							26.136625192000054
						],
						[
							-80.15962016299994,
							26.136625192000054
						],
						[
							-80.16214590899995,
							26.136661247000063
						],
						[
							-80.16345384899995,
							26.13666425000008
						],
						[
							-80.16395459099994,
							26.136672262000047
						],
						[
							-80.16467265599994,
							26.136672262000047
						],
						[
							-80.1652795569999,
							26.136672262000047
						],
						[
							-80.16548686399994,
							26.136672262000047
						],
						[
							-80.16567514299993,
							26.13667827200004
						],
						[
							-80.16601865299992,
							26.136697299000048
						],
						[
							-80.16618489899992,
							26.136701305000088
						],
						[
							-80.16642124999993,
							26.13670330800005
						],
						[
							-80.16742673999994,
							26.136656238000057
						],
						[
							-80.16772718699991,
							26.136663249000037
						],
						[
							-80.16855240899991,
							26.136676268000087
						],
						[
							-80.16910122399992,
							26.136676268000087
						],
						[
							-80.16921939999992,
							26.136676268000087
						],
						[
							-80.16936261199994,
							26.136676268000087
						],
						[
							-80.16943571999991,
							26.136676268000087
						],
						[
							-80.16949881399995,
							26.136676268000087
						],
						[
							-80.16976220399994,
							26.136676268000087
						],
						[
							-80.16983431199992,
							26.13667426500007
						],
						[
							-80.16996751399995,
							26.136674264000078
						],
						[
							-80.17023089899993,
							26.144633070000054
						],
						[
							-80.17018382799996,
							26.14624445800007
						],
						[
							-80.17011272199994,
							26.146797279000054
						],
						[
							-80.16997151399994,
							26.147242939000083
						],
						[
							-80.16990037399995,
							26.147435166000037
						],
						[
							-80.16852609099993,
							26.151162000000056
						],
						[
							-80.1682679999999,
							26.151162000000056
						],
						[
							-80.16778799999992,
							26.15116000000006
						],
						[
							-80.1675449999999,
							26.151159000000064
						],
						[
							-80.16691199999991,
							26.151550000000043
						],
						[
							-80.1661969999999,
							26.15320600000007
						],
						[
							-80.16488399999992,
							26.155583000000036
						],
						[
							-80.16184599999991,
							26.16108200000008
						],
						[
							-80.16132199999993,
							26.16203100000007
						],
						[
							-80.16046263699991,
							26.163578553000036
						],
						[
							-80.16033799999991,
							26.163803000000087
						],
						[
							-80.16026699999992,
							26.163662000000045
						],
						[
							-80.1580669999999,
							26.160862000000066
						],
						[
							-80.15456699999993,
							26.15586200000007
						],
						[
							-80.1544880159999,
							26.15584225400005
						],
						[
							-80.1544865489999,
							26.155706491000046
						],
						[
							-80.15448654999994,
							26.155297122000036
						],
						[
							-80.15447853699993,
							26.15469499200009
						],
						[
							-80.15451659399992,
							26.15379465600006
						],
						[
							-80.15452260199993,
							26.153180745000043
						],
						[
							-80.1545205999999,
							26.152668986000037
						],
						[
							-80.15449556199991,
							26.152079111000035
						],
						[
							-80.15447052499991,
							26.151747621000084
						],
						[
							-80.15446451699997,
							26.151563347000035
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Lauderdale Manors",
				"RegionID": "269062"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.64323808499995,
					30.354541874000066,
					-81.61847167799993,
					30.364238009000076
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.61875130599992,
							30.35714009700007
						],
						[
							-81.61878536099994,
							30.356266951000066
						],
						[
							-81.6187983399999,
							30.356145835000067
						],
						[
							-81.61882595799995,
							30.356032660000043
						],
						[
							-81.61917595799991,
							30.354917660000066
						],
						[
							-81.6191889129999,
							30.354879414000035
						],
						[
							-81.61919320999993,
							30.35487020100004
						],
						[
							-81.62003825599993,
							30.354761862000093
						],
						[
							-81.62186101099991,
							30.354541874000066
						],
						[
							-81.62252099999995,
							30.35456600000009
						],
						[
							-81.62410989099995,
							30.357023178000077
						],
						[
							-81.62425990599992,
							30.35687000900009
						],
						[
							-81.6243749059999,
							30.356753005000087
						],
						[
							-81.62445290399995,
							30.356622008000045
						],
						[
							-81.62452690499993,
							30.356399008000043
						],
						[
							-81.62474378399992,
							30.355477951000072
						],
						[
							-81.62485090599995,
							30.355301008000083
						],
						[
							-81.62498290699995,
							30.355138009000086
						],
						[
							-81.62509790699994,
							30.355031008000083
						],
						[
							-81.6252079059999,
							30.35495700900009
						],
						[
							-81.6253889059999,
							30.354872008000086
						],
						[
							-81.6256809059999,
							30.354769010000044
						],
						[
							-81.62596390599992,
							30.354723009000054
						],
						[
							-81.62614890599991,
							30.354709009000086
						],
						[
							-81.62649990599994,
							30.35471200800004
						],
						[
							-81.6284219069999,
							30.35471800800008
						],
						[
							-81.62954990599991,
							30.354782009000076
						],
						[
							-81.63273190599995,
							30.354840008000053
						],
						[
							-81.63390090599995,
							30.354713008000093
						],
						[
							-81.63399390699993,
							30.354693009000076
						],
						[
							-81.63472790499993,
							30.354680008000056
						],
						[
							-81.63546190599993,
							30.354666009000084
						],
						[
							-81.6368879609999,
							30.35463801000009
						],
						[
							-81.63688990599991,
							30.354771008000053
						],
						[
							-81.63689390499991,
							30.355024009000093
						],
						[
							-81.63690390599993,
							30.35513100800006
						],
						[
							-81.63690890599992,
							30.35521300900007
						],
						[
							-81.63692990499993,
							30.35531200900005
						],
						[
							-81.63694790499994,
							30.355375009000056
						],
						[
							-81.63696290699994,
							30.35543800800008
						],
						[
							-81.63699290599993,
							30.355516008000055
						],
						[
							-81.63712290599995,
							30.35576100800006
						],
						[
							-81.63719190599994,
							30.355858009000087
						],
						[
							-81.63723690599994,
							30.355916008000065
						],
						[
							-81.63731490499993,
							30.35599000900004
						],
						[
							-81.63734290499991,
							30.35601900800009
						],
						[
							-81.63744185199994,
							30.35610108100008
						],
						[
							-81.6375019059999,
							30.356142008000063
						],
						[
							-81.63755890499993,
							30.356178008000082
						],
						[
							-81.63759990599993,
							30.356200008000087
						],
						[
							-81.63769690599992,
							30.356248009000073
						],
						[
							-81.63777190499991,
							30.356279008000058
						],
						[
							-81.63782890599992,
							30.356302008000057
						],
						[
							-81.63799190599991,
							30.356344008000065
						],
						[
							-81.6381129049999,
							30.35636400900006
						],
						[
							-81.63832190599993,
							30.356380008000087
						],
						[
							-81.63848390499993,
							30.356390008000062
						],
						[
							-81.6387859059999,
							30.356406008000082
						],
						[
							-81.63901890499994,
							30.356396008000047
						],
						[
							-81.64049190599991,
							30.356347009000043
						],
						[
							-81.6411689059999,
							30.356324009000048
						],
						[
							-81.64130490499991,
							30.356321008000062
						],
						[
							-81.64177405099991,
							30.356311087000055
						],
						[
							-81.64175475999991,
							30.356283930000078
						],
						[
							-81.6418259049999,
							30.35628200800005
						],
						[
							-81.6424089059999,
							30.35626900800008
						],
						[
							-81.64322394899995,
							30.356249954000077
						],
						[
							-81.64323808499995,
							30.356284996000056
						],
						[
							-81.64322090999991,
							30.356358010000065
						],
						[
							-81.64320398899991,
							30.356600035000042
						],
						[
							-81.64307090999995,
							30.356831009000075
						],
						[
							-81.64304290699994,
							30.356929010000048
						],
						[
							-81.64302290699993,
							30.35707001000009
						],
						[
							-81.64302690699992,
							30.35732001000008
						],
						[
							-81.64302790799991,
							30.35796501100009
						],
						[
							-81.64303590899993,
							30.35872301000006
						],
						[
							-81.64307390899995,
							30.359541010000044
						],
						[
							-81.64307390899995,
							30.359684011000066
						],
						[
							-81.64312690899993,
							30.360426011000076
						],
						[
							-81.64318800599995,
							30.361044073000073
						],
						[
							-81.63984490599995,
							30.364047010000036
						],
						[
							-81.63972990799994,
							30.364117011000076
						],
						[
							-81.63963990699995,
							30.364167010000074
						],
						[
							-81.63953290699993,
							30.36421001000008
						],
						[
							-81.63941790599995,
							30.364238009000076
						],
						[
							-81.63925390799994,
							30.364238009000076
						],
						[
							-81.63910590799992,
							30.36421001200006
						],
						[
							-81.63889190799996,
							30.364202010000046
						],
						[
							-81.6370309049999,
							30.364048009000044
						],
						[
							-81.63527390699994,
							30.363558010000077
						],
						[
							-81.6343179079999,
							30.363341010000056
						],
						[
							-81.63288876799993,
							30.36316813300004
						],
						[
							-81.6328740379999,
							30.36260787700007
						],
						[
							-81.62188616399993,
							30.362489890000063
						],
						[
							-81.62094566699994,
							30.362479791000055
						],
						[
							-81.62088832099994,
							30.362285098000086
						],
						[
							-81.62086947099993,
							30.362209007000047
						],
						[
							-81.62045012199991,
							30.360132308000065
						],
						[
							-81.61923683599991,
							30.359949258000086
						],
						[
							-81.61921483399993,
							30.359945659000065
						],
						[
							-81.61906341299994,
							30.35990508600008
						],
						[
							-81.61892133899994,
							30.359838836000055
						],
						[
							-81.6187929269999,
							30.359748920000076
						],
						[
							-81.61868207899994,
							30.359638073000042
						],
						[
							-81.61859216399995,
							30.35950966100006
						],
						[
							-81.61852591299993,
							30.359367586000072
						],
						[
							-81.61848533999995,
							30.359216165000078
						],
						[
							-81.61847167799993,
							30.359060000000056
						],
						[
							-81.61848175199992,
							30.358925765000038
						],
						[
							-81.61875130599992,
							30.35714009700007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Longbranch",
				"RegionID": "269075"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.33122385798583,
					28.52425217626425,
					-81.3248066997804,
					28.5392985406815
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.32502656423148,
							28.538781711103162
						],
						[
							-81.32499548006477,
							28.537536878543378
						],
						[
							-81.32497544946521,
							28.53654640932713
						],
						[
							-81.32497044293952,
							28.535833352178514
						],
						[
							-81.32497044293952,
							28.535686134061706
						],
						[
							-81.32497144388488,
							28.535361652378228
						],
						[
							-81.3249494104952,
							28.534405234191894
						],
						[
							-81.32494840954982,
							28.533949558511594
						],
						[
							-81.32493539096406,
							28.532827894398977
						],
						[
							-81.32491541522319,
							28.531558009425538
						],
						[
							-81.3248066997804,
							28.52436829402668
						],
						[
							-81.32758532066508,
							28.524333296010546
						],
						[
							-81.32771253336348,
							28.52433042357599
						],
						[
							-81.3278897483666,
							28.524254047753345
						],
						[
							-81.32809608971239,
							28.524254178155083
						],
						[
							-81.32881514443952,
							28.52425217626425
						],
						[
							-81.32935594634588,
							28.524253178108992
						],
						[
							-81.33023124478584,
							28.52425417905436
						],
						[
							-81.33062182304108,
							28.52425417905436
						],
						[
							-81.33094530108117,
							28.524255126939778
						],
						[
							-81.330943300989,
							28.52432628669467
						],
						[
							-81.33095231399427,
							28.525006294657935
						],
						[
							-81.3309591605329,
							28.525507096519075
						],
						[
							-81.33103560020749,
							28.52560011609458
						],
						[
							-81.3310364383756,
							28.525679293305323
						],
						[
							-81.33105146065076,
							28.526531557410216
						],
						[
							-81.33106147550095,
							28.52733074262946
						],
						[
							-81.33106848571612,
							28.52794365127685
						],
						[
							-81.3310724921957,
							28.528161975189313
						],
						[
							-81.33108450983602,
							28.52900322259918
						],
						[
							-81.33109552563158,
							28.529583082061315
						],
						[
							-81.331100533956,
							28.529848476488816
						],
						[
							-81.3311135525417,
							28.530682713683518
						],
						[
							-81.33112557108126,
							28.531478894267913
						],
						[
							-81.33112751901277,
							28.53156600709624
						],
						[
							-81.33113758872156,
							28.532333162062194
						],
						[
							-81.33114560078147,
							28.53313234638216
						],
						[
							-81.33115261099672,
							28.533988616067273
						],
						[
							-81.33116362679229,
							28.534804826351966
						],
						[
							-81.33116462863703,
							28.53567611831223
						],
						[
							-81.33117464348705,
							28.536514362885896
						],
						[
							-81.33117364164231,
							28.537064177797717
						],
						[
							-81.3312056889829,
							28.537504833900883
						],
						[
							-81.33116563048176,
							28.53782831014223
						],
						[
							-81.33116362679229,
							28.53797552915841
						],
						[
							-81.33116863691527,
							28.53824592831294
						],
						[
							-81.33120160785947,
							28.53838217919774
						],
						[
							-81.33122385798583,
							28.538449332472943
						],
						[
							-81.33113258129643,
							28.538449230849523
						],
						[
							-81.33026329212636,
							28.538443222479103
						],
						[
							-81.32997786889793,
							28.538452236383833
						],
						[
							-81.32971548000474,
							28.538462250334568
						],
						[
							-81.3292507904197,
							28.538493296729712
						],
						[
							-81.32849366739099,
							28.53856740626085
						],
						[
							-81.32786673831318,
							28.538650530595994
						],
						[
							-81.32747615825919,
							28.53875067819785
						],
						[
							-81.32694036377788,
							28.538870856399285
						],
						[
							-81.3265147326479,
							28.5389810206499
						],
						[
							-81.32559236459227,
							28.539190330657625
						],
						[
							-81.32502555339349,
							28.5392985406815
						],
						[
							-81.32502656423148,
							28.538781711103162
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Dover Shores East",
				"RegionID": "268957"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.24868999999991,
					26.02406700000006,
					-80.21312657599992,
					26.045567000000062
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.23106999999993,
							26.042567000000076
						],
						[
							-80.23082976599994,
							26.038721422000037
						],
						[
							-80.22878342999991,
							26.038816600000075
						],
						[
							-80.2267846819999,
							26.038911779000045
						],
						[
							-80.2248335239999,
							26.038959368000064
						],
						[
							-80.22488111399991,
							26.03972079600004
						],
						[
							-80.22478593499994,
							26.040434634000064
						],
						[
							-80.2248335239999,
							26.041576775000067
						],
						[
							-80.22488111399991,
							26.043670701000053
						],
						[
							-80.22496999999993,
							26.04516700000005
						],
						[
							-80.22496999999993,
							26.045367000000056
						],
						[
							-80.22446999999994,
							26.045367000000056
						],
						[
							-80.22396999999995,
							26.04516700000005
						],
						[
							-80.22296999999992,
							26.045067000000078
						],
						[
							-80.22296999999992,
							26.044767000000036
						],
						[
							-80.22136999999992,
							26.044867000000067
						],
						[
							-80.22056999999995,
							26.044867000000067
						],
						[
							-80.22056999999995,
							26.045367000000056
						],
						[
							-80.2171689999999,
							26.045567000000062
						],
						[
							-80.21706899999992,
							26.044867000000067
						],
						[
							-80.21704099999994,
							26.044670000000057
						],
						[
							-80.21696899999995,
							26.044167000000073
						],
						[
							-80.21696899999995,
							26.044027000000085
						],
						[
							-80.21696899999995,
							26.043567000000056
						],
						[
							-80.21696899999995,
							26.04340700000006
						],
						[
							-80.21696899999995,
							26.042867000000058
						],
						[
							-80.21686899999992,
							26.042467000000048
						],
						[
							-80.21686899999992,
							26.042267000000038
						],
						[
							-80.21686899999992,
							26.04176700000005
						],
						[
							-80.21686899999992,
							26.041615000000036
						],
						[
							-80.21686899999992,
							26.04146700000007
						],
						[
							-80.21686899999992,
							26.04125600000009
						],
						[
							-80.21686899999992,
							26.040767000000073
						],
						[
							-80.21686899999992,
							26.039967000000047
						],
						[
							-80.21676899999994,
							26.039267000000052
						],
						[
							-80.21816999999994,
							26.039267000000052
						],
						[
							-80.22046999999992,
							26.039167000000077
						],
						[
							-80.22126999999995,
							26.039167000000077
						],
						[
							-80.22116999999992,
							26.03836700000005
						],
						[
							-80.22116999999992,
							26.037667000000056
						],
						[
							-80.22116999999992,
							26.036867000000086
						],
						[
							-80.22116999999992,
							26.03616700000009
						],
						[
							-80.22106999999994,
							26.03546700000004
						],
						[
							-80.22116999999992,
							26.034767000000045
						],
						[
							-80.22106999999994,
							26.03406700000005
						],
						[
							-80.22106999999994,
							26.03326700000008
						],
						[
							-80.22106999999994,
							26.032567000000085
						],
						[
							-80.22106999999994,
							26.03186700000009
						],
						[
							-80.22077399999995,
							26.031873000000076
						],
						[
							-80.2164689999999,
							26.031967000000066
						],
						[
							-80.21650999999991,
							26.032541000000037
						],
						[
							-80.21656899999994,
							26.033367000000055
						],
						[
							-80.21656899999994,
							26.03416700000008
						],
						[
							-80.21666899999991,
							26.034867000000077
						],
						[
							-80.21666899999991,
							26.03557100000006
						],
						[
							-80.21436899999992,
							26.035667000000046
						],
						[
							-80.21394099999992,
							26.03568800000005
						],
						[
							-80.21384099999995,
							26.035685000000058
						],
						[
							-80.21384099999995,
							26.035677000000078
						],
						[
							-80.21364815499993,
							26.035677000000078
						],
						[
							-80.21350728999994,
							26.03224928800006
						],
						[
							-80.21312657599992,
							26.024825370000087
						],
						[
							-80.22069326199994,
							26.02463501300008
						],
						[
							-80.22397691799995,
							26.02449224500009
						],
						[
							-80.2316863719999,
							26.024301888000082
						],
						[
							-80.23236999999995,
							26.02406700000006
						],
						[
							-80.23236999999995,
							26.024767000000054
						],
						[
							-80.23236999999995,
							26.025667000000055
						],
						[
							-80.23246999999994,
							26.02636700000005
						],
						[
							-80.23246999999994,
							26.027067000000045
						],
						[
							-80.23246999999994,
							26.02786700000007
						],
						[
							-80.23246999999994,
							26.02856700000007
						],
						[
							-80.23246999999994,
							26.02926700000006
						],
						[
							-80.2325699999999,
							26.031467000000077
						],
						[
							-80.23496999999992,
							26.031367000000046
						],
						[
							-80.23666999999995,
							26.031367000000046
						],
						[
							-80.23856999999992,
							26.03126700000007
						],
						[
							-80.24066999999991,
							26.03116700000004
						],
						[
							-80.24256999999994,
							26.03116700000004
						],
						[
							-80.24466999999993,
							26.031067000000064
						],
						[
							-80.24666999999995,
							26.031067000000064
						],
						[
							-80.24865099999994,
							26.030963000000042
						],
						[
							-80.24864999999994,
							26.03099700000007
						],
						[
							-80.24868999999991,
							26.032533000000058
						],
						[
							-80.24867299999994,
							26.033056000000045
						],
						[
							-80.2465699999999,
							26.033967000000075
						],
						[
							-80.2447699999999,
							26.034967000000055
						],
						[
							-80.24276999999995,
							26.035767000000078
						],
						[
							-80.24166999999994,
							26.036267000000066
						],
						[
							-80.23926999999992,
							26.037267000000043
						],
						[
							-80.23876999999993,
							26.03746700000005
						],
						[
							-80.23676999999992,
							26.038567000000057
						],
						[
							-80.23536899999993,
							26.040090000000077
						],
						[
							-80.23496999999992,
							26.040467000000035
						],
						[
							-80.23446999999993,
							26.041167000000087
						],
						[
							-80.2341869999999,
							26.041356000000064
						],
						[
							-80.23416999999995,
							26.041367000000037
						],
						[
							-80.23286999999993,
							26.042567000000076
						],
						[
							-80.23106999999993,
							26.042567000000076
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Hollywood",
				"Name": "Driftwood",
				"RegionID": "268964"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.3519415314809,
					28.538379072939467,
					-81.34355700831021,
					28.549502606356143
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.34547384936383,
							28.548243757862608
						],
						[
							-81.34545295181783,
							28.546011311434
						],
						[
							-81.34401168214586,
							28.546026468607472
						],
						[
							-81.34387447618114,
							28.546011445432946
						],
						[
							-81.34380136849475,
							28.545989412043255
						],
						[
							-81.34375221155258,
							28.545962476449148
						],
						[
							-81.34370310767046,
							28.545900347686036
						],
						[
							-81.34367518462082,
							28.545813154818003
						],
						[
							-81.34366116149248,
							28.54567094142822
						],
						[
							-81.34365515312189,
							28.54512112651649
						],
						[
							-81.34364313458238,
							28.544205767776756
						],
						[
							-81.34362510857156,
							28.543297421050916
						],
						[
							-81.34360708166146,
							28.542386070589416
						],
						[
							-81.34359005659618,
							28.540563366069215
						],
						[
							-81.34356001204578,
							28.539279462464005
						],
						[
							-81.34355800925567,
							28.538739662402378
						],
						[
							-81.34355700831021,
							28.538462249435295
						],
						[
							-81.34764106436836,
							28.53842219093415
						],
						[
							-81.34770215441445,
							28.53842118998869
						],
						[
							-81.3477572369894,
							28.53842118998869
						],
						[
							-81.34956692112529,
							28.538409172348388
						],
						[
							-81.35182627436967,
							28.538379072939467
						],
						[
							-81.35183628562248,
							28.538691590941873
						],
						[
							-81.35185531347794,
							28.539601941357283
						],
						[
							-81.35186032180236,
							28.54047924258735
						],
						[
							-81.35185731716743,
							28.541318486307816
						],
						[
							-81.35185431253258,
							28.542322975954477
						],
						[
							-81.35185731716743,
							28.543216301304525
						],
						[
							-81.35187934965784,
							28.544082585839746
						],
						[
							-81.35191039605299,
							28.545037001235883
						],
						[
							-81.35192235973389,
							28.545944346116976
						],
						[
							-81.3519415314809,
							28.547659878430963
						],
						[
							-81.34783922548085,
							28.54779997032007
						],
						[
							-81.34785150572318,
							28.54950075015544
						],
						[
							-81.34538462852467,
							28.549502606356143
						],
						[
							-81.34547384936383,
							28.548243757862608
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "East Central Park",
				"RegionID": "268971"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.95574064499993,
					28.036007011000038,
					-81.94484415999995,
					28.04347970200007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.94732225699994,
							28.042907312000068
						],
						[
							-81.94727482299993,
							28.041786211000044
						],
						[
							-81.94486024299994,
							28.041738334000062
						],
						[
							-81.94484415999995,
							28.036843003000058
						],
						[
							-81.94727469199995,
							28.036866601000042
						],
						[
							-81.94903940599994,
							28.036890449000055
						],
						[
							-81.94992391099993,
							28.03709801100007
						],
						[
							-81.95047995899995,
							28.03727819500006
						],
						[
							-81.95076991099995,
							28.036968011000056
						],
						[
							-81.95119891099995,
							28.03659201000005
						],
						[
							-81.95125491099992,
							28.036554011000078
						],
						[
							-81.95151591099994,
							28.03643101100005
						],
						[
							-81.95183591099993,
							28.036297011000045
						],
						[
							-81.9521909099999,
							28.036184010000056
						],
						[
							-81.95235991099992,
							28.03613001000008
						],
						[
							-81.95296391099993,
							28.03601701000008
						],
						[
							-81.95308191099991,
							28.036007011000038
						],
						[
							-81.95375191099993,
							28.036035010000035
						],
						[
							-81.95413591099992,
							28.03608801100006
						],
						[
							-81.95426091099995,
							28.036113009000076
						],
						[
							-81.95475390999991,
							28.036241011000072
						],
						[
							-81.95489491099994,
							28.036294011000052
						],
						[
							-81.95504590999991,
							28.03637301100008
						],
						[
							-81.95512490999994,
							28.03641401200008
						],
						[
							-81.95525590699994,
							28.036530009000046
						],
						[
							-81.95536291099995,
							28.03668401300007
						],
						[
							-81.9554208109999,
							28.036830015000078
						],
						[
							-81.95559747499993,
							28.037446095000067
						],
						[
							-81.95574064499993,
							28.037923040000067
						],
						[
							-81.95559755099993,
							28.03856696600008
						],
						[
							-81.9552397619999,
							28.038996185000087
						],
						[
							-81.9547628979999,
							28.039497087000086
						],
						[
							-81.9540949169999,
							28.039830750000082
						],
						[
							-81.95411104499993,
							28.040467142000068
						],
						[
							-81.95311077999992,
							28.040475880000088
						],
						[
							-81.95311738399994,
							28.043288869000037
						],
						[
							-81.95285501099994,
							28.04297872300009
						],
						[
							-81.95240193499991,
							28.04264480900008
						],
						[
							-81.95199649999995,
							28.042477923000035
						],
						[
							-81.9517818569999,
							28.042430052000046
						],
						[
							-81.95144798199993,
							28.04257326800007
						],
						[
							-81.95099490799993,
							28.042931026000076
						],
						[
							-81.95061339799992,
							28.04347970200007
						],
						[
							-81.9490489339999,
							28.042916878000085
						],
						[
							-81.94732225699994,
							28.042907312000068
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Polk",
				"City": "Lakeland",
				"Name": "East Lake Morton",
				"RegionID": "268973"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.41057600039194,
					28.530968057771517,
					-81.39710128395845,
					28.544080583049634
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.39724062311511,
							28.54021485090395
						],
						[
							-81.39723261105512,
							28.539202348297927
						],
						[
							-81.3972205934148,
							28.538259950542102
						],
						[
							-81.39721458504438,
							28.537438731933072
						],
						[
							-81.3972025665047,
							28.536507351771363
						],
						[
							-81.39720039374275,
							28.53642217878066
						],
						[
							-81.39725271899638,
							28.536343129273543
						],
						[
							-81.39725965186986,
							28.535624042170788
						],
						[
							-81.39725965186986,
							28.53556996144059
						],
						[
							-81.39725464354552,
							28.535263505767922
						],
						[
							-81.39725264075533,
							28.535177379495764
						],
						[
							-81.39725163980995,
							28.535087245844736
						],
						[
							-81.39723761848016,
							28.53479080592146
						],
						[
							-81.39723461384531,
							28.53473672609062
						],
						[
							-81.39722276078092,
							28.534506322484653
						],
						[
							-81.39715332952292,
							28.53441831123357
						],
						[
							-81.39712244770378,
							28.532970105090826
						],
						[
							-81.39711443564387,
							28.532151892915387
						],
						[
							-81.39711343469841,
							28.53206676668932
						],
						[
							-81.39710241710421,
							28.5311353721385
						],
						[
							-81.39710128395845,
							28.531078171660106
						],
						[
							-81.40136172494547,
							28.53096813781123
						],
						[
							-81.40296711639122,
							28.53096813601258
						],
						[
							-81.40408078912817,
							28.530968057771517
						],
						[
							-81.40468872002819,
							28.531339614466617
						],
						[
							-81.40537685426534,
							28.531920471276827
						],
						[
							-81.40537763577619,
							28.531983673830418
						],
						[
							-81.40537769063481,
							28.53203872402984
						],
						[
							-81.40537769063481,
							28.53298112268495
						],
						[
							-81.4053937147547,
							28.53392752602118
						],
						[
							-81.4054037296049,
							28.53470167411517
						],
						[
							-81.40539671849027,
							28.534886947943093
						],
						[
							-81.40532361080388,
							28.5359685526552
						],
						[
							-81.40532361080388,
							28.536221927643652
						],
						[
							-81.40532361080388,
							28.536315066828905
						],
						[
							-81.40532544721943,
							28.53645236902119
						],
						[
							-81.40570918253346,
							28.536653568942803
						],
						[
							-81.40611172626832,
							28.536913027844896
						],
						[
							-81.40657346337927,
							28.5372764924403
						],
						[
							-81.40789842822973,
							28.538365106468284
						],
						[
							-81.40889490671586,
							28.53911121370144
						],
						[
							-81.40943771141234,
							28.53950980491605
						],
						[
							-81.41027089100432,
							28.540084510363553
						],
						[
							-81.41032903397227,
							28.540127720089124
						],
						[
							-81.41057600039194,
							28.5403229997739
						],
						[
							-81.41045700030243,
							28.54031800044273
						],
						[
							-81.41034200039726,
							28.54031700039664
						],
						[
							-81.41033800021282,
							28.54062200006696
						],
						[
							-81.41022200026157,
							28.54062200006696
						],
						[
							-81.41022600044593,
							28.54032699995826
						],
						[
							-81.40957997516422,
							28.54032699995826
						],
						[
							-81.40957593091306,
							28.540096672794697
						],
						[
							-81.40549874117862,
							28.5400644968511
						],
						[
							-81.40549486510066,
							28.54188833091976
						],
						[
							-81.40549586604604,
							28.54194441533954
						],
						[
							-81.40549887068097,
							28.542339000074467
						],
						[
							-81.40555394875935,
							28.544043585840694
						],
						[
							-81.40381136753673,
							28.544080583049634
						],
						[
							-81.4032034699117,
							28.544080582150265
						],
						[
							-81.40229211495362,
							28.543845234971094
						],
						[
							-81.40158306248613,
							28.543710034494595
						],
						[
							-81.39999671058703,
							28.543710033595225
						],
						[
							-81.39728463503587,
							28.543672980628312
						],
						[
							-81.39727968067078,
							28.543414595516687
						],
						[
							-81.39726866487521,
							28.542594379651774
						],
						[
							-81.39726170951874,
							28.54199949521646
						],
						[
							-81.39724963701975,
							28.541084140074112
						],
						[
							-81.39724062311511,
							28.54021485090395
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Lorna Doone",
				"RegionID": "269076"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.69740288499992,
					30.318478974000072,
					-81.67040593599995,
					30.336538008000044
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.67584350599992,
							30.329626883000063
						],
						[
							-81.67661322599992,
							30.32890892200004
						],
						[
							-81.67661482699992,
							30.328822864000074
						],
						[
							-81.6766649079999,
							30.328853009000056
						],
						[
							-81.67673690599992,
							30.328895509000066
						],
						[
							-81.67677191899992,
							30.32891920100008
						],
						[
							-81.6773879079999,
							30.32843400800004
						],
						[
							-81.6776089039999,
							30.328261009000077
						],
						[
							-81.67815590799995,
							30.32781000800009
						],
						[
							-81.6783829069999,
							30.32762300800005
						],
						[
							-81.67847690799994,
							30.327522008000077
						],
						[
							-81.67856890699994,
							30.327429009000067
						],
						[
							-81.6786059069999,
							30.327397009000038
						],
						[
							-81.67870294399995,
							30.327304042000037
						],
						[
							-81.6787349089999,
							30.327249008000084
						],
						[
							-81.67892890799993,
							30.327007009000052
						],
						[
							-81.67903590699991,
							30.326873008000067
						],
						[
							-81.67910590299994,
							30.326785009000048
						],
						[
							-81.67930890799994,
							30.326479009000085
						],
						[
							-81.6794168319999,
							30.326338956000086
						],
						[
							-81.6794869069999,
							30.32622800800004
						],
						[
							-81.6795509289999,
							30.326120075000066
						],
						[
							-81.67962190599991,
							30.325990009000066
						],
						[
							-81.67968090499994,
							30.32588800900004
						],
						[
							-81.6797159059999,
							30.325806008000082
						],
						[
							-81.67983590599994,
							30.32550500800005
						],
						[
							-81.6799579069999,
							30.32521200800005
						],
						[
							-81.6800729069999,
							30.324966008000047
						],
						[
							-81.68050790699994,
							30.32412800800006
						],
						[
							-81.68056690599991,
							30.324021009000035
						],
						[
							-81.6806819059999,
							30.32379400800005
						],
						[
							-81.68077890399992,
							30.323612009000044
						],
						[
							-81.68085990899993,
							30.32345800800005
						],
						[
							-81.68101090699992,
							30.323268008000074
						],
						[
							-81.68122490699994,
							30.323042009000062
						],
						[
							-81.68143790599993,
							30.322849009000038
						],
						[
							-81.68181290699994,
							30.322560009000085
						],
						[
							-81.68229090599993,
							30.322269008000035
						],
						[
							-81.68287390599994,
							30.32194600900004
						],
						[
							-81.68305790699992,
							30.321833009000045
						],
						[
							-81.68315687599994,
							30.32177282500004
						],
						[
							-81.68319390599993,
							30.32178200800007
						],
						[
							-81.68326390699991,
							30.321799008000085
						],
						[
							-81.68332390699993,
							30.321805008000073
						],
						[
							-81.6833849059999,
							30.321811009000044
						],
						[
							-81.68355990599991,
							30.321817008000043
						],
						[
							-81.6837429069999,
							30.321809008000063
						],
						[
							-81.68390685199995,
							30.321784069000042
						],
						[
							-81.68403190299995,
							30.321759007000082
						],
						[
							-81.68409490699993,
							30.32173300900007
						],
						[
							-81.68418890599992,
							30.32169400900006
						],
						[
							-81.68437690399992,
							30.32159900900007
						],
						[
							-81.68449690599994,
							30.321533008000078
						],
						[
							-81.68468390699991,
							30.321424009000058
						],
						[
							-81.68476390399991,
							30.321379008000065
						],
						[
							-81.68481590699992,
							30.32134900800008
						],
						[
							-81.68501090699993,
							30.321250008000053
						],
						[
							-81.68519490499995,
							30.321147009000068
						],
						[
							-81.68562090699993,
							30.320948008000073
						],
						[
							-81.68589890499993,
							30.32084800800004
						],
						[
							-81.68622690599994,
							30.32076500800008
						],
						[
							-81.6864039049999,
							30.320728009000046
						],
						[
							-81.68666090699992,
							30.320688009000037
						],
						[
							-81.68686990599991,
							30.32067100800009
						],
						[
							-81.68735490699993,
							30.32062900900007
						],
						[
							-81.68794690599992,
							30.32061100800007
						],
						[
							-81.68875190499995,
							30.32059900800005
						],
						[
							-81.68911190699993,
							30.32059500800006
						],
						[
							-81.68933490699993,
							30.32058400900007
						],
						[
							-81.69005190399992,
							30.320581009000076
						],
						[
							-81.6901789069999,
							30.320581009000076
						],
						[
							-81.69037190499995,
							30.320584008000083
						],
						[
							-81.6908139059999,
							30.320577008000043
						],
						[
							-81.69102490599994,
							30.320581009000076
						],
						[
							-81.69136290499995,
							30.32059800800005
						],
						[
							-81.69186490699991,
							30.32065300800008
						],
						[
							-81.6921199059999,
							30.320709009000044
						],
						[
							-81.69272390499992,
							30.320882008000066
						],
						[
							-81.69301892199991,
							30.320980191000046
						],
						[
							-81.69313590599995,
							30.32091700800004
						],
						[
							-81.6932339039999,
							30.320850008000036
						],
						[
							-81.69422790699991,
							30.320185008000067
						],
						[
							-81.69577190699994,
							30.319304008000074
						],
						[
							-81.6969158039999,
							30.318478974000072
						],
						[
							-81.69692790599993,
							30.318933008000045
						],
						[
							-81.6969559069999,
							30.31922100900005
						],
						[
							-81.69695990599992,
							30.319292008000044
						],
						[
							-81.69697590499993,
							30.320141008000064
						],
						[
							-81.69697590499993,
							30.32019600900009
						],
						[
							-81.69698990699993,
							30.320655008000074
						],
						[
							-81.69699890699991,
							30.321066008000063
						],
						[
							-81.6970059059999,
							30.321589008000043
						],
						[
							-81.6970059059999,
							30.32173300800008
						],
						[
							-81.69700585299995,
							30.321875007000077
						],
						[
							-81.69701290699993,
							30.32233200800005
						],
						[
							-81.69702098599993,
							30.322527027000035
						],
						[
							-81.69667082399991,
							30.32325398900008
						],
						[
							-81.69667090699994,
							30.323448008000074
						],
						[
							-81.69668590599991,
							30.32375300800004
						],
						[
							-81.6966929059999,
							30.324203008000044
						],
						[
							-81.69671590699994,
							30.32500100900006
						],
						[
							-81.69671590699994,
							30.325312009000076
						],
						[
							-81.69672390699992,
							30.325504008000053
						],
						[
							-81.69673190599991,
							30.32600400900009
						],
						[
							-81.69674690699992,
							30.32654200800005
						],
						[
							-81.69676190299992,
							30.326654007000062
						],
						[
							-81.69675690699995,
							30.326753008000082
						],
						[
							-81.69675390499992,
							30.327560008000034
						],
						[
							-81.69674990699991,
							30.328592009000094
						],
						[
							-81.69674990699991,
							30.329525008000076
						],
						[
							-81.69675290599992,
							30.33006100800009
						],
						[
							-81.69674690699992,
							30.33062400800009
						],
						[
							-81.69675390499992,
							30.331133008000055
						],
						[
							-81.69675390599991,
							30.331547008000086
						],
						[
							-81.69677690799995,
							30.331701008000042
						],
						[
							-81.69682490799995,
							30.331857008000043
						],
						[
							-81.69715090699992,
							30.33253500900008
						],
						[
							-81.69728890599993,
							30.332790009000064
						],
						[
							-81.69740288499992,
							30.333038067000075
						],
						[
							-81.69662490699994,
							30.33316600900008
						],
						[
							-81.69430490699995,
							30.333551008000086
						],
						[
							-81.69391590599992,
							30.333624008000076
						],
						[
							-81.69316090599996,
							30.33374200800006
						],
						[
							-81.69262690699992,
							30.33380100800008
						],
						[
							-81.69219190599995,
							30.333866008000083
						],
						[
							-81.6916869069999,
							30.333943008000062
						],
						[
							-81.69098790699992,
							30.334058008000053
						],
						[
							-81.6903379069999,
							30.334208008000076
						],
						[
							-81.6902009069999,
							30.33423000800008
						],
						[
							-81.6897349059999,
							30.33432400800007
						],
						[
							-81.68924690699993,
							30.33439600900005
						],
						[
							-81.68842290499992,
							30.334547008000072
						],
						[
							-81.68617090599992,
							30.334933008000068
						],
						[
							-81.68587901399991,
							30.334982934000042
						],
						[
							-81.6856079069999,
							30.33502300900005
						],
						[
							-81.68315890799994,
							30.335440008000035
						],
						[
							-81.68192290699994,
							30.33565500800006
						],
						[
							-81.68089290699993,
							30.33582300900008
						],
						[
							-81.68004590699991,
							30.33598100800009
						],
						[
							-81.67923690299995,
							30.336123008000072
						],
						[
							-81.67898090699993,
							30.33616700800007
						],
						[
							-81.67835190699992,
							30.33627500900008
						],
						[
							-81.67784490699995,
							30.336359008000045
						],
						[
							-81.6770059079999,
							30.33651200900005
						],
						[
							-81.6768459079999,
							30.33653800700006
						],
						[
							-81.67672790799992,
							30.336538008000044
						],
						[
							-81.67664090799991,
							30.336538008000044
						],
						[
							-81.6765609069999,
							30.336528008000077
						],
						[
							-81.67645390699994,
							30.336509009000057
						],
						[
							-81.67604790699994,
							30.33641600800007
						],
						[
							-81.67572790799994,
							30.336321008000084
						],
						[
							-81.67545290799991,
							30.336224008000045
						],
						[
							-81.67498790799993,
							30.33604200800005
						],
						[
							-81.67425490699992,
							30.33577300800005
						],
						[
							-81.67353090799993,
							30.335506009000085
						],
						[
							-81.67349690399993,
							30.335494009000058
						],
						[
							-81.67346290799992,
							30.335484008000037
						],
						[
							-81.67339090799993,
							30.33545600900004
						],
						[
							-81.67279790399994,
							30.335218008000087
						],
						[
							-81.67235590799993,
							30.335052008000048
						],
						[
							-81.6720959079999,
							30.334963009000038
						],
						[
							-81.67185190799995,
							30.334883009000063
						],
						[
							-81.67168390699993,
							30.334843009000053
						],
						[
							-81.6715789079999,
							30.334817008000073
						],
						[
							-81.67143190699994,
							30.33478100800005
						],
						[
							-81.67040593599995,
							30.33441810100004
						],
						[
							-81.67082951399993,
							30.33386230600007
						],
						[
							-81.6717637989999,
							30.33283459200004
						],
						[
							-81.67322750999995,
							30.331713449000063
						],
						[
							-81.67444207999995,
							30.33068573900005
						],
						[
							-81.67584350599992,
							30.329626883000063
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Mixon Town",
				"RegionID": "269092"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.63029832199993,
					30.30155201000008,
					-81.60696882499991,
					30.31868232200009
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.61173873599995,
							30.315987695000047
						],
						[
							-81.61145960599993,
							30.315779985000063
						],
						[
							-81.61134977799992,
							30.315796904000084
						],
						[
							-81.61114608199995,
							30.31591167000005
						],
						[
							-81.61105099999992,
							30.314933000000057
						],
						[
							-81.61098990699992,
							30.314795011000058
						],
						[
							-81.61096491099994,
							30.31473101200004
						],
						[
							-81.61095706499992,
							30.31463890400005
						],
						[
							-81.61084190699995,
							30.314575011000045
						],
						[
							-81.61060290799992,
							30.31448901100004
						],
						[
							-81.6100919079999,
							30.314312009000048
						],
						[
							-81.60964690799995,
							30.314070011000073
						],
						[
							-81.60923475999994,
							30.313835116000067
						],
						[
							-81.6091689829999,
							30.31350097400008
						],
						[
							-81.60911983599993,
							30.31344404400005
						],
						[
							-81.60910390599992,
							30.31329500800007
						],
						[
							-81.60899590699995,
							30.312961011000084
						],
						[
							-81.60888790799993,
							30.312732011000037
						],
						[
							-81.60866285799995,
							30.312261028000083
						],
						[
							-81.60864077499991,
							30.312153010000088
						],
						[
							-81.60866690799992,
							30.31203001200004
						],
						[
							-81.60876590799995,
							30.311795011000072
						],
						[
							-81.60898690699992,
							30.311442008000085
						],
						[
							-81.60907490499994,
							30.311207012000068
						],
						[
							-81.6091009079999,
							30.311001010000044
						],
						[
							-81.60911992899993,
							30.31091092800005
						],
						[
							-81.60886090699995,
							30.310863010000045
						],
						[
							-81.60854986999993,
							30.310783085000086
						],
						[
							-81.60821580499993,
							30.310501097000042
						],
						[
							-81.60805178299995,
							30.310218056000053
						],
						[
							-81.60798190799994,
							30.309627010000042
						],
						[
							-81.60794290699994,
							30.309036011000046
						],
						[
							-81.60791195999991,
							30.30846400100006
						],
						[
							-81.60784190999993,
							30.30826901200004
						],
						[
							-81.60783371999992,
							30.30820196000008
						],
						[
							-81.60787280099993,
							30.30814786900004
						],
						[
							-81.6079349069999,
							30.308121825000057
						],
						[
							-81.60803590699993,
							30.30816201100004
						],
						[
							-81.60812989699991,
							30.308195167000065
						],
						[
							-81.60823090799994,
							30.308169010000086
						],
						[
							-81.6090559349999,
							30.30786609800009
						],
						[
							-81.60915790799993,
							30.30783887700005
						],
						[
							-81.60923398199992,
							30.307853185000056
						],
						[
							-81.60950703299994,
							30.307450058000082
						],
						[
							-81.6096859079999,
							30.30667701100009
						],
						[
							-81.60992690699993,
							30.306034010000072
						],
						[
							-81.6099430399999,
							30.30595801000004
						],
						[
							-81.60992705399991,
							30.30589488600009
						],
						[
							-81.60985693099991,
							30.305863881000054
						],
						[
							-81.60976388199992,
							30.305870878000068
						],
						[
							-81.6087908909999,
							30.30632795500009
						],
						[
							-81.6086819009999,
							30.306341095000054
						],
						[
							-81.60857290699994,
							30.306308008000084
						],
						[
							-81.60795790899994,
							30.305951010000058
						],
						[
							-81.60720990799992,
							30.305320010000063
						],
						[
							-81.60698479399991,
							30.305091076000057
						],
						[
							-81.60696882499991,
							30.305031006000032
						],
						[
							-81.60699179099993,
							30.30494994500009
						],
						[
							-81.60717890699993,
							30.304707010000076
						],
						[
							-81.60832890799992,
							30.302797010000067
						],
						[
							-81.6083829069999,
							30.30270701000006
						],
						[
							-81.6084529069999,
							30.30256201000009
						],
						[
							-81.60849290699991,
							30.302437010000062
						],
						[
							-81.6085169079999,
							30.30233601000009
						],
						[
							-81.60853382999994,
							30.302260974000035
						],
						[
							-81.60858590999993,
							30.302191011000048
						],
						[
							-81.60866188199992,
							30.302130964000074
						],
						[
							-81.60876590999995,
							30.302086011000085
						],
						[
							-81.60889390799991,
							30.302061011000035
						],
						[
							-81.60900990599993,
							30.302056013000083
						],
						[
							-81.60913192599992,
							30.302085960000056
						],
						[
							-81.6092599079999,
							30.302156011000083
						],
						[
							-81.6093519069999,
							30.302226010000087
						],
						[
							-81.60945090999991,
							30.30232100900008
						],
						[
							-81.60958490799993,
							30.302392009000076
						],
						[
							-81.60970090599994,
							30.30243200800004
						],
						[
							-81.60981690799991,
							30.302447063000045
						],
						[
							-81.60995590699991,
							30.302432010000075
						],
						[
							-81.61010090699995,
							30.302402010000037
						],
						[
							-81.61022890699991,
							30.30235600900005
						],
						[
							-81.61035690699993,
							30.30228100900007
						],
						[
							-81.61049590599993,
							30.302161010000077
						],
						[
							-81.61059490699995,
							30.302036011000038
						],
						[
							-81.61071090799993,
							30.301910010000082
						],
						[
							-81.61082690799992,
							30.301810011000043
						],
						[
							-81.61092490699991,
							30.301750010000035
						],
						[
							-81.61100090799994,
							30.30171001100007
						],
						[
							-81.61119390799992,
							30.301641011000076
						],
						[
							-81.6113779069999,
							30.301592010000036
						],
						[
							-81.61151890799994,
							30.301564011000035
						],
						[
							-81.61161490799992,
							30.301552011000073
						],
						[
							-81.61164290799991,
							30.30155201000008
						],
						[
							-81.6118130289999,
							30.30156994200007
						],
						[
							-81.61427220299993,
							30.304128953000088
						],
						[
							-81.6158254369999,
							30.305590820000077
						],
						[
							-81.6167390999999,
							30.306504484000072
						],
						[
							-81.6178354999999,
							30.307418147000078
						],
						[
							-81.61919987699991,
							30.308183179000086
						],
						[
							-81.61925190499994,
							30.30817400800004
						],
						[
							-81.61934190599993,
							30.30814600800005
						],
						[
							-81.62009490499992,
							30.307864009000074
						],
						[
							-81.6204819049999,
							30.307720008000047
						],
						[
							-81.62080990599992,
							30.307595008000078
						],
						[
							-81.6218769059999,
							30.307191009000064
						],
						[
							-81.6220819049999,
							30.30711100800005
						],
						[
							-81.62256990499992,
							30.306929009000047
						],
						[
							-81.62289290599995,
							30.306807009000067
						],
						[
							-81.62318090599992,
							30.306713009000077
						],
						[
							-81.62340290599991,
							30.306651009000067
						],
						[
							-81.62385590499991,
							30.30657000800005
						],
						[
							-81.62409390499994,
							30.306539009000062
						],
						[
							-81.62461890499992,
							30.30649000800008
						],
						[
							-81.62525990499996,
							30.306415008000045
						],
						[
							-81.62567690499992,
							30.306366009000048
						],
						[
							-81.62627190599994,
							30.30631100800008
						],
						[
							-81.6266529049999,
							30.306284009000077
						],
						[
							-81.6272809059999,
							30.306218008000087
						],
						[
							-81.62761590499991,
							30.306189008000047
						],
						[
							-81.62783090499994,
							30.306160008000067
						],
						[
							-81.62808790499992,
							30.306131009000072
						],
						[
							-81.62842302699994,
							30.30608987000005
						],
						[
							-81.6284238689999,
							30.306160022000086
						],
						[
							-81.62843890599993,
							30.30630000900004
						],
						[
							-81.62872490599995,
							30.307716008000053
						],
						[
							-81.6291579999999,
							30.309778000000055
						],
						[
							-81.63027664099991,
							30.311174323000042
						],
						[
							-81.63028838799994,
							30.311252703000036
						],
						[
							-81.63029832199993,
							30.311386000000084
						],
						[
							-81.63028465899993,
							30.311542166000038
						],
						[
							-81.63024408599995,
							30.31169358600005
						],
						[
							-81.63017783499993,
							30.31183566100009
						],
						[
							-81.63008791999994,
							30.31196407300007
						],
						[
							-81.6299770729999,
							30.31207492100009
						],
						[
							-81.62984866099993,
							30.312164836000083
						],
						[
							-81.62970658599994,
							30.312231086000057
						],
						[
							-81.62955516499994,
							30.312271659000093
						],
						[
							-81.6295140869999,
							30.31227792800007
						],
						[
							-81.6284290879999,
							30.31241792800006
						],
						[
							-81.62839886499995,
							30.312421309000058
						],
						[
							-81.62576074999993,
							30.312671372000068
						],
						[
							-81.62510444799995,
							30.31274823600006
						],
						[
							-81.62481121499991,
							30.312878279000074
						],
						[
							-81.62308504499993,
							30.31368757000007
						],
						[
							-81.62210753499994,
							30.31440042800006
						],
						[
							-81.62018663599991,
							30.31581452500006
						],
						[
							-81.61778510399995,
							30.317536818000065
						],
						[
							-81.6177414359999,
							30.31756623800004
						],
						[
							-81.61619543499995,
							30.31854323800007
						],
						[
							-81.61616466099991,
							30.31856183600007
						],
						[
							-81.61602258599993,
							30.318628086000047
						],
						[
							-81.61587116599992,
							30.318668659000082
						],
						[
							-81.61571499999991,
							30.31868232200009
						],
						[
							-81.61555883499994,
							30.318668659000082
						],
						[
							-81.6153986999999,
							30.318624812000053
						],
						[
							-81.61461598499994,
							30.318321537000088
						],
						[
							-81.61449133899993,
							30.318261835000044
						],
						[
							-81.61447385899993,
							30.31825147900008
						],
						[
							-81.61388985899993,
							30.317896478000076
						],
						[
							-81.61377892699994,
							30.31781692000004
						],
						[
							-81.61372343399995,
							30.317766259000052
						],
						[
							-81.61325949899992,
							30.31730573500005
						],
						[
							-81.61226971399992,
							30.316722973000083
						],
						[
							-81.61220804099992,
							30.31668318600003
						],
						[
							-81.61214981799992,
							30.316638503000032
						],
						[
							-81.61209543199993,
							30.316589221000076
						],
						[
							-81.61204524499995,
							30.316535668000085
						],
						[
							-81.61199959299995,
							30.316478201000052
						],
						[
							-81.6119587789999,
							30.316417203000068
						],
						[
							-81.61192307399995,
							30.316353080000056
						],
						[
							-81.61173873599995,
							30.315987695000047
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Empire Point",
				"RegionID": "268980"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.72077195899993,
					30.273801010000057,
					-81.70661267799994,
					30.293462902000044
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.71568791699991,
							30.28998894600005
						],
						[
							-81.7133938579999,
							30.28997983800008
						],
						[
							-81.71317995399994,
							30.290126178000037
						],
						[
							-81.7119029079999,
							30.290138006000063
						],
						[
							-81.7114258169999,
							30.29001716000005
						],
						[
							-81.71115979099996,
							30.28973807400007
						],
						[
							-81.71111802099995,
							30.28960494100005
						],
						[
							-81.7109349509999,
							30.28941093900005
						],
						[
							-81.7106408599999,
							30.289314075000053
						],
						[
							-81.71030390499993,
							30.28892700900008
						],
						[
							-81.71010693799992,
							30.28874496700007
						],
						[
							-81.70993877199993,
							30.288672133000038
						],
						[
							-81.70984104999991,
							30.288392906000066
						],
						[
							-81.70968593999993,
							30.288271932000043
						],
						[
							-81.7094759069999,
							30.288236009000062
						],
						[
							-81.70916399999993,
							30.288185000000055
						],
						[
							-81.70815937799995,
							30.287440354000072
						],
						[
							-81.70858490199993,
							30.28736961000004
						],
						[
							-81.70871907899993,
							30.287124263000067
						],
						[
							-81.70848832299993,
							30.28702456700006
						],
						[
							-81.70839533899994,
							30.286977836000062
						],
						[
							-81.70832594299992,
							30.286933411000064
						],
						[
							-81.70819294299991,
							30.286839411000074
						],
						[
							-81.70813905699993,
							30.28679819300004
						],
						[
							-81.70808843099991,
							30.286753030000057
						],
						[
							-81.70804135399993,
							30.286704178000036
						],
						[
							-81.70799809399995,
							30.286651917000086
						],
						[
							-81.70795889599992,
							30.286596544000076
						],
						[
							-81.7078498969999,
							30.286429543000054
						],
						[
							-81.70782416499992,
							30.28638766100005
						],
						[
							-81.70776871899994,
							30.286273790000052
						],
						[
							-81.7076717189999,
							30.286032791000085
						],
						[
							-81.70766091399992,
							30.286004587000036
						],
						[
							-81.70761891899991,
							30.285844620000038
						],
						[
							-81.70758149599993,
							30.285606072000064
						],
						[
							-81.70757118099995,
							30.285497083000052
						],
						[
							-81.70752379099991,
							30.284081188000073
						],
						[
							-81.70739922599995,
							30.28319978600007
						],
						[
							-81.70734634999991,
							30.28305813600008
						],
						[
							-81.70722412799995,
							30.282832384000073
						],
						[
							-81.70675983299992,
							30.282123975000047
						],
						[
							-81.70673316499995,
							30.282080661000066
						],
						[
							-81.70666691399992,
							30.28193858600008
						],
						[
							-81.70662634099995,
							30.281787166000075
						],
						[
							-81.70661267799994,
							30.28163100000006
						],
						[
							-81.70662634099995,
							30.28147483400005
						],
						[
							-81.70663421799992,
							30.281435350000038
						],
						[
							-81.7067082179999,
							30.281103350000077
						],
						[
							-81.7067271279999,
							30.28103232000007
						],
						[
							-81.70675177499993,
							30.28096307000004
						],
						[
							-81.70678199499991,
							30.280896065000036
						],
						[
							-81.70681758699993,
							30.28083175200004
						],
						[
							-81.7068583109999,
							30.28077056000006
						],
						[
							-81.70691931099992,
							30.28068656000005
						],
						[
							-81.70695807999994,
							30.28063692700005
						],
						[
							-81.70706892699991,
							30.280526079000087
						],
						[
							-81.70719733899995,
							30.280436164000033
						],
						[
							-81.70733941399993,
							30.280369913000072
						],
						[
							-81.70749083499993,
							30.280329340000037
						],
						[
							-81.70764699999995,
							30.28031567800008
						],
						[
							-81.70781599999992,
							30.28031567800008
						],
						[
							-81.70791583599993,
							30.28032123600008
						],
						[
							-81.70865637599991,
							30.28040395700009
						],
						[
							-81.7089490379999,
							30.28042907100007
						],
						[
							-81.70900553599995,
							30.280434064000072
						],
						[
							-81.70953520099994,
							30.280126747000054
						],
						[
							-81.71108710399994,
							30.279096477000056
						],
						[
							-81.71115559899994,
							30.279019312000063
						],
						[
							-81.71120400899991,
							30.27896021800007
						],
						[
							-81.71121778399993,
							30.278926630000058
						],
						[
							-81.71145375299994,
							30.27826264000004
						],
						[
							-81.71152116399992,
							30.278117339000058
						],
						[
							-81.71157678799995,
							30.27803244900008
						],
						[
							-81.7116617879999,
							30.277917450000075
						],
						[
							-81.71170695299993,
							30.277861211000072
						],
						[
							-81.7117564799999,
							30.277808772000075
						],
						[
							-81.71181004999994,
							30.277760471000075
						],
						[
							-81.71186731799992,
							30.277716619000042
						],
						[
							-81.71192791699991,
							30.27767749700007
						],
						[
							-81.71199145599991,
							30.27764335700004
						],
						[
							-81.7120575269999,
							30.277614420000074
						],
						[
							-81.71219052599992,
							30.27756242000004
						],
						[
							-81.71223031699992,
							30.27754793300005
						],
						[
							-81.71300631699995,
							30.277285933000087
						],
						[
							-81.71309764999995,
							30.277260374000036
						],
						[
							-81.71398264999993,
							30.27706237400008
						],
						[
							-81.71406613699992,
							30.277047788000065
						],
						[
							-81.71473336499992,
							30.276963385000045
						],
						[
							-81.71513802899995,
							30.27683239100008
						],
						[
							-81.71517030299992,
							30.27682260800009
						],
						[
							-81.7153153029999,
							30.276781608000082
						],
						[
							-81.71546321599993,
							30.27675290100007
						],
						[
							-81.7156572159999,
							30.276731901000062
						],
						[
							-81.71577870099992,
							30.27672811700006
						],
						[
							-81.71585572299995,
							30.276442463000084
						],
						[
							-81.71587484299994,
							30.27606723400004
						],
						[
							-81.71588227299992,
							30.275988962000042
						],
						[
							-81.71589651099993,
							30.27591163900007
						],
						[
							-81.71591744699994,
							30.275835855000082
						],
						[
							-81.71594492299994,
							30.27576218900009
						],
						[
							-81.71597872799993,
							30.275691204000054
						],
						[
							-81.71601860399994,
							30.275623443000086
						],
						[
							-81.7160724439999,
							30.27554047600006
						],
						[
							-81.71606767799994,
							30.275486000000058
						],
						[
							-81.71606767799994,
							30.275371000000067
						],
						[
							-81.71607092999994,
							30.27529459100009
						],
						[
							-81.71608066199991,
							30.275218735000063
						],
						[
							-81.7160968039999,
							30.275143980000053
						],
						[
							-81.71611923799992,
							30.275070867000068
						],
						[
							-81.71614780399995,
							30.274999924000042
						],
						[
							-81.7161822939999,
							30.274931665000054
						],
						[
							-81.71622245799995,
							30.274866583000062
						],
						[
							-81.71626800699994,
							30.274805148000045
						],
						[
							-81.7163580429999,
							30.274694037000078
						],
						[
							-81.71647392699992,
							30.274577079000043
						],
						[
							-81.71654597899993,
							30.274522547000064
						],
						[
							-81.71706017799994,
							30.274172564000086
						],
						[
							-81.71716607699996,
							30.273973546000036
						],
						[
							-81.71720068799993,
							30.273914103000035
						],
						[
							-81.71723973999991,
							30.27385747800008
						],
						[
							-81.71728300599995,
							30.273804004000052
						],
						[
							-81.71728583399994,
							30.273801010000057
						],
						[
							-81.71795999999995,
							30.27439600000008
						],
						[
							-81.7189809059999,
							30.275297008000052
						],
						[
							-81.71920190499992,
							30.27551000800008
						],
						[
							-81.71949790499991,
							30.275858008000057
						],
						[
							-81.71955490499994,
							30.27592200800007
						],
						[
							-81.71971090599993,
							30.27613500900009
						],
						[
							-81.71985090599992,
							30.276347008000076
						],
						[
							-81.71998290499994,
							30.276574009000058
						],
						[
							-81.72008090499992,
							30.27679400800008
						],
						[
							-81.72019590499991,
							30.27705700900009
						],
						[
							-81.72026990599994,
							30.277227008000068
						],
						[
							-81.72031590499996,
							30.277369008000054
						],
						[
							-81.7204479049999,
							30.27798400900008
						],
						[
							-81.72055090499993,
							30.278827008000068
						],
						[
							-81.72063190599994,
							30.27972900900005
						],
						[
							-81.72067290599995,
							30.280516008000067
						],
						[
							-81.72072590499994,
							30.28218800900004
						],
						[
							-81.7207119059999,
							30.283088009000036
						],
						[
							-81.72070590499993,
							30.284041008000084
						],
						[
							-81.72068190499994,
							30.284769009000062
						],
						[
							-81.72060690599994,
							30.285780009000064
						],
						[
							-81.7205989059999,
							30.286631008000086
						],
						[
							-81.72058190599996,
							30.28748900800008
						],
						[
							-81.72061490599992,
							30.288525008000082
						],
						[
							-81.72066190599992,
							30.28924400800008
						],
						[
							-81.72077195899993,
							30.290091008000044
						],
						[
							-81.72063490699992,
							30.290941007000075
						],
						[
							-81.72065884999995,
							30.292030010000076
						],
						[
							-81.72065290599994,
							30.292684009000087
						],
						[
							-81.72065590599993,
							30.293356010000082
						],
						[
							-81.72066183099992,
							30.293462902000044
						],
						[
							-81.72033890599994,
							30.29330800900004
						],
						[
							-81.7201289059999,
							30.29320800800008
						],
						[
							-81.71994474099995,
							30.29312010700005
						],
						[
							-81.71994490599991,
							30.29279700800004
						],
						[
							-81.7199559849999,
							30.29263098800004
						],
						[
							-81.71909402199992,
							30.290982879000072
						],
						[
							-81.71809590599992,
							30.29055500900006
						],
						[
							-81.71568791699991,
							30.28998894600005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Fairfax",
				"RegionID": "268982"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.5140112835053,
					27.944699998092602,
					-82.50599016107816,
					27.95498988067247
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.50599016107816,
							27.954952801625176
						],
						[
							-82.50601920018643,
							27.94499065357646
						],
						[
							-82.51001999880975,
							27.94500001372014
						],
						[
							-82.51112000095254,
							27.944699998092602
						],
						[
							-82.5140112835053,
							27.94474104494865
						],
						[
							-82.51392004998333,
							27.950900032081215
						],
						[
							-82.5121299791617,
							27.951450014266875
						],
						[
							-82.5106899928223,
							27.952300029167297
						],
						[
							-82.50599022493002,
							27.95498988067247
						],
						[
							-82.50599016107816,
							27.954952801625176
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Bon Air North",
				"RegionID": "273000"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.13898829699997,
					26.17634313600007,
					-80.13154521799999,
					26.188952650000033
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.13185272099997,
							26.18318776700005
						],
						[
							-80.13185189799998,
							26.183164801000032
						],
						[
							-80.13154521799999,
							26.177317707000043
						],
						[
							-80.13173917799998,
							26.17731140400008
						],
						[
							-80.13471040899998,
							26.177214856000035
						],
						[
							-80.13474269499994,
							26.17640770700007
						],
						[
							-80.13879458199995,
							26.17634313600007
						],
						[
							-80.13886163999996,
							26.178988884000034
						],
						[
							-80.13891813899994,
							26.181218046000026
						],
						[
							-80.13895982499997,
							26.18286275500003
						],
						[
							-80.13896635699996,
							26.183120468000027
						],
						[
							-80.13897384699999,
							26.183601505000073
						],
						[
							-80.13897995999997,
							26.18409300900004
						],
						[
							-80.13898690599996,
							26.18458957100006
						],
						[
							-80.13898829699997,
							26.184689054000046
						],
						[
							-80.13898139899999,
							26.184688915000038
						],
						[
							-80.13593971599994,
							26.18474335800005
						],
						[
							-80.13585872599998,
							26.185291007000046
						],
						[
							-80.13572741599995,
							26.186900641000026
						],
						[
							-80.13555376399995,
							26.186907587000064
						],
						[
							-80.13532384199993,
							26.18691678400006
						],
						[
							-80.13533317599996,
							26.187270832000024
						],
						[
							-80.13534542399998,
							26.187735462000035
						],
						[
							-80.13535100299998,
							26.18794709100007
						],
						[
							-80.13534895499998,
							26.188300653000056
						],
						[
							-80.13534631899995,
							26.188755754000056
						],
						[
							-80.13534540099994,
							26.18891429000007
						],
						[
							-80.13189295499996,
							26.188952650000033
						],
						[
							-80.13189076699996,
							26.188636191000057
						],
						[
							-80.13185272099997,
							26.18318776700005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Oakland Park",
				"Name": "Central Business District",
				"RegionID": "273191"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.43478194891813,
					27.974439945378144,
					-82.4279077417676,
					27.981800131764288
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.42801805260771,
							27.981800131764288
						],
						[
							-82.4279077417676,
							27.974439945378144
						],
						[
							-82.43478194891813,
							27.974499869902864
						],
						[
							-82.43471830929407,
							27.98180012726762
						],
						[
							-82.42801805260771,
							27.981800131764288
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "College Hill",
				"RegionID": "273311"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.3644600077939,
					28.553112977810212,
					-81.35164509425564,
					28.567804821389615
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.35178721231732,
							28.56769560502442
						],
						[
							-81.35176518072619,
							28.566995567360852
						],
						[
							-81.35171009905062,
							28.56525598717588
						],
						[
							-81.3516760489199,
							28.56304570993465
						],
						[
							-81.3516760489199,
							28.56284340924281
						],
						[
							-81.35165702016506,
							28.56173676830472
						],
						[
							-81.35165702016506,
							28.561699713539156
						],
						[
							-81.35165101089528,
							28.56088450419992
						],
						[
							-81.35164509425564,
							28.560584060495074
						],
						[
							-81.3516560192197,
							28.560434837789415
						],
						[
							-81.35169407493063,
							28.560259580610243
						],
						[
							-81.35178320763629,
							28.560067292070578
						],
						[
							-81.35200653807443,
							28.55970976030256
						],
						[
							-81.35209666902753,
							28.55947741775834
						],
						[
							-81.35211473550785,
							28.55931619180157
						],
						[
							-81.35210969210988,
							28.55868424180879
						],
						[
							-81.35210774327909,
							28.55858408881099
						],
						[
							-81.35210268099534,
							28.558250598618812
						],
						[
							-81.3520996763605,
							28.557992214406568
						],
						[
							-81.35208565593,
							28.55724610897207
						],
						[
							-81.3520816494504,
							28.556869549348587
						],
						[
							-81.35207664292463,
							28.55641387456756
						],
						[
							-81.3520636225403,
							28.555820994721103
						],
						[
							-81.35204359373937,
							28.554975741730836
						],
						[
							-81.35203357888926,
							28.55411346277593
						],
						[
							-81.3520024416626,
							28.553247176442063
						],
						[
							-81.35200602815885,
							28.553187090039273
						],
						[
							-81.35276466294789,
							28.55319510030062
						],
						[
							-81.35406859625348,
							28.55318107897083
						],
						[
							-81.35555780428611,
							28.553154039055457
						],
						[
							-81.35560086922084,
							28.553154039055457
						],
						[
							-81.35566195926693,
							28.55315203626526
						],
						[
							-81.35615569155763,
							28.553145026050004
						],
						[
							-81.3564521314809,
							28.55314001862495
						],
						[
							-81.35722327404066,
							28.553128000984735
						],
						[
							-81.35812060587031,
							28.553121992614223
						],
						[
							-81.35823677759215,
							28.553120989870116
						],
						[
							-81.35902895259615,
							28.553112977810212
						],
						[
							-81.36028481534069,
							28.553124996349794
						],
						[
							-81.36267536078336,
							28.55314402420527
						],
						[
							-81.36443798879331,
							28.55315403995474
						],
						[
							-81.36443697345875,
							28.55322414390556
						],
						[
							-81.36444799015358,
							28.554215614067267
						],
						[
							-81.36444498551865,
							28.554987759371137
						],
						[
							-81.36444498551865,
							28.55529020766484
						],
						[
							-81.3644539985241,
							28.556223591515938
						],
						[
							-81.36445700315895,
							28.55677741380672
						],
						[
							-81.3644600077939,
							28.558592104468282
						],
						[
							-81.3644519957339,
							28.559495444668435
						],
						[
							-81.36444298272853,
							28.559954124084392
						],
						[
							-81.36444899199833,
							28.560416809979948
						],
						[
							-81.36445499946947,
							28.56129711674432
						],
						[
							-81.36445299667936,
							28.562158393854396
						],
						[
							-81.36445299667936,
							28.562275567420976
						],
						[
							-81.36443797440411,
							28.563129834315887
						],
						[
							-81.36444292337326,
							28.56404019012716
						],
						[
							-81.36443997809359,
							28.564075236706664
						],
						[
							-81.36444398367391,
							28.564798308705384
						],
						[
							-81.36444203574248,
							28.5655534289439
						],
						[
							-81.36266935151357,
							28.56557345864411
						],
						[
							-81.36237491527977,
							28.56557646237968
						],
						[
							-81.3618000623434,
							28.565584474439582
						],
						[
							-81.36090673789273,
							28.565585476284326
						],
						[
							-81.36048911792328,
							28.565585476284326
						],
						[
							-81.35998236704691,
							28.565590482810094
						],
						[
							-81.35953370158177,
							28.565598494870088
						],
						[
							-81.35852720824555,
							28.565613517145245
						],
						[
							-81.35749868421765,
							28.565627538474942
						],
						[
							-81.35633395606966,
							28.565642559850822
						],
						[
							-81.35519927427075,
							28.565664593240598
						],
						[
							-81.35514906512182,
							28.565666469226365
						],
						[
							-81.35520027431684,
							28.56706166573136
						],
						[
							-81.35519710060932,
							28.567178885163386
						],
						[
							-81.3552525222287,
							28.567266925192698
						],
						[
							-81.35524434019693,
							28.5673691214502
						],
						[
							-81.35522431049664,
							28.5674702708968
						],
						[
							-81.35520836731573,
							28.56752852448124
						],
						[
							-81.35513714011168,
							28.567501131132232
						],
						[
							-81.35505806362501,
							28.567582436138956
						],
						[
							-81.35497096158848,
							28.567646577584714
						],
						[
							-81.35487479078861,
							28.567684587430293
						],
						[
							-81.3547115494512,
							28.567709625454924
						],
						[
							-81.35414557552116,
							28.56771850895784
						],
						[
							-81.35414885085201,
							28.567765839376975
						],
						[
							-81.35368102173372,
							28.567771718245034
						],
						[
							-81.35270254587606,
							28.567788690250346
						],
						[
							-81.3522488972675,
							28.567797757215125
						],
						[
							-81.35179221794372,
							28.567804821389615
						],
						[
							-81.35179021785154,
							28.56774768206523
						],
						[
							-81.35178721231732,
							28.56769560502442
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Colonialtown North",
				"RegionID": "273327"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.53458562899993,
					27.922870301000046,
					-82.51420456699992,
					27.93390015300008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.51423759999994,
							27.93387621000005
						],
						[
							-82.51420456699992,
							27.92635566000007
						],
						[
							-82.51805024299995,
							27.923193086000087
						],
						[
							-82.51833403899991,
							27.922870301000046
						],
						[
							-82.5186201599999,
							27.923800008000057
						],
						[
							-82.51861003199991,
							27.92459999600004
						],
						[
							-82.51858996899995,
							27.926449999000056
						],
						[
							-82.51853989099993,
							27.931210170000043
						],
						[
							-82.51899242799993,
							27.931191396000088
						],
						[
							-82.5190198439999,
							27.930799878000073
						],
						[
							-82.52182000099992,
							27.930700008000088
						],
						[
							-82.52332002199995,
							27.930900019000035
						],
						[
							-82.52452014099993,
							27.931200106000063
						],
						[
							-82.52451986099993,
							27.93009987700009
						],
						[
							-82.5253200009999,
							27.929600012000037
						],
						[
							-82.5270769999999,
							27.928520000000052
						],
						[
							-82.52738144599994,
							27.92865136200004
						],
						[
							-82.52771824899992,
							27.92865136200004
						],
						[
							-82.5280550519999,
							27.928659381000045
						],
						[
							-82.5284319509999,
							27.928707496000072
						],
						[
							-82.52868054299995,
							27.92873957200004
						],
						[
							-82.52967491399994,
							27.928747592000036
						],
						[
							-82.53056503699992,
							27.928763630000052
						],
						[
							-82.5309018399999,
							27.92873957200004
						],
						[
							-82.5311825089999,
							27.92865136200004
						],
						[
							-82.53150327399993,
							27.928394750000052
						],
						[
							-82.53171707599995,
							27.928068292000038
						],
						[
							-82.53200710399994,
							27.928067680000083
						],
						[
							-82.53209747299991,
							27.928072041000068
						],
						[
							-82.53236047299993,
							27.928098040000066
						],
						[
							-82.5324103499999,
							27.92810438300006
						],
						[
							-82.53258625699993,
							27.928131862000043
						],
						[
							-82.53274850499992,
							27.92817461700008
						],
						[
							-82.53289942399994,
							27.92823032000007
						],
						[
							-82.53302309199995,
							27.92828693200005
						],
						[
							-82.5331840909999,
							27.92837593300004
						],
						[
							-82.53331401499992,
							27.928463331000046
						],
						[
							-82.53357901499993,
							27.928677331000074
						],
						[
							-82.53361686099993,
							27.928709663000063
						],
						[
							-82.53382385999993,
							27.928896662000056
						],
						[
							-82.53391897699993,
							27.92899689500007
						],
						[
							-82.53404897699994,
							27.929156896000052
						],
						[
							-82.53411227499993,
							27.92924521000009
						],
						[
							-82.5342122749999,
							27.929404211000076
						],
						[
							-82.53426472199993,
							27.929500070000074
						],
						[
							-82.5343207219999,
							27.92961906900007
						],
						[
							-82.53436943899993,
							27.92974709100008
						],
						[
							-82.53454943899993,
							27.93035609100008
						],
						[
							-82.5345675499999,
							27.930428213000088
						],
						[
							-82.53457964099994,
							27.930501585000062
						],
						[
							-82.53458562899993,
							27.930575704000034
						],
						[
							-82.53458547299994,
							27.930650065000066
						],
						[
							-82.53458147299995,
							27.93074206600005
						],
						[
							-82.53456865899994,
							27.93085916600006
						],
						[
							-82.53455547099992,
							27.930921115000046
						],
						[
							-82.5345414709999,
							27.930977115000076
						],
						[
							-82.53452354299992,
							27.931035688000065
						],
						[
							-82.5345409059999,
							27.931103265000047
						],
						[
							-82.5345491189999,
							27.931154491000086
						],
						[
							-82.53456408599993,
							27.931248286000084
						],
						[
							-82.53457532199991,
							27.93139000000008
						],
						[
							-82.53456992999992,
							27.931488336000086
						],
						[
							-82.5345589289999,
							27.93158833600006
						],
						[
							-82.53454751699991,
							27.93166304300007
						],
						[
							-82.53446751699994,
							27.932071043000064
						],
						[
							-82.53443008599993,
							27.932205586000066
						],
						[
							-82.53442159899993,
							27.932227972000078
						],
						[
							-82.53428751599995,
							27.932567921000043
						],
						[
							-82.53397772299991,
							27.932746185000042
						],
						[
							-82.53352082099991,
							27.93295223800004
						],
						[
							-82.5330549599999,
							27.933086621000086
						],
						[
							-82.53103025699994,
							27.933104539000055
						],
						[
							-82.52875470599992,
							27.933077663000063
						],
						[
							-82.52827092799993,
							27.93306870400005
						],
						[
							-82.52813654499994,
							27.933014951000075
						],
						[
							-82.52805591499992,
							27.932871609000074
						],
						[
							-82.52790140099995,
							27.93289203200004
						],
						[
							-82.52722130199993,
							27.932879109000055
						],
						[
							-82.52451674399994,
							27.932826504000047
						],
						[
							-82.5245044049999,
							27.93347599100008
						],
						[
							-82.52045083999991,
							27.933397079000088
						],
						[
							-82.51981128299991,
							27.933651586000053
						],
						[
							-82.51909244799992,
							27.933507473000077
						],
						[
							-82.51852006599995,
							27.93390015300008
						],
						[
							-82.51423759999994,
							27.93387621000005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Culbreath",
				"RegionID": "273418"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.8082359089999,
					30.26849600900005,
					-81.76742092199993,
					30.297662066000044
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.7718879059999,
							30.284420008000037
						],
						[
							-81.77187890499994,
							30.28372200800004
						],
						[
							-81.77184990599994,
							30.28310000800008
						],
						[
							-81.7717769059999,
							30.28245400800006
						],
						[
							-81.77174290499994,
							30.282169009000086
						],
						[
							-81.77156590599992,
							30.28124600900009
						],
						[
							-81.77140590499994,
							30.28063000900005
						],
						[
							-81.77123790499991,
							30.280016008000075
						],
						[
							-81.77113890499993,
							30.27970700800006
						],
						[
							-81.77012290599993,
							30.27701600900008
						],
						[
							-81.77000190599995,
							30.276695008000047
						],
						[
							-81.76980090599994,
							30.276162009000075
						],
						[
							-81.76908690499994,
							30.27428700900009
						],
						[
							-81.76889790599995,
							30.27374500900004
						],
						[
							-81.76876490599994,
							30.273328008000078
						],
						[
							-81.76775690599993,
							30.270781008000085
						],
						[
							-81.76742092199993,
							30.26985392100005
						],
						[
							-81.76792090499993,
							30.26985400800004
						],
						[
							-81.7688099049999,
							30.269814008000083
						],
						[
							-81.76960790599992,
							30.269817009000068
						],
						[
							-81.77097090599996,
							30.269793008000075
						],
						[
							-81.77191190499991,
							30.269768008000085
						],
						[
							-81.7722359679999,
							30.26976109700007
						],
						[
							-81.77250390499995,
							30.269753008000066
						],
						[
							-81.77273390499994,
							30.26975600800006
						],
						[
							-81.77305590599991,
							30.269747008000078
						],
						[
							-81.77356890599992,
							30.26973500800006
						],
						[
							-81.77469590599992,
							30.26971800800004
						],
						[
							-81.77664890599993,
							30.269674008000038
						],
						[
							-81.77728290499994,
							30.269663009000055
						],
						[
							-81.77784890499993,
							30.269656008000084
						],
						[
							-81.77878590499995,
							30.269672008000043
						],
						[
							-81.77888190499993,
							30.269675008000036
						],
						[
							-81.77972890599995,
							30.26968900800006
						],
						[
							-81.78127190599992,
							30.269675008000036
						],
						[
							-81.78487390499993,
							30.26961300800008
						],
						[
							-81.7857359059999,
							30.26960400900009
						],
						[
							-81.78605690899991,
							30.269575006000082
						],
						[
							-81.78627490799994,
							30.269514006000065
						],
						[
							-81.78646090599995,
							30.269421007000066
						],
						[
							-81.78657490499995,
							30.269339008000088
						],
						[
							-81.78666690499995,
							30.269260008000064
						],
						[
							-81.78673590499994,
							30.26919700800005
						],
						[
							-81.78685790499992,
							30.26904900800008
						],
						[
							-81.78695690699993,
							30.268902009000044
						],
						[
							-81.78713990599995,
							30.26871100900007
						],
						[
							-81.7872009059999,
							30.268661010000077
						],
						[
							-81.78737590499992,
							30.26857001000008
						],
						[
							-81.7875139059999,
							30.268528008000086
						],
						[
							-81.78768890599991,
							30.268499009000042
						],
						[
							-81.7879409059999,
							30.26849600900005
						],
						[
							-81.7881239059999,
							30.26851700900005
						],
						[
							-81.78826090599995,
							30.268555009000064
						],
						[
							-81.7890469059999,
							30.268871008000076
						],
						[
							-81.78926090599992,
							30.26892300800006
						],
						[
							-81.78936003899992,
							30.268935979000048
						],
						[
							-81.78921490899995,
							30.269352010000034
						],
						[
							-81.7891919079999,
							30.269482010000047
						],
						[
							-81.78918490699995,
							30.26958101000008
						],
						[
							-81.78919990799994,
							30.27170201000007
						],
						[
							-81.78919995699994,
							30.272209028000077
						],
						[
							-81.78916902499992,
							30.272297077000076
						],
						[
							-81.78912574399993,
							30.272349952000074
						],
						[
							-81.78912373399993,
							30.273174076000092
						],
						[
							-81.78914590699992,
							30.27319701100004
						],
						[
							-81.78920007199991,
							30.273265947000084
						],
						[
							-81.78922990599995,
							30.27374301200007
						],
						[
							-81.78921490799992,
							30.273830011000086
						],
						[
							-81.78919190599993,
							30.273977010000063
						],
						[
							-81.78896277599996,
							30.27455298700005
						],
						[
							-81.78898590799992,
							30.275066010000046
						],
						[
							-81.7889858559999,
							30.27536401900005
						],
						[
							-81.78913890799993,
							30.275898011000038
						],
						[
							-81.78922290799994,
							30.27617301000004
						],
						[
							-81.78934483899991,
							30.276466059000086
						],
						[
							-81.78980307499995,
							30.27687493500008
						],
						[
							-81.78978690799994,
							30.27941701000009
						],
						[
							-81.78977190799992,
							30.280283011000048
						],
						[
							-81.78974177399994,
							30.284283143000042
						],
						[
							-81.79031390799992,
							30.284285010000072
						],
						[
							-81.79162590699991,
							30.284262010000077
						],
						[
							-81.7923509069999,
							30.284252010000046
						],
						[
							-81.79290090799992,
							30.284244010000066
						],
						[
							-81.79340390699993,
							30.28423701000008
						],
						[
							-81.79445590699993,
							30.284224010000063
						],
						[
							-81.80516090799995,
							30.28408201000008
						],
						[
							-81.80533290699992,
							30.284076010000035
						],
						[
							-81.8057429079999,
							30.284033011000073
						],
						[
							-81.80730190799994,
							30.284030010000038
						],
						[
							-81.80761390999993,
							30.283993009000085
						],
						[
							-81.80788690799994,
							30.283905010000073
						],
						[
							-81.80817698699991,
							30.283832834000066
						],
						[
							-81.8082359089999,
							30.283935067000076
						],
						[
							-81.80644790499991,
							30.284621008000045
						],
						[
							-81.80530690599994,
							30.285069008000054
						],
						[
							-81.80450690599992,
							30.285393009000074
						],
						[
							-81.80339590599993,
							30.285859009000035
						],
						[
							-81.8031179059999,
							30.28595700900007
						],
						[
							-81.80262790499997,
							30.286137008000086
						],
						[
							-81.8020399049999,
							30.286363009000073
						],
						[
							-81.8011329059999,
							30.286677009000073
						],
						[
							-81.80099490599991,
							30.286745008000086
						],
						[
							-81.80054590599991,
							30.286912009000048
						],
						[
							-81.7995569059999,
							30.28729000800007
						],
						[
							-81.79933690599995,
							30.287364008000058
						],
						[
							-81.79813290499993,
							30.287796008000043
						],
						[
							-81.79700590599992,
							30.288120009000068
						],
						[
							-81.79676090599992,
							30.288192008000067
						],
						[
							-81.79612090599994,
							30.288368008000077
						],
						[
							-81.79566790599995,
							30.288492009000038
						],
						[
							-81.79542990499993,
							30.28855500800006
						],
						[
							-81.79412490599994,
							30.28886000800009
						],
						[
							-81.7935039059999,
							30.288994008000092
						],
						[
							-81.79279390499994,
							30.28917000900009
						],
						[
							-81.7919739049999,
							30.289353009000084
						],
						[
							-81.79185490499992,
							30.289395008000042
						],
						[
							-81.79009490499993,
							30.289829009000076
						],
						[
							-81.7883279049999,
							30.290234009000073
						],
						[
							-81.78789090599993,
							30.290340008000044
						],
						[
							-81.78694390599992,
							30.29060000900006
						],
						[
							-81.78645090599991,
							30.29073100900007
						],
						[
							-81.7855359049999,
							30.291013008000053
						],
						[
							-81.7845029049999,
							30.291340009000066
						],
						[
							-81.78396990599992,
							30.291523009000056
						],
						[
							-81.78367590499994,
							30.29162200800005
						],
						[
							-81.78301890499995,
							30.291855008000088
						],
						[
							-81.78261390599994,
							30.292007008000045
						],
						[
							-81.7813458199999,
							30.29251394900007
						],
						[
							-81.7808329049999,
							30.292736008000077
						],
						[
							-81.78006390599995,
							30.293120008000077
						],
						[
							-81.77945890599995,
							30.29342200800005
						],
						[
							-81.77797690599994,
							30.294151009000075
						],
						[
							-81.77775690599992,
							30.29425600800005
						],
						[
							-81.77708790499992,
							30.29453500900007
						],
						[
							-81.77633581999993,
							30.294923904000086
						],
						[
							-81.77625498999993,
							30.29501011200006
						],
						[
							-81.77388290499994,
							30.296181008000072
						],
						[
							-81.77321090599992,
							30.29650400800006
						],
						[
							-81.77297790599994,
							30.29661500800006
						],
						[
							-81.77214690599993,
							30.297024008000047
						],
						[
							-81.77085899199994,
							30.297662066000044
						],
						[
							-81.77087090599991,
							30.297544009000035
						],
						[
							-81.77099990499994,
							30.296244008000087
						],
						[
							-81.7711239059999,
							30.29481500800006
						],
						[
							-81.77118590599991,
							30.293887008000066
						],
						[
							-81.77123990599995,
							30.293285008000055
						],
						[
							-81.77127690599991,
							30.29268600800009
						],
						[
							-81.7713539049999,
							30.292252008000048
						],
						[
							-81.77136190599992,
							30.291996008000073
						],
						[
							-81.77139990599994,
							30.291378009000088
						],
						[
							-81.77142290599994,
							30.290850009000057
						],
						[
							-81.77147690599992,
							30.29021800800007
						],
						[
							-81.77156790499993,
							30.288961008000054
						],
						[
							-81.7716219049999,
							30.28833000800006
						],
						[
							-81.77163690599991,
							30.28801900900004
						],
						[
							-81.77176690599994,
							30.286535008000044
						],
						[
							-81.77180490599994,
							30.285906008000044
						],
						[
							-81.77187990499995,
							30.284983009000086
						],
						[
							-81.7718879059999,
							30.284420008000037
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Normandy Manor",
				"RegionID": "269103"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.1972429999999,
					26.05057500000004,
					-80.18575499999992,
					26.06256600000006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.1947209999999,
							26.05057500000004
						],
						[
							-80.19516899999991,
							26.050583000000074
						],
						[
							-80.1963649999999,
							26.050644000000094
						],
						[
							-80.19679999999994,
							26.050666000000035
						],
						[
							-80.19711999999993,
							26.050598000000036
						],
						[
							-80.1972429999999,
							26.054081000000053
						],
						[
							-80.1926632119999,
							26.054092740000044
						],
						[
							-80.19323428199993,
							26.054996935000077
						],
						[
							-80.19371017399993,
							26.055472827000074
						],
						[
							-80.19394812099995,
							26.056186666000087
						],
						[
							-80.19413847699991,
							26.057186039000044
						],
						[
							-80.19409088799995,
							26.057947467000076
						],
						[
							-80.19385294199992,
							26.058423359000074
						],
						[
							-80.19337704999992,
							26.058518538000044
						],
						[
							-80.19218731899991,
							26.058518538000044
						],
						[
							-80.19213972999995,
							26.061183534000065
						],
						[
							-80.1926632119999,
							26.06194496100005
						],
						[
							-80.19266899999991,
							26.06256600000006
						],
						[
							-80.1924249999999,
							26.06251700000007
						],
						[
							-80.19186799999994,
							26.062508000000037
						],
						[
							-80.19126899999993,
							26.06256600000006
						],
						[
							-80.19064099999991,
							26.062531000000035
						],
						[
							-80.19069399999995,
							26.06204800000006
						],
						[
							-80.19076399999994,
							26.061828000000048
						],
						[
							-80.18754199999995,
							26.061712000000057
						],
						[
							-80.18759599999993,
							26.06043100000005
						],
						[
							-80.1876309999999,
							26.05957600000005
						],
						[
							-80.18750599999993,
							26.05936300000008
						],
						[
							-80.18739899999991,
							26.059169000000054
						],
						[
							-80.18711499999995,
							26.058996000000036
						],
						[
							-80.18718599999994,
							26.05882100000008
						],
						[
							-80.1867039999999,
							26.05863000000005
						],
						[
							-80.18575499999992,
							26.058462000000077
						],
						[
							-80.18577399999992,
							26.055233000000044
						],
						[
							-80.18576999999993,
							26.05466700000005
						],
						[
							-80.18606799999992,
							26.054666000000054
						],
						[
							-80.18713699999995,
							26.054636000000073
						],
						[
							-80.18715199999991,
							26.05437500000005
						],
						[
							-80.18720399999995,
							26.05077700000004
						],
						[
							-80.18780911099992,
							26.05138015500006
						],
						[
							-80.19033133999994,
							26.05128497600009
						],
						[
							-80.19080723199994,
							26.05152292200006
						],
						[
							-80.19252044399991,
							26.05142774400008
						],
						[
							-80.19252044399991,
							26.050761495000074
						],
						[
							-80.19404329899993,
							26.050761495000074
						],
						[
							-80.1947209999999,
							26.05057500000004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Hollywood",
				"Name": "Oakridge",
				"RegionID": "269118"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.05685472419975,
					26.736240000000073,
					-80.05256353099986,
					26.745841617095607
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.05622904399993,
							26.74583161400019
						],
						[
							-80.05601710799988,
							26.745820558000162
						],
						[
							-80.05561405299993,
							26.745821144000033
						],
						[
							-80.05494748599995,
							26.74580540800015
						],
						[
							-80.05454322499988,
							26.745794177000022
						],
						[
							-80.05392153599986,
							26.745793521000145
						],
						[
							-80.05357567099993,
							26.74577402300013
						],
						[
							-80.05322909699994,
							26.745774000000043
						],
						[
							-80.0530599999999,
							26.745760000000125
						],
						[
							-80.05281879999986,
							26.745773972000038
						],
						[
							-80.05256353099986,
							26.7457693410001
						],
						[
							-80.0525799999998,
							26.74516000100013
						],
						[
							-80.05258999999991,
							26.744540001000168
						],
						[
							-80.05259999999994,
							26.74424000000013
						],
						[
							-80.0526199999999,
							26.743490000000065
						],
						[
							-80.05263999999988,
							26.742540001000066
						],
						[
							-80.0526499999999,
							26.742040000000177
						],
						[
							-80.05265999999993,
							26.741650000000057
						],
						[
							-80.0526799999999,
							26.74092000100014
						],
						[
							-80.05269999999977,
							26.740070001000156
						],
						[
							-80.05271999999992,
							26.73934000100015
						],
						[
							-80.05271999999992,
							26.739140000000212
						],
						[
							-80.05273999999989,
							26.738240000000175
						],
						[
							-80.05275999999986,
							26.737440001000152
						],
						[
							-80.0527400649999,
							26.736889967000117
						],
						[
							-80.05274983399981,
							26.736809917000066
						],
						[
							-80.05280999999991,
							26.736840000000157
						],
						[
							-80.05281595299986,
							26.736714980000116
						],
						[
							-80.05282523499993,
							26.736520058000153
						],
						[
							-80.05283153199991,
							26.73640061800004
						],
						[
							-80.0528399999999,
							26.736240000000073
						],
						[
							-80.05334999999991,
							26.736250000000013
						],
						[
							-80.05362319699987,
							26.736257334000086
						],
						[
							-80.05391490499994,
							26.736265165000113
						],
						[
							-80.05443031699986,
							26.736279002000103
						],
						[
							-80.05483999999991,
							26.73629000000013
						],
						[
							-80.05518819999988,
							26.736297254000192
						],
						[
							-80.05564513399993,
							26.73630677400009
						],
						[
							-80.05627999999979,
							26.73632000000012
						],
						[
							-80.05657848899996,
							26.73632523700011
						],
						[
							-80.05684999999995,
							26.73633000000006
						],
						[
							-80.05685472419975,
							26.736330111200175
						],
						[
							-80.05684376899988,
							26.73649928700012
						],
						[
							-80.05681586899989,
							26.736900810000037
						],
						[
							-80.05679517699987,
							26.737276959000162
						],
						[
							-80.05677329799992,
							26.737807522000097
						],
						[
							-80.05676367099993,
							26.73804098500014
						],
						[
							-80.05675241999997,
							26.738313804000065
						],
						[
							-80.05673374299994,
							26.738766723000147
						],
						[
							-80.05671999999986,
							26.7391000000001
						],
						[
							-80.05670945099988,
							26.73953249400018
						],
						[
							-80.05670376399985,
							26.73976568200011
						],
						[
							-80.05669999999989,
							26.73992000000009
						],
						[
							-80.0566904519999,
							26.740206429000075
						],
						[
							-80.05667662699983,
							26.74062120200002
						],
						[
							-80.0566699999999,
							26.740820000000127
						],
						[
							-80.0566699999999,
							26.741100737000174
						],
						[
							-80.05665728199982,
							26.741477078000138
						],
						[
							-80.05664999999993,
							26.74163000000018
						],
						[
							-80.05664118299991,
							26.741982661000137
						],
						[
							-80.05662418399993,
							26.74241003800006
						],
						[
							-80.05661999999994,
							26.742500000000042
						],
						[
							-80.05661702499987,
							26.742746917000133
						],
						[
							-80.0566140579998,
							26.74299317000017
						],
						[
							-80.0566099999999,
							26.74333000000015
						],
						[
							-80.0566099999999,
							26.743740000000145
						],
						[
							-80.05658999999986,
							26.74416000000008
						],
						[
							-80.0565851249999,
							26.74456949900012
						],
						[
							-80.05657999999993,
							26.745000000000125
						],
						[
							-80.05656480699992,
							26.74563541000012
						],
						[
							-80.05655835189766,
							26.745841617095607
						],
						[
							-80.05622904399993,
							26.74583161400019
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "West Palm Beach",
				"Name": "Old Northwood",
				"RegionID": "269119"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.50890218199993,
					30.287225955000054,
					-81.49483795499992,
					30.29579956600008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.50264890699994,
							30.287233010000083
						],
						[
							-81.50488296099991,
							30.287225955000054
						],
						[
							-81.50890218199993,
							30.295458729000075
						],
						[
							-81.49850864399991,
							30.29579956600008
						],
						[
							-81.49483795499992,
							30.287334956000056
						],
						[
							-81.4968019069999,
							30.287311010000053
						],
						[
							-81.49893390699992,
							30.28728901000005
						],
						[
							-81.50111190699994,
							30.287261010000066
						],
						[
							-81.50264890699994,
							30.287233010000083
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Park Ridge",
				"RegionID": "269135"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.14907796499995,
					25.99656800000008,
					-80.14268501799995,
					26.011644926000088
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.1430965969999,
							26.011644926000088
						],
						[
							-80.14268501799995,
							25.99674579200007
						],
						[
							-80.14286699999991,
							25.996668000000057
						],
						[
							-80.14395799999994,
							25.99672000000004
						],
						[
							-80.14496699999995,
							25.99676800000009
						],
						[
							-80.14686699999993,
							25.996668000000057
						],
						[
							-80.1478669999999,
							25.99656800000008
						],
						[
							-80.14846699999993,
							25.99656800000008
						],
						[
							-80.14861103599993,
							25.996623028000045
						],
						[
							-80.14907796499995,
							26.011464683000042
						],
						[
							-80.1430965969999,
							26.011644926000088
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Hollywood",
				"Name": "Park Side",
				"RegionID": "269136"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.07173399999994,
					26.644939983000086,
					-80.05859985599994,
					26.66600607600009
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.06571999999994,
							26.665790000000072
						],
						[
							-80.06517995299993,
							26.665780001000087
						],
						[
							-80.06492035699995,
							26.665785409000083
						],
						[
							-80.0646999999999,
							26.665790000000072
						],
						[
							-80.06430588199993,
							26.665817497000038
						],
						[
							-80.06414282899993,
							26.665828872000077
						],
						[
							-80.06382059399994,
							26.66584079900008
						],
						[
							-80.06373284499995,
							26.665844047000064
						],
						[
							-80.06365999999991,
							26.66584000000006
						],
						[
							-80.0636720569999,
							26.665698331000044
						],
						[
							-80.06369417299993,
							26.66543846500008
						],
						[
							-80.06371167499992,
							26.665232822000064
						],
						[
							-80.06372504099996,
							26.665075767000076
						],
						[
							-80.06373253899994,
							26.66498766600006
						],
						[
							-80.06373999999994,
							26.664900000000046
						],
						[
							-80.06354140099995,
							26.664895587000046
						],
						[
							-80.06328999999994,
							26.66489000000007
						],
						[
							-80.0626266139999,
							26.664866308000057
						],
						[
							-80.06213375199991,
							26.664848705000054
						],
						[
							-80.06182108699994,
							26.664837539000075
						],
						[
							-80.06160999999992,
							26.66483000000005
						],
						[
							-80.0608516499999,
							26.664810679000084
						],
						[
							-80.06041500899994,
							26.66479955400007
						],
						[
							-80.0600399999999,
							26.66479000000004
						],
						[
							-80.0594457439999,
							26.664770025000053
						],
						[
							-80.0591179619999,
							26.664759007000043
						],
						[
							-80.05884999999995,
							26.664750000000083
						],
						[
							-80.05874880899995,
							26.664745181000058
						],
						[
							-80.05868204699993,
							26.664740522000045
						],
						[
							-80.05869890799994,
							26.664503637000053
						],
						[
							-80.05869890799994,
							26.663801636000073
						],
						[
							-80.05869890799994,
							26.66300063600005
						],
						[
							-80.05869890799994,
							26.66229863600006
						],
						[
							-80.05859985599994,
							26.66159663700006
						],
						[
							-80.05868090899992,
							26.660921637000058
						],
						[
							-80.05869890799994,
							26.660795636000046
						],
						[
							-80.05869890899993,
							26.660201636000068
						],
						[
							-80.0587979089999,
							26.659400636000047
						],
						[
							-80.0587979089999,
							26.658698636000057
						],
						[
							-80.0587979089999,
							26.65817011300004
						],
						[
							-80.0587979089999,
							26.657897636000087
						],
						[
							-80.0587979089999,
							26.65719563600004
						],
						[
							-80.0587979089999,
							26.65702931900006
						],
						[
							-80.0587979089999,
							26.65499963600007
						],
						[
							-80.05889690899994,
							26.653496636000057
						],
						[
							-80.05910390899993,
							26.645801636000044
						],
						[
							-80.05910390999992,
							26.645252493000044
						],
						[
							-80.05910391099991,
							26.644939983000086
						],
						[
							-80.06476299999991,
							26.645144000000073
						],
						[
							-80.06696399999993,
							26.646144000000053
						],
						[
							-80.06706199999991,
							26.64644100000004
						],
						[
							-80.06746699999991,
							26.64664300000004
						],
						[
							-80.06822499999994,
							26.647526000000088
						],
						[
							-80.06865354799993,
							26.64805461900005
						],
						[
							-80.06878599999995,
							26.648218000000043
						],
						[
							-80.06876399999993,
							26.648318000000074
						],
						[
							-80.0688659999999,
							26.649306000000085
						],
						[
							-80.06901699999992,
							26.64991600000008
						],
						[
							-80.06915499999991,
							26.650559000000044
						],
						[
							-80.06966099999994,
							26.65195200000005
						],
						[
							-80.06991399999994,
							26.652810000000045
						],
						[
							-80.0703959999999,
							26.655119000000074
						],
						[
							-80.07042799999995,
							26.65527600000007
						],
						[
							-80.07044599999995,
							26.655369000000064
						],
						[
							-80.07101099999994,
							26.658456000000058
						],
						[
							-80.0714465179999,
							26.660786096000038
						],
						[
							-80.07160499999992,
							26.66163400000005
						],
						[
							-80.07164999999992,
							26.662310000000048
						],
						[
							-80.07172199999991,
							26.663425000000075
						],
						[
							-80.07173399999994,
							26.664041000000054
						],
						[
							-80.07170599999995,
							26.664580000000058
						],
						[
							-80.07165953499992,
							26.665257057000076
						],
						[
							-80.07160813199994,
							26.66600607600009
						],
						[
							-80.07160802499995,
							26.666006072000073
						],
						[
							-80.07051875099995,
							26.665967205000072
						],
						[
							-80.06934415899993,
							26.665921834000073
						],
						[
							-80.06871648999993,
							26.665897590000043
						],
						[
							-80.06851999999992,
							26.665890000000047
						],
						[
							-80.06819773099994,
							26.665879929000084
						],
						[
							-80.06729676399993,
							26.66584871400005
						],
						[
							-80.0667776109999,
							26.665829767000048
						],
						[
							-80.0666407569999,
							26.665824772000065
						],
						[
							-80.06650999999994,
							26.665820000000053
						],
						[
							-80.06619029599995,
							26.66580785900004
						],
						[
							-80.06590397699995,
							26.66579698600009
						],
						[
							-80.06571999999994,
							26.665790000000072
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "West Palm Beach",
				"Name": "Parker Ridge",
				"RegionID": "269137"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.5619100529999,
					30.390106678000055,
					-81.45268750199995,
					30.464956012000073
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.5327679099999,
							30.459030013000074
						],
						[
							-81.53253890999991,
							30.45902301200005
						],
						[
							-81.53211090999991,
							30.459035012000076
						],
						[
							-81.52976990999991,
							30.45910301200007
						],
						[
							-81.5280909089999,
							30.459152013000054
						],
						[
							-81.52741990999994,
							30.459179012000046
						],
						[
							-81.52710690999993,
							30.459183012000036
						],
						[
							-81.52664890999995,
							30.45920901200009
						],
						[
							-81.52653490999995,
							30.459208012000094
						],
						[
							-81.52629090999994,
							30.459175012000063
						],
						[
							-81.52177390899993,
							30.458414012000052
						],
						[
							-81.52091590899994,
							30.458250013000054
						],
						[
							-81.5205689089999,
							30.458168012000044
						],
						[
							-81.52035590999992,
							30.458100012000042
						],
						[
							-81.5200499099999,
							30.45798601200005
						],
						[
							-81.51947890999992,
							30.457745013000082
						],
						[
							-81.51911990999992,
							30.457630012000042
						],
						[
							-81.51886690999993,
							30.45756201300009
						],
						[
							-81.51844190899993,
							30.457481013000063
						],
						[
							-81.51805590999993,
							30.457470013000087
						],
						[
							-81.51780291099993,
							30.457470013000087
						],
						[
							-81.51744390899995,
							30.45749301300009
						],
						[
							-81.51707190899992,
							30.457539012000037
						],
						[
							-81.5154369089999,
							30.457848012000056
						],
						[
							-81.51422690899994,
							30.458054013000037
						],
						[
							-81.5132959099999,
							30.45823801200004
						],
						[
							-81.51317690999991,
							30.458249013000056
						],
						[
							-81.51166090999993,
							30.45853601200008
						],
						[
							-81.51144390999991,
							30.458576012000037
						],
						[
							-81.51045190999992,
							30.45877301200005
						],
						[
							-81.5090819099999,
							30.45903501300006
						],
						[
							-81.50854490899991,
							30.45913701200004
						],
						[
							-81.5022659089999,
							30.460367012000063
						],
						[
							-81.50221290999991,
							30.46037701300008
						],
						[
							-81.49548290999991,
							30.461668013000065
						],
						[
							-81.49492590999995,
							30.461782013000064
						],
						[
							-81.49325590899991,
							30.462091012000087
						],
						[
							-81.4929899089999,
							30.46212001300006
						],
						[
							-81.49259190899994,
							30.462175013000035
						],
						[
							-81.49169190899995,
							30.462259012000064
						],
						[
							-81.4909379099999,
							30.462303012000067
						],
						[
							-81.49063890899993,
							30.46231701200008
						],
						[
							-81.48980690999991,
							30.462315012000094
						],
						[
							-81.4883959089999,
							30.462242012000047
						],
						[
							-81.48778490999992,
							30.462179012000032
						],
						[
							-81.4874039099999,
							30.462132013000087
						],
						[
							-81.4862979099999,
							30.461969012000054
						],
						[
							-81.48583990899994,
							30.46188901200009
						],
						[
							-81.48532090999993,
							30.461811012000055
						],
						[
							-81.48473390999993,
							30.461712012000074
						],
						[
							-81.48291790999991,
							30.46142401200007
						],
						[
							-81.48083490999994,
							30.46110201200008
						],
						[
							-81.47856090899995,
							30.46072801300005
						],
						[
							-81.47770690999995,
							30.46060801200008
						],
						[
							-81.47739990999992,
							30.460557012000038
						],
						[
							-81.47635693799992,
							30.460390018000055
						],
						[
							-81.47450890999994,
							30.460106013000086
						],
						[
							-81.4743269089999,
							30.46007901200005
						],
						[
							-81.47411290899993,
							30.460051012000065
						],
						[
							-81.47325090999993,
							30.459890013000063
						],
						[
							-81.47286990999993,
							30.459803012000066
						],
						[
							-81.47244990999991,
							30.459677012000043
						],
						[
							-81.47186290999991,
							30.459473012000046
						],
						[
							-81.47133590999994,
							30.459261012000074
						],
						[
							-81.47123691099995,
							30.45920601300008
						],
						[
							-81.47097790999993,
							30.45908401200006
						],
						[
							-81.4705659089999,
							30.45886001200006
						],
						[
							-81.47007790899994,
							30.45856301300006
						],
						[
							-81.46963490999991,
							30.458256013000042
						],
						[
							-81.4693449099999,
							30.458025012000064
						],
						[
							-81.46916990999995,
							30.457890012000064
						],
						[
							-81.46888790899993,
							30.457621012000065
						],
						[
							-81.4686739089999,
							30.457424012000047
						],
						[
							-81.46829190999995,
							30.457016012000057
						],
						[
							-81.4681549089999,
							30.45686501300008
						],
						[
							-81.46786490999995,
							30.456491012000075
						],
						[
							-81.46766690999993,
							30.456198012000073
						],
						[
							-81.46742990999991,
							30.455822012000056
						],
						[
							-81.46724690899993,
							30.45550301300005
						],
						[
							-81.46591890899992,
							30.453058012000042
						],
						[
							-81.46584290899995,
							30.452927013000075
						],
						[
							-81.46578190899993,
							30.45279701200008
						],
						[
							-81.46571390999992,
							30.452677012000038
						],
						[
							-81.46563690999994,
							30.45249601300009
						],
						[
							-81.46556090999991,
							30.452358012000047
						],
						[
							-81.46547690999995,
							30.45216201300008
						],
						[
							-81.46530891099991,
							30.45172501200005
						],
						[
							-81.46527090899991,
							30.451567012000055
						],
						[
							-81.46521790999992,
							30.451424012000075
						],
						[
							-81.46505690999993,
							30.45075001200007
						],
						[
							-81.4641269089999,
							30.446171012000036
						],
						[
							-81.46383702799994,
							30.444735862000073
						],
						[
							-81.4620799999999,
							30.44488700000005
						],
						[
							-81.45997212799995,
							30.444383381000083
						],
						[
							-81.45994344499991,
							30.444318131000045
						],
						[
							-81.45992066199994,
							30.444250594000035
						],
						[
							-81.4599039599999,
							30.444181303000054
						],
						[
							-81.45989346899995,
							30.44411080300006
						],
						[
							-81.45988927299993,
							30.444039651000086
						],
						[
							-81.45989140499995,
							30.443968406000067
						],
						[
							-81.45922117399994,
							30.44451547500006
						],
						[
							-81.45793715499991,
							30.44442291000007
						],
						[
							-81.45557381399993,
							30.443891158000046
						],
						[
							-81.45403764199995,
							30.442975363000073
						],
						[
							-81.45312184699992,
							30.442148194000087
						],
						[
							-81.45269305099993,
							30.441760277000068
						],
						[
							-81.45268750199995,
							30.44168756700009
						],
						[
							-81.45268840999995,
							30.441614652000055
						],
						[
							-81.4526957679999,
							30.441542103000074
						],
						[
							-81.45270951799995,
							30.441470490000086
						],
						[
							-81.45272955299993,
							30.441400376000043
						],
						[
							-81.45275571499991,
							30.441332309000074
						],
						[
							-81.45280262499995,
							30.441224872000078
						],
						[
							-81.4530622289999,
							30.440588617000063
						],
						[
							-81.45311416399994,
							30.440483339000078
						],
						[
							-81.4531861879999,
							30.440376946000068
						],
						[
							-81.45420418799995,
							30.43908294500005
						],
						[
							-81.45422207899993,
							30.43906092700007
						],
						[
							-81.45433292699994,
							30.43895007900005
						],
						[
							-81.45446133899992,
							30.438860164000065
						],
						[
							-81.4546034139999,
							30.43879391400009
						],
						[
							-81.45465604399993,
							30.438779811000074
						],
						[
							-81.45465875699995,
							30.438712403000068
						],
						[
							-81.45466654699993,
							30.43864539100008
						],
						[
							-81.4546793689999,
							30.43857915800004
						],
						[
							-81.4546971499999,
							30.438514080000065
						],
						[
							-81.45471978899991,
							30.438450529000082
						],
						[
							-81.45635078899994,
							30.43436552900005
						],
						[
							-81.45640716399993,
							30.434249339000072
						],
						[
							-81.45649707899992,
							30.434120927000038
						],
						[
							-81.45660792699994,
							30.434010079000075
						],
						[
							-81.45673633899992,
							30.433920164000085
						],
						[
							-81.4568441049999,
							30.433867202000044
						],
						[
							-81.45895327499994,
							30.433000267000068
						],
						[
							-81.45899356899992,
							30.43177492500007
						],
						[
							-81.45719527699993,
							30.43083746700006
						],
						[
							-81.45716133899992,
							30.43081883600007
						],
						[
							-81.45703292699994,
							30.43072892100008
						],
						[
							-81.45692207999993,
							30.430618073000062
						],
						[
							-81.45683216499992,
							30.430489661000085
						],
						[
							-81.45677825799993,
							30.430374057000048
						],
						[
							-81.45611180399993,
							30.427006013000035
						],
						[
							-81.45528913999993,
							30.42289269500009
						],
						[
							-81.45496007499992,
							30.420013373000074
						],
						[
							-81.45438420999994,
							30.41631138600008
						],
						[
							-81.45454874299992,
							30.41540645600009
						],
						[
							-81.45482471399993,
							30.414830016000053
						],
						[
							-81.4597630259999,
							30.40971533600009
						],
						[
							-81.45983192699993,
							30.409651080000064
						],
						[
							-81.4599603389999,
							30.40956116500007
						],
						[
							-81.46010241399995,
							30.409494914000053
						],
						[
							-81.4602538339999,
							30.409454341000075
						],
						[
							-81.46040999999991,
							30.409440678000067
						],
						[
							-81.46056616499993,
							30.409454341000075
						],
						[
							-81.46065706199994,
							30.409475281000088
						],
						[
							-81.46350088199996,
							30.410287800000045
						],
						[
							-81.46345698699992,
							30.41022748900008
						],
						[
							-81.4634184709999,
							30.41016360800006
						],
						[
							-81.46338562199992,
							30.410096637000038
						],
						[
							-81.46335868699992,
							30.410027077000056
						],
						[
							-81.4633378659999,
							30.409955448000062
						],
						[
							-81.46314774199993,
							30.40918494500005
						],
						[
							-81.46213645199992,
							30.405066127000055
						],
						[
							-81.46096616099993,
							30.40108403600004
						],
						[
							-81.4606744699999,
							30.400585151000087
						],
						[
							-81.46064458599994,
							30.400599086000057
						],
						[
							-81.46050248199992,
							30.40063796600009
						],
						[
							-81.46008048199991,
							30.400716966000065
						],
						[
							-81.4600474099999,
							30.400722521000038
						],
						[
							-81.45978540899995,
							30.400761521000053
						],
						[
							-81.45972422999995,
							30.40076849700006
						],
						[
							-81.45957307599991,
							30.400780506000046
						],
						[
							-81.45945477099991,
							30.400876413000052
						],
						[
							-81.45932684899994,
							30.400994495000077
						],
						[
							-81.45922757499994,
							30.40109002400004
						],
						[
							-81.4591769939999,
							30.40113515100006
						],
						[
							-81.45912315899994,
							30.401176339000074
						],
						[
							-81.45906637399992,
							30.40121335600009
						],
						[
							-81.45900696199993,
							30.401245991000057
						],
						[
							-81.45894526099994,
							30.40127405800007
						],
						[
							-81.45872826099992,
							30.401363059000065
						],
						[
							-81.45869458599992,
							30.401376087000074
						],
						[
							-81.45854316599991,
							30.40141666000005
						],
						[
							-81.4583869999999,
							30.401430322000067
						],
						[
							-81.45823083399995,
							30.40141666000005
						],
						[
							-81.45807941399994,
							30.401376087000074
						],
						[
							-81.45793478799993,
							30.40130818600005
						],
						[
							-81.4578805079999,
							30.401330001000076
						],
						[
							-81.45781610599994,
							30.401356262000036
						],
						[
							-81.4577498669999,
							30.401377466000042
						],
						[
							-81.45768218699993,
							30.401393489000046
						],
						[
							-81.45761347199993,
							30.40140423400004
						],
						[
							-81.45744247199991,
							30.401424234000046
						],
						[
							-81.45733799999994,
							30.401430322000067
						],
						[
							-81.45718183499991,
							30.40141666000005
						],
						[
							-81.45703041399992,
							30.401376087000074
						],
						[
							-81.45688833899993,
							30.401309836000053
						],
						[
							-81.45675992699995,
							30.401219921000067
						],
						[
							-81.45664907999992,
							30.40110907400009
						],
						[
							-81.4565010789999,
							30.398083927000073
						],
						[
							-81.45657769199995,
							30.398007314000036
						],
						[
							-81.4565470689999,
							30.39793870900007
						],
						[
							-81.45652256599993,
							30.397867688000076
						],
						[
							-81.45650437099994,
							30.39779479600008
						],
						[
							-81.4564926239999,
							30.397720591000052
						],
						[
							-81.45648741399992,
							30.397645642000043
						],
						[
							-81.45648878199995,
							30.397570526000038
						],
						[
							-81.45649671599995,
							30.397495817000053
						],
						[
							-81.45651771699994,
							30.397348817000083
						],
						[
							-81.45653011299993,
							30.397280819000056
						],
						[
							-81.45654769599992,
							30.397213975000057
						],
						[
							-81.45657035999994,
							30.39714867800006
						],
						[
							-81.45659797199994,
							30.397085315000087
						],
						[
							-81.45663036799994,
							30.397024260000077
						],
						[
							-81.45666735799995,
							30.396965872000063
						],
						[
							-81.4567087229999,
							30.396910498000068
						],
						[
							-81.4568017229999,
							30.396795499000064
						],
						[
							-81.4568845309999,
							30.396706212000083
						],
						[
							-81.45980237799996,
							30.393959124000048
						],
						[
							-81.46347227299992,
							30.390415087000065
						],
						[
							-81.46352792899997,
							30.390365625000072
						],
						[
							-81.46358748699993,
							30.390320935000094
						],
						[
							-81.46365053699992,
							30.39028132600004
						],
						[
							-81.46371664799995,
							30.390247069000058
						],
						[
							-81.4637853669999,
							30.390218398000062
						],
						[
							-81.4638562209999,
							30.390195510000066
						],
						[
							-81.46392872599995,
							30.390178561000084
						],
						[
							-81.46422877999993,
							30.390121451000084
						],
						[
							-81.46439099999992,
							30.390106678000055
						],
						[
							-81.4644808889999,
							30.39011118200005
						],
						[
							-81.46491888899993,
							30.39015518100007
						],
						[
							-81.4649965939999,
							30.39016643200006
						],
						[
							-81.46507302099991,
							30.390184417000057
						],
						[
							-81.46514758799992,
							30.390208999000038
						],
						[
							-81.46521972699993,
							30.39023999200009
						],
						[
							-81.46528888799992,
							30.39027715800006
						],
						[
							-81.46535454299995,
							30.39032021600008
						],
						[
							-81.46792531199992,
							30.39217151700007
						],
						[
							-81.46994736799991,
							30.392968341000085
						],
						[
							-81.47416923399993,
							30.394287612000085
						],
						[
							-81.47425716599992,
							30.394320212000082
						],
						[
							-81.47598216499995,
							30.39506421200008
						],
						[
							-81.47607566099992,
							30.39511116400007
						],
						[
							-81.4762040729999,
							30.39520107900006
						],
						[
							-81.47631491999994,
							30.39531192700008
						],
						[
							-81.47640483499993,
							30.395440339000057
						],
						[
							-81.47647108599995,
							30.395582413000053
						],
						[
							-81.47651165899993,
							30.39573383400006
						],
						[
							-81.47652532199993,
							30.395890000000065
						],
						[
							-81.47651165899993,
							30.396046165000083
						],
						[
							-81.47647108599995,
							30.39619758600009
						],
						[
							-81.47640483499993,
							30.39633966100007
						],
						[
							-81.47631491999994,
							30.396468073000054
						],
						[
							-81.4762040729999,
							30.39657892000008
						],
						[
							-81.47607566099992,
							30.39666883500007
						],
						[
							-81.47593358599994,
							30.39673508600004
						],
						[
							-81.47578216499994,
							30.396775659000074
						],
						[
							-81.47562599999992,
							30.396789322000075
						],
						[
							-81.47549442999991,
							30.396779645000038
						],
						[
							-81.47418756499992,
							30.39658637300005
						],
						[
							-81.47482055799992,
							30.39699595600007
						],
						[
							-81.47487022199994,
							30.397030516000086
						],
						[
							-81.47579522199993,
							30.39772151600005
						],
						[
							-81.47584748499992,
							30.397763689000044
						],
						[
							-81.47620760899991,
							30.39807718500009
						],
						[
							-81.47704749099995,
							30.397841992000053
						],
						[
							-81.47713383399991,
							30.39782234100005
						],
						[
							-81.47728999999993,
							30.397808678000047
						],
						[
							-81.47744616599994,
							30.39782234100005
						],
						[
							-81.47759758599994,
							30.397862914000086
						],
						[
							-81.47773966099993,
							30.397929164000065
						],
						[
							-81.47786807299991,
							30.39801907900005
						],
						[
							-81.47796085599992,
							30.39810905700006
						],
						[
							-81.47893492599991,
							30.399200082000053
						],
						[
							-81.47897810199993,
							30.399198355000067
						],
						[
							-81.47963861599993,
							30.399099318000086
						],
						[
							-81.48059013899991,
							30.39873201600005
						],
						[
							-81.48069677399991,
							30.39869830700007
						],
						[
							-81.48138777399993,
							30.398526307000054
						],
						[
							-81.48151935399994,
							30.39850376600009
						],
						[
							-81.48207335299992,
							30.398450765000067
						],
						[
							-81.48215899999991,
							30.398446678000088
						],
						[
							-81.48226248299994,
							30.39845265100007
						],
						[
							-81.4842015129999,
							30.39867726300008
						],
						[
							-81.48510976499995,
							30.398211695000043
						],
						[
							-81.48521412699996,
							30.398166292000045
						],
						[
							-81.48693112699993,
							30.397545292000075
						],
						[
							-81.48708083399993,
							30.39750534100006
						],
						[
							-81.48720281699991,
							30.397492328000055
						],
						[
							-81.48882954999993,
							30.39743045200004
						],
						[
							-81.49016831599994,
							30.39736977700005
						],
						[
							-81.49099267699995,
							30.39728449800009
						],
						[
							-81.49145510799991,
							30.397184948000074
						],
						[
							-81.49203648999992,
							30.396965415000068
						],
						[
							-81.49207754399993,
							30.39663508600006
						],
						[
							-81.4920878929999,
							30.39657087900008
						],
						[
							-81.49210285499993,
							30.396507588000077
						],
						[
							-81.4921223529999,
							30.396445544000077
						],
						[
							-81.4921462829999,
							30.396385071000054
						],
						[
							-81.49218454599992,
							30.396297746000073
						],
						[
							-81.49097841499992,
							30.396712455000056
						],
						[
							-81.49084563399992,
							30.396747041000083
						],
						[
							-81.48852263399993,
							30.397166040000062
						],
						[
							-81.48840484599992,
							30.39717934800007
						],
						[
							-81.48707384699992,
							30.397241348000076
						],
						[
							-81.48695484399991,
							30.397239006000063
						],
						[
							-81.48642470499993,
							30.397193355000073
						],
						[
							-81.4857048799999,
							30.39744129500008
						],
						[
							-81.48556816599995,
							30.397476659000063
						],
						[
							-81.48554485999995,
							30.39748045400006
						],
						[
							-81.48490885899992,
							30.397575454000048
						],
						[
							-81.4847759999999,
							30.397585322000054
						],
						[
							-81.48461398299992,
							30.397570588000068
						],
						[
							-81.48440813199994,
							30.397531516000075
						],
						[
							-81.48426841399993,
							30.397493087000043
						],
						[
							-81.4841252519999,
							30.397426206000034
						],
						[
							-81.48397616499994,
							30.397339576000036
						],
						[
							-81.48384992699994,
							30.39725092100008
						],
						[
							-81.48373907899992,
							30.39714007300006
						],
						[
							-81.48364916399993,
							30.39701166100008
						],
						[
							-81.4835829139999,
							30.396869586000033
						],
						[
							-81.48354234099992,
							30.39671816600009
						],
						[
							-81.48352867799991,
							30.396562000000074
						],
						[
							-81.48354234099992,
							30.396405834000063
						],
						[
							-81.4835829139999,
							30.396254414000058
						],
						[
							-81.48360686899991,
							30.396195225000042
						],
						[
							-81.48367386899992,
							30.396045226000073
						],
						[
							-81.48370527799995,
							30.395981745000086
						],
						[
							-81.48374158599995,
							30.39592093300007
						],
						[
							-81.48378256599995,
							30.395863167000076
						],
						[
							-81.48382796499993,
							30.39580880500006
						],
						[
							-81.48387750199993,
							30.395758184000044
						],
						[
							-81.48403950099993,
							30.395605183000043
						],
						[
							-81.48409270699995,
							30.39555874700005
						],
						[
							-81.48414939299994,
							30.395516628000056
						],
						[
							-81.48420920799992,
							30.39547908700007
						],
						[
							-81.48427178499992,
							30.39544635600004
						],
						[
							-81.48433673699992,
							30.395418635000055
						],
						[
							-81.4844036639999,
							30.39539609700006
						],
						[
							-81.4857285679999,
							30.395007125000063
						],
						[
							-81.48997773199994,
							30.393758643000066
						],
						[
							-81.49475399099993,
							30.392418132000046
						],
						[
							-81.4948805759999,
							30.392392246000043
						],
						[
							-81.49664221099994,
							30.392162254000088
						],
						[
							-81.49831041899995,
							30.39179654000009
						],
						[
							-81.49846479799993,
							30.391776490000044
						],
						[
							-81.49905279799992,
							30.391751489000054
						],
						[
							-81.49915912299991,
							30.39175326100008
						],
						[
							-81.5019761229999,
							30.391967261000048
						],
						[
							-81.50206416499992,
							30.391978340000037
						],
						[
							-81.50221558599992,
							30.392018913000072
						],
						[
							-81.5023576609999,
							30.392085164000033
						],
						[
							-81.50248607299994,
							30.392175079000086
						],
						[
							-81.50258316499992,
							30.39226991800007
						],
						[
							-81.50482516499994,
							30.394817919000047
						],
						[
							-81.50486682899992,
							30.394868920000075
						],
						[
							-81.50490464899991,
							30.394922834000056
						],
						[
							-81.50493842299994,
							30.394979370000044
						],
						[
							-81.50496796899995,
							30.395038227000047
						],
						[
							-81.50874696999995,
							30.403308227000082
						],
						[
							-81.50877408699996,
							30.40337441400004
						],
						[
							-81.50881465999993,
							30.403525834000046
						],
						[
							-81.50882832199994,
							30.40368200000006
						],
						[
							-81.50881465999993,
							30.40383816600007
						],
						[
							-81.50877408699996,
							30.403989586000076
						],
						[
							-81.50870783599993,
							30.404131661000065
						],
						[
							-81.50863705099994,
							30.40423647700004
						],
						[
							-81.50803680399991,
							30.405002975000063
						],
						[
							-81.50633851799995,
							30.407541996000077
						],
						[
							-81.50627991999994,
							30.407620073000093
						],
						[
							-81.50622207099991,
							30.407682726000075
						],
						[
							-81.50496107099991,
							30.40892472500008
						],
						[
							-81.50490807299991,
							30.408972921000043
						],
						[
							-81.5047783789999,
							30.409063573000083
						],
						[
							-81.50459209699994,
							30.40917031100008
						],
						[
							-81.5045318089999,
							30.409201886000062
						],
						[
							-81.50446930599992,
							30.409228812000038
						],
						[
							-81.50440494599991,
							30.40925093500005
						],
						[
							-81.50433909799995,
							30.409268127000075
						],
						[
							-81.50427213699993,
							30.409280290000083
						],
						[
							-81.50420444899993,
							30.409287355000064
						],
						[
							-81.50340444999995,
							30.409340355000044
						],
						[
							-81.50334499999991,
							30.40934232200004
						],
						[
							-81.50318883499995,
							30.40932865900004
						],
						[
							-81.50303741399995,
							30.40928808600006
						],
						[
							-81.5028953389999,
							30.409221836000086
						],
						[
							-81.50276692699993,
							30.409131921000043
						],
						[
							-81.50265607999995,
							30.40902107300008
						],
						[
							-81.50256616499992,
							30.408892661000042
						],
						[
							-81.50249991399994,
							30.408750586000053
						],
						[
							-81.5024881089999,
							30.408715977000046
						],
						[
							-81.50243000599995,
							30.408533590000047
						],
						[
							-81.50162923899991,
							30.40930334700005
						],
						[
							-81.50158471599991,
							30.40934498000007
						],
						[
							-81.5015368839999,
							30.40938276500009
						],
						[
							-81.50148607199992,
							30.40941643700006
						],
						[
							-81.5014326349999,
							30.40944576400005
						],
						[
							-81.50137694299991,
							30.40947054200007
						],
						[
							-81.50196857999993,
							30.40940844000005
						],
						[
							-81.50204807299991,
							30.40940377100009
						],
						[
							-81.50212766699993,
							30.409406153000077
						],
						[
							-81.50220673899992,
							30.40941556600006
						],
						[
							-81.5022846679999,
							30.409431936000086
						],
						[
							-81.50236084399995,
							30.40945513600008
						],
						[
							-81.50243466799992,
							30.409484983000084
						],
						[
							-81.50392766899995,
							30.410166983000064
						],
						[
							-81.5040036609999,
							30.410206165000087
						],
						[
							-81.50413207299994,
							30.410296080000084
						],
						[
							-81.5042429209999,
							30.410406927000054
						],
						[
							-81.50433283599995,
							30.41053533900003
						],
						[
							-81.50439908599992,
							30.410677414000077
						],
						[
							-81.5044396589999,
							30.410828835000075
						],
						[
							-81.5044533219999,
							30.41098500000004
						],
						[
							-81.5044396589999,
							30.41114116600005
						],
						[
							-81.50443079799993,
							30.411185014000072
						],
						[
							-81.50434479799992,
							30.411562013000037
						],
						[
							-81.50432419699992,
							30.411637149000057
						],
						[
							-81.50429716899993,
							30.411710221000074
						],
						[
							-81.50426391999991,
							30.41178067900006
						],
						[
							-81.50422469599994,
							30.411847994000084
						],
						[
							-81.50400061099994,
							30.41219689600007
						],
						[
							-81.50348202999993,
							30.41438260900009
						],
						[
							-81.50346064599995,
							30.414457962000085
						],
						[
							-81.50292564699993,
							30.41607196200005
						],
						[
							-81.50291708599991,
							30.416096586000037
						],
						[
							-81.50285083599994,
							30.416238661000083
						],
						[
							-81.50276092099995,
							30.41636707300006
						],
						[
							-81.50265007299993,
							30.416477920000087
						],
						[
							-81.50252166099995,
							30.416567835000084
						],
						[
							-81.5023795859999,
							30.416634086000045
						],
						[
							-81.50222816599995,
							30.41667465900008
						],
						[
							-81.50207199999994,
							30.416688322000088
						],
						[
							-81.50194811599994,
							30.416679748000032
						],
						[
							-81.50149742499991,
							30.41661706600007
						],
						[
							-81.50204687299993,
							30.417124065000053
						],
						[
							-81.50206234199993,
							30.417138682000086
						],
						[
							-81.50255534199994,
							30.417615682000076
						],
						[
							-81.5026094179999,
							30.417672787000072
						],
						[
							-81.50265829699993,
							30.41773439900004
						],
						[
							-81.50270160699995,
							30.41780004400005
						],
						[
							-81.50273901599991,
							30.417869223000082
						],
						[
							-81.50277023799994,
							30.417941406000068
						],
						[
							-81.50295466199992,
							30.418424909000066
						],
						[
							-81.50297930099993,
							30.41850122300008
						],
						[
							-81.50299704199995,
							30.418579428000044
						],
						[
							-81.50300774399994,
							30.41865890400004
						],
						[
							-81.5030113219999,
							30.418739016000078
						],
						[
							-81.50300774699993,
							30.418819129000045
						],
						[
							-81.50299704799994,
							30.418898605000038
						],
						[
							-81.50297930999994,
							30.418976811000054
						],
						[
							-81.50268804699994,
							30.42003906300005
						],
						[
							-81.50220403599991,
							30.42338090700008
						],
						[
							-81.50219965999992,
							30.423408166000055
						],
						[
							-81.50215908699994,
							30.423559586000067
						],
						[
							-81.50209283599992,
							30.423701661000056
						],
						[
							-81.50200292099993,
							30.423830073000094
						],
						[
							-81.50189207299991,
							30.423940921000053
						],
						[
							-81.5018601559999,
							30.42396648800008
						],
						[
							-81.49915215599992,
							30.42603648900007
						],
						[
							-81.49905566099994,
							30.426100836000046
						],
						[
							-81.4989135859999,
							30.42616708600008
						],
						[
							-81.4987621649999,
							30.426207659000056
						],
						[
							-81.49860599999994,
							30.426221322000057
						],
						[
							-81.49844983399993,
							30.426207659000056
						],
						[
							-81.4984076749999,
							30.426199182000065
						],
						[
							-81.49731195499993,
							30.425951448000035
						],
						[
							-81.49707226699991,
							30.426304822000077
						],
						[
							-81.4970435489999,
							30.426342830000067
						],
						[
							-81.49721490199994,
							30.426311052000074
						],
						[
							-81.49737499999992,
							30.42629667800009
						],
						[
							-81.49753116599993,
							30.42631034100009
						],
						[
							-81.49768258699993,
							30.426350914000068
						],
						[
							-81.49782466099992,
							30.426417165000093
						],
						[
							-81.49795307399995,
							30.42650708000008
						],
						[
							-81.49805648099994,
							30.42660917500007
						],
						[
							-81.49809120099991,
							30.426649551000086
						],
						[
							-81.49818483599996,
							30.42678233900006
						],
						[
							-81.49825108599993,
							30.426924414000037
						],
						[
							-81.4982916589999,
							30.42707583400005
						],
						[
							-81.49830532199991,
							30.427232000000064
						],
						[
							-81.4982916589999,
							30.427388166000068
						],
						[
							-81.49825108599993,
							30.42753958600008
						],
						[
							-81.49818483599996,
							30.42768166100007
						],
						[
							-81.4980949209999,
							30.427810073000046
						],
						[
							-81.49799886599993,
							30.42790823300004
						],
						[
							-81.49795388199995,
							30.427947671000084
						],
						[
							-81.49793461399992,
							30.427981307000042
						],
						[
							-81.49784392099991,
							30.42811107300008
						],
						[
							-81.49780279999993,
							30.42815680600006
						],
						[
							-81.49775079999995,
							30.428210807000085
						],
						[
							-81.49768107299991,
							30.42827592100008
						],
						[
							-81.49760425699992,
							30.42832970800003
						],
						[
							-81.49743966199992,
							30.42848571600007
						],
						[
							-81.49737260699993,
							30.428543289000064
						],
						[
							-81.49732080599995,
							30.428583517000053
						],
						[
							-81.49726394499993,
							30.42863965400005
						],
						[
							-81.49714610799992,
							30.42881252800004
						],
						[
							-81.49709191999995,
							30.428884073000063
						],
						[
							-81.49705443599993,
							30.428921558000066
						],
						[
							-81.49704772099994,
							30.428945061000036
						],
						[
							-81.49703944999993,
							30.42897055700007
						],
						[
							-81.49706792699993,
							30.42894207900008
						],
						[
							-81.49714143199992,
							30.428886560000077
						],
						[
							-81.4992704309999,
							30.427443560000086
						],
						[
							-81.49939474899992,
							30.42737302200004
						],
						[
							-81.50263249499994,
							30.42586236200009
						],
						[
							-81.50263466999992,
							30.42517721900009
						],
						[
							-81.5026126859999,
							30.42144164700005
						],
						[
							-81.50262634099994,
							30.421282835000056
						],
						[
							-81.50265523199994,
							30.42116563400009
						],
						[
							-81.5027372319999,
							30.42090863400006
						],
						[
							-81.50274891399994,
							30.420874414000078
						],
						[
							-81.50277203999991,
							30.42082253500007
						],
						[
							-81.50351199999994,
							30.421439000000078
						],
						[
							-81.50411208299994,
							30.421938933000035
						],
						[
							-81.50370084899993,
							30.42910914500004
						],
						[
							-81.50380690899993,
							30.429003012000067
						],
						[
							-81.50465391099993,
							30.428083016000073
						],
						[
							-81.50469190799993,
							30.42806201100007
						],
						[
							-81.50498190999991,
							30.427792012000054
						],
						[
							-81.50547790899992,
							30.427366015000075
						],
						[
							-81.50556188999991,
							30.42732592900006
						],
						[
							-81.50570691099995,
							30.427320013000045
						],
						[
							-81.50650790999993,
							30.42744101200009
						],
						[
							-81.50672090899991,
							30.42748101300009
						],
						[
							-81.50677492799991,
							30.42750196200007
						],
						[
							-81.50684407099993,
							30.42755892000008
						],
						[
							-81.50685090799993,
							30.427605013000065
						],
						[
							-81.50684390999993,
							30.427938012000084
						],
						[
							-81.50685091399993,
							30.427996016000066
						],
						[
							-81.50689691899993,
							30.428093020000066
						],
						[
							-81.50700390999992,
							30.428202012000042
						],
						[
							-81.5084759099999,
							30.429390012000056
						],
						[
							-81.50863590999995,
							30.42950601200005
						],
						[
							-81.50880390899994,
							30.42960901300006
						],
						[
							-81.50903290999992,
							30.429726013000046
						],
						[
							-81.50917790999995,
							30.42978501300007
						],
						[
							-81.51007090899992,
							30.43010301300006
						],
						[
							-81.51020790899992,
							30.430162013000086
						],
						[
							-81.51038390899993,
							30.430269013000043
						],
						[
							-81.51097090999991,
							30.430777012000075
						],
						[
							-81.51106990999995,
							30.430851012000062
						],
						[
							-81.51111590799992,
							30.430876010000077
						],
						[
							-81.5114749089999,
							30.430981012000075
						],
						[
							-81.51184090999993,
							30.43106301200004
						],
						[
							-81.51296990199995,
							30.43122310200005
						],
						[
							-81.5131379099999,
							30.43123101300006
						],
						[
							-81.51336691599994,
							30.43122710200004
						],
						[
							-81.51357290899995,
							30.43120401200008
						],
						[
							-81.51376290899992,
							30.431173013000038
						],
						[
							-81.51399188399996,
							30.43111792500008
						],
						[
							-81.5155939089999,
							30.430571013000073
						],
						[
							-81.51570091199994,
							30.430546013000082
						],
						[
							-81.51579291099995,
							30.430542013000036
						],
						[
							-81.51663190999994,
							30.430672012000063
						],
						[
							-81.51684590999993,
							30.430693011000077
						],
						[
							-81.5169659099999,
							30.43068601300007
						],
						[
							-81.51708990899994,
							30.430679012000038
						],
						[
							-81.51733390999993,
							30.430643013000065
						],
						[
							-81.51747090899995,
							30.430611013000092
						],
						[
							-81.51788290699996,
							30.430485014000055
						],
						[
							-81.51794390999993,
							30.43047901300008
						],
						[
							-81.51805090999994,
							30.43048501200008
						],
						[
							-81.51814290999994,
							30.430500013000085
						],
						[
							-81.51856990999994,
							30.43060501300005
						],
						[
							-81.5192409089999,
							30.43080101300006
						],
						[
							-81.52088890999994,
							30.43134301200007
						],
						[
							-81.52120990999993,
							30.43145601200007
						],
						[
							-81.52136990999992,
							30.431520013000068
						],
						[
							-81.52159090899994,
							30.431625013000087
						],
						[
							-81.52176690999994,
							30.431723013000067
						],
						[
							-81.5220109089999,
							30.431881013000062
						],
						[
							-81.52221690899995,
							30.43203701300007
						],
						[
							-81.52239191099994,
							30.432194013000075
						],
						[
							-81.5225979089999,
							30.43240901300004
						],
						[
							-81.52270490999992,
							30.432539014000042
						],
						[
							-81.52283490999991,
							30.43271401300007
						],
						[
							-81.52292590899992,
							30.43286301200004
						],
						[
							-81.52299490999991,
							30.433006013000064
						],
						[
							-81.52315490899991,
							30.433369013000064
						],
						[
							-81.5234509089999,
							30.43442801300006
						],
						[
							-81.52355190899993,
							30.434788012000073
						],
						[
							-81.52368891099991,
							30.435209013000073
						],
						[
							-81.52377291099992,
							30.435360011000057
						],
						[
							-81.52391790999991,
							30.435549011000035
						],
						[
							-81.5240549099999,
							30.43568601200008
						],
						[
							-81.52422291099992,
							30.435823012000075
						],
						[
							-81.52452090999992,
							30.436012013000038
						],
						[
							-81.52476490999994,
							30.43614201200006
						],
						[
							-81.5260159099999,
							30.43685701200008
						],
						[
							-81.5273209099999,
							30.437712012000073
						],
						[
							-81.52773290999994,
							30.43792201300005
						],
						[
							-81.53008290999992,
							30.438959012000055
						],
						[
							-81.53045690999994,
							30.439144012000042
						],
						[
							-81.53104390899995,
							30.439390013000036
						],
						[
							-81.53148690899991,
							30.439598013000083
						],
						[
							-81.53195190999992,
							30.439802012000087
						],
						[
							-81.53228790899993,
							30.439964012000072
						],
						[
							-81.53266890999993,
							30.440128013000052
						],
						[
							-81.5330889089999,
							30.440329013000053
						],
						[
							-81.53338590899995,
							30.440462013000054
						],
						[
							-81.53357690899992,
							30.44053801300004
						],
						[
							-81.53435490999993,
							30.44088901300006
						],
						[
							-81.53487390999993,
							30.441088012000076
						],
						[
							-81.53511790899995,
							30.441154012000084
						],
						[
							-81.53538690999994,
							30.441213012000052
						],
						[
							-81.53546890899992,
							30.44123101200006
						],
						[
							-81.53565990999994,
							30.44125601300004
						],
						[
							-81.53607889599994,
							30.44129404800009
						],
						[
							-81.5366439089999,
							30.441278013000044
						],
						[
							-81.54112990899995,
							30.441275013000052
						],
						[
							-81.54255690999992,
							30.441257013000037
						],
						[
							-81.54279290999995,
							30.44128401200004
						],
						[
							-81.54316690999991,
							30.441292012000076
						],
						[
							-81.54369390999994,
							30.441267012000086
						],
						[
							-81.54448690899994,
							30.441248012000074
						],
						[
							-81.54701190999992,
							30.44125901200005
						],
						[
							-81.54785190899992,
							30.441248012000074
						],
						[
							-81.54800390999992,
							30.44125401200006
						],
						[
							-81.54861490899992,
							30.44124201200009
						],
						[
							-81.54899590999992,
							30.441212013000037
						],
						[
							-81.55026190899991,
							30.441212012000054
						],
						[
							-81.55076590899995,
							30.441223012000084
						],
						[
							-81.55632790899996,
							30.44117501200009
						],
						[
							-81.55811296799993,
							30.441168014000084
						],
						[
							-81.55811290799994,
							30.444082011000035
						],
						[
							-81.5581279079999,
							30.45069101000007
						],
						[
							-81.55812090799992,
							30.45109401000008
						],
						[
							-81.5581279079999,
							30.45318001000004
						],
						[
							-81.55812090799992,
							30.453896011000044
						],
						[
							-81.55813590799994,
							30.45510901100005
						],
						[
							-81.55816690699993,
							30.455564010000042
						],
						[
							-81.55820481799992,
							30.45591902400008
						],
						[
							-81.55832690799991,
							30.45652601000006
						],
						[
							-81.55840290799995,
							30.456783011000084
						],
						[
							-81.55851690799994,
							30.457157010000056
						],
						[
							-81.55866190699994,
							30.45753501100006
						],
						[
							-81.55894490799994,
							30.45814701000006
						],
						[
							-81.5591929069999,
							30.458565010000086
						],
						[
							-81.55928990699994,
							30.458735011000044
						],
						[
							-81.5604249079999,
							30.46037601100005
						],
						[
							-81.5608309079999,
							30.46094501000005
						],
						[
							-81.5617660879999,
							30.462320144000046
						],
						[
							-81.5619100529999,
							30.462959130000062
						],
						[
							-81.56099390999992,
							30.46296701200004
						],
						[
							-81.56084890999995,
							30.46296801300008
						],
						[
							-81.56072590999992,
							30.462989013000087
						],
						[
							-81.56058590999993,
							30.46302401200006
						],
						[
							-81.5578109089999,
							30.46385201200008
						],
						[
							-81.5575149089999,
							30.46393401200004
						],
						[
							-81.55636390899991,
							30.464196012000055
						],
						[
							-81.55493090999994,
							30.464535013000045
						],
						[
							-81.55400887399992,
							30.46475401700008
						],
						[
							-81.55353990899994,
							30.46484801300005
						],
						[
							-81.55344590999994,
							30.464873011000066
						],
						[
							-81.5533069089999,
							30.46489501200006
						],
						[
							-81.55286390899995,
							30.464937012000068
						],
						[
							-81.55249790999994,
							30.464956012000073
						],
						[
							-81.55222290899991,
							30.464954012000078
						],
						[
							-81.55198690899994,
							30.464941013000043
						],
						[
							-81.55160490899993,
							30.464903013000082
						],
						[
							-81.55115490999992,
							30.464830013000043
						],
						[
							-81.5503309099999,
							30.464674013000035
						],
						[
							-81.54889690899995,
							30.46438201300009
						],
						[
							-81.54827890899992,
							30.46424701300009
						],
						[
							-81.5473629089999,
							30.46406901300009
						],
						[
							-81.54616290899992,
							30.46381601300004
						],
						[
							-81.54565390999994,
							30.463713013000074
						],
						[
							-81.54531090899991,
							30.463621012000093
						],
						[
							-81.54486790999994,
							30.463474012000063
						],
						[
							-81.54045090999995,
							30.461769013000037
						],
						[
							-81.5382229089999,
							30.460920012000088
						],
						[
							-81.53638790899993,
							30.460204013000066
						],
						[
							-81.53579990899995,
							30.45999601200009
						],
						[
							-81.53537790999991,
							30.45985201300005
						],
						[
							-81.5340809089999,
							30.459394012000075
						],
						[
							-81.5332179099999,
							30.45910301200007
						],
						[
							-81.53296690999991,
							30.45905101300008
						],
						[
							-81.5327679099999,
							30.459030013000074
						]
					],
					[
						[
							-81.52606039799991,
							30.450393522000066
						],
						[
							-81.52524397499991,
							30.450302833000084
						],
						[
							-81.52582296199995,
							30.450454751000056
						],
						[
							-81.52606039799991,
							30.450393522000066
						]
					],
					[
						[
							-81.51909216599996,
							30.448686260000045
						],
						[
							-81.5190677459999,
							30.448667808000035
						],
						[
							-81.51927206199991,
							30.449052750000078
						],
						[
							-81.51947516099995,
							30.44931974100007
						],
						[
							-81.51996340799991,
							30.44927722600005
						],
						[
							-81.51909216599996,
							30.448686260000045
						]
					],
					[
						[
							-81.51993363799994,
							30.444352336000065
						],
						[
							-81.51870992799991,
							30.443993093000078
						],
						[
							-81.51787236699994,
							30.445319231000045
						],
						[
							-81.5178291759999,
							30.445382221000045
						],
						[
							-81.5177805859999,
							30.445441147000057
						],
						[
							-81.51772697899992,
							30.445495548000054
						],
						[
							-81.51766877299993,
							30.445544998000063
						],
						[
							-81.51760642399995,
							30.44558911000007
						],
						[
							-81.51754041999993,
							30.445627538000053
						],
						[
							-81.5174712779999,
							30.445659982000056
						],
						[
							-81.51853648699995,
							30.44766688900006
						],
						[
							-81.5185183399999,
							30.44759916600009
						],
						[
							-81.51850467799994,
							30.44744300000008
						],
						[
							-81.5185183399999,
							30.44728683400007
						],
						[
							-81.51855891299994,
							30.44713541400006
						],
						[
							-81.5186251639999,
							30.446993339000077
						],
						[
							-81.51866611199995,
							30.44692889700008
						],
						[
							-81.5188361129999,
							30.44668489700007
						],
						[
							-81.5188850799999,
							30.446620927000087
						],
						[
							-81.51899592699993,
							30.446510079000067
						],
						[
							-81.51912433899992,
							30.446420164000074
						],
						[
							-81.5192664139999,
							30.446353913000056
						],
						[
							-81.5194178349999,
							30.446313340000078
						],
						[
							-81.5194876839999,
							30.446303829000048
						],
						[
							-81.52032116099991,
							30.446223462000034
						],
						[
							-81.52093275999994,
							30.44603729900007
						],
						[
							-81.52128712299994,
							30.445226180000073
						],
						[
							-81.52057672199993,
							30.444751998000076
						],
						[
							-81.52054208499993,
							30.444727681000074
						],
						[
							-81.52017468999992,
							30.444456625000043
						],
						[
							-81.51993363799994,
							30.444352336000065
						]
					],
					[
						[
							-81.51523816399992,
							30.442203773000074
						],
						[
							-81.5152887459999,
							30.441614986000047
						],
						[
							-81.51398530599994,
							30.44202742200008
						],
						[
							-81.51387016599995,
							30.442055659000065
						],
						[
							-81.51384826299994,
							30.44205685100008
						],
						[
							-81.51398766099993,
							30.44212116400007
						],
						[
							-81.51411607299991,
							30.44221108000005
						],
						[
							-81.51422692099993,
							30.44232192700008
						],
						[
							-81.51431683599992,
							30.442450339000057
						],
						[
							-81.51438308599995,
							30.442592414000046
						],
						[
							-81.51442437299994,
							30.442747994000058
						],
						[
							-81.51444408599991,
							30.442866152000082
						],
						[
							-81.51445341999994,
							30.44293967100009
						],
						[
							-81.51445655999993,
							30.443013713000084
						],
						[
							-81.51445348099992,
							30.443087758000047
						],
						[
							-81.51444420699994,
							30.44316128400004
						],
						[
							-81.51442880199994,
							30.44323377400008
						],
						[
							-81.5144073749999,
							30.443304717000043
						],
						[
							-81.51523816399992,
							30.442203773000074
						]
					],
					[
						[
							-81.5129230789999,
							30.441717073000063
						],
						[
							-81.51283316399991,
							30.441588661000083
						],
						[
							-81.51279630599993,
							30.441517714000046
						],
						[
							-81.51275730599991,
							30.441433713000038
						],
						[
							-81.51272791399992,
							30.441362586000082
						],
						[
							-81.5126873399999,
							30.441211165000084
						],
						[
							-81.51267367799994,
							30.441055000000066
						],
						[
							-81.5126873399999,
							30.440898834000052
						],
						[
							-81.51269189499993,
							30.440874904000054
						],
						[
							-81.5131860059999,
							30.43845750800006
						],
						[
							-81.51265365899991,
							30.437622425000086
						],
						[
							-81.51262153999994,
							30.43756974000007
						],
						[
							-81.51259382199993,
							30.437514612000086
						],
						[
							-81.51257069099995,
							30.437457407000064
						],
						[
							-81.51255229999992,
							30.437398507000072
						],
						[
							-81.51253877199991,
							30.437338304000036
						],
						[
							-81.51238816599994,
							30.43737865900005
						],
						[
							-81.5123407289999,
							30.437385725000073
						],
						[
							-81.5121847289999,
							30.43740472500008
						],
						[
							-81.51207599999992,
							30.437411322000063
						],
						[
							-81.51191983399991,
							30.437397659000055
						],
						[
							-81.5117684139999,
							30.437357086000077
						],
						[
							-81.51162633899992,
							30.437290836000045
						],
						[
							-81.51149792699994,
							30.437200920000066
						],
						[
							-81.51143054099992,
							30.437138229000087
						],
						[
							-81.51103629099994,
							30.436731873000046
						],
						[
							-81.50999683299995,
							30.436979309000037
						],
						[
							-81.51001132199991,
							30.43713900000006
						],
						[
							-81.51001132199991,
							30.439973869000085
						],
						[
							-81.51261097399993,
							30.441814787000055
						],
						[
							-81.5126700809999,
							30.441824223000083
						],
						[
							-81.51272835399993,
							30.441837898000074
						],
						[
							-81.51278548899995,
							30.441855739000065
						],
						[
							-81.51284118799992,
							30.441877654000056
						],
						[
							-81.51302591299992,
							30.441957598000048
						],
						[
							-81.51329860599992,
							30.44198020100004
						],
						[
							-81.5131623389999,
							30.441917836000076
						],
						[
							-81.51303392699992,
							30.441827921000083
						],
						[
							-81.5129230789999,
							30.441717073000063
						]
					],
					[
						[
							-81.49280046699994,
							30.440638799000055
						],
						[
							-81.49262125999992,
							30.435979402000044
						],
						[
							-81.49258210699992,
							30.43608161600008
						],
						[
							-81.4924162659999,
							30.43700315600006
						],
						[
							-81.4919595049999,
							30.44061467100005
						],
						[
							-81.49243742899995,
							30.44109259500004
						],
						[
							-81.49280046699994,
							30.440638799000055
						]
					],
					[
						[
							-81.50628809499995,
							30.43528310700009
						],
						[
							-81.50862720999994,
							30.436037661000054
						],
						[
							-81.50817740099991,
							30.434797684000046
						],
						[
							-81.50690120099995,
							30.432931451000062
						],
						[
							-81.50536704299992,
							30.432585264000068
						],
						[
							-81.50529579399995,
							30.43256608500008
						],
						[
							-81.50522635599992,
							30.43254112800008
						],
						[
							-81.50515919899993,
							30.43251056200006
						],
						[
							-81.50509477299994,
							30.43247459300005
						],
						[
							-81.50503351399993,
							30.432433463000056
						],
						[
							-81.50497583299995,
							30.43238744900009
						],
						[
							-81.5049221189999,
							30.43233686000008
						],
						[
							-81.50487273399995,
							30.43228203800004
						],
						[
							-81.50448892399993,
							30.43181369800004
						],
						[
							-81.50181573899994,
							30.431403940000052
						],
						[
							-81.50178428499993,
							30.43139854500004
						],
						[
							-81.49750128499996,
							30.430585545000042
						],
						[
							-81.4974260429999,
							30.43056788500007
						],
						[
							-81.49735259699992,
							30.430543829000044
						],
						[
							-81.49728148699995,
							30.43051355300008
						],
						[
							-81.49721324099994,
							30.430477283000073
						],
						[
							-81.4971483619999,
							30.430435285000044
						],
						[
							-81.4970873289999,
							30.43038787000006
						],
						[
							-81.49705573299991,
							30.43036082000009
						],
						[
							-81.49695207899993,
							30.43025607300007
						],
						[
							-81.49686216399994,
							30.430127661000082
						],
						[
							-81.4967959139999,
							30.429985587000086
						],
						[
							-81.49675534099993,
							30.429834166000035
						],
						[
							-81.49674167799992,
							30.429678000000084
						],
						[
							-81.49674672499992,
							30.429582861000085
						],
						[
							-81.49675172499992,
							30.42953586100009
						],
						[
							-81.49676034099993,
							30.42947483400008
						],
						[
							-81.49678224799993,
							30.429393075000064
						],
						[
							-81.49677207299993,
							30.42940345200009
						],
						[
							-81.49671492099992,
							30.42948507300008
						],
						[
							-81.49669735799995,
							30.42950538100007
						],
						[
							-81.49665232599995,
							30.429555294000068
						],
						[
							-81.49664257799992,
							30.42958446300008
						],
						[
							-81.49661830199994,
							30.429671948000077
						],
						[
							-81.49660865899995,
							30.429782165000066
						],
						[
							-81.49656808599991,
							30.42993358600006
						],
						[
							-81.49650183599994,
							30.43007566100005
						],
						[
							-81.4964119199999,
							30.430204073000088
						],
						[
							-81.49630107299993,
							30.430314920000058
						],
						[
							-81.49617266099995,
							30.430404836000037
						],
						[
							-81.4960305859999,
							30.43047108600007
						],
						[
							-81.49590187199993,
							30.43050735400004
						],
						[
							-81.49574672799992,
							30.430538840000057
						],
						[
							-81.49569658599995,
							30.43056208700006
						],
						[
							-81.49564573099991,
							30.43057889900007
						],
						[
							-81.49555173099992,
							30.430606898000068
						],
						[
							-81.49545169499993,
							30.43063053400004
						],
						[
							-81.49534158599994,
							30.430681086000053
						],
						[
							-81.49526952299993,
							30.430703933000075
						],
						[
							-81.49514262499991,
							30.43073836800005
						],
						[
							-81.49511007299992,
							30.43077092100009
						],
						[
							-81.49504877499993,
							30.430813842000077
						],
						[
							-81.49514941399991,
							30.43076691300007
						],
						[
							-81.49530083499991,
							30.430726340000035
						],
						[
							-81.49545699999993,
							30.430712678000077
						],
						[
							-81.49561316599994,
							30.430726340000035
						],
						[
							-81.49576458599995,
							30.43076691300007
						],
						[
							-81.49585450199993,
							30.430805295000084
						],
						[
							-81.49804834299994,
							30.431886305000035
						],
						[
							-81.49968253499992,
							30.432033390000075
						],
						[
							-81.50141232699991,
							30.43176343400006
						],
						[
							-81.50155099999995,
							30.431752678000066
						],
						[
							-81.50170716499991,
							30.431766341000074
						],
						[
							-81.50185858599991,
							30.431806914000052
						],
						[
							-81.5020006609999,
							30.431873164000084
						],
						[
							-81.5020738099999,
							30.431920256000073
						],
						[
							-81.50513481099995,
							30.43410725600006
						],
						[
							-81.50519007299994,
							30.434150079000062
						],
						[
							-81.50530092099991,
							30.434260927000082
						],
						[
							-81.50539083599995,
							30.43438933900006
						],
						[
							-81.50545708699991,
							30.43453141400005
						],
						[
							-81.50549765999995,
							30.43468283400006
						],
						[
							-81.50551084699993,
							30.43480975700004
						],
						[
							-81.50553655199991,
							30.435373459000065
						],
						[
							-81.50558878899994,
							30.435345481000073
						],
						[
							-81.5056560829999,
							30.43531310400005
						],
						[
							-81.50572583099995,
							30.43528642300004
						],
						[
							-81.50579755299992,
							30.435265620000052
						],
						[
							-81.5058707529999,
							30.43525083900005
						],
						[
							-81.50594492699992,
							30.435242182000085
						],
						[
							-81.50601956299994,
							30.43523970900009
						],
						[
							-81.50609414799993,
							30.435243437000054
						],
						[
							-81.50616816599995,
							30.43525334000009
						],
						[
							-81.50628809499995,
							30.43528310700009
						]
					],
					[
						[
							-81.49356206799992,
							30.433523235000056
						],
						[
							-81.49408216199993,
							30.432419673000084
						],
						[
							-81.49394163299992,
							30.432532304000066
						],
						[
							-81.49356206799992,
							30.433523235000056
						]
					],
					[
						[
							-81.49005733699994,
							30.433110539000044
						],
						[
							-81.49101810899992,
							30.431023875000054
						],
						[
							-81.49105616399993,
							30.43095033900005
						],
						[
							-81.49115210999993,
							30.43081589600007
						],
						[
							-81.48952165299994,
							30.43060494400004
						],
						[
							-81.48936767299995,
							30.430803312000084
						],
						[
							-81.48932170599994,
							30.431118210000083
						],
						[
							-81.48951322399995,
							30.432273983000076
						],
						[
							-81.4895221299999,
							30.43234529500006
						],
						[
							-81.48960778599991,
							30.43335922100005
						],
						[
							-81.4896566569999,
							30.433313041000076
						],
						[
							-81.48970905399995,
							30.43327090300005
						],
						[
							-81.4897646419999,
							30.43323307700007
						],
						[
							-81.48982306999994,
							30.433199802000047
						],
						[
							-81.4898839629999,
							30.433171291000065
						],
						[
							-81.48994693599991,
							30.433147724000033
						],
						[
							-81.49005733699994,
							30.433110539000044
						]
					],
					[
						[
							-81.4946181599999,
							30.431207235000045
						],
						[
							-81.49462509299991,
							30.431267653000077
						],
						[
							-81.49464349599992,
							30.43122860600005
						],
						[
							-81.49467903499995,
							30.431160068000054
						],
						[
							-81.49472064399993,
							30.431095036000045
						],
						[
							-81.4947679789999,
							30.431034045000047
						],
						[
							-81.49482064999995,
							30.430977598000084
						],
						[
							-81.49487822399993,
							30.43092616100006
						],
						[
							-81.49494022499994,
							30.430880158000036
						],
						[
							-81.4948395859999,
							30.430927086000054
						],
						[
							-81.49468816499991,
							30.43096765900009
						],
						[
							-81.4945321429999,
							30.430981310000053
						],
						[
							-81.49456201699991,
							30.431034281000056
						],
						[
							-81.49458646399995,
							30.431089966000062
						],
						[
							-81.49460523999994,
							30.431147809000038
						],
						[
							-81.4946181599999,
							30.431207235000045
						]
					],
					[
						[
							-81.51322594399994,
							30.43599628000004
						],
						[
							-81.51324249099991,
							30.436089362000075
						],
						[
							-81.51325748999994,
							30.436210362000057
						],
						[
							-81.51325965599995,
							30.43624543800007
						],
						[
							-81.51415356399991,
							30.43597444800008
						],
						[
							-81.51456108199994,
							30.43585752500007
						],
						[
							-81.5146198189999,
							30.435842801000035
						],
						[
							-81.51483973299993,
							30.43579548100007
						],
						[
							-81.51422351399992,
							30.435733859000035
						],
						[
							-81.51415683399995,
							30.435724659000073
						],
						[
							-81.51400541299995,
							30.43568408600004
						],
						[
							-81.5138633389999,
							30.435617836000063
						],
						[
							-81.51373492699992,
							30.435527921000077
						],
						[
							-81.51366224299994,
							30.435459722000076
						],
						[
							-81.51304662599995,
							30.434814317000075
						],
						[
							-81.51296574899993,
							30.434877507000067
						],
						[
							-81.51322594399994,
							30.43599628000004
						]
					],
					[
						[
							-81.51638244299994,
							30.436083448000094
						],
						[
							-81.51680239699994,
							30.43677752900004
						],
						[
							-81.51820868499993,
							30.437200815000036
						],
						[
							-81.51839499699992,
							30.436668325000085
						],
						[
							-81.5179472179999,
							30.43663598600006
						],
						[
							-81.51787602799993,
							30.436627984000044
						],
						[
							-81.51780570099993,
							30.436614340000066
						],
						[
							-81.5177366819999,
							30.43659514300009
						],
						[
							-81.51766941099993,
							30.43657051300005
						],
						[
							-81.51633862699993,
							30.43602222000004
						],
						[
							-81.51638244299994,
							30.436083448000094
						]
					],
					[
						[
							-81.49500033899994,
							30.426879159000066
						],
						[
							-81.49502588199994,
							30.42682330400004
						],
						[
							-81.49494877899991,
							30.42683041900005
						],
						[
							-81.49385877299994,
							30.42767550700006
						],
						[
							-81.49361550799995,
							30.427999859000064
						],
						[
							-81.4937581659999,
							30.428012340000066
						],
						[
							-81.49377837299994,
							30.428016142000043
						],
						[
							-81.49394130799993,
							30.428048729000068
						],
						[
							-81.4940511659999,
							30.428058341000057
						],
						[
							-81.4941689449999,
							30.42808967800005
						],
						[
							-81.49424999999991,
							30.42808967800005
						],
						[
							-81.49440616599992,
							30.428103341000057
						],
						[
							-81.49454220699994,
							30.42813979300007
						],
						[
							-81.49458489799991,
							30.42812211300009
						],
						[
							-81.49466377599992,
							30.428093677000053
						],
						[
							-81.49481272499992,
							30.428047705000044
						],
						[
							-81.4948450039999,
							30.428027391000057
						],
						[
							-81.49486894599994,
							30.428006557000057
						],
						[
							-81.49489374399991,
							30.42792912200008
						],
						[
							-81.49490827299991,
							30.42788535900007
						],
						[
							-81.4948851929999,
							30.427797506000047
						],
						[
							-81.49486961699995,
							30.42772672000007
						],
						[
							-81.4948597909999,
							30.427654910000058
						],
						[
							-81.49485577999991,
							30.427582541000053
						],
						[
							-81.49485760999994,
							30.427510085000055
						],
						[
							-81.49486526899994,
							30.42743801100005
						],
						[
							-81.49487870699996,
							30.42736678800009
						],
						[
							-81.4948997059999,
							30.427275787000042
						],
						[
							-81.4949309129999,
							30.42717041300006
						],
						[
							-81.49495482899994,
							30.427119126000036
						],
						[
							-81.49495744099994,
							30.42705776300005
						],
						[
							-81.4949659589999,
							30.42699693800006
						],
						[
							-81.49498030299992,
							30.426937217000045
						],
						[
							-81.49500033899994,
							30.426879159000066
						]
					],
					[
						[
							-81.47901124599991,
							30.424578352000086
						],
						[
							-81.47907826199992,
							30.424543854000035
						],
						[
							-81.47914793299992,
							30.424515089000067
						],
						[
							-81.4792197669999,
							30.42449225900009
						],
						[
							-81.47929326099995,
							30.424475525000048
						],
						[
							-81.47936789799991,
							30.42446500400007
						],
						[
							-81.47944315299993,
							30.424460770000056
						],
						[
							-81.4795895769999,
							30.424458724000093
						],
						[
							-81.47965691999991,
							30.424460129000064
						],
						[
							-81.4797239369999,
							30.42446690100007
						],
						[
							-81.47979019999991,
							30.424478997000055
						],
						[
							-81.4798552869999,
							30.424496339000083
						],
						[
							-81.47991878399995,
							30.424518817000035
						],
						[
							-81.4799802849999,
							30.42454628800004
						],
						[
							-81.47992235899994,
							30.42428728300007
						],
						[
							-81.47991434099993,
							30.424247166000047
						],
						[
							-81.47990067799992,
							30.424091000000093
						],
						[
							-81.47991434099993,
							30.42393483400008
						],
						[
							-81.4799549139999,
							30.423783414000066
						],
						[
							-81.48002116399994,
							30.42364133900009
						],
						[
							-81.48011107899993,
							30.42351292700005
						],
						[
							-81.48022192699995,
							30.423402079000088
						],
						[
							-81.48035033899993,
							30.423312164000038
						],
						[
							-81.48049241399991,
							30.42324591400006
						],
						[
							-81.48064383399992,
							30.423205341000084
						],
						[
							-81.48066391399993,
							30.423202034000038
						],
						[
							-81.48278758899994,
							30.42287693500009
						],
						[
							-81.48427636299994,
							30.421891988000084
						],
						[
							-81.48468779199993,
							30.421381530000076
						],
						[
							-81.48467783399991,
							30.42138065900008
						],
						[
							-81.4846186979999,
							30.421368169000065
						],
						[
							-81.48454569799993,
							30.421350170000043
						],
						[
							-81.48445341399993,
							30.42132208600009
						],
						[
							-81.48431133899993,
							30.421255836000057
						],
						[
							-81.48418292699995,
							30.421165921000068
						],
						[
							-81.48407207899993,
							30.421055073000048
						],
						[
							-81.48398216399994,
							30.42092666100007
						],
						[
							-81.48391591399991,
							30.42078458600008
						],
						[
							-81.48389672899992,
							30.42072562700008
						],
						[
							-81.48385472899992,
							30.42057962800004
						],
						[
							-81.48383277199991,
							30.42048066700005
						],
						[
							-81.48382583799992,
							30.42046079100004
						],
						[
							-81.48378137599991,
							30.42034418900005
						],
						[
							-81.48373834099993,
							30.420186166000065
						],
						[
							-81.4837291099999,
							30.420080657000085
						],
						[
							-81.48367174399993,
							30.420035480000085
						],
						[
							-81.4836185659999,
							30.419985442000044
						],
						[
							-81.48356998499992,
							30.41993092900009
						],
						[
							-81.48352637799991,
							30.419872362000035
						],
						[
							-81.48348807999992,
							30.419810192000057
						],
						[
							-81.48347383399994,
							30.419804659000075
						],
						[
							-81.48332241399993,
							30.41976408600004
						],
						[
							-81.48318033899994,
							30.419697836000072
						],
						[
							-81.4830519269999,
							30.41960792100008
						],
						[
							-81.48294107899994,
							30.41949707300006
						],
						[
							-81.48287384499992,
							30.419405837000053
						],
						[
							-81.48277984499992,
							30.41925983700008
						],
						[
							-81.48274726699992,
							30.419209939000044
						],
						[
							-81.48271979999993,
							30.419157056000074
						],
						[
							-81.48269771499992,
							30.419101708000085
						],
						[
							-81.48268122899992,
							30.419044443000075
						],
						[
							-81.4826560919999,
							30.419008542000086
						],
						[
							-81.48252945199994,
							30.418949155000064
						],
						[
							-81.48246356499993,
							30.418910474000086
						],
						[
							-81.48234092699994,
							30.41882392000008
						],
						[
							-81.48226775599994,
							30.41875075000007
						],
						[
							-81.48221883499991,
							30.418855661000066
						],
						[
							-81.48218976999993,
							30.41890261300006
						],
						[
							-81.48167777099991,
							30.419675613000038
						],
						[
							-81.4816169209999,
							30.41975707300009
						],
						[
							-81.48150607299993,
							30.41986792100005
						],
						[
							-81.4813776609999,
							30.419957836000037
						],
						[
							-81.48123558699992,
							30.420024087000055
						],
						[
							-81.4810841659999,
							30.42006466000004
						],
						[
							-81.48098513299993,
							30.420076506000047
						],
						[
							-81.47978719199995,
							30.420152763000086
						],
						[
							-81.47930619099994,
							30.421173734000035
						],
						[
							-81.47931452599994,
							30.421217655000078
						],
						[
							-81.47932497099993,
							30.421287435000064
						],
						[
							-81.47932966899992,
							30.421357837000077
						],
						[
							-81.47932858799993,
							30.421428386000063
						],
						[
							-81.47932173399994,
							30.421498610000075
						],
						[
							-81.4793091539999,
							30.421568038000093
						],
						[
							-81.4792909329999,
							30.42163620200006
						],
						[
							-81.47926719199995,
							30.421702646000085
						],
						[
							-81.4792380909999,
							30.42176692300006
						],
						[
							-81.47927349199995,
							30.421841714000042
						],
						[
							-81.47932064999992,
							30.421967786000042
						],
						[
							-81.47934497599994,
							30.42204283400008
						],
						[
							-81.4793626099999,
							30.422119730000077
						],
						[
							-81.47937341599993,
							30.42219787800008
						],
						[
							-81.47937730899991,
							30.422276674000045
						],
						[
							-81.47937425999993,
							30.422355507000074
						],
						[
							-81.47936429299995,
							30.422433767000086
						],
						[
							-81.4793474839999,
							30.42251084800006
						],
						[
							-81.47932396399995,
							30.422586153000054
						],
						[
							-81.47924496399992,
							30.42280715200008
						],
						[
							-81.4791778359999,
							30.422951661000074
						],
						[
							-81.47908792099992,
							30.423080073000055
						],
						[
							-81.4789770729999,
							30.42319092000008
						],
						[
							-81.47884866099992,
							30.423280835000075
						],
						[
							-81.47882421499992,
							30.423294446000057
						],
						[
							-81.47854822499994,
							30.423442539000067
						],
						[
							-81.47844203699992,
							30.423503376000042
						],
						[
							-81.47779404099992,
							30.424062417000073
						],
						[
							-81.47768131999993,
							30.424386197000043
						],
						[
							-81.4777388359999,
							30.424468339000043
						],
						[
							-81.4777758539999,
							30.424539632000062
						],
						[
							-81.47812284699995,
							30.425287834000073
						],
						[
							-81.47888703399991,
							30.424663540000036
						],
						[
							-81.47894735299991,
							30.42461834100004
						],
						[
							-81.47901124599991,
							30.424578352000086
						]
					],
					[
						[
							-81.47321556399993,
							30.423466678000068
						],
						[
							-81.47376347799991,
							30.423076588000068
						],
						[
							-81.47289315499995,
							30.42314273500006
						],
						[
							-81.4728211229999,
							30.423145313000074
						],
						[
							-81.47274911599993,
							30.423142114000086
						],
						[
							-81.47267759699992,
							30.423133159000088
						],
						[
							-81.4726070239999,
							30.42311850600004
						],
						[
							-81.4725378519999,
							30.42309824700004
						],
						[
							-81.4724705239999,
							30.423072514000065
						],
						[
							-81.47240547299994,
							30.423041472000083
						],
						[
							-81.47146799099994,
							30.42254705100004
						],
						[
							-81.47154289399992,
							30.423322224000064
						],
						[
							-81.47174423799994,
							30.423466678000068
						],
						[
							-81.47321556399993,
							30.423466678000068
						]
					],
					[
						[
							-81.48960818799992,
							30.418750286000094
						],
						[
							-81.48962046999992,
							30.41877662500008
						],
						[
							-81.49015335199994,
							30.417903495000076
						],
						[
							-81.49023207899995,
							30.41779392700005
						],
						[
							-81.49032639599994,
							30.41769961000006
						],
						[
							-81.49008905099993,
							30.417508529000088
						],
						[
							-81.49002883599991,
							30.41763766100007
						],
						[
							-81.48993892099992,
							30.417766073000053
						],
						[
							-81.48992488499994,
							30.417780109000038
						],
						[
							-81.48989494099993,
							30.41789069700007
						],
						[
							-81.48981164199995,
							30.418114451000065
						],
						[
							-81.48974135899994,
							30.418442435000088
						],
						[
							-81.48972701199995,
							30.418508623000037
						],
						[
							-81.48970629599995,
							30.41857310100005
						],
						[
							-81.48967940799992,
							30.418635260000084
						],
						[
							-81.48964660099995,
							30.418694509000094
						],
						[
							-81.48960818799992,
							30.418750286000094
						]
					],
					[
						[
							-81.48215976599994,
							30.417550990000052
						],
						[
							-81.48220009699993,
							30.417490300000054
						],
						[
							-81.48224561099994,
							30.417433395000046
						],
						[
							-81.48230939599995,
							30.417254786000058
						],
						[
							-81.48231534099995,
							30.417186835000056
						],
						[
							-81.48232979399995,
							30.41711988600008
						],
						[
							-81.48235491199995,
							30.417021806000033
						],
						[
							-81.4823591409999,
							30.416979517000073
						],
						[
							-81.48236833999994,
							30.41691283500006
						],
						[
							-81.48238838899994,
							30.41683801100004
						],
						[
							-81.4823919879999,
							30.416774805000045
						],
						[
							-81.48240021799995,
							30.416712035000042
						],
						[
							-81.48241303699992,
							30.416650039000046
						],
						[
							-81.48243037599993,
							30.416589152000086
						],
						[
							-81.48245213899992,
							30.416529703000037
						],
						[
							-81.48246313899995,
							30.41650270200006
						],
						[
							-81.48251716399994,
							30.41639233900008
						],
						[
							-81.48260707899993,
							30.416263927000045
						],
						[
							-81.4827179269999,
							30.416153079000082
						],
						[
							-81.48284633899993,
							30.416063164000036
						],
						[
							-81.48298841399992,
							30.41599691300007
						],
						[
							-81.48304546199995,
							30.415978256000077
						],
						[
							-81.48307791399992,
							30.415878414000076
						],
						[
							-81.48312827799992,
							30.41576505200004
						],
						[
							-81.48324427799992,
							30.415546052000085
						],
						[
							-81.48328344999993,
							30.415479225000066
						],
						[
							-81.4833282269999,
							30.415416016000055
						],
						[
							-81.48337827799992,
							30.415356896000052
						],
						[
							-81.48343322999995,
							30.415302302000043
						],
						[
							-81.4834926769999,
							30.41525263900007
						],
						[
							-81.48355617699991,
							30.415208276000044
						],
						[
							-81.48361168499991,
							30.41517295300008
						],
						[
							-81.48384439599994,
							30.41502530200006
						],
						[
							-81.4839873709999,
							30.41490068900003
						],
						[
							-81.48412981199994,
							30.41480142200004
						],
						[
							-81.48419441099992,
							30.414718359000062
						],
						[
							-81.4841671659999,
							30.414725659000055
						],
						[
							-81.48406615399995,
							30.414737629000058
						],
						[
							-81.48370025699995,
							30.414760111000074
						],
						[
							-81.48215830299995,
							30.41599799400007
						],
						[
							-81.4815510059999,
							30.416821506000076
						],
						[
							-81.48159308399995,
							30.417111778000045
						],
						[
							-81.48207278899991,
							30.417750931000057
						],
						[
							-81.48209586399992,
							30.417681813000062
						],
						[
							-81.48212493199992,
							30.41761499300009
						],
						[
							-81.48215976599994,
							30.417550990000052
						]
					],
					[
						[
							-81.47098320899994,
							30.414757264000063
						],
						[
							-81.46988632999995,
							30.414154262000068
						],
						[
							-81.4699989209999,
							30.41426192700004
						],
						[
							-81.4700758489999,
							30.414368561000064
						],
						[
							-81.47093058699994,
							30.415757076000034
						],
						[
							-81.47098320899994,
							30.414757264000063
						]
					],
					[
						[
							-81.46698680299994,
							30.414857223000073
						],
						[
							-81.4689557399999,
							30.41401339300006
						],
						[
							-81.46900241399993,
							30.41399491400006
						],
						[
							-81.46915383399994,
							30.413954341000082
						],
						[
							-81.46930999999995,
							30.413940678000074
						],
						[
							-81.4694661659999,
							30.413954341000082
						],
						[
							-81.46956570499992,
							30.413981012000082
						],
						[
							-81.46772184399993,
							30.41297127900009
						],
						[
							-81.46648977799993,
							30.413680057000082
						],
						[
							-81.46698680299994,
							30.414857223000073
						]
					],
					[
						[
							-81.48491028799992,
							30.413847828000083
						],
						[
							-81.48489665999995,
							30.413996165000075
						],
						[
							-81.48487915999993,
							30.41406147600009
						],
						[
							-81.48494933899991,
							30.414013165000085
						],
						[
							-81.4850914129999,
							30.413946914000068
						],
						[
							-81.4852428339999,
							30.41390634100009
						],
						[
							-81.48539899999992,
							30.41389267800008
						],
						[
							-81.48555516499994,
							30.41390634100009
						],
						[
							-81.48560771399991,
							30.413922230000086
						],
						[
							-81.48569237599992,
							30.41394512800008
						],
						[
							-81.48575052399991,
							30.413962516000083
						],
						[
							-81.48582170399993,
							30.413990612000077
						],
						[
							-81.48589013399993,
							30.41402486600009
						],
						[
							-81.4859552819999,
							30.414065013000087
						],
						[
							-81.48601664199992,
							30.414110739000083
						],
						[
							-81.48607373699991,
							30.414161691000057
						],
						[
							-81.48612612499994,
							30.41421747200008
						],
						[
							-81.48617339799995,
							30.41427764900004
						],
						[
							-81.48623208099991,
							30.414358685000078
						],
						[
							-81.48634300499992,
							30.414504523000065
						],
						[
							-81.48639783599992,
							30.41458833900009
						],
						[
							-81.48644963399994,
							30.41469328600004
						],
						[
							-81.48646544399992,
							30.41473138400005
						],
						[
							-81.4865153639999,
							30.41480267700007
						],
						[
							-81.48616108099992,
							30.414016477000075
						],
						[
							-81.48613477899994,
							30.413951451000063
						],
						[
							-81.48611362499992,
							30.41388457300007
						],
						[
							-81.48609774699992,
							30.41381624900004
						],
						[
							-81.48608724299993,
							30.413746896000077
						],
						[
							-81.48608217599991,
							30.41367693500007
						],
						[
							-81.48608257699993,
							30.413606792000056
						],
						[
							-81.48608844299991,
							30.41353689400006
						],
						[
							-81.48670384999991,
							30.408548198000062
						],
						[
							-81.48660466099994,
							30.408799816000055
						],
						[
							-81.48657464899992,
							30.408867615000077
						],
						[
							-81.48492449999992,
							30.412215305000075
						],
						[
							-81.48491028799992,
							30.413847828000083
						]
					],
					[
						[
							-81.46947162099991,
							30.409245780000045
						],
						[
							-81.46874336499991,
							30.40723297400007
						],
						[
							-81.4681528019999,
							30.40768180200007
						],
						[
							-81.4663270069999,
							30.410084165000058
						],
						[
							-81.46629992099992,
							30.410118073000035
						],
						[
							-81.46618907299991,
							30.410228921000055
						],
						[
							-81.46606066099991,
							30.410318836000048
						],
						[
							-81.46591858699992,
							30.410385087000066
						],
						[
							-81.46576716599992,
							30.410425660000044
						],
						[
							-81.46573818299993,
							30.410430284000086
						],
						[
							-81.46457910999993,
							30.410595865000058
						],
						[
							-81.4648570629999,
							30.410675280000074
						],
						[
							-81.46492562599991,
							30.41069758200007
						],
						[
							-81.46499207799991,
							30.410725556000042
						],
						[
							-81.46505594899992,
							30.410759005000045
						],
						[
							-81.46511678999991,
							30.410797692000077
						],
						[
							-81.46517417199993,
							30.41084134600004
						],
						[
							-81.46523241699992,
							30.410801291000038
						],
						[
							-81.46529382299991,
							30.41076627600006
						],
						[
							-81.46535795599993,
							30.410736548000042
						],
						[
							-81.46542436199991,
							30.41071231900008
						],
						[
							-81.4695409229999,
							30.409392601000036
						],
						[
							-81.46947162099991,
							30.409245780000045
						]
					],
					[
						[
							-81.48718482599992,
							30.407328078000035
						],
						[
							-81.4869433419999,
							30.407940664000083
						],
						[
							-81.48699768199992,
							30.407883947000073
						],
						[
							-81.48705691999993,
							30.40783236600004
						],
						[
							-81.48712057199992,
							30.40778634300005
						],
						[
							-81.48718811799995,
							30.40774625300008
						],
						[
							-81.48725900799991,
							30.407712424000067
						],
						[
							-81.49153479899991,
							30.405893804000076
						],
						[
							-81.48905209599991,
							30.406276445000064
						],
						[
							-81.48817846499992,
							30.406896414000077
						],
						[
							-81.4881076609999,
							30.406941836000048
						],
						[
							-81.48799837399991,
							30.406995422000076
						],
						[
							-81.48718482599992,
							30.407328078000035
						]
					],
					[
						[
							-81.47266708799992,
							30.405908958000055
						],
						[
							-81.47290785599995,
							30.405708730000068
						],
						[
							-81.47098786899994,
							30.403940793000064
						],
						[
							-81.47090857099994,
							30.405196098000086
						],
						[
							-81.4709038769999,
							30.405261863000078
						],
						[
							-81.47089314699991,
							30.405326915000046
						],
						[
							-81.47087646999995,
							30.405390703000084
						],
						[
							-81.47085398899992,
							30.405452684000068
						],
						[
							-81.4708258949999,
							30.40551233000008
						],
						[
							-81.47266708799992,
							30.405908958000055
						]
					],
					[
						[
							-81.49801091999991,
							30.411317927000088
						],
						[
							-81.49806711699995,
							30.411392432000074
						],
						[
							-81.49892811699993,
							30.41266643200004
						],
						[
							-81.49899214299995,
							30.41277748700009
						],
						[
							-81.49901934799995,
							30.412833567000064
						],
						[
							-81.49900844699994,
							30.412570187000085
						],
						[
							-81.49900843899991,
							30.412496008000062
						],
						[
							-81.49901454499991,
							30.412422081000045
						],
						[
							-81.49902672199994,
							30.41234890900006
						],
						[
							-81.49904488699991,
							30.412276989000077
						],
						[
							-81.49956589199991,
							30.41053160900009
						],
						[
							-81.4974778799999,
							30.411009088000068
						],
						[
							-81.4976295859999,
							30.411050914000047
						],
						[
							-81.49777166099994,
							30.41111716400007
						],
						[
							-81.49790007299993,
							30.411207079000068
						],
						[
							-81.49801091999991,
							30.411317927000088
						]
					],
					[
						[
							-81.49261416099995,
							30.41248895500007
						],
						[
							-81.49548664699995,
							30.41136047800006
						],
						[
							-81.4953794569999,
							30.41136083100008
						],
						[
							-81.4907387479999,
							30.412942171000058
						],
						[
							-81.48972961699991,
							30.413986553000086
						],
						[
							-81.48872826699994,
							30.415648186000055
						],
						[
							-81.48867797399993,
							30.41571859700008
						],
						[
							-81.48888440799993,
							30.415538656000084
						],
						[
							-81.48901933899992,
							30.415443164000067
						],
						[
							-81.48916141399991,
							30.415376914000035
						],
						[
							-81.48931283499991,
							30.41533634000007
						],
						[
							-81.48946899999993,
							30.415322678000056
						],
						[
							-81.48962516599994,
							30.41533634000007
						],
						[
							-81.48977658599995,
							30.415376914000035
						],
						[
							-81.48991866099993,
							30.415443164000067
						],
						[
							-81.48994378599991,
							30.415458221000048
						],
						[
							-81.4900177859999,
							30.415504221000052
						],
						[
							-81.49007988699992,
							30.415549229000074
						],
						[
							-81.4908954849999,
							30.41366220200007
						],
						[
							-81.49092680099994,
							30.41359706500009
						],
						[
							-81.49096324699991,
							30.41353465300006
						],
						[
							-81.4910045869999,
							30.413475370000075
						],
						[
							-81.4910505549999,
							30.41341959800008
						],
						[
							-81.49110085199993,
							30.41336769700007
						],
						[
							-81.49115515599993,
							30.41332000400007
						],
						[
							-81.4912131129999,
							30.413276825000082
						],
						[
							-81.49127435199995,
							30.413238440000043
						],
						[
							-81.4924993649999,
							30.412543716000073
						],
						[
							-81.49261416099995,
							30.41248895500007
						]
					],
					[
						[
							-81.48706416399995,
							30.401301021000055
						],
						[
							-81.48677886899992,
							30.401234489000046
						],
						[
							-81.49258045399995,
							30.40363459500008
						],
						[
							-81.49244466599994,
							30.403441607000047
						],
						[
							-81.4911856569999,
							30.402468888000044
						],
						[
							-81.48706416399995,
							30.401301021000055
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Pumpkin Hill",
				"RegionID": "269151"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.56061496399991,
					30.321477836000042,
					-81.53577391999994,
					30.361099050000064
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.54403708699994,
							30.354247958000087
						],
						[
							-81.54395786499992,
							30.354151872000045
						],
						[
							-81.54394690999993,
							30.354297012000075
						],
						[
							-81.5439450099999,
							30.35438315600004
						],
						[
							-81.54357890999995,
							30.354259012000057
						],
						[
							-81.54309790999991,
							30.35412601300004
						],
						[
							-81.5428089099999,
							30.354067012000087
						],
						[
							-81.54244190999992,
							30.353979012000085
						],
						[
							-81.5421829089999,
							30.353931013000075
						],
						[
							-81.5414809099999,
							30.35384001300008
						],
						[
							-81.54096990999994,
							30.353838013000082
						],
						[
							-81.54052190899995,
							30.353851012000067
						],
						[
							-81.5398169099999,
							30.353866012000083
						],
						[
							-81.53963390699994,
							30.35385201300005
						],
						[
							-81.5392329089999,
							30.35390401300009
						],
						[
							-81.53897090999995,
							30.35393301300007
						],
						[
							-81.53770390999996,
							30.354027012000078
						],
						[
							-81.53741491599993,
							30.35405509900005
						],
						[
							-81.5372916419999,
							30.35282150200004
						],
						[
							-81.5379983329999,
							30.351267311000075
						],
						[
							-81.53715037899991,
							30.350702281000057
						],
						[
							-81.53616135699991,
							30.348724241000067
						],
						[
							-81.53616144099993,
							30.346604933000037
						],
						[
							-81.53672658099993,
							30.344909503000054
						],
						[
							-81.53729172299991,
							30.343355357000068
						],
						[
							-81.53738881399994,
							30.34310308000005
						],
						[
							-81.53799828599995,
							30.341518664000038
						],
						[
							-81.53799815399992,
							30.338834208000037
						],
						[
							-81.53799815399992,
							30.337280063000037
						],
						[
							-81.53757429799992,
							30.33290020000004
						],
						[
							-81.53700915199994,
							30.32781391000009
						],
						[
							-81.53577391999994,
							30.323188920000067
						],
						[
							-81.53592690799991,
							30.323177010000055
						],
						[
							-81.5367619079999,
							30.323080010000073
						],
						[
							-81.5375709079999,
							30.322990010000073
						],
						[
							-81.53783790799991,
							30.322960010000088
						],
						[
							-81.53814690799993,
							30.32292701100005
						],
						[
							-81.53906990699996,
							30.32283601000006
						],
						[
							-81.5395819069999,
							30.322781010000085
						],
						[
							-81.54109490799993,
							30.322621010000038
						],
						[
							-81.54235790799993,
							30.322477011000046
						],
						[
							-81.5433879069999,
							30.322376010000088
						],
						[
							-81.54460790699994,
							30.322247010000073
						],
						[
							-81.54562590699993,
							30.32214201000005
						],
						[
							-81.54637890799995,
							30.322048011000046
						],
						[
							-81.54661993999991,
							30.322012087000072
						],
						[
							-81.5467358759999,
							30.321928933000034
						],
						[
							-81.54688302599993,
							30.32190787400009
						],
						[
							-81.54688280699992,
							30.32197315000008
						],
						[
							-81.54719790799993,
							30.32186801100005
						],
						[
							-81.54725703399993,
							30.321858890000048
						],
						[
							-81.54721978499992,
							30.32199812500005
						],
						[
							-81.54731290799992,
							30.32198501100004
						],
						[
							-81.54746290799994,
							30.321961010000056
						],
						[
							-81.54782690799993,
							30.321915011000044
						],
						[
							-81.54844290699992,
							30.32184101000007
						],
						[
							-81.54856090699991,
							30.321827010000053
						],
						[
							-81.54866690799992,
							30.32181601000008
						],
						[
							-81.54962890699994,
							30.32171401000005
						],
						[
							-81.5498259069999,
							30.32169401100009
						],
						[
							-81.55011390699991,
							30.32169001000005
						],
						[
							-81.5503369079999,
							30.32169401000004
						],
						[
							-81.55041390699996,
							30.32169401000004
						],
						[
							-81.55057090799994,
							30.321686010000068
						],
						[
							-81.55095790699994,
							30.32166601100005
						],
						[
							-81.55139190799991,
							30.32165401000009
						],
						[
							-81.55143590799992,
							30.32164901100009
						],
						[
							-81.55175790699991,
							30.321655010000086
						],
						[
							-81.55208890799992,
							30.32165701000008
						],
						[
							-81.55258690799991,
							30.32167301000004
						],
						[
							-81.5529470319999,
							30.32169414800006
						],
						[
							-81.55295674099995,
							30.32156893000007
						],
						[
							-81.55305285599991,
							30.321477836000042
						],
						[
							-81.5533579069999,
							30.321519010000088
						],
						[
							-81.55410790799993,
							30.321619011000056
						],
						[
							-81.55483390799992,
							30.32173401000006
						],
						[
							-81.55506590699991,
							30.321766010000093
						],
						[
							-81.55588106199991,
							30.321903901000045
						],
						[
							-81.55586673399995,
							30.32198509400007
						],
						[
							-81.55596701799993,
							30.322036040000057
						],
						[
							-81.55585878399995,
							30.322033864000048
						],
						[
							-81.55584574499994,
							30.322118110000076
						],
						[
							-81.55665090799994,
							30.32233801000007
						],
						[
							-81.55718090699992,
							30.322478011000044
						],
						[
							-81.55777490799994,
							30.32267801100005
						],
						[
							-81.55825590699993,
							30.322843010000042
						],
						[
							-81.55835890799995,
							30.32289001100008
						],
						[
							-81.55885590699995,
							30.32311201100004
						],
						[
							-81.5589159079999,
							30.323150009000077
						],
						[
							-81.55909090699993,
							30.323234010000075
						],
						[
							-81.55921790799994,
							30.323292010000046
						],
						[
							-81.55976474999994,
							30.323513044000038
						],
						[
							-81.55982491099991,
							30.32353601300008
						],
						[
							-81.55987590799992,
							30.32355701300008
						],
						[
							-81.56009590999992,
							30.323650012000087
						],
						[
							-81.56061496399991,
							30.323864936000064
						],
						[
							-81.56057690699993,
							30.324013010000044
						],
						[
							-81.56042990799995,
							30.324772010000064
						],
						[
							-81.56039590699993,
							30.32500401100009
						],
						[
							-81.56029890799994,
							30.325478010000044
						],
						[
							-81.56025990799992,
							30.325720011000044
						],
						[
							-81.56021190799993,
							30.325959010000076
						],
						[
							-81.56018090799995,
							30.32618701100006
						],
						[
							-81.5601109079999,
							30.32666701000005
						],
						[
							-81.56010390799992,
							30.327159010000063
						],
						[
							-81.56008790699991,
							30.328141011000067
						],
						[
							-81.56007790799993,
							30.32864801000005
						],
						[
							-81.56007790799993,
							30.328941010000054
						],
						[
							-81.56007790799993,
							30.329190011000037
						],
						[
							-81.56008790699991,
							30.329421010000086
						],
						[
							-81.56008790699991,
							30.330523011000086
						],
						[
							-81.5601119079999,
							30.331083011000093
						],
						[
							-81.56018790699994,
							30.332220011000057
						],
						[
							-81.5602039069999,
							30.33289101000008
						],
						[
							-81.56021890699992,
							30.33315901000009
						],
						[
							-81.56025690799993,
							30.33420801000005
						],
						[
							-81.5602709069999,
							30.334587010000064
						],
						[
							-81.56002291599992,
							30.337931062000056
						],
						[
							-81.55943290899995,
							30.337934010000083
						],
						[
							-81.55888390799993,
							30.33789601000007
						],
						[
							-81.5584489069999,
							30.337893010000077
						],
						[
							-81.55725890699995,
							30.337849010000074
						],
						[
							-81.55338590799994,
							30.33775201000009
						],
						[
							-81.55306190699991,
							30.33775501100007
						],
						[
							-81.5527539069999,
							30.33774501000005
						],
						[
							-81.5525699069999,
							30.33773801100006
						],
						[
							-81.55232577499993,
							30.337733877000062
						],
						[
							-81.55232790799994,
							30.337927010000044
						],
						[
							-81.55236090699992,
							30.34031501000004
						],
						[
							-81.55237590799993,
							30.340790010000035
						],
						[
							-81.55238090799992,
							30.341701011000055
						],
						[
							-81.55241790799994,
							30.343780010000046
						],
						[
							-81.5524549079999,
							30.346192010000042
						],
						[
							-81.55247290799991,
							30.346961010000086
						],
						[
							-81.5524769079999,
							30.347574011000063
						],
						[
							-81.55249790699992,
							30.348768010000075
						],
						[
							-81.55250790799994,
							30.349111011000048
						],
						[
							-81.55252090699992,
							30.34980201000008
						],
						[
							-81.55252590799995,
							30.350161011000072
						],
						[
							-81.5525668539999,
							30.352427012000078
						],
						[
							-81.55256790999994,
							30.352955012000056
						],
						[
							-81.55256990999993,
							30.353670012000062
						],
						[
							-81.55258990999994,
							30.353822013000073
						],
						[
							-81.55263490899995,
							30.354134013000078
						],
						[
							-81.5526279099999,
							30.354841012000062
						],
						[
							-81.55261690999993,
							30.355782012000077
						],
						[
							-81.5526710389999,
							30.356367035000062
						],
						[
							-81.55234977799995,
							30.35711198800004
						],
						[
							-81.55234490999993,
							30.357512012000083
						],
						[
							-81.55235190999991,
							30.35788401200006
						],
						[
							-81.5523559099999,
							30.358556013000058
						],
						[
							-81.55238690899995,
							30.358979012000077
						],
						[
							-81.55239090999993,
							30.359749013000055
						],
						[
							-81.55239090999993,
							30.359945013000072
						],
						[
							-81.5523759109999,
							30.36023501300008
						],
						[
							-81.5523849089999,
							30.36040101200007
						],
						[
							-81.55239890899992,
							30.36067401200006
						],
						[
							-81.55237599299994,
							30.360949036000083
						],
						[
							-81.55233490899991,
							30.361030012000068
						],
						[
							-81.55228386999994,
							30.361099050000064
						],
						[
							-81.55193290999995,
							30.360796012000034
						],
						[
							-81.55187590999992,
							30.36073801300006
						],
						[
							-81.5512109089999,
							30.360135013000047
						],
						[
							-81.55094090999995,
							30.35993201200006
						],
						[
							-81.55073290999991,
							30.35975301200006
						],
						[
							-81.54956090999991,
							30.358723012000045
						],
						[
							-81.54906490999991,
							30.358250012000045
						],
						[
							-81.54871390999995,
							30.35789701300007
						],
						[
							-81.54816390899992,
							30.35731101300007
						],
						[
							-81.54791290899993,
							30.357031012000053
						],
						[
							-81.5474089089999,
							30.356504012000073
						],
						[
							-81.54714990899993,
							30.356255013000066
						],
						[
							-81.54708590999991,
							30.35618301200009
						],
						[
							-81.5470429099999,
							30.35613401500007
						],
						[
							-81.5469359089999,
							30.356054010000037
						],
						[
							-81.54681390999991,
							30.35591501500005
						],
						[
							-81.5465089089999,
							30.35569401300006
						],
						[
							-81.54632590999995,
							30.355589013000042
						],
						[
							-81.54563890899993,
							30.355152013000062
						],
						[
							-81.5449749089999,
							30.354801012000053
						],
						[
							-81.54430390899995,
							30.354511012000042
						],
						[
							-81.54402074899991,
							30.35441011400008
						],
						[
							-81.54403708699994,
							30.354247958000087
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Regency",
				"RegionID": "269153"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.72034197499994,
					30.382421005000086,
					-81.69617485599991,
					30.399663395000058
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.70129522699995,
							30.399469370000077
						],
						[
							-81.70071315299992,
							30.399178333000066
						],
						[
							-81.70035744199993,
							30.398919634000038
						],
						[
							-81.70013107999995,
							30.39869327200006
						],
						[
							-81.6998077049999,
							30.39859625900004
						],
						[
							-81.69977434799995,
							30.398599292000082
						],
						[
							-81.6997179999999,
							30.398330000000044
						],
						[
							-81.6996420129999,
							30.397966853000074
						],
						[
							-81.6990219079999,
							30.39811001000004
						],
						[
							-81.69853990699994,
							30.398218011000036
						],
						[
							-81.69777689099993,
							30.39840292000008
						],
						[
							-81.69753290799993,
							30.398439009000068
						],
						[
							-81.69741079799991,
							30.39844317000006
						],
						[
							-81.69705990699993,
							30.39752201000005
						],
						[
							-81.69647990699991,
							30.396109011000075
						],
						[
							-81.69624290799993,
							30.39549401000005
						],
						[
							-81.69617485599991,
							30.39526001900009
						],
						[
							-81.69617490899992,
							30.39512301000008
						],
						[
							-81.69618990799995,
							30.39503501100006
						],
						[
							-81.69621990999991,
							30.394941010000085
						],
						[
							-81.69626590899992,
							30.394855010000075
						],
						[
							-81.69636490799991,
							30.39473701100008
						],
						[
							-81.6965259079999,
							30.394604011000066
						],
						[
							-81.6965709079999,
							30.394579010000083
						],
						[
							-81.6968609079999,
							30.394464010000036
						],
						[
							-81.69729990699994,
							30.394322010000053
						],
						[
							-81.69739490699993,
							30.394291010000078
						],
						[
							-81.69752490799993,
							30.39422600900008
						],
						[
							-81.69767790799995,
							30.39412101000005
						],
						[
							-81.6977689069999,
							30.394035009000046
						],
						[
							-81.69782990699993,
							30.393955010000074
						],
						[
							-81.69792907999994,
							30.393772052000088
						],
						[
							-81.69791690699992,
							30.39347401200007
						],
						[
							-81.69779590799993,
							30.39297201100004
						],
						[
							-81.69778390699992,
							30.392918010000074
						],
						[
							-81.6975859069999,
							30.39210501000008
						],
						[
							-81.69735690899995,
							30.390940009000072
						],
						[
							-81.69735690699991,
							30.390900011000046
						],
						[
							-81.69720490799995,
							30.38999601100005
						],
						[
							-81.69716590799993,
							30.389818010000056
						],
						[
							-81.69703690799992,
							30.389122011000037
						],
						[
							-81.69697590999995,
							30.38886500900009
						],
						[
							-81.69697590699991,
							30.388828010000054
						],
						[
							-81.69680790699994,
							30.387941010000077
						],
						[
							-81.69679290699992,
							30.38781701100004
						],
						[
							-81.69676190799993,
							30.387695010000073
						],
						[
							-81.69673890899992,
							30.38752401000005
						],
						[
							-81.69673890899992,
							30.387398010000087
						],
						[
							-81.6967619099999,
							30.387232012000084
						],
						[
							-81.69685390799992,
							30.387024013000083
						],
						[
							-81.6969299079999,
							30.386913010000058
						],
						[
							-81.69713590799995,
							30.38669201000005
						],
						[
							-81.69753290699992,
							30.38631801100007
						],
						[
							-81.69824190799994,
							30.385679010000047
						],
						[
							-81.69852490699992,
							30.38542401000007
						],
						[
							-81.69867890699993,
							30.38524901000005
						],
						[
							-81.69871790699995,
							30.38519101000009
						],
						[
							-81.69877095399994,
							30.385117036000054
						],
						[
							-81.69883890699992,
							30.38492701100006
						],
						[
							-81.6988689069999,
							30.384772011000052
						],
						[
							-81.69890690699994,
							30.384414011000047
						],
						[
							-81.69895190699992,
							30.383762011000044
						],
						[
							-81.69901290699994,
							30.38318801000008
						],
						[
							-81.69906582199991,
							30.382421005000086
						],
						[
							-81.70005290799992,
							30.382553010000038
						],
						[
							-81.70065290699995,
							30.382633010000063
						],
						[
							-81.70158390799992,
							30.382751010000053
						],
						[
							-81.7019739079999,
							30.382805010000087
						],
						[
							-81.70374290799992,
							30.383041011000046
						],
						[
							-81.70411790799994,
							30.383085010000062
						],
						[
							-81.70428490699993,
							30.383104011000057
						],
						[
							-81.70483490799995,
							30.383183011000085
						],
						[
							-81.70556790799992,
							30.38326901100004
						],
						[
							-81.7058259069999,
							30.38331901000004
						],
						[
							-81.70602190699992,
							30.38335801000005
						],
						[
							-81.70626390899992,
							30.383420011000055
						],
						[
							-81.70645890799995,
							30.383481010000082
						],
						[
							-81.70682090699995,
							30.383619010000075
						],
						[
							-81.70706890699995,
							30.383718011000045
						],
						[
							-81.70834390699991,
							30.38428901000009
						],
						[
							-81.7088389079999,
							30.384521011000064
						],
						[
							-81.70907590799993,
							30.38462101100004
						],
						[
							-81.7098769079999,
							30.384977010000057
						],
						[
							-81.71097590699992,
							30.385466010000073
						],
						[
							-81.7115019069999,
							30.385704010000044
						],
						[
							-81.71233390799995,
							30.386076010000068
						],
						[
							-81.71362290699994,
							30.386650011000086
						],
						[
							-81.7154619069999,
							30.387478010000052
						],
						[
							-81.71563690699992,
							30.387564011000055
						],
						[
							-81.71646890799991,
							30.387939010000082
						],
						[
							-81.7167429079999,
							30.388062010000052
						],
						[
							-81.71724690799994,
							30.38826801100004
						],
						[
							-81.71821590799993,
							30.388617011000065
						],
						[
							-81.71921490799991,
							30.38892401000004
						],
						[
							-81.7193529079999,
							30.388958010000067
						],
						[
							-81.7197589999999,
							30.38905500000004
						],
						[
							-81.72001838999995,
							30.389117254000045
						],
						[
							-81.72001860099994,
							30.38912139100006
						],
						[
							-81.72021262599992,
							30.38992982700006
						],
						[
							-81.72034197499994,
							30.390705926000066
						],
						[
							-81.7202773009999,
							30.39135267400008
						],
						[
							-81.72024496299991,
							30.39190241100005
						],
						[
							-81.72018028799994,
							30.39235513500006
						],
						[
							-81.72005093899992,
							30.392678509000064
						],
						[
							-81.71982457699994,
							30.39303422100005
						],
						[
							-81.71950120199995,
							30.393228245000042
						],
						[
							-81.71921016499994,
							30.39326058300008
						],
						[
							-81.71895146599991,
							30.393131233000076
						],
						[
							-81.7186604289999,
							30.39277552100009
						],
						[
							-81.71840172899994,
							30.39235513500006
						],
						[
							-81.71811069299991,
							30.39209643500004
						],
						[
							-81.71765796799991,
							30.39190241100005
						],
						[
							-81.71707589499994,
							30.391870073000067
						],
						[
							-81.71642914599994,
							30.391999423000073
						],
						[
							-81.7158794099999,
							30.392322797000077
						],
						[
							-81.71542668599994,
							30.392710847000046
						],
						[
							-81.71484461199992,
							30.393131233000076
						],
						[
							-81.7142302009999,
							30.393486945000063
						],
						[
							-81.71371280199992,
							30.39355162000004
						],
						[
							-81.71316306499995,
							30.393713307000045
						],
						[
							-81.71261332899991,
							30.393907332000083
						],
						[
							-81.71222527999993,
							30.39419836800005
						],
						[
							-81.71199891799995,
							30.394586418000078
						],
						[
							-81.71190190499993,
							30.394974467000054
						],
						[
							-81.71206359299993,
							30.39545952800006
						],
						[
							-81.71206359299993,
							30.395847578000087
						],
						[
							-81.7118372299999,
							30.39613861400005
						],
						[
							-81.71138450599994,
							30.396364977000076
						],
						[
							-81.71102879499995,
							30.396300302000046
						],
						[
							-81.7107054199999,
							30.396106277000055
						],
						[
							-81.71025269599994,
							30.395815240000047
						],
						[
							-81.70950893499992,
							30.395491866000043
						],
						[
							-81.70902387399991,
							30.395524203000036
						],
						[
							-81.70870049899992,
							30.395718228000078
						],
						[
							-81.70853881199992,
							30.396041602000086
						],
						[
							-81.70847413699994,
							30.396397314000072
						],
						[
							-81.70850647499992,
							30.396817701000085
						],
						[
							-81.70860348699995,
							30.39743211200005
						],
						[
							-81.70863582499993,
							30.39788483600006
						],
						[
							-81.70860348699995,
							30.398499247000075
						],
						[
							-81.70837712499991,
							30.39885495900006
						],
						[
							-81.70785972599992,
							30.39914599600007
						],
						[
							-81.70718063999993,
							30.399469370000077
						],
						[
							-81.70637220399993,
							30.399663395000058
						],
						[
							-81.70553143099994,
							30.399663395000058
						],
						[
							-81.70491701999993,
							30.399404695000047
						],
						[
							-81.70430260799992,
							30.39927534600008
						],
						[
							-81.70384988399991,
							30.39927534600008
						],
						[
							-81.70330014799993,
							30.399469370000077
						],
						[
							-81.70281508699992,
							30.39959872000009
						],
						[
							-81.70220067499992,
							30.399663395000058
						],
						[
							-81.70178028899994,
							30.39963105700008
						],
						[
							-81.70129522699995,
							30.399469370000077
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Ribault",
				"RegionID": "269154"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.07848066299995,
					26.714711526000087,
					-80.06652869899995,
					26.725104000000044
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.07064908099994,
							26.72494000100005
						],
						[
							-80.0683034729999,
							26.72491703500009
						],
						[
							-80.06827004699994,
							26.72494017000008
						],
						[
							-80.0671599989999,
							26.72494000100005
						],
						[
							-80.06652869899995,
							26.724920998000073
						],
						[
							-80.06652999999994,
							26.724800000000073
						],
						[
							-80.06655827299994,
							26.724289732000045
						],
						[
							-80.06657999999993,
							26.723790000000065
						],
						[
							-80.06658869799993,
							26.723385554000064
						],
						[
							-80.06659999999994,
							26.722860000000082
						],
						[
							-80.06661925399993,
							26.72218609900006
						],
						[
							-80.06666473199994,
							26.720594377000054
						],
						[
							-80.0666799999999,
							26.720060000000046
						],
						[
							-80.0666853919999,
							26.71992627600008
						],
						[
							-80.06670279799994,
							26.719494610000083
						],
						[
							-80.06672501499992,
							26.718943635000073
						],
						[
							-80.06675106799992,
							26.718196289000048
						],
						[
							-80.06675999999993,
							26.717900000000043
						],
						[
							-80.0667653029999,
							26.71789706800007
						],
						[
							-80.06689547099995,
							26.71779394500004
						],
						[
							-80.06736094799993,
							26.717845665000084
						],
						[
							-80.06809282299992,
							26.717777830000045
						],
						[
							-80.06848214899992,
							26.71778844800008
						],
						[
							-80.06899204599995,
							26.717737188000058
						],
						[
							-80.06902318199991,
							26.717734604000047
						],
						[
							-80.06908199999992,
							26.71773267800006
						],
						[
							-80.06910028599992,
							26.717732864000084
						],
						[
							-80.06939528499993,
							26.71773886400007
						],
						[
							-80.06943581799993,
							26.71774060300004
						],
						[
							-80.06949438499993,
							26.71774637100009
						],
						[
							-80.06952223299993,
							26.717750482000042
						],
						[
							-80.0697206079999,
							26.71778294400008
						],
						[
							-80.0699200819999,
							26.717805678000047
						],
						[
							-80.07011531199993,
							26.717805678000047
						],
						[
							-80.07013114699993,
							26.71780356700009
						],
						[
							-80.07013261499992,
							26.71780337200005
						],
						[
							-80.07018812199993,
							26.717797810000036
						],
						[
							-80.07042012199992,
							26.717781809000087
						],
						[
							-80.0704231819999,
							26.71778160300005
						],
						[
							-80.07045153399991,
							26.717780194000056
						],
						[
							-80.07074653399991,
							26.71777019400008
						],
						[
							-80.07083581899991,
							26.717771604000063
						],
						[
							-80.07089438499992,
							26.717777372000057
						],
						[
							-80.0709199989999,
							26.71778112000004
						],
						[
							-80.0712992739999,
							26.717842205000068
						],
						[
							-80.07158618699992,
							26.717864343000088
						],
						[
							-80.07159595699994,
							26.71786515100007
						],
						[
							-80.07184601299991,
							26.717887190000056
						],
						[
							-80.07217863799991,
							26.71788308300006
						],
						[
							-80.07264752599993,
							26.71784881500008
						],
						[
							-80.07277395699992,
							26.717820878000055
						],
						[
							-80.0729180909999,
							26.71767153500008
						],
						[
							-80.0739935069999,
							26.71627524200005
						],
						[
							-80.07402985399995,
							26.716231035000078
						],
						[
							-80.0740439409999,
							26.71621534700006
						],
						[
							-80.0747619409999,
							26.71543434700004
						],
						[
							-80.07478808299993,
							26.71540708300006
						],
						[
							-80.07483103499993,
							26.71536685400008
						],
						[
							-80.0748765269999,
							26.71532951900008
						],
						[
							-80.07489465399993,
							26.715315969000073
						],
						[
							-80.07522565499994,
							26.715074970000046
						],
						[
							-80.07525536399993,
							26.715054241000075
						],
						[
							-80.0753053389999,
							26.71502316400006
						],
						[
							-80.07534418499995,
							26.715001993000044
						],
						[
							-80.07560318499992,
							26.71486899300004
						],
						[
							-80.07561623999993,
							26.714862423000056
						],
						[
							-80.07566984399995,
							26.714838135000036
						],
						[
							-80.0757235019999,
							26.714817889000074
						],
						[
							-80.07589050199994,
							26.714760889000047
						],
						[
							-80.07589192299992,
							26.71476040500005
						],
						[
							-80.0759482389999,
							26.71474332200006
						],
						[
							-80.07600555099992,
							26.714729959000067
						],
						[
							-80.07606361499995,
							26.714720372000045
						],
						[
							-80.07612218199995,
							26.71471460400005
						],
						[
							-80.07612246999992,
							26.71471458500008
						],
						[
							-80.07616937799992,
							26.714711526000087
						],
						[
							-80.07687735499991,
							26.714966607000065
						],
						[
							-80.07761866999994,
							26.715328644000067
						],
						[
							-80.07811862599993,
							26.715587242000083
						],
						[
							-80.07834274399994,
							26.715742401000057
						],
						[
							-80.0784117039999,
							26.716311316000088
						],
						[
							-80.07848066299995,
							26.716742313000054
						],
						[
							-80.07839446399993,
							26.717276749000064
						],
						[
							-80.07817034499993,
							26.717776705000063
						],
						[
							-80.0777910679999,
							26.718259422000074
						],
						[
							-80.0773773109999,
							26.71881109700007
						],
						[
							-80.07694631499993,
							26.71938001300009
						],
						[
							-80.07673943599991,
							26.71967309100006
						],
						[
							-80.0766532369999,
							26.720000648000052
						],
						[
							-80.0766532369999,
							26.72032820600009
						],
						[
							-80.07672219599993,
							26.72062128400006
						],
						[
							-80.07689459499994,
							26.72115571900008
						],
						[
							-80.07710147299991,
							26.721724635000044
						],
						[
							-80.07720491299995,
							26.72198323300006
						],
						[
							-80.07736007199992,
							26.722655588000066
						],
						[
							-80.07741179099992,
							26.72305210500008
						],
						[
							-80.07744627099993,
							26.72367274000004
						],
						[
							-80.0774635109999,
							26.72403477800009
						],
						[
							-80.0772911119999,
							26.72510364900006
						],
						[
							-80.07691999999992,
							26.725104000000044
						],
						[
							-80.0761622409999,
							26.72508681700009
						],
						[
							-80.07546214399991,
							26.72504915400009
						],
						[
							-80.07427999999993,
							26.725040000000035
						],
						[
							-80.0715600019999,
							26.725039999000046
						],
						[
							-80.07115999699994,
							26.72494000200004
						],
						[
							-80.07064908099994,
							26.72494000100005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "West Palm Beach",
				"Name": "Roosevelt Estates",
				"RegionID": "269167"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.79156706299995,
					30.437700012000054,
					-81.70574990099993,
					30.518641040000034
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.75011990999991,
							30.50385001300009
						],
						[
							-81.74937490899993,
							30.503143013000056
						],
						[
							-81.7477609099999,
							30.501653012000077
						],
						[
							-81.74741890999991,
							30.501346013000042
						],
						[
							-81.74577190999993,
							30.499810012000072
						],
						[
							-81.74558190899995,
							30.499622012000092
						],
						[
							-81.74052890899992,
							30.494939012000092
						],
						[
							-81.74018190899994,
							30.494598013000083
						],
						[
							-81.73997990999993,
							30.49441201200006
						],
						[
							-81.73969790899993,
							30.494172012000035
						],
						[
							-81.73928090999993,
							30.493771012000078
						],
						[
							-81.7382609089999,
							30.49281101200006
						],
						[
							-81.73725090999994,
							30.491901012000085
						],
						[
							-81.73699790899991,
							30.49164301300004
						],
						[
							-81.73644690999994,
							30.491168013000053
						],
						[
							-81.73543590999992,
							30.490238012000077
						],
						[
							-81.73436490899991,
							30.48921901300008
						],
						[
							-81.73415590899992,
							30.48905601300004
						],
						[
							-81.73398790999994,
							30.488911013000067
						],
						[
							-81.73343690899992,
							30.488555013000052
						],
						[
							-81.73319990899995,
							30.48843901300006
						],
						[
							-81.73284890999992,
							30.488272012000042
						],
						[
							-81.73247490999995,
							30.488123013000067
						],
						[
							-81.73203990899992,
							30.487980012000037
						],
						[
							-81.73158290899994,
							30.487852013000065
						],
						[
							-81.73147590899993,
							30.487831013000065
						],
						[
							-81.73114790999995,
							30.48776101200008
						],
						[
							-81.72782890899992,
							30.486973013000068
						],
						[
							-81.72698190999995,
							30.486765012000035
						],
						[
							-81.72656190999993,
							30.48667301200004
						],
						[
							-81.7252959089999,
							30.48636801300006
						],
						[
							-81.72335790999995,
							30.48590701200004
						],
						[
							-81.72300690999992,
							30.485800013000073
						],
						[
							-81.72269390999992,
							30.485687012000085
						],
						[
							-81.72228990999993,
							30.48552701300008
						],
						[
							-81.72205390999994,
							30.485409013000034
						],
						[
							-81.7217559099999,
							30.48524101200007
						],
						[
							-81.72151890999993,
							30.485096012000046
						],
						[
							-81.72113790999992,
							30.484823012000046
						],
						[
							-81.72081790999994,
							30.484562012000083
						],
						[
							-81.72025290999994,
							30.484009013000048
						],
						[
							-81.71973390999995,
							30.483458013000075
						],
						[
							-81.71869690999995,
							30.48233001300008
						],
						[
							-81.71700290899992,
							30.480492013000056
						],
						[
							-81.71604390899995,
							30.479466013000035
						],
						[
							-81.71459290999991,
							30.477894012000036
						],
						[
							-81.71334990999992,
							30.476547012000083
						],
						[
							-81.71252691099994,
							30.475605012000074
						],
						[
							-81.7123039089999,
							30.47528601300007
						],
						[
							-81.71201290999994,
							30.474903012000084
						],
						[
							-81.71156290899995,
							30.474234013000057
						],
						[
							-81.70870990999993,
							30.469809012000045
						],
						[
							-81.70828190999993,
							30.469177012000046
						],
						[
							-81.70750490899991,
							30.46794801300007
						],
						[
							-81.7073519089999,
							30.467659012000073
						],
						[
							-81.7071909089999,
							30.467289013000084
						],
						[
							-81.70708490899995,
							30.466974012000037
						],
						[
							-81.7070079099999,
							30.466660013000077
						],
						[
							-81.70693190999992,
							30.466208013000085
						],
						[
							-81.70688590999993,
							30.46539901300008
						],
						[
							-81.7068709099999,
							30.46459001300008
						],
						[
							-81.70686290899994,
							30.46412101300007
						],
						[
							-81.70685290999995,
							30.46346801300007
						],
						[
							-81.7068299099999,
							30.462772012000077
						],
						[
							-81.70681790999993,
							30.46225501200007
						],
						[
							-81.70681590899994,
							30.46179601200004
						],
						[
							-81.7067839099999,
							30.461366012000042
						],
						[
							-81.70677590999993,
							30.460746013000065
						],
						[
							-81.70677890899992,
							30.46063801300005
						],
						[
							-81.70675590999991,
							30.460141013000058
						],
						[
							-81.70672190999994,
							30.459551012000073
						],
						[
							-81.70671090999991,
							30.459358013000042
						],
						[
							-81.7066509089999,
							30.458816013000046
						],
						[
							-81.70657190899993,
							30.458246012000075
						],
						[
							-81.70652190999994,
							30.458085012000087
						],
						[
							-81.70635290899992,
							30.457544012000085
						],
						[
							-81.70621090999994,
							30.456982013000072
						],
						[
							-81.70611590999994,
							30.456554013000073
						],
						[
							-81.70591690899994,
							30.455740013000078
						],
						[
							-81.70577790999994,
							30.455207012000074
						],
						[
							-81.70574990099993,
							30.455097010000088
						],
						[
							-81.70585490699995,
							30.45505501100007
						],
						[
							-81.7076469079999,
							30.45436201100006
						],
						[
							-81.70813590699993,
							30.454188011000042
						],
						[
							-81.7090899079999,
							30.45381601100007
						],
						[
							-81.70941290799993,
							30.453716010000054
						],
						[
							-81.70952590799993,
							30.453682010000076
						],
						[
							-81.71131090799993,
							30.45297401000005
						],
						[
							-81.71218390699994,
							30.45259201000005
						],
						[
							-81.71252390799992,
							30.45242901000006
						],
						[
							-81.7133709069999,
							30.45199001000009
						],
						[
							-81.71418790799993,
							30.451515011000083
						],
						[
							-81.71495090699995,
							30.451023010000085
						],
						[
							-81.71531690699993,
							30.450769010000048
						],
						[
							-81.71595890799995,
							30.45027801000009
						],
						[
							-81.71651790699991,
							30.44980501100008
						],
						[
							-81.71717190699991,
							30.449212011000046
						],
						[
							-81.71784490699991,
							30.448541011000092
						],
						[
							-81.71843890799994,
							30.447862010000055
						],
						[
							-81.7191309079999,
							30.446957011000055
						],
						[
							-81.71936490699994,
							30.44662101100005
						],
						[
							-81.72038290799992,
							30.44501601000007
						],
						[
							-81.7207959079999,
							30.44440601100007
						],
						[
							-81.72101590799991,
							30.444061011000088
						],
						[
							-81.72134190799994,
							30.443523010000035
						],
						[
							-81.72171790699991,
							30.442903010000062
						],
						[
							-81.72213990799992,
							30.442250011000056
						],
						[
							-81.72370390799995,
							30.439725010000075
						],
						[
							-81.72447790699994,
							30.438534010000073
						],
						[
							-81.72450898799991,
							30.438473055000088
						],
						[
							-81.72464491799991,
							30.438256016000082
						],
						[
							-81.7253809099999,
							30.438243012000044
						],
						[
							-81.72568290899996,
							30.438239012000054
						],
						[
							-81.72643090999992,
							30.43822701200008
						],
						[
							-81.72742290899993,
							30.438198012000043
						],
						[
							-81.72804390999994,
							30.43819101200006
						],
						[
							-81.72831490999994,
							30.438195013000044
						],
						[
							-81.72918290899992,
							30.43818801200007
						],
						[
							-81.72998691099991,
							30.438148012000056
						],
						[
							-81.73087290899991,
							30.438153012000043
						],
						[
							-81.7315569079999,
							30.438133014000076
						],
						[
							-81.73161591199994,
							30.438148010000077
						],
						[
							-81.7320199099999,
							30.43814301200007
						],
						[
							-81.7322919099999,
							30.438152012000046
						],
						[
							-81.73342890899994,
							30.43812901200005
						],
						[
							-81.73763990999993,
							30.438063012000043
						],
						[
							-81.73835690999994,
							30.438043012000033
						],
						[
							-81.73871590899995,
							30.438043012000033
						],
						[
							-81.73982390999993,
							30.438017012000046
						],
						[
							-81.74021090999992,
							30.43801501200005
						],
						[
							-81.74121390999994,
							30.437998013000083
						],
						[
							-81.74182090999994,
							30.437984012000076
						],
						[
							-81.74267590999995,
							30.437965012000063
						],
						[
							-81.74600990899995,
							30.43791401200008
						],
						[
							-81.74799290999994,
							30.437887012000093
						],
						[
							-81.75020590999992,
							30.43784701200008
						],
						[
							-81.75296190899991,
							30.43779601200004
						],
						[
							-81.75440990899995,
							30.437769012000047
						],
						[
							-81.75576790899993,
							30.437740012000063
						],
						[
							-81.75669090899993,
							30.437735012000076
						],
						[
							-81.75759090999992,
							30.437708013000076
						],
						[
							-81.7584079099999,
							30.437700012000054
						],
						[
							-81.75860590999991,
							30.43771001300007
						],
						[
							-81.7587969089999,
							30.43771901200006
						],
						[
							-81.75917790999996,
							30.43776301200006
						],
						[
							-81.75952890899993,
							30.437818012000037
						],
						[
							-81.76001590899995,
							30.43792601300004
						],
						[
							-81.76044390999994,
							30.43805701300005
						],
						[
							-81.76087090999994,
							30.438216013000044
						],
						[
							-81.76114490999993,
							30.438339012000085
						],
						[
							-81.76170390899995,
							30.43862401300004
						],
						[
							-81.76381490999995,
							30.439741011000084
						],
						[
							-81.76397390999995,
							30.439796013000038
						],
						[
							-81.76402990999992,
							30.439815011000064
						],
						[
							-81.76410490999992,
							30.43982601100004
						],
						[
							-81.76418790999992,
							30.43982601100004
						],
						[
							-81.76428790999996,
							30.439811012000067
						],
						[
							-81.76439996599993,
							30.439778830000076
						],
						[
							-81.7646157879999,
							30.44004376200007
						],
						[
							-81.76513590699994,
							30.44098401100007
						],
						[
							-81.76559990699991,
							30.44190801000008
						],
						[
							-81.76635190799993,
							30.443496011000033
						],
						[
							-81.76638790799991,
							30.443575011000068
						],
						[
							-81.76663090699992,
							30.44410601000004
						],
						[
							-81.76720790799993,
							30.44534401000004
						],
						[
							-81.76796090699992,
							30.44695901100005
						],
						[
							-81.76810190799995,
							30.447282011000087
						],
						[
							-81.76840090699994,
							30.44792001000007
						],
						[
							-81.76843090699992,
							30.44798301100008
						],
						[
							-81.7685299069999,
							30.44819401000007
						],
						[
							-81.76911890799994,
							30.449466011000084
						],
						[
							-81.76947690799994,
							30.450273011000036
						],
						[
							-81.76991190699994,
							30.451190010000065
						],
						[
							-81.77046890799994,
							30.452405010000067
						],
						[
							-81.77059090699993,
							30.45268901000009
						],
						[
							-81.77080390799995,
							30.453132010000047
						],
						[
							-81.77158890699991,
							30.45484501100009
						],
						[
							-81.77199390699991,
							30.45572001000005
						],
						[
							-81.77222981999995,
							30.45622117600004
						],
						[
							-81.77230590799991,
							30.45621301000006
						],
						[
							-81.77286390799992,
							30.456207010000075
						],
						[
							-81.77482590799991,
							30.456147010000052
						],
						[
							-81.7763599079999,
							30.456112010000087
						],
						[
							-81.77703890799995,
							30.456104010000047
						],
						[
							-81.77766390799991,
							30.45609300800004
						],
						[
							-81.77861790799994,
							30.455759010000065
						],
						[
							-81.77962493099994,
							30.455380945000062
						],
						[
							-81.78406520199991,
							30.45960363300009
						],
						[
							-81.78445573999994,
							30.462729989000085
						],
						[
							-81.78465122299991,
							30.469373301000076
						],
						[
							-81.78484653299995,
							30.484027702000052
						],
						[
							-81.78797288099992,
							30.490280216000087
						],
						[
							-81.7887544489999,
							30.49321109500005
						],
						[
							-81.78973140799991,
							30.498486672000073
						],
						[
							-81.79128905499994,
							30.50447912700008
						],
						[
							-81.79156706299995,
							30.505512336000038
						],
						[
							-81.79144699999995,
							30.505519000000053
						],
						[
							-81.79119299999991,
							30.505540000000053
						],
						[
							-81.79113699999995,
							30.505536000000063
						],
						[
							-81.79111299999994,
							30.50553400000007
						],
						[
							-81.78675482299991,
							30.50452473300004
						],
						[
							-81.7816259999999,
							30.503337000000045
						],
						[
							-81.77659203499991,
							30.50800160100005
						],
						[
							-81.76897922599994,
							30.515055826000037
						],
						[
							-81.7653259999999,
							30.518441000000053
						],
						[
							-81.76532064199995,
							30.518641040000034
						],
						[
							-81.76248890999995,
							30.517317013000085
						],
						[
							-81.76231390999993,
							30.517227013000085
						],
						[
							-81.76177190999994,
							30.516903012000057
						],
						[
							-81.7616039099999,
							30.516779013000075
						],
						[
							-81.76148190999993,
							30.516689012000082
						],
						[
							-81.76118490999994,
							30.516424012000073
						],
						[
							-81.76094083999993,
							30.516159071000065
						],
						[
							-81.76072690899991,
							30.515879012000088
						],
						[
							-81.7605439109999,
							30.515594012000065
						],
						[
							-81.76039890899995,
							30.515310012000043
						],
						[
							-81.76021590999994,
							30.51499401200005
						],
						[
							-81.75884990899993,
							30.512465013000053
						],
						[
							-81.75859790899995,
							30.512035012000073
						],
						[
							-81.75822390999991,
							30.511517013000056
						],
						[
							-81.75785790899994,
							30.511076012000046
						],
						[
							-81.75771390999995,
							30.51091401200006
						],
						[
							-81.7570119099999,
							30.510268013000086
						],
						[
							-81.75684590899994,
							30.510104012000056
						],
						[
							-81.75594390899994,
							30.509266013000055
						],
						[
							-81.7557549089999,
							30.509078013000074
						],
						[
							-81.75499290899995,
							30.508368013000055
						],
						[
							-81.75391290899995,
							30.507385012000043
						],
						[
							-81.75354490899991,
							30.50702901300008
						],
						[
							-81.7520129099999,
							30.50561801300006
						],
						[
							-81.75164490999992,
							30.505263012000057
						],
						[
							-81.75011990999991,
							30.50385001300009
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Forest Trails",
				"RegionID": "268989"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.0622633399999,
					26.697900979000057,
					-80.05560766199994,
					26.705850000000055
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.06115674699993,
							26.705770000000086
						],
						[
							-80.06091029899994,
							26.705762079000067
						],
						[
							-80.06066259499994,
							26.70577122700007
						],
						[
							-80.06033414799992,
							26.705785934000062
						],
						[
							-80.06013220499995,
							26.70579497600005
						],
						[
							-80.0598163059999,
							26.705800000000067
						],
						[
							-80.05983646299991,
							26.704813332000075
						],
						[
							-80.05983999999995,
							26.70464000000004
						],
						[
							-80.05984599499993,
							26.704493119000063
						],
						[
							-80.05985645599992,
							26.70423682900008
						],
						[
							-80.05986912099992,
							26.703926524000053
						],
						[
							-80.05987999999991,
							26.70366000000007
						],
						[
							-80.05988927499993,
							26.703478218000043
						],
						[
							-80.05990095199991,
							26.703249335000066
						],
						[
							-80.0599158629999,
							26.702957091000087
						],
						[
							-80.05992232799991,
							26.70283036300009
						],
						[
							-80.0599265859999,
							26.702746910000087
						],
						[
							-80.05992999999995,
							26.702680000000043
						],
						[
							-80.05974006499991,
							26.702673873000037
						],
						[
							-80.0595203609999,
							26.70267000000007
						],
						[
							-80.05908157599993,
							26.70265538700005
						],
						[
							-80.05832270799993,
							26.70263093500006
						],
						[
							-80.05793999999992,
							26.70262000000008
						],
						[
							-80.05780173599993,
							26.702617289000045
						],
						[
							-80.05761879099994,
							26.702613702000065
						],
						[
							-80.0574299999999,
							26.70261000000005
						],
						[
							-80.05706738899994,
							26.702603525000086
						],
						[
							-80.05701979499992,
							26.702602675000037
						],
						[
							-80.05694236099993,
							26.702601292000054
						],
						[
							-80.05686999999995,
							26.702600000000075
						],
						[
							-80.0568675319999,
							26.70271971300008
						],
						[
							-80.05686394799994,
							26.702893522000068
						],
						[
							-80.05686018799993,
							26.70307590400006
						],
						[
							-80.05685641199995,
							26.703259039000045
						],
						[
							-80.05685320099992,
							26.70341476100009
						],
						[
							-80.05684999999994,
							26.70357000000007
						],
						[
							-80.05676869599995,
							26.70356859800006
						],
						[
							-80.05666816599995,
							26.703566865000084
						],
						[
							-80.05652194099991,
							26.703564344000085
						],
						[
							-80.05638469599995,
							26.70356197800004
						],
						[
							-80.05626999999993,
							26.70356000000004
						],
						[
							-80.0562019219999,
							26.70355866500006
						],
						[
							-80.05607398599994,
							26.703556157000037
						],
						[
							-80.05590895899991,
							26.70355292100004
						],
						[
							-80.0558304139999,
							26.703551381000068
						],
						[
							-80.0557599999999,
							26.703550000000064
						],
						[
							-80.05560766199994,
							26.70355165300009
						],
						[
							-80.05563508799992,
							26.701357617000042
						],
						[
							-80.0557447889999,
							26.69809398700005
						],
						[
							-80.05573856299992,
							26.697900979000057
						],
						[
							-80.05589990999994,
							26.697903284000063
						],
						[
							-80.05635937899991,
							26.69790984800005
						],
						[
							-80.05702999999994,
							26.697920000000067
						],
						[
							-80.05728556499992,
							26.69792456400006
						],
						[
							-80.05763776599991,
							26.69793085300006
						],
						[
							-80.05814999999991,
							26.697940000000074
						],
						[
							-80.0583732039999,
							26.697967901000084
						],
						[
							-80.05869506399995,
							26.69797782200004
						],
						[
							-80.05917776299992,
							26.697987366000064
						],
						[
							-80.0601299999999,
							26.698000000000036
						],
						[
							-80.06031528199992,
							26.698004411000056
						],
						[
							-80.06051648999994,
							26.698009202000037
						],
						[
							-80.0609294439999,
							26.698019034000083
						],
						[
							-80.06155318799995,
							26.698033885000086
						],
						[
							-80.06222999999994,
							26.69805000000008
						],
						[
							-80.0622633399999,
							26.698050940000087
						],
						[
							-80.06226226899993,
							26.698079500000066
						],
						[
							-80.06226162799993,
							26.69809659300006
						],
						[
							-80.06225709599994,
							26.698145374000035
						],
						[
							-80.06205994699991,
							26.69873999100008
						],
						[
							-80.06200002799994,
							26.698876819000077
						],
						[
							-80.06193528699994,
							26.699004279000064
						],
						[
							-80.06187417799993,
							26.699124588000075
						],
						[
							-80.06179824499992,
							26.699274079000077
						],
						[
							-80.06176064699991,
							26.699392252000052
						],
						[
							-80.06173291399995,
							26.699520152000048
						],
						[
							-80.06170474299995,
							26.699757773000044
						],
						[
							-80.06169402199993,
							26.699977546000074
						],
						[
							-80.06166684099992,
							26.700534763000064
						],
						[
							-80.06163743499991,
							26.70113758000008
						],
						[
							-80.06161290099993,
							26.70164052100006
						],
						[
							-80.06158701099992,
							26.702171268000086
						],
						[
							-80.06156067599994,
							26.702711134000083
						],
						[
							-80.06153169399994,
							26.703305277000084
						],
						[
							-80.06151429999994,
							26.70366185100005
						],
						[
							-80.06149516999994,
							26.704054016000043
						],
						[
							-80.06149266799991,
							26.704218696000055
						],
						[
							-80.06149999999991,
							26.70438000000007
						],
						[
							-80.06150811599993,
							26.70449363000006
						],
						[
							-80.06151600499993,
							26.704604074000088
						],
						[
							-80.06152888399993,
							26.70472218900005
						],
						[
							-80.06154332799991,
							26.704823297000075
						],
						[
							-80.06156388799991,
							26.704960306000093
						],
						[
							-80.06161752999992,
							26.705240433000085
						],
						[
							-80.06164999999993,
							26.70540744300007
						],
						[
							-80.06170541499995,
							26.70561514700006
						],
						[
							-80.06174246299992,
							26.705749865000087
						],
						[
							-80.06176999999991,
							26.705850000000055
						],
						[
							-80.06161357499991,
							26.705820205000066
						],
						[
							-80.06139681199994,
							26.70577891700009
						],
						[
							-80.06115674699993,
							26.705770000000086
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "West Palm Beach",
				"Name": "Grandview Heights",
				"RegionID": "268996"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.4200677508587,
					28.543561999793297,
					-81.41399000038433,
					28.55244212134783
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.4193853713832,
							28.552328981240677
						],
						[
							-81.41868249545934,
							28.551560508768
						],
						[
							-81.41798739147643,
							28.551572695480797
						],
						[
							-81.4175736556789,
							28.551582853323097
						],
						[
							-81.41756075940098,
							28.551480558140195
						],
						[
							-81.41755488413023,
							28.550635170251702
						],
						[
							-81.4171710471928,
							28.550636172995723
						],
						[
							-81.41718337509921,
							28.551015946796127
						],
						[
							-81.41711603116764,
							28.551073907201584
						],
						[
							-81.41708204848617,
							28.551167093151648
						],
						[
							-81.41704813325376,
							28.551259339310185
						],
						[
							-81.41677864601175,
							28.551427648327305
						],
						[
							-81.41652409650867,
							28.551427620448276
						],
						[
							-81.41651420666433,
							28.551308301998752
						],
						[
							-81.41640316377602,
							28.55064316972114
						],
						[
							-81.41616769249045,
							28.55064932558043
						],
						[
							-81.4161296367795,
							28.55064932558043
						],
						[
							-81.41608957558034,
							28.55065032562652
						],
						[
							-81.41546064551108,
							28.55064932558043
						],
						[
							-81.41452625891579,
							28.550712418416722
						],
						[
							-81.41414756969776,
							28.550725571900713
						],
						[
							-81.41414268817776,
							28.550582226264552
						],
						[
							-81.41408460186724,
							28.549865161736975
						],
						[
							-81.41409161298178,
							28.549146095318655
						],
						[
							-81.41415470761672,
							28.548383964864883
						],
						[
							-81.4141276991775,
							28.54765522983532
						],
						[
							-81.41412598506972,
							28.547632667644358
						],
						[
							-81.41417399987287,
							28.547630000255207
						],
						[
							-81.41411399980502,
							28.546968000316163
						],
						[
							-81.41401899992249,
							28.54611399962058
						],
						[
							-81.41400200003814,
							28.5438790000167
						],
						[
							-81.41399000038433,
							28.543561999793297
						],
						[
							-81.41446199965894,
							28.5439119997393
						],
						[
							-81.41447200011984,
							28.54418199959484
						],
						[
							-81.41489799997194,
							28.54418199959484
						],
						[
							-81.4151141565183,
							28.544328223960875
						],
						[
							-81.41537400033009,
							28.544504000048782
						],
						[
							-81.41456402144782,
							28.544504000048782
						],
						[
							-81.41448199968146,
							28.544504000048782
						],
						[
							-81.41448199968146,
							28.54556600043997
						],
						[
							-81.41458099974845,
							28.54556600043997
						],
						[
							-81.41458399988672,
							28.546268000424156
						],
						[
							-81.41458099974845,
							28.546405000444196
						],
						[
							-81.4149919998084,
							28.546504999657905
						],
						[
							-81.41609400024471,
							28.546743999883113
						],
						[
							-81.41836100042431,
							28.54750900007342
						],
						[
							-81.41896300029558,
							28.54760099981769
						],
						[
							-81.41895900011113,
							28.548854000020036
						],
						[
							-81.41878500018422,
							28.54885099988186
						],
						[
							-81.4187880003225,
							28.54923899978091
						],
						[
							-81.41834599973294,
							28.54924199991909
						],
						[
							-81.41844299970766,
							28.54937899993913
						],
						[
							-81.41908999985453,
							28.5493820000774
						],
						[
							-81.41960900039628,
							28.549396999869565
						],
						[
							-81.41960900039628,
							28.54927899982605
						],
						[
							-81.41960900039628,
							28.54886000029667
						],
						[
							-81.4200677508587,
							28.54886000029667
						],
						[
							-81.4200675934773,
							28.55244212134783
						],
						[
							-81.4193853713832,
							28.552328981240677
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Haralson Estates",
				"RegionID": "268998"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.3106499999999,
					28.545863000000057,
					-81.3057619999999,
					28.553423000000066
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.3076549999999,
							28.553423000000066
						],
						[
							-81.3074049999999,
							28.553405000000055
						],
						[
							-81.30706634199993,
							28.55341594500004
						],
						[
							-81.30687899999992,
							28.55342200000007
						],
						[
							-81.30686799999995,
							28.550966000000074
						],
						[
							-81.3068659999999,
							28.549942000000044
						],
						[
							-81.30839599999992,
							28.549942000000044
						],
						[
							-81.30838499999993,
							28.548760000000073
						],
						[
							-81.30838799999992,
							28.548152000000073
						],
						[
							-81.30811699999992,
							28.548152000000073
						],
						[
							-81.30811699999992,
							28.549041000000045
						],
						[
							-81.3082159999999,
							28.549041000000045
						],
						[
							-81.3082839999999,
							28.54903900000005
						],
						[
							-81.30827699999992,
							28.549758000000054
						],
						[
							-81.30809199999993,
							28.549767000000088
						],
						[
							-81.3068669999999,
							28.549787000000038
						],
						[
							-81.30592072099995,
							28.549787856000084
						],
						[
							-81.3057619999999,
							28.549788000000035
						],
						[
							-81.30576203099992,
							28.54974052700004
						],
						[
							-81.3057629999999,
							28.548276000000048
						],
						[
							-81.3057629999999,
							28.54814300000004
						],
						[
							-81.30658999999991,
							28.548079000000087
						],
						[
							-81.3068659999999,
							28.548079000000087
						],
						[
							-81.3068649999999,
							28.546310000000062
						],
						[
							-81.3080359999999,
							28.546309000000065
						],
						[
							-81.30857999999995,
							28.546306000000076
						],
						[
							-81.30857999999995,
							28.546173000000067
						],
						[
							-81.30857899999997,
							28.54586800000004
						],
						[
							-81.30867399999994,
							28.54586800000004
						],
						[
							-81.30874899999992,
							28.54586900000004
						],
						[
							-81.30875099999992,
							28.546230000000037
						],
						[
							-81.3087549999999,
							28.546309000000065
						],
						[
							-81.30898599999995,
							28.546308000000067
						],
						[
							-81.30899099999993,
							28.546219000000065
						],
						[
							-81.30898899999994,
							28.54586400000005
						],
						[
							-81.30978899999991,
							28.54586400000005
						],
						[
							-81.3099069999999,
							28.545863000000057
						],
						[
							-81.30990899999995,
							28.54608200000007
						],
						[
							-81.30990899999995,
							28.546316000000047
						],
						[
							-81.31055399999991,
							28.546316000000047
						],
						[
							-81.3106459999999,
							28.546910000000082
						],
						[
							-81.3106459999999,
							28.546952842000056
						],
						[
							-81.3106459999999,
							28.54712200000006
						],
						[
							-81.3106469999999,
							28.547173000000043
						],
						[
							-81.3106499999999,
							28.54728077900006
						],
						[
							-81.3106499999999,
							28.54738452400005
						],
						[
							-81.3106493869999,
							28.547384494000084
						],
						[
							-81.31059699999993,
							28.547382000000084
						],
						[
							-81.31059859299997,
							28.547541300000034
						],
						[
							-81.3106029999999,
							28.547982000000047
						],
						[
							-81.3098819999999,
							28.54797700000006
						],
						[
							-81.30978299999992,
							28.54797700000006
						],
						[
							-81.30978299999992,
							28.548080000000084
						],
						[
							-81.30978299999992,
							28.549040000000048
						],
						[
							-81.30948999999993,
							28.54903900000005
						],
						[
							-81.30936824999992,
							28.54903900000005
						],
						[
							-81.30924699999991,
							28.54903900000005
						],
						[
							-81.30924699999991,
							28.54911877300009
						],
						[
							-81.30924699999991,
							28.549880000000087
						],
						[
							-81.30908999999991,
							28.54987900000009
						],
						[
							-81.3088899999999,
							28.54987900000009
						],
						[
							-81.3088899999999,
							28.550379000000078
						],
						[
							-81.3088909999999,
							28.55289900000008
						],
						[
							-81.3091399999999,
							28.552860000000067
						],
						[
							-81.3093409999999,
							28.55297900000005
						],
						[
							-81.30908999999991,
							28.553079000000086
						],
						[
							-81.3088909999999,
							28.553177000000062
						],
						[
							-81.3088909999999,
							28.55342200000007
						],
						[
							-81.3076549999999,
							28.553423000000066
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Hibiscus",
				"RegionID": "269005"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.22877199999994,
					25.81189100000006,
					-80.20577259499993,
					25.847613000000084
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.20901199999992,
							25.847613000000084
						],
						[
							-80.20901199999992,
							25.847575000000063
						],
						[
							-80.20821299999994,
							25.847591000000083
						],
						[
							-80.20815299999992,
							25.847589000000088
						],
						[
							-80.2077549999999,
							25.84760200000005
						],
						[
							-80.20769208899992,
							25.84760425400009
						],
						[
							-80.20758216199994,
							25.847608193000042
						],
						[
							-80.2072181819999,
							25.847563584000056
						],
						[
							-80.20715454499994,
							25.847572727000056
						],
						[
							-80.20712557299993,
							25.847573871000066
						],
						[
							-80.20707272599992,
							25.846963637000044
						],
						[
							-80.20627272799993,
							25.84326363500009
						],
						[
							-80.20617272599992,
							25.835881819000065
						],
						[
							-80.20577259499993,
							25.82957270500009
						],
						[
							-80.20647285899992,
							25.82757275000006
						],
						[
							-80.20589124199995,
							25.812268339000074
						],
						[
							-80.20776900599992,
							25.81243121000006
						],
						[
							-80.21022180699993,
							25.812322793000078
						],
						[
							-80.22407445099992,
							25.811976704000074
						],
						[
							-80.22589247999991,
							25.812090330000046
						],
						[
							-80.22805912699994,
							25.811939445000064
						],
						[
							-80.2280889999999,
							25.81189100000006
						],
						[
							-80.22810399999992,
							25.81213500000007
						],
						[
							-80.22811899999994,
							25.812448000000074
						],
						[
							-80.22812299999993,
							25.812538000000075
						],
						[
							-80.22814599999992,
							25.813034000000073
						],
						[
							-80.22812799999991,
							25.813194000000067
						],
						[
							-80.2281372189999,
							25.81339129400004
						],
						[
							-80.22816299999994,
							25.81394300000005
						],
						[
							-80.22823799999992,
							25.81468300000006
						],
						[
							-80.22826999999995,
							25.815439000000083
						],
						[
							-80.22831799999994,
							25.816188000000068
						],
						[
							-80.22834999999992,
							25.81691100000006
						],
						[
							-80.2283809999999,
							25.817661000000044
						],
						[
							-80.22840599999995,
							25.818404000000044
						],
						[
							-80.22843899999994,
							25.819105000000036
						],
						[
							-80.22845099999995,
							25.819878000000074
						],
						[
							-80.22849599999995,
							25.820644000000073
						],
						[
							-80.22850799999992,
							25.821365000000075
						],
						[
							-80.2285359999999,
							25.82210000000009
						],
						[
							-80.22856499999995,
							25.82282100000009
						],
						[
							-80.22859399999993,
							25.823503000000073
						],
						[
							-80.22862299999993,
							25.824299000000053
						],
						[
							-80.22866899999991,
							25.825074000000086
						],
						[
							-80.22866987499992,
							25.825099788000045
						],
						[
							-80.2286939999999,
							25.825811000000044
						],
						[
							-80.22872199999995,
							25.82654000000008
						],
						[
							-80.22874699999994,
							25.82725000000005
						],
						[
							-80.22877199999994,
							25.82794700000005
						],
						[
							-80.2267819999999,
							25.82802600000008
						],
						[
							-80.22527291499995,
							25.82808651000005
						],
						[
							-80.2251359999999,
							25.828092000000083
						],
						[
							-80.22513099999992,
							25.82816200000008
						],
						[
							-80.2251599999999,
							25.82897200000008
						],
						[
							-80.22517199999993,
							25.829077000000044
						],
						[
							-80.2251839999999,
							25.829504000000043
						],
						[
							-80.22521299999994,
							25.829935000000035
						],
						[
							-80.2252910869999,
							25.829931871000042
						],
						[
							-80.22573699999992,
							25.829914000000088
						],
						[
							-80.22571199999993,
							25.829977000000042
						],
						[
							-80.22576499999992,
							25.83078100000006
						],
						[
							-80.22530099999994,
							25.830792000000088
						],
						[
							-80.22530463399994,
							25.830891989000065
						],
						[
							-80.22533199999992,
							25.831645000000037
						],
						[
							-80.22533599999991,
							25.831729000000053
						],
						[
							-80.22525799999994,
							25.831732000000045
						],
						[
							-80.2252857709999,
							25.83237569700009
						],
						[
							-80.22528599999993,
							25.83238100000006
						],
						[
							-80.2252841859999,
							25.83241969900007
						],
						[
							-80.22528299999993,
							25.832445000000064
						],
						[
							-80.22530499999993,
							25.832914000000073
						],
						[
							-80.22531099999992,
							25.83296500000006
						],
						[
							-80.22533699999991,
							25.833576000000054
						],
						[
							-80.2253619999999,
							25.834173000000078
						],
						[
							-80.22540299999991,
							25.834782000000075
						],
						[
							-80.22542299999992,
							25.835376000000053
						],
						[
							-80.22544099999993,
							25.83595900000006
						],
						[
							-80.22546699999992,
							25.836591000000055
						],
						[
							-80.22549199999992,
							25.83716700000008
						],
						[
							-80.22552399999995,
							25.837851000000057
						],
						[
							-80.22555699999992,
							25.838448000000085
						],
						[
							-80.2255669999999,
							25.83911500000005
						],
						[
							-80.2252519999999,
							25.839124000000083
						],
						[
							-80.22501802699992,
							25.839131572000042
						],
						[
							-80.22432499999991,
							25.839154000000068
						],
						[
							-80.22431590799994,
							25.83915439200007
						],
						[
							-80.22358199999991,
							25.83918600000004
						],
						[
							-80.22345441399995,
							25.83918955300004
						],
						[
							-80.22318699999994,
							25.83919700000007
						],
						[
							-80.22278699999993,
							25.83921200000009
						],
						[
							-80.22274559499994,
							25.839213356000077
						],
						[
							-80.2211079999999,
							25.839267000000063
						],
						[
							-80.21905099999992,
							25.839330000000075
						],
						[
							-80.21731788599993,
							25.839391697000053
						],
						[
							-80.21719699999994,
							25.83939600000008
						],
						[
							-80.21699499999994,
							25.83940300000006
						],
						[
							-80.21667420699993,
							25.839414007000073
						],
						[
							-80.21550938299993,
							25.839453977000062
						],
						[
							-80.21547275099994,
							25.83945523400007
						],
						[
							-80.2149908749999,
							25.839471769000056
						],
						[
							-80.21495499999992,
							25.839473000000055
						],
						[
							-80.2131543239999,
							25.83952927100006
						],
						[
							-80.21293899999995,
							25.839536000000066
						],
						[
							-80.21089499999994,
							25.839608000000055
						],
						[
							-80.2094009999999,
							25.83965900000004
						],
						[
							-80.20941499999992,
							25.839765000000057
						],
						[
							-80.20946099999992,
							25.840688000000057
						],
						[
							-80.20945741299994,
							25.840748981000047
						],
						[
							-80.20945699999993,
							25.840756000000056
						],
						[
							-80.20945599999993,
							25.84083700000008
						],
						[
							-80.20946156999992,
							25.84095481500009
						],
						[
							-80.20947599999994,
							25.84126000000009
						],
						[
							-80.20947953399991,
							25.84129534400006
						],
						[
							-80.20948499999992,
							25.84135000000009
						],
						[
							-80.2094889999999,
							25.841383000000064
						],
						[
							-80.20950499999992,
							25.841520000000063
						],
						[
							-80.20952299999993,
							25.841877000000068
						],
						[
							-80.2095139999999,
							25.841942000000078
						],
						[
							-80.2095369999999,
							25.842562000000044
						],
						[
							-80.20954799999993,
							25.842633000000035
						],
						[
							-80.20955199999992,
							25.84269800000004
						],
						[
							-80.20956699999994,
							25.843282000000045
						],
						[
							-80.20957299999992,
							25.84335800000008
						],
						[
							-80.2095819999999,
							25.843431000000066
						],
						[
							-80.2096168029999,
							25.84407635000008
						],
						[
							-80.20961699999992,
							25.844080000000076
						],
						[
							-80.20965699999994,
							25.84482200000008
						],
						[
							-80.20966502499994,
							25.845233008000037
						],
						[
							-80.2096709999999,
							25.845539000000088
						],
						[
							-80.2096722199999,
							25.845582094000065
						],
						[
							-80.2096919999999,
							25.84628100000009
						],
						[
							-80.20969799999995,
							25.84690900000004
						],
						[
							-80.20969599999995,
							25.84702400000009
						],
						[
							-80.20968599999993,
							25.847131000000047
						],
						[
							-80.2096889849999,
							25.847496138000054
						],
						[
							-80.20968899999991,
							25.847498000000087
						],
						[
							-80.20956875299993,
							25.847501485000066
						],
						[
							-80.20955987699995,
							25.847501743000066
						],
						[
							-80.20955099999992,
							25.847502000000077
						],
						[
							-80.20955499999991,
							25.84760700000004
						],
						[
							-80.20914599999992,
							25.847613000000084
						],
						[
							-80.20901199999992,
							25.847613000000084
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami",
				"Name": "Liberty City",
				"RegionID": "269093"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.63069093999991,
					30.215638198000075,
					-81.61556990799994,
					30.24325219600007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.62471790899993,
							30.241179010000053
						],
						[
							-81.62446590699994,
							30.240864010000053
						],
						[
							-81.62383990699993,
							30.240135011000064
						],
						[
							-81.62325990699992,
							30.23947001000005
						],
						[
							-81.62261191099992,
							30.238697012000046
						],
						[
							-81.62259685999993,
							30.238665042000036
						],
						[
							-81.62230690699994,
							30.23835401100007
						],
						[
							-81.62190990699992,
							30.23788501100006
						],
						[
							-81.62180790699995,
							30.237770011000062
						],
						[
							-81.6214449069999,
							30.237357011000086
						],
						[
							-81.62125590799991,
							30.237155010000038
						],
						[
							-81.62118490799992,
							30.237078010000065
						],
						[
							-81.62093390699994,
							30.23678401100005
						],
						[
							-81.62068890799992,
							30.236469010000068
						],
						[
							-81.62063590799994,
							30.236416010000088
						],
						[
							-81.62011690799994,
							30.23584201100005
						],
						[
							-81.61994890799991,
							30.23564101100004
						],
						[
							-81.61959090699992,
							30.235214010000046
						],
						[
							-81.61897990799991,
							30.234524010000086
						],
						[
							-81.61830090699993,
							30.233706010000052
						],
						[
							-81.6177599429999,
							30.23307596700005
						],
						[
							-81.61765390799991,
							30.232948011000076
						],
						[
							-81.61742790799993,
							30.23260901000009
						],
						[
							-81.61734485799991,
							30.232436028000055
						],
						[
							-81.6173359579999,
							30.232397991000084
						],
						[
							-81.61720090999997,
							30.23212301200005
						],
						[
							-81.6171399079999,
							30.23190101100005
						],
						[
							-81.61709690799997,
							30.23174201000006
						],
						[
							-81.6169609069999,
							30.230893011000035
						],
						[
							-81.61688990699992,
							30.230276011000058
						],
						[
							-81.61682090699992,
							30.22975501000008
						],
						[
							-81.61677690699992,
							30.22930701000007
						],
						[
							-81.61672990699992,
							30.228964010000087
						],
						[
							-81.61672090799993,
							30.228922011000066
						],
						[
							-81.6167149069999,
							30.22888801000005
						],
						[
							-81.61668390699992,
							30.228693010000082
						],
						[
							-81.61656990699993,
							30.22814401000005
						],
						[
							-81.61630990799995,
							30.226927010000054
						],
						[
							-81.61625690699992,
							30.226631011000052
						],
						[
							-81.61622590799993,
							30.22650501000004
						],
						[
							-81.61597390799994,
							30.225361011000075
						],
						[
							-81.61593590699994,
							30.22519901000004
						],
						[
							-81.61579890699994,
							30.22457501000008
						],
						[
							-81.61575290799993,
							30.224295011000038
						],
						[
							-81.61559290699995,
							30.223616011000043
						],
						[
							-81.61557790799992,
							30.223520010000072
						],
						[
							-81.61556990799994,
							30.223211010000053
						],
						[
							-81.61557790799992,
							30.22301301000005
						],
						[
							-81.61559290699995,
							30.222673011000044
						],
						[
							-81.6156039089999,
							30.22247301300007
						],
						[
							-81.61566490799993,
							30.222235010000077
						],
						[
							-81.61569290699993,
							30.22214701000007
						],
						[
							-81.61575490799993,
							30.221946011000057
						],
						[
							-81.61587490799991,
							30.221632010000064
						],
						[
							-81.61611890699993,
							30.22103101100004
						],
						[
							-81.61623390699992,
							30.220720011000083
						],
						[
							-81.61627990699992,
							30.22062101100005
						],
						[
							-81.61663090799993,
							30.219725011000033
						],
						[
							-81.61684390699992,
							30.21920001100006
						],
						[
							-81.61694290799994,
							30.218903011000066
						],
						[
							-81.61715890799991,
							30.21816401100006
						],
						[
							-81.6172049079999,
							30.217915010000066
						],
						[
							-81.61722990699991,
							30.21777901100006
						],
						[
							-81.61725690799994,
							30.217576011000062
						],
						[
							-81.61730690799993,
							30.21719101000008
						],
						[
							-81.61738099999991,
							30.21661400000005
						],
						[
							-81.61746097799994,
							30.215991142000064
						],
						[
							-81.6179477789999,
							30.215899867000076
						],
						[
							-81.6188897859999,
							30.215795199000073
						],
						[
							-81.61951779099991,
							30.215742866000085
						],
						[
							-81.62030279699992,
							30.215847533000044
						],
						[
							-81.62145413899992,
							30.215690532000057
						],
						[
							-81.62218681099995,
							30.215638198000075
						],
						[
							-81.62244847999995,
							30.215899867000076
						],
						[
							-81.62312534999995,
							30.216618316000048
						],
						[
							-81.62295557199991,
							30.21743668300007
						],
						[
							-81.6229340129999,
							30.21752022700008
						],
						[
							-81.62267256799994,
							30.218363811000078
						],
						[
							-81.6221979789999,
							30.221027392000057
						],
						[
							-81.62419283199995,
							30.229986574000066
						],
						[
							-81.62446271499994,
							30.231199063000076
						],
						[
							-81.62477664099993,
							30.232477694000067
						],
						[
							-81.62601249599993,
							30.234256215000077
						],
						[
							-81.63029233899994,
							30.240465417000053
						],
						[
							-81.63035749199992,
							30.240545606000072
						],
						[
							-81.63069093999991,
							30.24094585100005
						],
						[
							-81.62966299999994,
							30.241117000000088
						],
						[
							-81.62957199999994,
							30.24100500000009
						],
						[
							-81.62907284199991,
							30.24115889400008
						],
						[
							-81.6288909079999,
							30.241309010000066
						],
						[
							-81.6265338959999,
							30.24325219600007
						],
						[
							-81.62633290799994,
							30.243035011000075
						],
						[
							-81.62612990699995,
							30.242794010000072
						],
						[
							-81.62567595799993,
							30.242291983000086
						],
						[
							-81.62532490699994,
							30.24188201000004
						],
						[
							-81.62485490699993,
							30.241333010000062
						],
						[
							-81.62471790899993,
							30.241179010000053
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Monclair",
				"RegionID": "269094"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.4323107521496,
					28.523290000000074,
					-81.42605037768126,
					28.52736000027315
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.43171343357082,
							28.523304134130832
						],
						[
							-81.43230000000003,
							28.523290000000074
						],
						[
							-81.43230202567007,
							28.523417617215003
						],
						[
							-81.43230421293484,
							28.52355541490133
						],
						[
							-81.43230736121247,
							28.52375375638635
						],
						[
							-81.43231000000006,
							28.524089231153155
						],
						[
							-81.43230720365104,
							28.524348632050277
						],
						[
							-81.43230156642427,
							28.52460794448527
						],
						[
							-81.43229757999646,
							28.524791320158577
						],
						[
							-81.43229227437128,
							28.525035378920755
						],
						[
							-81.4322873003476,
							28.5252641840103
						],
						[
							-81.43228564233972,
							28.525340452373392
						],
						[
							-81.43228164870337,
							28.525524159648207
						],
						[
							-81.43227534827324,
							28.52581397942847
						],
						[
							-81.43227104466146,
							28.526011945571234
						],
						[
							-81.43227331973084,
							28.52614963273477
						],
						[
							-81.43227614194868,
							28.526225832615047
						],
						[
							-81.43228235082786,
							28.526393472351714
						],
						[
							-81.43229083838652,
							28.526622636436045
						],
						[
							-81.4323107521496,
							28.526883440187
						],
						[
							-81.4322970800276,
							28.527330035138597
						],
						[
							-81.43210099976933,
							28.527330999835627
						],
						[
							-81.43179300715526,
							28.52733266358139
						],
						[
							-81.43080500028267,
							28.52733800015826
						],
						[
							-81.43029300006357,
							28.527342000342713
						],
						[
							-81.42819300038755,
							28.52736000027315
						],
						[
							-81.42630499984604,
							28.52735099992921
						],
						[
							-81.42607673270795,
							28.52734991181179
						],
						[
							-81.42607538659026,
							28.527026285250507
						],
						[
							-81.42606937821992,
							28.526097913320953
						],
						[
							-81.42605936247044,
							28.525205590714926
						],
						[
							-81.42606236800466,
							28.52484405426597
						],
						[
							-81.42606136615993,
							28.524719870484226
						],
						[
							-81.42605335409993,
							28.52393470569522
						],
						[
							-81.42605037768126,
							28.5234009663981
						],
						[
							-81.42631105296165,
							28.523394608464365
						],
						[
							-81.4269523729013,
							28.523378966514677
						],
						[
							-81.42756281722917,
							28.523364077628727
						],
						[
							-81.42794411243695,
							28.523354777745553
						],
						[
							-81.42832552833723,
							28.523347055105695
						],
						[
							-81.42864616829618,
							28.523341965582667
						],
						[
							-81.42892085594471,
							28.52334000000004
						],
						[
							-81.42934816062292,
							28.52334000000004
						],
						[
							-81.42998911764052,
							28.52334000000004
						],
						[
							-81.4303400139225,
							28.52333697642043
						],
						[
							-81.43053865285403,
							28.523332356910412
						],
						[
							-81.43085932014301,
							28.52332471517721
						],
						[
							-81.43119486470388,
							28.5233166297662
						],
						[
							-81.43171343357082,
							28.523304134130832
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Roosevelt Park",
				"RegionID": "269168"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.3644580589999,
					28.570280925000077,
					-81.35530077599992,
					28.577732095000044
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.35879071499994,
							28.577392969000073
						],
						[
							-81.35875625099993,
							28.577286928000035
						],
						[
							-81.35869911099991,
							28.57712885800004
						],
						[
							-81.35867550199993,
							28.577097037000044
						],
						[
							-81.35854470599992,
							28.576962564000045
						],
						[
							-81.35846649299992,
							28.576913872000034
						],
						[
							-81.35826531199992,
							28.576844280000046
						],
						[
							-81.35789938099992,
							28.576737905000073
						],
						[
							-81.35784980199992,
							28.576728640000056
						],
						[
							-81.35782740399992,
							28.576749030000087
						],
						[
							-81.35781496399994,
							28.576760146000083
						],
						[
							-81.35776947199993,
							28.57679748000004
						],
						[
							-81.35772163599995,
							28.576831759000076
						],
						[
							-81.3576740929999,
							28.57686142600005
						],
						[
							-81.3574900939999,
							28.576968427000054
						],
						[
							-81.35748766099994,
							28.576969836000046
						],
						[
							-81.35743575999993,
							28.57699757800009
						],
						[
							-81.35738215599991,
							28.577021865000066
						],
						[
							-81.35732707799991,
							28.57704259500008
						],
						[
							-81.35727076199993,
							28.577059679000058
						],
						[
							-81.35724330499994,
							28.57706657400007
						],
						[
							-81.35709830499991,
							28.577100574000042
						],
						[
							-81.35706844899995,
							28.57710704200008
						],
						[
							-81.35701038499991,
							28.577116628000056
						],
						[
							-81.35695181799991,
							28.57712239600005
						],
						[
							-81.3568929999999,
							28.57712432200009
						],
						[
							-81.35685510799993,
							28.57712352300007
						],
						[
							-81.35668910899996,
							28.577116523000086
						],
						[
							-81.35666818199991,
							28.577115396000067
						],
						[
							-81.35660961499991,
							28.577109628000073
						],
						[
							-81.35655155099994,
							28.57710004100005
						],
						[
							-81.35649423899991,
							28.577086678000057
						],
						[
							-81.35643792299993,
							28.57706959500007
						],
						[
							-81.35638595699993,
							28.57705014700008
						],
						[
							-81.35620295699994,
							28.576975148000088
						],
						[
							-81.35619984399996,
							28.576973865000074
						],
						[
							-81.35617876999993,
							28.576964819000068
						],
						[
							-81.35616076999992,
							28.576956820000078
						],
						[
							-81.35612823999992,
							28.57694157800006
						],
						[
							-81.35607633899991,
							28.576913836000074
						],
						[
							-81.3560263629999,
							28.576882759000057
						],
						[
							-81.35597852699993,
							28.57684848000008
						],
						[
							-81.3559330359999,
							28.576811146000068
						],
						[
							-81.3558900829999,
							28.576770917000093
						],
						[
							-81.35584985399993,
							28.57672796500009
						],
						[
							-81.35582523499994,
							28.576698657000065
						],
						[
							-81.35571423599993,
							28.576560657000073
						],
						[
							-81.35570151999991,
							28.57654447300007
						],
						[
							-81.35566724099994,
							28.576496637000048
						],
						[
							-81.35563616499991,
							28.576446661000094
						],
						[
							-81.35560842299992,
							28.576394760000085
						],
						[
							-81.3555841349999,
							28.57634115600007
						],
						[
							-81.35556340499994,
							28.576286078000066
						],
						[
							-81.35555176799994,
							28.57624921000007
						],
						[
							-81.3554547679999,
							28.575917210000057
						],
						[
							-81.35544932199991,
							28.575897762000068
						],
						[
							-81.35543595799993,
							28.575840449000054
						],
						[
							-81.3554263719999,
							28.575782385000082
						],
						[
							-81.3554206039999,
							28.575723819000075
						],
						[
							-81.3554196099999,
							28.57570591700005
						],
						[
							-81.35539912199994,
							28.57525607400004
						],
						[
							-81.3553779479999,
							28.57518947300008
						],
						[
							-81.35536632199995,
							28.57514976200008
						],
						[
							-81.3553567049999,
							28.575110334000044
						],
						[
							-81.35532170499994,
							28.574951334000048
						],
						[
							-81.35531795799994,
							28.57493344900007
						],
						[
							-81.35530837199991,
							28.574875385000045
						],
						[
							-81.35530260399992,
							28.574816818000045
						],
						[
							-81.35530077599992,
							28.57476100000008
						],
						[
							-81.35620065999991,
							28.57476100000008
						],
						[
							-81.35619999999996,
							28.57475800000009
						],
						[
							-81.35620699999993,
							28.574654000000066
						],
						[
							-81.35627699999992,
							28.57455800000008
						],
						[
							-81.35650499999991,
							28.574502000000056
						],
						[
							-81.3566439999999,
							28.574433000000056
						],
						[
							-81.3567401869999,
							28.574349761000065
						],
						[
							-81.35674878599991,
							28.574090139000077
						],
						[
							-81.35676299999996,
							28.573661000000072
						],
						[
							-81.35689799999994,
							28.573586000000034
						],
						[
							-81.35689799999994,
							28.573326000000066
						],
						[
							-81.35689799999994,
							28.572865000000036
						],
						[
							-81.35675099999992,
							28.572800000000086
						],
						[
							-81.35675024499994,
							28.572732390000056
						],
						[
							-81.35674899999992,
							28.572621000000083
						],
						[
							-81.35674971699991,
							28.57180681300008
						],
						[
							-81.35679775499995,
							28.571823318000042
						],
						[
							-81.35683235899995,
							28.57183516500004
						],
						[
							-81.35703384899995,
							28.57186599800008
						],
						[
							-81.35728677399993,
							28.571904593000056
						],
						[
							-81.35742459999994,
							28.57190846800006
						],
						[
							-81.35745796799995,
							28.57190526800008
						],
						[
							-81.3576268139999,
							28.571866944000078
						],
						[
							-81.3583141819999,
							28.571573776000037
						],
						[
							-81.35832284399993,
							28.57157013500006
						],
						[
							-81.35837792199993,
							28.57154940500004
						],
						[
							-81.35838571699992,
							28.57154679900009
						],
						[
							-81.35888071699992,
							28.57138379800006
						],
						[
							-81.35891096199992,
							28.57137442600009
						],
						[
							-81.35926349199991,
							28.571271946000085
						],
						[
							-81.3593770789999,
							28.571215410000036
						],
						[
							-81.35955860699994,
							28.57110431500007
						],
						[
							-81.35987021299991,
							28.570872191000035
						],
						[
							-81.35996067499991,
							28.57080459300005
						],
						[
							-81.35999936299993,
							28.570777241000087
						],
						[
							-81.3600083469999,
							28.570771316000048
						],
						[
							-81.36030634699995,
							28.570577316000083
						],
						[
							-81.36034733899993,
							28.57055216400005
						],
						[
							-81.36035244199991,
							28.570549437000068
						],
						[
							-81.36110542999995,
							28.570491466000078
						],
						[
							-81.36195760299995,
							28.570280925000077
						],
						[
							-81.3621775819999,
							28.570313208000076
						],
						[
							-81.36222244899994,
							28.57032095800008
						],
						[
							-81.3622797619999,
							28.570334321000075
						],
						[
							-81.36233607799994,
							28.570351404000064
						],
						[
							-81.36239115599996,
							28.57037213400008
						],
						[
							-81.3624447599999,
							28.570396422000044
						],
						[
							-81.36249666099991,
							28.570424164000087
						],
						[
							-81.36250355099992,
							28.570428182000057
						],
						[
							-81.36285655099994,
							28.57063618300009
						],
						[
							-81.36287689099993,
							28.570648957000063
						],
						[
							-81.36290387199995,
							28.570591069000045
						],
						[
							-81.36291242199991,
							28.570573240000048
						],
						[
							-81.36294016399995,
							28.570521339000038
						],
						[
							-81.36297124099991,
							28.570471363000085
						],
						[
							-81.36300551999994,
							28.57042352700006
						],
						[
							-81.36302160699995,
							28.57040392500005
						],
						[
							-81.36397999999991,
							28.57030300000008
						],
						[
							-81.3644580589999,
							28.57039218600005
						],
						[
							-81.36445600199994,
							28.57089935600004
						],
						[
							-81.36445099499993,
							28.572015012000065
						],
						[
							-81.36444999299994,
							28.57218226000009
						],
						[
							-81.3644429279999,
							28.573096674000055
						],
						[
							-81.36442495599994,
							28.575079557000038
						],
						[
							-81.3644239539999,
							28.575209750000056
						],
						[
							-81.36440405499991,
							28.57739311800009
						],
						[
							-81.35980045799994,
							28.57733852300004
						],
						[
							-81.35897927299993,
							28.577732095000044
						],
						[
							-81.35890613499993,
							28.577626253000062
						],
						[
							-81.3588982409999,
							28.577614636000078
						],
						[
							-81.35886716399995,
							28.577564661000054
						],
						[
							-81.35883942299995,
							28.577512760000047
						],
						[
							-81.35881513499993,
							28.577459155000042
						],
						[
							-81.35879440499991,
							28.577404077000043
						],
						[
							-81.35879071499994,
							28.577392969000073
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Rose Isle",
				"RegionID": "269169"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.45125400042228,
					28.601931823930414,
					-81.44108064781634,
					28.61190699993908
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.44757299981325,
							28.611503000201864
						],
						[
							-81.44757800004378,
							28.611344000067206
						],
						[
							-81.44741000039342,
							28.611344000067206
						],
						[
							-81.44727766335812,
							28.611342991027684
						],
						[
							-81.44662300008831,
							28.611337999790393
						],
						[
							-81.44632299974916,
							28.611334999652215
						],
						[
							-81.44624000041979,
							28.611335999698305
						],
						[
							-81.44623200005098,
							28.61082599957146
						],
						[
							-81.44622699982044,
							28.610725000311483
						],
						[
							-81.44619800028238,
							28.60979699980207
						],
						[
							-81.44619800028238,
							28.60932699972055
						],
						[
							-81.44612699970746,
							28.607877000329594
						],
						[
							-81.44611299996139,
							28.607580000128713
						],
						[
							-81.44519299982069,
							28.607589999690248
						],
						[
							-81.44339399963054,
							28.607609999712864
						],
						[
							-81.44279900008206,
							28.607565000336553
						],
						[
							-81.44209900019014,
							28.607544000267843
						],
						[
							-81.44114646598103,
							28.607546275230995
						],
						[
							-81.44114373313597,
							28.607313414099554
						],
						[
							-81.44108064781634,
							28.60193802028451
						],
						[
							-81.44123000000003,
							28.6019400000001
						],
						[
							-81.44141469322261,
							28.6019400000001
						],
						[
							-81.44210024604298,
							28.60193902051303
						],
						[
							-81.44361719004593,
							28.601935007433738
						],
						[
							-81.44482055434187,
							28.601931823930414
						],
						[
							-81.44667299969517,
							28.601941000094243
						],
						[
							-81.44667299969517,
							28.602995403012727
						],
						[
							-81.44667299969517,
							28.603077000299166
						],
						[
							-81.44667299969517,
							28.603347788860255
						],
						[
							-81.44667299969517,
							28.60386199961281
						],
						[
							-81.44943530507969,
							28.60386199961281
						],
						[
							-81.449492000139,
							28.60386199961281
						],
						[
							-81.449492000139,
							28.60546133952052
						],
						[
							-81.449492000139,
							28.60588800037428
						],
						[
							-81.45112626521772,
							28.605888947360413
						],
						[
							-81.45121699961595,
							28.605889000420277
						],
						[
							-81.45123699963865,
							28.607579000082445
						],
						[
							-81.45125400042228,
							28.607741000355556
						],
						[
							-81.45009803976477,
							28.607746904404713
						],
						[
							-81.449492000139,
							28.607749999871174
						],
						[
							-81.449492000139,
							28.61133100036713
						],
						[
							-81.44949300018517,
							28.611418999926947
						],
						[
							-81.44980099999377,
							28.611421000019128
						],
						[
							-81.45012902410662,
							28.611421000019128
						],
						[
							-81.45023100003023,
							28.611421000019128
						],
						[
							-81.45049499960916,
							28.611421000019128
						],
						[
							-81.45023500021459,
							28.61146300015654
						],
						[
							-81.44833470398835,
							28.61175520966904
						],
						[
							-81.44819299961488,
							28.61177700024185
						],
						[
							-81.44808893366692,
							28.611797893291097
						],
						[
							-81.44793400026641,
							28.611828999940798
						],
						[
							-81.44775390203675,
							28.611867805686437
						],
						[
							-81.44759889489177,
							28.61190120470794
						],
						[
							-81.44757199976715,
							28.61190699993908
						],
						[
							-81.44757267246007,
							28.611635248204188
						],
						[
							-81.44757299981325,
							28.611503000201864
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Rosemont North",
				"RegionID": "269170"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.69012804199991,
					30.35560100900005,
					-81.67591090699995,
					30.370075068000066
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.67959590499993,
							30.364960008000082
						],
						[
							-81.67934390499994,
							30.364637009000038
						],
						[
							-81.67908490499991,
							30.364290008000065
						],
						[
							-81.67894690599991,
							30.364107009000065
						],
						[
							-81.67860390499993,
							30.36362300800005
						],
						[
							-81.67850790499995,
							30.36348000800007
						],
						[
							-81.67812290599994,
							30.362940009000056
						],
						[
							-81.67768390599991,
							30.36231000800007
						],
						[
							-81.67764290499991,
							30.362251008000044
						],
						[
							-81.67739890599995,
							30.36191200900004
						],
						[
							-81.6771699059999,
							30.361574009000037
						],
						[
							-81.6766969059999,
							30.36088600800008
						],
						[
							-81.6762009059999,
							30.360210008000077
						],
						[
							-81.67600973499992,
							30.359911057000094
						],
						[
							-81.67600290599997,
							30.35951200900007
						],
						[
							-81.67597990599995,
							30.358826009000044
						],
						[
							-81.67597190499993,
							30.358131008000043
						],
						[
							-81.6759569059999,
							30.357584008000057
						],
						[
							-81.67596390499995,
							30.357450008000058
						],
						[
							-81.67594890599992,
							30.357271008000055
						],
						[
							-81.67594090599994,
							30.356760009000087
						],
						[
							-81.67591890599994,
							30.356091008000078
						],
						[
							-81.67591090699995,
							30.35567695300006
						],
						[
							-81.67704690599993,
							30.355640009000073
						],
						[
							-81.6780749049999,
							30.355618008000075
						],
						[
							-81.67948890699995,
							30.35560100900005
						],
						[
							-81.68001290599994,
							30.355627008000056
						],
						[
							-81.68023690599995,
							30.355645008000067
						],
						[
							-81.68030690599994,
							30.355650009000044
						],
						[
							-81.6805279049999,
							30.355680008000036
						],
						[
							-81.68064190599995,
							30.355696008000056
						],
						[
							-81.68087090699993,
							30.355738009000046
						],
						[
							-81.6811680109999,
							30.35581415900009
						],
						[
							-81.68117882399991,
							30.355705854000067
						],
						[
							-81.68128090599993,
							30.35575500800007
						],
						[
							-81.68280590599994,
							30.356273009000063
						],
						[
							-81.68293890599995,
							30.356339008000077
						],
						[
							-81.68458589699992,
							30.356864060000074
						],
						[
							-81.68642003799994,
							30.356931874000058
						],
						[
							-81.68642377799995,
							30.35701414300007
						],
						[
							-81.68812592599994,
							30.356985955000084
						],
						[
							-81.68817890499992,
							30.35727300800005
						],
						[
							-81.68819390599994,
							30.357948008000054
						],
						[
							-81.68820990599994,
							30.35863900800007
						],
						[
							-81.68823190599994,
							30.359335009000066
						],
						[
							-81.68823990499993,
							30.359612009000045
						],
						[
							-81.6882479059999,
							30.36002200900009
						],
						[
							-81.68825490599994,
							30.36070400900007
						],
						[
							-81.6882709059999,
							30.361055008000047
						],
						[
							-81.6882709059999,
							30.361376009000082
						],
						[
							-81.68828590599993,
							30.361616008000052
						],
						[
							-81.6882929059999,
							30.36208000800008
						],
						[
							-81.6883159059999,
							30.36277000800004
						],
						[
							-81.68833890499991,
							30.363451009000073
						],
						[
							-81.68836977599994,
							30.364824141000042
						],
						[
							-81.68900290499994,
							30.36482200800009
						],
						[
							-81.68970490499993,
							30.364813008000056
						],
						[
							-81.69012804199991,
							30.364802952000044
						],
						[
							-81.6890419049999,
							30.365878008000042
						],
						[
							-81.6886807429999,
							30.36616492800005
						],
						[
							-81.6886780719999,
							30.366255087000074
						],
						[
							-81.68761690299993,
							30.36718200600006
						],
						[
							-81.68603079099995,
							30.367869876000047
						],
						[
							-81.68582591599994,
							30.36821188500005
						],
						[
							-81.6857330069999,
							30.368359095000077
						],
						[
							-81.68538490499992,
							30.368609007000092
						],
						[
							-81.6850769049999,
							30.368763010000066
						],
						[
							-81.68495380399993,
							30.36886292300005
						],
						[
							-81.68487800699995,
							30.369020093000074
						],
						[
							-81.68461190599993,
							30.36921200900008
						],
						[
							-81.68437190599991,
							30.369458008000038
						],
						[
							-81.68410490799994,
							30.369780009000067
						],
						[
							-81.68398683999993,
							30.370075068000066
						],
						[
							-81.68349390499992,
							30.369707009000077
						],
						[
							-81.6830899059999,
							30.36938700800005
						],
						[
							-81.68296490599994,
							30.369258009000077
						],
						[
							-81.68269391899992,
							30.368930935000037
						],
						[
							-81.68249490599993,
							30.368673009000073
						],
						[
							-81.68118990499994,
							30.36699300800007
						],
						[
							-81.68067190499994,
							30.366331009000074
						],
						[
							-81.6801219109999,
							30.365640925000037
						],
						[
							-81.67959590499993,
							30.364960008000082
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Moncrief Park",
				"RegionID": "269095"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.06449586899993,
					26.72452822100007,
					-80.05644974299992,
					26.734890000000064
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.05965614299993,
							26.73476349100008
						],
						[
							-80.0595199999999,
							26.73476000000005
						],
						[
							-80.05943935099992,
							26.73476000000005
						],
						[
							-80.05934999999994,
							26.73476000000005
						],
						[
							-80.05917639699993,
							26.734752452000066
						],
						[
							-80.05900584099993,
							26.73474503700004
						],
						[
							-80.05865999999992,
							26.73473000000007
						],
						[
							-80.05866230199992,
							26.734744858000056
						],
						[
							-80.0586556909999,
							26.73474090600007
						],
						[
							-80.05849168299994,
							26.734727450000037
						],
						[
							-80.05839266299995,
							26.73472594900005
						],
						[
							-80.0583406149999,
							26.734725161000085
						],
						[
							-80.05818866399994,
							26.734722859000044
						],
						[
							-80.05800473199992,
							26.734720731000042
						],
						[
							-80.05778105899992,
							26.733293486000036
						],
						[
							-80.0571311349999,
							26.729152105000086
						],
						[
							-80.05685668599995,
							26.727272129000085
						],
						[
							-80.05644974299992,
							26.72452822100007
						],
						[
							-80.05682559099995,
							26.724533703000077
						],
						[
							-80.05709382999993,
							26.724537155000064
						],
						[
							-80.05732999999992,
							26.72454000000005
						],
						[
							-80.05769335399992,
							26.72455048100005
						],
						[
							-80.05796162299993,
							26.724558220000063
						],
						[
							-80.05836999999991,
							26.724570000000085
						],
						[
							-80.05875055899992,
							26.724578552000082
						],
						[
							-80.05901904299992,
							26.72458458500006
						],
						[
							-80.05925999999994,
							26.724590000000035
						],
						[
							-80.05963410999993,
							26.724599353000087
						],
						[
							-80.0601003239999,
							26.724611008000068
						],
						[
							-80.06045999999992,
							26.724620000000073
						],
						[
							-80.06084166599993,
							26.724632514000064
						],
						[
							-80.06138627699994,
							26.724650370000063
						],
						[
							-80.06167999999991,
							26.724660000000085
						],
						[
							-80.0621510329999,
							26.724671776000037
						],
						[
							-80.06278263999991,
							26.724687566000057
						],
						[
							-80.06295619199994,
							26.724690000000066
						],
						[
							-80.06306174499991,
							26.724691663000044
						],
						[
							-80.06307879099995,
							26.724817805000043
						],
						[
							-80.06326763299995,
							26.726114084000073
						],
						[
							-80.06358503899992,
							26.728124317000038
						],
						[
							-80.0639326729999,
							26.730376382000088
						],
						[
							-80.06428030699993,
							26.732658676000085
						],
						[
							-80.06443145199995,
							26.734124785000063
						],
						[
							-80.06449586899993,
							26.734865582000054
						],
						[
							-80.06426999999991,
							26.734890000000064
						],
						[
							-80.06395742699993,
							26.734882353000046
						],
						[
							-80.06343165299995,
							26.73486949000005
						],
						[
							-80.0630763609999,
							26.734860798000057
						],
						[
							-80.06255058599993,
							26.734847935000065
						],
						[
							-80.06193051499991,
							26.73483276500008
						],
						[
							-80.06125010199992,
							26.734816119000072
						],
						[
							-80.06099999999992,
							26.73481000000004
						],
						[
							-80.06078627099993,
							26.734800136000047
						],
						[
							-80.06057010699993,
							26.734790159000056
						],
						[
							-80.06034999999991,
							26.73478000000006
						],
						[
							-80.0601664589999,
							26.734775829000057
						],
						[
							-80.05996541099995,
							26.73477125900007
						],
						[
							-80.05965614299993,
							26.73476349100008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "West Palm Beach",
				"Name": "North Tamarind",
				"RegionID": "269109"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.21871344599992,
					25.778319646000057,
					-80.19480624499994,
					25.797690000000046
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.20047295799992,
							25.797246345000076
						],
						[
							-80.20046999999994,
							25.797060000000045
						],
						[
							-80.20046121999991,
							25.796937083000046
						],
						[
							-80.20044999999993,
							25.796780000000073
						],
						[
							-80.2004468909999,
							25.796652518000087
						],
						[
							-80.20044341599993,
							25.796510054000066
						],
						[
							-80.2004399999999,
							25.79637000000008
						],
						[
							-80.20043587399994,
							25.796273047000057
						],
						[
							-80.20042780099993,
							25.796083326000087
						],
						[
							-80.20041999999995,
							25.795900000000074
						],
						[
							-80.20041579399992,
							25.795773806000057
						],
						[
							-80.20041104699993,
							25.79563141600005
						],
						[
							-80.20037999999994,
							25.79541000000006
						],
						[
							-80.19988736499994,
							25.795424489000084
						],
						[
							-80.19955503799991,
							25.795434264000054
						],
						[
							-80.1993599999999,
							25.795440000000042
						],
						[
							-80.1990307879999,
							25.79543803900009
						],
						[
							-80.19886999999994,
							25.795430000000067
						],
						[
							-80.19867527999992,
							25.79542114900005
						],
						[
							-80.1984799999999,
							25.795420000000036
						],
						[
							-80.19822458199992,
							25.795429951000074
						],
						[
							-80.19789247299991,
							25.79544289100005
						],
						[
							-80.19770999999992,
							25.795450000000073
						],
						[
							-80.19746289599993,
							25.795447411000055
						],
						[
							-80.19722999999993,
							25.79546000000005
						],
						[
							-80.19701280699991,
							25.79547174000004
						],
						[
							-80.19673999999992,
							25.795480000000055
						],
						[
							-80.19651391199994,
							25.79548471000004
						],
						[
							-80.19613345199991,
							25.795492636000063
						],
						[
							-80.1957799999999,
							25.79550000000006
						],
						[
							-80.19549284199991,
							25.795511642000065
						],
						[
							-80.19515885099992,
							25.795525182000063
						],
						[
							-80.19482999999991,
							25.795580000000086
						],
						[
							-80.1948255179999,
							25.795369350000044
						],
						[
							-80.19481901199993,
							25.79506062300004
						],
						[
							-80.19481472799993,
							25.794846410000048
						],
						[
							-80.19480624499994,
							25.79449136900007
						],
						[
							-80.19535671199992,
							25.792330656000047
						],
						[
							-80.19552687599992,
							25.79164994200005
						],
						[
							-80.19547135999994,
							25.79162414600006
						],
						[
							-80.19569394699994,
							25.79065618200008
						],
						[
							-80.19593687199995,
							25.789584452000042
						],
						[
							-80.19614407399992,
							25.788669909000077
						],
						[
							-80.19627268099993,
							25.78799114700007
						],
						[
							-80.19631202399995,
							25.787336475000075
						],
						[
							-80.19631202399995,
							25.787068523000073
						],
						[
							-80.19631202399995,
							25.786583974000052
						],
						[
							-80.1962836269999,
							25.786229021000054
						],
						[
							-80.19624103299994,
							25.785263548000046
						],
						[
							-80.19618424099991,
							25.78370175300006
						],
						[
							-80.19629782599992,
							25.78218255200005
						],
						[
							-80.19622683499995,
							25.78035099300007
						],
						[
							-80.19619843899994,
							25.77924353900005
						],
						[
							-80.19618865399991,
							25.778901083000054
						],
						[
							-80.19630385399995,
							25.778897446000087
						],
						[
							-80.19650803299993,
							25.778888873000085
						],
						[
							-80.1966953669999,
							25.77887716500004
						],
						[
							-80.19680999999991,
							25.77887000000004
						],
						[
							-80.19689812299993,
							25.778869456000052
						],
						[
							-80.19707036199992,
							25.77886428900007
						],
						[
							-80.19727438699994,
							25.778858168000056
						],
						[
							-80.19754057499995,
							25.77885018300009
						],
						[
							-80.19775978799993,
							25.778843606000066
						],
						[
							-80.19787999999994,
							25.77884000000006
						],
						[
							-80.1980738879999,
							25.77883419500006
						],
						[
							-80.19835526599991,
							25.778825770000083
						],
						[
							-80.19876284599991,
							25.778813567000043
						],
						[
							-80.19899818699992,
							25.778806521000035
						],
						[
							-80.19940529899992,
							25.778794332000075
						],
						[
							-80.19963999899994,
							25.778785500000083
						],
						[
							-80.1998273289999,
							25.778782872000082
						],
						[
							-80.2000320969999,
							25.77878000000004
						],
						[
							-80.2003146269999,
							25.778775384000085
						],
						[
							-80.20047210399993,
							25.77877096900005
						],
						[
							-80.20072134399993,
							25.778763981000054
						],
						[
							-80.20091057999991,
							25.778758675000063
						],
						[
							-80.20121999999992,
							25.77875000000006
						],
						[
							-80.20136481399993,
							25.778744766000045
						],
						[
							-80.2016308929999,
							25.778735148000067
						],
						[
							-80.2019137559999,
							25.778724924000073
						],
						[
							-80.2023206209999,
							25.77871355700006
						],
						[
							-80.20269653999993,
							25.778704606000076
						],
						[
							-80.20288999999991,
							25.77870000000007
						],
						[
							-80.20310373399991,
							25.77869363900004
						],
						[
							-80.2032607829999,
							25.77868896500007
						],
						[
							-80.20355875699994,
							25.778680097000063
						],
						[
							-80.20382494799992,
							25.778672174000064
						],
						[
							-80.2040911389999,
							25.778664252000056
						],
						[
							-80.20438864699992,
							25.77865539700008
						],
						[
							-80.20456999999993,
							25.778650000000084
						],
						[
							-80.20481235199992,
							25.778643125000087
						],
						[
							-80.20504724599994,
							25.778636461000076
						],
						[
							-80.20526692399994,
							25.778630229000044
						],
						[
							-80.20559577499995,
							25.77862090000008
						],
						[
							-80.20583111299993,
							25.77861422400008
						],
						[
							-80.20604999999995,
							25.77861000000007
						],
						[
							-80.20619228499993,
							25.778598883000086
						],
						[
							-80.20628554799993,
							25.778590405000045
						],
						[
							-80.20638999999994,
							25.77858000000009
						],
						[
							-80.20645964499994,
							25.778566071000057
						],
						[
							-80.20654841999993,
							25.77854473700006
						],
						[
							-80.20670741499993,
							25.77849103400007
						],
						[
							-80.20681480899994,
							25.778406646000064
						],
						[
							-80.2069255269999,
							25.778319646000057
						],
						[
							-80.20697495799993,
							25.77836289700008
						],
						[
							-80.20726217399994,
							25.77861181800006
						],
						[
							-80.20814297099992,
							25.779013921000058
						],
						[
							-80.20877484599993,
							25.77930113700006
						],
						[
							-80.20923439199993,
							25.779569206000076
						],
						[
							-80.20986626799993,
							25.780067047000045
						],
						[
							-80.21036410999994,
							25.78050744500007
						],
						[
							-80.21072791699993,
							25.78089040000009
						],
						[
							-80.21116831499995,
							25.78119676400007
						],
						[
							-80.2116853039999,
							25.78146483300009
						],
						[
							-80.21262354399994,
							25.781866936000085
						],
						[
							-80.21375326099991,
							25.782269038000038
						],
						[
							-80.21448087599993,
							25.782517959000074
						],
						[
							-80.2165871279999,
							25.78326472100008
						],
						[
							-80.2177359929999,
							25.78366682400008
						],
						[
							-80.2183104259999,
							25.78376256300004
						],
						[
							-80.21871344599992,
							25.78381752000007
						],
						[
							-80.21808688499993,
							25.78397540800006
						],
						[
							-80.21331925299995,
							25.785984974000087
						],
						[
							-80.20785513499993,
							25.788552355000036
						],
						[
							-80.20462345499993,
							25.78870128400007
						],
						[
							-80.20397682499993,
							25.78888649600009
						],
						[
							-80.20462645599991,
							25.789826297000047
						],
						[
							-80.20527702299995,
							25.79280986100008
						],
						[
							-80.20546490699991,
							25.79524508700007
						],
						[
							-80.20549353399991,
							25.797212433000084
						],
						[
							-80.20489954399994,
							25.79717080900008
						],
						[
							-80.20468628099991,
							25.79717507400005
						],
						[
							-80.20443999999992,
							25.797180000000083
						],
						[
							-80.20418784599991,
							25.797188848000076
						],
						[
							-80.20399801499991,
							25.797195508000076
						],
						[
							-80.20386999999994,
							25.797200000000093
						],
						[
							-80.2036181009999,
							25.79720730100007
						],
						[
							-80.20337934399993,
							25.797214222000036
						],
						[
							-80.2031426289999,
							25.797226228000056
						],
						[
							-80.20306195499995,
							25.79726869600006
						],
						[
							-80.20302610099992,
							25.79732932400009
						],
						[
							-80.20301999999992,
							25.79738876500005
						],
						[
							-80.20301999999992,
							25.79762000000005
						],
						[
							-80.20266676599994,
							25.79762375300004
						],
						[
							-80.20228693699994,
							25.797634452000068
						],
						[
							-80.20197765799992,
							25.797643165000068
						],
						[
							-80.20159782999991,
							25.79765386400004
						],
						[
							-80.20140791499995,
							25.797659214000078
						],
						[
							-80.20126608599992,
							25.797666701000086
						],
						[
							-80.20120999999995,
							25.79767000000004
						],
						[
							-80.20100446999993,
							25.79767563100006
						],
						[
							-80.20083763799994,
							25.797680202000038
						],
						[
							-80.20071828599993,
							25.797683472000074
						],
						[
							-80.20047999999991,
							25.797690000000046
						],
						[
							-80.20047822999993,
							25.797578498000064
						],
						[
							-80.20047521399994,
							25.797388481000045
						],
						[
							-80.20047295799992,
							25.797246345000076
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami",
				"Name": "Overtown",
				"RegionID": "269126"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.37591304830542,
					28.537237375529344,
					-81.36837180771042,
					28.54574710860816
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.36845293015482,
							28.542356025139824
						],
						[
							-81.36844992462059,
							28.542162738352623
						],
						[
							-81.3684419125606,
							28.54137156609265
						],
						[
							-81.36843590419018,
							28.540551349328368
						],
						[
							-81.36842388654988,
							28.539864330250474
						],
						[
							-81.36840686058515,
							28.539278461518542
						],
						[
							-81.36838883457442,
							28.5384872883592
						],
						[
							-81.36837180860978,
							28.53732856948111
						],
						[
							-81.36837180771042,
							28.53728550634503
						],
						[
							-81.36862418355224,
							28.53729151381617
						],
						[
							-81.37016046209999,
							28.537271484115962
						],
						[
							-81.37190705160084,
							28.53724844978081
						],
						[
							-81.37283342613614,
							28.537237375529344
						],
						[
							-81.37283542802697,
							28.537339586175868
						],
						[
							-81.37283726444262,
							28.537571019505613
						],
						[
							-81.37294258674336,
							28.537641033524196
						],
						[
							-81.37300371815832,
							28.537698082916428
						],
						[
							-81.3730427352446,
							28.53776121172563
						],
						[
							-81.37309180854966,
							28.537872376022328
						],
						[
							-81.37328023000471,
							28.53844232135841
						],
						[
							-81.37285032079977,
							28.538444094821482
						],
						[
							-81.3728544576811,
							28.539193336191847
						],
						[
							-81.37285946420688,
							28.53983428570016
						],
						[
							-81.3728724845912,
							28.53996948617666
						],
						[
							-81.37287048090171,
							28.540439183186834
						],
						[
							-81.37286547347666,
							28.541361551242463
						],
						[
							-81.37285933200648,
							28.542260016217853
						],
						[
							-81.37528506072562,
							28.54222382929808
						],
						[
							-81.37586404964402,
							28.542215685937077
						],
						[
							-81.37587093035691,
							28.542789668329803
						],
						[
							-81.37587293404631,
							28.54295891893702
						],
						[
							-81.3758809461063,
							28.543604878568317
						],
						[
							-81.37589696932692,
							28.544857734879187
						],
						[
							-81.37591304830542,
							28.54570298876874
						],
						[
							-81.36849498964742,
							28.54574710860816
						],
						[
							-81.36847295895566,
							28.544752579852197
						],
						[
							-81.36846594874049,
							28.54363592406409
						],
						[
							-81.36845293015482,
							28.542356025139824
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "South Eola",
				"RegionID": "269184"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.95716996599992,
					28.02575545700006,
					-81.94483191199993,
					28.03727819500006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.94484415999995,
							28.036843003000058
						],
						[
							-81.94483191199993,
							28.033126955000057
						],
						[
							-81.94783890999992,
							28.03312901000004
						],
						[
							-81.94898191099992,
							28.033132010000088
						],
						[
							-81.94991804499995,
							28.03313414200005
						],
						[
							-81.94989590999995,
							28.03206201100005
						],
						[
							-81.94988591099991,
							28.031156009000085
						],
						[
							-81.94987690999994,
							28.03023500900008
						],
						[
							-81.94987490999995,
							28.029978009000047
						],
						[
							-81.94979091099992,
							28.028405010000085
						],
						[
							-81.94979194099994,
							28.027610930000037
						],
						[
							-81.94971159399995,
							28.02671423700008
						],
						[
							-81.94979498299995,
							28.026702859000068
						],
						[
							-81.9499094869999,
							28.026663889000076
						],
						[
							-81.94997692099992,
							28.02663213200009
						],
						[
							-81.95043895899994,
							28.02632629900006
						],
						[
							-81.95048726399995,
							28.026285088000066
						],
						[
							-81.95052123999994,
							28.02624553800007
						],
						[
							-81.95053855499992,
							28.02621693100008
						],
						[
							-81.95056672299995,
							28.026123192000057
						],
						[
							-81.95057640499994,
							28.02609292200009
						],
						[
							-81.9505971349999,
							28.02603784400009
						],
						[
							-81.95060985399994,
							28.02600861400009
						],
						[
							-81.95067785399993,
							28.02585961500006
						],
						[
							-81.95068942299991,
							28.02583524000005
						],
						[
							-81.9507171649999,
							28.025783339000043
						],
						[
							-81.95073450299992,
							28.02575545700006
						],
						[
							-81.95147063899992,
							28.026288571000066
						],
						[
							-81.95286491099995,
							28.02633601000008
						],
						[
							-81.9570489109999,
							28.026335009000036
						],
						[
							-81.95710496499993,
							28.026335009000036
						],
						[
							-81.95710191099994,
							28.02669001000004
						],
						[
							-81.95710291099994,
							28.027239010000077
						],
						[
							-81.95710391099995,
							28.02763401100009
						],
						[
							-81.95711291099991,
							28.028608011000074
						],
						[
							-81.95711091099992,
							28.029476011000042
						],
						[
							-81.95712491099994,
							28.03046001100006
						],
						[
							-81.9571369109999,
							28.031358010000076
						],
						[
							-81.9571369109999,
							28.03204301100004
						],
						[
							-81.9571379109999,
							28.03229201000005
						],
						[
							-81.95713890999991,
							28.033258010000054
						],
						[
							-81.95714990999994,
							28.034098009000047
						],
						[
							-81.95715691099991,
							28.034255010000038
						],
						[
							-81.9571599109999,
							28.035024010000086
						],
						[
							-81.9571619109999,
							28.035298010000076
						],
						[
							-81.95716491099995,
							28.035851010000044
						],
						[
							-81.95716996599992,
							28.03669401700006
						],
						[
							-81.9571229099999,
							28.03669701000007
						],
						[
							-81.95557685499995,
							28.036709845000075
						],
						[
							-81.9554208109999,
							28.036830015000078
						],
						[
							-81.95536291099995,
							28.03668401300007
						],
						[
							-81.95525590699994,
							28.036530009000046
						],
						[
							-81.95512490999994,
							28.03641401200008
						],
						[
							-81.95504590999991,
							28.03637301100008
						],
						[
							-81.95489491099994,
							28.036294011000052
						],
						[
							-81.95475390999991,
							28.036241011000072
						],
						[
							-81.95426091099995,
							28.036113009000076
						],
						[
							-81.95413591099992,
							28.03608801100006
						],
						[
							-81.95375191099993,
							28.036035010000035
						],
						[
							-81.95308191099991,
							28.036007011000038
						],
						[
							-81.95296391099993,
							28.03601701000008
						],
						[
							-81.95235991099992,
							28.03613001000008
						],
						[
							-81.9521909099999,
							28.036184010000056
						],
						[
							-81.95183591099993,
							28.036297011000045
						],
						[
							-81.95151591099994,
							28.03643101100005
						],
						[
							-81.95125491099992,
							28.036554011000078
						],
						[
							-81.95119891099995,
							28.03659201000005
						],
						[
							-81.95076991099995,
							28.036968011000056
						],
						[
							-81.95047995899995,
							28.03727819500006
						],
						[
							-81.94992391099993,
							28.03709801100007
						],
						[
							-81.94903940599994,
							28.036890449000055
						],
						[
							-81.94727469199995,
							28.036866601000042
						],
						[
							-81.94484415999995,
							28.036843003000058
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Polk",
				"City": "Lakeland",
				"Name": "South Lake Morton",
				"RegionID": "269185"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.15452260199993,
					26.136600069000053,
					-80.14040739799992,
					26.15584225400005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.15342349199996,
							26.155318492000053
						],
						[
							-80.15316699999994,
							26.155062000000044
						],
						[
							-80.15215399999994,
							26.15513400000009
						],
						[
							-80.15155799999991,
							26.154459000000088
						],
						[
							-80.15112399999992,
							26.15399700000006
						],
						[
							-80.15012599999994,
							26.153139000000067
						],
						[
							-80.14963999999992,
							26.152810000000045
						],
						[
							-80.14908499999991,
							26.15252600000008
						],
						[
							-80.14850199999995,
							26.152232000000083
						],
						[
							-80.14835299999993,
							26.152008000000084
						],
						[
							-80.14826899999991,
							26.151902000000064
						],
						[
							-80.14812799999993,
							26.15172400000006
						],
						[
							-80.14783299999993,
							26.15159200000005
						],
						[
							-80.14756699999992,
							26.151462000000038
						],
						[
							-80.14616699999993,
							26.15106200000008
						],
						[
							-80.14596699999993,
							26.151162000000056
						],
						[
							-80.14386699999994,
							26.150662000000068
						],
						[
							-80.1435669999999,
							26.15070600000007
						],
						[
							-80.14259399999992,
							26.150850000000048
						],
						[
							-80.14255910799994,
							26.150855178000086
						],
						[
							-80.14231099999995,
							26.150892000000056
						],
						[
							-80.14187570099995,
							26.150956686000086
						],
						[
							-80.14116699999994,
							26.15106200000008
						],
						[
							-80.14084844899992,
							26.151039246000042
						],
						[
							-80.14085065499995,
							26.151016721000076
						],
						[
							-80.1408693539999,
							26.150833264000084
						],
						[
							-80.14085132699995,
							26.15008615700009
						],
						[
							-80.14082328699993,
							26.149125731000083
						],
						[
							-80.14079924999993,
							26.148572913000066
						],
						[
							-80.14078522999996,
							26.147547391000046
						],
						[
							-80.14071612799995,
							26.14577075600005
						],
						[
							-80.14065603899991,
							26.14401815800005
						],
						[
							-80.14060195799993,
							26.142256544000077
						],
						[
							-80.14040739799992,
							26.13693279200004
						],
						[
							-80.14091041599994,
							26.136918628000046
						],
						[
							-80.14138812399995,
							26.136905609000053
						],
						[
							-80.14233352499991,
							26.13687856900009
						],
						[
							-80.14422531699995,
							26.13682749200007
						],
						[
							-80.14517173599995,
							26.136796446000062
						],
						[
							-80.14611012599994,
							26.136772411000038
						],
						[
							-80.14705653099992,
							26.136747375000084
						],
						[
							-80.14800293399992,
							26.136720335000064
						],
						[
							-80.14898740799993,
							26.13669137900007
						],
						[
							-80.14999388599995,
							26.13666425000008
						],
						[
							-80.15096244999995,
							26.136639078000087
						],
						[
							-80.15096532799993,
							26.136701305000088
						],
						[
							-80.15097622299993,
							26.136791584000036
						],
						[
							-80.15383511199991,
							26.136606517000075
						],
						[
							-80.15393472099993,
							26.136600069000053
						],
						[
							-80.15395271899992,
							26.13684851800008
						],
						[
							-80.15397478999995,
							26.13702478500005
						],
						[
							-80.15399982699995,
							26.137319223000077
						],
						[
							-80.15402887099992,
							26.138015254000038
						],
						[
							-80.15403487899994,
							26.13835676000008
						],
						[
							-80.15405691299992,
							26.13888053800008
						],
						[
							-80.15407293599992,
							26.139664701000072
						],
						[
							-80.15410197999995,
							26.140104352000037
						],
						[
							-80.15411700199991,
							26.140708249000056
						],
						[
							-80.15414504299991,
							26.141720750000047
						],
						[
							-80.15415005099993,
							26.141906024000036
						],
						[
							-80.15415305499994,
							26.142029207000064
						],
						[
							-80.15417909399991,
							26.142629097000054
						],
						[
							-80.15419812199991,
							26.143623571000035
						],
						[
							-80.1542211549999,
							26.144227468000057
						],
						[
							-80.15424519099992,
							26.144683143000066
						],
						[
							-80.15427723899995,
							26.145395200000053
						],
						[
							-80.15427924099993,
							26.145797796000068
						],
						[
							-80.15430127499991,
							26.146382663000054
						],
						[
							-80.15432430899995,
							26.147148800000082
						],
						[
							-80.15438840399992,
							26.148910412000077
						],
						[
							-80.1544204519999,
							26.14996798100009
						],
						[
							-80.15444649099993,
							26.15067503000006
						],
						[
							-80.15446451699997,
							26.151563347000035
						],
						[
							-80.15447052499991,
							26.151747621000084
						],
						[
							-80.15449556199991,
							26.152079111000035
						],
						[
							-80.1545205999999,
							26.152668986000037
						],
						[
							-80.15452260199993,
							26.153180745000043
						],
						[
							-80.15451659399992,
							26.15379465600006
						],
						[
							-80.15447853699993,
							26.15469499200009
						],
						[
							-80.15448654999994,
							26.155297122000036
						],
						[
							-80.1544865489999,
							26.155706491000046
						],
						[
							-80.1544880159999,
							26.15584225400005
						],
						[
							-80.15436985999992,
							26.15581271500008
						],
						[
							-80.1543463829999,
							26.155806846000075
						],
						[
							-80.15416699999992,
							26.15576200000004
						],
						[
							-80.15346699999992,
							26.155362000000082
						],
						[
							-80.15342349199996,
							26.155318492000053
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "South Middle River",
				"RegionID": "269186"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.51039090899991,
					30.378084013000034,
					-81.48400958499991,
					30.39035689600007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.48816691099995,
							30.38766301300007
						],
						[
							-81.48552295699994,
							30.385405828000046
						],
						[
							-81.48400958499991,
							30.385762430000057
						],
						[
							-81.48472590999995,
							30.38481501300004
						],
						[
							-81.48508490899992,
							30.384285012000078
						],
						[
							-81.48525191399995,
							30.384058012000082
						],
						[
							-81.48540491099993,
							30.383924013000073
						],
						[
							-81.48575590899992,
							30.38365701300006
						],
						[
							-81.48588591099991,
							30.383581012000036
						],
						[
							-81.48596990899995,
							30.383543012000075
						],
						[
							-81.48622090899994,
							30.38346101300004
						],
						[
							-81.48643490899991,
							30.383425012000092
						],
						[
							-81.48657191099994,
							30.383417013000038
						],
						[
							-81.4868009089999,
							30.383430013000066
						],
						[
							-81.48690790799992,
							30.383446013000086
						],
						[
							-81.4871139089999,
							30.383495013000076
						],
						[
							-81.4874649109999,
							30.38363601300006
						],
						[
							-81.48753394499994,
							30.383676972000046
						],
						[
							-81.48764790799993,
							30.383799012000058
						],
						[
							-81.48772391099993,
							30.383915012000045
						],
						[
							-81.48858590899994,
							30.38507501200007
						],
						[
							-81.48929591099994,
							30.38604501200007
						],
						[
							-81.48954790899995,
							30.38625101000008
						],
						[
							-81.48970790899995,
							30.386335012000078
						],
						[
							-81.48987590899992,
							30.38640001200008
						],
						[
							-81.49002790899993,
							30.386440012000037
						],
						[
							-81.49013490899995,
							30.386452012000063
						],
						[
							-81.49030290799993,
							30.38645401200006
						],
						[
							-81.49040190699992,
							30.38644201200009
						],
						[
							-81.49067690899994,
							30.38638901200005
						],
						[
							-81.49321690999994,
							30.385689012000057
						],
						[
							-81.49530790799992,
							30.38509901200007
						],
						[
							-81.49551390799991,
							30.38502901200007
						],
						[
							-81.49565090999994,
							30.38495801300007
						],
						[
							-81.49576291099993,
							30.384889012000087
						],
						[
							-81.49587990799995,
							30.384817012000042
						],
						[
							-81.4959559109999,
							30.384756012000082
						],
						[
							-81.49617790999991,
							30.38452101200005
						],
						[
							-81.49626190899994,
							30.384405012000062
						],
						[
							-81.49641390799991,
							30.384136012000052
						],
						[
							-81.49685691099997,
							30.383142012000068
						],
						[
							-81.49742090899991,
							30.381878012000076
						],
						[
							-81.49803290999995,
							30.380505013000064
						],
						[
							-81.49817890899993,
							30.380243012000054
						],
						[
							-81.49828791099992,
							30.38009601300007
						],
						[
							-81.49838191099991,
							30.379983013000075
						],
						[
							-81.49849191099992,
							30.379885013000038
						],
						[
							-81.49871491099992,
							30.379714010000047
						],
						[
							-81.49875502599991,
							30.379668078000066
						],
						[
							-81.4987759629999,
							30.379601021000045
						],
						[
							-81.49878490299996,
							30.379463957000045
						],
						[
							-81.49951690899991,
							30.37944101200009
						],
						[
							-81.50252292699992,
							30.379373066000085
						],
						[
							-81.50269290999995,
							30.37936901200004
						],
						[
							-81.50319390999994,
							30.37936101200006
						],
						[
							-81.5042449099999,
							30.37934401200005
						],
						[
							-81.50521090899991,
							30.379313013000058
						],
						[
							-81.50734690999991,
							30.37928201200009
						],
						[
							-81.50743790899992,
							30.379272012000058
						],
						[
							-81.50783390999993,
							30.379258013000083
						],
						[
							-81.50823790899996,
							30.379207012000055
						],
						[
							-81.50868790899995,
							30.379106012000083
						],
						[
							-81.50896990999992,
							30.379008013000085
						],
						[
							-81.50925890999991,
							30.37889201200005
						],
						[
							-81.50965590899995,
							30.378684011000075
						],
						[
							-81.5099599099999,
							30.37847601300007
						],
						[
							-81.51015090899995,
							30.378314012000093
						],
						[
							-81.51038777699995,
							30.378084013000034
						],
						[
							-81.51037390999994,
							30.378404012000093
						],
						[
							-81.51037590999994,
							30.378752013000053
						],
						[
							-81.51038390899993,
							30.37957001300003
						],
						[
							-81.51038390899993,
							30.381468013000074
						],
						[
							-81.51039090899991,
							30.383108013000083
						],
						[
							-81.51037590899995,
							30.38331601200008
						],
						[
							-81.51032990899995,
							30.383547012000065
						],
						[
							-81.51031490799994,
							30.38359501300005
						],
						[
							-81.51020090899993,
							30.38380601200004
						],
						[
							-81.5101239089999,
							30.383919012000035
						],
						[
							-81.50994890899995,
							30.384109011000074
						],
						[
							-81.50955790899991,
							30.38443501200004
						],
						[
							-81.50930790899992,
							30.384645013000068
						],
						[
							-81.50916290999993,
							30.384743013000048
						],
						[
							-81.50842290999992,
							30.38529801200008
						],
						[
							-81.50829290999991,
							30.38541001200008
						],
						[
							-81.50817090999993,
							30.385542013000077
						],
						[
							-81.50795691199994,
							30.385834010000053
						],
						[
							-81.5078889099999,
							30.38597701200007
						],
						[
							-81.50782791099995,
							30.38615801100008
						],
						[
							-81.50780490999995,
							30.38638101300006
						],
						[
							-81.50779690999991,
							30.38703201200008
						],
						[
							-81.50780490999995,
							30.387659012000086
						],
						[
							-81.50779790999991,
							30.388212013000043
						],
						[
							-81.50783407499995,
							30.38924006700006
						],
						[
							-81.5078283769999,
							30.389289838000078
						],
						[
							-81.5077186069999,
							30.389391375000056
						],
						[
							-81.50705349799995,
							30.39000660100004
						],
						[
							-81.50701342399992,
							30.38995103200006
						],
						[
							-81.50667273099992,
							30.38965257400008
						],
						[
							-81.50659998799995,
							30.389633936000052
						],
						[
							-81.50652918799994,
							30.38960891100004
						],
						[
							-81.50646088999991,
							30.38957769800004
						],
						[
							-81.50639563399994,
							30.389540542000077
						],
						[
							-81.50555504499994,
							30.389012522000087
						],
						[
							-81.50524712599992,
							30.388989906000063
						],
						[
							-81.50515683499992,
							30.388978659000088
						],
						[
							-81.50505916499992,
							30.38895575600009
						],
						[
							-81.50446548299993,
							30.388781086000048
						],
						[
							-81.50439616599994,
							30.388799659000085
						],
						[
							-81.50431460999994,
							30.388810222000078
						],
						[
							-81.50332960899995,
							30.388892222000038
						],
						[
							-81.50326034199992,
							30.38889530600005
						],
						[
							-81.5031910429999,
							30.38889304500009
						],
						[
							-81.50312212299991,
							30.388885451000075
						],
						[
							-81.50305399399991,
							30.388872571000036
						],
						[
							-81.50298705999995,
							30.38885448000008
						],
						[
							-81.50292171799993,
							30.388831286000084
						],
						[
							-81.50252071799991,
							30.388671286000093
						],
						[
							-81.50238910099995,
							30.38860583700006
						],
						[
							-81.50217666599991,
							30.388477549000072
						],
						[
							-81.50020326799996,
							30.387875172000065
						],
						[
							-81.49765572599995,
							30.38766180500005
						],
						[
							-81.4975897519999,
							30.38770907000009
						],
						[
							-81.49752688199993,
							30.38775024800009
						],
						[
							-81.4974607929999,
							30.387786033000054
						],
						[
							-81.49739194799992,
							30.38781617500007
						],
						[
							-81.4973208259999,
							30.38784046400008
						],
						[
							-81.49724792399991,
							30.387858729000076
						],
						[
							-81.4964253409999,
							30.38802864200005
						],
						[
							-81.49552475799993,
							30.38821555700008
						],
						[
							-81.49537680899994,
							30.38823364800004
						],
						[
							-81.49427476799991,
							30.388276336000043
						],
						[
							-81.49237638999995,
							30.389073352000082
						],
						[
							-81.49121665399991,
							30.389842627000064
						],
						[
							-81.49114492099996,
							30.38994507300004
						],
						[
							-81.49103407299992,
							30.39005592100006
						],
						[
							-81.49090566099994,
							30.390145836000045
						],
						[
							-81.4907635859999,
							30.390212087000062
						],
						[
							-81.49064915999992,
							30.390245334000042
						],
						[
							-81.49040218899995,
							30.39029960400006
						],
						[
							-81.49012380799992,
							30.39035689600007
						],
						[
							-81.48965599999991,
							30.38953500000008
						],
						[
							-81.4893919079999,
							30.38907101400008
						],
						[
							-81.48816691099995,
							30.38766301300007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "St. Johns Bluff",
				"RegionID": "269201"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.75654797699991,
					30.282087008000076,
					-81.73033890599993,
					30.309210009000083
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.73044590599994,
							30.295250009000085
						],
						[
							-81.73043090599992,
							30.293806008000047
						],
						[
							-81.7304229049999,
							30.29359100800008
						],
						[
							-81.73043090599992,
							30.293276008000074
						],
						[
							-81.73041490599991,
							30.292885009000088
						],
						[
							-81.73039996099993,
							30.29199401200009
						],
						[
							-81.73039190599991,
							30.29102700900006
						],
						[
							-81.73038490499994,
							30.290213008000084
						],
						[
							-81.73037690699994,
							30.290163008000036
						],
						[
							-81.73036990599991,
							30.289310008000086
						],
						[
							-81.73036990599991,
							30.289028009000052
						],
						[
							-81.73036190499994,
							30.288685008000073
						],
						[
							-81.73036990599991,
							30.28841600800007
						],
						[
							-81.73035390599995,
							30.286823008000056
						],
						[
							-81.73034690599991,
							30.286526008000063
						],
						[
							-81.73035790599994,
							30.28555600800007
						],
						[
							-81.73035490599995,
							30.284124008000052
						],
						[
							-81.73036190499994,
							30.28395800800007
						],
						[
							-81.7303769049999,
							30.283806008000052
						],
						[
							-81.73037690599995,
							30.283707008000082
						],
						[
							-81.73036190499994,
							30.283075008000083
						],
						[
							-81.73033890599993,
							30.282589008000055
						],
						[
							-81.73034677599992,
							30.282126876000063
						],
						[
							-81.73128490599993,
							30.28212200800004
						],
						[
							-81.73244490499991,
							30.282129009000073
						],
						[
							-81.7328029059999,
							30.282116008000063
						],
						[
							-81.73452790599993,
							30.282110009000064
						],
						[
							-81.73532090499992,
							30.282103007000046
						],
						[
							-81.7366099059999,
							30.282103007000046
						],
						[
							-81.73732790499992,
							30.282095008000056
						],
						[
							-81.73783090599994,
							30.28210100800004
						],
						[
							-81.7381439049999,
							30.282095008000056
						],
						[
							-81.7406199639999,
							30.282087008000076
						],
						[
							-81.74056490499993,
							30.282880009000053
						],
						[
							-81.74049403799995,
							30.284636032000034
						],
						[
							-81.73992973299994,
							30.28589700200007
						],
						[
							-81.74011808099993,
							30.286498009000073
						],
						[
							-81.73991573099995,
							30.287097004000092
						],
						[
							-81.74053079099991,
							30.28922907500004
						],
						[
							-81.74074385799992,
							30.289483075000078
						],
						[
							-81.74132988299993,
							30.289711139000076
						],
						[
							-81.74170790599993,
							30.289683009000047
						],
						[
							-81.74274092699996,
							30.289682929000037
						],
						[
							-81.74327697799993,
							30.289997922000055
						],
						[
							-81.74431890699992,
							30.291053007000073
						],
						[
							-81.74536990399993,
							30.291814006000035
						],
						[
							-81.7460689909999,
							30.292141907000087
						],
						[
							-81.74662995099993,
							30.29289298100008
						],
						[
							-81.74675678299991,
							30.293248157000054
						],
						[
							-81.7484548889999,
							30.29345106400007
						],
						[
							-81.74886688899994,
							30.293642183000088
						],
						[
							-81.74916291099993,
							30.29358192500007
						],
						[
							-81.74955904399991,
							30.29370588000006
						],
						[
							-81.74962175699994,
							30.29394811800006
						],
						[
							-81.74982890699994,
							30.29407600700006
						],
						[
							-81.7499579059999,
							30.294120008000046
						],
						[
							-81.74999090499996,
							30.294128009000076
						],
						[
							-81.7500229179999,
							30.294136061000074
						],
						[
							-81.75014290199994,
							30.294124011000065
						],
						[
							-81.75028590599993,
							30.294156008000076
						],
						[
							-81.75043405699995,
							30.29418290200005
						],
						[
							-81.75041972999992,
							30.294267056000077
						],
						[
							-81.75055790499994,
							30.294434008000056
						],
						[
							-81.75061581599994,
							30.294527172000077
						],
						[
							-81.75084892599995,
							30.294521929000044
						],
						[
							-81.7513109059999,
							30.29477401200006
						],
						[
							-81.75161990499993,
							30.295100004000062
						],
						[
							-81.75173288799994,
							30.295160058000082
						],
						[
							-81.75253899499995,
							30.295335858000044
						],
						[
							-81.75317302099995,
							30.29607094200009
						],
						[
							-81.75342079199994,
							30.29699207400006
						],
						[
							-81.75382990599991,
							30.29742100800007
						],
						[
							-81.7546489049999,
							30.298053009000057
						],
						[
							-81.75500890599994,
							30.298407009000076
						],
						[
							-81.75530398199993,
							30.298779970000055
						],
						[
							-81.75607090599993,
							30.30188900800005
						],
						[
							-81.75631890299991,
							30.302521011000067
						],
						[
							-81.75638085399993,
							30.30362501700006
						],
						[
							-81.7565399579999,
							30.304078999000065
						],
						[
							-81.75654797699991,
							30.30418007600008
						],
						[
							-81.75638690699992,
							30.304240011000047
						],
						[
							-81.75569490799995,
							30.304500011000076
						],
						[
							-81.75523290799994,
							30.304689011000054
						],
						[
							-81.75486790699995,
							30.304841011000068
						],
						[
							-81.75428790799992,
							30.305075011000046
						],
						[
							-81.75393890799995,
							30.30521301100004
						],
						[
							-81.75364190699992,
							30.305332011000075
						],
						[
							-81.7532788819999,
							30.305479964000085
						],
						[
							-81.7532599349999,
							30.305494056000043
						],
						[
							-81.75287090799992,
							30.305647011000076
						],
						[
							-81.75208490799992,
							30.30597801000005
						],
						[
							-81.7518878539999,
							30.306060972000072
						],
						[
							-81.75151590699994,
							30.306203010000047
						],
						[
							-81.75069590699991,
							30.306516010000053
						],
						[
							-81.74953790799992,
							30.30692901100008
						],
						[
							-81.74835990799994,
							30.307304011000042
						],
						[
							-81.7473829079999,
							30.307581010000032
						],
						[
							-81.74672590799992,
							30.307751011000047
						],
						[
							-81.74564790799991,
							30.308011010000087
						],
						[
							-81.74525590699994,
							30.30809401000005
						],
						[
							-81.7444789079999,
							30.308260011000076
						],
						[
							-81.74352290799993,
							30.30844501000007
						],
						[
							-81.74283590699991,
							30.308567011000036
						],
						[
							-81.74208790699993,
							30.30867801000005
						],
						[
							-81.74046290799993,
							30.308882011000037
						],
						[
							-81.7401639069999,
							30.308912010000086
						],
						[
							-81.73944890799993,
							30.30898501100006
						],
						[
							-81.73897990799992,
							30.309018010000045
						],
						[
							-81.73846390699993,
							30.30905501100006
						],
						[
							-81.73738090799992,
							30.309111010000038
						],
						[
							-81.73727390699992,
							30.309111010000038
						],
						[
							-81.7352069069999,
							30.30914301000007
						],
						[
							-81.73345890799993,
							30.309170010000063
						],
						[
							-81.73314690799992,
							30.30917401100004
						],
						[
							-81.73160590799996,
							30.309202010000035
						],
						[
							-81.73063685199992,
							30.309210009000083
						],
						[
							-81.7306209059999,
							30.30841600900004
						],
						[
							-81.73061390599992,
							30.307627009000043
						],
						[
							-81.73059790499991,
							30.306877008000072
						],
						[
							-81.73056790599993,
							30.305099009000063
						],
						[
							-81.73056790599993,
							30.30500600900007
						],
						[
							-81.73056690599992,
							30.30470800900008
						],
						[
							-81.7305519059999,
							30.304379008000073
						],
						[
							-81.73055290499991,
							30.303418009000044
						],
						[
							-81.73053690599994,
							30.30316200900006
						],
						[
							-81.73053590599994,
							30.30308000800005
						],
						[
							-81.7305299059999,
							30.302402009000048
						],
						[
							-81.73052190499993,
							30.301912009000034
						],
						[
							-81.73051490499995,
							30.30173900900007
						],
						[
							-81.73051490599994,
							30.301064008000083
						],
						[
							-81.7305069059999,
							30.300676008000043
						],
						[
							-81.73051490499995,
							30.300467009000048
						],
						[
							-81.7305069059999,
							30.30039000900007
						],
						[
							-81.73049890599992,
							30.29946700800008
						],
						[
							-81.73049890599992,
							30.29941700800003
						],
						[
							-81.73047590599992,
							30.29756900900008
						],
						[
							-81.73046090499992,
							30.296186009000053
						],
						[
							-81.73044590599994,
							30.295622008000063
						],
						[
							-81.73044590599994,
							30.295250009000085
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Hillcrest",
				"RegionID": "269007"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.20033552799993,
					26.00255361500007,
					-80.17521230699992,
					26.033138673000053
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.17559296099995,
							26.00312468500005
						],
						[
							-80.17748224999991,
							26.00312468500005
						],
						[
							-80.18067072799994,
							26.003029507000065
						],
						[
							-80.18942714499991,
							26.002839150000057
						],
						[
							-80.19556089999992,
							26.00265962600008
						],
						[
							-80.1991829349999,
							26.00255361500007
						],
						[
							-80.1995160589999,
							26.010263068000086
						],
						[
							-80.20013471899995,
							26.025110905000076
						],
						[
							-80.20033552799993,
							26.032342759000073
						],
						[
							-80.19870909299993,
							26.032584993000057
						],
						[
							-80.19459109999993,
							26.03265420300005
						],
						[
							-80.19012705599994,
							26.032758018000038
						],
						[
							-80.18414039299995,
							26.032827228000087
						],
						[
							-80.17535072699991,
							26.033138673000053
						],
						[
							-80.17524691199992,
							26.03082013900007
						],
						[
							-80.17521230699992,
							26.02867463000007
						],
						[
							-80.17521230699992,
							26.026390701000082
						],
						[
							-80.17528151699992,
							26.024210586000038
						],
						[
							-80.1754545419999,
							26.021822842000063
						],
						[
							-80.17566217099996,
							26.019400493000035
						],
						[
							-80.17573138099993,
							26.01701274900006
						],
						[
							-80.17562756599995,
							26.014486585000043
						],
						[
							-80.17562756599995,
							26.012133446000064
						],
						[
							-80.17559296099995,
							26.01071464100005
						],
						[
							-80.17559296099995,
							26.00441653300004
						],
						[
							-80.17559296099995,
							26.00312468500005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Hollywood",
				"Name": "Hollywood Hills",
				"RegionID": "269014"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.84778702299991,
					30.225478010000074,
					-81.79348596199992,
					30.24789501100008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.81536390799994,
							30.24789501100008
						],
						[
							-81.81480690699993,
							30.24788101000007
						],
						[
							-81.81403990699994,
							30.247888010000054
						],
						[
							-81.8136899079999,
							30.24788601000006
						],
						[
							-81.8124289079999,
							30.24786101000007
						],
						[
							-81.81160790799993,
							30.247835011000067
						],
						[
							-81.81135890799993,
							30.247836011000064
						],
						[
							-81.81115690699994,
							30.247823011000037
						],
						[
							-81.81059190699995,
							30.247816011000054
						],
						[
							-81.8100429079999,
							30.24781201000008
						],
						[
							-81.80956090799992,
							30.247799011000037
						],
						[
							-81.80902190799992,
							30.247799011000037
						],
						[
							-81.80785340799991,
							30.24776101100008
						],
						[
							-81.80694890799992,
							30.247761010000094
						],
						[
							-81.80677390799991,
							30.247764010000086
						],
						[
							-81.80578490799991,
							30.247752010000056
						],
						[
							-81.80559890699993,
							30.24775101000006
						],
						[
							-81.8040569069999,
							30.247749010000064
						],
						[
							-81.80388690699994,
							30.247744010000076
						],
						[
							-81.80383490799994,
							30.247744010000076
						],
						[
							-81.8032709069999,
							30.24775101000006
						],
						[
							-81.80269390799992,
							30.247748010000066
						],
						[
							-81.8016499069999,
							30.247728010000056
						],
						[
							-81.8012869069999,
							30.247717011000077
						],
						[
							-81.8005449069999,
							30.247714010000042
						],
						[
							-81.79983590699993,
							30.247708010000053
						],
						[
							-81.7992369079999,
							30.247708010000053
						],
						[
							-81.79890490699995,
							30.247708010000053
						],
						[
							-81.79807690799993,
							30.24772101000008
						],
						[
							-81.79745196899995,
							30.24773601000004
						],
						[
							-81.79742790599994,
							30.24766100900007
						],
						[
							-81.79740390599994,
							30.247570007000036
						],
						[
							-81.7971910519999,
							30.246735914000055
						],
						[
							-81.79603580499992,
							30.245844093000073
						],
						[
							-81.7956249049999,
							30.245023009000075
						],
						[
							-81.79524790599993,
							30.24418200900004
						],
						[
							-81.7948539059999,
							30.243347009000047
						],
						[
							-81.79443790699993,
							30.24248600800007
						],
						[
							-81.7940547739999,
							30.24116603000005
						],
						[
							-81.79412790599991,
							30.240332008000053
						],
						[
							-81.79431190499992,
							30.238215008000054
						],
						[
							-81.79387799699992,
							30.23299198600006
						],
						[
							-81.79348596199992,
							30.225478010000074
						],
						[
							-81.79809390899993,
							30.22653900900008
						],
						[
							-81.79814490799993,
							30.226538010000066
						],
						[
							-81.8082229119999,
							30.226343024000073
						],
						[
							-81.81756303799995,
							30.22802187200006
						],
						[
							-81.81852978799992,
							30.232699151000077
						],
						[
							-81.8233339059999,
							30.232643008000082
						],
						[
							-81.82360090499992,
							30.232645008000077
						],
						[
							-81.8277679059999,
							30.232573009000077
						],
						[
							-81.82998690599993,
							30.232578008000075
						],
						[
							-81.8303379059999,
							30.232582008000065
						],
						[
							-81.83161890499991,
							30.23256700800005
						],
						[
							-81.83188390499993,
							30.23256300800006
						],
						[
							-81.83457190599995,
							30.232525008000042
						],
						[
							-81.83622690599992,
							30.232479009000087
						],
						[
							-81.83768490499995,
							30.232450008000058
						],
						[
							-81.8405839049999,
							30.232443008000075
						],
						[
							-81.84250590499994,
							30.23242800800006
						],
						[
							-81.84295690599993,
							30.232435008000035
						],
						[
							-81.8436739039999,
							30.23242000500005
						],
						[
							-81.84372801599994,
							30.232400144000053
						],
						[
							-81.84379003099991,
							30.232303055000045
						],
						[
							-81.84380890499995,
							30.232204009000043
						],
						[
							-81.84389890599994,
							30.230911008000078
						],
						[
							-81.84414090599995,
							30.229653009000057
						],
						[
							-81.84429182899993,
							30.229037971000082
						],
						[
							-81.84435385699993,
							30.22895594200008
						],
						[
							-81.84440199599993,
							30.22893506400004
						],
						[
							-81.84439790499994,
							30.229316009000062
						],
						[
							-81.84436990599994,
							30.231795009000056
						],
						[
							-81.84442190599994,
							30.23384100900006
						],
						[
							-81.8443859059999,
							30.23451700800007
						],
						[
							-81.84439590499994,
							30.234999009000035
						],
						[
							-81.84475485399992,
							30.241529018000055
						],
						[
							-81.84507190699992,
							30.242424008000057
						],
						[
							-81.84548690499992,
							30.243157009000072
						],
						[
							-81.84684190599995,
							30.245452009000076
						],
						[
							-81.8471789059999,
							30.245922009000083
						],
						[
							-81.84741590899995,
							30.24620200700008
						],
						[
							-81.84753490499992,
							30.246278008000047
						],
						[
							-81.84762790699995,
							30.24633700700008
						],
						[
							-81.84778702299991,
							30.246390019000042
						],
						[
							-81.8457419049999,
							30.246703008000054
						],
						[
							-81.84456875999992,
							30.246882885000048
						],
						[
							-81.84456990599995,
							30.24694000800008
						],
						[
							-81.84458589399992,
							30.247025010000073
						],
						[
							-81.84406990699995,
							30.247025010000073
						],
						[
							-81.84393690799993,
							30.247028010000065
						],
						[
							-81.84289790699995,
							30.247040010000035
						],
						[
							-81.8425549079999,
							30.247040010000035
						],
						[
							-81.84172590799994,
							30.247067010000077
						],
						[
							-81.84141890799992,
							30.24706501000008
						],
						[
							-81.84105090799994,
							30.247067010000077
						],
						[
							-81.84060190799994,
							30.247072010000068
						],
						[
							-81.84030190699991,
							30.247077010000055
						],
						[
							-81.84016290699992,
							30.24707901000005
						],
						[
							-81.83954290699995,
							30.247081011000034
						],
						[
							-81.83895190699991,
							30.24710701000004
						],
						[
							-81.83781990699993,
							30.247158011000067
						],
						[
							-81.83660490799993,
							30.247168010000053
						],
						[
							-81.83575290699991,
							30.24718701000006
						],
						[
							-81.8349009069999,
							30.247186010000064
						],
						[
							-81.83457290799993,
							30.24719701000004
						],
						[
							-81.83419890699992,
							30.247211011000047
						],
						[
							-81.83300190799991,
							30.247229011000062
						],
						[
							-81.83180490799992,
							30.24726601000009
						],
						[
							-81.83160890799991,
							30.247273011000065
						],
						[
							-81.83050390699992,
							30.247333011000077
						],
						[
							-81.82917890699991,
							30.24737601000004
						],
						[
							-81.82850190699992,
							30.247388011000055
						],
						[
							-81.8279869079999,
							30.24741001100006
						],
						[
							-81.82738190799995,
							30.24743201000007
						],
						[
							-81.8268219069999,
							30.247448011000074
						],
						[
							-81.82627490699991,
							30.247475010000077
						],
						[
							-81.82602290699992,
							30.24749501000008
						],
						[
							-81.82571490799995,
							30.24750401100005
						],
						[
							-81.82456190699992,
							30.247536009000044
						],
						[
							-81.82449590699991,
							30.24753800900004
						],
						[
							-81.8238229079999,
							30.24756501100006
						],
						[
							-81.82351190799994,
							30.247574010000054
						],
						[
							-81.82340090699996,
							30.24757501000005
						],
						[
							-81.82281690699995,
							30.247602011000087
						],
						[
							-81.82232790799992,
							30.24762601100008
						],
						[
							-81.82122590699993,
							30.247674010000086
						],
						[
							-81.81994290799992,
							30.247722011000064
						],
						[
							-81.81973290799993,
							30.247729010000057
						],
						[
							-81.8184419079999,
							30.247790010000074
						],
						[
							-81.81743790699994,
							30.247817011000052
						],
						[
							-81.81679390699993,
							30.24783301000008
						],
						[
							-81.81652990799995,
							30.24785001000004
						],
						[
							-81.8163689079999,
							30.247856011000067
						],
						[
							-81.81621390799995,
							30.24786101000007
						],
						[
							-81.81536390799994,
							30.24789501100008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Jacksonville Heights South",
				"RegionID": "269021"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.59956494499994,
					30.103748000000053,
					-81.50421199999994,
					30.15883606300008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.53444990499992,
							30.134829008000057
						],
						[
							-81.53288990499993,
							30.13325900800004
						],
						[
							-81.5298639049999,
							30.130257008000058
						],
						[
							-81.52836790599991,
							30.12871500900008
						],
						[
							-81.5264579059999,
							30.12682600700009
						],
						[
							-81.52467290499993,
							30.125032007000073
						],
						[
							-81.52445190599991,
							30.124796007000043
						],
						[
							-81.52390290599993,
							30.124252007000052
						],
						[
							-81.5232159059999,
							30.123549007000065
						],
						[
							-81.52149990599992,
							30.121826007000042
						],
						[
							-81.51944390499995,
							30.119750008000036
						],
						[
							-81.51912690499995,
							30.119431007000063
						],
						[
							-81.5170059049999,
							30.117275008000036
						],
						[
							-81.5154739059999,
							30.115740008000046
						],
						[
							-81.51460990499993,
							30.11486400700005
						],
						[
							-81.51322890599994,
							30.113470008000032
						],
						[
							-81.51213790599992,
							30.112352007000087
						],
						[
							-81.51105490499992,
							30.111267007000038
						],
						[
							-81.51086390499995,
							30.111061007000046
						],
						[
							-81.50949090599994,
							30.109673007000083
						],
						[
							-81.50849890599994,
							30.10866900700006
						],
						[
							-81.50559290599995,
							30.10572700700004
						],
						[
							-81.50440890599992,
							30.104527008000048
						],
						[
							-81.50421199999994,
							30.10434900000007
						],
						[
							-81.50426399999992,
							30.104348000000073
						],
						[
							-81.50925499999994,
							30.104276000000088
						],
						[
							-81.50925651199992,
							30.104276000000088
						],
						[
							-81.50925799999993,
							30.104276000000088
						],
						[
							-81.50949999999995,
							30.104273000000035
						],
						[
							-81.5126019999999,
							30.104199000000047
						],
						[
							-81.5135459999999,
							30.10417700000005
						],
						[
							-81.5143809999999,
							30.104157000000043
						],
						[
							-81.51494699999995,
							30.104143000000082
						],
						[
							-81.51505199999991,
							30.104142000000085
						],
						[
							-81.51512699999995,
							30.104142000000085
						],
						[
							-81.51525199999992,
							30.104141000000087
						],
						[
							-81.51529899999991,
							30.104141000000087
						],
						[
							-81.51529999999991,
							30.104141000000087
						],
						[
							-81.51530099999991,
							30.104140998000045
						],
						[
							-81.5162429579999,
							30.104137025000057
						],
						[
							-81.5162489999999,
							30.10413699700007
						],
						[
							-81.51643999999993,
							30.104136000000043
						],
						[
							-81.51661999999993,
							30.104135000000046
						],
						[
							-81.5167209999999,
							30.104135000000046
						],
						[
							-81.51676999999995,
							30.104135000000046
						],
						[
							-81.5171467589999,
							30.10413327700007
						],
						[
							-81.51742599999994,
							30.10413200000005
						],
						[
							-81.51774299999994,
							30.104131000000052
						],
						[
							-81.51827299999991,
							30.10412800000006
						],
						[
							-81.52362899999991,
							30.104103000000062
						],
						[
							-81.52593499999995,
							30.104093000000038
						],
						[
							-81.52596899999992,
							30.10409200000004
						],
						[
							-81.53129378599994,
							30.10394820000005
						],
						[
							-81.5313256259999,
							30.103947340000047
						],
						[
							-81.53870699999993,
							30.103748000000053
						],
						[
							-81.53870799999993,
							30.103842000000043
						],
						[
							-81.53871099999992,
							30.103983000000085
						],
						[
							-81.53871499999991,
							30.104195000000058
						],
						[
							-81.5388576069999,
							30.111826450000084
						],
						[
							-81.53885864599994,
							30.11188203600005
						],
						[
							-81.5388591809999,
							30.111910675000047
						],
						[
							-81.53900282899991,
							30.11959785000005
						],
						[
							-81.53900499999992,
							30.11971400000004
						],
						[
							-81.53900899999992,
							30.11994200000004
						],
						[
							-81.53941505099993,
							30.119891346000088
						],
						[
							-81.54644799999994,
							30.11901400000005
						],
						[
							-81.54667296899993,
							30.118985560000056
						],
						[
							-81.54701813799994,
							30.118941924000072
						],
						[
							-81.54706499999992,
							30.118936000000076
						],
						[
							-81.54706699999991,
							30.118936000000076
						],
						[
							-81.54706824899995,
							30.118936000000076
						],
						[
							-81.54706899999992,
							30.118936000000076
						],
						[
							-81.5470719999999,
							30.118936000000076
						],
						[
							-81.55064599999992,
							30.11849000000006
						],
						[
							-81.5510799999999,
							30.118435000000094
						],
						[
							-81.55108199999995,
							30.118435000000094
						],
						[
							-81.55108399999995,
							30.118435000000094
						],
						[
							-81.55108421999995,
							30.118435000000094
						],
						[
							-81.55108599999994,
							30.118435000000094
						],
						[
							-81.55108899999993,
							30.118435000000094
						],
						[
							-81.55322826699995,
							30.11816833000006
						],
						[
							-81.5532629999999,
							30.118164000000032
						],
						[
							-81.55554645799992,
							30.117879438000045
						],
						[
							-81.55564793399992,
							30.117866792000086
						],
						[
							-81.55621599999995,
							30.117796000000055
						],
						[
							-81.55622649999992,
							30.117795000000058
						],
						[
							-81.5562369999999,
							30.11779400000006
						],
						[
							-81.55633499999993,
							30.117786000000077
						],
						[
							-81.55656199999993,
							30.11776800000007
						],
						[
							-81.55689482999992,
							30.11766024900004
						],
						[
							-81.5569789999999,
							30.117633000000072
						],
						[
							-81.55755399999993,
							30.11743800000005
						],
						[
							-81.55771299999992,
							30.117256000000054
						],
						[
							-81.55796599999991,
							30.117082000000043
						],
						[
							-81.55815958799991,
							30.117059225000048
						],
						[
							-81.55818699999992,
							30.117056000000048
						],
						[
							-81.55819099999991,
							30.117057000000045
						],
						[
							-81.5581949999999,
							30.117058000000043
						],
						[
							-81.5584409999999,
							30.117144000000053
						],
						[
							-81.55845499999992,
							30.11714900000004
						],
						[
							-81.55845799999993,
							30.117150000000038
						],
						[
							-81.55845899899992,
							30.11715050000004
						],
						[
							-81.55845999999993,
							30.117151000000035
						],
						[
							-81.5584629999999,
							30.11715200000009
						],
						[
							-81.55847699999993,
							30.117157000000077
						],
						[
							-81.55849999999992,
							30.11716500000006
						],
						[
							-81.55865299999994,
							30.11721800000004
						],
						[
							-81.55902499999992,
							30.11723900000004
						],
						[
							-81.55930899999993,
							30.11716000000007
						],
						[
							-81.55975199999995,
							30.117033000000053
						],
						[
							-81.55995270999995,
							30.117014210000036
						],
						[
							-81.55998699999992,
							30.117011000000048
						],
						[
							-81.5601989999999,
							30.117039000000087
						],
						[
							-81.56020261099991,
							30.11703990300009
						],
						[
							-81.56020299999994,
							30.117040000000085
						],
						[
							-81.56020696799993,
							30.117040794000047
						],
						[
							-81.56020799999993,
							30.117041000000086
						],
						[
							-81.56020870099991,
							30.117041172000086
						],
						[
							-81.5602649999999,
							30.11705500000005
						],
						[
							-81.5602669999999,
							30.11705500000005
						],
						[
							-81.56026899999995,
							30.11705500000005
						],
						[
							-81.56027099999994,
							30.11705500000005
						],
						[
							-81.56027199999994,
							30.11705500000005
						],
						[
							-81.56027299999994,
							30.11705500000005
						],
						[
							-81.56027499999993,
							30.11705500000005
						],
						[
							-81.56027699999993,
							30.11705500000005
						],
						[
							-81.56027899999992,
							30.11705500000005
						],
						[
							-81.56031299999995,
							30.117067000000077
						],
						[
							-81.5603989999999,
							30.117088000000077
						],
						[
							-81.5604689999999,
							30.117106000000035
						],
						[
							-81.56067699999994,
							30.117159000000072
						],
						[
							-81.56086278099991,
							30.117234766000085
						],
						[
							-81.56117587099993,
							30.11736245000009
						],
						[
							-81.56121399999995,
							30.117378000000087
						],
						[
							-81.56168899999994,
							30.117488000000037
						],
						[
							-81.5621799999999,
							30.117543000000072
						],
						[
							-81.5633269999999,
							30.117373000000043
						],
						[
							-81.56368392299993,
							30.117389967000065
						],
						[
							-81.56391599999995,
							30.11740100000009
						],
						[
							-81.56392199999993,
							30.11740100000009
						],
						[
							-81.56392284999993,
							30.117401425000086
						],
						[
							-81.56392399999993,
							30.117402000000087
						],
						[
							-81.56392699999992,
							30.117402000000087
						],
						[
							-81.5639369999999,
							30.117402000000087
						],
						[
							-81.56394699999993,
							30.117402000000087
						],
						[
							-81.56395199399992,
							30.117402000000087
						],
						[
							-81.5639569999999,
							30.117402000000087
						],
						[
							-81.56396699999993,
							30.117402000000087
						],
						[
							-81.56397599999991,
							30.117402000000087
						],
						[
							-81.56398499999995,
							30.117402000000087
						],
						[
							-81.56413977799991,
							30.117430020000086
						],
						[
							-81.56417326499991,
							30.117436083000083
						],
						[
							-81.56433299999992,
							30.117465000000035
						],
						[
							-81.56458099999992,
							30.117587000000075
						],
						[
							-81.56504999999993,
							30.117866000000053
						],
						[
							-81.56532399999992,
							30.11794800000007
						],
						[
							-81.56537299999991,
							30.117963000000092
						],
						[
							-81.56539869599993,
							30.11796339600005
						],
						[
							-81.56647699999992,
							30.117980000000042
						],
						[
							-81.56718299999994,
							30.11779400000006
						],
						[
							-81.56718500399995,
							30.117793499000072
						],
						[
							-81.56718699999993,
							30.117793000000063
						],
						[
							-81.56721699999991,
							30.11778500000008
						],
						[
							-81.56724699999995,
							30.11777700000005
						],
						[
							-81.56726999999997,
							30.11777100000006
						],
						[
							-81.56727052899993,
							30.11777082400005
						],
						[
							-81.56727299999994,
							30.117770000000064
						],
						[
							-81.56727585699991,
							30.117769429000077
						],
						[
							-81.56727799999993,
							30.117769000000067
						],
						[
							-81.56738199999995,
							30.117742000000074
						],
						[
							-81.56739249999993,
							30.117739000000082
						],
						[
							-81.5674029999999,
							30.11773600000004
						],
						[
							-81.5674453119999,
							30.11774146000005
						],
						[
							-81.56746499999991,
							30.11774400000007
						],
						[
							-81.56763799999993,
							30.11776800000007
						],
						[
							-81.56764199999992,
							30.117769000000067
						],
						[
							-81.56771999999995,
							30.117780000000042
						],
						[
							-81.56772199999995,
							30.117780000000042
						],
						[
							-81.56772999999993,
							30.11778100000004
						],
						[
							-81.56773199999992,
							30.11778100000004
						],
						[
							-81.56773399999992,
							30.11778100000004
						],
						[
							-81.56773599999991,
							30.11778100000004
						],
						[
							-81.5677379999999,
							30.11778100000004
						],
						[
							-81.56774199999991,
							30.11778100000004
						],
						[
							-81.56774399999995,
							30.117782000000094
						],
						[
							-81.56778699999991,
							30.11778900000007
						],
						[
							-81.56792899999995,
							30.117864000000054
						],
						[
							-81.5687069999999,
							30.118369000000087
						],
						[
							-81.56952199999996,
							30.118815000000044
						],
						[
							-81.56998699999991,
							30.11907000000008
						],
						[
							-81.56999499999995,
							30.11907400000007
						],
						[
							-81.5705539999999,
							30.11937900000004
						],
						[
							-81.57081699999992,
							30.119589000000076
						],
						[
							-81.57090199999993,
							30.119785000000036
						],
						[
							-81.57105199999995,
							30.11995600000006
						],
						[
							-81.57137999999992,
							30.119892000000053
						],
						[
							-81.57154199999991,
							30.119860000000074
						],
						[
							-81.57155799999992,
							30.11985700000008
						],
						[
							-81.5715689999999,
							30.119855000000086
						],
						[
							-81.57157199999995,
							30.11985400000009
						],
						[
							-81.5716589999999,
							30.11983700000008
						],
						[
							-81.57182499999993,
							30.119900000000083
						],
						[
							-81.57192326599994,
							30.120188969000083
						],
						[
							-81.57194299999992,
							30.120247000000063
						],
						[
							-81.57198899999992,
							30.120291885000086
						],
						[
							-81.5721079999999,
							30.120408000000058
						],
						[
							-81.57229899999993,
							30.120464000000084
						],
						[
							-81.5726049999999,
							30.12044800000007
						],
						[
							-81.57262299999991,
							30.120447000000073
						],
						[
							-81.57266799999991,
							30.12044500000008
						],
						[
							-81.57284199999992,
							30.12043600000004
						],
						[
							-81.57310599999994,
							30.120422000000076
						],
						[
							-81.57310799999993,
							30.120422000000076
						],
						[
							-81.5731419999999,
							30.12042000000008
						],
						[
							-81.57315799999992,
							30.120422000000076
						],
						[
							-81.57329599999991,
							30.120443000000083
						],
						[
							-81.57355799999993,
							30.12048100000004
						],
						[
							-81.57371599999993,
							30.120573000000036
						],
						[
							-81.57394499999992,
							30.12088900000009
						],
						[
							-81.57434099999995,
							30.12131100000005
						],
						[
							-81.57463299999995,
							30.121492000000043
						],
						[
							-81.57538299999995,
							30.121551000000068
						],
						[
							-81.57572499999992,
							30.121723000000085
						],
						[
							-81.57572699999992,
							30.121723000000085
						],
						[
							-81.57578099999995,
							30.121752000000072
						],
						[
							-81.57605899999993,
							30.122070000000065
						],
						[
							-81.57640299999991,
							30.122604000000084
						],
						[
							-81.57641899999993,
							30.122628000000077
						],
						[
							-81.57675599999993,
							30.122907000000055
						],
						[
							-81.5767679999999,
							30.12291300000004
						],
						[
							-81.5767699999999,
							30.12291300000004
						],
						[
							-81.57702199999994,
							30.12301300000007
						],
						[
							-81.57757099999992,
							30.12323100000009
						],
						[
							-81.57769699999994,
							30.123281000000077
						],
						[
							-81.57770799999992,
							30.123285000000067
						],
						[
							-81.57770999999991,
							30.123286000000064
						],
						[
							-81.5777149999999,
							30.12328800000006
						],
						[
							-81.57771699999995,
							30.123289000000057
						],
						[
							-81.57781199999994,
							30.123327000000074
						],
						[
							-81.57786599999993,
							30.123348000000078
						],
						[
							-81.57801299999994,
							30.123473000000047
						],
						[
							-81.57818099999992,
							30.123615000000086
						],
						[
							-81.57842899999993,
							30.123848000000066
						],
						[
							-81.57852899999995,
							30.124306000000043
						],
						[
							-81.58065109699993,
							30.125923952000054
						],
						[
							-81.58088199999992,
							30.126100000000065
						],
						[
							-81.58115685099996,
							30.126055187000077
						],
						[
							-81.5811579999999,
							30.126055000000065
						],
						[
							-81.58350399999995,
							30.125676000000055
						],
						[
							-81.58442632099991,
							30.125697820000084
						],
						[
							-81.5845491959999,
							30.125700727000034
						],
						[
							-81.59026699999993,
							30.125836000000053
						],
						[
							-81.59051099999994,
							30.12584100000004
						],
						[
							-81.59157399999992,
							30.126308000000055
						],
						[
							-81.59347999999994,
							30.12714500000004
						],
						[
							-81.59688088399992,
							30.128638715000076
						],
						[
							-81.59716498799992,
							30.128934033000068
						],
						[
							-81.59771760099994,
							30.129475829000057
						],
						[
							-81.59773319999994,
							30.129491503000054
						],
						[
							-81.5981351989999,
							30.12990550300009
						],
						[
							-81.59815759299994,
							30.129929422000085
						],
						[
							-81.5985375919999,
							30.130350422000046
						],
						[
							-81.5985560009999,
							30.130371466000042
						],
						[
							-81.59889000099992,
							30.130765466000067
						],
						[
							-81.59893297699995,
							30.130820338000035
						],
						[
							-81.59926097699991,
							30.131274339000072
						],
						[
							-81.5993025649999,
							30.13133731000005
						],
						[
							-81.5993387279999,
							30.131403546000055
						],
						[
							-81.5993692099999,
							30.13147258200007
						],
						[
							-81.59939379699995,
							30.13154392900009
						],
						[
							-81.59949879699991,
							30.131895929000052
						],
						[
							-81.5995231149999,
							30.131999440000072
						],
						[
							-81.59956494499994,
							30.13224082200009
						],
						[
							-81.5994509109999,
							30.13259192800007
						],
						[
							-81.59925366399995,
							30.132960695000065
						],
						[
							-81.59897065599995,
							30.133278006000072
						],
						[
							-81.59861904099995,
							30.133535286000043
						],
						[
							-81.59830172999995,
							30.133723957000086
						],
						[
							-81.59802729899991,
							30.13386117300007
						],
						[
							-81.59770141099995,
							30.13396408500006
						],
						[
							-81.59735837199992,
							30.134024116000038
						],
						[
							-81.59693814899993,
							30.134024116000038
						],
						[
							-81.59649219799991,
							30.133955509000085
						],
						[
							-81.59644299999991,
							30.134449000000075
						],
						[
							-81.59632090399992,
							30.13553801000006
						],
						[
							-81.59627490499992,
							30.135677008000076
						],
						[
							-81.59621390399991,
							30.135792009000056
						],
						[
							-81.59597790499993,
							30.136078008000084
						],
						[
							-81.5958709059999,
							30.136221009000057
						],
						[
							-81.59578690599994,
							30.136356009000053
						],
						[
							-81.59571790699994,
							30.136518008000056
						],
						[
							-81.59567990699992,
							30.136650009000054
						],
						[
							-81.59565690699992,
							30.136837008000043
						],
						[
							-81.59565690699992,
							30.136902008000053
						],
						[
							-81.59573390599991,
							30.137697008000092
						],
						[
							-81.59576390399991,
							30.138023008000065
						],
						[
							-81.59575690699995,
							30.138159008000063
						],
						[
							-81.59576390399991,
							30.138248008000062
						],
						[
							-81.5957409049999,
							30.138489009000068
						],
						[
							-81.59568790499992,
							30.13877100900004
						],
						[
							-81.59553490699994,
							30.139292006000062
						],
						[
							-81.5955119059999,
							30.13951900800004
						],
						[
							-81.59551990599994,
							30.139786009000094
						],
						[
							-81.59558090599995,
							30.14116300800004
						],
						[
							-81.59564190599991,
							30.142658010000048
						],
						[
							-81.59563390599993,
							30.143139008000045
						],
						[
							-81.59563390599993,
							30.144135008000035
						],
						[
							-81.59563390599993,
							30.14448700800006
						],
						[
							-81.59566490599991,
							30.146021008000048
						],
						[
							-81.59567290599995,
							30.146416008000077
						],
						[
							-81.59572890499993,
							30.148286008000074
						],
						[
							-81.59575090599992,
							30.148669008000066
						],
						[
							-81.59578990599994,
							30.14886900600004
						],
						[
							-81.59605990499996,
							30.14953600800004
						],
						[
							-81.5965039049999,
							30.15040600900005
						],
						[
							-81.59686990499995,
							30.15114000900007
						],
						[
							-81.59705490499994,
							30.151492009000037
						],
						[
							-81.59721690599991,
							30.151795009000065
						],
						[
							-81.59743190599994,
							30.15220800800006
						],
						[
							-81.59754690599993,
							30.152435009000047
						],
						[
							-81.59847290599993,
							30.154214009000043
						],
						[
							-81.59861090499993,
							30.154519010000058
						],
						[
							-81.59882990499995,
							30.15510500900007
						],
						[
							-81.59896790499994,
							30.155524008000043
						],
						[
							-81.5991409049999,
							30.156027008000084
						],
						[
							-81.59931103799994,
							30.15658498700009
						],
						[
							-81.59929695799991,
							30.15675901800006
						],
						[
							-81.59923790399995,
							30.156937006000078
						],
						[
							-81.59913594699992,
							30.157089043000042
						],
						[
							-81.59886990599995,
							30.157341008000056
						],
						[
							-81.59865390499994,
							30.157566008000064
						],
						[
							-81.59761290599994,
							30.158649008000058
						],
						[
							-81.59747488999994,
							30.15883606300008
						],
						[
							-81.59644590699993,
							30.15824701100007
						],
						[
							-81.59357190599991,
							30.15658101000008
						],
						[
							-81.59310690799992,
							30.156318011000053
						],
						[
							-81.59301690599995,
							30.156263011000078
						],
						[
							-81.59216690699992,
							30.155823010000063
						],
						[
							-81.59157490599995,
							30.155565010000092
						],
						[
							-81.5900269089999,
							30.154852011000056
						],
						[
							-81.58997190699995,
							30.154828010000074
						],
						[
							-81.58902390799994,
							30.154373010000086
						],
						[
							-81.58740490699995,
							30.15360501100008
						],
						[
							-81.58708990799994,
							30.153476010000077
						],
						[
							-81.58597190899991,
							30.15293601000008
						],
						[
							-81.5811369079999,
							30.15073601100005
						],
						[
							-81.58028590899994,
							30.150340010000036
						],
						[
							-81.57826490699995,
							30.14941701000004
						],
						[
							-81.57797690599995,
							30.149307010000086
						],
						[
							-81.57760690599991,
							30.14919701100007
						],
						[
							-81.57660090899992,
							30.148930011000065
						],
						[
							-81.57437690899991,
							30.148382011000077
						],
						[
							-81.5739359079999,
							30.148291010000037
						],
						[
							-81.57348590599992,
							30.148170010000054
						],
						[
							-81.57215890599991,
							30.147836010000052
						],
						[
							-81.57199290699992,
							30.147795010000035
						],
						[
							-81.57074690699994,
							30.147486011000073
						],
						[
							-81.56856590899993,
							30.146913011000038
						],
						[
							-81.56836090799993,
							30.146862010000063
						],
						[
							-81.56741890899991,
							30.14663001000008
						],
						[
							-81.56529490599992,
							30.14610501000004
						],
						[
							-81.56476090599995,
							30.145969010000044
						],
						[
							-81.56373390599992,
							30.14571101000007
						],
						[
							-81.56272190599992,
							30.145457011000076
						],
						[
							-81.56180790699995,
							30.14522001100005
						],
						[
							-81.56053090699993,
							30.144904011000055
						],
						[
							-81.5591289059999,
							30.144547010000057
						],
						[
							-81.55853190699992,
							30.144403011000065
						],
						[
							-81.5576089079999,
							30.14416401100004
						],
						[
							-81.55563890799993,
							30.143694011000033
						],
						[
							-81.55469690799993,
							30.143472010000043
						],
						[
							-81.55432485999995,
							30.143396135000046
						],
						[
							-81.55418892999995,
							30.14330493200004
						],
						[
							-81.55378490899994,
							30.143286010000057
						],
						[
							-81.55291790599996,
							30.14314201000008
						],
						[
							-81.5525639089999,
							30.143075011000068
						],
						[
							-81.55039790699993,
							30.142722011000046
						],
						[
							-81.54519590699994,
							30.141770010000073
						],
						[
							-81.54463590799992,
							30.14158501100007
						],
						[
							-81.54431990899991,
							30.14153701100008
						],
						[
							-81.54310290699995,
							30.141472011000076
						],
						[
							-81.54242990599994,
							30.141436010000064
						],
						[
							-81.54224890599994,
							30.141427010000086
						],
						[
							-81.54136290899993,
							30.141345010000066
						],
						[
							-81.5407939239999,
							30.141326121000077
						],
						[
							-81.54055790599995,
							30.14111800800004
						],
						[
							-81.53896590599993,
							30.139512008000054
						],
						[
							-81.53853290599994,
							30.139085008000052
						],
						[
							-81.53718990499993,
							30.137710009000045
						],
						[
							-81.53444990499992,
							30.134829008000057
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Del Rio",
				"RegionID": "273452"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.43467268668749,
					27.952481819920948,
					-82.40140909226912,
					27.968206039324556
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.40140909226912,
							27.965409090256827
						],
						[
							-82.40150903752358,
							27.952481819920948
						],
						[
							-82.40770910029052,
							27.952599947668084
						],
						[
							-82.41510908167639,
							27.954800051778534
						],
						[
							-82.42451819074383,
							27.954799948356552
						],
						[
							-82.42621820435683,
							27.955299939928523
						],
						[
							-82.42761816007413,
							27.9561000793285
						],
						[
							-82.43451818226357,
							27.956142735970985
						],
						[
							-82.4345181813642,
							27.956172727461343
						],
						[
							-82.43467268668749,
							27.965400027788718
						],
						[
							-82.4175316915467,
							27.96552717843393
						],
						[
							-82.4169182046353,
							27.965299868495684
						],
						[
							-82.41401241961559,
							27.96536176973031
						],
						[
							-82.40751815803588,
							27.96549986872175
						],
						[
							-82.40339997360606,
							27.967127227906673
						],
						[
							-82.40200187948541,
							27.968187171548415
						],
						[
							-82.40197729471909,
							27.968206039324556
						],
						[
							-82.40175753818666,
							27.96712425474815
						],
						[
							-82.40140909226912,
							27.965409090256827
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "East Ybor",
				"RegionID": "273575"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.31054499999993,
					28.51898000000006,
					-81.28920199999993,
					28.539220000000057
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.2926609999999,
							28.539079000000072
						],
						[
							-81.29266499999994,
							28.53789100000006
						],
						[
							-81.29183599999993,
							28.53788300000008
						],
						[
							-81.29183199999994,
							28.537773000000072
						],
						[
							-81.29183899999992,
							28.53762100000006
						],
						[
							-81.29184499999991,
							28.532971000000092
						],
						[
							-81.2905889999999,
							28.532971000000092
						],
						[
							-81.28967099999994,
							28.531707000000043
						],
						[
							-81.28920999999991,
							28.529944000000057
						],
						[
							-81.28920199999993,
							28.52969900000005
						],
						[
							-81.28922399999993,
							28.529580000000067
						],
						[
							-81.2892809999999,
							28.529408000000046
						],
						[
							-81.2894149999999,
							28.529251000000045
						],
						[
							-81.28951599999994,
							28.529127000000077
						],
						[
							-81.28959999999995,
							28.529034000000085
						],
						[
							-81.2898899999999,
							28.528759000000036
						],
						[
							-81.2899779999999,
							28.528679000000068
						],
						[
							-81.29010599999992,
							28.52857800000004
						],
						[
							-81.29023999999993,
							28.52844200000004
						],
						[
							-81.29035499999992,
							28.52831800000007
						],
						[
							-81.2904289999999,
							28.528170000000046
						],
						[
							-81.29044899999991,
							28.528022000000078
						],
						[
							-81.29042199999992,
							28.52788000000004
						],
						[
							-81.29035499999992,
							28.52774400000004
						],
						[
							-81.29026799999991,
							28.52763000000005
						],
						[
							-81.29023299999994,
							28.527584000000047
						],
						[
							-81.29003699999993,
							28.527307000000064
						],
						[
							-81.28999799999991,
							28.527258000000074
						],
						[
							-81.2901809999999,
							28.527097000000083
						],
						[
							-81.2903419999999,
							28.527070000000037
						],
						[
							-81.29074777999995,
							28.52683408100006
						],
						[
							-81.2909009999999,
							28.526745000000062
						],
						[
							-81.29122499999994,
							28.52673600000009
						],
						[
							-81.29141799999991,
							28.526651000000072
						],
						[
							-81.29170799999991,
							28.526647000000082
						],
						[
							-81.2917799999999,
							28.526647000000082
						],
						[
							-81.2917789999999,
							28.526699000000065
						],
						[
							-81.2920529999999,
							28.52769600000005
						],
						[
							-81.29224999999991,
							28.52846100000005
						],
						[
							-81.29263399999991,
							28.529057000000083
						],
						[
							-81.29278999999991,
							28.52897900000005
						],
						[
							-81.29279799999995,
							28.528884000000062
						],
						[
							-81.29286399999995,
							28.528946000000076
						],
						[
							-81.29298199999994,
							28.52889500000009
						],
						[
							-81.29319199999992,
							28.528810000000078
						],
						[
							-81.2934019999999,
							28.528720000000078
						],
						[
							-81.29361899999992,
							28.528593000000058
						],
						[
							-81.29369699999995,
							28.528530000000046
						],
						[
							-81.29384099999993,
							28.528415000000052
						],
						[
							-81.29386399999993,
							28.528354000000036
						],
						[
							-81.29388599999993,
							28.528276000000062
						],
						[
							-81.29391299999992,
							28.527931000000084
						],
						[
							-81.29391299999992,
							28.52768800000007
						],
						[
							-81.29392499999994,
							28.526587000000063
						],
						[
							-81.29392599999994,
							28.526208000000054
						],
						[
							-81.29419699999994,
							28.526208000000054
						],
						[
							-81.29462999999993,
							28.526208000000054
						],
						[
							-81.29496299999994,
							28.526207000000056
						],
						[
							-81.29514799999993,
							28.526383000000067
						],
						[
							-81.29659299999992,
							28.52639000000005
						],
						[
							-81.29659299999992,
							28.526175000000084
						],
						[
							-81.29659299999992,
							28.52444200000008
						],
						[
							-81.29808999999995,
							28.524380000000065
						],
						[
							-81.29808999999995,
							28.52422400000006
						],
						[
							-81.29808399999992,
							28.52007800000007
						],
						[
							-81.29808999999995,
							28.51898000000006
						],
						[
							-81.29830588399994,
							28.519063475000056
						],
						[
							-81.29868145499995,
							28.519206694000047
						],
						[
							-81.29879362099992,
							28.51924875700007
						],
						[
							-81.30043905999992,
							28.519866672000035
						],
						[
							-81.3004991489999,
							28.519891709000035
						],
						[
							-81.30074451299993,
							28.519980841000063
						],
						[
							-81.30100790499995,
							28.52005695400004
						],
						[
							-81.30123123599992,
							28.520120049000074
						],
						[
							-81.30208942899992,
							28.52046662600009
						],
						[
							-81.3031090209999,
							28.520825095000077
						],
						[
							-81.3036147709999,
							28.521031399000037
						],
						[
							-81.30364181099992,
							28.52104141400008
						],
						[
							-81.30405342199992,
							28.521190637000075
						],
						[
							-81.30479852699995,
							28.521462039000085
						],
						[
							-81.30491970599991,
							28.52150610500007
						],
						[
							-81.30504689399993,
							28.52155017000007
						],
						[
							-81.30529526299995,
							28.521637299000076
						],
						[
							-81.30616371199994,
							28.521966680000048
						],
						[
							-81.30615738199992,
							28.522041005000062
						],
						[
							-81.3076647769999,
							28.522590712000067
						],
						[
							-81.30803031899991,
							28.522716900000034
						],
						[
							-81.30807338299991,
							28.522736929000075
						],
						[
							-81.30824163199992,
							28.522801025000035
						],
						[
							-81.30903981699993,
							28.523111485000072
						],
						[
							-81.3091920409999,
							28.523175580000043
						],
						[
							-81.30997119799991,
							28.523479029000043
						],
						[
							-81.31028966899993,
							28.52360421600008
						],
						[
							-81.3103377409999,
							28.523623243000088
						],
						[
							-81.3103841109999,
							28.523640411000088
						],
						[
							-81.31038881699993,
							28.52394672300005
						],
						[
							-81.31039182199993,
							28.524167050000074
						],
						[
							-81.31039182199993,
							28.524208111000064
						],
						[
							-81.3103998329999,
							28.524912155000038
						],
						[
							-81.3104308799999,
							28.52759513400008
						],
						[
							-81.3104368889999,
							28.52941984100005
						],
						[
							-81.31044089499994,
							28.529706266000062
						],
						[
							-81.31044189599993,
							28.52974131800005
						],
						[
							-81.31044189599993,
							28.52978237900004
						],
						[
							-81.31043989299991,
							28.530329189000046
						],
						[
							-81.31045090899994,
							28.531112350000058
						],
						[
							-81.3104619259999,
							28.531639131000077
						],
						[
							-81.31048996699991,
							28.53313835600005
						],
						[
							-81.31051099799993,
							28.534944033000045
						],
						[
							-81.31050498999991,
							28.535462803000087
						],
						[
							-81.3105250189999,
							28.536330088000057
						],
						[
							-81.31052602099993,
							28.537176343000056
						],
						[
							-81.31053303099992,
							28.537662064000074
						],
						[
							-81.31053903899993,
							28.53847026200009
						],
						[
							-81.31054104299994,
							28.53890590800006
						],
						[
							-81.31054204499992,
							28.53901707400007
						],
						[
							-81.31054204499992,
							28.539040107000062
						],
						[
							-81.31054499999993,
							28.539118000000087
						],
						[
							-81.30948999999993,
							28.539079000000072
						],
						[
							-81.30608999999993,
							28.53912900000006
						],
						[
							-81.30077199999994,
							28.539220000000057
						],
						[
							-81.29368999999991,
							28.539218000000062
						],
						[
							-81.2926609999999,
							28.539217000000065
						],
						[
							-81.2926609999999,
							28.539079000000072
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Engelwood Park",
				"RegionID": "273645"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.11009336199993,
					26.107999739000036,
					-80.10621194999993,
					26.110944232000065
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.10630601999992,
							26.109273597000083
						],
						[
							-80.10723651799992,
							26.107999739000036
						],
						[
							-80.1094419129999,
							26.108533247000082
						],
						[
							-80.10962363899995,
							26.108577208000042
						],
						[
							-80.10954234699994,
							26.109003516000087
						],
						[
							-80.10969284299995,
							26.109404839000035
						],
						[
							-80.10986842199992,
							26.10988141000007
						],
						[
							-80.11009336199993,
							26.11022954500004
						],
						[
							-80.11002496499992,
							26.110661359000062
						],
						[
							-80.10998308599994,
							26.110820586000045
						],
						[
							-80.10992542899993,
							26.110944232000065
						],
						[
							-80.10941693299992,
							26.110909801000048
						],
						[
							-80.10871461799991,
							26.110759305000045
						],
						[
							-80.10806699999996,
							26.110651000000075
						],
						[
							-80.10702816899993,
							26.110341214000073
						],
						[
							-80.10621194999993,
							26.110255174000088
						],
						[
							-80.10630601999992,
							26.109273597000083
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Harbor Drive",
				"RegionID": "273929"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.12274547499993,
					26.11987029100004,
					-80.1198702129999,
					26.130134000000055
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.12100800099995,
							26.129431562000036
						],
						[
							-80.12080010699992,
							26.129097124000054
						],
						[
							-80.12001740099993,
							26.129103099000076
						],
						[
							-80.12001099999992,
							26.12871000000007
						],
						[
							-80.1198702129999,
							26.120064578000044
						],
						[
							-80.12049914399995,
							26.12004560400004
						],
						[
							-80.12061331399991,
							26.120036592000076
						],
						[
							-80.12106298099991,
							26.12003859400005
						],
						[
							-80.12155871399996,
							26.11999052200008
						],
						[
							-80.12173497799996,
							26.11996147900004
						],
						[
							-80.12180207699993,
							26.119948461000035
						],
						[
							-80.12225673799992,
							26.11987029100004
						],
						[
							-80.12274145999993,
							26.12308412200008
						],
						[
							-80.12274547499993,
							26.126905778000037
						],
						[
							-80.12262839099992,
							26.127787096000077
						],
						[
							-80.12248509099993,
							26.12810155200009
						],
						[
							-80.12199850599991,
							26.12957484300006
						],
						[
							-80.12177908799993,
							26.129723080000076
						],
						[
							-80.1216587749999,
							26.12973381100005
						],
						[
							-80.12134047399991,
							26.130127720000075
						],
						[
							-80.12121499999995,
							26.130134000000055
						],
						[
							-80.12109994699995,
							26.130126777000044
						],
						[
							-80.12112550599994,
							26.12992869800007
						],
						[
							-80.12112550599994,
							26.129756960000066
						],
						[
							-80.1211074279999,
							26.129630416000055
						],
						[
							-80.12100800099995,
							26.129431562000036
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Hendricks and Venice Isles",
				"RegionID": "273961"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.41421456472469,
					27.96536176973031,
					-82.40200187948541,
					27.982735329547943
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.40200901650509,
							27.982106591034245
						],
						[
							-82.40200914600747,
							27.974520246741484
						],
						[
							-82.40200909114876,
							27.97270000006845
						],
						[
							-82.40200909114876,
							27.97188105224751
						],
						[
							-82.4021181807096,
							27.970800000618496
						],
						[
							-82.40203636488793,
							27.969536362335774
						],
						[
							-82.40211823466893,
							27.96890000026918
						],
						[
							-82.40200187948541,
							27.968187171548415
						],
						[
							-82.40339997360606,
							27.967127227906673
						],
						[
							-82.40751815803588,
							27.96549986872175
						],
						[
							-82.41401241961559,
							27.96536176973031
						],
						[
							-82.41421456472469,
							27.96626562793992
						],
						[
							-82.41420717139829,
							27.975675415096234
						],
						[
							-82.41420736385322,
							27.975778222892643
						],
						[
							-82.41420526483556,
							27.978168146903872
						],
						[
							-82.40922659649769,
							27.97816795984479
						],
						[
							-82.4022601009204,
							27.982735329547943
						],
						[
							-82.40226379983189,
							27.982227174829816
						],
						[
							-82.40200901650509,
							27.982106591034245
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Highland Pines",
				"RegionID": "274004"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.11232799999993,
					26.721800000000087,
					-80.0998899999999,
					26.732450000000085
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.10551524499994,
							26.732341287000054
						],
						[
							-80.1051249599999,
							26.732268742000088
						],
						[
							-80.10472492399994,
							26.732164979000064
						],
						[
							-80.1043968219999,
							26.732047842000043
						],
						[
							-80.10420999999991,
							26.73197000000005
						],
						[
							-80.1040413959999,
							26.731885698000042
						],
						[
							-80.10390766899991,
							26.73181868900008
						],
						[
							-80.1035990929999,
							26.73164511500005
						],
						[
							-80.10340441499994,
							26.731519621000075
						],
						[
							-80.10312453599994,
							26.73134544900006
						],
						[
							-80.10298704899992,
							26.731277049000084
						],
						[
							-80.10286206099994,
							26.731152061000046
						],
						[
							-80.10272818199991,
							26.731055455000046
						],
						[
							-80.10254329399993,
							26.730907131000038
						],
						[
							-80.10239400699993,
							26.73078643100007
						],
						[
							-80.10224999999991,
							26.73067000000009
						],
						[
							-80.1021520079999,
							26.730589301000066
						],
						[
							-80.10206337799991,
							26.73051337800007
						],
						[
							-80.10196436299992,
							26.730431916000043
						],
						[
							-80.10180010099992,
							26.73032161200007
						],
						[
							-80.1016319229999,
							26.730198713000053
						],
						[
							-80.10139478099991,
							26.72999464700007
						],
						[
							-80.10121985299992,
							26.729815234000057
						],
						[
							-80.10100999999992,
							26.72960000000006
						],
						[
							-80.10089972899993,
							26.72948972900008
						],
						[
							-80.10079558099994,
							26.729385363000063
						],
						[
							-80.10055791299993,
							26.72914409300006
						],
						[
							-80.10029941499994,
							26.72888167900004
						],
						[
							-80.10002999999995,
							26.728600000000085
						],
						[
							-80.0998899999999,
							26.728430000000063
						],
						[
							-80.10000963599992,
							26.72832194200004
						],
						[
							-80.10028268199994,
							26.728074508000077
						],
						[
							-80.10044358199991,
							26.72792472100008
						],
						[
							-80.10052425499993,
							26.72783396400007
						],
						[
							-80.10061942699993,
							26.727726894000057
						],
						[
							-80.10075436199992,
							26.727566170000046
						],
						[
							-80.10092999999995,
							26.727350000000058
						],
						[
							-80.1010059219999,
							26.72724487700009
						],
						[
							-80.10110881599991,
							26.727085386000056
						],
						[
							-80.10125905299992,
							26.726794374000065
						],
						[
							-80.10140253299994,
							26.726460226000086
						],
						[
							-80.1015333339999,
							26.726161999000055
						],
						[
							-80.10159729599991,
							26.72598047000008
						],
						[
							-80.10165783899993,
							26.725808646000075
						],
						[
							-80.10171543099995,
							26.72557827500009
						],
						[
							-80.10177920299992,
							26.725270183000077
						],
						[
							-80.1018297899999,
							26.724829051000086
						],
						[
							-80.1018499999999,
							26.724600000000066
						],
						[
							-80.10186818099993,
							26.724351527000067
						],
						[
							-80.10188842299993,
							26.72399837800009
						],
						[
							-80.1019094429999,
							26.723520179000047
						],
						[
							-80.1019275999999,
							26.723143192000066
						],
						[
							-80.1019399999999,
							26.722920000000045
						],
						[
							-80.10219646599997,
							26.72293141000006
						],
						[
							-80.1024569999999,
							26.722943000000043
						],
						[
							-80.10721499999994,
							26.723081000000036
						],
						[
							-80.10803699999991,
							26.723104000000035
						],
						[
							-80.10904099999993,
							26.723141000000055
						],
						[
							-80.1093689999999,
							26.723146000000042
						],
						[
							-80.10939799999994,
							26.722270000000037
						],
						[
							-80.11001399999992,
							26.722313000000046
						],
						[
							-80.11003699999992,
							26.72196400000007
						],
						[
							-80.11002899999994,
							26.721800000000087
						],
						[
							-80.11034999999993,
							26.721809000000064
						],
						[
							-80.11029799999994,
							26.722026000000085
						],
						[
							-80.11029799999994,
							26.722594000000075
						],
						[
							-80.1105159999999,
							26.722594000000075
						],
						[
							-80.11039399999993,
							26.725228000000072
						],
						[
							-80.11064603099993,
							26.72523790400004
						],
						[
							-80.11232799999993,
							26.72530400000005
						],
						[
							-80.11232799999993,
							26.726031000000035
						],
						[
							-80.11228299999993,
							26.72742500000004
						],
						[
							-80.11219299999993,
							26.729828000000055
						],
						[
							-80.11045665799992,
							26.72977703300006
						],
						[
							-80.11018299999995,
							26.72976900000009
						],
						[
							-80.11010543999993,
							26.731427779000057
						],
						[
							-80.1100899999999,
							26.73175800000007
						],
						[
							-80.1100625759999,
							26.732355126000073
						],
						[
							-80.1098915849999,
							26.732347479000055
						],
						[
							-80.10964174399993,
							26.73234166800006
						],
						[
							-80.1091631459999,
							26.732327286000043
						],
						[
							-80.10880805699992,
							26.732316189000073
						],
						[
							-80.10828768099992,
							26.732301735000082
						],
						[
							-80.10795267499992,
							26.732319482000037
						],
						[
							-80.10772223299995,
							26.73235193900007
						],
						[
							-80.10753552099993,
							26.732378237000034
						],
						[
							-80.10728745799992,
							26.732412373000045
						],
						[
							-80.10691261299992,
							26.732450000000085
						],
						[
							-80.10660014199993,
							26.732450000000085
						],
						[
							-80.1062599999999,
							26.73243000000008
						],
						[
							-80.10614128599991,
							26.732420868000077
						],
						[
							-80.10589277999992,
							26.732401752000044
						],
						[
							-80.10551524499994,
							26.732341287000054
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "West Palm Beach",
				"Name": "Palm Club Village",
				"RegionID": "269129"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.6492340449999,
					30.34504200700007,
					-81.63678177299994,
					30.356406008000082
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.63759990599993,
							30.356200008000087
						],
						[
							-81.63755890499993,
							30.356178008000082
						],
						[
							-81.6375019059999,
							30.356142008000063
						],
						[
							-81.63744185199994,
							30.35610108100008
						],
						[
							-81.63734290499991,
							30.35601900800009
						],
						[
							-81.63731490499993,
							30.35599000900004
						],
						[
							-81.63723690599994,
							30.355916008000065
						],
						[
							-81.63719190599994,
							30.355858009000087
						],
						[
							-81.63712290599995,
							30.35576100800006
						],
						[
							-81.63699290599993,
							30.355516008000055
						],
						[
							-81.63696290699994,
							30.35543800800008
						],
						[
							-81.63694790499994,
							30.355375009000056
						],
						[
							-81.63692990499993,
							30.35531200900005
						],
						[
							-81.63690890599992,
							30.35521300900007
						],
						[
							-81.63690390599993,
							30.35513100800006
						],
						[
							-81.63689390499991,
							30.355024009000093
						],
						[
							-81.63688990599991,
							30.354771008000053
						],
						[
							-81.6368879609999,
							30.35463801000009
						],
						[
							-81.63688690599992,
							30.354322008000054
						],
						[
							-81.63688290599993,
							30.354092008000066
						],
						[
							-81.63687990599993,
							30.35367200900004
						],
						[
							-81.63687690599994,
							30.353298009000074
						],
						[
							-81.63687090599991,
							30.353037008000054
						],
						[
							-81.63686890599992,
							30.35296400800007
						],
						[
							-81.63686590599991,
							30.35287900800006
						],
						[
							-81.63685990599993,
							30.352671008000073
						],
						[
							-81.63686590599991,
							30.35228300800009
						],
						[
							-81.63686190599992,
							30.35213500900005
						],
						[
							-81.63686090599992,
							30.351867008000053
						],
						[
							-81.6368489059999,
							30.35138900900006
						],
						[
							-81.63684990599995,
							30.350968008000056
						],
						[
							-81.63684090599992,
							30.350655008000047
						],
						[
							-81.63684390599991,
							30.35034300900009
						],
						[
							-81.6368309049999,
							30.349832009000064
						],
						[
							-81.6368249059999,
							30.34970600800006
						],
						[
							-81.63682190599992,
							30.349512008000094
						],
						[
							-81.63681790599992,
							30.349215008000044
						],
						[
							-81.63681790599992,
							30.34900900800005
						],
						[
							-81.63681790599992,
							30.348890009000062
						],
						[
							-81.63680690599995,
							30.348665009000058
						],
						[
							-81.6368029059999,
							30.348587008000035
						],
						[
							-81.6368029059999,
							30.348234008000077
						],
						[
							-81.63678890499995,
							30.347960009000072
						],
						[
							-81.63678177299994,
							30.34750988000007
						],
						[
							-81.63681503799995,
							30.34750913600004
						],
						[
							-81.63681390599993,
							30.34741800800009
						],
						[
							-81.63680790599994,
							30.346929008000078
						],
						[
							-81.6368029059999,
							30.34629200800003
						],
						[
							-81.63679190699992,
							30.34530595500007
						],
						[
							-81.63682790599995,
							30.345306008000076
						],
						[
							-81.63703690599993,
							30.345303008000084
						],
						[
							-81.63884390499993,
							30.34528400800008
						],
						[
							-81.63942690499994,
							30.345274008000047
						],
						[
							-81.64100490599992,
							30.34524100900006
						],
						[
							-81.64113390599995,
							30.345236008000086
						],
						[
							-81.6422959059999,
							30.345085009000062
						],
						[
							-81.6429749049999,
							30.345078008000087
						],
						[
							-81.64311990599992,
							30.345068009000045
						],
						[
							-81.64327590599993,
							30.34506000800008
						],
						[
							-81.6438939059999,
							30.34505600800009
						],
						[
							-81.64431290599993,
							30.34505600800009
						],
						[
							-81.6450479049999,
							30.34504200700007
						],
						[
							-81.64536690599994,
							30.345048009000042
						],
						[
							-81.64559096199993,
							30.34505200500007
						],
						[
							-81.64572690299991,
							30.348536007000064
						],
						[
							-81.64557690599992,
							30.34915101100006
						],
						[
							-81.64557290499994,
							30.349315008000076
						],
						[
							-81.64549006699991,
							30.35242007100004
						],
						[
							-81.64537473199994,
							30.352545944000042
						],
						[
							-81.6453969069999,
							30.353238868000062
						],
						[
							-81.64540885399992,
							30.353023999000072
						],
						[
							-81.64544190599992,
							30.352907008000045
						],
						[
							-81.64547590599994,
							30.352810009000052
						],
						[
							-81.64556690599994,
							30.352635009000043
						],
						[
							-81.64567990599994,
							30.352459009000082
						],
						[
							-81.64583790599994,
							30.352254008000045
						],
						[
							-81.6460299069999,
							30.352040008000078
						],
						[
							-81.64614384999993,
							30.35194193600006
						],
						[
							-81.64626790599993,
							30.351854008000092
						],
						[
							-81.64653383799993,
							30.351617892000036
						],
						[
							-81.64710490599992,
							30.35139700900004
						],
						[
							-81.6474988949999,
							30.35130294400005
						],
						[
							-81.64903603499994,
							30.351212871000087
						],
						[
							-81.64905290599997,
							30.35176700900007
						],
						[
							-81.64908090499995,
							30.352161008000053
						],
						[
							-81.64910890599992,
							30.35287900800006
						],
						[
							-81.64913190599992,
							30.353592009000067
						],
						[
							-81.64916190499991,
							30.354305008000036
						],
						[
							-81.64918881699992,
							30.355025023000053
						],
						[
							-81.64921590699993,
							30.35572300800004
						],
						[
							-81.64923090699995,
							30.356042008000088
						],
						[
							-81.6492340449999,
							30.356077137000057
						],
						[
							-81.64863090699993,
							30.35610401000008
						],
						[
							-81.64765690699994,
							30.35612401000009
						],
						[
							-81.64735290899995,
							30.35613401100005
						],
						[
							-81.64675590699994,
							30.35615401100006
						],
						[
							-81.6464529079999,
							30.35615801100005
						],
						[
							-81.64630590899992,
							30.356167010000036
						],
						[
							-81.64598490799995,
							30.356172011000066
						],
						[
							-81.64556380199991,
							30.35617785100004
						],
						[
							-81.64554801899993,
							30.356214168000065
						],
						[
							-81.64525778599995,
							30.356232155000043
						],
						[
							-81.64525303199991,
							30.356192865000082
						],
						[
							-81.64464690699992,
							30.35621501100007
						],
						[
							-81.64368590799995,
							30.356237010000083
						],
						[
							-81.64322394899995,
							30.356249954000077
						],
						[
							-81.6424089059999,
							30.35626900800008
						],
						[
							-81.6418259049999,
							30.35628200800005
						],
						[
							-81.64175475999991,
							30.356283930000078
						],
						[
							-81.64177405099991,
							30.356311087000055
						],
						[
							-81.64130490499991,
							30.356321008000062
						],
						[
							-81.6411689059999,
							30.356324009000048
						],
						[
							-81.64049190599991,
							30.356347009000043
						],
						[
							-81.63901890499994,
							30.356396008000047
						],
						[
							-81.6387859059999,
							30.356406008000082
						],
						[
							-81.63848390499993,
							30.356390008000062
						],
						[
							-81.63832190599993,
							30.356380008000087
						],
						[
							-81.6381129049999,
							30.35636400900006
						],
						[
							-81.63799190599991,
							30.356344008000065
						],
						[
							-81.63782890599992,
							30.356302008000057
						],
						[
							-81.63777190499991,
							30.356279008000058
						],
						[
							-81.63769690599992,
							30.356248009000073
						],
						[
							-81.63759990599993,
							30.356200008000087
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Phoenix",
				"RegionID": "269142"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.77315502499994,
					30.36987682800009,
					-81.73250782199995,
					30.39430518600005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.74381980499993,
							30.393650096000048
						],
						[
							-81.74346871699993,
							30.393028024000046
						],
						[
							-81.74361209999995,
							30.39269199800009
						],
						[
							-81.7380030029999,
							30.382356001000066
						],
						[
							-81.73601090799991,
							30.379127010000047
						],
						[
							-81.73467890699993,
							30.37696801100009
						],
						[
							-81.73250782199995,
							30.37347088900009
						],
						[
							-81.73389689099992,
							30.372657819000043
						],
						[
							-81.73555688499994,
							30.37330514100006
						],
						[
							-81.74034693099992,
							30.373082090000086
						],
						[
							-81.7457209499999,
							30.36987682800009
						],
						[
							-81.74603890799995,
							30.370355011000072
						],
						[
							-81.7464219069999,
							30.370953010000047
						],
						[
							-81.74660890799993,
							30.371217011000052
						],
						[
							-81.74683690799992,
							30.371554011000057
						],
						[
							-81.74698890699995,
							30.37176501100004
						],
						[
							-81.74706990699991,
							30.37187801100003
						],
						[
							-81.74750290799994,
							30.37253401000004
						],
						[
							-81.7475919069999,
							30.37266801000004
						],
						[
							-81.74784090799994,
							30.373045010000055
						],
						[
							-81.74804690799994,
							30.37331401100005
						],
						[
							-81.7481769069999,
							30.37351201000007
						],
						[
							-81.74832190899991,
							30.373831011000053
						],
						[
							-81.74847379999994,
							30.374216166000053
						],
						[
							-81.7489399079999,
							30.37421001000007
						],
						[
							-81.75154090799992,
							30.374243010000043
						],
						[
							-81.7521129079999,
							30.37423901000005
						],
						[
							-81.7522739069999,
							30.374216010000055
						],
						[
							-81.7524109069999,
							30.374174009000058
						],
						[
							-81.75261690799994,
							30.374081011000044
						],
						[
							-81.75593590699992,
							30.372332010000036
						],
						[
							-81.75635490799995,
							30.372129011000084
						],
						[
							-81.75651590799993,
							30.372080011000037
						],
						[
							-81.75665290799992,
							30.372051011000057
						],
						[
							-81.7568359089999,
							30.37204401000008
						],
						[
							-81.75730090799993,
							30.372050010000066
						],
						[
							-81.75950290799994,
							30.372067010000084
						],
						[
							-81.76028390699992,
							30.37207701000005
						],
						[
							-81.76090990699993,
							30.372087065000077
						],
						[
							-81.7612019099999,
							30.372091012000052
						],
						[
							-81.7621009099999,
							30.372103012000082
						],
						[
							-81.76288290999993,
							30.37210401200008
						],
						[
							-81.76323290999994,
							30.37209901300008
						],
						[
							-81.76370290999995,
							30.37211201200006
						],
						[
							-81.76467590999994,
							30.37211201200006
						],
						[
							-81.7648009099999,
							30.37211201200006
						],
						[
							-81.7660449089999,
							30.372080013000073
						],
						[
							-81.76847790999994,
							30.371990012000087
						],
						[
							-81.7687249089999,
							30.371987012000094
						],
						[
							-81.76950790899993,
							30.371964013000085
						],
						[
							-81.77068790999994,
							30.371920013000082
						],
						[
							-81.77289304099992,
							30.37183787700008
						],
						[
							-81.7729079099999,
							30.37318101200009
						],
						[
							-81.77289990999992,
							30.373488013000042
						],
						[
							-81.77291690899995,
							30.373795013000066
						],
						[
							-81.7729319099999,
							30.375614013000074
						],
						[
							-81.77292390899993,
							30.376059013000088
						],
						[
							-81.77293190899991,
							30.376507013000037
						],
						[
							-81.77294690999992,
							30.37674701300006
						],
						[
							-81.77298590999993,
							30.37959701200009
						],
						[
							-81.77299390999991,
							30.380797012000077
						],
						[
							-81.77300990999993,
							30.381406012000074
						],
						[
							-81.77301790999991,
							30.382647012000064
						],
						[
							-81.77305590999994,
							30.385048012000084
						],
						[
							-81.77304990999994,
							30.385465013000047
						],
						[
							-81.77309390999994,
							30.388304012000052
						],
						[
							-81.77309390999994,
							30.388903012000075
						],
						[
							-81.7731549099999,
							30.393152012000087
						],
						[
							-81.7731549099999,
							30.393826012000094
						],
						[
							-81.77315502499994,
							30.393924149000043
						],
						[
							-81.77266390999995,
							30.393837013000052
						],
						[
							-81.76793690999995,
							30.39392101200008
						],
						[
							-81.7659989089999,
							30.393953012000054
						],
						[
							-81.76551090899994,
							30.39395501200005
						],
						[
							-81.7650299099999,
							30.393967013000065
						],
						[
							-81.76464790999995,
							30.39396301200009
						],
						[
							-81.76454190899996,
							30.39395501200005
						],
						[
							-81.76438891099991,
							30.39394801300006
						],
						[
							-81.76361790899995,
							30.393953012000054
						],
						[
							-81.75785790999993,
							30.394037015000038
						],
						[
							-81.75778980799993,
							30.394059868000056
						],
						[
							-81.7577288729999,
							30.394135164000094
						],
						[
							-81.7575570379999,
							30.393369008000036
						],
						[
							-81.75730387599992,
							30.393205822000084
						],
						[
							-81.75667691099994,
							30.39397300900004
						],
						[
							-81.75663800799992,
							30.394054176000058
						],
						[
							-81.75468490799994,
							30.394073010000056
						],
						[
							-81.75366190699992,
							30.394083010000088
						],
						[
							-81.75289190799992,
							30.39409001000007
						],
						[
							-81.75191490799995,
							30.394100011000035
						],
						[
							-81.75170790699991,
							30.394105010000093
						],
						[
							-81.75145190699995,
							30.394114010000067
						],
						[
							-81.75126590799994,
							30.394119011000043
						],
						[
							-81.7507859079999,
							30.39413501000007
						],
						[
							-81.75007590799994,
							30.39415701100006
						],
						[
							-81.74845090699996,
							30.394203010000066
						],
						[
							-81.7479709079999,
							30.394209010000054
						],
						[
							-81.74459084499995,
							30.39430518600005
						],
						[
							-81.74381980499993,
							30.393650096000048
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Picketville",
				"RegionID": "269143"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.63508992299995,
					30.181648003000078,
					-81.61923986799997,
					30.208216655000058
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.61923986799997,
							30.200300969000068
						],
						[
							-81.61969290799999,
							30.199722010000077
						],
						[
							-81.61994090799999,
							30.199394011000038
						],
						[
							-81.62028190799998,
							30.198972010000038
						],
						[
							-81.62147290799999,
							30.197395010000037
						],
						[
							-81.62270990499997,
							30.19579501100003
						],
						[
							-81.62272490999999,
							30.19576501000006
						],
						[
							-81.62365390799994,
							30.19455301000005
						],
						[
							-81.62389390799997,
							30.194259010000053
						],
						[
							-81.62467690799997,
							30.19326201000007
						],
						[
							-81.62501490799997,
							30.19280001000004
						],
						[
							-81.62517690799996,
							30.192607010000074
						],
						[
							-81.62579290699995,
							30.191807011000037
						],
						[
							-81.62635690799993,
							30.19112001100007
						],
						[
							-81.62657290699997,
							30.190844010000035
						],
						[
							-81.62679190699998,
							30.190507010000033
						],
						[
							-81.62701590799998,
							30.190126011000075
						],
						[
							-81.62708490699998,
							30.19000201100005
						],
						[
							-81.62722890699996,
							30.189694010000043
						],
						[
							-81.627468907,
							30.18893101100008
						],
						[
							-81.62754790799995,
							30.188626011000053
						],
						[
							-81.62781790699995,
							30.18770001000007
						],
						[
							-81.62789990699997,
							30.187365010000065
						],
						[
							-81.62795479099998,
							30.187168944000064
						],
						[
							-81.62802798499996,
							30.187075047000064
						],
						[
							-81.62820190799994,
							30.186347010000077
						],
						[
							-81.62823390699998,
							30.18615901000004
						],
						[
							-81.62828190799996,
							30.185938010000033
						],
						[
							-81.628295908,
							30.18588101000006
						],
						[
							-81.62832490799997,
							30.185788010000067
						],
						[
							-81.62837590799995,
							30.185609010000068
						],
						[
							-81.62847990799997,
							30.18518801000005
						],
						[
							-81.62858790699994,
							30.18468301100006
						],
						[
							-81.62863190799999,
							30.184346010000073
						],
						[
							-81.62868190699999,
							30.183653010000054
						],
						[
							-81.62867390899999,
							30.18320201000006
						],
						[
							-81.62868190499995,
							30.18316001200003
						],
						[
							-81.62862090699997,
							30.182380011000078
						],
						[
							-81.62859290799997,
							30.182076011000053
						],
						[
							-81.62854390399997,
							30.181648003000078
						],
						[
							-81.62887290499998,
							30.181772009000042
						],
						[
							-81.62955790499996,
							30.18203000900007
						],
						[
							-81.63237490599994,
							30.183081009000034
						],
						[
							-81.63312990499998,
							30.183392009000045
						],
						[
							-81.63508992299995,
							30.184142918000077
						],
						[
							-81.63249304199996,
							30.187351180000064
						],
						[
							-81.631014399,
							30.190472760000038
						],
						[
							-81.63019284699999,
							30.19326574600007
						],
						[
							-81.63052139199993,
							30.195073026000042
						],
						[
							-81.63200015699994,
							30.19720879600004
						],
						[
							-81.63420115799994,
							30.199409797000047
						],
						[
							-81.63119447599996,
							30.201593780000056
						],
						[
							-81.63005947299996,
							30.202407556000026
						],
						[
							-81.62939560399997,
							30.20285727400005
						],
						[
							-81.62917431399995,
							30.202885828000035
						],
						[
							-81.62908865299994,
							30.202885828000035
						],
						[
							-81.62813924799997,
							30.203456898000073
						],
						[
							-81.62763242299997,
							30.203806679000024
						],
						[
							-81.62898806499999,
							30.20549385400005
						],
						[
							-81.62856914499997,
							30.205775317000075
						],
						[
							-81.62493554199995,
							30.208216655000058
						],
						[
							-81.62296401099997,
							30.20723070800005
						],
						[
							-81.62197810499998,
							30.20673793800006
						],
						[
							-81.62164966299997,
							30.20542347600008
						],
						[
							-81.62164966099994,
							30.204273423000075
						],
						[
							-81.62164983199995,
							30.202794733000076
						],
						[
							-81.62082829599996,
							30.20148034500005
						],
						[
							-81.61923986799997,
							30.200300969000068
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Pickwick Park",
				"RegionID": "269144"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.37730104299993,
					28.504176000000086,
					-81.35563399999995,
					28.513161961000037
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-81.37231699999995,
								28.505084000000068
							],
							[
								-81.3724259999999,
								28.50507500000009
							],
							[
								-81.37337799999995,
								28.50507900000008
							],
							[
								-81.37359099999993,
								28.50508000000008
							],
							[
								-81.37413399999991,
								28.505076000000088
							],
							[
								-81.37415399999993,
								28.50417800000008
							],
							[
								-81.37432599999994,
								28.504176000000086
							],
							[
								-81.37439099999995,
								28.504176000000086
							],
							[
								-81.37444099999993,
								28.504176000000086
							],
							[
								-81.3754909999999,
								28.504184000000066
							],
							[
								-81.37618174399995,
								28.504181413000083
							],
							[
								-81.37627208599991,
								28.504181075000076
							],
							[
								-81.37626999999992,
								28.504399902000046
							],
							[
								-81.37626126899994,
								28.504874331000057
							],
							[
								-81.37625063299993,
								28.50525722200007
							],
							[
								-81.37619899999993,
								28.505482000000086
							],
							[
								-81.37519299999991,
								28.505487000000073
							],
							[
								-81.37504699999995,
								28.505487000000073
							],
							[
								-81.37504299999996,
								28.505915000000073
							],
							[
								-81.37339199999991,
								28.50590800000009
							],
							[
								-81.37338799999992,
								28.505501000000038
							],
							[
								-81.37232099999994,
								28.505491000000063
							],
							[
								-81.37231699999995,
								28.505084000000068
							]
						]
					],
					[
						[
							[
								-81.37424299999992,
								28.506920000000036
							],
							[
								-81.37421199999994,
								28.50661400000007
							],
							[
								-81.37520699999993,
								28.50661400000007
							],
							[
								-81.3751959999999,
								28.506433000000072
							],
							[
								-81.3761743039999,
								28.506450487000052
							],
							[
								-81.37620299999992,
								28.506451000000084
							],
							[
								-81.37620399999992,
								28.506842000000063
							],
							[
								-81.3758029999999,
								28.50683500000008
							],
							[
								-81.3758029999999,
								28.50698000000006
							],
							[
								-81.37421799999993,
								28.506979000000058
							],
							[
								-81.37424299999992,
								28.506920000000036
							]
						]
					],
					[
						[
							[
								-81.36787299999993,
								28.513021000000037
							],
							[
								-81.36771399999992,
								28.513017000000048
							],
							[
								-81.36746699999992,
								28.513018000000045
							],
							[
								-81.3672939999999,
								28.513021000000037
							],
							[
								-81.36712699999993,
								28.513015000000053
							],
							[
								-81.36712499999993,
								28.512890000000084
							],
							[
								-81.36712299999994,
								28.512731000000088
							],
							[
								-81.36712499999993,
								28.511267000000093
							],
							[
								-81.36712399999995,
								28.511120000000062
							],
							[
								-81.36712399999995,
								28.51105700000005
							],
							[
								-81.36704299999991,
								28.51105800000005
							],
							[
								-81.3666445909999,
								28.511056953000036
							],
							[
								-81.36628199999991,
								28.511056000000053
							],
							[
								-81.36628699999994,
								28.510563000000047
							],
							[
								-81.36581199999996,
								28.51056200000005
							],
							[
								-81.3658099999999,
								28.510174000000063
							],
							[
								-81.36581099999995,
								28.509536000000082
							],
							[
								-81.36599099999995,
								28.50968000000006
							],
							[
								-81.36605904799991,
								28.50969706800004
							],
							[
								-81.36629399999993,
								28.50975600000004
							],
							[
								-81.36629399999993,
								28.509216000000038
							],
							[
								-81.36582099999993,
								28.509214000000043
							],
							[
								-81.36582099999993,
								28.50870400000008
							],
							[
								-81.36575299999993,
								28.50874900000008
							],
							[
								-81.36567999999994,
								28.508805000000052
							],
							[
								-81.36557599999993,
								28.508898000000045
							],
							[
								-81.3654919999999,
								28.508979000000068
							],
							[
								-81.36533999999995,
								28.509100000000046
							],
							[
								-81.36525799999993,
								28.509175000000084
							],
							[
								-81.36525599999993,
								28.51035200000007
							],
							[
								-81.36526999999995,
								28.512703000000045
							],
							[
								-81.36520699999994,
								28.51270500000004
							],
							[
								-81.36516391299995,
								28.51270542700007
							],
							[
								-81.36399799999992,
								28.512717000000066
							],
							[
								-81.36295599999994,
								28.512703000000045
							],
							[
								-81.36291188199993,
								28.51270326200006
							],
							[
								-81.3627577229999,
								28.512704174000078
							],
							[
								-81.36194299999994,
								28.512709000000086
							],
							[
								-81.36096299999991,
								28.51272000000006
							],
							[
								-81.36004799999995,
								28.512736000000075
							],
							[
								-81.36004699999997,
								28.51187200000004
							],
							[
								-81.36034699999993,
								28.511859000000072
							],
							[
								-81.36034699999993,
								28.51241200000004
							],
							[
								-81.3609469999999,
								28.512407000000053
							],
							[
								-81.3619109999999,
								28.512406000000055
							],
							[
								-81.36237696199993,
								28.512406000000055
							],
							[
								-81.3625429999999,
								28.512406000000055
							],
							[
								-81.36254899999994,
								28.512549000000035
							],
							[
								-81.36290098899991,
								28.512549000000035
							],
							[
								-81.3629489999999,
								28.512549000000035
							],
							[
								-81.3630829999999,
								28.51254300000005
							],
							[
								-81.36302499999994,
								28.51127400000007
							],
							[
								-81.36302199999994,
								28.51030800000007
							],
							[
								-81.36288799999994,
								28.510307000000072
							],
							[
								-81.36217999999991,
								28.51030800000007
							],
							[
								-81.36216899999994,
								28.50947700000006
							],
							[
								-81.36193099999991,
								28.50947800000006
							],
							[
								-81.36194099999994,
								28.50930500000004
							],
							[
								-81.36190699999992,
								28.509216000000038
							],
							[
								-81.36168099999992,
								28.50892900000008
							],
							[
								-81.36165699999992,
								28.50810500000006
							],
							[
								-81.3617109999999,
								28.50808600000005
							],
							[
								-81.3622269999999,
								28.50792400000006
							],
							[
								-81.36244499999992,
								28.50785600000006
							],
							[
								-81.36261998999994,
								28.507792333000058
							],
							[
								-81.36291499999993,
								28.50768500000004
							],
							[
								-81.36407837799993,
								28.507250230000068
							],
							[
								-81.36417799999992,
								28.507213000000036
							],
							[
								-81.36472499999991,
								28.506984000000045
							],
							[
								-81.36386699999991,
								28.50699700000007
							],
							[
								-81.36384871099995,
								28.506996908000076
							],
							[
								-81.3636689999999,
								28.506996000000072
							],
							[
								-81.36366499999991,
								28.506872000000044
							],
							[
								-81.36366430699991,
								28.506832863000056
							],
							[
								-81.36366299999992,
								28.506759000000045
							],
							[
								-81.3636767239999,
								28.506132085000047
							],
							[
								-81.36434296499995,
								28.506218776000082
							],
							[
								-81.36436891699992,
								28.506243083000072
							],
							[
								-81.36437487099994,
								28.506249093000065
							],
							[
								-81.36453286999995,
								28.506410093000056
							],
							[
								-81.36453879999993,
								28.506416193000064
							],
							[
								-81.36456479999993,
								28.506443193000056
							],
							[
								-81.36459080199995,
								28.506471374000057
							],
							[
								-81.36475080199995,
								28.506652374000055
							],
							[
								-81.36475314599994,
								28.50665503600004
							],
							[
								-81.36475460299994,
								28.506656702000043
							],
							[
								-81.36488056499992,
								28.50669855400008
							],
							[
								-81.36488607699994,
								28.50670040500006
							],
							[
								-81.36494115499994,
								28.506721135000078
							],
							[
								-81.36499475999995,
								28.50674542300004
							],
							[
								-81.36504666099995,
								28.506773164000037
							],
							[
								-81.36508200499992,
								28.506795143000094
							],
							[
								-81.36509663599992,
								28.506804241000054
							],
							[
								-81.3651089029999,
								28.506812585000034
							],
							[
								-81.3651739039999,
								28.506857585000034
							],
							[
								-81.36520947299994,
								28.506883520000088
							],
							[
								-81.36525496399992,
								28.506920854000043
							],
							[
								-81.3652979169999,
								28.506961084000068
							],
							[
								-81.36533814599994,
								28.50700403600007
							],
							[
								-81.36534910499995,
								28.507016771000053
							],
							[
								-81.36538710499991,
								28.507061770000064
							],
							[
								-81.36541347999992,
								28.507094527000053
							],
							[
								-81.36544775899995,
								28.50714236300007
							],
							[
								-81.36547883599991,
								28.507192339000085
							],
							[
								-81.3655065769999,
								28.507244240000094
							],
							[
								-81.36553086499993,
								28.50729784400005
							],
							[
								-81.36555159499994,
								28.507352922000052
							],
							[
								-81.36556867799993,
								28.507409238000037
							],
							[
								-81.36558204199991,
								28.50746655100005
							],
							[
								-81.36559162799995,
								28.50752461500008
							],
							[
								-81.36559739599994,
								28.507583181000086
							],
							[
								-81.36559902599993,
								28.507618947000083
							],
							[
								-81.36560102699993,
								28.507696947000056
							],
							[
								-81.36559939699993,
								28.507778818000077
							],
							[
								-81.36559437699992,
								28.507831552000088
							],
							[
								-81.3655933579999,
								28.507839698000055
							],
							[
								-81.36561845599994,
								28.50801339800006
							],
							[
								-81.36562828599995,
								28.508058334000054
							],
							[
								-81.36566585499992,
								28.50816715700006
							],
							[
								-81.3656746659999,
								28.508176603000038
							],
							[
								-81.3656931459999,
								28.50819703600007
							],
							[
								-81.36573047999991,
								28.50824252800004
							],
							[
								-81.36576475899994,
								28.50829036400006
							],
							[
								-81.3657958359999,
								28.508340339000085
							],
							[
								-81.36580776699992,
								28.508361668000077
							],
							[
								-81.3658500649999,
								28.50843975800007
							],
							[
								-81.3659699509999,
								28.508513236000056
							],
							[
								-81.36599963699992,
								28.50853224100007
							],
							[
								-81.36604747299992,
								28.508566519000055
							],
							[
								-81.36608490499992,
								28.508596870000076
							],
							[
								-81.36619279899992,
								28.508689251000078
							],
							[
								-81.36626949899994,
								28.508739089000073
							],
							[
								-81.36630015599991,
								28.508751135000068
							],
							[
								-81.36635375999992,
								28.50877542300009
							],
							[
								-81.36640566099993,
								28.508803164000085
							],
							[
								-81.36645424099993,
								28.508833373000073
							],
							[
								-81.36649181799993,
								28.508834603000082
							],
							[
								-81.36651709599994,
								28.50883661800009
							],
							[
								-81.36664156799992,
								28.508848309000086
							],
							[
								-81.36673601599996,
								28.508845243000053
							],
							[
								-81.36688821199994,
								28.508839351000063
							],
							[
								-81.36698181799994,
								28.508840604000056
							],
							[
								-81.36700789699995,
								28.508842694000066
							],
							[
								-81.36712389699994,
								28.508853694000038
							],
							[
								-81.36715638499993,
								28.50885737100009
							],
							[
								-81.3672144489999,
								28.508866958000056
							],
							[
								-81.36727176199992,
								28.50888032100005
							],
							[
								-81.36732807699991,
								28.508897405000084
							],
							[
								-81.3673831559999,
								28.508918134000055
							],
							[
								-81.36740278499991,
								28.50892654000006
							],
							[
								-81.36745478499995,
								28.50894954000006
							],
							[
								-81.3674887599999,
								28.508965422000074
							],
							[
								-81.36754066099991,
								28.50899316400006
							],
							[
								-81.36759063599993,
								28.509024241000077
							],
							[
								-81.3676384719999,
								28.509058520000053
							],
							[
								-81.36765715699994,
								28.509073854000064
							],
							[
								-81.36778625399995,
								28.50906900800004
							],
							[
								-81.36778599999991,
								28.509219000000087
							],
							[
								-81.3676559999999,
								28.509228000000064
							],
							[
								-81.3676559999999,
								28.50942000000009
							],
							[
								-81.3676734359999,
								28.509973199000058
							],
							[
								-81.36802499999993,
								28.509960000000035
							],
							[
								-81.36818799999992,
								28.50994200000008
							],
							[
								-81.36843299999992,
								28.509881000000064
							],
							[
								-81.36852699999992,
								28.50987400000008
							],
							[
								-81.36867199999996,
								28.509902000000068
							],
							[
								-81.36878299999995,
								28.509912000000046
							],
							[
								-81.36885899999993,
								28.50990500000006
							],
							[
								-81.36907599999995,
								28.50994200000008
							],
							[
								-81.3691409999999,
								28.50993100000005
							],
							[
								-81.36926047399993,
								28.50986796400008
							],
							[
								-81.36885599999995,
								28.50937900000008
							],
							[
								-81.36917999999991,
								28.509368000000052
							],
							[
								-81.3695919999999,
								28.509367000000054
							],
							[
								-81.36971704799993,
								28.50936672100005
							],
							[
								-81.37048799999991,
								28.50936500000006
							],
							[
								-81.37145499999991,
								28.509370000000047
							],
							[
								-81.37170999999995,
								28.50936500000006
							],
							[
								-81.37219299999992,
								28.50937500000009
							],
							[
								-81.37218899999993,
								28.509290000000078
							],
							[
								-81.37266299999993,
								28.50928500000009
							],
							[
								-81.3729229999999,
								28.50928600000009
							],
							[
								-81.37299499999995,
								28.509280000000047
							],
							[
								-81.37298299999993,
								28.508459000000073
							],
							[
								-81.37315399999994,
								28.508461000000068
							],
							[
								-81.37336099999993,
								28.50846000000007
							],
							[
								-81.37338999999992,
								28.50937900000008
							],
							[
								-81.37354099999993,
								28.50937900000008
							],
							[
								-81.37353999999993,
								28.50944000000004
							],
							[
								-81.37590599999993,
								28.50945100000007
							],
							[
								-81.37590599999993,
								28.50938000000008
							],
							[
								-81.37590599999993,
								28.508987000000047
							],
							[
								-81.37621299999995,
								28.508995000000088
							],
							[
								-81.37622245099993,
								28.509329043000037
							],
							[
								-81.37624373199992,
								28.510658609000075
							],
							[
								-81.37677188099991,
								28.510658609000075
							],
							[
								-81.37677188099991,
								28.51149796900006
							],
							[
								-81.37725538099994,
								28.511498386000085
							],
							[
								-81.37726907199993,
								28.511917520000054
							],
							[
								-81.37727899299995,
								28.512246763000064
							],
							[
								-81.3772904999999,
								28.51261149200008
							],
							[
								-81.37730104299993,
								28.51290298500004
							],
							[
								-81.3762796549999,
								28.51290298500004
							],
							[
								-81.3762799889999,
								28.51292386700004
							],
							[
								-81.3712430519999,
								28.51297597300004
							],
							[
								-81.37033070399991,
								28.513012467000067
							],
							[
								-81.37011899999993,
								28.513024000000087
							],
							[
								-81.37002398499995,
								28.513024000000087
							],
							[
								-81.36999099999991,
								28.513024000000087
							],
							[
								-81.36909199999991,
								28.51302000000004
							],
							[
								-81.36812282199992,
								28.513048961000038
							],
							[
								-81.36787299999993,
								28.513021000000037
							]
						]
					],
					[
						[
							[
								-81.3629709999999,
								28.51294400000006
							],
							[
								-81.36399399999993,
								28.512934000000087
							],
							[
								-81.36509099999995,
								28.51294400000006
							],
							[
								-81.36515474099991,
								28.512944608000055
							],
							[
								-81.36582499999992,
								28.512951000000044
							],
							[
								-81.36671999999993,
								28.512960000000078
							],
							[
								-81.36646234799991,
								28.513048961000038
							],
							[
								-81.36261223999992,
								28.513085455000066
							],
							[
								-81.36251512299992,
								28.51308728700008
							],
							[
								-81.3625209999999,
								28.51294800000005
							],
							[
								-81.3629709999999,
								28.51294400000006
							]
						]
					],
					[
						[
							[
								-81.35569664199994,
								28.51314019600005
							],
							[
								-81.35563899999995,
								28.512780000000078
							],
							[
								-81.35563562899995,
								28.512486744000057
							],
							[
								-81.35563399999995,
								28.51234500000004
							],
							[
								-81.35614123699992,
								28.51234112800006
							],
							[
								-81.35628899999995,
								28.51234000000005
							],
							[
								-81.3563279999999,
								28.512338000000057
							],
							[
								-81.35639199999993,
								28.512339000000054
							],
							[
								-81.35638599999993,
								28.51194800000008
							],
							[
								-81.35639099999992,
								28.511880000000076
							],
							[
								-81.35638999999993,
								28.511809000000085
							],
							[
								-81.35758499999991,
								28.511802000000046
							],
							[
								-81.3575909999999,
								28.511880000000076
							],
							[
								-81.35758499999991,
								28.512789000000055
							],
							[
								-81.35982599099992,
								28.51274040900006
							],
							[
								-81.35989099999995,
								28.512739000000067
							],
							[
								-81.35989099999995,
								28.512780000000078
							],
							[
								-81.3598629999999,
								28.512898000000064
							],
							[
								-81.3598649999999,
								28.51297100000005
							],
							[
								-81.36000599999994,
								28.512970000000053
							],
							[
								-81.3609679999999,
								28.512961000000075
							],
							[
								-81.36144499999995,
								28.512957000000085
							],
							[
								-81.36145301699992,
								28.513105703000065
							],
							[
								-81.35814173499995,
								28.51314019600005
							],
							[
								-81.35569664199994,
								28.51314019600005
							]
						]
					],
					[
						[
							[
								-81.3620236509999,
								28.513161961000037
							],
							[
								-81.36202899999995,
								28.51294800000005
							],
							[
								-81.36203249999994,
								28.512951000000044
							],
							[
								-81.36203599999993,
								28.512954000000036
							],
							[
								-81.36232699999994,
								28.51293700000008
							],
							[
								-81.36232089999993,
								28.513100472000076
							],
							[
								-81.36212741399993,
								28.513102512000046
							],
							[
								-81.3621326899999,
								28.513161858000046
							],
							[
								-81.3620236509999,
								28.513161961000037
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Pineloch",
				"RegionID": "269145"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.18582903599992,
					26.09612613200005,
					-80.1760704159999,
					26.106404369000074
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.1776729369999,
							26.103236675000062
						],
						[
							-80.17766592499993,
							26.10304338900005
						],
						[
							-80.17760483499991,
							26.102706890000036
						],
						[
							-80.17749767599992,
							26.10236338100009
						],
						[
							-80.17745260899994,
							26.102261230000067
						],
						[
							-80.17736848499993,
							26.10208296500008
						],
						[
							-80.17713213499991,
							26.101713416000052
						],
						[
							-80.17694085099993,
							26.101433000000046
						],
						[
							-80.1768647369999,
							26.10132984700005
						],
						[
							-80.17666644299993,
							26.101021391000074
						],
						[
							-80.17652122899995,
							26.100798059000056
						],
						[
							-80.17642208199993,
							26.10062379900006
						],
						[
							-80.17629188899991,
							26.100282295000056
						],
						[
							-80.17626985499993,
							26.100179145000087
						],
						[
							-80.1762548339999,
							26.100147090000064
						],
						[
							-80.17620781999995,
							26.09992072500006
						],
						[
							-80.17616970699993,
							26.099562226000046
						],
						[
							-80.17616269599995,
							26.09901842100004
						],
						[
							-80.17614667299995,
							26.09869193600008
						],
						[
							-80.17614667299995,
							26.098508665000054
						],
						[
							-80.17613265199994,
							26.098177172000078
						],
						[
							-80.17612664199994,
							26.097853693000047
						],
						[
							-80.17612636099994,
							26.09784961300005
						],
						[
							-80.17611863099995,
							26.097737521000056
						],
						[
							-80.17611061999992,
							26.09750417500004
						],
						[
							-80.17609459599993,
							26.09704849800005
						],
						[
							-80.17609158999994,
							26.09674705200007
						],
						[
							-80.1760704159999,
							26.096239176000044
						],
						[
							-80.17721525499991,
							26.09612613200005
						],
						[
							-80.17809956899993,
							26.09620424700006
						],
						[
							-80.17824278199993,
							26.09620925300004
						],
						[
							-80.17859830799995,
							26.096217265000064
						],
						[
							-80.1788286499999,
							26.096210255000074
						],
						[
							-80.17899289399992,
							26.096198239000046
						],
						[
							-80.17946659699993,
							26.09630439400007
						],
						[
							-80.17951498399994,
							26.096313162000058
						],
						[
							-80.17970910399993,
							26.09634833800004
						],
						[
							-80.17961781999992,
							26.099409000000037
						],
						[
							-80.17962082499992,
							26.09953118100009
						],
						[
							-80.1796738779999,
							26.10115933600008
						],
						[
							-80.17967462699994,
							26.10306644900004
						],
						[
							-80.18525900299994,
							26.103024409000056
						],
						[
							-80.18579571599992,
							26.102933187000076
						],
						[
							-80.1857959699999,
							26.102933144000076
						],
						[
							-80.18579898699994,
							26.103073433000077
						],
						[
							-80.18581400999994,
							26.103828553000085
						],
						[
							-80.18581400999994,
							26.103919688000076
						],
						[
							-80.18581400999994,
							26.10455262700009
						],
						[
							-80.18582903599992,
							26.10560618900007
						],
						[
							-80.18537134699994,
							26.10569135600008
						],
						[
							-80.18493670799995,
							26.105753408000055
						],
						[
							-80.18406641799993,
							26.105858564000073
						],
						[
							-80.1831590729999,
							26.105937681000057
						],
						[
							-80.18232183099991,
							26.106005782000068
						],
						[
							-80.18228076899995,
							26.10600978900004
						],
						[
							-80.1814044699999,
							26.106087905000038
						],
						[
							-80.17981711599992,
							26.106211088000066
						],
						[
							-80.17948161899994,
							26.106241131000047
						],
						[
							-80.17859630599992,
							26.106318246000058
						],
						[
							-80.17798239599995,
							26.10638634700007
						],
						[
							-80.17777308699993,
							26.106404369000074
						],
						[
							-80.1777450429999,
							26.10557213900006
						],
						[
							-80.1777230109999,
							26.10474591400009
						],
						[
							-80.1777109919999,
							26.104522583000062
						],
						[
							-80.1776729369999,
							26.103236675000062
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "River Run",
				"RegionID": "269159"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.45112740559048,
					27.956142735970985,
					-82.4345181813642,
					27.966045888494616
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.43467268668749,
							27.965400027788718
						],
						[
							-82.4345181813642,
							27.956172727461343
						],
						[
							-82.43451818226357,
							27.956142735970985
						],
						[
							-82.44200444550427,
							27.956189275886018
						],
						[
							-82.44551831340935,
							27.956381926852487
						],
						[
							-82.44913839124605,
							27.956240731495214
						],
						[
							-82.44971980563602,
							27.956878889507962
						],
						[
							-82.45024428394827,
							27.956672203721872
						],
						[
							-82.45112740559048,
							27.956672201023856
						],
						[
							-82.4511273867047,
							27.964400061731833
						],
						[
							-82.44931836446993,
							27.965300075339734
						],
						[
							-82.4428181682642,
							27.96534634545823
						],
						[
							-82.43581509815931,
							27.966045888494616
						],
						[
							-82.43467268668749,
							27.965400027788718
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Historic Ybor",
				"RegionID": "274036"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.88626390999991,
					30.24614801200005,
					-81.83529633999991,
					30.308667013000047
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.84254476399991,
							30.29719712100007
						],
						[
							-81.84171295699991,
							30.293476987000076
						],
						[
							-81.83826683099994,
							30.287981036000073
						],
						[
							-81.8376869629999,
							30.279978003000053
						],
						[
							-81.83563399199994,
							30.274215995000077
						],
						[
							-81.83534690699992,
							30.273636011000065
						],
						[
							-81.83529633999991,
							30.273536146000087
						],
						[
							-81.8490500289999,
							30.267432704000047
						],
						[
							-81.84904985299995,
							30.246949104000066
						],
						[
							-81.8517289099999,
							30.246847013000036
						],
						[
							-81.85487290899994,
							30.246722012000077
						],
						[
							-81.85824790899994,
							30.246626012000036
						],
						[
							-81.85857190999991,
							30.246609013000068
						],
						[
							-81.8590469099999,
							30.24661201300006
						],
						[
							-81.8611439089999,
							30.246583012000087
						],
						[
							-81.8642719099999,
							30.246543012000075
						],
						[
							-81.86604390999992,
							30.246513013000083
						],
						[
							-81.86742290899991,
							30.246483012000056
						],
						[
							-81.87058090999994,
							30.246443012000043
						],
						[
							-81.87386790999994,
							30.24642401200003
						],
						[
							-81.8750129089999,
							30.246378012000033
						],
						[
							-81.8768589099999,
							30.24630301300005
						],
						[
							-81.88030790999994,
							30.24619301200005
						],
						[
							-81.88202390999993,
							30.24614801200005
						],
						[
							-81.88319490999993,
							30.24615401200009
						],
						[
							-81.88477390999992,
							30.246160012000075
						],
						[
							-81.88616403899994,
							30.246159878000068
						],
						[
							-81.88626390999991,
							30.248756013000047
						],
						[
							-81.88625990999992,
							30.248918013000036
						],
						[
							-81.88626190999992,
							30.24905201300004
						],
						[
							-81.8862320419999,
							30.263987142000076
						],
						[
							-81.88426990999994,
							30.264018012000065
						],
						[
							-81.8710958879999,
							30.264229933000077
						],
						[
							-81.86992774799995,
							30.264933919000043
						],
						[
							-81.86976190999991,
							30.27745701300006
						],
						[
							-81.8696319089999,
							30.290214013000085
						],
						[
							-81.8695648609999,
							30.29568314500006
						],
						[
							-81.87433282799992,
							30.289855839000037
						],
						[
							-81.87811704299992,
							30.289826879000085
						],
						[
							-81.8780989089999,
							30.297826013000073
						],
						[
							-81.8780309089999,
							30.30510801200006
						],
						[
							-81.87797890999991,
							30.30548801200007
						],
						[
							-81.87792691099992,
							30.306092965000065
						],
						[
							-81.87787206899992,
							30.306562083000077
						],
						[
							-81.87763299799991,
							30.306850171000065
						],
						[
							-81.87712890799992,
							30.306898010000054
						],
						[
							-81.87702090699992,
							30.306915011000058
						],
						[
							-81.87604490699994,
							30.307007011000053
						],
						[
							-81.87585790799994,
							30.307022010000082
						],
						[
							-81.87496790799992,
							30.30711101000008
						],
						[
							-81.87467990699992,
							30.307143011000047
						],
						[
							-81.87402290799992,
							30.307208010000064
						],
						[
							-81.87338390799994,
							30.30728101100004
						],
						[
							-81.8697939079999,
							30.30765401100007
						],
						[
							-81.86951890799992,
							30.30767801000007
						],
						[
							-81.86932390799991,
							30.307693011000087
						],
						[
							-81.8688939079999,
							30.30773301100004
						],
						[
							-81.86839090699993,
							30.307773010000062
						],
						[
							-81.86769190699994,
							30.30783001000009
						],
						[
							-81.8669569079999,
							30.30788701000006
						],
						[
							-81.86662890799994,
							30.307909010000056
						],
						[
							-81.8659969069999,
							30.307949010000076
						],
						[
							-81.86522090799991,
							30.308016010000074
						],
						[
							-81.8645319069999,
							30.30806301000007
						],
						[
							-81.86182290699992,
							30.308276010000046
						],
						[
							-81.86062890799991,
							30.308366010000046
						],
						[
							-81.85664685199993,
							30.308667013000047
						],
						[
							-81.85650990999994,
							30.308439013000054
						],
						[
							-81.8560709439999,
							30.30792097200009
						],
						[
							-81.85545290499995,
							30.30749301200007
						],
						[
							-81.85308888399993,
							30.306489058000068
						],
						[
							-81.85257690899994,
							30.306087012000038
						],
						[
							-81.85231275199993,
							30.30581408600005
						],
						[
							-81.85227990999994,
							30.305515013000043
						],
						[
							-81.85212603399992,
							30.304722966000046
						],
						[
							-81.85162290799991,
							30.303898013000037
						],
						[
							-81.84946490899995,
							30.30144701100005
						],
						[
							-81.84856396499993,
							30.300104951000037
						],
						[
							-81.84254476399991,
							30.29719712100007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Jacksonville Farms-Terrace",
				"RegionID": "274122"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.31067442599993,
					28.502354000000082,
					-81.3019842189999,
					28.523640411000088
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.30489985999992,
							28.510535851000043
						],
						[
							-81.3042417719999,
							28.509643338000046
						],
						[
							-81.30311202399992,
							28.50978371900004
						],
						[
							-81.3019842189999,
							28.50973677800005
						],
						[
							-81.30198422199993,
							28.50249778300008
						],
						[
							-81.3050893489999,
							28.50248386700008
						],
						[
							-81.30550599999992,
							28.502482000000047
						],
						[
							-81.30550099999994,
							28.502354000000082
						],
						[
							-81.30598169199993,
							28.50235666100008
						],
						[
							-81.30784999999992,
							28.50236700000005
						],
						[
							-81.30830199999991,
							28.502362000000062
						],
						[
							-81.30897199999993,
							28.502369000000044
						],
						[
							-81.3094779999999,
							28.502375000000086
						],
						[
							-81.30961799999994,
							28.502379000000076
						],
						[
							-81.30961882399993,
							28.50246268400008
						],
						[
							-81.31035890599992,
							28.50245571700009
						],
						[
							-81.3103587729999,
							28.502572023000084
						],
						[
							-81.3103277269999,
							28.504043205000077
						],
						[
							-81.31032271899994,
							28.504525922000084
						],
						[
							-81.3103277269999,
							28.504909491000035
						],
						[
							-81.31033473699995,
							28.505406227000037
						],
						[
							-81.31035075999996,
							28.50570867600004
						],
						[
							-81.31035076099994,
							28.505778779000085
						],
						[
							-81.31035076099994,
							28.50582184400008
						],
						[
							-81.31033870599992,
							28.507297045000087
						],
						[
							-81.31035075999996,
							28.507523366000044
						],
						[
							-81.31038481099995,
							28.508900409000034
						],
						[
							-81.31038080499991,
							28.509104712000067
						],
						[
							-81.31039182199993,
							28.509693585000036
						],
						[
							-81.31036878799995,
							28.511084648000065
						],
						[
							-81.3103938239999,
							28.512186283000062
						],
						[
							-81.31041285299995,
							28.512545816000056
						],
						[
							-81.31041485599991,
							28.513116661000083
						],
						[
							-81.31041980899994,
							28.514535765000062
						],
						[
							-81.31041986299994,
							28.514586842000085
						],
						[
							-81.31042086499991,
							28.51463891900005
						],
						[
							-81.31043488299991,
							28.51576506500004
						],
						[
							-81.31043889199992,
							28.51608706700006
						],
						[
							-81.31045691799996,
							28.517069524000078
						],
						[
							-81.31045791999992,
							28.51714263300005
						],
						[
							-81.31046693299993,
							28.519095528000037
						],
						[
							-81.3104689349999,
							28.519240745000047
						],
						[
							-81.31047294199993,
							28.519590263000055
						],
						[
							-81.3104749449999,
							28.519932770000082
						],
						[
							-81.31047093799992,
							28.520132066000087
						],
						[
							-81.31045090899994,
							28.520713930000056
						],
						[
							-81.31041986299994,
							28.52176949400007
						],
						[
							-81.3104557659999,
							28.523272768000083
						],
						[
							-81.31059111899992,
							28.523466011000043
						],
						[
							-81.31067442599993,
							28.52354310000004
						],
						[
							-81.31061624699993,
							28.52362941800004
						],
						[
							-81.3103841109999,
							28.523640411000088
						],
						[
							-81.3103377409999,
							28.523623243000088
						],
						[
							-81.31028966899993,
							28.52360421600008
						],
						[
							-81.30997119799991,
							28.523479029000043
						],
						[
							-81.3091920409999,
							28.523175580000043
						],
						[
							-81.30903981699993,
							28.523111485000072
						],
						[
							-81.30824163199992,
							28.522801025000035
						],
						[
							-81.30807338299991,
							28.522736929000075
						],
						[
							-81.30803031899991,
							28.522716900000034
						],
						[
							-81.3076647769999,
							28.522590712000067
						],
						[
							-81.30615738199992,
							28.522041005000062
						],
						[
							-81.30616371199994,
							28.521966680000048
						],
						[
							-81.30529526299995,
							28.521637299000076
						],
						[
							-81.30504689399993,
							28.52155017000007
						],
						[
							-81.30491970599991,
							28.52150610500007
						],
						[
							-81.30479852699995,
							28.521462039000085
						],
						[
							-81.30405342199992,
							28.521190637000075
						],
						[
							-81.30364181099992,
							28.52104141400008
						],
						[
							-81.3036147709999,
							28.521031399000037
						],
						[
							-81.3031090209999,
							28.520825095000077
						],
						[
							-81.30208942899992,
							28.52046662600009
						],
						[
							-81.3020875059999,
							28.520392452000067
						],
						[
							-81.30209050999993,
							28.519736479000073
						],
						[
							-81.30209151199995,
							28.51961930500005
						],
						[
							-81.30209752099995,
							28.519085515000086
						],
						[
							-81.3020845019999,
							28.51812108300004
						],
						[
							-81.3020814969999,
							28.517286847000037
						],
						[
							-81.30207932699994,
							28.51250966300006
						],
						[
							-81.30372393099992,
							28.511616436000054
						],
						[
							-81.30489985999992,
							28.510535851000043
						]
					],
					[
						[
							-81.30723740399992,
							28.50657786700009
						],
						[
							-81.30701552399995,
							28.506549802000052
						],
						[
							-81.30670619599994,
							28.50656848600005
						],
						[
							-81.30659843299993,
							28.506587897000088
						],
						[
							-81.30651919099995,
							28.506602357000077
						],
						[
							-81.30635421799991,
							28.50665494900005
						],
						[
							-81.3059974979999,
							28.50684536600005
						],
						[
							-81.30599592099992,
							28.506846206000034
						],
						[
							-81.30577566099993,
							28.506963218000067
						],
						[
							-81.30562064499992,
							28.507156561000045
						],
						[
							-81.30559514599992,
							28.507186964000084
						],
						[
							-81.30555491599995,
							28.507229917000075
						],
						[
							-81.3055173269999,
							28.507265405000055
						],
						[
							-81.30539791799994,
							28.507371817000035
						],
						[
							-81.30527813899994,
							28.50780743300004
						],
						[
							-81.30526259499993,
							28.507858077000037
						],
						[
							-81.30524186499991,
							28.507913156000086
						],
						[
							-81.30521757699995,
							28.507966760000045
						],
						[
							-81.30518983499991,
							28.50801866100005
						],
						[
							-81.30517654099992,
							28.508040939000068
						],
						[
							-81.30511156199992,
							28.50814634300008
						],
						[
							-81.30514453899991,
							28.50821681100007
						],
						[
							-81.30516086499995,
							28.50825384400008
						],
						[
							-81.30518159499991,
							28.508308922000083
						],
						[
							-81.3051898519999,
							28.508334495000042
						],
						[
							-81.30530370399993,
							28.508706010000083
						],
						[
							-81.30535155399991,
							28.508861524000057
						],
						[
							-81.30536067799994,
							28.50889323800004
						],
						[
							-81.30537404199994,
							28.508950551000055
						],
						[
							-81.30537583599994,
							28.50895982800006
						],
						[
							-81.30543754099995,
							28.50928802500005
						],
						[
							-81.3054978429999,
							28.509502903000055
						],
						[
							-81.3055222019999,
							28.509589621000092
						],
						[
							-81.3055348339999,
							28.50961366900009
						],
						[
							-81.3057268149999,
							28.509780975000073
						],
						[
							-81.3057496639999,
							28.509800883000082
						],
						[
							-81.30606418599992,
							28.509967566000057
						],
						[
							-81.30619161899995,
							28.510024023000085
						],
						[
							-81.30626753199994,
							28.51005728800004
						],
						[
							-81.30660689699994,
							28.510115674000076
						],
						[
							-81.30725102699995,
							28.510065404000045
						],
						[
							-81.30725809199993,
							28.510064881000062
						],
						[
							-81.30750499099992,
							28.510047567000072
						],
						[
							-81.30788271099993,
							28.509950992000086
						],
						[
							-81.30802862199994,
							28.50988686000005
						],
						[
							-81.3081892479999,
							28.509746920000055
						],
						[
							-81.30819807899991,
							28.509739326000044
						],
						[
							-81.3083124339999,
							28.50964227500009
						],
						[
							-81.30841675099992,
							28.509531940000045
						],
						[
							-81.30866367499993,
							28.509238718000063
						],
						[
							-81.30872894099991,
							28.509146445000056
						],
						[
							-81.30880812099991,
							28.508955875000083
						],
						[
							-81.30885273399991,
							28.508847814000035
						],
						[
							-81.30885313499994,
							28.50884684400006
						],
						[
							-81.3088774229999,
							28.50879324000005
						],
						[
							-81.30889143699994,
							28.508766001000087
						],
						[
							-81.3089284369999,
							28.508697001000087
						],
						[
							-81.30892953799992,
							28.508694954000077
						],
						[
							-81.30899176999992,
							28.508579618000056
						],
						[
							-81.3090072949999,
							28.508388298000057
						],
						[
							-81.30899972799995,
							28.50766946600004
						],
						[
							-81.30899967799992,
							28.507660000000048
						],
						[
							-81.30900000899993,
							28.507635615000083
						],
						[
							-81.30900111999995,
							28.507594633000053
						],
						[
							-81.30896083899995,
							28.507587484000055
						],
						[
							-81.30894255099992,
							28.507584042000076
						],
						[
							-81.3088852379999,
							28.507570679000082
						],
						[
							-81.30882892199992,
							28.507553596000037
						],
						[
							-81.30877384399992,
							28.507532866000076
						],
						[
							-81.3087202399999,
							28.507508578000056
						],
						[
							-81.30869928599992,
							28.50749790100008
						],
						[
							-81.30846928599993,
							28.507376901000043
						],
						[
							-81.3084383389999,
							28.507359836000035
						],
						[
							-81.30839607799993,
							28.50733385600006
						],
						[
							-81.30804407799992,
							28.50710385600007
						],
						[
							-81.30803636399992,
							28.507098759000087
						],
						[
							-81.30800977799993,
							28.507080295000037
						],
						[
							-81.30733436399993,
							28.506592950000083
						],
						[
							-81.30730937899995,
							28.506587421000063
						],
						[
							-81.30723740399992,
							28.50657786700009
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Lake Frendrica",
				"RegionID": "274229"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.18672950099995,
					26.14165600000007,
					-80.16852203699995,
					26.151323613000045
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.16852203699995,
							26.151323613000045
						],
						[
							-80.16859899999992,
							26.151162000000056
						],
						[
							-80.16852609099993,
							26.151162000000056
						],
						[
							-80.16990037399995,
							26.147435166000037
						],
						[
							-80.17407971699993,
							26.14736427100007
						],
						[
							-80.17417875199993,
							26.14707569400008
						],
						[
							-80.17419377599992,
							26.14689442200006
						],
						[
							-80.17418676599993,
							26.146697130000064
						],
						[
							-80.17417875399991,
							26.146252471000082
						],
						[
							-80.17415658899995,
							26.145996963000073
						],
						[
							-80.17453529399997,
							26.146004041000083
						],
						[
							-80.17461126799992,
							26.147514477000072
						],
						[
							-80.18066337199991,
							26.147346092000078
						],
						[
							-80.1808114719999,
							26.14734000100009
						],
						[
							-80.18081107899991,
							26.145889243000056
						],
						[
							-80.18053299999993,
							26.145887000000073
						],
						[
							-80.18054399999994,
							26.14537500000006
						],
						[
							-80.18261599999994,
							26.145343000000082
						],
						[
							-80.18261299999995,
							26.145061000000055
						],
						[
							-80.18256799999995,
							26.141677000000072
						],
						[
							-80.1847679999999,
							26.14166300000005
						],
						[
							-80.18550299999993,
							26.14165600000007
						],
						[
							-80.1857139999999,
							26.14165600000007
						],
						[
							-80.18647199999992,
							26.14165600000007
						],
						[
							-80.18646799999993,
							26.142063000000064
						],
						[
							-80.18646799999993,
							26.14286300000009
						],
						[
							-80.18649199999993,
							26.143343000000073
						],
						[
							-80.18668799999995,
							26.14676200000008
						],
						[
							-80.18667948799992,
							26.147098635000077
						],
						[
							-80.18666799999994,
							26.147553000000073
						],
						[
							-80.18666799999994,
							26.147863000000086
						],
						[
							-80.18666799999994,
							26.148763000000088
						],
						[
							-80.18666799999994,
							26.149263000000076
						],
						[
							-80.18656799999991,
							26.15046300000006
						],
						[
							-80.18672146299993,
							26.150462359000073
						],
						[
							-80.1867213829999,
							26.150484988000073
						],
						[
							-80.18672950099995,
							26.150771300000088
						],
						[
							-80.18596423199995,
							26.150790200000074
						],
						[
							-80.18431077999992,
							26.150858301000085
						],
						[
							-80.18277750599992,
							26.150921396000058
						],
						[
							-80.18084664199995,
							26.15099450300005
						],
						[
							-80.18034389799993,
							26.15101653700009
						],
						[
							-80.17871047499995,
							26.151075623000054
						],
						[
							-80.17806151299993,
							26.151093650000064
						],
						[
							-80.17502601099994,
							26.15117877600005
						],
						[
							-80.17455330899992,
							26.151192798000068
						],
						[
							-80.17371606699993,
							26.15119780400005
						],
						[
							-80.17110920099992,
							26.15127291600004
						],
						[
							-80.17058642599994,
							26.15128693700007
						],
						[
							-80.16881980599993,
							26.15131798300007
						],
						[
							-80.16852203699995,
							26.151323613000045
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Lake Aire Palm View",
				"RegionID": "269030"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.37764056138742,
					28.529184456672525,
					-81.3683567872339,
					28.53729151381617
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.36860014647307,
							28.53128760937163
						],
						[
							-81.36850994986938,
							28.530996199356494
						],
						[
							-81.36859413720319,
							28.530966135920394
						],
						[
							-81.36878442115419,
							28.530949109056387
						],
						[
							-81.37056819582224,
							28.530943230188328
						],
						[
							-81.37056893596433,
							28.530826796763826
						],
						[
							-81.37280050555388,
							28.53078499177929
						],
						[
							-81.37279847758276,
							28.529184456672525
						],
						[
							-81.37355549629004,
							28.529760345627892
						],
						[
							-81.37464126036654,
							28.530484319646586
						],
						[
							-81.37476516805644,
							28.531229671449175
						],
						[
							-81.37551039575261,
							28.5312114970503
						],
						[
							-81.37644378859696,
							28.53119041154602
						],
						[
							-81.37656996707503,
							28.53259354726599
						],
						[
							-81.37681032437717,
							28.53391851211645
						],
						[
							-81.37699154226267,
							28.534823873093217
						],
						[
							-81.37764056138742,
							28.536117831118744
						],
						[
							-81.3773200798884,
							28.536225934123337
						],
						[
							-81.37623246590651,
							28.536570445507024
						],
						[
							-81.37598610113321,
							28.536648560618467
						],
						[
							-81.37578480138683,
							28.53671265619878
						],
						[
							-81.3752990820554,
							28.536859875214958
						],
						[
							-81.37475126903442,
							28.537006091487115
						],
						[
							-81.37438672795061,
							28.537079199173505
						],
						[
							-81.37357252045611,
							28.53718235230967
						],
						[
							-81.37283342613614,
							28.537237375529344
						],
						[
							-81.37190705160084,
							28.53724844978081
						],
						[
							-81.37016046209999,
							28.537271484115962
						],
						[
							-81.36862418355224,
							28.53729151381617
						],
						[
							-81.36837180771042,
							28.53728550634503
						],
						[
							-81.36837080766432,
							28.537201380165143
						],
						[
							-81.36836780302947,
							28.53707218895826
						],
						[
							-81.36836680208401,
							28.536680608858262
						],
						[
							-81.36836680208401,
							28.536247967513027
						],
						[
							-81.36836580023927,
							28.535549931740285
						],
						[
							-81.36836580023927,
							28.534849893177437
						],
						[
							-81.36837080766432,
							28.533911501001917
						],
						[
							-81.36837180860978,
							28.533275558019376
						],
						[
							-81.3683567872339,
							28.532455341255087
						],
						[
							-81.36836780392875,
							28.53239024562869
						],
						[
							-81.36840585963978,
							28.532290098026834
						],
						[
							-81.36852804063132,
							28.532064763899122
						],
						[
							-81.36859313535844,
							28.53194058011737
						],
						[
							-81.36861622365294,
							28.531860469410418
						],
						[
							-81.36861617149225,
							28.531788352776864
						],
						[
							-81.36861416870214,
							28.531401779202554
						],
						[
							-81.36860014647307,
							28.53128760937163
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Lake Cherokee",
				"RegionID": "269032"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.37258205199993,
					28.56404019000007,
					-81.36443997799995,
					28.573950015000037
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.36853313799992,
							28.573626361000038
						],
						[
							-81.36787006499992,
							28.57347905000006
						],
						[
							-81.36728219299994,
							28.57362640100007
						],
						[
							-81.36676742999992,
							28.57369950900005
						],
						[
							-81.3661044239999,
							28.573699641000076
						],
						[
							-81.36573689999994,
							28.573552292000045
						],
						[
							-81.36500181199995,
							28.57340507100008
						],
						[
							-81.3644429279999,
							28.573096674000055
						],
						[
							-81.36444999299994,
							28.57218226000009
						],
						[
							-81.36445099499993,
							28.572015012000065
						],
						[
							-81.36445600199994,
							28.57089935600004
						],
						[
							-81.3644580589999,
							28.57039218600005
						],
						[
							-81.3644580049999,
							28.570336522000048
						],
						[
							-81.3644580049999,
							28.57026942200008
						],
						[
							-81.36445900599995,
							28.570147241000086
						],
						[
							-81.36446000799992,
							28.569943941000076
						],
						[
							-81.36446000799992,
							28.56978670700005
						],
						[
							-81.36444798999993,
							28.56677624300005
						],
						[
							-81.3644420359999,
							28.56555342900009
						],
						[
							-81.36444398399993,
							28.564798309000082
						],
						[
							-81.36443997799995,
							28.564075237000054
						],
						[
							-81.3644429229999,
							28.56404019000007
						],
						[
							-81.36451208499994,
							28.564042188000087
						],
						[
							-81.36507291599992,
							28.56404419000006
						],
						[
							-81.36566479399994,
							28.564048196000044
						],
						[
							-81.36621761399994,
							28.564050200000054
						],
						[
							-81.36727017599992,
							28.564054205000048
						],
						[
							-81.36833875899993,
							28.564057209000055
						],
						[
							-81.3692701409999,
							28.564058211000088
						],
						[
							-81.36997318399995,
							28.564059213000068
						],
						[
							-81.3707102759999,
							28.56406221700007
						],
						[
							-81.3713342019999,
							28.564063218000058
						],
						[
							-81.37177285299992,
							28.564064220000034
						],
						[
							-81.3721143599999,
							28.564065221000078
						],
						[
							-81.37243593199992,
							28.564066223000054
						],
						[
							-81.37250894399995,
							28.565385180000078
						],
						[
							-81.3725480029999,
							28.566231434000088
						],
						[
							-81.37258205199993,
							28.566796272000094
						],
						[
							-81.37257604299992,
							28.567155805000084
						],
						[
							-81.37255300899994,
							28.567320048000056
						],
						[
							-81.37251495399994,
							28.567532364000044
						],
						[
							-81.3722175129999,
							28.569078656000045
						],
						[
							-81.37177285299992,
							28.57126189400009
						],
						[
							-81.37176283699995,
							28.571312971000054
						],
						[
							-81.37175081999993,
							28.571377065000036
						],
						[
							-81.37141131699991,
							28.573057557000087
						],
						[
							-81.37130415799994,
							28.57359034700005
						],
						[
							-81.37126819699995,
							28.573852744000078
						],
						[
							-81.37126422599994,
							28.573950015000037
						],
						[
							-81.37037177499991,
							28.57392083700006
						],
						[
							-81.36985600899993,
							28.57384772900008
						],
						[
							-81.36934124599992,
							28.573773619000068
						],
						[
							-81.36853313799992,
							28.573626361000038
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Lake Formosa",
				"RegionID": "269039"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.38476414699994,
					28.50622400000009,
					-81.3796213469999,
					28.513679361000072
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.38430543999993,
							28.513264882000044
						],
						[
							-81.38409512899995,
							28.513096634000078
						],
						[
							-81.38395091299992,
							28.513020520000055
						],
						[
							-81.38381070599992,
							28.51296844400008
						],
						[
							-81.3837616319999,
							28.512960431000067
						],
						[
							-81.38363344299995,
							28.512943405000044
						],
						[
							-81.3831617429999,
							28.51293038600005
						],
						[
							-81.38168655499993,
							28.512917366000067
						],
						[
							-81.38103058299993,
							28.512915363000047
						],
						[
							-81.38049754199994,
							28.512910385000055
						],
						[
							-81.38048577399991,
							28.512843257000043
						],
						[
							-81.3804707509999,
							28.512778161000085
						],
						[
							-81.3800421169999,
							28.511005531000084
						],
						[
							-81.37989089199993,
							28.510375598000053
						],
						[
							-81.37969860699991,
							28.509579415000076
						],
						[
							-81.3796213469999,
							28.509233804000075
						],
						[
							-81.38047575899992,
							28.509221886000034
						],
						[
							-81.38129608199995,
							28.50923005500005
						],
						[
							-81.38158340199993,
							28.508528857000044
						],
						[
							-81.38194106599991,
							28.50739318500007
						],
						[
							-81.38194120499992,
							28.506258985000045
						],
						[
							-81.3820879999999,
							28.506253000000076
						],
						[
							-81.3823799999999,
							28.50624600000009
						],
						[
							-81.38280899999995,
							28.50622400000009
						],
						[
							-81.3831837329999,
							28.50623419300007
						],
						[
							-81.38343399999991,
							28.506241000000045
						],
						[
							-81.38454473599995,
							28.50627099700006
						],
						[
							-81.38455796499994,
							28.50628185400007
						],
						[
							-81.38460091699994,
							28.506322083000043
						],
						[
							-81.38464114599992,
							28.506365035000044
						],
						[
							-81.38467848099992,
							28.50641052700007
						],
						[
							-81.38471275899992,
							28.506458363000036
						],
						[
							-81.38474383599993,
							28.50650833900005
						],
						[
							-81.38476414699994,
							28.506546089000043
						],
						[
							-81.38475799999992,
							28.507126000000085
						],
						[
							-81.3847403389999,
							28.508720894000078
						],
						[
							-81.38471647199992,
							28.508740480000085
						],
						[
							-81.3846686359999,
							28.50877475900006
						],
						[
							-81.38461866099993,
							28.50880583600008
						],
						[
							-81.38456675999993,
							28.508833578000065
						],
						[
							-81.38451315599993,
							28.508857866000085
						],
						[
							-81.38445807699992,
							28.508878595000056
						],
						[
							-81.38444918399995,
							28.50888129300006
						],
						[
							-81.38445204199991,
							28.508893551000085
						],
						[
							-81.38446162799994,
							28.50895161500006
						],
						[
							-81.38446739699992,
							28.509010181000065
						],
						[
							-81.38446932199992,
							28.509069000000068
						],
						[
							-81.38446932199992,
							28.509097000000054
						],
						[
							-81.38446739699992,
							28.509155819000057
						],
						[
							-81.38446162799994,
							28.509214385000064
						],
						[
							-81.38445204199991,
							28.509272449000036
						],
						[
							-81.38443867899991,
							28.50932976200005
						],
						[
							-81.38442490099993,
							28.509376151000083
						],
						[
							-81.38440890099993,
							28.509425151000073
						],
						[
							-81.38440559499992,
							28.509435077000035
						],
						[
							-81.38440204999995,
							28.509445319000065
						],
						[
							-81.38439004899993,
							28.509479320000082
						],
						[
							-81.38437286499993,
							28.509524156000055
						],
						[
							-81.38434857699991,
							28.50957776000007
						],
						[
							-81.38432083599992,
							28.50962966100008
						],
						[
							-81.38429617799996,
							28.50966989300008
						],
						[
							-81.38422017799991,
							28.50978689300007
						],
						[
							-81.38421375899992,
							28.50979663700008
						],
						[
							-81.38417947999994,
							28.509844473000044
						],
						[
							-81.38414214599993,
							28.50988996500007
						],
						[
							-81.38410191699995,
							28.50993291700007
						],
						[
							-81.38408379399993,
							28.509950537000066
						],
						[
							-81.3838981479999,
							28.510126030000038
						],
						[
							-81.38364073499991,
							28.51050307500009
						],
						[
							-81.3836114799999,
							28.51054347300004
						],
						[
							-81.38357414599996,
							28.51058896400008
						],
						[
							-81.3835601429999,
							28.510604561000036
						],
						[
							-81.3835503439999,
							28.51061522300006
						],
						[
							-81.38360105399994,
							28.510783450000076
						],
						[
							-81.38360867799992,
							28.51081023800009
						],
						[
							-81.38361785099994,
							28.51084766000008
						],
						[
							-81.38365481299991,
							28.511013768000055
						],
						[
							-81.38367769799993,
							28.511035706000087
						],
						[
							-81.38402370199992,
							28.511297884000044
						],
						[
							-81.38436693799991,
							28.51155731500006
						],
						[
							-81.38437826299992,
							28.51156076800004
						],
						[
							-81.38438476699991,
							28.51156277800004
						],
						[
							-81.38470774899992,
							28.51166392500005
						],
						[
							-81.3846989999999,
							28.512454000000048
						],
						[
							-81.38469299999991,
							28.51295600000009
						],
						[
							-81.38469199999992,
							28.513283000000058
						],
						[
							-81.38457099999994,
							28.513201000000038
						],
						[
							-81.38458393899992,
							28.513679361000072
						],
						[
							-81.38436953399992,
							28.51333899200006
						],
						[
							-81.38430543999993,
							28.513264882000044
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Lake Holden",
				"RegionID": "269041"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.43523099999993,
					28.52732000000009,
					-81.42627698699994,
					28.53808261100005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.4294543609999,
							28.536482376000038
						],
						[
							-81.42982236199992,
							28.536252376000053
						],
						[
							-81.42984933899993,
							28.53623616400006
						],
						[
							-81.42990123999994,
							28.536208423000062
						],
						[
							-81.42995484499994,
							28.536184135000042
						],
						[
							-81.43000124499991,
							28.53616640000007
						],
						[
							-81.43041899899994,
							28.536019820000035
						],
						[
							-81.43061079199992,
							28.53589930800007
						],
						[
							-81.43085377099993,
							28.535642155000062
						],
						[
							-81.43102364799995,
							28.535410330000047
						],
						[
							-81.4312045069999,
							28.53497855100005
						],
						[
							-81.43122742299995,
							28.534928240000056
						],
						[
							-81.43125516499993,
							28.53487633900005
						],
						[
							-81.43128233599992,
							28.53483225800005
						],
						[
							-81.43132848399995,
							28.534762003000083
						],
						[
							-81.43125656599994,
							28.533937646000084
						],
						[
							-81.43119646899993,
							28.533541582000055
						],
						[
							-81.43112822099994,
							28.533390697000076
						],
						[
							-81.43088266099994,
							28.533083935000036
						],
						[
							-81.43030011699994,
							28.532420264000052
						],
						[
							-81.43029985399994,
							28.53241996400004
						],
						[
							-81.43026722399992,
							28.532380549000038
						],
						[
							-81.42975093399991,
							28.53171948000005
						],
						[
							-81.42954059899995,
							28.53153311600005
						],
						[
							-81.42954047299992,
							28.531533005000085
						],
						[
							-81.42941556699992,
							28.53142229200006
						],
						[
							-81.42929297099995,
							28.531366103000043
						],
						[
							-81.42868969699992,
							28.53134381600006
						],
						[
							-81.4285285929999,
							28.53133890400005
						],
						[
							-81.42849718199994,
							28.531337397000073
						],
						[
							-81.42843861499995,
							28.53133162800009
						],
						[
							-81.42838055099992,
							28.531322042000056
						],
						[
							-81.4283232379999,
							28.531308679000066
						],
						[
							-81.42828166499993,
							28.531296458000043
						],
						[
							-81.42802566499995,
							28.53121445800008
						],
						[
							-81.42801092199994,
							28.531209595000064
						],
						[
							-81.42795584399994,
							28.531188865000047
						],
						[
							-81.42795336399992,
							28.531187833000047
						],
						[
							-81.42787593899993,
							28.53115549200004
						],
						[
							-81.42766436999995,
							28.531068057000084
						],
						[
							-81.42755434499992,
							28.531071582000042
						],
						[
							-81.42728287999995,
							28.53116366200004
						],
						[
							-81.42722676199992,
							28.531180678000055
						],
						[
							-81.4271694489999,
							28.53119404100005
						],
						[
							-81.42714568999992,
							28.531198436000068
						],
						[
							-81.4267716899999,
							28.531262437000066
						],
						[
							-81.42673738499991,
							28.53126762800008
						],
						[
							-81.42667881799991,
							28.531273396000074
						],
						[
							-81.42663324399992,
							28.53127522400007
						],
						[
							-81.4264195639999,
							28.531278372000088
						],
						[
							-81.42627698699994,
							28.530380526000044
						],
						[
							-81.42627899999992,
							28.530196000000046
						],
						[
							-81.42628999999994,
							28.528980000000047
						],
						[
							-81.42629799999992,
							28.528080000000045
						],
						[
							-81.4263049999999,
							28.527351000000067
						],
						[
							-81.42819299999991,
							28.527360000000044
						],
						[
							-81.43029299999995,
							28.52734200000009
						],
						[
							-81.4308049999999,
							28.527338000000043
						],
						[
							-81.4317930069999,
							28.527332664000085
						],
						[
							-81.43210099999993,
							28.52733100000006
						],
						[
							-81.4322970799999,
							28.52733003500009
						],
						[
							-81.43234466199993,
							28.527329801000064
						],
						[
							-81.43433699999991,
							28.52732000000009
						],
						[
							-81.43432876899993,
							28.527830357000084
						],
						[
							-81.43442677199994,
							28.527833487000066
						],
						[
							-81.43449329799995,
							28.527833387000044
						],
						[
							-81.4345009999999,
							28.528074000000064
						],
						[
							-81.4345199999999,
							28.52880500000009
						],
						[
							-81.4345209999999,
							28.529045000000053
						],
						[
							-81.4345229999999,
							28.53006600000009
						],
						[
							-81.43457299999996,
							28.530789000000084
						],
						[
							-81.43458099999992,
							28.531174000000078
						],
						[
							-81.43458199999992,
							28.531876000000068
						],
						[
							-81.43458199999992,
							28.532188000000076
						],
						[
							-81.43458299999992,
							28.532680000000084
						],
						[
							-81.43458299999992,
							28.53358000000009
						],
						[
							-81.43458199999992,
							28.534580000000062
						],
						[
							-81.43523099999993,
							28.534580000000062
						],
						[
							-81.43523099999993,
							28.535475000000076
						],
						[
							-81.43458099999992,
							28.53547300000008
						],
						[
							-81.43458099999992,
							28.536099473000036
						],
						[
							-81.43458099999992,
							28.536326000000088
						],
						[
							-81.43439999999993,
							28.536317916000087
						],
						[
							-81.43439999999993,
							28.536449385000083
						],
						[
							-81.43440466899996,
							28.53694245300005
						],
						[
							-81.43441715999995,
							28.53769819200005
						],
						[
							-81.4344208899999,
							28.538076096000054
						],
						[
							-81.4297929999999,
							28.538082000000088
						],
						[
							-81.42960704399991,
							28.53808210300008
						],
						[
							-81.42869079199994,
							28.53808261100005
						],
						[
							-81.42874702899991,
							28.537793286000067
						],
						[
							-81.4288268599999,
							28.537378165000064
						],
						[
							-81.42882795799994,
							28.53737255100009
						],
						[
							-81.42884132199993,
							28.537315238000076
						],
						[
							-81.42885840499991,
							28.537258922000035
						],
						[
							-81.42887913499993,
							28.53720384400009
						],
						[
							-81.42890342299995,
							28.537150240000077
						],
						[
							-81.42893116399995,
							28.537098339000067
						],
						[
							-81.42896224099991,
							28.537048363000054
						],
						[
							-81.42898341199992,
							28.53701804700006
						],
						[
							-81.42920441199993,
							28.536715047000087
						],
						[
							-81.4292175189999,
							28.536697527000058
						],
						[
							-81.42925485299992,
							28.536652036000078
						],
						[
							-81.42929508299994,
							28.536609083000087
						],
						[
							-81.42933803499994,
							28.536568854000052
						],
						[
							-81.42938352699991,
							28.53653152000004
						],
						[
							-81.42943136299994,
							28.536497241000063
						],
						[
							-81.4294543609999,
							28.536482376000038
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Lake Mann Gardens",
				"RegionID": "269046"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.44289041346843,
					28.50986784236283,
					-81.43586376224063,
					28.5153189272607
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.43647180465652,
							28.510396628427635
						],
						[
							-81.43637669595596,
							28.510118106596437
						],
						[
							-81.43882442478989,
							28.510263563840816
						],
						[
							-81.43882416398651,
							28.50986871560449
						],
						[
							-81.44282227723419,
							28.50986784236283
						],
						[
							-81.44289041346843,
							28.5152768497816
						],
						[
							-81.43796496520959,
							28.5153189272607
						],
						[
							-81.43795600706282,
							28.514488696545676
						],
						[
							-81.43795515090821,
							28.513746471685707
						],
						[
							-81.43708759023504,
							28.513619546770414
						],
						[
							-81.43688942642453,
							28.512829232463616
						],
						[
							-81.4368895990944,
							28.512316410264155
						],
						[
							-81.43653489839208,
							28.511921890280455
						],
						[
							-81.43629854756963,
							28.511685539457893
						],
						[
							-81.43598192056473,
							28.511369148974836
						],
						[
							-81.43590396283469,
							28.51097448599885
						],
						[
							-81.43586376224063,
							28.51069795796469
						],
						[
							-81.43658712472032,
							28.51066611297165
						],
						[
							-81.43654691693168,
							28.510587911525263
						],
						[
							-81.43647180465652,
							28.510396628427635
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Lake Richmond",
				"RegionID": "269048"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.36662534951057,
					28.520322293679563,
					-81.35985299957302,
					28.526325434599663
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.3599152686303,
							28.523994794796025
						],
						[
							-81.35991326494083,
							28.523606218431517
						],
						[
							-81.35991126215063,
							28.523400905910222
						],
						[
							-81.3598545562995,
							28.523402387992945
						],
						[
							-81.35985599971129,
							28.523180000044263
						],
						[
							-81.35985599971129,
							28.522480000152257
						],
						[
							-81.35985299957302,
							28.52162899959486
						],
						[
							-81.35985899984965,
							28.521158000366526
						],
						[
							-81.3598575771222,
							28.520638653585753
						],
						[
							-81.35991126215063,
							28.520638828953466
						],
						[
							-81.35990612252527,
							28.520359274700652
						],
						[
							-81.35999238189702,
							28.520358401459
						],
						[
							-81.36195829715517,
							28.52034638381869
						],
						[
							-81.36293574688644,
							28.52034938845363
						],
						[
							-81.3640213562795,
							28.520345381973954
						],
						[
							-81.36600129376671,
							28.520333364333737
						],
						[
							-81.36650905008511,
							28.520322293679563
						],
						[
							-81.36662534951057,
							28.523914805497462
						],
						[
							-81.36578083306509,
							28.523914541996064
						],
						[
							-81.36578112534471,
							28.525783559802093
						],
						[
							-81.36415353953068,
							28.526325434599663
						],
						[
							-81.36318912277427,
							28.525843536487578
						],
						[
							-81.36216562235919,
							28.525301684173094
						],
						[
							-81.36120117412644,
							28.52512046448895
						],
						[
							-81.35990019149645,
							28.524934176225734
						],
						[
							-81.3599182714666,
							28.52481701435042
						],
						[
							-81.35996734387238,
							28.524511562321152
						],
						[
							-81.35996434013681,
							28.524368347985913
						],
						[
							-81.35995332344197,
							28.524285225449418
						],
						[
							-81.3599152686303,
							28.523994794796025
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Lancaster Park",
				"RegionID": "269057"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.12206617599992,
					26.137437397000042,
					-80.11608919899994,
					26.147157826000072
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.11971598199995,
							26.13757159700009
						],
						[
							-80.1197800779999,
							26.137547561000076
						],
						[
							-80.12014261599995,
							26.137449416000038
						],
						[
							-80.12025978999992,
							26.137437397000042
						],
						[
							-80.12071946799995,
							26.137438399000075
						],
						[
							-80.12104896199992,
							26.13752452500006
						],
						[
							-80.12120619299992,
							26.13752452600005
						],
						[
							-80.1218892039999,
							26.13755156400009
						],
						[
							-80.12206617599992,
							26.137507458000073
						],
						[
							-80.12141149799993,
							26.13787805100009
						],
						[
							-80.12057116699992,
							26.13831059100005
						],
						[
							-80.12034191299995,
							26.138629165000054
						],
						[
							-80.12026078999993,
							26.13878539700005
						],
						[
							-80.12022373499991,
							26.138863513000047
						],
						[
							-80.1201796709999,
							26.138973675000045
						],
						[
							-80.12015162999995,
							26.13907983300004
						],
						[
							-80.12013660799994,
							26.139166961000058
						],
						[
							-80.12013860899992,
							26.13923406300006
						],
						[
							-80.12013460399993,
							26.13936025000004
						],
						[
							-80.12015663699992,
							26.14011637100009
						],
						[
							-80.12019569499995,
							26.14151945100008
						],
						[
							-80.12023169299994,
							26.14279934700005
						],
						[
							-80.12023475299992,
							26.143143861000055
						],
						[
							-80.12023475299992,
							26.143593527000064
						],
						[
							-80.12021672499992,
							26.144568974000038
						],
						[
							-80.1201546339999,
							26.145102765000047
						],
						[
							-80.12013969399993,
							26.147157826000072
						],
						[
							-80.11659373399993,
							26.147077855000077
						],
						[
							-80.11608919899994,
							26.147066477000067
						],
						[
							-80.11608919899994,
							26.146659935000063
						],
						[
							-80.11622974499994,
							26.14609775000008
						],
						[
							-80.11645461899991,
							26.14539501900009
						],
						[
							-80.1167076019999,
							26.144804726000075
						],
						[
							-80.11707302199994,
							26.144101995000085
						],
						[
							-80.11752276899995,
							26.14331493600008
						],
						[
							-80.11791629899994,
							26.142527878000067
						],
						[
							-80.11814117299991,
							26.141881365000074
						],
						[
							-80.11828171899994,
							26.141347290000056
						],
						[
							-80.11828171899994,
							26.140504013000054
						],
						[
							-80.11816928199994,
							26.139773173000037
						],
						[
							-80.11788818899993,
							26.139267207000046
						],
						[
							-80.11794440799991,
							26.13864880400007
						],
						[
							-80.11797251699994,
							26.138255274000073
						],
						[
							-80.11816177299994,
							26.137822690000064
						],
						[
							-80.11845499999993,
							26.137815000000046
						],
						[
							-80.1189678739999,
							26.137776901000052
						],
						[
							-80.1192683189999,
							26.13771981600007
						],
						[
							-80.11950867499992,
							26.13765171500006
						],
						[
							-80.11971598199995,
							26.13757159700009
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Laudergate Isles",
				"RegionID": "269064"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.19314001099991,
					26.091882705000046,
					-80.18562999999995,
					26.102933187000076
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.18579571599992,
							26.102933187000076
						],
						[
							-80.18578908099994,
							26.102618800000073
						],
						[
							-80.18577999999991,
							26.102110834000086
						],
						[
							-80.18577999999991,
							26.101840105000065
						],
						[
							-80.1857773509999,
							26.10150139900009
						],
						[
							-80.18576999999993,
							26.10106176100004
						],
						[
							-80.18575754799991,
							26.100723457000072
						],
						[
							-80.18575472799995,
							26.10052045000009
						],
						[
							-80.1857473959999,
							26.099979518000055
						],
						[
							-80.18574343599994,
							26.09967456000004
						],
						[
							-80.18573031299991,
							26.099066122000067
						],
						[
							-80.18571417699991,
							26.098286560000076
						],
						[
							-80.18570809599993,
							26.09784717100007
						],
						[
							-80.18569999999994,
							26.097240000000056
						],
						[
							-80.18569686399991,
							26.096933180000065
						],
						[
							-80.18567999999993,
							26.096520000000055
						],
						[
							-80.18567999999993,
							26.09615480700006
						],
						[
							-80.18567999999993,
							26.09584230500008
						],
						[
							-80.18567999999993,
							26.095810000000085
						],
						[
							-80.18567498599992,
							26.095443990000035
						],
						[
							-80.1856699999999,
							26.095080000000053
						],
						[
							-80.18566520699994,
							26.094902647000083
						],
						[
							-80.18565999999993,
							26.094710000000077
						],
						[
							-80.18565472599994,
							26.094530700000064
						],
						[
							-80.18564999999995,
							26.094370000000083
						],
						[
							-80.18564999999995,
							26.093988979000077
						],
						[
							-80.18564999999995,
							26.093660000000057
						],
						[
							-80.18564396799991,
							26.09324378100007
						],
						[
							-80.18563999999992,
							26.092970000000037
						],
						[
							-80.18563502699993,
							26.092567173000077
						],
						[
							-80.18562999999995,
							26.092160000000035
						],
						[
							-80.1861073789999,
							26.092109443000084
						],
						[
							-80.18658100999995,
							26.092073697000046
						],
						[
							-80.18712999999991,
							26.09206000000006
						],
						[
							-80.18713011499995,
							26.092059820000088
						],
						[
							-80.18740590599992,
							26.092053431000068
						],
						[
							-80.18754999999993,
							26.092050000000086
						],
						[
							-80.18765257899992,
							26.092045540000072
						],
						[
							-80.18780220199994,
							26.092039035000084
						],
						[
							-80.1880061899999,
							26.092030166000086
						],
						[
							-80.18819859599995,
							26.092023015000052
						],
						[
							-80.18843463099995,
							26.092014273000075
						],
						[
							-80.18854999999992,
							26.092010000000077
						],
						[
							-80.18871285999995,
							26.09200638100009
						],
						[
							-80.18887339299994,
							26.09200281300008
						],
						[
							-80.18906580099991,
							26.09200000000004
						],
						[
							-80.18921557199991,
							26.09199575200006
						],
						[
							-80.18934523399992,
							26.09198999000006
						],
						[
							-80.18947299599995,
							26.09198431100009
						],
						[
							-80.18956999999995,
							26.091980000000035
						],
						[
							-80.18963332599992,
							26.091978397000048
						],
						[
							-80.18972963199991,
							26.09197595900008
						],
						[
							-80.18985803999993,
							26.09197270800007
						],
						[
							-80.19012609799995,
							26.091965922000043
						],
						[
							-80.19035999999994,
							26.091960000000086
						],
						[
							-80.1905099999999,
							26.091950000000054
						],
						[
							-80.19069305599993,
							26.09194511900006
						],
						[
							-80.1908642539999,
							26.091940553000086
						],
						[
							-80.19102532399995,
							26.09193625800009
						],
						[
							-80.19125999999994,
							26.091930000000048
						],
						[
							-80.19137840899992,
							26.091926711000042
						],
						[
							-80.19149639799991,
							26.091923433000094
						],
						[
							-80.19161999999994,
							26.091920000000073
						],
						[
							-80.19174250999993,
							26.091916937000065
						],
						[
							-80.19191399099992,
							26.09191265000004
						],
						[
							-80.19201999999991,
							26.09191000000004
						],
						[
							-80.19210574599992,
							26.091902205000054
						],
						[
							-80.1922137329999,
							26.091898358000037
						],
						[
							-80.19247103499993,
							26.09189331300007
						],
						[
							-80.19256831299992,
							26.09189140600006
						],
						[
							-80.19263999999993,
							26.091890000000035
						],
						[
							-80.19276515299993,
							26.091883756000072
						],
						[
							-80.19278621899991,
							26.091882705000046
						],
						[
							-80.1928324189999,
							26.093369041000074
						],
						[
							-80.19288549799995,
							26.094610883000087
						],
						[
							-80.19292455599992,
							26.095539260000066
						],
						[
							-80.19295560099995,
							26.096301391000054
						],
						[
							-80.1929856459999,
							26.097019455000066
						],
						[
							-80.19300767899995,
							26.097746534000066
						],
						[
							-80.19303972599994,
							26.09846359700009
						],
						[
							-80.19306576499991,
							26.099202693000052
						],
						[
							-80.19309981599991,
							26.099949802000086
						],
						[
							-80.19311483799993,
							26.100664862000087
						],
						[
							-80.19314001099991,
							26.100999481000088
						],
						[
							-80.19131503299991,
							26.101103385000048
						],
						[
							-80.19137338699994,
							26.10278714100008
						],
						[
							-80.19094662099992,
							26.10277599200009
						],
						[
							-80.18839585299992,
							26.102883189000067
						],
						[
							-80.1857959699999,
							26.102933144000076
						],
						[
							-80.18579571599992,
							26.102933187000076
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Riverland Village",
				"RegionID": "269160"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.18227659599995,
					26.088863186000083,
					-80.18125776799991,
					26.092902381000048
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.18126799999993,
							26.089065000000062
						],
						[
							-80.18169033299995,
							26.088863186000083
						],
						[
							-80.18209480799993,
							26.089636965000068
						],
						[
							-80.18220153599992,
							26.089976555000078
						],
						[
							-80.18217242899993,
							26.090257929000074
						],
						[
							-80.18222094099991,
							26.09087889400007
						],
						[
							-80.18224034699995,
							26.091160268000067
						],
						[
							-80.18223064399992,
							26.091558073000044
						],
						[
							-80.18227659599995,
							26.092743626000072
						],
						[
							-80.18209305099992,
							26.092781864000074
						],
						[
							-80.1820260209999,
							26.092795829000067
						],
						[
							-80.1819099999999,
							26.092820000000074
						],
						[
							-80.18149324899991,
							26.092902381000048
						],
						[
							-80.18149324899991,
							26.092343981000056
						],
						[
							-80.1814253309999,
							26.091917068000043
						],
						[
							-80.18138652099992,
							26.091538668000055
						],
						[
							-80.18138652099992,
							26.091160268000067
						],
						[
							-80.18130889999992,
							26.090995324000062
						],
						[
							-80.18127979299993,
							26.09076246300009
						],
						[
							-80.18136711599993,
							26.090616924000074
						],
						[
							-80.18125776799991,
							26.089076942000077
						],
						[
							-80.18126799999993,
							26.089065000000062
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Riverland Woods",
				"RegionID": "269161"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.58428991199992,
					30.250080012000065,
					-81.55268090099993,
					30.269635024000085
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.5527529069999,
							30.250596010000038
						],
						[
							-81.55268090099993,
							30.250102013000063
						],
						[
							-81.5531919099999,
							30.250108012000055
						],
						[
							-81.55338590999992,
							30.25011101200005
						],
						[
							-81.5538899089999,
							30.250093012000036
						],
						[
							-81.5548839089999,
							30.250099012000078
						],
						[
							-81.55625490999995,
							30.250093012000036
						],
						[
							-81.55671690899993,
							30.250101013000066
						],
						[
							-81.55686890899995,
							30.250101013000066
						],
						[
							-81.5579409099999,
							30.250096012000085
						],
						[
							-81.55892390899993,
							30.25009401200009
						],
						[
							-81.5599929089999,
							30.25009201200004
						],
						[
							-81.56060790999993,
							30.25009101200004
						],
						[
							-81.56096690899994,
							30.25008801200005
						],
						[
							-81.56193890899993,
							30.25008801200005
						],
						[
							-81.56347190999992,
							30.25008401300005
						],
						[
							-81.56371790899993,
							30.25008401300005
						],
						[
							-81.56527890899991,
							30.250082013000053
						],
						[
							-81.5693569099999,
							30.250080012000065
						],
						[
							-81.56984290999992,
							30.250080012000065
						],
						[
							-81.57015790899993,
							30.250080012000065
						],
						[
							-81.57047290899993,
							30.25009101300009
						],
						[
							-81.57097190999991,
							30.25012501300006
						],
						[
							-81.57109090999995,
							30.250148012000068
						],
						[
							-81.57183890899995,
							30.25021601200007
						],
						[
							-81.57333690899992,
							30.250386012000035
						],
						[
							-81.57362590999992,
							30.250420013000056
						],
						[
							-81.57380990899992,
							30.250443012000066
						],
						[
							-81.57400690999992,
							30.25045401300008
						],
						[
							-81.57428290999991,
							30.250488012000066
						],
						[
							-81.5744929089999,
							30.25052201200009
						],
						[
							-81.5750049099999,
							30.250579012000063
						],
						[
							-81.57543891199992,
							30.25062401400004
						],
						[
							-81.5754889079999,
							30.25063901100009
						],
						[
							-81.5759079099999,
							30.250683012000085
						],
						[
							-81.5764449099999,
							30.25074401200004
						],
						[
							-81.5769479089999,
							30.250793012000088
						],
						[
							-81.57731790899993,
							30.250836012000036
						],
						[
							-81.57831890999995,
							30.250946013000092
						],
						[
							-81.57869490999991,
							30.250981013000057
						],
						[
							-81.58013490999991,
							30.25114301200006
						],
						[
							-81.58140790999994,
							30.251279012000055
						],
						[
							-81.58182390899992,
							30.251329012000046
						],
						[
							-81.58205190899992,
							30.251357013000078
						],
						[
							-81.58239190899991,
							30.25140001200009
						],
						[
							-81.58303890999991,
							30.251464012000042
						],
						[
							-81.58348090899995,
							30.25151801200008
						],
						[
							-81.58377790899993,
							30.25154301200007
						],
						[
							-81.58395090999994,
							30.25156301200008
						],
						[
							-81.58428991199992,
							30.251601921000084
						],
						[
							-81.58427290799995,
							30.251749010000086
						],
						[
							-81.58421290799993,
							30.25236501100005
						],
						[
							-81.5841839069999,
							30.252671010000086
						],
						[
							-81.58411290799995,
							30.253058011000064
						],
						[
							-81.58405990799992,
							30.253457011000084
						],
						[
							-81.58401890599993,
							30.253764011000044
						],
						[
							-81.58397590899995,
							30.253895009000075
						],
						[
							-81.58391290799995,
							30.25435101000005
						],
						[
							-81.58385390799992,
							30.254574010000056
						],
						[
							-81.58381190699993,
							30.254685007000035
						],
						[
							-81.58370490699991,
							30.254841010000067
						],
						[
							-81.5830279079999,
							30.255535010000077
						],
						[
							-81.58250090699994,
							30.256084010000052
						],
						[
							-81.5818119079999,
							30.25684901100004
						],
						[
							-81.58132290799995,
							30.257351010000036
						],
						[
							-81.58107177199992,
							30.257608982000082
						],
						[
							-81.58038590799993,
							30.25831401100004
						],
						[
							-81.57976690699991,
							30.25895701100006
						],
						[
							-81.57948790699993,
							30.25924501000009
						],
						[
							-81.57863690699992,
							30.260116010000047
						],
						[
							-81.57845390799991,
							30.26031701000005
						],
						[
							-81.5773769079999,
							30.261407010000088
						],
						[
							-81.57723190799993,
							30.261570011000064
						],
						[
							-81.57696099299996,
							30.26184816400007
						],
						[
							-81.57627178699994,
							30.261995865000078
						],
						[
							-81.57588797499994,
							30.26290705900004
						],
						[
							-81.57451390799991,
							30.263931011000068
						],
						[
							-81.57397573499992,
							30.264465946000087
						],
						[
							-81.57399907999991,
							30.264944074000084
						],
						[
							-81.57358290699995,
							30.26536501100009
						],
						[
							-81.57300690799991,
							30.265967011000043
						],
						[
							-81.57270590799995,
							30.266260011000046
						],
						[
							-81.57225790799993,
							30.266752010000065
						],
						[
							-81.57210590699992,
							30.266959011000043
						],
						[
							-81.57183690799991,
							30.267318011000043
						],
						[
							-81.57169890699993,
							30.267543011000043
						],
						[
							-81.57156690799991,
							30.26779901000009
						],
						[
							-81.57146290699991,
							30.268042010000045
						],
						[
							-81.57132590799995,
							30.26839501000006
						],
						[
							-81.5712549079999,
							30.268631011000082
						],
						[
							-81.57116790799995,
							30.269003011000052
						],
						[
							-81.57108691999991,
							30.26945902400007
						],
						[
							-81.56884990899994,
							30.26948501200007
						],
						[
							-81.56604990999995,
							30.269532012000067
						],
						[
							-81.56591290999995,
							30.269534013000055
						],
						[
							-81.56405990899992,
							30.26955901200006
						],
						[
							-81.56134690999994,
							30.269586012000048
						],
						[
							-81.56078590999994,
							30.269591013000085
						],
						[
							-81.55943890999993,
							30.269623012000064
						],
						[
							-81.55904581499993,
							30.269635024000085
						],
						[
							-81.55895890699992,
							30.268893011000042
						],
						[
							-81.55883290799994,
							30.26813001000005
						],
						[
							-81.55875090799992,
							30.267619011000082
						],
						[
							-81.55854790699993,
							30.266573011000048
						],
						[
							-81.55843590799992,
							30.266057011000044
						],
						[
							-81.55825190699994,
							30.265315011000045
						],
						[
							-81.5581779069999,
							30.26503301000008
						],
						[
							-81.55811290699995,
							30.264811011000067
						],
						[
							-81.55807790699993,
							30.264680011000053
						],
						[
							-81.55800190699995,
							30.264401011000075
						],
						[
							-81.55786690699995,
							30.263996011000074
						],
						[
							-81.55747890799995,
							30.262791010000058
						],
						[
							-81.55695090799992,
							30.261427011000084
						],
						[
							-81.5563559069999,
							30.260136010000057
						],
						[
							-81.55625190799992,
							30.259951011000055
						],
						[
							-81.5547579069999,
							30.256822010000064
						],
						[
							-81.55470790799991,
							30.256719011000087
						],
						[
							-81.55440290799993,
							30.256034011000057
						],
						[
							-81.55411490699993,
							30.25530001000004
						],
						[
							-81.55386590699993,
							30.25457201100005
						],
						[
							-81.55377090799995,
							30.254291010000088
						],
						[
							-81.55334890799993,
							30.253032010000084
						],
						[
							-81.55318690799993,
							30.25247101000008
						],
						[
							-81.55301490799991,
							30.25181901100007
						],
						[
							-81.5528619079999,
							30.25113401100009
						],
						[
							-81.5527529069999,
							30.250596010000038
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Secret Cove",
				"RegionID": "269176"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.81544908899991,
					30.203915024000086,
					-81.7722288999999,
					30.22653900900008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.77665490799991,
							30.211332011000078
						],
						[
							-81.7722288999999,
							30.203915024000086
						],
						[
							-81.80352967699991,
							30.203938082000032
						],
						[
							-81.80443582899994,
							30.204585333000065
						],
						[
							-81.80443552199995,
							30.20730365300005
						],
						[
							-81.8066361679999,
							30.20743283000007
						],
						[
							-81.8067653249999,
							30.21183383800007
						],
						[
							-81.81038969499991,
							30.212221856000042
						],
						[
							-81.81284902999994,
							30.214810621000087
						],
						[
							-81.81284868799992,
							30.21610509600003
						],
						[
							-81.81544908899991,
							30.218631019000046
						],
						[
							-81.8147029079999,
							30.21919901100006
						],
						[
							-81.81117690699995,
							30.221930011000037
						],
						[
							-81.80956990699991,
							30.223188010000058
						],
						[
							-81.80925590699991,
							30.223432011000057
						],
						[
							-81.80908090799994,
							30.22357901000004
						],
						[
							-81.8087579079999,
							30.22385101100008
						],
						[
							-81.80862290799992,
							30.224009011000078
						],
						[
							-81.80858490799994,
							30.224075011000085
						],
						[
							-81.80850790799991,
							30.224265010000067
						],
						[
							-81.8084869079999,
							30.224348010000085
						],
						[
							-81.8082229119999,
							30.226343024000073
						],
						[
							-81.79814490799993,
							30.226538010000066
						],
						[
							-81.79809390899993,
							30.22653900900008
						],
						[
							-81.79348596199992,
							30.225478010000074
						],
						[
							-81.7814718219999,
							30.21916511200004
						],
						[
							-81.7810209079999,
							30.218533011000094
						],
						[
							-81.77665490799991,
							30.211332011000078
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Settlers Landing",
				"RegionID": "269177"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.11628630599989,
					26.11989154800007,
					-80.10708613499993,
					26.129241746000105
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.11295683499993,
							26.1292051780001
						],
						[
							-80.11299718299989,
							26.128979228000055
						],
						[
							-80.11257554399991,
							26.128529480000147
						],
						[
							-80.11181659499991,
							26.128107841000165
						],
						[
							-80.11097331799995,
							26.128023514000027
						],
						[
							-80.11024205999975,
							26.128138721000056
						],
						[
							-80.10875524299992,
							26.127858900000085
						],
						[
							-80.1078531929998,
							26.12737700100009
						],
						[
							-80.1072628989999,
							26.12687103500015
						],
						[
							-80.10708613499993,
							26.12622910500015
						],
						[
							-80.10711220999968,
							26.126128659000187
						],
						[
							-80.10717420999976,
							26.12594965900012
						],
						[
							-80.10720065299981,
							26.125882228000137
						],
						[
							-80.10735835299971,
							26.125523322000106
						],
						[
							-80.10743391299984,
							26.125069170000188
						],
						[
							-80.10752102899994,
							26.124499948000164
						],
						[
							-80.10753561599982,
							26.124425687000148
						],
						[
							-80.10755639399984,
							26.12435291500017
						],
						[
							-80.10758321799993,
							26.124282147000173
						],
						[
							-80.1076158969997,
							26.12421388600012
						],
						[
							-80.1079358969998,
							26.12361188600005
						],
						[
							-80.10796510699991,
							26.12356101000028
						],
						[
							-80.10828867999986,
							26.123037746000154
						],
						[
							-80.10847660499978,
							26.122640828000172
						],
						[
							-80.1085650759999,
							26.12241391800005
						],
						[
							-80.10882339399987,
							26.121765913000168
						],
						[
							-80.10889832899986,
							26.121581390000088
						],
						[
							-80.10926291599992,
							26.120537018000007
						],
						[
							-80.1093354239997,
							26.120382118000514
						],
						[
							-80.10944230099975,
							26.120204572000212
						],
						[
							-80.10943734099988,
							26.120184165000033
						],
						[
							-80.10942367799963,
							26.12002800000017
						],
						[
							-80.1094356159999,
							26.11989154800007
						],
						[
							-80.11032358399983,
							26.12002987050019
						],
						[
							-80.11045800199986,
							26.120052258000044
						],
						[
							-80.11064895499993,
							26.120082275000133
						],
						[
							-80.11082343999989,
							26.12010321300009
						],
						[
							-80.11098938699986,
							26.120124585000077
						],
						[
							-80.11114931899995,
							26.120145909000065
						],
						[
							-80.11134898499995,
							26.12016584200003
						],
						[
							-80.11149999999992,
							26.120180000000133
						],
						[
							-80.11155756199979,
							26.120180000000133
						],
						[
							-80.11164922699992,
							26.120180000000133
						],
						[
							-80.11184102499989,
							26.120177851000044
						],
						[
							-80.11210721199988,
							26.120172187000108
						],
						[
							-80.11243241399988,
							26.120165268000157
						],
						[
							-80.11267999999986,
							26.120160000000077
						],
						[
							-80.11283258299996,
							26.120156979000093
						],
						[
							-80.11301567599992,
							26.12015335300015
						],
						[
							-80.11318260499986,
							26.120150047000052
						],
						[
							-80.11339101799989,
							26.120145920000155
						],
						[
							-80.11363258599988,
							26.120141137000203
						],
						[
							-80.11399083999987,
							26.120136765000023
						],
						[
							-80.11434921499993,
							26.120132912000145
						],
						[
							-80.11461999999996,
							26.12013000000008
						],
						[
							-80.11485746899989,
							26.120126916000185
						],
						[
							-80.11529072199994,
							26.12012128900016
						],
						[
							-80.11551675639986,
							26.120121097600197
						],
						[
							-80.11625384899988,
							26.12011365100006
						],
						[
							-80.11628499999996,
							26.128815000000145
						],
						[
							-80.11628630599989,
							26.12917977600013
						],
						[
							-80.11354191699985,
							26.129241746000105
						],
						[
							-80.11295683499993,
							26.1292051780001
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Seven Isles",
				"RegionID": "269178"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.1695499029999,
					26.096308487000044,
					-80.15902828799994,
					26.10719755000008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.15904236199992,
							26.107195552000064
						],
						[
							-80.15902828799994,
							26.10684202100009
						],
						[
							-80.15909926599994,
							26.106470425000055
						],
						[
							-80.15950511799991,
							26.105872632000057
						],
						[
							-80.15959207299994,
							26.10546095600006
						],
						[
							-80.1596792499999,
							26.10530274000007
						],
						[
							-80.15984149099995,
							26.105002294000087
						],
						[
							-80.16011790199991,
							26.10450255300009
						],
						[
							-80.16044338299992,
							26.103612232000046
						],
						[
							-80.16045840599992,
							26.10357117300009
						],
						[
							-80.1605805879999,
							26.10273793600004
						],
						[
							-80.16086801299991,
							26.10175247500007
						],
						[
							-80.16099720699992,
							26.10109450100009
						],
						[
							-80.16130566299995,
							26.100390453000045
						],
						[
							-80.16136274799993,
							26.100260261000074
						],
						[
							-80.16153018699993,
							26.099881689000085
						],
						[
							-80.16113425799995,
							26.099153537000063
						],
						[
							-80.16149894999995,
							26.09912557800004
						],
						[
							-80.16328559899995,
							26.099048463000088
						],
						[
							-80.16409479799995,
							26.098875208000038
						],
						[
							-80.1649270339999,
							26.098739955000042
						],
						[
							-80.16567814899992,
							26.09884216000006
						],
						[
							-80.16633511499992,
							26.099082690000046
						],
						[
							-80.16704323699992,
							26.09888033200008
						],
						[
							-80.16739268899994,
							26.09861682400009
						],
						[
							-80.1683621279999,
							26.097640377000065
						],
						[
							-80.1685874609999,
							26.09745610500005
						],
						[
							-80.16872266299993,
							26.097386999000037
						],
						[
							-80.1688379759999,
							26.09730598300007
						],
						[
							-80.1690410189999,
							26.096705924000048
						],
						[
							-80.1693877379999,
							26.096308487000044
						],
						[
							-80.16943972599995,
							26.099885696000058
						],
						[
							-80.16953887299991,
							26.106562608000047
						],
						[
							-80.1695499029999,
							26.10677892600006
						],
						[
							-80.16931554099995,
							26.10678794200004
						],
						[
							-80.16928449599995,
							26.10678794200004
						],
						[
							-80.16899406399995,
							26.10679895800007
						],
						[
							-80.16883983699995,
							26.10679395200009
						],
						[
							-80.1687405959999,
							26.10679207900006
						],
						[
							-80.1687336789999,
							26.10679194900007
						],
						[
							-80.1685994799999,
							26.106783937000046
						],
						[
							-80.1685063409999,
							26.10678794200004
						],
						[
							-80.16837314499992,
							26.10679395200009
						],
						[
							-80.1678283359999,
							26.10679895800007
						],
						[
							-80.16755993799991,
							26.106795954000063
						],
						[
							-80.16725248199992,
							26.10679895800007
						],
						[
							-80.16691698499994,
							26.106805969000053
						],
						[
							-80.1665043719999,
							26.10683501300008
						],
						[
							-80.16608775399993,
							26.106831006000053
						],
						[
							-80.16582035899995,
							26.10683501300008
						],
						[
							-80.16553493499993,
							26.10685804600007
						],
						[
							-80.16546382999992,
							26.106859049000036
						],
						[
							-80.16516238199995,
							26.106898107000063
						],
						[
							-80.1649771079999,
							26.10693516100008
						],
						[
							-80.1643932419999,
							26.107064352000066
						],
						[
							-80.1639886339999,
							26.10712051900009
						],
						[
							-80.16387648299991,
							26.107082296000044
						],
						[
							-80.16374928699992,
							26.10710240900005
						],
						[
							-80.16358703999992,
							26.107121346000042
						],
						[
							-80.1633316679999,
							26.10712744600005
						],
						[
							-80.16281089499995,
							26.107144471000083
						],
						[
							-80.16230013699993,
							26.10715548700006
						],
						[
							-80.16146089299991,
							26.107173514000067
						],
						[
							-80.15945091099991,
							26.10719755000008
						],
						[
							-80.15916448699994,
							26.107196548000047
						],
						[
							-80.15904236199992,
							26.107195552000064
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Shady Banks",
				"RegionID": "269179"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.05463999999995,
					26.67957765500006,
					-80.04720168999995,
					26.688339640000038
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.0472412119999,
							26.682130761000053
						],
						[
							-80.0476354409999,
							26.67957765500006
						],
						[
							-80.04854527399993,
							26.679578608000046
						],
						[
							-80.04868999999991,
							26.679580000000044
						],
						[
							-80.04889784099993,
							26.67958021800007
						],
						[
							-80.04915230799992,
							26.67958728600007
						],
						[
							-80.04942684899993,
							26.679594912000084
						],
						[
							-80.04960999999992,
							26.67960000000005
						],
						[
							-80.04967462599991,
							26.679601777000073
						],
						[
							-80.0498688699999,
							26.679607117000046
						],
						[
							-80.05033096599995,
							26.679619820000084
						],
						[
							-80.0507930629999,
							26.679632524000056
						],
						[
							-80.05133545899992,
							26.67964743500005
						],
						[
							-80.05195852499992,
							26.679664564000063
						],
						[
							-80.05240686999991,
							26.679676890000053
						],
						[
							-80.0525199999999,
							26.67968000000008
						],
						[
							-80.05260113299994,
							26.679681955000035
						],
						[
							-80.05268160899993,
							26.67968389400005
						],
						[
							-80.05300302899991,
							26.679691639000055
						],
						[
							-80.05346515999992,
							26.67970277500007
						],
						[
							-80.05402099199995,
							26.679716168000084
						],
						[
							-80.05417999999992,
							26.67972000000009
						],
						[
							-80.05422853399995,
							26.67972000000009
						],
						[
							-80.05439595399992,
							26.67972000000009
						],
						[
							-80.05453419699995,
							26.679717634000042
						],
						[
							-80.05460261199994,
							26.67970623100007
						],
						[
							-80.05463999999995,
							26.679700000000082
						],
						[
							-80.0546381929999,
							26.679781309000077
						],
						[
							-80.05463649599996,
							26.679857681000048
						],
						[
							-80.05463431699992,
							26.679955740000082
						],
						[
							-80.05462789199993,
							26.68020903300004
						],
						[
							-80.05462323599994,
							26.680339393000054
						],
						[
							-80.05461999999994,
							26.680430000000058
						],
						[
							-80.05461476999994,
							26.680497992000085
						],
						[
							-80.05461242799993,
							26.680528431000084
						],
						[
							-80.05460999999991,
							26.68056000000007
						],
						[
							-80.05461172799994,
							26.680599733000065
						],
						[
							-80.0546145539999,
							26.68066474400007
						],
						[
							-80.05461929199993,
							26.680773724000062
						],
						[
							-80.05461501999991,
							26.680882138000072
						],
						[
							-80.05460910599994,
							26.680991548000065
						],
						[
							-80.05460288599994,
							26.681106614000043
						],
						[
							-80.05459999999994,
							26.68116000000009
						],
						[
							-80.05459999999994,
							26.68129466000005
						],
						[
							-80.05459999999994,
							26.681400000000053
						],
						[
							-80.05459510799994,
							26.681634838000036
						],
						[
							-80.0545899999999,
							26.681880000000035
						],
						[
							-80.05457909599994,
							26.682076274000053
						],
						[
							-80.0545699999999,
							26.682240000000036
						],
						[
							-80.0545699999999,
							26.682459833000053
						],
						[
							-80.0545699999999,
							26.68261000000007
						],
						[
							-80.0545588519999,
							26.683081920000063
						],
						[
							-80.05454636299993,
							26.683610617000056
						],
						[
							-80.05453999999992,
							26.683880000000045
						],
						[
							-80.05453388199993,
							26.684442860000047
						],
						[
							-80.0545307349999,
							26.684732388000043
						],
						[
							-80.05452999999994,
							26.684800000000052
						],
						[
							-80.05450981699994,
							26.685419912000047
						],
						[
							-80.05449191299995,
							26.685969820000082
						],
						[
							-80.05446905799994,
							26.686671782000076
						],
						[
							-80.05445999999995,
							26.68695000000008
						],
						[
							-80.05445421499991,
							26.687308663000067
						],
						[
							-80.05444999999992,
							26.68757000000005
						],
						[
							-80.05443379699994,
							26.688339640000038
						],
						[
							-80.05439351399991,
							26.68833797900004
						],
						[
							-80.05416626999994,
							26.688328099000046
						],
						[
							-80.05397999999991,
							26.68832000000009
						],
						[
							-80.05381290499992,
							26.688316287000077
						],
						[
							-80.05354370599991,
							26.688310305000073
						],
						[
							-80.05325867899995,
							26.68830397100004
						],
						[
							-80.05306873899991,
							26.688299750000056
						],
						[
							-80.05285745899994,
							26.688295055000083
						],
						[
							-80.05262999999991,
							26.688290000000052
						],
						[
							-80.05224511099993,
							26.68827963800004
						],
						[
							-80.0517804939999,
							26.688267129000053
						],
						[
							-80.05142693399995,
							26.68825761000005
						],
						[
							-80.05083044499992,
							26.688241550000043
						],
						[
							-80.05035014499992,
							26.688228619000085
						],
						[
							-80.05012318199994,
							26.68822250900007
						],
						[
							-80.04985222699992,
							26.68821521400008
						],
						[
							-80.04894531699995,
							26.68819079700006
						],
						[
							-80.04890181799993,
							26.687779181000057
						],
						[
							-80.04873144699991,
							26.687225478000073
						],
						[
							-80.04870682599994,
							26.68712536600009
						],
						[
							-80.04862746899994,
							26.686698482000054
						],
						[
							-80.04840726099991,
							26.685923166000066
						],
						[
							-80.04811683999992,
							26.685114542000065
						],
						[
							-80.04781030499993,
							26.684345298000043
						],
						[
							-80.04776396199992,
							26.684295519000045
						],
						[
							-80.0477218339999,
							26.684242126000072
						],
						[
							-80.04768420099992,
							26.68418547400006
						],
						[
							-80.04765131499994,
							26.684125941000048
						],
						[
							-80.0476233949999,
							26.684063924000043
						],
						[
							-80.04737639399991,
							26.683458924000035
						],
						[
							-80.04733627399992,
							26.683336094000083
						],
						[
							-80.04728627399993,
							26.68313509400008
						],
						[
							-80.04727931199994,
							26.683104893000063
						],
						[
							-80.04722131199992,
							26.68283189300007
						],
						[
							-80.04721020499994,
							26.68276854600009
						],
						[
							-80.04720365299994,
							26.682704567000087
						],
						[
							-80.04720168999995,
							26.68264028300007
						],
						[
							-80.04720432699992,
							26.68257602400007
						],
						[
							-80.04723332699992,
							26.682199024000056
						],
						[
							-80.0472412119999,
							26.682130761000053
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "West Palm Beach",
				"Name": "Propect-Southland Park",
				"RegionID": "269193"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.25733222447313,
					28.418267067916627,
					-81.2438462818028,
					28.436637208742994
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.24402444828864,
							28.432850556681394
						],
						[
							-81.2438462818028,
							28.418267067916627
						],
						[
							-81.24404635217599,
							28.418594530852587
						],
						[
							-81.2443588908629,
							28.419011098615186
						],
						[
							-81.24457721477526,
							28.419256462443016
						],
						[
							-81.24487565838803,
							28.419584948807525
						],
						[
							-81.24526223016368,
							28.41991744255091
						],
						[
							-81.24573392906468,
							28.420256945610177
						],
						[
							-81.24629275878043,
							28.420699602704886
						],
						[
							-81.24722514168616,
							28.42144170255908
						],
						[
							-81.24887759285505,
							28.422752647878397
						],
						[
							-81.2496847640539,
							28.42338263105389
						],
						[
							-81.24980897391602,
							28.423483731937026
						],
						[
							-81.2500152792888,
							28.423642967694228
						],
						[
							-81.25238279039641,
							28.42551474372093
						],
						[
							-81.25489050940566,
							28.42747465060856
						],
						[
							-81.25503172005132,
							28.427608849240322
						],
						[
							-81.2557377669847,
							28.428305882269044
						],
						[
							-81.25627155957517,
							28.42894894428468
						],
						[
							-81.25648687705413,
							28.42928233195424
						],
						[
							-81.256753272427,
							28.429911262922786
						],
						[
							-81.25689948959844,
							28.4303799589875
						],
						[
							-81.25693554251917,
							28.430524171570177
						],
						[
							-81.25702167058999,
							28.431220204552716
						],
						[
							-81.25706974115111,
							28.432202662608425
						],
						[
							-81.25707274668535,
							28.432275770294826
						],
						[
							-81.25707374763071,
							28.432335859395536
						],
						[
							-81.2570837624809,
							28.432868649242003
						],
						[
							-81.2570957810204,
							28.4331530706256
						],
						[
							-81.25713784231174,
							28.433441499388167
						],
						[
							-81.25716087664689,
							28.434089460910293
						],
						[
							-81.25719092119729,
							28.43474643453841
						],
						[
							-81.25718491282679,
							28.434998808581593
						],
						[
							-81.25722597407203,
							28.43548452971166
						],
						[
							-81.25724900750781,
							28.435821028135983
						],
						[
							-81.25733222447313,
							28.436637208742994
						],
						[
							-81.25156240815684,
							28.436635494635297
						],
						[
							-81.25032767228552,
							28.436635122315963
						],
						[
							-81.24407140998566,
							28.436633232840364
						],
						[
							-81.24402444828864,
							28.432850556681394
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "LaVina",
				"RegionID": "269066"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.20758216199994,
					25.811370025000087,
					-80.18774483699991,
					25.853592000000052
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.19016899999991,
							25.853105000000085
						],
						[
							-80.18971999999991,
							25.85292300000009
						],
						[
							-80.1892584869999,
							25.852971405000062
						],
						[
							-80.18916699999994,
							25.85298100000006
						],
						[
							-80.18880599999994,
							25.852952000000073
						],
						[
							-80.18862199999995,
							25.852557000000047
						],
						[
							-80.18858930499994,
							25.85253193400007
						],
						[
							-80.18870821599995,
							25.852095929000086
						],
						[
							-80.18870821599995,
							25.84622807800008
						],
						[
							-80.1883578959999,
							25.842724883000074
						],
						[
							-80.18844547599991,
							25.83930926800008
						],
						[
							-80.1880951569999,
							25.833704156000067
						],
						[
							-80.18774483699991,
							25.825471647000086
						],
						[
							-80.1909019169999,
							25.811370025000087
						],
						[
							-80.20047273499995,
							25.81137263900007
						],
						[
							-80.20589124199995,
							25.812268339000074
						],
						[
							-80.20647285899992,
							25.82757275000006
						],
						[
							-80.20577259499993,
							25.82957270500009
						],
						[
							-80.20617272599992,
							25.835881819000065
						],
						[
							-80.20627272799993,
							25.84326363500009
						],
						[
							-80.20707272599992,
							25.846963637000044
						],
						[
							-80.20712557299993,
							25.847573871000066
						],
						[
							-80.20715454499994,
							25.847572727000056
						],
						[
							-80.2072181819999,
							25.847563584000056
						],
						[
							-80.20758216199994,
							25.847608193000042
						],
						[
							-80.20714099999992,
							25.847624000000053
						],
						[
							-80.2061589999999,
							25.847635000000082
						],
						[
							-80.20520299999993,
							25.847665000000063
						],
						[
							-80.20520299999993,
							25.847608817000037
						],
						[
							-80.20520299999993,
							25.847569000000078
						],
						[
							-80.20513799999992,
							25.847567000000087
						],
						[
							-80.20355571599993,
							25.847621960000083
						],
						[
							-80.20349699999991,
							25.847624000000053
						],
						[
							-80.20345415599992,
							25.847625539000035
						],
						[
							-80.20341783999993,
							25.847626843000057
						],
						[
							-80.20328165199993,
							25.84763173400006
						],
						[
							-80.20310882099994,
							25.847637941000073
						],
						[
							-80.20204557699992,
							25.847676127000057
						],
						[
							-80.20179070699993,
							25.847685281000054
						],
						[
							-80.20171499999992,
							25.847688000000062
						],
						[
							-80.20171499999992,
							25.847778000000066
						],
						[
							-80.20168999999993,
							25.847778000000066
						],
						[
							-80.2014749999999,
							25.847784000000047
						],
						[
							-80.20118599999995,
							25.84779700000007
						],
						[
							-80.20060753399991,
							25.847816582000064
						],
						[
							-80.20047699999992,
							25.847821000000067
						],
						[
							-80.20041697199991,
							25.847848620000036
						],
						[
							-80.19982499999992,
							25.84812100000005
						],
						[
							-80.19955099999993,
							25.84811200000007
						],
						[
							-80.1992249999999,
							25.848123000000044
						],
						[
							-80.19891199999995,
							25.848159000000066
						],
						[
							-80.19863199999992,
							25.84818800000005
						],
						[
							-80.19835799999993,
							25.848186000000055
						],
						[
							-80.1980769999999,
							25.848179000000073
						],
						[
							-80.19792999999993,
							25.84787900000009
						],
						[
							-80.1969279999999,
							25.847903000000088
						],
						[
							-80.1969519999999,
							25.848592000000053
						],
						[
							-80.19697984699992,
							25.849685006000072
						],
						[
							-80.19697999999994,
							25.849691000000064
						],
						[
							-80.19701199999992,
							25.850609000000077
						],
						[
							-80.19702799999993,
							25.851130000000072
						],
						[
							-80.19705899999991,
							25.85182000000009
						],
						[
							-80.19706008599991,
							25.851845601000036
						],
						[
							-80.19707999999991,
							25.85231500000009
						],
						[
							-80.1970869999999,
							25.852546000000075
						],
						[
							-80.19709599999993,
							25.852928000000077
						],
						[
							-80.19709691399993,
							25.85297234500007
						],
						[
							-80.19709799999993,
							25.85302500000006
						],
						[
							-80.19658099999992,
							25.853038000000083
						],
						[
							-80.19622056299994,
							25.853047175000086
						],
						[
							-80.19548099999992,
							25.85306600000007
						],
						[
							-80.19507699999991,
							25.853076000000048
						],
						[
							-80.19443499999994,
							25.853243000000077
						],
						[
							-80.19396199999994,
							25.853387000000055
						],
						[
							-80.19380199999995,
							25.853435000000047
						],
						[
							-80.19312265799994,
							25.853507973000035
						],
						[
							-80.19301999999993,
							25.853519000000063
						],
						[
							-80.1927189999999,
							25.853563000000065
						],
						[
							-80.19246785299993,
							25.853574879000064
						],
						[
							-80.19227499999994,
							25.85358400000007
						],
						[
							-80.19210999999991,
							25.853592000000052
						],
						[
							-80.19146799999993,
							25.85351200000008
						],
						[
							-80.19087499999995,
							25.853374000000088
						],
						[
							-80.1904352059999,
							25.853206430000057
						],
						[
							-80.19016899999991,
							25.853105000000085
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami",
				"Name": "Little Haiti",
				"RegionID": "269071"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.4426029999999,
					28.536317916000087,
					-81.43051999999994,
					28.54823900000008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.43776964299991,
							28.54724733200004
						],
						[
							-81.43759899999992,
							28.54675100000009
						],
						[
							-81.43749999999994,
							28.54678000000007
						],
						[
							-81.43740099999991,
							28.546535000000063
						],
						[
							-81.4373569999999,
							28.546408000000042
						],
						[
							-81.43708790999995,
							28.546519877000037
						],
						[
							-81.43698899999993,
							28.546561000000054
						],
						[
							-81.43698520299995,
							28.546458490000077
						],
						[
							-81.43695599999995,
							28.545670000000086
						],
						[
							-81.43620499999992,
							28.545663000000047
						],
						[
							-81.43620499999992,
							28.545375000000035
						],
						[
							-81.4355799999999,
							28.545374000000038
						],
						[
							-81.43557699999991,
							28.546887000000083
						],
						[
							-81.4352209999999,
							28.546995000000038
						],
						[
							-81.4352209999999,
							28.546661000000086
						],
						[
							-81.4348619999999,
							28.546661000000086
						],
						[
							-81.4348599999999,
							28.545764000000077
						],
						[
							-81.4347229999999,
							28.545764000000077
						],
						[
							-81.43461402599992,
							28.545764000000077
						],
						[
							-81.43458599999991,
							28.545764000000077
						],
						[
							-81.43270099999995,
							28.545754000000045
						],
						[
							-81.43272899999994,
							28.547389000000067
						],
						[
							-81.4317079999999,
							28.54688100000004
						],
						[
							-81.43170539499994,
							28.546210802000076
						],
						[
							-81.43170199999992,
							28.545337000000075
						],
						[
							-81.43162915699992,
							28.545337678000067
						],
						[
							-81.43051999999994,
							28.545348000000047
						],
						[
							-81.43055399999992,
							28.544841000000076
						],
						[
							-81.43284915899994,
							28.54486322400004
						],
						[
							-81.43354899999991,
							28.54487000000006
						],
						[
							-81.43356409199993,
							28.54518495700006
						],
						[
							-81.43357199999991,
							28.54535000000004
						],
						[
							-81.43446099999994,
							28.54537300000004
						],
						[
							-81.4344611219999,
							28.545169886000053
						],
						[
							-81.43446199999994,
							28.543709000000035
						],
						[
							-81.4343189999999,
							28.543719000000067
						],
						[
							-81.4317539999999,
							28.543719000000067
						],
						[
							-81.4305609999999,
							28.543683000000048
						],
						[
							-81.43055998899992,
							28.543545514000073
						],
						[
							-81.4305579999999,
							28.54327500000005
						],
						[
							-81.43057199999993,
							28.54253600000004
						],
						[
							-81.43054499999994,
							28.542118000000073
						],
						[
							-81.43257199999994,
							28.542118000000073
						],
						[
							-81.43257199999994,
							28.54188000000005
						],
						[
							-81.4344789999999,
							28.541878000000057
						],
						[
							-81.43447999999995,
							28.541770000000042
						],
						[
							-81.43447999999995,
							28.541506000000084
						],
						[
							-81.43447999999995,
							28.54123300000009
						],
						[
							-81.43436983099991,
							28.54123300000009
						],
						[
							-81.4326099999999,
							28.54123300000009
						],
						[
							-81.43261299999995,
							28.540437000000054
						],
						[
							-81.4326901899999,
							28.540435913000067
						],
						[
							-81.43275499999993,
							28.54043500000006
						],
						[
							-81.43459299999995,
							28.540429000000074
						],
						[
							-81.43459299999995,
							28.540329000000042
						],
						[
							-81.43450199999995,
							28.540329000000042
						],
						[
							-81.43450199999995,
							28.540294000000074
						],
						[
							-81.43450199999995,
							28.54007900000005
						],
						[
							-81.43450199999995,
							28.53987900000004
						],
						[
							-81.4344989999999,
							28.53954800000008
						],
						[
							-81.4344989999999,
							28.539479000000085
						],
						[
							-81.43434637999991,
							28.539479000000085
						],
						[
							-81.43289299999992,
							28.539479000000085
						],
						[
							-81.43261799999993,
							28.539480000000083
						],
						[
							-81.43261799999993,
							28.539213000000075
						],
						[
							-81.43269953599992,
							28.53921304300008
						],
						[
							-81.4344989999999,
							28.539214000000072
						],
						[
							-81.4344989999999,
							28.53839400000004
						],
						[
							-81.4344979999999,
							28.53811500000006
						],
						[
							-81.43449599999991,
							28.538076000000046
						],
						[
							-81.4344208899999,
							28.538076096000054
						],
						[
							-81.43441715999995,
							28.53769819200005
						],
						[
							-81.43440466899996,
							28.53694245300005
						],
						[
							-81.43439999999993,
							28.536449385000083
						],
						[
							-81.43439999999993,
							28.536317916000087
						],
						[
							-81.43458099999992,
							28.536326000000088
						],
						[
							-81.43649299999993,
							28.53632900000008
						],
						[
							-81.43701599999991,
							28.536332000000073
						],
						[
							-81.43828599999995,
							28.536334000000068
						],
						[
							-81.43833499999994,
							28.536334000000068
						],
						[
							-81.43831799999992,
							28.537862000000075
						],
						[
							-81.43831299999994,
							28.538248000000067
						],
						[
							-81.43926799999991,
							28.538248000000067
						],
						[
							-81.4424929999999,
							28.538280000000043
						],
						[
							-81.4424929999999,
							28.53987900000004
						],
						[
							-81.4424929999999,
							28.54025900000005
						],
						[
							-81.44211799999994,
							28.54025900000005
						],
						[
							-81.44211799999994,
							28.53987900000004
						],
						[
							-81.44211799999994,
							28.539697000000047
						],
						[
							-81.44129499999991,
							28.53973700000006
						],
						[
							-81.44129084799994,
							28.539939605000086
						],
						[
							-81.44128999999992,
							28.53998100000007
						],
						[
							-81.44090399999993,
							28.539998000000082
						],
						[
							-81.44089799999995,
							28.540279000000055
						],
						[
							-81.44129299999992,
							28.540279000000055
						],
						[
							-81.44129299999992,
							28.540579000000037
						],
						[
							-81.44129299999992,
							28.541634731000045
						],
						[
							-81.44129299999992,
							28.541979000000083
						],
						[
							-81.44055012799993,
							28.541979000000083
						],
						[
							-81.44049299999995,
							28.541979000000083
						],
						[
							-81.44027699999992,
							28.541972000000047
						],
						[
							-81.44017799999995,
							28.54196900000005
						],
						[
							-81.44017799999995,
							28.54278700000009
						],
						[
							-81.44017799999995,
							28.542853000000036
						],
						[
							-81.44212499999992,
							28.542818000000068
						],
						[
							-81.44213465199994,
							28.543016829000067
						],
						[
							-81.44214499999993,
							28.54323000000005
						],
						[
							-81.44245799999993,
							28.54321500000009
						],
						[
							-81.44245599999994,
							28.54512800000009
						],
						[
							-81.4420889999999,
							28.54519600000009
						],
						[
							-81.44194099999993,
							28.54524500000008
						],
						[
							-81.44194099999993,
							28.544967000000042
						],
						[
							-81.4414119999999,
							28.54497900000007
						],
						[
							-81.4414119999999,
							28.544632000000036
						],
						[
							-81.44138399999991,
							28.544292000000045
						],
						[
							-81.44024399999996,
							28.54428400000006
						],
						[
							-81.4401739999999,
							28.54428400000006
						],
						[
							-81.44017899999994,
							28.54348500000009
						],
						[
							-81.43878199999995,
							28.54348500000009
						],
						[
							-81.43823299999993,
							28.54348500000009
						],
						[
							-81.43814399999991,
							28.54348500000009
						],
						[
							-81.43814999999995,
							28.543716000000074
						],
						[
							-81.43814299999991,
							28.544188000000076
						],
						[
							-81.43814299999991,
							28.545377000000087
						],
						[
							-81.43815499999994,
							28.54627000000005
						],
						[
							-81.4382379999999,
							28.54624000000007
						],
						[
							-81.4382829999999,
							28.54636700000009
						],
						[
							-81.43872499999992,
							28.54620900000009
						],
						[
							-81.43923999999993,
							28.546137000000044
						],
						[
							-81.43941199999995,
							28.54611200000005
						],
						[
							-81.43980699999992,
							28.546011000000078
						],
						[
							-81.44027599999993,
							28.545851000000084
						],
						[
							-81.44072999999992,
							28.54574000000008
						],
						[
							-81.4407799999999,
							28.54573600000009
						],
						[
							-81.4425829999999,
							28.545589000000064
						],
						[
							-81.4426029999999,
							28.546650000000056
						],
						[
							-81.44179299999992,
							28.546700000000044
						],
						[
							-81.44178712299993,
							28.54707951800009
						],
						[
							-81.44178599999992,
							28.547152000000043
						],
						[
							-81.4424909999999,
							28.547146000000055
						],
						[
							-81.44249360899994,
							28.54705357000006
						],
						[
							-81.44249799999994,
							28.546898000000056
						],
						[
							-81.44257599999992,
							28.54689600000006
						],
						[
							-81.44257883699994,
							28.547050440000078
						],
						[
							-81.4425829999999,
							28.547277000000065
						],
						[
							-81.44027699999992,
							28.547239000000047
						],
						[
							-81.43984699999993,
							28.547246000000086
						],
						[
							-81.43982799999992,
							28.54753500000004
						],
						[
							-81.43990999999994,
							28.547601000000043
						],
						[
							-81.43979499999995,
							28.547637000000066
						],
						[
							-81.4397679999999,
							28.54823900000008
						],
						[
							-81.43842399999994,
							28.548147000000085
						],
						[
							-81.4384409999999,
							28.547862000000066
						],
						[
							-81.43797099999995,
							28.547833000000082
						],
						[
							-81.43776964299991,
							28.54724733200004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Malibu Groves",
				"RegionID": "269080"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.62221495499995,
					30.230908832000072,
					-81.58107177199992,
					30.26932709900007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.6098689069999,
							30.26601301000005
						],
						[
							-81.60956597199993,
							30.26559683100004
						],
						[
							-81.60599433999994,
							30.26655920500008
						],
						[
							-81.6048979979999,
							30.265371265000056
						],
						[
							-81.60371023199991,
							30.264457597000046
						],
						[
							-81.60188290399992,
							30.263269831000063
						],
						[
							-81.59987288399992,
							30.26189921000008
						],
						[
							-81.5971887959999,
							30.261309869000062
						],
						[
							-81.59717990799993,
							30.261565011000076
						],
						[
							-81.59715690699994,
							30.261783010000048
						],
						[
							-81.59699890699994,
							30.262569011000036
						],
						[
							-81.59682290699993,
							30.263567011000077
						],
						[
							-81.59666902399994,
							30.264330156000085
						],
						[
							-81.5959769079999,
							30.264302011000037
						],
						[
							-81.59583490799992,
							30.264302011000037
						],
						[
							-81.5943789079999,
							30.26424301100008
						],
						[
							-81.59305990699994,
							30.264206011000052
						],
						[
							-81.59253779199992,
							30.26418286300009
						],
						[
							-81.5924889069999,
							30.26439901100008
						],
						[
							-81.59244690799994,
							30.26462201000004
						],
						[
							-81.59240790699994,
							30.264937011000086
						],
						[
							-81.59231802099993,
							30.265433160000043
						],
						[
							-81.59209778799993,
							30.265409867000074
						],
						[
							-81.59203100199996,
							30.266397948000076
						],
						[
							-81.58850912299994,
							30.263150485000043
						],
						[
							-81.58394079699991,
							30.259581479000076
						],
						[
							-81.58107177199992,
							30.257608982000082
						],
						[
							-81.58132290799995,
							30.257351010000036
						],
						[
							-81.5818119079999,
							30.25684901100004
						],
						[
							-81.58250090699994,
							30.256084010000052
						],
						[
							-81.5830279079999,
							30.255535010000077
						],
						[
							-81.58370490699991,
							30.254841010000067
						],
						[
							-81.58381190699993,
							30.254685007000035
						],
						[
							-81.58385390799992,
							30.254574010000056
						],
						[
							-81.58391290799995,
							30.25435101000005
						],
						[
							-81.58397590899995,
							30.253895009000075
						],
						[
							-81.58401890599993,
							30.253764011000044
						],
						[
							-81.58405990799992,
							30.253457011000084
						],
						[
							-81.58411290799995,
							30.253058011000064
						],
						[
							-81.5841839069999,
							30.252671010000086
						],
						[
							-81.58421290799993,
							30.25236501100005
						],
						[
							-81.58427290799995,
							30.251749010000086
						],
						[
							-81.58428991199992,
							30.251601921000084
						],
						[
							-81.58468590699994,
							30.251641011000064
						],
						[
							-81.58492690799994,
							30.25166401100006
						],
						[
							-81.5850279089999,
							30.25167601000004
						],
						[
							-81.58525190699993,
							30.251719011000034
						],
						[
							-81.58560290799994,
							30.251756011000055
						],
						[
							-81.58631090699993,
							30.251787010000047
						],
						[
							-81.58652190799995,
							30.251780011000054
						],
						[
							-81.5869469079999,
							30.25175801100005
						],
						[
							-81.5873339069999,
							30.251725010000087
						],
						[
							-81.58751990699994,
							30.25169701100009
						],
						[
							-81.5878239079999,
							30.251626010000052
						],
						[
							-81.58809890799995,
							30.25157200900009
						],
						[
							-81.58826890799993,
							30.25152901100006
						],
						[
							-81.58858890699992,
							30.251433010000085
						],
						[
							-81.58884690699995,
							30.251338010000037
						],
						[
							-81.58906190699992,
							30.251249011000084
						],
						[
							-81.58930090799994,
							30.251142010000084
						],
						[
							-81.5895119079999,
							30.251038010000062
						],
						[
							-81.58961390799993,
							30.250981011000082
						],
						[
							-81.58981690799995,
							30.25087201000008
						],
						[
							-81.59008890699994,
							30.250704011000042
						],
						[
							-81.59014090799991,
							30.250666011000078
						],
						[
							-81.59018690699992,
							30.25063501000005
						],
						[
							-81.59042890799994,
							30.25048401000004
						],
						[
							-81.59078190799994,
							30.25025301100004
						],
						[
							-81.59117390799992,
							30.25000801100003
						],
						[
							-81.59133490799991,
							30.24991701000005
						],
						[
							-81.5920349079999,
							30.249478010000075
						],
						[
							-81.59241390699992,
							30.249219011000037
						],
						[
							-81.59286390699992,
							30.248929011000087
						],
						[
							-81.59308090699994,
							30.24879001100004
						],
						[
							-81.59333190699994,
							30.248615011000084
						],
						[
							-81.59340390699992,
							30.248574010000084
						],
						[
							-81.59346190699995,
							30.24853501000007
						],
						[
							-81.59356708799993,
							30.248464033000065
						],
						[
							-81.59349686199994,
							30.248390095000047
						],
						[
							-81.6006037709999,
							30.244548828000063
						],
						[
							-81.60416724099991,
							30.24263016500004
						],
						[
							-81.59941600499991,
							30.236325837000038
						],
						[
							-81.5962584639999,
							30.231639023000074
						],
						[
							-81.59761795799994,
							30.230908832000072
						],
						[
							-81.59770990599992,
							30.23109200900007
						],
						[
							-81.59781590599994,
							30.231272008000076
						],
						[
							-81.5979389069999,
							30.231419007000053
						],
						[
							-81.59806090599994,
							30.23153100800005
						],
						[
							-81.59825090099991,
							30.23168212800005
						],
						[
							-81.59830290499991,
							30.231709008000053
						],
						[
							-81.59856390599992,
							30.23183300800008
						],
						[
							-81.59880790599993,
							30.231911008000058
						],
						[
							-81.59887690599993,
							30.231924007000092
						],
						[
							-81.59982290499994,
							30.232162008000046
						],
						[
							-81.60037190499992,
							30.232296008000045
						],
						[
							-81.60096690599994,
							30.23244500900006
						],
						[
							-81.60144790599992,
							30.232573009000077
						],
						[
							-81.60292790499994,
							30.232924009000048
						],
						[
							-81.60345490499992,
							30.233067009000084
						],
						[
							-81.6041159049999,
							30.233214008000065
						],
						[
							-81.60453990499991,
							30.233362009000075
						],
						[
							-81.60466990499992,
							30.23343300900007
						],
						[
							-81.60500790499992,
							30.23367800900007
						],
						[
							-81.60513690599993,
							30.233798508000064
						],
						[
							-81.60520790299995,
							30.233862008000074
						],
						[
							-81.6052879049999,
							30.23396900800009
						],
						[
							-81.60538990499992,
							30.234138009000052
						],
						[
							-81.6054379059999,
							30.234255009000037
						],
						[
							-81.6055069059999,
							30.23442300800008
						],
						[
							-81.60581990599991,
							30.235146008000076
						],
						[
							-81.60594190599994,
							30.235462009000056
						],
						[
							-81.60608690499993,
							30.235777009000063
						],
						[
							-81.60676590599991,
							30.237354009000057
						],
						[
							-81.60703290599992,
							30.238005009000062
						],
						[
							-81.60716990599991,
							30.238298008000072
						],
						[
							-81.6074219059999,
							30.23876000900009
						],
						[
							-81.60752890499992,
							30.238930008000068
						],
						[
							-81.60760490599995,
							30.239086008000076
						],
						[
							-81.60770390599993,
							30.239244009000064
						],
						[
							-81.60795585299991,
							30.239702023000067
						],
						[
							-81.60803998499995,
							30.23985298700006
						],
						[
							-81.60803985399991,
							30.240011017000086
						],
						[
							-81.60834090599991,
							30.24102400900006
						],
						[
							-81.60841890599994,
							30.24131300900007
						],
						[
							-81.60860490499994,
							30.241920009000072
						],
						[
							-81.60866790599994,
							30.24213700900009
						],
						[
							-81.60880990499994,
							30.24263000800005
						],
						[
							-81.60901490499992,
							30.24331100900008
						],
						[
							-81.60912290599993,
							30.243582008000093
						],
						[
							-81.60919690599991,
							30.24371700900008
						],
						[
							-81.60926090599992,
							30.243835008000076
						],
						[
							-81.60944190499993,
							30.244085009000056
						],
						[
							-81.60995090499995,
							30.24481700800004
						],
						[
							-81.61059590499991,
							30.245724009000075
						],
						[
							-81.6111339059999,
							30.246493009000062
						],
						[
							-81.61144590599991,
							30.246920009000064
						],
						[
							-81.61168590599993,
							30.24725500800008
						],
						[
							-81.61236090599994,
							30.248200009000076
						],
						[
							-81.61294690599993,
							30.24902000900005
						],
						[
							-81.61315890599991,
							30.249317009000038
						],
						[
							-81.61360390599992,
							30.249958009000068
						],
						[
							-81.61405390599992,
							30.25058400800009
						],
						[
							-81.61512990599994,
							30.25207800800007
						],
						[
							-81.61527290499993,
							30.25227700800008
						],
						[
							-81.61577590599991,
							30.252985009000046
						],
						[
							-81.61639390499994,
							30.253832009000067
						],
						[
							-81.61664590599992,
							30.254253009000085
						],
						[
							-81.61675290599993,
							30.254477009000087
						],
						[
							-81.61685190499992,
							30.25472800800009
						],
						[
							-81.6170579059999,
							30.255306009000037
						],
						[
							-81.61780490699994,
							30.25748400700007
						],
						[
							-81.61792790599992,
							30.25772100800009
						],
						[
							-81.61825590599996,
							30.258184008000057
						],
						[
							-81.6186139049999,
							30.258715008000085
						],
						[
							-81.6189729059999,
							30.25920300800004
						],
						[
							-81.61914090499994,
							30.259453008000037
						],
						[
							-81.61993390499993,
							30.26056100800008
						],
						[
							-81.62044490499994,
							30.261299009000084
						],
						[
							-81.62067390599992,
							30.261602008000068
						],
						[
							-81.62110090499993,
							30.26220900900006
						],
						[
							-81.62144490599992,
							30.262741009000077
						],
						[
							-81.62181890599993,
							30.26324100800008
						],
						[
							-81.62213890599992,
							30.263693009000065
						],
						[
							-81.62221495499995,
							30.26378808500004
						],
						[
							-81.6220309059999,
							30.263913008000088
						],
						[
							-81.62096390599993,
							30.26458700800004
						],
						[
							-81.62049090599993,
							30.264890008000066
						],
						[
							-81.6198428649999,
							30.265300927000055
						],
						[
							-81.61896890499992,
							30.265867009000093
						],
						[
							-81.61847190599991,
							30.266142009000077
						],
						[
							-81.6183859329999,
							30.266205054000068
						],
						[
							-81.61827790499991,
							30.266247009000043
						],
						[
							-81.61801990599992,
							30.26635000900006
						],
						[
							-81.6166119049999,
							30.267070009000065
						],
						[
							-81.61515390599993,
							30.267852009000077
						],
						[
							-81.61468890499992,
							30.268089009000047
						],
						[
							-81.61417190599991,
							30.268344008000042
						],
						[
							-81.61370990499995,
							30.26858400800006
						],
						[
							-81.61296090599991,
							30.26897200800005
						],
						[
							-81.61259390599992,
							30.269146008000064
						],
						[
							-81.61222692899992,
							30.26932709900007
						],
						[
							-81.61200590699991,
							30.269016010000087
						],
						[
							-81.61174090799994,
							30.268665010000067
						],
						[
							-81.61022190799991,
							30.266526011000053
						],
						[
							-81.6098689069999,
							30.26601301000005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Southpoint",
				"RegionID": "269194"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.6653203219999,
					30.30436886000007,
					-81.63710490699992,
					30.321313924000037
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.65869249899993,
							30.321299372000055
						],
						[
							-81.6586345639999,
							30.321284088000088
						],
						[
							-81.65807517499991,
							30.321287307000034
						],
						[
							-81.65794616499994,
							30.321278755000037
						],
						[
							-81.65649316499993,
							30.321076756000082
						],
						[
							-81.65646083399992,
							30.321071660000083
						],
						[
							-81.65633685699993,
							30.321040576000087
						],
						[
							-81.65615229399992,
							30.320980074000094
						],
						[
							-81.65538276099994,
							30.320946466000066
						],
						[
							-81.65526583399992,
							30.320933659000048
						],
						[
							-81.65511441299992,
							30.320893086000073
						],
						[
							-81.65497233899993,
							30.320826836000037
						],
						[
							-81.65484392699994,
							30.32073692100005
						],
						[
							-81.65473307899993,
							30.32062607300008
						],
						[
							-81.65464316399994,
							30.320497661000044
						],
						[
							-81.65458876299994,
							30.320380998000076
						],
						[
							-81.65422525799994,
							30.320305560000065
						],
						[
							-81.65410041299992,
							30.32027008600005
						],
						[
							-81.65395833899993,
							30.320203836000076
						],
						[
							-81.65382992699995,
							30.320113921000086
						],
						[
							-81.65371907899993,
							30.32000307300007
						],
						[
							-81.65362916399994,
							30.31987466100009
						],
						[
							-81.65356291299992,
							30.319732586000043
						],
						[
							-81.65352233999994,
							30.31958116600003
						],
						[
							-81.65351273899995,
							30.31947142300004
						],
						[
							-81.6534273389999,
							30.31942983500005
						],
						[
							-81.65330829099992,
							30.31934767000007
						],
						[
							-81.6528136089999,
							30.318943796000045
						],
						[
							-81.65272080999995,
							30.31885180400008
						],
						[
							-81.6516575409999,
							30.31881002400007
						],
						[
							-81.65126105699994,
							30.318893865000067
						],
						[
							-81.65118715799991,
							30.318906301000084
						],
						[
							-81.65111247999994,
							30.31891254100009
						],
						[
							-81.65103754199993,
							30.31891254200008
						],
						[
							-81.6509628629999,
							30.318906303000063
						],
						[
							-81.65088896399993,
							30.318893870000068
						],
						[
							-81.65081635599995,
							30.318875326000068
						],
						[
							-81.64591435599995,
							30.31740332700008
						],
						[
							-81.6458654139999,
							30.317387087000043
						],
						[
							-81.64572333899991,
							30.317320836000082
						],
						[
							-81.64559492699993,
							30.31723092100009
						],
						[
							-81.6454840799999,
							30.31712007300007
						],
						[
							-81.64545720099994,
							30.31708643700006
						],
						[
							-81.64438189499992,
							30.31567267400004
						],
						[
							-81.64221325699992,
							30.31475318600008
						],
						[
							-81.63846462499993,
							30.31362770600009
						],
						[
							-81.63825052899995,
							30.313564045000078
						],
						[
							-81.63840899999991,
							30.31267300000008
						],
						[
							-81.63837390499992,
							30.312450009000088
						],
						[
							-81.63832090499994,
							30.31188000900005
						],
						[
							-81.6382679059999,
							30.311668009000076
						],
						[
							-81.63816090499995,
							30.311375010000067
						],
						[
							-81.6381147809999,
							30.31130405300007
						],
						[
							-81.63793190599995,
							30.310032009000057
						],
						[
							-81.63766490599994,
							30.308870008000046
						],
						[
							-81.63744690599992,
							30.308016009000088
						],
						[
							-81.63720590499992,
							30.30690100800007
						],
						[
							-81.63711590699995,
							30.306438008000047
						],
						[
							-81.63710490699992,
							30.306201007000084
						],
						[
							-81.63711877999992,
							30.306122963000064
						],
						[
							-81.63720785899994,
							30.305978958000082
						],
						[
							-81.63787490599992,
							30.306211008000044
						],
						[
							-81.63845290599994,
							30.30639600800004
						],
						[
							-81.63918390599991,
							30.306630008000074
						],
						[
							-81.64091490599992,
							30.30718400800004
						],
						[
							-81.64134690599991,
							30.307323009000072
						],
						[
							-81.6425219059999,
							30.307716008000053
						],
						[
							-81.64311599199995,
							30.307889173000035
						],
						[
							-81.64319183999993,
							30.307642835000085
						],
						[
							-81.64335590699994,
							30.307735008000066
						],
						[
							-81.6439290699999,
							30.307957912000067
						],
						[
							-81.64390390699992,
							30.308140008000066
						],
						[
							-81.64390674999993,
							30.308481115000063
						],
						[
							-81.64538600599991,
							30.309059150000053
						],
						[
							-81.6453799059999,
							30.30894900800007
						],
						[
							-81.64538090899993,
							30.30890500900006
						],
						[
							-81.64539390399995,
							30.30886900800005
						],
						[
							-81.6454009059999,
							30.308827010000073
						],
						[
							-81.64543890599992,
							30.30873700800004
						],
						[
							-81.64547990499995,
							30.308673008000085
						],
						[
							-81.64551490499991,
							30.308616010000033
						],
						[
							-81.64561690599993,
							30.308508009000036
						],
						[
							-81.64574390599995,
							30.30840600800008
						],
						[
							-81.6459259049999,
							30.308292009000073
						],
						[
							-81.64595090599994,
							30.30827800900005
						],
						[
							-81.64615490599994,
							30.30820000900008
						],
						[
							-81.64631892299991,
							30.30814693900004
						],
						[
							-81.64724574899992,
							30.309054696000093
						],
						[
							-81.64912750699995,
							30.31093645300007
						],
						[
							-81.65107290899994,
							30.312872009000046
						],
						[
							-81.65251462599991,
							30.313872126000035
						],
						[
							-81.6544717029999,
							30.31424835100006
						],
						[
							-81.65635346099992,
							30.314248352000053
						],
						[
							-81.6588909059999,
							30.314104009000065
						],
						[
							-81.65909190399992,
							30.31409700800009
						],
						[
							-81.6594509059999,
							30.31406500900005
						],
						[
							-81.65975790499995,
							30.31405600800008
						],
						[
							-81.66057204499992,
							30.314040130000084
						],
						[
							-81.66056490599993,
							30.313972009000057
						],
						[
							-81.66055890599995,
							30.313915009000088
						],
						[
							-81.66055190599991,
							30.313850009000078
						],
						[
							-81.66053690599995,
							30.313704008000062
						],
						[
							-81.66053690599995,
							30.313303008000048
						],
						[
							-81.66053790599996,
							30.312925009000082
						],
						[
							-81.66054490599993,
							30.312366008000083
						],
						[
							-81.6605379049999,
							30.312130009000043
						],
						[
							-81.66053790599996,
							30.311308008000086
						],
						[
							-81.66054490599993,
							30.310482009000054
						],
						[
							-81.6605299069999,
							30.309669008000075
						],
						[
							-81.6605379049999,
							30.30961400800004
						],
						[
							-81.66052990599991,
							30.30883000800009
						],
						[
							-81.66053990499995,
							30.30776400900004
						],
						[
							-81.66052290499994,
							30.307665012000086
						],
						[
							-81.66047590499994,
							30.307565008000044
						],
						[
							-81.66030090599992,
							30.307278009000072
						],
						[
							-81.66002690599993,
							30.30681600800006
						],
						[
							-81.65996873499995,
							30.306715051000083
						],
						[
							-81.65997507599991,
							30.306632965000063
						],
						[
							-81.6598859689999,
							30.30647882800008
						],
						[
							-81.65984284399991,
							30.306498189000084
						],
						[
							-81.6591869049999,
							30.305393008000067
						],
						[
							-81.65910290599993,
							30.305286009000042
						],
						[
							-81.6590417399999,
							30.305222964000055
						],
						[
							-81.65910390599993,
							30.305205006000055
						],
						[
							-81.65915390599991,
							30.30517400900004
						],
						[
							-81.6595459049999,
							30.305012009000055
						],
						[
							-81.65988188299991,
							30.30485292300006
						],
						[
							-81.65995789199991,
							30.304845952000047
						],
						[
							-81.66026599999994,
							30.304708000000065
						],
						[
							-81.66111341099992,
							30.30436886000007
						],
						[
							-81.66357118299995,
							30.308353747000073
						],
						[
							-81.66427438599993,
							30.309513033000087
						],
						[
							-81.66453061099992,
							30.30970135800004
						],
						[
							-81.6645855129999,
							30.309745112000083
						],
						[
							-81.6646368349999,
							30.309793015000082
						],
						[
							-81.66468426299993,
							30.309844775000045
						],
						[
							-81.66472750999992,
							30.30990007700007
						],
						[
							-81.66476631099994,
							30.30995858400007
						],
						[
							-81.6648004299999,
							30.310019939000085
						],
						[
							-81.66482965999995,
							30.310083769000073
						],
						[
							-81.66492265999995,
							30.31030976800008
						],
						[
							-81.66494711799993,
							30.310376599000055
						],
						[
							-81.6649662129999,
							30.31044515600007
						],
						[
							-81.66497982599992,
							30.310515008000042
						],
						[
							-81.66498786999995,
							30.310585718000087
						],
						[
							-81.66499029599993,
							30.31065684300006
						],
						[
							-81.66497252399995,
							30.312309271000064
						],
						[
							-81.66521809199992,
							30.313284374000087
						],
						[
							-81.66523355599992,
							30.31335900100004
						],
						[
							-81.66524264599991,
							30.313434670000053
						],
						[
							-81.66524529599991,
							30.313510836000034
						],
						[
							-81.66524148799994,
							30.313586954000073
						],
						[
							-81.66523124899993,
							30.31366247600005
						],
						[
							-81.66521465299991,
							30.313736860000066
						],
						[
							-81.66523216099995,
							30.313822347000045
						],
						[
							-81.66524450599991,
							30.31388482700004
						],
						[
							-81.66525084799991,
							30.31394819800005
						],
						[
							-81.6652511289999,
							30.31401188500007
						],
						[
							-81.66524534599995,
							30.31407531000008
						],
						[
							-81.66525076499994,
							30.31422435400009
						],
						[
							-81.6653198009999,
							30.316251390000048
						],
						[
							-81.6653203219999,
							30.31628200000006
						],
						[
							-81.66530665899995,
							30.316438166000065
						],
						[
							-81.66526608599992,
							30.316589586000077
						],
						[
							-81.66519983599994,
							30.316731661000066
						],
						[
							-81.6651376609999,
							30.31682530200004
						],
						[
							-81.66347666099995,
							30.31901630200008
						],
						[
							-81.66343578199991,
							30.31906637900005
						],
						[
							-81.6633914119999,
							30.31911338900005
						],
						[
							-81.66334377999993,
							30.319157091000083
						],
						[
							-81.66329313199992,
							30.319197259000077
						],
						[
							-81.66307745899991,
							30.31935601700007
						],
						[
							-81.66302195899993,
							30.319396949000065
						],
						[
							-81.66293005099993,
							30.319517985000065
						],
						[
							-81.66221805799995,
							30.320553522000065
						],
						[
							-81.66217355899994,
							30.320612846000078
						],
						[
							-81.66212432299994,
							30.32066830200006
						],
						[
							-81.66207068499995,
							30.320719513000082
						],
						[
							-81.66201301099994,
							30.320766130000038
						],
						[
							-81.6619516909999,
							30.320807838000068
						],
						[
							-81.66188714399993,
							30.320844351000062
						],
						[
							-81.6618198079999,
							30.32087542200009
						],
						[
							-81.66107280799991,
							30.321183422000047
						],
						[
							-81.66100347999992,
							30.321208731000073
						],
						[
							-81.6609323109999,
							30.321228270000066
						],
						[
							-81.6608597789999,
							30.321241908000047
						],
						[
							-81.66071577899993,
							30.32126290900004
						],
						[
							-81.66060723399994,
							30.32127207100007
						],
						[
							-81.65887123399995,
							30.32131307100008
						],
						[
							-81.65881132299995,
							30.321313924000037
						],
						[
							-81.65875157999994,
							30.321309345000092
						],
						[
							-81.65869249899993,
							30.321299372000055
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Southside",
				"RegionID": "269195"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.36644407856504,
					28.537304477543245,
					-81.35182627436967,
					28.545944346116976
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.35183628562248,
							28.538691590941873
						],
						[
							-81.35182627436967,
							28.538379072939467
						],
						[
							-81.35217679052649,
							28.53837412037302
						],
						[
							-81.3535808732325,
							28.538358096253123
						],
						[
							-81.35548669759127,
							28.538351139997197
						],
						[
							-81.35599645580051,
							28.53835108603787
						],
						[
							-81.35775606568578,
							28.53833205728303
						],
						[
							-81.35850016833008,
							28.53831202848219
						],
						[
							-81.3593484259553,
							28.53825394217159
						],
						[
							-81.35940551132045,
							28.53824793380116
						],
						[
							-81.3596218324427,
							28.53822990599169
						],
						[
							-81.36010254524834,
							28.53816080298624
						],
						[
							-81.36060729333461,
							28.53806566280953
						],
						[
							-81.36096882888428,
							28.537996560703355
						],
						[
							-81.3619913463404,
							28.53777022473099
						],
						[
							-81.36229079089854,
							28.537690105930068
						],
						[
							-81.36286764482637,
							28.537575936998422
						],
						[
							-81.36385010288207,
							28.537405684546464
						],
						[
							-81.36421764770154,
							28.537369630726268
						],
						[
							-81.3646032194311,
							28.53734359175627
						],
						[
							-81.36587009887042,
							28.537309541625554
						],
						[
							-81.36611145891659,
							28.537304477543245
						],
						[
							-81.36614337585537,
							28.538439349099086
						],
						[
							-81.36638399036369,
							28.538439084698403
						],
						[
							-81.36644407856504,
							28.541934526394495
						],
						[
							-81.36312889877523,
							28.541994358289045
						],
						[
							-81.36329727883881,
							28.54580219028383
						],
						[
							-81.3622387138578,
							28.54581315212007
						],
						[
							-81.36021170675495,
							28.545837188299956
						],
						[
							-81.35967390948342,
							28.54585521520997
						],
						[
							-81.3591481298522,
							28.54585621615543
						],
						[
							-81.35889976138944,
							28.54585721800017
						],
						[
							-81.3586624096215,
							28.54586022263502
						],
						[
							-81.35811359475578,
							28.545869235640474
						],
						[
							-81.35603551335628,
							28.545896275555933
						],
						[
							-81.35511514899015,
							28.54590528946058
						],
						[
							-81.35393239483143,
							28.545917307100886
						],
						[
							-81.35314422540766,
							28.54592932384182
						],
						[
							-81.35293691729078,
							28.545932329376043
						],
						[
							-81.35290487084954,
							28.545932329376043
						],
						[
							-81.35192235973389,
							28.545944346116976
						],
						[
							-81.35191039605299,
							28.545037001235883
						],
						[
							-81.35187934965784,
							28.544082585839746
						],
						[
							-81.35185731716743,
							28.543216301304525
						],
						[
							-81.35185431253258,
							28.542322975954477
						],
						[
							-81.35185731716743,
							28.541318486307816
						],
						[
							-81.35186032180236,
							28.54047924258735
						],
						[
							-81.35185531347794,
							28.539601941357283
						],
						[
							-81.35183628562248,
							28.538691590941873
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Lawsona-Fern Creek",
				"RegionID": "274286"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.53849405499994,
					27.82045385200007,
					-82.46828174899991,
					27.86439868000008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.48129429099993,
							27.856266609000045
						],
						[
							-82.48125361299992,
							27.85619407900009
						],
						[
							-82.4812090929999,
							27.856212957000082
						],
						[
							-82.48114345499994,
							27.856237816000093
						],
						[
							-82.48107607899993,
							27.85625748000007
						],
						[
							-82.48100737399994,
							27.856271830000082
						],
						[
							-82.48093775899991,
							27.856280778000045
						],
						[
							-82.48079175999993,
							27.856293778000065
						],
						[
							-82.48073447699994,
							27.85629704100006
						],
						[
							-82.48067732999993,
							27.85629846900008
						],
						[
							-82.48065694399992,
							27.856303736000086
						],
						[
							-82.48058616399993,
							27.85631901000005
						],
						[
							-82.48051438499994,
							27.85632854100004
						],
						[
							-82.4804420719999,
							27.856332266000038
						],
						[
							-82.48036969399993,
							27.856330161000074
						],
						[
							-82.48029769399994,
							27.856325161000086
						],
						[
							-82.48020383499994,
							27.85631365900008
						],
						[
							-82.48005241399994,
							27.856273086000044
						],
						[
							-82.4799103389999,
							27.85620683600007
						],
						[
							-82.47978192699992,
							27.85611692100008
						],
						[
							-82.47967107999995,
							27.856006073000064
						],
						[
							-82.4795811649999,
							27.85587766100008
						],
						[
							-82.47955151899993,
							27.85582187500006
						],
						[
							-82.47953251899992,
							27.855782875000045
						],
						[
							-82.47949591399993,
							27.855696586000082
						],
						[
							-82.47945534099995,
							27.85554516600007
						],
						[
							-82.47944167799994,
							27.85538900000006
						],
						[
							-82.47945534099995,
							27.85523283400005
						],
						[
							-82.47945963599994,
							27.85521017700006
						],
						[
							-82.47947363599991,
							27.855141177000064
						],
						[
							-82.47950991399995,
							27.855012413000054
						],
						[
							-82.47954142899994,
							27.854936747000067
						],
						[
							-82.47962073099991,
							27.854768405000073
						],
						[
							-82.47970705499995,
							27.854443464000042
						],
						[
							-82.47930562999994,
							27.853718961000084
						],
						[
							-82.47925793499991,
							27.85363496200006
						],
						[
							-82.47913534799994,
							27.853453009000077
						],
						[
							-82.47894695999992,
							27.85321090700006
						],
						[
							-82.4786603419999,
							27.852925108000083
						],
						[
							-82.47854959499995,
							27.852829788000065
						],
						[
							-82.47775232999993,
							27.852373555000042
						],
						[
							-82.47771637199992,
							27.85235184800007
						],
						[
							-82.47755280699994,
							27.85224782100005
						],
						[
							-82.47721327799991,
							27.85212785400006
						],
						[
							-82.4766593189999,
							27.851952304000065
						],
						[
							-82.47662981899992,
							27.85194239000009
						],
						[
							-82.47629781899991,
							27.851824390000047
						],
						[
							-82.47617224299995,
							27.85176861800005
						],
						[
							-82.47592924299994,
							27.85163761800004
						],
						[
							-82.47581594799993,
							27.85156511400004
						],
						[
							-82.47531394799995,
							27.851188113000035
						],
						[
							-82.47529575499993,
							27.851174083000046
						],
						[
							-82.47477599399991,
							27.850762565000082
						],
						[
							-82.4742216169999,
							27.850356542000043
						],
						[
							-82.47417023799996,
							27.850315958000067
						],
						[
							-82.47304423799996,
							27.84935795800004
						],
						[
							-82.47300294399992,
							27.84932056000008
						],
						[
							-82.47170699299994,
							27.84807164700004
						],
						[
							-82.47162642099994,
							27.84801887200007
						],
						[
							-82.47153772699994,
							27.848002658000045
						],
						[
							-82.47146141199994,
							27.84798629700009
						],
						[
							-82.47138680299992,
							27.847963378000088
						],
						[
							-82.47131446299994,
							27.84793407500007
						],
						[
							-82.47124493699994,
							27.847898608000037
						],
						[
							-82.47117874899995,
							27.847857245000057
						],
						[
							-82.47104774899992,
							27.84776724500006
						],
						[
							-82.47097892699992,
							27.84771492100009
						],
						[
							-82.47091079599994,
							27.847651461000055
						],
						[
							-82.47051879599991,
							27.847246460000065
						],
						[
							-82.47045378099995,
							27.847171407000076
						],
						[
							-82.47012178099995,
							27.846742407000082
						],
						[
							-82.47008497099995,
							27.84669123100008
						],
						[
							-82.46979950699995,
							27.846263503000046
						],
						[
							-82.46959226899992,
							27.846000158000038
						],
						[
							-82.4695232219999,
							27.845898917000056
						],
						[
							-82.46931591999993,
							27.84554540000005
						],
						[
							-82.46927761699993,
							27.845479883000053
						],
						[
							-82.46921941699992,
							27.84536103800008
						],
						[
							-82.4690524159999,
							27.84494503800005
						],
						[
							-82.4690419129999,
							27.844917586000065
						],
						[
							-82.4690060129999,
							27.84479067300009
						],
						[
							-82.4686733989999,
							27.84316880700004
						],
						[
							-82.46855796499995,
							27.842756412000085
						],
						[
							-82.46853834099994,
							27.84267016600006
						],
						[
							-82.46852467799994,
							27.84251400000005
						],
						[
							-82.46852467799994,
							27.842128261000084
						],
						[
							-82.46851292999992,
							27.841803501000072
						],
						[
							-82.46847169099993,
							27.841507465000063
						],
						[
							-82.46831517599992,
							27.84095016100008
						],
						[
							-82.46830000099993,
							27.840887611000085
						],
						[
							-82.46828933899992,
							27.840824135000048
						],
						[
							-82.46828324499995,
							27.840760059000047
						],
						[
							-82.46828174899991,
							27.84069571200007
						],
						[
							-82.46828485999993,
							27.840631423000048
						],
						[
							-82.46831285899992,
							27.84029942300009
						],
						[
							-82.46832334099992,
							27.840218835000087
						],
						[
							-82.4683457669999,
							27.840122791000056
						],
						[
							-82.46841701499994,
							27.83987893200009
						],
						[
							-82.46843311299995,
							27.839680017000035
						],
						[
							-82.46840793599995,
							27.83909557600009
						],
						[
							-82.46838057899993,
							27.838675436000074
						],
						[
							-82.46837867799991,
							27.83861700000006
						],
						[
							-82.4683864829999,
							27.83849877700004
						],
						[
							-82.46844750399993,
							27.83803861800004
						],
						[
							-82.46854552399992,
							27.83730146000005
						],
						[
							-82.46855831499994,
							27.837228447000086
						],
						[
							-82.4687763149999,
							27.836228446000064
						],
						[
							-82.4687849469999,
							27.83619242800006
						],
						[
							-82.4689589809999,
							27.835527064000075
						],
						[
							-82.46899465599995,
							27.835346076000064
						],
						[
							-82.46900251099993,
							27.835310122000067
						],
						[
							-82.46906257699993,
							27.83505984800007
						],
						[
							-82.46912064299994,
							27.834818574000053
						],
						[
							-82.4691499139999,
							27.834721414000057
						],
						[
							-82.4691708769999,
							27.834668999000087
						],
						[
							-82.4693493289999,
							27.83426048200005
						],
						[
							-82.46942229699994,
							27.83399698800008
						],
						[
							-82.4694542389999,
							27.83390240500006
						],
						[
							-82.46955123899994,
							27.833660405000046
						],
						[
							-82.46957823799994,
							27.83359965200009
						],
						[
							-82.46969709399991,
							27.833356810000055
						],
						[
							-82.4697659489999,
							27.83317012000009
						],
						[
							-82.46989026299991,
							27.832728527000086
						],
						[
							-82.47000819999994,
							27.832308751000085
						],
						[
							-82.47001760299992,
							27.83227776700005
						],
						[
							-82.46997936199995,
							27.83221948700009
						],
						[
							-82.46994575699995,
							27.832158417000073
						],
						[
							-82.46991699199992,
							27.832094924000046
						],
						[
							-82.46989323799994,
							27.83202939100005
						],
						[
							-82.4698746389999,
							27.831962213000054
						],
						[
							-82.4698256399999,
							27.831754213000067
						],
						[
							-82.46981075799994,
							27.83167546800007
						],
						[
							-82.46980294499991,
							27.831595710000045
						],
						[
							-82.4698022629999,
							27.831515574000036
						],
						[
							-82.4698092619999,
							27.83132157400007
						],
						[
							-82.46982233999995,
							27.83119783400008
						],
						[
							-82.46983457199991,
							27.831139748000055
						],
						[
							-82.4701085719999,
							27.83002274800009
						],
						[
							-82.47013691299992,
							27.829929414000052
						],
						[
							-82.47020370199994,
							27.829786410000054
						],
						[
							-82.4703772389999,
							27.829487482000047
						],
						[
							-82.47046607899995,
							27.82936092700004
						],
						[
							-82.47056923199995,
							27.829256610000073
						],
						[
							-82.4707445759999,
							27.829106093000064
						],
						[
							-82.47074033099994,
							27.82905045300004
						],
						[
							-82.47070160099992,
							27.828853646000084
						],
						[
							-82.47068539899993,
							27.828716003000068
						],
						[
							-82.47066139899994,
							27.828117003000045
						],
						[
							-82.47066067799994,
							27.828081000000054
						],
						[
							-82.47067490699995,
							27.82792169100009
						],
						[
							-82.47068423399992,
							27.82787085500007
						],
						[
							-82.47088699599993,
							27.826748164000037
						],
						[
							-82.47090367299995,
							27.826673932000062
						],
						[
							-82.47093479199992,
							27.82655849000008
						],
						[
							-82.47111903099994,
							27.82587777400005
						],
						[
							-82.4711508499999,
							27.82573155700004
						],
						[
							-82.4712818619999,
							27.82490861000008
						],
						[
							-82.4712865429999,
							27.82488181900004
						],
						[
							-82.47136426399993,
							27.82447355100004
						],
						[
							-82.47142273499992,
							27.824009560000036
						],
						[
							-82.47142913399995,
							27.823967012000082
						],
						[
							-82.47163313399994,
							27.82280101100008
						],
						[
							-82.47166217599994,
							27.82268281100005
						],
						[
							-82.47172627399995,
							27.822481775000085
						],
						[
							-82.4717414559999,
							27.82243176500009
						],
						[
							-82.47176649199993,
							27.82236027400006
						],
						[
							-82.47179745499994,
							27.822291145000065
						],
						[
							-82.47183412599992,
							27.822224866000056
						],
						[
							-82.47197312599991,
							27.821996866000067
						],
						[
							-82.47205371599995,
							27.82188498200009
						],
						[
							-82.47219971699991,
							27.821711981000078
						],
						[
							-82.47230892699992,
							27.821603079000056
						],
						[
							-82.47237880299991,
							27.82155003200006
						],
						[
							-82.4730358029999,
							27.82110003200006
						],
						[
							-82.47308099499992,
							27.82107102200007
						],
						[
							-82.47345566699994,
							27.820846093000057
						],
						[
							-82.4736008029999,
							27.820777237000073
						],
						[
							-82.47386560899992,
							27.820679575000042
						],
						[
							-82.47401883499992,
							27.820638341000063
						],
						[
							-82.47406380399993,
							27.820631579000064
						],
						[
							-82.47437680399992,
							27.82059257900005
						],
						[
							-82.4744261219999,
							27.820587810000063
						],
						[
							-82.4745114449999,
							27.82058192800008
						],
						[
							-82.47467416599994,
							27.82057009100004
						],
						[
							-82.47472756199994,
							27.820566135000036
						],
						[
							-82.47482994599994,
							27.820564397000055
						],
						[
							-82.4748769819999,
							27.820566278000058
						],
						[
							-82.47605613499992,
							27.820474396000066
						],
						[
							-82.47610833199991,
							27.820471852000082
						],
						[
							-82.47702433199993,
							27.82045385200007
						],
						[
							-82.47706379399995,
							27.820453943000075
						],
						[
							-82.47740242999993,
							27.820462234000047
						],
						[
							-82.47750306599994,
							27.820466527000065
						],
						[
							-82.4776462079999,
							27.820484330000056
						],
						[
							-82.47806781899993,
							27.820571559000086
						],
						[
							-82.47838640499992,
							27.82060604600008
						],
						[
							-82.47911690399991,
							27.82064175000005
						],
						[
							-82.47915904199994,
							27.82064480300005
						],
						[
							-82.47960511999992,
							27.82068767800007
						],
						[
							-82.47985505899993,
							27.82068767800007
						],
						[
							-82.48017321299994,
							27.820639331000052
						],
						[
							-82.48067374099992,
							27.82053692800008
						],
						[
							-82.48074003999994,
							27.820525927000066
						],
						[
							-82.48080697499995,
							27.82051990800005
						],
						[
							-82.4808741729999,
							27.82051890400004
						],
						[
							-82.48118617299991,
							27.820525904000082
						],
						[
							-82.48126025099992,
							27.820530631000054
						],
						[
							-82.48133368799995,
							27.820541450000064
						],
						[
							-82.4814059819999,
							27.820558289000076
						],
						[
							-82.48147664099992,
							27.820581032000064
						],
						[
							-82.48154518299992,
							27.820609525000066
						],
						[
							-82.48161114299995,
							27.82064357300004
						],
						[
							-82.48167406999994,
							27.82068294600009
						],
						[
							-82.48178506999994,
							27.820758945000083
						],
						[
							-82.48184482499994,
							27.820803571000056
						],
						[
							-82.48190066099994,
							27.82085301300009
						],
						[
							-82.48195218899991,
							27.820906929000046
						],
						[
							-82.48199905299992,
							27.82096494500007
						],
						[
							-82.4820409269999,
							27.82102665900004
						],
						[
							-82.48207752199994,
							27.82109164300005
						],
						[
							-82.48231431099993,
							27.82126204900004
						],
						[
							-82.4823582219999,
							27.821296160000088
						],
						[
							-82.48372782099995,
							27.821130208000056
						],
						[
							-82.4837970769999,
							27.82112452000007
						],
						[
							-82.4840723399999,
							27.82111259900006
						],
						[
							-82.48440960199991,
							27.82109667800006
						],
						[
							-82.48447130499994,
							27.82109588600008
						],
						[
							-82.48479730399993,
							27.821102885000073
						],
						[
							-82.48486048299992,
							27.82110646800004
						],
						[
							-82.48505389699994,
							27.821124283000074
						],
						[
							-82.48549716899993,
							27.82113077500009
						],
						[
							-82.48559660199993,
							27.821137755000052
						],
						[
							-82.48642860199993,
							27.82124275500007
						],
						[
							-82.48647216499995,
							27.821249340000065
						],
						[
							-82.48660038999992,
							27.821281828000053
						],
						[
							-82.48730238999991,
							27.821515828000088
						],
						[
							-82.48733787899994,
							27.821528490000052
						],
						[
							-82.48771887999993,
							27.82167349000008
						],
						[
							-82.48785666599991,
							27.821739897000043
						],
						[
							-82.4879786699999,
							27.821813629000076
						],
						[
							-82.48803657799994,
							27.82185180400006
						],
						[
							-82.48809137099994,
							27.821894329000088
						],
						[
							-82.48814272399994,
							27.821940950000055
						],
						[
							-82.48819033199993,
							27.82199139000005
						],
						[
							-82.48823391099995,
							27.822045349000064
						],
						[
							-82.48827320099991,
							27.82210250600008
						],
						[
							-82.48830797099993,
							27.822162521000052
						],
						[
							-82.4883175299999,
							27.822180594000088
						],
						[
							-82.4883410729999,
							27.82219707900009
						],
						[
							-82.4883841329999,
							27.822235636000073
						],
						[
							-82.4885621329999,
							27.822405635000052
						],
						[
							-82.48861301199992,
							27.822458354000048
						],
						[
							-82.48865942999993,
							27.822515039000052
						],
						[
							-82.48870107999994,
							27.82257531500005
						],
						[
							-82.48873768599992,
							27.82263878000009
						],
						[
							-82.48876900399996,
							27.822705015000054
						],
						[
							-82.48879482599995,
							27.822773580000046
						],
						[
							-82.4888808259999,
							27.82303358000007
						],
						[
							-82.48891265999993,
							27.82315983400008
						],
						[
							-82.48892630699993,
							27.823310760000084
						],
						[
							-82.48893169899992,
							27.82423622500005
						],
						[
							-82.48917597999991,
							27.824418653000066
						],
						[
							-82.48951089799993,
							27.824639425000044
						],
						[
							-82.48959280299995,
							27.82465877800007
						],
						[
							-82.48966930499995,
							27.824680467000064
						],
						[
							-82.4897435929999,
							27.824708829000087
						],
						[
							-82.48981508499992,
							27.824743641000055
						],
						[
							-82.48988322199995,
							27.824784633000036
						],
						[
							-82.48994747199993,
							27.824831483000082
						],
						[
							-82.4902064719999,
							27.82503848400006
						],
						[
							-82.49026017099993,
							27.825084993000075
						],
						[
							-82.49031003099992,
							27.825135596000052
						],
						[
							-82.49035574099992,
							27.82518997700004
						],
						[
							-82.4905627409999,
							27.825456976000055
						],
						[
							-82.49063083599992,
							27.825558339000054
						],
						[
							-82.49066514999993,
							27.82562385600005
						],
						[
							-82.49080214999992,
							27.825913856000057
						],
						[
							-82.49083408599995,
							27.825990414000046
						],
						[
							-82.49086749299995,
							27.82610556900005
						],
						[
							-82.49095949299993,
							27.826525569000072
						],
						[
							-82.49097366299992,
							27.826608762000035
						],
						[
							-82.49106694099993,
							27.827371004000042
						],
						[
							-82.49118673499993,
							27.827890980000063
						],
						[
							-82.49146434199992,
							27.828782150000052
						],
						[
							-82.49163373899995,
							27.829093784000065
						],
						[
							-82.49200309299994,
							27.82961554100007
						],
						[
							-82.49213945799994,
							27.829790557000084
						],
						[
							-82.49215591399991,
							27.829735414000083
						],
						[
							-82.4921891159999,
							27.82965618700007
						],
						[
							-82.4922801159999,
							27.82946518700004
						],
						[
							-82.49231327399991,
							27.82940214900009
						],
						[
							-82.49235131699993,
							27.82934193300008
						],
						[
							-82.49239400599993,
							27.829284916000063
						],
						[
							-82.49244107399994,
							27.82923145600006
						],
						[
							-82.49249222399993,
							27.82918188900004
						],
						[
							-82.49254713699992,
							27.82913652500008
						],
						[
							-82.49267713599994,
							27.829037525000047
						],
						[
							-82.49273949699995,
							27.828993405000062
						],
						[
							-82.49280559599993,
							27.828955114000053
						],
						[
							-82.49287489199992,
							27.82892296700004
						],
						[
							-82.49294681499993,
							27.828897228000073
						],
						[
							-82.4930207729999,
							27.828878108000083
						],
						[
							-82.49325008499994,
							27.828623780000044
						],
						[
							-82.4933012699999,
							27.828571459000045
						],
						[
							-82.49380326999994,
							27.828098458000056
						],
						[
							-82.49384192699995,
							27.828064079000058
						],
						[
							-82.49397033899993,
							27.827974164000068
						],
						[
							-82.49411241399991,
							27.827907914000036
						],
						[
							-82.49426383399992,
							27.82786734000007
						],
						[
							-82.49441999999995,
							27.827853678000054
						],
						[
							-82.49480699999992,
							27.827853678000054
						],
						[
							-82.4948340489999,
							27.827856044000043
						],
						[
							-82.49480971899993,
							27.827793189000094
						],
						[
							-82.49479055199993,
							27.82772857100008
						],
						[
							-82.49477667399992,
							27.827662615000065
						],
						[
							-82.49476817599992,
							27.827595753000082
						],
						[
							-82.4947651139999,
							27.827528422000057
						],
						[
							-82.49476750799994,
							27.82746106500008
						],
						[
							-82.49477534099992,
							27.827394121000054
						],
						[
							-82.4947576209999,
							27.827361188000054
						],
						[
							-82.49465613599995,
							27.82715821700009
						],
						[
							-82.49453933699994,
							27.826972174000048
						],
						[
							-82.49450429699993,
							27.82691119000009
						],
						[
							-82.49447413199994,
							27.826847655000055
						],
						[
							-82.49444902599993,
							27.826781955000058
						],
						[
							-82.49442913299993,
							27.826714494000043
						],
						[
							-82.4944145739999,
							27.826645684000084
						],
						[
							-82.49437680699992,
							27.82641820100008
						],
						[
							-82.49436781599991,
							27.826346055000045
						],
						[
							-82.49436468199991,
							27.826273419000078
						],
						[
							-82.49436742499995,
							27.826200766000056
						],
						[
							-82.49437602799992,
							27.826128573000062
						],
						[
							-82.4943904349999,
							27.826057311000056
						],
						[
							-82.49441054999994,
							27.825987445000067
						],
						[
							-82.49451254999991,
							27.825680445000046
						],
						[
							-82.49453623199992,
							27.82561720600006
						],
						[
							-82.49456459299996,
							27.825555922000035
						],
						[
							-82.4945974719999,
							27.82549693900006
						],
						[
							-82.49463468399995,
							27.825440590000085
						],
						[
							-82.49467601999993,
							27.82538719100006
						],
						[
							-82.49515054999995,
							27.824819559000048
						],
						[
							-82.49526192699994,
							27.82470807900006
						],
						[
							-82.49537133899992,
							27.824629447000063
						],
						[
							-82.49553822699994,
							27.82452754700006
						],
						[
							-82.49558938199993,
							27.824456842000075
						],
						[
							-82.49562907999992,
							27.824405927000043
						],
						[
							-82.49573992699993,
							27.82429507900008
						],
						[
							-82.49586833899991,
							27.82420516400009
						],
						[
							-82.4960104139999,
							27.82413891300007
						],
						[
							-82.4961618349999,
							27.824098340000035
						],
						[
							-82.49631799999992,
							27.824084678000077
						],
						[
							-82.49647416599993,
							27.824098340000035
						],
						[
							-82.4965352939999,
							27.824111324000057
						],
						[
							-82.49678429399995,
							27.82417332400007
						],
						[
							-82.4969233089999,
							27.824220273000037
						],
						[
							-82.49706930899993,
							27.824283274000038
						],
						[
							-82.49713751599995,
							27.82431617900005
						],
						[
							-82.49720271399991,
							27.824354706000065
						],
						[
							-82.49726443899993,
							27.824398581000082
						],
						[
							-82.49732225399993,
							27.824447494000083
						],
						[
							-82.49737574799991,
							27.82450109800004
						],
						[
							-82.49742454299991,
							27.824559013000055
						],
						[
							-82.4974564609999,
							27.824600306000036
						],
						[
							-82.4976385949999,
							27.82440895800005
						],
						[
							-82.4976934469999,
							27.82435601800006
						],
						[
							-82.49775258499994,
							27.824307914000087
						],
						[
							-82.4978155849999,
							27.824264991000064
						],
						[
							-82.49788199299991,
							27.824227557000086
						],
						[
							-82.49799199299991,
							27.824171558000046
						],
						[
							-82.49805410999994,
							27.82414285500005
						],
						[
							-82.49811823099992,
							27.82411895900009
						],
						[
							-82.49818398199994,
							27.824100007000084
						],
						[
							-82.49825098399992,
							27.824086110000056
						],
						[
							-82.49831884899993,
							27.824077347000074
						],
						[
							-82.4986168499999,
							27.82405034600004
						],
						[
							-82.49876851899995,
							27.82404944700005
						],
						[
							-82.49886007099991,
							27.82405665500005
						],
						[
							-82.49909962299995,
							27.824076863000073
						],
						[
							-82.49918016599992,
							27.82408734100005
						],
						[
							-82.49927688999992,
							27.824109966000037
						],
						[
							-82.49949188999994,
							27.824172967000038
						],
						[
							-82.49955240999992,
							27.82419305600007
						],
						[
							-82.4996113549999,
							27.824217384000065
						],
						[
							-82.4996684269999,
							27.824245828000073
						],
						[
							-82.49972333999995,
							27.824278244000087
						],
						[
							-82.49982033999993,
							27.82434024400004
						],
						[
							-82.49991036799992,
							27.82440598800008
						],
						[
							-82.50007594199992,
							27.82454341400006
						],
						[
							-82.50010043299994,
							27.824559931000067
						],
						[
							-82.50014092999993,
							27.824567614000046
						],
						[
							-82.50036289899992,
							27.824593935000053
						],
						[
							-82.50044011199992,
							27.824606517000063
						],
						[
							-82.50051593799992,
							27.82462576200004
						],
						[
							-82.50058980599994,
							27.824651524000046
						],
						[
							-82.50066115499993,
							27.824683608000043
						],
						[
							-82.50072944599992,
							27.82472177200009
						],
						[
							-82.50097005399994,
							27.82487032100005
						],
						[
							-82.50104823699992,
							27.82487636600007
						],
						[
							-82.5011382379999,
							27.82489036600009
						],
						[
							-82.50128087099995,
							27.824924663000047
						],
						[
							-82.50135444999995,
							27.824948905000042
						],
						[
							-82.5015159969999,
							27.82497045200006
						],
						[
							-82.50159243799993,
							27.824983949000057
						],
						[
							-82.50166743199992,
							27.825003987000063
						],
						[
							-82.50174041799994,
							27.82503041700005
						],
						[
							-82.50189341799995,
							27.825093417000065
						],
						[
							-82.5020006609999,
							27.825146164000046
						],
						[
							-82.50204812699991,
							27.825172431000055
						],
						[
							-82.50210499999991,
							27.825170678000063
						],
						[
							-82.50225699999993,
							27.825170678000063
						],
						[
							-82.50232578799995,
							27.82517331300005
						],
						[
							-82.50239417299991,
							27.825181201000078
						],
						[
							-82.5024617549999,
							27.825194297000053
						],
						[
							-82.5025281369999,
							27.82521252400005
						],
						[
							-82.50259292999995,
							27.825235775000067
						],
						[
							-82.50303992999994,
							27.825415776000057
						],
						[
							-82.50311527299993,
							27.82544917900009
						],
						[
							-82.50323381499993,
							27.825455782000063
						],
						[
							-82.50332081499994,
							27.825466782000035
						],
						[
							-82.50339850099994,
							27.825480086000084
						],
						[
							-82.50347472499993,
							27.825500142000067
						],
						[
							-82.50354889999994,
							27.82552679400004
						],
						[
							-82.5036318999999,
							27.82556079400007
						],
						[
							-82.50374066099994,
							27.825614164000058
						],
						[
							-82.50381204699994,
							27.825659999000038
						],
						[
							-82.50385875599994,
							27.825693202000082
						],
						[
							-82.50407759299992,
							27.82565684000008
						],
						[
							-82.5042249999999,
							27.82564467800006
						],
						[
							-82.50436598599993,
							27.82565579700008
						],
						[
							-82.50468857599992,
							27.82570706900009
						],
						[
							-82.50476255599995,
							27.825722064000047
						],
						[
							-82.50483491699993,
							27.825743555000088
						],
						[
							-82.50490508799993,
							27.825771374000055
						],
						[
							-82.50497251899992,
							27.82580530100006
						],
						[
							-82.5050366779999,
							27.82584507000007
						],
						[
							-82.5050970609999,
							27.825890367000056
						],
						[
							-82.50524405499993,
							27.82592567100005
						],
						[
							-82.5054707029999,
							27.825973587000078
						],
						[
							-82.50550518299991,
							27.82597613300004
						],
						[
							-82.50561136099992,
							27.82596477800007
						],
						[
							-82.50575447699993,
							27.825960932000044
						],
						[
							-82.50598147699992,
							27.82597293200007
						],
						[
							-82.50609016599992,
							27.825985341000035
						],
						[
							-82.5061737449999,
							27.82600422300004
						],
						[
							-82.50632570999994,
							27.82604837300005
						],
						[
							-82.50640821199994,
							27.826071213000034
						],
						[
							-82.5064744099999,
							27.826089633000038
						],
						[
							-82.50653843399994,
							27.82611458300005
						],
						[
							-82.50659964099992,
							27.82614581300004
						],
						[
							-82.50665741599994,
							27.82618300900009
						],
						[
							-82.50669105799994,
							27.826205711000057
						],
						[
							-82.50690773999992,
							27.82611139200009
						],
						[
							-82.5070376779999,
							27.82606710400006
						],
						[
							-82.50710367799991,
							27.826050104000046
						],
						[
							-82.50724157199994,
							27.826025840000057
						],
						[
							-82.5073865729999,
							27.82601184100008
						],
						[
							-82.50746428299993,
							27.826007720000067
						],
						[
							-82.5075420579999,
							27.826010333000056
						],
						[
							-82.50761931699992,
							27.82601966100009
						],
						[
							-82.50769547899995,
							27.82603563200007
						],
						[
							-82.50778947899994,
							27.826059632000067
						],
						[
							-82.5078745859999,
							27.82608591400009
						],
						[
							-82.50801666099994,
							27.826152165000053
						],
						[
							-82.50814507299992,
							27.826242080000043
						],
						[
							-82.50825592099994,
							27.826352927000073
						],
						[
							-82.50828780899991,
							27.826382619000075
						],
						[
							-82.5083547619999,
							27.826390158000038
						],
						[
							-82.50840316499995,
							27.826397341000074
						],
						[
							-82.5085597019999,
							27.826439811000057
						],
						[
							-82.50865481799991,
							27.82647570800009
						],
						[
							-82.50876764399993,
							27.826527490000046
						],
						[
							-82.50884464399991,
							27.826569490000054
						],
						[
							-82.50890794799994,
							27.826607471000045
						],
						[
							-82.50896792299994,
							27.82665051600009
						],
						[
							-82.5090241659999,
							27.82669833600005
						],
						[
							-82.50907629799991,
							27.826750607000065
						],
						[
							-82.50915529799994,
							27.826836606000086
						],
						[
							-82.50918192099994,
							27.826866927000083
						],
						[
							-82.5092754929999,
							27.827001795000058
						],
						[
							-82.50929075999994,
							27.827029150000044
						],
						[
							-82.5094071769999,
							27.827022951000064
						],
						[
							-82.50954914499994,
							27.827026619000037
						],
						[
							-82.50965304599993,
							27.82703755600005
						],
						[
							-82.5098628529999,
							27.826995898000064
						],
						[
							-82.50998796899997,
							27.826980071000037
						],
						[
							-82.51004511399992,
							27.826976887000058
						],
						[
							-82.51013542499993,
							27.826907367000047
						],
						[
							-82.51019926299995,
							27.82686249700004
						],
						[
							-82.5102667509999,
							27.82682332900004
						],
						[
							-82.5103373799999,
							27.82679015900004
						],
						[
							-82.51041061899991,
							27.82676323700008
						],
						[
							-82.51048591499995,
							27.826742764000073
						],
						[
							-82.5106409149999,
							27.826707764000048
						],
						[
							-82.51071288899993,
							27.826694564000036
						],
						[
							-82.51078569799995,
							27.82668725900004
						],
						[
							-82.51085885899994,
							27.82668589700006
						],
						[
							-82.51093188899995,
							27.826690488000054
						],
						[
							-82.51100430399993,
							27.82670100100006
						],
						[
							-82.51107562499993,
							27.826717366000082
						],
						[
							-82.51114162499994,
							27.826735366000037
						],
						[
							-82.51121738499995,
							27.82675967600005
						],
						[
							-82.51129069899991,
							27.826790586000072
						],
						[
							-82.5113609949999,
							27.82682785600008
						],
						[
							-82.5114277209999,
							27.826871192000056
						],
						[
							-82.5114907219999,
							27.826916192000056
						],
						[
							-82.51154607299992,
							27.826959079000062
						],
						[
							-82.5115983959999,
							27.82701140200004
						],
						[
							-82.51163099999991,
							27.82700967800008
						],
						[
							-82.51177211999993,
							27.82702081900004
						],
						[
							-82.51188664299991,
							27.827039080000077
						],
						[
							-82.51204558599994,
							27.827080914000078
						],
						[
							-82.51216802199991,
							27.827136152000037
						],
						[
							-82.5122580229999,
							27.827185151000037
						],
						[
							-82.5123151649999,
							27.827219057000036
						],
						[
							-82.5123652069999,
							27.82725130600005
						],
						[
							-82.5124477569999,
							27.827292911000086
						],
						[
							-82.51250188499995,
							27.827322563000052
						],
						[
							-82.51255385199994,
							27.82735585800009
						],
						[
							-82.51260341299991,
							27.82739263800005
						],
						[
							-82.51265033499993,
							27.82743273200009
						],
						[
							-82.5127333339999,
							27.82750873200007
						],
						[
							-82.51280700799992,
							27.82758462700008
						],
						[
							-82.51287600899991,
							27.827664627000047
						],
						[
							-82.51296546799995,
							27.827788147000035
						],
						[
							-82.51314665199993,
							27.82808924300008
						],
						[
							-82.51321708599994,
							27.828238414000054
						],
						[
							-82.5132275659999,
							27.828277524000043
						],
						[
							-82.51333272099993,
							27.828286398000046
						],
						[
							-82.51343544299993,
							27.82830386900008
						],
						[
							-82.51350426399995,
							27.828318580000087
						],
						[
							-82.51357172299993,
							27.82833862600006
						],
						[
							-82.5136374089999,
							27.82836388700008
						],
						[
							-82.51370091699994,
							27.82839420600004
						],
						[
							-82.51376186099992,
							27.828429399000072
						],
						[
							-82.51381986599995,
							27.82846925000007
						],
						[
							-82.51388686599995,
							27.828519250000056
						],
						[
							-82.51393260799996,
							27.828551701000038
						],
						[
							-82.5140895859999,
							27.828592914000073
						],
						[
							-82.51421063599992,
							27.828647398000044
						],
						[
							-82.51437663699994,
							27.828737398000044
						],
						[
							-82.51439766099992,
							27.828749164000044
						],
						[
							-82.51453158299996,
							27.828843778000078
						],
						[
							-82.51468343199991,
							27.82897534200004
						],
						[
							-82.5151546699999,
							27.829099236000047
						],
						[
							-82.51525371399993,
							27.82913151400004
						],
						[
							-82.51534415599991,
							27.829166116000067
						],
						[
							-82.51539687799993,
							27.82917180900006
						],
						[
							-82.51549116599995,
							27.82918334100009
						],
						[
							-82.51561666099991,
							27.829214923000052
						],
						[
							-82.5157106609999,
							27.82924592300009
						],
						[
							-82.5157828429999,
							27.829273214000068
						],
						[
							-82.51585241899994,
							27.82930659200008
						],
						[
							-82.51591887799992,
							27.829345812000042
						],
						[
							-82.51598172999991,
							27.829390585000056
						],
						[
							-82.5160405119999,
							27.829440581000085
						],
						[
							-82.51609479199993,
							27.82949543300009
						],
						[
							-82.51616090899995,
							27.829568245000075
						],
						[
							-82.51630983399991,
							27.82952834100007
						],
						[
							-82.51646599999992,
							27.829514678000066
						],
						[
							-82.51649999999995,
							27.829514678000066
						],
						[
							-82.51665616499992,
							27.82952834100007
						],
						[
							-82.51673060999991,
							27.829544748000046
						],
						[
							-82.51677961099995,
							27.82955774800007
						],
						[
							-82.51685658699995,
							27.829581913000084
						],
						[
							-82.51699866099995,
							27.829648164000048
						],
						[
							-82.51712707299994,
							27.829738079000037
						],
						[
							-82.51723792099995,
							27.829848927000057
						],
						[
							-82.51727291299994,
							27.82988920300005
						],
						[
							-82.51735486899992,
							27.82989539600004
						],
						[
							-82.51749262899995,
							27.82991697400007
						],
						[
							-82.51755162899991,
							27.82993097400004
						],
						[
							-82.5176158619999,
							27.829948754000043
						],
						[
							-82.51767860199993,
							27.829971241000067
						],
						[
							-82.5177395039999,
							27.82999831400008
						],
						[
							-82.51779823299995,
							27.830029822000085
						],
						[
							-82.51785446799994,
							27.830065593000086
						],
						[
							-82.51813231299991,
							27.83025715100007
						],
						[
							-82.51818272299994,
							27.83028368300006
						],
						[
							-82.51824467299991,
							27.830274467000038
						],
						[
							-82.51837699999993,
							27.83026467800005
						],
						[
							-82.51850503799994,
							27.830273839000085
						],
						[
							-82.51865103699993,
							27.830294839000093
						],
						[
							-82.51872634799992,
							27.83030897000009
						],
						[
							-82.51880018299994,
							27.830329460000087
						],
						[
							-82.51887200599992,
							27.830356161000054
						],
						[
							-82.51894129499993,
							27.830388879000054
						],
						[
							-82.5190002949999,
							27.83041987900009
						],
						[
							-82.51905704599994,
							27.83045238300008
						],
						[
							-82.51911128499995,
							27.830488926000044
						],
						[
							-82.51916272499994,
							27.830529313000056
						],
						[
							-82.51921109299991,
							27.830573333000075
						],
						[
							-82.51925613499992,
							27.830620750000037
						],
						[
							-82.5192962289999,
							27.830666158000042
						],
						[
							-82.51947321199992,
							27.830816307000077
						],
						[
							-82.51952433799994,
							27.830848096000068
						],
						[
							-82.5196556219999,
							27.83090158200008
						],
						[
							-82.51980016999994,
							27.83087640800005
						],
						[
							-82.5199971699999,
							27.83085840800004
						],
						[
							-82.5200789999999,
							27.830854678000037
						],
						[
							-82.52017999999993,
							27.830854678000037
						],
						[
							-82.52033616599994,
							27.830868340000052
						],
						[
							-82.52040993799994,
							27.83088456900009
						],
						[
							-82.52053093699993,
							27.830916570000056
						],
						[
							-82.52060242699991,
							27.83093869700008
						],
						[
							-82.52067182899992,
							27.83096669200006
						],
						[
							-82.52073866299992,
							27.831000360000075
						],
						[
							-82.5208024669999,
							27.831039468000085
						],
						[
							-82.52086279799994,
							27.831083745000058
						],
						[
							-82.52095279899993,
							27.831155745000046
						],
						[
							-82.5210540349999,
							27.831250411000045
						],
						[
							-82.52129473399992,
							27.831512831000055
						],
						[
							-82.52131514199993,
							27.831525147000036
						],
						[
							-82.52178907899992,
							27.831715434000046
						],
						[
							-82.52185570899991,
							27.831745382000065
						],
						[
							-82.52318550099994,
							27.832409287000075
						],
						[
							-82.5238031369999,
							27.83269457600005
						],
						[
							-82.52440558099994,
							27.832972889000075
						],
						[
							-82.52471712599993,
							27.833026603000068
						],
						[
							-82.52491307299994,
							27.833044339000082
						],
						[
							-82.5249881659999,
							27.833054340000047
						],
						[
							-82.52507514399991,
							27.83307417000009
						],
						[
							-82.52510911899992,
							27.833083711000086
						],
						[
							-82.52533781499994,
							27.833086690000073
						],
						[
							-82.52549599999992,
							27.833072678000065
						],
						[
							-82.52557799999994,
							27.833072678000065
						],
						[
							-82.52573416599995,
							27.83308634100007
						],
						[
							-82.52576020799995,
							27.83309133000006
						],
						[
							-82.5258472079999,
							27.83310933000007
						],
						[
							-82.52597258599991,
							27.83314491400006
						],
						[
							-82.5260625009999,
							27.833183295000083
						],
						[
							-82.52609076299991,
							27.833197221000034
						],
						[
							-82.5262252089999,
							27.833247354000036
						],
						[
							-82.5262965849999,
							27.833277532000068
						],
						[
							-82.52636509699994,
							27.833313743000076
						],
						[
							-82.52643023899992,
							27.833355717000074
						],
						[
							-82.52649152399994,
							27.833403144000044
						],
						[
							-82.52654849999993,
							27.833455670000035
						],
						[
							-82.52660074199991,
							27.833512907000056
						],
						[
							-82.52664786199995,
							27.833574428000077
						],
						[
							-82.52668951099992,
							27.83363977800008
						],
						[
							-82.52673751099991,
							27.833722777000048
						],
						[
							-82.52677124699994,
							27.833786950000047
						],
						[
							-82.52688833099995,
							27.834033295000044
						],
						[
							-82.52703365699995,
							27.834309274000077
						],
						[
							-82.52706024199996,
							27.834338308000042
						],
						[
							-82.52711399899994,
							27.834359069000072
						],
						[
							-82.5271722629999,
							27.83438396400004
						],
						[
							-82.52787926299993,
							27.834715964000054
						],
						[
							-82.52797170499991,
							27.83476617100007
						],
						[
							-82.52853970399991,
							27.835119171000088
						],
						[
							-82.52860196099994,
							27.83516157600008
						],
						[
							-82.52897681499991,
							27.835440583000036
						],
						[
							-82.52937368999994,
							27.83517045600007
						],
						[
							-82.53041007999991,
							27.83423290400009
						],
						[
							-82.5322994469999,
							27.832321741000044
						],
						[
							-82.53241745399993,
							27.83222135400007
						],
						[
							-82.53253545399991,
							27.832137354000054
						],
						[
							-82.53264453499992,
							27.832070842000064
						],
						[
							-82.53273753499991,
							27.83202284300006
						],
						[
							-82.5328424139999,
							27.83197691400005
						],
						[
							-82.5329477759999,
							27.83194570900008
						],
						[
							-82.53305177599992,
							27.831921709000085
						],
						[
							-82.53316530799994,
							27.831903062000038
						],
						[
							-82.53327630899992,
							27.831892062000065
						],
						[
							-82.53336499999995,
							27.831887678000047
						],
						[
							-82.5334959999999,
							27.831887678000047
						],
						[
							-82.53355649399992,
							27.831889714000056
						],
						[
							-82.53382349399993,
							27.831907715000057
						],
						[
							-82.53391916499993,
							27.83191934100006
						],
						[
							-82.53401325599992,
							27.831941200000074
						],
						[
							-82.53412025599994,
							27.831972199000063
						],
						[
							-82.53417758599994,
							27.831990914000077
						],
						[
							-82.53428215199995,
							27.83203668100009
						],
						[
							-82.53441015199991,
							27.832102682000084
						],
						[
							-82.53452519199993,
							27.832173407000084
						],
						[
							-82.53501719199994,
							27.83252940600005
						],
						[
							-82.5350359649999,
							27.83254336500005
						],
						[
							-82.53802296499993,
							27.834825365000086
						],
						[
							-82.53807469199995,
							27.834868029000063
						],
						[
							-82.53812309599994,
							27.834914428000047
						],
						[
							-82.53816790899992,
							27.834964305000085
						],
						[
							-82.53820888199995,
							27.835017382000046
						],
						[
							-82.53824578599995,
							27.83507336400004
						],
						[
							-82.53827841599991,
							27.835131941000043
						],
						[
							-82.53838941599992,
							27.83534994100006
						],
						[
							-82.5384226189999,
							27.835423050000088
						],
						[
							-82.53844916799994,
							27.835498830000066
						],
						[
							-82.53846885199994,
							27.835576675000084
						],
						[
							-82.53848151499994,
							27.83565596600005
						],
						[
							-82.53848705399992,
							27.835736071000042
						],
						[
							-82.53849405499994,
							27.836023070000067
						],
						[
							-82.53849273899993,
							27.836098337000067
						],
						[
							-82.53848513299994,
							27.836173229000053
						],
						[
							-82.53847129099995,
							27.836247223000044
						],
						[
							-82.53844129099991,
							27.836377224000046
						],
						[
							-82.53840420199992,
							27.83649829500007
						],
						[
							-82.53835720199993,
							27.836620295000046
						],
						[
							-82.53829683599992,
							27.836746661000063
						],
						[
							-82.53820237499991,
							27.836880406000034
						],
						[
							-82.53758382899991,
							27.837594738000064
						],
						[
							-82.53754551999992,
							27.837636263000036
						],
						[
							-82.53729195499994,
							27.83789435700004
						],
						[
							-82.5373181949999,
							27.837910615000055
						],
						[
							-82.53742219399993,
							27.83797961500005
						],
						[
							-82.53750307299993,
							27.838040079000052
						],
						[
							-82.5376139199999,
							27.838150927000076
						],
						[
							-82.53770383499995,
							27.838279339000053
						],
						[
							-82.53777008599991,
							27.838421414000038
						],
						[
							-82.5378087709999,
							27.83856248400008
						],
						[
							-82.53782271599994,
							27.838636659000088
						],
						[
							-82.53783732199992,
							27.838798000000054
						],
						[
							-82.53782271599994,
							27.838959340000088
						],
						[
							-82.53780877199995,
							27.83903351400005
						],
						[
							-82.53777008599991,
							27.839174586000073
						],
						[
							-82.5377013399999,
							27.839320929000053
						],
						[
							-82.53767042099992,
							27.839373202000047
						],
						[
							-82.5377322729999,
							27.839414489000035
						],
						[
							-82.53779037899994,
							27.839460901000052
						],
						[
							-82.53784431499992,
							27.839512099000046
						],
						[
							-82.53789368799994,
							27.839567711000086
						],
						[
							-82.53793813899995,
							27.83962733100009
						],
						[
							-82.53797734199993,
							27.839690525000037
						],
						[
							-82.53804984899995,
							27.839820712000062
						],
						[
							-82.53808162199994,
							27.83988346700005
						],
						[
							-82.53810839199991,
							27.839948513000085
						],
						[
							-82.53812999699994,
							27.840015453000035
						],
						[
							-82.53814630499994,
							27.84008387700004
						],
						[
							-82.53815721399991,
							27.840153366000038
						],
						[
							-82.5381626599999,
							27.84022349500009
						],
						[
							-82.53816260799994,
							27.840293835000068
						],
						[
							-82.5381570589999,
							27.840363955000043
						],
						[
							-82.53814305899994,
							27.840481955000087
						],
						[
							-82.53813554699991,
							27.840539705000083
						],
						[
							-82.53812338199992,
							27.84059665700005
						],
						[
							-82.53810664199995,
							27.840652436000084
						],
						[
							-82.53808543899993,
							27.84070667600008
						],
						[
							-82.53805991099995,
							27.840759020000068
						],
						[
							-82.5366422919999,
							27.841167604000077
						],
						[
							-82.5358663159999,
							27.841425592000064
						],
						[
							-82.53623268899992,
							27.854971034000073
						],
						[
							-82.53513420399992,
							27.854879533000087
						],
						[
							-82.53464636199993,
							27.854141521000088
						],
						[
							-82.53266321699994,
							27.853781120000065
						],
						[
							-82.53064973699992,
							27.853414950000058
						],
						[
							-82.52774342099991,
							27.85428452600007
						],
						[
							-82.5255011829999,
							27.854070894000074
						],
						[
							-82.5236632239999,
							27.85389585000007
						],
						[
							-82.5214975799999,
							27.853689600000052
						],
						[
							-82.51957554299993,
							27.853506381000045
						],
						[
							-82.51783654499991,
							27.856160646000035
						],
						[
							-82.51801993299995,
							27.857625080000048
						],
						[
							-82.51742434599994,
							27.858329145000084
						],
						[
							-82.51745470799995,
							27.863393847000054
						],
						[
							-82.49441471499995,
							27.864020223000068
						],
						[
							-82.4882793999999,
							27.86418623600008
						],
						[
							-82.4873920309999,
							27.86439868000008
						],
						[
							-82.48719135699992,
							27.86411330900006
						],
						[
							-82.48714816499995,
							27.86404566100009
						],
						[
							-82.48708006499993,
							27.863898407000082
						],
						[
							-82.48699754499995,
							27.863662861000083
						],
						[
							-82.48695088599993,
							27.863565425000047
						],
						[
							-82.48692902099992,
							27.86351600900008
						],
						[
							-82.48630414699994,
							27.86198063100005
						],
						[
							-82.48627138899991,
							27.861917951000066
						],
						[
							-82.48625558299995,
							27.86190018900004
						],
						[
							-82.4860876599999,
							27.86171071600006
						],
						[
							-82.48592204499994,
							27.861547012000074
						],
						[
							-82.48564078299995,
							27.861373985000057
						],
						[
							-82.48557909099992,
							27.86133242200009
						],
						[
							-82.48552104499993,
							27.861285902000077
						],
						[
							-82.48546704199993,
							27.861234744000058
						],
						[
							-82.48541745099993,
							27.86117929800008
						],
						[
							-82.48537261299992,
							27.861119944000052
						],
						[
							-82.48533283299992,
							27.861057087000063
						],
						[
							-82.48529838399992,
							27.860991157000058
						],
						[
							-82.48521738399995,
							27.86081915700004
						],
						[
							-82.48519020999993,
							27.860755134000044
						],
						[
							-82.4851680619999,
							27.86068920400004
						],
						[
							-82.48515107299994,
							27.860621759000082
						],
						[
							-82.48513934599993,
							27.86055320400004
						],
						[
							-82.48513294799994,
							27.86048394800008
						],
						[
							-82.4851319199999,
							27.860414405000085
						],
						[
							-82.48513626699992,
							27.860344989000055
						],
						[
							-82.4850710799999,
							27.86027207300009
						],
						[
							-82.4850402589999,
							27.86023321400006
						],
						[
							-82.48484277999995,
							27.859969620000072
						],
						[
							-82.4842758129999,
							27.859363900000066
						],
						[
							-82.48424865999995,
							27.859345957000073
						],
						[
							-82.48411592199994,
							27.85928405900006
						],
						[
							-82.4840768759999,
							27.859264685000085
						],
						[
							-82.48383387599995,
							27.85913668600006
						],
						[
							-82.48377434899993,
							27.859102363000094
						],
						[
							-82.48371761599992,
							27.859063596000055
						],
						[
							-82.48366400899995,
							27.859020611000062
						],
						[
							-82.48361383999992,
							27.85897365800008
						],
						[
							-82.48356740299995,
							27.858923012000048
						],
						[
							-82.4829044029999,
							27.85814201100004
						],
						[
							-82.48285345399995,
							27.85807602300008
						],
						[
							-82.48261945399992,
							27.857742023000075
						],
						[
							-82.4825771639999,
							27.857675661000087
						],
						[
							-82.4825405659999,
							27.857605272000058
						],
						[
							-82.4823893759999,
							27.85728021400007
						],
						[
							-82.48194281199994,
							27.856740615000035
						],
						[
							-82.48187736099993,
							27.85672495500006
						],
						[
							-82.48181331899991,
							27.85670427900004
						],
						[
							-82.48175106799994,
							27.856678711000086
						],
						[
							-82.48169098099993,
							27.856648403000065
						],
						[
							-82.48163341899995,
							27.856613537000044
						],
						[
							-82.48157872799993,
							27.856574323000075
						],
						[
							-82.48152572799995,
							27.85653332300007
						],
						[
							-82.48147127599992,
							27.856487653000045
						],
						[
							-82.48142060199991,
							27.856437823000082
						],
						[
							-82.48137402399995,
							27.85638414500005
						],
						[
							-82.48133183199992,
							27.856326954000053
						],
						[
							-82.48129429099993,
							27.856266609000045
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "MacDill AFB Area",
				"RegionID": "274386"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.81659921699992,
					26.166302617000042,
					-81.79834699999992,
					26.18933699200005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.80254512899995,
							26.18933699200005
						],
						[
							-81.80230230599994,
							26.18926900100007
						],
						[
							-81.80193321399992,
							26.18930785300006
						],
						[
							-81.80151555899994,
							26.18926900100007
						],
						[
							-81.80049570199992,
							26.189278714000068
						],
						[
							-81.8000102709999,
							26.189278714000068
						],
						[
							-81.79995449299992,
							26.189278714000068
						],
						[
							-81.79993999999994,
							26.188376000000062
						],
						[
							-81.79990099999993,
							26.18600900000007
						],
						[
							-81.79834699999992,
							26.186026000000084
						],
						[
							-81.79835113599995,
							26.185762271000044
						],
						[
							-81.79835999999995,
							26.185197000000073
						],
						[
							-81.79856199999995,
							26.18519500000008
						],
						[
							-81.79855177499991,
							26.184754352000084
						],
						[
							-81.79854655699995,
							26.18452946900004
						],
						[
							-81.79854099999994,
							26.18429000000009
						],
						[
							-81.79987099999994,
							26.184272000000078
						],
						[
							-81.79986909399993,
							26.184162644000082
						],
						[
							-81.79985499999992,
							26.183354000000065
						],
						[
							-81.79983099999993,
							26.18198700000005
						],
						[
							-81.79982999999993,
							26.181955000000073
						],
						[
							-81.7999143699999,
							26.18196465500006
						],
						[
							-81.79990994899993,
							26.181867785000065
						],
						[
							-81.79986999999994,
							26.180160000000058
						],
						[
							-81.79984999999994,
							26.17956999900008
						],
						[
							-81.79978999899993,
							26.177270000000078
						],
						[
							-81.79974999899991,
							26.175469999000086
						],
						[
							-81.7997099989999,
							26.17417000000006
						],
						[
							-81.7997099989999,
							26.173970000000054
						],
						[
							-81.79964999899994,
							26.171019999000066
						],
						[
							-81.79960999799994,
							26.16937000200005
						],
						[
							-81.79942029699993,
							26.168520295000064
						],
						[
							-81.79979169799992,
							26.16840774900004
						],
						[
							-81.80011311499993,
							26.16835185000008
						],
						[
							-81.80029478599994,
							26.16835185000008
						],
						[
							-81.80120313999993,
							26.168184154000073
						],
						[
							-81.80199969599994,
							26.168016458000068
						],
						[
							-81.80294997399994,
							26.167890686000078
						],
						[
							-81.80388627799994,
							26.16773696400009
						],
						[
							-81.80507412499992,
							26.16756926800008
						],
						[
							-81.8058427329999,
							26.167429522000077
						],
						[
							-81.80601042899993,
							26.16737362300006
						],
						[
							-81.80634347599994,
							26.16741802900009
						],
						[
							-81.80634099999992,
							26.16743400000007
						],
						[
							-81.80698520999994,
							26.167929369000035
						],
						[
							-81.80746587499993,
							26.168188188000045
						],
						[
							-81.80794654099992,
							26.16837306000008
						],
						[
							-81.80839023199991,
							26.168447008000044
						],
						[
							-81.80905576899995,
							26.168336085000078
						],
						[
							-81.80920366599992,
							26.167966343000046
						],
						[
							-81.80920366599992,
							26.16752265200006
						],
						[
							-81.80916669099992,
							26.167078960000083
						],
						[
							-81.8090924409999,
							26.16686419800004
						],
						[
							-81.80930806799995,
							26.166832188000058
						],
						[
							-81.81009103399992,
							26.166660914000094
						],
						[
							-81.81021680599991,
							26.166549117000045
						],
						[
							-81.81077579299995,
							26.166632965000076
						],
						[
							-81.81179648199992,
							26.166458984000087
						],
						[
							-81.8126878949999,
							26.166302617000042
						],
						[
							-81.81320621099991,
							26.167870595000068
						],
						[
							-81.8133233609999,
							26.168182391000073
						],
						[
							-81.81341306299993,
							26.16839426000007
						],
						[
							-81.81365409899992,
							26.16889754300007
						],
						[
							-81.81367409599994,
							26.168942402000088
						],
						[
							-81.81390809599992,
							26.169508402000076
						],
						[
							-81.81395084299993,
							26.169639446000076
						],
						[
							-81.81401384199995,
							26.169898445000058
						],
						[
							-81.8140225329999,
							26.16993804100008
						],
						[
							-81.81413334899992,
							26.17050348700008
						],
						[
							-81.81421692799995,
							26.170811454000045
						],
						[
							-81.81423944799991,
							26.170920969000065
						],
						[
							-81.81428036399991,
							26.171210058000042
						],
						[
							-81.81430364499994,
							26.171313576000045
						],
						[
							-81.8144294029999,
							26.171521382000037
						],
						[
							-81.81446035199991,
							26.171576857000048
						],
						[
							-81.81458955999994,
							26.171828994000066
						],
						[
							-81.81463303399994,
							26.171900597000047
						],
						[
							-81.81468118499993,
							26.171963756000082
						],
						[
							-81.81474483599993,
							26.172059339000043
						],
						[
							-81.81477713499993,
							26.172120618000065
						],
						[
							-81.81489013499993,
							26.172356618000038
						],
						[
							-81.81492566999992,
							26.17244179900007
						],
						[
							-81.81500220499993,
							26.172655520000035
						],
						[
							-81.81508174599992,
							26.172662622000075
						],
						[
							-81.81513332599991,
							26.172671904000083
						],
						[
							-81.81528158599991,
							26.172711914000047
						],
						[
							-81.8154236609999,
							26.172778165000068
						],
						[
							-81.81555207299994,
							26.172868080000057
						],
						[
							-81.81566291999991,
							26.172978927000088
						],
						[
							-81.81568294499993,
							26.173003668000035
						],
						[
							-81.8157149459999,
							26.173044668000045
						],
						[
							-81.81575962499994,
							26.173107255000048
						],
						[
							-81.81579879299994,
							26.173173431000066
						],
						[
							-81.8158321649999,
							26.173242710000068
						],
						[
							-81.8158594969999,
							26.17331458700005
						],
						[
							-81.8158805889999,
							26.17338853600006
						],
						[
							-81.81589528599994,
							26.17346401700007
						],
						[
							-81.8159034809999,
							26.173540477000074
						],
						[
							-81.8159084799999,
							26.173618477000048
						],
						[
							-81.81591137899994,
							26.173669632000042
						],
						[
							-81.81598583499994,
							26.173773339000036
						],
						[
							-81.81601830499994,
							26.17383497500009
						],
						[
							-81.8160513059999,
							26.173903975000087
						],
						[
							-81.8160804449999,
							26.173971950000066
						],
						[
							-81.8161039009999,
							26.174042090000057
						],
						[
							-81.8161215149999,
							26.17411392000008
						],
						[
							-81.81613316599993,
							26.17418695400005
						],
						[
							-81.81613877699994,
							26.174260699000058
						],
						[
							-81.81613830999993,
							26.174334656000042
						],
						[
							-81.81613176799993,
							26.17440832400007
						],
						[
							-81.81612276699991,
							26.174477323000076
						],
						[
							-81.8161108029999,
							26.174547420000067
						],
						[
							-81.81609332199992,
							26.174616349000075
						],
						[
							-81.81607043499992,
							26.17468367500004
						],
						[
							-81.81604228499992,
							26.174748977000036
						],
						[
							-81.81600904899994,
							26.174811843000043
						],
						[
							-81.81600729899992,
							26.17494840100005
						],
						[
							-81.81600388099992,
							26.175020586000073
						],
						[
							-81.81587241999995,
							26.17651925000007
						],
						[
							-81.81587724799994,
							26.178456263000044
						],
						[
							-81.81588734499991,
							26.178609395000084
						],
						[
							-81.81599631599994,
							26.180237959000067
						],
						[
							-81.81599802799991,
							26.180274999000062
						],
						[
							-81.8160435129999,
							26.182052844000058
						],
						[
							-81.81610614899995,
							26.18294097200004
						],
						[
							-81.8161933369999,
							26.183469667000058
						],
						[
							-81.81620487599992,
							26.183587689000035
						],
						[
							-81.81622018999991,
							26.184073907000084
						],
						[
							-81.81624744999993,
							26.184414183000058
						],
						[
							-81.8162491299999,
							26.184532295000054
						],
						[
							-81.81622716099992,
							26.184958486000085
						],
						[
							-81.81623627999994,
							26.185073279000054
						],
						[
							-81.81629842299992,
							26.18543622900006
						],
						[
							-81.81630954899993,
							26.185531550000064
						],
						[
							-81.81632954899993,
							26.185849551000047
						],
						[
							-81.81633126299994,
							26.185895723000044
						],
						[
							-81.81633488499995,
							26.18621257500007
						],
						[
							-81.81635302599994,
							26.18642520000009
						],
						[
							-81.81640501999993,
							26.18669454400009
						],
						[
							-81.81641789399993,
							26.18678655800005
						],
						[
							-81.81643694999991,
							26.187004195000043
						],
						[
							-81.81647344399994,
							26.187428327000077
						],
						[
							-81.81654837299993,
							26.188443343000074
						],
						[
							-81.81658692799994,
							26.188764956000057
						],
						[
							-81.81659245399993,
							26.18883250600004
						],
						[
							-81.81659921699992,
							26.188986356000044
						],
						[
							-81.81569813299991,
							26.188966018000087
						],
						[
							-81.8136293099999,
							26.18896140600009
						],
						[
							-81.81289545499993,
							26.188959398000065
						],
						[
							-81.81199668399995,
							26.188990964000084
						],
						[
							-81.8119921139999,
							26.18887000600006
						],
						[
							-81.81193884699991,
							26.18824193800009
						],
						[
							-81.81178900099992,
							26.18818200000004
						],
						[
							-81.81167333899992,
							26.18812583600004
						],
						[
							-81.81163359699991,
							26.188101497000048
						],
						[
							-81.81152935999995,
							26.18803388400005
						],
						[
							-81.81152765899992,
							26.18809416600004
						],
						[
							-81.81151538499995,
							26.188152425000055
						],
						[
							-81.81147438499994,
							26.18831942500009
						],
						[
							-81.81143763799992,
							26.188434873000066
						],
						[
							-81.81136863899991,
							26.188609873000075
						],
						[
							-81.8113108359999,
							26.18872966100008
						],
						[
							-81.81127474399995,
							26.188787062000074
						],
						[
							-81.81120374399991,
							26.18889106200004
						],
						[
							-81.81116324099992,
							26.188945818000036
						],
						[
							-81.81114723999991,
							26.188965818000042
						],
						[
							-81.81110510499991,
							26.18901477100008
						],
						[
							-81.81109737199995,
							26.18902254900007
						],
						[
							-81.8084649999999,
							26.189115000000072
						],
						[
							-81.80846558699994,
							26.18913119000007
						],
						[
							-81.8084666659999,
							26.18916098400007
						],
						[
							-81.80841954699991,
							26.189167078000082
						],
						[
							-81.80813977299995,
							26.18920101100008
						],
						[
							-81.80762498799993,
							26.18920101100008
						],
						[
							-81.80676053799993,
							26.189171872000088
						],
						[
							-81.8055464219999,
							26.18920101100008
						],
						[
							-81.80473053599991,
							26.189249575000076
						],
						[
							-81.80424488999995,
							26.18920101100008
						],
						[
							-81.80376895699993,
							26.189210723000087
						],
						[
							-81.80342900499994,
							26.189317566000057
						],
						[
							-81.80294335899993,
							26.189317566000057
						],
						[
							-81.80254512899995,
							26.18933699200005
						]
					],
					[
						[
							-81.81141269999995,
							26.184946343000036
						],
						[
							-81.81152240799992,
							26.18487000600004
						],
						[
							-81.81143958599995,
							26.18491308600005
						],
						[
							-81.81140751599992,
							26.18492407900004
						],
						[
							-81.81136988899993,
							26.18493618900004
						],
						[
							-81.81137648299995,
							26.18495662500004
						],
						[
							-81.81138100699991,
							26.18497264800004
						],
						[
							-81.81141269999995,
							26.184946343000036
						]
					],
					[
						[
							-81.81072132899993,
							26.17874898200006
						],
						[
							-81.81078432899994,
							26.17872998200005
						],
						[
							-81.8108878349999,
							26.17870534000008
						],
						[
							-81.81098573299995,
							26.178693567000042
						],
						[
							-81.81106273299991,
							26.17868856800004
						],
						[
							-81.8111209999999,
							26.178686678000076
						],
						[
							-81.81125868499993,
							26.17869728000005
						],
						[
							-81.81133892499992,
							26.178709810000043
						],
						[
							-81.81143120699994,
							26.178732729000046
						],
						[
							-81.8114452929999,
							26.17808972200004
						],
						[
							-81.81141118199992,
							26.177217037000048
						],
						[
							-81.8113885009999,
							26.17695272900005
						],
						[
							-81.81135850099992,
							26.176715372000047
						],
						[
							-81.81133940199993,
							26.17677748600005
						],
						[
							-81.81132431499992,
							26.17685097800006
						],
						[
							-81.81129673899994,
							26.17707762100008
						],
						[
							-81.81128363199991,
							26.17715615700007
						],
						[
							-81.8112636319999,
							26.17725015600007
						],
						[
							-81.8112290869999,
							26.177370586000052
						],
						[
							-81.81120716299995,
							26.17742519300009
						],
						[
							-81.81107516199995,
							26.17772519300007
						],
						[
							-81.81103083499994,
							26.17781266100008
						],
						[
							-81.81099728899994,
							26.177866313000038
						],
						[
							-81.81084128899994,
							26.178097313000084
						],
						[
							-81.81076539199995,
							26.178194579000035
						],
						[
							-81.81066939199991,
							26.17830157800006
						],
						[
							-81.81061164199991,
							26.178360298000086
						],
						[
							-81.81052864299994,
							26.178437298000063
						],
						[
							-81.81049507299991,
							26.178466920000062
						],
						[
							-81.81038861699994,
							26.178543740000066
						],
						[
							-81.81023761599994,
							26.178636741000048
						],
						[
							-81.81018928999993,
							26.17866447700004
						],
						[
							-81.8097071059999,
							26.17892170400006
						],
						[
							-81.8098064379999,
							26.17927306000007
						],
						[
							-81.81000259199993,
							26.179229839000072
						],
						[
							-81.81009976199994,
							26.179195279000055
						],
						[
							-81.81013241399995,
							26.179179700000077
						],
						[
							-81.81017115999992,
							26.179130110000074
						],
						[
							-81.81026315999992,
							26.179030110000046
						],
						[
							-81.81031876999992,
							26.178974722000078
						],
						[
							-81.81037899699993,
							26.17892439500008
						],
						[
							-81.81044338299995,
							26.17887951000006
						],
						[
							-81.81051143699995,
							26.178840410000078
						],
						[
							-81.81056743699992,
							26.178811410000037
						],
						[
							-81.81067341399995,
							26.178764913000066
						],
						[
							-81.81072132899993,
							26.17874898200006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Collier",
				"City": "Naples",
				"Name": "Moorings",
				"RegionID": "274586"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.08365711999994,
					26.733292686000087,
					-80.06722999999994,
					26.75327092100008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.07136694799993,
							26.74872203500007
						],
						[
							-80.07116425099991,
							26.748476140000037
						],
						[
							-80.07095529999992,
							26.74822265800009
						],
						[
							-80.07080796699995,
							26.748043928000072
						],
						[
							-80.07069492599993,
							26.747885224000072
						],
						[
							-80.07062999999994,
							26.747790000000066
						],
						[
							-80.07046721299992,
							26.747557447000077
						],
						[
							-80.0703696409999,
							26.74737401300007
						],
						[
							-80.07027946699992,
							26.74719882800008
						],
						[
							-80.07015605299995,
							26.74692048500009
						],
						[
							-80.07006113299991,
							26.74666783200007
						],
						[
							-80.06998331599993,
							26.746426607000046
						],
						[
							-80.06992229799994,
							26.746129563000068
						],
						[
							-80.06988999999993,
							26.745960000000082
						],
						[
							-80.06988999999993,
							26.745850000000075
						],
						[
							-80.0698841009999,
							26.745513743000064
						],
						[
							-80.0698799999999,
							26.74491098900006
						],
						[
							-80.0698799999999,
							26.744601826000068
						],
						[
							-80.0698799999999,
							26.744330000000048
						],
						[
							-80.06988355599992,
							26.744076332000077
						],
						[
							-80.06988810599996,
							26.743751775000078
						],
						[
							-80.06989135899994,
							26.74351973200004
						],
						[
							-80.06989720899992,
							26.743102444000044
						],
						[
							-80.06990045899994,
							26.74287061800004
						],
						[
							-80.06990349499995,
							26.74265403000004
						],
						[
							-80.06990674499991,
							26.742422203000046
						],
						[
							-80.06990999999995,
							26.74219000000005
						],
						[
							-80.06990630799993,
							26.742097697000077
						],
						[
							-80.06990075199991,
							26.741958796000063
						],
						[
							-80.06989272599992,
							26.741758161000064
						],
						[
							-80.06987595599993,
							26.741528490000064
						],
						[
							-80.06986023899992,
							26.74138679100008
						],
						[
							-80.06983557199995,
							26.74120007600004
						],
						[
							-80.0697847319999,
							26.740980110000066
						],
						[
							-80.06974988199994,
							26.74081543300008
						],
						[
							-80.06969910599992,
							26.740596425000035
						],
						[
							-80.06963832799994,
							26.74040522300004
						],
						[
							-80.06958193499992,
							26.74024410000004
						],
						[
							-80.0695139739999,
							26.740049927000086
						],
						[
							-80.06944413199994,
							26.739885849000075
						],
						[
							-80.06937066599994,
							26.73972259100009
						],
						[
							-80.06929980299992,
							26.73956511700004
						],
						[
							-80.06923212099991,
							26.739414713000087
						],
						[
							-80.0691502709999,
							26.739260942000044
						],
						[
							-80.06908209399995,
							26.739133480000078
						],
						[
							-80.06895939399993,
							26.738917246000085
						],
						[
							-80.0688386089999,
							26.738734890000046
						],
						[
							-80.06874139399991,
							26.738594237000086
						],
						[
							-80.06860035799993,
							26.738398957000072
						],
						[
							-80.06844263499994,
							26.738184708000063
						],
						[
							-80.06828253299994,
							26.737956616000076
						],
						[
							-80.06820999999991,
							26.737850000000037
						],
						[
							-80.06811581499994,
							26.73768517700006
						],
						[
							-80.06802239399991,
							26.737491831000057
						],
						[
							-80.06790366699995,
							26.737216446000048
						],
						[
							-80.06782886399992,
							26.737015608000036
						],
						[
							-80.06775909399994,
							26.736745831000064
						],
						[
							-80.06772359899992,
							26.736608582000088
						],
						[
							-80.06767999999994,
							26.736440000000073
						],
						[
							-80.06762772299994,
							26.736211722000064
						],
						[
							-80.0675986729999,
							26.736084874000085
						],
						[
							-80.0675142579999,
							26.73571625900007
						],
						[
							-80.06745103499992,
							26.73544018700005
						],
						[
							-80.06738454499992,
							26.73514984400009
						],
						[
							-80.0672855649999,
							26.734740920000036
						],
						[
							-80.06722999999994,
							26.734570000000076
						],
						[
							-80.06813161499991,
							26.733410458000037
						],
						[
							-80.06903298899994,
							26.733292686000087
						],
						[
							-80.06936722699993,
							26.73447172100009
						],
						[
							-80.06937067799993,
							26.73448423800005
						],
						[
							-80.06938404199991,
							26.734541551000063
						],
						[
							-80.06939362799994,
							26.734599615000036
						],
						[
							-80.06939621999993,
							26.734621345000054
						],
						[
							-80.06952385499994,
							26.735814531000074
						],
						[
							-80.06968986399994,
							26.736642893000067
						],
						[
							-80.06994630699995,
							26.737166004000073
						],
						[
							-80.07030477099994,
							26.737753697000073
						],
						[
							-80.0703158359999,
							26.73777233900006
						],
						[
							-80.0703435769999,
							26.737824240000066
						],
						[
							-80.07036786499992,
							26.737877845000074
						],
						[
							-80.07038859499994,
							26.737932923000074
						],
						[
							-80.07039679999991,
							26.73795832600007
						],
						[
							-80.07045070499993,
							26.73813410400004
						],
						[
							-80.07077600799994,
							26.738625745000036
						],
						[
							-80.07080483599992,
							26.73867233900006
						],
						[
							-80.07082768799995,
							26.73871447500005
						],
						[
							-80.07113268799992,
							26.73931447500007
						],
						[
							-80.07113757799993,
							26.739324240000087
						],
						[
							-80.07115842699994,
							26.739369658000044
						],
						[
							-80.07140242699995,
							26.739942658000075
						],
						[
							-80.07140586499992,
							26.739950844000077
						],
						[
							-80.07142659499993,
							26.740005922000083
						],
						[
							-80.07144367799992,
							26.740062238000064
						],
						[
							-80.0714570419999,
							26.740119551000078
						],
						[
							-80.07146662799994,
							26.74017761500005
						],
						[
							-80.07147239599993,
							26.740236181000057
						],
						[
							-80.07147248899992,
							26.74023761300009
						],
						[
							-80.07152377199992,
							26.741039637000085
						],
						[
							-80.0716485609999,
							26.741335333000052
						],
						[
							-80.07165086499992,
							26.741340844000035
						],
						[
							-80.07167159499994,
							26.741395922000038
						],
						[
							-80.07168867799994,
							26.74145223800008
						],
						[
							-80.07170204099992,
							26.741509551000036
						],
						[
							-80.07171162799996,
							26.741567615000065
						],
						[
							-80.07171739599994,
							26.741626181000072
						],
						[
							-80.07171932199992,
							26.741685000000075
						],
						[
							-80.07171739599994,
							26.74174381800009
						],
						[
							-80.07171162799996,
							26.741802385000085
						],
						[
							-80.07170407099994,
							26.741849916000035
						],
						[
							-80.07164307199992,
							26.742176916000062
						],
						[
							-80.0716410419999,
							26.742187449000085
						],
						[
							-80.0716276789999,
							26.74224476100005
						],
						[
							-80.07162368399992,
							26.742259189000038
						],
						[
							-80.07162531299991,
							26.742279920000044
						],
						[
							-80.07165596699991,
							26.742737753000085
						],
						[
							-80.07168556099992,
							26.743114590000065
						],
						[
							-80.0716863959999,
							26.743126181000036
						],
						[
							-80.07168832199994,
							26.74318500000004
						],
						[
							-80.0716863959999,
							26.743243818000053
						],
						[
							-80.07168062799991,
							26.74330238500005
						],
						[
							-80.07167104199993,
							26.74336044900008
						],
						[
							-80.07165767799995,
							26.743417761000046
						],
						[
							-80.07164649999993,
							26.743456060000085
						],
						[
							-80.07143668899994,
							26.744119798000042
						],
						[
							-80.07149434699994,
							26.744826912000065
						],
						[
							-80.07149539699994,
							26.744841181000083
						],
						[
							-80.07149725799991,
							26.744889262000072
						],
						[
							-80.07150124999993,
							26.745223535000036
						],
						[
							-80.07150272199993,
							26.74533216900005
						],
						[
							-80.0715970739999,
							26.745543043000055
						],
						[
							-80.07201218099993,
							26.745614492000076
						],
						[
							-80.07271497999996,
							26.745640283000057
						],
						[
							-80.07274081799994,
							26.745641603000085
						],
						[
							-80.07279938499994,
							26.745647372000064
						],
						[
							-80.07285744899991,
							26.74565695800004
						],
						[
							-80.07287151899993,
							26.74565987400007
						],
						[
							-80.07375751899991,
							26.74585087400004
						],
						[
							-80.0738007619999,
							26.745861322000053
						],
						[
							-80.07385707799995,
							26.74587840500004
						],
						[
							-80.07391215599995,
							26.745899135000062
						],
						[
							-80.07396575999991,
							26.74592342300008
						],
						[
							-80.07399188499994,
							26.74593684100006
						],
						[
							-80.07429688399992,
							26.746099840000056
						],
						[
							-80.07432266099994,
							26.746114164000062
						],
						[
							-80.0743726369999,
							26.74614524100008
						],
						[
							-80.07442047299992,
							26.74617952000006
						],
						[
							-80.07442733799991,
							26.74618484100006
						],
						[
							-80.0746337189999,
							26.746346393000067
						],
						[
							-80.0747399679999,
							26.74641271200005
						],
						[
							-80.07478144899994,
							26.746419958000047
						],
						[
							-80.07483876099991,
							26.74643332100004
						],
						[
							-80.07489507699995,
							26.746450405000076
						],
						[
							-80.07495015499991,
							26.746471135000036
						],
						[
							-80.0750037599999,
							26.746495422000066
						],
						[
							-80.07505566099991,
							26.746523164000052
						],
						[
							-80.07510563599993,
							26.74655424100007
						],
						[
							-80.0751534719999,
							26.746588520000046
						],
						[
							-80.07519896399992,
							26.746625854000058
						],
						[
							-80.07524191599992,
							26.74666608300004
						],
						[
							-80.07528214599995,
							26.746709036000084
						],
						[
							-80.0753194799999,
							26.746754527000068
						],
						[
							-80.07535375899994,
							26.746802363000086
						],
						[
							-80.07538483499991,
							26.746852339000043
						],
						[
							-80.07541257699995,
							26.74690424000005
						],
						[
							-80.07541648099993,
							26.746912826000084
						],
						[
							-80.07545266099993,
							26.746932164000043
						],
						[
							-80.0755026359999,
							26.74696324100006
						],
						[
							-80.07555047199992,
							26.746997520000036
						],
						[
							-80.07559596399994,
							26.74703485400005
						],
						[
							-80.07563891699994,
							26.747075083000084
						],
						[
							-80.07567914599991,
							26.747118036000074
						],
						[
							-80.07571647999993,
							26.747163527000055
						],
						[
							-80.07575001499993,
							26.74721025200006
						],
						[
							-80.07590989399995,
							26.747448760000054
						],
						[
							-80.07591246999993,
							26.747451927000043
						],
						[
							-80.07606872799994,
							26.747440906000065
						],
						[
							-80.07607318099991,
							26.747440603000086
						],
						[
							-80.07613199999992,
							26.747438678000037
						],
						[
							-80.07619081799993,
							26.747440603000086
						],
						[
							-80.0762004149999,
							26.747441284000047
						],
						[
							-80.07653325699994,
							26.74746667800008
						],
						[
							-80.07696982899995,
							26.74746667800008
						],
						[
							-80.07768567099993,
							26.747439333000045
						],
						[
							-80.07771999999994,
							26.747438678000037
						],
						[
							-80.07777487899995,
							26.74744035400005
						],
						[
							-80.07823287799994,
							26.74746835400009
						],
						[
							-80.07823681799994,
							26.747468604000062
						],
						[
							-80.07829538499993,
							26.747474372000056
						],
						[
							-80.0783534489999,
							26.747483959000082
						],
						[
							-80.07841076099993,
							26.747497322000072
						],
						[
							-80.07845796499993,
							26.747511366000083
						],
						[
							-80.07903796599993,
							26.747701366000058
						],
						[
							-80.07904707799992,
							26.747704405000036
						],
						[
							-80.07910215599993,
							26.747725135000053
						],
						[
							-80.07915575999994,
							26.747749423000073
						],
						[
							-80.07919239099994,
							26.747768545000042
						],
						[
							-80.0794684679999,
							26.747920840000063
						],
						[
							-80.07961321999996,
							26.747786903000076
						],
						[
							-80.07963103499993,
							26.747770854000066
						],
						[
							-80.07967652699995,
							26.747733520000054
						],
						[
							-80.07972436299991,
							26.747699242000067
						],
						[
							-80.07974163199992,
							26.747687987000063
						],
						[
							-80.0798934629999,
							26.74759149500005
						],
						[
							-80.08011255099991,
							26.747395596000047
						],
						[
							-80.08011903499994,
							26.747389854000062
						],
						[
							-80.08015175899993,
							26.747362501000055
						],
						[
							-80.08040792099992,
							26.747158503000037
						],
						[
							-80.08060391299995,
							26.746984491000035
						],
						[
							-80.0806080349999,
							26.74698085400007
						],
						[
							-80.08064075899995,
							26.746953501000064
						],
						[
							-80.08091575899994,
							26.74673450100005
						],
						[
							-80.08092852699991,
							26.746724520000043
						],
						[
							-80.08097636299993,
							26.746690241000067
						],
						[
							-80.08102326999995,
							26.74666094400004
						],
						[
							-80.08169765199995,
							26.74626803500007
						],
						[
							-80.08219024599993,
							26.745932046000064
						],
						[
							-80.08219736399991,
							26.74592724100006
						],
						[
							-80.08224294799993,
							26.745898716000056
						],
						[
							-80.08245054499992,
							26.74577729100008
						],
						[
							-80.08310883799993,
							26.746403473000044
						],
						[
							-80.08320579399992,
							26.74648108300005
						],
						[
							-80.08365711999994,
							26.746842359000084
						],
						[
							-80.08128738099992,
							26.748668027000065
						],
						[
							-80.08125744099993,
							26.748636919000035
						],
						[
							-80.0811071139999,
							26.74874966400006
						],
						[
							-80.08080211299995,
							26.748978415000067
						],
						[
							-80.08048674799994,
							26.749217718000068
						],
						[
							-80.08031426699995,
							26.749344204000067
						],
						[
							-80.08010953599995,
							26.74949434000007
						],
						[
							-80.0798932859999,
							26.749652923000042
						],
						[
							-80.07972829199991,
							26.749773919000063
						],
						[
							-80.07964478699995,
							26.749835156000074
						],
						[
							-80.07956999999993,
							26.74989000000005
						],
						[
							-80.07948139199993,
							26.74997307000007
						],
						[
							-80.07939257399994,
							26.750056337000046
						],
						[
							-80.07928983699992,
							26.750152653000043
						],
						[
							-80.0791663309999,
							26.75026843900008
						],
						[
							-80.07909121199992,
							26.75033886400007
						],
						[
							-80.07903138699993,
							26.75042791900006
						],
						[
							-80.07895781399992,
							26.750538279000068
						],
						[
							-80.07888321899992,
							26.750650171000075
						],
						[
							-80.07882206799991,
							26.75071336700006
						],
						[
							-80.07876206599991,
							26.75076765400007
						],
						[
							-80.07868519499993,
							26.75083720500004
						],
						[
							-80.07866432399993,
							26.750856087000045
						],
						[
							-80.0786599999999,
							26.750890816000037
						],
						[
							-80.0786447619999,
							26.75094285700004
						],
						[
							-80.07860184399993,
							26.751007233000053
						],
						[
							-80.07855483899993,
							26.751077741000074
						],
						[
							-80.0785037469999,
							26.751154379000074
						],
						[
							-80.07845061099994,
							26.75123408400009
						],
						[
							-80.07840492399993,
							26.751315141000077
						],
						[
							-80.0783664679999,
							26.75139081800006
						],
						[
							-80.07832407099994,
							26.75152065900005
						],
						[
							-80.07829279299995,
							26.75161644700006
						],
						[
							-80.07825627599993,
							26.751728281000055
						],
						[
							-80.07823019799991,
							26.75180814500004
						],
						[
							-80.0782099999999,
							26.751870000000054
						],
						[
							-80.07819624099996,
							26.75192732800008
						],
						[
							-80.07817556199991,
							26.75201349400004
						],
						[
							-80.07815865599991,
							26.75208217800008
						],
						[
							-80.07813588999994,
							26.75217467600004
						],
						[
							-80.07810732599995,
							26.752285361000077
						],
						[
							-80.07808114699992,
							26.75238680600006
						],
						[
							-80.0780561659999,
							26.752549891000058
						],
						[
							-80.0780393359999,
							26.752698295000073
						],
						[
							-80.07802455299992,
							26.75288308800009
						],
						[
							-80.07800911499993,
							26.753076066000062
						],
						[
							-80.07799999999992,
							26.753190000000075
						],
						[
							-80.07800392899992,
							26.753229289000046
						],
						[
							-80.07800809199995,
							26.75327092100008
						],
						[
							-80.07791315799994,
							26.75326983100007
						],
						[
							-80.07705699999991,
							26.75326000000007
						],
						[
							-80.07633299999992,
							26.75325500000008
						],
						[
							-80.07520399999993,
							26.753247000000044
						],
						[
							-80.07244478799993,
							26.753229038000086
						],
						[
							-80.07256012999994,
							26.752039977000038
						],
						[
							-80.07262999999995,
							26.751600000000053
						],
						[
							-80.07262125899992,
							26.75143392700005
						],
						[
							-80.07260492499995,
							26.75130954900004
						],
						[
							-80.0725698309999,
							26.751098984000066
						],
						[
							-80.07252022699993,
							26.750907425000037
						],
						[
							-80.07248566399994,
							26.75080220600006
						],
						[
							-80.07240736099993,
							26.750595771000064
						],
						[
							-80.07232593499992,
							26.75039339700004
						],
						[
							-80.07222309299993,
							26.750153114000057
						],
						[
							-80.07208043399993,
							26.74986160300006
						],
						[
							-80.07195633999993,
							26.74962345000006
						],
						[
							-80.07185159799991,
							26.74943601700005
						],
						[
							-80.0717699999999,
							26.749290000000087
						],
						[
							-80.07161835199992,
							26.749073498000087
						],
						[
							-80.07136694799993,
							26.74872203500007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "West Palm Beach",
				"Name": "North Shore",
				"RegionID": "274745"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.41442715999996,
					27.99636363600007,
					-82.40185993599994,
					28.020364919000087
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.41004299999992,
							27.999731000000054
						],
						[
							-82.4059519999999,
							27.999712000000045
						],
						[
							-82.40496472599995,
							27.999727908000068
						],
						[
							-82.4049589999999,
							27.99972800000006
						],
						[
							-82.40449091199991,
							27.99972893200004
						],
						[
							-82.40445699999992,
							27.99972900000006
						],
						[
							-82.40433557999995,
							27.999728474000054
						],
						[
							-82.40191599999991,
							27.99971800000009
						],
						[
							-82.40191585799995,
							27.999712533000036
						],
						[
							-82.40187998599993,
							27.998327561000053
						],
						[
							-82.40186999999992,
							27.99794200000008
						],
						[
							-82.40188181899993,
							27.997490909000078
						],
						[
							-82.40185993599994,
							27.996399524000083
						],
						[
							-82.4141909089999,
							27.99636363600007
						],
						[
							-82.4141850879999,
							28.00370170900004
						],
						[
							-82.41418219799993,
							28.007379205000063
						],
						[
							-82.41418115899995,
							28.00877024600004
						],
						[
							-82.41419437899992,
							28.008818766000047
						],
						[
							-82.41442715999996,
							28.009341324000047
						],
						[
							-82.41442246299994,
							28.00934184600004
						],
						[
							-82.41398948699992,
							28.009475069000075
						],
						[
							-82.41382295799991,
							28.009758169000065
						],
						[
							-82.4137765399999,
							28.01002864700007
						],
						[
							-82.41304706099993,
							28.01068605900008
						],
						[
							-82.4130379639999,
							28.01069414600005
						],
						[
							-82.41303265399995,
							28.010698766000075
						],
						[
							-82.41285566199991,
							28.010851550000044
						],
						[
							-82.41284819099991,
							28.01090733400008
						],
						[
							-82.41284023499992,
							28.01105930600005
						],
						[
							-82.41283878399993,
							28.01109063000007
						],
						[
							-82.4128600649999,
							28.01127010500005
						],
						[
							-82.41286439599992,
							28.011317182000084
						],
						[
							-82.41286584899991,
							28.011346847000084
						],
						[
							-82.41287172999995,
							28.01152817700006
						],
						[
							-82.41289558199992,
							28.01211550900007
						],
						[
							-82.41289439699995,
							28.012210819000074
						],
						[
							-82.4128886279999,
							28.01226938500008
						],
						[
							-82.41288837399992,
							28.012271302000045
						],
						[
							-82.41283537299995,
							28.01266730100008
						],
						[
							-82.4128260409999,
							28.01272344900008
						],
						[
							-82.41281903799997,
							28.012755577000064
						],
						[
							-82.41235581099994,
							28.014708304000067
						],
						[
							-82.41152485799995,
							28.016669123000042
						],
						[
							-82.41120845199993,
							28.017451810000072
						],
						[
							-82.41099196499994,
							28.018434331000037
						],
						[
							-82.41077547699992,
							28.019283629000086
						],
						[
							-82.41044241899993,
							28.019949745000076
						],
						[
							-82.40990862299992,
							28.020364919000087
						],
						[
							-82.40957640199991,
							28.019506223000064
						],
						[
							-82.4096679999999,
							28.019423000000074
						],
						[
							-82.40977399999991,
							28.01934200000005
						],
						[
							-82.40979845499993,
							28.019330143000047
						],
						[
							-82.40987299999995,
							28.01929400000006
						],
						[
							-82.40994199999994,
							28.01925300000005
						],
						[
							-82.40997699999991,
							28.019216000000085
						],
						[
							-82.41002199999991,
							28.019152000000076
						],
						[
							-82.4100729999999,
							28.01909100000006
						],
						[
							-82.4100699999999,
							28.018417000000056
						],
						[
							-82.41008199999993,
							28.015973000000088
						],
						[
							-82.4100699999999,
							28.01554400000009
						],
						[
							-82.41008699999992,
							28.01527200000004
						],
						[
							-82.41009099999991,
							28.014848000000086
						],
						[
							-82.4100709999999,
							28.01448600000009
						],
						[
							-82.41007899999994,
							28.01364600000005
						],
						[
							-82.41010799999992,
							28.013509000000056
						],
						[
							-82.41011399999991,
							28.013048000000083
						],
						[
							-82.40998599999995,
							28.011288000000036
						],
						[
							-82.4099486209999,
							28.010867331000043
						],
						[
							-82.40992299999994,
							28.010579000000064
						],
						[
							-82.40998599999995,
							28.01053900000005
						],
						[
							-82.4100699999999,
							28.010371000000077
						],
						[
							-82.41009673199994,
							28.007061217000057
						],
						[
							-82.41009673199994,
							28.007061143000048
						],
						[
							-82.41009699999995,
							28.007028000000048
						],
						[
							-82.41009694099995,
							28.007021530000088
						],
						[
							-82.41007999999994,
							28.00516300000004
						],
						[
							-82.41005440099991,
							28.004083568000055
						],
						[
							-82.41003799999993,
							28.003392000000076
						],
						[
							-82.41006299999992,
							28.00264100000004
						],
						[
							-82.41003299999994,
							28.001930000000073
						],
						[
							-82.41003199999994,
							28.00153800000004
						],
						[
							-82.41002999999995,
							28.00120600000008
						],
						[
							-82.41002899999995,
							28.00055800000007
						],
						[
							-82.4100269999999,
							28.000329000000082
						],
						[
							-82.41004299999992,
							27.999731000000054
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Northeast",
				"RegionID": "274763"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.50601920018643,
					27.944936308445662,
					-82.48499999840412,
					27.956390908381607
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.48499999840412,
							27.956354545194657
						],
						[
							-82.48511818100997,
							27.944936308445662
						],
						[
							-82.4933182406419,
							27.944957818429856
						],
						[
							-82.50601920018643,
							27.94499065357646
						],
						[
							-82.50599016107816,
							27.954952801625176
						],
						[
							-82.50561817990305,
							27.955199999170716
						],
						[
							-82.50271818112131,
							27.95619999940196
						],
						[
							-82.501736363383,
							27.956390908381607
						],
						[
							-82.48499999840412,
							27.956354545194657
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Oakford Park",
				"RegionID": "274847"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.18806799999999,
					26.205586307000033,
					-80.17161402599999,
					26.21016000000003
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.17162082199997,
							26.209930022000037
						],
						[
							-80.17172598299999,
							26.206371498000067
						],
						[
							-80.18789905399996,
							26.205586307000033
						],
						[
							-80.18789893699994,
							26.20559073000004
						],
						[
							-80.18794316799995,
							26.206786245000046
						],
						[
							-80.18794717399999,
							26.20699555600004
						],
						[
							-80.18795117899998,
							26.20730801900004
						],
						[
							-80.18800225499996,
							26.208847302000038
						],
						[
							-80.18800826299997,
							26.208928422000042
						],
						[
							-80.18800826399996,
							26.20899952800005
						],
						[
							-80.18800671399998,
							26.20906000000008
						],
						[
							-80.18806799999999,
							26.20906000000008
						],
						[
							-80.18806799999999,
							26.20923300000004
						],
						[
							-80.18806643899995,
							26.209560000000067
						],
						[
							-80.18802171999994,
							26.209560000000067
						],
						[
							-80.18799606099998,
							26.209560000000067
						],
						[
							-80.18663982999999,
							26.209560000000067
						],
						[
							-80.18656599999997,
							26.209560000000067
						],
						[
							-80.18649406099996,
							26.209560000000067
						],
						[
							-80.18564182999995,
							26.209560000000067
						],
						[
							-80.18556799999999,
							26.209560000000067
						],
						[
							-80.18549606099998,
							26.209560000000067
						],
						[
							-80.18538504999998,
							26.209560000000067
						],
						[
							-80.18531121999997,
							26.209560000000067
						],
						[
							-80.18494182999996,
							26.209560000000067
						],
						[
							-80.18486799999994,
							26.209560000000067
						],
						[
							-80.18484182999998,
							26.209560000000067
						],
						[
							-80.18479606099999,
							26.209560000000067
						],
						[
							-80.18476799999996,
							26.209560000000067
						],
						[
							-80.18346799999995,
							26.20936000000006
						],
						[
							-80.18339607099995,
							26.209359131000042
						],
						[
							-80.18114181399994,
							26.209331892000023
						],
						[
							-80.18106799999998,
							26.209331000000077
						],
						[
							-80.18099607099998,
							26.209330115000057
						],
						[
							-80.17596519699998,
							26.20926823900004
						],
						[
							-80.17591408399994,
							26.20926761000004
						],
						[
							-80.17589138299996,
							26.209267331000035
						],
						[
							-80.17584026899993,
							26.209266702000036
						],
						[
							-80.17553181399995,
							26.20926290800003
						],
						[
							-80.17545799999994,
							26.209262000000024
						],
						[
							-80.17538606899996,
							26.20926124300007
						],
						[
							-80.17534181799994,
							26.209260777000054
						],
						[
							-80.17533436099995,
							26.209260699000026
						],
						[
							-80.17526799999996,
							26.20926000000003
						],
						[
							-80.17526053499995,
							26.209260679000067
						],
						[
							-80.17416799999995,
							26.20936000000006
						],
						[
							-80.17269563299999,
							26.20991213800005
						],
						[
							-80.17256799999996,
							26.209960000000024
						],
						[
							-80.17196899999999,
							26.21009300000003
						],
						[
							-80.17168795299995,
							26.210155559000043
						],
						[
							-80.17166799999995,
							26.21016000000003
						],
						[
							-80.17161402599999,
							26.21016000000003
						],
						[
							-80.17162082199997,
							26.209930022000037
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Palm-Aire Village (EAST)",
				"RegionID": "274947"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.20112899999992,
					26.05399200000005,
					-80.19213972999995,
					26.062866000000042
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.19493899999992,
							26.062627000000077
						],
						[
							-80.19371299999995,
							26.062594000000047
						],
						[
							-80.19266899999991,
							26.06256600000006
						],
						[
							-80.1926632119999,
							26.06194496100005
						],
						[
							-80.19213972999995,
							26.061183534000065
						],
						[
							-80.19218731899991,
							26.058518538000044
						],
						[
							-80.19337704999992,
							26.058518538000044
						],
						[
							-80.19385294199992,
							26.058423359000074
						],
						[
							-80.19409088799995,
							26.057947467000076
						],
						[
							-80.19413847699991,
							26.057186039000044
						],
						[
							-80.19394812099995,
							26.056186666000087
						],
						[
							-80.19371017399993,
							26.055472827000074
						],
						[
							-80.19323428199993,
							26.054996935000077
						],
						[
							-80.1926632119999,
							26.054092740000044
						],
						[
							-80.1972429999999,
							26.054081000000053
						],
						[
							-80.1974689999999,
							26.054066000000095
						],
						[
							-80.20020099999994,
							26.05399200000005
						],
						[
							-80.2000579999999,
							26.05457700000005
						],
						[
							-80.20003999999994,
							26.054635000000076
						],
						[
							-80.20112899999992,
							26.05461100000008
						],
						[
							-80.20092799999992,
							26.05537300000009
						],
						[
							-80.19982499999992,
							26.055397000000085
						],
						[
							-80.1995609999999,
							26.056166000000076
						],
						[
							-80.19939999999991,
							26.05670900000007
						],
						[
							-80.19937099999993,
							26.05686600000007
						],
						[
							-80.19915299999991,
							26.058066000000053
						],
						[
							-80.19884499999995,
							26.058853000000056
						],
						[
							-80.19832099999991,
							26.060906000000045
						],
						[
							-80.2001899999999,
							26.060979000000092
						],
						[
							-80.20034199999992,
							26.06100300000009
						],
						[
							-80.1999689999999,
							26.062866000000042
						],
						[
							-80.19896899999992,
							26.062866000000042
						],
						[
							-80.19793199999992,
							26.062786000000074
						],
						[
							-80.19794699999994,
							26.062650000000076
						],
						[
							-80.19810799999993,
							26.06168100000008
						],
						[
							-80.19766299999992,
							26.061679000000083
						],
						[
							-80.19759199999993,
							26.062760000000086
						],
						[
							-80.19636899999995,
							26.062666000000036
						],
						[
							-80.19493899999992,
							26.062627000000077
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Hollywood",
				"Name": "Mapleridge",
				"RegionID": "269082"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.64787609099994,
					30.31763272700005,
					-81.6251286779999,
					30.330058362000045
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.6361088079999,
							30.32736346700006
						],
						[
							-81.63345918099992,
							30.327363465000072
						],
						[
							-81.63016998499995,
							30.327363465000072
						],
						[
							-81.62715315899993,
							30.327363191000078
						],
						[
							-81.62637219099992,
							30.326800620000085
						],
						[
							-81.62656379399994,
							30.32667447900008
						],
						[
							-81.62666311999993,
							30.326075633000073
						],
						[
							-81.6257572099999,
							30.325789585000052
						],
						[
							-81.62572041399994,
							30.325777086000077
						],
						[
							-81.6255783389999,
							30.325710835000052
						],
						[
							-81.62544992699992,
							30.325620920000066
						],
						[
							-81.6253390789999,
							30.32551007300009
						],
						[
							-81.62524916399991,
							30.32538166100005
						],
						[
							-81.62518291399994,
							30.32523958600007
						],
						[
							-81.6251423409999,
							30.325088165000068
						],
						[
							-81.6251286779999,
							30.324932000000047
						],
						[
							-81.62513627899995,
							30.324815324000042
						],
						[
							-81.62561897199993,
							30.321126234000076
						],
						[
							-81.62565110399993,
							30.32055637300005
						],
						[
							-81.62565888299991,
							30.320478656000038
						],
						[
							-81.62567337599997,
							30.320401908000065
						],
						[
							-81.6256944729999,
							30.32032670700005
						],
						[
							-81.62572201599994,
							30.320253619000084
						],
						[
							-81.62575579599991,
							30.320183198000052
						],
						[
							-81.62579555899993,
							30.320115972000053
						],
						[
							-81.62584100599992,
							30.320052451000038
						],
						[
							-81.62723600599992,
							30.318271451000044
						],
						[
							-81.62725507899995,
							30.318247927000073
						],
						[
							-81.62736592699991,
							30.318137079000053
						],
						[
							-81.62749433899995,
							30.318047164000063
						],
						[
							-81.62763641399994,
							30.317980913000046
						],
						[
							-81.62778783399995,
							30.31794034000006
						],
						[
							-81.6279439999999,
							30.317926678000052
						],
						[
							-81.62796621099994,
							30.317926952000047
						],
						[
							-81.62964362199995,
							30.317968392000065
						],
						[
							-81.62966673599993,
							30.317955377000093
						],
						[
							-81.62973123499995,
							30.317922405000044
						],
						[
							-81.62979817899992,
							30.317894731000077
						],
						[
							-81.62986713299995,
							30.31787253400006
						],
						[
							-81.62993764999993,
							30.317855959000042
						],
						[
							-81.63000927099995,
							30.317845114000082
						],
						[
							-81.63008153399994,
							30.317840068000066
						],
						[
							-81.63015396799996,
							30.317840854000057
						],
						[
							-81.6316719429999,
							30.317918545000058
						],
						[
							-81.63170120899991,
							30.317919650000082
						],
						[
							-81.63525849099995,
							30.317913679000068
						],
						[
							-81.63529195299992,
							30.317914246000047
						],
						[
							-81.63648350099993,
							30.317956608000088
						],
						[
							-81.63762711299995,
							30.317661250000075
						],
						[
							-81.6376981109999,
							30.31764594300006
						],
						[
							-81.63777011199994,
							30.31763641400005
						],
						[
							-81.63784264799996,
							30.31763272700005
						],
						[
							-81.63791524399994,
							30.317634905000034
						],
						[
							-81.63798742799992,
							30.31764293400005
						],
						[
							-81.63805872799992,
							30.31765676100008
						],
						[
							-81.63838472799995,
							30.317733761000056
						],
						[
							-81.63851327399993,
							30.31777451200009
						],
						[
							-81.63919027499992,
							30.31804651200008
						],
						[
							-81.63930466099993,
							30.31810216500008
						],
						[
							-81.6394330729999,
							30.318192080000077
						],
						[
							-81.63954392099994,
							30.318302927000047
						],
						[
							-81.63963383599992,
							30.318431339000085
						],
						[
							-81.63969024199992,
							30.318547606000035
						],
						[
							-81.63972651099994,
							30.318638470000057
						],
						[
							-81.63978935499995,
							30.318638484000076
						],
						[
							-81.63985202799995,
							30.318643107000074
						],
						[
							-81.63991419299992,
							30.31865231600006
						],
						[
							-81.63997551499995,
							30.31866605900007
						],
						[
							-81.64003566399994,
							30.31868426400007
						],
						[
							-81.6410938759999,
							30.31904290500006
						],
						[
							-81.64117633899991,
							30.318985164000082
						],
						[
							-81.6413184139999,
							30.318918913000058
						],
						[
							-81.64146983499995,
							30.31887834000008
						],
						[
							-81.64162599999992,
							30.31886467800007
						],
						[
							-81.64178216599993,
							30.31887834000008
						],
						[
							-81.6419401359999,
							30.318921355000047
						],
						[
							-81.64372568499994,
							30.319602797000073
						],
						[
							-81.64379048699993,
							30.31962962800009
						],
						[
							-81.64385278899994,
							30.319661844000056
						],
						[
							-81.64391214199992,
							30.31969921400008
						],
						[
							-81.64396812199993,
							30.319741469000068
						],
						[
							-81.6440203279999,
							30.319788307000067
						],
						[
							-81.6440683859999,
							30.319839393000052
						],
						[
							-81.64413987199993,
							30.31983308100007
						],
						[
							-81.64421163499992,
							30.31983274300006
						],
						[
							-81.64428317799991,
							30.319838381000068
						],
						[
							-81.64435400199994,
							30.319849957000084
						],
						[
							-81.64442361699992,
							30.319867390000073
						],
						[
							-81.6444915379999,
							30.319890559000044
						],
						[
							-81.64455729399992,
							30.319919303000066
						],
						[
							-81.64496129499992,
							30.320113303000088
						],
						[
							-81.6450238839999,
							30.320146187000034
						],
						[
							-81.64508358499995,
							30.320184062000067
						],
						[
							-81.64513999999991,
							30.32022667600006
						],
						[
							-81.64519275599991,
							30.320273746000055
						],
						[
							-81.64524149999994,
							30.32032495800007
						],
						[
							-81.64528590899994,
							30.32037997300006
						],
						[
							-81.64532568699991,
							30.320438423000045
						],
						[
							-81.64541041399991,
							30.32039891400007
						],
						[
							-81.64556183399992,
							30.320358341000084
						],
						[
							-81.64571799999993,
							30.320344678000083
						],
						[
							-81.64587416599994,
							30.320358341000084
						],
						[
							-81.6459237329999,
							30.32036852700008
						],
						[
							-81.64703168299991,
							30.320628891000073
						],
						[
							-81.6472070239999,
							30.320559262000074
						],
						[
							-81.6471009999999,
							30.321569000000068
						],
						[
							-81.64651890499994,
							30.323045009000055
						],
						[
							-81.64644902299995,
							30.323244075000048
						],
						[
							-81.64615471699994,
							30.323585011000038
						],
						[
							-81.64673106599992,
							30.324166930000047
						],
						[
							-81.64691775499995,
							30.32514911200008
						],
						[
							-81.64717096499993,
							30.32530094600008
						],
						[
							-81.64748390599993,
							30.32575300900004
						],
						[
							-81.64753490599992,
							30.32585800800007
						],
						[
							-81.64757690699992,
							30.325917009000083
						],
						[
							-81.64768690499994,
							30.326092009000035
						],
						[
							-81.64787609099994,
							30.326370000000058
						],
						[
							-81.64780372099996,
							30.326514033000084
						],
						[
							-81.64783808999994,
							30.326547952000052
						],
						[
							-81.6477719529999,
							30.327036036000038
						],
						[
							-81.64744290899995,
							30.327678007000088
						],
						[
							-81.6472239069999,
							30.328408009000047
						],
						[
							-81.64701490599992,
							30.329069009000076
						],
						[
							-81.64691690599994,
							30.329323009000063
						],
						[
							-81.64689890599995,
							30.329358008000046
						],
						[
							-81.6468798329999,
							30.329398951000087
						],
						[
							-81.6467779059999,
							30.329622008000058
						],
						[
							-81.64670390499992,
							30.329796009000063
						],
						[
							-81.64660065099991,
							30.330058362000045
						],
						[
							-81.6361088079999,
							30.32736346700006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Midtown",
				"RegionID": "269089"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.44261709199992,
					28.471978000000036,
					-81.41475143699995,
					28.504551649000064
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.42202899999995,
							28.503359000000046
						],
						[
							-81.42202999999995,
							28.49741700000004
						],
						[
							-81.41794399999992,
							28.497382000000073
						],
						[
							-81.4178485079999,
							28.495583855000064
						],
						[
							-81.41777899999994,
							28.494275000000073
						],
						[
							-81.4178725999999,
							28.494273825000054
						],
						[
							-81.41825699999993,
							28.494269000000088
						],
						[
							-81.41813745299993,
							28.490513469000064
						],
						[
							-81.41813399999995,
							28.490405000000067
						],
						[
							-81.41801154799992,
							28.489697788000058
						],
						[
							-81.41644997799995,
							28.489698064000038
						],
						[
							-81.41645026799995,
							28.48881451400007
						],
						[
							-81.41475143699995,
							28.488136721000046
						],
						[
							-81.41475159399994,
							28.486987857000088
						],
						[
							-81.41525959599996,
							28.487003356000063
						],
						[
							-81.41525999999993,
							28.48688100000004
						],
						[
							-81.41729299999992,
							28.48688100000004
						],
						[
							-81.4196639999999,
							28.48684800000007
						],
						[
							-81.4198859999999,
							28.486845000000073
						],
						[
							-81.4205179999999,
							28.48683600000004
						],
						[
							-81.42379299999993,
							28.48688100000004
						],
						[
							-81.42570599999993,
							28.48688100000004
						],
						[
							-81.42609299999994,
							28.48688100000004
						],
						[
							-81.42617699999994,
							28.486880000000042
						],
						[
							-81.42651499999994,
							28.486876000000052
						],
						[
							-81.42651999999993,
							28.484576000000065
						],
						[
							-81.42651499999994,
							28.48408100000006
						],
						[
							-81.42651499999994,
							28.483381000000065
						],
						[
							-81.42651499999994,
							28.47985678000009
						],
						[
							-81.42651499999994,
							28.479806000000053
						],
						[
							-81.4319089999999,
							28.47980700000005
						],
						[
							-81.43179299999991,
							28.479482000000075
						],
						[
							-81.43211962399994,
							28.479482000000075
						],
						[
							-81.43219299999993,
							28.479482000000075
						],
						[
							-81.43369299999995,
							28.479482000000075
						],
						[
							-81.43499099999991,
							28.479500000000087
						],
						[
							-81.43772899999993,
							28.479537000000054
						],
						[
							-81.43772832499991,
							28.479296441000088
						],
						[
							-81.43771299999993,
							28.473839000000055
						],
						[
							-81.43381399999993,
							28.47385900000006
						],
						[
							-81.43371599999995,
							28.471981000000085
						],
						[
							-81.43619099999995,
							28.47197900000009
						],
						[
							-81.43790199999997,
							28.471978000000036
						],
						[
							-81.43930099999994,
							28.471980000000087
						],
						[
							-81.43974134699994,
							28.471980891000044
						],
						[
							-81.43992266399994,
							28.471981259000074
						],
						[
							-81.43991577999992,
							28.47210497000009
						],
						[
							-81.44038761299993,
							28.47210083400006
						],
						[
							-81.44069005999997,
							28.472099831000037
						],
						[
							-81.44149024799992,
							28.472094824000067
						],
						[
							-81.44195593899991,
							28.47209182000006
						],
						[
							-81.44217626499994,
							28.472090818000087
						],
						[
							-81.4422663979999,
							28.472090819000073
						],
						[
							-81.44232348399993,
							28.472088815000063
						],
						[
							-81.44246181799991,
							28.47208768200005
						],
						[
							-81.44261709199992,
							28.48446124600008
						],
						[
							-81.44216825299992,
							28.48481869400007
						],
						[
							-81.44133000999994,
							28.485506715000042
						],
						[
							-81.44112871099992,
							28.48568698300005
						],
						[
							-81.44095345199992,
							28.485823185000072
						],
						[
							-81.43974365799994,
							28.48681365400006
						],
						[
							-81.43933805599994,
							28.487157162000074
						],
						[
							-81.43861097799993,
							28.487772075000066
						],
						[
							-81.43747429199995,
							28.488825638000037
						],
						[
							-81.43720088599991,
							28.489143108000064
						],
						[
							-81.43694350399994,
							28.489409503000047
						],
						[
							-81.43687940899991,
							28.48948161000004
						],
						[
							-81.43597506899994,
							28.490469075000078
						],
						[
							-81.43357951599995,
							28.493353351000057
						],
						[
							-81.43346935199993,
							28.49348554800008
						],
						[
							-81.43238973099994,
							28.494668268000055
						],
						[
							-81.42904579099991,
							28.498511001000054
						],
						[
							-81.42870027999993,
							28.49890458400006
						],
						[
							-81.42745543299992,
							28.500354735000087
						],
						[
							-81.42731822899992,
							28.50048993600007
						],
						[
							-81.42644124999993,
							28.501480834000063
						],
						[
							-81.4264399999999,
							28.501480000000072
						],
						[
							-81.4255906599999,
							28.501496976000055
						],
						[
							-81.42328702999993,
							28.50421196800005
						],
						[
							-81.4229988159999,
							28.504551649000064
						],
						[
							-81.42202399999991,
							28.504548000000057
						],
						[
							-81.4220279999999,
							28.50438100000008
						],
						[
							-81.42202815099995,
							28.504226762000087
						],
						[
							-81.42202899999995,
							28.503359000000046
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Millenia",
				"RegionID": "269091"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.61325832199992,
					30.327278000000035,
					-81.60254190599994,
					30.346072098000036
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.6080979159999,
							30.346072098000036
						],
						[
							-81.60517190699994,
							30.346038010000086
						],
						[
							-81.60273081799994,
							30.346070024000085
						],
						[
							-81.60272290599994,
							30.345324009000084
						],
						[
							-81.60270690599992,
							30.34502400800005
						],
						[
							-81.60269190699995,
							30.34477200900005
						],
						[
							-81.6026989049999,
							30.344704008000065
						],
						[
							-81.60269290499991,
							30.344570008000062
						],
						[
							-81.60268090599993,
							30.344251009000065
						],
						[
							-81.6026749049999,
							30.343870008000067
						],
						[
							-81.60264390599991,
							30.343000009000036
						],
						[
							-81.6026289049999,
							30.342663008000045
						],
						[
							-81.60261490499994,
							30.34155200800006
						],
						[
							-81.60261390499994,
							30.341188008000074
						],
						[
							-81.6025829969999,
							30.340104042000064
						],
						[
							-81.60257090599993,
							30.339755008000054
						],
						[
							-81.60257190499995,
							30.33966100900005
						],
						[
							-81.60256690499995,
							30.339592008000068
						],
						[
							-81.60254190599994,
							30.338617008000085
						],
						[
							-81.60256190599995,
							30.338232008000034
						],
						[
							-81.60256990599993,
							30.337761009000076
						],
						[
							-81.60256990599993,
							30.337667009000086
						],
						[
							-81.60257690499992,
							30.336981008000066
						],
						[
							-81.60258490599995,
							30.336758009000047
						],
						[
							-81.6025849049999,
							30.336641008000072
						],
						[
							-81.6026079049999,
							30.336349008000067
						],
						[
							-81.60266090599993,
							30.33587600900006
						],
						[
							-81.60266890499992,
							30.335781009000073
						],
						[
							-81.6027599059999,
							30.335011009000088
						],
						[
							-81.60279290499994,
							30.334741008000037
						],
						[
							-81.60291290599991,
							30.33379400800004
						],
						[
							-81.60292190599995,
							30.333621008000083
						],
						[
							-81.60300190499993,
							30.33310100800009
						],
						[
							-81.60302690499992,
							30.33281700900005
						],
						[
							-81.60306890599992,
							30.33248600900004
						],
						[
							-81.60315290599993,
							30.33175000800009
						],
						[
							-81.60317190599994,
							30.331579009000052
						],
						[
							-81.60317990499993,
							30.331415008000082
						],
						[
							-81.60321790499995,
							30.331150008000062
						],
						[
							-81.60333590599993,
							30.33055500800009
						],
						[
							-81.60341590599995,
							30.330265009000072
						],
						[
							-81.60359190499992,
							30.32976700800009
						],
						[
							-81.60396790599992,
							30.328719010000047
						],
						[
							-81.60406790499991,
							30.32836700900009
						],
						[
							-81.60410690599991,
							30.328226008000062
						],
						[
							-81.6043619049999,
							30.327551008000057
						],
						[
							-81.6044238689999,
							30.327371952000078
						],
						[
							-81.60468790699991,
							30.327367010000046
						],
						[
							-81.60629390799994,
							30.327350010000092
						],
						[
							-81.60647390799994,
							30.327350010000092
						],
						[
							-81.60681390699995,
							30.32734801000004
						],
						[
							-81.60731090799993,
							30.32734801000004
						],
						[
							-81.60779290799991,
							30.32734801000004
						],
						[
							-81.60787490699994,
							30.32735101000009
						],
						[
							-81.60801304899991,
							30.32735111500006
						],
						[
							-81.60799376699993,
							30.32728790500005
						],
						[
							-81.61033090799992,
							30.327295010000057
						],
						[
							-81.61068690699994,
							30.32729601100004
						],
						[
							-81.61099599999994,
							30.327278000000035
						],
						[
							-81.61193891399995,
							30.327288064000072
						],
						[
							-81.61188800999992,
							30.327438963000077
						],
						[
							-81.6118810719999,
							30.32751604000003
						],
						[
							-81.61181403199993,
							30.328153770000082
						],
						[
							-81.61186103099993,
							30.328208377000067
						],
						[
							-81.6120601479999,
							30.32833894600009
						],
						[
							-81.61211885099993,
							30.32838090100006
						],
						[
							-81.61217399999992,
							30.328427426000076
						],
						[
							-81.61222524299991,
							30.328478223000044
						],
						[
							-81.61227224899994,
							30.328532964000086
						],
						[
							-81.61231471399992,
							30.32859129700006
						],
						[
							-81.61235236699991,
							30.32865284700006
						],
						[
							-81.61238496399994,
							30.32871721700008
						],
						[
							-81.61241229699993,
							30.328783993000062
						],
						[
							-81.61252050799995,
							30.329082573000054
						],
						[
							-81.61256065899994,
							30.329232834000035
						],
						[
							-81.61257049099993,
							30.32930608000004
						],
						[
							-81.6125754919999,
							30.329360080000068
						],
						[
							-81.6125771529999,
							30.329396046000056
						],
						[
							-81.61264332999993,
							30.32948632800009
						],
						[
							-81.61269683499995,
							30.32956833900005
						],
						[
							-81.61276308599992,
							30.32971041400009
						],
						[
							-81.61280365899995,
							30.32986183500009
						],
						[
							-81.6128173219999,
							30.330018000000056
						],
						[
							-81.61280365899995,
							30.33017416600006
						],
						[
							-81.61276308599992,
							30.330325586000072
						],
						[
							-81.61269683499995,
							30.33046766100006
						],
						[
							-81.61263975799994,
							30.33055451200005
						],
						[
							-81.61242505399991,
							30.330843348000087
						],
						[
							-81.61239190399994,
							30.330951087000077
						],
						[
							-81.61241653199994,
							30.33154932000008
						],
						[
							-81.61243990899993,
							30.332096782000068
						],
						[
							-81.6124836219999,
							30.332191220000084
						],
						[
							-81.61258549599995,
							30.332291692000073
						],
						[
							-81.61263532399994,
							30.33234499200006
						],
						[
							-81.61268066799994,
							30.332402155000068
						],
						[
							-81.61272122799994,
							30.332462806000077
						],
						[
							-81.61275673799992,
							30.332526546000057
						],
						[
							-81.61278696399995,
							30.332592954000066
						],
						[
							-81.61319196399995,
							30.333587954000055
						],
						[
							-81.61320408599994,
							30.33361941300006
						],
						[
							-81.6132446599999,
							30.333770834000067
						],
						[
							-81.61325832199992,
							30.333927000000074
						],
						[
							-81.6132446599999,
							30.334083165000035
						],
						[
							-81.61322863599992,
							30.334156160000077
						],
						[
							-81.61307263599991,
							30.33474816000006
						],
						[
							-81.61302192599993,
							30.334890674000064
						],
						[
							-81.6115353909999,
							30.338166020000074
						],
						[
							-81.61123099899993,
							30.338927000000073
						],
						[
							-81.61121195499993,
							30.338971149000084
						],
						[
							-81.6108379559999,
							30.33977814900004
						],
						[
							-81.6108001469999,
							30.33985085200004
						],
						[
							-81.61056763999994,
							30.340252147000058
						],
						[
							-81.61096938999992,
							30.340795856000057
						],
						[
							-81.61125346299991,
							30.34111361700008
						],
						[
							-81.61127192099991,
							30.34113492700004
						],
						[
							-81.6113618359999,
							30.34126333900008
						],
						[
							-81.61142808599993,
							30.341405413000075
						],
						[
							-81.61146865899991,
							30.34155683400007
						],
						[
							-81.61148232199992,
							30.341713000000084
						],
						[
							-81.61146865899991,
							30.34186916500005
						],
						[
							-81.61142808599993,
							30.34202058600005
						],
						[
							-81.61137766199994,
							30.342128721000048
						],
						[
							-81.61144615299992,
							30.342163464000066
						],
						[
							-81.61151112199991,
							30.342204416000072
						],
						[
							-81.61157200999993,
							30.342251221000083
						],
						[
							-81.61162828999994,
							30.34230347500005
						],
						[
							-81.61181528999992,
							30.342492475000086
						],
						[
							-81.61186491999992,
							30.342546927000058
						],
						[
							-81.61195483499995,
							30.34267533900004
						],
						[
							-81.61202108599991,
							30.342817414000084
						],
						[
							-81.61206165899995,
							30.34296883400009
						],
						[
							-81.6120753219999,
							30.343125000000043
						],
						[
							-81.6120753219999,
							30.343367000000057
						],
						[
							-81.61207181499992,
							30.343446374000052
						],
						[
							-81.61206131499995,
							30.343525127000078
						],
						[
							-81.61204390299991,
							30.34360264600008
						],
						[
							-81.61201971499992,
							30.34367832600009
						],
						[
							-81.61198894099994,
							30.343751574000066
						],
						[
							-81.6119518189999,
							30.343821819000084
						],
						[
							-81.6119086409999,
							30.34388851300008
						],
						[
							-81.61185974299991,
							30.343951134000065
						],
						[
							-81.61166756599994,
							30.344172194000066
						],
						[
							-81.61156707299995,
							30.344270921000085
						],
						[
							-81.61149929699991,
							30.344322525000052
						],
						[
							-81.61118110199993,
							30.344541440000057
						],
						[
							-81.61121307299994,
							30.344572079000045
						],
						[
							-81.6112709169999,
							30.344625083000043
						],
						[
							-81.61130091699994,
							30.344655083000077
						],
						[
							-81.61135037299994,
							30.344708725000093
						],
						[
							-81.61139531799995,
							30.34476619900005
						],
						[
							-81.61143545599992,
							30.344827127000087
						],
						[
							-81.61147052299992,
							30.344891109000063
						],
						[
							-81.61150028799995,
							30.344957722000064
						],
						[
							-81.61152455599995,
							30.345026529000055
						],
						[
							-81.61153655499993,
							30.345065529000067
						],
						[
							-81.61155515399992,
							30.34513602900006
						],
						[
							-81.61156798199995,
							30.345207803000054
						],
						[
							-81.6115749519999,
							30.345280381000066
						],
						[
							-81.6115760209999,
							30.345353285000044
						],
						[
							-81.61157117999994,
							30.34542603600005
						],
						[
							-81.6115604609999,
							30.34549815500009
						],
						[
							-81.61154393599992,
							30.345569170000086
						],
						[
							-81.61153593599994,
							30.345598169000084
						],
						[
							-81.61151323699994,
							30.345668908000054
						],
						[
							-81.61148477699993,
							30.345737532000044
						],
						[
							-81.61145075099995,
							30.34580357300007
						],
						[
							-81.6114113889999,
							30.345866580000067
						],
						[
							-81.61140232399993,
							30.34587872900005
						],
						[
							-81.6099930979999,
							30.345756721000043
						],
						[
							-81.60856990699995,
							30.34598801100009
						],
						[
							-81.6080979159999,
							30.346072098000036
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Monterey",
				"RegionID": "269096"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.2462799999999,
					25.72015538700009,
					-80.18829346099994,
					25.750360000000057
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-80.2285285399999,
								25.721392627000057
							],
							[
								-80.22859483399992,
								25.721378341000047
							],
							[
								-80.22864379999993,
								25.721374435000087
							],
							[
								-80.2286822609999,
								25.721366611000068
							],
							[
								-80.22876159599991,
								25.721346084000064
							],
							[
								-80.22883256299991,
								25.72132937100008
							],
							[
								-80.22890467399992,
								25.721318619000044
							],
							[
								-80.22897742999993,
								25.721313904000056
							],
							[
								-80.22905032599994,
								25.721315256000082
							],
							[
								-80.22912285599995,
								25.721322668000084
							],
							[
								-80.22919451899992,
								25.721336088000044
							],
							[
								-80.22926481699994,
								25.72135542300009
							],
							[
								-80.22934081599993,
								25.721379423000087
							],
							[
								-80.22937030199995,
								25.72139097900009
							],
							[
								-80.22939507699994,
								25.72139096300009
							],
							[
								-80.22945107699991,
								25.72139496300008
							],
							[
								-80.22952861199991,
								25.721403897000073
							],
							[
								-80.22960508099993,
								25.72141952000004
							],
							[
								-80.22967990699993,
								25.721441714000036
							],
							[
								-80.2297525269999,
								25.721470312000065
							],
							[
								-80.22982239299995,
								25.72150509900007
							],
							[
								-80.22988898099993,
								25.72154581300009
							],
							[
								-80.2299439809999,
								25.721582812000065
							],
							[
								-80.23002007299993,
								25.721640079000053
							],
							[
								-80.23013356799993,
								25.721754112000042
							],
							[
								-80.2301782159999,
								25.721808297000052
							],
							[
								-80.2302582499999,
								25.721922489000065
							],
							[
								-80.23031254299991,
								25.722014414000057
							],
							[
								-80.23038108599991,
								25.722160414000086
							],
							[
								-80.23038826899995,
								25.722180914000035
							],
							[
								-80.23042026899992,
								25.72227591400008
							],
							[
								-80.23045661099992,
								25.722424610000076
							],
							[
								-80.2304741509999,
								25.722537240000065
							],
							[
								-80.23048357699992,
								25.722590368000056
							],
							[
								-80.2304973219999,
								25.722747000000084
							],
							[
								-80.23049339499994,
								25.72283094800008
							],
							[
								-80.23049039499995,
								25.722862948000056
							],
							[
								-80.23047990999993,
								25.72293935500005
							],
							[
								-80.23046291799994,
								25.723014582000076
							],
							[
								-80.23043954199994,
								25.723088077000057
							],
							[
								-80.23040995499991,
								25.723159299000088
							],
							[
								-80.23039595599994,
								25.723189300000058
							],
							[
								-80.2303641979999,
								25.723251632000085
							],
							[
								-80.2303274759999,
								25.72331117400006
							],
							[
								-80.23028603199992,
								25.723367533000044
							],
							[
								-80.2302401419999,
								25.72342033400008
							],
							[
								-80.23019010999991,
								25.723469227000066
							],
							[
								-80.23013626699992,
								25.72351389000005
							],
							[
								-80.23007592099992,
								25.723600073000057
							],
							[
								-80.2299650729999,
								25.723710921000077
							],
							[
								-80.22983666099992,
								25.723800836000066
							],
							[
								-80.22969458599995,
								25.72386708600004
							],
							[
								-80.22954316599993,
								25.723907660000066
							],
							[
								-80.22947771399993,
								25.72391338600005
							],
							[
								-80.22941565799994,
								25.723941023000066
							],
							[
								-80.22935155899995,
								25.72396352000004
							],
							[
								-80.2292858429999,
								25.72398072900006
							],
							[
								-80.2292189449999,
								25.723992534000047
							],
							[
								-80.22915130799993,
								25.723998858000073
							],
							[
								-80.22911630699991,
								25.724000858000068
							],
							[
								-80.2290482599999,
								25.724002167000037
							],
							[
								-80.22898030899995,
								25.72399832600007
							],
							[
								-80.22891284199994,
								25.72398935700005
							],
							[
								-80.22884624799991,
								25.72397531200005
							],
							[
								-80.22878090599994,
								25.723956271000077
							],
							[
								-80.22871719099993,
								25.723932343000058
							],
							[
								-80.22868619099997,
								25.723919342000045
							],
							[
								-80.22862653699991,
								25.72389171900005
							],
							[
								-80.22856905999993,
								25.723859812000057
							],
							[
								-80.22851406799992,
								25.723823792000076
							],
							[
								-80.22846185399993,
								25.723783851000064
							],
							[
								-80.2284126969999,
								25.723740202000045
							],
							[
								-80.2283897289999,
								25.723719099000053
							],
							[
								-80.22836992699992,
								25.72370292000005
							],
							[
								-80.22826276899991,
								25.723596442000087
							],
							[
								-80.2282269239999,
								25.723554257000046
							],
							[
								-80.22817813899991,
								25.72349100300005
							],
							[
								-80.22813516299993,
								25.723423667000077
							],
							[
								-80.22809833399992,
								25.723352782000063
							],
							[
								-80.22806794399992,
								25.723278907000065
							],
							[
								-80.22804423199995,
								25.72320262600005
							],
							[
								-80.22802738599995,
								25.72312454100006
							],
							[
								-80.22801776799992,
								25.72306175500006
							],
							[
								-80.22799234099995,
								25.72296116600006
							],
							[
								-80.22798228999994,
								25.722885517000066
							],
							[
								-80.22797537299994,
								25.72281483500007
							],
							[
								-80.22794416399995,
								25.722764661000042
							],
							[
								-80.22787791399992,
								25.72262258600006
							],
							[
								-80.22783734099994,
								25.722471166000048
							],
							[
								-80.22782367799994,
								25.722315000000037
							],
							[
								-80.2278251429999,
								25.72226369100008
							],
							[
								-80.2278271429999,
								25.722228691000055
							],
							[
								-80.22783934099994,
								25.722123835000048
							],
							[
								-80.22787991399991,
								25.72197241400005
							],
							[
								-80.22794616499995,
								25.721830339000064
							],
							[
								-80.22803607999992,
								25.721701927000083
							],
							[
								-80.2281469269999,
								25.721591080000053
							],
							[
								-80.22825366299992,
								25.72151408800005
							],
							[
								-80.22827966299991,
								25.72149808800009
							],
							[
								-80.22833871799992,
								25.721464748000074
							],
							[
								-80.22840011699994,
								25.72143595400007
							],
							[
								-80.22846351099992,
								25.721411868000075
							],
							[
								-80.2285285399999,
								25.721392627000057
							]
						]
					],
					[
						[
							[
								-80.20382999999993,
								25.750360000000057
							],
							[
								-80.20370386799993,
								25.750200675000087
							],
							[
								-80.20344494799991,
								25.74990494400004
							],
							[
								-80.20314399599994,
								25.74959333000004
							],
							[
								-80.20287844799992,
								25.74936216000009
							],
							[
								-80.20266365699992,
								25.749167898000053
							],
							[
								-80.20246064699995,
								25.74895895800006
							],
							[
								-80.20218999999992,
								25.748680000000036
							],
							[
								-80.20198447199994,
								25.748444024000037
							],
							[
								-80.2019159059999,
								25.748365565000086
							],
							[
								-80.20179458799993,
								25.74824481400009
							],
							[
								-80.20179799999994,
								25.74824200000006
							],
							[
								-80.20111306099994,
								25.747631874000035
							],
							[
								-80.20053163699993,
								25.748122611000042
							],
							[
								-80.20041917399993,
								25.74811489500007
							],
							[
								-80.19933117499994,
								25.747964895000056
							],
							[
								-80.19929783399994,
								25.74795965900006
							],
							[
								-80.19916201699994,
								25.747924604000048
							],
							[
								-80.19839001799996,
								25.747659603000045
							],
							[
								-80.19825017699992,
								25.747597865000046
							],
							[
								-80.19807531999993,
								25.74750214900007
							],
							[
								-80.19776419799992,
								25.74746469900009
							],
							[
								-80.19368139399995,
								25.747493209000083
							],
							[
								-80.19073549899991,
								25.74759973500005
							],
							[
								-80.1906651029999,
								25.747599523000076
							],
							[
								-80.1893611019999,
								25.747544523000045
							],
							[
								-80.18924283399991,
								25.747531659000064
							],
							[
								-80.18909141299991,
								25.747491086000082
							],
							[
								-80.18894933899992,
								25.74742483600005
							],
							[
								-80.18882092699994,
								25.74733492100006
							],
							[
								-80.18871007899992,
								25.74722407300004
							],
							[
								-80.18868247099994,
								25.747189477000063
							],
							[
								-80.18848147199992,
								25.74692447700005
							],
							[
								-80.18843854299992,
								25.746862668000063
							],
							[
								-80.18840093099993,
								25.746797486000048
							],
							[
								-80.18836890099993,
								25.746729388000062
							],
							[
								-80.18834267599993,
								25.746658850000074
							],
							[
								-80.18832244099991,
								25.746586367000077
							],
							[
								-80.18830833599992,
								25.746512446000054
							],
							[
								-80.18830046099994,
								25.74643760400005
							],
							[
								-80.18829346099994,
								25.746326604000046
							],
							[
								-80.18829405199995,
								25.74620468900008
							],
							[
								-80.18830905199991,
								25.74599868900009
							],
							[
								-80.1883203399999,
								25.745907835000082
							],
							[
								-80.18835228099994,
								25.745781257000093
							],
							[
								-80.18841884299991,
								25.745595345000083
							],
							[
								-80.1884564739999,
								25.74547057600006
							],
							[
								-80.1884639139999,
								25.745445414000073
							],
							[
								-80.18853016399993,
								25.74530333900009
							],
							[
								-80.18862007899992,
								25.745174927000054
							],
							[
								-80.18873092699994,
								25.745064080000077
							],
							[
								-80.18885933899992,
								25.744974165000087
							],
							[
								-80.1890014139999,
								25.744907914000066
							],
							[
								-80.1890995839999,
								25.744880238000064
							],
							[
								-80.18915263899993,
								25.74486652700006
							],
							[
								-80.1895491219999,
								25.74477051100007
							],
							[
								-80.18966051799993,
								25.744751086000065
							],
							[
								-80.19048651899993,
								25.744660087000057
							],
							[
								-80.19058499999994,
								25.744654678000074
							],
							[
								-80.19332099999991,
								25.744654678000074
							],
							[
								-80.1934285179999,
								25.744661128000075
							],
							[
								-80.1946715059999,
								25.744810808000068
							],
							[
								-80.19588519699994,
								25.744701316000093
							],
							[
								-80.19594972399996,
								25.74469782600005
							],
							[
								-80.19799372299991,
								25.744660826000086
							],
							[
								-80.19811355699994,
								25.744666661000053
							],
							[
								-80.19882955599991,
								25.744749660000082
							],
							[
								-80.1989380949999,
								25.744769046000044
							],
							[
								-80.19938775399993,
								25.74487817100004
							],
							[
								-80.20023084399992,
								25.744827310000062
							],
							[
								-80.20028499999995,
								25.74482567800004
							],
							[
								-80.20044116499992,
								25.744839341000045
							],
							[
								-80.20059258599991,
								25.74487991400008
							],
							[
								-80.2007346609999,
								25.744946164000055
							],
							[
								-80.20086307299994,
								25.745036079000045
							],
							[
								-80.20097391999991,
								25.745146927000064
							],
							[
								-80.2010638349999,
								25.745275339000045
							],
							[
								-80.20113008599992,
								25.745417414000087
							],
							[
								-80.20115338599993,
								25.745491150000078
							],
							[
								-80.20148838599995,
								25.746735150000063
							],
							[
								-80.2015042939999,
								25.746805281000036
							],
							[
								-80.20151454799992,
								25.746876460000067
							],
							[
								-80.20151908199995,
								25.746948230000044
							],
							[
								-80.20151786699995,
								25.747020133000035
							],
							[
								-80.2015109109999,
								25.747091710000063
							],
							[
								-80.2014982579999,
								25.747162501000048
							],
							[
								-80.20147998899995,
								25.74723205500004
							],
							[
								-80.20144282899992,
								25.74735354200004
							],
							[
								-80.20144527799994,
								25.747351198000047
							],
							[
								-80.2014977469999,
								25.747304773000053
							],
							[
								-80.20155367099994,
								25.747262573000057
							],
							[
								-80.20161271099994,
								25.74722485400008
							],
							[
								-80.20167450699995,
								25.747191846000078
							],
							[
								-80.20173868599994,
								25.747163748000048
							],
							[
								-80.2018048569999,
								25.747140732000048
							],
							[
								-80.2042393349999,
								25.74639889100007
							],
							[
								-80.2045000569999,
								25.746319097000082
							],
							[
								-80.20585619799994,
								25.74583489400004
							],
							[
								-80.20763480699992,
								25.744753553000066
							],
							[
								-80.20770326999991,
								25.744715796000037
							],
							[
								-80.20777481399995,
								25.744684264000057
							],
							[
								-80.20784887299993,
								25.74465920500006
							],
							[
								-80.20792486399995,
								25.74464081800005
							],
							[
								-80.20800218699992,
								25.744629246000045
							],
							[
								-80.20808023199993,
								25.744624582000085
							],
							[
								-80.20820699799992,
								25.74455897300004
							],
							[
								-80.20842119299994,
								25.74426184400005
							],
							[
								-80.2084854169999,
								25.744157400000063
							],
							[
								-80.20849153099994,
								25.744090621000055
							],
							[
								-80.2085029019999,
								25.744024533000072
							],
							[
								-80.20851946099992,
								25.743959550000056
							],
							[
								-80.2085411029999,
								25.74389608000007
							],
							[
								-80.20856769199992,
								25.74383451800009
							],
							[
								-80.20859906399994,
								25.743775250000056
							],
							[
								-80.2086306139999,
								25.74372029500006
							],
							[
								-80.20872107999992,
								25.74359092700007
							],
							[
								-80.20883105399992,
								25.743480813000076
							],
							[
								-80.20889449099991,
								25.743427447000048
							],
							[
								-80.20902333899994,
								25.74333716500007
							],
							[
								-80.20904296899994,
								25.743326157000073
							],
							[
								-80.20913296799995,
								25.74327715600009
							],
							[
								-80.20925541399993,
								25.74322191400006
							],
							[
								-80.20940558299992,
								25.743181562000075
							],
							[
								-80.20943107599993,
								25.743177030000084
							],
							[
								-80.20941932099993,
								25.743072588000075
							],
							[
								-80.20941367799992,
								25.742972000000066
							],
							[
								-80.20942841999994,
								25.742809940000086
							],
							[
								-80.2095233149999,
								25.742310543000087
							],
							[
								-80.20952655399992,
								25.74228518600006
							],
							[
								-80.20948534099995,
								25.742132165000044
							],
							[
								-80.20947183299995,
								25.74199265200008
							],
							[
								-80.2094587549999,
								25.741282326000093
							],
							[
								-80.20946085899993,
								25.741211751000037
							],
							[
								-80.20946849699993,
								25.741141559000084
							],
							[
								-80.20948162099995,
								25.741072183000085
							],
							[
								-80.20950014999994,
								25.741004051000065
							],
							[
								-80.2095239709999,
								25.74093758400005
							],
							[
								-80.20976397099992,
								25.740342585000064
							],
							[
								-80.20979441099992,
								25.74027523700005
							],
							[
								-80.20983027799991,
								25.740210616000073
							],
							[
								-80.20987133099993,
								25.740149159000055
							],
							[
								-80.2099172909999,
								25.74009128000006
							],
							[
								-80.2099678479999,
								25.74003737100009
							],
							[
								-80.21002266199993,
								25.739987794000058
							],
							[
								-80.21008135999995,
								25.73994288600005
							],
							[
								-80.21083975099992,
								25.739410612000086
							],
							[
								-80.21121714299994,
								25.73914633800007
							],
							[
								-80.21131275399995,
								25.739087907000055
							],
							[
								-80.21185813999995,
								25.73879964400004
							],
							[
								-80.21228353099993,
								25.738472285000057
							],
							[
								-80.21232481699991,
								25.738442339000073
							],
							[
								-80.21277581699991,
								25.738134339000055
							],
							[
								-80.21279736899993,
								25.738120070000036
							],
							[
								-80.21386036899992,
								25.737438070000053
							],
							[
								-80.21389633899992,
								25.73741616400008
							],
							[
								-80.2140384139999,
								25.73734991400005
							],
							[
								-80.2141898349999,
								25.73730934100007
							],
							[
								-80.21434599999992,
								25.737295678000066
							],
							[
								-80.21450216599993,
								25.73730934100007
							],
							[
								-80.21465358599994,
								25.73734991400005
							],
							[
								-80.21471831699995,
								25.73737636700008
							],
							[
								-80.21503078799992,
								25.737518479000077
							],
							[
								-80.21619656099995,
								25.737911891000067
							],
							[
								-80.2162165869999,
								25.73791891400009
							],
							[
								-80.2163586609999,
								25.737985164000065
							],
							[
								-80.21648707299994,
								25.738075079000055
							],
							[
								-80.2165979209999,
								25.738185927000075
							],
							[
								-80.21661432299993,
								25.73820605800006
							],
							[
								-80.21689892099995,
								25.738565832000063
							],
							[
								-80.21823571099992,
								25.738633954000083
							],
							[
								-80.21827016799995,
								25.738621660000035
							],
							[
								-80.21897457199992,
								25.738149174000057
							],
							[
								-80.21945105399993,
								25.737795110000036
							],
							[
								-80.2194679829999,
								25.73771721600008
							],
							[
								-80.2194917619999,
								25.737641133000068
							],
							[
								-80.21952220199995,
								25.737567462000072
							],
							[
								-80.2195590629999,
								25.737496784000086
							],
							[
								-80.21960205499995,
								25.737429659000043
							],
							[
								-80.21965083599991,
								25.737366616000088
							],
							[
								-80.2197050229999,
								25.73730815400006
							],
							[
								-80.21976418699991,
								25.73725473400009
							],
							[
								-80.21983046499992,
								25.73720099700006
							],
							[
								-80.21991098899991,
								25.73706517800008
							],
							[
								-80.22005187799994,
								25.736804721000055
							],
							[
								-80.22062721499992,
								25.73629733000007
							],
							[
								-80.22070937099994,
								25.73624456400006
							],
							[
								-80.22121981299995,
								25.73590394100006
							],
							[
								-80.22131681099995,
								25.73584762200005
							],
							[
								-80.22182007899994,
								25.735595988000057
							],
							[
								-80.2232185819999,
								25.734858387000088
							],
							[
								-80.22399471999995,
								25.734459232000063
							],
							[
								-80.22403045399994,
								25.73444184400006
							],
							[
								-80.22424186099994,
								25.734344686000043
							],
							[
								-80.22459821699995,
								25.734155288000068
							],
							[
								-80.22497527999991,
								25.73393277400004
							],
							[
								-80.22588379699994,
								25.733362356000043
							],
							[
								-80.22591233899993,
								25.73334516500006
							],
							[
								-80.22603028899994,
								25.73328808900004
							],
							[
								-80.22653428899991,
								25.733088089000095
							],
							[
								-80.22656590299994,
								25.733076776000075
							],
							[
								-80.22662028199994,
								25.733030184000086
							],
							[
								-80.22667821699991,
								25.732988097000092
							],
							[
								-80.2267393379999,
								25.73295078500007
							],
							[
								-80.22680324999993,
								25.732918488000053
							],
							[
								-80.2268695439999,
								25.73289141300006
							],
							[
								-80.22693779399992,
								25.732869735000065
							],
							[
								-80.22700755999995,
								25.732853593000073
							],
							[
								-80.22711610999994,
								25.732832896000048
							],
							[
								-80.22721192699993,
								25.73273707900006
							],
							[
								-80.22732117399994,
								25.732660584000087
							],
							[
								-80.22729046099994,
								25.732634002000054
							],
							[
								-80.22721538799993,
								25.732560959000068
							],
							[
								-80.2270653889999,
								25.732396959000084
							],
							[
								-80.22699806799994,
								25.732313944000055
							],
							[
								-80.22683606699992,
								25.732087945000046
							],
							[
								-80.22678900199992,
								25.732015108000045
							],
							[
								-80.22665100099994,
								25.731777108000074
							],
							[
								-80.2266254779999,
								25.731729897000037
							],
							[
								-80.22646049299993,
								25.731399998000086
							],
							[
								-80.22644933099993,
								25.73137897400005
							],
							[
								-80.22643628399993,
								25.731354002000046
							],
							[
								-80.2263475279999,
								25.73119087500004
							],
							[
								-80.22632456299993,
								25.73114553700009
							],
							[
								-80.22623356299994,
								25.730952537000064
							],
							[
								-80.22618801699991,
								25.730835325000044
							],
							[
								-80.2261219099999,
								25.730622107000045
							],
							[
								-80.22604037999992,
								25.730389699000057
							],
							[
								-80.22600925299992,
								25.730278616000078
							],
							[
								-80.22598125299993,
								25.73014661600007
							],
							[
								-80.22597533999993,
								25.730116166000073
							],
							[
								-80.22596190299993,
								25.729980130000058
							],
							[
								-80.22595890299993,
								25.729846130000055
							],
							[
								-80.22595867799993,
								25.72982600000006
							],
							[
								-80.22597181799995,
								25.72967282600007
							],
							[
								-80.2259858189999,
								25.729591826000046
							],
							[
								-80.22602100499995,
								25.729454160000046
							],
							[
								-80.22604800499994,
								25.729375160000075
							],
							[
								-80.2260710029999,
								25.729315000000042
							],
							[
								-80.22611000299992,
								25.729223000000047
							],
							[
								-80.22615916399991,
								25.729124339000066
							],
							[
								-80.22620082899994,
								25.729058870000074
							],
							[
								-80.2262588289999,
								25.728975870000056
							],
							[
								-80.22634313899994,
								25.72887249100006
							],
							[
								-80.22639713899991,
								25.72881549100009
							],
							[
								-80.22647192699992,
								25.728745079000078
							],
							[
								-80.22656143799992,
								25.728678959000035
							],
							[
								-80.22659543799996,
								25.72865695900009
							],
							[
								-80.22666455399991,
								25.728616484000046
							],
							[
								-80.22673699699993,
								25.728582320000044
							],
							[
								-80.2268121919999,
								25.72855473700008
							],
							[
								-80.22685319199991,
								25.728541737000057
							],
							[
								-80.22692410099995,
								25.728522397000066
							],
							[
								-80.22699635299995,
								25.72850891700006
							],
							[
								-80.22706946599993,
								25.728501388000044
							],
							[
								-80.22714294899993,
								25.728499860000056
							],
							[
								-80.22721631099995,
								25.728504342000065
							],
							[
								-80.2272890619999,
								25.728514806000078
							],
							[
								-80.22737395799993,
								25.728531271000065
							],
							[
								-80.22750958599994,
								25.72856891400005
							],
							[
								-80.22754251299995,
								25.72858163500007
							],
							[
								-80.22763051299995,
								25.728617635000035
							],
							[
								-80.22773966099993,
								25.728671164000048
							],
							[
								-80.22778885799994,
								25.728701721000053
							],
							[
								-80.22786685799991,
								25.72875372200008
							],
							[
								-80.2279654749999,
								25.728829837000035
							],
							[
								-80.22804647499993,
								25.72890183700008
							],
							[
								-80.22813792099993,
								25.728995927000085
							],
							[
								-80.22822512699992,
								25.729119679000068
							],
							[
								-80.22827448099991,
								25.729204009000057
							],
							[
								-80.22834208699993,
								25.72934841400007
							],
							[
								-80.22837958799994,
								25.729483320000043
							],
							[
								-80.2283991239999,
								25.729583577000085
							],
							[
								-80.22841432199994,
								25.729748000000086
							],
							[
								-80.22841007199992,
								25.72983532800004
							],
							[
								-80.22840207199994,
								25.729917328000056
							],
							[
								-80.22839263299994,
								25.729986315000076
							],
							[
								-80.22837788499993,
								25.730054365000058
							],
							[
								-80.22835791599994,
								25.730121071000042
							],
							[
								-80.22833284599994,
								25.730186031000073
							],
							[
								-80.22830282599995,
								25.73024885700005
							],
							[
								-80.22828282599994,
								25.73028685700007
							],
							[
								-80.22826583599993,
								25.730317661000072
							],
							[
								-80.2282510739999,
								25.73033874200007
							],
							[
								-80.2283328719999,
								25.73045128600006
							],
							[
								-80.22843648899993,
								25.73056641800008
							],
							[
								-80.22857494399994,
								25.730694982000045
							],
							[
								-80.22861254499992,
								25.730732010000054
							],
							[
								-80.22877054499992,
								25.730897009000046
							],
							[
								-80.22885830699995,
								25.731004065000036
							],
							[
								-80.22890230699994,
								25.731067065000047
							],
							[
								-80.22897845599994,
								25.731198504000076
							],
							[
								-80.22901145599991,
								25.73126850400007
							],
							[
								-80.2290413799999,
								25.731338789000063
							],
							[
								-80.22906492999994,
								25.73141145900007
							],
							[
								-80.22908192099993,
								25.73148593500008
							],
							[
								-80.2290922169999,
								25.731561629000055
							],
							[
								-80.22916483599994,
								25.731665339000074
							],
							[
								-80.22920204099995,
								25.731745127000067
							],
							[
								-80.22926141599993,
								25.731694232000052
							],
							[
								-80.22932509099991,
								25.731648832000076
							],
							[
								-80.2293925589999,
								25.731609288000072
							],
							[
								-80.22946328299992,
								25.731575916000054
							],
							[
								-80.22953669999993,
								25.73154897900008
							],
							[
								-80.22961222599992,
								25.731528694000076
							],
							[
								-80.22978522499994,
								25.73148969400006
							],
							[
								-80.22982683399994,
								25.731481341000062
							],
							[
								-80.22989184499994,
								25.731475653000075
							],
							[
								-80.22993192699994,
								25.731437079000045
							],
							[
								-80.2300249509999,
								25.731368697000054
							],
							[
								-80.23027278199993,
								25.731209737000086
							],
							[
								-80.23031890899995,
								25.731148268000084
							],
							[
								-80.23037003099995,
								25.73109088500007
							],
							[
								-80.2304257859999,
								25.731037993000086
							],
							[
								-80.2304857819999,
								25.73098996400006
							],
							[
								-80.2305495949999,
								25.730947138000094
							],
							[
								-80.23061677599992,
								25.730909817000054
							],
							[
								-80.2306868519999,
								25.730878262000093
							],
							[
								-80.23075689799992,
								25.73085042300005
							],
							[
								-80.23090765299992,
								25.73078716000009
							],
							[
								-80.23096040199994,
								25.730754484000045
							],
							[
								-80.23098433899992,
								25.730740164000053
							],
							[
								-80.2311264139999,
								25.73067391400008
							],
							[
								-80.23127783399991,
								25.730633340000054
							],
							[
								-80.23143399999992,
								25.73061967800004
							],
							[
								-80.2315259479999,
								25.730625839000083
							],
							[
								-80.23159581199991,
								25.730589102000067
							],
							[
								-80.23166863699993,
								25.73055865200007
							],
							[
								-80.23174385799992,
								25.730534726000087
							],
							[
								-80.23182089199993,
								25.730517508000048
							],
							[
								-80.23189914099993,
								25.73050713100008
							],
							[
								-80.23197799999991,
								25.730503678000048
							],
							[
								-80.23209778799992,
								25.730504359000065
							],
							[
								-80.23218407899992,
								25.730392927000082
							],
							[
								-80.2322695549999,
								25.730307451000044
							],
							[
								-80.23226767799991,
								25.730286000000035
							],
							[
								-80.23227623199995,
								25.730188226000053
							],
							[
								-80.23223056799993,
								25.730138704000073
							],
							[
								-80.23218905499994,
								25.73008565500004
							],
							[
								-80.23215196299992,
								25.730029426000044
							],
							[
								-80.23211953499992,
								25.72997038400007
							],
							[
								-80.23209198299992,
								25.729908914000077
							],
							[
								-80.23190198299994,
								25.729441914000063
							],
							[
								-80.2318787079999,
								25.729377853000074
							],
							[
								-80.23186035099991,
								25.72931221300007
							],
							[
								-80.23184701899993,
								25.729245372000037
							],
							[
								-80.2318387869999,
								25.72917771300007
							],
							[
								-80.23183570199991,
								25.729109624000046
							],
							[
								-80.23183778299995,
								25.729041498000072
							],
							[
								-80.2318547829999,
								25.728793498000073
							],
							[
								-80.2318663399999,
								25.72869883500005
							],
							[
								-80.23190691299995,
								25.728547414000047
							],
							[
								-80.2319731639999,
								25.728405339000062
							],
							[
								-80.23206307899994,
								25.728276927000085
							],
							[
								-80.2321739269999,
								25.72816608000005
							],
							[
								-80.2322064899999,
								25.72814327800006
							],
							[
								-80.23218891399995,
								25.728105586000083
							],
							[
								-80.23215350899994,
								25.72798107300008
							],
							[
								-80.2321411829999,
								25.72792178900005
							],
							[
								-80.23211758999992,
								25.727975563000086
							],
							[
								-80.23208858999993,
								25.72803156200007
							],
							[
								-80.2320557619999,
								25.728089580000074
							],
							[
								-80.23201872799991,
								25.72814500600009
							],
							[
								-80.2319776889999,
								25.728197537000085
							],
							[
								-80.2319328719999,
								25.728246884000047
							],
							[
								-80.23188787299995,
								25.728292884000044
							],
							[
								-80.23182307299993,
								25.728352921000067
							],
							[
								-80.23169466099995,
								25.728442836000056
							],
							[
								-80.23155258699991,
								25.728509086000088
							],
							[
								-80.2314011659999,
								25.72854965900007
							],
							[
								-80.23123563399992,
								25.728563225000073
							],
							[
								-80.2311782669999,
								25.72856212700009
							],
							[
								-80.23104083399994,
								25.728548659000072
							],
							[
								-80.23098344499994,
								25.72853659900005
							],
							[
								-80.23093844499994,
								25.72852559800009
							],
							[
								-80.23086499599992,
								25.72850429600004
							],
							[
								-80.2307936229999,
								25.72847683100008
							],
							[
								-80.23072484099993,
								25.72844340100005
							],
							[
								-80.23065914799992,
								25.72840424800006
							],
							[
								-80.23060114799995,
								25.728366248000043
							],
							[
								-80.23051592699994,
								25.72830292000009
							],
							[
								-80.23039973099992,
								25.728185576000044
							],
							[
								-80.23035238199992,
								25.728127080000036
							],
							[
								-80.23027316399993,
								25.72801166100004
							],
							[
								-80.23023047299995,
								25.727927888000067
							],
							[
								-80.23017747299991,
								25.727808888000084
							],
							[
								-80.23015838599991,
								25.727762607000045
							],
							[
								-80.23008538699992,
								25.727570608000065
							],
							[
								-80.23005520399994,
								25.72747552000004
							],
							[
								-80.22995871199993,
								25.727473021000037
							],
							[
								-80.22991002299995,
								25.72747043700008
							],
							[
								-80.2296360229999,
								25.727448437000078
							],
							[
								-80.2296165759999,
								25.72744666300008
							],
							[
								-80.2294795759999,
								25.72743266300006
							],
							[
								-80.22941244899994,
								25.72742323600005
							],
							[
								-80.22927844899993,
								25.727399236000053
							],
							[
								-80.22913990899991,
								25.727362833000086
							],
							[
								-80.22897115199993,
								25.72730366600007
							],
							[
								-80.22888265499995,
								25.72727072200007
							],
							[
								-80.2287922349999,
								25.727281953000045
							],
							[
								-80.22873723499993,
								25.727285953000038
							],
							[
								-80.22867199999992,
								25.72728832200005
							],
							[
								-80.22853694499992,
								25.727278123000076
							],
							[
								-80.22845794599993,
								25.72726612400004
							],
							[
								-80.22831555599993,
								25.72723245600008
							],
							[
								-80.2282415549999,
								25.727208456000085
							],
							[
								-80.22810818499994,
								25.727153007000084
							],
							[
								-80.2280341849999,
								25.72711500700007
							],
							[
								-80.22790363899992,
								25.727033128000073
							],
							[
								-80.22783863899991,
								25.726984128000087
							],
							[
								-80.22774126299994,
								25.726899084000085
							],
							[
								-80.22762926299993,
								25.726786084000082
							],
							[
								-80.2275513269999,
								25.72669628600005
							],
							[
								-80.22745732699991,
								25.72657228600008
							],
							[
								-80.22739824299993,
								25.72648395300007
							],
							[
								-80.22732024299995,
								25.726350952000075
							],
							[
								-80.22729641599994,
								25.726307638000037
							],
							[
								-80.22715921499992,
								25.72604113300008
							],
							[
								-80.22713808499992,
								25.726000955000075
							],
							[
								-80.22710427699991,
								25.72599976200007
							],
							[
								-80.2269798339999,
								25.725986659000057
							],
							[
								-80.22686662199993,
								25.72595903000007
							],
							[
								-80.22678062299991,
								25.72593203100007
							],
							[
								-80.22666855499995,
								25.725888420000047
							],
							[
								-80.22658955499992,
								25.725851419000037
							],
							[
								-80.2264938969999,
								25.725799333000055
							],
							[
								-80.22634689599994,
								25.72570733300006
							],
							[
								-80.22625050499994,
								25.72563773600007
							],
							[
								-80.2261262159999,
								25.725534828000036
							],
							[
								-80.22600783999991,
								25.725415712000085
							],
							[
								-80.22590560099992,
								25.72528935100007
							],
							[
								-80.2258261639999,
								25.725173661000042
							],
							[
								-80.22580061799994,
								25.725126183000043
							],
							[
								-80.22575561899993,
								25.725036182000053
							],
							[
								-80.22569910199991,
								25.724894067000037
							],
							[
								-80.22567010199992,
								25.724798067000055
							],
							[
								-80.2256453409999,
								25.724694166000067
							],
							[
								-80.2256316779999,
								25.724538000000052
							],
							[
								-80.2256453409999,
								25.724381834000045
							],
							[
								-80.22568591399994,
								25.72423041400009
							],
							[
								-80.22575216399991,
								25.724088339000048
							],
							[
								-80.2258420789999,
								25.723959927000067
							],
							[
								-80.22595292699992,
								25.723849079000047
							],
							[
								-80.2260813389999,
								25.723759164000057
							],
							[
								-80.22622274799994,
								25.72369315600008
							],
							[
								-80.22637108099991,
								25.723639035000076
							],
							[
								-80.22652283499991,
								25.72359834100007
							],
							[
								-80.22654394299991,
								25.72359487700004
							],
							[
								-80.22670194299991,
								25.723570877000046
							],
							[
								-80.2268080039999,
								25.72356114600007
							],
							[
								-80.2269010039999,
								25.723558145000084
							],
							[
								-80.2270157179999,
								25.72356177200004
							],
							[
								-80.22710971699992,
								25.723570773000063
							],
							[
								-80.22720589099993,
								25.723585264000064
							],
							[
								-80.22729789099992,
								25.723604264000073
							],
							[
								-80.22742358599993,
								25.723639914000046
							],
							[
								-80.22745164999992,
								25.723650663000058
							],
							[
								-80.22753864999993,
								25.723685662000037
							],
							[
								-80.22765266099992,
								25.723741164000046
							],
							[
								-80.2277176419999,
								25.723782767000046
							],
							[
								-80.22775445699995,
								25.723789432000046
							],
							[
								-80.2278154569999,
								25.723802432000074
							],
							[
								-80.22789020599993,
								25.72382175100006
							],
							[
								-80.22796302199993,
								25.723847410000076
							],
							[
								-80.22803336899995,
								25.72387922000007
							],
							[
								-80.22810072899995,
								25.723916946000088
							],
							[
								-80.22816460399991,
								25.723960311000045
							],
							[
								-80.22822452499992,
								25.724008994000087
							],
							[
								-80.22826852599991,
								25.724047994000045
							],
							[
								-80.22833739299995,
								25.724118753000084
							],
							[
								-80.22841508499994,
								25.724151620000043
							],
							[
								-80.2284950849999,
								25.72419062000006
							],
							[
								-80.22855906799992,
								25.724225078000075
							],
							[
								-80.22862005999991,
								25.724264590000075
							],
							[
								-80.22867766299993,
								25.724308898000064
							],
							[
								-80.22873149999992,
								25.724357712000085
							],
							[
								-80.22878121999992,
								25.724410713000054
							],
							[
								-80.22884956999991,
								25.724489821000077
							],
							[
								-80.2289418119999,
								25.724619852000046
							],
							[
								-80.22896503399994,
								25.72466815300004
							],
							[
								-80.22898651399993,
								25.72464372400009
							],
							[
								-80.22902151499994,
								25.72460572400007
							],
							[
								-80.22907068799992,
								25.724556324000048
							],
							[
								-80.22912353899994,
								25.72451088100007
							],
							[
								-80.22917975099995,
								25.72446966700005
							],
							[
								-80.22923898599993,
								25.72443293100008
							],
							[
								-80.2293008879999,
								25.724400893000055
							],
							[
								-80.22936508499994,
								25.724373745000037
							],
							[
								-80.22943119199994,
								25.724351650000074
							],
							[
								-80.22947919199993,
								25.724337650000052
							],
							[
								-80.22957483399995,
								25.72431534100008
							],
							[
								-80.22962654999992,
								25.724314091000053
							],
							[
								-80.22973128399991,
								25.724304928000038
							],
							[
								-80.22977435099995,
								25.724303554000073
							],
							[
								-80.22981745299995,
								25.72430562900007
							],
							[
								-80.22993916599995,
								25.724317341000074
							],
							[
								-80.23002318099992,
								25.724338421000084
							],
							[
								-80.23009314299992,
								25.72435720100009
							],
							[
								-80.23016258599995,
								25.72437791400006
							],
							[
								-80.2302619699999,
								25.724421030000087
							],
							[
								-80.2303289699999,
								25.72445503000006
							],
							[
								-80.23037166099994,
								25.72447816400006
							],
							[
								-80.23046917399995,
								25.72454329100009
							],
							[
								-80.2304875069999,
								25.72455826500004
							],
							[
								-80.23053376199994,
								25.724507449000043
							],
							[
								-80.2305927619999,
								25.72444744900008
							],
							[
								-80.23065592699993,
								25.724389079000048
							],
							[
								-80.23078582199992,
								25.72429831100004
							],
							[
								-80.2312853059999,
								25.724012459000054
							],
							[
								-80.23136244599993,
								25.72397311600008
							],
							[
								-80.23176844599993,
								25.72379011600009
							],
							[
								-80.23182331399995,
								25.723767532000068
							],
							[
								-80.23246478899995,
								25.723527922000073
							],
							[
								-80.23245123999993,
								25.723513808000064
							],
							[
								-80.2324028349999,
								25.723459103000042
							],
							[
								-80.23235902899995,
								25.723400650000087
							],
							[
								-80.23232011199991,
								25.72333883400006
							],
							[
								-80.23228633999993,
								25.723274064000066
							],
							[
								-80.23225793599994,
								25.72320676700008
							],
							[
								-80.23224442499992,
								25.72317067700004
							],
							[
								-80.23221996599995,
								25.723094152000044
							],
							[
								-80.23220243799994,
								25.72301574800008
							],
							[
								-80.23219198299995,
								25.722936092000054
							],
							[
								-80.23218868399994,
								25.722855820000067
							],
							[
								-80.23219256699991,
								25.722775575000075
							],
							[
								-80.23220360099992,
								25.722695997000073
							],
							[
								-80.23220986099994,
								25.722663159000035
							],
							[
								-80.23222577699994,
								25.72259487400004
							],
							[
								-80.2322469639999,
								25.72252803600009
							],
							[
								-80.23227329399992,
								25.72246305200008
							],
							[
								-80.2323046059999,
								25.72240031700005
							],
							[
								-80.2323407099999,
								25.722340211000073
							],
							[
								-80.23238138799991,
								25.722283101000073
							],
							[
								-80.23239838799992,
								25.72226110200006
							],
							[
								-80.23242107899995,
								25.72223292700005
							],
							[
								-80.23253192699991,
								25.72212208000008
							],
							[
								-80.23266033899995,
								25.722032165000087
							],
							[
								-80.23280241399993,
								25.721965914000066
							],
							[
								-80.2329612659999,
								25.721924095000077
							],
							[
								-80.23301269799992,
								25.721915848000037
							],
							[
								-80.2331057749999,
								25.72190849000009
							],
							[
								-80.23315483499994,
								25.721896341000047
							],
							[
								-80.23322573199994,
								25.72188672900006
							],
							[
								-80.2333097309999,
								25.721878729000082
							],
							[
								-80.2334055799999,
								25.72187474000009
							],
							[
								-80.23348000199991,
								25.721875615000044
							],
							[
								-80.23353408399993,
								25.721874979000063
							],
							[
								-80.23361588099993,
								25.721854530000087
							],
							[
								-80.2336449199999,
								25.721847780000076
							],
							[
								-80.2338309189999,
								25.721807780000066
							],
							[
								-80.23397272999995,
								25.72178892100004
							],
							[
								-80.23408672999996,
								25.721782921000056
							],
							[
								-80.23422733899991,
								25.721786535000035
							],
							[
								-80.2343423399999,
								25.721798535000065
							],
							[
								-80.23440727999991,
								25.721807716000058
							],
							[
								-80.23447137799991,
								25.72182160600005
							],
							[
								-80.2345342939999,
								25.72184013000009
							],
							[
								-80.23459569199991,
								25.721863190000082
							],
							[
								-80.23465524699992,
								25.721890664000057
							],
							[
								-80.23473424699995,
								25.72193066400007
							],
							[
								-80.23485454399992,
								25.722003938000057
							],
							[
								-80.2349051889999,
								25.72204051500006
							],
							[
								-80.23495508499991,
								25.722052141000063
							],
							[
								-80.2350238219999,
								25.72207105500007
							],
							[
								-80.2350908439999,
								25.722095357000057
							],
							[
								-80.23515572899993,
								25.722124894000046
							],
							[
								-80.23521806899993,
								25.722159480000073
							],
							[
								-80.23527747299994,
								25.722198898000045
							],
							[
								-80.2353335649999,
								25.722242899000037
							],
							[
								-80.23539382799993,
								25.72229477700006
							],
							[
								-80.23542685299992,
								25.72230143900009
							],
							[
								-80.23546175299992,
								25.722309205000045
							],
							[
								-80.23557675299992,
								25.722337206000077
							],
							[
								-80.2357209509999,
								25.72238555100006
							],
							[
								-80.23581047999994,
								25.722424266000075
							],
							[
								-80.23584807899995,
								25.722428604000072
							],
							[
								-80.23599876199995,
								25.722459222000055
							],
							[
								-80.23608556499994,
								25.72248475300006
							],
							[
								-80.23610668399994,
								25.722485678000055
							],
							[
								-80.23622499999993,
								25.722485678000055
							],
							[
								-80.23625798199993,
								25.72248628300008
							],
							[
								-80.23636698199994,
								25.72249028300007
							],
							[
								-80.23645660299991,
								25.722498074000043
							],
							[
								-80.23656560299992,
								25.722513074000066
							],
							[
								-80.23659916599992,
								25.72251834100007
							],
							[
								-80.23674111299994,
								25.722555526000065
							],
							[
								-80.2368576319999,
								25.72259650500007
							],
							[
								-80.23691623699995,
								25.722617711000055
							],
							[
								-80.2369570329999,
								25.72262278800008
							],
							[
								-80.23708303899991,
								25.722630008000067
							],
							[
								-80.23719492899994,
								25.722627094000075
							],
							[
								-80.23735587499993,
								25.722607546000063
							],
							[
								-80.2374882549999,
								25.72257812800007
							],
							[
								-80.23770509699995,
								25.722493402000055
							],
							[
								-80.23789890699993,
								25.72240645900007
							],
							[
								-80.23792381999993,
								25.722395731000063
							],
							[
								-80.2380328189999,
								25.722350732000052
							],
							[
								-80.23809836599992,
								25.72232660600008
							],
							[
								-80.23821236499992,
								25.72228960500007
							],
							[
								-80.2382833449999,
								25.722269743000084
							],
							[
								-80.23835534599993,
								25.72225274300007
							],
							[
								-80.23840583499992,
								25.722242340000037
							],
							[
								-80.23853864799992,
								25.722228981000058
							],
							[
								-80.23861564799995,
								25.722226981000063
							],
							[
								-80.23869599099993,
								25.722228485000073
							],
							[
								-80.2387758779999,
								25.722237155000073
							],
							[
								-80.23885467299993,
								25.722252921000063
							],
							[
								-80.23893174599993,
								25.722275658000058
							],
							[
								-80.2389927449999,
								25.72229665800006
							],
							[
								-80.23906616499994,
								25.722325227000056
							],
							[
								-80.23913358599992,
								25.72234691400007
							],
							[
								-80.23924921199995,
								25.722398481000084
							],
							[
								-80.23927921099994,
								25.722414481000047
							],
							[
								-80.23934817699991,
								25.722455310000047
							],
							[
								-80.23941323399993,
								25.722502118000083
							],
							[
								-80.23947386599991,
								25.72255453100007
							],
							[
								-80.2395295899999,
								25.722612134000087
							],
							[
								-80.2395525899999,
								25.72263813400008
							],
							[
								-80.2395679199999,
								25.722655927000062
							],
							[
								-80.23965783499995,
								25.722784339000043
							],
							[
								-80.23972408599991,
								25.722926414000085
							],
							[
								-80.23976465899995,
								25.723077834000037
							],
							[
								-80.23977832199995,
								25.723234000000048
							],
							[
								-80.23977550399991,
								25.723305141000083
							],
							[
								-80.23977050399992,
								25.723368142000083
							],
							[
								-80.23975965999995,
								25.72345316600007
							],
							[
								-80.23975080399993,
								25.723486217000072
							],
							[
								-80.23981810899994,
								25.723451535000038
							],
							[
								-80.23988813599993,
								25.723422741000036
							],
							[
								-80.23996036999995,
								25.72340004600005
							],
							[
								-80.24003428099991,
								25.723383616000035
							],
							[
								-80.24010932699991,
								25.72337357100008
							],
							[
								-80.24018495799993,
								25.72336998700007
							],
							[
								-80.24026061799992,
								25.72337288900008
							],
							[
								-80.24033575199991,
								25.723382255000047
							],
							[
								-80.24037170299994,
								25.723346303000085
							],
							[
								-80.2403569139999,
								25.72331458700006
							],
							[
								-80.24031634099993,
								25.723163166000063
							],
							[
								-80.24030267799992,
								25.723007000000052
							],
							[
								-80.24031634099993,
								25.722850835000088
							],
							[
								-80.2403569139999,
								25.72269941400009
							],
							[
								-80.24036818699994,
								25.722670049000044
							],
							[
								-80.24042718699991,
								25.72252404900007
							],
							[
								-80.2404821639999,
								25.722411339000075
							],
							[
								-80.24054542099992,
								25.722316273000047
							],
							[
								-80.2410362999999,
								25.721671432000054
							],
							[
								-80.24143352199991,
								25.721149142000062
							],
							[
								-80.24219128499993,
								25.72015538700009
							],
							[
								-80.24287521799994,
								25.720741615000065
							],
							[
								-80.24316148899993,
								25.72098699100008
							],
							[
								-80.24344276399995,
								25.721228083000085
							],
							[
								-80.2440874369999,
								25.721780661000082
							],
							[
								-80.24474648299991,
								25.72234555600005
							],
							[
								-80.24522896099997,
								25.722759110000084
							],
							[
								-80.24566446799992,
								25.72312374100005
							],
							[
								-80.24601453399993,
								25.72341681900008
							],
							[
								-80.2462799999999,
								25.723660000000056
							],
							[
								-80.24616418799991,
								25.72378868000004
							],
							[
								-80.24597335199991,
								25.723995091000063
							],
							[
								-80.24576735099994,
								25.724211523000065
							],
							[
								-80.24552665199991,
								25.72444392200009
							],
							[
								-80.24539688199991,
								25.724591161000035
							],
							[
								-80.24531437699994,
								25.724681651000083
							],
							[
								-80.24516999999992,
								25.724840000000086
							],
							[
								-80.24512861599995,
								25.72488914300004
							],
							[
								-80.24500999999992,
								25.72503000000006
							],
							[
								-80.2448904339999,
								25.725217393000037
							],
							[
								-80.24479999999994,
								25.72537000000006
							],
							[
								-80.24471634999992,
								25.725532072000078
							],
							[
								-80.24463999999995,
								25.725680000000068
							],
							[
								-80.24454334199993,
								25.725853985000075
							],
							[
								-80.24447417899995,
								25.725969896000038
							],
							[
								-80.24430833699995,
								25.726194120000063
							],
							[
								-80.24418999999995,
								25.726300000000037
							],
							[
								-80.24410108899991,
								25.726382984000054
							],
							[
								-80.24397140299995,
								25.726504024000064
							],
							[
								-80.24373999999995,
								25.726720000000057
							],
							[
								-80.24410900499993,
								25.72704841400008
							],
							[
								-80.24445080699991,
								25.727352618000054
							],
							[
								-80.24492667399994,
								25.727773909000064
							],
							[
								-80.24514999999991,
								25.727970000000088
							],
							[
								-80.24532060099995,
								25.727964830000076
							],
							[
								-80.24547999999993,
								25.727960000000053
							],
							[
								-80.24548652699991,
								25.728103592000082
							],
							[
								-80.24550050499994,
								25.728279797000084
							],
							[
								-80.24551205599994,
								25.728427579000083
							],
							[
								-80.24551999999994,
								25.728650000000076
							],
							[
								-80.24552873699992,
								25.728754841000068
							],
							[
								-80.24553999999995,
								25.728890000000035
							],
							[
								-80.24554607499994,
								25.72902668900008
							],
							[
								-80.24555492199994,
								25.72922574000006
							],
							[
								-80.2455599999999,
								25.729340000000036
							],
							[
								-80.24557470999991,
								25.729523870000037
							],
							[
								-80.24557639199992,
								25.729672985000036
							],
							[
								-80.24556999999993,
								25.729820000000075
							],
							[
								-80.24557208699991,
								25.72992504000007
							],
							[
								-80.2455799999999,
								25.73002000000008
							],
							[
								-80.24559190999992,
								25.730222472000037
							],
							[
								-80.24560085099995,
								25.730374462000043
							],
							[
								-80.24560999999994,
								25.730530000000044
							],
							[
								-80.24561515699992,
								25.730622828000037
							],
							[
								-80.24561999999992,
								25.730710000000045
							],
							[
								-80.24564399899992,
								25.73106998700007
							],
							[
								-80.24565238299995,
								25.731195743000058
							],
							[
								-80.24566892999991,
								25.73144394500008
							],
							[
								-80.2456699999999,
								25.731630000000052
							],
							[
								-80.24567810699995,
								25.731817479000085
							],
							[
								-80.2456899899999,
								25.732092279000085
							],
							[
								-80.2457007509999,
								25.73234111900007
							],
							[
								-80.2457115119999,
								25.732589958000062
							],
							[
								-80.24572989799992,
								25.73301513800004
							],
							[
								-80.24573855299991,
								25.733215286000075
							],
							[
								-80.24574999999993,
								25.733480000000046
							],
							[
								-80.24575805299992,
								25.73366320000008
							],
							[
								-80.2457657089999,
								25.733837377000043
							],
							[
								-80.24577778799994,
								25.73411217800009
							],
							[
								-80.24578999999994,
								25.734390000000076
							],
							[
								-80.24579835499992,
								25.73458495700004
							],
							[
								-80.2458091119999,
								25.73483593800006
							],
							[
								-80.24582583999995,
								25.735160075000067
							],
							[
								-80.24583999999993,
								25.73533000000009
							],
							[
								-80.24586022099993,
								25.735484351000082
							],
							[
								-80.24587160099992,
								25.735708147000082
							],
							[
								-80.24588677299994,
								25.73600654100005
							],
							[
								-80.24588999999992,
								25.736220000000063
							],
							[
								-80.2458981129999,
								25.73650394500004
							],
							[
								-80.24590313499993,
								25.736679740000056
							],
							[
								-80.24590646399992,
								25.736921283000072
							],
							[
								-80.24563756099991,
								25.73701883800004
							],
							[
								-80.24525833199993,
								25.737156419000087
							],
							[
								-80.24476664099991,
								25.737334800000042
							],
							[
								-80.2444248999999,
								25.737458781000043
							],
							[
								-80.2441855109999,
								25.737545629000067
							],
							[
								-80.24394471999994,
								25.73763298500006
							],
							[
								-80.24375999999995,
								25.737700000000075
							],
							[
								-80.24354929399993,
								25.737775438000085
							],
							[
								-80.24313768899994,
								25.73792280300006
							],
							[
								-80.24294999999995,
								25.73799000000008
							],
							[
								-80.24288639699995,
								25.738012757000035
							],
							[
								-80.24275789799992,
								25.73805873400005
							],
							[
								-80.2424372349999,
								25.73817346700008
							],
							[
								-80.24199829299994,
								25.738330519000044
							],
							[
								-80.24167253699994,
								25.738449986000035
							],
							[
								-80.24139499199993,
								25.73855360300007
							],
							[
								-80.24108772499994,
								25.738667862000057
							],
							[
								-80.24053305099994,
								25.73887056700005
							],
							[
								-80.23780985099995,
								25.739878564000037
							],
							[
								-80.23778384799995,
								25.739888991000043
							],
							[
								-80.23775537599994,
								25.73990040700005
							],
							[
								-80.2372991499999,
								25.740067601000078
							],
							[
								-80.21888753299993,
								25.746814955000048
							],
							[
								-80.2132236729999,
								25.748757883000053
							],
							[
								-80.21156373799994,
								25.749327307000044
							],
							[
								-80.21033648999992,
								25.749748301000068
							],
							[
								-80.2099815009999,
								25.749796651000054
							],
							[
								-80.20972420899994,
								25.749851654000057
							],
							[
								-80.20949512499993,
								25.74989134000009
							],
							[
								-80.20816679399992,
								25.750121456000045
							],
							[
								-80.20756168899993,
								25.750114730000064
							],
							[
								-80.20703807899991,
								25.75014879500009
							],
							[
								-80.20653778799993,
								25.75018214700009
							],
							[
								-80.20641999999992,
								25.75019000000009
							],
							[
								-80.2059812409999,
								25.750220409000065
							],
							[
								-80.20537092599994,
								25.75026402800006
							],
							[
								-80.20487649699993,
								25.750315000000057
							],
							[
								-80.2045844299999,
								25.75034511000007
							],
							[
								-80.20419356199994,
								25.750262466000038
							],
							[
								-80.20400999999993,
								25.750290000000064
							],
							[
								-80.20400939599995,
								25.75029023500008
							],
							[
								-80.20382999999993,
								25.750360000000057
							]
						],
						[
							[
								-80.23294049799995,
								25.726387543000047
							],
							[
								-80.23300170899995,
								25.72635235100006
							],
							[
								-80.23331670899995,
								25.726187352000068
							],
							[
								-80.23342641399995,
								25.726138914000046
							],
							[
								-80.2335778339999,
								25.726098341000068
							],
							[
								-80.23373399999991,
								25.726084678000063
							],
							[
								-80.23389016599992,
								25.726098341000068
							],
							[
								-80.23404158599993,
								25.726138914000046
							],
							[
								-80.23418917299995,
								25.726208399000086
							],
							[
								-80.23427501399995,
								25.72625954700004
							],
							[
								-80.23442768599996,
								25.726109530000087
							],
							[
								-80.23445676699993,
								25.72608219600005
							],
							[
								-80.23482349699992,
								25.725752519000082
							],
							[
								-80.23514025599991,
								25.725432924000074
							],
							[
								-80.23518193799993,
								25.725388360000068
							],
							[
								-80.23522826899995,
								25.725348650000058
							],
							[
								-80.2352786859999,
								25.725314276000063
							],
							[
								-80.23533257699995,
								25.72528565500005
							],
							[
								-80.23523530099993,
								25.725244607000036
							],
							[
								-80.2350913009999,
								25.725173607000045
							],
							[
								-80.23502630199994,
								25.725138162000064
							],
							[
								-80.23489130199994,
								25.72505716200004
							],
							[
								-80.23485731099993,
								25.72503572000005
							],
							[
								-80.23466179899992,
								25.724906194000088
							],
							[
								-80.23461856799992,
								25.724946899000088
							],
							[
								-80.23457246299996,
								25.724984318000054
							],
							[
								-80.23452373399994,
								25.725018249000073
							],
							[
								-80.23447264399994,
								25.72504851000008
							],
							[
								-80.2344396439999,
								25.725066510000094
							],
							[
								-80.23437250899991,
								25.72509958200004
							],
							[
								-80.23430285699993,
								25.725126957000047
							],
							[
								-80.23423116999993,
								25.725148447000038
							],
							[
								-80.23415794499994,
								25.725163902000077
							],
							[
								-80.23408368799994,
								25.72517321500004
							],
							[
								-80.23402368799992,
								25.72517821500009
							],
							[
								-80.23393682299991,
								25.72517447300004
							],
							[
								-80.2338922159999,
								25.725178102000086
							],
							[
								-80.23385656599993,
								25.725182465000046
							],
							[
								-80.23356904899993,
								25.72525273900004
							],
							[
								-80.23330249899993,
								25.725333069000044
							],
							[
								-80.2332786309999,
								25.725339904000066
							],
							[
								-80.23306473799994,
								25.725397975000078
							],
							[
								-80.23296273099993,
								25.725427471000046
							],
							[
								-80.23287688699992,
								25.72546509400007
							],
							[
								-80.23276457399993,
								25.725521608000065
							],
							[
								-80.2325571909999,
								25.725641529000086
							],
							[
								-80.23248083699991,
								25.725680940000075
							],
							[
								-80.2321995609999,
								25.725809496000068
							],
							[
								-80.23209857199993,
								25.72585964500007
							],
							[
								-80.2320750259999,
								25.725879421000062
							],
							[
								-80.23202151799991,
								25.725926454000046
							],
							[
								-80.23195458299995,
								25.725980745000072
							],
							[
								-80.23201398999993,
								25.726063353000086
							],
							[
								-80.2320534129999,
								25.72612884600005
							],
							[
								-80.23212408599994,
								25.726278414000035
							],
							[
								-80.23216463799993,
								25.726429711000037
							],
							[
								-80.23218564899992,
								25.726548773000047
							],
							[
								-80.23219932199993,
								25.726705000000038
							],
							[
								-80.2321973629999,
								25.726764332000073
							],
							[
								-80.23218936299993,
								25.726885333000045
							],
							[
								-80.23217765899994,
								25.726982166000084
							],
							[
								-80.2321533359999,
								25.72709737200006
							],
							[
								-80.2321978839999,
								25.72725812300007
							],
							[
								-80.2322061779999,
								25.727305967000063
							],
							[
								-80.23222848299991,
								25.72725732500004
							],
							[
								-80.23233332399991,
								25.72707033200004
							],
							[
								-80.23242319299993,
								25.726940384000045
							],
							[
								-80.23272863599993,
								25.726572656000087
							],
							[
								-80.23277597799996,
								25.726520272000073
							],
							[
								-80.23282728299995,
								25.726471763000063
							],
							[
								-80.23288223599991,
								25.72642742900007
							],
							[
								-80.23294049799995,
								25.726387543000047
							]
						],
						[
							[
								-80.23683856199996,
								25.725836790000074
							],
							[
								-80.23748350799991,
								25.72638251400008
							],
							[
								-80.23777281499991,
								25.726254726000036
							],
							[
								-80.23802444099995,
								25.72587506800005
							],
							[
								-80.23859116199992,
								25.725020490000077
							],
							[
								-80.23908871999993,
								25.724267937000036
							],
							[
								-80.23904802599992,
								25.724287578000087
							],
							[
								-80.23896104599993,
								25.72432189200009
							],
							[
								-80.2386997879999,
								25.724441199000072
							],
							[
								-80.2384209199999,
								25.724583001000042
							],
							[
								-80.23809851199991,
								25.72474421600009
							],
							[
								-80.23780108599993,
								25.724902599000075
							],
							[
								-80.23760014099992,
								25.725019816000042
							],
							[
								-80.23755062899994,
								25.725046656000075
							],
							[
								-80.23732762799995,
								25.72515865600008
							],
							[
								-80.23723158599995,
								25.725200086000086
							],
							[
								-80.23717830099991,
								25.725217618000045
							],
							[
								-80.2370053009999,
								25.725268619000076
							],
							[
								-80.2369550379999,
								25.72528187000006
							],
							[
								-80.23677903799995,
								25.72532287000007
							],
							[
								-80.23674875799992,
								25.725329377000037
							],
							[
								-80.23641496199991,
								25.72539501700004
							],
							[
								-80.23638079299991,
								25.725398381000048
							],
							[
								-80.2364020149999,
								25.72541743900007
							],
							[
								-80.23683856199996,
								25.725836790000074
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami",
				"Name": "North-East Coconut Grove",
				"RegionID": "269105"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.05962128699991,
					26.736330130000056,
					-80.05655976299994,
					26.745929889000085
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.0568437689999,
							26.736499287000072
						],
						[
							-80.05685552299991,
							26.736330130000056
						],
						[
							-80.05701617299991,
							26.73633391000004
						],
						[
							-80.0572593149999,
							26.73633963100008
						],
						[
							-80.0576999999999,
							26.736350000000076
						],
						[
							-80.05783314799993,
							26.73635532600008
						],
						[
							-80.0580956089999,
							26.736365824000078
						],
						[
							-80.05829184299995,
							26.736376913000072
						],
						[
							-80.05830999999995,
							26.736480001000075
						],
						[
							-80.05827800999992,
							26.736482170000045
						],
						[
							-80.05962128699991,
							26.745929889000085
						],
						[
							-80.05957339199995,
							26.745929086000046
						],
						[
							-80.0592700439999,
							26.745913784000038
						],
						[
							-80.05911753299995,
							26.745909551000068
						],
						[
							-80.05870796499994,
							26.745908117000056
						],
						[
							-80.0583293329999,
							26.745896926000057
						],
						[
							-80.0579726389999,
							26.745886383000084
						],
						[
							-80.05757206899995,
							26.74587454400006
						],
						[
							-80.05730152699995,
							26.745866548000038
						],
						[
							-80.05707999999993,
							26.74586000000005
						],
						[
							-80.05683630499993,
							26.745855314000043
						],
						[
							-80.05655976299994,
							26.745846360000087
						],
						[
							-80.05656480699992,
							26.74563541000009
						],
						[
							-80.05657999999994,
							26.745000000000065
						],
						[
							-80.05658512499991,
							26.74456949900008
						],
						[
							-80.05658999999991,
							26.74416000000008
						],
						[
							-80.05660999999992,
							26.74374000000006
						],
						[
							-80.05660999999992,
							26.74333000000007
						],
						[
							-80.05661405799992,
							26.74299317000009
						],
						[
							-80.05661702499992,
							26.74274691700009
						],
						[
							-80.05661999999995,
							26.742500000000064
						],
						[
							-80.05662418399993,
							26.74241003800006
						],
						[
							-80.0566411829999,
							26.741982661000065
						],
						[
							-80.05664999999993,
							26.741630000000043
						],
						[
							-80.05665728199995,
							26.74147707800006
						],
						[
							-80.05666999999994,
							26.74110073700007
						],
						[
							-80.05666999999994,
							26.740820000000042
						],
						[
							-80.05667662699994,
							26.740621202000057
						],
						[
							-80.05669045199994,
							26.74020642900007
						],
						[
							-80.05669999999992,
							26.73992000000004
						],
						[
							-80.0567037639999,
							26.739765682000044
						],
						[
							-80.0567094509999,
							26.73953249400006
						],
						[
							-80.05671999999993,
							26.739100000000064
						],
						[
							-80.05673374299994,
							26.738766723000083
						],
						[
							-80.05675241999995,
							26.738313804000086
						],
						[
							-80.05676367099994,
							26.738040985000055
						],
						[
							-80.05677329799994,
							26.737807522000082
						],
						[
							-80.05679517699991,
							26.73727695900004
						],
						[
							-80.05681586899993,
							26.736900810000066
						],
						[
							-80.0568437689999,
							26.736499287000072
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "West Palm Beach",
				"Name": "Northwood Pines",
				"RegionID": "269114"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.63840899999991,
					30.298147908000093,
					-81.6118130289999,
					30.313564045000078
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.6284238689999,
							30.306160022000086
						],
						[
							-81.62842302699994,
							30.30608987000005
						],
						[
							-81.62808790499992,
							30.306131009000072
						],
						[
							-81.62783090499994,
							30.306160008000067
						],
						[
							-81.62761590499991,
							30.306189008000047
						],
						[
							-81.6272809059999,
							30.306218008000087
						],
						[
							-81.6266529049999,
							30.306284009000077
						],
						[
							-81.62627190599994,
							30.30631100800008
						],
						[
							-81.62567690499992,
							30.306366009000048
						],
						[
							-81.62525990499996,
							30.306415008000045
						],
						[
							-81.62461890499992,
							30.30649000800008
						],
						[
							-81.62409390499994,
							30.306539009000062
						],
						[
							-81.62385590499991,
							30.30657000800005
						],
						[
							-81.62340290599991,
							30.306651009000067
						],
						[
							-81.62318090599992,
							30.306713009000077
						],
						[
							-81.62289290599995,
							30.306807009000067
						],
						[
							-81.62256990499992,
							30.306929009000047
						],
						[
							-81.6220819049999,
							30.30711100800005
						],
						[
							-81.6218769059999,
							30.307191009000064
						],
						[
							-81.62080990599992,
							30.307595008000078
						],
						[
							-81.6204819049999,
							30.307720008000047
						],
						[
							-81.62009490499992,
							30.307864009000074
						],
						[
							-81.61934190599993,
							30.30814600800005
						],
						[
							-81.61925190499994,
							30.30817400800004
						],
						[
							-81.61919987699991,
							30.308183179000086
						],
						[
							-81.6178354999999,
							30.307418147000078
						],
						[
							-81.6167390999999,
							30.306504484000072
						],
						[
							-81.6158254369999,
							30.305590820000077
						],
						[
							-81.61427220299993,
							30.304128953000088
						],
						[
							-81.6118130289999,
							30.30156994200007
						],
						[
							-81.6119219069999,
							30.301589010000043
						],
						[
							-81.6120669099999,
							30.301601009000077
						],
						[
							-81.61215590799992,
							30.301586010000047
						],
						[
							-81.6122299079999,
							30.30156901000004
						],
						[
							-81.61236090699992,
							30.301531011000066
						],
						[
							-81.61242897499994,
							30.301506126000053
						],
						[
							-81.61253090699995,
							30.301407011000038
						],
						[
							-81.61280490699994,
							30.301077011000075
						],
						[
							-81.61290790899996,
							30.300996010000063
						],
						[
							-81.61347690799994,
							30.300555011000085
						],
						[
							-81.61450692099993,
							30.29983881900006
						],
						[
							-81.61562390699993,
							30.300776197000065
						],
						[
							-81.61852790799992,
							30.298383011000055
						],
						[
							-81.61881390799994,
							30.298147908000093
						],
						[
							-81.61910890599995,
							30.298280008000066
						],
						[
							-81.61932190599993,
							30.298379009000087
						],
						[
							-81.61983490499995,
							30.29861900900005
						],
						[
							-81.62128090599992,
							30.29929000800007
						],
						[
							-81.6214529049999,
							30.299371008000033
						],
						[
							-81.6223989049999,
							30.299804009000074
						],
						[
							-81.6230699059999,
							30.300129008000056
						],
						[
							-81.62337990599991,
							30.30028500800006
						],
						[
							-81.6247329059999,
							30.300922008000043
						],
						[
							-81.62531290499993,
							30.301195009000082
						],
						[
							-81.62547690499991,
							30.301276008000062
						],
						[
							-81.62563090599991,
							30.301353008000035
						],
						[
							-81.6258589059999,
							30.30144500900008
						],
						[
							-81.62620890599993,
							30.30160300800009
						],
						[
							-81.62658690599994,
							30.30177900800004
						],
						[
							-81.62735490499995,
							30.30213700800004
						],
						[
							-81.6276399059999,
							30.302275008000034
						],
						[
							-81.62778690599993,
							30.302350008000076
						],
						[
							-81.62796090599994,
							30.30242700900004
						],
						[
							-81.62821390499995,
							30.302550008000086
						],
						[
							-81.62841890499993,
							30.302655009000034
						],
						[
							-81.6289239059999,
							30.302894008000067
						],
						[
							-81.62959790499991,
							30.30319100900005
						],
						[
							-81.62989290599995,
							30.303335009000076
						],
						[
							-81.63001990499993,
							30.30339500900004
						],
						[
							-81.63056890599995,
							30.303652008000086
						],
						[
							-81.63082090599994,
							30.30376100800004
						],
						[
							-81.63095890599995,
							30.30382200800005
						],
						[
							-81.63178390899992,
							30.304095182000086
						],
						[
							-81.63185790199992,
							30.30406783400008
						],
						[
							-81.63194590599996,
							30.304095009000036
						],
						[
							-81.63277940599994,
							30.304386008000048
						],
						[
							-81.63347790499995,
							30.30460500800007
						],
						[
							-81.63386990499993,
							30.30471700800007
						],
						[
							-81.63428790499995,
							30.30482500800008
						],
						[
							-81.63449490499995,
							30.30486600800009
						],
						[
							-81.63530706799992,
							30.305070955000073
						],
						[
							-81.63517776999993,
							30.30522507400008
						],
						[
							-81.63524090599992,
							30.305220008000052
						],
						[
							-81.63532990599992,
							30.305212009000055
						],
						[
							-81.63541690599993,
							30.30521500900005
						],
						[
							-81.6355079029999,
							30.305221009000036
						],
						[
							-81.63584390599993,
							30.305309008000055
						],
						[
							-81.63596390599992,
							30.305326009000055
						],
						[
							-81.63634490499993,
							30.305431009000078
						],
						[
							-81.63704990499991,
							30.305680009000067
						],
						[
							-81.63729607399995,
							30.305751928000067
						],
						[
							-81.63720785899994,
							30.305978958000082
						],
						[
							-81.63711877999992,
							30.306122963000064
						],
						[
							-81.63710490699992,
							30.306201007000084
						],
						[
							-81.63711590699995,
							30.306438008000047
						],
						[
							-81.63720590499992,
							30.30690100800007
						],
						[
							-81.63744690599992,
							30.308016009000088
						],
						[
							-81.63766490599994,
							30.308870008000046
						],
						[
							-81.63793190599995,
							30.310032009000057
						],
						[
							-81.6381147809999,
							30.31130405300007
						],
						[
							-81.63816090499995,
							30.311375010000067
						],
						[
							-81.6382679059999,
							30.311668009000076
						],
						[
							-81.63832090499994,
							30.31188000900005
						],
						[
							-81.63837390499992,
							30.312450009000088
						],
						[
							-81.63840899999991,
							30.31267300000008
						],
						[
							-81.63825052899995,
							30.313564045000078
						],
						[
							-81.63814529799993,
							30.31353275500004
						],
						[
							-81.63401179699991,
							30.31222514200005
						],
						[
							-81.63285626299997,
							30.31213137600008
						],
						[
							-81.63277283399992,
							30.31212066000006
						],
						[
							-81.63261314699992,
							30.31207698600008
						],
						[
							-81.63027664099991,
							30.311174323000042
						],
						[
							-81.6291579999999,
							30.309778000000055
						],
						[
							-81.62872490599995,
							30.307716008000053
						],
						[
							-81.62843890599993,
							30.30630000900004
						],
						[
							-81.6284238689999,
							30.306160022000086
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "St. Nicholas",
				"RegionID": "269202"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.11873146599993,
					26.128023514000063,
					-80.10829819799994,
					26.138155442000084
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.10966282499993,
							26.12864768600008
						],
						[
							-80.1097047479999,
							26.128583773000063
						],
						[
							-80.10975207399991,
							26.12852375300008
						],
						[
							-80.1098044439999,
							26.128468078000083
						],
						[
							-80.10986146099992,
							26.12841717300006
						],
						[
							-80.10992269299993,
							26.12837142400008
						],
						[
							-80.10999992599994,
							26.128318660000048
						],
						[
							-80.11012824599993,
							26.128218384000036
						],
						[
							-80.11017715699995,
							26.12818274600005
						],
						[
							-80.1102420599999,
							26.128138721000084
						],
						[
							-80.11097331799994,
							26.128023514000063
						],
						[
							-80.11181659499994,
							26.128107841000087
						],
						[
							-80.11257554399992,
							26.128529480000054
						],
						[
							-80.11299718299995,
							26.12897922800005
						],
						[
							-80.11295683499992,
							26.129205178000063
						],
						[
							-80.11285663699994,
							26.129766286000063
						],
						[
							-80.11282852799992,
							26.130244143000084
						],
						[
							-80.1128847459999,
							26.13083443700009
						],
						[
							-80.11302529199992,
							26.131284185000084
						],
						[
							-80.11344693099994,
							26.131649605000064
						],
						[
							-80.11406533399992,
							26.132015025000044
						],
						[
							-80.11504915699993,
							26.132211789000053
						],
						[
							-80.1161735259999,
							26.132324226000037
						],
						[
							-80.11731106899992,
							26.13249075100009
						],
						[
							-80.11734208999992,
							26.13250568500007
						],
						[
							-80.11740166099992,
							26.13253716400004
						],
						[
							-80.11749689499993,
							26.132600549000074
						],
						[
							-80.11814289499995,
							26.133092549000082
						],
						[
							-80.11817607299992,
							26.13311907900004
						],
						[
							-80.11825806699994,
							26.133201073000066
						],
						[
							-80.11847848299995,
							26.133701579000046
						],
						[
							-80.11873146599993,
							26.134769730000073
						],
						[
							-80.1186471389999,
							26.136034645000052
						],
						[
							-80.11847848299995,
							26.137018468000065
						],
						[
							-80.11816928199994,
							26.13780552700007
						],
						[
							-80.11816177299994,
							26.137822690000064
						],
						[
							-80.11788299999995,
							26.137830000000065
						],
						[
							-80.11767016199991,
							26.137838507000083
						],
						[
							-80.11723616599994,
							26.137856101000068
						],
						[
							-80.1170050049999,
							26.137865400000067
						],
						[
							-80.1168899999999,
							26.137870000000078
						],
						[
							-80.11655362999994,
							26.137895149000087
						],
						[
							-80.11617948299994,
							26.137923123000064
						],
						[
							-80.1158177929999,
							26.137950066000087
						],
						[
							-80.11547037199995,
							26.137960385000042
						],
						[
							-80.11512295099993,
							26.137970704000054
						],
						[
							-80.11493499799991,
							26.137976287000072
						],
						[
							-80.11480999999992,
							26.137980000000084
						],
						[
							-80.11451572899995,
							26.13798900800009
						],
						[
							-80.11396591399995,
							26.138005839000073
						],
						[
							-80.11361894099991,
							26.138016461000063
						],
						[
							-80.11332846999996,
							26.138025353000046
						],
						[
							-80.11305422599992,
							26.138033748000055
						],
						[
							-80.11284999999992,
							26.13804000000005
						],
						[
							-80.1125043799999,
							26.138050018000058
						],
						[
							-80.11230195999991,
							26.138055885000085
						],
						[
							-80.1121599999999,
							26.138060000000053
						],
						[
							-80.11196887999995,
							26.138061470000082
						],
						[
							-80.11159255199993,
							26.138064365000048
						],
						[
							-80.11118728399993,
							26.138067482000054
						],
						[
							-80.11085999999995,
							26.138070000000084
						],
						[
							-80.11044917599992,
							26.138080271000035
						],
						[
							-80.11004424899994,
							26.138090394000074
						],
						[
							-80.10982732299993,
							26.138095817000078
						],
						[
							-80.1096599999999,
							26.138100000000065
						],
						[
							-80.10931927099995,
							26.138117252000086
						],
						[
							-80.1090024589999,
							26.138133293000067
						],
						[
							-80.1088718339999,
							26.13813963000007
						],
						[
							-80.10835546699991,
							26.138155442000084
						],
						[
							-80.10833104999995,
							26.13787465300004
						],
						[
							-80.10836390199997,
							26.137053348000055
						],
						[
							-80.10829819799994,
							26.136396304000073
						],
						[
							-80.10846245899995,
							26.135509295000077
						],
						[
							-80.10895524199992,
							26.13426091100007
						],
						[
							-80.10921805999993,
							26.13343960700007
						],
						[
							-80.1095794339999,
							26.13268400600009
						],
						[
							-80.10977654699991,
							26.132191223000063
						],
						[
							-80.10980939899991,
							26.13176414500009
						],
						[
							-80.10977654699991,
							26.13081143100004
						],
						[
							-80.10977654699991,
							26.12946449100008
						],
						[
							-80.10966282499993,
							26.12864768600008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Sunrise Intracoastal",
				"RegionID": "269203"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.0698995429999,
					26.675920000000076,
					-80.06276999999994,
					26.67930032000004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.06617537199992,
							26.679222997000068
						],
						[
							-80.06605999999994,
							26.679220000000043
						],
						[
							-80.06602579499992,
							26.679248504000043
						],
						[
							-80.06599084099992,
							26.679272290000085
						],
						[
							-80.06589688299994,
							26.67927890200008
						],
						[
							-80.06576165799993,
							26.679276551000044
						],
						[
							-80.06562629399991,
							26.67927419600005
						],
						[
							-80.06519666899995,
							26.679271252000035
						],
						[
							-80.06502957599993,
							26.679263819000084
						],
						[
							-80.06480999999991,
							26.67926000000006
						],
						[
							-80.0647194149999,
							26.679257574000076
						],
						[
							-80.0645840329999,
							26.679253947000063
						],
						[
							-80.06433734899991,
							26.67924681400007
						],
						[
							-80.06410655999991,
							26.67924035400006
						],
						[
							-80.06381216599993,
							26.679232115000048
						],
						[
							-80.06373262499994,
							26.67923114200005
						],
						[
							-80.06365935299993,
							26.679219784000054
						],
						[
							-80.06359298399991,
							26.679194387000052
						],
						[
							-80.0635499999999,
							26.67916000000008
						],
						[
							-80.06343027799994,
							26.67915910100004
						],
						[
							-80.0632870039999,
							26.67915307900006
						],
						[
							-80.0631041179999,
							26.679148353000073
						],
						[
							-80.06297358199993,
							26.679145090000077
						],
						[
							-80.06284946099993,
							26.679141987000037
						],
						[
							-80.06276999999994,
							26.679140000000075
						],
						[
							-80.06277375499991,
							26.678912110000056
						],
						[
							-80.06277471499993,
							26.678840618000038
						],
						[
							-80.06277859599993,
							26.678594143000055
						],
						[
							-80.06278348399991,
							26.678283779000083
						],
						[
							-80.06278999999995,
							26.67787000000004
						],
						[
							-80.0627835109999,
							26.677718863000052
						],
						[
							-80.06279492999994,
							26.67731295400006
						],
						[
							-80.06279999999992,
							26.676740000000052
						],
						[
							-80.06279999999992,
							26.67663675500006
						],
						[
							-80.06279999999992,
							26.676580000000058
						],
						[
							-80.06279999999992,
							26.67647761900008
						],
						[
							-80.06279999999992,
							26.67635000000007
						],
						[
							-80.06279547999992,
							26.67625484200005
						],
						[
							-80.06280554599994,
							26.676111510000055
						],
						[
							-80.06280163999992,
							26.676057035000042
						],
						[
							-80.0627975619999,
							26.67600017600006
						],
						[
							-80.0628099999999,
							26.675920000000076
						],
						[
							-80.06287513399991,
							26.675957220000043
						],
						[
							-80.0629428279999,
							26.675995902000068
						],
						[
							-80.06300854599993,
							26.676001239000072
						],
						[
							-80.06330298499995,
							26.676007471000048
						],
						[
							-80.06353396599991,
							26.676012359000083
						],
						[
							-80.06388390899991,
							26.676019765000035
						],
						[
							-80.06436127199993,
							26.67602986800006
						],
						[
							-80.06483999999995,
							26.676040000000057
						],
						[
							-80.06499836599994,
							26.676044988000058
						],
						[
							-80.06515684399994,
							26.676049979000084
						],
						[
							-80.06542735699992,
							26.676058499000078
						],
						[
							-80.06610999999992,
							26.67608000000007
						],
						[
							-80.0662150849999,
							26.676082765000046
						],
						[
							-80.06633456399993,
							26.67608591000004
						],
						[
							-80.06659716599995,
							26.676092820000065
						],
						[
							-80.06686999999994,
							26.676100000000076
						],
						[
							-80.06697120299992,
							26.676101406000043
						],
						[
							-80.06711428699992,
							26.676103393000062
						],
						[
							-80.06743260899992,
							26.67610781400009
						],
						[
							-80.0678543489999,
							26.67611372300007
						],
						[
							-80.06829999999991,
							26.676120000000083
						],
						[
							-80.06845906099994,
							26.67612521500007
						],
						[
							-80.06868982099991,
							26.676132781000035
						],
						[
							-80.06910339199995,
							26.67614634100005
						],
						[
							-80.06947748099992,
							26.676158606000058
						],
						[
							-80.06948004999992,
							26.67621994700005
						],
						[
							-80.06975990799992,
							26.67774001300006
						],
						[
							-80.0698995429999,
							26.67930032000004
						],
						[
							-80.06889665399991,
							26.67930032000004
						],
						[
							-80.06880103599991,
							26.679298023000058
						],
						[
							-80.0687135629999,
							26.67929567200008
						],
						[
							-80.06853067299994,
							26.67929126000007
						],
						[
							-80.06837163599994,
							26.67928728100009
						],
						[
							-80.06814841799991,
							26.679278968000062
						],
						[
							-80.06785403799995,
							26.67927026700005
						],
						[
							-80.06760759199994,
							26.679262983000058
						],
						[
							-80.06741655999991,
							26.67925733700008
						],
						[
							-80.06723347799993,
							26.679251925000074
						],
						[
							-80.06702654599991,
							26.679245809000065
						],
						[
							-80.06689934899993,
							26.679242050000084
						],
						[
							-80.06682999999992,
							26.67924000000005
						],
						[
							-80.06671648399993,
							26.679237052000076
						],
						[
							-80.06655724799992,
							26.679232916000046
						],
						[
							-80.0663902679999,
							26.67922857800005
						],
						[
							-80.06617537199992,
							26.679222997000068
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "West Palm Beach",
				"Name": "Vedado",
				"RegionID": "269217"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.30508934875834,
					28.498809999923786,
					-81.28534000018858,
					28.52046662587216
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-81.28535700007293,
								28.50598000038523
							],
							[
								-81.28546899983981,
								28.50598000038523
							],
							[
								-81.28554199960756,
								28.506213000333812
							],
							[
								-81.28534000018858,
								28.506213000333812
							],
							[
								-81.28535700007293,
								28.50598000038523
							]
						]
					],
					[
						[
							[
								-81.29112099957418,
								28.510454999823175
							],
							[
								-81.29025300003198,
								28.50824799971153
							],
							[
								-81.28943900028074,
								28.506204999965085
							],
							[
								-81.28598288953444,
								28.506206927212162
							],
							[
								-81.2858520004077,
								28.50620700005718
							],
							[
								-81.2856680000198,
								28.50589600011032
							],
							[
								-81.28561000004403,
								28.50552900028006
							],
							[
								-81.28556299967626,
								28.505215000194923
							],
							[
								-81.28579122062764,
								28.505215000194923
							],
							[
								-81.28593799987524,
								28.505215000194923
							],
							[
								-81.28600500026582,
								28.504878999994816
							],
							[
								-81.28571914806079,
								28.504878999994816
							],
							[
								-81.28559000002151,
								28.504878999994816
							],
							[
								-81.28559000002151,
								28.504784000112366
							],
							[
								-81.28571163602393,
								28.504784000112366
							],
							[
								-81.28677599983338,
								28.504784000112366
							],
							[
								-81.28865300002182,
								28.504784000112366
							],
							[
								-81.28935900019044,
								28.50478500015837
							],
							[
								-81.28935900019044,
								28.504347659855377
							],
							[
								-81.28935900019044,
								28.502998999668115
							],
							[
								-81.28935800014429,
								28.502500000048443
							],
							[
								-81.29305999992265,
								28.50250300018663
							],
							[
								-81.29338800065322,
								28.50250338059984
							],
							[
								-81.2956479996108,
								28.502506000324985
							],
							[
								-81.29565005636023,
								28.501945703815
							],
							[
								-81.29565599997952,
								28.500325999659047
							],
							[
								-81.29565700002561,
								28.499991000404663
							],
							[
								-81.29566077627888,
								28.4990711387595
							],
							[
								-81.29631895050191,
								28.499067826556455
							],
							[
								-81.296635391347,
								28.499063767916184
							],
							[
								-81.29732243830382,
								28.4990608163412
							],
							[
								-81.29737052055614,
								28.499060814542553
							],
							[
								-81.29736827404979,
								28.49881200001588
							],
							[
								-81.29739300000963,
								28.49881200001588
							],
							[
								-81.29797599990431,
								28.498819000338777
							],
							[
								-81.29797699995041,
								28.498919999598492
							],
							[
								-81.29860500012076,
								28.498919999598492
							],
							[
								-81.29860300002858,
								28.498819000338777
							],
							[
								-81.29939499966476,
								28.498809999923786
							],
							[
								-81.30329000024594,
								28.49881500015433
							],
							[
								-81.30451400001085,
								28.49883400013094
							],
							[
								-81.30451569253485,
								28.498987145679187
							],
							[
								-81.30455099991782,
								28.502180999732595
							],
							[
								-81.30507947658522,
								28.502167957832498
							],
							[
								-81.30508934875834,
								28.502483867370316
							],
							[
								-81.30198422243082,
								28.50249778321959
							],
							[
								-81.30198421883361,
								28.5097367778682
							],
							[
								-81.30311202441631,
								28.509783718880875
							],
							[
								-81.30424177163529,
								28.509643338309353
							],
							[
								-81.30489986042275,
								28.510535850672298
							],
							[
								-81.30372393121895,
								28.51161643645262
							],
							[
								-81.3020793266348,
								28.51250966287718
							],
							[
								-81.30208149669893,
								28.5172868471076
							],
							[
								-81.30208450223314,
								28.518121083403024
							],
							[
								-81.30209752081882,
								28.51908551454872
							],
							[
								-81.30209151154904,
								28.51961930534056
							],
							[
								-81.30209050970429,
								28.51973647890705
							],
							[
								-81.30208750596873,
								28.52039245248917
							],
							[
								-81.30208942871913,
								28.52046662587216
							],
							[
								-81.30123123628361,
								28.52012004874561
							],
							[
								-81.30100790494609,
								28.520056954110757
							],
							[
								-81.3007445133088,
								28.519980840890142
							],
							[
								-81.30049914948087,
								28.51989170908385
							],
							[
								-81.30043906038016,
								28.519866671958503
							],
							[
								-81.29879362122519,
								28.51924875678552
							],
							[
								-81.29868145508365,
								28.519206693695438
							],
							[
								-81.29830588381516,
								28.519063474863714
							],
							[
								-81.29808999976338,
								28.518979999792947
							],
							[
								-81.29811099983199,
								28.518841999726902
							],
							[
								-81.29705000038636,
								28.51846100015048
							],
							[
								-81.29671600027844,
								28.5183490003836
							],
							[
								-81.29650088964361,
								28.51827269830543
							],
							[
								-81.29599610558462,
								28.518093645087937
							],
							[
								-81.29437634207348,
								28.51751909792094
							],
							[
								-81.29421199277131,
								28.517460801169157
							],
							[
								-81.29418999985111,
								28.517452999550514
							],
							[
								-81.29403900008501,
								28.517342999875815
							],
							[
								-81.29404825860544,
								28.514143358685065
							],
							[
								-81.29404899964672,
								28.513886999746006
							],
							[
								-81.29400247771818,
								28.513856644929568
							],
							[
								-81.2939080003417,
								28.51379500000174
							],
							[
								-81.29361119889107,
								28.51358849947608
							],
							[
								-81.29348399968248,
								28.513499999893128
							],
							[
								-81.29322700042611,
								28.513314000312413
							],
							[
								-81.29296500004001,
								28.51312000036271
							],
							[
								-81.29280900004353,
								28.512998000135013
							],
							[
								-81.29245037649864,
								28.512662399234074
							],
							[
								-81.29240400026023,
								28.51261899975149
							],
							[
								-81.29240400026023,
								28.512522765999144
							],
							[
								-81.29240400026023,
								28.510903999836252
							],
							[
								-81.2921699004407,
								28.510822074297366
							],
							[
								-81.29112099957418,
								28.510454999823175
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Ventura",
				"RegionID": "269218"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.13772969899992,
					26.122421129000088,
					-80.11788345299993,
					26.137822690000064
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.11816928199994,
							26.13780552700007
						],
						[
							-80.11847848299995,
							26.137018468000065
						],
						[
							-80.1186471389999,
							26.136034645000052
						],
						[
							-80.11873146599993,
							26.134769730000073
						],
						[
							-80.11847848299995,
							26.133701579000046
						],
						[
							-80.11825806699994,
							26.133201073000066
						],
						[
							-80.11827584999992,
							26.13261393800008
						],
						[
							-80.11788345299993,
							26.13232345000006
						],
						[
							-80.11836499999993,
							26.131395000000055
						],
						[
							-80.11832099999992,
							26.131302000000062
						],
						[
							-80.12099199999994,
							26.13012000000009
						],
						[
							-80.12109994699995,
							26.130126777000044
						],
						[
							-80.12121499999995,
							26.130134000000055
						],
						[
							-80.12134047399991,
							26.130127720000075
						],
						[
							-80.1216587749999,
							26.12973381100005
						],
						[
							-80.12177908799993,
							26.129723080000076
						],
						[
							-80.12199850599991,
							26.12957484300006
						],
						[
							-80.12248509099993,
							26.12810155200009
						],
						[
							-80.12262839099992,
							26.127787096000077
						],
						[
							-80.12274547499993,
							26.126905778000037
						],
						[
							-80.12274145999993,
							26.12308412200008
						],
						[
							-80.1236839789999,
							26.12309227800006
						],
						[
							-80.1237894329999,
							26.122721811000076
						],
						[
							-80.1251030169999,
							26.122695540000052
						],
						[
							-80.12539464999992,
							26.122689707000063
						],
						[
							-80.12574174299994,
							26.122682765000036
						],
						[
							-80.12588399799995,
							26.122683650000056
						],
						[
							-80.12725816799991,
							26.122664488000055
						],
						[
							-80.12751054299991,
							26.12266048200007
						],
						[
							-80.12863220499992,
							26.12264946600004
						],
						[
							-80.12923409899992,
							26.122641455000064
						],
						[
							-80.13000524299993,
							26.122627433000048
						],
						[
							-80.13025661499995,
							26.122621424000044
						],
						[
							-80.13125609699995,
							26.122602396000048
						],
						[
							-80.13137126799995,
							26.122599446000038
						],
						[
							-80.13228562499995,
							26.122577359000047
						],
						[
							-80.13330112999995,
							26.122555327000047
						],
						[
							-80.13734512699995,
							26.122421129000088
						],
						[
							-80.13738017999992,
							26.12336352600005
						],
						[
							-80.13741222699991,
							26.124292903000082
						],
						[
							-80.1374382649999,
							26.12522428400007
						],
						[
							-80.13745729499993,
							26.126207743000066
						],
						[
							-80.13751938699994,
							26.12800541000007
						],
						[
							-80.1375163809999,
							26.12841902200006
						],
						[
							-80.13754943099991,
							26.129452555000057
						],
						[
							-80.13755543999991,
							26.12991924700009
						],
						[
							-80.1375624499999,
							26.130478076000088
						],
						[
							-80.1376185339999,
							26.131414465000095
						],
						[
							-80.13762854799995,
							26.131681861000065
						],
						[
							-80.13763355599991,
							26.13194625300008
						],
						[
							-80.1376816259999,
							26.13334833300007
						],
						[
							-80.1376816259999,
							26.13344046900005
						],
						[
							-80.1376816259999,
							26.13355864500005
						],
						[
							-80.13771567799995,
							26.13442492900009
						],
						[
							-80.1377216869999,
							26.134962728000065
						],
						[
							-80.13772969899992,
							26.135209091000036
						],
						[
							-80.13771968299994,
							26.13536232100006
						],
						[
							-80.1376816259999,
							26.13560668200006
						],
						[
							-80.13762654499993,
							26.13577593300005
						],
						[
							-80.1375784729999,
							26.13589410800006
						],
						[
							-80.13748533599995,
							26.13604633400007
						],
						[
							-80.1374002089999,
							26.13618153500005
						],
						[
							-80.13730707099995,
							26.136304718000076
						],
						[
							-80.13727201899991,
							26.136347782000087
						],
						[
							-80.13722094299993,
							26.13640186100008
						],
						[
							-80.13717387399993,
							26.13645794200005
						],
						[
							-80.13711078099993,
							26.13650501500007
						],
						[
							-80.13705469699994,
							26.136552085000066
						],
						[
							-80.13697357699994,
							26.13661217300006
						],
						[
							-80.13692350299993,
							26.136647225000047
						],
						[
							-80.13685740499994,
							26.136692293000067
						],
						[
							-80.13676226399991,
							26.136759391000055
						],
						[
							-80.13660603099993,
							26.136846521000052
						],
						[
							-80.13633981399994,
							26.136977624000053
						],
						[
							-80.13624749999991,
							26.137004755000078
						],
						[
							-80.1361042879999,
							26.137045816000068
						],
						[
							-80.13592502199992,
							26.13708487400004
						],
						[
							-80.13552743299994,
							26.137143962000042
						],
						[
							-80.13533815199992,
							26.137159986000086
						],
						[
							-80.13439274899991,
							26.13718001500007
						],
						[
							-80.13409130299993,
							26.137188027000036
						],
						[
							-80.1334373329999,
							26.13720505200007
						],
						[
							-80.13317093699993,
							26.13721206300005
						],
						[
							-80.13292056599994,
							26.137222078000036
						],
						[
							-80.13289352499993,
							26.137222078000036
						],
						[
							-80.13249994199992,
							26.137224081000056
						],
						[
							-80.13180591199995,
							26.13724110600009
						],
						[
							-80.13156856099994,
							26.137247115000037
						],
						[
							-80.1305901099999,
							26.137270150000063
						],
						[
							-80.12967975899994,
							26.13728917700007
						],
						[
							-80.12868027699994,
							26.137319222000087
						],
						[
							-80.12771584699993,
							26.13733224100008
						],
						[
							-80.12678546799992,
							26.137375306000084
						],
						[
							-80.12661821899991,
							26.137376306000082
						],
						[
							-80.12588312799994,
							26.137393332000048
						],
						[
							-80.12580200899993,
							26.13739834000006
						],
						[
							-80.1252501909999,
							26.137416366000082
						],
						[
							-80.12487964099995,
							26.13742838400009
						],
						[
							-80.12393123499993,
							26.137455424000052
						],
						[
							-80.1229938429999,
							26.137489474000063
						],
						[
							-80.12265534199992,
							26.13749648600009
						],
						[
							-80.12206617599992,
							26.137507458000073
						],
						[
							-80.1218892039999,
							26.13755156400009
						],
						[
							-80.12120619299992,
							26.13752452600005
						],
						[
							-80.12104896199992,
							26.13752452500006
						],
						[
							-80.12071946799995,
							26.137438399000075
						],
						[
							-80.12025978999992,
							26.137437397000042
						],
						[
							-80.12014261599995,
							26.137449416000038
						],
						[
							-80.1197800779999,
							26.137547561000076
						],
						[
							-80.11971598199995,
							26.13757159700009
						],
						[
							-80.11950867499992,
							26.13765171500006
						],
						[
							-80.1192683189999,
							26.13771981600007
						],
						[
							-80.1189678739999,
							26.137776901000052
						],
						[
							-80.11845499999993,
							26.137815000000046
						],
						[
							-80.11816177299994,
							26.137822690000064
						],
						[
							-80.11816928199994,
							26.13780552700007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Victoria Park",
				"RegionID": "269219"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.21461699999992,
					26.76574373400007,
					-80.19730789699992,
					26.81194000000005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.19790299999994,
							26.811555000000055
						],
						[
							-80.19738399999994,
							26.81153900000004
						],
						[
							-80.19738199999995,
							26.81158000000005
						],
						[
							-80.19738099999995,
							26.811622000000057
						],
						[
							-80.19730789699992,
							26.81162798600008
						],
						[
							-80.19739527199994,
							26.808387518000075
						],
						[
							-80.1974459299999,
							26.806508455000085
						],
						[
							-80.19854485799993,
							26.765743978000046
						],
						[
							-80.1993792689999,
							26.76574373400007
						],
						[
							-80.19936699999994,
							26.76634000000007
						],
						[
							-80.20112399999994,
							26.766334000000086
						],
						[
							-80.21461699999992,
							26.766384000000073
						],
						[
							-80.21459599999991,
							26.766732000000047
						],
						[
							-80.21454799999992,
							26.76756900000004
						],
						[
							-80.2144439999999,
							26.769452000000058
						],
						[
							-80.21433799999994,
							26.77133500000008
						],
						[
							-80.21423599999991,
							26.77321100000006
						],
						[
							-80.2141279999999,
							26.775101000000063
						],
						[
							-80.21402199999994,
							26.776984000000084
						],
						[
							-80.21391699999992,
							26.778867000000048
						],
						[
							-80.21381299999992,
							26.780743000000086
						],
						[
							-80.21380599999992,
							26.781608000000062
						],
						[
							-80.21393799999993,
							26.783750000000055
						],
						[
							-80.21364599999993,
							26.792080000000055
						],
						[
							-80.21301199999994,
							26.81018700000004
						],
						[
							-80.2131149999999,
							26.81194000000005
						],
						[
							-80.2129789999999,
							26.811937000000057
						],
						[
							-80.21085199999993,
							26.81188300000008
						],
						[
							-80.2089279999999,
							26.81183400000009
						],
						[
							-80.20525099999992,
							26.811740000000043
						],
						[
							-80.20063899999991,
							26.811637000000076
						],
						[
							-80.19790299999994,
							26.811555000000055
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "West Palm Beach",
				"Name": "Pineapple Park - Ibis",
				"RegionID": "275031"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.50871285762256,
					27.974016734323676,
					-82.48856099977675,
					28.00000499968472
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.5008850003989,
							27.999928999778618
						],
						[
							-82.49849909006186,
							27.999868434936587
						],
						[
							-82.49678800039874,
							27.999825000380547
						],
						[
							-82.49643866954837,
							27.999855232889225
						],
						[
							-82.49530899967108,
							27.999952999985688
						],
						[
							-82.49324015520804,
							27.999789791023787
						],
						[
							-82.49260900021604,
							27.99974000005963
						],
						[
							-82.49253400035613,
							27.999782000197044
						],
						[
							-82.49174700005092,
							27.99977399982832
						],
						[
							-82.48856099977675,
							27.99975299975953
						],
						[
							-82.48871191950306,
							27.992658819339887
						],
						[
							-82.4887534429998,
							27.990786593652164
						],
						[
							-82.48887988947585,
							27.985085304775247
						],
						[
							-82.48888181762229,
							27.98148181942993
						],
						[
							-82.4889302407176,
							27.974016734323676
						],
						[
							-82.5056909116729,
							27.974145448889793
						],
						[
							-82.5053545445495,
							27.99633636475359
						],
						[
							-82.50531106952398,
							27.999264903520018
						],
						[
							-82.50634548231264,
							27.999427227548985
						],
						[
							-82.50719997583676,
							27.999890989933036
						],
						[
							-82.50871285762256,
							27.999934479347772
						],
						[
							-82.50719699998012,
							27.999924999594256
						],
						[
							-82.50526600000047,
							28.00000499968472
						],
						[
							-82.50230100002106,
							27.999954000031778
						],
						[
							-82.50172354624534,
							27.99994380441791
						],
						[
							-82.5008850003989,
							27.999928999778618
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Plaza Terrace",
				"RegionID": "275049"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.14505055799992,
					26.08191540900009,
					-80.13595752899994,
					26.107655228000056
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.13662619099995,
							26.092722954000067
						],
						[
							-80.13648184999994,
							26.09271807600004
						],
						[
							-80.13636465199994,
							26.09272099900005
						],
						[
							-80.1362475219999,
							26.09278525600007
						],
						[
							-80.13595752899994,
							26.09279341200005
						],
						[
							-80.13596699999994,
							26.092765000000043
						],
						[
							-80.13636699999995,
							26.091565000000063
						],
						[
							-80.1367669999999,
							26.089665000000085
						],
						[
							-80.1367669999999,
							26.089065000000062
						],
						[
							-80.13686699999994,
							26.08726500000006
						],
						[
							-80.1368609999999,
							26.08716100000004
						],
						[
							-80.13680999999991,
							26.086190000000045
						],
						[
							-80.13677399999995,
							26.08527900000007
						],
						[
							-80.1367704999999,
							26.085281500000065
						],
						[
							-80.1367669999999,
							26.085284000000062
						],
						[
							-80.1367669999999,
							26.08446500000008
						],
						[
							-80.1367669999999,
							26.083665000000053
						],
						[
							-80.13666699999993,
							26.081965000000082
						],
						[
							-80.13820707199994,
							26.08191540900009
						],
						[
							-80.1382284789999,
							26.08193605000008
						],
						[
							-80.1382844179999,
							26.08202336700009
						],
						[
							-80.13878426399992,
							26.08212341600006
						],
						[
							-80.13963953299992,
							26.082041152000045
						],
						[
							-80.14201797599992,
							26.092768195000076
						],
						[
							-80.14220633799994,
							26.093660473000057
						],
						[
							-80.14228244999993,
							26.094057062000047
						],
						[
							-80.14241364399993,
							26.09459686200006
						],
						[
							-80.14256987599992,
							26.09550420900007
						],
						[
							-80.14265099799992,
							26.09621826700004
						],
						[
							-80.14270407599992,
							26.096439596000042
						],
						[
							-80.14361142099995,
							26.10026326700006
						],
						[
							-80.1442193229999,
							26.103019353000036
						],
						[
							-80.14505055799992,
							26.107473051000056
						],
						[
							-80.14488330699993,
							26.107490986000073
						],
						[
							-80.1446379439999,
							26.107513017000088
						],
						[
							-80.14399599099995,
							26.107529041000078
						],
						[
							-80.14300449599995,
							26.10754601300005
						],
						[
							-80.13697858499995,
							26.107655228000056
						],
						[
							-80.13684438599995,
							26.104880114000082
						],
						[
							-80.1368664179999,
							26.100193163000085
						],
						[
							-80.13674623999992,
							26.09659182100006
						],
						[
							-80.13663006799995,
							26.09284726700008
						],
						[
							-80.13662619099995,
							26.092722954000067
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Poinciana Park",
				"RegionID": "275063"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.36061591899994,
					29.661246181000028,
					-82.35575469799994,
					29.666738328000065
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.35592599199998,
							29.663095498000075
						],
						[
							-82.35787734799999,
							29.66247823300006
						],
						[
							-82.35777778899995,
							29.661960526000033
						],
						[
							-82.36061591899994,
							29.661246181000028
						],
						[
							-82.36057821799994,
							29.663218422000057
						],
						[
							-82.35998799799995,
							29.663174826000045
						],
						[
							-82.35998799799995,
							29.66508667800002
						],
						[
							-82.36057354599997,
							29.66512608500005
						],
						[
							-82.36055717999994,
							29.666738328000065
						],
						[
							-82.35575469799994,
							29.666738328000065
						],
						[
							-82.35592599199998,
							29.663095498000075
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Alachua",
				"City": "Gainesville",
				"Name": "Raintree",
				"RegionID": "275124"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.24424158329737,
					28.427712729928018,
					-81.23066214890744,
					28.450561999879326
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.23094400002873,
							28.430288999758908
						],
						[
							-81.23066214890744,
							28.427712729928018
						],
						[
							-81.2309179583607,
							28.427713003321863
						],
						[
							-81.2334897819435,
							28.428015401253532
						],
						[
							-81.23591036114468,
							28.42862135094707
						],
						[
							-81.2396919698084,
							28.43028481791142
						],
						[
							-81.24402444828864,
							28.432850556681394
						],
						[
							-81.24407140998566,
							28.436633232840364
						],
						[
							-81.24424158329737,
							28.450552991370543
						],
						[
							-81.2435069999767,
							28.450561999879326
						],
						[
							-81.24113999968405,
							28.44942100034305
						],
						[
							-81.23957200024975,
							28.44866399962219
						],
						[
							-81.23831699995505,
							28.44805899961281
						],
						[
							-81.23658099997111,
							28.44725300023046
						],
						[
							-81.23247699964841,
							28.44526600036742
						],
						[
							-81.23229300015979,
							28.44517699986214
						],
						[
							-81.23214599967885,
							28.44395100000495
						],
						[
							-81.23188900042257,
							28.441881999959257
						],
						[
							-81.23178900030949,
							28.439981999610026
						],
						[
							-81.23173499961891,
							28.439922000441463
						],
						[
							-81.2315259998773,
							28.43737900012971
						],
						[
							-81.23109799993311,
							28.43216599994725
						],
						[
							-81.23094400002873,
							28.430288999758908
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Randal Park",
				"RegionID": "275133"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.6082409789999,
					30.269963985000064,
					-81.57810792499993,
					30.29254800500007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.58605290499992,
							30.289426009000067
						],
						[
							-81.58597589699991,
							30.28941692500007
						],
						[
							-81.58586591699992,
							30.289457092000077
						],
						[
							-81.58583675499995,
							30.28945411500007
						],
						[
							-81.58584790599991,
							30.28940200800008
						],
						[
							-81.58585905699994,
							30.289350901000034
						],
						[
							-81.58568990599991,
							30.28933200800009
						],
						[
							-81.5854229059999,
							30.289291009000067
						],
						[
							-81.58458779499995,
							30.28918686200007
						],
						[
							-81.5845740179999,
							30.289335154000067
						],
						[
							-81.58427590499991,
							30.289300008000055
						],
						[
							-81.58399290499995,
							30.28927100600004
						],
						[
							-81.58371390599991,
							30.289155011000048
						],
						[
							-81.5835169049999,
							30.289132009000067
						],
						[
							-81.58335090599991,
							30.289112009000064
						],
						[
							-81.58319690499991,
							30.289095008000064
						],
						[
							-81.58314290499993,
							30.28908900800008
						],
						[
							-81.58307590599992,
							30.289082007000047
						],
						[
							-81.58302290599994,
							30.289068008000072
						],
						[
							-81.58291790699991,
							30.289053009000042
						],
						[
							-81.58286290599995,
							30.289049008000067
						],
						[
							-81.58184790599995,
							30.288923009000086
						],
						[
							-81.5817398829999,
							30.288918877000075
						],
						[
							-81.58166990599995,
							30.288948008000094
						],
						[
							-81.58155892899993,
							30.289002092000093
						],
						[
							-81.5814259039999,
							30.289012007000057
						],
						[
							-81.5793669059999,
							30.288717008000052
						],
						[
							-81.57841290599993,
							30.288601008000057
						],
						[
							-81.57810792499993,
							30.288563103000058
						],
						[
							-81.5781719069999,
							30.288389011000053
						],
						[
							-81.57823390699991,
							30.288179010000075
						],
						[
							-81.5783489069999,
							30.287885010000085
						],
						[
							-81.5790709069999,
							30.286135010000066
						],
						[
							-81.57911696499991,
							30.285980019000082
						],
						[
							-81.57936890699995,
							30.28530200800009
						],
						[
							-81.5794169049999,
							30.285216009000067
						],
						[
							-81.57956690499992,
							30.284994011000038
						],
						[
							-81.57978090499995,
							30.284781009000085
						],
						[
							-81.58037590499993,
							30.284235008000053
						],
						[
							-81.5804499059999,
							30.284148008000045
						],
						[
							-81.58057890499992,
							30.284023009000062
						],
						[
							-81.58067590699994,
							30.28392100800005
						],
						[
							-81.58082090399995,
							30.283807009000043
						],
						[
							-81.58095390599993,
							30.283686008000075
						],
						[
							-81.58124990499994,
							30.283417009000058
						],
						[
							-81.58167690599993,
							30.283006009000076
						],
						[
							-81.58222690499991,
							30.28249700800006
						],
						[
							-81.58332390599992,
							30.281442008000056
						],
						[
							-81.58383090599995,
							30.280981009000072
						],
						[
							-81.58483690499992,
							30.28002200900005
						],
						[
							-81.58595390499994,
							30.27894900900009
						],
						[
							-81.58654490599992,
							30.278390008000088
						],
						[
							-81.5869549059999,
							30.278008008000086
						],
						[
							-81.58755890599993,
							30.277431009000054
						],
						[
							-81.5877469049999,
							30.27725700900004
						],
						[
							-81.58829290499995,
							30.276740008000047
						],
						[
							-81.58883690599993,
							30.276229008000087
						],
						[
							-81.58933990599992,
							30.275745008000055
						],
						[
							-81.58961490599995,
							30.275490008000077
						],
						[
							-81.5900169059999,
							30.275089008000062
						],
						[
							-81.59074190599995,
							30.274418008000058
						],
						[
							-81.59086490499993,
							30.27427400800008
						],
						[
							-81.59093903099995,
							30.274149054000073
						],
						[
							-81.5909619059999,
							30.27396900800005
						],
						[
							-81.59101190599995,
							30.273567009000086
						],
						[
							-81.59106390499994,
							30.27322700800005
						],
						[
							-81.59143890599995,
							30.27107300900008
						],
						[
							-81.59160485699994,
							30.269963985000064
						],
						[
							-81.59449290799995,
							30.270049010000037
						],
						[
							-81.59512090699991,
							30.270073010000093
						],
						[
							-81.59568590799995,
							30.270094011000086
						],
						[
							-81.59627290799995,
							30.270116011000084
						],
						[
							-81.5966949079999,
							30.270131010000053
						],
						[
							-81.59778990799992,
							30.27016501000009
						],
						[
							-81.59873190699994,
							30.270199010000056
						],
						[
							-81.59980990699995,
							30.270233011000073
						],
						[
							-81.60032890699995,
							30.270253011000076
						],
						[
							-81.60043690799995,
							30.270257010000083
						],
						[
							-81.60051990799991,
							30.270260010000076
						],
						[
							-81.60080890799992,
							30.270270011000036
						],
						[
							-81.60104390799995,
							30.27028001000008
						],
						[
							-81.60130490699993,
							30.270291011000044
						],
						[
							-81.60224790699993,
							30.270327010000074
						],
						[
							-81.6031639069999,
							30.27035601000006
						],
						[
							-81.60353090799993,
							30.270368011000073
						],
						[
							-81.60408690799994,
							30.27039401100006
						],
						[
							-81.60443790799991,
							30.27040601000005
						],
						[
							-81.60499690699993,
							30.27042801100004
						],
						[
							-81.60541990799993,
							30.27044901100004
						],
						[
							-81.60568690799994,
							30.270459010000078
						],
						[
							-81.6059289079999,
							30.270499011000084
						],
						[
							-81.6062479069999,
							30.270598010000068
						],
						[
							-81.60641390799992,
							30.27067301100004
						],
						[
							-81.60656590799994,
							30.270755010000073
						],
						[
							-81.60673790699991,
							30.27085901100008
						],
						[
							-81.60686790699992,
							30.270963010000063
						],
						[
							-81.60698190699992,
							30.271073011000055
						],
						[
							-81.6071259069999,
							30.27124701100007
						],
						[
							-81.6077269079999,
							30.272069010000052
						],
						[
							-81.60790590699992,
							30.27231301000006
						],
						[
							-81.6082409789999,
							30.27277106500009
						],
						[
							-81.60781590599993,
							30.27319400900006
						],
						[
							-81.60743190499994,
							30.27351200800007
						],
						[
							-81.60677790599993,
							30.274076008000065
						],
						[
							-81.60644090499994,
							30.274361008000085
						],
						[
							-81.6059859049999,
							30.27475800900004
						],
						[
							-81.60553590599994,
							30.275144009000087
						],
						[
							-81.60330990499995,
							30.27705100800006
						],
						[
							-81.60322590699991,
							30.277129008000088
						],
						[
							-81.60308190599994,
							30.277315009000066
						],
						[
							-81.60301390599994,
							30.277419009000084
						],
						[
							-81.60293790599991,
							30.277562009000064
						],
						[
							-81.60284690799995,
							30.27779300700007
						],
						[
							-81.60281690699993,
							30.278058008000073
						],
						[
							-81.60281990599992,
							30.27818300800004
						],
						[
							-81.60274090599995,
							30.28018500800005
						],
						[
							-81.60270690599992,
							30.281024009000074
						],
						[
							-81.60271490499993,
							30.281745009000076
						],
						[
							-81.60271790599995,
							30.281975008000078
						],
						[
							-81.60275190499993,
							30.28300100900009
						],
						[
							-81.60274390599996,
							30.283355008000058
						],
						[
							-81.60274790499994,
							30.28385600800004
						],
						[
							-81.60273390499992,
							30.284025009000057
						],
						[
							-81.60272790599993,
							30.284214008000053
						],
						[
							-81.6026319049999,
							30.285182009000042
						],
						[
							-81.60254890499994,
							30.286052008000073
						],
						[
							-81.60252390599993,
							30.28635400900004
						],
						[
							-81.60240490599995,
							30.287638008000048
						],
						[
							-81.60238790499996,
							30.288005008000084
						],
						[
							-81.60234290499994,
							30.28833100900005
						],
						[
							-81.60227590599993,
							30.289068008000072
						],
						[
							-81.60220990599993,
							30.28975300800005
						],
						[
							-81.60218290499995,
							30.29008300800007
						],
						[
							-81.60209290599994,
							30.29104000800004
						],
						[
							-81.60195790799992,
							30.29254800500007
						],
						[
							-81.60128690499994,
							30.292342008000045
						],
						[
							-81.6007329059999,
							30.292179009000048
						],
						[
							-81.6003109049999,
							30.29204800900004
						],
						[
							-81.59966290599993,
							30.291855008000088
						],
						[
							-81.59829690599992,
							30.291449008000082
						],
						[
							-81.59754890599993,
							30.291231008000068
						],
						[
							-81.59627490499992,
							30.290861008000036
						],
						[
							-81.59600290499992,
							30.29079500800009
						],
						[
							-81.5957179049999,
							30.290733009000064
						],
						[
							-81.59480990599991,
							30.29054500800004
						],
						[
							-81.59412390499995,
							30.29044000900007
						],
						[
							-81.59387990699992,
							30.29039700800007
						],
						[
							-81.59349790599993,
							30.290350008000075
						],
						[
							-81.59279390499995,
							30.290254009000076
						],
						[
							-81.59243790599993,
							30.29021900800007
						],
						[
							-81.59167890499992,
							30.290123008000084
						],
						[
							-81.59114191399993,
							30.29005391800007
						],
						[
							-81.59011590599994,
							30.289923008000073
						],
						[
							-81.59000190599994,
							30.289908008000054
						],
						[
							-81.5886259049999,
							30.28974500800007
						],
						[
							-81.58798290499993,
							30.28966500900009
						],
						[
							-81.58755290499994,
							30.289612008000066
						],
						[
							-81.58722390499992,
							30.289567009000052
						],
						[
							-81.58605290499992,
							30.289426009000067
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Sans Souci",
				"RegionID": "275299"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.11088099999995,
					26.70675703900008,
					-80.08955516799995,
					26.759189407000065
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.1087803179999,
							26.759189407000065
						],
						[
							-80.0942003429999,
							26.759151430000088
						],
						[
							-80.0920564299999,
							26.75915150700007
						],
						[
							-80.09205433099993,
							26.758950960000053
						],
						[
							-80.09218231099993,
							26.758956585000078
						],
						[
							-80.0922599999999,
							26.75896000000006
						],
						[
							-80.09294291999993,
							26.758988471000066
						],
						[
							-80.0933659399999,
							26.759014265000076
						],
						[
							-80.09364148199995,
							26.759027562000085
						],
						[
							-80.09471230699995,
							26.758019051000076
						],
						[
							-80.09571999999991,
							26.75707000000006
						],
						[
							-80.09589698799994,
							26.756873012000085
						],
						[
							-80.09611590899993,
							26.756654091000087
						],
						[
							-80.09625999999992,
							26.75651000000005
						],
						[
							-80.09654827499992,
							26.756226782000056
						],
						[
							-80.0968299999999,
							26.75595000000004
						],
						[
							-80.09712632599991,
							26.755653674000087
						],
						[
							-80.09740999999991,
							26.755370000000084
						],
						[
							-80.09769135699992,
							26.75508361800007
						],
						[
							-80.09787328399995,
							26.754898444000048
						],
						[
							-80.09796999999992,
							26.754800000000046
						],
						[
							-80.09808340399992,
							26.75469714500008
						],
						[
							-80.09818124599991,
							26.754608405000056
						],
						[
							-80.09825390299994,
							26.754542507000053
						],
						[
							-80.09836377499994,
							26.754442855000036
						],
						[
							-80.09817229899994,
							26.750134613000057
						],
						[
							-80.09816517799993,
							26.749832986000058
						],
						[
							-80.09196716799994,
							26.74958306600007
						],
						[
							-80.09207305599995,
							26.737346373000037
						],
						[
							-80.09210381499992,
							26.733789078000086
						],
						[
							-80.09218023099993,
							26.72496084900007
						],
						[
							-80.08955516799995,
							26.719442100000037
						],
						[
							-80.09595128399991,
							26.71184674300008
						],
						[
							-80.10128128699995,
							26.70696074500006
						],
						[
							-80.10150350299995,
							26.70675703900008
						],
						[
							-80.10246299999994,
							26.706777000000045
						],
						[
							-80.1030629999999,
							26.70679000000007
						],
						[
							-80.10435799999993,
							26.706817000000058
						],
						[
							-80.1043249999999,
							26.707691000000068
						],
						[
							-80.10386299999993,
							26.707692000000065
						],
						[
							-80.1038069999999,
							26.709126000000083
						],
						[
							-80.10426999999993,
							26.709145000000035
						],
						[
							-80.1042359999999,
							26.710297000000082
						],
						[
							-80.10451599999993,
							26.710307000000057
						],
						[
							-80.10446099999992,
							26.710958000000062
						],
						[
							-80.10612299999991,
							26.710935000000063
						],
						[
							-80.10606499999994,
							26.710342000000082
						],
						[
							-80.10631099999995,
							26.71034700000007
						],
						[
							-80.10667699999993,
							26.71038400000009
						],
						[
							-80.10681299999993,
							26.712728000000084
						],
						[
							-80.10734892399995,
							26.712716046000082
						],
						[
							-80.10737161799995,
							26.71271554000009
						],
						[
							-80.10842699999995,
							26.71269200000006
						],
						[
							-80.11088099999995,
							26.71261700000008
						],
						[
							-80.11087299999991,
							26.71284600000007
						],
						[
							-80.11086599999993,
							26.71303200000006
						],
						[
							-80.11086299999994,
							26.713130000000035
						],
						[
							-80.1108569999999,
							26.713301000000058
						],
						[
							-80.11082999999991,
							26.71408600000007
						],
						[
							-80.11081941399993,
							26.714386520000062
						],
						[
							-80.11078099999992,
							26.715477000000078
						],
						[
							-80.11073799999993,
							26.71667400000007
						],
						[
							-80.11072599999994,
							26.717028000000084
						],
						[
							-80.1107209999999,
							26.717175000000054
						],
						[
							-80.11071699999991,
							26.71727800000008
						],
						[
							-80.11070399999994,
							26.717650000000052
						],
						[
							-80.11030699999992,
							26.717658000000085
						],
						[
							-80.11030699999992,
							26.71777300000008
						],
						[
							-80.10686699999991,
							26.717775000000074
						],
						[
							-80.10686099999992,
							26.718023000000077
						],
						[
							-80.1067799999999,
							26.72037800000004
						],
						[
							-80.1091439999999,
							26.720394000000056
						],
						[
							-80.1097509999999,
							26.72041900000005
						],
						[
							-80.10975499999995,
							26.720631000000083
						],
						[
							-80.10975499999995,
							26.720794917000035
						],
						[
							-80.10975499999995,
							26.720926000000077
						],
						[
							-80.10975599999996,
							26.721215000000086
						],
						[
							-80.1078369999999,
							26.721163000000047
						],
						[
							-80.10755099999996,
							26.721161000000052
						],
						[
							-80.10710199999994,
							26.721174000000076
						],
						[
							-80.10674699999993,
							26.721197000000075
						],
						[
							-80.10643899999991,
							26.72122200000007
						],
						[
							-80.10564599999992,
							26.721219000000076
						],
						[
							-80.10463299999992,
							26.721190000000036
						],
						[
							-80.10289499999993,
							26.721140000000048
						],
						[
							-80.10238099999992,
							26.721125000000086
						],
						[
							-80.10228899999993,
							26.722806000000052
						],
						[
							-80.10230399999995,
							26.72284700000006
						],
						[
							-80.10232999999994,
							26.72288300000008
						],
						[
							-80.1023649999999,
							26.722912000000065
						],
						[
							-80.10240699999991,
							26.72293200000007
						],
						[
							-80.1024569999999,
							26.722943000000043
						],
						[
							-80.10219646599997,
							26.72293141000006
						],
						[
							-80.1019399999999,
							26.722920000000045
						],
						[
							-80.1019275999999,
							26.723143192000066
						],
						[
							-80.1019094429999,
							26.723520179000047
						],
						[
							-80.10188842299993,
							26.72399837800009
						],
						[
							-80.10186818099993,
							26.724351527000067
						],
						[
							-80.1018499999999,
							26.724600000000066
						],
						[
							-80.1018297899999,
							26.724829051000086
						],
						[
							-80.10177920299992,
							26.725270183000077
						],
						[
							-80.10171543099995,
							26.72557827500009
						],
						[
							-80.10165783899993,
							26.725808646000075
						],
						[
							-80.10159729599991,
							26.72598047000008
						],
						[
							-80.1015333339999,
							26.726161999000055
						],
						[
							-80.10140253299994,
							26.726460226000086
						],
						[
							-80.10125905299992,
							26.726794374000065
						],
						[
							-80.10110881599991,
							26.727085386000056
						],
						[
							-80.1010059219999,
							26.72724487700009
						],
						[
							-80.10092999999995,
							26.727350000000058
						],
						[
							-80.10075436199992,
							26.727566170000046
						],
						[
							-80.10061942699993,
							26.727726894000057
						],
						[
							-80.10052425499993,
							26.72783396400007
						],
						[
							-80.10044358199991,
							26.72792472100008
						],
						[
							-80.10028268199994,
							26.728074508000077
						],
						[
							-80.10000963599992,
							26.72832194200004
						],
						[
							-80.0998899999999,
							26.728430000000063
						],
						[
							-80.10002999999995,
							26.728600000000085
						],
						[
							-80.10029941499994,
							26.72888167900004
						],
						[
							-80.10055791299993,
							26.72914409300006
						],
						[
							-80.10079558099994,
							26.729385363000063
						],
						[
							-80.10089972899993,
							26.72948972900008
						],
						[
							-80.10100999999992,
							26.72960000000006
						],
						[
							-80.10121985299992,
							26.729815234000057
						],
						[
							-80.10139478099991,
							26.72999464700007
						],
						[
							-80.1016319229999,
							26.730198713000053
						],
						[
							-80.10180010099992,
							26.73032161200007
						],
						[
							-80.10196436299992,
							26.730431916000043
						],
						[
							-80.10206337799991,
							26.73051337800007
						],
						[
							-80.1021520079999,
							26.730589301000066
						],
						[
							-80.10224999999991,
							26.73067000000009
						],
						[
							-80.10239400699993,
							26.73078643100007
						],
						[
							-80.10254329399993,
							26.730907131000038
						],
						[
							-80.10272818199991,
							26.731055455000046
						],
						[
							-80.10286206099994,
							26.731152061000046
						],
						[
							-80.10298704899992,
							26.731277049000084
						],
						[
							-80.10312453599994,
							26.73134544900006
						],
						[
							-80.10340441499994,
							26.731519621000075
						],
						[
							-80.1035990929999,
							26.73164511500005
						],
						[
							-80.10390766899991,
							26.73181868900008
						],
						[
							-80.1040413959999,
							26.731885698000042
						],
						[
							-80.10420999999991,
							26.73197000000005
						],
						[
							-80.1043968219999,
							26.732047842000043
						],
						[
							-80.10472492399994,
							26.732164979000064
						],
						[
							-80.1051249599999,
							26.732268742000088
						],
						[
							-80.10551524499994,
							26.732341287000054
						],
						[
							-80.10589277999992,
							26.732401752000044
						],
						[
							-80.10614128599991,
							26.732420868000077
						],
						[
							-80.1062599999999,
							26.73243000000008
						],
						[
							-80.10660014199993,
							26.732450000000085
						],
						[
							-80.10691261299992,
							26.732450000000085
						],
						[
							-80.10728745799992,
							26.732412373000045
						],
						[
							-80.10753552099993,
							26.732378237000034
						],
						[
							-80.10772223299995,
							26.73235193900007
						],
						[
							-80.10795267499992,
							26.732319482000037
						],
						[
							-80.10828768099992,
							26.732301735000082
						],
						[
							-80.10880805699992,
							26.732316189000073
						],
						[
							-80.1091631459999,
							26.732327286000043
						],
						[
							-80.10964174399993,
							26.73234166800006
						],
						[
							-80.1098915849999,
							26.732347479000055
						],
						[
							-80.1100625759999,
							26.732355126000073
						],
						[
							-80.11005899999992,
							26.73243300000007
						],
						[
							-80.10989399999994,
							26.735986000000082
						],
						[
							-80.10966299999991,
							26.74104600000004
						],
						[
							-80.10950899999995,
							26.744395000000054
						],
						[
							-80.1094579999999,
							26.745512000000076
						],
						[
							-80.10940999999991,
							26.74636600000008
						],
						[
							-80.1093929999999,
							26.746776000000068
						],
						[
							-80.1094991299999,
							26.74677593000007
						],
						[
							-80.10928305599992,
							26.750507403000086
						],
						[
							-80.1087803179999,
							26.759189407000065
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "West Palm Beach",
				"Name": "Villages of Palm Beach Lakes",
				"RegionID": "269220"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.27626399999991,
					28.45096600000005,
					-81.24091765399993,
					28.49467500000009
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.24270299999995,
							28.49454300000008
						],
						[
							-81.24268999999993,
							28.492972000000066
						],
						[
							-81.24227399999995,
							28.492972000000066
						],
						[
							-81.24222299999991,
							28.491636000000085
						],
						[
							-81.24226099999993,
							28.49151900000004
						],
						[
							-81.24248199999994,
							28.491313000000048
						],
						[
							-81.24246899999991,
							28.49119900000005
						],
						[
							-81.2425859999999,
							28.49119900000005
						],
						[
							-81.24254596599991,
							28.489624020000065
						],
						[
							-81.2425379789999,
							28.48930981700005
						],
						[
							-81.2424949999999,
							28.487619000000052
						],
						[
							-81.24248199999994,
							28.48742400000009
						],
						[
							-81.24186999999995,
							28.48656600000004
						],
						[
							-81.24163599999991,
							28.48656600000004
						],
						[
							-81.24157467599991,
							28.48544036800007
						],
						[
							-81.24118299999992,
							28.478251000000057
						],
						[
							-81.24114099999991,
							28.477479000000073
						],
						[
							-81.24091765399993,
							28.47337466600004
						],
						[
							-81.2603988109999,
							28.473601194000082
						],
						[
							-81.26055356499995,
							28.450971000000038
						],
						[
							-81.26108799999992,
							28.450971000000038
						],
						[
							-81.26116499999995,
							28.45096600000005
						],
						[
							-81.26133599999991,
							28.451215000000047
						],
						[
							-81.26687699999991,
							28.459552000000087
						],
						[
							-81.27134299999994,
							28.45953200000008
						],
						[
							-81.2726229999999,
							28.461139000000063
						],
						[
							-81.2727799999999,
							28.461359000000073
						],
						[
							-81.27284999999995,
							28.46151700000007
						],
						[
							-81.27433499999995,
							28.463797000000056
						],
						[
							-81.2749379999999,
							28.464699000000053
						],
						[
							-81.2752779999999,
							28.46527000000009
						],
						[
							-81.27553299999994,
							28.465673000000038
						],
						[
							-81.27561999999995,
							28.465768000000082
						],
						[
							-81.2756399999999,
							28.46584000000007
						],
						[
							-81.27573099999995,
							28.465982000000054
						],
						[
							-81.27578199999994,
							28.46606200000008
						],
						[
							-81.27582599999994,
							28.466117000000054
						],
						[
							-81.27588299999991,
							28.466198000000077
						],
						[
							-81.27626399999991,
							28.466774000000044
						],
						[
							-81.27304399999991,
							28.466653000000065
						],
						[
							-81.27304238199991,
							28.466993132000084
						],
						[
							-81.27297926299991,
							28.480264728000066
						],
						[
							-81.2729789999999,
							28.480320000000063
						],
						[
							-81.26858399999992,
							28.480309000000094
						],
						[
							-81.26693599999993,
							28.48030700000004
						],
						[
							-81.26641999999993,
							28.480279000000053
						],
						[
							-81.26409099999995,
							28.480288000000087
						],
						[
							-81.26197899999994,
							28.48029500000007
						],
						[
							-81.26067899999993,
							28.480333000000087
						],
						[
							-81.26068299999991,
							28.48073200000005
						],
						[
							-81.26068399999991,
							28.480792000000065
						],
						[
							-81.26068399999991,
							28.48085378400009
						],
						[
							-81.26068399999991,
							28.483498487000077
						],
						[
							-81.26068399999991,
							28.484695000000045
						],
						[
							-81.26068399999991,
							28.487621000000047
						],
						[
							-81.25842699999994,
							28.487640000000056
						],
						[
							-81.25842629099992,
							28.488015160000092
						],
						[
							-81.25842499999995,
							28.488698000000056
						],
						[
							-81.25842499999995,
							28.49094900000006
						],
						[
							-81.26069799999993,
							28.490960000000086
						],
						[
							-81.26069299999995,
							28.49140900000009
						],
						[
							-81.26069099999995,
							28.49157900000006
						],
						[
							-81.26067408699993,
							28.49213971100005
						],
						[
							-81.2606449999999,
							28.493104000000073
						],
						[
							-81.26065299999993,
							28.494318000000078
						],
						[
							-81.26065499999993,
							28.49467500000009
						],
						[
							-81.2603969999999,
							28.494673000000034
						],
						[
							-81.25972399999995,
							28.494660000000067
						],
						[
							-81.25460099999992,
							28.494625000000042
						],
						[
							-81.25361399999991,
							28.49461800000006
						],
						[
							-81.24778899999991,
							28.49458000000004
						],
						[
							-81.24692699999991,
							28.494574000000057
						],
						[
							-81.24572799999993,
							28.49456500000008
						],
						[
							-81.24441699999994,
							28.494556000000046
						],
						[
							-81.24344726699991,
							28.49454864500007
						],
						[
							-81.24270299999995,
							28.49454300000008
						]
					],
					[
						[
							-81.26437795499993,
							28.46066995800004
						],
						[
							-81.2636969159999,
							28.46062372600005
						],
						[
							-81.26303662599992,
							28.46067578800006
						],
						[
							-81.2630245069999,
							28.460678767000047
						],
						[
							-81.26268147699994,
							28.460848561000034
						],
						[
							-81.26274103399993,
							28.460899272000063
						],
						[
							-81.2627509639999,
							28.460907854000087
						],
						[
							-81.2627939169999,
							28.460948083000062
						],
						[
							-81.26283414599993,
							28.460991036000053
						],
						[
							-81.26287147999994,
							28.46103652700009
						],
						[
							-81.26290575899992,
							28.461084363000055
						],
						[
							-81.26293501799995,
							28.461131205000076
						],
						[
							-81.26301601799992,
							28.461270205000062
						],
						[
							-81.2630178359999,
							28.46127333900006
						],
						[
							-81.26304557799995,
							28.461325240000065
						],
						[
							-81.26306986499992,
							28.46137884400008
						],
						[
							-81.2630852179999,
							28.461418542000047
						],
						[
							-81.26313588399995,
							28.46155936400004
						],
						[
							-81.26337519499992,
							28.46204346500008
						],
						[
							-81.26337557699992,
							28.46204424000007
						],
						[
							-81.26339986499994,
							28.462097844000088
						],
						[
							-81.2634205949999,
							28.462152922000087
						],
						[
							-81.26343767799995,
							28.46220923800007
						],
						[
							-81.2634503029999,
							28.46226287500008
						],
						[
							-81.2635003019999,
							28.462508876000072
						],
						[
							-81.26350104099993,
							28.46251255100009
						],
						[
							-81.26351062799995,
							28.462570615000065
						],
						[
							-81.26351639599994,
							28.462629182000057
						],
						[
							-81.26351832199992,
							28.46268800000007
						],
						[
							-81.26351639599994,
							28.462746819000074
						],
						[
							-81.26351178699991,
							28.46279621400004
						],
						[
							-81.2634877879999,
							28.462994214000048
						],
						[
							-81.26348662899994,
							28.463003385000036
						],
						[
							-81.26347704199992,
							28.463061449000065
						],
						[
							-81.26346367899993,
							28.46311876100009
						],
						[
							-81.26344659499995,
							28.463175077000074
						],
						[
							-81.26342586599992,
							28.463230155000076
						],
						[
							-81.26340786899993,
							28.46327074000004
						],
						[
							-81.26327486799994,
							28.46355174000007
						],
						[
							-81.2632685769999,
							28.463564760000054
						],
						[
							-81.26324083499992,
							28.46361666100006
						],
						[
							-81.26320975899995,
							28.463666637000077
						],
						[
							-81.26317547999992,
							28.46371447300004
						],
						[
							-81.2631381459999,
							28.463759964000076
						],
						[
							-81.26312705799995,
							28.463772374000087
						],
						[
							-81.26291405799992,
							28.464006374000064
						],
						[
							-81.26290402099994,
							28.464016893000064
						],
						[
							-81.26293091699995,
							28.464042084000084
						],
						[
							-81.26297114599993,
							28.464085036000085
						],
						[
							-81.26297310699994,
							28.464087279000072
						],
						[
							-81.26311516399994,
							28.46425035100009
						],
						[
							-81.2631587599999,
							28.464270422000084
						],
						[
							-81.2632106609999,
							28.46429816400007
						],
						[
							-81.26326063599993,
							28.464329241000087
						],
						[
							-81.26330847199995,
							28.464363520000063
						],
						[
							-81.26335396399992,
							28.464400854000075
						],
						[
							-81.26339691699991,
							28.464441083000054
						],
						[
							-81.26343791699992,
							28.464482083000064
						],
						[
							-81.2634781459999,
							28.464525036000055
						],
						[
							-81.26349361299992,
							28.464543150000054
						],
						[
							-81.26355761299993,
							28.464620150000087
						],
						[
							-81.26357947999992,
							28.464647527000068
						],
						[
							-81.26361375899995,
							28.46469536300009
						],
						[
							-81.26364483599991,
							28.46474533900005
						],
						[
							-81.2636725779999,
							28.464797240000053
						],
						[
							-81.26369312899993,
							28.464841960000058
						],
						[
							-81.2637281289999,
							28.46492396000008
						],
						[
							-81.26373155699993,
							28.464932112000042
						],
						[
							-81.26374885399991,
							28.464911036000046
						],
						[
							-81.26378908299995,
							28.46486808300006
						],
						[
							-81.26382100699993,
							28.464837687000056
						],
						[
							-81.2639436149999,
							28.464726547000055
						],
						[
							-81.2639798699999,
							28.46464981400004
						],
						[
							-81.26398642299995,
							28.46463624000006
						],
						[
							-81.2639919209999,
							28.464625278000085
						],
						[
							-81.26401692199994,
							28.464576279000084
						],
						[
							-81.26403916499993,
							28.46453533900007
						],
						[
							-81.2640702409999,
							28.46448536400004
						],
						[
							-81.26409131999992,
							28.46445517300009
						],
						[
							-81.26409440499992,
							28.46444592300009
						],
						[
							-81.26411513499994,
							28.464390845000082
						],
						[
							-81.26413942199991,
							28.464337240000077
						],
						[
							-81.2641671639999,
							28.46428533900007
						],
						[
							-81.26416928899994,
							28.464281679000067
						],
						[
							-81.26426095099993,
							28.464124627000047
						],
						[
							-81.26426132199992,
							28.46412323800007
						],
						[
							-81.26427840499991,
							28.46406692200009
						],
						[
							-81.26429913499993,
							28.464011844000083
						],
						[
							-81.26432342299995,
							28.46395824000007
						],
						[
							-81.26432490799994,
							28.463955243000044
						],
						[
							-81.2644197759999,
							28.463764660000038
						],
						[
							-81.2645226429999,
							28.463504413000067
						],
						[
							-81.26452813499994,
							28.46349084500008
						],
						[
							-81.26455242299994,
							28.463437240000076
						],
						[
							-81.26458016399994,
							28.463385339000073
						],
						[
							-81.2646009629999,
							28.463351100000068
						],
						[
							-81.26462409999993,
							28.46321124600007
						],
						[
							-81.26463798099991,
							28.463073980000047
						],
						[
							-81.26465306799992,
							28.46286747100004
						],
						[
							-81.26465837199993,
							28.462815615000068
						],
						[
							-81.2646679579999,
							28.46275755100004
						],
						[
							-81.26467248199992,
							28.462736171000074
						],
						[
							-81.26467724199995,
							28.462714949000087
						],
						[
							-81.2646799769999,
							28.462608828000043
						],
						[
							-81.26468160399992,
							28.46257318100004
						],
						[
							-81.26468737199993,
							28.46251461500009
						],
						[
							-81.26469695799994,
							28.46245655100006
						],
						[
							-81.26471032199994,
							28.462399238000046
						],
						[
							-81.26472740499992,
							28.46234292200006
						],
						[
							-81.26474813499993,
							28.462287844000063
						],
						[
							-81.26475810099993,
							28.462264705000052
						],
						[
							-81.2647593719999,
							28.462254615000063
						],
						[
							-81.26476895799993,
							28.46219655100009
						],
						[
							-81.26478232199992,
							28.462139239000066
						],
						[
							-81.26478685799992,
							28.462122926000063
						],
						[
							-81.26481368799995,
							28.462029838000035
						],
						[
							-81.26481981699993,
							28.46197059900004
						],
						[
							-81.26482519699994,
							28.461751526000057
						],
						[
							-81.26479217199994,
							28.460992883000074
						],
						[
							-81.26477184599992,
							28.460727295000083
						],
						[
							-81.26472180099995,
							28.460708083000043
						],
						[
							-81.26437795499993,
							28.46066995800004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Vista East",
				"RegionID": "269221"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.61114608199995,
					30.31091092800005,
					-81.59013321799996,
					30.323472924000043
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.59585149599991,
							30.32281072900008
						],
						[
							-81.59523330399992,
							30.322678259000043
						],
						[
							-81.59468134699995,
							30.322744494000066
						],
						[
							-81.59399691999994,
							30.322325007000074
						],
						[
							-81.59351119699994,
							30.32192759700007
						],
						[
							-81.5931358659999,
							30.321176935000043
						],
						[
							-81.59276053499991,
							30.32069121300009
						],
						[
							-81.5918332469999,
							30.320249647000082
						],
						[
							-81.59136960299992,
							30.319786003000047
						],
						[
							-81.59108258499992,
							30.318947028000082
						],
						[
							-81.59055270599993,
							30.31813013100009
						],
						[
							-81.59013321799996,
							30.31755609500004
						],
						[
							-81.5902436099999,
							30.31722492100005
						],
						[
							-81.59095011499994,
							30.316695042000052
						],
						[
							-81.59163454199995,
							30.316165163000054
						],
						[
							-81.59216442099995,
							30.315701519000072
						],
						[
							-81.59273845699995,
							30.315083326000035
						],
						[
							-81.5930917099999,
							30.31470799500005
						],
						[
							-81.59395276299995,
							30.314288508000065
						],
						[
							-81.59490212999992,
							30.31384694200005
						],
						[
							-81.59547616499992,
							30.313030045000065
						],
						[
							-81.59548338199994,
							30.31301982100007
						],
						[
							-81.59593199999995,
							30.313131000000055
						],
						[
							-81.59676090699992,
							30.313339010000053
						],
						[
							-81.59746990699995,
							30.31350801100007
						],
						[
							-81.59805590699995,
							30.31364401100007
						],
						[
							-81.5983419069999,
							30.313720011000044
						],
						[
							-81.5985179079999,
							30.313775010000086
						],
						[
							-81.59870790799994,
							30.313823011000068
						],
						[
							-81.5990879069999,
							30.31391101000008
						],
						[
							-81.59917294199994,
							30.313925934000054
						],
						[
							-81.5992718739999,
							30.314002087000063
						],
						[
							-81.5993900119999,
							30.314023162000073
						],
						[
							-81.5994008529999,
							30.313966995000044
						],
						[
							-81.59965190899993,
							30.31399401200008
						],
						[
							-81.59988990999994,
							30.31400801200005
						],
						[
							-81.60017190899993,
							30.313991012000088
						],
						[
							-81.60040190899991,
							30.313964012000046
						],
						[
							-81.60052490999993,
							30.31394001300004
						],
						[
							-81.60062390999991,
							30.313925012000084
						],
						[
							-81.60082990899991,
							30.313871012000046
						],
						[
							-81.60131787499995,
							30.313695928000072
						],
						[
							-81.60163890999992,
							30.313546013000064
						],
						[
							-81.60178390999994,
							30.31348201200007
						],
						[
							-81.60275990899993,
							30.31306801200009
						],
						[
							-81.60330190999991,
							30.31283201200006
						],
						[
							-81.60367390899995,
							30.312669013000065
						],
						[
							-81.6044079099999,
							30.312370012000084
						],
						[
							-81.60457490899995,
							30.312301013000084
						],
						[
							-81.6048599099999,
							30.312175012000072
						],
						[
							-81.60537090899993,
							30.311955013000045
						],
						[
							-81.60581190999996,
							30.311771013000055
						],
						[
							-81.60604890999991,
							30.311674013000072
						],
						[
							-81.60652890999995,
							30.311463013000033
						],
						[
							-81.60686890999995,
							30.311317013000068
						],
						[
							-81.60701490899993,
							30.311253013000055
						],
						[
							-81.60719190999993,
							30.31118801300005
						],
						[
							-81.60723890999992,
							30.31117101300004
						],
						[
							-81.60750590999993,
							30.31109401300006
						],
						[
							-81.60769390999991,
							30.311055013000043
						],
						[
							-81.60785690999995,
							30.311028012000065
						],
						[
							-81.60797990999993,
							30.31101401300009
						],
						[
							-81.60819190899991,
							30.310995013000078
						],
						[
							-81.60835790899995,
							30.310984012000063
						],
						[
							-81.60877490999991,
							30.310942012000055
						],
						[
							-81.60911992899993,
							30.31091092800005
						],
						[
							-81.6091009079999,
							30.311001010000044
						],
						[
							-81.60907490499994,
							30.311207012000068
						],
						[
							-81.60898690699992,
							30.311442008000085
						],
						[
							-81.60876590799995,
							30.311795011000072
						],
						[
							-81.60866690799992,
							30.31203001200004
						],
						[
							-81.60864077499991,
							30.312153010000088
						],
						[
							-81.60866285799995,
							30.312261028000083
						],
						[
							-81.60888790799993,
							30.312732011000037
						],
						[
							-81.60899590699995,
							30.312961011000084
						],
						[
							-81.60910390599992,
							30.31329500800007
						],
						[
							-81.60911983599993,
							30.31344404400005
						],
						[
							-81.6091689829999,
							30.31350097400008
						],
						[
							-81.60923475999994,
							30.313835116000067
						],
						[
							-81.60964690799995,
							30.314070011000073
						],
						[
							-81.6100919079999,
							30.314312009000048
						],
						[
							-81.61060290799992,
							30.31448901100004
						],
						[
							-81.61084190699995,
							30.314575011000045
						],
						[
							-81.61095706499992,
							30.31463890400005
						],
						[
							-81.61096491099994,
							30.31473101200004
						],
						[
							-81.61098990699992,
							30.314795011000058
						],
						[
							-81.61105099999992,
							30.314933000000057
						],
						[
							-81.61114608199995,
							30.31591167000005
						],
						[
							-81.6108144509999,
							30.316098518000047
						],
						[
							-81.61068058699993,
							30.316160086000085
						],
						[
							-81.61059858099992,
							30.316185570000073
						],
						[
							-81.61007758099993,
							30.316320571000066
						],
						[
							-81.60998540499992,
							30.316339373000066
						],
						[
							-81.6093854049999,
							30.316429372000073
						],
						[
							-81.60925199999991,
							30.31643932200006
						],
						[
							-81.60768799999994,
							30.31643932200006
						],
						[
							-81.60761758899991,
							30.31643656200004
						],
						[
							-81.60735304699995,
							30.316415786000054
						],
						[
							-81.60716811499992,
							30.31653810000006
						],
						[
							-81.60714045599991,
							30.316555678000043
						],
						[
							-81.60651445499991,
							30.31693767800005
						],
						[
							-81.6064560559999,
							30.316970396000045
						],
						[
							-81.60639538499993,
							30.316998680000044
						],
						[
							-81.6063327789999,
							30.317022372000057
						],
						[
							-81.60626858299992,
							30.31704134200004
						],
						[
							-81.60512158299991,
							30.31733434200004
						],
						[
							-81.60505516599994,
							30.31734866000005
						],
						[
							-81.60489151199994,
							30.31736226000004
						],
						[
							-81.60369673399993,
							30.31734242400006
						],
						[
							-81.60347674999991,
							30.31743743800007
						],
						[
							-81.60323055099991,
							30.31759947000006
						],
						[
							-81.6032915859999,
							30.317826893000078
						],
						[
							-81.60330865899994,
							30.317903835000042
						],
						[
							-81.60332232199995,
							30.31806000000006
						],
						[
							-81.60330865899994,
							30.318216166000074
						],
						[
							-81.6032680859999,
							30.31836758600008
						],
						[
							-81.60323664599991,
							30.31844309300004
						],
						[
							-81.60289764599992,
							30.319163092000053
						],
						[
							-81.6028630109999,
							30.31922935700004
						],
						[
							-81.60282299099993,
							30.31929251600008
						],
						[
							-81.60277786299991,
							30.319352132000066
						],
						[
							-81.60272793799993,
							30.31940779300004
						],
						[
							-81.60267356199995,
							30.319459114000036
						],
						[
							-81.60265119999993,
							30.319478527000054
						],
						[
							-81.60260137599994,
							30.319598333000048
						],
						[
							-81.60256840799991,
							30.319668836000066
						],
						[
							-81.60252946799994,
							30.319736225000042
						],
						[
							-81.60248484599992,
							30.319799995000043
						],
						[
							-81.60243487899993,
							30.319859667000063
						],
						[
							-81.6023799379999,
							30.319914796000035
						],
						[
							-81.60232043699995,
							30.319964968000082
						],
						[
							-81.60182543799993,
							30.320346968000084
						],
						[
							-81.60178600299992,
							30.320375727000055
						],
						[
							-81.5996960029999,
							30.321814727000056
						],
						[
							-81.59963566099992,
							30.321852836000062
						],
						[
							-81.59950314999992,
							30.321915544000035
						],
						[
							-81.59931802599993,
							30.321985311000045
						],
						[
							-81.59932588099991,
							30.322059610000053
						],
						[
							-81.59932719299991,
							30.32213431200006
						],
						[
							-81.5993219529999,
							30.322208841000073
						],
						[
							-81.59931020099992,
							30.322282624000085
						],
						[
							-81.5992528189999,
							30.322564129000057
						],
						[
							-81.59882497199993,
							30.32305063100006
						],
						[
							-81.59845624199994,
							30.32333742100008
						],
						[
							-81.59843232999992,
							30.323472924000043
						],
						[
							-81.59735281999991,
							30.32320813800004
						],
						[
							-81.59664631499993,
							30.322943199000065
						],
						[
							-81.59585149599991,
							30.32281072900008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Oak Haven",
				"RegionID": "269116"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.73410794199992,
					30.189045838000087,
					-81.70051581299992,
					30.22655841900007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.70119187099993,
							30.22605813300004
						],
						[
							-81.7006679029999,
							30.225794819000043
						],
						[
							-81.70051581299992,
							30.22587812100005
						],
						[
							-81.70058190599991,
							30.225673009000047
						],
						[
							-81.70061690599994,
							30.225553009000066
						],
						[
							-81.70085290599991,
							30.22478300800009
						],
						[
							-81.70141290499993,
							30.222830008000074
						],
						[
							-81.7021179059999,
							30.220549008000035
						],
						[
							-81.70260590599992,
							30.219082008000044
						],
						[
							-81.70317090599991,
							30.21712000800005
						],
						[
							-81.70375790599991,
							30.215225008000065
						],
						[
							-81.70381890499995,
							30.215059008000082
						],
						[
							-81.70384390599992,
							30.214951008000067
						],
						[
							-81.70398390499992,
							30.21453100900004
						],
						[
							-81.70426390599994,
							30.21364900900005
						],
						[
							-81.7043709049999,
							30.21330700800007
						],
						[
							-81.7045529049999,
							30.212631008000074
						],
						[
							-81.70505490499994,
							30.210988009000065
						],
						[
							-81.70521490499993,
							30.210443008000087
						],
						[
							-81.7057649059999,
							30.208670008000066
						],
						[
							-81.70593290499994,
							30.208103008000084
						],
						[
							-81.7061079049999,
							30.207548008000057
						],
						[
							-81.70620090599994,
							30.207239008000045
						],
						[
							-81.70722979099992,
							30.20383594200007
						],
						[
							-81.70739201899994,
							30.20367307400005
						],
						[
							-81.7076369049999,
							30.202745009000065
						],
						[
							-81.7077929049999,
							30.20196700800005
						],
						[
							-81.70789990599991,
							30.201300008000093
						],
						[
							-81.70799590599995,
							30.20065300800007
						],
						[
							-81.7080159059999,
							30.200056009000036
						],
						[
							-81.70800790499993,
							30.19950900900005
						],
						[
							-81.70796790499992,
							30.198612009000048
						],
						[
							-81.70791590599993,
							30.198027009000043
						],
						[
							-81.70788190599991,
							30.197760008000046
						],
						[
							-81.70782490599993,
							30.197450008000093
						],
						[
							-81.70777490599994,
							30.19717400800005
						],
						[
							-81.70756890499992,
							30.19627200800005
						],
						[
							-81.7075479049999,
							30.19612200800009
						],
						[
							-81.70744890599991,
							30.195762009000074
						],
						[
							-81.70731890599991,
							30.195324008000057
						],
						[
							-81.70705390599994,
							30.194501009000078
						],
						[
							-81.70690490599992,
							30.194111009000043
						],
						[
							-81.70677190599991,
							30.193813009000053
						],
						[
							-81.70667590499994,
							30.193599008000035
						],
						[
							-81.7065519059999,
							30.193306008000036
						],
						[
							-81.70633890599993,
							30.192923008000033
						],
						[
							-81.70630790499992,
							30.192869008000063
						],
						[
							-81.70609490499993,
							30.192490008000053
						],
						[
							-81.70570790599993,
							30.191858009000047
						],
						[
							-81.7056309059999,
							30.191742009000052
						],
						[
							-81.70545990599993,
							30.19149500800006
						],
						[
							-81.70537190499994,
							30.191367008000046
						],
						[
							-81.70460690499993,
							30.190409008000074
						],
						[
							-81.7040519059999,
							30.189720008000055
						],
						[
							-81.70397790599992,
							30.189634009000088
						],
						[
							-81.7038059059999,
							30.189402009000048
						],
						[
							-81.70354744799994,
							30.189045838000087
						],
						[
							-81.70362821499992,
							30.189093315000036
						],
						[
							-81.7045546139999,
							30.18963788200006
						],
						[
							-81.70467899999994,
							30.189711000000045
						],
						[
							-81.70528003299995,
							30.18967562500006
						],
						[
							-81.70639499999993,
							30.189610000000073
						],
						[
							-81.70657699999994,
							30.189769000000073
						],
						[
							-81.70688314099993,
							30.190036836000047
						],
						[
							-81.70759199999992,
							30.190657000000044
						],
						[
							-81.70774099999994,
							30.190787000000057
						],
						[
							-81.70821099999995,
							30.191198000000043
						],
						[
							-81.7085889999999,
							30.191204000000084
						],
						[
							-81.7090849999999,
							30.19121400000006
						],
						[
							-81.71101599999992,
							30.191197000000045
						],
						[
							-81.7113839999999,
							30.191192000000054
						],
						[
							-81.7217369999999,
							30.19105400000006
						],
						[
							-81.72291298599994,
							30.191038587000037
						],
						[
							-81.72532299999995,
							30.191007000000067
						],
						[
							-81.72539799999993,
							30.19103000000007
						],
						[
							-81.73171799999994,
							30.192935000000034
						],
						[
							-81.73177299999992,
							30.192953000000045
						],
						[
							-81.7334899999999,
							30.193466000000058
						],
						[
							-81.73410794199992,
							30.194816927000094
						],
						[
							-81.73183490599992,
							30.199301008000077
						],
						[
							-81.73076490599993,
							30.20141200800009
						],
						[
							-81.72788002099992,
							30.20889007500006
						],
						[
							-81.72449794099992,
							30.212336049000044
						],
						[
							-81.71751890599995,
							30.216808008000044
						],
						[
							-81.71273176299991,
							30.22022490700004
						],
						[
							-81.71136199999995,
							30.224677000000042
						],
						[
							-81.7112131099999,
							30.225132771000062
						],
						[
							-81.71087243499994,
							30.225384575000078
						],
						[
							-81.71054657199994,
							30.225784497000063
						],
						[
							-81.71036882899995,
							30.226169608000074
						],
						[
							-81.7101938639999,
							30.22655841900007
						],
						[
							-81.70966499999992,
							30.226531000000076
						],
						[
							-81.70162190499991,
							30.22611400800008
						],
						[
							-81.70119187099993,
							30.22605813300004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Ortega Hills",
				"RegionID": "269123"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.72117805099992,
					30.404320954000067,
					-81.69728090699994,
					30.41931532200005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.71364353599995,
							30.418754384000064
						],
						[
							-81.71337483999991,
							30.41863487600006
						],
						[
							-81.71170744599993,
							30.41811083800008
						],
						[
							-81.71051731599994,
							30.41822519400006
						],
						[
							-81.70854388599992,
							30.418383444000085
						],
						[
							-81.7083959389999,
							30.41838309900004
						],
						[
							-81.70397793899991,
							30.418008100000062
						],
						[
							-81.7038978349999,
							30.417997660000086
						],
						[
							-81.7038041699999,
							30.417975925000068
						],
						[
							-81.70189808299995,
							30.41742472200008
						],
						[
							-81.7007731349999,
							30.417507390000086
						],
						[
							-81.70041152099992,
							30.418003046000084
						],
						[
							-81.70037392099994,
							30.418051073000072
						],
						[
							-81.70026307299992,
							30.418161921000035
						],
						[
							-81.70013466099994,
							30.418251836000078
						],
						[
							-81.69999258699994,
							30.418318086000056
						],
						[
							-81.69984116599994,
							30.41835865900003
						],
						[
							-81.69967550399991,
							30.418372222000073
						],
						[
							-81.69889107199992,
							30.418355083000055
						],
						[
							-81.6981286109999,
							30.41799704200008
						],
						[
							-81.69759768799992,
							30.417952048000075
						],
						[
							-81.69745999999992,
							30.417426000000034
						],
						[
							-81.69737990999994,
							30.417120009000087
						],
						[
							-81.69738790799995,
							30.416862010000045
						],
						[
							-81.6973799079999,
							30.416708011000082
						],
						[
							-81.6973799079999,
							30.41628601000008
						],
						[
							-81.69737190699993,
							30.41617401000008
						],
						[
							-81.69736490899993,
							30.41610901000007
						],
						[
							-81.69737190799992,
							30.41569901100007
						],
						[
							-81.69735690699991,
							30.41512701000005
						],
						[
							-81.69735290799991,
							30.41446901000006
						],
						[
							-81.69734190799994,
							30.41412900900008
						],
						[
							-81.69734990799992,
							30.41393101000006
						],
						[
							-81.6973339079999,
							30.413155010000082
						],
						[
							-81.69732690799992,
							30.412846011000056
						],
						[
							-81.69730390799992,
							30.411121011000034
						],
						[
							-81.6972889079999,
							30.41021201100006
						],
						[
							-81.69728090699994,
							30.409824011000072
						],
						[
							-81.69729590799996,
							30.408443010000045
						],
						[
							-81.69730390799992,
							30.408337010000082
						],
						[
							-81.6973109079999,
							30.40774701000004
						],
						[
							-81.6973189069999,
							30.406761010000086
						],
						[
							-81.69732482199993,
							30.405763946000036
						],
						[
							-81.69749990899993,
							30.40567401300007
						],
						[
							-81.69905890899992,
							30.405039012000085
						],
						[
							-81.69921090899993,
							30.404970013000085
						],
						[
							-81.69940890899994,
							30.40488801300006
						],
						[
							-81.6998979089999,
							30.404732012000068
						],
						[
							-81.70006590999992,
							30.404692012000055
						],
						[
							-81.70052290899991,
							30.404636013000076
						],
						[
							-81.70181290999994,
							30.40459601200007
						],
						[
							-81.70272790899992,
							30.404583012000046
						],
						[
							-81.70342290999992,
							30.40456201300009
						],
						[
							-81.7041929099999,
							30.404539013000093
						],
						[
							-81.70515190999993,
							30.40452401300007
						],
						[
							-81.70560190999993,
							30.404504013000068
						],
						[
							-81.70623390899993,
							30.40449801200009
						],
						[
							-81.70661690999992,
							30.40448301300006
						],
						[
							-81.70764590899995,
							30.404454012000087
						],
						[
							-81.70902090999994,
							30.404418012000068
						],
						[
							-81.71150190999992,
							30.404371012000073
						],
						[
							-81.7121659089999,
							30.404350012000066
						],
						[
							-81.71339095999991,
							30.404320954000067
						],
						[
							-81.7134459909999,
							30.404431990000035
						],
						[
							-81.71346990799992,
							30.405630011000085
						],
						[
							-81.71348590799994,
							30.406200010000074
						],
						[
							-81.71349290699993,
							30.407719011000044
						],
						[
							-81.71348590799994,
							30.407946010000046
						],
						[
							-81.71349290699993,
							30.408623011000085
						],
						[
							-81.71350890699995,
							30.40892201000008
						],
						[
							-81.7135239079999,
							30.41072801000007
						],
						[
							-81.71356190799992,
							30.413240011000084
						],
						[
							-81.71355390799994,
							30.413540010000077
						],
						[
							-81.71356190799992,
							30.413845010000042
						],
						[
							-81.71358490699993,
							30.415052011000057
						],
						[
							-81.71359990799994,
							30.415342011000064
						],
						[
							-81.71359990799994,
							30.416456011000037
						],
						[
							-81.7136077799999,
							30.416746143000065
						],
						[
							-81.7162699079999,
							30.416723010000055
						],
						[
							-81.71791090799991,
							30.41669801100005
						],
						[
							-81.71805590699995,
							30.416710011000077
						],
						[
							-81.71819290699995,
							30.41674401100005
						],
						[
							-81.71850590799994,
							30.416866011000085
						],
						[
							-81.71865090799992,
							30.416935009000042
						],
						[
							-81.71886389899993,
							30.417000063000042
						],
						[
							-81.71919290799991,
							30.417017010000055
						],
						[
							-81.72017690799993,
							30.417009010000072
						],
						[
							-81.72117805099992,
							30.416997911000067
						],
						[
							-81.72080099999994,
							30.417903000000084
						],
						[
							-81.72060278899994,
							30.418378792000055
						],
						[
							-81.71983367099995,
							30.41864270500008
						],
						[
							-81.71800885599993,
							30.41920202500006
						],
						[
							-81.71726169899995,
							30.41930663500006
						],
						[
							-81.71713699999992,
							30.41931532200005
						],
						[
							-81.7170135049999,
							30.41930680300004
						],
						[
							-81.71440950599992,
							30.418945802000053
						],
						[
							-81.71430844799994,
							30.418925836000085
						],
						[
							-81.71364353599995,
							30.418754384000064
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Osceola Forest",
				"RegionID": "269125"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.44755751499973,
					27.903461996653892,
					-82.40150903784097,
					27.9561892759623
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-82.4250759999998,
								27.91201000000029
							],
							[
								-82.42516919596915,
								27.91195392909966
							],
							[
								-82.4245819999997,
								27.91294600000011
							],
							[
								-82.42428099999965,
								27.913405000000427
							],
							[
								-82.42361795536463,
								27.914414314933925
							],
							[
								-82.42391999999973,
								27.913873000000248
							],
							[
								-82.42413499999975,
								27.91353800000024
							],
							[
								-82.42423599999994,
								27.91340000000037
							],
							[
								-82.42432199999976,
								27.91331900000024
							],
							[
								-82.42435499999992,
								27.913274000000246
							],
							[
								-82.42440199999982,
								27.913172000000333
							],
							[
								-82.4244729999999,
								27.912989000000113
							],
							[
								-82.42455399999986,
								27.912841000000302
							],
							[
								-82.4250759999998,
								27.91201000000029
							]
						]
					],
					[
						[
							[
								-82.40675790881322,
								27.942833756565047
							],
							[
								-82.40682399999979,
								27.94280900000025
							],
							[
								-82.4068540171499,
								27.942805063324908
							],
							[
								-82.40675790881322,
								27.942833756565047
							]
						]
					],
					[
						[
							[
								-82.40675790881322,
								27.942833756565047
							],
							[
								-82.40656699999975,
								27.942980000000897
							],
							[
								-82.40625899999985,
								27.943185000000273
							],
							[
								-82.40606799999976,
								27.943361000000625
							],
							[
								-82.40598899999962,
								27.94348300000077
							],
							[
								-82.4059087824226,
								27.943609727078673
							],
							[
								-82.40588799999989,
								27.943588000000222
							],
							[
								-82.40588199999983,
								27.94356100000012
							],
							[
								-82.40589199999987,
								27.94349900000032
							],
							[
								-82.40589199999987,
								27.943472000000217
							],
							[
								-82.40587999999984,
								27.943454000000326
							],
							[
								-82.4058559999999,
								27.94344700000028
							],
							[
								-82.40575299999982,
								27.943448000000007
							],
							[
								-82.40572399999972,
								27.94344100000014
							],
							[
								-82.40569799999982,
								27.943425000000236
							],
							[
								-82.40567599999984,
								27.943402000000287
							],
							[
								-82.40566099999994,
								27.94337600000027
							],
							[
								-82.40565799999978,
								27.943352000000235
							],
							[
								-82.40566599999981,
								27.94332600000022
							],
							[
								-82.4056829999999,
								27.94329900000029
							],
							[
								-82.40574599999977,
								27.94323800000022
							],
							[
								-82.40584099999981,
								27.9431660000003
							],
							[
								-82.40596999999983,
								27.94309100000031
							],
							[
								-82.40608099999977,
								27.943039000000272
							],
							[
								-82.40619499999988,
								27.94299700000035
							],
							[
								-82.4063229999999,
								27.94296700000036
							],
							[
								-82.40652499999993,
								27.94292100000028
							],
							[
								-82.40675790881322,
								27.942833756565047
							]
						]
					],
					[
						[
							[
								-82.40508599999978,
								27.944401000000344
							],
							[
								-82.4051139999998,
								27.944393000000215
							],
							[
								-82.40514399999988,
								27.944396000000285
							],
							[
								-82.40521537714282,
								27.944417339558672
							],
							[
								-82.40498299999962,
								27.944533000000785
							],
							[
								-82.40481497124426,
								27.944589327821593
							],
							[
								-82.40483399999981,
								27.944580000000233
							],
							[
								-82.40503399999993,
								27.94442900000035
							],
							[
								-82.40508599999978,
								27.944401000000344
							]
						]
					],
					[
						[
							[
								-82.40445299999982,
								27.9444980000002
							],
							[
								-82.40447599999985,
								27.944497000000293
							],
							[
								-82.40452799999989,
								27.944516000000267
							],
							[
								-82.40455899999988,
								27.94453500000024
							],
							[
								-82.40464399999989,
								27.94458700000028
							],
							[
								-82.40468311768757,
								27.94460386107264
							],
							[
								-82.40461899999978,
								27.94461000000076
							],
							[
								-82.4044809999999,
								27.944612000000927
							],
							[
								-82.40435403311845,
								27.944626464581926
							],
							[
								-82.40440499999993,
								27.94458500000029
							],
							[
								-82.40443599999973,
								27.94451500000036
							],
							[
								-82.40445299999982,
								27.9444980000002
							]
						]
					],
					[
						[
							[
								-82.40415799999992,
								27.944635000000343
							],
							[
								-82.40418599999975,
								27.94462900000038
							],
							[
								-82.4042835853654,
								27.944640801829586
							],
							[
								-82.4041909999999,
								27.94466700000068
							],
							[
								-82.40411099999994,
								27.94470700000097
							],
							[
								-82.40374776013064,
								27.944948301189957
							],
							[
								-82.4038709999998,
								27.944849000000108
							],
							[
								-82.40403599999978,
								27.944716000000295
							],
							[
								-82.40415799999992,
								27.944635000000343
							]
						]
					],
					[
						[
							[
								-82.40206899999991,
								27.945136000000407
							],
							[
								-82.40189399999973,
								27.945104999999973
							],
							[
								-82.40185499999988,
								27.94510000000027
							],
							[
								-82.40181199999988,
								27.94509400000084
							],
							[
								-82.40166899999969,
								27.945081000000652
							],
							[
								-82.40152583373906,
								27.945085014007734
							],
							[
								-82.40157099999992,
								27.945072000000263
							],
							[
								-82.40168699999975,
								27.945027999999997
							],
							[
								-82.40174699999992,
								27.94501900000032
							],
							[
								-82.40184699999985,
								27.94501900000032
							],
							[
								-82.40187199999978,
								27.94501900000032
							],
							[
								-82.40196499999983,
								27.945030000000163
							],
							[
								-82.40205399999982,
								27.9450510000003
							],
							[
								-82.40225699999984,
								27.945122000000314
							],
							[
								-82.40228599999993,
								27.945129000000364
							],
							[
								-82.40231599999994,
								27.945131000000348
							],
							[
								-82.40259099999986,
								27.94507600000024
							],
							[
								-82.40265099999993,
								27.94507400000025
							],
							[
								-82.40280199999981,
								27.94511000000021
							],
							[
								-82.40292499999987,
								27.94511800000034
							],
							[
								-82.40320499999976,
								27.94511800000034
							],
							[
								-82.40326999999989,
								27.94512300000004
							],
							[
								-82.40328029248028,
								27.945123884510288
							],
							[
								-82.40326399999967,
								27.945127000000372
							],
							[
								-82.40290099999991,
								27.94514100000011
							],
							[
								-82.40206899999991,
								27.945136000000407
							]
						]
					],
					[
						[
							[
								-82.42621820417816,
								27.955299939964565
							],
							[
								-82.42451819087175,
								27.954799948178636
							],
							[
								-82.41510908183815,
								27.954800051889453
							],
							[
								-82.40770910014514,
								27.952599947834425
							],
							[
								-82.40150903784097,
								27.952481819973865
							],
							[
								-82.40161734499985,
								27.946802424000442
							],
							[
								-82.40161821299984,
								27.94675691000005
							],
							[
								-82.4016360919998,
								27.94581933200046
							],
							[
								-82.40169886299984,
								27.945808673000908
							],
							[
								-82.40342372699965,
								27.945777024000865
							],
							[
								-82.40421494899975,
								27.945713727000868
							],
							[
								-82.40533848499989,
								27.94528646700122
							],
							[
								-82.40633243999962,
								27.944619527000572
							],
							[
								-82.4063840949999,
								27.944594300000706
							],
							[
								-82.40749792299987,
								27.943983007001023
							],
							[
								-82.40758333899976,
								27.943925164000763
							],
							[
								-82.40769369199973,
								27.9438711440002
							],
							[
								-82.40777469199985,
								27.943838144000846
							],
							[
								-82.40780641399981,
								27.94382591400019
							],
							[
								-82.40795919599984,
								27.943785103000454
							],
							[
								-82.40800117399976,
								27.943777832000833
							],
							[
								-82.40808192699978,
								27.94369707900081
							],
							[
								-82.40812445799983,
								27.943663522000254
							],
							[
								-82.40826745699968,
								27.943557523000454
							],
							[
								-82.40835333899986,
								27.943501165000235
							],
							[
								-82.40841675499959,
								27.943467845000853
							],
							[
								-82.40880575499953,
								27.943282845000642
							],
							[
								-82.40888441299965,
								27.943249914000848
							],
							[
								-82.4089738899995,
								27.943222527000803
							],
							[
								-82.40900830099953,
								27.943212705000878
							],
							[
								-82.40905348399978,
								27.943179054000847
							],
							[
								-82.40877217199987,
								27.943209170000852
							],
							[
								-82.40859148199966,
								27.943251996000487
							],
							[
								-82.4084221619996,
								27.943323001000767
							],
							[
								-82.40827160199966,
								27.94340462100077
							],
							[
								-82.40826254399971,
								27.94340861300039
							],
							[
								-82.40766599999982,
								27.94268400000021
							],
							[
								-82.40770899999983,
								27.94266100000026
							],
							[
								-82.40782599999991,
								27.942600000000365
							],
							[
								-82.40805899999975,
								27.942465000000386
							],
							[
								-82.40829199999985,
								27.942283000000252
							],
							[
								-82.40836899999982,
								27.94223700000035
							],
							[
								-82.40842499999984,
								27.942214000000227
							],
							[
								-82.40848499999991,
								27.942201000000217
							],
							[
								-82.40869999999975,
								27.942179000000348
							],
							[
								-82.40881799999994,
								27.942147000000364
							],
							[
								-82.40887299999977,
								27.94212200000025
							],
							[
								-82.4088979999999,
								27.942105000000264
							],
							[
								-82.40891899999986,
								27.942084000000303
							],
							[
								-82.40893199999987,
								27.94206000000027
							],
							[
								-82.40894399999979,
								27.942006000000067
							],
							[
								-82.40895399999981,
								27.94192400000039
							],
							[
								-82.40896199999986,
								27.941897000000285
							],
							[
								-82.40897699999985,
								27.94187400000034
							],
							[
								-82.4090029999997,
								27.94185900000034
							],
							[
								-82.40909299999986,
								27.941838000000377
							],
							[
								-82.40912099999977,
								27.941827000000178
							],
							[
								-82.40914199999973,
								27.9418070000003
							],
							[
								-82.40917699999989,
								27.941762000000306
							],
							[
								-82.4092049999998,
								27.941751000000284
							],
							[
								-82.40926399999988,
								27.941765000000377
							],
							[
								-82.40930399999974,
								27.941744000000238
							],
							[
								-82.4093489999999,
								27.941710000000267
							],
							[
								-82.40946599999981,
								27.941644000000313
							],
							[
								-82.40949399999984,
								27.94163300000029
							],
							[
								-82.40954299999979,
								27.94166400000019
							],
							[
								-82.40958599999979,
								27.941704000000307
							],
							[
								-82.40961499999979,
								27.941701000000233
							],
							[
								-82.40962699999982,
								27.941676000000296
							],
							[
								-82.40965499999992,
								27.94166900000025
							],
							[
								-82.40968199999975,
								27.94168200000026
							],
							[
								-82.40971199999983,
								27.941687000000318
							],
							[
								-82.40974199999991,
								27.94168200000026
							],
							[
								-82.40976399999987,
								27.941663000000286
							],
							[
								-82.40976799999976,
								27.94163600000036
							],
							[
								-82.40979499999986,
								27.94162500000034
							],
							[
								-82.40982499999976,
								27.94162200000027
							],
							[
								-82.40984599999972,
								27.941604000000204
							],
							[
								-82.40986199999989,
								27.941580000000346
							],
							[
								-82.40986799999976,
								27.941498000000312
							],
							[
								-82.40988699999983,
								27.941476000000268
							],
							[
								-82.40989199999989,
								27.941449000000166
							],
							[
								-82.40988499999985,
								27.941422000000063
							],
							[
								-82.40989599999986,
								27.941293000000048
							],
							[
								-82.40989199999989,
								27.941267000000206
							],
							[
								-82.40987399999982,
								27.941249000000315
							],
							[
								-82.40989399999988,
								27.941184000000266
							],
							[
								-82.40989299999988,
								27.941157000000164
							],
							[
								-82.40986799999976,
								27.94114100000026
							],
							[
								-82.40986999999967,
								27.94111500000024
							],
							[
								-82.40988699999983,
								27.941093000000375
							],
							[
								-82.40990099999992,
								27.94101100000034
							],
							[
								-82.40989799999976,
								27.94098400000024
							],
							[
								-82.40988299999985,
								27.940960000000207
							],
							[
								-82.40989299999988,
								27.94093500000027
							],
							[
								-82.40990999999978,
								27.94091300000023
							],
							[
								-82.40990599999981,
								27.94077600000026
							],
							[
								-82.40991599999982,
								27.94075000000024
							],
							[
								-82.4099199999998,
								27.940723000000315
							],
							[
								-82.4099049999999,
								27.940642000000366
							],
							[
								-82.40988599999983,
								27.94062000000032
							],
							[
								-82.40985599999993,
								27.94061500000026
							],
							[
								-82.40982599999975,
								27.940619000000236
							],
							[
								-82.40978099999977,
								27.940656000000278
							],
							[
								-82.40975299999984,
								27.940649000000235
							],
							[
								-82.4097279999999,
								27.940635000000317
							],
							[
								-82.40969699999992,
								27.94063800000021
							],
							[
								-82.40966699999983,
								27.940635000000317
							],
							[
								-82.40965399999992,
								27.94061200000019
							],
							[
								-82.40967999999984,
								27.940598000000097
							],
							[
								-82.40974099999991,
								27.940588000000336
							],
							[
								-82.40986399999979,
								27.9405940000003
							],
							[
								-82.40988199999985,
								27.940574000000243
							],
							[
								-82.40989599999986,
								27.94040900000027
							],
							[
								-82.40990199999992,
								27.940382000000344
							],
							[
								-82.40991299999968,
								27.94035700000023
							],
							[
								-82.40991599999982,
								27.940329000000222
							],
							[
								-82.40990999999978,
								27.940302000000298
							],
							[
								-82.40990999999978,
								27.940275000000195
							],
							[
								-82.40993299999991,
								27.940262000000363
							],
							[
								-82.40994299999993,
								27.940314000000225
							],
							[
								-82.40997299999984,
								27.94032100000027
							],
							[
								-82.4099769999999,
								27.940342000000232
							],
							[
								-82.4099629999998,
								27.940366000000267
							],
							[
								-82.40996099999983,
								27.94039400000027
							],
							[
								-82.4099199999998,
								27.940497000000267
							],
							[
								-82.40991599999982,
								27.94052400000019
							],
							[
								-82.40992899999983,
								27.94057800000022
							],
							[
								-82.40993099999974,
								27.94060500000032
							],
							[
								-82.40995899999983,
								27.94065400000029
							],
							[
								-82.40996699999988,
								27.940736000000147
							],
							[
								-82.40996499999973,
								27.94076300000025
							],
							[
								-82.40995399999977,
								27.94078900000027
							],
							[
								-82.40994399999994,
								27.940871000000303
							],
							[
								-82.40995699999966,
								27.94089600000024
							],
							[
								-82.40996499999973,
								27.941033000000207
							],
							[
								-82.40996199999982,
								27.941170000000355
							],
							[
								-82.40994899999981,
								27.94119500000029
							],
							[
								-82.40992599999986,
								27.941213000000356
							],
							[
								-82.40991699999982,
								27.941238000000293
							],
							[
								-82.4099479999999,
								27.94128600000018
							],
							[
								-82.40995899999983,
								27.941311000000116
							],
							[
								-82.4099469999999,
								27.9415310000002
							],
							[
								-82.4099339999999,
								27.941555000000232
							],
							[
								-82.40991199999976,
								27.941575000000288
							],
							[
								-82.40989699999977,
								27.94159900000032
							],
							[
								-82.40989299999988,
								27.941681000000354
							],
							[
								-82.40988199999985,
								27.941707000000196
							],
							[
								-82.40985599999993,
								27.941741000000167
							],
							[
								-82.40978499999991,
								27.94176300000021
							],
							[
								-82.40973199999988,
								27.941790000000314
							],
							[
								-82.4096709999998,
								27.94179300000021
							],
							[
								-82.40961899999976,
								27.94178600000034
							],
							[
								-82.40942199999982,
								27.941819000000226
							],
							[
								-82.40942099999982,
								27.941880000000303
							],
							[
								-82.40943199999984,
								27.941905000000236
							],
							[
								-82.40947199999987,
								27.94194800000024
							],
							[
								-82.40948599999977,
								27.94197400000026
							],
							[
								-82.40949299999991,
								27.94200500000034
							],
							[
								-82.40947599999976,
								27.942021000000242
							],
							[
								-82.40935099999989,
								27.94204400000037
							],
							[
								-82.4093219999998,
								27.942053000000225
							],
							[
								-82.40930199999983,
								27.94206900000031
							],
							[
								-82.40929599999969,
								27.9420990000003
							],
							[
								-82.4092789999998,
								27.942121000000345
							],
							[
								-82.40917799999987,
								27.942189000000287
							],
							[
								-82.40915899999982,
								27.942209000000343
							],
							[
								-82.40915299999993,
								27.94223700000035
							],
							[
								-82.4091609999998,
								27.942266000000263
							],
							[
								-82.40918199999984,
								27.942283000000252
							],
							[
								-82.40921299999984,
								27.94229800000007
							],
							[
								-82.40924499999983,
								27.942303000000305
							],
							[
								-82.4092759999999,
								27.94230100000032
							],
							[
								-82.40932999999966,
								27.94228100000026
							],
							[
								-82.40946399999983,
								27.942206000000272
							],
							[
								-82.40949199999991,
								27.94219400000035
							],
							[
								-82.40958599999979,
								27.942181000000335
							],
							[
								-82.4096139999998,
								27.9421720000003
							],
							[
								-82.40965899999979,
								27.942137000000248
							],
							[
								-82.4097279999999,
								27.94206200000026
							],
							[
								-82.40979649801783,
								27.942008866023752
							],
							[
								-82.40983499999979,
								27.94197900000032
							],
							[
								-82.40987099999965,
								27.941959000000264
							],
							[
								-82.40993899999987,
								27.941922000000222
							],
							[
								-82.41003299999991,
								27.94191600000026
							],
							[
								-82.41011099999989,
								27.94187400000034
							],
							[
								-82.4102129999998,
								27.941808000000204
							],
							[
								-82.41026699999973,
								27.941783000000267
							],
							[
								-82.41043899999976,
								27.941731000000228
							],
							[
								-82.41039664135046,
								27.940480757988443
							],
							[
								-82.41031099999992,
								27.937953000000274
							],
							[
								-82.40998199999989,
								27.931147000000248
							],
							[
								-82.4098769999998,
								27.924896000000313
							],
							[
								-82.40987599999981,
								27.924784000000283
							],
							[
								-82.40986699999978,
								27.924723000000387
							],
							[
								-82.40985699999992,
								27.924667000000017
							],
							[
								-82.40984599999972,
								27.924564000000377
							],
							[
								-82.4096289999998,
								27.923053000000056
							],
							[
								-82.41264899999992,
								27.92151800000024
							],
							[
								-82.42357878814488,
								27.91447393688468
							],
							[
								-82.4244158299998,
								27.914837713000754
							],
							[
								-82.42288752999974,
								27.917164157000865
							],
							[
								-82.4219252339996,
								27.918810137000452
							],
							[
								-82.42178809299963,
								27.919044379000827
							],
							[
								-82.42171902699987,
								27.919145781000868
							],
							[
								-82.42144839799958,
								27.91949005700111
							],
							[
								-82.4205278279998,
								27.9210164040003
							],
							[
								-82.42046812899966,
								27.921111578000893
							],
							[
								-82.42102638299984,
								27.921901992000034
							],
							[
								-82.42157152599974,
								27.92263011300033
							],
							[
								-82.42182974399961,
								27.92292117900043
							],
							[
								-82.42187701499988,
								27.92297915100114
							],
							[
								-82.42191930399974,
								27.92304085000065
							],
							[
								-82.4219563199997,
								27.923105851000077
							],
							[
								-82.42208831999969,
								27.923361851001186
							],
							[
								-82.42214657699981,
								27.923503186000534
							],
							[
								-82.42230257699975,
								27.923997185000996
							],
							[
								-82.42233065899948,
								27.924111834000445
							],
							[
								-82.42234081199945,
								27.92418862200005
							],
							[
								-82.42236920499975,
								27.924509055000005
							],
							[
								-82.42244035999987,
								27.92478260600088
							],
							[
								-82.4224556589998,
								27.924852834001182
							],
							[
								-82.42245950799985,
								27.924896826000026
							],
							[
								-82.4239487669997,
								27.92614447700085
							],
							[
								-82.42566543999963,
								27.92702228800074
							],
							[
								-82.42572672399955,
								27.92705671100101
							],
							[
								-82.42578513299985,
								27.92709581500016
							],
							[
								-82.42584030999988,
								27.927139361000922
							],
							[
								-82.4258919169998,
								27.927187083000785
							],
							[
								-82.42809801399981,
								27.929393181000886
							],
							[
								-82.42844665699954,
								27.929696837001142
							],
							[
								-82.42854492099967,
								27.929796927001075
							],
							[
								-82.42863483599983,
								27.929925339000153
							],
							[
								-82.4287010859998,
								27.930067413000717
							],
							[
								-82.42874165899978,
								27.930218834000545
							],
							[
								-82.42874852199974,
								27.93026461800078
							],
							[
								-82.42878352199989,
								27.930547618000748
							],
							[
								-82.42878955199966,
								27.930620764001116
							],
							[
								-82.42878959699975,
								27.930694158000975
							],
							[
								-82.42878365499972,
								27.930767312000807
							],
							[
								-82.4287717669997,
								27.93083973700085
							],
							[
								-82.42875401199983,
								27.930910951000346
							],
							[
								-82.42873050799949,
								27.930980480000148
							],
							[
								-82.42870141199965,
								27.931047860000394
							],
							[
								-82.42866691699965,
								27.93111264300087
							],
							[
								-82.42861999799976,
								27.931191624001098
							],
							[
								-82.42857842099987,
								27.931255261000235
							],
							[
								-82.42854242452358,
								27.931301331444406
							],
							[
								-82.42853161899981,
								27.931315161000573
							],
							[
								-82.42847992599944,
								27.931370893001098
							],
							[
								-82.42842370999976,
								27.93142206100107
							],
							[
								-82.42836337499975,
								27.931468299001164
							],
							[
								-82.42829934999952,
								27.93150927700118
							],
							[
								-82.42817937799963,
								27.93157909000083
							],
							[
								-82.4279454049998,
								27.93171690300024
							],
							[
								-82.42782178799962,
								27.931777483001166
							],
							[
								-82.42710878699977,
								27.93206148400095
							],
							[
								-82.42698464199962,
								27.93210078500074
							],
							[
								-82.42663664199988,
								27.93218378500121
							],
							[
								-82.4265735069998,
								27.93219647300084
							],
							[
								-82.42650962499975,
								27.932204611000447
							],
							[
								-82.42644532499968,
								27.932208156000474
							],
							[
								-82.42638093599986,
								27.932207090000208
							],
							[
								-82.42615193699974,
								27.932195090000636
							],
							[
								-82.4260772149996,
								27.932188038000408
							],
							[
								-82.4260033419997,
								27.932174780000555
							],
							[
								-82.42593083099983,
								27.932155409000995
							],
							[
								-82.42586018799976,
								27.932130059000674
							],
							[
								-82.42538318799981,
								27.931936059000254
							],
							[
								-82.42527233899987,
								27.931881836000475
							],
							[
								-82.4252142269996,
								27.931845258000823
							],
							[
								-82.4247742269997,
								27.931544257000347
							],
							[
								-82.42470392699974,
								27.93149092000046
							],
							[
								-82.42462071799979,
								27.931411496000816
							],
							[
								-82.42446771799983,
								27.93124549600005
							],
							[
								-82.42438386999946,
								27.931139548000164
							],
							[
								-82.42421086899962,
								27.9308835470011
							],
							[
								-82.42418379099979,
								27.93084094900077
							],
							[
								-82.42398647799972,
								27.93051030500006
							],
							[
								-82.42392022099965,
								27.93037152700101
							],
							[
								-82.42378056699964,
								27.930000057001006
							],
							[
								-82.42373833999987,
								27.92984416600099
							],
							[
								-82.42373392099987,
								27.929816611000394
							],
							[
								-82.4236709219998,
								27.92938061100109
							],
							[
								-82.42366171699966,
								27.929260379000556
							],
							[
								-82.4236610969998,
								27.92919383300109
							],
							[
								-82.42349950399966,
								27.92905495400017
							],
							[
								-82.42313912499968,
								27.92877970300022
							],
							[
								-82.42306091799978,
								27.928712535000347
							],
							[
								-82.42208374499975,
								27.92777075200032
							],
							[
								-82.42148436599972,
								27.927250340000246
							],
							[
								-82.42094242299947,
								27.926814963000727
							],
							[
								-82.42058564899979,
								27.926589407000183
							],
							[
								-82.42044222399964,
								27.92650707900101
							],
							[
								-82.42040221799981,
								27.926497987000083
							],
							[
								-82.42033104899953,
								27.92649349900042
							],
							[
								-82.42030041099973,
								27.92649694000097
							],
							[
								-82.42025987599993,
								27.92650886200018
							],
							[
								-82.4201593789997,
								27.926557474000294
							],
							[
								-82.41989381499984,
								27.92672709800083
							],
							[
								-82.41950545799976,
								27.92703011800121
							],
							[
								-82.41947746299967,
								27.927072294000613
							],
							[
								-82.41878178399985,
								27.92866077800024
							],
							[
								-82.41873683599985,
								27.9287496610004
							],
							[
								-82.41864692099988,
								27.92887807300072
							],
							[
								-82.41853607299967,
								27.92898892100119
							],
							[
								-82.4184076609997,
								27.9290788360009
							],
							[
								-82.41827626399959,
								27.92914112300117
							],
							[
								-82.41815992599965,
								27.92918510500108
							],
							[
								-82.4180031659998,
								27.92922766000096
							],
							[
								-82.41784699999961,
								27.9292413220012
							],
							[
								-82.4177569999997,
								27.9292413220012
							],
							[
								-82.41760083399991,
								27.92922766000096
							],
							[
								-82.41744941299973,
								27.929187087000532
							],
							[
								-82.41730733899952,
								27.929120836000113
							],
							[
								-82.41717892699982,
								27.929030921000578
							],
							[
								-82.4170680789998,
								27.928920073001176
							],
							[
								-82.41703089399992,
								27.92887261400036
							],
							[
								-82.41695489399976,
								27.92876861400028
							],
							[
								-82.4169153379996,
								27.928709744001093
							],
							[
								-82.41688054399992,
								27.928647941001042
							],
							[
								-82.41685072899985,
								27.928583588000958
							],
							[
								-82.41682607799986,
								27.928517085000873
							],
							[
								-82.41680674399967,
								27.928448847000556
							],
							[
								-82.41679284699977,
								27.928379298000397
							],
							[
								-82.41678447399987,
								27.928308869000166
							],
							[
								-82.41678167799982,
								27.928238000000608
							],
							[
								-82.41678167799982,
								27.928127000000664
							],
							[
								-82.41678742899977,
								27.92802545700052
							],
							[
								-82.41684078399973,
								27.92755593600084
							],
							[
								-82.41685160799966,
								27.92742217700034
							],
							[
								-82.41679821199976,
								27.927336892000834
							],
							[
								-82.41655791299978,
								27.927363755001192
							],
							[
								-82.41646980899968,
								27.927369245001113
							],
							[
								-82.41603063499986,
								27.927375012000613
							],
							[
								-82.4153354149997,
								27.927531248000395
							],
							[
								-82.41522009599984,
								27.92773570100088
							],
							[
								-82.41512792099977,
								27.92786807400002
							],
							[
								-82.41508769299946,
								27.927912879000264
							],
							[
								-82.41489469199983,
								27.928113878000108
							],
							[
								-82.41482407299985,
								27.928179920000066
							],
							[
								-82.41476792399973,
								27.92822337600082
							],
							[
								-82.41459392399973,
								27.928347376000954
							],
							[
								-82.41452166099953,
								27.928393836000357
							],
							[
								-82.41443595099962,
								27.928437387000674
							],
							[
								-82.41425654999989,
								27.92851678100085
							],
							[
								-82.41421778599987,
								27.928540636000957
							],
							[
								-82.41402940399982,
								27.928656871000005
							],
							[
								-82.41394818599967,
								27.928721658000836
							],
							[
								-82.41391969299946,
								27.92875180300093
							],
							[
								-82.41384332199979,
								27.92897171500012
							],
							[
								-82.41384332199979,
								27.929062814000996
							],
							[
								-82.41387147799946,
								27.929295616000008
							],
							[
								-82.41389359399987,
								27.92938693400028
							],
							[
								-82.41424411599982,
								27.93003531300055
							],
							[
								-82.4142984989998,
								27.9301565520009
							],
							[
								-82.41438149999973,
								27.930385551000217
							],
							[
								-82.41441603199983,
								27.930506732000385
							],
							[
								-82.41446403099972,
								27.93073473100033
							],
							[
								-82.41447465799989,
								27.930795472000472
							],
							[
								-82.41448109799971,
								27.930856798000395
							],
							[
								-82.41448331999982,
								27.93091842200052
							],
							[
								-82.41448131399964,
								27.930980052000468
							],
							[
								-82.4144123149998,
								27.93201105300024
							],
							[
								-82.41440603299972,
								27.93207282100038
							],
							[
								-82.41439157999969,
								27.932193297000044
							],
							[
								-82.41445044299986,
								27.932284415000833
							],
							[
								-82.41448144299974,
								27.932339414000143
							],
							[
								-82.41454308699979,
								27.932473414001105
							],
							[
								-82.41455022699948,
								27.932493790000837
							],
							[
								-82.41461122599992,
								27.932674790000892
							],
							[
								-82.4146460849996,
								27.93281415000088
							],
							[
								-82.41467308499988,
								27.932976150000247
							],
							[
								-82.41468532199983,
								27.93312400000111
							],
							[
								-82.41468532199983,
								27.933402000000132
							],
							[
								-82.41467151199976,
								27.933558996000688
							],
							[
								-82.41463802799966,
								27.93374683900051
							],
							[
								-82.41461051799976,
								27.934092670000794
							],
							[
								-82.41467008599963,
								27.93422041400017
							],
							[
								-82.41470229499963,
								27.93433017600019
							],
							[
								-82.41472529499967,
								27.934432176000104
							],
							[
								-82.41473865699982,
								27.934505459000395
							],
							[
								-82.4147459089995,
								27.934579597000845
							],
							[
								-82.41474699999978,
								27.934654081000435
							],
							[
								-82.4147439999998,
								27.9347660820002
							],
							[
								-82.41473065899959,
								27.934898166000114
							],
							[
								-82.41472156999963,
								27.934943011000893
							],
							[
								-82.41462456999986,
								27.935366010000813
							],
							[
								-82.4146096429997,
								27.93542258900096
							],
							[
								-82.41451865999956,
								27.93572693000012
							],
							[
								-82.41490484199987,
								27.93614394400034
							],
							[
								-82.41493527599981,
								27.936178546000537
							],
							[
								-82.4152492759996,
								27.936554546000384
							],
							[
								-82.41533783499982,
								27.93668133900066
							],
							[
								-82.41534877899947,
								27.936700850000943
							],
							[
								-82.41540977899955,
								27.93681285000044
							],
							[
								-82.41546508599968,
								27.936935413000544
							],
							[
								-82.41548663499951,
								27.93700274100043
							],
							[
								-82.4155146349998,
								27.937103742001238
							],
							[
								-82.41553065499987,
								27.937171662001177
							],
							[
								-82.4155413609996,
								27.93724062100075
							],
							[
								-82.41554668699979,
								27.937310201000646
							],
							[
								-82.41554660199976,
								27.937379985000025
							],
							[
								-82.41554110599985,
								27.937449553000096
							],
							[
								-82.41552810599966,
								27.937559554000938
							],
							[
								-82.41551615999991,
								27.937633829000067
							],
							[
								-82.41549804699966,
								27.9377068470006
							],
							[
								-82.41547389299944,
								27.937778094000368
							],
							[
								-82.4154438689997,
								27.937847073000306
							],
							[
								-82.4154081839996,
								27.937913301000453
							],
							[
								-82.41536708799975,
								27.93797631500105
							],
							[
								-82.41532086799974,
								27.938035672000545
							],
							[
								-82.41521581599976,
								27.938158271000827
							],
							[
								-82.41514923699958,
								27.93822800600118
							],
							[
								-82.41490467799969,
								27.93845808800121
							],
							[
								-82.4147429539997,
								27.938703042000515
							],
							[
								-82.41460626499968,
								27.938950266000365
							],
							[
								-82.41446413799973,
								27.939231980000404
							],
							[
								-82.41450932199983,
								27.939325865000978
							],
							[
								-82.41453832099965,
								27.939399865000173
							],
							[
								-82.41456158199962,
								27.939466891000748
							],
							[
								-82.41457948699951,
								27.939535541000918
							],
							[
								-82.41459192399974,
								27.939605390000747
							],
							[
								-82.41460692499948,
								27.93971438900026
							],
							[
								-82.41461532199945,
								27.93983700000037
							],
							[
								-82.41461532199945,
								27.940101000000897
							],
							[
								-82.41461468599975,
								27.94013482300041
							],
							[
								-82.41460068599984,
								27.94050682300117
							],
							[
								-82.41458765899984,
								27.940629166000367
							],
							[
								-82.41457959799969,
								27.940669475000238
							],
							[
								-82.4145495979999,
								27.9408034750012
							],
							[
								-82.41451708599959,
								27.94091458600089
							],
							[
								-82.41447500099957,
								27.94101193200113
							],
							[
								-82.41441600099967,
								27.94112893200033
							],
							[
								-82.41438126699971,
								27.941191489001152
							],
							[
								-82.41434166999981,
								27.941251087000932
							],
							[
								-82.41429745999972,
								27.941307348000883
							],
							[
								-82.41424891699987,
								27.9413599170007
							],
							[
								-82.41416891699973,
								27.941439917000213
							],
							[
								-82.4141127959998,
								27.941491471000926
							],
							[
								-82.4140525119996,
								27.941538089000876
							],
							[
								-82.41398849799974,
								27.941579436001188
							],
							[
								-82.41392121399984,
								27.941615216000418
							],
							[
								-82.41385114099964,
								27.941645170000765
							],
							[
								-82.41377878499952,
								27.941669084000257
							],
							[
								-82.41295048604405,
								27.941904416268773
							],
							[
								-82.41288375699962,
								27.941923375001135
							],
							[
								-82.41258436499982,
								27.942007670000027
							],
							[
								-82.4118467299998,
								27.9422350540009
							],
							[
								-82.41191266399947,
								27.942241346000532
							],
							[
								-82.41195516299945,
								27.942249350000132
							],
							[
								-82.41202478199988,
								27.9422653880011
							],
							[
								-82.41209290499982,
								27.94228691300084
							],
							[
								-82.41215909899971,
								27.942313789000043
							],
							[
								-82.41222294599974,
								27.942345845000563
							],
							[
								-82.41228404099965,
								27.942382879000785
							],
							[
								-82.41234199599965,
								27.942424655000156
							],
							[
								-82.41239644399946,
								27.942470908001052
							],
							[
								-82.4125099209997,
								27.942583927001078
							],
							[
								-82.41259983599967,
								27.942712339000156
							],
							[
								-82.41260936894575,
								27.942732782364846
							],
							[
								-82.41266608699965,
								27.942854414000987
							],
							[
								-82.41270665999944,
								27.943005834000548
							],
							[
								-82.41272032199969,
								27.943162000000502
							],
							[
								-82.41272032199969,
								27.94323200000061
							],
							[
								-82.41270732599968,
								27.94338433700087
							],
							[
								-82.41268532599973,
								27.943512338000534
							],
							[
								-82.4126561439998,
								27.94363218500077
							],
							[
								-82.41246017399975,
								27.944249319001027
							],
							[
								-82.41244832199992,
								27.94441093100001
							],
							[
								-82.41244832199992,
								27.944812470000464
							],
							[
								-82.41253354199986,
								27.94511940700001
							],
							[
								-82.41255265999949,
								27.945203834000512
							],
							[
								-82.41256524699973,
								27.945316031000647
							],
							[
								-82.4125755689997,
								27.945526894000597
							],
							[
								-82.41290247099992,
								27.947017998000337
							],
							[
								-82.41294942699982,
								27.94711191000029
							],
							[
								-82.41308591599966,
								27.947328276000253
							],
							[
								-82.4131907819999,
								27.947472636000118
							],
							[
								-82.41325280199969,
								27.947539407001113
							],
							[
								-82.41336343199953,
								27.94759424900032
							],
							[
								-82.41342751899985,
								27.94762933100056
							],
							[
								-82.41348854699974,
								27.947669500000774
							],
							[
								-82.41354611299981,
								27.947714490000767
							],
							[
								-82.41359983799963,
								27.947764004000778
							],
							[
								-82.41364936499973,
								27.94781771600078
							],
							[
								-82.41369436899964,
								27.94787527100119
							],
							[
								-82.41376836899973,
								27.947978271000654
							],
							[
								-82.4138168349999,
								27.948053339000825
							],
							[
								-82.41388338599982,
								27.948196312001198
							],
							[
								-82.41476207799978,
								27.9492483090004
							],
							[
								-82.4148513189998,
								27.949376177000676
							],
							[
								-82.41496131899974,
								27.94956717700014
							],
							[
								-82.41502708699986,
								27.949708414001076
							],
							[
								-82.41505289599978,
								27.949791679000064
							],
							[
								-82.41510389599982,
								27.949989678000367
							],
							[
								-82.41512453899985,
								27.950095940000455
							],
							[
								-82.41515353999975,
								27.950314940000812
							],
							[
								-82.41515853999964,
								27.950362307000734
							],
							[
								-82.41518053899976,
								27.950641308000815
							],
							[
								-82.41518070099987,
								27.950780599000172
							],
							[
								-82.41516670199978,
								27.950963599000392
							],
							[
								-82.41515829399981,
								27.951035408000916
							],
							[
								-82.41514414399978,
								27.95110631000092
							],
							[
								-82.41512434499974,
								27.951175846000993
							],
							[
								-82.41509902399977,
								27.95124356700082
							],
							[
								-82.41502502499951,
								27.951419567000993
							],
							[
								-82.41499060599959,
								27.951492167000783
							],
							[
								-82.41494984599977,
								27.95156140500065
							],
							[
								-82.41490306799982,
								27.95162673000046
							],
							[
								-82.41485064699974,
								27.951687618000523
							],
							[
								-82.41467503299968,
								27.951874063000407
							],
							[
								-82.41453368999963,
								27.95208552600094
							],
							[
								-82.41455571299967,
								27.95210475900031
							],
							[
								-82.41464166299986,
								27.952179890000043
							],
							[
								-82.41500743799983,
								27.952404024001183
							],
							[
								-82.41530893899983,
								27.95254854500026
							],
							[
								-82.41588508699954,
								27.952790907000594
							],
							[
								-82.41635917699976,
								27.9528998190009
							],
							[
								-82.41673283999978,
								27.952940839001098
							],
							[
								-82.41676046799975,
								27.95287158300052
							],
							[
								-82.41679376799975,
								27.95280486800006
							],
							[
								-82.41683250799986,
								27.952741158001185
							],
							[
								-82.41687641899975,
								27.952680896000818
							],
							[
								-82.41692519599961,
								27.95262450000077
							],
							[
								-82.41697849899985,
								27.9525723610001
							],
							[
								-82.4170359599999,
								27.95252484300114
							],
							[
								-82.4170971779998,
								27.95248227500117
							],
							[
								-82.41722917799972,
								27.952398276000526
							],
							[
								-82.41729074299984,
								27.95236244100103
							],
							[
								-82.41735495099965,
								27.95233159300007
							],
							[
								-82.41742139999972,
								27.952305924001234
							],
							[
								-82.41748967299951,
								27.95228559600044
							],
							[
								-82.41755933999977,
								27.952270737000013
							],
							[
								-82.41774376199976,
								27.952239706000018
							],
							[
								-82.41787441099981,
								27.95220569100049
							],
							[
								-82.4179448349996,
								27.95219034100082
							],
							[
								-82.41807499599963,
								27.952177054000874
							],
							[
								-82.41831699599976,
								27.952170054000828
							],
							[
								-82.4184297519995,
								27.952173872000078
							],
							[
								-82.41855071199981,
								27.95218559500025
							],
							[
								-82.41858291399957,
								27.952065414000874
							],
							[
								-82.41864404799946,
								27.951932319000786
							],
							[
								-82.41872790099983,
								27.951783149000523
							],
							[
								-82.41840282399993,
								27.951721648000852
							],
							[
								-82.41826241399968,
								27.951683087000237
							],
							[
								-82.41822544499973,
								27.951668700000557
							],
							[
								-82.41804944499982,
								27.951595700000734
							],
							[
								-82.41797880899958,
								27.951562745000405
							],
							[
								-82.41791129199984,
								27.951523797000913
							],
							[
								-82.41784740099989,
								27.951479150001216
							],
							[
								-82.41778761599966,
								27.95142913700001
							],
							[
								-82.41764920899992,
								27.951302766000833
							],
							[
								-82.41755644699981,
								27.95122897800077
							],
							[
								-82.41747645699967,
								27.951196982000074
							],
							[
								-82.41670219199982,
								27.950924230000243
							],
							[
								-82.41656853299968,
								27.950864513000187
							],
							[
								-82.41611453199987,
								27.95061551200099
							],
							[
								-82.41604881599993,
								27.950575727000807
							],
							[
								-82.41598673399959,
								27.950530479000083
							],
							[
								-82.41592874099977,
								27.950480097000888
							],
							[
								-82.41587525899979,
								27.950424950000144
							],
							[
								-82.41564025899979,
								27.95016095000086
							],
							[
								-82.41560005899976,
								27.950112472000757
							],
							[
								-82.41556334999983,
								27.95006130000043
							],
							[
								-82.41553031299985,
								27.95000768400026
							],
							[
								-82.41550110799983,
								27.949951888000793
							],
							[
								-82.41509010799983,
								27.949094888000406
							],
							[
								-82.41506580399987,
								27.949039508000975
							],
							[
								-82.4148318039996,
								27.948453508000807
							],
							[
								-82.41480745999989,
								27.94838451900087
							],
							[
								-82.4147888039996,
								27.94831378000079
							],
							[
								-82.41477595899987,
								27.948241758000698
							],
							[
								-82.41473195899988,
								27.94791975700061
							],
							[
								-82.41472497499964,
								27.947846280000835
							],
							[
								-82.41470997499965,
								27.94756728100022
							],
							[
								-82.41471148799951,
								27.947447966000386
							],
							[
								-82.41473726099977,
								27.947122686000473
							],
							[
								-82.41470915599967,
								27.944723048000878
							],
							[
								-82.4146783159997,
								27.94438381100061
							],
							[
								-82.41456729599983,
								27.944063592000493
							],
							[
								-82.41453495699965,
								27.94394444700085
							],
							[
								-82.41446195799982,
								27.94357744700086
							],
							[
								-82.41445096099972,
								27.943508119000807
							],
							[
								-82.4144454039997,
								27.943438144000613
							],
							[
								-82.41444532299987,
								27.943367949000578
							],
							[
								-82.41445071599978,
								27.94329796200056
							],
							[
								-82.4144797159996,
								27.94304896100012
							],
							[
								-82.41448889499974,
								27.94298826100096
							],
							[
								-82.41451889499965,
								27.94282726200034
							],
							[
								-82.41455791399977,
								27.942684414001132
							],
							[
								-82.41462416399975,
								27.9425423390003
							],
							[
								-82.41471407899972,
								27.942413927001226
							],
							[
								-82.41482492699993,
								27.94230308000102
							],
							[
								-82.41492669399973,
								27.942229168000058
							],
							[
								-82.41513169499973,
								27.94210116800084
							],
							[
								-82.41519038199989,
								27.942067523000805
							],
							[
								-82.41525143199986,
								27.942038386000792
							],
							[
								-82.41531449899959,
								27.942013919000278
							],
							[
								-82.41537922699978,
								27.94199426200034
							],
							[
								-82.41544524999982,
								27.941979527000807
							],
							[
								-82.41551219399967,
								27.94196979600027
							],
							[
								-82.41612819299984,
								27.941903796000492
							],
							[
								-82.41624212999977,
								27.941898861001064
							],
							[
								-82.41755587399985,
								27.941925351000766
							],
							[
								-82.41800262999968,
								27.941909261000678
							],
							[
								-82.41806116699972,
								27.941909059000483
							],
							[
								-82.41863942499978,
								27.94192589100046
							],
							[
								-82.41959767299976,
								27.94194153600042
							],
							[
								-82.42036367999964,
								27.941926770000084
							],
							[
								-82.42057972599957,
								27.941899422000308
							],
							[
								-82.42064775099969,
								27.941869189000737
							],
							[
								-82.42072232799964,
								27.941839948000183
							],
							[
								-82.42079921099979,
								27.94181745900001
							],
							[
								-82.42087779099971,
								27.94180190000112
							],
							[
								-82.42131178999965,
								27.9417359000001
							],
							[
								-82.42144699999965,
								27.941725678000143
							],
							[
								-82.42158251399967,
								27.941735946000637
							],
							[
								-82.42201551399988,
								27.941801947000858
							],
							[
								-82.42208930299977,
								27.94181637300081
							],
							[
								-82.42216162899989,
								27.94183691300073
							],
							[
								-82.42223198599967,
								27.941863422000175
							],
							[
								-82.42229988399978,
								27.9418957150008
							],
							[
								-82.4223648459995,
								27.941933567000735
							],
							[
								-82.42270384599964,
								27.94215056700075
							],
							[
								-82.42279707299963,
								27.942219079000733
							],
							[
								-82.42289892499979,
								27.942319373000505
							],
							[
								-82.42314842299992,
								27.942607649000553
							],
							[
								-82.42324283599973,
								27.942741339000424
							],
							[
								-82.42329140799949,
								27.942838613000124
							],
							[
								-82.42351840799971,
								27.94337161300088
							],
							[
								-82.42354246499984,
								27.943434537000048
							],
							[
								-82.42356174299948,
								27.94349908400086
							],
							[
								-82.4235761359996,
								27.943564893001064
							],
							[
								-82.42358556299968,
								27.943631596000632
							],
							[
								-82.4235899699995,
								27.943698816000865
							],
							[
								-82.42358933299963,
								27.94376617800022
							],
							[
								-82.42351451199974,
								27.94535973900089
							],
							[
								-82.42354749699972,
								27.94594415600013
							],
							[
								-82.4236999039998,
								27.946687896000203
							],
							[
								-82.42433515599951,
								27.946704976000728
							],
							[
								-82.42444322399967,
								27.946714303001055
							],
							[
								-82.42478222499965,
								27.94676430400013
							],
							[
								-82.42485525299975,
								27.946778180000212
							],
							[
								-82.42500913899968,
								27.946811032000443
							],
							[
								-82.4255418409998,
								27.94673303100065
							],
							[
								-82.42557481799969,
								27.946680011000883
							],
							[
								-82.42561181899964,
								27.946625011001128
							],
							[
								-82.4256564869996,
								27.946564275000544
							],
							[
								-82.42570608599954,
								27.94650749400002
							],
							[
								-82.42576026699975,
								27.946455067000745
							],
							[
								-82.42581864899988,
								27.94640736200115
							],
							[
								-82.42588082099978,
								27.946364714001174
							],
							[
								-82.42594634699978,
								27.946327425001197
							],
							[
								-82.42601476499976,
								27.946295754001152
							],
							[
								-82.42652576499994,
								27.946084754000214
							],
							[
								-82.4266743879998,
								27.946037988000075
							],
							[
								-82.42725011699983,
								27.945910377000263
							],
							[
								-82.4273238759998,
								27.945892919000773
							],
							[
								-82.42745513799956,
								27.945831904000965
							],
							[
								-82.4277904849996,
								27.94563441400079
							],
							[
								-82.42785129499974,
								27.945601950000945
							],
							[
								-82.42791441399964,
								27.945574243000873
							],
							[
								-82.4279794709996,
								27.94555145500023
							],
							[
								-82.4280460839996,
								27.945533722000807
							],
							[
								-82.42811385999981,
								27.94552114700021
							],
							[
								-82.4281824009996,
								27.945513804000047
							],
							[
								-82.42825130299944,
								27.94551173700121
							],
							[
								-82.42830029899959,
								27.945512473000026
							],
							[
								-82.42832791299983,
								27.945409414000114
							],
							[
								-82.42839416399981,
								27.945267339000527
							],
							[
								-82.42848407899952,
								27.945138927000205
							],
							[
								-82.4285949269998,
								27.945028079000803
							],
							[
								-82.42872333899969,
								27.944938164000025
							],
							[
								-82.42886541299963,
								27.94487191400005
							],
							[
								-82.42901683399974,
								27.944831341000867
							],
							[
								-82.42917299999986,
								27.94481767800018
							],
							[
								-82.42927399999978,
								27.94481767800018
							],
							[
								-82.42934935199979,
								27.944820429001208
							],
							[
								-82.42942417799986,
								27.94482973600118
							],
							[
								-82.42949790699991,
								27.94484553000071
							],
							[
								-82.42956997999975,
								27.944867689000677
							],
							[
								-82.42963984699985,
								27.944896046000807
							],
							[
								-82.42970697599964,
								27.944930384000447
							],
							[
								-82.42991063299961,
								27.9446106060001
							],
							[
								-82.43030561999979,
								27.943950137000076
							],
							[
								-82.43103611899964,
								27.94277977300023
							],
							[
								-82.4310838699996,
								27.942710684000996
							],
							[
								-82.43129306499986,
								27.942436345001123
							],
							[
								-82.43163900399979,
								27.941911242000753
							],
							[
								-82.43168368699985,
								27.941849312001136
							],
							[
								-82.43193668699982,
								27.9415283110006
							],
							[
								-82.43201954999967,
								27.941436856000582
							],
							[
								-82.43219645499983,
								27.941266691001157
							],
							[
								-82.43225115699964,
								27.941202112000344
							],
							[
								-82.4325580679998,
								27.940638130000043
							],
							[
								-82.43262747699968,
								27.940529830001207
							],
							[
								-82.43279420999963,
								27.940306601001122
							],
							[
								-82.43313071899968,
								27.93942228600123
							],
							[
								-82.43361730599979,
								27.937990542000893
							],
							[
								-82.4336110479998,
								27.937887619000282
							],
							[
								-82.43358495599986,
								27.93775655700081
							],
							[
								-82.43350043999962,
								27.93742980800086
							],
							[
								-82.43328197599975,
								27.936965777001102
							],
							[
								-82.4331043369998,
								27.93664117800098
							],
							[
								-82.43291061199976,
								27.936440975000846
							],
							[
								-82.43254782899984,
								27.936171193000195
							],
							[
								-82.43212957899979,
								27.935880363001
							],
							[
								-82.43207238299986,
								27.93583710900062
							],
							[
								-82.43201881499986,
								27.935789436001027
							],
							[
								-82.43196921599984,
								27.935737647000916
							],
							[
								-82.43192389999983,
								27.935682070000848
							],
							[
								-82.43188315699983,
								27.93562306000076
							],
							[
								-82.43184724399961,
								27.93556099100069
							],
							[
								-82.43181639099964,
								27.93549625800075
							],
							[
								-82.43176539199986,
								27.93537725800032
							],
							[
								-82.4317394449995,
								27.93530923300064
							],
							[
								-82.43171908499994,
								27.935239333000897
							],
							[
								-82.43170444699962,
								27.935168014000414
							],
							[
								-82.43169562499968,
								27.93509574500003
							],
							[
								-82.43169267799952,
								27.935023000001205
							],
							[
								-82.43169267799952,
								27.934926000000996
							],
							[
								-82.43170634099985,
								27.93476983400104
							],
							[
								-82.43174038599966,
								27.934624062000882
							],
							[
								-82.43169052999961,
								27.93456797000086
							],
							[
								-82.4316455229998,
								27.934507919000243
							],
							[
								-82.43160567799953,
								27.934444325000488
							],
							[
								-82.4315712709997,
								27.934377632001098
							],
							[
								-82.43154254299962,
								27.93430830300078
							],
							[
								-82.43151969299969,
								27.934236821000376
							],
							[
								-82.43150269299962,
								27.93417482100075
							],
							[
								-82.43148433999987,
								27.934093166000835
							],
							[
								-82.43147067799963,
								27.933937000000878
							],
							[
								-82.43148433999987,
								27.933780835000128
							],
							[
								-82.43149117813856,
								27.933755314634215
							],
							[
								-82.43152491299986,
								27.933629414000297
							],
							[
								-82.43156562999967,
								27.933534794001176
							],
							[
								-82.43158263099984,
								27.9335007940012
							],
							[
								-82.43160816499982,
								27.93345333900074
							],
							[
								-82.43169807999979,
								27.933324927000417
							],
							[
								-82.43180892699974,
								27.933214080000216
							],
							[
								-82.43193733899987,
								27.93312416500068
							],
							[
								-82.43208196099977,
								27.933056996000364
							],
							[
								-82.43209850799963,
								27.933051077000318
							],
							[
								-82.43213623499946,
								27.933038536000613
							],
							[
								-82.43234723499977,
								27.932973535001008
							],
							[
								-82.4324558339997,
								27.932947341000794
							],
							[
								-82.43255693299953,
								27.93293536500069
							],
							[
								-82.43271993299979,
								27.93292536600031
							],
							[
								-82.43286448599984,
								27.932928141000804
							],
							[
								-82.43289140699977,
								27.932930833001205
							],
							[
								-82.43293841399984,
								27.932908914000013
							],
							[
								-82.43296874899985,
								27.932898481000127
							],
							[
								-82.43307674899982,
								27.932863481000783
							],
							[
								-82.43319783399963,
								27.932833341000066
							],
							[
								-82.43334262499963,
								27.932820673000794
							],
							[
								-82.43335467799982,
								27.932057896000476
							],
							[
								-82.43335467799982,
								27.93090354500062
							],
							[
								-82.43218406999978,
								27.92992787700054
							],
							[
								-82.43213192999973,
								27.92988069000081
							],
							[
								-82.43208363699955,
								27.9298295740012
							],
							[
								-82.4320394859999,
								27.929774841000846
							],
							[
								-82.43199974599962,
								27.929716825000487
							],
							[
								-82.43196466099965,
								27.92965588200015
							],
							[
								-82.4319344449999,
								27.929592383001204
							],
							[
								-82.43190928299987,
								27.92952671800101
							],
							[
								-82.4318892819998,
								27.929467718001103
							],
							[
								-82.43187709599987,
								27.929420127001162
							],
							[
								-82.43161326399962,
								27.929194127000937
							],
							[
								-82.4304849399997,
								27.928274227000674
							],
							[
								-82.42939012899944,
								27.927350748000737
							],
							[
								-82.42852882499994,
								27.92669423800113
							],
							[
								-82.42849592699962,
								27.926667921000462
							],
							[
								-82.4283834079998,
								27.926555070000983
							],
							[
								-82.42831373699981,
								27.926471067001227
							],
							[
								-82.42826881399974,
								27.926412108001056
							],
							[
								-82.42822889799963,
								27.926349651000596
							],
							[
								-82.42819426199979,
								27.926284119001036
							],
							[
								-82.42816513899969,
								27.92621595600117
							],
							[
								-82.42814172899989,
								27.9261456280005
							],
							[
								-82.42812072899947,
								27.926072628000856
							],
							[
								-82.42809934099975,
								27.925980166001022
							],
							[
								-82.42808578399979,
								27.925837794000433
							],
							[
								-82.4280697309997,
								27.924787897000517
							],
							[
								-82.4280696779997,
								27.92454451200054
							],
							[
								-82.42804207799972,
								27.924516911000655
							],
							[
								-82.4279912109996,
								27.924461603000697
							],
							[
								-82.4279451379997,
								27.92440224200085
							],
							[
								-82.42790418199976,
								27.924339241000343
							],
							[
								-82.42786862799994,
								27.924273042000284
							],
							[
								-82.42780662799969,
								27.924145042000884
							],
							[
								-82.42777679499972,
								27.924076287000968
							],
							[
								-82.42775278999977,
								27.924005287000245
							],
							[
								-82.42773478099978,
								27.923932535001153
							],
							[
								-82.42772289199978,
								27.92385853600116
							],
							[
								-82.42771720599967,
								27.923783804001015
							],
							[
								-82.42768920499975,
								27.922966804000918
							],
							[
								-82.42768901099973,
								27.922911537000875
							],
							[
								-82.42770101099984,
								27.92247053600018
							],
							[
								-82.4277143409996,
								27.92233883400083
							],
							[
								-82.42772815099985,
								27.922274410000472
							],
							[
								-82.42777015199987,
								27.92210841100122
							],
							[
								-82.42779810999978,
								27.922025350000826
							],
							[
								-82.42781083699968,
								27.921939899000243
							],
							[
								-82.42782415099963,
								27.92152981700077
							],
							[
								-82.42783733999974,
								27.921402834000126
							],
							[
								-82.42788152999985,
								27.921243658000453
							],
							[
								-82.42790162899982,
								27.92011764000019
							],
							[
								-82.42788469999975,
								27.917788296000726
							],
							[
								-82.4278747039999,
								27.91629625400073
							],
							[
								-82.42788259499967,
								27.915350107000695
							],
							[
								-82.42785889499976,
								27.91427176000038
							],
							[
								-82.42785871999965,
								27.914243317000246
							],
							[
								-82.42786763099967,
								27.913320525001165
							],
							[
								-82.42785773099983,
								27.91240573200106
							],
							[
								-82.42785773599984,
								27.91238580600101
							],
							[
								-82.42786273499972,
								27.911944806000758
							],
							[
								-82.42787633999977,
								27.911798835000315
							],
							[
								-82.42791691299976,
								27.911647414000488
							],
							[
								-82.42798316399964,
								27.9115053390009
							],
							[
								-82.42807307899972,
								27.911376927000582
							],
							[
								-82.42815494599982,
								27.91129147500079
							],
							[
								-82.4282019469998,
								27.911248475000786
							],
							[
								-82.42823092699972,
								27.911223080000372
							],
							[
								-82.4283593389996,
								27.911133165000837
							],
							[
								-82.4285014139998,
								27.91106691400042
							],
							[
								-82.4286528339998,
								27.911026341001058
							],
							[
								-82.42873054099994,
								27.91101954200094
							],
							[
								-82.42875407899975,
								27.9109859270002
							],
							[
								-82.42884214099966,
								27.910894860000575
							],
							[
								-82.42889114199963,
								27.910850860001016
							],
							[
								-82.42891665199987,
								27.91082917100091
							],
							[
								-82.42894423399967,
								27.91076417200095
							],
							[
								-82.42897710999964,
								27.91070168200004
							],
							[
								-82.42901505299993,
								27.910642133000714
							],
							[
								-82.42905780199975,
								27.9105859350005
							],
							[
								-82.42910506299984,
								27.910533475000783
							],
							[
								-82.4291229139997,
								27.910476414000765
							],
							[
								-82.4291763359996,
								27.910357330001215
							],
							[
								-82.42925933499963,
								27.91020332900082
							],
							[
								-82.42929811999964,
								27.910138682000888
							],
							[
								-82.4293418299997,
								27.910077258000246
							],
							[
								-82.4293902009998,
								27.910019433000706
							],
							[
								-82.42944293699972,
								27.909965558000597
							],
							[
								-82.42946256799983,
								27.909887643000634
							],
							[
								-82.42948907399955,
								27.909811791000397
							],
							[
								-82.4295222419997,
								27.909738606000825
							],
							[
								-82.4295618079996,
								27.909668672000368
							],
							[
								-82.42960745599974,
								27.90960254800076
							],
							[
								-82.42965882199974,
								27.909540761000887
							],
							[
								-82.42971549699972,
								27.909483803001148
							],
							[
								-82.42976571199969,
								27.90943765900035
							],
							[
								-82.43001032199986,
								27.909112229000602
							],
							[
								-82.4301094329998,
								27.908916208000637
							],
							[
								-82.43014219699975,
								27.90885704400036
							],
							[
								-82.43017931499945,
								27.908800509000923
							],
							[
								-82.43022057599975,
								27.90874692300004
							],
							[
								-82.43026574799977,
								27.90869658900085
							],
							[
								-82.43035574799967,
								27.908603589000972
							],
							[
								-82.43044019699981,
								27.908526748000742
							],
							[
								-82.43055358999969,
								27.908436034000164
							],
							[
								-82.4306752259998,
								27.90831596700027
							],
							[
								-82.43077312399974,
								27.90823229000036
							],
							[
								-82.43083412399982,
								27.90818729000019
							],
							[
								-82.43091833899949,
								27.908132165000513
							],
							[
								-82.43100277699982,
								27.908088457000098
							],
							[
								-82.4310541719999,
								27.908007518001124
							],
							[
								-82.43109017199986,
								27.90795751800001
							],
							[
								-82.43113362999972,
								27.9079019000002
							],
							[
								-82.43118131599977,
								27.907849862000337
							],
							[
								-82.43123293599977,
								27.907801725000883
							],
							[
								-82.43128817199981,
								27.907757783000267
							],
							[
								-82.43133317099971,
								27.907724783000912
							],
							[
								-82.43135782699972,
								27.90770869400003
							],
							[
								-82.43140964499992,
								27.907636862000476
							],
							[
								-82.43143781499984,
								27.907599866001146
							],
							[
								-82.43191729690567,
								27.907002840879894
							],
							[
								-82.43535799999992,
								27.90431300000026
							],
							[
								-82.43666585777427,
								27.903461996653892
							],
							[
								-82.43670396999966,
								27.903481491001184
							],
							[
								-82.43677187499985,
								27.903524264000016
							],
							[
								-82.43683569299981,
								27.903572924000134
							],
							[
								-82.43689491699973,
								27.90362708300115
							],
							[
								-82.43693891699972,
								27.903671084000973
							],
							[
								-82.43703749599989,
								27.903788063000796
							],
							[
								-82.43716749599947,
								27.903972062001184
							],
							[
								-82.43721183599983,
								27.90404133900008
							],
							[
								-82.43725327099962,
								27.904122305000737
							],
							[
								-82.43735926099968,
								27.90435811300053
							],
							[
								-82.43759806499973,
								27.904750180000196
							],
							[
								-82.43762995199988,
								27.904807078000108
							],
							[
								-82.43786610899961,
								27.905266811000576
							],
							[
								-82.4393206899998,
								27.90785085400042
							],
							[
								-82.43934273499984,
								27.907892537000762
							],
							[
								-82.43950874999973,
								27.908227396000843
							],
							[
								-82.4402589929998,
								27.909567883001
							],
							[
								-82.44035378199975,
								27.90972401400104
							],
							[
								-82.4404208669997,
								27.909835635001127
							],
							[
								-82.44050819699973,
								27.909921414001033
							],
							[
								-82.44056692099981,
								27.90998492700051
							],
							[
								-82.44065060899979,
								27.910102723000666
							],
							[
								-82.44070972299971,
								27.910202031
							],
							[
								-82.44077934499961,
								27.9103501240008
							],
							[
								-82.44084840599963,
								27.910540863000858
							],
							[
								-82.44087689499969,
								27.910584088000082
							],
							[
								-82.44090163799977,
								27.910623844000177
							],
							[
								-82.44153363699967,
								27.911700844000467
							],
							[
								-82.44155326599979,
								27.911736081001163
							],
							[
								-82.44173205299965,
								27.912074679000757
							],
							[
								-82.44205272499981,
								27.91268049900079
							],
							[
								-82.44236022199976,
								27.913234914000743
							],
							[
								-82.44242267099969,
								27.91332373000081
							],
							[
								-82.4424658359997,
								27.91339133900063
							],
							[
								-82.44251178399969,
								27.9134825160008
							],
							[
								-82.44260203899987,
								27.913690169000308
							],
							[
								-82.44297436799977,
								27.914182631000376
							],
							[
								-82.44304978399961,
								27.914300412999996
							],
							[
								-82.44316504999982,
								27.91451563700004
							],
							[
								-82.44324873499964,
								27.91465162500028
							],
							[
								-82.44333507299977,
								27.91471207900084
							],
							[
								-82.44343134199947,
								27.914805985000793
							],
							[
								-82.44347634199964,
								27.91485698500022
							],
							[
								-82.44356666399948,
								27.914978641000868
							],
							[
								-82.44361866399979,
								27.91506264100089
							],
							[
								-82.4436571799996,
								27.91513142300001
							],
							[
								-82.44368952399961,
								27.915203314000188
							],
							[
								-82.44371544799981,
								27.915277761000215
							],
							[
								-82.44373475299972,
								27.91535419200041
							],
							[
								-82.44376946499965,
								27.915522354000824
							],
							[
								-82.44383662199971,
								27.915631389000698
							],
							[
								-82.44387461699965,
								27.915665075000465
							],
							[
								-82.44395862699967,
								27.915750185000224
							],
							[
								-82.44439562699976,
								27.91625618500088
							],
							[
								-82.44446408699966,
								27.916346357000883
							],
							[
								-82.44455908699945,
								27.916489357000632
							],
							[
								-82.44461437799977,
								27.916584811000536
							],
							[
								-82.44464537799965,
								27.916646811001225
							],
							[
								-82.44468608599965,
								27.91674141300088
							],
							[
								-82.44471510099947,
								27.91683751400093
							],
							[
								-82.44473010199964,
								27.91689951400055
							],
							[
								-82.44473698099976,
								27.916930298000256
							],
							[
								-82.44474497999981,
								27.916969298001174
							],
							[
								-82.4447554699996,
								27.917031418000096
							],
							[
								-82.44476158399958,
								27.917094119000932
							],
							[
								-82.44476329399964,
								27.917157095000636
							],
							[
								-82.44476059099986,
								27.91722003600025
							],
							[
								-82.44475559099962,
								27.917284037000304
							],
							[
								-82.4447476389995,
								27.917352205000793
							],
							[
								-82.44473451199983,
								27.917419569001037
							],
							[
								-82.44471628699965,
								27.917485736001094
							],
							[
								-82.44469306799986,
								27.91755032000022
							],
							[
								-82.44466806799993,
								27.91761232000091
							],
							[
								-82.44463643799963,
								27.917682047000728
							],
							[
								-82.44459899099989,
								27.91774883100057
							],
							[
								-82.44455599999962,
								27.917812187001015
							],
							[
								-82.44450777499945,
								27.917871657000784
							],
							[
								-82.44438577499976,
								27.918009657000834
							],
							[
								-82.44436894699969,
								27.918028167000234
							],
							[
								-82.44349294099969,
								27.918965191000847
							],
							[
								-82.44421060699983,
								27.91853413000009
							],
							[
								-82.44435941399962,
								27.91846391400067
							],
							[
								-82.44441992499992,
								27.91844428400118
							],
							[
								-82.4444549249997,
								27.91843428400053
							],
							[
								-82.44454583399977,
								27.91841334100066
							],
							[
								-82.44470199999972,
								27.91839967800122
							],
							[
								-82.44485816499967,
								27.91841334100066
							],
							[
								-82.44500958599967,
								27.918453914001088
							],
							[
								-82.44515166099971,
								27.918520164001063
							],
							[
								-82.44525153499988,
								27.91858710700065
							],
							[
								-82.44529270699965,
								27.918618890000705
							],
							[
								-82.4453673529997,
								27.918671388000256
							],
							[
								-82.44542807299966,
								27.91871808000021
							],
							[
								-82.44549151999968,
								27.918776736000797
							],
							[
								-82.44554751999986,
								27.91883373600054
							],
							[
								-82.44559481099951,
								27.91888579600023
							],
							[
								-82.4456378889997,
								27.918941393000654
							],
							[
								-82.44567649099979,
								27.91900018600081
							],
							[
								-82.44571038099984,
								27.91906181600076
							],
							[
								-82.44573937699975,
								27.919119811000673
							],
							[
								-82.44576237499962,
								27.919165804001192
							],
							[
								-82.44581533499974,
								27.919296419000897
							],
							[
								-82.44582390299973,
								27.919323468000204
							],
							[
								-82.44591563299969,
								27.919452844000784
							],
							[
								-82.44593171999986,
								27.919476311000683
							],
							[
								-82.44598557899978,
								27.919557607000304
							],
							[
								-82.44607744299975,
								27.919647850000576
							],
							[
								-82.44617026499961,
								27.9197331950008
							],
							[
								-82.44628122399955,
								27.91983876900083
							],
							[
								-82.4463290249996,
								27.919887902000898
							],
							[
								-82.44637294499977,
								27.91994053300108
							],
							[
								-82.44641272799969,
								27.91999635600099
							],
							[
								-82.44644814399987,
								27.920055048000695
							],
							[
								-82.44647898699984,
								27.920116266000786
							],
							[
								-82.4465319869996,
								27.920232266000617
							],
							[
								-82.44655908599962,
								27.920298414000758
							],
							[
								-82.4465932379997,
								27.920417004000978
							],
							[
								-82.44661623799948,
								27.920524005001038
							],
							[
								-82.44663523299981,
								27.92066876700058
							],
							[
								-82.44663792099976,
								27.920723346000745
							],
							[
								-82.44670583599951,
								27.920820339000688
							],
							[
								-82.44672992699974,
								27.920864920000735
							],
							[
								-82.44678592599985,
								27.92097592000086
							],
							[
								-82.44682808699969,
								27.921073413001025
							],
							[
								-82.44684510099975,
								27.921124948000756
							],
							[
								-82.44698410099953,
								27.92159294800093
							],
							[
								-82.44700765999971,
								27.921692834001202
							],
							[
								-82.44701753299955,
								27.92176652400055
							],
							[
								-82.44702453199986,
								27.921842525000176
							],
							[
								-82.44702605799954,
								27.921988772000997
							],
							[
								-82.44700281099948,
								27.922322060000862
							],
							[
								-82.44708772099976,
								27.922725602000146
							],
							[
								-82.4472727459997,
								27.9230073830001
							],
							[
								-82.44729983599973,
								27.923051339001074
							],
							[
								-82.4473660859997,
								27.92319341400084
							],
							[
								-82.4474066589995,
								27.923344835000666
							],
							[
								-82.44742032199983,
								27.923501000000176
							],
							[
								-82.44740884899986,
								27.9236441950011
							],
							[
								-82.44739775399965,
								27.923712681000904
							],
							[
								-82.44738171099992,
								27.923787984000473
							],
							[
								-82.44735928199985,
								27.92386163800071
							],
							[
								-82.44733063399978,
								27.923933103000667
							],
							[
								-82.44729597599967,
								27.92400185500067
							],
							[
								-82.44725556199988,
								27.924067389000765
							],
							[
								-82.44723452299957,
								27.924098440001114
							],
							[
								-82.44728085699967,
								27.92415393900082
							],
							[
								-82.44732236399963,
								27.924213135000922
							],
							[
								-82.44735875099944,
								27.924275609000762
							],
							[
								-82.44738975899979,
								27.924340919000837
							],
							[
								-82.44741516999976,
								27.92440860400031
							],
							[
								-82.44744216999969,
								27.924489603000172
							],
							[
								-82.44747465999988,
								27.924617834000923
							],
							[
								-82.44748832199978,
								27.924774000000877
							],
							[
								-82.44747511673188,
								27.924924944273602
							],
							[
								-82.44747465999988,
								27.924930165000564
							],
							[
								-82.4474340869999,
								27.925081586000392
							],
							[
								-82.44740526499992,
								27.9251433930008
							],
							[
								-82.4474240859997,
								27.92519041300007
							],
							[
								-82.44746465899986,
								27.92534183400114
							],
							[
								-82.44747832199992,
								27.9254980000011
							],
							[
								-82.44746465899986,
								27.925654165000783
							],
							[
								-82.44745455999976,
								27.92569198400027
							],
							[
								-82.44746408599973,
								27.925712414000895
							],
							[
								-82.44747855299985,
								27.92575552200073
							],
							[
								-82.44751855299988,
								27.925885521000918
							],
							[
								-82.44753794499962,
								27.9259596430003
							],
							[
								-82.44755095799972,
								27.92603514600042
							],
							[
								-82.44755749699982,
								27.926111483000074
							],
							[
								-82.44755751499973,
								27.926188100000466
							],
							[
								-82.4475335139997,
								27.9267541000004
							],
							[
								-82.44753172399963,
								27.926784305000147
							],
							[
								-82.4474927239998,
								27.927296305001118
							],
							[
								-82.4474681539998,
								27.927447377000828
							],
							[
								-82.44738615399976,
								27.9277733770008
							],
							[
								-82.44735908599965,
								27.927861586000194
							],
							[
								-82.44730454999976,
								27.927982731000007
							],
							[
								-82.44716563499945,
								27.928238881000947
							],
							[
								-82.44712868799978,
								27.928343912000134
							],
							[
								-82.44707821499968,
								27.928680158000777
							],
							[
								-82.44706266699981,
								27.929087318000892
							],
							[
								-82.4470580989997,
								27.92914978400002
							],
							[
								-82.44703709899974,
								27.92934378400044
							],
							[
								-82.44702865899976,
								27.929403165000473
							],
							[
								-82.4470042849997,
								27.9295057800007
							],
							[
								-82.44687967799977,
								27.929920504001085
							],
							[
								-82.44682711499978,
								27.930133008000904
							],
							[
								-82.44682346499984,
								27.930160818000008
							],
							[
								-82.44682604099987,
								27.930209017
							],
							[
								-82.44682731599971,
								27.93026015400041
							],
							[
								-82.44682431699981,
								27.931115155001077
							],
							[
								-82.44682190599961,
								27.931177887000405
							],
							[
								-82.4467639119997,
								27.931967339
							],
							[
								-82.44677632599983,
								27.932224928000796
							],
							[
								-82.44679728399989,
								27.93229892100079
							],
							[
								-82.44681076199959,
								27.932352803001162
							],
							[
								-82.44686276299988,
								27.93259180300051
							],
							[
								-82.44687504399984,
								27.932661250000837
							],
							[
								-82.44688184399978,
								27.93273144600114
							],
							[
								-82.44688312199979,
								27.932801958000045
							],
							[
								-82.44687886999962,
								27.932872354001073
							],
							[
								-82.4468691139998,
								27.93294220100019
							],
							[
								-82.44682656799982,
								27.933174236000827
							],
							[
								-82.44678561899991,
								27.933323561000485
							],
							[
								-82.44664300099973,
								27.93370425800045
							],
							[
								-82.44623459899978,
								27.934880891000727
							],
							[
								-82.44620821599982,
								27.934948071000427
							],
							[
								-82.44580988599955,
								27.93585372700075
							],
							[
								-82.44518203599982,
								27.937363215000595
							],
							[
								-82.44521865899975,
								27.937507835000833
							],
							[
								-82.4452305699996,
								27.937607899000586
							],
							[
								-82.44523456999991,
								27.937671898000996
							],
							[
								-82.44523578799983,
								27.93771088900058
							],
							[
								-82.44491196199986,
								27.938317145000116
							],
							[
								-82.44473161399986,
								27.938806663000296
							],
							[
								-82.44463834099977,
								27.939480166000692
							],
							[
								-82.44463520799978,
								27.939444358000923
							],
							[
								-82.44461557099984,
								27.939485891000363
							],
							[
								-82.44457720299987,
								27.93955327600123
							],
							[
								-82.44448592099978,
								27.939684073000773
							],
							[
								-82.44444874199972,
								27.93972568800093
							],
							[
								-82.44439074199981,
								27.939786688001004
							],
							[
								-82.44431707299985,
								27.939855921000248
							],
							[
								-82.44429268599968,
								27.939872997000595
							],
							[
								-82.44430432199985,
								27.940006000000853
							],
							[
								-82.44430390099956,
								27.940033519001087
							],
							[
								-82.44430090099983,
								27.940131519000847
							],
							[
								-82.44429521499973,
								27.940208626000032
							],
							[
								-82.44428292799977,
								27.94028496000102
							],
							[
								-82.44426412899972,
								27.940359956000652
							],
							[
								-82.44423895799977,
								27.94043306100004
							],
							[
								-82.4441007799998,
								27.940784515001052
							],
							[
								-82.44387460099982,
								27.941357968000453
							],
							[
								-82.44384738699988,
								27.94142001100052
							],
							[
								-82.44381557999974,
								27.941479830000407
							],
							[
								-82.44377935899968,
								27.941537084000704
							],
							[
								-82.44373893099953,
								27.941591450000054
							],
							[
								-82.44369452499949,
								27.94164261700082
							],
							[
								-82.4436505249995,
								27.941689618000357
							],
							[
								-82.44360921999963,
								27.941734627000265
							],
							[
								-82.44356387799961,
								27.9417755680009
							],
							[
								-82.44351489899972,
								27.941812078000186
							],
							[
								-82.44346271299968,
								27.94184383800122
							],
							[
								-82.44340778099983,
								27.941870567000496
							],
							[
								-82.44330146899965,
								27.942142209000412
							],
							[
								-82.44321940699943,
								27.94239659100068
							],
							[
								-82.44316191399956,
								27.94257271700015
							],
							[
								-82.44319823199965,
								27.9426459270007
							],
							[
								-82.44323223099978,
								27.942726926000564
							],
							[
								-82.44324808599985,
								27.942767413001164
							],
							[
								-82.44328781599995,
								27.94291412300051
							],
							[
								-82.4433118159997,
								27.943046124000507
							],
							[
								-82.44331665713423,
								27.943093659826804
							],
							[
								-82.44332608199964,
								27.943186204000728
							],
							[
								-82.44332931199983,
								27.94332586200056
							],
							[
								-82.44313423899976,
								27.943959486000228
							],
							[
								-82.44303118199986,
								27.94452629700032
							],
							[
								-82.44290236199986,
								27.945634154000235
							],
							[
								-82.44274777699967,
								27.94638131300015
							],
							[
								-82.44264471999985,
								27.947772575000332
							],
							[
								-82.44262672499978,
								27.948415541000596
							],
							[
								-82.44258283599979,
								27.948509661000923
							],
							[
								-82.44255508499963,
								27.948554622000824
							],
							[
								-82.44252808499971,
								27.94859562200084
							],
							[
								-82.44246591999945,
								27.948679073001085
							],
							[
								-82.44243199399966,
								27.948713000000076
							],
							[
								-82.44242548699992,
								27.94883715200093
							],
							[
								-82.44246541199976,
								27.9488946290008
							],
							[
								-82.44250100899977,
								27.948954883000813
							],
							[
								-82.4425320839996,
								27.94901758800076
							],
							[
								-82.44255846999964,
								27.94908240600115
							],
							[
								-82.44258002499974,
								27.94914898700053
							],
							[
								-82.44259663199996,
								27.949216971000293
							],
							[
								-82.44258697999987,
								27.949627074000386
							],
							[
								-82.44254908599976,
								27.949778587000043
							],
							[
								-82.44252577799986,
								27.949840529000728
							],
							[
								-82.44249716099954,
								27.94990020300016
							],
							[
								-82.44246345099987,
								27.949957157000785
							],
							[
								-82.44242490499987,
								27.950010956001062
							],
							[
								-82.44238181699977,
								27.950061190001133
							],
							[
								-82.44233451599949,
								27.950107479001144
							],
							[
								-82.44232333599973,
								27.950141930001063
							],
							[
								-82.44234647899968,
								27.9502047570012
							],
							[
								-82.44238765899989,
								27.95035783400063
							],
							[
								-82.44239203099981,
								27.950385068000752
							],
							[
								-82.44242315799981,
								27.950599946000768
							],
							[
								-82.44243128399978,
								27.950656824000323
							],
							[
								-82.44244017699963,
								27.950767875000185
							],
							[
								-82.44244789699972,
								27.95119840000037
							],
							[
								-82.44240624399974,
								27.95213851200035
							],
							[
								-82.44273755399989,
								27.95265053600026
							],
							[
								-82.44291826899983,
								27.953212759000326
							],
							[
								-82.44286806999986,
								27.95465847500022
							],
							[
								-82.4428244819998,
								27.954894737000227
							],
							[
								-82.44207443399982,
								27.954999172000253
							],
							[
								-82.4420044458347,
								27.9561892759623
							],
							[
								-82.43451818217568,
								27.956142735981008
							],
							[
								-82.42761816003694,
								27.95610007916462
							],
							[
								-82.42621820417816,
								27.955299939964565
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Palmetto Beach",
				"RegionID": "269130"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.41813399985298,
					28.4868810004227,
					-81.40872999983392,
					28.498229000121384
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.40872999983392,
							28.498084999778627
						],
						[
							-81.40880399964784,
							28.497798000038742
						],
						[
							-81.40938400030343,
							28.497835999991793
						],
						[
							-81.4099330004295,
							28.49779399985438
						],
						[
							-81.41009199966489,
							28.497781000154482
						],
						[
							-81.41014400026329,
							28.497848999691684
						],
						[
							-81.41027600005279,
							28.497892999921373
						],
						[
							-81.41067699965183,
							28.497912999943892
						],
						[
							-81.41243499975057,
							28.498022999618602
						],
						[
							-81.4125729998167,
							28.498019000333517
						],
						[
							-81.41270999983665,
							28.497987999803904
						],
						[
							-81.4127920000193,
							28.497981000380555
						],
						[
							-81.41280199958092,
							28.497808999646544
						],
						[
							-81.41274100036637,
							28.497721000086635
						],
						[
							-81.41260300030022,
							28.49763000038846
						],
						[
							-81.41243499975057,
							28.49759899985876
						],
						[
							-81.41232900026031,
							28.497389000071067
						],
						[
							-81.41225200030813,
							28.497271000027553
						],
						[
							-81.41098999969087,
							28.49637300000166
						],
						[
							-81.41098100017525,
							28.49629800014165
						],
						[
							-81.41106599959689,
							28.49618999965985
						],
						[
							-81.41118899987084,
							28.49611499979992
						],
						[
							-81.41131200014482,
							28.49606500019307
						],
						[
							-81.4108979999466,
							28.495467999653044
						],
						[
							-81.41049200011712,
							28.494980999687087
						],
						[
							-81.41045200007188,
							28.494901999642806
						],
						[
							-81.41000500015116,
							28.494409000299502
						],
						[
							-81.40965500020516,
							28.494409000299502
						],
						[
							-81.40962599976764,
							28.494559000019436
						],
						[
							-81.40954100034601,
							28.494674999970677
						],
						[
							-81.4094210002104,
							28.494749999830603
						],
						[
							-81.4094099997034,
							28.494575999903688
						],
						[
							-81.40950300039304,
							28.494426000183843
						],
						[
							-81.40948400041651,
							28.49428099979508
						],
						[
							-81.40939199977296,
							28.49428099979508
						],
						[
							-81.40939199977296,
							28.494112202446097
						],
						[
							-81.40939199977296,
							28.49322200044154
						],
						[
							-81.40939199977296,
							28.4925399995806
						],
						[
							-81.40939199977296,
							28.492381000345134
						],
						[
							-81.40929199965989,
							28.49068100022197
						],
						[
							-81.40919994775494,
							28.490312790803458
						],
						[
							-81.40919200044618,
							28.490280999769745
						],
						[
							-81.40920227070372,
							28.490280894549112
						],
						[
							-81.40967999955895,
							28.49027600043857
						],
						[
							-81.40961700025211,
							28.488797999756997
						],
						[
							-81.41114699973343,
							28.48880400003354
						],
						[
							-81.41114000031008,
							28.488602999761376
						],
						[
							-81.41233899982194,
							28.488603999807466
						],
						[
							-81.41231757797115,
							28.486926291179444
						],
						[
							-81.41231699970714,
							28.4868810004227
						],
						[
							-81.4137989996738,
							28.4868810004227
						],
						[
							-81.41525999957175,
							28.4868810004227
						],
						[
							-81.41525959577618,
							28.487003355882777
						],
						[
							-81.41475159394278,
							28.486987856966934
						],
						[
							-81.41475143656147,
							28.488136721074248
						],
						[
							-81.41645026846533,
							28.48881451400741
						],
						[
							-81.41644997798427,
							28.489698063726927
						],
						[
							-81.41801154816544,
							28.489697787635162
						],
						[
							-81.41813399985298,
							28.4904050000898
						],
						[
							-81.4178249999983,
							28.4904050000898
						],
						[
							-81.4174620003524,
							28.490416999743605
						],
						[
							-81.41725699989578,
							28.490423000020236
						],
						[
							-81.41690699994979,
							28.490433999627946
						],
						[
							-81.41693000011067,
							28.491136999658224
						],
						[
							-81.41692118495611,
							28.49139505022199
						],
						[
							-81.4169189996036,
							28.49145900011226
						],
						[
							-81.41682699985932,
							28.4914889996965
						],
						[
							-81.41686899999674,
							28.492603999832813
						],
						[
							-81.41687826481231,
							28.492846969665415
						],
						[
							-81.41689999962706,
							28.49341700043707
						],
						[
							-81.4169189996036,
							28.49390999978037
						],
						[
							-81.41602699985424,
							28.493920000241275
						],
						[
							-81.41603999955422,
							28.494019000308263
						],
						[
							-81.41542299989086,
							28.494002999570732
						],
						[
							-81.41541400037542,
							28.4941690000282
						],
						[
							-81.41540800009878,
							28.494291000256077
						],
						[
							-81.41015299977883,
							28.49428199984117
						],
						[
							-81.41016300023982,
							28.494388000230792
						],
						[
							-81.41024500042246,
							28.494518999974204
						],
						[
							-81.41034300044336,
							28.49465399990197
						],
						[
							-81.41044000041808,
							28.494781000360298
						],
						[
							-81.41047800037106,
							28.494836000197694
						],
						[
							-81.41054299977006,
							28.494930000034145
						],
						[
							-81.41064499997532,
							28.49502900010104
						],
						[
							-81.41074299999622,
							28.49514199991402
						],
						[
							-81.41083000040932,
							28.495195999705324
						],
						[
							-81.4109549998761,
							28.495199999889685
						],
						[
							-81.41160400011516,
							28.49519100037415
						],
						[
							-81.41212699994198,
							28.495082999892347
						],
						[
							-81.41256300025499,
							28.49493900044896
						],
						[
							-81.41261399990802,
							28.494817000221172
						],
						[
							-81.41289600031674,
							28.49482100040553
						],
						[
							-81.41289100008619,
							28.495056000446382
						],
						[
							-81.4125729998167,
							28.495056000446382
						],
						[
							-81.41181399990293,
							28.495235999750555
						],
						[
							-81.41140900011962,
							28.495317999933107
						],
						[
							-81.41112200037965,
							28.495345000278448
						],
						[
							-81.4109549998761,
							28.495339000001906
						],
						[
							-81.41140499993517,
							28.49602500014784
						],
						[
							-81.4116209999995,
							28.496043000078274
						],
						[
							-81.41200999994464,
							28.49621399986691
						],
						[
							-81.41245099958883,
							28.496458000322576
						],
						[
							-81.41272799976709,
							28.496647000041648
						],
						[
							-81.41287200010967,
							28.496854999737163
						],
						[
							-81.4129330002236,
							28.496971999734498
						],
						[
							-81.4129999997148,
							28.49705800010159
						],
						[
							-81.41338100019051,
							28.497447000046733
						],
						[
							-81.41332000007657,
							28.497569000274524
						],
						[
							-81.41332000007657,
							28.497717999948367
						],
						[
							-81.41339199979822,
							28.498180999707344
						],
						[
							-81.4130759996209,
							28.498197999591596
						],
						[
							-81.41274100036637,
							28.498229000121384
						],
						[
							-81.4125270003942,
							28.498229000121384
						],
						[
							-81.40872999983392,
							28.498084999778627
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Park Central",
				"RegionID": "269132"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.55976474999994,
					30.286619008000056,
					-81.52310282699995,
					30.324526012000035
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.52321390599991,
							30.322131008000042
						],
						[
							-81.5232429049999,
							30.321739009000055
						],
						[
							-81.5232639059999,
							30.321550008000088
						],
						[
							-81.5232869049999,
							30.321352008000073
						],
						[
							-81.52336690599992,
							30.320926008000075
						],
						[
							-81.52345490599993,
							30.32057100900005
						],
						[
							-81.52363790599992,
							30.319900009000037
						],
						[
							-81.52385790599993,
							30.319261009000062
						],
						[
							-81.52406190599993,
							30.318764008000077
						],
						[
							-81.52442890599991,
							30.31782500800006
						],
						[
							-81.52450290599995,
							30.317632008000093
						],
						[
							-81.52459790499995,
							30.317372009000053
						],
						[
							-81.52469290499994,
							30.317062009000043
						],
						[
							-81.5247729049999,
							30.316723008000054
						],
						[
							-81.52477990599994,
							30.316653008000063
						],
						[
							-81.52479290499991,
							30.316580008000074
						],
						[
							-81.52484790499994,
							30.31633700800006
						],
						[
							-81.52495490599995,
							30.315775008000056
						],
						[
							-81.5251079059999,
							30.314966009000045
						],
						[
							-81.52515490499991,
							30.314640008000087
						],
						[
							-81.52523090599993,
							30.31418000900004
						],
						[
							-81.52526190499992,
							30.313907008000058
						],
						[
							-81.52532890499994,
							30.313313009000073
						],
						[
							-81.52536590499994,
							30.312865009000063
						],
						[
							-81.52536590599993,
							30.31218700800008
						],
						[
							-81.52536590599993,
							30.31188300800005
						],
						[
							-81.52537290599992,
							30.311326008000034
						],
						[
							-81.5254029059999,
							30.31102300900005
						],
						[
							-81.52541790499993,
							30.310922008000034
						],
						[
							-81.5254469059999,
							30.310719008000035
						],
						[
							-81.52562190599991,
							30.309807007000074
						],
						[
							-81.52577590599992,
							30.309009008000093
						],
						[
							-81.5258299059999,
							30.308776008000056
						],
						[
							-81.52595090499995,
							30.30822000900008
						],
						[
							-81.5260119049999,
							30.307854008000046
						],
						[
							-81.52607190599991,
							30.307415009000064
						],
						[
							-81.52609490599991,
							30.30714700800007
						],
						[
							-81.52611794299992,
							30.306834021000043
						],
						[
							-81.52611590599992,
							30.306697009000064
						],
						[
							-81.52609490599991,
							30.305245008000043
						],
						[
							-81.5260759059999,
							30.304384008000053
						],
						[
							-81.5260589049999,
							30.302985009000054
						],
						[
							-81.52602190499994,
							30.301239008000042
						],
						[
							-81.52601990499994,
							30.301165008000055
						],
						[
							-81.52601890599993,
							30.301090008000077
						],
						[
							-81.5259849059999,
							30.297979009000077
						],
						[
							-81.52597990499993,
							30.29762000900007
						],
						[
							-81.52590896099991,
							30.294874011000047
						],
						[
							-81.52588190599994,
							30.292322008000045
						],
						[
							-81.52585490599995,
							30.289735008000036
						],
						[
							-81.52583390599995,
							30.289308009000084
						],
						[
							-81.5258299059999,
							30.28923400900004
						],
						[
							-81.52580490499992,
							30.28807800900006
						],
						[
							-81.52580290599991,
							30.287858008000057
						],
						[
							-81.52579790599992,
							30.28740800800006
						],
						[
							-81.52579490599993,
							30.287107008000078
						],
						[
							-81.52579690099992,
							30.287003016000085
						],
						[
							-81.52595990499992,
							30.287007009000035
						],
						[
							-81.5263009059999,
							30.286997008000068
						],
						[
							-81.52773990499992,
							30.28695600800006
						],
						[
							-81.5290929059999,
							30.28695600800006
						],
						[
							-81.53047790599993,
							30.28693100800007
						],
						[
							-81.53144790599994,
							30.28691500800005
						],
						[
							-81.53157690499995,
							30.286913008000056
						],
						[
							-81.53351990599992,
							30.28690400800008
						],
						[
							-81.53565890499993,
							30.286875008000038
						],
						[
							-81.5388219059999,
							30.286828008000043
						],
						[
							-81.53901990599991,
							30.286828008000043
						],
						[
							-81.54031290499995,
							30.286810009000078
						],
						[
							-81.54041790499991,
							30.28680900800003
						],
						[
							-81.54155290599994,
							30.286802008000056
						],
						[
							-81.54225590599992,
							30.286791009000066
						],
						[
							-81.54418890599993,
							30.286766008000086
						],
						[
							-81.54642690599991,
							30.286751009000056
						],
						[
							-81.54861490499991,
							30.286736008000048
						],
						[
							-81.5505929059999,
							30.286709008000063
						],
						[
							-81.5512689059999,
							30.286700008000086
						],
						[
							-81.55292090599994,
							30.28667800800008
						],
						[
							-81.55375390599994,
							30.286667008000048
						],
						[
							-81.55425190499994,
							30.286660008000073
						],
						[
							-81.55494890599994,
							30.28665600900007
						],
						[
							-81.55581090499993,
							30.28664500800005
						],
						[
							-81.55731390499994,
							30.286619008000056
						],
						[
							-81.55765790599992,
							30.286623008000046
						],
						[
							-81.5577789049999,
							30.286625008000044
						],
						[
							-81.55809690599995,
							30.286637009000064
						],
						[
							-81.5588419099999,
							30.286659954000076
						],
						[
							-81.55885390799995,
							30.287268011000034
						],
						[
							-81.55885790699995,
							30.287658011000076
						],
						[
							-81.5588739079999,
							30.288273010000065
						],
						[
							-81.55888390799993,
							30.288639010000058
						],
						[
							-81.55894890699994,
							30.28929901000004
						],
						[
							-81.55895290799992,
							30.290207010000074
						],
						[
							-81.55895290799992,
							30.290502011000054
						],
						[
							-81.55894890799993,
							30.290692010000047
						],
						[
							-81.55893990699991,
							30.29089901000009
						],
						[
							-81.55892790799994,
							30.291113010000064
						],
						[
							-81.55876990799993,
							30.292018010000046
						],
						[
							-81.55861890699994,
							30.29292601100008
						],
						[
							-81.5584939069999,
							30.29384301000005
						],
						[
							-81.55843690799992,
							30.294364011000084
						],
						[
							-81.55842690799994,
							30.294463010000072
						],
						[
							-81.5584269069999,
							30.29450401000008
						],
						[
							-81.5583987899999,
							30.294736137000086
						],
						[
							-81.55855190799991,
							30.294703011000085
						],
						[
							-81.55871402899993,
							30.294677872000083
						],
						[
							-81.55868790799991,
							30.295228011000066
						],
						[
							-81.55869390799995,
							30.29566301000006
						],
						[
							-81.55870490699994,
							30.296554010000083
						],
						[
							-81.55871690799995,
							30.297450010000038
						],
						[
							-81.55872890799992,
							30.298340010000064
						],
						[
							-81.55875290799992,
							30.30013401000008
						],
						[
							-81.5587629069999,
							30.301612010000042
						],
						[
							-81.5587629069999,
							30.30197601000009
						],
						[
							-81.5587629069999,
							30.302000011000075
						],
						[
							-81.55877190799993,
							30.302256011000058
						],
						[
							-81.55879190799993,
							30.303810011000056
						],
						[
							-81.55881190799994,
							30.305556010000092
						],
						[
							-81.55881190799994,
							30.305641010000045
						],
						[
							-81.55881190799994,
							30.307168010000055
						],
						[
							-81.55881190799994,
							30.30745801000006
						],
						[
							-81.55882090699993,
							30.307730011000046
						],
						[
							-81.55883090799995,
							30.30854801100008
						],
						[
							-81.55883090799995,
							30.30925401000008
						],
						[
							-81.5588499079999,
							30.310733010000035
						],
						[
							-81.5588499079999,
							30.311072011000082
						],
						[
							-81.55885990699994,
							30.311411011000075
						],
						[
							-81.55887990699995,
							30.312886010000057
						],
						[
							-81.55889190799991,
							30.314702011000065
						],
						[
							-81.55889890699991,
							30.315101010000035
						],
						[
							-81.55890790799992,
							30.31564401000008
						],
						[
							-81.55892185199991,
							30.316470949000067
						],
						[
							-81.55890390899992,
							30.31770301100005
						],
						[
							-81.55892390899993,
							30.319067011000072
						],
						[
							-81.55892195399991,
							30.319535142000063
						],
						[
							-81.55880086799993,
							30.31938985800008
						],
						[
							-81.55876190699992,
							30.31962601000004
						],
						[
							-81.55874796199993,
							30.319904020000084
						],
						[
							-81.55857482399995,
							30.32049500300008
						],
						[
							-81.55868990899995,
							30.32140801000008
						],
						[
							-81.55872990599995,
							30.321572013000036
						],
						[
							-81.55873990899994,
							30.321790010000086
						],
						[
							-81.5587629069999,
							30.32208901000007
						],
						[
							-81.55882590899995,
							30.322365010000055
						],
						[
							-81.55886990699992,
							30.322482010000048
						],
						[
							-81.55889290599993,
							30.32252601000005
						],
						[
							-81.55894890899992,
							30.322624011000073
						],
						[
							-81.55904390899991,
							30.322770011000046
						],
						[
							-81.55911490699992,
							30.322862010000048
						],
						[
							-81.55917790699995,
							30.322944010000075
						],
						[
							-81.55924090899993,
							30.323017010000058
						],
						[
							-81.55929990699991,
							30.323088010000053
						],
						[
							-81.5594509089999,
							30.323213010000075
						],
						[
							-81.55959290599992,
							30.32331901100008
						],
						[
							-81.55967996699991,
							30.323373951000068
						],
						[
							-81.55976474999994,
							30.323513044000038
						],
						[
							-81.55921790799994,
							30.323292010000046
						],
						[
							-81.55909090699993,
							30.323234010000075
						],
						[
							-81.5589159079999,
							30.323150009000077
						],
						[
							-81.55885590699995,
							30.32311201100004
						],
						[
							-81.55835890799995,
							30.32289001100008
						],
						[
							-81.55825590699993,
							30.322843010000042
						],
						[
							-81.55777490799994,
							30.32267801100005
						],
						[
							-81.55718090699992,
							30.322478011000044
						],
						[
							-81.55665090799994,
							30.32233801000007
						],
						[
							-81.55584574499994,
							30.322118110000076
						],
						[
							-81.55585878399995,
							30.322033864000048
						],
						[
							-81.55596701799993,
							30.322036040000057
						],
						[
							-81.55586673399995,
							30.32198509400007
						],
						[
							-81.55588106199991,
							30.321903901000045
						],
						[
							-81.55506590699991,
							30.321766010000093
						],
						[
							-81.55483390799992,
							30.32173401000006
						],
						[
							-81.55410790799993,
							30.321619011000056
						],
						[
							-81.5533579069999,
							30.321519010000088
						],
						[
							-81.55305285599991,
							30.321477836000042
						],
						[
							-81.55295674099995,
							30.32156893000007
						],
						[
							-81.5529470319999,
							30.32169414800006
						],
						[
							-81.55258690799991,
							30.32167301000004
						],
						[
							-81.55208890799992,
							30.32165701000008
						],
						[
							-81.55175790699991,
							30.321655010000086
						],
						[
							-81.55143590799992,
							30.32164901100009
						],
						[
							-81.55139190799991,
							30.32165401000009
						],
						[
							-81.55095790699994,
							30.32166601100005
						],
						[
							-81.55057090799994,
							30.321686010000068
						],
						[
							-81.55041390699996,
							30.32169401000004
						],
						[
							-81.5503369079999,
							30.32169401000004
						],
						[
							-81.55011390699991,
							30.32169001000005
						],
						[
							-81.5498259069999,
							30.32169401100009
						],
						[
							-81.54962890699994,
							30.32171401000005
						],
						[
							-81.54866690799992,
							30.32181601000008
						],
						[
							-81.54856090699991,
							30.321827010000053
						],
						[
							-81.54844290699992,
							30.32184101000007
						],
						[
							-81.54782690799993,
							30.321915011000044
						],
						[
							-81.54746290799994,
							30.321961010000056
						],
						[
							-81.54731290799992,
							30.32198501100004
						],
						[
							-81.54721978499992,
							30.32199812500005
						],
						[
							-81.54725703399993,
							30.321858890000048
						],
						[
							-81.54719790799993,
							30.32186801100005
						],
						[
							-81.54688280699992,
							30.32197315000008
						],
						[
							-81.54688302599993,
							30.32190787400009
						],
						[
							-81.5467358759999,
							30.321928933000034
						],
						[
							-81.54661993999991,
							30.322012087000072
						],
						[
							-81.54637890799995,
							30.322048011000046
						],
						[
							-81.54562590699993,
							30.32214201000005
						],
						[
							-81.54460790699994,
							30.322247010000073
						],
						[
							-81.5433879069999,
							30.322376010000088
						],
						[
							-81.54235790799993,
							30.322477011000046
						],
						[
							-81.54109490799993,
							30.322621010000038
						],
						[
							-81.5395819069999,
							30.322781010000085
						],
						[
							-81.53906990699996,
							30.32283601000006
						],
						[
							-81.53814690799993,
							30.32292701100005
						],
						[
							-81.53783790799991,
							30.322960010000088
						],
						[
							-81.5375709079999,
							30.322990010000073
						],
						[
							-81.5367619079999,
							30.323080010000073
						],
						[
							-81.53592690799991,
							30.323177010000055
						],
						[
							-81.53577391999994,
							30.323188920000067
						],
						[
							-81.53515590699993,
							30.323250010000038
						],
						[
							-81.53400390599995,
							30.323378010000052
						],
						[
							-81.53276790599995,
							30.32351501100004
						],
						[
							-81.53199790699995,
							30.323578011000055
						],
						[
							-81.53053990899991,
							30.323717010000053
						],
						[
							-81.53009790699991,
							30.32376701100009
						],
						[
							-81.5295639069999,
							30.32381901000008
						],
						[
							-81.52898183799994,
							30.323868849000064
						],
						[
							-81.52888694299992,
							30.323947085000043
						],
						[
							-81.52879690799995,
							30.323960010000064
						],
						[
							-81.52840890599992,
							30.32401401000004
						],
						[
							-81.52796190899994,
							30.324055010000052
						],
						[
							-81.52777090699993,
							30.32407201000007
						],
						[
							-81.52764290599993,
							30.324083011000084
						],
						[
							-81.52751890899992,
							30.324096010000062
						],
						[
							-81.52739990699992,
							30.324108011000074
						],
						[
							-81.5272479059999,
							30.324119010000064
						],
						[
							-81.52711490799993,
							30.324129010000032
						],
						[
							-81.52694790699991,
							30.324141010000062
						],
						[
							-81.5266149069999,
							30.32417001000005
						],
						[
							-81.52620090599994,
							30.32421501000005
						],
						[
							-81.52562490699995,
							30.324280010000052
						],
						[
							-81.5255449089999,
							30.324289010000086
						],
						[
							-81.52536290799992,
							30.324313011000072
						],
						[
							-81.5247139089999,
							30.32438101000008
						],
						[
							-81.52311790099992,
							30.324526012000035
						],
						[
							-81.52311190599994,
							30.324453008000035
						],
						[
							-81.5231049059999,
							30.324362008000037
						],
						[
							-81.52310282699995,
							30.32421698700006
						],
						[
							-81.52318398599994,
							30.324075030000078
						],
						[
							-81.52319290499992,
							30.323720008000066
						],
						[
							-81.52319790599996,
							30.323485008000034
						],
						[
							-81.52319190599991,
							30.322501008000074
						],
						[
							-81.52319890599995,
							30.32243500900006
						],
						[
							-81.52321390599991,
							30.322131008000042
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Southside Estates",
				"RegionID": "275490"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.41513111863108,
					28.552871566502645,
					-81.39558817284559,
					28.564798483173824
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.39726666118574,
							28.559967143569438
						],
						[
							-81.39717853032491,
							28.559830941248016
						],
						[
							-81.39704833727336,
							28.559630644245658
						],
						[
							-81.39608891445218,
							28.55804629603614
						],
						[
							-81.39588561461352,
							28.55763568628194
						],
						[
							-81.39578646705776,
							28.557334239832983
						],
						[
							-81.39568531671179,
							28.556964691324033
						],
						[
							-81.39562122293013,
							28.55653905929468
						],
						[
							-81.39561621370643,
							28.556007272192325
						],
						[
							-81.39558817284559,
							28.553891132383875
						],
						[
							-81.39559418211539,
							28.553165055750213
						],
						[
							-81.39561020443664,
							28.553019840423516
						],
						[
							-81.39561921294542,
							28.552961752314356
						],
						[
							-81.39568431486705,
							28.552960752268262
						],
						[
							-81.39592867774961,
							28.552958750377428
						],
						[
							-81.3960418448365,
							28.55295774853269
						],
						[
							-81.39743390990222,
							28.552944729047645
						],
						[
							-81.39825212207765,
							28.552936716987652
						],
						[
							-81.39974233375384,
							28.55293871977785
						],
						[
							-81.40056955983393,
							28.552928704927744
						],
						[
							-81.40114641556049,
							28.55292369840206
						],
						[
							-81.40162512557602,
							28.55292369840206
						],
						[
							-81.40259656603752,
							28.552908675227535
						],
						[
							-81.40364111598406,
							28.552895656641773
						],
						[
							-81.40456748872062,
							28.552883638102273
						],
						[
							-81.40469768267153,
							28.552882637156813
						],
						[
							-81.40565109172636,
							28.552871566502645
						],
						[
							-81.40560088707402,
							28.554248796352184
						],
						[
							-81.40971826121465,
							28.554248530152854
						],
						[
							-81.40971799321667,
							28.55634089998083
						],
						[
							-81.41069670829401,
							28.556340636479433
						],
						[
							-81.41069657969102,
							28.55651001568974
						],
						[
							-81.41076460350995,
							28.556913647604297
						],
						[
							-81.41106813009081,
							28.55731921575918
						],
						[
							-81.41133853464129,
							28.557589616712363
						],
						[
							-81.4117773498323,
							28.55782588299863
						],
						[
							-81.41174299483143,
							28.55812953998121
						],
						[
							-81.41370114804104,
							28.558129574155387
						],
						[
							-81.41376902347193,
							28.557893914012162
						],
						[
							-81.41442421734175,
							28.55791094177554
						],
						[
							-81.4144962134662,
							28.558123410202214
						],
						[
							-81.41466246123721,
							28.55859611094796
						],
						[
							-81.41513111863108,
							28.559918124223525
						],
						[
							-81.40992029300924,
							28.559917938063812
						],
						[
							-81.4099886603692,
							28.56471130829229
						],
						[
							-81.40043427931771,
							28.564798483173824
						],
						[
							-81.400264106006,
							28.564598012602303
						],
						[
							-81.39973540807479,
							28.563845794476023
						],
						[
							-81.39963010645847,
							28.563779858882775
						],
						[
							-81.39958615209433,
							28.563712606682074
						],
						[
							-81.39907534347688,
							28.562896488128274
						],
						[
							-81.39887003904946,
							28.562550975799212
						],
						[
							-81.39726666118574,
							28.559967143569438
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Spring Lake",
				"RegionID": "275515"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.7999143699999,
					26.167493033000085,
					-81.78992499999993,
					26.182164000000057
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.79159361299992,
							26.182011646000035
						],
						[
							-81.7915789999999,
							26.181079000000068
						],
						[
							-81.79156799999993,
							26.179843000000062
						],
						[
							-81.79154699999992,
							26.17754000000008
						],
						[
							-81.7915097259999,
							26.177538562000052
						],
						[
							-81.79048399999994,
							26.17749900000007
						],
						[
							-81.79025599999994,
							26.17775400000005
						],
						[
							-81.78997299999992,
							26.177555000000044
						],
						[
							-81.78992499999993,
							26.177411000000063
						],
						[
							-81.7899559999999,
							26.175381000000073
						],
						[
							-81.79144742799991,
							26.175381856000058
						],
						[
							-81.79140999999993,
							26.174070000000086
						],
						[
							-81.79140972699992,
							26.17320864800007
						],
						[
							-81.79149999999993,
							26.173209000000043
						],
						[
							-81.79148299999991,
							26.171685000000082
						],
						[
							-81.79148100699992,
							26.171503600000054
						],
						[
							-81.79147299999994,
							26.17077500000005
						],
						[
							-81.79141399999992,
							26.169414000000074
						],
						[
							-81.7914072829999,
							26.16919585800008
						],
						[
							-81.79139299999991,
							26.16873200000009
						],
						[
							-81.79139292199996,
							26.168731050000076
						],
						[
							-81.79151999999993,
							26.168720000000064
						],
						[
							-81.79190852099993,
							26.16866022800008
						],
						[
							-81.79266986199991,
							26.168543098000043
						],
						[
							-81.79347000299992,
							26.168418108000083
						],
						[
							-81.79423036799994,
							26.168294805000073
						],
						[
							-81.79478271399995,
							26.168205236000063
						],
						[
							-81.79536999999993,
							26.16811000000007
						],
						[
							-81.79553164299995,
							26.16808332100004
						],
						[
							-81.79585316899994,
							26.168030254000087
						],
						[
							-81.79630460999994,
							26.16795574400004
						],
						[
							-81.79684420599995,
							26.167869331000077
						],
						[
							-81.79733508999993,
							26.167791236000085
						],
						[
							-81.79771999999991,
							26.167730000000063
						],
						[
							-81.79786579899991,
							26.167711775000043
						],
						[
							-81.79810607699994,
							26.167681740000035
						],
						[
							-81.79838701599994,
							26.167646623000053
						],
						[
							-81.79856691599991,
							26.16762413500004
						],
						[
							-81.79871423199995,
							26.167598242000054
						],
						[
							-81.79887616899993,
							26.167567396000038
						],
						[
							-81.79901999999993,
							26.167540000000088
						],
						[
							-81.79906838099993,
							26.167525486000045
						],
						[
							-81.79912900199992,
							26.16750729900008
						],
						[
							-81.79919095499991,
							26.167493033000085
						],
						[
							-81.79942029699993,
							26.168520295000064
						],
						[
							-81.79960999799994,
							26.16937000200005
						],
						[
							-81.79964999899994,
							26.171019999000066
						],
						[
							-81.7997099989999,
							26.173970000000054
						],
						[
							-81.7997099989999,
							26.17417000000006
						],
						[
							-81.79974999899991,
							26.175469999000086
						],
						[
							-81.79978999899993,
							26.177270000000078
						],
						[
							-81.79984999999994,
							26.17956999900008
						],
						[
							-81.79986999999994,
							26.180160000000058
						],
						[
							-81.79990994899993,
							26.181867785000065
						],
						[
							-81.7999143699999,
							26.18196465500006
						],
						[
							-81.79982999999993,
							26.181955000000073
						],
						[
							-81.7982869999999,
							26.18200500000006
						],
						[
							-81.79578599999991,
							26.18207300000006
						],
						[
							-81.7924099999999,
							26.18211000000008
						],
						[
							-81.79223599999995,
							26.182117000000062
						],
						[
							-81.79159599999991,
							26.182164000000057
						],
						[
							-81.79159361299992,
							26.182011646000035
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Collier",
				"City": "Naples",
				"Name": "Sun Terrace",
				"RegionID": "275615"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.05848999999995,
					26.690310000000068,
					-80.0542391749999,
					26.69385824200009
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.05437497699995,
							26.69050591100006
						],
						[
							-80.05437999999992,
							26.690310000000068
						],
						[
							-80.05439224299994,
							26.690310329000056
						],
						[
							-80.05451987999993,
							26.69031375500009
						],
						[
							-80.05468396899994,
							26.690318160000064
						],
						[
							-80.0550576899999,
							26.690328193000084
						],
						[
							-80.05540571299991,
							26.690337536000072
						],
						[
							-80.05591095599993,
							26.69035134300009
						],
						[
							-80.05647999999991,
							26.690370000000087
						],
						[
							-80.0566192849999,
							26.69037346500005
						],
						[
							-80.05687517799993,
							26.69037983000004
						],
						[
							-80.05741302999992,
							26.69039321000008
						],
						[
							-80.05814808699995,
							26.690411495000035
						],
						[
							-80.05848999999995,
							26.690420000000074
						],
						[
							-80.05848829099995,
							26.690490086000068
						],
						[
							-80.05848617299995,
							26.690576924000084
						],
						[
							-80.05848364499991,
							26.69068056800006
						],
						[
							-80.05848012599995,
							26.690824830000054
						],
						[
							-80.05845845899995,
							26.690890077000063
						],
						[
							-80.05844967999991,
							26.691028283000037
						],
						[
							-80.05844999999994,
							26.691110000000037
						],
						[
							-80.05844999999994,
							26.691166077000048
						],
						[
							-80.05844999999994,
							26.69126000000006
						],
						[
							-80.05844760499991,
							26.691323460000035
						],
						[
							-80.0584441439999,
							26.691415187000075
						],
						[
							-80.05844016899994,
							26.691520512000068
						],
						[
							-80.05843497699993,
							26.691658102000076
						],
						[
							-80.05842999999993,
							26.691790000000083
						],
						[
							-80.0584114689999,
							26.691946623000035
						],
						[
							-80.0584199999999,
							26.692090000000064
						],
						[
							-80.05840977799994,
							26.692222883000056
						],
						[
							-80.05839970499994,
							26.69235383700004
						],
						[
							-80.05838563099991,
							26.692481912000062
						],
						[
							-80.05838218499991,
							26.692589798000085
						],
						[
							-80.05837255599994,
							26.69278018600005
						],
						[
							-80.05836834399992,
							26.692912117000052
						],
						[
							-80.05835859699994,
							26.69305575100009
						],
						[
							-80.05835105999995,
							26.693166816000087
						],
						[
							-80.05834501499993,
							26.69335753300004
						],
						[
							-80.05833856699991,
							26.69360686300007
						],
						[
							-80.0583299999999,
							26.693740000000048
						],
						[
							-80.05832510199991,
							26.69385824200009
						],
						[
							-80.05824639699995,
							26.693854352000077
						],
						[
							-80.0581021239999,
							26.693851081000048
						],
						[
							-80.0578987849999,
							26.693848682000066
						],
						[
							-80.05770179699994,
							26.69384200400009
						],
						[
							-80.05755752399995,
							26.693838733000064
						],
						[
							-80.05735407299994,
							26.693833690000076
						],
						[
							-80.05721999999992,
							26.693830000000048
						],
						[
							-80.05712436699991,
							26.69382756600004
						],
						[
							-80.05700644899991,
							26.693822905000047
						],
						[
							-80.0567440829999,
							26.693819733000055
						],
						[
							-80.05639999999994,
							26.693810000000042
						],
						[
							-80.05631757099991,
							26.693807745000072
						],
						[
							-80.05621254399995,
							26.693803057000082
						],
						[
							-80.05583849399994,
							26.693785523000088
						],
						[
							-80.05534636399994,
							26.693773987000043
						],
						[
							-80.05483479599991,
							26.69376606500009
						],
						[
							-80.05439515499995,
							26.693753831000038
						],
						[
							-80.0542994409999,
							26.69375106800004
						],
						[
							-80.0542391749999,
							26.69374932800008
						],
						[
							-80.05423999999994,
							26.69367564500004
						],
						[
							-80.05423999999994,
							26.693620000000067
						],
						[
							-80.05424272199993,
							26.693569190000062
						],
						[
							-80.05424924899995,
							26.693447356000036
						],
						[
							-80.05425497599992,
							26.693340445000047
						],
						[
							-80.05426424599995,
							26.69316741700004
						],
						[
							-80.05426999999992,
							26.69306000000006
						],
						[
							-80.0542724039999,
							26.692995091000057
						],
						[
							-80.05427653699991,
							26.69288349100009
						],
						[
							-80.05427999999995,
							26.69279000000006
						],
						[
							-80.0542854659999,
							26.692715297000063
						],
						[
							-80.0542958449999,
							26.69257345400007
						],
						[
							-80.05430326599993,
							26.69247203200007
						],
						[
							-80.05430999999993,
							26.69238000000007
						],
						[
							-80.05431190299993,
							26.692314356000054
						],
						[
							-80.05431440799993,
							26.69222792700009
						],
						[
							-80.05431838899995,
							26.69209059700006
						],
						[
							-80.05432265499991,
							26.69194341000008
						],
						[
							-80.05432692499994,
							26.69179607600006
						],
						[
							-80.05432869099991,
							26.691735171000065
						],
						[
							-80.05432999999994,
							26.691623459000084
						],
						[
							-80.05432999999994,
							26.69154000000009
						],
						[
							-80.05433302999995,
							26.69148647500009
						],
						[
							-80.05433965399993,
							26.691369442000052
						],
						[
							-80.05435057799993,
							26.691176458000086
						],
						[
							-80.05436085699995,
							26.690983430000074
						],
						[
							-80.05436642799992,
							26.69081073700005
						],
						[
							-80.05437119899995,
							26.69065325400004
						],
						[
							-80.05437497699995,
							26.69050591100006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "West Palm Beach",
				"Name": "Sunshine Park",
				"RegionID": "275640"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.29737052055623,
					28.49511499956877,
					-81.29476200013798,
					28.499071138759412
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.29566077627888,
							28.499071138759412
						],
						[
							-81.29566200025614,
							28.498773000016826
						],
						[
							-81.2953060000336,
							28.498761000363025
						],
						[
							-81.29530399994134,
							28.498631999812424
						],
						[
							-81.29520130186222,
							28.498629001472892
						],
						[
							-81.29516699992138,
							28.498627999628063
						],
						[
							-81.29517100010574,
							28.49875600013248
						],
						[
							-81.29476200013798,
							28.49875099990203
						],
						[
							-81.29476600032244,
							28.498615999974263
						],
						[
							-81.29480100013713,
							28.495119999799307
						],
						[
							-81.29525300028838,
							28.49511499956877
						],
						[
							-81.29524905496264,
							28.495188799733153
						],
						[
							-81.29523600040405,
							28.49543299983835
						],
						[
							-81.2956139998421,
							28.495438000068802
						],
						[
							-81.29561893442214,
							28.495188799733153
						],
						[
							-81.29562000011873,
							28.495134999591386
						],
						[
							-81.2973529999645,
							28.49517799977489
						],
						[
							-81.29733594162415,
							28.495634029788192
						],
						[
							-81.297222000221,
							28.498680000226475
						],
						[
							-81.29718500031413,
							28.49881200001597
						],
						[
							-81.29736827404979,
							28.49881200001597
						],
						[
							-81.29737052055623,
							28.49906081454246
						],
						[
							-81.29732243830392,
							28.499060816341114
						],
						[
							-81.29663539134708,
							28.499063767916006
						],
						[
							-81.29631895050191,
							28.499067826556363
						],
						[
							-81.29566077627888,
							28.499071138759412
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Pershing",
				"RegionID": "269141"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.05800473199992,
					26.72717753900008,
					-80.05288793299991,
					26.734720731000042
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.05800011899993,
							26.734720678000087
						],
						[
							-80.05792245999993,
							26.734719780000034
						],
						[
							-80.05776999999996,
							26.73472000000004
						],
						[
							-80.05763165299993,
							26.734714876000055
						],
						[
							-80.05749999999995,
							26.734710000000067
						],
						[
							-80.05722102499993,
							26.734698613000035
						],
						[
							-80.05695488799995,
							26.734701751000046
						],
						[
							-80.0564463689999,
							26.734676386000046
						],
						[
							-80.0560595629999,
							26.73466704300006
						],
						[
							-80.0555035289999,
							26.734653612000045
						],
						[
							-80.05494615499993,
							26.734647136000035
						],
						[
							-80.05456055299993,
							26.73463719700004
						],
						[
							-80.05397865899994,
							26.734611725000036
						],
						[
							-80.05315692699992,
							26.734587557000054
						],
						[
							-80.05289999999991,
							26.73458000000005
						],
						[
							-80.05289999999991,
							26.734405983000045
						],
						[
							-80.05289999999991,
							26.734250000000088
						],
						[
							-80.05288793299991,
							26.734067236000044
						],
						[
							-80.05289332599995,
							26.733880670000076
						],
						[
							-80.05289716999994,
							26.73375304700005
						],
						[
							-80.05290999999994,
							26.733560000000068
						],
						[
							-80.05291278499993,
							26.733462519000057
						],
						[
							-80.05291999999992,
							26.733210000000042
						],
						[
							-80.0529207479999,
							26.73302739500008
						],
						[
							-80.05293999999992,
							26.73276000000004
						],
						[
							-80.05293995699992,
							26.732543407000037
						],
						[
							-80.05295999999993,
							26.732300000000066
						],
						[
							-80.05295581099995,
							26.732059414000048
						],
						[
							-80.05298999999991,
							26.731790000000046
						],
						[
							-80.05298999999991,
							26.73164838200006
						],
						[
							-80.05298999999991,
							26.73147905500008
						],
						[
							-80.05298999999991,
							26.73130000000009
						],
						[
							-80.05299491499994,
							26.73116484500008
						],
						[
							-80.05298611799992,
							26.73094682300007
						],
						[
							-80.05299279699994,
							26.73075140400005
						],
						[
							-80.0529967839999,
							26.730632719000084
						],
						[
							-80.05301999999995,
							26.730570000000057
						],
						[
							-80.0530057119999,
							26.730366935000063
						],
						[
							-80.05302999999992,
							26.730170000000044
						],
						[
							-80.0530349089999,
							26.730027637000035
						],
						[
							-80.05303999999991,
							26.729880000000037
						],
						[
							-80.05303450299994,
							26.729688986000042
						],
						[
							-80.05305399499991,
							26.72944614700009
						],
						[
							-80.05306999999993,
							26.72903000000008
						],
						[
							-80.0530744269999,
							26.728817493000065
						],
						[
							-80.05307999999991,
							26.72855000000004
						],
						[
							-80.05308999999994,
							26.72834000000006
						],
						[
							-80.05310043399993,
							26.72818870000009
						],
						[
							-80.05310999999995,
							26.728050000000053
						],
						[
							-80.05311580399992,
							26.72775400900008
						],
						[
							-80.05311999999992,
							26.72754000000009
						],
						[
							-80.05311440999992,
							26.727342862000057
						],
						[
							-80.05312069399992,
							26.72717753900008
						],
						[
							-80.05327801499993,
							26.72718168200004
						],
						[
							-80.05356868199993,
							26.727189537000072
						],
						[
							-80.0540280649999,
							26.72719952300008
						],
						[
							-80.05451162599991,
							26.72721003500004
						],
						[
							-80.05495738899994,
							26.72722590500007
						],
						[
							-80.05521327899993,
							26.72722620600007
						],
						[
							-80.05545501699993,
							26.72723237300005
						],
						[
							-80.05603518699992,
							26.72724717300008
						],
						[
							-80.0567373319999,
							26.727270066000074
						],
						[
							-80.05685668599995,
							26.727272129000085
						],
						[
							-80.0571311349999,
							26.729152105000086
						],
						[
							-80.05778105899992,
							26.733293486000036
						],
						[
							-80.05800473199992,
							26.734720731000042
						],
						[
							-80.05800011899993,
							26.734720678000087
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "West Palm Beach",
				"Name": "Pleasant City",
				"RegionID": "269146"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.05338309299992,
					26.719389702000058,
					-80.0478096789999,
					26.724641392000084
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.04863541599991,
							26.72455501700006
						],
						[
							-80.0480234129999,
							26.72238410100005
						],
						[
							-80.04784752599994,
							26.721797153000068
						],
						[
							-80.04783109599992,
							26.72173410000005
						],
						[
							-80.04781927399995,
							26.721670024000048
						],
						[
							-80.04781212199993,
							26.721605260000047
						],
						[
							-80.0478096789999,
							26.721540147000045
						],
						[
							-80.04781195599992,
							26.721475029000093
						],
						[
							-80.04785595599992,
							26.720858029000055
						],
						[
							-80.04786345199994,
							26.72078977400008
						],
						[
							-80.04787613299993,
							26.720722291000072
						],
						[
							-80.04789392599992,
							26.720655971000042
						],
						[
							-80.04791672699992,
							26.720591203000083
						],
						[
							-80.04794440299992,
							26.72052836200004
						],
						[
							-80.04813676299995,
							26.72013322300006
						],
						[
							-80.04868553599994,
							26.719874614000048
						],
						[
							-80.04899055099992,
							26.719645852000042
						],
						[
							-80.04912799999994,
							26.719393000000082
						],
						[
							-80.05007831899991,
							26.719389702000058
						],
						[
							-80.05082991099994,
							26.71941421300005
						],
						[
							-80.0513884259999,
							26.719431953000083
						],
						[
							-80.05175999999994,
							26.71945000000005
						],
						[
							-80.05235480999994,
							26.71945612500008
						],
						[
							-80.05338309299992,
							26.719478766000066
						],
						[
							-80.05336999999992,
							26.71993000000009
						],
						[
							-80.0533599659999,
							26.720316324000066
						],
						[
							-80.05334999999991,
							26.72070000000008
						],
						[
							-80.05333999999993,
							26.721070000000058
						],
						[
							-80.05331999999993,
							26.721550000000036
						],
						[
							-80.0533089299999,
							26.72189684700004
						],
						[
							-80.05328999999995,
							26.72249000000005
						],
						[
							-80.05326999999996,
							26.722960000000057
						],
						[
							-80.05335999999994,
							26.723460000000046
						],
						[
							-80.0532399999999,
							26.723910000000046
						],
						[
							-80.0532199999999,
							26.724440000000072
						],
						[
							-80.0526659649999,
							26.72441948000005
						],
						[
							-80.05205455799995,
							26.724394026000084
						],
						[
							-80.05159999999995,
							26.724380000000053
						],
						[
							-80.05126478699992,
							26.724374170000093
						],
						[
							-80.05071684399991,
							26.72435887200004
						],
						[
							-80.0497716459999,
							26.724339583000074
						],
						[
							-80.04950978999995,
							26.72433617300004
						],
						[
							-80.04866379599991,
							26.724641392000084
						],
						[
							-80.04865195699995,
							26.724607491000086
						],
						[
							-80.04863541599991,
							26.72455501700006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "West Palm Beach",
				"Name": "Providencia Park",
				"RegionID": "269150"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.43796815240684,
					28.510118106596437,
					-81.42601830212456,
					28.515844705992627
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.43420544389488,
							28.51030348924229
						],
						[
							-81.43637669595596,
							28.510118106596437
						],
						[
							-81.43647180465652,
							28.510396628427635
						],
						[
							-81.43654691693168,
							28.510587911525263
						],
						[
							-81.43658712472032,
							28.51066611297165
						],
						[
							-81.43586376224063,
							28.51069795796469
						],
						[
							-81.43590396283469,
							28.51097448599885
						],
						[
							-81.43598192056473,
							28.511369148974836
						],
						[
							-81.43629854756963,
							28.511685539457893
						],
						[
							-81.43653489839208,
							28.511921890280455
						],
						[
							-81.4368895990944,
							28.512316410264155
						],
						[
							-81.43688942642453,
							28.512829232463616
						],
						[
							-81.43708759023504,
							28.513619546770414
						],
						[
							-81.43795515090821,
							28.513746471685707
						],
						[
							-81.43795600706282,
							28.514488696545676
						],
						[
							-81.43796496520959,
							28.5153189272607
						],
						[
							-81.43796815240684,
							28.51563852832347
						],
						[
							-81.42606031035587,
							28.515844705992627
						],
						[
							-81.42604934762034,
							28.515404054386046
						],
						[
							-81.4260604191738,
							28.514600862687118
						],
						[
							-81.42606036521447,
							28.514547784700937
						],
						[
							-81.42606136526055,
							28.51447768075011
						],
						[
							-81.42601830212456,
							28.51352526724481
						],
						[
							-81.42602030491467,
							28.513323969296984
						],
						[
							-81.42602931881942,
							28.51234651956579
						],
						[
							-81.42603031976488,
							28.51230245458497
						],
						[
							-81.42602931881942,
							28.512255384069924
						],
						[
							-81.42602130675942,
							28.511628454092836
						],
						[
							-81.426024310495,
							28.511162764461623
						],
						[
							-81.42603031976488,
							28.510688060026396
						],
						[
							-81.42602926486009,
							28.510521810456822
						],
						[
							-81.43420544389488,
							28.51030348924229
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Richmond Estates",
				"RegionID": "269155"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.18149324899991,
					26.089076942000077,
					-80.1804642219999,
					26.093050000000062
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.18088499999993,
							26.08951200000007
						],
						[
							-80.18125776799991,
							26.089076942000077
						],
						[
							-80.18136711599993,
							26.090616924000074
						],
						[
							-80.18127979299993,
							26.09076246300009
						],
						[
							-80.18130889999992,
							26.090995324000062
						],
						[
							-80.18138652099992,
							26.091160268000067
						],
						[
							-80.18138652099992,
							26.091538668000055
						],
						[
							-80.1814253309999,
							26.091917068000043
						],
						[
							-80.18149324899991,
							26.092343981000056
						],
						[
							-80.18149324899991,
							26.092902381000048
						],
						[
							-80.18143454999995,
							26.092913984000067
						],
						[
							-80.18118253999997,
							26.092963800000064
						],
						[
							-80.18104999999991,
							26.092990000000043
						],
						[
							-80.18091896399994,
							26.093012463000036
						],
						[
							-80.18079643099992,
							26.09303346900009
						],
						[
							-80.18069999999994,
							26.093050000000062
						],
						[
							-80.18068708899995,
							26.092877344000048
						],
						[
							-80.18068282599995,
							26.092741642000078
						],
						[
							-80.18067704099991,
							26.092557475000035
						],
						[
							-80.1806718549999,
							26.092392389000054
						],
						[
							-80.18066515599992,
							26.09217914300007
						],
						[
							-80.18066118799993,
							26.092052830000057
						],
						[
							-80.18065446999992,
							26.091838975000087
						],
						[
							-80.18064746699991,
							26.09161603600006
						],
						[
							-80.18064288999994,
							26.091470336000043
						],
						[
							-80.18063802799992,
							26.091315553000072
						],
						[
							-80.18063194799993,
							26.091121997000073
						],
						[
							-80.18062249099995,
							26.090996175000043
						],
						[
							-80.1806065959999,
							26.09086106700005
						],
						[
							-80.18059619799993,
							26.090772685000047
						],
						[
							-80.18058999999994,
							26.090720000000093
						],
						[
							-80.18063942299995,
							26.09046168300006
						],
						[
							-80.1804642219999,
							26.090002822000088
						],
						[
							-80.18088499999993,
							26.08951200000007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "River Landings",
				"RegionID": "269157"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.11553987699995,
					26.111186504000045,
					-80.11205997499991,
					26.11790760000008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.11270745599995,
							26.11790329300004
						],
						[
							-80.11271309799992,
							26.117089643000043
						],
						[
							-80.11206044499994,
							26.117099841000083
						],
						[
							-80.11205999999993,
							26.111496000000045
						],
						[
							-80.11205997499991,
							26.111186504000045
						],
						[
							-80.11327827499991,
							26.11121419200009
						],
						[
							-80.11445886299992,
							26.11124230200005
						],
						[
							-80.1153696689999,
							26.111295879000068
						],
						[
							-80.11538899999994,
							26.11193200000008
						],
						[
							-80.11553987699995,
							26.116896927000084
						],
						[
							-80.11456330999994,
							26.116995004000046
						],
						[
							-80.11327548499992,
							26.11790760000008
						],
						[
							-80.11270745599995,
							26.11790329300004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Riviera Isles",
				"RegionID": "269164"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.4098169995789,
					28.542081999918825,
					-81.39561921294542,
					28.552961752314356
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.39561921294542,
							28.552961752314356
						],
						[
							-81.39562322482097,
							28.552924700246805
						],
						[
							-81.39564926289168,
							28.552760455265897
						],
						[
							-81.39571226939303,
							28.552468999385315
						],
						[
							-81.39580849954818,
							28.55216857906283
						],
						[
							-81.39587760165425,
							28.552024364681504
						],
						[
							-81.3960638782262,
							28.551705891368535
						],
						[
							-81.39610493857208,
							28.551652813382443
						],
						[
							-81.39616602951753,
							28.55154565736398
						],
						[
							-81.39631625226929,
							28.55139042358988
						],
						[
							-81.39673186854917,
							28.55099183327455
						],
						[
							-81.39691814422174,
							28.550779516833323
						],
						[
							-81.39694017761151,
							28.550742462967037
						],
						[
							-81.39705835212347,
							28.550544168754875
						],
						[
							-81.39727467324573,
							28.55008048101449
						],
						[
							-81.39733782004134,
							28.549868175365077
						],
						[
							-81.39736180226191,
							28.54954668932338
						],
						[
							-81.39736686454566,
							28.54933537652545
						],
						[
							-81.39737281895675,
							28.54908600801659
						],
						[
							-81.39736680968697,
							28.54886167303568
						],
						[
							-81.39734678088604,
							28.5481295880316
						],
						[
							-81.3973477818315,
							28.547487636678632
						],
						[
							-81.39734878367615,
							28.547155142035884
						],
						[
							-81.39731673543635,
							28.545679955332957
						],
						[
							-81.39730471779605,
							28.544936853634027
						],
						[
							-81.39729370200057,
							28.544217786316338
						],
						[
							-81.39728869457552,
							28.543851243341607
						],
						[
							-81.39728463503587,
							28.543672980628312
						],
						[
							-81.39999671058703,
							28.543710033595225
						],
						[
							-81.40158306248613,
							28.543710034494595
						],
						[
							-81.40229211495362,
							28.543845234971094
						],
						[
							-81.4032034699117,
							28.544080582150265
						],
						[
							-81.40381136753673,
							28.544080583049634
						],
						[
							-81.40555394875935,
							28.544043585840694
						],
						[
							-81.40772617388684,
							28.54411563592428
						],
						[
							-81.40958697188955,
							28.544456147123604
						],
						[
							-81.40975129691007,
							28.544486324773672
						],
						[
							-81.4096346458497,
							28.5420822607222
						],
						[
							-81.40967999955895,
							28.542081999918825
						],
						[
							-81.40968399974331,
							28.542162000009192
						],
						[
							-81.4098169995789,
							28.54480799967301
						],
						[
							-81.40969200011213,
							28.54477900013487
						],
						[
							-81.40978511501564,
							28.550527871241044
						],
						[
							-81.40967005575531,
							28.550528133843073
						],
						[
							-81.40968521382806,
							28.551675980817166
						],
						[
							-81.40568701514472,
							28.55170075174319
						],
						[
							-81.40569015377869,
							28.551814051929668
						],
						[
							-81.40569716489314,
							28.552070433351805
						],
						[
							-81.40568314266407,
							28.55279450539653
						],
						[
							-81.40568227122108,
							28.552871752662263
						],
						[
							-81.40565109172636,
							28.552871566502645
						],
						[
							-81.40469768267153,
							28.552882637156813
						],
						[
							-81.40456748872062,
							28.552883638102273
						],
						[
							-81.40364111598406,
							28.552895656641773
						],
						[
							-81.40259656603752,
							28.552908675227535
						],
						[
							-81.40162512557602,
							28.55292369840206
						],
						[
							-81.40114641556049,
							28.55292369840206
						],
						[
							-81.40056955983393,
							28.552928704927744
						],
						[
							-81.39974233375384,
							28.55293871977785
						],
						[
							-81.39825212207765,
							28.552936716987652
						],
						[
							-81.39743390990222,
							28.552944729047645
						],
						[
							-81.3960418448365,
							28.55295774853269
						],
						[
							-81.39592867774961,
							28.552958750377428
						],
						[
							-81.39568431486705,
							28.552960752268262
						],
						[
							-81.39561921294542,
							28.552961752314356
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Rock Lake",
				"RegionID": "269166"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.36446000799992,
					28.56555342900009,
					-81.35262699999993,
					28.571578397000053
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.35675093799995,
							28.570418999000083
						],
						[
							-81.35675099999992,
							28.57034900000008
						],
						[
							-81.35658399999994,
							28.57034900000008
						],
						[
							-81.35573799999992,
							28.57034900000008
						],
						[
							-81.35475099999991,
							28.57034800000008
						],
						[
							-81.35475099999991,
							28.57054700000009
						],
						[
							-81.35420099999993,
							28.57054700000009
						],
						[
							-81.35426199999995,
							28.57034800000008
						],
						[
							-81.35417299999995,
							28.57034800000008
						],
						[
							-81.35262699999993,
							28.57034800000008
						],
						[
							-81.35262699999993,
							28.570278000000087
						],
						[
							-81.35264499999994,
							28.570017000000064
						],
						[
							-81.35267199999993,
							28.569340000000068
						],
						[
							-81.35272617399994,
							28.56852847300007
						],
						[
							-81.3527719999999,
							28.56784200000004
						],
						[
							-81.35270413899991,
							28.567842789000053
						],
						[
							-81.35270254599993,
							28.567788690000043
						],
						[
							-81.35368102199993,
							28.567771718000074
						],
						[
							-81.35414885099993,
							28.56776583900006
						],
						[
							-81.35414557599995,
							28.567718509000088
						],
						[
							-81.35471154899994,
							28.56770962500008
						],
						[
							-81.35487479099993,
							28.567684587000088
						],
						[
							-81.35497096199992,
							28.56764657800005
						],
						[
							-81.35505806399993,
							28.567582436000066
						],
						[
							-81.3551371399999,
							28.567501131000085
						],
						[
							-81.35520836699993,
							28.567528524000068
						],
						[
							-81.35522430999993,
							28.567470271000047
						],
						[
							-81.3552443399999,
							28.56736912100007
						],
						[
							-81.35525252199994,
							28.56726692500007
						],
						[
							-81.35519710099993,
							28.56717888500009
						],
						[
							-81.35520027399991,
							28.567061666000086
						],
						[
							-81.35514906499992,
							28.565666469000064
						],
						[
							-81.35519927399992,
							28.565664593000065
						],
						[
							-81.3563339559999,
							28.565642560000075
						],
						[
							-81.35749868399995,
							28.565627538000058
						],
						[
							-81.35852720799994,
							28.565613517000088
						],
						[
							-81.35953370199991,
							28.565598495000074
						],
						[
							-81.35998236699993,
							28.56559048300005
						],
						[
							-81.36048911799992,
							28.56558547600008
						],
						[
							-81.36090673799993,
							28.56558547600008
						],
						[
							-81.36180006199993,
							28.565584474000048
						],
						[
							-81.36237491499992,
							28.56557646200008
						],
						[
							-81.3626693519999,
							28.565573459000067
						],
						[
							-81.3644420359999,
							28.56555342900009
						],
						[
							-81.36444798999993,
							28.56677624300005
						],
						[
							-81.36446000799992,
							28.56978670700005
						],
						[
							-81.36446000799992,
							28.569943941000076
						],
						[
							-81.36445900599995,
							28.570147241000086
						],
						[
							-81.3644580049999,
							28.57026942200008
						],
						[
							-81.3644580049999,
							28.570336522000048
						],
						[
							-81.3644580589999,
							28.57039218600005
						],
						[
							-81.36397999999991,
							28.57030300000008
						],
						[
							-81.36302160699995,
							28.57040392500005
						],
						[
							-81.3629862379999,
							28.57039567800007
						],
						[
							-81.36292992199992,
							28.57037859500008
						],
						[
							-81.36287484399992,
							28.570357865000062
						],
						[
							-81.36282123999992,
							28.570333577000042
						],
						[
							-81.36279214799993,
							28.570318566000083
						],
						[
							-81.36267121599991,
							28.570253354000045
						],
						[
							-81.36230849599991,
							28.570229212000072
						],
						[
							-81.36205406399995,
							28.570245293000085
						],
						[
							-81.36195844299995,
							28.57028036400004
						],
						[
							-81.36195760299995,
							28.570280925000077
						],
						[
							-81.36110542999995,
							28.570491466000078
						],
						[
							-81.36035244199991,
							28.570549437000068
						],
						[
							-81.36029692199992,
							28.570532595000092
						],
						[
							-81.36027316799994,
							28.57052415800007
						],
						[
							-81.35942416799992,
							28.570209159000058
						],
						[
							-81.35940772999993,
							28.570202876000053
						],
						[
							-81.35934949699993,
							28.57017996500008
						],
						[
							-81.35795548999994,
							28.56964210700005
						],
						[
							-81.3579526289999,
							28.569666385000062
						],
						[
							-81.35794304199993,
							28.569724449000034
						],
						[
							-81.35793419599992,
							28.56976419500006
						],
						[
							-81.35783019599995,
							28.570186196000066
						],
						[
							-81.35782567799993,
							28.570203762000062
						],
						[
							-81.35780859499994,
							28.57026007800005
						],
						[
							-81.35778786499993,
							28.57031515600005
						],
						[
							-81.35778276799994,
							28.570327214000088
						],
						[
							-81.35765141299993,
							28.570631718000072
						],
						[
							-81.35761105199992,
							28.570726221000086
						],
						[
							-81.35759057799993,
							28.570770760000073
						],
						[
							-81.35756283599994,
							28.570822661000083
						],
						[
							-81.35753175899993,
							28.570872637000036
						],
						[
							-81.35751426199994,
							28.570897879000086
						],
						[
							-81.35744526099995,
							28.57099387900007
						],
						[
							-81.35744387199992,
							28.57099580600004
						],
						[
							-81.35737087199993,
							28.57109680600007
						],
						[
							-81.35735547999991,
							28.571117473000072
						],
						[
							-81.3573181459999,
							28.571162964000052
						],
						[
							-81.35727791699992,
							28.571205917000043
						],
						[
							-81.35723496399994,
							28.571246146000078
						],
						[
							-81.35722455199993,
							28.571255138000083
						],
						[
							-81.35703755199995,
							28.57141413800008
						],
						[
							-81.35700247299991,
							28.571442480000087
						],
						[
							-81.35695463699994,
							28.571476759000063
						],
						[
							-81.35690466099993,
							28.57150783600008
						],
						[
							-81.35685275999992,
							28.571535578000066
						],
						[
							-81.35679915599991,
							28.57155986500004
						],
						[
							-81.35674991799993,
							28.571578397000053
						],
						[
							-81.35675093799995,
							28.570418999000083
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Rowena Gardens",
				"RegionID": "269171"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.14966699999991,
					26.011464683000042,
					-80.1430965969999,
					26.033567000000062
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.14907796499995,
							26.011464683000042
						],
						[
							-80.14966699999991,
							26.033467000000087
						],
						[
							-80.14776699999994,
							26.033467000000087
						],
						[
							-80.14546699999994,
							26.033467000000087
						],
						[
							-80.14346699999993,
							26.033567000000062
						],
						[
							-80.1430965969999,
							26.011644926000088
						],
						[
							-80.14907796499995,
							26.011464683000042
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Hollywood",
				"Name": "Royal Poinciana",
				"RegionID": "269173"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.44325100011662,
					28.575979000332225,
					-81.4235579998693,
					28.589094283830924
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.44088435067628,
							28.589094283830924
						],
						[
							-81.4263467884889,
							28.58891607597623
						],
						[
							-81.42456413167811,
							28.58891607597623
						],
						[
							-81.42452563080265,
							28.588915801683108
						],
						[
							-81.42452101638135,
							28.586624191556297
						],
						[
							-81.42428300001438,
							28.58661300039283
						],
						[
							-81.42429200042929,
							28.586378000351985
						],
						[
							-81.4242910003832,
							28.586009000429364
						],
						[
							-81.42452100019351,
							28.586008000383273
						],
						[
							-81.42457900016917,
							28.586013999760624
						],
						[
							-81.42458100026136,
							28.585872999556315
						],
						[
							-81.42457600003081,
							28.58573300029728
						],
						[
							-81.42450813808985,
							28.58573657150524
						],
						[
							-81.4242910003832,
							28.585748000089538
						],
						[
							-81.4235579998693,
							28.58573300029728
						],
						[
							-81.4235589999154,
							28.585373999936465
						],
						[
							-81.42450195075432,
							28.58535235505387
						],
						[
							-81.42456100023874,
							28.58535099977567
						],
						[
							-81.42455900014656,
							28.585288999615642
						],
						[
							-81.42456200028482,
							28.583574999746226
						],
						[
							-81.42456400037709,
							28.582295000097908
						],
						[
							-81.42543099987329,
							28.58229900028236
						],
						[
							-81.42543400001156,
							28.582217000099625
						],
						[
							-81.42543600010374,
							28.58215199980133
						],
						[
							-81.42456400037709,
							28.582153999893507
						],
						[
							-81.42456463529837,
							28.581717124540194
						],
						[
							-81.43046631830448,
							28.581717124540194
						],
						[
							-81.43046599994447,
							28.581782999878797
						],
						[
							-81.43045999966785,
							28.58236399968147
						],
						[
							-81.4305829999418,
							28.582356000211846
						],
						[
							-81.43076100005317,
							28.582356000211846
						],
						[
							-81.43079599986787,
							28.581777999648438
						],
						[
							-81.43079938221808,
							28.581717124540194
						],
						[
							-81.43080200014441,
							28.581670000066005
						],
						[
							-81.43080200014441,
							28.581162000031256
						],
						[
							-81.43080200014441,
							28.580180999776623
						],
						[
							-81.43080200014441,
							28.57872434090612
						],
						[
							-81.43080200014441,
							28.57870099990224
						],
						[
							-81.43133699962512,
							28.578705000086508
						],
						[
							-81.43133699962512,
							28.578074999823883
						],
						[
							-81.43169199980157,
							28.578077999962247
						],
						[
							-81.43169199980157,
							28.578212999890106
						],
						[
							-81.43386800028298,
							28.578212999890106
						],
						[
							-81.43403900007162,
							28.578212999890106
						],
						[
							-81.43417099986112,
							28.578210999797836
						],
						[
							-81.43479299975485,
							28.578313000003096
						],
						[
							-81.4355509996226,
							28.578313000003096
						],
						[
							-81.43709299965703,
							28.578313000003096
						],
						[
							-81.43843300027255,
							28.578322999564627
						],
						[
							-81.43919300023241,
							28.578313000003096
						],
						[
							-81.44034000004514,
							28.578311999957098
						],
						[
							-81.44033799995296,
							28.578178000075326
						],
						[
							-81.44043900011212,
							28.578178000075326
						],
						[
							-81.44043900011212,
							28.57809275064212
						],
						[
							-81.44043900011212,
							28.576277999726006
						],
						[
							-81.44043900011212,
							28.575985999755666
						],
						[
							-81.44047099978854,
							28.575986999801756
						],
						[
							-81.44061199999295,
							28.575986999801756
						],
						[
							-81.4425520003875,
							28.575979000332225
						],
						[
							-81.44255799976467,
							28.57641399969995
						],
						[
							-81.44255799976467,
							28.57762099958044
						],
						[
							-81.44255799976467,
							28.57786099985183
						],
						[
							-81.44255692057826,
							28.578082898569363
						],
						[
							-81.44255599967249,
							28.57827199991177
						],
						[
							-81.44269299969244,
							28.578278000188313
						],
						[
							-81.44269699987689,
							28.578411000023817
						],
						[
							-81.44310807098329,
							28.5783531844093
						],
						[
							-81.44311193387917,
							28.585776072742092
						],
						[
							-81.44325100011662,
							28.585775999790847
						],
						[
							-81.44324600000287,
							28.58581899976501
						],
						[
							-81.44323100021062,
							28.58603199969106
						],
						[
							-81.44323222688591,
							28.58633050086044
						],
						[
							-81.4432432046304,
							28.58900186132039
						],
						[
							-81.44311361530349,
							28.589007074775125
						],
						[
							-81.44304956019268,
							28.58900721147218
						],
						[
							-81.44200401020005,
							28.58904927456208
						],
						[
							-81.44185278560356,
							28.589056284777243
						],
						[
							-81.44094443887765,
							28.58909233859744
						],
						[
							-81.44088435067628,
							28.589094283830924
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Seaboard Industrial",
				"RegionID": "269175"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.45125899999994,
					28.589001861000046,
					-81.44088435099991,
					28.601941000000068
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.44667299999992,
							28.601941000000068
						],
						[
							-81.44482055399993,
							28.601931824000076
						],
						[
							-81.44361718999994,
							28.60193500700007
						],
						[
							-81.44210024599994,
							28.601939021000078
						],
						[
							-81.4414146929999,
							28.60194000000007
						],
						[
							-81.44122999999992,
							28.60194000000007
						],
						[
							-81.44108064799991,
							28.60193802000009
						],
						[
							-81.44107858399991,
							28.601762128000075
						],
						[
							-81.44103544199993,
							28.598184693000064
						],
						[
							-81.44303066399995,
							28.59814689400008
						],
						[
							-81.4429994859999,
							28.59616582800004
						],
						[
							-81.4429365229999,
							28.592750631000058
						],
						[
							-81.44097335299995,
							28.59275089600004
						],
						[
							-81.44088435099991,
							28.589094284000055
						],
						[
							-81.4409444389999,
							28.589092339000047
						],
						[
							-81.44185278599991,
							28.589056285000087
						],
						[
							-81.44200400999995,
							28.589049275000036
						],
						[
							-81.4430495599999,
							28.589007211000084
						],
						[
							-81.4431136149999,
							28.58900707500004
						],
						[
							-81.44324320499993,
							28.589001861000046
						],
						[
							-81.44324484099991,
							28.58940000700005
						],
						[
							-81.44324599999993,
							28.58968200000004
						],
						[
							-81.44348599999995,
							28.589685000000088
						],
						[
							-81.44431299999991,
							28.589691000000073
						],
						[
							-81.44499899999994,
							28.589694000000065
						],
						[
							-81.4461149999999,
							28.589690000000076
						],
						[
							-81.4461149999999,
							28.589825000000076
						],
						[
							-81.4461149999999,
							28.59009400000008
						],
						[
							-81.4461149999999,
							28.59169901900009
						],
						[
							-81.4461149999999,
							28.59200300000009
						],
						[
							-81.44640699999991,
							28.592049000000088
						],
						[
							-81.4464074999999,
							28.592050000000086
						],
						[
							-81.4464079999999,
							28.592051000000083
						],
						[
							-81.4468829999999,
							28.59209100000004
						],
						[
							-81.44697899999994,
							28.592101000000074
						],
						[
							-81.44726425099992,
							28.592139932000066
						],
						[
							-81.44735999999995,
							28.592153000000053
						],
						[
							-81.44745599999993,
							28.592167000000074
						],
						[
							-81.44740721799991,
							28.592318996000074
						],
						[
							-81.44736099999994,
							28.592463000000066
						],
						[
							-81.44720999999993,
							28.592939000000058
						],
						[
							-81.44720999999993,
							28.595032000000064
						],
						[
							-81.44909599999994,
							28.595032000000064
						],
						[
							-81.44909299999995,
							28.595278000000064
						],
						[
							-81.44909299999995,
							28.59530354900005
						],
						[
							-81.44909299999995,
							28.595458000000065
						],
						[
							-81.44944099999992,
							28.59545300000008
						],
						[
							-81.45117499999992,
							28.59545600000007
						],
						[
							-81.45117743499992,
							28.595871620000082
						],
						[
							-81.4511809999999,
							28.596480000000042
						],
						[
							-81.45119299999993,
							28.598431000000062
						],
						[
							-81.45059299999991,
							28.59842800000007
						],
						[
							-81.45059299999991,
							28.60021800000004
						],
						[
							-81.45119199999993,
							28.60021800000004
						],
						[
							-81.45125899999994,
							28.600210000000065
						],
						[
							-81.45125899999994,
							28.600401385000055
						],
						[
							-81.45125899999994,
							28.601805639000077
						],
						[
							-81.45125899999994,
							28.601941000000068
						],
						[
							-81.4471133479999,
							28.601941000000068
						],
						[
							-81.44667299999992,
							28.601941000000068
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Signal Hill",
				"RegionID": "269180"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.40107699999993,
					28.50733200000008,
					-81.38049754199994,
					28.535237531000064
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.38163152699991,
							28.520659849000083
						],
						[
							-81.3815713809999,
							28.520118042000036
						],
						[
							-81.38126988599993,
							28.519273802000043
						],
						[
							-81.38108966999994,
							28.51692330900005
						],
						[
							-81.3807882239999,
							28.514694001000066
						],
						[
							-81.38049754199994,
							28.512910385000055
						],
						[
							-81.38103058299993,
							28.512915363000047
						],
						[
							-81.38168655499993,
							28.512917366000067
						],
						[
							-81.3831617429999,
							28.51293038600005
						],
						[
							-81.38363344299995,
							28.512943405000044
						],
						[
							-81.3837616319999,
							28.512960431000067
						],
						[
							-81.38381070599992,
							28.51296844400008
						],
						[
							-81.38395091299992,
							28.513020520000055
						],
						[
							-81.38409512899995,
							28.513096634000078
						],
						[
							-81.38430543999993,
							28.513264882000044
						],
						[
							-81.38436953399992,
							28.51333899200006
						],
						[
							-81.38458393899992,
							28.513679361000072
						],
						[
							-81.38457099999994,
							28.513201000000038
						],
						[
							-81.38469199999992,
							28.513283000000058
						],
						[
							-81.3848569999999,
							28.513461000000063
						],
						[
							-81.3849889999999,
							28.513711000000058
						],
						[
							-81.38515099999995,
							28.513933000000065
						],
						[
							-81.3852829999999,
							28.514094000000057
						],
						[
							-81.38542499999994,
							28.514218000000085
						],
						[
							-81.38607999999994,
							28.514424000000076
						],
						[
							-81.38750199999993,
							28.514406000000065
						],
						[
							-81.38879199999991,
							28.51440800000006
						],
						[
							-81.38915299999991,
							28.51440900000006
						],
						[
							-81.39048699999995,
							28.51441000000006
						],
						[
							-81.3904859999999,
							28.51416800000004
						],
						[
							-81.39063699999991,
							28.51416800000004
						],
						[
							-81.39091699999994,
							28.51397200000008
						],
						[
							-81.39091699999994,
							28.513795000000073
						],
						[
							-81.39098199999995,
							28.51368800000006
						],
						[
							-81.39097499999991,
							28.513600000000054
						],
						[
							-81.39103599999993,
							28.513596000000064
						],
						[
							-81.39116199999995,
							28.51358700000009
						],
						[
							-81.39123199999995,
							28.51345800000007
						],
						[
							-81.39128199999993,
							28.513370000000066
						],
						[
							-81.39128199999993,
							28.513191000000067
						],
						[
							-81.39134899999993,
							28.51319000000007
						],
						[
							-81.39148899999992,
							28.513022000000035
						],
						[
							-81.39149399999991,
							28.512942000000066
						],
						[
							-81.39120999999994,
							28.512942000000066
						],
						[
							-81.39120999999994,
							28.512878000000057
						],
						[
							-81.3912059999999,
							28.512823000000083
						],
						[
							-81.39143199999995,
							28.512823000000083
						],
						[
							-81.39149099999992,
							28.512807000000066
						],
						[
							-81.3915639999999,
							28.512788000000057
						],
						[
							-81.3917689999999,
							28.51265300000006
						],
						[
							-81.39184999999992,
							28.512544000000048
						],
						[
							-81.39198799999991,
							28.51227800000004
						],
						[
							-81.39221299999991,
							28.511990000000083
						],
						[
							-81.39233299999995,
							28.51186000000007
						],
						[
							-81.39253699999995,
							28.511769000000072
						],
						[
							-81.3928699999999,
							28.511772000000065
						],
						[
							-81.39286799999991,
							28.511519000000078
						],
						[
							-81.3928909999999,
							28.511519000000078
						],
						[
							-81.3928909999999,
							28.51174800000007
						],
						[
							-81.39288999999991,
							28.51180800000009
						],
						[
							-81.3928919999999,
							28.511880000000076
						],
						[
							-81.39292599999993,
							28.511880000000076
						],
						[
							-81.39319199999994,
							28.511880000000076
						],
						[
							-81.39328699999993,
							28.511885000000063
						],
						[
							-81.39326599999993,
							28.51151100000004
						],
						[
							-81.39389199999994,
							28.511480000000066
						],
						[
							-81.39383099999992,
							28.511298000000068
						],
						[
							-81.39429199999995,
							28.511280000000056
						],
						[
							-81.39430599999992,
							28.510980000000075
						],
						[
							-81.39438999999993,
							28.510980000000075
						],
						[
							-81.39438399999995,
							28.510879000000045
						],
						[
							-81.39467899999994,
							28.510879000000045
						],
						[
							-81.39479099999994,
							28.51073400000007
						],
						[
							-81.39493899999991,
							28.510710000000074
						],
						[
							-81.39504299999993,
							28.51070800000008
						],
						[
							-81.39504299999993,
							28.510619000000077
						],
						[
							-81.3951879999999,
							28.510619000000077
						],
						[
							-81.3951879999999,
							28.510180000000048
						],
						[
							-81.39537699999994,
							28.510069000000044
						],
						[
							-81.39538199999993,
							28.50951500000008
						],
						[
							-81.39600799999994,
							28.509110000000078
						],
						[
							-81.39614799999993,
							28.509022000000073
						],
						[
							-81.39633299999991,
							28.50890700000008
						],
						[
							-81.39684999999992,
							28.50858400000004
						],
						[
							-81.39685899999995,
							28.50818000000004
						],
						[
							-81.3968539999999,
							28.508110000000045
						],
						[
							-81.39691699999992,
							28.508110000000045
						],
						[
							-81.39691399999992,
							28.507580000000075
						],
						[
							-81.39691299999993,
							28.507341000000054
						],
						[
							-81.3969919999999,
							28.50733200000008
						],
						[
							-81.39706799999993,
							28.50733200000008
						],
						[
							-81.39706199999995,
							28.507570000000044
						],
						[
							-81.39706799999993,
							28.508114000000035
						],
						[
							-81.39736799999991,
							28.50811200000004
						],
						[
							-81.39749099999995,
							28.508113000000037
						],
						[
							-81.39749199999994,
							28.50818000000004
						],
						[
							-81.39749199999994,
							28.508980000000065
						],
						[
							-81.39749199999994,
							28.50910300000004
						],
						[
							-81.39908899999995,
							28.50918900000005
						],
						[
							-81.40107699999993,
							28.50918500000006
						],
						[
							-81.40107699999993,
							28.509374000000037
						],
						[
							-81.40106999999995,
							28.509509465000065
						],
						[
							-81.40106999999995,
							28.509652561000053
						],
						[
							-81.40020161899992,
							28.50966844900006
						],
						[
							-81.39877723399991,
							28.510043287000087
						],
						[
							-81.39722790199994,
							28.51059304900008
						],
						[
							-81.39600343099994,
							28.511117823000063
						],
						[
							-81.39275483299991,
							28.512867068000048
						],
						[
							-81.39138042599991,
							28.513791669000057
						],
						[
							-81.3903808579999,
							28.514600000000087
						],
						[
							-81.39017927399993,
							28.514717998000037
						],
						[
							-81.38959628599991,
							28.515111621000074
						],
						[
							-81.38876405199994,
							28.515675456000054
						],
						[
							-81.38839950999994,
							28.515945859000055
						],
						[
							-81.38768545199991,
							28.51670899000004
						],
						[
							-81.38758325999993,
							28.516810105000047
						],
						[
							-81.38746612599994,
							28.516990407000037
						],
						[
							-81.38719672799994,
							28.517347937000068
						],
						[
							-81.38704049599994,
							28.517578279000077
						],
						[
							-81.38682717899991,
							28.517964852000095
						],
						[
							-81.3866839669999,
							28.51828432600007
						],
						[
							-81.3865307399999,
							28.518702947000065
						],
						[
							-81.38641256499994,
							28.519130580000084
						],
						[
							-81.38633344699991,
							28.51950914200006
						],
						[
							-81.38630941199995,
							28.519729470000073
						],
						[
							-81.38630352799993,
							28.51987281600009
						],
						[
							-81.38608395199992,
							28.51986052700005
						],
						[
							-81.38606691799993,
							28.52015222600005
						],
						[
							-81.3862875129999,
							28.52015096200006
						],
						[
							-81.38628136999995,
							28.52040747500007
						],
						[
							-81.3862993969999,
							28.523191603000043
						],
						[
							-81.3862993969999,
							28.523719386000042
						],
						[
							-81.3862993969999,
							28.524114974000042
						],
						[
							-81.38631642199994,
							28.52470184400005
						],
						[
							-81.38632743799991,
							28.525086413000054
						],
						[
							-81.38634546399993,
							28.526138975000038
						],
						[
							-81.3863534759999,
							28.526575622000053
						],
						[
							-81.38635948599995,
							28.527023286000087
						],
						[
							-81.3863965409999,
							28.52877688800004
						],
						[
							-81.38638452299995,
							28.529114387000053
						],
						[
							-81.38637450699991,
							28.52939280000004
						],
						[
							-81.38634446299994,
							28.529671214000075
						],
						[
							-81.38633645099992,
							28.529756339000073
						],
						[
							-81.38632743799991,
							28.529835457000047
						],
						[
							-81.3862563319999,
							28.53020400300005
						],
						[
							-81.3860660499999,
							28.53069473100004
						],
						[
							-81.38601697699994,
							28.530836942000064
						],
						[
							-81.38590479399994,
							28.531078215000036
						],
						[
							-81.3858096699999,
							28.531304635000083
						],
						[
							-81.38567246699995,
							28.531546995000042
						],
						[
							-81.38510061799991,
							28.532408273000044
						],
						[
							-81.38486727199995,
							28.532735758000058
						],
						[
							-81.38483422399992,
							28.53278282800005
						],
						[
							-81.38479917099995,
							28.532831900000076
						],
						[
							-81.38473908299994,
							28.532919031000066
						],
						[
							-81.38442862199992,
							28.533367695000038
						],
						[
							-81.38423633699995,
							28.53363108600007
						],
						[
							-81.38401500899994,
							28.533997629000055
						],
						[
							-81.38368952499991,
							28.534540435000054
						],
						[
							-81.38360039399993,
							28.534715695000045
						],
						[
							-81.38348422199994,
							28.534946036000065
						],
						[
							-81.38342312999993,
							28.53509325400006
						],
						[
							-81.3833571049999,
							28.535237531000064
						],
						[
							-81.38315773699992,
							28.535204419000085
						],
						[
							-81.38286528899994,
							28.535177436000083
						],
						[
							-81.38243065799992,
							28.531094324000037
						],
						[
							-81.38193392199992,
							28.52638634200008
						],
						[
							-81.3816314739999,
							28.523010335000038
						],
						[
							-81.38157138399993,
							28.522045904000038
						],
						[
							-81.38157138399993,
							28.521202653000046
						],
						[
							-81.38163152699991,
							28.520659849000083
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "South Division",
				"RegionID": "269182"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.65098103699995,
					30.28464800900008,
					-81.63551190499993,
					30.300079186000065
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.63944990599992,
							30.284908009000052
						],
						[
							-81.6399539059999,
							30.284843009000042
						],
						[
							-81.6403109769999,
							30.284808833000053
						],
						[
							-81.64037683799995,
							30.284886183000083
						],
						[
							-81.64093790599992,
							30.284815008000066
						],
						[
							-81.64211190599991,
							30.28482700800004
						],
						[
							-81.64382303899993,
							30.284845141000062
						],
						[
							-81.64382185099993,
							30.284761006000053
						],
						[
							-81.64476390599992,
							30.284734008000047
						],
						[
							-81.64563790599993,
							30.284712008000042
						],
						[
							-81.64748390499994,
							30.284672008000086
						],
						[
							-81.64965090499993,
							30.284655008000072
						],
						[
							-81.65081290599994,
							30.28464800900008
						],
						[
							-81.65098103699995,
							30.284664983000084
						],
						[
							-81.65086990599991,
							30.285109008000067
						],
						[
							-81.65079290599994,
							30.285370008000086
						],
						[
							-81.6507189049999,
							30.285604008000064
						],
						[
							-81.65060490499991,
							30.28593600900007
						],
						[
							-81.65047790599994,
							30.286269009000083
						],
						[
							-81.65035090499993,
							30.28656600900007
						],
						[
							-81.6501989059999,
							30.28691100900005
						],
						[
							-81.64994490499993,
							30.28747900900004
						],
						[
							-81.6497519049999,
							30.287920008000075
						],
						[
							-81.64947290499993,
							30.28854700800008
						],
						[
							-81.64926690599992,
							30.289063008000085
						],
						[
							-81.64921290599995,
							30.28921300900004
						],
						[
							-81.64912590499995,
							30.28945300900006
						],
						[
							-81.64901690599993,
							30.289756009000087
						],
						[
							-81.64890390599993,
							30.29011400900004
						],
						[
							-81.64885190599995,
							30.29032500800008
						],
						[
							-81.6488069049999,
							30.290508009000064
						],
						[
							-81.64869990599993,
							30.29097700800008
						],
						[
							-81.6486449059999,
							30.291241009000085
						],
						[
							-81.64851390599995,
							30.29186500900005
						],
						[
							-81.64836090599994,
							30.292589009000043
						],
						[
							-81.64817090499992,
							30.293475008000087
						],
						[
							-81.64796390599992,
							30.29444900800007
						],
						[
							-81.64789490499993,
							30.294765008000073
						],
						[
							-81.64780982499991,
							30.295119961000065
						],
						[
							-81.64779690599994,
							30.295176008000055
						],
						[
							-81.64772290499991,
							30.29567800800004
						],
						[
							-81.64769590599991,
							30.295939008000065
						],
						[
							-81.64769190599992,
							30.29611800900005
						],
						[
							-81.6476999059999,
							30.29628500800004
						],
						[
							-81.64772590599995,
							30.29643900800005
						],
						[
							-81.64780690599991,
							30.296802009000093
						],
						[
							-81.64781681799991,
							30.29684903200007
						],
						[
							-81.64789690499993,
							30.297105008000077
						],
						[
							-81.64798890599991,
							30.29733100800007
						],
						[
							-81.6481429879999,
							30.29761998400005
						],
						[
							-81.64815182599995,
							30.29775203300005
						],
						[
							-81.64846008399991,
							30.298260067000058
						],
						[
							-81.6475219049999,
							30.298658009000064
						],
						[
							-81.64665190599993,
							30.299030009000035
						],
						[
							-81.6457669049999,
							30.299404009000057
						],
						[
							-81.6455609059999,
							30.299500011000074
						],
						[
							-81.64546990999992,
							30.299582009000066
						],
						[
							-81.64540090499992,
							30.29970400800005
						],
						[
							-81.6452260069999,
							30.300064093000056
						],
						[
							-81.64520687099991,
							30.300079186000065
						],
						[
							-81.64509490599994,
							30.29988400900004
						],
						[
							-81.6449129049999,
							30.29964100800004
						],
						[
							-81.64488090599991,
							30.299606008000065
						],
						[
							-81.64453290599994,
							30.29916900800004
						],
						[
							-81.6439449049999,
							30.29831400800009
						],
						[
							-81.64327505799992,
							30.297378965000068
						],
						[
							-81.6427899059999,
							30.296702009000057
						],
						[
							-81.64144190699994,
							30.295127008000065
						],
						[
							-81.64122190499995,
							30.294724008000063
						],
						[
							-81.64044390499993,
							30.29360200900004
						],
						[
							-81.63809490599994,
							30.29032200900008
						],
						[
							-81.63551190499993,
							30.286706006000088
						],
						[
							-81.63716390499991,
							30.285799009000076
						],
						[
							-81.63798490499994,
							30.285383008000053
						],
						[
							-81.63853290499992,
							30.285172009000064
						],
						[
							-81.6388319049999,
							30.285067009000045
						],
						[
							-81.63944990599992,
							30.284908009000052
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "South Riverside",
				"RegionID": "269189"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.36779699999994,
					28.49500800000004,
					-81.35972599999991,
					28.506870322000054
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.36444677499992,
							28.506146089000087
						],
						[
							-81.36436634199993,
							28.50612469000004
						],
						[
							-81.3643479559999,
							28.50613227400004
						],
						[
							-81.36434296499995,
							28.506218776000082
						],
						[
							-81.3636767239999,
							28.506132085000047
						],
						[
							-81.3636909999999,
							28.505480000000095
						],
						[
							-81.36369045899994,
							28.50543773600009
						],
						[
							-81.36368199999993,
							28.50477700000005
						],
						[
							-81.36366299999992,
							28.503242000000057
						],
						[
							-81.35982799999994,
							28.503231000000085
						],
						[
							-81.3598189999999,
							28.503081000000066
						],
						[
							-81.3598189999999,
							28.502781000000084
						],
						[
							-81.3597749999999,
							28.501486000000057
						],
						[
							-81.35973699999994,
							28.50038200000006
						],
						[
							-81.35975599999995,
							28.498650000000055
						],
						[
							-81.3597494249999,
							28.49850315900005
						],
						[
							-81.35972599999991,
							28.49798000000004
						],
						[
							-81.3597279999999,
							28.49765100000008
						],
						[
							-81.35988299999991,
							28.497652000000077
						],
						[
							-81.36249099999992,
							28.497653000000074
						],
						[
							-81.36269138499996,
							28.497653000000074
						],
						[
							-81.36275499999994,
							28.497653000000074
						],
						[
							-81.36365099999995,
							28.496770000000083
						],
						[
							-81.36425974999992,
							28.496169897000073
						],
						[
							-81.36435499999993,
							28.496076000000073
						],
						[
							-81.36490502499993,
							28.495538556000042
						],
						[
							-81.3654479999999,
							28.49500800000004
						],
						[
							-81.36464699999993,
							28.49642700000004
						],
						[
							-81.36393599999992,
							28.49768700000004
						],
						[
							-81.36373966399992,
							28.49802865500004
						],
						[
							-81.36342799999994,
							28.498571000000084
						],
						[
							-81.3634261869999,
							28.498652573000072
						],
						[
							-81.36342499999995,
							28.498706000000087
						],
						[
							-81.3638279999999,
							28.49871600000006
						],
						[
							-81.36439199999995,
							28.49871600000006
						],
						[
							-81.36508299999991,
							28.498706000000087
						],
						[
							-81.36560099999991,
							28.49871100000007
						],
						[
							-81.36560099999991,
							28.500740827000072
						],
						[
							-81.36560099999991,
							28.500781000000075
						],
						[
							-81.36560099999991,
							28.501681000000076
						],
						[
							-81.36560099999991,
							28.502077000000043
						],
						[
							-81.3656049999999,
							28.502181000000064
						],
						[
							-81.36589199999992,
							28.502181000000064
						],
						[
							-81.36748399999993,
							28.502196000000083
						],
						[
							-81.36748498499992,
							28.502256756000065
						],
						[
							-81.36748699999993,
							28.50238100000007
						],
						[
							-81.36748699999993,
							28.502826000000084
						],
						[
							-81.36748699999993,
							28.503464181000083
						],
						[
							-81.36748699999993,
							28.50374684700006
						],
						[
							-81.36748699999993,
							28.50377700000007
						],
						[
							-81.36754699999995,
							28.50389400000006
						],
						[
							-81.36759399999994,
							28.503921000000048
						],
						[
							-81.36766799999992,
							28.503963000000056
						],
						[
							-81.36776404599993,
							28.503963000000056
						],
						[
							-81.36779699999994,
							28.503963000000056
						],
						[
							-81.36779199999995,
							28.50568000000004
						],
						[
							-81.36779047399995,
							28.50658030900007
						],
						[
							-81.3677790239999,
							28.50658248600007
						],
						[
							-81.36773946799991,
							28.506589099000053
						],
						[
							-81.36758600299994,
							28.506611249000063
						],
						[
							-81.36756413099994,
							28.506621813000038
						],
						[
							-81.36751715499993,
							28.506642865000064
						],
						[
							-81.36746207699991,
							28.506663595000077
						],
						[
							-81.36740576099993,
							28.506680678000066
						],
						[
							-81.36735202099993,
							28.506693324000082
						],
						[
							-81.36721982499995,
							28.506720176000044
						],
						[
							-81.3671841549999,
							28.506735865000056
						],
						[
							-81.3671290769999,
							28.50675659500007
						],
						[
							-81.36707276099992,
							28.50677367800006
						],
						[
							-81.36706458399993,
							28.50677582800006
						],
						[
							-81.36687458399992,
							28.50682482800005
						],
						[
							-81.36682544899992,
							28.50683604200009
						],
						[
							-81.36676738499995,
							28.506845628000065
						],
						[
							-81.36673948499993,
							28.50684885900006
						],
						[
							-81.36656948599995,
							28.506865859000072
						],
						[
							-81.36653881899991,
							28.506868396000073
						],
						[
							-81.36647999999991,
							28.506870322000054
						],
						[
							-81.36647049999993,
							28.506870272000075
						],
						[
							-81.36618649999991,
							28.50686727200008
						],
						[
							-81.36613718099994,
							28.50686539600008
						],
						[
							-81.36607861499994,
							28.50685962800009
						],
						[
							-81.3660205509999,
							28.506850042000053
						],
						[
							-81.36596323799995,
							28.50683667800007
						],
						[
							-81.36590692199991,
							28.50681959500008
						],
						[
							-81.36590382799994,
							28.50681853800006
						],
						[
							-81.36577282799993,
							28.50677353800006
						],
						[
							-81.36572084399995,
							28.506753865000064
						],
						[
							-81.36566723999994,
							28.506729577000044
						],
						[
							-81.36561533899993,
							28.506701835000058
						],
						[
							-81.3655763189999,
							28.506677964000062
						],
						[
							-81.36491040499993,
							28.50624692300005
						],
						[
							-81.36487929299994,
							28.506236116000085
						],
						[
							-81.36449777999991,
							28.506158080000034
						],
						[
							-81.36444677499992,
							28.506146089000087
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Southern Oaks",
				"RegionID": "269191"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.62823005599995,
					30.169312012000038,
					-81.60247688599992,
					30.183847175000043
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.61711827399995,
							30.183732969000065
						],
						[
							-81.61414886099993,
							30.18350455200005
						],
						[
							-81.61037999099995,
							30.18350455200005
						],
						[
							-81.6075819269999,
							30.183592024000063
						],
						[
							-81.6073679079999,
							30.18304801100004
						],
						[
							-81.60674990699994,
							30.18162201100006
						],
						[
							-81.60655190799991,
							30.181133011000046
						],
						[
							-81.6062699069999,
							30.180479010000056
						],
						[
							-81.60591890699993,
							30.179636011000074
						],
						[
							-81.6056819069999,
							30.17910401100005
						],
						[
							-81.60546090799994,
							30.178559011000065
						],
						[
							-81.60522490799991,
							30.178009011000086
						],
						[
							-81.60484290799991,
							30.17706301100009
						],
						[
							-81.60475190799991,
							30.176868010000078
						],
						[
							-81.60462990699995,
							30.176563010000056
						],
						[
							-81.60436990699992,
							30.175991010000075
						],
						[
							-81.6041949079999,
							30.175533011000084
						],
						[
							-81.60409490799992,
							30.175234010000054
						],
						[
							-81.60402990799992,
							30.174990011000094
						],
						[
							-81.60378290799991,
							30.174036011000055
						],
						[
							-81.60365290699991,
							30.173586011000058
						],
						[
							-81.60283890799991,
							30.170617011000047
						],
						[
							-81.60260890699993,
							30.169850009000072
						],
						[
							-81.60247688599992,
							30.169312012000038
						],
						[
							-81.60286590699992,
							30.169368011000078
						],
						[
							-81.60331190799991,
							30.169424010000057
						],
						[
							-81.60358290799991,
							30.169469010000057
						],
						[
							-81.60407290699993,
							30.169545011000082
						],
						[
							-81.60456190799994,
							30.169633010000037
						],
						[
							-81.60525690799994,
							30.169778011000062
						],
						[
							-81.60584790799993,
							30.169905011000083
						],
						[
							-81.60677790799991,
							30.170124010000052
						],
						[
							-81.60720290699993,
							30.170227011000062
						],
						[
							-81.60760090899993,
							30.17030601100004
						],
						[
							-81.60839590699995,
							30.170520011000065
						],
						[
							-81.60920990799991,
							30.170760010000034
						],
						[
							-81.60970190699993,
							30.17090501000007
						],
						[
							-81.6101369079999,
							30.171046010000055
						],
						[
							-81.61098690799992,
							30.17134101100004
						],
						[
							-81.6116739069999,
							30.17160201100006
						],
						[
							-81.61233490699995,
							30.171860010000046
						],
						[
							-81.61327390699995,
							30.17224901000009
						],
						[
							-81.61417390799994,
							30.172651011000088
						],
						[
							-81.61505090799994,
							30.173067010000068
						],
						[
							-81.61589090799993,
							30.173492010000075
						],
						[
							-81.61629490699994,
							30.17370401100004
						],
						[
							-81.61706490799992,
							30.17413901000009
						],
						[
							-81.61778290799992,
							30.174559011000042
						],
						[
							-81.61811790799993,
							30.17476301000005
						],
						[
							-81.6188739079999,
							30.17524101100008
						],
						[
							-81.61925490699991,
							30.175491010000083
						],
						[
							-81.6200759749999,
							30.176061165000082
						],
						[
							-81.62013584899995,
							30.175779850000083
						],
						[
							-81.6243270889999,
							30.17899001100005
						],
						[
							-81.62416672799992,
							30.17910801100004
						],
						[
							-81.62449790799991,
							30.179346010000074
						],
						[
							-81.62456990699991,
							30.17939801100005
						],
						[
							-81.62488990799994,
							30.179628010000044
						],
						[
							-81.62534290699995,
							30.17992801100007
						],
						[
							-81.62588090799994,
							30.180273011000054
						],
						[
							-81.62617590799994,
							30.180449011000064
						],
						[
							-81.62643690699991,
							30.180602010000083
						],
						[
							-81.62669290699995,
							30.18074601000006
						],
						[
							-81.6269539079999,
							30.18088301100005
						],
						[
							-81.62714290699996,
							30.18098301100008
						],
						[
							-81.62756590799995,
							30.18119801100005
						],
						[
							-81.62764190699994,
							30.181236010000077
						],
						[
							-81.6279669079999,
							30.181397010000065
						],
						[
							-81.62823005599995,
							30.181517062000072
						],
						[
							-81.62408501599992,
							30.183504679000066
						],
						[
							-81.62111555999991,
							30.183847175000043
						],
						[
							-81.61711827399995,
							30.183732969000065
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Southwood",
				"RegionID": "269198"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.64631892299991,
					30.286706006000088,
					-81.60967493699992,
					30.309059150000053
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.64335590699994,
							30.307735008000066
						],
						[
							-81.64319183999993,
							30.307642835000085
						],
						[
							-81.64311599199995,
							30.307889173000035
						],
						[
							-81.6425219059999,
							30.307716008000053
						],
						[
							-81.64134690599991,
							30.307323009000072
						],
						[
							-81.64091490599992,
							30.30718400800004
						],
						[
							-81.63918390599991,
							30.306630008000074
						],
						[
							-81.63845290599994,
							30.30639600800004
						],
						[
							-81.63787490599992,
							30.306211008000044
						],
						[
							-81.63720785899994,
							30.305978958000082
						],
						[
							-81.63729607399995,
							30.305751928000067
						],
						[
							-81.63704990499991,
							30.305680009000067
						],
						[
							-81.63634490499993,
							30.305431009000078
						],
						[
							-81.63596390599992,
							30.305326009000055
						],
						[
							-81.63584390599993,
							30.305309008000055
						],
						[
							-81.6355079029999,
							30.305221009000036
						],
						[
							-81.63541690599993,
							30.30521500900005
						],
						[
							-81.63532990599992,
							30.305212009000055
						],
						[
							-81.63524090599992,
							30.305220008000052
						],
						[
							-81.63517776999993,
							30.30522507400008
						],
						[
							-81.63530706799992,
							30.305070955000073
						],
						[
							-81.63449490499995,
							30.30486600800009
						],
						[
							-81.63428790499995,
							30.30482500800008
						],
						[
							-81.63386990499993,
							30.30471700800007
						],
						[
							-81.63347790499995,
							30.30460500800007
						],
						[
							-81.63277940599994,
							30.304386008000048
						],
						[
							-81.63194590599996,
							30.304095009000036
						],
						[
							-81.63185790199992,
							30.30406783400008
						],
						[
							-81.63178390899992,
							30.304095182000086
						],
						[
							-81.63095890599995,
							30.30382200800005
						],
						[
							-81.63082090599994,
							30.30376100800004
						],
						[
							-81.63056890599995,
							30.303652008000086
						],
						[
							-81.63001990499993,
							30.30339500900004
						],
						[
							-81.62989290599995,
							30.303335009000076
						],
						[
							-81.62959790499991,
							30.30319100900005
						],
						[
							-81.6289239059999,
							30.302894008000067
						],
						[
							-81.62841890499993,
							30.302655009000034
						],
						[
							-81.62821390499995,
							30.302550008000086
						],
						[
							-81.62796090599994,
							30.30242700900004
						],
						[
							-81.62778690599993,
							30.302350008000076
						],
						[
							-81.6276399059999,
							30.302275008000034
						],
						[
							-81.62735490499995,
							30.30213700800004
						],
						[
							-81.62658690599994,
							30.30177900800004
						],
						[
							-81.62620890599993,
							30.30160300800009
						],
						[
							-81.6258589059999,
							30.30144500900008
						],
						[
							-81.62563090599991,
							30.301353008000035
						],
						[
							-81.62547690499991,
							30.301276008000062
						],
						[
							-81.62531290499993,
							30.301195009000082
						],
						[
							-81.6247329059999,
							30.300922008000043
						],
						[
							-81.62337990599991,
							30.30028500800006
						],
						[
							-81.6230699059999,
							30.300129008000056
						],
						[
							-81.6223989049999,
							30.299804009000074
						],
						[
							-81.6214529049999,
							30.299371008000033
						],
						[
							-81.62128090599992,
							30.29929000800007
						],
						[
							-81.61983490499995,
							30.29861900900005
						],
						[
							-81.61932190599993,
							30.298379009000087
						],
						[
							-81.61910890599995,
							30.298280008000066
						],
						[
							-81.61881390799994,
							30.298147908000093
						],
						[
							-81.61763790799995,
							30.297576010000057
						],
						[
							-81.61751190799993,
							30.297508011000048
						],
						[
							-81.61722490699992,
							30.297385010000085
						],
						[
							-81.6164459069999,
							30.297014010000055
						],
						[
							-81.61634590799991,
							30.29697301000005
						],
						[
							-81.61575090699995,
							30.29669801000006
						],
						[
							-81.61572890699995,
							30.296688011000068
						],
						[
							-81.61564790699992,
							30.296653011000046
						],
						[
							-81.61461690699991,
							30.296260011000076
						],
						[
							-81.61453590699996,
							30.29623901100007
						],
						[
							-81.61448290699991,
							30.296224011000046
						],
						[
							-81.61438990799991,
							30.296199011000056
						],
						[
							-81.61432090799991,
							30.296180011000047
						],
						[
							-81.61342090699992,
							30.295918010000037
						],
						[
							-81.61330690699992,
							30.29588201000007
						],
						[
							-81.61258990699992,
							30.29567001000004
						],
						[
							-81.61184390699992,
							30.295449010000084
						],
						[
							-81.61087090699993,
							30.295162010000066
						],
						[
							-81.60967493699992,
							30.294812113000038
						],
						[
							-81.61004505999996,
							30.294454088000066
						],
						[
							-81.6100947459999,
							30.293959916000063
						],
						[
							-81.61026990599993,
							30.293826008000057
						],
						[
							-81.61052490599992,
							30.29366900800005
						],
						[
							-81.6108689049999,
							30.293512008000047
						],
						[
							-81.61143890599993,
							30.293270009000082
						],
						[
							-81.61256790599992,
							30.292811008000058
						],
						[
							-81.61287090599991,
							30.292688009000077
						],
						[
							-81.61305590599996,
							30.29261100900004
						],
						[
							-81.61357890499994,
							30.29238500800005
						],
						[
							-81.61395990599993,
							30.292183008000055
						],
						[
							-81.6149399059999,
							30.291511009000093
						],
						[
							-81.61614190599994,
							30.290705009000078
						],
						[
							-81.61640190599991,
							30.29055000900007
						],
						[
							-81.6165389059999,
							30.290491009000046
						],
						[
							-81.61675290599993,
							30.290422009000054
						],
						[
							-81.61704290599994,
							30.290352009000056
						],
						[
							-81.61723290599991,
							30.29033400800006
						],
						[
							-81.61736290499994,
							30.29033500900005
						],
						[
							-81.61748490499991,
							30.290355009000052
						],
						[
							-81.61762290299993,
							30.29041000800004
						],
						[
							-81.61771493999993,
							30.290472967000085
						],
						[
							-81.61780084299994,
							30.290574190000086
						],
						[
							-81.6178679059999,
							30.290557009000054
						],
						[
							-81.61794990499993,
							30.290530008000076
						],
						[
							-81.6181159059999,
							30.290486009000066
						],
						[
							-81.61826190499994,
							30.29046000900007
						],
						[
							-81.61840590599991,
							30.29044500900005
						],
						[
							-81.61873590599993,
							30.29044000900007
						],
						[
							-81.61884090499991,
							30.29044000900007
						],
						[
							-81.61895790599993,
							30.290442009000056
						],
						[
							-81.6194459049999,
							30.290489008000065
						],
						[
							-81.62032290499991,
							30.29055200800008
						],
						[
							-81.62081140599992,
							30.290595509000074
						],
						[
							-81.6216559049999,
							30.29066500900007
						],
						[
							-81.6221239059999,
							30.290712009000064
						],
						[
							-81.62261190499993,
							30.29075800900006
						],
						[
							-81.6241529049999,
							30.29089700800006
						],
						[
							-81.62459890499991,
							30.290936009000063
						],
						[
							-81.62502390599991,
							30.290979008000075
						],
						[
							-81.62556490599991,
							30.29104200800009
						],
						[
							-81.62578090599993,
							30.291067009000074
						],
						[
							-81.6262189059999,
							30.291097008000065
						],
						[
							-81.62676790499995,
							30.29114600900004
						],
						[
							-81.62701890599993,
							30.291176008000036
						],
						[
							-81.62717990499995,
							30.291195008000045
						],
						[
							-81.62737790599994,
							30.291205009000066
						],
						[
							-81.62758390499994,
							30.291207008000075
						],
						[
							-81.62774490499994,
							30.29120300900007
						],
						[
							-81.62800390599995,
							30.291179008000086
						],
						[
							-81.6281839049999,
							30.291161009000064
						],
						[
							-81.62834590499995,
							30.291137008000078
						],
						[
							-81.62850790599992,
							30.29110600900009
						],
						[
							-81.62872090499991,
							30.291063009000084
						],
						[
							-81.62888490499995,
							30.291020008000093
						],
						[
							-81.6289929049999,
							30.290989009000043
						],
						[
							-81.62913790499994,
							30.290943008000056
						],
						[
							-81.62931390499995,
							30.290881008000046
						],
						[
							-81.62948790599995,
							30.290805008000063
						],
						[
							-81.62968840499991,
							30.29072050900004
						],
						[
							-81.62972793199992,
							30.290705054000057
						],
						[
							-81.62975090599991,
							30.290688009000064
						],
						[
							-81.6297779059999,
							30.290674009000046
						],
						[
							-81.62987890599993,
							30.29062600800006
						],
						[
							-81.62995290599991,
							30.290583008000056
						],
						[
							-81.6299869049999,
							30.290561009000044
						],
						[
							-81.63005690499995,
							30.29052100900009
						],
						[
							-81.63012890599992,
							30.29047200800005
						],
						[
							-81.63024390599992,
							30.29039700800007
						],
						[
							-81.63038590499991,
							30.290283009000063
						],
						[
							-81.63048990499993,
							30.290197009000057
						],
						[
							-81.63062190499994,
							30.29008900900004
						],
						[
							-81.63077990499994,
							30.28994200900007
						],
						[
							-81.63091090599994,
							30.28983500800007
						],
						[
							-81.63118190599994,
							30.289604009000072
						],
						[
							-81.63134690599992,
							30.289461008000046
						],
						[
							-81.63208690499994,
							30.288760008000057
						],
						[
							-81.63239890599993,
							30.288486008000067
						],
						[
							-81.6327559049999,
							30.288210008000075
						],
						[
							-81.63282790599993,
							30.288150009000045
						],
						[
							-81.63294690599992,
							30.288074008000077
						],
						[
							-81.6331529059999,
							30.28794300900006
						],
						[
							-81.63332990599991,
							30.287842008000037
						],
						[
							-81.63351090599991,
							30.28774800900004
						],
						[
							-81.63356890499995,
							30.287718009000063
						],
						[
							-81.63366990599991,
							30.287667008000085
						],
						[
							-81.63551190499993,
							30.286706006000088
						],
						[
							-81.63809490599994,
							30.29032200900008
						],
						[
							-81.64044390499993,
							30.29360200900004
						],
						[
							-81.64122190499995,
							30.294724008000063
						],
						[
							-81.64144190699994,
							30.295127008000065
						],
						[
							-81.6427899059999,
							30.296702009000057
						],
						[
							-81.64327505799992,
							30.297378965000068
						],
						[
							-81.63939782599994,
							30.29946921000004
						],
						[
							-81.64067713799994,
							30.301570688000087
						],
						[
							-81.64168216999991,
							30.303032554000087
						],
						[
							-81.64277856899992,
							30.304768514000042
						],
						[
							-81.6441490659999,
							30.306230381000034
						],
						[
							-81.6455196039999,
							30.307235366000047
						],
						[
							-81.64631892299991,
							30.30814693900004
						],
						[
							-81.64615490599994,
							30.30820000900008
						],
						[
							-81.64595090599994,
							30.30827800900005
						],
						[
							-81.6459259049999,
							30.308292009000073
						],
						[
							-81.64574390599995,
							30.30840600800008
						],
						[
							-81.64561690599993,
							30.308508009000036
						],
						[
							-81.64551490499991,
							30.308616010000033
						],
						[
							-81.64547990499995,
							30.308673008000085
						],
						[
							-81.64543890599992,
							30.30873700800004
						],
						[
							-81.6454009059999,
							30.308827010000073
						],
						[
							-81.64539390399995,
							30.30886900800005
						],
						[
							-81.64538090899993,
							30.30890500900006
						],
						[
							-81.6453799059999,
							30.30894900800007
						],
						[
							-81.64538600599991,
							30.309059150000053
						],
						[
							-81.64390674999993,
							30.308481115000063
						],
						[
							-81.64390390699992,
							30.308140008000066
						],
						[
							-81.6439290699999,
							30.307957912000067
						],
						[
							-81.64335590699994,
							30.307735008000066
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Spring Park",
				"RegionID": "269200"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.64387895199991,
					30.361044073000073,
					-81.62094566699994,
					30.37256117200008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.63962090699994,
							30.371948011000086
						],
						[
							-81.63956298599993,
							30.371745843000042
						],
						[
							-81.63875690799995,
							30.37208201000004
						],
						[
							-81.63843292699994,
							30.372256194000048
						],
						[
							-81.63820076199994,
							30.372189137000074
						],
						[
							-81.63817005899995,
							30.372028906000082
						],
						[
							-81.63806190799994,
							30.37196201000006
						],
						[
							-81.63776790799996,
							30.371736014000078
						],
						[
							-81.63730390699993,
							30.37157601000007
						],
						[
							-81.63724290699992,
							30.371549010000084
						],
						[
							-81.63721193099991,
							30.371535879000078
						],
						[
							-81.63713388499991,
							30.37153614200008
						],
						[
							-81.6365159309999,
							30.37130887800004
						],
						[
							-81.63639290899994,
							30.371309011000047
						],
						[
							-81.6360059079999,
							30.37138901100008
						],
						[
							-81.63571193099995,
							30.37149614200007
						],
						[
							-81.63218599999993,
							30.371504000000076
						],
						[
							-81.6314255339999,
							30.372050306000062
						],
						[
							-81.63031310799994,
							30.37117681700005
						],
						[
							-81.62697224999994,
							30.369850896000063
						],
						[
							-81.62685433899992,
							30.369793836000042
						],
						[
							-81.62681115999993,
							30.36976725600005
						],
						[
							-81.62385915999994,
							30.36783325600004
						],
						[
							-81.62380300099994,
							30.367793306000067
						],
						[
							-81.6237500659999,
							30.367749174000043
						],
						[
							-81.62370066699992,
							30.36770111700008
						],
						[
							-81.62365509199992,
							30.36764941800004
						],
						[
							-81.62361360999995,
							30.36759438100006
						],
						[
							-81.62357646499994,
							30.367536330000064
						],
						[
							-81.62166246499993,
							30.364276330000056
						],
						[
							-81.62162100699993,
							30.36419690100007
						],
						[
							-81.62117700699991,
							30.36323190200005
						],
						[
							-81.62113132199995,
							30.36311009900004
						],
						[
							-81.62094566699994,
							30.362479791000055
						],
						[
							-81.62188616399993,
							30.362489890000063
						],
						[
							-81.6328740379999,
							30.36260787700007
						],
						[
							-81.63288876799993,
							30.36316813300004
						],
						[
							-81.6343179079999,
							30.363341010000056
						],
						[
							-81.63527390699994,
							30.363558010000077
						],
						[
							-81.6370309049999,
							30.364048009000044
						],
						[
							-81.63889190799996,
							30.364202010000046
						],
						[
							-81.63910590799992,
							30.36421001200006
						],
						[
							-81.63925390799994,
							30.364238009000076
						],
						[
							-81.63941790599995,
							30.364238009000076
						],
						[
							-81.63953290699993,
							30.36421001000008
						],
						[
							-81.63963990699995,
							30.364167010000074
						],
						[
							-81.63972990799994,
							30.364117011000076
						],
						[
							-81.63984490599995,
							30.364047010000036
						],
						[
							-81.64318800599995,
							30.361044073000073
						],
						[
							-81.64324991099994,
							30.361702013000073
						],
						[
							-81.6433109109999,
							30.362373012000038
						],
						[
							-81.64335590899992,
							30.363007013000075
						],
						[
							-81.6433779109999,
							30.363276013000075
						],
						[
							-81.64339391099992,
							30.363537013000045
						],
						[
							-81.6434439109999,
							30.363881013000082
						],
						[
							-81.64356090899993,
							30.36436701200006
						],
						[
							-81.6436619129999,
							30.364665009000078
						],
						[
							-81.64375991199995,
							30.36480501200009
						],
						[
							-81.64387895199991,
							30.364940089000072
						],
						[
							-81.64382290799995,
							30.364975011000073
						],
						[
							-81.64371590999991,
							30.365062010000088
						],
						[
							-81.64301890699994,
							30.365976010000058
						],
						[
							-81.64281790699994,
							30.36622501000005
						],
						[
							-81.64268090799993,
							30.366351009000084
						],
						[
							-81.64255390699992,
							30.366437010000087
						],
						[
							-81.64171990799991,
							30.366888011000075
						],
						[
							-81.64132290799995,
							30.36713301000009
						],
						[
							-81.6411409079999,
							30.367262011000037
						],
						[
							-81.64106186599992,
							30.36733997500005
						],
						[
							-81.64096990799993,
							30.367474014000038
						],
						[
							-81.64092185499993,
							30.36760000100008
						],
						[
							-81.64090877599995,
							30.36777403200006
						],
						[
							-81.64096390999993,
							30.36795801200009
						],
						[
							-81.64130290799994,
							30.36854601100003
						],
						[
							-81.64199090699992,
							30.369772011000066
						],
						[
							-81.64205190599995,
							30.369919011000036
						],
						[
							-81.64207490699994,
							30.370094008000084
						],
						[
							-81.64206695999991,
							30.370224019000087
						],
						[
							-81.64202090499992,
							30.370384012000045
						],
						[
							-81.6419299069999,
							30.370539008000037
						],
						[
							-81.6418379079999,
							30.370640010000045
						],
						[
							-81.64027690799992,
							30.372063010000094
						],
						[
							-81.6401759069999,
							30.37215001100009
						],
						[
							-81.6399469079999,
							30.37237901000009
						],
						[
							-81.63979587699993,
							30.37256117200008
						],
						[
							-81.6397269069999,
							30.37232201000006
						],
						[
							-81.63966390799993,
							30.37213901000007
						],
						[
							-81.63962090699994,
							30.371948011000086
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Tallyrand",
				"RegionID": "269205"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.55928890699994,
					30.25005091800006,
					-81.51632590699995,
					30.287007009000035
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.52579290699992,
							30.286834011000057
						],
						[
							-81.52578190799994,
							30.28635501000008
						],
						[
							-81.5257749079999,
							30.286049010000056
						],
						[
							-81.52578390799994,
							30.28531501100008
						],
						[
							-81.5257769079999,
							30.284890011000073
						],
						[
							-81.52576890699993,
							30.28432001100009
						],
						[
							-81.52575390699991,
							30.283883010000068
						],
						[
							-81.52574490799992,
							30.283718011000076
						],
						[
							-81.52573790799994,
							30.28359801100004
						],
						[
							-81.52570790699991,
							30.283273010000073
						],
						[
							-81.52563790799991,
							30.28268401100007
						],
						[
							-81.52554590799991,
							30.282074011000077
						],
						[
							-81.52542390799994,
							30.281411011000042
						],
						[
							-81.5254189069999,
							30.28138101000007
						],
						[
							-81.52540690599994,
							30.28129901200009
						],
						[
							-81.52538290799993,
							30.28124401000008
						],
						[
							-81.52522990799991,
							30.280737011000046
						],
						[
							-81.52505190699992,
							30.280219010000053
						],
						[
							-81.52493290699994,
							30.279848011000073
						],
						[
							-81.52479990799992,
							30.279503010000045
						],
						[
							-81.52474890699995,
							30.27935301100007
						],
						[
							-81.52457290799993,
							30.27895101000007
						],
						[
							-81.52432090799994,
							30.278423010000044
						],
						[
							-81.52413790799994,
							30.27805401100005
						],
						[
							-81.52396190799993,
							30.27773101100007
						],
						[
							-81.52347390799991,
							30.276814010000066
						],
						[
							-81.52241190699993,
							30.27488401000005
						],
						[
							-81.52184790699994,
							30.27384101000007
						],
						[
							-81.52076990799992,
							30.271885010000062
						],
						[
							-81.52010490799995,
							30.27067001000006
						],
						[
							-81.5198379069999,
							30.270155011000046
						],
						[
							-81.51978290799991,
							30.270045010000047
						],
						[
							-81.51974290799991,
							30.269963011000076
						],
						[
							-81.5196289079999,
							30.26972901100004
						],
						[
							-81.51955590799992,
							30.269543010000064
						],
						[
							-81.51946090699994,
							30.26932601100009
						],
						[
							-81.51934790799993,
							30.269064011000072
						],
						[
							-81.51929090699993,
							30.26893201000007
						],
						[
							-81.51925690799993,
							30.268855010000042
						],
						[
							-81.51924190799991,
							30.26880801100009
						],
						[
							-81.51902390799995,
							30.26815201100004
						],
						[
							-81.51892090799993,
							30.267831011000055
						],
						[
							-81.51886190699992,
							30.26761601000004
						],
						[
							-81.51876690699993,
							30.267199011000063
						],
						[
							-81.5186879069999,
							30.266879010000086
						],
						[
							-81.51859990799994,
							30.266338011000073
						],
						[
							-81.51852290799992,
							30.26583701000004
						],
						[
							-81.51845190699993,
							30.265234010000086
						],
						[
							-81.51840490799992,
							30.26462101000004
						],
						[
							-81.51838090799993,
							30.264044010000077
						],
						[
							-81.5183689079999,
							30.26351001100005
						],
						[
							-81.51834290799991,
							30.263010010000073
						],
						[
							-81.51832890799994,
							30.26271601000008
						],
						[
							-81.51830690799994,
							30.262252011000044
						],
						[
							-81.51827190799992,
							30.261786010000034
						],
						[
							-81.51824090699995,
							30.261460011000054
						],
						[
							-81.51820390699993,
							30.261054010000066
						],
						[
							-81.51814690799996,
							30.26058501100005
						],
						[
							-81.5180799069999,
							30.260076011000084
						],
						[
							-81.51802290699993,
							30.259696011000077
						],
						[
							-81.51800290699993,
							30.259563011000065
						],
						[
							-81.51797290799993,
							30.25936001000008
						],
						[
							-81.51791490799992,
							30.259058011000036
						],
						[
							-81.51781290699995,
							30.25854001000005
						],
						[
							-81.51777590799992,
							30.258363010000043
						],
						[
							-81.51765890799993,
							30.257845011000086
						],
						[
							-81.51754190799994,
							30.25735201000009
						],
						[
							-81.5173809069999,
							30.256746010000086
						],
						[
							-81.51730590699992,
							30.256483011000057
						],
						[
							-81.51719090799992,
							30.256083010000054
						],
						[
							-81.51705190699994,
							30.25557701000008
						],
						[
							-81.51697190699991,
							30.255318011000043
						],
						[
							-81.51679390699991,
							30.25475001000007
						],
						[
							-81.51650090699991,
							30.253684010000086
						],
						[
							-81.51632590699995,
							30.253067953000087
						],
						[
							-81.51751090499994,
							30.25282900900004
						],
						[
							-81.52124390599994,
							30.252022008000043
						],
						[
							-81.5218429059999,
							30.251895008000076
						],
						[
							-81.52252290599995,
							30.25173200900008
						],
						[
							-81.5227239049999,
							30.25168500800004
						],
						[
							-81.52346590499991,
							30.251535008000076
						],
						[
							-81.52457090599995,
							30.251305009000074
						],
						[
							-81.52663590599991,
							30.25087400900009
						],
						[
							-81.5272939059999,
							30.250741008000034
						],
						[
							-81.52756990599994,
							30.25068500800006
						],
						[
							-81.5279439059999,
							30.25062600800004
						],
						[
							-81.52824790599993,
							30.250577008000047
						],
						[
							-81.52855390499991,
							30.250537008000038
						],
						[
							-81.52898990599994,
							30.25048200800006
						],
						[
							-81.52933190499994,
							30.250444009000034
						],
						[
							-81.52961890599994,
							30.250422008000047
						],
						[
							-81.5297019059999,
							30.25041600800006
						],
						[
							-81.52975690599993,
							30.250411009000064
						],
						[
							-81.5314129059999,
							30.250325008000065
						],
						[
							-81.53177290499991,
							30.250320008000074
						],
						[
							-81.53384490499991,
							30.250302008000062
						],
						[
							-81.53426890599991,
							30.250295008000077
						],
						[
							-81.53472990599995,
							30.250284008000055
						],
						[
							-81.53540490499995,
							30.250274008000076
						],
						[
							-81.53578698399991,
							30.25026417400005
						],
						[
							-81.53587609699991,
							30.250162023000087
						],
						[
							-81.53580776099994,
							30.250060928000043
						],
						[
							-81.53587690599994,
							30.250060008000045
						],
						[
							-81.53600390499992,
							30.250057009000045
						],
						[
							-81.53609190599991,
							30.25005300800007
						],
						[
							-81.53615604799997,
							30.25005091800006
						],
						[
							-81.53610571399992,
							30.250152024000045
						],
						[
							-81.53617882599991,
							30.250254179000077
						],
						[
							-81.53624690599992,
							30.250249009000072
						],
						[
							-81.53647090499993,
							30.250245008000032
						],
						[
							-81.5369539049999,
							30.250232009000058
						],
						[
							-81.54006490499995,
							30.250140008000077
						],
						[
							-81.54221690599991,
							30.25009800800007
						],
						[
							-81.54271090599991,
							30.25010300800005
						],
						[
							-81.54308690499994,
							30.25011100800009
						],
						[
							-81.54624590499992,
							30.250100008000064
						],
						[
							-81.5465219049999,
							30.25010200800006
						],
						[
							-81.5468129059999,
							30.250105008000045
						],
						[
							-81.54763590499994,
							30.25010300800005
						],
						[
							-81.54865290499993,
							30.250095009000063
						],
						[
							-81.55007090499993,
							30.250097008000072
						],
						[
							-81.5508629059999,
							30.250099008000067
						],
						[
							-81.55156690599995,
							30.25011400900007
						],
						[
							-81.55216290599992,
							30.250104008000047
						],
						[
							-81.55241590599991,
							30.25010300800005
						],
						[
							-81.55268090099993,
							30.250102013000063
						],
						[
							-81.5527529069999,
							30.250596010000038
						],
						[
							-81.5528619079999,
							30.25113401100009
						],
						[
							-81.55301490799991,
							30.25181901100007
						],
						[
							-81.55318690799993,
							30.25247101000008
						],
						[
							-81.55334890799993,
							30.253032010000084
						],
						[
							-81.55377090799995,
							30.254291010000088
						],
						[
							-81.55386590699993,
							30.25457201100005
						],
						[
							-81.55411490699993,
							30.25530001000004
						],
						[
							-81.55440290799993,
							30.256034011000057
						],
						[
							-81.55470790799991,
							30.256719011000087
						],
						[
							-81.5547579069999,
							30.256822010000064
						],
						[
							-81.55625190799992,
							30.259951011000055
						],
						[
							-81.5563559069999,
							30.260136010000057
						],
						[
							-81.55695090799992,
							30.261427011000084
						],
						[
							-81.55747890799995,
							30.262791010000058
						],
						[
							-81.55786690699995,
							30.263996011000074
						],
						[
							-81.55800190699995,
							30.264401011000075
						],
						[
							-81.55807790699993,
							30.264680011000053
						],
						[
							-81.55811290699995,
							30.264811011000067
						],
						[
							-81.5581779069999,
							30.26503301000008
						],
						[
							-81.55825190699994,
							30.265315011000045
						],
						[
							-81.55843590799992,
							30.266057011000044
						],
						[
							-81.55854790699993,
							30.266573011000048
						],
						[
							-81.55875090799992,
							30.267619011000082
						],
						[
							-81.55883290799994,
							30.26813001000005
						],
						[
							-81.55895890699992,
							30.268893011000042
						],
						[
							-81.55904581499993,
							30.269635024000085
						],
						[
							-81.5590569069999,
							30.269886010000054
						],
						[
							-81.55911490699992,
							30.270493010000056
						],
						[
							-81.55913290699995,
							30.270992011000093
						],
						[
							-81.5591429079999,
							30.271281010000052
						],
						[
							-81.55917090699995,
							30.271843011000048
						],
						[
							-81.55917090799994,
							30.271966010000085
						],
						[
							-81.55917090799994,
							30.272099010000087
						],
						[
							-81.55917090799994,
							30.272677010000052
						],
						[
							-81.55917090699995,
							30.272925011000037
						],
						[
							-81.55919985399993,
							30.27416407000004
						],
						[
							-81.55918081699991,
							30.277950014000055
						],
						[
							-81.5591919069999,
							30.27807401000007
						],
						[
							-81.55919890799993,
							30.280215010000063
						],
						[
							-81.55923204299995,
							30.28090413600006
						],
						[
							-81.55906075999992,
							30.280912894000043
						],
						[
							-81.55914190699991,
							30.281312011000065
						],
						[
							-81.55920190799992,
							30.28260601100004
						],
						[
							-81.55919990799993,
							30.28292401000005
						],
						[
							-81.55919790799993,
							30.283151011000086
						],
						[
							-81.55919590799994,
							30.283510010000043
						],
						[
							-81.5591869079999,
							30.28478201000007
						],
						[
							-81.55918377299992,
							30.28490202100005
						],
						[
							-81.55927995999991,
							30.285233001000055
						],
						[
							-81.55928890699994,
							30.285708011000057
						],
						[
							-81.55928690799993,
							30.286232011000042
						],
						[
							-81.55928690799993,
							30.28645601000005
						],
						[
							-81.55928690799993,
							30.286514010000076
						],
						[
							-81.55928690799993,
							30.286594010000044
						],
						[
							-81.55928690799993,
							30.286669064000076
						],
						[
							-81.5591699069999,
							30.286666010000094
						],
						[
							-81.5590349069999,
							30.286663010000044
						],
						[
							-81.5588999069999,
							30.28666101100003
						],
						[
							-81.5588419099999,
							30.286659954000076
						],
						[
							-81.55809690599995,
							30.286637009000064
						],
						[
							-81.5577789049999,
							30.286625008000044
						],
						[
							-81.55765790599992,
							30.286623008000046
						],
						[
							-81.55731390499994,
							30.286619008000056
						],
						[
							-81.55581090499993,
							30.28664500800005
						],
						[
							-81.55494890599994,
							30.28665600900007
						],
						[
							-81.55425190499994,
							30.286660008000073
						],
						[
							-81.55375390599994,
							30.286667008000048
						],
						[
							-81.55292090599994,
							30.28667800800008
						],
						[
							-81.5512689059999,
							30.286700008000086
						],
						[
							-81.5505929059999,
							30.286709008000063
						],
						[
							-81.54861490499991,
							30.286736008000048
						],
						[
							-81.54642690599991,
							30.286751009000056
						],
						[
							-81.54418890599993,
							30.286766008000086
						],
						[
							-81.54225590599992,
							30.286791009000066
						],
						[
							-81.54155290599994,
							30.286802008000056
						],
						[
							-81.54041790499991,
							30.28680900800003
						],
						[
							-81.54031290499995,
							30.286810009000078
						],
						[
							-81.53901990599991,
							30.286828008000043
						],
						[
							-81.5388219059999,
							30.286828008000043
						],
						[
							-81.53565890499993,
							30.286875008000038
						],
						[
							-81.53351990599992,
							30.28690400800008
						],
						[
							-81.53157690499995,
							30.286913008000056
						],
						[
							-81.53144790599994,
							30.28691500800005
						],
						[
							-81.53047790599993,
							30.28693100800007
						],
						[
							-81.5290929059999,
							30.28695600800006
						],
						[
							-81.52773990499992,
							30.28695600800006
						],
						[
							-81.5263009059999,
							30.286997008000068
						],
						[
							-81.52595990499992,
							30.287007009000035
						],
						[
							-81.52579690099992,
							30.287003016000085
						],
						[
							-81.52579290699992,
							30.286834011000057
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Windy Hill",
				"RegionID": "269234"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.60274303099993,
					30.312584010000084,
					-81.55857482399995,
					30.32772820100007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.58736690799992,
							30.32772820100007
						],
						[
							-81.5867239179999,
							30.327546958000084
						],
						[
							-81.58614490899993,
							30.32754701000005
						],
						[
							-81.58607190599992,
							30.32754801000004
						],
						[
							-81.58603890699993,
							30.327549010000038
						],
						[
							-81.58587690899992,
							30.327553011000077
						],
						[
							-81.58578390699995,
							30.327554010000085
						],
						[
							-81.5854679059999,
							30.327554010000085
						],
						[
							-81.58382190899994,
							30.327573010000037
						],
						[
							-81.5834837669999,
							30.327577126000055
						],
						[
							-81.58349605099994,
							30.32752789400007
						],
						[
							-81.58273390599993,
							30.327534010000083
						],
						[
							-81.58210890599992,
							30.32753901000007
						],
						[
							-81.58165477099993,
							30.327545956000055
						],
						[
							-81.58170293799992,
							30.32759089200005
						],
						[
							-81.5814389059999,
							30.327603010000075
						],
						[
							-81.5810759069999,
							30.327623009000035
						],
						[
							-81.58077590599993,
							30.327642010000087
						],
						[
							-81.58056890899991,
							30.327644010000082
						],
						[
							-81.57979490699995,
							30.32765801000005
						],
						[
							-81.5790439079999,
							30.32765801000005
						],
						[
							-81.57876490699994,
							30.327661010000043
						],
						[
							-81.5781029069999,
							30.327669011000065
						],
						[
							-81.57769490899994,
							30.327666010000087
						],
						[
							-81.57686890799994,
							30.32767201000007
						],
						[
							-81.57622090599995,
							30.327675010000068
						],
						[
							-81.57588990799991,
							30.327683009000054
						],
						[
							-81.57545790899991,
							30.327700010000058
						],
						[
							-81.57505690699992,
							30.327700010000058
						],
						[
							-81.57438290699992,
							30.32769501000007
						],
						[
							-81.5736889069999,
							30.327691010000077
						],
						[
							-81.57330990699995,
							30.327684010000045
						],
						[
							-81.57292790699995,
							30.32767401000007
						],
						[
							-81.5728369059999,
							30.327673010000073
						],
						[
							-81.57250790599996,
							30.327651011000057
						],
						[
							-81.57185790699992,
							30.327594011000087
						],
						[
							-81.57167190899992,
							30.327575011000075
						],
						[
							-81.57134190799991,
							30.327533011000067
						],
						[
							-81.57105290599992,
							30.327502011000036
						],
						[
							-81.57060090599992,
							30.327437011000082
						],
						[
							-81.57041490699993,
							30.327406010000065
						],
						[
							-81.57018490699994,
							30.327364011000043
						],
						[
							-81.56982490799993,
							30.327295010000057
						],
						[
							-81.56965890599992,
							30.32725901100008
						],
						[
							-81.56951890699992,
							30.327228010000056
						],
						[
							-81.56933290599994,
							30.327188010000043
						],
						[
							-81.5690789059999,
							30.327125011000078
						],
						[
							-81.56892190699995,
							30.327089010000066
						],
						[
							-81.56859290599994,
							30.327002010000058
						],
						[
							-81.56840390699995,
							30.326949011000067
						],
						[
							-81.5677679069999,
							30.326760010000044
						],
						[
							-81.56675790799994,
							30.32641301000007
						],
						[
							-81.56648290699991,
							30.32631101000004
						],
						[
							-81.56499190599993,
							30.325671010000068
						],
						[
							-81.56451190899992,
							30.325491010000064
						],
						[
							-81.5640929089999,
							30.32531701000005
						],
						[
							-81.56392590699994,
							30.32524201000007
						],
						[
							-81.56361590799993,
							30.325111011000047
						],
						[
							-81.56348190599994,
							30.325055011000075
						],
						[
							-81.56296490699992,
							30.32483201100007
						],
						[
							-81.56276090799992,
							30.32474601100006
						],
						[
							-81.5627229079999,
							30.32472901000006
						],
						[
							-81.5625639079999,
							30.324657010000067
						],
						[
							-81.56254090699991,
							30.32464501200008
						],
						[
							-81.56222690899995,
							30.324502010000057
						],
						[
							-81.56061496399991,
							30.323864936000064
						],
						[
							-81.56009590999992,
							30.323650012000087
						],
						[
							-81.55987590799992,
							30.32355701300008
						],
						[
							-81.55982491099991,
							30.32353601300008
						],
						[
							-81.55976474999994,
							30.323513044000038
						],
						[
							-81.55967996699991,
							30.323373951000068
						],
						[
							-81.55959290599992,
							30.32331901100008
						],
						[
							-81.5594509089999,
							30.323213010000075
						],
						[
							-81.55929990699991,
							30.323088010000053
						],
						[
							-81.55924090899993,
							30.323017010000058
						],
						[
							-81.55917790699995,
							30.322944010000075
						],
						[
							-81.55911490699992,
							30.322862010000048
						],
						[
							-81.55904390899991,
							30.322770011000046
						],
						[
							-81.55894890899992,
							30.322624011000073
						],
						[
							-81.55889290599993,
							30.32252601000005
						],
						[
							-81.55886990699992,
							30.322482010000048
						],
						[
							-81.55882590899995,
							30.322365010000055
						],
						[
							-81.5587629069999,
							30.32208901000007
						],
						[
							-81.55873990899994,
							30.321790010000086
						],
						[
							-81.55872990599995,
							30.321572013000036
						],
						[
							-81.55868990899995,
							30.32140801000008
						],
						[
							-81.55857482399995,
							30.32049500300008
						],
						[
							-81.55874796199993,
							30.319904020000084
						],
						[
							-81.55876190699992,
							30.31962601000004
						],
						[
							-81.55880086799993,
							30.31938985800008
						],
						[
							-81.55892195399991,
							30.319535142000063
						],
						[
							-81.55892390899993,
							30.319067011000072
						],
						[
							-81.55890390899992,
							30.31770301100005
						],
						[
							-81.55892185199991,
							30.316470949000067
						],
						[
							-81.55903091099992,
							30.316409012000065
						],
						[
							-81.55920391099994,
							30.316311013000075
						],
						[
							-81.55946190799995,
							30.316171013000087
						],
						[
							-81.55966290799995,
							30.316057013000087
						],
						[
							-81.55982491099991,
							30.315955013000067
						],
						[
							-81.56000290899993,
							30.315862013000075
						],
						[
							-81.56060490899995,
							30.315531012000065
						],
						[
							-81.56163890999994,
							30.314923012000065
						],
						[
							-81.56191490899994,
							30.31475601300008
						],
						[
							-81.56198790999991,
							30.314719013000058
						],
						[
							-81.56214690899992,
							30.314639013000093
						],
						[
							-81.56240890899994,
							30.31453901200007
						],
						[
							-81.5625399079999,
							30.314491013000065
						],
						[
							-81.5627119099999,
							30.314443012000083
						],
						[
							-81.56290290899994,
							30.31439501300008
						],
						[
							-81.5631499079999,
							30.314360012000066
						],
						[
							-81.56330190799991,
							30.314349013000083
						],
						[
							-81.56369690899993,
							30.314309013000074
						],
						[
							-81.56439090899994,
							30.31427501300004
						],
						[
							-81.56569390899995,
							30.314202012000063
						],
						[
							-81.56815190999993,
							30.31406001200008
						],
						[
							-81.56904690999994,
							30.31400401200006
						],
						[
							-81.57141090899995,
							30.31386801200006
						],
						[
							-81.5723069089999,
							30.31381601200008
						],
						[
							-81.57237990799992,
							30.31381201200009
						],
						[
							-81.57245291099991,
							30.313808012000038
						],
						[
							-81.57438990899993,
							30.313693012000044
						],
						[
							-81.57529890799992,
							30.313639011000078
						],
						[
							-81.57568791099993,
							30.313617012000066
						],
						[
							-81.5775469109999,
							30.31349801200008
						],
						[
							-81.57817790799993,
							30.31346201200006
						],
						[
							-81.57905791799993,
							30.313418099000046
						],
						[
							-81.58159290899995,
							30.31326001000008
						],
						[
							-81.58244090699992,
							30.313212011000076
						],
						[
							-81.58275090699993,
							30.313195010000076
						],
						[
							-81.58391690899992,
							30.31312901000007
						],
						[
							-81.58492790799994,
							30.31307201000004
						],
						[
							-81.58537290599992,
							30.313047010000048
						],
						[
							-81.58596390899993,
							30.313004010000046
						],
						[
							-81.5863579089999,
							30.31298301100009
						],
						[
							-81.58686090899994,
							30.312961011000084
						],
						[
							-81.58752890599993,
							30.31291801100008
						],
						[
							-81.5890669069999,
							30.312811010000075
						],
						[
							-81.58975790699992,
							30.312781011000084
						],
						[
							-81.59003390799995,
							30.31276201100008
						],
						[
							-81.59107990599995,
							30.31270501100005
						],
						[
							-81.59152690899992,
							30.31267501000008
						],
						[
							-81.5919779059999,
							30.31265101000008
						],
						[
							-81.59228590599992,
							30.31263401000007
						],
						[
							-81.59267890799993,
							30.312608011000066
						],
						[
							-81.59285490899993,
							30.312597011000037
						],
						[
							-81.59326990799991,
							30.312584010000084
						],
						[
							-81.5934129069999,
							30.312591011000052
						],
						[
							-81.59378290699993,
							30.312610012000047
						],
						[
							-81.5941599059999,
							30.312682010000064
						],
						[
							-81.59459690799993,
							30.312779010000046
						],
						[
							-81.59501199999994,
							30.312903000000063
						],
						[
							-81.59548338199994,
							30.31301982100007
						],
						[
							-81.59547616499992,
							30.313030045000065
						],
						[
							-81.59490212999992,
							30.31384694200005
						],
						[
							-81.59395276299995,
							30.314288508000065
						],
						[
							-81.5930917099999,
							30.31470799500005
						],
						[
							-81.59273845699995,
							30.315083326000035
						],
						[
							-81.59216442099995,
							30.315701519000072
						],
						[
							-81.59163454199995,
							30.316165163000054
						],
						[
							-81.59095011499994,
							30.316695042000052
						],
						[
							-81.5902436099999,
							30.31722492100005
						],
						[
							-81.59013321799996,
							30.31755609500004
						],
						[
							-81.59055270599993,
							30.31813013100009
						],
						[
							-81.59108258499992,
							30.318947028000082
						],
						[
							-81.59136960299992,
							30.319786003000047
						],
						[
							-81.5918332469999,
							30.320249647000082
						],
						[
							-81.59276053499991,
							30.32069121300009
						],
						[
							-81.5931358659999,
							30.321176935000043
						],
						[
							-81.59351119699994,
							30.32192759700007
						],
						[
							-81.59399691999994,
							30.322325007000074
						],
						[
							-81.59468134699995,
							30.322744494000066
						],
						[
							-81.59523330399992,
							30.322678259000043
						],
						[
							-81.59585149599991,
							30.32281072900008
						],
						[
							-81.59664631499993,
							30.322943199000065
						],
						[
							-81.59735281999991,
							30.32320813800004
						],
						[
							-81.59843232999992,
							30.323472924000043
						],
						[
							-81.59838249599994,
							30.323755316000078
						],
						[
							-81.59861192799991,
							30.32395197200009
						],
						[
							-81.5988905239999,
							30.324156822000077
						],
						[
							-81.5991445379999,
							30.324263344000087
						],
						[
							-81.59936799999991,
							30.32431400000007
						],
						[
							-81.6005630489999,
							30.324881891000075
						],
						[
							-81.60104783799994,
							30.326262058000054
						],
						[
							-81.60183990999991,
							30.32704201300004
						],
						[
							-81.6019118239999,
							30.327143114000076
						],
						[
							-81.60207788999992,
							30.327236092000078
						],
						[
							-81.60214490999994,
							30.32723701200007
						],
						[
							-81.60241290899995,
							30.327255013000073
						],
						[
							-81.60262590899993,
							30.32725201300008
						],
						[
							-81.60274303099993,
							30.327261991000057
						],
						[
							-81.60257715299993,
							30.32733906100009
						],
						[
							-81.60210290899994,
							30.327334010000072
						],
						[
							-81.60147290799995,
							30.327352010000087
						],
						[
							-81.60077390899994,
							30.327355011000066
						],
						[
							-81.59963790699993,
							30.32736001000006
						],
						[
							-81.59834890899992,
							30.32737201000009
						],
						[
							-81.5969557759999,
							30.327394878000064
						],
						[
							-81.59695503799992,
							30.327449142000034
						],
						[
							-81.59636890599997,
							30.327448010000072
						],
						[
							-81.59576390599995,
							30.327447010000075
						],
						[
							-81.59537490699995,
							30.327457010000042
						],
						[
							-81.59487090899995,
							30.327454011000043
						],
						[
							-81.59470490899992,
							30.327461010000036
						],
						[
							-81.59434890699993,
							30.327468010000075
						],
						[
							-81.59316990699995,
							30.327480010000045
						],
						[
							-81.59152990699994,
							30.327496010000065
						],
						[
							-81.59065590799992,
							30.327500010000055
						],
						[
							-81.59027290799992,
							30.327517011000058
						],
						[
							-81.59006490699994,
							30.327530011000075
						],
						[
							-81.58938290599993,
							30.327529010000035
						],
						[
							-81.58905790599995,
							30.327536010000077
						],
						[
							-81.58901790699991,
							30.327536010000077
						],
						[
							-81.58862290699994,
							30.327531011000072
						],
						[
							-81.58791390699992,
							30.327534958000058
						],
						[
							-81.58736690799992,
							30.32772820100007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Woodland Acres",
				"RegionID": "269235"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.73102896199993,
					30.32759402700009,
					-81.70551290799995,
					30.343908008000085
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.7267529049999,
							30.343868008000072
						],
						[
							-81.7244109049999,
							30.343864008000082
						],
						[
							-81.7239379049999,
							30.343870008000067
						],
						[
							-81.7236919049999,
							30.34386900800007
						],
						[
							-81.72361890499991,
							30.34386900800007
						],
						[
							-81.72276290499991,
							30.343866008000077
						],
						[
							-81.7215269049999,
							30.34385700900009
						],
						[
							-81.71843690599991,
							30.34385300800005
						],
						[
							-81.71626990599994,
							30.343866008000077
						],
						[
							-81.71601090599995,
							30.343866008000077
						],
						[
							-81.7141108539999,
							30.34387400900005
						],
						[
							-81.71411090799995,
							30.34286501100007
						],
						[
							-81.71410390799991,
							30.342441010000076
						],
						[
							-81.7140879079999,
							30.34143301100005
						],
						[
							-81.71410390799991,
							30.340256011000065
						],
						[
							-81.7140879079999,
							30.338591010000073
						],
						[
							-81.71409590699996,
							30.338518010000083
						],
						[
							-81.7140879079999,
							30.338276010000076
						],
						[
							-81.71408804099991,
							30.336642877000084
						],
						[
							-81.71315790799991,
							30.336655010000072
						],
						[
							-81.71305790799994,
							30.336670009000045
						],
						[
							-81.7120359079999,
							30.336653010000077
						],
						[
							-81.71144090699994,
							30.336650010000085
						],
						[
							-81.7110749069999,
							30.336658010000065
						],
						[
							-81.71030390699991,
							30.336666010000044
						],
						[
							-81.70981590699995,
							30.33666001000006
						],
						[
							-81.70901490799992,
							30.336657010000067
						],
						[
							-81.7076949069999,
							30.336637010000064
						],
						[
							-81.70551290799995,
							30.33661106500006
						],
						[
							-81.7055468769999,
							30.331700959000045
						],
						[
							-81.70653190599995,
							30.331532009000057
						],
						[
							-81.70699490599992,
							30.331455009000077
						],
						[
							-81.70838790599993,
							30.331215009000065
						],
						[
							-81.70934290499991,
							30.331055008000074
						],
						[
							-81.70967890599991,
							30.33100500900008
						],
						[
							-81.7109909049999,
							30.330790009000058
						],
						[
							-81.71153990599993,
							30.330709009000085
						],
						[
							-81.71197490599991,
							30.330633009000053
						],
						[
							-81.71242490599992,
							30.330566008000062
						],
						[
							-81.71295890499994,
							30.330471008000075
						],
						[
							-81.71402690499991,
							30.330301008000053
						],
						[
							-81.7164379049999,
							30.329908009000068
						],
						[
							-81.71749890599995,
							30.329746008000086
						],
						[
							-81.71820790499993,
							30.329624008000053
						],
						[
							-81.71890990499992,
							30.329508008000058
						],
						[
							-81.71922290499992,
							30.32946800800005
						],
						[
							-81.72090090499995,
							30.32917400900004
						],
						[
							-81.72245790499994,
							30.32893800900007
						],
						[
							-81.72280890499991,
							30.32888800800004
						],
						[
							-81.72381590599993,
							30.32872000900005
						],
						[
							-81.72669190499994,
							30.328264008000076
						],
						[
							-81.72842190699993,
							30.327967011000055
						],
						[
							-81.72851290599993,
							30.327981005000083
						],
						[
							-81.7287289059999,
							30.32794800800008
						],
						[
							-81.73077696199994,
							30.32759402700009
						],
						[
							-81.73079890699995,
							30.32881800900009
						],
						[
							-81.73080390699994,
							30.32919900900004
						],
						[
							-81.73082890599994,
							30.32978000800006
						],
						[
							-81.7308419069999,
							30.33019900900007
						],
						[
							-81.73085290499995,
							30.330966009000065
						],
						[
							-81.7308689059999,
							30.331414009000067
						],
						[
							-81.7309129059999,
							30.332690008000046
						],
						[
							-81.73091790699993,
							30.333165009000084
						],
						[
							-81.73095690699995,
							30.333957009000073
						],
						[
							-81.73095590499992,
							30.334102008000055
						],
						[
							-81.7309599049999,
							30.334413009000055
						],
						[
							-81.7309639049999,
							30.334911008000063
						],
						[
							-81.73096790699992,
							30.33517200800009
						],
						[
							-81.7309749069999,
							30.33562600900007
						],
						[
							-81.73097990799994,
							30.336423009000047
						],
						[
							-81.73102896199993,
							30.34388201300004
						],
						[
							-81.73074890599992,
							30.343894009000053
						],
						[
							-81.72926290499993,
							30.343908008000085
						],
						[
							-81.72747790499994,
							30.343908008000085
						],
						[
							-81.7269959059999,
							30.34388100800004
						],
						[
							-81.7267529049999,
							30.343868008000072
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Woodstock",
				"RegionID": "269236"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.70942657899991,
					28.265912952000065,
					-82.69906818599992,
					28.274082000000078
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.69906818599992,
							28.26722641500004
						],
						[
							-82.69951790399995,
							28.267212138000048
						],
						[
							-82.69982485499992,
							28.26712647700009
						],
						[
							-82.69985340799991,
							28.26691946400007
						],
						[
							-82.69971064099991,
							28.266619652000088
						],
						[
							-82.69956787299992,
							28.266412639000066
						],
						[
							-82.69954645799993,
							28.266241318000084
						],
						[
							-82.6997320559999,
							28.26615565700007
						],
						[
							-82.70006755999992,
							28.26615565700007
						],
						[
							-82.7002460189999,
							28.266091412000037
						],
						[
							-82.70034595699991,
							28.266034305000062
						],
						[
							-82.70044589399993,
							28.265912952000065
						],
						[
							-82.70453372199995,
							28.265917224000077
						],
						[
							-82.7045753299999,
							28.268676506000077
						],
						[
							-82.70529273699994,
							28.268672937000076
						],
						[
							-82.70529987599991,
							28.269590219000065
						],
						[
							-82.70727720799994,
							28.269568804000073
						],
						[
							-82.70728791499994,
							28.270072060000075
						],
						[
							-82.70530701399991,
							28.270089906000067
						],
						[
							-82.70530701399991,
							28.270489655000063
						],
						[
							-82.70730932999993,
							28.27047894800006
						],
						[
							-82.70730932999993,
							28.27138195300006
						],
						[
							-82.70942586099994,
							28.27138195300006
						],
						[
							-82.70942657899991,
							28.271694830000058
						],
						[
							-82.70727199999993,
							28.27184600000004
						],
						[
							-82.7072179999999,
							28.273386000000073
						],
						[
							-82.70729499999993,
							28.27338000000009
						],
						[
							-82.70728899999995,
							28.274082000000078
						],
						[
							-82.70623251399991,
							28.274056427000062
						],
						[
							-82.70596699999993,
							28.274050000000045
						],
						[
							-82.70595899999996,
							28.273446000000035
						],
						[
							-82.7050839389999,
							28.27341700000005
						],
						[
							-82.70475199999993,
							28.27340600000008
						],
						[
							-82.70474399999995,
							28.27240000000006
						],
						[
							-82.70399399999991,
							28.273039000000043
						],
						[
							-82.70335199999994,
							28.273308000000043
						],
						[
							-82.70319625799993,
							28.27329915900009
						],
						[
							-82.70316371399991,
							28.269599737000078
						],
						[
							-82.69909007699994,
							28.269637808000084
						],
						[
							-82.69906818599992,
							28.26722641500004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pasco",
				"City": "New Port Richey",
				"Name": "Northeast",
				"RegionID": "270320"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.2633130001537,
					28.436633232840364,
					-81.24407140998566,
					28.450552991370543
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.24424158329737,
							28.450552991370543
						],
						[
							-81.24407140998566,
							28.436633232840364
						],
						[
							-81.25032767228552,
							28.436635122315963
						],
						[
							-81.25156240815684,
							28.436635494635297
						],
						[
							-81.25733222447313,
							28.436637208742994
						],
						[
							-81.25736117364926,
							28.436754411987177
						],
						[
							-81.25756046970625,
							28.437478486729916
						],
						[
							-81.25771569988305,
							28.437956194001345
						],
						[
							-81.2579410331114,
							28.43845693740657
						],
						[
							-81.25818239225828,
							28.43889658896706
						],
						[
							-81.25851488420301,
							28.439428378767346
						],
						[
							-81.25937215663224,
							28.440735316707887
						],
						[
							-81.2607131456026,
							28.442767330336444
						],
						[
							-81.26198102598735,
							28.444727236324702
						],
						[
							-81.26262798476537,
							28.445726718546403
						],
						[
							-81.2633130001537,
							28.446825000286175
						],
						[
							-81.26072300037346,
							28.447181999655534
						],
						[
							-81.26049899994032,
							28.446982000328745
						],
						[
							-81.26050500021695,
							28.447191000070433
						],
						[
							-81.25901599992757,
							28.447238000438297
						],
						[
							-81.25417499980591,
							28.448249000277166
						],
						[
							-81.2539900002712,
							28.448290000368488
						],
						[
							-81.25394399994943,
							28.44805700041991
						],
						[
							-81.2537160002313,
							28.44808900009633
						],
						[
							-81.25375700032262,
							28.448346000251973
						],
						[
							-81.25299800040885,
							28.448510999763982
						],
						[
							-81.25294499976437,
							28.448539000155417
						],
						[
							-81.2506199996092,
							28.44941500006651
						],
						[
							-81.24902599987557,
							28.449997999961184
						],
						[
							-81.24673500038838,
							28.450401999698403
						],
						[
							-81.24456700027571,
							28.450549000179343
						],
						[
							-81.24424158329737,
							28.450552991370543
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Bal Bay",
				"RegionID": "272844"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.12013969399993,
					26.147066477000067,
					-80.11381235099992,
					26.158769218000092
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.11419699999993,
							26.157124000000067
						],
						[
							-80.11420587999993,
							26.156919805000086
						],
						[
							-80.11431831699991,
							26.156694931000064
						],
						[
							-80.11459940899994,
							26.15652627600008
						],
						[
							-80.11485239199993,
							26.156441948000065
						],
						[
							-80.11504915699993,
							26.156245183000067
						],
						[
							-80.11521781199993,
							26.15602030900004
						],
						[
							-80.11530213999993,
							26.15565488900006
						],
						[
							-80.1152740309999,
							26.15517703200004
						],
						[
							-80.11479617399993,
							26.15531757900004
						],
						[
							-80.11451508099992,
							26.15531757900004
						],
						[
							-80.11412155199993,
							26.155261360000054
						],
						[
							-80.11384045999996,
							26.15514892300007
						],
						[
							-80.11381235099992,
							26.154839722000077
						],
						[
							-80.11389667799995,
							26.154502411000067
						],
						[
							-80.11406533399992,
							26.154024554000046
						],
						[
							-80.11437453499991,
							26.153518588000054
						],
						[
							-80.11468373699995,
							26.153181277000044
						],
						[
							-80.11473995499995,
							26.15287207500006
						],
						[
							-80.11488050199995,
							26.152338000000046
						],
						[
							-80.11513348499994,
							26.15146661400007
						],
						[
							-80.11547079499991,
							26.150539009000056
						],
						[
							-80.1158643249999,
							26.149836278000066
						],
						[
							-80.1161173079999,
							26.149161657000036
						],
						[
							-80.11625785399991,
							26.148571363000087
						],
						[
							-80.11622974499994,
							26.147896741000068
						],
						[
							-80.11608919899994,
							26.14713779200008
						],
						[
							-80.11608919899994,
							26.147066477000067
						],
						[
							-80.11659373399993,
							26.147077855000077
						],
						[
							-80.12013969399993,
							26.147157826000072
						],
						[
							-80.11997035999991,
							26.14834958000006
						],
						[
							-80.11959780699993,
							26.149933931000078
						],
						[
							-80.11928634499992,
							26.151013532000036
						],
						[
							-80.11902996499992,
							26.15174862200007
						],
						[
							-80.1186904619999,
							26.15300949100009
						],
						[
							-80.11822677599991,
							26.154745062000075
						],
						[
							-80.11794635899992,
							26.155792619000067
						],
						[
							-80.11752972699992,
							26.157333950000066
						],
						[
							-80.1173384569999,
							26.157265805000065
						],
						[
							-80.11687869299995,
							26.157107401000076
						],
						[
							-80.11657245999993,
							26.158203299000036
						],
						[
							-80.1160765859999,
							26.15854470000005
						],
						[
							-80.1157841779999,
							26.158769218000092
						],
						[
							-80.1145491879999,
							26.158243377000076
						],
						[
							-80.11419699999993,
							26.157124000000067
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Bal Harbour",
				"RegionID": "272845"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.50819608599994,
					27.89358223700009,
					-82.48481844699995,
					27.919500076000077
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.48482838799993,
							27.89365330800007
						],
						[
							-82.48481844699995,
							27.893599493000067
						],
						[
							-82.48573544499993,
							27.893599687000062
						],
						[
							-82.48721818199994,
							27.89360000100004
						],
						[
							-82.49391818399994,
							27.89360005500004
						],
						[
							-82.50652539499993,
							27.893595565000055
						],
						[
							-82.50819608599994,
							27.89358223700009
						],
						[
							-82.5077729859999,
							27.894149628000037
						],
						[
							-82.50631818199992,
							27.896100001000036
						],
						[
							-82.50295449499993,
							27.90240907300006
						],
						[
							-82.50220012499994,
							27.90550004800008
						],
						[
							-82.50017531899994,
							27.908499878000043
						],
						[
							-82.49821818099991,
							27.91140000000007
						],
						[
							-82.49331818199994,
							27.919099997000046
						],
						[
							-82.49291814899993,
							27.919500076000077
						],
						[
							-82.49061935499992,
							27.919313964000082
						],
						[
							-82.49025199999994,
							27.919197000000054
						],
						[
							-82.48948294999991,
							27.91872884600008
						],
						[
							-82.48963304799992,
							27.91845366600006
						],
						[
							-82.48972957299992,
							27.918184525000072
						],
						[
							-82.49025418199994,
							27.915975186000082
						],
						[
							-82.49029115999991,
							27.915742867000063
						],
						[
							-82.49030874599994,
							27.91557686200008
						],
						[
							-82.49030964899993,
							27.914941009000074
						],
						[
							-82.49026762599993,
							27.91402627100007
						],
						[
							-82.49026687799994,
							27.913966044000063
						],
						[
							-82.49027293299991,
							27.913678859000072
						],
						[
							-82.49025625699994,
							27.913466938000056
						],
						[
							-82.49018069399995,
							27.91306619900007
						],
						[
							-82.49011674099995,
							27.912804496000035
						],
						[
							-82.49007125999992,
							27.912657052000043
						],
						[
							-82.48901368999992,
							27.909883404000084
						],
						[
							-82.48900208899994,
							27.90985114500006
						],
						[
							-82.48891008899994,
							27.90957914600006
						],
						[
							-82.48888337199992,
							27.909482814000057
						],
						[
							-82.4888213719999,
							27.909198814000035
						],
						[
							-82.4888117239999,
							27.909147518000054
						],
						[
							-82.48875572399993,
							27.90879351800004
						],
						[
							-82.48874792799995,
							27.90872938700005
						],
						[
							-82.4887219279999,
							27.908424387000082
						],
						[
							-82.48871906999995,
							27.908321449000084
						],
						[
							-82.48873306999991,
							27.907847450000077
						],
						[
							-82.4887345489999,
							27.90781601100008
						],
						[
							-82.4887540279999,
							27.90751455600008
						],
						[
							-82.4887611659999,
							27.906923008000035
						],
						[
							-82.48870227799995,
							27.906300227000088
						],
						[
							-82.48855770299991,
							27.905379775000085
						],
						[
							-82.48842050999991,
							27.904425701000036
						],
						[
							-82.4881322409999,
							27.90256142700008
						],
						[
							-82.48812612199993,
							27.902513295000066
						],
						[
							-82.48794039199994,
							27.900651246000052
						],
						[
							-82.4878278459999,
							27.899273939000068
						],
						[
							-82.48781062299992,
							27.899152722000053
						],
						[
							-82.48754209999993,
							27.897953059000088
						],
						[
							-82.48718345099991,
							27.89647193500008
						],
						[
							-82.4870875389999,
							27.896189529000083
						],
						[
							-82.48682348799991,
							27.895636494000087
						],
						[
							-82.48614543999992,
							27.895552500000065
						],
						[
							-82.48611428499993,
							27.895548086000076
						],
						[
							-82.48591905999992,
							27.895516873000076
						],
						[
							-82.48584230499995,
							27.895500523000067
						],
						[
							-82.4857672679999,
							27.89547754000006
						],
						[
							-82.48569452099991,
							27.895448101000056
						],
						[
							-82.4856246199999,
							27.895412428000046
						],
						[
							-82.48555809499993,
							27.895370796000066
						],
						[
							-82.48548461599995,
							27.89532021800005
						],
						[
							-82.48544515799995,
							27.895293608000088
						],
						[
							-82.48538609999991,
							27.89525017400007
						],
						[
							-82.48533077499991,
							27.895202075000046
						],
						[
							-82.4852795509999,
							27.895149629000063
						],
						[
							-82.48523276999994,
							27.895093185000064
						],
						[
							-82.48519074099994,
							27.89503311800007
						],
						[
							-82.48510874099992,
							27.894905118000057
						],
						[
							-82.48506957199993,
							27.894837712000083
						],
						[
							-82.4850363889999,
							27.894767168000044
						],
						[
							-82.4850094389999,
							27.894694014000038
						],
						[
							-82.48498892599991,
							27.894618802000082
						],
						[
							-82.48495492599994,
							27.894468802000063
						],
						[
							-82.48493779599994,
							27.89436580800009
						],
						[
							-82.48489741599991,
							27.893988936000085
						],
						[
							-82.48482838799993,
							27.89365330800007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Bayshore Beautiful",
				"RegionID": "272879"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.42569899999995,
					28.069015320000066,
					-82.35394299999996,
					28.149398217000055
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.40836891799995,
							28.127656139000067
						],
						[
							-82.40781999999996,
							28.12765500000006
						],
						[
							-82.40782253799995,
							28.12961267700007
						],
						[
							-82.40782499999995,
							28.131512000000043
						],
						[
							-82.40647114799998,
							28.131517831000053
						],
						[
							-82.40503899999999,
							28.13152400000007
						],
						[
							-82.40356899999995,
							28.133117000000027
						],
						[
							-82.40323299999994,
							28.133621000000062
						],
						[
							-82.40315599999998,
							28.134011000000044
						],
						[
							-82.40320799999995,
							28.135043000000056
						],
						[
							-82.40349299999997,
							28.137152000000075
						],
						[
							-82.40307999999999,
							28.138619000000062
						],
						[
							-82.40315799999998,
							28.141026000000068
						],
						[
							-82.40326099999999,
							28.141163000000063
						],
						[
							-82.40344299999998,
							28.141988000000026
						],
						[
							-82.40357199999994,
							28.142172000000073
						],
						[
							-82.40377899999999,
							28.14331800000008
						],
						[
							-82.40377999999998,
							28.144395000000035
						],
						[
							-82.40352099999996,
							28.145106000000055
						],
						[
							-82.40261599999997,
							28.145794000000024
						],
						[
							-82.40227999999996,
							28.146161000000063
						],
						[
							-82.40093599999994,
							28.146826000000033
						],
						[
							-82.40049599999998,
							28.14721600000007
						],
						[
							-82.40031499999998,
							28.147628000000058
						],
						[
							-82.40039299999995,
							28.148087000000032
						],
						[
							-82.40107680899996,
							28.14928279700007
						],
						[
							-82.40114281199999,
							28.149398217000055
						],
						[
							-82.38669599999997,
							28.149392000000034
						],
						[
							-82.38374527199994,
							28.144431631000035
						],
						[
							-82.38079750199995,
							28.140209150000032
						],
						[
							-82.37520204499998,
							28.124984657000027
						],
						[
							-82.37376354199995,
							28.125291076000053
						],
						[
							-82.37346699399995,
							28.12447458200006
						],
						[
							-82.37295454399998,
							28.12306363700003
						],
						[
							-82.36989090899993,
							28.117900001000066
						],
						[
							-82.36613207999994,
							28.11055009200004
						],
						[
							-82.36531804799995,
							28.11730909100004
						],
						[
							-82.36556281699995,
							28.11821296200003
						],
						[
							-82.36522399999996,
							28.11798300000004
						],
						[
							-82.36505299999999,
							28.117965000000027
						],
						[
							-82.36497999999995,
							28.112805000000037
						],
						[
							-82.36496999599996,
							28.112664945000063
						],
						[
							-82.36495699999995,
							28.112483000000054
						],
						[
							-82.36477399999995,
							28.100150000000042
						],
						[
							-82.36472784799997,
							28.099410731000035
						],
						[
							-82.364719,
							28.09926900000005
						],
						[
							-82.36331399999996,
							28.09804500000007
						],
						[
							-82.36066399999999,
							28.096149000000025
						],
						[
							-82.36028499999998,
							28.09588300000007
						],
						[
							-82.35932076199998,
							28.095205891000035
						],
						[
							-82.35915999999997,
							28.095093000000077
						],
						[
							-82.35884099999998,
							28.09478800000005
						],
						[
							-82.35800399999994,
							28.09398900000008
						],
						[
							-82.35664699999995,
							28.092569000000026
						],
						[
							-82.35540999999995,
							28.090422000000046
						],
						[
							-82.35471599999994,
							28.08889900000003
						],
						[
							-82.35434599999996,
							28.08753900000005
						],
						[
							-82.35433738099994,
							28.087507517000066
						],
						[
							-82.35427399999998,
							28.08727600000003
						],
						[
							-82.35425799999996,
							28.087153000000058
						],
						[
							-82.35424499999993,
							28.087092000000045
						],
						[
							-82.354242738,
							28.087074677000032
						],
						[
							-82.35394299999996,
							28.084779000000026
						],
						[
							-82.35397699999999,
							28.076370000000054
						],
						[
							-82.35403964999995,
							28.07591573000008
						],
						[
							-82.35423599999996,
							28.074492000000077
						],
						[
							-82.35487899999998,
							28.07244400000008
						],
						[
							-82.35488999999995,
							28.072415000000035
						],
						[
							-82.35569999999996,
							28.070257000000026
						],
						[
							-82.35577099999995,
							28.07002300000005
						],
						[
							-82.35572779499995,
							28.069761571000072
						],
						[
							-82.35571199999998,
							28.06966600000004
						],
						[
							-82.35601299999996,
							28.069653000000073
						],
						[
							-82.35839899999996,
							28.069521000000066
						],
						[
							-82.35961599999996,
							28.069453000000067
						],
						[
							-82.36236599999995,
							28.069445000000034
						],
						[
							-82.36366699999996,
							28.069483000000048
						],
						[
							-82.36488899999995,
							28.069518000000073
						],
						[
							-82.36793599999999,
							28.069672000000025
						],
						[
							-82.36823999999996,
							28.069683000000055
						],
						[
							-82.36907999999994,
							28.069712000000038
						],
						[
							-82.36907777199997,
							28.07031018600003
						],
						[
							-82.36903799999999,
							28.080989000000045
						],
						[
							-82.36903799999999,
							28.081145544000037
						],
						[
							-82.36903799999999,
							28.081222000000025
						],
						[
							-82.36903799999999,
							28.081313000000023
						],
						[
							-82.36911799999996,
							28.081313000000023
						],
						[
							-82.36918447499994,
							28.081299349000062
						],
						[
							-82.36921799999999,
							28.08128400000004
						],
						[
							-82.36926399999999,
							28.08124600000008
						],
						[
							-82.36929899999996,
							28.081200000000024
						],
						[
							-82.36935599999998,
							28.081102000000044
						],
						[
							-82.36945299999996,
							28.080899000000045
						],
						[
							-82.36952599999995,
							28.080810000000042
						],
						[
							-82.36961099999996,
							28.080730000000074
						],
						[
							-82.36968199999995,
							28.080677000000037
						],
						[
							-82.36975259399998,
							28.08063339800003
						],
						[
							-82.36977999999993,
							28.080614000000025
						],
						[
							-82.37003099999998,
							28.080475000000035
						],
						[
							-82.37029799999993,
							28.08035700000005
						],
						[
							-82.37081599999993,
							28.08023000000003
						],
						[
							-82.37115699999998,
							28.080174000000056
						],
						[
							-82.37131499999998,
							28.080129000000056
						],
						[
							-82.37155499999994,
							28.080020000000047
						],
						[
							-82.37173299999995,
							28.07997000000006
						],
						[
							-82.37224199999997,
							28.07991000000004
						],
						[
							-82.37257199999993,
							28.079846000000032
						],
						[
							-82.37265799999994,
							28.07980500000008
						],
						[
							-82.37274099999996,
							28.079738000000077
						],
						[
							-82.37279277999994,
							28.07966844400005
						],
						[
							-82.37280099999998,
							28.079631000000063
						],
						[
							-82.37280099999998,
							28.07952100000006
						],
						[
							-82.37281099999996,
							28.07946700000008
						],
						[
							-82.37284904599994,
							28.079378227000063
						],
						[
							-82.37284599999998,
							28.079363000000058
						],
						[
							-82.37278192399998,
							28.07925546000007
						],
						[
							-82.37274999999994,
							28.079281000000037
						],
						[
							-82.37272299999995,
							28.079293000000064
						],
						[
							-82.37268999999998,
							28.079296000000056
						],
						[
							-82.37265899999994,
							28.07929100000007
						],
						[
							-82.37264099999999,
							28.07927200000006
						],
						[
							-82.37260999999995,
							28.079192000000035
						],
						[
							-82.37255999999996,
							28.079090000000065
						],
						[
							-82.37254799999994,
							28.079037000000028
						],
						[
							-82.37255599999997,
							28.078899000000035
						],
						[
							-82.37255,
							28.078431000000023
						],
						[
							-82.37256699999995,
							28.078294000000028
						],
						[
							-82.37259294699999,
							28.078168896000083
						],
						[
							-82.372597,
							28.078110000000038
						],
						[
							-82.37262699999997,
							28.078013000000055
						],
						[
							-82.37270499999994,
							28.077908000000036
						],
						[
							-82.37276899999995,
							28.07788200000005
						],
						[
							-82.37285575599998,
							28.07789223700007
						],
						[
							-82.37289645299995,
							28.077897268000072
						],
						[
							-82.37291599999998,
							28.077900000000056
						],
						[
							-82.37294199999997,
							28.07791100000003
						],
						[
							-82.37296299999997,
							28.07793000000004
						],
						[
							-82.37297278699998,
							28.077942432000043
						],
						[
							-82.37301599999995,
							28.077968000000055
						],
						[
							-82.37320399999999,
							28.078115000000025
						],
						[
							-82.37329399999999,
							28.078170000000057
						],
						[
							-82.37338399999999,
							28.078151000000048
						],
						[
							-82.37343299999998,
							28.078067000000033
						],
						[
							-82.37353199999997,
							28.077734000000078
						],
						[
							-82.37354073499995,
							28.07771904200007
						],
						[
							-82.37355499999995,
							28.077680000000043
						],
						[
							-82.37358499999993,
							28.077630000000056
						],
						[
							-82.37360498099997,
							28.07760902000007
						],
						[
							-82.37361199999998,
							28.077597000000026
						],
						[
							-82.37365599999998,
							28.07753900000006
						],
						[
							-82.37374199999994,
							28.07747900000004
						],
						[
							-82.37384299999997,
							28.07743400000004
						],
						[
							-82.37401199999994,
							28.077386000000047
						],
						[
							-82.37412870799994,
							28.077328790000024
						],
						[
							-82.37417499999998,
							28.07729600000005
						],
						[
							-82.37420899699998,
							28.07728454000005
						],
						[
							-82.37430799999998,
							28.07722500000006
						],
						[
							-82.37431788299996,
							28.07721637000003
						],
						[
							-82.37436799999995,
							28.077117000000044
						],
						[
							-82.37440699999996,
							28.077076000000034
						],
						[
							-82.37455599999998,
							28.07697600000006
						],
						[
							-82.37465999999996,
							28.076872000000037
						],
						[
							-82.37468399999995,
							28.076858000000072
						],
						[
							-82.37470790499998,
							28.076851831000056
						],
						[
							-82.37471499999998,
							28.076850000000036
						],
						[
							-82.37474999999995,
							28.076850000000036
						],
						[
							-82.37477999999999,
							28.076857000000075
						],
						[
							-82.37480299999999,
							28.07687100000004
						],
						[
							-82.37481999999994,
							28.076896000000033
						],
						[
							-82.37482999999997,
							28.076924000000076
						],
						[
							-82.37483199999997,
							28.076951000000065
						],
						[
							-82.37481999999994,
							28.07700600000004
						],
						[
							-82.37481599999995,
							28.077063000000066
						],
						[
							-82.37481999999994,
							28.077090000000055
						],
						[
							-82.37483799999995,
							28.07711000000006
						],
						[
							-82.37486399999995,
							28.077125000000024
						],
						[
							-82.37492199999997,
							28.07714800000008
						],
						[
							-82.37501299999997,
							28.07716700000003
						],
						[
							-82.37519899999995,
							28.077175000000068
						],
						[
							-82.37544799999995,
							28.07720500000005
						],
						[
							-82.37550799999997,
							28.077222000000063
						],
						[
							-82.37552699999998,
							28.07723800000008
						],
						[
							-82.37553399999996,
							28.07726400000007
						],
						[
							-82.37553599999995,
							28.07746100000003
						],
						[
							-82.37555899999995,
							28.07770800000003
						],
						[
							-82.37558099999995,
							28.077844000000027
						],
						[
							-82.37565199999995,
							28.078027000000077
						],
						[
							-82.37566199999998,
							28.078080000000057
						],
						[
							-82.37566099999998,
							28.078108000000043
						],
						[
							-82.37563499999999,
							28.078246000000036
						],
						[
							-82.37563299999994,
							28.078299000000072
						],
						[
							-82.37563999999998,
							28.078326000000065
						],
						[
							-82.37565399999994,
							28.078352000000052
						],
						[
							-82.37569399999995,
							28.078395000000057
						],
						[
							-82.37571899999995,
							28.078410000000076
						],
						[
							-82.37577599999997,
							28.078434000000073
						],
						[
							-82.37586599999997,
							28.07845800000007
						],
						[
							-82.37605099999996,
							28.078479000000073
						],
						[
							-82.37624099999994,
							28.078479000000073
						],
						[
							-82.37630099999996,
							28.078469000000045
						],
						[
							-82.37632699999995,
							28.07845800000007
						],
						[
							-82.37634799999995,
							28.078440000000057
						],
						[
							-82.37638199999998,
							28.078391000000067
						],
						[
							-82.37641999999994,
							28.07834500000007
						],
						[
							-82.37644399999994,
							28.07833100000005
						],
						[
							-82.37647299999998,
							28.07832200000007
						],
						[
							-82.37659699999995,
							28.078298000000075
						],
						[
							-82.37662499999999,
							28.078287000000046
						],
						[
							-82.37672799999996,
							28.07822500000003
						],
						[
							-82.37681299999997,
							28.07819100000006
						],
						[
							-82.37687399999999,
							28.078178000000037
						],
						[
							-82.37693499999995,
							28.07817600000004
						],
						[
							-82.37705899999997,
							28.07818700000007
						],
						[
							-82.37717999999995,
							28.078211000000067
						],
						[
							-82.37735699999996,
							28.07826300000005
						],
						[
							-82.37752599999999,
							28.07833500000004
						],
						[
							-82.37758499999995,
							28.078348000000062
						],
						[
							-82.37764699999997,
							28.07835100000006
						],
						[
							-82.37774099999996,
							28.07834500000007
						],
						[
							-82.37783199999996,
							28.07832300000007
						],
						[
							-82.37789199999997,
							28.078315000000032
						],
						[
							-82.37795299999993,
							28.078320000000076
						],
						[
							-82.37831799999998,
							28.078389000000072
						],
						[
							-82.37847299999999,
							28.078400000000045
						],
						[
							-82.37875299999996,
							28.078404000000035
						],
						[
							-82.37881199999998,
							28.078415000000064
						],
						[
							-82.37886899999995,
							28.07843900000006
						],
						[
							-82.37897,
							28.07850600000006
						],
						[
							-82.37903699999998,
							28.07856400000003
						],
						[
							-82.37906799999996,
							28.07861000000003
						],
						[
							-82.37908299999998,
							28.078666000000055
						],
						[
							-82.37907499999994,
							28.078719000000035
						],
						[
							-82.37904199999997,
							28.078796000000068
						],
						[
							-82.37895499999996,
							28.078945000000033
						],
						[
							-82.37876799999998,
							28.079199000000074
						],
						[
							-82.37874299999999,
							28.07924900000006
						],
						[
							-82.37873799999996,
							28.079278000000045
						],
						[
							-82.37874099999993,
							28.079305000000033
						],
						[
							-82.37875899999995,
							28.07932500000004
						],
						[
							-82.37878899999998,
							28.079338000000064
						],
						[
							-82.37881899999996,
							28.079341000000056
						],
						[
							-82.37885099999994,
							28.079334000000078
						],
						[
							-82.378878,
							28.07932100000005
						],
						[
							-82.37899099999998,
							28.079225000000065
						],
						[
							-82.37903099999994,
							28.07920500000006
						],
						[
							-82.37908899999996,
							28.07918600000005
						],
						[
							-82.37916999999999,
							28.079143000000045
						],
						[
							-82.37921799999998,
							28.079109000000074
						],
						[
							-82.37925799999994,
							28.079068000000063
						],
						[
							-82.37928899999997,
							28.079019000000073
						],
						[
							-82.37930899999998,
							28.078967000000034
						],
						[
							-82.37936999999994,
							28.07887100000005
						],
						[
							-82.37938999999994,
							28.078820000000064
						],
						[
							-82.37939599999999,
							28.078737000000046
						],
						[
							-82.37937199999999,
							28.078629000000035
						],
						[
							-82.37935399999998,
							28.07846500000005
						],
						[
							-82.37933399999997,
							28.078190000000063
						],
						[
							-82.37930999999998,
							28.07808200000005
						],
						[
							-82.37931399999997,
							28.07805600000006
						],
						[
							-82.37940899999995,
							28.077736000000073
						],
						[
							-82.37950399999994,
							28.07756100000006
						],
						[
							-82.37953599999997,
							28.077515000000062
						],
						[
							-82.37956099999997,
							28.077500000000043
						],
						[
							-82.37961899999993,
							28.077478000000042
						],
						[
							-82.37964399999998,
							28.07746200000003
						],
						[
							-82.37970399999995,
							28.07739900000007
						],
						[
							-82.37979399999995,
							28.07725400000004
						],
						[
							-82.37983099999997,
							28.077176000000065
						],
						[
							-82.37984699999998,
							28.077154000000068
						],
						[
							-82.37986899999999,
							28.07713700000005
						],
						[
							-82.37989599999997,
							28.07712300000003
						],
						[
							-82.37991188299998,
							28.077117085000054
						],
						[
							-82.37996299999998,
							28.077080000000024
						],
						[
							-82.38033699999994,
							28.076964000000032
						],
						[
							-82.38044099999996,
							28.076910000000055
						],
						[
							-82.38056399999995,
							28.076797000000056
						],
						[
							-82.38062699999995,
							28.07670200000007
						],
						[
							-82.38066599999996,
							28.07658200000003
						],
						[
							-82.380659,
							28.076459000000057
						],
						[
							-82.38064099999997,
							28.07640800000007
						],
						[
							-82.38062399999995,
							28.07635700000003
						],
						[
							-82.38060599999994,
							28.076248000000078
						],
						[
							-82.38062599999995,
							28.075887000000023
						],
						[
							-82.38058999999998,
							28.075461000000075
						],
						[
							-82.38052199999998,
							28.074790000000064
						],
						[
							-82.38056699999999,
							28.074491000000023
						],
						[
							-82.38055999999995,
							28.07425500000005
						],
						[
							-82.38051299999995,
							28.074087000000077
						],
						[
							-82.38043499999998,
							28.073908000000074
						],
						[
							-82.38032999999996,
							28.07377400000007
						],
						[
							-82.38024499999995,
							28.07370700000007
						],
						[
							-82.38003399999997,
							28.073623000000055
						],
						[
							-82.37986399999996,
							28.07353100000006
						],
						[
							-82.37976099999997,
							28.07345900000007
						],
						[
							-82.37953899999997,
							28.073241000000056
						],
						[
							-82.37940799999996,
							28.07309300000003
						],
						[
							-82.37933399999997,
							28.072959000000026
						],
						[
							-82.37919999999997,
							28.072452000000055
						],
						[
							-82.37913899999995,
							28.072281000000036
						],
						[
							-82.37908599999997,
							28.072175000000072
						],
						[
							-82.37899799999997,
							28.072094000000053
						],
						[
							-82.37877199999997,
							28.072017000000073
						],
						[
							-82.37851199999994,
							28.071843000000058
						],
						[
							-82.37845099999998,
							28.071802000000048
						],
						[
							-82.37819799999994,
							28.071668000000045
						],
						[
							-82.37806899999998,
							28.07151200000004
						],
						[
							-82.37799977699996,
							28.07141311000004
						],
						[
							-82.37794499999995,
							28.071339000000023
						],
						[
							-82.37790630099994,
							28.071276236000074
						],
						[
							-82.37786799999998,
							28.071219000000042
						],
						[
							-82.37785952499996,
							28.071200372000078
						],
						[
							-82.37782599999997,
							28.071146000000056
						],
						[
							-82.37777799999998,
							28.07104400000003
						],
						[
							-82.37775085199996,
							28.070961513000043
						],
						[
							-82.37767099999996,
							28.070786000000055
						],
						[
							-82.37764411999996,
							28.07068324900007
						],
						[
							-82.37764199999998,
							28.070678000000044
						],
						[
							-82.37758099999996,
							28.070494000000053
						],
						[
							-82.37753699999996,
							28.070305000000076
						],
						[
							-82.37751399999996,
							28.070141000000035
						],
						[
							-82.37751598499995,
							28.070005011000035
						],
						[
							-82.37750999999997,
							28.069922000000076
						],
						[
							-82.37748299999998,
							28.06978600000008
						],
						[
							-82.37741801499999,
							28.069546204000062
						],
						[
							-82.37738299999995,
							28.069417000000044
						],
						[
							-82.39306299999998,
							28.069340000000068
						],
						[
							-82.39378299999998,
							28.06932000000006
						],
						[
							-82.39490099999995,
							28.06936900000005
						],
						[
							-82.39742699999994,
							28.069359000000077
						],
						[
							-82.40116999999998,
							28.069280000000052
						],
						[
							-82.40190503499997,
							28.069330198000046
						],
						[
							-82.40198999999996,
							28.069336000000078
						],
						[
							-82.40207516399995,
							28.06923201500007
						],
						[
							-82.40229103099995,
							28.06922741300008
						],
						[
							-82.40229999799999,
							28.06916363600004
						],
						[
							-82.40230909099995,
							28.06912727300005
						],
						[
							-82.40231858899995,
							28.069015320000066
						],
						[
							-82.40985404699995,
							28.06915292800005
						],
						[
							-82.40988799999997,
							28.071162000000072
						],
						[
							-82.409904,
							28.071943000000033
						],
						[
							-82.40990999999997,
							28.072641000000033
						],
						[
							-82.40995699999996,
							28.074876000000074
						],
						[
							-82.40997699999997,
							28.07582400000007
						],
						[
							-82.40998699999994,
							28.076317000000074
						],
						[
							-82.40999699999998,
							28.076768000000072
						],
						[
							-82.41002099999997,
							28.077924000000053
						],
						[
							-82.41006599999997,
							28.078869000000054
						],
						[
							-82.41008799999997,
							28.079346000000044
						],
						[
							-82.41009099999997,
							28.08012700000006
						],
						[
							-82.41009099999997,
							28.080254000000025
						],
						[
							-82.41022499999997,
							28.080359000000044
						],
						[
							-82.40983599999998,
							28.081342000000063
						],
						[
							-82.40973999999994,
							28.081590000000062
						],
						[
							-82.40964299999996,
							28.081837000000064
						],
						[
							-82.40933199999995,
							28.082701000000043
						],
						[
							-82.40932299999997,
							28.083019000000036
						],
						[
							-82.40932399999997,
							28.083308000000045
						],
						[
							-82.40932499999997,
							28.083567000000073
						],
						[
							-82.40935199999996,
							28.086856000000072
						],
						[
							-82.40937899999994,
							28.089414000000037
						],
						[
							-82.40939999999995,
							28.101665000000025
						],
						[
							-82.40939599999996,
							28.102242000000047
						],
						[
							-82.40939599999996,
							28.103942000000078
						],
						[
							-82.40939799999995,
							28.10725000000008
						],
						[
							-82.40940599999999,
							28.10943800000007
						],
						[
							-82.41020017399995,
							28.109465029000035
						],
						[
							-82.41191703499999,
							28.10952345900006
						],
						[
							-82.41316699999999,
							28.10956600000003
						],
						[
							-82.42569899999995,
							28.109886000000074
						],
						[
							-82.42522799999995,
							28.110199000000023
						],
						[
							-82.42470799999995,
							28.11073200000004
						],
						[
							-82.42385279199993,
							28.112237308000033
						],
						[
							-82.42350299999998,
							28.11285300000003
						],
						[
							-82.42311345699994,
							28.114391410000053
						],
						[
							-82.422892,
							28.115266000000076
						],
						[
							-82.42244499999998,
							28.11605600000007
						],
						[
							-82.41762887899995,
							28.125751845000025
						],
						[
							-82.41729599999996,
							28.126422000000048
						],
						[
							-82.41377699999998,
							28.12651500000004
						],
						[
							-82.41375887799995,
							28.127554272000054
						],
						[
							-82.41375699999998,
							28.127662000000047
						],
						[
							-82.41312199999999,
							28.127666000000033
						],
						[
							-82.40938673899996,
							28.12765825100007
						],
						[
							-82.40840031999994,
							28.12765620400006
						],
						[
							-82.40836891799995,
							28.127656139000067
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Tampa Palms",
				"RegionID": "269207"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.45489025076711,
					28.52768426611923,
					-81.44259100038656,
					28.534480000228186
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.44259293662688,
							28.53429804939521
						],
						[
							-81.44259100038656,
							28.528718999965747
						],
						[
							-81.44274400024476,
							28.528716999873566
						],
						[
							-81.44274400024476,
							28.528163000416413
						],
						[
							-81.44282449406303,
							28.528163000416413
						],
						[
							-81.44285900014991,
							28.528163000416413
						],
						[
							-81.44285900014991,
							28.52808200027986
						],
						[
							-81.44282558583993,
							28.52808200027986
						],
						[
							-81.44283123448159,
							28.52781640800156
						],
						[
							-81.44324184513513,
							28.527814459170685
						],
						[
							-81.44330794350556,
							28.527814459170685
						],
						[
							-81.44354329248337,
							28.52780844990089
						],
						[
							-81.44365145214522,
							28.527806447110777
						],
						[
							-81.44481017192268,
							28.527785416465107
						],
						[
							-81.44554526156162,
							28.527777404405114
						],
						[
							-81.44665690992476,
							28.527768391399754
						],
						[
							-81.44907149064804,
							28.527734340369758
						],
						[
							-81.45085012838877,
							28.52774135148438
						],
						[
							-81.4522782463753,
							28.527726328309853
						],
						[
							-81.45232731968055,
							28.527725327364394
						],
						[
							-81.45238340230159,
							28.52772432551965
						],
						[
							-81.45415503072644,
							28.52768426611923
						],
						[
							-81.45475191525392,
							28.527687270754086
						],
						[
							-81.45489017612336,
							28.527687270754086
						],
						[
							-81.45489025076711,
							28.53417602398632
						],
						[
							-81.45290717284736,
							28.534175893584674
						],
						[
							-81.45291122968906,
							28.534280000002028
						],
						[
							-81.45189300020034,
							28.534280000002028
						],
						[
							-81.45099300008226,
							28.534280000002028
						],
						[
							-81.44888399999135,
							28.534328000416075
						],
						[
							-81.44659299960479,
							28.534380000115107
						],
						[
							-81.4450470002852,
							28.534380000115107
						],
						[
							-81.44459300004178,
							28.534380000115107
						],
						[
							-81.4428929999186,
							28.534380000115107
						],
						[
							-81.44259299957945,
							28.534480000228186
						],
						[
							-81.44259293662688,
							28.53429804939521
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Timberleaf",
				"RegionID": "269214"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.1909019169999,
					25.80884675200008,
					-80.16086399999995,
					25.85561559400009
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-80.1608644829999,
								25.809942701000068
							],
							[
								-80.1608671919999,
								25.80904309200008
							],
							[
								-80.16213417099993,
								25.80908277000009
							],
							[
								-80.1625623779999,
								25.809055196000088
							],
							[
								-80.16297964899991,
								25.808974668000076
							],
							[
								-80.16314299999993,
								25.808959678000065
							],
							[
								-80.16322850099994,
								25.808963752000068
							],
							[
								-80.16425496999994,
								25.809061786000086
							],
							[
								-80.1686137289999,
								25.809072682000078
							],
							[
								-80.17152950299993,
								25.809083092000037
							],
							[
								-80.17200664299992,
								25.808903412000063
							],
							[
								-80.17207867999991,
								25.808879565000044
							],
							[
								-80.17215252299991,
								25.808862092000084
							],
							[
								-80.17222760899996,
								25.808851127000082
							],
							[
								-80.17230336499995,
								25.80884675200008
							],
							[
								-80.17237921399993,
								25.808849002000045
							],
							[
								-80.17245457699994,
								25.808857860000046
							],
							[
								-80.17252888099995,
								25.808873257000077
							],
							[
								-80.17262826699994,
								25.808898071000044
							],
							[
								-80.17366138099993,
								25.809142392000073
							],
							[
								-80.17373035799994,
								25.809161841000048
							],
							[
								-80.17379756699995,
								25.80918672100006
							],
							[
								-80.1738625829999,
								25.80921687400007
							],
							[
								-80.17392498999993,
								25.809252108000067
							],
							[
								-80.17398439399994,
								25.809292199000083
							],
							[
								-80.1740404169999,
								25.80933689300008
							],
							[
								-80.17409270299993,
								25.809385906000045
							],
							[
								-80.17414092099995,
								25.809438927000087
							],
							[
								-80.17418429299994,
								25.809494959000062
							],
							[
								-80.17422311899992,
								25.80955423100005
							],
							[
								-80.17425715799993,
								25.80961637500008
							],
							[
								-80.17428619999993,
								25.80968100700005
							],
							[
								-80.1743100619999,
								25.80974772500008
							],
							[
								-80.17432859799993,
								25.809816114000057
							],
							[
								-80.17443859799994,
								25.810296113000053
							],
							[
								-80.17444765899995,
								25.810340834000044
							],
							[
								-80.1744613219999,
								25.810497000000055
							],
							[
								-80.17444765899995,
								25.810653166000066
							],
							[
								-80.17440708599992,
								25.810804586000074
							],
							[
								-80.17434083599994,
								25.81094666100006
							],
							[
								-80.17432037999994,
								25.810980363000056
							],
							[
								-80.17416858399991,
								25.811218525000072
							],
							[
								-80.1739995019999,
								25.811546797000062
							],
							[
								-80.17397883599995,
								25.81158466100004
							],
							[
								-80.1738889209999,
								25.811713073000078
							],
							[
								-80.17377807299994,
								25.81182392000005
							],
							[
								-80.1736496609999,
								25.81191383500004
							],
							[
								-80.17350758599991,
								25.811980086000062
							],
							[
								-80.1733561659999,
								25.81202065900004
							],
							[
								-80.17325123299992,
								25.81203286100009
							],
							[
								-80.17255023299992,
								25.812072861000047
							],
							[
								-80.17248884599991,
								25.81207426400005
							],
							[
								-80.17009032199991,
								25.812047117000077
							],
							[
								-80.16727315899993,
								25.81196820300005
							],
							[
								-80.16096106799995,
								25.811908692000088
							],
							[
								-80.16096199999993,
								25.81185600000009
							],
							[
								-80.16090715999991,
								25.811008822000076
							],
							[
								-80.1609039999999,
								25.81096000000008
							],
							[
								-80.16086499999994,
								25.81050900000008
							],
							[
								-80.16086399999995,
								25.810103000000083
							],
							[
								-80.1608644829999,
								25.809942701000068
							]
						]
					],
					[
						[
							[
								-80.17108283399995,
								25.815542341000082
							],
							[
								-80.1712389999999,
								25.815528678000078
							],
							[
								-80.17139516499992,
								25.815542341000082
							],
							[
								-80.17149855199995,
								25.815566947000036
							],
							[
								-80.17170755199993,
								25.815629947000048
							],
							[
								-80.17175558699995,
								25.815645914000072
							],
							[
								-80.17189766099995,
								25.81571216400005
							],
							[
								-80.17202607299993,
								25.815802080000083
							],
							[
								-80.17213692099995,
								25.815912927000056
							],
							[
								-80.17222683599994,
								25.816041339000037
							],
							[
								-80.1722930869999,
								25.81618341400008
							],
							[
								-80.17233365999994,
								25.816334835000077
							],
							[
								-80.17234501199994,
								25.816426583000066
							],
							[
								-80.17238501199995,
								25.81698358200009
							],
							[
								-80.1723873219999,
								25.81704871100004
							],
							[
								-80.1723849089999,
								25.817113835000043
							],
							[
								-80.1723777869999,
								25.817178614000056
							],
							[
								-80.17236599199992,
								25.817242707000048
							],
							[
								-80.17212015099994,
								25.818351272000086
							],
							[
								-80.1721258739999,
								25.818659729000046
							],
							[
								-80.17219032299994,
								25.81887434400005
							],
							[
								-80.1722093599999,
								25.818949297000074
							],
							[
								-80.17222188699992,
								25.81902560900005
							],
							[
								-80.1722278119999,
								25.81910271600009
							],
							[
								-80.17222709099991,
								25.819180046000042
							],
							[
								-80.17221972899995,
								25.819257028000038
							],
							[
								-80.1722057799999,
								25.819333093000072
							],
							[
								-80.17218534799993,
								25.81940767800006
							],
							[
								-80.17201534799995,
								25.819937678000088
							],
							[
								-80.1720040859999,
								25.819970586000068
							],
							[
								-80.17193783499994,
								25.820112661000053
							],
							[
								-80.17184791999995,
								25.82024107300009
							],
							[
								-80.17173707299992,
								25.820351920000064
							],
							[
								-80.17160866099994,
								25.820441836000043
							],
							[
								-80.17146658599995,
								25.820508086000075
							],
							[
								-80.1713151649999,
								25.820548659000053
							],
							[
								-80.17115899999995,
								25.820562322000058
							],
							[
								-80.17100283399992,
								25.820548659000053
							],
							[
								-80.17088380099995,
								25.820519181000066
							],
							[
								-80.17086155599992,
								25.820507640000073
							],
							[
								-80.17074418899995,
								25.820472737000046
							],
							[
								-80.17071141399992,
								25.820463087000064
							],
							[
								-80.17056933899994,
								25.820396836000043
							],
							[
								-80.1704409269999,
								25.820306921000057
							],
							[
								-80.17033007999993,
								25.82019607300009
							],
							[
								-80.17024016499994,
								25.820067661000053
							],
							[
								-80.17017391399992,
								25.819925587000057
							],
							[
								-80.17013334099994,
								25.81977416600006
							],
							[
								-80.17013001399994,
								25.819744712000045
							],
							[
								-80.17011522899992,
								25.81961863400005
							],
							[
								-80.17007866599994,
								25.819393830000084
							],
							[
								-80.17006967799995,
								25.81926700000008
							],
							[
								-80.1700840659999,
								25.819106829000077
							],
							[
								-80.17008966999992,
								25.81907654300005
							],
							[
								-80.17001051199992,
								25.81902003400006
							],
							[
								-80.16989621999994,
								25.818926477000048
							],
							[
								-80.16984256199993,
								25.81887826700006
							],
							[
								-80.16979294099991,
								25.818825910000044
							],
							[
								-80.16974767699992,
								25.818769745000054
							],
							[
								-80.16970706099994,
								25.818710132000035
							],
							[
								-80.16967135399995,
								25.818647455000075
							],
							[
								-80.16964078599995,
								25.818582117000062
							],
							[
								-80.16961555299991,
								25.81851454000008
							],
							[
								-80.16959581899994,
								25.818445157000042
							],
							[
								-80.16954581899995,
								25.818238157000053
							],
							[
								-80.16953312999993,
								25.81817613700008
							],
							[
								-80.16952483599995,
								25.818113378000078
							],
							[
								-80.16952097699993,
								25.818050191000054
							],
							[
								-80.16952157299994,
								25.817986890000043
							],
							[
								-80.16953157299992,
								25.81776289000004
							],
							[
								-80.1695369329999,
								25.817697120000048
							],
							[
								-80.16954710099992,
								25.817631920000053
							],
							[
								-80.16956202199992,
								25.81756764100004
							],
							[
								-80.16958161699995,
								25.81750462900004
							],
							[
								-80.16960577899994,
								25.817443224000044
							],
							[
								-80.16971577899994,
								25.817191223000066
							],
							[
								-80.16976116399991,
								25.81710133900009
							],
							[
								-80.16979671299993,
								25.81704473500008
							],
							[
								-80.17001671299994,
								25.816721735000044
							],
							[
								-80.17009446999992,
								25.816623145000055
							],
							[
								-80.17029232199991,
								25.81640544600009
							],
							[
								-80.1703928849999,
								25.81612326900006
							],
							[
								-80.1704601639999,
								25.815978339000083
							],
							[
								-80.17055007899995,
								25.815849927000045
							],
							[
								-80.17066092699991,
								25.815739079000082
							],
							[
								-80.17078933899995,
								25.815649164000035
							],
							[
								-80.17093141299995,
								25.815582914000064
							],
							[
								-80.17108283399995,
								25.815542341000082
							]
						]
					],
					[
						[
							[
								-80.16990983399995,
								25.82179134100005
							],
							[
								-80.1700659999999,
								25.821777678000046
							],
							[
								-80.17022216499993,
								25.82179134100005
							],
							[
								-80.17037358599993,
								25.821831914000086
							],
							[
								-80.17051566099991,
								25.82189816500005
							],
							[
								-80.17055672799995,
								25.82192336500009
							],
							[
								-80.1705997279999,
								25.821951365000075
							],
							[
								-80.1706870729999,
								25.822016079000036
							],
							[
								-80.17079791999993,
								25.822126927000056
							],
							[
								-80.1708878359999,
								25.82225533900004
							],
							[
								-80.17095408599994,
								25.82239741300009
							],
							[
								-80.17099465899992,
								25.822548834000088
							],
							[
								-80.17100832199992,
								25.82270500000004
							],
							[
								-80.17100826599994,
								25.822823090000043
							],
							[
								-80.17099620999994,
								25.82359117900006
							],
							[
								-80.17098265899995,
								25.823733166000068
							],
							[
								-80.17093923199991,
								25.82389221300008
							],
							[
								-80.17077637799991,
								25.824315838000075
							],
							[
								-80.17074720199992,
								25.824383324000053
							],
							[
								-80.17071261099994,
								25.824448200000063
							],
							[
								-80.17067283699993,
								25.82451003400007
							],
							[
								-80.17062814399992,
								25.824568413000065
							],
							[
								-80.17057883199993,
								25.82462294600009
							],
							[
								-80.1703988889999,
								25.824806284000093
							],
							[
								-80.17043512299995,
								25.824978025000064
							],
							[
								-80.17053040099995,
								25.82526130800005
							],
							[
								-80.17056365899992,
								25.82539183500006
							],
							[
								-80.17057732199993,
								25.825548000000083
							],
							[
								-80.17057732199993,
								25.825631000000048
							],
							[
								-80.17056365899992,
								25.825787165000065
							],
							[
								-80.17055402799991,
								25.825834359000055
							],
							[
								-80.17054102799995,
								25.825890359000084
							],
							[
								-80.17052181199995,
								25.825960228000042
							],
							[
								-80.17049703299995,
								25.82602832200007
							],
							[
								-80.17046685199995,
								25.826094201000046
							],
							[
								-80.17043146599991,
								25.826157436000074
							],
							[
								-80.17039110299993,
								25.826217617000054
							],
							[
								-80.17034602599995,
								25.826274353000088
							],
							[
								-80.17029652699995,
								25.826327276000086
							],
							[
								-80.17024292899993,
								25.82637604100006
							],
							[
								-80.17014378399995,
								25.826459163000038
							],
							[
								-80.17001566099992,
								25.82654883600009
							],
							[
								-80.1699000019999,
								25.826604998000054
							],
							[
								-80.16984500199993,
								25.82662699900004
							],
							[
								-80.16978491899994,
								25.826648591000037
							],
							[
								-80.16972345499994,
								25.826665867000088
							],
							[
								-80.16966092099995,
								25.826678738000055
							],
							[
								-80.16959762999994,
								25.826687140000047
							],
							[
								-80.16953562999993,
								25.82669314000009
							],
							[
								-80.16946855899994,
								25.826697110000055
							],
							[
								-80.16940137899991,
								25.826696061000064
							],
							[
								-80.16933446399992,
								25.826689999000052
							],
							[
								-80.16926818899992,
								25.82667895800006
							],
							[
								-80.16920292399993,
								25.826662999000064
							],
							[
								-80.16913903199992,
								25.826642212000085
							],
							[
								-80.16900164999993,
								25.82659133700008
							],
							[
								-80.16893933099993,
								25.82656830700006
							],
							[
								-80.16887945499991,
								25.82653951900005
							],
							[
								-80.16882255199995,
								25.826505226000055
							],
							[
								-80.16876912599992,
								25.826465734000067
							],
							[
								-80.16871965199994,
								25.82642139300009
							],
							[
								-80.16867456699993,
								25.826372595000066
							],
							[
								-80.16864255399992,
								25.826363264000065
							],
							[
								-80.16861141399994,
								25.826354087000084
							],
							[
								-80.1684693389999,
								25.826287836000063
							],
							[
								-80.16834092699992,
								25.826197921000073
							],
							[
								-80.1682300789999,
								25.826087073000053
							],
							[
								-80.16821592399992,
								25.82606793800005
							],
							[
								-80.16818635899995,
								25.82602793300009
							],
							[
								-80.16813864199992,
								25.825959698000077
							],
							[
								-80.16809908399995,
								25.825897541000074
							],
							[
								-80.1680654079999,
								25.825832012000035
							],
							[
								-80.16803789699992,
								25.825763665000068
							],
							[
								-80.1680167849999,
								25.825693079000075
							],
							[
								-80.16794278499992,
								25.825404078000076
							],
							[
								-80.16792834099994,
								25.825337165000064
							],
							[
								-80.16791467799993,
								25.825181000000043
							],
							[
								-80.16791467799993,
								25.825120000000084
							],
							[
								-80.16792037399995,
								25.825039230000073
							],
							[
								-80.1678973999999,
								25.82497375400004
							],
							[
								-80.16786034099994,
								25.824832165000092
							],
							[
								-80.16784667799993,
								25.824676000000068
							],
							[
								-80.16784667799993,
								25.82461500000005
							],
							[
								-80.16786034099994,
								25.82445883400004
							],
							[
								-80.16790091399992,
								25.824307413000042
							],
							[
								-80.16796716399995,
								25.824165339000047
							],
							[
								-80.16805707899994,
								25.824036927000066
							],
							[
								-80.1681679269999,
								25.82392607900005
							],
							[
								-80.16820097599992,
								25.823899640000036
							],
							[
								-80.16827377899995,
								25.82383076600007
							],
							[
								-80.16832030499995,
								25.823792603000072
							],
							[
								-80.16832191499992,
								25.823773145000075
							],
							[
								-80.1683324899999,
								25.823709699000062
							],
							[
								-80.16836222899991,
								25.82350727700009
							],
							[
								-80.16837573999995,
								25.82343564200005
							],
							[
								-80.16839500799995,
								25.82336533700004
							],
							[
								-80.16841990699993,
								25.823296824000067
							],
							[
								-80.1684502729999,
								25.82323055200004
							],
							[
								-80.16848127299994,
								25.82316955300007
							],
							[
								-80.16851721199993,
								25.823105457000054
							],
							[
								-80.16855826699992,
								25.823044511000035
							],
							[
								-80.16860416199995,
								25.82298712100004
							],
							[
								-80.16865459199994,
								25.82293367300008
							],
							[
								-80.16870921999993,
								25.822884523000084
							],
							[
								-80.16877494699992,
								25.822830799000087
							],
							[
								-80.16910563499994,
								25.82257012000008
							],
							[
								-80.16912538699997,
								25.822504992000063
							],
							[
								-80.16914543899992,
								25.822446254000056
							],
							[
								-80.16916949499995,
								25.822389039000086
							],
							[
								-80.16919743999995,
								25.822333619000062
							],
							[
								-80.16922914099992,
								25.82228025900008
							],
							[
								-80.16927214099991,
								25.82221325900008
							],
							[
								-80.16931190899993,
								25.822156265000046
							],
							[
								-80.1693559599999,
								25.82210251300006
							],
							[
								-80.16940402999995,
								25.822052322000047
							],
							[
								-80.16945583199994,
								25.82200599300006
							],
							[
								-80.1695110579999,
								25.821963802000084
							],
							[
								-80.16956937599991,
								25.821926002000055
							],
							[
								-80.16961135699995,
								25.821901083000057
							],
							[
								-80.1697584129999,
								25.821831914000086
							],
							[
								-80.16990983399995,
								25.82179134100005
							]
						]
					],
					[
						[
							[
								-80.17643039199993,
								25.826525299000085
							],
							[
								-80.17650553699991,
								25.82652270200009
							],
							[
								-80.17658063699992,
								25.826526391000076
							],
							[
								-80.17665516599993,
								25.826536341000065
							],
							[
								-80.17680658699993,
								25.826576914000043
							],
							[
								-80.1768758639999,
								25.826605450000045
							],
							[
								-80.17696686399995,
								25.826647450000053
							],
							[
								-80.17702877599993,
								25.826678980000054
							],
							[
								-80.17708806899992,
								25.826715196000066
							],
							[
								-80.17714438999991,
								25.826755881000054
							],
							[
								-80.17719740099994,
								25.826800792000085
							],
							[
								-80.17724678699994,
								25.826849662000086
							],
							[
								-80.17729225399995,
								25.826902199000074
							],
							[
								-80.17741027299991,
								25.827049723000073
							],
							[
								-80.17747243999992,
								25.827119964000076
							],
							[
								-80.17748791999992,
								25.82713792700008
							],
							[
								-80.17757783499991,
								25.82726633900006
							],
							[
								-80.17764408599993,
								25.827408413000057
							],
							[
								-80.17768465899991,
								25.827559834000056
							],
							[
								-80.17769832199991,
								25.82771600000007
							],
							[
								-80.1776933299999,
								25.827810620000037
							],
							[
								-80.17766233099991,
								25.828103620000036
							],
							[
								-80.17763914099993,
								25.82823236900009
							],
							[
								-80.17761914099994,
								25.828310369000064
							],
							[
								-80.17760508999993,
								25.828355787000078
							],
							[
								-80.17764408599993,
								25.82843941400006
							],
							[
								-80.17768495199994,
								25.828592513000046
							],
							[
								-80.17770024499993,
								25.828681191000044
							],
							[
								-80.17771332199993,
								25.828834000000086
							],
							[
								-80.17769965999992,
								25.82899016600004
							],
							[
								-80.17765908699994,
								25.829141586000052
							],
							[
								-80.17759283599992,
								25.82928366100009
							],
							[
								-80.17750292099993,
								25.82941207300007
							],
							[
								-80.17744416199992,
								25.82947562000004
							],
							[
								-80.17733216199993,
								25.829585620000046
							],
							[
								-80.1772800729999,
								25.82963292100004
							],
							[
								-80.17714520399994,
								25.829726493000067
							],
							[
								-80.17694074799994,
								25.829840150000052
							],
							[
								-80.17681158599993,
								25.82989908600007
							],
							[
								-80.17669299699992,
								25.82993323900007
							],
							[
								-80.1765859969999,
								25.82995623900007
							],
							[
								-80.17651704799994,
								25.82996908000007
							],
							[
								-80.17644721599993,
								25.829975587000035
							],
							[
								-80.17637708199993,
								25.829975705000038
							],
							[
								-80.17630722799994,
								25.829969435000066
							],
							[
								-80.1762176339999,
								25.829960523000068
							],
							[
								-80.17615383399993,
								25.82995365900007
							],
							[
								-80.17606778499993,
								25.82993203300009
							],
							[
								-80.17600206499992,
								25.829914329000076
							],
							[
								-80.17593527299994,
								25.829896947000066
							],
							[
								-80.1758705979999,
								25.829876153000043
							],
							[
								-80.17580767699991,
								25.829850537000087
							],
							[
								-80.17574686999991,
								25.829820245000064
							],
							[
								-80.1756885229999,
								25.829785448000052
							],
							[
								-80.17563296899993,
								25.829746347000086
							],
							[
								-80.17558052499993,
								25.82970316300009
							],
							[
								-80.1755445249999,
								25.829671164000047
							],
							[
								-80.17548908399993,
								25.829617451000047
							],
							[
								-80.1754384539999,
								25.829559182000086
							],
							[
								-80.17539300699991,
								25.82949678500006
							],
							[
								-80.17535307799994,
								25.82943072100005
							],
							[
								-80.1751850789999,
								25.829123720000045
							],
							[
								-80.1751533499999,
								25.82905984900009
							],
							[
								-80.17512678299994,
								25.82899366500004
							],
							[
								-80.17510554299992,
								25.828925584000046
							],
							[
								-80.17508976399995,
								25.82885603300008
							],
							[
								-80.17507954699994,
								25.828785451000044
							],
							[
								-80.17502354599992,
								25.82824945200008
							],
							[
								-80.1750189569999,
								25.828178405000074
							],
							[
								-80.17502000199994,
								25.82810721700008
							],
							[
								-80.17502667399992,
								25.828036335000036
							],
							[
								-80.17503893299994,
								25.827966203000074
							],
							[
								-80.17505670199995,
								25.82789726100009
							],
							[
								-80.17507986799991,
								25.827829940000072
							],
							[
								-80.17510828699994,
								25.82776466300004
							],
							[
								-80.17538328699993,
								25.827195662000065
							],
							[
								-80.1754141639999,
								25.827137339000046
							],
							[
								-80.17550407899995,
								25.827008927000065
							],
							[
								-80.17561492699991,
								25.826898079000046
							],
							[
								-80.17574333899995,
								25.826808164000056
							],
							[
								-80.17576616999992,
								25.826795421000043
							],
							[
								-80.17607217099993,
								25.82663042200005
							],
							[
								-80.1761397869999,
								25.826597533000044
							],
							[
								-80.17620991399991,
								25.826570408000066
							],
							[
								-80.17628206199993,
								25.826549236000062
							],
							[
								-80.17635572599994,
								25.826534165000055
							],
							[
								-80.17643039199993,
								25.826525299000085
							]
						]
					],
					[
						[
							[
								-80.1749974139999,
								25.83306891400008
							],
							[
								-80.17502932999992,
								25.833057971000073
							],
							[
								-80.17508832999994,
								25.833038971000065
							],
							[
								-80.1751555749999,
								25.83302016400006
							],
							[
								-80.17522407599995,
								25.833006630000057
							],
							[
								-80.17529341999995,
								25.832998452000083
							],
							[
								-80.17536319099992,
								25.832995679000078
							],
							[
								-80.17543296499991,
								25.83299832600005
							],
							[
								-80.17549796599991,
								25.83300332600004
							],
							[
								-80.1755851659999,
								25.833014340000094
							],
							[
								-80.17574063799992,
								25.83305829300008
							],
							[
								-80.17582841299992,
								25.833020914000087
							],
							[
								-80.1758553169999,
								25.83301296600007
							],
							[
								-80.17593193399995,
								25.83299026800006
							],
							[
								-80.17597913599991,
								25.83297756400009
							],
							[
								-80.17603813099993,
								25.832961699000066
							],
							[
								-80.17609816499993,
								25.832950390000065
							],
							[
								-80.17615888799992,
								25.83294370400006
							],
							[
								-80.1762199449999,
								25.832941679000044
							],
							[
								-80.17628097699992,
								25.832944327000064
							],
							[
								-80.17634597799992,
								25.83294932700005
							],
							[
								-80.17648923899992,
								25.832972081000037
							],
							[
								-80.17676923899995,
								25.833040081000036
							],
							[
								-80.1768776099999,
								25.833073769000066
							],
							[
								-80.17695360999994,
								25.83310276800006
							],
							[
								-80.17701771399993,
								25.83313011900009
							],
							[
								-80.17707950699992,
								25.833162352000045
							],
							[
								-80.17713861899995,
								25.833199273000048
							],
							[
								-80.17719469399992,
								25.833240660000058
							],
							[
								-80.17724739499994,
								25.833286266000073
							],
							[
								-80.17729640699991,
								25.833335816000044
							],
							[
								-80.17735040699995,
								25.833394816000066
							],
							[
								-80.17739570799995,
								25.83344836300006
							],
							[
								-80.17743669799995,
								25.833505278000075
							],
							[
								-80.17747312799992,
								25.833565213000043
							],
							[
								-80.17750477699991,
								25.83362780500005
							],
							[
								-80.17765577599994,
								25.833957805000068
							],
							[
								-80.17770355199991,
								25.83408786800004
							],
							[
								-80.17772555199991,
								25.834165868000074
							],
							[
								-80.17774565899992,
								25.834253834000037
							],
							[
								-80.17775721999993,
								25.83434854400008
							],
							[
								-80.17776221999992,
								25.834421545000055
							],
							[
								-80.1777643129999,
								25.834487117000037
							],
							[
								-80.1777616199999,
								25.83455266800007
							],
							[
								-80.17775415499995,
								25.83461784800005
							],
							[
								-80.1777419579999,
								25.834682310000062
							],
							[
								-80.17767695799995,
								25.83496831000008
							],
							[
								-80.1776640189999,
								25.835018502000082
							],
							[
								-80.17755601899995,
								25.835392502000047
							],
							[
								-80.17753509799991,
								25.835455997000054
							],
							[
								-80.17750951699992,
								25.835517761000066
							],
							[
								-80.17747941899995,
								25.83557745600007
							],
							[
								-80.1774449699999,
								25.835634749000064
							],
							[
								-80.17741296899993,
								25.835683748000065
							],
							[
								-80.17737082299993,
								25.83574291800005
							],
							[
								-80.17732403799994,
								25.835798492000038
							],
							[
								-80.17727292099994,
								25.835850109000035
							],
							[
								-80.17721780399995,
								25.83589743200008
							],
							[
								-80.17717480399995,
								25.83593143300004
							],
							[
								-80.17706809899994,
								25.836003860000062
							],
							[
								-80.1770246129999,
								25.83608055500008
							],
							[
								-80.17693292099995,
								25.83621207300007
							],
							[
								-80.1768988789999,
								25.836250372000055
							],
							[
								-80.17686687799994,
								25.83628437200008
							],
							[
								-80.17679918999994,
								25.836348309000076
							],
							[
								-80.17676508599993,
								25.836475586000066
							],
							[
								-80.17671182599992,
								25.836594369000068
							],
							[
								-80.17669082599991,
								25.836633369000083
							],
							[
								-80.17667783499991,
								25.836656661000063
							],
							[
								-80.17658791999992,
								25.836785073000048
							],
							[
								-80.17647707299996,
								25.836895920000075
							],
							[
								-80.1763486609999,
								25.836985836000053
							],
							[
								-80.17632449899992,
								25.83699929400007
							],
							[
								-80.17627049899994,
								25.83702829500004
							],
							[
								-80.17620727699996,
								25.837059126000042
							],
							[
								-80.17614183799992,
								25.83708492100004
							],
							[
								-80.17607458399993,
								25.837105524000037
							],
							[
								-80.17600592499991,
								25.837120807000076
							],
							[
								-80.17593628199995,
								25.83713067800005
							],
							[
								-80.1758872819999,
								25.83713567700005
							],
							[
								-80.17579599999995,
								25.83714032200004
							],
							[
								-80.17570283799995,
								25.837135483000054
							],
							[
								-80.1756548379999,
								25.837130484000056
							],
							[
								-80.17559183399993,
								25.837121660000037
							],
							[
								-80.17543845299991,
								25.837080368000045
							],
							[
								-80.17537149399995,
								25.837055649000035
							],
							[
								-80.1752980359999,
								25.83702476200006
							],
							[
								-80.1752276009999,
								25.836987494000084
							],
							[
								-80.17516074199995,
								25.836944138000035
							],
							[
								-80.1750979819999,
								25.836895033000076
							],
							[
								-80.17503981699991,
								25.836840566000035
							],
							[
								-80.17499681599992,
								25.836796565000043
							],
							[
								-80.1749439589999,
								25.836737479000078
							],
							[
								-80.17489651099993,
								25.83667396700008
							],
							[
								-80.17485483999991,
								25.836606524000047
							],
							[
								-80.17481927099993,
								25.836535672000082
							],
							[
								-80.17462909499994,
								25.836111156000072
							],
							[
								-80.17458436499993,
								25.836035567000067
							],
							[
								-80.17444911699995,
								25.835951959000056
							],
							[
								-80.17434392699994,
								25.83587592100008
							],
							[
								-80.17424137799992,
								25.835774821000086
							],
							[
								-80.1741992279999,
								25.83572594700007
							],
							[
								-80.17415099399994,
								25.835664015000077
							],
							[
								-80.1741083469999,
								25.83559811300006
							],
							[
								-80.17407160899995,
								25.835528741000076
							],
							[
								-80.17404106299995,
								25.83545643000008
							],
							[
								-80.17401694099993,
								25.83538173000005
							],
							[
								-80.17399942599991,
								25.83530521000006
							],
							[
								-80.17398865199993,
								25.83522745500005
							],
							[
								-80.17398365299994,
								25.835174454000082
							],
							[
								-80.17398083899991,
								25.835044330000073
							],
							[
								-80.17400183899991,
								25.834631331000082
							],
							[
								-80.17400867999993,
								25.834557301000075
							],
							[
								-80.17402161199993,
								25.834484089000057
							],
							[
								-80.17404054799994,
								25.834412196000077
							],
							[
								-80.1740653569999,
								25.83434211200006
							],
							[
								-80.17426035699992,
								25.833856112000035
							],
							[
								-80.17431616499994,
								25.833741339000085
							],
							[
								-80.17437834599993,
								25.833647689000088
							],
							[
								-80.17458834599995,
								25.833370689000052
							],
							[
								-80.17461607899992,
								25.833335927000064
							],
							[
								-80.17472692699994,
								25.83322508000009
							],
							[
								-80.17485533899992,
								25.833135164000055
							],
							[
								-80.1749974139999,
								25.83306891400008
							]
						]
					],
					[
						[
							[
								-80.16547216399994,
								25.850272661000076
							],
							[
								-80.16545258699995,
								25.85023067600008
							],
							[
								-80.16529523299994,
								25.850236670000072
							],
							[
								-80.16521649799996,
								25.85023417900004
							],
							[
								-80.16513867499992,
								25.850248686000043
							],
							[
								-80.16505986899995,
								25.85025619700008
							],
							[
								-80.16498070699993,
								25.850256651000052
							],
							[
								-80.16490181899991,
								25.850250044000063
							],
							[
								-80.16465181899991,
								25.850218044000087
							],
							[
								-80.16460983399992,
								25.850211660000074
							],
							[
								-80.16445841399991,
								25.850171086000046
							],
							[
								-80.16431633899992,
								25.850104836000074
							],
							[
								-80.16418792699994,
								25.85001492100008
							],
							[
								-80.16407707899992,
								25.84990407300006
							],
							[
								-80.16406209599995,
								25.849885732000075
							],
							[
								-80.16399609599995,
								25.849802732000057
							],
							[
								-80.16392116399993,
								25.849692661000063
							],
							[
								-80.16387114399993,
								25.849591969000073
							],
							[
								-80.16386314499994,
								25.849572969000064
							],
							[
								-80.16385246599992,
								25.84954574200009
							],
							[
								-80.16180649999991,
								25.849575275000063
							],
							[
								-80.1616438339999,
								25.849561659000074
							],
							[
								-80.16157040299993,
								25.84954123400007
							],
							[
								-80.16154299999994,
								25.848677000000066
							],
							[
								-80.16168488699992,
								25.84850509900008
							],
							[
								-80.16175099999992,
								25.848425000000077
							],
							[
								-80.1617096889999,
								25.848394152000083
							],
							[
								-80.16152199999993,
								25.848254000000054
							],
							[
								-80.16149472899991,
								25.84728358700005
							],
							[
								-80.16151365399992,
								25.847276111000042
							],
							[
								-80.16158594599995,
								25.847254502000055
							],
							[
								-80.16165982399991,
								25.847239164000086
							],
							[
								-80.16173474399994,
								25.847230210000077
							],
							[
								-80.16181015599994,
								25.84722770700006
							],
							[
								-80.16389195399995,
								25.847251550000067
							],
							[
								-80.16509375299995,
								25.847221191000074
							],
							[
								-80.16513191399991,
								25.84708241400006
							],
							[
								-80.1651715939999,
								25.846989873000044
							],
							[
								-80.16540459399994,
								25.846520873000088
							],
							[
								-80.16543116399993,
								25.84647133900006
							],
							[
								-80.16552107899992,
								25.84634292700008
							],
							[
								-80.16563192699994,
								25.84623207900006
							],
							[
								-80.16576033899992,
								25.84614216400007
							],
							[
								-80.1659024139999,
								25.84607591400004
							],
							[
								-80.16605383399991,
								25.84603534100006
							],
							[
								-80.16608571699993,
								25.846030307000035
							],
							[
								-80.16638671699991,
								25.845988307000084
							],
							[
								-80.16650856299992,
								25.845979681000074
							],
							[
								-80.16832317199993,
								25.845974763000072
							],
							[
								-80.16870485499993,
								25.845947898000077
							],
							[
								-80.16878440699992,
								25.845945828000083
							],
							[
								-80.1688638299999,
								25.84595079800005
							],
							[
								-80.16894250199994,
								25.845962770000085
							],
							[
								-80.1690198089999,
								25.845981650000056
							],
							[
								-80.16918780799995,
								25.846030650000046
							],
							[
								-80.16924358599994,
								25.84604891300006
							],
							[
								-80.16938566099992,
								25.846115164000082
							],
							[
								-80.1695140729999,
								25.84620507900007
							],
							[
								-80.16962491999993,
								25.846315927000035
							],
							[
								-80.16971762499992,
								25.846449241000073
							],
							[
								-80.16978041399994,
								25.846561143000088
							],
							[
								-80.16980290299995,
								25.846603901000037
							],
							[
								-80.16992790299992,
								25.846857901000078
							],
							[
								-80.16996608599993,
								25.846947414000056
							],
							[
								-80.16998663399994,
								25.847024098000077
							],
							[
								-80.17006058599992,
								25.84704391300005
							],
							[
								-80.1702026609999,
								25.84711016400007
							],
							[
								-80.17033107299994,
								25.84720007900006
							],
							[
								-80.17044191999992,
								25.847310927000084
							],
							[
								-80.1705318349999,
								25.84743933900006
							],
							[
								-80.1705920679999,
								25.847565357000065
							],
							[
								-80.1706203139999,
								25.84763862500006
							],
							[
								-80.17067532299991,
								25.847784653000076
							],
							[
								-80.17071765899993,
								25.84794083500009
							],
							[
								-80.17072793999995,
								25.848019088000058
							],
							[
								-80.1707439409999,
								25.848203088000048
							],
							[
								-80.1707473219999,
								25.848281000000043
							],
							[
								-80.17073365999994,
								25.848437165000064
							],
							[
								-80.1706930869999,
								25.848588586000062
							],
							[
								-80.17062683599994,
								25.848730661000047
							],
							[
								-80.1705369259999,
								25.848859066000045
							],
							[
								-80.17046392299994,
								25.848946070000068
							],
							[
								-80.17041027499994,
								25.849004561000076
							],
							[
								-80.17035167799992,
								25.849058093000053
							],
							[
								-80.17028858799995,
								25.849106249000044
							],
							[
								-80.17022149799993,
								25.849148653000043
							],
							[
								-80.17015092799994,
								25.84918497600006
							],
							[
								-80.17007743099992,
								25.84921493300004
							],
							[
								-80.17000157799993,
								25.849238291000063
							],
							[
								-80.16992396099994,
								25.84925487000004
							],
							[
								-80.16853512499995,
								25.84947584400004
							],
							[
								-80.16850643099991,
								25.84953078600006
							],
							[
								-80.16845943099992,
								25.849644786000056
							],
							[
								-80.16840683499993,
								25.849751661000084
							],
							[
								-80.16838466899992,
								25.849788036000064
							],
							[
								-80.1680326689999,
								25.850336036000044
							],
							[
								-80.16796491999992,
								25.850428073000046
							],
							[
								-80.16785407299994,
								25.85053892100007
							],
							[
								-80.1677256609999,
								25.850628836000055
							],
							[
								-80.16758358599992,
								25.850695086000087
							],
							[
								-80.16743216499992,
								25.850735659000065
							],
							[
								-80.1672759999999,
								25.85074932200007
							],
							[
								-80.16723322299993,
								25.850748304000035
							],
							[
								-80.16674801199991,
								25.850725199000067
							],
							[
								-80.1662458209999,
								25.85072230700007
							],
							[
								-80.16609483399992,
								25.850708659000077
							],
							[
								-80.16594341399991,
								25.85066808600004
							],
							[
								-80.16580133899993,
								25.850601835000077
							],
							[
								-80.16567292699995,
								25.850511920000088
							],
							[
								-80.16556207899993,
								25.85040107300006
							],
							[
								-80.16547216399994,
								25.850272661000076
							]
						]
					],
					[
						[
							[
								-80.1703937229999,
								25.855473605000043
							],
							[
								-80.17049133199993,
								25.855036839000036
							],
							[
								-80.1705071639999,
								25.854982697000082
							],
							[
								-80.17051745499992,
								25.854855936000035
							],
							[
								-80.17079739699994,
								25.85314338500007
							],
							[
								-80.17080922999992,
								25.853077694000035
							],
							[
								-80.17082681099993,
								25.85301330300007
							],
							[
								-80.17085000299994,
								25.852950714000087
							],
							[
								-80.17087862699992,
								25.852890415000047
							],
							[
								-80.17091245699993,
								25.852832876000036
							],
							[
								-80.17095123199994,
								25.85277854600008
							],
							[
								-80.17093758099992,
								25.852714054000046
							],
							[
								-80.17092905899995,
								25.85264868700006
							],
							[
								-80.17092571799992,
								25.85258285000009
							],
							[
								-80.17092757899991,
								25.852516956000045
							],
							[
								-80.17093463099991,
								25.85245141300004
							],
							[
								-80.17102400999994,
								25.851822810000044
							],
							[
								-80.17107638699991,
								25.851469206000047
							],
							[
								-80.17108034099994,
								25.851444834000063
							],
							[
								-80.17110308999993,
								25.851359932000037
							],
							[
								-80.17110400099995,
								25.851338755000086
							],
							[
								-80.17110900099993,
								25.85128075500006
							],
							[
								-80.17112801799993,
								25.85115879600005
							],
							[
								-80.1712038359999,
								25.850825013000076
							],
							[
								-80.17125534699994,
								25.850508697000066
							],
							[
								-80.17129691399992,
								25.850351413000055
							],
							[
								-80.17131826899993,
								25.85030561700006
							],
							[
								-80.17134642699996,
								25.850032703000068
							],
							[
								-80.1713542729999,
								25.849975017000077
							],
							[
								-80.17170217999991,
								25.84791812900005
							],
							[
								-80.1717119619999,
								25.84782033600004
							],
							[
								-80.17173278399991,
								25.847603157000037
							],
							[
								-80.1717395579999,
								25.847549530000038
							],
							[
								-80.17189355799991,
								25.84656853000007
							],
							[
								-80.17189773099994,
								25.846544142000084
							],
							[
								-80.1720717309999,
								25.845605142000068
							],
							[
								-80.17211091299993,
								25.845461414000056
							],
							[
								-80.17214565099994,
								25.845378981000067
							],
							[
								-80.1723386509999,
								25.844977982000046
							],
							[
								-80.17238119399991,
								25.84489975400004
							],
							[
								-80.17258349299993,
								25.844568035000066
							],
							[
								-80.17258786199994,
								25.844475293000073
							],
							[
								-80.17254277599996,
								25.84431373700005
							],
							[
								-80.17252639999992,
								25.844244639000067
							],
							[
								-80.17251552999994,
								25.84417446400005
							],
							[
								-80.17251023299991,
								25.84410365000008
							],
							[
								-80.17251054299993,
								25.844032638000044
							],
							[
								-80.17251645699992,
								25.84396187300007
							],
							[
								-80.17252793999995,
								25.843891796000037
							],
							[
								-80.17254491799991,
								25.843822843000055
							],
							[
								-80.17256728599995,
								25.843755446000046
							],
							[
								-80.17328245499993,
								25.841913334000086
							],
							[
								-80.17327896699993,
								25.841887820000068
							],
							[
								-80.17327067799994,
								25.841766000000064
							],
							[
								-80.17328434099994,
								25.841609834000057
							],
							[
								-80.17332491399992,
								25.841458413000055
							],
							[
								-80.17339116399995,
								25.84131633900006
							],
							[
								-80.17348107899994,
								25.841187927000078
							],
							[
								-80.1735919269999,
								25.84107707900006
							],
							[
								-80.17372033899994,
								25.84098716400007
							],
							[
								-80.17374094099995,
								25.84097562700009
							],
							[
								-80.17397174599995,
								25.840850334000038
							],
							[
								-80.17415406799995,
								25.840693751000064
							],
							[
								-80.17419858499994,
								25.84065791200004
							],
							[
								-80.17495131099992,
								25.84009038100004
							],
							[
								-80.1761936549999,
								25.839135800000065
							],
							[
								-80.17784033999993,
								25.837822835000054
							],
							[
								-80.17787660899995,
								25.837795387000085
							],
							[
								-80.17821340599994,
								25.837553655000082
							],
							[
								-80.17831586099993,
								25.83746413500006
							],
							[
								-80.17845470599991,
								25.83736659400006
							],
							[
								-80.17844254499994,
								25.837288156000056
							],
							[
								-80.17843702699992,
								25.83720897300009
							],
							[
								-80.17843819299992,
								25.837129606000076
							],
							[
								-80.17844603299994,
								25.83705061900008
							],
							[
								-80.1784790339999,
								25.836823619000086
							],
							[
								-80.17848334099995,
								25.83679683400004
							],
							[
								-80.17852391399992,
								25.83664541400009
							],
							[
								-80.17859016499995,
								25.83650333900005
							],
							[
								-80.17868007999994,
								25.836374927000065
							],
							[
								-80.17879533299993,
								25.83626043000004
							],
							[
								-80.17884831099991,
								25.836212395000075
							],
							[
								-80.17887439799995,
								25.836146043000042
							],
							[
								-80.17900039699992,
								25.83586504400006
							],
							[
								-80.17903139299995,
								25.835802534000038
							],
							[
								-80.1795443929999,
								25.834861534000083
							],
							[
								-80.1795915209999,
								25.834784547000083
							],
							[
								-80.17958540799992,
								25.834712935000084
							],
							[
								-80.1795849909999,
								25.83464106400004
							],
							[
								-80.17959027299992,
								25.834569386000055
							],
							[
								-80.17960121999994,
								25.834498352000082
							],
							[
								-80.17961776399994,
								25.834428410000044
							],
							[
								-80.1796397999999,
								25.83435999900007
							],
							[
								-80.17977740599991,
								25.83398853300008
							],
							[
								-80.17980347999992,
								25.833886696000036
							],
							[
								-80.17981249699994,
								25.83380771700007
							],
							[
								-80.17980367799993,
								25.833688000000052
							],
							[
								-80.17981081999994,
								25.83360636100008
							],
							[
								-80.17979967799994,
								25.833479000000068
							],
							[
								-80.1798087169999,
								25.833351813000036
							],
							[
								-80.17981271699996,
								25.83332381200006
							],
							[
								-80.17982266399991,
								25.83326017400009
							],
							[
								-80.1798386289999,
								25.83319777400004
							],
							[
								-80.17986046599992,
								25.833137178000072
							],
							[
								-80.1798879779999,
								25.833078939000075
							],
							[
								-80.17988210499993,
								25.832766208000066
							],
							[
								-80.17987336999994,
								25.832593821000046
							],
							[
								-80.17981894699994,
								25.832413322000036
							],
							[
								-80.1796833649999,
								25.83219374300006
							],
							[
								-80.17925531999992,
								25.831547750000087
							],
							[
								-80.17922027399993,
								25.831490302000077
							],
							[
								-80.17918962199991,
								25.83143039400005
							],
							[
								-80.17916353599992,
								25.831368362000035
							],
							[
								-80.1791421609999,
								25.83130455400004
							],
							[
								-80.1790081609999,
								25.830848553000067
							],
							[
								-80.17898857499995,
								25.830768510000045
							],
							[
								-80.17895357499992,
								25.830590510000036
							],
							[
								-80.17893821399991,
								25.83046953300004
							],
							[
								-80.17892721299995,
								25.83028153300006
							],
							[
								-80.17892632399992,
								25.830194903000063
							],
							[
								-80.17898047799991,
								25.82876762300009
							],
							[
								-80.17881779499993,
								25.828115361000073
							],
							[
								-80.17870061299993,
								25.827854436000052
							],
							[
								-80.17866980999992,
								25.827776268000036
							],
							[
								-80.17853214899992,
								25.82737258900005
							],
							[
								-80.17803661999994,
								25.826200097000083
							],
							[
								-80.17799355099993,
								25.826072167000063
							],
							[
								-80.17720655199992,
								25.82298516700007
							],
							[
								-80.17718244799994,
								25.822845261000055
							],
							[
								-80.1771294479999,
								25.82226826200008
							],
							[
								-80.17712617299992,
								25.822156162000056
							],
							[
								-80.1771341729999,
								25.82191516200004
							],
							[
								-80.17713985799992,
								25.821839752000074
							],
							[
								-80.17715185799995,
								25.821765087000074
							],
							[
								-80.1771700889999,
								25.821691694000037
							],
							[
								-80.17719442099991,
								25.82162009100006
							],
							[
								-80.1772246829999,
								25.821550787000035
							],
							[
								-80.17744268299992,
								25.821103787000084
							],
							[
								-80.17746485099991,
								25.82106125000007
							],
							[
								-80.17747772699994,
								25.821038075000047
							],
							[
								-80.17750791399993,
								25.820925414000044
							],
							[
								-80.1775562659999,
								25.820815874000065
							],
							[
								-80.17793426499992,
								25.820093874000065
							],
							[
								-80.17801203499994,
								25.81997075000004
							],
							[
								-80.1793270359999,
								25.81822074900009
							],
							[
								-80.17935707899994,
								25.818182927000066
							],
							[
								-80.17945970999995,
								25.81807905800008
							],
							[
								-80.18188781899994,
								25.81599156900006
							],
							[
								-80.1819360419999,
								25.815950487000066
							],
							[
								-80.18198769999992,
								25.81591381700008
							],
							[
								-80.18204238899995,
								25.81588184400005
							],
							[
								-80.18209968399992,
								25.81585481700006
							],
							[
								-80.1821591399999,
								25.815832948000036
							],
							[
								-80.18222029099991,
								25.81581640500008
							],
							[
								-80.18227678599993,
								25.815759583000045
							],
							[
								-80.18352065099992,
								25.814680859000077
							],
							[
								-80.18376183899994,
								25.81440952300005
							],
							[
								-80.18385592699991,
								25.81431807900009
							],
							[
								-80.18393335199994,
								25.81425991800006
							],
							[
								-80.18441711799996,
								25.813935728000047
							],
							[
								-80.18443535099993,
								25.813466205000054
							],
							[
								-80.18445551499991,
								25.812943872000062
							],
							[
								-80.18445549699993,
								25.81294197500006
							],
							[
								-80.18408198399993,
								25.81278042100007
							],
							[
								-80.1840612179999,
								25.812771125000044
							],
							[
								-80.18276163999991,
								25.812169554000036
							],
							[
								-80.1822694889999,
								25.81209389600008
							],
							[
								-80.1817789399999,
								25.81206125600005
							],
							[
								-80.18172942899992,
								25.81205899400004
							],
							[
								-80.18162266399992,
								25.812050379000087
							],
							[
								-80.18119785999994,
								25.812034655000048
							],
							[
								-80.17981585899992,
								25.81198985000009
							],
							[
								-80.17968883399993,
								25.811976660000084
							],
							[
								-80.17964758499994,
								25.811968387000036
							],
							[
								-80.1795275849999,
								25.811941387000047
							],
							[
								-80.1794174129999,
								25.81190908600007
							],
							[
								-80.1792753389999,
								25.81184283600004
							],
							[
								-80.17914692699992,
								25.81175292100005
							],
							[
								-80.1790360789999,
								25.811642073000087
							],
							[
								-80.17894655499992,
								25.811514337000062
							],
							[
								-80.1788063599999,
								25.81127199900004
							],
							[
								-80.17873991399995,
								25.81112958600005
							],
							[
								-80.17869934099991,
								25.81097816500005
							],
							[
								-80.17868567799991,
								25.810822000000087
							],
							[
								-80.17869934099991,
								25.810665834000076
							],
							[
								-80.17873991399995,
								25.81051441300008
							],
							[
								-80.17875136399994,
								25.810485330000063
							],
							[
								-80.1787506899999,
								25.810390247000043
							],
							[
								-80.17876434099992,
								25.810230835000084
							],
							[
								-80.1788049139999,
								25.810079414000086
							],
							[
								-80.17887116399993,
								25.809937339000044
							],
							[
								-80.17896107899992,
								25.809808927000063
							],
							[
								-80.17907192699994,
								25.80969808000009
							],
							[
								-80.17920033899992,
								25.809608165000043
							],
							[
								-80.17931706199994,
								25.809551577000036
							],
							[
								-80.17958806199994,
								25.809443576000035
							],
							[
								-80.17965406099995,
								25.80942020100008
							],
							[
								-80.17972168099995,
								25.809402039000076
							],
							[
								-80.17979050999992,
								25.809389199000066
							],
							[
								-80.17986012999995,
								25.809381762000044
							],
							[
								-80.1799301179999,
								25.809379770000078
							],
							[
								-80.18107323599992,
								25.80940286300006
							],
							[
								-80.18109735699994,
								25.809403676000045
							],
							[
								-80.18262435699995,
								25.80947567600009
							],
							[
								-80.1826644539999,
								25.80947846500004
							],
							[
								-80.18384263399992,
								25.80958697300008
							],
							[
								-80.18445367299995,
								25.809650358000056
							],
							[
								-80.1850126089999,
								25.810005514000068
							],
							[
								-80.18516239699994,
								25.810484836000057
							],
							[
								-80.18525226999992,
								25.810829349000073
							],
							[
								-80.18522231299994,
								25.81094917900009
							],
							[
								-80.18523729099991,
								25.81120381900007
							],
							[
								-80.18537213499991,
								25.811210368000047
							],
							[
								-80.18627000599992,
								25.81148000400009
							],
							[
								-80.19063756299994,
								25.811370267000086
							],
							[
								-80.19064997299995,
								25.811369956000078
							],
							[
								-80.1909019169999,
								25.811370025000087
							],
							[
								-80.18774483699991,
								25.825471647000086
							],
							[
								-80.1880951569999,
								25.833704156000067
							],
							[
								-80.18844547599991,
								25.83930926800008
							],
							[
								-80.1883578959999,
								25.842724883000074
							],
							[
								-80.18870821599995,
								25.84622807800008
							],
							[
								-80.18870821599995,
								25.852095929000086
							],
							[
								-80.18858930499994,
								25.85253193400007
							],
							[
								-80.18843178299994,
								25.85241116700007
							],
							[
								-80.18841199999991,
								25.85239600000006
							],
							[
								-80.18837699999995,
								25.85238000000004
							],
							[
								-80.18821099999991,
								25.85230400000006
							],
							[
								-80.1880129079999,
								25.85212367400004
							],
							[
								-80.1879879999999,
								25.85210100000006
							],
							[
								-80.18796399999991,
								25.851947000000052
							],
							[
								-80.1878079999999,
								25.851826000000074
							],
							[
								-80.1875829999999,
								25.851650000000063
							],
							[
								-80.1873159999999,
								25.851455000000044
							],
							[
								-80.1872744499999,
								25.851456109000083
							],
							[
								-80.18525499999993,
								25.851510000000076
							],
							[
								-80.1852889999999,
								25.85272200000009
							],
							[
								-80.18529003099991,
								25.85276365800007
							],
							[
								-80.18529137999991,
								25.852818169000045
							],
							[
								-80.18529399999994,
								25.852924000000087
							],
							[
								-80.18529815099993,
								25.853008724000063
							],
							[
								-80.18530929299993,
								25.853236154000058
							],
							[
								-80.1853109999999,
								25.853271000000063
							],
							[
								-80.18532299999993,
								25.85373300000009
							],
							[
								-80.18541099999993,
								25.85399300000006
							],
							[
								-80.18546199999992,
								25.85517200000004
							],
							[
								-80.1849059999999,
								25.855187000000058
							],
							[
								-80.18443999999994,
								25.855198000000087
							],
							[
								-80.18431399999992,
								25.85520100000008
							],
							[
								-80.1808299999999,
								25.855300000000057
							],
							[
								-80.17974199999992,
								25.85533600000008
							],
							[
								-80.1790939999999,
								25.85535500000009
							],
							[
								-80.17836399999993,
								25.855459000000053
							],
							[
								-80.17772599999995,
								25.855473000000075
							],
							[
								-80.17672499999992,
								25.85542100000004
							],
							[
								-80.17594299999992,
								25.855453000000068
							],
							[
								-80.17560099999992,
								25.855461000000048
							],
							[
								-80.17176351799992,
								25.85558732900006
							],
							[
								-80.17165199999994,
								25.85559100000006
							],
							[
								-80.1712852899999,
								25.855607536000036
							],
							[
								-80.17127499999992,
								25.855608000000075
							],
							[
								-80.17036292499995,
								25.85561559400009
							],
							[
								-80.1703937229999,
								25.855473605000043
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami",
				"Name": "Upper Eastside",
				"RegionID": "269216"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.37639587099994,
					28.512780000000078,
					-81.35154499999993,
					28.522524201000067
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-81.36212741399993,
								28.513102512000046
							],
							[
								-81.36232089999993,
								28.513100472000076
							],
							[
								-81.3623169999999,
								28.513205000000085
							],
							[
								-81.36202299999991,
								28.51318800000007
							],
							[
								-81.3620236509999,
								28.513161961000037
							],
							[
								-81.3621326899999,
								28.513161858000046
							],
							[
								-81.36212741399993,
								28.513102512000046
							]
						]
					],
					[
						[
							[
								-81.3722294769999,
								28.522407419000047
							],
							[
								-81.37222966199994,
								28.520117911000057
							],
							[
								-81.36862718799995,
								28.52029230300008
							],
							[
								-81.36853505099992,
								28.52029631000005
							],
							[
								-81.36813245299993,
								28.520300315000043
							],
							[
								-81.36801327799992,
								28.520303321000085
							],
							[
								-81.36692065599993,
								28.52031433600007
							],
							[
								-81.36650904999993,
								28.52032229400004
							],
							[
								-81.36600129399994,
								28.520333364000066
							],
							[
								-81.36402135599992,
								28.520345382000077
							],
							[
								-81.36293574699994,
								28.520349388000056
							],
							[
								-81.36195829699994,
								28.52034638400005
							],
							[
								-81.35999238199992,
								28.520358401000067
							],
							[
								-81.35990612299992,
								28.520359275000093
							],
							[
								-81.35991126199991,
								28.520638829000063
							],
							[
								-81.3598575769999,
								28.520638654000038
							],
							[
								-81.35985699999992,
								28.520428000000038
							],
							[
								-81.35821399999992,
								28.52041600000007
							],
							[
								-81.35797699999995,
								28.52041900000006
							],
							[
								-81.3579739999999,
								28.52028400000006
							],
							[
								-81.3579299999999,
								28.51861800000006
							],
							[
								-81.35793703099995,
								28.518617960000086
							],
							[
								-81.35897699999992,
								28.518612000000076
							],
							[
								-81.35923699999995,
								28.518605000000036
							],
							[
								-81.35936199999992,
								28.518609000000083
							],
							[
								-81.35935999999992,
								28.51907200000005
							],
							[
								-81.35935399999994,
								28.51931600000006
							],
							[
								-81.35983299999992,
								28.51931600000006
							],
							[
								-81.35991999999993,
								28.519314000000065
							],
							[
								-81.35992099999993,
								28.51907200000005
							],
							[
								-81.35992099999993,
								28.51898600000004
							],
							[
								-81.35992099999993,
								28.518567746000087
							],
							[
								-81.35992099999993,
								28.518476000000078
							],
							[
								-81.35991912299994,
								28.51822762200004
							],
							[
								-81.35991799999994,
								28.518079000000057
							],
							[
								-81.35991599999994,
								28.517784000000066
							],
							[
								-81.3599099999999,
								28.517270000000057
							],
							[
								-81.35990899999992,
								28.51715500000006
							],
							[
								-81.35915299999994,
								28.51715500000006
							],
							[
								-81.35890399999994,
								28.517154000000062
							],
							[
								-81.35890399999994,
								28.51680646400007
							],
							[
								-81.35890399999994,
								28.51670400000006
							],
							[
								-81.3586929999999,
								28.51669600000008
							],
							[
								-81.35869099999991,
								28.51658000000009
							],
							[
								-81.35868462299993,
								28.516547476000085
							],
							[
								-81.3586709999999,
								28.516478000000063
							],
							[
								-81.35866830599991,
								28.516120602000058
							],
							[
								-81.35866799999991,
								28.516080000000045
							],
							[
								-81.35910332299994,
								28.516080000000045
							],
							[
								-81.35924099999994,
								28.516080000000045
							],
							[
								-81.35923999999994,
								28.515469000000053
							],
							[
								-81.3590769999999,
								28.515465000000066
							],
							[
								-81.35907037099992,
								28.51525540900008
							],
							[
								-81.35906399999995,
								28.515054000000077
							],
							[
								-81.35925416399994,
								28.515059094000037
							],
							[
								-81.35951199999994,
								28.51506600000005
							],
							[
								-81.3595055749999,
								28.514943920000064
							],
							[
								-81.35950530199995,
								28.514938734000054
							],
							[
								-81.3595049999999,
								28.514933000000042
							],
							[
								-81.35959507799993,
								28.514939213000048
							],
							[
								-81.35959562799991,
								28.514939250000054
							],
							[
								-81.3596034649999,
								28.514939791000074
							],
							[
								-81.35961185199994,
								28.514940369000044
							],
							[
								-81.3596147749999,
								28.514940571000068
							],
							[
								-81.35972196499995,
								28.514947963000058
							],
							[
								-81.35972578399992,
								28.514948227000048
							],
							[
								-81.35976599999994,
								28.514951000000053
							],
							[
								-81.35976599999994,
								28.51486600000004
							],
							[
								-81.35976599999994,
								28.514738000000083
							],
							[
								-81.35964199999995,
								28.514717000000076
							],
							[
								-81.35958807899993,
								28.514713790000087
							],
							[
								-81.35947399999992,
								28.514707000000044
							],
							[
								-81.3594754849999,
								28.51466636200007
							],
							[
								-81.35948499999995,
								28.514406000000065
							],
							[
								-81.35976599999994,
								28.51442300000008
							],
							[
								-81.35976599999994,
								28.513955000000067
							],
							[
								-81.35931499999992,
								28.513947000000087
							],
							[
								-81.35931499999992,
								28.513887000000068
							],
							[
								-81.35924592399994,
								28.513885859000084
							],
							[
								-81.35889099999991,
								28.513880000000086
							],
							[
								-81.35889099999991,
								28.513482000000067
							],
							[
								-81.35882509299995,
								28.513482165000084
							],
							[
								-81.35769099999993,
								28.51348500000006
							],
							[
								-81.35769099999993,
								28.513566000000086
							],
							[
								-81.35733499999992,
								28.513585000000035
							],
							[
								-81.3573529279999,
								28.513424844000042
							],
							[
								-81.3573649999999,
								28.513317000000086
							],
							[
								-81.3573054119999,
								28.513320330000056
							],
							[
								-81.35668499999991,
								28.51335500000005
							],
							[
								-81.3566862429999,
								28.513443486000085
							],
							[
								-81.35669599999994,
								28.51413800000006
							],
							[
								-81.35610099999991,
								28.514166000000046
							],
							[
								-81.35611661099995,
								28.51397866600007
							],
							[
								-81.35615999999993,
								28.51345800000007
							],
							[
								-81.35545899999994,
								28.513464000000056
							],
							[
								-81.35545899999994,
								28.513205000000085
							],
							[
								-81.35514299999994,
								28.513212000000067
							],
							[
								-81.35511099999991,
								28.51298200000008
							],
							[
								-81.35497299999992,
								28.51298200000008
							],
							[
								-81.3535839999999,
								28.512980000000088
							],
							[
								-81.35179299999993,
								28.512977000000035
							],
							[
								-81.35179299999993,
								28.514180000000067
							],
							[
								-81.35179299999993,
								28.514357506000067
							],
							[
								-81.35179299999993,
								28.514880000000062
							],
							[
								-81.35179297199994,
								28.514889380000056
							],
							[
								-81.35155099999992,
								28.51487800000007
							],
							[
								-81.35155099999992,
								28.514180000000067
							],
							[
								-81.35155099999992,
								28.51324772700008
							],
							[
								-81.35155099999992,
								28.512911000000088
							],
							[
								-81.35154499999993,
								28.512780000000078
							],
							[
								-81.3515746249999,
								28.512780000000078
							],
							[
								-81.3516909999999,
								28.512780000000078
							],
							[
								-81.3549779999999,
								28.512780000000078
							],
							[
								-81.3552932739999,
								28.512780000000078
							],
							[
								-81.35563899999995,
								28.512780000000078
							],
							[
								-81.35569664199994,
								28.51314019600005
							],
							[
								-81.35814173499995,
								28.51314019600005
							],
							[
								-81.36145301699992,
								28.513105703000065
							],
							[
								-81.36145612699994,
								28.51316338500004
							],
							[
								-81.3614869999999,
								28.51373600000005
							],
							[
								-81.36107499999991,
								28.51372800000007
							],
							[
								-81.36108699999994,
								28.513199000000043
							],
							[
								-81.36095299999994,
								28.513191000000067
							],
							[
								-81.36030999999991,
								28.513224000000037
							],
							[
								-81.36034399999994,
								28.513716000000045
							],
							[
								-81.36000599999994,
								28.513723000000084
							],
							[
								-81.36000599999994,
								28.513953000000072
							],
							[
								-81.36000599999994,
								28.514180000000067
							],
							[
								-81.36000599999994,
								28.514435000000052
							],
							[
								-81.36000599999994,
								28.514760000000084
							],
							[
								-81.36000599999994,
								28.51488100000006
							],
							[
								-81.36000599999994,
								28.514961000000085
							],
							[
								-81.36000599999994,
								28.515180000000043
							],
							[
								-81.36059999999992,
								28.515180000000043
							],
							[
								-81.3606059999999,
								28.515060000000062
							],
							[
								-81.36095799999993,
								28.515059000000065
							],
							[
								-81.3609909999999,
								28.515480000000082
							],
							[
								-81.36000599999994,
								28.515480000000082
							],
							[
								-81.36000599999994,
								28.516403000000082
							],
							[
								-81.36042499999992,
								28.51640800000007
							],
							[
								-81.36069099999992,
								28.516411000000062
							],
							[
								-81.3609909999999,
								28.516414000000054
							],
							[
								-81.36209099999991,
								28.516425000000087
							],
							[
								-81.36299099999991,
								28.51643400000006
							],
							[
								-81.3639619999999,
								28.516444000000035
							],
							[
								-81.36395599999992,
								28.516180000000077
							],
							[
								-81.36395099999993,
								28.515180000000043
							],
							[
								-81.36319399999991,
								28.515164000000084
							],
							[
								-81.36312299999992,
								28.515476000000035
							],
							[
								-81.36299099999991,
								28.515480000000082
							],
							[
								-81.3628799999999,
								28.51537200000007
							],
							[
								-81.3628804999999,
								28.51536900000008
							],
							[
								-81.3628809999999,
								28.515366000000085
							],
							[
								-81.3624759999999,
								28.51536400000009
							],
							[
								-81.3624979999999,
								28.515022000000044
							],
							[
								-81.36291799999992,
								28.515028000000086
							],
							[
								-81.3629499999999,
								28.514782000000082
							],
							[
								-81.36309099999995,
								28.514780000000087
							],
							[
								-81.36325199999993,
								28.51476400000007
							],
							[
								-81.36397699999992,
								28.514691000000084
							],
							[
								-81.36393999999991,
								28.514401000000078
							],
							[
								-81.3632429999999,
								28.51440800000006
							],
							[
								-81.3632429999999,
								28.514181000000065
							],
							[
								-81.36393999999991,
								28.51418700000005
							],
							[
								-81.36388199999993,
								28.513194000000055
							],
							[
								-81.36341499999992,
								28.513195000000053
							],
							[
								-81.36344899999995,
								28.51331500000009
							],
							[
								-81.36314699999991,
								28.51331500000009
							],
							[
								-81.3631289999999,
								28.513182000000086
							],
							[
								-81.3629949999999,
								28.513195000000053
							],
							[
								-81.36251099999993,
								28.513185000000078
							],
							[
								-81.3625146469999,
								28.513098572000047
							],
							[
								-81.36251512299992,
								28.51308728700008
							],
							[
								-81.36261223999992,
								28.513085455000066
							],
							[
								-81.36646234799991,
								28.513048961000038
							],
							[
								-81.36671999999993,
								28.512960000000078
							],
							[
								-81.36672558499993,
								28.513124206000043
							],
							[
								-81.3667299999999,
								28.513254000000074
							],
							[
								-81.36683399999993,
								28.513254000000074
							],
							[
								-81.36683299999993,
								28.514777000000038
							],
							[
								-81.36684499999991,
								28.515116000000035
							],
							[
								-81.36687999999992,
								28.515524000000084
							],
							[
								-81.36699399999992,
								28.51563500000009
							],
							[
								-81.36697099999992,
								28.51563500000009
							],
							[
								-81.36678799999993,
								28.51597600000008
							],
							[
								-81.3668219999999,
								28.516297000000066
							],
							[
								-81.36694799999992,
								28.51643800000005
							],
							[
								-81.36697099999992,
								28.51644500000009
							],
							[
								-81.36745299999991,
								28.51644500000009
							],
							[
								-81.36771299999992,
								28.516446000000087
							],
							[
								-81.36789299999992,
								28.516452000000072
							],
							[
								-81.36788999999993,
								28.516293000000076
							],
							[
								-81.36788299999995,
								28.515801000000067
							],
							[
								-81.36787332499995,
								28.513111522000088
							],
							[
								-81.36787299999993,
								28.513021000000037
							],
							[
								-81.36812282199992,
								28.513048961000038
							],
							[
								-81.36909199999991,
								28.51302000000004
							],
							[
								-81.36999099999991,
								28.513024000000087
							],
							[
								-81.37002398499995,
								28.513024000000087
							],
							[
								-81.37011899999993,
								28.513024000000087
							],
							[
								-81.37033070399991,
								28.513012467000067
							],
							[
								-81.3712430519999,
								28.51297597300004
							],
							[
								-81.3762799889999,
								28.51292386700004
							],
							[
								-81.37628058999992,
								28.512961403000077
							],
							[
								-81.3763015689999,
								28.51388580300005
							],
							[
								-81.37632860999992,
								28.514760099000057
							],
							[
								-81.37635064099993,
								28.515726532000087
							],
							[
								-81.37634863799991,
								28.516563774000076
							],
							[
								-81.37633862399991,
								28.51748914700005
							],
							[
								-81.3763456339999,
								28.518415521000065
							],
							[
								-81.3763586529999,
								28.519316857000035
							],
							[
								-81.37637067199996,
								28.52024323200004
							],
							[
								-81.37638068599995,
								28.521150576000082
							],
							[
								-81.37638769699993,
								28.52195577100008
							],
							[
								-81.37639079099996,
								28.522044878000088
							],
							[
								-81.37639587099994,
								28.52251450300008
							],
							[
								-81.37223056399995,
								28.522524201000067
							],
							[
								-81.3722294769999,
								28.522407419000047
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Wadeview Park",
				"RegionID": "269223"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.33930200012762,
					28.51149700019183,
					-81.33506768276057,
					28.518347479630034
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.33615900003686,
							28.512935999974985
						],
						[
							-81.33612700036043,
							28.511517000214532
						],
						[
							-81.33659700044213,
							28.51150699975345
						],
						[
							-81.33704699960175,
							28.51149700019183
						],
						[
							-81.33705900015492,
							28.512933999882893
						],
						[
							-81.33722100042795,
							28.512933999882893
						],
						[
							-81.33921999994489,
							28.512929999698528
						],
						[
							-81.33920900033726,
							28.513063999580122
						],
						[
							-81.33923299964478,
							28.514264000037343
						],
						[
							-81.33923499973704,
							28.515059999857982
						],
						[
							-81.33921899989879,
							28.51589399963158
						],
						[
							-81.33929299971263,
							28.516814999818536
						],
						[
							-81.33930200012762,
							28.517317999622747
						],
						[
							-81.33930200012762,
							28.517670999707107
						],
						[
							-81.33930000003535,
							28.51807000011316
						],
						[
							-81.33929899998925,
							28.518310000384545
						],
						[
							-81.33885987273355,
							28.51831393311975
						],
						[
							-81.33511443390246,
							28.518347479630034
						],
						[
							-81.33506791736981,
							28.51336102496201
						],
						[
							-81.33507029068076,
							28.51332683723505
						],
						[
							-81.33506768276057,
							28.512953904659028
						],
						[
							-81.33579100016041,
							28.5129450003898
						],
						[
							-81.33610200010727,
							28.512935999974985
						],
						[
							-81.33615900003686,
							28.512935999974985
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Wedgewood Groves",
				"RegionID": "269225"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.41036699975096,
					28.5400644968511,
					-81.40549486510066,
					28.544486324773672
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.40549887068097,
							28.542339000074467
						],
						[
							-81.40549586604604,
							28.54194441533954
						],
						[
							-81.40549486510066,
							28.54188833091976
						],
						[
							-81.40549874117862,
							28.5400644968511
						],
						[
							-81.40957593091306,
							28.540096672794697
						],
						[
							-81.40957997516422,
							28.54032699995826
						],
						[
							-81.4095529999999,
							28.54032699995826
						],
						[
							-81.40958735230276,
							28.54071926444236
						],
						[
							-81.40962699981382,
							28.54117200023903
						],
						[
							-81.40962999995209,
							28.54130299998244
						],
						[
							-81.40995100035995,
							28.541307000166803
						],
						[
							-81.40995100035995,
							28.541656000066716
						],
						[
							-81.41036699975096,
							28.541656000066716
						],
						[
							-81.41036699975096,
							28.541996999597906
						],
						[
							-81.41019599996241,
							28.541996999597906
						],
						[
							-81.40962999455606,
							28.541997817980956
						],
						[
							-81.40950400043913,
							28.541997999643996
						],
						[
							-81.40950599963203,
							28.542082999964823
						],
						[
							-81.4096346458497,
							28.5420822607222
						],
						[
							-81.40975129691007,
							28.544486324773672
						],
						[
							-81.40958697188955,
							28.544456147123604
						],
						[
							-81.40772617388684,
							28.54411563592428
						],
						[
							-81.40555394875935,
							28.544043585840694
						],
						[
							-81.40549887068097,
							28.542339000074467
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Westfield",
				"RegionID": "269230"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.73763125799991,
					28.246125017000058,
					-82.72603322699992,
					28.269551000000035
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-82.7279860829999,
								28.253467588000035
							],
							[
								-82.72797755499994,
								28.24923738600006
							],
							[
								-82.72844415899993,
								28.249223076000078
							],
							[
								-82.72844415899993,
								28.24972276200009
							],
							[
								-82.73173495399993,
								28.24972276200009
							],
							[
								-82.73174922999993,
								28.248851880000075
							],
							[
								-82.73214897999992,
								28.248851880000075
							],
							[
								-82.73216325699991,
								28.24826653200006
							],
							[
								-82.73469024399992,
								28.24827367100005
							],
							[
								-82.73465455199995,
								28.247795399000044
							],
							[
								-82.7340834819999,
								28.247138668000048
							],
							[
								-82.73404778999992,
								28.246125017000058
							],
							[
								-82.73729575399994,
								28.246132156000048
							],
							[
								-82.73733144599993,
								28.24699590000006
							],
							[
								-82.73706732599993,
								28.24754555600009
							],
							[
								-82.73680320599993,
								28.247859644000073
							],
							[
								-82.73668899099994,
								28.24811662600007
							],
							[
								-82.7365105319999,
								28.248516376000055
							],
							[
								-82.73642487099994,
								28.248794773000043
							],
							[
								-82.7365105319999,
								28.249372982000068
							],
							[
								-82.73671040699992,
								28.24988694500007
							],
							[
								-82.73698166499992,
								28.250243864000083
							],
							[
								-82.73704591099994,
								28.250615060000086
							],
							[
								-82.7372814769999,
								28.250907734000066
							],
							[
								-82.73756701299993,
								28.25115043900007
							],
							[
								-82.73760984299992,
								28.251336037000044
							],
							[
								-82.73763125799991,
								28.252156951000075
							],
							[
								-82.73749562899991,
								28.25279226700008
							],
							[
								-82.73691028099995,
								28.25279226700008
							],
							[
								-82.73691028099995,
								28.253213432000056
							],
							[
								-82.73440470899993,
								28.253213432000056
							],
							[
								-82.7343547399999,
								28.24935870500008
							],
							[
								-82.73187058299993,
								28.24935156600009
							],
							[
								-82.73184916799994,
								28.24974417800007
							],
							[
								-82.73172067699994,
								28.249836977000086
							],
							[
								-82.73112819099993,
								28.249836977000086
							],
							[
								-82.73112819099993,
								28.250236726000082
							],
							[
								-82.73172781499994,
								28.250236726000082
							],
							[
								-82.73172781499994,
								28.25158588000005
							],
							[
								-82.72975762199991,
								28.25158588000005
							],
							[
								-82.72975762199991,
								28.253441860000066
							],
							[
								-82.7279860829999,
								28.253467588000035
							]
						]
					],
					[
						[
							[
								-82.7279860829999,
								28.25601290700007
							],
							[
								-82.7287382799999,
								28.25601290700007
							],
							[
								-82.72873530599992,
								28.256592901000094
							],
							[
								-82.7279860829999,
								28.256595875000073
							],
							[
								-82.7279860829999,
								28.25601290700007
							]
						]
					],
					[
						[
							[
								-82.7333669269999,
								28.257927541000072
							],
							[
								-82.73329316399992,
								28.25791326400008
							],
							[
								-82.73320988199993,
								28.25793229900006
							],
							[
								-82.73309804799993,
								28.25793229900006
							],
							[
								-82.73299810999993,
								28.257820465000066
							],
							[
								-82.73297431599991,
								28.257749081000046
							],
							[
								-82.73308377099994,
								28.25756110400005
							],
							[
								-82.73309566799992,
								28.257358849000074
							],
							[
								-82.73306473499991,
								28.25720894300008
							],
							[
								-82.7329957309999,
								28.257094729000073
							],
							[
								-82.73286486099994,
								28.25704476100009
							],
							[
								-82.7328125119999,
								28.256882957000073
							],
							[
								-82.73284582499991,
								28.256780640000045
							],
							[
								-82.73282678899994,
								28.256699739000055
							],
							[
								-82.73285058399995,
								28.25647131000005
							],
							[
								-82.73274350799994,
								28.25630712800006
							],
							[
								-82.73274112899992,
								28.25601921300006
							],
							[
								-82.73355252499995,
								28.256023972000037
							],
							[
								-82.73355252499995,
								28.255776508000054
							],
							[
								-82.7336072519999,
								28.255771749000075
							],
							[
								-82.73369053399995,
								28.25584313300004
							],
							[
								-82.73379522999994,
								28.25588834200005
							],
							[
								-82.73400700199994,
								28.255962106000084
							],
							[
								-82.73426160399993,
								28.25602635100006
							],
							[
								-82.73526335699995,
								28.256621216000042
							],
							[
								-82.73509917399991,
								28.256842506000055
							],
							[
								-82.73506110299991,
								28.256978136000043
							],
							[
								-82.73501589299991,
								28.25709235000005
							],
							[
								-82.73495164799994,
								28.257206564000057
							],
							[
								-82.73490881799995,
								28.257320778000064
							],
							[
								-82.7348945409999,
								28.257418336000057
							],
							[
								-82.73482077799991,
								28.25751351400004
							],
							[
								-82.73471846099994,
								28.257634867000036
							],
							[
								-82.7345828309999,
								28.257739563000086
							],
							[
								-82.73451144799992,
								28.257825224000044
							],
							[
								-82.73432822899991,
								28.257922782000037
							],
							[
								-82.73424732699993,
								28.25793943800005
							],
							[
								-82.73397606899994,
								28.25811075900009
							],
							[
								-82.73396179199995,
								28.258189281000057
							],
							[
								-82.73387137299994,
								28.258215455000084
							],
							[
								-82.73378809099995,
								28.25821783500004
							],
							[
								-82.73360487299993,
								28.258065549000037
							],
							[
								-82.73348114099991,
								28.25797275000008
							],
							[
								-82.7333669269999,
								28.257927541000072
							]
						]
					],
					[
						[
							[
								-82.72802177499995,
								28.26437741700005
							],
							[
								-82.72806842599994,
								28.262756300000035
							],
							[
								-82.72806936399991,
								28.262723691000076
							],
							[
								-82.72806526599993,
								28.262039232000063
							],
							[
								-82.72805746699994,
								28.26073684100004
							],
							[
								-82.72805210799993,
								28.260034791000066
							],
							[
								-82.7280499279999,
								28.259749207000088
							],
							[
								-82.72804556999995,
								28.259178294000037
							],
							[
								-82.72799797999994,
								28.25873809400008
							],
							[
								-82.72797418599993,
								28.25846445600007
							],
							[
								-82.7279860829999,
								28.25741749300005
							],
							[
								-82.7279860829999,
								28.257048568000076
							],
							[
								-82.7279860829999,
								28.257039645000077
							],
							[
								-82.72874244399992,
								28.257051542000056
							],
							[
								-82.72874244399992,
								28.257545280000045
							],
							[
								-82.73078878099994,
								28.257551229000057
							],
							[
								-82.73078878099994,
								28.257461999000043
							],
							[
								-82.7317881539999,
								28.25747389600008
							],
							[
								-82.73179112899993,
								28.258624961000066
							],
							[
								-82.73183276899994,
								28.25868147300008
							],
							[
								-82.73183574399991,
								28.259561873000052
							],
							[
								-82.73285593799994,
								28.259570796000048
							],
							[
								-82.73285891199993,
								28.260269763000053
							],
							[
								-82.73323367699993,
								28.260269763000053
							],
							[
								-82.73323962599994,
								28.260445248000053
							],
							[
								-82.73285891199993,
								28.26045119700007
							],
							[
								-82.73286188599991,
								28.26092411500008
							],
							[
								-82.7332544969999,
								28.26092411500008
							],
							[
								-82.73325747199993,
								28.261587390000045
							],
							[
								-82.7328797319999,
								28.261590364000085
							],
							[
								-82.7328797319999,
								28.262036513000055
							],
							[
								-82.7329035269999,
								28.26208112800009
							],
							[
								-82.73290055199993,
								28.262185229000067
							],
							[
								-82.73322475399993,
								28.26186697600008
							],
							[
								-82.73345080299993,
								28.26180749000008
							],
							[
								-82.73486658199994,
								28.262000821000072
							],
							[
								-82.73491119699992,
								28.262072205000038
							],
							[
								-82.73500042699993,
								28.262134666000065
							],
							[
								-82.73510452799991,
								28.26217630600007
							],
							[
								-82.7351967319999,
								28.262194152000063
							],
							[
								-82.73593436499993,
								28.26219117800008
							],
							[
								-82.73593436499993,
								28.261420827000055
							],
							[
								-82.73610687599995,
								28.26142380200008
							],
							[
								-82.73619907999995,
								28.26143569900006
							],
							[
								-82.73693373899994,
								28.261426776000064
							],
							[
								-82.73693671299992,
								28.262307176000036
							],
							[
								-82.73695455899991,
								28.262369637000067
							],
							[
								-82.73695455899991,
								28.26319650000005
							],
							[
								-82.73697835399992,
								28.263253012000064
							],
							[
								-82.73697537899994,
								28.26406500300004
							],
							[
								-82.73632400199995,
								28.264070952000054
							],
							[
								-82.7362645149999,
								28.264056080000046
							],
							[
								-82.7346464819999,
								28.26406500300004
							],
							[
								-82.73463160999995,
								28.26369618700005
							],
							[
								-82.73461078999992,
								28.263636700000063
							],
							[
								-82.73461078999992,
								28.262262562000046
							],
							[
								-82.73442935599991,
								28.26225661300009
							],
							[
								-82.73442638199992,
								28.262134666000065
							],
							[
								-82.73444422799992,
								28.26208112800009
							],
							[
								-82.73439068999994,
								28.26204543600005
							],
							[
								-82.7333883419999,
								28.261956206000036
							],
							[
								-82.73293029599995,
								28.262304202000056
							],
							[
								-82.7319279479999,
								28.26231312500005
							],
							[
								-82.7319279479999,
								28.262675993000073
							],
							[
								-82.73222240599995,
								28.262678967000056
							],
							[
								-82.73225214899992,
								28.262857427000085
							],
							[
								-82.73278455399992,
								28.26286040100007
							],
							[
								-82.73285891199993,
								28.262872298000048
							],
							[
								-82.73289162899994,
								28.26286635000008
							],
							[
								-82.73291542399994,
								28.262821735000045
							],
							[
								-82.7330552169999,
								28.262821735000045
							],
							[
								-82.7330552169999,
								28.263351165000074
							],
							[
								-82.73307008899991,
								28.263422549000044
							],
							[
								-82.73306711499993,
								28.26408284900009
							],
							[
								-82.72883464799992,
								28.264076901000067
							],
							[
								-82.72883762299995,
								28.26436838500007
							],
							[
								-82.7285431649999,
								28.26436541000004
							],
							[
								-82.72853721599995,
								28.264698535000036
							],
							[
								-82.72800604199995,
								28.26469993700005
							],
							[
								-82.72802177499995,
								28.26437741700005
							]
						]
					],
					[
						[
							[
								-82.72776003399991,
								28.26607873100005
							],
							[
								-82.7278573829999,
								28.265640658000052
							],
							[
								-82.72783499999991,
								28.266188000000056
							],
							[
								-82.72781199999991,
								28.26949600000006
							],
							[
								-82.72659599999992,
								28.269539000000066
							],
							[
								-82.72643099999993,
								28.269551000000035
							],
							[
								-82.72603322699992,
								28.26939573800007
							],
							[
								-82.72639184399992,
								28.268945982000048
							],
							[
								-82.72658220099993,
								28.26861285700005
							],
							[
								-82.72702240099994,
								28.267994197000064
							],
							[
								-82.72718896399994,
								28.267708662000075
							],
							[
								-82.7273436289999,
								28.267387435000046
							],
							[
								-82.72747449899992,
								28.267066208000074
							],
							[
								-82.72762916399995,
								28.26663790500004
							],
							[
								-82.72776003399991,
								28.26607873100005
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pasco",
				"City": "New Port Richey",
				"Name": "Northwest",
				"RegionID": "269650"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.53298932199993,
					27.908605901000044,
					-82.51829054599995,
					27.91520012500007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.52411013299991,
							27.91520012500007
						],
						[
							-82.52112003399992,
							27.915150031000053
						],
						[
							-82.51829054599995,
							27.915156077000066
						],
						[
							-82.51830908999995,
							27.912336364000055
						],
						[
							-82.5185084389999,
							27.908605901000044
						],
						[
							-82.52245595499994,
							27.908651581000072
						],
						[
							-82.52633731999994,
							27.908696495000072
						],
						[
							-82.52700511499995,
							27.908704222000043
						],
						[
							-82.53207243399994,
							27.90876238100009
						],
						[
							-82.53297994899992,
							27.90877279700004
						],
						[
							-82.53292464399993,
							27.90914778100006
						],
						[
							-82.53292826899991,
							27.909890875000087
						],
						[
							-82.53295218199992,
							27.910877475000063
						],
						[
							-82.5329548929999,
							27.911333994000078
						],
						[
							-82.5329770859999,
							27.911467154000036
						],
						[
							-82.53298932199993,
							27.91161500000004
						],
						[
							-82.53298571599993,
							27.91169545300005
						],
						[
							-82.53297071599991,
							27.911862452000037
						],
						[
							-82.53295785099994,
							27.911953330000074
						],
						[
							-82.53289693399995,
							27.91226723300008
						],
						[
							-82.53289887299991,
							27.91228930400007
						],
						[
							-82.53290232199993,
							27.912368000000072
						],
						[
							-82.53290232199993,
							27.912534371000053
						],
						[
							-82.5329097899999,
							27.912623453000037
						],
						[
							-82.53295877699993,
							27.912902504000044
						],
						[
							-82.53297232199992,
							27.913058000000035
						],
						[
							-82.53297232199992,
							27.91321400000004
						],
						[
							-82.53295751199994,
							27.91337641200005
						],
						[
							-82.5327543649999,
							27.914440658000046
						],
						[
							-82.53271905199995,
							27.91457131100009
						],
						[
							-82.53268756999995,
							27.914660448000067
						],
						[
							-82.53261983599992,
							27.914806661000057
						],
						[
							-82.5325928769999,
							27.91485041800007
						],
						[
							-82.53255087599992,
							27.91491441800008
						],
						[
							-82.53251934899993,
							27.91496417500008
						],
						[
							-82.53248332399994,
							27.915010779000056
						],
						[
							-82.53244311499992,
							27.91505382400004
						],
						[
							-82.53239906999994,
							27.915092936000068
						],
						[
							-82.53235157299991,
							27.915127776000077
						],
						[
							-82.5320668889999,
							27.91503279200009
						],
						[
							-82.53165489499992,
							27.914862311000036
						],
						[
							-82.53104400599995,
							27.914706038000077
						],
						[
							-82.53039049699993,
							27.914677624000035
						],
						[
							-82.53004953599992,
							27.914720244000083
						],
						[
							-82.52966595499993,
							27.914677624000035
						],
						[
							-82.52929657999994,
							27.914691831000084
						],
						[
							-82.52892720599993,
							27.914706038000077
						],
						[
							-82.5286856919999,
							27.914663417000043
						],
						[
							-82.52852941799995,
							27.914563970000074
						],
						[
							-82.52844417699993,
							27.914436110000054
						],
						[
							-82.52835893699995,
							27.91422300900007
						],
						[
							-82.52825948999993,
							27.914066736000052
						],
						[
							-82.52808900999992,
							27.913938875000042
						],
						[
							-82.5278048749999,
							27.913896255000054
						],
						[
							-82.52727922699995,
							27.913896255000054
						],
						[
							-82.5263842039999,
							27.913896255000054
						],
						[
							-82.52556021499993,
							27.91392466800005
						],
						[
							-82.52483567199994,
							27.913938875000042
						],
						[
							-82.5240258899999,
							27.913938875000042
						],
						[
							-82.5240258899999,
							27.914265630000045
						],
						[
							-82.5241049999999,
							27.91460600000005
						],
						[
							-82.52411013299991,
							27.91520012500007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Belmar Gardens",
				"RegionID": "272929"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.10372940799995,
					26.144449345000055,
					-80.1009112509999,
					26.152661029000058
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.10218050399993,
							26.144487481000056
						],
						[
							-80.10218813099993,
							26.144449345000055
						],
						[
							-80.10220594899995,
							26.144450394000046
						],
						[
							-80.10372617299993,
							26.144539914000063
						],
						[
							-80.10363613899995,
							26.145265003000077
						],
						[
							-80.10372940799995,
							26.145731698000077
						],
						[
							-80.10335872399992,
							26.14778173800005
						],
						[
							-80.10325657499993,
							26.148412671000074
						],
						[
							-80.10331565799993,
							26.14911271400007
						],
						[
							-80.10274287099992,
							26.15208414500006
						],
						[
							-80.1027207859999,
							26.152661029000058
						],
						[
							-80.10236812999995,
							26.152626790000056
						],
						[
							-80.10167144699994,
							26.15254897400007
						],
						[
							-80.10132639999995,
							26.15251446900004
						],
						[
							-80.1010078189999,
							26.152505095000038
						],
						[
							-80.10097994799992,
							26.15239968800006
						],
						[
							-80.1009606749999,
							26.15228405000005
						],
						[
							-80.10094917399994,
							26.152215041000094
						],
						[
							-80.10094171299994,
							26.152170278000085
						],
						[
							-80.10092999999995,
							26.15210000000008
						],
						[
							-80.10092999999995,
							26.152042905000087
						],
						[
							-80.10091998399992,
							26.15193987400005
						],
						[
							-80.1009112509999,
							26.15184623400006
						],
						[
							-80.10092162199993,
							26.15173216100004
						],
						[
							-80.10093821399994,
							26.151549645000046
						],
						[
							-80.10094990399995,
							26.151421053000035
						],
						[
							-80.10095999999993,
							26.15131000000008
						],
						[
							-80.1009761549999,
							26.151168195000082
						],
						[
							-80.10099829199993,
							26.15097388000004
						],
						[
							-80.10101425599993,
							26.15083374900007
						],
						[
							-80.10103107199991,
							26.150686144000076
						],
						[
							-80.10103768699992,
							26.150628080000047
						],
						[
							-80.10104999999993,
							26.150520000000085
						],
						[
							-80.10106368099991,
							26.150398387000052
						],
						[
							-80.10108327899991,
							26.15022418700005
						],
						[
							-80.10110131099992,
							26.150063899000088
						],
						[
							-80.10111664399994,
							26.149927606000062
						],
						[
							-80.10113098699992,
							26.149800114000076
						],
						[
							-80.10113999999993,
							26.14972000000006
						],
						[
							-80.1011655449999,
							26.14958376000004
						],
						[
							-80.10119379999992,
							26.149433068000064
						],
						[
							-80.10122869499992,
							26.14924695900004
						],
						[
							-80.10126072599991,
							26.149076129000036
						],
						[
							-80.10127608999994,
							26.14899418600004
						],
						[
							-80.10128999999995,
							26.14892000000009
						],
						[
							-80.10134646599994,
							26.148626378000074
						],
						[
							-80.10138649999995,
							26.148418201000084
						],
						[
							-80.10141972499991,
							26.148245432000067
						],
						[
							-80.10143999999991,
							26.148140000000073
						],
						[
							-80.1014679669999,
							26.14797004500008
						],
						[
							-80.10152446299992,
							26.147626724000077
						],
						[
							-80.10155301399993,
							26.147453221000035
						],
						[
							-80.10156999999992,
							26.147350000000074
						],
						[
							-80.10159507899994,
							26.14719952300004
						],
						[
							-80.10162132999994,
							26.147004693000042
						],
						[
							-80.10164506299992,
							26.14682076200006
						],
						[
							-80.10166276899992,
							26.14668354400004
						],
						[
							-80.10167999999993,
							26.146550000000047
						],
						[
							-80.10171112499995,
							26.146394375000057
						],
						[
							-80.10175179599992,
							26.14616558100005
						],
						[
							-80.10179356599991,
							26.145923318000087
						],
						[
							-80.10181999999992,
							26.145770000000084
						],
						[
							-80.10185006199993,
							26.145589630000075
						],
						[
							-80.1018809059999,
							26.14544195600007
						],
						[
							-80.1019195419999,
							26.145342605000053
						],
						[
							-80.10196669899995,
							26.14521811700007
						],
						[
							-80.10199994999994,
							26.145128596000063
						],
						[
							-80.10203931399991,
							26.145022615000073
						],
						[
							-80.1020761609999,
							26.144915355000084
						],
						[
							-80.10210525299993,
							26.14479898600007
						],
						[
							-80.10212029599995,
							26.144738818000064
						],
						[
							-80.10214228699994,
							26.14465085200004
						],
						[
							-80.10216580799995,
							26.14455676700004
						],
						[
							-80.10218050399993,
							26.144487481000056
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Birch Park Finger Sts.",
				"RegionID": "272962"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.59903432199991,
					30.376101938000094,
					-81.50876867799992,
					30.438131964000036
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-81.57519942599993,
								30.395720054000037
							],
							[
								-81.57146182199995,
								30.392526752000038
							],
							[
								-81.57140389999995,
								30.392472673000043
							],
							[
								-81.57064301399993,
								30.39169676700004
							],
							[
								-81.56519112799992,
								30.386105861000086
							],
							[
								-81.56514221999993,
								30.386051443000042
							],
							[
								-81.56432137999991,
								30.385059782000045
							],
							[
								-81.56290241399995,
								30.384168843000054
							],
							[
								-81.56088816399995,
								30.383343805000038
							],
							[
								-81.55722944599995,
								30.383166861000063
							],
							[
								-81.5562897239999,
								30.383320600000047
							],
							[
								-81.55615568399992,
								30.383342382000084
							],
							[
								-81.55306081599991,
								30.384036521000045
							],
							[
								-81.55299036299994,
								30.38404940000004
							],
							[
								-81.55291910799991,
								30.38405663200007
							],
							[
								-81.55284750399994,
								30.38405817100005
							],
							[
								-81.55277600399995,
								30.38405400700009
							],
							[
								-81.5527050629999,
								30.38404416600008
							],
							[
								-81.55263512899995,
								30.384028712000088
							],
							[
								-81.55250212899995,
								30.383993712000066
							],
							[
								-81.55244063399994,
								30.38397676900007
							],
							[
								-81.55238086899993,
								30.383954478000078
							],
							[
								-81.55232329899992,
								30.383927012000072
							],
							[
								-81.55226837099991,
								30.383894583000085
							],
							[
								-81.55221651199992,
								30.383857443000068
							],
							[
								-81.55208795899996,
								30.383852487000073
							],
							[
								-81.55191084099994,
								30.383876302000093
							],
							[
								-81.55179099999992,
								30.38388432200009
							],
							[
								-81.55170573499993,
								30.38388027100007
							],
							[
								-81.55149299699991,
								30.383860010000035
							],
							[
								-81.55127988899994,
								30.383858455000052
							],
							[
								-81.54988319799992,
								30.38391484300007
							],
							[
								-81.54911411199993,
								30.383932083000047
							],
							[
								-81.54829331099995,
								30.38420453100008
							],
							[
								-81.54816616599993,
								30.384236659000067
							],
							[
								-81.54809423299992,
								30.38424636800005
							],
							[
								-81.54608523299993,
								30.384435368000084
							],
							[
								-81.5460384889999,
								30.38443854000008
							],
							[
								-81.54527148799991,
								30.384470541000038
							],
							[
								-81.5452041559999,
								30.38447082700009
							],
							[
								-81.54513699099994,
								30.384466075000038
							],
							[
								-81.5450703699999,
								30.38445631100007
							],
							[
								-81.5450046659999,
								30.38444159000005
							],
							[
								-81.54494024699994,
								30.384421994000032
							],
							[
								-81.54487747499991,
								30.38439763400004
							],
							[
								-81.54465747599994,
								30.384302634000054
							],
							[
								-81.54461034399993,
								30.38428064300007
							],
							[
								-81.5442573819999,
								30.384103356000086
							],
							[
								-81.54398447699992,
								30.384032326000067
							],
							[
								-81.54391948499995,
								30.38401315600004
							],
							[
								-81.54385622299992,
								30.383988879000075
							],
							[
								-81.54379509199993,
								30.383959649000076
							],
							[
								-81.54373647699992,
								30.383925652000077
							],
							[
								-81.54368075199994,
								30.383887102000077
							],
							[
								-81.54362826699992,
								30.383844244000045
							],
							[
								-81.54357935599995,
								30.383797349000076
							],
							[
								-81.54190245699994,
								30.384031669000084
							],
							[
								-81.54177799999991,
								30.38404032200009
							],
							[
								-81.54162183499994,
								30.38402665900009
							],
							[
								-81.54147041399995,
								30.383986086000053
							],
							[
								-81.5413283389999,
								30.383919836000075
							],
							[
								-81.54119508399992,
								30.383825798000093
							],
							[
								-81.54053823999993,
								30.383258675000036
							],
							[
								-81.54048566199992,
								30.38320946500005
							],
							[
								-81.54043719099991,
								30.383156206000077
							],
							[
								-81.54039313599992,
								30.383099239000046
							],
							[
								-81.54035377999992,
								30.383038930000055
							],
							[
								-81.5403193759999,
								30.382975666000046
							],
							[
								-81.54029014399993,
								30.382909851000083
							],
							[
								-81.54026627199994,
								30.382841909000035
							],
							[
								-81.5399798229999,
								30.381908751000083
							],
							[
								-81.53980140499993,
								30.38164533900005
							],
							[
								-81.53976716499994,
								30.381590661000075
							],
							[
								-81.53970091399992,
								30.38144858600009
							],
							[
								-81.53966034099994,
								30.381297165000035
							],
							[
								-81.53964667799994,
								30.38114100000007
							],
							[
								-81.53966034099994,
								30.38098483400006
							],
							[
								-81.53970383899991,
								30.380827142000044
							],
							[
								-81.53969737099993,
								30.380749543000036
							],
							[
								-81.53963863099995,
								30.380519477000067
							],
							[
								-81.53962367199995,
								30.380450015000065
							],
							[
								-81.5396143509999,
								30.38037957500006
							],
							[
								-81.53961072699991,
								30.38030861400006
							],
							[
								-81.5396128239999,
								30.380237591000082
							],
							[
								-81.53962062799991,
								30.380166966000047
							],
							[
								-81.53963408999994,
								30.380097199000087
							],
							[
								-81.53965312099992,
								30.380028741000046
							],
							[
								-81.53950767799995,
								30.37877670900008
							],
							[
								-81.53950167799991,
								30.378673000000052
							],
							[
								-81.53951534099991,
								30.378516834000038
							],
							[
								-81.53955591399995,
								30.378365414000086
							],
							[
								-81.53962216399992,
								30.378223339000048
							],
							[
								-81.53971207899991,
								30.378094927000067
							],
							[
								-81.53982292699993,
								30.377984079000047
							],
							[
								-81.53995133899991,
								30.377894164000054
							],
							[
								-81.54009341399991,
								30.37782791400008
							],
							[
								-81.5402448339999,
								30.377787341000044
							],
							[
								-81.54036288099991,
								30.37777448600008
							],
							[
								-81.54158477199991,
								30.37772264800009
							],
							[
								-81.54189624199995,
								30.37750396900009
							],
							[
								-81.54196009499992,
								30.377463046000063
							],
							[
								-81.54202716999993,
								30.377427648000037
							],
							[
								-81.54209698799991,
								30.377398028000073
							],
							[
								-81.54216905299995,
								30.377374396000054
							],
							[
								-81.54224285399994,
								30.377356920000068
							],
							[
								-81.54231786399993,
								30.377345724000065
							],
							[
								-81.55354449799995,
								30.376151401000076
							],
							[
								-81.55368714199994,
								30.37613416900007
							],
							[
								-81.55377337699991,
								30.37612793800008
							],
							[
								-81.55485437599992,
								30.376101938000094
							],
							[
								-81.55493260699991,
								30.37610346200006
							],
							[
								-81.55501040899992,
								30.376111779000045
							],
							[
								-81.5550871929999,
								30.376126828000054
							],
							[
								-81.55516237899991,
								30.37614849400006
							],
							[
								-81.5586333789999,
								30.37731449400007
							],
							[
								-81.55865458599993,
								30.37732191400005
							],
							[
								-81.55879666099992,
								30.37738816400008
							],
							[
								-81.5589250729999,
								30.37747808000006
							],
							[
								-81.55903591999994,
								30.37758892700009
							],
							[
								-81.55912712999992,
								30.377719596000077
							],
							[
								-81.55995498099992,
								30.37917281600005
							],
							[
								-81.56087530399992,
								30.379256361000046
							],
							[
								-81.56094806499993,
								30.37926597300009
							],
							[
								-81.56101979999994,
								30.379281486000085
							],
							[
								-81.56109002999995,
								30.37930279700004
							],
							[
								-81.56115828999992,
								30.379329763000044
							],
							[
								-81.56239937599992,
								30.37987962300008
							],
							[
								-81.56395940499993,
								30.380113627000075
							],
							[
								-81.56403274199994,
								30.380127764000065
							],
							[
								-81.5641046529999,
								30.38014793700006
							],
							[
								-81.56417464099991,
								30.38017400700005
							],
							[
								-81.56567264199992,
								30.380804007000048
							],
							[
								-81.56573851199994,
								30.38083490200006
							],
							[
								-81.56580166799995,
								30.380871020000086
							],
							[
								-81.56586169899992,
								30.380912125000066
							],
							[
								-81.56591820999995,
								30.38095794800006
							],
							[
								-81.56597083299994,
								30.381008189000056
							],
							[
								-81.56601922199992,
								30.381062520000054
							],
							[
								-81.56606306099992,
								30.381120584000087
							],
							[
								-81.56610206199991,
								30.381182002000056
							],
							[
								-81.56689601699992,
								30.382551732000085
							],
							[
								-81.56797822899995,
								30.383429260000074
							],
							[
								-81.5680949209999,
								30.38354492700006
							],
							[
								-81.56818401499993,
								30.383671921000087
							],
							[
								-81.56878513999993,
								30.384708731000046
							],
							[
								-81.56953759399994,
								30.385268103000048
							],
							[
								-81.5704027189999,
								30.38544864300008
							],
							[
								-81.57047412199995,
								30.38546662300007
							],
							[
								-81.5705438139999,
								30.385490384000036
							],
							[
								-81.57061132899992,
								30.385519766000073
							],
							[
								-81.57067621399995,
								30.385554573000036
							],
							[
								-81.57073803399993,
								30.38559457200006
							],
							[
								-81.57079637499993,
								30.385639493000042
							],
							[
								-81.57184596899992,
								30.38651839600004
							],
							[
								-81.5720694659999,
								30.386530642000082
							],
							[
								-81.57354284699994,
								30.386408740000036
							],
							[
								-81.5736169999999,
								30.386405678000077
							],
							[
								-81.57377316599991,
								30.386419340000085
							],
							[
								-81.57392458699991,
								30.38645991300007
							],
							[
								-81.5740666609999,
								30.386526164000088
							],
							[
								-81.57419507299994,
								30.386616079000078
							],
							[
								-81.57422901599995,
								30.386646048000046
							],
							[
								-81.57707901499992,
								30.38929304900006
							],
							[
								-81.57712909599991,
								30.389343388000043
							],
							[
								-81.57717504899995,
								30.389397522000085
							],
							[
								-81.57721658799994,
								30.389455112000064
							],
							[
								-81.5772534539999,
								30.389515800000087
							],
							[
								-81.57728541599994,
								30.389579208000047
							],
							[
								-81.57731227699992,
								30.389644939000046
							],
							[
								-81.57789546799995,
								30.391253464000044
							],
							[
								-81.57793565999992,
								30.391403834000073
							],
							[
								-81.57794736199992,
								30.391500651000054
							],
							[
								-81.57800274899995,
								30.39233810600007
							],
							[
								-81.57877147699992,
								30.393242718000067
							],
							[
								-81.57930696199992,
								30.39328210000008
							],
							[
								-81.57939716499993,
								30.393293341000057
							],
							[
								-81.57954858599993,
								30.393333914000042
							],
							[
								-81.57969066099992,
								30.39340016400007
							],
							[
								-81.5798190729999,
								30.393490079000063
							],
							[
								-81.57992991999993,
								30.393600927000083
							],
							[
								-81.57997265299991,
								30.39365606200005
							],
							[
								-81.58084439699991,
								30.394875737000064
							],
							[
								-81.58570965799993,
								30.394960870000034
							],
							[
								-81.58718985799993,
								30.394808411000046
							],
							[
								-81.5872819999999,
								30.39480367800007
							],
							[
								-81.58736502699992,
								30.394807519000043
							],
							[
								-81.59178702699995,
								30.395217519000088
							],
							[
								-81.5918601649999,
								30.395227341000066
							],
							[
								-81.59201001799994,
								30.39526734500004
							],
							[
								-81.59314380199993,
								30.39567762900009
							],
							[
								-81.59321679699991,
								30.39570781100008
							],
							[
								-81.5932868619999,
								30.39574428100008
							],
							[
								-81.59335345699992,
								30.395786758000042
							],
							[
								-81.5934160679999,
								30.395834916000066
							],
							[
								-81.59347421099994,
								30.395888381000074
							],
							[
								-81.59592221199995,
								30.398346381000067
							],
							[
								-81.59597392099994,
								30.398402927000063
							],
							[
								-81.59604809199993,
								30.398505111000077
							],
							[
								-81.5988980919999,
								30.40307511100008
							],
							[
								-81.59891383599997,
								30.403101339000045
							],
							[
								-81.59898008599993,
								30.40324341400009
							],
							[
								-81.5990206589999,
								30.40339483500009
							],
							[
								-81.59903432199991,
								30.40355100000005
							],
							[
								-81.5990206589999,
								30.403707166000064
							],
							[
								-81.59898008599993,
								30.40385858700006
							],
							[
								-81.59891383599997,
								30.404000661000055
							],
							[
								-81.5988239209999,
								30.404129073000036
							],
							[
								-81.59871307299994,
								30.404239921000055
							],
							[
								-81.59869698699993,
								30.404253105000066
							],
							[
								-81.59689429799994,
								30.40569603600005
							],
							[
								-81.59560533899992,
								30.40704120500004
							],
							[
								-81.59554966099995,
								30.407094535000056
							],
							[
								-81.59548961999991,
								30.40714290000005
							],
							[
								-81.59542565599992,
								30.407185944000048
							],
							[
								-81.59535824199992,
								30.407223352000074
							],
							[
								-81.59528786999994,
								30.407254849000083
							],
							[
								-81.59298586999995,
								30.40816884800006
							],
							[
								-81.59296158599994,
								30.40817808600008
							],
							[
								-81.59280091399997,
								30.40822019100006
							],
							[
								-81.59096466099993,
								30.408504723000082
							],
							[
								-81.59089087299992,
								30.408513051000057
							],
							[
								-81.59081664799993,
								30.40851526200004
							],
							[
								-81.59074249499992,
								30.408511343000043
							],
							[
								-81.5906689169999,
								30.40850131900004
							],
							[
								-81.59059641699992,
								30.408485259000088
							],
							[
								-81.58917141699993,
								30.408107260000065
							],
							[
								-81.58910293499991,
								30.408086140000076
							],
							[
								-81.58749067499991,
								30.407517613000042
							],
							[
								-81.58742753399991,
								30.407492261000076
							],
							[
								-81.5873664909999,
								30.407462208000084
							],
							[
								-81.58730789599991,
								30.407427624000036
							],
							[
								-81.5872520829999,
								30.40738870900009
							],
							[
								-81.58719937299993,
								30.407345684000067
							],
							[
								-81.58220983899992,
								30.402948020000053
							],
							[
								-81.58219398899992,
								30.40293306700005
							],
							[
								-81.58209907899993,
								30.40283707300006
							],
							[
								-81.58207298299993,
								30.402801578000037
							],
							[
								-81.58200634799994,
								30.402710797000054
							],
							[
								-81.58021285199993,
								30.400352783000073
							],
							[
								-81.57892909599991,
								30.399405689000048
							],
							[
								-81.57882970999992,
								30.399320532000047
							],
							[
								-81.57519942599993,
								30.395720054000037
							]
						]
					],
					[
						[
							[
								-81.52509581499993,
								30.410122442000045
							],
							[
								-81.51481382599991,
								30.405045373000064
							],
							[
								-81.5147491969999,
								30.405010098000044
							],
							[
								-81.5146876689999,
								30.404969655000063
							],
							[
								-81.5146296559999,
								30.404924314000084
							],
							[
								-81.51457554599995,
								30.404874379000038
							],
							[
								-81.51452570299995,
								30.404820185000066
							],
							[
								-81.5144804599999,
								30.40476209500008
							],
							[
								-81.5144401199999,
								30.404700499000057
							],
							[
								-81.50893664199992,
								30.395495580000045
							],
							[
								-81.50890251499993,
								30.395431770000073
							],
							[
								-81.50887362999993,
								30.395365422000058
							],
							[
								-81.5088501759999,
								30.39529696500006
							],
							[
								-81.50883230199992,
								30.39522684400004
							],
							[
								-81.50882012699992,
								30.395155513000073
							],
							[
								-81.5088137269999,
								30.39508343300008
							],
							[
								-81.5087697269999,
								30.394173434000038
							],
							[
								-81.50876867799992,
								30.394130000000075
							],
							[
								-81.50878233999993,
								30.393973835000057
							],
							[
								-81.5088229129999,
								30.39382241400006
							],
							[
								-81.50888916399992,
								30.39368033900007
							],
							[
								-81.50897907899991,
								30.393551927000093
							],
							[
								-81.5090790079999,
								30.393450391000048
							],
							[
								-81.50912946799991,
								30.393406735000042
							],
							[
								-81.50919205199995,
								30.393357952000088
							],
							[
								-81.50925869499991,
								30.393314877000076
							],
							[
								-81.50932887499994,
								30.393277846000046
							],
							[
								-81.50940204799991,
								30.393247147000068
							],
							[
								-81.50947764199992,
								30.39322301900006
							],
							[
								-81.50955506899993,
								30.393205651000073
							],
							[
								-81.50963372599995,
								30.393195176000063
							],
							[
								-81.50971299999993,
								30.39319167800005
							],
							[
								-81.50975799999993,
								30.39319167800005
							],
							[
								-81.50991416599993,
								30.393205341000055
							],
							[
								-81.51005140299992,
								30.393240886000054
							],
							[
								-81.51026445899993,
								30.393314418000045
							],
							[
								-81.51047938599993,
								30.39338134700006
							],
							[
								-81.51055188799995,
								30.393407380000045
							],
							[
								-81.51062189499993,
								30.39343952100006
							],
							[
								-81.51068889599992,
								30.393477536000034
							],
							[
								-81.51075239699992,
								30.39352114600007
							],
							[
								-81.5108119329999,
								30.39357002900005
							],
							[
								-81.51086706799992,
								30.39362382900004
							],
							[
								-81.51260123599991,
								30.395467467000064
							],
							[
								-81.51333000099993,
								30.395682685000054
							],
							[
								-81.5143184719999,
								30.395485974000053
							],
							[
								-81.5143789789999,
								30.395476064000036
							],
							[
								-81.51444002099993,
								30.395470299000063
							],
							[
								-81.51450131399992,
								30.39546870800007
							],
							[
								-81.51456257199993,
								30.395471296000043
							],
							[
								-81.51490257299992,
								30.395497296000087
							],
							[
								-81.5149901659999,
								30.39550834100004
							],
							[
								-81.51514931299994,
								30.39555180700006
							],
							[
								-81.5154350389999,
								30.395661699000073
							],
							[
								-81.51556166099994,
								30.395722164000063
							],
							[
								-81.51569007299992,
								30.395812079000052
							],
							[
								-81.51580091999995,
								30.395922927000072
							],
							[
								-81.51589083499994,
								30.39605133900005
							],
							[
								-81.51593103199991,
								30.396129563000045
							],
							[
								-81.51604060699992,
								30.396371180000077
							],
							[
								-81.51688726899994,
								30.396627163000062
							],
							[
								-81.51693871399993,
								30.39664442700007
							],
							[
								-81.51780471299992,
								30.396964427000054
							],
							[
								-81.51794266099995,
								30.39702916400006
							],
							[
								-81.51805529599994,
								30.397106143000084
							],
							[
								-81.51878611399991,
								30.397691643000083
							],
							[
								-81.52001373999991,
								30.398068220000084
							],
							[
								-81.52005758699994,
								30.398082914000042
							],
							[
								-81.52016808699994,
								30.398131769000088
							],
							[
								-81.52230108599991,
								30.399251769000045
							],
							[
								-81.52233266099995,
								30.39926916400009
							],
							[
								-81.52246107299993,
								30.399359079000075
							],
							[
								-81.52257191999992,
								30.399469927000045
							],
							[
								-81.52266183499995,
								30.399598339000082
							],
							[
								-81.52272808599992,
								30.399740414000064
							],
							[
								-81.52274079199992,
								30.39978783400005
							],
							[
								-81.52458780299992,
								30.400704384000054
							],
							[
								-81.52469578699993,
								30.400558360000048
							],
							[
								-81.52036629399993,
								30.39783051900008
							],
							[
								-81.5188652949999,
								30.396958651000034
							],
							[
								-81.5188004229999,
								30.396917157000075
							],
							[
								-81.51873933799993,
								30.396870265000075
							],
							[
								-81.51868248999996,
								30.396818319000094
							],
							[
								-81.51863029299994,
								30.396761701000063
							],
							[
								-81.51858313199995,
								30.39670082400005
							],
							[
								-81.51834558599995,
								30.396365466000077
							],
							[
								-81.51800818999993,
								30.39615143700007
							],
							[
								-81.51734933599994,
								30.395946877000085
							],
							[
								-81.5173084139999,
								30.39593308600007
							],
							[
								-81.51716182099996,
								30.39586419200009
							],
							[
								-81.51485030299995,
								30.394493549000057
							],
							[
								-81.5147309269999,
								30.394408921000036
							],
							[
								-81.51462007899994,
								30.394298073000076
							],
							[
								-81.51453016399995,
								30.39416966100004
							],
							[
								-81.51446391299993,
								30.394027587000043
							],
							[
								-81.51442333999995,
								30.393876166000037
							],
							[
								-81.51440967799994,
								30.39372099900004
							],
							[
								-81.51440867799994,
								30.392819499000044
							],
							[
								-81.5144223399999,
								30.39266283500007
							],
							[
								-81.51446291299993,
								30.392511414000072
							],
							[
								-81.5145291639999,
								30.392369339000084
							],
							[
								-81.51461907899994,
								30.39224092700005
							],
							[
								-81.5147299269999,
								30.392130080000072
							],
							[
								-81.51485833899994,
								30.392040164000033
							],
							[
								-81.51500041299994,
								30.391973914000065
							],
							[
								-81.51515183399994,
								30.39193334100008
							],
							[
								-81.51519343199993,
								30.391927006000063
							],
							[
								-81.51835186999995,
								30.39152134200009
							],
							[
								-81.5279483089999,
								30.390232679000068
							],
							[
								-81.52801718699993,
								30.390226115000075
							],
							[
								-81.52808636599991,
								30.390224866000043
							],
							[
								-81.5281554359999,
								30.390228939000053
							],
							[
								-81.52822398899991,
								30.39023831000009
							],
							[
								-81.52829161799993,
								30.39025292300005
							],
							[
								-81.52844993499991,
								30.39029356600008
							],
							[
								-81.52910254199992,
								30.390195636000044
							],
							[
								-81.52923599999991,
								30.39018567800008
							],
							[
								-81.52935673999991,
								30.39018567800008
							],
							[
								-81.52975851499993,
								30.39016398600006
							],
							[
								-81.52983186699993,
								30.39016302200008
							],
							[
								-81.52990505299994,
								30.39016803900006
							],
							[
								-81.52997758599992,
								30.39017900500005
							],
							[
								-81.53004898499995,
								30.39019584600004
							],
							[
								-81.53011877299991,
								30.390218450000074
							],
							[
								-81.53018648699992,
								30.39024666600005
							],
							[
								-81.53040348799993,
								30.390347666000082
							],
							[
								-81.53042984599995,
								30.390360461000057
							],
							[
								-81.53069284599991,
								30.390493461000062
							],
							[
								-81.53075241199993,
								30.39052429200007
							],
							[
								-81.53080856199995,
								30.390560979000043
							],
							[
								-81.5308607209999,
								30.390603146000046
							],
							[
								-81.53090835699993,
								30.390650363000077
							],
							[
								-81.53098084899995,
								30.390679144000046
							],
							[
								-81.53109866099993,
								30.39073616500008
							],
							[
								-81.53116707399994,
								30.390784068000077
							],
							[
								-81.53125833899992,
								30.390720164000076
							],
							[
								-81.53136580199993,
								30.390667327000074
							],
							[
								-81.53394482199991,
								30.389610478000062
							],
							[
								-81.53405446799991,
								30.389562756000092
							],
							[
								-81.53408841399994,
								30.389547914000048
							],
							[
								-81.53419732599991,
								30.389517480000055
							],
							[
								-81.53423971699993,
								30.389506821000058
							],
							[
								-81.53807240999993,
								30.388636356000063
							],
							[
								-81.54525189299994,
								30.38713472500007
							],
							[
								-81.54527983399993,
								30.387129341000048
							],
							[
								-81.54542338599992,
								30.38711576600008
							],
							[
								-81.54756328499991,
								30.38708575000004
							],
							[
								-81.54785618199992,
								30.38703558500004
							],
							[
								-81.54788634499994,
								30.38703094500005
							],
							[
								-81.5492577999999,
								30.38684370100009
							],
							[
								-81.55113526399994,
								30.386563528000067
							],
							[
								-81.55121513099994,
								30.386555233000077
							],
							[
								-81.55129541899994,
								30.386554096000054
							],
							[
								-81.5513754879999,
								30.386560125000077
							],
							[
								-81.55145469999991,
								30.38657327100009
							],
							[
								-81.55153242499995,
								30.38659343100005
							],
							[
								-81.55160804099995,
								30.386620442000037
							],
							[
								-81.55229604099992,
								30.386901442000067
							],
							[
								-81.55240566099991,
								30.386955164000085
							],
							[
								-81.55253407299995,
								30.387045079000075
							],
							[
								-81.55264492099991,
								30.387155927000038
							],
							[
								-81.5527348359999,
								30.38728433900007
							],
							[
								-81.55280108599993,
								30.387426413000068
							],
							[
								-81.55283573199995,
								30.387547313000084
							],
							[
								-81.55290873199993,
								30.387891314000058
							],
							[
								-81.55292101999993,
								30.387963629000073
							],
							[
								-81.55292737299993,
								30.388036706000037
							],
							[
								-81.55292774999992,
								30.388110057000063
							],
							[
								-81.55292214799994,
								30.388183194000078
							],
							[
								-81.55291060499991,
								30.38825563200004
							],
							[
								-81.5528931959999,
								30.38832688900004
							],
							[
								-81.55285719599993,
								30.388451888000077
							],
							[
								-81.55281654899994,
								30.388564313000074
							],
							[
								-81.54986654899994,
								30.395288313000037
							],
							[
								-81.5498529489999,
								30.39531784900004
							],
							[
								-81.54718294899993,
								30.40085084800006
							],
							[
								-81.54714546999992,
								30.400920511000038
							],
							[
								-81.5469295769999,
								30.40128264300006
							],
							[
								-81.5459421079999,
								30.40295739100009
							],
							[
								-81.54631835899994,
								30.40305984600008
							],
							[
								-81.54639147699993,
								30.403057534000087
							],
							[
								-81.54646451899993,
								30.403061590000053
							],
							[
								-81.54653693099993,
								30.403071985000054
							],
							[
								-81.54660816499995,
								30.40308863900009
							],
							[
								-81.5466776799999,
								30.40311142600007
							],
							[
								-81.54695377299993,
								30.403214939000065
							],
							[
								-81.54708766099992,
								30.40327816400009
							],
							[
								-81.5472160729999,
								30.403368080000067
							],
							[
								-81.54732691999993,
								30.403478927000037
							],
							[
								-81.54741683499992,
								30.403607339000075
							],
							[
								-81.54748308599994,
								30.40374941400006
							],
							[
								-81.54752365899992,
								30.40390083500006
							],
							[
								-81.54753732199993,
								30.40405700000008
							],
							[
								-81.54752365899992,
								30.40421316600009
							],
							[
								-81.54749221899993,
								30.404338230000064
							],
							[
								-81.5468512189999,
								30.40628523000004
							],
							[
								-81.54684208599991,
								30.406311586000072
							],
							[
								-81.54677583499995,
								30.40645366100006
							],
							[
								-81.5466859199999,
								30.406582073000042
							],
							[
								-81.54657507299994,
								30.40669292100006
							],
							[
								-81.54644666099995,
								30.406782836000048
							],
							[
								-81.5463045859999,
								30.40684908600008
							],
							[
								-81.54615316499991,
								30.406889659000058
							],
							[
								-81.54599699999994,
								30.406903322000066
							],
							[
								-81.54584083399993,
								30.406889659000058
							],
							[
								-81.54574783699992,
								30.40686811700004
							],
							[
								-81.54542183799992,
								30.40677411700005
							],
							[
								-81.54536341399995,
								30.40675508600009
							],
							[
								-81.54522133899991,
								30.406688836000058
							],
							[
								-81.54509292699993,
								30.40659892100007
							],
							[
								-81.54498207899991,
								30.40648807300005
							],
							[
								-81.54489216399992,
								30.40635966100007
							],
							[
								-81.54482591399994,
								30.406217586000082
							],
							[
								-81.54478534099991,
								30.406066166000073
							],
							[
								-81.54477167799992,
								30.405910000000066
							],
							[
								-81.54478534099991,
								30.405753835000038
							],
							[
								-81.5448180219999,
								30.40562502800009
							],
							[
								-81.54509439499992,
								30.404797791000078
							],
							[
								-81.54501613699995,
								30.404779209000083
							],
							[
								-81.54476937699991,
								30.40535846100005
							],
							[
								-81.5447217169999,
								30.40545413200005
							],
							[
								-81.54446656599993,
								30.405898077000078
							],
							[
								-81.5443668879999,
								30.406108700000065
							],
							[
								-81.54432267199991,
								30.406190824000074
							],
							[
								-81.54355867099991,
								30.407448824000088
							],
							[
								-81.54351854499993,
								30.40750925900005
							],
							[
								-81.54074235799995,
								30.41134525500007
							],
							[
								-81.54065984699992,
								30.411457330000076
							],
							[
								-81.53950252399994,
								30.413037409000086
							],
							[
								-81.53945447899991,
								30.413097444000076
							],
							[
								-81.53940148099991,
								30.413153154000042
							],
							[
								-81.5393439149999,
								30.413204131000047
							],
							[
								-81.53928220299991,
								30.41325000200004
							],
							[
								-81.53921679799993,
								30.413290431000068
							],
							[
								-81.5391481769999,
								30.41332512400004
							],
							[
								-81.53907684199993,
								30.41335382500006
							],
							[
								-81.53794509799991,
								30.413742564000074
							],
							[
								-81.53780743399994,
								30.413777963000086
							],
							[
								-81.53748043399992,
								30.413834963000056
							],
							[
								-81.53742997899991,
								30.41384229100004
							],
							[
								-81.53356397899995,
								30.414292291000038
							],
							[
								-81.53348799199995,
								30.414297886000043
							],
							[
								-81.53341180399993,
								30.414297030000057
							],
							[
								-81.5333359629999,
								30.414289727000043
							],
							[
								-81.53326101199991,
								30.414276031000043
							],
							[
								-81.53318748899996,
								30.414256040000055
							],
							[
								-81.53311592199992,
								30.414229897000038
							],
							[
								-81.53304682499993,
								30.41419779000006
							],
							[
								-81.52622670099993,
								30.410670072000073
							],
							[
								-81.52554706599994,
								30.410360352000055
							],
							[
								-81.52549798399991,
								30.410336156000085
							],
							[
								-81.52509581499993,
								30.410122442000045
							]
						],
						[
							[
								-81.53370367899993,
								30.40487593800009
							],
							[
								-81.53359019999994,
								30.40457974000009
							],
							[
								-81.5335784049999,
								30.40454707700008
							],
							[
								-81.53356132099992,
								30.40449076100009
							],
							[
								-81.53354795799993,
								30.40443344900007
							],
							[
								-81.53353837199995,
								30.404375385000037
							],
							[
								-81.53353260299991,
								30.404316818000044
							],
							[
								-81.53353067799992,
								30.404258000000084
							],
							[
								-81.53353067799992,
								30.404114511000046
							],
							[
								-81.5333859619999,
								30.403927641000053
							],
							[
								-81.53338351999992,
								30.403924473000075
							],
							[
								-81.53334924099994,
								30.403876637000053
							],
							[
								-81.53331816399992,
								30.403826661000043
							],
							[
								-81.53329042199994,
								30.40377476000009
							],
							[
								-81.5332661349999,
								30.403721156000074
							],
							[
								-81.53324540499995,
								30.40366607800007
							],
							[
								-81.53322832099991,
								30.40360976200009
							],
							[
								-81.53322312499995,
								30.40358942300009
							],
							[
								-81.53310417599994,
								30.403100083000083
							],
							[
								-81.53274201799991,
								30.401824233000074
							],
							[
								-81.53264909699993,
								30.401534612000038
							],
							[
								-81.5324421059999,
								30.40172780400007
							],
							[
								-81.53234951399992,
								30.401821045000077
							],
							[
								-81.53233619399992,
								30.401878640000064
							],
							[
								-81.53232867799994,
								30.401908762000062
							],
							[
								-81.5323115949999,
								30.401965078000046
							],
							[
								-81.53229086499994,
								30.402020156000052
							],
							[
								-81.53226657699992,
								30.402073760000064
							],
							[
								-81.53223883499993,
								30.40212566100007
							],
							[
								-81.5322077589999,
								30.402175637000084
							],
							[
								-81.53218327999991,
								30.40221045900006
							],
							[
								-81.53201627999994,
								30.402436459000057
							],
							[
								-81.53200647999995,
								30.402449472000058
							],
							[
								-81.53196914599994,
								30.402494964000088
							],
							[
								-81.5319289169999,
								30.402537916000085
							],
							[
								-81.53188596399993,
								30.402578146000057
							],
							[
								-81.53184047299993,
								30.402615480000065
							],
							[
								-81.53179263699991,
								30.402649759000038
							],
							[
								-81.53175760799992,
								30.40267201300009
							],
							[
								-81.53162929799993,
								30.402749432000064
							],
							[
								-81.53160922899991,
								30.40277108500004
							],
							[
								-81.53147555499993,
								30.403030694000055
							],
							[
								-81.53145483599991,
								30.40306866100008
							],
							[
								-81.53142375899996,
								30.40311863600004
							],
							[
								-81.5313894809999,
								30.40316647200007
							],
							[
								-81.5313521459999,
								30.403211964000036
							],
							[
								-81.53131191699993,
								30.403254916000037
							],
							[
								-81.53126896499992,
								30.403295146000062
							],
							[
								-81.53124837199994,
								30.40331266400005
							],
							[
								-81.5312445319999,
								30.40333614600007
							],
							[
								-81.53123904199992,
								30.40336644900009
							],
							[
								-81.53122567799994,
								30.40342376200005
							],
							[
								-81.5312085949999,
								30.40348007700004
							],
							[
								-81.53118786499994,
								30.403535155000046
							],
							[
								-81.53116357699992,
								30.403588760000048
							],
							[
								-81.53113583599992,
								30.403640661000058
							],
							[
								-81.5311047589999,
								30.40369063600008
							],
							[
								-81.53107047999993,
								30.40373847200004
							],
							[
								-81.53104344199994,
								30.403772015000072
							],
							[
								-81.53079544199994,
								30.40406501500007
							],
							[
								-81.53078514599991,
								30.404076964000073
							],
							[
								-81.53074491699994,
								30.40411991700006
							],
							[
								-81.53073680299991,
								30.40412792800004
							],
							[
								-81.53068618499992,
								30.404243859000076
							],
							[
								-81.53066857699991,
								30.40428176000006
							],
							[
								-81.53065463199994,
								30.40430886900009
							],
							[
								-81.53046863299994,
								30.40465586900007
							],
							[
								-81.53045483599993,
								30.40468066100004
							],
							[
								-81.53042375899992,
								30.40473063700006
							],
							[
								-81.53038947999994,
								30.404778473000082
							],
							[
								-81.53035214599993,
								30.40482396400006
							],
							[
								-81.53035041599993,
								30.40482593200005
							],
							[
								-81.52991511099992,
								30.40531939400006
							],
							[
								-81.52971167299995,
								30.405669669000076
							],
							[
								-81.52968175899991,
								30.405717636000077
							],
							[
								-81.52964747999995,
								30.40576547200004
							],
							[
								-81.52963952399995,
								30.40577568800006
							],
							[
								-81.52917552399992,
								30.40636268800006
							],
							[
								-81.5291461459999,
								30.406397964000064
							],
							[
								-81.52910591699992,
								30.406440917000058
							],
							[
								-81.52908169299991,
								30.40646425100005
							],
							[
								-81.52890945399992,
								30.406624065000074
							],
							[
								-81.52895582799994,
								30.406656837000067
							],
							[
								-81.5300504459999,
								30.40689817000009
							],
							[
								-81.53148939599993,
								30.40638552600007
							],
							[
								-81.53157333399993,
								30.406268081000064
							],
							[
								-81.53159151999995,
								30.40624352800006
							],
							[
								-81.5316288539999,
								30.40619803600003
							],
							[
								-81.53166908299994,
								30.406155084000087
							],
							[
								-81.53171203599993,
								30.406114854000066
							],
							[
								-81.53175752699991,
								30.406077520000057
							],
							[
								-81.53180536299993,
								30.40604324100008
							],
							[
								-81.53184833299991,
								30.40601625200009
							],
							[
								-81.53243533299992,
								30.405670251000064
							],
							[
								-81.53244233899994,
								30.405666164000085
							],
							[
								-81.53249423999995,
								30.405638422000035
							],
							[
								-81.53254784399991,
								30.40561413400007
							],
							[
								-81.53260292199991,
								30.405593405000047
							],
							[
								-81.53265923799995,
								30.40557632100007
							],
							[
								-81.53268991699991,
								30.40556867600009
							],
							[
								-81.53361791599991,
								30.40535467600006
							],
							[
								-81.53364455099995,
								30.405348958000047
							],
							[
								-81.53367623299994,
								30.405343243000065
							],
							[
								-81.5338524579999,
								30.405314705000084
							],
							[
								-81.53376868799995,
								30.405061035000074
							],
							[
								-81.53370367899993,
								30.40487593800009
							]
						]
					],
					[
						[
							[
								-81.58210424999993,
								30.438073309000064
							],
							[
								-81.55640663799994,
								30.432019217000065
							],
							[
								-81.55573524099992,
								30.429501162000065
							],
							[
								-81.5547280479999,
								30.427486774000048
							],
							[
								-81.55388886199995,
								30.42530441800005
							],
							[
								-81.55170651599991,
								30.423793607000054
							],
							[
								-81.54902060899991,
								30.42312232100005
							],
							[
								-81.54667043899991,
								30.421611536000057
							],
							[
								-81.54532765499995,
								30.419429150000045
							],
							[
								-81.54213815999992,
								30.416239586000074
							],
							[
								-81.53844510199991,
								30.417750695000052
							],
							[
								-81.53626282699992,
								30.41775056400007
							],
							[
								-81.53307337699994,
								30.417750563000084
							],
							[
								-81.53246172899992,
								30.417653712000064
							],
							[
								-81.5318820729999,
								30.416904096000057
							],
							[
								-81.5318941779999,
								30.41689851300004
							],
							[
								-81.53337494099992,
								30.416386112000055
							],
							[
								-81.53352040399994,
								30.416349072000063
							],
							[
								-81.53942297299994,
								30.415411804000083
							],
							[
								-81.53956399999993,
								30.415400678000083
							],
							[
								-81.5396580819999,
								30.415408909000067
							],
							[
								-81.53992418299993,
								30.415177982000046
							],
							[
								-81.53997922699995,
								30.41513457800005
							],
							[
								-81.54003748499991,
								30.415095596000075
							],
							[
								-81.54009860399992,
								30.415061271000067
							],
							[
								-81.54016221199993,
								30.41503181400009
							],
							[
								-81.54022792199993,
								30.41500740300006
							],
							[
								-81.54103017099993,
								30.41474448100007
							],
							[
								-81.54309425899993,
								30.41313047000006
							],
							[
								-81.54445618099994,
								30.410194556000082
							],
							[
								-81.54449242899994,
								30.410124615000086
							],
							[
								-81.54453465799992,
								30.410058115000083
							],
							[
								-81.54458254399992,
								30.409995565000084
							],
							[
								-81.54463571999992,
								30.40993744600007
							],
							[
								-81.54469377899994,
								30.409884203000043
							],
							[
								-81.54475627399995,
								30.409836246000058
							],
							[
								-81.54494627499992,
								30.409703246000046
							],
							[
								-81.54501233899992,
								30.409661165000045
							],
							[
								-81.54515696899995,
								30.409593993000048
							],
							[
								-81.54526852399994,
								30.409554143000037
							],
							[
								-81.54773302699994,
								30.40769870400004
							],
							[
								-81.54797928699992,
								30.40699399600004
							],
							[
								-81.54994088899991,
								30.40164003800004
							],
							[
								-81.55035724099992,
								30.399725787000083
							],
							[
								-81.55070925799993,
								30.39810870900004
							],
							[
								-81.55072774399991,
								30.398037808000087
							],
							[
								-81.55075194299991,
								30.397968648000077
							],
							[
								-81.55078169299992,
								30.397901689000037
							],
							[
								-81.55081679599994,
								30.397837374000066
							],
							[
								-81.5508570209999,
								30.397776131000057
							],
							[
								-81.55090209799994,
								30.39771836700004
							],
							[
								-81.55388250499993,
								30.394240382000078
							],
							[
								-81.55443149699994,
								30.39280241100005
							],
							[
								-81.55636317999995,
								30.387980552000045
							],
							[
								-81.55639520099993,
								30.387909669000067
							],
							[
								-81.5564332269999,
								30.387841818000084
							],
							[
								-81.55647697299992,
								30.38777750600008
							],
							[
								-81.5565261129999,
								30.387717214000077
							],
							[
								-81.5565802779999,
								30.387661395000062
							],
							[
								-81.5566390649999,
								30.387610464000094
							],
							[
								-81.55670203199992,
								30.38756480300009
							],
							[
								-81.5577230319999,
								30.386889803000084
							],
							[
								-81.55776933899995,
								30.386861164000038
							],
							[
								-81.55786686599993,
								30.386812484000078
							],
							[
								-81.55800786599991,
								30.386752484000056
							],
							[
								-81.55809193099992,
								30.38672156000007
							],
							[
								-81.55864593099994,
								30.386548560000055
							],
							[
								-81.55875783399995,
								30.386521341000048
							],
							[
								-81.5589139999999,
								30.38650767800004
							],
							[
								-81.55907016499992,
								30.386521341000048
							],
							[
								-81.55922158599992,
								30.386561914000083
							],
							[
								-81.55926610699993,
								30.38657947300004
							],
							[
								-81.55978684399992,
								30.386801043000045
							],
							[
								-81.56047436799992,
								30.387024844000056
							],
							[
								-81.56053865399993,
								30.387048515000064
							],
							[
								-81.56060095299995,
								30.387077010000038
							],
							[
								-81.56066090099995,
								30.38711016500008
							],
							[
								-81.56071815199994,
								30.387147786000074
							],
							[
								-81.56124742199995,
								30.387525217000075
							],
							[
								-81.56182808999995,
								30.387770617000058
							],
							[
								-81.56188843399991,
								30.387798797000073
							],
							[
								-81.56194652699992,
								30.38783136500007
							],
							[
								-81.56200204999993,
								30.387868143000052
							],
							[
								-81.56205469999992,
								30.387908929000044
							],
							[
								-81.56210418599994,
								30.38795349900005
							],
							[
								-81.56494148199994,
								30.39070589800008
							],
							[
								-81.56554748499991,
								30.39099984300009
							],
							[
								-81.5656106319999,
								30.391033643000075
							],
							[
								-81.56567088799994,
								30.391072360000063
							],
							[
								-81.5657278729999,
								30.39111575000004
							],
							[
								-81.56578122299993,
								30.391163536000082
							],
							[
								-81.56583060199995,
								30.39121541700007
							],
							[
								-81.56587569599992,
								30.39127106300009
							],
							[
								-81.56591621799993,
								30.39133012000008
							],
							[
								-81.56824990699994,
								30.39503970600003
							],
							[
								-81.56991635999992,
								30.397119618000087
							],
							[
								-81.57201195099992,
								30.399409281000086
							],
							[
								-81.5732461689999,
								30.400216305000075
							],
							[
								-81.5733551479999,
								30.400300119000068
							],
							[
								-81.57945510299993,
								30.405782370000058
							],
							[
								-81.57968273599994,
								30.40570712200008
							],
							[
								-81.57980883399995,
								30.405675340000077
							],
							[
								-81.5799649999999,
								30.40566167800006
							],
							[
								-81.58012116499992,
								30.405675340000077
							],
							[
								-81.58027258599992,
								30.405715913000055
							],
							[
								-81.5804146609999,
								30.405782164000072
							],
							[
								-81.58054307299994,
								30.405872079000066
							],
							[
								-81.58058856299994,
								30.40591296400004
							],
							[
								-81.58323656199991,
								30.408460965000074
							],
							[
								-81.58327113399992,
								30.408496106000086
							],
							[
								-81.5838401339999,
								30.40910710600008
							],
							[
								-81.58387091999992,
								30.409141927000064
							],
							[
								-81.58396083499991,
								30.40927033900004
							],
							[
								-81.58402708599994,
								30.409412414000087
							],
							[
								-81.58406765899991,
								30.409563835000085
							],
							[
								-81.58408132199992,
								30.40972000000005
							],
							[
								-81.58406765899991,
								30.40987616600006
							],
							[
								-81.58402708599994,
								30.41002758700006
							],
							[
								-81.58396083499991,
								30.410169661000054
							],
							[
								-81.58387091999992,
								30.41029807400008
							],
							[
								-81.58376007299995,
								30.41040892100006
							],
							[
								-81.58365369199993,
								30.410485694000048
							],
							[
								-81.5824686929999,
								30.411215693000084
							],
							[
								-81.58244666099995,
								30.411228836000078
							],
							[
								-81.58230848099993,
								30.411293658000087
							],
							[
								-81.5820300339999,
								30.411396462000084
							],
							[
								-81.5820075979999,
								30.411428021000066
							],
							[
								-81.5821129059999,
								30.41190191000004
							],
							[
								-81.58212065899994,
								30.41194083500005
							],
							[
								-81.58213432199994,
								30.412097000000077
							],
							[
								-81.58212065899994,
								30.412253166000085
							],
							[
								-81.5820800859999,
								30.41240458700008
							],
							[
								-81.58201383599993,
								30.412546661000082
							],
							[
								-81.58192392099994,
								30.412675073000063
							],
							[
								-81.58182552199992,
								30.41277528100005
							],
							[
								-81.58099229699991,
								30.41350060100007
							],
							[
								-81.5809304359999,
								30.41354898200007
							],
							[
								-81.58086458799994,
								30.41359178000005
							],
							[
								-81.58079525699993,
								30.41362866700007
							],
							[
								-81.5807229699999,
								30.413659362000093
							],
							[
								-81.58064827999993,
								30.413683630000033
							],
							[
								-81.58057175699992,
								30.413701287000038
							],
							[
								-81.58013596199993,
								30.413781974000077
							],
							[
								-81.57997599999993,
								30.41379632200005
							],
							[
								-81.5798736129999,
								30.413790475000045
							],
							[
								-81.57894861199992,
								30.413684475000082
							],
							[
								-81.57889812199994,
								30.413677233000048
							],
							[
								-81.57847539199992,
								30.41360431000004
							],
							[
								-81.57835839199993,
								30.413821387000045
							],
							[
								-81.57837392499994,
								30.41414155700005
							],
							[
								-81.57863712499994,
								30.415430007000058
							],
							[
								-81.57864165899991,
								30.415453835000054
							],
							[
								-81.57865532199992,
								30.415610000000076
							],
							[
								-81.57864165899991,
								30.41576616600008
							],
							[
								-81.57860108599994,
								30.415917587000084
							],
							[
								-81.5785321219999,
								30.416063536000078
							],
							[
								-81.57895212599993,
								30.41620215500006
							],
							[
								-81.57903006599992,
								30.416231031000052
							],
							[
								-81.57993806699994,
								30.41661603200004
							],
							[
								-81.58000738399994,
								30.416648980000048
							],
							[
								-81.58007363999991,
								30.41668771900004
							],
							[
								-81.58013635199991,
								30.416731966000043
							],
							[
								-81.58019506199992,
								30.41678139900006
							],
							[
								-81.58024934399992,
								30.41683565700004
							],
							[
								-81.5802988019999,
								30.416894347000042
							],
							[
								-81.58044662299994,
								30.41708577500009
							],
							[
								-81.5805185779999,
								30.41710790000008
							],
							[
								-81.58058830899995,
								30.417136265000064
							],
							[
								-81.58065527699995,
								30.41717065100005
							],
							[
								-81.58071896299992,
								30.417210790000073
							],
							[
								-81.58077887399992,
								30.417256373000047
							],
							[
								-81.58083454599995,
								30.417307045000086
							],
							[
								-81.58088554699992,
								30.417362416000064
							],
							[
								-81.58119673399995,
								30.41772517100009
							],
							[
								-81.58128983599994,
								30.41785733900008
							],
							[
								-81.58135608599991,
								30.417999413000075
							],
							[
								-81.58139665899995,
								30.418150834000073
							],
							[
								-81.5814103219999,
								30.418307000000084
							],
							[
								-81.58139665899995,
								30.41846316500005
							],
							[
								-81.58135608599991,
								30.418614586000043
							],
							[
								-81.58134761999992,
								30.418636919000054
							],
							[
								-81.58106701799994,
								30.419348480000053
							],
							[
								-81.58111480899993,
								30.419428702000065
							],
							[
								-81.58160501599993,
								30.42005180500007
							],
							[
								-81.58246886199993,
								30.42062273200008
							],
							[
								-81.58252855599994,
								30.42066579600004
							],
							[
								-81.58258452899992,
								30.420713597000088
							],
							[
								-81.5826364049999,
								30.42076581500004
							],
							[
								-81.58268383699993,
								30.420822100000066
							],
							[
								-81.58274583699995,
								30.42090210000004
							],
							[
								-81.5828138359999,
								30.421003339000038
							],
							[
								-81.58288008599993,
								30.421145414000083
							],
							[
								-81.58292065899991,
								30.42129683400009
							],
							[
								-81.58293432199991,
								30.421453000000042
							],
							[
								-81.58292065899991,
								30.421609166000056
							],
							[
								-81.58288008599993,
								30.42176058600006
							],
							[
								-81.5828138359999,
								30.421902661000047
							],
							[
								-81.58278410799994,
								30.421950612000046
							],
							[
								-81.58273387799994,
								30.422026228000053
							],
							[
								-81.58276166099995,
								30.422041164000063
							],
							[
								-81.58289007299993,
								30.422131079000057
							],
							[
								-81.58300092099995,
								30.422241927000076
							],
							[
								-81.58309083599994,
								30.422370339000054
							],
							[
								-81.58315708599991,
								30.422512414000042
							],
							[
								-81.58319765899995,
								30.422663834000048
							],
							[
								-81.5832113219999,
								30.42282000000006
							],
							[
								-81.5832113219999,
								30.42324215600007
							],
							[
								-81.58335709799991,
								30.42403643800009
							],
							[
								-81.58438749399994,
								30.426013329000057
							],
							[
								-81.58443508599993,
								30.426121414000082
							],
							[
								-81.58445410299993,
								30.42617979000005
							],
							[
								-81.58454610399991,
								30.426498790000036
							],
							[
								-81.5845622299999,
								30.426563675000068
							],
							[
								-81.5845734909999,
								30.426629578000078
							],
							[
								-81.58457982599992,
								30.42669613600009
							],
							[
								-81.58458119799991,
								30.42676298000004
							],
							[
								-81.58457759999993,
								30.426829742000052
							],
							[
								-81.58454305599992,
								30.427208224000086
							],
							[
								-81.58474879999994,
								30.427311933000055
							],
							[
								-81.58479366099994,
								30.427336165000042
							],
							[
								-81.58492207299992,
								30.42742608000009
							],
							[
								-81.58503292099994,
								30.427536927000066
							],
							[
								-81.58512283599993,
								30.427665339000043
							],
							[
								-81.58518908699995,
								30.42780741400009
							],
							[
								-81.58522965999992,
								30.427958835000087
							],
							[
								-81.58524300199991,
								30.428091006000045
							],
							[
								-81.58529942599995,
								30.43020508500007
							],
							[
								-81.58550346299995,
								30.430593805000058
							],
							[
								-81.58619924699991,
								30.431262661000062
							],
							[
								-81.5862500369999,
								30.43131563900005
							],
							[
								-81.5862963379999,
								30.43137258200005
							],
							[
								-81.58633784099993,
								30.431433110000057
							],
							[
								-81.5863742709999,
								30.431496822000042
							],
							[
								-81.58640538499992,
								30.431563291000085
							],
							[
								-81.58678643299993,
								30.432474237000065
							],
							[
								-81.58679564699992,
								30.43242641100005
							],
							[
								-81.58706946899991,
								30.433436913000033
							],
							[
								-81.58685725799995,
								30.434437726000056
							],
							[
								-81.58686816699992,
								30.434364966000093
							],
							[
								-81.58645080299993,
								30.434652281000073
							],
							[
								-81.58639566099993,
								30.434686836000086
							],
							[
								-81.5862836949999,
								30.434741512000073
							],
							[
								-81.58550278699994,
								30.435057895000057
							],
							[
								-81.58492628899995,
								30.435970355000048
							],
							[
								-81.5848577509999,
								30.436061893000044
							],
							[
								-81.58421285299995,
								30.436756998000078
							],
							[
								-81.5840576359999,
								30.436924299000054
							],
							[
								-81.5836877619999,
								30.437611208000078
							],
							[
								-81.58324227599991,
								30.437760112000035
							],
							[
								-81.5826018649999,
								30.438001127000064
							],
							[
								-81.58234707799994,
								30.438131964000036
							],
							[
								-81.58210424999993,
								30.438073309000064
							]
						],
						[
							[
								-81.55332923899995,
								30.41435032200008
							],
							[
								-81.5533865509999,
								30.41433695900008
							],
							[
								-81.55344461499993,
								30.414327372000063
							],
							[
								-81.55350318199993,
								30.414321604000065
							],
							[
								-81.55356199999994,
								30.414319678000084
							],
							[
								-81.55358639799994,
								30.414320009000054
							],
							[
								-81.55434414399991,
								30.41434057400005
							],
							[
								-81.55431624099992,
								30.41430163600006
							],
							[
								-81.5542953229999,
								30.41426881300003
							],
							[
								-81.55420336799995,
								30.414117396000055
							],
							[
								-81.55300704899992,
								30.414406207000066
							],
							[
								-81.55297144899993,
								30.414414042000093
							],
							[
								-81.5529133849999,
								30.414423628000062
							],
							[
								-81.55285481899995,
								30.41442939600006
							],
							[
								-81.55279599999994,
								30.41443132200004
							],
							[
								-81.55273718199993,
								30.41442939600006
							],
							[
								-81.5527270259999,
								30.414428673000092
							],
							[
								-81.5525192479999,
								30.41441269000006
							],
							[
								-81.55143349499991,
								30.41436131700004
							],
							[
								-81.55141718099992,
								30.414360397000053
							],
							[
								-81.55135861499993,
								30.414354629000062
							],
							[
								-81.55131350799991,
								30.41434718100004
							],
							[
								-81.55202330899994,
								30.414841833000082
							],
							[
								-81.55257910299991,
								30.414646480000048
							],
							[
								-81.55322476099991,
								30.414385304000064
							],
							[
								-81.55327292299995,
								30.414367405000068
							],
							[
								-81.55332923899995,
								30.41435032200008
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Blaunt-Quarantine Island",
				"RegionID": "272979"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.50601920018643,
					27.9375737100778,
					-82.4933182406419,
					27.94499065357646
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.4933909085598,
							27.937599944200763
						],
						[
							-82.49750139839036,
							27.9375737100778
						],
						[
							-82.50580431887875,
							27.937586733160146
						],
						[
							-82.50601920018643,
							27.94499065357646
						],
						[
							-82.4933182406419,
							27.944957818429856
						],
						[
							-82.4933909085598,
							27.937599944200763
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Bon Air",
				"RegionID": "272997"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.57120990699991,
					30.26945902400007,
					-81.55904581499993,
					30.27944308200006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.56884990899994,
							30.26948501200007
						],
						[
							-81.57108691999991,
							30.26945902400007
						],
						[
							-81.57108790699994,
							30.270551011000066
						],
						[
							-81.57111690799992,
							30.271334010000093
						],
						[
							-81.57113390799992,
							30.271790010000075
						],
						[
							-81.57118190799991,
							30.27327401100007
						],
						[
							-81.57120090799992,
							30.27404101100007
						],
						[
							-81.57120990699991,
							30.27481601100004
						],
						[
							-81.57120890699991,
							30.275040011000044
						],
						[
							-81.57119490699995,
							30.275250010000036
						],
						[
							-81.57113290699994,
							30.275528008000038
						],
						[
							-81.57100290799991,
							30.27583501000004
						],
						[
							-81.5702889069999,
							30.277073010000038
						],
						[
							-81.5698159079999,
							30.27788001100004
						],
						[
							-81.56959890799993,
							30.278219010000043
						],
						[
							-81.56921990699993,
							30.27890201100007
						],
						[
							-81.56913190799992,
							30.27910101000009
						],
						[
							-81.56900686799992,
							30.27944308200006
						],
						[
							-81.55919985399993,
							30.27416407000004
						],
						[
							-81.55917090699995,
							30.272925011000037
						],
						[
							-81.55917090799994,
							30.272677010000052
						],
						[
							-81.55917090799994,
							30.272099010000087
						],
						[
							-81.55917090799994,
							30.271966010000085
						],
						[
							-81.55917090699995,
							30.271843011000048
						],
						[
							-81.5591429079999,
							30.271281010000052
						],
						[
							-81.55913290699995,
							30.270992011000093
						],
						[
							-81.55911490699992,
							30.270493010000056
						],
						[
							-81.5590569069999,
							30.269886010000054
						],
						[
							-81.55904581499993,
							30.269635024000085
						],
						[
							-81.55943890999993,
							30.269623012000064
						],
						[
							-81.56078590999994,
							30.269591013000085
						],
						[
							-81.56134690999994,
							30.269586012000048
						],
						[
							-81.56405990899992,
							30.26955901200006
						],
						[
							-81.56591290999995,
							30.269534013000055
						],
						[
							-81.56604990999995,
							30.269532012000067
						],
						[
							-81.56884990899994,
							30.26948501200007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Brackridge",
				"RegionID": "273014"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.56534132199994,
					27.93481569000005,
					-82.50593324599993,
					27.967533462000063
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.50593324599993,
							27.96733885000009
						],
						[
							-82.50599022499995,
							27.954989881000074
						],
						[
							-82.51068999299991,
							27.95230002900007
						],
						[
							-82.51212997899995,
							27.951450014000045
						],
						[
							-82.51392004999991,
							27.95090003200005
						],
						[
							-82.51622002199991,
							27.95090001500006
						],
						[
							-82.51821999899994,
							27.950700003000065
						],
						[
							-82.52232003499995,
							27.95070000200008
						],
						[
							-82.52443000999995,
							27.95046001700007
						],
						[
							-82.52511998999995,
							27.950399980000043
						],
						[
							-82.53159996399995,
							27.94800004600006
						],
						[
							-82.53210998799995,
							27.94787998700008
						],
						[
							-82.53231999499991,
							27.947799968000083
						],
						[
							-82.53292003299993,
							27.947600030000046
						],
						[
							-82.53433138399993,
							27.947129758000074
						],
						[
							-82.54031356699994,
							27.944977045000087
						],
						[
							-82.5401454339999,
							27.944562658000056
						],
						[
							-82.53995036099991,
							27.94408075200005
						],
						[
							-82.53979393399993,
							27.943618006000065
						],
						[
							-82.53976709199992,
							27.943192675000034
						],
						[
							-82.5415318609999,
							27.94258438500009
						],
						[
							-82.54211852399993,
							27.942470300000082
						],
						[
							-82.54254648199992,
							27.941915900000083
						],
						[
							-82.54279936599994,
							27.94182836400006
						],
						[
							-82.54302307099994,
							27.94181863700004
						],
						[
							-82.54333431399994,
							27.941935353000076
						],
						[
							-82.54381090299995,
							27.942032616000063
						],
						[
							-82.5442874929999,
							27.942003437000043
						],
						[
							-82.5446570929999,
							27.941789458000073
						],
						[
							-82.54497488299995,
							27.94134302200007
						],
						[
							-82.54536965499994,
							27.94122394900006
						],
						[
							-82.54594827699992,
							27.94098950000006
						],
						[
							-82.54602254999992,
							27.940963132000036
						],
						[
							-82.54649254999993,
							27.94081913100007
						],
						[
							-82.5465222009999,
							27.940810600000077
						],
						[
							-82.54673020099995,
							27.940754600000048
						],
						[
							-82.54680468299995,
							27.94073790200008
						],
						[
							-82.54700836199993,
							27.94070125600007
						],
						[
							-82.54708204199994,
							27.940688609000063
						],
						[
							-82.54717900399993,
							27.940677361000045
						],
						[
							-82.54757500499994,
							27.940653099000087
						],
						[
							-82.54783153999995,
							27.940601926000056
						],
						[
							-82.55407077299992,
							27.938373982000087
						],
						[
							-82.5550155119999,
							27.938037145000067
						],
						[
							-82.55847835199995,
							27.936770509000045
						],
						[
							-82.55949396999995,
							27.936413310000034
						],
						[
							-82.56000792399993,
							27.936222057000066
						],
						[
							-82.56179850399991,
							27.93554396400009
						],
						[
							-82.56182327499994,
							27.935534997000047
						],
						[
							-82.56305076599995,
							27.935110827000077
						],
						[
							-82.56335104899995,
							27.935007450000057
						],
						[
							-82.5636698639999,
							27.934893307000042
						],
						[
							-82.56368861599992,
							27.93488682600008
						],
						[
							-82.5637636159999,
							27.934861826000088
						],
						[
							-82.56383199499993,
							27.934842004000075
						],
						[
							-82.56390172899995,
							27.93482765300007
						],
						[
							-82.56397237899996,
							27.93481886300009
						],
						[
							-82.56404350299994,
							27.93481569000005
						],
						[
							-82.56411465499993,
							27.934818152000048
						],
						[
							-82.56418538999992,
							27.93482623500006
						],
						[
							-82.56425526299995,
							27.934839888000056
						],
						[
							-82.56433126299993,
							27.934857888000067
						],
						[
							-82.5644315859999,
							27.934887914000058
						],
						[
							-82.56451717599992,
							27.934924179000063
						],
						[
							-82.56458917599991,
							27.93495917900009
						],
						[
							-82.56465240499995,
							27.934993097000074
						],
						[
							-82.5647127279999,
							27.935031948000073
						],
						[
							-82.56476976199991,
							27.935075485000088
						],
						[
							-82.5648231429999,
							27.93512343000009
						],
						[
							-82.56487253299991,
							27.935175478000076
						],
						[
							-82.56491761599995,
							27.935231297000087
						],
						[
							-82.56495810599995,
							27.935290533000057
						],
						[
							-82.56506210599991,
							27.935456533000036
						],
						[
							-82.5651012159999,
							27.935525591000047
						],
						[
							-82.5651341109999,
							27.935597817000087
						],
						[
							-82.56516053699994,
							27.935672652000054
						],
						[
							-82.56519626099994,
							27.935736633000094
						],
						[
							-82.5652640859999,
							27.93588141300006
						],
						[
							-82.56530435999993,
							27.936031144000083
						],
						[
							-82.56532750999992,
							27.936160990000076
						],
						[
							-82.56534132199994,
							27.936318000000085
						],
						[
							-82.5653290859999,
							27.93646584700008
						],
						[
							-82.56531137299993,
							27.936572006000063
						],
						[
							-82.56529512399993,
							27.936647273000062
						],
						[
							-82.56527249599992,
							27.93672087300007
						],
						[
							-82.56524365399991,
							27.93679226800009
						],
						[
							-82.56520880999994,
							27.936860934000038
						],
						[
							-82.56516821899994,
							27.93692636600008
						],
						[
							-82.5651221789999,
							27.93698808700009
						],
						[
							-82.56509604999991,
							27.937020079000035
						],
						[
							-82.5649810729999,
							27.93713592100005
						],
						[
							-82.56492233099993,
							27.937181217000045
						],
						[
							-82.56488133099992,
							27.937210218000075
						],
						[
							-82.56481166099991,
							27.93725483600008
						],
						[
							-82.56469600199995,
							27.93731099900009
						],
						[
							-82.56464100199992,
							27.937332999000034
						],
						[
							-82.56455135399995,
							27.937363489000063
						],
						[
							-82.56244035399993,
							27.937959489000036
						],
						[
							-82.56233072299995,
							27.937983174000067
						],
						[
							-82.56202835099992,
							27.938028988000042
						],
						[
							-82.56196296999991,
							27.938053611000043
						],
						[
							-82.56193308099995,
							27.93806427000004
						],
						[
							-82.5616613869999,
							27.938155788000074
						],
						[
							-82.56100783699992,
							27.938398891000077
						],
						[
							-82.55602813299993,
							27.940214969000067
						],
						[
							-82.55061189899993,
							27.942146881000042
						],
						[
							-82.54869236299993,
							27.94280501700007
						],
						[
							-82.54751424799991,
							27.943251820000057
						],
						[
							-82.5473133619999,
							27.943335388000037
						],
						[
							-82.54693809499992,
							27.943531109000048
						],
						[
							-82.54660698599992,
							27.943765755000072
						],
						[
							-82.54652119299995,
							27.94381956400008
						],
						[
							-82.54610219299991,
							27.944050564000065
						],
						[
							-82.54597558599994,
							27.944108086000085
						],
						[
							-82.54595307299991,
							27.94411594400009
						],
						[
							-82.54561474399992,
							27.94422902200006
						],
						[
							-82.54556731999992,
							27.944249416000048
						],
						[
							-82.54515448799992,
							27.94457871900005
						],
						[
							-82.54507907099992,
							27.944641259000036
						],
						[
							-82.54494713399993,
							27.944732086000048
						],
						[
							-82.54481460499994,
							27.94480533600006
						],
						[
							-82.54472518499995,
							27.944848438000065
						],
						[
							-82.5445591859999,
							27.94491743800006
						],
						[
							-82.5444968459999,
							27.944940686000052
						],
						[
							-82.54436463499991,
							27.94498449000008
						],
						[
							-82.54430334799991,
							27.945010334000074
						],
						[
							-82.5441578949999,
							27.945104016000073
						],
						[
							-82.54357273099993,
							27.94553798900006
						],
						[
							-82.54306205899991,
							27.94595774600009
						],
						[
							-82.54293309899992,
							27.946046153000054
						],
						[
							-82.54287109899991,
							27.946081153000083
						],
						[
							-82.54273658599993,
							27.946143086000063
						],
						[
							-82.54271658699992,
							27.94615009900008
						],
						[
							-82.54263658699995,
							27.946177100000057
						],
						[
							-82.54259018899995,
							27.946191376000062
						],
						[
							-82.54236647099994,
							27.946253657000057
						],
						[
							-82.5421814369999,
							27.94632867000007
						],
						[
							-82.54204033699995,
							27.946484861000044
						],
						[
							-82.54193852999994,
							27.94658125400008
						],
						[
							-82.54168778899992,
							27.94678411800004
						],
						[
							-82.54158905399993,
							27.946893748000036
						],
						[
							-82.54144561999993,
							27.947185808000086
						],
						[
							-82.54142829799991,
							27.947226749000038
						],
						[
							-82.54144654499993,
							27.94726484200004
						],
						[
							-82.54147800999993,
							27.947332558000085
						],
						[
							-82.54149433099991,
							27.94736873800008
						],
						[
							-82.5415532909999,
							27.947474982000074
						],
						[
							-82.54202675599993,
							27.948362127000053
						],
						[
							-82.54228689999991,
							27.948777635000056
						],
						[
							-82.54246173999991,
							27.949029429000063
						],
						[
							-82.54249430599992,
							27.949030648000075
						],
						[
							-82.54329902099994,
							27.94898136000006
						],
						[
							-82.5433337959999,
							27.948979905000044
						],
						[
							-82.54457979499996,
							27.948951905000058
						],
						[
							-82.54471739299993,
							27.948959373000037
						],
						[
							-82.54503639399991,
							27.949001373000044
						],
						[
							-82.5450830449999,
							27.949008766000077
						],
						[
							-82.54530404399992,
							27.94904976600009
						],
						[
							-82.54544758599991,
							27.949088914000072
						],
						[
							-82.54550984199994,
							27.94911424600008
						],
						[
							-82.54572484199991,
							27.94921124600006
						],
						[
							-82.54583333499994,
							27.94926943900009
						],
						[
							-82.54607533499991,
							27.94942143800006
						],
						[
							-82.54613777899993,
							27.94946443300006
						],
						[
							-82.5463317789999,
							27.94961043400008
						],
						[
							-82.54643850999992,
							27.949704892000057
						],
						[
							-82.54659850999991,
							27.949870892000035
						],
						[
							-82.54668866499992,
							27.949980577000076
						],
						[
							-82.54684766499992,
							27.95020857700007
						],
						[
							-82.54688323599993,
							27.950263778000078
						],
						[
							-82.54713623599991,
							27.950689778000083
						],
						[
							-82.54718493999991,
							27.950784042000066
						],
						[
							-82.54764894099992,
							27.951829042000043
						],
						[
							-82.54767208699991,
							27.951886414000057
						],
						[
							-82.54771317299992,
							27.95204080500008
						],
						[
							-82.54775468699995,
							27.952285777000043
						],
						[
							-82.54776732199993,
							27.952436000000034
						],
						[
							-82.5477668549999,
							27.95246499700005
						],
						[
							-82.54776385499991,
							27.952557997000042
						],
						[
							-82.54775840899993,
							27.95263195800004
						],
						[
							-82.54774688799995,
							27.952705219000052
						],
						[
							-82.54772937099995,
							27.952777282000056
						],
						[
							-82.54770597499993,
							27.952847657000063
						],
						[
							-82.54767685999991,
							27.95291586400009
						],
						[
							-82.54764222399992,
							27.952981441000077
						],
						[
							-82.5476023029999,
							27.95304394100009
						],
						[
							-82.5475573679999,
							27.95310294000007
						],
						[
							-82.54749264399993,
							27.953181006000083
						],
						[
							-82.54744389899992,
							27.953234873000042
						],
						[
							-82.54739096499992,
							27.95328463000004
						],
						[
							-82.54733418799992,
							27.95332995200005
						],
						[
							-82.54727393699994,
							27.953370543000066
						],
						[
							-82.54721060599991,
							27.953406138000048
						],
						[
							-82.54714460899993,
							27.95343650500007
						],
						[
							-82.54707637599995,
							27.953461445000073
						],
						[
							-82.54700635299992,
							27.953480797000054
						],
						[
							-82.54682635299991,
							27.953522797000062
						],
						[
							-82.54670828099995,
							27.953542174000063
						],
						[
							-82.5462102809999,
							27.95359017300007
						],
						[
							-82.54615299499994,
							27.953593854000076
						],
						[
							-82.54559499499993,
							27.953611854000087
						],
						[
							-82.54548146899992,
							27.953608340000073
						],
						[
							-82.54496246999993,
							27.953559341000073
						],
						[
							-82.54490088599994,
							27.95355137300004
						],
						[
							-82.54477175399991,
							27.953530110000088
						],
						[
							-82.54474809699991,
							27.953538476000062
						],
						[
							-82.54488198899992,
							27.953807035000068
						],
						[
							-82.54490584799993,
							27.953859013000056
						],
						[
							-82.54506584699993,
							27.954239012000073
						],
						[
							-82.54511371099994,
							27.954387607000058
						],
						[
							-82.54518571199992,
							27.95470260700006
						],
						[
							-82.5451940879999,
							27.954743627000084
						],
						[
							-82.54523598299994,
							27.954976293000076
						],
						[
							-82.54527579599994,
							27.955083546000083
						],
						[
							-82.54545501699994,
							27.95522709000005
						],
						[
							-82.54580410299991,
							27.955452016000038
						],
						[
							-82.54586807699991,
							27.955497300000047
						],
						[
							-82.54605507799994,
							27.95564230000008
						],
						[
							-82.54611256599992,
							27.95569086100005
						],
						[
							-82.54616579299994,
							27.95574405800005
						],
						[
							-82.5462143869999,
							27.955801519000094
						],
						[
							-82.5463323859999,
							27.955953519000047
						],
						[
							-82.54640083499993,
							27.956055339000045
						],
						[
							-82.54641759299994,
							27.956085701000063
						],
						[
							-82.54653459299993,
							27.95630770200006
						],
						[
							-82.54658408599994,
							27.956419414000038
						],
						[
							-82.54661640499995,
							27.956529669000076
						],
						[
							-82.54666640799991,
							27.956751999000062
						],
						[
							-82.5467099789999,
							27.956902393000064
						],
						[
							-82.54675447799991,
							27.957017659000087
						],
						[
							-82.54693562499995,
							27.957334476000085
						],
						[
							-82.54702135799994,
							27.957452748000037
						],
						[
							-82.5470536819999,
							27.957482739000056
						],
						[
							-82.54715759299995,
							27.957597292000063
						],
						[
							-82.5473105939999,
							27.957798293000053
						],
						[
							-82.54738107899993,
							27.95790612500008
						],
						[
							-82.5479416519999,
							27.95891477500004
						],
						[
							-82.54808663799992,
							27.958989417000055
						],
						[
							-82.5481550149999,
							27.959028497000077
						],
						[
							-82.5482197099999,
							27.95907340900004
						],
						[
							-82.5482802279999,
							27.95912380900006
						],
						[
							-82.54833610399993,
							27.95917931100007
						],
						[
							-82.54841910399995,
							27.95926931100007
						],
						[
							-82.54846672499991,
							27.959325386000046
						],
						[
							-82.5485096029999,
							27.95938516600006
						],
						[
							-82.54854745199992,
							27.959448250000037
						],
						[
							-82.54882845299994,
							27.959963250000044
						],
						[
							-82.54886032499991,
							27.960027659000048
						],
						[
							-82.54892232399993,
							27.960166659000038
						],
						[
							-82.54894608599994,
							27.960225414000035
						],
						[
							-82.54897929299995,
							27.960339660000045
						],
						[
							-82.5490142939999,
							27.96049866000004
						],
						[
							-82.54902165999994,
							27.96053583400004
						],
						[
							-82.54903122799993,
							27.96060328200008
						],
						[
							-82.54910055699992,
							27.960630904000084
						],
						[
							-82.54916719199991,
							27.960664508000036
						],
						[
							-82.5492306189999,
							27.96070383400007
						],
						[
							-82.5492903469999,
							27.96074857800005
						],
						[
							-82.54934591499995,
							27.96079839500004
						],
						[
							-82.54939689299995,
							27.960852900000077
						],
						[
							-82.54946942499993,
							27.960874109000088
						],
						[
							-82.54953793999994,
							27.960901032000038
						],
						[
							-82.54901284399995,
							27.961583658000052
						],
						[
							-82.54881636099992,
							27.961718388000065
						],
						[
							-82.5486030369999,
							27.961847505000037
						],
						[
							-82.54839532699992,
							27.961903643000085
						],
						[
							-82.54818761699994,
							27.961903643000085
						],
						[
							-82.54785078999993,
							27.961881188000064
						],
						[
							-82.54729502599992,
							27.961808209000083
						],
						[
							-82.54685715099993,
							27.96174645700006
						],
						[
							-82.54649786899995,
							27.961757685000066
						],
						[
							-82.54627331699993,
							27.961808209000083
						],
						[
							-82.54620742399993,
							27.961680069000067
						],
						[
							-82.5457183019999,
							27.96079985700004
						],
						[
							-82.54251818799992,
							27.95969991800007
						],
						[
							-82.54031818199991,
							27.960099998000093
						],
						[
							-82.53791818099995,
							27.960000000000036
						],
						[
							-82.52011815899994,
							27.95949986800008
						],
						[
							-82.51891811599997,
							27.959899886000073
						],
						[
							-82.51569999999992,
							27.96297272700008
						],
						[
							-82.51231818199996,
							27.966300001000036
						],
						[
							-82.5113935249999,
							27.967533462000063
						],
						[
							-82.50593324599993,
							27.96733885000009
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Carver City",
				"RegionID": "273148"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.45894832199991,
					27.93962977800004,
					-82.44200444599994,
					27.956381927000052
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.44332931199996,
							27.94332586200005
						],
						[
							-82.4439135319999,
							27.942599881000035
						],
						[
							-82.4439954099999,
							27.942501726000046
						],
						[
							-82.44410692699995,
							27.942390079000063
						],
						[
							-82.44413474699991,
							27.94237059900007
						],
						[
							-82.44419195599994,
							27.942195263000087
						],
						[
							-82.44426694599991,
							27.94183883900007
						],
						[
							-82.44428048799995,
							27.941778079000073
						],
						[
							-82.44429894899991,
							27.941718628000046
						],
						[
							-82.44432220499993,
							27.941660884000044
						],
						[
							-82.44435010099994,
							27.941605233000075
						],
						[
							-82.44438245099991,
							27.941552048000062
						],
						[
							-82.44441903799992,
							27.941501683000073
						],
						[
							-82.44445694599995,
							27.941280103000057
						],
						[
							-82.44447355099993,
							27.94120414100007
						],
						[
							-82.44449665499991,
							27.941129896000064
						],
						[
							-82.44452608599994,
							27.941057925000052
						],
						[
							-82.44456162499995,
							27.94098876600009
						],
						[
							-82.44460300499992,
							27.94092293500006
						],
						[
							-82.44464991699994,
							27.94086092400005
						],
						[
							-82.44489658099991,
							27.94055770000006
						],
						[
							-82.4456840869999,
							27.941021486000068
						],
						[
							-82.44603619599991,
							27.94130317300005
						],
						[
							-82.44672730299995,
							27.94160629000004
						],
						[
							-82.44844900999993,
							27.94158204100006
						],
						[
							-82.45044627099992,
							27.941135506000084
						],
						[
							-82.45458720499994,
							27.940048597000043
						],
						[
							-82.45491051399995,
							27.939986322000042
						],
						[
							-82.45514715899992,
							27.939860111000087
						],
						[
							-82.45543902199995,
							27.939749676000076
						],
						[
							-82.45568355599994,
							27.93968657100004
						],
						[
							-82.45597053199992,
							27.93962977800004
						],
						[
							-82.4560678439999,
							27.93966946800009
						],
						[
							-82.45667692199993,
							27.939897994000034
						],
						[
							-82.45671565499993,
							27.939913562000072
						],
						[
							-82.45793459899994,
							27.940436656000088
						],
						[
							-82.45808678299994,
							27.94048354100005
						],
						[
							-82.45817287299992,
							27.940514949000093
						],
						[
							-82.45823704999992,
							27.94054218100007
						],
						[
							-82.45829922699994,
							27.94056941300005
						],
						[
							-82.4583876609999,
							27.940614165000056
						],
						[
							-82.45849498699994,
							27.94139584000004
						],
						[
							-82.45870945299993,
							27.94218221300008
						],
						[
							-82.45890008899995,
							27.942992415000052
						],
						[
							-82.45894832199991,
							27.943330046000085
						],
						[
							-82.4585009999999,
							27.943317000000036
						],
						[
							-82.4579181819999,
							27.943300002000058
						],
						[
							-82.45411818199995,
							27.944000001000063
						],
						[
							-82.4538124199999,
							27.94411467300006
						],
						[
							-82.45363711499994,
							27.944290158000058
						],
						[
							-82.45346363499993,
							27.94446363600008
						],
						[
							-82.45276363399995,
							27.945163639000043
						],
						[
							-82.45221828299992,
							27.946027361000063
						],
						[
							-82.45180074399991,
							27.94634214200005
						],
						[
							-82.45179999899995,
							27.94642727300004
						],
						[
							-82.45185462599994,
							27.946827281000083
						],
						[
							-82.45153636499992,
							27.94758182000004
						],
						[
							-82.45129090899991,
							27.94861818600009
						],
						[
							-82.45126371299995,
							27.949981840000078
						],
						[
							-82.45105441899995,
							27.950290862000088
						],
						[
							-82.45089103299995,
							27.95103640900004
						],
						[
							-82.45059987199994,
							27.95148177200008
						],
						[
							-82.45042734999993,
							27.952300034000075
						],
						[
							-82.44951813599994,
							27.95356361000006
						],
						[
							-82.44946363399993,
							27.953718182000046
						],
						[
							-82.4493272709999,
							27.953936363000082
						],
						[
							-82.44926478699995,
							27.954020297000056
						],
						[
							-82.44915449799993,
							27.954045330000042
						],
						[
							-82.44551831299992,
							27.956381927000052
						],
						[
							-82.44200444599994,
							27.95618927600009
						],
						[
							-82.44207443399995,
							27.954999172000043
						],
						[
							-82.44282448199993,
							27.954894737000075
						],
						[
							-82.44286806999992,
							27.954658475000087
						],
						[
							-82.4429182689999,
							27.953212759000053
						],
						[
							-82.44273755399992,
							27.95265053600008
						],
						[
							-82.44240624399993,
							27.95213851200009
						],
						[
							-82.44244789699991,
							27.951198400000067
						],
						[
							-82.44252869899992,
							27.951159800000084
						],
						[
							-82.44255892799993,
							27.951148154000066
						],
						[
							-82.44254756399994,
							27.951079676000063
						],
						[
							-82.4425416229999,
							27.951010516000053
						],
						[
							-82.44254114199993,
							27.950941103000048
						],
						[
							-82.44256017599992,
							27.95034908400004
						],
						[
							-82.44258697999993,
							27.94962707400009
						],
						[
							-82.44259663199995,
							27.949216971000055
						],
						[
							-82.44262672499991,
							27.94841554100009
						],
						[
							-82.44264471999992,
							27.947772575000045
						],
						[
							-82.44274777699991,
							27.946381313000074
						],
						[
							-82.44290236199993,
							27.94563415400006
						],
						[
							-82.44303118199991,
							27.94452629700004
						],
						[
							-82.4431342389999,
							27.94395948600004
						],
						[
							-82.44332931199996,
							27.94332586200005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Channel District",
				"RegionID": "273214"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.42601823699995,
					28.00925858200031,
					-82.39735299999988,
					28.033680912999973
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-82.40782899999981,
								28.020006000000315
							],
							[
								-82.40792632073759,
								28.019986357282637
							],
							[
								-82.40748999999974,
								28.020220000000965
							],
							[
								-82.40705699999988,
								28.020396000000254
							],
							[
								-82.40689592045464,
								28.02037500000029
							],
							[
								-82.40698699999977,
								28.02037500000029
							],
							[
								-82.40709699999974,
								28.02035900000021
							],
							[
								-82.4072029999998,
								28.020329000000213
							],
							[
								-82.40735599999975,
								28.020268000000318
							],
							[
								-82.40752499999988,
								28.02018000000032
							],
							[
								-82.40770699999966,
								28.020064000000314
							],
							[
								-82.40782899999981,
								28.020006000000315
							]
						]
					],
					[
						[
							[
								-82.40618599999986,
								28.020309000000335
							],
							[
								-82.4062969999998,
								28.020298000000313
							],
							[
								-82.40640999999991,
								28.020296000000325
							],
							[
								-82.40651999999986,
								28.020306000000264
							],
							[
								-82.4066159999999,
								28.020326000000143
							],
							[
								-82.40676432578844,
								28.020357843954816
							],
							[
								-82.40638199999955,
								28.020308000000075
							],
							[
								-82.40613899999987,
								28.02036200000028
							],
							[
								-82.40602499999976,
								28.020416000000484
							],
							[
								-82.40588482760279,
								28.020687885591503
							],
							[
								-82.40590699999977,
								28.02056800000027
							],
							[
								-82.40592299999985,
								28.020522000000373
							],
							[
								-82.40595199999976,
								28.020479000000368
							],
							[
								-82.40602399999977,
								28.020403000000123
							],
							[
								-82.40613499999972,
								28.020325000000238
							],
							[
								-82.40618599999986,
								28.020309000000335
							]
						]
					],
					[
						[
							[
								-82.40504399999969,
								28.02181500000042
							],
							[
								-82.4047739999999,
								28.02166900000095
							],
							[
								-82.40471199999966,
								28.021658000000752
							],
							[
								-82.40459099999987,
								28.02166900000095
							],
							[
								-82.40453899999964,
								28.02171800000021
							],
							[
								-82.40442708947347,
								28.021761892180766
							],
							[
								-82.40447099999989,
								28.021723000000268
							],
							[
								-82.40455499999973,
								28.02165800000022
							],
							[
								-82.40460499999986,
								28.021633000000282
							],
							[
								-82.40465899999981,
								28.021621
							],
							[
								-82.40471199999983,
								28.021630000000034
							],
							[
								-82.4047899999998,
								28.021662000000195
							],
							[
								-82.40502899999977,
								28.021792000000293
							],
							[
								-82.40508099999981,
								28.021809000000278
							],
							[
								-82.4051109999999,
								28.02180700000029
							],
							[
								-82.4051309999997,
								28.021801000000327
							],
							[
								-82.40514499999988,
								28.021779000000283
							],
							[
								-82.40513399999985,
								28.021754000000346
							],
							[
								-82.40510199999987,
								28.021722000000363
							],
							[
								-82.40496899999988,
								28.021644000000304
							],
							[
								-82.40490399999992,
								28.021597000000323
							],
							[
								-82.4048649999998,
								28.021555000000223
							],
							[
								-82.40485399999986,
								28.021534000000262
							],
							[
								-82.40485799999993,
								28.021514000000387
							],
							[
								-82.40489499999988,
								28.021485000000116
							],
							[
								-82.4049679999997,
								28.021446000000264
							],
							[
								-82.40519699999992,
								28.02135400000029
							],
							[
								-82.40538199999985,
								28.021298000000275
							],
							[
								-82.40554599999983,
								28.021269000000366
							],
							[
								-82.4056829999999,
								28.021240000000272
							],
							[
								-82.40573499999992,
								28.0212210000003
							],
							[
								-82.40577799999993,
								28.021191000000304
							],
							[
								-82.4058309999998,
								28.021131000000317
							],
							[
								-82.4058549999999,
								28.021085000000237
							],
							[
								-82.40586899999991,
								28.021014000000225
							],
							[
								-82.40586899999991,
								28.020861000000355
							],
							[
								-82.40588257747879,
								28.020712496322027
							],
							[
								-82.40587599999978,
								28.02101600000039
							],
							[
								-82.40584899999986,
								28.02119200000074
							],
							[
								-82.40561999999964,
								28.021279000000124
							],
							[
								-82.40535599999974,
								28.021353999999935
							],
							[
								-82.40511999999976,
								28.02144100000074
							],
							[
								-82.40498899999993,
								28.02149800000048
							],
							[
								-82.4049519999998,
								28.02154600000019
							],
							[
								-82.40496699999971,
								28.021589000000194
							],
							[
								-82.40518599999989,
								28.021768000000083
							],
							[
								-82.40519299999994,
								28.021801000000682
							],
							[
								-82.40514599999962,
								28.021833000000488
							],
							[
								-82.40510599999975,
								28.02183700000064
							],
							[
								-82.40504399999969,
								28.02181500000042
							]
						]
					],
					[
						[
							[
								-82.40029799999984,
								28.022979000000095
							],
							[
								-82.40037099999994,
								28.02297100000032
							],
							[
								-82.40054615393467,
								28.022977541018538
							],
							[
								-82.40013499999985,
								28.023048000000653
							],
							[
								-82.4000756416522,
								28.023063683811525
							],
							[
								-82.4001739999998,
								28.023021000000373
							],
							[
								-82.4002189999997,
								28.023002000000222
							],
							[
								-82.40029799999984,
								28.022979000000095
							]
						]
					],
					[
						[
							[
								-82.39891099999974,
								28.02330200000053
							],
							[
								-82.39845499999994,
								28.02323499999996
							],
							[
								-82.39841032857116,
								28.023235000000316
							],
							[
								-82.39841799999982,
								28.023232000000245
							],
							[
								-82.39849999999967,
								28.02321500000026
							],
							[
								-82.39856799999987,
								28.023213000000272
							],
							[
								-82.39869399999992,
								28.023220000000318
							],
							[
								-82.39874499999978,
								28.023242000000185
							],
							[
								-82.3988259999999,
								28.023259000000348
							],
							[
								-82.39890999999993,
								28.023262000000063
							],
							[
								-82.39902099999988,
								28.023256000000277
							],
							[
								-82.39912999999983,
								28.02323600000022
							],
							[
								-82.3992989999997,
								28.02323900000029
							],
							[
								-82.39940899999992,
								28.023235000000316
							],
							[
								-82.39943399999986,
								28.02322600000028
							],
							[
								-82.39950399999978,
								28.02318200000037
							],
							[
								-82.39955399999984,
								28.02315800000034
							],
							[
								-82.39962999999982,
								28.023128000000344
							],
							[
								-82.39968399999984,
								28.023121000000298
							],
							[
								-82.3997969999997,
								28.023125000000274
							],
							[
								-82.39990062395826,
								28.02310992742473
							],
							[
								-82.39934399999969,
								28.02325700000036
							],
							[
								-82.39891099999974,
								28.02330200000053
							]
						]
					],
					[
						[
							[
								-82.39757506311143,
								28.033680912999973
							],
							[
								-82.39757299999988,
								28.032619000000306
							],
							[
								-82.39758196294041,
								28.031478233999888
							],
							[
								-82.39758217564378,
								28.031451161997648
							],
							[
								-82.39760199999988,
								28.028928000000267
							],
							[
								-82.39756294878882,
								28.02882315807899
							],
							[
								-82.39739899999988,
								28.028383000000293
							],
							[
								-82.39735299999988,
								28.02604400000003
							],
							[
								-82.39747499999986,
								28.026021000000263
							],
							[
								-82.3975259999999,
								28.025921000000334
							],
							[
								-82.3975279999999,
								28.02522200000023
							],
							[
								-82.39754572913805,
								28.02519844210433
							],
							[
								-82.3976009999999,
								28.02512500000002
							],
							[
								-82.39761999999978,
								28.02477400000011
							],
							[
								-82.3976208593267,
								28.02476365502741
							],
							[
								-82.39764599999988,
								28.024461000000326
							],
							[
								-82.3976661147262,
								28.024153646982445
							],
							[
								-82.39901852799994,
								28.023763260001036
							],
							[
								-82.40011761899986,
								28.023613384000008
							],
							[
								-82.40076708199967,
								28.023613384000008
							],
							[
								-82.40149980999989,
								28.02344685500106
							],
							[
								-82.40254894299947,
								28.02301387900094
							],
							[
								-82.40341489399962,
								28.02283069700088
							],
							[
								-82.40469716799986,
								28.02234776300089
							],
							[
								-82.40539658899972,
								28.02221454000097
							],
							[
								-82.4059461349999,
								28.02194809400095
							],
							[
								-82.4062958459998,
								28.021365242000865
							],
							[
								-82.40659559799973,
								28.020948919000613
							],
							[
								-82.4069453089998,
								28.020882308000875
							],
							[
								-82.40726171499978,
								28.020882308000875
							],
							[
								-82.40798456699972,
								28.020975311000665
							],
							[
								-82.40800883599977,
								28.021014339000164
							],
							[
								-82.40803438499948,
								28.021061824000984
							],
							[
								-82.40804538399986,
								28.021083824000318
							],
							[
								-82.40804757699969,
								28.021088240000683
							],
							[
								-82.40807186499967,
								28.021141844001033
							],
							[
								-82.4080925949995,
								28.02119692200097
							],
							[
								-82.40810961799967,
								28.021253040000108
							],
							[
								-82.4081873409998,
								28.021243709000668
							],
							[
								-82.40863501999945,
								28.02109685200033
							],
							[
								-82.40875863999973,
								28.021044868000292
							],
							[
								-82.40928293199977,
								28.02076583800012
							],
							[
								-82.4094076819997,
								28.020687016000704
							],
							[
								-82.40941521699988,
								28.020680804000012
							],
							[
								-82.40947300199969,
								28.020605202500196
							],
							[
								-82.40950269599965,
								28.020568975000977
							],
							[
								-82.40984291399974,
								28.020416026000664
							],
							[
								-82.40990862299985,
								28.02036491900061
							],
							[
								-82.41044241899986,
								28.019949745000364
							],
							[
								-82.41077547699989,
								28.019283629000316
							],
							[
								-82.41099196499987,
								28.01843433100021
							],
							[
								-82.41120845199993,
								28.017451810000363
							],
							[
								-82.41152485799981,
								28.016669123000177
							],
							[
								-82.41235581099964,
								28.014708304000028
							],
							[
								-82.41236803599985,
								28.014696854000324
							],
							[
								-82.41238398099948,
								28.014683196000437
							],
							[
								-82.41242406899987,
								28.014540216000864
							],
							[
								-82.41243840399981,
								28.014493923000675
							],
							[
								-82.41245913399985,
								28.014438844000114
							],
							[
								-82.41247114799977,
								28.014411164000666
							],
							[
								-82.41279646799977,
								28.013694750000543
							],
							[
								-82.41280211899979,
								28.01366801300073
							],
							[
								-82.41281332099993,
								28.013621238000677
							],
							[
								-82.41283040499957,
								28.013564922000636
							],
							[
								-82.41285113399985,
								28.013509844000698
							],
							[
								-82.41287542199983,
								28.01345624000017
							],
							[
								-82.41290316399963,
								28.01340433900005
							],
							[
								-82.41290780299992,
								28.013396397000815
							],
							[
								-82.41304913299973,
								28.013157288000304
							],
							[
								-82.41311094599959,
								28.013011075000197
							],
							[
								-82.4130994049998,
								28.012979077000924
							],
							[
								-82.4130823219998,
								28.012922762000265
							],
							[
								-82.4130689589996,
								28.012865449000582
							],
							[
								-82.41305937199978,
								28.01280738500022
							],
							[
								-82.41305360399973,
								28.012748818000613
							],
							[
								-82.41305167799975,
								28.01269000000072
							],
							[
								-82.41305360399973,
								28.012631181000206
							],
							[
								-82.41305937199978,
								28.012572615001044
							],
							[
								-82.4130689589996,
								28.01251455100068
							],
							[
								-82.41307739799974,
								28.012476459000727
							],
							[
								-82.41309939799953,
								28.012386460000652
							],
							[
								-82.41310432099975,
								28.012367239000927
							],
							[
								-82.41312140499986,
								28.012310923001063
							],
							[
								-82.41313896899987,
								28.012263589000344
							],
							[
								-82.4131413709998,
								28.01224361500029
							],
							[
								-82.41315095799972,
								28.012185551000993
							],
							[
								-82.41316432099984,
								28.012128238000248
							],
							[
								-82.41318140499948,
								28.012071922000207
							],
							[
								-82.41320213399976,
								28.01201684400009
							],
							[
								-82.41322642199974,
								28.011963240000807
							],
							[
								-82.4132541639999,
								28.011911339000687
							],
							[
								-82.41328583899968,
								28.01186047000012
							],
							[
								-82.41333143799955,
								28.01179257700063
							],
							[
								-82.41336451999962,
								28.011746527000373
							],
							[
								-82.41340172899959,
								28.011701178000084
							],
							[
								-82.41381654899962,
								28.010356380000548
							],
							[
								-82.41379112199957,
								28.010220953000623
							],
							[
								-82.4137833709999,
								28.010172385000338
							],
							[
								-82.4137776029995,
								28.01011381800073
							],
							[
								-82.4137756779998,
								28.01005500000066
							],
							[
								-82.41377653999986,
								28.0100286470007
							],
							[
								-82.41382295799988,
								28.009758169000346
							],
							[
								-82.4139894869999,
								28.00947506900037
							],
							[
								-82.41442246299992,
								28.00934184600027
							],
							[
								-82.41442715999996,
								28.00934132400005
							],
							[
								-82.41517184299977,
								28.00925858200031
							],
							[
								-82.41613771199982,
								28.00934184600027
							],
							[
								-82.41740333199992,
								28.009608293000202
							],
							[
								-82.4183692009999,
								28.009941351000226
							],
							[
								-82.41936837499979,
								28.009941351000226
							],
							[
								-82.4198513089998,
								28.010107880000238
							],
							[
								-82.4208005239999,
								28.010607467000273
							],
							[
								-82.42171643399983,
								28.010940525000297
							],
							[
								-82.42214940999968,
								28.01163994700026
							],
							[
								-82.4225157729998,
								28.012522551000277
							],
							[
								-82.42256573199975,
								28.013488419000257
							],
							[
								-82.42244916199988,
								28.013938047000334
							],
							[
								-82.42211610399985,
								28.01465412200034
							],
							[
								-82.42174973999992,
								28.015320238000033
							],
							[
								-82.42120019399994,
								28.016319412000104
							],
							[
								-82.42085048299985,
								28.01716871000021
							],
							[
								-82.42052045499973,
								28.01801236500047
							],
							[
								-82.42050697099977,
								28.018024475000583
							],
							[
								-82.42048615499964,
								28.0182246270008
							],
							[
								-82.42048666751829,
								28.018235699770347
							],
							[
								-82.42043104099979,
								28.018390611000324
							],
							[
								-82.4203161909998,
								28.01875813000027
							],
							[
								-82.42006352199985,
								28.01942425700023
							],
							[
								-82.4198289359998,
								28.02019289700059
							],
							[
								-82.4197259169998,
								28.020295917000585
							],
							[
								-82.41969193299983,
								28.020328175000948
							],
							[
								-82.41945993299973,
								28.020537174000385
							],
							[
								-82.4194509639998,
								28.020545146001044
							],
							[
								-82.41940547299984,
								28.020582480000048
							],
							[
								-82.41939947399952,
								28.02058704300034
							],
							[
								-82.41929252999982,
								28.02066768900097
							],
							[
								-82.4192706599997,
								28.02069294800084
							],
							[
								-82.41922436199978,
								28.020774193000722
							],
							[
								-82.4192139109998,
								28.020819227000363
							],
							[
								-82.41920129899982,
								28.020972668000717
							],
							[
								-82.41919662799988,
								28.02101638500069
							],
							[
								-82.41918694949975,
								28.021074909501134
							],
							[
								-82.41915561999951,
								28.02123155700055
							],
							[
								-82.41918430999975,
								28.021336189001037
							],
							[
								-82.41918567899978,
								28.021341239000567
							],
							[
								-82.41919904199982,
								28.021398551000868
							],
							[
								-82.41920667699992,
								28.021442638000696
							],
							[
								-82.41920940699978,
								28.02146113300036
							],
							[
								-82.4193964689998,
								28.021860661000023
							],
							[
								-82.41941286499957,
								28.021897845000257
							],
							[
								-82.41942269699967,
								28.021922613000708
							],
							[
								-82.41972678699987,
								28.022723045000323
							],
							[
								-82.4198290269998,
								28.022902135000397
							],
							[
								-82.42012592799976,
								28.0233628110005
							],
							[
								-82.42014883599971,
								28.02340033900005
							],
							[
								-82.42017657799987,
								28.02345224000017
							],
							[
								-82.42020086499984,
								28.0235058440007
							],
							[
								-82.42022159499969,
								28.023560922000637
							],
							[
								-82.42022639399964,
								28.023575464000952
							],
							[
								-82.42028533699981,
								28.023759331000978
							],
							[
								-82.42035081999981,
								28.02392871400105
							],
							[
								-82.42036359499944,
								28.023963922000586
							],
							[
								-82.42038067799946,
								28.024020238000627
							],
							[
								-82.4203930469995,
								28.024072626001054
							],
							[
								-82.42044504799979,
								28.024326626000754
							],
							[
								-82.42044604199953,
								28.024331551000007
							],
							[
								-82.42045562799979,
								28.02438961500055
							],
							[
								-82.42045820399981,
								28.024411192000645
							],
							[
								-82.42051820399989,
								28.02497119300053
							],
							[
								-82.42052139699989,
								28.025008182000658
							],
							[
								-82.42052332199988,
								28.02506700000073
							],
							[
								-82.42052139699989,
								28.025125819
							],
							[
								-82.42052018099979,
								28.025142098000195
							],
							[
								-82.42050518099971,
								28.02532109800008
							],
							[
								-82.42050062899986,
								28.025363385000293
							],
							[
								-82.4204910419997,
								28.025421449000657
							],
							[
								-82.42047767899976,
								28.02547876200034
							],
							[
								-82.42046169399975,
								28.025531821000374
							],
							[
								-82.42040114449985,
								28.025712448501064
							],
							[
								-82.42037986599973,
								28.025769155001004
							],
							[
								-82.42035557799976,
								28.025822760000732
							],
							[
								-82.42034737699962,
								28.02583897500092
							],
							[
								-82.42024593899976,
								28.02603460400032
							],
							[
								-82.42017032299962,
								28.02620064700047
							],
							[
								-82.42021175999967,
								28.02621942200069
							],
							[
								-82.4202636609998,
								28.026247164000676
							],
							[
								-82.42029716099955,
								28.026267491001025
							],
							[
								-82.42058916099981,
								28.02645349100096
							],
							[
								-82.42060563699975,
								28.026464241000962
							],
							[
								-82.4206534729999,
								28.026498520001045
							],
							[
								-82.42066947599972,
								28.02651109000102
							],
							[
								-82.42089854099994,
								28.026695240000624
							],
							[
								-82.42106663399971,
								28.026778202000916
							],
							[
								-82.42160765949993,
								28.026961263000164
							],
							[
								-82.42166315599977,
								28.026982135001003
							],
							[
								-82.42171675999985,
								28.027006423000348
							],
							[
								-82.42176866099962,
								28.027034164000955
							],
							[
								-82.42181863699976,
								28.027065241000418
							],
							[
								-82.42183011199982,
								28.027073036999997
							],
							[
								-82.42188807399972,
								28.027113073000645
							],
							[
								-82.42194173799966,
								28.02711634600065
							],
							[
								-82.42194581899962,
								28.027116604000316
							],
							[
								-82.42200438499985,
								28.027122372000083
							],
							[
								-82.42206244899977,
								28.027131958000343
							],
							[
								-82.42211976199971,
								28.027145322000383
							],
							[
								-82.42217607799975,
								28.027162405000823
							],
							[
								-82.42222520299991,
								28.027180694000112
							],
							[
								-82.42246420399971,
								28.027277694000322
							],
							[
								-82.42247015599966,
								28.027280135000257
							],
							[
								-82.42252375999975,
								28.02730442300067
							],
							[
								-82.42257566099987,
								28.027332165000654
							],
							[
								-82.42259909199967,
								28.027346170001014
							],
							[
								-82.42279309199965,
								28.027466171000373
							],
							[
								-82.42281963699962,
								28.02748324100072
							],
							[
								-82.42284604999986,
								28.027501581000994
							],
							[
								-82.42300823399978,
								28.027618547000724
							],
							[
								-82.42317563899951,
								28.027676635000557
							],
							[
								-82.42338880499982,
								28.027710998001
							],
							[
								-82.42355087099973,
								28.027709469000076
							],
							[
								-82.42367631299965,
								28.027685851000076
							],
							[
								-82.42379896099975,
								28.02765244600007
							],
							[
								-82.42416518299967,
								28.027466572000673
							],
							[
								-82.42455704599968,
								28.027154228000942
							],
							[
								-82.42464498199966,
								28.027078043000593
							],
							[
								-82.42514027399987,
								28.026830811000384
							],
							[
								-82.42559681599981,
								28.026495629000184
							],
							[
								-82.42599543799984,
								28.027275245000208
							],
							[
								-82.42601823699995,
								28.032709091000033
							],
							[
								-82.39820908999984,
								28.032700000000258
							],
							[
								-82.39759076299984,
								28.032660428000003
							],
							[
								-82.39757506311143,
								28.033680912999973
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Temple Crest",
				"RegionID": "275681"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.39349899999998,
					28.11055009200004,
					-82.35320599999994,
					28.171291000000053
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.35386499699996,
							28.171280867000064
						],
						[
							-82.35386434999998,
							28.171245182000067
						],
						[
							-82.35380999999995,
							28.16824900000006
						],
						[
							-82.35373500599997,
							28.163892539000074
						],
						[
							-82.35373299999998,
							28.163776000000045
						],
						[
							-82.36168599999996,
							28.163815000000056
						],
						[
							-82.36498103799994,
							28.16381317700007
						],
						[
							-82.36529999999993,
							28.16381300000006
						],
						[
							-82.36529999999993,
							28.16372820400005
						],
						[
							-82.36529999999993,
							28.160141000000067
						],
						[
							-82.36593478799995,
							28.16014143100006
						],
						[
							-82.36971599999998,
							28.160144000000063
						],
						[
							-82.37283299999996,
							28.160138000000074
						],
						[
							-82.37282599999998,
							28.156379000000072
						],
						[
							-82.37217329299995,
							28.156361879000034
						],
						[
							-82.36939499999994,
							28.156289000000072
						],
						[
							-82.36912999999998,
							28.156172000000026
						],
						[
							-82.36872499999998,
							28.156039000000078
						],
						[
							-82.36647727799993,
							28.156039000000078
						],
						[
							-82.36635099999995,
							28.156039000000078
						],
						[
							-82.36604099999994,
							28.15604000000008
						],
						[
							-82.36521499999998,
							28.15605000000005
						],
						[
							-82.36503899999997,
							28.156052000000045
						],
						[
							-82.36352299999999,
							28.156059000000027
						],
						[
							-82.36320999999998,
							28.156070000000057
						],
						[
							-82.36309699999998,
							28.156071000000054
						],
						[
							-82.36274899999995,
							28.156075000000044
						],
						[
							-82.36043999999998,
							28.15609900000004
						],
						[
							-82.36004499999996,
							28.156105000000025
						],
						[
							-82.35949399999998,
							28.15610900000007
						],
						[
							-82.35898099999997,
							28.156113000000065
						],
						[
							-82.35702799999996,
							28.156131000000073
						],
						[
							-82.35433499999994,
							28.156153000000074
						],
						[
							-82.35389699999996,
							28.156157000000064
						],
						[
							-82.35358960399998,
							28.15615647200008
						],
						[
							-82.35331499999995,
							28.156156000000067
						],
						[
							-82.35329899999994,
							28.15423400000003
						],
						[
							-82.35329699999994,
							28.15399300000007
						],
						[
							-82.35327299999994,
							28.151366000000053
						],
						[
							-82.35327199999995,
							28.15086800000006
						],
						[
							-82.35326799999996,
							28.148857000000078
						],
						[
							-82.35324899999995,
							28.146581000000026
						],
						[
							-82.35320599999994,
							28.143533000000048
						],
						[
							-82.35344599999996,
							28.14299600000004
						],
						[
							-82.35384547399997,
							28.14235876400005
						],
						[
							-82.35394499999995,
							28.14220000000006
						],
						[
							-82.35422599999998,
							28.14192200000008
						],
						[
							-82.35959090699998,
							28.136654547000035
						],
						[
							-82.360627272,
							28.135600000000068
						],
						[
							-82.36117272899997,
							28.13506363600004
						],
						[
							-82.36174545499995,
							28.13450000000006
						],
						[
							-82.36295473299998,
							28.133300016000078
						],
						[
							-82.36287272899995,
							28.13318182000006
						],
						[
							-82.36272727299996,
							28.132945456000073
						],
						[
							-82.36263636599995,
							28.132672726000067
						],
						[
							-82.36256363499996,
							28.132318183000052
						],
						[
							-82.36253636499998,
							28.131763636000073
						],
						[
							-82.362449106,
							28.131233260000045
						],
						[
							-82.36316999999997,
							28.13035700000006
						],
						[
							-82.36328799999995,
							28.130348000000026
						],
						[
							-82.36348199999998,
							28.130133000000058
						],
						[
							-82.36365299999994,
							28.129882000000066
						],
						[
							-82.36363699999998,
							28.12979000000007
						],
						[
							-82.36491699999993,
							28.128235000000075
						],
						[
							-82.36655799999994,
							28.126555000000053
						],
						[
							-82.36669299999994,
							28.126417000000064
						],
						[
							-82.36665699999998,
							28.125823000000025
						],
						[
							-82.36662499999994,
							28.12528100000003
						],
						[
							-82.36663099999998,
							28.125184000000047
						],
						[
							-82.36645399999998,
							28.120344000000046
						],
						[
							-82.36670899999996,
							28.120484000000033
						],
						[
							-82.36641399999996,
							28.12023400000004
						],
						[
							-82.36641299999997,
							28.118790000000047
						],
						[
							-82.36556281699995,
							28.11821296200003
						],
						[
							-82.36531804799995,
							28.11730909100004
						],
						[
							-82.36613207999994,
							28.11055009200004
						],
						[
							-82.36989090899993,
							28.117900001000066
						],
						[
							-82.37295454399998,
							28.12306363700003
						],
						[
							-82.37346699399995,
							28.12447458200006
						],
						[
							-82.37376354199995,
							28.125291076000053
						],
						[
							-82.37520204499998,
							28.124984657000027
						],
						[
							-82.38079750199995,
							28.140209150000032
						],
						[
							-82.38374527199994,
							28.144431631000035
						],
						[
							-82.38669599999997,
							28.149392000000034
						],
						[
							-82.38640425199998,
							28.14939741500007
						],
						[
							-82.38577999999995,
							28.149409000000052
						],
						[
							-82.38578273099995,
							28.150100975000043
						],
						[
							-82.38578599999994,
							28.150929000000076
						],
						[
							-82.38578599999994,
							28.151036000000033
						],
						[
							-82.38578699999994,
							28.15114200000005
						],
						[
							-82.38580399999995,
							28.153954000000056
						],
						[
							-82.38623899999999,
							28.15435000000008
						],
						[
							-82.38672599999995,
							28.15479700000003
						],
						[
							-82.38733799999994,
							28.15542800000003
						],
						[
							-82.38791199999997,
							28.156026000000054
						],
						[
							-82.38852399999996,
							28.156743000000063
						],
						[
							-82.38908599999996,
							28.157309000000055
						],
						[
							-82.38951599999996,
							28.157768000000033
						],
						[
							-82.39015399999994,
							28.15845700000006
						],
						[
							-82.39052699999996,
							28.15872600000006
						],
						[
							-82.39089399999995,
							28.159107000000063
						],
						[
							-82.39129899999995,
							28.159466000000066
						],
						[
							-82.39161599999994,
							28.159737000000064
						],
						[
							-82.39188199999995,
							28.159965000000057
						],
						[
							-82.39248799999996,
							28.160518000000025
						],
						[
							-82.39275899999996,
							28.160769000000073
						],
						[
							-82.39312099999995,
							28.16122500000006
						],
						[
							-82.39343999999994,
							28.161677000000054
						],
						[
							-82.39325499999995,
							28.16181800000004
						],
						[
							-82.39320599999996,
							28.161911000000032
						],
						[
							-82.39307699999995,
							28.162117000000023
						],
						[
							-82.39310299999994,
							28.162346000000074
						],
						[
							-82.39330099999995,
							28.162550000000067
						],
						[
							-82.39328999999998,
							28.16265500000003
						],
						[
							-82.39321599999994,
							28.162863000000073
						],
						[
							-82.39315099999999,
							28.16307100000006
						],
						[
							-82.39315199999999,
							28.163374000000033
						],
						[
							-82.39320399999997,
							28.163573000000042
						],
						[
							-82.39330999999999,
							28.16379100000006
						],
						[
							-82.39336599999996,
							28.163999000000047
						],
						[
							-82.39342099999999,
							28.164161000000036
						],
						[
							-82.39344099999994,
							28.16433200000006
						],
						[
							-82.39347799999996,
							28.16451100000006
						],
						[
							-82.39349899999998,
							28.164946000000043
						],
						[
							-82.39343199999996,
							28.165072000000066
						],
						[
							-82.39340799999997,
							28.165114000000074
						],
						[
							-82.39327799999995,
							28.165189000000055
						],
						[
							-82.39266099999998,
							28.165231000000063
						],
						[
							-82.39225899999997,
							28.165233000000057
						],
						[
							-82.39189099999999,
							28.165198000000032
						],
						[
							-82.39167299999998,
							28.165134000000023
						],
						[
							-82.39152099999995,
							28.165031000000056
						],
						[
							-82.39120699999995,
							28.16489100000007
						],
						[
							-82.39085799999998,
							28.16478900000004
						],
						[
							-82.39054199999998,
							28.164777000000072
						],
						[
							-82.39028299999995,
							28.164752000000078
						],
						[
							-82.39007599999997,
							28.164780000000064
						],
						[
							-82.38989299999997,
							28.164870000000064
						],
						[
							-82.38966699999997,
							28.164911000000075
						],
						[
							-82.38947399999995,
							28.165073000000064
						],
						[
							-82.38915299999996,
							28.16531800000007
						],
						[
							-82.38886399999997,
							28.165460000000053
						],
						[
							-82.38857399999995,
							28.165535000000038
						],
						[
							-82.38826399999994,
							28.165593000000058
						],
						[
							-82.38808899999998,
							28.16571600000003
						],
						[
							-82.38753299999996,
							28.166067000000055
						],
						[
							-82.38725199999999,
							28.166221000000064
						],
						[
							-82.38704699999994,
							28.166391000000033
						],
						[
							-82.38685399999997,
							28.16657200000003
						],
						[
							-82.38668699999994,
							28.166889000000026
						],
						[
							-82.38647799999995,
							28.16749200000004
						],
						[
							-82.38612499999994,
							28.168078000000037
						],
						[
							-82.38580699999994,
							28.16841000000005
						],
						[
							-82.38580621399996,
							28.168563362000043
						],
						[
							-82.38580599999995,
							28.16860500000007
						],
						[
							-82.38606799999997,
							28.168606000000068
						],
						[
							-82.38853321499994,
							28.168563911000035
						],
						[
							-82.38855732999997,
							28.168563499000072
						],
						[
							-82.38975799999997,
							28.168543000000057
						],
						[
							-82.38975899999997,
							28.17004600000007
						],
						[
							-82.39193399999994,
							28.170904000000064
						],
						[
							-82.392095,
							28.17094300000008
						],
						[
							-82.39102718799995,
							28.170933734000073
						],
						[
							-82.38967499999995,
							28.170922000000076
						],
						[
							-82.38856599999997,
							28.17090500000006
						],
						[
							-82.38358999999997,
							28.170919000000026
						],
						[
							-82.38305299999996,
							28.170875000000024
						],
						[
							-82.38251299999996,
							28.170806000000027
						],
						[
							-82.38251299999996,
							28.170102000000043
						],
						[
							-82.38214899999997,
							28.170097000000055
						],
						[
							-82.38204385499995,
							28.170079952000037
						],
						[
							-82.38108199999995,
							28.169924000000037
						],
						[
							-82.38115499999998,
							28.17044800000008
						],
						[
							-82.38038499999999,
							28.170290000000023
						],
						[
							-82.38036137699999,
							28.17028923500004
						],
						[
							-82.37985999999997,
							28.170273000000066
						],
						[
							-82.37907299999995,
							28.170083000000034
						],
						[
							-82.37587999999995,
							28.169820000000072
						],
						[
							-82.37554299999994,
							28.169870000000063
						],
						[
							-82.37557299999997,
							28.168863000000048
						],
						[
							-82.37357505099999,
							28.168656182000063
						],
						[
							-82.36810342099994,
							28.168089785000063
						],
						[
							-82.36217399999998,
							28.16747600000008
						],
						[
							-82.36148099999997,
							28.167490000000043
						],
						[
							-82.35977507099994,
							28.171245619000047
						],
						[
							-82.35975899999994,
							28.17128100000008
						],
						[
							-82.35850799999997,
							28.171278000000033
						],
						[
							-82.35714099999996,
							28.171290000000056
						],
						[
							-82.35696699999994,
							28.171291000000053
						],
						[
							-82.35587399999997,
							28.171287000000063
						],
						[
							-82.35574199999996,
							28.171287000000063
						],
						[
							-82.35386499699996,
							28.171280867000064
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "West Meadows",
				"RegionID": "275976"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.59771004399994,
					30.36567292600006,
					-81.57921667799991,
					30.39163932200006
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-81.57988167799994,
								30.382363000000055
							],
							[
								-81.57989533999995,
								30.382206835000094
							],
							[
								-81.57993591299993,
								30.38205541400004
							],
							[
								-81.5799583989999,
								30.382000062000085
							],
							[
								-81.57990911899992,
								30.38194155000008
							],
							[
								-81.57986498999992,
								30.38187906100006
							],
							[
								-81.57982633099994,
								30.381813048000083
							],
							[
								-81.5797934229999,
								30.381743989000082
							],
							[
								-81.57976650299992,
								30.38167238200009
							],
							[
								-81.57974550299991,
								30.381608382000085
							],
							[
								-81.57973111799993,
								30.381551043000055
							],
							[
								-81.57966633899993,
								30.38152083600005
							],
							[
								-81.57953792699993,
								30.381430921000064
							],
							[
								-81.57942707899991,
								30.381320073000044
							],
							[
								-81.57933716399992,
								30.381191661000056
							],
							[
								-81.5792709129999,
								30.381049586000074
							],
							[
								-81.57923033999992,
								30.380898166000065
							],
							[
								-81.57921667799991,
								30.38074200000006
							],
							[
								-81.57921667799991,
								30.380641000000086
							],
							[
								-81.57923033999992,
								30.38048483400007
							],
							[
								-81.5792709129999,
								30.38033341400006
							],
							[
								-81.57933716399992,
								30.38019133900008
							],
							[
								-81.57942707899991,
								30.380062927000044
							],
							[
								-81.57952545099994,
								30.379962743000082
							],
							[
								-81.57964768999994,
								30.379856411000052
							],
							[
								-81.5797823389999,
								30.379761164000058
							],
							[
								-81.5798922159999,
								30.37970986200008
							],
							[
								-81.57995033899994,
								30.379669164000063
							],
							[
								-81.57999176899995,
								30.379646672000035
							],
							[
								-81.58004476899993,
								30.379619671000057
							],
							[
								-81.5800852509999,
								30.37960207100008
							],
							[
								-81.58011516499994,
								30.379540339000076
							],
							[
								-81.58020507999993,
								30.37941192700003
							],
							[
								-81.5803159269999,
								30.37930107900007
							],
							[
								-81.58044433899994,
								30.379211164000083
							],
							[
								-81.58058641399992,
								30.379144913000065
							],
							[
								-81.58073783499992,
								30.379104340000087
							],
							[
								-81.5807768489999,
								30.379098341000088
							],
							[
								-81.58080636099993,
								30.37909446300006
							],
							[
								-81.58086708699994,
								30.37905319500004
							],
							[
								-81.5809311829999,
								30.37901738300008
							],
							[
								-81.58099815799994,
								30.378987299000073
							],
							[
								-81.58106750299994,
								30.378963173000045
							],
							[
								-81.5811386879999,
								30.378945189000035
							],
							[
								-81.58121852199992,
								30.378928283000054
							],
							[
								-81.58124607899994,
								30.37888892700005
							],
							[
								-81.5813601129999,
								30.37877562300008
							],
							[
								-81.58140407899992,
								30.37871492700009
							],
							[
								-81.58151492699994,
								30.37860407900007
							],
							[
								-81.58164333899992,
								30.37851416400008
							],
							[
								-81.58178541399991,
								30.37844791400005
							],
							[
								-81.58185453999994,
								30.37842586900007
							],
							[
								-81.58189602199991,
								30.37841446100009
							],
							[
								-81.58193833899992,
								30.37838616500005
							],
							[
								-81.58198932999994,
								30.37836238700004
							],
							[
								-81.58204824899991,
								30.378314002000085
							],
							[
								-81.58210607199993,
								30.37827029500005
							],
							[
								-81.58216722799996,
								30.37823138700009
							],
							[
								-81.58223131799991,
								30.37819753100007
							],
							[
								-81.5822979269999,
								30.378168945000084
							],
							[
								-81.58236662199994,
								30.37814581700007
							],
							[
								-81.58243695499993,
								30.37812829600006
							],
							[
								-81.58261595599993,
								30.378091296000033
							],
							[
								-81.58264183399992,
								30.378086341000085
							],
							[
								-81.58279799999991,
								30.37807267800008
							],
							[
								-81.5828483279999,
								30.37807267800008
							],
							[
								-81.58293709199995,
								30.378060497000032
							],
							[
								-81.58300847999993,
								30.378027785000082
							],
							[
								-81.58308250699992,
								30.37800158600004
							],
							[
								-81.58315857899993,
								30.377982108000083
							],
							[
								-81.58323608799994,
								30.377969508000035
							],
							[
								-81.58331441199994,
								30.37796388600009
							],
							[
								-81.58339292599995,
								30.377965287000055
							],
							[
								-81.58347099999992,
								30.377973701000084
							],
							[
								-81.58359699999994,
								30.377962678000078
							],
							[
								-81.58369199999993,
								30.377962678000078
							],
							[
								-81.58384816499995,
								30.37797634100008
							],
							[
								-81.5839691729999,
								30.378013872000057
							],
							[
								-81.58397495899993,
								30.377946075000068
							],
							[
								-81.58398733699994,
								30.377879166000074
							],
							[
								-81.58400618699994,
								30.377813785000058
							],
							[
								-81.58403132899991,
								30.377750557000073
							],
							[
								-81.58404434099992,
								30.377601835000064
							],
							[
								-81.58408789799995,
								30.37744245100004
							],
							[
								-81.58412288099994,
								30.377351488000045
							],
							[
								-81.58414989699992,
								30.37728864600007
							],
							[
								-81.58418161199995,
								30.37722803800006
							],
							[
								-81.58421784099994,
								30.377170017000083
							],
							[
								-81.58425837599992,
								30.377114916000043
							],
							[
								-81.58430298099995,
								30.377063057000047
							],
							[
								-81.58435498099993,
								30.37700705700007
							],
							[
								-81.58440330399992,
								30.37695882500009
							],
							[
								-81.58445514599993,
								30.376914399000043
							],
							[
								-81.58451020899992,
								30.376874034000085
							],
							[
								-81.58456817599995,
								30.376837962000085
							],
							[
								-81.58462871199993,
								30.376806391000063
							],
							[
								-81.58474471199992,
								30.376751391000088
							],
							[
								-81.58482241299993,
								30.376718914000037
							],
							[
								-81.58489551899993,
								30.37669578400005
							],
							[
								-81.58503251899992,
								30.376658784000085
							],
							[
								-81.58509067199992,
								30.37664583200007
							],
							[
								-81.58167360399995,
								30.37475218800006
							],
							[
								-81.5812729999999,
								30.373502000000087
							],
							[
								-81.58114204099991,
								30.36988397800008
							],
							[
								-81.57995873399994,
								30.366556023000044
							],
							[
								-81.58019986799991,
								30.36567292600006
							],
							[
								-81.58040590999991,
								30.365675012000054
							],
							[
								-81.58064990999992,
								30.36570501200004
							],
							[
								-81.58119190999992,
								30.365837012000043
							],
							[
								-81.58135990999995,
								30.36588301200004
							],
							[
								-81.58146594199991,
								30.365896935000084
							],
							[
								-81.58231185599993,
								30.366514178000042
							],
							[
								-81.58240490899993,
								30.36651201200004
							],
							[
								-81.5834749089999,
								30.366506012000062
							],
							[
								-81.58358090899992,
								30.366505012000065
							],
							[
								-81.5843509099999,
								30.366489012000045
							],
							[
								-81.5848269089999,
								30.366478013000066
							],
							[
								-81.58524390999992,
								30.366470012000036
							],
							[
								-81.58589490899993,
								30.366470012000036
							],
							[
								-81.5861329089999,
								30.36646001300005
							],
							[
								-81.58702090999992,
								30.366449012000093
							],
							[
								-81.58790590399991,
								30.366447064000052
							],
							[
								-81.58877590799995,
								30.36642801000005
							],
							[
								-81.5896049079999,
								30.36641201000009
							],
							[
								-81.59028790699995,
								30.36639901000007
							],
							[
								-81.59167490699991,
								30.366397010000075
							],
							[
								-81.59250990699991,
								30.36638301000005
							],
							[
								-81.59386990799993,
								30.36636301000004
							],
							[
								-81.59510790699994,
								30.366344010000034
							],
							[
								-81.59670988099992,
								30.366305948000047
							],
							[
								-81.59672290799995,
								30.366899010000054
							],
							[
								-81.59673290799992,
								30.367344011000057
							],
							[
								-81.5967459069999,
								30.36783501000008
							],
							[
								-81.59677090799994,
								30.368759010000076
							],
							[
								-81.5967859079999,
								30.36953501100004
							],
							[
								-81.5968089079999,
								30.369747010000083
							],
							[
								-81.59680190799993,
								30.37001001100009
							],
							[
								-81.5968089079999,
								30.370867011000087
							],
							[
								-81.59681690699996,
								30.370981012000072
							],
							[
								-81.59683990799994,
								30.372129011000084
							],
							[
								-81.59686290699995,
								30.373289010000068
							],
							[
								-81.59688585399994,
								30.37431501700007
							],
							[
								-81.59689291099994,
								30.37477701000006
							],
							[
								-81.59693090999991,
								30.37494501000009
							],
							[
								-81.59698504099993,
								30.375064989000066
							],
							[
								-81.59698473799995,
								30.37511309500007
							],
							[
								-81.5970309089999,
								30.37514701500004
							],
							[
								-81.59709891099993,
								30.375235012000076
							],
							[
								-81.5972059099999,
								30.375330012000063
							],
							[
								-81.59730490999993,
								30.37540401200005
							],
							[
								-81.5974959099999,
								30.375523011000045
							],
							[
								-81.5975489089999,
								30.375546013000076
							],
							[
								-81.59764909099994,
								30.375607978000065
							],
							[
								-81.59739690999993,
								30.375940013000047
							],
							[
								-81.5972289099999,
								30.37624401200009
							],
							[
								-81.59716791099994,
								30.376377012000034
							],
							[
								-81.59712190999994,
								30.376518012000076
							],
							[
								-81.59705390999994,
								30.37682301200004
							],
							[
								-81.59703790999993,
								30.37696501200008
							],
							[
								-81.59703791099992,
								30.37715001200007
							],
							[
								-81.59705390999994,
								30.377247013000044
							],
							[
								-81.59711504299992,
								30.37763601300009
							],
							[
								-81.59707790899995,
								30.377793012000044
							],
							[
								-81.5970479099999,
								30.37786901300007
							],
							[
								-81.59702291199994,
								30.37797201400008
							],
							[
								-81.59704590899992,
								30.378695013000083
							],
							[
								-81.59706090899994,
								30.379005013000043
							],
							[
								-81.59706091099991,
								30.379328012000087
							],
							[
								-81.59706891099995,
								30.379374011000035
							],
							[
								-81.5970918399999,
								30.379431059000066
							],
							[
								-81.59719790999992,
								30.379532013000073
							],
							[
								-81.59761790899995,
								30.379885013000038
							],
							[
								-81.59765590699993,
								30.379929012000048
							],
							[
								-81.59767190699995,
								30.379961011000034
							],
							[
								-81.59768690899995,
								30.380064012000048
							],
							[
								-81.59771004399994,
								30.38081714400005
							],
							[
								-81.59507799999994,
								30.38084800000007
							],
							[
								-81.59452095599994,
								30.38157961200005
							],
							[
								-81.59451611799994,
								30.381573983000063
							],
							[
								-81.59445192399994,
								30.38154240900008
							],
							[
								-81.59130455399992,
								30.379941474000077
							],
							[
								-81.59058827399991,
								30.379753936000046
							],
							[
								-81.59041756499994,
								30.37973247000008
							],
							[
								-81.59030116499991,
								30.37976365900005
							],
							[
								-81.59014499999995,
								30.379777322000052
							],
							[
								-81.58998883399994,
								30.37976365900005
							],
							[
								-81.58983741299994,
								30.379723086000073
							],
							[
								-81.58981556099991,
								30.379714809000063
							],
							[
								-81.58939902599991,
								30.37955082600007
							],
							[
								-81.58881012299992,
								30.37940948900007
							],
							[
								-81.58871241399993,
								30.379380086000083
							],
							[
								-81.58857033899996,
								30.37931383600005
							],
							[
								-81.5884419269999,
								30.37922392100006
							],
							[
								-81.58833107899994,
								30.379113073000045
							],
							[
								-81.5882411639999,
								30.378984661000064
							],
							[
								-81.58817491399992,
								30.378842586000076
							],
							[
								-81.58816932899992,
								30.37882174500004
							],
							[
								-81.58804910799995,
								30.37875768900005
							],
							[
								-81.58798927299995,
								30.37872278500004
							],
							[
								-81.58793230299995,
								30.37868338000004
							],
							[
								-81.58787853399991,
								30.378639706000058
							],
							[
								-81.58757453499993,
								30.37837270600005
							],
							[
								-81.58750942199993,
								30.378309417000082
							],
							[
								-81.58717832299993,
								30.37795336200008
							],
							[
								-81.5869751809999,
								30.377813165000074
							],
							[
								-81.58691708899994,
								30.377770433000084
							],
							[
								-81.58686300699992,
								30.37772272700005
							],
							[
								-81.5868133589999,
								30.377670421000058
							],
							[
								-81.58676853599991,
								30.377613926000038
							],
							[
								-81.58672888899991,
								30.377553686000056
							],
							[
								-81.58646535399993,
								30.377407643000083
							],
							[
								-81.58649472099997,
								30.377469324000064
							],
							[
								-81.58651818999994,
								30.37753348200005
							],
							[
								-81.5865355549999,
								30.377599554000085
							],
							[
								-81.58654666399991,
								30.37766696000006
							],
							[
								-81.5866161539999,
								30.377775171000053
							],
							[
								-81.58668292099992,
								30.37784392700007
							],
							[
								-81.58677253699996,
								30.377971823000053
							],
							[
								-81.5868160899999,
								30.378047144000053
							],
							[
								-81.58686008699993,
								30.378098583000053
							],
							[
								-81.58690882099995,
								30.378161535000057
							],
							[
								-81.58695179599994,
								30.378228550000074
							],
							[
								-81.58698867499993,
								30.378299104000064
							],
							[
								-81.5870191699999,
								30.378372643000038
							],
							[
								-81.58704303999991,
								30.378448591000048
							],
							[
								-81.58706009999992,
								30.378526353000044
							],
							[
								-81.58707021599992,
								30.378605319000087
							],
							[
								-81.5870802149999,
								30.37872531800008
							],
							[
								-81.5870833219999,
								30.37880000000007
							],
							[
								-81.58707686499991,
								30.378907569000035
							],
							[
								-81.58706686599993,
								30.37899056900005
							],
							[
								-81.58705965899992,
								30.37903916600004
							],
							[
								-81.58701908599994,
								30.379190586000053
							],
							[
								-81.58695283599991,
								30.379332661000035
							],
							[
								-81.58686292099992,
								30.379461073000073
							],
							[
								-81.5867520729999,
								30.379571921000032
							],
							[
								-81.58663806999994,
								30.379651746000036
							],
							[
								-81.58676558599991,
								30.379685914000053
							],
							[
								-81.58690766099994,
								30.37975216500007
							],
							[
								-81.58703607299992,
								30.379842080000056
							],
							[
								-81.58714691999995,
								30.37995292700009
							],
							[
								-81.58723683499994,
								30.38008133900007
							],
							[
								-81.5873030859999,
								30.38022341400006
							],
							[
								-81.58734365899994,
								30.380374835000055
							],
							[
								-81.58735732199995,
								30.380531000000076
							],
							[
								-81.58734930099992,
								30.380650838000065
							],
							[
								-81.58732842999991,
								30.380806069000073
							],
							[
								-81.5873622179999,
								30.38087628400007
							],
							[
								-81.58738951099993,
								30.38094926900004
							],
							[
								-81.58741008699991,
								30.381024424000092
							],
							[
								-81.58742377599992,
								30.38110113400006
							],
							[
								-81.58743046599994,
								30.38117876700005
							],
							[
								-81.58743277899993,
								30.381204610000054
							],
							[
								-81.58747465999994,
								30.381358834000082
							],
							[
								-81.5874883219999,
								30.381522000000075
							],
							[
								-81.58747465999994,
								30.38168516500008
							],
							[
								-81.5874340869999,
								30.381836586000077
							],
							[
								-81.58736783599994,
								30.381978661000066
							],
							[
								-81.58727792099997,
								30.382107073000043
							],
							[
								-81.58716707299993,
								30.382217920000073
							],
							[
								-81.58703866099995,
								30.382307835000066
							],
							[
								-81.5868965869999,
								30.382374086000084
							],
							[
								-81.58686589099995,
								30.382384671000068
							],
							[
								-81.58679444699993,
								30.382405907000074
							],
							[
								-81.58672149199992,
								30.382421157000067
							],
							[
								-81.58664752399994,
								30.382430316000068
							],
							[
								-81.58657305199995,
								30.382433321000065
							],
							[
								-81.58649858699994,
								30.38243015300009
							],
							[
								-81.5864246399999,
								30.382420832000033
							],
							[
								-81.58623123699994,
								30.382388246000062
							],
							[
								-81.58607641399993,
								30.382347086000042
							],
							[
								-81.5859667069999,
								30.382298648000074
							],
							[
								-81.58593529599995,
								30.382283817000086
							],
							[
								-81.58582259799994,
								30.38231331700007
							],
							[
								-81.58578037299992,
								30.382321129000044
							],
							[
								-81.58572183599995,
								30.382446661000078
							],
							[
								-81.58568647399994,
								30.38250510200004
							],
							[
								-81.5856716589999,
								30.382667165000043
							],
							[
								-81.58566174999993,
								30.382715553000082
							],
							[
								-81.5856297499999,
								30.382852553000077
							],
							[
								-81.58561310699992,
								30.382915758000085
							],
							[
								-81.58559158299994,
								30.38297747200005
							],
							[
								-81.58556530899995,
								30.38303731900004
							],
							[
								-81.58553444499995,
								30.383094933000056
							],
							[
								-81.5854991789999,
								30.38314996200006
							],
							[
								-81.5854597259999,
								30.383202072000074
							],
							[
								-81.58543365799994,
								30.383274210000078
							],
							[
								-81.58540143099992,
								30.38334381400006
							],
							[
								-81.58536328699995,
								30.383410360000084
							],
							[
								-81.58531951499992,
								30.383473347000066
							],
							[
								-81.58527044399995,
								30.38353229900008
							],
							[
								-81.58528532199995,
								30.383693000000054
							],
							[
								-81.58528309499991,
								30.383756260000045
							],
							[
								-81.58527209399995,
								30.383912260000045
							],
							[
								-81.58526065899991,
								30.384005166000065
							],
							[
								-81.5852519739999,
								30.384037773000045
							],
							[
								-81.5852528389999,
								30.384116480000046
							],
							[
								-81.58524681799992,
								30.38419496100005
							],
							[
								-81.58523395799995,
								30.38427261600009
							],
							[
								-81.58521435699993,
								30.38434884800006
							],
							[
								-81.58517235699992,
								30.38448684800005
							],
							[
								-81.58516230099991,
								30.384516968000074
							],
							[
								-81.58530257699994,
								30.38459696800004
							],
							[
								-81.58543307299993,
								30.384688079000053
							],
							[
								-81.5854871009999,
								30.38473729000009
							],
							[
								-81.58557110099991,
								30.38482029000005
							],
							[
								-81.58562791999992,
								30.38488192700004
							],
							[
								-81.5857178359999,
								30.385010339000075
							],
							[
								-81.58578408599993,
								30.385152414000064
							],
							[
								-81.58582465899991,
								30.38530383400007
							],
							[
								-81.58583832199993,
								30.38546000000008
							],
							[
								-81.58583832199993,
								30.385506000000078
							],
							[
								-81.58582465899991,
								30.385662166000092
							],
							[
								-81.58578103199994,
								30.385815725000043
							],
							[
								-81.58585883599994,
								30.385933339000076
							],
							[
								-81.58588277799993,
								30.385984683000064
							],
							[
								-81.58597266099991,
								30.38602816400004
							],
							[
								-81.58610107299995,
								30.386118079000084
							],
							[
								-81.58621191999993,
								30.386228927000047
							],
							[
								-81.58630183499992,
								30.386357339000085
							],
							[
								-81.58635247599994,
								30.386459510000066
							],
							[
								-81.58638347599992,
								30.386533510000053
							],
							[
								-81.58640840899994,
								30.38660034700007
							],
							[
								-81.58642796499993,
								30.38666895000006
							],
							[
								-81.5864420229999,
								30.386738888000078
							],
							[
								-81.58645049299992,
								30.38680972000009
							],
							[
								-81.5864533219999,
								30.386881000000077
							],
							[
								-81.5864533219999,
								30.386992000000077
							],
							[
								-81.58643965999995,
								30.38714816500004
							],
							[
								-81.58641428999994,
								30.38724284600005
							],
							[
								-81.58641037899991,
								30.38732817400006
							],
							[
								-81.58639765899994,
								30.387443165000036
							],
							[
								-81.58637235799995,
								30.387548848000055
							],
							[
								-81.58633035799994,
								30.387686848000044
							],
							[
								-81.5863150859999,
								30.387732586000084
							],
							[
								-81.58626625699992,
								30.38784303600005
							],
							[
								-81.58614025699991,
								30.38808303600007
							],
							[
								-81.58610378599991,
								30.388146181000085
							],
							[
								-81.5860623019999,
								30.388206152000066
							],
							[
								-81.58601607999992,
								30.38826255200007
							],
							[
								-81.58596542499993,
								30.388315007000074
							],
							[
								-81.58591067399993,
								30.388363171000037
							],
							[
								-81.58585218799993,
								30.38840672300006
							],
							[
								-81.58579035499992,
								30.38844537700004
							],
							[
								-81.58571692099991,
								30.388547073000044
							],
							[
								-81.58562247799995,
								30.38864381600007
							],
							[
								-81.58558047799994,
								30.38868081600009
							],
							[
								-81.58552522799994,
								30.38872576300008
							],
							[
								-81.58546657499996,
								30.388766170000054
							],
							[
								-81.58540489199993,
								30.38880177900006
							],
							[
								-81.58534056999991,
								30.388832364000056
							],
							[
								-81.5852740169999,
								30.388857732000076
							],
							[
								-81.58520565599991,
								30.38887772200008
							],
							[
								-81.58513591999991,
								30.38889220500005
							],
							[
								-81.58507176799993,
								30.388923263000038
							],
							[
								-81.58500535999991,
								30.388949148000055
							],
							[
								-81.58493711299991,
								30.38896969800004
							],
							[
								-81.58486745399995,
								30.38898478500005
							],
							[
								-81.5847968189999,
								30.388994314000062
							],
							[
								-81.58460681899994,
								30.389012313000084
							],
							[
								-81.58453596599992,
								30.389016214000034
							],
							[
								-81.58446502499993,
								30.38901451600009
							],
							[
								-81.58439443999993,
								30.38900723000006
							],
							[
								-81.58432464799995,
								30.38899440100005
							],
							[
								-81.58425608499994,
								30.388976110000044
							],
							[
								-81.58415984699991,
								30.38894632200004
							],
							[
								-81.5840608339999,
								30.388937659000078
							],
							[
								-81.58396993899993,
								30.388916720000058
							],
							[
								-81.58390693799993,
								30.388898720000043
							],
							[
								-81.58383808399992,
								30.388876008000068
							],
							[
								-81.58377128399991,
								30.38884782300005
							],
							[
								-81.58370697099991,
								30.388814349000086
							],
							[
								-81.58364556299995,
								30.388775803000044
							],
							[
								-81.58358745999993,
								30.38873243600006
							],
							[
								-81.58353303899992,
								30.388684529000045
							],
							[
								-81.58346252699994,
								30.388617222000054
							],
							[
								-81.58336733899995,
								30.388572835000048
							],
							[
								-81.58327133699993,
								30.388508865000066
							],
							[
								-81.5831023369999,
								30.388379865000044
							],
							[
								-81.58304718099993,
								30.388334178000036
							],
							[
								-81.58299583599995,
								30.38828424500008
							],
							[
								-81.58294862799994,
								30.388230384000057
							],
							[
								-81.58290585799996,
								30.388172936000046
							],
							[
								-81.58286779499991,
								30.388112267000054
							],
							[
								-81.5827800799999,
								30.388022073000062
							],
							[
								-81.58273318599993,
								30.387961066000063
							],
							[
								-81.58271998999993,
								30.387942287000048
							],
							[
								-81.58266060299991,
								30.38788009900009
							],
							[
								-81.58261995399994,
								30.387834038000047
							],
							[
								-81.5825760919999,
								30.387811824000043
							],
							[
								-81.5825077149999,
								30.387773329000083
							],
							[
								-81.58237492699993,
								30.387680920000037
							],
							[
								-81.58226386399991,
								30.387569816000052
							],
							[
								-81.58223264899993,
								30.38753255900008
							],
							[
								-81.58219234199994,
								30.387484489000084
							],
							[
								-81.58215637099994,
								30.38743309300008
							],
							[
								-81.58212500999991,
								30.387378761000033
							],
							[
								-81.58209849699995,
								30.38732190700006
							],
							[
								-81.58207703199992,
								30.387262960000044
							],
							[
								-81.5820607789999,
								30.387202369000075
							],
							[
								-81.5820214979999,
								30.387148351000068
							],
							[
								-81.58198652499993,
								30.387091448000035
							],
							[
								-81.58195607099994,
								30.387032005000034
							],
							[
								-81.58193031799993,
								30.386970378000058
							],
							[
								-81.58190942199991,
								30.386906941000063
							],
							[
								-81.58189350899995,
								30.386842073000082
							],
							[
								-81.58187250899994,
								30.386741073000053
							],
							[
								-81.58186733999992,
								30.386714166000047
							],
							[
								-81.5818608049999,
								30.38663946800006
							],
							[
								-81.58184165499995,
								30.386565884000053
							],
							[
								-81.5818290709999,
								30.386490898000094
							],
							[
								-81.58182314899994,
								30.38641509400009
							],
							[
								-81.58182393699991,
								30.38633906300004
							],
							[
								-81.58183142699994,
								30.38626339800004
							],
							[
								-81.58184556299994,
								30.38618868900005
							],
							[
								-81.58186623299991,
								30.38611551800005
							],
							[
								-81.58188723299992,
								30.38605051800005
							],
							[
								-81.58189791399991,
								30.38601941400009
							],
							[
								-81.58194638899994,
								30.38591545900005
							],
							[
								-81.58194034099995,
								30.38589017000004
							],
							[
								-81.58192733899995,
								30.38583325200005
							],
							[
								-81.58191903399995,
								30.385775461000037
							],
							[
								-81.58191548199994,
								30.38571718500009
							],
							[
								-81.58191670699995,
								30.385658814000067
							],
							[
								-81.58192269999995,
								30.38560073800005
							],
							[
								-81.58189041399993,
								30.385592087000077
							],
							[
								-81.58184373699994,
								30.385573607000083
							],
							[
								-81.58178073699992,
								30.385546606000048
							],
							[
								-81.58172111499994,
								30.385518423000065
							],
							[
								-81.58166371899995,
								30.385485947000063
							],
							[
								-81.58160885799992,
								30.385449352000077
							],
							[
								-81.58155682499995,
								30.385408835000074
							],
							[
								-81.58150790199994,
								30.385364614000082
							],
							[
								-81.5811399019999,
								30.385006614000073
							],
							[
								-81.58107807999994,
								30.38494007300005
							],
							[
								-81.58098521199992,
								30.384805458000077
							],
							[
								-81.58093158999992,
								30.384747700000045
							],
							[
								-81.58088332499995,
								30.384685395000076
							],
							[
								-81.58084080299994,
								30.38461903800004
							],
							[
								-81.58080435999995,
								30.384549158000087
							],
							[
								-81.58077428699994,
								30.384476309000036
							],
							[
								-81.5807508229999,
								30.384401071000074
							],
							[
								-81.5807341549999,
								30.384324042000063
							],
							[
								-81.58069091399994,
								30.38422958600006
							],
							[
								-81.58064973599994,
								30.38407125600008
							],
							[
								-81.58063607899994,
								30.384051073000077
							],
							[
								-81.58054616399994,
								30.383922661000042
							],
							[
								-81.58047991299992,
								30.38378058600006
							],
							[
								-81.58043933999994,
								30.38362916600005
							],
							[
								-81.58042567799993,
								30.383473000000038
							],
							[
								-81.58042567799993,
								30.38342700000004
							],
							[
								-81.58043556399991,
								30.383313996000084
							],
							[
								-81.58041208899994,
								30.38328295200006
							],
							[
								-81.5803025489999,
								30.383177143000072
							],
							[
								-81.58023707899991,
								30.38310707300008
							],
							[
								-81.58019503799994,
								30.383047032000036
							],
							[
								-81.58010107899992,
								30.382953073000067
							],
							[
								-81.5800660619999,
								30.38290861900009
							],
							[
								-81.58000216399995,
								30.38281266100006
							],
							[
								-81.57993591299993,
								30.382670586000074
							],
							[
								-81.57989533999995,
								30.38251916600007
							],
							[
								-81.57988167799994,
								30.382363000000055
							]
						]
					],
					[
						[
							[
								-81.5865148339999,
								30.389403340000058
							],
							[
								-81.58667099999991,
								30.389389678000043
							],
							[
								-81.58672816799992,
								30.389391496000087
							],
							[
								-81.58688516799992,
								30.389401497000048
							],
							[
								-81.58695603899992,
								30.389409305000072
							],
							[
								-81.58702613299994,
								30.38942235600007
							],
							[
								-81.58709506399993,
								30.38944058000004
							],
							[
								-81.58716244999994,
								30.389463875000047
							],
							[
								-81.58724028099994,
								30.389466963000075
							],
							[
								-81.58731754999991,
								30.38947678700003
							],
							[
								-81.5873936779999,
								30.38949327100005
							],
							[
								-81.5874680899999,
								30.389516293000046
							],
							[
								-81.58754022599993,
								30.38954567800005
							],
							[
								-81.58760954299993,
								30.389581205000074
							],
							[
								-81.58767551999995,
								30.38962260800008
							],
							[
								-81.5877376599999,
								30.38966957300005
							],
							[
								-81.58791836599994,
								30.389818826000067
							],
							[
								-81.58797530099991,
								30.38987049400004
							],
							[
								-81.58802761499993,
								30.389926837000075
							],
							[
								-81.5880749239999,
								30.38998744200006
							],
							[
								-81.58811688299996,
								30.39005186800006
							],
							[
								-81.58815318599994,
								30.390119642000055
							],
							[
								-81.58820618499993,
								30.390229642000065
							],
							[
								-81.58824108599993,
								30.390312414000046
							],
							[
								-81.5882816589999,
								30.39046383500005
							],
							[
								-81.58829532199991,
								30.390620000000073
							],
							[
								-81.5882816589999,
								30.390776166000084
							],
							[
								-81.58824108599993,
								30.390927587000082
							],
							[
								-81.58820755699992,
								30.391007500000057
							],
							[
								-81.58815455699994,
								30.391118499000072
							],
							[
								-81.58812183599991,
								30.391180661000075
							],
							[
								-81.58803192099992,
								30.391309073000063
							],
							[
								-81.58792107299992,
								30.391419921000082
							],
							[
								-81.58779266099992,
								30.39150983600007
							],
							[
								-81.58765058599994,
								30.391576086000047
							],
							[
								-81.58749916599993,
								30.39161665900008
							],
							[
								-81.58736566399995,
								30.391630037000088
							],
							[
								-81.58700866299995,
								30.391639036000072
							],
							[
								-81.58698599999991,
								30.39163932200006
							],
							[
								-81.5868298339999,
								30.39162565900006
							],
							[
								-81.5866784129999,
								30.39158508600008
							],
							[
								-81.58665095099991,
								30.391574579000064
							],
							[
								-81.58654132399994,
								30.39153030900008
							],
							[
								-81.58651426199994,
								30.39151887700007
							],
							[
								-81.58642912399995,
								30.391479297000046
							],
							[
								-81.58639919199993,
								30.391464113000044
							],
							[
								-81.58621874099993,
								30.391369086000054
							],
							[
								-81.58618933899993,
								30.391352836000067
							],
							[
								-81.58606092699995,
								30.391262921000077
							],
							[
								-81.58595007899993,
								30.391152073000057
							],
							[
								-81.58586016399994,
								30.39102366100008
							],
							[
								-81.58579391399991,
								30.390881586000035
							],
							[
								-81.58575334099993,
								30.390730166000086
							],
							[
								-81.58573967799992,
								30.390574000000075
							],
							[
								-81.58573967799992,
								30.390418000000068
							],
							[
								-81.58575334099993,
								30.390261834000057
							],
							[
								-81.58576613199995,
								30.39020147800005
							],
							[
								-81.58579813199992,
								30.390072477000047
							],
							[
								-81.58582591299995,
								30.389981413000044
							],
							[
								-81.58589216399992,
								30.389839339000048
							],
							[
								-81.5859820789999,
								30.38971092700007
							],
							[
								-81.58609292699994,
								30.38960007900005
							],
							[
								-81.5862213389999,
								30.389510164000058
							],
							[
								-81.5863634129999,
								30.389443913000036
							],
							[
								-81.5865148339999,
								30.389403340000058
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Woodmere",
				"RegionID": "276144"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.80687727499992,
					26.11944928400007,
					-81.79047288499974,
					26.13085110200004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.79415815999995,
							26.129131308000026
						],
						[
							-81.79394410999963,
							26.129018370000097
						],
						[
							-81.79371272499985,
							26.12944583400047
						],
						[
							-81.79364715699984,
							26.12961917500016
						],
						[
							-81.79358483599992,
							26.129750661000024
						],
						[
							-81.79350990399976,
							26.12986073200016
						],
						[
							-81.7934439039999,
							26.1299437320001
						],
						[
							-81.79339614499986,
							26.129999023000146
						],
						[
							-81.7933440569999,
							26.13005025500012
						],
						[
							-81.7932879809997,
							26.130097090000177
						],
						[
							-81.79322828899973,
							26.130139218000288
						],
						[
							-81.79316537399977,
							26.130176362000164
						],
						[
							-81.79297537499986,
							26.130278362000077
						],
						[
							-81.79286655699991,
							26.130327767000168
						],
						[
							-81.79274507199972,
							26.130373426000126
						],
						[
							-81.79258916599979,
							26.130415659000157
						],
						[
							-81.79243299999983,
							26.130429322000133
						],
						[
							-81.79219999999974,
							26.130429322000133
						],
						[
							-81.79208782499978,
							26.130422298000262
						],
						[
							-81.79191282499987,
							26.130400298000044
						],
						[
							-81.79184146199974,
							26.1303883940003
						],
						[
							-81.79177128599962,
							26.130370791000352
						],
						[
							-81.79170275199981,
							26.13034760400012
						],
						[
							-81.79163630399972,
							26.130318984000063
						],
						[
							-81.79157237199978,
							26.130285115000014
						],
						[
							-81.79151136899969,
							26.130246216000437
						],
						[
							-81.7914536909999,
							26.13020253900011
						],
						[
							-81.79132630899974,
							26.130097730000053
						],
						[
							-81.79127597799985,
							26.13005261900014
						],
						[
							-81.7912291779998,
							26.1300038540001
						],
						[
							-81.79118617399979,
							26.129951711000494
						],
						[
							-81.79114720699977,
							26.129896486000455
						],
						[
							-81.79111249899982,
							26.129838489000186
						],
						[
							-81.79094849899984,
							26.129539489000138
						],
						[
							-81.79089191299987,
							26.129414586000017
						],
						[
							-81.7908813439997,
							26.129383827000048
						],
						[
							-81.79082376699982,
							26.129205859000244
						],
						[
							-81.79081090999965,
							26.129173076000107
						],
						[
							-81.79075501599984,
							26.129109003000046
						],
						[
							-81.7906591649998,
							26.128973661000217
						],
						[
							-81.79063485299991,
							26.128928642000133
						],
						[
							-81.79056885299978,
							26.12879764200013
						],
						[
							-81.79053605199982,
							26.128724619000042
						],
						[
							-81.79050987399988,
							26.128648968999997
						],
						[
							-81.79049052799961,
							26.128571290000053
						],
						[
							-81.79047816599984,
							26.12849219900017
						],
						[
							-81.79047288499974,
							26.12841232100049
						],
						[
							-81.79047472899981,
							26.12833229100044
						],
						[
							-81.79048368299993,
							26.12825274100043
						],
						[
							-81.79050001099995,
							26.128149788000172
						],
						[
							-81.79051464999974,
							26.12807949700013
						],
						[
							-81.79053485199981,
							26.128010599000113
						],
						[
							-81.7905604879998,
							26.12794353300007
						],
						[
							-81.79059139499978,
							26.127878727000216
						],
						[
							-81.79062737499974,
							26.127816594000137
						],
						[
							-81.79066819999983,
							26.12775753100049
						],
						[
							-81.79064553399974,
							26.127471620000016
						],
						[
							-81.79064267799976,
							26.12740000000013
						],
						[
							-81.79064769399973,
							26.127305146000097
						],
						[
							-81.79066169499991,
							26.1271731450001
						],
						[
							-81.79067034099965,
							26.127111834000093
						],
						[
							-81.79070115599971,
							26.126996832000167
						],
						[
							-81.79068795599977,
							26.126466371000063
						],
						[
							-81.79069073799982,
							26.126369871000076
						],
						[
							-81.79070173899976,
							26.126236870000348
						],
						[
							-81.79071234099966,
							26.12615483400031
						],
						[
							-81.79075291399982,
							26.126003413000483
						],
						[
							-81.7908191649997,
							26.125861339000096
						],
						[
							-81.79090907999986,
							26.12573292700013
						],
						[
							-81.79101992699962,
							26.125622079000372
						],
						[
							-81.79107113199977,
							26.12558217200018
						],
						[
							-81.7911541309998,
							26.12552217200001
						],
						[
							-81.7912313389998,
							26.125472164000136
						],
						[
							-81.79135850899983,
							26.125411488000445
						],
						[
							-81.79150051499977,
							26.125356938000373
						],
						[
							-81.79153344399994,
							26.125342266000047
						],
						[
							-81.79156674099974,
							26.125309682000193
						],
						[
							-81.7916083309999,
							26.12525796700009
						],
						[
							-81.79173884799978,
							26.12495454900039
						],
						[
							-81.79180107499968,
							26.124767870000305
						],
						[
							-81.7919431519998,
							26.124081319000076
						],
						[
							-81.79208921899964,
							26.123278934000034
						],
						[
							-81.7921289139998,
							26.123132414000168
						],
						[
							-81.7921629079998,
							26.123055721000128
						],
						[
							-81.79202859299986,
							26.122164446000014
						],
						[
							-81.79196281299974,
							26.121797821000143
						],
						[
							-81.79194869699982,
							26.121644849000454
						],
						[
							-81.79194221199973,
							26.120647820000116
						],
						[
							-81.7919021639998,
							26.120587661000023
						],
						[
							-81.79183499099973,
							26.120443028000402
						],
						[
							-81.79181906899976,
							26.120398470000445
						],
						[
							-81.79179851599974,
							26.120333174000017
						],
						[
							-81.79178298899978,
							26.120266504000362
						],
						[
							-81.79177257799981,
							26.12019884600027
						],
						[
							-81.79176734399982,
							26.12013059200013
						],
						[
							-81.79176731599982,
							26.120062138000154
						],
						[
							-81.79177249499982,
							26.11999388000001
						],
						[
							-81.79177649499978,
							26.119958880000134
						],
						[
							-81.7917842299997,
							26.119899049000246
						],
						[
							-81.79179683699986,
							26.11984005200025
						],
						[
							-81.7918142319998,
							26.11978228600009
						],
						[
							-81.79183629799967,
							26.11972613700015
						],
						[
							-81.79186288599973,
							26.11967198300011
						],
						[
							-81.79184534399988,
							26.119648302000197
						],
						[
							-81.7926496059999,
							26.11974402800012
						],
						[
							-81.79350470799996,
							26.11979507900017
						],
						[
							-81.79439809799989,
							26.11979507900017
						],
						[
							-81.79512557299995,
							26.11979507900017
						],
						[
							-81.79563608199992,
							26.11979507900017
						],
						[
							-81.79637631899988,
							26.11979507900017
						],
						[
							-81.7970399809999,
							26.11978231600009
						],
						[
							-81.79746114999993,
							26.119807842000075
						],
						[
							-81.79794613299991,
							26.11989718100009
						],
						[
							-81.79818862499991,
							26.11990994300008
						],
						[
							-81.79849492999993,
							26.11982060400006
						],
						[
							-81.79880123499987,
							26.11979507900017
						],
						[
							-81.79922240499991,
							26.11978231600009
						],
						[
							-81.79955423599984,
							26.11987165500011
						],
						[
							-81.79972028463804,
							26.11967092812126
						],
						[
							-81.79977366199995,
							26.119542490000143
						],
						[
							-81.80014612199996,
							26.11950524400008
						],
						[
							-81.80162354699989,
							26.1194990360001
						],
						[
							-81.8032809949999,
							26.11946799800002
						],
						[
							-81.80490869299983,
							26.11945598500018
						],
						[
							-81.80581670999993,
							26.11944928400007
						],
						[
							-81.80582374399988,
							26.11949709900003
						],
						[
							-81.80582863499966,
							26.119536305000075
						],
						[
							-81.8059806349998,
							26.121019305000033
						],
						[
							-81.80598348999978,
							26.12105362500003
						],
						[
							-81.80601148999978,
							26.12149162500021
						],
						[
							-81.80601331299975,
							26.12155315400042
						],
						[
							-81.80600945599979,
							26.12238803400004
						],
						[
							-81.80606748299988,
							26.12328556800005
						],
						[
							-81.80624059499972,
							26.124586328000206
						],
						[
							-81.80629867299973,
							26.124938307000107
						],
						[
							-81.80634605799975,
							26.12526525000007
						],
						[
							-81.80634960699979,
							26.125292779000127
						],
						[
							-81.80644817199985,
							26.126162933000003
						],
						[
							-81.80650724299994,
							26.126647120000364
						],
						[
							-81.80658150799978,
							26.12714450500004
						],
						[
							-81.80672980899979,
							26.128142547000373
						],
						[
							-81.80684383099981,
							26.128930933000056
						],
						[
							-81.80687727499992,
							26.129101320000032
						],
						[
							-81.80598807099989,
							26.129240293000073
						],
						[
							-81.80536595699994,
							26.129382465000113
						],
						[
							-81.80446999899995,
							26.129459999000133
						],
						[
							-81.8029599989999,
							26.129579999000114
						],
						[
							-81.80160999899992,
							26.129699999000096
						],
						[
							-81.80052602899985,
							26.12979225200018
						],
						[
							-81.8001999989998,
							26.129820000000166
						],
						[
							-81.7998081469998,
							26.129850788000052
						],
						[
							-81.79879999999986,
							26.12992999900012
						],
						[
							-81.79740999899987,
							26.1300499990001
						],
						[
							-81.79609177299996,
							26.130162870000113
						],
						[
							-81.79600984999985,
							26.130169884000164
						],
						[
							-81.79607465599987,
							26.130701201000157
						],
						[
							-81.79482713999995,
							26.13079256700008
						],
						[
							-81.79391789799986,
							26.13085110200004
						],
						[
							-81.7938709889998,
							26.13050918500008
						],
						[
							-81.79386217799969,
							26.130434019000077
						],
						[
							-81.79384117899973,
							26.130153020000186
						],
						[
							-81.79383867799979,
							26.130086000000148
						],
						[
							-81.79385234099976,
							26.129929834000016
						],
						[
							-81.79389291399974,
							26.1297784140001
						],
						[
							-81.7939591649998,
							26.129636339000335
						],
						[
							-81.7940490799998,
							26.12950792700019
						],
						[
							-81.79415992699981,
							26.12939707900008
						],
						[
							-81.79428833899986,
							26.12930716400019
						],
						[
							-81.79439603399963,
							26.12925694600012
						],
						[
							-81.79415815999995,
							26.129131308000026
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Collier",
				"City": "Naples",
				"Name": "Aqualane Shore",
				"RegionID": "276185"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.2925909999999,
					28.34798600000005,
					-81.23188899999991,
					28.36348600000008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.24126899999995,
							28.357236000000057
						],
						[
							-81.23976999999992,
							28.355654000000072
						],
						[
							-81.23872799999992,
							28.354591000000084
						],
						[
							-81.23646999999994,
							28.352295000000083
						],
						[
							-81.23647799999992,
							28.350272000000075
						],
						[
							-81.23417299999994,
							28.35025200000007
						],
						[
							-81.23331067799995,
							28.349434229000053
						],
						[
							-81.23188899999991,
							28.34808600000008
						],
						[
							-81.2319931269999,
							28.34808600000008
						],
						[
							-81.23288086799994,
							28.34808600000008
						],
						[
							-81.23288899999994,
							28.34808600000008
						],
						[
							-81.23306223399993,
							28.34808600000008
						],
						[
							-81.23478899999992,
							28.34808600000008
						],
						[
							-81.23918999999995,
							28.34808600000008
						],
						[
							-81.24019299999992,
							28.34808600000008
						],
						[
							-81.24152771399991,
							28.34808600000008
						],
						[
							-81.24155272799993,
							28.34808600000008
						],
						[
							-81.24206499999991,
							28.34808600000008
						],
						[
							-81.24458923299994,
							28.34808600000008
						],
						[
							-81.24571099999991,
							28.34808600000008
						],
						[
							-81.24910799999992,
							28.34808600000008
						],
						[
							-81.24972384799992,
							28.34808600000008
						],
						[
							-81.2497899999999,
							28.34808600000008
						],
						[
							-81.2500853549999,
							28.348075815000072
						],
						[
							-81.25268999999992,
							28.34798600000005
						],
						[
							-81.25828999999993,
							28.34798600000005
						],
						[
							-81.25958999999995,
							28.34798600000005
						],
						[
							-81.26368999999994,
							28.34798600000005
						],
						[
							-81.26758999999993,
							28.34798600000005
						],
						[
							-81.26908999999995,
							28.34798600000005
						],
						[
							-81.28088999999994,
							28.34798600000005
						],
						[
							-81.2839899999999,
							28.34798600000005
						],
						[
							-81.2925909999999,
							28.34798600000005
						],
						[
							-81.2925909999999,
							28.348092630000053
						],
						[
							-81.2925909999999,
							28.35212091300008
						],
						[
							-81.2925909999999,
							28.35322000000008
						],
						[
							-81.28503557699992,
							28.35322000000008
						],
						[
							-81.28427999999991,
							28.35322000000008
						],
						[
							-81.28427999999991,
							28.355341000000067
						],
						[
							-81.2925909999999,
							28.355341000000067
						],
						[
							-81.2925909999999,
							28.358336000000065
						],
						[
							-81.2925909999999,
							28.36295869500009
						],
						[
							-81.28963704099993,
							28.36295896900009
						],
						[
							-81.28415683299994,
							28.363216522000076
						],
						[
							-81.28189958799993,
							28.36012157500005
						],
						[
							-81.28099622699995,
							28.360830814000053
						],
						[
							-81.28054555699993,
							28.361411675000056
						],
						[
							-81.28015801899994,
							28.361798437000065
						],
						[
							-81.27964206399992,
							28.361605068000074
						],
						[
							-81.27964221799994,
							28.360960005000038
						],
						[
							-81.27964237499992,
							28.360186746000068
						],
						[
							-81.27815901899993,
							28.35973518700007
						],
						[
							-81.27680501099991,
							28.359089230000052
						],
						[
							-81.2747419509999,
							28.357736224000064
						],
						[
							-81.2733869729999,
							28.356896797000047
						],
						[
							-81.27254969699993,
							28.357090265000068
						],
						[
							-81.27074394499994,
							28.357090431000074
						],
						[
							-81.26977558999994,
							28.355930365000063
						],
						[
							-81.2683574749999,
							28.35747801900004
						],
						[
							-81.2678417699999,
							28.35676860400008
						],
						[
							-81.26468203199994,
							28.357929511000066
						],
						[
							-81.26313470199996,
							28.35844523500009
						],
						[
							-81.26229549199991,
							28.359089230000052
						],
						[
							-81.2617166309999,
							28.359670092000044
						],
						[
							-81.26100641399997,
							28.360057571000084
						],
						[
							-81.26107059599991,
							28.361282507000055
						],
						[
							-81.26132925099995,
							28.36173417200007
						],
						[
							-81.25991103099994,
							28.363281615000062
						],
						[
							-81.24432499999995,
							28.36348600000008
						],
						[
							-81.24424158099993,
							28.363026309000077
						],
						[
							-81.2441839999999,
							28.362709000000052
						],
						[
							-81.24392299999994,
							28.361593000000084
						],
						[
							-81.24379799999991,
							28.361137000000046
						],
						[
							-81.2434859999999,
							28.360349000000042
						],
						[
							-81.24283699999995,
							28.359278000000074
						],
						[
							-81.24209899999994,
							28.35821700000008
						],
						[
							-81.24126899999995,
							28.357236000000057
						]
					],
					[
						[
							-81.28894538499992,
							28.35823762800004
						],
						[
							-81.28888681799992,
							28.358243396000034
						],
						[
							-81.28882799999991,
							28.358245322000073
						],
						[
							-81.28881789499991,
							28.35824526500005
						],
						[
							-81.28857389399991,
							28.358242523000058
						],
						[
							-81.28814115699993,
							28.35825980000004
						],
						[
							-81.28793314599994,
							28.35830110200004
						],
						[
							-81.28787538499995,
							28.358310628000083
						],
						[
							-81.28781681899994,
							28.358316396000077
						],
						[
							-81.28777531599991,
							28.358318155000067
						],
						[
							-81.28704831599993,
							28.358332156000074
						],
						[
							-81.2870309999999,
							28.35833232200008
						],
						[
							-81.28699857099991,
							28.35833173700007
						],
						[
							-81.28682624099991,
							28.358325519000065
						],
						[
							-81.28683604199995,
							28.35836755100007
						],
						[
							-81.28684562799992,
							28.358425615000044
						],
						[
							-81.28685139599992,
							28.35848418200004
						],
						[
							-81.2868533219999,
							28.358543000000054
						],
						[
							-81.28685139599992,
							28.358601819000057
						],
						[
							-81.28684879499991,
							28.35863312200007
						],
						[
							-81.28683479499996,
							28.35877212200006
						],
						[
							-81.2868316279999,
							28.358799385000054
						],
						[
							-81.28682204199993,
							28.358857449000087
						],
						[
							-81.28680867799994,
							28.35891476200004
						],
						[
							-81.2867915949999,
							28.35897107800008
						],
						[
							-81.28677086499995,
							28.359026156000084
						],
						[
							-81.28674657699992,
							28.359079760000043
						],
						[
							-81.28671883599992,
							28.35913166100005
						],
						[
							-81.2866877589999,
							28.359181637000063
						],
						[
							-81.28665347999993,
							28.359229473000084
						],
						[
							-81.28661614599991,
							28.359274965000054
						],
						[
							-81.28657591699994,
							28.359317917000055
						],
						[
							-81.28655488599992,
							28.359338275000084
						],
						[
							-81.28644388599992,
							28.359442274000063
						],
						[
							-81.28642196399994,
							28.359462146000055
						],
						[
							-81.2863764729999,
							28.359499480000068
						],
						[
							-81.28632863699994,
							28.359533759000044
						],
						[
							-81.28627866099993,
							28.359564835000075
						],
						[
							-81.28622675999992,
							28.359592577000058
						],
						[
							-81.2861731559999,
							28.359616865000078
						],
						[
							-81.2861180779999,
							28.359637595000038
						],
						[
							-81.28606176199992,
							28.359654678000084
						],
						[
							-81.28605188199992,
							28.35965726600006
						],
						[
							-81.28604350799992,
							28.359659408000084
						],
						[
							-81.28605996699991,
							28.36024472200006
						],
						[
							-81.28605979499991,
							28.36025390700007
						],
						[
							-81.28606032199991,
							28.36027000000007
						],
						[
							-81.28606032199991,
							28.36047134200004
						],
						[
							-81.28608365399992,
							28.360728850000044
						],
						[
							-81.28608539699991,
							28.360751182000058
						],
						[
							-81.28608707399991,
							28.360788883000055
						],
						[
							-81.28609407399995,
							28.361086882000052
						],
						[
							-81.28609432199994,
							28.36110800000006
						],
						[
							-81.28609380799992,
							28.361138392000043
						],
						[
							-81.28608878799992,
							28.361286849000066
						],
						[
							-81.28610360899995,
							28.36129701400006
						],
						[
							-81.28720570299993,
							28.36125535900004
						],
						[
							-81.28718393999992,
							28.36100052800009
						],
						[
							-81.2871826029999,
							28.360982819000075
						],
						[
							-81.28718067799991,
							28.36092400000007
						],
						[
							-81.2871826029999,
							28.360865182000055
						],
						[
							-81.2871883709999,
							28.360806615000058
						],
						[
							-81.28719795799992,
							28.360748551000086
						],
						[
							-81.28721132099992,
							28.360691239000065
						],
						[
							-81.28722840499995,
							28.360634923000077
						],
						[
							-81.28723628199992,
							28.360612681000077
						],
						[
							-81.28730528199992,
							28.36042568000005
						],
						[
							-81.28731813499991,
							28.360392844000046
						],
						[
							-81.28734242299993,
							28.360339240000087
						],
						[
							-81.28737016399992,
							28.360287339000084
						],
						[
							-81.28740124099994,
							28.360237363000067
						],
						[
							-81.28743551999992,
							28.360189527000045
						],
						[
							-81.28747285399993,
							28.360144036000065
						],
						[
							-81.28751308299992,
							28.360101083000075
						],
						[
							-81.28755488299993,
							28.36006186700007
						],
						[
							-81.28767988199992,
							28.359951867000063
						],
						[
							-81.28768103499993,
							28.35995085400009
						],
						[
							-81.2877265269999,
							28.359913520000077
						],
						[
							-81.28777436299993,
							28.359879241000044
						],
						[
							-81.28782433899994,
							28.359848164000084
						],
						[
							-81.28787623999995,
							28.359820423000087
						],
						[
							-81.28788302299995,
							28.359817113000076
						],
						[
							-81.28802802299992,
							28.359747113000083
						],
						[
							-81.28807484399994,
							28.359726135000074
						],
						[
							-81.28812992199994,
							28.359705405000057
						],
						[
							-81.28818623799992,
							28.359688322000068
						],
						[
							-81.28824355099994,
							28.359674959000074
						],
						[
							-81.28824561599994,
							28.35967455000008
						],
						[
							-81.28828908199995,
							28.359631084000057
						],
						[
							-81.28833203599993,
							28.359590854000093
						],
						[
							-81.28837752699991,
							28.359553520000077
						],
						[
							-81.28842536299994,
							28.359519241000044
						],
						[
							-81.28847533899994,
							28.359488164000087
						],
						[
							-81.28852723999995,
							28.35946042200004
						],
						[
							-81.28858084399991,
							28.359436134000077
						],
						[
							-81.28863592199993,
							28.35941540500005
						],
						[
							-81.2886922379999,
							28.35939832100007
						],
						[
							-81.28869532499994,
							28.359397500000057
						],
						[
							-81.28885432499993,
							28.35935550100004
						],
						[
							-81.2889085509999,
							28.35934295900006
						],
						[
							-81.28896661499995,
							28.35933337200004
						],
						[
							-81.28902518199993,
							28.359327604000043
						],
						[
							-81.28908399999995,
							28.359325678000065
						],
						[
							-81.28914281899995,
							28.359327604000043
						],
						[
							-81.28917884899994,
							28.35933069400005
						],
						[
							-81.28931084899995,
							28.35934469400007
						],
						[
							-81.2893333849999,
							28.35934737200006
						],
						[
							-81.28939144899994,
							28.359356958000035
						],
						[
							-81.28944876199995,
							28.359370322000075
						],
						[
							-81.28950507699994,
							28.359387405000064
						],
						[
							-81.2895527629999,
							28.35940511100006
						],
						[
							-81.28965676299993,
							28.359447111000065
						],
						[
							-81.2896641559999,
							28.35945013500009
						],
						[
							-81.28971775999992,
							28.35947442300005
						],
						[
							-81.28976966099992,
							28.359502165000038
						],
						[
							-81.28981963699994,
							28.359533241000065
						],
						[
							-81.2898674729999,
							28.35956752000004
						],
						[
							-81.28991296399994,
							28.359604854000054
						],
						[
							-81.28995591699993,
							28.35964508400008
						],
						[
							-81.28999614599991,
							28.35968803600008
						],
						[
							-81.29003347999992,
							28.35973352800005
						],
						[
							-81.2900677589999,
							28.35978136400007
						],
						[
							-81.29009883599991,
							28.35983133900004
						],
						[
							-81.2901265779999,
							28.359883240000045
						],
						[
							-81.29015086499994,
							28.35993684500005
						],
						[
							-81.29016566399991,
							28.359975004000034
						],
						[
							-81.29027566299993,
							28.360279004000063
						],
						[
							-81.2902815949999,
							28.360295922000034
						],
						[
							-81.29029867799994,
							28.360352238000075
						],
						[
							-81.29030535999993,
							28.360378783000048
						],
						[
							-81.29035435999992,
							28.36058678300009
						],
						[
							-81.29036104199992,
							28.360617551000075
						],
						[
							-81.29037062899994,
							28.360675615000048
						],
						[
							-81.29037639699993,
							28.360734181000055
						],
						[
							-81.29037663299994,
							28.36073789800008
						],
						[
							-81.29039510199993,
							28.361038776000044
						],
						[
							-81.29052616799993,
							28.36104384900006
						],
						[
							-81.29061819899994,
							28.361034162000067
						],
						[
							-81.29061540499993,
							28.361026077000076
						],
						[
							-81.29059832199994,
							28.36096976100004
						],
						[
							-81.2905849579999,
							28.360912449000068
						],
						[
							-81.29057537199992,
							28.360854385000042
						],
						[
							-81.29056960399993,
							28.360795818000042
						],
						[
							-81.29056767799995,
							28.360737000000086
						],
						[
							-81.29056960399993,
							28.360678181000083
						],
						[
							-81.29057537199992,
							28.36061961500008
						],
						[
							-81.2905849579999,
							28.360561551000046
						],
						[
							-81.29059832199994,
							28.36050423800009
						],
						[
							-81.2906082749999,
							28.36046984500007
						],
						[
							-81.29063627499994,
							28.360379845000068
						],
						[
							-81.29064340499991,
							28.36035792200005
						],
						[
							-81.29066413499993,
							28.360302844000046
						],
						[
							-81.2906884219999,
							28.360249240000087
						],
						[
							-81.29071616399995,
							28.36019733900008
						],
						[
							-81.2907472409999,
							28.360147364000056
						],
						[
							-81.29078151999994,
							28.360099528000035
						],
						[
							-81.29081885399997,
							28.36005403600007
						],
						[
							-81.29082425299993,
							28.36004793500007
						],
						[
							-81.29089386599992,
							28.359969992000064
						],
						[
							-81.2909104869999,
							28.359944127000063
						],
						[
							-81.29092656799992,
							28.35983477500008
						],
						[
							-81.29092474799995,
							28.359726867000063
						],
						[
							-81.29090308299993,
							28.359705917000042
						],
						[
							-81.2908628539999,
							28.359662964000055
						],
						[
							-81.29082551999994,
							28.35961747300007
						],
						[
							-81.29079124099991,
							28.35956963700005
						],
						[
							-81.29076016399996,
							28.359519661000036
						],
						[
							-81.29073242299995,
							28.359467760000086
						],
						[
							-81.29070813499993,
							28.35941415600007
						],
						[
							-81.29068740499991,
							28.359359078000068
						],
						[
							-81.29067032199993,
							28.359302762000084
						],
						[
							-81.29066875099994,
							28.359296818000075
						],
						[
							-81.29061975099995,
							28.35910881700005
						],
						[
							-81.29060795899994,
							28.35905744900009
						],
						[
							-81.29059837199992,
							28.358999385000065
						],
						[
							-81.29059260399993,
							28.358940818000065
						],
						[
							-81.29059067799994,
							28.35888200000005
						],
						[
							-81.29059260399993,
							28.358823181000048
						],
						[
							-81.29059837199992,
							28.35876461500004
						],
						[
							-81.29060795899994,
							28.35870655100007
						],
						[
							-81.29062132199994,
							28.35864923800006
						],
						[
							-81.29063840499992,
							28.35859292200007
						],
						[
							-81.29065913499994,
							28.358537844000068
						],
						[
							-81.2906834229999,
							28.358484240000053
						],
						[
							-81.29071116499995,
							28.358432339000046
						],
						[
							-81.29074224099992,
							28.35838236300009
						],
						[
							-81.29077651999995,
							28.358334527000068
						],
						[
							-81.29081385399991,
							28.35828903500004
						],
						[
							-81.29085408399993,
							28.35824608300004
						],
						[
							-81.29086584299995,
							28.358234538000094
						],
						[
							-81.29086912499992,
							28.358124116000056
						],
						[
							-81.29075049599993,
							28.358121014000062
						],
						[
							-81.29071518099994,
							28.358119396000067
						],
						[
							-81.29071094999995,
							28.358119109000086
						],
						[
							-81.29021295099996,
							28.35808410900006
						],
						[
							-81.29015861499994,
							28.358078628000044
						],
						[
							-81.29010055099991,
							28.35806904200007
						],
						[
							-81.29004323899994,
							28.358055678000085
						],
						[
							-81.2899869229999,
							28.35803859500004
						],
						[
							-81.2899318449999,
							28.35801786500008
						],
						[
							-81.28987823999995,
							28.35799357700006
						],
						[
							-81.28982633899994,
							28.357965835000073
						],
						[
							-81.28979456199995,
							28.357946603000073
						],
						[
							-81.28959557699994,
							28.357820486000037
						],
						[
							-81.28959232099993,
							28.357819327000072
						],
						[
							-81.28957575899994,
							28.357845636000036
						],
						[
							-81.28954147999991,
							28.357893472000057
						],
						[
							-81.2895041459999,
							28.357938964000084
						],
						[
							-81.28946391699992,
							28.357981917000075
						],
						[
							-81.28942096399993,
							28.358022146000053
						],
						[
							-81.28937547299995,
							28.358059480000065
						],
						[
							-81.28932763699993,
							28.35809375900004
						],
						[
							-81.28927766099991,
							28.35812483600006
						],
						[
							-81.28922575999991,
							28.358152577000055
						],
						[
							-81.28917215599995,
							28.358176865000075
						],
						[
							-81.28911707799995,
							28.358197595000036
						],
						[
							-81.2890607619999,
							28.35821467800008
						],
						[
							-81.28900344899995,
							28.358228042000064
						],
						[
							-81.28894538499992,
							28.35823762800004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "City of Orlando-GOAA",
				"RegionID": "273265"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.4047589999999,
					28.552961752000048,
					-81.3751658839999,
					28.58975200000009
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.39186499999994,
							28.58975200000009
						],
						[
							-81.39187099999994,
							28.589151000000072
						],
						[
							-81.39042499999994,
							28.589151000000072
						],
						[
							-81.39032640999994,
							28.589151163000054
						],
						[
							-81.3873989999999,
							28.58915600000006
						],
						[
							-81.38727399999993,
							28.589159000000052
						],
						[
							-81.38727357999994,
							28.589159017000043
						],
						[
							-81.38569099999995,
							28.58922300000006
						],
						[
							-81.38561099999993,
							28.58922300000006
						],
						[
							-81.38427599999994,
							28.589208000000042
						],
						[
							-81.38356799999991,
							28.589208000000042
						],
						[
							-81.3826729999999,
							28.58920900000004
						],
						[
							-81.38055999999995,
							28.589151000000072
						],
						[
							-81.37855599999995,
							28.589117000000044
						],
						[
							-81.37849099999994,
							28.58917800000006
						],
						[
							-81.37849099999994,
							28.589063000000067
						],
						[
							-81.37779499999994,
							28.58907000000005
						],
						[
							-81.37757099999993,
							28.588879000000077
						],
						[
							-81.37749599999995,
							28.588971000000072
						],
						[
							-81.37772399999994,
							28.589233000000036
						],
						[
							-81.37792175499993,
							28.589461598000074
						],
						[
							-81.3779419999999,
							28.58948500000008
						],
						[
							-81.37777199999994,
							28.589695000000063
						],
						[
							-81.37761899999992,
							28.58968600000009
						],
						[
							-81.37754404799995,
							28.589681315000064
						],
						[
							-81.37735706599995,
							28.589469463000057
						],
						[
							-81.37732007999995,
							28.589425832000074
						],
						[
							-81.37669515299991,
							28.58871778300005
						],
						[
							-81.37602704699992,
							28.587895630000048
						],
						[
							-81.37594085699993,
							28.587642117000087
						],
						[
							-81.37607641299991,
							28.587579144000074
						],
						[
							-81.37592200599995,
							28.58732371600007
						],
						[
							-81.3757177039999,
							28.586949159000085
						],
						[
							-81.37561555199996,
							28.586709804000066
						],
						[
							-81.37550438599993,
							28.586422378000066
						],
						[
							-81.37536518099995,
							28.58596269600008
						],
						[
							-81.37531210199995,
							28.585681279000084
						],
						[
							-81.37528105599995,
							28.585397860000057
						],
						[
							-81.37526002399994,
							28.58493016600005
						],
						[
							-81.37522697499992,
							28.58427519500009
						],
						[
							-81.37520694599993,
							28.583503049000058
						],
						[
							-81.3751959299999,
							28.583056387000056
						],
						[
							-81.3751839119999,
							28.582458500000087
						],
						[
							-81.37518090799995,
							28.582243180000038
						],
						[
							-81.37517890499993,
							28.582007831000055
						],
						[
							-81.3751708929999,
							28.58098531500008
						],
						[
							-81.3751658839999,
							28.580120031000035
						],
						[
							-81.37516888999994,
							28.579690394000067
						],
						[
							-81.37517890499993,
							28.578623813000036
						],
						[
							-81.3751839119999,
							28.578511647000084
						],
						[
							-81.37519292399992,
							28.578425519000064
						],
						[
							-81.3752740459999,
							28.577763536000077
						],
						[
							-81.37529808099994,
							28.577578262000088
						],
						[
							-81.37549637399991,
							28.57650166600007
						],
						[
							-81.37566963199993,
							28.57561735300004
						],
						[
							-81.37573973499991,
							28.575081560000058
						],
						[
							-81.37575575999995,
							28.57494435600006
						],
						[
							-81.3758118419999,
							28.57434747000008
						],
						[
							-81.3758589119999,
							28.573790645000088
						],
						[
							-81.37586091599991,
							28.573562306000042
						],
						[
							-81.3758639209999,
							28.573196764000045
						],
						[
							-81.37586992899992,
							28.572530777000054
						],
						[
							-81.37587593799992,
							28.571914862000085
						],
						[
							-81.3758639209999,
							28.571375062000072
						],
						[
							-81.37586291899993,
							28.571280922000085
						],
						[
							-81.37586191699995,
							28.571207815000037
						],
						[
							-81.37585290299995,
							28.570557850000057
						],
						[
							-81.3758488979999,
							28.56990287900004
						],
						[
							-81.37585590899994,
							28.56899453200009
						],
						[
							-81.3758519029999,
							28.568133255000077
						],
						[
							-81.3758739349999,
							28.567641525000056
						],
						[
							-81.37589797099992,
							28.567217897000035
						],
						[
							-81.3759430369999,
							28.566955507000046
						],
						[
							-81.37596206599994,
							28.566841338000074
						],
						[
							-81.37605620699992,
							28.566441747000056
						],
						[
							-81.37625049399992,
							28.56595302100004
						],
						[
							-81.37629355799993,
							28.565844861000077
						],
						[
							-81.37639370499994,
							28.56559048400004
						],
						[
							-81.37650386999991,
							28.565363147000085
						],
						[
							-81.37705668899991,
							28.56443376900006
						],
						[
							-81.37727199999995,
							28.564119000000066
						],
						[
							-81.37747999999993,
							28.563816000000088
						],
						[
							-81.37802931399995,
							28.56302958300006
						],
						[
							-81.37824445099994,
							28.562722230000077
						],
						[
							-81.37936911899993,
							28.561085802000036
						],
						[
							-81.3795233479999,
							28.560845447000077
						],
						[
							-81.3795954549999,
							28.56073328100007
						],
						[
							-81.37969860599992,
							28.56058506100004
						],
						[
							-81.38011622699992,
							28.559964141000084
						],
						[
							-81.38022438599995,
							28.55980991000007
						],
						[
							-81.3803996449999,
							28.55951347100006
						],
						[
							-81.3805989409999,
							28.55914893100004
						],
						[
							-81.38076118399994,
							28.558797411000057
						],
						[
							-81.3808893719999,
							28.558488950000083
						],
						[
							-81.38105962499992,
							28.557996221000053
						],
						[
							-81.38117980299995,
							28.557576599000072
						],
						[
							-81.38127794899992,
							28.55730820100007
						],
						[
							-81.38141515299992,
							28.55686554500005
						],
						[
							-81.38168655499993,
							28.555922146000057
						],
						[
							-81.38182375899993,
							28.555485497000063
						],
						[
							-81.38196296599995,
							28.555002782000088
						],
						[
							-81.38207212599991,
							28.554694325000074
						],
						[
							-81.38232750599991,
							28.553758937000055
						],
						[
							-81.38240762599992,
							28.553462498000044
						],
						[
							-81.38247572499995,
							28.553200109000045
						],
						[
							-81.3824907469999,
							28.553127000000078
						],
						[
							-81.38250668899991,
							28.553067862000034
						],
						[
							-81.38255083699994,
							28.553067911000085
						],
						[
							-81.38301652799993,
							28.553060901000038
						],
						[
							-81.3831116689999,
							28.55306190400006
						],
						[
							-81.3834922339999,
							28.553037867000057
						],
						[
							-81.38381571199994,
							28.553015835000053
						],
						[
							-81.38417123999994,
							28.553010827000037
						],
						[
							-81.38467598799991,
							28.553001814000083
						],
						[
							-81.3861001009999,
							28.552972770000054
						],
						[
							-81.38713363399995,
							28.55297577500005
						],
						[
							-81.38765039999993,
							28.552981784000053
						],
						[
							-81.38842554999991,
							28.552996806000067
						],
						[
							-81.38881713099994,
							28.55300281500007
						],
						[
							-81.38903445299991,
							28.553003816000057
						],
						[
							-81.38910155299993,
							28.553003816000057
						],
						[
							-81.38917766599991,
							28.553005819000077
						],
						[
							-81.38988972099992,
							28.553001814000083
						],
						[
							-81.39101238599994,
							28.55299380200006
						],
						[
							-81.3915231439999,
							28.552989796000077
						],
						[
							-81.3932807509999,
							28.552980782000077
						],
						[
							-81.3946738169999,
							28.552969766000047
						],
						[
							-81.39505337899995,
							28.552967763000083
						],
						[
							-81.39536884599994,
							28.552962755000067
						],
						[
							-81.39545897999994,
							28.552962755000067
						],
						[
							-81.39555612499993,
							28.55296175400008
						],
						[
							-81.39561921299992,
							28.552961752000048
						],
						[
							-81.39561020399992,
							28.553019840000047
						],
						[
							-81.39559418199991,
							28.55316505600007
						],
						[
							-81.39558817299991,
							28.553891132000047
						],
						[
							-81.39561621399992,
							28.556007272000045
						],
						[
							-81.39562122299992,
							28.556539059000045
						],
						[
							-81.3956853169999,
							28.556964691000076
						],
						[
							-81.39578646699994,
							28.557334240000046
						],
						[
							-81.39588561499994,
							28.557635686000083
						],
						[
							-81.3960889139999,
							28.558046296000043
						],
						[
							-81.39704833699994,
							28.559630644000038
						],
						[
							-81.3971785299999,
							28.55983094100009
						],
						[
							-81.39726666099995,
							28.55996714400004
						],
						[
							-81.39887003899992,
							28.562550976000068
						],
						[
							-81.39907534299994,
							28.562896488000035
						],
						[
							-81.39958615199994,
							28.56371260700007
						],
						[
							-81.39946492199994,
							28.56372972300005
						],
						[
							-81.39939381699992,
							28.563741742000047
						],
						[
							-81.39930668799991,
							28.563755762000085
						],
						[
							-81.39922040099992,
							28.563767707000068
						],
						[
							-81.39961113799991,
							28.564384695000058
						],
						[
							-81.40001673899991,
							28.56505168500007
						],
						[
							-81.40041032499994,
							28.565682622000054
						],
						[
							-81.40080791399993,
							28.566339594000056
						],
						[
							-81.40120149699993,
							28.56698956000008
						],
						[
							-81.40142282499994,
							28.567372125000077
						],
						[
							-81.4016352729999,
							28.567961977000042
						],
						[
							-81.40156089699991,
							28.573405203000053
						],
						[
							-81.40398874199991,
							28.573479030000044
						],
						[
							-81.40468599999991,
							28.57539500000007
						],
						[
							-81.40459599999991,
							28.575397000000066
						],
						[
							-81.40451299999995,
							28.575397000000066
						],
						[
							-81.4047589999999,
							28.576002000000074
						],
						[
							-81.40454099999994,
							28.576002000000074
						],
						[
							-81.40453999999994,
							28.576282000000052
						],
						[
							-81.40380799999991,
							28.57627300000007
						],
						[
							-81.40380699999992,
							28.57600300000007
						],
						[
							-81.40342399999992,
							28.576005000000066
						],
						[
							-81.40342399999992,
							28.575586000000044
						],
						[
							-81.4033609999999,
							28.575586000000044
						],
						[
							-81.40281799999991,
							28.575582000000054
						],
						[
							-81.40281799999991,
							28.575665000000072
						],
						[
							-81.40262899999993,
							28.575667000000067
						],
						[
							-81.40241399999991,
							28.575668000000064
						],
						[
							-81.40242399999994,
							28.57586500000008
						],
						[
							-81.40262399999995,
							28.57586500000008
						],
						[
							-81.40281799999991,
							28.57586400000008
						],
						[
							-81.40281799999991,
							28.576014000000043
						],
						[
							-81.40262399999995,
							28.57601600000004
						],
						[
							-81.40229799999992,
							28.57601600000004
						],
						[
							-81.40206299999994,
							28.57601600000004
						],
						[
							-81.40205899999995,
							28.576272000000074
						],
						[
							-81.40204299999994,
							28.57737300000008
						],
						[
							-81.40203999999994,
							28.577619000000084
						],
						[
							-81.40205999999995,
							28.577892000000077
						],
						[
							-81.4020549999999,
							28.578014000000053
						],
						[
							-81.40206499999994,
							28.578168000000062
						],
						[
							-81.40206632899992,
							28.578252413000087
						],
						[
							-81.40206899999993,
							28.578422000000046
						],
						[
							-81.40229599999992,
							28.578422000000046
						],
						[
							-81.40274699999992,
							28.578422000000046
						],
						[
							-81.40339899999992,
							28.578423000000043
						],
						[
							-81.40339699999993,
							28.578565000000083
						],
						[
							-81.4029139999999,
							28.57858200000004
						],
						[
							-81.40229599999992,
							28.57858200000004
						],
						[
							-81.40207199999992,
							28.578594000000066
						],
						[
							-81.40207599999991,
							28.57878100000005
						],
						[
							-81.40209199999993,
							28.579378000000077
						],
						[
							-81.40209199999993,
							28.57977800000009
						],
						[
							-81.40209199999993,
							28.580078000000075
						],
						[
							-81.40188341299995,
							28.58022430400007
						],
						[
							-81.4018724899999,
							28.580259239000043
						],
						[
							-81.40183944299991,
							28.58031632300009
						],
						[
							-81.4018159069999,
							28.580354379000084
						],
						[
							-81.40179838299991,
							28.58037841400005
						],
						[
							-81.40174734099993,
							28.58044054700008
						],
						[
							-81.4016932269999,
							28.58047656000008
						],
						[
							-81.40165416799994,
							28.580503600000043
						],
						[
							-81.40162712499996,
							28.580522628000043
						],
						[
							-81.40135772799995,
							28.580625780000048
						],
						[
							-81.40112738699992,
							28.580662836000045
						],
						[
							-81.40090105199995,
							28.580687874000034
						],
						[
							-81.4007157769999,
							28.580741955000065
						],
						[
							-81.40056555399991,
							28.58080504800006
						],
						[
							-81.40051247499991,
							28.580838097000083
						],
						[
							-81.40038728999991,
							28.58091621300008
						],
						[
							-81.4001349159999,
							28.581091472000082
						],
						[
							-81.39984648799992,
							28.581291770000064
						],
						[
							-81.39974333499993,
							28.58136087200006
						],
						[
							-81.39967723599995,
							28.58140493700006
						],
						[
							-81.39963016699994,
							28.581435984000052
						],
						[
							-81.39956306699992,
							28.581479047000073
						],
						[
							-81.39914644899994,
							28.58174544100007
						],
						[
							-81.39907934999991,
							28.581788506000066
						],
						[
							-81.39905932099992,
							28.581802526000047
						],
						[
							-81.39897920099992,
							28.581854605000046
						],
						[
							-81.39891811099994,
							28.58189266100004
						],
						[
							-81.39879092199993,
							28.58196176300004
						],
						[
							-81.39854956499994,
							28.582053899000073
						],
						[
							-81.39848446699995,
							28.58207993900004
						],
						[
							-81.39837530499996,
							28.58212300200006
						],
						[
							-81.39827515799993,
							28.582162061000076
						],
						[
							-81.3981149199999,
							28.582226155000058
						],
						[
							-81.39764522299993,
							28.582414434000047
						],
						[
							-81.39720256699991,
							28.582591697000055
						],
						[
							-81.39688309199994,
							28.582719887000053
						],
						[
							-81.39675990899991,
							28.582753938000053
						],
						[
							-81.39661870099991,
							28.582792995000094
						],
						[
							-81.39642140699993,
							28.58284807800004
						],
						[
							-81.39610694099991,
							28.58295523600009
						],
						[
							-81.39565026499992,
							28.583066402000043
						],
						[
							-81.39542793399994,
							28.58311547500006
						],
						[
							-81.3953928819999,
							28.58312348700008
						],
						[
							-81.39517756399994,
							28.583170556000084
						],
						[
							-81.39487911999993,
							28.58322964300004
						],
						[
							-81.3943212929999,
							28.58331977800009
						],
						[
							-81.39372240499995,
							28.58342493300006
						],
						[
							-81.39326873199991,
							28.58351206200007
						],
						[
							-81.39229428699991,
							28.583699340000067
						],
						[
							-81.39175333499992,
							28.583804455000063
						],
						[
							-81.39208297399995,
							28.58408591400007
						],
						[
							-81.39268694099991,
							28.584602740000037
						],
						[
							-81.39271090499994,
							28.584623711000063
						],
						[
							-81.39277199499992,
							28.58467478600005
						],
						[
							-81.3932236629999,
							28.58507638100008
						],
						[
							-81.39342095799992,
							28.585345782000047
						],
						[
							-81.3934500009999,
							28.58539685700004
						],
						[
							-81.39348281899993,
							28.585475107000036
						],
						[
							-81.39348099999995,
							28.585477000000083
						],
						[
							-81.39348549999994,
							28.58548150000007
						],
						[
							-81.39348999999993,
							28.58548600000006
						],
						[
							-81.39352899999994,
							28.585544000000084
						],
						[
							-81.39363999999995,
							28.58578600000004
						],
						[
							-81.39365799999992,
							28.585890000000067
						],
						[
							-81.39365599999992,
							28.58600400000006
						],
						[
							-81.39365299999992,
							28.58638600000006
						],
						[
							-81.3936569999999,
							28.58687800000007
						],
						[
							-81.39365299999992,
							28.58754200000004
						],
						[
							-81.3936569999999,
							28.587878000000046
						],
						[
							-81.39364799999993,
							28.588376000000043
						],
						[
							-81.39346899999993,
							28.588375000000042
						],
						[
							-81.39346799999994,
							28.588434000000063
						],
						[
							-81.39346799999994,
							28.58849500000008
						],
						[
							-81.39365099999992,
							28.588496000000077
						],
						[
							-81.39364299999994,
							28.58877500000006
						],
						[
							-81.39364999999992,
							28.58897500000006
						],
						[
							-81.39380399999993,
							28.58953400000007
						],
						[
							-81.39362699999992,
							28.58953400000007
						],
						[
							-81.39362699999992,
							28.589744000000053
						],
						[
							-81.39186499999994,
							28.58975200000009
						]
					],
					[
						[
							-81.37725399999994,
							28.584793000000047
						],
						[
							-81.37725599999993,
							28.584410000000048
						],
						[
							-81.3771319999999,
							28.584411000000046
						],
						[
							-81.37713699999995,
							28.58407100000005
						],
						[
							-81.37725199999994,
							28.584070000000054
						],
						[
							-81.37725599999993,
							28.583867000000055
						],
						[
							-81.37727699999994,
							28.58336200000008
						],
						[
							-81.37727099999995,
							28.58310800000004
						],
						[
							-81.37728199999992,
							28.58208200000007
						],
						[
							-81.37725499999993,
							28.582085000000063
						],
						[
							-81.37678799999992,
							28.58209700000009
						],
						[
							-81.3767729999999,
							28.582276000000036
						],
						[
							-81.37674699999991,
							28.582584000000054
						],
						[
							-81.37632499999995,
							28.582584000000054
						],
						[
							-81.37625199999991,
							28.58258500000005
						],
						[
							-81.37625199999991,
							28.582752000000085
						],
						[
							-81.3762779999999,
							28.58322300000009
						],
						[
							-81.37628899999993,
							28.58341500000006
						],
						[
							-81.37643899999995,
							28.584152000000074
						],
						[
							-81.3764809999999,
							28.58435600000007
						],
						[
							-81.37663899999991,
							28.584862000000047
						],
						[
							-81.37678299999993,
							28.58567800000009
						],
						[
							-81.3769509999999,
							28.586578000000088
						],
						[
							-81.3769749999999,
							28.587090000000046
						],
						[
							-81.37707399999994,
							28.58747800000009
						],
						[
							-81.37710699999991,
							28.587560000000053
						],
						[
							-81.37715999999995,
							28.587646000000063
						],
						[
							-81.37723999999992,
							28.587758000000065
						],
						[
							-81.37730299999993,
							28.58782700000006
						],
						[
							-81.37737399999992,
							28.58788100000004
						],
						[
							-81.37734699999993,
							28.58747800000009
						],
						[
							-81.37725699999993,
							28.586578000000088
						],
						[
							-81.37724999999996,
							28.58567800000009
						],
						[
							-81.37725399999994,
							28.584793000000047
						]
					],
					[
						[
							-81.39745213499992,
							28.578448156000036
						],
						[
							-81.39743885999991,
							28.578414173000056
						],
						[
							-81.39728085999991,
							28.57798417300006
						],
						[
							-81.39727340499991,
							28.57796307800004
						],
						[
							-81.39725632199992,
							28.577906762000055
						],
						[
							-81.39724295799994,
							28.57784944900004
						],
						[
							-81.39723960799995,
							28.577831675000088
						],
						[
							-81.39718760799991,
							28.577539675000082
						],
						[
							-81.39718137099993,
							28.57749938500007
						],
						[
							-81.39717560299994,
							28.57744081900006
						],
						[
							-81.39717367799994,
							28.577382000000057
						],
						[
							-81.39717367799994,
							28.576522000000068
						],
						[
							-81.39717560299994,
							28.576463182000058
						],
						[
							-81.39718137099993,
							28.576404615000058
						],
						[
							-81.3971909579999,
							28.576346551000086
						],
						[
							-81.39720432099995,
							28.57628923900006
						],
						[
							-81.39720623499994,
							28.576282209000055
						],
						[
							-81.39722682799993,
							28.576207775000057
						],
						[
							-81.39712030399994,
							28.576197062000062
						],
						[
							-81.39497435899995,
							28.57618467900005
						],
						[
							-81.3948281619999,
							28.576204914000073
						],
						[
							-81.39466352799992,
							28.576259793000077
						],
						[
							-81.39460898099992,
							28.576288593000076
						],
						[
							-81.39453239799991,
							28.576369049000053
						],
						[
							-81.3945313669999,
							28.576370129000054
						],
						[
							-81.39450044099993,
							28.576402512000072
						],
						[
							-81.39439104999991,
							28.576566338000077
						],
						[
							-81.39438581299993,
							28.57658069900009
						],
						[
							-81.39438269499993,
							28.576656496000055
						],
						[
							-81.39442051999993,
							28.576862507000044
						],
						[
							-81.39450450499993,
							28.577319421000084
						],
						[
							-81.39450496699993,
							28.57732195400007
						],
						[
							-81.3945061579999,
							28.57732854300008
						],
						[
							-81.39459224199993,
							28.577546711000085
						],
						[
							-81.39462637699995,
							28.57756081200006
						],
						[
							-81.3946271559999,
							28.577561135000053
						],
						[
							-81.39468075999993,
							28.577585423000073
						],
						[
							-81.39473266099992,
							28.57761316400007
						],
						[
							-81.39478263699993,
							28.577644241000087
						],
						[
							-81.39483047299991,
							28.577678520000063
						],
						[
							-81.39487596399995,
							28.57771585400008
						],
						[
							-81.39491891699993,
							28.577756083000054
						],
						[
							-81.3949591459999,
							28.577799036000044
						],
						[
							-81.39499647999992,
							28.57784452700008
						],
						[
							-81.39503075899995,
							28.577892363000046
						],
						[
							-81.39506183599991,
							28.57794233900006
						],
						[
							-81.39508097299995,
							28.57797724800008
						],
						[
							-81.39525197299992,
							28.578306248000047
						],
						[
							-81.39526057699993,
							28.57832324000009
						],
						[
							-81.39528486499995,
							28.578376844000047
						],
						[
							-81.39530559499991,
							28.57843192200005
						],
						[
							-81.3953131099999,
							28.57845508600008
						],
						[
							-81.39535210999992,
							28.578581086000042
						],
						[
							-81.3953532939999,
							28.578584941000088
						],
						[
							-81.39553966999995,
							28.579196780000075
						],
						[
							-81.3956517119999,
							28.579473799000088
						],
						[
							-81.39565208399995,
							28.579474722000043
						],
						[
							-81.3958304379999,
							28.579917100000046
						],
						[
							-81.39603451399995,
							28.580168325000045
						],
						[
							-81.39604690399995,
							28.58018352000005
						],
						[
							-81.39610227899993,
							28.58023468500005
						],
						[
							-81.39629737599995,
							28.58028139000004
						],
						[
							-81.3963207619999,
							28.58028732100007
						],
						[
							-81.3963770769999,
							28.58030440500005
						],
						[
							-81.39638711399994,
							28.580307878000042
						],
						[
							-81.39677984299993,
							28.580446385000073
						],
						[
							-81.39692615699994,
							28.58047740400008
						],
						[
							-81.39708263999995,
							28.58049367800004
						],
						[
							-81.39739095699991,
							28.58049367800004
						],
						[
							-81.39759268699993,
							28.58046934500004
						],
						[
							-81.39773431899994,
							28.580451741000047
						],
						[
							-81.39811100199995,
							28.58037567100007
						],
						[
							-81.3983099639999,
							28.58033503200005
						],
						[
							-81.39833667799991,
							28.580327321000084
						],
						[
							-81.39833667799991,
							28.580069733000073
						],
						[
							-81.39832785999994,
							28.58003479200005
						],
						[
							-81.39822185799994,
							28.579784043000075
						],
						[
							-81.3977995539999,
							28.578951910000058
						],
						[
							-81.3975689479999,
							28.578650726000035
						],
						[
							-81.3975352409999,
							28.57860363700007
						],
						[
							-81.39750416499993,
							28.578553661000058
						],
						[
							-81.39747642299996,
							28.578501760000055
						],
						[
							-81.39745213499992,
							28.578448156000036
						]
					],
					[
						[
							-81.38329314599993,
							28.56449762400007
						],
						[
							-81.38248888999993,
							28.56431632200008
						],
						[
							-81.38234178399995,
							28.56431632200008
						],
						[
							-81.38099743099991,
							28.56464638400007
						],
						[
							-81.38095844899993,
							28.564655042000084
						],
						[
							-81.3809003849999,
							28.56466462800006
						],
						[
							-81.38088373799991,
							28.564666268000053
						],
						[
							-81.38088362799994,
							28.564667385000064
						],
						[
							-81.3808740419999,
							28.56472544900004
						],
						[
							-81.38086067799992,
							28.56478276100006
						],
						[
							-81.38084359499993,
							28.564839077000045
						],
						[
							-81.38082286499991,
							28.564894155000047
						],
						[
							-81.38079857699995,
							28.564947760000052
						],
						[
							-81.3807708359999,
							28.56499966100006
						],
						[
							-81.3807638589999,
							28.565011534000064
						],
						[
							-81.38077819699993,
							28.565049360000046
						],
						[
							-81.38097635499992,
							28.565454682000052
						],
						[
							-81.3811308679999,
							28.565640191000057
						],
						[
							-81.38133163299995,
							28.56575373800007
						],
						[
							-81.38143439599992,
							28.565795000000037
						],
						[
							-81.38206747599992,
							28.56587767800005
						],
						[
							-81.38220699999994,
							28.56587767800005
						],
						[
							-81.38226581899994,
							28.56587960300004
						],
						[
							-81.3822749759999,
							28.565880250000077
						],
						[
							-81.38256131599991,
							28.56590195600006
						],
						[
							-81.38299396899993,
							28.56588007000005
						],
						[
							-81.38314138999993,
							28.565864489000035
						],
						[
							-81.3836326309999,
							28.565100088000065
						],
						[
							-81.38364316399992,
							28.564992024000052
						],
						[
							-81.38365617599993,
							28.564609678000068
						],
						[
							-81.38329314599993,
							28.56449762400007
						]
					],
					[
						[
							-81.38138704999994,
							28.561899379000067
						],
						[
							-81.38055629299993,
							28.561568195000063
						],
						[
							-81.38054885799994,
							28.56160537100004
						],
						[
							-81.38053567799994,
							28.56166176100004
						],
						[
							-81.38052904999995,
							28.561685221000065
						],
						[
							-81.38042204999994,
							28.562045221000062
						],
						[
							-81.38041159499994,
							28.56207807800007
						],
						[
							-81.38039086499992,
							28.562133156000073
						],
						[
							-81.3803665769999,
							28.562186760000092
						],
						[
							-81.38033883499992,
							28.562238661000038
						],
						[
							-81.38031159999991,
							28.56228283900009
						],
						[
							-81.38019111599993,
							28.562466210000082
						],
						[
							-81.38107872899991,
							28.562045383000058
						],
						[
							-81.3810791059999,
							28.56204520500006
						],
						[
							-81.38138704999994,
							28.561899379000067
						]
					],
					[
						[
							-81.38665769999994,
							28.555817234000074
						],
						[
							-81.38662896299991,
							28.55578104300008
						],
						[
							-81.38640097099994,
							28.555823351000072
						],
						[
							-81.38612365099993,
							28.555888493000054
						],
						[
							-81.38609344899993,
							28.555895042000092
						],
						[
							-81.38604312399991,
							28.55590357500006
						],
						[
							-81.38580112499994,
							28.555937575000087
						],
						[
							-81.38579338499994,
							28.55593862900008
						],
						[
							-81.38573481899994,
							28.555944397000076
						],
						[
							-81.38567599999993,
							28.555946322000068
						],
						[
							-81.38561756099995,
							28.55594442200004
						],
						[
							-81.38540256099992,
							28.555930421000085
						],
						[
							-81.38540218199995,
							28.555930396000065
						],
						[
							-81.3853436149999,
							28.55592462800007
						],
						[
							-81.38528555099992,
							28.555915042000038
						],
						[
							-81.38522823799991,
							28.555901678000055
						],
						[
							-81.38517192299992,
							28.55588459500007
						],
						[
							-81.38511684399992,
							28.55586386500005
						],
						[
							-81.38506323999991,
							28.55583957700009
						],
						[
							-81.38502836599991,
							28.555821421000076
						],
						[
							-81.38475136499994,
							28.55566942100006
						],
						[
							-81.38473433899992,
							28.555659836000075
						],
						[
							-81.3846843629999,
							28.555628759000058
						],
						[
							-81.38463652699994,
							28.55559448000008
						],
						[
							-81.3845910359999,
							28.55555714600007
						],
						[
							-81.38458063199994,
							28.555547879000073
						],
						[
							-81.3844336329999,
							28.55541487900007
						],
						[
							-81.38443256199993,
							28.555413909000038
						],
						[
							-81.3843025619999,
							28.55529590900005
						],
						[
							-81.38427108299993,
							28.555265917000042
						],
						[
							-81.38423085399995,
							28.555222964000052
						],
						[
							-81.38421466799991,
							28.55520398400006
						],
						[
							-81.38402881399992,
							28.554979809000088
						],
						[
							-81.38376925299991,
							28.55483249100007
						],
						[
							-81.38364964099992,
							28.55479324800007
						],
						[
							-81.38364417899993,
							28.55479783200008
						],
						[
							-81.38361347299991,
							28.55482248000004
						],
						[
							-81.38360206599992,
							28.55483109000005
						],
						[
							-81.38346580399991,
							28.55493224800006
						],
						[
							-81.38334806199992,
							28.55540873700005
						],
						[
							-81.3833436779999,
							28.555425762000088
						],
						[
							-81.38332659499991,
							28.555482078000068
						],
						[
							-81.38331165399991,
							28.555522834000044
						],
						[
							-81.38329225199993,
							28.555572048000045
						],
						[
							-81.38305752199996,
							28.556511912000076
						],
						[
							-81.38305367899994,
							28.556526762000093
						],
						[
							-81.38303659499991,
							28.556583078000074
						],
						[
							-81.38301586499995,
							28.556638156000076
						],
						[
							-81.38299157799992,
							28.556691760000035
						],
						[
							-81.38296383599993,
							28.55674366100004
						],
						[
							-81.38293275899991,
							28.556793637000055
						],
						[
							-81.38290509699993,
							28.55683274000006
						],
						[
							-81.3828040969999,
							28.55696774000006
						],
						[
							-81.38279747999992,
							28.556976473000077
						],
						[
							-81.3827601459999,
							28.55702196400006
						],
						[
							-81.38271991699992,
							28.557064917000048
						],
						[
							-81.38269820599993,
							28.55708575700004
						],
						[
							-81.38276050299993,
							28.557751678000045
						],
						[
							-81.38300117599994,
							28.557751678000045
						],
						[
							-81.38333838899992,
							28.55773304800005
						],
						[
							-81.38338799999991,
							28.55773167800004
						],
						[
							-81.38340455799994,
							28.55773183100007
						],
						[
							-81.38393553299994,
							28.55774160900006
						],
						[
							-81.38440350799993,
							28.557737710000087
						],
						[
							-81.38446981899995,
							28.557739604000062
						],
						[
							-81.38447441099993,
							28.55773991700005
						],
						[
							-81.38495541099991,
							28.557773916000087
						],
						[
							-81.38497701699993,
							28.557775706000086
						],
						[
							-81.38549301799992,
							28.557824705000087
						],
						[
							-81.38552538499994,
							28.557828372000074
						],
						[
							-81.38558344899991,
							28.55783795800005
						],
						[
							-81.38564076199992,
							28.557851321000044
						],
						[
							-81.38564563299991,
							28.557852641000068
						],
						[
							-81.38593859799994,
							28.557932906000076
						],
						[
							-81.38611276599994,
							28.557950678000058
						],
						[
							-81.38643178699994,
							28.557950678000058
						],
						[
							-81.38643360299994,
							28.55789518200004
						],
						[
							-81.38643937199993,
							28.557836615000042
						],
						[
							-81.3864489579999,
							28.55777855100007
						],
						[
							-81.38646232199994,
							28.557721239000045
						],
						[
							-81.38647940499993,
							28.55766492300006
						],
						[
							-81.38650013499995,
							28.55760984500006
						],
						[
							-81.38652442299991,
							28.557556240000054
						],
						[
							-81.38655216399991,
							28.557504339000047
						],
						[
							-81.38658324099993,
							28.55745436400008
						],
						[
							-81.3866175199999,
							28.557406528000058
						],
						[
							-81.38665485399991,
							28.55736103600009
						],
						[
							-81.38669508299996,
							28.557318084000087
						],
						[
							-81.38673803599994,
							28.557277854000063
						],
						[
							-81.38678352699992,
							28.55724052000005
						],
						[
							-81.38679917199995,
							28.557228784000074
						],
						[
							-81.38697917199994,
							28.557096783000077
						],
						[
							-81.38701136399993,
							28.557074241000066
						],
						[
							-81.3870613389999,
							28.55704316400005
						],
						[
							-81.3871132399999,
							28.557015422000063
						],
						[
							-81.38716510699993,
							28.55699185600008
						],
						[
							-81.38723138299991,
							28.55696424200005
						],
						[
							-81.38723895899994,
							28.556920551000076
						],
						[
							-81.38724198999995,
							28.556905946000086
						],
						[
							-81.38727528499993,
							28.55675195500004
						],
						[
							-81.38725459999995,
							28.556732663000048
						],
						[
							-81.38723208399995,
							28.55671091700009
						],
						[
							-81.38719185399992,
							28.55666796400004
						],
						[
							-81.38715451999991,
							28.556622473000065
						],
						[
							-81.38712024199992,
							28.55657463700004
						],
						[
							-81.3870891649999,
							28.556524661000083
						],
						[
							-81.38706142299992,
							28.556472760000077
						],
						[
							-81.3870371349999,
							28.55641915600006
						],
						[
							-81.38701640499994,
							28.55636407800006
						],
						[
							-81.38700961599994,
							28.556343247000086
						],
						[
							-81.3869396149999,
							28.55611924600004
						],
						[
							-81.38693022699994,
							28.556087114000036
						],
						[
							-81.38674470899991,
							28.55591201300007
						],
						[
							-81.38672608299993,
							28.55589391700005
						],
						[
							-81.3866858529999,
							28.555850964000058
						],
						[
							-81.38665769999994,
							28.555817234000074
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "College Park",
				"RegionID": "273314"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.85664685199993,
					30.274215995000077,
					-81.79028376899993,
					30.31500007200009
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.79798900599991,
							30.302132106000045
						],
						[
							-81.83563399199994,
							30.274215995000077
						],
						[
							-81.8376869629999,
							30.279978003000053
						],
						[
							-81.83826683099994,
							30.287981036000073
						],
						[
							-81.84171295699991,
							30.293476987000076
						],
						[
							-81.84254476399991,
							30.29719712100007
						],
						[
							-81.84856396499993,
							30.300104951000037
						],
						[
							-81.84946490899995,
							30.30144701100005
						],
						[
							-81.85162290799991,
							30.303898013000037
						],
						[
							-81.85212603399992,
							30.304722966000046
						],
						[
							-81.85227990999994,
							30.305515013000043
						],
						[
							-81.85231275199993,
							30.30581408600005
						],
						[
							-81.85257690899994,
							30.306087012000038
						],
						[
							-81.85308888399993,
							30.306489058000068
						],
						[
							-81.85545290499995,
							30.30749301200007
						],
						[
							-81.8560709439999,
							30.30792097200009
						],
						[
							-81.85650990999994,
							30.308439013000054
						],
						[
							-81.85664685199993,
							30.308667013000047
						],
						[
							-81.8558239109999,
							30.308720012000034
						],
						[
							-81.85465890899991,
							30.308813013000076
						],
						[
							-81.85459791099993,
							30.308825012000057
						],
						[
							-81.85430591099993,
							30.30885001300004
						],
						[
							-81.85425790999994,
							30.308855013000084
						],
						[
							-81.85374391099992,
							30.30889301200006
						],
						[
							-81.85302390999993,
							30.30895301200007
						],
						[
							-81.85270791099992,
							30.30897801200007
						],
						[
							-81.85255091099992,
							30.30898701200005
						],
						[
							-81.85233090899993,
							30.309001013000056
						],
						[
							-81.85184190899992,
							30.309022013000064
						],
						[
							-81.85110090899991,
							30.309074012000053
						],
						[
							-81.84973891099992,
							30.309172012000094
						],
						[
							-81.84956390799994,
							30.309193012000037
						],
						[
							-81.8491169109999,
							30.309239012000035
						],
						[
							-81.84854890799994,
							30.309263013000074
						],
						[
							-81.84819991099994,
							30.30929301300006
						],
						[
							-81.84765690799992,
							30.30933301200008
						],
						[
							-81.84582890999991,
							30.30946901300007
						],
						[
							-81.8443189109999,
							30.30958501200007
						],
						[
							-81.84022490799993,
							30.30988301200006
						],
						[
							-81.83847790899995,
							30.310013012000073
						],
						[
							-81.83610391099995,
							30.310191012000075
						],
						[
							-81.83501391099992,
							30.31027301200004
						],
						[
							-81.8347409079999,
							30.31029601200004
						],
						[
							-81.83369390999991,
							30.31037501300006
						],
						[
							-81.8334369079999,
							30.310402012000058
						],
						[
							-81.83283790899993,
							30.310452013000088
						],
						[
							-81.8317009079999,
							30.310571012000082
						],
						[
							-81.82989690799991,
							30.31079301200009
						],
						[
							-81.82956290899995,
							30.310842013000073
						],
						[
							-81.82931991099991,
							30.310872012000058
						],
						[
							-81.82878190899993,
							30.310956013000066
						],
						[
							-81.8279179079999,
							30.31107301300006
						],
						[
							-81.82784990899995,
							30.311087012000087
						],
						[
							-81.82750491099995,
							30.31113501200008
						],
						[
							-81.82296790899994,
							30.311789012000077
						],
						[
							-81.82243390799994,
							30.311866012000053
						],
						[
							-81.81741191099991,
							30.312586012000054
						],
						[
							-81.81600190899991,
							30.312788013000045
						],
						[
							-81.81545090799995,
							30.312873013000054
						],
						[
							-81.80967690999995,
							30.313711012000056
						],
						[
							-81.8066859079999,
							30.314137013000046
						],
						[
							-81.80525991099995,
							30.314318012000058
						],
						[
							-81.80400790899995,
							30.314463013000076
						],
						[
							-81.80372090799995,
							30.314488013000073
						],
						[
							-81.80221990899992,
							30.314627013000063
						],
						[
							-81.80133590899993,
							30.314697013000053
						],
						[
							-81.79971590899993,
							30.314793012000052
						],
						[
							-81.79837190899991,
							30.314852012000078
						],
						[
							-81.79792591099995,
							30.314863012000046
						],
						[
							-81.7974489099999,
							30.31488401200005
						],
						[
							-81.79652691099994,
							30.31490501200005
						],
						[
							-81.79607390799993,
							30.314909012000044
						],
						[
							-81.79518290999994,
							30.314928012000053
						],
						[
							-81.79178291399995,
							30.314978956000065
						],
						[
							-81.79028376899993,
							30.31500007200009
						],
						[
							-81.79039290899993,
							30.31488801100005
						],
						[
							-81.7905189089999,
							30.314756011000043
						],
						[
							-81.79086290599992,
							30.314484011000047
						],
						[
							-81.7915199059999,
							30.313950010000045
						],
						[
							-81.79172790799993,
							30.313771011000085
						],
						[
							-81.79192990799993,
							30.313592011000086
						],
						[
							-81.79209190699994,
							30.31343201100009
						],
						[
							-81.79287697299992,
							30.31277312900005
						],
						[
							-81.79368650999993,
							30.308133428000076
						],
						[
							-81.79822405699991,
							30.302148942000088
						],
						[
							-81.79798900599991,
							30.302132106000045
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Crystal Springs",
				"RegionID": "273415"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.05889999999994,
					26.70471967800006,
					-80.04685107899991,
					26.711490000000083
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.05528869199992,
							26.711396822000044
						],
						[
							-80.0551744469999,
							26.71139000000005
						],
						[
							-80.05508999999995,
							26.71139000000005
						],
						[
							-80.05495999999994,
							26.711380000000077
						],
						[
							-80.05430770899994,
							26.711380000000077
						],
						[
							-80.05377169999991,
							26.711380000000077
						],
						[
							-80.05356999999992,
							26.711380000000077
						],
						[
							-80.05299613099993,
							26.71135535500008
						],
						[
							-80.05253981599992,
							26.711335759000065
						],
						[
							-80.0521750559999,
							26.711320094000087
						],
						[
							-80.05193999999995,
							26.711310000000083
						],
						[
							-80.05135391899995,
							26.711298837000072
						],
						[
							-80.05098889199992,
							26.71129188400005
						],
						[
							-80.0507399999999,
							26.711280000000045
						],
						[
							-80.0505943469999,
							26.711205739000036
						],
						[
							-80.05033135399992,
							26.71109431900004
						],
						[
							-80.05016825999991,
							26.711022255000046
						],
						[
							-80.05004999999994,
							26.71097000000009
						],
						[
							-80.04983415699992,
							26.71083708100008
						],
						[
							-80.04909467199991,
							26.710313737000035
						],
						[
							-80.04910072199993,
							26.710302470000045
						],
						[
							-80.0492331069999,
							26.709947343000067
						],
						[
							-80.0493186839999,
							26.70931027100005
						],
						[
							-80.0493229139999,
							26.70928215200007
						],
						[
							-80.04938900899992,
							26.708885586000065
						],
						[
							-80.04938552899995,
							26.70873030100006
						],
						[
							-80.04934258199995,
							26.70858181600005
						],
						[
							-80.0492761289999,
							26.70844048300006
						],
						[
							-80.0490948069999,
							26.708281164000084
						],
						[
							-80.04890783999991,
							26.70819001700005
						],
						[
							-80.04866652099992,
							26.70809096900007
						],
						[
							-80.04856858999995,
							26.708043665000048
						],
						[
							-80.04838846399991,
							26.707942751000076
						],
						[
							-80.0482549269999,
							26.707849921000047
						],
						[
							-80.0481933069999,
							26.707793119000087
						],
						[
							-80.04802630799992,
							26.70762411800007
						],
						[
							-80.04798006899995,
							26.707573617000037
						],
						[
							-80.04793780599994,
							26.70751974400008
						],
						[
							-80.0478997649999,
							26.707462812000074
						],
						[
							-80.04786616599995,
							26.70740315100005
						],
						[
							-80.04783720299992,
							26.707341106000058
						],
						[
							-80.04781741399995,
							26.70729412600008
						],
						[
							-80.04756284599995,
							26.70713617100006
						],
						[
							-80.0475131899999,
							26.707103029000052
						],
						[
							-80.04725918999992,
							26.706921029000057
						],
						[
							-80.04720492699995,
							26.706878920000065
						],
						[
							-80.04709407899992,
							26.706768073000035
						],
						[
							-80.04700416399993,
							26.706639661000054
						],
						[
							-80.04693791299991,
							26.70649758600007
						],
						[
							-80.04690221599992,
							26.70637166000006
						],
						[
							-80.04686921699994,
							26.706211661000054
						],
						[
							-80.04685776699995,
							26.706142697000075
						],
						[
							-80.04685170899995,
							26.70607305200008
						],
						[
							-80.04685107899991,
							26.706003146000057
						],
						[
							-80.04685588099994,
							26.705933403000074
						],
						[
							-80.04686608499992,
							26.705864244000058
						],
						[
							-80.0468816309999,
							26.705796086000078
						],
						[
							-80.04695463099995,
							26.705525086000083
						],
						[
							-80.04697759699991,
							26.705452285000035
						],
						[
							-80.04700665399992,
							26.70538169400004
						],
						[
							-80.0470415929999,
							26.70531382200005
						],
						[
							-80.04708216199992,
							26.705249157000083
						],
						[
							-80.04712806899994,
							26.705188166000084
						],
						[
							-80.04724607399993,
							26.705044546000067
						],
						[
							-80.04735992699995,
							26.704930080000054
						],
						[
							-80.04748833899993,
							26.704840165000064
						],
						[
							-80.04763041299992,
							26.704773914000043
						],
						[
							-80.04778183399992,
							26.704733341000065
						],
						[
							-80.04793799999993,
							26.70471967800006
						],
						[
							-80.0480279539999,
							26.704724188000057
						],
						[
							-80.04805431799993,
							26.704726839000045
						],
						[
							-80.04866854199992,
							26.705408177000038
						],
						[
							-80.0491199999999,
							26.705390000000083
						],
						[
							-80.0494953459999,
							26.705398937000044
						],
						[
							-80.04990569099994,
							26.705407033000085
						],
						[
							-80.0501906959999,
							26.705412513000056
						],
						[
							-80.05037309999994,
							26.705416021000076
						],
						[
							-80.05057999999991,
							26.70542000000006
						],
						[
							-80.0509663499999,
							26.705427625000084
						],
						[
							-80.0513539499999,
							26.70543527500007
						],
						[
							-80.0517301509999,
							26.70544270000005
						],
						[
							-80.05188975099992,
							26.70544585000005
						],
						[
							-80.05209999999994,
							26.70545000000004
						],
						[
							-80.05260832699992,
							26.705456162000075
						],
						[
							-80.05320267799993,
							26.70546336600006
						],
						[
							-80.05353222799994,
							26.705467360000057
						],
						[
							-80.05374999999992,
							26.705470000000048
						],
						[
							-80.05398849999995,
							26.70547500400005
						],
						[
							-80.05439864099992,
							26.705483608000065
						],
						[
							-80.05467294399995,
							26.705489362000037
						],
						[
							-80.05493489199995,
							26.705494858000066
						],
						[
							-80.05509472299991,
							26.705498211000076
						],
						[
							-80.0552653119999,
							26.705507528000055
						],
						[
							-80.05541342299995,
							26.705520596000042
						],
						[
							-80.0555613329999,
							26.70553435100004
						],
						[
							-80.05562010499995,
							26.705540537000047
						],
						[
							-80.05570999999993,
							26.705550000000073
						],
						[
							-80.05592669999993,
							26.705575494000072
						],
						[
							-80.05636002499995,
							26.705631879000066
						],
						[
							-80.0565896359999,
							26.705667756000086
						],
						[
							-80.05671383399994,
							26.70568716200006
						],
						[
							-80.05694058099994,
							26.705727267000043
						],
						[
							-80.05712642099991,
							26.705769174000068
						],
						[
							-80.05725999999993,
							26.705800000000067
						],
						[
							-80.05746668199993,
							26.705803388000053
						],
						[
							-80.0577176999999,
							26.705807503000074
						],
						[
							-80.05815096799995,
							26.705807272000072
						],
						[
							-80.05834482599994,
							26.70580539000008
						],
						[
							-80.05852738999994,
							26.70580361800006
						],
						[
							-80.05874405399993,
							26.705801514000086
						],
						[
							-80.05889999999994,
							26.705800000000067
						],
						[
							-80.05888452699992,
							26.705970205000085
						],
						[
							-80.05887999999993,
							26.706130573000053
						],
						[
							-80.05887999999993,
							26.706170000000043
						],
						[
							-80.05887560899993,
							26.706358805000036
						],
						[
							-80.05886980899993,
							26.706609567000044
						],
						[
							-80.05886318799992,
							26.70694061900008
						],
						[
							-80.05885143899991,
							26.707476665000062
						],
						[
							-80.05883362599991,
							26.708285948000082
						],
						[
							-80.0588227849999,
							26.70855967700004
						],
						[
							-80.05881999999991,
							26.708630000000085
						],
						[
							-80.05881543299995,
							26.70886747800006
						],
						[
							-80.05881060599995,
							26.70911850200008
						],
						[
							-80.05880999999994,
							26.709369436000088
						],
						[
							-80.05880730399991,
							26.709470786000054
						],
						[
							-80.05879053199993,
							26.709537871000066
						],
						[
							-80.0587799999999,
							26.709580000000074
						],
						[
							-80.0587799999999,
							26.70985982700006
						],
						[
							-80.0587746459999,
							26.71013384600008
						],
						[
							-80.05876417099996,
							26.710395729000084
						],
						[
							-80.05875999999995,
							26.710500000000085
						],
						[
							-80.05875712699992,
							26.710646543000053
						],
						[
							-80.05875243199995,
							26.71088594400004
						],
						[
							-80.05874999999992,
							26.711010000000044
						],
						[
							-80.05874521599992,
							26.711124819000077
						],
						[
							-80.05873713199992,
							26.711318833000064
						],
						[
							-80.0587328229999,
							26.71142224400006
						],
						[
							-80.05872999999991,
							26.711490000000083
						],
						[
							-80.05856174199994,
							26.711484901000063
						],
						[
							-80.05810529199994,
							26.711471069000083
						],
						[
							-80.05771755099994,
							26.711459320000074
						],
						[
							-80.0573412039999,
							26.71144791500007
						],
						[
							-80.05720447699991,
							26.711443772000052
						],
						[
							-80.05707999999993,
							26.711440000000042
						],
						[
							-80.0568967289999,
							26.711435811000058
						],
						[
							-80.05648586199993,
							26.71142642000007
						],
						[
							-80.05613250899995,
							26.711418343000048
						],
						[
							-80.0557102439999,
							26.711408691000088
						],
						[
							-80.05528869199992,
							26.711396822000044
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "West Palm Beach",
				"Name": "Downtown",
				"RegionID": "273481"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.14549020699991,
					26.10754601300005,
					-80.13697858499995,
					26.122421129000088
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.13726601099995,
							26.11920335600007
						],
						[
							-80.13725913099995,
							26.118741535000087
						],
						[
							-80.13717373199995,
							26.118746780000038
						],
						[
							-80.13726413899991,
							26.118512353000085
						],
						[
							-80.1372450689999,
							26.11799956200008
						],
						[
							-80.13723896999994,
							26.117879392000077
						],
						[
							-80.13723796799991,
							26.117610993000085
						],
						[
							-80.13723596599993,
							26.117094227000052
						],
						[
							-80.13722294599995,
							26.116882914000087
						],
						[
							-80.13716486099992,
							26.115334617000087
						],
						[
							-80.13716385899994,
							26.114886953000052
						],
						[
							-80.13717587699995,
							26.114023673000077
						],
						[
							-80.13718889599994,
							26.113121324000076
						],
						[
							-80.13718388899991,
							26.11215990900007
						],
						[
							-80.13715284199992,
							26.111509945000083
						],
						[
							-80.13714783599994,
							26.11135471600005
						],
						[
							-80.13713381399992,
							26.11097515200004
						],
						[
							-80.1371127839999,
							26.11041532300004
						],
						[
							-80.13697858499995,
							26.107655228000056
						],
						[
							-80.14300449599995,
							26.10754601300005
						],
						[
							-80.14302755499995,
							26.10813093500008
						],
						[
							-80.14304057499994,
							26.108400333000077
						],
						[
							-80.1430515909999,
							26.108592619000035
						],
						[
							-80.1430666139999,
							26.109328711000046
						],
						[
							-80.1430666139999,
							26.10935475000008
						],
						[
							-80.14308163499993,
							26.109821441000065
						],
						[
							-80.14309765899992,
							26.11030616000005
						],
						[
							-80.14309765899992,
							26.11042032900008
						],
						[
							-80.1431046699999,
							26.110683721000044
						],
						[
							-80.1431427249999,
							26.111232535000056
						],
						[
							-80.14318178399992,
							26.112115844000073
						],
						[
							-80.14320381699991,
							26.11299514800004
						],
						[
							-80.1432038179999,
							26.11319242500008
						],
						[
							-80.14325689599991,
							26.11474774700008
						],
						[
							-80.14331498099995,
							26.11623695600008
						],
						[
							-80.14331498099995,
							26.116494337000063
						],
						[
							-80.14336405499995,
							26.117727167000055
						],
						[
							-80.14336505599994,
							26.11782230700004
						],
						[
							-80.1433689079999,
							26.11799267500004
						],
						[
							-80.14384276599992,
							26.11812075000006
						],
						[
							-80.14539413299991,
							26.118628407000074
						],
						[
							-80.14549020699991,
							26.12222584700004
						],
						[
							-80.13734512699995,
							26.122421129000088
						],
						[
							-80.13733010599992,
							26.12204557000007
						],
						[
							-80.13731207899991,
							26.121569866000073
						],
						[
							-80.13729805799994,
							26.121088151000038
						],
						[
							-80.1372840379999,
							26.120736629000078
						],
						[
							-80.13728303599993,
							26.120662520000053
						],
						[
							-80.13727307599993,
							26.120001537000064
						],
						[
							-80.13727302099994,
							26.119923423000046
						],
						[
							-80.13726701199994,
							26.119321530000036
						],
						[
							-80.13726603499993,
							26.11920613300009
						],
						[
							-80.13726601099995,
							26.11920335600007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Downtown",
				"RegionID": "273498"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.73961390799991,
					30.194816927000094,
					-81.70788041899993,
					30.23391638600009
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.70874720699993,
							30.23224236900006
						],
						[
							-81.70828034199992,
							30.231724093000082
						],
						[
							-81.7080433509999,
							30.231279735000044
						],
						[
							-81.70788041899993,
							30.23068725600007
						],
						[
							-81.7080433509999,
							30.23025770900006
						],
						[
							-81.7083247779999,
							30.229887410000064
						],
						[
							-81.70881357299993,
							30.22922087200004
						],
						[
							-81.70900612799994,
							30.228954257000055
						],
						[
							-81.70937642699994,
							30.227932232000057
						],
						[
							-81.70952454699994,
							30.227635992000046
						],
						[
							-81.71010221299991,
							30.226762087000058
						],
						[
							-81.7101938639999,
							30.22655841900007
						],
						[
							-81.71036882899995,
							30.226169608000074
						],
						[
							-81.71054657199994,
							30.225784497000063
						],
						[
							-81.71087243499994,
							30.225384575000078
						],
						[
							-81.7112131099999,
							30.225132771000062
						],
						[
							-81.71136199999995,
							30.224677000000042
						],
						[
							-81.71273176299991,
							30.22022490700004
						],
						[
							-81.71751890599995,
							30.216808008000044
						],
						[
							-81.72449794099992,
							30.212336049000044
						],
						[
							-81.72788002099992,
							30.20889007500006
						],
						[
							-81.73076490599993,
							30.20141200800009
						],
						[
							-81.73183490599992,
							30.199301008000077
						],
						[
							-81.73410794199992,
							30.194816927000094
						],
						[
							-81.73503090699995,
							30.195187011000087
						],
						[
							-81.73834590799993,
							30.196403010000036
						],
						[
							-81.73884290799992,
							30.19658501100008
						],
						[
							-81.73931690799992,
							30.196759011000037
						],
						[
							-81.73954796699991,
							30.19684397500004
						],
						[
							-81.7395489079999,
							30.196899011000085
						],
						[
							-81.73954390799992,
							30.19720501000006
						],
						[
							-81.73956490799992,
							30.197722010000064
						],
						[
							-81.73958390799993,
							30.198131011000044
						],
						[
							-81.73960690799993,
							30.199607011000072
						],
						[
							-81.73958690799992,
							30.200797011000077
						],
						[
							-81.73959190799991,
							30.20111701100006
						],
						[
							-81.73961190799992,
							30.202524011000033
						],
						[
							-81.73961390799991,
							30.202978010000038
						],
						[
							-81.73961390799991,
							30.203271010000037
						],
						[
							-81.73961390799991,
							30.203871010000057
						],
						[
							-81.73961390699992,
							30.204382011000067
						],
						[
							-81.73958490799993,
							30.204804011000082
						],
						[
							-81.73958490799993,
							30.205098010000086
						],
						[
							-81.73959890799995,
							30.205392010000086
						],
						[
							-81.7395989069999,
							30.20596701000005
						],
						[
							-81.7395939079999,
							30.20600201000008
						],
						[
							-81.73948090699992,
							30.206849010000045
						],
						[
							-81.7393479079999,
							30.207424010000068
						],
						[
							-81.73927490699992,
							30.207629010000062
						],
						[
							-81.73924390699995,
							30.207718010000065
						],
						[
							-81.7391259069999,
							30.207999011000087
						],
						[
							-81.73902290799992,
							30.20828001100006
						],
						[
							-81.73880090799992,
							30.208855011000082
						],
						[
							-81.7386519069999,
							30.20919801000008
						],
						[
							-81.73812890799991,
							30.210441010000068
						],
						[
							-81.73801390699992,
							30.210727011000074
						],
						[
							-81.73797190699992,
							30.21082801000006
						],
						[
							-81.73784790799994,
							30.211120011000048
						],
						[
							-81.73769190799993,
							30.211524010000065
						],
						[
							-81.73754990799995,
							30.211952010000065
						],
						[
							-81.7373429079999,
							30.21297501100008
						],
						[
							-81.73732190899995,
							30.213123010000064
						],
						[
							-81.73726390799993,
							30.214201011000057
						],
						[
							-81.7372249089999,
							30.21492001000007
						],
						[
							-81.73720490799991,
							30.215284010000065
						],
						[
							-81.73714690799994,
							30.21585401000004
						],
						[
							-81.73710490799994,
							30.216636010000062
						],
						[
							-81.7370759069999,
							30.217179010000052
						],
						[
							-81.7370509079999,
							30.217760010000067
						],
						[
							-81.7369928199999,
							30.21909699300005
						],
						[
							-81.7369929059999,
							30.21925300800007
						],
						[
							-81.7369929059999,
							30.219419008000045
						],
						[
							-81.7369929059999,
							30.22007700800009
						],
						[
							-81.73711090599994,
							30.221213008000063
						],
						[
							-81.73711499599995,
							30.221249994000065
						],
						[
							-81.73717190499991,
							30.221532009000047
						],
						[
							-81.73736790499993,
							30.22259100900004
						],
						[
							-81.73744190499991,
							30.22295300800005
						],
						[
							-81.73749390599994,
							30.223274009000075
						],
						[
							-81.73767290599994,
							30.22422300900007
						],
						[
							-81.73772390599993,
							30.224431008000067
						],
						[
							-81.73790690599992,
							30.22527000900004
						],
						[
							-81.73795290599992,
							30.22548400900007
						],
						[
							-81.73807790599994,
							30.22625800900005
						],
						[
							-81.73815990599991,
							30.22675100800007
						],
						[
							-81.73821990599993,
							30.22706200900007
						],
						[
							-81.73828790599993,
							30.22746500900007
						],
						[
							-81.73838090499993,
							30.228013009000048
						],
						[
							-81.73850990599993,
							30.228755009000057
						],
						[
							-81.73860090599993,
							30.229273008000064
						],
						[
							-81.73872490499991,
							30.23005400800008
						],
						[
							-81.7387469059999,
							30.23022200800006
						],
						[
							-81.73878390599992,
							30.230404008000054
						],
						[
							-81.73893190599995,
							30.231269009000073
						],
						[
							-81.73914690599992,
							30.232523008000047
						],
						[
							-81.73916690599992,
							30.232638009000087
						],
						[
							-81.7392879059999,
							30.233193008000057
						],
						[
							-81.73936190599994,
							30.233464008000052
						],
						[
							-81.73944248999993,
							30.23380746700008
						],
						[
							-81.73932590599992,
							30.23381800800007
						],
						[
							-81.73920790599993,
							30.23381900700008
						],
						[
							-81.73868590599994,
							30.233824009000042
						],
						[
							-81.7344509049999,
							30.233810008000034
						],
						[
							-81.73422990599994,
							30.233810008000034
						],
						[
							-81.73329190499993,
							30.233812008000086
						],
						[
							-81.7306899049999,
							30.233807008000042
						],
						[
							-81.7261429049999,
							30.233805008000047
						],
						[
							-81.72545590599994,
							30.233807008000042
						],
						[
							-81.7249449059999,
							30.233809008000037
						],
						[
							-81.7246549059999,
							30.233807009000092
						],
						[
							-81.7245179059999,
							30.23382200800006
						],
						[
							-81.72416690599994,
							30.233810008000034
						],
						[
							-81.72300690499992,
							30.233805008000047
						],
						[
							-81.72225990599992,
							30.233805008000047
						],
						[
							-81.72133590599992,
							30.233805008000047
						],
						[
							-81.72041290499993,
							30.233797008000067
						],
						[
							-81.71948990599992,
							30.233799008000062
						],
						[
							-81.7185359049999,
							30.23380300900004
						],
						[
							-81.71611790499992,
							30.233807008000042
						],
						[
							-81.71430990599993,
							30.233816008000076
						],
						[
							-81.71373690599995,
							30.23381600900007
						],
						[
							-81.7136538819999,
							30.233821926000076
						],
						[
							-81.71356192699994,
							30.233871089000047
						],
						[
							-81.71233490599992,
							30.23387900800009
						],
						[
							-81.71028199999995,
							30.23390500000005
						],
						[
							-81.70938274999992,
							30.23391638600009
						],
						[
							-81.70937402299995,
							30.233228655000065
						],
						[
							-81.70930611299991,
							30.233132383000054
						],
						[
							-81.70926216399994,
							30.233063661000077
						],
						[
							-81.70922204499993,
							30.232985607000042
						],
						[
							-81.70906504499993,
							30.232639607000067
						],
						[
							-81.7090371299999,
							30.232570639000077
						],
						[
							-81.7090150109999,
							30.23249959900005
						],
						[
							-81.70899884099993,
							30.232426975000063
						],
						[
							-81.70898872899994,
							30.23235326200006
						],
						[
							-81.70898054299994,
							30.23231621100007
						],
						[
							-81.70882441299995,
							30.232275086000072
						],
						[
							-81.70874720699993,
							30.23224236900006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Duclay Forest",
				"RegionID": "273514"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.50588778225833,
					27.925161245845707,
					-82.49341852404143,
					27.937586733160146
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.49348813336516,
							27.930246925411183
						],
						[
							-82.49357259769012,
							27.925899864424274
						],
						[
							-82.49443187201008,
							27.92596730728117
						],
						[
							-82.4954493622561,
							27.92533980443593
						],
						[
							-82.49588209083565,
							27.92532257612382
						],
						[
							-82.49722497108024,
							27.925268691445766
						],
						[
							-82.49813803834746,
							27.92580617755188
						],
						[
							-82.4998032050304,
							27.925161245845707
						],
						[
							-82.50049089140528,
							27.925795781389283
						],
						[
							-82.50201254787615,
							27.92569067042908
						],
						[
							-82.50506061643271,
							27.92565167492661
						],
						[
							-82.50588778225833,
							27.92563047071178
						],
						[
							-82.50581729159907,
							27.932059092575155
						],
						[
							-82.50581729159907,
							27.933348921813327
						],
						[
							-82.50580166408014,
							27.933853958581906
						],
						[
							-82.50580426312077,
							27.935818492481378
						],
						[
							-82.50580431887875,
							27.937586733160146
						],
						[
							-82.49750139839036,
							27.9375737100778
						],
						[
							-82.49754734025622,
							27.933862878057823
						],
						[
							-82.49341852404143,
							27.933812170684497
						],
						[
							-82.49348813336516,
							27.930246925411183
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Golf View",
				"RegionID": "273847"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.17303684099994,
					26.23617814100004,
					-80.1654487969999,
					26.241675929000053
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.16563536899992,
							26.23622060400004
						],
						[
							-80.17296301099992,
							26.236178462000055
						],
						[
							-80.17303684099994,
							26.23617814100004
						],
						[
							-80.17301621799993,
							26.23620468900009
						],
						[
							-80.17220289099993,
							26.237251679000053
						],
						[
							-80.16977789099991,
							26.240172679000068
						],
						[
							-80.16899007999992,
							26.24160527400005
						],
						[
							-80.16891624999994,
							26.241605595000067
						],
						[
							-80.1654487969999,
							26.241675929000053
						],
						[
							-80.16572081999993,
							26.24033281700008
						],
						[
							-80.16563536899992,
							26.23622060400004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Pompano Beach",
				"Name": "Golfview Estates",
				"RegionID": "273848"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.45647074899995,
					27.924571678000063,
					-82.44463834099992,
					27.94160629000004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.44855183399994,
							27.924585341000068
						],
						[
							-82.4487079999999,
							27.924571678000063
						],
						[
							-82.44886416599992,
							27.924585341000068
						],
						[
							-82.44901558599992,
							27.924625914000046
						],
						[
							-82.44906225799991,
							27.92464439200006
						],
						[
							-82.44910425799992,
							27.924662392000076
						],
						[
							-82.44916304899994,
							27.924691831000075
						],
						[
							-82.45309772799995,
							27.931612100000052
						],
						[
							-82.45645954499992,
							27.93808535700009
						],
						[
							-82.4564674479999,
							27.938157361000037
						],
						[
							-82.45647044799995,
							27.938225361000036
						],
						[
							-82.45647074899995,
							27.938297184000078
						],
						[
							-82.45646531399991,
							27.93836880200007
						],
						[
							-82.45645417799994,
							27.938439758000076
						],
						[
							-82.4564374119999,
							27.938509597000063
						],
						[
							-82.45641512299994,
							27.938577875000078
						],
						[
							-82.45610716099992,
							27.939392164000083
						],
						[
							-82.45604483599993,
							27.939523661000067
						],
						[
							-82.45597053199992,
							27.93962977800004
						],
						[
							-82.45568355599994,
							27.93968657100004
						],
						[
							-82.45543902199995,
							27.939749676000076
						],
						[
							-82.45514715899992,
							27.939860111000087
						],
						[
							-82.45491051399995,
							27.939986322000042
						],
						[
							-82.45458720499994,
							27.940048597000043
						],
						[
							-82.45044627099992,
							27.941135506000084
						],
						[
							-82.44844900999993,
							27.94158204100006
						],
						[
							-82.44672730299995,
							27.94160629000004
						],
						[
							-82.44603619599991,
							27.94130317300005
						],
						[
							-82.4456840869999,
							27.941021486000068
						],
						[
							-82.44489658099991,
							27.94055770000006
						],
						[
							-82.44480121899994,
							27.94026344000008
						],
						[
							-82.44477133999993,
							27.94014316600004
						],
						[
							-82.4447614099999,
							27.94006885500005
						],
						[
							-82.4447371469999,
							27.939803381000047
						],
						[
							-82.44467259999993,
							27.939613652000048
						],
						[
							-82.44463834099992,
							27.939480166000067
						],
						[
							-82.44473161399993,
							27.938806663000037
						],
						[
							-82.44491196199994,
							27.938317145000042
						],
						[
							-82.44523578799993,
							27.937710889000073
						],
						[
							-82.4456665809999,
							27.937062551000054
						],
						[
							-82.44584901399992,
							27.93666326400006
						],
						[
							-82.44588816499993,
							27.936587339000084
						],
						[
							-82.44595495199991,
							27.93648766700005
						],
						[
							-82.44626066399991,
							27.936091401000056
						],
						[
							-82.44629177299993,
							27.935800402000044
						],
						[
							-82.4463219559999,
							27.935646585000086
						],
						[
							-82.44635389299992,
							27.935545128000058
						],
						[
							-82.44637989599994,
							27.935453105000082
						],
						[
							-82.44639691399993,
							27.93539441300004
						],
						[
							-82.44642257699991,
							27.935336371000066
						],
						[
							-82.44646095099995,
							27.93525135100009
						],
						[
							-82.44686073999992,
							27.934349514000075
						],
						[
							-82.4468738519999,
							27.934321441000066
						],
						[
							-82.44714680599992,
							27.93376236900008
						],
						[
							-82.44717064199996,
							27.933673455000076
						],
						[
							-82.4471821489999,
							27.933576947000063
						],
						[
							-82.44716845199991,
							27.93344454000004
						],
						[
							-82.44716367799992,
							27.93335200000007
						],
						[
							-82.44716678499992,
							27.933277313000076
						],
						[
							-82.4471727849999,
							27.93320531200004
						],
						[
							-82.44718334099991,
							27.93312383400007
						],
						[
							-82.44720639799993,
							27.933025641000086
						],
						[
							-82.44722939899992,
							27.932947641000055
						],
						[
							-82.44726285899992,
							27.932858519000035
						],
						[
							-82.44733761299995,
							27.93214791300005
						],
						[
							-82.44734550599992,
							27.932090645000073
						],
						[
							-82.44737147899991,
							27.931938519000084
						],
						[
							-82.44739424099993,
							27.931483262000086
						],
						[
							-82.44740718199995,
							27.930967509000084
						],
						[
							-82.44740350899991,
							27.930884097000046
						],
						[
							-82.44737859999992,
							27.930806356000062
						],
						[
							-82.4473415999999,
							27.930661356000087
						],
						[
							-82.4473273399999,
							27.930595166000046
						],
						[
							-82.44731419399994,
							27.93046946900006
						],
						[
							-82.44731219399995,
							27.930410469000037
						],
						[
							-82.44731228599994,
							27.930346926000084
						],
						[
							-82.44731686499995,
							27.930283547000048
						],
						[
							-82.44732590799993,
							27.93022065000008
						],
						[
							-82.4473393689999,
							27.930158549000055
						],
						[
							-82.4474576369999,
							27.92969304600007
						],
						[
							-82.44747682099995,
							27.929592224000093
						],
						[
							-82.44747454599991,
							27.929524632000042
						],
						[
							-82.44742952099995,
							27.929161728000054
						],
						[
							-82.44742401899993,
							27.929100085000073
						],
						[
							-82.44740848799995,
							27.928815958000087
						],
						[
							-82.4473715609999,
							27.92849469400005
						],
						[
							-82.4473661689999,
							27.928362292000088
						],
						[
							-82.4473701679999,
							27.928241292000052
						],
						[
							-82.44738333999993,
							27.92811483400004
						],
						[
							-82.44740832699995,
							27.92801018700004
						],
						[
							-82.4474283269999,
							27.927944188000083
						],
						[
							-82.44744391299992,
							27.927897414000086
						],
						[
							-82.44751415699994,
							27.927748963000056
						],
						[
							-82.44751968299994,
							27.92726908900005
						],
						[
							-82.4475207619999,
							27.927227867000056
						],
						[
							-82.44753776199991,
							27.926881867000077
						],
						[
							-82.4475415949999,
							27.92683208700004
						],
						[
							-82.44756259499991,
							27.926632087000087
						],
						[
							-82.44759199499994,
							27.926479939000046
						],
						[
							-82.44778686699993,
							27.92579488000007
						],
						[
							-82.44778299799992,
							27.925745548000066
						],
						[
							-82.4477676809999,
							27.925583762000088
						],
						[
							-82.44776367799994,
							27.92549900000006
						],
						[
							-82.4477773399999,
							27.92534283400005
						],
						[
							-82.44781791299994,
							27.92519141300005
						],
						[
							-82.4478841639999,
							27.925049339000058
						],
						[
							-82.44797407899996,
							27.924920927000073
						],
						[
							-82.44808492699991,
							27.924810079000054
						],
						[
							-82.44818789499993,
							27.924735419000058
						],
						[
							-82.44823289499993,
							27.92470742000006
						],
						[
							-82.44825833899995,
							27.924692165000067
						],
						[
							-82.44840041399993,
							27.924625914000046
						],
						[
							-82.44855183399994,
							27.924585341000068
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Harbour Island",
				"RegionID": "273934"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.80303132199992,
					26.078883723000047,
					-81.79250083199992,
					26.094462286000066
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.79673747899994,
							26.093199952000077
						],
						[
							-81.79503559999995,
							26.092449271000078
						],
						[
							-81.7942232819999,
							26.091531289000045
						],
						[
							-81.79409756699994,
							26.090247042000044
						],
						[
							-81.79315836399991,
							26.089099829000077
						],
						[
							-81.79310776999995,
							26.088870417000066
						],
						[
							-81.79295542699992,
							26.08864101900008
						],
						[
							-81.79293048799993,
							26.087929992000056
						],
						[
							-81.79303230399995,
							26.087677839000037
						],
						[
							-81.79359160199994,
							26.08712777900007
						],
						[
							-81.79369371799993,
							26.086416685000078
						],
						[
							-81.79252577099993,
							26.085269510000046
						],
						[
							-81.79250083199992,
							26.08494838200005
						],
						[
							-81.79260248399993,
							26.084719024000037
						],
						[
							-81.79344141799993,
							26.084008706000077
						],
						[
							-81.7934417479999,
							26.083549919000063
						],
						[
							-81.79298474299992,
							26.082884635000084
						],
						[
							-81.79306106799993,
							26.082655164000073
						],
						[
							-81.7933406169999,
							26.082517693000057
						],
						[
							-81.79397553899992,
							26.08244925000008
						],
						[
							-81.79433115299992,
							26.082632885000066
						],
						[
							-81.79468637499991,
							26.083046149000044
						],
						[
							-81.7950926389999,
							26.083252937000054
						],
						[
							-81.79562598799993,
							26.08300071900004
						],
						[
							-81.79590569899995,
							26.082679822000046
						],
						[
							-81.79590635599993,
							26.08176235200006
						],
						[
							-81.79582978499991,
							26.081716619000076
						],
						[
							-81.7956019799999,
							26.08095960500009
						],
						[
							-81.79468856299991,
							26.079720643000087
						],
						[
							-81.79463817699991,
							26.079261787000064
						],
						[
							-81.7945470919999,
							26.079047143000082
						],
						[
							-81.7946389999999,
							26.079041000000075
						],
						[
							-81.79567999999995,
							26.07897100000008
						],
						[
							-81.79574639999993,
							26.07897100000008
						],
						[
							-81.79584099999994,
							26.07897100000008
						],
						[
							-81.7966800879999,
							26.078883723000047
						],
						[
							-81.79675477399991,
							26.079070436000052
						],
						[
							-81.79720147099994,
							26.079986544000064
						],
						[
							-81.79729678799993,
							26.080157408000048
						],
						[
							-81.7973228539999,
							26.080192812000064
						],
						[
							-81.79736831499991,
							26.080219818000046
						],
						[
							-81.7974870729999,
							26.080304079000086
						],
						[
							-81.7975095239999,
							26.080323560000068
						],
						[
							-81.79757752499995,
							26.080384560000084
						],
						[
							-81.79766592099992,
							26.080475927000066
						],
						[
							-81.79772839099991,
							26.08055984200007
						],
						[
							-81.79794739099992,
							26.080892842000083
						],
						[
							-81.79798820699995,
							26.080961337000076
						],
						[
							-81.79823481499994,
							26.081420302000083
						],
						[
							-81.79895416999994,
							26.08268140800004
						],
						[
							-81.79898453599994,
							26.08273945700006
						],
						[
							-81.7991838769999,
							26.083156889000065
						],
						[
							-81.79928712599991,
							26.08336568200008
						],
						[
							-81.79946106799991,
							26.083617461000074
						],
						[
							-81.79955387099994,
							26.083743342000048
						],
						[
							-81.79959514099994,
							26.083804412000063
						],
						[
							-81.7996791409999,
							26.08394041200006
						],
						[
							-81.79973804699995,
							26.08405282300004
						],
						[
							-81.7998040459999,
							26.084203823000053
						],
						[
							-81.79983551299995,
							26.084286734000045
						],
						[
							-81.79997291299992,
							26.084710683000083
						],
						[
							-81.80005466199992,
							26.084894416000054
						],
						[
							-81.80006517999993,
							26.084919037000077
						],
						[
							-81.80018317999992,
							26.08520703700009
						],
						[
							-81.8002242199999,
							26.085332904000044
						],
						[
							-81.8002753479999,
							26.085540468000094
						],
						[
							-81.80043618999991,
							26.08593306000006
						],
						[
							-81.80046251099992,
							26.08600615900008
						],
						[
							-81.80060612199992,
							26.08646647800009
						],
						[
							-81.80066838199991,
							26.086633350000056
						],
						[
							-81.80077232499991,
							26.08692846100007
						],
						[
							-81.80079501799992,
							26.08700315100009
						],
						[
							-81.80089601799995,
							26.087396151000064
						],
						[
							-81.80091571699995,
							26.087495884000077
						],
						[
							-81.80092098599994,
							26.08753370200009
						],
						[
							-81.8011296919999,
							26.08814920800006
						],
						[
							-81.80116365999994,
							26.08828183500009
						],
						[
							-81.8011723159999,
							26.08834323900004
						],
						[
							-81.8011823189999,
							26.08843764100004
						],
						[
							-81.80130746899994,
							26.088479861000053
						],
						[
							-81.8013742629999,
							26.088505394000038
						],
						[
							-81.80143881599992,
							26.088536153000064
						],
						[
							-81.8015007219999,
							26.08857194300009
						],
						[
							-81.80155958799992,
							26.088612539000053
						],
						[
							-81.80157958799992,
							26.088627538000082
						],
						[
							-81.80163810199991,
							26.088675394000063
						],
						[
							-81.80169238999991,
							26.08872799500006
						],
						[
							-81.80174206899994,
							26.088784968000084
						],
						[
							-81.8017867879999,
							26.088845913000057
						],
						[
							-81.80182623099995,
							26.088910398000053
						],
						[
							-81.80186011899991,
							26.088977967000062
						],
						[
							-81.80186911899995,
							26.08899796700007
						],
						[
							-81.80189584199991,
							26.089064281000052
						],
						[
							-81.80191721299991,
							26.08913250800009
						],
						[
							-81.80193309599991,
							26.089202217000036
						],
						[
							-81.80194339199994,
							26.089272967000056
						],
						[
							-81.80194803599994,
							26.089344312000037
						],
						[
							-81.8019469969999,
							26.08941580000004
						],
						[
							-81.80194028299991,
							26.08948698000006
						],
						[
							-81.80193257899992,
							26.089544209000053
						],
						[
							-81.80194691799994,
							26.08961399100008
						],
						[
							-81.80195165899994,
							26.089638834000084
						],
						[
							-81.8019652129999,
							26.089781022000068
						],
						[
							-81.80196771599992,
							26.08994199900008
						],
						[
							-81.8019790059999,
							26.090071840000064
						],
						[
							-81.80200546999993,
							26.090264047000062
						],
						[
							-81.8020556059999,
							26.090405426000075
						],
						[
							-81.80209365899992,
							26.090549834000058
						],
						[
							-81.80210494499994,
							26.090640659000087
						],
						[
							-81.80212152099995,
							26.090868199000056
						],
						[
							-81.80214809899991,
							26.090914534000035
						],
						[
							-81.80215990499994,
							26.090938840000035
						],
						[
							-81.80224887999992,
							26.090951112000084
						],
						[
							-81.80228216599994,
							26.090956341000037
						],
						[
							-81.80243358599995,
							26.090996914000073
						],
						[
							-81.80257566099993,
							26.091063164000047
						],
						[
							-81.80270407299992,
							26.091153079000037
						],
						[
							-81.80281492099994,
							26.091263927000057
						],
						[
							-81.80290483599993,
							26.091392339000038
						],
						[
							-81.8029455379999,
							26.091471610000045
						],
						[
							-81.80297708699993,
							26.091547413000058
						],
						[
							-81.80301765999991,
							26.091698834000056
						],
						[
							-81.80303132199992,
							26.091855000000066
						],
						[
							-81.80301765999991,
							26.092011165000088
						],
						[
							-81.80297708699993,
							26.092162586000086
						],
						[
							-81.80296008399995,
							26.092205917000058
						],
						[
							-81.80290383599993,
							26.092321661000085
						],
						[
							-81.80281392099994,
							26.092450073000066
						],
						[
							-81.80270307299992,
							26.092560921000086
						],
						[
							-81.80257466099994,
							26.092650836000075
						],
						[
							-81.80250185599994,
							26.092688554000063
						],
						[
							-81.8024758549999,
							26.09270055400009
						],
						[
							-81.8024065859999,
							26.092729086000077
						],
						[
							-81.80226275599995,
							26.09276828700007
						],
						[
							-81.80207375599991,
							26.092803287000038
						],
						[
							-81.80194700099992,
							26.09281756000007
						],
						[
							-81.80183494199991,
							26.092822175000038
						],
						[
							-81.80172228899994,
							26.09284146600004
						],
						[
							-81.80170266099992,
							26.092852836000077
						],
						[
							-81.80156058699993,
							26.092919086000055
						],
						[
							-81.80154315999994,
							26.09292340500008
						],
						[
							-81.80098100299995,
							26.09280890000008
						],
						[
							-81.80028636399993,
							26.09292798100006
						],
						[
							-81.7994527969999,
							26.093166143000076
						],
						[
							-81.7987978509999,
							26.093245530000047
						],
						[
							-81.79848030199992,
							26.09372185400008
						],
						[
							-81.79838106799991,
							26.094019556000035
						],
						[
							-81.79835339699991,
							26.094462286000066
						],
						[
							-81.7976789999999,
							26.094421983000075
						],
						[
							-81.79754904499993,
							26.09405584700005
						],
						[
							-81.79711782899994,
							26.09336755900006
						],
						[
							-81.7969027179999,
							26.093272846000048
						],
						[
							-81.79673747899994,
							26.093199952000077
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Collier",
				"City": "Naples",
				"Name": "Keewaydin",
				"RegionID": "274165"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.6075819269999,
					30.16727001000004,
					-81.55629473199993,
					30.206107097000086
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.57876385999992,
							30.206107097000086
						],
						[
							-81.5711759479999,
							30.195644977000082
						],
						[
							-81.56466290799995,
							30.188694010000063
						],
						[
							-81.56242690699992,
							30.186311010000058
						],
						[
							-81.56166590799995,
							30.185655010000065
						],
						[
							-81.55859684399991,
							30.18304806500004
						],
						[
							-81.5586689079999,
							30.182632010000077
						],
						[
							-81.55874290799994,
							30.182179010000088
						],
						[
							-81.5588079069999,
							30.181737011000052
						],
						[
							-81.55888690899991,
							30.18120701000004
						],
						[
							-81.55894790699995,
							30.18090201100006
						],
						[
							-81.55899890799992,
							30.18059301100004
						],
						[
							-81.55910090799995,
							30.179963011000044
						],
						[
							-81.55912390599991,
							30.17965001100003
						],
						[
							-81.55915690699993,
							30.179345010000077
						],
						[
							-81.55918490599993,
							30.17902801000008
						],
						[
							-81.55919790699994,
							30.178718011000058
						],
						[
							-81.55921190799995,
							30.178209011000035
						],
						[
							-81.55920790799992,
							30.177675010000087
						],
						[
							-81.55919390699995,
							30.177338011000078
						],
						[
							-81.55916090699992,
							30.176976011000075
						],
						[
							-81.55908190699995,
							30.176374011000064
						],
						[
							-81.55906881699991,
							30.176149019000036
						],
						[
							-81.55902890599992,
							30.175888011000044
						],
						[
							-81.5589889069999,
							30.17561101100006
						],
						[
							-81.55895290899991,
							30.17540401000008
						],
						[
							-81.55886890599994,
							30.175001010000074
						],
						[
							-81.55881590699994,
							30.174774011000064
						],
						[
							-81.55872690799993,
							30.17443601000008
						],
						[
							-81.55866490799991,
							30.17421301100006
						],
						[
							-81.55859290699993,
							30.17398701000008
						],
						[
							-81.55844690799995,
							30.173537010000075
						],
						[
							-81.5576089079999,
							30.17174801100009
						],
						[
							-81.55711790599992,
							30.17072801000006
						],
						[
							-81.5567319079999,
							30.16997501100008
						],
						[
							-81.55654090699994,
							30.16956901000009
						],
						[
							-81.55646490899994,
							30.169373010000072
						],
						[
							-81.5563809059999,
							30.169132010000055
						],
						[
							-81.55629473199993,
							30.168893946000082
						],
						[
							-81.55677890699991,
							30.168615010000053
						],
						[
							-81.55743087799993,
							30.168237826000052
						],
						[
							-81.55760790799991,
							30.16827501100005
						],
						[
							-81.5577719069999,
							30.16829701000006
						],
						[
							-81.55794490799993,
							30.168311010000085
						],
						[
							-81.55807390799993,
							30.168320010000055
						],
						[
							-81.55824390699992,
							30.16832201000005
						],
						[
							-81.55840690899993,
							30.168320010000055
						],
						[
							-81.55849990599995,
							30.16830901000009
						],
						[
							-81.55857390699992,
							30.168300011000046
						],
						[
							-81.5586509069999,
							30.168290010000078
						],
						[
							-81.55879690899991,
							30.168267010000083
						],
						[
							-81.55884890699991,
							30.16826401000009
						],
						[
							-81.55906040699995,
							30.16822951000006
						],
						[
							-81.55912090899994,
							30.16821601000004
						],
						[
							-81.5593609089999,
							30.168164010000055
						],
						[
							-81.55953490699994,
							30.16812701100008
						],
						[
							-81.55995590799996,
							30.168032011000037
						],
						[
							-81.56022090599993,
							30.16796701100009
						],
						[
							-81.56086190899993,
							30.167822010000066
						],
						[
							-81.56112690799996,
							30.167784010000048
						],
						[
							-81.56162090899994,
							30.167663010000066
						],
						[
							-81.56192190799993,
							30.16759701100006
						],
						[
							-81.56221990699993,
							30.167548010000075
						],
						[
							-81.5624549069999,
							30.167512010000056
						],
						[
							-81.56276690699991,
							30.167464010000064
						],
						[
							-81.56406790799991,
							30.16733901100008
						],
						[
							-81.56491290699995,
							30.167293010000034
						],
						[
							-81.5655389069999,
							30.167276010000084
						],
						[
							-81.56625090799992,
							30.16727001000004
						],
						[
							-81.56632390699991,
							30.16727001000004
						],
						[
							-81.56710290899991,
							30.167276010000084
						],
						[
							-81.56737590599994,
							30.167282011000054
						],
						[
							-81.56749590699991,
							30.167282011000054
						],
						[
							-81.56843290599994,
							30.16733401000005
						],
						[
							-81.5700179079999,
							30.167420011000047
						],
						[
							-81.5710289079999,
							30.167478010000078
						],
						[
							-81.57106890799992,
							30.16747801100007
						],
						[
							-81.5723609069999,
							30.167554011000046
						],
						[
							-81.57376790799992,
							30.167627010000047
						],
						[
							-81.57535590899994,
							30.167713011000046
						],
						[
							-81.57594290899993,
							30.16774901100007
						],
						[
							-81.5781319059999,
							30.167869011000054
						],
						[
							-81.5801419089999,
							30.16797901000007
						],
						[
							-81.58123090899994,
							30.168039010000083
						],
						[
							-81.58313790599993,
							30.16814401000005
						],
						[
							-81.5836329089999,
							30.16817701100007
						],
						[
							-81.58580290799995,
							30.16829301000007
						],
						[
							-81.59370790699995,
							30.168715010000085
						],
						[
							-81.5956389079999,
							30.168818010000052
						],
						[
							-81.59756390899992,
							30.16893001000005
						],
						[
							-81.59823390799994,
							30.168960011000078
						],
						[
							-81.59848690699994,
							30.168969010000072
						],
						[
							-81.59923190899991,
							30.169020010000057
						],
						[
							-81.60007290599992,
							30.169070010000045
						],
						[
							-81.6010019069999,
							30.169140010000035
						],
						[
							-81.60145490699995,
							30.169197011000048
						],
						[
							-81.60193790799991,
							30.169254010000092
						],
						[
							-81.60247688599992,
							30.169312012000038
						],
						[
							-81.60260890699993,
							30.169850009000072
						],
						[
							-81.60283890799991,
							30.170617011000047
						],
						[
							-81.60365290699991,
							30.173586011000058
						],
						[
							-81.60378290799991,
							30.174036011000055
						],
						[
							-81.60402990799992,
							30.174990011000094
						],
						[
							-81.60409490799992,
							30.175234010000054
						],
						[
							-81.6041949079999,
							30.175533011000084
						],
						[
							-81.60436990699992,
							30.175991010000075
						],
						[
							-81.60462990699995,
							30.176563010000056
						],
						[
							-81.60475190799991,
							30.176868010000078
						],
						[
							-81.60484290799991,
							30.17706301100009
						],
						[
							-81.60522490799991,
							30.178009011000086
						],
						[
							-81.60546090799994,
							30.178559011000065
						],
						[
							-81.6056819069999,
							30.17910401100005
						],
						[
							-81.60591890699993,
							30.179636011000074
						],
						[
							-81.6062699069999,
							30.180479010000056
						],
						[
							-81.60655190799991,
							30.181133011000046
						],
						[
							-81.60674990699994,
							30.18162201100006
						],
						[
							-81.6073679079999,
							30.18304801100004
						],
						[
							-81.6075819269999,
							30.183592024000063
						],
						[
							-81.60425590799993,
							30.184052010000073
						],
						[
							-81.60387390799991,
							30.184105010000057
						],
						[
							-81.60368290799994,
							30.18414101100007
						],
						[
							-81.60340090699992,
							30.184193010000058
						],
						[
							-81.60285190699994,
							30.184345010000076
						],
						[
							-81.6018067519999,
							30.18464090000009
						],
						[
							-81.6018110569999,
							30.184731132000085
						],
						[
							-81.60088090699992,
							30.18490601000008
						],
						[
							-81.5999149079999,
							30.18518801000005
						],
						[
							-81.5995789079999,
							30.18527801000005
						],
						[
							-81.59853390699993,
							30.18558501100006
						],
						[
							-81.59719790699995,
							30.185984010000087
						],
						[
							-81.59550090699992,
							30.18646201100006
						],
						[
							-81.59532990899994,
							30.18651901100009
						],
						[
							-81.5951249069999,
							30.186610011000084
						],
						[
							-81.59413890799993,
							30.187149011000088
						],
						[
							-81.59371190799993,
							30.187403010000082
						],
						[
							-81.59149190699992,
							30.188654010000054
						],
						[
							-81.59106390799991,
							30.18890201100004
						],
						[
							-81.5909349069999,
							30.188982011000064
						],
						[
							-81.58875290799995,
							30.19021001000004
						],
						[
							-81.58834090699992,
							30.19037601000008
						],
						[
							-81.58808090699995,
							30.190453010000056
						],
						[
							-81.58772290699996,
							30.190525010000048
						],
						[
							-81.58722690699994,
							30.190582010000075
						],
						[
							-81.58689890699992,
							30.19060101000008
						],
						[
							-81.58669290799992,
							30.190603010000075
						],
						[
							-81.58555590799995,
							30.190598010000087
						],
						[
							-81.5848319079999,
							30.190598010000087
						],
						[
							-81.58419690799991,
							30.190616010000042
						],
						[
							-81.58398390499991,
							30.190596012000068
						],
						[
							-81.58364690799993,
							30.19063801100009
						],
						[
							-81.58341490799995,
							30.190686010000036
						],
						[
							-81.58306590799992,
							30.19080601100006
						],
						[
							-81.58261590799992,
							30.191050011000073
						],
						[
							-81.5824199079999,
							30.191197011000042
						],
						[
							-81.58231690799994,
							30.19130301000007
						],
						[
							-81.58202690799993,
							30.191531011000052
						],
						[
							-81.58183372099995,
							30.19170200000008
						],
						[
							-81.58310192199991,
							30.192988151000065
						],
						[
							-81.58334308299993,
							30.194556814000062
						],
						[
							-81.58334308399992,
							30.201917095000052
						],
						[
							-81.58338190899991,
							30.20599906400008
						],
						[
							-81.58225390699994,
							30.206019010000034
						],
						[
							-81.58151190699994,
							30.20602001000009
						],
						[
							-81.58011590799993,
							30.20604101000004
						],
						[
							-81.57913990599991,
							30.206093009000085
						],
						[
							-81.57904790999994,
							30.20608101100004
						],
						[
							-81.57885390799993,
							30.206093011000064
						],
						[
							-81.57876385999992,
							30.206107097000086
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Mandarin Station - Losco",
				"RegionID": "276435"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.71834454699989,
					28.034956371000092,
					-82.71347967699998,
					28.043579543000106
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.7146917099999,
							28.043387079000077
						],
						[
							-82.7146144839999,
							28.043384730000064
						],
						[
							-82.71440708199988,
							28.04338684000006
						],
						[
							-82.71412470899988,
							28.043390028000054
						],
						[
							-82.71385192199996,
							28.04339282100002
						],
						[
							-82.71359574499989,
							28.04339518400004
						],
						[
							-82.71355447099995,
							28.043376060000057
						],
						[
							-82.7135399289999,
							28.043348888000118
						],
						[
							-82.71353209899988,
							28.043079556000038
						],
						[
							-82.71352581499988,
							28.042832048000072
						],
						[
							-82.71352512699993,
							28.04253706500009
						],
						[
							-82.71352298199992,
							28.042256186000124
						],
						[
							-82.71352116699985,
							28.041981150000105
						],
						[
							-82.71351694699986,
							28.041679310000085
						],
						[
							-82.71351287699989,
							28.04138537600002
						],
						[
							-82.71350903899992,
							28.041126853000033
						],
						[
							-82.71349257199998,
							28.04080410400006
						],
						[
							-82.71349127999987,
							28.04046133600012
						],
						[
							-82.71348709799987,
							28.040106549000072
						],
						[
							-82.71347967699998,
							28.039833261000112
						],
						[
							-82.71348821599989,
							28.039482877000076
						],
						[
							-82.71349832399993,
							28.039135580000032
						],
						[
							-82.71350092699996,
							28.038869459000033
						],
						[
							-82.71349430699995,
							28.03833590600003
						],
						[
							-82.7134947019999,
							28.03792608600005
						],
						[
							-82.7135817239999,
							28.037534381000057
						],
						[
							-82.71363620099996,
							28.037289995000002
						],
						[
							-82.71364475599995,
							28.03726554100011
						],
						[
							-82.71377059399988,
							28.036986747000043
						],
						[
							-82.71381102599995,
							28.03691915100005
						],
						[
							-82.71395685999994,
							28.03670557700005
						],
						[
							-82.71413003499997,
							28.036495298000062
						],
						[
							-82.71433734899998,
							28.036291718000093
						],
						[
							-82.7143964499999,
							28.036234338000053
						],
						[
							-82.71455829999987,
							28.036099412000077
						],
						[
							-82.7146714869999,
							28.036018028000093
						],
						[
							-82.71482374899999,
							28.03592715900004
						],
						[
							-82.71513813899989,
							28.035772872000063
						],
						[
							-82.71539033399996,
							28.035677013000033
						],
						[
							-82.7154905009999,
							28.03564829900006
						],
						[
							-82.71564365199988,
							28.035604181000046
						],
						[
							-82.71593195499993,
							28.035548357000046
						],
						[
							-82.71622203199986,
							28.03549699300006
						],
						[
							-82.7162623099999,
							28.035494033000088
						],
						[
							-82.71652906299995,
							28.035431788000082
						],
						[
							-82.71657984499988,
							28.03542017800001
						],
						[
							-82.71690435999992,
							28.035318093000093
						],
						[
							-82.71692752999988,
							28.035306283000093
						],
						[
							-82.71720997199989,
							28.03517038000004
						],
						[
							-82.71727507899995,
							28.035128096000093
						],
						[
							-82.71756997299993,
							28.034956371000092
						],
						[
							-82.71776458899986,
							28.03517642200009
						],
						[
							-82.71792631999992,
							28.035359514000056
						],
						[
							-82.7181149859999,
							28.03557306300005
						],
						[
							-82.71834454699989,
							28.035832469000106
						],
						[
							-82.71809708999993,
							28.036058612000076
						],
						[
							-82.71763155199996,
							28.036484615000063
						],
						[
							-82.71726094099994,
							28.036823481000038
						],
						[
							-82.71705170899995,
							28.037014699000046
						],
						[
							-82.71683044399992,
							28.037217324000025
						],
						[
							-82.7166088799999,
							28.03741960700007
						],
						[
							-82.71639695199994,
							28.037613588000042
						],
						[
							-82.71618184699992,
							28.037810680000092
						],
						[
							-82.71603365599991,
							28.037945881
						],
						[
							-82.71596790399988,
							28.038227801000055
						],
						[
							-82.71590497799991,
							28.038497330000062
						],
						[
							-82.71584167499992,
							28.03876858000004
						],
						[
							-82.71577894299988,
							28.03903810700005
						],
						[
							-82.71571591699991,
							28.039307292000025
						],
						[
							-82.71565327799996,
							28.039576820000033
						],
						[
							-82.71564055799989,
							28.03963052000003
						],
						[
							-82.71564170399998,
							28.03984780000007
						],
						[
							-82.7156429419999,
							28.04012283900009
						],
						[
							-82.71564437499985,
							28.04039787700011
						],
						[
							-82.71564561499996,
							28.040672915000037
						],
						[
							-82.7156471439999,
							28.040947953000057
						],
						[
							-82.7156482849999,
							28.04122299200008
						],
						[
							-82.71564981699996,
							28.0414980300001
						],
						[
							-82.71565134599989,
							28.04177306700003
						],
						[
							-82.71565315699986,
							28.042090735000023
						],
						[
							-82.71565392199993,
							28.042250257000077
						],
						[
							-82.71551902899996,
							28.042390202000025
						],
						[
							-82.71542079399993,
							28.042492136000106
						],
						[
							-82.71590782899997,
							28.042864004000055
						],
						[
							-82.7161377179999,
							28.043039866000036
						],
						[
							-82.71601579999994,
							28.043251943000087
						],
						[
							-82.71597289199994,
							28.043326429000032
						],
						[
							-82.71582702399986,
							28.043579543000106
						],
						[
							-82.71556384399993,
							28.04349668200009
						],
						[
							-82.71524070199993,
							28.043429604000046
						],
						[
							-82.71496247299991,
							28.043400797000064
						],
						[
							-82.71489296799994,
							28.043393939000026
						],
						[
							-82.7146917099999,
							28.043387079000077
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Landmark-Countryside Homeowners Assoc",
				"RegionID": "343258"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.58969055699993,
					30.46091695700005,
					-81.53905463799993,
					30.522290051000088
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.57669067099994,
							30.521506861000034
						],
						[
							-81.57634032899995,
							30.52142900700005
						],
						[
							-81.57598998599991,
							30.521584715000074
						],
						[
							-81.57563964299993,
							30.52177935000009
						],
						[
							-81.57513359199993,
							30.52170149600005
						],
						[
							-81.57482217699993,
							30.52135115300007
						],
						[
							-81.57462754199992,
							30.520922957000042
						],
						[
							-81.57431612599993,
							30.52061154100005
						],
						[
							-81.5739268559999,
							30.520455833000085
						],
						[
							-81.57326509699993,
							30.52037797900005
						],
						[
							-81.57264226599995,
							30.520105490000052
						],
						[
							-81.5723308499999,
							30.519833001000055
						],
						[
							-81.5718247989999,
							30.520144417000036
						],
						[
							-81.57139660199994,
							30.519910855000035
						],
						[
							-81.57089055199994,
							30.51987192800004
						],
						[
							-81.5704623549999,
							30.519910855000035
						],
						[
							-81.5699563039999,
							30.519988709000078
						],
						[
							-81.56952810799993,
							30.520300125000063
						],
						[
							-81.56898312999994,
							30.52053368700007
						],
						[
							-81.5686327869999,
							30.52037797900005
						],
						[
							-81.56832137099991,
							30.520066563000057
						],
						[
							-81.56832137099991,
							30.51971622000008
						],
						[
							-81.56851600599992,
							30.519443731000084
						],
						[
							-81.56843815199994,
							30.519054462000042
						],
						[
							-81.56793210099994,
							30.51862626500008
						],
						[
							-81.56738712399995,
							30.51843163000007
						],
						[
							-81.56738712399995,
							30.51769201700006
						],
						[
							-81.56765961299995,
							30.51718596700005
						],
						[
							-81.56804888199991,
							30.516640989000056
						],
						[
							-81.56824351699993,
							30.51613493800005
						],
						[
							-81.5683602979999,
							30.515473180000075
						],
						[
							-81.5683602979999,
							30.514967129000066
						],
						[
							-81.56824351699993,
							30.514538932000054
						],
						[
							-81.56793210099994,
							30.514149662000083
						],
						[
							-81.56750390499991,
							30.513877174000072
						],
						[
							-81.56688107299993,
							30.51372146600005
						],
						[
							-81.56614145999993,
							30.513877174000072
						],
						[
							-81.5654407749999,
							30.51457785900004
						],
						[
							-81.5648957969999,
							30.514967129000066
						],
						[
							-81.56431189299991,
							30.51520069100008
						],
						[
							-81.56365013399994,
							30.515278545000058
						],
						[
							-81.56302730199991,
							30.515161764000084
						],
						[
							-81.56240447099992,
							30.514889275000087
						],
						[
							-81.56162593099992,
							30.514538932000054
						],
						[
							-81.56084739099992,
							30.514344297000036
						],
						[
							-81.56002992499992,
							30.51411073500009
						],
						[
							-81.55956280099991,
							30.513643612000067
						],
						[
							-81.55940709299995,
							30.51274829100004
						],
						[
							-81.55929031199992,
							30.511930825000036
						],
						[
							-81.55886211599996,
							30.511502628000073
						],
						[
							-81.55831713799995,
							30.511463701000086
						],
						[
							-81.55722718299995,
							30.511852971000057
						],
						[
							-81.55613722699991,
							30.512203313000047
						],
						[
							-81.55539761499995,
							30.512592583000075
						],
						[
							-81.55473585599992,
							30.513215415000047
						],
						[
							-81.55450229399992,
							30.513877174000072
						],
						[
							-81.55434658599995,
							30.514461078000068
						],
						[
							-81.55368482799992,
							30.51520069100008
						],
						[
							-81.55267272599991,
							30.515706741000084
						],
						[
							-81.55146598999994,
							30.515901376000045
						],
						[
							-81.5508431579999,
							30.515823522000066
						],
						[
							-81.55045388799994,
							30.515551034000055
						],
						[
							-81.55018139999993,
							30.515161764000084
						],
						[
							-81.55018139999993,
							30.514694640000076
						],
						[
							-81.55014247299994,
							30.514149662000083
						],
						[
							-81.5497921299999,
							30.513254342000042
						],
						[
							-81.5492860789999,
							30.512359021000062
						],
						[
							-81.54885788199994,
							30.511619409000044
						],
						[
							-81.54858539299994,
							30.511307993000063
						],
						[
							-81.54811826999992,
							30.511035504000066
						],
						[
							-81.54745651099995,
							30.51099657700007
						],
						[
							-81.54663904499995,
							30.511113358000046
						],
						[
							-81.54551016199993,
							30.511502628000073
						],
						[
							-81.54492625799992,
							30.51189189800004
						],
						[
							-81.54474201099993,
							30.512112912000077
						],
						[
							-81.54468125299991,
							30.512103875000037
						],
						[
							-81.54462133999994,
							30.512090327000063
						],
						[
							-81.5445626049999,
							30.512072342000067
						],
						[
							-81.54450537799994,
							30.512050022000043
						],
						[
							-81.54419558399992,
							30.511916649000057
						],
						[
							-81.5434306329999,
							30.511687318000046
						],
						[
							-81.54256921599995,
							30.511687318000046
						],
						[
							-81.54119094999993,
							30.51151503400007
						],
						[
							-81.54038121899993,
							30.511136011000076
						],
						[
							-81.53977822799993,
							30.510498563000056
						],
						[
							-81.53946811799996,
							30.509757745000062
						],
						[
							-81.53934751899993,
							30.50917198200006
						],
						[
							-81.53917523599995,
							30.50789708600007
						],
						[
							-81.53905463799993,
							30.50689784300005
						],
						[
							-81.53916685899992,
							30.50624435400005
						],
						[
							-81.5393298589999,
							30.505836354000053
						],
						[
							-81.53937885099992,
							30.505733251000038
						],
						[
							-81.53989544599995,
							30.504803380000055
						],
						[
							-81.54016576999993,
							30.50407287400009
						],
						[
							-81.54031560899996,
							30.50362617000007
						],
						[
							-81.54029658199994,
							30.503553202000038
						],
						[
							-81.54028116399991,
							30.503526661000084
						],
						[
							-81.54023115199993,
							30.503425985000035
						],
						[
							-81.5401991519999,
							30.50334998500006
						],
						[
							-81.54017709999994,
							30.503301255000054
						],
						[
							-81.54016000399992,
							30.503250574000045
						],
						[
							-81.54014803499992,
							30.50319844300009
						],
						[
							-81.54014130999991,
							30.50314538000004
						],
						[
							-81.5410389999999,
							30.502811000000065
						],
						[
							-81.54162790899994,
							30.50256101300005
						],
						[
							-81.54535805499995,
							30.50066912200009
						],
						[
							-81.54538380299994,
							30.50055485600007
						],
						[
							-81.54567701799994,
							30.500597162000076
						],
						[
							-81.54569991099994,
							30.500458012000085
						],
						[
							-81.54698890999992,
							30.496811012000084
						],
						[
							-81.54722590999995,
							30.496119013000055
						],
						[
							-81.54726390999991,
							30.495985013000052
						],
						[
							-81.54740090899992,
							30.495575013000067
						],
						[
							-81.54760690899991,
							30.494719013000065
						],
						[
							-81.54786690999993,
							30.493586012000033
						],
						[
							-81.54816390999991,
							30.492241013000072
						],
						[
							-81.54842390999994,
							30.491121015000093
						],
						[
							-81.54849986399995,
							30.490952986000085
						],
						[
							-81.5485689109999,
							30.490873013000055
						],
						[
							-81.54904190899992,
							30.490444012000065
						],
						[
							-81.54994190899993,
							30.48966001300005
						],
						[
							-81.55023190899993,
							30.489376012000037
						],
						[
							-81.55048390899992,
							30.489077012000056
						],
						[
							-81.55053690799991,
							30.488993012000034
						],
						[
							-81.55059790999991,
							30.48878701300003
						],
						[
							-81.5506519089999,
							30.488546012000086
						],
						[
							-81.55066990899991,
							30.488358013000042
						],
						[
							-81.55068990899991,
							30.488152012000057
						],
						[
							-81.5508499099999,
							30.48549501300005
						],
						[
							-81.55098690999995,
							30.48327601300008
						],
						[
							-81.55098690999995,
							30.48311201200005
						],
						[
							-81.55106390999994,
							30.482290013000068
						],
						[
							-81.55108590999993,
							30.481920013000035
						],
						[
							-81.5511859099999,
							30.48030301300008
						],
						[
							-81.5512309099999,
							30.479725012000074
						],
						[
							-81.55136090999991,
							30.477768013000055
						],
						[
							-81.55145290999991,
							30.47609301200004
						],
						[
							-81.55150590999995,
							30.475407012000062
						],
						[
							-81.5517269099999,
							30.471901012000046
						],
						[
							-81.55175790999994,
							30.471695013000044
						],
						[
							-81.55178785899994,
							30.471578994000083
						],
						[
							-81.5518209089999,
							30.471518013000036
						],
						[
							-81.55185690999991,
							30.471451015000067
						],
						[
							-81.55193290799991,
							30.47137301500004
						],
						[
							-81.55201688299991,
							30.471312966000088
						],
						[
							-81.5530549099999,
							30.470886012000054
						],
						[
							-81.5537339089999,
							30.47059401200005
						],
						[
							-81.55385590999992,
							30.470526011000064
						],
						[
							-81.55393194999994,
							30.470463046000074
						],
						[
							-81.55397803499994,
							30.470396060000038
						],
						[
							-81.55404690899991,
							30.470098012000054
						],
						[
							-81.55408290899993,
							30.46958701300008
						],
						[
							-81.55400887399992,
							30.46475401700008
						],
						[
							-81.55493090999994,
							30.464535013000045
						],
						[
							-81.55636390899991,
							30.464196012000055
						],
						[
							-81.5575149089999,
							30.46393401200004
						],
						[
							-81.5578109089999,
							30.46385201200008
						],
						[
							-81.56058590999993,
							30.46302401200006
						],
						[
							-81.56072590999992,
							30.462989013000087
						],
						[
							-81.56084890999995,
							30.46296801300008
						],
						[
							-81.56099390999992,
							30.46296701200004
						],
						[
							-81.5619100529999,
							30.462959130000062
						],
						[
							-81.5617660879999,
							30.462320144000046
						],
						[
							-81.56191590899994,
							30.462506010000084
						],
						[
							-81.56205990799992,
							30.46263001000006
						],
						[
							-81.56221590699994,
							30.462732010000078
						],
						[
							-81.56240990799995,
							30.462829010000064
						],
						[
							-81.56258490699992,
							30.46288301000004
						],
						[
							-81.56280390599994,
							30.462953006000077
						],
						[
							-81.5636919079999,
							30.462932010000088
						],
						[
							-81.56639890799994,
							30.46290401000005
						],
						[
							-81.56744290699993,
							30.462893010000073
						],
						[
							-81.5690989069999,
							30.462875010000058
						],
						[
							-81.56921790699994,
							30.46287201100006
						],
						[
							-81.57067090699991,
							30.462837010000044
						],
						[
							-81.57100690699991,
							30.46281201100004
						],
						[
							-81.57149490699993,
							30.462757010000075
						],
						[
							-81.57189890799992,
							30.462687010000078
						],
						[
							-81.5722729069999,
							30.462605011000054
						],
						[
							-81.57407390799995,
							30.46214101000004
						],
						[
							-81.57575190799992,
							30.46169501000009
						],
						[
							-81.57617190799994,
							30.46159001000007
						],
						[
							-81.57691190799994,
							30.461388010000064
						],
						[
							-81.5782549079999,
							30.461020010000084
						],
						[
							-81.5786819089999,
							30.460926011000087
						],
						[
							-81.57900991199995,
							30.46091695700005
						],
						[
							-81.57910190799993,
							30.46312501100005
						],
						[
							-81.57927690799994,
							30.46641501000005
						],
						[
							-81.5792919079999,
							30.46683701100005
						],
						[
							-81.57945990699994,
							30.469944010000066
						],
						[
							-81.5794529069999,
							30.47019400900007
						],
						[
							-81.57942990999993,
							30.470306011000044
						],
						[
							-81.5794299069999,
							30.470367009000086
						],
						[
							-81.57937590699993,
							30.47061701100006
						],
						[
							-81.57931490699991,
							30.470829011000035
						],
						[
							-81.57915490799991,
							30.471209010000056
						],
						[
							-81.57900990699994,
							30.47145801000005
						],
						[
							-81.57880390699995,
							30.471739011000068
						],
						[
							-81.57788090699995,
							30.472826010000063
						],
						[
							-81.57778890899993,
							30.472944010000052
						],
						[
							-81.57770490799993,
							30.473082010000045
						],
						[
							-81.57753785799991,
							30.47341699200007
						],
						[
							-81.5775299579999,
							30.473450028000062
						],
						[
							-81.57749890999992,
							30.473505009000064
						],
						[
							-81.5773999079999,
							30.473831010000087
						],
						[
							-81.57734690799994,
							30.474079010000082
						],
						[
							-81.5773159069999,
							30.474455010000042
						],
						[
							-81.5773089079999,
							30.475416011000046
						],
						[
							-81.57730090799993,
							30.47564501000005
						],
						[
							-81.57729290799995,
							30.47737901000005
						],
						[
							-81.57727790699994,
							30.479259011000064
						],
						[
							-81.57725490799994,
							30.48022701000008
						],
						[
							-81.57725490699994,
							30.48059501000006
						],
						[
							-81.57723190699994,
							30.480808010000093
						],
						[
							-81.5768589079999,
							30.482533011000047
						],
						[
							-81.5765689079999,
							30.483854010000076
						],
						[
							-81.57635990699993,
							30.484798011000066
						],
						[
							-81.57599090699995,
							30.486503010000035
						],
						[
							-81.57553090899995,
							30.48862801200005
						],
						[
							-81.57552290699994,
							30.48939901000006
						],
						[
							-81.57556190699995,
							30.493614010000048
						],
						[
							-81.57553590799995,
							30.495322011000045
						],
						[
							-81.57553590799995,
							30.49611101000005
						],
						[
							-81.57555190799991,
							30.497110010000085
						],
						[
							-81.57554790799992,
							30.498385011000035
						],
						[
							-81.57553690799995,
							30.498968010000052
						],
						[
							-81.57555090899992,
							30.499095012000055
						],
						[
							-81.5756239079999,
							30.499329010000057
						],
						[
							-81.57565490699994,
							30.499412011000064
						],
						[
							-81.57613490799991,
							30.50056001100006
						],
						[
							-81.5765939069999,
							30.50170901000007
						],
						[
							-81.57667490799992,
							30.501890010000068
						],
						[
							-81.57675890899992,
							30.502035009000053
						],
						[
							-81.57736990699993,
							30.502733011000092
						],
						[
							-81.57820083699994,
							30.50365406900005
						],
						[
							-81.57833887899994,
							30.503838142000063
						],
						[
							-81.57930790899991,
							30.50487301200008
						],
						[
							-81.57958991099993,
							30.505148013000053
						],
						[
							-81.58132890899992,
							30.507017012000063
						],
						[
							-81.58210790999993,
							30.50782801300005
						],
						[
							-81.58297690899991,
							30.50867501200008
						],
						[
							-81.58306090999992,
							30.508751013000047
						],
						[
							-81.58377090999994,
							30.509554012000084
						],
						[
							-81.58617390899991,
							30.512213013000068
						],
						[
							-81.5865549099999,
							30.512621012000068
						],
						[
							-81.58682990799991,
							30.512947012000037
						],
						[
							-81.58712790899995,
							30.51349601200008
						],
						[
							-81.58818790899994,
							30.515629013000083
						],
						[
							-81.58899690999993,
							30.51724101200006
						],
						[
							-81.58917190999996,
							30.517553012000064
						],
						[
							-81.58927590899992,
							30.51772701200008
						],
						[
							-81.58943490799993,
							30.51806801500004
						],
						[
							-81.58955090899991,
							30.518692013000074
						],
						[
							-81.58958390999993,
							30.51905501200008
						],
						[
							-81.58969055699993,
							30.51989712300008
						],
						[
							-81.5887924189999,
							30.519959786000072
						],
						[
							-81.5874979319999,
							30.51995978500008
						],
						[
							-81.58559934099992,
							30.51952829000004
						],
						[
							-81.58335555899993,
							30.51952829000004
						],
						[
							-81.58154326999994,
							30.519700891000074
						],
						[
							-81.5794720859999,
							30.520563882000094
						],
						[
							-81.5781774699999,
							30.521254153000086
						],
						[
							-81.57765983599995,
							30.522290051000088
						],
						[
							-81.57749347899994,
							30.52216016500006
						],
						[
							-81.57758899999993,
							30.522087000000056
						],
						[
							-81.57700208699993,
							30.52174042300004
						],
						[
							-81.57669067099994,
							30.521506861000034
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "The Cape",
				"RegionID": "269209"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.32502656423148,
					28.531506880270136,
					-81.31963034247396,
					28.53965907708445
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.31963034247396,
							28.53300413093981
						],
						[
							-81.32064395304464,
							28.531506880270136
						],
						[
							-81.32491541522319,
							28.531558009425538
						],
						[
							-81.32493539096406,
							28.532827894398977
						],
						[
							-81.32494840954982,
							28.533949558511594
						],
						[
							-81.3249494104952,
							28.534405234191894
						],
						[
							-81.32497144388488,
							28.535361652378228
						],
						[
							-81.32497044293952,
							28.535686134061706
						],
						[
							-81.32497044293952,
							28.535833352178514
						],
						[
							-81.32497544946521,
							28.53654640932713
						],
						[
							-81.32499548006477,
							28.537536878543378
						],
						[
							-81.32502656423148,
							28.538781711103162
						],
						[
							-81.32502555339349,
							28.5392985406815
						],
						[
							-81.32468501791251,
							28.539364589589262
						],
						[
							-81.32330797602125,
							28.539579908866784
						],
						[
							-81.32271411951106,
							28.53965907708445
						],
						[
							-81.32269506737386,
							28.53894396498496
						],
						[
							-81.32266988635705,
							28.535644947810674
						],
						[
							-81.32299461985063,
							28.535608174532918
						],
						[
							-81.32313991072037,
							28.535355672786036
						],
						[
							-81.3230677545167,
							28.535065074858707
						],
						[
							-81.32274213788881,
							28.534993105714022
						],
						[
							-81.32060687040013,
							28.534849051412024
						],
						[
							-81.31970263267667,
							28.533256531962557
						],
						[
							-81.31963034247396,
							28.53300413093981
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "The Dovers",
				"RegionID": "269210"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.44722299986724,
					28.57830799977264,
					-81.44310807098329,
					28.585776072742092
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.44310807098329,
							28.5783531844093
						],
						[
							-81.4434080002759,
							28.578310999911007
						],
						[
							-81.44349299969753,
							28.578313000003096
						],
						[
							-81.4446120000182,
							28.57830799977264
						],
						[
							-81.44629300016493,
							28.57841200007008
						],
						[
							-81.44699300005693,
							28.578418000346716
						],
						[
							-81.44720099975252,
							28.57842699986216
						],
						[
							-81.44720199979862,
							28.578877999967332
						],
						[
							-81.44720700002907,
							28.580377999864332
						],
						[
							-81.44722164548831,
							28.585298769850045
						],
						[
							-81.44722299986724,
							28.585754000365988
						],
						[
							-81.4470730001474,
							28.585774000388696
						],
						[
							-81.44325100011662,
							28.585775999790847
						],
						[
							-81.44311193387917,
							28.585776072742092
						],
						[
							-81.44310807098329,
							28.5783531844093
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "The Willows",
				"RegionID": "269211"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.36849498964742,
					28.537281498966067,
					-81.36312889877523,
					28.54580219028383
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.36644407856504,
							28.541934526394495
						],
						[
							-81.36638399036369,
							28.538439084698403
						],
						[
							-81.36614337585537,
							28.538439349099086
						],
						[
							-81.36611145891659,
							28.537304477543245
						],
						[
							-81.3662897207306,
							28.53729952587608
						],
						[
							-81.36731824655716,
							28.537281498966067
						],
						[
							-81.36807436774113,
							28.537281498966067
						],
						[
							-81.36837180771042,
							28.53728550634503
						],
						[
							-81.36837180860978,
							28.53732856948111
						],
						[
							-81.36838883457442,
							28.5384872883592
						],
						[
							-81.36840686058515,
							28.539278461518542
						],
						[
							-81.36842388654988,
							28.539864330250474
						],
						[
							-81.36843590419018,
							28.540551349328368
						],
						[
							-81.3684419125606,
							28.54137156609265
						],
						[
							-81.36844992462059,
							28.542162738352623
						],
						[
							-81.36845293015482,
							28.542356025139824
						],
						[
							-81.36846594874049,
							28.54363592406409
						],
						[
							-81.36847295895566,
							28.544752579852197
						],
						[
							-81.36849498964742,
							28.54574710860816
						],
						[
							-81.36643293416647,
							28.545773093618926
						],
						[
							-81.36618556664907,
							28.5457760973545
						],
						[
							-81.36487261943883,
							28.545787114049347
						],
						[
							-81.36439288779357,
							28.545793068460537
						],
						[
							-81.36406842589516,
							28.54579512520997
						],
						[
							-81.36329727883881,
							28.54580219028383
						],
						[
							-81.36312889877523,
							28.541994358289045
						],
						[
							-81.36644407856504,
							28.541934526394495
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Thornton Park",
				"RegionID": "269212"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.44584299999991,
					28.545866000000046,
					-81.40560088699993,
					28.560279000000037
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-81.41288099999991,
								28.54686600000008
							],
							[
								-81.41284799999994,
								28.545866000000046
							],
							[
								-81.4137016169999,
								28.546136312000044
							],
							[
								-81.41374799999994,
								28.546151000000066
							],
							[
								-81.41378099999991,
								28.546842000000083
							],
							[
								-81.41369757299992,
								28.54684416500004
							],
							[
								-81.41312599999992,
								28.54685900000004
							],
							[
								-81.41288099999991,
								28.54686600000008
							]
						]
					],
					[
						[
							[
								-81.43159899999995,
								28.551066000000052
							],
							[
								-81.43195299999991,
								28.55102700000009
							],
							[
								-81.43198299999995,
								28.551528000000076
							],
							[
								-81.43159999999995,
								28.551528000000076
							],
							[
								-81.43159899999995,
								28.551066000000052
							]
						]
					],
					[
						[
							[
								-81.44189599999993,
								28.551776373000056
							],
							[
								-81.44189599999993,
								28.551531000000068
							],
							[
								-81.44210399999992,
								28.551531000000068
							],
							[
								-81.44210399999992,
								28.551159000000045
							],
							[
								-81.44225489899992,
								28.551159000000045
							],
							[
								-81.44255299999992,
								28.551159000000045
							],
							[
								-81.44268999999991,
								28.551159000000045
							],
							[
								-81.44268899999992,
								28.551078000000075
							],
							[
								-81.44269359899994,
								28.550219602000084
							],
							[
								-81.4426936349999,
								28.550212874000067
							],
							[
								-81.4426949999999,
								28.54995800000006
							],
							[
								-81.44270543199991,
								28.549957936000055
							],
							[
								-81.4441049429999,
								28.549949385000048
							],
							[
								-81.44416799999993,
								28.549949000000083
							],
							[
								-81.4441717229999,
								28.550616593000086
							],
							[
								-81.44417226799993,
								28.55071447200004
							],
							[
								-81.44417399999992,
								28.55102500000004
							],
							[
								-81.44584299999991,
								28.55102500000004
							],
							[
								-81.44584299999991,
								28.55230548800006
							],
							[
								-81.44584299999991,
								28.552526000000057
							],
							[
								-81.44534199999993,
								28.55252100000007
							],
							[
								-81.4453400079999,
								28.552293212000052
							],
							[
								-81.44533599999994,
								28.55183500000004
							],
							[
								-81.44485199999991,
								28.55183500000004
							],
							[
								-81.44485199999991,
								28.552281302000043
							],
							[
								-81.44485199999991,
								28.552516000000086
							],
							[
								-81.44446999999991,
								28.552516000000086
							],
							[
								-81.44446999999991,
								28.552271979000068
							],
							[
								-81.44446999999991,
								28.55206000000004
							],
							[
								-81.44436623899992,
								28.55206000000004
							],
							[
								-81.44405999999992,
								28.55206000000004
							],
							[
								-81.44405999999992,
								28.55175068300008
							],
							[
								-81.44405999999992,
								28.551145000000076
							],
							[
								-81.4433479999999,
								28.55114000000009
							],
							[
								-81.4433479999999,
								28.551630000000046
							],
							[
								-81.44274421499995,
								28.551626395000085
							],
							[
								-81.44267799999994,
								28.551626000000056
							],
							[
								-81.44266599999992,
								28.551821000000075
							],
							[
								-81.44266299999992,
								28.55272400000007
							],
							[
								-81.44252799999992,
								28.552728000000062
							],
							[
								-81.44237499999991,
								28.55272900000006
							],
							[
								-81.44166199999995,
								28.55273500000004
							],
							[
								-81.4416609999999,
								28.552685000000054
							],
							[
								-81.44165499999991,
								28.55225900000005
							],
							[
								-81.44189599999993,
								28.55225900000005
							],
							[
								-81.44189599999993,
								28.551776373000056
							]
						]
					],
					[
						[
							[
								-81.4389913629999,
								28.558792759000085
							],
							[
								-81.43894640699995,
								28.55876054400005
							],
							[
								-81.43889138499992,
								28.55876962800005
							],
							[
								-81.43883281799992,
								28.558775396000044
							],
							[
								-81.43877399999991,
								28.558777322000083
							],
							[
								-81.4387151809999,
								28.558775396000044
							],
							[
								-81.4386566149999,
								28.55876962800005
							],
							[
								-81.43859855099993,
								28.558760041000085
							],
							[
								-81.43854123799991,
								28.558746678000094
							],
							[
								-81.43848492199993,
								28.558729595000045
							],
							[
								-81.43842984399993,
								28.558708865000085
							],
							[
								-81.43837623999991,
								28.558684577000065
							],
							[
								-81.4383243389999,
								28.558656835000082
							],
							[
								-81.43827436299995,
								28.55862575900005
							],
							[
								-81.43822652699993,
								28.558591480000075
							],
							[
								-81.4382214499999,
								28.558587555000088
							],
							[
								-81.43821419499994,
								28.558586827000056
							],
							[
								-81.43820723499994,
								28.55858610100006
							],
							[
								-81.43798296299991,
								28.55856182900004
							],
							[
								-81.43796974199995,
								28.55856059900009
							],
							[
								-81.43731318399995,
								28.558336453000038
							],
							[
								-81.43662079699993,
								28.558471685000086
							],
							[
								-81.43664179099994,
								28.557936402000053
							],
							[
								-81.43664218899995,
								28.556019155000058
							],
							[
								-81.43152327899993,
								28.556113362000076
							],
							[
								-81.43152299999991,
								28.556171000000063
							],
							[
								-81.43152499999991,
								28.556476000000092
							],
							[
								-81.43152499999991,
								28.55654900000008
							],
							[
								-81.43068099999995,
								28.55654800000008
							],
							[
								-81.43066499999992,
								28.556178000000045
							],
							[
								-81.43066499999992,
								28.556129182000063
							],
							[
								-81.4304478709999,
								28.55613345800009
							],
							[
								-81.4299404919999,
								28.556140337000045
							],
							[
								-81.42995899999994,
								28.55654900000008
							],
							[
								-81.4272059999999,
								28.556552000000067
							],
							[
								-81.42690199999993,
								28.556550000000072
							],
							[
								-81.42689629299991,
								28.55618326300004
							],
							[
								-81.42526221199995,
								28.556206303000067
							],
							[
								-81.42525899999993,
								28.556550000000072
							],
							[
								-81.4251270929999,
								28.556550249000054
							],
							[
								-81.42313799999994,
								28.556554000000062
							],
							[
								-81.42313799999994,
								28.559896053000045
							],
							[
								-81.42015996599991,
								28.559901022000076
							],
							[
								-81.42006760899994,
								28.559901177000086
							],
							[
								-81.41513111899991,
								28.559918124000035
							],
							[
								-81.41466246099992,
								28.558596111000043
							],
							[
								-81.41449621299996,
								28.558123410000064
							],
							[
								-81.41442421699992,
								28.557910942000035
							],
							[
								-81.41376902299993,
								28.55789391400009
							],
							[
								-81.41370114799992,
								28.558129574000077
							],
							[
								-81.41174299499995,
								28.55812954000004
							],
							[
								-81.41177734999991,
								28.55782588300008
							],
							[
								-81.41133853499991,
								28.557589617000076
							],
							[
								-81.41106812999993,
								28.557319216000053
							],
							[
								-81.41076460399995,
								28.55691364800009
							],
							[
								-81.41069657999992,
								28.55651001600006
							],
							[
								-81.41069670799993,
								28.556340636000073
							],
							[
								-81.4097179929999,
								28.556340900000066
							],
							[
								-81.40971826099991,
								28.554248530000052
							],
							[
								-81.40560088699993,
								28.55424879600008
							],
							[
								-81.40565109199991,
								28.552871567000068
							],
							[
								-81.40568227099993,
								28.552871753000094
							],
							[
								-81.40568314299992,
								28.552794505000065
							],
							[
								-81.40569716499994,
								28.55207043300004
							],
							[
								-81.40569015399991,
								28.551814052000054
							],
							[
								-81.4056870149999,
								28.551700752000045
							],
							[
								-81.40968521399992,
								28.551675981000074
							],
							[
								-81.40967005599992,
								28.550528134000047
							],
							[
								-81.40978511499992,
								28.550527871000043
							],
							[
								-81.40978799999993,
								28.550706000000048
							],
							[
								-81.4113309999999,
								28.550706000000048
							],
							[
								-81.4113309999999,
								28.549993000000086
							],
							[
								-81.4116919999999,
								28.549979000000064
							],
							[
								-81.41176599999994,
								28.549986000000047
							],
							[
								-81.41384599999992,
								28.54998900000004
							],
							[
								-81.41384599999992,
								28.549281000000065
							],
							[
								-81.41387999999995,
								28.54867900000005
							],
							[
								-81.41390399999996,
								28.548557000000077
							],
							[
								-81.41335538399994,
								28.548561283000083
							],
							[
								-81.41249499999994,
								28.548568000000046
							],
							[
								-81.41249599999992,
								28.54855900000007
							],
							[
								-81.41249699999993,
								28.548550000000034
							],
							[
								-81.41250317899994,
								28.54816536700008
							],
							[
								-81.4125049999999,
								28.54805200000004
							],
							[
								-81.4125039999999,
								28.547853000000092
							],
							[
								-81.41215499999993,
								28.547453000000075
							],
							[
								-81.41215399999993,
								28.547059000000047
							],
							[
								-81.4128859999999,
								28.54702800000007
							],
							[
								-81.41289099999995,
								28.54716600000006
							],
							[
								-81.41312499999992,
								28.54715900000008
							],
							[
								-81.41312599999992,
								28.547637000000066
							],
							[
								-81.41370148999994,
								28.547638989000063
							],
							[
								-81.41381266699995,
								28.547639373000038
							],
							[
								-81.41399399999996,
								28.547640000000058
							],
							[
								-81.41412598499994,
								28.547632668000062
							],
							[
								-81.41412769899995,
								28.54765523000009
							],
							[
								-81.4141547079999,
								28.548383965000085
							],
							[
								-81.41409161299993,
								28.549146095000083
							],
							[
								-81.41408460199995,
								28.54986516200006
							],
							[
								-81.41414268799991,
								28.550582226000074
							],
							[
								-81.4141475699999,
								28.55072557200009
							],
							[
								-81.4145262589999,
								28.550712418000046
							],
							[
								-81.41546064599993,
								28.55064932600004
							],
							[
								-81.41608957599993,
								28.55065032600004
							],
							[
								-81.41612963699993,
								28.55064932600004
							],
							[
								-81.41616769199993,
								28.55064932600004
							],
							[
								-81.41640316399992,
								28.55064317000006
							],
							[
								-81.41651420699992,
								28.551308302000052
							],
							[
								-81.41652409699992,
								28.551427620000084
							],
							[
								-81.4167786459999,
								28.55142764800007
							],
							[
								-81.41704813299992,
								28.55125933900007
							],
							[
								-81.41708204799994,
								28.55116709300006
							],
							[
								-81.41711603099992,
								28.551073907000045
							],
							[
								-81.41718337499992,
								28.551015947000053
							],
							[
								-81.41717104699991,
								28.550636173000047
							],
							[
								-81.41755488399991,
								28.550635170000078
							],
							[
								-81.41756075899991,
								28.551480558000037
							],
							[
								-81.41757365599995,
								28.55158285300007
							],
							[
								-81.41798739099994,
								28.55157269500006
							],
							[
								-81.41868249499993,
								28.55156050900007
							],
							[
								-81.41938537099992,
								28.552328981000073
							],
							[
								-81.42006759299994,
								28.55244212100007
							],
							[
								-81.42006775099992,
								28.548860000000047
							],
							[
								-81.42009199999991,
								28.548860000000047
							],
							[
								-81.4202499999999,
								28.548860000000047
							],
							[
								-81.4202479999999,
								28.54761700000006
							],
							[
								-81.42339199999992,
								28.547509000000048
							],
							[
								-81.42643499999991,
								28.547404000000085
							],
							[
								-81.4264409999999,
								28.547272000000078
							],
							[
								-81.42642499999994,
								28.546504000000084
							],
							[
								-81.42671699999994,
								28.54651300000006
							],
							[
								-81.42720199999991,
								28.546511000000066
							],
							[
								-81.42719299999993,
								28.54637900000006
							],
							[
								-81.42719699999992,
								28.54626200000007
							],
							[
								-81.42910999999992,
								28.546272000000044
							],
							[
								-81.43014399999993,
								28.546533000000068
							],
							[
								-81.43014799999992,
								28.546828000000062
							],
							[
								-81.42928699999993,
								28.54682200000008
							],
							[
								-81.42927999999995,
								28.547178000000088
							],
							[
								-81.43036190099991,
								28.547356859000047
							],
							[
								-81.43039299999992,
								28.547362000000078
							],
							[
								-81.43039299999992,
								28.54747900000007
							],
							[
								-81.43048399999992,
								28.547497000000078
							],
							[
								-81.43048317799992,
								28.547695112000042
							],
							[
								-81.43048299999992,
								28.54773800000004
							],
							[
								-81.43048299999992,
								28.549082000000055
							],
							[
								-81.43048399999992,
								28.549239000000057
							],
							[
								-81.43132630799994,
								28.549239000000057
							],
							[
								-81.43138499999993,
								28.549239000000057
							],
							[
								-81.43140199999993,
								28.550533000000087
							],
							[
								-81.43139799999994,
								28.551097000000084
							],
							[
								-81.43139499999995,
								28.55152700000008
							],
							[
								-81.4313929999999,
								28.551859000000036
							],
							[
								-81.4313997399999,
								28.552365122000083
							],
							[
								-81.43140399999993,
								28.552685000000054
							],
							[
								-81.43149299999993,
								28.552685000000054
							],
							[
								-81.43244199999992,
								28.55268300000006
							],
							[
								-81.43258199999991,
								28.552684000000056
							],
							[
								-81.43359299999992,
								28.552692000000036
							],
							[
								-81.4340039999999,
								28.55270100000007
							],
							[
								-81.43406199999993,
								28.552707000000055
							],
							[
								-81.43405299999995,
								28.552422000000035
							],
							[
								-81.43405199999995,
								28.55221000000006
							],
							[
								-81.43404299999992,
								28.551953000000086
							],
							[
								-81.4339991729999,
								28.55195283800009
							],
							[
								-81.43377299999992,
								28.551952000000085
							],
							[
								-81.4335969999999,
								28.551952000000085
							],
							[
								-81.4335989999999,
								28.551634000000035
							],
							[
								-81.4335999999999,
								28.551528000000076
							],
							[
								-81.43409199999991,
								28.551528000000076
							],
							[
								-81.43415799999991,
								28.551528000000076
							],
							[
								-81.43415786599991,
								28.551456451000035
							],
							[
								-81.43415699999991,
								28.550994000000063
							],
							[
								-81.43452599999996,
								28.550994000000063
							],
							[
								-81.4345229999999,
								28.551349000000073
							],
							[
								-81.43453199999993,
								28.551525000000083
							],
							[
								-81.4345239999999,
								28.55185400000005
							],
							[
								-81.43452799999996,
								28.55219500000004
							],
							[
								-81.43421727099991,
								28.55219500000004
							],
							[
								-81.43417499999993,
								28.55219500000004
							],
							[
								-81.43417399999993,
								28.552425000000085
							],
							[
								-81.43417522999994,
								28.552495588000056
							],
							[
								-81.43417899999992,
								28.552712000000042
							],
							[
								-81.43435299999993,
								28.552718000000084
							],
							[
								-81.43541999999992,
								28.55273500000004
							],
							[
								-81.43558799999994,
								28.552745000000073
							],
							[
								-81.43848999999994,
								28.552744000000075
							],
							[
								-81.43951199999992,
								28.55274200000008
							],
							[
								-81.4404199999999,
								28.552740000000085
							],
							[
								-81.4415449999999,
								28.55273600000004
							],
							[
								-81.44155099999995,
								28.552886000000058
							],
							[
								-81.44239299999992,
								28.552879000000075
							],
							[
								-81.44252699999993,
								28.552880000000073
							],
							[
								-81.44254599999994,
								28.555457000000047
							],
							[
								-81.44255199999992,
								28.556876000000045
							],
							[
								-81.4425494759999,
								28.559674985000072
							],
							[
								-81.44254899999993,
								28.560203000000058
							],
							[
								-81.4425159999999,
								28.560206000000054
							],
							[
								-81.43990699999995,
								28.560209000000043
							],
							[
								-81.43979299999995,
								28.560279000000037
							],
							[
								-81.43879299999992,
								28.560279000000037
							],
							[
								-81.43838239299993,
								28.56013039000004
							],
							[
								-81.43845572499993,
								28.559951269000067
							],
							[
								-81.43845713499991,
								28.559947845000067
							],
							[
								-81.43848142299993,
								28.559894240000062
							],
							[
								-81.43850916399992,
								28.559842339000056
							],
							[
								-81.43852738999993,
								28.55981215500009
							],
							[
								-81.43862138899993,
								28.559663154000077
							],
							[
								-81.43863424099993,
								28.559643363000077
							],
							[
								-81.43866851999991,
								28.559595527000056
							],
							[
								-81.43870585399993,
								28.559550035000086
							],
							[
								-81.4387460829999,
								28.559507083000085
							],
							[
								-81.43876983299992,
								28.55948418900005
							],
							[
								-81.43888283299992,
								28.559379190000072
							],
							[
								-81.43888500899993,
								28.559377174000076
							],
							[
								-81.43897600899993,
								28.55929317400006
							],
							[
								-81.43899303599994,
								28.559277854000072
							],
							[
								-81.43903852799991,
								28.55924052000006
							],
							[
								-81.43908407499993,
								28.55920777500006
							],
							[
								-81.43936280399993,
								28.559020297000075
							],
							[
								-81.43932533899994,
								28.558999836000055
							],
							[
								-81.43930126799995,
								28.55898543300009
							],
							[
								-81.43901726699994,
								28.55880943300008
							],
							[
								-81.4389913629999,
								28.558792759000085
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "West Colonial",
				"RegionID": "269226"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.28822999999994,
					25.757275623000055,
					-80.23060092799994,
					25.77971094500009
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.23116102199992,
							25.77914699200005
						],
						[
							-80.2311499999999,
							25.778820000000053
						],
						[
							-80.23114201599994,
							25.778631037000082
						],
						[
							-80.23113023199994,
							25.77835215300007
						],
						[
							-80.23111999999992,
							25.778110000000083
						],
						[
							-80.23111999999992,
							25.777900784000053
						],
						[
							-80.23110527199992,
							25.777491791000045
						],
						[
							-80.23109999999991,
							25.777360000000044
						],
						[
							-80.23109311399992,
							25.777084554000055
						],
						[
							-80.23108375999993,
							25.77669791900007
						],
						[
							-80.2310799999999,
							25.776540000000068
						],
						[
							-80.23107053699994,
							25.776355467000087
						],
						[
							-80.2310660839999,
							25.77626863000006
						],
						[
							-80.2310599999999,
							25.776150000000086
						],
						[
							-80.2310573179999,
							25.776053433000072
						],
						[
							-80.23105551099991,
							25.77598841400004
						],
						[
							-80.23104999999993,
							25.775790000000086
						],
						[
							-80.23104303799994,
							25.775664678000055
						],
						[
							-80.2310370859999,
							25.775557554000045
						],
						[
							-80.23102999999992,
							25.775430000000085
						],
						[
							-80.23102999999992,
							25.775321871000074
						],
						[
							-80.23102999999992,
							25.77519292600005
						],
						[
							-80.23102999999992,
							25.775040000000047
						],
						[
							-80.23102611799993,
							25.774977895000063
						],
						[
							-80.23101675299995,
							25.774828043000074
						],
						[
							-80.23100999999991,
							25.77472000000006
						],
						[
							-80.23100583899992,
							25.77457019800005
						],
						[
							-80.23100345299991,
							25.77448430000004
						],
						[
							-80.23099999999994,
							25.77436000000006
						],
						[
							-80.23099572199993,
							25.77427017000008
						],
						[
							-80.2309899999999,
							25.774150000000077
						],
						[
							-80.23098587999993,
							25.773989313000072
						],
						[
							-80.23097999999993,
							25.77376000000004
						],
						[
							-80.23097647899993,
							25.77355932000006
						],
						[
							-80.23097270999995,
							25.77334447700008
						],
						[
							-80.2309699999999,
							25.773190000000056
						],
						[
							-80.2309699999999,
							25.773065323000083
						],
						[
							-80.2309699999999,
							25.772871904000056
						],
						[
							-80.23095999999993,
							25.772600000000068
						],
						[
							-80.23089759299995,
							25.77241945800006
						],
						[
							-80.23088942499993,
							25.77224792000004
						],
						[
							-80.2308773499999,
							25.771969166000076
						],
						[
							-80.23086890299994,
							25.77171155200006
						],
						[
							-80.23086397599991,
							25.771561277000046
						],
						[
							-80.23085999999995,
							25.77144000000004
						],
						[
							-80.23085075299991,
							25.771239654000055
						],
						[
							-80.23084076399995,
							25.771023221000064
						],
						[
							-80.23082999999993,
							25.77079000000009
						],
						[
							-80.23082184999993,
							25.770614770000066
						],
						[
							-80.23079977399995,
							25.770336606000058
						],
						[
							-80.2307869359999,
							25.770144043000073
						],
						[
							-80.23077999999992,
							25.770040000000055
						],
						[
							-80.23077616099994,
							25.76986342500004
						],
						[
							-80.23077335999994,
							25.76973454000006
						],
						[
							-80.23076999999995,
							25.769580000000076
						],
						[
							-80.23074999999994,
							25.769360000000066
						],
						[
							-80.23074999999994,
							25.769196953000062
						],
						[
							-80.23074999999994,
							25.769089499000074
						],
						[
							-80.23074999999994,
							25.76897000000008
						],
						[
							-80.2307418719999,
							25.768767272000048
						],
						[
							-80.23073077099991,
							25.768531394000036
						],
						[
							-80.23072370799991,
							25.76838129000004
						],
						[
							-80.23071664399993,
							25.768231186000037
						],
						[
							-80.23070999999993,
							25.768090000000086
						],
						[
							-80.23070011699991,
							25.767800100000045
						],
						[
							-80.23069279899994,
							25.76758544000006
						],
						[
							-80.23068840799993,
							25.76745664400005
						],
						[
							-80.23068474899992,
							25.767349314000057
						],
						[
							-80.23067999999995,
							25.76721000000009
						],
						[
							-80.23066763899993,
							25.767028698000047
						],
						[
							-80.23064847899991,
							25.76674769200008
						],
						[
							-80.23063535199992,
							25.76655516900007
						],
						[
							-80.23062348499991,
							25.766381120000062
						],
						[
							-80.23061999999993,
							25.76633000000004
						],
						[
							-80.23061003999993,
							25.766080999000053
						],
						[
							-80.23060773399993,
							25.765930454000056
						],
						[
							-80.23060382799993,
							25.76567262100008
						],
						[
							-80.23060154899991,
							25.765522219000047
						],
						[
							-80.23060092799994,
							25.765418698000076
						],
						[
							-80.23070282099991,
							25.765416121000044
						],
						[
							-80.23070281699995,
							25.76541603800007
						],
						[
							-80.23073269399993,
							25.765415285000074
						],
						[
							-80.23072406599994,
							25.76516375500006
						],
						[
							-80.23071596599993,
							25.764827607000086
						],
						[
							-80.23070999999993,
							25.76458000000008
						],
						[
							-80.23083829899991,
							25.764577459000066
						],
						[
							-80.23116950499991,
							25.76457090100007
						],
						[
							-80.2316426729999,
							25.764561531000084
						],
						[
							-80.23235042199991,
							25.76454751600005
						],
						[
							-80.23272999999995,
							25.764540000000068
						],
						[
							-80.23316024399992,
							25.764527093000083
						],
						[
							-80.23373289199992,
							25.764509913000044
						],
						[
							-80.2342718559999,
							25.76449374400005
						],
						[
							-80.2347299999999,
							25.76448000000005
						],
						[
							-80.23514785999993,
							25.764469931000065
						],
						[
							-80.23555999999991,
							25.764460000000042
						],
						[
							-80.23557999999991,
							25.76457000000005
						],
						[
							-80.23585637299993,
							25.764557145000083
						],
						[
							-80.23606135899992,
							25.76454761100007
						],
						[
							-80.2364667139999,
							25.764527571000087
						],
						[
							-80.23676999999992,
							25.764500000000055
						],
						[
							-80.23723900099992,
							25.764465762000047
						],
						[
							-80.2378790009999,
							25.76444625000005
						],
						[
							-80.23838529199992,
							25.764430814000036
						],
						[
							-80.23887992699991,
							25.764418687000045
						],
						[
							-80.23886534099995,
							25.764016370000036
						],
						[
							-80.2388499999999,
							25.76368000000008
						],
						[
							-80.23884333899991,
							25.76344351700004
						],
						[
							-80.2388385939999,
							25.763275073000045
						],
						[
							-80.23882999999995,
							25.762970000000053
						],
						[
							-80.23881545299992,
							25.76280125800008
						],
						[
							-80.23879814299994,
							25.76260045700008
						],
						[
							-80.2387799999999,
							25.76239000000004
						],
						[
							-80.2387799999999,
							25.762180000000058
						],
						[
							-80.23877560699992,
							25.762028434000058
						],
						[
							-80.23876486599995,
							25.761657874000036
						],
						[
							-80.2387599999999,
							25.761490000000038
						],
						[
							-80.23874847499991,
							25.76121917100005
						],
						[
							-80.23873266099991,
							25.760847538000064
						],
						[
							-80.23871999999994,
							25.76055000000008
						],
						[
							-80.23870963799993,
							25.760309075000066
						],
						[
							-80.23869226799991,
							25.759905235000076
						],
						[
							-80.23867999999993,
							25.75962000000004
						],
						[
							-80.23867039099991,
							25.759399002000066
						],
						[
							-80.23865575999992,
							25.759062482000047
						],
						[
							-80.23863999999992,
							25.75870000000009
						],
						[
							-80.23863420499993,
							25.758522282000058
						],
						[
							-80.23861989199993,
							25.75808334700008
						],
						[
							-80.23860999999995,
							25.757780000000082
						],
						[
							-80.23895990099993,
							25.75776945000007
						],
						[
							-80.23997044899994,
							25.757738981000045
						],
						[
							-80.24059999999992,
							25.757720000000063
						],
						[
							-80.24091358099992,
							25.757709396000052
						],
						[
							-80.24148836799992,
							25.757689959000064
						],
						[
							-80.24223040099992,
							25.757664866000084
						],
						[
							-80.24266999999992,
							25.75765000000007
						],
						[
							-80.24307233099995,
							25.757636262000062
						],
						[
							-80.24371217999993,
							25.757614413000056
						],
						[
							-80.24425100099995,
							25.757596015000047
						],
						[
							-80.24471999999992,
							25.757580000000075
						],
						[
							-80.24512914899992,
							25.757576589000053
						],
						[
							-80.24549965799991,
							25.757565011000054
						],
						[
							-80.24630766599995,
							25.75753214300005
						],
						[
							-80.24677999999994,
							25.75751000000008
						],
						[
							-80.24688347099993,
							25.757501002000083
						],
						[
							-80.2472872059999,
							25.75748060300009
						],
						[
							-80.24775868099994,
							25.757464621000054
						],
						[
							-80.24839854099991,
							25.75744293100007
						],
						[
							-80.24887999999993,
							25.75743000000006
						],
						[
							-80.24944328099991,
							25.75742805100009
						],
						[
							-80.25004962899995,
							25.75741008500006
						],
						[
							-80.25038999999992,
							25.757400000000075
						],
						[
							-80.25055524599993,
							25.757396157000073
						],
						[
							-80.25065868899992,
							25.757393751000052
						],
						[
							-80.25081999999992,
							25.757390000000044
						],
						[
							-80.25102961099992,
							25.757383712000035
						],
						[
							-80.25163594499992,
							25.757365522000043
						],
						[
							-80.25227596399992,
							25.757346321000057
						],
						[
							-80.25281999999993,
							25.75733000000008
						],
						[
							-80.25308341699991,
							25.757322176000063
						],
						[
							-80.25348964799991,
							25.75731010900006
						],
						[
							-80.25402862099992,
							25.75729410000008
						],
						[
							-80.2546022809999,
							25.75727706100008
						],
						[
							-80.25483433199993,
							25.757275623000055
						],
						[
							-80.2549019999999,
							25.758048000000088
						],
						[
							-80.25491199999993,
							25.75834800000007
						],
						[
							-80.25492999999994,
							25.758838000000083
						],
						[
							-80.25493999999992,
							25.75912800000009
						],
						[
							-80.25495099999995,
							25.75961600000005
						],
						[
							-80.25496899999992,
							25.75989700000008
						],
						[
							-80.25497799999994,
							25.760324000000082
						],
						[
							-80.25499499999995,
							25.76065200000005
						],
						[
							-80.25500499999993,
							25.761025000000075
						],
						[
							-80.25501999999994,
							25.761420000000044
						],
						[
							-80.25504599999994,
							25.762186000000042
						],
						[
							-80.25507418099994,
							25.762926872000037
						],
						[
							-80.25507699999991,
							25.763001000000088
						],
						[
							-80.2550779739999,
							25.763027077000064
						],
						[
							-80.25513999999993,
							25.764687000000038
						],
						[
							-80.25514005299993,
							25.764688549000084
						],
						[
							-80.2551643889999,
							25.765399974000047
						],
						[
							-80.25516688499994,
							25.765472927000076
						],
						[
							-80.25516811699994,
							25.76550893800004
						],
						[
							-80.25516999999991,
							25.765564000000044
						],
						[
							-80.25517061099993,
							25.76559096300008
						],
						[
							-80.25518199999993,
							25.76609300000007
						],
						[
							-80.25522099999995,
							25.766914000000043
						],
						[
							-80.25525199999993,
							25.767473000000052
						],
						[
							-80.25525499999992,
							25.767671000000064
						],
						[
							-80.25527291499992,
							25.767987498000082
						],
						[
							-80.2552849999999,
							25.76820100000009
						],
						[
							-80.25528531099991,
							25.76820897400006
						],
						[
							-80.25531099999995,
							25.768868000000058
						],
						[
							-80.25531999999993,
							25.76916600000004
						],
						[
							-80.25533399999995,
							25.76953400000008
						],
						[
							-80.25536499999993,
							25.770026000000087
						],
						[
							-80.2551929999999,
							25.770068000000038
						],
						[
							-80.25496471699995,
							25.77007091900009
						],
						[
							-80.25469372599991,
							25.770074385000044
						],
						[
							-80.25441099999995,
							25.77007800000007
						],
						[
							-80.25435299999992,
							25.770079000000067
						],
						[
							-80.2544519999999,
							25.77138800000006
						],
						[
							-80.2541790269999,
							25.771401558000036
						],
						[
							-80.25414999999992,
							25.771403000000078
						],
						[
							-80.25415099999992,
							25.77144000000004
						],
						[
							-80.25416899999995,
							25.77185300000008
						],
						[
							-80.25455999999991,
							25.771835000000067
						],
						[
							-80.25476995499992,
							25.771835000000067
						],
						[
							-80.25484899999992,
							25.771835000000067
						],
						[
							-80.25483199999991,
							25.771377000000086
						],
						[
							-80.25544699999995,
							25.771356000000083
						],
						[
							-80.25544434499994,
							25.77123618800005
						],
						[
							-80.25543951199995,
							25.771018111000046
						],
						[
							-80.25543899999991,
							25.770995000000084
						],
						[
							-80.25540699999993,
							25.77064000000007
						],
						[
							-80.25541737399993,
							25.770639718000044
						],
						[
							-80.2583605069999,
							25.770559810000066
						],
						[
							-80.25846399999995,
							25.770557000000053
						],
						[
							-80.25846399999995,
							25.77022800000009
						],
						[
							-80.25841799999995,
							25.769123000000036
						],
						[
							-80.25840699999992,
							25.768154000000038
						],
						[
							-80.25889985199991,
							25.76814018600004
						],
						[
							-80.25909060999993,
							25.768134840000073
						],
						[
							-80.2594059999999,
							25.768126000000052
						],
						[
							-80.25938999999994,
							25.767809000000057
						],
						[
							-80.25921939999995,
							25.764617891000057
						],
						[
							-80.25921699999992,
							25.76457300000004
						],
						[
							-80.25960999999995,
							25.764553000000035
						],
						[
							-80.25975463299994,
							25.764547993000065
						],
						[
							-80.26082733299995,
							25.764510854000036
						],
						[
							-80.26085199999994,
							25.764510000000087
						],
						[
							-80.26126299999993,
							25.764496000000065
						],
						[
							-80.26130999999992,
							25.76449400000007
						],
						[
							-80.26157399999995,
							25.76449000000008
						],
						[
							-80.26161294899993,
							25.764488518000064
						],
						[
							-80.26330899999994,
							25.764424000000076
						],
						[
							-80.26442813599995,
							25.764387755000087
						],
						[
							-80.26445441599992,
							25.764386904000048
						],
						[
							-80.26461788099994,
							25.764381610000044
						],
						[
							-80.26531599999993,
							25.76435900000007
						],
						[
							-80.26700499999993,
							25.764305000000036
						],
						[
							-80.2673744619999,
							25.764282218000062
						],
						[
							-80.26737799999995,
							25.764282000000037
						],
						[
							-80.26741880899993,
							25.764282603000087
						],
						[
							-80.26746367399994,
							25.764283266000064
						],
						[
							-80.26758099999995,
							25.764285000000086
						],
						[
							-80.2679077869999,
							25.76427319600009
						],
						[
							-80.2692419999999,
							25.764225000000067
						],
						[
							-80.26927436799991,
							25.764226133000083
						],
						[
							-80.26944199999991,
							25.76423200000005
						],
						[
							-80.26982099999992,
							25.764229000000057
						],
						[
							-80.27035155899995,
							25.764208626000084
						],
						[
							-80.27044599999994,
							25.76420500000006
						],
						[
							-80.27064218899994,
							25.764197230000036
						],
						[
							-80.27064799999994,
							25.76419700200006
						],
						[
							-80.27072738999993,
							25.764193913000042
						],
						[
							-80.2707640509999,
							25.76419248700006
						],
						[
							-80.27082799999994,
							25.764190000000042
						],
						[
							-80.27146399999992,
							25.764170000000036
						],
						[
							-80.27211832099994,
							25.76413941900006
						],
						[
							-80.2725979999999,
							25.764117000000056
						],
						[
							-80.27331499999991,
							25.764094000000057
						],
						[
							-80.27338180099991,
							25.764094338000064
						],
						[
							-80.2734363909999,
							25.764094613000054
						],
						[
							-80.27351299999992,
							25.764095000000054
						],
						[
							-80.2740619999999,
							25.764071000000058
						],
						[
							-80.27480799999995,
							25.764034000000038
						],
						[
							-80.2756149999999,
							25.76401100000004
						],
						[
							-80.27628699999991,
							25.763987000000043
						],
						[
							-80.27704799999992,
							25.76395000000008
						],
						[
							-80.27776499999993,
							25.76392700000008
						],
						[
							-80.27785451699992,
							25.763927342000045
						],
						[
							-80.27828799999992,
							25.763929000000076
						],
						[
							-80.27850045899993,
							25.76392024800009
						],
						[
							-80.27925899999991,
							25.763889000000063
						],
						[
							-80.27966199999992,
							25.763869000000057
						],
						[
							-80.27968467199992,
							25.76386791500005
						],
						[
							-80.28066499999994,
							25.763821000000064
						],
						[
							-80.28074483499995,
							25.763816087000066
						],
						[
							-80.28078154999992,
							25.76381382800008
						],
						[
							-80.2808599999999,
							25.763809000000037
						],
						[
							-80.28175099999993,
							25.76378800000009
						],
						[
							-80.2822799999999,
							25.76376600000009
						],
						[
							-80.28307299999994,
							25.76373200000006
						],
						[
							-80.28379699999994,
							25.76371000000006
						],
						[
							-80.28544540599995,
							25.763653127000055
						],
						[
							-80.28562299999994,
							25.76364700000005
						],
						[
							-80.28582499999993,
							25.763644000000056
						],
						[
							-80.28600898499991,
							25.76363455400008
						],
						[
							-80.28672099999994,
							25.76359800000006
						],
						[
							-80.28754544799995,
							25.763572486000044
						],
						[
							-80.28785199999993,
							25.76356300000009
						],
						[
							-80.2878641229999,
							25.763562575000037
						],
						[
							-80.2878679129999,
							25.763716170000066
						],
						[
							-80.28787352199993,
							25.763833960000056
						],
						[
							-80.28788572699995,
							25.76418762100008
						],
						[
							-80.28789599499993,
							25.764511862000063
						],
						[
							-80.28790589999994,
							25.76477931000005
						],
						[
							-80.2879099999999,
							25.764984594000055
						],
						[
							-80.28791629599993,
							25.765220536000072
						],
						[
							-80.28792331999995,
							25.76539966100006
						],
						[
							-80.2879299999999,
							25.765570000000082
						],
						[
							-80.2879299999999,
							25.765663422000046
						],
						[
							-80.2879299999999,
							25.76577000000009
						],
						[
							-80.28794836399994,
							25.765898546000074
						],
						[
							-80.28795578199993,
							25.766106582000077
						],
						[
							-80.28795999999994,
							25.76625000000007
						],
						[
							-80.28795999999994,
							25.766401279000036
						],
						[
							-80.28795999999994,
							25.76648000000006
						],
						[
							-80.28796784399992,
							25.766668266000067
						],
						[
							-80.28797398299992,
							25.76681558200005
						],
						[
							-80.28797999999995,
							25.76696000000004
						],
						[
							-80.2879860079999,
							25.767110200000047
						],
						[
							-80.28798999999992,
							25.76721000000009
						],
						[
							-80.28799560399995,
							25.767316477000065
						],
						[
							-80.2879999999999,
							25.767400000000066
						],
						[
							-80.2880064869999,
							25.767581635000056
						],
						[
							-80.28800999999993,
							25.76768000000004
						],
						[
							-80.28801640799992,
							25.767965177000065
						],
						[
							-80.28802371499995,
							25.76829033300004
						],
						[
							-80.28802999999994,
							25.768570000000068
						],
						[
							-80.2880332979999,
							25.76864421600004
						],
						[
							-80.28804519699992,
							25.768911939000077
						],
						[
							-80.28804999999994,
							25.76902000000007
						],
						[
							-80.28805505499992,
							25.76917671500007
						],
						[
							-80.28805999999992,
							25.769330000000082
						],
						[
							-80.2880638979999,
							25.76944109400006
						],
						[
							-80.28807324299993,
							25.769707430000043
						],
						[
							-80.28807999999992,
							25.769900000000064
						],
						[
							-80.28808537499992,
							25.770031682000084
						],
						[
							-80.28809259099995,
							25.770208473000082
						],
						[
							-80.28809999999993,
							25.77039000000008
						],
						[
							-80.28810578499991,
							25.77062140000004
						],
						[
							-80.28810999999992,
							25.77079000000009
						],
						[
							-80.28811662499993,
							25.771094731000062
						],
						[
							-80.28811999999994,
							25.771250000000066
						],
						[
							-80.28812962399991,
							25.771507935000045
						],
						[
							-80.28814721999993,
							25.771979506000037
						],
						[
							-80.28815944099995,
							25.772307011000066
						],
						[
							-80.28816999999992,
							25.772590000000037
						],
						[
							-80.28818410799994,
							25.773013241000058
						],
						[
							-80.28820474499992,
							25.77363235200005
						],
						[
							-80.2882155879999,
							25.773957632000077
						],
						[
							-80.28822999999994,
							25.77439000000004
						],
						[
							-80.28791196999993,
							25.77440109400004
						],
						[
							-80.28764666399991,
							25.77441034900005
						],
						[
							-80.2873699999999,
							25.774420000000077
						],
						[
							-80.28711390599995,
							25.774430109000036
						],
						[
							-80.28687815899991,
							25.774439415000074
						],
						[
							-80.28660999999994,
							25.77445000000006
						],
						[
							-80.2863183309999,
							25.774462821000043
						],
						[
							-80.28596484199994,
							25.774478359000057
						],
						[
							-80.2856999999999,
							25.77449000000007
						],
						[
							-80.28543434399995,
							25.774500350000043
						],
						[
							-80.28496053499993,
							25.774518810000075
						],
						[
							-80.28448787399992,
							25.774537226000064
						],
						[
							-80.28415999999993,
							25.77455000000009
						],
						[
							-80.28392674799994,
							25.774561160000076
						],
						[
							-80.2834261509999,
							25.774585112000068
						],
						[
							-80.28292555399992,
							25.774609064000064
						],
						[
							-80.2824544049999,
							25.77463160700006
						],
						[
							-80.28221601199995,
							25.77464301400005
						],
						[
							-80.28206999999992,
							25.774650000000065
						],
						[
							-80.28207425699992,
							25.774841567000067
						],
						[
							-80.28207999999995,
							25.775100000000066
						],
						[
							-80.28168239799993,
							25.775115516000085
						],
						[
							-80.28124035699994,
							25.77513276700006
						],
						[
							-80.28085725499994,
							25.77514771700004
						],
						[
							-80.28053309199993,
							25.77516036700007
						],
						[
							-80.28032680599995,
							25.775168417000092
						],
						[
							-80.2800299999999,
							25.77518000000009
						],
						[
							-80.2797670569999,
							25.77519154400005
						],
						[
							-80.2793802299999,
							25.775208526000085
						],
						[
							-80.27902803299992,
							25.77522398900004
						],
						[
							-80.2786156279999,
							25.775242094000077
						],
						[
							-80.2782326809999,
							25.775258907000083
						],
						[
							-80.2779799999999,
							25.775270000000035
						],
						[
							-80.27770101999994,
							25.775281272000086
						],
						[
							-80.27737332099991,
							25.775294512000073
						],
						[
							-80.27713878199995,
							25.77530398900007
						],
						[
							-80.2769899999999,
							25.775310000000047
						],
						[
							-80.2766675869999,
							25.77532645000008
						],
						[
							-80.27643208599994,
							25.77533846500006
						],
						[
							-80.27622301899993,
							25.775349132000088
						],
						[
							-80.27600999999993,
							25.77536000000004
						],
						[
							-80.2758697989999,
							25.77536467300007
						],
						[
							-80.2756044649999,
							25.775373518000038
						],
						[
							-80.27540999999991,
							25.77538000000004
						],
						[
							-80.27516122799996,
							25.775389852000046
						],
						[
							-80.27486654799992,
							25.775401523000085
						],
						[
							-80.27460016799995,
							25.77541207300004
						],
						[
							-80.2743999999999,
							25.775420000000054
						],
						[
							-80.27386356799991,
							25.775442960000078
						],
						[
							-80.27303741899993,
							25.77547832100004
						],
						[
							-80.27229964999992,
							25.775509898000053
						],
						[
							-80.27182999999991,
							25.77553000000006
						],
						[
							-80.27153378199995,
							25.775543139000035
						],
						[
							-80.27100226099992,
							25.775566714000036
						],
						[
							-80.27049758399994,
							25.775589099000058
						],
						[
							-80.27002628299994,
							25.775610004000043
						],
						[
							-80.26934999999992,
							25.77564000000007
						],
						[
							-80.26933662599993,
							25.775342767000044
						],
						[
							-80.26931999999994,
							25.77511000000004
						],
						[
							-80.2687573529999,
							25.77512479800004
						],
						[
							-80.26830999999993,
							25.775130000000047
						],
						[
							-80.26804878199994,
							25.77513607500009
						],
						[
							-80.26763554699994,
							25.77513385800006
						],
						[
							-80.26730999999995,
							25.77514000000008
						],
						[
							-80.26669121499992,
							25.775144797000053
						],
						[
							-80.26624852799995,
							25.775148228000035
						],
						[
							-80.26582999999994,
							25.775160000000085
						],
						[
							-80.26584197999995,
							25.77537323900009
						],
						[
							-80.26585850899994,
							25.77566745300004
						],
						[
							-80.26587999999992,
							25.776050000000055
						],
						[
							-80.26588817299995,
							25.77622980800004
						],
						[
							-80.26590022199993,
							25.77649488900005
						],
						[
							-80.26590965499992,
							25.77670240200007
						],
						[
							-80.26591999999994,
							25.776930000000053
						],
						[
							-80.26592921299994,
							25.77720331900008
						],
						[
							-80.2659411379999,
							25.777557088000037
						],
						[
							-80.26594999999992,
							25.77782000000008
						],
						[
							-80.26595806499995,
							25.778059255000073
						],
						[
							-80.26596803599995,
							25.778355057000056
						],
						[
							-80.2659799999999,
							25.778710000000046
						],
						[
							-80.26542169699991,
							25.778701138000088
						],
						[
							-80.26503810799994,
							25.778695049000078
						],
						[
							-80.26453649199993,
							25.77868708700004
						],
						[
							-80.26359300699994,
							25.77869340300009
						],
						[
							-80.2632971569999,
							25.77871106500004
						],
						[
							-80.26297999999991,
							25.778730000000053
						],
						[
							-80.26270675599994,
							25.778738959000066
						],
						[
							-80.26236999999992,
							25.77875000000006
						],
						[
							-80.26214636799995,
							25.778755325000077
						],
						[
							-80.2619499999999,
							25.77876000000009
						],
						[
							-80.2614681089999,
							25.77877338600007
						],
						[
							-80.26111421099995,
							25.778783216000082
						],
						[
							-80.2608699999999,
							25.778790000000072
						],
						[
							-80.2606407159999,
							25.77879667800005
						],
						[
							-80.26013939899991,
							25.77881128000007
						],
						[
							-80.25983999999995,
							25.778820000000053
						],
						[
							-80.25931366999993,
							25.77883503800007
						],
						[
							-80.25878116099994,
							25.778850253000087
						],
						[
							-80.25843999999995,
							25.778860000000066
						],
						[
							-80.25804401599993,
							25.778872866000086
						],
						[
							-80.2571300379999,
							25.77890256200004
						],
						[
							-80.25639104399994,
							25.778926573000035
						],
						[
							-80.2556694239999,
							25.778950122000083
						],
						[
							-80.25566942299992,
							25.778950086000066
						],
						[
							-80.25534307299995,
							25.77896077800006
						],
						[
							-80.2550736419999,
							25.778969660000087
						],
						[
							-80.25436628999995,
							25.778990787000055
						],
						[
							-80.25402999999996,
							25.779000000000053
						],
						[
							-80.25372630499993,
							25.779009590000044
						],
						[
							-80.25335580299992,
							25.779021290000063
						],
						[
							-80.2530799999999,
							25.77903000000009
						],
						[
							-80.25288227899995,
							25.779034119000073
						],
						[
							-80.25281487699995,
							25.77903552300006
						],
						[
							-80.25259999999992,
							25.779040000000066
						],
						[
							-80.25237684799993,
							25.77905217200004
						],
						[
							-80.25204999999994,
							25.779070000000047
						],
						[
							-80.2518382749999,
							25.779077057000052
						],
						[
							-80.25150149399991,
							25.779088284000068
						],
						[
							-80.25114999999994,
							25.779100000000085
						],
						[
							-80.25097999999991,
							25.779100000000085
						],
						[
							-80.2508265859999,
							25.779104870000083
						],
						[
							-80.25048870099994,
							25.779115597000043
						],
						[
							-80.25010999999995,
							25.77912000000009
						],
						[
							-80.2497813889999,
							25.779133983000065
						],
						[
							-80.24944484299994,
							25.779148305000035
						],
						[
							-80.24916999999994,
							25.779160000000047
						],
						[
							-80.2490499999999,
							25.779160000000047
						],
						[
							-80.2487034319999,
							25.779170397000087
						],
						[
							-80.24833188399992,
							25.77918154300005
						],
						[
							-80.24804999999992,
							25.779190000000085
						],
						[
							-80.24782698799994,
							25.779198416000042
						],
						[
							-80.24751999999995,
							25.779210000000035
						],
						[
							-80.24725303699995,
							25.779217776000053
						],
						[
							-80.24684683099991,
							25.779229607000048
						],
						[
							-80.24648999999994,
							25.779240000000073
						],
						[
							-80.24633999999992,
							25.77925000000005
						],
						[
							-80.24600481899995,
							25.77925971500008
						],
						[
							-80.24573532099993,
							25.77926752700006
						],
						[
							-80.2454699999999,
							25.779270000000054
						],
						[
							-80.24519641099994,
							25.779280009000047
						],
						[
							-80.24492704799991,
							25.779289864000077
						],
						[
							-80.24464999999992,
							25.779300000000035
						],
						[
							-80.24445571399991,
							25.779307286000062
						],
						[
							-80.24415143699991,
							25.779318696000075
						],
						[
							-80.24384999999995,
							25.779330000000073
						],
						[
							-80.24367858799992,
							25.77933398600004
						],
						[
							-80.2434199999999,
							25.779340000000047
						],
						[
							-80.2430049919999,
							25.77935338700007
						],
						[
							-80.24270186699994,
							25.779363166000053
						],
						[
							-80.24233141199994,
							25.77937520000006
						],
						[
							-80.24212712699995,
							25.779381897000064
						],
						[
							-80.24187999999992,
							25.779390000000035
						],
						[
							-80.24152068199993,
							25.779397333000077
						],
						[
							-80.24138999999991,
							25.779400000000066
						],
						[
							-80.24115033499993,
							25.779408876000048
						],
						[
							-80.24101440999993,
							25.779413911000063
						],
						[
							-80.24084999999991,
							25.779420000000073
						],
						[
							-80.24054289499992,
							25.779428300000063
						],
						[
							-80.24027336799992,
							25.779435585000044
						],
						[
							-80.24010999999992,
							25.77944000000008
						],
						[
							-80.23990322899994,
							25.779448862000038
						],
						[
							-80.23956669199994,
							25.77946328500008
						],
						[
							-80.2394099999999,
							25.77947000000006
						],
						[
							-80.23909468999994,
							25.779475717000082
						],
						[
							-80.23865575499991,
							25.77949003000009
						],
						[
							-80.23834999999991,
							25.77950000000004
						],
						[
							-80.23804820799995,
							25.779507186000046
						],
						[
							-80.23792999999995,
							25.779510000000073
						],
						[
							-80.2377448069999,
							25.779513430000065
						],
						[
							-80.23738999999996,
							25.779520000000048
						],
						[
							-80.23720590499994,
							25.77952526000007
						],
						[
							-80.23703999999992,
							25.779530000000083
						],
						[
							-80.23676901699992,
							25.77954270200007
						],
						[
							-80.23653352499991,
							25.779553741000086
						],
						[
							-80.23639999999995,
							25.77956000000006
						],
						[
							-80.23602634499991,
							25.779571677000035
						],
						[
							-80.23575999999991,
							25.779580000000067
						],
						[
							-80.23562006199995,
							25.779583998000078
						],
						[
							-80.23540999999994,
							25.77959000000004
						],
						[
							-80.23514839599994,
							25.779596623000092
						],
						[
							-80.23487884499991,
							25.779603447000056
						],
						[
							-80.23461999999995,
							25.779610000000048
						],
						[
							-80.23442999999992,
							25.77962000000008
						],
						[
							-80.23407026799994,
							25.779628668000043
						],
						[
							-80.23359999999991,
							25.779640000000086
						],
						[
							-80.23342883299995,
							25.779640000000086
						],
						[
							-80.23322838399991,
							25.779640848000042
						],
						[
							-80.23273999999992,
							25.779660000000035
						],
						[
							-80.2325699999999,
							25.779670000000067
						],
						[
							-80.23228302099994,
							25.779678567000076
						],
						[
							-80.23208090799994,
							25.779684600000053
						],
						[
							-80.23189999999994,
							25.779690000000073
						],
						[
							-80.2317102849999,
							25.779695270000047
						],
						[
							-80.23132399899993,
							25.779706115000067
						],
						[
							-80.23117961999992,
							25.77971094500009
						],
						[
							-80.23117841299997,
							25.77966291300004
						],
						[
							-80.2311690059999,
							25.779383848000066
						],
						[
							-80.23116102199992,
							25.77914699200005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami",
				"Name": "Alameda - West Flagler",
				"RegionID": "269228"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.26225784599995,
					25.954778738000073,
					-80.25418205899996,
					25.96191975000005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.26166606399994,
							25.954813168000044
						],
						[
							-80.26200977299999,
							25.954778738000073
						],
						[
							-80.26201108999999,
							25.954865625000025
						],
						[
							-80.26225784599995,
							25.961586950000026
						],
						[
							-80.26224518099997,
							25.96190106100005
						],
						[
							-80.26136716399998,
							25.96191975000005
						],
						[
							-80.259261392,
							25.961717967000027
						],
						[
							-80.25418205899996,
							25.96149377100005
						],
						[
							-80.25418780199999,
							25.960749381000028
						],
						[
							-80.25430928899995,
							25.959848951000026
						],
						[
							-80.25436306599994,
							25.959458289000054
						],
						[
							-80.25440490399995,
							25.959321765000027
						],
						[
							-80.25457427799995,
							25.958769070000073
						],
						[
							-80.25464097699995,
							25.958191015000068
						],
						[
							-80.25468544299997,
							25.957612960000063
						],
						[
							-80.25464097699995,
							25.957257234000053
						],
						[
							-80.25462986099996,
							25.956656946000066
						],
						[
							-80.25450757999994,
							25.95615670600006
						],
						[
							-80.25437418199994,
							25.955689816000074
						],
						[
							-80.25435838499999,
							25.95543858900004
						],
						[
							-80.25455272799996,
							25.955423687000064
						],
						[
							-80.25669681699998,
							25.955029739000054
						],
						[
							-80.25744251999998,
							25.954985365000027
						],
						[
							-80.25837551999996,
							25.954966580000075
						],
						[
							-80.26166606399994,
							25.954813168000044
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Gardens",
				"Name": "Riverview Estates",
				"RegionID": "270482"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.12630910999991,
					26.231579749000048,
					-80.12162286799992,
					26.23692940300009
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.12162286799992,
							26.23159671700006
						],
						[
							-80.1228846429999,
							26.231580532000066
						],
						[
							-80.12295679599993,
							26.231580050000048
						],
						[
							-80.12630910999991,
							26.231579749000048
						],
						[
							-80.1244166749999,
							26.23692940300009
						],
						[
							-80.12320501799991,
							26.236904675000062
						],
						[
							-80.12313083499993,
							26.235099554000044
						],
						[
							-80.12164717299993,
							26.235198464000064
						],
						[
							-80.12162286799992,
							26.23159671700006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Pompano Beach",
				"Name": "Downtown",
				"RegionID": "271851"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.4900430969999,
					30.251464922000082,
					-81.43371577699992,
					30.288022065000064
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.43397690799992,
							30.288022065000064
						],
						[
							-81.43397490799993,
							30.287878010000043
						],
						[
							-81.43387590799995,
							30.282776011000067
						],
						[
							-81.43384590799991,
							30.281569011000045
						],
						[
							-81.43382990799995,
							30.280684010000073
						],
						[
							-81.43380190699992,
							30.279423011000066
						],
						[
							-81.43377690799993,
							30.27842501100008
						],
						[
							-81.43373090799992,
							30.27595301000008
						],
						[
							-81.43371577699992,
							30.27518788100008
						],
						[
							-81.43462390699995,
							30.275177010000053
						],
						[
							-81.43555490799992,
							30.275169011000063
						],
						[
							-81.43647790699993,
							30.27515401000005
						],
						[
							-81.43743904299993,
							30.275141142000052
						],
						[
							-81.43741590799993,
							30.27406101100007
						],
						[
							-81.43740090799992,
							30.273729011000057
						],
						[
							-81.43735490699993,
							30.271795010000062
						],
						[
							-81.43734690799994,
							30.27101701000004
						],
						[
							-81.43732490799994,
							30.27039001100007
						],
						[
							-81.43728490799992,
							30.26830201100006
						],
						[
							-81.43726608899993,
							30.267696922000088
						],
						[
							-81.43663690799993,
							30.26704901000005
						],
						[
							-81.43631090699995,
							30.26671201100004
						],
						[
							-81.4361777279999,
							30.26658107600008
						],
						[
							-81.43704589899994,
							30.257339986000094
						],
						[
							-81.43711090999994,
							30.25733001200007
						],
						[
							-81.43744290999992,
							30.257316012000047
						],
						[
							-81.4383419099999,
							30.25731101200006
						],
						[
							-81.4388899089999,
							30.257288012000064
						],
						[
							-81.43917190899992,
							30.257260012000074
						],
						[
							-81.4394929099999,
							30.25721701200007
						],
						[
							-81.43983990999993,
							30.25717501200006
						],
						[
							-81.44016490899992,
							30.257114013000034
						],
						[
							-81.44047990899992,
							30.25706701300004
						],
						[
							-81.4407999099999,
							30.256997013000042
						],
						[
							-81.44114690999994,
							30.256908012000057
						],
						[
							-81.44151090999992,
							30.256810012000074
						],
						[
							-81.44182590899993,
							30.25671601300007
						],
						[
							-81.44221590899991,
							30.25657501200004
						],
						[
							-81.44225390999992,
							30.256566012000064
						],
						[
							-81.44291290899992,
							30.256353012000094
						],
						[
							-81.44343907799993,
							30.256147086000055
						],
						[
							-81.44336274199992,
							30.25596193800004
						],
						[
							-81.4441369839999,
							30.25565184300007
						],
						[
							-81.44420883599992,
							30.25583318000008
						],
						[
							-81.44575590999995,
							30.255203013000088
						],
						[
							-81.44882990899993,
							30.253980012000056
						],
						[
							-81.45167190899991,
							30.252850012000067
						],
						[
							-81.4519419099999,
							30.252743013000043
						],
						[
							-81.45227790899992,
							30.25261901300007
						],
						[
							-81.45304090999991,
							30.25238401300004
						],
						[
							-81.4534759089999,
							30.252272013000038
						],
						[
							-81.45395690899994,
							30.252165012000034
						],
						[
							-81.45445590999994,
							30.252077013000072
						],
						[
							-81.4550249099999,
							30.251993012000074
						],
						[
							-81.45548990999994,
							30.251945013000068
						],
						[
							-81.45617690899991,
							30.251904013000058
						],
						[
							-81.4570539099999,
							30.251883012000064
						],
						[
							-81.4589469089999,
							30.251840013000045
						],
						[
							-81.46007290999995,
							30.251811011000086
						],
						[
							-81.46033490899993,
							30.251802013000088
						],
						[
							-81.46070390999995,
							30.251798012000055
						],
						[
							-81.46260590899993,
							30.251756012000047
						],
						[
							-81.46382490999991,
							30.251728012000058
						],
						[
							-81.4645969099999,
							30.251711012000047
						],
						[
							-81.46576290899992,
							30.251677012000073
						],
						[
							-81.46634790899992,
							30.25167001300008
						],
						[
							-81.46641490999991,
							30.251667013000088
						],
						[
							-81.46647290999994,
							30.251670012000087
						],
						[
							-81.47151290999994,
							30.251537012000085
						],
						[
							-81.47218290899991,
							30.251520012000075
						],
						[
							-81.47523892299995,
							30.251464922000082
						],
						[
							-81.47564090999992,
							30.252703012000037
						],
						[
							-81.47636590899994,
							30.254934013000078
						],
						[
							-81.47651490999993,
							30.255852012000048
						],
						[
							-81.47662590999995,
							30.256536012000087
						],
						[
							-81.47671990999994,
							30.257118012000035
						],
						[
							-81.47786290899997,
							30.264765012000055
						],
						[
							-81.47796775599994,
							30.265469094000082
						],
						[
							-81.47881690899993,
							30.266273012000056
						],
						[
							-81.48318784399993,
							30.27041012700005
						],
						[
							-81.48371990999993,
							30.27058201200009
						],
						[
							-81.4856310269999,
							30.271158869000093
						],
						[
							-81.48787890799991,
							30.275108012000086
						],
						[
							-81.48868890799992,
							30.277422011000052
						],
						[
							-81.48876578599993,
							30.278067057000047
						],
						[
							-81.48905203299995,
							30.278484967000054
						],
						[
							-81.48919990999991,
							30.280037012000037
						],
						[
							-81.48931190999991,
							30.280603012000086
						],
						[
							-81.4900430969999,
							30.284290044000045
						],
						[
							-81.4890669099999,
							30.28604701200004
						],
						[
							-81.48882291099994,
							30.28650101100004
						],
						[
							-81.4887589089999,
							30.286698012000045
						],
						[
							-81.48872391099991,
							30.286804013000054
						],
						[
							-81.4886859099999,
							30.287048012000074
						],
						[
							-81.48867590999994,
							30.287258012000052
						],
						[
							-81.48866891499995,
							30.287392066000052
						],
						[
							-81.4880869079999,
							30.28739801000006
						],
						[
							-81.48487790699994,
							30.28743501000008
						],
						[
							-81.4844719159999,
							30.28743192400009
						],
						[
							-81.4841549109999,
							30.287444013000083
						],
						[
							-81.48399190899994,
							30.28744601200009
						],
						[
							-81.48108691099992,
							30.287475012000076
						],
						[
							-81.47986591099993,
							30.287490012000035
						],
						[
							-81.47724990799992,
							30.28752101300006
						],
						[
							-81.47388590899993,
							30.287553012000046
						],
						[
							-81.47376590899995,
							30.28755501200004
						],
						[
							-81.46770291099995,
							30.287631012000077
						],
						[
							-81.46726990899994,
							30.287636012000064
						],
						[
							-81.46676591099994,
							30.287643012000046
						],
						[
							-81.46423990799991,
							30.28768701200005
						],
						[
							-81.4617979109999,
							30.287701012000074
						],
						[
							-81.4588749099999,
							30.28774201200008
						],
						[
							-81.45574090999992,
							30.28776901200007
						],
						[
							-81.45527190899992,
							30.287768012000072
						],
						[
							-81.45278590999993,
							30.287811012000073
						],
						[
							-81.4526269079999,
							30.28781401300006
						],
						[
							-81.45123090999994,
							30.28782601200004
						],
						[
							-81.45079491099995,
							30.287831012000083
						],
						[
							-81.44842790799993,
							30.287852013000077
						],
						[
							-81.44835490899993,
							30.287853013000074
						],
						[
							-81.44715790899994,
							30.287868012000047
						],
						[
							-81.44549290799995,
							30.28789101200005
						],
						[
							-81.44407890899993,
							30.28791401300009
						],
						[
							-81.44271191199994,
							30.287937012000047
						],
						[
							-81.44190890999994,
							30.287941012000093
						],
						[
							-81.44062191099994,
							30.287948012000076
						],
						[
							-81.4399809109999,
							30.28795201300005
						],
						[
							-81.43818090999991,
							30.28798301200004
						],
						[
							-81.43811590799993,
							30.28798401200004
						],
						[
							-81.4377689069999,
							30.287986958000094
						],
						[
							-81.43768090999993,
							30.28798901300007
						],
						[
							-81.43762490899991,
							30.28798701200009
						],
						[
							-81.43755290899992,
							30.28798701200009
						],
						[
							-81.43723390999992,
							30.28799001300007
						],
						[
							-81.43597190999992,
							30.288002012000046
						],
						[
							-81.43397690799992,
							30.288022065000064
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Beach Haven",
				"RegionID": "272887"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.72918850799996,
					28.039117826000066,
					-82.72154842099994,
					28.04103085900008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.72261768799986,
							28.040241037000012
						],
						[
							-82.72268894199989,
							28.04023413000006
						],
						[
							-82.72290561999998,
							28.040229896000064
						],
						[
							-82.72298652999991,
							28.04023290800005
						],
						[
							-82.72301599099987,
							28.040234472000087
						],
						[
							-82.7233244569999,
							28.040237317000056
						],
						[
							-82.72363752599996,
							28.04023326200008
						],
						[
							-82.72403428699992,
							28.040228077000094
						],
						[
							-82.72435074099991,
							28.040222971000027
						],
						[
							-82.72457001399992,
							28.040230409000017
						],
						[
							-82.72470569799988,
							28.040224536000068
						],
						[
							-82.7247800739999,
							28.040221050000042
						],
						[
							-82.72498856799992,
							28.04019553900007
						],
						[
							-82.72501613099989,
							28.040188862000043
						],
						[
							-82.72532298099988,
							28.040138421000048
						],
						[
							-82.7253511359999,
							28.040133115000053
						],
						[
							-82.72559407699994,
							28.040050866000087
						],
						[
							-82.72577116899993,
							28.039987186000054
						],
						[
							-82.72586725999989,
							28.039942671000105
						],
						[
							-82.72615131999994,
							28.03977339200013
						],
						[
							-82.72638947299993,
							28.039605731000023
						],
						[
							-82.72644134499987,
							28.039569357000033
						],
						[
							-82.72675861999991,
							28.03931223000008
						],
						[
							-82.72681571999993,
							28.039260701000075
						],
						[
							-82.7269440599999,
							28.039142784
						],
						[
							-82.72697662299994,
							28.03912335900008
						],
						[
							-82.72701519099992,
							28.039117826000066
						],
						[
							-82.72705230799997,
							28.039127342000057
						],
						[
							-82.72729811499997,
							28.039284621000014
						],
						[
							-82.72733888499997,
							28.03931122200008
						],
						[
							-82.7274615569999,
							28.039387929000036
						],
						[
							-82.72749421899994,
							28.039404602000083
						],
						[
							-82.72759123599988,
							28.039454628000044
						],
						[
							-82.72767488799988,
							28.03949097200003
						],
						[
							-82.72795153199993,
							28.039602275000092
						],
						[
							-82.7281689979999,
							28.039671946000084
						],
						[
							-82.7282096539999,
							28.03968170100009
						],
						[
							-82.72839285799995,
							28.039727144000032
						],
						[
							-82.72853533999992,
							28.03975320500006
						],
						[
							-82.72856358899996,
							28.039761994000074
						],
						[
							-82.72885181999992,
							28.039795533000095
						],
						[
							-82.72896629199997,
							28.0398052400001
						],
						[
							-82.72908188999995,
							28.03980944000009
						],
						[
							-82.7291865309999,
							28.039804759000063
						],
						[
							-82.7291875699999,
							28.04044010700005
						],
						[
							-82.72918808299995,
							28.040746092000056
						],
						[
							-82.72918850799996,
							28.0409956930001
						],
						[
							-82.72714874699996,
							28.04100031700004
						],
						[
							-82.72695655199995,
							28.041000991000097
						],
						[
							-82.72644912799989,
							28.041001956000088
						],
						[
							-82.72626218599996,
							28.041005695000038
						],
						[
							-82.72587159699988,
							28.041007072000063
						],
						[
							-82.72569645199987,
							28.04100765400003
						],
						[
							-82.72326146599993,
							28.041016027000097
						],
						[
							-82.7220556369999,
							28.041026153000047
						],
						[
							-82.72155249899993,
							28.04103085900008
						],
						[
							-82.72154842099994,
							28.040593903000072
						],
						[
							-82.7218345989999,
							28.04042118400008
						],
						[
							-82.72224915399994,
							28.040295234000055
						],
						[
							-82.72247392399996,
							28.04025485800009
						],
						[
							-82.72261768799986,
							28.040241037000012
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Forest Run Homeowners Association",
				"RegionID": "343260"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.72713137899994,
					28.023199925000096,
					-82.72480398999993,
					28.026288379000015
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.72504460599994,
							28.023264135000076
						],
						[
							-82.7250289659999,
							28.023199925000096
						],
						[
							-82.72506038199991,
							28.023204917000065
						],
						[
							-82.72570108199992,
							28.023302958000002
						],
						[
							-82.72711648399986,
							28.02351963800008
						],
						[
							-82.72713137899994,
							28.02628411200002
						],
						[
							-82.72619437099986,
							28.026288379000015
						],
						[
							-82.72613382599991,
							28.02612882900005
						],
						[
							-82.72597842899994,
							28.025792031000073
						],
						[
							-82.72579057699994,
							28.02546847000012
						],
						[
							-82.72557154399993,
							28.025160544000045
						],
						[
							-82.72532304299997,
							28.024870823000057
						],
						[
							-82.7251664959999,
							28.024701637000092
						],
						[
							-82.7250269709999,
							28.024521187000083
						],
						[
							-82.72490607299993,
							28.024330324000097
						],
						[
							-82.72480398999993,
							28.024129048000056
						],
						[
							-82.72520051899996,
							28.024098076000065
						],
						[
							-82.72519051899994,
							28.023993268000098
						],
						[
							-82.72518623199993,
							28.023946532000053
						],
						[
							-82.72518130599988,
							28.023905301000106
						],
						[
							-82.72517433499992,
							28.023847923000062
						],
						[
							-82.72516028199992,
							28.02377442200011
						],
						[
							-82.72515224299987,
							28.023731145000085
						],
						[
							-82.72513739699988,
							28.023654898000082
						],
						[
							-82.72512080899993,
							28.023578660000076
						],
						[
							-82.7250997939999,
							28.02349247600005
						],
						[
							-82.72508256199988,
							28.023421398000032
						],
						[
							-82.72506532999996,
							28.023350321000102
						],
						[
							-82.72504460599994,
							28.023264135000076
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Westchester Lake Condominium Association",
				"RegionID": "343267"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.72636107799988,
					28.016597614000133,
					-82.7235756459999,
					28.018369387000092
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.72468225799989,
							28.01663950300005
						],
						[
							-82.72532353099993,
							28.016597614000133
						],
						[
							-82.72528810999992,
							28.016861845000058
						],
						[
							-82.72578949499993,
							28.017219508000075
						],
						[
							-82.7259726609999,
							28.017265298000048
						],
						[
							-82.72626937399995,
							28.01760478800007
						],
						[
							-82.72636107799988,
							28.01787659900009
						],
						[
							-82.72561233999993,
							28.018070336000044
						],
						[
							-82.72553066299992,
							28.018094833000113
						],
						[
							-82.72543579399989,
							28.018131090000097
						],
						[
							-82.72534494799991,
							28.01817488900008
						],
						[
							-82.7252587969999,
							28.018225540000095
						],
						[
							-82.72517772099994,
							28.018282352000085
						],
						[
							-82.72509486499992,
							28.018352353000104
						],
						[
							-82.72505936699991,
							28.018369387000092
						],
						[
							-82.72502859799995,
							28.018368976000062
						],
						[
							-82.72500370899995,
							28.018359595000085
						],
						[
							-82.7235756459999,
							28.017541983000022
						],
						[
							-82.72389808299994,
							28.017094711000055
						],
						[
							-82.72447682199994,
							28.016970641000093
						],
						[
							-82.72464510499992,
							28.016645200000077
						],
						[
							-82.72468225799989,
							28.01663950300005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Winding Wood I",
				"RegionID": "343276"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.72389808299994,
					28.016347526000047,
					-82.72291742099988,
					28.017541983000022
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.72362212199992,
							28.01638104400007
						],
						[
							-82.7237195259999,
							28.016347526000047
						],
						[
							-82.72368987699994,
							28.016548466000067
						],
						[
							-82.72384348299994,
							28.016808950000033
						],
						[
							-82.72389808299994,
							28.017094711000055
						],
						[
							-82.7235756459999,
							28.017541983000022
						],
						[
							-82.72342005999991,
							28.017449287000083
						],
						[
							-82.72334128099996,
							28.017400537000043
						],
						[
							-82.72326750299989,
							28.017345916000053
						],
						[
							-82.72319949399996,
							28.01728542000002
						],
						[
							-82.7231377519999,
							28.01722042100006
						],
						[
							-82.72308236899994,
							28.017150576000056
						],
						[
							-82.72303422199987,
							28.017076567000064
						],
						[
							-82.72299341599995,
							28.016999425000073
						],
						[
							-82.72296033699988,
							28.016919148000092
						],
						[
							-82.72293528599994,
							28.016837109000058
						],
						[
							-82.72291742099988,
							28.01674351600004
						],
						[
							-82.72295065299997,
							28.01673044800011
						],
						[
							-82.72298692999995,
							28.016724413000055
						],
						[
							-82.72302212399993,
							28.01671528900001
						],
						[
							-82.72305652699994,
							28.016703762000038
						],
						[
							-82.72308955399991,
							28.01668914800007
						],
						[
							-82.72315713699992,
							28.01664272200005
						],
						[
							-82.72343415999991,
							28.016472455000084
						],
						[
							-82.7235284459999,
							28.01642176300006
						],
						[
							-82.72362212199992,
							28.01638104400007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Winding Wood No.6 Condominium Association",
				"RegionID": "343278"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.72535856499991,
					28.015584017000023,
					-82.72437768099991,
					28.01663950300005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.72450316299991,
							28.015812558000015
						],
						[
							-82.72455122199999,
							28.015584017000023
						],
						[
							-82.72506608599994,
							28.015641812000098
						],
						[
							-82.72528503599993,
							28.015940457000028
						],
						[
							-82.72535856499991,
							28.01627562500005
						],
						[
							-82.72532353099993,
							28.016597614000133
						],
						[
							-82.72468225799989,
							28.01663950300005
						],
						[
							-82.72437768099991,
							28.016049759000012
						],
						[
							-82.7244204979999,
							28.015964269000044
						],
						[
							-82.72442911499992,
							28.01586245700006
						],
						[
							-82.72450316299991,
							28.015812558000015
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Winding Wood 2",
				"RegionID": "343283"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.72393424099994,
					28.00836603700027,
					-82.71327569499991,
					28.01604315700025
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.7132775429997,
							28.012892520000246
						],
						[
							-82.71328202099981,
							28.012248888000283
						],
						[
							-82.71586669799972,
							28.012244390000266
						],
						[
							-82.71611772899979,
							28.012244114000243
						],
						[
							-82.71714974099982,
							28.012242515000377
						],
						[
							-82.71724993799977,
							28.011973134000204
						],
						[
							-82.71722873999988,
							28.009007212000295
						],
						[
							-82.71722764699979,
							28.008842190000323
						],
						[
							-82.71722425899986,
							28.008374628000357
						],
						[
							-82.71731723199973,
							28.008374831000285
						],
						[
							-82.72009087199972,
							28.00837236300026
						],
						[
							-82.72043201699988,
							28.00836603700027
						],
						[
							-82.72070699999982,
							28.0083770000002
						],
						[
							-82.72154422319726,
							28.008371147977154
						],
						[
							-82.72154699999994,
							28.00839500000009
						],
						[
							-82.72284199999989,
							28.008662000000154
						],
						[
							-82.72374799999989,
							28.008407000000194
						],
						[
							-82.7239298170215,
							28.00839156725569
						],
						[
							-82.72393424099994,
							28.008916709000356
						],
						[
							-82.72358405799973,
							28.00891855300033
						],
						[
							-82.72358596799971,
							28.009262351000356
						],
						[
							-82.72331635799979,
							28.00926377000021
						],
						[
							-82.72331793799974,
							28.009500301000326
						],
						[
							-82.72323116599976,
							28.009500758000275
						],
						[
							-82.72323806499979,
							28.0107074870002
						],
						[
							-82.72158725199981,
							28.010729228000134
						],
						[
							-82.72091662099983,
							28.01073549700021
						],
						[
							-82.72067224599986,
							28.010745717000344
						],
						[
							-82.72053783299984,
							28.010761894000172
						],
						[
							-82.72042944999984,
							28.010774839000266
						],
						[
							-82.7202334989997,
							28.010814028000045
						],
						[
							-82.7201904559997,
							28.010822505000302
						],
						[
							-82.71995729899986,
							28.010888706000184
						],
						[
							-82.71993594999978,
							28.010896726000315
						],
						[
							-82.71973162099975,
							28.01097274600021
						],
						[
							-82.71964260399976,
							28.011014125000347
						],
						[
							-82.71951467699984,
							28.01107358600003
						],
						[
							-82.71935354999991,
							28.011165538000352
						],
						[
							-82.71930878099975,
							28.01119087000014
						],
						[
							-82.71911500199971,
							28.01132390700022
						],
						[
							-82.71906441799987,
							28.011363709000317
						],
						[
							-82.71901913799978,
							28.011399358000336
						],
						[
							-82.71890478799973,
							28.011491065000374
						],
						[
							-82.71878503999977,
							28.011571799000304
						],
						[
							-82.7187649869998,
							28.01158565700003
						],
						[
							-82.71861648899977,
							28.01166894700035
						],
						[
							-82.7184604569999,
							28.011740587000237
						],
						[
							-82.71829978199985,
							28.011812939000183
						],
						[
							-82.71825540299982,
							28.012086842000375
						],
						[
							-82.71827776999982,
							28.01255361600027
						],
						[
							-82.71889322399974,
							28.012550055000247
						],
						[
							-82.71887614299976,
							28.01273408100037
						],
						[
							-82.71889905399979,
							28.015294643000136
						],
						[
							-82.7189058989999,
							28.01553767900035
						],
						[
							-82.71890698599974,
							28.0157013260003
						],
						[
							-82.71890745899987,
							28.015772492000327
						],
						[
							-82.71890874299987,
							28.016009713000148
						],
						[
							-82.7172182099998,
							28.016028171000254
						],
						[
							-82.71698267999976,
							28.016030432
						],
						[
							-82.71566247199978,
							28.01604315700025
						],
						[
							-82.71540075799979,
							28.01583514000018
						],
						[
							-82.71526214599969,
							28.015729969000276
						],
						[
							-82.71502793299986,
							28.015550688000094
						],
						[
							-82.71482701199974,
							28.01539633200029
						],
						[
							-82.71462726199984,
							28.015243345000332
						],
						[
							-82.7144260529997,
							28.01508899000026
						],
						[
							-82.71423321399973,
							28.01494146700005
						],
						[
							-82.71414540999966,
							28.014873849000313
						],
						[
							-82.71402329399997,
							28.014773404000263
						],
						[
							-82.7138907309999,
							28.01464516500022
						],
						[
							-82.71377106499986,
							28.014504481000305
						],
						[
							-82.71362727199987,
							28.014318196000257
						],
						[
							-82.71360691699988,
							28.014286328000285
						],
						[
							-82.71350155399978,
							28.01409709200026
						],
						[
							-82.71344550799975,
							28.013969143000242
						],
						[
							-82.71341531999983,
							28.01390019400031
						],
						[
							-82.71335206299975,
							28.013707130000324
						],
						[
							-82.71330230499971,
							28.013490274000322
						],
						[
							-82.71329667799988,
							28.0134449200003
						],
						[
							-82.7132862419999,
							28.013360054000383
						],
						[
							-82.7132764199997,
							28.01328034100027
						],
						[
							-82.71327569499991,
							28.01317032700023
						],
						[
							-82.7132775429997,
							28.012892520000246
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Northwood Estates Homeowners Association",
				"RegionID": "343285"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.57911696499991,
					30.27416407000004,
					-81.55906075999992,
					30.288563103000058
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.56885490799993,
							30.287429009000054
						],
						[
							-81.56853588499992,
							30.287392957000066
						],
						[
							-81.56834191999991,
							30.287464096000065
						],
						[
							-81.56743390999992,
							30.287371013000037
						],
						[
							-81.56740390999994,
							30.28737101200005
						],
						[
							-81.56695490999995,
							30.287324012000056
						],
						[
							-81.56605890899993,
							30.28723601300004
						],
						[
							-81.56556490999992,
							30.287193013000035
						],
						[
							-81.56410090999992,
							30.287039013000086
						],
						[
							-81.56392290999992,
							30.287023012000077
						],
						[
							-81.56223690899992,
							30.28687501200005
						],
						[
							-81.56164190999993,
							30.28681701200009
						],
						[
							-81.5606179099999,
							30.286746012000037
						],
						[
							-81.56025390999991,
							30.286721012000047
						],
						[
							-81.56010090899991,
							30.28671001200007
						],
						[
							-81.55951290999991,
							30.28668101200009
						],
						[
							-81.5594269099999,
							30.286669013000047
						],
						[
							-81.55935090999992,
							30.28666901200006
						],
						[
							-81.55928690799993,
							30.286669064000076
						],
						[
							-81.55928690799993,
							30.286594010000044
						],
						[
							-81.55928690799993,
							30.286514010000076
						],
						[
							-81.55928690799993,
							30.28645601000005
						],
						[
							-81.55928690799993,
							30.286232011000042
						],
						[
							-81.55928890699994,
							30.285708011000057
						],
						[
							-81.55927995999991,
							30.285233001000055
						],
						[
							-81.55918377299992,
							30.28490202100005
						],
						[
							-81.5591869079999,
							30.28478201000007
						],
						[
							-81.55919590799994,
							30.283510010000043
						],
						[
							-81.55919790799993,
							30.283151011000086
						],
						[
							-81.55919990799993,
							30.28292401000005
						],
						[
							-81.55920190799992,
							30.28260601100004
						],
						[
							-81.55914190699991,
							30.281312011000065
						],
						[
							-81.55906075999992,
							30.280912894000043
						],
						[
							-81.55923204299995,
							30.28090413600006
						],
						[
							-81.55919890799993,
							30.280215010000063
						],
						[
							-81.5591919069999,
							30.27807401000007
						],
						[
							-81.55918081699991,
							30.277950014000055
						],
						[
							-81.55919985399993,
							30.27416407000004
						],
						[
							-81.56900686799992,
							30.27944308200006
						],
						[
							-81.56931790699991,
							30.279548010000045
						],
						[
							-81.57050590699993,
							30.279910012000073
						],
						[
							-81.57064290699992,
							30.27997901100008
						],
						[
							-81.57082090699993,
							30.280105011000046
						],
						[
							-81.57132290699991,
							30.280517011000082
						],
						[
							-81.57153090799994,
							30.28071701000005
						],
						[
							-81.57228090699994,
							30.281533011000082
						],
						[
							-81.5731959069999,
							30.282541011000035
						],
						[
							-81.57392590799994,
							30.283327011000043
						],
						[
							-81.57421990799992,
							30.28358401000008
						],
						[
							-81.57428890799991,
							30.283635011000058
						],
						[
							-81.5744519079999,
							30.283749010000065
						],
						[
							-81.5749469079999,
							30.28403701000008
						],
						[
							-81.57661990799994,
							30.284818010000038
						],
						[
							-81.57738890699994,
							30.285179011000082
						],
						[
							-81.57911696499991,
							30.285980019000082
						],
						[
							-81.5790709069999,
							30.286135010000066
						],
						[
							-81.5783489069999,
							30.287885010000085
						],
						[
							-81.57823390699991,
							30.288179010000075
						],
						[
							-81.5781719069999,
							30.288389011000053
						],
						[
							-81.57810792499993,
							30.288563103000058
						],
						[
							-81.57789190799991,
							30.28854001000008
						],
						[
							-81.5777609079999,
							30.288527010000053
						],
						[
							-81.57762390799991,
							30.288507010000043
						],
						[
							-81.57744177199993,
							30.288488039000068
						],
						[
							-81.57757404799992,
							30.28840198000006
						],
						[
							-81.57697690799995,
							30.288322011000048
						],
						[
							-81.5762559069999,
							30.288233010000056
						],
						[
							-81.5758509069999,
							30.288204011000058
						],
						[
							-81.57575990799995,
							30.288202010000077
						],
						[
							-81.57524090699991,
							30.288130010000085
						],
						[
							-81.5748589069999,
							30.288076010000058
						],
						[
							-81.57445890699996,
							30.28802801100005
						],
						[
							-81.57412290799994,
							30.287989011000036
						],
						[
							-81.57372290699993,
							30.28794101000005
						],
						[
							-81.57335690699995,
							30.28790101000004
						],
						[
							-81.5730819069999,
							30.287857011000085
						],
						[
							-81.57284490699993,
							30.287827010000058
						],
						[
							-81.57247190699991,
							30.28779601100007
						],
						[
							-81.5711439079999,
							30.287630010000044
						],
						[
							-81.57050299999992,
							30.28757600000006
						],
						[
							-81.57019579399991,
							30.287549517000063
						],
						[
							-81.56998099999993,
							30.287531000000058
						],
						[
							-81.56885490799993,
							30.287429009000054
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Kilarney Shores",
				"RegionID": "274183"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.28265863399992,
					28.377079767000055,
					-81.24364274399994,
					28.40807832200005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.24932523799993,
							28.40804367800007
						],
						[
							-81.24930044199994,
							28.408036652000078
						],
						[
							-81.24911644199994,
							28.407981652000046
						],
						[
							-81.24908492199995,
							28.40797159500005
						],
						[
							-81.24902984399995,
							28.40795086500009
						],
						[
							-81.24897623999993,
							28.40792657800006
						],
						[
							-81.24892433899993,
							28.407898836000072
						],
						[
							-81.24892006399995,
							28.40789635200008
						],
						[
							-81.2488750789999,
							28.407870049000053
						],
						[
							-81.2484064219999,
							28.407786111000064
						],
						[
							-81.24820763499991,
							28.40777058100008
						],
						[
							-81.24714914899994,
							28.407717949000073
						],
						[
							-81.2463429689999,
							28.407704480000064
						],
						[
							-81.24619689299993,
							28.407707560000063
						],
						[
							-81.24614845799994,
							28.40773508500007
						],
						[
							-81.24613395999995,
							28.407745420000083
						],
						[
							-81.24613254899992,
							28.407746742000086
						],
						[
							-81.24605470799992,
							28.407836332000045
						],
						[
							-81.24543441199995,
							28.407179074000055
						],
						[
							-81.24389369499994,
							28.407165317000082
						],
						[
							-81.24364274399994,
							28.407163077000064
						],
						[
							-81.24367499999994,
							28.406828000000075
						],
						[
							-81.2438249999999,
							28.405249000000083
						],
						[
							-81.2438459999999,
							28.40450000000004
						],
						[
							-81.2440029999999,
							28.404509000000076
						],
						[
							-81.24430964399994,
							28.40443408100009
						],
						[
							-81.24435499999993,
							28.40442300000007
						],
						[
							-81.2445899999999,
							28.40438000000006
						],
						[
							-81.24499999999995,
							28.40425900000008
						],
						[
							-81.24520599999995,
							28.404199000000062
						],
						[
							-81.24552899999992,
							28.404113000000052
						],
						[
							-81.24608599999993,
							28.403863000000058
						],
						[
							-81.24650699999995,
							28.403648000000093
						],
						[
							-81.24691699999994,
							28.403373000000045
						],
						[
							-81.2474059999999,
							28.403020000000083
						],
						[
							-81.2478759999999,
							28.402573000000075
						],
						[
							-81.24813999999992,
							28.40222000000006
						],
						[
							-81.24851199999995,
							28.40186800000004
						],
						[
							-81.24881499999994,
							28.40141200000005
						],
						[
							-81.24899099999993,
							28.40106700000007
						],
						[
							-81.2492739999999,
							28.400672000000043
						],
						[
							-81.24956799999991,
							28.400310000000047
						],
						[
							-81.24982199999994,
							28.40000900000007
						],
						[
							-81.24997899999994,
							28.39982000000009
						],
						[
							-81.25016399999993,
							28.399510000000078
						],
						[
							-81.24896099999995,
							28.400637000000074
						],
						[
							-81.2485309999999,
							28.400999000000073
						],
						[
							-81.24827699999992,
							28.40117900000007
						],
						[
							-81.24800299999993,
							28.401403000000073
						],
						[
							-81.24780699999991,
							28.401541000000066
						],
						[
							-81.24750399999994,
							28.40177300000005
						],
						[
							-81.24714199999994,
							28.402048000000036
						],
						[
							-81.24691699999994,
							28.402212000000077
						],
						[
							-81.24654599999991,
							28.40241800000007
						],
						[
							-81.24580199999991,
							28.402840000000083
						],
						[
							-81.24532299999993,
							28.403132000000088
						],
						[
							-81.24492199999992,
							28.40338200000008
						],
						[
							-81.24476599999991,
							28.40352800000005
						],
						[
							-81.24454099999991,
							28.403640000000053
						],
						[
							-81.24440399999992,
							28.40371700000009
						],
						[
							-81.24430599999994,
							28.403752000000054
						],
						[
							-81.24425699999995,
							28.403726000000063
						],
						[
							-81.2442769999999,
							28.40362300000004
						],
						[
							-81.24427299999991,
							28.403417000000047
						],
						[
							-81.2442999999999,
							28.403122000000053
						],
						[
							-81.2443209999999,
							28.402865000000077
						],
						[
							-81.24431099999993,
							28.402641000000077
						],
						[
							-81.24429099999992,
							28.40232300000008
						],
						[
							-81.24432999999993,
							28.40186700000004
						],
						[
							-81.2443209999999,
							28.40162600000008
						],
						[
							-81.24436899999995,
							28.40141900000009
						],
						[
							-81.24441799999994,
							28.400877000000037
						],
						[
							-81.2444340909999,
							28.400678547000044
						],
						[
							-81.24461822599994,
							28.40060523200009
						],
						[
							-81.24675544399992,
							28.39930587500004
						],
						[
							-81.25027674899991,
							28.396880384000042
						],
						[
							-81.25747634499993,
							28.387801814000056
						],
						[
							-81.25982486299995,
							28.385453376000044
						],
						[
							-81.26256387199993,
							28.384046193000074
						],
						[
							-81.2680410129999,
							28.382637153000076
						],
						[
							-81.27555515599994,
							28.37981997600008
						],
						[
							-81.2825986979999,
							28.377079767000055
						],
						[
							-81.28265863399992,
							28.37869526700007
						],
						[
							-81.28220707999992,
							28.407005087000073
						],
						[
							-81.28220515399994,
							28.407137618000036
						],
						[
							-81.28148160099994,
							28.40717853600006
						],
						[
							-81.28070749799991,
							28.407640135000065
						],
						[
							-81.2805326159999,
							28.407386501000076
						],
						[
							-81.2805252409999,
							28.40737563600004
						],
						[
							-81.28049416399995,
							28.407325661000073
						],
						[
							-81.28048813299995,
							28.40731504900009
						],
						[
							-81.28022913399991,
							28.406852050000055
						],
						[
							-81.28020742299992,
							28.40681076000004
						],
						[
							-81.28018515399992,
							28.406761989000074
						],
						[
							-81.2801317119999,
							28.406635064000056
						],
						[
							-81.28010277699991,
							28.406605547000087
						],
						[
							-81.28006885399992,
							28.406568964000087
						],
						[
							-81.28003151999991,
							28.40652347200006
						],
						[
							-81.28002577899991,
							28.406515908000074
						],
						[
							-81.27975177899992,
							28.406150909000075
						],
						[
							-81.27974042299991,
							28.40613544000007
						],
						[
							-81.27956742299995,
							28.405894440000054
						],
						[
							-81.27955024099992,
							28.40586963700008
						],
						[
							-81.27951916399991,
							28.405819661000066
						],
						[
							-81.27950730999993,
							28.40579847400005
						],
						[
							-81.27941030999995,
							28.405619474000048
						],
						[
							-81.27939442199994,
							28.405588760000057
						],
						[
							-81.27937013499991,
							28.40553515600004
						],
						[
							-81.27934940499995,
							28.40548007800004
						],
						[
							-81.27933232099991,
							28.405423762000055
						],
						[
							-81.27931895799992,
							28.40536644900004
						],
						[
							-81.27931182599991,
							28.405325723000093
						],
						[
							-81.27931171099993,
							28.405324962000066
						],
						[
							-81.27930295599992,
							28.405306532000054
						],
						[
							-81.2792984159999,
							28.405302143000085
						],
						[
							-81.27926692599993,
							28.405276486000048
						],
						[
							-81.27921365399993,
							28.405255130000057
						],
						[
							-81.27917440999995,
							28.405247410000072
						],
						[
							-81.27917255099993,
							28.405247042000045
						],
						[
							-81.27911523799992,
							28.40523367800006
						],
						[
							-81.27905892199993,
							28.40521659500007
						],
						[
							-81.27900384399994,
							28.405195865000053
						],
						[
							-81.27900188099994,
							28.405195049000042
						],
						[
							-81.27874288099991,
							28.405087050000077
						],
						[
							-81.27869123999994,
							28.405063578000068
						],
						[
							-81.27863933899994,
							28.405035836000085
						],
						[
							-81.27858936299992,
							28.405004759000064
						],
						[
							-81.27858256299993,
							28.40500017100004
						],
						[
							-81.27845304399995,
							28.404911909000077
						],
						[
							-81.2781247559999,
							28.404816804000063
						],
						[
							-81.27810504699994,
							28.404810849000057
						],
						[
							-81.27799105299994,
							28.40477497700005
						],
						[
							-81.27797180399995,
							28.404770322000047
						],
						[
							-81.2779614069999,
							28.404770322000047
						],
						[
							-81.27770673599991,
							28.40478813100009
						],
						[
							-81.27770281799991,
							28.40478839600007
						],
						[
							-81.27764399999995,
							28.404790322000053
						],
						[
							-81.2775925819999,
							28.404788851000035
						],
						[
							-81.2773655819999,
							28.404775851000068
						],
						[
							-81.27735818199994,
							28.404775396000048
						],
						[
							-81.27731034599992,
							28.404770975000076
						],
						[
							-81.27688334599992,
							28.404719976000084
						],
						[
							-81.27687261499995,
							28.404718629000058
						],
						[
							-81.27681455099992,
							28.40470904200004
						],
						[
							-81.27675723899995,
							28.404695679000042
						],
						[
							-81.2767250359999,
							28.404686404000074
						],
						[
							-81.27597903599991,
							28.40445640300004
						],
						[
							-81.27595492199993,
							28.404448595000076
						],
						[
							-81.2759515649999,
							28.40444744800004
						],
						[
							-81.27566656499994,
							28.404349448000062
						],
						[
							-81.27561484499995,
							28.40432986500008
						],
						[
							-81.27556123999994,
							28.40430557700006
						],
						[
							-81.2755329929999,
							28.404291021000063
						],
						[
							-81.2754009919999,
							28.40422002100007
						],
						[
							-81.27537733899993,
							28.40420683600007
						],
						[
							-81.27532736299992,
							28.404175759000058
						],
						[
							-81.2752874059999,
							28.40414745700008
						],
						[
							-81.2752367889999,
							28.40410949400007
						],
						[
							-81.27517585599992,
							28.404082413000083
						],
						[
							-81.27463332999992,
							28.403958876000047
						],
						[
							-81.27460614199993,
							28.403952239000034
						],
						[
							-81.27438338799993,
							28.403894171000047
						],
						[
							-81.27397733599992,
							28.40379945400008
						],
						[
							-81.27332382599991,
							28.40371729900005
						],
						[
							-81.27331861499994,
							28.40371662800004
						],
						[
							-81.27326055099991,
							28.403707042000065
						],
						[
							-81.27325157399991,
							28.403705209000066
						],
						[
							-81.27312723999995,
							28.403679158000045
						],
						[
							-81.27303673799992,
							28.40367802600008
						],
						[
							-81.27293923799994,
							28.403690290000043
						],
						[
							-81.2728858179999,
							28.403695396000046
						],
						[
							-81.27282699999995,
							28.403697322000085
						],
						[
							-81.27276818099995,
							28.403695396000046
						],
						[
							-81.27275339099992,
							28.403694304000055
						],
						[
							-81.27241594199995,
							28.403666591000047
						],
						[
							-81.27239607799993,
							28.403673595000043
						],
						[
							-81.27233976199994,
							28.403690678000093
						],
						[
							-81.27228244899993,
							28.403704042000072
						],
						[
							-81.2722243849999,
							28.403713628000048
						],
						[
							-81.2721658179999,
							28.403719396000042
						],
						[
							-81.27213716299991,
							28.40372081600009
						],
						[
							-81.27190135899991,
							28.40372872900008
						],
						[
							-81.27171351299995,
							28.40376130700008
						],
						[
							-81.27150813899993,
							28.403807449000055
						],
						[
							-81.27148644899995,
							28.403812042000084
						],
						[
							-81.27142838499992,
							28.40382162900005
						],
						[
							-81.2713737979999,
							28.403827127000056
						],
						[
							-81.27117379799995,
							28.403841127000078
						],
						[
							-81.27116981799992,
							28.403841397000065
						],
						[
							-81.2711109999999,
							28.403843322000057
						],
						[
							-81.27109328199992,
							28.403843148000078
						],
						[
							-81.27089028199993,
							28.403839147000046
						],
						[
							-81.27084918199995,
							28.403837396000085
						],
						[
							-81.2707906149999,
							28.403831628000034
						],
						[
							-81.27073255099994,
							28.40382204200006
						],
						[
							-81.2707191049999,
							28.403819260000034
						],
						[
							-81.27042148699991,
							28.403755322000052
						],
						[
							-81.27031699999992,
							28.403755322000052
						],
						[
							-81.2702581819999,
							28.40375339600007
						],
						[
							-81.27025371999991,
							28.403753093000034
						],
						[
							-81.27009383299992,
							28.403741814000057
						],
						[
							-81.26977589899991,
							28.403778653000074
						],
						[
							-81.26954042099993,
							28.403842232000045
						],
						[
							-81.26953876199991,
							28.403842678000046
						],
						[
							-81.2694814489999,
							28.40385604100004
						],
						[
							-81.26947076499994,
							28.403858100000036
						],
						[
							-81.26927136099994,
							28.40389526100006
						],
						[
							-81.26909940899992,
							28.40393567400008
						],
						[
							-81.26897469599993,
							28.403972502000045
						],
						[
							-81.26895276199991,
							28.403978678000044
						],
						[
							-81.2689169869999,
							28.403987483000037
						],
						[
							-81.2687988209999,
							28.404014010000083
						],
						[
							-81.26828802499995,
							28.40422863000009
						],
						[
							-81.26803456699992,
							28.40434287800008
						],
						[
							-81.26800915599995,
							28.404353865000076
						],
						[
							-81.26795407799995,
							28.404374595000036
						],
						[
							-81.26794524299993,
							28.404377543000066
						],
						[
							-81.2675867449999,
							28.404495111000074
						],
						[
							-81.26688490999993,
							28.40487020100005
						],
						[
							-81.2668535979999,
							28.404894978000076
						],
						[
							-81.26669015999994,
							28.40504055400004
						],
						[
							-81.26668496399992,
							28.405045146000077
						],
						[
							-81.26663947199995,
							28.40508248000009
						],
						[
							-81.26659163599993,
							28.405116759000066
						],
						[
							-81.2665416609999,
							28.405147836000083
						],
						[
							-81.2664897599999,
							28.40517557800007
						],
						[
							-81.26646721899994,
							28.405186307000065
						],
						[
							-81.26624721999991,
							28.405287307000037
						],
						[
							-81.26621615599993,
							28.40530086600006
						],
						[
							-81.26616107799993,
							28.40532159500009
						],
						[
							-81.26614781599994,
							28.40532598300007
						],
						[
							-81.26606356799995,
							28.405353129000048
						],
						[
							-81.26605786899995,
							28.405356503000064
						],
						[
							-81.26441584999992,
							28.406526429000053
						],
						[
							-81.2643936369999,
							28.406541759000053
						],
						[
							-81.26434366099994,
							28.406572836000066
						],
						[
							-81.26429175999994,
							28.406600578000052
						],
						[
							-81.26423815599992,
							28.406624865000083
						],
						[
							-81.26418307799992,
							28.406645595000043
						],
						[
							-81.26412676199993,
							28.40666267900008
						],
						[
							-81.2640995559999,
							28.40666951500009
						],
						[
							-81.26388203999994,
							28.406720585000073
						],
						[
							-81.26384842399995,
							28.406739822000077
						],
						[
							-81.26355199199992,
							28.406928898000047
						],
						[
							-81.2634526459999,
							28.407014909000054
						],
						[
							-81.2634114729999,
							28.40704848000007
						],
						[
							-81.26336363699994,
							28.40708275900005
						],
						[
							-81.26334008999994,
							28.407097967000084
						],
						[
							-81.26332446499993,
							28.407107717000088
						],
						[
							-81.26322321499993,
							28.407622685000035
						],
						[
							-81.26234167599995,
							28.407444670000075
						],
						[
							-81.26193796199993,
							28.40744494500007
						],
						[
							-81.2613109099999,
							28.40752291000007
						],
						[
							-81.26119549999993,
							28.407522778000043
						],
						[
							-81.26033401699993,
							28.407264179000038
						],
						[
							-81.26033926699995,
							28.407245514000067
						],
						[
							-81.26035340499993,
							28.407199922000075
						],
						[
							-81.26036134899994,
							28.40717749800007
						],
						[
							-81.2604813499999,
							28.406852498000035
						],
						[
							-81.26049413499993,
							28.406819845000086
						],
						[
							-81.26051842299995,
							28.40676624000008
						],
						[
							-81.26054616499994,
							28.406714339000075
						],
						[
							-81.26056745299991,
							28.406679334000046
						],
						[
							-81.26068645299995,
							28.40649333300007
						],
						[
							-81.26069624099995,
							28.406478363000076
						],
						[
							-81.26073051999992,
							28.406430527000055
						],
						[
							-81.26076785399994,
							28.406385036000074
						],
						[
							-81.2608080839999,
							28.406342083000084
						],
						[
							-81.2608303749999,
							28.406320547000064
						],
						[
							-81.26088923499992,
							28.406265611000038
						],
						[
							-81.26089595899992,
							28.40622755100009
						],
						[
							-81.26090932199992,
							28.406170239000062
						],
						[
							-81.2609264049999,
							28.40611392300008
						],
						[
							-81.26094713499992,
							28.406058845000075
						],
						[
							-81.2609572259999,
							28.406035429000042
						],
						[
							-81.26109577099993,
							28.405726062000042
						],
						[
							-81.26110895599993,
							28.405666531000065
						],
						[
							-81.2611183219999,
							28.405628238000077
						],
						[
							-81.26113540499995,
							28.40557192200004
						],
						[
							-81.26115613499992,
							28.40551684400009
						],
						[
							-81.26118042299993,
							28.405463240000074
						],
						[
							-81.26120816399992,
							28.405411339000068
						],
						[
							-81.26123924099994,
							28.405361363000054
						],
						[
							-81.26127351999992,
							28.40531352700009
						],
						[
							-81.26127765599995,
							28.405308179000087
						],
						[
							-81.26137318399992,
							28.405185604000053
						],
						[
							-81.26137559199992,
							28.40517490000008
						],
						[
							-81.26138302899994,
							28.405081572000086
						],
						[
							-81.26138196399995,
							28.40507107700006
						],
						[
							-81.26137925199993,
							28.405033118000063
						],
						[
							-81.26132349599993,
							28.404951873000073
						],
						[
							-81.26131724099992,
							28.404942636000044
						],
						[
							-81.2612861639999,
							28.40489266100008
						],
						[
							-81.2612584229999,
							28.40484076000007
						],
						[
							-81.2612557779999,
							28.404835352000077
						],
						[
							-81.26122818499994,
							28.404778442000065
						],
						[
							-81.2612214429999,
							28.40476931900008
						],
						[
							-81.26112330099994,
							28.404662615000063
						],
						[
							-81.26108134499992,
							28.404622148000044
						],
						[
							-81.26043683299991,
							28.40432055000008
						],
						[
							-81.26042023999992,
							28.40431257700004
						],
						[
							-81.2604086309999,
							28.40430674800007
						],
						[
							-81.2602306309999,
							28.40421574800007
						],
						[
							-81.2601903389999,
							28.40419383600005
						],
						[
							-81.26014036399994,
							28.404162759000087
						],
						[
							-81.26009252799992,
							28.404128480000054
						],
						[
							-81.26006057299992,
							28.40410278300004
						],
						[
							-81.25989461799993,
							28.404061382000066
						],
						[
							-81.25980932899995,
							28.404048900000078
						],
						[
							-81.25954916899991,
							28.404031262000046
						],
						[
							-81.25949261499994,
							28.404025628000056
						],
						[
							-81.25943455099991,
							28.40401604200008
						],
						[
							-81.25938227899991,
							28.404004013000076
						],
						[
							-81.25908427899992,
							28.40392601300005
						],
						[
							-81.25907923799993,
							28.40392467800007
						],
						[
							-81.25902292199993,
							28.403907595000078
						],
						[
							-81.25901360799992,
							28.403904376000074
						],
						[
							-81.25886860799994,
							28.403853377000075
						],
						[
							-81.25882284399995,
							28.403835865000076
						],
						[
							-81.25876923999994,
							28.403811578000045
						],
						[
							-81.25871733899993,
							28.40378383600006
						],
						[
							-81.25870948799991,
							28.40377925000007
						],
						[
							-81.2585774879999,
							28.40370125000004
						],
						[
							-81.25853536299991,
							28.40367475900007
						],
						[
							-81.25849540399992,
							28.403646456000047
						],
						[
							-81.25834740399995,
							28.403535455000057
						],
						[
							-81.25833952799991,
							28.40352948000009
						],
						[
							-81.25829403599994,
							28.403492146000076
						],
						[
							-81.25825108399994,
							28.40345191600005
						],
						[
							-81.25821085399991,
							28.40340896400005
						],
						[
							-81.2581735199999,
							28.403363472000084
						],
						[
							-81.25813924099992,
							28.40331563600006
						],
						[
							-81.2581081649999,
							28.403265661000034
						],
						[
							-81.25808042299992,
							28.403213760000085
						],
						[
							-81.25806440299993,
							28.40317947300008
						],
						[
							-81.25800740299991,
							28.403050474000054
						],
						[
							-81.25799913499992,
							28.403031156000054
						],
						[
							-81.2579784049999,
							28.40297607800005
						],
						[
							-81.25796132199991,
							28.402919762000067
						],
						[
							-81.2579481439999,
							28.402863380000042
						],
						[
							-81.25793476199993,
							28.40279647300008
						],
						[
							-81.2579184029999,
							28.40271756100009
						],
						[
							-81.2579169579999,
							28.402710449000043
						],
						[
							-81.25790737199992,
							28.402652385000067
						],
						[
							-81.25790160299994,
							28.40259381900006
						],
						[
							-81.25789967799994,
							28.402535000000057
						],
						[
							-81.25790160299994,
							28.402476182000044
						],
						[
							-81.2579057129999,
							28.40243098800005
						],
						[
							-81.25792271299991,
							28.402284988000076
						],
						[
							-81.25792437099994,
							28.402271615000075
						],
						[
							-81.25793395799991,
							28.402213551000045
						],
						[
							-81.2579473209999,
							28.40215623800009
						],
						[
							-81.25796440499994,
							28.402099922000048
						],
						[
							-81.25797095099995,
							28.402081311000074
						],
						[
							-81.25828531299993,
							28.401217934000044
						],
						[
							-81.25828352299993,
							28.401207458000048
						],
						[
							-81.25827837199995,
							28.40117338500005
						],
						[
							-81.25827260299991,
							28.401114819000043
						],
						[
							-81.25827088799991,
							28.401075434000063
						],
						[
							-81.25823648399995,
							28.40090054800004
						],
						[
							-81.25815169499992,
							28.400825131000094
						],
						[
							-81.25814432199991,
							28.40082078100005
						],
						[
							-81.25811278499992,
							28.40081143000009
						],
						[
							-81.25753793099994,
							28.400689863000082
						],
						[
							-81.25752221699992,
							28.400686393000058
						],
						[
							-81.2573091509999,
							28.400637336000045
						],
						[
							-81.25724602799994,
							28.40063424600004
						],
						[
							-81.25723118199994,
							28.40063339600005
						],
						[
							-81.25717261499994,
							28.400627628000052
						],
						[
							-81.25713964499994,
							28.400622664000082
						],
						[
							-81.25673864399994,
							28.400554664000083
						],
						[
							-81.2567135509999,
							28.400550042000077
						],
						[
							-81.25665623799995,
							28.400536679000083
						],
						[
							-81.25661832199995,
							28.400525621000043
						],
						[
							-81.2563835389999,
							28.400451520000047
						],
						[
							-81.25598326999994,
							28.400390368000046
						],
						[
							-81.25587753899993,
							28.400413163000053
						],
						[
							-81.2557949529999,
							28.40043554600004
						],
						[
							-81.25554922299995,
							28.400689441000054
						],
						[
							-81.25553891699991,
							28.400699917000054
						],
						[
							-81.25549596399992,
							28.40074014700008
						],
						[
							-81.25545468999991,
							28.400774224000088
						],
						[
							-81.25516557299994,
							28.400998806000075
						],
						[
							-81.2551088219999,
							28.401172028000076
						],
						[
							-81.25509839899992,
							28.40121040400004
						],
						[
							-81.25509583899992,
							28.401288471000044
						],
						[
							-81.25509439599995,
							28.401317818000052
						],
						[
							-81.25509173799992,
							28.401349683000035
						],
						[
							-81.25504423799993,
							28.401818350000042
						],
						[
							-81.25506178699993,
							28.40191880000009
						],
						[
							-81.2551423139999,
							28.402012282000044
						],
						[
							-81.25523622799994,
							28.40210540600009
						],
						[
							-81.25523891599994,
							28.402108083000087
						],
						[
							-81.2552791459999,
							28.402151036000078
						],
						[
							-81.25531647999992,
							28.402196527000058
						],
						[
							-81.25532461699993,
							28.402207298000064
						],
						[
							-81.25540732299993,
							28.402318499000046
						],
						[
							-81.25551132599992,
							28.402424787000086
						],
						[
							-81.25570401199991,
							28.40258176100008
						],
						[
							-81.2557289639999,
							28.402602854000065
						],
						[
							-81.25577191699995,
							28.40264308400009
						],
						[
							-81.25580910199994,
							28.402682582000068
						],
						[
							-81.25601910099994,
							28.40291958200004
						],
						[
							-81.2560221459999,
							28.40292303600006
						],
						[
							-81.25605947999992,
							28.402968528000088
						],
						[
							-81.25609375899995,
							28.403016364000052
						],
						[
							-81.25612483599991,
							28.403066339000077
						],
						[
							-81.25615257699991,
							28.403118240000083
						],
						[
							-81.25617686499993,
							28.403171845000088
						],
						[
							-81.25618488599991,
							28.40319188600006
						],
						[
							-81.25621888599994,
							28.403279885000075
						],
						[
							-81.25623159499992,
							28.40331492200005
						],
						[
							-81.2562486779999,
							28.40337123800009
						],
						[
							-81.2562528229999,
							28.40338729700005
						],
						[
							-81.25648959799992,
							28.403588053000078
						],
						[
							-81.25650096399994,
							28.403597854000054
						],
						[
							-81.25654391599994,
							28.40363808400008
						],
						[
							-81.25658414599991,
							28.40368103600008
						],
						[
							-81.25662147999992,
							28.40372652800005
						],
						[
							-81.25665130399994,
							28.40376776100004
						],
						[
							-81.25685630499993,
							28.404068760000087
						],
						[
							-81.25686075899995,
							28.40407536300006
						],
						[
							-81.25689183599991,
							28.404125339000075
						],
						[
							-81.25691957799995,
							28.40417724000008
						],
						[
							-81.25694386499993,
							28.40423084400004
						],
						[
							-81.25696459499994,
							28.404285922000042
						],
						[
							-81.25697569499994,
							28.404320958000085
						],
						[
							-81.25702369499993,
							28.40448395800007
						],
						[
							-81.25702967799992,
							28.40450523800007
						],
						[
							-81.25704304099992,
							28.404562551000083
						],
						[
							-81.25705177099991,
							28.40461428000009
						],
						[
							-81.25705872499992,
							28.40466434700005
						],
						[
							-81.25713533399994,
							28.404802488000087
						],
						[
							-81.2572400009999,
							28.40494179900009
						],
						[
							-81.25726875899994,
							28.40498236400009
						],
						[
							-81.2572998359999,
							28.40503233900006
						],
						[
							-81.2573275769999,
							28.405084240000065
						],
						[
							-81.25735186499992,
							28.40513784500007
						],
						[
							-81.25737259499994,
							28.405192923000072
						],
						[
							-81.25738967799992,
							28.405249239000057
						],
						[
							-81.25739127799994,
							28.40525529200005
						],
						[
							-81.25742227799992,
							28.405374292000094
						],
						[
							-81.2574340409999,
							28.405425551000064
						],
						[
							-81.25743976099994,
							28.405457265000052
						],
						[
							-81.25745654899994,
							28.40556095100004
						],
						[
							-81.25746571899992,
							28.405582708000054
						],
						[
							-81.25746786499991,
							28.40558784500007
						],
						[
							-81.25748859499993,
							28.405642923000073
						],
						[
							-81.25750567799992,
							28.405699239000057
						],
						[
							-81.25751904199991,
							28.40575655100008
						],
						[
							-81.25752862799993,
							28.405814615000054
						],
						[
							-81.25753439599993,
							28.40587318200005
						],
						[
							-81.25753632199991,
							28.405932000000064
						],
						[
							-81.25753439599993,
							28.405990819000067
						],
						[
							-81.25752862799993,
							28.406049385000074
						],
						[
							-81.25752684499992,
							28.406062217000056
						],
						[
							-81.25751484499995,
							28.40614421800007
						],
						[
							-81.25750704199993,
							28.406189449000067
						],
						[
							-81.25749367899994,
							28.40624676200008
						],
						[
							-81.2574765949999,
							28.406303078000064
						],
						[
							-81.25747475599991,
							28.40630844100008
						],
						[
							-81.25747382599991,
							28.40632824800008
						],
						[
							-81.2575481909999,
							28.406673783000087
						],
						[
							-81.25755104099994,
							28.40668755100006
						],
						[
							-81.25755533599994,
							28.40671072200007
						],
						[
							-81.2575873159999,
							28.40689686500008
						],
						[
							-81.25761656799995,
							28.40700582800008
						],
						[
							-81.25761667799992,
							28.407006239000054
						],
						[
							-81.2576300419999,
							28.40706355100008
						],
						[
							-81.25763962799994,
							28.40712161500005
						],
						[
							-81.25764539599993,
							28.40718018200005
						],
						[
							-81.25764708999992,
							28.40721856500005
						],
						[
							-81.25764978299992,
							28.407337061000078
						],
						[
							-81.25674993299994,
							28.40732406400008
						],
						[
							-81.25658028099991,
							28.40731935100007
						],
						[
							-81.25385306699991,
							28.407243595000068
						],
						[
							-81.25294373199995,
							28.407452440000043
						],
						[
							-81.25288902299991,
							28.40738510600005
						],
						[
							-81.25287351999992,
							28.407365472000038
						],
						[
							-81.25283924099995,
							28.407317636000073
						],
						[
							-81.25280816399993,
							28.40726766100005
						],
						[
							-81.25278262199993,
							28.407220189000043
						],
						[
							-81.2527456219999,
							28.407146189000063
						],
						[
							-81.25274342199992,
							28.40714176000006
						],
						[
							-81.25271913499995,
							28.407088156000043
						],
						[
							-81.25269840499993,
							28.40703307700005
						],
						[
							-81.2526813209999,
							28.406976762000056
						],
						[
							-81.2526679579999,
							28.406919449000043
						],
						[
							-81.25265837199993,
							28.40686138500007
						],
						[
							-81.25265260299994,
							28.406802818000074
						],
						[
							-81.25265067799995,
							28.40674400000006
						],
						[
							-81.25265069099994,
							28.406739085000083
						],
						[
							-81.25265269099994,
							28.406373086000087
						],
						[
							-81.25265460299994,
							28.40631918200006
						],
						[
							-81.25265499599993,
							28.40631346500004
						],
						[
							-81.2526649969999,
							28.40617446400006
						],
						[
							-81.25266838399995,
							28.406137859000072
						],
						[
							-81.2526601909999,
							28.40612874800007
						],
						[
							-81.25255819199992,
							28.406013748000078
						],
						[
							-81.25255485399992,
							28.406009964000077
						],
						[
							-81.25251751999991,
							28.40596447200005
						],
						[
							-81.25248324099994,
							28.405916636000086
						],
						[
							-81.25245216499991,
							28.40586666100006
						],
						[
							-81.25242442299992,
							28.405814760000055
						],
						[
							-81.25240979699993,
							28.40578361300004
						],
						[
							-81.25235979699994,
							28.405671613000038
						],
						[
							-81.25235013499992,
							28.405649156000038
						],
						[
							-81.2523294049999,
							28.405594078000036
						],
						[
							-81.25231232099992,
							28.40553776200005
						],
						[
							-81.25229895799993,
							28.405480449000038
						],
						[
							-81.25229284699992,
							28.405446294000058
						],
						[
							-81.2522788469999,
							28.405358293000063
						],
						[
							-81.25227537199993,
							28.405334385000064
						],
						[
							-81.25226960399993,
							28.405275818000064
						],
						[
							-81.25226767999993,
							28.405218782000077
						],
						[
							-81.25225382999992,
							28.405197156000046
						],
						[
							-81.25224103599993,
							28.405186146000062
						],
						[
							-81.25219808299994,
							28.405145917000088
						],
						[
							-81.2521578539999,
							28.405102965000083
						],
						[
							-81.25213710499992,
							28.405078435000064
						],
						[
							-81.25207911199993,
							28.40500733600004
						],
						[
							-81.25185306899994,
							28.40497329300007
						],
						[
							-81.25181155099995,
							28.40496604100008
						],
						[
							-81.25177345499992,
							28.404957601000035
						],
						[
							-81.25174485399992,
							28.404950609000082
						],
						[
							-81.25169730499994,
							28.40495230600004
						],
						[
							-81.25143025499995,
							28.404953882000086
						],
						[
							-81.25130999399994,
							28.40513919500006
						],
						[
							-81.2513051869999,
							28.40514844500007
						],
						[
							-81.25132057799993,
							28.405178240000055
						],
						[
							-81.25134486499991,
							28.40523184400007
						],
						[
							-81.25136559499992,
							28.405286922000073
						],
						[
							-81.25137955199995,
							28.405331869000065
						],
						[
							-81.25142355199995,
							28.405487869000073
						],
						[
							-81.2514266789999,
							28.40549923800006
						],
						[
							-81.2514400419999,
							28.405556551000075
						],
						[
							-81.25144602799993,
							28.405589916000054
						],
						[
							-81.25146602799992,
							28.40571491600008
						],
						[
							-81.25146962899993,
							28.405739615000073
						],
						[
							-81.25147539699992,
							28.40579818200007
						],
						[
							-81.25147732199991,
							28.405857000000083
						],
						[
							-81.25147539699992,
							28.405915819000086
						],
						[
							-81.2514714589999,
							28.405959531000065
						],
						[
							-81.25143645799996,
							28.406264530000048
						],
						[
							-81.25143462799991,
							28.40627938500006
						],
						[
							-81.25142504099995,
							28.406337449000034
						],
						[
							-81.2514166929999,
							28.406375168000068
						],
						[
							-81.25135822699991,
							28.406614794000063
						],
						[
							-81.25134065399993,
							28.40675830600009
						],
						[
							-81.25133962799993,
							28.406766385000083
						],
						[
							-81.25133004199995,
							28.406824449000055
						],
						[
							-81.25131667799991,
							28.40688176200007
						],
						[
							-81.25130906999993,
							28.40690849600009
						],
						[
							-81.25126507099993,
							28.407054496000057
						],
						[
							-81.25125559599992,
							28.407084078000082
						],
						[
							-81.25124195099994,
							28.407121527000072
						],
						[
							-81.25115895099992,
							28.407334527000046
						],
						[
							-81.25115186499994,
							28.407352156000062
						],
						[
							-81.25112757799991,
							28.407405760000074
						],
						[
							-81.25109983599992,
							28.40745766100008
						],
						[
							-81.2510687589999,
							28.407507637000037
						],
						[
							-81.25103447999994,
							28.40755547300006
						],
						[
							-81.2509978089999,
							28.407600208000076
						],
						[
							-81.2508858089999,
							28.407728208000037
						],
						[
							-81.2508851469999,
							28.407728964000057
						],
						[
							-81.25084491699994,
							28.40777191700005
						],
						[
							-81.25080196499994,
							28.407812146000083
						],
						[
							-81.25075647299991,
							28.40784948000004
						],
						[
							-81.25070863699995,
							28.40788375900007
						],
						[
							-81.25065866099993,
							28.40791483600009
						],
						[
							-81.25060675999993,
							28.407942577000085
						],
						[
							-81.25055315599992,
							28.40796686500005
						],
						[
							-81.25049807799991,
							28.407987595000066
						],
						[
							-81.25044176199992,
							28.408004678000058
						],
						[
							-81.25043913299993,
							28.408005379000087
						],
						[
							-81.25033713199993,
							28.408032379000076
						],
						[
							-81.25028244899994,
							28.408045042000083
						],
						[
							-81.25022438499991,
							28.40805462900005
						],
						[
							-81.2501658189999,
							28.408060397000042
						],
						[
							-81.2501069999999,
							28.408062322000035
						],
						[
							-81.25004818199994,
							28.408060397000042
						],
						[
							-81.24998961499995,
							28.40805462900005
						],
						[
							-81.24993155099992,
							28.408045042000083
						],
						[
							-81.24992157299994,
							28.408042999000088
						],
						[
							-81.24990476199991,
							28.40804767900005
						],
						[
							-81.2498474489999,
							28.408061042000043
						],
						[
							-81.24978938499993,
							28.408070628000075
						],
						[
							-81.24973081799993,
							28.40807639700006
						],
						[
							-81.24967199999992,
							28.40807832200005
						],
						[
							-81.24964046299993,
							28.408077769000045
						],
						[
							-81.24952646299994,
							28.408073769000055
						],
						[
							-81.24949918199991,
							28.40807239600008
						],
						[
							-81.24944061499991,
							28.408066628000086
						],
						[
							-81.24938255099994,
							28.408057042000053
						],
						[
							-81.24932523799993,
							28.40804367800007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Lake Nona Central",
				"RegionID": "274233"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.27226744599994,
					28.407163077000064,
					-81.24292673499991,
					28.423382631000038
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.24722514199993,
							28.421441703000088
						],
						[
							-81.24629275899991,
							28.42069960300006
						],
						[
							-81.24573392899993,
							28.420256946000052
						],
						[
							-81.24526222999992,
							28.419917443000088
						],
						[
							-81.2448756579999,
							28.41958494900007
						],
						[
							-81.24457721499994,
							28.419256462000078
						],
						[
							-81.24435889099993,
							28.419011099000045
						],
						[
							-81.24404635199994,
							28.418594531000053
						],
						[
							-81.24384628199994,
							28.418267068000034
						],
						[
							-81.2436979119999,
							28.41802763900006
						],
						[
							-81.24365384599992,
							28.417923486000063
						],
						[
							-81.2434365229999,
							28.417412727000055
						],
						[
							-81.2432592589999,
							28.416910984000083
						],
						[
							-81.2431050319999,
							28.41631109300005
						],
						[
							-81.2430489489999,
							28.415797333000057
						],
						[
							-81.24302491399993,
							28.41457048400008
						],
						[
							-81.24292673499991,
							28.414559223000087
						],
						[
							-81.24303085999992,
							28.413506159000065
						],
						[
							-81.24329299999994,
							28.410855000000083
						],
						[
							-81.24331899999993,
							28.410475000000076
						],
						[
							-81.24352299999993,
							28.410263000000043
						],
						[
							-81.24334399999992,
							28.41026400000004
						],
						[
							-81.24343838899995,
							28.40928493200005
						],
						[
							-81.24350499999991,
							28.408594000000054
						],
						[
							-81.24364274399994,
							28.407163077000064
						],
						[
							-81.24389369499994,
							28.407165317000082
						],
						[
							-81.24543441199995,
							28.407179074000055
						],
						[
							-81.24605470799992,
							28.407836332000045
						],
						[
							-81.2460038719999,
							28.407894841000086
						],
						[
							-81.24600114599991,
							28.407897964000085
						],
						[
							-81.24596091699993,
							28.407940916000086
						],
						[
							-81.24591796399994,
							28.407981146000058
						],
						[
							-81.2458724729999,
							28.408018480000067
						],
						[
							-81.24582463699994,
							28.408052759000043
						],
						[
							-81.2457997859999,
							28.408068779000075
						],
						[
							-81.2456887859999,
							28.40813777900007
						],
						[
							-81.24566366099992,
							28.408152836000056
						],
						[
							-81.24561175999992,
							28.408180578000042
						],
						[
							-81.24556538299993,
							28.408201835000057
						],
						[
							-81.2454962939999,
							28.40823116100006
						],
						[
							-81.2454281869999,
							28.408292850000066
						],
						[
							-81.24540595799994,
							28.408320130000053
						],
						[
							-81.24534313099991,
							28.408480360000055
						],
						[
							-81.2453415409999,
							28.408490085000043
						],
						[
							-81.24533604099992,
							28.408520449000036
						],
						[
							-81.24532267799992,
							28.40857776200005
						],
						[
							-81.24530559499993,
							28.40863407800009
						],
						[
							-81.24528486499992,
							28.40868915600004
						],
						[
							-81.2452823239999,
							28.408695228000056
						],
						[
							-81.2452619899999,
							28.408743319000052
						],
						[
							-81.24525604199994,
							28.408776449000072
						],
						[
							-81.24524267899994,
							28.408833762000086
						],
						[
							-81.24522559499991,
							28.40889007800007
						],
						[
							-81.24521570399992,
							28.408917726000084
						],
						[
							-81.2452041439999,
							28.408948446000068
						],
						[
							-81.2452090779999,
							28.40916003600006
						],
						[
							-81.24520739699994,
							28.40923981800006
						],
						[
							-81.2452016279999,
							28.409298385000056
						],
						[
							-81.24519204199993,
							28.409356449000086
						],
						[
							-81.24517971099993,
							28.409409872000083
						],
						[
							-81.2451157399999,
							28.409652960000074
						],
						[
							-81.24510689399995,
							28.409939729000087
						],
						[
							-81.24510539599993,
							28.40997081900008
						],
						[
							-81.24509962799993,
							28.410029385000087
						],
						[
							-81.2450900419999,
							28.41008744900006
						],
						[
							-81.24507942899994,
							28.410134244000062
						],
						[
							-81.24505240499991,
							28.410240207000072
						],
						[
							-81.24503657799994,
							28.41034421100005
						],
						[
							-81.2450326949999,
							28.41039967100005
						],
						[
							-81.24505692899994,
							28.410467526000048
						],
						[
							-81.24506101399993,
							28.410479215000066
						],
						[
							-81.24519863099994,
							28.410627718000057
						],
						[
							-81.24521514599991,
							28.41064603600006
						],
						[
							-81.24525247999992,
							28.410691528000086
						],
						[
							-81.2452867589999,
							28.41073936400005
						],
						[
							-81.24529910199993,
							28.41075907800007
						],
						[
							-81.24532238499997,
							28.410761371000035
						],
						[
							-81.24538044899992,
							28.41077095800006
						],
						[
							-81.24538137999991,
							28.41077114300009
						],
						[
							-81.24541637999994,
							28.410778144000062
						],
						[
							-81.24547276099992,
							28.41079132200008
						],
						[
							-81.2455290769999,
							28.41080840500007
						],
						[
							-81.2455841549999,
							28.41082913500009
						],
						[
							-81.24563775999991,
							28.41085342200006
						],
						[
							-81.24568966099991,
							28.410881164000045
						],
						[
							-81.24570935899993,
							28.41089287400007
						],
						[
							-81.24575824199991,
							28.410922783000046
						],
						[
							-81.24577329099992,
							28.41092604100004
						],
						[
							-81.24581576199995,
							28.410936322000055
						],
						[
							-81.24587207799993,
							28.410953405000043
						],
						[
							-81.24588396999991,
							28.41095753500008
						],
						[
							-81.24592309199994,
							28.41097142900009
						],
						[
							-81.2461038479999,
							28.41097803200006
						],
						[
							-81.24611992199993,
							28.410972405000052
						],
						[
							-81.24617623799992,
							28.410955322000063
						],
						[
							-81.24623355099993,
							28.41094195800008
						],
						[
							-81.2462916149999,
							28.410932372000048
						],
						[
							-81.24635018099991,
							28.410926604000053
						],
						[
							-81.2463715589999,
							28.410925458000065
						],
						[
							-81.24653955899993,
							28.410918458000083
						],
						[
							-81.24657699999995,
							28.41091767800009
						],
						[
							-81.24688580999992,
							28.41091767800009
						],
						[
							-81.24690050099993,
							28.410904964000053
						],
						[
							-81.24694152799992,
							28.410871520000057
						],
						[
							-81.24698936399994,
							28.41083724100008
						],
						[
							-81.24703933899991,
							28.410806164000064
						],
						[
							-81.24709123999992,
							28.41077842300007
						],
						[
							-81.24714484399993,
							28.410754135000047
						],
						[
							-81.24719992199995,
							28.410733405000087
						],
						[
							-81.24725623799992,
							28.41071632200004
						],
						[
							-81.24726259999994,
							28.410714642000073
						],
						[
							-81.24804831599994,
							28.41051026000008
						],
						[
							-81.24819660899993,
							28.410460828000055
						],
						[
							-81.24824823799992,
							28.410445322000044
						],
						[
							-81.24827863899992,
							28.410437741000067
						],
						[
							-81.24872338099995,
							28.41033503300008
						],
						[
							-81.24932448599992,
							28.410175448000075
						],
						[
							-81.2494566119999,
							28.41011902000008
						],
						[
							-81.24949175299992,
							28.41006912800009
						],
						[
							-81.24951351999994,
							28.410039527000038
						],
						[
							-81.24955085399995,
							28.409994036000057
						],
						[
							-81.24959108399992,
							28.409951083000067
						],
						[
							-81.24963403599992,
							28.40991085400009
						],
						[
							-81.24967952799994,
							28.409873520000076
						],
						[
							-81.2497061059999,
							28.40985389100007
						],
						[
							-81.24982010499991,
							28.40977289100005
						],
						[
							-81.2498413639999,
							28.409758241000077
						],
						[
							-81.24989133899993,
							28.40972716400006
						],
						[
							-81.24994323999994,
							28.409699422000074
						],
						[
							-81.24997264699994,
							28.409685575000083
						],
						[
							-81.25026664699993,
							28.409553576000064
						],
						[
							-81.25029084499994,
							28.40954313500004
						],
						[
							-81.25034592299994,
							28.409522405000075
						],
						[
							-81.25040223899992,
							28.409505322000086
						],
						[
							-81.25045955099995,
							28.409491958000046
						],
						[
							-81.25047464499994,
							28.40948909000008
						],
						[
							-81.2506236449999,
							28.409462089000044
						],
						[
							-81.25066661499996,
							28.409455371000035
						],
						[
							-81.25072518099995,
							28.409449603000045
						],
						[
							-81.25074541799995,
							28.409448506000047
						],
						[
							-81.25090841799994,
							28.409441506000064
						],
						[
							-81.25100581899994,
							28.40944260400005
						],
						[
							-81.25102814899992,
							28.40944434700009
						],
						[
							-81.25115819199995,
							28.409456129000034
						],
						[
							-81.25130921999994,
							28.40940432700006
						],
						[
							-81.2513119219999,
							28.409403405000035
						],
						[
							-81.25136823799994,
							28.409386321000056
						],
						[
							-81.25140818299991,
							28.40937659100007
						],
						[
							-81.25153118299994,
							28.40934959200007
						],
						[
							-81.25154855099993,
							28.409345959000067
						],
						[
							-81.2516066149999,
							28.40933637200004
						],
						[
							-81.2516651819999,
							28.409330604000047
						],
						[
							-81.25172399999992,
							28.409328678000065
						],
						[
							-81.25176188699993,
							28.409329477000085
						],
						[
							-81.2519024369999,
							28.409335403000057
						],
						[
							-81.25204685299991,
							28.409333310000083
						],
						[
							-81.25254383599992,
							28.40928495500009
						],
						[
							-81.25268529899995,
							28.409264432000043
						],
						[
							-81.25269993699993,
							28.40924936300007
						],
						[
							-81.25270908399995,
							28.40924008400009
						],
						[
							-81.2527204669999,
							28.409228900000073
						],
						[
							-81.25272472799993,
							28.409224788000074
						],
						[
							-81.25273500999992,
							28.409195361000062
						],
						[
							-81.25275313499992,
							28.409147844000074
						],
						[
							-81.25275464999993,
							28.409144209000093
						],
						[
							-81.25281424399992,
							28.409002101000056
						],
						[
							-81.2528377619999,
							28.40889540900008
						],
						[
							-81.25284732199992,
							28.408856238000055
						],
						[
							-81.25285373199995,
							28.408833513000047
						],
						[
							-81.25287062899991,
							28.40877648700007
						],
						[
							-81.25290988699993,
							28.40841334000004
						],
						[
							-81.25291237199991,
							28.408392615000082
						],
						[
							-81.2529186239999,
							28.408354746000043
						],
						[
							-81.25291295799991,
							28.40833044900006
						],
						[
							-81.25290337199993,
							28.40827238500009
						],
						[
							-81.25289760399994,
							28.408213819000082
						],
						[
							-81.2528956779999,
							28.40815500000008
						],
						[
							-81.25289760399994,
							28.408096182000065
						],
						[
							-81.25290337199993,
							28.40803761500007
						],
						[
							-81.2529073629999,
							28.408010501000035
						],
						[
							-81.25292836299991,
							28.407881501000077
						],
						[
							-81.2529339589999,
							28.40785055100008
						],
						[
							-81.2529473219999,
							28.40779323800007
						],
						[
							-81.25296309999993,
							28.407740795000052
						],
						[
							-81.25295737199991,
							28.40770338500005
						],
						[
							-81.25295160399992,
							28.40764481900004
						],
						[
							-81.25294967799994,
							28.407586000000038
						],
						[
							-81.25295098899994,
							28.407537457000046
						],
						[
							-81.25295463299994,
							28.407470042000057
						],
						[
							-81.25294373199995,
							28.407452440000043
						],
						[
							-81.25385306699991,
							28.407243595000068
						],
						[
							-81.25658028099991,
							28.40731935100007
						],
						[
							-81.25674993299994,
							28.40732406400008
						],
						[
							-81.25764978299992,
							28.407337061000078
						],
						[
							-81.25765108999991,
							28.40739456500006
						],
						[
							-81.25764939599992,
							28.407473819000074
						],
						[
							-81.25764641099994,
							28.407508858000085
						],
						[
							-81.25762941099993,
							28.407670857000085
						],
						[
							-81.25762662799991,
							28.40769438500007
						],
						[
							-81.25761704199994,
							28.407752449000043
						],
						[
							-81.25760367799995,
							28.407809761000067
						],
						[
							-81.25759901299995,
							28.40782652300004
						],
						[
							-81.2576057089999,
							28.40782805400005
						],
						[
							-81.25777770899992,
							28.407868054000062
						],
						[
							-81.25778501399992,
							28.407869785000063
						],
						[
							-81.25784301399995,
							28.407883784000035
						],
						[
							-81.25786476199995,
							28.407889322000074
						],
						[
							-81.2579090449999,
							28.40790241500008
						],
						[
							-81.2579640859999,
							28.407920238000088
						],
						[
							-81.25800581899995,
							28.40792160400008
						],
						[
							-81.25803976399993,
							28.407924475000073
						],
						[
							-81.25817476399993,
							28.407938475000037
						],
						[
							-81.2581993849999,
							28.407941372000042
						],
						[
							-81.25825744899994,
							28.40795095800007
						],
						[
							-81.25825786699994,
							28.407951041000047
						],
						[
							-81.25827661499994,
							28.407948372000078
						],
						[
							-81.2583140619999,
							28.407944238000084
						],
						[
							-81.2585919679999,
							28.40791943800008
						],
						[
							-81.2586177419999,
							28.40790839200008
						],
						[
							-81.25862784399993,
							28.40790413500008
						],
						[
							-81.25867017899992,
							28.40788783700009
						],
						[
							-81.25887987499993,
							28.40781312900009
						],
						[
							-81.25905088199994,
							28.40773464600005
						],
						[
							-81.25908184399994,
							28.40772113400004
						],
						[
							-81.25913692199993,
							28.40770040400008
						],
						[
							-81.25919323799991,
							28.407683321000036
						],
						[
							-81.25925055099992,
							28.407669958000042
						],
						[
							-81.2592657209999,
							28.407667075000063
						],
						[
							-81.2595851609999,
							28.40760921800006
						],
						[
							-81.25973642499991,
							28.40752820900008
						],
						[
							-81.25976323999993,
							28.40751442200008
						],
						[
							-81.25981684399994,
							28.407490135000046
						],
						[
							-81.25987192199995,
							28.407469405000086
						],
						[
							-81.2599165229999,
							28.40745554500006
						],
						[
							-81.26009352299991,
							28.407405546000064
						],
						[
							-81.26010523799994,
							28.407402322000053
						],
						[
							-81.26016255099995,
							28.40738895800007
						],
						[
							-81.26022061499992,
							28.40737937200004
						],
						[
							-81.26026942999994,
							28.407374296000057
						],
						[
							-81.26030378599995,
							28.407371669000046
						],
						[
							-81.26033401699993,
							28.407264179000038
						],
						[
							-81.26119549999993,
							28.407522778000043
						],
						[
							-81.2613109099999,
							28.40752291000007
						],
						[
							-81.26193796199993,
							28.40744494500007
						],
						[
							-81.26234167599995,
							28.407444670000075
						],
						[
							-81.26322321499993,
							28.407622685000035
						],
						[
							-81.26321277199992,
							28.40767580000005
						],
						[
							-81.26320250599991,
							28.407837117000042
						],
						[
							-81.26320239599994,
							28.407838818000073
						],
						[
							-81.26319662799995,
							28.40789738500007
						],
						[
							-81.26318704099992,
							28.407955449000042
						],
						[
							-81.26318410599993,
							28.407969611000055
						],
						[
							-81.26304522299995,
							28.408613522000056
						],
						[
							-81.2629818019999,
							28.409801990000062
						],
						[
							-81.26298511399995,
							28.40996758500006
						],
						[
							-81.26299170099992,
							28.41025169100004
						],
						[
							-81.2630309889999,
							28.41050269300007
						],
						[
							-81.2630496999999,
							28.41058100500004
						],
						[
							-81.26305029899993,
							28.410583528000075
						],
						[
							-81.26316729899992,
							28.411079528000077
						],
						[
							-81.2631738579999,
							28.411109627000087
						],
						[
							-81.26321200799993,
							28.41130037700009
						],
						[
							-81.26329590899991,
							28.411611123000057
						],
						[
							-81.2634153649999,
							28.411891512000068
						],
						[
							-81.26341886499995,
							28.41189984400006
						],
						[
							-81.26343959499991,
							28.411954922000064
						],
						[
							-81.2634566779999,
							28.412011238000048
						],
						[
							-81.26347004199994,
							28.41206855100006
						],
						[
							-81.26347962799991,
							28.41212661500009
						],
						[
							-81.2634853969999,
							28.41218518100004
						],
						[
							-81.26348690899994,
							28.412216759000046
						],
						[
							-81.2634870739999,
							28.412222202000066
						],
						[
							-81.26349548099995,
							28.41224277200007
						],
						[
							-81.26351459499995,
							28.41229392300005
						],
						[
							-81.26351876799993,
							28.412306520000072
						],
						[
							-81.26362376799995,
							28.412631520000048
						],
						[
							-81.2636361509999,
							28.412673278000057
						],
						[
							-81.26365899799993,
							28.41275778000005
						],
						[
							-81.26366275899994,
							28.412763363000067
						],
						[
							-81.26367225699994,
							28.41277788000008
						],
						[
							-81.2637542569999,
							28.41290587900005
						],
						[
							-81.26377583599994,
							28.412941339000042
						],
						[
							-81.26380357699992,
							28.41299324000005
						],
						[
							-81.26382786499994,
							28.413046844000068
						],
						[
							-81.2638485949999,
							28.413101922000067
						],
						[
							-81.26386146699991,
							28.413143053000056
						],
						[
							-81.26387391999992,
							28.413186472000064
						],
						[
							-81.26394288699993,
							28.413320025000075
						],
						[
							-81.26399207899993,
							28.41339935500008
						],
						[
							-81.26405082999992,
							28.413464092000083
						],
						[
							-81.26431226999995,
							28.413680457000055
						],
						[
							-81.26457372699991,
							28.41388671800007
						],
						[
							-81.26483093799993,
							28.414089299000068
						],
						[
							-81.26499508499995,
							28.41412953100007
						],
						[
							-81.26501376199991,
							28.414134322000052
						],
						[
							-81.26507007799995,
							28.41415140500004
						],
						[
							-81.26511587399995,
							28.414168351000058
						],
						[
							-81.26537064999991,
							28.41427057100009
						],
						[
							-81.26574633599995,
							28.414348356000062
						],
						[
							-81.26579676099993,
							28.41436032100006
						],
						[
							-81.26580816699993,
							28.414363458000082
						],
						[
							-81.2663611669999,
							28.41451945800009
						],
						[
							-81.26640607699994,
							28.414533405000043
						],
						[
							-81.26645415299993,
							28.414551268000082
						],
						[
							-81.26677315299992,
							28.414680269000087
						],
						[
							-81.26678015599992,
							28.414683135000075
						],
						[
							-81.26683375999994,
							28.41470742300004
						],
						[
							-81.26688566099996,
							28.41473516500008
						],
						[
							-81.2669005919999,
							28.414743978000047
						],
						[
							-81.26699251399992,
							28.41479943900004
						],
						[
							-81.26716698099995,
							28.41485680400007
						],
						[
							-81.26721855099993,
							28.41484495800006
						],
						[
							-81.2672766149999,
							28.414835372000084
						],
						[
							-81.2673351819999,
							28.41482960400009
						],
						[
							-81.26739399999991,
							28.41482767800005
						],
						[
							-81.26743250899995,
							28.41482850300008
						],
						[
							-81.26750250899994,
							28.414831503000073
						],
						[
							-81.26752281799992,
							28.414832604000082
						],
						[
							-81.26758138499991,
							28.414838372000077
						],
						[
							-81.26763944899994,
							28.414847959000042
						],
						[
							-81.2676967619999,
							28.414861322000036
						],
						[
							-81.26775307799994,
							28.41487840500008
						],
						[
							-81.26780815599994,
							28.41489913500004
						],
						[
							-81.26783779499993,
							28.414912041000036
						],
						[
							-81.2678606849999,
							28.414922501000035
						],
						[
							-81.26788145799992,
							28.414923229000067
						],
						[
							-81.26790881799991,
							28.414924604000078
						],
						[
							-81.2679673849999,
							28.41493037200007
						],
						[
							-81.26802544899994,
							28.414939958000048
						],
						[
							-81.26803986999994,
							28.414942950000068
						],
						[
							-81.26808800899994,
							28.41495334800004
						],
						[
							-81.26815432799992,
							28.414955889000055
						],
						[
							-81.2681939229999,
							28.414941405000036
						],
						[
							-81.26825023799995,
							28.414924321000058
						],
						[
							-81.26830755099991,
							28.414910958000064
						],
						[
							-81.26836561499994,
							28.414901372000088
						],
						[
							-81.26842131699993,
							28.414895796000053
						],
						[
							-81.26874131599993,
							28.414873795000062
						],
						[
							-81.26874418099993,
							28.414873603000046
						],
						[
							-81.26880299999993,
							28.414871678000058
						],
						[
							-81.26886181799995,
							28.414873603000046
						],
						[
							-81.26889075199995,
							28.414875969000036
						],
						[
							-81.26894898099994,
							28.414881678000086
						],
						[
							-81.26920599999995,
							28.414881678000086
						],
						[
							-81.26926481899994,
							28.414883604000067
						],
						[
							-81.26932338499995,
							28.41488937200006
						],
						[
							-81.26935937399992,
							28.414894853000078
						],
						[
							-81.26951537399992,
							28.414921853000067
						],
						[
							-81.26953744899993,
							28.414925959000072
						],
						[
							-81.26959476199994,
							28.414939322000066
						],
						[
							-81.26964639099992,
							28.414954829000067
						],
						[
							-81.26984970199993,
							28.415022599000054
						],
						[
							-81.26985788299993,
							28.415024687000084
						],
						[
							-81.26987810299994,
							28.41502131300007
						],
						[
							-81.2700521029999,
							28.41499431300008
						],
						[
							-81.27007261499996,
							28.414991372000088
						],
						[
							-81.2701311809999,
							28.41498560400004
						],
						[
							-81.27018999999991,
							28.414983678000056
						],
						[
							-81.27024881799991,
							28.41498560400004
						],
						[
							-81.27026839099995,
							28.414987101000065
						],
						[
							-81.27121758499993,
							28.41507015500008
						],
						[
							-81.27170652299992,
							28.41501380300008
						],
						[
							-81.27190290599992,
							28.415896445000044
						],
						[
							-81.27211205099991,
							28.416523408000046
						],
						[
							-81.27226744599994,
							28.417306659000076
						],
						[
							-81.26984152699993,
							28.418322972000055
						],
						[
							-81.2698418569999,
							28.41949688400007
						],
						[
							-81.26952828499992,
							28.419809454000074
						],
						[
							-81.26874605899991,
							28.419809281000084
						],
						[
							-81.2677285499999,
							28.419809282000074
						],
						[
							-81.26647657199993,
							28.41988854500005
						],
						[
							-81.2663987009999,
							28.41926232600008
						],
						[
							-81.26538106899994,
							28.41926247200007
						],
						[
							-81.2642062999999,
							28.419340455000054
						],
						[
							-81.26350228099994,
							28.419654051000066
						],
						[
							-81.26271912899995,
							28.419888451000077
						],
						[
							-81.26146826399992,
							28.41996651500006
						],
						[
							-81.26037264199994,
							28.419966516000045
						],
						[
							-81.25912069099991,
							28.42004580200006
						],
						[
							-81.2588854999999,
							28.419653874000062
						],
						[
							-81.2579460419999,
							28.41996651500006
						],
						[
							-81.25724197099993,
							28.420122917000075
						],
						[
							-81.2563807379999,
							28.419654001000083
						],
						[
							-81.25544132399995,
							28.419418704000066
						],
						[
							-81.25442479599991,
							28.41941857100005
						],
						[
							-81.25387700899995,
							28.419654051000066
						],
						[
							-81.25317279699993,
							28.420122657000036
						],
						[
							-81.25317288299993,
							28.42090592900007
						],
						[
							-81.25356473199992,
							28.42160994900007
						],
						[
							-81.25348549099994,
							28.421767363000075
						],
						[
							-81.25270326599991,
							28.42145372300007
						],
						[
							-81.25176380999994,
							28.421375431000058
						],
						[
							-81.24968476399994,
							28.423382631000038
						],
						[
							-81.24887759299992,
							28.422752648000085
						],
						[
							-81.24722514199993,
							28.421441703000088
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Lake Nona Estates",
				"RegionID": "274234"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.13294141799992,
					26.103918556000053,
					-80.1196008419999,
					26.108354444000042
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.12119462299995,
							26.10753354700006
						],
						[
							-80.12112226699992,
							26.10695469600006
						],
						[
							-80.1210116119999,
							26.106858396000064
						],
						[
							-80.12095593399994,
							26.106805603000055
						],
						[
							-80.1209049599999,
							26.106748256000063
						],
						[
							-80.12085905899994,
							26.106686772000046
						],
						[
							-80.12081856599991,
							26.10662160000004
						],
						[
							-80.12078377599994,
							26.106553213000044
						],
						[
							-80.12075494199992,
							26.10648211000006
						],
						[
							-80.12073227399992,
							26.106408808000083
						],
						[
							-80.12071593699994,
							26.10633384000005
						],
						[
							-80.12068577999992,
							26.10615743400007
						],
						[
							-80.12055541299992,
							26.106121087000076
						],
						[
							-80.12041333899992,
							26.10605483600006
						],
						[
							-80.12028492699994,
							26.105964921000066
						],
						[
							-80.12017407899992,
							26.105854073000046
						],
						[
							-80.12008416399993,
							26.105725661000065
						],
						[
							-80.12001791299991,
							26.10558358700007
						],
						[
							-80.12000282499991,
							26.10553845000004
						],
						[
							-80.11981182499994,
							26.104912450000086
						],
						[
							-80.11978487499994,
							26.104797613000077
						],
						[
							-80.11976457799994,
							26.104675632000067
						],
						[
							-80.1196008419999,
							26.104607394000084
						],
						[
							-80.12059542899993,
							26.104189824000063
						],
						[
							-80.1328105309999,
							26.103918556000053
						],
						[
							-80.13281240599991,
							26.104047878000074
						],
						[
							-80.1328284299999,
							26.104969245000063
						],
						[
							-80.13285847299994,
							26.10588961100007
						],
						[
							-80.13288050699992,
							26.10681898900009
						],
						[
							-80.1328953979999,
							26.107628211000076
						],
						[
							-80.13291949199993,
							26.10767931500004
						],
						[
							-80.13294141799992,
							26.107701226000074
						],
						[
							-80.12841275199992,
							26.10779657200004
						],
						[
							-80.12839598599993,
							26.107226456000035
						],
						[
							-80.12382799999995,
							26.107501000000074
						],
						[
							-80.12279655099991,
							26.108354444000042
						],
						[
							-80.12204623499991,
							26.108320398000046
						],
						[
							-80.12193083499994,
							26.108307660000037
						],
						[
							-80.12177941399995,
							26.10826708700006
						],
						[
							-80.1216373389999,
							26.108200836000037
						],
						[
							-80.12150892699992,
							26.108110921000048
						],
						[
							-80.12139807999995,
							26.108000073000085
						],
						[
							-80.12130816499992,
							26.107871661000047
						],
						[
							-80.12124191399994,
							26.10772958700005
						],
						[
							-80.1212013409999,
							26.107578166000057
						],
						[
							-80.12119462299995,
							26.10753354700006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Lauderdale Harbours",
				"RegionID": "274282"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.43467270377462,
					27.996275665912613,
					-82.41418508764657,
					28.003701708751578
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.41418508764657,
							28.003701708751578
						],
						[
							-82.414190908958,
							27.996363635794836
						],
						[
							-82.43467270377462,
							27.996275665912613
						],
						[
							-82.43461834965049,
							28.003566521764817
						],
						[
							-82.42629999949406,
							28.00349999981367
						],
						[
							-82.41418508764657,
							28.003701708751578
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Live Oaks Square",
				"RegionID": "274335"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.66550829699992,
					30.26182590600007,
					-81.64599576299992,
					30.295904715000063
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.64667490599993,
							30.263657008000052
						],
						[
							-81.64599576299992,
							30.26182590600007
						],
						[
							-81.64718499999992,
							30.261872000000043
						],
						[
							-81.6481481749999,
							30.26212823800006
						],
						[
							-81.65005369499994,
							30.262968058000066
						],
						[
							-81.65014066099991,
							30.263012164000088
						],
						[
							-81.65026907299995,
							30.263102079000074
						],
						[
							-81.65037991999992,
							30.263212927000037
						],
						[
							-81.6504698359999,
							30.263341339000082
						],
						[
							-81.65048916599994,
							30.26337662100008
						],
						[
							-81.65168109399991,
							30.26567248100008
						],
						[
							-81.65217037499991,
							30.266614116000085
						],
						[
							-81.65395331199994,
							30.268843273000073
						],
						[
							-81.6539740469999,
							30.268870226000047
						],
						[
							-81.65634502699993,
							30.272075930000085
						],
						[
							-81.65662570199993,
							30.27211202200004
						],
						[
							-81.65677547899992,
							30.272144447000077
						],
						[
							-81.6576204779999,
							30.272404447000042
						],
						[
							-81.65769539199994,
							30.272431178000094
						],
						[
							-81.6577676519999,
							30.27246442400008
						],
						[
							-81.65783669099994,
							30.27250392400003
						],
						[
							-81.6579019699999,
							30.272549370000036
						],
						[
							-81.65828832999995,
							30.272844545000055
						],
						[
							-81.65856787299992,
							30.27302908000007
						],
						[
							-81.65967094599995,
							30.273754815000075
						],
						[
							-81.66065480499994,
							30.274397067000052
						],
						[
							-81.6615179179999,
							30.274961180000048
						],
						[
							-81.66505580799992,
							30.27723218400007
						],
						[
							-81.6651480729999,
							30.27730008000009
						],
						[
							-81.66525892099992,
							30.277410927000066
						],
						[
							-81.66534883599991,
							30.277539339000047
						],
						[
							-81.66541508699993,
							30.277681414000085
						],
						[
							-81.6654556599999,
							30.277832835000087
						],
						[
							-81.66546927099996,
							30.277979389000052
						],
						[
							-81.66550829699992,
							30.281633195000044
						],
						[
							-81.66550580099994,
							30.281705181000067
						],
						[
							-81.66549755099993,
							30.28177673600004
						],
						[
							-81.66548360099995,
							30.281847401000054
						],
						[
							-81.6654640399999,
							30.28191672300005
						],
						[
							-81.66543899299995,
							30.28198425700009
						],
						[
							-81.66540862099993,
							30.282049570000083
						],
						[
							-81.66537311899992,
							30.28211224200004
						],
						[
							-81.66533271399993,
							30.28217187100006
						],
						[
							-81.66121607699995,
							30.287752372000057
						],
						[
							-81.6612192639999,
							30.287954792000047
						],
						[
							-81.66121671899992,
							30.288030127000074
						],
						[
							-81.66120787199993,
							30.288104984000086
						],
						[
							-81.66119278499991,
							30.28817883600004
						],
						[
							-81.66117156399991,
							30.288251165000077
						],
						[
							-81.66114435899993,
							30.28832146200006
						],
						[
							-81.66111135999995,
							30.288389233000093
						],
						[
							-81.6598453599999,
							30.290734233000084
						],
						[
							-81.65980866599995,
							30.290796143000083
						],
						[
							-81.65976713799995,
							30.290854919000083
						],
						[
							-81.6597210409999,
							30.290910186000076
						],
						[
							-81.65967067199995,
							30.290961588000073
						],
						[
							-81.65961635199994,
							30.291008797000075
						],
						[
							-81.65955842999996,
							30.291051509000056
						],
						[
							-81.65949727799995,
							30.291089452000048
						],
						[
							-81.6561958389999,
							30.29292445200008
						],
						[
							-81.65575613999994,
							30.295563401000038
						],
						[
							-81.65482685299992,
							30.295904715000063
						],
						[
							-81.65260864099992,
							30.295724266000036
						],
						[
							-81.65005431499992,
							30.295156641000066
						],
						[
							-81.64780982499991,
							30.295119961000065
						],
						[
							-81.64789490499993,
							30.294765008000073
						],
						[
							-81.64796390599992,
							30.29444900800007
						],
						[
							-81.64817090499992,
							30.293475008000087
						],
						[
							-81.64836090599994,
							30.292589009000043
						],
						[
							-81.64851390599995,
							30.29186500900005
						],
						[
							-81.6486449059999,
							30.291241009000085
						],
						[
							-81.64869990599993,
							30.29097700800008
						],
						[
							-81.6488069049999,
							30.290508009000064
						],
						[
							-81.64885190599995,
							30.29032500800008
						],
						[
							-81.64890390599993,
							30.29011400900004
						],
						[
							-81.64901690599993,
							30.289756009000087
						],
						[
							-81.64912590499995,
							30.28945300900006
						],
						[
							-81.64921290599995,
							30.28921300900004
						],
						[
							-81.64926690599992,
							30.289063008000085
						],
						[
							-81.64947290499993,
							30.28854700800008
						],
						[
							-81.6497519049999,
							30.287920008000075
						],
						[
							-81.64994490499993,
							30.28747900900004
						],
						[
							-81.6501989059999,
							30.28691100900005
						],
						[
							-81.65035090499993,
							30.28656600900007
						],
						[
							-81.65047790599994,
							30.286269009000083
						],
						[
							-81.65060490499991,
							30.28593600900007
						],
						[
							-81.6507189049999,
							30.285604008000064
						],
						[
							-81.65079290599994,
							30.285370008000086
						],
						[
							-81.65086990599991,
							30.285109008000067
						],
						[
							-81.65098103699995,
							30.284664983000084
						],
						[
							-81.65091573599994,
							30.284553038000073
						],
						[
							-81.65097390599993,
							30.284259009000035
						],
						[
							-81.6510129049999,
							30.28400300900006
						],
						[
							-81.65109290599992,
							30.28338200800005
						],
						[
							-81.65111490499993,
							30.283258008000075
						],
						[
							-81.65113090499995,
							30.282942008000077
						],
						[
							-81.65110790599994,
							30.28231000900007
						],
						[
							-81.6510539059999,
							30.281681010000057
						],
						[
							-81.6509859059999,
							30.28118900800007
						],
						[
							-81.65089390599991,
							30.280418009000073
						],
						[
							-81.65078690599996,
							30.279531008000053
						],
						[
							-81.65077990599991,
							30.279472008000084
						],
						[
							-81.65068190599993,
							30.278829008000063
						],
						[
							-81.65063490599994,
							30.278524009000083
						],
						[
							-81.65057290599992,
							30.278057008000076
						],
						[
							-81.65047490599994,
							30.277323008000057
						],
						[
							-81.65045890599994,
							30.27715500900007
						],
						[
							-81.65039790599991,
							30.27663200800004
						],
						[
							-81.65030090599993,
							30.275912008000034
						],
						[
							-81.65018490599994,
							30.275055008000038
						],
						[
							-81.65013090499991,
							30.274738008000043
						],
						[
							-81.65009290599994,
							30.274593008000068
						],
						[
							-81.65004990599994,
							30.274411009000065
						],
						[
							-81.64986990599994,
							30.273930008000036
						],
						[
							-81.64980890499993,
							30.27379700900008
						],
						[
							-81.64972190599991,
							30.273604009000056
						],
						[
							-81.64958290499993,
							30.27317800900005
						],
						[
							-81.64953777999995,
							30.27309305300008
						],
						[
							-81.64952403199993,
							30.27297996400006
						],
						[
							-81.64929890499991,
							30.27255700800003
						],
						[
							-81.6492079059999,
							30.27239000800006
						],
						[
							-81.64896390599995,
							30.27183200900004
						],
						[
							-81.64887990599993,
							30.271641009000067
						],
						[
							-81.6487589059999,
							30.27130900800006
						],
						[
							-81.64865890599992,
							30.271013009000058
						],
						[
							-81.64861090599993,
							30.270829008000078
						],
						[
							-81.6485819049999,
							30.27071500900007
						],
						[
							-81.64846790599995,
							30.270266009000068
						],
						[
							-81.64838390599994,
							30.269806008000046
						],
						[
							-81.64836090599994,
							30.269449009000084
						],
						[
							-81.64831490499995,
							30.26882900900006
						],
						[
							-81.64831490599994,
							30.268723008000052
						],
						[
							-81.64831190599995,
							30.26843400800004
						],
						[
							-81.64827490599993,
							30.268093008000054
						],
						[
							-81.64826090499992,
							30.26780000800005
						],
						[
							-81.64820090599994,
							30.267431008000077
						],
						[
							-81.64818990499992,
							30.267341008000077
						],
						[
							-81.64816990499992,
							30.26725000800008
						],
						[
							-81.64809290499994,
							30.267016009000088
						],
						[
							-81.6480599059999,
							30.266932009000072
						],
						[
							-81.64794190599991,
							30.266683009000076
						],
						[
							-81.64784190599994,
							30.26643800800008
						],
						[
							-81.64743790599994,
							30.265467009000076
						],
						[
							-81.64694190499995,
							30.264280009000064
						],
						[
							-81.64675890599995,
							30.26386600900008
						],
						[
							-81.64667490599993,
							30.263657008000052
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Miramar",
				"RegionID": "274550"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.74214892399988,
					28.004740416071986,
					-82.73795721598736,
					28.011424710000302
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.73996705299973,
							28.01133700700024
						],
						[
							-82.7399065639998,
							28.010967396000304
						],
						[
							-82.73986317799975,
							28.01096763000032
						],
						[
							-82.739725507,
							28.01096011900032
						],
						[
							-82.73958936399974,
							28.010942630000205
						],
						[
							-82.73945557099987,
							28.010914470000007
						],
						[
							-82.73932485399972,
							28.010875979000286
						],
						[
							-82.7391983819999,
							28.010827839000214
						],
						[
							-82.73907741099984,
							28.010769698000285
						],
						[
							-82.73896228499981,
							28.010702587000328
						],
						[
							-82.73885426599986,
							28.010626843000278
						],
						[
							-82.73875418599974,
							28.010543148000192
						],
						[
							-82.73866276599982,
							28.010451499000336
						],
						[
							-82.7385734869998,
							28.01035433700029
						],
						[
							-82.73801554799982,
							28.01065919700029
						],
						[
							-82.73800582299972,
							28.010141819000292
						],
						[
							-82.73800149699974,
							28.009919055000335
						],
						[
							-82.73798409799988,
							28.00900049500036
						],
						[
							-82.73798037599975,
							28.008816922000182
						],
						[
							-82.73797063799984,
							28.00828544900035
						],
						[
							-82.73795721598736,
							28.007583578744214
						],
						[
							-82.73822499999993,
							28.00754700000009
						],
						[
							-82.73803099999986,
							28.005049000000177
						],
						[
							-82.73801599999986,
							28.004842000000103
						],
						[
							-82.73840599999988,
							28.004786000000085
						],
						[
							-82.74121999999993,
							28.004750000000126
						],
						[
							-82.74156499999988,
							28.00474600000015
						],
						[
							-82.7420312580008,
							28.004740416071986
						],
						[
							-82.74203154499985,
							28.00484820600026
						],
						[
							-82.74205078399983,
							28.005168531000205
						],
						[
							-82.74205794199989,
							28.005357930000333
						],
						[
							-82.74206473099983,
							28.00553598600032
						],
						[
							-82.74207113699993,
							28.005700635000004
						],
						[
							-82.74207792799977,
							28.005879034000106
						],
						[
							-82.74208438799977,
							28.00605159100026
						],
						[
							-82.74209153599975,
							28.00623273800024
						],
						[
							-82.74210550899974,
							28.006597099000277
						],
						[
							-82.74211228099978,
							28.006772748000333
						],
						[
							-82.74211908899989,
							28.006953554000194
						],
						[
							-82.74212586199984,
							28.00712920300025
						],
						[
							-82.74213599899979,
							28.007477768000225
						],
						[
							-82.74214246599978,
							28.007651356000203
						],
						[
							-82.74214892399988,
							28.007823569000326
						],
						[
							-82.74213722099988,
							28.008016508000217
						],
						[
							-82.74212770999989,
							28.008168866000208
						],
						[
							-82.7420965119998,
							28.008364660000243
						],
						[
							-82.7420760459999,
							28.00849438600032
						],
						[
							-82.74198092499982,
							28.0089085000003
						],
						[
							-82.74193573499974,
							28.009048329000233
						],
						[
							-82.74187524899979,
							28.009223997000202
						],
						[
							-82.74180604499983,
							28.0093924920002
						],
						[
							-82.74173016799986,
							28.009576839000268
						],
						[
							-82.74164302099967,
							28.00974852500026
						],
						[
							-82.74154909299972,
							28.009927124000203
						],
						[
							-82.74150597399988,
							28.010008839000303
						],
						[
							-82.74145076899975,
							28.01009336900019
						],
						[
							-82.74134371799987,
							28.01025794300013
						],
						[
							-82.74125295799972,
							28.010397330000206
						],
						[
							-82.74111652299972,
							28.010570313000223
						],
						[
							-82.7409982309997,
							28.010719819000332
						],
						[
							-82.74096289799988,
							28.010764705000316
						],
						[
							-82.74086414699988,
							28.01086872300022
						],
						[
							-82.74069919799983,
							28.011042891000063
						],
						[
							-82.7406376589997,
							28.01110785800002
						],
						[
							-82.74050520199977,
							28.011225466000337
						],
						[
							-82.74028032699981,
							28.011424710000302
						],
						[
							-82.74023979699983,
							28.01134000800022
						],
						[
							-82.73996705299973,
							28.01133700700024
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Woodgate II Homeowners Association",
				"RegionID": "343292"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.74663933602733,
					28.00474302184181,
					-82.74240664999793,
					28.010281593000133
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.74241144199975,
							28.004888444000038
						],
						[
							-82.74240664999793,
							28.00474302184181
						],
						[
							-82.7428899999999,
							28.004757000000172
						],
						[
							-82.74314399999989,
							28.004765000000123
						],
						[
							-82.74358299999996,
							28.00478000000012
						],
						[
							-82.74378899999995,
							28.00479500000012
						],
						[
							-82.74611599999993,
							28.004960999999998
						],
						[
							-82.74652899999991,
							28.004980000000153
						],
						[
							-82.74663933602733,
							28.010215350999626
						],
						[
							-82.74653441499973,
							28.010281593000133
						],
						[
							-82.74648574399978,
							28.010277217000304
						],
						[
							-82.74646793499991,
							28.0102577160002
						],
						[
							-82.74645213099976,
							28.010234079000288
						],
						[
							-82.74642591699981,
							28.010210499000113
						],
						[
							-82.74638450799976,
							28.01018150000029
						],
						[
							-82.74627045599973,
							28.01009479200022
						],
						[
							-82.7461487689997,
							28.01001775300033
						],
						[
							-82.74601968999977,
							28.009950036000323
						],
						[
							-82.74598457699972,
							28.00993509900024
						],
						[
							-82.74588448499978,
							28.009892666000194
						],
						[
							-82.74575770999978,
							28.00984315800036
						],
						[
							-82.74555066999987,
							28.009754204000284
						],
						[
							-82.74513075699967,
							28.009573231000324
						],
						[
							-82.74491876199981,
							28.009481896000313
						],
						[
							-82.74472230899981,
							28.009397353000335
						],
						[
							-82.74438260699988,
							28.009254450000146
						],
						[
							-82.74418277899984,
							28.00917198700034
						],
						[
							-82.74395527199977,
							28.00907798400029
						],
						[
							-82.74372621599973,
							28.008983988000328
						],
						[
							-82.74350526399984,
							28.008892699000324
						],
						[
							-82.74341795199972,
							28.00885672800028
						],
						[
							-82.7432783189997,
							28.00878872200034
						],
						[
							-82.74314480399975,
							28.008708993000045
						],
						[
							-82.74303658599977,
							28.008629127000187
						],
						[
							-82.74293976599976,
							28.008544386000192
						],
						[
							-82.7428498819998,
							28.008451013000194
						],
						[
							-82.74283176099979,
							28.00842841900028
						],
						[
							-82.74276987599984,
							28.008350709000247
						],
						[
							-82.74270000199982,
							28.00824450700016
						],
						[
							-82.74267051999986,
							28.008189313000212
						],
						[
							-82.74264069599988,
							28.008133434000296
						],
						[
							-82.74259250199981,
							28.00801851800038
						],
						[
							-82.74256457899989,
							28.00792893600025
						],
						[
							-82.74255571299987,
							28.00790010400018
						],
						[
							-82.74253072099984,
							28.007779218000298
						],
						[
							-82.74251777799984,
							28.007656893000213
						],
						[
							-82.74251015099973,
							28.00744858700021
						],
						[
							-82.74250285999976,
							28.007239936000264
						],
						[
							-82.74249523399976,
							28.00703163000026
						],
						[
							-82.74248793899977,
							28.006829167000294
						],
						[
							-82.74248029099975,
							28.0066177660003
						],
						[
							-82.74246535599967,
							28.006198058000212
						],
						[
							-82.74245807699978,
							28.00599800200036
						],
						[
							-82.7424507609998,
							28.005792444000228
						],
						[
							-82.74244350799982,
							28.00558929400029
						],
						[
							-82.74243586599981,
							28.005378581000354
						],
						[
							-82.74242779899986,
							28.005155150000256
						],
						[
							-82.74241144199975,
							28.004888444000038
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Woodgate III Homeowners Association",
				"RegionID": "343294"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.76299820216495,
					27.999053572000246,
					-82.75947401299993,
					28.004443757000278
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.76003605899972,
							27.99976843400024
						],
						[
							-82.76003104299983,
							27.999053572000246
						],
						[
							-82.76298016699977,
							27.999064085000317
						],
						[
							-82.76299820216495,
							28.001646473002243
						],
						[
							-82.76297799999986,
							28.00329800000007
						],
						[
							-82.76284799193856,
							28.004430113993198
						],
						[
							-82.75949493699989,
							28.004443757000278
						],
						[
							-82.75947401299993,
							28.001459974000223
						],
						[
							-82.76005777099991,
							28.001448153000222
						],
						[
							-82.7600425159998,
							28.000688768000366
						],
						[
							-82.76030261999983,
							28.00048139000008
						],
						[
							-82.76018728699988,
							27.999812292000318
						],
						[
							-82.76003605899972,
							27.99976843400024
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Spring Lakes of Clearwater Homeowners Association",
				"RegionID": "343301"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.75473369999985,
					27.995317730000227,
					-82.75067757895698,
					27.99721012500022
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.75067757895698,
							27.995678894693047
						],
						[
							-82.75074999999993,
							27.995353000000126
						],
						[
							-82.75074989092727,
							27.9953199510005
						],
						[
							-82.75106148399976,
							27.995323157000232
						],
						[
							-82.7511089309997,
							27.99532324100024
						],
						[
							-82.75179309699972,
							27.99532156500028
						],
						[
							-82.75198022399984,
							27.995320886000133
						],
						[
							-82.75337339199982,
							27.995317730000227
						],
						[
							-82.75468105399975,
							27.99532121700025
						],
						[
							-82.75470619199987,
							27.995948184000166
						],
						[
							-82.75471230699985,
							27.996116959000187
						],
						[
							-82.75473369999985,
							27.99718608300036
						],
						[
							-82.75271559499977,
							27.997198176000207
						],
						[
							-82.75071855,
							27.99721012500022
						],
						[
							-82.7507173219997,
							27.99716578100028
						],
						[
							-82.75070518499976,
							27.99671374100036
						],
						[
							-82.75069976299994,
							27.996511267000304
						],
						[
							-82.75069479899979,
							27.996332858000198
						],
						[
							-82.75068982099974,
							27.99615238700028
						],
						[
							-82.75068527499973,
							27.99598566500016
						],
						[
							-82.75067757895698,
							27.995678894693047
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Charter Oaks Homeowners Association",
				"RegionID": "343308"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.75901057599992,
					27.993640859000053,
					-82.75501405499992,
					27.997097905000096
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.75770750499993,
							27.997089276000096
						],
						[
							-82.75745523099992,
							27.997086541000044
						],
						[
							-82.75730311799995,
							27.997088754000053
						],
						[
							-82.75706297399998,
							27.997089732000042
						],
						[
							-82.75682027099988,
							27.99708453600006
						],
						[
							-82.75666535299986,
							27.997087108000095
						],
						[
							-82.75617051999986,
							27.997086392000124
						],
						[
							-82.7560217799999,
							27.997086178000103
						],
						[
							-82.75565797599991,
							27.997086803000066
						],
						[
							-82.7555364989999,
							27.997087127000007
						],
						[
							-82.75506394999987,
							27.99708800300008
						],
						[
							-82.75505712199993,
							27.99690719800013
						],
						[
							-82.75504796999988,
							27.996663833000063
						],
						[
							-82.7550437919999,
							27.996550744000036
						],
						[
							-82.7550395919999,
							27.996434560000104
						],
						[
							-82.75503538699991,
							27.99632422100003
						],
						[
							-82.75503124999992,
							27.99621697500004
						],
						[
							-82.75502700299992,
							27.99610079200002
						],
						[
							-82.75502286399994,
							27.995993203000094
						],
						[
							-82.75501830899991,
							27.995874615000048
						],
						[
							-82.75501405499992,
							27.99575052400008
						],
						[
							-82.75531771599991,
							27.995749200000066
						],
						[
							-82.75552749799996,
							27.995748047000056
						],
						[
							-82.75574439999995,
							27.99574719900007
						],
						[
							-82.75598918899996,
							27.99574619700008
						],
						[
							-82.75598152099994,
							27.995583963000065
						],
						[
							-82.75611356699994,
							27.99541236400008
						],
						[
							-82.75612515699993,
							27.99538720200004
						],
						[
							-82.75661472799993,
							27.995384510000086
						],
						[
							-82.75665397099989,
							27.99539518100008
						],
						[
							-82.7566776609999,
							27.995386742000093
						],
						[
							-82.75671295699989,
							27.99538339600008
						],
						[
							-82.75675732499991,
							27.995392836000065
						],
						[
							-82.7567840329999,
							27.99539733000008
						],
						[
							-82.75703615299999,
							27.995385284000058
						],
						[
							-82.75728067399987,
							27.995387720000082
						],
						[
							-82.75729887599996,
							27.995422000000076
						],
						[
							-82.75732313099992,
							27.99541138100009
						],
						[
							-82.7573528469999,
							27.995406232000015
						],
						[
							-82.75737812299994,
							27.99540678000006
						],
						[
							-82.75740261699993,
							27.995412834000028
						],
						[
							-82.75743002999988,
							27.995386554000078
						],
						[
							-82.75792760099995,
							27.995378311000103
						],
						[
							-82.75796113599995,
							27.995408811000054
						],
						[
							-82.75800699799993,
							27.99540056400008
						],
						[
							-82.75803686299992,
							27.995404067000017
						],
						[
							-82.75807599599996,
							27.995329704000078
						],
						[
							-82.7585659269999,
							27.99533009600011
						],
						[
							-82.75856390299991,
							27.995179176000057
						],
						[
							-82.75806955399996,
							27.995183965000102
						],
						[
							-82.75803542799989,
							27.995198937000097
						],
						[
							-82.75799237099996,
							27.995203644000043
						],
						[
							-82.75794303799996,
							27.99519268500002
						],
						[
							-82.75792372599997,
							27.995219149000082
						],
						[
							-82.75742832399993,
							27.99521165200008
						],
						[
							-82.75744733399999,
							27.995181550000076
						],
						[
							-82.75746524099996,
							27.995152571000077
						],
						[
							-82.75747146699995,
							27.99512933000002
						],
						[
							-82.75747208199991,
							27.995106463000084
						],
						[
							-82.75767684399997,
							27.995100522000126
						],
						[
							-82.7576748209999,
							27.99499120200005
						],
						[
							-82.75766914699996,
							27.994664616000115
						],
						[
							-82.75766712199996,
							27.994554953000105
						],
						[
							-82.7576652209999,
							27.99445629100002
						],
						[
							-82.75766301799989,
							27.994321187000125
						],
						[
							-82.7576610199999,
							27.99420877300006
						],
						[
							-82.75765903399991,
							27.994104610000058
						],
						[
							-82.75765534099988,
							27.99388803200008
						],
						[
							-82.75765337899989,
							27.993780775000083
						],
						[
							-82.75765085199995,
							27.993640859000053
						],
						[
							-82.75790091199994,
							27.993646358000063
						],
						[
							-82.75806512999996,
							27.993645108000052
						],
						[
							-82.75842091099989,
							27.993648304000047
						],
						[
							-82.75855289999988,
							27.99364929500004
						],
						[
							-82.75883334099991,
							27.99365153000005
						],
						[
							-82.75896660799992,
							27.993655264000004
						],
						[
							-82.75896875199994,
							27.993829906000066
						],
						[
							-82.75897345399996,
							27.994190190000033
						],
						[
							-82.7589769349999,
							27.994465904000016
						],
						[
							-82.7589866999999,
							27.995238041000047
						],
						[
							-82.75898737499996,
							27.99529270200013
						],
						[
							-82.75900029899996,
							27.996294485000057
						],
						[
							-82.75900313699992,
							27.996526539000072
						],
						[
							-82.7590049599999,
							27.996655456000084
						],
						[
							-82.75900834199992,
							27.99691707500006
						],
						[
							-82.75901057599992,
							27.997097905000096
						],
						[
							-82.75846547999994,
							27.997096099000125
						],
						[
							-82.7583406059999,
							27.99709541300007
						],
						[
							-82.7581032119999,
							27.997094659000098
						],
						[
							-82.75795386699988,
							27.997091357000087
						],
						[
							-82.75770750499993,
							27.997089276000096
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Valencia Park Homeowners Association",
				"RegionID": "343310"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.7794895029999,
					27.986423188000074,
					-82.77558833399986,
					27.989855659000035
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.7761522719999,
							27.98939171600002
						],
						[
							-82.77614006199987,
							27.98768684800009
						],
						[
							-82.77560214099995,
							27.987679912000047
						],
						[
							-82.77558833399986,
							27.987266046000087
						],
						[
							-82.77676255799994,
							27.98725460600012
						],
						[
							-82.77674552099995,
							27.98643128600012
						],
						[
							-82.77902835899992,
							27.986423188000074
						],
						[
							-82.7790450869999,
							27.987241696000027
						],
						[
							-82.77946202799993,
							27.987229363000075
						],
						[
							-82.7794864559999,
							27.989070996000038
						],
						[
							-82.77906938999986,
							27.98907336000006
						],
						[
							-82.77907043799995,
							27.989219128000038
						],
						[
							-82.77902636299994,
							27.98920975100006
						],
						[
							-82.77901748099991,
							27.989482783000092
						],
						[
							-82.7794895029999,
							27.989494549000092
						],
						[
							-82.77948101199989,
							27.989845279000065
						],
						[
							-82.77855911299993,
							27.989855659000035
						],
						[
							-82.7785503249999,
							27.98940738500007
						],
						[
							-82.7761522719999,
							27.98939171600002
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Brentwood Estates",
				"RegionID": "343317"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.79949729624512,
					27.986120616886115,
					-82.79595105199984,
					27.98900313648797
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.7992160000054,
							27.98866200021674
						],
						[
							-82.7992148228964,
							27.988435184003286
						],
						[
							-82.79919186499976,
							27.98848929100021
						],
						[
							-82.79917027599974,
							27.98854236200025
						],
						[
							-82.7991484129999,
							27.98858443400036
						],
						[
							-82.79911243199969,
							27.988642058000327
						],
						[
							-82.7990762179997,
							27.98868799500031
						],
						[
							-82.79903562699988,
							27.988731206000242
						],
						[
							-82.79899791999979,
							27.988764946000195
						],
						[
							-82.79894260399973,
							27.988807040000303
						],
						[
							-82.79889109099975,
							27.988839657000245
						],
						[
							-82.79883649299967,
							27.98886782200036
						],
						[
							-82.7987790079997,
							27.988891535000274
						],
						[
							-82.79872105199988,
							27.988910609000254
						],
						[
							-82.79865875599988,
							27.98892558200016
						],
						[
							-82.7985965229997,
							27.988935570000102
						],
						[
							-82.79853337999991,
							27.98894075000017
						],
						[
							-82.79846395399974,
							27.988940466000326
						],
						[
							-82.79800838899972,
							27.98892832600021
						],
						[
							-82.79757451599987,
							27.9889164030002
						],
						[
							-82.79736067999985,
							27.988910767000267
						],
						[
							-82.79695843399998,
							27.988900722000057
						],
						[
							-82.79650226399988,
							27.988891675000286
						],
						[
							-82.79603443599973,
							27.988897134000293
						],
						[
							-82.79595105199984,
							27.988894866000283
						],
						[
							-82.79599900499981,
							27.988377505000198
						],
						[
							-82.79655215599983,
							27.98838805500036
						],
						[
							-82.79655143299986,
							27.98883638100033
						],
						[
							-82.79682210499979,
							27.98877602300031
						],
						[
							-82.79682458199981,
							27.988691432000326
						],
						[
							-82.79682938699986,
							27.988331096000355
						],
						[
							-82.79683210099982,
							27.98815367700033
						],
						[
							-82.79684102999975,
							27.98812371400025
						],
						[
							-82.7968553519998,
							27.98810036600027
						],
						[
							-82.79688846799978,
							27.988069805000144
						],
						[
							-82.79693170999971,
							27.988051333000215
						],
						[
							-82.79707518699978,
							27.988048782000266
						],
						[
							-82.79736057299976,
							27.988054004000343
						],
						[
							-82.79779131199979,
							27.988061477000162
						],
						[
							-82.79815387799977,
							27.988067968000255
						],
						[
							-82.79818504099977,
							27.98806933400019
						],
						[
							-82.79821455199999,
							27.988060854000377
						],
						[
							-82.7982377679997,
							27.988042613000022
						],
						[
							-82.79824956099968,
							27.988017905000287
						],
						[
							-82.79824930499966,
							27.98794364400027
						],
						[
							-82.7982477369998,
							27.987349557000233
						],
						[
							-82.79824502799976,
							27.987312156000247
						],
						[
							-82.79822760599983,
							27.987285210000326
						],
						[
							-82.79820858699985,
							27.9872729440002
						],
						[
							-82.79816345499975,
							27.987264783000324
						],
						[
							-82.79793418099987,
							27.987266113000256
						],
						[
							-82.7979319939997,
							27.98696907700037
						],
						[
							-82.79811394199974,
							27.986852503000318
						],
						[
							-82.79812225499973,
							27.986679520000127
						],
						[
							-82.79821953299978,
							27.986504646000224
						],
						[
							-82.79823564099978,
							27.986463296000355
						],
						[
							-82.79826484899988,
							27.986392990000223
						],
						[
							-82.79841099468699,
							27.986391179858852
						],
						[
							-82.79846489535127,
							27.98612070414254
						],
						[
							-82.79847200887704,
							27.986120616886115
						],
						[
							-82.79851347481724,
							27.98612356126632
						],
						[
							-82.79855399556986,
							27.986132840471104
						],
						[
							-82.79859261065911,
							27.98614823506568
						],
						[
							-82.79862840187728,
							27.986169379925233
						],
						[
							-82.79866052026443,
							27.986195771429504
						],
						[
							-82.79868820229568,
							27.98622678365003
						],
						[
							-82.79871079146639,
							27.98626168094255
						],
						[
							-82.79872775088143,
							27.986299635029717
						],
						[
							-82.79873867854313,
							27.986339742993774
						],
						[
							-82.7987433154476,
							27.986381054250412
						],
						[
							-82.79874417160202,
							27.986405764922143
						],
						[
							-82.79882060318265,
							27.986405320656896
						],
						[
							-82.79882748029841,
							27.986405368320636
						],
						[
							-82.79888141983507,
							27.986406430420026
						],
						[
							-82.79891873450474,
							27.986409766904888
						],
						[
							-82.79898509008123,
							27.986420384300917
						],
						[
							-82.79901557080274,
							27.98642708874645
						],
						[
							-82.799047879846,
							27.986436183590083
						],
						[
							-82.7990709267717,
							27.986443806243702
						],
						[
							-82.79910199834768,
							27.98645565840882
						],
						[
							-82.79911763665868,
							27.986462192882406
						],
						[
							-82.79914746267359,
							27.98647577174577
						],
						[
							-82.79917040617721,
							27.98648757264949
						],
						[
							-82.79919875010967,
							27.9865039106329
						],
						[
							-82.79921806844601,
							27.9865161656944
						],
						[
							-82.79924453999017,
							27.986534577514202
						],
						[
							-82.7992600029331,
							27.98654617517126
						],
						[
							-82.79928493843494,
							27.986566314588504
						],
						[
							-82.79930382239911,
							27.986583085145536
						],
						[
							-82.79932659413214,
							27.986605299299253
						],
						[
							-82.79934393216146,
							27.986623886487042
						],
						[
							-82.7993642496449,
							27.986647835432624
						],
						[
							-82.79937805064071,
							27.98666554847912
						],
						[
							-82.79939590398156,
							27.986690542437135
						],
						[
							-82.79941582936041,
							27.986723075411316
						],
						[
							-82.79944411753489,
							27.986777576125125
						],
						[
							-82.79945929719143,
							27.986812718032823
						],
						[
							-82.79946938668512,
							27.986841538605592
						],
						[
							-82.7994768492595,
							27.98686672142107
						],
						[
							-82.79948388735362,
							27.98689556087989
						],
						[
							-82.79948890467128,
							27.986921628628206
						],
						[
							-82.79949314407531,
							27.98695151489802
						],
						[
							-82.79949549040644,
							27.98697609246982
						],
						[
							-82.79949696799267,
							27.98700599492758
						],
						[
							-82.79949729624512,
							27.987020086404183
						],
						[
							-82.79949686367114,
							27.987171270531093
						],
						[
							-82.7994959238797,
							27.98759427204384
						],
						[
							-82.79948362295293,
							27.988242448503904
						],
						[
							-82.7994840195539,
							27.98831894393629
						],
						[
							-82.79948432892093,
							27.9883784259945
						],
						[
							-82.79948461760316,
							27.988434484333983
						],
						[
							-82.79948227127203,
							27.98847070272991
						],
						[
							-82.79947508389031,
							27.988506278110776
						],
						[
							-82.79946318675921,
							27.98854056656161
						],
						[
							-82.79944101577337,
							27.988592818970407
						],
						[
							-82.79942018567634,
							27.988644023668666
						],
						[
							-82.79940967709851,
							27.98866676842248
						],
						[
							-82.79938781457996,
							27.988708840505367
						],
						[
							-82.79937726013651,
							27.988727328767663
						],
						[
							-82.79934127916151,
							27.988784952826787
						],
						[
							-82.7993243071562,
							27.988809087931724
						],
						[
							-82.79928809325668,
							27.988855025301188
						],
						[
							-82.79927286054007,
							27.9888727149655
						],
						[
							-82.7992322696402,
							27.988915926489813
						],
						[
							-82.79921553235805,
							27.988932263573503
						],
						[
							-82.79917782468462,
							27.98896600343809
						],
						[
							-82.79916130144098,
							27.98897964705286
						],
						[
							-82.79913043405934,
							27.98900313648797
						],
						[
							-82.79917499991426,
							27.988953000141162
						],
						[
							-82.7992160000054,
							27.98866200021674
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Old Clearwater Bay Neighborhood Association",
				"RegionID": "343319"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.79171644099992,
					27.968247547000075,
					-82.78364218299994,
					27.97531933900007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.78375434099989,
							27.97463780500008
						],
						[
							-82.7837502629999,
							27.973644914000083
						],
						[
							-82.78374513699993,
							27.97336439600005
						],
						[
							-82.78374666499988,
							27.973147101000016
						],
						[
							-82.78374831199993,
							27.9729463090001
						],
						[
							-82.78374987899988,
							27.97273451500007
						],
						[
							-82.78375152599992,
							27.972533722000065
						],
						[
							-82.78375007499999,
							27.972332947000062
						],
						[
							-82.78374435299996,
							27.971969919000045
						],
						[
							-82.78364218299994,
							27.97197875200007
						],
						[
							-82.78364996599996,
							27.971769673
						],
						[
							-82.78365426699987,
							27.970221141000124
						],
						[
							-82.78365605299993,
							27.970039601000025
						],
						[
							-82.78365481899993,
							27.969440008000063
						],
						[
							-82.78365379699991,
							27.96904394800007
						],
						[
							-82.78365332599988,
							27.96880466100008
						],
						[
							-82.7842171599999,
							27.968806950000086
						],
						[
							-82.78421912399997,
							27.96865016200008
						],
						[
							-82.78431675999988,
							27.96863722900008
						],
						[
							-82.78468364999995,
							27.96862826100005
						],
						[
							-82.78488832099993,
							27.968657348000058
						],
						[
							-82.78488535599986,
							27.968247547000075
						],
						[
							-82.78536863599996,
							27.968248915000103
						],
						[
							-82.78559788499993,
							27.968249669000073
						],
						[
							-82.78584571999991,
							27.96825031700004
						],
						[
							-82.78605019099987,
							27.96825189900008
						],
						[
							-82.78629494899987,
							27.968255314000096
						],
						[
							-82.7867472909999,
							27.968262355000057
						],
						[
							-82.7869951459999,
							27.968265751000075
						],
						[
							-82.78719959799993,
							27.968264581000064
						],
						[
							-82.78767360399989,
							27.968268745000053
						],
						[
							-82.78816619699988,
							27.968272800000122
						],
						[
							-82.78837376599992,
							27.968274361000077
						],
						[
							-82.78860920599995,
							27.96827438800008
						],
						[
							-82.7888663289999,
							27.96827428900007
						],
						[
							-82.78934959799993,
							27.968274268000066
						],
						[
							-82.78981119299992,
							27.9682757450001
						],
						[
							-82.79005284799993,
							27.968278483000063
						],
						[
							-82.79054854899992,
							27.968283887000062
						],
						[
							-82.79074990199987,
							27.968282730000055
						],
						[
							-82.79098534199991,
							27.968282752000057
						],
						[
							-82.79121458499996,
							27.968282809000065
						],
						[
							-82.79145931799987,
							27.968282777000063
						],
						[
							-82.79171644099992,
							27.968282673000054
						],
						[
							-82.79171539499991,
							27.969028052000084
						],
						[
							-82.7917152279999,
							27.96934985700007
						],
						[
							-82.79171490399996,
							27.969517636000006
						],
						[
							-82.79171485699996,
							27.969677163000057
						],
						[
							-82.79171420299991,
							27.970097986000063
						],
						[
							-82.79171240999995,
							27.97027677600002
						],
						[
							-82.79171042299996,
							27.970681105000082
						],
						[
							-82.79170980199991,
							27.970854387000117
						],
						[
							-82.79170745499997,
							27.971335386000035
						],
						[
							-82.7917065449999,
							27.971509013000105
						],
						[
							-82.79170575199991,
							27.97169879900009
						],
						[
							-82.79170510699996,
							27.971822574000022
						],
						[
							-82.79073539899993,
							27.97181714800011
						],
						[
							-82.79054640999992,
							27.97181548400006
						],
						[
							-82.78956118199994,
							27.971806014000073
						],
						[
							-82.7893504979999,
							27.9718030970001
						],
						[
							-82.78837771199998,
							27.971800423000055
						],
						[
							-82.78816395999988,
							27.97180164800007
						],
						[
							-82.78767879599988,
							27.971969454000096
						],
						[
							-82.7876779369999,
							27.97210457500009
						],
						[
							-82.7876768969999,
							27.97230777100011
						],
						[
							-82.78767543699988,
							27.972533317000035
						],
						[
							-82.78767325599996,
							27.972912892000092
						],
						[
							-82.78779717199991,
							27.972912182000115
						],
						[
							-82.78780196799995,
							27.973145944000095
						],
						[
							-82.78780686699992,
							27.97339380000009
						],
						[
							-82.78780821099993,
							27.973665400000087
						],
						[
							-82.7878088009999,
							27.97391328100008
						],
						[
							-82.78780936099994,
							27.974163569000005
						],
						[
							-82.7876606429999,
							27.974162014000058
						],
						[
							-82.78765707899996,
							27.97448418200007
						],
						[
							-82.7876511929999,
							27.97503361900005
						],
						[
							-82.78764828399993,
							27.97531933900007
						],
						[
							-82.78718884399993,
							27.97531887400003
						],
						[
							-82.7869533839999,
							27.975318158000057
						],
						[
							-82.78672412299994,
							27.975317751000112
						],
						[
							-82.78648276099996,
							27.975317411999995
						],
						[
							-82.78625040199991,
							27.975317021000052
						],
						[
							-82.78600874599991,
							27.975316339000088
						],
						[
							-82.78577328899988,
							27.975315965000057
						],
						[
							-82.78531447299993,
							27.975314803000046
						],
						[
							-82.7850790159999,
							27.97531442800002
						],
						[
							-82.78484046099996,
							27.975314070000074
						],
						[
							-82.78460809899993,
							27.975313332000013
						],
						[
							-82.7843695439999,
							27.975312974000076
						],
						[
							-82.78375301599996,
							27.975311674000054
						],
						[
							-82.78374937799992,
							27.974808361000065
						],
						[
							-82.78375434099989,
							27.97463780500008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Country Club Estates Homeowners Assoc",
				"RegionID": "343326"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.8020025520114,
					27.97048809865158,
					-82.8006162579999,
					27.971682518815598
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.80066305899997,
							27.971212393000073
						],
						[
							-82.8006162579999,
							27.9707478390001
						],
						[
							-82.80165902899124,
							27.970757773925953
						],
						[
							-82.80166299948938,
							27.970613000092236
						],
						[
							-82.80167306470152,
							27.97048809865158
						],
						[
							-82.80169389389908,
							27.970488297401754
						],
						[
							-82.80173409809035,
							27.970491698637666
						],
						[
							-82.80177334630241,
							27.970501056982698
						],
						[
							-82.80181075989748,
							27.970516163794144
						],
						[
							-82.80184550160672,
							27.970536680926934
						],
						[
							-82.80187679531541,
							27.970562150626087
						],
						[
							-82.80190394135087,
							27.97059200182227
						],
						[
							-82.80192633177141,
							27.970625567218327
						],
						[
							-82.8019434656547,
							27.970662096779844
						],
						[
							-82.8019549598896,
							27.970700773023026
						],
						[
							-82.80196055906859,
							27.97074073080011
						],
						[
							-82.8020025520114,
							27.97139234267035
						],
						[
							-82.8020018892111,
							27.971435333860605
						],
						[
							-82.8019944050531,
							27.971477673941735
						],
						[
							-82.80198029109313,
							27.971518287324614
						],
						[
							-82.80195990346279,
							27.97155614248682
						],
						[
							-82.80193376197,
							27.971590278053014
						],
						[
							-82.80190252941533,
							27.971619827976234
						],
						[
							-82.80186699900054,
							27.9716440404233
						],
						[
							-82.80182807364515,
							27.971662302056394
						],
						[
							-82.80178674170399,
							27.971674147926194
						],
						[
							-82.80174405268589,
							27.97167927675973
						],
						[
							-82.80166758513236,
							27.971682322763442
						],
						[
							-82.80165375355959,
							27.971682518815598
						],
						[
							-82.80163984014845,
							27.971682359635636
						],
						[
							-82.80165699921284,
							27.97142000042004
						],
						[
							-82.80165684666393,
							27.971412740096675
						],
						[
							-82.80071092699991,
							27.971401896000124
						],
						[
							-82.80066305899997,
							27.971212393000073
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Harbor Bluffs Waterfront Condo Assoc",
				"RegionID": "343328"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.80480333848617,
					27.96077307080697,
					-82.80258358099991,
					27.9623375206172
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.80340964388698,
							27.962337380323557
						],
						[
							-82.80340999998035,
							27.962311999656567
						],
						[
							-82.80342299968025,
							27.962243000073453
						],
						[
							-82.8034609996332,
							27.9621290002143
						],
						[
							-82.80350831773075,
							27.962067724954057
						],
						[
							-82.80259563299984,
							27.9620664240004
						],
						[
							-82.80258358099991,
							27.961010778000276
						],
						[
							-82.80339797399988,
							27.96101049600043
						],
						[
							-82.80453354199986,
							27.961007988000222
						],
						[
							-82.80450061592431,
							27.961109685182986
						],
						[
							-82.80466493642311,
							27.96077307080697
						],
						[
							-82.80469188685593,
							27.96078954638627
						],
						[
							-82.80472411091323,
							27.96081700718453
						],
						[
							-82.80475164095928,
							27.960849171436944
						],
						[
							-82.80477380115342,
							27.960885245941572
						],
						[
							-82.80479004470783,
							27.960924343067642
						],
						[
							-82.80479997142434,
							27.960965500540095
						],
						[
							-82.80480169272674,
							27.960987077973623
						],
						[
							-82.80480333848617,
							27.96100770392435
						],
						[
							-82.80480006045738,
							27.96104991360401
						],
						[
							-82.80479022007563,
							27.961091091761073
						],
						[
							-82.8047572940976,
							27.961192788894458
						],
						[
							-82.80458401003095,
							27.96172799611895
						],
						[
							-82.8045672232858,
							27.961768350496744
						],
						[
							-82.80454414128673,
							27.961805464617765
						],
						[
							-82.80451536837779,
							27.961838365414696
						],
						[
							-82.80448166178809,
							27.961866187740117
						],
						[
							-82.80444390465192,
							27.961888203143484
						],
						[
							-82.80440308802247,
							27.961903833360605
						],
						[
							-82.80436028299174,
							27.961912667400952
						],
						[
							-82.80431661371261,
							27.961914475037833
						],
						[
							-82.80417851831838,
							27.961908984676956
						],
						[
							-82.8041707913436,
							27.961910714073493
						],
						[
							-82.8041587107508,
							27.961913129652164
						],
						[
							-82.80411504147168,
							27.961917209876322
						],
						[
							-82.80407626900102,
							27.961917666731853
						],
						[
							-82.80407471407328,
							27.961935434637223
						],
						[
							-82.80406439974885,
							27.961975589365654
						],
						[
							-82.804047862116,
							27.962024042138825
						],
						[
							-82.80403409259642,
							27.962056300820063
						],
						[
							-82.8040162491481,
							27.962086497355823
						],
						[
							-82.80399463304383,
							27.962114120031703
						],
						[
							-82.80391696219736,
							27.962201368657805
						],
						[
							-82.80389434604689,
							27.96223477667265
						],
						[
							-82.80386700036189,
							27.96226443901101
						],
						[
							-82.80383553758071,
							27.962289691973933
						],
						[
							-82.80380066097324,
							27.96230996988697
						],
						[
							-82.80376314935205,
							27.962324820391263
						],
						[
							-82.80372384358337,
							27.96233391073876
						],
						[
							-82.8036836214057,
							27.962337037681202
						],
						[
							-82.80350849822547,
							27.9623375206172
						],
						[
							-82.80340964388698,
							27.962337380323557
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Oak Bluffs Condominium Association",
				"RegionID": "343333"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.79579698899994,
					27.959559713000132,
					-82.79444094199992,
					27.960768956000003
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.79444847499992,
							27.96016545800007
						],
						[
							-82.79444094199992,
							27.959559713000132
						],
						[
							-82.7947885209999,
							27.95956183200004
						],
						[
							-82.7947905769999,
							27.959882248000085
						],
						[
							-82.79494390399988,
							27.9598813630001
						],
						[
							-82.79494691399995,
							27.960166705000084
						],
						[
							-82.79511884199988,
							27.960167775000087
						],
						[
							-82.7952854939999,
							27.960168875000086
						],
						[
							-82.79545369499996,
							27.960169966000088
						],
						[
							-82.79562097599995,
							27.960171062000093
						],
						[
							-82.79578951399996,
							27.96017215000009
						],
						[
							-82.79579698899994,
							27.960768956000003
						],
						[
							-82.79478710499987,
							27.96076275900011
						],
						[
							-82.7947799299999,
							27.960166295000054
						],
						[
							-82.79444847499992,
							27.96016545800007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Prospect Towers Homeowners Association",
				"RegionID": "343335"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.75025011499991,
					27.95314800200005,
					-82.74622514899995,
					27.956704834999996
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.74622814099995,
							27.95340034200005
						],
						[
							-82.74622514899995,
							27.95314800200005
						],
						[
							-82.74715750099992,
							27.95315016400005
						],
						[
							-82.74741156699989,
							27.9531507990001
						],
						[
							-82.74763224899995,
							27.953151350000056
						],
						[
							-82.74785134599996,
							27.953151897000012
						],
						[
							-82.7479635529999,
							27.95315210100003
						],
						[
							-82.7483252639999,
							27.953152759000083
						],
						[
							-82.74877130599995,
							27.95315377200008
						],
						[
							-82.7492452269999,
							27.95315497500009
						],
						[
							-82.74968507499997,
							27.953156018000087
						],
						[
							-82.7501949999999,
							27.953163000000046
						],
						[
							-82.7502004399999,
							27.953418631000055
						],
						[
							-82.75020295499993,
							27.953600492000092
						],
						[
							-82.75020532299995,
							27.953767915000093
						],
						[
							-82.75021283799994,
							27.95426708500009
						],
						[
							-82.75021636299996,
							27.954510827000007
						],
						[
							-82.75021377499993,
							27.954675526000045
						],
						[
							-82.75021787599992,
							27.954911701000054
						],
						[
							-82.75021893999991,
							27.9549746120001
						],
						[
							-82.7502274209999,
							27.955438365000106
						],
						[
							-82.7502283699999,
							27.955484774000038
						],
						[
							-82.75023189299992,
							27.955679351000057
						],
						[
							-82.75023506199992,
							27.955871523000063
						],
						[
							-82.75023858199994,
							27.95606575600006
						],
						[
							-82.75024053499993,
							27.95617301400005
						],
						[
							-82.75024210699989,
							27.95626067700002
						],
						[
							-82.75024465899992,
							27.95640575000003
						],
						[
							-82.75024562199992,
							27.95646075500005
						],
						[
							-82.75025011499991,
							27.956704834999996
						],
						[
							-82.74994654199993,
							27.95670305100012
						],
						[
							-82.74975322099993,
							27.95670101000004
						],
						[
							-82.74943976999992,
							27.95669893500004
						],
						[
							-82.74919504999993,
							27.956697173000073
						],
						[
							-82.74892182399988,
							27.956695566000032
						],
						[
							-82.74867676599986,
							27.956693805000064
						],
						[
							-82.7484131679999,
							27.95669180100008
						],
						[
							-82.74815944899987,
							27.95669043000005
						],
						[
							-82.74790698499994,
							27.956688708000087
						],
						[
							-82.74763380399989,
							27.956686754000103
						],
						[
							-82.74723942799994,
							27.95668408200006
						],
						[
							-82.74677786699995,
							27.956680742000046
						],
						[
							-82.7467258349999,
							27.9566803370001
						],
						[
							-82.74626892199986,
							27.956677314000032
						],
						[
							-82.74626111799992,
							27.955676183000065
						],
						[
							-82.74625712199995,
							27.955503268000058
						],
						[
							-82.7462545049999,
							27.954982067000095
						],
						[
							-82.74625080299987,
							27.95480949500003
						],
						[
							-82.74624931099991,
							27.95454339400004
						],
						[
							-82.7462481119999,
							27.95427763600008
						],
						[
							-82.74624109699995,
							27.95411608400012
						],
						[
							-82.74623479899996,
							27.9538335060001
						],
						[
							-82.74622938699987,
							27.95358152300013
						],
						[
							-82.74622814099995,
							27.95340034200005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "University Park Homeowners Association",
				"RegionID": "343342"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.72547267199992,
					27.9531604270001,
					-82.7238912939999,
					27.955267608000007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.7238912939999,
							27.95484329800007
						],
						[
							-82.72433835799986,
							27.954068060000058
						],
						[
							-82.72485577499995,
							27.9531604270001
						],
						[
							-82.72538083299987,
							27.953585705000116
						],
						[
							-82.72541732799996,
							27.953615424000084
						],
						[
							-82.72547267199992,
							27.953655014000077
						],
						[
							-82.72531278799993,
							27.953875896000056
						],
						[
							-82.7253071529999,
							27.95442327200005
						],
						[
							-82.7253319319999,
							27.954423141000035
						],
						[
							-82.72532523499989,
							27.954855003000066
						],
						[
							-82.72531899099992,
							27.955267608000007
						],
						[
							-82.72458715699993,
							27.955101793000054
						],
						[
							-82.72403777199995,
							27.954977301000056
						],
						[
							-82.7238912939999,
							27.95484329800007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Seville Condominium",
				"RegionID": "343344"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.7450842819999,
					27.945443693000037,
					-82.7443254419999,
					27.945782553000093
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.74432731799996,
							27.94560270900005
						],
						[
							-82.7445187169999,
							27.945443693000037
						],
						[
							-82.74454956299988,
							27.94546045900009
						],
						[
							-82.74457618799995,
							27.945468653000056
						],
						[
							-82.7446014449999,
							27.94547161000013
						],
						[
							-82.74501089899995,
							27.94546973900006
						],
						[
							-82.74504084799993,
							27.945467085000104
						],
						[
							-82.7450811759999,
							27.945738906000123
						],
						[
							-82.7450842819999,
							27.945782553000093
						],
						[
							-82.74492631899996,
							27.945782032000057
						],
						[
							-82.7447033119999,
							27.945781520000097
						],
						[
							-82.74448959999998,
							27.94578130000008
						],
						[
							-82.7443254419999,
							27.94578081300004
						],
						[
							-82.74432731799996,
							27.94560270900005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Imperial Courts Bldg D Condominium Assoc",
				"RegionID": "343351"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.74450664799973,
					27.94409463000999,
					-82.7441582117509,
					27.944956926993672
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.74418082937672,
							27.94409463000999
						],
						[
							-82.74450664799973,
							27.944382416000227
						],
						[
							-82.74447914599978,
							27.944413938000352
						],
						[
							-82.74446449299971,
							27.944447024000244
						],
						[
							-82.74445901399979,
							27.944482551000252
						],
						[
							-82.74446352499972,
							27.944688813000266
						],
						[
							-82.74446387099974,
							27.944922602000336
						],
						[
							-82.74435672899976,
							27.944923181000295
						],
						[
							-82.74435693699978,
							27.944953435000134
						],
						[
							-82.7441582117509,
							27.944956926993672
						],
						[
							-82.74418082937672,
							27.94409463000999
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Imperial Courts Bldg G Condominium Assoc",
				"RegionID": "343353"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.97054380899993,
					28.04672987300006,
					-81.9573482209999,
					28.05500201800004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.9575589069999,
							28.05500201800004
						],
						[
							-81.9573482209999,
							28.04683812500008
						],
						[
							-81.95849003599994,
							28.046840866000082
						],
						[
							-81.95850191199992,
							28.046966011000052
						],
						[
							-81.95858691099994,
							28.04725301000008
						],
						[
							-81.95865391099996,
							28.047415011000055
						],
						[
							-81.95882690999991,
							28.047727011000067
						],
						[
							-81.95893590999992,
							28.04791301000006
						],
						[
							-81.95900491399993,
							28.048012011000083
						],
						[
							-81.95916091099991,
							28.048154010000076
						],
						[
							-81.9593319089999,
							28.04828200700007
						],
						[
							-81.9595009109999,
							28.04836700900006
						],
						[
							-81.95970788799991,
							28.048439142000063
						],
						[
							-81.96048191099995,
							28.048407010000062
						],
						[
							-81.9607619329999,
							28.04842614200004
						],
						[
							-81.96107190999993,
							28.048324009000055
						],
						[
							-81.9612139109999,
							28.048253009000064
						],
						[
							-81.96148592799995,
							28.048076821000052
						],
						[
							-81.96152092599993,
							28.048112194000055
						],
						[
							-81.96154791099991,
							28.04807601000005
						],
						[
							-81.96231690999991,
							28.047266010000044
						],
						[
							-81.96248285799994,
							28.04701898700006
						],
						[
							-81.96251590899993,
							28.046894010000074
						],
						[
							-81.9625219109999,
							28.04682401000008
						],
						[
							-81.96252878399993,
							28.04672987300006
						],
						[
							-81.96259690999995,
							28.046731011000077
						],
						[
							-81.96372590999994,
							28.04675201100008
						],
						[
							-81.96393391099991,
							28.04677101100009
						],
						[
							-81.9642139099999,
							28.04683501100004
						],
						[
							-81.96439191099995,
							28.046906010000043
						],
						[
							-81.96469590999993,
							28.047051011000065
						],
						[
							-81.96486490899991,
							28.047156010000037
						],
						[
							-81.9650849109999,
							28.04735401000005
						],
						[
							-81.96523990999992,
							28.047537011000088
						],
						[
							-81.9653359109999,
							28.047695011000087
						],
						[
							-81.96547590799992,
							28.047988006000082
						],
						[
							-81.96550891099992,
							28.04811101000007
						],
						[
							-81.96556493299994,
							28.048451612000065
						],
						[
							-81.96556777799992,
							28.048629146000057
						],
						[
							-81.96562703799992,
							28.04862787500008
						],
						[
							-81.96563990999994,
							28.048896010000078
						],
						[
							-81.96566391099992,
							28.04913901000009
						],
						[
							-81.9657879099999,
							28.04978601000005
						],
						[
							-81.96587891099995,
							28.050124009000058
						],
						[
							-81.96600591099991,
							28.050459010000054
						],
						[
							-81.9661919109999,
							28.050899008000044
						],
						[
							-81.96631091099994,
							28.05114601100007
						],
						[
							-81.96640505699992,
							28.051305090000085
						],
						[
							-81.96633676499994,
							28.051307931000053
						],
						[
							-81.96646990999994,
							28.051517011000044
						],
						[
							-81.96679491099991,
							28.05195101000004
						],
						[
							-81.96705791099993,
							28.05226201000005
						],
						[
							-81.96722190999992,
							28.052432011000064
						],
						[
							-81.96745291099995,
							28.052662010000063
						],
						[
							-81.96775891099992,
							28.052905010000075
						],
						[
							-81.96805790999991,
							28.053143010000042
						],
						[
							-81.96891193399995,
							28.053781193000077
						],
						[
							-81.96894288699991,
							28.053738826000085
						],
						[
							-81.96969091099993,
							28.054293010000038
						],
						[
							-81.96985590999992,
							28.05440701000009
						],
						[
							-81.9700159109999,
							28.054517011000087
						],
						[
							-81.97041091099993,
							28.054812010000035
						],
						[
							-81.97046291099991,
							28.05485101100004
						],
						[
							-81.97054380899993,
							28.05491110400004
						],
						[
							-81.97044605199994,
							28.05491395200005
						],
						[
							-81.97034590999993,
							28.054917010000057
						],
						[
							-81.97002290899991,
							28.054926011000077
						],
						[
							-81.9695989089999,
							28.054918010000055
						],
						[
							-81.9685789099999,
							28.05491401000006
						],
						[
							-81.96729990999995,
							28.054919010000052
						],
						[
							-81.96701690899994,
							28.054919010000052
						],
						[
							-81.96677290999992,
							28.054921010000044
						],
						[
							-81.96629590899994,
							28.05492201000004
						],
						[
							-81.96604990999992,
							28.05492201000004
						],
						[
							-81.9657929089999,
							28.05492301000004
						],
						[
							-81.96548490399995,
							28.054922956000045
						],
						[
							-81.96471691099993,
							28.05492301000004
						],
						[
							-81.96446591099995,
							28.05492301000004
						],
						[
							-81.96415991099991,
							28.05492501100008
						],
						[
							-81.96345191099994,
							28.054932010000073
						],
						[
							-81.96279190999991,
							28.054938010000058
						],
						[
							-81.96245491099995,
							28.05494100900006
						],
						[
							-81.96141991099995,
							28.054950010000084
						],
						[
							-81.96135391099995,
							28.05495101000008
						],
						[
							-81.96130590999991,
							28.05495101000008
						],
						[
							-81.96095690999994,
							28.054954010000074
						],
						[
							-81.96061591099993,
							28.054957010000066
						],
						[
							-81.95981391099991,
							28.054965011000036
						],
						[
							-81.95940191099993,
							28.05497200900004
						],
						[
							-81.95902390999993,
							28.054979010000068
						],
						[
							-81.95835891099995,
							28.054990010000044
						],
						[
							-81.95816490999994,
							28.054991010000037
						],
						[
							-81.9575589069999,
							28.05500201800004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Polk",
				"City": "Lakeland",
				"Name": "North Lake Wire",
				"RegionID": "343437"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.95333286099994,
					28.059179707000055,
					-81.94304036099993,
					28.070460000000082
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.94920999999994,
							28.069896764000077
						],
						[
							-81.94920999999994,
							28.069753091000052
						],
						[
							-81.9489019099999,
							28.06976601000008
						],
						[
							-81.9482049099999,
							28.06982501000005
						],
						[
							-81.94463085699994,
							28.069831842000045
						],
						[
							-81.9444499999999,
							28.06996100000004
						],
						[
							-81.94359571599995,
							28.07024817900009
						],
						[
							-81.94331818099994,
							28.06957284400005
						],
						[
							-81.94329840499995,
							28.06952007800004
						],
						[
							-81.94328927299995,
							28.06949163200005
						],
						[
							-81.94312727199991,
							28.06895663100005
						],
						[
							-81.94311932099993,
							28.068928761000052
						],
						[
							-81.94310595799993,
							28.068871449000085
						],
						[
							-81.94309637099992,
							28.068813385000055
						],
						[
							-81.94309461799992,
							28.068799195000057
						],
						[
							-81.94305961799995,
							28.06849619600007
						],
						[
							-81.94305560299995,
							28.068451818000085
						],
						[
							-81.94305436099995,
							28.068428044000086
						],
						[
							-81.94304036099993,
							28.068069043000037
						],
						[
							-81.94304160399992,
							28.067975181000065
						],
						[
							-81.94304594199991,
							28.06792804400004
						],
						[
							-81.94309830899994,
							28.067486664000057
						],
						[
							-81.9431147809999,
							28.067154460000044
						],
						[
							-81.94311560299991,
							28.06714018100007
						],
						[
							-81.94312137199995,
							28.067081615000063
						],
						[
							-81.94313041999993,
							28.067026279000064
						],
						[
							-81.94322141999993,
							28.06656127900004
						],
						[
							-81.94322195899991,
							28.06655855100007
						],
						[
							-81.94323532199991,
							28.066501238000058
						],
						[
							-81.9432524049999,
							28.066444922000073
						],
						[
							-81.94327313499991,
							28.06638984400007
						],
						[
							-81.94329742299993,
							28.066336240000055
						],
						[
							-81.94332516499992,
							28.06628433900005
						],
						[
							-81.94335243099994,
							28.06624011400004
						],
						[
							-81.9434231649999,
							28.066132476000064
						],
						[
							-81.9435457589999,
							28.06590554600007
						],
						[
							-81.9435581649999,
							28.065883339000038
						],
						[
							-81.94358924099993,
							28.06583336400007
						],
						[
							-81.94359443899992,
							28.065825672000074
						],
						[
							-81.94388343799996,
							28.065402671000072
						],
						[
							-81.94391251999991,
							28.065362527000048
						],
						[
							-81.94394985399994,
							28.065317036000067
						],
						[
							-81.94399008399995,
							28.06527408300008
						],
						[
							-81.94403303599996,
							28.06523385400004
						],
						[
							-81.94407852799992,
							28.065196520000086
						],
						[
							-81.94412636399994,
							28.065162241000053
						],
						[
							-81.94416050999992,
							28.06514052000006
						],
						[
							-81.94432250999995,
							28.065042520000077
						],
						[
							-81.9443383389999,
							28.06503316400006
						],
						[
							-81.9443902399999,
							28.06500542200007
						],
						[
							-81.94444384399992,
							28.06498113500004
						],
						[
							-81.94447018099993,
							28.06497070800009
						],
						[
							-81.94469518199992,
							28.06488570900007
						],
						[
							-81.94472392199992,
							28.064875405000066
						],
						[
							-81.94478023799991,
							28.064858322000077
						],
						[
							-81.94482972299994,
							28.064846552000063
						],
						[
							-81.94527090199996,
							28.06475471400006
						],
						[
							-81.94556129699993,
							28.064659762000076
						],
						[
							-81.9456729179999,
							28.064614618000064
						],
						[
							-81.94587390999993,
							28.06448083400005
						],
						[
							-81.94701250999992,
							28.063534489000062
						],
						[
							-81.9470483799999,
							28.06347314700008
						],
						[
							-81.94732362299993,
							28.06287462800009
						],
						[
							-81.94730616399994,
							28.06284566100004
						],
						[
							-81.9472784219999,
							28.06279376000009
						],
						[
							-81.94725413399993,
							28.062740155000085
						],
						[
							-81.94723340399992,
							28.062685077000083
						],
						[
							-81.94721632099993,
							28.062628761000042
						],
						[
							-81.94720295799993,
							28.062571449000075
						],
						[
							-81.94719337099991,
							28.062513385000045
						],
						[
							-81.94718760299993,
							28.06245481800005
						],
						[
							-81.9471871419999,
							28.062447301000077
						],
						[
							-81.94718114299992,
							28.062342301000058
						],
						[
							-81.94718160399992,
							28.06223218200006
						],
						[
							-81.94718737199992,
							28.062173615000063
						],
						[
							-81.94719695799995,
							28.06211555100009
						],
						[
							-81.94721032199993,
							28.062058239000066
						],
						[
							-81.94722740499992,
							28.062001923000082
						],
						[
							-81.94724813499994,
							28.06194684500008
						],
						[
							-81.9472724229999,
							28.061893240000074
						],
						[
							-81.9473001639999,
							28.06184133900007
						],
						[
							-81.94730383899991,
							28.06183503400007
						],
						[
							-81.9473338379999,
							28.061784034000084
						],
						[
							-81.9473612409999,
							28.06174036300007
						],
						[
							-81.94739551999994,
							28.061692527000048
						],
						[
							-81.94743285399994,
							28.061647035000078
						],
						[
							-81.94747308299992,
							28.061604083000077
						],
						[
							-81.94751399099994,
							28.06156565200007
						],
						[
							-81.94763299099992,
							28.061460653000044
						],
						[
							-81.94763503599995,
							28.06145885400008
						],
						[
							-81.94768052699993,
							28.061421520000067
						],
						[
							-81.9477283629999,
							28.06138724100009
						],
						[
							-81.94777833899991,
							28.061356165000063
						],
						[
							-81.94783023999992,
							28.061328423000077
						],
						[
							-81.94788384399993,
							28.061304135000057
						],
						[
							-81.94793892199993,
							28.06128340500004
						],
						[
							-81.94796420699993,
							28.061275237000075
						],
						[
							-81.9480072479999,
							28.06126203100007
						],
						[
							-81.94789933499993,
							28.06107810900005
						],
						[
							-81.94789616399993,
							28.061072661000082
						],
						[
							-81.9478737419999,
							28.06103137000008
						],
						[
							-81.94766773999993,
							28.060627176000082
						],
						[
							-81.9473819769999,
							28.06009885800006
						],
						[
							-81.94736642299995,
							28.060068760000036
						],
						[
							-81.94734213499993,
							28.060015156000077
						],
						[
							-81.94733666499991,
							28.06000164300008
						],
						[
							-81.94728566599991,
							28.059872643000062
						],
						[
							-81.94727040499993,
							28.05983107800006
						],
						[
							-81.94725604599995,
							28.05978470100007
						],
						[
							-81.94713724699994,
							28.059360826000045
						],
						[
							-81.94802046099994,
							28.059179707000055
						],
						[
							-81.9532805469999,
							28.059206307000068
						],
						[
							-81.9532795259999,
							28.05959785400006
						],
						[
							-81.9532719099999,
							28.062417011000036
						],
						[
							-81.95333286099994,
							28.069742099000052
						],
						[
							-81.95330291099992,
							28.069741011000076
						],
						[
							-81.95323690999993,
							28.06974301000008
						],
						[
							-81.95127390899995,
							28.069734011000037
						],
						[
							-81.95034190899992,
							28.069739010000035
						],
						[
							-81.95033696599995,
							28.069834051000043
						],
						[
							-81.9503329399999,
							28.069958874000065
						],
						[
							-81.9503291819999,
							28.070075357000064
						],
						[
							-81.95032601799994,
							28.070173432000047
						],
						[
							-81.95032285499991,
							28.070271507000086
						],
						[
							-81.95031999999992,
							28.07036000000005
						],
						[
							-81.9503031559999,
							28.070426844000053
						],
						[
							-81.95022951099992,
							28.070455122000055
						],
						[
							-81.95014793599995,
							28.070460000000082
						],
						[
							-81.94981770299995,
							28.070460000000082
						],
						[
							-81.94937144199992,
							28.070460000000082
						],
						[
							-81.94920999999994,
							28.070460000000082
						],
						[
							-81.94920999999994,
							28.070360875000063
						],
						[
							-81.94920999999994,
							28.070182371000044
						],
						[
							-81.94920999999994,
							28.069896764000077
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Polk",
				"City": "Lakeland",
				"Name": "Lakeshore",
				"RegionID": "343442"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.25264531238926,
					28.377903860274174,
					-81.24432399986605,
					28.393635595312034
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.24442500002522,
							28.385000000316595
						],
						[
							-81.24462500025138,
							28.378088000056977
						],
						[
							-81.24676299988036,
							28.378156999640353
						],
						[
							-81.24676299988036,
							28.377903860274174
						],
						[
							-81.24867542706151,
							28.377904000568442
						],
						[
							-81.24867516266075,
							28.379288319773572
						],
						[
							-81.24969493538612,
							28.3792149440892
						],
						[
							-81.24969466738814,
							28.37976101512337
						],
						[
							-81.25067840068243,
							28.379833869200898
						],
						[
							-81.25060500791093,
							28.383876113079893
						],
						[
							-81.25122422080575,
							28.383985029970866
						],
						[
							-81.2511878863971,
							28.38518706289589
						],
						[
							-81.25264531238926,
							28.385223861354746
						],
						[
							-81.25260825672441,
							28.390577058647033
						],
						[
							-81.2505689693792,
							28.390612850764484
						],
						[
							-81.25053317726176,
							28.393635595312034
						],
						[
							-81.24437830542682,
							28.393635189717813
						],
						[
							-81.24440099981824,
							28.392611000422036
						],
						[
							-81.24442500002522,
							28.391484999778648
						],
						[
							-81.24442399997913,
							28.390380000103242
						],
						[
							-81.24435500039574,
							28.389204999899086
						],
						[
							-81.24432399986605,
							28.388676999841806
						],
						[
							-81.24442500002522,
							28.385990000086757
						],
						[
							-81.24442500002522,
							28.385000000316595
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Narcoossee Groves",
				"RegionID": "274635"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.32698699995268,
					28.138641961123355,
					-82.25974100010495,
					28.17147799986251
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.25974100010495,
							28.171462000024256
						],
						[
							-82.25993800019285,
							28.17133599961202
						],
						[
							-82.26074899980564,
							28.170804000269662
						],
						[
							-82.26514900028312,
							28.165377000115242
						],
						[
							-82.26525699986566,
							28.165243000233477
						],
						[
							-82.26593899982721,
							28.164403000183068
						],
						[
							-82.27212900007994,
							28.156765999778465
						],
						[
							-82.27276599976592,
							28.15614800006901
						],
						[
							-82.27859000023439,
							28.14889100009411
						],
						[
							-82.28178299993192,
							28.14889000004793
						],
						[
							-82.28181799974669,
							28.14888599986339
						],
						[
							-82.28218400043023,
							28.148886999909656
						],
						[
							-82.28823940904743,
							28.148901717314555
						],
						[
							-82.28876699991318,
							28.148902999747733
						],
						[
							-82.28879800044288,
							28.148742000420086
						],
						[
							-82.28824635361218,
							28.148505819569564
						],
						[
							-82.28253599956913,
							28.146061000042295
						],
						[
							-82.28233400015017,
							28.145968000252118
						],
						[
							-82.2811719996459,
							28.14546999977908
						],
						[
							-82.28206000011018,
							28.14362300007426
						],
						[
							-82.28803200020648,
							28.143433000309003
						],
						[
							-82.28820489126929,
							28.143440569902666
						],
						[
							-82.28873999956794,
							28.14346399993933
						],
						[
							-82.28875700035157,
							28.142178000014468
						],
						[
							-82.29147399969094,
							28.142132999738784
						],
						[
							-82.29146917662686,
							28.141716115414837
						],
						[
							-82.29144099996834,
							28.139280999572264
						],
						[
							-82.29120900006576,
							28.13918799978191
						],
						[
							-82.29107099999972,
							28.139108999737445
						],
						[
							-82.29243299983068,
							28.139007000431647
						],
						[
							-82.29465069827735,
							28.138641961123355
						],
						[
							-82.29464545522994,
							28.14065454579871
						],
						[
							-82.29471489638044,
							28.141363771835543
						],
						[
							-82.29552002521906,
							28.141359995582278
						],
						[
							-82.30621011869243,
							28.141309856580527
						],
						[
							-82.30709094436563,
							28.14240907541391
						],
						[
							-82.30741812311585,
							28.14293642256341
						],
						[
							-82.31220081389509,
							28.145825816539755
						],
						[
							-82.31248200041733,
							28.146710000281445
						],
						[
							-82.31248200041733,
							28.147055343538018
						],
						[
							-82.31248200041733,
							28.14718181969157
						],
						[
							-82.31248200041733,
							28.14787299993234
						],
						[
							-82.3125869998616,
							28.148508999572233
						],
						[
							-82.31263100009119,
							28.150230999810184
						],
						[
							-82.31314600044857,
							28.153411999854
						],
						[
							-82.31320100028587,
							28.1543540001094
						],
						[
							-82.31324300042328,
							28.155072999977932
						],
						[
							-82.31330999991448,
							28.156225000021294
						],
						[
							-82.31878499958384,
							28.15618299988379
						],
						[
							-82.31876599960732,
							28.156741999571395
						],
						[
							-82.31697699987808,
							28.156821999661858
						],
						[
							-82.3169739997398,
							28.157690000103607
						],
						[
							-82.3187349999769,
							28.157738999664367
						],
						[
							-82.31869800007003,
							28.158095999933003
						],
						[
							-82.32110400036174,
							28.158092999794732
						],
						[
							-82.32469000018887,
							28.158095999933003
						],
						[
							-82.32591099981552,
							28.15628299999687
						],
						[
							-82.32649599980238,
							28.156261999928162
						],
						[
							-82.32671600005105,
							28.156250000274362
						],
						[
							-82.32698699995268,
							28.16951400016044
						],
						[
							-82.32697000006834,
							28.169732000316948
						],
						[
							-82.3269409996309,
							28.17146500016262
						],
						[
							-82.32410400015593,
							28.171449000324543
						],
						[
							-82.32214599983104,
							28.17143799981737
						],
						[
							-82.31278900017993,
							28.17138400002615
						],
						[
							-82.3082980000042,
							28.17141000032531
						],
						[
							-82.3071049998696,
							28.171417999794663
						],
						[
							-82.30428999961012,
							28.171434999679008
						],
						[
							-82.30226599984012,
							28.17143899986346
						],
						[
							-82.29014000025131,
							28.17146400011653
						],
						[
							-82.28820800022558,
							28.171471000439247
						],
						[
							-82.28649699959533,
							28.171471000439247
						],
						[
							-82.26938100021094,
							28.17147799986251
						],
						[
							-82.26921199961521,
							28.17147699981642
						],
						[
							-82.25974100010495,
							28.171462000024256
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "New Tampa",
				"RegionID": "274666"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.4851181809999,
					27.92435271900007,
					-82.4583876609999,
					27.956354545000067
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.47875569799993,
							27.956324776000088
						],
						[
							-82.47884350299995,
							27.950099868000052
						],
						[
							-82.46921818499993,
							27.950100002000056
						],
						[
							-82.46841818199994,
							27.950300001000073
						],
						[
							-82.46751820399993,
							27.95060013300008
						],
						[
							-82.46558567699992,
							27.950569881000035
						],
						[
							-82.46503574099995,
							27.950561272000073
						],
						[
							-82.46485745899992,
							27.95016509000004
						],
						[
							-82.46454767599994,
							27.949712330000068
						],
						[
							-82.46404725699995,
							27.949235740000063
						],
						[
							-82.46338003099993,
							27.948759150000058
						],
						[
							-82.46280812399993,
							27.948306390000084
						],
						[
							-82.46204557999994,
							27.947567676000062
						],
						[
							-82.4609732539999,
							27.946685985000045
						],
						[
							-82.46040134599991,
							27.94611407800005
						],
						[
							-82.4598532679999,
							27.945661318000077
						],
						[
							-82.45954348499993,
							27.945351534000054
						],
						[
							-82.45932901899994,
							27.945017922000094
						],
						[
							-82.45918604199994,
							27.94468430900008
						],
						[
							-82.4590907239999,
							27.944350696000072
						],
						[
							-82.45899540599994,
							27.943659641000067
						],
						[
							-82.45894832199991,
							27.943330046000085
						],
						[
							-82.45890008899995,
							27.942992415000052
						],
						[
							-82.45870945299993,
							27.94218221300008
						],
						[
							-82.45849498699994,
							27.94139584000004
						],
						[
							-82.4583876609999,
							27.940614165000056
						],
						[
							-82.45843396399994,
							27.940641566000068
						],
						[
							-82.45845785799992,
							27.94059543900005
						],
						[
							-82.4587784069999,
							27.940517815000078
						],
						[
							-82.4589378089999,
							27.940268749000044
						],
						[
							-82.45908724799995,
							27.94010934700009
						],
						[
							-82.4593263509999,
							27.939969870000084
						],
						[
							-82.45953556699993,
							27.939870244000076
						],
						[
							-82.4598344449999,
							27.939631141000064
						],
						[
							-82.46097018499995,
							27.938535252000065
						],
						[
							-82.46143842799995,
							27.938096896000047
						],
						[
							-82.4616376809999,
							27.937947457000064
						],
						[
							-82.46185685899991,
							27.937628653000047
						],
						[
							-82.46208188799994,
							27.937231857000086
						],
						[
							-82.46216077899993,
							27.937232861000044
						],
						[
							-82.4622392849999,
							27.93724070600007
						],
						[
							-82.46231681499995,
							27.937255332000063
						],
						[
							-82.46239278399992,
							27.937276629000053
						],
						[
							-82.4632347559999,
							27.936891165000077
						],
						[
							-82.46325485099993,
							27.936882205000074
						],
						[
							-82.46388108599992,
							27.93661212300009
						],
						[
							-82.46459528299994,
							27.936290125000085
						],
						[
							-82.46485670599992,
							27.936138305000043
						],
						[
							-82.46496101799994,
							27.936070076000078
						],
						[
							-82.46532939399992,
							27.935777393000084
						],
						[
							-82.46596710299991,
							27.93515050900004
						],
						[
							-82.46606594299993,
							27.935029160000056
						],
						[
							-82.46608760599992,
							27.93495590100008
						],
						[
							-82.46609937799991,
							27.934893256000066
						],
						[
							-82.46616350199992,
							27.934200152000074
						],
						[
							-82.46617946999993,
							27.934095365000076
						],
						[
							-82.46622746999992,
							27.933870365000075
						],
						[
							-82.46625001299992,
							27.933785322000062
						],
						[
							-82.46631301299993,
							27.933587322000054
						],
						[
							-82.4663670999999,
							27.93345486900006
						],
						[
							-82.4664770999999,
							27.933236868000055
						],
						[
							-82.46650116399991,
							27.933192339000072
						],
						[
							-82.46656443899991,
							27.93309725000006
						],
						[
							-82.4666824389999,
							27.932942250000053
						],
						[
							-82.46671823399993,
							27.93289818900007
						],
						[
							-82.46684123499995,
							27.932756189000088
						],
						[
							-82.46690399199991,
							27.932690721000085
						],
						[
							-82.46706199199991,
							27.932541721000064
						],
						[
							-82.46715418799994,
							27.93246569100006
						],
						[
							-82.46738518699993,
							27.932299690000036
						],
						[
							-82.46744730299993,
							27.932258837000063
						],
						[
							-82.46765382099994,
							27.932135001000066
						],
						[
							-82.46779017699993,
							27.932069468000066
						],
						[
							-82.46810817599993,
							27.931948469000076
						],
						[
							-82.46824310099994,
							27.931908891000035
						],
						[
							-82.46848110099995,
							27.931858890000058
						],
						[
							-82.46851778099995,
							27.931851976000075
						],
						[
							-82.47122468299995,
							27.931399661000057
						],
						[
							-82.47241406799992,
							27.931189603000064
						],
						[
							-82.47245544299994,
							27.93117598200007
						],
						[
							-82.47262047499993,
							27.931095360000086
						],
						[
							-82.47265609899995,
							27.931067513000073
						],
						[
							-82.4743456999999,
							27.929481250000038
						],
						[
							-82.47567295399995,
							27.92825214900006
						],
						[
							-82.4757322079999,
							27.928201855000058
						],
						[
							-82.47579558199993,
							27.92815686600005
						],
						[
							-82.47586260399993,
							27.928117515000054
						],
						[
							-82.4759327729999,
							27.928084099000046
						],
						[
							-82.4759987729999,
							27.92805609900006
						],
						[
							-82.47604241399995,
							27.92803891400007
						],
						[
							-82.47613505299995,
							27.92801409100008
						],
						[
							-82.47643555199994,
							27.927763885000047
						],
						[
							-82.4764987879999,
							27.927715799000055
						],
						[
							-82.47712078799992,
							27.927284799000063
						],
						[
							-82.47715774499996,
							27.92726051200009
						],
						[
							-82.47785666699991,
							27.92682549300008
						],
						[
							-82.48094364799994,
							27.924958437000043
						],
						[
							-82.48194553299993,
							27.92435271900007
						],
						[
							-82.48243020799993,
							27.925110587000063
						],
						[
							-82.48260909099992,
							27.925390909000043
						],
						[
							-82.48331835199991,
							27.926499954000064
						],
						[
							-82.48316376499992,
							27.932190847000076
						],
						[
							-82.47875316499994,
							27.93740172400004
						],
						[
							-82.47756581099992,
							27.93880464500006
						],
						[
							-82.47662394899993,
							27.93998635300005
						],
						[
							-82.4772577899999,
							27.939982644000054
						],
						[
							-82.4771271809999,
							27.94136778300009
						],
						[
							-82.4767922289999,
							27.944922116000043
						],
						[
							-82.4851181809999,
							27.94493630800008
						],
						[
							-82.48499999799992,
							27.956354545000067
						],
						[
							-82.47875569799993,
							27.956324776000088
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "North Hyde Park",
				"RegionID": "274719"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.95425999999992,
					28.05503501800007,
					-81.94690869499995,
					28.059360826000045
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.94711486299991,
							28.059270971000046
						],
						[
							-81.94706694299992,
							28.05902937700006
						],
						[
							-81.94695202499992,
							28.058452784000053
						],
						[
							-81.94695195799994,
							28.05845244900007
						],
						[
							-81.94694237199991,
							28.05839438600009
						],
						[
							-81.94693980199992,
							28.05837286900004
						],
						[
							-81.94690869499995,
							28.058082728000045
						],
						[
							-81.94766699999991,
							28.057123000000047
						],
						[
							-81.94766212099995,
							28.05711996100007
						],
						[
							-81.94789244399993,
							28.056901759000084
						],
						[
							-81.9480946679999,
							28.056677066000077
						],
						[
							-81.9480939099999,
							28.05596900900008
						],
						[
							-81.94809390699993,
							28.055968594000035
						],
						[
							-81.94800337399994,
							28.055971171000067
						],
						[
							-81.94763849899994,
							28.055976101000056
						],
						[
							-81.94743226499993,
							28.055978888000084
						],
						[
							-81.94725841699994,
							28.055972955000072
						],
						[
							-81.94715999999994,
							28.055960000000084
						],
						[
							-81.9470861989999,
							28.055849396000042
						],
						[
							-81.94706999999994,
							28.055711731000088
						],
						[
							-81.94706999999994,
							28.055441991000066
						],
						[
							-81.94706999999994,
							28.05521985200005
						],
						[
							-81.94706999999994,
							28.05506650800004
						],
						[
							-81.94808789899992,
							28.055075010000053
						],
						[
							-81.95019290999994,
							28.055063011000076
						],
						[
							-81.95117990999995,
							28.05505701000004
						],
						[
							-81.95219690899995,
							28.05505000900007
						],
						[
							-81.95321690999992,
							28.055044011000064
						],
						[
							-81.95422999999994,
							28.05503501800007
						],
						[
							-81.95422999999994,
							28.055116542000064
						],
						[
							-81.95422999999994,
							28.055180850000056
						],
						[
							-81.95423488799992,
							28.055388952000044
						],
						[
							-81.95424661399994,
							28.05567428100005
						],
						[
							-81.95425658099992,
							28.055916812000078
						],
						[
							-81.95425999999992,
							28.05600000000004
						],
						[
							-81.95425999999992,
							28.05609544700008
						],
						[
							-81.95424028299993,
							28.056223656000043
						],
						[
							-81.9542078529999,
							28.05635036700005
						],
						[
							-81.95417022999993,
							28.05643709800006
						],
						[
							-81.95413167999993,
							28.056503313000064
						],
						[
							-81.95408874599991,
							28.056571140000074
						],
						[
							-81.95401726099995,
							28.05663612600006
						],
						[
							-81.95396928299994,
							28.05667982400007
						],
						[
							-81.95386800799992,
							28.056772659000046
						],
						[
							-81.95372958799993,
							28.056890412000087
						],
						[
							-81.95362240899993,
							28.056997591000084
						],
						[
							-81.95356082599994,
							28.057071008000037
						],
						[
							-81.95349247599995,
							28.05716754100007
						],
						[
							-81.95345073099992,
							28.057239647000074
						],
						[
							-81.9534099999999,
							28.057310000000086
						],
						[
							-81.9533716329999,
							28.057379061000063
						],
						[
							-81.9533291649999,
							28.05748479600004
						],
						[
							-81.9532991239999,
							28.05759768100006
						],
						[
							-81.95327259699991,
							28.05770909200004
						],
						[
							-81.95328418799994,
							28.057809473000077
						],
						[
							-81.9532805469999,
							28.059206307000068
						],
						[
							-81.94802046099994,
							28.059179707000055
						],
						[
							-81.94713724699994,
							28.059360826000045
						],
						[
							-81.94713104599992,
							28.059338701000062
						],
						[
							-81.94712832199991,
							28.059328762000064
						],
						[
							-81.94711495799993,
							28.05927144900005
						],
						[
							-81.94711486299991,
							28.059270971000046
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Polk",
				"City": "Lakeland",
				"Name": "John Cox",
				"RegionID": "343444"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.9664661249999,
					27.996670922000078,
					-81.9569609099999,
					28.004932573000076
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.9645279419999,
							28.004912820000072
						],
						[
							-81.96220079199992,
							28.004902290000075
						],
						[
							-81.96037908699992,
							28.004902290000075
						],
						[
							-81.95803087699994,
							28.004870699000037
						],
						[
							-81.95757808299993,
							28.00479698900006
						],
						[
							-81.9570082699999,
							28.004805247000036
						],
						[
							-81.9570079099999,
							28.004458010000068
						],
						[
							-81.9570007929999,
							28.003990870000052
						],
						[
							-81.95712503399994,
							28.00401613200006
						],
						[
							-81.95706591099992,
							28.003758007000044
						],
						[
							-81.95705904099992,
							28.003563876000047
						],
						[
							-81.95699077899991,
							28.00356313900005
						],
						[
							-81.95698790999995,
							28.00301101000008
						],
						[
							-81.9569839099999,
							28.001801010000065
						],
						[
							-81.95697190999994,
							28.000731010000038
						],
						[
							-81.9569609099999,
							27.999928010000076
						],
						[
							-81.95697078099994,
							27.99910187800009
						],
						[
							-81.95713504399993,
							27.999102142000083
						],
						[
							-81.95712581899994,
							27.998827007000045
						],
						[
							-81.95712990899995,
							27.998762010000064
						],
						[
							-81.95713490999992,
							27.998617009000043
						],
						[
							-81.95713190899994,
							27.99823801000008
						],
						[
							-81.95712890999994,
							27.997902010000075
						],
						[
							-81.95712490999996,
							27.997333010000094
						],
						[
							-81.95712990999994,
							27.99705600900006
						],
						[
							-81.95713292599993,
							27.996670922000078
						],
						[
							-81.95781390899992,
							27.996690010000066
						],
						[
							-81.95833490899992,
							27.996722009000052
						],
						[
							-81.95867892899992,
							27.996727090000036
						],
						[
							-81.95878789099993,
							27.996673927000078
						],
						[
							-81.95885690999997,
							27.996676009000055
						],
						[
							-81.96093490899995,
							27.996687010000073
						],
						[
							-81.96119890999996,
							27.99668801000007
						],
						[
							-81.96223890999994,
							27.99670400900004
						],
						[
							-81.9638319099999,
							27.996709010000075
						],
						[
							-81.96391990899991,
							27.99670301000009
						],
						[
							-81.96602690899994,
							27.99673300900008
						],
						[
							-81.96644217499994,
							27.996733549000055
						],
						[
							-81.9664661249999,
							27.998816504000047
						],
						[
							-81.9655715689999,
							27.998816255000065
						],
						[
							-81.96557170299991,
							27.99941257800009
						],
						[
							-81.96566375299994,
							28.004932573000076
						],
						[
							-81.9645279419999,
							28.004912820000072
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Polk",
				"City": "Lakeland",
				"Name": "Imperial",
				"RegionID": "343451"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.95705696599993,
					28.00398195100007,
					-81.94555990999993,
					28.011284063000062
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.94555990999993,
							28.011284063000062
						],
						[
							-81.94555991099992,
							28.011076010000068
						],
						[
							-81.94559491099994,
							28.01088500900005
						],
						[
							-81.94566591099995,
							28.01068101000004
						],
						[
							-81.94577890999996,
							28.010491009000077
						],
						[
							-81.94584390999995,
							28.010398009000085
						],
						[
							-81.94598290999994,
							28.01020200800008
						],
						[
							-81.9460919089999,
							28.010012009000036
						],
						[
							-81.9461589089999,
							28.00982600900005
						],
						[
							-81.94620890999994,
							28.009572009000067
						],
						[
							-81.94621690999992,
							28.00946601000004
						],
						[
							-81.94623090999994,
							28.00926000900006
						],
						[
							-81.94622538399994,
							28.008643910000046
						],
						[
							-81.94610600099992,
							28.008554373000038
						],
						[
							-81.94603399399995,
							28.008230343000037
						],
						[
							-81.94600999199992,
							28.007858309000085
						],
						[
							-81.94603399399995,
							28.00719824800007
						],
						[
							-81.94608199899994,
							28.007090238000046
						],
						[
							-81.94614200399991,
							28.00662219500009
						],
						[
							-81.94620200999992,
							28.00593813200004
						],
						[
							-81.9464180299999,
							28.005830122000077
						],
						[
							-81.94646603399991,
							28.00556609700004
						],
						[
							-81.94639402699994,
							28.005362078000076
						],
						[
							-81.94662204799994,
							28.00494204000006
						],
						[
							-81.94662204799994,
							28.004726020000078
						],
						[
							-81.9467780629999,
							28.004437993000067
						],
						[
							-81.94681406599994,
							28.00398195100007
						],
						[
							-81.94882763499993,
							28.00400536500007
						],
						[
							-81.9488400539999,
							28.004391127000076
						],
						[
							-81.94876690199993,
							28.00440499700005
						],
						[
							-81.94890749099994,
							28.007612287000086
						],
						[
							-81.9491167679999,
							28.00761674000006
						],
						[
							-81.9493394559999,
							28.00762173600009
						],
						[
							-81.94952482999992,
							28.00762637100007
						],
						[
							-81.9496645559999,
							28.00762986400008
						],
						[
							-81.95006287799993,
							28.00763140300006
						],
						[
							-81.95056365999994,
							28.00763319200007
						],
						[
							-81.95098100699994,
							28.007634682000063
						],
						[
							-81.95110163999993,
							28.00763511300005
						],
						[
							-81.95144475899991,
							28.007636338000054
						],
						[
							-81.95196408999993,
							28.007638193000048
						],
						[
							-81.95233506499994,
							28.00763951800008
						],
						[
							-81.95257618999995,
							28.007640000000038
						],
						[
							-81.9527895029999,
							28.007640000000038
						],
						[
							-81.95309556099994,
							28.007640000000038
						],
						[
							-81.9532903249999,
							28.007640000000038
						],
						[
							-81.95342010399992,
							28.007639121000068
						],
						[
							-81.95366132899996,
							28.00763488900009
						],
						[
							-81.95380967499995,
							28.007632286000046
						],
						[
							-81.95402306299991,
							28.007629097000063
						],
						[
							-81.95439399799994,
							28.00762506500007
						],
						[
							-81.95461655999992,
							28.007622646000073
						],
						[
							-81.95485999999994,
							28.007620000000088
						],
						[
							-81.95502465499993,
							28.007620000000088
						],
						[
							-81.95542345799994,
							28.007620000000088
						],
						[
							-81.95590573099992,
							28.007620000000088
						],
						[
							-81.95641572699992,
							28.007623402000036
						],
						[
							-81.95661057399991,
							28.007625721000068
						],
						[
							-81.9568240779999,
							28.007628263000072
						],
						[
							-81.95702395699993,
							28.007629620000046
						],
						[
							-81.95702638699993,
							28.00781369100008
						],
						[
							-81.95702990999992,
							28.00809101100009
						],
						[
							-81.95704390999992,
							28.009005011000056
						],
						[
							-81.95705490899991,
							28.009907010000063
						],
						[
							-81.95705696599993,
							28.011257012000044
						],
						[
							-81.95700190999992,
							28.011258010000063
						],
						[
							-81.95644290999991,
							28.011261010000055
						],
						[
							-81.95488690899992,
							28.01127001000009
						],
						[
							-81.95436690999992,
							28.011269010000035
						],
						[
							-81.95340390899992,
							28.01126700900005
						],
						[
							-81.95247390999992,
							28.011269010000035
						],
						[
							-81.95045090999992,
							28.01126700900005
						],
						[
							-81.94938590899994,
							28.011265009000056
						],
						[
							-81.94855290999993,
							28.011265009000056
						],
						[
							-81.94759390999991,
							28.01127301000008
						],
						[
							-81.94753190999995,
							28.011276010000074
						],
						[
							-81.94747090899995,
							28.01127301000008
						],
						[
							-81.94648790999992,
							28.01128201000006
						],
						[
							-81.94555990999993,
							28.011284063000062
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Polk",
				"City": "Lakeland",
				"Name": "Edgewood",
				"RegionID": "343453"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.94196171999994,
					28.025534487000073,
					-81.92699102499995,
					28.038828016000082
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.93544838699995,
							28.033948372000054
						],
						[
							-81.9337049099999,
							28.03233201000006
						],
						[
							-81.9326709099999,
							28.031385010000065
						],
						[
							-81.93180790999992,
							28.030611010000086
						],
						[
							-81.92878391099993,
							28.027845010000078
						],
						[
							-81.92849783999992,
							28.02757305600005
						],
						[
							-81.9284319809999,
							28.027398964000042
						],
						[
							-81.92714380699994,
							28.026161095000077
						],
						[
							-81.92706373599992,
							28.02598903100005
						],
						[
							-81.92706808799994,
							28.025960947000044
						],
						[
							-81.92699102499995,
							28.025889953000046
						],
						[
							-81.92707890999993,
							28.025888010000074
						],
						[
							-81.92716990999992,
							28.02588601000008
						],
						[
							-81.92732090999993,
							28.025883010000086
						],
						[
							-81.92792690999994,
							28.02586301100007
						],
						[
							-81.92848590999996,
							28.025836010000035
						],
						[
							-81.92859491099995,
							28.02583001000005
						],
						[
							-81.92902990999994,
							28.025833010000046
						],
						[
							-81.93012690899991,
							28.025839010000084
						],
						[
							-81.93047490899994,
							28.02583801100008
						],
						[
							-81.93254590999993,
							28.025835064000034
						],
						[
							-81.93395590999995,
							28.02584101000008
						],
						[
							-81.93446390999992,
							28.02584401100006
						],
						[
							-81.93505890999995,
							28.025870010000062
						],
						[
							-81.93609991099993,
							28.02587101000006
						],
						[
							-81.93738491099992,
							28.02583001000005
						],
						[
							-81.9375309109999,
							28.025834010000043
						],
						[
							-81.93802495799991,
							28.02583392200006
						],
						[
							-81.93821190199992,
							28.02584006300009
						],
						[
							-81.93906073099993,
							28.025534487000073
						],
						[
							-81.93919850599991,
							28.02578030700005
						],
						[
							-81.93921196199994,
							28.02580522800008
						],
						[
							-81.93939449999993,
							28.026156404000062
						],
						[
							-81.93952313499994,
							28.02636665500006
						],
						[
							-81.93953483599995,
							28.026386339000055
						],
						[
							-81.93956257799994,
							28.02643824000006
						],
						[
							-81.9395868659999,
							28.026491844000077
						],
						[
							-81.93959548499993,
							28.02651343900004
						],
						[
							-81.93971145099994,
							28.02681524800005
						],
						[
							-81.93989758399995,
							28.02707941600005
						],
						[
							-81.94023905299991,
							28.027431455000055
						],
						[
							-81.94040484599992,
							28.02757296500005
						],
						[
							-81.94040590299994,
							28.027573868000047
						],
						[
							-81.94079803999995,
							28.02790962000006
						],
						[
							-81.94162766799991,
							28.028376902000048
						],
						[
							-81.94176835799993,
							28.02844753700009
						],
						[
							-81.94195523699995,
							28.02849707100006
						],
						[
							-81.94196171999994,
							28.028497934000086
						],
						[
							-81.94177999999994,
							28.029381000000058
						],
						[
							-81.94179001799995,
							28.029382334000047
						],
						[
							-81.94178999999993,
							28.029725704000043
						],
						[
							-81.94179306699994,
							28.029726904000086
						],
						[
							-81.94179291899991,
							28.03263849700005
						],
						[
							-81.94074178099993,
							28.032541877000085
						],
						[
							-81.94074590999992,
							28.033509010000046
						],
						[
							-81.94075890999994,
							28.03478700900007
						],
						[
							-81.94075590999995,
							28.03678301000008
						],
						[
							-81.94075662399992,
							28.036842753000087
						],
						[
							-81.94076490899994,
							28.037483010000074
						],
						[
							-81.94076790999992,
							28.03769801100009
						],
						[
							-81.94073390999995,
							28.038324011000043
						],
						[
							-81.94072790999991,
							28.038413010000056
						],
						[
							-81.9407287439999,
							28.038492087000066
						],
						[
							-81.94078707599994,
							28.038542934000077
						],
						[
							-81.94078690999993,
							28.038688010000044
						],
						[
							-81.94078578299991,
							28.038828016000082
						],
						[
							-81.94072590999991,
							28.038774011000044
						],
						[
							-81.9406639099999,
							28.038718010000082
						],
						[
							-81.93981191099994,
							28.037948010000036
						],
						[
							-81.9387959099999,
							28.037005010000087
						],
						[
							-81.93850345499993,
							28.036742627000084
						],
						[
							-81.93830190899992,
							28.03656201000007
						],
						[
							-81.93773490899991,
							28.036054010000043
						],
						[
							-81.93675490899994,
							28.035123011000053
						],
						[
							-81.93568190999991,
							28.034165010000038
						],
						[
							-81.93544838699995,
							28.033948372000054
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Polk",
				"City": "Lakeland",
				"Name": "Lake Horney",
				"RegionID": "343458"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.36832304899997,
					28.742040653000064,
					-81.35768102599997,
					28.756241276000026
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.35874809799998,
							28.742040653000064
						],
						[
							-81.36832304899997,
							28.742040653000064
						],
						[
							-81.36653369399994,
							28.74712318200005
						],
						[
							-81.36499180299995,
							28.751596568000025
						],
						[
							-81.36333569799996,
							28.756241276000026
						],
						[
							-81.35768102599997,
							28.75621286700005
						],
						[
							-81.35772017099998,
							28.755860562000063
						],
						[
							-81.35787245599994,
							28.75519431300006
						],
						[
							-81.35857677599995,
							28.753956994000077
						],
						[
							-81.35876713299996,
							28.75325267300008
						],
						[
							-81.35876713299996,
							28.75073996200007
						],
						[
							-81.35905266899994,
							28.750092749000032
						],
						[
							-81.35933820399998,
							28.749426500000027
						],
						[
							-81.35945241799999,
							28.748379537000066
						],
						[
							-81.35950952499996,
							28.74754196700007
						],
						[
							-81.35943338199996,
							28.747028003000022
						],
						[
							-81.35924302599996,
							28.746285611000072
						],
						[
							-81.35897652599994,
							28.74546707700006
						],
						[
							-81.35882424,
							28.744762756000057
						],
						[
							-81.35871002599998,
							28.743734829000065
						],
						[
							-81.35874809799998,
							28.742040653000064
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Seminole",
				"City": "Lake Mary",
				"Name": "North Point",
				"RegionID": "274734"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.45463107428449,
					28.032843318205312,
					-82.4425234388515,
					28.05499300015407
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.44494700020444,
							28.05491099997143
						],
						[
							-82.44488248913737,
							28.054909918986347
						],
						[
							-82.44440999973234,
							28.05490199955652
						],
						[
							-82.44288200034319,
							28.054973000131454
						],
						[
							-82.4425234388515,
							28.05497645802471
						],
						[
							-82.4425499688513,
							28.047179997931636
						],
						[
							-82.4425700309272,
							28.043499973087044
						],
						[
							-82.4425800241935,
							28.042699997363695
						],
						[
							-82.44259007141925,
							28.039950011791632
						],
						[
							-82.44260987269168,
							28.036459875196257
						],
						[
							-82.44291015541802,
							28.036460138697656
						],
						[
							-82.44284953661655,
							28.032843318205312
						],
						[
							-82.45451822106102,
							28.032899945815558
						],
						[
							-82.45463107428449,
							28.033218641260966
						],
						[
							-82.4546181816039,
							28.035800000355266
						],
						[
							-82.45452290293147,
							28.054895857187066
						],
						[
							-82.45427799955647,
							28.05482799974269
						],
						[
							-82.45415600022787,
							28.05479600006627
						],
						[
							-82.45350439465295,
							28.054830746272184
						],
						[
							-82.45127857263043,
							28.054949436994946
						],
						[
							-82.45125482333431,
							28.054950703240365
						],
						[
							-82.45119300034074,
							28.05495400015493
						],
						[
							-82.4511547215978,
							28.054956893273918
						],
						[
							-82.45109007113584,
							28.054961781089133
						],
						[
							-82.4507299996824,
							28.054988999969712
						],
						[
							-82.44981699986432,
							28.05492899990186
						],
						[
							-82.44969300044365,
							28.054920000386325
						],
						[
							-82.44941900040365,
							28.05491099997143
						],
						[
							-82.44856399966189,
							28.054955000201105
						],
						[
							-82.44828287159564,
							28.054986889260853
						],
						[
							-82.44822900040734,
							28.05499300015407
						],
						[
							-82.44698999995106,
							28.054980999600893
						],
						[
							-82.44494700020444,
							28.05491099997143
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "North Tampa",
				"RegionID": "274749"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.2768279249999,
					28.414404995000044,
					-81.24968476399994,
					28.429075156000067
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.24968476399994,
							28.423382631000038
						],
						[
							-81.25176380999994,
							28.421375431000058
						],
						[
							-81.25270326599991,
							28.42145372300007
						],
						[
							-81.25348549099994,
							28.421767363000075
						],
						[
							-81.25356473199992,
							28.42160994900007
						],
						[
							-81.25317288299993,
							28.42090592900007
						],
						[
							-81.25317279699993,
							28.420122657000036
						],
						[
							-81.25387700899995,
							28.419654051000066
						],
						[
							-81.25442479599991,
							28.41941857100005
						],
						[
							-81.25544132399995,
							28.419418704000066
						],
						[
							-81.2563807379999,
							28.419654001000083
						],
						[
							-81.25724197099993,
							28.420122917000075
						],
						[
							-81.2579460419999,
							28.41996651500006
						],
						[
							-81.2588854999999,
							28.419653874000062
						],
						[
							-81.25912069099991,
							28.42004580200006
						],
						[
							-81.26037264199994,
							28.419966516000045
						],
						[
							-81.26146826399992,
							28.41996651500006
						],
						[
							-81.26271912899995,
							28.419888451000077
						],
						[
							-81.26350228099994,
							28.419654051000066
						],
						[
							-81.2642062999999,
							28.419340455000054
						],
						[
							-81.26538106899994,
							28.41926247200007
						],
						[
							-81.2663987009999,
							28.41926232600008
						],
						[
							-81.26647657199993,
							28.41988854500005
						],
						[
							-81.2677285499999,
							28.419809282000074
						],
						[
							-81.26874605899991,
							28.419809281000084
						],
						[
							-81.26952828499992,
							28.419809454000074
						],
						[
							-81.2698418569999,
							28.41949688400007
						],
						[
							-81.26984152699993,
							28.418322972000055
						],
						[
							-81.27226744599994,
							28.417306659000076
						],
						[
							-81.27211205099991,
							28.416523408000046
						],
						[
							-81.27190290599992,
							28.415896445000044
						],
						[
							-81.27170652299992,
							28.41501380300008
						],
						[
							-81.27201203099993,
							28.414978592000068
						],
						[
							-81.27203669999994,
							28.414976093000064
						],
						[
							-81.27390798999994,
							28.414812545000075
						],
						[
							-81.27407831099993,
							28.414759441000058
						],
						[
							-81.27411323799993,
							28.414749321000045
						],
						[
							-81.27417055099994,
							28.41473595800005
						],
						[
							-81.27422861499991,
							28.414726372000075
						],
						[
							-81.2742745999999,
							28.41472151700009
						],
						[
							-81.27459511099994,
							28.41469599000004
						],
						[
							-81.2755246989999,
							28.414583223000083
						],
						[
							-81.27556117599994,
							28.414579551000088
						],
						[
							-81.27614309299992,
							28.414532928000085
						],
						[
							-81.27644743099997,
							28.41444387200005
						],
						[
							-81.27646723899994,
							28.41443832100009
						],
						[
							-81.27649272199994,
							28.41443189100005
						],
						[
							-81.27660627199992,
							28.414404995000044
						],
						[
							-81.2768279249999,
							28.41527670000005
						],
						[
							-81.27675806999991,
							28.421963607000066
						],
						[
							-81.2684374669999,
							28.421963344000062
						],
						[
							-81.26858895899994,
							28.429075156000067
						],
						[
							-81.2562715599999,
							28.42894894400007
						],
						[
							-81.25573776699991,
							28.428305882000075
						],
						[
							-81.25503171999992,
							28.42760884900008
						],
						[
							-81.25489050899995,
							28.427474651000068
						],
						[
							-81.2523827899999,
							28.425514744000054
						],
						[
							-81.25001527899991,
							28.42364296800008
						],
						[
							-81.24980897399992,
							28.42348373200008
						],
						[
							-81.24968476399994,
							28.423382631000038
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Northlake Park at Lake Nona",
				"RegionID": "274785"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.81080028699996,
					26.129101320000032,
					-81.78662165099986,
					26.157545837000136
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.79704994999993,
							26.15727001600014
						],
						[
							-81.7969099999999,
							26.156459999000177
						],
						[
							-81.79640999999991,
							26.153769999000183
						],
						[
							-81.79624298499995,
							26.152850742000062
						],
						[
							-81.79619979299993,
							26.152462691000018
						],
						[
							-81.79614309599994,
							26.152025310000155
						],
						[
							-81.79610999999996,
							26.15177000000017
						],
						[
							-81.7960124349998,
							26.151155914000164
						],
						[
							-81.79593999999993,
							26.1507000000001
						],
						[
							-81.79584366099995,
							26.149987090000092
						],
						[
							-81.79578999999985,
							26.149590000000096
						],
						[
							-81.79570651799988,
							26.148977795000157
						],
						[
							-81.79563999999989,
							26.14849000000003
						],
						[
							-81.79555239699992,
							26.14789555100014
						],
						[
							-81.79550461699996,
							26.147571328000048
						],
						[
							-81.79547999999988,
							26.147370000000087
						],
						[
							-81.79539094299979,
							26.14675216800013
						],
						[
							-81.79531999999998,
							26.146260000000083
						],
						[
							-81.79527318799991,
							26.14594987300009
						],
						[
							-81.79523999999992,
							26.14573000000011
						],
						[
							-81.79511288199988,
							26.144845468000106
						],
						[
							-81.79504043599992,
							26.144341367000052
						],
						[
							-81.79499999999986,
							26.14406000000013
						],
						[
							-81.79490879599977,
							26.143403332000155
						],
						[
							-81.79484999999988,
							26.142980000000122
						],
						[
							-81.79482057799994,
							26.142734820000086
						],
						[
							-81.79478999999989,
							26.14248000000014
						],
						[
							-81.79475794299991,
							26.142119144000127
						],
						[
							-81.79475467099991,
							26.14197975800014
						],
						[
							-81.79477999999996,
							26.141870000000118
						],
						[
							-81.79452716199991,
							26.14193788900014
						],
						[
							-81.79404389099989,
							26.14199273300006
						],
						[
							-81.79364863699988,
							26.142040164000164
						],
						[
							-81.7933999999999,
							26.142070000000146
						],
						[
							-81.79291995099989,
							26.14213085100012
						],
						[
							-81.79238928699995,
							26.142198119000177
						],
						[
							-81.7920055179999,
							26.142246765000117
						],
						[
							-81.79166069799989,
							26.14228080400018
						],
						[
							-81.79140584399994,
							26.142291553000092
						],
						[
							-81.79113350199987,
							26.142295675000078
						],
						[
							-81.79090788399985,
							26.142277543000176
						],
						[
							-81.79083999999992,
							26.142270000000174
						],
						[
							-81.79065999999995,
							26.14224000000018
						],
						[
							-81.7904222219999,
							26.14220195600005
						],
						[
							-81.79026481999993,
							26.142167217000107
						],
						[
							-81.79010122299991,
							26.14212153900006
						],
						[
							-81.79010099999988,
							26.142127000000066
						],
						[
							-81.78943171599992,
							26.141840858000194
						],
						[
							-81.78928240599993,
							26.141766203000145
						],
						[
							-81.7889085569999,
							26.14156751900005
						],
						[
							-81.7885737269999,
							26.141387854000193
						],
						[
							-81.7882719469999,
							26.14122592300003
						],
						[
							-81.78799999999977,
							26.141080000000123
						],
						[
							-81.78756404299985,
							26.1408467250001
						],
						[
							-81.78717151799988,
							26.14063668900013
						],
						[
							-81.78696596799993,
							26.140526702000173
						],
						[
							-81.78686285449987,
							26.14047249600013
						],
						[
							-81.78662165099986,
							26.14035574800006
						],
						[
							-81.7867660669999,
							26.140040312000075
						],
						[
							-81.78692568599988,
							26.13983888800011
						],
						[
							-81.78723732199991,
							26.13951965100007
						],
						[
							-81.7875109539999,
							26.139208015000044
						],
						[
							-81.78777318399993,
							26.138877377000046
						],
						[
							-81.7878263899999,
							26.138668352000067
						],
						[
							-81.78795940599979,
							26.138383319000198
						],
						[
							-81.78807738299987,
							26.13794941700018
						],
						[
							-81.78834095799992,
							26.137520167000012
						],
						[
							-81.78891798299988,
							26.136953913000056
						],
						[
							-81.78902731099969,
							26.13696259000033
						],
						[
							-81.78908947199977,
							26.13696768400004
						],
						[
							-81.78917216599977,
							26.13697834100048
						],
						[
							-81.78929931499981,
							26.13701047000003
						],
						[
							-81.78942253999979,
							26.137051373000126
						],
						[
							-81.78942117599976,
							26.136979107000187
						],
						[
							-81.78942612499974,
							26.13690699800017
						],
						[
							-81.78943734899968,
							26.136835597000037
						],
						[
							-81.78947034899976,
							26.136671596000056
						],
						[
							-81.78950691299984,
							26.1365414140003
						],
						[
							-81.78952079199983,
							26.136505671000094
						],
						[
							-81.7895397919999,
							26.136459672000107
						],
						[
							-81.78957040799968,
							26.136393327000036
						],
						[
							-81.78960630799972,
							26.136329686000188
						],
						[
							-81.78964725599974,
							26.136269170000155
						],
						[
							-81.7896929819998,
							26.136212177000147
						],
						[
							-81.78974318299986,
							26.136159085000195
						],
						[
							-81.7897831829997,
							26.13612008500052
						],
						[
							-81.7898329269999,
							26.136075080000083
						],
						[
							-81.78994830399995,
							26.135992837000117
						],
						[
							-81.79001982199973,
							26.135950001000303
						],
						[
							-81.79016841399987,
							26.1358799140001
						],
						[
							-81.79029791599974,
							26.13584348700002
						],
						[
							-81.79039691599976,
							26.135823487000316
						],
						[
							-81.79051039499983,
							26.135808002000367
						],
						[
							-81.79070581299992,
							26.13579392700018
						],
						[
							-81.79075919099982,
							26.135723087000535
						],
						[
							-81.79090519099981,
							26.1355550860004
						],
						[
							-81.7909502739999,
							26.135506899000056
						],
						[
							-81.7910627949997,
							26.1353936350001
						],
						[
							-81.79108572999982,
							26.135358974000162
						],
						[
							-81.79112571399985,
							26.13528988600013
						],
						[
							-81.79115575099968,
							26.135224003000097
						],
						[
							-81.79119108899977,
							26.13516080600011
						],
						[
							-81.79123149099973,
							26.1351007190002
						],
						[
							-81.79129107899976,
							26.1350179270001
						],
						[
							-81.7913505369998,
							26.134956513000525
						],
						[
							-81.79140786499974,
							26.134900281000135
						],
						[
							-81.79149567399973,
							26.13482017600017
						],
						[
							-81.79157367399988,
							26.134760176
						],
						[
							-81.79167233899987,
							26.13469416500049
						],
						[
							-81.79176300499982,
							26.13464843800017
						],
						[
							-81.79191394799987,
							26.13458286400043
						],
						[
							-81.79179390899981,
							26.13443873800005
						],
						[
							-81.79165173499976,
							26.134275682000062
						],
						[
							-81.79155301999985,
							26.134135125000064
						],
						[
							-81.79146887599983,
							26.133984589000043
						],
						[
							-81.7914363719998,
							26.13392051900007
						],
						[
							-81.79140908499994,
							26.13385405800017
						],
						[
							-81.79138719099991,
							26.1337856310001
						],
						[
							-81.7913708289998,
							26.133715675000353
						],
						[
							-81.79136010399979,
							26.13364463600007
						],
						[
							-81.7913441039997,
							26.133499636000153
						],
						[
							-81.7913386779997,
							26.133401000000163
						],
						[
							-81.79135234099986,
							26.13324483400003
						],
						[
							-81.79139291399986,
							26.133093414000115
						],
						[
							-81.79145916499964,
							26.132951339000172
						],
						[
							-81.7915490799998,
							26.132822927000028
						],
						[
							-81.7915682419997,
							26.132800830000065
						],
						[
							-81.79163724099982,
							26.13272383000009
						],
						[
							-81.79168988999982,
							26.13266981700015
						],
						[
							-81.79174687899982,
							26.132620406000058
						],
						[
							-81.79180780899979,
							26.13257594400011
						],
						[
							-81.7918722499998,
							26.132536744000063
						],
						[
							-81.79193974899988,
							26.132503082000476
						],
						[
							-81.79201574899969,
							26.132469082000505
						],
						[
							-81.79214518499974,
							26.13242269200022
						],
						[
							-81.79226918599987,
							26.13238869100016
						],
						[
							-81.79235083399988,
							26.13237034000015
						],
						[
							-81.79250699999983,
							26.13235667800009
						],
						[
							-81.79265699999972,
							26.13235667800009
						],
						[
							-81.79273751699981,
							26.132360289000296
						],
						[
							-81.7929155169997,
							26.13237629000011
						],
						[
							-81.79299116599974,
							26.132386341000142
						],
						[
							-81.79305477099976,
							26.132401377000143
						],
						[
							-81.7930497349997,
							26.131953104000267
						],
						[
							-81.7930543929999,
							26.131851035000082
						],
						[
							-81.79306539199966,
							26.13174403500011
						],
						[
							-81.79307489599965,
							26.131676717000225
						],
						[
							-81.79308945699988,
							26.13161030900006
						],
						[
							-81.7931089939999,
							26.13154519200009
						],
						[
							-81.7931333939997,
							26.131481736000346
						],
						[
							-81.79315439399974,
							26.1314327360002
						],
						[
							-81.79318529599982,
							26.13136791200017
						],
						[
							-81.79322127099987,
							26.131305760000174
						],
						[
							-81.79326209099978,
							26.131246676000437
						],
						[
							-81.7933074939998,
							26.131191038000274
						],
						[
							-81.79335719299974,
							26.13113920000007
						],
						[
							-81.79338419299975,
							26.131113200000406
						],
						[
							-81.79344045199979,
							26.131063383000104
						],
						[
							-81.7935006729998,
							26.13101843700047
						],
						[
							-81.79356443699974,
							26.130978675000023
						],
						[
							-81.79363129699986,
							26.130944376000116
						],
						[
							-81.79370078699984,
							26.13091577800006
						],
						[
							-81.79377242299981,
							26.1308930810004
						],
						[
							-81.79391789799986,
							26.13085110200004
						],
						[
							-81.79482713999995,
							26.13079256700008
						],
						[
							-81.79607465599987,
							26.130701201000157
						],
						[
							-81.79600984999985,
							26.130169884000164
						],
						[
							-81.79609177299996,
							26.130162870000113
						],
						[
							-81.79740999899987,
							26.1300499990001
						],
						[
							-81.79879999999986,
							26.12992999900012
						],
						[
							-81.7998081469998,
							26.129850788000052
						],
						[
							-81.8001999989998,
							26.129820000000166
						],
						[
							-81.80052602899985,
							26.12979225200018
						],
						[
							-81.80160999899992,
							26.129699999000096
						],
						[
							-81.8029599989999,
							26.129579999000114
						],
						[
							-81.80446999899995,
							26.129459999000133
						],
						[
							-81.80536595699994,
							26.129382465000113
						],
						[
							-81.80598807099989,
							26.129240293000073
						],
						[
							-81.80687727499992,
							26.129101320000032
						],
						[
							-81.80691334599979,
							26.129285089000227
						],
						[
							-81.80692574199983,
							26.12934771600017
						],
						[
							-81.80717287399978,
							26.13024260500005
						],
						[
							-81.8071828889998,
							26.13028238500032
						],
						[
							-81.80725394099981,
							26.1305945060003
						],
						[
							-81.80730042899975,
							26.13072054200007
						],
						[
							-81.80755453099982,
							26.13106750500009
						],
						[
							-81.80756646199983,
							26.131083412000073
						],
						[
							-81.80762583599994,
							26.13117333900032
						],
						[
							-81.80768333499972,
							26.131292357000397
						],
						[
							-81.80773433399986,
							26.131421357000413
						],
						[
							-81.80774308599979,
							26.13144441300001
						],
						[
							-81.80778466799968,
							26.131601792000154
						],
						[
							-81.80781167799987,
							26.131767751000123
						],
						[
							-81.8078192109997,
							26.13182611100015
						],
						[
							-81.8078452119997,
							26.132097111000196
						],
						[
							-81.80784861799972,
							26.13214741100009
						],
						[
							-81.8078688919998,
							26.132661833000377
						],
						[
							-81.80788915799981,
							26.133744815000277
						],
						[
							-81.80789214199979,
							26.13389701200017
						],
						[
							-81.80789334099978,
							26.133955762000056
						],
						[
							-81.8079846929998,
							26.13480743100009
						],
						[
							-81.80811314599985,
							26.13589778000016
						],
						[
							-81.80811571899972,
							26.135922580000077
						],
						[
							-81.80817150199981,
							26.136543884000325
						],
						[
							-81.80827092799967,
							26.137226350000127
						],
						[
							-81.8082753489997,
							26.137261548000197
						],
						[
							-81.80830734799984,
							26.137564549000132
						],
						[
							-81.80831096799989,
							26.137609662000045
						],
						[
							-81.80833980099986,
							26.13813443900039
						],
						[
							-81.80838145999985,
							26.138540837999997
						],
						[
							-81.80844064199978,
							26.139001549000014
						],
						[
							-81.80845272799979,
							26.139060072000152
						],
						[
							-81.80867766399966,
							26.140148764000166
						],
						[
							-81.80889727299972,
							26.14120839800009
						],
						[
							-81.80914935099979,
							26.142234434000073
						],
						[
							-81.80917121699973,
							26.14236316400007
						],
						[
							-81.80917797799985,
							26.14243375300031
						],
						[
							-81.80920074099969,
							26.142658343000065
						],
						[
							-81.8092042569998,
							26.142705253000216
						],
						[
							-81.80923322999989,
							26.143300148000144
						],
						[
							-81.80925724499974,
							26.143550464000075
						],
						[
							-81.80936127499983,
							26.144643774000116
						],
						[
							-81.80942727099988,
							26.145336736000075
						],
						[
							-81.8094306649998,
							26.145387626000023
						],
						[
							-81.80944361899981,
							26.145726288000155
						],
						[
							-81.80945669799974,
							26.145857945000127
						],
						[
							-81.80947851199994,
							26.14606730700004
						],
						[
							-81.80958873099974,
							26.14671903900014
						],
						[
							-81.80959976999985,
							26.14681618800045
						],
						[
							-81.8096033949997,
							26.146877805000308
						],
						[
							-81.80968666499984,
							26.14801682900005
						],
						[
							-81.80970630699979,
							26.148258779000173
						],
						[
							-81.8097687999998,
							26.14870948500016
						],
						[
							-81.80977319299971,
							26.14874692300006
						],
						[
							-81.8097977869998,
							26.14900269900044
						],
						[
							-81.80980954399979,
							26.149113937000052
						],
						[
							-81.80993254099984,
							26.150115776000078
						],
						[
							-81.8100724099997,
							26.151242392000213
						],
						[
							-81.81019037499986,
							26.152359799000035
						],
						[
							-81.81028278199979,
							26.15323861200018
						],
						[
							-81.8102915979998,
							26.153277327000097
						],
						[
							-81.81056709799985,
							26.154371396000116
						],
						[
							-81.81057396199981,
							26.154400721000144
						],
						[
							-81.8107499619998,
							26.155213720000177
						],
						[
							-81.81075940399987,
							26.15526429100001
						],
						[
							-81.8107984039999,
							26.1555122910001
						],
						[
							-81.81080028699996,
							26.15552540500012
						],
						[
							-81.80990999999993,
							26.155652000000202
						],
						[
							-81.8099085209999,
							26.155642592000135
						],
						[
							-81.80954523799996,
							26.1557044280001
						],
						[
							-81.80896643399986,
							26.15580294700017
						],
						[
							-81.80873656499992,
							26.15584207400012
						],
						[
							-81.80850747299988,
							26.15588106800015
						],
						[
							-81.80832246999994,
							26.15591255800009
						],
						[
							-81.8082199999999,
							26.155930000000115
						],
						[
							-81.80815400299986,
							26.155930000000115
						],
						[
							-81.80804128399986,
							26.155930000000115
						],
						[
							-81.80790999999992,
							26.155930000000115
						],
						[
							-81.80788404399982,
							26.15592642000017
						],
						[
							-81.80784074799988,
							26.155920448000032
						],
						[
							-81.80778870199993,
							26.15591326900006
						],
						[
							-81.80769376199989,
							26.15590017400013
						],
						[
							-81.80762818999996,
							26.155891130000093
						],
						[
							-81.80757639399985,
							26.155890000000177
						],
						[
							-81.80752394099996,
							26.155890000000177
						],
						[
							-81.80748723199993,
							26.155890000000177
						],
						[
							-81.80745453899989,
							26.155890000000177
						],
						[
							-81.8073462149999,
							26.155890582000048
						],
						[
							-81.80731070499989,
							26.155896045000055
						],
						[
							-81.80726849399987,
							26.15590253900006
						],
						[
							-81.80721968599991,
							26.15591006000006
						],
						[
							-81.80714839599996,
							26.15592363900003
						],
						[
							-81.80708741599989,
							26.155935254000013
						],
						[
							-81.80704876599981,
							26.15594261600009
						],
						[
							-81.80700871699986,
							26.155950461000117
						],
						[
							-81.8069918749999,
							26.155956514000174
						],
						[
							-81.80696272399987,
							26.155966990000152
						],
						[
							-81.80694445599988,
							26.155973555000074
						],
						[
							-81.8069285599999,
							26.15597926700019
						],
						[
							-81.8068910319999,
							26.155992754000152
						],
						[
							-81.80686892599994,
							26.1560006980001
						],
						[
							-81.80680128699993,
							26.156025006000156
						],
						[
							-81.80670566699983,
							26.156059370000158
						],
						[
							-81.80659871399978,
							26.15609780600014
						],
						[
							-81.80643102399993,
							26.156158070000153
						],
						[
							-81.80630907399988,
							26.156198747000055
						],
						[
							-81.80618947899985,
							26.15623554500008
						],
						[
							-81.80600388699986,
							26.156276978000044
						],
						[
							-81.80580196199993,
							26.15630829100006
						],
						[
							-81.80564709199992,
							26.156322804000105
						],
						[
							-81.80545999999988,
							26.156330000000168
						],
						[
							-81.80532715499992,
							26.156333907000047
						],
						[
							-81.8051993019999,
							26.15633766800009
						],
						[
							-81.80493061299987,
							26.15633689500012
						],
						[
							-81.80461057899987,
							26.156331649000037
						],
						[
							-81.80443583699979,
							26.156335705000018
						],
						[
							-81.80438109899988,
							26.15633991500001
						],
						[
							-81.8042783089999,
							26.156347822000043
						],
						[
							-81.8041956869999,
							26.15635472300017
						],
						[
							-81.80413250699992,
							26.156360217000092
						],
						[
							-81.80408709999989,
							26.156364165000063
						],
						[
							-81.80405936299991,
							26.156366577000085
						],
						[
							-81.80402764499986,
							26.156369335000136
						],
						[
							-81.80401794099994,
							26.15637045800014
						],
						[
							-81.80400339299989,
							26.156373690000052
						],
						[
							-81.80398243599984,
							26.156378348000082
						],
						[
							-81.80394497499985,
							26.15638667200006
						],
						[
							-81.80391417299988,
							26.156393517000183
						],
						[
							-81.8038939279999,
							26.15639801600011
						],
						[
							-81.80386523899992,
							26.156404391000194
						],
						[
							-81.80381537899989,
							26.156415471000045
						],
						[
							-81.80375950299988,
							26.156427888000096
						],
						[
							-81.80370414899991,
							26.156442227000127
						],
						[
							-81.80365191299985,
							26.156456157000036
						],
						[
							-81.80360125999992,
							26.156469664000003
						],
						[
							-81.80352450699988,
							26.15649402100015
						],
						[
							-81.80346703499993,
							26.156512307000064
						],
						[
							-81.80340287099995,
							26.156532723000154
						],
						[
							-81.80326527499993,
							26.15658142800001
						],
						[
							-81.80314767799987,
							26.15662389400015
						],
						[
							-81.80298681199989,
							26.15667948200013
						],
						[
							-81.80288234099986,
							26.156709331000023
						],
						[
							-81.80273951599986,
							26.156740844000055
						],
						[
							-81.80254260799991,
							26.156760000000045
						],
						[
							-81.80238440899987,
							26.156760000000045
						],
						[
							-81.80217347599984,
							26.156760000000045
						],
						[
							-81.80194907399992,
							26.156769244000095
						],
						[
							-81.80174484599989,
							26.156800041000068
						],
						[
							-81.8015902639999,
							26.156837086000024
						],
						[
							-81.80139912799989,
							26.156900336000106
						],
						[
							-81.80122774499984,
							26.156966252000053
						],
						[
							-81.80107933099981,
							26.157023334000158
						],
						[
							-81.80093283099986,
							26.15707057800016
						],
						[
							-81.80073508199992,
							26.15712331200008
						],
						[
							-81.80057811499991,
							26.157153979000043
						],
						[
							-81.80034043499978,
							26.157190395000036
						],
						[
							-81.80017093299996,
							26.157209006000066
						],
						[
							-81.79989999999992,
							26.15721000000015
						],
						[
							-81.79974776699994,
							26.157207015000168
						],
						[
							-81.79956301299984,
							26.157203392000135
						],
						[
							-81.79941805299984,
							26.157200550000077
						],
						[
							-81.7992995659999,
							26.15720822100009
						],
						[
							-81.79912936399994,
							26.15722752500009
						],
						[
							-81.79898443499985,
							26.15725436400009
						],
						[
							-81.79884274399984,
							26.157288218000048
						],
						[
							-81.79871976599979,
							26.157327347
						],
						[
							-81.79856087399979,
							26.157377904000008
						],
						[
							-81.79839811999992,
							26.157428564000114
						],
						[
							-81.79828926699979,
							26.15746122000015
						],
						[
							-81.79821730799996,
							26.157475692000105
						],
						[
							-81.79810999999997,
							26.157490000000045
						],
						[
							-81.7980211559999,
							26.157493920000014
						],
						[
							-81.79786210299989,
							26.15750093700015
						],
						[
							-81.7976378419999,
							26.15751083100008
						],
						[
							-81.79742711199987,
							26.157520289000153
						],
						[
							-81.7972299999999,
							26.157540000000097
						],
						[
							-81.79710516299987,
							26.157545837000136
						],
						[
							-81.79704994999993,
							26.15727001600014
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Collier",
				"City": "Naples",
				"Name": "Old Naples",
				"RegionID": "274885"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.48499999799992,
					27.95620000100007,
					-82.46402342699992,
					27.974403678000044
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.4812472459999,
							27.97428523700006
						],
						[
							-82.48144277999995,
							27.973780108000085
						],
						[
							-82.48168107499993,
							27.97285075800005
						],
						[
							-82.48168107499993,
							27.972278851000056
						],
						[
							-82.48144277999995,
							27.97154013700009
						],
						[
							-82.48091853099993,
							27.970539298000062
						],
						[
							-82.48056108899993,
							27.969943561000036
						],
						[
							-82.48020364699994,
							27.96975292500008
						],
						[
							-82.47967939799992,
							27.969609948000084
						],
						[
							-82.4792742969999,
							27.969538460000084
						],
						[
							-82.4787977069999,
							27.969490801000063
						],
						[
							-82.47827345899994,
							27.969371654000042
						],
						[
							-82.47779686899992,
							27.96925250600009
						],
						[
							-82.47727261999995,
							27.969038041000093
						],
						[
							-82.47689134799992,
							27.968799746000062
						],
						[
							-82.47643858799995,
							27.968394645000046
						],
						[
							-82.4760096579999,
							27.967822737000063
						],
						[
							-82.4752471139999,
							27.966893387000088
						],
						[
							-82.47496413499994,
							27.96654673800009
						],
						[
							-82.47429393499993,
							27.965725743000064
						],
						[
							-82.4738411749999,
							27.964987029000042
						],
						[
							-82.47326926699992,
							27.964010020000046
						],
						[
							-82.47262587099993,
							27.963295135000067
						],
						[
							-82.4715535439999,
							27.96231812700006
						],
						[
							-82.47093397799995,
							27.961722389000045
						],
						[
							-82.47031441099995,
							27.96110282300009
						],
						[
							-82.4696710149999,
							27.960673892000045
						],
						[
							-82.46881315399992,
							27.96043559700007
						],
						[
							-82.46805184899995,
							27.96024991300004
						],
						[
							-82.46783614499992,
							27.96019730200004
						],
						[
							-82.4670259419999,
							27.960125814000037
						],
						[
							-82.46645403499991,
							27.959959008000055
						],
						[
							-82.46614425099995,
							27.959911349000038
						],
						[
							-82.46559617299994,
							27.959887519000063
						],
						[
							-82.46504809499993,
							27.959959008000055
						],
						[
							-82.46461916499993,
							27.959887519000063
						],
						[
							-82.46426172199995,
							27.95960156500007
						],
						[
							-82.46407108599993,
							27.95926795300005
						],
						[
							-82.46402342699992,
							27.95876753300007
						],
						[
							-82.46411874499995,
							27.958076478000066
						],
						[
							-82.46426172199995,
							27.957361594000076
						],
						[
							-82.4644017139999,
							27.956661636000035
						],
						[
							-82.46489778099993,
							27.95660614700006
						],
						[
							-82.46495587999993,
							27.956599444000062
						],
						[
							-82.46841818199994,
							27.95620000100007
						],
						[
							-82.47054420899991,
							27.95628550200007
						],
						[
							-82.47875569799993,
							27.956324776000088
						],
						[
							-82.48499999799992,
							27.956354545000067
						],
						[
							-82.48489090899994,
							27.96680000100008
						],
						[
							-82.48495195999993,
							27.973333770000067
						],
						[
							-82.48482014699994,
							27.97399037300005
						],
						[
							-82.48292364799994,
							27.973978056000078
						],
						[
							-82.48172619199994,
							27.974403678000044
						],
						[
							-82.4812472459999,
							27.97428523700006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Old West Tampa",
				"RegionID": "274902"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.37372675058683,
					28.553135959085317,
					-81.36443697345875,
					28.564066222801927
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.36443697345875,
							28.55322414390556
						],
						[
							-81.36443798879331,
							28.55315403995474
						],
						[
							-81.36548853272116,
							28.553165054850936
						],
						[
							-81.36651004743318,
							28.553188090085364
						],
						[
							-81.3678540401392,
							28.553194099355245
						],
						[
							-81.36860515479741,
							28.55319510030062
						],
						[
							-81.37058709417535,
							28.553191093821027
						],
						[
							-81.37106380140078,
							28.55318107897083
						],
						[
							-81.3713191800788,
							28.553186087295252
						],
						[
							-81.37275330643585,
							28.553147028840115
						],
						[
							-81.37372675058683,
							28.553135959085317
						],
						[
							-81.37370972462219,
							28.556795439817453
						],
						[
							-81.37371473204723,
							28.557578601816168
						],
						[
							-81.37370972462219,
							28.558429864076224
						],
						[
							-81.37371273105569,
							28.559294144921964
						],
						[
							-81.37371373200115,
							28.55975182429183
						],
						[
							-81.37372268924854,
							28.560516900025263
						],
						[
							-81.37372274500653,
							28.56057704848117
						],
						[
							-81.37372592231124,
							28.56086153551528
						],
						[
							-81.37319396074037,
							28.561413291164
						],
						[
							-81.37288950965655,
							28.5619160346615
						],
						[
							-81.37260108269255,
							28.56257100729816
						],
						[
							-81.37247889990235,
							28.56334915917372
						],
						[
							-81.37243593209446,
							28.564066222801927
						],
						[
							-81.37211435971774,
							28.56406522095719
						],
						[
							-81.37177285296899,
							28.564064220011815
						],
						[
							-81.37133420235396,
							28.564063218167078
						],
						[
							-81.37071027611235,
							28.56406221722162
						],
						[
							-81.3699731836833,
							28.564059212586763
						],
						[
							-81.3692701413849,
							28.564058210742026
						],
						[
							-81.36833875942453,
							28.56405720889728
						],
						[
							-81.36727017599611,
							28.56405420516171
						],
						[
							-81.36621761398968,
							28.564050199581406
						],
						[
							-81.36566479444302,
							28.56404819589192
						],
						[
							-81.36507291644128,
							28.564044190311606
						],
						[
							-81.36451208483462,
							28.56404218752141
						],
						[
							-81.36444292337326,
							28.56404019012716
						],
						[
							-81.36443797440411,
							28.563129834315887
						],
						[
							-81.36445299667936,
							28.562275567420976
						],
						[
							-81.36445299667936,
							28.562158393854396
						],
						[
							-81.36445499946947,
							28.56129711674432
						],
						[
							-81.36444899199833,
							28.560416809979948
						],
						[
							-81.36444298272853,
							28.559954124084392
						],
						[
							-81.3644519957339,
							28.559495444668435
						],
						[
							-81.3644600077939,
							28.558592104468282
						],
						[
							-81.36445700315895,
							28.55677741380672
						],
						[
							-81.3644539985241,
							28.556223591515938
						],
						[
							-81.36444498551865,
							28.55529020766484
						],
						[
							-81.36444498551865,
							28.554987759371137
						],
						[
							-81.36444799015358,
							28.554215614067267
						],
						[
							-81.36443697345875,
							28.55322414390556
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Park Lake-Highland",
				"RegionID": "274967"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.1126185949999,
					26.09383947400005,
					-80.1090930819999,
					26.09767442900005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.10957028299993,
							26.093863711000044
						],
						[
							-80.11239529499994,
							26.09383947400005
						],
						[
							-80.11250960099994,
							26.094737841000043
						],
						[
							-80.1126185949999,
							26.095594461000076
						],
						[
							-80.11104298899994,
							26.095621253000047
						],
						[
							-80.11105527099994,
							26.097038613000052
						],
						[
							-80.1094396119999,
							26.097063390000073
						],
						[
							-80.10943682499993,
							26.09767442900005
						],
						[
							-80.1090930819999,
							26.09761946900005
						],
						[
							-80.10911352199992,
							26.09479226800005
						],
						[
							-80.1091200379999,
							26.093890985000087
						],
						[
							-80.10952144399994,
							26.09386545800004
						],
						[
							-80.10957028299993,
							26.093863711000044
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Breakwater Surf",
				"RegionID": "273021"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.7479249029999,
					30.259541815000038,
					-81.7305616779999,
					30.28466415200006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.74353003499994,
							30.28206988100004
						],
						[
							-81.7433399059999,
							30.282066008000076
						],
						[
							-81.7425539059999,
							30.282076008000043
						],
						[
							-81.7406199639999,
							30.282087008000076
						],
						[
							-81.74068399999993,
							30.28195500000004
						],
						[
							-81.74081890499991,
							30.28166106300006
						],
						[
							-81.74096326499995,
							30.281318207000087
						],
						[
							-81.74089108499993,
							30.28110166600004
						],
						[
							-81.74089108499993,
							30.280921215000035
						],
						[
							-81.7411256709999,
							30.28059640400005
						],
						[
							-81.74145048199995,
							30.279910691000058
						],
						[
							-81.74152266199991,
							30.279531745000046
						],
						[
							-81.74152266199991,
							30.278846032000047
						],
						[
							-81.74137830199993,
							30.278376860000037
						],
						[
							-81.7411256709999,
							30.277871598000043
						],
						[
							-81.7406564989999,
							30.27751069600004
						],
						[
							-81.73970010999994,
							30.277023479000036
						],
						[
							-81.73890612699995,
							30.276536262000036
						],
						[
							-81.73746252099994,
							30.275706189000058
						],
						[
							-81.73628959099995,
							30.275020476000066
						],
						[
							-81.73573019399993,
							30.27473175500006
						],
						[
							-81.73508057099991,
							30.274749800000052
						],
						[
							-81.73430463299991,
							30.274533259000066
						],
						[
							-81.73372718999991,
							30.274027997000076
						],
						[
							-81.73307756799994,
							30.273143788000084
						],
						[
							-81.73228358499995,
							30.272133264000043
						],
						[
							-81.7309408889999,
							30.27032808000007
						],
						[
							-81.7306182449999,
							30.269480845000093
						],
						[
							-81.7305753409999,
							30.269323166000053
						],
						[
							-81.7305616779999,
							30.26916700000004
						],
						[
							-81.7305753409999,
							30.269010835000078
						],
						[
							-81.73061591399994,
							30.26885941400008
						],
						[
							-81.73068216399992,
							30.26871733900009
						],
						[
							-81.73074872799992,
							30.268617957000057
						],
						[
							-81.73099150999991,
							30.268302996000045
						],
						[
							-81.73116167199993,
							30.268053009000084
						],
						[
							-81.73221099999995,
							30.267657000000042
						],
						[
							-81.73305794399995,
							30.266572051000082
						],
						[
							-81.73339590499997,
							30.26633700800005
						],
						[
							-81.7338909469999,
							30.26589804200006
						],
						[
							-81.73430490599992,
							30.265259009000093
						],
						[
							-81.73468385899992,
							30.26482494000004
						],
						[
							-81.73802905499991,
							30.263643130000048
						],
						[
							-81.73809503699994,
							30.26286998600006
						],
						[
							-81.73762872499992,
							30.26144895600004
						],
						[
							-81.74004391099993,
							30.259541815000038
						],
						[
							-81.74084896799991,
							30.260302011000082
						],
						[
							-81.74031890599993,
							30.261402008000058
						],
						[
							-81.74005073399991,
							30.26194407500009
						],
						[
							-81.7403259059999,
							30.262053009000056
						],
						[
							-81.74092890599991,
							30.262255008000068
						],
						[
							-81.74107390599994,
							30.262285008000052
						],
						[
							-81.74121090499995,
							30.262300008000068
						],
						[
							-81.74134090599995,
							30.26230800900004
						],
						[
							-81.74278290599995,
							30.262283008000058
						],
						[
							-81.74385790499991,
							30.26226600800004
						],
						[
							-81.7473530339999,
							30.262191874000052
						],
						[
							-81.7473749049999,
							30.262758008000052
						],
						[
							-81.7473749049999,
							30.263002008000058
						],
						[
							-81.74740590599993,
							30.263884008000044
						],
						[
							-81.7474819059999,
							30.26692400800005
						],
						[
							-81.74751290499995,
							30.26801300900007
						],
						[
							-81.74757385099991,
							30.270254007000062
						],
						[
							-81.7475969059999,
							30.271532008000065
						],
						[
							-81.74760390599994,
							30.271803008000067
						],
						[
							-81.74761590599991,
							30.27247100900007
						],
						[
							-81.74762290599995,
							30.272825009000087
						],
						[
							-81.7476429059999,
							30.273729008000085
						],
						[
							-81.74764590599995,
							30.27383500800005
						],
						[
							-81.74765790599992,
							30.274574008000055
						],
						[
							-81.74767290599995,
							30.274973009000067
						],
						[
							-81.7476879049999,
							30.27558700800006
						],
						[
							-81.74771090599995,
							30.276087008000047
						],
						[
							-81.74771090599995,
							30.276283008000064
						],
						[
							-81.74771990499994,
							30.27636700800008
						],
						[
							-81.74775690599995,
							30.27702000900007
						],
						[
							-81.74778690499994,
							30.277765008000074
						],
						[
							-81.74784090499992,
							30.278927008000043
						],
						[
							-81.74786090499992,
							30.27940600800008
						],
						[
							-81.7478879059999,
							30.280064009000057
						],
						[
							-81.74790990599992,
							30.28059000900004
						],
						[
							-81.7479249029999,
							30.28070400600006
						],
						[
							-81.7479169049999,
							30.28074500900004
						],
						[
							-81.74790190599992,
							30.28082500800008
						],
						[
							-81.74789490599994,
							30.281196009000045
						],
						[
							-81.74786390499992,
							30.282043009000066
						],
						[
							-81.74783990499992,
							30.28257000800005
						],
						[
							-81.74780990599993,
							30.283253008000088
						],
						[
							-81.74778690499994,
							30.283911009000064
						],
						[
							-81.7477490359999,
							30.28462014300004
						],
						[
							-81.7456209049999,
							30.28465100800008
						],
						[
							-81.74353778199992,
							30.28466415200006
						],
						[
							-81.74352990599994,
							30.28459000800007
						],
						[
							-81.74353790599991,
							30.284016008000037
						],
						[
							-81.74352890599994,
							30.283524008000082
						],
						[
							-81.7435229059999,
							30.282852009000063
						],
						[
							-81.74353003499994,
							30.28206988100004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Cedar Hills Estate",
				"RegionID": "273171"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.31224599999996,
					28.126807000000042,
					-82.28761399999996,
					28.14582581600007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.30969740699999,
							28.129244030000056
						],
						[
							-82.30968191499994,
							28.130681647000074
						],
						[
							-82.30925433399995,
							28.131451294000044
						],
						[
							-82.30933984999996,
							28.132163929000058
						],
						[
							-82.30965340999995,
							28.13313311400003
						],
						[
							-82.30968334699998,
							28.14208388800006
						],
						[
							-82.30900099999997,
							28.142101000000025
						],
						[
							-82.30812099999997,
							28.142119000000037
						],
						[
							-82.30816999999996,
							28.142203000000052
						],
						[
							-82.30835499999995,
							28.14237600000007
						],
						[
							-82.30858099999995,
							28.142487000000074
						],
						[
							-82.30883399999999,
							28.14253300000007
						],
						[
							-82.30908699999998,
							28.142514000000062
						],
						[
							-82.30932899999993,
							28.142439000000024
						],
						[
							-82.30968599999994,
							28.142321000000038
						],
						[
							-82.30994899999996,
							28.14228300000008
						],
						[
							-82.31224599999996,
							28.142303000000027
						],
						[
							-82.31212899999998,
							28.14560000000006
						],
						[
							-82.31220081399994,
							28.14582581600007
						],
						[
							-82.30741812299993,
							28.142936423000037
						],
						[
							-82.30709094399998,
							28.142409075000046
						],
						[
							-82.30621011899996,
							28.141309857000067
						],
						[
							-82.29552002499997,
							28.141359996000062
						],
						[
							-82.29471489599996,
							28.141363772000034
						],
						[
							-82.29464545499997,
							28.140654546000064
						],
						[
							-82.29465069799996,
							28.138641961000076
						],
						[
							-82.29493599999995,
							28.138595000000066
						],
						[
							-82.29493599999995,
							28.134644000000037
						],
						[
							-82.29493399999996,
							28.134507000000042
						],
						[
							-82.29462726899999,
							28.134507085000052
						],
						[
							-82.29359229299996,
							28.134507374000066
						],
						[
							-82.29356670099997,
							28.13450738100005
						],
						[
							-82.29134599999998,
							28.13450800000004
						],
						[
							-82.29134461799998,
							28.134483626000076
						],
						[
							-82.29131599999994,
							28.133979000000068
						],
						[
							-82.29127040899994,
							28.133976596000025
						],
						[
							-82.29031099999997,
							28.13392600000003
						],
						[
							-82.29031099999997,
							28.13340500000004
						],
						[
							-82.28761399999996,
							28.13368600000007
						],
						[
							-82.28767499999998,
							28.133598000000063
						],
						[
							-82.28818399999994,
							28.132876000000067
						],
						[
							-82.28905899999995,
							28.13152400000007
						],
						[
							-82.28918299999998,
							28.131331000000046
						],
						[
							-82.28958299999994,
							28.131323000000066
						],
						[
							-82.29025699999994,
							28.131298000000072
						],
						[
							-82.29151899999994,
							28.13129200000003
						],
						[
							-82.29341699999998,
							28.131507000000056
						],
						[
							-82.29342976799995,
							28.130786503000024
						],
						[
							-82.29345199999995,
							28.12953200000004
						],
						[
							-82.29359920499996,
							28.12953337600004
						],
						[
							-82.29494999999997,
							28.12954600000006
						],
						[
							-82.29493599999995,
							28.129945000000077
						],
						[
							-82.29581699999994,
							28.12991500000004
						],
						[
							-82.29837099999997,
							28.13034300000004
						],
						[
							-82.29839846099998,
							28.12994625700003
						],
						[
							-82.29840899999994,
							28.129794000000064
						],
						[
							-82.29899396299999,
							28.129801405000027
						],
						[
							-82.29904099999999,
							28.12980200000004
						],
						[
							-82.29903699599998,
							28.128562486000078
						],
						[
							-82.29903599999994,
							28.128254000000027
						],
						[
							-82.29948899999994,
							28.12825900000007
						],
						[
							-82.30103958299998,
							28.128247077000026
						],
						[
							-82.30123599999996,
							28.12824600000005
						],
						[
							-82.30125241499996,
							28.127578155000037
						],
						[
							-82.30127099999999,
							28.12682200000006
						],
						[
							-82.30268599999994,
							28.126807000000042
						],
						[
							-82.30637999999999,
							28.127986000000078
						],
						[
							-82.30969740699999,
							28.129244030000056
						]
					],
					[
						[
							-82.30803469799997,
							28.133890395000037
						],
						[
							-82.30791225499996,
							28.133776322000074
						],
						[
							-82.30773708099998,
							28.133821160000025
						],
						[
							-82.30708128399993,
							28.134073786000044
						],
						[
							-82.30709567799994,
							28.134121238000034
						],
						[
							-82.30710904199998,
							28.13417855100005
						],
						[
							-82.30711862799996,
							28.134236615000077
						],
						[
							-82.30712439599996,
							28.134295182000074
						],
						[
							-82.30712505999998,
							28.134306373000072
						],
						[
							-82.30713205999996,
							28.134438373000023
						],
						[
							-82.30713201299994,
							28.134445998000047
						],
						[
							-82.30713332199997,
							28.134486000000038
						],
						[
							-82.30713139699998,
							28.13454481800005
						],
						[
							-82.30712537499994,
							28.134605274000023
						],
						[
							-82.30710377199995,
							28.13476419500006
						],
						[
							-82.30710744399994,
							28.134918402000043
						],
						[
							-82.30711812399994,
							28.134922093000057
						],
						[
							-82.30712997899997,
							28.134924463000065
						],
						[
							-82.30717828499996,
							28.134926825000036
						],
						[
							-82.30723771699998,
							28.134911744000078
						],
						[
							-82.30738383199997,
							28.13483014700006
						],
						[
							-82.30765914999995,
							28.13461601100005
						],
						[
							-82.30785326399996,
							28.134436066000035
						],
						[
							-82.30793046799994,
							28.13433819000005
						],
						[
							-82.30801582799995,
							28.134159018000048
						],
						[
							-82.30803469799997,
							28.133890395000037
						]
					],
					[
						[
							-82.30379185399995,
							28.133801964000043
						],
						[
							-82.30375451999998,
							28.133756473000066
						],
						[
							-82.30373824899993,
							28.133734590000074
						],
						[
							-82.30361724999995,
							28.133566589000054
						],
						[
							-82.30359924199996,
							28.133540636000077
						],
						[
							-82.30356816499994,
							28.133490661000053
						],
						[
							-82.30354042299996,
							28.133438760000047
						],
						[
							-82.30351613499995,
							28.133385155000042
						],
						[
							-82.30349540499998,
							28.13333007700004
						],
						[
							-82.30349105599998,
							28.13331693200007
						],
						[
							-82.30344205499995,
							28.133164932000057
						],
						[
							-82.30342932199994,
							28.13312176200003
						],
						[
							-82.30342054899995,
							28.133092667000028
						],
						[
							-82.30337923999997,
							28.13307357700006
						],
						[
							-82.30332733899996,
							28.133045836000065
						],
						[
							-82.30331256199997,
							28.133037115000036
						],
						[
							-82.30300092299996,
							28.132849173000068
						],
						[
							-82.30300462799994,
							28.132871615000056
						],
						[
							-82.30301039599993,
							28.132930182000052
						],
						[
							-82.30301232199997,
							28.132989000000066
						],
						[
							-82.30301192399997,
							28.13301575500003
						],
						[
							-82.30300692399999,
							28.13318375500006
						],
						[
							-82.30300539599995,
							28.133215818000053
						],
						[
							-82.30299962799995,
							28.13327438500005
						],
						[
							-82.30299004199998,
							28.13333244900008
						],
						[
							-82.30297667799994,
							28.133389761000046
						],
						[
							-82.30295959499996,
							28.133446077000034
						],
						[
							-82.30293886499999,
							28.133501155000033
						],
						[
							-82.30291457699998,
							28.133554760000038
						],
						[
							-82.30288683499998,
							28.133606661000044
						],
						[
							-82.30285575899995,
							28.13365663600007
						],
						[
							-82.30282147999998,
							28.133704472000034
						],
						[
							-82.30278480999993,
							28.133749205000072
						],
						[
							-82.30277660099995,
							28.133758587000045
						],
						[
							-82.30276966699995,
							28.13393924500008
						],
						[
							-82.30278970499995,
							28.133937223000032
						],
						[
							-82.30282118199995,
							28.13393460400005
						],
						[
							-82.30287999999996,
							28.133932678000065
						],
						[
							-82.30294034499997,
							28.133934707000037
						],
						[
							-82.30305787099998,
							28.133942809000075
						],
						[
							-82.30311338499996,
							28.133948372000077
						],
						[
							-82.30317144899999,
							28.133957958000053
						],
						[
							-82.30322876199995,
							28.13397132200004
						],
						[
							-82.30328507799999,
							28.133988405000025
						],
						[
							-82.30332357399999,
							28.134002459000044
						],
						[
							-82.30336214499994,
							28.134017544000073
						],
						[
							-82.30366044699997,
							28.13391211000004
						],
						[
							-82.30382497299996,
							28.133837326000048
						],
						[
							-82.30379185399995,
							28.133801964000043
						]
					],
					[
						[
							-82.30555978199999,
							28.129898574000038
						],
						[
							-82.30461559599996,
							28.12982680000005
						],
						[
							-82.30469042999994,
							28.12987944200006
						],
						[
							-82.30472047199999,
							28.129901520000033
						],
						[
							-82.30476596399996,
							28.12993885400005
						],
						[
							-82.30480891599997,
							28.12997908400007
						],
						[
							-82.30484615499995,
							28.130018643000028
						],
						[
							-82.30497815599995,
							28.13016764300005
						],
						[
							-82.30498114599999,
							28.130171036000036
						],
						[
							-82.30501847999994,
							28.130216527000073
						],
						[
							-82.30503439299997,
							28.130237914000077
						],
						[
							-82.30524424399994,
							28.13011921800006
						],
						[
							-82.30528923999998,
							28.130095423000057
						],
						[
							-82.30534284499998,
							28.130071135000037
						],
						[
							-82.30535473699996,
							28.13006630800004
						],
						[
							-82.30560373599997,
							28.12996730800006
						],
						[
							-82.30564692199994,
							28.129951405000043
						],
						[
							-82.30569409499998,
							28.129936823000037
						],
						[
							-82.30569977199997,
							28.12993523800003
						],
						[
							-82.30555978199999,
							28.129898574000038
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Cory Lake Isles",
				"RegionID": "273356"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.94991804499995,
					28.02671423700008,
					-81.94177999999994,
					28.03313414200005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.94177999999994,
							28.029381000000058
						],
						[
							-81.94196171999994,
							28.028497934000086
						],
						[
							-81.94242259499993,
							28.028559273000045
						],
						[
							-81.94270431799993,
							28.02857632000007
						],
						[
							-81.9427069809999,
							28.028576485000087
						],
						[
							-81.94280451999992,
							28.028582678000078
						],
						[
							-81.9437239689999,
							28.028582678000078
						],
						[
							-81.94628624199993,
							28.028117163000047
						],
						[
							-81.94629442199994,
							28.02811571600006
						],
						[
							-81.94727118899993,
							28.027947561000076
						],
						[
							-81.94728213499991,
							28.027919844000053
						],
						[
							-81.94730642299993,
							28.027866240000037
						],
						[
							-81.94733416399993,
							28.027814339000088
						],
						[
							-81.94736524099994,
							28.027764364000063
						],
						[
							-81.94739951999993,
							28.02771652800004
						],
						[
							-81.9474086269999,
							28.02770485900004
						],
						[
							-81.94756262699991,
							28.027510859000074
						],
						[
							-81.94759085399994,
							28.02747703600005
						],
						[
							-81.94763108299992,
							28.02743408300006
						],
						[
							-81.94765241499994,
							28.027413444000047
						],
						[
							-81.94787141499995,
							28.027208444000053
						],
						[
							-81.94789303599993,
							28.027188854000087
						],
						[
							-81.94793852799995,
							28.027151520000075
						],
						[
							-81.94798636399992,
							28.02711724100004
						],
						[
							-81.94801527899996,
							28.027098709000086
						],
						[
							-81.94822527899993,
							28.02696970900007
						],
						[
							-81.94824633899992,
							28.026957164000066
						],
						[
							-81.94829823999993,
							28.02692942300007
						],
						[
							-81.94835184399994,
							28.02690513500005
						],
						[
							-81.94840692199995,
							28.02688440500009
						],
						[
							-81.94846323799993,
							28.026867322000044
						],
						[
							-81.9484718349999,
							28.02686506400005
						],
						[
							-81.94870883499993,
							28.02680406400009
						],
						[
							-81.94875755099991,
							28.026792958000044
						],
						[
							-81.94881561499994,
							28.026783372000068
						],
						[
							-81.94887418199994,
							28.026777603000085
						],
						[
							-81.94891195899993,
							28.026775924000052
						],
						[
							-81.94933146199992,
							28.026766106000082
						],
						[
							-81.94971159399995,
							28.02671423700008
						],
						[
							-81.94979194099994,
							28.027610930000037
						],
						[
							-81.94979091099992,
							28.028405010000085
						],
						[
							-81.94987490999995,
							28.029978009000047
						],
						[
							-81.94987690999994,
							28.03023500900008
						],
						[
							-81.94988591099991,
							28.031156009000085
						],
						[
							-81.94989590999995,
							28.03206201100005
						],
						[
							-81.94991804499995,
							28.03313414200005
						],
						[
							-81.94898191099992,
							28.033132010000088
						],
						[
							-81.94783890999992,
							28.03312901000004
						],
						[
							-81.94483191199993,
							28.033126955000057
						],
						[
							-81.9428219099999,
							28.033101009000063
						],
						[
							-81.94270890699994,
							28.033090008000045
						],
						[
							-81.94268090999992,
							28.03308001000005
						],
						[
							-81.94251691199992,
							28.033011010000052
						],
						[
							-81.94223090999992,
							28.032826011000054
						],
						[
							-81.94193190899995,
							28.032669011000053
						],
						[
							-81.94186491199991,
							28.032645012000046
						],
						[
							-81.94179291899991,
							28.03263849700005
						],
						[
							-81.94179306699994,
							28.029726904000086
						],
						[
							-81.94178999999993,
							28.029725704000043
						],
						[
							-81.94179001799995,
							28.029382334000047
						],
						[
							-81.94177999999994,
							28.029381000000058
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Polk",
				"City": "Lakeland",
				"Name": "Florida Southern College",
				"RegionID": "343460"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.93922382999995,
					28.03202657500009,
					-81.92172899999993,
					28.04904302500006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.9243699999999,
							28.04490500000009
						],
						[
							-81.92436499999991,
							28.044359000000043
						],
						[
							-81.92435499999993,
							28.044130000000052
						],
						[
							-81.92436499999991,
							28.04406000000006
						],
						[
							-81.92436499999991,
							28.043969000000065
						],
						[
							-81.92435499999993,
							28.043762000000072
						],
						[
							-81.92433499999993,
							28.043554000000086
						],
						[
							-81.92426699999993,
							28.043326000000036
						],
						[
							-81.92420499999992,
							28.04317400000008
						],
						[
							-81.92413699999992,
							28.043036000000086
						],
						[
							-81.9240529999999,
							28.042901000000086
						],
						[
							-81.92400499999991,
							28.042830000000038
						],
						[
							-81.92395999999991,
							28.042763000000036
						],
						[
							-81.92363099999994,
							28.04244200000005
						],
						[
							-81.92343599999992,
							28.04226200000005
						],
						[
							-81.9232639999999,
							28.04211100000009
						],
						[
							-81.9225429999999,
							28.04146200000008
						],
						[
							-81.92321499999991,
							28.040831000000082
						],
						[
							-81.92326199999991,
							28.040650000000085
						],
						[
							-81.92326053999994,
							28.040649923000046
						],
						[
							-81.92320499999994,
							28.040647000000035
						],
						[
							-81.9232024499999,
							28.04064088000007
						],
						[
							-81.92320002399993,
							28.040635059000067
						],
						[
							-81.92317999999995,
							28.040587000000073
						],
						[
							-81.92319199999991,
							28.040515000000084
						],
						[
							-81.92330399999992,
							28.040356000000088
						],
						[
							-81.92327899999992,
							28.04033400000009
						],
						[
							-81.92317999999995,
							28.040235000000052
						],
						[
							-81.92304999999993,
							28.040152000000035
						],
						[
							-81.9229499999999,
							28.040036000000043
						],
						[
							-81.92291299999994,
							28.04000800000006
						],
						[
							-81.92282599999993,
							28.03994300000005
						],
						[
							-81.92257799999993,
							28.03988200000009
						],
						[
							-81.92254699999995,
							28.039844000000077
						],
						[
							-81.92260899999991,
							28.039794000000086
						],
						[
							-81.92261599999996,
							28.039734000000067
						],
						[
							-81.92257199999995,
							28.03965100000005
						],
						[
							-81.92250999999993,
							28.03960200000006
						],
						[
							-81.9224109999999,
							28.039591000000087
						],
						[
							-81.9222739999999,
							28.039613000000088
						],
						[
							-81.92215699999991,
							28.03962400000006
						],
						[
							-81.92201999999992,
							28.039580000000058
						],
						[
							-81.92194599999993,
							28.039514000000054
						],
						[
							-81.92197699999991,
							28.039398000000066
						],
						[
							-81.92208799999992,
							28.039266000000055
						],
						[
							-81.92210699999993,
							28.039156000000048
						],
						[
							-81.9220259999999,
							28.039101000000073
						],
						[
							-81.92185899999993,
							28.039040000000057
						],
						[
							-81.92175999999995,
							28.03896300000008
						],
						[
							-81.92172899999993,
							28.03880900000007
						],
						[
							-81.92174699999993,
							28.038567000000057
						],
						[
							-81.92183399999993,
							28.03825400000005
						],
						[
							-81.92192099999994,
							28.03824300000008
						],
						[
							-81.9220269999999,
							28.03824300000008
						],
						[
							-81.92210099999994,
							28.038215000000037
						],
						[
							-81.92217499999992,
							28.03813800000006
						],
						[
							-81.9222309999999,
							28.038006000000053
						],
						[
							-81.9223429999999,
							28.037852000000047
						],
						[
							-81.92238599999992,
							28.037720000000036
						],
						[
							-81.92244799999992,
							28.037599000000057
						],
						[
							-81.92250999999993,
							28.03752700000007
						],
						[
							-81.92252899999994,
							28.037439000000063
						],
						[
							-81.92250999999993,
							28.037368000000072
						],
						[
							-81.92235499999992,
							28.03725200000008
						],
						[
							-81.92231199999992,
							28.037175000000047
						],
						[
							-81.92231199999992,
							28.037087000000042
						],
						[
							-81.92239899999993,
							28.03690000000006
						],
						[
							-81.92237999999992,
							28.03674600000005
						],
						[
							-81.92238599999992,
							28.03668500000009
						],
						[
							-81.92244199999993,
							28.03659200000004
						],
						[
							-81.92252299999991,
							28.036531000000082
						],
						[
							-81.92259699999994,
							28.036493000000068
						],
						[
							-81.9226779999999,
							28.03648700000008
						],
						[
							-81.92294499999993,
							28.03658600000006
						],
						[
							-81.92302499999994,
							28.036608000000058
						],
						[
							-81.92311199999995,
							28.03659200000004
						],
						[
							-81.92322999999993,
							28.03647600000005
						],
						[
							-81.92355199999992,
							28.036091000000056
						],
						[
							-81.9238069999999,
							28.035888000000057
						],
						[
							-81.92388099999995,
							28.03584900000004
						],
						[
							-81.92386899999991,
							28.03580500000004
						],
						[
							-81.92381299999994,
							28.03577800000005
						],
						[
							-81.92371999999995,
							28.035750000000064
						],
						[
							-81.92365799999993,
							28.03570600000006
						],
						[
							-81.9236269999999,
							28.03562400000004
						],
						[
							-81.92358999999993,
							28.035382000000084
						],
						[
							-81.92360799999994,
							28.035051000000067
						],
						[
							-81.9236459999999,
							28.034842000000083
						],
						[
							-81.92377599999992,
							28.03469400000006
						],
						[
							-81.92380099999991,
							28.034683000000086
						],
						[
							-81.92380099999991,
							28.03459500000008
						],
						[
							-81.92371999999995,
							28.034463000000073
						],
						[
							-81.92361499999993,
							28.03435200000007
						],
						[
							-81.92357099999992,
							28.03419800000006
						],
						[
							-81.92362099999991,
							28.034083000000066
						],
						[
							-81.9237389999999,
							28.03397300000006
						],
						[
							-81.92396799999995,
							28.033786000000077
						],
						[
							-81.92422199999993,
							28.033494000000076
						],
						[
							-81.92436499999991,
							28.033186000000057
						],
						[
							-81.92448299999995,
							28.032856000000038
						],
						[
							-81.92453299999994,
							28.032603000000055
						],
						[
							-81.92460699999992,
							28.032339000000036
						],
						[
							-81.92463199999993,
							28.03210800000005
						],
						[
							-81.92463099799994,
							28.032099644000084
						],
						[
							-81.92549739799995,
							28.03202657500009
						],
						[
							-81.92545039999993,
							28.032473958000082
						],
						[
							-81.92544762799992,
							28.032497385000056
						],
						[
							-81.92544657099995,
							28.03250515100007
						],
						[
							-81.9253775709999,
							28.032996151000077
						],
						[
							-81.92537178899994,
							28.033032022000043
						],
						[
							-81.92528273499994,
							28.033521360000066
						],
						[
							-81.92525432199994,
							28.03386962400009
						],
						[
							-81.92525432199994,
							28.034029278000048
						],
						[
							-81.92539594699991,
							28.03481184700007
						],
						[
							-81.92540262799992,
							28.034854615000086
						],
						[
							-81.9254083969999,
							28.034913181000036
						],
						[
							-81.92541032199995,
							28.03497200000004
						],
						[
							-81.92541032199995,
							28.035214000000053
						],
						[
							-81.9254083969999,
							28.035272819000056
						],
						[
							-81.92540262799992,
							28.035331385000063
						],
						[
							-81.92539304199994,
							28.03538944900004
						],
						[
							-81.9253928569999,
							28.035390374000087
						],
						[
							-81.9253698199999,
							28.035505558000068
						],
						[
							-81.9253607309999,
							28.035553733000086
						],
						[
							-81.92535904199991,
							28.035562449000054
						],
						[
							-81.92534567899992,
							28.035619762000067
						],
						[
							-81.92532859599993,
							28.03567607800005
						],
						[
							-81.92530786599991,
							28.035731156000054
						],
						[
							-81.92528357799995,
							28.03578476000007
						],
						[
							-81.92526868499993,
							28.03581363300009
						],
						[
							-81.9251716839999,
							28.03599363400008
						],
						[
							-81.92515883499993,
							28.036016661000076
						],
						[
							-81.92512775799992,
							28.036066637000093
						],
						[
							-81.92509347999993,
							28.036114473000055
						],
						[
							-81.92505614599992,
							28.03615996500008
						],
						[
							-81.92503838099992,
							28.03617963000005
						],
						[
							-81.92394038099991,
							28.037359629000036
						],
						[
							-81.92392766799992,
							28.03737301400008
						],
						[
							-81.92333426499994,
							28.037985047000063
						],
						[
							-81.92323302999995,
							28.038123636000083
						],
						[
							-81.92321515899995,
							28.03816088600007
						],
						[
							-81.9232140389999,
							28.038164549000044
						],
						[
							-81.92320284399995,
							28.03834525900004
						],
						[
							-81.92320900499993,
							28.03845791200007
						],
						[
							-81.92322165999991,
							28.038506148000067
						],
						[
							-81.92325568299992,
							28.038537037000083
						],
						[
							-81.92407828099994,
							28.039007222000066
						],
						[
							-81.92408166099995,
							28.03900916400005
						],
						[
							-81.9241316369999,
							28.039040241000066
						],
						[
							-81.92417947299992,
							28.039074520000042
						],
						[
							-81.9242249639999,
							28.039111854000055
						],
						[
							-81.92426791699995,
							28.03915208300009
						],
						[
							-81.92434391699993,
							28.03922808300007
						],
						[
							-81.92438414599991,
							28.03927103600006
						],
						[
							-81.92442147999992,
							28.03931652700004
						],
						[
							-81.92443783199991,
							28.039338524000073
						],
						[
							-81.92452783199991,
							28.03946352400004
						],
						[
							-81.9245457589999,
							28.039489364000076
						],
						[
							-81.9245677429999,
							28.039523946000088
						],
						[
							-81.9246303619999,
							28.039627591000055
						],
						[
							-81.92483309199991,
							28.039744846000076
						],
						[
							-81.92555334799994,
							28.04011304000005
						],
						[
							-81.92743295399993,
							28.040969657000062
						],
						[
							-81.92745775999992,
							28.040981423000062
						],
						[
							-81.92750966099993,
							28.041009165000048
						],
						[
							-81.9275596359999,
							28.041040241000076
						],
						[
							-81.92760543599991,
							28.041072962000044
						],
						[
							-81.92850343599991,
							28.04175796200008
						],
						[
							-81.92850547199993,
							28.041759520000085
						],
						[
							-81.9285509639999,
							28.04179685400004
						],
						[
							-81.92859391699994,
							28.041837084000065
						],
						[
							-81.92863414599992,
							28.041880036000066
						],
						[
							-81.92865434799995,
							28.041904653000074
						],
						[
							-81.92873934999994,
							28.041922153000087
						],
						[
							-81.9287907609999,
							28.04193432200009
						],
						[
							-81.92881242999994,
							28.04194042000006
						],
						[
							-81.92892338199994,
							28.04197314700008
						],
						[
							-81.92912985499993,
							28.04201971300006
						],
						[
							-81.92916476199991,
							28.04202832200008
						],
						[
							-81.92918707399991,
							28.042034610000087
						],
						[
							-81.92940007399994,
							28.04209761000004
						],
						[
							-81.92943407699994,
							28.04210840500008
						],
						[
							-81.92948915499994,
							28.042129135000042
						],
						[
							-81.92952625599992,
							28.042145492000092
						],
						[
							-81.92965670299992,
							28.04220655200004
						],
						[
							-81.92966495799995,
							28.042156551000062
						],
						[
							-81.92967832099993,
							28.042099239000038
						],
						[
							-81.92968891499993,
							28.04206279500005
						],
						[
							-81.92973691599992,
							28.041909795000038
						],
						[
							-81.9297434049999,
							28.041889923000042
						],
						[
							-81.92976413499991,
							28.04183484500004
						],
						[
							-81.92978842299993,
							28.041781240000034
						],
						[
							-81.92981616399993,
							28.041729339000085
						],
						[
							-81.92982952299991,
							28.041706958000077
						],
						[
							-81.92994052199992,
							28.041526957000087
						],
						[
							-81.92995824099995,
							28.04149936400006
						],
						[
							-81.92999251999993,
							28.04145152800004
						],
						[
							-81.93002985399994,
							28.04140603600007
						],
						[
							-81.93007008299992,
							28.04136308300008
						],
						[
							-81.93011303599992,
							28.041322854000043
						],
						[
							-81.93012577699994,
							28.041311889000042
						],
						[
							-81.93021577799993,
							28.041235889000063
						],
						[
							-81.93024852799994,
							28.041209520000052
						],
						[
							-81.9302963639999,
							28.041175241000076
						],
						[
							-81.93034633899993,
							28.04114416400006
						],
						[
							-81.93039823999993,
							28.041116423000062
						],
						[
							-81.93045184499994,
							28.041092135000042
						],
						[
							-81.93050692299994,
							28.041071405000082
						],
						[
							-81.93051315299994,
							28.041069316000062
						],
						[
							-81.93067915299991,
							28.041014316000087
						],
						[
							-81.93072923799991,
							28.04099932200006
						],
						[
							-81.93078655099993,
							28.040985959000068
						],
						[
							-81.93083350699993,
							28.04097790500009
						],
						[
							-81.93121450699994,
							28.040922904000073
						],
						[
							-81.9312256149999,
							28.04092137100008
						],
						[
							-81.9312619289999,
							28.040917339000092
						],
						[
							-81.9316619839999,
							28.04088112800008
						],
						[
							-81.93170260199992,
							28.04087149700007
						],
						[
							-81.93171585399995,
							28.040856036000037
						],
						[
							-81.93172972399992,
							28.04084058400008
						],
						[
							-81.9320347229999,
							28.040508584000065
						],
						[
							-81.93206108299997,
							28.04048108300009
						],
						[
							-81.9320738159999,
							28.040468600000054
						],
						[
							-81.93225381699995,
							28.040295600000036
						],
						[
							-81.93228403599994,
							28.040267854000035
						],
						[
							-81.93232952699992,
							28.04023052000008
						],
						[
							-81.93237736299994,
							28.040196241000046
						],
						[
							-81.93242699099994,
							28.040165366000053
						],
						[
							-81.93268998999993,
							28.04001336600004
						],
						[
							-81.93269033899992,
							28.04001316500006
						],
						[
							-81.93274223999993,
							28.039985423000076
						],
						[
							-81.93279584399994,
							28.039961135000055
						],
						[
							-81.93285092199994,
							28.03994040500004
						],
						[
							-81.93290723799993,
							28.03992332200005
						],
						[
							-81.93292959099995,
							28.039917639000066
						],
						[
							-81.9332156939999,
							28.039848790000068
						],
						[
							-81.93370067399991,
							28.040643559000046
						],
						[
							-81.93605251999992,
							28.040643921000083
						],
						[
							-81.93722451199994,
							28.04060613000007
						],
						[
							-81.93723650999993,
							28.040697186000045
						],
						[
							-81.93724949299991,
							28.040888150000058
						],
						[
							-81.93727155399995,
							28.041320314000075
						],
						[
							-81.93727764099992,
							28.04175254200004
						],
						[
							-81.9372768639999,
							28.04196704400005
						],
						[
							-81.9372545949999,
							28.04211621400009
						],
						[
							-81.93716288999991,
							28.04224768800009
						],
						[
							-81.93703182399992,
							28.042319018000057
						],
						[
							-81.93679132499994,
							28.04241412600004
						],
						[
							-81.93654667999994,
							28.042510605000075
						],
						[
							-81.93636049299995,
							28.042584031000047
						],
						[
							-81.93615999999992,
							28.04266000000007
						],
						[
							-81.93615999999992,
							28.04297501800005
						],
						[
							-81.93615999999992,
							28.04343063600004
						],
						[
							-81.93615999999992,
							28.04379033400005
						],
						[
							-81.93615999999992,
							28.04416000000009
						],
						[
							-81.93659371699994,
							28.04416000000009
						],
						[
							-81.93755291399992,
							28.04416000000009
						],
						[
							-81.93870394899994,
							28.04416000000009
						],
						[
							-81.9391909599999,
							28.04416143600008
						],
						[
							-81.93919090999992,
							28.044165010000086
						],
						[
							-81.93919490999991,
							28.04536901000006
						],
						[
							-81.93919590999991,
							28.046687009000042
						],
						[
							-81.93922382999995,
							28.048442412000046
						],
						[
							-81.9377893759999,
							28.04904302500006
						],
						[
							-81.92946388699994,
							28.04862892100005
						],
						[
							-81.92491017899994,
							28.048122954000064
						],
						[
							-81.92471023999991,
							28.048108565000064
						],
						[
							-81.92250299999995,
							28.047863316000075
						],
						[
							-81.92250299999995,
							28.047372000000053
						],
						[
							-81.92250299999995,
							28.04595400000005
						],
						[
							-81.92333799999994,
							28.045944000000077
						],
						[
							-81.92428899999993,
							28.04591300000004
						],
						[
							-81.92438699999991,
							28.04591000000005
						],
						[
							-81.92438614399993,
							28.045867136000084
						],
						[
							-81.92437099999995,
							28.045109000000082
						],
						[
							-81.92436499999991,
							28.045017000000087
						],
						[
							-81.9243699999999,
							28.04490500000009
						]
					],
					[
						[
							-81.93267139199992,
							28.044214384000043
						],
						[
							-81.93254503299994,
							28.04405381400005
						],
						[
							-81.93229399099994,
							28.043781600000045
						],
						[
							-81.9321833969999,
							28.043699415000052
						],
						[
							-81.9318366949999,
							28.043496788000084
						],
						[
							-81.93182096699991,
							28.043496099000038
						],
						[
							-81.93171441099992,
							28.043505742000036
						],
						[
							-81.9314137739999,
							28.04357028600009
						],
						[
							-81.93140044899991,
							28.04357304100006
						],
						[
							-81.93134238499994,
							28.04358262800008
						],
						[
							-81.93132921499996,
							28.04358426300007
						],
						[
							-81.9309935469999,
							28.04362342400009
						],
						[
							-81.93100078399993,
							28.043639152000083
						],
						[
							-81.93108930799991,
							28.04384599100007
						],
						[
							-81.93113073399991,
							28.043923319000044
						],
						[
							-81.93114457699994,
							28.043950240000072
						],
						[
							-81.9311688649999,
							28.044003844000088
						],
						[
							-81.93118959499992,
							28.04405892200009
						],
						[
							-81.93120667799991,
							28.044115238000074
						],
						[
							-81.93122004199996,
							28.044172551000088
						],
						[
							-81.93122155399993,
							28.044181708000053
						],
						[
							-81.93122886499992,
							28.044197845000042
						],
						[
							-81.93124959499994,
							28.044252923000045
						],
						[
							-81.93125939399994,
							28.044283580000073
						],
						[
							-81.9312773929999,
							28.044343579000042
						],
						[
							-81.93128205399995,
							28.044359996000082
						],
						[
							-81.93131446799993,
							28.04438367700004
						],
						[
							-81.93153473099994,
							28.044515694000044
						],
						[
							-81.9317272319999,
							28.044595600000036
						],
						[
							-81.93190348299994,
							28.04463842100006
						],
						[
							-81.93203332399992,
							28.04465767800008
						],
						[
							-81.93218141599993,
							28.04465767800008
						],
						[
							-81.93234726999992,
							28.04464749400006
						],
						[
							-81.9323472989999,
							28.044647490000045
						],
						[
							-81.9324557079999,
							28.04457907200009
						],
						[
							-81.93270240599992,
							28.044378755000086
						],
						[
							-81.93267139199992,
							28.044214384000043
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Polk",
				"City": "Lakeland",
				"Name": "Lake Bonny",
				"RegionID": "343462"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.9833989999999,
					28.05413726000006,
					-81.9708790119999,
					28.063710128000082
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.98220676399991,
							28.063635100000056
						],
						[
							-81.9819199879999,
							28.06228496100005
						],
						[
							-81.98143491099995,
							28.06228501000004
						],
						[
							-81.98075391099991,
							28.06228501000004
						],
						[
							-81.9804778489999,
							28.062285186000057
						],
						[
							-81.97965392499992,
							28.061618972000076
						],
						[
							-81.97845190999993,
							28.06071901000007
						],
						[
							-81.9775819109999,
							28.060024010000063
						],
						[
							-81.9765279099999,
							28.059235010000066
						],
						[
							-81.97626291099994,
							28.059037010000054
						],
						[
							-81.97465290999993,
							28.057807009000044
						],
						[
							-81.9736669099999,
							28.057029010000065
						],
						[
							-81.97206191099991,
							28.055791011000057
						],
						[
							-81.9708790119999,
							28.054900916000065
						],
						[
							-81.9712159099999,
							28.054890011000055
						],
						[
							-81.97173491099994,
							28.05487401000005
						],
						[
							-81.97232990999993,
							28.05485501000004
						],
						[
							-81.97419091099994,
							28.054850010000052
						],
						[
							-81.97527290999994,
							28.054845010000065
						],
						[
							-81.97618891099995,
							28.054842010000073
						],
						[
							-81.9766629099999,
							28.054825010000062
						],
						[
							-81.97734504199991,
							28.054819140000063
						],
						[
							-81.97734477699993,
							28.05475987500006
						],
						[
							-81.9783259109999,
							28.054758009000068
						],
						[
							-81.9793619109999,
							28.054755010000065
						],
						[
							-81.98034016299994,
							28.054765002000067
						],
						[
							-81.98053491099995,
							28.05476501000004
						],
						[
							-81.9813510429999,
							28.05473687600005
						],
						[
							-81.98135077799992,
							28.054780144000063
						],
						[
							-81.98178491099992,
							28.054778010000064
						],
						[
							-81.98213461799992,
							28.054776711000045
						],
						[
							-81.98211932399994,
							28.05413726000006
						],
						[
							-81.9821587479999,
							28.05444908900006
						],
						[
							-81.98218199999991,
							28.05463300000008
						],
						[
							-81.98232283699993,
							28.05463665800005
						],
						[
							-81.98232941899994,
							28.05463682900006
						],
						[
							-81.98233599999993,
							28.05463700000007
						],
						[
							-81.98233699999992,
							28.054757000000052
						],
						[
							-81.98233437599993,
							28.05559211700006
						],
						[
							-81.98233299999993,
							28.056030000000078
						],
						[
							-81.98188857999992,
							28.056030975000056
						],
						[
							-81.98188278999993,
							28.05603098800009
						],
						[
							-81.98187699999994,
							28.056031000000075
						],
						[
							-81.98186299999993,
							28.056715000000054
						],
						[
							-81.98185399999994,
							28.056908000000078
						],
						[
							-81.9820729999999,
							28.056887000000074
						],
						[
							-81.98233099999993,
							28.056837000000087
						],
						[
							-81.98233099999993,
							28.056877000000043
						],
						[
							-81.98233876199993,
							28.05694600000004
						],
						[
							-81.98233914699995,
							28.05694941900009
						],
						[
							-81.98233938099992,
							28.056951500000086
						],
						[
							-81.98233999999991,
							28.056957000000068
						],
						[
							-81.98223285599994,
							28.056957000000068
						],
						[
							-81.9822289999999,
							28.056957000000068
						],
						[
							-81.98199762899992,
							28.05696382300005
						],
						[
							-81.98185599999994,
							28.05696800000004
						],
						[
							-81.98191099999991,
							28.058633000000043
						],
						[
							-81.98233599999993,
							28.058631000000048
						],
						[
							-81.9833329999999,
							28.058595000000082
						],
						[
							-81.98332899999991,
							28.058836000000042
						],
						[
							-81.9833329999999,
							28.06014500000009
						],
						[
							-81.98333574199995,
							28.061124885000083
						],
						[
							-81.98333576899995,
							28.06113463400004
						],
						[
							-81.98333599999995,
							28.06121700000006
						],
						[
							-81.98338599999994,
							28.061442000000056
						],
						[
							-81.9833989999999,
							28.061600000000055
						],
						[
							-81.98218199999991,
							28.061743000000035
						],
						[
							-81.98230599999994,
							28.062305000000038
						],
						[
							-81.9823040469999,
							28.063710128000082
						],
						[
							-81.98220676399991,
							28.063635100000056
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Polk",
				"City": "Lakeland",
				"Name": "Jewel Avenue",
				"RegionID": "343467"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.97358891099992,
					28.03679168900004,
					-81.96697261399993,
					28.04256307500009
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.96733045699995,
							28.037040688000047
						],
						[
							-81.96733053999992,
							28.03679168900004
						],
						[
							-81.9696273269999,
							28.03682814600006
						],
						[
							-81.9713596549999,
							28.036837770000094
						],
						[
							-81.9723028109999,
							28.036837770000094
						],
						[
							-81.97357804699993,
							28.03684701000009
						],
						[
							-81.97357890899991,
							28.03723601100006
						],
						[
							-81.97357804399991,
							28.037345041000037
						],
						[
							-81.9735749109999,
							28.03771001000007
						],
						[
							-81.97357191099991,
							28.03852001100006
						],
						[
							-81.97357791099995,
							28.03930401100007
						],
						[
							-81.97358791099992,
							28.039924011000043
						],
						[
							-81.97358891099992,
							28.040559010000038
						],
						[
							-81.97358190999995,
							28.04120800800007
						],
						[
							-81.97356191299991,
							28.04129301200004
						],
						[
							-81.9735750719999,
							28.041805946000068
						],
						[
							-81.97254383899991,
							28.042007054000067
						],
						[
							-81.97107791099995,
							28.042293009000048
						],
						[
							-81.97001991099995,
							28.04252801000007
						],
						[
							-81.96986287199991,
							28.04256307500009
						],
						[
							-81.96972390999991,
							28.04237001100006
						],
						[
							-81.96965297799994,
							28.042298895000044
						],
						[
							-81.9695199119999,
							28.042246013000067
						],
						[
							-81.96890439399994,
							28.042191751000075
						],
						[
							-81.9678073689999,
							28.04190565600004
						],
						[
							-81.96733038899994,
							28.04147637300008
						],
						[
							-81.96697261399993,
							28.04047475400006
						],
						[
							-81.96702044099993,
							28.039878547000058
						],
						[
							-81.96721121799993,
							28.039425441000052
						],
						[
							-81.96733058899991,
							28.039139293000062
						],
						[
							-81.96733040399994,
							28.037345041000037
						],
						[
							-81.96733045699995,
							28.037040688000047
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Polk",
				"City": "Lakeland",
				"Name": "Lake Beulah",
				"RegionID": "343469"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.5338333059999,
					27.32290009500008,
					-82.52972872099991,
					27.326704352000036
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.52972872099991,
							27.322905820000074
						],
						[
							-82.53380140699994,
							27.32290009500008
						],
						[
							-82.53382186499994,
							27.32533989600006
						],
						[
							-82.5338333059999,
							27.326704352000036
						],
						[
							-82.53381874399992,
							27.32670175900006
						],
						[
							-82.53360216899996,
							27.326663194000048
						],
						[
							-82.53333150799995,
							27.326448606000042
						],
						[
							-82.53297907699994,
							27.326224951000086
						],
						[
							-82.53251431399991,
							27.326024689000064
						],
						[
							-82.5324662829999,
							27.32601068000008
						],
						[
							-82.53226915899995,
							27.32595318500006
						],
						[
							-82.53205972899993,
							27.325932841000053
						],
						[
							-82.53179926999992,
							27.325810172000047
						],
						[
							-82.5314366419999,
							27.325524159000054
						],
						[
							-82.53127320399996,
							27.32543733500006
						],
						[
							-82.53102774999991,
							27.325397473000066
						],
						[
							-82.52987475599991,
							27.324297281000042
						],
						[
							-82.5297456699999,
							27.324190526000052
						],
						[
							-82.52972872099991,
							27.322905820000074
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Avondale",
				"RegionID": "343953"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.54627032199994,
					27.314856458000065,
					-82.5378268469999,
					27.323134632000063
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.54239416999991,
							27.322847680000052
						],
						[
							-82.54186800199994,
							27.322752970000067
						],
						[
							-82.54111031899993,
							27.322795063000058
						],
						[
							-82.54047891699992,
							27.322763493000082
						],
						[
							-82.53960547799994,
							27.322679306000058
						],
						[
							-82.53913192599992,
							27.322500409000043
						],
						[
							-82.5386571549999,
							27.32286000000005
						],
						[
							-82.53784686799992,
							27.32286000000005
						],
						[
							-82.53784546799994,
							27.322781071000065
						],
						[
							-82.53784273399992,
							27.321668269000043
						],
						[
							-82.53784238599991,
							27.32152722700005
						],
						[
							-82.5378385539999,
							27.319967749000057
						],
						[
							-82.53783825999994,
							27.319847850000087
						],
						[
							-82.53782771899995,
							27.315535116000035
						],
						[
							-82.5378268469999,
							27.315255749000073
						],
						[
							-82.53841999999992,
							27.31525000000005
						],
						[
							-82.5385952339999,
							27.315123527000083
						],
						[
							-82.53866889799991,
							27.314955153000085
						],
						[
							-82.53878465499992,
							27.31490253700008
						],
						[
							-82.5390477389999,
							27.314892013000076
						],
						[
							-82.53925820599994,
							27.31490253700008
						],
						[
							-82.53964757099993,
							27.31488149000006
						],
						[
							-82.54059042499995,
							27.314856458000065
						],
						[
							-82.54061665899991,
							27.314958835000084
						],
						[
							-82.54061986299992,
							27.314978245000077
						],
						[
							-82.54063586399991,
							27.315082244000052
						],
						[
							-82.54064120999993,
							27.31515214700005
						],
						[
							-82.54099846799994,
							27.31535870600004
						],
						[
							-82.54144334499995,
							27.315571118000037
						],
						[
							-82.54176159899993,
							27.315712476000044
						],
						[
							-82.54214123299994,
							27.315805262000083
						],
						[
							-82.5423441339999,
							27.31577648500007
						],
						[
							-82.54257047999994,
							27.315639144000045
						],
						[
							-82.54258733899991,
							27.31562916500008
						],
						[
							-82.5427188399999,
							27.315566838000052
						],
						[
							-82.5433031259999,
							27.315345876000038
						],
						[
							-82.54337442899993,
							27.315322741000045
						],
						[
							-82.54344741199994,
							27.315305627000043
						],
						[
							-82.54352156599992,
							27.31529465200009
						],
						[
							-82.54359637699991,
							27.315289893000056
						],
						[
							-82.54367132499993,
							27.315291382000055
						],
						[
							-82.5452613249999,
							27.315389382000035
						],
						[
							-82.5453621659999,
							27.31540134100004
						],
						[
							-82.54551358599991,
							27.315441914000075
						],
						[
							-82.5456556609999,
							27.31550816500004
						],
						[
							-82.54578407299994,
							27.315598080000086
						],
						[
							-82.5458949209999,
							27.31570892700006
						],
						[
							-82.54598483599995,
							27.31583733900004
						],
						[
							-82.54605108599992,
							27.315979414000083
						],
						[
							-82.5460591719999,
							27.316002610000055
						],
						[
							-82.54609517199992,
							27.316110609000077
						],
						[
							-82.54611062599992,
							27.316162043000077
						],
						[
							-82.54623962599993,
							27.316643043000056
						],
						[
							-82.54625665899994,
							27.31671983500007
						],
						[
							-82.54627032199994,
							27.31687600000004
						],
						[
							-82.54625665899994,
							27.317032166000047
						],
						[
							-82.5462160859999,
							27.317183587000045
						],
						[
							-82.54614983499994,
							27.31732566100004
						],
						[
							-82.54608796299993,
							27.31741890300009
						],
						[
							-82.54509632299994,
							27.318728474000068
						],
						[
							-82.5446931919999,
							27.31958205500007
						],
						[
							-82.54465646499995,
							27.319651958000065
						],
						[
							-82.54461365299994,
							27.319718309000056
						],
						[
							-82.54456509699992,
							27.319780580000042
						],
						[
							-82.54451118299994,
							27.319838275000052
						],
						[
							-82.5444523409999,
							27.319890934000057
						],
						[
							-82.54447441499991,
							27.31996133100006
						],
						[
							-82.54449129599995,
							27.320033150000086
						],
						[
							-82.54450289599993,
							27.32010600800004
						],
						[
							-82.54450915099994,
							27.32017951900008
						],
						[
							-82.54451002999991,
							27.32025329000004
						],
						[
							-82.5445055269999,
							27.32032692900009
						],
						[
							-82.54438152699993,
							27.321413929000073
						],
						[
							-82.54436931299996,
							27.32149107200007
						],
						[
							-82.54435045199996,
							27.32156686500008
						],
						[
							-82.5443250859999,
							27.321640736000067
						],
						[
							-82.54429340599995,
							27.32171212700007
						],
						[
							-82.5442556509999,
							27.321780500000045
						],
						[
							-82.54379365099993,
							27.322537500000067
						],
						[
							-82.5437516419999,
							27.32260024800007
						],
						[
							-82.54370451699992,
							27.32265925100006
						],
						[
							-82.5436526069999,
							27.32271409200007
						],
						[
							-82.5435962809999,
							27.322764385000085
						],
						[
							-82.54353593299993,
							27.322809775000053
						],
						[
							-82.54347199099995,
							27.32284994300005
						],
						[
							-82.54340490399994,
							27.32288460500007
						],
						[
							-82.54286670999994,
							27.323134632000063
						],
						[
							-82.54239416999991,
							27.322847680000052
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Harbor Acres",
				"RegionID": "343955"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.54123514499992,
					27.305482794000056,
					-82.5336679959999,
					27.30945997200007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.5336915549999,
							27.30945274900006
						],
						[
							-82.53368611899992,
							27.308379613000056
						],
						[
							-82.53367873099995,
							27.30742273000004
						],
						[
							-82.5336679959999,
							27.305945570000063
						],
						[
							-82.5338307909999,
							27.30595948100006
						],
						[
							-82.53511577299992,
							27.305969843000074
						],
						[
							-82.53653547199993,
							27.305907667000042
						],
						[
							-82.53828677899992,
							27.305886941000043
						],
						[
							-82.53831786699993,
							27.305482794000056
						],
						[
							-82.54028902499994,
							27.305492048000076
						],
						[
							-82.54118956299993,
							27.305496276000042
						],
						[
							-82.54119828099994,
							27.305679694000048
						],
						[
							-82.54123121499993,
							27.306023157000084
						],
						[
							-82.54123514499992,
							27.306091179000077
						],
						[
							-82.54123391399992,
							27.306159303000072
						],
						[
							-82.54122752799992,
							27.306227138000054
						],
						[
							-82.54121602599992,
							27.306294295000043
						],
						[
							-82.5411994719999,
							27.306360389000076
						],
						[
							-82.54113123999991,
							27.306594721000067
						],
						[
							-82.54032911299993,
							27.309414642000036
						],
						[
							-82.53940078599993,
							27.30939119800007
						],
						[
							-82.53899700399995,
							27.30937642500004
						],
						[
							-82.53892999999994,
							27.30941000000007
						],
						[
							-82.5388536349999,
							27.309414582000045
						],
						[
							-82.53878495899994,
							27.309418702000073
						],
						[
							-82.53866408899995,
							27.309425955000055
						],
						[
							-82.53853177299993,
							27.30943389400005
						],
						[
							-82.53842999999995,
							27.309440000000052
						],
						[
							-82.5356799999999,
							27.309430000000077
						],
						[
							-82.53553697699994,
							27.30943128800004
						],
						[
							-82.53534704799995,
							27.30943366200006
						],
						[
							-82.53518334299991,
							27.30943570800008
						],
						[
							-82.5350305259999,
							27.309437618000064
						],
						[
							-82.53483999999992,
							27.309440000000052
						],
						[
							-82.53469645199993,
							27.309442496000088
						],
						[
							-82.5343863459999,
							27.309447890000058
						],
						[
							-82.5340114249999,
							27.30945441000006
						],
						[
							-82.53388629999995,
							27.309456586000067
						],
						[
							-82.5337880749999,
							27.30945829400008
						],
						[
							-82.53369159199991,
							27.30945997200007
						],
						[
							-82.5336915549999,
							27.30945274900006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Cherokee Park",
				"RegionID": "343960"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.53000840499993,
					27.308305535000045,
					-82.51181699999995,
					27.322905820000074
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.51408484199993,
							27.322842888000082
						],
						[
							-82.51406703299996,
							27.31896490300005
						],
						[
							-82.51361899999995,
							27.31896900000004
						],
						[
							-82.51362399999994,
							27.31876800000009
						],
						[
							-82.51333999999991,
							27.31876800000009
						],
						[
							-82.51340799999993,
							27.31816900000007
						],
						[
							-82.51360199999993,
							27.31818100000004
						],
						[
							-82.51362699999993,
							27.317957000000035
						],
						[
							-82.51351899999992,
							27.317150000000083
						],
						[
							-82.51348599999994,
							27.31693400000006
						],
						[
							-82.51276399999995,
							27.31693000000007
						],
						[
							-82.51274999999993,
							27.31655500000005
						],
						[
							-82.51181899999995,
							27.316544000000082
						],
						[
							-82.51181699999995,
							27.316338000000087
						],
						[
							-82.5133909999999,
							27.31634100000008
						],
						[
							-82.5134129999999,
							27.315514000000068
						],
						[
							-82.51342499999993,
							27.314487000000042
						],
						[
							-82.5133659999999,
							27.311925000000087
						],
						[
							-82.51336399999991,
							27.311772000000076
						],
						[
							-82.51403399999992,
							27.311772000000076
						],
						[
							-82.51415299999992,
							27.311772000000076
						],
						[
							-82.51415099999991,
							27.311926000000085
						],
						[
							-82.51499299999995,
							27.31198100000006
						],
						[
							-82.51610799999992,
							27.312019000000078
						],
						[
							-82.51621799999992,
							27.311987000000045
						],
						[
							-82.51628899999992,
							27.31197500000008
						],
						[
							-82.51634799999994,
							27.311971000000085
						],
						[
							-82.5173759999999,
							27.311968000000036
						],
						[
							-82.51874599999991,
							27.31196600000004
						],
						[
							-82.51884399999994,
							27.311970000000088
						],
						[
							-82.5189289999999,
							27.311980000000062
						],
						[
							-82.51907099999994,
							27.31201200000004
						],
						[
							-82.51916899999993,
							27.31204800000006
						],
						[
							-82.52055699999994,
							27.311929000000077
						],
						[
							-82.52067599999992,
							27.311951000000082
						],
						[
							-82.52078499999993,
							27.311960000000056
						],
						[
							-82.5219889999999,
							27.31195900000006
						],
						[
							-82.52545299999991,
							27.31185800000009
						],
						[
							-82.52540999999991,
							27.311454000000083
						],
						[
							-82.52544699999993,
							27.31055100000009
						],
						[
							-82.52546299999995,
							27.31009400000005
						],
						[
							-82.52546399999994,
							27.31006300000007
						],
						[
							-82.5254799999999,
							27.309612000000072
						],
						[
							-82.52552339499995,
							27.308346782000058
						],
						[
							-82.53000840499993,
							27.308305535000045
						],
						[
							-82.52999329199992,
							27.30854744600009
						],
						[
							-82.52997999999991,
							27.308800000000076
						],
						[
							-82.52997999999991,
							27.309016127000064
						],
						[
							-82.52996939199994,
							27.30933619600006
						],
						[
							-82.52994999999994,
							27.30964000000006
						],
						[
							-82.5299459869999,
							27.309762396000053
						],
						[
							-82.52993828299992,
							27.309997362000047
						],
						[
							-82.52992431699994,
							27.310338080000065
						],
						[
							-82.52990999999992,
							27.310560000000066
						],
						[
							-82.5299003319999,
							27.310701798000082
						],
						[
							-82.52989020399991,
							27.31085034700004
						],
						[
							-82.52987999999993,
							27.311000000000035
						],
						[
							-82.52987428799992,
							27.311083782000082
						],
						[
							-82.52986261399991,
							27.311254999000084
						],
						[
							-82.5298499999999,
							27.31144000000006
						],
						[
							-82.5298359759999,
							27.31174502400006
						],
						[
							-82.5298222369999,
							27.312043852000045
						],
						[
							-82.52980999999994,
							27.312310000000082
						],
						[
							-82.52980394299993,
							27.31246950600007
						],
						[
							-82.5297925939999,
							27.312768365000068
						],
						[
							-82.52978366999992,
							27.313003355000035
						],
						[
							-82.5297799999999,
							27.31310000000008
						],
						[
							-82.52976449999994,
							27.31327936000008
						],
						[
							-82.52974438299992,
							27.313512141000047
						],
						[
							-82.52972744899995,
							27.313708085000087
						],
						[
							-82.52970999999991,
							27.313910000000078
						],
						[
							-82.52970225699994,
							27.314111327000035
						],
						[
							-82.52969324999992,
							27.31434550000006
						],
						[
							-82.52967999999993,
							27.31469000000004
						],
						[
							-82.52967102299995,
							27.314835429000084
						],
						[
							-82.52965643899995,
							27.315071681000063
						],
						[
							-82.5296446399999,
							27.315262832000087
						],
						[
							-82.52962999999994,
							27.315500000000043
						],
						[
							-82.52965997299992,
							27.315497694000047
						],
						[
							-82.5297015239999,
							27.321045189000074
						],
						[
							-82.52972872099991,
							27.322905820000074
						],
						[
							-82.5258474769999,
							27.322894481000052
						],
						[
							-82.51408484199993,
							27.322842888000082
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Arlington Park",
				"RegionID": "343962"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.56766132199994,
					27.353296000000057,
					-82.54737074899992,
					27.386632543000076
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.56466590199994,
							27.38660669300009
						],
						[
							-82.56459099999995,
							27.386484000000053
						],
						[
							-82.55913813099994,
							27.38662660400007
						],
						[
							-82.55912299999994,
							27.38662700000009
						],
						[
							-82.55912399999994,
							27.386315000000085
						],
						[
							-82.55911999999995,
							27.386120000000062
						],
						[
							-82.55827599999992,
							27.386119000000065
						],
						[
							-82.55814974299994,
							27.386118448000047
						],
						[
							-82.55653514999995,
							27.381439829000044
						],
						[
							-82.54909436899993,
							27.35988231400006
						],
						[
							-82.54908002999991,
							27.359840939000037
						],
						[
							-82.54737074899992,
							27.354940525000075
						],
						[
							-82.5487470079999,
							27.354070807000085
						],
						[
							-82.54908829499993,
							27.353971666000064
						],
						[
							-82.54934152099992,
							27.353971717000036
						],
						[
							-82.54972685699994,
							27.353883642000085
						],
						[
							-82.55023329499994,
							27.35380657500008
						],
						[
							-82.55049752499991,
							27.353751527000043
						],
						[
							-82.55093806399992,
							27.353575481000064
						],
						[
							-82.55093776299992,
							27.35345415100005
						],
						[
							-82.55111405899993,
							27.353421109000067
						],
						[
							-82.55133198199991,
							27.35347008800005
						],
						[
							-82.55162049799993,
							27.353432252000065
						],
						[
							-82.5522929999999,
							27.353296000000057
						],
						[
							-82.55320958399994,
							27.353336941000066
						],
						[
							-82.5532690629999,
							27.353448811000078
						],
						[
							-82.55332008599993,
							27.353563414000064
						],
						[
							-82.55333297999994,
							27.353601464000068
						],
						[
							-82.55397351499994,
							27.355640402000063
						],
						[
							-82.55473657199991,
							27.357061426000087
						],
						[
							-82.55492335399992,
							27.357311383000084
						],
						[
							-82.55546090799993,
							27.357824420000043
						],
						[
							-82.55551063999991,
							27.357875815000057
						],
						[
							-82.55555613199994,
							27.357931000000065
						],
						[
							-82.55559709399995,
							27.357989625000073
						],
						[
							-82.55563326899994,
							27.358051320000072
						],
						[
							-82.55566442599991,
							27.35811569400005
						],
						[
							-82.55569036999992,
							27.358182341000088
						],
						[
							-82.55571093599991,
							27.35825083800006
						],
						[
							-82.5557259929999,
							27.358320753000044
						],
						[
							-82.55597432699994,
							27.359765672000037
						],
						[
							-82.55598732199991,
							27.35991800000005
						],
						[
							-82.55598573599991,
							27.35997137700008
						],
						[
							-82.55597677999992,
							27.360122018000084
						],
						[
							-82.55598119099994,
							27.36037960200008
						],
						[
							-82.55598126799993,
							27.36039562800005
						],
						[
							-82.5560880729999,
							27.36047108000008
						],
						[
							-82.5561573729999,
							27.360535750000054
						],
						[
							-82.5561843719999,
							27.36056374900005
						],
						[
							-82.55622591999992,
							27.360609927000045
						],
						[
							-82.55631583499991,
							27.36073833900008
						],
						[
							-82.55638208599993,
							27.360880414000064
						],
						[
							-82.5564226589999,
							27.361031834000073
						],
						[
							-82.55643328799994,
							27.361114188000045
						],
						[
							-82.55650817999994,
							27.362023590000035
						],
						[
							-82.55740821899991,
							27.364670954000076
						],
						[
							-82.55745658699993,
							27.364683914000068
						],
						[
							-82.55759866099993,
							27.36475016500009
						],
						[
							-82.55772707299991,
							27.36484008000008
						],
						[
							-82.55783792099993,
							27.364950927000052
						],
						[
							-82.55792783599992,
							27.365079339000093
						],
						[
							-82.55797081199995,
							27.365163752000058
						],
						[
							-82.5580319959999,
							27.365301418000058
						],
						[
							-82.5580700729999,
							27.365328080000044
						],
						[
							-82.55809906899992,
							27.36535348900009
						],
						[
							-82.55862806899995,
							27.365837489000057
						],
						[
							-82.55870992099995,
							27.365922927000042
						],
						[
							-82.55880228599995,
							27.366055637000045
						],
						[
							-82.55906473599993,
							27.366521935000037
						],
						[
							-82.55909509199995,
							27.366580855000052
						],
						[
							-82.5591210259999,
							27.366641849000075
						],
						[
							-82.55914239699992,
							27.366704588000065
						],
						[
							-82.55915908899993,
							27.366768731000036
						],
						[
							-82.55917101199992,
							27.36683392900005
						],
						[
							-82.55926924999994,
							27.36751133000007
						],
						[
							-82.56186079999992,
							27.370686066000076
						],
						[
							-82.56193221299992,
							27.370702637000083
						],
						[
							-82.56200199599994,
							27.370725105000076
						],
						[
							-82.56206966199994,
							27.370753312000094
						],
						[
							-82.5621347419999,
							27.37078706200009
						],
						[
							-82.5621967809999,
							27.37082611900007
						],
						[
							-82.56222942099993,
							27.370848578000054
						],
						[
							-82.56228695099992,
							27.370872717000054
						],
						[
							-82.56238866099994,
							27.37092316400009
						],
						[
							-82.56251707299992,
							27.37101307900008
						],
						[
							-82.56262792099994,
							27.371123927000042
						],
						[
							-82.56271783599993,
							27.37125233900008
						],
						[
							-82.56278408599991,
							27.371394413000075
						],
						[
							-82.56282465899996,
							27.371545834000077
						],
						[
							-82.56283832199995,
							27.371702000000084
						],
						[
							-82.56282465899996,
							27.37185816500005
						],
						[
							-82.56281514799991,
							27.371900889000074
						],
						[
							-82.5630095759999,
							27.372110658000054
						],
						[
							-82.5630506089999,
							27.372158150000075
						],
						[
							-82.56420490999994,
							27.373592423000048
						],
						[
							-82.56428548899993,
							27.37364614200004
						],
						[
							-82.56464096299993,
							27.373693581000055
						],
						[
							-82.56478422799995,
							27.373724758000037
						],
						[
							-82.56505322799991,
							27.373806757000068
						],
						[
							-82.56514281499994,
							27.373839349000036
						],
						[
							-82.56612381499991,
							27.374256349000063
						],
						[
							-82.56622166099993,
							27.374305164000077
						],
						[
							-82.5663270469999,
							27.37437639600006
						],
						[
							-82.56676304699994,
							27.37471839600005
						],
						[
							-82.56682254399993,
							27.37476940600004
						],
						[
							-82.56687737399994,
							27.374825402000056
						],
						[
							-82.56692712099994,
							27.37488595800005
						],
						[
							-82.56731312199992,
							27.37539995900005
						],
						[
							-82.56735708899993,
							27.375464105000052
						],
						[
							-82.56739534999991,
							27.375531811000087
						],
						[
							-82.56742761899994,
							27.37560256800009
						],
						[
							-82.5674536539999,
							27.37567584900006
						],
						[
							-82.56747326099992,
							27.375751106000052
						],
						[
							-82.56764126099995,
							27.376533106000068
						],
						[
							-82.56764765899993,
							27.376565834000075
						],
						[
							-82.56766132199994,
							27.376722000000086
						],
						[
							-82.56764765899993,
							27.37687816600004
						],
						[
							-82.56760708599991,
							27.377029586000052
						],
						[
							-82.56754083599992,
							27.37717166100009
						],
						[
							-82.56748175399991,
							27.377261198000042
						],
						[
							-82.5672637539999,
							27.377552198000046
						],
						[
							-82.56723292099991,
							27.377591073000076
						],
						[
							-82.56717027999991,
							27.37765371300009
						],
						[
							-82.56721136999994,
							27.377712015000043
						],
						[
							-82.5672474989999,
							27.37777351600005
						],
						[
							-82.5672784169999,
							27.377837793000083
						],
						[
							-82.56730391499991,
							27.377904407000074
						],
						[
							-82.56732381599994,
							27.377972901000078
						],
						[
							-82.56733798499994,
							27.378042807000046
						],
						[
							-82.5673463249999,
							27.378113644000052
						],
						[
							-82.56737832499994,
							27.37850464400009
						],
						[
							-82.5673813219999,
							27.37857800000006
						],
						[
							-82.5673676589999,
							27.378734166000072
						],
						[
							-82.56732708599993,
							27.37888558600008
						],
						[
							-82.5672608349999,
							27.379027661000066
						],
						[
							-82.5672104709999,
							27.379105361000086
						],
						[
							-82.56697447099994,
							27.37943136000007
						],
						[
							-82.5669322139999,
							27.379485283000065
						],
						[
							-82.56688597399994,
							27.37953583300009
						],
						[
							-82.56683602099992,
							27.379582716000073
						],
						[
							-82.5667826429999,
							27.379625660000045
						],
						[
							-82.5655025399999,
							27.380577575000075
						],
						[
							-82.56532798299992,
							27.381215360000056
						],
						[
							-82.5655810319999,
							27.38270185600004
						],
						[
							-82.5658685279999,
							27.38445709000007
						],
						[
							-82.56644295599995,
							27.386632543000076
						],
						[
							-82.56550922499991,
							27.386618961000067
						],
						[
							-82.56466590199994,
							27.38660669300009
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Indian Beach-Sapphire Shores",
				"RegionID": "343969"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.05611453799992,
					26.75293221700008,
					-80.04944730499994,
					26.763499102000083
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.05021407899994,
							26.75296507300004
						],
						[
							-80.05019107299995,
							26.75293221700008
						],
						[
							-80.05127039699994,
							26.752960598000072
						],
						[
							-80.05275156999994,
							26.75299954500008
						],
						[
							-80.05274986699993,
							26.75305012800004
						],
						[
							-80.05439999999993,
							26.753100000000074
						],
						[
							-80.05611453799992,
							26.75314932200007
						],
						[
							-80.05610460799994,
							26.753260607000072
						],
						[
							-80.05609058899995,
							26.753417707000043
						],
						[
							-80.05607999999995,
							26.75362000000007
						],
						[
							-80.0560614659999,
							26.75375045000004
						],
						[
							-80.05603906899995,
							26.75401910000005
						],
						[
							-80.05601999999993,
							26.754320000000064
						],
						[
							-80.05600442999992,
							26.754462081000042
						],
						[
							-80.05596665599997,
							26.754795653000087
						],
						[
							-80.05593999999991,
							26.75505000000004
						],
						[
							-80.0559240149999,
							26.75519386800005
						],
						[
							-80.05588712999992,
							26.755525826000053
						],
						[
							-80.05585999999994,
							26.75577000000004
						],
						[
							-80.0558364879999,
							26.75604626900008
						],
						[
							-80.05580281099992,
							26.756441976000076
						],
						[
							-80.05577999999991,
							26.756710000000055
						],
						[
							-80.05576142799993,
							26.756870182000057
						],
						[
							-80.0557340439999,
							26.75710637000009
						],
						[
							-80.05572206999994,
							26.757412403000046
						],
						[
							-80.05570466199993,
							26.757580104000056
						],
						[
							-80.05567667999992,
							26.757849683000074
						],
						[
							-80.05562999999995,
							26.758110000000045
						],
						[
							-80.05561336699992,
							26.75846890200006
						],
						[
							-80.05557897599994,
							26.758808773000055
						],
						[
							-80.05555297099994,
							26.759197553000035
						],
						[
							-80.05549999999994,
							26.759550000000047
						],
						[
							-80.05550963799993,
							26.759752252000055
						],
						[
							-80.05545101199993,
							26.760067878000086
						],
						[
							-80.05542999999996,
							26.760290000000055
						],
						[
							-80.05544172799996,
							26.760432718000065
						],
						[
							-80.05540903399992,
							26.760747671000047
						],
						[
							-80.05536999999993,
							26.76096000000007
						],
						[
							-80.05536372499995,
							26.76118971500006
						],
						[
							-80.05533092899992,
							26.76141583100008
						],
						[
							-80.0553099999999,
							26.761660000000063
						],
						[
							-80.05529701299992,
							26.76181151600008
						],
						[
							-80.05528535999991,
							26.76207966800007
						],
						[
							-80.05524999999994,
							26.762360000000058
						],
						[
							-80.0552337659999,
							26.76253857900008
						],
						[
							-80.0552321529999,
							26.762680919000047
						],
						[
							-80.0552256439999,
							26.76290196800005
						],
						[
							-80.0552199999999,
							26.763060000000053
						],
						[
							-80.05521203599994,
							26.763203350000083
						],
						[
							-80.05520999999993,
							26.763298726000073
						],
						[
							-80.05520819199995,
							26.76344169400005
						],
						[
							-80.05520755299995,
							26.763499102000083
						],
						[
							-80.05519799999992,
							26.76349900000008
						],
						[
							-80.05229199999991,
							26.763348000000065
						],
						[
							-80.05042916399992,
							26.763257742000064
						],
						[
							-80.05034472699992,
							26.76325365000008
						],
						[
							-80.05006299999991,
							26.763240000000053
						],
						[
							-80.04944730499994,
							26.763201519000063
						],
						[
							-80.04944806499992,
							26.76318401700007
						],
						[
							-80.04957542699992,
							26.761720770000068
						],
						[
							-80.04955796099995,
							26.76156033600006
						],
						[
							-80.04955267799994,
							26.76146300000005
						],
						[
							-80.04955267799994,
							26.76058900000004
						],
						[
							-80.0495663399999,
							26.760432834000085
						],
						[
							-80.04960691299993,
							26.760281414000076
						],
						[
							-80.0496731639999,
							26.76013933900009
						],
						[
							-80.04976307899996,
							26.760010927000053
						],
						[
							-80.04987392699991,
							26.75990007900009
						],
						[
							-80.04995834999994,
							26.75984096600007
						],
						[
							-80.04996267799993,
							26.75979381400009
						],
						[
							-80.04996267799993,
							26.759719225000083
						],
						[
							-80.04995134099994,
							26.759667165000053
						],
						[
							-80.04993894299992,
							26.759558686000048
						],
						[
							-80.04993294299993,
							26.75944568700004
						],
						[
							-80.04993185199993,
							26.759380296000074
						],
						[
							-80.04994948199993,
							26.758484895000038
						],
						[
							-80.04990783799991,
							26.758177875000058
						],
						[
							-80.04990053099993,
							26.758096151000075
						],
						[
							-80.04986153099992,
							26.75720115100006
						],
						[
							-80.04986190499994,
							26.757115051000085
						],
						[
							-80.04989287699993,
							26.756522576000066
						],
						[
							-80.04992985599995,
							26.755798982000044
						],
						[
							-80.04994472899995,
							26.75550962200009
						],
						[
							-80.04999560999994,
							26.754384065000067
						],
						[
							-80.05000462399994,
							26.754187750000085
						],
						[
							-80.0500173399999,
							26.754072834000056
						],
						[
							-80.05005791299993,
							26.753921414000047
						],
						[
							-80.0501241639999,
							26.75377933900006
						],
						[
							-80.05021407899994,
							26.75365092700008
						],
						[
							-80.05027812499992,
							26.753586881000047
						],
						[
							-80.0503483569999,
							26.75318201400006
						],
						[
							-80.05035974899994,
							26.753100304000043
						],
						[
							-80.0503249269999,
							26.75307592100006
						],
						[
							-80.05021407899994,
							26.75296507300004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "West Palm Beach",
				"Name": "Northwood Harbor",
				"RegionID": "275035"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.06087999999994,
					26.74584628000008,
					-80.05616550699996,
					26.753039581000053
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.0565499999999,
							26.746050000000082
						],
						[
							-80.05655727599994,
							26.74584628000008
						],
						[
							-80.05655976299994,
							26.745846360000087
						],
						[
							-80.05683630499993,
							26.745855314000043
						],
						[
							-80.05707999999993,
							26.74586000000005
						],
						[
							-80.05730152699995,
							26.745866548000038
						],
						[
							-80.05757206899995,
							26.74587454400006
						],
						[
							-80.0579726389999,
							26.745886383000084
						],
						[
							-80.0583293329999,
							26.745896926000057
						],
						[
							-80.05870796499994,
							26.745908117000056
						],
						[
							-80.05911753299995,
							26.745909551000068
						],
						[
							-80.0592700439999,
							26.745913784000038
						],
						[
							-80.05957339199995,
							26.745929086000046
						],
						[
							-80.05962128699991,
							26.745929889000085
						],
						[
							-80.05982350499994,
							26.745933277000063
						],
						[
							-80.05998453399991,
							26.745935976000055
						],
						[
							-80.06022999999993,
							26.745940000000076
						],
						[
							-80.0602479449999,
							26.74608038200006
						],
						[
							-80.06027648999992,
							26.746297323000082
						],
						[
							-80.0603093009999,
							26.746546685000055
						],
						[
							-80.06033999999994,
							26.74678000000006
						],
						[
							-80.06037646499993,
							26.747007904000043
						],
						[
							-80.06041865999993,
							26.747271624000064
						],
						[
							-80.06045999999992,
							26.74753000000004
						],
						[
							-80.06052112899994,
							26.747906963000048
						],
						[
							-80.0605799999999,
							26.748270000000048
						],
						[
							-80.06060167899994,
							26.74843258900006
						],
						[
							-80.0606204629999,
							26.748573469000064
						],
						[
							-80.06064681399994,
							26.74877110700004
						],
						[
							-80.06067999999993,
							26.749020000000087
						],
						[
							-80.06070242899995,
							26.74916098500006
						],
						[
							-80.06072201799994,
							26.74928411600007
						],
						[
							-80.06074999999993,
							26.749460000000056
						],
						[
							-80.06076881099995,
							26.749626162000084
						],
						[
							-80.06078264699994,
							26.749748381000074
						],
						[
							-80.06080552199995,
							26.74995044700006
						],
						[
							-80.0608299999999,
							26.750170000000082
						],
						[
							-80.0608385889999,
							26.750290248000056
						],
						[
							-80.06085251999993,
							26.750506704000088
						],
						[
							-80.06086006999993,
							26.750676573000078
						],
						[
							-80.06086487399995,
							26.750784672000066
						],
						[
							-80.06086999999991,
							26.75090000000006
						],
						[
							-80.06087255199994,
							26.75107861400005
						],
						[
							-80.0608747579999,
							26.751233093000053
						],
						[
							-80.06087763799991,
							26.751434646000064
						],
						[
							-80.06087999999994,
							26.751600000000053
						],
						[
							-80.06087610899993,
							26.751759518000085
						],
						[
							-80.0608727149999,
							26.75189869400009
						],
						[
							-80.06086905699993,
							26.75203829600008
						],
						[
							-80.06085999999993,
							26.752310000000083
						],
						[
							-80.06084014499993,
							26.752517063000084
						],
						[
							-80.06082074999995,
							26.752719322000075
						],
						[
							-80.0608060479999,
							26.752872644000036
						],
						[
							-80.06080272999992,
							26.75303425600004
						],
						[
							-80.06076778199991,
							26.753039581000053
						],
						[
							-80.0606213449999,
							26.753036818000055
						],
						[
							-80.0604965149999,
							26.753034463000063
						],
						[
							-80.0604055419999,
							26.753032746000088
						],
						[
							-80.06020534299995,
							26.75302817800008
						],
						[
							-80.06003539799991,
							26.753022513000076
						],
						[
							-80.05988143999991,
							26.75301685800008
						],
						[
							-80.05974996399993,
							26.753011599000047
						],
						[
							-80.05970999999994,
							26.753010000000074
						],
						[
							-80.05958101099992,
							26.753005443000063
						],
						[
							-80.05945582299995,
							26.752987033000068
						],
						[
							-80.05927188099992,
							26.752967761000036
						],
						[
							-80.05907163799992,
							26.752961181000046
						],
						[
							-80.0587866759999,
							26.752951816000063
						],
						[
							-80.05858567399991,
							26.752945210000064
						],
						[
							-80.0582622039999,
							26.752934579000055
						],
						[
							-80.05798494399994,
							26.752925468000058
						],
						[
							-80.05772308699996,
							26.752916862000063
						],
						[
							-80.05749127799993,
							26.75290924400008
						],
						[
							-80.05715187699991,
							26.75289833900007
						],
						[
							-80.05682017799995,
							26.752888862000077
						],
						[
							-80.05655825299995,
							26.752881379000087
						],
						[
							-80.0563729239999,
							26.752876084000036
						],
						[
							-80.05622655399992,
							26.752871902000038
						],
						[
							-80.05616550699996,
							26.752869513000068
						],
						[
							-80.05619999899994,
							26.75249000100007
						],
						[
							-80.0562599989999,
							26.751690001000043
						],
						[
							-80.05632999999995,
							26.750990001000048
						],
						[
							-80.05639999899995,
							26.750190001000078
						],
						[
							-80.05645999899991,
							26.74945000100007
						],
						[
							-80.05645999899991,
							26.749259731000052
						],
						[
							-80.0564599999999,
							26.748950000000036
						],
						[
							-80.0564599999999,
							26.748540000000048
						],
						[
							-80.05648999999994,
							26.747640000000047
						],
						[
							-80.05651999999992,
							26.746890001000054
						],
						[
							-80.0565499999999,
							26.746050000000082
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "West Palm Beach",
				"Name": "Pinewood Park",
				"RegionID": "275037"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.43477280199994,
					28.00719515800006,
					-82.41418115899995,
					28.027347322000082
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.41982893599993,
							28.020192897000076
						],
						[
							-82.42006352199991,
							28.019424257000082
						],
						[
							-82.42031619099993,
							28.018758130000037
						],
						[
							-82.42043104099992,
							28.018390611000086
						],
						[
							-82.42048638599994,
							28.018237510000063
						],
						[
							-82.42048755299993,
							28.018234549000056
						],
						[
							-82.4205086469999,
							28.018086310000058
						],
						[
							-82.42051124799991,
							28.018069208000043
						],
						[
							-82.42052045499992,
							28.01801236500006
						],
						[
							-82.42085048299992,
							28.017168710000078
						],
						[
							-82.42120019399994,
							28.016319412000087
						],
						[
							-82.42174973999995,
							28.015320238000072
						],
						[
							-82.42211610399994,
							28.01465412200008
						],
						[
							-82.42244916199991,
							28.013938047000067
						],
						[
							-82.4225657319999,
							28.013488419000055
						],
						[
							-82.42251577299993,
							28.012522551000075
						],
						[
							-82.42214940999992,
							28.01163994700005
						],
						[
							-82.4217164339999,
							28.01094052500008
						],
						[
							-82.4208005239999,
							28.010607467000057
						],
						[
							-82.41985130899991,
							28.010107880000078
						],
						[
							-82.41936837499992,
							28.009941351000066
						],
						[
							-82.4183692009999,
							28.009941351000066
						],
						[
							-82.41740333199994,
							28.009608293000046
						],
						[
							-82.41613771199991,
							28.00934184600004
						],
						[
							-82.41517184299994,
							28.009258582000086
						],
						[
							-82.41442715999996,
							28.009341324000047
						],
						[
							-82.41419437899992,
							28.008818766000047
						],
						[
							-82.41418115899995,
							28.00877024600004
						],
						[
							-82.41418219799993,
							28.007379205000063
						],
						[
							-82.41813938899992,
							28.00719515800006
						],
						[
							-82.42628194799995,
							28.007299868000075
						],
						[
							-82.4263571329999,
							28.010891041000036
						],
						[
							-82.4345636889999,
							28.010891075000075
						],
						[
							-82.43449561199992,
							28.020006352000053
						],
						[
							-82.43477280199994,
							28.02206372900008
						],
						[
							-82.43151815499994,
							28.022754500000076
						],
						[
							-82.43048699999991,
							28.023358000000087
						],
						[
							-82.43052367999991,
							28.023708927000087
						],
						[
							-82.43026557199994,
							28.023881000000074
						],
						[
							-82.42990913599994,
							28.024016199000073
						],
						[
							-82.42920855599994,
							28.02420056300008
						],
						[
							-82.4284833939999,
							28.02432347100006
						],
						[
							-82.4277828139999,
							28.02493801500009
						],
						[
							-82.42722972399991,
							28.025380487000064
						],
						[
							-82.42611125399993,
							28.026117940000063
						],
						[
							-82.42559681599994,
							28.026495629000067
						],
						[
							-82.42514027399994,
							28.026830811000085
						],
						[
							-82.4246449819999,
							28.027078043000078
						],
						[
							-82.4240783699999,
							28.027290213000075
						],
						[
							-82.42405207799993,
							28.02729959500005
						],
						[
							-82.42399576199995,
							28.02731667800009
						],
						[
							-82.42393844899993,
							28.027330042000074
						],
						[
							-82.4238803849999,
							28.02733962800005
						],
						[
							-82.4238218189999,
							28.02734539700009
						],
						[
							-82.42376299999995,
							28.027347322000082
						],
						[
							-82.4237245619999,
							28.02734650000008
						],
						[
							-82.42335056199994,
							28.027330500000062
						],
						[
							-82.42333018199992,
							28.027329397000074
						],
						[
							-82.42327161499992,
							28.027323628000094
						],
						[
							-82.42325807599991,
							28.027321741000037
						],
						[
							-82.4229250759999,
							28.027272741000047
						],
						[
							-82.4228928579999,
							28.027267401000078
						],
						[
							-82.42258385899993,
							28.027210401000048
						],
						[
							-82.42257155099992,
							28.02720804200004
						],
						[
							-82.42251423899995,
							28.027194678000058
						],
						[
							-82.42245792299991,
							28.02717759500007
						],
						[
							-82.42240284499991,
							28.02715686500005
						],
						[
							-82.4223492399999,
							28.02713257700009
						],
						[
							-82.4222973389999,
							28.027104836000035
						],
						[
							-82.42224736399993,
							28.027073759000075
						],
						[
							-82.42224192899994,
							28.02707009900007
						],
						[
							-82.42188392899993,
							28.026827099000062
						],
						[
							-82.42184152699991,
							28.026796480000087
						],
						[
							-82.42179603599993,
							28.026759146000074
						],
						[
							-82.42175308299994,
							28.026718917000043
						],
						[
							-82.4217128539999,
							28.026675965000038
						],
						[
							-82.42168914899992,
							28.026647791000073
						],
						[
							-82.42155114899992,
							28.02647679000006
						],
						[
							-82.4215375199999,
							28.02645947200006
						],
						[
							-82.42150324099993,
							28.026411636000034
						],
						[
							-82.42147327699992,
							28.026363582000045
						],
						[
							-82.42132927599994,
							28.026115583000035
						],
						[
							-82.42132816399993,
							28.026113661000068
						],
						[
							-82.42130042199996,
							28.02606176000006
						],
						[
							-82.42127613399992,
							28.026008156000046
						],
						[
							-82.42125540399991,
							28.025953077000054
						],
						[
							-82.42123832099992,
							28.02589676200006
						],
						[
							-82.42123333099995,
							28.025877266000066
						],
						[
							-82.4210805159999,
							28.02525124400006
						],
						[
							-82.42073756799994,
							28.02455202200008
						],
						[
							-82.4207227149999,
							28.02452018100007
						],
						[
							-82.4205435799999,
							28.024115711000036
						],
						[
							-82.42030188699994,
							28.023647551000067
						],
						[
							-82.42029442299993,
							28.023632760000055
						],
						[
							-82.4202710859999,
							28.023581444000058
						],
						[
							-82.42000308599997,
							28.02293944400009
						],
						[
							-82.42000213499995,
							28.02293715600007
						],
						[
							-82.41998140499993,
							28.022882078000066
						],
						[
							-82.41996432199994,
							28.022825762000082
						],
						[
							-82.4199509579999,
							28.02276844900007
						],
						[
							-82.4199483139999,
							28.022754587000065
						],
						[
							-82.41982831399991,
							28.022097586000086
						],
						[
							-82.41982137199994,
							28.022053385000053
						],
						[
							-82.41981973999992,
							28.02204024100007
						],
						[
							-82.41975478799992,
							28.02148365700009
						],
						[
							-82.41974483699994,
							28.021399073000055
						],
						[
							-82.41974060399991,
							28.021352818000082
						],
						[
							-82.41973867799993,
							28.02129400000007
						],
						[
							-82.41973981799993,
							28.02124873300005
						],
						[
							-82.41977781799994,
							28.020494734000067
						],
						[
							-82.41977860399993,
							28.020481182000083
						],
						[
							-82.41978437199992,
							28.020422615000086
						],
						[
							-82.4197939579999,
							28.020364551000057
						],
						[
							-82.41979479699995,
							28.02036038500006
						],
						[
							-82.41982893599993,
							28.020192897000076
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "River Grove",
				"RegionID": "275184"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.5426401499999,
					27.355232000000058,
					-82.52720899999991,
					27.367928000000063
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.53533599999992,
							27.36713400000008
						],
						[
							-82.5350679149999,
							27.36713248500007
						],
						[
							-82.53462799999994,
							27.36713000000009
						],
						[
							-82.53352499999994,
							27.367128000000037
						],
						[
							-82.53310399999992,
							27.367125000000044
						],
						[
							-82.53302490899995,
							27.367124436000044
						],
						[
							-82.53226299999994,
							27.36711900000006
						],
						[
							-82.53178391099993,
							27.367115143000035
						],
						[
							-82.53164199999992,
							27.367113999000082
						],
						[
							-82.53163632299993,
							27.367113952000068
						],
						[
							-82.53069399999993,
							27.367106000000035
						],
						[
							-82.53063199999991,
							27.36710692300005
						],
						[
							-82.53059423699995,
							27.367107485000076
						],
						[
							-82.52981271999994,
							27.367119117000072
						],
						[
							-82.52961899999991,
							27.367122000000055
						],
						[
							-82.52888499999995,
							27.362543000000073
						],
						[
							-82.52882199999993,
							27.362078000000054
						],
						[
							-82.52867199999991,
							27.361277000000086
						],
						[
							-82.52852299999995,
							27.360486000000037
						],
						[
							-82.52837230799992,
							27.35990810900006
						],
						[
							-82.52831099999992,
							27.359673000000043
						],
						[
							-82.5282949999999,
							27.359601000000055
						],
						[
							-82.52825258699994,
							27.35960287100005
						],
						[
							-82.52781899999991,
							27.359622000000062
						],
						[
							-82.52720899999991,
							27.35611700000004
						],
						[
							-82.52745199999993,
							27.356122000000084
						],
						[
							-82.52724699999993,
							27.355232000000058
						],
						[
							-82.52784831299994,
							27.35592557700005
						],
						[
							-82.5293864919999,
							27.35592547200008
						],
						[
							-82.53055949899993,
							27.355943763000084
						],
						[
							-82.53186077399994,
							27.355998784000064
						],
						[
							-82.5323181149999,
							27.356007454000064
						],
						[
							-82.5327076399999,
							27.35601483800008
						],
						[
							-82.5357279829999,
							27.356072096000048
						],
						[
							-82.54074991499994,
							27.35614537500004
						],
						[
							-82.54080953099992,
							27.35645886000009
						],
						[
							-82.54143611699993,
							27.35975372100006
						],
						[
							-82.5426401499999,
							27.367189988000064
						],
						[
							-82.5425699999999,
							27.367189000000053
						],
						[
							-82.54154099999994,
							27.36717400000009
						],
						[
							-82.53886699999993,
							27.367161000000067
						],
						[
							-82.53870499999994,
							27.367155000000082
						],
						[
							-82.53848799999992,
							27.367148000000043
						],
						[
							-82.53703699999994,
							27.367142000000058
						],
						[
							-82.53683199999995,
							27.36713300000008
						],
						[
							-82.53665499999995,
							27.36714100000006
						],
						[
							-82.53664338599992,
							27.367793876000064
						],
						[
							-82.53664099999992,
							27.367928000000063
						],
						[
							-82.5352289999999,
							27.36792200000008
						],
						[
							-82.53523327499994,
							27.36789051700004
						],
						[
							-82.53533599999992,
							27.36713400000008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Amaryllis Park",
				"RegionID": "343971"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.4973037389999,
					27.34489740700008,
					-82.48853058999993,
					27.348379204000082
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.48853058999993,
							27.34646193000009
						],
						[
							-82.48963485999991,
							27.34489740700008
						],
						[
							-82.4973037389999,
							27.344912785000076
						],
						[
							-82.49730360799992,
							27.34670738300008
						],
						[
							-82.49724225999995,
							27.347121492000042
						],
						[
							-82.49715029599993,
							27.348057065000035
						],
						[
							-82.49461957799991,
							27.34805707000004
						],
						[
							-82.4940981069999,
							27.34817976800008
						],
						[
							-82.49371467299994,
							27.348302464000085
						],
						[
							-82.49319320399991,
							27.348379204000082
						],
						[
							-82.49288645599995,
							27.34833314000008
						],
						[
							-82.49279824799993,
							27.34831238600009
						],
						[
							-82.49262572299995,
							27.34827179200005
						],
						[
							-82.49225762699992,
							27.34817976700009
						],
						[
							-82.4909539539999,
							27.347673635000035
						],
						[
							-82.48934353299991,
							27.346906769000043
						],
						[
							-82.48853058999993,
							27.34646193000009
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Glen Oaks Estates",
				"RegionID": "343976"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.49761099999995,
					27.32999700000005,
					-82.48994044599993,
					27.337511462000066
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.49380076499995,
							27.337478309000062
						],
						[
							-82.49315462899995,
							27.337428569000057
						],
						[
							-82.48994044599993,
							27.33742862300005
						],
						[
							-82.48994059799992,
							27.33483698000009
						],
						[
							-82.4900844519999,
							27.334574659000054
						],
						[
							-82.49024891299992,
							27.33442116100008
						],
						[
							-82.49041337499995,
							27.334223807000058
						],
						[
							-82.4904901239999,
							27.333949705000066
						],
						[
							-82.49051205199993,
							27.333730423000077
						],
						[
							-82.4904791589999,
							27.33337957100008
						],
						[
							-82.49044626699992,
							27.332886186000053
						],
						[
							-82.49044626699992,
							27.332535335000046
						],
						[
							-82.49053397999995,
							27.332348945000035
						],
						[
							-82.49070940599995,
							27.331811704000074
						],
						[
							-82.4908848309999,
							27.33137314000004
						],
						[
							-82.49093965199995,
							27.331120965000082
						],
						[
							-82.49093965199995,
							27.33092361100006
						],
						[
							-82.49092868799994,
							27.330671437000035
						],
						[
							-82.49091772399993,
							27.330452155000046
						],
						[
							-82.49091772399993,
							27.330279140000073
						],
						[
							-82.49146399999995,
							27.330284000000063
						],
						[
							-82.49144109899993,
							27.330403482000065
						],
						[
							-82.4914179999999,
							27.330524000000082
						],
						[
							-82.49163099999993,
							27.330504000000076
						],
						[
							-82.49267348699993,
							27.330403482000065
						],
						[
							-82.49565499999994,
							27.33011600000009
						],
						[
							-82.49639699999994,
							27.32999700000005
						],
						[
							-82.49638899999992,
							27.33010100000007
						],
						[
							-82.49624904199993,
							27.330403482000065
						],
						[
							-82.4958059999999,
							27.331361000000072
						],
						[
							-82.49615999999992,
							27.33137700000009
						],
						[
							-82.4965699999999,
							27.331400000000087
						],
						[
							-82.49660599999993,
							27.331116000000065
						],
						[
							-82.4969339999999,
							27.331135000000074
						],
						[
							-82.4969319999999,
							27.331361000000072
						],
						[
							-82.49761099999995,
							27.331410000000062
						],
						[
							-82.4975782699999,
							27.334794264000042
						],
						[
							-82.49737945599992,
							27.337130346000038
						],
						[
							-82.49736289299994,
							27.337511462000066
						],
						[
							-82.49380076499995,
							27.337478309000062
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Eastwood Oaks",
				"RegionID": "343978"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.50991999999991,
					27.32281000000006,
					-82.50360199999994,
					27.329960000000085
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.50571999999994,
							27.32994000000008
						],
						[
							-82.50523599999991,
							27.32980400000008
						],
						[
							-82.50360199999994,
							27.329811000000067
						],
						[
							-82.50365399999993,
							27.328618000000063
						],
						[
							-82.50363899999991,
							27.328017000000045
						],
						[
							-82.50430299999994,
							27.32801500000005
						],
						[
							-82.50451599999991,
							27.32801500000005
						],
						[
							-82.50473199999995,
							27.328018000000043
						],
						[
							-82.50529499999995,
							27.328012000000058
						],
						[
							-82.50522499999994,
							27.325406000000047
						],
						[
							-82.5051959999999,
							27.32395500000007
						],
						[
							-82.50523299999992,
							27.323383000000035
						],
						[
							-82.50524899999994,
							27.323133000000045
						],
						[
							-82.50520999999992,
							27.32285100000007
						],
						[
							-82.50545999999991,
							27.322848000000082
						],
						[
							-82.50562999999994,
							27.322846000000084
						],
						[
							-82.5057359999999,
							27.322845000000086
						],
						[
							-82.50585711399992,
							27.322844677000035
						],
						[
							-82.5059599999999,
							27.322840000000042
						],
						[
							-82.50607064899992,
							27.32283940500008
						],
						[
							-82.50652173799995,
							27.32283698000009
						],
						[
							-82.50678289399991,
							27.322835576000045
						],
						[
							-82.50692540699993,
							27.322834810000074
						],
						[
							-82.50721030499994,
							27.322833278000076
						],
						[
							-82.50750707399993,
							27.32283168200007
						],
						[
							-82.50781999999992,
							27.322830000000067
						],
						[
							-82.50800549999991,
							27.322827973000077
						],
						[
							-82.50824315299991,
							27.322825375000036
						],
						[
							-82.50840932899992,
							27.322823559000085
						],
						[
							-82.50883663699994,
							27.322818889000075
						],
						[
							-82.50945411999993,
							27.322812141000043
						],
						[
							-82.50988999999993,
							27.32281000000006
						],
						[
							-82.50988999999993,
							27.322972339000046
						],
						[
							-82.50988999999993,
							27.32328098700009
						],
						[
							-82.50988999999993,
							27.323554023000046
						],
						[
							-82.50988999999993,
							27.323720000000037
						],
						[
							-82.50988999999993,
							27.32395764000006
						],
						[
							-82.50988999999993,
							27.32429003100009
						],
						[
							-82.50988999999993,
							27.32462000000004
						],
						[
							-82.50988999999993,
							27.32485984400006
						],
						[
							-82.50988999999993,
							27.325204106000058
						],
						[
							-82.50988999999993,
							27.32552000000004
						],
						[
							-82.50988999999993,
							27.32579766100008
						],
						[
							-82.50988999999993,
							27.326236891000065
						],
						[
							-82.50988999999993,
							27.326440000000048
						],
						[
							-82.50988999999993,
							27.326676122000038
						],
						[
							-82.50988999999993,
							27.326870000000042
						],
						[
							-82.50988999999993,
							27.32699664200004
						],
						[
							-82.50988999999993,
							27.327139095000064
						],
						[
							-82.50988999999993,
							27.327352775000065
						],
						[
							-82.50988999999993,
							27.327570000000037
						],
						[
							-82.50988999999993,
							27.327685166000037
						],
						[
							-82.50988999999993,
							27.32785000000007
						],
						[
							-82.50988999999993,
							27.328053170000093
						],
						[
							-82.50988999999993,
							27.328290000000038
						],
						[
							-82.50988999999993,
							27.328421174000084
						],
						[
							-82.50988999999993,
							27.328550000000064
						],
						[
							-82.50988999999993,
							27.328753565000056
						],
						[
							-82.50988999999993,
							27.328960000000052
						],
						[
							-82.50988999999993,
							27.329109698000085
						],
						[
							-82.50988999999993,
							27.32926000000009
						],
						[
							-82.50988999999993,
							27.32940647500004
						],
						[
							-82.50988999999993,
							27.329548928000065
						],
						[
							-82.50991999999991,
							27.32962000000009
						],
						[
							-82.50972999999993,
							27.329960000000085
						],
						[
							-82.50957264899995,
							27.329959590000044
						],
						[
							-82.50908593699995,
							27.329958323000085
						],
						[
							-82.50850425699991,
							27.329956808000077
						],
						[
							-82.50806502899991,
							27.329955664000067
						],
						[
							-82.50782757799995,
							27.329955046000066
						],
						[
							-82.50751893099994,
							27.329954242000042
						],
						[
							-82.50639118399994,
							27.329951305000066
						],
						[
							-82.5058454149999,
							27.329947377000053
						],
						[
							-82.50571999999994,
							27.32994000000008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Bellevue Terrace",
				"RegionID": "343980"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.56083818999991,
					27.29882400000008,
					-82.54564567799991,
					27.306031232000066
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.5561648339999,
							27.306011659000035
						],
						[
							-82.5560936089999,
							27.30599257500006
						],
						[
							-82.5560581659999,
							27.306000659000063
						],
						[
							-82.55590199999995,
							27.306014322000067
						],
						[
							-82.55574799999994,
							27.306014322000067
						],
						[
							-82.55559183399993,
							27.306000659000063
						],
						[
							-82.55545546099995,
							27.305965412000035
						],
						[
							-82.5553229379999,
							27.305919750000044
						],
						[
							-82.55525115299992,
							27.305890822000038
						],
						[
							-82.5551821219999,
							27.305855827000073
						],
						[
							-82.55511635699992,
							27.305815024000086
						],
						[
							-82.55505434499992,
							27.305768715000056
						],
						[
							-82.55499654699992,
							27.30571724400005
						],
						[
							-82.55494338999995,
							27.30566099200007
						],
						[
							-82.55485239099994,
							27.305555991000062
						],
						[
							-82.55480493899995,
							27.30549630300004
						],
						[
							-82.5547323269999,
							27.305396562000055
						],
						[
							-82.55402515999992,
							27.305366119000045
						],
						[
							-82.55238532999994,
							27.305429650000068
						],
						[
							-82.55226586499992,
							27.305436992000068
						],
						[
							-82.55220288899994,
							27.305438379000066
						],
						[
							-82.5521399939999,
							27.30543487300008
						],
						[
							-82.55207756199991,
							27.305426496000052
						],
						[
							-82.55201596799992,
							27.305413299000065
						],
						[
							-82.55195558399993,
							27.30539536100008
						],
						[
							-82.55192130599994,
							27.305385425000054
						],
						[
							-82.55058094599993,
							27.30495745500008
						],
						[
							-82.5472694419999,
							27.30415528900005
						],
						[
							-82.54724226999991,
							27.304151172000047
						],
						[
							-82.5472227009999,
							27.30414798600009
						],
						[
							-82.54686670099994,
							27.304085987000065
						],
						[
							-82.54675728299992,
							27.304059787000085
						],
						[
							-82.54628128299994,
							27.303913787000056
						],
						[
							-82.5462374139999,
							27.303899086000058
						],
						[
							-82.54609533899993,
							27.303832836000083
						],
						[
							-82.54596692699994,
							27.303742921000037
						],
						[
							-82.54585607899992,
							27.303632073000074
						],
						[
							-82.54576616399993,
							27.303503661000036
						],
						[
							-82.5456999139999,
							27.30336158600005
						],
						[
							-82.54565934099992,
							27.303210166000042
						],
						[
							-82.54564567799991,
							27.30305400000009
						],
						[
							-82.54565934099992,
							27.302897834000078
						],
						[
							-82.54568117299993,
							27.302803832000052
						],
						[
							-82.54575967499994,
							27.30253276600007
						],
						[
							-82.54574692599994,
							27.301990124000042
						],
						[
							-82.54574667799994,
							27.301969000000046
						],
						[
							-82.54576034099995,
							27.301812835000078
						],
						[
							-82.54580091399993,
							27.30166141400008
						],
						[
							-82.5458671639999,
							27.301519339000038
						],
						[
							-82.54595707899995,
							27.301390927000057
						],
						[
							-82.54606792699991,
							27.301280080000083
						],
						[
							-82.54617087999992,
							27.30120542900005
						],
						[
							-82.54626087999993,
							27.301149428000087
						],
						[
							-82.54633086299992,
							27.301110102000052
						],
						[
							-82.54640407399995,
							27.301077173000067
						],
						[
							-82.54647992999992,
							27.30105090400008
						],
						[
							-82.54655782599991,
							27.301031504000036
						],
						[
							-82.5466371409999,
							27.301019128000064
						],
						[
							-82.54685414099993,
							27.300995128000068
						],
						[
							-82.54692093599995,
							27.30099025000004
						],
						[
							-82.5471838279999,
							27.300980871000036
						],
						[
							-82.54716519399994,
							27.300941452000075
						],
						[
							-82.54701055399994,
							27.300530019000064
						],
						[
							-82.54698683399994,
							27.300456305000072
						],
						[
							-82.54696954499991,
							27.30038082300007
						],
						[
							-82.54695881399994,
							27.300304133000058
						],
						[
							-82.5469547209999,
							27.30022680500008
						],
						[
							-82.5469572959999,
							27.300149411000064
						],
						[
							-82.5469665199999,
							27.300072526000065
						],
						[
							-82.54698232499993,
							27.299996719000035
						],
						[
							-82.54700459299994,
							27.299922553000044
						],
						[
							-82.54706275299992,
							27.29975548400006
						],
						[
							-82.54708832499995,
							27.299691476000078
						],
						[
							-82.54711872599995,
							27.29962961600006
						],
						[
							-82.54715377799994,
							27.299570267000036
						],
						[
							-82.54719327599992,
							27.29951378000004
						],
						[
							-82.54723698599992,
							27.299460485000054
						],
						[
							-82.54728465199992,
							27.29941069700004
						],
						[
							-82.54733599299993,
							27.29936470800004
						],
						[
							-82.54746065099994,
							27.299262539000043
						],
						[
							-82.54755946299991,
							27.299157328000035
						],
						[
							-82.54763692699993,
							27.299084079000068
						],
						[
							-82.54770964399995,
							27.299029094000048
						],
						[
							-82.5478402569999,
							27.298940365000078
						],
						[
							-82.54879999999991,
							27.298906000000045
						],
						[
							-82.55111899999991,
							27.29882400000008
						],
						[
							-82.55108299999995,
							27.29929700000008
						],
						[
							-82.55108282499992,
							27.29929982500005
						],
						[
							-82.55106799999993,
							27.29953900000004
						],
						[
							-82.55138038099994,
							27.299521923000043
						],
						[
							-82.55172404999992,
							27.299503136000055
						],
						[
							-82.55181799999991,
							27.299498000000085
						],
						[
							-82.55184299999992,
							27.299505000000067
						],
						[
							-82.55187099999995,
							27.299507000000066
						],
						[
							-82.55190299999992,
							27.299502000000075
						],
						[
							-82.55198199999991,
							27.29946100000007
						],
						[
							-82.5520909999999,
							27.299420000000055
						],
						[
							-82.55219599999992,
							27.299398000000053
						],
						[
							-82.55228099999994,
							27.299386000000084
						],
						[
							-82.5523159999999,
							27.29938700000008
						],
						[
							-82.55234799999994,
							27.299405000000036
						],
						[
							-82.5523839999999,
							27.29944500000005
						],
						[
							-82.55246499999993,
							27.29944800000004
						],
						[
							-82.55300999999992,
							27.29951900000009
						],
						[
							-82.55317599999995,
							27.299437000000072
						],
						[
							-82.55330229599991,
							27.299441431000048
						],
						[
							-82.55351799999994,
							27.29944900000004
						],
						[
							-82.55359799999991,
							27.29946000000007
						],
						[
							-82.55432252499992,
							27.299425719000055
						],
						[
							-82.55437999999992,
							27.299423000000047
						],
						[
							-82.55500599999993,
							27.29930500000006
						],
						[
							-82.55501599999991,
							27.299307000000056
						],
						[
							-82.55578699999995,
							27.299308000000053
						],
						[
							-82.5562359999999,
							27.29929800000008
						],
						[
							-82.55658199999993,
							27.299299000000076
						],
						[
							-82.55672099999992,
							27.29927500000008
						],
						[
							-82.55675999999994,
							27.29928300000006
						],
						[
							-82.55678199999994,
							27.29932000000008
						],
						[
							-82.55771799999991,
							27.299299000000076
						],
						[
							-82.55941999999993,
							27.29932400000007
						],
						[
							-82.55961999999994,
							27.29932400000007
						],
						[
							-82.56001999999995,
							27.299337000000037
						],
						[
							-82.5608319769999,
							27.29933079100005
						],
						[
							-82.56083818999991,
							27.299691572000086
						],
						[
							-82.5608366809999,
							27.29976130400007
						],
						[
							-82.5607236809999,
							27.301629304000073
						],
						[
							-82.56071670099993,
							27.30169922500005
						],
						[
							-82.56070428299995,
							27.301768389000074
						],
						[
							-82.56068650199991,
							27.301836371000036
						],
						[
							-82.5606634689999,
							27.30190275800004
						],
						[
							-82.56063532199994,
							27.30196714400006
						],
						[
							-82.5605258459999,
							27.302193086000045
						],
						[
							-82.56042657199993,
							27.30252482700007
						],
						[
							-82.5604184799999,
							27.30255046500008
						],
						[
							-82.5603264799999,
							27.302827465000064
						],
						[
							-82.56029792499993,
							27.302902162000066
						],
						[
							-82.56015567799994,
							27.303229786000088
						],
						[
							-82.56000040599992,
							27.303670943000046
						],
						[
							-82.55990664399991,
							27.303962647000052
						],
						[
							-82.5598380589999,
							27.30418407800005
						],
						[
							-82.55982551199992,
							27.304221641000083
						],
						[
							-82.55972579899992,
							27.304499614000065
						],
						[
							-82.55965883599993,
							27.304643661000057
						],
						[
							-82.55962990199993,
							27.30469041500004
						],
						[
							-82.55948890199994,
							27.30490341500007
						],
						[
							-82.55944860999995,
							27.304959480000036
						],
						[
							-82.55940413499991,
							27.305012290000036
						],
						[
							-82.55935574099993,
							27.305061531000035
						],
						[
							-82.55930371099993,
							27.305106915000067
						],
						[
							-82.55924835399992,
							27.305148174000067
						],
						[
							-82.55902135399992,
							27.30530417400007
						],
						[
							-82.5588864799999,
							27.30538064700005
						],
						[
							-82.55801747899994,
							27.30577864600008
						],
						[
							-82.55795058599995,
							27.305806086000075
						],
						[
							-82.55784122099993,
							27.305838205000043
						],
						[
							-82.55724822199994,
							27.305972204000057
						],
						[
							-82.55715865499991,
							27.30598773400004
						],
						[
							-82.55685465399995,
							27.30602473400006
						],
						[
							-82.55673330599991,
							27.306031232000066
						],
						[
							-82.55630830599996,
							27.30602523300007
						],
						[
							-82.5561648339999,
							27.306011659000035
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Bay Isle-Siesta",
				"RegionID": "343985"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.7399702379999,
					28.22701591300006,
					-82.7279480119999,
					28.246783682000057
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-82.73528745899995,
								28.23208416500006
							],
							[
								-82.73541594999995,
								28.231774835000067
							],
							[
								-82.7352731819999,
								28.23170821000008
							],
							[
								-82.73532553099994,
								28.23157971900008
							],
							[
								-82.73533504799991,
								28.230071141000057
							],
							[
								-82.73510186099992,
								28.230066382000075
							],
							[
								-82.73502571799992,
								28.230085418000044
							],
							[
								-82.73476873699991,
								28.230085418000044
							],
							[
								-82.73473542399995,
								28.23006162300004
							],
							[
								-82.73440229999994,
								28.23006162300004
							],
							[
								-82.73439754099991,
								28.229999757000087
							],
							[
								-82.73426904999991,
								28.229990239000074
							],
							[
								-82.73425001399994,
								28.22949531100005
							],
							[
								-82.73395496099995,
								28.22949531100005
							],
							[
								-82.73395971999992,
								28.229999757000087
							],
							[
								-82.73384550599991,
								28.229994998000052
							],
							[
								-82.7336028009999,
								28.229528624000068
							],
							[
								-82.73369797899994,
								28.229471517000036
							],
							[
								-82.73371225599993,
								28.229000384000074
							],
							[
								-82.73365038999992,
								28.228971830000035
							],
							[
								-82.73369797899994,
								28.228871893000075
							],
							[
								-82.73380743399991,
								28.228876652000054
							],
							[
								-82.73376936299991,
								28.227058743000043
							],
							[
								-82.73452035299994,
								28.227043520000052
							],
							[
								-82.73588232399993,
								28.22701591300006
							],
							[
								-82.73589184199994,
								28.22793914400006
							],
							[
								-82.7399702379999,
								28.227886796000067
							],
							[
								-82.7399702379999,
								28.22878623200006
							],
							[
								-82.73986078299993,
								28.228790991000043
							],
							[
								-82.7397751229999,
								28.22881002700007
							],
							[
								-82.73586804799993,
								28.22885285700005
							],
							[
								-82.73585852999992,
								28.23158447800006
							],
							[
								-82.73723861699995,
								28.231560684000044
							],
							[
								-82.73723385799991,
								28.231341773000054
							],
							[
								-82.73781920599993,
								28.231341773000054
							],
							[
								-82.7376193309999,
								28.232046094000054
							],
							[
								-82.7373004829999,
								28.232041335000076
							],
							[
								-82.7373004829999,
								28.232312593000074
							],
							[
								-82.73707681399992,
								28.232778968000048
							],
							[
								-82.73528745899995,
								28.23208416500006
							]
						]
					],
					[
						[
							[
								-82.73041194399991,
								28.241599630000053
							],
							[
								-82.7304175079999,
								28.236502101000042
							],
							[
								-82.73041752099994,
								28.236490125000046
							],
							[
								-82.73041789199993,
								28.236150664000036
							],
							[
								-82.73067487399994,
								28.236150664000036
							],
							[
								-82.73170874999994,
								28.236150664000036
							],
							[
								-82.73173849299991,
								28.238875147000044
							],
							[
								-82.7331483239999,
								28.238863249000076
							],
							[
								-82.73314237499994,
								28.236091177000052
							],
							[
								-82.73337437299995,
								28.236091177000052
							],
							[
								-82.73343385899996,
								28.23575805300004
							],
							[
								-82.7336896509999,
								28.235746155000072
							],
							[
								-82.73563486099994,
								28.23571046400008
							],
							[
								-82.73562891199992,
								28.23617445800005
							],
							[
								-82.73565270599994,
								28.23638266100005
							],
							[
								-82.73573003899992,
								28.23664440200008
							],
							[
								-82.73581331999992,
								28.236947783000062
							],
							[
								-82.73587280699991,
								28.23720357500008
							],
							[
								-82.73587875499993,
								28.238726430000042
							],
							[
								-82.73585496099992,
								28.238910839000088
							],
							[
								-82.73577167999991,
								28.23911309300007
							],
							[
								-82.73567055199993,
								28.239243963000035
							],
							[
								-82.73556942499994,
								28.239309398000046
							],
							[
								-82.73454030799991,
								28.23958898500007
							],
							[
								-82.7340822619999,
								28.239713907000066
							],
							[
								-82.73378482999993,
								28.239868572000038
							],
							[
								-82.73356472899992,
								28.240041083000055
							],
							[
								-82.73332678299995,
								28.240237388000086
							],
							[
								-82.7331483239999,
								28.240421796000078
							],
							[
								-82.73304124799995,
								28.240594307000038
							],
							[
								-82.73292227499991,
								28.24079656100008
							],
							[
								-82.73284494199993,
								28.241117789000047
							],
							[
								-82.73279140499994,
								28.241409273000045
							],
							[
								-82.73279140499994,
								28.24159368100004
							],
							[
								-82.73041194399991,
								28.241599630000053
							]
						]
					],
					[
						[
							[
								-82.72856905099991,
								28.245670094000047
							],
							[
								-82.72856905099991,
								28.24538455900006
							],
							[
								-82.72797656499995,
								28.24538455900006
							],
							[
								-82.7279480119999,
								28.24035913700004
							],
							[
								-82.72904732299992,
								28.240323445000058
							],
							[
								-82.72903304599993,
								28.24177253700009
							],
							[
								-82.73073198099992,
								28.24175826000004
							],
							[
								-82.7307462579999,
								28.243385812000042
							],
							[
								-82.73042503099992,
								28.243385812000042
							],
							[
								-82.73041789199993,
								28.245662956000047
							],
							[
								-82.72856905099991,
								28.245670094000047
							]
						]
					],
					[
						[
							[
								-82.72796942699995,
								28.24588424600006
							],
							[
								-82.72849766699994,
								28.245855692000077
							],
							[
								-82.72848338999997,
								28.246084120000035
							],
							[
								-82.72798370399994,
								28.24609125900008
							],
							[
								-82.72796942699995,
								28.24588424600006
							]
						]
					],
					[
						[
							[
								-82.72796942699995,
								28.246776544000056
							],
							[
								-82.72796942699995,
								28.246548115000053
							],
							[
								-82.72873323399995,
								28.246555254000043
							],
							[
								-82.72873323399995,
								28.246783682000057
							],
							[
								-82.72796942699995,
								28.246776544000056
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pasco",
				"City": "New Port Richey",
				"Name": "Southwest",
				"RegionID": "271581"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.78334999999993,
					26.14555906600009,
					-81.76666099999994,
					26.160569000000066
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.76689699999991,
							26.160379000000034
						],
						[
							-81.7669039999999,
							26.158655000000067
						],
						[
							-81.76691199999993,
							26.15684500000009
						],
						[
							-81.76691399999993,
							26.15578100000005
						],
						[
							-81.76690999999994,
							26.155161000000078
						],
						[
							-81.7668589999999,
							26.154342000000042
						],
						[
							-81.76683999999995,
							26.15374600000007
						],
						[
							-81.76683899999995,
							26.153233000000057
						],
						[
							-81.76683899999995,
							26.15322500000008
						],
						[
							-81.76683899999995,
							26.15322497300008
						],
						[
							-81.76683899999995,
							26.15321700000004
						],
						[
							-81.7668339999999,
							26.152865000000077
						],
						[
							-81.76681699999995,
							26.152626000000055
						],
						[
							-81.76674199999991,
							26.150764000000038
						],
						[
							-81.76673699999992,
							26.15047300000009
						],
						[
							-81.76671054799993,
							26.148950954000043
						],
						[
							-81.76671013599992,
							26.14892726100004
						],
						[
							-81.76668699999993,
							26.147596000000078
						],
						[
							-81.76667120499991,
							26.146631899000056
						],
						[
							-81.76666099999994,
							26.146009000000053
						],
						[
							-81.76698799999991,
							26.14597800000007
						],
						[
							-81.7672159999999,
							26.145949000000087
						],
						[
							-81.76754499999993,
							26.14590300000009
						],
						[
							-81.76785799999993,
							26.14586100000008
						],
						[
							-81.76794499999994,
							26.145854000000043
						],
						[
							-81.76817199999994,
							26.145848000000058
						],
						[
							-81.76848699999994,
							26.145845000000065
						],
						[
							-81.76884199999995,
							26.145841000000075
						],
						[
							-81.7700109999999,
							26.14582800000005
						],
						[
							-81.7707979999999,
							26.145819000000074
						],
						[
							-81.7723059999999,
							26.145800000000065
						],
						[
							-81.77490799999993,
							26.14575700000006
						],
						[
							-81.77603899999991,
							26.14573900000005
						],
						[
							-81.77754199999993,
							26.145719000000042
						],
						[
							-81.7804579999999,
							26.14568100000008
						],
						[
							-81.78262999999993,
							26.14565300000004
						],
						[
							-81.78268799999995,
							26.145660000000078
						],
						[
							-81.78269449899996,
							26.145661999000083
						],
						[
							-81.78270099999992,
							26.145664000000068
						],
						[
							-81.78270983399995,
							26.14555906600009
						],
						[
							-81.78271283999993,
							26.145668181000076
						],
						[
							-81.78273983299994,
							26.14567707100008
						],
						[
							-81.7827655349999,
							26.145688086000064
						],
						[
							-81.78280425399993,
							26.145724254000072
						],
						[
							-81.7828275409999,
							26.14575809900009
						],
						[
							-81.78284366999992,
							26.145796808000057
						],
						[
							-81.78286710799995,
							26.145853058000057
						],
						[
							-81.78287999999992,
							26.14590112500008
						],
						[
							-81.78287999999992,
							26.14594677900004
						],
						[
							-81.78287999999992,
							26.14632318200006
						],
						[
							-81.78287999999992,
							26.14698912500006
						],
						[
							-81.78288781899994,
							26.14829235900004
						],
						[
							-81.78291109799994,
							26.149103236000087
						],
						[
							-81.78292936899993,
							26.149739701000044
						],
						[
							-81.7829338489999,
							26.15040523700009
						],
						[
							-81.78294841099996,
							26.150898390000066
						],
						[
							-81.78297341499992,
							26.15141934800005
						],
						[
							-81.78298457699992,
							26.151940282000055
						],
						[
							-81.78299583599994,
							26.15246570100004
						],
						[
							-81.78300178099994,
							26.152731250000045
						],
						[
							-81.78300727999994,
							26.152951211000072
						],
						[
							-81.78301215399995,
							26.15315263900004
						],
						[
							-81.78301492799994,
							26.15327188300006
						],
						[
							-81.78301790899991,
							26.153400071000082
						],
						[
							-81.7830245099999,
							26.15368391600009
						],
						[
							-81.78302813999994,
							26.15383999900007
						],
						[
							-81.78303297399992,
							26.15397650600005
						],
						[
							-81.78303879499992,
							26.154087099000037
						],
						[
							-81.78304507099995,
							26.15420634700007
						],
						[
							-81.78304999999995,
							26.15443523700009
						],
						[
							-81.78304230299995,
							26.154554672000074
						],
						[
							-81.7830348679999,
							26.154636447000087
						],
						[
							-81.78302999999995,
							26.154728397000042
						],
						[
							-81.78302999999995,
							26.154810000000055
						],
						[
							-81.78301899999991,
							26.156471000000067
						],
						[
							-81.78334810699994,
							26.16016972300008
						],
						[
							-81.78334999999993,
							26.160191000000054
						],
						[
							-81.78332127199991,
							26.160190671000066
						],
						[
							-81.7823019999999,
							26.160179000000085
						],
						[
							-81.78189399999991,
							26.160266000000036
						],
						[
							-81.7787909999999,
							26.160305000000054
						],
						[
							-81.77343699999994,
							26.16042300000004
						],
						[
							-81.76791999999995,
							26.16054100000008
						],
						[
							-81.76689699999991,
							26.160569000000066
						],
						[
							-81.76689699999991,
							26.160379000000034
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Collier",
				"City": "Naples",
				"Name": "Airport",
				"RegionID": "272731"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.78337878299999,
					26.16749481100004,
					-81.76701848799996,
					26.17402861000005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.778798,
							26.167588
						],
						[
							-81.78337878299999,
							26.16749481100004
						],
						[
							-81.783296,
							26.173652869000026
						],
						[
							-81.77471288199996,
							26.17368525200004
						],
						[
							-81.76710613799997,
							26.17402861000005
						],
						[
							-81.76701848799996,
							26.167929473000072
						],
						[
							-81.778271,
							26.167801
						],
						[
							-81.778798,
							26.167588
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Collier",
				"City": "Naples",
				"Name": "Bears Paw",
				"RegionID": "272892"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.39737281895675,
					28.54199949521646,
					-81.38230834399242,
					28.549830281532117
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.3851277041651,
							28.54934827010534
						],
						[
							-81.38464594634719,
							28.549287306863597
						],
						[
							-81.38265790686793,
							28.54940348847797
						],
						[
							-81.38254582975937,
							28.547558742474195
						],
						[
							-81.38253982048958,
							28.54746259775463
						],
						[
							-81.38247684096788,
							28.54614450372444
						],
						[
							-81.38231237295517,
							28.546175835204608
						],
						[
							-81.38230947803753,
							28.546133628223146
						],
						[
							-81.38230834399242,
							28.546101446883682
						],
						[
							-81.38247485796275,
							28.546101711284365
						],
						[
							-81.38246270722287,
							28.54574004443367
						],
						[
							-81.38245970078927,
							28.545582810567304
						],
						[
							-81.38243566550875,
							28.544798649421864
						],
						[
							-81.38241163112751,
							28.54403050879902
						],
						[
							-81.38240749244756,
							28.543875145522556
						],
						[
							-81.38258889289536,
							28.543875278622217
						],
						[
							-81.38287845570304,
							28.543875411721885
						],
						[
							-81.38287426216446,
							28.54201852487067
						],
						[
							-81.39726170951874,
							28.54199949521646
						],
						[
							-81.39726866487521,
							28.542594379651774
						],
						[
							-81.39727968067078,
							28.543414595516687
						],
						[
							-81.39728463503587,
							28.543672980628312
						],
						[
							-81.39728869457552,
							28.543851243341607
						],
						[
							-81.39729370200057,
							28.544217786316338
						],
						[
							-81.39730471779605,
							28.544936853634027
						],
						[
							-81.39731673543635,
							28.545679955332957
						],
						[
							-81.39734878367615,
							28.547155142035884
						],
						[
							-81.3973477818315,
							28.547487636678632
						],
						[
							-81.39734678088604,
							28.5481295880316
						],
						[
							-81.39736680968697,
							28.54886167303568
						],
						[
							-81.39737281895675,
							28.54908600801659
						],
						[
							-81.39736686454566,
							28.54933537652545
						],
						[
							-81.38801994989176,
							28.549348396909778
						],
						[
							-81.38717667990653,
							28.5495286138499
						],
						[
							-81.38663392737065,
							28.549830281532117
						],
						[
							-81.38609208674734,
							28.549769017017496
						],
						[
							-81.38554928295005,
							28.549588750614625
						],
						[
							-81.3851277041651,
							28.54934827010534
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Callahan",
				"RegionID": "273110"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.68269391899992,
					30.36489600800007,
					-81.66889381699991,
					30.373302085000034
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.66900071499992,
							30.371192006000058
						],
						[
							-81.66889381699991,
							30.364943023000084
						],
						[
							-81.66981190599995,
							30.364928009000035
						],
						[
							-81.67065090499995,
							30.364931008000045
						],
						[
							-81.67075190599991,
							30.364931008000045
						],
						[
							-81.67143590599994,
							30.364928009000035
						],
						[
							-81.6721279059999,
							30.36492000800007
						],
						[
							-81.67268690499992,
							30.364913008000087
						],
						[
							-81.67373390599994,
							30.36489600800007
						],
						[
							-81.67400390599994,
							30.36490100800006
						],
						[
							-81.67432390499994,
							30.36494100800007
						],
						[
							-81.67481990599993,
							30.365046009000082
						],
						[
							-81.67524690499994,
							30.36517300800006
						],
						[
							-81.67610890599991,
							30.365433009000075
						],
						[
							-81.67662290599992,
							30.36556900800008
						],
						[
							-81.67695990499993,
							30.365635009000073
						],
						[
							-81.67725290599992,
							30.365672008000047
						],
						[
							-81.67776690499994,
							30.365681008000085
						],
						[
							-81.67783290599995,
							30.365682008000082
						],
						[
							-81.6792689049999,
							30.365681008000085
						],
						[
							-81.67979390499994,
							30.365677009000077
						],
						[
							-81.67997690599992,
							30.36566700800006
						],
						[
							-81.6801219109999,
							30.365640925000037
						],
						[
							-81.68067190499994,
							30.366331009000074
						],
						[
							-81.68118990499994,
							30.36699300800007
						],
						[
							-81.68249490599993,
							30.368673009000073
						],
						[
							-81.68269391899992,
							30.368930935000037
						],
						[
							-81.68198190499993,
							30.369132008000065
						],
						[
							-81.6747159059999,
							30.371493008000076
						],
						[
							-81.6728239059999,
							30.37202000900004
						],
						[
							-81.67245590499994,
							30.372192009000056
						],
						[
							-81.6715189059999,
							30.372570008000086
						],
						[
							-81.66970695599991,
							30.373302085000034
						],
						[
							-81.66900071499992,
							30.371192006000058
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Cranzel T Brown Park",
				"RegionID": "273390"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.46343832199994,
					27.906261172000086,
					-82.4441958459999,
					27.94059543900005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.44488416399992,
							27.911189661000037
						],
						[
							-82.44482571799995,
							27.911068237000052
						],
						[
							-82.4447077179999,
							27.910767236000083
						],
						[
							-82.44467261699992,
							27.91065746600009
						],
						[
							-82.4445256169999,
							27.910070466000036
						],
						[
							-82.44451651199995,
							27.910030207000094
						],
						[
							-82.44446051199992,
							27.90975320800004
						],
						[
							-82.4444458289999,
							27.909650207000084
						],
						[
							-82.44443382799994,
							27.909507207000047
						],
						[
							-82.4444340259999,
							27.90935446400005
						],
						[
							-82.44445202599991,
							27.90914646400006
						],
						[
							-82.44446233999992,
							27.90906783500009
						],
						[
							-82.44448157399995,
							27.90898298800005
						],
						[
							-82.44456057399992,
							27.908698988000083
						],
						[
							-82.44458191399991,
							27.908632414000067
						],
						[
							-82.44462672499992,
							27.90852970600008
						],
						[
							-82.44472772499995,
							27.908332706000067
						],
						[
							-82.44476208399993,
							27.908271669000044
						],
						[
							-82.44483408399992,
							27.908154669000055
						],
						[
							-82.44489270799994,
							27.90807055600004
						],
						[
							-82.44503170799993,
							27.90789355600009
						],
						[
							-82.44510308399992,
							27.907813082000075
						],
						[
							-82.44546508399992,
							27.90745108300007
						],
						[
							-82.4455229269999,
							27.907398080000064
						],
						[
							-82.44564093199995,
							27.907314267000064
						],
						[
							-82.4458191359999,
							27.907208215000082
						],
						[
							-82.44596641399994,
							27.907138914000086
						],
						[
							-82.44601003399993,
							27.90712429000007
						],
						[
							-82.44636503399994,
							27.90701529000006
						],
						[
							-82.44645061999996,
							27.90699354700007
						],
						[
							-82.44758187399992,
							27.906764613000064
						],
						[
							-82.44837257799992,
							27.90650921300005
						],
						[
							-82.44840115699992,
							27.906500504000064
						],
						[
							-82.44869454799993,
							27.90641639200004
						],
						[
							-82.44886293899992,
							27.906368280000038
						],
						[
							-82.44894407099991,
							27.906349118000037
						],
						[
							-82.4492210709999,
							27.906297118000058
						],
						[
							-82.4493190149999,
							27.906284251000045
						],
						[
							-82.44959601499994,
							27.90626325100004
						],
						[
							-82.44969381999994,
							27.906261172000086
						],
						[
							-82.44990481999992,
							27.906268173000058
						],
						[
							-82.44996393399992,
							27.90627208600006
						],
						[
							-82.45005668499994,
							27.90628130400006
						],
						[
							-82.45025119499991,
							27.906270950000078
						],
						[
							-82.45029899999992,
							27.906269678000058
						],
						[
							-82.45056599999992,
							27.906269678000058
						],
						[
							-82.45062251199994,
							27.90627145500008
						],
						[
							-82.45089251199994,
							27.906288455000038
						],
						[
							-82.45100466199995,
							27.90630263500009
						],
						[
							-82.45142366199991,
							27.90638263500006
						],
						[
							-82.45147311499994,
							27.90639352900007
						],
						[
							-82.45168111599992,
							27.906445529000052
						],
						[
							-82.4517328519999,
							27.906460119000087
						],
						[
							-82.45194585199995,
							27.90652711900009
						],
						[
							-82.4520181769999,
							27.90655331800008
						],
						[
							-82.45208799799991,
							27.906585602000064
						],
						[
							-82.4521548049999,
							27.90662373400005
						],
						[
							-82.45237580499992,
							27.90676273400004
						],
						[
							-82.45245434499992,
							27.906818205000036
						],
						[
							-82.45272534499992,
							27.907032205000064
						],
						[
							-82.4527460729999,
							27.907049080000036
						],
						[
							-82.45285843499994,
							27.90716174100004
						],
						[
							-82.45299194799992,
							27.907322554000075
						],
						[
							-82.45308177699991,
							27.90744524300004
						],
						[
							-82.4531220419999,
							27.907390010000086
						],
						[
							-82.45316628099994,
							27.907337906000066
						],
						[
							-82.4532142509999,
							27.90728921600004
						],
						[
							-82.4532656909999,
							27.907244206000087
						],
						[
							-82.4533203179999,
							27.90720312400009
						],
						[
							-82.45336560599992,
							27.90717170000005
						],
						[
							-82.45344091999993,
							27.90711831300007
						],
						[
							-82.45349837999993,
							27.907080792000045
						],
						[
							-82.45355853399991,
							27.907047761000058
						],
						[
							-82.4536210309999,
							27.907019413000057
						],
						[
							-82.45368550799992,
							27.90699591400005
						],
						[
							-82.45375158899992,
							27.906977399000084
						],
						[
							-82.4538935889999,
							27.906943399000056
						],
						[
							-82.45396430499994,
							27.906929438000077
						],
						[
							-82.45403591199995,
							27.906921184000055
						],
						[
							-82.45410795099991,
							27.90691869200009
						],
						[
							-82.45417995699995,
							27.90692197700008
						],
						[
							-82.45434295699994,
							27.90693597700005
						],
						[
							-82.45446159499994,
							27.906954206000083
						],
						[
							-82.45464559599992,
							27.90699520600009
						],
						[
							-82.45471467199991,
							27.907013507000045
						],
						[
							-82.45478207799994,
							27.907037234000086
						],
						[
							-82.45484738699993,
							27.907066239000073
						],
						[
							-82.45491018599995,
							27.907100337000088
						],
						[
							-82.45497008099994,
							27.907139313000073
						],
						[
							-82.45504908099991,
							27.907195313000045
						],
						[
							-82.45511131899991,
							27.907243664000077
						],
						[
							-82.45516908399992,
							27.907297278000044
						],
						[
							-82.45522193399995,
							27.907355744000085
						],
						[
							-82.45526946299992,
							27.907418612000072
						],
						[
							-82.4553113039999,
							27.90748540000004
						],
						[
							-82.45534713799992,
							27.907555595000076
						],
						[
							-82.45543613699994,
							27.907750595000042
						],
						[
							-82.45547184899995,
							27.90784165100007
						],
						[
							-82.4555073379999,
							27.90792295400007
						],
						[
							-82.45556953399995,
							27.90789890700006
						],
						[
							-82.45610253399991,
							27.90771490700007
						],
						[
							-82.4561778819999,
							27.907692529000087
						],
						[
							-82.45625968799993,
							27.90767208200009
						],
						[
							-82.45637549299994,
							27.907643635000056
						],
						[
							-82.45644640299992,
							27.90762921600009
						],
						[
							-82.45729340399993,
							27.907492216000037
						],
						[
							-82.45735695399992,
							27.90748424800006
						],
						[
							-82.45759195399995,
							27.907463248000056
						],
						[
							-82.45767354299994,
							27.907459679000056
						],
						[
							-82.4588055079999,
							27.907461621000042
						],
						[
							-82.45985156499995,
							27.907384135000086
						],
						[
							-82.4599179999999,
							27.907381678000036
						],
						[
							-82.46020499999992,
							27.907381678000036
						],
						[
							-82.46035148999994,
							27.90739368900006
						],
						[
							-82.46056222099992,
							27.907428481000068
						],
						[
							-82.46063495199991,
							27.907440273000077
						],
						[
							-82.46075353799995,
							27.907467852000085
						],
						[
							-82.46100253799995,
							27.907543853000053
						],
						[
							-82.4610600279999,
							27.907563547000052
						],
						[
							-82.46134102899993,
							27.907670547000066
						],
						[
							-82.46147066099991,
							27.907732164000038
						],
						[
							-82.4614873999999,
							27.90774207100009
						],
						[
							-82.4616703989999,
							27.90785307100009
						],
						[
							-82.4617176399999,
							27.907883790000085
						],
						[
							-82.46202663999992,
							27.908098790000054
						],
						[
							-82.4620910729999,
							27.908148079000057
						],
						[
							-82.46219057299993,
							27.908245666000084
						],
						[
							-82.46243624599992,
							27.908527296000045
						],
						[
							-82.46252769499995,
							27.908655243000055
						],
						[
							-82.46273376599993,
							27.909004791000086
						],
						[
							-82.46280208599991,
							27.909150414000067
						],
						[
							-82.46282383899997,
							27.90921847800007
						],
						[
							-82.46290783899991,
							27.909522478000042
						],
						[
							-82.46293069099994,
							27.909630736000054
						],
						[
							-82.46297569099994,
							27.90993573600008
						],
						[
							-82.46298512199992,
							27.910085966000054
						],
						[
							-82.46298012199992,
							27.910322966000084
						],
						[
							-82.46296544099994,
							27.910466924000048
						],
						[
							-82.46292344099993,
							27.91069492400004
						],
						[
							-82.46288984499995,
							27.910823279000056
						],
						[
							-82.46281096599995,
							27.911053433000063
						],
						[
							-82.46273908899991,
							27.911208352000074
						],
						[
							-82.46262534199991,
							27.91140004500005
						],
						[
							-82.46260022099995,
							27.911436623000043
						],
						[
							-82.46268973699995,
							27.911540313000046
						],
						[
							-82.46278096599991,
							27.91166664600007
						],
						[
							-82.46288540099994,
							27.911841492000065
						],
						[
							-82.46295508599991,
							27.91198941400006
						],
						[
							-82.4629650519999,
							27.91201831500007
						],
						[
							-82.46300905299995,
							27.912153315000072
						],
						[
							-82.46303965899995,
							27.91227583400007
						],
						[
							-82.46304594999992,
							27.91231708600009
						],
						[
							-82.46306694999993,
							27.912480086000073
						],
						[
							-82.4630743219999,
							27.912595000000067
						],
						[
							-82.46307273199994,
							27.912648464000085
						],
						[
							-82.46304904699991,
							27.913046172000065
						],
						[
							-82.46303009199994,
							27.913443269000084
						],
						[
							-82.4630234199999,
							27.91406562700007
						],
						[
							-82.46303387499995,
							27.914576929000077
						],
						[
							-82.4630769979999,
							27.915462409000042
						],
						[
							-82.46316969899993,
							27.916332080000075
						],
						[
							-82.46326366799991,
							27.91700453800007
						],
						[
							-82.46327021199994,
							27.917067432000067
						],
						[
							-82.46327721199992,
							27.917169432000037
						],
						[
							-82.46327932199995,
							27.917231000000072
						],
						[
							-82.46326478899994,
							27.91739195000008
						],
						[
							-82.46323991799994,
							27.917524736000075
						],
						[
							-82.46322338599992,
							27.917596531000072
						],
						[
							-82.4632010329999,
							27.917666732000043
						],
						[
							-82.46317300899995,
							27.917734868000082
						],
						[
							-82.46313950199993,
							27.917800481000086
						],
						[
							-82.46310073599994,
							27.917863131000047
						],
						[
							-82.46305697299994,
							27.917922398000087
						],
						[
							-82.46299844399994,
							27.91799521900009
						],
						[
							-82.46307517299994,
							27.918134099000042
						],
						[
							-82.46313813699993,
							27.918275663000088
						],
						[
							-82.46324613699994,
							27.918588662000047
						],
						[
							-82.4632816589999,
							27.918725834000043
						],
						[
							-82.46329014099992,
							27.91878560400005
						],
						[
							-82.46331914099994,
							27.919054605000042
						],
						[
							-82.4633241169999,
							27.91913179700009
						],
						[
							-82.46333478199995,
							27.91963112600007
						],
						[
							-82.46335555299993,
							27.92000028700005
						],
						[
							-82.46339200199992,
							27.920520166000074
						],
						[
							-82.46343331999994,
							27.92091028100009
						],
						[
							-82.46343832199994,
							27.921005000000036
						],
						[
							-82.46343358099995,
							27.921097221000082
						],
						[
							-82.4634235819999,
							27.921194221000064
						],
						[
							-82.46340892799992,
							27.921287763000066
						],
						[
							-82.46337690699994,
							27.92143821700006
						],
						[
							-82.46336981199995,
							27.921467464000045
						],
						[
							-82.4633360869999,
							27.92158958600004
						],
						[
							-82.46329639499993,
							27.92167791600008
						],
						[
							-82.46327073499992,
							27.921732102000078
						],
						[
							-82.4632110949999,
							27.921855709000056
						],
						[
							-82.46314298599992,
							27.92197152300008
						],
						[
							-82.46305698499994,
							27.922095523000053
						],
						[
							-82.46296977899993,
							27.922202648000052
						],
						[
							-82.46294565999995,
							27.922228018000055
						],
						[
							-82.4629722869999,
							27.922272863000046
						],
						[
							-82.4629913469999,
							27.92230659900008
						],
						[
							-82.46312234699991,
							27.92255059900009
						],
						[
							-82.46317508599994,
							27.922668414000047
						],
						[
							-82.46320576699992,
							27.92277151700006
						],
						[
							-82.46330476699991,
							27.923195517000067
						],
						[
							-82.46331465999992,
							27.92324383400006
						],
						[
							-82.46332722799991,
							27.923355644000083
						],
						[
							-82.46334322799993,
							27.92367964300007
						],
						[
							-82.4633401779999,
							27.92381023300004
						],
						[
							-82.46331917799995,
							27.924028233000058
						],
						[
							-82.46331049399993,
							27.924093354000036
						],
						[
							-82.46326149399994,
							27.92438035400005
						],
						[
							-82.46324045999995,
							27.924473456000044
						],
						[
							-82.46312799299994,
							27.924871628000062
						],
						[
							-82.46311363199993,
							27.924950095000042
						],
						[
							-82.46298918999992,
							27.92610994000006
						],
						[
							-82.46298610399992,
							27.92613530200009
						],
						[
							-82.46290810399995,
							27.926708302000065
						],
						[
							-82.46290408599992,
							27.92673485000006
						],
						[
							-82.46285208499995,
							27.927046850000067
						],
						[
							-82.46284082999995,
							27.927103207000073
						],
						[
							-82.46279583099994,
							27.92729620700004
						],
						[
							-82.4627483889999,
							27.927442074000055
						],
						[
							-82.46264738899993,
							27.927681074000077
						],
						[
							-82.46261413999991,
							27.927751157000046
						],
						[
							-82.46257497599993,
							27.927818114000047
						],
						[
							-82.46253018699991,
							27.92788144700006
						],
						[
							-82.46248010799991,
							27.927940686000056
						],
						[
							-82.46239277099994,
							27.928034824000065
						],
						[
							-82.46242408599996,
							27.928115413000057
						],
						[
							-82.46243700499991,
							27.928153544000054
						],
						[
							-82.46247500499993,
							27.928274544000093
						],
						[
							-82.46250265899994,
							27.92838783400009
						],
						[
							-82.46250927499995,
							27.928431640000042
						],
						[
							-82.4625262749999,
							27.928566640000042
						],
						[
							-82.4625331339999,
							27.92866064900005
						],
						[
							-82.46254022799991,
							27.929012825000086
						],
						[
							-82.46252545599992,
							27.929184706000058
						],
						[
							-82.46246025299992,
							27.929525247000072
						],
						[
							-82.46242208599996,
							27.92966358700005
						],
						[
							-82.46241254899991,
							27.92968862200007
						],
						[
							-82.46228754999993,
							27.930002622000075
						],
						[
							-82.46223083599995,
							27.93011966100005
						],
						[
							-82.46221496599992,
							27.930146092000086
						],
						[
							-82.46205896599992,
							27.93039609100009
						],
						[
							-82.4620081839999,
							27.93046915800005
						],
						[
							-82.46194392199993,
							27.930552497000065
						],
						[
							-82.46195869899992,
							27.930582445000088
						],
						[
							-82.4620316999999,
							27.930758445000038
						],
						[
							-82.46205700099996,
							27.93082724100009
						],
						[
							-82.46207661499994,
							27.930897868000045
						],
						[
							-82.46209041199995,
							27.930969858000083
						],
						[
							-82.46211541199995,
							27.93113685900005
						],
						[
							-82.46212431299995,
							27.931227424000046
						],
						[
							-82.46213431399991,
							27.931438424000078
						],
						[
							-82.46213042599993,
							27.931574711000053
						],
						[
							-82.4620294259999,
							27.932538711000063
						],
						[
							-82.46201910799994,
							27.93260972300004
						],
						[
							-82.46184146299994,
							27.933563114000037
						],
						[
							-82.46166206599992,
							27.934486633000063
						],
						[
							-82.4615339479999,
							27.93538060900005
						],
						[
							-82.46150414999994,
							27.935734465000053
						],
						[
							-82.46150211199995,
							27.935755661000087
						],
						[
							-82.46144211199993,
							27.93631066100005
						],
						[
							-82.46143082999993,
							27.93638543800006
						],
						[
							-82.46137869599994,
							27.93665390600006
						],
						[
							-82.46155807499991,
							27.93678488100005
						],
						[
							-82.46169998099992,
							27.936857565000082
						],
						[
							-82.46176365999992,
							27.936893522000048
						],
						[
							-82.46182420799994,
							27.936934535000034
						],
						[
							-82.46188122299993,
							27.936980331000086
						],
						[
							-82.46193432899992,
							27.937030608000043
						],
						[
							-82.46198317399991,
							27.937085034000066
						],
						[
							-82.46202743499994,
							27.93714324800004
						],
						[
							-82.46206682099995,
							27.937204867000048
						],
						[
							-82.46208188799994,
							27.937231857000086
						],
						[
							-82.46185685899991,
							27.937628653000047
						],
						[
							-82.4616376809999,
							27.937947457000064
						],
						[
							-82.46143842799995,
							27.938096896000047
						],
						[
							-82.46097018499995,
							27.938535252000065
						],
						[
							-82.4598344449999,
							27.939631141000064
						],
						[
							-82.45953556699993,
							27.939870244000076
						],
						[
							-82.4593263509999,
							27.939969870000084
						],
						[
							-82.45908724799995,
							27.94010934700009
						],
						[
							-82.4589378089999,
							27.940268749000044
						],
						[
							-82.4587784069999,
							27.940517815000078
						],
						[
							-82.45845785799992,
							27.94059543900005
						],
						[
							-82.45834933899994,
							27.940544836000072
						],
						[
							-82.45830014799992,
							27.940514282000038
						],
						[
							-82.4582191479999,
							27.94046028300005
						],
						[
							-82.45813992699993,
							27.940400921000048
						],
						[
							-82.45808855799993,
							27.94035432600009
						],
						[
							-82.45739055799993,
							27.939670326000055
						],
						[
							-82.45733107999992,
							27.93960607300005
						],
						[
							-82.45727892199994,
							27.939537492000056
						],
						[
							-82.45715792099992,
							27.939361492000046
						],
						[
							-82.45711210999993,
							27.939287412000056
						],
						[
							-82.45686032099991,
							27.938832293000075
						],
						[
							-82.45647546399994,
							27.93811505000008
						],
						[
							-82.45645954499992,
							27.93808535700009
						],
						[
							-82.45309772799995,
							27.931612100000052
						],
						[
							-82.44916304899994,
							27.924691831000075
						],
						[
							-82.44912077299995,
							27.924616067000045
						],
						[
							-82.44823117999995,
							27.92294764600007
						],
						[
							-82.4481253809999,
							27.922748667000064
						],
						[
							-82.44759974699991,
							27.921797757000036
						],
						[
							-82.44745840699994,
							27.921541577000085
						],
						[
							-82.44728334599995,
							27.921233838000035
						],
						[
							-82.44726951199993,
							27.921212319000063
						],
						[
							-82.44721556099995,
							27.921115831000066
						],
						[
							-82.4471827019999,
							27.92104752000006
						],
						[
							-82.44692016699992,
							27.920536667000082
						],
						[
							-82.44622206999992,
							27.919313755000076
						],
						[
							-82.4462109719999,
							27.91929216500006
						],
						[
							-82.44615275599995,
							27.91917582500008
						],
						[
							-82.44563970599995,
							27.918233356000087
						],
						[
							-82.44552977699993,
							27.918030333000047
						],
						[
							-82.44504670499992,
							27.91714421000006
						],
						[
							-82.44482229099992,
							27.91675570800004
						],
						[
							-82.44473578799995,
							27.916644946000076
						],
						[
							-82.44453878799993,
							27.91634694600009
						],
						[
							-82.44447056399991,
							27.916223751000075
						],
						[
							-82.44437856499991,
							27.916021751000077
						],
						[
							-82.44432951099992,
							27.915886155000067
						],
						[
							-82.4442915109999,
							27.915747155000076
						],
						[
							-82.44426837299994,
							27.915634756000088
						],
						[
							-82.44423237399991,
							27.915377756000055
						],
						[
							-82.44422577499995,
							27.91531437400005
						],
						[
							-82.44420477499995,
							27.915007374000087
						],
						[
							-82.44420284599994,
							27.914963388000047
						],
						[
							-82.4441958459999,
							27.91460138800005
						],
						[
							-82.44419598899992,
							27.914560341000083
						],
						[
							-82.4442029889999,
							27.914294340000083
						],
						[
							-82.44421931399995,
							27.91414582100009
						],
						[
							-82.44429831399992,
							27.91374082100009
						],
						[
							-82.4443288839999,
							27.913625463000074
						],
						[
							-82.4444658839999,
							27.913219463000075
						],
						[
							-82.4444973599999,
							27.913139129000058
						],
						[
							-82.44460135899993,
							27.912907129000075
						],
						[
							-82.44467252099992,
							27.91277794800004
						],
						[
							-82.44486352099995,
							27.912489948000086
						],
						[
							-82.44488917899992,
							27.912453274000086
						],
						[
							-82.4451653509999,
							27.912078740000084
						],
						[
							-82.4451978649999,
							27.912028685000056
						],
						[
							-82.44521633599993,
							27.911991216000047
						],
						[
							-82.44528610299994,
							27.911778742000084
						],
						[
							-82.44517708899991,
							27.91162229200006
						],
						[
							-82.44507382499995,
							27.911487870000087
						],
						[
							-82.44502266399991,
							27.911413889000073
						],
						[
							-82.44489866399994,
							27.911213889000067
						],
						[
							-82.44488416399992,
							27.911189661000037
						]
					],
					[
						[
							-82.45201719499994,
							27.90926257400008
						],
						[
							-82.45232826499995,
							27.909100876000082
						],
						[
							-82.45208439299995,
							27.909151935000068
						],
						[
							-82.45200090999992,
							27.90917546700007
						],
						[
							-82.4517272249999,
							27.909277744000065
						],
						[
							-82.45165686599995,
							27.909300460000054
						],
						[
							-82.45158487899994,
							27.90931732000007
						],
						[
							-82.45151175099994,
							27.90932820900008
						],
						[
							-82.45143797499992,
							27.90933305300007
						],
						[
							-82.45136404999995,
							27.90933182100008
						],
						[
							-82.45129047699993,
							27.90932452000004
						],
						[
							-82.45121775199993,
							27.90931119900006
						],
						[
							-82.45114636699992,
							27.909291950000068
						],
						[
							-82.4511113669999,
							27.90928095000004
						],
						[
							-82.45103890999991,
							27.909254960000055
						],
						[
							-82.45096906099991,
							27.909222610000086
						],
						[
							-82.45090237599993,
							27.909184156000038
						],
						[
							-82.45083938899995,
							27.909139906000064
						],
						[
							-82.45078059999992,
							27.90909021300007
						],
						[
							-82.4507264799999,
							27.909035474000063
						],
						[
							-82.45031015199993,
							27.908966086000078
						],
						[
							-82.45026444599995,
							27.908957246000057
						],
						[
							-82.44990144699996,
							27.90887724600009
						],
						[
							-82.44976411499994,
							27.90883523900004
						],
						[
							-82.44962511499995,
							27.908780239000066
						],
						[
							-82.44950633899992,
							27.90872283600004
						],
						[
							-82.4494215709999,
							27.908666440000047
						],
						[
							-82.44932985299994,
							27.908671872000074
						],
						[
							-82.4492830769999,
							27.90867797400006
						],
						[
							-82.44900834499992,
							27.90878320300004
						],
						[
							-82.4488135439999,
							27.90889277900004
						],
						[
							-82.44853886599992,
							27.90908201700006
						],
						[
							-82.44838997399995,
							27.909241654000084
						],
						[
							-82.44830738499991,
							27.90939061000006
						],
						[
							-82.44823743299993,
							27.909576251000093
						],
						[
							-82.44818257399993,
							27.90975888400004
						],
						[
							-82.44816143999992,
							27.909879183000044
						],
						[
							-82.4481585119999,
							27.909926031000055
						],
						[
							-82.44816397999995,
							27.90996254500004
						],
						[
							-82.44826451599994,
							27.910318844000074
						],
						[
							-82.44838691899992,
							27.91065545200007
						],
						[
							-82.44850195899994,
							27.91088336300004
						],
						[
							-82.44854505299992,
							27.91087942000007
						],
						[
							-82.44862699999995,
							27.91087567800008
						],
						[
							-82.44915299999991,
							27.91087567800008
						],
						[
							-82.44925403699995,
							27.910881372000063
						],
						[
							-82.44965203699991,
							27.910926371000073
						],
						[
							-82.44970079199993,
							27.910933240000077
						],
						[
							-82.44999679199992,
							27.910983241000054
						],
						[
							-82.4500919759999,
							27.91100468700006
						],
						[
							-82.45031097599991,
							27.911066687000073
						],
						[
							-82.45036728099991,
							27.911084646000063
						],
						[
							-82.45048467799995,
							27.911125033000076
						],
						[
							-82.4505194919999,
							27.91103018700005
						],
						[
							-82.45063749199994,
							27.91075718700006
						],
						[
							-82.45069807499993,
							27.91064106300007
						],
						[
							-82.45092807499992,
							27.910269063000044
						],
						[
							-82.45099451899995,
							27.910175516000038
						],
						[
							-82.45130351899991,
							27.90979451600009
						],
						[
							-82.45138200299995,
							27.90970955200004
						],
						[
							-82.45152700299992,
							27.909571552000045
						],
						[
							-82.45157479299992,
							27.909529199000076
						],
						[
							-82.45167179299995,
							27.90944919900005
						],
						[
							-82.45179433899995,
							27.909364164000067
						],
						[
							-82.45187674899995,
							27.909322081000084
						],
						[
							-82.45195274899993,
							27.909288082000046
						],
						[
							-82.45201719499994,
							27.90926257400008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Davis Island",
				"RegionID": "273437"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.40211823466893,
					27.968187171548415,
					-82.3936648279274,
					27.974520246741484
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.40197729471909,
							27.968206039324556
						],
						[
							-82.40200187948541,
							27.968187171548415
						],
						[
							-82.40211823466893,
							27.96890000026918
						],
						[
							-82.40203636488793,
							27.969536362335774
						],
						[
							-82.4021181807096,
							27.970800000618496
						],
						[
							-82.40200909114876,
							27.97188105224751
						],
						[
							-82.40200909114876,
							27.97270000006845
						],
						[
							-82.40200914600747,
							27.974520246741484
						],
						[
							-82.39798901465849,
							27.97451445061098
						],
						[
							-82.3936648279274,
							27.97450815625607
						],
						[
							-82.39915495509247,
							27.970345737772938
						],
						[
							-82.40197729471909,
							27.968206039324556
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Florence",
				"RegionID": "273739"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.48532080799993,
					28.032899946000043,
					-82.45451822099994,
					28.05631900000009
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.47408899999994,
							28.055758000000083
						],
						[
							-82.47411999999991,
							28.05574900000005
						],
						[
							-82.4741489999999,
							28.055746000000056
						],
						[
							-82.47427499999992,
							28.055757000000085
						],
						[
							-82.47433599999994,
							28.05575300000004
						],
						[
							-82.47442699999993,
							28.055731000000037
						],
						[
							-82.4744829999999,
							28.05570700000004
						],
						[
							-82.47455699999995,
							28.055657000000053
						],
						[
							-82.4746189999999,
							28.055595000000043
						],
						[
							-82.47475899999995,
							28.055413000000044
						],
						[
							-82.47495199999992,
							28.05523400000004
						],
						[
							-82.4750459999999,
							28.055123000000037
						],
						[
							-82.47508999999991,
							28.05505100000005
						],
						[
							-82.47510099999994,
							28.055026000000055
						],
						[
							-82.47510899999992,
							28.054972000000078
						],
						[
							-82.47510899999992,
							28.05479600000007
						],
						[
							-82.47409340299993,
							28.054838433000043
						],
						[
							-82.47364899999991,
							28.054857000000084
						],
						[
							-82.47351999999995,
							28.054843000000066
						],
						[
							-82.47326599999991,
							28.054866000000064
						],
						[
							-82.47321845599993,
							28.054868872000046
						],
						[
							-82.47281110299991,
							28.054893483000058
						],
						[
							-82.47230599999995,
							28.054924000000085
						],
						[
							-82.47128232599994,
							28.054903481000053
						],
						[
							-82.47050999999993,
							28.054888000000062
						],
						[
							-82.46973199999991,
							28.05495200000007
						],
						[
							-82.4675949999999,
							28.054882000000077
						],
						[
							-82.46554699999992,
							28.054914000000057
						],
						[
							-82.46488124299992,
							28.05490086000009
						],
						[
							-82.46463499999993,
							28.054896000000042
						],
						[
							-82.46348719699995,
							28.054894019000074
						],
						[
							-82.4634759999999,
							28.054894000000047
						],
						[
							-82.4614279999999,
							28.054808000000037
						],
						[
							-82.45937299999991,
							28.054772000000074
						],
						[
							-82.4553029999999,
							28.05465300000009
						],
						[
							-82.45490099999995,
							28.054995000000076
						],
						[
							-82.45467499999995,
							28.054938000000053
						],
						[
							-82.45452290299994,
							28.054895857000076
						],
						[
							-82.45461818199995,
							28.03580000000005
						],
						[
							-82.4546310739999,
							28.033218641000076
						],
						[
							-82.45451822099994,
							28.032899946000043
						],
						[
							-82.45927272799992,
							28.032900056000074
						],
						[
							-82.46763638699991,
							28.03309077700004
						],
						[
							-82.46971815699993,
							28.033900132000042
						],
						[
							-82.47346363499992,
							28.033990909000067
						],
						[
							-82.4760181819999,
							28.033900000000074
						],
						[
							-82.47891818199992,
							28.033900000000074
						],
						[
							-82.4799181809999,
							28.033800001000092
						],
						[
							-82.48403635999995,
							28.033781821000048
						],
						[
							-82.48532080799993,
							28.03409872900005
						],
						[
							-82.48531899999995,
							28.034355000000062
						],
						[
							-82.48528099999994,
							28.035664000000054
						],
						[
							-82.48525199999995,
							28.03632200000004
						],
						[
							-82.4847299999999,
							28.03631800000005
						],
						[
							-82.4845909089999,
							28.036318235000067
						],
						[
							-82.48427271599991,
							28.036318772000072
						],
						[
							-82.48413799999992,
							28.03631900000005
						],
						[
							-82.48337875899995,
							28.037630087000082
						],
						[
							-82.48309099999994,
							28.038127000000088
						],
						[
							-82.48307714099991,
							28.038293800000076
						],
						[
							-82.48297699999995,
							28.039499000000035
						],
						[
							-82.4825263919999,
							28.039716911000085
						],
						[
							-82.48239799999993,
							28.039779000000067
						],
						[
							-82.48233358399995,
							28.03985427200007
						],
						[
							-82.48230899999993,
							28.03988300000009
						],
						[
							-82.48219063499994,
							28.039894167000057
						],
						[
							-82.48204399999992,
							28.039908000000082
						],
						[
							-82.48194761699995,
							28.040014599000074
						],
						[
							-82.48160999999993,
							28.040388000000064
						],
						[
							-82.48128022299994,
							28.040509522000036
						],
						[
							-82.48036484799991,
							28.04084683600007
						],
						[
							-82.48024499999991,
							28.040891000000045
						],
						[
							-82.48022899999995,
							28.04099100000008
						],
						[
							-82.48022899999995,
							28.041079627000048
						],
						[
							-82.48022899999995,
							28.041686000000084
						],
						[
							-82.48019999999991,
							28.042403000000036
						],
						[
							-82.48020799999995,
							28.043285000000083
						],
						[
							-82.4802049999999,
							28.043435000000045
						],
						[
							-82.48019399999993,
							28.043656000000055
						],
						[
							-82.48014999999992,
							28.04382800000008
						],
						[
							-82.48009699999994,
							28.044032000000072
						],
						[
							-82.4800486709999,
							28.044158354000047
						],
						[
							-82.48001399999993,
							28.044249000000036
						],
						[
							-82.48001999999991,
							28.044812000000036
						],
						[
							-82.48002649399992,
							28.045571519000077
						],
						[
							-82.4800449999999,
							28.047736000000043
						],
						[
							-82.4801119999999,
							28.049685000000068
						],
						[
							-82.48011699999995,
							28.05015500000008
						],
						[
							-82.48023099999995,
							28.050782000000083
						],
						[
							-82.48022099999991,
							28.05090800000005
						],
						[
							-82.48022330099991,
							28.05125498700005
						],
						[
							-82.4802259999999,
							28.05166200000008
						],
						[
							-82.48021912099995,
							28.05317120300009
						],
						[
							-82.48021799999994,
							28.05341700000008
						],
						[
							-82.48021974599993,
							28.05414373700006
						],
						[
							-82.48022199999991,
							28.055082000000084
						],
						[
							-82.4801809999999,
							28.055158000000063
						],
						[
							-82.47961199999993,
							28.05512500000009
						],
						[
							-82.47954699999991,
							28.05517800000007
						],
						[
							-82.47948799999995,
							28.05519400000009
						],
						[
							-82.47920999999991,
							28.055188000000044
						],
						[
							-82.47890099999995,
							28.05519400000009
						],
						[
							-82.47859299999993,
							28.055150000000083
						],
						[
							-82.47688999999991,
							28.055166000000042
						],
						[
							-82.47584099999995,
							28.055153000000075
						],
						[
							-82.47516999999993,
							28.05515100000008
						],
						[
							-82.47517799999991,
							28.055206000000055
						],
						[
							-82.47520399999992,
							28.055289000000073
						],
						[
							-82.47523499999994,
							28.055340000000058
						],
						[
							-82.47524499999992,
							28.05536500000005
						],
						[
							-82.47523399999994,
							28.05541700000009
						],
						[
							-82.47518699999995,
							28.055521000000056
						],
						[
							-82.47517499999992,
							28.05557500000009
						],
						[
							-82.47517199999993,
							28.055768000000057
						],
						[
							-82.47515299999992,
							28.055848000000083
						],
						[
							-82.47510699999992,
							28.05595100000005
						],
						[
							-82.47509098799992,
							28.05597606300006
						],
						[
							-82.47506099999994,
							28.05602300000004
						],
						[
							-82.47498499999995,
							28.05611000000005
						],
						[
							-82.47489499999995,
							28.056186000000082
						],
						[
							-82.4748472089999,
							28.056220489000054
						],
						[
							-82.47479799999991,
							28.056256000000076
						],
						[
							-82.47471799999994,
							28.05629600000009
						],
						[
							-82.47465699999992,
							28.056314000000043
						],
						[
							-82.47462499999995,
							28.05631900000009
						],
						[
							-82.47456399999993,
							28.05631500000004
						],
						[
							-82.47453699999994,
							28.05630700000006
						],
						[
							-82.4744839999999,
							28.056278000000077
						],
						[
							-82.47443792799993,
							28.056244151000044
						],
						[
							-82.47438599999992,
							28.05620600000009
						],
						[
							-82.47427699999992,
							28.056108000000055
						],
						[
							-82.47407999999992,
							28.055969000000065
						],
						[
							-82.4740579999999,
							28.055950000000053
						],
						[
							-82.47404199999994,
							28.05592900000005
						],
						[
							-82.47403099999993,
							28.055904000000055
						],
						[
							-82.47402499999993,
							28.05587500000007
						],
						[
							-82.47402899999992,
							28.055817000000047
						],
						[
							-82.47403899999995,
							28.05579300000005
						],
						[
							-82.47405999999995,
							28.055773000000045
						],
						[
							-82.47408899999994,
							28.055758000000083
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Forest Hills",
				"RegionID": "273756"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.48674488099994,
					30.28743192400009,
					-81.4376847389999,
					30.321014104000085
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.44939890899991,
							30.317979013000066
						],
						[
							-81.44913190799991,
							30.317289012000064
						],
						[
							-81.44846290899994,
							30.315430013000082
						],
						[
							-81.44730391099995,
							30.31230201200009
						],
						[
							-81.4472349099999,
							30.312112012000057
						],
						[
							-81.44697590999994,
							30.311399012000038
						],
						[
							-81.44663990799995,
							30.310503013000073
						],
						[
							-81.44631990799991,
							30.30955101300009
						],
						[
							-81.4461289109999,
							30.30911301200007
						],
						[
							-81.44552090899992,
							30.30747701200005
						],
						[
							-81.44547290799994,
							30.307337012000062
						],
						[
							-81.44499990799994,
							30.306026012000075
						],
						[
							-81.44493090999993,
							30.305830012000058
						],
						[
							-81.44483890799997,
							30.305622012000068
						],
						[
							-81.44470195699995,
							30.305268977000086
						],
						[
							-81.44421390799994,
							30.30390901300007
						],
						[
							-81.44390890799991,
							30.303085012000057
						],
						[
							-81.44369490999992,
							30.30269201200008
						],
						[
							-81.44347390799993,
							30.302389013000038
						],
						[
							-81.44330590899995,
							30.30220001300006
						],
						[
							-81.44302391199994,
							30.301929013000063
						],
						[
							-81.44282490899991,
							30.30176201200004
						],
						[
							-81.44245090799991,
							30.30151201300004
						],
						[
							-81.4419019099999,
							30.301254012000076
						],
						[
							-81.44172690799991,
							30.301180013000078
						],
						[
							-81.44134490899995,
							30.30099301300004
						],
						[
							-81.4408649099999,
							30.30078301200007
						],
						[
							-81.43985691099994,
							30.30033901200005
						],
						[
							-81.4395219079999,
							30.30016501300008
						],
						[
							-81.43923190999993,
							30.299982012000044
						],
						[
							-81.43898790899993,
							30.299799012000054
						],
						[
							-81.43864390999994,
							30.29947701200007
						],
						[
							-81.43855990999992,
							30.29938901200006
						],
						[
							-81.43829290899993,
							30.299002012000077
						],
						[
							-81.43810990999992,
							30.298641013000065
						],
						[
							-81.43804190899994,
							30.29847101200005
						],
						[
							-81.43796991099993,
							30.298233013000075
						],
						[
							-81.4378889109999,
							30.297853012000076
						],
						[
							-81.43786590799994,
							30.29759401200005
						],
						[
							-81.4378479099999,
							30.29656501200009
						],
						[
							-81.43783990899993,
							30.29622801300007
						],
						[
							-81.43783790899994,
							30.295910013000082
						],
						[
							-81.43783590899994,
							30.29549801200005
						],
						[
							-81.43780591099994,
							30.294270012000087
						],
						[
							-81.43780090899992,
							30.29402401200008
						],
						[
							-81.43777490899993,
							30.29306801300004
						],
						[
							-81.43775890899991,
							30.29208001200004
						],
						[
							-81.43775490899992,
							30.291535012000054
						],
						[
							-81.43775190999992,
							30.29119501300005
						],
						[
							-81.43770490799994,
							30.289776012000065
						],
						[
							-81.43769891099993,
							30.28959201300006
						],
						[
							-81.43769190899991,
							30.28931401200009
						],
						[
							-81.4376847389999,
							30.288422965000056
						],
						[
							-81.43775898699994,
							30.288313035000048
						],
						[
							-81.43775991099994,
							30.28828701300006
						],
						[
							-81.4377689069999,
							30.287986958000094
						],
						[
							-81.43811590799993,
							30.28798401200004
						],
						[
							-81.43818090999991,
							30.28798301200004
						],
						[
							-81.4399809109999,
							30.28795201300005
						],
						[
							-81.44062191099994,
							30.287948012000076
						],
						[
							-81.44190890999994,
							30.287941012000093
						],
						[
							-81.44271191199994,
							30.287937012000047
						],
						[
							-81.44407890899993,
							30.28791401300009
						],
						[
							-81.44549290799995,
							30.28789101200005
						],
						[
							-81.44715790899994,
							30.287868012000047
						],
						[
							-81.44835490899993,
							30.287853013000074
						],
						[
							-81.44842790799993,
							30.287852013000077
						],
						[
							-81.45079491099995,
							30.287831012000083
						],
						[
							-81.45123090999994,
							30.28782601200004
						],
						[
							-81.4526269079999,
							30.28781401300006
						],
						[
							-81.45278590999993,
							30.287811012000073
						],
						[
							-81.45527190899992,
							30.287768012000072
						],
						[
							-81.45574090999992,
							30.28776901200007
						],
						[
							-81.4588749099999,
							30.28774201200008
						],
						[
							-81.4617979109999,
							30.287701012000074
						],
						[
							-81.46423990799991,
							30.28768701200005
						],
						[
							-81.46676591099994,
							30.287643012000046
						],
						[
							-81.46726990899994,
							30.287636012000064
						],
						[
							-81.46770291099995,
							30.287631012000077
						],
						[
							-81.47376590899995,
							30.28755501200004
						],
						[
							-81.47388590899993,
							30.287553012000046
						],
						[
							-81.47724990799992,
							30.28752101300006
						],
						[
							-81.47986591099993,
							30.287490012000035
						],
						[
							-81.48108691099992,
							30.287475012000076
						],
						[
							-81.48399190899994,
							30.28744601200009
						],
						[
							-81.4841549109999,
							30.287444013000083
						],
						[
							-81.4844719159999,
							30.28743192400009
						],
						[
							-81.48451390699995,
							30.287600011000052
						],
						[
							-81.48589590599994,
							30.294457010000084
						],
						[
							-81.48613190799996,
							30.302105009000062
						],
						[
							-81.48577990699994,
							30.306123010000082
						],
						[
							-81.48577990599995,
							30.306380010000055
						],
						[
							-81.48568903199993,
							30.307012156000045
						],
						[
							-81.48334279799991,
							30.30698098100004
						],
						[
							-81.48344690899995,
							30.307033011000048
						],
						[
							-81.48365790899993,
							30.307168011000044
						],
						[
							-81.48382490799992,
							30.307310011000084
						],
						[
							-81.48396690599992,
							30.307473010000084
						],
						[
							-81.48405790499993,
							30.30762001100004
						],
						[
							-81.48413990699993,
							30.307821010000055
						],
						[
							-81.48421490599992,
							30.308087011000055
						],
						[
							-81.48449590799993,
							30.30906901000009
						],
						[
							-81.48452990599992,
							30.30927801000007
						],
						[
							-81.48453290799995,
							30.30952601000007
						],
						[
							-81.48449890599994,
							30.309735010000058
						],
						[
							-81.48443890899995,
							30.309925010000082
						],
						[
							-81.48436990599993,
							30.310118010000053
						],
						[
							-81.48415372499994,
							30.31082506100006
						],
						[
							-81.48564505999992,
							30.312197927000053
						],
						[
							-81.48639890899994,
							30.31678001000006
						],
						[
							-81.48671190899995,
							30.318860010000037
						],
						[
							-81.48674488099994,
							30.319079098000092
						],
						[
							-81.48619391099993,
							30.319005012000048
						],
						[
							-81.48586891199994,
							30.318965012000035
						],
						[
							-81.4851849069999,
							30.31886901200005
						],
						[
							-81.48495790699991,
							30.318838012000075
						],
						[
							-81.48234290699992,
							30.318480012000066
						],
						[
							-81.4816979069999,
							30.318396013000044
						],
						[
							-81.48132091199994,
							30.318338012000083
						],
						[
							-81.48123390799992,
							30.31832401200006
						],
						[
							-81.48114690699992,
							30.318313012000093
						],
						[
							-81.48087791199993,
							30.318278013000054
						],
						[
							-81.48075491199995,
							30.318259012000055
						],
						[
							-81.4794919119999,
							30.31810401200005
						],
						[
							-81.47825091099993,
							30.31793001200009
						],
						[
							-81.47743390799991,
							30.317824013000067
						],
						[
							-81.47690891099995,
							30.31776601300004
						],
						[
							-81.4764949129999,
							30.317737012000066
						],
						[
							-81.47599191099994,
							30.317737012000066
						],
						[
							-81.47545490699991,
							30.317766012000046
						],
						[
							-81.47510791199994,
							30.317795012000094
						],
						[
							-81.47473891099992,
							30.31785301200006
						],
						[
							-81.4745159119999,
							30.317892012000076
						],
						[
							-81.47412390699992,
							30.317988013000047
						],
						[
							-81.47390090799992,
							30.318046012000078
						],
						[
							-81.47328590699993,
							30.31823901300004
						],
						[
							-81.47311791099992,
							30.318297012000073
						],
						[
							-81.47288286299994,
							30.318383935000043
						],
						[
							-81.47193190799995,
							30.31877801300004
						],
						[
							-81.4712939069999,
							30.319036012000083
						],
						[
							-81.47075891199995,
							30.319228012000053
						],
						[
							-81.47050890799994,
							30.319306013000073
						],
						[
							-81.47026590699994,
							30.319377012000075
						],
						[
							-81.4699679119999,
							30.319449013000053
						],
						[
							-81.4693779079999,
							30.31956301200006
						],
						[
							-81.4691629109999,
							30.319590012000045
						],
						[
							-81.46891291199995,
							30.319620013000073
						],
						[
							-81.46857990799992,
							30.319650012000068
						],
						[
							-81.46835090699994,
							30.319662012000038
						],
						[
							-81.46812890799993,
							30.319674013000053
						],
						[
							-81.46777490799991,
							30.31969801200006
						],
						[
							-81.46736490799992,
							30.319734013000073
						],
						[
							-81.46557391099992,
							30.319866012000038
						],
						[
							-81.46479691199994,
							30.319926013000043
						],
						[
							-81.46283990799994,
							30.320079012000065
						],
						[
							-81.46065390799993,
							30.320238012000065
						],
						[
							-81.46036990699992,
							30.320259013000054
						],
						[
							-81.4593629069999,
							30.320343012000077
						],
						[
							-81.45859991099991,
							30.32039101200007
						],
						[
							-81.4566839119999,
							30.32053001200006
						],
						[
							-81.45650291099993,
							30.320543012000087
						],
						[
							-81.45517091099993,
							30.320655012000092
						],
						[
							-81.45346490799994,
							30.320781012000054
						],
						[
							-81.45259991099994,
							30.320845012000067
						],
						[
							-81.45206390699991,
							30.320886012000074
						],
						[
							-81.45051389499993,
							30.321014104000085
						],
						[
							-81.45043990799991,
							30.320802012000062
						],
						[
							-81.4502129089999,
							30.320171013000053
						],
						[
							-81.44995090799995,
							30.31947901300003
						],
						[
							-81.44980090999991,
							30.319069013000046
						],
						[
							-81.44971490899991,
							30.31884501200005
						],
						[
							-81.44942790899995,
							30.318058013000044
						],
						[
							-81.44939890899991,
							30.317979013000066
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Golden Glades - The Woods",
				"RegionID": "273842"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.39726170951874,
					28.531076297472985,
					-81.38240849699021,
					28.54201852487067
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.38284627436359,
							28.540591407829503
						],
						[
							-81.38283939455006,
							28.54020069737387
						],
						[
							-81.38258588826051,
							28.54020483695313
						],
						[
							-81.38240849699021,
							28.5402169840958
						],
						[
							-81.38249775829895,
							28.538407169558276
						],
						[
							-81.38249775829895,
							28.538359098097864
						],
						[
							-81.3825508380837,
							28.53778624705224
						],
						[
							-81.3827341100207,
							28.53695902187144
						],
						[
							-81.38284527251884,
							28.536574450187963
						],
						[
							-81.38286530491708,
							28.536432239496122
						],
						[
							-81.38289434492471,
							28.536360133654554
						],
						[
							-81.38325688321841,
							28.535481831479032
						],
						[
							-81.38332398433303,
							28.535314582762563
						],
						[
							-81.38335710456474,
							28.53523753064978
						],
						[
							-81.38342313009015,
							28.535093254215248
						],
						[
							-81.38348422193488,
							28.534946036098347
						],
						[
							-81.38360039365664,
							28.534715694545582
						],
						[
							-81.38368952546301,
							28.53454043466857
						],
						[
							-81.38401500899114,
							28.533997629072637
						],
						[
							-81.38423633663918,
							28.533631086097998
						],
						[
							-81.38442862158163,
							28.533367695359978
						],
						[
							-81.38473908283461,
							28.53291903079412
						],
						[
							-81.38479917103595,
							28.532831899979293
						],
						[
							-81.38483422391069,
							28.53278282847279
						],
						[
							-81.38486727219667,
							28.532735757957745
						],
						[
							-81.38510061838429,
							28.532408272538788
						],
						[
							-81.3856724666857,
							28.53154699542862
						],
						[
							-81.3858096699525,
							28.531304635336273
						],
						[
							-81.38590479394153,
							28.531078214827616
						],
						[
							-81.38636349134391,
							28.531076297472985
						],
						[
							-81.38709958282759,
							28.531078300263193
						],
						[
							-81.3872217647185,
							28.531078300263193
						],
						[
							-81.387338938285,
							28.53108130399876
						],
						[
							-81.38769346361953,
							28.53108531047844
						],
						[
							-81.38780362787014,
							28.53108731326855
						],
						[
							-81.38806902049889,
							28.531092319794325
						],
						[
							-81.38888623262832,
							28.531106341124108
						],
						[
							-81.38965937977693,
							28.531121363399265
						],
						[
							-81.39041149448114,
							28.531132380094114
						],
						[
							-81.39092325368193,
							28.531141393099475
						],
						[
							-81.39133786811708,
							28.531146401423896
						],
						[
							-81.3930253712614,
							28.531164427434625
						],
						[
							-81.39506139047027,
							28.531149405159468
						],
						[
							-81.39710241710421,
							28.5311353721385
						],
						[
							-81.39711343469841,
							28.53206676668932
						],
						[
							-81.39711443564387,
							28.532151892915387
						],
						[
							-81.39712244770378,
							28.532970105090826
						],
						[
							-81.39715332952292,
							28.53441831123357
						],
						[
							-81.39722276078092,
							28.534506322484653
						],
						[
							-81.39723461384531,
							28.53473672609062
						],
						[
							-81.39723761848016,
							28.53479080592146
						],
						[
							-81.39725163980995,
							28.535087245844736
						],
						[
							-81.39725264075533,
							28.535177379495764
						],
						[
							-81.39725464354552,
							28.535263505767922
						],
						[
							-81.39725965186986,
							28.53556996144059
						],
						[
							-81.39725965186986,
							28.535624042170788
						],
						[
							-81.39725271899638,
							28.536343129273543
						],
						[
							-81.39720039374275,
							28.53642217878066
						],
						[
							-81.3972025665047,
							28.536507351771363
						],
						[
							-81.39721458504438,
							28.537438731933072
						],
						[
							-81.3972205934148,
							28.538259950542102
						],
						[
							-81.39723261105512,
							28.539202348297927
						],
						[
							-81.39724062311511,
							28.54021485090395
						],
						[
							-81.39724963701975,
							28.541084140074112
						],
						[
							-81.39726170951874,
							28.54199949521646
						],
						[
							-81.38287426216446,
							28.54201852487067
						],
						[
							-81.38286229758411,
							28.541320489097927
						],
						[
							-81.38284627436359,
							28.540591407829503
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Holden-Parramore",
				"RegionID": "274041"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.36295473299998,
					28.120457000000044,
					-82.32248084899999,
					28.142018000000064
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.34023999999994,
							28.141859000000068
						],
						[
							-82.33798758899998,
							28.141855707000047
						],
						[
							-82.331349,
							28.141846000000044
						],
						[
							-82.32594099999994,
							28.14188600000006
						],
						[
							-82.32256630199998,
							28.141875019000054
						],
						[
							-82.32248084899999,
							28.139917404000073
						],
						[
							-82.32313647399997,
							28.13948982200003
						],
						[
							-82.32410565799995,
							28.13923327300006
						],
						[
							-82.32484679899994,
							28.13883419800004
						],
						[
							-82.32598701599994,
							28.13911925200006
						],
						[
							-82.32692769399995,
							28.139261779000037
						],
						[
							-82.32792538399997,
							28.139546833000054
						],
						[
							-82.32866652499996,
							28.13931879000006
						],
						[
							-82.32892307399999,
							28.138520638000045
						],
						[
							-82.32937916099996,
							28.13755145400006
						],
						[
							-82.33017731199999,
							28.134843439000065
						],
						[
							-82.32860951399994,
							28.134387352000033
						],
						[
							-82.32889456799995,
							28.13364621100004
						],
						[
							-82.32875204099997,
							28.133446673000037
						],
						[
							-82.32786837299994,
							28.133190124000066
						],
						[
							-82.32695619999998,
							28.13279104800006
						],
						[
							-82.32644310199998,
							28.131593821000024
						],
						[
							-82.32658562899996,
							28.130396593000057
						],
						[
							-82.32695619999998,
							28.128486730000077
						],
						[
							-82.32689883299997,
							28.127557654000046
						],
						[
							-82.32878399999998,
							28.127563000000066
						],
						[
							-82.32882994999994,
							28.127563458000058
						],
						[
							-82.33089299999995,
							28.12758400000007
						],
						[
							-82.33136384699998,
							28.127572762000057
						],
						[
							-82.33138760699995,
							28.127572195000027
						],
						[
							-82.33713599999999,
							28.127435000000048
						],
						[
							-82.33844524899996,
							28.12745452000007
						],
						[
							-82.34043720999996,
							28.127484219000053
						],
						[
							-82.34458099999995,
							28.127546000000052
						],
						[
							-82.35039001399997,
							28.12765825500003
						],
						[
							-82.35042185199995,
							28.127658866000047
						],
						[
							-82.35242099999994,
							28.12769700000007
						],
						[
							-82.35242199999999,
							28.127613000000057
						],
						[
							-82.35242699999998,
							28.127208000000053
						],
						[
							-82.35246091399995,
							28.12627493100007
						],
						[
							-82.35250699999995,
							28.12500700000004
						],
						[
							-82.35257699999994,
							28.123028000000033
						],
						[
							-82.35261999999994,
							28.120607000000064
						],
						[
							-82.35543099999995,
							28.120561000000066
						],
						[
							-82.35645499999998,
							28.120538000000067
						],
						[
							-82.36042775299995,
							28.12047945000006
						],
						[
							-82.36059399699997,
							28.12047682300005
						],
						[
							-82.36180199999995,
							28.120457000000044
						],
						[
							-82.36180899999994,
							28.121152000000052
						],
						[
							-82.36179899999996,
							28.12148300000007
						],
						[
							-82.361814,
							28.12466900000004
						],
						[
							-82.36181299999998,
							28.12489400000004
						],
						[
							-82.36163399999998,
							28.125092000000052
						],
						[
							-82.36076099999997,
							28.125966000000062
						],
						[
							-82.36047899999994,
							28.126248000000032
						],
						[
							-82.35723299999995,
							28.129069000000072
						],
						[
							-82.35718399999996,
							28.129125000000045
						],
						[
							-82.35720299999997,
							28.12953800000003
						],
						[
							-82.35727999999995,
							28.131196000000045
						],
						[
							-82.35730899999999,
							28.132906000000048
						],
						[
							-82.35971599999993,
							28.136165000000062
						],
						[
							-82.36141899999996,
							28.13442800000007
						],
						[
							-82.36196899999999,
							28.133890000000065
						],
						[
							-82.36231099999998,
							28.13354500000003
						],
						[
							-82.36240199999997,
							28.133436000000074
						],
						[
							-82.36235799999997,
							28.13134400000007
						],
						[
							-82.362449106,
							28.131233260000045
						],
						[
							-82.36253636499998,
							28.131763636000073
						],
						[
							-82.36256363499996,
							28.132318183000052
						],
						[
							-82.36263636599995,
							28.132672726000067
						],
						[
							-82.36272727299996,
							28.132945456000073
						],
						[
							-82.36287272899995,
							28.13318182000006
						],
						[
							-82.36295473299998,
							28.133300016000078
						],
						[
							-82.36174545499995,
							28.13450000000006
						],
						[
							-82.36117272899997,
							28.13506363600004
						],
						[
							-82.360627272,
							28.135600000000068
						],
						[
							-82.35959090699998,
							28.136654547000035
						],
						[
							-82.35422599999998,
							28.14192200000008
						],
						[
							-82.35366199999999,
							28.141936000000044
						],
						[
							-82.35116099999999,
							28.14197000000007
						],
						[
							-82.34929399999999,
							28.141990000000078
						],
						[
							-82.34738804499995,
							28.142016564000073
						],
						[
							-82.34728499999994,
							28.142018000000064
						],
						[
							-82.34567899999996,
							28.141981000000047
						],
						[
							-82.34278599999999,
							28.141917000000035
						],
						[
							-82.34023999999994,
							28.141859000000068
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Hunters Green",
				"RegionID": "274072"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.7101938639999,
					30.189025000000075,
					-81.65972068899993,
					30.245604186000037
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.6739324099999,
							30.24126162400006
						],
						[
							-81.67104168999992,
							30.240610442000047
						],
						[
							-81.6707066699999,
							30.240627552000035
						],
						[
							-81.67038106899992,
							30.240757371000086
						],
						[
							-81.67031586299993,
							30.24078050400004
						],
						[
							-81.67024907099994,
							30.240798556000076
						],
						[
							-81.67018108899993,
							30.24081142000006
						],
						[
							-81.6693590889999,
							30.240934420000087
						],
						[
							-81.66928082299995,
							30.24094265000008
						],
						[
							-81.6692021369999,
							30.240944006000067
						],
						[
							-81.6691236339999,
							30.24093847800009
						],
						[
							-81.66904591499993,
							30.240926107000067
						],
						[
							-81.66896957499995,
							30.240906990000045
						],
						[
							-81.6688951989999,
							30.24088127200008
						],
						[
							-81.66815838899993,
							30.240589815000078
						],
						[
							-81.66766767399992,
							30.240544941000056
						],
						[
							-81.66694044299993,
							30.240573624000035
						],
						[
							-81.66690499999993,
							30.240574322000043
						],
						[
							-81.66677023299991,
							30.24056416700006
						],
						[
							-81.66616323199992,
							30.240472167000068
						],
						[
							-81.66601552199995,
							30.240436807000037
						],
						[
							-81.66419739799994,
							30.23983528800005
						],
						[
							-81.66376498499994,
							30.23988857100005
						],
						[
							-81.66369607699994,
							30.23989438300004
						],
						[
							-81.66301807699995,
							30.239925384000063
						],
						[
							-81.6629769999999,
							30.23992632200009
						],
						[
							-81.66282083399994,
							30.239912660000073
						],
						[
							-81.66266941399994,
							30.239872087000037
						],
						[
							-81.66252733899995,
							30.23980583600007
						],
						[
							-81.66239892699991,
							30.239715921000084
						],
						[
							-81.66237307099993,
							30.239693371000048
						],
						[
							-81.66165807199991,
							30.239045371000085
						],
						[
							-81.6615637459999,
							30.23894576400005
						],
						[
							-81.66131374699995,
							30.238637765000078
						],
						[
							-81.66126907199993,
							30.238577792000058
						],
						[
							-81.66122953399992,
							30.238514314000042
						],
						[
							-81.66119540799991,
							30.238447772000082
						],
						[
							-81.6611669269999,
							30.238378624000067
						],
						[
							-81.66114429099991,
							30.238307348000035
						],
						[
							-81.66100882299992,
							30.23781000400004
						],
						[
							-81.66073310199994,
							30.237004123000077
						],
						[
							-81.66070101399993,
							30.23688363100007
						],
						[
							-81.66055667699993,
							30.236136398000042
						],
						[
							-81.6605416779999,
							30.235973000000058
						],
						[
							-81.66054897299995,
							30.235858687000075
						],
						[
							-81.66071967799991,
							30.234526610000042
						],
						[
							-81.66071967799991,
							30.233906000000047
						],
						[
							-81.66073393199991,
							30.233746552000074
						],
						[
							-81.66078757699995,
							30.23345491300006
						],
						[
							-81.6607779119999,
							30.233435853000064
						],
						[
							-81.66042916899994,
							30.233194465000057
						],
						[
							-81.66037457199991,
							30.23315352700007
						],
						[
							-81.66032323699994,
							30.233108566000055
						],
						[
							-81.66027545899993,
							30.23305984300004
						],
						[
							-81.66023151299993,
							30.23300763700007
						],
						[
							-81.66019165099993,
							30.23295224900005
						],
						[
							-81.65990565099992,
							30.232521249000058
						],
						[
							-81.65986611199992,
							30.232455782000045
						],
						[
							-81.6598322779999,
							30.232387192000086
						],
						[
							-81.65980439399993,
							30.23231597600005
						],
						[
							-81.65978266199994,
							30.232242648000067
						],
						[
							-81.6597672389999,
							30.23216773900009
						],
						[
							-81.6597582359999,
							30.232091790000084
						],
						[
							-81.65972323599993,
							30.23162878900007
						],
						[
							-81.65972068899993,
							30.231556488000077
						],
						[
							-81.65972396199993,
							30.231484216000066
						],
						[
							-81.65973303299995,
							30.231412440000042
						],
						[
							-81.65974784399992,
							30.231341627000067
						],
						[
							-81.65976829999994,
							30.23127223200004
						],
						[
							-81.65994629999994,
							30.230747232000056
						],
						[
							-81.65995291399992,
							30.23072841300006
						],
						[
							-81.66001916399995,
							30.230586339000066
						],
						[
							-81.66010907899994,
							30.23045792700009
						],
						[
							-81.6602199269999,
							30.23034707900007
						],
						[
							-81.66031944699995,
							30.230274576000053
						],
						[
							-81.66071244699992,
							30.230027576000058
						],
						[
							-81.66074133899991,
							30.230010164000078
						],
						[
							-81.66088496799995,
							30.229943351000085
						],
						[
							-81.66131452199994,
							30.229788789000057
						],
						[
							-81.66146283499995,
							30.229749341000062
						],
						[
							-81.66153268499994,
							30.22973983000008
						],
						[
							-81.66194412099993,
							30.22970015800007
						],
						[
							-81.66256242999992,
							30.22927497500007
						],
						[
							-81.66260930199991,
							30.229244838000056
						],
						[
							-81.66329082099992,
							30.228836001000047
						],
						[
							-81.66342853399993,
							30.22876995300004
						],
						[
							-81.66399223299993,
							30.22855650600007
						],
						[
							-81.66409995899994,
							30.228471070000072
						],
						[
							-81.66410375499993,
							30.228306674000066
						],
						[
							-81.66411283199994,
							30.227812348000043
						],
						[
							-81.66412634099993,
							30.22767283500008
						],
						[
							-81.6641669139999,
							30.227521414000076
						],
						[
							-81.66423316399994,
							30.227379339000038
						],
						[
							-81.66432307899993,
							30.22725092700006
						],
						[
							-81.66443392699995,
							30.227140080000083
						],
						[
							-81.66456233899993,
							30.227050165000037
						],
						[
							-81.66470441399991,
							30.22698391400007
						],
						[
							-81.66485583399994,
							30.226943341000034
						],
						[
							-81.66498921499993,
							30.226929967000046
						],
						[
							-81.66522093899994,
							30.226924094000083
						],
						[
							-81.66528747599995,
							30.22682907100005
						],
						[
							-81.66527572099994,
							30.225797699000054
						],
						[
							-81.66522169199993,
							30.21899857400007
						],
						[
							-81.66522476999995,
							30.218920541000045
						],
						[
							-81.66523460699995,
							30.218843069000062
						],
						[
							-81.6652511289999,
							30.21876674200007
						],
						[
							-81.66527420999995,
							30.218692137000062
						],
						[
							-81.66530367699994,
							30.21861981500007
						],
						[
							-81.6653393069999,
							30.21855032300004
						],
						[
							-81.66538083299992,
							30.21848418400009
						],
						[
							-81.66542793999992,
							30.218421897000045
						],
						[
							-81.66547300999991,
							30.21836741200008
						],
						[
							-81.66552676099991,
							30.21830841300004
						],
						[
							-81.66558553199991,
							30.21825441300007
						],
						[
							-81.66564885999993,
							30.218205837000085
						],
						[
							-81.66571624499996,
							30.218163067000035
						],
						[
							-81.66578715599991,
							30.218126440000052
						],
						[
							-81.66586103599991,
							30.218096245000087
						],
						[
							-81.66593730299991,
							30.218072719000077
						],
						[
							-81.66696230199994,
							30.217805719000072
						],
						[
							-81.66703283399994,
							30.21779034100007
						],
						[
							-81.66711280599992,
							30.217783344000058
						],
						[
							-81.66716815199993,
							30.217749236000092
						],
						[
							-81.66722595299991,
							30.217719476000067
						],
						[
							-81.66728586699992,
							30.21769424000007
						],
						[
							-81.6673475419999,
							30.217673678000036
						],
						[
							-81.6674106129999,
							30.217657911000064
						],
						[
							-81.66747470799993,
							30.217647032000063
						],
						[
							-81.66753427399993,
							30.217638856000068
						],
						[
							-81.66760149399994,
							30.217601969000043
						],
						[
							-81.6682674939999,
							30.21728497000004
						],
						[
							-81.66834641399993,
							30.217251914000087
						],
						[
							-81.66844307699995,
							30.217222763000056
						],
						[
							-81.66964147699991,
							30.216933631000078
						],
						[
							-81.6699738829999,
							30.216850529000055
						],
						[
							-81.67009842399995,
							30.21682856000007
						],
						[
							-81.6718954239999,
							30.21664055900004
						],
						[
							-81.67198899999994,
							30.21663567800005
						],
						[
							-81.67209992699992,
							30.216642545000067
						],
						[
							-81.67263092699994,
							30.216708545000074
						],
						[
							-81.67272675899994,
							30.216725768000057
						],
						[
							-81.6739797589999,
							30.217021768000052
						],
						[
							-81.67404652999994,
							30.217040285000056
						],
						[
							-81.67411167799992,
							30.217063887000055
						],
						[
							-81.6741748149999,
							30.21709243500004
						],
						[
							-81.67423556699993,
							30.21712575900005
						],
						[
							-81.6742935719999,
							30.217163662000072
						],
						[
							-81.67434848799991,
							30.21720591800005
						],
						[
							-81.6748340069999,
							30.21761022700008
						],
						[
							-81.67515513099994,
							30.21778197200007
						],
						[
							-81.67521977099995,
							30.21782009400005
						],
						[
							-81.6752810079999,
							30.21786347200009
						],
						[
							-81.67533841499994,
							30.21791180500009
						],
						[
							-81.67539159199993,
							30.217964756000075
						],
						[
							-81.67544016999994,
							30.218021956000086
						],
						[
							-81.67548380999995,
							30.218083006000082
						],
						[
							-81.67573280999994,
							30.21846400600009
						],
						[
							-81.67575883599994,
							30.218506339000044
						],
						[
							-81.67579031499992,
							30.218573847000073
						],
						[
							-81.6758102949999,
							30.218582903000083
						],
						[
							-81.67582984299992,
							30.218592049000055
						],
						[
							-81.67600184399993,
							30.21867504800008
						],
						[
							-81.67606066099995,
							30.218706164000082
						],
						[
							-81.67618907299993,
							30.218796079000075
						],
						[
							-81.67629992099995,
							30.218906927000038
						],
						[
							-81.67638983599994,
							30.219035339000072
						],
						[
							-81.6764560869999,
							30.219177413000068
						],
						[
							-81.67647834799993,
							30.219247328000055
						],
						[
							-81.67649496199994,
							30.21930795900005
						],
						[
							-81.67688722499992,
							30.219716500000057
						],
						[
							-81.67765275199991,
							30.21986736000008
						],
						[
							-81.6777016989999,
							30.21980822600006
						],
						[
							-81.6777555459999,
							30.219753516000083
						],
						[
							-81.67781389299995,
							30.219703635000087
						],
						[
							-81.67787631099992,
							30.219658950000056
						],
						[
							-81.67794233699993,
							30.219619794000042
						],
						[
							-81.67834433699994,
							30.21940379300008
						],
						[
							-81.67841344199991,
							30.21937038100009
						],
						[
							-81.67848514299993,
							30.219342984000036
						],
						[
							-81.67855891999996,
							30.21932180000005
						],
						[
							-81.6786342339999,
							30.219306985000056
						],
						[
							-81.67871053699992,
							30.219298646000084
						],
						[
							-81.67915367799993,
							30.21926928100004
						],
						[
							-81.67915367799993,
							30.218473781000057
						],
						[
							-81.67901873599993,
							30.218113233000054
						],
						[
							-81.67899689899993,
							30.218047218000038
						],
						[
							-81.67876789899992,
							30.217253218000053
						],
						[
							-81.67874634099991,
							30.217160166000046
						],
						[
							-81.6787388329999,
							30.21711445400007
						],
						[
							-81.67871307899992,
							30.217085073000074
						],
						[
							-81.67862316399993,
							30.21695666100004
						],
						[
							-81.67855691299991,
							30.21681458600006
						],
						[
							-81.67851633999993,
							30.216663166000046
						],
						[
							-81.67850291499991,
							30.216527656000036
						],
						[
							-81.67848542099995,
							30.215766214000045
						],
						[
							-81.67828542199993,
							30.214590861000094
						],
						[
							-81.67827707999993,
							30.214528874000052
						],
						[
							-81.67816207999994,
							30.213370873000088
						],
						[
							-81.67815890099992,
							30.213235121000082
						],
						[
							-81.67817754099991,
							30.21287801200009
						],
						[
							-81.67821504299991,
							30.21185952900004
						],
						[
							-81.67834389699993,
							30.20602215300005
						],
						[
							-81.67834799799995,
							30.20595394700007
						],
						[
							-81.67835726699991,
							30.20588625000005
						],
						[
							-81.67837164799994,
							30.205819452000075
						],
						[
							-81.67839105999991,
							30.205753939000093
						],
						[
							-81.67841538899995,
							30.205690088000043
						],
						[
							-81.67844449599994,
							30.205628269000044
						],
						[
							-81.68187349699991,
							30.199010270000088
						],
						[
							-81.6818931649999,
							30.198974339000074
						],
						[
							-81.68198307999995,
							30.19884592700004
						],
						[
							-81.68209392699993,
							30.198735080000063
						],
						[
							-81.6822223389999,
							30.198645165000073
						],
						[
							-81.68236441399995,
							30.19857891400005
						],
						[
							-81.6824309189999,
							30.19855759400008
						],
						[
							-81.6859530399999,
							30.197577550000062
						],
						[
							-81.68853328199992,
							30.195168634000087
						],
						[
							-81.68858483199995,
							30.195124040000053
						],
						[
							-81.68863961099993,
							30.195083480000054
						],
						[
							-81.68869730499995,
							30.19504718400009
						],
						[
							-81.68875758199994,
							30.19501536200005
						],
						[
							-81.68882009599992,
							30.19498819700004
						],
						[
							-81.68887105899995,
							30.19496831200007
						],
						[
							-81.68889986599993,
							30.194865476000075
						],
						[
							-81.68891457799992,
							30.194704356000045
						],
						[
							-81.68894475399992,
							30.194388468000056
						],
						[
							-81.68895544799994,
							30.194311677000087
						],
						[
							-81.6889727169999,
							30.194236092000043
						],
						[
							-81.68899643099991,
							30.194162275000057
						],
						[
							-81.68902641499994,
							30.194090775000067
						],
						[
							-81.68906244699991,
							30.194022124000075
						],
						[
							-81.68910425699994,
							30.19395683100004
						],
						[
							-81.6892495219999,
							30.19375017300007
						],
						[
							-81.68928008599994,
							30.19355831900009
						],
						[
							-81.68932191399995,
							30.19339941400005
						],
						[
							-81.68937811499991,
							30.193275213000053
						],
						[
							-81.69053209499992,
							30.191166865000074
						],
						[
							-81.6912309999999,
							30.191212000000064
						],
						[
							-81.6915538369999,
							30.191230307000072
						],
						[
							-81.6943169999999,
							30.191387000000077
						],
						[
							-81.6957359999999,
							30.191427000000086
						],
						[
							-81.69731699999994,
							30.19149500000009
						],
						[
							-81.69796899999994,
							30.191534000000047
						],
						[
							-81.69891699999994,
							30.191590000000076
						],
						[
							-81.69932199999994,
							30.191522000000074
						],
						[
							-81.6994003879999,
							30.191508970000083
						],
						[
							-81.69970099999995,
							30.19145900000007
						],
						[
							-81.70061499999991,
							30.191437000000064
						],
						[
							-81.70091970099992,
							30.19142994200007
						],
						[
							-81.70120271799995,
							30.191423387000043
						],
						[
							-81.70186699999994,
							30.19140800000008
						],
						[
							-81.70191899999992,
							30.19141300000007
						],
						[
							-81.70203599999991,
							30.191424000000044
						],
						[
							-81.7026249999999,
							30.191481000000067
						],
						[
							-81.70272399999993,
							30.191340000000082
						],
						[
							-81.70274511199995,
							30.191310477000055
						],
						[
							-81.70374299999992,
							30.189915000000045
						],
						[
							-81.70378199999993,
							30.18985900000007
						],
						[
							-81.70368799999994,
							30.189734000000048
						],
						[
							-81.7032529999999,
							30.189165000000063
						],
						[
							-81.70321599999994,
							30.18908600000009
						],
						[
							-81.70335699999993,
							30.189028000000068
						],
						[
							-81.70344232899993,
							30.189026348000088
						],
						[
							-81.70351199999993,
							30.189025000000075
						],
						[
							-81.70354744799994,
							30.189045838000087
						],
						[
							-81.7038059059999,
							30.189402009000048
						],
						[
							-81.70397790599992,
							30.189634009000088
						],
						[
							-81.7040519059999,
							30.189720008000055
						],
						[
							-81.70460690499993,
							30.190409008000074
						],
						[
							-81.70537190499994,
							30.191367008000046
						],
						[
							-81.70545990599993,
							30.19149500800006
						],
						[
							-81.7056309059999,
							30.191742009000052
						],
						[
							-81.70570790599993,
							30.191858009000047
						],
						[
							-81.70609490499993,
							30.192490008000053
						],
						[
							-81.70630790499992,
							30.192869008000063
						],
						[
							-81.70633890599993,
							30.192923008000033
						],
						[
							-81.7065519059999,
							30.193306008000036
						],
						[
							-81.70667590499994,
							30.193599008000035
						],
						[
							-81.70677190599991,
							30.193813009000053
						],
						[
							-81.70690490599992,
							30.194111009000043
						],
						[
							-81.70705390599994,
							30.194501009000078
						],
						[
							-81.70731890599991,
							30.195324008000057
						],
						[
							-81.70744890599991,
							30.195762009000074
						],
						[
							-81.7075479049999,
							30.19612200800009
						],
						[
							-81.70756890499992,
							30.19627200800005
						],
						[
							-81.70777490599994,
							30.19717400800005
						],
						[
							-81.70782490599993,
							30.197450008000093
						],
						[
							-81.70788190599991,
							30.197760008000046
						],
						[
							-81.70791590599993,
							30.198027009000043
						],
						[
							-81.70796790499992,
							30.198612009000048
						],
						[
							-81.70800790499993,
							30.19950900900005
						],
						[
							-81.7080159059999,
							30.200056009000036
						],
						[
							-81.70799590599995,
							30.20065300800007
						],
						[
							-81.70789990599991,
							30.201300008000093
						],
						[
							-81.7077929049999,
							30.20196700800005
						],
						[
							-81.7076369049999,
							30.202745009000065
						],
						[
							-81.70739201899994,
							30.20367307400005
						],
						[
							-81.70722979099992,
							30.20383594200007
						],
						[
							-81.70620090599994,
							30.207239008000045
						],
						[
							-81.7061079049999,
							30.207548008000057
						],
						[
							-81.70593290499994,
							30.208103008000084
						],
						[
							-81.7057649059999,
							30.208670008000066
						],
						[
							-81.70521490499993,
							30.210443008000087
						],
						[
							-81.70505490499994,
							30.210988009000065
						],
						[
							-81.7045529049999,
							30.212631008000074
						],
						[
							-81.7043709049999,
							30.21330700800007
						],
						[
							-81.70426390599994,
							30.21364900900005
						],
						[
							-81.70398390499992,
							30.21453100900004
						],
						[
							-81.70384390599992,
							30.214951008000067
						],
						[
							-81.70381890499995,
							30.215059008000082
						],
						[
							-81.70375790599991,
							30.215225008000065
						],
						[
							-81.70317090599991,
							30.21712000800005
						],
						[
							-81.70260590599992,
							30.219082008000044
						],
						[
							-81.7021179059999,
							30.220549008000035
						],
						[
							-81.70141290499993,
							30.222830008000074
						],
						[
							-81.70085290599991,
							30.22478300800009
						],
						[
							-81.70061690599994,
							30.225553009000066
						],
						[
							-81.70058190599991,
							30.225673009000047
						],
						[
							-81.70051581299992,
							30.22587812100005
						],
						[
							-81.7006679029999,
							30.225794819000043
						],
						[
							-81.70119187099993,
							30.22605813300004
						],
						[
							-81.70162190499991,
							30.22611400800008
						],
						[
							-81.70966499999992,
							30.226531000000076
						],
						[
							-81.7101938639999,
							30.22655841900007
						],
						[
							-81.71010221299991,
							30.226762087000058
						],
						[
							-81.70952454699994,
							30.227635992000046
						],
						[
							-81.70937642699994,
							30.227932232000057
						],
						[
							-81.70900612799994,
							30.228954257000055
						],
						[
							-81.70881357299993,
							30.22922087200004
						],
						[
							-81.7083247779999,
							30.229887410000064
						],
						[
							-81.7080433509999,
							30.23025770900006
						],
						[
							-81.70788041899993,
							30.23068725600007
						],
						[
							-81.7080433509999,
							30.231279735000044
						],
						[
							-81.70828034199992,
							30.231724093000082
						],
						[
							-81.70874720699993,
							30.23224236900006
						],
						[
							-81.7088341239999,
							30.232411723000038
						],
						[
							-81.70897481299995,
							30.232667258000053
						],
						[
							-81.70903208599994,
							30.232793413000078
						],
						[
							-81.70905463299994,
							30.23286437200005
						],
						[
							-81.70911463399996,
							30.233084373000054
						],
						[
							-81.70913265899992,
							30.233164834000036
						],
						[
							-81.70914306599991,
							30.23324454300007
						],
						[
							-81.70916806699995,
							30.23353754300007
						],
						[
							-81.70917128999992,
							30.233606318000056
						],
						[
							-81.70916924199992,
							30.23367513800008
						],
						[
							-81.70916193499994,
							30.233743600000082
						],
						[
							-81.70914941199993,
							30.23381130200005
						],
						[
							-81.70906441199992,
							30.23418930200006
						],
						[
							-81.70901728199993,
							30.234337560000085
						],
						[
							-81.70881181699991,
							30.23483123400007
						],
						[
							-81.70856141099996,
							30.23562790500006
						],
						[
							-81.70855061899994,
							30.237261962000044
						],
						[
							-81.7085966919999,
							30.237721183000076
						],
						[
							-81.70873232799994,
							30.238123896000047
						],
						[
							-81.70921406199994,
							30.23899491900005
						],
						[
							-81.70847399999991,
							30.239515000000043
						],
						[
							-81.7073709089999,
							30.240290201000047
						],
						[
							-81.70637690899991,
							30.239723820000048
						],
						[
							-81.7052969259999,
							30.240300089000073
						],
						[
							-81.70044683299994,
							30.240311176000038
						],
						[
							-81.69802790499995,
							30.237723009000035
						],
						[
							-81.6975297219999,
							30.237277068000086
						],
						[
							-81.69788890599995,
							30.235932009000063
						],
						[
							-81.69828584899994,
							30.234401002000087
						],
						[
							-81.6982507749999,
							30.233855985000048
						],
						[
							-81.69832690499993,
							30.233645008000057
						],
						[
							-81.69835990699994,
							30.23351400900009
						],
						[
							-81.6985117989999,
							30.233105854000087
						],
						[
							-81.69858801299995,
							30.233106163000063
						],
						[
							-81.6989078389999,
							30.232275961000084
						],
						[
							-81.69906206999991,
							30.232151982000065
						],
						[
							-81.69884090599993,
							30.232065008000063
						],
						[
							-81.69874783499995,
							30.232020838000043
						],
						[
							-81.69826190599991,
							30.233486008000057
						],
						[
							-81.69819090499993,
							30.233825008000057
						],
						[
							-81.69813890599994,
							30.233987008000042
						],
						[
							-81.6980899049999,
							30.23416600800005
						],
						[
							-81.69799001799993,
							30.23448916500007
						],
						[
							-81.69787290599993,
							30.23448900900007
						],
						[
							-81.69763390599991,
							30.23450000800005
						],
						[
							-81.69713290399996,
							30.23452400800005
						],
						[
							-81.6954079059999,
							30.23429300900005
						],
						[
							-81.68750990599995,
							30.23447900800005
						],
						[
							-81.68561279799991,
							30.234662854000078
						],
						[
							-81.68116990699991,
							30.244094009000037
						],
						[
							-81.68105082199992,
							30.244443999000058
						],
						[
							-81.68108607599993,
							30.24473404400004
						],
						[
							-81.68087899999995,
							30.245059000000083
						],
						[
							-81.68004057399992,
							30.245604186000037
						],
						[
							-81.67676104999993,
							30.243622807000065
						],
						[
							-81.67664792699992,
							30.243541921000084
						],
						[
							-81.6765997469999,
							30.24349843600004
						],
						[
							-81.67619955099991,
							30.24311013400006
						],
						[
							-81.67582449399994,
							30.243014362000054
						],
						[
							-81.67573941299992,
							30.242988086000086
						],
						[
							-81.67559733899992,
							30.24292183600005
						],
						[
							-81.67546892699994,
							30.242831921000064
						],
						[
							-81.67535807899992,
							30.242721073000045
						],
						[
							-81.6753184069999,
							30.242670194000084
						],
						[
							-81.67523067699994,
							30.242548949000085
						],
						[
							-81.6750003109999,
							30.242389563000074
						],
						[
							-81.67493392699993,
							30.24233892000007
						],
						[
							-81.67485024899992,
							30.24225898700007
						],
						[
							-81.6739324099999,
							30.24126162400006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Jacksonville Naval Air Station",
				"RegionID": "274123"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.61353007299994,
					30.345756721000043,
					-81.60261385099994,
					30.363942069000075
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.60497993099995,
							30.354269070000043
						],
						[
							-81.60508690799992,
							30.354216009000083
						],
						[
							-81.60514785999993,
							30.35417183000004
						],
						[
							-81.60572803699995,
							30.35423307900004
						],
						[
							-81.60557590799993,
							30.35405901000007
						],
						[
							-81.6055219079999,
							30.35401001000008
						],
						[
							-81.60529286199994,
							30.35374303600008
						],
						[
							-81.60523190799995,
							30.35360701000008
						],
						[
							-81.60517890799991,
							30.353430010000068
						],
						[
							-81.6050489079999,
							30.353123010000047
						],
						[
							-81.6049419069999,
							30.352816011000073
						],
						[
							-81.60447690799992,
							30.351603010000076
						],
						[
							-81.60436196799992,
							30.351346835000072
						],
						[
							-81.60405590699992,
							30.35151000900004
						],
						[
							-81.60359285599992,
							30.351665190000066
						],
						[
							-81.60349300799993,
							30.35153786500007
						],
						[
							-81.60332286199991,
							30.351486077000065
						],
						[
							-81.60303290799993,
							30.351152012000057
						],
						[
							-81.6029219099999,
							30.35106901300008
						],
						[
							-81.60283290699994,
							30.351027011000042
						],
						[
							-81.60268692999995,
							30.35097887700005
						],
						[
							-81.60261385099994,
							30.350981005000055
						],
						[
							-81.60261490799991,
							30.350702011000067
						],
						[
							-81.60263090799992,
							30.35010501100004
						],
						[
							-81.60266090799992,
							30.349438010000082
						],
						[
							-81.60267590699995,
							30.349300010000032
						],
						[
							-81.60272190799992,
							30.348415010000053
						],
						[
							-81.60275990699995,
							30.34798001100006
						],
						[
							-81.60275990799994,
							30.347504010000083
						],
						[
							-81.60274390799992,
							30.346990010000074
						],
						[
							-81.60274790799991,
							30.34664801000008
						],
						[
							-81.60273081799994,
							30.346070024000085
						],
						[
							-81.60517190699994,
							30.346038010000086
						],
						[
							-81.6080979159999,
							30.346072098000036
						],
						[
							-81.60856990699995,
							30.34598801100009
						],
						[
							-81.6099930979999,
							30.345756721000043
						],
						[
							-81.61140232399993,
							30.34587872900005
						],
						[
							-81.61136696199992,
							30.345926123000083
						],
						[
							-81.6113177709999,
							30.345981796000046
						],
						[
							-81.61129377199991,
							30.346006796000037
						],
						[
							-81.61124117999992,
							30.346058448000065
						],
						[
							-81.61118409599993,
							30.34610508600008
						],
						[
							-81.61112299599996,
							30.346146322000042
						],
						[
							-81.61105838799995,
							30.34618181200005
						],
						[
							-81.61099081299994,
							30.346211261000064
						],
						[
							-81.61122166199993,
							30.346626050000054
						],
						[
							-81.61163024299992,
							30.347206122000046
						],
						[
							-81.6116715469999,
							30.347270398000035
						],
						[
							-81.61170724599992,
							30.347337947000085
						],
						[
							-81.61173708299992,
							30.34740828300005
						],
						[
							-81.61176084199991,
							30.34748089800007
						],
						[
							-81.61197984199994,
							30.34826089800003
						],
						[
							-81.61199965999992,
							30.34834783400004
						],
						[
							-81.61201088599995,
							30.34843784800006
						],
						[
							-81.61241588599995,
							30.35392884900006
						],
						[
							-81.61241727099991,
							30.35403846700007
						],
						[
							-81.6124082849999,
							30.354224163000087
						],
						[
							-81.61231633799991,
							30.356151268000076
						],
						[
							-81.61353007299994,
							30.36258913000006
						],
						[
							-81.61265381999993,
							30.36279552700006
						],
						[
							-81.60684489899995,
							30.363942069000075
						],
						[
							-81.60407074099993,
							30.356487929000085
						],
						[
							-81.60420907299994,
							30.356451088000085
						],
						[
							-81.6041319069999,
							30.35627701100009
						],
						[
							-81.60351190799992,
							30.354770008000063
						],
						[
							-81.60350374299992,
							30.354730914000072
						],
						[
							-81.60462190699991,
							30.354380010000057
						],
						[
							-81.60497993099995,
							30.354269070000043
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Jacksonville University",
				"RegionID": "274124"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.72123482399991,
					30.336144822000055,
					-81.6892578959999,
					30.35910006300009
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.69466990799992,
							30.341370011000038
						],
						[
							-81.69308790799994,
							30.34033301100004
						],
						[
							-81.69276090799991,
							30.340143009000087
						],
						[
							-81.69106290799994,
							30.33881301000008
						],
						[
							-81.68993290799995,
							30.337927010000044
						],
						[
							-81.6892578959999,
							30.337397997000036
						],
						[
							-81.68935395699992,
							30.337241031000072
						],
						[
							-81.68947090699993,
							30.337036010000077
						],
						[
							-81.6895289069999,
							30.336941013000057
						],
						[
							-81.68957490799994,
							30.33689301100009
						],
						[
							-81.68965090799992,
							30.33683601100006
						],
						[
							-81.69005590799992,
							30.336580009000045
						],
						[
							-81.69010892799992,
							30.336537828000075
						],
						[
							-81.69022390799995,
							30.336687011000038
						],
						[
							-81.69051386099994,
							30.33701307900009
						],
						[
							-81.69055890599992,
							30.337030008000056
						],
						[
							-81.69060490499993,
							30.337033953000056
						],
						[
							-81.69064293299994,
							30.337025056000073
						],
						[
							-81.69120790699992,
							30.336670010000034
						],
						[
							-81.69199393899993,
							30.336144822000055
						],
						[
							-81.69227590799994,
							30.336489011000083
						],
						[
							-81.69246690799991,
							30.336704011000055
						],
						[
							-81.69284090799995,
							30.337122011000076
						],
						[
							-81.69294690699991,
							30.33725201100009
						],
						[
							-81.69342790699994,
							30.337807010000066
						],
						[
							-81.69406082199993,
							30.338560112000042
						],
						[
							-81.69415991099993,
							30.33860601000004
						],
						[
							-81.69422891099993,
							30.338623009000063
						],
						[
							-81.69429804899994,
							30.338625127000054
						],
						[
							-81.69425576399993,
							30.338449900000057
						],
						[
							-81.69580101799994,
							30.33835385500004
						],
						[
							-81.69586190699994,
							30.338579010000046
						],
						[
							-81.69586890699992,
							30.338652010000093
						],
						[
							-81.69584673899995,
							30.339230056000076
						],
						[
							-81.69587685399995,
							30.339275033000035
						],
						[
							-81.69595190699994,
							30.339561010000068
						],
						[
							-81.69604076799993,
							30.339920136000046
						],
						[
							-81.6972959069999,
							30.340353010000058
						],
						[
							-81.69736490999992,
							30.340370009000083
						],
						[
							-81.6981959069999,
							30.340366010000082
						],
						[
							-81.69930290699995,
							30.340357010000048
						],
						[
							-81.7004010419999,
							30.34034914200004
						],
						[
							-81.70037790799995,
							30.33952701000004
						],
						[
							-81.70037790799995,
							30.33870901100005
						],
						[
							-81.70037090799991,
							30.337870011000064
						],
						[
							-81.70036290699996,
							30.337097011000083
						],
						[
							-81.70035577499993,
							30.336566877000053
						],
						[
							-81.70136290799991,
							30.336576010000044
						],
						[
							-81.70275890699992,
							30.33657801000004
						],
						[
							-81.70320890699992,
							30.33657801000004
						],
						[
							-81.70437590699993,
							30.336597010000045
						],
						[
							-81.70551290799995,
							30.33661106500006
						],
						[
							-81.7076949069999,
							30.336637010000064
						],
						[
							-81.70901490799992,
							30.336657010000067
						],
						[
							-81.70981590699995,
							30.33666001000006
						],
						[
							-81.71030390699991,
							30.336666010000044
						],
						[
							-81.7110749069999,
							30.336658010000065
						],
						[
							-81.71144090699994,
							30.336650010000085
						],
						[
							-81.7120359079999,
							30.336653010000077
						],
						[
							-81.71305790799994,
							30.336670009000045
						],
						[
							-81.71315790799991,
							30.336655010000072
						],
						[
							-81.71408804099991,
							30.336642877000084
						],
						[
							-81.7140879079999,
							30.338276010000076
						],
						[
							-81.71409590699996,
							30.338518010000083
						],
						[
							-81.7140879079999,
							30.338591010000073
						],
						[
							-81.71410390799991,
							30.340256011000065
						],
						[
							-81.7140879079999,
							30.34143301100005
						],
						[
							-81.71410390799991,
							30.342441010000076
						],
						[
							-81.71411090799995,
							30.34286501100007
						],
						[
							-81.7141108539999,
							30.34387400900005
						],
						[
							-81.71411890799993,
							30.34478801100005
						],
						[
							-81.71411890799993,
							30.345695010000043
						],
						[
							-81.71411890799993,
							30.346586010000067
						],
						[
							-81.71412690799991,
							30.347517011000036
						],
						[
							-81.71412690799991,
							30.34841201000006
						],
						[
							-81.71412690799991,
							30.349331010000075
						],
						[
							-81.7141339069999,
							30.349596011000077
						],
						[
							-81.71412690799991,
							30.349907010000035
						],
						[
							-81.71413390799995,
							30.35024801100008
						],
						[
							-81.71414190899992,
							30.35117500900009
						],
						[
							-81.71419490799991,
							30.351423010000076
						],
						[
							-81.71423291199994,
							30.351536011000064
						],
						[
							-81.71706785399994,
							30.355427556000052
						],
						[
							-81.72123482399991,
							30.35895807500009
						],
						[
							-81.7202989079999,
							30.35910006300009
						],
						[
							-81.71987990799994,
							30.35905801000007
						],
						[
							-81.7177369069999,
							30.358611011000047
						],
						[
							-81.71532738899992,
							30.35803357000009
						],
						[
							-81.71404890699996,
							30.356996011000035
						],
						[
							-81.7106019069999,
							30.354364011000087
						],
						[
							-81.71033190799994,
							30.35420301000005
						],
						[
							-81.70734090699995,
							30.351974010000045
						],
						[
							-81.70495590799993,
							30.350062010000045
						],
						[
							-81.70480190699993,
							30.349938010000077
						],
						[
							-81.70348690799995,
							30.348888010000053
						],
						[
							-81.7020991199999,
							30.347794127000043
						],
						[
							-81.69786290699994,
							30.34417401100006
						],
						[
							-81.69703590799992,
							30.343460010000058
						],
						[
							-81.69612890899992,
							30.342437013000055
						],
						[
							-81.69466990799992,
							30.341370011000038
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Kennel Club",
				"RegionID": "274173"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.35568900008177,
					28.524053999863185,
					-81.343379745643,
					28.538462249435295
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.34345986264528,
							28.53005878834128
						],
						[
							-81.34343182178436,
							28.529171472261027
						],
						[
							-81.34342781620414,
							28.529114386895973
						],
						[
							-81.34341379487435,
							28.5282531097858
						],
						[
							-81.34339777075445,
							28.52735277422059
						],
						[
							-81.34339476701888,
							28.526433411699188
						],
						[
							-81.34339476611952,
							28.52547799445822
						],
						[
							-81.343379745643,
							28.52513849139896
						],
						[
							-81.34339576796425,
							28.524229141929098
						],
						[
							-81.34339678509747,
							28.524135917308186
						],
						[
							-81.34352699973273,
							28.52414200032237
						],
						[
							-81.34361400014582,
							28.524132999907557
						],
						[
							-81.34365600028323,
							28.524130999815284
						],
						[
							-81.34366321374524,
							28.524130468315995
						],
						[
							-81.34386060144085,
							28.52411593257406
						],
						[
							-81.3439139995857,
							28.52411199983876
						],
						[
							-81.34391350945518,
							28.524121538947554
						],
						[
							-81.34389999983964,
							28.524387999970934
						],
						[
							-81.34375300025805,
							28.524387999970934
						],
						[
							-81.34376399986584,
							28.524792999754332
						],
						[
							-81.34376599995794,
							28.52495800016571
						],
						[
							-81.34376685161597,
							28.525097018264255
						],
						[
							-81.34377100018848,
							28.52577400000896
						],
						[
							-81.34388273915198,
							28.52577400000896
						],
						[
							-81.34424300036235,
							28.52577400000896
						],
						[
							-81.34473699975166,
							28.52577400000896
						],
						[
							-81.34473699975166,
							28.525436999762853
						],
						[
							-81.34424300036235,
							28.525436999762853
						],
						[
							-81.34417199978742,
							28.525436999762853
						],
						[
							-81.34416999969524,
							28.524653999642197
						],
						[
							-81.34418665603849,
							28.524128899898336
						],
						[
							-81.34418899967177,
							28.524054999909275
						],
						[
							-81.34424300036235,
							28.524054999909275
						],
						[
							-81.34539599955235,
							28.524060000139727
						],
						[
							-81.34545200033511,
							28.524060000139727
						],
						[
							-81.34587400000277,
							28.524062000231908
						],
						[
							-81.34615000013494,
							28.524053999863185
						],
						[
							-81.34615260547089,
							28.524120753839483
						],
						[
							-81.34617100020365,
							28.524592000381453
						],
						[
							-81.34627899978616,
							28.524571000312747
						],
						[
							-81.34649900003487,
							28.524573999551734
						],
						[
							-81.34650999964256,
							28.52576400044734
						],
						[
							-81.34659800010175,
							28.52576400044734
						],
						[
							-81.34697367749041,
							28.525758751104597
						],
						[
							-81.34709899981378,
							28.525757000124614
						],
						[
							-81.34749500008165,
							28.52576400044734
						],
						[
							-81.34809099967622,
							28.52576400044734
						],
						[
							-81.34959000042649,
							28.52576499959406
						],
						[
							-81.35059099980437,
							28.52576400044734
						],
						[
							-81.35177100023907,
							28.52576400044734
						],
						[
							-81.35190600016684,
							28.52576400044734
						],
						[
							-81.35191299959028,
							28.52667600021922
						],
						[
							-81.35192600018945,
							28.526979999843533
						],
						[
							-81.3519339996589,
							28.52728899969813
						],
						[
							-81.35279099959357,
							28.52728799965204
						],
						[
							-81.35371399987253,
							28.52728699960595
						],
						[
							-81.35479100005587,
							28.527285999559858
						],
						[
							-81.35568900008177,
							28.52730999976692
						],
						[
							-81.35567311625604,
							28.527394964114926
						],
						[
							-81.35476863481634,
							28.527531038732455
						],
						[
							-81.35466648712222,
							28.527530984773215
						],
						[
							-81.35469452438583,
							28.528617650869613
						],
						[
							-81.35469265559468,
							28.529399944123256
						],
						[
							-81.35360677820356,
							28.529399679722665
						],
						[
							-81.35372695550572,
							28.531267714569736
						],
						[
							-81.35537454224173,
							28.531368671561395
						],
						[
							-81.35541359170352,
							28.531961609863764
						],
						[
							-81.3554306167688,
							28.534150856459327
						],
						[
							-81.35545164741447,
							28.534995108504223
						],
						[
							-81.3554626641094,
							28.535764249173155
						],
						[
							-81.35546867247982,
							28.53685286410051
						],
						[
							-81.35547468174961,
							28.53771313936585
						],
						[
							-81.35547568359435,
							28.537874378812532
						],
						[
							-81.35548069101941,
							28.53803061083407
						],
						[
							-81.3554826938096,
							28.538115737060053
						],
						[
							-81.35548369475507,
							28.538230907836436
						],
						[
							-81.35548669759127,
							28.538351139997197
						],
						[
							-81.3535808732325,
							28.538358096253123
						],
						[
							-81.35217679052649,
							28.53837412037302
						],
						[
							-81.35182627436967,
							28.538379072939467
						],
						[
							-81.34956692112529,
							28.538409172348388
						],
						[
							-81.3477572369894,
							28.53842118998869
						],
						[
							-81.34770215441445,
							28.53842118998869
						],
						[
							-81.34764106436836,
							28.53842219093415
						],
						[
							-81.34355700831021,
							28.538462249435295
						],
						[
							-81.34355700741094,
							28.538342072133133
						],
						[
							-81.3435560055662,
							28.53825093753673
						],
						[
							-81.34355500462074,
							28.537972523624184
						],
						[
							-81.34355300183053,
							28.537514845153687
						],
						[
							-81.3435339730758,
							28.537035134192685
						],
						[
							-81.34353697771073,
							28.53680178890444
						],
						[
							-81.3435319693863,
							28.535483833369867
						],
						[
							-81.34352496007043,
							28.535093254215248
						],
						[
							-81.34351694801043,
							28.534634574799284
						],
						[
							-81.34351494522032,
							28.534303082001273
						],
						[
							-81.34351194058537,
							28.5337482596644
						],
						[
							-81.34351093874064,
							28.533553971931923
						],
						[
							-81.34350392852538,
							28.53280986838825
						],
						[
							-81.34348790440548,
							28.531949592223455
						],
						[
							-81.34347697764288,
							28.530982139355864
						],
						[
							-81.34345986264528,
							28.53005878834128
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Lake Como",
				"RegionID": "274225"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.36861622365294,
					28.52763905989869,
					-81.35537454224173,
					28.538351139997197
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.35547468174961,
							28.53771313936585
						],
						[
							-81.35546867247982,
							28.53685286410051
						],
						[
							-81.3554626641094,
							28.535764249173155
						],
						[
							-81.35545164741447,
							28.534995108504223
						],
						[
							-81.3554306167688,
							28.534150856459327
						],
						[
							-81.35541359170352,
							28.531961609863764
						],
						[
							-81.35537454224173,
							28.531368671561395
						],
						[
							-81.35585925163444,
							28.53136472443699
						],
						[
							-81.35887772889902,
							28.531353708641426
						],
						[
							-81.35988622682402,
							28.531343747750647
						],
						[
							-81.36009353134361,
							28.531342691946577
						],
						[
							-81.3606293267243,
							28.531336683576157
						],
						[
							-81.36225573892308,
							28.53132065945617
						],
						[
							-81.3628476169248,
							28.531326667826683
						],
						[
							-81.36411662685802,
							28.531331808351396
						],
						[
							-81.36415355302053,
							28.530181970278285
						],
						[
							-81.3641534217195,
							28.528555534697052
						],
						[
							-81.36451506069115,
							28.527772312443776
						],
						[
							-81.36505789236739,
							28.5278324851815
						],
						[
							-81.36596223711021,
							28.52777239787943
						],
						[
							-81.36698675465861,
							28.527772396980062
						],
						[
							-81.36821169331569,
							28.52763905989869
						],
						[
							-81.36822959791803,
							28.52837328888652
						],
						[
							-81.36826464989339,
							28.529273623552363
						],
						[
							-81.36828167495875,
							28.530129893237564
						],
						[
							-81.36828467959361,
							28.530176963752517
						],
						[
							-81.36828467959361,
							28.530266096458178
						],
						[
							-81.36827566748761,
							28.530393286673515
						],
						[
							-81.36829870182268,
							28.530571548487536
						],
						[
							-81.36832874727244,
							28.53067570436763
						],
						[
							-81.36841286895566,
							28.530825925320734
						],
						[
							-81.36850994986938,
							28.530996199356494
						],
						[
							-81.36860014647307,
							28.53128760937163
						],
						[
							-81.36861416870214,
							28.531401779202554
						],
						[
							-81.36861617149225,
							28.531788352776864
						],
						[
							-81.36861622365294,
							28.531860469410418
						],
						[
							-81.36859313535844,
							28.53194058011737
						],
						[
							-81.36852804063132,
							28.532064763899122
						],
						[
							-81.36840585963978,
							28.532290098026834
						],
						[
							-81.36836780392875,
							28.53239024562869
						],
						[
							-81.3683567872339,
							28.532455341255087
						],
						[
							-81.36837180860978,
							28.533275558019376
						],
						[
							-81.36837080766432,
							28.533911501001917
						],
						[
							-81.36836580023927,
							28.534849893177437
						],
						[
							-81.36836580023927,
							28.535549931740285
						],
						[
							-81.36836680208401,
							28.536247967513027
						],
						[
							-81.36836680208401,
							28.536680608858262
						],
						[
							-81.36836780302947,
							28.53707218895826
						],
						[
							-81.36837080766432,
							28.537201380165143
						],
						[
							-81.36837180771042,
							28.53728550634503
						],
						[
							-81.36807436774113,
							28.537281498966067
						],
						[
							-81.36731824655716,
							28.537281498966067
						],
						[
							-81.3662897207306,
							28.53729952587608
						],
						[
							-81.36611145891659,
							28.537304477543245
						],
						[
							-81.36587009887042,
							28.537309541625554
						],
						[
							-81.3646032194311,
							28.53734359175627
						],
						[
							-81.36421764770154,
							28.537369630726268
						],
						[
							-81.36385010288207,
							28.537405684546464
						],
						[
							-81.36286764482637,
							28.537575936998422
						],
						[
							-81.36229079089854,
							28.537690105930068
						],
						[
							-81.3619913463404,
							28.53777022473099
						],
						[
							-81.36096882888428,
							28.537996560703355
						],
						[
							-81.36060729333461,
							28.53806566280953
						],
						[
							-81.36010254524834,
							28.53816080298624
						],
						[
							-81.3596218324427,
							28.53822990599169
						],
						[
							-81.35940551132045,
							28.53824793380116
						],
						[
							-81.3593484259553,
							28.53825394217159
						],
						[
							-81.35850016833008,
							28.53831202848219
						],
						[
							-81.35775606568578,
							28.53833205728303
						],
						[
							-81.35599645580051,
							28.53835108603787
						],
						[
							-81.35548669759127,
							28.538351139997197
						],
						[
							-81.35548369475507,
							28.538230907836436
						],
						[
							-81.3554826938096,
							28.538115737060053
						],
						[
							-81.35548069101941,
							28.53803061083407
						],
						[
							-81.35547568359435,
							28.537874378812532
						],
						[
							-81.35547468174961,
							28.53771313936585
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Lake Davis-Greenwood",
				"RegionID": "274226"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.38335710456474,
					28.535170202006675,
					-81.37283342613614,
					28.56302958329205
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.37670499668039,
							28.56004233678358
						],
						[
							-81.37671426689192,
							28.558914439469994
						],
						[
							-81.37372268924854,
							28.560516900025263
						],
						[
							-81.37371373200115,
							28.55975182429183
						],
						[
							-81.37371273105569,
							28.559294144921964
						],
						[
							-81.37370972462219,
							28.558429864076224
						],
						[
							-81.37371473204723,
							28.557578601816168
						],
						[
							-81.37370972462219,
							28.556795439817453
						],
						[
							-81.37372675058683,
							28.553135959085317
						],
						[
							-81.37514785745891,
							28.55314001952432
						],
						[
							-81.37686353726158,
							28.553127132239574
						],
						[
							-81.37686239961926,
							28.553084937848567
						],
						[
							-81.37683736339326,
							28.552239683959023
						],
						[
							-81.37680731884286,
							28.550954778509073
						],
						[
							-81.37677627334718,
							28.549413492536267
						],
						[
							-81.3767382158375,
							28.548097539791712
						],
						[
							-81.37672332396399,
							28.54757763723
						],
						[
							-81.37589283244559,
							28.547572893306345
						],
						[
							-81.37587693962662,
							28.546642383688365
						],
						[
							-81.37590598233228,
							28.54643507557138
						],
						[
							-81.37593301954982,
							28.54630988994499
						],
						[
							-81.37591304830542,
							28.54570298876874
						],
						[
							-81.37589696932692,
							28.544857734879187
						],
						[
							-81.3758809461063,
							28.543604878568317
						],
						[
							-81.37587293404631,
							28.54295891893702
						],
						[
							-81.37587093035691,
							28.542789668329803
						],
						[
							-81.37586404964402,
							28.542215685937077
						],
						[
							-81.37528506072562,
							28.54222382929808
						],
						[
							-81.37285933200648,
							28.542260016217853
						],
						[
							-81.37286547347666,
							28.541361551242463
						],
						[
							-81.37287048090171,
							28.540439183186834
						],
						[
							-81.3728724845912,
							28.53996948617666
						],
						[
							-81.37285946420688,
							28.53983428570016
						],
						[
							-81.3728544576811,
							28.539193336191847
						],
						[
							-81.37285032079977,
							28.538444094821482
						],
						[
							-81.37328023000471,
							28.53844232135841
						],
						[
							-81.37309180854966,
							28.537872376022328
						],
						[
							-81.3730427352446,
							28.53776121172563
						],
						[
							-81.37300371815832,
							28.537698082916428
						],
						[
							-81.37294258674336,
							28.537641033524196
						],
						[
							-81.37283726444262,
							28.537571019505613
						],
						[
							-81.37283542802697,
							28.537339586175868
						],
						[
							-81.37283342613614,
							28.537237375529344
						],
						[
							-81.37357252045611,
							28.53718235230967
						],
						[
							-81.37438672795061,
							28.537079199173505
						],
						[
							-81.37475126903442,
							28.537006091487115
						],
						[
							-81.3752990820554,
							28.536859875214958
						],
						[
							-81.37578480138683,
							28.53671265619878
						],
						[
							-81.37598610113321,
							28.536648560618467
						],
						[
							-81.37623246590651,
							28.536570445507024
						],
						[
							-81.3773200798884,
							28.536225934123337
						],
						[
							-81.37764056138742,
							28.536117831118744
						],
						[
							-81.3778448567756,
							28.5360566844154
						],
						[
							-81.37797104424683,
							28.536014621325407
						],
						[
							-81.37811826236363,
							28.535964547074798
						],
						[
							-81.37829652867431,
							28.53590345702871
						],
						[
							-81.37843373194112,
							28.535856387413034
						],
						[
							-81.37867308739844,
							28.535778270502853
						],
						[
							-81.37887638723709,
							28.535717180456764
						],
						[
							-81.37934508420116,
							28.535590992086256
						],
						[
							-81.37955339146478,
							28.53553490946513
						],
						[
							-81.37979475420897,
							28.53542574615998
						],
						[
							-81.38056189028914,
							28.53523045838132
						],
						[
							-81.38126806672487,
							28.535199277987232
						],
						[
							-81.38126379404595,
							28.535339752987483
						],
						[
							-81.38135606358676,
							28.5353386171438
						],
						[
							-81.38197298141176,
							28.535330605983084
						],
						[
							-81.3824236496671,
							28.535325598558032
						],
						[
							-81.38254793417289,
							28.535324763087942
						],
						[
							-81.38261984126437,
							28.535170202006675
						],
						[
							-81.38286528872922,
							28.535177436153116
						],
						[
							-81.38315773746129,
							28.53520441941123
						],
						[
							-81.38335710456474,
							28.53523753064978
						],
						[
							-81.38332398433303,
							28.535314582762563
						],
						[
							-81.38325688321841,
							28.535481831479032
						],
						[
							-81.38289434492471,
							28.536360133654554
						],
						[
							-81.38286530491708,
							28.536432239496122
						],
						[
							-81.38284527251884,
							28.536574450187963
						],
						[
							-81.3827341100207,
							28.53695902187144
						],
						[
							-81.3825508380837,
							28.53778624705224
						],
						[
							-81.38249775829895,
							28.538359098097864
						],
						[
							-81.38249775829895,
							28.538407169558276
						],
						[
							-81.38240849699021,
							28.5402169840958
						],
						[
							-81.38258588826051,
							28.54020483695313
						],
						[
							-81.38283939455006,
							28.54020069737387
						],
						[
							-81.38284627436359,
							28.540591407829503
						],
						[
							-81.38286229758411,
							28.541320489097927
						],
						[
							-81.38287426216446,
							28.54201852487067
						],
						[
							-81.38287845570304,
							28.543875411721885
						],
						[
							-81.38258889289536,
							28.543875278622217
						],
						[
							-81.38240749244756,
							28.543875145522556
						],
						[
							-81.38241163112751,
							28.54403050879902
						],
						[
							-81.38243566550875,
							28.544798649421864
						],
						[
							-81.38245970078927,
							28.545582810567304
						],
						[
							-81.38246270722287,
							28.54574004443367
						],
						[
							-81.38247485796275,
							28.546101711284365
						],
						[
							-81.38230834399242,
							28.546101446883682
						],
						[
							-81.38230947803753,
							28.546133628223146
						],
						[
							-81.38231237295517,
							28.546175835204608
						],
						[
							-81.38247684096788,
							28.54614450372444
						],
						[
							-81.38253982048958,
							28.54746259775463
						],
						[
							-81.38254582975937,
							28.547558742474195
						],
						[
							-81.38265790686793,
							28.54940348847797
						],
						[
							-81.38275013234204,
							28.551255223113206
						],
						[
							-81.38275013234204,
							28.551620766041836
						],
						[
							-81.38267301727669,
							28.552270730354167
						],
						[
							-81.38264898199607,
							28.552421953152006
						],
						[
							-81.38259991048957,
							28.552665315089094
						],
						[
							-81.38251678705379,
							28.55302384780257
						],
						[
							-81.38250668856668,
							28.553067862421273
						],
						[
							-81.38249074718433,
							28.553127000039275
						],
						[
							-81.38247572490926,
							28.55320010862495
						],
						[
							-81.38240762554712,
							28.553462497518233
						],
						[
							-81.3823275058469,
							28.553758937441415
						],
						[
							-81.38207212626959,
							28.554694324982087
						],
						[
							-81.38196296566238,
							28.555002781646298
						],
						[
							-81.38182375870612,
							28.555485497242145
						],
						[
							-81.38168655543933,
							28.55592214596635
						],
						[
							-81.38141515264138,
							28.556865544667637
						],
						[
							-81.38127794937459,
							28.557308200862984
						],
						[
							-81.3811798027643,
							28.557576599025964
						],
						[
							-81.38105962546223,
							28.557996220886245
						],
						[
							-81.3808893721109,
							28.558488950432924
						],
						[
							-81.38076118364812,
							28.558797410694346
						],
						[
							-81.38059894145741,
							28.559148931393914
						],
						[
							-81.38039964540052,
							28.559513470679164
						],
						[
							-81.3802243855234,
							28.55980990970307
						],
						[
							-81.38011622676093,
							28.55996414073315
						],
						[
							-81.3796986058922,
							28.560585060541165
						],
						[
							-81.37959545455477,
							28.56073328140208
						],
						[
							-81.37952334781384,
							28.560845446644244
						],
						[
							-81.37936911858233,
							28.561085802147744
						],
						[
							-81.37824445073423,
							28.562722230096004
						],
						[
							-81.37802931401903,
							28.56302958329205
						],
						[
							-81.37817735141826,
							28.562068259304084
						],
						[
							-81.37819256345043,
							28.56164259579848
						],
						[
							-81.37802519332556,
							28.561229967066325
						],
						[
							-81.37747631101068,
							28.56077333990322
						],
						[
							-81.37704967713657,
							28.560316661478808
						],
						[
							-81.37670499668039,
							28.56004233678358
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Central Business District",
				"RegionID": "273192"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.14537201199994,
					25.790211860000056,
					-80.12424150299995,
					25.799189334000065
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.12993652599994,
							25.799189334000065
						],
						[
							-80.1294264679999,
							25.798770604000083
						],
						[
							-80.1280769569999,
							25.798379956000076
						],
						[
							-80.1259816619999,
							25.79788276700009
						],
						[
							-80.12424150299995,
							25.797350065000046
						],
						[
							-80.12534241999992,
							25.79085110200009
						],
						[
							-80.13191241099992,
							25.790744562000043
						],
						[
							-80.1412879639999,
							25.790460454000083
						],
						[
							-80.14537201199994,
							25.790211860000056
						],
						[
							-80.14537201199994,
							25.791738939000084
						],
						[
							-80.14487482399994,
							25.791312777000087
						],
						[
							-80.12993652599994,
							25.799189334000065
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Beach",
				"Name": "City Center",
				"RegionID": "273260"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.14866605799995,
					26.123993451000047,
					-80.14551725199993,
					26.12595637000004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.14564037199995,
							26.12595637000004
						],
						[
							-80.14551725199993,
							26.123993451000047
						],
						[
							-80.14860495699993,
							26.124026375000085
						],
						[
							-80.14866605799995,
							26.12591242000008
						],
						[
							-80.14814113799991,
							26.12592432300005
						],
						[
							-80.14564037199995,
							26.12595637000004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "City View Townhome",
				"RegionID": "273267"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.61877332199992,
					30.317700685000094,
					-81.59838249599994,
					30.33171932200008
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-81.6044238689999,
								30.327371952000078
							],
							[
								-81.60444005099993,
								30.327324909000087
							],
							[
								-81.60405890699991,
								30.327318011000045
							],
							[
								-81.60399290799995,
								30.32731901000005
							],
							[
								-81.60257715299993,
								30.32733906100009
							],
							[
								-81.60274303099993,
								30.327261991000057
							],
							[
								-81.60262590899993,
								30.32725201300008
							],
							[
								-81.60241290899995,
								30.327255013000073
							],
							[
								-81.60214490999994,
								30.32723701200007
							],
							[
								-81.60207788999992,
								30.327236092000078
							],
							[
								-81.6019118239999,
								30.327143114000076
							],
							[
								-81.60183990999991,
								30.32704201300004
							],
							[
								-81.60104783799994,
								30.326262058000054
							],
							[
								-81.6005630489999,
								30.324881891000075
							],
							[
								-81.59936799999991,
								30.32431400000007
							],
							[
								-81.5991445379999,
								30.324263344000087
							],
							[
								-81.5988905239999,
								30.324156822000077
							],
							[
								-81.59861192799991,
								30.32395197200009
							],
							[
								-81.59838249599994,
								30.323755316000078
							],
							[
								-81.59843232999992,
								30.323472924000043
							],
							[
								-81.59845624199994,
								30.32333742100008
							],
							[
								-81.59882497199993,
								30.32305063100006
							],
							[
								-81.5992528189999,
								30.322564129000057
							],
							[
								-81.5997506189999,
								30.32242338400005
							],
							[
								-81.6000084449999,
								30.322247790000066
							],
							[
								-81.60015464299994,
								30.32212442000008
							],
							[
								-81.60018515699994,
								30.32207185600004
							],
							[
								-81.60034429099994,
								30.321697320000055
							],
							[
								-81.60037585599991,
								30.321630748000075
							],
							[
								-81.60041276399994,
								30.321566983000086
							],
							[
								-81.60045476699992,
								30.321506452000055
							],
							[
								-81.6005015849999,
								30.32144956400009
							],
							[
								-81.60055290199995,
								30.32139669800006
							],
							[
								-81.60060837399993,
								30.321348211000043
							],
							[
								-81.60066762799994,
								30.32130442600004
							],
							[
								-81.60208914099991,
								30.32034149900005
							],
							[
								-81.6037671919999,
								30.31915487000009
							],
							[
								-81.60420807499992,
								30.318774209000082
							],
							[
								-81.60434133899992,
								30.318680164000053
							],
							[
								-81.60442533199995,
								30.318637375000037
							],
							[
								-81.60525033499994,
								30.31827290800004
							],
							[
								-81.60533618599993,
								30.318234207000046
							],
							[
								-81.60539329599995,
								30.318208231000085
							],
							[
								-81.60545264899991,
								30.31818789500005
							],
							[
								-81.6055136889999,
								30.31817338700006
							],
							[
								-81.60557584499992,
								30.31816484500007
							],
							[
								-81.60570038899994,
								30.318150337000077
							],
							[
								-81.60613811399992,
								30.31808433300006
							],
							[
								-81.60623204599995,
								30.31805060100004
							],
							[
								-81.60630773299994,
								30.31802713000008
							],
							[
								-81.60638519299994,
								30.31801041300008
							],
							[
								-81.6064638229999,
								30.31800057900006
							],
							[
								-81.6065430139999,
								30.317997705000042
							],
							[
								-81.60662214999991,
								30.318001814000073
							],
							[
								-81.6078873049999,
								30.31812356900008
							],
							[
								-81.6087404889999,
								30.317982692000044
							],
							[
								-81.60888699999992,
								30.317970678000055
							],
							[
								-81.60893362899992,
								30.317971887000056
							],
							[
								-81.60933532199994,
								30.31799274300005
							],
							[
								-81.60965792399992,
								30.317979816000044
							],
							[
								-81.6099683569999,
								30.317810489000067
							],
							[
								-81.61003600899994,
								30.317777189000083
							],
							[
								-81.61010621299994,
								30.317749673000037
							],
							[
								-81.61017847499994,
								30.31772813500004
							],
							[
								-81.61025228699992,
								30.31771272600008
							],
							[
								-81.6103271309999,
								30.317703554000047
							],
							[
								-81.6104024789999,
								30.317700685000094
							],
							[
								-81.61047780399991,
								30.317704137000078
							],
							[
								-81.61055257399994,
								30.31771388800007
							],
							[
								-81.61120586999994,
								30.317827114000067
							],
							[
								-81.61135858599994,
								30.317867913000043
							],
							[
								-81.6115042969999,
								30.31793628600008
							],
							[
								-81.61200293099995,
								30.318230407000044
							],
							[
								-81.61206847799991,
								30.318273016000035
							],
							[
								-81.61213007599991,
								30.318321158000057
							],
							[
								-81.61218725899994,
								30.31837446900005
							],
							[
								-81.61223959499995,
								30.318432545000068
							],
							[
								-81.61228668899992,
								30.31849494800008
							],
							[
								-81.61232818399992,
								30.318561205000037
							],
							[
								-81.61236376599993,
								30.31863081700004
							],
							[
								-81.61239316699994,
								30.318703257000042
							],
							[
								-81.61257141499993,
								30.31921473100004
							],
							[
								-81.61306858299992,
								30.320616361000077
							],
							[
								-81.61310665899993,
								30.320760834000055
							],
							[
								-81.61311246399993,
								30.32079837200007
							],
							[
								-81.6132814639999,
								30.322068372000047
							],
							[
								-81.6132893219999,
								30.322187000000046
							],
							[
								-81.61328679099996,
								30.32225442200007
							],
							[
								-81.61319326199992,
								30.32349784400009
							],
							[
								-81.6130987329999,
								30.324553266000066
							],
							[
								-81.61308888999991,
								30.324627854000088
							],
							[
								-81.61307284599991,
								30.324701359000077
							],
							[
								-81.61305071499993,
								30.32477326500009
							],
							[
								-81.61302265199994,
								30.324843070000046
							],
							[
								-81.61252465099994,
								30.325946069000057
							],
							[
								-81.61248383499992,
								30.32602566100007
							],
							[
								-81.61242607899993,
								30.326113424000084
							],
							[
								-81.6122384439999,
								30.326365179000053
							],
							[
								-81.61204964299992,
								30.32695981700005
							],
							[
								-81.61193891399995,
								30.327288064000072
							],
							[
								-81.61099599999994,
								30.327278000000035
							],
							[
								-81.61068690699994,
								30.32729601100004
							],
							[
								-81.61033090799992,
								30.327295010000057
							],
							[
								-81.60799376699993,
								30.32728790500005
							],
							[
								-81.60801304899991,
								30.32735111500006
							],
							[
								-81.60787490699994,
								30.32735101000009
							],
							[
								-81.60779290799991,
								30.32734801000004
							],
							[
								-81.60731090799993,
								30.32734801000004
							],
							[
								-81.60681390699995,
								30.32734801000004
							],
							[
								-81.60647390799994,
								30.327350010000092
							],
							[
								-81.60629390799994,
								30.327350010000092
							],
							[
								-81.60468790699991,
								30.327367010000046
							],
							[
								-81.6044238689999,
								30.327371952000078
							]
						]
					],
					[
						[
							[
								-81.6140283389999,
								30.325953164000055
							],
							[
								-81.61417041399994,
								30.325886914000076
							],
							[
								-81.61432183399995,
								30.32584634000006
							],
							[
								-81.6144779999999,
								30.32583267800004
							],
							[
								-81.61463416499993,
								30.32584634000006
							],
							[
								-81.61468876299996,
								30.325857723000073
							],
							[
								-81.61492790199992,
								30.32591537300004
							],
							[
								-81.61520893599993,
								30.325106836000092
							],
							[
								-81.6151839879999,
								30.324922944000036
							],
							[
								-81.61504411499993,
								30.324416352000075
							],
							[
								-81.61503688099992,
								30.324388415000048
							],
							[
								-81.61490017099995,
								30.323823171000072
							],
							[
								-81.61477757699993,
								30.323548120000055
							],
							[
								-81.61475391399995,
								30.32348958600005
							],
							[
								-81.61471580199992,
								30.32335153100007
							],
							[
								-81.61465257099991,
								30.323021849000042
							],
							[
								-81.61463767799995,
								30.322859000000047
							],
							[
								-81.61464699299997,
								30.322729896000055
							],
							[
								-81.61469399299996,
								30.322405895000088
							],
							[
								-81.6146983399999,
								30.322378834000066
							],
							[
								-81.61473891299994,
								30.32222741300006
							],
							[
								-81.6148051639999,
								30.322085339000065
							],
							[
								-81.61489507899995,
								30.321956927000087
							],
							[
								-81.61494569799994,
								30.321901477000036
							],
							[
								-81.61521069799994,
								30.32163447700009
							],
							[
								-81.61526062999991,
								30.321587852000047
							],
							[
								-81.6153139569999,
								30.321545152000056
							],
							[
								-81.61537037199992,
								30.321506623000065
							],
							[
								-81.61542954799995,
								30.32147248800004
							],
							[
								-81.61549114499991,
								30.32144294300008
							],
							[
								-81.6157401449999,
								30.321334943000068
							],
							[
								-81.61580879699994,
								30.32130844800008
							],
							[
								-81.61587938699995,
								30.32128765400006
							],
							[
								-81.6159514389999,
								30.321272701000055
							],
							[
								-81.61602447299994,
								30.321263689000034
							],
							[
								-81.61609799999991,
								30.32126067800004
							],
							[
								-81.61631599999993,
								30.32126067800004
							],
							[
								-81.61693674999992,
								30.32126067800004
							],
							[
								-81.61697430599993,
								30.32124983300008
							],
							[
								-81.61732166599995,
								30.321125378000094
							],
							[
								-81.6173862519999,
								30.321104948000084
							],
							[
								-81.61745219299992,
								30.32108943700007
							],
							[
								-81.61751911499994,
								30.321078933000084
							],
							[
								-81.61758663699993,
								30.321073496000057
							],
							[
								-81.61765437699995,
								30.32107315800005
							],
							[
								-81.61772194999992,
								30.32107791900006
							],
							[
								-81.61787428199995,
								30.321097073000086
							],
							[
								-81.61797077599994,
								30.321106907000058
							],
							[
								-81.61803016599993,
								30.321113341000057
							],
							[
								-81.61818158599993,
								30.321153914000032
							],
							[
								-81.61832366099992,
								30.321220164000067
							],
							[
								-81.6184520729999,
								30.321310080000046
							],
							[
								-81.61856292099992,
								30.32142092700008
							],
							[
								-81.61865283599992,
								30.321549339000057
							],
							[
								-81.61871908599994,
								30.32169141400004
							],
							[
								-81.61875965899992,
								30.321842835000044
							],
							[
								-81.61877332199992,
								30.321999000000066
							],
							[
								-81.61875965899992,
								30.322155166000076
							],
							[
								-81.61874603199993,
								30.32221067100005
							],
							[
								-81.61872176999992,
								30.322307238000064
							],
							[
								-81.61775493399995,
								30.32630118000009
							],
							[
								-81.61774667399993,
								30.32633269900009
							],
							[
								-81.61767967299994,
								30.326570699000058
							],
							[
								-81.6176393419999,
								30.32668419700008
							],
							[
								-81.6175073419999,
								30.326989197000046
							],
							[
								-81.61748298499992,
								30.327040905000043
							],
							[
								-81.61724075399991,
								30.327515392000066
							],
							[
								-81.6171975229999,
								30.327600878000055
							],
							[
								-81.61713893799993,
								30.327700308000093
							],
							[
								-81.6171029379999,
								30.327753308000073
							],
							[
								-81.61705642899994,
								30.327812653000077
							],
							[
								-81.6169442289999,
								30.328012450000077
							],
							[
								-81.6168597169999,
								30.32815846400007
							],
							[
								-81.61681286399994,
								30.32872860800006
							],
							[
								-81.61694274599995,
								30.32917655600005
							],
							[
								-81.61696049999995,
								30.32924885100004
							],
							[
								-81.61697221399993,
								30.32932236700009
							],
							[
								-81.61697780799994,
								30.329396599000066
							],
							[
								-81.61697724299995,
								30.329471040000048
							],
							[
								-81.6169705229999,
								30.32954518000008
							],
							[
								-81.61695769499994,
								30.329618509000056
							],
							[
								-81.61692369499993,
								30.32977450900006
							],
							[
								-81.61690413499991,
								30.32984883200004
							],
							[
								-81.61687830199992,
								30.32992121400008
							],
							[
								-81.61684638199996,
								30.32999112600004
							],
							[
								-81.6168086109999,
								30.33005805700009
							],
							[
								-81.61676526199994,
								30.33012151900005
							],
							[
								-81.6167166539999,
								30.33018104800004
							],
							[
								-81.61631684799994,
								30.330630061000083
							],
							[
								-81.61615376499994,
								30.33090001800008
							],
							[
								-81.61613418199994,
								30.330927403000093
							],
							[
								-81.61608183599992,
								30.331039661000087
							],
							[
								-81.6159890909999,
								30.331171276000077
							],
							[
								-81.61594943499995,
								30.331235892000052
							],
							[
								-81.61590458099994,
								30.33129701500008
							],
							[
								-81.61585483499995,
								30.331354227000073
							],
							[
								-81.61580053599994,
								30.33140713800009
							],
							[
								-81.61574205599993,
								30.331455387000066
							],
							[
								-81.61567979299991,
								30.331498644000078
							],
							[
								-81.61554979299991,
								30.331580644000045
							],
							[
								-81.61551966099995,
								30.33159883600007
							],
							[
								-81.61537758599991,
								30.331665087000093
							],
							[
								-81.6152261659999,
								30.331705660000072
							],
							[
								-81.61506999999995,
								30.33171932200008
							],
							[
								-81.61491383499992,
								30.331705660000072
							],
							[
								-81.61476241399993,
								30.331665087000093
							],
							[
								-81.61474403999995,
								30.331658171000072
							],
							[
								-81.61465403999995,
								30.331623170000057
							],
							[
								-81.6145849369999,
								30.331592902000065
							],
							[
								-81.61451861499995,
								30.331556949000063
							],
							[
								-81.61445553999994,
								30.331515563000043
							],
							[
								-81.61439615499997,
								30.331469036000048
							],
							[
								-81.61434087899994,
								30.331417695000084
							],
							[
								-81.61429010099994,
								30.331361903000072
							],
							[
								-81.6142003189999,
								30.33125416900009
							],
							[
								-81.61407232699992,
								30.331143018000038
							],
							[
								-81.61401700699993,
								30.331090709000083
							],
							[
								-81.61396630999991,
								30.33103390800005
							],
							[
								-81.61392059899993,
								30.33097302300007
							],
							[
								-81.61388020099992,
								30.330908489000077
							],
							[
								-81.61384540699993,
								30.330840770000066
							],
							[
								-81.6138164649999,
								30.330770351000066
							],
							[
								-81.6137935829999,
								30.330697735000058
							],
							[
								-81.61377692499991,
								30.330623445000075
							],
							[
								-81.61375256799994,
								30.330488238000047
							],
							[
								-81.61368290899992,
								30.33037688600007
							],
							[
								-81.61365937199992,
								30.330340739000064
							],
							[
								-81.6136209579999,
								30.330275974000074
							],
							[
								-81.61358809899991,
								30.330208221000078
							],
							[
								-81.6135610259999,
								30.330137956000044
							],
							[
								-81.61353992799991,
								30.330065672000046
							],
							[
								-81.6135249539999,
								30.32999187600007
							],
							[
								-81.61351620799991,
								30.329917085000094
							],
							[
								-81.6135137519999,
								30.329841825000074
							],
							[
								-81.61351482599991,
								30.32977865000004
							],
							[
								-81.6135283399999,
								30.32963883400004
							],
							[
								-81.61355546699991,
								30.32953759600008
							],
							[
								-81.61354867799992,
								30.329460000000044
							],
							[
								-81.61355263199994,
								30.329375759000076
							],
							[
								-81.61357950899992,
								30.32909010200007
							],
							[
								-81.61344203399995,
								30.32769840700007
							],
							[
								-81.61343767799991,
								30.32761000000005
							],
							[
								-81.61344484199992,
								30.327496710000048
							],
							[
								-81.61348484199993,
								30.32718171000005
							],
							[
								-81.61349171499995,
								30.327123437000072
							],
							[
								-81.61350433199993,
								30.327066132000084
							],
							[
								-81.61352256999993,
								30.327010362000067
							],
							[
								-81.61354624699993,
								30.326956674000083
							],
							[
								-81.61353701199994,
								30.326882218000033
							],
							[
								-81.61353407899992,
								30.32680724900007
							],
							[
								-81.61353746799995,
								30.32673229900007
							],
							[
								-81.61354715499994,
								30.32665790000004
							],
							[
								-81.61356307099993,
								30.32658458100008
							],
							[
								-81.61358510399992,
								30.32651286300006
							],
							[
								-81.61361309699993,
								30.326443254000086
							],
							[
								-81.61364685199993,
								30.326376249000077
							],
							[
								-81.61369550799994,
								30.32628879400005
							],
							[
								-81.6137890789999,
								30.326153927000068
							],
							[
								-81.61389992699992,
								30.326043079000048
							],
							[
								-81.6140283389999,
								30.325953164000055
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Clifton",
				"RegionID": "273283"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.4933909085598,
					27.937401723732897,
					-82.47662394864554,
					27.944957818429856
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.47712718137419,
							27.941367783344823
						],
						[
							-82.47725778991249,
							27.939982643958086
						],
						[
							-82.47662394864554,
							27.939986352762098
						],
						[
							-82.4775658113048,
							27.938804645414216
						],
						[
							-82.47875316549575,
							27.937401723732897
						],
						[
							-82.4933909085598,
							27.937599944200763
						],
						[
							-82.4933182406419,
							27.944957818429856
						],
						[
							-82.48511818100997,
							27.944936308445662
						],
						[
							-82.47679222888435,
							27.944922116244648
						],
						[
							-82.47712718137419,
							27.941367783344823
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Courier City",
				"RegionID": "273378"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.16999053899991,
					26.12169605200006,
					-80.15050345899994,
					26.12955000000005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.15070999999995,
							26.12955000000005
						],
						[
							-80.15069468599995,
							26.12906250800006
						],
						[
							-80.1506827469999,
							26.128682449000053
						],
						[
							-80.15066434999994,
							26.128096823000078
						],
						[
							-80.15064999999993,
							26.127640000000042
						],
						[
							-80.15063604099993,
							26.127190512000084
						],
						[
							-80.1506196979999,
							26.126664264000055
						],
						[
							-80.15060692999992,
							26.12625314400009
						],
						[
							-80.15059999999994,
							26.125860000000046
						],
						[
							-80.15060763299994,
							26.125433721000036
						],
						[
							-80.15059611399994,
							26.12511118100008
						],
						[
							-80.15058999999991,
							26.12494000000004
						],
						[
							-80.1505836369999,
							26.124672735000047
						],
						[
							-80.15056874899994,
							26.12420496900006
						],
						[
							-80.15055999999993,
							26.123960000000068
						],
						[
							-80.15055133499993,
							26.123561411000082
						],
						[
							-80.15054306899992,
							26.123181156000047
						],
						[
							-80.15053999999992,
							26.123040000000064
						],
						[
							-80.1505272739999,
							26.122683666000057
						],
						[
							-80.15051478099991,
							26.122422590000046
						],
						[
							-80.15050345899994,
							26.12218281400004
						],
						[
							-80.15084114399991,
							26.122184777000086
						],
						[
							-80.1517104319999,
							26.122167751000063
						],
						[
							-80.15185664899992,
							26.12216174200006
						],
						[
							-80.15203591599993,
							26.12215473300006
						],
						[
							-80.15319062599991,
							26.122124687000053
						],
						[
							-80.1534810579999,
							26.122117677000066
						],
						[
							-80.15488514099991,
							26.12207962100007
						],
						[
							-80.15621210799992,
							26.12204456900008
						],
						[
							-80.15666177599991,
							26.122037558000045
						],
						[
							-80.15742490699995,
							26.122015527000087
						],
						[
							-80.15757813399995,
							26.12200851500006
						],
						[
							-80.15861266899992,
							26.12198347800006
						],
						[
							-80.15879293699993,
							26.121977469000058
						],
						[
							-80.15944690599991,
							26.12196144500007
						],
						[
							-80.16047743399992,
							26.121934405000047
						],
						[
							-80.16146089299991,
							26.12191037100007
						],
						[
							-80.1616211299999,
							26.121917381000063
						],
						[
							-80.16221601299992,
							26.121921386000054
						],
						[
							-80.1624453519999,
							26.12191938400008
						],
						[
							-80.16268470699993,
							26.12191537700005
						],
						[
							-80.16315739599992,
							26.12191246100008
						],
						[
							-80.16331464199993,
							26.121902359000046
						],
						[
							-80.1639876399999,
							26.12188533300008
						],
						[
							-80.1644533299999,
							26.12184727600004
						],
						[
							-80.16462859099994,
							26.12183325600006
						],
						[
							-80.16512532799993,
							26.121784182000056
						],
						[
							-80.1657332289999,
							26.121752136000055
						],
						[
							-80.16635915799992,
							26.121718085000058
						],
						[
							-80.1667968079999,
							26.12169605200006
						],
						[
							-80.1672254419999,
							26.12169605200006
						],
						[
							-80.16739268899994,
							26.12169805500008
						],
						[
							-80.1679875719999,
							26.12171508000006
						],
						[
							-80.16855741699993,
							26.121708070000068
						],
						[
							-80.1687186559999,
							26.121708070000068
						],
						[
							-80.16894499299993,
							26.121712075000065
						],
						[
							-80.1689513309999,
							26.121712138000078
						],
						[
							-80.16934959199995,
							26.121716081000045
						],
						[
							-80.16981729499992,
							26.121708074000082
						],
						[
							-80.16989493199992,
							26.12501889400005
						],
						[
							-80.16999053899991,
							26.129096032000064
						],
						[
							-80.16956491199994,
							26.129102036000063
						],
						[
							-80.1693576049999,
							26.129118059000064
						],
						[
							-80.16915330199993,
							26.129110048000086
						],
						[
							-80.16851235099995,
							26.129136087000063
						],
						[
							-80.1676009979999,
							26.12915110900008
						],
						[
							-80.1671413169999,
							26.12917814800005
						],
						[
							-80.16676175499992,
							26.12917814800005
						],
						[
							-80.16613482499992,
							26.12920318500005
						],
						[
							-80.16597759199993,
							26.12920719200008
						],
						[
							-80.16517940799993,
							26.12921220000004
						],
						[
							-80.16511230899994,
							26.12922020900004
						],
						[
							-80.16435418299994,
							26.129219209000045
						],
						[
							-80.16412284099994,
							26.129217206000078
						],
						[
							-80.16369620699993,
							26.129235233000088
						],
						[
							-80.16353496799991,
							26.12923723700004
						],
						[
							-80.16286497499993,
							26.129276295000068
						],
						[
							-80.1626887139999,
							26.12927829700004
						],
						[
							-80.16203274099992,
							26.129293319000055
						],
						[
							-80.16185748099991,
							26.129295322000075
						],
						[
							-80.16126960899993,
							26.129307340000082
						],
						[
							-80.16108333299991,
							26.12931234800004
						],
						[
							-80.16101122499992,
							26.129314350000072
						],
						[
							-80.16054453399994,
							26.12932436500006
						],
						[
							-80.16025510499992,
							26.129332377000082
						],
						[
							-80.16017097999992,
							26.129334380000046
						],
						[
							-80.15982146199991,
							26.129340389000053
						],
						[
							-80.1594008379999,
							26.129351405000083
						],
						[
							-80.15908136399992,
							26.129357414000083
						],
						[
							-80.1585916379999,
							26.129368430000056
						],
						[
							-80.15776040499992,
							26.129386457000066
						],
						[
							-80.15738585299994,
							26.129392412000072
						],
						[
							-80.15646949099994,
							26.129405486000053
						],
						[
							-80.15605888199991,
							26.129423513000063
						],
						[
							-80.1555010539999,
							26.12943553000008
						],
						[
							-80.1546858449999,
							26.129448549000074
						],
						[
							-80.15454861599994,
							26.12945250200005
						],
						[
							-80.15383157899993,
							26.12946757700007
						],
						[
							-80.1536007229999,
							26.129472469000063
						],
						[
							-80.15359522799992,
							26.12947258500009
						],
						[
							-80.15300021699994,
							26.12948974200009
						],
						[
							-80.15274380999995,
							26.129496655000082
						],
						[
							-80.15218797199992,
							26.12950907600009
						],
						[
							-80.15167999999994,
							26.12952000000007
						],
						[
							-80.15116309399991,
							26.129535987000057
						],
						[
							-80.15070999999995,
							26.12955000000005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Dorsey-Riverbend",
				"RegionID": "273476"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.51402896999991,
					27.341336949000038,
					-82.50574948399992,
					27.34316000000007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.5135952519999,
							27.34315317800008
						],
						[
							-82.51316133499995,
							27.343150000000037
						],
						[
							-82.51282682899995,
							27.343150000000037
						],
						[
							-82.5123295919999,
							27.343150000000037
						],
						[
							-82.51192276099995,
							27.343150000000037
						],
						[
							-82.51151592999992,
							27.343150000000037
						],
						[
							-82.51097348799993,
							27.343150000000037
						],
						[
							-82.51061186099993,
							27.343150000000037
						],
						[
							-82.51018694899994,
							27.343150000000037
						],
						[
							-82.50988999999993,
							27.343150000000037
						],
						[
							-82.50971683299993,
							27.343150000000037
						],
						[
							-82.50944561199992,
							27.343150000000037
						],
						[
							-82.50910206599991,
							27.343150000000037
						],
						[
							-82.50884999999994,
							27.343150000000037
						],
						[
							-82.50871331699994,
							27.343150000000037
						],
						[
							-82.50849633999991,
							27.343150000000037
						],
						[
							-82.50809854999994,
							27.343150000000037
						],
						[
							-82.50779999999992,
							27.343150000000037
						],
						[
							-82.50767363699993,
							27.343150000000037
						],
						[
							-82.50746570199993,
							27.343150000000037
						],
						[
							-82.50697750499995,
							27.343150000000037
						],
						[
							-82.50675999999993,
							27.343150000000037
						],
						[
							-82.50663395799995,
							27.343150000000037
						],
						[
							-82.50646218499992,
							27.343150000000037
						],
						[
							-82.50589262199992,
							27.343150000000037
						],
						[
							-82.50574948399992,
							27.343150000000037
						],
						[
							-82.5057494859999,
							27.34137605600006
						],
						[
							-82.51402896999991,
							27.341336949000038
						],
						[
							-82.51402315199994,
							27.343154775000073
						],
						[
							-82.51394999999991,
							27.34316000000007
						],
						[
							-82.5138302229999,
							27.343157697000038
						],
						[
							-82.5135952519999,
							27.34315317800008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Jordan's Crossing",
				"RegionID": "343987"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.38270999999992,
					27.44741600000009,
					-80.33107199999995,
					27.49986400000006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.34569199999993,
							27.49982600000004
						],
						[
							-80.3445109999999,
							27.49597300000005
						],
						[
							-80.34413799999993,
							27.494834000000083
						],
						[
							-80.34353899999991,
							27.49483900000007
						],
						[
							-80.3432729999999,
							27.49405900000005
						],
						[
							-80.34266599999997,
							27.493935000000082
						],
						[
							-80.34237499999995,
							27.493356000000063
						],
						[
							-80.34367199999991,
							27.493415000000084
						],
						[
							-80.34289399999994,
							27.491055000000074
						],
						[
							-80.34260299999994,
							27.490172000000086
						],
						[
							-80.34217499999994,
							27.488873000000073
						],
						[
							-80.3421209999999,
							27.48870900000009
						],
						[
							-80.3412669999999,
							27.486117000000036
						],
						[
							-80.3410189999999,
							27.48509000000007
						],
						[
							-80.3407719999999,
							27.484315000000038
						],
						[
							-80.3401659999999,
							27.482450000000085
						],
						[
							-80.33994199999995,
							27.481761000000063
						],
						[
							-80.33975399999991,
							27.48118100000005
						],
						[
							-80.33953799999995,
							27.480518000000075
						],
						[
							-80.33947199999994,
							27.480315000000076
						],
						[
							-80.33872099999991,
							27.47881300000006
						],
						[
							-80.33847199999991,
							27.478315000000066
						],
						[
							-80.33547199999992,
							27.478315000000066
						],
						[
							-80.33541999999994,
							27.47818200000006
						],
						[
							-80.33534199999991,
							27.47798300000005
						],
						[
							-80.33476699999994,
							27.47797200000008
						],
						[
							-80.3345589999999,
							27.477474000000086
						],
						[
							-80.33439099999993,
							27.477096000000074
						],
						[
							-80.33427899999992,
							27.47681300000005
						],
						[
							-80.33401399999991,
							27.476204000000052
						],
						[
							-80.33385399999993,
							27.47581000000008
						],
						[
							-80.3337719999999,
							27.47561500000006
						],
						[
							-80.33371399999993,
							27.475498000000073
						],
						[
							-80.33337199999994,
							27.474815000000035
						],
						[
							-80.3339719999999,
							27.47471500000006
						],
						[
							-80.33431299999995,
							27.47545400000007
						],
						[
							-80.33680599999991,
							27.475452000000075
						],
						[
							-80.3372379999999,
							27.475452000000075
						],
						[
							-80.3372379999999,
							27.473670000000084
						],
						[
							-80.33806499999992,
							27.473669000000086
						],
						[
							-80.33963199999994,
							27.473673000000076
						],
						[
							-80.33846399999993,
							27.472874000000047
						],
						[
							-80.33808699999992,
							27.472874000000047
						],
						[
							-80.33730199999991,
							27.472875000000045
						],
						[
							-80.33530799999996,
							27.472876000000042
						],
						[
							-80.33527199999992,
							27.472815000000082
						],
						[
							-80.3352099999999,
							27.47271500000005
						],
						[
							-80.33525199999991,
							27.472500000000082
						],
						[
							-80.33527399999991,
							27.472161000000085
						],
						[
							-80.33528299999995,
							27.471907000000048
						],
						[
							-80.3353479999999,
							27.471329000000082
						],
						[
							-80.33537199999995,
							27.471070000000054
						],
						[
							-80.33549099999993,
							27.47107200000005
						],
						[
							-80.33562599999993,
							27.47107500000004
						],
						[
							-80.33717799999994,
							27.471108000000076
						],
						[
							-80.33760499999995,
							27.471114000000057
						],
						[
							-80.33712199999991,
							27.470082000000048
						],
						[
							-80.33673099999993,
							27.469247000000053
						],
						[
							-80.3359769999999,
							27.468455000000063
						],
						[
							-80.33570999999995,
							27.46817400000009
						],
						[
							-80.33471899999995,
							27.46817200000004
						],
						[
							-80.3346269999999,
							27.468410000000063
						],
						[
							-80.33464399999991,
							27.468450000000075
						],
						[
							-80.33460899999994,
							27.468450000000075
						],
						[
							-80.33432099999995,
							27.467817000000082
						],
						[
							-80.33352499999997,
							27.466459000000043
						],
						[
							-80.3329809999999,
							27.466459000000043
						],
						[
							-80.33296499999994,
							27.467020000000048
						],
						[
							-80.33213399999994,
							27.467253000000085
						],
						[
							-80.33197499999994,
							27.467298000000085
						],
						[
							-80.3323719999999,
							27.467915000000062
						],
						[
							-80.33314699999994,
							27.469287000000065
						],
						[
							-80.33320399999991,
							27.46938700000004
						],
						[
							-80.33225599999992,
							27.469441000000074
						],
						[
							-80.33179799999994,
							27.469509000000073
						],
						[
							-80.33204499999994,
							27.47007700000006
						],
						[
							-80.3321249999999,
							27.470215000000053
						],
						[
							-80.33197199999995,
							27.470215000000053
						],
						[
							-80.33168499999994,
							27.469569000000035
						],
						[
							-80.33117199999992,
							27.468415000000054
						],
						[
							-80.33167199999991,
							27.468215000000043
						],
						[
							-80.33107199999995,
							27.466616000000045
						],
						[
							-80.3314719999999,
							27.466516000000073
						],
						[
							-80.3312719999999,
							27.466116000000056
						],
						[
							-80.33337199999994,
							27.465616000000068
						],
						[
							-80.33452599999993,
							27.465647000000047
						],
						[
							-80.33476399999995,
							27.465649000000045
						],
						[
							-80.33587799999992,
							27.46564600000005
						],
						[
							-80.33688299999994,
							27.46566800000005
						],
						[
							-80.33779499999993,
							27.465666000000056
						],
						[
							-80.33858099999992,
							27.46568300000007
						],
						[
							-80.3388379999999,
							27.46568300000007
						],
						[
							-80.33884399999994,
							27.467875000000053
						],
						[
							-80.33884599999993,
							27.468334000000084
						],
						[
							-80.33947699999993,
							27.46810800000009
						],
						[
							-80.33988599999992,
							27.46811000000008
						],
						[
							-80.33988399999993,
							27.46838500000007
						],
						[
							-80.34137099999992,
							27.46844100000004
						],
						[
							-80.34137199999992,
							27.46811500000007
						],
						[
							-80.3408159999999,
							27.46811500000007
						],
						[
							-80.3408159999999,
							27.467612000000088
						],
						[
							-80.34137199999992,
							27.467613000000085
						],
						[
							-80.34137199999992,
							27.467553000000066
						],
						[
							-80.34184199999993,
							27.467553000000066
						],
						[
							-80.34184199999993,
							27.46704200000005
						],
						[
							-80.34184099999993,
							27.466877000000068
						],
						[
							-80.34137199999992,
							27.466878000000065
						],
						[
							-80.34137199999992,
							27.466465000000085
						],
						[
							-80.34184199999993,
							27.466465000000085
						],
						[
							-80.34184199999993,
							27.465663000000063
						],
						[
							-80.3423719999999,
							27.465716000000043
						],
						[
							-80.3434719999999,
							27.465716000000043
						],
						[
							-80.34438599999993,
							27.465715000000046
						],
						[
							-80.34438599999993,
							27.466105000000084
						],
						[
							-80.34485699999993,
							27.466104000000087
						],
						[
							-80.34485699999993,
							27.465714000000048
						],
						[
							-80.34514699999994,
							27.46571300000005
						],
						[
							-80.34514699999994,
							27.466120000000046
						],
						[
							-80.3455679999999,
							27.466120000000046
						],
						[
							-80.34557199999995,
							27.466516000000073
						],
						[
							-80.34513399999992,
							27.46651200000008
						],
						[
							-80.34513399999992,
							27.466690000000085
						],
						[
							-80.34557299999996,
							27.466690000000085
						],
						[
							-80.34557399999994,
							27.466975000000048
						],
						[
							-80.34512699999993,
							27.466975000000048
						],
						[
							-80.34512699999993,
							27.467841000000078
						],
						[
							-80.34557799999993,
							27.467841000000078
						],
						[
							-80.34557899999993,
							27.467974000000083
						],
						[
							-80.34557899999993,
							27.46810400000004
						],
						[
							-80.34558099999992,
							27.46841100000006
						],
						[
							-80.34957199999991,
							27.468415000000054
						],
						[
							-80.34957199999991,
							27.468125000000043
						],
						[
							-80.34957199999991,
							27.46751500000005
						],
						[
							-80.35009899999994,
							27.46751500000005
						],
						[
							-80.35009899999994,
							27.467160000000035
						],
						[
							-80.34957199999991,
							27.467095000000086
						],
						[
							-80.34957199999991,
							27.466515000000076
						],
						[
							-80.35157199999992,
							27.466515000000076
						],
						[
							-80.35157199999992,
							27.466116000000056
						],
						[
							-80.35157199999992,
							27.465716000000043
						],
						[
							-80.3530659999999,
							27.465716000000043
						],
						[
							-80.35305999999991,
							27.466102000000035
						],
						[
							-80.35343799999993,
							27.466102000000035
						],
						[
							-80.35344399999991,
							27.46571300000005
						],
						[
							-80.35361199999994,
							27.465716000000043
						],
						[
							-80.3536719999999,
							27.465716000000043
						],
						[
							-80.35577299999994,
							27.465716000000043
						],
						[
							-80.3579729999999,
							27.465716000000043
						],
						[
							-80.35827299999994,
							27.465716000000043
						],
						[
							-80.35827299999994,
							27.464716000000067
						],
						[
							-80.35827299999994,
							27.463816000000065
						],
						[
							-80.35827299999994,
							27.462916000000064
						],
						[
							-80.35827299999994,
							27.462016000000066
						],
						[
							-80.35827299999994,
							27.46111600000006
						],
						[
							-80.35827299999994,
							27.46021600000006
						],
						[
							-80.3582639999999,
							27.459323000000044
						],
						[
							-80.3582669999999,
							27.45842500000009
						],
						[
							-80.35817299999991,
							27.45751600000006
						],
						[
							-80.35816199999994,
							27.45651000000004
						],
						[
							-80.35810199999992,
							27.45561600000008
						],
						[
							-80.35804199999991,
							27.45481600000005
						],
						[
							-80.35789799999992,
							27.452916000000073
						],
						[
							-80.35782599999993,
							27.451970000000074
						],
						[
							-80.35787299999993,
							27.45111600000007
						],
						[
							-80.35787299999993,
							27.450016000000065
						],
						[
							-80.3579729999999,
							27.449216000000035
						],
						[
							-80.35907299999991,
							27.449216000000035
						],
						[
							-80.35877299999993,
							27.448716000000047
						],
						[
							-80.35872299999994,
							27.448630000000037
						],
						[
							-80.3595469999999,
							27.44859400000007
						],
						[
							-80.35951599999993,
							27.447639000000038
						],
						[
							-80.3585569999999,
							27.447632000000056
						],
						[
							-80.35813699999994,
							27.447625000000077
						],
						[
							-80.35807299999993,
							27.447516000000064
						],
						[
							-80.35855599999992,
							27.447516000000064
						],
						[
							-80.35951199999994,
							27.447516000000064
						],
						[
							-80.35997299999991,
							27.447516000000064
						],
						[
							-80.36037299999992,
							27.447516000000064
						],
						[
							-80.36181699999992,
							27.447516000000064
						],
						[
							-80.36187299999995,
							27.447516000000064
						],
						[
							-80.36417299999994,
							27.44741600000009
						],
						[
							-80.36467299999993,
							27.44771600000007
						],
						[
							-80.36627299999992,
							27.448716000000047
						],
						[
							-80.36627299999992,
							27.452824000000078
						],
						[
							-80.36627299999992,
							27.454716000000076
						],
						[
							-80.3663729999999,
							27.45791600000007
						],
						[
							-80.36708699999993,
							27.458489000000043
						],
						[
							-80.36699499999993,
							27.458488000000045
						],
						[
							-80.36685099999994,
							27.45846700000004
						],
						[
							-80.3665529999999,
							27.458240000000046
						],
						[
							-80.36679499999991,
							27.458594000000065
						],
						[
							-80.3670919999999,
							27.458691000000044
						],
						[
							-80.36717699999991,
							27.458692000000042
						],
						[
							-80.36790999999994,
							27.45951400000007
						],
						[
							-80.3688259999999,
							27.460395000000062
						],
						[
							-80.37068699999992,
							27.462139000000036
						],
						[
							-80.37216499999994,
							27.463523000000066
						],
						[
							-80.37217299999992,
							27.463516000000084
						],
						[
							-80.37287299999991,
							27.46421600000008
						],
						[
							-80.37386499999991,
							27.465208000000075
						],
						[
							-80.37457299999994,
							27.46591600000005
						],
						[
							-80.3749729999999,
							27.466315000000066
						],
						[
							-80.37573999999995,
							27.466977000000043
						],
						[
							-80.37637299999994,
							27.467715000000055
						],
						[
							-80.37667299999993,
							27.468015000000037
						],
						[
							-80.37747299999995,
							27.468615000000057
						],
						[
							-80.3783729999999,
							27.46901500000007
						],
						[
							-80.37888399999991,
							27.46916500000009
						],
						[
							-80.37934699999994,
							27.46923000000004
						],
						[
							-80.3801509999999,
							27.469284000000073
						],
						[
							-80.38247299999995,
							27.46951500000006
						],
						[
							-80.38247299999995,
							27.469715000000065
						],
						[
							-80.38247299999995,
							27.470015000000046
						],
						[
							-80.3824479999999,
							27.47037000000006
						],
						[
							-80.38237299999992,
							27.47141500000004
						],
						[
							-80.38238099999995,
							27.477016000000052
						],
						[
							-80.38248699999991,
							27.477016000000052
						],
						[
							-80.38254399999994,
							27.47702000000004
						],
						[
							-80.38261799999992,
							27.47702200000009
						],
						[
							-80.38270999999992,
							27.48420900000008
						],
						[
							-80.38246099999992,
							27.484206000000086
						],
						[
							-80.37837799999994,
							27.484266000000048
						],
						[
							-80.37486499999994,
							27.484078000000068
						],
						[
							-80.37349999999992,
							27.484075000000075
						],
						[
							-80.37338799999992,
							27.484049000000084
						],
						[
							-80.36928399999994,
							27.48392300000006
						],
						[
							-80.36580499999991,
							27.483935000000088
						],
						[
							-80.36528599999991,
							27.484026000000085
						],
						[
							-80.36511799999995,
							27.484049000000084
						],
						[
							-80.36484299999995,
							27.484110000000044
						],
						[
							-80.36469099999994,
							27.48411400000009
						],
						[
							-80.3645689999999,
							27.48414400000007
						],
						[
							-80.36429399999992,
							27.484125000000063
						],
						[
							-80.36417199999994,
							27.484163000000084
						],
						[
							-80.36397299999993,
							27.484205000000088
						],
						[
							-80.36377499999992,
							27.484213000000068
						],
						[
							-80.36360699999994,
							27.484221000000048
						],
						[
							-80.36340899999993,
							27.484217000000058
						],
						[
							-80.36317999999994,
							27.484205000000088
						],
						[
							-80.3628599999999,
							27.48414400000007
						],
						[
							-80.36264599999993,
							27.48414800000006
						],
						[
							-80.36249299999993,
							27.484160000000088
						],
						[
							-80.3622489999999,
							27.48416700000007
						],
						[
							-80.36205099999995,
							27.48414400000007
						],
						[
							-80.35777799999994,
							27.484034000000065
						],
						[
							-80.35757999999993,
							27.484034000000065
						],
						[
							-80.35292499999991,
							27.483908000000042
						],
						[
							-80.35200999999995,
							27.483984000000078
						],
						[
							-80.35100199999994,
							27.48397300000005
						],
						[
							-80.34997199999992,
							27.48391500000008
						],
						[
							-80.3499339999999,
							27.486590000000035
						],
						[
							-80.3499339999999,
							27.48676500000005
						],
						[
							-80.34949199999994,
							27.486761000000058
						],
						[
							-80.34936999999992,
							27.49844500000006
						],
						[
							-80.34853099999992,
							27.49853200000007
						],
						[
							-80.34834999999993,
							27.498526000000084
						],
						[
							-80.34769099999994,
							27.498502000000087
						],
						[
							-80.34668399999993,
							27.498471000000052
						],
						[
							-80.34613499999995,
							27.498582000000056
						],
						[
							-80.34601299999991,
							27.49968800000005
						],
						[
							-80.34598199999994,
							27.499742000000083
						],
						[
							-80.34593699999994,
							27.499803000000043
						],
						[
							-80.3459059999999,
							27.49986400000006
						],
						[
							-80.34569199999993,
							27.49982600000004
						]
					],
					[
						[
							-80.34403899999995,
							27.471115000000054
						],
						[
							-80.34403299999991,
							27.47067100000004
						],
						[
							-80.34370799999994,
							27.47066300000006
						],
						[
							-80.3436979999999,
							27.471115000000054
						],
						[
							-80.34403899999995,
							27.471115000000054
						],
						[
							-80.34404099999995,
							27.471261000000084
						],
						[
							-80.34404499999994,
							27.471512000000075
						],
						[
							-80.34362399999992,
							27.471501000000046
						],
						[
							-80.34361799999994,
							27.471115000000054
						],
						[
							-80.34337199999995,
							27.471115000000054
						],
						[
							-80.34342199999992,
							27.470657000000074
						],
						[
							-80.3434719999999,
							27.470215000000053
						],
						[
							-80.3442389999999,
							27.470251000000076
						],
						[
							-80.3442389999999,
							27.47067700000008
						],
						[
							-80.34467299999994,
							27.470688000000056
						],
						[
							-80.34467699999993,
							27.47027200000008
						],
						[
							-80.34521499999994,
							27.47029800000007
						],
						[
							-80.34521499999994,
							27.469904000000042
						],
						[
							-80.34557199999995,
							27.46991200000008
						],
						[
							-80.34557199999995,
							27.469415000000083
						],
						[
							-80.34507499999995,
							27.469391000000087
						],
						[
							-80.34506899999991,
							27.469900000000052
						],
						[
							-80.3441279999999,
							27.46987900000005
						],
						[
							-80.34413399999994,
							27.469346000000087
						],
						[
							-80.3439029999999,
							27.469335000000058
						],
						[
							-80.34390899999994,
							27.46987400000006
						],
						[
							-80.3434719999999,
							27.469865000000087
						],
						[
							-80.34321999999992,
							27.469858000000045
						],
						[
							-80.3432259999999,
							27.46931500000005
						],
						[
							-80.34301899999991,
							27.46931500000005
						],
						[
							-80.34301499999992,
							27.469854000000055
						],
						[
							-80.34301199999993,
							27.470215000000053
						],
						[
							-80.34200499999992,
							27.470215000000053
						],
						[
							-80.34200199999992,
							27.469832000000054
						],
						[
							-80.34263199999992,
							27.469845000000078
						],
						[
							-80.34263799999991,
							27.46931500000005
						],
						[
							-80.3414719999999,
							27.46931500000005
						],
						[
							-80.3414709999999,
							27.46982100000008
						],
						[
							-80.3414719999999,
							27.470215000000053
						],
						[
							-80.34200499999992,
							27.470215000000053
						],
						[
							-80.34200799999991,
							27.47065500000008
						],
						[
							-80.34293799999995,
							27.470688000000056
						],
						[
							-80.34292099999993,
							27.471115000000054
						],
						[
							-80.34255799999994,
							27.471115000000054
						],
						[
							-80.3425519999999,
							27.471494000000064
						],
						[
							-80.34220799999991,
							27.471490000000074
						],
						[
							-80.34219799999994,
							27.471115000000054
						],
						[
							-80.3414719999999,
							27.471115000000054
						],
						[
							-80.3414719999999,
							27.47058700000008
						],
						[
							-80.34110099999992,
							27.47058700000008
						],
						[
							-80.34110099999992,
							27.470215000000053
						],
						[
							-80.34110099999992,
							27.46984400000008
						],
						[
							-80.34085699999991,
							27.46984400000008
						],
						[
							-80.34085299999992,
							27.470215000000053
						],
						[
							-80.3404799999999,
							27.470215000000053
						],
						[
							-80.34048399999995,
							27.46984400000008
						],
						[
							-80.3397349999999,
							27.46984400000008
						],
						[
							-80.3397359999999,
							27.470215000000053
						],
						[
							-80.33963599999993,
							27.470215000000053
						],
						[
							-80.33963199999994,
							27.470639000000062
						],
						[
							-80.33927099999994,
							27.470643000000052
						],
						[
							-80.33927099999994,
							27.47074100000009
						],
						[
							-80.3390149999999,
							27.47073500000005
						],
						[
							-80.33901099999993,
							27.471115000000054
						],
						[
							-80.33879399999995,
							27.471115000000054
						],
						[
							-80.33878499999992,
							27.47070800000006
						],
						[
							-80.3382509999999,
							27.470706000000064
						],
						[
							-80.3382489999999,
							27.470656000000076
						],
						[
							-80.33823799999993,
							27.470215000000053
						],
						[
							-80.33851099999993,
							27.470215000000053
						],
						[
							-80.33852499999995,
							27.470652000000086
						],
						[
							-80.3390169999999,
							27.470646000000045
						],
						[
							-80.33902299999994,
							27.470215000000053
						],
						[
							-80.33868099999995,
							27.470215000000053
						],
						[
							-80.3386799999999,
							27.469773000000092
						],
						[
							-80.33736599999992,
							27.469759000000067
						],
						[
							-80.33757199999991,
							27.470215000000053
						],
						[
							-80.33776499999993,
							27.470968000000088
						],
						[
							-80.33782699999995,
							27.471115000000054
						],
						[
							-80.33814499999994,
							27.47186700000009
						],
						[
							-80.33816499999995,
							27.47191500000008
						],
						[
							-80.33856299999991,
							27.47282800000005
						],
						[
							-80.3391719999999,
							27.47291500000006
						],
						[
							-80.3391719999999,
							27.47191500000008
						],
						[
							-80.3393989999999,
							27.47191500000008
						],
						[
							-80.3393989999999,
							27.471538000000066
						],
						[
							-80.3408189999999,
							27.471554000000086
						],
						[
							-80.34081099999992,
							27.47191500000008
						],
						[
							-80.34099299999991,
							27.47191500000008
						],
						[
							-80.3409979999999,
							27.471486000000084
						],
						[
							-80.34099199999991,
							27.471115000000054
						],
						[
							-80.3414719999999,
							27.471115000000054
						],
						[
							-80.34141799999992,
							27.47154500000005
						],
						[
							-80.34117099999992,
							27.471538000000066
						],
						[
							-80.34117099999992,
							27.47191500000008
						],
						[
							-80.34117099999992,
							27.47246400000006
						],
						[
							-80.34098699999993,
							27.47246000000007
						],
						[
							-80.34098299999994,
							27.472875000000045
						],
						[
							-80.34137199999992,
							27.47291500000006
						],
						[
							-80.34222299999993,
							27.472872000000052
						],
						[
							-80.34221799999995,
							27.473357000000078
						],
						[
							-80.3417419999999,
							27.473354000000086
						],
						[
							-80.34174499999995,
							27.47381500000006
						],
						[
							-80.34156899999994,
							27.47381500000006
						],
						[
							-80.34157499999992,
							27.473354000000086
						],
						[
							-80.34137099999992,
							27.473354000000086
						],
						[
							-80.34137199999992,
							27.47381500000006
						],
						[
							-80.34156899999994,
							27.47381500000006
						],
						[
							-80.34156799999994,
							27.47392300000007
						],
						[
							-80.34156799999994,
							27.47421200000008
						],
						[
							-80.34174899999994,
							27.474217000000067
						],
						[
							-80.34174499999995,
							27.47381500000006
						],
						[
							-80.34198199999992,
							27.47381500000006
						],
						[
							-80.34198199999992,
							27.47422400000005
						],
						[
							-80.34217099999995,
							27.47423000000009
						],
						[
							-80.3421659999999,
							27.47381500000006
						],
						[
							-80.34276199999995,
							27.47381500000006
						],
						[
							-80.3427749999999,
							27.47336000000007
						],
						[
							-80.3433169999999,
							27.473363000000063
						],
						[
							-80.34365199999992,
							27.47336400000006
						],
						[
							-80.34365799999995,
							27.472829000000047
						],
						[
							-80.34415499999994,
							27.472855000000038
						],
						[
							-80.34413899999993,
							27.473366000000055
						],
						[
							-80.34476599999994,
							27.473369000000048
						],
						[
							-80.34427199999993,
							27.47381500000006
						],
						[
							-80.3432719999999,
							27.47381500000006
						],
						[
							-80.34305299999994,
							27.47381500000006
						],
						[
							-80.3430479999999,
							27.474258000000077
						],
						[
							-80.34280499999996,
							27.47425100000004
						],
						[
							-80.34280499999996,
							27.47476600000005
						],
						[
							-80.3430899999999,
							27.474735000000067
						],
						[
							-80.3430899999999,
							27.47510800000009
						],
						[
							-80.34371899999991,
							27.475366000000065
						],
						[
							-80.34370599999994,
							27.47473300000007
						],
						[
							-80.3432719999999,
							27.47471500000006
						],
						[
							-80.3432709999999,
							27.47426500000006
						],
						[
							-80.34375399999993,
							27.47428000000008
						],
						[
							-80.34427199999993,
							27.47381500000006
						],
						[
							-80.34557199999995,
							27.47381500000006
						],
						[
							-80.34557099999996,
							27.474337000000048
						],
						[
							-80.34557199999995,
							27.474815000000035
						],
						[
							-80.34677699999992,
							27.474815000000035
						],
						[
							-80.34679399999993,
							27.474375000000066
						],
						[
							-80.3470989999999,
							27.47438500000004
						],
						[
							-80.34647199999995,
							27.47381500000006
						],
						[
							-80.34613999999993,
							27.473483000000044
						],
						[
							-80.3461099999999,
							27.47291500000006
						],
						[
							-80.3461759999999,
							27.47291500000006
						],
						[
							-80.34618099999996,
							27.472506000000067
						],
						[
							-80.34627199999994,
							27.472507000000064
						],
						[
							-80.34627799999993,
							27.47291500000006
						],
						[
							-80.34627999999992,
							27.473042000000078
						],
						[
							-80.3462879999999,
							27.473457000000053
						],
						[
							-80.34676399999995,
							27.473483000000044
						],
						[
							-80.34683299999995,
							27.473483000000044
						],
						[
							-80.34682499999991,
							27.473847000000035
						],
						[
							-80.3475719999999,
							27.47391500000009
						],
						[
							-80.3475719999999,
							27.474815000000035
						],
						[
							-80.3475709999999,
							27.475287000000037
						],
						[
							-80.34717599999993,
							27.475281000000056
						],
						[
							-80.3471639999999,
							27.474815000000035
						],
						[
							-80.34694499999995,
							27.474815000000035
						],
						[
							-80.34694899999994,
							27.47527800000006
						],
						[
							-80.34695199999993,
							27.475715000000037
						],
						[
							-80.3475719999999,
							27.475715000000037
						],
						[
							-80.34786899999995,
							27.475715000000037
						],
						[
							-80.34786899999995,
							27.475324000000057
						],
						[
							-80.34806899999995,
							27.47532300000006
						],
						[
							-80.34814999999993,
							27.475715000000037
						],
						[
							-80.3481549999999,
							27.47621500000008
						],
						[
							-80.34907199999992,
							27.47621500000008
						],
						[
							-80.34907199999992,
							27.475715000000037
						],
						[
							-80.34881499999995,
							27.475715000000037
						],
						[
							-80.34882499999992,
							27.475324000000057
						],
						[
							-80.3491229999999,
							27.475324000000057
						],
						[
							-80.3491229999999,
							27.47506400000009
						],
						[
							-80.34957199999991,
							27.47506400000009
						],
						[
							-80.34957199999991,
							27.474815000000035
						],
						[
							-80.34925399999992,
							27.474815000000035
						],
						[
							-80.34925499999991,
							27.47468400000008
						],
						[
							-80.34957199999991,
							27.47468400000008
						],
						[
							-80.34957199999991,
							27.47454600000009
						],
						[
							-80.34925699999991,
							27.474538000000052
						],
						[
							-80.3492589999999,
							27.474402000000055
						],
						[
							-80.34957199999991,
							27.474406000000045
						],
						[
							-80.34957199999991,
							27.47391500000009
						],
						[
							-80.34957199999991,
							27.47372500000006
						],
						[
							-80.34925199999992,
							27.473736000000088
						],
						[
							-80.34925199999992,
							27.47391500000009
						],
						[
							-80.34882999999991,
							27.47391500000009
						],
						[
							-80.34881599999994,
							27.473472000000072
						],
						[
							-80.34869099999992,
							27.473471000000075
						],
						[
							-80.34869099999992,
							27.47391500000009
						],
						[
							-80.34853099999992,
							27.47391500000009
						],
						[
							-80.34854599999994,
							27.473470000000077
						],
						[
							-80.34863899999993,
							27.473470000000077
						],
						[
							-80.34863799999994,
							27.47291500000006
						],
						[
							-80.34957199999991,
							27.47291500000006
						],
						[
							-80.34957199999991,
							27.47211500000009
						],
						[
							-80.34917499999995,
							27.47209500000008
						],
						[
							-80.34918199999994,
							27.47119500000008
						],
						[
							-80.34905299999991,
							27.471189000000038
						],
						[
							-80.34905399999991,
							27.470881000000077
						],
						[
							-80.34905999999995,
							27.470639000000062
						],
						[
							-80.34957199999991,
							27.470639000000062
						],
						[
							-80.34957199999991,
							27.470215000000053
						],
						[
							-80.34957199999991,
							27.469757000000072
						],
						[
							-80.34830199999993,
							27.46974400000005
						],
						[
							-80.34827999999993,
							27.470214000000055
						],
						[
							-80.34817699999991,
							27.470215000000053
						],
						[
							-80.34814899999992,
							27.470639000000062
						],
						[
							-80.3475719999999,
							27.470639000000062
						],
						[
							-80.3475719999999,
							27.471115000000054
						],
						[
							-80.34734899999995,
							27.471115000000054
						],
						[
							-80.34734299999991,
							27.471607000000063
						],
						[
							-80.34715699999992,
							27.471602000000075
						],
						[
							-80.34714799999995,
							27.472015000000056
						],
						[
							-80.34635099999991,
							27.472015000000056
						],
						[
							-80.34637399999991,
							27.471579000000077
						],
						[
							-80.34620799999993,
							27.471575000000087
						],
						[
							-80.34622799999995,
							27.471115000000054
						],
						[
							-80.34616899999992,
							27.471115000000054
						],
						[
							-80.34617999999995,
							27.470688000000056
						],
						[
							-80.34608999999995,
							27.470691000000045
						],
						[
							-80.34609499999993,
							27.47028800000004
						],
						[
							-80.34591199999994,
							27.470297000000073
						],
						[
							-80.34590099999991,
							27.470697000000087
						],
						[
							-80.34597599999995,
							27.470695000000035
						],
						[
							-80.34597599999995,
							27.471115000000054
						],
						[
							-80.34557199999995,
							27.471115000000054
						],
						[
							-80.34544899999992,
							27.471115000000054
						],
						[
							-80.34544899999992,
							27.47070700000006
						],
						[
							-80.3451629999999,
							27.47070000000008
						],
						[
							-80.3451629999999,
							27.471115000000054
						],
						[
							-80.34529399999992,
							27.471115000000054
						],
						[
							-80.34529399999992,
							27.47154900000004
						],
						[
							-80.34454999999991,
							27.471527000000037
						],
						[
							-80.34454999999991,
							27.471115000000054
						],
						[
							-80.34403899999995,
							27.471115000000054
						]
					],
					[
						[
							-80.34640799999994,
							27.470679000000075
						],
						[
							-80.34640799999994,
							27.471115000000054
						],
						[
							-80.34682499999991,
							27.471115000000054
						],
						[
							-80.3468299999999,
							27.47066400000006
						],
						[
							-80.34709499999991,
							27.47065500000008
						],
						[
							-80.34710599999994,
							27.470237000000054
						],
						[
							-80.34722699999992,
							27.470232000000067
						],
						[
							-80.34724699999992,
							27.469814000000042
						],
						[
							-80.34762199999994,
							27.469809000000055
						],
						[
							-80.34767199999993,
							27.469415000000083
						],
						[
							-80.34713999999991,
							27.469415000000083
						],
						[
							-80.3471209999999,
							27.46981500000004
						],
						[
							-80.34665899999993,
							27.46982200000008
						],
						[
							-80.3466259999999,
							27.470262000000048
						],
						[
							-80.34650499999992,
							27.47026800000009
						],
						[
							-80.3464889999999,
							27.470676000000083
						],
						[
							-80.34640799999994,
							27.470679000000075
						]
					],
					[
						[
							-80.34654899999992,
							27.469823000000076
						],
						[
							-80.3465599999999,
							27.469415000000083
						],
						[
							-80.34638799999993,
							27.469415000000083
						],
						[
							-80.34637499999991,
							27.46982600000007
						],
						[
							-80.34654899999992,
							27.469823000000076
						]
					],
					[
						[
							-80.34485199999995,
							27.475715000000037
						],
						[
							-80.34485699999993,
							27.475250000000074
						],
						[
							-80.34486099999992,
							27.47492500000004
						],
						[
							-80.34495699999991,
							27.47492600000004
						],
						[
							-80.34495499999991,
							27.474785000000054
						],
						[
							-80.34512699999993,
							27.47479300000009
						],
						[
							-80.3451159999999,
							27.474322000000086
						],
						[
							-80.3448679999999,
							27.47431400000005
						],
						[
							-80.34486299999992,
							27.47478200000006
						],
						[
							-80.34437899999995,
							27.474761000000058
						],
						[
							-80.34438399999993,
							27.47429800000009
						],
						[
							-80.34383799999995,
							27.474282000000073
						],
						[
							-80.34382799999992,
							27.47473800000006
						],
						[
							-80.34419099999991,
							27.474753000000078
						],
						[
							-80.3441729999999,
							27.47524100000004
						],
						[
							-80.34439099999992,
							27.475243000000034
						],
						[
							-80.34440999999993,
							27.475648000000035
						],
						[
							-80.34457199999991,
							27.475715000000037
						],
						[
							-80.34485199999995,
							27.475715000000037
						],
						[
							-80.34553499999993,
							27.47603500000008
						],
						[
							-80.3457719999999,
							27.47611500000005
						],
						[
							-80.34651199999992,
							27.47615600000006
						],
						[
							-80.34652999999992,
							27.475715000000037
						],
						[
							-80.3463769999999,
							27.475715000000037
						],
						[
							-80.34638899999993,
							27.475271000000077
						],
						[
							-80.34592399999991,
							27.475265000000036
						],
						[
							-80.34591699999993,
							27.475715000000037
						],
						[
							-80.34557199999995,
							27.475715000000037
						],
						[
							-80.3454759999999,
							27.475715000000037
						],
						[
							-80.34548299999994,
							27.475259000000054
						],
						[
							-80.34549099999992,
							27.474811000000045
						],
						[
							-80.34526699999992,
							27.474800000000073
						],
						[
							-80.34526299999993,
							27.47525500000006
						],
						[
							-80.34525899999994,
							27.475715000000037
						],
						[
							-80.34485199999995,
							27.475715000000037
						]
					],
					[
						[
							-80.34005899999994,
							27.472841000000074
						],
						[
							-80.34037199999995,
							27.472815000000082
						],
						[
							-80.34058599999992,
							27.47283500000009
						],
						[
							-80.34061199999991,
							27.47191500000008
						],
						[
							-80.3400979999999,
							27.47191500000008
						],
						[
							-80.33974299999994,
							27.47191500000008
						],
						[
							-80.33971899999995,
							27.47242700000004
						],
						[
							-80.3400759999999,
							27.47243700000007
						],
						[
							-80.34005899999994,
							27.472841000000074
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Saint Lucie",
				"City": "Fort Pierce",
				"Name": "Fort Pierce North",
				"RegionID": "396874"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.13299718299993,
					26.260569075000035,
					-80.12285882999993,
					26.271597626000073
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.13299718299993,
							26.260569075000035
						],
						[
							-80.12730981499993,
							26.267295007000087
						],
						[
							-80.12634543499992,
							26.26867975800008
						],
						[
							-80.12530894499992,
							26.271553312000037
						],
						[
							-80.12305665199995,
							26.271597626000073
						],
						[
							-80.12285882999993,
							26.266083350000088
						],
						[
							-80.12320501799991,
							26.26566298000006
						],
						[
							-80.12315556199991,
							26.260717441000054
						],
						[
							-80.12738399799991,
							26.260643258000073
						],
						[
							-80.13299718299993,
							26.260569075000035
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Pompano Beach",
				"Name": "Leisureville",
				"RegionID": "399378"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.56493266199999,
					28.309137082000063,
					-81.55785619399995,
					28.31622506300005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.56052194199998,
							28.309137082000063
						],
						[
							-81.56331359099994,
							28.31073707400003
						],
						[
							-81.56493266199999,
							28.312046312000064
						],
						[
							-81.56103882599996,
							28.31622506300005
						],
						[
							-81.55888779299994,
							28.31415017300003
						],
						[
							-81.55785619399995,
							28.312547661000053
						],
						[
							-81.55844629999996,
							28.311786234000067
						],
						[
							-81.55861223799997,
							28.31139114400003
						],
						[
							-81.55943982799994,
							28.310704713000064
						],
						[
							-81.56031546999998,
							28.309657750000046
						],
						[
							-81.56052194199998,
							28.309137082000063
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Osceola",
				"City": "Celebration",
				"Name": "Spring Lake",
				"RegionID": "405946"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.12920895299993,
					25.844390098000076,
					-80.11626684599992,
					25.872561000000076
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.11626684599992,
							25.872289712000054
						],
						[
							-80.11651180599995,
							25.84439805900007
						],
						[
							-80.12063302399991,
							25.84461122500005
						],
						[
							-80.1222760359999,
							25.844390098000076
						],
						[
							-80.12246240499991,
							25.846551976000057
						],
						[
							-80.12294696399994,
							25.849012043000073
						],
						[
							-80.12328242699994,
							25.850502993000077
						],
						[
							-80.12425154499994,
							25.851807574000077
						],
						[
							-80.12518338799993,
							25.85445401000004
						],
						[
							-80.12600341099994,
							25.854789474000086
						],
						[
							-80.12920895299993,
							25.859038681000076
						],
						[
							-80.12913440599993,
							25.859858704000093
						],
						[
							-80.12809074099994,
							25.860604178000074
						],
						[
							-80.12809074099994,
							25.862169676000065
						],
						[
							-80.12771800299993,
							25.862840603000052
						],
						[
							-80.12440063999992,
							25.866977989000077
						],
						[
							-80.12466155599992,
							25.87167448100007
						],
						[
							-80.12488476099992,
							25.87244720700005
						],
						[
							-80.1244309999999,
							25.872467000000086
						],
						[
							-80.12439599999993,
							25.871980000000065
						],
						[
							-80.12391899999994,
							25.87207200000006
						],
						[
							-80.12306899999993,
							25.872075000000052
						],
						[
							-80.12225999999993,
							25.872487000000035
						],
						[
							-80.12153099999995,
							25.87252800000005
						],
						[
							-80.12098999999995,
							25.87255900000008
						],
						[
							-80.1204919999999,
							25.872561000000076
						],
						[
							-80.1196139999999,
							25.872175000000087
						],
						[
							-80.11630111599995,
							25.872288538000078
						],
						[
							-80.11626684599992,
							25.872289712000054
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Beach",
				"Name": "North Shore",
				"RegionID": "407493"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.10874630399996,
					26.891658196000037,
					-80.10335824199996,
					26.897255794000046
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.10356777799996,
							26.891658196000037
						],
						[
							-80.10739928899994,
							26.89186773200004
						],
						[
							-80.10763875799995,
							26.89351408400006
						],
						[
							-80.10802789599995,
							26.894052891000058
						],
						[
							-80.10868643699996,
							26.895010768000077
						],
						[
							-80.10874630399996,
							26.895459773000027
						],
						[
							-80.10865650299996,
							26.895729177000078
						],
						[
							-80.10856670199996,
							26.895729177000078
						],
						[
							-80.10766869199995,
							26.896028513000033
						],
						[
							-80.10653121199994,
							26.895878845000027
						],
						[
							-80.10590260499998,
							26.89698639100004
						],
						[
							-80.10578286999998,
							26.897255794000046
						],
						[
							-80.10335824199996,
							26.897165993000044
						],
						[
							-80.10356777799996,
							26.891658196000037
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Jupiter",
				"Name": "Cambridge",
				"RegionID": "412416"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.11066205899994,
					26.905307953000033,
					-80.10293917099995,
					26.91030687700004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.11042258999998,
							26.91018714300003
						],
						[
							-80.11027292199998,
							26.91021707600004
						],
						[
							-80.10988378399998,
							26.91030687700004
						],
						[
							-80.10293917099995,
							26.910127275000036
						],
						[
							-80.10299903799995,
							26.905307953000033
						],
						[
							-80.11066205899994,
							26.90542768800003
						],
						[
							-80.11042258999998,
							26.91018714300003
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Jupiter",
				"Name": "Canterbury",
				"RegionID": "414456"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.1954695359999,
					26.20107908700004,
					-80.18884963499994,
					26.20246368000005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.19043641299993,
							26.201090987000043
						],
						[
							-80.19545011899993,
							26.20107908700004
						],
						[
							-80.19545359199992,
							26.20149068900008
						],
						[
							-80.19545522899995,
							26.20168458200004
						],
						[
							-80.19545645499994,
							26.201829925000084
						],
						[
							-80.19545999999991,
							26.20225000000005
						],
						[
							-80.19545999999991,
							26.202326493000044
						],
						[
							-80.1954695359999,
							26.20241566100009
						],
						[
							-80.19532404899991,
							26.20241957500008
						],
						[
							-80.19489869199992,
							26.202420000000078
						],
						[
							-80.19448951899994,
							26.202420000000078
						],
						[
							-80.19416203499992,
							26.202424633000078
						],
						[
							-80.19388387499993,
							26.20242926900005
						],
						[
							-80.19350750399991,
							26.20243000000005
						],
						[
							-80.19314743199993,
							26.20243000000005
						],
						[
							-80.19262368999995,
							26.20243000000005
						],
						[
							-80.1920017409999,
							26.202432711000085
						],
						[
							-80.19139621499994,
							26.202438216000075
						],
						[
							-80.19080713999995,
							26.202445694000062
						],
						[
							-80.19043052199993,
							26.202450000000056
						],
						[
							-80.18997999999993,
							26.202450000000056
						],
						[
							-80.18989077799995,
							26.202455576000094
						],
						[
							-80.18967764399991,
							26.202460000000087
						],
						[
							-80.18921926599995,
							26.202461035000056
						],
						[
							-80.18886174799991,
							26.20246368000005
						],
						[
							-80.18886174799991,
							26.20172085300004
						],
						[
							-80.18884963499994,
							26.201103100000072
						],
						[
							-80.19043641299993,
							26.201090987000043
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Lofts of Palm Aire Village",
				"RegionID": "416133"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.18355999999994,
					26.088860000000068,
					-80.18169033299995,
					26.092743626000072
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.18169033299995,
							26.088863186000083
						],
						[
							-80.18169699999993,
							26.088860000000068
						],
						[
							-80.18323000799995,
							26.089103324000064
						],
						[
							-80.1834199999999,
							26.089630000000056
						],
						[
							-80.18342821399995,
							26.089831243000052
						],
						[
							-80.18344046999994,
							26.09013152200004
						],
						[
							-80.18345195199993,
							26.090412824000055
						],
						[
							-80.1834595119999,
							26.090598052000075
						],
						[
							-80.18347063499994,
							26.090820792000045
						],
						[
							-80.18348144099991,
							26.09100450500006
						],
						[
							-80.18348999999995,
							26.091150000000084
						],
						[
							-80.18349502199993,
							26.09131571100005
						],
						[
							-80.18350502699991,
							26.091645883000073
						],
						[
							-80.18351471999995,
							26.091965774000073
						],
						[
							-80.18351971399994,
							26.092130566000037
						],
						[
							-80.18353315199994,
							26.092284669000037
						],
						[
							-80.18354746999995,
							26.092412288000048
						],
						[
							-80.18355999999994,
							26.092500000000086
						],
						[
							-80.18337482499993,
							26.092534111000077
						],
						[
							-80.18313330699993,
							26.09257860100007
						],
						[
							-80.18294043799995,
							26.092614130000072
						],
						[
							-80.18279999999993,
							26.092640000000074
						],
						[
							-80.18253878299993,
							26.092690969000046
						],
						[
							-80.18238999999994,
							26.092720000000043
						],
						[
							-80.18227659599995,
							26.092743626000072
						],
						[
							-80.18223064399992,
							26.091558073000044
						],
						[
							-80.18224034699995,
							26.091160268000067
						],
						[
							-80.18222094099991,
							26.09087889400007
						],
						[
							-80.18217242899993,
							26.090257929000074
						],
						[
							-80.18220153599992,
							26.089976555000078
						],
						[
							-80.18209480799993,
							26.089636965000068
						],
						[
							-80.18169033299995,
							26.088863186000083
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Riverland Manors",
				"RegionID": "416135"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.70745486399994,
					27.706136678000064,
					-82.69162560899991,
					27.719345322000038
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.6992937309999,
							27.719217960000037
						],
						[
							-82.69895558699994,
							27.71856233500006
						],
						[
							-82.6981053689999,
							27.717712117000076
						],
						[
							-82.69737083699994,
							27.716977584000063
						],
						[
							-82.69578608599994,
							27.715216751000074
						],
						[
							-82.6940252519999,
							27.713367875000074
						],
						[
							-82.69235245999994,
							27.711651062000048
						],
						[
							-82.69182420999994,
							27.710990749000075
						],
						[
							-82.69162560899991,
							27.710349320000034
						],
						[
							-82.69163860899994,
							27.710276320000048
						],
						[
							-82.69167891399991,
							27.710126414000058
						],
						[
							-82.69174979199994,
							27.709976508000068
						],
						[
							-82.69180641899993,
							27.709882677000053
						],
						[
							-82.69188707899991,
							27.70976992700008
						],
						[
							-82.6919948119999,
							27.70966170400004
						],
						[
							-82.69210736899993,
							27.709566392000056
						],
						[
							-82.69223733899992,
							27.709475164000086
						],
						[
							-82.69230583299992,
							27.70943945000005
						],
						[
							-82.69246183299992,
							27.709366450000065
						],
						[
							-82.69254011299995,
							27.709334218000038
						],
						[
							-82.69280011399991,
							27.709241218000045
						],
						[
							-82.69292437599995,
							27.709206596000058
						],
						[
							-82.69380579199992,
							27.70902797000008
						],
						[
							-82.69659874299992,
							27.70831813800004
						],
						[
							-82.69686740399993,
							27.70825579600006
						],
						[
							-82.69690676999996,
							27.708246710000083
						],
						[
							-82.69696552199991,
							27.70823461000009
						],
						[
							-82.69702501299992,
							27.708226929000094
						],
						[
							-82.69708491099993,
							27.708223710000084
						],
						[
							-82.69714488199992,
							27.70822497100005
						],
						[
							-82.69719392699994,
							27.708176079000058
						],
						[
							-82.69730930599991,
							27.708093836000046
						],
						[
							-82.6974493059999,
							27.70800983600009
						],
						[
							-82.6975830589999,
							27.70794399500005
						],
						[
							-82.69784005799994,
							27.707842995000078
						],
						[
							-82.69793402399995,
							27.70781191800006
						],
						[
							-82.69904602399993,
							27.707510918000082
						],
						[
							-82.69907451099994,
							27.70750370400009
						],
						[
							-82.70050367499994,
							27.707166553000036
						],
						[
							-82.70213187399992,
							27.706751541000074
						],
						[
							-82.70216263799995,
							27.706744273000083
						],
						[
							-82.70376063799995,
							27.706396273000053
						],
						[
							-82.70378558699991,
							27.70639120900006
						],
						[
							-82.70417937799994,
							27.70631706100005
						],
						[
							-82.7050695019999,
							27.706151126000066
						],
						[
							-82.70522999999991,
							27.706136678000064
						],
						[
							-82.70530352499992,
							27.706139689000054
						],
						[
							-82.7055595249999,
							27.706160689000058
						],
						[
							-82.70563007699991,
							27.706169294000063
						],
						[
							-82.70569972899995,
							27.70618344400009
						],
						[
							-82.70576804599995,
							27.706203051000045
						],
						[
							-82.70583460199992,
							27.70622799100005
						],
						[
							-82.70589897999992,
							27.70625810900009
						],
						[
							-82.70596077899995,
							27.706293217000052
						],
						[
							-82.70607177899991,
							27.70636221600006
						],
						[
							-82.70613554399995,
							27.706405756000038
						],
						[
							-82.70619533899992,
							27.706454604000044
						],
						[
							-82.70625072299993,
							27.706508402000054
						],
						[
							-82.7063012889999,
							27.70656675200007
						],
						[
							-82.70634666299992,
							27.70662922400004
						],
						[
							-82.70638651199994,
							27.70669535800005
						],
						[
							-82.70651851199995,
							27.70693735900005
						],
						[
							-82.70657408599993,
							27.70706041400007
						],
						[
							-82.70659498399993,
							27.707125406000046
						],
						[
							-82.70683898399994,
							27.707996405000074
						],
						[
							-82.7068570049999,
							27.708073729000034
						],
						[
							-82.70694300499991,
							27.708533729000067
						],
						[
							-82.70695772199991,
							27.708666158000085
						],
						[
							-82.70696872199994,
							27.708967157000075
						],
						[
							-82.7069693219999,
							27.70900000000006
						],
						[
							-82.70695831699993,
							27.70914025600007
						],
						[
							-82.70693298899994,
							27.709300211000084
						],
						[
							-82.7069169849999,
							27.70937588700008
						],
						[
							-82.7068945339999,
							27.70944990600009
						],
						[
							-82.70686580299991,
							27.70952172200009
						],
						[
							-82.70683100499991,
							27.70959080100005
						],
						[
							-82.7067903979999,
							27.709656634000055
						],
						[
							-82.70674428099994,
							27.709718732000056
						],
						[
							-82.7066835999999,
							27.70979340200006
						],
						[
							-82.7065762009999,
							27.709903017000045
						],
						[
							-82.70645113799992,
							27.710010469000053
						],
						[
							-82.7063186609999,
							27.710103836000087
						],
						[
							-82.70625090499993,
							27.710139205000075
						],
						[
							-82.70594390399992,
							27.710283204000064
						],
						[
							-82.70582136999991,
							27.71033010800005
						],
						[
							-82.70548936999995,
							27.710430108000082
						],
						[
							-82.70542071599994,
							27.710447867000084
						],
						[
							-82.70498803399994,
							27.71054176000007
						],
						[
							-82.70409124399993,
							27.71076718800009
						],
						[
							-82.70406132099994,
							27.710774169000047
						],
						[
							-82.70265434099991,
							27.71107715000005
						],
						[
							-82.69980306799994,
							27.711787842000035
						],
						[
							-82.70093277199993,
							27.71295206400004
						],
						[
							-82.70097425299991,
							27.71299776300009
						],
						[
							-82.7010125029999,
							27.713046200000065
						],
						[
							-82.70104733999995,
							27.713097146000052
						],
						[
							-82.70107860099995,
							27.71315036200008
						],
						[
							-82.7011685999999,
							27.713316361000068
						],
						[
							-82.70119992799994,
							27.71337459700004
						],
						[
							-82.70122570899991,
							27.713435492000087
						],
						[
							-82.70124571899993,
							27.71349851900004
						],
						[
							-82.70125978599992,
							27.713563132000047
						],
						[
							-82.70126778899993,
							27.713628774000085
						],
						[
							-82.70131366099992,
							27.713650164000057
						],
						[
							-82.70139929699991,
							27.713706340000044
						],
						[
							-82.7014262969999,
							27.71372634000005
						],
						[
							-82.70146907299994,
							27.713760079000053
						],
						[
							-82.70156603999993,
							27.713854776000062
						],
						[
							-82.70163606199993,
							27.713934322000057
						],
						[
							-82.70421836199995,
							27.713304538000045
						],
						[
							-82.7051770139999,
							27.713087904000076
						],
						[
							-82.70540630399995,
							27.713028459000043
						],
						[
							-82.7054758349999,
							27.71301334000009
						],
						[
							-82.70563199999992,
							27.712999678000074
						],
						[
							-82.70575699999995,
							27.712999678000074
						],
						[
							-82.70583434899993,
							27.71300301000008
						],
						[
							-82.70591112599993,
							27.713012983000056
						],
						[
							-82.70598675999992,
							27.713029523000046
						],
						[
							-82.70606069099995,
							27.713052506000057
						],
						[
							-82.7061323719999,
							27.713081763000048
						],
						[
							-82.70620126999995,
							27.71311707700005
						],
						[
							-82.70626687599992,
							27.713158185000054
						],
						[
							-82.70632870299994,
							27.713204784000087
						],
						[
							-82.70634675899994,
							27.713219654000056
						],
						[
							-82.70643913099991,
							27.71385210400007
						],
						[
							-82.7066152139999,
							27.714468396000086
						],
						[
							-82.7066592349999,
							27.715216751000074
						],
						[
							-82.70696738099991,
							27.716009126000074
						],
						[
							-82.70745486399994,
							27.71677675300009
						],
						[
							-82.70743929299994,
							27.716854802000057
						],
						[
							-82.70741688299995,
							27.716931168000087
						],
						[
							-82.7073878089999,
							27.71700525400007
						],
						[
							-82.70736780899995,
							27.71705025300008
						],
						[
							-82.70733235199992,
							27.717121384000052
						],
						[
							-82.70729075299994,
							27.717189105000045
						],
						[
							-82.7072433379999,
							27.717252890000054
						],
						[
							-82.70719047599994,
							27.71731224000007
						],
						[
							-82.70713258099994,
							27.717366690000066
						],
						[
							-82.7070853269999,
							27.71740730600004
						],
						[
							-82.70702489399991,
							27.717454385000053
						],
						[
							-82.70696067299991,
							27.717496149000056
						],
						[
							-82.70689312999991,
							27.71753229400008
						],
						[
							-82.7068227549999,
							27.717562558000054
						],
						[
							-82.70675005899994,
							27.71758672100009
						],
						[
							-82.70668502399991,
							27.717605302000038
						],
						[
							-82.70604664299992,
							27.717953511000076
						],
						[
							-82.70592358699992,
							27.718009086000052
						],
						[
							-82.70589554599991,
							27.71801877100006
						],
						[
							-82.70573654599991,
							27.718070771000043
						],
						[
							-82.70566330899993,
							27.71809133800008
						],
						[
							-82.70446593199995,
							27.718373443000075
						],
						[
							-82.7030157989999,
							27.718682735000073
						],
						[
							-82.70147092299993,
							27.718991152000058
						],
						[
							-82.7011398709999,
							27.719068140000047
						],
						[
							-82.70011103399992,
							27.71930533400007
						],
						[
							-82.70007957799993,
							27.71931199700009
						],
						[
							-82.69998437199992,
							27.71933032800007
						],
						[
							-82.69982099999994,
							27.719345322000038
						],
						[
							-82.69973852399994,
							27.719341532000044
						],
						[
							-82.6996625239999,
							27.71933453200006
						],
						[
							-82.69958534999995,
							27.719323857000063
						],
						[
							-82.69950934999991,
							27.71930671800004
						],
						[
							-82.69943506399994,
							27.71928323700007
						],
						[
							-82.69936301999991,
							27.719253580000043
						],
						[
							-82.6992937309999,
							27.719217960000037
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Bayway Isles",
				"RegionID": "416183"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.4871849999999,
					28.010760017000052,
					-82.4551926659999,
					28.03409872900005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.48532080799993,
							28.03409872900005
						],
						[
							-82.48403635999995,
							28.033781821000048
						],
						[
							-82.4799181809999,
							28.033800001000092
						],
						[
							-82.47891818199992,
							28.033900000000074
						],
						[
							-82.4760181819999,
							28.033900000000074
						],
						[
							-82.47346363499992,
							28.033990909000067
						],
						[
							-82.46971815699993,
							28.033900132000042
						],
						[
							-82.46763638699991,
							28.03309077700004
						],
						[
							-82.45927272799992,
							28.032900056000074
						],
						[
							-82.45930013399993,
							28.025399866000043
						],
						[
							-82.4556180479999,
							28.02540922500009
						],
						[
							-82.45561818099992,
							28.02270909100008
						],
						[
							-82.4551926659999,
							28.02014269000006
						],
						[
							-82.45548182699991,
							28.020109010000056
						],
						[
							-82.45648013699991,
							28.020579402000067
						],
						[
							-82.45843065799994,
							28.02092759700008
						],
						[
							-82.46127276099992,
							28.021291080000086
						],
						[
							-82.46199103399994,
							28.020881942000074
						],
						[
							-82.46238169399993,
							28.020127148000086
						],
						[
							-82.4638000839999,
							28.01943646600006
						],
						[
							-82.46457290599994,
							28.018381859000048
						],
						[
							-82.46416363499992,
							28.01610909100009
						],
						[
							-82.46408181999993,
							28.015309095000077
						],
						[
							-82.46475454499995,
							28.012309091000077
						],
						[
							-82.46488493599992,
							28.010873789000073
						],
						[
							-82.4660445529999,
							28.010760017000052
						],
						[
							-82.46752554599993,
							28.010768677000044
						],
						[
							-82.48476433199994,
							28.010869488000083
						],
						[
							-82.48530869099994,
							28.010873581000055
						],
						[
							-82.48585199999991,
							28.01237000000009
						],
						[
							-82.4860819999999,
							28.013189000000068
						],
						[
							-82.4860834129999,
							28.01321762500004
						],
						[
							-82.48612099999991,
							28.013979000000063
						],
						[
							-82.48620799999992,
							28.01471500000008
						],
						[
							-82.48618999999991,
							28.01555600000006
						],
						[
							-82.48616218299992,
							28.017027840000083
						],
						[
							-82.48616173199993,
							28.017051722000076
						],
						[
							-82.48614499999991,
							28.017937000000074
						],
						[
							-82.48618099999993,
							28.01798800000006
						],
						[
							-82.48627799999991,
							28.01803700000005
						],
						[
							-82.48633299999995,
							28.01807100000008
						],
						[
							-82.4863519999999,
							28.018103000000053
						],
						[
							-82.4863494299999,
							28.018640894000043
						],
						[
							-82.4863489999999,
							28.01873100000006
						],
						[
							-82.48633499999994,
							28.019406000000064
						],
						[
							-82.48634091299994,
							28.020047513000065
						],
						[
							-82.48634099999992,
							28.020057000000065
						],
						[
							-82.48633380099994,
							28.020654515000047
						],
						[
							-82.48633299999995,
							28.02072100000004
						],
						[
							-82.48632299999991,
							28.021382000000074
						],
						[
							-82.48631899999992,
							28.02212300000008
						],
						[
							-82.48631099999996,
							28.02245000000005
						],
						[
							-82.48630880299993,
							28.022553962000075
						],
						[
							-82.48630799999995,
							28.022592000000092
						],
						[
							-82.48626999999993,
							28.025367000000074
						],
						[
							-82.48566209499995,
							28.025365271000055
						],
						[
							-82.4852631469999,
							28.025364137000054
						],
						[
							-82.48521499999993,
							28.02536400000008
						],
						[
							-82.48521425799993,
							28.025444881000055
						],
						[
							-82.4851999999999,
							28.027000000000044
						],
						[
							-82.48566299999993,
							28.027023000000042
						],
						[
							-82.48615299999994,
							28.02700400000009
						],
						[
							-82.48615199999995,
							28.027447000000056
						],
						[
							-82.48669599999994,
							28.02744500000006
						],
						[
							-82.48715699999991,
							28.027473000000043
						],
						[
							-82.4871849999999,
							28.028244000000086
						],
						[
							-82.48713608799996,
							28.028243558000042
						],
						[
							-82.48541599999993,
							28.02822800000007
						],
						[
							-82.48541599999993,
							28.028499220000075
						],
						[
							-82.48541599999993,
							28.030230000000074
						],
						[
							-82.48537599999992,
							28.030456000000072
						],
						[
							-82.48527225799995,
							28.030685196000036
						],
						[
							-82.4852039999999,
							28.03083600000008
						],
						[
							-82.48523646099994,
							28.031720481000036
						],
						[
							-82.48530099999994,
							28.033479000000057
						],
						[
							-82.4853158979999,
							28.033688247000043
						],
						[
							-82.48532299999994,
							28.033788000000072
						],
						[
							-82.48532231399992,
							28.03388522000006
						],
						[
							-82.48532080799993,
							28.03409872900005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Lowry Park Central",
				"RegionID": "274376"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.33105459299992,
					28.510476730000054,
					-81.31840056499993,
					28.51866401500007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.32896339199993,
							28.518634793000047
						],
						[
							-81.32672090499995,
							28.51863497800008
						],
						[
							-81.3267211729999,
							28.517007298000067
						],
						[
							-81.31863587499993,
							28.516971150000074
						],
						[
							-81.31862294799993,
							28.516971092000063
						],
						[
							-81.31862748499994,
							28.51691891900009
						],
						[
							-81.31863676199993,
							28.516858798000044
						],
						[
							-81.31864726399995,
							28.51679073400004
						],
						[
							-81.31865617999995,
							28.51673946300008
						],
						[
							-81.31867159199993,
							28.516631343000086
						],
						[
							-81.3186796729999,
							28.51648588900008
						],
						[
							-81.31868797699991,
							28.51633640700004
						],
						[
							-81.31868999999995,
							28.516187678000055
						],
						[
							-81.3186906819999,
							28.515998395000054
						],
						[
							-81.31869330499991,
							28.515838391000045
						],
						[
							-81.3186958089999,
							28.51568565900004
						],
						[
							-81.31869938799991,
							28.515467352000087
						],
						[
							-81.31870118899991,
							28.515357443000084
						],
						[
							-81.31864599999994,
							28.51535800000005
						],
						[
							-81.31842728499993,
							28.51536006300006
						],
						[
							-81.31843575099992,
							28.51482519500007
						],
						[
							-81.31840056499993,
							28.51141700800008
						],
						[
							-81.32494853799994,
							28.511417005000055
						],
						[
							-81.32505644399993,
							28.513225959000067
						],
						[
							-81.32679328099994,
							28.513154845000088
						],
						[
							-81.32672090499995,
							28.51047761600006
						],
						[
							-81.33101048899994,
							28.510476730000054
						],
						[
							-81.33102041399991,
							28.511277936000056
						],
						[
							-81.33101440599995,
							28.511422149000058
						],
						[
							-81.33098936899995,
							28.511911875000067
						],
						[
							-81.33097434599995,
							28.513249860000087
						],
						[
							-81.33097134099995,
							28.51330394000007
						],
						[
							-81.33096733699995,
							28.513337988000046
						],
						[
							-81.3309983819999,
							28.513807687000053
						],
						[
							-81.33101039899992,
							28.51434247900005
						],
						[
							-81.3310324329999,
							28.514763104000053
						],
						[
							-81.3310324329999,
							28.515381020000063
						],
						[
							-81.33104144599992,
							28.516845192000062
						],
						[
							-81.33104244799995,
							28.517062514000088
						],
						[
							-81.33104645399993,
							28.517757545000055
						],
						[
							-81.33105045999991,
							28.518206211000066
						],
						[
							-81.3310514609999,
							28.51843755400006
						],
						[
							-81.33105459299992,
							28.51866401500007
						],
						[
							-81.32896339199993,
							28.518634793000047
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Mariners Village",
				"RegionID": "274424"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.50599022493002,
					27.954952801625176,
					-82.4848201474881,
					27.974145448889793
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.48489090884337,
							27.96680000059316
						],
						[
							-82.48499999840412,
							27.956354545194657
						],
						[
							-82.501736363383,
							27.956390908381607
						],
						[
							-82.50271818112131,
							27.95619999940196
						],
						[
							-82.50561817990305,
							27.955199999170716
						],
						[
							-82.50599016107816,
							27.954952801625176
						],
						[
							-82.50599022493002,
							27.95498988067247
						],
						[
							-82.50593324568489,
							27.96733885007135
						],
						[
							-82.5056909116729,
							27.974145448889793
						],
						[
							-82.4889302407176,
							27.974016734323676
						],
						[
							-82.4848201474881,
							27.97399037339637
						],
						[
							-82.48495196021861,
							27.97333377028893
						],
						[
							-82.48489090884337,
							27.96680000059316
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Northeast Macfarlane",
				"RegionID": "274774"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.41420526483556,
					27.97816795984479,
					-82.40167552811148,
					27.997941999915575
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.4018059999529,
							27.985162999903352
						],
						[
							-82.40179300025292,
							27.982517000239532
						],
						[
							-82.40167552811148,
							27.981947994694988
						],
						[
							-82.40200901650509,
							27.982106591034245
						],
						[
							-82.40226379983189,
							27.982227174829816
						],
						[
							-82.4022601009204,
							27.982735329547943
						],
						[
							-82.40922659649769,
							27.97816795984479
						],
						[
							-82.41420526483556,
							27.978168146903872
						],
						[
							-82.41419812331938,
							27.987535020211524
						],
						[
							-82.41419751987426,
							27.9879534891409
						],
						[
							-82.41419645597631,
							27.98930694990925
						],
						[
							-82.414190908958,
							27.996363635794836
						],
						[
							-82.40185993589226,
							27.996399524139758
						],
						[
							-82.40188181909515,
							27.99749090897897
						],
						[
							-82.40187000020511,
							27.997941999915575
						],
						[
							-82.40182199979107,
							27.9960899999803
						],
						[
							-82.40171800039299,
							27.99481799980142
						],
						[
							-82.4017310000929,
							27.994470999993688
						],
						[
							-82.40174818793551,
							27.994219467716015
						],
						[
							-82.40182399988325,
							27.993110000208816
						],
						[
							-82.40182499992933,
							27.992757000124456
						],
						[
							-82.40182399988325,
							27.992532999691406
						],
						[
							-82.40182700002161,
							27.992420999924526
						],
						[
							-82.40183352100563,
							27.992152532513643
						],
						[
							-82.4019149995815,
							27.988798000190528
						],
						[
							-82.4019149995815,
							27.987349999992468
						],
						[
							-82.4019149995815,
							27.986997999954284
						],
						[
							-82.4018059999529,
							27.985162999903352
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Northview Hills",
				"RegionID": "274794"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.34547384899992,
					28.538263957000083,
					-81.31455301299991,
					28.552466163000076
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.33815086599992,
							28.552466163000076
						],
						[
							-81.33804896299995,
							28.55134220800005
						],
						[
							-81.32037593799993,
							28.551410763000035
						],
						[
							-81.31921568299992,
							28.55141526400007
						],
						[
							-81.31921683199994,
							28.55141331200008
						],
						[
							-81.31924383199993,
							28.55136831100009
						],
						[
							-81.31926724099992,
							28.551331363000088
						],
						[
							-81.31930151899991,
							28.551283527000066
						],
						[
							-81.31933885299993,
							28.55123803500004
						],
						[
							-81.31937908299994,
							28.55119508300004
						],
						[
							-81.31942203499996,
							28.55115485400006
						],
						[
							-81.31946752699992,
							28.551117520000048
						],
						[
							-81.31946811099994,
							28.551117072000068
						],
						[
							-81.31946802399995,
							28.551113972000053
						],
						[
							-81.31946767799991,
							28.55108900000005
						],
						[
							-81.31946771499992,
							28.551080848000083
						],
						[
							-81.31943716399991,
							28.55103166100008
						],
						[
							-81.31942437099991,
							28.551008736000085
						],
						[
							-81.31937263599991,
							28.550912764000092
						],
						[
							-81.31922643099995,
							28.550687292000077
						],
						[
							-81.31920216399993,
							28.550647661000085
						],
						[
							-81.31917442199995,
							28.55059576000008
						],
						[
							-81.31915013499992,
							28.550542156000063
						],
						[
							-81.31915003699993,
							28.550541921000047
						],
						[
							-81.31912865599992,
							28.55049026100005
						],
						[
							-81.31911733899994,
							28.55048383500008
						],
						[
							-81.31906736299993,
							28.550452759000052
						],
						[
							-81.31901952699991,
							28.550418480000076
						],
						[
							-81.31897403499994,
							28.550381146000067
						],
						[
							-81.31893108299994,
							28.55034091600004
						],
						[
							-81.3188908539999,
							28.550297964000038
						],
						[
							-81.3188535189999,
							28.550252472000068
						],
						[
							-81.31881924099991,
							28.550204636000046
						],
						[
							-81.31881871699994,
							28.55020385100005
						],
						[
							-81.31877671799992,
							28.550140852000084
						],
						[
							-81.31874635299994,
							28.550091965000036
						],
						[
							-81.31872708299994,
							28.550073917000077
						],
						[
							-81.3186868539999,
							28.550030964000086
						],
						[
							-81.31864951999995,
							28.54998547300005
						],
						[
							-81.31863914899992,
							28.549971000000085
						],
						[
							-81.31918499999995,
							28.549971000000085
						],
						[
							-81.31918887099994,
							28.549048229000054
						],
						[
							-81.31918999999994,
							28.54877900000008
						],
						[
							-81.31918999999994,
							28.546838000000037
						],
						[
							-81.31918999999994,
							28.546381000000054
						],
						[
							-81.3186536529999,
							28.546381000000054
						],
						[
							-81.3186490679999,
							28.546107589000087
						],
						[
							-81.31865721399993,
							28.54254517200008
						],
						[
							-81.31463498499994,
							28.542545439000037
						],
						[
							-81.31455301299991,
							28.53971401800004
						],
						[
							-81.31480937299995,
							28.53973413700004
						],
						[
							-81.31579796799991,
							28.539813389000074
						],
						[
							-81.31579871199995,
							28.53971397600009
						],
						[
							-81.31650288399993,
							28.539714108000055
						],
						[
							-81.31701276899992,
							28.53980635100004
						],
						[
							-81.3169644269999,
							28.539683962000083
						],
						[
							-81.31759850999993,
							28.539714107000066
						],
						[
							-81.31853703399992,
							28.53973801500007
						],
						[
							-81.31853289399993,
							28.539903389000077
						],
						[
							-81.31853075999993,
							28.539963605000082
						],
						[
							-81.31892948399991,
							28.539972490000082
						],
						[
							-81.3192579709999,
							28.53996247500004
						],
						[
							-81.3196545589999,
							28.53995045800008
						],
						[
							-81.32055589499993,
							28.539894375000074
						],
						[
							-81.32094847699994,
							28.539858322000043
						],
						[
							-81.32192893099995,
							28.539764182000056
						],
						[
							-81.32271411999994,
							28.539659077000067
						],
						[
							-81.32330797599991,
							28.539579909000054
						],
						[
							-81.32468501799991,
							28.539364590000048
						],
						[
							-81.32502555299993,
							28.539298541000054
						],
						[
							-81.32559236499992,
							28.539190331000043
						],
						[
							-81.3265147329999,
							28.53898102100004
						],
						[
							-81.32694036399995,
							28.538870856000074
						],
						[
							-81.32747615799991,
							28.538750678000042
						],
						[
							-81.32786673799991,
							28.538650531000087
						],
						[
							-81.32849366699992,
							28.538567406000084
						],
						[
							-81.32925078999995,
							28.53849329700006
						],
						[
							-81.32971547999995,
							28.538462250000066
						],
						[
							-81.32997786899995,
							28.53845223600007
						],
						[
							-81.33026329199993,
							28.53844322200007
						],
						[
							-81.3311325809999,
							28.538449231000072
						],
						[
							-81.33122385799993,
							28.538449332000084
						],
						[
							-81.3312016079999,
							28.538382179000052
						],
						[
							-81.33386363199992,
							28.538376123000035
						],
						[
							-81.33401886099995,
							28.538376123000035
						],
						[
							-81.33440843999995,
							28.53837512100006
						],
						[
							-81.33501699999995,
							28.538373000000036
						],
						[
							-81.3359187989999,
							28.538355978000084
						],
						[
							-81.3359173959999,
							28.53839881900007
						],
						[
							-81.33591562799995,
							28.53842142500008
						],
						[
							-81.3359126279999,
							28.538454425000054
						],
						[
							-81.33591245699995,
							28.538456283000073
						],
						[
							-81.33590845799995,
							28.53849928300008
						],
						[
							-81.33590462799992,
							28.53853338500005
						],
						[
							-81.33589504199995,
							28.538591449000084
						],
						[
							-81.3358816789999,
							28.538648762000037
						],
						[
							-81.33586459499992,
							28.538705078000078
						],
						[
							-81.3358438649999,
							28.538760156000084
						],
						[
							-81.33581957799993,
							28.53881376000004
						],
						[
							-81.33581472999992,
							28.53882344300007
						],
						[
							-81.33578596099994,
							28.53888005300007
						],
						[
							-81.33574314399993,
							28.53896663800009
						],
						[
							-81.3357158359999,
							28.53901766100006
						],
						[
							-81.33568475899995,
							28.539067636000084
						],
						[
							-81.3356504809999,
							28.53911547200005
						],
						[
							-81.3356131459999,
							28.53916096400008
						],
						[
							-81.33557291699992,
							28.53920391700007
						],
						[
							-81.33550991699991,
							28.539266917000077
						],
						[
							-81.33546696399992,
							28.539307146000056
						],
						[
							-81.33542147299994,
							28.539344480000068
						],
						[
							-81.33537363699992,
							28.539378759000044
						],
						[
							-81.3353236609999,
							28.53940983600006
						],
						[
							-81.3352717599999,
							28.539437577000058
						],
						[
							-81.33521815599994,
							28.539461865000078
						],
						[
							-81.33516307799994,
							28.539482595000038
						],
						[
							-81.33510676199995,
							28.539499678000084
						],
						[
							-81.33509471399992,
							28.539502817000084
						],
						[
							-81.3350192819999,
							28.53952191400009
						],
						[
							-81.33498084299993,
							28.539531981000042
						],
						[
							-81.3349284489999,
							28.539544041000056
						],
						[
							-81.33487038499993,
							28.539553628000082
						],
						[
							-81.33483256199992,
							28.539557795000064
						],
						[
							-81.33452856199995,
							28.539584796000042
						],
						[
							-81.33450781899995,
							28.53958639700005
						],
						[
							-81.33444899999995,
							28.539588322000043
						],
						[
							-81.33441467999995,
							28.539587667000035
						],
						[
							-81.33377238399993,
							28.539563138000062
						],
						[
							-81.33336321399992,
							28.539606499000058
						],
						[
							-81.3331149469999,
							28.539658666000037
						],
						[
							-81.33307672999992,
							28.53969584400005
						],
						[
							-81.33301893499993,
							28.539764309000077
						],
						[
							-81.33293876499994,
							28.53989488800005
						],
						[
							-81.33293175799992,
							28.539908310000044
						],
						[
							-81.33293865199994,
							28.540026585000078
						],
						[
							-81.33294216399992,
							28.540034019000075
						],
						[
							-81.3336776569999,
							28.540587342000038
						],
						[
							-81.33368447299995,
							28.540592520000075
						],
						[
							-81.33368920799991,
							28.54059617900009
						],
						[
							-81.33424107999991,
							28.541025509000065
						],
						[
							-81.33447625799994,
							28.541132796000056
						],
						[
							-81.33447967599994,
							28.541134364000076
						],
						[
							-81.3349478209999,
							28.541350297000065
						],
						[
							-81.33504975999995,
							28.541352992000043
						],
						[
							-81.33508481799993,
							28.54135460300006
						],
						[
							-81.33514338499992,
							28.541360371000057
						],
						[
							-81.33517305499993,
							28.541364782000073
						],
						[
							-81.33535405499993,
							28.541394783000044
						],
						[
							-81.33538244899995,
							28.541399958000056
						],
						[
							-81.33541221899992,
							28.54140640600008
						],
						[
							-81.33560421899995,
							28.54145140600008
						],
						[
							-81.33563176199993,
							28.54145832200004
						],
						[
							-81.33568807799992,
							28.541475405000085
						],
						[
							-81.33574315599992,
							28.541496135000045
						],
						[
							-81.33579675999994,
							28.541520423000065
						],
						[
							-81.3358025679999,
							28.541523313000084
						],
						[
							-81.33603556799994,
							28.541640313000073
						],
						[
							-81.33608166099992,
							28.54166516500004
						],
						[
							-81.33613163699994,
							28.541696241000068
						],
						[
							-81.33613862199991,
							28.541700956000057
						],
						[
							-81.33616097799995,
							28.541716199000064
						],
						[
							-81.33617655099994,
							28.541712958000062
						],
						[
							-81.33623461499991,
							28.541703372000086
						],
						[
							-81.33629318099993,
							28.541697604000035
						],
						[
							-81.33635199999992,
							28.541695678000053
						],
						[
							-81.33641081799993,
							28.541697604000035
						],
						[
							-81.33646938499993,
							28.541703372000086
						],
						[
							-81.3365274489999,
							28.541712958000062
						],
						[
							-81.33658476199992,
							28.541726322000045
						],
						[
							-81.3366410779999,
							28.54174340500009
						],
						[
							-81.3366961559999,
							28.54176413500005
						],
						[
							-81.33674975999992,
							28.541788423000074
						],
						[
							-81.33676258999992,
							28.541794878000076
						],
						[
							-81.3368385899999,
							28.54183387800009
						],
						[
							-81.3368776609999,
							28.541855164000083
						],
						[
							-81.33689346599994,
							28.54186499300005
						],
						[
							-81.33693523799991,
							28.541852321000082
						],
						[
							-81.33697957599992,
							28.54184163800005
						],
						[
							-81.33702157599994,
							28.541832639000063
						],
						[
							-81.33703455099993,
							28.54182995800005
						],
						[
							-81.3370926149999,
							28.541820372000075
						],
						[
							-81.33715118099991,
							28.54181460400008
						],
						[
							-81.33720999999991,
							28.541812678000042
						],
						[
							-81.33726881799993,
							28.54181460400008
						],
						[
							-81.33732738499992,
							28.541820372000075
						],
						[
							-81.33733008099995,
							28.541820731000087
						],
						[
							-81.33786642799993,
							28.541613905000077
						],
						[
							-81.33789686999995,
							28.54160279100006
						],
						[
							-81.33850180199995,
							28.54139422600008
						],
						[
							-81.33869789499994,
							28.541307407000094
						],
						[
							-81.33870042199993,
							28.54130224000005
						],
						[
							-81.33872816399992,
							28.541250339000044
						],
						[
							-81.33875924099993,
							28.541200364000076
						],
						[
							-81.33879351999991,
							28.541152528000058
						],
						[
							-81.33883085399992,
							28.541107036000085
						],
						[
							-81.3388399509999,
							28.541096820000064
						],
						[
							-81.33890202299995,
							28.541028175000065
						],
						[
							-81.33892231599992,
							28.541001983000058
						],
						[
							-81.33895146499992,
							28.540948240000038
						],
						[
							-81.33896316399995,
							28.540927339000064
						],
						[
							-81.33899424099991,
							28.54087736300005
						],
						[
							-81.33902851999994,
							28.540829527000085
						],
						[
							-81.3390658539999,
							28.540784036000048
						],
						[
							-81.33910608299993,
							28.540741083000057
						],
						[
							-81.33911713999993,
							28.540730215000053
						],
						[
							-81.3392351409999,
							28.540616215000057
						],
						[
							-81.33926703599991,
							28.540586854000082
						],
						[
							-81.33931252699995,
							28.540549520000074
						],
						[
							-81.33932195999995,
							28.54054238000009
						],
						[
							-81.33942760499991,
							28.540374075000045
						],
						[
							-81.33954331299994,
							28.540155328000083
						],
						[
							-81.33965494599994,
							28.539929618000087
						],
						[
							-81.33970712999991,
							28.539790716000084
						],
						[
							-81.33971813499994,
							28.53976284400005
						],
						[
							-81.3397424229999,
							28.539709240000036
						],
						[
							-81.3397701639999,
							28.539657339000087
						],
						[
							-81.33977365499993,
							28.53965134500004
						],
						[
							-81.33979592199995,
							28.539613457000087
						],
						[
							-81.33977623899996,
							28.539608678000036
						],
						[
							-81.3397199229999,
							28.539591595000047
						],
						[
							-81.3396648449999,
							28.539570865000087
						],
						[
							-81.3396112399999,
							28.539546577000067
						],
						[
							-81.33955933899995,
							28.53951883500008
						],
						[
							-81.33950936399992,
							28.539487759000053
						],
						[
							-81.3394615279999,
							28.53945348000008
						],
						[
							-81.33941603599993,
							28.539416146000065
						],
						[
							-81.33937308399993,
							28.53937591600004
						],
						[
							-81.33935411699991,
							28.53935636700004
						],
						[
							-81.3392901169999,
							28.53928836700004
						],
						[
							-81.3392688539999,
							28.53926496400004
						],
						[
							-81.33923151999994,
							28.53921947300006
						],
						[
							-81.33919724099991,
							28.539171637000038
						],
						[
							-81.33916616399995,
							28.53912166100008
						],
						[
							-81.33913842299995,
							28.539069760000075
						],
						[
							-81.33911413499993,
							28.53901615600006
						],
						[
							-81.33909340499991,
							28.538961078000057
						],
						[
							-81.33907632199993,
							28.538904762000072
						],
						[
							-81.33906797999992,
							28.53887103800008
						],
						[
							-81.33903597999996,
							28.53873003800004
						],
						[
							-81.3390309589999,
							28.538706449000074
						],
						[
							-81.33902137199993,
							28.538648385000045
						],
						[
							-81.33901560399994,
							28.538589818000048
						],
						[
							-81.3390136779999,
							28.538531000000035
						],
						[
							-81.3390136779999,
							28.538467000000082
						],
						[
							-81.33901560399994,
							28.53840818100008
						],
						[
							-81.33902137199993,
							28.538349615000072
						],
						[
							-81.3390264279999,
							28.538316102000067
						],
						[
							-81.33902963499992,
							28.538297259000046
						],
						[
							-81.33994399999995,
							28.538280000000043
						],
						[
							-81.34137376799993,
							28.538263957000083
						],
						[
							-81.3416322519999,
							28.538277819000086
						],
						[
							-81.3416922429999,
							28.538395152000078
						],
						[
							-81.34171721199993,
							28.538426379000043
						],
						[
							-81.34184055399993,
							28.53840400100006
						],
						[
							-81.3418673939999,
							28.53847542500006
						],
						[
							-81.34355700799995,
							28.53846224900008
						],
						[
							-81.34355800899993,
							28.53873966200007
						],
						[
							-81.3435600119999,
							28.53927946200008
						],
						[
							-81.34359005699991,
							28.54056336600007
						],
						[
							-81.34360708199995,
							28.542386071000067
						],
						[
							-81.3436251089999,
							28.54329742100009
						],
						[
							-81.34364313499992,
							28.54420576800004
						],
						[
							-81.34365515299993,
							28.545121127000073
						],
						[
							-81.34366116099994,
							28.545670941000083
						],
						[
							-81.34367518499994,
							28.545813155000076
						],
						[
							-81.34370310799994,
							28.54590034800009
						],
						[
							-81.34375221199991,
							28.545962476000057
						],
						[
							-81.3438013679999,
							28.54598941200004
						],
						[
							-81.34387447599994,
							28.54601144500009
						],
						[
							-81.34401168199992,
							28.546026469000083
						],
						[
							-81.3454529519999,
							28.546011311000086
						],
						[
							-81.34547384899992,
							28.54824375800007
						],
						[
							-81.34538462899991,
							28.54950260600009
						],
						[
							-81.34537177999994,
							28.54967390300004
						],
						[
							-81.3447247389999,
							28.55079754500008
						],
						[
							-81.34452054199994,
							28.551309459000038
						],
						[
							-81.34343068599992,
							28.551309435000064
						],
						[
							-81.34346500399994,
							28.550490959000058
						],
						[
							-81.33947883399992,
							28.55056004900007
						],
						[
							-81.3393098329999,
							28.552466162000087
						],
						[
							-81.33815086599992,
							28.552466163000076
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Orlando Executive Airport",
				"RegionID": "274925"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.49754734025622,
					27.930246925411183,
					-82.47875316549575,
					27.937599944200763
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.48873820488743,
							27.9305327776162
						],
						[
							-82.49348813336516,
							27.930246925411183
						],
						[
							-82.49341852404143,
							27.933812170684497
						],
						[
							-82.49754734025622,
							27.933862878057823
						],
						[
							-82.49750139839036,
							27.9375737100778
						],
						[
							-82.4933909085598,
							27.937599944200763
						],
						[
							-82.47875316549575,
							27.937401723732897
						],
						[
							-82.48316376538267,
							27.932190846849757
						],
						[
							-82.48442684158906,
							27.930783812568755
						],
						[
							-82.4861057795903,
							27.93068612461272
						],
						[
							-82.48873820488743,
							27.9305327776162
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Parkland Estates",
				"RegionID": "274976"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.07006016999992,
					26.676005632000056,
					-80.06051708799994,
					26.690758904000063
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.0607357319999,
							26.67958643700007
						],
						[
							-80.06074421199992,
							26.679255743000056
						],
						[
							-80.06074999999993,
							26.67903000000007
						],
						[
							-80.06075453499994,
							26.678671699000063
						],
						[
							-80.0607599999999,
							26.678240000000073
						],
						[
							-80.06076742199991,
							26.677859006000062
						],
						[
							-80.06077385299994,
							26.677528872000043
						],
						[
							-80.06077831499994,
							26.67729982300006
						],
						[
							-80.06078474599991,
							26.67696968900009
						],
						[
							-80.06078999999994,
							26.67670000000004
						],
						[
							-80.06078999999994,
							26.67648690200008
						],
						[
							-80.06079999999992,
							26.676300000000083
						],
						[
							-80.06081432099995,
							26.676005632000056
						],
						[
							-80.06099999899993,
							26.676010001000066
						],
						[
							-80.06280163999992,
							26.676057035000042
						],
						[
							-80.06280554599994,
							26.676111510000055
						],
						[
							-80.06279547999992,
							26.67625484200005
						],
						[
							-80.06279999999992,
							26.67635000000007
						],
						[
							-80.06279999999992,
							26.67647761900008
						],
						[
							-80.06279999999992,
							26.676580000000058
						],
						[
							-80.06279999999992,
							26.67663675500006
						],
						[
							-80.06279999999992,
							26.676740000000052
						],
						[
							-80.06279492999994,
							26.67731295400006
						],
						[
							-80.0627835109999,
							26.677718863000052
						],
						[
							-80.06278999999995,
							26.67787000000004
						],
						[
							-80.06278348399991,
							26.678283779000083
						],
						[
							-80.06277859599993,
							26.678594143000055
						],
						[
							-80.06277471499993,
							26.678840618000038
						],
						[
							-80.06277375499991,
							26.678912110000056
						],
						[
							-80.06276999999994,
							26.679140000000075
						],
						[
							-80.06284946099993,
							26.679141987000037
						],
						[
							-80.06297358199993,
							26.679145090000077
						],
						[
							-80.0631041179999,
							26.679148353000073
						],
						[
							-80.0632870039999,
							26.67915307900006
						],
						[
							-80.06343027799994,
							26.67915910100004
						],
						[
							-80.0635499999999,
							26.67916000000008
						],
						[
							-80.06359298399991,
							26.679194387000052
						],
						[
							-80.06365935299993,
							26.679219784000054
						],
						[
							-80.06373262499994,
							26.67923114200005
						],
						[
							-80.06381216599993,
							26.679232115000048
						],
						[
							-80.06410655999991,
							26.67924035400006
						],
						[
							-80.06433734899991,
							26.67924681400007
						],
						[
							-80.0645840329999,
							26.679253947000063
						],
						[
							-80.0647194149999,
							26.679257574000076
						],
						[
							-80.06480999999991,
							26.67926000000006
						],
						[
							-80.06502957599993,
							26.679263819000084
						],
						[
							-80.06519666899995,
							26.679271252000035
						],
						[
							-80.06562629399991,
							26.67927419600005
						],
						[
							-80.06576165799993,
							26.679276551000044
						],
						[
							-80.06589688299994,
							26.67927890200008
						],
						[
							-80.06599084099992,
							26.679272290000085
						],
						[
							-80.06602579499992,
							26.679248504000043
						],
						[
							-80.06605999999994,
							26.679220000000043
						],
						[
							-80.06617537199992,
							26.679222997000068
						],
						[
							-80.0663902679999,
							26.67922857800005
						],
						[
							-80.06655724799992,
							26.679232916000046
						],
						[
							-80.06671648399993,
							26.679237052000076
						],
						[
							-80.06682999999992,
							26.67924000000005
						],
						[
							-80.06689934899993,
							26.679242050000084
						],
						[
							-80.06702654599991,
							26.679245809000065
						],
						[
							-80.06723347799993,
							26.679251925000074
						],
						[
							-80.06741655999991,
							26.67925733700008
						],
						[
							-80.06760759199994,
							26.679262983000058
						],
						[
							-80.06785403799995,
							26.67927026700005
						],
						[
							-80.06814841799991,
							26.679278968000062
						],
						[
							-80.06837163599994,
							26.67928728100009
						],
						[
							-80.06853067299994,
							26.67929126000007
						],
						[
							-80.0687135629999,
							26.67929567200008
						],
						[
							-80.06880103599991,
							26.679298023000058
						],
						[
							-80.06889665399991,
							26.67930032000004
						],
						[
							-80.0698995429999,
							26.67930032000004
						],
						[
							-80.06991406399993,
							26.679462579000074
						],
						[
							-80.06991999899992,
							26.679530000000057
						],
						[
							-80.0699699999999,
							26.68014000100004
						],
						[
							-80.07002999999992,
							26.680840001000035
						],
						[
							-80.07005999899991,
							26.68124000100005
						],
						[
							-80.0700599999999,
							26.681920000000048
						],
						[
							-80.0700599999999,
							26.682340000000067
						],
						[
							-80.0700599999999,
							26.683040000000062
						],
						[
							-80.07006016999992,
							26.68424004700006
						],
						[
							-80.06825991999995,
							26.687139956000067
						],
						[
							-80.0682399989999,
							26.687180000000073
						],
						[
							-80.0678599499999,
							26.687939982000046
						],
						[
							-80.06745986699991,
							26.689940000000036
						],
						[
							-80.06764484999991,
							26.69075145900007
						],
						[
							-80.06745948699995,
							26.690753914000084
						],
						[
							-80.06725018399993,
							26.690756686000046
						],
						[
							-80.06708271899993,
							26.690758904000063
						],
						[
							-80.06691613699991,
							26.69075354900008
						],
						[
							-80.0668404569999,
							26.690748359000054
						],
						[
							-80.06673106599993,
							26.69074228100004
						],
						[
							-80.0667051129999,
							26.69074111100008
						],
						[
							-80.06660550399994,
							26.690736620000052
						],
						[
							-80.06648016799994,
							26.69073160700009
						],
						[
							-80.06633811899991,
							26.690725925000038
						],
						[
							-80.06611184799993,
							26.69071699400007
						],
						[
							-80.06605334999995,
							26.690714744000047
						],
						[
							-80.06583575199994,
							26.690706375000048
						],
						[
							-80.0656699999999,
							26.69070000000005
						],
						[
							-80.0655676209999,
							26.690693700000054
						],
						[
							-80.06536751899996,
							26.69068138600005
						],
						[
							-80.06510020299993,
							26.690664936000076
						],
						[
							-80.06472193299993,
							26.69064165700007
						],
						[
							-80.06444679299995,
							26.690624726000067
						],
						[
							-80.06432334699991,
							26.69060444900009
						],
						[
							-80.06421999999992,
							26.690570000000037
						],
						[
							-80.06406984699993,
							26.690566338000053
						],
						[
							-80.06375200899993,
							26.690558586000066
						],
						[
							-80.0632415899999,
							26.690546136000084
						],
						[
							-80.0627809479999,
							26.690534901000035
						],
						[
							-80.06257938899995,
							26.69052977800004
						],
						[
							-80.06257938999994,
							26.690529653000056
						],
						[
							-80.0622877269999,
							26.690521767000064
						],
						[
							-80.06166981199993,
							26.69050309700009
						],
						[
							-80.06115725399991,
							26.690488035000044
						],
						[
							-80.0607652089999,
							26.690476940000053
						],
						[
							-80.06051999999994,
							26.69047000000006
						],
						[
							-80.06051708799994,
							26.690469928000084
						],
						[
							-80.06053127899992,
							26.690229935000048
						],
						[
							-80.0605431489999,
							26.689950990000057
						],
						[
							-80.06054999999992,
							26.689790000000073
						],
						[
							-80.06055462299992,
							26.689417871000046
						],
						[
							-80.06056219599992,
							26.688808256000073
						],
						[
							-80.06056630099994,
							26.68847773200008
						],
						[
							-80.06056999999993,
							26.688180000000045
						],
						[
							-80.06057449699995,
							26.68784271800007
						],
						[
							-80.0605799999999,
							26.687430000000063
						],
						[
							-80.0605869979999,
							26.687157092000064
						],
						[
							-80.06059547699994,
							26.68682639900004
						],
						[
							-80.06059999999991,
							26.686650000000043
						],
						[
							-80.06060573699995,
							26.686446319000083
						],
						[
							-80.06061435799995,
							26.68614027600006
						],
						[
							-80.06061999999991,
							26.685940000000073
						],
						[
							-80.06061999999991,
							26.68587000000008
						],
						[
							-80.06063197499992,
							26.685708893000083
						],
						[
							-80.06063622599993,
							26.68555587800006
						],
						[
							-80.06063999999992,
							26.68542000000008
						],
						[
							-80.06064999999995,
							26.685140000000047
						],
						[
							-80.06064999999995,
							26.684960000000046
						],
						[
							-80.06065556999994,
							26.684692639000048
						],
						[
							-80.06065999999993,
							26.684480000000065
						],
						[
							-80.06065999999993,
							26.684330000000045
						],
						[
							-80.06065999999993,
							26.684159081000075
						],
						[
							-80.06065999999993,
							26.684010000000058
						],
						[
							-80.06066679399993,
							26.683853740000075
						],
						[
							-80.06067451099995,
							26.683676243000036
						],
						[
							-80.06067999999993,
							26.683550000000082
						],
						[
							-80.06067999999993,
							26.683295325000074
						],
						[
							-80.06067999999993,
							26.683130000000062
						],
						[
							-80.06067999999993,
							26.68291425700005
						],
						[
							-80.06068999999991,
							26.682770000000062
						],
						[
							-80.06068999999991,
							26.682355356000073
						],
						[
							-80.06068999999991,
							26.682030000000054
						],
						[
							-80.0606970799999,
							26.681771575000084
						],
						[
							-80.06070264399995,
							26.681568491000064
						],
						[
							-80.06070999999991,
							26.68130000000008
						],
						[
							-80.06071293699995,
							26.681085607000057
						],
						[
							-80.0607167739999,
							26.680805513000053
						],
						[
							-80.06071999999995,
							26.680570000000046
						],
						[
							-80.06072391999993,
							26.68027211800006
						],
						[
							-80.06072999999992,
							26.67981000000009
						],
						[
							-80.0607357319999,
							26.67958643700007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "West Palm Beach",
				"Name": "Poinciana Park",
				"RegionID": "275062"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.63822999999991,
					27.70883239200009,
					-82.63017975999992,
					27.71962540000004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.63053701099994,
							27.719188590000044
						],
						[
							-82.63044894199993,
							27.719082106000087
						],
						[
							-82.6303631639999,
							27.718958661000045
						],
						[
							-82.63029696599995,
							27.71881673000007
						],
						[
							-82.63023393999993,
							27.718643658000076
						],
						[
							-82.63019334099994,
							27.71849216600009
						],
						[
							-82.63017975999992,
							27.71832742500004
						],
						[
							-82.63018684199994,
							27.717951849000087
						],
						[
							-82.63019856699992,
							27.71782325500004
						],
						[
							-82.63061456699995,
							27.71529025500007
						],
						[
							-82.63062059099991,
							27.71525740000004
						],
						[
							-82.63126759099993,
							27.71206439900004
						],
						[
							-82.6312821169999,
							27.712003635000087
						],
						[
							-82.63139311799995,
							27.71160163600007
						],
						[
							-82.63142952899994,
							27.711495894000056
						],
						[
							-82.63161652899993,
							27.71104589400005
						],
						[
							-82.63165872699994,
							27.71095809500008
						],
						[
							-82.63185972799994,
							27.710592096000084
						],
						[
							-82.63189329999994,
							27.71053591100008
						],
						[
							-82.6321602999999,
							27.71012391100004
						],
						[
							-82.6322260789999,
							27.710034927000038
						],
						[
							-82.63232124199993,
							27.709937551000053
						],
						[
							-82.63266024299992,
							27.709639551000066
						],
						[
							-82.63273106299994,
							27.709583347000034
						],
						[
							-82.63305006199994,
							27.70935534700004
						],
						[
							-82.63316420899991,
							27.70928595700008
						],
						[
							-82.63350320899991,
							27.70911295700006
						],
						[
							-82.63362835399994,
							27.709060581000074
						],
						[
							-82.63397135399993,
							27.708946580000088
						],
						[
							-82.63409902899991,
							27.708914306000057
						],
						[
							-82.63441702899992,
							27.70885830600008
						],
						[
							-82.6345371669999,
							27.708845392000057
						],
						[
							-82.63486316599995,
							27.70883239200009
						],
						[
							-82.63500645699992,
							27.708838121000042
						],
						[
							-82.63546345799995,
							27.708893121000074
						],
						[
							-82.63555746299994,
							27.708909534000043
						],
						[
							-82.63595368599994,
							27.709000609000043
						],
						[
							-82.63605212899995,
							27.709017217000053
						],
						[
							-82.63660595799992,
							27.70972875600006
						],
						[
							-82.6369699999999,
							27.71037000000007
						],
						[
							-82.63758499999994,
							27.71036500000008
						],
						[
							-82.63797239799993,
							27.710361850000083
						],
						[
							-82.63819999999993,
							27.710360000000037
						],
						[
							-82.63819999999993,
							27.710575085000073
						],
						[
							-82.63819999999993,
							27.71084000000008
						],
						[
							-82.63820773099991,
							27.711002342000086
						],
						[
							-82.63821999999993,
							27.71126000000004
						],
						[
							-82.63821723299992,
							27.711514544000067
						],
						[
							-82.6382129019999,
							27.711912976000068
						],
						[
							-82.6382099999999,
							27.712180000000046
						],
						[
							-82.6382125639999,
							27.712410797000075
						],
						[
							-82.63821714999995,
							27.71282345600008
						],
						[
							-82.63821999999993,
							27.713080000000048
						],
						[
							-82.63821999999993,
							27.713293282000052
						],
						[
							-82.63821999999993,
							27.713520000000074
						],
						[
							-82.63822469099995,
							27.71376231800008
						],
						[
							-82.6382278129999,
							27.71389032400009
						],
						[
							-82.63822999999991,
							27.71398000000005
						],
						[
							-82.63822999999991,
							27.714246785000057
						],
						[
							-82.63822999999991,
							27.714502950000053
						],
						[
							-82.63822999999991,
							27.71477334700006
						],
						[
							-82.63822999999991,
							27.71494000000007
						],
						[
							-82.63822999999991,
							27.71514336300004
						],
						[
							-82.63822999999991,
							27.715413759000057
						],
						[
							-82.63822999999991,
							27.71581000000009
						],
						[
							-82.63822999999991,
							27.716025709000064
						],
						[
							-82.63822999999991,
							27.71626000000009
						],
						[
							-82.63822999999991,
							27.71666612200005
						],
						[
							-82.63822999999991,
							27.716893824000067
						],
						[
							-82.63822999999991,
							27.71712000000008
						],
						[
							-82.63822999999991,
							27.71742038600007
						],
						[
							-82.63822999999991,
							27.71771924500007
						],
						[
							-82.6381536589999,
							27.71764614500006
						],
						[
							-82.63683393999992,
							27.717661717000055
						],
						[
							-82.63603977299994,
							27.71767728900005
						],
						[
							-82.63605923799992,
							27.718623282000067
						],
						[
							-82.6350367039999,
							27.718634945000076
						],
						[
							-82.63448460299992,
							27.71934555300004
						],
						[
							-82.63444395599993,
							27.719311618000063
						],
						[
							-82.6344284079999,
							27.71929866100004
						],
						[
							-82.63417830999992,
							27.719189209000035
						],
						[
							-82.63400693699992,
							27.719155322000063
						],
						[
							-82.63383920599995,
							27.719155322000063
						],
						[
							-82.63342692999993,
							27.719168351000064
						],
						[
							-82.63305452399993,
							27.719193846000053
						],
						[
							-82.63268680999994,
							27.71923563200005
						],
						[
							-82.63251544899992,
							27.71929390400004
						],
						[
							-82.63215091799992,
							27.71950468700004
						],
						[
							-82.6320819629999,
							27.71954064600004
						],
						[
							-82.63201015899995,
							27.719570512000075
						],
						[
							-82.63193604399993,
							27.719594064000034
						],
						[
							-82.63186017099991,
							27.71961112400004
						],
						[
							-82.63178310699993,
							27.719621566000058
						],
						[
							-82.6317054299999,
							27.719625311000076
						],
						[
							-82.63168739399993,
							27.71962540000004
						],
						[
							-82.63057725999994,
							27.719229254000084
						],
						[
							-82.63053701099994,
							27.719188590000044
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Bahama Shores",
				"RegionID": "416185"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.69192585299993,
					27.718965353000044,
					-82.67515849299991,
					27.725630000000084
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.67518999999993,
							27.72558976600004
						],
						[
							-82.67518999999993,
							27.725307353000062
						],
						[
							-82.6751799999999,
							27.723805241000036
						],
						[
							-82.6751799999999,
							27.722910000000073
						],
						[
							-82.6751799999999,
							27.72265468800009
						],
						[
							-82.6751799999999,
							27.721930000000043
						],
						[
							-82.67517632199991,
							27.721632102000058
						],
						[
							-82.67517197799992,
							27.72128020300005
						],
						[
							-82.67516999999992,
							27.72112000000004
						],
						[
							-82.67516999999992,
							27.72083297800009
						],
						[
							-82.67515849299991,
							27.72022562500007
						],
						[
							-82.67515882399994,
							27.71916843200006
						],
						[
							-82.67548099799991,
							27.719166691000055
						],
						[
							-82.67598425499995,
							27.719161503000066
						],
						[
							-82.6765747629999,
							27.719160000000045
						],
						[
							-82.67688175399991,
							27.719153754000047
						],
						[
							-82.6772102139999,
							27.719141810000053
						],
						[
							-82.6774932749999,
							27.71912915000007
						],
						[
							-82.67768999999993,
							27.71912000000009
						],
						[
							-82.67810754699991,
							27.71909273900008
						],
						[
							-82.67832516399994,
							27.719072484000037
						],
						[
							-82.67854999999992,
							27.71905000000004
						],
						[
							-82.68527740199995,
							27.718965353000044
						],
						[
							-82.68577074899991,
							27.71898457500004
						],
						[
							-82.68626481699994,
							27.71898536200007
						],
						[
							-82.68681696099992,
							27.71897691500004
						],
						[
							-82.68716597799994,
							27.718973623000068
						],
						[
							-82.68786316299992,
							27.718973600000083
						],
						[
							-82.68818316399995,
							27.718977278000068
						],
						[
							-82.68920032799991,
							27.718990000000076
						],
						[
							-82.69076975399992,
							27.718981670000062
						],
						[
							-82.6912658039999,
							27.718982280000034
						],
						[
							-82.6912661799999,
							27.71904797700006
						],
						[
							-82.69126999999992,
							27.719157814000084
						],
						[
							-82.69126999999992,
							27.719190000000083
						],
						[
							-82.69127545299995,
							27.719249981000075
						],
						[
							-82.69128321199992,
							27.71933533200007
						],
						[
							-82.69129301699991,
							27.719428100000073
						],
						[
							-82.69131148699996,
							27.719490677000067
						],
						[
							-82.69134417899994,
							27.719549521000094
						],
						[
							-82.69137344399991,
							27.71958344400008
						],
						[
							-82.69143578999991,
							27.71960521500006
						],
						[
							-82.6914948029999,
							27.719620000000077
						],
						[
							-82.69159622699993,
							27.719620000000077
						],
						[
							-82.6917139819999,
							27.719623374000037
						],
						[
							-82.69178238699993,
							27.719627649000074
						],
						[
							-82.69184978499993,
							27.71974099900007
						],
						[
							-82.69190894899992,
							27.721634238000036
						],
						[
							-82.69192585299993,
							27.723316177000072
						],
						[
							-82.69175681399992,
							27.723333081000078
						],
						[
							-82.69175681399992,
							27.723831746000087
						],
						[
							-82.6915117069999,
							27.723831746000087
						],
						[
							-82.69150529399991,
							27.724255016000086
						],
						[
							-82.69150135799993,
							27.72451480600006
						],
						[
							-82.6911006489999,
							27.72451480600006
						],
						[
							-82.68661199999991,
							27.72451480600006
						],
						[
							-82.6840616309999,
							27.72451480600006
						],
						[
							-82.68225086799993,
							27.72451480600006
						],
						[
							-82.68174999999991,
							27.72477900000007
						],
						[
							-82.68175047199992,
							27.72474683900009
						],
						[
							-82.68134321899993,
							27.724741263000055
						],
						[
							-82.68134224999994,
							27.72492156700008
						],
						[
							-82.68134031099993,
							27.72528217300004
						],
						[
							-82.68134267799991,
							27.725402486000064
						],
						[
							-82.67921637099994,
							27.72544252000006
						],
						[
							-82.6789405159999,
							27.725402402000043
						],
						[
							-82.67699727099995,
							27.725402398000085
						],
						[
							-82.67700701799993,
							27.72558433000006
						],
						[
							-82.6765499999999,
							27.725630000000084
						],
						[
							-82.67587533799991,
							27.725618849000057
						],
						[
							-82.67543437299992,
							27.72561156000006
						],
						[
							-82.67518999999993,
							27.72558976600004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Maximo",
				"RegionID": "416192"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.6752699999999,
					27.751989592000086,
					-82.67111999999992,
					27.755600000000072
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.67113999999992,
							27.755600000000072
						],
						[
							-82.67113999999992,
							27.755344954000066
						],
						[
							-82.67113999999992,
							27.754937789000053
						],
						[
							-82.67113999999992,
							27.75467000000009
						],
						[
							-82.67113999999992,
							27.754419578000068
						],
						[
							-82.67113999999992,
							27.75397539800008
						],
						[
							-82.67113999999992,
							27.753810000000044
						],
						[
							-82.67113999999992,
							27.753531217000045
						],
						[
							-82.67113999999992,
							27.753087037000057
						],
						[
							-82.67113589399992,
							27.752550399000086
						],
						[
							-82.67112554499995,
							27.752198516000078
						],
						[
							-82.67111999999992,
							27.75201000000004
						],
						[
							-82.6712431659999,
							27.75201000000004
						],
						[
							-82.67153318599992,
							27.752007881000054
						],
						[
							-82.67173810899993,
							27.75200521900007
						],
						[
							-82.67195986899992,
							27.752002339000057
						],
						[
							-82.6721399999999,
							27.752000000000066
						],
						[
							-82.6724375039999,
							27.751997112000083
						],
						[
							-82.67271029499994,
							27.751994463000077
						],
						[
							-82.67298341599991,
							27.751991811000043
						],
						[
							-82.67316999999991,
							27.751990000000035
						],
						[
							-82.6734611409999,
							27.751990000000035
						],
						[
							-82.67369999999994,
							27.751990000000035
						],
						[
							-82.67395591999991,
							27.751990000000035
						],
						[
							-82.67415999999992,
							27.751990000000035
						],
						[
							-82.67429714699995,
							27.751990000000035
						],
						[
							-82.67467249599991,
							27.751990000000035
						],
						[
							-82.67511609099995,
							27.751990000000035
						],
						[
							-82.67525010899993,
							27.751989592000086
						],
						[
							-82.67525217299993,
							27.752161646000047
						],
						[
							-82.6752569599999,
							27.752539855000066
						],
						[
							-82.6752624799999,
							27.752968486000043
						],
						[
							-82.6752681239999,
							27.75339745000008
						],
						[
							-82.6752699999999,
							27.753649520000067
						],
						[
							-82.67526741899991,
							27.753951970000063
						],
						[
							-82.67526236799995,
							27.75422973500008
						],
						[
							-82.67525999999994,
							27.754532151000035
						],
						[
							-82.67526385899993,
							27.754834531000085
						],
						[
							-82.67526814899992,
							27.755061888000057
						],
						[
							-82.6752699999999,
							27.75541478200006
						],
						[
							-82.67526890399995,
							27.755570928000054
						],
						[
							-82.6750992119999,
							27.755568389000075
						],
						[
							-82.67484012999996,
							27.755565945000058
						],
						[
							-82.67426644799991,
							27.75556053300005
						],
						[
							-82.67389621799992,
							27.75556615300008
						],
						[
							-82.67361834999991,
							27.755571601000042
						],
						[
							-82.67335934399995,
							27.755576680000047
						],
						[
							-82.67311887199992,
							27.755580704000067
						],
						[
							-82.67284128699993,
							27.755583453000042
						],
						[
							-82.67241565499995,
							27.755587667000043
						],
						[
							-82.67213806799994,
							27.755590403000042
						],
						[
							-82.6718604809999,
							27.755593072000067
						],
						[
							-82.67158271599993,
							27.75559574300007
						],
						[
							-82.67141616399994,
							27.75559734500007
						],
						[
							-82.67114173499994,
							27.75559998300008
						],
						[
							-82.67113999999992,
							27.755600000000072
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Mel-Tan Heights",
				"RegionID": "416367"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.53631731199994,
					27.913896255000054,
					-82.5182425829999,
					27.931210170000043
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.51853989099993,
							27.931210170000043
						],
						[
							-82.51858996899995,
							27.926449999000056
						],
						[
							-82.51861003199991,
							27.92459999600004
						],
						[
							-82.5186201599999,
							27.923800008000057
						],
						[
							-82.51833403899991,
							27.922870301000046
						],
						[
							-82.5182425829999,
							27.92248884700007
						],
						[
							-82.51826042899995,
							27.91975736200004
						],
						[
							-82.51829054599995,
							27.915156077000066
						],
						[
							-82.52112003399992,
							27.915150031000053
						],
						[
							-82.52411013299991,
							27.91520012500007
						],
						[
							-82.5241049999999,
							27.91460600000005
						],
						[
							-82.5240258899999,
							27.914265630000045
						],
						[
							-82.5240258899999,
							27.913938875000042
						],
						[
							-82.52483567199994,
							27.913938875000042
						],
						[
							-82.52556021499993,
							27.91392466800005
						],
						[
							-82.5263842039999,
							27.913896255000054
						],
						[
							-82.52727922699995,
							27.913896255000054
						],
						[
							-82.5278048749999,
							27.913896255000054
						],
						[
							-82.52808900999992,
							27.913938875000042
						],
						[
							-82.52825948999993,
							27.914066736000052
						],
						[
							-82.52835893699995,
							27.91422300900007
						],
						[
							-82.52844417699993,
							27.914436110000054
						],
						[
							-82.52852941799995,
							27.914563970000074
						],
						[
							-82.5286856919999,
							27.914663417000043
						],
						[
							-82.52892720599993,
							27.914706038000077
						],
						[
							-82.52929657999994,
							27.914691831000084
						],
						[
							-82.52966595499993,
							27.914677624000035
						],
						[
							-82.53004953599992,
							27.914720244000083
						],
						[
							-82.53039049699993,
							27.914677624000035
						],
						[
							-82.53104400599995,
							27.914706038000077
						],
						[
							-82.53165489499992,
							27.914862311000036
						],
						[
							-82.5320668889999,
							27.91503279200009
						],
						[
							-82.53235157299991,
							27.915127776000077
						],
						[
							-82.53326482199992,
							27.915134703000035
						],
						[
							-82.53330276299994,
							27.915135792000058
						],
						[
							-82.53360376299992,
							27.915150793000066
						],
						[
							-82.53371516599992,
							27.91516334100004
						],
						[
							-82.53377767099995,
							27.915176668000072
						],
						[
							-82.53414867099991,
							27.915269668000068
						],
						[
							-82.53420796899991,
							27.915286715000036
						],
						[
							-82.5345279689999,
							27.915390715000058
						],
						[
							-82.53459540699993,
							27.91541565500006
						],
						[
							-82.53466063799995,
							27.91544590300009
						],
						[
							-82.53472324299992,
							27.91548126500004
						],
						[
							-82.5349464869999,
							27.915619416000084
						],
						[
							-82.53508873099992,
							27.915707566000037
						],
						[
							-82.53513362299992,
							27.915737282000066
						],
						[
							-82.53528662299993,
							27.915845282000078
						],
						[
							-82.53534607299991,
							27.915891079000062
						],
						[
							-82.5354338269999,
							27.91597547200007
						],
						[
							-82.53571982699992,
							27.91629047200007
						],
						[
							-82.53574292099995,
							27.916316927000082
						],
						[
							-82.53583595999993,
							27.91645084000004
						],
						[
							-82.53603408499993,
							27.916805341000043
						],
						[
							-82.53609408599993,
							27.916936413000087
						],
						[
							-82.53611146499992,
							27.916989180000087
						],
						[
							-82.53621546599993,
							27.91734118000005
						],
						[
							-82.53624048199993,
							27.91745055100006
						],
						[
							-82.53629948299994,
							27.91781055200005
						],
						[
							-82.5363113219999,
							27.91795600000006
						],
						[
							-82.53631080199995,
							27.917986573000064
						],
						[
							-82.5363058019999,
							27.918133573000095
						],
						[
							-82.53629497499992,
							27.918245409000065
						],
						[
							-82.53627681699993,
							27.918358288000036
						],
						[
							-82.53623508599992,
							27.918516586000067
						],
						[
							-82.53618508599993,
							27.91862926100004
						],
						[
							-82.53614808599991,
							27.91869926000004
						],
						[
							-82.53613183599992,
							27.918728661000046
						],
						[
							-82.53604090999994,
							27.91885827300007
						],
						[
							-82.53597989899993,
							27.918930474000035
						],
						[
							-82.5358710729999,
							27.919038921000038
						],
						[
							-82.5357623129999,
							27.91911715400005
						],
						[
							-82.53567731299995,
							27.919169154000087
						],
						[
							-82.53557844799991,
							27.91922148000009
						],
						[
							-82.53550758099993,
							27.919253509000043
						],
						[
							-82.5354377139999,
							27.919285539000043
						],
						[
							-82.5353100609999,
							27.91933272000006
						],
						[
							-82.53518203899995,
							27.91936879900004
						],
						[
							-82.53518109099991,
							27.919403682000052
						],
						[
							-82.53518708999991,
							27.919488683000054
						],
						[
							-82.53518932199995,
							27.919552000000067
						],
						[
							-82.53517844099991,
							27.919676372000083
						],
						[
							-82.53520665899993,
							27.919682220000087
						],
						[
							-82.53531565899993,
							27.919708219000086
						],
						[
							-82.53538022799995,
							27.919726188000084
						],
						[
							-82.53544327999992,
							27.91974891600006
						],
						[
							-82.53550446399993,
							27.91977627700004
						],
						[
							-82.53556344099991,
							27.91980811800005
						],
						[
							-82.53561988299992,
							27.919844264000062
						],
						[
							-82.53577688299993,
							27.91995326400007
						],
						[
							-82.5358562049999,
							27.920015190000072
						],
						[
							-82.53589620499991,
							27.92005018900005
						],
						[
							-82.53597535699993,
							27.92012861900008
						],
						[
							-82.53601635699994,
							27.92017462000007
						],
						[
							-82.5360608279999,
							27.92022860200007
						],
						[
							-82.53610096999995,
							27.920285876000037
						],
						[
							-82.53613653899993,
							27.92034609700005
						],
						[
							-82.53618453899992,
							27.920435097000052
						],
						[
							-82.53623808599991,
							27.920554414000037
						],
						[
							-82.53625179599993,
							27.92059507400006
						],
						[
							-82.53627479599993,
							27.920669074000045
						],
						[
							-82.53630165999994,
							27.92077983400009
						],
						[
							-82.53631530299992,
							27.920930086000055
						],
						[
							-82.53631731199994,
							27.921237043000076
						],
						[
							-82.53630365899994,
							27.92139616600008
						],
						[
							-82.53629519399993,
							27.921438269000078
						],
						[
							-82.5362622749999,
							27.92158390900005
						],
						[
							-82.53622835699991,
							27.921734549000064
						],
						[
							-82.53620959699992,
							27.92180456400007
						],
						[
							-82.53614259699992,
							27.92201956400004
						],
						[
							-82.5361290859999,
							27.922059586000046
						],
						[
							-82.53606788099997,
							27.922192807000044
						],
						[
							-82.53584435899995,
							27.92259023400004
						],
						[
							-82.53575192099993,
							27.922723073000043
						],
						[
							-82.53572844399991,
							27.92274995000008
						],
						[
							-82.53549844299994,
							27.92300295000007
						],
						[
							-82.53539603599995,
							27.92309926300004
						],
						[
							-82.53518803599991,
							27.923266264000063
						],
						[
							-82.5351086689999,
							27.923323185000072
						],
						[
							-82.53481866899995,
							27.92350818500006
						],
						[
							-82.53478466099995,
							27.92352883600006
						],
						[
							-82.53467511899993,
							27.923582526000075
						],
						[
							-82.53451973499995,
							27.92364600600007
						],
						[
							-82.53429727699995,
							27.923742308000048
						],
						[
							-82.53422791199995,
							27.923768990000042
						],
						[
							-82.5340829129999,
							27.92381799000009
						],
						[
							-82.5339644739999,
							27.923846981000054
						],
						[
							-82.53401776399994,
							27.92389121800005
						],
						[
							-82.53406732499991,
							27.92393959800006
						],
						[
							-82.53411283399993,
							27.92399180600006
						],
						[
							-82.53415399699992,
							27.924047504000043
						],
						[
							-82.53419054799991,
							27.924106333000054
						],
						[
							-82.53423026099995,
							27.924176326000065
						],
						[
							-82.5342659019999,
							27.924246079000056
						],
						[
							-82.53429533699995,
							27.92431866900006
						],
						[
							-82.53431834299994,
							27.924393545000044
						],
						[
							-82.53433474799995,
							27.92447013900005
						],
						[
							-82.53434442399993,
							27.924547870000083
						],
						[
							-82.53435842499994,
							27.92472187000004
						],
						[
							-82.53436130499995,
							27.924788427000067
						],
						[
							-82.53435924999991,
							27.92485501400006
						],
						[
							-82.53435227199992,
							27.92492126600007
						],
						[
							-82.53434040799993,
							27.924986820000072
						],
						[
							-82.53432240799992,
							27.925068820000035
						],
						[
							-82.5343047739999,
							27.92513647600009
						],
						[
							-82.53428193799994,
							27.92520255800008
						],
						[
							-82.53425403699993,
							27.925266667000074
						],
						[
							-82.53422123999991,
							27.925328414000035
						],
						[
							-82.53418374499995,
							27.92538742700009
						],
						[
							-82.53412774499992,
							27.925468427000055
						],
						[
							-82.53408466299993,
							27.925525719000063
						],
						[
							-82.53403715499991,
							27.925579397000035
						],
						[
							-82.53398552199991,
							27.92562912200009
						],
						[
							-82.53393009299992,
							27.925674576000066
						],
						[
							-82.53387121999992,
							27.925715471000046
						],
						[
							-82.53337521999993,
							27.926031472000094
						],
						[
							-82.53324773999992,
							27.92609897200009
						],
						[
							-82.53286727199992,
							27.92626283700008
						],
						[
							-82.53254818799991,
							27.926422378000044
						],
						[
							-82.53242887399995,
							27.926471675000073
						],
						[
							-82.53225987499991,
							27.926527675000045
						],
						[
							-82.53213316599994,
							27.926559659000077
						],
						[
							-82.53205667299994,
							27.926569786000073
						],
						[
							-82.53173009599993,
							27.926600379000035
						],
						[
							-82.53171665999992,
							27.926761166000063
						],
						[
							-82.53171082599994,
							27.92679124400007
						],
						[
							-82.53168785299994,
							27.92689977300006
						],
						[
							-82.53169965899993,
							27.926943834000042
						],
						[
							-82.53171282199993,
							27.927070038000068
						],
						[
							-82.53172182299994,
							27.92734003700008
						],
						[
							-82.53172231699995,
							27.927366909000057
						],
						[
							-82.53172331899992,
							27.927659454000036
						],
						[
							-82.53170965899994,
							27.92781716500008
						],
						[
							-82.53170527799995,
							27.92784007800009
						],
						[
							-82.5317193219999,
							27.92799800000006
						],
						[
							-82.53171842199993,
							27.92803822500008
						],
						[
							-82.53171707599995,
							27.928068292000038
						],
						[
							-82.53150327399993,
							27.928394750000052
						],
						[
							-82.5311825089999,
							27.92865136200004
						],
						[
							-82.5309018399999,
							27.92873957200004
						],
						[
							-82.53056503699992,
							27.928763630000052
						],
						[
							-82.52967491399994,
							27.928747592000036
						],
						[
							-82.52868054299995,
							27.92873957200004
						],
						[
							-82.5284319509999,
							27.928707496000072
						],
						[
							-82.5280550519999,
							27.928659381000045
						],
						[
							-82.52771824899992,
							27.92865136200004
						],
						[
							-82.52738144599994,
							27.92865136200004
						],
						[
							-82.5270769999999,
							27.928520000000052
						],
						[
							-82.5253200009999,
							27.929600012000037
						],
						[
							-82.52451986099993,
							27.93009987700009
						],
						[
							-82.52452014099993,
							27.931200106000063
						],
						[
							-82.52332002199995,
							27.930900019000035
						],
						[
							-82.52182000099992,
							27.930700008000088
						],
						[
							-82.5190198439999,
							27.930799878000073
						],
						[
							-82.51899242799993,
							27.931191396000088
						],
						[
							-82.51853989099993,
							27.931210170000043
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Sunset Park",
				"RegionID": "275635"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.072651,
					26.627607364000028,
					-80.0563,
					26.645104115000038
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.072651,
							26.632244
						],
						[
							-80.072575,
							26.633058
						],
						[
							-80.072538,
							26.633458
						],
						[
							-80.072453,
							26.634533
						],
						[
							-80.072411,
							26.635533
						],
						[
							-80.07231,
							26.636316
						],
						[
							-80.070454,
							26.642443
						],
						[
							-80.06902152799995,
							26.642305274000023
						],
						[
							-80.06897584199999,
							26.641414404000045
						],
						[
							-80.06877025699998,
							26.639347129000043
						],
						[
							-80.06591490299996,
							26.63946134300005
						],
						[
							-80.06401894899994,
							26.63946134300005
						],
						[
							-80.06365666899995,
							26.645104115000038
						],
						[
							-80.05910391099997,
							26.64493998300003
						],
						[
							-80.058827,
							26.64493
						],
						[
							-80.0563,
							26.644735
						],
						[
							-80.05631012999999,
							26.64417299300004
						],
						[
							-80.05641672999997,
							26.643167908000066
						],
						[
							-80.05656901499998,
							26.638675486000068
						],
						[
							-80.05681267199998,
							26.631183039000064
						],
						[
							-80.05693448199997,
							26.627607364000028
						],
						[
							-80.06749105799997,
							26.62790287300004
						],
						[
							-80.06794110099997,
							26.63207442600003
						],
						[
							-80.072651,
							26.632244
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Lake Worth",
				"Name": "Sunset Ridge",
				"RegionID": "275636"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.64868149299991,
					27.95949986800008,
					-82.50569091199992,
					27.997047000000066
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-82.64816722799992,
								27.96590279800006
							],
							[
								-82.64860840799992,
								27.96585007100009
							],
							[
								-82.64861599999995,
								27.966337000000067
							],
							[
								-82.64860799999991,
								27.966671000000076
							],
							[
								-82.64861419599993,
								27.966755059000036
							],
							[
								-82.64863799999995,
								27.967078000000072
							],
							[
								-82.64865634299991,
								27.96735850200008
							],
							[
								-82.64866199999994,
								27.967445000000055
							],
							[
								-82.64868149299991,
								27.968261452000036
							],
							[
								-82.64846720599992,
								27.968287667000084
							],
							[
								-82.6483832049999,
								27.968293969000058
							],
							[
								-82.64789341999995,
								27.96830770100007
							],
							[
								-82.64764427999995,
								27.96833990300007
							],
							[
								-82.64760529099993,
								27.968344080000065
							],
							[
								-82.64629061499994,
								27.96845600900008
							],
							[
								-82.6451123949999,
								27.968621085000052
							],
							[
								-82.63980499899992,
								27.969323547000045
							],
							[
								-82.63974930199993,
								27.96932916200007
							],
							[
								-82.63954403299994,
								27.969343416000072
							],
							[
								-82.63819275799995,
								27.969469794000076
							],
							[
								-82.63686187799993,
								27.969678840000086
							],
							[
								-82.63549420299995,
								27.969885253000086
							],
							[
								-82.63547316199993,
								27.96988817400006
							],
							[
								-82.63440309399994,
								27.970023900000058
							],
							[
								-82.63420938999991,
								27.970056424000063
							],
							[
								-82.63391020299991,
								27.97014685700009
							],
							[
								-82.63380423799993,
								27.97017199700008
							],
							[
								-82.63279323899991,
								27.97034799700009
							],
							[
								-82.63277158699992,
								27.970351495000045
							],
							[
								-82.63138958699994,
								27.970557494000047
							],
							[
								-82.63136918299995,
								27.970560297000077
							],
							[
								-82.63016018299993,
								27.97071229800008
							],
							[
								-82.6301000439999,
								27.970717815000057
							],
							[
								-82.62996204399991,
								27.970725815000037
							],
							[
								-82.62989266799991,
								27.970727155000077
							],
							[
								-82.6298233949999,
								27.970723142000054
							],
							[
								-82.62975463899994,
								27.970713801000045
							],
							[
								-82.62968680699993,
								27.970699186000047
							],
							[
								-82.6295658059999,
								27.97066818600007
							],
							[
								-82.62948141299995,
								27.970642087000044
							],
							[
								-82.62933956499995,
								27.97057596700006
							],
							[
								-82.6293134519999,
								27.970560901000056
							],
							[
								-82.62918133399995,
								27.970467873000075
							],
							[
								-82.6291427399999,
								27.970434826000087
							],
							[
								-82.62903907899994,
								27.97033007300007
							],
							[
								-82.62900979299991,
								27.970293257000037
							],
							[
								-82.62895779299993,
								27.970224258000087
							],
							[
								-82.62891468899994,
								27.970161734000044
							],
							[
								-82.62887701299991,
								27.970095797000056
							],
							[
								-82.62884503499993,
								27.97002691600005
							],
							[
								-82.62881898199993,
								27.96995558200007
							],
							[
								-82.62879904099992,
								27.969882306000045
							],
							[
								-82.62876784199995,
								27.96974487300008
							],
							[
								-82.62875764199994,
								27.96969744100005
							],
							[
								-82.6287528069999,
								27.969673430000057
							],
							[
								-82.62874263499992,
								27.96963050700009
							],
							[
								-82.62873034099994,
								27.969572165000045
							],
							[
								-82.62871667799993,
								27.969416000000084
							],
							[
								-82.62871667799993,
								27.969309000000067
							],
							[
								-82.62872964999991,
								27.969156800000064
							],
							[
								-82.62874699499991,
								27.969055817000083
							],
							[
								-82.62878791299994,
								27.96890241400007
							],
							[
								-82.62885008399991,
								27.968767481000043
							],
							[
								-82.62887608499994,
								27.968721480000056
							],
							[
								-82.62890854699992,
								27.96866841800005
							],
							[
								-82.62894354699995,
								27.96861541800007
							],
							[
								-82.6289863319999,
								27.968556036000052
							],
							[
								-82.62903380299991,
								27.96850032800006
							],
							[
								-82.6290856469999,
								27.968448666000086
							],
							[
								-82.6291415199999,
								27.968401390000054
							],
							[
								-82.62920105299992,
								27.968358814000055
							],
							[
								-82.62926384999992,
								27.968321221000053
							],
							[
								-82.62937584999992,
								27.968260221000037
							],
							[
								-82.62951400399993,
								27.96819940100005
							],
							[
								-82.62978200499992,
								27.968107401000054
							],
							[
								-82.62991475399991,
								27.968072890000087
							],
							[
								-82.63063175299993,
								27.967943889000082
							],
							[
								-82.63071246599992,
								27.967933113000072
							],
							[
								-82.63279537499994,
								27.967750524000053
							],
							[
								-82.63320636999993,
								27.967699567000068
							],
							[
								-82.63341924699995,
								27.967640949000042
							],
							[
								-82.63354243399993,
								27.967616134000085
							],
							[
								-82.63389743399995,
								27.967570134000088
							],
							[
								-82.63394819899992,
								27.967565016000037
							],
							[
								-82.6344741989999,
								27.967527016000076
							],
							[
								-82.6345238319999,
								27.967524806000085
							],
							[
								-82.6348992739999,
								27.96751847300004
							],
							[
								-82.63551592599993,
								27.967453612000043
							],
							[
								-82.63554192999993,
								27.96745125800004
							],
							[
								-82.6357487219999,
								27.96743556100006
							],
							[
								-82.63577746999994,
								27.96742431100006
							],
							[
								-82.63586686399992,
								27.96738563100007
							],
							[
								-82.6359164129999,
								27.967365914000084
							],
							[
								-82.63607199199993,
								27.967324628000085
							],
							[
								-82.63627485199993,
								27.96729079700009
							],
							[
								-82.63637394699992,
								27.96725585700006
							],
							[
								-82.6365168339999,
								27.967218341000034
							],
							[
								-82.63665106999991,
								27.967204946000038
							],
							[
								-82.6369463129999,
								27.96719774400009
							],
							[
								-82.63785417899994,
								27.967109259000043
							],
							[
								-82.63842417099994,
								27.967063197000073
							],
							[
								-82.63950901499993,
								27.96695738200009
							],
							[
								-82.64028133999994,
								27.966873888000066
							],
							[
								-82.64032823399992,
								27.96687005600006
							],
							[
								-82.64071368499992,
								27.966848694000078
							],
							[
								-82.64483523899992,
								27.96634688800009
							],
							[
								-82.64816722799992,
								27.96590279800006
							]
						]
					],
					[
						[
							[
								-82.53381899999994,
								27.997047000000066
							],
							[
								-82.53179299999994,
								27.997013000000038
							],
							[
								-82.53170399999993,
								27.997013000000038
							],
							[
								-82.53161799999992,
								27.997011000000043
							],
							[
								-82.53080499999993,
								27.997017000000085
							],
							[
								-82.52908453899994,
								27.996971467000037
							],
							[
								-82.52729099999993,
								27.996924000000035
							],
							[
								-82.5268846969999,
								27.996917946000053
							],
							[
								-82.5272356559999,
								27.995576845000077
							],
							[
								-82.52740190599991,
								27.99494207300006
							],
							[
								-82.52800150299993,
								27.992653356000062
							],
							[
								-82.52554906599994,
								27.986713647000045
							],
							[
								-82.52663900399995,
								27.98153681000008
							],
							[
								-82.52762001699995,
								27.972490862000086
							],
							[
								-82.5133851889999,
								27.97208949100008
							],
							[
								-82.51345184799993,
								27.973853433000045
							],
							[
								-82.50569091199992,
								27.974145449000048
							],
							[
								-82.50593324599993,
								27.96733885000009
							],
							[
								-82.5113935249999,
								27.967533462000063
							],
							[
								-82.51231818199996,
								27.966300001000036
							],
							[
								-82.51569999999992,
								27.96297272700008
							],
							[
								-82.51891811599997,
								27.959899886000073
							],
							[
								-82.52011815899994,
								27.95949986800008
							],
							[
								-82.53791818099995,
								27.960000000000036
							],
							[
								-82.54031818199991,
								27.960099998000093
							],
							[
								-82.54251818799992,
								27.95969991800007
							],
							[
								-82.5457183019999,
								27.96079985700004
							],
							[
								-82.54620742399993,
								27.961680069000067
							],
							[
								-82.54627331699993,
								27.961808209000083
							],
							[
								-82.54649786899995,
								27.961757685000066
							],
							[
								-82.54685715099993,
								27.96174645700006
							],
							[
								-82.54729502599992,
								27.961808209000083
							],
							[
								-82.54785078999993,
								27.961881188000064
							],
							[
								-82.54818761699994,
								27.961903643000085
							],
							[
								-82.54839532699992,
								27.961903643000085
							],
							[
								-82.5486030369999,
								27.961847505000037
							],
							[
								-82.54881636099992,
								27.961718388000065
							],
							[
								-82.54901284399995,
								27.961583658000052
							],
							[
								-82.54953793999994,
								27.960901032000038
							],
							[
								-82.54953975899991,
								27.960901747000037
							],
							[
								-82.54960732599994,
								27.960935590000076
							],
							[
								-82.54967157999994,
								27.96097536600007
							],
							[
								-82.54973200199993,
								27.96102075300007
							],
							[
								-82.54994203699995,
								27.961191916000075
							],
							[
								-82.55005791999992,
								27.961306927000066
							],
							[
								-82.5500815179999,
								27.961336276000058
							],
							[
								-82.5502155179999,
								27.96151027600007
							],
							[
								-82.55025833299993,
								27.961570889000086
							],
							[
								-82.55029600499995,
								27.96163482600008
							],
							[
								-82.55032827699995,
								27.961701651000055
							],
							[
								-82.55035492999991,
								27.96177091000004
							],
							[
								-82.55041978899993,
								27.96196270900009
							],
							[
								-82.55060955099992,
								27.962464157000056
							],
							[
								-82.55066457299995,
								27.96258276000009
							],
							[
								-82.55073570799993,
								27.962699710000038
							],
							[
								-82.55109335899994,
								27.96318537200006
							],
							[
								-82.5511766919999,
								27.96324728700006
							],
							[
								-82.55143002299991,
								27.96341190600009
							],
							[
								-82.55149230399991,
								27.96345625300006
							],
							[
								-82.55177630399993,
								27.963677253000075
							],
							[
								-82.5518599159999,
								27.96375108300009
							],
							[
								-82.55195691599994,
								27.963848083000073
							],
							[
								-82.55200991999993,
								27.96390592700004
							],
							[
								-82.55209984099992,
								27.96403434800004
							],
							[
								-82.55215584599995,
								27.964131357000042
							],
							[
								-82.55221573799992,
								27.964256504000048
							],
							[
								-82.55229916499991,
								27.964472141000044
							],
							[
								-82.55245522099995,
								27.964709587000073
							],
							[
								-82.55259479999995,
								27.964883687000054
							],
							[
								-82.55273324099994,
								27.965033375000075
							],
							[
								-82.55278281199992,
								27.96509178000008
							],
							[
								-82.55320681199993,
								27.965636780000068
							],
							[
								-82.55323729799994,
								27.96567837400005
							],
							[
								-82.5534320349999,
								27.96596070000004
							],
							[
								-82.55345778399993,
								27.965989024000066
							],
							[
								-82.55351523199994,
								27.96603959500004
							],
							[
								-82.55357886899992,
								27.966081543000087
							],
							[
								-82.55372724099993,
								27.96611172100006
							],
							[
								-82.55385558599994,
								27.966147913000043
							],
							[
								-82.55390479399995,
								27.966169991000072
							],
							[
								-82.55400027499991,
								27.96615879600006
							],
							[
								-82.5540657489999,
								27.966153535000046
							],
							[
								-82.55427174899995,
								27.96614453500007
							],
							[
								-82.55431881699991,
								27.966143712000076
							],
							[
								-82.55674131699993,
								27.96616481600006
							],
							[
								-82.55833877899994,
								27.96620175600009
							],
							[
								-82.5599293699999,
								27.966213678000088
							],
							[
								-82.5613459999999,
								27.966213678000088
							],
							[
								-82.56142053799994,
								27.966216772000053
							],
							[
								-82.56192553799991,
								27.966258772000064
							],
							[
								-82.5620635599999,
								27.96628115900006
							],
							[
								-82.56217455899991,
								27.96630815900005
							],
							[
								-82.56220472899992,
								27.966317288000088
							],
							[
								-82.56223513799995,
								27.96630928600007
							],
							[
								-82.5623020939999,
								27.96629437200005
							],
							[
								-82.56236999299995,
								27.966284605000055
							],
							[
								-82.56243843899995,
								27.96628004100006
							],
							[
								-82.5625070339999,
								27.966280708000056
							],
							[
								-82.56264296599994,
								27.966287220000083
							],
							[
								-82.5632228689999,
								27.96627488100006
							],
							[
								-82.56325598799992,
								27.96627478700009
							],
							[
								-82.56458108099991,
								27.966295399000046
							],
							[
								-82.56491898099995,
								27.96628193500004
							],
							[
								-82.56493646299992,
								27.96626279100008
							],
							[
								-82.56523959299994,
								27.965481648000036
							],
							[
								-82.5652991639999,
								27.965357339000036
							],
							[
								-82.56533354499994,
								27.96530245400004
							],
							[
								-82.56648769299994,
								27.963599514000066
							],
							[
								-82.56729725999992,
								27.96230980200005
							],
							[
								-82.56735994999991,
								27.962045470000078
							],
							[
								-82.5673784039999,
								27.96197909500006
							],
							[
								-82.56740188399993,
								27.961914328000034
							],
							[
								-82.56743025299994,
								27.961851549000073
							],
							[
								-82.56746334399992,
								27.961791125000047
							],
							[
								-82.56750096399992,
								27.96173341100007
							],
							[
								-82.5675428909999,
								27.961678747000068
							],
							[
								-82.56777348599991,
								27.96140083800009
							],
							[
								-82.56782200099991,
								27.96134722900007
							],
							[
								-82.56787466499992,
								27.961297690000038
							],
							[
								-82.56793113899994,
								27.961252543000057
							],
							[
								-82.5679910579999,
								27.961212079000063
							],
							[
								-82.5680540329999,
								27.96117655800009
							],
							[
								-82.56811965899993,
								27.961146212000074
							],
							[
								-82.56827165899995,
								27.961083212000062
							],
							[
								-82.5683403409999,
								27.961057967000045
							],
							[
								-82.56841084799993,
								27.961038390000056
							],
							[
								-82.56848271299992,
								27.961024610000038
							],
							[
								-82.5688497129999,
								27.960969610000063
							],
							[
								-82.56898299999995,
								27.96095967800005
							],
							[
								-82.5690838139999,
								27.96096534700007
							],
							[
								-82.56957442599992,
								27.96102069300008
							],
							[
								-82.57028270699993,
								27.961044004000087
							],
							[
								-82.5703513389999,
								27.96100016500009
							],
							[
								-82.57049341399994,
								27.960933914000066
							],
							[
								-82.57064483399995,
								27.96089334100009
							],
							[
								-82.5708009999999,
								27.960879678000087
							],
							[
								-82.57091299099994,
								27.960886678000065
							],
							[
								-82.5711599899999,
								27.960917678000044
							],
							[
								-82.57123616399991,
								27.96093058300005
							],
							[
								-82.57131094899995,
								27.960949978000087
							],
							[
								-82.57138379299994,
								27.96097572000008
							],
							[
								-82.57145415999992,
								27.961007619000043
							],
							[
								-82.57152152799995,
								27.961045441000067
							],
							[
								-82.57158540199993,
								27.961088904000064
							],
							[
								-82.57232340199994,
								27.961638904000043
							],
							[
								-82.5723573489999,
								27.961665493000055
							],
							[
								-82.5734298239999,
								27.962547785000083
							],
							[
								-82.57348324299994,
								27.962586444000067
							],
							[
								-82.57353111399993,
								27.962623608000058
							],
							[
								-82.57357637299992,
								27.96266391100005
							],
							[
								-82.57361881499992,
								27.96270717100009
							],
							[
								-82.57365824699993,
								27.96275319100005
							],
							[
								-82.5736862469999,
								27.962788191000072
							],
							[
								-82.5737310799999,
								27.962849348000077
							],
							[
								-82.57377060099992,
								27.962914065000064
							],
							[
								-82.57380452899991,
								27.962981881000076
							],
							[
								-82.57383262399992,
								27.963052314000038
							],
							[
								-82.57385468599995,
								27.963124864000065
							],
							[
								-82.5738705569999,
								27.963199014000054
							],
							[
								-82.57388012499992,
								27.963274238000057
							],
							[
								-82.57388332199992,
								27.963350000000048
							],
							[
								-82.57388332199992,
								27.963419000000048
							],
							[
								-82.5738798559999,
								27.96349783000005
							],
							[
								-82.57386949599993,
								27.963576052000064
							],
							[
								-82.57385232299993,
								27.963653067000052
							],
							[
								-82.57382846799993,
								27.963728280000055
							],
							[
								-82.57379811599992,
								27.963801114000034
							],
							[
								-82.57376149899994,
								27.96387100900006
							],
							[
								-82.57371889899991,
								27.963937427000076
							],
							[
								-82.57369891099995,
								27.96396560300008
							],
							[
								-82.5735559119999,
								27.96415960300004
							],
							[
								-82.57353744199992,
								27.96418379100004
							],
							[
								-82.57317125399993,
								27.964646912000035
							],
							[
								-82.57308178599993,
								27.964766818000044
							],
							[
								-82.57303520699992,
								27.96482422200006
							],
							[
								-82.5729840429999,
								27.964877580000064
							],
							[
								-82.5729286429999,
								27.96492652500007
							],
							[
								-82.5728693879999,
								27.964970725000057
							],
							[
								-82.57280668199991,
								27.965009875000078
							],
							[
								-82.57280505999995,
								27.96505637900009
							],
							[
								-82.5728061019999,
								27.965123875000074
							],
							[
								-82.57280207899993,
								27.96519125900005
							],
							[
								-82.57279301199992,
								27.965258152000047
							],
							[
								-82.5727789529999,
								27.965324175000035
							],
							[
								-82.57275998199992,
								27.96538895900005
							],
							[
								-82.5727362049999,
								27.96545213700006
							],
							[
								-82.57268120499992,
								27.965583137000067
							],
							[
								-82.57264803599993,
								27.965653459000066
							],
							[
								-82.57260891599992,
								27.965720653000062
							],
							[
								-82.57256413899995,
								27.965784217000078
							],
							[
								-82.57251403799995,
								27.965843675000087
							],
							[
								-82.57245898999993,
								27.96589858400006
							],
							[
								-82.57239940399995,
								27.965948533000073
							],
							[
								-82.57233572599995,
								27.96599314900004
							],
							[
								-82.57220003099991,
								27.966079728000068
							],
							[
								-82.5720649239999,
								27.96632069000009
							],
							[
								-82.57198494199992,
								27.966582671000083
							],
							[
								-82.57210911099992,
								27.966523763000055
							],
							[
								-82.57224811099991,
								27.96646876300008
							],
							[
								-82.57230853299991,
								27.96644731200007
							],
							[
								-82.5723703299999,
								27.966430221000053
							],
							[
								-82.57243318799993,
								27.966417577000072
							],
							[
								-82.57249678699992,
								27.96640944300009
							],
							[
								-82.5728017859999,
								27.966381444000035
							],
							[
								-82.57287600899991,
								27.96637771400009
							],
							[
								-82.57295028599992,
								27.966380124000068
							],
							[
								-82.57302410999996,
								27.966388659000074
							],
							[
								-82.57309697799991,
								27.96640326100004
							],
							[
								-82.57316839099991,
								27.966423829000064
							],
							[
								-82.57341739099991,
								27.966506829000082
							],
							[
								-82.5734797749999,
								27.966530225000042
							],
							[
								-82.57354025599994,
								27.966558176000035
							],
							[
								-82.57359850099994,
								27.96659052700005
							],
							[
								-82.57365419099995,
								27.966627102000075
							],
							[
								-82.57447119099993,
								27.967208102000086
							],
							[
								-82.57456376199991,
								27.96728367500009
							],
							[
								-82.57534674699991,
								27.968014769000035
							],
							[
								-82.57539531899994,
								27.968045431000064
							],
							[
								-82.57548906999995,
								27.968104020000055
							],
							[
								-82.5809958989999,
								27.970102273000066
							],
							[
								-82.5833395919999,
								27.970997882000063
							],
							[
								-82.58470335099992,
								27.971451504000076
							],
							[
								-82.58525984399995,
								27.97159340500008
							],
							[
								-82.5866883509999,
								27.971743229000083
							],
							[
								-82.58792862799993,
								27.971810635000054
							],
							[
								-82.59017076599991,
								27.971806692000087
							],
							[
								-82.59161140399993,
								27.97179570000009
							],
							[
								-82.59303969199993,
								27.97180469600005
							],
							[
								-82.59307523599996,
								27.97180562400007
							],
							[
								-82.5936168579999,
								27.971830485000055
							],
							[
								-82.59407479299995,
								27.971781732000068
							],
							[
								-82.59420494799991,
								27.971777357000065
							],
							[
								-82.5949074799999,
								27.97180467800007
							],
							[
								-82.59546319499992,
								27.97180467800007
							],
							[
								-82.59598203099995,
								27.971730686000058
							],
							[
								-82.59602744699993,
								27.971725383000035
							],
							[
								-82.59724644699992,
								27.971614384000077
							],
							[
								-82.59735828399994,
								27.971611188000054
							],
							[
								-82.59812445499995,
								27.97163700300007
							],
							[
								-82.60006074299991,
								27.971422545000053
							],
							[
								-82.60233286199991,
								27.971200398000065
							],
							[
								-82.6035633919999,
								27.97106720700009
							],
							[
								-82.60525653899992,
								27.97087308800008
							],
							[
								-82.60716483499994,
								27.97051878800005
							],
							[
								-82.60722303099993,
								27.97050994300008
							],
							[
								-82.60833954499992,
								27.97037745900008
							],
							[
								-82.60915288299992,
								27.970193771000083
							],
							[
								-82.6092029369999,
								27.970183950000035
							],
							[
								-82.60986793699993,
								27.97007295000009
							],
							[
								-82.60993706699992,
								27.970064149000052
							],
							[
								-82.61182106599995,
								27.969898149000073
							],
							[
								-82.61187025499993,
								27.969895170000086
							],
							[
								-82.6134792339999,
								27.969841924000036
							],
							[
								-82.61434078699995,
								27.96971090100004
							],
							[
								-82.61444687599993,
								27.96970115000005
							],
							[
								-82.61512565399994,
								27.96967915700009
							],
							[
								-82.6152346529999,
								27.96967557100004
							],
							[
								-82.61627219999991,
								27.969542035000075
							],
							[
								-82.61630090299991,
								27.969538809000085
							],
							[
								-82.61711231999993,
								27.96946076900008
							],
							[
								-82.61772305099993,
								27.969402604000038
							],
							[
								-82.61892646899992,
								27.96923434200005
							],
							[
								-82.6190509999999,
								27.969225678000047
							],
							[
								-82.61920478299993,
								27.969238924000084
							],
							[
								-82.6194467819999,
								27.96928092400009
							],
							[
								-82.6195160449999,
								27.96929577600008
							],
							[
								-82.62009804399992,
								27.96944477600005
							],
							[
								-82.62018258599994,
								27.96947091400006
							],
							[
								-82.6202999009999,
								27.96952338400007
							],
							[
								-82.62039690099994,
								27.969575384000056
							],
							[
								-82.62042166099991,
								27.96958916400007
							],
							[
								-82.62055007299995,
								27.969679079000063
							],
							[
								-82.62066092099991,
								27.96978992700008
							],
							[
								-82.62075083599991,
								27.96991833900006
							],
							[
								-82.62077863899992,
								27.969970364000062
							],
							[
								-82.62088363899994,
								27.970183365000082
							],
							[
								-82.62091289599995,
								27.97024925100004
							],
							[
								-82.62093678199994,
								27.970317269000077
							],
							[
								-82.62095514399994,
								27.970386982000036
							],
							[
								-82.62096786299992,
								27.970457942000056
							],
							[
								-82.62097485699991,
								27.97052969200007
							],
							[
								-82.62097725699994,
								27.970573063000074
							],
							[
								-82.62097983399991,
								27.970638888000053
							],
							[
								-82.62098079099991,
								27.970673980000075
							],
							[
								-82.62098841499994,
								27.970843624000054
							],
							[
								-82.6209893219999,
								27.97088400000007
							],
							[
								-82.6209756589999,
								27.97104016600008
							],
							[
								-82.62093508599992,
								27.971191586000092
							],
							[
								-82.6208688349999,
								27.971333661000074
							],
							[
								-82.6207789199999,
								27.971462073000055
							],
							[
								-82.62072055499993,
								27.97152523300008
							],
							[
								-82.6206605559999,
								27.971584233000044
							],
							[
								-82.62060574799995,
								27.97163386500006
							],
							[
								-82.62054704899994,
								27.971678827000062
							],
							[
								-82.62048485499992,
								27.97171881400004
							],
							[
								-82.62041958599991,
								27.971753557000056
							],
							[
								-82.6203516839999,
								27.971782821000094
							],
							[
								-82.62028160699992,
								27.971806409000067
							],
							[
								-82.62020982899992,
								27.971824159000054
							],
							[
								-82.61962182899993,
								27.97194415900009
							],
							[
								-82.61952612699992,
								27.971958379000057
							],
							[
								-82.61740795799994,
								27.972157395000067
							],
							[
								-82.6163417169999,
								27.972257171000084
							],
							[
								-82.61616670599994,
								27.972283037000068
							],
							[
								-82.61530839099993,
								27.972659309000054
							],
							[
								-82.61468919299995,
								27.972969875000047
							],
							[
								-82.61463512899991,
								27.97299478700006
							],
							[
								-82.61410812899993,
								27.97321678800006
							],
							[
								-82.61401500799991,
								27.973250114000052
							],
							[
								-82.61362100799994,
								27.97336711400004
							],
							[
								-82.61354592599992,
								27.973385935000067
							],
							[
								-82.61313692599992,
								27.973469935000082
							],
							[
								-82.61311216599995,
								27.97347466000008
							],
							[
								-82.6129485589999,
								27.973488261000057
							],
							[
								-82.61252928099992,
								27.97348138400008
							],
							[
								-82.61132872199994,
								27.973491306000085
							],
							[
								-82.61116883499994,
								27.973477659000082
							],
							[
								-82.6110330059999,
								27.973442599000066
							],
							[
								-82.61092542299991,
								27.973405668000055
							],
							[
								-82.61082464899994,
								27.97341371400006
							],
							[
								-82.61061697799994,
								27.97346456000008
							],
							[
								-82.61043240799995,
								27.97353823600008
							],
							[
								-82.61037460999995,
								27.973559049000073
							],
							[
								-82.6103155269999,
								27.97357586700008
							],
							[
								-82.6102554329999,
								27.97358861200007
							],
							[
								-82.6101946089999,
								27.973597226000038
							],
							[
								-82.60987660799992,
								27.973631225000076
							],
							[
								-82.60978099999994,
								27.97363632200006
							],
							[
								-82.60946199999995,
								27.97363632200006
							],
							[
								-82.60938833199992,
								27.973633300000074
							],
							[
								-82.60857010599995,
								27.973566049000056
							],
							[
								-82.6080229559999,
								27.973591637000084
							],
							[
								-82.60768939799993,
								27.97370090600009
							],
							[
								-82.60703866299991,
								27.973938694000083
							],
							[
								-82.60698760199995,
								27.973955639000053
							],
							[
								-82.60650260199992,
								27.97410063800004
							],
							[
								-82.6064011659999,
								27.97412465900004
							],
							[
								-82.60628862999994,
								27.97413726300005
							],
							[
								-82.60593862999991,
								27.97415426300006
							],
							[
								-82.60578780999992,
								27.974148911000043
							],
							[
								-82.60502262799992,
								27.97405705400007
							],
							[
								-82.60287475299992,
								27.974245868000082
							],
							[
								-82.60283106199995,
								27.974248639000052
							],
							[
								-82.60267619799994,
								27.974254681000048
							],
							[
								-82.60264439399992,
								27.97432062300004
							],
							[
								-82.60260703599994,
								27.974383586000044
							],
							[
								-82.60256440099995,
								27.974443102000066
							],
							[
								-82.60251680599993,
								27.97449873000005
							],
							[
								-82.60246460199994,
								27.97455005900008
							],
							[
								-82.60240817599993,
								27.974596707000046
							],
							[
								-82.60231817599993,
								27.97466570800009
							],
							[
								-82.60225997399994,
								27.974706774000087
							],
							[
								-82.60219870499992,
								27.974743106000062
							],
							[
								-82.60213475299992,
								27.97477447400007
							],
							[
								-82.60206851899994,
								27.97480068300007
							],
							[
								-82.60200041799993,
								27.97482156800004
							],
							[
								-82.6017654179999,
								27.974883568000052
							],
							[
								-82.60169216499993,
								27.974899660000062
							],
							[
								-82.60154577299994,
								27.97491326900007
							],
							[
								-82.60089688599994,
								27.97492029500006
							],
							[
								-82.60073583399992,
								27.974906659000055
							],
							[
								-82.60071249099991,
								27.97490222400006
							],
							[
								-82.60046685499992,
								27.974852188000057
							],
							[
								-82.59996338099995,
								27.974778322000077
							],
							[
								-82.59990999999991,
								27.974778322000077
							],
							[
								-82.59973345799995,
								27.974778322000077
							],
							[
								-82.59928501799993,
								27.974850038000056
							],
							[
								-82.59922968399991,
								27.974857134000047
							],
							[
								-82.59875547699994,
								27.974903056000073
							],
							[
								-82.5982045049999,
								27.974996241000042
							],
							[
								-82.5974657239999,
								27.97516717500008
							],
							[
								-82.59741154599993,
								27.97517796900007
							],
							[
								-82.59658754599991,
								27.975315969000064
							],
							[
								-82.59644829399991,
								27.97532827400005
							],
							[
								-82.59402309799992,
								27.975353306000045
							],
							[
								-82.5924599999999,
								27.975353322000046
							],
							[
								-82.59234721399991,
								27.97534622200004
							],
							[
								-82.5919042139999,
								27.97529022200007
							],
							[
								-82.59185807199992,
								27.97528316800009
							],
							[
								-82.5914180719999,
								27.97520416800006
							],
							[
								-82.5912694139999,
								27.975164086000063
							],
							[
								-82.59122869499993,
								27.97514813400005
							],
							[
								-82.59004962799992,
								27.974652828000046
							],
							[
								-82.58993934499995,
								27.97461140900009
							],
							[
								-82.58868276899994,
								27.974439932000053
							],
							[
								-82.58865382199991,
								27.974436402000038
							],
							[
								-82.5885861889999,
								27.97443325200004
							],
							[
								-82.5872321619999,
								27.974364153000067
							],
							[
								-82.58718627099995,
								27.97436063200007
							],
							[
								-82.58639562199994,
								27.974279565000074
							],
							[
								-82.5861449709999,
								27.974253497000067
							],
							[
								-82.5860867419999,
								27.97424551000006
							],
							[
								-82.58385374099993,
								27.973864511000045
							],
							[
								-82.58376361799992,
								27.973844323000037
							],
							[
								-82.58213061799995,
								27.97338932300005
							],
							[
								-82.58208793499995,
								27.973376280000082
							],
							[
								-82.5805139339999,
								27.97285228000004
							],
							[
								-82.58047775299991,
								27.972839371000077
							],
							[
								-82.5789707909999,
								27.972265101000062
							],
							[
								-82.57588759999993,
								27.971214870000043
							],
							[
								-82.57431522099995,
								27.970710316000066
							],
							[
								-82.57422643599995,
								27.970676558000036
							],
							[
								-82.57284505099994,
								27.970065996000073
							],
							[
								-82.57134536599995,
								27.969503614000075
							],
							[
								-82.57108953499994,
								27.969410535000065
							],
							[
								-82.57108791299993,
								27.969479456000045
							],
							[
								-82.5710949999999,
								27.969606268000064
							],
							[
								-82.57110907899994,
								27.969873733000043
							],
							[
								-82.57111032199994,
								27.969921000000056
							],
							[
								-82.57110117099995,
								27.970048968000075
							],
							[
								-82.5709871709999,
								27.97084196900005
							],
							[
								-82.5709733889999,
								27.970915799000068
							],
							[
								-82.57093838899993,
								27.971067799000082
							],
							[
								-82.57091852999991,
								27.971140113000047
							],
							[
								-82.57089271399991,
								27.971210520000056
							],
							[
								-82.57086112299993,
								27.971278532000042
							],
							[
								-82.57082397599993,
								27.97134367500007
							],
							[
								-82.5708222799999,
								27.97134614500004
							],
							[
								-82.5700829999999,
								27.97106800000006
							],
							[
								-82.5698799999999,
								27.97103400000009
							],
							[
								-82.56968799999993,
								27.97109400000005
							],
							[
								-82.56935199999992,
								27.97112300000009
							],
							[
								-82.56897499999991,
								27.97114300000004
							],
							[
								-82.5688429999999,
								27.971125000000086
							],
							[
								-82.5687509999999,
								27.971044000000063
							],
							[
								-82.56849799999992,
								27.970766000000083
							],
							[
								-82.56846685699992,
								27.97076874800007
							],
							[
								-82.56832799999995,
								27.970781000000045
							],
							[
								-82.5683479999999,
								27.97111300000006
							],
							[
								-82.56826799999993,
								27.97138300000006
							],
							[
								-82.56814054099993,
								27.971387828000047
							],
							[
								-82.56813599999992,
								27.971388000000047
							],
							[
								-82.56813201699993,
								27.971398812000075
							],
							[
								-82.5681219999999,
								27.971426000000065
							],
							[
								-82.56786799999992,
								27.97165300000006
							],
							[
								-82.56786722499993,
								27.971653551000088
							],
							[
								-82.56743199999994,
								27.971963000000073
							],
							[
								-82.56735499999992,
								27.972022000000038
							],
							[
								-82.56714799999992,
								27.972181000000035
							],
							[
								-82.56708234299992,
								27.97220905000006
							],
							[
								-82.56693499999994,
								27.97227200000009
							],
							[
								-82.56685644899994,
								27.97229419900009
							],
							[
								-82.5667509999999,
								27.97232400000007
							],
							[
								-82.56629499999991,
								27.972455000000082
							],
							[
								-82.56548299999992,
								27.97267500000004
							],
							[
								-82.56511899999992,
								27.97273800000005
							],
							[
								-82.56477499999994,
								27.972729000000072
							],
							[
								-82.56464499999993,
								27.97271900000004
							],
							[
								-82.56449399999991,
								27.97270700000007
							],
							[
								-82.56398999999993,
								27.97260700000004
							],
							[
								-82.56383699999992,
								27.97260200000005
							],
							[
								-82.56374599999994,
								27.97262100000006
							],
							[
								-82.56367099999994,
								27.972637000000077
							],
							[
								-82.56361810999994,
								27.97264600300008
							],
							[
								-82.56331141999993,
								27.972698205000086
							],
							[
								-82.56329499999993,
								27.972701000000086
							],
							[
								-82.5632800649999,
								27.97269916500005
							],
							[
								-82.56300199999993,
								27.972665000000063
							],
							[
								-82.56279099999995,
								27.972593000000074
							],
							[
								-82.56268899999992,
								27.972570000000076
							],
							[
								-82.56229680399991,
								27.972577131000037
							],
							[
								-82.56224899999995,
								27.972578000000055
							],
							[
								-82.56182099999995,
								27.97256200000004
							],
							[
								-82.56164199999995,
								27.97254600000008
							],
							[
								-82.56150931699995,
								27.972488629000054
							],
							[
								-82.56146732199994,
								27.972470470000076
							],
							[
								-82.5608949999999,
								27.972223000000042
							],
							[
								-82.56067699999994,
								27.972120000000075
							],
							[
								-82.55957299999994,
								27.971596000000094
							],
							[
								-82.5593659999999,
								27.971482000000037
							],
							[
								-82.55924799999993,
								27.971400000000074
							],
							[
								-82.55920099999993,
								27.971351000000084
							],
							[
								-82.55917899999992,
								27.971299000000045
							],
							[
								-82.55914199999995,
								27.97118100000006
							],
							[
								-82.55912499999994,
								27.97089300000005
							],
							[
								-82.5587799999999,
								27.970139000000074
							],
							[
								-82.55878799999994,
								27.970067000000085
							],
							[
								-82.55876299999994,
								27.969952000000035
							],
							[
								-82.55889799999994,
								27.968413000000055
							],
							[
								-82.55001499999993,
								27.968300000000056
							],
							[
								-82.55001399999992,
								27.970872000000046
							],
							[
								-82.55000799999993,
								27.970994000000076
							],
							[
								-82.54981499999991,
								27.970994000000076
							],
							[
								-82.5473179999999,
								27.97111700000005
							],
							[
								-82.54661499999992,
								27.971150000000083
							],
							[
								-82.54725019699993,
								27.97182741800009
							],
							[
								-82.54729199999993,
								27.971872000000076
							],
							[
								-82.54737018299994,
								27.97198577800009
							],
							[
								-82.54865599999994,
								27.973857000000066
							],
							[
								-82.54890599999993,
								27.97399100000007
							],
							[
								-82.54915399999993,
								27.97404700000004
							],
							[
								-82.54952999999995,
								27.974081000000073
							],
							[
								-82.54984306199992,
								27.97407956300009
							],
							[
								-82.55033512799992,
								27.974077304000048
							],
							[
								-82.55061899999993,
								27.974076000000082
							],
							[
								-82.55125456899992,
								27.974074298000062
							],
							[
								-82.55136599999992,
								27.974074000000087
							],
							[
								-82.55177999999995,
								27.97407300000009
							],
							[
								-82.55181817999994,
								27.97407314800006
							],
							[
								-82.55306899999994,
								27.974078000000077
							],
							[
								-82.55311816799991,
								27.974077831000045
							],
							[
								-82.55394399999994,
								27.974075000000084
							],
							[
								-82.55400007999992,
								27.974075750000054
							],
							[
								-82.5540295369999,
								27.974076144000037
							],
							[
								-82.55543999999992,
								27.97409500000009
							],
							[
								-82.55670826499994,
								27.97408422700005
							],
							[
								-82.55673499999995,
								27.97408400000006
							],
							[
								-82.55680808299991,
								27.974083758000063
							],
							[
								-82.5579449999999,
								27.974080000000075
							],
							[
								-82.55812999999995,
								27.974079000000078
							],
							[
								-82.55819142199994,
								27.974089379000077
							],
							[
								-82.55849099999995,
								27.97414000000009
							],
							[
								-82.55882399999992,
								27.97438500000004
							],
							[
								-82.55879599999992,
								27.977816000000075
							],
							[
								-82.55878899999993,
								27.978665000000035
							],
							[
								-82.55878399999995,
								27.97924400000005
							],
							[
								-82.55876799999993,
								27.98077600000005
							],
							[
								-82.55874399999993,
								27.98181100000005
							],
							[
								-82.5583289999999,
								27.981797000000086
							],
							[
								-82.55703799999992,
								27.98179500000009
							],
							[
								-82.55669799999993,
								27.98178900000005
							],
							[
								-82.55631799999992,
								27.981787000000054
							],
							[
								-82.55281295599991,
								27.981770720000043
							],
							[
								-82.5527636459999,
								27.981770491000077
							],
							[
								-82.55201199999993,
								27.981767000000048
							],
							[
								-82.55198342699994,
								27.98176652400008
							],
							[
								-82.55056999999994,
								27.98174300000005
							],
							[
								-82.55033999999995,
								27.981741000000056
							],
							[
								-82.54910799999993,
								27.981701000000044
							],
							[
								-82.54874499999994,
								27.981697000000057
							],
							[
								-82.54697399999992,
								27.98171700000006
							],
							[
								-82.54693611099992,
								27.981716920000054
							],
							[
								-82.54655482099992,
								27.98171611400005
							],
							[
								-82.54650099999992,
								27.981716000000063
							],
							[
								-82.54658799999993,
								27.979344000000083
							],
							[
								-82.5468009999999,
								27.97689300000008
							],
							[
								-82.54681899999991,
								27.976675000000057
							],
							[
								-82.5469219609999,
								27.97549007100008
							],
							[
								-82.54699599999992,
								27.974638000000084
							],
							[
								-82.54698899999994,
								27.974322000000086
							],
							[
								-82.54660999999993,
								27.974330000000066
							],
							[
								-82.54629199999994,
								27.974337000000048
							],
							[
								-82.54620499999993,
								27.974337000000048
							],
							[
								-82.54599799999994,
								27.974345000000085
							],
							[
								-82.54392414299991,
								27.97441040600006
							],
							[
								-82.54371845599992,
								27.97441689300007
							],
							[
								-82.5426369999999,
								27.974451000000045
							],
							[
								-82.54264999999992,
								27.981913000000077
							],
							[
								-82.54261799999995,
								27.985613000000058
							],
							[
								-82.53829018999994,
								27.98562899400008
							],
							[
								-82.53801799999991,
								27.98563000000007
							],
							[
								-82.53798799999993,
								27.98653100000007
							],
							[
								-82.53798799999993,
								27.98656800000009
							],
							[
								-82.53798399999994,
								27.98672600000009
							],
							[
								-82.53797999999995,
								27.986845000000073
							],
							[
								-82.53797999999995,
								27.986883000000034
							],
							[
								-82.53791799999995,
								27.989035000000058
							],
							[
								-82.53792858799994,
								27.989281546000086
							],
							[
								-82.53793899999994,
								27.989524000000078
							],
							[
								-82.53438215799991,
								27.989419056000088
							],
							[
								-82.53414299999991,
								27.989412000000073
							],
							[
								-82.53425799999991,
								27.992611000000068
							],
							[
								-82.5342369999999,
								27.99412600000005
							],
							[
								-82.5340119999999,
								27.994746000000077
							],
							[
								-82.53396499999991,
								27.995100000000036
							],
							[
								-82.5339699999999,
								27.996218000000056
							],
							[
								-82.53394673199995,
								27.996864859000087
							],
							[
								-82.5339449999999,
								27.996913000000063
							],
							[
								-82.53396199999992,
								27.997047000000066
							],
							[
								-82.53381899999994,
								27.997047000000066
							]
						],
						[
							[
								-82.55954891599993,
								27.968990716000064
							],
							[
								-82.55955018499992,
								27.96903219400008
							],
							[
								-82.55961599999995,
								27.969025678000037
							],
							[
								-82.55964596199993,
								27.969026177000046
							],
							[
								-82.55982863799994,
								27.969032275000075
							],
							[
								-82.5611973149999,
								27.96908605300007
							],
							[
								-82.5612375629999,
								27.96908234600005
							],
							[
								-82.56128965599993,
								27.969071244000077
							],
							[
								-82.56139950099993,
								27.96902623400007
							],
							[
								-82.56230881099992,
								27.968600175000066
							],
							[
								-82.56219883499995,
								27.968589659000088
							],
							[
								-82.56215280099991,
								27.968580881000037
							],
							[
								-82.5620851409999,
								27.96859127500005
							],
							[
								-82.5620381409999,
								27.968596275000042
							],
							[
								-82.56201568299991,
								27.96859838000006
							],
							[
								-82.56197868299995,
								27.968601380000052
							],
							[
								-82.56190599999991,
								27.96860432200009
							],
							[
								-82.56181346099994,
								27.968599548000043
							],
							[
								-82.56168056999991,
								27.968585801000078
							],
							[
								-82.56154280399994,
								27.968584252000085
							],
							[
								-82.5595210759999,
								27.968556626000066
							],
							[
								-82.55952791499993,
								27.96861571700009
							],
							[
								-82.55954891599993,
								27.968990716000064
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Tampa International Airport Area",
				"RegionID": "275668"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.49291814899993,
					27.91872884600008,
					-82.48194553299993,
					27.932190847000076
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.48948040699992,
							27.91873350900005
						],
						[
							-82.48948294999991,
							27.91872884600008
						],
						[
							-82.49025199999994,
							27.919197000000054
						],
						[
							-82.49061935499992,
							27.919313964000082
						],
						[
							-82.49291814899993,
							27.919500076000077
						],
						[
							-82.49181818099993,
							27.921400001000055
						],
						[
							-82.48865454499992,
							27.925581819000058
						],
						[
							-82.48611821899993,
							27.928900014000078
						],
						[
							-82.48442684199995,
							27.930783813000062
						],
						[
							-82.48316376499992,
							27.932190847000076
						],
						[
							-82.48331835199991,
							27.926499954000064
						],
						[
							-82.48260909099992,
							27.925390909000043
						],
						[
							-82.48243020799993,
							27.925110587000063
						],
						[
							-82.48194553299993,
							27.92435271900007
						],
						[
							-82.48478297299994,
							27.922637266000038
						],
						[
							-82.48523322499994,
							27.92237330900008
						],
						[
							-82.48567615399992,
							27.922063698000045
						],
						[
							-82.48601986499996,
							27.921775086000082
						],
						[
							-82.4871849349999,
							27.920682894000038
						],
						[
							-82.48724199399993,
							27.92063372800004
						],
						[
							-82.48785499399992,
							27.920148727000083
						],
						[
							-82.48787573599992,
							27.92013280100008
						],
						[
							-82.48882451899993,
							27.919425996000086
						],
						[
							-82.48926306599992,
							27.91900920300009
						],
						[
							-82.48939851699994,
							27.91885781600007
						],
						[
							-82.48948040699992,
							27.91873350900005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Tampa-Bayshore Gardens",
				"RegionID": "275669"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.61666721899991,
					30.36258913000006,
					-81.59670988099992,
					30.374755315000073
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.59686290699995,
							30.373289010000068
						],
						[
							-81.59683990799994,
							30.372129011000084
						],
						[
							-81.59681690699996,
							30.370981012000072
						],
						[
							-81.5968089079999,
							30.370867011000087
						],
						[
							-81.59680190799993,
							30.37001001100009
						],
						[
							-81.5968089079999,
							30.369747010000083
						],
						[
							-81.5967859079999,
							30.36953501100004
						],
						[
							-81.59677090799994,
							30.368759010000076
						],
						[
							-81.5967459069999,
							30.36783501000008
						],
						[
							-81.59673290799992,
							30.367344011000057
						],
						[
							-81.59672290799995,
							30.366899010000054
						],
						[
							-81.59670988099992,
							30.366305948000047
						],
						[
							-81.5972729049999,
							30.366216008000038
						],
						[
							-81.59793590599992,
							30.366074008000055
						],
						[
							-81.59871690599994,
							30.365872009000043
						],
						[
							-81.59937890499992,
							30.365710009000058
						],
						[
							-81.60102090599992,
							30.365366008000077
						],
						[
							-81.60223290599993,
							30.36506700800004
						],
						[
							-81.60454990599993,
							30.364501008000047
						],
						[
							-81.60684489899995,
							30.363942069000075
						],
						[
							-81.61265381999993,
							30.36279552700006
						],
						[
							-81.61353007299994,
							30.36258913000006
						],
						[
							-81.6135365209999,
							30.36262333100007
						],
						[
							-81.61414205299991,
							30.364889429000073
						],
						[
							-81.61446037699994,
							30.365371303000074
						],
						[
							-81.61448883599991,
							30.36541733900009
						],
						[
							-81.61455372099994,
							30.36555568700004
						],
						[
							-81.61663374099993,
							30.37119295900004
						],
						[
							-81.61666721899991,
							30.371259051000038
						],
						[
							-81.6158079999999,
							30.371553000000066
						],
						[
							-81.61539690799992,
							30.372238010000046
						],
						[
							-81.61494301699992,
							30.37310716600007
						],
						[
							-81.61417390799994,
							30.373210010000037
						],
						[
							-81.61311490799994,
							30.37327901000009
						],
						[
							-81.60763878599994,
							30.372938863000062
						],
						[
							-81.60732840299994,
							30.374755315000073
						],
						[
							-81.59688585399994,
							30.37431501700007
						],
						[
							-81.59686290699995,
							30.373289010000068
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "University Park",
				"RegionID": "275820"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.51850843864096,
					27.908464106595808,
					-82.50198532989494,
					27.922576516991825
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.50215521992018,
							27.9084882452984
						],
						[
							-82.50625488281273,
							27.908464106595808
						],
						[
							-82.51642727256683,
							27.908581817956907
						],
						[
							-82.51721125924382,
							27.908590890317548
						],
						[
							-82.51785655517544,
							27.908598357388335
						],
						[
							-82.51850843864096,
							27.908605900901527
						],
						[
							-82.5183090904233,
							27.912336364222178
						],
						[
							-82.51829054640302,
							27.91515607692906
						],
						[
							-82.5182604290076,
							27.919757361864527
						],
						[
							-82.51824258286126,
							27.922488847483105
						],
						[
							-82.5059512968767,
							27.922576516991825
						],
						[
							-82.50595148213695,
							27.91979814162196
						],
						[
							-82.50198532989494,
							27.919777192814564
						],
						[
							-82.5020200194435,
							27.916979974849575
						],
						[
							-82.5020200194435,
							27.916299992966593
						],
						[
							-82.50205999250907,
							27.91560002275218
						],
						[
							-82.50211003258542,
							27.914809965651465
						],
						[
							-82.5021200267511,
							27.913970015963258
						],
						[
							-82.5021200267511,
							27.913190027671973
						],
						[
							-82.5021400123846,
							27.910519984633755
						],
						[
							-82.50215521992018,
							27.9084882452984
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Virginia Park",
				"RegionID": "275888"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.5315999638502,
					27.94474104494865,
					-82.51392004998333,
					27.950900032081215
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.51392004998333,
							27.950900032081215
						],
						[
							-82.5140112835053,
							27.94474104494865
						],
						[
							-82.52731997699824,
							27.94492998801038
						],
						[
							-82.52912008695179,
							27.944999842849
						],
						[
							-82.53062003738604,
							27.94650003879825
						],
						[
							-82.5315999638502,
							27.948000045889945
						],
						[
							-82.5251199897996,
							27.95039998025469
						],
						[
							-82.52443001015375,
							27.950460017194647
						],
						[
							-82.52232003519775,
							27.950700002177463
						],
						[
							-82.51821999908641,
							27.950700003076832
						],
						[
							-82.51622002200646,
							27.950900014994083
						],
						[
							-82.51392004998333,
							27.950900032081215
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "West Shore Palms",
				"RegionID": "275987"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.81808195899993,
					26.188959398000065,
					-81.7985119999999,
					26.211242000000084
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.80042099999993,
							26.211242000000084
						],
						[
							-81.80042299999991,
							26.210894000000053
						],
						[
							-81.80040699999995,
							26.210209000000077
						],
						[
							-81.80040354299992,
							26.21005699200009
						],
						[
							-81.80036799999993,
							26.208494000000087
						],
						[
							-81.80036599999994,
							26.20826100000005
						],
						[
							-81.80036299999995,
							26.207985000000065
						],
						[
							-81.80036099999995,
							26.207896000000062
						],
						[
							-81.8003181389999,
							26.20576189500008
						],
						[
							-81.80031799999995,
							26.205755000000067
						],
						[
							-81.8003152089999,
							26.205562430000043
						],
						[
							-81.8003129999999,
							26.205410000000086
						],
						[
							-81.80029999999994,
							26.20506400000005
						],
						[
							-81.80029599999995,
							26.204766000000063
						],
						[
							-81.80027499999994,
							26.202945000000057
						],
						[
							-81.80026399999991,
							26.20257900000007
						],
						[
							-81.80025999999992,
							26.201960000000042
						],
						[
							-81.80024299999991,
							26.200923000000046
						],
						[
							-81.80020850599993,
							26.19922589800007
						],
						[
							-81.80020799999994,
							26.199201000000073
						],
						[
							-81.80020732499992,
							26.199154408000084
						],
						[
							-81.80018399999996,
							26.19754400000005
						],
						[
							-81.80017199999992,
							26.19703100000004
						],
						[
							-81.80016899999993,
							26.19653100000005
						],
						[
							-81.8001129999999,
							26.195597000000078
						],
						[
							-81.80010299999992,
							26.195194000000072
						],
						[
							-81.80010004899992,
							26.195048790000044
						],
						[
							-81.80007899999993,
							26.19401300000004
						],
						[
							-81.8000419999999,
							26.193740000000048
						],
						[
							-81.80002999999994,
							26.193378000000052
						],
						[
							-81.80000999999993,
							26.192664000000036
						],
						[
							-81.79997999999995,
							26.190877000000057
						],
						[
							-81.7986242739999,
							26.190874222000048
						],
						[
							-81.79851599999995,
							26.190874000000065
						],
						[
							-81.7985119999999,
							26.19067700000005
						],
						[
							-81.79865599999994,
							26.19067300000006
						],
						[
							-81.79881399999994,
							26.190655000000053
						],
						[
							-81.79895199999993,
							26.190629000000058
						],
						[
							-81.79913099999993,
							26.190582000000063
						],
						[
							-81.7992329999999,
							26.190567000000044
						],
						[
							-81.7995049999999,
							26.19055300000008
						],
						[
							-81.7999749999999,
							26.190556000000072
						],
						[
							-81.79997036299994,
							26.19026720100004
						],
						[
							-81.79995449299992,
							26.189278714000068
						],
						[
							-81.8000102709999,
							26.189278714000068
						],
						[
							-81.80049570199992,
							26.189278714000068
						],
						[
							-81.80151555899994,
							26.18926900100007
						],
						[
							-81.80193321399992,
							26.18930785300006
						],
						[
							-81.80230230599994,
							26.18926900100007
						],
						[
							-81.80254512899995,
							26.18933699200005
						],
						[
							-81.80294335899993,
							26.189317566000057
						],
						[
							-81.80342900499994,
							26.189317566000057
						],
						[
							-81.80376895699993,
							26.189210723000087
						],
						[
							-81.80424488999995,
							26.18920101100008
						],
						[
							-81.80473053599991,
							26.189249575000076
						],
						[
							-81.8055464219999,
							26.18920101100008
						],
						[
							-81.80676053799993,
							26.189171872000088
						],
						[
							-81.80762498799993,
							26.18920101100008
						],
						[
							-81.80813977299995,
							26.18920101100008
						],
						[
							-81.80841954699991,
							26.189167078000082
						],
						[
							-81.8084666659999,
							26.18916098400007
						],
						[
							-81.80846558699994,
							26.18913119000007
						],
						[
							-81.8084649999999,
							26.189115000000072
						],
						[
							-81.81109737199995,
							26.18902254900007
						],
						[
							-81.81105956499994,
							26.189060575000042
						],
						[
							-81.81101085499995,
							26.189102991000084
						],
						[
							-81.81095922599991,
							26.18914180200005
						],
						[
							-81.81086022699992,
							26.18921080100006
						],
						[
							-81.81079566099993,
							26.18925183600004
						],
						[
							-81.81066494499993,
							26.189313865000088
						],
						[
							-81.8105722649999,
							26.189348975000087
						],
						[
							-81.8104225269999,
							26.189389686000084
						],
						[
							-81.81050228899994,
							26.18949239300008
						],
						[
							-81.81057726699993,
							26.18960566800007
						],
						[
							-81.8108122669999,
							26.19002666700004
						],
						[
							-81.81084733699993,
							26.19009645300008
						],
						[
							-81.8108762199999,
							26.190169018000063
						],
						[
							-81.8108986979999,
							26.190243816000077
						],
						[
							-81.81091460199991,
							26.190320281000083
						],
						[
							-81.81092381099995,
							26.19039783800008
						],
						[
							-81.81094081099991,
							26.190624838000076
						],
						[
							-81.81094599399995,
							26.190743810000072
						],
						[
							-81.8110541229999,
							26.190831668000044
						],
						[
							-81.81115251099993,
							26.190925333000052
						],
						[
							-81.81124540699994,
							26.19102822400004
						],
						[
							-81.81119662299994,
							26.190811457000056
						],
						[
							-81.81118494099991,
							26.190749474000086
						],
						[
							-81.81115294099993,
							26.190539474000047
						],
						[
							-81.8111431079999,
							26.190431802000035
						],
						[
							-81.8111401079999,
							26.190334802000052
						],
						[
							-81.8111396779999,
							26.190307000000075
						],
						[
							-81.81115013499993,
							26.19017026000006
						],
						[
							-81.81115813399992,
							26.190118260000077
						],
						[
							-81.8111730519999,
							26.19004287900009
						],
						[
							-81.81119434999994,
							26.18996904700009
						],
						[
							-81.8112218739999,
							26.189897303000066
						],
						[
							-81.81125542099994,
							26.189828170000055
						],
						[
							-81.81129474799991,
							26.18976215400005
						],
						[
							-81.81131374799992,
							26.189733153000077
						],
						[
							-81.8113770789999,
							26.18964792700007
						],
						[
							-81.81148073999992,
							26.18954317400005
						],
						[
							-81.81151933399991,
							26.189510127000062
						],
						[
							-81.81165133899992,
							26.189417164000076
						],
						[
							-81.81175568799995,
							26.189365615000042
						],
						[
							-81.81185668699993,
							26.189323615000035
						],
						[
							-81.81189441299995,
							26.189308914000037
						],
						[
							-81.81200754999992,
							26.18927859900009
						],
						[
							-81.81199668399995,
							26.188990964000084
						],
						[
							-81.81289545499993,
							26.188959398000065
						],
						[
							-81.8136293099999,
							26.18896140600009
						],
						[
							-81.81569813299991,
							26.188966018000087
						],
						[
							-81.81659921699992,
							26.188986356000044
						],
						[
							-81.81660282699994,
							26.18906847900007
						],
						[
							-81.8166264589999,
							26.189254581000057
						],
						[
							-81.81666065799993,
							26.189430898000072
						],
						[
							-81.81675982599995,
							26.189815409000065
						],
						[
							-81.81677746799996,
							26.189900703000035
						],
						[
							-81.81681446899995,
							26.190136703000064
						],
						[
							-81.8168238149999,
							26.19022395400009
						],
						[
							-81.81685108699992,
							26.190694394000047
						],
						[
							-81.81688908399991,
							26.191135762000044
						],
						[
							-81.81695616099995,
							26.19193366400009
						],
						[
							-81.81695774399992,
							26.19195574400004
						],
						[
							-81.81697874399993,
							26.192309744000056
						],
						[
							-81.81698032199995,
							26.192363000000057
						],
						[
							-81.81698032199995,
							26.192486546000055
						],
						[
							-81.81699847499993,
							26.192693038000073
						],
						[
							-81.81708152099992,
							26.19324852400007
						],
						[
							-81.81717975399994,
							26.19375316600008
						],
						[
							-81.81719085499992,
							26.19382598100009
						],
						[
							-81.81722785499994,
							26.19415998100004
						],
						[
							-81.8172301269999,
							26.194183252000073
						],
						[
							-81.81728169699994,
							26.19479333600009
						],
						[
							-81.8173326289999,
							26.19520848800005
						],
						[
							-81.81733897799995,
							26.19529312700007
						],
						[
							-81.81736643699992,
							26.19628557100009
						],
						[
							-81.81743404599992,
							26.19723405800005
						],
						[
							-81.81743542199992,
							26.197257773000047
						],
						[
							-81.81747093899992,
							26.198050987000045
						],
						[
							-81.81751666799994,
							26.19871603900009
						],
						[
							-81.81756213799991,
							26.19959986200007
						],
						[
							-81.8175622199999,
							26.199690507000074
						],
						[
							-81.81753071999992,
							26.20032622300005
						],
						[
							-81.81753783999994,
							26.200724007000076
						],
						[
							-81.8175697069999,
							26.20125513800008
						],
						[
							-81.81757130099993,
							26.201302892000058
						],
						[
							-81.81757521999992,
							26.201879873000053
						],
						[
							-81.81760281699992,
							26.202702859000055
						],
						[
							-81.8176032799999,
							26.202741710000055
						],
						[
							-81.81759951799995,
							26.20313011500008
						],
						[
							-81.81762741099993,
							26.20374954400006
						],
						[
							-81.81762788499992,
							26.20381801200006
						],
						[
							-81.8175843169999,
							26.20521608100006
						],
						[
							-81.8176333589999,
							26.205906105000054
						],
						[
							-81.81766400799995,
							26.20604436900004
						],
						[
							-81.8176771659999,
							26.206118158000038
						],
						[
							-81.8176931669999,
							26.20623615800008
						],
						[
							-81.81770014999995,
							26.206311088000064
						],
						[
							-81.81771355799992,
							26.20657339400009
						],
						[
							-81.81773457299994,
							26.20670050600006
						],
						[
							-81.81778597899995,
							26.206854033000074
						],
						[
							-81.81781417299993,
							26.20693861500007
						],
						[
							-81.81784822199995,
							26.20707597200004
						],
						[
							-81.81787722199994,
							26.207250972000054
						],
						[
							-81.81788711599995,
							26.207335046000082
						],
						[
							-81.81789911599992,
							26.207506046000052
						],
						[
							-81.81790113099993,
							26.20758752000006
						],
						[
							-81.81789059399995,
							26.208099082000047
						],
						[
							-81.81789871199993,
							26.208376010000052
						],
						[
							-81.81792214899991,
							26.20888186500008
						],
						[
							-81.81797885599991,
							26.20988720500009
						],
						[
							-81.81808195899993,
							26.210636211000065
						],
						[
							-81.81763599999994,
							26.210686000000067
						],
						[
							-81.8171878949999,
							26.210735868000086
						],
						[
							-81.81700557799991,
							26.21075615700005
						],
						[
							-81.81700509699994,
							26.210756210000056
						],
						[
							-81.8169979999999,
							26.210757000000058
						],
						[
							-81.8163891129999,
							26.210768473000087
						],
						[
							-81.81614680399991,
							26.21077303800007
						],
						[
							-81.81564425699992,
							26.21078250700009
						],
						[
							-81.81556499999994,
							26.210784000000046
						],
						[
							-81.81550874999994,
							26.210786876000046
						],
						[
							-81.81529193799992,
							26.210797961000086
						],
						[
							-81.81405899999993,
							26.21086100000008
						],
						[
							-81.81288199999995,
							26.210892000000058
						],
						[
							-81.81236999999993,
							26.210965000000044
						],
						[
							-81.8102199999999,
							26.210953000000075
						],
						[
							-81.80993099999996,
							26.210980000000063
						],
						[
							-81.80972799999995,
							26.211055000000044
						],
						[
							-81.80935499999993,
							26.211197000000084
						],
						[
							-81.80817599999995,
							26.211224000000072
						],
						[
							-81.80760499999991,
							26.211239000000035
						],
						[
							-81.80696999999992,
							26.211213000000043
						],
						[
							-81.80677999999995,
							26.21113500000007
						],
						[
							-81.80414699999994,
							26.21117600000008
						],
						[
							-81.80042099999993,
							26.211242000000084
						]
					],
					[
						[
							-81.8114383759999,
							26.19264722500009
						],
						[
							-81.81139516999991,
							26.19258552000008
						],
						[
							-81.81133593399994,
							26.192691314000058
						],
						[
							-81.81129993399992,
							26.192744314000038
						],
						[
							-81.81126857999993,
							26.192785782000044
						],
						[
							-81.81131791099995,
							26.19282337900006
						],
						[
							-81.8113822439999,
							26.19272365900008
						],
						[
							-81.8114383759999,
							26.19264722500009
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Collier",
				"City": "Naples",
				"Name": "Park Shore",
				"RegionID": "276507"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.6795509289999,
					30.32028567800006,
					-81.64615471699994,
					30.337044070000044
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.65303690499991,
							30.32995100800008
						],
						[
							-81.65150181199994,
							30.329608845000052
						],
						[
							-81.65127690499992,
							30.330349008000045
						],
						[
							-81.6510549859999,
							30.331104052000057
						],
						[
							-81.65082890699995,
							30.33110200800007
						],
						[
							-81.65063790699992,
							30.331079009000067
						],
						[
							-81.6503389049999,
							30.331027008000035
						],
						[
							-81.6501929069999,
							30.330981009000087
						],
						[
							-81.65012390599992,
							30.330957008000045
						],
						[
							-81.65005190399995,
							30.330934008000042
						],
						[
							-81.65002190599995,
							30.330924009000057
						],
						[
							-81.6499229069999,
							30.33088200800006
						],
						[
							-81.64981290499992,
							30.330820008000043
						],
						[
							-81.64974690399994,
							30.330782008000085
						],
						[
							-81.6496989069999,
							30.33075100800005
						],
						[
							-81.64963890699994,
							30.330707008000047
						],
						[
							-81.64961790599996,
							30.33068600900009
						],
						[
							-81.64958791499993,
							30.330659818000072
						],
						[
							-81.64953390599993,
							30.330699008000067
						],
						[
							-81.64948872699995,
							30.330736006000052
						],
						[
							-81.64963190399993,
							30.330859008000065
						],
						[
							-81.64973208899994,
							30.33094201100005
						],
						[
							-81.64942590099993,
							30.33115819600005
						],
						[
							-81.64935890599992,
							30.331110008000053
						],
						[
							-81.64934093999995,
							30.331095933000086
						],
						[
							-81.64927490699995,
							30.331086009000042
						],
						[
							-81.64923377999992,
							30.33108515100008
						],
						[
							-81.6492269069999,
							30.33101300800007
						],
						[
							-81.64922973599994,
							30.33050892400007
						],
						[
							-81.64927458599993,
							30.330478017000075
						],
						[
							-81.64920990699994,
							30.33041700900009
						],
						[
							-81.64908690699991,
							30.33031100800008
						],
						[
							-81.6489829059999,
							30.330218009000077
						],
						[
							-81.6488929059999,
							30.330141009000048
						],
						[
							-81.64877290599992,
							30.330040008000083
						],
						[
							-81.6484859059999,
							30.32985400900009
						],
						[
							-81.64814390399994,
							30.32969200900004
						],
						[
							-81.64801479999994,
							30.329641904000084
						],
						[
							-81.64804201999995,
							30.32969911400005
						],
						[
							-81.64791390599993,
							30.32965800800008
						],
						[
							-81.64773390699992,
							30.329608008000037
						],
						[
							-81.64755990399993,
							30.329563009000083
						],
						[
							-81.6468798329999,
							30.329398951000087
						],
						[
							-81.64689890599995,
							30.329358008000046
						],
						[
							-81.64691690599994,
							30.329323009000063
						],
						[
							-81.64701490599992,
							30.329069009000076
						],
						[
							-81.6472239069999,
							30.328408009000047
						],
						[
							-81.64744290899995,
							30.327678007000088
						],
						[
							-81.6477719529999,
							30.327036036000038
						],
						[
							-81.64783808999994,
							30.326547952000052
						],
						[
							-81.64780372099996,
							30.326514033000084
						],
						[
							-81.64787609099994,
							30.326370000000058
						],
						[
							-81.64768690499994,
							30.326092009000035
						],
						[
							-81.64757690699992,
							30.325917009000083
						],
						[
							-81.64753490599992,
							30.32585800800007
						],
						[
							-81.64748390599993,
							30.32575300900004
						],
						[
							-81.64717096499993,
							30.32530094600008
						],
						[
							-81.64691775499995,
							30.32514911200008
						],
						[
							-81.64673106599992,
							30.324166930000047
						],
						[
							-81.64615471699994,
							30.323585011000038
						],
						[
							-81.64644902299995,
							30.323244075000048
						],
						[
							-81.64651890499994,
							30.323045009000055
						],
						[
							-81.6471009999999,
							30.321569000000068
						],
						[
							-81.6472070239999,
							30.320559262000074
						],
						[
							-81.64773608699994,
							30.320349169000053
						],
						[
							-81.6477604129999,
							30.320339914000044
						],
						[
							-81.6479118339999,
							30.32029934100007
						],
						[
							-81.64806799999991,
							30.32028567800006
						],
						[
							-81.64822416499993,
							30.32029934100007
						],
						[
							-81.64837558599993,
							30.320339914000044
						],
						[
							-81.64840601399993,
							30.320351618000075
						],
						[
							-81.64854901399991,
							30.320409618000042
						],
						[
							-81.64861531399993,
							30.320439586000077
						],
						[
							-81.64867894399993,
							30.320474871000048
						],
						[
							-81.64873947899991,
							30.320515237000055
						],
						[
							-81.64879651299992,
							30.32056041400006
						],
						[
							-81.64884966499994,
							30.320610100000067
						],
						[
							-81.64889857999992,
							30.320663962000083
						],
						[
							-81.64894293099991,
							30.32072164000005
						],
						[
							-81.64898242099991,
							30.32078275000003
						],
						[
							-81.6490536899999,
							30.320761472000076
						],
						[
							-81.64912650399992,
							30.320746305000057
						],
						[
							-81.64920034199992,
							30.32073735800009
						],
						[
							-81.64927467199993,
							30.320734695000056
						],
						[
							-81.64934895999994,
							30.32073833600009
						],
						[
							-81.64942267399994,
							30.320748255000073
						],
						[
							-81.64958791999993,
							30.320777297000067
						],
						[
							-81.64973958699994,
							30.32081791400009
						],
						[
							-81.64981463599992,
							30.32085291000004
						],
						[
							-81.64986299999993,
							30.32084867800006
						],
						[
							-81.64998702399993,
							30.32085727100008
						],
						[
							-81.6502240239999,
							30.32089027100005
						],
						[
							-81.65029216599993,
							30.320902139000054
						],
						[
							-81.65035910899991,
							30.32091954400005
						],
						[
							-81.65042440199994,
							30.320942371000058
						],
						[
							-81.65048760699995,
							30.320970464000084
						],
						[
							-81.6505483009999,
							30.321003637000047
						],
						[
							-81.65060607599992,
							30.321041667000085
						],
						[
							-81.65069533899992,
							30.320979164000047
						],
						[
							-81.65083741399991,
							30.32091291400008
						],
						[
							-81.65098883499991,
							30.320872341000044
						],
						[
							-81.65114499999993,
							30.320858678000036
						],
						[
							-81.65130116599994,
							30.320872341000044
						],
						[
							-81.65132255199991,
							30.320876379000087
						],
						[
							-81.65146655199993,
							30.320905379000067
						],
						[
							-81.65159658599993,
							30.32094191400006
						],
						[
							-81.65173866099991,
							30.321008165000077
						],
						[
							-81.65186707299995,
							30.321098080000073
						],
						[
							-81.65197791999992,
							30.321208927000043
						],
						[
							-81.65206783499991,
							30.32133733900008
						],
						[
							-81.65213408599993,
							30.321479414000066
						],
						[
							-81.65217465899993,
							30.321630835000065
						],
						[
							-81.65218832199992,
							30.321787000000086
						],
						[
							-81.65218126399992,
							30.321867676000068
						],
						[
							-81.65225735199994,
							30.32185286800006
						],
						[
							-81.65233446799994,
							30.321845007000036
						],
						[
							-81.65241197899991,
							30.32184415800009
						],
						[
							-81.65248924799994,
							30.321850328000043
						],
						[
							-81.65256564299995,
							30.321863466000078
						],
						[
							-81.65264053399994,
							30.321883464000052
						],
						[
							-81.6533577639999,
							30.32210420200005
						],
						[
							-81.65342379599991,
							30.322091434000072
						],
						[
							-81.65349062799993,
							30.32208391000006
						],
						[
							-81.6535578459999,
							30.322081676000042
						],
						[
							-81.65362503099993,
							30.322084747000076
						],
						[
							-81.65369176399992,
							30.322093103000046
						],
						[
							-81.65375763199995,
							30.32210669200009
						],
						[
							-81.65516063199993,
							30.322444692000094
						],
						[
							-81.65520821799993,
							30.322457545000077
						],
						[
							-81.65630542799994,
							30.322786430000065
						],
						[
							-81.65856957699992,
							30.32300747100004
						],
						[
							-81.65863878499994,
							30.323015010000063
						],
						[
							-81.65871738399994,
							30.323027145000083
						],
						[
							-81.65879460399992,
							30.32304617600005
						],
						[
							-81.65886983999991,
							30.323071955000042
						],
						[
							-81.65905421199994,
							30.32314438700007
						],
						[
							-81.65973041699993,
							30.32319932300004
						],
						[
							-81.66046016799993,
							30.323212246000086
						],
						[
							-81.66051122699992,
							30.32318921500007
						],
						[
							-81.66057216599995,
							30.323164369000043
						],
						[
							-81.66063475999994,
							30.323144046000035
						],
						[
							-81.66069867199991,
							30.32312835500005
						],
						[
							-81.6607635599999,
							30.323117379000056
						],
						[
							-81.66118798899993,
							30.323061475000088
						],
						[
							-81.66124178099994,
							30.323034157000052
						],
						[
							-81.66131141699992,
							30.323002443000064
						],
						[
							-81.66138349699992,
							30.322976763000046
						],
						[
							-81.66145749899994,
							30.322957304000052
						],
						[
							-81.6615328879999,
							30.322944205000052
						],
						[
							-81.66208588799992,
							30.322872205000067
						],
						[
							-81.66224152399991,
							30.322865547000045
						],
						[
							-81.66315247699993,
							30.32290562100008
						],
						[
							-81.66400361599995,
							30.322903170000075
						],
						[
							-81.66486368699992,
							30.32256353500009
						],
						[
							-81.6649248789999,
							30.32254188900004
						],
						[
							-81.66498747199995,
							30.32252471400005
						],
						[
							-81.66505114099994,
							30.32251209700007
						],
						[
							-81.6651155539999,
							30.322504106000057
						],
						[
							-81.66518037499992,
							30.32250078100009
						],
						[
							-81.66531237499993,
							30.32249878100004
						],
						[
							-81.66541739099995,
							30.322503334000086
						],
						[
							-81.66560338999994,
							30.32252233400004
						],
						[
							-81.66567740699992,
							30.32253302000004
						],
						[
							-81.66575027899995,
							30.322549819000077
						],
						[
							-81.66582150399995,
							30.322572614000077
						],
						[
							-81.6658905889999,
							30.322601249000062
						],
						[
							-81.66595705599991,
							30.322635524000077
						],
						[
							-81.66599209799995,
							30.322655481000087
						],
						[
							-81.66629999999992,
							30.323802000000057
						],
						[
							-81.66719790499991,
							30.325107009000078
						],
						[
							-81.66737987199991,
							30.325365194000085
						],
						[
							-81.6681589239999,
							30.32489481500005
						],
						[
							-81.66826890599992,
							30.32499100800004
						],
						[
							-81.66844490699992,
							30.32512900800009
						],
						[
							-81.66940686199992,
							30.32584816800005
						],
						[
							-81.67034090699991,
							30.325968009000068
						],
						[
							-81.67137290699992,
							30.32624100900006
						],
						[
							-81.67146589599992,
							30.326269060000072
						],
						[
							-81.67243190499994,
							30.32633000900006
						],
						[
							-81.67414090599993,
							30.32671900600008
						],
						[
							-81.67531590699991,
							30.326647008000062
						],
						[
							-81.67616995199995,
							30.326458134000063
						],
						[
							-81.67684188299995,
							30.326020928000048
						],
						[
							-81.67770691599992,
							30.32596906100008
						],
						[
							-81.67806990399993,
							30.32586900900009
						],
						[
							-81.67841390599995,
							30.32577987500008
						],
						[
							-81.67887390699991,
							30.32585300900007
						],
						[
							-81.67915791599995,
							30.325932015000035
						],
						[
							-81.67938490699993,
							30.326088009000046
						],
						[
							-81.67943388299994,
							30.32611013900004
						],
						[
							-81.67946990699994,
							30.32611000900005
						],
						[
							-81.6795509289999,
							30.326120075000066
						],
						[
							-81.6794869069999,
							30.32622800800004
						],
						[
							-81.6794168319999,
							30.326338956000086
						],
						[
							-81.67930890799994,
							30.326479009000085
						],
						[
							-81.67910590299994,
							30.326785009000048
						],
						[
							-81.67903590699991,
							30.326873008000067
						],
						[
							-81.67892890799993,
							30.327007009000052
						],
						[
							-81.6787349089999,
							30.327249008000084
						],
						[
							-81.67870294399995,
							30.327304042000037
						],
						[
							-81.6786059069999,
							30.327397009000038
						],
						[
							-81.67856890699994,
							30.327429009000067
						],
						[
							-81.67847690799994,
							30.327522008000077
						],
						[
							-81.6783829069999,
							30.32762300800005
						],
						[
							-81.67815590799995,
							30.32781000800009
						],
						[
							-81.6776089039999,
							30.328261009000077
						],
						[
							-81.6773879079999,
							30.32843400800004
						],
						[
							-81.67677191899992,
							30.32891920100008
						],
						[
							-81.67673690599992,
							30.328895509000066
						],
						[
							-81.6766649079999,
							30.328853009000056
						],
						[
							-81.67661482699992,
							30.328822864000074
						],
						[
							-81.67661322599992,
							30.32890892200004
						],
						[
							-81.67584350599992,
							30.329626883000063
						],
						[
							-81.67444207999995,
							30.33068573900005
						],
						[
							-81.67322750999995,
							30.331713449000063
						],
						[
							-81.6717637989999,
							30.33283459200004
						],
						[
							-81.67082951399993,
							30.33386230600007
						],
						[
							-81.67040593599995,
							30.33441810100004
						],
						[
							-81.66983294699992,
							30.335170302000055
						],
						[
							-81.6690232329999,
							30.336571727000038
						],
						[
							-81.66884083799994,
							30.337044070000044
						],
						[
							-81.6686799069999,
							30.336925008000037
						],
						[
							-81.66851090699993,
							30.33680500800006
						],
						[
							-81.6683469059999,
							30.33669100800006
						],
						[
							-81.6681969039999,
							30.336583009000037
						],
						[
							-81.66805990699993,
							30.336493008000044
						],
						[
							-81.66796590699994,
							30.33643100900008
						],
						[
							-81.66727390599993,
							30.335942009000068
						],
						[
							-81.66702893699994,
							30.33576793200007
						],
						[
							-81.66649881399991,
							30.335717169000077
						],
						[
							-81.66603900199993,
							30.335136848000047
						],
						[
							-81.66527390399995,
							30.334990008000087
						],
						[
							-81.66477790699992,
							30.33487800800009
						],
						[
							-81.66450990699991,
							30.33482300900005
						],
						[
							-81.66366490599995,
							30.334641008000062
						],
						[
							-81.6635899069999,
							30.334625008000046
						],
						[
							-81.6633479059999,
							30.334571009000058
						],
						[
							-81.66308690699992,
							30.334515008000043
						],
						[
							-81.66220190699994,
							30.334325008000068
						],
						[
							-81.66206490699996,
							30.33429200800003
						],
						[
							-81.66182790499994,
							30.334252008000078
						],
						[
							-81.66133090699992,
							30.334138008000085
						],
						[
							-81.66103974899994,
							30.33407810100005
						],
						[
							-81.6611599069999,
							30.333698008000056
						],
						[
							-81.6612690629999,
							30.33331591200005
						],
						[
							-81.66009190599993,
							30.33307300900009
						],
						[
							-81.65890090599993,
							30.33282700800004
						],
						[
							-81.65788090599995,
							30.332619009000044
						],
						[
							-81.65771390599991,
							30.33257500800005
						],
						[
							-81.6569239069999,
							30.332404009000072
						],
						[
							-81.6562149049999,
							30.332246008000084
						],
						[
							-81.65502874799995,
							30.331985103000076
						],
						[
							-81.65518190699993,
							30.33146100800008
						],
						[
							-81.65523490599992,
							30.33124900900009
						],
						[
							-81.65531890699994,
							30.330952009000043
						],
						[
							-81.65540390599995,
							30.330671008000085
						],
						[
							-81.6554560649999,
							30.330473905000076
						],
						[
							-81.65509790599992,
							30.33039700900008
						],
						[
							-81.65453190599993,
							30.330272008000065
						],
						[
							-81.65426790599992,
							30.330219009000075
						],
						[
							-81.65303690499991,
							30.32995100800008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Downtown Jacksonville",
				"RegionID": "273501"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.16999053899991,
					26.129096032000064,
					-80.15738585299994,
					26.13670330800005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.16567514299993,
							26.13667827200004
						],
						[
							-80.16548686399994,
							26.136672262000047
						],
						[
							-80.1652795569999,
							26.136672262000047
						],
						[
							-80.16467265599994,
							26.136672262000047
						],
						[
							-80.16395459099994,
							26.136672262000047
						],
						[
							-80.16345384899995,
							26.13666425000008
						],
						[
							-80.16214590899995,
							26.136661247000063
						],
						[
							-80.15962016299994,
							26.136625192000054
						],
						[
							-80.15959111899991,
							26.136625192000054
						],
						[
							-80.1588820689999,
							26.136615178000056
						],
						[
							-80.15815599099994,
							26.136615178000056
						],
						[
							-80.15763019399992,
							26.13660316100004
						],
						[
							-80.1575652059999,
							26.13467728800009
						],
						[
							-80.15738585299994,
							26.129392412000072
						],
						[
							-80.15776040499992,
							26.129386457000066
						],
						[
							-80.1585916379999,
							26.129368430000056
						],
						[
							-80.15908136399992,
							26.129357414000083
						],
						[
							-80.1594008379999,
							26.129351405000083
						],
						[
							-80.15982146199991,
							26.129340389000053
						],
						[
							-80.16017097999992,
							26.129334380000046
						],
						[
							-80.16025510499992,
							26.129332377000082
						],
						[
							-80.16054453399994,
							26.12932436500006
						],
						[
							-80.16101122499992,
							26.129314350000072
						],
						[
							-80.16108333299991,
							26.12931234800004
						],
						[
							-80.16126960899993,
							26.129307340000082
						],
						[
							-80.16185748099991,
							26.129295322000075
						],
						[
							-80.16203274099992,
							26.129293319000055
						],
						[
							-80.1626887139999,
							26.12927829700004
						],
						[
							-80.16286497499993,
							26.129276295000068
						],
						[
							-80.16353496799991,
							26.12923723700004
						],
						[
							-80.16369620699993,
							26.129235233000088
						],
						[
							-80.16412284099994,
							26.129217206000078
						],
						[
							-80.16435418299994,
							26.129219209000045
						],
						[
							-80.16511230899994,
							26.12922020900004
						],
						[
							-80.16517940799993,
							26.12921220000004
						],
						[
							-80.16597759199993,
							26.12920719200008
						],
						[
							-80.16613482499992,
							26.12920318500005
						],
						[
							-80.16676175499992,
							26.12917814800005
						],
						[
							-80.1671413169999,
							26.12917814800005
						],
						[
							-80.1676009979999,
							26.12915110900008
						],
						[
							-80.16851235099995,
							26.129136087000063
						],
						[
							-80.16915330199993,
							26.129110048000086
						],
						[
							-80.1693576049999,
							26.129118059000064
						],
						[
							-80.16956491199994,
							26.129102036000063
						],
						[
							-80.16999053899991,
							26.129096032000064
						],
						[
							-80.16996751399995,
							26.136674264000078
						],
						[
							-80.16983431199992,
							26.13667426500007
						],
						[
							-80.16976220399994,
							26.136676268000087
						],
						[
							-80.16949881399995,
							26.136676268000087
						],
						[
							-80.16943571999991,
							26.136676268000087
						],
						[
							-80.16936261199994,
							26.136676268000087
						],
						[
							-80.16921939999992,
							26.136676268000087
						],
						[
							-80.16910122399992,
							26.136676268000087
						],
						[
							-80.16855240899991,
							26.136676268000087
						],
						[
							-80.16772718699991,
							26.136663249000037
						],
						[
							-80.16742673999994,
							26.136656238000057
						],
						[
							-80.16642124999993,
							26.13670330800005
						],
						[
							-80.16618489899992,
							26.136701305000088
						],
						[
							-80.16601865299992,
							26.136697299000048
						],
						[
							-80.16567514299993,
							26.13667827200004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Durrs Homeowners",
				"RegionID": "273517"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.16896799999995,
					26.070365000000038,
					-80.13820707199994,
					26.092768195000076
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.14201797599992,
							26.092768195000076
						],
						[
							-80.13963953299992,
							26.082041152000045
						],
						[
							-80.13878426399992,
							26.08212341600006
						],
						[
							-80.1382844179999,
							26.08202336700009
						],
						[
							-80.1382284789999,
							26.08193605000008
						],
						[
							-80.13820707199994,
							26.08191540900009
						],
						[
							-80.13890299999991,
							26.081893000000036
						],
						[
							-80.1390669999999,
							26.08156500000007
						],
						[
							-80.1392669999999,
							26.079565000000063
						],
						[
							-80.14076734199995,
							26.073876202000065
						],
						[
							-80.14083999999991,
							26.073600708000072
						],
						[
							-80.14166699999993,
							26.07046500000007
						],
						[
							-80.1417669999999,
							26.07046500000007
						],
						[
							-80.1417669999999,
							26.070365000000038
						],
						[
							-80.1421029999999,
							26.07040300000006
						],
						[
							-80.14206699999994,
							26.07046500000007
						],
						[
							-80.14166699999993,
							26.072665000000086
						],
						[
							-80.14089499999994,
							26.075603000000058
						],
						[
							-80.14011099999993,
							26.078573000000063
						],
						[
							-80.13975899999991,
							26.079845000000095
						],
						[
							-80.13974499999995,
							26.07998100000009
						],
						[
							-80.13966299999993,
							26.080771000000084
						],
						[
							-80.13976699999995,
							26.081365000000062
						],
						[
							-80.13956699999994,
							26.081665000000044
						],
						[
							-80.14186699999993,
							26.08156500000007
						],
						[
							-80.1442669999999,
							26.081469000000084
						],
						[
							-80.14436699999993,
							26.08146500000004
						],
						[
							-80.1528669999999,
							26.08156500000007
						],
						[
							-80.15546699999993,
							26.081365000000062
						],
						[
							-80.15666699999991,
							26.081365000000062
						],
						[
							-80.1573679999999,
							26.081365000000062
						],
						[
							-80.15856799999995,
							26.081365000000062
						],
						[
							-80.15935499999995,
							26.08133500000008
						],
						[
							-80.16116799999992,
							26.081265000000087
						],
						[
							-80.16186799999991,
							26.081065000000084
						],
						[
							-80.1673679999999,
							26.08096500000005
						],
						[
							-80.16866799999991,
							26.080865000000074
						],
						[
							-80.16896799999995,
							26.080865000000074
						],
						[
							-80.16896799999995,
							26.081241080000044
						],
						[
							-80.16896799999995,
							26.088200314000066
						],
						[
							-80.16088904399993,
							26.090689067000085
						],
						[
							-80.16065970499994,
							26.090755166000065
						],
						[
							-80.15988755899991,
							26.090958466000075
						],
						[
							-80.15887505799992,
							26.091220855000074
						],
						[
							-80.15845743799991,
							26.091319001000045
						],
						[
							-80.15778944699991,
							26.091514291000067
						],
						[
							-80.15686106999993,
							26.091763660000083
						],
						[
							-80.15667980299992,
							26.091802718000054
						],
						[
							-80.15594771699995,
							26.09197898000008
						],
						[
							-80.15582853899991,
							26.09200802400005
						],
						[
							-80.15555613599992,
							26.092081131000043
						],
						[
							-80.15489715799993,
							26.092242371000058
						],
						[
							-80.15463276699995,
							26.09230546400005
						],
						[
							-80.1539457479999,
							26.092444671000067
						],
						[
							-80.15327875799994,
							26.09255783900005
						],
						[
							-80.15306043399994,
							26.092586881000045
						],
						[
							-80.15285713899993,
							26.092609853000056
						],
						[
							-80.14678212299992,
							26.09258487900007
						],
						[
							-80.14201797599992,
							26.092768195000076
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Edgewood",
				"RegionID": "273603"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.6368879609999,
					30.34528000900008,
					-81.61908767799991,
					30.357023178000077
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.62410989099995,
							30.357023178000077
						],
						[
							-81.62252099999995,
							30.35456600000009
						],
						[
							-81.62186101099991,
							30.354541874000066
						],
						[
							-81.62003825599993,
							30.354761862000093
						],
						[
							-81.61919320999993,
							30.35487020100004
						],
						[
							-81.6191996469999,
							30.35485639600006
						],
						[
							-81.6191419139999,
							30.35473258600007
						],
						[
							-81.61910134099992,
							30.354581166000063
						],
						[
							-81.61908767799991,
							30.35442500000005
						],
						[
							-81.61910134099992,
							30.354268835000084
						],
						[
							-81.61912939699994,
							30.354154266000084
						],
						[
							-81.61928279499995,
							30.35366834700005
						],
						[
							-81.61986755599992,
							30.35137481600009
						],
						[
							-81.61989514699991,
							30.351286045000048
						],
						[
							-81.62062685199993,
							30.349300388000078
						],
						[
							-81.62065170199992,
							30.345907414000067
						],
						[
							-81.62066534099995,
							30.34575783400004
						],
						[
							-81.62070591399993,
							30.345606414000088
						],
						[
							-81.62074324899993,
							30.345526349000064
						],
						[
							-81.62191999999993,
							30.345534000000047
						],
						[
							-81.62214688199992,
							30.345431877000067
						],
						[
							-81.62436990599991,
							30.34535900900005
						],
						[
							-81.62479690499993,
							30.34535900900005
						],
						[
							-81.62540090499995,
							30.345384008000057
						],
						[
							-81.62589690599992,
							30.345375008000076
						],
						[
							-81.62667790599994,
							30.345362008000052
						],
						[
							-81.62716790699994,
							30.34535300800007
						],
						[
							-81.62793690599995,
							30.345389008000044
						],
						[
							-81.62811203099994,
							30.34537815300007
						],
						[
							-81.6281327879999,
							30.34528086200004
						],
						[
							-81.62843990499994,
							30.34528400800008
						],
						[
							-81.62898290599992,
							30.34528000900008
						],
						[
							-81.62974490599994,
							30.34528400800008
						],
						[
							-81.63050790599993,
							30.34528400800008
						],
						[
							-81.63128690499991,
							30.34528900800007
						],
						[
							-81.63207990599994,
							30.345291008000064
						],
						[
							-81.6328659049999,
							30.34529300800006
						],
						[
							-81.63365890599994,
							30.345299009000087
						],
						[
							-81.63445290499993,
							30.34530100900008
						],
						[
							-81.63459790699994,
							30.34529700800005
						],
						[
							-81.6349109059999,
							30.345306008000076
						],
						[
							-81.63524590599991,
							30.34530400800008
						],
						[
							-81.63603990599995,
							30.345308008000075
						],
						[
							-81.63674590599993,
							30.345307008000074
						],
						[
							-81.63679190699992,
							30.34530595500007
						],
						[
							-81.6368029059999,
							30.34629200800003
						],
						[
							-81.63680790599994,
							30.346929008000078
						],
						[
							-81.63681390599993,
							30.34741800800009
						],
						[
							-81.63681503799995,
							30.34750913600004
						],
						[
							-81.63678177299994,
							30.34750988000007
						],
						[
							-81.63678890499995,
							30.347960009000072
						],
						[
							-81.6368029059999,
							30.348234008000077
						],
						[
							-81.6368029059999,
							30.348587008000035
						],
						[
							-81.63680690599995,
							30.348665009000058
						],
						[
							-81.63681790599992,
							30.348890009000062
						],
						[
							-81.63681790599992,
							30.34900900800005
						],
						[
							-81.63681790599992,
							30.349215008000044
						],
						[
							-81.63682190599992,
							30.349512008000094
						],
						[
							-81.6368249059999,
							30.34970600800006
						],
						[
							-81.6368309049999,
							30.349832009000064
						],
						[
							-81.63684390599991,
							30.35034300900009
						],
						[
							-81.63684090599992,
							30.350655008000047
						],
						[
							-81.63684990599995,
							30.350968008000056
						],
						[
							-81.6368489059999,
							30.35138900900006
						],
						[
							-81.63686090599992,
							30.351867008000053
						],
						[
							-81.63686190599992,
							30.35213500900005
						],
						[
							-81.63686590599991,
							30.35228300800009
						],
						[
							-81.63685990599993,
							30.352671008000073
						],
						[
							-81.63686590599991,
							30.35287900800006
						],
						[
							-81.63686890599992,
							30.35296400800007
						],
						[
							-81.63687090599991,
							30.353037008000054
						],
						[
							-81.63687690599994,
							30.353298009000074
						],
						[
							-81.63687990599993,
							30.35367200900004
						],
						[
							-81.63688290599993,
							30.354092008000066
						],
						[
							-81.63688690599992,
							30.354322008000054
						],
						[
							-81.6368879609999,
							30.35463801000009
						],
						[
							-81.63546190599993,
							30.354666009000084
						],
						[
							-81.63472790499993,
							30.354680008000056
						],
						[
							-81.63399390699993,
							30.354693009000076
						],
						[
							-81.63390090599995,
							30.354713008000093
						],
						[
							-81.63273190599995,
							30.354840008000053
						],
						[
							-81.62954990599991,
							30.354782009000076
						],
						[
							-81.6284219069999,
							30.35471800800008
						],
						[
							-81.62649990599994,
							30.35471200800004
						],
						[
							-81.62614890599991,
							30.354709009000086
						],
						[
							-81.62596390599992,
							30.354723009000054
						],
						[
							-81.6256809059999,
							30.354769010000044
						],
						[
							-81.6253889059999,
							30.354872008000086
						],
						[
							-81.6252079059999,
							30.35495700900009
						],
						[
							-81.62509790699994,
							30.355031008000083
						],
						[
							-81.62498290699995,
							30.355138009000086
						],
						[
							-81.62485090599995,
							30.355301008000083
						],
						[
							-81.62474378399992,
							30.355477951000072
						],
						[
							-81.62452690499993,
							30.356399008000043
						],
						[
							-81.62445290399995,
							30.356622008000045
						],
						[
							-81.6243749059999,
							30.356753005000087
						],
						[
							-81.62425990599992,
							30.35687000900009
						],
						[
							-81.62410989099995,
							30.357023178000077
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Fairfield",
				"RegionID": "273667"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.5558533219999,
					27.840759020000068,
					-82.5172361999999,
					27.87268399900006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.51881804499993,
							27.87240011600005
						],
						[
							-82.51889090899994,
							27.871272728000065
						],
						[
							-82.51898919299992,
							27.86974934500006
						],
						[
							-82.51911826899993,
							27.865900053000075
						],
						[
							-82.51911833799994,
							27.864699888000075
						],
						[
							-82.5172361999999,
							27.86417281400009
						],
						[
							-82.51745470799995,
							27.863393847000054
						],
						[
							-82.51742434599994,
							27.858329145000084
						],
						[
							-82.51801993299995,
							27.857625080000048
						],
						[
							-82.51783654499991,
							27.856160646000035
						],
						[
							-82.51957554299993,
							27.853506381000045
						],
						[
							-82.5214975799999,
							27.853689600000052
						],
						[
							-82.5236632239999,
							27.85389585000007
						],
						[
							-82.5255011829999,
							27.854070894000074
						],
						[
							-82.52774342099991,
							27.85428452600007
						],
						[
							-82.53064973699992,
							27.853414950000058
						],
						[
							-82.53266321699994,
							27.853781120000065
						],
						[
							-82.53464636199993,
							27.854141521000088
						],
						[
							-82.53513420399992,
							27.854879533000087
						],
						[
							-82.53623268899992,
							27.854971034000073
						],
						[
							-82.5358663159999,
							27.841425592000064
						],
						[
							-82.5366422919999,
							27.841167604000077
						],
						[
							-82.53805991099995,
							27.840759020000068
						],
						[
							-82.5381236689999,
							27.840785956000047
						],
						[
							-82.53818514499994,
							27.84081775600004
						],
						[
							-82.53824396999994,
							27.84085422800007
						],
						[
							-82.53829978999995,
							27.840895153000076
						],
						[
							-82.53835226699994,
							27.840940283000066
						],
						[
							-82.53850826699994,
							27.84108528200005
						],
						[
							-82.53858491999995,
							27.841165927000077
						],
						[
							-82.53867890599992,
							27.841301542000053
						],
						[
							-82.53877289299993,
							27.841471321000085
						],
						[
							-82.5388956839999,
							27.84156003900006
						],
						[
							-82.53896723799994,
							27.841617516000042
						],
						[
							-82.53902223799992,
							27.84166651600009
						],
						[
							-82.53911291999992,
							27.84175992700006
						],
						[
							-82.53916630299994,
							27.841836165000075
						],
						[
							-82.5392503569999,
							27.841874027000074
						],
						[
							-82.53933064199992,
							27.84191515400005
						],
						[
							-82.53942764199991,
							27.841971154000078
						],
						[
							-82.53950003199992,
							27.84201770100009
						],
						[
							-82.53960103199995,
							27.842089701000077
						],
						[
							-82.53965707299994,
							27.842133079000064
						],
						[
							-82.53973888799995,
							27.842210994000084
						],
						[
							-82.5398388879999,
							27.842318995000085
						],
						[
							-82.5398851789999,
							27.842373142000042
						],
						[
							-82.5399270389999,
							27.842430783000058
						],
						[
							-82.53996420499993,
							27.842491557000073
						],
						[
							-82.53999644499993,
							27.842555081000057
						],
						[
							-82.5400210329999,
							27.842608692000056
						],
						[
							-82.5400741659999,
							27.84261334000007
						],
						[
							-82.54017641999991,
							27.84263760600004
						],
						[
							-82.5402464199999,
							27.842658606000043
						],
						[
							-82.54031132999995,
							27.842680811000037
						],
						[
							-82.54037435799995,
							27.84270789900006
						],
						[
							-82.54043513899991,
							27.84273971300007
						],
						[
							-82.54049331699991,
							27.842776068000035
						],
						[
							-82.54054855499993,
							27.842816751000043
						],
						[
							-82.54061755499993,
							27.842871751000075
						],
						[
							-82.54063507299992,
							27.84288607900004
						],
						[
							-82.54074592099994,
							27.84299692700006
						],
						[
							-82.54083583599993,
							27.84312533900004
						],
						[
							-82.54090208699995,
							27.843267413000035
						],
						[
							-82.54093089999992,
							27.843362681000087
						],
						[
							-82.5409670119999,
							27.843511316000047
						],
						[
							-82.54103492799993,
							27.84354327600005
						],
						[
							-82.5411090419999,
							27.843582472000037
						],
						[
							-82.54128159899996,
							27.84368429700004
						],
						[
							-82.5415688459999,
							27.84380764400004
						],
						[
							-82.54166366099992,
							27.843855164000047
						],
						[
							-82.54178248399995,
							27.843937146000087
						],
						[
							-82.54190753599994,
							27.844039162000062
						],
						[
							-82.54223896999991,
							27.844269324000038
						],
						[
							-82.54225926999993,
							27.844283843000085
						],
						[
							-82.54241193399992,
							27.844396265000057
						],
						[
							-82.54249066099995,
							27.844433165000055
						],
						[
							-82.54254527699993,
							27.844467363000035
						],
						[
							-82.54270327699993,
							27.844574363000053
						],
						[
							-82.54277707299991,
							27.84463007900007
						],
						[
							-82.5428541739999,
							27.844702942000083
						],
						[
							-82.54291717399991,
							27.844769943000077
						],
						[
							-82.54296540499992,
							27.844825640000067
						],
						[
							-82.54300891399994,
							27.844885099000066
						],
						[
							-82.54304740899994,
							27.844947921000085
						],
						[
							-82.5430806299999,
							27.845013684000037
						],
						[
							-82.5431083549999,
							27.84508194600005
						],
						[
							-82.54314862399991,
							27.84519547800005
						],
						[
							-82.54318665999995,
							27.845339834000075
						],
						[
							-82.54319999099994,
							27.845502483000075
						],
						[
							-82.54327135799991,
							27.84551491900004
						],
						[
							-82.54334151899991,
							27.845532957000046
						],
						[
							-82.54341003499991,
							27.84555648500009
						],
						[
							-82.54347647699991,
							27.845585354000036
						],
						[
							-82.54366658999993,
							27.84567983800008
						],
						[
							-82.54374861399992,
							27.84571920500008
						],
						[
							-82.5438076609999,
							27.845748164000042
						],
						[
							-82.54383313999995,
							27.84576506800005
						],
						[
							-82.54393841699994,
							27.845834322000087
						],
						[
							-82.5440634929999,
							27.845907114000056
						],
						[
							-82.54415436999994,
							27.845928232000063
						],
						[
							-82.54422336899995,
							27.84594823200007
						],
						[
							-82.5442951679999,
							27.845972363000044
						],
						[
							-82.54436468099993,
							27.84600245100006
						],
						[
							-82.5444314149999,
							27.846038285000077
						],
						[
							-82.5444948949999,
							27.84607960900007
						],
						[
							-82.54455466999991,
							27.846126131000062
						],
						[
							-82.54460726699995,
							27.846171181000045
						],
						[
							-82.5446655099999,
							27.84622576900006
						],
						[
							-82.54471868299993,
							27.846285306000084
						],
						[
							-82.54476636699991,
							27.846349324000073
						],
						[
							-82.5448081859999,
							27.84641731800008
						],
						[
							-82.54484381099991,
							27.846488752000088
						],
						[
							-82.54486467299995,
							27.846535887000073
						],
						[
							-82.54492691999991,
							27.846557851000057
						],
						[
							-82.54498738199993,
							27.84658433800007
						],
						[
							-82.54504572999991,
							27.846615204000045
						],
						[
							-82.54510164699991,
							27.84665028200004
						],
						[
							-82.54515482999994,
							27.84668938100009
						],
						[
							-82.54524183099994,
							27.84675838000004
						],
						[
							-82.54529771099993,
							27.84680656200004
						],
						[
							-82.5453494539999,
							27.84685916300009
						],
						[
							-82.54539671099991,
							27.84691582800008
						],
						[
							-82.5454657109999,
							27.847005829000068
						],
						[
							-82.5455308359999,
							27.847103339000057
						],
						[
							-82.54556368699991,
							27.84716577400008
						],
						[
							-82.5457716869999,
							27.847601773000065
						],
						[
							-82.54579404899994,
							27.847652634000042
						],
						[
							-82.5459900489999,
							27.84813863400007
						],
						[
							-82.54603345399994,
							27.84827788700005
						],
						[
							-82.54606435099994,
							27.848411515000066
						],
						[
							-82.54609513699997,
							27.848439616000064
						],
						[
							-82.5461581369999,
							27.84850861600006
						],
						[
							-82.54620053399992,
							27.848558592000074
						],
						[
							-82.54623917799995,
							27.848611523000045
						],
						[
							-82.54627386499993,
							27.848667127000056
						],
						[
							-82.54630441099994,
							27.84872511000009
						],
						[
							-82.54633065299993,
							27.84878516400005
						],
						[
							-82.54637165299994,
							27.84888916300008
						],
						[
							-82.5464002839999,
							27.848973921000038
						],
						[
							-82.54644928399996,
							27.849146921000056
						],
						[
							-82.54646367199992,
							27.849218441000062
						],
						[
							-82.54648362699993,
							27.84922447100007
						],
						[
							-82.5466317229999,
							27.849246229000073
						],
						[
							-82.5467051839999,
							27.849260164000043
						],
						[
							-82.54677723299994,
							27.849280152000063
						],
						[
							-82.54684737299993,
							27.849306057000035
						],
						[
							-82.54691511899995,
							27.849337698000056
						],
						[
							-82.54707511899994,
							27.849420699000063
						],
						[
							-82.54713925499993,
							27.849457389000065
						],
						[
							-82.54720016199991,
							27.84949922000004
						],
						[
							-82.54725742999995,
							27.849545909000085
						],
						[
							-82.54731067199992,
							27.84959714300004
						],
						[
							-82.54791249599992,
							27.850225885000043
						],
						[
							-82.54822643299991,
							27.850506582000037
						],
						[
							-82.54826291699993,
							27.850541083000053
						],
						[
							-82.54853291699993,
							27.850811083000053
						],
						[
							-82.54857747499995,
							27.85085900900009
						],
						[
							-82.54861843099991,
							27.850910048000063
						],
						[
							-82.54865556699991,
							27.850963930000038
						],
						[
							-82.54868868599995,
							27.85102037000007
						],
						[
							-82.54878568599992,
							27.851200370000072
						],
						[
							-82.54881810699993,
							27.85126696100008
						],
						[
							-82.54884493799995,
							27.85133599400007
						],
						[
							-82.54886599799994,
							27.85140700100004
						],
						[
							-82.54888114399995,
							27.85147950000004
						],
						[
							-82.54889027199994,
							27.851552999000035
						],
						[
							-82.54889332199993,
							27.851627000000065
						],
						[
							-82.54889332199993,
							27.851890000000083
						],
						[
							-82.54887965899991,
							27.85204616500005
						],
						[
							-82.54887430899993,
							27.852073945000086
						],
						[
							-82.54883230899992,
							27.85227494600008
						],
						[
							-82.54879642199991,
							27.85240040400004
						],
						[
							-82.54874842299995,
							27.852531404000047
						],
						[
							-82.54868926099994,
							27.85266034400007
						],
						[
							-82.54833925999993,
							27.853287344000083
						],
						[
							-82.54829845499995,
							27.85335354600005
						],
						[
							-82.54659437999993,
							27.855867902000057
						],
						[
							-82.54647768399992,
							27.856059518000052
						],
						[
							-82.54646412699992,
							27.85616849500008
						],
						[
							-82.54651303999992,
							27.857558486000073
						],
						[
							-82.54665688599994,
							27.85748883100007
						],
						[
							-82.54736721699993,
							27.85709777900007
						],
						[
							-82.54735785499992,
							27.85696551700005
						],
						[
							-82.54734578499995,
							27.856789526000057
						],
						[
							-82.54734367799995,
							27.85672800000009
						],
						[
							-82.5473546689999,
							27.856587825000076
						],
						[
							-82.54743766899992,
							27.856061826000087
						],
						[
							-82.5474502269999,
							27.855997547000072
						],
						[
							-82.54764422699992,
							27.855166548000057
						],
						[
							-82.54767491399991,
							27.855063414000085
						],
						[
							-82.54772218199992,
							27.85495595000009
						],
						[
							-82.54790218199992,
							27.854609950000054
						],
						[
							-82.54794768099993,
							27.854532256000084
						],
						[
							-82.54904868099993,
							27.852851256000065
						],
						[
							-82.54910558699993,
							27.852773754000054
						],
						[
							-82.55049519099994,
							27.85107922900005
						],
						[
							-82.55140498199995,
							27.850005154000087
						],
						[
							-82.5511721339999,
							27.849836830000072
						],
						[
							-82.55112092699994,
							27.849796921000063
						],
						[
							-82.55101007899992,
							27.849686073000044
						],
						[
							-82.55092016399993,
							27.849557661000063
						],
						[
							-82.5508539139999,
							27.84941558600008
						],
						[
							-82.55081334099992,
							27.84926416600007
						],
						[
							-82.55079967799992,
							27.849108000000058
						],
						[
							-82.55079967799992,
							27.848707000000047
						],
						[
							-82.55081334099992,
							27.84855083400004
						],
						[
							-82.55083610399993,
							27.84845364000006
						],
						[
							-82.55090510399992,
							27.848218640000084
						],
						[
							-82.55093482799992,
							27.848133464000057
						],
						[
							-82.55111482899991,
							27.847690465000085
						],
						[
							-82.55114604999994,
							27.84762199100004
						],
						[
							-82.55118288699992,
							27.84755636700004
						],
						[
							-82.55122508099993,
							27.84749405200006
						],
						[
							-82.55127233799993,
							27.847435484000073
						],
						[
							-82.55132432599993,
							27.847381071000086
						],
						[
							-82.5516837479999,
							27.847035104000042
						],
						[
							-82.55193281599993,
							27.84677277800006
						],
						[
							-82.55198574299993,
							27.846721425000055
						],
						[
							-82.55204269899991,
							27.84667458200005
						],
						[
							-82.55210330099993,
							27.84663256200008
						],
						[
							-82.55216714199992,
							27.84659564900005
						],
						[
							-82.55243014199993,
							27.84645764900006
						],
						[
							-82.55249556299992,
							27.846426614000052
						],
						[
							-82.5525632689999,
							27.84640094200006
						],
						[
							-82.55263282099992,
							27.846380800000077
						],
						[
							-82.55270376699991,
							27.846366319000083
						],
						[
							-82.5527756489999,
							27.846357593000054
						],
						[
							-82.55284799999993,
							27.84635467800007
						],
						[
							-82.55329199999994,
							27.84635467800007
						],
						[
							-82.55345359099994,
							27.84636933200005
						],
						[
							-82.55404101699992,
							27.84648032300004
						],
						[
							-82.55418508799994,
							27.846520196000085
						],
						[
							-82.55460008799992,
							27.84667319600004
						],
						[
							-82.55473866099993,
							27.846738164000044
						],
						[
							-82.55478576799993,
							27.84676733200007
						],
						[
							-82.55495176899991,
							27.846877333000066
						],
						[
							-82.55503307299995,
							27.846938080000086
						],
						[
							-82.55509091699992,
							27.846991083000034
						],
						[
							-82.55532691699996,
							27.847227084000057
						],
						[
							-82.55537411099994,
							27.84727807300004
						],
						[
							-82.55541722699992,
							27.847332553000058
						],
						[
							-82.5554560089999,
							27.847390199000078
						],
						[
							-82.5554902259999,
							27.84745066700009
						],
						[
							-82.55551967199995,
							27.847513595000066
						],
						[
							-82.55554417199994,
							27.847578610000085
						],
						[
							-82.5556961719999,
							27.84803460900008
						],
						[
							-82.55573013399993,
							27.848171440000044
						],
						[
							-82.55581313399995,
							27.84867044100008
						],
						[
							-82.55582353099993,
							27.848761272000047
						],
						[
							-82.55585153099992,
							27.849204272000065
						],
						[
							-82.5558533219999,
							27.84926100000007
						],
						[
							-82.5558533219999,
							27.850133000000085
						],
						[
							-82.5558522099999,
							27.850177698000042
						],
						[
							-82.55581079699994,
							27.851009903000094
						],
						[
							-82.55579807499993,
							27.85155209700008
						],
						[
							-82.55578465899993,
							27.85168716600009
						],
						[
							-82.5557592429999,
							27.851793224000062
						],
						[
							-82.55562024299991,
							27.852249224000047
						],
						[
							-82.55558852099995,
							27.85233676000007
						],
						[
							-82.55532552199992,
							27.85295976000009
						],
						[
							-82.55531017299995,
							27.85299409600009
						],
						[
							-82.55519917299995,
							27.853229096000064
						],
						[
							-82.55512463199994,
							27.853358033000063
						],
						[
							-82.55436963199992,
							27.854445033000047
						],
						[
							-82.55432387399992,
							27.854505330000052
						],
						[
							-82.55415453299992,
							27.854709979000063
						],
						[
							-82.5537741469999,
							27.85547157600007
						],
						[
							-82.5535263939999,
							27.856297419000047
						],
						[
							-82.5535021309999,
							27.85636762000007
						],
						[
							-82.55347215899992,
							27.85643557800006
						],
						[
							-82.55343668099994,
							27.85650083200005
						],
						[
							-82.55339593899993,
							27.856562936000046
						],
						[
							-82.55307548499991,
							27.857009999000073
						],
						[
							-82.55304256099994,
							27.85707909000007
						],
						[
							-82.5530355599999,
							27.85714063800009
						],
						[
							-82.5530059429999,
							27.85728876400009
						],
						[
							-82.55291760199992,
							27.85759433700008
						],
						[
							-82.55295249199992,
							27.857659010000077
						],
						[
							-82.55298252299991,
							27.857720105000055
						],
						[
							-82.55300784699995,
							27.857783297000083
						],
						[
							-82.5530283189999,
							27.857848224000065
						],
						[
							-82.55304381999991,
							27.857914514000072
						],
						[
							-82.55305426299992,
							27.85798178500005
						],
						[
							-82.55307526299993,
							27.85816178500005
						],
						[
							-82.55308132199991,
							27.85826600000007
						],
						[
							-82.55307911599994,
							27.858328956000037
						],
						[
							-82.55305772199995,
							27.858633807000047
						],
						[
							-82.55307824599993,
							27.86024834200009
						],
						[
							-82.55308124299995,
							27.86047511600009
						],
						[
							-82.55307921999992,
							27.860548451000057
						],
						[
							-82.55306921999994,
							27.860694451000086
						],
						[
							-82.55305765999992,
							27.860789166000075
						],
						[
							-82.55302464599993,
							27.86091237300008
						],
						[
							-82.55305258599992,
							27.860920914000076
						],
						[
							-82.5531946609999,
							27.86098716400005
						],
						[
							-82.55332307299994,
							27.861077079000044
						],
						[
							-82.55343391999992,
							27.861187927000064
						],
						[
							-82.55348234899992,
							27.86125112500008
						],
						[
							-82.55364214399992,
							27.861479967000037
						],
						[
							-82.55367191099992,
							27.86152182700005
						],
						[
							-82.55371783499993,
							27.86159333900008
						],
						[
							-82.55378408599995,
							27.861735414000066
						],
						[
							-82.55382465899994,
							27.861886834000074
						],
						[
							-82.55383832199993,
							27.862043000000085
						],
						[
							-82.55382404999995,
							27.86220254500006
						],
						[
							-82.55376744099993,
							27.86250992300006
						],
						[
							-82.55375006199995,
							27.862585711000065
						],
						[
							-82.5537262009999,
							27.862659715000067
						],
						[
							-82.55369603799994,
							27.86273138200005
						],
						[
							-82.55365979599992,
							27.862800175000075
						],
						[
							-82.55361774799991,
							27.86286558000006
						],
						[
							-82.55357020699995,
							27.862927109000054
						],
						[
							-82.55351752799993,
							27.862984301000044
						],
						[
							-82.55346010699992,
							27.863036729000047
						],
						[
							-82.55312714099995,
							27.863314537000065
						],
						[
							-82.55302779499993,
							27.863386526000056
						],
						[
							-82.55258479499992,
							27.863663527000085
						],
						[
							-82.5525219779999,
							27.863699375000067
						],
						[
							-82.55245648299992,
							27.86373005900009
						],
						[
							-82.55238873499991,
							27.86375538200008
						],
						[
							-82.55231917099992,
							27.863775178000083
						],
						[
							-82.55224824099992,
							27.86378932000008
						],
						[
							-82.55217640399991,
							27.863797717000068
						],
						[
							-82.55159293499992,
							27.86384222500004
						],
						[
							-82.55126252799994,
							27.863974386000052
						],
						[
							-82.55120320499992,
							27.863998370000047
						],
						[
							-82.55068118899993,
							27.864259378000042
						],
						[
							-82.55058658599995,
							27.86430008600007
						],
						[
							-82.55052567099995,
							27.864319831000046
						],
						[
							-82.54994367099994,
							27.86448583200007
						],
						[
							-82.54985316599993,
							27.86450665900009
						],
						[
							-82.54975639199995,
							27.864518359000044
						],
						[
							-82.54892539199994,
							27.864573359000076
						],
						[
							-82.54886599999992,
							27.864575322000064
						],
						[
							-82.54796336399994,
							27.864575322000064
						],
						[
							-82.5472810089999,
							27.864676580000037
						],
						[
							-82.54720822099995,
							27.864684370000077
						],
						[
							-82.54713504099993,
							27.864686213000084
						],
						[
							-82.54706195299991,
							27.86468209900005
						],
						[
							-82.54698944199993,
							27.86467205400004
						],
						[
							-82.5469179879999,
							27.864656145000083
						],
						[
							-82.54684806499995,
							27.86463447700004
						],
						[
							-82.5462607689999,
							27.864425932000074
						],
						[
							-82.54540503699991,
							27.864211779000073
						],
						[
							-82.54445145999995,
							27.86414652500008
						],
						[
							-82.54341024899992,
							27.86422116400007
						],
						[
							-82.54245434099994,
							27.864315333000036
						],
						[
							-82.54207991299995,
							27.864447260000077
						],
						[
							-82.54185279299993,
							27.86453584600008
						],
						[
							-82.54178632899993,
							27.864558818000035
						],
						[
							-82.54171827399995,
							27.864576528000043
						],
						[
							-82.54164904299995,
							27.864588865000087
						],
						[
							-82.5415790589999,
							27.86459575500004
						],
						[
							-82.54115605899995,
							27.86462075600008
						],
						[
							-82.54110299999991,
							27.86462232200006
						],
						[
							-82.54098643299994,
							27.864614736000078
						],
						[
							-82.54086434599992,
							27.864598777000083
						],
						[
							-82.54083603899994,
							27.864606818000084
						],
						[
							-82.54050159499991,
							27.86475178900008
						],
						[
							-82.54027349099994,
							27.86493130300005
						],
						[
							-82.54001203599995,
							27.86515995900004
						],
						[
							-82.53997725999994,
							27.865188862000082
						],
						[
							-82.53974926099994,
							27.865368862000082
						],
						[
							-82.53965959599992,
							27.86543120200008
						],
						[
							-82.53959059599993,
							27.86547320200009
						],
						[
							-82.53957819399994,
							27.86548604500007
						],
						[
							-82.5395959569999,
							27.86554964600009
						],
						[
							-82.5396177259999,
							27.86556519600009
						],
						[
							-82.5396730729999,
							27.865608080000072
						],
						[
							-82.53975610399993,
							27.865687311000045
						],
						[
							-82.53983910499996,
							27.86577731100005
						],
						[
							-82.53986692099994,
							27.865808927000046
						],
						[
							-82.53995683599993,
							27.865937339000084
						],
						[
							-82.5400230859999,
							27.86607941400007
						],
						[
							-82.54006365999993,
							27.866230834000078
						],
						[
							-82.54007616799993,
							27.866341444000057
						],
						[
							-82.54008316699992,
							27.866479444000053
						],
						[
							-82.54008432199993,
							27.86652500000008
						],
						[
							-82.54007065899992,
							27.866681166000035
						],
						[
							-82.54003008599994,
							27.866832586000044
						],
						[
							-82.53996383499992,
							27.866974661000086
						],
						[
							-82.53991782899993,
							27.86704628800004
						],
						[
							-82.53984882899994,
							27.86714328800008
						],
						[
							-82.53980183399995,
							27.867203732000064
						],
						[
							-82.5397498669999,
							27.86725996000007
						],
						[
							-82.53969330599995,
							27.86731156400009
						],
						[
							-82.53963255999992,
							27.867358170000045
						],
						[
							-82.5395680709999,
							27.867399439000053
						],
						[
							-82.53950030399994,
							27.86743507400007
						],
						[
							-82.53942975299992,
							27.867464816000055
						],
						[
							-82.53929534299994,
							27.867514843000038
						],
						[
							-82.53926325999993,
							27.867526978000058
						],
						[
							-82.53910616499991,
							27.867569659000083
						],
						[
							-82.53900211099995,
							27.86758181100004
						],
						[
							-82.53868815499995,
							27.867600034000077
						],
						[
							-82.53866221099992,
							27.867669015000047
						],
						[
							-82.53862821099995,
							27.867741015000036
						],
						[
							-82.53859285499993,
							27.86780835600007
						],
						[
							-82.53855193399994,
							27.867872469000076
						],
						[
							-82.53850574199993,
							27.86793289500008
						],
						[
							-82.53845460999992,
							27.867989202000047
						],
						[
							-82.53839890199993,
							27.868040987000086
						],
						[
							-82.53835498799992,
							27.868078454000056
						],
						[
							-82.5382236609999,
							27.868170836000047
						],
						[
							-82.53808263999991,
							27.868236702000047
						],
						[
							-82.53797863999995,
							27.868274702000065
						],
						[
							-82.53789542499993,
							27.868300611000052
						],
						[
							-82.53716644999992,
							27.868489363000037
						],
						[
							-82.5364572439999,
							27.86877230200008
						],
						[
							-82.53635806799991,
							27.868805327000075
						],
						[
							-82.53624306799992,
							27.868836327000054
						],
						[
							-82.53618016699994,
							27.86885088200006
						],
						[
							-82.5361163849999,
							27.868860888000086
						],
						[
							-82.53605204799993,
							27.868866291000074
						],
						[
							-82.53598748999991,
							27.868867065000074
						],
						[
							-82.53577848999993,
							27.86886206400004
						],
						[
							-82.53571415899995,
							27.868858215000046
						],
						[
							-82.53567469199993,
							27.868857302000038
						],
						[
							-82.53558406099995,
							27.86892507600004
						],
						[
							-82.53559376999993,
							27.868997464000074
						],
						[
							-82.5355980949999,
							27.869070373000056
						],
						[
							-82.53559701199993,
							27.869143401000088
						],
						[
							-82.5355905269999,
							27.869216149000067
						],
						[
							-82.53557952699992,
							27.869299150000074
						],
						[
							-82.53557365899991,
							27.869337166000037
						],
						[
							-82.53554068599993,
							27.869466844000044
						],
						[
							-82.53548168599991,
							27.869642844000055
						],
						[
							-82.53545717499992,
							27.869707581000057
						],
						[
							-82.53542775599993,
							27.869770241000083
						],
						[
							-82.53539360599991,
							27.869830453000077
						],
						[
							-82.53535492599991,
							27.869887860000063
						],
						[
							-82.53531194399994,
							27.869942122000058
						],
						[
							-82.53526491699995,
							27.869992917000047
						],
						[
							-82.53520591699993,
							27.87005191700007
						],
						[
							-82.53515442499992,
							27.87009954100006
						],
						[
							-82.53509937799993,
							27.87014300700008
						],
						[
							-82.53504111199993,
							27.870182051000086
						],
						[
							-82.53497997999995,
							27.87021643500009
						],
						[
							-82.53493897899995,
							27.87023743600008
						],
						[
							-82.53483658599993,
							27.87028208600009
						],
						[
							-82.53467859499995,
							27.870323234000068
						],
						[
							-82.5346109159999,
							27.87038491700008
						],
						[
							-82.53455717299994,
							27.87043445900008
						],
						[
							-82.53448559999993,
							27.870495248000054
						],
						[
							-82.5342457239999,
							27.87081053500009
						],
						[
							-82.53420529599993,
							27.87085993100004
						],
						[
							-82.53413229599995,
							27.870942932000048
						],
						[
							-82.5340569299999,
							27.871018973000048
						],
						[
							-82.53383692999995,
							27.871215973000062
						],
						[
							-82.53381183399995,
							27.87123762500005
						],
						[
							-82.53343283499993,
							27.871552625000053
						],
						[
							-82.53340718599992,
							27.87157316300005
						],
						[
							-82.53291695099995,
							27.87195120800004
						],
						[
							-82.53266278799993,
							27.872183592000056
						],
						[
							-82.5326595379999,
							27.87219838200008
						],
						[
							-82.53177523499994,
							27.872030288000076
						],
						[
							-82.5312521379999,
							27.871988954000077
						],
						[
							-82.52709986499991,
							27.871999866000067
						],
						[
							-82.52710135399991,
							27.872458710000046
						],
						[
							-82.52380408699992,
							27.872467348000043
						],
						[
							-82.52330978299995,
							27.87252031900005
						],
						[
							-82.52178286999992,
							27.87268399900006
						],
						[
							-82.51881804499993,
							27.87240011600005
						]
					],
					[
						[
							-82.54004745799995,
							27.85909573500004
						],
						[
							-82.5404170409999,
							27.859081358000083
						],
						[
							-82.54051118699994,
							27.859082628000067
						],
						[
							-82.5407066269999,
							27.85908685700008
						],
						[
							-82.54069432099993,
							27.85898811100009
						],
						[
							-82.54068767799993,
							27.85887900000006
						],
						[
							-82.54069672399993,
							27.85873103700004
						],
						[
							-82.54064068199995,
							27.858619161000036
						],
						[
							-82.54062845199991,
							27.85858473600007
						],
						[
							-82.54058969599993,
							27.858432793000077
						],
						[
							-82.54052197899995,
							27.858469876000072
						],
						[
							-82.54045148799992,
							27.85850136900007
						],
						[
							-82.5403786839999,
							27.85852706500009
						],
						[
							-82.54030404199995,
							27.85854679600004
						],
						[
							-82.54014304099991,
							27.858581796000067
						],
						[
							-82.54010816599992,
							27.858588659000077
						],
						[
							-82.53995199999991,
							27.85860232200008
						],
						[
							-82.53988199999992,
							27.85860232200008
						],
						[
							-82.53981145299991,
							27.858599550000065
						],
						[
							-82.53974134099991,
							27.85859125400009
						],
						[
							-82.5396720949999,
							27.858577482000044
						],
						[
							-82.5396041429999,
							27.85855832200008
						],
						[
							-82.53953790399993,
							27.858533890000047
						],
						[
							-82.53947378499993,
							27.858504337000056
						],
						[
							-82.53942078499996,
							27.858477337000068
						],
						[
							-82.5393694899999,
							27.85845365800009
						],
						[
							-82.53942110499992,
							27.858542674000034
						],
						[
							-82.5394766789999,
							27.858653294000078
						],
						[
							-82.53959920099993,
							27.85874197000004
						],
						[
							-82.5396981429999,
							27.85882452400006
						],
						[
							-82.53994282199994,
							27.859060385000078
						],
						[
							-82.54004745799995,
							27.85909573500004
						]
					],
					[
						[
							-82.54118191399994,
							27.856742410000038
						],
						[
							-82.54118272499994,
							27.856706977000044
						],
						[
							-82.5410988829999,
							27.85685423800004
						],
						[
							-82.5410785549999,
							27.856898990000047
						],
						[
							-82.54107886199995,
							27.85694224200006
						],
						[
							-82.54107932199992,
							27.856971000000044
						],
						[
							-82.54107673999994,
							27.856997817000035
						],
						[
							-82.54117007899993,
							27.856862927000066
						],
						[
							-82.54118878399993,
							27.856844222000063
						],
						[
							-82.54118167799993,
							27.856763000000058
						],
						[
							-82.54118191399994,
							27.856742410000038
						]
					],
					[
						[
							-82.54290560299995,
							27.85496689100006
						],
						[
							-82.54287411699994,
							27.854876339000043
						],
						[
							-82.5427869429999,
							27.854925673000082
						],
						[
							-82.54264458599994,
							27.854992087000085
						],
						[
							-82.54262550899995,
							27.854998788000046
						],
						[
							-82.54256350899993,
							27.855019788000053
						],
						[
							-82.5425408449999,
							27.855025589000036
						],
						[
							-82.54234605699992,
							27.855373831000065
						],
						[
							-82.54225837799993,
							27.855549189000044
						],
						[
							-82.54221121899991,
							27.855632179000054
						],
						[
							-82.54217017799994,
							27.85569623100008
						],
						[
							-82.54221006599994,
							27.85569552700008
						],
						[
							-82.54234806599993,
							27.855701527000065
						],
						[
							-82.54239125399994,
							27.855706253000054
						],
						[
							-82.54240751099991,
							27.855673094000053
						],
						[
							-82.54245282999995,
							27.855597805000063
						],
						[
							-82.54251052199993,
							27.85544334000008
						],
						[
							-82.54253905799993,
							27.855375536000054
						],
						[
							-82.54257303999992,
							27.85531029200007
						],
						[
							-82.54261224099992,
							27.855248043000074
						],
						[
							-82.5426563979999,
							27.85518920600009
						],
						[
							-82.54270521699993,
							27.855134176000035
						],
						[
							-82.54275836999994,
							27.855083319000073
						],
						[
							-82.54281736999991,
							27.85503131900009
						],
						[
							-82.54283392699995,
							27.85501708000004
						],
						[
							-82.54290560299995,
							27.85496689100006
						]
					],
					[
						[
							-82.54447431599993,
							27.85258023700004
						],
						[
							-82.54444406399995,
							27.852511759000038
						],
						[
							-82.54441608699995,
							27.852625586000045
						],
						[
							-82.54440092899995,
							27.852664408000066
						],
						[
							-82.5443529289999,
							27.85277940800006
						],
						[
							-82.54432007199995,
							27.852849481000078
						],
						[
							-82.5442813119999,
							27.852916470000082
						],
						[
							-82.54423693599995,
							27.852979878000042
						],
						[
							-82.54418727199993,
							27.85303923600009
						],
						[
							-82.54413268899994,
							27.85309410400004
						],
						[
							-82.54404268999991,
							27.853177104000054
						],
						[
							-82.54399616599994,
							27.853219462000084
						],
						[
							-82.54394578899992,
							27.853257157000087
						],
						[
							-82.54389202599992,
							27.85328984000006
						],
						[
							-82.54383537299992,
							27.853317210000057
						],
						[
							-82.54395116599994,
							27.853327340000078
						],
						[
							-82.54404877099995,
							27.853350225000042
						],
						[
							-82.54408276999993,
							27.853360225000078
						],
						[
							-82.54415138899992,
							27.853383450000084
						],
						[
							-82.54421791599992,
							27.853412122000066
						],
						[
							-82.54428191999995,
							27.853446055000063
						],
						[
							-82.5443429849999,
							27.85348503000006
						],
						[
							-82.54440071399995,
							27.853528794000056
						],
						[
							-82.54445473399994,
							27.853577062000056
						],
						[
							-82.54448673499991,
							27.853608061000045
						],
						[
							-82.54454992099994,
							27.85367592700004
						],
						[
							-82.54458907499992,
							27.853731845000084
						],
						[
							-82.54460684499992,
							27.853665057000057
						],
						[
							-82.54462989399991,
							27.853599901000052
						],
						[
							-82.54465807299994,
							27.853536795000082
						],
						[
							-82.54469120399995,
							27.85347614200009
						],
						[
							-82.54472907299993,
							27.85341832900008
						],
						[
							-82.54477144099991,
							27.853363726000055
						],
						[
							-82.54481803399995,
							27.85331268200008
						],
						[
							-82.54486855599993,
							27.85326552400005
						],
						[
							-82.54493824199994,
							27.85320480200005
						],
						[
							-82.54497359499993,
							27.853179006000065
						],
						[
							-82.54496510099995,
							27.853161042000067
						],
						[
							-82.5448705959999,
							27.853069203000075
						],
						[
							-82.5446005949999,
							27.852765204000036
						],
						[
							-82.54455290999994,
							27.852707492000036
						],
						[
							-82.54451069999993,
							27.85264566400008
						],
						[
							-82.54447431599993,
							27.85258023700004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Port Tampa City",
				"RegionID": "275076"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.06306174499991,
					26.714460581000083,
					-80.05522273799994,
					26.724691663000044
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.05524052099992,
							26.71533400800007
						],
						[
							-80.05525836899994,
							26.714460581000083
						],
						[
							-80.05558679699995,
							26.71447097500004
						],
						[
							-80.0558274149999,
							26.714478589000066
						],
						[
							-80.05619436899991,
							26.714490202000036
						],
						[
							-80.05668958599996,
							26.714505873000064
						],
						[
							-80.0569799999999,
							26.714510000000075
						],
						[
							-80.05713440099993,
							26.714510000000075
						],
						[
							-80.05760559499993,
							26.714518627000075
						],
						[
							-80.05865999999992,
							26.714540000000056
						],
						[
							-80.05885061999993,
							26.714544630000034
						],
						[
							-80.05918829599996,
							26.714552833000084
						],
						[
							-80.0602464019999,
							26.71457853600009
						],
						[
							-80.06128667699994,
							26.71460580300004
						],
						[
							-80.06193999999994,
							26.714630000000056
						],
						[
							-80.06203406199995,
							26.714734621000048
						],
						[
							-80.06203406199995,
							26.715222079000057
						],
						[
							-80.06202546099992,
							26.71640903800005
						],
						[
							-80.06203406199995,
							26.717621801000064
						],
						[
							-80.06205986499992,
							26.71806046000006
						],
						[
							-80.0621200729999,
							26.718533524000065
						],
						[
							-80.06219748399991,
							26.719187212000065
						],
						[
							-80.06236090599992,
							26.720090333000087
						],
						[
							-80.06247272099995,
							26.720941848000052
						],
						[
							-80.06270495199993,
							26.72238684200005
						],
						[
							-80.06300599199994,
							26.72427909700008
						],
						[
							-80.06306174499991,
							26.724691663000044
						],
						[
							-80.06295619199994,
							26.724690000000066
						],
						[
							-80.06278263999991,
							26.724687566000057
						],
						[
							-80.0621510329999,
							26.724671776000037
						],
						[
							-80.06167999999991,
							26.724660000000085
						],
						[
							-80.06138627699994,
							26.724650370000063
						],
						[
							-80.06084166599993,
							26.724632514000064
						],
						[
							-80.06045999999992,
							26.724620000000073
						],
						[
							-80.0601003239999,
							26.724611008000068
						],
						[
							-80.05963410999993,
							26.724599353000087
						],
						[
							-80.05925999999994,
							26.724590000000035
						],
						[
							-80.05901904299992,
							26.72458458500006
						],
						[
							-80.05875055899992,
							26.724578552000082
						],
						[
							-80.05836999999991,
							26.724570000000085
						],
						[
							-80.05796162299993,
							26.724558220000063
						],
						[
							-80.05769335399992,
							26.72455048100005
						],
						[
							-80.05732999999992,
							26.72454000000005
						],
						[
							-80.05709382999993,
							26.724537155000064
						],
						[
							-80.05682559099995,
							26.724533703000077
						],
						[
							-80.05644974299992,
							26.72452822100007
						],
						[
							-80.05608520899995,
							26.721842553000045
						],
						[
							-80.05573844199995,
							26.719477426000083
						],
						[
							-80.05541834999991,
							26.71749463200007
						],
						[
							-80.05524052099992,
							26.71632985100007
						],
						[
							-80.05522273799994,
							26.715947519000053
						],
						[
							-80.05524052099992,
							26.71533400800007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "West Palm Beach",
				"Name": "Progressive North West",
				"RegionID": "275094"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.44374044499995,
					28.515276850000078,
					-81.42605021899993,
					28.527833487000066
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.43432876899993,
							28.527830357000084
						],
						[
							-81.43433699999991,
							28.52732000000009
						],
						[
							-81.43234466199993,
							28.527329801000064
						],
						[
							-81.4322970799999,
							28.52733003500009
						],
						[
							-81.43231075199992,
							28.526883440000063
						],
						[
							-81.43229083799991,
							28.52662263600007
						],
						[
							-81.43228235099991,
							28.526393472000052
						],
						[
							-81.43227614199992,
							28.52622583300007
						],
						[
							-81.43227331999992,
							28.526149633000045
						],
						[
							-81.43227104499994,
							28.52601194600004
						],
						[
							-81.4322753479999,
							28.525813979000077
						],
						[
							-81.43228164899995,
							28.52552416000009
						],
						[
							-81.4322856419999,
							28.52534045200008
						],
						[
							-81.43228729999993,
							28.52526418400004
						],
						[
							-81.4322922739999,
							28.525035379000087
						],
						[
							-81.4322975799999,
							28.524791320000077
						],
						[
							-81.43230156599992,
							28.52460794400008
						],
						[
							-81.43230720399993,
							28.524348632000056
						],
						[
							-81.43230999999992,
							28.52408923100006
						],
						[
							-81.43230736099991,
							28.523753756000076
						],
						[
							-81.43230421299995,
							28.52355541500009
						],
						[
							-81.43230202599995,
							28.523417617000064
						],
						[
							-81.43229999999994,
							28.52329000000009
						],
						[
							-81.4317134339999,
							28.523304134000057
						],
						[
							-81.43119486499995,
							28.523316630000068
						],
						[
							-81.43085931999991,
							28.523324715000058
						],
						[
							-81.43053865299993,
							28.523332357000072
						],
						[
							-81.43034001399991,
							28.523336976000053
						],
						[
							-81.42998911799992,
							28.523340000000076
						],
						[
							-81.42934816099995,
							28.523340000000076
						],
						[
							-81.42892085599993,
							28.523340000000076
						],
						[
							-81.42864616799994,
							28.52334196600009
						],
						[
							-81.4283255279999,
							28.523347055000045
						],
						[
							-81.42794411199992,
							28.523354778000055
						],
						[
							-81.42756281699991,
							28.523364078000046
						],
						[
							-81.42695237299995,
							28.523378967000042
						],
						[
							-81.42631105299995,
							28.523394608000046
						],
						[
							-81.4260503779999,
							28.523400966000057
						],
						[
							-81.42605034899992,
							28.523395907000065
						],
						[
							-81.42605029599991,
							28.523297762000084
						],
						[
							-81.42605134999991,
							28.522919199000057
						],
						[
							-81.42605134999991,
							28.52247654300004
						],
						[
							-81.42605235299993,
							28.52199683100008
						],
						[
							-81.42605335399992,
							28.52153514700007
						],
						[
							-81.42605021899993,
							28.52090719200004
						],
						[
							-81.42611157099992,
							28.520776044000062
						],
						[
							-81.42611544599993,
							28.52007698500006
						],
						[
							-81.42609441399993,
							28.51935891900007
						],
						[
							-81.42607438499994,
							28.518507657000043
						],
						[
							-81.42606737499995,
							28.518197196000074
						],
						[
							-81.42606937799991,
							28.51798287800006
						],
						[
							-81.42607839099992,
							28.51701243900004
						],
						[
							-81.42607338399995,
							28.51646963400009
						],
						[
							-81.42606537199993,
							28.516107097000088
						],
						[
							-81.42606030999991,
							28.515844706000053
						],
						[
							-81.43796815199994,
							28.515638528000068
						],
						[
							-81.43796496499994,
							28.515318927000067
						],
						[
							-81.44289041299993,
							28.515276850000078
						],
						[
							-81.44295799999992,
							28.52062000000007
						],
						[
							-81.44374044499995,
							28.52118518700007
						],
						[
							-81.44370791699993,
							28.521219917000053
						],
						[
							-81.44367696799992,
							28.52124942800009
						],
						[
							-81.44364801199993,
							28.521393809000074
						],
						[
							-81.4436305509999,
							28.52206781400008
						],
						[
							-81.44364014899992,
							28.522556334000058
						],
						[
							-81.44364032199991,
							28.522574000000077
						],
						[
							-81.44363952299994,
							28.522611914000038
						],
						[
							-81.44363311299992,
							28.52276380500007
						],
						[
							-81.44254399999994,
							28.523310000000038
						],
						[
							-81.43803498999995,
							28.52330964500004
						],
						[
							-81.43807503999994,
							28.526863173000038
						],
						[
							-81.43807929199994,
							28.52724048200008
						],
						[
							-81.43648799999994,
							28.527247000000045
						],
						[
							-81.4345899999999,
							28.52730100000008
						],
						[
							-81.4344759999999,
							28.527293000000043
						],
						[
							-81.43449329799995,
							28.527833387000044
						],
						[
							-81.43442677199994,
							28.527833487000066
						],
						[
							-81.43432876899993,
							28.527830357000084
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Richmond Heights",
				"RegionID": "275162"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.1372450689999,
					26.107226456000035,
					-80.1188763099999,
					26.118010583000057
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.13614234599993,
							26.117791262000086
						],
						[
							-80.13493555699996,
							26.117268300000035
						],
						[
							-80.13427658499995,
							26.117518939000036
						],
						[
							-80.13373377199991,
							26.11742972500008
						],
						[
							-80.13114293099994,
							26.117303537000055
						],
						[
							-80.13092651699992,
							26.11725294900009
						],
						[
							-80.12980685699995,
							26.116991221000035
						],
						[
							-80.12900477599993,
							26.11596236300005
						],
						[
							-80.1282075929999,
							26.116663780000067
						],
						[
							-80.12656924399994,
							26.115607981000043
						],
						[
							-80.12607744099995,
							26.11531851500007
						],
						[
							-80.1259782699999,
							26.115315588000044
						],
						[
							-80.12453911799992,
							26.115023205000057
						],
						[
							-80.12381811199992,
							26.114652479000085
						],
						[
							-80.12200938399991,
							26.114456315000044
						],
						[
							-80.12131134899995,
							26.114268037000045
						],
						[
							-80.1197499999999,
							26.113973000000044
						],
						[
							-80.1188763099999,
							26.11317256700005
						],
						[
							-80.11900358999992,
							26.112068047000037
						],
						[
							-80.11901475699995,
							26.111996565000084
						],
						[
							-80.11903163399995,
							26.111926211000082
						],
						[
							-80.11905411099991,
							26.111857442000087
						],
						[
							-80.11908204399992,
							26.111790702000068
						],
						[
							-80.11911525099993,
							26.111726423000054
						],
						[
							-80.1191722609999,
							26.11153845800004
						],
						[
							-80.11921456099992,
							26.11088583200007
						],
						[
							-80.1194904159999,
							26.11017415100008
						],
						[
							-80.11971964299994,
							26.10952577100005
						],
						[
							-80.1197170129999,
							26.109583993000058
						],
						[
							-80.11976766899994,
							26.10953315100005
						],
						[
							-80.11982235799991,
							26.109486677000064
						],
						[
							-80.11988070599995,
							26.109444887000052
						],
						[
							-80.11994231299991,
							26.109408071000075
						],
						[
							-80.1200067549999,
							26.109376479000048
						],
						[
							-80.12007359099994,
							26.10935032900005
						],
						[
							-80.12014236199991,
							26.10932980000007
						],
						[
							-80.12021259499994,
							26.10931503400008
						],
						[
							-80.12276448099993,
							26.10887551600007
						],
						[
							-80.12277941399992,
							26.108506626000064
						],
						[
							-80.12278785399992,
							26.10841486000004
						],
						[
							-80.12279655099991,
							26.108354444000042
						],
						[
							-80.12382799999995,
							26.107501000000074
						],
						[
							-80.12839598599993,
							26.107226456000035
						],
						[
							-80.12841275199992,
							26.10779657200004
						],
						[
							-80.13294141799992,
							26.107701226000074
						],
						[
							-80.13298864399991,
							26.107723459000056
						],
						[
							-80.13360958699991,
							26.10771531800009
						],
						[
							-80.13697858499995,
							26.107655228000056
						],
						[
							-80.1371127839999,
							26.11041532300004
						],
						[
							-80.13713381399992,
							26.11097515200004
						],
						[
							-80.13714783599994,
							26.11135471600005
						],
						[
							-80.13715284199992,
							26.111509945000083
						],
						[
							-80.13718388899991,
							26.11215990900007
						],
						[
							-80.13718889599994,
							26.113121324000076
						],
						[
							-80.13717587699995,
							26.114023673000077
						],
						[
							-80.13716385899994,
							26.114886953000052
						],
						[
							-80.13716486099992,
							26.115334617000087
						],
						[
							-80.13722294599995,
							26.116882914000087
						],
						[
							-80.13723596599993,
							26.117094227000052
						],
						[
							-80.13723796799991,
							26.117610993000085
						],
						[
							-80.13723896999994,
							26.117879392000077
						],
						[
							-80.1372450689999,
							26.11799956200008
						],
						[
							-80.13712780999992,
							26.118010583000057
						],
						[
							-80.13614234599993,
							26.117791262000086
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Rio Vista",
				"RegionID": "275178"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.47387564299993,
					27.996200084000066,
					-82.45260909299992,
					28.021291080000086
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.45648013699991,
							28.020579402000067
						],
						[
							-82.45548182699991,
							28.020109010000056
						],
						[
							-82.4551926659999,
							28.02014269000006
						],
						[
							-82.45471818199991,
							28.017100001000074
						],
						[
							-82.45411817999991,
							28.012099999000043
						],
						[
							-82.45331818299991,
							28.009600000000034
						],
						[
							-82.45260909299992,
							28.006000002000064
						],
						[
							-82.4528272739999,
							28.002536365000083
						],
						[
							-82.45340908999992,
							27.999809091000092
						],
						[
							-82.4537175289999,
							27.996200202000068
						],
						[
							-82.46512556199991,
							27.996216918000073
						],
						[
							-82.46555773599995,
							27.996200084000066
						],
						[
							-82.46573914999993,
							27.996513435000054
						],
						[
							-82.4660489339999,
							27.996847048000063
						],
						[
							-82.46645403499991,
							27.997228320000094
						],
						[
							-82.46683530699994,
							27.997538103000068
						],
						[
							-82.4670974309999,
							27.997728739000085
						],
						[
							-82.46740721399993,
							27.997847886000045
						],
						[
							-82.46771699699991,
							27.997919375000038
						],
						[
							-82.46816975799993,
							27.997919375000038
						],
						[
							-82.46867017699992,
							27.997847886000045
						],
						[
							-82.46928974299993,
							27.997752568000067
						],
						[
							-82.4698854799999,
							27.99770490900005
						],
						[
							-82.4705050469999,
							27.99770490900005
						],
						[
							-82.47097797799995,
							27.99772793900007
						],
						[
							-82.47146403799991,
							27.997868149000055
						],
						[
							-82.4716696779999,
							27.997952275000046
						],
						[
							-82.47205291799992,
							27.998073790000035
						],
						[
							-82.47246419899994,
							27.998335514000075
						],
						[
							-82.4729035229999,
							27.99868136500004
						],
						[
							-82.47313720599993,
							27.998971131000076
						],
						[
							-82.47322133099993,
							27.99931698200004
						],
						[
							-82.47328676199993,
							27.999690874000066
						],
						[
							-82.47332415199992,
							28.000289101000078
						],
						[
							-82.47338958299991,
							28.000691036000035
						],
						[
							-82.4735110979999,
							28.00110231700006
						],
						[
							-82.47366065499995,
							28.001457515000084
						],
						[
							-82.47383825399993,
							28.001887491000048
						],
						[
							-82.47387564299993,
							28.002139868000086
						],
						[
							-82.47382890599994,
							28.002495066000055
						],
						[
							-82.47369804399995,
							28.002803527000083
						],
						[
							-82.4734830559999,
							28.00307459900006
						],
						[
							-82.47324002599993,
							28.003317629000037
						],
						[
							-82.47267918799992,
							28.003560659000073
						],
						[
							-82.47209030699992,
							28.003691521000064
						],
						[
							-82.47142664799992,
							28.00379434200005
						],
						[
							-82.4709966719999,
							28.003869120000047
						],
						[
							-82.47063212699993,
							28.00401867700009
						],
						[
							-82.4702956239999,
							28.004299096000068
						],
						[
							-82.46988434299993,
							28.004710378000084
						],
						[
							-82.46951979799991,
							28.005000144000064
						],
						[
							-82.46927676799993,
							28.005159048000053
						],
						[
							-82.4689122229999,
							28.00523382700004
						],
						[
							-82.46858506699994,
							28.005299258000036
						],
						[
							-82.46806161799992,
							28.00553294100007
						],
						[
							-82.4670708029999,
							28.006028348000086
						],
						[
							-82.46624823999991,
							28.006523755000046
						],
						[
							-82.4657528329999,
							28.006785480000076
						],
						[
							-82.46547241399992,
							28.006944384000064
						],
						[
							-82.4650798269999,
							28.007262193000088
						],
						[
							-82.46485549199991,
							28.007449139000073
						],
						[
							-82.46474332399993,
							28.007589348000067
						],
						[
							-82.46454702999995,
							28.007832378000046
						],
						[
							-82.4644815989999,
							28.00797258800009
						],
						[
							-82.4644255149999,
							28.008084756000073
						],
						[
							-82.4643881259999,
							28.00823431200007
						],
						[
							-82.46433204199991,
							28.00843995300005
						],
						[
							-82.4643413899999,
							28.008804498000075
						],
						[
							-82.4643881259999,
							28.009103612000047
						],
						[
							-82.46447225199995,
							28.009346642000082
						],
						[
							-82.46461246199993,
							28.00966445000006
						],
						[
							-82.46472462899993,
							28.00990748000004
						],
						[
							-82.46479005999993,
							28.010103774000072
						],
						[
							-82.46481810199992,
							28.01033745700005
						],
						[
							-82.46488353299992,
							28.01054309700004
						],
						[
							-82.46492499999994,
							28.01066600000007
						],
						[
							-82.46490488199993,
							28.010652354000058
						],
						[
							-82.46488493599992,
							28.010873789000073
						],
						[
							-82.46475454499995,
							28.012309091000077
						],
						[
							-82.46408181999993,
							28.015309095000077
						],
						[
							-82.46416363499992,
							28.01610909100009
						],
						[
							-82.46457290599994,
							28.018381859000048
						],
						[
							-82.4638000839999,
							28.01943646600006
						],
						[
							-82.46238169399993,
							28.020127148000086
						],
						[
							-82.46199103399994,
							28.020881942000074
						],
						[
							-82.46127276099992,
							28.021291080000086
						],
						[
							-82.45843065799994,
							28.02092759700008
						],
						[
							-82.45648013699991,
							28.020579402000067
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Seminole Heights",
				"RegionID": "275329"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.10415183899994,
					26.16749903100009,
					-80.0948374319999,
					26.18204047200004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.0948374319999,
							26.181834728000073
						],
						[
							-80.09665234999994,
							26.167564119000076
						],
						[
							-80.09756299999992,
							26.16753200000005
						],
						[
							-80.09801880399995,
							26.16760713900004
						],
						[
							-80.09858664599994,
							26.167587111000046
						],
						[
							-80.0994599419999,
							26.167558068000062
						],
						[
							-80.10036428399991,
							26.167528024000035
						],
						[
							-80.10048447399993,
							26.167528079000082
						],
						[
							-80.1011734839999,
							26.167540041000052
						],
						[
							-80.10158509199994,
							26.167533030000072
						],
						[
							-80.10195964999991,
							26.167528023000045
						],
						[
							-80.10327560099995,
							26.16750899500005
						],
						[
							-80.1036151049999,
							26.16750899500005
						],
						[
							-80.1037389999999,
							26.167505000000062
						],
						[
							-80.10415183899994,
							26.16749903100009
						],
						[
							-80.10412596899994,
							26.167803002000085
						],
						[
							-80.10402741299993,
							26.168558603000065
						],
						[
							-80.10409311699995,
							26.169018534000088
						],
						[
							-80.10402741299993,
							26.16977413400008
						],
						[
							-80.10386315199992,
							26.171482448000063
						],
						[
							-80.10379712399993,
							26.172494878000066
						],
						[
							-80.10339847499995,
							26.172498096000083
						],
						[
							-80.10335471899992,
							26.17249739300007
						],
						[
							-80.10236224699992,
							26.172505405000038
						],
						[
							-80.1008149509999,
							26.172521429000085
						],
						[
							-80.09977328499991,
							26.17254231900006
						],
						[
							-80.09964221299992,
							26.17341675600005
						],
						[
							-80.09956810299991,
							26.17413081500007
						],
						[
							-80.09943991199992,
							26.175250478000066
						],
						[
							-80.09930571399991,
							26.176051665000045
						],
						[
							-80.09908839099995,
							26.176964017000046
						],
						[
							-80.09881698899994,
							26.177850332000048
						],
						[
							-80.09859966699992,
							26.178501297000082
						],
						[
							-80.09822911599991,
							26.179562872000076
						],
						[
							-80.0978886119999,
							26.180487242000083
						],
						[
							-80.0976732929999,
							26.181305456000075
						],
						[
							-80.09754945599991,
							26.18204047200004
						],
						[
							-80.09573975199993,
							26.181868119000058
						],
						[
							-80.09566499999994,
							26.181861000000083
						],
						[
							-80.0948374319999,
							26.181834728000073
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Galt Mile",
				"RegionID": "273801"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.54248027099993,
					27.865900053000075,
					-82.49391818399994,
					27.89360005500004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.49391818399994,
							27.89360005500004
						],
						[
							-82.49407272799994,
							27.885000001000037
						],
						[
							-82.4940862439999,
							27.88424786700006
						],
						[
							-82.49411812799991,
							27.88019994700005
						],
						[
							-82.49641818099991,
							27.87910000000005
						],
						[
							-82.49762226399992,
							27.878524136000067
						],
						[
							-82.50670909099995,
							27.872627273000035
						],
						[
							-82.5091824189999,
							27.871022217000075
						],
						[
							-82.51383621399992,
							27.868002152000088
						],
						[
							-82.51911826899993,
							27.865900053000075
						],
						[
							-82.51898919299992,
							27.86974934500006
						],
						[
							-82.51889090899994,
							27.871272728000065
						],
						[
							-82.51881804499993,
							27.87240011600005
						],
						[
							-82.52178286999992,
							27.87268399900006
						],
						[
							-82.52330978299995,
							27.87252031900005
						],
						[
							-82.52380408699992,
							27.872467348000043
						],
						[
							-82.52710135399991,
							27.872458710000046
						],
						[
							-82.52709986499991,
							27.871999866000067
						],
						[
							-82.5312521379999,
							27.871988954000077
						],
						[
							-82.53177523499994,
							27.872030288000076
						],
						[
							-82.5326595379999,
							27.87219838200008
						],
						[
							-82.53263367199992,
							27.872316095000087
						],
						[
							-82.5326116839999,
							27.87251154100005
						],
						[
							-82.53260015199994,
							27.87258591300008
						],
						[
							-82.53258243699992,
							27.872659060000046
						],
						[
							-82.5325586649999,
							27.872730468000043
						],
						[
							-82.53252900199993,
							27.87279963700007
						],
						[
							-82.53249365499994,
							27.872866082000087
						],
						[
							-82.53245947499994,
							27.872923503000038
						],
						[
							-82.53242786699991,
							27.87297632700006
						],
						[
							-82.53239189199991,
							27.873026279000044
						],
						[
							-82.53235180799993,
							27.873072999000044
						],
						[
							-82.53230790599991,
							27.873116150000044
						],
						[
							-82.53226050099994,
							27.873155421000035
						],
						[
							-82.5322099359999,
							27.873190528000066
						],
						[
							-82.5322070769999,
							27.873312991000034
						],
						[
							-82.53219365899992,
							27.87344816500007
						],
						[
							-82.53216036499992,
							27.873578800000075
						],
						[
							-82.53205336499991,
							27.873896800000068
						],
						[
							-82.53202447599995,
							27.87397148000008
						],
						[
							-82.53184235499992,
							27.874386365000078
						],
						[
							-82.53170202399991,
							27.874732435000055
						],
						[
							-82.53164616399994,
							27.874942940000043
						],
						[
							-82.53162515299994,
							27.87501102500005
						],
						[
							-82.53159881799992,
							27.87507723300007
						],
						[
							-82.53156732399992,
							27.87514114700008
						],
						[
							-82.53153086899994,
							27.87520236800009
						],
						[
							-82.53148968099993,
							27.87526051100008
						],
						[
							-82.53144401999992,
							27.875315211000043
						],
						[
							-82.53142629799993,
							27.87533480700006
						],
						[
							-82.53141615899995,
							27.87535574000009
						],
						[
							-82.53106417499993,
							27.87643730700006
						],
						[
							-82.53105088199993,
							27.876475250000055
						],
						[
							-82.53068324199995,
							27.877456919000053
						],
						[
							-82.53073228799991,
							27.877622226000085
						],
						[
							-82.5307566589999,
							27.87772483400005
						],
						[
							-82.53076711999995,
							27.87780517400006
						],
						[
							-82.53077778399995,
							27.87793120300006
						],
						[
							-82.5310128619999,
							27.87791807700006
						],
						[
							-82.5311388259999,
							27.877919880000036
						],
						[
							-82.53139882599993,
							27.87794188000004
						],
						[
							-82.53147916499995,
							27.877952341000082
						],
						[
							-82.53158141699993,
							27.87797660500007
						],
						[
							-82.53164627699994,
							27.87799606300007
						],
						[
							-82.53174911799994,
							27.878025582000078
						],
						[
							-82.5318085859999,
							27.878044913000053
						],
						[
							-82.53193575599995,
							27.87810274700007
						],
						[
							-82.53207720799992,
							27.87818095600005
						],
						[
							-82.53221307299992,
							27.878275080000037
						],
						[
							-82.53224839699993,
							27.878306335000048
						],
						[
							-82.5323523969999,
							27.878403335000087
						],
						[
							-82.53242792099991,
							27.87848292700005
						],
						[
							-82.53250518899995,
							27.87859011300009
						],
						[
							-82.53256418899991,
							27.87868611300007
						],
						[
							-82.53260151699993,
							27.878753093000057
						],
						[
							-82.53263300299994,
							27.878823009000087
						],
						[
							-82.53265841899992,
							27.878895354000065
						],
						[
							-82.5327104189999,
							27.87906635300004
						],
						[
							-82.53273565899991,
							27.87917183400009
						],
						[
							-82.53274369799993,
							27.879227583000045
						],
						[
							-82.53277369799991,
							27.879494583000056
						],
						[
							-82.5327792889999,
							27.87960270800005
						],
						[
							-82.53277628899991,
							27.879952708000076
						],
						[
							-82.53276204699995,
							27.88010459900005
						],
						[
							-82.53273825199994,
							27.880235982000045
						],
						[
							-82.53250169799992,
							27.88140552100009
						],
						[
							-82.53239779899991,
							27.88220208200005
						],
						[
							-82.53233482899992,
							27.88268684700006
						],
						[
							-82.53232503999993,
							27.882746460000078
						],
						[
							-82.53228803999991,
							27.882932459000074
						],
						[
							-82.53227288099993,
							27.882996369000068
						],
						[
							-82.5322530979999,
							27.88305900200004
						],
						[
							-82.53222879599991,
							27.88312002400005
						],
						[
							-82.53220010599995,
							27.883179109000082
						],
						[
							-82.53216717899994,
							27.883235943000045
						],
						[
							-82.53205517899994,
							27.88341394300005
						],
						[
							-82.53198292099995,
							27.883513073000074
						],
						[
							-82.5318737419999,
							27.88362251700005
						],
						[
							-82.53168790699993,
							27.883779219000075
						],
						[
							-82.53155743699995,
							27.88387054000009
						],
						[
							-82.53140548199991,
							27.883957639000073
						],
						[
							-82.53137166099992,
							27.88399000700008
						],
						[
							-82.5313175899999,
							27.88406051900006
						],
						[
							-82.5312278159999,
							27.884239491000073
						],
						[
							-82.53111021199993,
							27.884586803000047
						],
						[
							-82.53105196699994,
							27.88519203700008
						],
						[
							-82.5311811659999,
							27.88520334000009
						],
						[
							-82.53133904999993,
							27.885246322000057
						],
						[
							-82.53144251399993,
							27.885285731000067
						],
						[
							-82.53154852499995,
							27.88533615800009
						],
						[
							-82.53194254599994,
							27.88506135700004
						],
						[
							-82.5320073389999,
							27.885020164000082
						],
						[
							-82.5321245529999,
							27.88496338100009
						],
						[
							-82.5322175529999,
							27.88492638100007
						],
						[
							-82.53228418299994,
							27.884902860000068
						],
						[
							-82.53235245399992,
							27.88488464300008
						],
						[
							-82.5324219439999,
							27.884871842000056
						],
						[
							-82.53249222499994,
							27.884864536000066
						],
						[
							-82.53272522499992,
							27.884849536000047
						],
						[
							-82.53286158599991,
							27.88485111800009
						],
						[
							-82.53303258499994,
							27.884866118000048
						],
						[
							-82.53309445499991,
							27.88487371400004
						],
						[
							-82.53311935599993,
							27.884877651000068
						],
						[
							-82.53320592699993,
							27.88479108000007
						],
						[
							-82.53331026799992,
							27.884715567000057
						],
						[
							-82.53338126799991,
							27.884671567000055
						],
						[
							-82.53344085099991,
							27.884637714000068
						],
						[
							-82.53350283899994,
							27.884608496000055
						],
						[
							-82.53356687199994,
							27.88458408300005
						],
						[
							-82.53363257799992,
							27.884564617000084
						],
						[
							-82.5336995749999,
							27.88455021100009
						],
						[
							-82.5338263139999,
							27.88452808100004
						],
						[
							-82.5339397699999,
							27.884515624000073
						],
						[
							-82.53476776999992,
							27.884477624000056
						],
						[
							-82.53482945899992,
							27.884476911000036
						],
						[
							-82.53646248299992,
							27.88451406900009
						],
						[
							-82.53667756399994,
							27.884501267000076
						],
						[
							-82.53673099999992,
							27.884499678000054
						],
						[
							-82.53696499999995,
							27.884499678000054
						],
						[
							-82.5370410829999,
							27.884502902000065
						],
						[
							-82.5372184499999,
							27.884517962000075
						],
						[
							-82.53804878799991,
							27.884524141000046
						],
						[
							-82.5380486869999,
							27.884506850000037
						],
						[
							-82.53806234099994,
							27.884347835000085
						],
						[
							-82.53806723299994,
							27.88432226000009
						],
						[
							-82.53809323299993,
							27.884196259000078
						],
						[
							-82.53813734599993,
							27.88404816600007
						],
						[
							-82.53817834599994,
							27.883944165000063
						],
						[
							-82.53821007199991,
							27.883872912000072
						],
						[
							-82.53824785299992,
							27.883804675000082
						],
						[
							-82.53829140399995,
							27.88373996900009
						],
						[
							-82.53834039799995,
							27.88367928000008
						],
						[
							-82.53839446599994,
							27.883623064000062
						],
						[
							-82.53845320199991,
							27.88357174400005
						],
						[
							-82.53851320199993,
							27.883523745000048
						],
						[
							-82.53857030799992,
							27.883481644000085
						],
						[
							-82.53863055499994,
							27.88344417600007
						],
						[
							-82.53869356799993,
							27.883411574000036
						],
						[
							-82.53875895399996,
							27.883384041000056
						],
						[
							-82.5388263079999,
							27.883361748000084
						],
						[
							-82.53889520999991,
							27.88334483300008
						],
						[
							-82.53896522999992,
							27.883333402000062
						],
						[
							-82.53903593399991,
							27.883327527000063
						],
						[
							-82.53912793399991,
							27.883323527000073
						],
						[
							-82.5391669999999,
							27.88332267800007
						],
						[
							-82.53932365599991,
							27.883336427000078
						],
						[
							-82.53990397799993,
							27.883439416000044
						],
						[
							-82.53996288499991,
							27.88344071100005
						],
						[
							-82.54006225299992,
							27.883430969000074
						],
						[
							-82.54014286199993,
							27.88342670700007
						],
						[
							-82.54052086299993,
							27.88342370600009
						],
						[
							-82.54059214299991,
							27.88342596800004
						],
						[
							-82.54151514199992,
							27.883491968000044
						],
						[
							-82.54158699699992,
							27.883500020000042
						],
						[
							-82.54165797199994,
							27.88351381800004
						],
						[
							-82.5417276089999,
							27.883533273000072
						],
						[
							-82.5417954589999,
							27.883558260000086
						],
						[
							-82.54187745899992,
							27.883592261000047
						],
						[
							-82.54194314699993,
							27.883622651000053
						],
						[
							-82.54200617899994,
							27.883658224000044
						],
						[
							-82.54206614499992,
							27.883698752000043
						],
						[
							-82.54212265899992,
							27.883743970000072
						],
						[
							-82.54217535299995,
							27.88379358600008
						],
						[
							-82.54222388699992,
							27.883847279000065
						],
						[
							-82.54226794599992,
							27.883904701000063
						],
						[
							-82.5423072449999,
							27.883965480000086
						],
						[
							-82.54233554099994,
							27.88401340900009
						],
						[
							-82.54240408699991,
							27.884159413000077
						],
						[
							-82.54243416799996,
							27.884259971000063
						],
						[
							-82.54245616899993,
							27.884352972000045
						],
						[
							-82.54246665999995,
							27.884403835000057
						],
						[
							-82.54248027099993,
							27.88456681300005
						],
						[
							-82.54247820699993,
							27.884706363000078
						],
						[
							-82.54244719499991,
							27.88655310000007
						],
						[
							-82.54243976799995,
							27.88665431600009
						],
						[
							-82.54242476799993,
							27.886769316000084
						],
						[
							-82.54241145999993,
							27.886845581000046
						],
						[
							-82.54239164299992,
							27.886920419000035
						],
						[
							-82.5423654619999,
							27.886993275000066
						],
						[
							-82.5423606729999,
							27.887004992000072
						],
						[
							-82.54142053299995,
							27.886901814000055
						],
						[
							-82.52681809099994,
							27.886700165000036
						],
						[
							-82.52650009099996,
							27.886199836000063
						],
						[
							-82.5197748299999,
							27.88605298400006
						],
						[
							-82.51869999899992,
							27.88600000300005
						],
						[
							-82.5182999999999,
							27.886100133000074
						],
						[
							-82.51774545599994,
							27.88601818300009
						],
						[
							-82.51649992699993,
							27.885900161000052
						],
						[
							-82.51589999599992,
							27.885400003000086
						],
						[
							-82.51542728499993,
							27.885218008000038
						],
						[
							-82.5148635239999,
							27.885363489000042
						],
						[
							-82.51463636199992,
							27.885745455000063
						],
						[
							-82.51449999899997,
							27.88590000100004
						],
						[
							-82.50970715499994,
							27.89357034200009
						],
						[
							-82.50939999899992,
							27.89357272700005
						],
						[
							-82.5087448829999,
							27.893577933000074
						],
						[
							-82.50819608599994,
							27.89358223700009
						],
						[
							-82.50652539499993,
							27.893595565000055
						],
						[
							-82.49391818399994,
							27.89360005500004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Gandy-Sun Bay South",
				"RegionID": "273803"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.6023909079999,
					30.46091695700005,
					-81.57552290699994,
					30.50399447500007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.57927690799994,
							30.46641501000005
						],
						[
							-81.57910190799993,
							30.46312501100005
						],
						[
							-81.57900991199995,
							30.46091695700005
						],
						[
							-81.57922390499994,
							30.46092000900006
						],
						[
							-81.57932290499991,
							30.46093600900008
						],
						[
							-81.57944490699992,
							30.460968008000066
						],
						[
							-81.57960490599993,
							30.461023008000044
						],
						[
							-81.57984190499991,
							30.46112600800006
						],
						[
							-81.58000790599993,
							30.46122000800005
						],
						[
							-81.58017590299994,
							30.461329008000064
						],
						[
							-81.58043690599993,
							30.461578009000046
						],
						[
							-81.58130390499991,
							30.462473009000064
						],
						[
							-81.58223690599993,
							30.463444008000067
						],
						[
							-81.5824359049999,
							30.463621008000075
						],
						[
							-81.58251190499993,
							30.46370300600006
						],
						[
							-81.58270285499992,
							30.463844083000083
						],
						[
							-81.58302290599994,
							30.464037008000044
						],
						[
							-81.58338890599993,
							30.46420500700009
						],
						[
							-81.58376290599995,
							30.464319008000075
						],
						[
							-81.5840299059999,
							30.464373008000052
						],
						[
							-81.5843429059999,
							30.46440900800007
						],
						[
							-81.58457190599995,
							30.46442000700006
						],
						[
							-81.5851359049999,
							30.46440700900007
						],
						[
							-81.5875629059999,
							30.464390008000066
						],
						[
							-81.5898819059999,
							30.464363008000074
						],
						[
							-81.59149190499994,
							30.46434600900005
						],
						[
							-81.59194891899995,
							30.464356971000086
						],
						[
							-81.59256690599994,
							30.464405009000075
						],
						[
							-81.59320790499993,
							30.464502009000057
						],
						[
							-81.59364290499991,
							30.46459200800007
						],
						[
							-81.59396390599994,
							30.464668008000046
						],
						[
							-81.59452090499991,
							30.464828008000044
						],
						[
							-81.59489390599992,
							30.46494700800008
						],
						[
							-81.59520690599993,
							30.46506700800006
						],
						[
							-81.59567990499994,
							30.46527500800005
						],
						[
							-81.5961419059999,
							30.46550600800009
						],
						[
							-81.59654190599991,
							30.46572500900004
						],
						[
							-81.59700790599993,
							30.466024009000083
						],
						[
							-81.59747290599995,
							30.46636000900008
						],
						[
							-81.5979389069999,
							30.46675300900006
						],
						[
							-81.59827090599993,
							30.467075008000055
						],
						[
							-81.59842690599993,
							30.46722600800007
						],
						[
							-81.59883090499994,
							30.467680008000062
						],
						[
							-81.6008909059999,
							30.470106008000073
						],
						[
							-81.60111190599991,
							30.470341008000048
						],
						[
							-81.60146495499993,
							30.470626979000087
						],
						[
							-81.6004707379999,
							30.472275978000084
						],
						[
							-81.6023909079999,
							30.48388010000008
						],
						[
							-81.60162390699992,
							30.48395901100008
						],
						[
							-81.60075390799994,
							30.48401601100005
						],
						[
							-81.60040990699991,
							30.484030010000083
						],
						[
							-81.5966719079999,
							30.48411801100008
						],
						[
							-81.59530590799994,
							30.48415601100004
						],
						[
							-81.59369690699992,
							30.484186011000077
						],
						[
							-81.59347490799992,
							30.484207010000034
						],
						[
							-81.59319290799995,
							30.484266010000056
						],
						[
							-81.5929789079999,
							30.484333011000047
						],
						[
							-81.59275090799991,
							30.484430011000086
						],
						[
							-81.5926439079999,
							30.484484011000063
						],
						[
							-81.59252190799992,
							30.48456401100009
						],
						[
							-81.5920179069999,
							30.484987010000058
						],
						[
							-81.59089690799993,
							30.485901010000077
						],
						[
							-81.59071394499995,
							30.48605008500005
						],
						[
							-81.59067482099994,
							30.48605885700005
						],
						[
							-81.58905116099993,
							30.48777003300006
						],
						[
							-81.58844722499992,
							30.491998780000074
						],
						[
							-81.5879294799999,
							30.499247939000043
						],
						[
							-81.58767065399991,
							30.500111070000063
						],
						[
							-81.5857719089999,
							30.50036974600005
						],
						[
							-81.58439114999993,
							30.501491714000053
						],
						[
							-81.58223366499993,
							30.503217702000086
						],
						[
							-81.58093919899994,
							30.50399447500007
						],
						[
							-81.57833887899994,
							30.503838142000063
						],
						[
							-81.57820083699994,
							30.50365406900005
						],
						[
							-81.57736990699993,
							30.502733011000092
						],
						[
							-81.57675890899992,
							30.502035009000053
						],
						[
							-81.57667490799992,
							30.501890010000068
						],
						[
							-81.5765939069999,
							30.50170901000007
						],
						[
							-81.57613490799991,
							30.50056001100006
						],
						[
							-81.57565490699994,
							30.499412011000064
						],
						[
							-81.5756239079999,
							30.499329010000057
						],
						[
							-81.57555090899992,
							30.499095012000055
						],
						[
							-81.57553690799995,
							30.498968010000052
						],
						[
							-81.57554790799992,
							30.498385011000035
						],
						[
							-81.57555190799991,
							30.497110010000085
						],
						[
							-81.57553590799995,
							30.49611101000005
						],
						[
							-81.57553590799995,
							30.495322011000045
						],
						[
							-81.57556190699995,
							30.493614010000048
						],
						[
							-81.57552290699994,
							30.48939901000006
						],
						[
							-81.57553090899995,
							30.48862801200005
						],
						[
							-81.57599090699995,
							30.486503010000035
						],
						[
							-81.57635990699993,
							30.484798011000066
						],
						[
							-81.5765689079999,
							30.483854010000076
						],
						[
							-81.5768589079999,
							30.482533011000047
						],
						[
							-81.57723190699994,
							30.480808010000093
						],
						[
							-81.57725490699994,
							30.48059501000006
						],
						[
							-81.57725490799994,
							30.48022701000008
						],
						[
							-81.57727790699994,
							30.479259011000064
						],
						[
							-81.57729290799995,
							30.47737901000005
						],
						[
							-81.57730090799993,
							30.47564501000005
						],
						[
							-81.5773089079999,
							30.475416011000046
						],
						[
							-81.5773159069999,
							30.474455010000042
						],
						[
							-81.57734690799994,
							30.474079010000082
						],
						[
							-81.5773999079999,
							30.473831010000087
						],
						[
							-81.57749890999992,
							30.473505009000064
						],
						[
							-81.5775299579999,
							30.473450028000062
						],
						[
							-81.57753785799991,
							30.47341699200007
						],
						[
							-81.57770490799993,
							30.473082010000045
						],
						[
							-81.57778890899993,
							30.472944010000052
						],
						[
							-81.57788090699995,
							30.472826010000063
						],
						[
							-81.57880390699995,
							30.471739011000068
						],
						[
							-81.57900990699994,
							30.47145801000005
						],
						[
							-81.57915490799991,
							30.471209010000056
						],
						[
							-81.57931490699991,
							30.470829011000035
						],
						[
							-81.57937590699993,
							30.47061701100006
						],
						[
							-81.5794299069999,
							30.470367009000086
						],
						[
							-81.57942990999993,
							30.470306011000044
						],
						[
							-81.5794529069999,
							30.47019400900007
						],
						[
							-81.57945990699994,
							30.469944010000066
						],
						[
							-81.5792919079999,
							30.46683701100005
						],
						[
							-81.57927690799994,
							30.46641501000005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Jamestown",
				"RegionID": "274130"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.30967100030992,
					28.355930364504133,
					-81.24432399986605,
					28.400678547348456
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.24432399986605,
							28.396085999629094
						],
						[
							-81.24437830542682,
							28.393635189717898
						],
						[
							-81.25053317726176,
							28.393635595312126
						],
						[
							-81.2505689693792,
							28.390612850764484
						],
						[
							-81.25260825672441,
							28.390577058647033
						],
						[
							-81.25264531238926,
							28.38522386135483
						],
						[
							-81.2511878863971,
							28.38518706289589
						],
						[
							-81.25122422080575,
							28.38398502997078
						],
						[
							-81.25060500791093,
							28.383876113079985
						],
						[
							-81.25067840068233,
							28.37983386920107
						],
						[
							-81.24969466738814,
							28.37976101512337
						],
						[
							-81.24969493538605,
							28.379214944089114
						],
						[
							-81.24867516266075,
							28.379288319773572
						],
						[
							-81.24867542706151,
							28.377904000568527
						],
						[
							-81.24676299988036,
							28.377903860274174
						],
						[
							-81.24676299988036,
							28.37534999974961
						],
						[
							-81.24442900020958,
							28.37534999974961
						],
						[
							-81.24442099984086,
							28.37384599966824
						],
						[
							-81.24442299004042,
							28.372673793657583
						],
						[
							-81.24442276521005,
							28.372382941222114
						],
						[
							-81.24442230835442,
							28.371828126079755
						],
						[
							-81.24441920299543,
							28.36805610688694
						],
						[
							-81.24441613001206,
							28.364323151544944
						],
						[
							-81.24441599961041,
							28.364165000370207
						],
						[
							-81.24435044982631,
							28.36367589778937
						],
						[
							-81.24432499991214,
							28.36348599964745
						],
						[
							-81.25991103129152,
							28.363281615226683
						],
						[
							-81.26132925133979,
							28.36173417159594
						],
						[
							-81.26107059553233,
							28.36128250689181
						],
						[
							-81.26100641361708,
							28.360057570932568
						],
						[
							-81.26171663070667,
							28.35967009174108
						],
						[
							-81.26229549192136,
							28.35908923043403
						],
						[
							-81.26313470236677,
							28.35844523492218
						],
						[
							-81.26468203178372,
							28.357929510610653
						],
						[
							-81.267841770056,
							28.35676860368202
						],
						[
							-81.2683574754819,
							28.357478018576316
						],
						[
							-81.26977559030952,
							28.355930364504133
						],
						[
							-81.27074394519708,
							28.35709043056672
						],
						[
							-81.27254969749704,
							28.357090265091443
						],
						[
							-81.27338697260157,
							28.35689679664138
						],
						[
							-81.27474195052619,
							28.357736223823547
						],
						[
							-81.27680501054974,
							28.359089229534924
						],
						[
							-81.27815901900532,
							28.359735187367306
						],
						[
							-81.27964237514962,
							28.360186745951612
						],
						[
							-81.27964221776821,
							28.360960004616082
						],
						[
							-81.27964206398413,
							28.36160506762336
						],
						[
							-81.28015801942152,
							28.361798437148114
						],
						[
							-81.280545557069,
							28.361411674716162
						],
						[
							-81.28099622712298,
							28.36083081430874
						],
						[
							-81.28189958800758,
							28.360121574782077
						],
						[
							-81.28415683324097,
							28.363216522298124
						],
						[
							-81.2896370408843,
							28.362958969059477
						],
						[
							-81.29259099988704,
							28.362958694766093
						],
						[
							-81.29259099988704,
							28.364388999903976
						],
						[
							-81.29321399982685,
							28.364397000272874
						],
						[
							-81.30426200008567,
							28.364397000272874
						],
						[
							-81.30967100030992,
							28.36449700038569
						],
						[
							-81.30960099978117,
							28.36904999982218
						],
						[
							-81.30959887288455,
							28.369185065400544
						],
						[
							-81.30959497612209,
							28.36943252824605
						],
						[
							-81.30959155240318,
							28.369649906071658
						],
						[
							-81.30959100021946,
							28.369685000315343
						],
						[
							-81.30959100021946,
							28.36991227607924
						],
						[
							-81.30959100021946,
							28.37105499961566
						],
						[
							-81.30959100021946,
							28.375285000350765
						],
						[
							-81.30959200026555,
							28.37536200030278
						],
						[
							-81.3096419998724,
							28.380155000010483
						],
						[
							-81.30964399996468,
							28.380359999567723
						],
						[
							-81.3095320001977,
							28.380359999567723
						],
						[
							-81.30929129935463,
							28.380359999567723
						],
						[
							-81.30842899971529,
							28.380359999567723
						],
						[
							-81.30788799995794,
							28.380359999567723
						],
						[
							-81.30774200042245,
							28.380359999567723
						],
						[
							-81.30774200042245,
							28.381339999776266
						],
						[
							-81.30798599997884,
							28.381339999776266
						],
						[
							-81.30849099987532,
							28.381339999776266
						],
						[
							-81.30923399995073,
							28.381339999776266
						],
						[
							-81.30936064068028,
							28.381339999776266
						],
						[
							-81.309500999668,
							28.381339999776266
						],
						[
							-81.30951068986288,
							28.38208206905349
						],
						[
							-81.30951999964462,
							28.38279500029713
						],
						[
							-81.3095233505185,
							28.38305967436744
						],
						[
							-81.30952699996716,
							28.383347999708192
						],
						[
							-81.30954719244481,
							28.384007129910437
						],
						[
							-81.2979393534309,
							28.375972269440048
						],
						[
							-81.2959724812941,
							28.374913574057224
						],
						[
							-81.29445919301487,
							28.3747614204611
						],
						[
							-81.29264450055457,
							28.37506492365967
						],
						[
							-81.2902239105616,
							28.375821044843384
						],
						[
							-81.28265863378661,
							28.37869526725732
						],
						[
							-81.28259869847008,
							28.37707976743203
						],
						[
							-81.27555515617594,
							28.37981997557491
						],
						[
							-81.26804101305285,
							28.382637153092936
						],
						[
							-81.26256387209784,
							28.38404619286215
						],
						[
							-81.25982486275123,
							28.38545337643049
						],
						[
							-81.25747634532492,
							28.387801813817177
						],
						[
							-81.2502767490749,
							28.39688038426734
						],
						[
							-81.2467554437767,
							28.399305874666176
						],
						[
							-81.2446182256584,
							28.400605232221416
						],
						[
							-81.24443409073038,
							28.400678547348456
						],
						[
							-81.24444800018593,
							28.400507000175452
						],
						[
							-81.24446700016263,
							28.400248999973627
						],
						[
							-81.24447699972417,
							28.400051999885918
						],
						[
							-81.24446700016263,
							28.39999099977198
						],
						[
							-81.24438900016426,
							28.399940000118946
						],
						[
							-81.24437899970344,
							28.399853999751855
						],
						[
							-81.24440900018705,
							28.39975899986949
						],
						[
							-81.24445100032429,
							28.3991660004132
						],
						[
							-81.24439139595832,
							28.397720492236395
						],
						[
							-81.2443870387431,
							28.397614805709935
						],
						[
							-81.24432399986605,
							28.396085999629094
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Lake Nona South",
				"RegionID": "274235"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.48590922499994,
					27.996118184000068,
					-82.46433204199991,
					28.010873789000073
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.46488493599992,
							28.010873789000073
						],
						[
							-82.46490488199993,
							28.010652354000058
						],
						[
							-82.46492499999994,
							28.01066600000007
						],
						[
							-82.46488353299992,
							28.01054309700004
						],
						[
							-82.46481810199992,
							28.01033745700005
						],
						[
							-82.46479005999993,
							28.010103774000072
						],
						[
							-82.46472462899993,
							28.00990748000004
						],
						[
							-82.46461246199993,
							28.00966445000006
						],
						[
							-82.46447225199995,
							28.009346642000082
						],
						[
							-82.4643881259999,
							28.009103612000047
						],
						[
							-82.4643413899999,
							28.008804498000075
						],
						[
							-82.46433204199991,
							28.00843995300005
						],
						[
							-82.4643881259999,
							28.00823431200007
						],
						[
							-82.4644255149999,
							28.008084756000073
						],
						[
							-82.4644815989999,
							28.00797258800009
						],
						[
							-82.46454702999995,
							28.007832378000046
						],
						[
							-82.46474332399993,
							28.007589348000067
						],
						[
							-82.46485549199991,
							28.007449139000073
						],
						[
							-82.4650798269999,
							28.007262193000088
						],
						[
							-82.46547241399992,
							28.006944384000064
						],
						[
							-82.4657528329999,
							28.006785480000076
						],
						[
							-82.46624823999991,
							28.006523755000046
						],
						[
							-82.4670708029999,
							28.006028348000086
						],
						[
							-82.46806161799992,
							28.00553294100007
						],
						[
							-82.46858506699994,
							28.005299258000036
						],
						[
							-82.4689122229999,
							28.00523382700004
						],
						[
							-82.46927676799993,
							28.005159048000053
						],
						[
							-82.46951979799991,
							28.005000144000064
						],
						[
							-82.46988434299993,
							28.004710378000084
						],
						[
							-82.4702956239999,
							28.004299096000068
						],
						[
							-82.47063212699993,
							28.00401867700009
						],
						[
							-82.4709966719999,
							28.003869120000047
						],
						[
							-82.47142664799992,
							28.00379434200005
						],
						[
							-82.47209030699992,
							28.003691521000064
						],
						[
							-82.47267918799992,
							28.003560659000073
						],
						[
							-82.47324002599993,
							28.003317629000037
						],
						[
							-82.4734830559999,
							28.00307459900006
						],
						[
							-82.47369804399995,
							28.002803527000083
						],
						[
							-82.47382890599994,
							28.002495066000055
						],
						[
							-82.47387564299993,
							28.002139868000086
						],
						[
							-82.47383825399993,
							28.001887491000048
						],
						[
							-82.47366065499995,
							28.001457515000084
						],
						[
							-82.4735110979999,
							28.00110231700006
						],
						[
							-82.47338958299991,
							28.000691036000035
						],
						[
							-82.47332415199992,
							28.000289101000078
						],
						[
							-82.47328676199993,
							27.999690874000066
						],
						[
							-82.47322133099993,
							27.99931698200004
						],
						[
							-82.47313720599993,
							27.998971131000076
						],
						[
							-82.4729035229999,
							27.99868136500004
						],
						[
							-82.47246419899994,
							27.998335514000075
						],
						[
							-82.47205291799992,
							27.998073790000035
						],
						[
							-82.4716696779999,
							27.997952275000046
						],
						[
							-82.47146403799991,
							27.997868149000055
						],
						[
							-82.47097797799995,
							27.99772793900007
						],
						[
							-82.4705050469999,
							27.99770490900005
						],
						[
							-82.4698854799999,
							27.99770490900005
						],
						[
							-82.46928974299993,
							27.997752568000067
						],
						[
							-82.46867017699992,
							27.997847886000045
						],
						[
							-82.46816975799993,
							27.997919375000038
						],
						[
							-82.46771699699991,
							27.997919375000038
						],
						[
							-82.46740721399993,
							27.997847886000045
						],
						[
							-82.4670974309999,
							27.997728739000085
						],
						[
							-82.46683530699994,
							27.997538103000068
						],
						[
							-82.46645403499991,
							27.997228320000094
						],
						[
							-82.4660489339999,
							27.996847048000063
						],
						[
							-82.46573914999993,
							27.996513435000054
						],
						[
							-82.46555773599995,
							27.996200084000066
						],
						[
							-82.4659782459999,
							27.996183705000078
						],
						[
							-82.46909999899992,
							27.996118184000068
						],
						[
							-82.47001818199993,
							27.99620000100009
						],
						[
							-82.48456363499992,
							27.996263637000084
						],
						[
							-82.48590922499994,
							27.99626350300008
						],
						[
							-82.48590885399994,
							27.999726629000065
						],
						[
							-82.48577399999994,
							27.99972500000007
						],
						[
							-82.48563526499993,
							27.999724692000086
						],
						[
							-82.48532399999993,
							27.99972400000007
						],
						[
							-82.48532257499994,
							27.99993535100009
						],
						[
							-82.48532099999994,
							28.000169000000085
						],
						[
							-82.48523256099992,
							28.00120651900005
						],
						[
							-82.48521299999993,
							28.00143600000007
						],
						[
							-82.48527899999995,
							28.002421000000083
						],
						[
							-82.48545399999995,
							28.003320000000087
						],
						[
							-82.4854479999999,
							28.00383000000005
						],
						[
							-82.48544499999991,
							28.004573000000054
						],
						[
							-82.48543699999993,
							28.006643000000054
						],
						[
							-82.48543299999994,
							28.00750100000005
						],
						[
							-82.48540253899995,
							28.007706707000068
						],
						[
							-82.48527899999995,
							28.008541000000037
						],
						[
							-82.48529999999994,
							28.009010000000046
						],
						[
							-82.48529946799994,
							28.009037291000084
						],
						[
							-82.48526599999991,
							28.01075600000007
						],
						[
							-82.48530869099994,
							28.010873581000055
						],
						[
							-82.48476433199994,
							28.010869488000083
						],
						[
							-82.46752554599993,
							28.010768677000044
						],
						[
							-82.4660445529999,
							28.010760017000052
						],
						[
							-82.46488493599992,
							28.010873789000073
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Riverbend",
				"RegionID": "276539"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.20055299999977,
					26.704937000000335,
					-80.13135299999969,
					26.839332000000233
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.16276199999987,
							26.816196000000332
						],
						[
							-80.15474199999994,
							26.81083000000026
						],
						[
							-80.1539569999998,
							26.810316000000363
						],
						[
							-80.15283899999967,
							26.810264000000323
						],
						[
							-80.15240299999994,
							26.81024500000035
						],
						[
							-80.15211999999978,
							26.810233000000245
						],
						[
							-80.15185999999977,
							26.81022600000002
						],
						[
							-80.15031299999984,
							26.810187000000347
						],
						[
							-80.1499529999999,
							26.81016900000028
						],
						[
							-80.14995375977551,
							26.81005269099892
						],
						[
							-80.14995633432089,
							26.809658571002366
						],
						[
							-80.14996499999982,
							26.80833200000034
						],
						[
							-80.14996199999966,
							26.807621000000314
						],
						[
							-80.14375299999992,
							26.803471000000307
						],
						[
							-80.1372809999999,
							26.799137000000357
						],
						[
							-80.13270499999992,
							26.796083000000092
						],
						[
							-80.13172399999983,
							26.79542800000025
						],
						[
							-80.13135299999969,
							26.79517700000027
						],
						[
							-80.13136582081052,
							26.794744009994815
						],
						[
							-80.13137082255228,
							26.794575088987322
						],
						[
							-80.13166499999993,
							26.784640000000444
						],
						[
							-80.13198199999987,
							26.778601000000286
						],
						[
							-80.13305134258245,
							26.77860420310047
						],
						[
							-80.13425999899971,
							26.75974000000025
						],
						[
							-80.13426999999982,
							26.7595600000001
						],
						[
							-80.13476839999984,
							26.750638634000197
						],
						[
							-80.13476999899989,
							26.750610000000314
						],
						[
							-80.13487999999994,
							26.749230001000264
						],
						[
							-80.1351029289999,
							26.746292116000276
						],
						[
							-80.1351211489999,
							26.746052000000304
						],
						[
							-80.1351434409998,
							26.745758229000067
						],
						[
							-80.13515403899969,
							26.74562218400009
						],
						[
							-80.1346229999999,
							26.7456290000003
						],
						[
							-80.1340139999997,
							26.74562400000024
						],
						[
							-80.1340679999999,
							26.745181000000358
						],
						[
							-80.13464199999969,
							26.74519700000026
						],
						[
							-80.1351875489999,
							26.74521140200021
						],
						[
							-80.13520905599971,
							26.744943805000183
						],
						[
							-80.13585999999984,
							26.736740000000232
						],
						[
							-80.13595999899968,
							26.73544000100005
						],
						[
							-80.13601999999985,
							26.730220000000244
						],
						[
							-80.13606999999989,
							26.72544000100025
						],
						[
							-80.13615490099981,
							26.72213316900038
						],
						[
							-80.13615976799979,
							26.72194362096267
						],
						[
							-80.13637399999992,
							26.721943000000365
						],
						[
							-80.14351599999985,
							26.721981000000312
						],
						[
							-80.14471599999985,
							26.72198800000036
						],
						[
							-80.14599441099966,
							26.721990571062122
						],
						[
							-80.14641137400058,
							26.721991409632402
						],
						[
							-80.15117999999981,
							26.72200100000037
						],
						[
							-80.15145399999993,
							26.722035000000343
						],
						[
							-80.15147399999971,
							26.721523000000253
						],
						[
							-80.1514858166346,
							26.721234230985335
						],
						[
							-80.15177433499979,
							26.72123749100035
						],
						[
							-80.15506316699985,
							26.721274653000044
						],
						[
							-80.16050458399977,
							26.721380931000134
						],
						[
							-80.16498950199978,
							26.72146595300024
						],
						[
							-80.16726384499984,
							26.721593486000224
						],
						[
							-80.16760393299982,
							26.718809011000317
						],
						[
							-80.16811406599976,
							26.714175304000175
						],
						[
							-80.16875173199985,
							26.708946443000343
						],
						[
							-80.1688328419999,
							26.70858395700037
						],
						[
							-80.16887919399983,
							26.70837680900029
						],
						[
							-80.16873044699969,
							26.708374322000346
						],
						[
							-80.16681727299992,
							26.708342329000274
						],
						[
							-80.16607999999968,
							26.70833000000023
						],
						[
							-80.16579743799983,
							26.708322041000372
						],
						[
							-80.16524403499987,
							26.708306452000237
						],
						[
							-80.16413842699988,
							26.708275308000328
						],
						[
							-80.16273607599976,
							26.708235805000346
						],
						[
							-80.16225244423205,
							26.70822410196358
						],
						[
							-80.16208199999981,
							26.70714800000031
						],
						[
							-80.15995499999977,
							26.7072810000003
						],
						[
							-80.15970999999985,
							26.70511500000032
						],
						[
							-80.16260399999975,
							26.704937000000335
						],
						[
							-80.1625849999997,
							26.705071000000054
						],
						[
							-80.1625799999998,
							26.705294000000208
						],
						[
							-80.16231499999991,
							26.705275000000235
						],
						[
							-80.16234699999991,
							26.705560000000013
						],
						[
							-80.16226999999992,
							26.705913000000088
						],
						[
							-80.16272299999974,
							26.706389000000215
						],
						[
							-80.1623359999997,
							26.706460000000227
						],
						[
							-80.16246499999971,
							26.70656000000033
						],
						[
							-80.16245599999968,
							26.706891000000006
						],
						[
							-80.16261499999978,
							26.706908000000347
						],
						[
							-80.16241199999976,
							26.707079000000284
						],
						[
							-80.16242399999987,
							26.70718700000034
						],
						[
							-80.16607799999977,
							26.707277000000325
						],
						[
							-80.16607899999978,
							26.70700000000032
						],
						[
							-80.17005699999976,
							26.707072000000064
						],
						[
							-80.1700789999998,
							26.708227000000235
						],
						[
							-80.17008999999982,
							26.708509000000298
						],
						[
							-80.17284899999974,
							26.70858000000031
						],
						[
							-80.17285899999978,
							26.707849000000223
						],
						[
							-80.17309799999974,
							26.70785400000028
						],
						[
							-80.17309499999985,
							26.708586000000277
						],
						[
							-80.17330899999989,
							26.708591000000332
						],
						[
							-80.17409099999985,
							26.708610000000306
						],
						[
							-80.17554399999972,
							26.708647000000347
						],
						[
							-80.17581099999978,
							26.708654000000216
						],
						[
							-80.18252699999982,
							26.70879300000035
						],
						[
							-80.18281099999977,
							26.708802000000205
						],
						[
							-80.18345599999985,
							26.70882200000026
						],
						[
							-80.1866789999999,
							26.708922000000364
						],
						[
							-80.18978099999978,
							26.709005000000126
						],
						[
							-80.19242299999989,
							26.709070000000352
						],
						[
							-80.19285999999981,
							26.709081000000374
						],
						[
							-80.1951129999998,
							26.709139000000203
						],
						[
							-80.19543599999979,
							26.709148000000233
						],
						[
							-80.19642099999976,
							26.70917100000036
						],
						[
							-80.19716599999984,
							26.709190000000333
						],
						[
							-80.20015199999982,
							26.709263000000156
						],
						[
							-80.20055299999977,
							26.709273000000273
						],
						[
							-80.20053799999988,
							26.709467000000338
						],
						[
							-80.20054399999975,
							26.709682000000008
						],
						[
							-80.20053855464606,
							26.709977355993892
						],
						[
							-80.20049412800495,
							26.71238705700045
						],
						[
							-80.20049399999986,
							26.712394000000224
						],
						[
							-80.2004733836507,
							26.71299236498836
						],
						[
							-80.20045199999986,
							26.713613000000368
						],
						[
							-80.20045182784183,
							26.713621357997148
						],
						[
							-80.2003589999998,
							26.718128000000192
						],
						[
							-80.19937926864411,
							26.76574373399287
						],
						[
							-80.1985448579998,
							26.76574397800035
						],
						[
							-80.19744592999983,
							26.806508455000362
						],
						[
							-80.19739527199981,
							26.808387518000316
						],
						[
							-80.19730789699969,
							26.811627986000385
						],
						[
							-80.19738099999987,
							26.81162200000024
						],
						[
							-80.19736199999981,
							26.839332000000233
						],
						[
							-80.19555948762533,
							26.8381312525624
						],
						[
							-80.19023599999977,
							26.834585000000217
						],
						[
							-80.18051599999987,
							26.828085000000286
						],
						[
							-80.16941499999984,
							26.820655000000325
						],
						[
							-80.16302099999989,
							26.816371000000245
						],
						[
							-80.16276199999987,
							26.816196000000332
						]
					],
					[
						[
							-80.13561183299973,
							26.795520119000678
						],
						[
							-80.13566684399967,
							26.795495134000475
						],
						[
							-80.13572192199979,
							26.795474405000448
						],
						[
							-80.13577823799983,
							26.795457321000278
						],
						[
							-80.13583555099977,
							26.795443958000327
						],
						[
							-80.13589168299971,
							26.795434628000088
						],
						[
							-80.13601964799982,
							26.79541750000027
						],
						[
							-80.13607918099977,
							26.795411603000225
						],
						[
							-80.13613799999983,
							26.79540967800051
						],
						[
							-80.1361968179999,
							26.795411603000225
						],
						[
							-80.13625538499979,
							26.79541737200026
						],
						[
							-80.13631344899987,
							26.79542695800052
						],
						[
							-80.13636417399981,
							26.795438583000326
						],
						[
							-80.13649117499975,
							26.795471584000303
						],
						[
							-80.13649776199985,
							26.79547332200027
						],
						[
							-80.13655407799989,
							26.79549040500035
						],
						[
							-80.13659254699961,
							26.79550444900027
						],
						[
							-80.13662408199973,
							26.794735833000267
						],
						[
							-80.1365893459997,
							26.794679988000176
						],
						[
							-80.1365741639996,
							26.7946546610003
						],
						[
							-80.1365464219998,
							26.794602760000714
						],
						[
							-80.1365240919998,
							26.794553844000575
						],
						[
							-80.13641509199977,
							26.794294844000284
						],
						[
							-80.13641313499987,
							26.794290155000343
						],
						[
							-80.13639240499975,
							26.794235077000224
						],
						[
							-80.13637532199975,
							26.79417876100036
						],
						[
							-80.13636195799971,
							26.794121449000237
						],
						[
							-80.1363574589997,
							26.79409707800062
						],
						[
							-80.1362664579999,
							26.793563079000045
						],
						[
							-80.13626137099992,
							26.793529385000454
						],
						[
							-80.1362556029998,
							26.793470819000227
						],
						[
							-80.13625367799982,
							26.79341200000007
						],
						[
							-80.1362556029998,
							26.793353182000352
						],
						[
							-80.13626137099992,
							26.793294615000214
						],
						[
							-80.13627095799983,
							26.793236551000028
						],
						[
							-80.13628432099986,
							26.793179239000438
						],
						[
							-80.1363014039996,
							26.793122923000396
						],
						[
							-80.13632213399988,
							26.79306784500028
						],
						[
							-80.13634642199985,
							26.793014240000197
						],
						[
							-80.13637416399968,
							26.79296233900061
						],
						[
							-80.1363875439997,
							26.792939922000265
						],
						[
							-80.13638246599963,
							26.79289873300032
						],
						[
							-80.13631081999966,
							26.792707457000304
						],
						[
							-80.1363014039996,
							26.792681078000342
						],
						[
							-80.13628432099986,
							26.792624762000305
						],
						[
							-80.13627095799983,
							26.792567449000444
						],
						[
							-80.13626137099992,
							26.79250938500026
						],
						[
							-80.1362556029998,
							26.792450818000475
						],
						[
							-80.13625367799982,
							26.792392000000408
						],
						[
							-80.1362556029998,
							26.792333182000334
						],
						[
							-80.13626137099992,
							26.792274615000018
						],
						[
							-80.13627095799983,
							26.792216551000365
						],
						[
							-80.13628432099986,
							26.79215923800033
						],
						[
							-80.1363014039996,
							26.79210292200029
						],
						[
							-80.13632093399978,
							26.792050757000325
						],
						[
							-80.13635620999969,
							26.791964742000406
						],
						[
							-80.13636737299963,
							26.79189931500023
						],
						[
							-80.13638249899972,
							26.791654830000162
						],
						[
							-80.13638837199986,
							26.791594615000243
						],
						[
							-80.13639795799985,
							26.791536551000057
						],
						[
							-80.13641132199972,
							26.791479238000377
						],
						[
							-80.1364284049997,
							26.791422923000425
						],
						[
							-80.13644913499982,
							26.79136784400022
						],
						[
							-80.13647342299954,
							26.79131424000023
						],
						[
							-80.13650116399968,
							26.79126233900064
						],
						[
							-80.1365322409996,
							26.7912123640005
						],
						[
							-80.13656651999986,
							26.791164528000273
						],
						[
							-80.13660385399974,
							26.79111903600024
						],
						[
							-80.13663198199986,
							26.791088420000015
						],
						[
							-80.13665442299984,
							26.791039240000387
						],
						[
							-80.13668216499957,
							26.790987339000267
						],
						[
							-80.13671324099965,
							26.790937363000218
						],
						[
							-80.13674751999973,
							26.790889527000346
						],
						[
							-80.1367848539998,
							26.79084403600058
						],
						[
							-80.13682508399975,
							26.79080108300031
						],
						[
							-80.13684918099989,
							26.79077786600061
						],
						[
							-80.13692208899988,
							26.788430385000268
						],
						[
							-80.13673957199961,
							26.78841464100039
						],
						[
							-80.13567760499976,
							26.78845080100036
						],
						[
							-80.13565918999983,
							26.78845123900022
						],
						[
							-80.13470921299965,
							26.788464117000217
						],
						[
							-80.13420837999979,
							26.78848096300019
						],
						[
							-80.13406707999974,
							26.78947828100064
						],
						[
							-80.1340431419997,
							26.789945059000182
						],
						[
							-80.1340423969999,
							26.78995781900035
						],
						[
							-80.13403662799969,
							26.7900163850004
						],
						[
							-80.1340270419997,
							26.790074449000052
						],
						[
							-80.13401689199983,
							26.79011942100022
						],
						[
							-80.13394690899973,
							26.79039624200012
						],
						[
							-80.13389932199979,
							26.791110908000633
						],
						[
							-80.13389932199979,
							26.791379799000232
						],
						[
							-80.13395055499977,
							26.791937769000036
						],
						[
							-80.13395239699983,
							26.791961181000374
						],
						[
							-80.13395432199991,
							26.79202
						],
						[
							-80.13395239699983,
							26.79207881800007
						],
						[
							-80.13394662899964,
							26.792137385000387
						],
						[
							-80.13393704199972,
							26.79219544900004
						],
						[
							-80.1339326489998,
							26.79221624800025
						],
						[
							-80.13389664799966,
							26.792377248000605
						],
						[
							-80.13388767799972,
							26.79241376200025
						],
						[
							-80.13387059499972,
							26.792470078000296
						],
						[
							-80.13384986499987,
							26.79252515600041
						],
						[
							-80.13382557699973,
							26.792578760000048
						],
						[
							-80.13379783499974,
							26.792630661000167
						],
						[
							-80.13378711699974,
							26.792648735000242
						],
						[
							-80.13367811799979,
							26.79282773500031
						],
						[
							-80.13365775899962,
							26.792859637000284
						],
						[
							-80.13364125499984,
							26.792883494000215
						],
						[
							-80.13362802399973,
							26.79411264100022
						],
						[
							-80.13369092499987,
							26.794544329000587
						],
						[
							-80.13369262899974,
							26.794556615000715
						],
						[
							-80.13369839699986,
							26.794615181000232
						],
						[
							-80.13369915199983,
							26.794638235000185
						],
						[
							-80.13375070299966,
							26.79465507400007
						],
						[
							-80.13383816399971,
							26.794679503000225
						],
						[
							-80.13386738699955,
							26.794675213000403
						],
						[
							-80.13388061499975,
							26.79467337100025
						],
						[
							-80.13393918099972,
							26.79466760300013
						],
						[
							-80.13399799999979,
							26.794665678000236
						],
						[
							-80.13405681799986,
							26.79466760300013
						],
						[
							-80.13411538499973,
							26.79467337100025
						],
						[
							-80.13417344899983,
							26.794682958000244
						],
						[
							-80.13423076199977,
							26.794696321000195
						],
						[
							-80.13428707699981,
							26.79471340500019
						],
						[
							-80.13434215499966,
							26.79473413400022
						],
						[
							-80.13439575999985,
							26.79475842200027
						],
						[
							-80.1344476609996,
							26.794786164000257
						],
						[
							-80.13449763599974,
							26.794817241000434
						],
						[
							-80.13454547199962,
							26.79485152000069
						],
						[
							-80.13459096399973,
							26.794888854000227
						],
						[
							-80.13463391699973,
							26.794929083000625
						],
						[
							-80.13467414599978,
							26.794972035000626
						],
						[
							-80.13471147999985,
							26.795017527000482
						],
						[
							-80.13474575899976,
							26.795065363000358
						],
						[
							-80.13477683599966,
							26.795115339000404
						],
						[
							-80.13480457699983,
							26.795167240000524
						],
						[
							-80.13482692999963,
							26.79521621000049
						],
						[
							-80.13485481799971,
							26.79521760300016
						],
						[
							-80.13491338499976,
							26.795223372000372
						],
						[
							-80.13497144899968,
							26.795232958000277
						],
						[
							-80.1350287609998,
							26.795246321000228
						],
						[
							-80.13508507699984,
							26.79526340500022
						],
						[
							-80.1351401549997,
							26.79528413500034
						],
						[
							-80.13519375999986,
							26.795308422000303
						],
						[
							-80.13524566099981,
							26.79533616400029
						],
						[
							-80.13529563599977,
							26.795367241000463
						],
						[
							-80.13534347199973,
							26.79540152000019
						],
						[
							-80.13538896399959,
							26.79543885400026
						],
						[
							-80.13543191599977,
							26.795479083000657
						],
						[
							-80.13545076099982,
							26.795498504000044
						],
						[
							-80.13547790599975,
							26.795527333000564
						],
						[
							-80.13561183299973,
							26.795520119000678
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "West Palm Beach",
				"Name": "Water Catchment Area",
				"RegionID": "276638"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.72791366899992,
					28.041584917000097,
					-82.72468903999992,
					28.048942998000058
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.72568902399988,
							28.04160454100012
						],
						[
							-82.72777364599996,
							28.041584917000097
						],
						[
							-82.72791366899992,
							28.048942998000058
						],
						[
							-82.72621650499991,
							28.048929979000047
						],
						[
							-82.72559851199993,
							28.048817039000113
						],
						[
							-82.72584992299997,
							28.047749913000104
						],
						[
							-82.7259029449999,
							28.047039845000064
						],
						[
							-82.72478184899987,
							28.046960330000054
						],
						[
							-82.72468903999992,
							28.043419960000044
						],
						[
							-82.72570947099989,
							28.043409415000063
						],
						[
							-82.72568902399988,
							28.04160454100012
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Countryside Northridge Homeowners Assoc",
				"RegionID": "343254"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.7196059439999,
					28.04711039300013,
					-82.71846907699998,
					28.048797939000046
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.71850078899993,
							28.048733508000044
						],
						[
							-82.71846907699998,
							28.04711039300013
						],
						[
							-82.7195771129999,
							28.047113187
						],
						[
							-82.7196059439999,
							28.048795280000004
						],
						[
							-82.71857271599994,
							28.048797939000046
						],
						[
							-82.7185347609999,
							28.048786448000072
						],
						[
							-82.71851556199991,
							28.048769702000108
						],
						[
							-82.71850078899993,
							28.048733508000044
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Countryside Woods HOA, Inc",
				"RegionID": "343255"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.71329641899976,
					28.044895987000476,
					-82.70945099999983,
					28.047338830000182
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.70950656082128,
							28.047331626026587
						],
						[
							-82.7094963316141,
							28.047262286057087
						],
						[
							-82.70945099999983,
							28.046955000000043
						],
						[
							-82.70948627305728,
							28.046800421013277
						],
						[
							-82.70955299999991,
							28.046508000000184
						],
						[
							-82.70953699999984,
							28.046138000000123
						],
						[
							-82.7094979999999,
							28.0454970000002
						],
						[
							-82.70947210431706,
							28.044903248986333
						],
						[
							-82.70986338599975,
							28.044895987000476
						],
						[
							-82.70991826899977,
							28.044903267000013
						],
						[
							-82.70997078099984,
							28.04491881100041
						],
						[
							-82.70999594499989,
							28.044929683000422
						],
						[
							-82.71001985599973,
							28.04494193600028
						],
						[
							-82.71004700499985,
							28.044960190000193
						],
						[
							-82.71014476099987,
							28.045020022000347
						],
						[
							-82.71022495599973,
							28.045060864000174
						],
						[
							-82.7102460219998,
							28.045075195000383
						],
						[
							-82.71049124499983,
							28.045145095000304
						],
						[
							-82.71059581799989,
							28.045165870000336
						],
						[
							-82.7107131349998,
							28.045180390000116
						],
						[
							-82.71083126499973,
							28.045185624000016
						],
						[
							-82.7109137489998,
							28.045183036000157
						],
						[
							-82.7109493369998,
							28.04518191900033
						],
						[
							-82.71107339399985,
							28.04516804000034
						],
						[
							-82.71108311199988,
							28.045724784000218
						],
						[
							-82.71142904299971,
							28.045720930000254
						],
						[
							-82.71165601099975,
							28.04571837900031
						],
						[
							-82.71164333199985,
							28.044925283000236
						],
						[
							-82.71168636299977,
							28.044913370000227
						],
						[
							-82.71178298499977,
							28.04490358700004
						],
						[
							-82.71181554599971,
							28.044905137000523
						],
						[
							-82.71229853399973,
							28.044898164000035
						],
						[
							-82.71205740699976,
							28.04529582300052
						],
						[
							-82.71230927199989,
							28.04529544300031
						],
						[
							-82.7126185229998,
							28.045294976000186
						],
						[
							-82.71271898699977,
							28.045294798000167
						],
						[
							-82.71328077699971,
							28.045293601000157
						],
						[
							-82.71328545599974,
							28.045484437000496
						],
						[
							-82.71329641899976,
							28.04593162500019
						],
						[
							-82.71329477899971,
							28.04606503000048
						],
						[
							-82.71329537499986,
							28.046903915000346
						],
						[
							-82.71329543299986,
							28.047338830000182
						],
						[
							-82.71295818899975,
							28.047338174000306
						],
						[
							-82.7126161979998,
							28.047337543000342
						],
						[
							-82.7123867789999,
							28.04733667000018
						],
						[
							-82.71205844699983,
							28.04733631000051
						],
						[
							-82.71181507699986,
							28.047335509000174
						],
						[
							-82.71122138399994,
							28.047334115000414
						],
						[
							-82.71081438599974,
							28.04733347200045
						],
						[
							-82.71007470099991,
							28.047333172000247
						],
						[
							-82.70964561599985,
							28.047332983000498
						],
						[
							-82.70950656082128,
							28.047331626026587
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Oak Creek at Countryside HOA",
				"RegionID": "343256"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.71330145499982,
					28.041625575000246,
					-82.7091992729998,
					28.04439746600035
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.70946635070862,
							28.044377415003755
						],
						[
							-82.70946399999993,
							28.04419500000012
						],
						[
							-82.7094659999999,
							28.043946000000123
						],
						[
							-82.70947499999994,
							28.043506000000132
						],
						[
							-82.70946399999993,
							28.04306600000014
						],
						[
							-82.70946399999993,
							28.042941000000102
						],
						[
							-82.70946399999993,
							28.042381000000134
						],
						[
							-82.70946399999993,
							28.04195100000008
						],
						[
							-82.709202769995,
							28.04195602365411
						],
						[
							-82.7091992729998,
							28.04162981500024
						],
						[
							-82.70989999999976,
							28.041629073000355
						],
						[
							-82.71320542899979,
							28.041625575000246
						],
						[
							-82.71330073799986,
							28.04437484900035
						],
						[
							-82.71330145499982,
							28.04439746600035
						],
						[
							-82.71304935899984,
							28.04438850500023
						],
						[
							-82.70946635070862,
							28.044377415003755
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Ashland Heights Homeowners Association",
				"RegionID": "343257"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.72905461447414,
					28.019604253000203,
					-82.72475287199973,
					28.02186930302525
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.72773395399973,
							28.021862657000188
						],
						[
							-82.72711009099999,
							28.021789978000303
						],
						[
							-82.72710718899974,
							28.021862193000327
						],
						[
							-82.72702565399975,
							28.021850935000106
						],
						[
							-82.7270004759999,
							28.021851756000263
						],
						[
							-82.72655596899988,
							28.02183313400032
						],
						[
							-82.7264071829999,
							28.021831170000336
						],
						[
							-82.72626652599973,
							28.021842572000214
						],
						[
							-82.72593551699978,
							28.02184982200028
						],
						[
							-82.7256053049999,
							28.021831625000285
						],
						[
							-82.72543938899967,
							28.02181737400026
						],
						[
							-82.72529298399982,
							28.021795111000284
						],
						[
							-82.72516353299986,
							28.021773447000268
						],
						[
							-82.7247955519997,
							28.02169081200027
						],
						[
							-82.72476848499969,
							28.02167697300028
						],
						[
							-82.72475287199973,
							28.0216525300003
						],
						[
							-82.72476821799994,
							28.021608098000353
						],
						[
							-82.72497596299988,
							28.02101359100028
						],
						[
							-82.72503842599973,
							28.02085304700032
						],
						[
							-82.72510691299979,
							28.02062302200021
						],
						[
							-82.72515270399985,
							28.020388648000175
						],
						[
							-82.72517503799983,
							28.020151303000166
						],
						[
							-82.72521621399987,
							28.020008406000333
						],
						[
							-82.72520458699988,
							28.019747861000003
						],
						[
							-82.72533049099972,
							28.019630990000017
						],
						[
							-82.72640082399991,
							28.019642527000347
						],
						[
							-82.7274898299998,
							28.019622671000302
						],
						[
							-82.72769368599978,
							28.01961918500019
						],
						[
							-82.72905149899985,
							28.019604253000203
						],
						[
							-82.72905461447414,
							28.021491785024747
						],
						[
							-82.72903498048396,
							28.02186930302525
						],
						[
							-82.72773395399973,
							28.021862657000188
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Misty Sprints Condominium Association",
				"RegionID": "343270"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.83167399999971,
					27.963970844106104,
					-82.81654399999992,
					28.01910700000018
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-82.81979999999993,
								28.00375400000014
							],
							[
								-82.81974999999989,
								28.00373800000006
							],
							[
								-82.81966999999993,
								28.00369900000003
							],
							[
								-82.81943399999994,
								28.00352300000021
							],
							[
								-82.8193969999999,
								28.003479000000123
							],
							[
								-82.81933499999992,
								28.003419000000132
							],
							[
								-82.81930399999993,
								28.003375000000045
							],
							[
								-82.81926699999988,
								28.003336000000015
							],
							[
								-82.81920499999991,
								28.003243000000136
							],
							[
								-82.81917999999989,
								28.00319900000005
							],
							[
								-82.81916099999991,
								28.003138000000153
							],
							[
								-82.81911199999985,
								28.003050000000155
							],
							[
								-82.81909899999994,
								28.003006000000067
							],
							[
								-82.81906799999986,
								28.002962000000156
							],
							[
								-82.81900599999996,
								28.002858000000078
							],
							[
								-82.81893199999988,
								28.00277000000008
							],
							[
								-82.81883299999986,
								28.002682000000082
							],
							[
								-82.8187089999999,
								28.002605000000106
							],
							[
								-82.81866499999991,
								28.002555000000054
							],
							[
								-82.8186099999999,
								28.002511000000144
							],
							[
								-82.81857199999985,
								28.002461999999998
							],
							[
								-82.8185349999999,
								28.002423000000146
							],
							[
								-82.81847299999991,
								28.002335000000148
							],
							[
								-82.81841099999987,
								28.002264000000135
							],
							[
								-82.81839299999979,
								28.002220000000047
							],
							[
								-82.81834899999987,
								28.002176000000137
							],
							[
								-82.81831799999988,
								28.002131000000144
							],
							[
								-82.81824999999994,
								28.00204900000011
							],
							[
								-82.81822499999991,
								28.002005000000022
							],
							[
								-82.81810799999991,
								28.001878000000172
							],
							[
								-82.8180519999999,
								28.001840000000048
							],
							[
								-82.8180079999999,
								28.001790000000174
							],
							[
								-82.81794599999992,
								28.00175200000005
							],
							[
								-82.81789699999986,
								28.00170800000014
							],
							[
								-82.81783499999989,
								28.00166400000005
							],
							[
								-82.81779799999994,
								28.001625000000022
							],
							[
								-82.81767399999988,
								28.001537000000024
							],
							[
								-82.81756799999991,
								28.001455000000167
							],
							[
								-82.81746899999989,
								28.001345000000125
							],
							[
								-82.81731999999982,
								28.00114100000012
							],
							[
								-82.81721499999992,
								28.001053000000123
							],
							[
								-82.8171159999999,
								28.00098200000011
							],
							[
								-82.81701699999988,
								28.000921000000037
							],
							[
								-82.81696099999986,
								28.000905000000134
							],
							[
								-82.81684299999996,
								28.000855000000083
							],
							[
								-82.8167939999999,
								28.00084400000006
							],
							[
								-82.81659499999996,
								28.000822000000195
							],
							[
								-82.81654399999992,
								28.000827000000076
							],
							[
								-82.81655999999991,
								28.000820999999934
							],
							[
								-82.81672899999977,
								28.000804000000304
							],
							[
								-82.81691999999985,
								28.000838000000275
							],
							[
								-82.8171809999996,
								28.000965000000303
							],
							[
								-82.81767999999977,
								28.001463000000296
							],
							[
								-82.81785599999994,
								28.00154299999999
							],
							[
								-82.81803299999967,
								28.00170500000025
							],
							[
								-82.81863399999973,
								28.002392000000423
							],
							[
								-82.8188279999998,
								28.00258600000031
							],
							[
								-82.81896599999976,
								28.00266200000038
							],
							[
								-82.81911699999982,
								28.002792000000305
							],
							[
								-82.81924899999973,
								28.002996000000127
							],
							[
								-82.81940099999996,
								28.00332500000035
							],
							[
								-82.8195459999997,
								28.0035670000003
							],
							[
								-82.81971599999973,
								28.003712000000395
							],
							[
								-82.81979999999993,
								28.00375400000014
							]
						]
					],
					[
						[
							[
								-82.81979999999993,
								28.00375400000014
							],
							[
								-82.81989899999986,
								28.00380400000019
							],
							[
								-82.81984899999992,
								28.003787000000028
							],
							[
								-82.81979999999993,
								28.00375400000014
							]
						]
					],
					[
						[
							[
								-82.82022099999995,
								28.003985000000068
							],
							[
								-82.82012807472653,
								28.003908031591887
							],
							[
								-82.82025099999986,
								28.00396000000031
							],
							[
								-82.82035799999966,
								28.00407400000033
							],
							[
								-82.82038599999974,
								28.004219000000422
							],
							[
								-82.82038599999974,
								28.00426200000043
							],
							[
								-82.82038599999993,
								28.004276461538705
							],
							[
								-82.8203759999999,
								28.00423800000004
							],
							[
								-82.8203449999999,
								28.004167000000027
							],
							[
								-82.82032599999985,
								28.004117000000154
							],
							[
								-82.82022099999995,
								28.003985000000068
							]
						]
					],
					[
						[
							[
								-82.82038199999995,
								28.004546000000122
							],
							[
								-82.82038799999991,
								28.004502000000034
							],
							[
								-82.82040899999978,
								28.004837000000396
							],
							[
								-82.82038099999968,
								28.005071999999945
							],
							[
								-82.8203079999996,
								28.005297000000265
							],
							[
								-82.82029266192576,
								28.00531295159711
							],
							[
								-82.82025699999991,
								28.005283000000173
							],
							[
								-82.82028299999985,
								28.00521200000016
							],
							[
								-82.82029599999996,
								28.005124000000162
							],
							[
								-82.82032699999984,
								28.00507400000011
							],
							[
								-82.82035799999991,
								28.004992000000076
							],
							[
								-82.82036399999988,
								28.004942000000206
							],
							[
								-82.8203759999999,
								28.004898000000114
							],
							[
								-82.82038199999995,
								28.004854000000208
							],
							[
								-82.8203759999999,
								28.004788000000072
							],
							[
								-82.8203889999999,
								28.00472200000012
							],
							[
								-82.82038799999991,
								28.00467800000003
							],
							[
								-82.82038199999995,
								28.004640000000084
							],
							[
								-82.82038199999995,
								28.004546000000122
							]
						]
					],
					[
						[
							[
								-82.82547961010465,
								28.015973497071403
							],
							[
								-82.82568699999977,
								28.015463000000477
							],
							[
								-82.82583899999973,
								28.015228000000395
							],
							[
								-82.82583757112955,
								28.015086968711348
							],
							[
								-82.82579661910965,
								28.01508061095401
							],
							[
								-82.82575849505018,
								28.01506840715461
							],
							[
								-82.8257226345844,
								28.015050619463825
							],
							[
								-82.82568984979955,
								28.01502765167864
							],
							[
								-82.82566088263701,
								28.01500002450627
							],
							[
								-82.82563639050096,
								28.014968362974916
							],
							[
								-82.82561692647413,
								28.014933383844568
							],
							[
								-82.82561025170628,
								28.014925471608723
							],
							[
								-82.82545282718353,
								28.014738851495586
							],
							[
								-82.82543112294564,
								28.014709160378818
							],
							[
								-82.82541365901118,
								28.01467679377964
							],
							[
								-82.82540075823668,
								28.014642352443634
							],
							[
								-82.82539266253968,
								28.014606476689
							],
							[
								-82.82538952030858,
								28.014569832914407
							],
							[
								-82.82538673151095,
								28.014407644682496
							],
							[
								-82.82539080274177,
								28.014358499431427
							],
							[
								-82.8254199092991,
								28.01419327868661
							],
							[
								-82.825432084321,
								28.014147832346584
							],
							[
								-82.82544035448643,
								28.014127683037163
							],
							[
								-82.82550498966009,
								28.013986678335208
							],
							[
								-82.82551875828011,
								28.01396052785005
							],
							[
								-82.82556028807215,
								28.013891208107925
							],
							[
								-82.82557494971917,
								28.01386777447387
							],
							[
								-82.82559407290282,
								28.013841048422098
							],
							[
								-82.82561630324412,
								28.013816844967568
							],
							[
								-82.82564131159107,
								28.013795524740562
							],
							[
								-82.82570102657381,
								28.01375059551187
							],
							[
								-82.8257283362859,
								28.013732534426442
							],
							[
								-82.82577099382759,
								28.013712646819858
							],
							[
								-82.8258059810518,
								28.01369992321209
							],
							[
								-82.82584356012215,
								28.01368917001749
							],
							[
								-82.82588231550568,
								28.01368409064732
							],
							[
								-82.82592139554453,
								28.013684796615582
							],
							[
								-82.82595994228535,
								28.013691272632816
							],
							[
								-82.82607041410397,
								28.013601280175596
							],
							[
								-82.82607641168276,
								28.013596533554015
							],
							[
								-82.82627557194198,
								28.01344347793783
							],
							[
								-82.82628790884166,
								28.01342895838356
							],
							[
								-82.82629549911967,
								28.013409850488205
							],
							[
								-82.82628610749947,
								28.01333485422585
							],
							[
								-82.82626358487863,
								28.013285312373988
							],
							[
								-82.82624730085473,
								28.013249490577966
							],
							[
								-82.82623352773777,
								28.01321236746414
							],
							[
								-82.82622541765176,
								28.013173611182044
							],
							[
								-82.82622315046086,
								28.01313408058316
							],
							[
								-82.82622677472868,
								28.013094651606988
							],
							[
								-82.8262362104154,
								28.01305619659697
							],
							[
								-82.82625124977787,
								28.013019568110412
							],
							[
								-82.82624945203298,
								28.01299081048906
							],
							[
								-82.82625149889007,
								28.012962069056716
							],
							[
								-82.8262573534764,
								28.012933856425374
							],
							[
								-82.82625979513394,
								28.012926913679618
							],
							[
								-82.82612999999975,
								28.012916000000416
							],
							[
								-82.82610299999965,
								28.012792000000456
							],
							[
								-82.82611599999983,
								28.012667000000594
							],
							[
								-82.8261499897535,
								28.012607196605646
							],
							[
								-82.82612278882044,
								28.012578920100243
							],
							[
								-82.82609960160066,
								28.012546152403065
							],
							[
								-82.82608157918705,
								28.012510283843387
							],
							[
								-82.82606912537555,
								28.01247212291226
							],
							[
								-82.82606252255327,
								28.012432527561618
							],
							[
								-82.82606191820888,
								28.012392390818622
							],
							[
								-82.82606732673166,
								28.012352614705552
							],
							[
								-82.82607862581351,
								28.01231409584314
							],
							[
								-82.8261264076924,
								28.012188533400565
							],
							[
								-82.82614202441925,
								28.012154732382402
							],
							[
								-82.82616214495107,
								28.012123403599634
							],
							[
								-82.82618638707582,
								28.012095143304197
							],
							[
								-82.82620952753098,
								28.012071662006935
							],
							[
								-82.82623854685419,
								28.01198747737114
							],
							[
								-82.82626055596205,
								28.011940359191918
							],
							[
								-82.82632531614158,
								28.011833080865603
							],
							[
								-82.82638858884218,
								28.01172413789398
							],
							[
								-82.82641521506945,
								28.011686215283152
							],
							[
								-82.82643461524434,
								28.011665426554902
							],
							[
								-82.82645365389152,
								28.011647066895154
							],
							[
								-82.82645757673428,
								28.011638002629372
							],
							[
								-82.82647530956602,
								28.01159702681925
							],
							[
								-82.82649086423993,
								28.011539441431236
							],
							[
								-82.82649779981142,
								28.01151752135606
							],
							[
								-82.82651631775133,
								28.0114772766953
							],
							[
								-82.82661621624106,
								28.01130012014791
							],
							[
								-82.82657978740342,
								28.01128202578919
							],
							[
								-82.82654654036736,
								28.01125859305326
							],
							[
								-82.82651725304626,
								28.011230367831633
							],
							[
								-82.82649260712594,
								28.01119800932607
							],
							[
								-82.82647317997156,
								28.011162273865256
							],
							[
								-82.82645942394174,
								28.011123995123302
							],
							[
								-82.82644413906473,
								28.011069078022746
							],
							[
								-82.82643604156908,
								28.01102769571965
							],
							[
								-82.82642639723957,
								28.01094420985716
							],
							[
								-82.82642461568261,
								28.01091267692978
							],
							[
								-82.82642653123878,
								28.010881151195935
							],
							[
								-82.82643211782704,
								28.01085006522978
							],
							[
								-82.82644173877401,
								28.01081012633883
							],
							[
								-82.82644389714686,
								28.010801759047258
							],
							[
								-82.82645881959735,
								28.010747506545744
							],
							[
								-82.82646486304141,
								28.01071270907808
							],
							[
								-82.82647056654183,
								28.01061047235233
							],
							[
								-82.82647618910299,
								28.01050969702256
							],
							[
								-82.82648200411937,
								28.010467062863956
							],
							[
								-82.82649452358129,
								28.01042589459907
							],
							[
								-82.82653140028111,
								28.010332222115967
							],
							[
								-82.82654879316915,
								28.01029615390657
							],
							[
								-82.82656005358022,
								28.01027830146491
							],
							[
								-82.82660245841258,
								28.01021656300772
							],
							[
								-82.82660997764395,
								28.01019832385744
							],
							[
								-82.82662576074563,
								28.010166249537708
							],
							[
								-82.8266354392494,
								28.010150726340402
							],
							[
								-82.8266640709648,
								28.010108093979472
							],
							[
								-82.82666959549994,
								28.01010017814686
							],
							[
								-82.82669530082154,
								28.010064715180608
							],
							[
								-82.82671293472796,
								28.010040337258886
							],
							[
								-82.82672685623298,
								28.009991133551996
							],
							[
								-82.82675272433184,
								28.009794788170797
							],
							[
								-82.82675962303105,
								28.009759940341286
							],
							[
								-82.82677118741304,
								28.00972635066358
							],
							[
								-82.82678720433852,
								28.009694641468133
							],
							[
								-82.82680737613155,
								28.009665400012654
							],
							[
								-82.82681676235562,
								28.009568542130584
							],
							[
								-82.82682485535452,
								28.009453655539854
							],
							[
								-82.82682240020527,
								28.00915046890299
							],
							[
								-82.82681894051345,
								28.008847990931788
							],
							[
								-82.82681653392767,
								28.008837316878324
							],
							[
								-82.82681126479996,
								28.00880481537941
							],
							[
								-82.826778570847,
								28.008477777823618
							],
							[
								-82.82674284977583,
								28.00816283434894
							],
							[
								-82.82667243735771,
								28.007764041687114
							],
							[
								-82.82665871909927,
								28.007687389772077
							],
							[
								-82.8265794987211,
								28.007316572320313
							],
							[
								-82.82644999455016,
								28.00692609299002
							],
							[
								-82.82642302927836,
								28.006844762801922
							],
							[
								-82.82641853806439,
								28.006829776500304
							],
							[
								-82.8263438412759,
								28.00655140125851
							],
							[
								-82.82629256373235,
								28.006467755316425
							],
							[
								-82.8262558228302,
								28.006450384911222
							],
							[
								-82.82622217289804,
								28.006427596989983
							],
							[
								-82.82619240623805,
								28.006399928448747
							],
							[
								-82.82616722342249,
								28.006368030396192
							],
							[
								-82.82574692797009,
								28.005745865027013
							],
							[
								-82.82572633979093,
								28.005709648429292
							],
							[
								-82.82571158281573,
								28.005670689798837
							],
							[
								-82.8257030122766,
								28.005629921732936
							],
							[
								-82.82570083142076,
								28.005588319096223
							],
							[
								-82.82570509240877,
								28.00554687743723
							],
							[
								-82.82553727532081,
								28.005318962255746
							],
							[
								-82.82549628422265,
								28.00531119750868
							],
							[
								-82.82545701802427,
								28.005297097937746
							],
							[
								-82.8254204506911,
								28.00527701337973
							],
							[
								-82.82538748604223,
								28.005251440257798
							],
							[
								-82.82535894156086,
								28.005221012596696
							],
							[
								-82.82533552411485,
								28.005186484026826
							],
							[
								-82.82521613551806,
								28.00497809492494
							],
							[
								-82.82517525413719,
								28.004990843713987
							],
							[
								-82.82513286639197,
								28.00499694021791
							],
							[
								-82.82509004967017,
								28.004996229753335
							],
							[
								-82.82504788855414,
								28.004988730307293
							],
							[
								-82.82500745233772,
								28.00497463253492
							],
							[
								-82.82496976714746,
								28.004954293467957
							],
							[
								-82.82493578986168,
								28.00492822931712
							],
							[
								-82.82317595694468,
								28.00334353127109
							],
							[
								-82.82314981814983,
								28.003316462577136
							],
							[
								-82.8231253143225,
								28.003282130058796
							],
							[
								-82.82266899742552,
								28.002523640960778
							],
							[
								-82.82265005230761,
								28.00248466524319
							],
							[
								-82.82263759759682,
								28.002443157934312
							],
							[
								-82.82263195614979,
								28.002400191025703
							],
							[
								-82.82261673512446,
								28.00209735512393
							],
							[
								-82.82260528495644,
								28.001951480593693
							],
							[
								-82.82259653904968,
								28.001803092458847
							],
							[
								-82.82259609118732,
								28.001784249864517
							],
							[
								-82.82259790242186,
								28.001622209121383
							],
							[
								-82.82259295974785,
								28.001174228040174
							],
							[
								-82.82258925813852,
								28.000852500081766
							],
							[
								-82.82258649811921,
								28.00061041158443
							],
							[
								-82.82258555922712,
								28.000525154956183
							],
							[
								-82.82258441354269,
								28.000424725218057
							],
							[
								-82.82258179286639,
								28.00019492840359
							],
							[
								-82.82257853642123,
								27.999925724448822
							],
							[
								-82.82257554077954,
								27.999658790381794
							],
							[
								-82.82257176902304,
								27.999313059516698
							],
							[
								-82.82255015201939,
								27.99928162821256
							],
							[
								-82.82253331761022,
								27.99924739551979
							],
							[
								-82.82252162102803,
								27.999211084493428
							],
							[
								-82.82251531138465,
								27.999173462254948
							],
							[
								-82.82249159446404,
								27.998929465396674
							],
							[
								-82.82247773771034,
								27.99875966980007
							],
							[
								-82.82247764597946,
								27.9987169933727
							],
							[
								-82.82248428387538,
								27.998674837652363
							],
							[
								-82.82249748682203,
								27.99863425484627
							],
							[
								-82.82255860025066,
								27.998487129360075
							],
							[
								-82.82255811371735,
								27.998423013995325
							],
							[
								-82.82255681869353,
								27.998252495343326
							],
							[
								-82.82255556503866,
								27.998087476945802
							],
							[
								-82.82255378617964,
								27.997853253919228
							],
							[
								-82.82255160442452,
								27.99776480559696
							],
							[
								-82.82255262065837,
								27.99773382755088
							],
							[
								-82.82255718381826,
								27.997703170562108
							],
							[
								-82.82256523185117,
								27.9976732402255
							],
							[
								-82.82261914530744,
								27.997510641903848
							],
							[
								-82.82262150332984,
								27.99750383583383
							],
							[
								-82.82270612053952,
								27.997269747705747
							],
							[
								-82.82278011675632,
								27.997063999912903
							],
							[
								-82.82280485710521,
								27.996911294132435
							],
							[
								-82.8228162299317,
								27.996867125730166
							],
							[
								-82.8228265055851,
								27.996837788047305
							],
							[
								-82.82285927777922,
								27.996741814198703
							],
							[
								-82.82286768464154,
								27.996630306361073
							],
							[
								-82.82287043476833,
								27.99660718569125
							],
							[
								-82.82289734338269,
								27.996442100742872
							],
							[
								-82.82292458654499,
								27.99627414785785
							],
							[
								-82.82295063360878,
								27.99611445614431
							],
							[
								-82.8229772724266,
								27.995950314585475
							],
							[
								-82.8230039184392,
								27.995786847518215
							],
							[
								-82.8230304331506,
								27.995623495564207
							],
							[
								-82.82305763224593,
								27.99546365636189
							],
							[
								-82.8230930394535,
								27.995271990152407
							],
							[
								-82.82312012973108,
								27.9951240507793
							],
							[
								-82.82316091578376,
								27.99490280227214
							],
							[
								-82.82319662606284,
								27.994710105439783
							],
							[
								-82.82323053500009,
								27.994525794786643
							],
							[
								-82.82324235299068,
								27.99448233684753
							],
							[
								-82.82326081157538,
								27.994442197407317
							],
							[
								-82.82333093890865,
								27.994317706957364
							],
							[
								-82.82336015428402,
								27.994165540770513
							],
							[
								-82.82339591852254,
								27.993978274944556
							],
							[
								-82.82339969207777,
								27.993958640046763
							],
							[
								-82.82338661683484,
								27.993923722069628
							],
							[
								-82.82337874956578,
								27.99388727614566
							],
							[
								-82.82337625664489,
								27.99385007478971
							],
							[
								-82.82337919113256,
								27.993812904911866
							],
							[
								-82.82340738128119,
								27.993617313162495
							],
							[
								-82.82345971732673,
								27.993281203244994
							],
							[
								-82.82348484978,
								27.993108948901938
							],
							[
								-82.82351196254056,
								27.992924160708125
							],
							[
								-82.82355644930337,
								27.992619358888607
							],
							[
								-82.8236047285072,
								27.99228900463159
							],
							[
								-82.82364126796126,
								27.992038829430857
							],
							[
								-82.82370165114024,
								27.991625881440388
							],
							[
								-82.82370276719905,
								27.991618889211015
							],
							[
								-82.82373121005672,
								27.99145461005647
							],
							[
								-82.8237701273183,
								27.99118587824491
							],
							[
								-82.82380218185332,
								27.990963236687453
							],
							[
								-82.82383371927817,
								27.990745569280154
							],
							[
								-82.82385962874581,
								27.99056752600048
							],
							[
								-82.82388595459958,
								27.99040205524445
							],
							[
								-82.82390929830166,
								27.990243947237406
							],
							[
								-82.82393216716144,
								27.99008864241667
							],
							[
								-82.82395926733146,
								27.989915359248943
							],
							[
								-82.8239838332119,
								27.9897584743199
							],
							[
								-82.82400778395622,
								27.9896076274386
							],
							[
								-82.82403024452412,
								27.989465004856942
							],
							[
								-82.82404783796078,
								27.989353170565604
							],
							[
								-82.82402840990704,
								27.989229925676288
							],
							[
								-82.82402751598094,
								27.98922379769603
							],
							[
								-82.82400519750615,
								27.989057485173877
							],
							[
								-82.82398166764472,
								27.988902892615744
							],
							[
								-82.8239543408453,
								27.988737784286247
							],
							[
								-82.82392846375346,
								27.988562727656078
							],
							[
								-82.82385792363145,
								27.98808655552644
							],
							[
								-82.82383370488907,
								27.987921877972003
							],
							[
								-82.82383103660072,
								27.98789307448654
							],
							[
								-82.82382838449996,
								27.98782467385134
							],
							[
								-82.82382818215248,
								27.987814221031574
							],
							[
								-82.82383146737604,
								27.987772246974277
							],
							[
								-82.82384249666126,
								27.987702358860492
							],
							[
								-82.82385502691498,
								27.987654629142714
							],
							[
								-82.82387868987627,
								27.98758950833548
							],
							[
								-82.82389561601632,
								27.987552083049497
							],
							[
								-82.823912424345,
								27.98752138379196
							],
							[
								-82.8239309566739,
								27.98749215762452
							],
							[
								-82.82397268701487,
								27.987434836637096
							],
							[
								-82.82399965858173,
								27.987403226367142
							],
							[
								-82.82402790988418,
								27.98737486444846
							],
							[
								-82.82405007817209,
								27.987354941768064
							],
							[
								-82.82410397184331,
								27.987311643908544
							],
							[
								-82.82414246732283,
								27.98728582437288
							],
							[
								-82.82420788850374,
								27.987249676123685
							],
							[
								-82.82424755310193,
								27.98723176972341
							],
							[
								-82.82431896017026,
								27.987206243366206
							],
							[
								-82.82435968866649,
								27.98719518979961
							],
							[
								-82.82443486299466,
								27.98718098680634
							],
							[
								-82.82446646067443,
								27.98717693086498
							],
							[
								-82.82450483204735,
								27.987174294951803
							],
							[
								-82.82452326455177,
								27.98717189555983
							],
							[
								-82.8243685065189,
								27.987168873838467
							],
							[
								-82.82434641827041,
								27.98716772810163
							],
							[
								-82.8242006903303,
								27.987154161829434
							],
							[
								-82.8241788475969,
								27.987151224643828
							],
							[
								-82.82414675708887,
								27.98714351655402
							],
							[
								-82.8241125954422,
								27.98713306373425
							],
							[
								-82.82408390167369,
								27.98712247062067
							],
							[
								-82.82401920354754,
								27.987094322740194
							],
							[
								-82.82397930692429,
								27.987072812755645
							],
							[
								-82.82392140767267,
								27.987034998063468
							],
							[
								-82.82389177591119,
								27.987012589655894
							],
							[
								-82.82386550311747,
								27.986986323157584
							],
							[
								-82.82384308751574,
								27.98695669679258
							],
							[
								-82.82378849327266,
								27.986873149775096
							],
							[
								-82.82374402629482,
								27.986815226241752
							],
							[
								-82.82372242997587,
								27.986782395591906
							],
							[
								-82.82370235530942,
								27.986746416416356
							],
							[
								-82.82369125767558,
								27.986724177980552
							],
							[
								-82.82367455906419,
								27.986686458616212
							],
							[
								-82.82366168976586,
								27.98665081578601
							],
							[
								-82.8236397022416,
								27.98657324926143
							],
							[
								-82.82363230261988,
								27.98653862176589
							],
							[
								-82.82360026966876,
								27.986319063983803
							],
							[
								-82.82357736393669,
								27.986161585501993
							],
							[
								-82.82355351931218,
								27.985996822511364
							],
							[
								-82.82352739041004,
								27.9858183142829
							],
							[
								-82.82350599733756,
								27.985671375855606
							],
							[
								-82.82347969576544,
								27.98550436815727
							],
							[
								-82.82343119532845,
								27.985175927657583
							],
							[
								-82.82340002752483,
								27.984967026841296
							],
							[
								-82.82336783989022,
								27.984812520619432
							],
							[
								-82.82336568871169,
								27.984800933754453
							],
							[
								-82.82327880251266,
								27.984268310282193
							],
							[
								-82.8232746962082,
								27.98424313646041
							],
							[
								-82.82327117985913,
								27.98420098074043
							],
							[
								-82.82327429690912,
								27.98415879354305
							],
							[
								-82.82328396911758,
								27.98411761178922
							],
							[
								-82.82329995996267,
								27.984078448113184
							],
							[
								-82.823321875541,
								27.984042264791068
							],
							[
								-82.82334917805876,
								27.984009953049696
							],
							[
								-82.82338119572141,
								27.983982306091907
							],
							[
								-82.82341714072378,
								27.983960002905764
							],
							[
								-82.82345613083038,
								27.983943592976704
							],
							[
								-82.82349720646465,
								27.98393347920093
							],
							[
								-82.82353935768832,
								27.98392990979234
							],
							[
								-82.82376862275258,
								27.983928537425943
							],
							[
								-82.82378001986055,
								27.983928710096354
							],
							[
								-82.82380399039002,
								27.983929579740977
							],
							[
								-82.82388797897357,
								27.98390666231764
							],
							[
								-82.82392646725849,
								27.983899116106517
							],
							[
								-82.82396564352473,
								27.983897229328495
							],
							[
								-82.8240046785974,
								27.983901042454665
							],
							[
								-82.82404274869764,
								27.98391047544239
							],
							[
								-82.82412260489644,
								27.983920435433976
							],
							[
								-82.82413613789419,
								27.98392246880123
							],
							[
								-82.82417059002192,
								27.983930911636282
							],
							[
								-82.82420475436633,
								27.983941708897323
							],
							[
								-82.82422515638615,
								27.983949070746764
							],
							[
								-82.82431839449688,
								27.98398701763968
							],
							[
								-82.82435158937227,
								27.984003260295612
							],
							[
								-82.82438130477077,
								27.984024067908667
							],
							[
								-82.82441522899624,
								27.98402860139159
							],
							[
								-82.82444793913724,
								27.984038671100567
							],
							[
								-82.8244785394683,
								27.98405400184293
							],
							[
								-82.8245134178747,
								27.984072937068408
							],
							[
								-82.82453718695598,
								27.98407803352571
							],
							[
								-82.82462348140125,
								27.98410299510802
							],
							[
								-82.82469060409959,
								27.98411361340324
							],
							[
								-82.82473296756308,
								27.984123880063652
							],
							[
								-82.82478834691432,
								27.98414214889188
							],
							[
								-82.8248014455397,
								27.98414279640379
							],
							[
								-82.82481720525901,
								27.984144040166218
							],
							[
								-82.82487241913496,
								27.98415002785159
							],
							[
								-82.8249008889723,
								27.984144442162876
							],
							[
								-82.82495041373721,
								27.984139843030068
							],
							[
								-82.82499321067387,
								27.984143259554024
							],
							[
								-82.82500587492672,
								27.98414529382082
							],
							[
								-82.82506195844722,
								27.98414292860311
							],
							[
								-82.82514463402073,
								27.984139442831086
							],
							[
								-82.825168534403,
								27.984139494992025
							],
							[
								-82.82520014107557,
								27.98414096448393
							],
							[
								-82.82525261022079,
								27.98414340524477
							],
							[
								-82.82537772480072,
								27.984126154449488
							],
							[
								-82.82540034814569,
								27.98412400057312
							],
							[
								-82.82542325297867,
								27.98412279098496
							],
							[
								-82.82542548329717,
								27.984078028129847
							],
							[
								-82.82542690152803,
								27.984049578976414
							],
							[
								-82.82543195841565,
								27.984009344208364
							],
							[
								-82.82544298770114,
								27.98397032262613
							],
							[
								-82.8254597411713,
								27.98393339466482
							],
							[
								-82.82548184021151,
								27.983899394896486
							],
							[
								-82.82550878479877,
								27.983869091341088
							],
							[
								-82.82553996789089,
								27.98384316838362
							],
							[
								-82.82557468262047,
								27.983822211482693
							],
							[
								-82.82561214747693,
								27.983806694579375
							],
							[
								-82.82565494891034,
								27.9837926309818
							],
							[
								-82.82492523272047,
								27.98378680967001
							],
							[
								-82.82488053461685,
								27.983782719554387
							],
							[
								-82.82484538101806,
								27.983774054586622
							],
							[
								-82.82482040144951,
								27.983764809555925
							],
							[
								-82.82478573798124,
								27.983754537499653
							],
							[
								-82.82475271667494,
								27.983742828326644
							],
							[
								-82.82472195446562,
								27.98372605866827
							],
							[
								-82.8246942211728,
								27.98370464940884
							],
							[
								-82.82466084643295,
								27.983676658010666
							],
							[
								-82.82463162386289,
								27.983648103636334
							],
							[
								-82.82460704719045,
								27.983615464541703
							],
							[
								-82.8245876811901,
								27.983579488063373
							],
							[
								-82.82456293004905,
								27.98352376786905
							],
							[
								-82.82455061383381,
								27.98349020607073
							],
							[
								-82.82454284279231,
								27.983455310577657
							],
							[
								-82.82453975452063,
								27.983419693827575
							],
							[
								-82.82453347725259,
								27.983107753190342
							],
							[
								-82.82453722562681,
								27.983060047753234
							],
							[
								-82.82457993802728,
								27.982807439887228
							],
							[
								-82.8245810540859,
								27.982801277732353
							],
							[
								-82.82470195534239,
								27.98217503753559
							],
							[
								-82.82473662870336,
								27.981964399229145
							],
							[
								-82.82478669485982,
								27.98160012164629
							],
							[
								-82.82479451021929,
								27.98154534306764
							],
							[
								-82.82488199999969,
								27.98067499999998
							],
							[
								-82.82488199999969,
								27.980592000000396
							],
							[
								-82.82484099999958,
								27.980516000000325
							],
							[
								-82.82480599999963,
								27.980364000000538
							],
							[
								-82.8248199999998,
								27.980274000000197
							],
							[
								-82.82486199999981,
								27.98020500000035
							],
							[
								-82.8249239999997,
								27.980142000000466
							],
							[
								-82.82494899999982,
								27.98008800000044
							],
							[
								-82.82496599999989,
								27.980052000000303
							],
							[
								-82.82502899999977,
								27.979796000000437
							],
							[
								-82.82494799999982,
								27.9786240000001
							],
							[
								-82.82490799999981,
								27.978408000000524
							],
							[
								-82.82469800006965,
								27.978230004314423
							],
							[
								-82.82453809617073,
								27.97823308604929
							],
							[
								-82.82449749897552,
								27.97823041326321
							],
							[
								-82.8244577660289,
								27.978221666457973
							],
							[
								-82.8244198002502,
								27.97820704258182
							],
							[
								-82.82438446498837,
								27.978186876185266
							],
							[
								-82.82435256423734,
								27.97816162592081
							],
							[
								-82.8243248237502,
								27.978131864656422
							],
							[
								-82.82430187395116,
								27.978098270481514
							],
							[
								-82.82428423734673,
								27.97806160692115
							],
							[
								-82.82427231413531,
								27.97802270854614
							],
							[
								-82.82426637681145,
								27.977982459388176
							],
							[
								-82.82426016609337,
								27.97789514421282
							],
							[
								-82.82424622300464,
								27.977705471800466
							],
							[
								-82.82420116697106,
								27.97721518031661
							],
							[
								-82.82420032340701,
								27.977178020329877
							],
							[
								-82.82420530206076,
								27.977139304849988
							],
							[
								-82.82410699999978,
								27.976653000000447
							],
							[
								-82.82400099999971,
								27.976179000000304
							],
							[
								-82.82400099999971,
								27.976034000000386
							],
							[
								-82.82403599999986,
								27.97595600000033
							],
							[
								-82.82413299999989,
								27.975893000000443
							],
							[
								-82.82423699999997,
								27.97585200000025
							],
							[
								-82.82627599999965,
								27.975683000000476
							],
							[
								-82.82648399999981,
								27.975723000000414
							],
							[
								-82.82660999999968,
								27.975868000000506
							],
							[
								-82.82663699999978,
								27.97598700000005
							],
							[
								-82.8266469999998,
								27.976242000000543
							],
							[
								-82.82667747016433,
								27.976349952427988
							],
							[
								-82.82767987941504,
								27.976279797178734
							],
							[
								-82.82768364434288,
								27.976277241396655
							],
							[
								-82.8276979999538,
								27.97614752588721
							],
							[
								-82.82769799999981,
								27.976049000000383
							],
							[
								-82.82768399999962,
								27.975973000000312
							],
							[
								-82.82766099999968,
								27.975949000000462
							],
							[
								-82.82764381778225,
								27.975932142536056
							],
							[
								-82.82754076155514,
								27.975925735987875
							],
							[
								-82.82750920434505,
								27.97592189768149
							],
							[
								-82.82735190482845,
								27.975893276757194
							],
							[
								-82.82732102480786,
								27.97588575482816
							],
							[
								-82.82724523624239,
								27.97586248936678
							],
							[
								-82.82722581898064,
								27.975855708479816
							],
							[
								-82.82715250355074,
								27.975826925678252
							],
							[
								-82.82713969360776,
								27.975821511758983
							],
							[
								-82.82705512496145,
								27.97578317006383
							],
							[
								-82.82702489245287,
								27.97576707759585
							],
							[
								-82.82699694242348,
								27.975747283518007
							],
							[
								-82.82697172543372,
								27.975724108888148
							],
							[
								-82.82686817209945,
								27.975616038259258
							],
							[
								-82.8267796437381,
								27.975542213813146
							],
							[
								-82.82675531078183,
								27.975522151737056
							],
							[
								-82.82672928889905,
								27.975497403294828
							],
							[
								-82.82670678426445,
								27.97546941819117
							],
							[
								-82.82668819797613,
								27.975438690156658
							],
							[
								-82.82667385918579,
								27.97540576597665
							],
							[
								-82.82661988547487,
								27.975252893822603
							],
							[
								-82.82660859718474,
								27.97520993141031
							],
							[
								-82.8266061384382,
								27.975192786734585
							],
							[
								-82.82659719468073,
								27.975112047402565
							],
							[
								-82.82659583850317,
								27.975094734554165
							],
							[
								-82.82659344270911,
								27.975042634130283
							],
							[
								-82.82657589603717,
								27.974976116676334
							],
							[
								-82.82656745500059,
								27.974968668491154
							],
							[
								-82.82647756416644,
								27.974920581741817
							],
							[
								-82.82647043344217,
								27.974916627423166
							],
							[
								-82.82631053398528,
								27.97482476797281
							],
							[
								-82.82616090118864,
								27.97473882875973
							],
							[
								-82.82602383102169,
								27.97466679216651
							],
							[
								-82.82589221164523,
								27.974615836580444
							],
							[
								-82.82585471801063,
								27.974597887910875
							],
							[
								-82.82582777342309,
								27.974580100220084
							],
							[
								-82.82580911433895,
								27.97456611106305
							],
							[
								-82.82559409361541,
								27.974513963062467
							],
							[
								-82.82558596568303,
								27.97451321336776
							],
							[
								-82.82554423067728,
								27.97451256563274
							],
							[
								-82.82461397197014,
								27.974511653720416
							],
							[
								-82.82415166199132,
								27.974519213420837
							],
							[
								-82.82414527320759,
								27.97451924219924
							],
							[
								-82.82391582827876,
								27.974517560466797
							],
							[
								-82.82343396974514,
								27.974524460230757
							],
							[
								-82.8231859999998,
								27.974537000000335
							],
							[
								-82.82288052374554,
								27.974529964177034
							],
							[
								-82.82284463052132,
								27.97452785590561
							],
							[
								-82.82281089335457,
								27.974521435646086
							],
							[
								-82.82277824616624,
								27.974510781377507
							],
							[
								-82.82269493027552,
								27.974477586502037
							],
							[
								-82.82265988819277,
								27.974460601007248
							],
							[
								-82.82264762593694,
								27.974453078177778
							],
							[
								-82.82258847123181,
								27.974414581799426
							],
							[
								-82.8225645168901,
								27.974397043221547
							],
							[
								-82.82254263458648,
								27.97437698024591
							],
							[
								-82.82252308962084,
								27.974354633892876
							],
							[
								-82.82248242048007,
								27.974302618904648
							],
							[
								-82.82246131159326,
								27.974271335987414
							],
							[
								-82.82244166500446,
								27.97422933764945
							],
							[
								-82.82241940678404,
								27.97416864870083
							],
							[
								-82.82240712114593,
								27.974122910981084
							],
							[
								-82.8224051237516,
								27.97410967296027
							],
							[
								-82.8223955909383,
								27.97403374859783
							],
							[
								-82.82239369786531,
								27.97398952893328
							],
							[
								-82.82239576270862,
								27.9739370480976
							],
							[
								-82.82239522311555,
								27.97386534695018
							],
							[
								-82.82239931772864,
								27.97381747423994
							],
							[
								-82.82240583601464,
								27.97378938481582
							],
							[
								-82.82243451449494,
								27.973690197689752
							],
							[
								-82.82244729565952,
								27.973655238344822
							],
							[
								-82.82246476588931,
								27.97362237172162
							],
							[
								-82.82250233686577,
								27.97356212523933
							],
							[
								-82.82256861150346,
								27.97344231665956
							],
							[
								-82.8225912222577,
								27.97340851923817
							],
							[
								-82.82261865787495,
								27.973378505264993
							],
							[
								-82.82265029422528,
								27.973352958223888
							],
							[
								-82.82268541095199,
								27.973332457279657
							],
							[
								-82.8227891036813,
								27.973281985527723
							],
							[
								-82.82282122656486,
								27.97326883294399
							],
							[
								-82.82285477217577,
								27.973259913468343
							],
							[
								-82.82288918563266,
								27.973255375489106
							],
							[
								-82.82307906040137,
								27.973242681625724
							],
							[
								-82.82332399999984,
								27.97320800000033
							],
							[
								-82.82366452893173,
								27.97324164547305
							],
							[
								-82.8237150069717,
								27.973241665324014
							],
							[
								-82.82398932717035,
								27.97323391946424
							],
							[
								-82.82399532474886,
								27.97323381694145
							],
							[
								-82.82422734893326,
								27.97323242838782
							],
							[
								-82.82483612519592,
								27.973226040503466
							],
							[
								-82.82501771270272,
								27.973222555630986
							],
							[
								-82.82502682553267,
								27.973222534945666
							],
							[
								-82.82520222660341,
								27.973225099813096
							],
							[
								-82.82550326925707,
								27.973211572210595
							],
							[
								-82.82551538042674,
								27.97321130061558
							],
							[
								-82.82555690841995,
								27.97321451569214
							],
							[
								-82.82563920447943,
								27.973227335527287
							],
							[
								-82.82575280593896,
								27.973229923775836
							],
							[
								-82.82578347821612,
								27.973232377126426
							],
							[
								-82.82609917801993,
								27.97327586384341
							],
							[
								-82.82612040381838,
								27.973279658082465
							],
							[
								-82.82626481784925,
								27.973311470700782
							],
							[
								-82.82636577304226,
								27.973332558003353
							],
							[
								-82.8263745486266,
								27.973334543705977
							],
							[
								-82.8264934363009,
								27.973363545043487
							],
							[
								-82.8269111453033,
								27.97345817170733
							],
							[
								-82.82694381227651,
								27.97346777466824
							],
							[
								-82.82695670675587,
								27.973472846843453
							],
							[
								-82.82710067022636,
								27.97353378670319
							],
							[
								-82.82711877447804,
								27.97344911913139
							],
							[
								-82.82713756311384,
								27.973278603178034
							],
							[
								-82.8271385703548,
								27.973270573131362
							],
							[
								-82.82717972962581,
								27.97297796162265
							],
							[
								-82.82720680101743,
								27.97278685569122
							],
							[
								-82.82720805647112,
								27.97277885891926
							],
							[
								-82.82722729386857,
								27.972667280035882
							],
							[
								-82.82725779437533,
								27.972488155772016
							],
							[
								-82.82706717317863,
								27.972461454900458
							],
							[
								-82.8267049073795,
								27.97241625407675
							],
							[
								-82.82652368140002,
								27.97239880003445
							],
							[
								-82.82633518530139,
								27.972380364831753
							],
							[
								-82.82598966307988,
								27.97237345534082
							],
							[
								-82.82580926987258,
								27.972371541583488
							],
							[
								-82.82544181228724,
								27.97237918492154
							],
							[
								-82.82507011439877,
								27.97238691549381
							],
							[
								-82.82469670959694,
								27.97239466854872
							],
							[
								-82.82432297294535,
								27.972396924048684
							],
							[
								-82.8243169852592,
								27.97239689347119
							],
							[
								-82.82416206714707,
								27.972394383463342
							],
							[
								-82.8241407433224,
								27.97239319186186
							],
							[
								-82.82384651393266,
								27.972365043082906
							],
							[
								-82.82382565146031,
								27.972362221908856
							],
							[
								-82.8235353125377,
								27.97231135805386
							],
							[
								-82.82351455528605,
								27.972306873135114
							],
							[
								-82.82333981251904,
								27.972261852175354
							],
							[
								-82.82323025351228,
								27.9722336287514
							],
							[
								-82.82321103140313,
								27.972227907265182
							],
							[
								-82.82296408386907,
								27.97214429369827
							],
							[
								-82.82295449709618,
								27.972140844799146
							],
							[
								-82.82264909093236,
								27.972024407777344
							],
							[
								-82.82258665819853,
								27.972018484842312
							],
							[
								-82.82254889386785,
								27.972012173399566
							],
							[
								-82.82242785231738,
								27.97198298590359
							],
							[
								-82.82239051966121,
								27.971971056396963
							],
							[
								-82.82234919941124,
								27.971954455811346
							],
							[
								-82.8223105429531,
								27.97193520132676
							],
							[
								-82.82220657682984,
								27.971872561749326
							],
							[
								-82.82217238730459,
								27.971848144256587
							],
							[
								-82.8221615342861,
								27.971838528704854
							],
							[
								-82.82210381310023,
								27.97178455229609
							],
							[
								-82.82208141278724,
								27.971760913616453
							],
							[
								-82.82207157060702,
								27.97174845890648
							],
							[
								-82.82202525822046,
								27.97168616286935
							],
							[
								-82.82200812523637,
								27.971660094221665
							],
							[
								-82.82199782170386,
								27.971640421551417
							],
							[
								-82.82196284527161,
								27.971566367778525
							],
							[
								-82.82195327288784,
								27.971543418879566
							],
							[
								-82.82194207542915,
								27.971503217386232
							],
							[
								-82.82192003934152,
								27.971391060237597
							],
							[
								-82.82191545279936,
								27.97134159842553
							],
							[
								-82.8219157954411,
								27.971328009669453
							],
							[
								-82.82191954111713,
								27.971253725669346
							],
							[
								-82.82192329758524,
								27.971220464244443
							],
							[
								-82.82193084019916,
								27.9711889178267
							],
							[
								-82.82196347389774,
								27.97108145513871
							],
							[
								-82.82196810360743,
								27.97106757590281
							],
							[
								-82.8219844613759,
								27.971031237896074
							],
							[
								-82.82200279225671,
								27.970997435078818
							],
							[
								-82.82200630950507,
								27.9709911506168
							],
							[
								-82.82203069462201,
								27.97095576049681
							],
							[
								-82.82210536533022,
								27.970864022454936
							],
							[
								-82.82213991458451,
								27.970829201604733
							],
							[
								-82.82214456497871,
								27.970825387580437
							],
							[
								-82.82220677468091,
								27.970775507584126
							],
							[
								-82.82224064854435,
								27.970752347342756
							],
							[
								-82.82224617577752,
								27.970749241983942
							],
							[
								-82.822317423666,
								27.97071030943467
							],
							[
								-82.82234566777367,
								27.970696939214182
							],
							[
								-82.8223836470422,
								27.97068158418991
							],
							[
								-82.82241625016383,
								27.970670760849107
							],
							[
								-82.82249663696273,
								27.97064965196167
							],
							[
								-82.82253688252295,
								27.970642291011774
							],
							[
								-82.82261987825501,
								27.970633544205118
							],
							[
								-82.82266093860108,
								27.970632361596262
							],
							[
								-82.8227446133212,
								27.970636330305357
							],
							[
								-82.82278700196552,
								27.970641728935522
							],
							[
								-82.82286859835277,
								27.970658774685223
							],
							[
								-82.82290013218051,
								27.970667385692956
							],
							[
								-82.82293895681174,
								27.970680561660647
							],
							[
								-82.8229567445021,
								27.970687306575673
							],
							[
								-82.82299466891192,
								27.970703238964592
							],
							[
								-82.8230261092102,
								27.9707189285369
							],
							[
								-82.82309612322886,
								27.970759765850875
							],
							[
								-82.82312384033366,
								27.97077831976306
							],
							[
								-82.82315558550202,
								27.970802539405177
							],
							[
								-82.82316677037016,
								27.970811921132924
							],
							[
								-82.82332325330265,
								27.970871438264414
							],
							[
								-82.82346310057613,
								27.970924721295734
							],
							[
								-82.82365121985877,
								27.97098791485634
							],
							[
								-82.82380824238452,
								27.97102746973731
							],
							[
								-82.82403787976811,
								27.971069078669434
							],
							[
								-82.8244290605691,
								27.971090062550555
							],
							[
								-82.82466251107826,
								27.971080514448335
							],
							[
								-82.82484865095306,
								27.971072877405696
							],
							[
								-82.82503378088933,
								27.971064883332378
							],
							[
								-82.82521989468393,
								27.97105756734705
							],
							[
								-82.82578425882753,
								27.971034420597466
							],
							[
								-82.825799686697,
								27.97103422994038
							],
							[
								-82.82616342648497,
								27.971040124996552
							],
							[
								-82.82617842897497,
								27.971040785998827
							],
							[
								-82.82691890735174,
								27.971094096909006
							],
							[
								-82.82692945010382,
								27.9710950645801
							],
							[
								-82.8270113243813,
								27.971104198993505
							],
							[
								-82.82701835078433,
								27.971105076731213
							],
							[
								-82.82748796056046,
								27.971169991594383
							],
							[
								-82.82755075032486,
								27.971178702427682
							],
							[
								-82.82757830105537,
								27.971067170307965
							],
							[
								-82.82755081417672,
								27.971073410703543
							],
							[
								-82.82752271126286,
								27.971075584364616
							],
							[
								-82.82749459216097,
								27.971073645427072
							],
							[
								-82.82726719768654,
								27.971053336936183
							],
							[
								-82.82708219185666,
								27.971036578070954
							],
							[
								-82.82689710688629,
								27.971020156450628
							],
							[
								-82.8267120363053,
								27.9710033876918
							],
							[
								-82.82643674663744,
								27.970978892857904
							],
							[
								-82.82618102082118,
								27.97096227518551
							],
							[
								-82.82592092699791,
								27.970969085750955
							],
							[
								-82.8256495574746,
								27.970976553721375
							],
							[
								-82.82546369009418,
								27.970981794970232
							],
							[
								-82.8250923519344,
								27.970991929429903
							],
							[
								-82.82490613921459,
								27.97099717967139
							],
							[
								-82.82471979789142,
								27.971001744629934
							],
							[
								-82.82453367600276,
								27.97100630329449
							],
							[
								-82.82432398198462,
								27.971011003150995
							],
							[
								-82.82431664081889,
								27.97101106790222
							],
							[
								-82.82418933009444,
								27.971010455463233
							],
							[
								-82.8241584599662,
								27.971008534512368
							],
							[
								-82.82395938064597,
								27.97098462783449
							],
							[
								-82.82392951596006,
								27.97097932453251
							],
							[
								-82.82381313469631,
								27.970951829559812
							],
							[
								-82.82379530923441,
								27.97094696782462
							],
							[
								-82.82359938653438,
								27.970886256393005
							],
							[
								-82.82357942068595,
								27.970879199413293
							],
							[
								-82.8233820410844,
								27.97080059147358
							],
							[
								-82.82318482425984,
								27.970721931372925
							],
							[
								-82.82301563660528,
								27.970654249296803
							],
							[
								-82.8228459974907,
								27.97058684600923
							],
							[
								-82.82267644021475,
								27.970519015544784
							],
							[
								-82.8225077885558,
								27.97045167970761
							],
							[
								-82.82234024486178,
								27.970386261224537
							],
							[
								-82.82217055448606,
								27.97032228525406
							],
							[
								-82.82205846029045,
								27.970280313893984
							],
							[
								-82.82183767133613,
								27.970209424835804
							],
							[
								-82.82165380764519,
								27.970153956451608
							],
							[
								-82.82158081237421,
								27.970138944967818
							],
							[
								-82.82151801991151,
								27.970131362784226
							],
							[
								-82.82121692509746,
								27.970148574008494
							],
							[
								-82.82119592053208,
								27.970152541818397
							],
							[
								-82.82112113111333,
								27.970173004991597
							],
							[
								-82.82102404750196,
								27.970204400323798
							],
							[
								-82.82079645877383,
								27.97027790011459
							],
							[
								-82.82071493882898,
								27.970304389644088
							],
							[
								-82.82060251997822,
								27.970349634535655
							],
							[
								-82.82055199786515,
								27.97037701259654
							],
							[
								-82.82052429694804,
								27.970394889319397
							],
							[
								-82.82049883714143,
								27.970424590329404
							],
							[
								-82.8204700633331,
								27.970453429788048
							],
							[
								-82.8204372767497,
								27.9704776089596
							],
							[
								-82.82040122203033,
								27.97049657566159
							],
							[
								-82.82038597852208,
								27.970503177584153
							],
							[
								-82.82034448650143,
								27.970538644147172
							],
							[
								-82.82030808374437,
								27.970564854887773
							],
							[
								-82.82027107664287,
								27.970587078933665
							],
							[
								-82.82024356008674,
								27.970601516650465
							],
							[
								-82.82016362654605,
								27.970637748536223
							],
							[
								-82.82012906200328,
								27.970650645712528
							],
							[
								-82.82009306124311,
								27.97065870813437
							],
							[
								-82.81996048049159,
								27.970679000437674
							],
							[
								-82.819861790691,
								27.970697346607057
							],
							[
								-82.81982182122255,
								27.970701547339974
							],
							[
								-82.81978167278918,
								27.970699762185195
							],
							[
								-82.8197422339209,
								27.97069203161381
							],
							[
								-82.81965061818715,
								27.970666863186825
							],
							[
								-82.81962378151853,
								27.9706579545029
							],
							[
								-82.81949828112924,
								27.97060885062105
							],
							[
								-82.81945694019493,
								27.970588445004655
							],
							[
								-82.81941867044543,
								27.970565293757335
							],
							[
								-82.81939271511226,
								27.970547444012897
							],
							[
								-82.81932381805149,
								27.970493876795747
							],
							[
								-82.81929717833438,
								27.970470180560195
							],
							[
								-82.81926688736972,
								27.97043941835053
							],
							[
								-82.81924945401221,
								27.970419905760938
							],
							[
								-82.81922257957193,
								27.9703867171807
							],
							[
								-82.81920299053967,
								27.970359159255867
							],
							[
								-82.81915879066035,
								27.970287911366505
							],
							[
								-82.81915440286826,
								27.97028058189223
							],
							[
								-82.81913559714525,
								27.970240847147316
							],
							[
								-82.81910650317836,
								27.97016366373352
							],
							[
								-82.8190956447641,
								27.97012728345944
							],
							[
								-82.81908667672492,
								27.970087111644055
							],
							[
								-82.81908218641013,
								27.97006104839223
							],
							[
								-82.81907723294431,
								27.970020507854368
							],
							[
								-82.8190752418452,
								27.96998778872048
							],
							[
								-82.81907738582912,
								27.96995384291076
							],
							[
								-82.81909785170035,
								27.969792476660263
							],
							[
								-82.81910332677319,
								27.969762761261414
							],
							[
								-82.81911208886753,
								27.969733844460904
							],
							[
								-82.81912403006532,
								27.969706088685445
							],
							[
								-82.81917953442245,
								27.96959470855082
							],
							[
								-82.81918735762461,
								27.96958014493011
							],
							[
								-82.81921274098892,
								27.969543536227906
							],
							[
								-82.81926708342205,
								27.969477544876856
							],
							[
								-82.81929281752178,
								27.9694503772583
							],
							[
								-82.81932483248669,
								27.96942096313241
							],
							[
								-82.81935146590865,
								27.96939944505336
							],
							[
								-82.8194229638086,
								27.96934882311685
							],
							[
								-82.81946153662972,
								27.969326066671233
							],
							[
								-82.81957974531593,
								27.969268979507792
							],
							[
								-82.81958622493117,
								27.969265955987513
							],
							[
								-82.81967372266939,
								27.969226524313587
							],
							[
								-82.81984361719121,
								27.969150195254958
							],
							[
								-82.82009541926561,
								27.96904068840941
							],
							[
								-82.8202147898758,
								27.968989007969927
							],
							[
								-82.8202283318668,
								27.968983575164792
							],
							[
								-82.82036322567465,
								27.968933649302944
							],
							[
								-82.82060035261213,
								27.968845638052034
							],
							[
								-82.82063494143664,
								27.968835374088844
							],
							[
								-82.82070548965271,
								27.968819482169597
							],
							[
								-82.82071756215144,
								27.968817050402453
							],
							[
								-82.82102676615233,
								27.968762087437785
							],
							[
								-82.82105490413991,
								27.968758598968005
							],
							[
								-82.8212640693568,
								27.968743770046803
							],
							[
								-82.82128618728278,
								27.96874311174317
							],
							[
								-82.8214856802911,
								27.968745358249084
							],
							[
								-82.82150639977155,
								27.968746389772395
							],
							[
								-82.82169583656109,
								27.968763136946354
							],
							[
								-82.82171515309898,
								27.968765548928616
							],
							[
								-82.82192015625343,
								27.968798705132617
							],
							[
								-82.8219424171716,
								27.968803275487023
							],
							[
								-82.82203530904333,
								27.96882646090861
							],
							[
								-82.82213470211406,
								27.968851327163083
							],
							[
								-82.82215537123221,
								27.968857384096527
							],
							[
								-82.8223438574385,
								27.968920894218133
							],
							[
								-82.8223673774074,
								27.96893006550444
							],
							[
								-82.82262663486141,
								27.969045409850253
							],
							[
								-82.8226345228149,
								27.969049071889632
							],
							[
								-82.82279869405124,
								27.969128545876135
							],
							[
								-82.82296071770679,
								27.969206995535348
							],
							[
								-82.82312483768192,
								27.969286443441735
							],
							[
								-82.82336983548582,
								27.969404962394965
							],
							[
								-82.82347157398833,
								27.969454204772607
							],
							[
								-82.82359656805907,
								27.969505148667754
							],
							[
								-82.82382647793723,
								27.96957713759724
							],
							[
								-82.82416913312021,
								27.969644385300644
							],
							[
								-82.82423646985737,
								27.969646317044653
							],
							[
								-82.82429418115053,
								27.969643905063283
							],
							[
								-82.8243423173621,
								27.96964189237993
							],
							[
								-82.82451001394094,
								27.969635049439315
							],
							[
								-82.824695234709,
								27.96962707425134
							],
							[
								-82.82497412346322,
								27.969615070100776
							],
							[
								-82.82516044590061,
								27.969607746921913
							],
							[
								-82.82534626022115,
								27.9696004435274
							],
							[
								-82.8259028389337,
								27.96957854683423
							],
							[
								-82.8260884104372,
								27.969570908893107
							],
							[
								-82.82609561130874,
								27.969570708344197
							],
							[
								-82.82630060457085,
								27.969567754070926
							],
							[
								-82.82637545963982,
								27.96956729901378
							],
							[
								-82.82639828623164,
								27.969568129088277
							],
							[
								-82.82656441529201,
								27.969581226813848
							],
							[
								-82.82657284913408,
								27.969582025412727
							],
							[
								-82.82668790659578,
								27.969594742725082
							],
							[
								-82.82669750955651,
								27.969595978393894
							],
							[
								-82.82692658036729,
								27.96962965620448
							],
							[
								-82.82720189971256,
								27.969669934140843
							],
							[
								-82.82740631306388,
								27.96969987172019
							],
							[
								-82.8275939999999,
								27.969108000000023
							],
							[
								-82.8276011574866,
								27.969074256537777
							],
							[
								-82.82737384738661,
								27.96892997826969
							],
							[
								-82.82722008850054,
								27.968848811759376
							],
							[
								-82.82705987877772,
								27.968766900608802
							],
							[
								-82.82691228654294,
								27.968696107778005
							],
							[
								-82.82676548571145,
								27.9686370681863
							],
							[
								-82.8266083903406,
								27.968581223884673
							],
							[
								-82.82644686401035,
								27.968533646153052
							],
							[
								-82.8262657567415,
								27.96848814045855
							],
							[
								-82.82590266176742,
								27.968414584010155
							],
							[
								-82.82589689801262,
								27.968413351039448
							],
							[
								-82.82533832550267,
								27.9682874315662
							],
							[
								-82.82532949505963,
								27.968285284884434
							],
							[
								-82.8251448543545,
								27.96823707133111
							],
							[
								-82.82509150657187,
								27.96822288542497
							],
							[
								-82.82468702749586,
								27.96811228860118
							],
							[
								-82.8246803464326,
								27.968110369447988
							],
							[
								-82.82422232621956,
								27.96797234240184
							],
							[
								-82.82403765583693,
								27.96791418504451
							],
							[
								-82.82370639056722,
								27.967802739259998
							],
							[
								-82.82369967892708,
								27.967800381238664
							],
							[
								-82.82354228766592,
								27.96774275454396
							],
							[
								-82.82324799999985,
								27.967679000000448
							],
							[
								-82.82272199999976,
								27.967637000000348
							],
							[
								-82.82239599999978,
								27.967651000000263
							],
							[
								-82.82201499999962,
								27.96770600000055
							],
							[
								-82.82014199999972,
								27.967917000000245
							],
							[
								-82.81940214270536,
								27.96792509565648
							],
							[
								-82.81890876474705,
								27.968011060013357
							],
							[
								-82.8189027680679,
								27.96801203577896
							],
							[
								-82.8187725147618,
								27.968031719239512
							],
							[
								-82.81873220085305,
								27.968034748156715
							],
							[
								-82.81871277999392,
								27.96803404848386
							],
							[
								-82.81853673500866,
								27.968021343760903
							],
							[
								-82.8185093056869,
								27.968017944324078
							],
							[
								-82.81847509277894,
								27.968009577930633
							],
							[
								-82.8183915439638,
								27.967983258373255
							],
							[
								-82.81835112753224,
								27.967966828658422
							],
							[
								-82.81827431014256,
								27.967928091261133
							],
							[
								-82.81826089045931,
								27.96792084182666
							],
							[
								-82.81822703278345,
								27.967897694176994
							],
							[
								-82.81812827013748,
								27.96781851876428
							],
							[
								-82.81812360355569,
								27.967814691249618
							],
							[
								-82.81809149506108,
								27.967782793197063
							],
							[
								-82.81805804208015,
								27.967743454153396
							],
							[
								-82.81804911990649,
								27.96773238349967
							],
							[
								-82.81799240775996,
								27.96765806262808
							],
							[
								-82.81795572531381,
								27.96760837508511
							],
							[
								-82.81794819439116,
								27.967597630885447
							],
							[
								-82.81792063017093,
								27.967556194622848
							],
							[
								-82.81790758550507,
								27.96753443192951
							],
							[
								-82.817884021469,
								27.96749056569833
							],
							[
								-82.81787434836126,
								27.96747063582298
							],
							[
								-82.81786075510887,
								27.967439429348776
							],
							[
								-82.81785783860742,
								27.96743246949546
							],
							[
								-82.81783695365198,
								27.967380607392403
							],
							[
								-82.81781932244348,
								27.967339697233587
							],
							[
								-82.81781092457442,
								27.96731759369681
							],
							[
								-82.81779447687387,
								27.967267839604762
							],
							[
								-82.8177874855445,
								27.967242655889738
							],
							[
								-82.81777591936395,
								27.967191497956208
							],
							[
								-82.81777048206276,
								27.96715746041595
							],
							[
								-82.81775970188966,
								27.967043724057664
							],
							[
								-82.81775862090466,
								27.967010111897498
							],
							[
								-82.81776086741102,
								27.96693583689144
							],
							[
								-82.81776166690838,
								27.966921697750383
							],
							[
								-82.81776565989804,
								27.966873540854312
							],
							[
								-82.81776865374108,
								27.966850028080007
							],
							[
								-82.81777695538277,
								27.9668018460023
							],
							[
								-82.81778322545594,
								27.96677421433255
							],
							[
								-82.81779647426822,
								27.96672737854148
							],
							[
								-82.8178051248467,
								27.966701772144482
							],
							[
								-82.81782307801231,
								27.966656282638628
							],
							[
								-82.81783253078616,
								27.96663505683991
							],
							[
								-82.81785451201527,
								27.966590919013715
							],
							[
								-82.81786407904004,
								27.96657379232698
							],
							[
								-82.81786699999978,
								27.966516000000144
							],
							[
								-82.81797799999973,
								27.966269000000313
							],
							[
								-82.81872199999974,
								27.965551999999963
							],
							[
								-82.81910299999973,
								27.965262000000127
							],
							[
								-82.8194149999997,
								27.965089000000557
							],
							[
								-82.8198904827002,
								27.96491798589528
							],
							[
								-82.81989514384678,
								27.964912945984924
							],
							[
								-82.81992896824767,
								27.964879739418183
							],
							[
								-82.81996185735386,
								27.964852224661133
							],
							[
								-82.81999868818797,
								27.964830265914845
							],
							[
								-82.82002154355801,
								27.96480521440056
							],
							[
								-82.82003887259417,
								27.96478336447247
							],
							[
								-82.82005547497826,
								27.96475692530375
							],
							[
								-82.82006282243921,
								27.964745842059205
							],
							[
								-82.82009346863599,
								27.964701996513345
							],
							[
								-82.8201182215756,
								27.964671559858193
							],
							[
								-82.8201471275842,
								27.9646450352547
							],
							[
								-82.820179575123,
								27.964622982978785
							],
							[
								-82.82020902162432,
								27.964605959712078
							],
							[
								-82.8202365192946,
								27.964590063296516
							],
							[
								-82.82027159375313,
								27.964568999375068
							],
							[
								-82.82029949611835,
								27.9645543871916
							],
							[
								-82.8203433002958,
								27.96453461289811
							],
							[
								-82.82038052413394,
								27.964515728035014
							],
							[
								-82.82040877453684,
								27.964499364871035
							],
							[
								-82.82045338720472,
								27.964469017249197
							],
							[
								-82.82048415301125,
								27.964440560001794
							],
							[
								-82.82051208055756,
								27.96441798522064
							],
							[
								-82.82054275823077,
								27.964399318892067
							],
							[
								-82.82057564373939,
								27.964384892867958
							],
							[
								-82.82058441932384,
								27.96438174164361
							],
							[
								-82.82061787770044,
								27.964358314304963
							],
							[
								-82.820655273309,
								27.96434040250741
							],
							[
								-82.82068410557349,
								27.964329227531795
							],
							[
								-82.82070845651582,
								27.964316425683325
							],
							[
								-82.82075353773058,
								27.964292914706693
							],
							[
								-82.820784504086,
								27.964272057630804
							],
							[
								-82.82080027999308,
								27.964263633681092
							],
							[
								-82.82081003943584,
								27.96425881061754
							],
							[
								-82.82084001114106,
								27.96423872066295
							],
							[
								-82.82085791754194,
								27.96422925979495
							],
							[
								-82.82086490437484,
								27.964225292884596
							],
							[
								-82.82090711405424,
								27.964195743860746
							],
							[
								-82.82096500701044,
								27.964163824224745
							],
							[
								-82.82097430689974,
								27.964158934610698
							],
							[
								-82.82100208246044,
								27.964145016702805
							],
							[
								-82.82102778328556,
								27.964133768882352
							],
							[
								-82.82105682509176,
								27.964122821435314
							],
							[
								-82.82108605485641,
								27.964109626582815
							],
							[
								-82.82110189911174,
								27.96410307142391
							],
							[
								-82.82114041167857,
								27.96408856356091
							],
							[
								-82.8211872816447,
								27.964075856140727
							],
							[
								-82.8212052599915,
								27.96407330656276
							],
							[
								-82.8212429964429,
								27.964069245224113
							],
							[
								-82.8213166635076,
								27.964055928963663
							],
							[
								-82.82136408565782,
								27.96405172822968
							],
							[
								-82.82138534023449,
								27.964052564599587
							],
							[
								-82.8214062197939,
								27.964043759338
							],
							[
								-82.82149734629661,
								27.96400401379994
							],
							[
								-82.82152070978366,
								27.963995090727526
							],
							[
								-82.82155469965981,
								27.963983886073965
							],
							[
								-82.8215878037036,
								27.963975257079557
							],
							[
								-82.82162173422438,
								27.96397088637487
							],
							[
								-82.82165594443461,
								27.963970844106104
							],
							[
								-82.82173652368827,
								27.963975864121796
							],
							[
								-82.82176114262876,
								27.963978536906456
							],
							[
								-82.82179525841008,
								27.963983833913026
							],
							[
								-82.82181575126104,
								27.963987833198548
							],
							[
								-82.8219077626964,
								27.964009516751634
							],
							[
								-82.82194333627871,
								27.96400810211789
							],
							[
								-82.82197876956683,
								27.964011568105565
							],
							[
								-82.82201339436408,
								27.964019850861025
							],
							[
								-82.82204656046115,
								27.964032793904284
							],
							[
								-82.82207764282911,
								27.964050153517764
							],
							[
								-82.82209566344407,
								27.964061706207946
							],
							[
								-82.82219010304901,
								27.96408586829326
							],
							[
								-82.82220233202996,
								27.964089305501997
							],
							[
								-82.82225511593786,
								27.96410549239933
							],
							[
								-82.82227751984823,
								27.964113459493337
							],
							[
								-82.82243939331691,
								27.964179190041097
							],
							[
								-82.82245260076023,
								27.96418496908412
							],
							[
								-82.82258846583576,
								27.964248793069505
							],
							[
								-82.82262250427522,
								27.964267902762533
							],
							[
								-82.8226759770639,
								27.96430324162255
							],
							[
								-82.82269094897694,
								27.964311426351532
							],
							[
								-82.82272960273723,
								27.96433710469383
							],
							[
								-82.82275740437831,
								27.964359243304063
							],
							[
								-82.82282847869772,
								27.964409035167495
							],
							[
								-82.82285145547614,
								27.96442706117858
							],
							[
								-82.8229161715887,
								27.96448375353943
							],
							[
								-82.8230198445329,
								27.964553025618347
							],
							[
								-82.82303406910944,
								27.96456321223896
							],
							[
								-82.82308087161033,
								27.964599080838788
							],
							[
								-82.82318199999972,
								27.96463900000045
							],
							[
								-82.8232859999998,
								27.964667000000457
							],
							[
								-82.82340399999997,
								27.964687000000158
							],
							[
								-82.82387499999986,
								27.96473600000048
							],
							[
								-82.82406899999965,
								27.964833000000514
							],
							[
								-82.8248239999997,
								27.965302999999967
							],
							[
								-82.82517954117885,
								27.965481983956867
							],
							[
								-82.82520793729826,
								27.965488804363154
							],
							[
								-82.82523762661675,
								27.96549776880585
							],
							[
								-82.82536995196057,
								27.965546182007834
							],
							[
								-82.82539234417976,
								27.965550019415733
							],
							[
								-82.8254133505437,
								27.965554486348157
							],
							[
								-82.82551887968859,
								27.965581357190953
							],
							[
								-82.82553362047594,
								27.965585559722076
							],
							[
								-82.82559086861833,
								27.965603655879892
							],
							[
								-82.82566332609507,
								27.96561987065697
							],
							[
								-82.82569668194905,
								27.965629629199743
							],
							[
								-82.82570953416018,
								27.9656346833897
							],
							[
								-82.82581209104573,
								27.965678075677506
							],
							[
								-82.82582597927586,
								27.965684420394968
							],
							[
								-82.82586610072957,
								27.96570414162797
							],
							[
								-82.82589030418339,
								27.96571373469529
							],
							[
								-82.82590084064026,
								27.96571817195083
							],
							[
								-82.82604071669206,
								27.96578059299374
							],
							[
								-82.82607106071652,
								27.965796518187705
							],
							[
								-82.82611376682183,
								27.96582251578929
							],
							[
								-82.82618701660122,
								27.96584497635674
							],
							[
								-82.82621584526815,
								27.965855648610574
							],
							[
								-82.82623671763314,
								27.965864757843764
							],
							[
								-82.8262436586005,
								27.96586265792708
							],
							[
								-82.82628650320116,
								27.965853410198807
							],
							[
								-82.82633027860047,
								27.965851224845398
							],
							[
								-82.82637383096761,
								27.96585615762776
							],
							[
								-82.82641600917076,
								27.96586807993943
							],
							[
								-82.82643564676657,
								27.96587555060707
							],
							[
								-82.82644812306124,
								27.96587695175187
							],
							[
								-82.82646487293401,
								27.96587936643046
							],
							[
								-82.82651258016898,
								27.965892391312256
							],
							[
								-82.82662049611449,
								27.965933867144447
							],
							[
								-82.82663849244771,
								27.96594154825353
							],
							[
								-82.82671932531034,
								27.965979568890837
							],
							[
								-82.82674582293434,
								27.965993890594483
							],
							[
								-82.82686098022099,
								27.96606470950646
							],
							[
								-82.82686936190247,
								27.96607007935787
							],
							[
								-82.82693474890912,
								27.966113693778386
							],
							[
								-82.82695354024304,
								27.9661274354191
							],
							[
								-82.82702522610117,
								27.96618476360148
							],
							[
								-82.82704823795324,
								27.96620533289566
							],
							[
								-82.8270688872866,
								27.966228272801988
							],
							[
								-82.82711310065531,
								27.966249102898036
							],
							[
								-82.82714670472238,
								27.966272047300684
							],
							[
								-82.82718861133026,
								27.966305559636698
							],
							[
								-82.82721842385541,
								27.96631794510002
							],
							[
								-82.82727723322097,
								27.96634224747915
							],
							[
								-82.82728774899348,
								27.966346857403682
							],
							[
								-82.82738723199638,
								27.96639301600631
							],
							[
								-82.8274041302573,
								27.966401590142556
							],
							[
								-82.82744927442457,
								27.96642652744278
							],
							[
								-82.82748111132373,
								27.966439486673625
							],
							[
								-82.82749162889489,
								27.966444030048724
							],
							[
								-82.82754625281575,
								27.966469017710796
							],
							[
								-82.82758248739934,
								27.966481924780698
							],
							[
								-82.82763492686705,
								27.966491295716725
							],
							[
								-82.82767618326498,
								27.966502092077864
							],
							[
								-82.82773830483367,
								27.96652372167127
							],
							[
								-82.82777491623345,
								27.966539594705715
							],
							[
								-82.8278163776768,
								27.966561343910104
							],
							[
								-82.82785148900744,
								27.96657785815963
							],
							[
								-82.8278715573785,
								27.96658834695275
							],
							[
								-82.82790125838788,
								27.966608581697834
							],
							[
								-82.82813936378754,
								27.966621794538074
							],
							[
								-82.82817237700017,
								27.9666256778108
							],
							[
								-82.82820466176177,
								27.96663359094477
							],
							[
								-82.82823572884108,
								27.966645414331843
							],
							[
								-82.82881703441312,
								27.966908707043917
							],
							[
								-82.82885738969064,
								27.96693134117955
							],
							[
								-82.82962343938969,
								27.967452059426382
							],
							[
								-82.82965753178846,
								27.9674794662662
							],
							[
								-82.82968672468093,
								27.967512043307178
							],
							[
								-82.82971024375064,
								27.9675489254026
							],
							[
								-82.82972746396887,
								27.96758913588945
							],
							[
								-82.82973793027855,
								27.967631609070335
							],
							[
								-82.82974136389008,
								27.967675217195445
							],
							[
								-82.82973767487113,
								27.967718803736222
							],
							[
								-82.82972696034852,
								27.967761214863987
							],
							[
								-82.82970950540721,
								27.96780132372813
							],
							[
								-82.8298391804493,
								27.96788938713945
							],
							[
								-82.82985210460605,
								27.967898733793565
							],
							[
								-82.83004501637599,
								27.968047125525533
							],
							[
								-82.83006432392062,
								27.968063474301022
							],
							[
								-82.83011328312948,
								27.968109038579772
							],
							[
								-82.8302100410691,
								27.968199085767612
							],
							[
								-82.83021944078291,
								27.96820827144241
							],
							[
								-82.83034370280562,
								27.968335761132327
							],
							[
								-82.83036219826243,
								27.968356821455412
							],
							[
								-82.83047168352516,
								27.968495402483843
							],
							[
								-82.83048540627982,
								27.968514415049942
							],
							[
								-82.83054942092132,
								27.96861175946585
							],
							[
								-82.83055798516494,
								27.968625683668794
							],
							[
								-82.83058689746888,
								27.968676051097777
							],
							[
								-82.83068895972734,
								27.9688300671901
							],
							[
								-82.83069473607252,
								27.968839175523744
							],
							[
								-82.83076804970386,
								27.968960038109287
							],
							[
								-82.83083847830993,
								27.969076792592166
							],
							[
								-82.83085617157154,
								27.9691115918575
							],
							[
								-82.8309088727418,
								27.969236953750812
							],
							[
								-82.83093974736636,
								27.969290740403455
							],
							[
								-82.83095928783524,
								27.969332780110637
							],
							[
								-82.8309616476563,
								27.969339542112795
							],
							[
								-82.83101045296382,
								27.969485583017498
							],
							[
								-82.83101434882666,
								27.969498271551988
							],
							[
								-82.83103599730654,
								27.969575497233127
							],
							[
								-82.83104102002,
								27.96959666097873
							],
							[
								-82.83107230653408,
								27.96975702898205
							],
							[
								-82.83107492535986,
								27.969772979357646
							],
							[
								-82.83108767864557,
								27.96986862135721
							],
							[
								-82.83110417041291,
								27.970009622460626
							],
							[
								-82.83110599333872,
								27.970040929658886
							],
							[
								-82.83110370556484,
								27.97007496169634
							],
							[
								-82.83166699999975,
								27.970610000000487
							],
							[
								-82.83167399999971,
								27.970782000000508
							],
							[
								-82.83161999999969,
								27.971020000000482
							],
							[
								-82.8313849999996,
								27.971358000000027
							],
							[
								-82.83124999999971,
								27.972129000000404
							],
							[
								-82.83098199999965,
								27.974240000000453
							],
							[
								-82.83020299999986,
								27.976048000000123
							],
							[
								-82.83014271982647,
								27.97643312181776
							],
							[
								-82.83014241941913,
								27.976441359555185
							],
							[
								-82.8301411925717,
								27.976478254261853
							],
							[
								-82.83010601289254,
								27.97678342120601
							],
							[
								-82.83009982915448,
								27.976817573858984
							],
							[
								-82.83008931068395,
								27.97685065002408
							],
							[
								-82.830073442416,
								27.976883823702106
							],
							[
								-82.83003071199875,
								27.977176467234802
							],
							[
								-82.83002963257313,
								27.977201442272662
							],
							[
								-82.83002647505356,
								27.977231716149582
							],
							[
								-82.83002355495499,
								27.97725212626371
							],
							[
								-82.83000898797022,
								27.97733056283686
							],
							[
								-82.83000754998085,
								27.9773368640199
							],
							[
								-82.82999799999986,
								27.977403000000503
							],
							[
								-82.8299189999999,
								27.978440000000507
							],
							[
								-82.82987299999974,
								27.97869000000041
							],
							[
								-82.82929799999958,
								27.981864000000307
							],
							[
								-82.82923099999982,
								27.98241200000035
							],
							[
								-82.82913199999989,
								27.983235000000057
							],
							[
								-82.82906599999967,
								27.98378200000055
							],
							[
								-82.82889899999996,
								27.985157000000452
							],
							[
								-82.82881899999985,
								27.98583000000036
							],
							[
								-82.82877999999981,
								27.986354000000194
							],
							[
								-82.82874099999968,
								27.986878000000566
							],
							[
								-82.82869799999968,
								27.987461000000128
							],
							[
								-82.82865199999996,
								27.988087000000586
							],
							[
								-82.8286059999998,
								27.988714000000595
							],
							[
								-82.82857099999966,
								27.989185000000486
							],
							[
								-82.82853599999987,
								27.98967000000029
							],
							[
								-82.82853099999971,
								27.99207899999995
							],
							[
								-82.82852899999982,
								27.99345700000028
							],
							[
								-82.82852599999966,
								27.995023000000536
							],
							[
								-82.82852399999976,
								27.995991000000334
							],
							[
								-82.82852199999995,
								27.99732400000032
							],
							[
								-82.82856299999979,
								28.0011370000005
							],
							[
								-82.82862599999986,
								28.00493600000006
							],
							[
								-82.82869799999968,
								28.006843000000284
							],
							[
								-82.82873299999983,
								28.008559000000513
							],
							[
								-82.82870499999973,
								28.010649000000246
							],
							[
								-82.82869399999997,
								28.010786000000568
							],
							[
								-82.82847746323847,
								28.013302374331342
							],
							[
								-82.8285063402357,
								28.013407919643743
							],
							[
								-82.82867407278738,
								28.013892318770065
							],
							[
								-82.82868917600143,
								28.013936003338205
							],
							[
								-82.82869712510922,
								28.01396370425568
							],
							[
								-82.82878593675667,
								28.014349946878628
							],
							[
								-82.82878934878448,
								28.014367400920396
							],
							[
								-82.8288129155182,
								28.014513361785834
							],
							[
								-82.82891607225149,
								28.01502523340186
							],
							[
								-82.82900447470769,
								28.015309915589018
							],
							[
								-82.82901106853681,
								28.015335517488285
							],
							[
								-82.82906352689031,
								28.01559030261355
							],
							[
								-82.82906794166205,
								28.015620055783433
							],
							[
								-82.82909417519313,
								28.015905924090948
							],
							[
								-82.82893399999993,
								28.015903000000115
							],
							[
								-82.82838736940057,
								28.017585425014882
							],
							[
								-82.82833379990853,
								28.017614753843493
							],
							[
								-82.82827880636637,
								28.0176448631445
							],
							[
								-82.82824151777709,
								28.01766173892243
							],
							[
								-82.82823021689632,
								28.017665570933406
							],
							[
								-82.82815945307583,
								28.017687836382446
							],
							[
								-82.82801599999974,
								28.018680000000376
							],
							[
								-82.82799131870513,
								28.01880439372574
							],
							[
								-82.82789299999986,
								28.01910700000018
							],
							[
								-82.82665923402301,
								28.01891380285177
							],
							[
								-82.8263024590077,
								28.018857934950532
							],
							[
								-82.82514699999986,
								28.018677000000128
							],
							[
								-82.82513438516482,
								28.018559346703423
							],
							[
								-82.82513799999991,
								28.018429000000218
							],
							[
								-82.82509466514483,
								28.01818889466904
							],
							[
								-82.82501190385929,
								28.017417014729876
							],
							[
								-82.82505466245406,
								28.017362070594235
							],
							[
								-82.82503602559723,
								28.017346432123098
							],
							[
								-82.82500848386007,
								28.017314848832445
							],
							[
								-82.82499940221014,
								28.017300417070174
							],
							[
								-82.82496018569468,
								28.016934661012197
							],
							[
								-82.8249616732491,
								28.016927111534887
							],
							[
								-82.8249735272127,
								28.016892537099483
							],
							[
								-82.82498995153087,
								28.016859884515917
							],
							[
								-82.82501070428621,
								28.01682548634769
							],
							[
								-82.82500072181163,
								28.0167864224958
							],
							[
								-82.82499728370334,
								28.016746248882388
							],
							[
								-82.8250004852898,
								28.016706056382038
							],
							[
								-82.82501374219595,
								28.016615557606276
							],
							[
								-82.82502201505923,
								28.01657799742198
							],
							[
								-82.82505917054885,
								28.01645262923326
							],
							[
								-82.82507270084885,
								28.0164166257742
							],
							[
								-82.82513243561674,
								28.01628665395636
							],
							[
								-82.8251450989703,
								28.01626241902621
							],
							[
								-82.82519223603514,
								28.01618237307021
							],
							[
								-82.82520182011,
								28.016167266259476
							],
							[
								-82.82523831100058,
								28.016113758396802
							],
							[
								-82.82526374652547,
								28.016081923296912
							],
							[
								-82.82529368585523,
								28.016054281734984
							],
							[
								-82.82532744640416,
								28.016031465035343
							],
							[
								-82.82536425835285,
								28.01601399210735
							],
							[
								-82.82545094760047,
								28.015980636253804
							],
							[
								-82.82547961010465,
								28.015973497071403
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Clearwater Beach Association",
				"RegionID": "343271"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.72158621599996,
					28.011005547000096,
					-82.7188761429999,
					28.01938443600006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.72104084999995,
							28.01100782900002
						],
						[
							-82.72108267399997,
							28.011005547000096
						],
						[
							-82.72131121699995,
							28.0110174120001
						],
						[
							-82.72135055399993,
							28.01101961300011
						],
						[
							-82.72158164899994,
							28.011051061000046
						],
						[
							-82.72158621599996,
							28.012099995000057
						],
						[
							-82.72137297099991,
							28.012102146000064
						],
						[
							-82.72138423299995,
							28.01262948800008
						],
						[
							-82.72138610999993,
							28.01314381500001
						],
						[
							-82.7213921169999,
							28.01478649700003
						],
						[
							-82.72139386299995,
							28.01519355600005
						],
						[
							-82.72139582599993,
							28.01548819
						],
						[
							-82.7213987609999,
							28.015928592000115
						],
						[
							-82.72140068299989,
							28.016217036000086
						],
						[
							-82.72140443699993,
							28.016780174000054
						],
						[
							-82.72140552499994,
							28.016943476000066
						],
						[
							-82.72140930199988,
							28.01764138600008
						],
						[
							-82.72141030799989,
							28.01785041600005
						],
						[
							-82.7214114309999,
							28.018062195000077
						],
						[
							-82.7214127069999,
							28.018297352999994
						],
						[
							-82.72141501199992,
							28.01868687500007
						],
						[
							-82.72141856699994,
							28.019365189000062
						],
						[
							-82.72043680399989,
							28.019374465000034
						],
						[
							-82.72012378499993,
							28.019377136000074
						],
						[
							-82.71990684499993,
							28.019379649000108
						],
						[
							-82.7189265089999,
							28.01938443600006
						],
						[
							-82.71890874299994,
							28.016009713000074
						],
						[
							-82.71890745899992,
							28.015772492000075
						],
						[
							-82.71890698599988,
							28.015701326000052
						],
						[
							-82.71890589899996,
							28.015537679000097
						],
						[
							-82.71889905399993,
							28.01529464300006
						],
						[
							-82.7188761429999,
							28.01273408100012
						],
						[
							-82.7188932239999,
							28.012550055000084
						],
						[
							-82.71889193599988,
							28.01180159200006
						],
						[
							-82.71894536799995,
							28.01176830700006
						],
						[
							-82.71904499499993,
							28.011705556000017
						],
						[
							-82.71918810399987,
							28.01159822700002
						],
						[
							-82.71922762199995,
							28.01156982800007
						],
						[
							-82.71933683299991,
							28.011491900000102
						],
						[
							-82.71943927199996,
							28.01142947800009
						],
						[
							-82.7195374659999,
							28.01136982900004
						],
						[
							-82.71967057699992,
							28.011303121000118
						],
						[
							-82.71974934399995,
							28.011263858000063
						],
						[
							-82.71991190499999,
							28.011198371000063
						],
						[
							-82.71997063099987,
							28.011174685000057
						],
						[
							-82.72020006899993,
							28.011103002000077
						],
						[
							-82.72041243399993,
							28.011055818999992
						],
						[
							-82.72048450299994,
							28.011043064000006
						],
						[
							-82.72069420499987,
							28.011018242000084
						],
						[
							-82.72081842499993,
							28.011012777000076
						],
						[
							-82.72090546799986,
							28.011009227000045
						],
						[
							-82.72104084999995,
							28.01100782900002
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Northwood West Homeowners Association",
				"RegionID": "343273"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.72901715799992,
					28.017274008000058,
					-82.72517250099995,
					28.01929103800006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.72522332599989,
							28.018800573000064
						],
						[
							-82.72528207599996,
							28.018692995000045
						],
						[
							-82.72536142299995,
							28.018595623000074
						],
						[
							-82.72545820299987,
							28.018512254000104
						],
						[
							-82.72551249299993,
							28.018476555000078
						],
						[
							-82.72563045999992,
							28.018418173000043
						],
						[
							-82.72569326399987,
							28.01839583800006
						],
						[
							-82.7257322119999,
							28.01838325500009
						],
						[
							-82.72681819499986,
							28.018102470000123
						],
						[
							-82.72797528799995,
							28.01779654600004
						],
						[
							-82.72817883699992,
							28.01773358200007
						],
						[
							-82.72837569699995,
							28.017654839000038
						],
						[
							-82.72856383499989,
							28.01756135700012
						],
						[
							-82.7287421899999,
							28.017453488000072
						],
						[
							-82.7287786389999,
							28.017429228000115
						],
						[
							-82.72900384299997,
							28.017274008000058
						],
						[
							-82.72901715799992,
							28.019250829000015
						],
						[
							-82.72774654499995,
							28.019269597000065
						],
						[
							-82.72774323199994,
							28.018776938000066
						],
						[
							-82.72717989999987,
							28.018783104000043
						],
						[
							-82.7267701069999,
							28.018787589000056
						],
						[
							-82.72677323799988,
							28.019253874000093
						],
						[
							-82.7267734149999,
							28.019280247000054
						],
						[
							-82.7252514079999,
							28.01929103800006
						],
						[
							-82.7251815529999,
							28.01922986600006
						],
						[
							-82.72517250099995,
							28.019035318000036
						],
						[
							-82.72517645799992,
							28.01897547500006
						],
						[
							-82.72518622999993,
							28.018916288000053
						],
						[
							-82.72522332599989,
							28.018800573000064
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Rustlewood Condominium Association, Inc",
				"RegionID": "343274"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.72456666799992,
					28.01440496000008,
					-82.72284807399991,
					28.015744099000038
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.72287868999987,
							28.015744099000038
						],
						[
							-82.72284807399991,
							28.014872364000027
						],
						[
							-82.72329154399993,
							28.0149140380001
						],
						[
							-82.72333805599996,
							28.014917575000126
						],
						[
							-82.72338454599989,
							28.01491767400005
						],
						[
							-82.72343100999993,
							28.014913992000096
						],
						[
							-82.72347715999992,
							28.01490687300013
						],
						[
							-82.7235220259999,
							28.01489597800012
						],
						[
							-82.72356590199989,
							28.01488165100009
						],
						[
							-82.72360830099994,
							28.01486423800007
						],
						[
							-82.72364874599991,
							28.014843740000064
						],
						[
							-82.72368664699994,
							28.014819818000035
						],
						[
							-82.72372249799989,
							28.014793156000046
						],
						[
							-82.72375850399993,
							28.014760649000024
						],
						[
							-82.72383535499998,
							28.01466638400004
						],
						[
							-82.72385123499997,
							28.014637077000103
						],
						[
							-82.72387003299993,
							28.014609473000036
						],
						[
							-82.7238911649999,
							28.01458323300009
						],
						[
							-82.7239149239999,
							28.014558697000012
						],
						[
							-82.72394111699994,
							28.014536212000017
						],
						[
							-82.72396916399995,
							28.0145157790001
						],
						[
							-82.72399945099997,
							28.01449739800009
						],
						[
							-82.72403121299993,
							28.01448175900004
						],
						[
							-82.7240695639999,
							28.014467117000073
						],
						[
							-82.72438216999993,
							28.01440496000008
						],
						[
							-82.72456666799992,
							28.015113606000092
						],
						[
							-82.72455122199999,
							28.015584017000023
						],
						[
							-82.72432642599993,
							28.015337660000075
						],
						[
							-82.72413117999994,
							28.01533868900007
						],
						[
							-82.7238332579999,
							28.015279748000076
						],
						[
							-82.72353547199995,
							28.01570488700008
						],
						[
							-82.72321585499988,
							28.015646059000098
						],
						[
							-82.72287868999987,
							28.015744099000038
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Winding Wood Condominium No.5 Association",
				"RegionID": "343289"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.72534588199993,
					28.013607944000036,
					-82.72284807399991,
					28.015641812000098
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.72456666799992,
							28.015113606000092
						],
						[
							-82.72438216999993,
							28.01440496000008
						],
						[
							-82.7240695639999,
							28.014467117000073
						],
						[
							-82.72403121299993,
							28.01448175900004
						],
						[
							-82.72399945099997,
							28.01449739800009
						],
						[
							-82.72396916399995,
							28.0145157790001
						],
						[
							-82.72394111699994,
							28.014536212000017
						],
						[
							-82.7239149239999,
							28.014558697000012
						],
						[
							-82.7238911649999,
							28.01458323300009
						],
						[
							-82.72387003299993,
							28.014609473000036
						],
						[
							-82.72385123499997,
							28.014637077000103
						],
						[
							-82.72383535499998,
							28.01466638400004
						],
						[
							-82.72375850399993,
							28.014760649000024
						],
						[
							-82.72372249799989,
							28.014793156000046
						],
						[
							-82.72368664699994,
							28.014819818000035
						],
						[
							-82.72364874599991,
							28.014843740000064
						],
						[
							-82.72360830099994,
							28.01486423800007
						],
						[
							-82.72356590199989,
							28.01488165100009
						],
						[
							-82.7235220259999,
							28.01489597800012
						],
						[
							-82.72347715999992,
							28.01490687300013
						],
						[
							-82.72343100999993,
							28.014913992000096
						],
						[
							-82.72338454599989,
							28.01491767400005
						],
						[
							-82.72333805599996,
							28.014917575000126
						],
						[
							-82.72329154399993,
							28.0149140380001
						],
						[
							-82.72284807399991,
							28.014872364000027
						],
						[
							-82.7228500999999,
							28.01479877800007
						],
						[
							-82.72286206899992,
							28.01469110300004
						],
						[
							-82.72288460099992,
							28.014584405000093
						],
						[
							-82.72291731399987,
							28.01447971500005
						],
						[
							-82.72296041399997,
							28.014378409000102
						],
						[
							-82.72301332099991,
							28.014280489000086
						],
						[
							-82.72307564799992,
							28.014186989000073
						],
						[
							-82.72314663099993,
							28.014098601000043
						],
						[
							-82.72322636999986,
							28.01401635500008
						],
						[
							-82.72331351299997,
							28.01394060300003
						],
						[
							-82.72340796599988,
							28.01387168800001
						],
						[
							-82.72350886499989,
							28.013810647000113
						],
						[
							-82.72361542999991,
							28.013757139000035
						],
						[
							-82.72368340599994,
							28.013726183000053
						],
						[
							-82.72379411699985,
							28.01368468700008
						],
						[
							-82.72390856699991,
							28.01365176600011
						],
						[
							-82.72402578899992,
							28.013627770000078
						],
						[
							-82.72414472399991,
							28.013613391000042
						],
						[
							-82.72426497399991,
							28.013607944000036
						],
						[
							-82.72438490199998,
							28.013611781000087
						],
						[
							-82.7245043109999,
							28.01362524800005
						],
						[
							-82.72462193799996,
							28.0136473190001
						],
						[
							-82.7253295449999,
							28.01379486300005
						],
						[
							-82.72525116099989,
							28.014122581000073
						],
						[
							-82.72527019799995,
							28.01418849200011
						],
						[
							-82.72525586299992,
							28.014361846000064
						],
						[
							-82.72534588199993,
							28.01484545200011
						],
						[
							-82.72528430499996,
							28.01490628700008
						],
						[
							-82.72532830099996,
							28.014996820000114
						],
						[
							-82.72506608599994,
							28.015641812000098
						],
						[
							-82.72455122199999,
							28.015584017000023
						],
						[
							-82.72456666799992,
							28.015113606000092
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Winding Wood VII",
				"RegionID": "343290"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.73253699999994,
					27.99730400000008,
					-82.72996026099769,
					27.999491030000026
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.73077999699987,
							27.999489030000394
						],
						[
							-82.73077825299973,
							27.999230496000497
						],
						[
							-82.72997319299974,
							27.99923683500022
						],
						[
							-82.72997230299984,
							27.999104818000223
						],
						[
							-82.72996841799987,
							27.99852827200048
						],
						[
							-82.72996438399989,
							27.997886403000397
						],
						[
							-82.72996026099769,
							27.99731671570395
						],
						[
							-82.73053291700047,
							27.99731239610043
						],
						[
							-82.73086251999888,
							27.997309909870896
						],
						[
							-82.73157151899858,
							27.99730456181805
						],
						[
							-82.73164599999986,
							27.99730400000008
						],
						[
							-82.73175113299673,
							27.99730518126974
						],
						[
							-82.73235799999988,
							27.997312000000214
						],
						[
							-82.73244299999989,
							27.99731300000012
						],
						[
							-82.73253699999994,
							27.998834000000024
						],
						[
							-82.73244699999988,
							27.998832000000032
						],
						[
							-82.73154299999995,
							27.99881100000007
						],
						[
							-82.73153299999991,
							27.998948000000038
						],
						[
							-82.73153099999983,
							27.999453000000077
						],
						[
							-82.7309219999999,
							27.999409000000167
						],
						[
							-82.7309219999999,
							27.999491030000026
						],
						[
							-82.73077999699987,
							27.999489030000394
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Hillcrest Villas Condominium Association",
				"RegionID": "343304"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.76298016699992,
					27.99728598600003,
					-82.75906951099991,
					27.999064085000064
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.7590715349999,
							27.99757477200003
						],
						[
							-82.75906951099991,
							27.99728598600003
						],
						[
							-82.75939179999993,
							27.99728902000001
						],
						[
							-82.75962485099986,
							27.99729151400004
						],
						[
							-82.75985790199987,
							27.997294009000075
						],
						[
							-82.76009090399995,
							27.997296159000072
						],
						[
							-82.76032056399995,
							27.997298671000102
						],
						[
							-82.76055327499994,
							27.9973008220001
						],
						[
							-82.76078414799996,
							27.997303327000044
						],
						[
							-82.76101690499992,
							27.99730547700004
						],
						[
							-82.76124932399998,
							27.997307628000044
						],
						[
							-82.76148174599993,
							27.99731012300007
						],
						[
							-82.76171445699991,
							27.997312272000077
						],
						[
							-82.76194687799996,
							27.99731476600001
						],
						[
							-82.76217929999991,
							27.99731726000004
						],
						[
							-82.76241234799993,
							27.99731940600013
						],
						[
							-82.7626450619999,
							27.99732189700007
						],
						[
							-82.7629648809999,
							27.99732493700005
						],
						[
							-82.76298016699992,
							27.999064085000064
						],
						[
							-82.76003104299988,
							27.999053571999994
						],
						[
							-82.75910018999987,
							27.999052297000073
						],
						[
							-82.75909584099988,
							27.998832284000073
						],
						[
							-82.75909149799996,
							27.99861330300007
						],
						[
							-82.7590876049999,
							27.99841013500005
						],
						[
							-82.75908371699994,
							27.998207654000083
						],
						[
							-82.75907980699988,
							27.998002079000038
						],
						[
							-82.75907546499987,
							27.997783098000035
						],
						[
							-82.7590715349999,
							27.99757477200003
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Spring Lake South Homeowners Association",
				"RegionID": "343305"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.82347999999978,
					27.966833000000083,
					-82.80685899999962,
					27.997212915949557
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.81678499999978,
							27.994181000000502
						],
						[
							-82.81663299999973,
							27.993253000000454
						],
						[
							-82.816366827386,
							27.991522877598843
						],
						[
							-82.81636519527227,
							27.991514113058816
						],
						[
							-82.8163206913145,
							27.99129894460687
						],
						[
							-82.81628107710002,
							27.991114019711386
						],
						[
							-82.81589199999962,
							27.989489000000237
						],
						[
							-82.81559399999975,
							27.988617000000385
						],
						[
							-82.81528608183953,
							27.98768292982025
						],
						[
							-82.81526787929667,
							27.987654735262275
						],
						[
							-82.81524162448937,
							27.987612653286323
						],
						[
							-82.81522729559138,
							27.987586563055192
						],
						[
							-82.81520732524636,
							27.987544909156906
						],
						[
							-82.81519685174209,
							27.98751991609844
						],
						[
							-82.81518117925708,
							27.987476517515223
						],
						[
							-82.81517264199303,
							27.987448062066914
						],
						[
							-82.81516304802572,
							27.98740823738949
						],
						[
							-82.81515833198101,
							27.987383737159025
						],
						[
							-82.81515245940801,
							27.98734320291693
						],
						[
							-82.81515005911746,
							27.987318974282186
						],
						[
							-82.81514786387241,
							27.98727807491474
						],
						[
							-82.81514787556368,
							27.9872489386798
						],
						[
							-82.8151500869966,
							27.987208356773255
						],
						[
							-82.81515276068097,
							27.987182427520555
						],
						[
							-82.81515894262064,
							27.987141821332276
						],
						[
							-82.81516395364291,
							27.98711687413881
						],
						[
							-82.81517387226563,
							27.987077278788878
						],
						[
							-82.81518167748139,
							27.98705160764154
						],
						[
							-82.81519566553628,
							27.987012674192005
						],
						[
							-82.81520543936807,
							27.986989053499048
						],
						[
							-82.81522311734129,
							27.986951474428526
						],
						[
							-82.8152355855418,
							27.98692803719717
						],
						[
							-82.81525700469466,
							27.986892154248114
						],
						[
							-82.81527050981354,
							27.986871701866637
						],
						[
							-82.81529839778965,
							27.98683337366096
						],
						[
							-82.81531583114707,
							27.986811833099807
						],
						[
							-82.81534780474338,
							27.986776231638647
						],
						[
							-82.81536382706444,
							27.98675984868943
						],
						[
							-82.81539550838121,
							27.986730093720627
						],
						[
							-82.81541520443294,
							27.986713297982494
						],
						[
							-82.81544971591568,
							27.986686620493476
						],
						[
							-82.81546667083386,
							27.98667452910905
						],
						[
							-82.81550366894209,
							27.986650242917857
						],
						[
							-82.81552407995497,
							27.98663809577501
						],
						[
							-82.81556357008462,
							27.98661688976171
						],
						[
							-82.8155840251643,
							27.986606991823418
						],
						[
							-82.81562509090594,
							27.986589214025518
						],
						[
							-82.8156449911038,
							27.986581517627332
						],
						[
							-82.81568796700564,
							27.986566823604978
						],
						[
							-82.81570823682499,
							27.9865607702683
						],
						[
							-82.81575215881342,
							27.9865495071591
						],
						[
							-82.81577111202505,
							27.98654536668074
						],
						[
							-82.81581626788358,
							27.9865371918434
						],
						[
							-82.81583855488213,
							27.986534110765962
						],
						[
							-82.8158843690441,
							27.986529713081257
						],
						[
							-82.81590763810253,
							27.986528490902813
						],
						[
							-82.81595875826457,
							27.986528016060777
						],
						[
							-82.81598058211237,
							27.986528696847405
						],
						[
							-82.81603144237042,
							27.98653234809489
						],
						[
							-82.8160530764612,
							27.986534781660414
						],
						[
							-82.81609834653335,
							27.98654173341976
						],
						[
							-82.81612190337471,
							27.98654643327662
						],
						[
							-82.81616594497308,
							27.986557278200866
						],
						[
							-82.81618076220275,
							27.98656137731054
						],
						[
							-82.8162242866913,
							27.986574766416897
						],
						[
							-82.81624835075013,
							27.98658343768007
						],
						[
							-82.81629001813825,
							27.986600724448
						],
						[
							-82.81630964404279,
							27.986609805801628
						],
						[
							-82.81634944803578,
							27.986630197929077
						],
						[
							-82.81636928618042,
							27.98664144395097
						],
						[
							-82.81640693539804,
							27.986664942336255
						],
						[
							-82.81642306383918,
							27.986675836723332
						],
						[
							-82.81645859964975,
							27.98670175518431
						],
						[
							-82.81647843599592,
							27.986717709156853
						],
						[
							-82.81651084756197,
							27.986746396630583
						],
						[
							-82.81652827912075,
							27.986763284099606
						],
						[
							-82.81655795135173,
							27.986794736988077
						],
						[
							-82.81657470482189,
							27.986814287349763
						],
						[
							-82.81660476915735,
							27.986852959995826
						],
						[
							-82.81662098753075,
							27.986876256033458
						],
						[
							-82.81664671533554,
							27.98691770128922
						],
						[
							-82.81665993806708,
							27.986941629550547
						],
						[
							-82.81667818171393,
							27.986978996380532
						],
						[
							-82.8166838114697,
							27.986991301804057
						],
						[
							-82.81671666640145,
							27.98706814887161
						],
						[
							-82.81672373777063,
							27.987082760156415
						],
						[
							-82.81673048088709,
							27.987093996285598
						],
						[
							-82.81673857478545,
							27.98710512179891
						],
						[
							-82.81674629366636,
							27.98711401969111
						],
						[
							-82.81675748393045,
							27.987122235897136
						],
						[
							-82.81674452380041,
							27.987098813954173
						],
						[
							-82.81672507506244,
							27.987062142299482
						],
						[
							-82.81671387130858,
							27.987038265299553
						],
						[
							-82.81669808910628,
							27.98699985345731
						],
						[
							-82.81668910038256,
							27.986974429623604
						],
						[
							-82.8166773291566,
							27.98693496107766
						],
						[
							-82.81667096735247,
							27.98690899585178
						],
						[
							-82.81666321070007,
							27.98686881684144
						],
						[
							-82.8166592114149,
							27.98683960506338
						],
						[
							-82.8166547840526,
							27.986785310294696
						],
						[
							-82.81665401243419,
							27.986755289126744
						],
						[
							-82.81665525080058,
							27.986714024634654
						],
						[
							-82.81665770415117,
							27.986684930667774
						],
						[
							-82.81666330602809,
							27.986644672517183
						],
						[
							-82.8166677396857,
							27.98662075954407
						],
						[
							-82.81667702518563,
							27.98658082335105
						],
						[
							-82.81668438253911,
							27.98655505417759
						],
						[
							-82.81669773927013,
							27.986515780784163
						],
						[
							-82.81670747892755,
							27.986491173535303
						],
						[
							-82.81672452737527,
							27.98645359716271
						],
						[
							-82.81673486238395,
							27.986433169962158
						],
						[
							-82.8167553552351,
							27.986396603528544
						],
						[
							-82.81676975158206,
							27.986373692400615
						],
						[
							-82.81679394064676,
							27.986339168327238
						],
						[
							-82.8168085168582,
							27.986320211518137
						],
						[
							-82.81683615482274,
							27.986287386263978
						],
						[
							-82.81685184709289,
							27.986270297346852
						],
						[
							-82.81688230982807,
							27.986239861591248
						],
						[
							-82.81690217405308,
							27.986221894036515
						],
						[
							-82.81694006518813,
							27.986190898902766
						],
						[
							-82.81695876658961,
							27.98617690635147
						],
						[
							-82.81699915154472,
							27.986149334037083
						],
						[
							-82.81702044389287,
							27.98613620213707
						],
						[
							-82.81705930269857,
							27.986114655280506
						],
						[
							-82.81707776667922,
							27.986105323915137
						],
						[
							-82.81711882432698,
							27.98608651459499
						],
						[
							-82.81713891697997,
							27.986078271408946
						],
						[
							-82.81717257770411,
							27.986068444517468
						],
						[
							-82.81719218202504,
							27.986064081006493
						],
						[
							-82.81722103677234,
							27.98605275134786
						],
						[
							-82.81725509050044,
							27.986041914517404
						],
						[
							-82.81729028366935,
							27.986035700202297
						],
						[
							-82.81732598945186,
							27.986034217220027
						],
						[
							-82.81736127435175,
							27.986025509984206
						],
						[
							-82.817398428942,
							27.986021585342616
						],
						[
							-82.81744426288923,
							27.98601993778515
						],
						[
							-82.81746639430511,
							27.986020050200114
						],
						[
							-82.81751537048352,
							27.986022338974795
						],
						[
							-82.81756212983316,
							27.986025434441256
						],
						[
							-82.81759099267435,
							27.986028932803567
						],
						[
							-82.81761047648597,
							27.986033116450066
						],
						[
							-82.81766171985544,
							27.986046114351307
						],
						[
							-82.81767271676505,
							27.986049152261142
						],
						[
							-82.81772116594055,
							27.986063647533502
						],
						[
							-82.81774308421717,
							27.986071245905567
						],
						[
							-82.81778508435467,
							27.98608839058058
						],
						[
							-82.8177587737893,
							27.986047494810254
						],
						[
							-82.81774593956469,
							27.986024997370787
						],
						[
							-82.81772362918376,
							27.98598112394554
						],
						[
							-82.81771401992779,
							27.985960028548465
						],
						[
							-82.8176991712217,
							27.985923329015453
						],
						[
							-82.8176951179774,
							27.98591266935119
						],
						[
							-82.8176738238304,
							27.985852893214616
						],
						[
							-82.81766796834471,
							27.98583831970102
						],
						[
							-82.81765914149888,
							27.985820686694144
						],
						[
							-82.81764942972039,
							27.98580498992759
						],
						[
							-82.81764054711658,
							27.985793296043152
						],
						[
							-82.81761232009613,
							27.98576399703087
						],
						[
							-82.81759841747689,
							27.985752235697095
						],
						[
							-82.81758187264961,
							27.985740767542847
						],
						[
							-82.81755534984414,
							27.985725777643037
						],
						[
							-82.81754586109747,
							27.98572128103284
						],
						[
							-82.81751944980822,
							27.985710711301085
						],
						[
							-82.81749524905233,
							27.985702994218645
						],
						[
							-82.81746855087925,
							27.985696933687727
						],
						[
							-82.8174564531995,
							27.985694932696173
						],
						[
							-82.817429173165,
							27.98569211062382
						],
						[
							-82.81740268813091,
							27.985691687043005
						],
						[
							-82.8173748765974,
							27.985693062106446
						],
						[
							-82.81735234498314,
							27.98569599749349
						],
						[
							-82.81732640044213,
							27.985701573290026
						],
						[
							-82.81729661129907,
							27.98571020318416
						],
						[
							-82.81723009564324,
							27.98573281843534
						],
						[
							-82.81536183506624,
							27.986362878053153
						],
						[
							-82.81511555303058,
							27.986445805436873
						],
						[
							-82.81509542530425,
							27.98645260161347
						],
						[
							-82.81509129202014,
							27.98645718815546
						],
						[
							-82.81507864575389,
							27.986470302968872
						],
						[
							-82.81504759756018,
							27.986500397881212
						],
						[
							-82.81502814522462,
							27.98651752007341
						],
						[
							-82.81498670986147,
							27.986550598936258
						],
						[
							-82.8149647717998,
							27.986566381138648
						],
						[
							-82.8149199181136,
							27.986595353697044
						],
						[
							-82.81489708972332,
							27.98660856473766
						],
						[
							-82.81485725605256,
							27.986629086367035
						],
						[
							-82.81483849619507,
							27.986637856555166
						],
						[
							-82.81479713637496,
							27.98665529171142
						],
						[
							-82.81477543483503,
							27.986663361328215
						],
						[
							-82.81473216305623,
							27.986677370067454
						],
						[
							-82.81471374674004,
							27.98668261851073
						],
						[
							-82.81466953067296,
							27.986693537179367
						],
						[
							-82.81464695858921,
							27.986698099440158
						],
						[
							-82.81460174877164,
							27.986705242754898
						],
						[
							-82.8145737007162,
							27.98670818263879
						],
						[
							-82.81449196223639,
							27.98671244902248
						],
						[
							-82.81446134931431,
							27.986712307828935
						],
						[
							-82.81441543532739,
							27.986709485756403
						],
						[
							-82.81439722315696,
							27.98670774466895
						],
						[
							-82.814351668899,
							27.986701825331398
						],
						[
							-82.81432919394216,
							27.986697933065688
						],
						[
							-82.81428448594602,
							27.986688226682972
						],
						[
							-82.81426548507021,
							27.986683372142732
						],
						[
							-82.81422201094388,
							27.98667056579706
						],
						[
							-82.81420137330196,
							27.98666356817218
						],
						[
							-82.81415913124685,
							27.98664731652362
						],
						[
							-82.81413711494439,
							27.986637700073228
						],
						[
							-82.81409698000093,
							27.986617996827082
						],
						[
							-82.81407929303472,
							27.986608481100564
						],
						[
							-82.8140410223856,
							27.986586016036444
						],
						[
							-82.81402085059237,
							27.986572932699364
						],
						[
							-82.81398502699868,
							27.98654735957832
						],
						[
							-82.81396838504473,
							27.986534470495098
						],
						[
							-82.8139350130028,
							27.986506475499446
						],
						[
							-82.81391677385271,
							27.986489689653485
						],
						[
							-82.81389272508227,
							27.986465422348164
						],
						[
							-82.81388129739724,
							27.986453151098903
						],
						[
							-82.81385317020155,
							27.986420998537756
						],
						[
							-82.81383584476269,
							27.986398984933306
						],
						[
							-82.81381142637086,
							27.986364406000877
						],
						[
							-82.81379974417777,
							27.986346379990504
						],
						[
							-82.81377841405771,
							27.986310405310736
						],
						[
							-82.81376615270125,
							27.986287228882492
						],
						[
							-82.81374849091587,
							27.98624951491401
						],
						[
							-82.81373800661969,
							27.986223744841357
						],
						[
							-82.81372439897801,
							27.986184631527703
						],
						[
							-82.81371736358174,
							27.986160975760935
						],
						[
							-82.8137074782341,
							27.986121151982882
						],
						[
							-82.81370236378967,
							27.986095139992454
						],
						[
							-82.81369649481414,
							27.98605495019039
						],
						[
							-82.81369405045697,
							27.986030423879985
						],
						[
							-82.81369185611112,
							27.985989523613345
						],
						[
							-82.81369185071507,
							27.985960692248494
						],
						[
							-82.81369401628271,
							27.985920110341414
						],
						[
							-82.81369819813003,
							27.985885063762442
						],
						[
							-82.81371160072631,
							27.985813129691298
						],
						[
							-82.81372106069476,
							27.985776693659155
						],
						[
							-82.81373412784382,
							27.985737765605837
						],
						[
							-82.81374275863732,
							27.985715401265413
						],
						[
							-82.81375951300667,
							27.985677140509253
						],
						[
							-82.81377171590741,
							27.98565271672128
						],
						[
							-82.81379216559104,
							27.985616495627244
						],
						[
							-82.81380556099253,
							27.98559516191041
						],
						[
							-82.81382979502341,
							27.985560294295833
						],
						[
							-82.81384405737134,
							27.98554157220973
						],
						[
							-82.81387140395553,
							27.985508748754132
						],
						[
							-82.8138878534549,
							27.98549072903899
						],
						[
							-82.81391827032445,
							27.985460294182932
						],
						[
							-82.81393513171336,
							27.985444797964934
						],
						[
							-82.81397003619968,
							27.98541482176315
						],
						[
							-82.81396006451718,
							27.985414240800672
						],
						[
							-82.81393989901946,
							27.985413605879575
						],
						[
							-82.81389398233452,
							27.985410439366834
						],
						[
							-82.81386343236521,
							27.98540657048331
						],
						[
							-82.81377345429684,
							27.9853899123416
						],
						[
							-82.81374200950198,
							27.985382112521613
						],
						[
							-82.81369886902421,
							27.9853686154966
						],
						[
							-82.8136784067502,
							27.985361296813874
						],
						[
							-82.81363645157887,
							27.985344354485978
						],
						[
							-82.81361692280107,
							27.985335551022775
						],
						[
							-82.81357678515951,
							27.985315504235434
						],
						[
							-82.81355598114304,
							27.98530393985327
						],
						[
							-82.81351833552282,
							27.985280784109637
						],
						[
							-82.81350274937276,
							27.98527043471203
						],
						[
							-82.81347938588588,
							27.985253727107132
						],
						[
							-82.81346674321657,
							27.985244110656918
						],
						[
							-82.81343211392264,
							27.985216123755055
						],
						[
							-82.81341344039993,
							27.985199546552156
						],
						[
							-82.81338256937295,
							27.985169474122987
						],
						[
							-82.81336502989517,
							27.985150679191687
						],
						[
							-82.81333718868369,
							27.985117838649312
						],
						[
							-82.81332332113809,
							27.98510001858318
						],
						[
							-82.81329890724292,
							27.9850657831923
						],
						[
							-82.81328512243486,
							27.98504438382469
						],
						[
							-82.81326408099739,
							27.985008065603903
						],
						[
							-82.81325236013338,
							27.984985432366397
						],
						[
							-82.81323503649307,
							27.984947716599
						],
						[
							-82.8132216186085,
							27.984912061178516
						],
						[
							-82.81319812651844,
							27.984833124986
						],
						[
							-82.8131894390675,
							27.98479296576072
						],
						[
							-82.81318385877448,
							27.98475242971971
						],
						[
							-82.81318161406641,
							27.98472786114125
						],
						[
							-82.81317975876526,
							27.98468695907587
						],
						[
							-82.81317966073895,
							27.984664878921098
						],
						[
							-82.81318066618127,
							27.98463736955991
						],
						[
							-82.81318252238188,
							27.98461413377648
						],
						[
							-82.81318749653195,
							27.984573879223365
						],
						[
							-82.81319164960104,
							27.98454950669697
						],
						[
							-82.81320035323982,
							27.984509574100894
						],
						[
							-82.81320786977318,
							27.984482132188152
						],
						[
							-82.81322088925832,
							27.984442861493545
						],
						[
							-82.81322950925991,
							27.984420295705196
						],
						[
							-82.81324597404767,
							27.984382380288434
						],
						[
							-82.81325665169817,
							27.9843605402527
						],
						[
							-82.81327680460544,
							27.984323633875544
						],
						[
							-82.8132910525645,
							27.98430041338033
						],
						[
							-82.81331494845004,
							27.984265546665657
						],
						[
							-82.81332829079167,
							27.98424770681446
						],
						[
							-82.81335529833152,
							27.984214541616762
						],
						[
							-82.81337290705675,
							27.984194955282252
						],
						[
							-82.8134030784115,
							27.984164522224756
						],
						[
							-82.81341945416648,
							27.984149320084942
						],
						[
							-82.81345269310856,
							27.984120930287407
						],
						[
							-82.81347056623457,
							27.984106921547994
						],
						[
							-82.8135062962989,
							27.984081270185715
						],
						[
							-82.8135253412414,
							27.984068780401397
						],
						[
							-82.8135509332485,
							27.98405350181962
						],
						[
							-82.81356332770463,
							27.984046538369004
						],
						[
							-82.81360286639766,
							27.984025674997174
						],
						[
							-82.81362222250584,
							27.984016426369532
						],
						[
							-82.81366357782927,
							27.98399864767244
						],
						[
							-82.81368467862202,
							27.983990605934498
						],
						[
							-82.81372765632244,
							27.98397625545316
						],
						[
							-82.813750731127,
							27.983969675113865
						],
						[
							-82.81379524037298,
							27.98395909818733
						],
						[
							-82.81381352898573,
							27.983955414564505
						],
						[
							-82.81385873610566,
							27.983947926809197
						],
						[
							-82.81387890969742,
							27.983945361942478
						],
						[
							-82.81392443427771,
							27.98394131139627
						],
						[
							-82.81394437224712,
							27.983940278974654
						],
						[
							-82.81398338753483,
							27.98393970340857
						],
						[
							-82.81400393794235,
							27.983940183646286
						],
						[
							-82.81404980426525,
							27.983943006618365
						],
						[
							-82.81407126748472,
							27.983945191970708
						],
						[
							-82.81410831685443,
							27.983950468293376
						],
						[
							-82.81415885425581,
							27.98393359701176
						],
						[
							-82.81440439614947,
							27.983850822513215
						],
						[
							-82.81465069886974,
							27.983767544393704
						],
						[
							-82.81630194224891,
							27.983210642824577
						],
						[
							-82.81637973900045,
							27.983184576874823
						],
						[
							-82.81641421451044,
							27.983171511524425
						],
						[
							-82.81644122205039,
							27.983158649420506
						],
						[
							-82.81646621600805,
							27.983143986874307
						],
						[
							-82.81649042485782,
							27.98312720642439
						],
						[
							-82.81651177566214,
							27.98310938096275
						],
						[
							-82.81653236294193,
							27.98308900322485
						],
						[
							-82.8165389666636,
							27.983081389564394
						],
						[
							-82.81655675615285,
							27.98305806744629
						],
						[
							-82.81656945907636,
							27.983037741869158
						],
						[
							-82.81658038673842,
							27.983015762438793
						],
						[
							-82.8165889132104,
							27.982993082436387
						],
						[
							-82.81659482175633,
							27.982971157864714
						],
						[
							-82.81659883093403,
							27.982947589332344
						],
						[
							-82.81659976982591,
							27.982936705736808
						],
						[
							-82.81659991911361,
							27.982898100540258
						],
						[
							-82.81659896313414,
							27.982872127220407
						],
						[
							-82.816599439775,
							27.982843373197245
						],
						[
							-82.81660109992337,
							27.98281964008932
						],
						[
							-82.8166045227429,
							27.982791726932202
						],
						[
							-82.8166087009931,
							27.982767979434545
						],
						[
							-82.81661418865605,
							27.982743513378875
						],
						[
							-82.8166205027961,
							27.982720441271983
						],
						[
							-82.81662770331798,
							27.982698020697075
						],
						[
							-82.8166219999998,
							27.98267599999999
						],
						[
							-82.81658899999975,
							27.982612000000376
						],
						[
							-82.81650463439581,
							27.982468807223984
						],
						[
							-82.81650089386561,
							27.982466979948764
						],
						[
							-82.81648351896382,
							27.982457693549026
						],
						[
							-82.81644962711397,
							27.982437954330056
						],
						[
							-82.81643060915121,
							27.98242578470457
						],
						[
							-82.81639848986468,
							27.98240328366727
						],
						[
							-82.8163798253352,
							27.98238895566875
						],
						[
							-82.81635054430943,
							27.98236437539884
						],
						[
							-82.81633504989009,
							27.982350309103158
						],
						[
							-82.81630788496892,
							27.982323654097133
						],
						[
							-82.81628905676291,
							27.98230316934031
						],
						[
							-82.81626497201965,
							27.98227408886326
						],
						[
							-82.81625158830934,
							27.982256510714723
						],
						[
							-82.81623030045749,
							27.98222603898647
						],
						[
							-82.81621670540636,
							27.982204475942147
						],
						[
							-82.81619999240569,
							27.98217495479715
						],
						[
							-82.81618786864537,
							27.982149975228158
						],
						[
							-82.81618039527936,
							27.982133430401138
						],
						[
							-82.81616933721574,
							27.982109186478002
						],
						[
							-82.81616070282494,
							27.982087085639154
						],
						[
							-82.81608469572433,
							27.981863993520864
						],
						[
							-82.81604108580056,
							27.98172815272732
						],
						[
							-82.81599917739395,
							27.981597357129676
						],
						[
							-82.8159964083813,
							27.9815881534682
						],
						[
							-82.8159201917386,
							27.98131744944367
						],
						[
							-82.81584544818548,
							27.98104726162986
						],
						[
							-82.81577556276999,
							27.98077393428279
						],
						[
							-82.81575919241105,
							27.98070492750437
						],
						[
							-82.81571116411816,
							27.98049910416857
						],
						[
							-82.81566918826238,
							27.980302730907983
						],
						[
							-82.81565229449812,
							27.98022385946687
						],
						[
							-82.81559901956024,
							27.97994755986021
						],
						[
							-82.81555114595072,
							27.979670302476226
						],
						[
							-82.81550891648617,
							27.979392812167095
						],
						[
							-82.81547241570307,
							27.979114044821177
						],
						[
							-82.81544126138935,
							27.97883529726032
						],
						[
							-82.81541576381117,
							27.978555750202286
						],
						[
							-82.81539569723877,
							27.978275865898286
						],
						[
							-82.81538136294493,
							27.97799855185669
						],
						[
							-82.81538103379293,
							27.977988581073202
						],
						[
							-82.81538060571572,
							27.97795920741716
						],
						[
							-82.81537873602518,
							27.97794104291082
						],
						[
							-82.81537696076356,
							27.977932130629416
						],
						[
							-82.81537431226019,
							27.97792364192883
						],
						[
							-82.81536986870985,
							27.977913119860993
						],
						[
							-82.8153639340839,
							27.9779019412879
						],
						[
							-82.81535764152784,
							27.977892314945155
						],
						[
							-82.81534674354336,
							27.9778791128977
						],
						[
							-82.8153326223889,
							27.977865772354807
						],
						[
							-82.81531921079937,
							27.977855330326765
						],
						[
							-82.81529555862998,
							27.977839548124553
						],
						[
							-82.81525434450019,
							27.97781249112187
						],
						[
							-82.81523013385168,
							27.977794582922325
						],
						[
							-82.81520051647912,
							27.977770003551786
						],
						[
							-82.8151838448475,
							27.977754954297144
						],
						[
							-82.81517141531774,
							27.97774466785167
						],
						[
							-82.81515115629048,
							27.97776287102859
						],
						[
							-82.81512127721527,
							27.977787114052894
						],
						[
							-82.81510481332697,
							27.977799461744116
						],
						[
							-82.81507171557826,
							27.97782235848302
						],
						[
							-82.81505636235272,
							27.977832782524917
						],
						[
							-82.8150368173869,
							27.977848242769557
						],
						[
							-82.81502301009594,
							27.977861948437628
						],
						[
							-82.81501556550796,
							27.977871081052644
						],
						[
							-82.8150092216905,
							27.977880439397854
						],
						[
							-82.81500333203064,
							27.97789140932789
						],
						[
							-82.8149987958503,
							27.977902112159217
						],
						[
							-82.81499551422405,
							27.97791246065781
						],
						[
							-82.81499354740684,
							27.977921523125918
						],
						[
							-82.81499254826012,
							27.977931060436237
						],
						[
							-82.81499224698716,
							27.977947601666312
						],
						[
							-82.81499341520657,
							27.97797846639806
						],
						[
							-82.81500356765281,
							27.978192798220395
						],
						[
							-82.81501676610297,
							27.978405322404956
						],
						[
							-82.81503294760427,
							27.97861868925448
						],
						[
							-82.81505277225898,
							27.978831287183606
						],
						[
							-82.81507568068906,
							27.979044299699854
						],
						[
							-82.8151015793648,
							27.979256844569203
						],
						[
							-82.81513115626768,
							27.9794685881421
						],
						[
							-82.81516345092193,
							27.97968069234368
						],
						[
							-82.81519935725326,
							27.979891843263363
						],
						[
							-82.81523836174898,
							27.98010298968673
						],
						[
							-82.81528042304024,
							27.980313300639917
						],
						[
							-82.81532577225288,
							27.98052330672302
						],
						[
							-82.81537419444892,
							27.980732900916575
						],
						[
							-82.81542592345212,
							27.9809417387802
						],
						[
							-82.81548074162639,
							27.981149765455196
						],
						[
							-82.81553857163021,
							27.981357331677543
						],
						[
							-82.8155997048438,
							27.981564138872198
						],
						[
							-82.81566411428736,
							27.98177087771815
						],
						[
							-82.81567196986542,
							27.981795159413206
						],
						[
							-82.81567773901618,
							27.981809597128763
						],
						[
							-82.8156831502368,
							27.981820284672057
						],
						[
							-82.81568896165588,
							27.981829459555133
						],
						[
							-82.81571050401577,
							27.981857132593394
						],
						[
							-82.81571653307054,
							27.98186518152558
						],
						[
							-82.81574735553441,
							27.98190797396575
						],
						[
							-82.8157625594726,
							27.981931583866807
						],
						[
							-82.81578139667197,
							27.981964477469493
						],
						[
							-82.81579120467802,
							27.9819832813936
						],
						[
							-82.81580886376537,
							27.98202065182142
						],
						[
							-82.8158197455619,
							27.982047267256963
						],
						[
							-82.81583335320357,
							27.982086379670893
						],
						[
							-82.81584038770056,
							27.9821100300418
						],
						[
							-82.81585027304821,
							27.982149853820207
						],
						[
							-82.8158553452244,
							27.982175566336235
						],
						[
							-82.81586126096474,
							27.982215756138476
						],
						[
							-82.8158637709725,
							27.982240995611214
						],
						[
							-82.81586592215085,
							27.982282239418872
						],
						[
							-82.81586590506372,
							27.982310657095258
						],
						[
							-82.81586374129499,
							27.982351239001805
						],
						[
							-82.81586100465795,
							27.9823777824917
						],
						[
							-82.81585477595364,
							27.982418387780786
						],
						[
							-82.81585053205293,
							27.982440080327212
						],
						[
							-82.81584363245445,
							27.982469001624573
						],
						[
							-82.81583763127854,
							27.982490262496746
						],
						[
							-82.81582490137491,
							27.98252918695276
						],
						[
							-82.81581561677454,
							27.982553530700574
						],
						[
							-82.81579886420366,
							27.982591792356462
						],
						[
							-82.81578746169973,
							27.982614791618158
						],
						[
							-82.81576730339644,
							27.982651010913276
						],
						[
							-82.81575481091419,
							27.98267129422253
						],
						[
							-82.81573091952515,
							27.982706503579205
						],
						[
							-82.81571599707468,
							27.98272644784358
						],
						[
							-82.81568898773627,
							27.982759269500793
						],
						[
							-82.8156724249223,
							27.982777615670177
						],
						[
							-82.81564196488523,
							27.98280839496662
						],
						[
							-82.81562506032907,
							27.98282407554559
						],
						[
							-82.81559211006913,
							27.982852118204807
						],
						[
							-82.81557363889397,
							27.9828665046595
						],
						[
							-82.81553757248348,
							27.98289216141764
						],
						[
							-82.81551649777093,
							27.982905724992083
						],
						[
							-82.81546916375457,
							27.98293316600546
						],
						[
							-82.8154456986441,
							27.98294527537674
						],
						[
							-82.81539523318855,
							27.98296826564492
						],
						[
							-82.81537067270379,
							27.982978031382647
						],
						[
							-82.81532769860058,
							27.982992725405712
						],
						[
							-82.81530934703534,
							27.982998280517638
						],
						[
							-82.81526542864411,
							27.983009888067226
						],
						[
							-82.81524455537975,
							27.983014527669706
						],
						[
							-82.8151994004207,
							27.98302270250669
						],
						[
							-82.81517726450811,
							27.983025770094297
						],
						[
							-82.81513174352504,
							27.98303016508107
						],
						[
							-82.81511343782515,
							27.983031306320708
						],
						[
							-82.81506726483359,
							27.983032611236883
						],
						[
							-82.8150450812571,
							27.98303232525249
						],
						[
							-82.81499921673293,
							27.983029846721156
						],
						[
							-82.81497679393668,
							27.983027692844434
						],
						[
							-82.81493153105906,
							27.983021428167483
						],
						[
							-82.81491128102488,
							27.983017834476623
						],
						[
							-82.8148665739281,
							27.983008129892642
						],
						[
							-82.81484426354717,
							27.98300227800407
						],
						[
							-82.814790693632,
							27.98298574846509
						],
						[
							-82.8147667716659,
							27.98297711317527
						],
						[
							-82.81471534483511,
							27.982955757874276
						],
						[
							-82.81469095971816,
							27.982944169210736
						],
						[
							-82.81465178075409,
							27.982923085504932
						],
						[
							-82.81463447779831,
							27.98291292676335
						],
						[
							-82.81459711816221,
							27.98288908213912
						],
						[
							-82.81457652548656,
							27.98287454010186
						],
						[
							-82.81454190428643,
							27.9828475847226
						],
						[
							-82.81452674171702,
							27.98283485841672
						],
						[
							-82.8144946206322,
							27.982805825603588
						],
						[
							-82.81447539852296,
							27.982786606192285
						],
						[
							-82.81444664539907,
							27.982754801669
						],
						[
							-82.8144326195728,
							27.982737960065332
						],
						[
							-82.81440665884395,
							27.982704078107826
						],
						[
							-82.81439197651224,
							27.98268289187941
						],
						[
							-82.81436972998317,
							27.98264726703589
						],
						[
							-82.81435742905659,
							27.982625361349914
						],
						[
							-82.81433885355997,
							27.98258834165789
						],
						[
							-82.81432844120962,
							27.982564866654972
						],
						[
							-82.81431281548953,
							27.982524561739655
						],
						[
							-82.8143041469242,
							27.98249827455656
						],
						[
							-82.8142928235606,
							27.982456912937717
						],
						[
							-82.81428739615204,
							27.982432798516857
						],
						[
							-82.81428026812578,
							27.982392615010024
						],
						[
							-82.81427674008543,
							27.982363762960563
						],
						[
							-82.81427396477773,
							27.9823228662914
						],
						[
							-82.8142734719491,
							27.982296327298354
						],
						[
							-82.81427424896356,
							27.982270979906968
						],
						[
							-82.81427368508838,
							27.982264132468973
						],
						[
							-82.81426960396503,
							27.982239400213974
						],
						[
							-82.81426546888244,
							27.982215304678807
						],
						[
							-82.81426105950646,
							27.982198645637553
						],
						[
							-82.81422488967392,
							27.98208589763444
						],
						[
							-82.81415741713924,
							27.981865682448085
						],
						[
							-82.81409335663248,
							27.98164466506609
						],
						[
							-82.81403243206158,
							27.98142305682944
						],
						[
							-82.8139746623126,
							27.981200578049332
						],
						[
							-82.81392028480592,
							27.980977507515195
						],
						[
							-82.81386942184986,
							27.980753489995106
						],
						[
							-82.8138217802654,
							27.980529093860365
						],
						[
							-82.81377717029528,
							27.980304274144814
						],
						[
							-82.81373637435017,
							27.98007868820697
						],
						[
							-82.81369876110556,
							27.979853152631154
						],
						[
							-82.81366425861607,
							27.97962699112723
						],
						[
							-82.81363322211347,
							27.9793999653749
						],
						[
							-82.81360563990681,
							27.97917293242797
						],
						[
							-82.8135815677541,
							27.978945676449133
						],
						[
							-82.81356065132239,
							27.978718081425594
						],
						[
							-82.8135431667034,
							27.97848995760088
						],
						[
							-82.81352913278315,
							27.978261791508277
						],
						[
							-82.81351863949371,
							27.97803482421212
						],
						[
							-82.81351444955243,
							27.977930585594027
						],
						[
							-82.81351297286557,
							27.97791827477482
						],
						[
							-82.81351096198158,
							27.97790906122081
						],
						[
							-82.81350766506692,
							27.977899034679258
						],
						[
							-82.81350348052159,
							27.977889324699238
						],
						[
							-82.81349826895051,
							27.97787977030232
						],
						[
							-82.8134909241873,
							27.977868991927686
						],
						[
							-82.81348352726388,
							27.977859826037236
						],
						[
							-82.81346972446914,
							27.97784617612759
						],
						[
							-82.81345341436494,
							27.977832959691288
						],
						[
							-82.81342622426251,
							27.97781530240268
						],
						[
							-82.81341962413825,
							27.97781087683894
						],
						[
							-82.81338144971676,
							27.977784456556446
						],
						[
							-82.81336269165791,
							27.977770224784955
						],
						[
							-82.81335045188516,
							27.977760067842286
						],
						[
							-82.81333327123706,
							27.97777302167656
						],
						[
							-82.81331466336484,
							27.977785897270127
						],
						[
							-82.8132960554928,
							27.977798773763066
						],
						[
							-82.81329030882495,
							27.977802641746866
						],
						[
							-82.81328083806477,
							27.977808841672772
						],
						[
							-82.81326351982032,
							27.97782256442797
						],
						[
							-82.81324891932734,
							27.977837173914214
						],
						[
							-82.81324169417415,
							27.977845933310977
						],
						[
							-82.81323486652121,
							27.977856118132497
						],
						[
							-82.81322892200257,
							27.977866908198582
						],
						[
							-82.81322479681232,
							27.977876539937544
						],
						[
							-82.81322140816707,
							27.977887055710152
						],
						[
							-82.81321935951149,
							27.977896405061493
						],
						[
							-82.81321829831148,
							27.977905690561858
						],
						[
							-82.81321799973654,
							27.977922051028084
						],
						[
							-82.81321898089702,
							27.977955014777862
						],
						[
							-82.81322763507279,
							27.978167531767998
						],
						[
							-82.81323926690385,
							27.978379713310737
						],
						[
							-82.81325365605647,
							27.978591538722345
						],
						[
							-82.81327104444773,
							27.978803338053485
						],
						[
							-82.81329123512683,
							27.97901508972053
						],
						[
							-82.81331442594382,
							27.979226199271704
						],
						[
							-82.81334037498185,
							27.97943760919647
						],
						[
							-82.81336935023818,
							27.97964822412037
						],
						[
							-82.8134020603789,
							27.979864428330817
						],
						[
							-82.81343584610903,
							27.98006862659214
						],
						[
							-82.81347342697812,
							27.980278471696455
						],
						[
							-82.81351365275309,
							27.980487834764137
						],
						[
							-82.8135568984515,
							27.9806968399016
						],
						[
							-82.81360326749538,
							27.98090492143565
						],
						[
							-82.81365209618474,
							27.981113377087144
						],
						[
							-82.81370388724116,
							27.98132051523236
						],
						[
							-82.81375845000792,
							27.98152735840002
						],
						[
							-82.81381599132958,
							27.981733288755454
						],
						[
							-82.81387636281721,
							27.981938784738354
						],
						[
							-82.81393946464685,
							27.98214399293847
						],
						[
							-82.81400553333975,
							27.982348516754133
						],
						[
							-82.81404822325713,
							27.982477474137216
						],
						[
							-82.81405449602832,
							27.982493815718104
						],
						[
							-82.81405917610003,
							27.982502719006167
						],
						[
							-82.81406658291625,
							27.982514090933215
						],
						[
							-82.8140812067918,
							27.982532456887657
						],
						[
							-82.81410192897008,
							27.98255813702816
						],
						[
							-82.81411547905513,
							27.982576464311496
						],
						[
							-82.81413931918279,
							27.98261173572182
						],
						[
							-82.81415099777865,
							27.98263065026269
						],
						[
							-82.81417140879135,
							27.982666972980144
						],
						[
							-82.8141846261272,
							27.982693895983704
						],
						[
							-82.81420416749572,
							27.98274002311
						],
						[
							-82.81421471564367,
							27.982769607207484
						],
						[
							-82.81422870369857,
							27.982817483515024
						],
						[
							-82.81423504661676,
							27.982844165500357
						],
						[
							-82.81424246512427,
							27.98288434630926
						],
						[
							-82.81424616943161,
							27.982912842227062
						],
						[
							-82.81424928378367,
							27.982953737097485
						],
						[
							-82.81425003112055,
							27.982978311072163
						],
						[
							-82.81424941598424,
							27.983018883985373
						],
						[
							-82.81424767129948,
							27.983045699969825
						],
						[
							-82.81424299032822,
							27.983086295366025
						],
						[
							-82.81423864120698,
							27.98311255197216
						],
						[
							-82.8142299843331,
							27.983152484568233
						],
						[
							-82.81422296602396,
							27.983178504652457
						],
						[
							-82.81421023971801,
							27.983217773548677
						],
						[
							-82.81420141287235,
							27.983241231464643
						],
						[
							-82.81418494988297,
							27.98327949132179
						],
						[
							-82.81417391789982,
							27.983302151538783
						],
						[
							-82.81415376589176,
							27.98333905791647
						],
						[
							-82.81414152252181,
							27.983359313346515
						],
						[
							-82.81411945405839,
							27.98339244976599
						],
						[
							-82.81410500555067,
							27.983412147616452
						],
						[
							-82.81407829029044,
							27.98344531101559
						],
						[
							-82.81406099902584,
							27.98346477324351
						],
						[
							-82.81403087623447,
							27.983495550741214
						],
						[
							-82.81401538721126,
							27.983510172818274
						],
						[
							-82.81398244144816,
							27.983538904358443
						],
						[
							-82.81396331466702,
							27.983554115491064
						],
						[
							-82.81392787778177,
							27.983579766853342
						],
						[
							-82.8139092015612,
							27.98359213702792
						],
						[
							-82.81387127355389,
							27.98361505265269
						],
						[
							-82.81385295886092,
							27.98362517092478
						],
						[
							-82.81381283201117,
							27.983645349012782
						],
						[
							-82.81379218087952,
							27.983654668687414
						],
						[
							-82.81375047931697,
							27.983671417660464
						],
						[
							-82.81372929668593,
							27.98367891710722
						],
						[
							-82.81368602130985,
							27.98369223786505
						],
						[
							-82.81366705820534,
							27.9836973271281
						],
						[
							-82.81362097694476,
							27.983707914846537
						],
						[
							-82.81359828255324,
							27.983712115579987
						],
						[
							-82.81354999615507,
							27.983718932440485
						],
						[
							-82.81352802032183,
							27.983721122289854
						],
						[
							-82.81348219446849,
							27.983723800471086
						],
						[
							-82.81346198310524,
							27.983724222252988
						],
						[
							-82.81341613207081,
							27.98372346232593
						],
						[
							-82.81339604301542,
							27.983722379541934
						],
						[
							-82.81335011913596,
							27.98371818150695
						],
						[
							-82.81332752726722,
							27.983715148992978
						],
						[
							-82.81328254138066,
							27.983707163912822
						],
						[
							-82.81326192891976,
							27.98370266730245
						],
						[
							-82.81321788552265,
							27.983691238718325
						],
						[
							-82.81319910677938,
							27.98368563054591
						],
						[
							-82.81315620372263,
							27.983671100199917
						],
						[
							-82.81313513710414,
							27.983662967630988
						],
						[
							-82.81309380336432,
							27.983644990183723
						],
						[
							-82.81307355962547,
							27.98363516149315
						],
						[
							-82.8130343815605,
							27.983614076887978
						],
						[
							-82.81301560821326,
							27.983602972958824
						],
						[
							-82.81297824767806,
							27.983578783894206
						],
						[
							-82.81295883581217,
							27.983564962214228
						],
						[
							-82.8129251858799,
							27.98353868852114
						],
						[
							-82.81290929485958,
							27.983525263441962
						],
						[
							-82.81287712521122,
							27.98349588618844
						],
						[
							-82.81285877274662,
							27.983477426704543
						],
						[
							-82.81283006638745,
							27.983445622180728
						],
						[
							-82.81281609002383,
							27.983428814751324
						],
						[
							-82.81279042337297,
							27.983395273636905
						],
						[
							-82.81277536692356,
							27.983373456084696
						],
						[
							-82.8127530718313,
							27.983337487700158
						],
						[
							-82.81274156230775,
							27.983316972366016
						],
						[
							-82.81272269183357,
							27.983279610032344
						],
						[
							-82.81271178395666,
							27.98325504145335
						],
						[
							-82.81269697122376,
							27.983216622416688
						],
						[
							-82.81268905089456,
							27.983192845241614
						],
						[
							-82.81267791099259,
							27.983153374896933
						],
						[
							-82.81267009228691,
							27.983115428903385
						],
						[
							-82.81265988048527,
							27.983038133074093
						],
						[
							-82.8126575872141,
							27.982998706796383
						],
						[
							-82.81265820864563,
							27.982957715698223
						],
						[
							-82.81265849283119,
							27.982942143037906
						],
						[
							-82.81265784442019,
							27.982929278236064
						],
						[
							-82.81265660875164,
							27.982921319236556
						],
						[
							-82.81265174162077,
							27.982902908315946
						],
						[
							-82.81258404335652,
							27.982699930434155
						],
						[
							-82.8125141228673,
							27.982481099304227
						],
						[
							-82.81244701186014,
							27.98226109545833
						],
						[
							-82.81238303319157,
							27.98204068242082
						],
						[
							-82.81232217067405,
							27.981819966311964
						],
						[
							-82.81226421746311,
							27.98159859549624
						],
						[
							-82.81220901078174,
							27.98137594944247
						],
						[
							-82.8121572826779,
							27.98115345807172
						],
						[
							-82.81210808886372,
							27.98093011953934
						],
						[
							-82.81206231247296,
							27.9807056946262
						],
						[
							-82.81201938153735,
							27.980481730166066
						],
						[
							-82.81197961531583,
							27.980256629862158
						],
						[
							-82.81194264958305,
							27.98003108529336
						],
						[
							-82.8119091633275,
							27.979805511046788
						],
						[
							-82.81187853151965,
							27.979579903524968
						],
						[
							-82.81185070649606,
							27.97935355766025
						],
						[
							-82.8118263132854,
							27.979126843073058
						],
						[
							-82.81180479790515,
							27.97889995311841
						],
						[
							-82.81178641576285,
							27.97867290668147
						],
						[
							-82.81177114257694,
							27.978445960069568
						],
						[
							-82.8117587571138,
							27.978218110538148
						],
						[
							-82.8117498700136,
							27.977992317756343
						],
						[
							-82.81174969194787,
							27.97798577069194
						],
						[
							-82.81174854441298,
							27.97790924198448
						],
						[
							-82.81174758303773,
							27.977895422102886
						],
						[
							-82.81174616120965,
							27.97788727424539
						],
						[
							-82.81174392729358,
							27.97787932963455
						],
						[
							-82.81173760326118,
							27.977863538439
						],
						[
							-82.81172956242278,
							27.977848718511314
						],
						[
							-82.81172430228831,
							27.977841186689215
						],
						[
							-82.81171600244528,
							27.977831420052116
						],
						[
							-82.8117026915799,
							27.977818340312513
						],
						[
							-82.81168820530051,
							27.977806763339533
						],
						[
							-82.81166010148729,
							27.977788352419278
						],
						[
							-82.81165427747793,
							27.977784427778044
						],
						[
							-82.81161615072044,
							27.97775800749555
						],
						[
							-82.81159650772858,
							27.97774301849511
						],
						[
							-82.81158432821039,
							27.9777353005133
						],
						[
							-82.81156300798294,
							27.97775115106386
						],
						[
							-82.81152622481265,
							27.97777579518563
						],
						[
							-82.81150296025118,
							27.97779273391622
						],
						[
							-82.81148903604804,
							27.977805594221042
						],
						[
							-82.8114755803919,
							27.9778210175942
						],
						[
							-82.81146953245108,
							27.977829580039174
						],
						[
							-82.81146434336317,
							27.97783865239946
						],
						[
							-82.81145825135575,
							27.977852346376256
						],
						[
							-82.81145546345748,
							27.97786090972078
						],
						[
							-82.8114532547226,
							27.977870926369445
						],
						[
							-82.81145213506657,
							27.977880073373843
						],
						[
							-82.8114518562766,
							27.97789532677452
						],
						[
							-82.81145413066218,
							27.977970870724636
						],
						[
							-82.81146286038117,
							27.978197909067255
						],
						[
							-82.81147388876728,
							27.978410721934313
						],
						[
							-82.81148738489293,
							27.978623081543322
						],
						[
							-82.8115049288673,
							27.978848859935926
						],
						[
							-82.81152683904958,
							27.979087494137037
						],
						[
							-82.81155052089655,
							27.979313345375015
						],
						[
							-82.81157524685659,
							27.97952489739252
						],
						[
							-82.81160306738353,
							27.979736448510653
						],
						[
							-82.81163525861561,
							27.979960751115943
						],
						[
							-82.81167268300233,
							27.980197800711895
						],
						[
							-82.81171130618563,
							27.98042203946515
						],
						[
							-82.81175041320415,
							27.980633701199867
						],
						[
							-82.81175169563741,
							27.98064124201513
						],
						[
							-82.81178080399341,
							27.98082833427237
						],
						[
							-82.81179246909953,
							27.980847849560423
						],
						[
							-82.81180293181193,
							27.980869104137188
						],
						[
							-82.81181877516796,
							27.980894572937057
						],
						[
							-82.8118225631125,
							27.98090085020483
						],
						[
							-82.81184671530502,
							27.980942136280543
						],
						[
							-82.81186041197957,
							27.98096886053393
						],
						[
							-82.81188089493791,
							27.981014981364996
						],
						[
							-82.81189172097675,
							27.98104364365709
						],
						[
							-82.81190664882308,
							27.981091172826314
						],
						[
							-82.81191379393628,
							27.98111904011826
						],
						[
							-82.81192184017054,
							27.98115921732968
						],
						[
							-82.81192576840925,
							27.981185503613585
						],
						[
							-82.81192980007005,
							27.98122604864794
						],
						[
							-82.81193112297272,
							27.981252950967065
						],
						[
							-82.81193109149649,
							27.98129386382381
						],
						[
							-82.81192978747958,
							27.98132014291294
						],
						[
							-82.81192578279837,
							27.98136073651076
						],
						[
							-82.8119221855104,
							27.981385434591846
						],
						[
							-82.81191440367681,
							27.981425705332544
						],
						[
							-82.81190734130098,
							27.981453964729145
						],
						[
							-82.81189524272177,
							27.981493230028246
						],
						[
							-82.81188746808289,
							27.981515076359035
						],
						[
							-82.81187197186489,
							27.981553330820145
						],
						[
							-82.811860751024,
							27.981577520784132
						],
						[
							-82.81184118177646,
							27.981614767105004
						],
						[
							-82.81182941414772,
							27.98163498386447
						],
						[
							-82.81180859844015,
							27.98166742510794
						],
						[
							-82.8117997868828,
							27.98168032048657
						],
						[
							-82.81177435765306,
							27.981715314905312
						],
						[
							-82.81174723410095,
							27.98174713201941
						],
						[
							-82.81171738110594,
							27.981777098328667
						],
						[
							-82.81170668996569,
							27.981787257969795
						],
						[
							-82.81167437642586,
							27.981816329453682
						],
						[
							-82.81166735362022,
							27.981822431353645
						],
						[
							-82.8116379835614,
							27.981842996150267
						],
						[
							-82.81163221261163,
							27.98184876710003
						],
						[
							-82.81160305659164,
							27.981870077434863
						],
						[
							-82.81156576260649,
							27.981893675644823
						],
						[
							-82.81153530346852,
							27.98191030860561
						],
						[
							-82.81150296204973,
							27.981922892818925
						],
						[
							-82.81149175200066,
							27.98192709624995
						],
						[
							-82.81147789794481,
							27.981935650601134
						],
						[
							-82.8114377324244,
							27.981954618201957
						],
						[
							-82.81139243447295,
							27.981971605496017
						],
						[
							-82.81134874181156,
							27.9819879830492
						],
						[
							-82.8113094378417,
							27.981999206588274
						],
						[
							-82.8112688883105,
							27.982004363300845
						],
						[
							-82.81122802671479,
							27.982003332677788
						],
						[
							-82.81121823219866,
							27.982005405615165
						],
						[
							-82.81117904334188,
							27.982009395906818
						],
						[
							-82.81113320849538,
							27.982010698125062
						],
						[
							-82.81111097995273,
							27.98201041304022
						],
						[
							-82.8110651172272,
							27.982007932709788
						],
						[
							-82.81104296872444,
							27.98200581660534
						],
						[
							-82.81099736770157,
							27.981999552827226
						],
						[
							-82.81097677952214,
							27.9819959069756
						],
						[
							-82.81093212008963,
							27.981986199693512
						],
						[
							-82.81091317587118,
							27.981981356844546
						],
						[
							-82.81086970354357,
							27.981968548700312
						],
						[
							-82.81084846875177,
							27.981961319949914
						],
						[
							-82.81080652077515,
							27.981945065603604
						],
						[
							-82.81078579949603,
							27.981936019323076
						],
						[
							-82.81074537407152,
							27.9819163169763
						],
						[
							-82.81072711243844,
							27.98190653055396
						],
						[
							-82.8106887995214,
							27.981884066388677
						],
						[
							-82.81067074563155,
							27.981872492114338
						],
						[
							-82.81063463605356,
							27.981847263433327
						],
						[
							-82.81061348489878,
							27.981830866094906
						],
						[
							-82.81058045010273,
							27.981802525759853
						],
						[
							-82.81056355094243,
							27.981786721074467
						],
						[
							-82.81052699080398,
							27.98174946126359
						],
						[
							-82.81050714816256,
							27.981726846012226
						],
						[
							-82.81047525550542,
							27.98168612021438
						],
						[
							-82.81046043018188,
							27.981665215473686
						],
						[
							-82.81043785000423,
							27.981629935969924
						],
						[
							-82.81042425855058,
							27.981606114728056
						],
						[
							-82.81040538897552,
							27.98156875059529
						],
						[
							-82.81039523383136,
							27.981546111062908
						],
						[
							-82.81038008385255,
							27.98150769472382
						],
						[
							-82.81037191890783,
							27.981483759267537
						],
						[
							-82.810365820605,
							27.981461604469718
						],
						[
							-82.81036092469598,
							27.981444170212836
						],
						[
							-82.81035412402281,
							27.9814171105124
						],
						[
							-82.81034684131299,
							27.981377601496963
						],
						[
							-82.81034332046724,
							27.981351275642755
						],
						[
							-82.81033991833186,
							27.98131072611209
						],
						[
							-82.81033904688904,
							27.98128189474706
						],
						[
							-82.81034012697467,
							27.981235474442126
						],
						[
							-82.8103422565693,
							27.98120734544735
						],
						[
							-82.81034848257558,
							27.981159024874916
						],
						[
							-82.81035189550276,
							27.98113503456047
						],
						[
							-82.81035229480185,
							27.981126114185276
						],
						[
							-82.81035173902075,
							27.98111680440353
						],
						[
							-82.81034914897336,
							27.981100112087557
						],
						[
							-82.81034450037781,
							27.981077442877048
						],
						[
							-82.81031181451846,
							27.980912381311743
						],
						[
							-82.81030946728805,
							27.980898679241154
						],
						[
							-82.81029928786204,
							27.980828448486076
						],
						[
							-82.81026332127605,
							27.98057825799695
						],
						[
							-82.81022937636607,
							27.98034267789344
						],
						[
							-82.81019537479891,
							27.980107026743287
						],
						[
							-82.81016139661402,
							27.97987121461471
						],
						[
							-82.8101276873263,
							27.979635567961406
						],
						[
							-82.81009176930388,
							27.97938636492773
						],
						[
							-82.81005782709173,
							27.97915144852389
						],
						[
							-82.81005532427848,
							27.97912493830889
						],
						[
							-82.81004527615357,
							27.978900572751115
						],
						[
							-82.81003449957767,
							27.97866312745391
						],
						[
							-82.81002376526992,
							27.97842584043703
						],
						[
							-82.8100125938916,
							27.97817461213025
						],
						[
							-82.81000182271165,
							27.977937546346716
						],
						[
							-82.8099910848067,
							27.977699902299165
						],
						[
							-82.8099799053345,
							27.9774481982508
						],
						[
							-82.80997968679918,
							27.977431210057905
						],
						[
							-82.80998410696697,
							27.977193613674093
						],
						[
							-82.80998444511204,
							27.977184224752097
						],
						[
							-82.80999638181343,
							27.976961009427118
						],
						[
							-82.81000836527947,
							27.97673739300485
						],
						[
							-82.81002115813531,
							27.97650056913891
						],
						[
							-82.8100336164433,
							27.976263671528404
						],
						[
							-82.81004560260736,
							27.976040008341233
						],
						[
							-82.81005754020813,
							27.97581678672085
						],
						[
							-82.81007033306398,
							27.97557876136089
						],
						[
							-82.81007292311136,
							27.97555326018532
						],
						[
							-82.81011038437025,
							27.975303257654463
						],
						[
							-82.8101454795135,
							27.975067060615647
						],
						[
							-82.810178878535,
							27.974845750954206
						],
						[
							-82.81021185217712,
							27.974624351360614
						],
						[
							-82.81026382039983,
							27.97427635600311
						],
						[
							-82.81031941109187,
							27.97390507000436
						],
						[
							-82.8103226072822,
							27.973882433169553
						],
						[
							-82.8103231531707,
							27.973872100858546
						],
						[
							-82.81032272329475,
							27.973863635540503
						],
						[
							-82.81031779770795,
							27.973830740139253
						],
						[
							-82.81031216525416,
							27.973787403609332
						],
						[
							-82.81031004375342,
							27.973760374485682
						],
						[
							-82.81030875682364,
							27.97371448478049
						],
						[
							-82.81030967952796,
							27.97368338082872
						],
						[
							-82.81031367161853,
							27.973637802289023
						],
						[
							-82.81031748654264,
							27.97361045210717
						],
						[
							-82.81032522071195,
							27.9735701813663
						],
						[
							-82.81033128663908,
							27.973545130751024
						],
						[
							-82.81034280335706,
							27.973505868149854
						],
						[
							-82.8103516302028,
							27.973480520758645
						],
						[
							-82.81036712552145,
							27.973442267196727
						],
						[
							-82.81037745873145,
							27.97341977874989
						],
						[
							-82.8103966889343,
							27.97338253422758
						],
						[
							-82.81040896737818,
							27.973361201409755
						],
						[
							-82.81043164558166,
							27.973325655706663
						],
						[
							-82.81044620740408,
							27.97330502705783
						],
						[
							-82.81047229044087,
							27.973271524614166
						],
						[
							-82.81048742513127,
							27.97325373062868
						],
						[
							-82.81051662162093,
							27.973222272343993
						],
						[
							-82.81053392637527,
							27.973205233788537
						],
						[
							-82.81056623811656,
							27.973176163204375
						],
						[
							-82.81058738567422,
							27.97315898795222
						],
						[
							-82.8106304973736,
							27.973127447829352
						],
						[
							-82.81065096684237,
							27.973113859073454
						],
						[
							-82.81069725404772,
							27.973086080814472
						],
						[
							-82.81072136397209,
							27.973073225905512
						],
						[
							-82.81076212394447,
							27.97305407664165
						],
						[
							-82.81078045662393,
							27.97304627682148
						],
						[
							-82.8108224504662,
							27.97303021403074
						],
						[
							-82.8108423524627,
							27.973023477209505
						],
						[
							-82.81088625646474,
							27.973010498193776
						],
						[
							-82.81090812617798,
							27.973005015027145
						],
						[
							-82.81095264081972,
							27.972995813164584
						],
						[
							-82.81097332702501,
							27.97299236966008
						],
						[
							-82.81101883361906,
							27.972986600509234
						],
						[
							-82.8110390458815,
							27.972984807261373
						],
						[
							-82.81108486903699,
							27.972982474420252
						],
						[
							-82.81110710027757,
							27.97298225948232
						],
						[
							-82.81113504760896,
							27.972983141717226
						],
						[
							-82.81116550764611,
							27.97298004265311
						],
						[
							-82.81119661069833,
							27.972978683777786
						],
						[
							-82.81122766248961,
							27.972980917693594
						],
						[
							-82.81125825112986,
							27.97298671292491
						],
						[
							-82.81130223067493,
							27.972997708035866
						],
						[
							-82.81132165513128,
							27.97300334588552
						],
						[
							-82.81135358286195,
							27.973013924610616
						],
						[
							-82.81138860695847,
							27.973028361427335
						],
						[
							-82.81142122806642,
							27.973047623106698
						],
						[
							-82.81144905668734,
							27.973055663944915
						],
						[
							-82.81148291346375,
							27.973070693414673
						],
						[
							-82.81152213109884,
							27.97309143357928
						],
						[
							-82.81154264193648,
							27.97310346740726
						],
						[
							-82.81157999887404,
							27.973127657371425
						],
						[
							-82.81159925425798,
							27.97314135854247
						],
						[
							-82.81163382599554,
							27.97316831572029
						],
						[
							-82.81165092660403,
							27.973182831677082
						],
						[
							-82.81168275450995,
							27.97321221162853
						],
						[
							-82.81169892521925,
							27.973228464176106
						],
						[
							-82.811727672048,
							27.97325992425936
						],
						[
							-82.81174448757127,
							27.97328023724585
						],
						[
							-82.81177011015525,
							27.97331446634185
						],
						[
							-82.81178284275653,
							27.97333304273774
						],
						[
							-82.81180513245292,
							27.97336866758126
						],
						[
							-82.81181768429065,
							27.973391026525643
						],
						[
							-82.81183621302233,
							27.97342804891542
						],
						[
							-82.81184518286045,
							27.973447945516053
						],
						[
							-82.81185499716156,
							27.973472298257388
						],
						[
							-82.81186139853565,
							27.973489925868403
						],
						[
							-82.81187408347301,
							27.97352904457792
						],
						[
							-82.81188161169773,
							27.97355744696627
						],
						[
							-82.81188994841278,
							27.97359762237949
						],
						[
							-82.81189381190026,
							27.973621638774052
						],
						[
							-82.81189847128789,
							27.973662179311916
						],
						[
							-82.81190020607976,
							27.973689045658393
						],
						[
							-82.81190080322982,
							27.973729954917662
						],
						[
							-82.81189987782749,
							27.973756564058153
						],
						[
							-82.81189645500768,
							27.973797153159477
						],
						[
							-82.81189330378342,
							27.973821368304034
						],
						[
							-82.81188619824007,
							27.973861635448145
						],
						[
							-82.81187948030444,
							27.97389039756545
						],
						[
							-82.81186801125055,
							27.973929660166448
						],
						[
							-82.81186070605776,
							27.97395123670078
						],
						[
							-82.81184579619791,
							27.97398983110561
						],
						[
							-82.81183551964497,
							27.974013102861687
						],
						[
							-82.81182054503392,
							27.97404310154629
						],
						[
							-82.81180970370687,
							27.97406273284732
						],
						[
							-82.81178738163486,
							27.97409945936035
						],
						[
							-82.81177485138105,
							27.974120796674487
						],
						[
							-82.8117704707833,
							27.974130308803886
						],
						[
							-82.81176714688917,
							27.974139743591234
						],
						[
							-82.81176157828698,
							27.974162991065402
						],
						[
							-82.81172120592258,
							27.974376829159656
						],
						[
							-82.81168403244645,
							27.974587264219437
						],
						[
							-82.8116496576606,
							27.974797816190847
						],
						[
							-82.81161800871962,
							27.975009296262346
						],
						[
							-82.81158876726396,
							27.97522060816117
						],
						[
							-82.81156259969087,
							27.975432011790705
						],
						[
							-82.81153862376544,
							27.975643428909894
						],
						[
							-82.81151858956866,
							27.9758566905387
						],
						[
							-82.81149996101209,
							27.976069721940995
						],
						[
							-82.81148416621942,
							27.976282822591184
						],
						[
							-82.81148186665301,
							27.976317874566195
						],
						[
							-82.81148157257456,
							27.976332502938664
						],
						[
							-82.81148243412512,
							27.976342523184808
						],
						[
							-82.81148421837992,
							27.97635285009942
						],
						[
							-82.81148597385658,
							27.97635903113981
						],
						[
							-82.81149250563259,
							27.976374904173543
						],
						[
							-82.81150075241565,
							27.97639000738769
						],
						[
							-82.81150700360296,
							27.976398817146123
						],
						[
							-82.81151565598017,
							27.97640916204777
						],
						[
							-82.81152616455819,
							27.976419475472728
						],
						[
							-82.81153269993132,
							27.976424996410568
						],
						[
							-82.81155614255862,
							27.976442006187444
						],
						[
							-82.811581995369,
							27.976460768743042
						],
						[
							-82.81159583233782,
							27.976471512943238
						],
						[
							-82.81160735175364,
							27.976481073635924
						],
						[
							-82.81161670740083,
							27.97647355530383
						],
						[
							-82.8116402318664,
							27.97645664715002
						],
						[
							-82.81167925344934,
							27.976431663084714
						],
						[
							-82.81168450908704,
							27.976428382358268
						],
						[
							-82.81171325861372,
							27.97641089324269
						],
						[
							-82.81172829887538,
							27.976399610348427
						],
						[
							-82.81174190831564,
							27.976387161932973
						],
						[
							-82.81175081879819,
							27.97637727298802
						],
						[
							-82.81175725794394,
							27.97636872942856
						],
						[
							-82.81176585096597,
							27.976354302504728
						],
						[
							-82.81177290794597,
							27.976338344035337
						],
						[
							-82.81177592876882,
							27.97632819698485
						],
						[
							-82.81178494177404,
							27.976224506953532
						],
						[
							-82.81180256938521,
							27.975999966027945
						],
						[
							-82.81182322051694,
							27.975773348567504
						],
						[
							-82.81184735202503,
							27.975546366881968
						],
						[
							-82.81187428312238,
							27.975320221565806
						],
						[
							-82.81190442929629,
							27.97509388919074
						],
						[
							-82.8119376520508,
							27.974868421963453
						],
						[
							-82.81197372745434,
							27.97464314539237
						],
						[
							-82.81201316542342,
							27.97441668441404
						],
						[
							-82.81201665749086,
							27.974391315439032
						],
						[
							-82.81201695606579,
							27.974382884294716
						],
						[
							-82.81201637060718,
							27.974374332641464
						],
						[
							-82.81201257456877,
							27.974351713793514
						],
						[
							-82.81200591329056,
							27.974310190296695
						],
						[
							-82.81200307952695,
							27.974285002085356
						],
						[
							-82.81200061898184,
							27.974247199083738
						],
						[
							-82.81200017561615,
							27.974221397534752
						],
						[
							-82.81200142117704,
							27.974180821024067
						],
						[
							-82.81200329446487,
							27.97415629921051
						],
						[
							-82.81200826681639,
							27.97411570021683
						],
						[
							-82.81201327604009,
							27.974087392257122
						],
						[
							-82.81202256243938,
							27.974047456063925
						],
						[
							-82.81202869491639,
							27.97402537860744
						],
						[
							-82.81204142212147,
							27.973986109710683
						],
						[
							-82.81205211416108,
							27.97395841688736
						],
						[
							-82.81206920667567,
							27.973920497873298
						],
						[
							-82.81207888967603,
							27.973901131873117
						],
						[
							-82.81209904348275,
							27.973864569036625
						],
						[
							-82.81211377617612,
							27.973840837727085
						],
						[
							-82.81213800750889,
							27.97380597011251
						],
						[
							-82.81215212146884,
							27.973787426991695
						],
						[
							-82.81217913080734,
							27.973754949775227
						],
						[
							-82.81219660463452,
							27.97373587875224
						],
						[
							-82.81223288238581,
							27.97369990856914
						],
						[
							-82.81225261980632,
							27.973682175737405
						],
						[
							-82.81229265132771,
							27.973649622078618
						],
						[
							-82.81231400213221,
							27.973633935204237
						],
						[
							-82.8123507052627,
							27.97360965171062
						],
						[
							-82.8123694795093,
							27.973598299568998
						],
						[
							-82.81240862519866,
							27.97357675271225
						],
						[
							-82.81242816836583,
							27.973567004061653
						],
						[
							-82.81246927187914,
							27.97354854008091
						],
						[
							-82.81249008398957,
							27.973540211459742
						],
						[
							-82.81253271455158,
							27.97352517569475
						],
						[
							-82.81255352486346,
							27.973518767125785
						],
						[
							-82.81259744055694,
							27.973507162274487
						],
						[
							-82.81261604932817,
							27.973502942655518
						],
						[
							-82.81266090661175,
							27.97349442697527
						],
						[
							-82.8126834580109,
							27.973491125563857
						],
						[
							-82.81272926497854,
							27.97348638523768
						],
						[
							-82.81274937291954,
							27.973485061435458
						],
						[
							-82.81279520416882,
							27.97348375921739
						],
						[
							-82.81281742821498,
							27.973484043403047
						],
						[
							-82.8128632882425,
							27.97348652283375
						],
						[
							-82.81287890496952,
							27.97348782235424
						],
						[
							-82.8129108327002,
							27.973491416944466
						],
						[
							-82.81292977422082,
							27.973494232721766
						],
						[
							-82.81297475651,
							27.97350256134276
						],
						[
							-82.8129937654797,
							27.973506796250472
						],
						[
							-82.8130375624628,
							27.973518225734143
						],
						[
							-82.81305971276412,
							27.97352503540022
						],
						[
							-82.8131025699556,
							27.973540252828247
						],
						[
							-82.81312056089278,
							27.97354737815702
						],
						[
							-82.81316159875558,
							27.97356535830239
						],
						[
							-82.81318437768321,
							27.973576645693147
						],
						[
							-82.81322355754683,
							27.97359841827937
						],
						[
							-82.81324091805924,
							27.97360893854847
						],
						[
							-82.8132776472703,
							27.97363313121021
						],
						[
							-82.81329730734892,
							27.97364738996119
						],
						[
							-82.81333159040435,
							27.9736746915794
						],
						[
							-82.81334742926371,
							27.97368833969013
						],
						[
							-82.81337896668866,
							27.97371772233969
						],
						[
							-82.8133972121339,
							27.97373645162022
						],
						[
							-82.81342562711289,
							27.973768600583885
						],
						[
							-82.81344084633957,
							27.97378746296452
						],
						[
							-82.81346840426458,
							27.973824947606047
						],
						[
							-82.81348373410775,
							27.973848231053392
						],
						[
							-82.81350695100522,
							27.97388780302096
						],
						[
							-82.81351942370267,
							27.973911727685348
						],
						[
							-82.81353674554406,
							27.973949443452387
						],
						[
							-82.81354545098132,
							27.97397075018974
						],
						[
							-82.81355939227157,
							27.974009518163992
						],
						[
							-82.81356748886759,
							27.97403632875241
						],
						[
							-82.81357737511479,
							27.97407649607148
						],
						[
							-82.81358236455343,
							27.97410200354228
						],
						[
							-82.8135882326297,
							27.974142194243715
						],
						[
							-82.81359078580486,
							27.974168941879288
						],
						[
							-82.81359264200556,
							27.974209843045475
						],
						[
							-82.81359253588556,
							27.97423644589038
						],
						[
							-82.8135903712174,
							27.974277027796926
						],
						[
							-82.81358768044578,
							27.97430326191971
						],
						[
							-82.8135814985062,
							27.974343868108168
						],
						[
							-82.81357573205337,
							27.974371756983736
						],
						[
							-82.81356321439011,
							27.974419448030933
						],
						[
							-82.81355382906541,
							27.97444842958249
						],
						[
							-82.8135357374041,
							27.97449512148297
						],
						[
							-82.813523418491,
							27.974522337665523
						],
						[
							-82.81350418648941,
							27.974559238646993
						],
						[
							-82.81349469594409,
							27.974575964238216
						],
						[
							-82.81348355244471,
							27.974594068489825
						],
						[
							-82.81347287389502,
							27.974612206016683
						],
						[
							-82.81346816324627,
							27.974622349469872
						],
						[
							-82.81346473952709,
							27.974631971316303
						],
						[
							-82.81346244355808,
							27.97464126311137
						],
						[
							-82.8134282306501,
							27.974833337612207
						],
						[
							-82.8133942272842,
							27.975042858960922
						],
						[
							-82.81336319617763,
							27.97525370321178
						],
						[
							-82.81333470385704,
							27.97546440986675
						],
						[
							-82.81331005973544,
							27.97567546725698
						],
						[
							-82.8132872520295,
							27.975887153273607
						],
						[
							-82.81326787074039,
							27.976098638741504
						],
						[
							-82.8132510489217,
							27.97631202807402
						],
						[
							-82.813248547008,
							27.976344454028737
						],
						[
							-82.81324826821822,
							27.97635993585771
						],
						[
							-82.81324897688395,
							27.97636927171975
						],
						[
							-82.81325053450972,
							27.97637779369523
						],
						[
							-82.81325371810959,
							27.97638895248308
						],
						[
							-82.81325791614493,
							27.976400044720965
						],
						[
							-82.81326236958743,
							27.97640893361983
						],
						[
							-82.81326854703053,
							27.976418769505
						],
						[
							-82.81327568944617,
							27.976428085581976
						],
						[
							-82.8132898007081,
							27.976443178903413
						],
						[
							-82.81330650831282,
							27.976457465533247
						],
						[
							-82.81332099189409,
							27.976467707012556
						],
						[
							-82.81335419396416,
							27.97649203187486
						],
						[
							-82.8133718944203,
							27.97650619619684
						],
						[
							-82.81337776069789,
							27.97651130974181
						],
						[
							-82.81339617701427,
							27.976496649893182
						],
						[
							-82.81341845771759,
							27.976480693222708
						],
						[
							-82.81345764837293,
							27.97645553648717
						],
						[
							-82.81346420443059,
							27.976451458961474
						],
						[
							-82.81349258433595,
							27.97643436734624
						],
						[
							-82.81350774060996,
							27.976423008908853
						],
						[
							-82.81352161624953,
							27.97641023314014
						],
						[
							-82.81353060047667,
							27.976400129257076
						],
						[
							-82.81353699825365,
							27.97639164055649
						],
						[
							-82.81354500311895,
							27.976377981653506
						],
						[
							-82.8135523289962,
							27.976360693087013
						],
						[
							-82.8135585864789,
							27.976324343389898
						],
						[
							-82.81356399320303,
							27.97624925899324
						],
						[
							-82.81358305253484,
							27.976022047081376
						],
						[
							-82.81360559494082,
							27.975794429575377
						],
						[
							-82.81362053178042,
							27.97566031098306
						],
						[
							-82.81362155880616,
							27.975645689805543
						],
						[
							-82.81362116760097,
							27.975637647168764
						],
						[
							-82.81361863061345,
							27.97561787917086
						],
						[
							-82.8136154281277,
							27.97560446758151
						],
						[
							-82.8136059699579,
							27.97556398100333
						],
						[
							-82.81360112800813,
							27.975537222575678
						],
						[
							-82.8135958849608,
							27.97549668473575
						],
						[
							-82.81359377694997,
							27.975470168225872
						],
						[
							-82.81359255027468,
							27.975429261663823
						],
						[
							-82.81359320408181,
							27.97540073157176
						],
						[
							-82.81359628875629,
							27.97536014426935
						],
						[
							-82.81359898492376,
							27.975337439985385
						],
						[
							-82.81360550860579,
							27.97529717553939
						],
						[
							-82.81361160510983,
							27.975269105001136
						],
						[
							-82.81362244283963,
							27.975229502455896
						],
						[
							-82.81362885680419,
							27.975209239831603
						],
						[
							-82.81363798402361,
							27.975183916721775
						],
						[
							-82.81364553293267,
							27.97516519643405
						],
						[
							-82.81366288715002,
							27.97512641586987
						],
						[
							-82.81367514580846,
							27.975102335623273
						],
						[
							-82.81369593183852,
							27.975066111831307
						],
						[
							-82.81370838744857,
							27.975046425672115
						],
						[
							-82.81373261878133,
							27.975011558956734
						],
						[
							-82.81374777685409,
							27.97499176577826
						],
						[
							-82.81377541302025,
							27.974958939625086
						],
						[
							-82.81379311977162,
							27.974939857809847
						],
						[
							-82.8138238747864,
							27.974909765595793
						],
						[
							-82.81383946003709,
							27.97489566242756
						],
						[
							-82.8138729903597,
							27.974867615271496
						],
						[
							-82.81389253172821,
							27.974852727894834
						],
						[
							-82.8139286008369,
							27.97482776001711
						],
						[
							-82.81394740206298,
							27.97481586108727
						],
						[
							-82.81398596139445,
							27.974793629846953
						],
						[
							-82.81400363127352,
							27.974784296682845
						],
						[
							-82.81404409716752,
							27.974764803877964
						],
						[
							-82.8140642042096,
							27.97475610563477
						],
						[
							-82.8140927549861,
							27.97474510692687
						],
						[
							-82.81411134756966,
							27.974738712747108
						],
						[
							-82.81415696388102,
							27.974724862288372
						],
						[
							-82.81417877873547,
							27.974719221740788
						],
						[
							-82.81422329157857,
							27.97470967543713
						],
						[
							-82.81424393731444,
							27.974706079948067
						],
						[
							-82.81428944121039,
							27.974699966356656
						],
						[
							-82.81431164457194,
							27.974697912305327
						],
						[
							-82.81435746952599,
							27.97469557856466
						],
						[
							-82.8143776817887,
							27.97469530696929
						],
						[
							-82.81442353192368,
							27.97469641043754
						],
						[
							-82.81444380444077,
							27.97469766319313
						],
						[
							-82.81448939017524,
							27.974702206567873
						],
						[
							-82.81450978410072,
							27.97470502953995
						],
						[
							-82.81455476639017,
							27.974713014619926
						],
						[
							-82.81457720807202,
							27.974717992367562
						],
						[
							-82.81462129823385,
							27.97472976449253
						],
						[
							-82.81464016241279,
							27.97473554803293
						],
						[
							-82.81468301870471,
							27.974750421919587
						],
						[
							-82.81470548197045,
							27.974759364778304
						],
						[
							-82.81474761610673,
							27.974778369251325
						],
						[
							-82.81476125612402,
							27.97478498826155
						],
						[
							-82.81480370592236,
							27.97480708370436
						],
						[
							-82.8148265945673,
							27.974820465616116
						],
						[
							-82.8148636619236,
							27.974844656479473
						],
						[
							-82.81488078321624,
							27.97485680542088
						],
						[
							-82.81491535315506,
							27.97488341725877
						],
						[
							-82.81493285755913,
							27.974898113979588
						],
						[
							-82.81496497954303,
							27.97492749123275
						],
						[
							-82.81498304242614,
							27.974945659336573
						],
						[
							-82.81501179285209,
							27.97497746386021
						],
						[
							-82.81502670810805,
							27.974995473683
						],
						[
							-82.81505237655756,
							27.975029359237983
						],
						[
							-82.81506616226471,
							27.97504936915313
						],
						[
							-82.81508840789449,
							27.975084992197555
						],
						[
							-82.81509994349807,
							27.97510538702294
						],
						[
							-82.81511881037494,
							27.97514240761433
						],
						[
							-82.81513034867663,
							27.975168332370362
						],
						[
							-82.81514520907399,
							27.97520709404903
						],
						[
							-82.8151531851608,
							27.975231247141
						],
						[
							-82.81516432955954,
							27.975271234595418
						],
						[
							-82.81517006993198,
							27.975296450685786
						],
						[
							-82.81517785266493,
							27.975340239574923
						],
						[
							-82.81518139689295,
							27.975369181556534
						],
						[
							-82.8151841731003,
							27.975410077326327
						],
						[
							-82.81518466592848,
							27.97543661002432
						],
						[
							-82.8151834230656,
							27.975477186535006
						],
						[
							-82.8151813105581,
							27.97550360951543
						],
						[
							-82.8151760477258,
							27.975544209408483
						],
						[
							-82.81517169320824,
							27.97556880406741
						],
						[
							-82.81516269998785,
							27.975608738462046
						],
						[
							-82.81515526889017,
							27.975635312528727
						],
						[
							-82.81514220264022,
							27.975674238783302
						],
						[
							-82.81513357634338,
							27.975696595029756
						],
						[
							-82.81511682467186,
							27.975734856685467
						],
						[
							-82.81510710479931,
							27.975754784762255
						],
						[
							-82.81509835259762,
							27.975771003135566
						],
						[
							-82.81508609393897,
							27.975796194944383
						],
						[
							-82.81508270709217,
							27.975806763776593
						],
						[
							-82.81507859449249,
							27.975829560690993
						],
						[
							-82.8150684177645,
							27.97592092281597
						],
						[
							-82.8150471568924,
							27.976132069239338
						],
						[
							-82.81502951758995,
							27.976339865688185
						],
						[
							-82.81502671620196,
							27.976377208236794
						],
						[
							-82.81502646439172,
							27.976386423589542
						],
						[
							-82.81503006257907,
							27.97641528373244
						],
						[
							-82.81505465094278,
							27.976449432788645
						],
						[
							-82.81506985308233,
							27.97647304808574
						],
						[
							-82.8150973786317,
							27.976492554380986
						],
						[
							-82.81512816961934,
							27.976523345368168
						],
						[
							-82.81516190768545,
							27.97654375278366
						],
						[
							-82.81519210332185,
							27.97656911006793
						],
						[
							-82.81521803527248,
							27.976598812875967
						],
						[
							-82.81526562829337,
							27.976661830169217
						],
						[
							-82.81527519348265,
							27.976675337986126
						],
						[
							-82.81527910654809,
							27.97668123943186
						],
						[
							-82.81528999999972,
							27.976668000000263
						],
						[
							-82.8153519999996,
							27.976567000000433
						],
						[
							-82.81541299999968,
							27.976403000000364
						],
						[
							-82.81546499999972,
							27.976081000000367
						],
						[
							-82.81556199999976,
							27.975805000000268
						],
						[
							-82.81574399999971,
							27.975024000000307
						],
						[
							-82.81578499999982,
							27.974806000000388
						],
						[
							-82.81581299999974,
							27.974768000000264
						],
						[
							-82.8158609999998,
							27.974772000000417
						],
						[
							-82.81592399999968,
							27.97481000000001
						],
						[
							-82.81688499999989,
							27.97551700000024
						],
						[
							-82.81698199999974,
							27.975547999999964
						],
						[
							-82.81700599999968,
							27.975538000000203
						],
						[
							-82.81743899999962,
							27.975099000000295
						],
						[
							-82.81758099999983,
							27.974915000000347
						],
						[
							-82.81761199999983,
							27.974860000000415
						],
						[
							-82.81762199999967,
							27.974784000000344
						],
						[
							-82.81760199999961,
							27.974730000000317
						],
						[
							-82.81709599999976,
							27.97433500000032
						],
						[
							-82.81648599999964,
							27.973899000000305
						],
						[
							-82.8154229999999,
							27.97303100000043
						],
						[
							-82.8150009999997,
							27.9727890000003
						],
						[
							-82.81469599999996,
							27.972664000000087
						],
						[
							-82.81398999999999,
							27.972034000000363
						],
						[
							-82.81364699999993,
							27.971754000000107
						],
						[
							-82.81321099999974,
							27.971498000000242
						],
						[
							-82.8127669999996,
							27.97107600000032
						],
						[
							-82.81249699999982,
							27.970854000000248
						],
						[
							-82.8121639999998,
							27.97066000000036
						],
						[
							-82.81196299999986,
							27.97051100000029
						],
						[
							-82.8117659999999,
							27.970300000000243
						],
						[
							-82.81131099999992,
							27.969963000000245
						],
						[
							-82.81029099999972,
							27.969435000000257
						],
						[
							-82.80986899999982,
							27.969138000000374
						],
						[
							-82.80935999999978,
							27.96881600000002
						],
						[
							-82.80931099999991,
							27.9687850000003
						],
						[
							-82.80826299999988,
							27.968326000000335
						],
						[
							-82.80787199999969,
							27.968181000000417
						],
						[
							-82.80760899999996,
							27.96797300000026
						],
						[
							-82.8072659999999,
							27.967665000000355
						],
						[
							-82.80704299999984,
							27.967442000000027
						],
						[
							-82.80690099999964,
							27.967380000000222
						],
						[
							-82.80685899999962,
							27.967321000000318
						],
						[
							-82.80686999999965,
							27.967248000000314
						],
						[
							-82.80692399999985,
							27.967158000000328
						],
						[
							-82.80701199999984,
							27.966982000000332
						],
						[
							-82.80709499999988,
							27.96688800000037
						],
						[
							-82.80712299999998,
							27.96687500000036
						],
						[
							-82.80719199999974,
							27.96684300000038
						],
						[
							-82.80732299999964,
							27.966833000000083
						],
						[
							-82.80742199999985,
							27.96685900000028
						],
						[
							-82.8077229999997,
							27.967001000000305
						],
						[
							-82.80832899999984,
							27.96731200000028
						],
						[
							-82.80908599999985,
							27.967660000000297
						],
						[
							-82.80953299999999,
							27.967878000000216
						],
						[
							-82.80996599999975,
							27.968027000000287
						],
						[
							-82.81030499999973,
							27.96811700000045
						],
						[
							-82.81078099999995,
							27.968413000000073
						],
						[
							-82.8114909999998,
							27.968804000000276
						],
						[
							-82.81208499999984,
							27.96940100000029
						],
						[
							-82.81249699999982,
							27.969851000000393
						],
						[
							-82.81310499999995,
							27.97038000000011
						],
						[
							-82.81451299999992,
							27.97144800000037
						],
						[
							-82.81601399999977,
							27.97259100000026
						],
						[
							-82.81669299999963,
							27.973055000000283
						],
						[
							-82.81729199999981,
							27.97348800000005
						],
						[
							-82.8177629999997,
							27.97379900000038
						],
						[
							-82.81941599999969,
							27.975200000000303
						],
						[
							-82.82000499999975,
							27.975622000000225
						],
						[
							-82.82137799999985,
							27.976525000000333
						],
						[
							-82.82142099999986,
							27.976552999999985
						],
						[
							-82.82187099999969,
							27.976747000000227
						],
						[
							-82.82233499999971,
							27.976892000000323
						],
						[
							-82.82273699999968,
							27.976989000000355
						],
						[
							-82.82311799999967,
							27.977065000000426
						],
						[
							-82.82331199999965,
							27.977121000000086
						],
						[
							-82.8233899999996,
							27.977200000000227
						],
						[
							-82.82345099999968,
							27.977288000000225
						],
						[
							-82.82347999999978,
							27.977449000000224
						],
						[
							-82.82347299999972,
							27.97760500000034
						],
						[
							-82.82346799999958,
							27.977650000000335
						],
						[
							-82.82346699999958,
							27.97768800000028
						],
						[
							-82.82345699999982,
							27.977830000000306
						],
						[
							-82.82343599999977,
							27.977898000000426
						],
						[
							-82.82336099999998,
							27.977906000000377
						],
						[
							-82.82221599999991,
							27.97771100000023
						],
						[
							-82.82143999999965,
							27.977405000000314
						],
						[
							-82.82086799999966,
							27.977145000000295
						],
						[
							-82.82045399999969,
							27.976815000000347
						],
						[
							-82.81986599999998,
							27.97640700000034
						],
						[
							-82.81927899999981,
							27.975914000000227
						],
						[
							-82.81836299999996,
							27.97531600000031
						],
						[
							-82.81829399999985,
							27.97526200000028
						],
						[
							-82.81823499999976,
							27.975245000000296
						],
						[
							-82.81816199999967,
							27.975237000000345
						],
						[
							-82.81809299999973,
							27.97526200000028
						],
						[
							-82.81794999999981,
							27.975364000000372
						],
						[
							-82.81760138715357,
							27.97569087456548
						],
						[
							-82.81763391551607,
							27.97571303913308
						],
						[
							-82.817649979206,
							27.975724876908817
						],
						[
							-82.81769394706025,
							27.975759859636288
						],
						[
							-82.81801270995491,
							27.976013480140086
						],
						[
							-82.81810969823844,
							27.976084440245433
						],
						[
							-82.8184028907098,
							27.976298955528836
						],
						[
							-82.81851664685263,
							27.97638152947918
						],
						[
							-82.8185333671511,
							27.976393990586526
						],
						[
							-82.81867999999992,
							27.976244000000534
						],
						[
							-82.81878399999981,
							27.976208000000394
						],
						[
							-82.81883899999976,
							27.976201000000525
						],
						[
							-82.81898499999964,
							27.97622200000031
						],
						[
							-82.81932299999981,
							27.976436000000252
						],
						[
							-82.81997899999973,
							27.97693900000048
						],
						[
							-82.8200429999997,
							27.977041000000394
						],
						[
							-82.8200689999998,
							27.977083000000317
						],
						[
							-82.8200689999998,
							27.977242000000327
						],
						[
							-82.81990759343188,
							27.97743070846749
						],
						[
							-82.8201242569258,
							27.977596927228735
						],
						[
							-82.82035963827894,
							27.97777348662606
						],
						[
							-82.82059617616049,
							27.977951216940614
						],
						[
							-82.82083285523558,
							27.97812883214245
						],
						[
							-82.82106903428763,
							27.978305863683875
						],
						[
							-82.82119407782129,
							27.978399716031458
						],
						[
							-82.82120063387895,
							27.97840479630135
						],
						[
							-82.82122026158214,
							27.97842049396745
						],
						[
							-82.8212326506425,
							27.978431030424492
						],
						[
							-82.82126477262668,
							27.978460061439062
						],
						[
							-82.82128103866408,
							27.978476063075522
						],
						[
							-82.82131041861554,
							27.978507517762914
						],
						[
							-82.82132660461342,
							27.978526540222607
						],
						[
							-82.82135256354397,
							27.978560078639095
						],
						[
							-82.8213670642122,
							27.97858074326058
						],
						[
							-82.8213896506848,
							27.978616363607607
						],
						[
							-82.82140216744888,
							27.978638315158936
						],
						[
							-82.82142103702375,
							27.978675333052042
						],
						[
							-82.8214319359075,
							27.978699603955373
						],
						[
							-82.82144709218169,
							27.97873836383548
						],
						[
							-82.82145496304814,
							27.978761543860845
						],
						[
							-82.82146639702812,
							27.97880101240661
						],
						[
							-82.82147256637751,
							27.978827091846018
						],
						[
							-82.82147998668358,
							27.97886727265528
						],
						[
							-82.82148333036285,
							27.978891465317194
						],
						[
							-82.82148707334096,
							27.978932011250738
						],
						[
							-82.8214872029421,
							27.978940287588575
						],
						[
							-82.8222609999999,
							27.979563000000343
						],
						[
							-82.82235799999975,
							27.97968100000016
						],
						[
							-82.82235799999975,
							27.97977800000037
						],
						[
							-82.82230199999992,
							27.97986100000031
						],
						[
							-82.82178999999984,
							27.98039800000051
						],
						[
							-82.82174099999969,
							27.98044900000047
						],
						[
							-82.82160299999964,
							27.980505000000125
						],
						[
							-82.82153999999984,
							27.980511999999994
						],
						[
							-82.82148499999983,
							27.980505000000125
						],
						[
							-82.82139499999974,
							27.98044900000047
						],
						[
							-82.82130499999975,
							27.980373000000395
						],
						[
							-82.82111099999997,
							27.980027000000366
						],
						[
							-82.82102099999962,
							27.979903000000053
						],
						[
							-82.82083399999986,
							27.979709000000344
						],
						[
							-82.8208162223478,
							27.979699682287702
						],
						[
							-82.82079564488735,
							27.979702487412897
						],
						[
							-82.82075012480365,
							27.979706885097603
						],
						[
							-82.82072985858153,
							27.979708075800072
						],
						[
							-82.82068431331673,
							27.9797090344773
						],
						[
							-82.8206620766802,
							27.979708585715564
						],
						[
							-82.82061621125683,
							27.979705766340963
						],
						[
							-82.82059578765332,
							27.979703728477396
						],
						[
							-82.82055052567506,
							27.97969746559882
						],
						[
							-82.82052991231488,
							27.97969379276736
						],
						[
							-82.82048549659844,
							27.979684087284188
						],
						[
							-82.8204668563506,
							27.9796793118842
						],
						[
							-82.82042338582174,
							27.97966650733709
						],
						[
							-82.82040435526834,
							27.979660123050213
						],
						[
							-82.82037206870807,
							27.97964793813598
						],
						[
							-82.82035328906561,
							27.979640027699407
						],
						[
							-82.82033408314413,
							27.979630502080358
						],
						[
							-82.82031274223252,
							27.97962056727005
						],
						[
							-82.82029200746386,
							27.979610350072296
						],
						[
							-82.82025346701818,
							27.979585803977006
						],
						[
							-82.82023590146046,
							27.97957721635093
						],
						[
							-82.82019945463651,
							27.979552335707428
						],
						[
							-82.82018959177185,
							27.97954527153276
						],
						[
							-82.82000242397174,
							27.97940475606328
						],
						[
							-82.81979229558105,
							27.97924775871873
						],
						[
							-82.8195224764891,
							27.979530468692207
						],
						[
							-82.81970507213587,
							27.97959607873121
						],
						[
							-82.81996358135409,
							27.979689094709062
						],
						[
							-82.82013591483721,
							27.979751058896444
						],
						[
							-82.82030823303177,
							27.979813377416388
						],
						[
							-82.82032278406228,
							27.9798191222855
						],
						[
							-82.82035046699308,
							27.97983099063838
						],
						[
							-82.82036717549708,
							27.979838840820396
						],
						[
							-82.82040697769133,
							27.979859231148758
						],
						[
							-82.82042518266717,
							27.979869466332833
						],
						[
							-82.82046287325346,
							27.979892620277553
						],
						[
							-82.82048299468448,
							27.979906266590252
						],
						[
							-82.82051819324951,
							27.979932529491084
						],
						[
							-82.82053566707644,
							27.9799467396786
						],
						[
							-82.82056807774312,
							27.97997542715233
						],
						[
							-82.8205855164965,
							27.979992320017214
						],
						[
							-82.82061518692892,
							27.980023773805232
						],
						[
							-82.82063041065236,
							27.980041373537393
						],
						[
							-82.82065670592907,
							27.980074565714755
						],
						[
							-82.82067060315262,
							27.980093787823638
						],
						[
							-82.82069381555333,
							27.980129061032347
						],
						[
							-82.82070726761218,
							27.98015186604054
						],
						[
							-82.82072671904845,
							27.980188880336346
						],
						[
							-82.82073744885945,
							27.98021186161172
						],
						[
							-82.82075323016247,
							27.980250273454136
						],
						[
							-82.8207612143436,
							27.980272405769316
						],
						[
							-82.82077331921805,
							27.980311183635923
						],
						[
							-82.82078040137895,
							27.98033899427043
						],
						[
							-82.82078845300907,
							27.98037951502305
						],
						[
							-82.82079231110042,
							27.980405485644436
						],
						[
							-82.82079629599649,
							27.980445686238756
						],
						[
							-82.82079728255275,
							27.980485626928623
						],
						[
							-82.82079325179141,
							27.980567132484172
						],
						[
							-82.8207887416914,
							27.980604677380075
						],
						[
							-82.82078101021983,
							27.980644948121306
						],
						[
							-82.82077442628342,
							27.980671750615574
						],
						[
							-82.8207626226817,
							27.980711015015306
						],
						[
							-82.82074915263642,
							27.980746532839724
						],
						[
							-82.82071409796322,
							27.98082237896164
						],
						[
							-82.82069388030446,
							27.980858539800938
						],
						[
							-82.82066726576838,
							27.98089857941665
						],
						[
							-82.82065165173928,
							27.980919753054604
						],
						[
							-82.82062460013246,
							27.980952919151672
						],
						[
							-82.82061045649509,
							27.980968922587227
						],
						[
							-82.82058067634554,
							27.981000043625773
						],
						[
							-82.82056186252855,
							27.981017901463293
						],
						[
							-82.82052891766465,
							27.981046289462444
						],
						[
							-82.82051240161567,
							27.981059431255346
						],
						[
							-82.82047696832772,
							27.981085427957378
						],
						[
							-82.82045690085577,
							27.981098814365804
						],
						[
							-82.82041897464711,
							27.98112173088977
						],
						[
							-82.82039900430236,
							27.98113267563888
						],
						[
							-82.82035887835188,
							27.98115251108523
						],
						[
							-82.82034096655514,
							27.98116056811121
						],
						[
							-82.82029893134427,
							27.981177665122306
						],
						[
							-82.82027607147755,
							27.9811857860005
						],
						[
							-82.82022955944146,
							27.98119998809422
						],
						[
							-82.82020827338827,
							27.981205549501556
						],
						[
							-82.8201604753218,
							27.98121597624085
						],
						[
							-82.82013890957954,
							27.981219771380164
						],
						[
							-82.82009340208612,
							27.98122588766915
						],
						[
							-82.8200712005233,
							27.981227941720835
						],
						[
							-82.8200253746698,
							27.981230278159433
						],
						[
							-82.8200051570115,
							27.981230549754446
						],
						[
							-82.81995930417831,
							27.981229448084935
						],
						[
							-82.81994121341636,
							27.981228403972228
						],
						[
							-82.81989533630173,
							27.981224207735625
						],
						[
							-82.81987080459554,
							27.981220823586842
						],
						[
							-82.81982581780969,
							27.981212495864686
						],
						[
							-82.81980723601777,
							27.98120837427202
						],
						[
							-82.81976314495667,
							27.98119694658691
						],
						[
							-82.81974457575564,
							27.98119141575636
						],
						[
							-82.8197162579034,
							27.981181854164664
						],
						[
							-82.81949762282544,
							27.981105622233674
						],
						[
							-82.81932404288204,
							27.981043322599422
						],
						[
							-82.81915166353346,
							27.980981446545808
						],
						[
							-82.81894433293331,
							27.9809070986942
						],
						[
							-82.818903664692,
							27.98091090552443
						],
						[
							-82.81892495704034,
							27.980976519160198
						],
						[
							-82.81898942493989,
							27.981175182993848
						],
						[
							-82.81899693248016,
							27.981197213685608
						],
						[
							-82.81928309675013,
							27.981260473795647
						],
						[
							-82.81946322735541,
							27.98130062043064
						],
						[
							-82.8194963457883,
							27.981307897744326
						],
						[
							-82.81951411998882,
							27.981312442917634
						],
						[
							-82.81955792956211,
							27.981325246565728
						],
						[
							-82.81957733153556,
							27.981331725281603
						],
						[
							-82.81961956909407,
							27.981347631590232
						],
						[
							-82.81963931370926,
							27.981355977298353
						],
						[
							-82.8196797346371,
							27.981374989865877
						],
						[
							-82.81969902779262,
							27.981385033494025
						],
						[
							-82.81973763209008,
							27.981407151420182
						],
						[
							-82.81975575612692,
							27.981418512555326
						],
						[
							-82.819792156186,
							27.98144339409784
						],
						[
							-82.8198132920523,
							27.98145942001639
						],
						[
							-82.81984666499349,
							27.981487413213305
						],
						[
							-82.81986247237681,
							27.98150177538609
						],
						[
							-82.8198933928669,
							27.981532189557715
						],
						[
							-82.81991076686921,
							27.98155098089154
						],
						[
							-82.81994295900057,
							27.98158929560738
						],
						[
							-82.81996044631732,
							27.981612547578397
						],
						[
							-82.81998801143685,
							27.981653639400253
						],
						[
							-82.81999156555776,
							27.9816590776009
						],
						[
							-82.82001458910084,
							27.981695251031017
						],
						[
							-82.82002921027842,
							27.9817213052895
						],
						[
							-82.82004086189463,
							27.981748816449606
						],
						[
							-82.82004940005787,
							27.981777447265546
						],
						[
							-82.82005894546198,
							27.981817415834445
						],
						[
							-82.82006296633078,
							27.981837607412633
						],
						[
							-82.82007278243071,
							27.98186445037693
						],
						[
							-82.82008567601088,
							27.981911814070873
						],
						[
							-82.82008844951984,
							27.981931952589104
						],
						[
							-82.82009248387838,
							27.981972497623456
						],
						[
							-82.82009380138538,
							27.981997171422638
						],
						[
							-82.82009411075204,
							27.982038082481
						],
						[
							-82.82009299739126,
							27.98206468352699
						],
						[
							-82.8200892867885,
							27.982105274427056
						],
						[
							-82.82008551053542,
							27.98213187907034
						],
						[
							-82.82007863881569,
							27.98216745265247
						],
						[
							-82.82007453161195,
							27.982193522199697
						],
						[
							-82.82006704115881,
							27.98222613881133
						],
						[
							-82.82005543900526,
							27.982257528747315
						],
						[
							-82.82003991580778,
							27.982287175797286
						],
						[
							-82.82002072607433,
							27.98231459252857
						],
						[
							-82.82000722365346,
							27.982355444231747
						],
						[
							-82.81999055921625,
							27.98239498921983
						],
						[
							-82.81996783604642,
							27.98243139107807
						],
						[
							-82.81993962791167,
							27.982463730698118
						],
						[
							-82.81991887065992,
							27.982484016705126
						],
						[
							-82.81989616907389,
							27.982509288553562
						],
						[
							-82.81988003523678,
							27.98252577402557
						],
						[
							-82.81984831165204,
							27.982555530792933
						],
						[
							-82.81982888809505,
							27.982572094506178
						],
						[
							-82.8197944260748,
							27.982598771994663
						],
						[
							-82.81977879855604,
							27.98261000182897
						],
						[
							-82.81974180584369,
							27.9826346333601
						],
						[
							-82.81971819684173,
							27.982648672676294
						],
						[
							-82.81967865994726,
							27.982669536947316
						],
						[
							-82.81966608292872,
							27.982675761155132
						],
						[
							-82.81964200987665,
							27.982686904653878
						],
						[
							-82.81962686709237,
							27.982693361786307
						],
						[
							-82.81958487325011,
							27.982709771715367
						],
						[
							-82.81956363216317,
							27.982717067914923
						],
						[
							-82.81952001774265,
							27.982730047829666
						],
						[
							-82.8194992461017,
							27.982735341239465
						],
						[
							-82.81945439241552,
							27.98274489113989
						],
						[
							-82.81943418015298,
							27.98274839759653
						],
						[
							-82.81938871942438,
							27.98275451388587
						],
						[
							-82.81936646749936,
							27.982756573333237
						],
						[
							-82.81931912898652,
							27.982759535699945
						],
						[
							-82.81934993796057,
							27.982761942285453
						],
						[
							-82.81953436102974,
							27.982783845273854
						],
						[
							-82.81956737783929,
							27.98278543977172
						],
						[
							-82.8196012121328,
							27.98278922411878
						],
						[
							-82.81964640306477,
							27.98280131100707
						],
						[
							-82.81966667198463,
							27.982808666561812
						],
						[
							-82.81968554155952,
							27.982812771067348
						],
						[
							-82.81972675928652,
							27.98282525365742
						],
						[
							-82.81976546520758,
							27.982844136721777
						],
						[
							-82.81980067456433,
							27.98286893732548
						],
						[
							-82.81982373318122,
							27.982888107273954
						],
						[
							-82.81983782465801,
							27.982897551054645
						],
						[
							-82.81986715065023,
							27.98291541698596
						],
						[
							-82.81989418516957,
							27.98293424069548
						],
						[
							-82.81991872317114,
							27.9829562192263
						],
						[
							-82.81994039953008,
							27.982981025226042
						],
						[
							-82.81995843903063,
							27.983004407598703
						],
						[
							-82.81997764585121,
							27.983026214359192
						],
						[
							-82.81999335340976,
							27.983045817780653
						],
						[
							-82.82001526808898,
							27.983075941471572
						],
						[
							-82.82002999268865,
							27.983098463193127
						],
						[
							-82.82004882629035,
							27.983130668814407
						],
						[
							-82.82005932317736,
							27.983150461093334
						],
						[
							-82.82007506311152,
							27.983183371782975
						],
						[
							-82.82008549164964,
							27.983208316278155
						],
						[
							-82.82009785373015,
							27.983242623614863
						],
						[
							-82.82010545929664,
							27.983267403534132
						],
						[
							-82.82011439046391,
							27.983302418637482
						],
						[
							-82.82011993838141,
							27.98333017801077
						],
						[
							-82.82012514635511,
							27.983365902678617
						],
						[
							-82.820127486391,
							27.983388703190496
						],
						[
							-82.82012964656252,
							27.983424790285408
						],
						[
							-82.8201298588027,
							27.983452957051394
						],
						[
							-82.82012824541896,
							27.983489066629478
						],
						[
							-82.8201262120517,
							27.983512189098217
						],
						[
							-82.82012241241634,
							27.983541090610334
						],
						[
							-82.82011772604913,
							27.983566929930884
						],
						[
							-82.82010933357593,
							27.98360307997846
						],
						[
							-82.82010243038005,
							27.983627528947
						],
						[
							-82.82009092625262,
							27.98366197747743
						],
						[
							-82.82008133048666,
							27.98368662159884
						],
						[
							-82.82006638285517,
							27.983720059291453
						],
						[
							-82.82005579873413,
							27.98374119965416
						],
						[
							-82.82003774574383,
							27.983773624709688
						],
						[
							-82.82002354544902,
							27.983796387450003
						],
						[
							-82.8200024248711,
							27.983826768346734
						],
						[
							-82.81998785315608,
							27.98384585555748
						],
						[
							-82.81996343926117,
							27.98387504575174
						],
						[
							-82.81993004653481,
							27.983908465457677
						],
						[
							-82.81991769164883,
							27.98391726622295
						],
						[
							-82.81989724915977,
							27.983943637043144
						],
						[
							-82.81987276152012,
							27.983966299059052
						],
						[
							-82.81984488883249,
							27.983984639832396
						],
						[
							-82.81981062016663,
							27.984005797282588
						],
						[
							-82.81980485551264,
							27.98400925787369
						],
						[
							-82.81977092409221,
							27.98402905644803
						],
						[
							-82.81975180090863,
							27.984039208894377
						],
						[
							-82.81971629927226,
							27.984056267234717
						],
						[
							-82.81969788745236,
							27.98406428469075
						],
						[
							-82.81966670525962,
							27.98407650377907
						],
						[
							-82.8196483420031,
							27.98408294562275
						],
						[
							-82.81960999401245,
							27.984094864337653
						],
						[
							-82.81959126563112,
							27.984099953601064
						],
						[
							-82.81955197694958,
							27.984109126685404
						],
						[
							-82.81952904783515,
							27.98411344433084
						],
						[
							-82.81948915121198,
							27.98411918290437
						],
						[
							-82.81946685432098,
							27.984121450095426
						],
						[
							-82.81941899779832,
							27.984124313536643
						],
						[
							-82.81940305371822,
							27.984124795573454
						],
						[
							-82.81924095002304,
							27.984124899894805
						],
						[
							-82.81904999068138,
							27.98412471283537
						],
						[
							-82.81918227555599,
							27.984138657723104
						],
						[
							-82.8194178008008,
							27.98416348530647
						],
						[
							-82.819655421466,
							27.984169852506216
						],
						[
							-82.81968406577202,
							27.984172150274237
						],
						[
							-82.8196939394284,
							27.984173474975297
						],
						[
							-82.81971640629172,
							27.984173598182696
						],
						[
							-82.81975300060418,
							27.984176294349897
						],
						[
							-82.81978889074774,
							27.98418393139254
						],
						[
							-82.81982341302248,
							27.984196366318162
						],
						[
							-82.81989885444953,
							27.984229499140515
						],
						[
							-82.81990607960273,
							27.984232799652556
						],
						[
							-82.81994183844527,
							27.98424977615436
						],
						[
							-82.8199743768156,
							27.984268135813576
						],
						[
							-82.82000394382612,
							27.984290974996032
						],
						[
							-82.82002703751645,
							27.98430174437733
						],
						[
							-82.82006569487368,
							27.98432883105743
						],
						[
							-82.82009544984231,
							27.9843538636862
						],
						[
							-82.82011192182466,
							27.98436892822941
						],
						[
							-82.82013875129877,
							27.984395585033287
						],
						[
							-82.82015416567832,
							27.984412247672378
						],
						[
							-82.82017858766756,
							27.984440981910478
						],
						[
							-82.82019418011294,
							27.984461190575797
						],
						[
							-82.82021546886388,
							27.98449166230405
						],
						[
							-82.82022825902169,
							27.98451181341274
						],
						[
							-82.82024675627706,
							27.984544020832583
						],
						[
							-82.82025872445489,
							27.984567432883015
						],
						[
							-82.82027450395935,
							27.984602406617324
						],
						[
							-82.82028442078324,
							27.984627718935077
						],
						[
							-82.82029648069151,
							27.98466374667516
						],
						[
							-82.8203037643006,
							27.984689766759022
						],
						[
							-82.82031177725997,
							27.98472513079925
						],
						[
							-82.82031625678313,
							27.98475043952006
						],
						[
							-82.82032083703007,
							27.98478616778556
						],
						[
							-82.82032294414171,
							27.98481374009977
						],
						[
							-82.82032384616167,
							27.98484983349009
						],
						[
							-82.82032325440774,
							27.98487566111937
						],
						[
							-82.82032071742032,
							27.98491143165275
						],
						[
							-82.82031741331116,
							27.984938515635275
						],
						[
							-82.82031119629812,
							27.98497430865218
						],
						[
							-82.8203059757336,
							27.984997992297803
						],
						[
							-82.82029665336148,
							27.9850327726778
						],
						[
							-82.82028791734726,
							27.985059646218883
						],
						[
							-82.82027481512449,
							27.98509376110047
						],
						[
							-82.82026539562571,
							27.985115407781894
						],
						[
							-82.82024923390956,
							27.985148509127914
						],
						[
							-82.82024044303664,
							27.985165032371487
						],
						[
							-82.82021352542904,
							27.9852034882807
						],
						[
							-82.820191399409,
							27.98522987438911
						],
						[
							-82.82017461176483,
							27.985251717122598
						],
						[
							-82.82015133820993,
							27.985281997295278
						],
						[
							-82.82014724989197,
							27.985287183685262
						],
						[
							-82.82013064031338,
							27.985307696321474
						],
						[
							-82.8200974085658,
							27.985341510830004
						],
						[
							-82.82006816261338,
							27.985366440036433
						],
						[
							-82.82004681900366,
							27.985382867052625
						],
						[
							-82.82001479324694,
							27.98540506052173
						],
						[
							-82.81999708559623,
							27.985416338020134
						],
						[
							-82.81996315237733,
							27.98543613749384
						],
						[
							-82.81994209924856,
							27.98544720724873
						],
						[
							-82.81993532195776,
							27.985450398043202
						],
						[
							-82.81996573523018,
							27.985453177847678
						],
						[
							-82.81999556394338,
							27.985459729408394
						],
						[
							-82.82002434224817,
							27.985469952002187
						],
						[
							-82.82003159707914,
							27.9854708045595
						],
						[
							-82.8200469485062,
							27.985473058260194
						],
						[
							-82.8200885403512,
							27.985483867211617
						],
						[
							-82.8201314011398,
							27.985498739300244
						],
						[
							-82.820152265411,
							27.985506965398447
						],
						[
							-82.82019360184864,
							27.985525283688975
						],
						[
							-82.82021213957371,
							27.985534361445833
						],
						[
							-82.82025132033668,
							27.98555544425209
						],
						[
							-82.82027172775217,
							27.98556761387793
						],
						[
							-82.8203085091238,
							27.98559180384156
						],
						[
							-82.82032743265783,
							27.985605457348687
						],
						[
							-82.82036201248928,
							27.985632756269144
						],
						[
							-82.82037780548339,
							27.985646242502252
						],
						[
							-82.82040964058382,
							27.9856756188564
						],
						[
							-82.82042786084831,
							27.985694134098186
						],
						[
							-82.82045627762578,
							27.985725937722453
						],
						[
							-82.82047013617813,
							27.985742771232328
						],
						[
							-82.82049580822483,
							27.98577665498822
						],
						[
							-82.82051103014936,
							27.98579898785231
						],
						[
							-82.8205329915935,
							27.98583495623685
						],
						[
							-82.82054673862989,
							27.98586045651287
						],
						[
							-82.82057099514367,
							27.985911882444654
						],
						[
							-82.82057803323795,
							27.98592817276379
						],
						[
							-82.82074017560397,
							27.986340162078097
						],
						[
							-82.82085356752116,
							27.98662828866806
						],
						[
							-82.82091650927156,
							27.986785878666
						],
						[
							-82.8212189746523,
							27.987434026348016
						],
						[
							-82.82128397225266,
							27.98755482957819
						],
						[
							-82.82161156019441,
							27.98808848277378
						],
						[
							-82.82162267671384,
							27.988108440528343
						],
						[
							-82.8219760868892,
							27.988809603243784
						],
						[
							-82.82201616067873,
							27.988819706227126
						],
						[
							-82.82205421728895,
							27.9888358184807
						],
						[
							-82.82208936369322,
							27.988857560490136
						],
						[
							-82.82212077071651,
							27.988884421440577
						],
						[
							-82.82214770091467,
							27.988915770007697
						],
						[
							-82.822169521165,
							27.988950867848775
						],
						[
							-82.82229748389794,
							27.989196839617954
						],
						[
							-82.82231037747783,
							27.989225617023653
						],
						[
							-82.82232081231136,
							27.989253110197257
						],
						[
							-82.8223312939097,
							27.989287459802554
						],
						[
							-82.82239329406973,
							27.98955280296848
						],
						[
							-82.82239942025124,
							27.98959155475497
						],
						[
							-82.82241523752737,
							27.989779414133512
						],
						[
							-82.82244229722771,
							27.989858160569195
						],
						[
							-82.82245284267782,
							27.98989898889001
						],
						[
							-82.82245458106735,
							27.98991022861667
						],
						[
							-82.82247535540613,
							27.99006625109623
						],
						[
							-82.82249614503348,
							27.99022237160155
						],
						[
							-82.82249850485452,
							27.990257982955416
						],
						[
							-82.82249814782368,
							27.990271858595253
						],
						[
							-82.82248970858583,
							27.99043574564585
						],
						[
							-82.82248728041617,
							27.99046053725586
						],
						[
							-82.82245135160184,
							27.9907086350229
						],
						[
							-82.82244712928495,
							27.990731059617882
						],
						[
							-82.82237061496669,
							27.991060194393317
						],
						[
							-82.82236351302055,
							27.991085209934955
						],
						[
							-82.82225503859627,
							27.991407314710518
						],
						[
							-82.8222465274125,
							27.9914293489994
						],
						[
							-82.82210696072745,
							27.991748345717685
						],
						[
							-82.82189244004775,
							27.992229805860195
						],
						[
							-82.82188996241568,
							27.99223520538955
						],
						[
							-82.82184529398985,
							27.992329797879126
						],
						[
							-82.82183899064168,
							27.992342294857867
						],
						[
							-82.82162041761703,
							27.992749070802528
						],
						[
							-82.82158548525132,
							27.992819904103175
						],
						[
							-82.82149570323519,
							27.99301341392237
						],
						[
							-82.82137460952394,
							27.9932749502586
						],
						[
							-82.82135869692,
							27.9933090930194
						],
						[
							-82.8213202221251,
							27.993468387232063
						],
						[
							-82.82126193166827,
							27.993708991848113
						],
						[
							-82.82120644619712,
							27.993948846429287
						],
						[
							-82.82114773485779,
							27.994213296568585
						],
						[
							-82.82111502921373,
							27.99438714540933
						],
						[
							-82.8210960193445,
							27.994582968284583
						],
						[
							-82.82108459975335,
							27.994786748361303
						],
						[
							-82.82108114365865,
							27.994997458613216
						],
						[
							-82.82108397292596,
							27.995210302057064
						],
						[
							-82.82109232762753,
							27.995437323313258
						],
						[
							-82.82110638313138,
							27.99566437694462
						],
						[
							-82.82112455033575,
							27.99587793894684
						],
						[
							-82.82114948134118,
							27.99610543774246
						],
						[
							-82.82117982086896,
							27.996331904116648
						],
						[
							-82.8212157919517,
							27.99655859801941
						],
						[
							-82.82125275768439,
							27.99675360970621
						],
						[
							-82.82128183366477,
							27.996879102001518
						],
						[
							-82.82128798322883,
							27.996919066973117
						],
						[
							-82.8212880902482,
							27.996959501390887
						],
						[
							-82.8212821538236,
							27.996999498737654
						],
						[
							-82.82127030615499,
							27.99703815879326
						],
						[
							-82.82125281434156,
							27.997074613711096
						],
						[
							-82.82123007048739,
							27.99710804600767
						],
						[
							-82.82120258540766,
							27.99713770295035
						],
						[
							-82.8211709760369,
							27.997162919939736
						],
						[
							-82.82113595373913,
							27.997183129504425
						],
						[
							-82.82109830452178,
							27.99719787748664
						],
						[
							-82.8210588737474,
							27.997206833834657
						],
						[
							-82.82101854814765,
							27.99720979620101
						],
						[
							-82.82054100904935,
							27.997208191810966
						],
						[
							-82.820228053077,
							27.997210065098802
						],
						[
							-82.81975626874025,
							27.997212876379432
						],
						[
							-82.81971441339395,
							27.99720973684618
						],
						[
							-82.81967355179808,
							27.99720014287878
						],
						[
							-82.81963467230831,
							27.997184327401317
						],
						[
							-82.81959871651405,
							27.997162672626455
						],
						[
							-82.81956655495975,
							27.997135703757362
						],
						[
							-82.81953896465922,
							27.997104072802973
						],
						[
							-82.819516614708,
							27.997068545086204
						],
						[
							-82.81950004649825,
							27.997029980358793
						],
						[
							-82.81948965932918,
							27.996989313016588
						],
						[
							-82.8194678831453,
							27.996862367417133
						],
						[
							-82.8194335065607,
							27.996662543458154
						],
						[
							-82.81943235722717,
							27.99665526974159
						],
						[
							-82.81939638344669,
							27.99640553880575
						],
						[
							-82.81939556506364,
							27.996399353269044
						],
						[
							-82.81936813664099,
							27.99617152082458
						],
						[
							-82.8193451400774,
							27.99594008209915
						],
						[
							-82.8193271572341,
							27.99570861009865
						],
						[
							-82.81931411796427,
							27.995479312658592
						],
						[
							-82.81931383467753,
							27.99547301560576
						],
						[
							-82.8193058163224,
							27.995232400198336
						],
						[
							-82.81930567512876,
							27.99522545923089
						],
						[
							-82.81930547098283,
							27.995198312296058
						],
						[
							-82.81930280539231,
							27.994989651598804
						],
						[
							-82.81930281798269,
							27.994981870664684
						],
						[
							-82.81930639098921,
							27.994759580742038
						],
						[
							-82.81930665898709,
							27.994751137906984
						],
						[
							-82.81931429872776,
							27.994590018969415
						],
						[
							-82.81931498041395,
							27.994579772094244
						],
						[
							-82.8193227883279,
							27.994488618611793
						],
						[
							-82.81932526146328,
							27.994468589810953
						],
						[
							-82.81935174110123,
							27.994304781001414
						],
						[
							-82.81935584830487,
							27.994284397867478
						],
						[
							-82.81937612891602,
							27.994200561269015
						],
						[
							-82.81938099874473,
							27.99418303887872
						],
						[
							-82.81943111256538,
							27.994023730276677
						],
						[
							-82.81943818393465,
							27.994003970373097
						],
						[
							-82.81947632238322,
							27.99390919621995
						],
						[
							-82.81948452959618,
							27.99389081227936
						],
						[
							-82.81951107668311,
							27.993836855655655
						],
						[
							-82.81950364738371,
							27.993842914388193
						],
						[
							-82.81947928924669,
							27.99386128124201
						],
						[
							-82.81946490459073,
							27.993871409406626
						],
						[
							-82.81942790468378,
							27.993895696497187
						],
						[
							-82.81940994162571,
							27.993906513542758
						],
						[
							-82.81937078964113,
							27.993928061298515
						],
						[
							-82.81934889834426,
							27.993938849565684
						],
						[
							-82.81930749535655,
							27.993956974501724
						],
						[
							-82.81928720035647,
							27.99396489842813
						],
						[
							-82.81924455990166,
							27.99397959245066
						],
						[
							-82.81922517771328,
							27.993985467721597
						],
						[
							-82.8191809643446,
							27.993997077069746
						],
						[
							-82.81915883202913,
							27.99400190552969
						],
						[
							-82.81911396215536,
							27.994009735926642
						],
						[
							-82.81909333620455,
							27.99401252112698
						],
						[
							-82.81904747347902,
							27.994016919711054
						],
						[
							-82.81902938541508,
							27.99401804386356
						],
						[
							-82.81898354517273,
							27.994019347880187
						],
						[
							-82.81895931294041,
							27.994018947681916
						],
						[
							-82.81891344122164,
							27.994016126508928
						],
						[
							-82.81889302661163,
							27.994014089544198
						],
						[
							-82.81884775833788,
							27.994007826665626
						],
						[
							-82.81882944904086,
							27.994004647562424
						],
						[
							-82.81878474014535,
							27.99399528741883
						],
						[
							-82.81876428956234,
							27.993990164880348
						],
						[
							-82.81872857658533,
							27.993979719254828
						],
						[
							-82.81871103171204,
							27.993973929420083
						],
						[
							-82.8186687914556,
							27.993958364853558
						],
						[
							-82.81864804139836,
							27.99394972146924
						],
						[
							-82.81860727872805,
							27.99393071160036
						],
						[
							-82.81858707455933,
							27.993920230002193
						],
						[
							-82.81854851252983,
							27.99389811207639
						],
						[
							-82.81852922387117,
							27.993885937054692
						],
						[
							-82.81849277075206,
							27.993860711971156
						],
						[
							-82.81847633564199,
							27.993848387661938
						],
						[
							-82.81844267401829,
							27.993821084245166
						],
						[
							-82.8184245400889,
							27.99380497109222
						],
						[
							-82.81839361780025,
							27.993774901360627
						],
						[
							-82.81837592453864,
							27.993755958940728
						],
						[
							-82.81834808062942,
							27.99372311839853
						],
						[
							-82.81833510521118,
							27.993706545692124
						],
						[
							-82.81831769973252,
							27.993682431271264
						],
						[
							-82.81833652973727,
							27.99381964892699
						],
						[
							-82.8183725754635,
							27.99409584511149
						],
						[
							-82.81839467180576,
							27.99424805266703
						],
						[
							-82.81843278057674,
							27.994450448687154
						],
						[
							-82.81848035561141,
							27.994650121559875
						],
						[
							-82.81853758127073,
							27.99484814147856
						],
						[
							-82.81860444676317,
							27.99504377189887
						],
						[
							-82.8186280134967,
							27.995103658652557
						],
						[
							-82.81868061124491,
							27.995236543374983
						],
						[
							-82.81876628156073,
							27.995426864198084
						],
						[
							-82.81886104672037,
							27.995614023004936
						],
						[
							-82.81896370163196,
							27.995795815557152
						],
						[
							-82.81903347463214,
							27.99590845114476
						],
						[
							-82.81904472245286,
							27.995923893403255
						],
						[
							-82.81905385776598,
							27.99593426438484
						],
						[
							-82.81907143861245,
							27.995951096995345
						],
						[
							-82.81909936076282,
							27.995978311378984
						],
						[
							-82.81912803294762,
							27.996003943855744
						],
						[
							-82.81915009061922,
							27.9960260932577
						],
						[
							-82.81916943953244,
							27.9960506456484
						],
						[
							-82.81918581798544,
							27.996077270976475
						],
						[
							-82.81920579912227,
							27.99611441657383
						],
						[
							-82.81922567323983,
							27.996151362521285
						],
						[
							-82.81924521730612,
							27.996187694231725
						],
						[
							-82.819264665145,
							27.996223846078397
						],
						[
							-82.81927954892454,
							27.99625657150752
						],
						[
							-82.8192899504831,
							27.99629098586333
						],
						[
							-82.81929568366103,
							27.99632647670826
						],
						[
							-82.81929970093279,
							27.996369331201723
						],
						[
							-82.81930498175177,
							27.996409840263073
						],
						[
							-82.81930711314469,
							27.996436256049076
						],
						[
							-82.8193083865849,
							27.996476816371644
						],
						[
							-82.81930772108647,
							27.99650601735816
						],
						[
							-82.81930459234513,
							27.996546605560116
						],
						[
							-82.81930160839471,
							27.996570884556707
						],
						[
							-82.81929479423161,
							27.996611149902076
						],
						[
							-82.81928900799363,
							27.996637347152667
						],
						[
							-82.81927817116326,
							27.996676947898994
						],
						[
							-82.81927024543812,
							27.99670130423745
						],
						[
							-82.81925562605926,
							27.99673989864228
						],
						[
							-82.81924513276982,
							27.996763988781584
						],
						[
							-82.81922653389103,
							27.996801574146804
						],
						[
							-82.81921459988773,
							27.99682314978195
						],
						[
							-82.81919255120948,
							27.996859036328306
						],
						[
							-82.8191790892581,
							27.99687890774784
						],
						[
							-82.81915363754517,
							27.99691309637417
						],
						[
							-82.81913792638942,
							27.99693229240258
						],
						[
							-82.81910935762652,
							27.996964092429902
						],
						[
							-82.81909083159256,
							27.99698279293203
						],
						[
							-82.81905529668137,
							27.997015322309085
						],
						[
							-82.81903694871333,
							27.99703068093066
						],
						[
							-82.81899795770727,
							27.997060479966255
						],
						[
							-82.81897687759903,
							27.997075057976343
						],
						[
							-82.81893957731856,
							27.997098315343397
						],
						[
							-82.81892038488701,
							27.99710921782427
						],
						[
							-82.81888054851868,
							27.99712973945329
						],
						[
							-82.81886108179373,
							27.997138806418423
						],
						[
							-82.81881938202991,
							27.997156244272606
						],
						[
							-82.81879889007813,
							27.997163853436216
						],
						[
							-82.81875590608257,
							27.997177861276082
						],
						[
							-82.81873661022902,
							27.99718336512679
						],
						[
							-82.81869209918449,
							27.997194288292274
						],
						[
							-82.8186699156081,
							27.997198755224698
						],
						[
							-82.81862470129357,
							27.99720590123737
						],
						[
							-82.81860450521872,
							27.99720831681675
						],
						[
							-82.81855902020857,
							27.997212024721488
						],
						[
							-82.81853669543862,
							27.997212915949557
						],
						[
							-82.81849050535992,
							27.99721284760103
						],
						[
							-82.81847221494824,
							27.99721219918975
						],
						[
							-82.81842663101268,
							27.9972090335762
						],
						[
							-82.81840374956226,
							27.997206458817306
						],
						[
							-82.81835491008074,
							27.99719884155973
						],
						[
							-82.81833234609104,
							27.99719432966096
						],
						[
							-82.81828435017394,
							27.99718258271692
						],
						[
							-82.81826424043383,
							27.997176826156362
						],
						[
							-82.81822108916435,
							27.997162642049314
						],
						[
							-82.81819948924783,
							27.99715450228543
						],
						[
							-82.81815815281008,
							27.99713687107747
						],
						[
							-82.818138643817,
							27.997127610758202
						],
						[
							-82.81809912400983,
							27.997106873291347
						],
						[
							-82.8180808344977,
							27.997096344928813
						],
						[
							-82.81804347396277,
							27.99707284474461
						],
						[
							-82.8180225134642,
							27.997058231661246
						],
						[
							-82.8179930507752,
							27.997035543565044
						],
						[
							-82.81797874346103,
							27.9970237210777
						],
						[
							-82.81794116169266,
							27.99699042367944
						],
						[
							-82.81792291894543,
							27.996972654874877
						],
						[
							-82.81789353539686,
							27.99694120018749
						],
						[
							-82.81787735389548,
							27.996922184922216
						],
						[
							-82.81785138956906,
							27.99688864560689
						],
						[
							-82.81784333344244,
							27.996877678374613
						],
						[
							-82.81781734303564,
							27.996840358309175
						],
						[
							-82.81781359646014,
							27.99683483467305
						],
						[
							-82.81768131068617,
							27.996634496302093
						],
						[
							-82.81767547138833,
							27.99662525127157
						],
						[
							-82.81755181820677,
							27.99642039200815
						],
						[
							-82.81754609851848,
							27.996410443707834
						],
						[
							-82.81743175691696,
							27.996201402597723
						],
						[
							-82.81742675578732,
							27.996191807731133
						],
						[
							-82.81732134625236,
							27.995979275452424
						],
						[
							-82.81731637300139,
							27.99596867514335
						],
						[
							-82.81722052236027,
							27.995752305457803
						],
						[
							-82.81721608330662,
							27.99574167996834
						],
						[
							-82.81712984371994,
							27.9955221581589
						],
						[
							-82.81712595774957,
							27.995511627097716
						],
						[
							-82.81705055049666,
							27.995293414701298
						],
						[
							-82.81704699547656,
							27.995282363831922
						],
						[
							-82.81697896806043,
							27.995054138384138
						],
						[
							-82.81697581683608,
							27.99504264504861
						],
						[
							-82.81696894787983,
							27.995015231891003
						],
						[
							-82.81691699999988,
							27.994873000000382
						],
						[
							-82.81678499999978,
							27.994181000000502
						]
					],
					[
						[
							-82.818203017288,
							27.992436240735078
						],
						[
							-82.81816510097195,
							27.992220283838446
						],
						[
							-82.81812361884391,
							27.991990881177845
						],
						[
							-82.8180809702954,
							27.991762012714464
						],
						[
							-82.81803683246983,
							27.991533405054906
						],
						[
							-82.81799366771014,
							27.991318241360045
						],
						[
							-82.81794956315912,
							27.99110309834926
						],
						[
							-82.81790133072,
							27.990874889089415
						],
						[
							-82.81785193275971,
							27.99064717625505
						],
						[
							-82.81780404655954,
							27.99043387235766
						],
						[
							-82.8177559867904,
							27.990219753675053
						],
						[
							-82.81770600866405,
							27.990006590866404
						],
						[
							-82.81765408880612,
							27.989792637931213
						],
						[
							-82.81760163784105,
							27.989579222175212
						],
						[
							-82.8175468926198,
							27.98936634383448
						],
						[
							-82.81748822624671,
							27.98914018412912
						],
						[
							-82.81743159863646,
							27.988927576307457
						],
						[
							-82.81737401684558,
							27.98871623563041
						],
						[
							-82.81731341692999,
							27.988507199016613
						],
						[
							-82.81728856416571,
							27.988425403879372
						],
						[
							-82.81728311067694,
							27.988409841111764
						],
						[
							-82.81727900167446,
							27.988401162654345
						],
						[
							-82.81727026566033,
							27.988386746522234
						],
						[
							-82.81726047294266,
							27.988374554413404
						],
						[
							-82.81724984745284,
							27.98836374366324
						],
						[
							-82.81723771200154,
							27.988353168535088
						],
						[
							-82.81722428152622,
							27.98834353499792
						],
						[
							-82.8172199036265,
							27.988348785239584
						],
						[
							-82.81721547986159,
							27.98835838909987
						],
						[
							-82.81721154083107,
							27.988370410337563
						],
						[
							-82.81720835183506,
							27.988405396661978
						],
						[
							-82.81720980873678,
							27.98841610578872
						],
						[
							-82.81721389615535,
							27.988432131707622
						],
						[
							-82.81724747414215,
							27.988544209715474
						],
						[
							-82.81727812843289,
							27.988651810898194
						],
						[
							-82.8173106784943,
							27.988766191170736
						],
						[
							-82.81732100900649,
							27.988804930366413
						],
						[
							-82.81736953642314,
							27.988984042039636
						],
						[
							-82.81742699680564,
							27.989201795781963
						],
						[
							-82.81748301557491,
							27.989418352526588
						],
						[
							-82.81748513078024,
							27.989427133506798
						],
						[
							-82.81753230921385,
							27.989638464291136
						],
						[
							-82.81759069769652,
							27.98984603141303
						],
						[
							-82.81765114832476,
							27.990060929807573
						],
						[
							-82.81765682304687,
							27.990085432735793
						],
						[
							-82.81769600650745,
							27.990299597283933
						],
						[
							-82.8177439061976,
							27.9905102751605
						],
						[
							-82.81779265125004,
							27.99072979607057
						],
						[
							-82.81783990342812,
							27.99094908585477
						],
						[
							-82.81788591993785,
							27.991168868467145
						],
						[
							-82.81793028888937,
							27.991388781482055
						],
						[
							-82.8179737306401,
							27.991608810509053
						],
						[
							-82.81801598258765,
							27.99182924153307
						],
						[
							-82.81805667331213,
							27.99204999631268
						],
						[
							-82.81809602944274,
							27.992270054118258
						],
						[
							-82.8181345483049,
							27.992491040023918
						],
						[
							-82.8181715257285,
							27.992712400047385
						],
						[
							-82.81820688077548,
							27.992933718702165
						],
						[
							-82.81822602914006,
							27.99306306639117
						],
						[
							-82.81824369722084,
							27.99300392607488
						],
						[
							-82.81825632909789,
							27.992945221031036
						],
						[
							-82.81826273317029,
							27.992886846937207
						],
						[
							-82.81826358213003,
							27.992834703346784
						],
						[
							-82.8182588921657,
							27.99277335519516
						],
						[
							-82.81823935349529,
							27.992652138276878
						],
						[
							-82.818203017288,
							27.992436240735078
						]
					],
					[
						[
							-82.81972687260131,
							27.99228265991484
						],
						[
							-82.81974924863265,
							27.992416589649697
						],
						[
							-82.8197487962737,
							27.992380590688196
						],
						[
							-82.81973923737985,
							27.99217260987838
						],
						[
							-82.81972181481414,
							27.991964995991584
						],
						[
							-82.81969740001986,
							27.99175734523313
						],
						[
							-82.81966588687658,
							27.99155327377633
						],
						[
							-82.81962657930914,
							27.99134321013678
						],
						[
							-82.81958415738966,
							27.991128994327244
						],
						[
							-82.81954033792391,
							27.990914019490205
						],
						[
							-82.81953880817727,
							27.99090637795071
						],
						[
							-82.81949282674111,
							27.990686372306254
						],
						[
							-82.81944590011754,
							27.990470644736224
						],
						[
							-82.81939925767989,
							27.99025749012706
						],
						[
							-82.81934775350723,
							27.990029860030422
						],
						[
							-82.81929815050135,
							27.989816597502074
						],
						[
							-82.81924700066162,
							27.989603118237586
						],
						[
							-82.81919169325613,
							27.989376586212803
						],
						[
							-82.81913813503205,
							27.989163291309286
						],
						[
							-82.81908356956727,
							27.988951143041266
						],
						[
							-82.81902773425969,
							27.98873825553027
						],
						[
							-82.8189706497941,
							27.988525217832564
						],
						[
							-82.818959236498,
							27.988483213199014
						],
						[
							-82.81891278021997,
							27.988316252265403
						],
						[
							-82.8188517270462,
							27.988108122168246
						],
						[
							-82.81881744938697,
							27.987996019878484
						],
						[
							-82.81880273288127,
							27.98796100747342
						],
						[
							-82.81879686660369,
							27.987951608658893
						],
						[
							-82.81877511470188,
							27.987926766686503
						],
						[
							-82.81875349140282,
							27.987909128283587
						],
						[
							-82.81874874657989,
							27.987918037866525
						],
						[
							-82.81874517177481,
							27.987928741597408
						],
						[
							-82.81874275079984,
							27.987938908433133
						],
						[
							-82.81874150254083,
							27.987948475421046
						],
						[
							-82.8187412219524,
							27.987955869646544
						],
						[
							-82.81874190363857,
							27.98796590428189
						],
						[
							-82.81874364382655,
							27.987977012707535
						],
						[
							-82.8187475306965,
							27.987992245424135
						],
						[
							-82.81878146841197,
							27.988103486163244
						],
						[
							-82.81884555320039,
							27.98832300077773
						],
						[
							-82.81884717197998,
							27.988328782519392
						],
						[
							-82.81888465931944,
							27.988468721523777
						],
						[
							-82.81896477991901,
							27.988762096557554
						],
						[
							-82.81902184729766,
							27.98898022621625
						],
						[
							-82.81907744968098,
							27.989198290224696
						],
						[
							-82.81913182808675,
							27.989416017886374
						],
						[
							-82.81918496632758,
							27.989634519864484
						],
						[
							-82.81923682033641,
							27.989852957091724
						],
						[
							-82.81928746655562,
							27.990071794517064
						],
						[
							-82.81933694545509,
							27.99029142064803
						],
						[
							-82.81938379203903,
							27.99050836679903
						],
						[
							-82.81943092550657,
							27.99072776630062
						],
						[
							-82.8194765759921,
							27.99094740232359
						],
						[
							-82.81952099800377,
							27.99116701766248
						],
						[
							-82.81956672673026,
							27.991400867470798
						],
						[
							-82.81960863153948,
							27.991621156401894
						],
						[
							-82.81964929618367,
							27.99184110359018
						],
						[
							-82.81968870267649,
							27.99206208410034
						],
						[
							-82.81972687260131,
							27.99228265991484
						]
					],
					[
						[
							-82.8171212947647,
							27.984405955116035
						],
						[
							-82.81708690289172,
							27.9843100765958
						],
						[
							-82.81699115477312,
							27.984342316391167
						],
						[
							-82.81675943006313,
							27.984420340671182
						],
						[
							-82.81487719941782,
							27.985055110937754
						],
						[
							-82.81464510688517,
							27.98513359836871
						],
						[
							-82.81458280815019,
							27.985154442854668
						],
						[
							-82.81457161249033,
							27.985166906558693
						],
						[
							-82.81455575294643,
							27.985183133025618
						],
						[
							-82.81453404870867,
							27.985203546736518
						],
						[
							-82.81451991046696,
							27.985215945689493
						],
						[
							-82.8144920611616,
							27.985238700335305
						],
						[
							-82.81451156116127,
							27.98523894495101
						],
						[
							-82.81456752507175,
							27.985242222979707
						],
						[
							-82.81459122850252,
							27.985244665538392
						],
						[
							-82.8146197037359,
							27.985248877063565
						],
						[
							-82.8146592802005,
							27.9852360410403
						],
						[
							-82.8148891927763,
							27.98515853656848
						],
						[
							-82.81513551977831,
							27.98507524855662
						],
						[
							-82.81701808856859,
							27.984440706717987
						],
						[
							-82.8171212947647,
							27.984405955116035
						]
					],
					[
						[
							-82.81850694676523,
							27.98260877515368
						],
						[
							-82.81848695213847,
							27.98260855571907
						],
						[
							-82.81846822825372,
							27.982609937077388
						],
						[
							-82.81845810188776,
							27.982611113390835
						],
						[
							-82.81844847014888,
							27.98261282120357
						],
						[
							-82.81844109570818,
							27.982614662115527
						],
						[
							-82.81842814996752,
							27.982619932142786
						],
						[
							-82.81827847670165,
							27.98266535599875
						],
						[
							-82.81828277186365,
							27.982676006669855
						],
						[
							-82.81829096738515,
							27.98269936925745
						],
						[
							-82.81829825009515,
							27.982723656348366
						],
						[
							-82.81830393830691,
							27.982743119475476
						],
						[
							-82.81831076236237,
							27.98274699465441
						],
						[
							-82.81831675364566,
							27.982748020780793
						],
						[
							-82.81834349498637,
							27.982751234957806
						],
						[
							-82.81837031456784,
							27.98275445812745
						],
						[
							-82.81838981996337,
							27.982756802660372
						],
						[
							-82.81861375024924,
							27.98275124844746
						],
						[
							-82.81863115033195,
							27.982751377949914
						],
						[
							-82.81885873276485,
							27.982760420632605
						],
						[
							-82.81908554088122,
							27.982760412538813
						],
						[
							-82.8192342833489,
							27.982758457412974
						],
						[
							-82.8191886832253,
							27.982752285365926
						],
						[
							-82.81916466952859,
							27.982748795996418
						],
						[
							-82.81911070930751,
							27.98273845918892
						],
						[
							-82.81910327281359,
							27.98273692584498
						],
						[
							-82.81892268715144,
							27.982697031919482
						],
						[
							-82.81874229124638,
							27.982656826829025
						],
						[
							-82.81855712263899,
							27.982615772778377
						],
						[
							-82.8185254656044,
							27.98261024464576
						],
						[
							-82.81850694676523,
							27.98260877515368
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Island Estate Civic Association",
				"RegionID": "343306"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.76727429299986,
					27.993616950000032,
					-82.76328079599992,
					27.99719644000008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.76328874099995,
							27.99685006100011
						],
						[
							-82.76328079599992,
							27.993873769000054
						],
						[
							-82.76359131699986,
							27.993877890000036
						],
						[
							-82.76358947799989,
							27.993616950000032
						],
						[
							-82.76723462899994,
							27.993637574000047
						],
						[
							-82.76727429299986,
							27.99719644000008
						],
						[
							-82.76357080599993,
							27.997164109000067
						],
						[
							-82.76357509799993,
							27.99685259700005
						],
						[
							-82.76328874099995,
							27.99685006100011
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Winsor Park Homeowners Association",
				"RegionID": "343307"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.74417396599998,
					27.9797874450001,
					-82.74195487599987,
					27.98258709500002
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.74222069799993,
							27.980306578000068
						],
						[
							-82.74220597799986,
							27.9797874450001
						],
						[
							-82.74262842599991,
							27.97980510600005
						],
						[
							-82.74296274399985,
							27.9799463250001
						],
						[
							-82.74316418399991,
							27.980137769000045
						],
						[
							-82.74352687299991,
							27.980342782000044
						],
						[
							-82.74358852299994,
							27.980431152000072
						],
						[
							-82.74370558999995,
							27.980474870000045
						],
						[
							-82.74380018499996,
							27.980489142000074
						],
						[
							-82.74387831499993,
							27.98053822800005
						],
						[
							-82.7439122199999,
							27.980646689000054
						],
						[
							-82.74393530099995,
							27.980764834000055
						],
						[
							-82.74393220799996,
							27.980834530000052
						],
						[
							-82.7439304789999,
							27.980873503000076
						],
						[
							-82.74404938699988,
							27.98117850600009
						],
						[
							-82.74413926199995,
							27.98131623100003
						],
						[
							-82.74417396599998,
							27.981498605000105
						],
						[
							-82.74413092399996,
							27.981730565000113
						],
						[
							-82.74407080799996,
							27.981859131000093
						],
						[
							-82.74404910299995,
							27.981948294000098
						],
						[
							-82.74408131899995,
							27.982579352000087
						],
						[
							-82.74220287599987,
							27.98258709500002
						],
						[
							-82.74220477899993,
							27.98205177400005
						],
						[
							-82.74213256699991,
							27.982047351000034
						],
						[
							-82.74212480099989,
							27.980912825000047
						],
						[
							-82.74207852999989,
							27.980690121000094
						],
						[
							-82.74206743299995,
							27.980636712000027
						],
						[
							-82.74195487599987,
							27.98044513000007
						],
						[
							-82.74214740199992,
							27.980347741000095
						],
						[
							-82.74222069799993,
							27.980306578000068
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Alcove Homeowners Association, Inc",
				"RegionID": "343321"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.71716999098035,
					27.97484000000018,
					-82.71293425259161,
					27.982447525000357
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.71294639599975,
							27.98244651500045
						],
						[
							-82.7129372829999,
							27.97894073400037
						],
						[
							-82.71293425259161,
							27.97783064872689
						],
						[
							-82.7143929999999,
							27.975652000000043
						],
						[
							-82.71442125212569,
							27.975638271259054
						],
						[
							-82.71606399999978,
							27.97484000000018
						],
						[
							-82.71716999098035,
							27.97489124642293
						],
						[
							-82.71716846099969,
							27.975278825000164
						],
						[
							-82.71691440899988,
							27.97527774300043
						],
						[
							-82.71671302199984,
							27.97527638600041
						],
						[
							-82.71649614799975,
							27.975275452000506
						],
						[
							-82.71583312999978,
							27.9752720280004
						],
						[
							-82.71585429199983,
							27.97894655700041
						],
						[
							-82.71595033599971,
							27.978946402000485
						],
						[
							-82.71698032499992,
							27.978945548000414
						],
						[
							-82.71712765099986,
							27.978945426000404
						],
						[
							-82.71712652299985,
							27.97933118700026
						],
						[
							-82.7171256899997,
							27.97958561000026
						],
						[
							-82.71712148899988,
							27.980780027000055
						],
						[
							-82.71711922199987,
							27.98141814900045
						],
						[
							-82.71704722099977,
							27.9814187550005
						],
						[
							-82.71626104499983,
							27.981425371000515
						],
						[
							-82.71626467099969,
							27.98244302800043
						],
						[
							-82.71612740499988,
							27.982447525000357
						],
						[
							-82.71294639599975,
							27.98244651500045
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Mission Hills Condominium Association",
				"RegionID": "343322"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.71301618499984,
					27.956635000000066,
					-82.70884876293037,
					27.96051835200021
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.71169015899982,
							27.960514484000246
						],
						[
							-82.71015940799973,
							27.96048388500029
						],
						[
							-82.70896618099985,
							27.960493475000376
						],
						[
							-82.70894681599985,
							27.960054325000453
						],
						[
							-82.70889095399986,
							27.958787529000265
						],
						[
							-82.70884876293037,
							27.958562504685705
						],
						[
							-82.7088539999999,
							27.95856000000018
						],
						[
							-82.70901799999989,
							27.958481000000038
						],
						[
							-82.70921799999991,
							27.95838600000017
						],
						[
							-82.70951899999996,
							27.958145000000126
						],
						[
							-82.7095301619999,
							27.958136013000182
						],
						[
							-82.70955795096347,
							27.958113848159197
						],
						[
							-82.70956338238402,
							27.958109515987065
						],
						[
							-82.70956891476177,
							27.95810510329019
						],
						[
							-82.70963799999993,
							27.958050000000082
						],
						[
							-82.70977989299986,
							27.957894876000037
						],
						[
							-82.70974899999987,
							27.95783100000008
						],
						[
							-82.70986599999989,
							27.95774000000019
						],
						[
							-82.71009499999991,
							27.957525000000164
						],
						[
							-82.71015099999993,
							27.957432000000107
						],
						[
							-82.71047899999988,
							27.957168000000113
						],
						[
							-82.7106099999998,
							27.957026000000088
						],
						[
							-82.71082199999994,
							27.956635000000066
						],
						[
							-82.71102503699986,
							27.956884768000126
						],
						[
							-82.71107499999981,
							27.956896000000167
						],
						[
							-82.71112398896842,
							27.95692924251451
						],
						[
							-82.71113099999992,
							27.956934000000114
						],
						[
							-82.7111779999999,
							27.957007000000115
						],
						[
							-82.71121918707507,
							27.957085685755803
						],
						[
							-82.71124499999985,
							27.95713500000005
						],
						[
							-82.71128799999985,
							27.957190000000157
						],
						[
							-82.71131799999993,
							27.957228000000104
						],
						[
							-82.71142099999993,
							27.95731800000009
						],
						[
							-82.7116329999999,
							27.95749000000011
						],
						[
							-82.71179279051306,
							27.957613333454493
						],
						[
							-82.71183899999988,
							27.95764900000012
						],
						[
							-82.71196899999988,
							27.95774000000019
						],
						[
							-82.71219499999994,
							27.957802000000168
						],
						[
							-82.71237479899989,
							27.95785151000018
						],
						[
							-82.71236999999985,
							27.957739000000107
						],
						[
							-82.71300299999993,
							27.957716000000158
						],
						[
							-82.71301618499984,
							27.957930978000004
						],
						[
							-82.7129699993632,
							27.957934000193525
						],
						[
							-82.71295974894517,
							27.95793458392676
						],
						[
							-82.71294201799984,
							27.959395433000292
						],
						[
							-82.71293574699976,
							27.96051835200021
						],
						[
							-82.7124930599999,
							27.960517550000322
						],
						[
							-82.71186208399983,
							27.960514970000286
						],
						[
							-82.71169015899982,
							27.960514484000246
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Historic Bayview Association",
				"RegionID": "343337"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.73650935099997,
					27.95697158300004,
					-82.7356906089999,
					27.960366273000076
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.7356906089999,
							27.960366273000076
						],
						[
							-82.73573825799993,
							27.95697158300004
						],
						[
							-82.73650935099997,
							27.956984306000034
						],
						[
							-82.73647394099996,
							27.959939197000004
						],
						[
							-82.73647368999994,
							27.96035864700007
						],
						[
							-82.7356906089999,
							27.960366273000076
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Sunny Grove Mobile Homeowners Association",
				"RegionID": "343338"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.78405063699998,
					27.95867250800009,
					-82.78367896999995,
					27.958967440000066
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.7836804439999,
							27.958963704000027
						],
						[
							-82.78367896999995,
							27.95867250800009
						],
						[
							-82.78404790599993,
							27.958676595000075
						],
						[
							-82.78405063699998,
							27.958967440000066
						],
						[
							-82.78370522699991,
							27.95896390700004
						],
						[
							-82.7836804439999,
							27.958963704000027
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Clearwater Golf View Condominium Assoc",
				"RegionID": "343339"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.8068926074518,
					27.95393939699927,
					-82.8000462789999,
					27.957652051000125
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.80348089399986,
							27.957652051000125
						],
						[
							-82.80329503199994,
							27.957651073000044
						],
						[
							-82.80297908099992,
							27.957651197000054
						],
						[
							-82.80262842899994,
							27.95765152400008
						],
						[
							-82.80243671199989,
							27.957650923000116
						],
						[
							-82.80206835699997,
							27.957646194000084
						],
						[
							-82.80169661099987,
							27.957641140000106
						],
						[
							-82.80159378699996,
							27.957644489000117
						],
						[
							-82.80134352399995,
							27.95764594700006
						],
						[
							-82.8011142929999,
							27.95764453000003
						],
						[
							-82.8009931409999,
							27.95763698400012
						],
						[
							-82.80077039799995,
							27.95763587400003
						],
						[
							-82.80048230799991,
							27.95763376800003
						],
						[
							-82.80035840099988,
							27.957633113000064
						],
						[
							-82.80025927499995,
							27.957632658000115
						],
						[
							-82.80004892199995,
							27.957631475000106
						],
						[
							-82.80004807099996,
							27.957515960000052
						],
						[
							-82.8000462789999,
							27.957312437
						],
						[
							-82.80005101399993,
							27.957114377000046
						],
						[
							-82.80005137399988,
							27.956743063000054
						],
						[
							-82.80005193599993,
							27.95639925200003
						],
						[
							-82.80005363499988,
							27.956209461000043
						],
						[
							-82.80005250699989,
							27.955846407000116
						],
						[
							-82.80005141999989,
							27.95548885400011
						],
						[
							-82.80005313799987,
							27.955301813000084
						],
						[
							-82.8000505029999,
							27.95494426900008
						],
						[
							-82.80004786699995,
							27.95458672500007
						],
						[
							-82.80005272299991,
							27.954405166000058
						],
						[
							-82.80005028999997,
							27.95407512600011
						],
						[
							-82.80030430499995,
							27.954078117999998
						],
						[
							-82.80073953699988,
							27.954083151000063
						],
						[
							-82.8011840629999,
							27.954088471000055
						],
						[
							-82.80141329699985,
							27.95409126300011
						],
						[
							-82.80190583699994,
							27.95409698900005
						],
						[
							-82.80239837699992,
							27.95410271400008
						],
						[
							-82.80264241799995,
							27.95409854000009
						],
						[
							-82.80315415299992,
							27.95410174400009
						],
						[
							-82.80330128699993,
							27.954102261000045
						],
						[
							-82.80339886299991,
							27.95410306600011
						],
						[
							-82.80382633399994,
							27.954105727000062
						],
						[
							-82.8041360929999,
							27.954107356000108
						],
						[
							-82.80453907399993,
							27.954109815000045
						],
						[
							-82.80497864199991,
							27.954112402000085
						],
						[
							-82.80517371199996,
							27.95422678000004
						],
						[
							-82.80622766599994,
							27.954212359000095
						],
						[
							-82.80659212788692,
							27.954208323032177
						],
						[
							-82.80663755432838,
							27.95393939699927
						],
						[
							-82.80666547827732,
							27.953941520298585
						],
						[
							-82.80670814121511,
							27.9539519083673
						],
						[
							-82.80674855404916,
							27.95396907912287
						],
						[
							-82.80678564568694,
							27.953992577508153
						],
						[
							-82.80681843496818,
							27.954021782091708
						],
						[
							-82.80684605224828,
							27.954055918557277
						],
						[
							-82.80686776727805,
							27.95409408218695
						],
						[
							-82.8068830026925,
							27.95413526394131
						],
						[
							-82.80689135739422,
							27.954178371144096
						],
						[
							-82.8068926074518,
							27.95422226255576
						],
						[
							-82.80688743005489,
							27.95431993342475
						],
						[
							-82.80688166899792,
							27.954362876051626
						],
						[
							-82.80686910906651,
							27.954404343790472
						],
						[
							-82.80681154346338,
							27.954550801080856
						],
						[
							-82.80678946151023,
							27.954606531167713
						],
						[
							-82.80673009726311,
							27.954764244372697
						],
						[
							-82.80656698632733,
							27.955197447794184
						],
						[
							-82.80646975522683,
							27.95545525374233
						],
						[
							-82.80646758246486,
							27.955460828639588
						],
						[
							-82.80640418925498,
							27.955618250464227
						],
						[
							-82.80634492753047,
							27.95584236601053
						],
						[
							-82.80634307672581,
							27.95584902189286
						],
						[
							-82.806273235377,
							27.956088191190656
						],
						[
							-82.8062209164186,
							27.956331848105293
						],
						[
							-82.80621452313838,
							27.95635607943806
						],
						[
							-82.80613268123633,
							27.956616555473293
						],
						[
							-82.80599921195466,
							27.957163709291187
						],
						[
							-82.80599703919269,
							27.957172035214604
						],
						[
							-82.80591949335209,
							27.957450973431747
						],
						[
							-82.80590443870123,
							27.957491942946106
						],
						[
							-82.80588297548168,
							27.95752994829511
						],
						[
							-82.80585566397103,
							27.957563995727803
						],
						[
							-82.80582322002945,
							27.957593194016216
						],
						[
							-82.80578649261713,
							27.957616777836975
						],
						[
							-82.80574644220988,
							27.95763413115496
						],
						[
							-82.80570411831651,
							27.957644799812115
						],
						[
							-82.8056606280025,
							27.957648503220277
						],
						[
							-82.80565682117235,
							27.957648518508755
						],
						[
							-82.80569499919115,
							27.957495999787817
						],
						[
							-82.80595713283839,
							27.956275207002733
						],
						[
							-82.80587265499987,
							27.95654407300011
						],
						[
							-82.80573710099993,
							27.95709977100008
						],
						[
							-82.80565955499992,
							27.957378709000068
						],
						[
							-82.80418825599995,
							27.957384563000105
						],
						[
							-82.80407578999989,
							27.957255949000036
						],
						[
							-82.80405176199994,
							27.95727259200008
						],
						[
							-82.80402646099989,
							27.957287180000044
						],
						[
							-82.80399959599988,
							27.957299714000015
						],
						[
							-82.80397150599995,
							27.957310536000108
						],
						[
							-82.8039396529999,
							27.957319317000035
						],
						[
							-82.80392692999992,
							27.95765013300005
						],
						[
							-82.80377205599989,
							27.957650694000012
						],
						[
							-82.8037132039999,
							27.957651038000037
						],
						[
							-82.80348089399986,
							27.957652051000125
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Harbor Oaks Homeowners Association",
				"RegionID": "343340"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.67529999999994,
					27.75556053300005,
					-82.66296999999992,
					27.76207000000005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.66300999999993,
							27.76207000000005
						],
						[
							-82.66300999999993,
							27.761285868000073
						],
						[
							-82.66300999999993,
							27.761060000000043
						],
						[
							-82.6630077719999,
							27.760656646000086
						],
						[
							-82.66300582899993,
							27.76030501400004
						],
						[
							-82.6630041919999,
							27.760008800000037
						],
						[
							-82.66300265899991,
							27.759731196000075
						],
						[
							-82.6629999999999,
							27.759250000000065
						],
						[
							-82.66299731599992,
							27.758898383000087
						],
						[
							-82.66299279499992,
							27.758306177000065
						],
						[
							-82.66298999999992,
							27.757940000000076
						],
						[
							-82.66298999999992,
							27.757621379000057
						],
						[
							-82.66298999999992,
							27.757460000000037
						],
						[
							-82.66298999999992,
							27.75719570600006
						],
						[
							-82.66298999999992,
							27.75705000000005
						],
						[
							-82.66298835799995,
							27.756936702000075
						],
						[
							-82.66298540799994,
							27.756733162000046
						],
						[
							-82.66298218999992,
							27.75651111800005
						],
						[
							-82.66297999999995,
							27.756360000000086
						],
						[
							-82.66297999999995,
							27.756210000000067
						],
						[
							-82.66297529799994,
							27.755956073000053
						],
						[
							-82.66296999999992,
							27.755670000000066
						],
						[
							-82.66334683499991,
							27.755666324000064
						],
						[
							-82.66360609599991,
							27.755663794000043
						],
						[
							-82.66399471699992,
							27.75566000300006
						],
						[
							-82.6644388549999,
							27.755655670000067
						],
						[
							-82.6647351279999,
							27.75565277900006
						],
						[
							-82.66530878399993,
							27.75564857700005
						],
						[
							-82.66575295399991,
							27.75564638900005
						],
						[
							-82.66688188499995,
							27.755640828000082
						],
						[
							-82.6672333219999,
							27.755638220000037
						],
						[
							-82.6675482789999,
							27.755635162000093
						],
						[
							-82.66784437099994,
							27.755632288000072
						],
						[
							-82.66819598099994,
							27.75562888500008
						],
						[
							-82.66884368399991,
							27.75562265700006
						],
						[
							-82.66911999999992,
							27.75562000000008
						],
						[
							-82.6694542489999,
							27.755613381000046
						],
						[
							-82.66975061999996,
							27.75560751200004
						],
						[
							-82.66995412299991,
							27.755603483000073
						],
						[
							-82.67012999999992,
							27.755600000000072
						],
						[
							-82.67034279199993,
							27.755600000000072
						],
						[
							-82.6707869729999,
							27.755600000000072
						],
						[
							-82.67113999999992,
							27.755600000000072
						],
						[
							-82.67114173499994,
							27.75559998300008
						],
						[
							-82.67141616399994,
							27.75559734500007
						],
						[
							-82.67158271599993,
							27.75559574300007
						],
						[
							-82.6718604809999,
							27.755593072000067
						],
						[
							-82.67213806799994,
							27.755590403000042
						],
						[
							-82.67241565499995,
							27.755587667000043
						],
						[
							-82.67284128699993,
							27.755583453000042
						],
						[
							-82.67311887199992,
							27.755580704000067
						],
						[
							-82.67335934399995,
							27.755576680000047
						],
						[
							-82.67361834999991,
							27.755571601000042
						],
						[
							-82.67389621799992,
							27.75556615300008
						],
						[
							-82.67426644799991,
							27.75556053300005
						],
						[
							-82.67484012999996,
							27.755565945000058
						],
						[
							-82.6750992119999,
							27.755568389000075
						],
						[
							-82.67526890399995,
							27.755570928000054
						],
						[
							-82.67526769999996,
							27.755742498000075
						],
						[
							-82.67526534199993,
							27.75591932900005
						],
						[
							-82.67526231699992,
							27.756146251000075
						],
						[
							-82.67525999999994,
							27.756473939000045
						],
						[
							-82.67526856299992,
							27.75672549300009
						],
						[
							-82.67527500699993,
							27.756902702000048
						],
						[
							-82.67528692099995,
							27.75715419700009
						],
						[
							-82.67529919599991,
							27.75735672600007
						],
						[
							-82.67529999999994,
							27.757961802000068
						],
						[
							-82.67529881399992,
							27.758329700000047
						],
						[
							-82.6752131959999,
							27.758377348000067
						],
						[
							-82.67510329699991,
							27.758437292000053
						],
						[
							-82.67487705699995,
							27.758553374000087
						],
						[
							-82.6745946609999,
							27.75869904700005
						],
						[
							-82.67432255599994,
							27.75884280100007
						],
						[
							-82.67397703499995,
							27.759021483000083
						],
						[
							-82.67357889599992,
							27.759244917000046
						],
						[
							-82.67339295499994,
							27.759357166000086
						],
						[
							-82.67326300799994,
							27.75945246100008
						],
						[
							-82.67307922399993,
							27.75958614500007
						],
						[
							-82.6728920239999,
							27.75971940600005
						],
						[
							-82.67258675199993,
							27.759936719000052
						],
						[
							-82.67232933699995,
							27.76011996300008
						],
						[
							-82.6720617709999,
							27.760310434000075
						],
						[
							-82.6717483999999,
							27.76052708800006
						],
						[
							-82.6714768139999,
							27.76069391100009
						],
						[
							-82.67126746899993,
							27.760811266000076
						],
						[
							-82.67115999999993,
							27.760870000000068
						],
						[
							-82.67103518599993,
							27.76093142500008
						],
						[
							-82.6708417449999,
							27.761025215000075
						],
						[
							-82.67040107299995,
							27.761218627000062
						],
						[
							-82.66991223699995,
							27.76137835900005
						],
						[
							-82.66939347599994,
							27.761499305000086
						],
						[
							-82.66889919499994,
							27.761581896000052
						],
						[
							-82.6684177869999,
							27.761633274000076
						],
						[
							-82.66793659399991,
							27.761645461000057
						],
						[
							-82.66732591499994,
							27.761646788000068
						],
						[
							-82.66686337899995,
							27.761650000000092
						],
						[
							-82.6662158709999,
							27.76166419200007
						],
						[
							-82.66567965199994,
							27.761701550000055
						],
						[
							-82.66541931099994,
							27.761724618000073
						],
						[
							-82.66399657499994,
							27.76169955000006
						],
						[
							-82.6637011919999,
							27.761793615000045
						],
						[
							-82.66320085299992,
							27.76197457300009
						],
						[
							-82.66300999999993,
							27.76207000000005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Jordan Park",
				"RegionID": "416369"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.47093240399994,
					30.439420678000094,
					-81.41967128899995,
					30.52283032200006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.45525116499994,
							30.51270966100009
						],
						[
							-81.45520866999993,
							30.512626330000046
						],
						[
							-81.4548270759999,
							30.511770774000066
						],
						[
							-81.45467057299993,
							30.511526007000047
						],
						[
							-81.4540943689999,
							30.510758867000053
						],
						[
							-81.45136180599991,
							30.508793035000053
						],
						[
							-81.45128834799993,
							30.508734116000088
						],
						[
							-81.44643650799992,
							30.504406147000058
						],
						[
							-81.44293361699994,
							30.501303133000075
						],
						[
							-81.43962838999994,
							30.498374312000067
						],
						[
							-81.43917053199993,
							30.498020945000064
						],
						[
							-81.43915319099995,
							30.49800721800006
						],
						[
							-81.43595955899991,
							30.49541456900005
						],
						[
							-81.43590413499993,
							30.495364843000065
						],
						[
							-81.43585301699994,
							30.495310699000072
						],
						[
							-81.43580655499994,
							30.49525251100005
						],
						[
							-81.4357650689999,
							30.49519067700004
						],
						[
							-81.43572884299994,
							30.495125622000046
						],
						[
							-81.43177206299993,
							30.487271577000058
						],
						[
							-81.42436701399993,
							30.48474511800004
						],
						[
							-81.42429911499994,
							30.48471850300007
						],
						[
							-81.42423370199992,
							30.484686257000075
						],
						[
							-81.4241712409999,
							30.484648608000043
						],
						[
							-81.4241121789999,
							30.484605825000074
						],
						[
							-81.4240569349999,
							30.48455821400006
						],
						[
							-81.42400590399991,
							30.48450611300007
						],
						[
							-81.42395944899994,
							30.484449894000075
						],
						[
							-81.42430233499994,
							30.482996292000053
						],
						[
							-81.42473876799994,
							30.48241438000008
						],
						[
							-81.4250782169999,
							30.482123424000065
						],
						[
							-81.42566012799995,
							30.481808222000044
						],
						[
							-81.42626628599993,
							30.481444528000058
						],
						[
							-81.4268481979999,
							30.481129325000044
						],
						[
							-81.42730887699992,
							30.480983848000047
						],
						[
							-81.42781804999993,
							30.48105658600008
						],
						[
							-81.4281817449999,
							30.48120206400006
						],
						[
							-81.42854543899995,
							30.481808222000044
						],
						[
							-81.4290546119999,
							30.482147671000067
						],
						[
							-81.4294667989999,
							30.482196163000083
						],
						[
							-81.43002446499992,
							30.481783976000088
						],
						[
							-81.43048514499992,
							30.480741384000055
						],
						[
							-81.43065486899991,
							30.47977153200009
						],
						[
							-81.43104280999995,
							30.478074290000055
						],
						[
							-81.43094582499992,
							30.47758936400004
						],
						[
							-81.43058212999995,
							30.47691046700004
						],
						[
							-81.4299274789999,
							30.476183077000087
						],
						[
							-81.42898187299996,
							30.475431442000062
						],
						[
							-81.42873940999993,
							30.475140486000047
						],
						[
							-81.42893337999993,
							30.474776791000068
						],
						[
							-81.42924858299995,
							30.474728299000052
						],
						[
							-81.42978200099992,
							30.47475254500006
						],
						[
							-81.43036391299995,
							30.474728299000052
						],
						[
							-81.43065486899991,
							30.473952417000078
						],
						[
							-81.43048514499992,
							30.473661461000063
						],
						[
							-81.43033966699994,
							30.47307954900009
						],
						[
							-81.43058212999995,
							30.472182436000082
						],
						[
							-81.43048514499992,
							30.47184298700006
						],
						[
							-81.43024268099992,
							30.471794495000037
						],
						[
							-81.42970926299995,
							30.471794495000037
						],
						[
							-81.42854543899995,
							30.47172175600008
						],
						[
							-81.42813325199995,
							30.471479293000073
						],
						[
							-81.42810900599994,
							30.47101861300007
						],
						[
							-81.4281574979999,
							30.47055793300007
						],
						[
							-81.42830297599994,
							30.47036396200008
						],
						[
							-81.42912735099993,
							30.47038820800009
						],
						[
							-81.43002446499992,
							30.470606425000085
						],
						[
							-81.43026692799992,
							30.47043670100004
						],
						[
							-81.43220663299992,
							30.470097253000063
						],
						[
							-81.43249758899992,
							30.46983054300006
						],
						[
							-81.43290977599992,
							30.469103154000038
						],
						[
							-81.43370990399991,
							30.46878795200007
						],
						[
							-81.43412209199994,
							30.468521242000065
						],
						[
							-81.43402510599992,
							30.46820604000004
						],
						[
							-81.43358867299992,
							30.46808480900006
						],
						[
							-81.43274005199993,
							30.467866592000064
						],
						[
							-81.4319641699999,
							30.467599882000062
						],
						[
							-81.43179444599991,
							30.46672701500006
						],
						[
							-81.4312852729999,
							30.466120857000078
						],
						[
							-81.43133376599991,
							30.46592688700008
						],
						[
							-81.43147924299991,
							30.465805655000057
						],
						[
							-81.43208540099994,
							30.46532072900004
						],
						[
							-81.43189143099994,
							30.46483580300008
						],
						[
							-81.43177019899991,
							30.464302384000067
						],
						[
							-81.43162472099993,
							30.46403567400006
						],
						[
							-81.43143075099994,
							30.463817457000058
						],
						[
							-81.43145499699995,
							30.463478009000085
						],
						[
							-81.4317459529999,
							30.462411171000042
						],
						[
							-81.43172170699995,
							30.461974738000038
						],
						[
							-81.43157622899992,
							30.46180501300006
						],
						[
							-81.43109130199991,
							30.461901999000073
						],
						[
							-81.43080034699994,
							30.46202323000006
						],
						[
							-81.4301941889999,
							30.462265693000063
						],
						[
							-81.42890913399992,
							30.462192954000045
						],
						[
							-81.42854543899995,
							30.462095969000075
						],
						[
							-81.42786654299994,
							30.461756521000037
						],
						[
							-81.4279635279999,
							30.460786668000086
						],
						[
							-81.42765511199991,
							30.460137788000058
						],
						[
							-81.42763498199992,
							30.45996909400009
						],
						[
							-81.42781804999993,
							30.459162165000066
						],
						[
							-81.42767257199995,
							30.458652993000044
						],
						[
							-81.42696942899994,
							30.45748916900004
						],
						[
							-81.42699367499995,
							30.457028489000038
						],
						[
							-81.42716339999993,
							30.456640548000053
						],
						[
							-81.42716339999993,
							30.456179868000053
						],
						[
							-81.42694518299993,
							30.455961652000042
						],
						[
							-81.42641176399991,
							30.455500972000042
						],
						[
							-81.42602382299992,
							30.45491906000007
						],
						[
							-81.42650874899994,
							30.454264410000068
						],
						[
							-81.42755134099991,
							30.453512774000043
						],
						[
							-81.42936981399993,
							30.452179227000048
						],
						[
							-81.42915159699993,
							30.45164580800008
						],
						[
							-81.42873940999993,
							30.451136635000065
						],
						[
							-81.4281574979999,
							30.45060321600005
						],
						[
							-81.42779380399992,
							30.45038499900005
						],
						[
							-81.42718764599994,
							30.450530477000086
						],
						[
							-81.42624203999992,
							30.450869926000053
						],
						[
							-81.42500547799995,
							30.45130635900006
						],
						[
							-81.42345371399995,
							30.451694300000046
						],
						[
							-81.42260509299992,
							30.451524576000054
						],
						[
							-81.42185345699994,
							30.451136635000065
						],
						[
							-81.42048057099993,
							30.449848299000053
						],
						[
							-81.42020254199991,
							30.44947759300004
						],
						[
							-81.42014316399991,
							30.449387661000063
						],
						[
							-81.42009453499992,
							30.449290254000065
						],
						[
							-81.41988490599994,
							30.448797823000064
						],
						[
							-81.41973910399992,
							30.448467726000047
						],
						[
							-81.41967128899995,
							30.44808160000008
						],
						[
							-81.41995612699992,
							30.44640905300008
						],
						[
							-81.42043466299992,
							30.44522906200007
						],
						[
							-81.42115031399993,
							30.44364452400004
						],
						[
							-81.4213083219999,
							30.44007806500008
						],
						[
							-81.42132591399991,
							30.44001241400008
						],
						[
							-81.42139216399994,
							30.43987033900004
						],
						[
							-81.42148207899993,
							30.439741927000053
						],
						[
							-81.42159292699995,
							30.439631079000037
						],
						[
							-81.42172133899993,
							30.439541164000048
						],
						[
							-81.42186341399992,
							30.439474914000073
						],
						[
							-81.42201483399992,
							30.439434341000037
						],
						[
							-81.42217099999993,
							30.439420678000094
						],
						[
							-81.4223271649999,
							30.439434341000037
						],
						[
							-81.4223649839999,
							30.43944184800006
						],
						[
							-81.43060398399992,
							30.441261849000053
						],
						[
							-81.43065981099994,
							30.44127607100006
						],
						[
							-81.4389598109999,
							30.443676071000084
						],
						[
							-81.43901758599992,
							30.443694914000048
						],
						[
							-81.4391596609999,
							30.443761165000073
						],
						[
							-81.43928807299994,
							30.44385108000006
						],
						[
							-81.43939891999992,
							30.44396192700009
						],
						[
							-81.4394888349999,
							30.444090339000066
						],
						[
							-81.43952786599993,
							30.444183140000064
						],
						[
							-81.43963292699993,
							30.44407807900006
						],
						[
							-81.43976133899992,
							30.443988164000075
						],
						[
							-81.4399034139999,
							30.443921914000043
						],
						[
							-81.4400548349999,
							30.443881341000065
						],
						[
							-81.44021099999992,
							30.443867678000064
						],
						[
							-81.44045799999992,
							30.443867678000064
						],
						[
							-81.44052700099991,
							30.44387032900005
						],
						[
							-81.44059559399994,
							30.443878266000073
						],
						[
							-81.44066337699991,
							30.44389144300004
						],
						[
							-81.44072994899994,
							30.443909781000063
						],
						[
							-81.44079491699995,
							30.443933173000065
						],
						[
							-81.44175068899995,
							30.444319660000076
						],
						[
							-81.4417794119999,
							30.44433225700004
						],
						[
							-81.44186201499991,
							30.44437147800005
						],
						[
							-81.44378551599993,
							30.44615117800004
						],
						[
							-81.44380485799991,
							30.446209676000077
						],
						[
							-81.44383665899994,
							30.446335835000074
						],
						[
							-81.44385032199995,
							30.446492000000035
						],
						[
							-81.44383665899994,
							30.44664816600005
						],
						[
							-81.4437960859999,
							30.446799587000047
						],
						[
							-81.44377819999994,
							30.44684487400008
						],
						[
							-81.44356319999993,
							30.447348873000067
						],
						[
							-81.4435148359999,
							30.447445661000074
						],
						[
							-81.44345437599992,
							30.447532007000063
						],
						[
							-81.44611921599994,
							30.448485058000077
						],
						[
							-81.44626366099993,
							30.448552164000038
						],
						[
							-81.44636533099994,
							30.448620497000036
						],
						[
							-81.44698133199995,
							30.449098498000065
						],
						[
							-81.44700807299995,
							30.449120080000053
						],
						[
							-81.44711892099991,
							30.449230927000087
						],
						[
							-81.4472088359999,
							30.44935933900007
						],
						[
							-81.44727508599993,
							30.449501414000057
						],
						[
							-81.4473139609999,
							30.449643493000053
						],
						[
							-81.44762196099992,
							30.45128849200006
						],
						[
							-81.44763268899993,
							30.45136283100004
						],
						[
							-81.44797068899993,
							30.454679831000078
						],
						[
							-81.44797532199993,
							30.45477100000005
						],
						[
							-81.44796608699994,
							30.454899553000075
						],
						[
							-81.44788776799993,
							30.45544182000009
						],
						[
							-81.44791220499991,
							30.455797329000067
						],
						[
							-81.44791424499994,
							30.455870764000053
						],
						[
							-81.44791028499992,
							30.455944120000083
						],
						[
							-81.44790034999994,
							30.456016909000084
						],
						[
							-81.4478845079999,
							30.456088643000047
						],
						[
							-81.44786286399994,
							30.456158846000054
						],
						[
							-81.44783556199991,
							30.456227047000088
						],
						[
							-81.44753056099995,
							30.456907047000072
						],
						[
							-81.44748883499996,
							30.45698866100008
						],
						[
							-81.44744756099995,
							30.45704760800004
						],
						[
							-81.4475592359999,
							30.45704116900004
						],
						[
							-81.44761099999994,
							30.45703967800006
						],
						[
							-81.4477671649999,
							30.457053341000062
						],
						[
							-81.4479185859999,
							30.45709391400004
						],
						[
							-81.44806066099994,
							30.457160164000072
						],
						[
							-81.44818907299992,
							30.457250079000058
						],
						[
							-81.4482999199999,
							30.457360927000078
						],
						[
							-81.44838983499994,
							30.457489339000066
						],
						[
							-81.44843682099992,
							30.45758291200008
						],
						[
							-81.4501288219999,
							30.46150691200006
						],
						[
							-81.45015334599992,
							30.46157026600008
						],
						[
							-81.45017301699994,
							30.46163529100005
						],
						[
							-81.45018772399993,
							30.46170161600008
						],
						[
							-81.45019738199994,
							30.461768861000053
						],
						[
							-81.45020538099993,
							30.461844861000092
						],
						[
							-81.45021032199992,
							30.461939000000086
						],
						[
							-81.45019665899991,
							30.46209516600004
						],
						[
							-81.45015608599994,
							30.462246586000052
						],
						[
							-81.4500898359999,
							30.462388661000034
						],
						[
							-81.44999992099991,
							30.46251707300007
						],
						[
							-81.44988907299995,
							30.46262792100003
						],
						[
							-81.44976066099991,
							30.462717836000085
						],
						[
							-81.44970615199992,
							30.46274685900005
						],
						[
							-81.44961415199992,
							30.46279185900005
						],
						[
							-81.44952658599993,
							30.462829087000046
						],
						[
							-81.44944488499993,
							30.462854492000076
						],
						[
							-81.44898496899992,
							30.46297383600006
						],
						[
							-81.45113338899995,
							30.46450695600004
						],
						[
							-81.45118907299992,
							30.464550080000038
						],
						[
							-81.45129991999994,
							30.46466092700007
						],
						[
							-81.45138983499993,
							30.46478933900005
						],
						[
							-81.45145608599995,
							30.464931414000038
						],
						[
							-81.45149665899993,
							30.465082835000093
						],
						[
							-81.45150839399992,
							30.46521697100008
						],
						[
							-81.45248111599994,
							30.46505142600006
						],
						[
							-81.45263199999994,
							30.46503867800004
						],
						[
							-81.45278816599995,
							30.46505234100005
						],
						[
							-81.4529395859999,
							30.465092914000085
						],
						[
							-81.45308166099994,
							30.465159164000053
						],
						[
							-81.45321007299992,
							30.46524907900005
						],
						[
							-81.45332092099994,
							30.465359927000065
						],
						[
							-81.45337678999994,
							30.465433948000054
						],
						[
							-81.45503040999995,
							30.46787734300005
						],
						[
							-81.45596054799995,
							30.468689614000084
						],
						[
							-81.45605792099991,
							30.468788927000052
						],
						[
							-81.4561281899999,
							30.468884909000057
						],
						[
							-81.45728116399994,
							30.470700595000043
						],
						[
							-81.4573482799999,
							30.470737385000064
						],
						[
							-81.45741323599992,
							30.47077664400007
						],
						[
							-81.45747465199992,
							30.470821240000078
						],
						[
							-81.45753208799994,
							30.47087085500004
						],
						[
							-81.45758513599992,
							30.47092513700005
						],
						[
							-81.45763341799994,
							30.470983699000044
						],
						[
							-81.45796139399994,
							30.47141758300006
						],
						[
							-81.45818543199994,
							30.47173406100006
						],
						[
							-81.45824108699992,
							30.471853414000066
						],
						[
							-81.45826281899991,
							30.471920226000066
						],
						[
							-81.45827909499991,
							30.471988573000093
						],
						[
							-81.45828980899995,
							30.47205800900008
						],
						[
							-81.45829488999995,
							30.472128084000076
						],
						[
							-81.45829430599991,
							30.472198339000045
						],
						[
							-81.45828805999992,
							30.47226831900008
						],
						[
							-81.4582761929999,
							30.472337568000057
						],
						[
							-81.45830398999993,
							30.472373591000068
						],
						[
							-81.45834446399994,
							30.47243047800004
						],
						[
							-81.45838040399991,
							30.472490333000053
						],
						[
							-81.4584115909999,
							30.47255279700005
						],
						[
							-81.45843783999993,
							30.472617491000047
						],
						[
							-81.4584517529999,
							30.472661258000077
						],
						[
							-81.45845898999994,
							30.47268402600008
						],
						[
							-81.45847491599994,
							30.472752002000053
						],
						[
							-81.45848864599992,
							30.47282289800006
						],
						[
							-81.45851377799994,
							30.47295266000009
						],
						[
							-81.45852942099992,
							30.473001539000055
						],
						[
							-81.45890402899994,
							30.474795333000092
						],
						[
							-81.45873426199995,
							30.47684812200004
						],
						[
							-81.45871406799995,
							30.476977189000085
						],
						[
							-81.45822306799994,
							30.479094188000094
						],
						[
							-81.45821692599992,
							30.479119054000083
						],
						[
							-81.45709178399994,
							30.483410971000072
						],
						[
							-81.45723316599992,
							30.48342334000006
						],
						[
							-81.45738458599993,
							30.483463913000037
						],
						[
							-81.45752666099992,
							30.48353016400006
						],
						[
							-81.4576550729999,
							30.483620079000048
						],
						[
							-81.45776592099992,
							30.483730927000067
						],
						[
							-81.45785583599991,
							30.48385933900005
						],
						[
							-81.45788097499991,
							30.483913251000047
						],
						[
							-81.45793842699993,
							30.484667662000053
						],
						[
							-81.45822142999992,
							30.485354682000036
						],
						[
							-81.45844726899992,
							30.48640614500005
						],
						[
							-81.45845814299992,
							30.48646683800007
						],
						[
							-81.45846483299994,
							30.48652813300004
						],
						[
							-81.45846730699992,
							30.486589742000035
						],
						[
							-81.45846555299994,
							30.486651376000054
						],
						[
							-81.45836455299991,
							30.488259377000077
						],
						[
							-81.4583526589999,
							30.48835916600007
						],
						[
							-81.45831208599992,
							30.488510587000064
						],
						[
							-81.45824583599995,
							30.48865266100006
						],
						[
							-81.4581559209999,
							30.48878107300004
						],
						[
							-81.45804507299994,
							30.48889192100006
						],
						[
							-81.4579166609999,
							30.488981836000047
						],
						[
							-81.45788951199995,
							30.48899449600009
						],
						[
							-81.45795007299995,
							30.489038080000057
						],
						[
							-81.45801541799995,
							30.489098675000037
						],
						[
							-81.46105441799995,
							30.492210675000077
						],
						[
							-81.46109991999992,
							30.492260927000075
						],
						[
							-81.46116963899993,
							30.492356043000083
						],
						[
							-81.4658201979999,
							30.499661243000045
						],
						[
							-81.46697765099992,
							30.500768091000054
						],
						[
							-81.46787349399995,
							30.501630613000092
						],
						[
							-81.46851101699991,
							30.502552361000088
						],
						[
							-81.46945901299995,
							30.503181066000085
						],
						[
							-81.4707799919999,
							30.50506282100008
						],
						[
							-81.47093240399994,
							30.50653206600009
						],
						[
							-81.47056652899994,
							30.50792146400005
						],
						[
							-81.47051091399993,
							30.50796919700008
						],
						[
							-81.47045142399992,
							30.508012005000065
						],
						[
							-81.47038849499995,
							30.508049573000047
						],
						[
							-81.47032258699994,
							30.50808162900006
						],
						[
							-81.47025418099992,
							30.50810793700009
						],
						[
							-81.47018377699993,
							30.508128305000074
						],
						[
							-81.46956177699991,
							30.508284305000075
						],
						[
							-81.46949916499995,
							30.508297659000053
						],
						[
							-81.46938364899995,
							30.50831040300005
						],
						[
							-81.4663330759999,
							30.50844842800007
						],
						[
							-81.46547288399995,
							30.508493710000035
						],
						[
							-81.46560648999991,
							30.50853175700007
						],
						[
							-81.4656266259999,
							30.508537797000084
						],
						[
							-81.4660268849999,
							30.508672819000083
						],
						[
							-81.46645157799992,
							30.508771161000084
						],
						[
							-81.46697729599992,
							30.50875320200004
						],
						[
							-81.46700799999991,
							30.50875267800006
						],
						[
							-81.46716474699991,
							30.50876644300007
						],
						[
							-81.4678463269999,
							30.50888754600004
						],
						[
							-81.46799658599991,
							30.50892791400008
						],
						[
							-81.46812949899994,
							30.50898894600005
						],
						[
							-81.46859507999994,
							30.50925055500005
						],
						[
							-81.46872807299991,
							30.50934308000007
						],
						[
							-81.46883891999994,
							30.509453927000038
						],
						[
							-81.46892883499993,
							30.509582339000076
						],
						[
							-81.46899508599995,
							30.50972441400006
						],
						[
							-81.46903565899993,
							30.50987583500006
						],
						[
							-81.46904751599993,
							30.50997504500009
						],
						[
							-81.4690765169999,
							30.510432045000073
						],
						[
							-81.46907731699991,
							30.51045730300007
						],
						[
							-81.4661270819999,
							30.51487503000004
						],
						[
							-81.46604536899991,
							30.514960523000074
						],
						[
							-81.46603372899995,
							30.515024349000043
						],
						[
							-81.46602185299992,
							30.51506815900007
						],
						[
							-81.46566127299991,
							30.515729939000042
						],
						[
							-81.46391388399991,
							30.518453324000063
						],
						[
							-81.46342191799994,
							30.51933518200008
						],
						[
							-81.46188680799992,
							30.521807729000045
						],
						[
							-81.46054340199993,
							30.52268419600006
						],
						[
							-81.46050166099991,
							30.522709836000047
						],
						[
							-81.46035958699991,
							30.522776086000082
						],
						[
							-81.46020816599992,
							30.522816659000057
						],
						[
							-81.4600519999999,
							30.52283032200006
						],
						[
							-81.45989583499994,
							30.522816659000057
						],
						[
							-81.45985426699991,
							30.522808315000074
						],
						[
							-81.45901126599995,
							30.52261831500005
						],
						[
							-81.45896146399991,
							30.522605585000065
						],
						[
							-81.45847946299995,
							30.522467584000086
						],
						[
							-81.45840619699993,
							30.522443167000063
						],
						[
							-81.45833529999993,
							30.522412547000044
						],
						[
							-81.45826729599992,
							30.522375948000047
						],
						[
							-81.45820268599994,
							30.52233364300008
						],
						[
							-81.45814194999991,
							30.52228594500008
						],
						[
							-81.45787197399994,
							30.52204996800009
						],
						[
							-81.45777507899993,
							30.52195107400007
						],
						[
							-81.45768650899993,
							30.52182498200006
						],
						[
							-81.45746850899991,
							30.52144998200004
						],
						[
							-81.45743062799994,
							30.521377407000045
						],
						[
							-81.45742240699991,
							30.52135973900005
						],
						[
							-81.45729715099992,
							30.52132082000009
						],
						[
							-81.45722611999992,
							30.52129543700005
						],
						[
							-81.45715746699994,
							30.521264191000057
						],
						[
							-81.45709167299992,
							30.521227302000057
						],
						[
							-81.4570292009999,
							30.521185029000037
						],
						[
							-81.45697049199993,
							30.521137669000044
						],
						[
							-81.4569159589999,
							30.52108555600006
						],
						[
							-81.45660589099992,
							30.52076331300009
						],
						[
							-81.4563719539999,
							30.520611728000063
						],
						[
							-81.4563140599999,
							30.520570888000066
						],
						[
							-81.45625955999992,
							30.520525618000082
						],
						[
							-81.45620879299992,
							30.52047619800004
						],
						[
							-81.4561620739999,
							30.520422935000056
						],
						[
							-81.45611969299995,
							30.520366160000037
						],
						[
							-81.45585869399991,
							30.519986161000077
						],
						[
							-81.45582116499992,
							30.51992666100006
						],
						[
							-81.4557549139999,
							30.519784587000064
						],
						[
							-81.45571434099992,
							30.51963316600006
						],
						[
							-81.45570067799991,
							30.519477000000055
						],
						[
							-81.45570228399993,
							30.519444259000068
						],
						[
							-81.45563491399992,
							30.51930058600004
						],
						[
							-81.4556162319999,
							30.519243368000048
						],
						[
							-81.45558098899994,
							30.51912178100008
						],
						[
							-81.4555354709999,
							30.51906012200004
						],
						[
							-81.45551351799992,
							30.519029027000048
						],
						[
							-81.45525507699995,
							30.518646020000066
						],
						[
							-81.4551815989999,
							30.51859840800006
						],
						[
							-81.45466132399991,
							30.518421223000075
						],
						[
							-81.45451033899991,
							30.51835183500009
						],
						[
							-81.4544437429999,
							30.518309381000055
						],
						[
							-81.45397874199995,
							30.517983382000068
						],
						[
							-81.45391692699991,
							30.517935921000063
						],
						[
							-81.45380607899995,
							30.517825073000036
						],
						[
							-81.4537161639999,
							30.51769666100006
						],
						[
							-81.45364991299994,
							30.517554586000077
						],
						[
							-81.4536093399999,
							30.517403166000065
						],
						[
							-81.45359567799994,
							30.517247000000054
						],
						[
							-81.4536093399999,
							30.517090834000047
						],
						[
							-81.45364991299994,
							30.516939414000035
						],
						[
							-81.45371976899992,
							30.51679120700004
						],
						[
							-81.45411006499995,
							30.516139127000088
						],
						[
							-81.45434843999993,
							30.515393982000035
						],
						[
							-81.45438752099994,
							30.51529315700009
						],
						[
							-81.45457551999993,
							30.51488315700004
						],
						[
							-81.45461524399991,
							30.514806474000068
						],
						[
							-81.45480624399995,
							30.514477474000046
						],
						[
							-81.45489507999991,
							30.51435092700007
						],
						[
							-81.4549437629999,
							30.514297434000074
						],
						[
							-81.45538076199995,
							30.513854434000052
						],
						[
							-81.45544292699992,
							30.513797080000078
						],
						[
							-81.45557143299993,
							30.51370711000004
						],
						[
							-81.4559205409999,
							30.513505665000082
						],
						[
							-81.4558653759999,
							30.51346642900006
						],
						[
							-81.45581362599995,
							30.51342278700008
						],
						[
							-81.4557656419999,
							30.51337503500008
						],
						[
							-81.45572174899992,
							30.513323497000048
						],
						[
							-81.45532274999994,
							30.51281549700008
						],
						[
							-81.45525116499994,
							30.51270966100009
						]
					],
					[
						[
							-81.4623080799999,
							30.509624927000058
						],
						[
							-81.46242090099992,
							30.509507315000064
						],
						[
							-81.46218812599994,
							30.509660757000063
						],
						[
							-81.46171975699991,
							30.510137379000074
						],
						[
							-81.46163617199994,
							30.51039968300006
						],
						[
							-81.46141422399995,
							30.511159240000037
						],
						[
							-81.46139369499991,
							30.51122107900005
						],
						[
							-81.46136874299992,
							30.511281268000065
						],
						[
							-81.46133949799992,
							30.511339494000083
						],
						[
							-81.4613061149999,
							30.511395448000087
						],
						[
							-81.46056782099993,
							30.512536810000086
						],
						[
							-81.46049052199994,
							30.512658161000047
						],
						[
							-81.46082365699993,
							30.512444873000046
						],
						[
							-81.46101142599991,
							30.512222584000085
						],
						[
							-81.46111440699991,
							30.511989118000088
						],
						[
							-81.46170206099993,
							30.51053336000007
						],
						[
							-81.46175716399995,
							30.51042033900006
						],
						[
							-81.46179618499991,
							30.51035867400009
						],
						[
							-81.46225718599993,
							30.509691673000077
						],
						[
							-81.4623080799999,
							30.509624927000058
						]
					],
					[
						[
							-81.45395319599993,
							30.485628836000046
						],
						[
							-81.4540209189999,
							30.48536674500008
						],
						[
							-81.45392739099992,
							30.48555571000009
						],
						[
							-81.45395319599993,
							30.485628836000046
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Big Talbot Island",
				"RegionID": "416696"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.04891999999992,
					26.64454400000011,
					-80.04346299999996,
					26.675490000000153
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.0473802639999,
							26.675442416000124
						],
						[
							-80.04738864399961,
							26.67540680900011
						],
						[
							-80.04741764399988,
							26.67530880900017
						],
						[
							-80.04743422099965,
							26.675250495000142
						],
						[
							-80.04745668299982,
							26.675194187000102
						],
						[
							-80.04748479499975,
							26.67514047400001
						],
						[
							-80.04751825999995,
							26.67508992400009
						],
						[
							-80.04754239099981,
							26.674749130000137
						],
						[
							-80.04754836399977,
							26.67448291000014
						],
						[
							-80.0475241469998,
							26.67370504000008
						],
						[
							-80.04751137799973,
							26.673323702000147
						],
						[
							-80.04745713199986,
							26.67302423300015
						],
						[
							-80.04737844999974,
							26.672736740000076
						],
						[
							-80.04724287899991,
							26.67240904600032
						],
						[
							-80.04694516299969,
							26.67185920200012
						],
						[
							-80.04691273699984,
							26.67179296400015
						],
						[
							-80.04688584699976,
							26.67172429200015
						],
						[
							-80.04686467499987,
							26.671653647000078
						],
						[
							-80.04684936199975,
							26.671581505000148
						],
						[
							-80.04684001099969,
							26.671508351000135
						],
						[
							-80.04680401099982,
							26.671091351000094
						],
						[
							-80.04680180799983,
							26.670968937000445
						],
						[
							-80.04684580699981,
							26.67009193700018
						],
						[
							-80.04685143599974,
							26.670026958000044
						],
						[
							-80.04686943499972,
							26.669880958000043
						],
						[
							-80.04688610099969,
							26.669787086000092
						],
						[
							-80.04693010099986,
							26.669598086000086
						],
						[
							-80.04696091399965,
							26.669494414000035
						],
						[
							-80.0469806669996,
							26.669444780000013
						],
						[
							-80.04740154799978,
							26.668472389000115
						],
						[
							-80.04776000399987,
							26.667629621000195
						],
						[
							-80.04775811199971,
							26.667608485000045
						],
						[
							-80.0477280599998,
							26.667256908000176
						],
						[
							-80.04765331499992,
							26.666411783000505
						],
						[
							-80.04758045499976,
							26.665619335000308
						],
						[
							-80.04757810599983,
							26.665587651000173
						],
						[
							-80.0475584309998,
							26.66523886700009
						],
						[
							-80.04750052099972,
							26.664850696000215
						],
						[
							-80.04749302699972,
							26.66478295900003
						],
						[
							-80.0474200269998,
							26.66377495900047
						],
						[
							-80.04741775199989,
							26.663698449
						],
						[
							-80.0474219909998,
							26.663622022000162
						],
						[
							-80.0474327149997,
							26.663546233000197
						],
						[
							-80.04744984499979,
							26.663471630000508
						],
						[
							-80.04747325699987,
							26.663398754000518
						],
						[
							-80.04750278199973,
							26.663328134000004
						],
						[
							-80.04753820599981,
							26.663260280000255
						],
						[
							-80.04742935399969,
							26.66220258100005
						],
						[
							-80.04738984599972,
							26.661814385000078
						],
						[
							-80.04734568499978,
							26.661637741000384
						],
						[
							-80.04691507099986,
							26.660512401000176
						],
						[
							-80.04690630699984,
							26.660488490000063
						],
						[
							-80.04660730699982,
							26.6596354910001
						],
						[
							-80.04659212899979,
							26.65958801400034
						],
						[
							-80.04636193299983,
							26.658792622000078
						],
						[
							-80.04616448699994,
							26.658335804000117
						],
						[
							-80.04613609499971,
							26.65826118200016
						],
						[
							-80.04611443299979,
							26.658184336000197
						],
						[
							-80.04609967199973,
							26.6581058720001
						],
						[
							-80.0460919279997,
							26.658026408000097
						],
						[
							-80.04609126299982,
							26.657946570000064
						],
						[
							-80.04609768099982,
							26.65786698700014
						],
						[
							-80.04654236499994,
							26.65432478100016
						],
						[
							-80.04685972599981,
							26.652014981
						],
						[
							-80.04684944799985,
							26.651799659000126
						],
						[
							-80.0468421859997,
							26.65158525000006
						],
						[
							-80.04684399299984,
							26.65149050600004
						],
						[
							-80.04684712599975,
							26.651446935000074
						],
						[
							-80.04677015499986,
							26.651003839000182
						],
						[
							-80.04670961199973,
							26.650894501000373
						],
						[
							-80.0464474219998,
							26.650463646000162
						],
						[
							-80.04632871199975,
							26.650345541000426
						],
						[
							-80.04631223999989,
							26.6503287190001
						],
						[
							-80.04618824099985,
							26.65019871900018
						],
						[
							-80.04611316799968,
							26.650108988000127
						],
						[
							-80.04575731999972,
							26.649622555000114
						],
						[
							-80.0451944719997,
							26.648860122000535
						],
						[
							-80.04518153099978,
							26.648842132000112
						],
						[
							-80.04484508699983,
							26.648362061000448
						],
						[
							-80.0443015899998,
							26.647621018000333
						],
						[
							-80.04407346199984,
							26.647319059000125
						],
						[
							-80.04402292699966,
							26.647270506000105
						],
						[
							-80.04395707899981,
							26.64720007300005
						],
						[
							-80.04392120699968,
							26.647148842000163
						],
						[
							-80.04389751399985,
							26.647243385000085
						],
						[
							-80.04406624999979,
							26.64822222500007
						],
						[
							-80.0440793219997,
							26.64837500000001
						],
						[
							-80.04406565899974,
							26.64853116600014
						],
						[
							-80.04402508599975,
							26.648682586000056
						],
						[
							-80.04395883599986,
							26.648824661000177
						],
						[
							-80.04387903887533,
							26.648938622012537
						],
						[
							-80.04346299999996,
							26.644744000000138
						],
						[
							-80.04497788600274,
							26.644631703039252
						],
						[
							-80.04616099999991,
							26.64454400000011
						],
						[
							-80.04627339599678,
							26.64454476745785
						],
						[
							-80.04621821099995,
							26.64511412600003
						],
						[
							-80.04607999999986,
							26.645110000000045
						],
						[
							-80.0460728299999,
							26.64536813500018
						],
						[
							-80.04606470099993,
							26.64566075800014
						],
						[
							-80.0460599999999,
							26.64583000000011
						],
						[
							-80.04605704799992,
							26.64601890700002
						],
						[
							-80.04605349399989,
							26.64624636900001
						],
						[
							-80.04604999999987,
							26.64647000000013
						],
						[
							-80.0461136709999,
							26.646639790000144
						],
						[
							-80.04618588399984,
							26.646864883000028
						],
						[
							-80.04632761699993,
							26.647176138000113
						],
						[
							-80.04650841099988,
							26.6475731780001
						],
						[
							-80.04664121299994,
							26.647864821000162
						],
						[
							-80.04687668499979,
							26.64838193500014
						],
						[
							-80.04703627699985,
							26.648732412000097
						],
						[
							-80.04718999999997,
							26.64907000000014
						],
						[
							-80.04738955699986,
							26.649508053000055
						],
						[
							-80.04748053399993,
							26.64970775700006
						],
						[
							-80.04754695799991,
							26.649853567000044
						],
						[
							-80.04759999999986,
							26.649970000000174
						],
						[
							-80.0476991389999,
							26.650206832000052
						],
						[
							-80.04779585599982,
							26.65044439700008
						],
						[
							-80.04785202299985,
							26.65065745600021
						],
						[
							-80.04788317699985,
							26.650949097000094
						],
						[
							-80.04789713199993,
							26.651208657000076
						],
						[
							-80.0479129249999,
							26.651502406000134
						],
						[
							-80.04792426299987,
							26.651713298000175
						],
						[
							-80.04792999999991,
							26.65182000000012
						],
						[
							-80.04790656399992,
							26.65203573200003
						],
						[
							-80.04787010599992,
							26.65229549200003
						],
						[
							-80.04783999999982,
							26.65251000000019
						],
						[
							-80.04779629799994,
							26.652849903000163
						],
						[
							-80.04774999999994,
							26.653210000000023
						],
						[
							-80.04769814999992,
							26.653567767000048
						],
						[
							-80.04764999999993,
							26.653900000000093
						],
						[
							-80.04758717899996,
							26.654381627000063
						],
						[
							-80.04752999999994,
							26.65482000000019
						],
						[
							-80.04744182499992,
							26.655390545000053
						],
						[
							-80.04735701999992,
							26.655943176000036
						],
						[
							-80.04726799399992,
							26.65664207000013
						],
						[
							-80.04721758499993,
							26.65719656200018
						],
						[
							-80.04718999999997,
							26.657500000000063
						],
						[
							-80.04716475799991,
							26.657718761000133
						],
						[
							-80.04716510099985,
							26.657862026000174
						],
						[
							-80.04717982199992,
							26.658009111000176
						],
						[
							-80.04720547799991,
							26.65813738900013
						],
						[
							-80.04725951799995,
							26.658286045000175
						],
						[
							-80.04731999999989,
							26.658440000000034
						],
						[
							-80.04741699299991,
							26.658710913000156
						],
						[
							-80.0475210189999,
							26.65900146700004
						],
						[
							-80.04760999999989,
							26.659250000000085
						],
						[
							-80.04771354199994,
							26.659529113000175
						],
						[
							-80.04783999999982,
							26.659870000000048
						],
						[
							-80.04800455799995,
							26.660353390000076
						],
						[
							-80.04815999999992,
							26.660810000000197
						],
						[
							-80.04827999299982,
							26.66115103200017
						],
						[
							-80.04835346699986,
							26.661359535000102
						],
						[
							-80.04842999999988,
							26.66157000000002
						],
						[
							-80.04846830099986,
							26.661981732000157
						],
						[
							-80.04850999999984,
							26.66243000000012
						],
						[
							-80.04854921199988,
							26.662906146000083
						],
						[
							-80.04857999999986,
							26.66328000000011
						],
						[
							-80.04863132399993,
							26.663865950000094
						],
						[
							-80.0486556129999,
							26.664143252000127
						],
						[
							-80.04868555899981,
							26.664485136000167
						],
						[
							-80.04869999999993,
							26.664650000000133
						],
						[
							-80.04877196899993,
							26.665575998000186
						],
						[
							-80.04882504999989,
							26.66625898000003
						],
						[
							-80.0488499999999,
							26.666580000000124
						],
						[
							-80.04887901399991,
							26.66694060500003
						],
						[
							-80.04890523599995,
							26.66726650100017
						],
						[
							-80.04891999999992,
							26.667543272000067
						],
						[
							-80.04891792899993,
							26.667717248000077
						],
						[
							-80.0488478159999,
							26.667959746000065
						],
						[
							-80.04880999999989,
							26.668090000000184
						],
						[
							-80.04863991299993,
							26.668502126000178
						],
						[
							-80.04850999999984,
							26.668830000000128
						],
						[
							-80.04829837699992,
							26.669331848000084
						],
						[
							-80.04815999999992,
							26.669660000000057
						],
						[
							-80.04802926899994,
							26.669945974000093
						],
						[
							-80.0479416799999,
							26.670211068000178
						],
						[
							-80.04788692599989,
							26.670454588000077
						],
						[
							-80.04787016499992,
							26.67068374700012
						],
						[
							-80.0478526719999,
							26.67099279500011
						],
						[
							-80.04786633299996,
							26.67125232700009
						],
						[
							-80.04789537499988,
							26.671382467000022
						],
						[
							-80.04790999999993,
							26.671430000000136
						],
						[
							-80.04799397399995,
							26.671625938000183
						],
						[
							-80.04811200799988,
							26.671884016000043
						],
						[
							-80.04819986299994,
							26.672059725000103
						],
						[
							-80.04825999999986,
							26.672180000000196
						],
						[
							-80.04836947899985,
							26.672487911000186
						],
						[
							-80.04844094599991,
							26.672718440000164
						],
						[
							-80.04848645799984,
							26.672910600000073
						],
						[
							-80.04850999999984,
							26.673010000000126
						],
						[
							-80.04853695599985,
							26.67328555000019
						],
						[
							-80.04856091199979,
							26.6735304300002
						],
						[
							-80.0485847129999,
							26.67377373400008
						],
						[
							-80.04859999999992,
							26.67393000000004
						],
						[
							-80.0486213229999,
							26.674196542000068
						],
						[
							-80.04863834299991,
							26.674409285000173
						],
						[
							-80.04864998199989,
							26.674554778000044
						],
						[
							-80.04865999999991,
							26.6746800000001
						],
						[
							-80.04865999999991,
							26.674897031000032
						],
						[
							-80.0486588389999,
							26.67509226400011
						],
						[
							-80.0486534099998,
							26.675336546000068
						],
						[
							-80.04864999999997,
							26.675490000000153
						],
						[
							-80.04839211799985,
							26.675481330000146
						],
						[
							-80.0473802639999,
							26.675442416000124
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "West Palm Beach",
				"Name": "South Flagler Drive",
				"RegionID": "416910"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.8126878949999,
					26.15552540500005,
					-81.79710516299993,
					26.168520295000064
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.79919095499991,
							26.167493033000085
						],
						[
							-81.79915008499995,
							26.16730996800004
						],
						[
							-81.7990111979999,
							26.16639290300009
						],
						[
							-81.7987653749999,
							26.16511306400008
						],
						[
							-81.79866176199994,
							26.164573618000077
						],
						[
							-81.79858999999993,
							26.16420000000005
						],
						[
							-81.79842561999993,
							26.163403669000047
						],
						[
							-81.79823943899993,
							26.162501728000056
						],
						[
							-81.79817276599994,
							26.16217873400007
						],
						[
							-81.79813999999993,
							26.16202000000004
						],
						[
							-81.79805504099994,
							26.16162069300009
						],
						[
							-81.79793040699992,
							26.161031636000075
						],
						[
							-81.7977929459999,
							26.16033860200008
						],
						[
							-81.79769999999992,
							26.15987000000007
						],
						[
							-81.79761129999991,
							26.15943027600008
						],
						[
							-81.79750989199994,
							26.158927550000044
						],
						[
							-81.79735880099992,
							26.15817852300006
						],
						[
							-81.79710516299993,
							26.157545837000043
						],
						[
							-81.7972299999999,
							26.157540000000044
						],
						[
							-81.79742711199994,
							26.157520289000047
						],
						[
							-81.79763784199992,
							26.15751083100008
						],
						[
							-81.79786210299994,
							26.157500937000066
						],
						[
							-81.79802115599995,
							26.157493920000036
						],
						[
							-81.79810999999995,
							26.157490000000053
						],
						[
							-81.79821730799995,
							26.157475692000048
						],
						[
							-81.79828926699993,
							26.157461220000073
						],
						[
							-81.79839811999994,
							26.157428564000043
						],
						[
							-81.79856087399992,
							26.157377904000047
						],
						[
							-81.79871976599992,
							26.157327347000034
						],
						[
							-81.7988427439999,
							26.157288218000076
						],
						[
							-81.79898443499991,
							26.15725436400004
						],
						[
							-81.79912936399995,
							26.157227525000053
						],
						[
							-81.79929956599995,
							26.157208221000076
						],
						[
							-81.7994180529999,
							26.157200550000084
						],
						[
							-81.7995630129999,
							26.157203392000042
						],
						[
							-81.79974776699993,
							26.15720701500004
						],
						[
							-81.79989999999992,
							26.15721000000008
						],
						[
							-81.80017093299995,
							26.157209006000073
						],
						[
							-81.8003404349999,
							26.157190395000047
						],
						[
							-81.80057811499995,
							26.157153979000043
						],
						[
							-81.8007350819999,
							26.157123312000067
						],
						[
							-81.8009328309999,
							26.157070578000063
						],
						[
							-81.80107933099993,
							26.157023334000087
						],
						[
							-81.80122774499995,
							26.156966252000075
						],
						[
							-81.8013991279999,
							26.156900336000035
						],
						[
							-81.80159026399991,
							26.156837086000053
						],
						[
							-81.80174484599992,
							26.156800041000054
						],
						[
							-81.80194907399994,
							26.156769244000092
						],
						[
							-81.80217347599995,
							26.156760000000077
						],
						[
							-81.8023844089999,
							26.156760000000077
						],
						[
							-81.8025426079999,
							26.156760000000077
						],
						[
							-81.80273951599992,
							26.156740844000073
						],
						[
							-81.80288234099993,
							26.15670933100006
						],
						[
							-81.80298681199992,
							26.156679482000072
						],
						[
							-81.8031476779999,
							26.156623894000063
						],
						[
							-81.80326527499994,
							26.156581428000038
						],
						[
							-81.80340287099995,
							26.156532723000055
						],
						[
							-81.80346703499993,
							26.15651230700007
						],
						[
							-81.8035245069999,
							26.15649402100007
						],
						[
							-81.80360125999994,
							26.156469664000042
						],
						[
							-81.8036519129999,
							26.156456157000036
						],
						[
							-81.80370414899994,
							26.15644222700007
						],
						[
							-81.80375950299992,
							26.156427888000056
						],
						[
							-81.8038153789999,
							26.15641547100006
						],
						[
							-81.80386523899995,
							26.15640439100008
						],
						[
							-81.80389392799994,
							26.156398016000082
						],
						[
							-81.8039141729999,
							26.156393517000083
						],
						[
							-81.80394497499992,
							26.156386672000053
						],
						[
							-81.8039824359999,
							26.15637834800009
						],
						[
							-81.8040033929999,
							26.156373690000066
						],
						[
							-81.80401794099993,
							26.156370458000083
						],
						[
							-81.8040276449999,
							26.15636933500008
						],
						[
							-81.80405936299991,
							26.156366577000085
						],
						[
							-81.80408709999995,
							26.15636416500007
						],
						[
							-81.8041325069999,
							26.156360217000042
						],
						[
							-81.80419568699995,
							26.15635472300005
						],
						[
							-81.80427830899993,
							26.156347822000043
						],
						[
							-81.8043810989999,
							26.156339915000046
						],
						[
							-81.80443583699991,
							26.156335705000064
						],
						[
							-81.80461057899993,
							26.156331649000037
						],
						[
							-81.8049306129999,
							26.156336895000038
						],
						[
							-81.80519930199995,
							26.15633766800005
						],
						[
							-81.80532715499993,
							26.15633390700009
						],
						[
							-81.80545999999993,
							26.156330000000082
						],
						[
							-81.8056470919999,
							26.15632280400007
						],
						[
							-81.80580196199992,
							26.156308291000073
						],
						[
							-81.80600388699992,
							26.15627697800005
						],
						[
							-81.8061894789999,
							26.156235545000072
						],
						[
							-81.8063090739999,
							26.15619874700008
						],
						[
							-81.80643102399995,
							26.15615807000006
						],
						[
							-81.8065987139999,
							26.156097806000048
						],
						[
							-81.8067056669999,
							26.156059370000037
						],
						[
							-81.80680128699993,
							26.15602500600005
						],
						[
							-81.80686892599994,
							26.15600069800007
						],
						[
							-81.8068910319999,
							26.155992754000067
						],
						[
							-81.8069285599999,
							26.155979267000077
						],
						[
							-81.80694445599994,
							26.15597355500006
						],
						[
							-81.8069627239999,
							26.15596699000008
						],
						[
							-81.80699187499994,
							26.15595651400008
						],
						[
							-81.80700871699992,
							26.15595046100009
						],
						[
							-81.80704876599992,
							26.15594261600006
						],
						[
							-81.80708741599994,
							26.155935254000042
						],
						[
							-81.80714839599995,
							26.155923639000036
						],
						[
							-81.80721968599994,
							26.155910060000053
						],
						[
							-81.80726849399991,
							26.155902539000067
						],
						[
							-81.8073107049999,
							26.155896045000077
						],
						[
							-81.80734621499994,
							26.15589058200004
						],
						[
							-81.80745453899993,
							26.155890000000056
						],
						[
							-81.80748723199991,
							26.155890000000056
						],
						[
							-81.80752394099994,
							26.155890000000056
						],
						[
							-81.80757639399991,
							26.155890000000056
						],
						[
							-81.80762818999995,
							26.155891130000043
						],
						[
							-81.80769376199993,
							26.155900174000067
						],
						[
							-81.80778870199993,
							26.155913269000056
						],
						[
							-81.80784074799993,
							26.155920448000074
						],
						[
							-81.80788404399993,
							26.15592642000007
						],
						[
							-81.80790999999994,
							26.15593000000007
						],
						[
							-81.8080412839999,
							26.15593000000007
						],
						[
							-81.80815400299991,
							26.15593000000007
						],
						[
							-81.80821999999995,
							26.15593000000007
						],
						[
							-81.80832246999995,
							26.15591255800007
						],
						[
							-81.8085074729999,
							26.155881068000042
						],
						[
							-81.80873656499995,
							26.155842074000077
						],
						[
							-81.8089664339999,
							26.15580294700004
						],
						[
							-81.80954523799994,
							26.155704428000035
						],
						[
							-81.8099085209999,
							26.155642592000053
						],
						[
							-81.80990999999995,
							26.15565200000009
						],
						[
							-81.81080028699995,
							26.15552540500005
						],
						[
							-81.81080181399994,
							26.155536037000047
						],
						[
							-81.81092781399991,
							26.156505037000045
						],
						[
							-81.81093293499993,
							26.15655553000005
						],
						[
							-81.81097165199992,
							26.157085945000063
						],
						[
							-81.8109950409999,
							26.15729377000008
						],
						[
							-81.81102367199992,
							26.15738529600009
						],
						[
							-81.81110099699993,
							26.157595437000055
						],
						[
							-81.81111839399995,
							26.15764758100005
						],
						[
							-81.81122339399991,
							26.157997581000075
						],
						[
							-81.81125000799994,
							26.158113795000077
						],
						[
							-81.8112950069999,
							26.15839479500005
						],
						[
							-81.81130328699993,
							26.158463187000052
						],
						[
							-81.81133308799991,
							26.15882504700005
						],
						[
							-81.81143493499991,
							26.159274520000054
						],
						[
							-81.81162360999991,
							26.15994407800008
						],
						[
							-81.81164264199992,
							26.160026174000052
						],
						[
							-81.81171764299995,
							26.16043617400004
						],
						[
							-81.8117232059999,
							26.16047027600007
						],
						[
							-81.8117892059999,
							26.160930275000055
						],
						[
							-81.81179201599991,
							26.16095168800007
						],
						[
							-81.81185513199995,
							26.161481859000048
						],
						[
							-81.81186209599991,
							26.161526792000075
						],
						[
							-81.81192716899994,
							26.161963513000046
						],
						[
							-81.81208665299994,
							26.162903577000066
						],
						[
							-81.81209197499993,
							26.16293927600009
						],
						[
							-81.8121262979999,
							26.16320614100005
						],
						[
							-81.81213980199993,
							26.16326465900005
						],
						[
							-81.81229652299993,
							26.163788011000065
						],
						[
							-81.81230213099991,
							26.16380753800007
						],
						[
							-81.81232375399992,
							26.163886175000073
						],
						[
							-81.81247297199991,
							26.164422174000038
						],
						[
							-81.81249739499992,
							26.16450358500009
						],
						[
							-81.81252688699993,
							26.164639119000075
						],
						[
							-81.81254688699994,
							26.164784119000046
						],
						[
							-81.81255474699994,
							26.164874859000065
						],
						[
							-81.81258077899993,
							26.165602785000093
						],
						[
							-81.81260590799991,
							26.165863802000047
						],
						[
							-81.81267570699993,
							26.166265748000058
						],
						[
							-81.8126878949999,
							26.166302617000042
						],
						[
							-81.81179648199992,
							26.166458984000087
						],
						[
							-81.81077579299995,
							26.166632965000076
						],
						[
							-81.81021680599991,
							26.166549117000045
						],
						[
							-81.81009103399992,
							26.166660914000094
						],
						[
							-81.80930806799995,
							26.166832188000058
						],
						[
							-81.8090924409999,
							26.16686419800004
						],
						[
							-81.80916669099992,
							26.167078960000083
						],
						[
							-81.80920366599992,
							26.16752265200006
						],
						[
							-81.80920366599992,
							26.167966343000046
						],
						[
							-81.80905576899995,
							26.168336085000078
						],
						[
							-81.80839023199991,
							26.168447008000044
						],
						[
							-81.80794654099992,
							26.16837306000008
						],
						[
							-81.80746587499993,
							26.168188188000045
						],
						[
							-81.80698520999994,
							26.167929369000035
						],
						[
							-81.80634099999992,
							26.16743400000007
						],
						[
							-81.80634347599994,
							26.16741802900009
						],
						[
							-81.80601042899993,
							26.16737362300006
						],
						[
							-81.8058427329999,
							26.167429522000077
						],
						[
							-81.80507412499992,
							26.16756926800008
						],
						[
							-81.80388627799994,
							26.16773696400009
						],
						[
							-81.80294997399994,
							26.167890686000078
						],
						[
							-81.80199969599994,
							26.168016458000068
						],
						[
							-81.80120313999993,
							26.168184154000073
						],
						[
							-81.80029478599994,
							26.16835185000008
						],
						[
							-81.80011311499993,
							26.16835185000008
						],
						[
							-81.79979169799992,
							26.16840774900004
						],
						[
							-81.79942029699993,
							26.168520295000064
						],
						[
							-81.79919095499991,
							26.167493033000085
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Collier",
				"City": "Naples",
				"Name": "Coquina Sands",
				"RegionID": "417053"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.79102532199994,
					26.115699272000086,
					-81.78013399999992,
					26.140355748000047
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.78023999999994,
							26.13546100000008
						],
						[
							-81.78023499999995,
							26.135234000000082
						],
						[
							-81.78080999999992,
							26.135248000000047
						],
						[
							-81.78082099999995,
							26.13506200000006
						],
						[
							-81.78127799999993,
							26.135151000000064
						],
						[
							-81.78186899999992,
							26.135047000000043
						],
						[
							-81.7826159999999,
							26.135082000000068
						],
						[
							-81.7826159999999,
							26.13471100000004
						],
						[
							-81.78267099999994,
							26.133976000000075
						],
						[
							-81.78271599999994,
							26.133363000000088
						],
						[
							-81.78278299999994,
							26.133203000000037
						],
						[
							-81.78277099999991,
							26.13317600000005
						],
						[
							-81.78276099999994,
							26.133105000000057
						],
						[
							-81.7827529999999,
							26.132733000000087
						],
						[
							-81.78274699999993,
							26.132225000000062
						],
						[
							-81.78274299999993,
							26.131920000000036
						],
						[
							-81.78273499999995,
							26.13137100000006
						],
						[
							-81.78270499999991,
							26.129409000000066
						],
						[
							-81.78265999999991,
							26.129196000000036
						],
						[
							-81.78262799999993,
							26.12909300000007
						],
						[
							-81.78261399999991,
							26.12899900000008
						],
						[
							-81.78260499999993,
							26.128221000000057
						],
						[
							-81.7825969999999,
							26.12730300000004
						],
						[
							-81.7825964999999,
							26.127296000000058
						],
						[
							-81.7825959999999,
							26.127289000000076
						],
						[
							-81.78255899999995,
							26.12379200000004
						],
						[
							-81.78261199999992,
							26.122299000000055
						],
						[
							-81.78260705399993,
							26.122150616000056
						],
						[
							-81.78271231799994,
							26.12212669200005
						],
						[
							-81.78292548999991,
							26.122061101000043
						],
						[
							-81.78321245299992,
							26.122143090000066
						],
						[
							-81.78326164599991,
							26.12228247200005
						],
						[
							-81.78343382399993,
							26.122430052000084
						],
						[
							-81.7836469959999,
							26.122454649000076
						],
						[
							-81.78388476499993,
							26.122339864000082
						],
						[
							-81.7839831519999,
							26.122085697000045
						],
						[
							-81.78413073199994,
							26.12181513300004
						],
						[
							-81.78436030199993,
							26.12147077800006
						],
						[
							-81.78452255799995,
							26.121221154000068
						],
						[
							-81.78484444199995,
							26.12097109000007
						],
						[
							-81.78487414199992,
							26.120629534000045
						],
						[
							-81.78487414199992,
							26.120332528000063
						],
						[
							-81.78514144799993,
							26.11984246800006
						],
						[
							-81.78528995099992,
							26.119471211000075
						],
						[
							-81.78527946299994,
							26.119231941000066
						],
						[
							-81.78513045299991,
							26.11882878100005
						],
						[
							-81.78512011799995,
							26.118799252000088
						],
						[
							-81.78492211799994,
							26.118200252000065
						],
						[
							-81.78488615699992,
							26.118072913000052
						],
						[
							-81.78490384299994,
							26.117689175000066
						],
						[
							-81.78499294499994,
							26.117243666000036
						],
						[
							-81.78528995099992,
							26.116619954000047
						],
						[
							-81.78543007999991,
							26.116376707000086
						],
						[
							-81.78548367699995,
							26.116318548000038
						],
						[
							-81.78556692699993,
							26.11623907900008
						],
						[
							-81.78564317999991,
							26.11618170400004
						],
						[
							-81.78581717999992,
							26.116064704000053
						],
						[
							-81.78586933899993,
							26.116032164000046
						],
						[
							-81.78596358199991,
							26.11598489000005
						],
						[
							-81.78622158199994,
							26.115873890000046
						],
						[
							-81.78626941399995,
							26.115854914000067
						],
						[
							-81.78640134599993,
							26.11581799900006
						],
						[
							-81.7866373459999,
							26.115770999000063
						],
						[
							-81.7867407089999,
							26.11575658800007
						],
						[
							-81.78717470999993,
							26.115721588000042
						],
						[
							-81.78721431899993,
							26.115719272000035
						],
						[
							-81.7877643189999,
							26.115699272000086
						],
						[
							-81.78788547599993,
							26.115703041000078
						],
						[
							-81.78814847599995,
							26.115729041000066
						],
						[
							-81.78821616599993,
							26.115738341000053
						],
						[
							-81.7883568869999,
							26.11577509600005
						],
						[
							-81.78853988599992,
							26.11583909600006
						],
						[
							-81.78865484799991,
							26.11588852500006
						],
						[
							-81.78885284799992,
							26.11599052400004
						],
						[
							-81.78887325199992,
							26.11599697500009
						],
						[
							-81.78970028399993,
							26.117041414000084
						],
						[
							-81.78973036799994,
							26.11710979600008
						],
						[
							-81.7897547469999,
							26.11716315500007
						],
						[
							-81.78993574599991,
							26.117596156000047
						],
						[
							-81.7899585369999,
							26.117656711000052
						],
						[
							-81.78997691399991,
							26.117718749000062
						],
						[
							-81.78999078399994,
							26.117781948000076
						],
						[
							-81.79000007299993,
							26.117845980000084
						],
						[
							-81.79000473499991,
							26.117910514000073
						],
						[
							-81.7900107349999,
							26.11807651400005
						],
						[
							-81.79001132199994,
							26.11810900000006
						],
						[
							-81.79000699999995,
							26.11815840400004
						],
						[
							-81.79005049799991,
							26.118210024000064
						],
						[
							-81.7900899519999,
							26.11826479700005
						],
						[
							-81.79012513499993,
							26.11832240700005
						],
						[
							-81.79015584299992,
							26.118382522000047
						],
						[
							-81.79018189899995,
							26.118444794000084
						],
						[
							-81.7903289219999,
							26.118836242000043
						],
						[
							-81.79039015699993,
							26.11896586900008
						],
						[
							-81.79042311899991,
							26.119045267000047
						],
						[
							-81.79070511999993,
							26.11982826700006
						],
						[
							-81.79072021899992,
							26.11987399700007
						],
						[
							-81.79092321799993,
							26.12054899700007
						],
						[
							-81.7909483009999,
							26.120655517000046
						],
						[
							-81.79101230099992,
							26.121027517000073
						],
						[
							-81.79102532199994,
							26.121180000000038
						],
						[
							-81.79102532199994,
							26.121301000000074
						],
						[
							-81.79101073899994,
							26.12146221400008
						],
						[
							-81.79099081999993,
							26.121568263000086
						],
						[
							-81.79095208599995,
							26.121709586000065
						],
						[
							-81.79088707699992,
							26.121849505000057
						],
						[
							-81.79053832199992,
							26.122457443000087
						],
						[
							-81.79010820199996,
							26.123362144000055
						],
						[
							-81.79008086199991,
							26.123415056000056
						],
						[
							-81.78991568399994,
							26.12371033000005
						],
						[
							-81.78993991499993,
							26.123769835000076
						],
						[
							-81.78996442999994,
							26.12383771800006
						],
						[
							-81.78998342299991,
							26.123907348000046
						],
						[
							-81.7899967699999,
							26.12397827700005
						],
						[
							-81.79000438799994,
							26.124050048000072
						],
						[
							-81.79002238699991,
							26.124324048000062
						],
						[
							-81.79002432199991,
							26.12438300000008
						],
						[
							-81.79001676799993,
							26.124499317000073
						],
						[
							-81.78999876799992,
							26.12463731700007
						],
						[
							-81.7899879659999,
							26.124701773000083
						],
						[
							-81.78997251099992,
							26.124765275000073
						],
						[
							-81.78995248599995,
							26.124827486000072
						],
						[
							-81.78992799499991,
							26.124888079000073
						],
						[
							-81.78983499499992,
							26.12509607900006
						],
						[
							-81.78979827899991,
							26.12516909800007
						],
						[
							-81.78963955699993,
							26.12545188000007
						],
						[
							-81.78954469099995,
							26.125587710000048
						],
						[
							-81.78914595499992,
							26.126055581000063
						],
						[
							-81.78910488599992,
							26.12631286000004
						],
						[
							-81.78906308599994,
							26.126471586000036
						],
						[
							-81.78901305599993,
							26.126584317000038
						],
						[
							-81.78893005599991,
							26.12674131700004
						],
						[
							-81.78891383599995,
							26.12677066100008
						],
						[
							-81.78883471799992,
							26.12688595600008
						],
						[
							-81.78877959999994,
							26.126954221000062
						],
						[
							-81.78878565899993,
							26.12697683400006
						],
						[
							-81.78879395399993,
							26.127034884000068
						],
						[
							-81.78881188699995,
							26.12719828300004
						],
						[
							-81.78881782099995,
							26.127251682000068
						],
						[
							-81.7888218409999,
							26.127402602000075
						],
						[
							-81.78881183999994,
							26.12757660200009
						],
						[
							-81.78879965899995,
							26.12768116600006
						],
						[
							-81.78877839699993,
							26.127773189000038
						],
						[
							-81.78874939699995,
							26.127874189000067
						],
						[
							-81.78872552799994,
							26.12794583300007
						],
						[
							-81.78869573199995,
							26.12801522300009
						],
						[
							-81.78866021999994,
							26.12808186700005
						],
						[
							-81.78861924099994,
							26.12814529800005
						],
						[
							-81.78857308599993,
							26.128205067000067
						],
						[
							-81.7885220789999,
							26.128260753000063
						],
						[
							-81.78846657899993,
							26.128311963000044
						],
						[
							-81.78837282699993,
							26.12839144200007
						],
						[
							-81.78830779799995,
							26.128437227000063
						],
						[
							-81.78829420199992,
							26.128492133000066
						],
						[
							-81.78805184499993,
							26.129246341000055
						],
						[
							-81.78786663699992,
							26.130208914000036
						],
						[
							-81.78795907299991,
							26.130276080000044
						],
						[
							-81.78800096399993,
							26.130313521000062
						],
						[
							-81.7880629629999,
							26.130372521000083
						],
						[
							-81.78812730899995,
							26.130440476000047
						],
						[
							-81.78823730999994,
							26.130569476000062
						],
						[
							-81.78832416299991,
							26.13069030400004
						],
						[
							-81.78836316299993,
							26.130755304000047
						],
						[
							-81.7884308859999,
							26.130893886000084
						],
						[
							-81.7884440119999,
							26.130927860000046
						],
						[
							-81.78849554899995,
							26.13096314900008
						],
						[
							-81.78884481099993,
							26.131244114000083
						],
						[
							-81.78896292099995,
							26.13136092700006
						],
						[
							-81.78903882999992,
							26.131465909000042
						],
						[
							-81.78909882999996,
							26.13156290900008
						],
						[
							-81.7891128359999,
							26.13158633900008
						],
						[
							-81.78912652399993,
							26.131614037000077
						],
						[
							-81.78918267799992,
							26.13173099800008
						],
						[
							-81.78919860199994,
							26.131761364000056
						],
						[
							-81.78923318799991,
							26.13182168900005
						],
						[
							-81.78925370899992,
							26.131860446000076
						],
						[
							-81.78932408599991,
							26.13200841400004
						],
						[
							-81.78935556099992,
							26.13211495200005
						],
						[
							-81.78938056099992,
							26.13222395100007
						],
						[
							-81.78938965899994,
							26.132268834000058
						],
						[
							-81.78940332199994,
							26.13242500000007
						],
						[
							-81.78939244999992,
							26.132564417000083
						],
						[
							-81.78934144999994,
							26.132889417000058
						],
						[
							-81.7893330309999,
							26.132935271000065
						],
						[
							-81.7892850309999,
							26.133163271000058
						],
						[
							-81.78924733399992,
							26.133293046000063
						],
						[
							-81.78915233399994,
							26.133547046000047
						],
						[
							-81.78911437799991,
							26.133634189000077
						],
						[
							-81.7888704479999,
							26.13412203600007
						],
						[
							-81.78879751599993,
							26.134269884000048
						],
						[
							-81.78875318999991,
							26.134349332000056
						],
						[
							-81.78853507799995,
							26.134697607000078
						],
						[
							-81.78863000799993,
							26.134916032000035
						],
						[
							-81.7887242239999,
							26.135133530000076
						],
						[
							-81.78877366099995,
							26.13528184000006
						],
						[
							-81.78881766099994,
							26.135465840000055
						],
						[
							-81.78883286599995,
							26.13553237600007
						],
						[
							-81.78884119499992,
							26.13560011800007
						],
						[
							-81.7888425619999,
							26.135668356000053
						],
						[
							-81.78883695199994,
							26.135736376000068
						],
						[
							-81.78886851599992,
							26.135851133000074
						],
						[
							-81.78888751599993,
							26.13595113300005
						],
						[
							-81.78890322299992,
							26.136105628000053
						],
						[
							-81.78890722499995,
							26.13637476300005
						],
						[
							-81.78891492699995,
							26.136903320000044
						],
						[
							-81.78891798299992,
							26.13695391300007
						],
						[
							-81.78834095799994,
							26.137520167000048
						],
						[
							-81.78807738299992,
							26.137949417000073
						],
						[
							-81.78795940599991,
							26.13838331900007
						],
						[
							-81.7878263899999,
							26.13866835200008
						],
						[
							-81.78777318399995,
							26.138877377000085
						],
						[
							-81.78751095399991,
							26.139208015000065
						],
						[
							-81.7872373219999,
							26.139519651000057
						],
						[
							-81.7869256859999,
							26.139838888000043
						],
						[
							-81.78676606699992,
							26.140040312000053
						],
						[
							-81.7866216509999,
							26.140355748000047
						],
						[
							-81.78640036099995,
							26.140217328000062
						],
						[
							-81.78608771799993,
							26.14005136800006
						],
						[
							-81.78502720199992,
							26.139478689000043
						],
						[
							-81.78432308799995,
							26.13909216400009
						],
						[
							-81.78364589499995,
							26.13871908100009
						],
						[
							-81.7830368839999,
							26.13838356100007
						],
						[
							-81.78244691299994,
							26.13804810000005
						],
						[
							-81.78235705599991,
							26.137992803000092
						],
						[
							-81.78235299999994,
							26.13790300000005
						],
						[
							-81.78182399999992,
							26.13758400000006
						],
						[
							-81.78133699999995,
							26.137281000000087
						],
						[
							-81.78034899999994,
							26.136640000000057
						],
						[
							-81.78013399999992,
							26.13649500000008
						],
						[
							-81.7802309999999,
							26.13636400000007
						],
						[
							-81.78024899999991,
							26.13632000000007
						],
						[
							-81.78025999999996,
							26.13625200000007
						],
						[
							-81.78025599999995,
							26.135939000000064
						],
						[
							-81.78023999999994,
							26.13546100000008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Collier",
				"City": "Naples",
				"Name": "Royal Harbor",
				"RegionID": "417055"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.54284999999993,
					27.35645886000009,
					-82.54080953099992,
					27.35979197100005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.54143611699993,
							27.35975372100006
						],
						[
							-82.54080953099992,
							27.35645886000009
						],
						[
							-82.54154999999992,
							27.356520000000046
						],
						[
							-82.54163571799997,
							27.356515714000068
						],
						[
							-82.5417273949999,
							27.356511130000058
						],
						[
							-82.54184950399991,
							27.356505025000047
						],
						[
							-82.54194999999993,
							27.35650000000004
						],
						[
							-82.54196656199991,
							27.356483438000055
						],
						[
							-82.54203434199991,
							27.356467132000034
						],
						[
							-82.54216976999993,
							27.356460000000084
						],
						[
							-82.54245959899993,
							27.356460000000084
						],
						[
							-82.54268078399991,
							27.356460000000084
						],
						[
							-82.5427509779999,
							27.356460293000055
						],
						[
							-82.54280695699993,
							27.356477087000087
						],
						[
							-82.54284999999993,
							27.356490000000065
						],
						[
							-82.54284763699991,
							27.356610507000088
						],
						[
							-82.54284479699993,
							27.356755366000073
						],
						[
							-82.54284210599991,
							27.356892601000084
						],
						[
							-82.5428399999999,
							27.357000000000085
						],
						[
							-82.5428391499999,
							27.35707560700007
						],
						[
							-82.54283795099991,
							27.357182373000057
						],
						[
							-82.54283692299992,
							27.357273886000087
						],
						[
							-82.54283503699992,
							27.357441747000053
						],
						[
							-82.54283349399992,
							27.357579017000035
						],
						[
							-82.54283143799995,
							27.357762043000037
						],
						[
							-82.54282999999992,
							27.357890000000054
						],
						[
							-82.54282999999992,
							27.35805952000004
						],
						[
							-82.54282999999992,
							27.35833409500009
						],
						[
							-82.54282999999992,
							27.358578161000082
						],
						[
							-82.54282999999992,
							27.358820000000037
						],
						[
							-82.54282870299994,
							27.35886021400006
						],
						[
							-82.54282648299994,
							27.35892903200005
						],
						[
							-82.54282352599995,
							27.359020708000063
						],
						[
							-82.54282131399992,
							27.359089280000035
						],
						[
							-82.54281999999995,
							27.359130000000054
						],
						[
							-82.54281999999995,
							27.359211209000083
						],
						[
							-82.54281999999995,
							27.359310361000045
						],
						[
							-82.54281999999995,
							27.359493410000084
						],
						[
							-82.5428153549999,
							27.359637872000064
						],
						[
							-82.54280916099992,
							27.359671510000055
						],
						[
							-82.5427857759999,
							27.359713603000046
						],
						[
							-82.54276742799993,
							27.35974663000008
						],
						[
							-82.54274492399992,
							27.35979197100005
						],
						[
							-82.54143611699993,
							27.35975372100006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Janie Poe",
				"RegionID": "417062"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.5256111139999,
					27.330265999000062,
					-82.52169196499995,
					27.335596081000062
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.5221859699999,
							27.335596081000062
						],
						[
							-82.52198070999992,
							27.33559000000008
						],
						[
							-82.52169196499995,
							27.33559000000008
						],
						[
							-82.52172825799994,
							27.333764080000037
						],
						[
							-82.52172826899994,
							27.33332287500008
						],
						[
							-82.52182959699991,
							27.333324510000068
						],
						[
							-82.52196777099994,
							27.33332673800004
						],
						[
							-82.52211530599993,
							27.33332911800005
						],
						[
							-82.52216999999992,
							27.333330000000046
						],
						[
							-82.52219109399994,
							27.33332852400008
						],
						[
							-82.5221864419999,
							27.330273084000055
						],
						[
							-82.52246273799994,
							27.330265999000062
						],
						[
							-82.52312087299993,
							27.33029268000007
						],
						[
							-82.5236811769999,
							27.33048834200008
						],
						[
							-82.52425037499997,
							27.330755154000087
						],
						[
							-82.52458833599991,
							27.330986390000078
						],
						[
							-82.52505080999993,
							27.331466651000085
						],
						[
							-82.52536208999993,
							27.33187576200004
						],
						[
							-82.52551328299995,
							27.332275979000087
						],
						[
							-82.52558443299995,
							27.332525004000047
						],
						[
							-82.5256111139999,
							27.332836284000052
						],
						[
							-82.5256111139999,
							27.333218714000054
						],
						[
							-82.52558443299995,
							27.33464170900004
						],
						[
							-82.52556669699995,
							27.335580483000058
						],
						[
							-82.52513291899993,
							27.33558413600008
						],
						[
							-82.52482002099993,
							27.33558739600005
						],
						[
							-82.5244470749999,
							27.33559000000008
						],
						[
							-82.52415769999993,
							27.33559581500009
						],
						[
							-82.5221859699999,
							27.335596081000062
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Terrace Gardens",
				"RegionID": "417069"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.5467787689999,
					27.33427000000006,
					-82.54059999999993,
					27.33886142500006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.54060657399992,
							27.335122949000038
						],
						[
							-82.54060129499993,
							27.33491180900006
						],
						[
							-82.54059999999993,
							27.33486000000005
						],
						[
							-82.54069219599995,
							27.334829268000078
						],
						[
							-82.54080999999991,
							27.334790000000055
						],
						[
							-82.5410407309999,
							27.335041394000086
						],
						[
							-82.5411499999999,
							27.334980000000087
						],
						[
							-82.54125664399993,
							27.33491035500009
						],
						[
							-82.5413459479999,
							27.33485203400005
						],
						[
							-82.54150202299991,
							27.334750108000037
						],
						[
							-82.54163999999992,
							27.334660000000042
						],
						[
							-82.54181762099996,
							27.334537357000045
						],
						[
							-82.54195603999995,
							27.334441782000056
						],
						[
							-82.54207938199994,
							27.334357886000078
						],
						[
							-82.54221999999993,
							27.33427000000006
						],
						[
							-82.54235714099991,
							27.334407141000042
						],
						[
							-82.54252918999993,
							27.33457070600008
						],
						[
							-82.5426707929999,
							27.334697136000045
						],
						[
							-82.54283306199994,
							27.334831134000073
						],
						[
							-82.5429898619999,
							27.334954572000072
						],
						[
							-82.54311235099995,
							27.335051000000078
						],
						[
							-82.5431999999999,
							27.335120000000074
						],
						[
							-82.54329935299995,
							27.335201820000066
						],
						[
							-82.54347215299993,
							27.335335504000057
						],
						[
							-82.54359999999991,
							27.335430000000088
						],
						[
							-82.54377096199995,
							27.33555822200009
						],
						[
							-82.54389542099995,
							27.33565156600008
						],
						[
							-82.54395999999991,
							27.335700000000088
						],
						[
							-82.5441305089999,
							27.335827882000046
						],
						[
							-82.54426111299995,
							27.33592583500007
						],
						[
							-82.54438403499995,
							27.336018027000083
						],
						[
							-82.54451183499992,
							27.336108978000084
						],
						[
							-82.54464384199991,
							27.336198983000088
						],
						[
							-82.54476044599994,
							27.336260223000068
						],
						[
							-82.54494098799995,
							27.336350494000044
						],
						[
							-82.54504865399991,
							27.33639546200004
						],
						[
							-82.54510999999991,
							27.33642000000009
						],
						[
							-82.54521999999992,
							27.336460000000045
						],
						[
							-82.54534708699993,
							27.336500133000072
						],
						[
							-82.5454645769999,
							27.336527347000075
						],
						[
							-82.54563562899995,
							27.33655037300008
						],
						[
							-82.54580921999991,
							27.336573741000056
						],
						[
							-82.54592999999994,
							27.336590000000058
						],
						[
							-82.54607819599994,
							27.336611512000047
						],
						[
							-82.54627979899993,
							27.33664077700007
						],
						[
							-82.54655911299994,
							27.336680911000087
						],
						[
							-82.5467787689999,
							27.33670287700005
						],
						[
							-82.54677389999995,
							27.338329473000044
						],
						[
							-82.54677050599992,
							27.33883138400006
						],
						[
							-82.54062999999991,
							27.33886142500006
						],
						[
							-82.54062999999991,
							27.338604485000076
						],
						[
							-82.54062999999991,
							27.33845000000008
						],
						[
							-82.54063494999991,
							27.338256966000074
						],
						[
							-82.54063799799991,
							27.33813807000007
						],
						[
							-82.54063999999994,
							27.33806000000004
						],
						[
							-82.54063999999994,
							27.33797493700007
						],
						[
							-82.54064257499994,
							27.337840483000036
						],
						[
							-82.54064650799995,
							27.337734282000042
						],
						[
							-82.54065183599994,
							27.33759043000009
						],
						[
							-82.54065538799995,
							27.337494529000082
						],
						[
							-82.54065964999995,
							27.337379447000046
						],
						[
							-82.54065143399993,
							27.33735115400009
						],
						[
							-82.54063696299994,
							27.337319319000073
						],
						[
							-82.5406099999999,
							27.33726000000007
						],
						[
							-82.54060664999992,
							27.337139388000082
						],
						[
							-82.54060238499994,
							27.33698585500008
						],
						[
							-82.54059999999993,
							27.33690000000007
						],
						[
							-82.54059999999993,
							27.336716908000085
						],
						[
							-82.54059999999993,
							27.336544049000054
						],
						[
							-82.54059999999993,
							27.33645000000007
						],
						[
							-82.54059999999993,
							27.336313570000073
						],
						[
							-82.54059999999993,
							27.336159918000078
						],
						[
							-82.54059999999993,
							27.336040000000082
						],
						[
							-82.54060379899994,
							27.33596782300009
						],
						[
							-82.54060989999994,
							27.335851894000086
						],
						[
							-82.54061393299992,
							27.335775280000064
						],
						[
							-82.54061999999993,
							27.335660000000075
						],
						[
							-82.5406176169999,
							27.33556466400006
						],
						[
							-82.54061497099991,
							27.33545885400008
						],
						[
							-82.54061209199995,
							27.335343686000044
						],
						[
							-82.5406099999999,
							27.335260000000062
						],
						[
							-82.54060657399992,
							27.335122949000038
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "5 Points",
				"RegionID": "417071"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.73459099999991,
					27.76253600000007,
					-82.71211699999992,
					27.769350000000088
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.71791476099992,
							27.764580000000084
						],
						[
							-82.71733072299992,
							27.76457000000005
						],
						[
							-82.71638727599992,
							27.76457000000005
						],
						[
							-82.71566845999992,
							27.76457000000005
						],
						[
							-82.71521919999992,
							27.76457000000005
						],
						[
							-82.71252363799994,
							27.76457000000005
						],
						[
							-82.71212899999995,
							27.764574384000074
						],
						[
							-82.71212899999995,
							27.764176000000077
						],
						[
							-82.71212439499995,
							27.763636819000055
						],
						[
							-82.71211699999992,
							27.762771000000043
						],
						[
							-82.71311899999995,
							27.76276800000005
						],
						[
							-82.71413599999994,
							27.76276900000005
						],
						[
							-82.71511599999991,
							27.762766000000056
						],
						[
							-82.71616099999994,
							27.762766000000056
						],
						[
							-82.71721599999995,
							27.762758000000076
						],
						[
							-82.71821099999994,
							27.762759000000074
						],
						[
							-82.72023999999993,
							27.762753000000092
						],
						[
							-82.72127799999993,
							27.762752000000035
						],
						[
							-82.7223239999999,
							27.762748000000045
						],
						[
							-82.72285799999992,
							27.762745000000052
						],
						[
							-82.72320499999996,
							27.762749000000042
						],
						[
							-82.72374899999994,
							27.762735000000077
						],
						[
							-82.72426499999995,
							27.762741000000062
						],
						[
							-82.72636199999994,
							27.76273800000007
						],
						[
							-82.72690099999994,
							27.76272700000004
						],
						[
							-82.7271429999999,
							27.762731000000088
						],
						[
							-82.72768699999995,
							27.762741000000062
						],
						[
							-82.72813199999992,
							27.76272800000004
						],
						[
							-82.72824753899994,
							27.762760067000045
						],
						[
							-82.72846753599993,
							27.762821124000084
						],
						[
							-82.7288309999999,
							27.76292200000006
						],
						[
							-82.72917099999995,
							27.76302300000009
						],
						[
							-82.72926699999994,
							27.762784000000067
						],
						[
							-82.72985399999993,
							27.76295900000008
						],
						[
							-82.72986405799992,
							27.762909550000074
						],
						[
							-82.72993799999995,
							27.762546000000043
						],
						[
							-82.73004715899992,
							27.76258751100005
						],
						[
							-82.73114499999991,
							27.763005000000078
						],
						[
							-82.73115416799993,
							27.762979098000073
						],
						[
							-82.73131099999995,
							27.76253600000007
						],
						[
							-82.73150134699995,
							27.76259799400009
						],
						[
							-82.73193765199994,
							27.762740093000048
						],
						[
							-82.73261899999994,
							27.762962000000073
						],
						[
							-82.73395699999992,
							27.763419000000056
						],
						[
							-82.73459099999991,
							27.763614000000075
						],
						[
							-82.73439849599993,
							27.764243845000067
						],
						[
							-82.73428238299995,
							27.76458027400008
						],
						[
							-82.73409568099993,
							27.765117005000036
						],
						[
							-82.73387107199994,
							27.76575949100004
						],
						[
							-82.73365291099992,
							27.766377288000058
						],
						[
							-82.73342908399991,
							27.76700653800009
						],
						[
							-82.73330550799994,
							27.767353950000086
						],
						[
							-82.73315516299995,
							27.76778416500008
						],
						[
							-82.73296032399992,
							27.768347428000084
						],
						[
							-82.73280712399992,
							27.768790316000036
						],
						[
							-82.73264387299992,
							27.769244995000065
						],
						[
							-82.73243999999995,
							27.769350000000088
						],
						[
							-82.73212025599992,
							27.76922488300005
						],
						[
							-82.73174759099993,
							27.769079057000056
						],
						[
							-82.73132071999993,
							27.768912021000062
						],
						[
							-82.73074630899993,
							27.768714093000085
						],
						[
							-82.73018214799993,
							27.768521186000044
						],
						[
							-82.72973999999994,
							27.76837000000006
						],
						[
							-82.72969524199995,
							27.768357793000064
						],
						[
							-82.72938875999996,
							27.768253999000084
						],
						[
							-82.72906710899991,
							27.76813933200009
						],
						[
							-82.72861166699994,
							27.767976969000074
						],
						[
							-82.72776906299993,
							27.76767658400007
						],
						[
							-82.72708589899992,
							27.767433040000075
						],
						[
							-82.7267101779999,
							27.76729909700009
						],
						[
							-82.72604129899992,
							27.767060368000045
						],
						[
							-82.72574821199993,
							27.76695559300009
						],
						[
							-82.72523882299993,
							27.766773492000084
						],
						[
							-82.72470383799993,
							27.766582242000084
						],
						[
							-82.72424999999993,
							27.76642000000004
						],
						[
							-82.72348525299992,
							27.766193651000037
						],
						[
							-82.72282054199991,
							27.765984742000057
						],
						[
							-82.72235999999992,
							27.765840000000082
						],
						[
							-82.72186618299992,
							27.765659448000065
						],
						[
							-82.72131531999992,
							27.76546876500004
						],
						[
							-82.72064297599991,
							27.765240368000036
						],
						[
							-82.72019999999992,
							27.765090000000043
						],
						[
							-82.71989413499995,
							27.76501393800004
						],
						[
							-82.7195769249999,
							27.76493505500008
						],
						[
							-82.71906943399995,
							27.76480885400008
						],
						[
							-82.71863581699995,
							27.764701023000047
						],
						[
							-82.71819999999991,
							27.76461000000006
						],
						[
							-82.71791476099992,
							27.764580000000084
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Pasadena On The Gulf",
				"RegionID": "417119"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.74665604299992,
					27.762459000000035,
					-82.73993899999995,
					27.775285762000067
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.74502700999994,
							27.77502491300004
						],
						[
							-82.74468565199993,
							27.774504508000064
						],
						[
							-82.74459572399991,
							27.774375236000083
						],
						[
							-82.74434841999994,
							27.774060486000053
						],
						[
							-82.74392688099994,
							27.773565880000035
						],
						[
							-82.74363138699995,
							27.77319516800009
						],
						[
							-82.74388265699992,
							27.773044406000054
						],
						[
							-82.74408999999991,
							27.772920000000056
						],
						[
							-82.74393334099994,
							27.772727737000086
						],
						[
							-82.74371600799992,
							27.77246100900004
						],
						[
							-82.74351995299992,
							27.77222445400008
						],
						[
							-82.74328961999993,
							27.771948957000063
						],
						[
							-82.7430714919999,
							27.77168495600006
						],
						[
							-82.74288980999995,
							27.771459419000053
						],
						[
							-82.74272513599993,
							27.771254997000085
						],
						[
							-82.74261003999993,
							27.771112119000065
						],
						[
							-82.74250655399993,
							27.77097364800005
						],
						[
							-82.74243235499996,
							27.77086765000007
						],
						[
							-82.74232373099994,
							27.77069782500007
						],
						[
							-82.74226809599992,
							27.770598626000037
						],
						[
							-82.74220096899991,
							27.770471829000087
						],
						[
							-82.74216104599992,
							27.77035313900007
						],
						[
							-82.74212087899991,
							27.770203956000046
						],
						[
							-82.74147070899994,
							27.770053048000083
						],
						[
							-82.74145602699991,
							27.76993559200008
						],
						[
							-82.74139764199992,
							27.76946851300005
						],
						[
							-82.74136391899992,
							27.769260554000084
						],
						[
							-82.74132457499991,
							27.768940184000087
						],
						[
							-82.74122902599993,
							27.768496162000076
						],
						[
							-82.74116157999993,
							27.768102725000062
						],
						[
							-82.74096486099995,
							27.767596877000074
						],
						[
							-82.74071755799991,
							27.766883070000063
						],
						[
							-82.74054300799992,
							27.76638297100004
						],
						[
							-82.7406448079999,
							27.766377154000057
						],
						[
							-82.7408412069999,
							27.766365931000053
						],
						[
							-82.7410207989999,
							27.766355669000063
						],
						[
							-82.74111999999991,
							27.766350000000045
						],
						[
							-82.74107927299993,
							27.766210364000074
						],
						[
							-82.74102088299992,
							27.76598382700007
						],
						[
							-82.74098687599991,
							27.76583646200004
						],
						[
							-82.74094962799991,
							27.76563443300006
						],
						[
							-82.74093058499994,
							27.765477323000084
						],
						[
							-82.7409199999999,
							27.76539000000008
						],
						[
							-82.74086291599991,
							27.765361458000086
						],
						[
							-82.74076414599995,
							27.765308488000073
						],
						[
							-82.74066112799994,
							27.765208133000044
						],
						[
							-82.7404935379999,
							27.76503315800005
						],
						[
							-82.74034873399995,
							27.76487983600009
						],
						[
							-82.74014382899992,
							27.76465774000008
						],
						[
							-82.74002270099993,
							27.76452614500005
						],
						[
							-82.73993899999995,
							27.764435210000045
						],
						[
							-82.74036908499994,
							27.764100907000056
						],
						[
							-82.74056580399991,
							27.763904189000073
						],
						[
							-82.74019711599993,
							27.76349124500007
						],
						[
							-82.74024537799994,
							27.76345447400007
						],
						[
							-82.7405399999999,
							27.76323000000008
						],
						[
							-82.74059430799991,
							27.763193794000074
						],
						[
							-82.74065999999993,
							27.763150000000053
						],
						[
							-82.74071719199992,
							27.763105601000067
						],
						[
							-82.74081649499993,
							27.763028511000073
						],
						[
							-82.74089747799991,
							27.762965642000044
						],
						[
							-82.74099248999994,
							27.762891883000066
						],
						[
							-82.7411221559999,
							27.762791221000043
						],
						[
							-82.74123936299992,
							27.762700231000053
						],
						[
							-82.74131840899992,
							27.762638867000078
						],
						[
							-82.74138384199995,
							27.76258807000005
						],
						[
							-82.74143003699993,
							27.76254745400007
						],
						[
							-82.7414616339999,
							27.762498563000065
						],
						[
							-82.74146999999994,
							27.762459000000035
						],
						[
							-82.74149924199992,
							27.762473798000087
						],
						[
							-82.7417999999999,
							27.76262600000007
						],
						[
							-82.74183565499993,
							27.762624745000043
						],
						[
							-82.74273729799995,
							27.76259301400006
						],
						[
							-82.7427416829999,
							27.762640091000037
						],
						[
							-82.7427476819999,
							27.76279909100009
						],
						[
							-82.74274526199991,
							27.762907124000037
						],
						[
							-82.74273426199996,
							27.763040124000042
						],
						[
							-82.74272440899995,
							27.763117851000064
						],
						[
							-82.74270782799994,
							27.76319442600004
						],
						[
							-82.74268464599993,
							27.763269267000055
						],
						[
							-82.7426550369999,
							27.763341806000085
						],
						[
							-82.74261922699992,
							27.763411493000035
						],
						[
							-82.74257748799994,
							27.763477798000054
						],
						[
							-82.74239519399993,
							27.763741191000065
						],
						[
							-82.74238136499991,
							27.763781962000053
						],
						[
							-82.74233813299992,
							27.763921033000088
						],
						[
							-82.74235242799995,
							27.763983818000042
						],
						[
							-82.7423619839999,
							27.764047497000035
						],
						[
							-82.74236674899993,
							27.764111712000044
						],
						[
							-82.74236669399994,
							27.764176103000068
						],
						[
							-82.7423618219999,
							27.764240310000048
						],
						[
							-82.74234982199994,
							27.76434831100005
						],
						[
							-82.74234284999994,
							27.764406360000066
						],
						[
							-82.74233111199993,
							27.764463637000063
						],
						[
							-82.74231468999994,
							27.76451975000009
						],
						[
							-82.7422936939999,
							27.76457431700004
						],
						[
							-82.74226826799992,
							27.764626966000037
						],
						[
							-82.74226558099991,
							27.76467445600008
						],
						[
							-82.7422392439999,
							27.76490633900005
						],
						[
							-82.74221125799994,
							27.765139472000044
						],
						[
							-82.74223643599993,
							27.76520475400008
						],
						[
							-82.74225631999991,
							27.765271839000036
						],
						[
							-82.74227078099995,
							27.76534029800007
						],
						[
							-82.7422797289999,
							27.76540969200005
						],
						[
							-82.7422939839999,
							27.765568685000062
						],
						[
							-82.74235420999992,
							27.76571952900008
						],
						[
							-82.74237835499991,
							27.765787879000072
						],
						[
							-82.74252335499995,
							27.76625787900008
						],
						[
							-82.74253413399992,
							27.766295739000046
						],
						[
							-82.74268013299991,
							27.766854738000063
						],
						[
							-82.7426969739999,
							27.766933487000074
						],
						[
							-82.74284054499992,
							27.767790951000052
						],
						[
							-82.74313797799994,
							27.76937902800006
						],
						[
							-82.7430413969999,
							27.769605713000093
						],
						[
							-82.74295528499994,
							27.77007072200007
						],
						[
							-82.7430241749999,
							27.770656289000044
						],
						[
							-82.7432308459999,
							27.77117296600005
						],
						[
							-82.74338584899994,
							27.771414081000046
						],
						[
							-82.74373029999992,
							27.771861868000087
						],
						[
							-82.74395419299994,
							27.772068538000042
						],
						[
							-82.74455698199995,
							27.772430212000074
						],
						[
							-82.74541831499994,
							27.772810358000072
						],
						[
							-82.74612311699991,
							27.773668848000057
						],
						[
							-82.74659394899993,
							27.774250790000053
						],
						[
							-82.74665604299992,
							27.774320111000065
						],
						[
							-82.74590899999993,
							27.774834000000055
						],
						[
							-82.74590535699991,
							27.774829498000088
						],
						[
							-82.74524208499992,
							27.775285762000067
						],
						[
							-82.74502700999994,
							27.77502491300004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Sunset Drive South",
				"RegionID": "417121"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.72850999999991,
					27.78429931900007,
					-82.71939999999995,
					27.788300000000053
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.72239102499992,
							27.787362847000054
						],
						[
							-82.72206172199992,
							27.787098849000074
						],
						[
							-82.72175017299992,
							27.78684908400004
						],
						[
							-82.72144693899992,
							27.786605985000055
						],
						[
							-82.72118999999992,
							27.786400000000075
						],
						[
							-82.72118725899992,
							27.78639778800005
						],
						[
							-82.72103387199991,
							27.78627403300004
						],
						[
							-82.72080115099993,
							27.786086270000055
						],
						[
							-82.7205482899999,
							27.785882257000083
						],
						[
							-82.72031195599993,
							27.78569157800007
						],
						[
							-82.72007083099994,
							27.785497122000038
						],
						[
							-82.71990245199993,
							27.785360335000064
						],
						[
							-82.7197800809999,
							27.785260400000084
						],
						[
							-82.71939999999995,
							27.78495000000004
						],
						[
							-82.71955858399991,
							27.78480817600007
						],
						[
							-82.71967226999993,
							27.784707607000087
						],
						[
							-82.71975999999995,
							27.78463000000005
						],
						[
							-82.71977612599994,
							27.78459162300004
						],
						[
							-82.7197799999999,
							27.784557996000046
						],
						[
							-82.7197799999999,
							27.784475219000058
						],
						[
							-82.7197799999999,
							27.784375198000077
						],
						[
							-82.7197799999999,
							27.78429931900007
						],
						[
							-82.72032021099994,
							27.78431311500009
						],
						[
							-82.72032295299994,
							27.784455395000066
						],
						[
							-82.72075068899994,
							27.78444567300005
						],
						[
							-82.72101255299992,
							27.78448943300009
						],
						[
							-82.72132196899992,
							27.784485307000068
						],
						[
							-82.72233872499993,
							27.784480000000087
						],
						[
							-82.7231566129999,
							27.78447959500005
						],
						[
							-82.72399659799993,
							27.78447691200006
						],
						[
							-82.72565446099992,
							27.784471615000086
						],
						[
							-82.72684802499992,
							27.78446821700004
						],
						[
							-82.72702483899991,
							27.784466086000066
						],
						[
							-82.7271798189999,
							27.784464219000085
						],
						[
							-82.7274450409999,
							27.784461024000056
						],
						[
							-82.72782071099994,
							27.78446350300004
						],
						[
							-82.7280419949999,
							27.78446616900004
						],
						[
							-82.72817460699991,
							27.784467766000034
						],
						[
							-82.72835999999995,
							27.784470000000056
						],
						[
							-82.72849999999994,
							27.784471460000077
						],
						[
							-82.72849999999994,
							27.78461283300004
						],
						[
							-82.72849999999994,
							27.78507289500004
						],
						[
							-82.72849999999994,
							27.785508089000075
						],
						[
							-82.72849999999994,
							27.78594328300005
						],
						[
							-82.72849999999994,
							27.786104926000064
						],
						[
							-82.72850097899993,
							27.786328705000074
						],
						[
							-82.7285026589999,
							27.786515201000046
						],
						[
							-82.72850579599992,
							27.786863328000038
						],
						[
							-82.72850814799995,
							27.78712442300008
						],
						[
							-82.72850999999991,
							27.787330000000054
						],
						[
							-82.72823621099991,
							27.78732708700005
						],
						[
							-82.72805160899992,
							27.78732274400005
						],
						[
							-82.72768194799994,
							27.787314046000063
						],
						[
							-82.72750999999994,
							27.787310000000048
						],
						[
							-82.7273708809999,
							27.787310000000048
						],
						[
							-82.72713756999991,
							27.787310000000048
						],
						[
							-82.72670999999991,
							27.787310000000048
						],
						[
							-82.72650568699993,
							27.787310000000048
						],
						[
							-82.72618488499995,
							27.787310000000048
						],
						[
							-82.7258057549999,
							27.787310000000048
						],
						[
							-82.72527108399993,
							27.787310000000048
						],
						[
							-82.72495028199995,
							27.787310000000048
						],
						[
							-82.7247558219999,
							27.78732295000009
						],
						[
							-82.72461848799992,
							27.78734407900004
						],
						[
							-82.7245222059999,
							27.787394951000067
						],
						[
							-82.72444525899994,
							27.787458161000078
						],
						[
							-82.72434975999994,
							27.78753961700005
						],
						[
							-82.72424631599995,
							27.787627848000056
						],
						[
							-82.72414999999995,
							27.78771000000006
						],
						[
							-82.72410194999992,
							27.787758050000036
						],
						[
							-82.72401445899993,
							27.78784554100008
						],
						[
							-82.7238443359999,
							27.788015664000056
						],
						[
							-82.72375198399993,
							27.78810801600008
						],
						[
							-82.72365999999994,
							27.788200000000074
						],
						[
							-82.7236256079999,
							27.78823439200005
						],
						[
							-82.7235599999999,
							27.788300000000053
						],
						[
							-82.72335403699992,
							27.788134882000065
						],
						[
							-82.72308278899993,
							27.787917426000035
						],
						[
							-82.72270966499991,
							27.78761829700005
						],
						[
							-82.72239102499992,
							27.787362847000054
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Garden Manor",
				"RegionID": "417128"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.71923157099991,
					27.788110648000043,
					-82.71229999999991,
					27.791660000000036
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.71558699399992,
							27.78813000000008
						],
						[
							-82.7164145029999,
							27.788121110000077
						],
						[
							-82.7168434489999,
							27.788110648000043
						],
						[
							-82.71721210599992,
							27.788116982000076
						],
						[
							-82.71776372499994,
							27.788124536000055
						],
						[
							-82.71843811299993,
							27.78813000000008
						],
						[
							-82.71898994299994,
							27.78813000000008
						],
						[
							-82.71923157099991,
							27.78813000000008
						],
						[
							-82.71891976699993,
							27.788491693000083
						],
						[
							-82.71845415999991,
							27.789241837000077
						],
						[
							-82.71839878399993,
							27.789655816000053
						],
						[
							-82.71839432399992,
							27.790043770000068
						],
						[
							-82.71839075699995,
							27.79035413300005
						],
						[
							-82.71838465899992,
							27.790884634000065
						],
						[
							-82.71838064799994,
							27.791233644000044
						],
						[
							-82.71837443299995,
							27.79147927100007
						],
						[
							-82.71836999999994,
							27.791630000000055
						],
						[
							-82.71782496899995,
							27.791640000000086
						],
						[
							-82.71748773999991,
							27.791640000000086
						],
						[
							-82.71684393899994,
							27.791640000000086
						],
						[
							-82.71653736699994,
							27.791640000000086
						],
						[
							-82.71604685199992,
							27.791640000000086
						],
						[
							-82.7152497649999,
							27.791640000000086
						],
						[
							-82.71454464899996,
							27.791640000000086
						],
						[
							-82.7137169049999,
							27.791640000000086
						],
						[
							-82.71282784599993,
							27.791640000000086
						],
						[
							-82.71236999999991,
							27.791660000000036
						],
						[
							-82.71234484699994,
							27.791475543000047
						],
						[
							-82.71233534099991,
							27.791351477000035
						],
						[
							-82.71231999999992,
							27.791060000000073
						],
						[
							-82.71231767899991,
							27.79089059000006
						],
						[
							-82.71231430899991,
							27.790644538000038
						],
						[
							-82.71230999999995,
							27.79033000000004
						],
						[
							-82.71230999999995,
							27.79009281400005
						],
						[
							-82.71230999999995,
							27.789724927000066
						],
						[
							-82.71230999999995,
							27.789600000000064
						],
						[
							-82.71230630299993,
							27.789326389000056
						],
						[
							-82.7123042309999,
							27.78917313100004
						],
						[
							-82.71229999999991,
							27.788860000000057
						],
						[
							-82.71229999999991,
							27.788682582000035
						],
						[
							-82.71229999999991,
							27.788498639000068
						],
						[
							-82.71229999999991,
							27.788140000000055
						],
						[
							-82.7126439029999,
							27.788140000000055
						],
						[
							-82.71334901799992,
							27.788140000000055
						],
						[
							-82.71463664899994,
							27.788133540000047
						],
						[
							-82.71558699399992,
							27.78813000000008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Garden Manor Lake",
				"RegionID": "417130"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.64657999999991,
					27.740960000000086,
					-82.63855999999993,
					27.748440000000073
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.63855999999993,
							27.748440000000073
						],
						[
							-82.63855999999993,
							27.747863556000084
						],
						[
							-82.63856215999994,
							27.747157462000075
						],
						[
							-82.6385699999999,
							27.74664000000007
						],
						[
							-82.63857409799994,
							27.746263012000043
						],
						[
							-82.63857999999993,
							27.745720000000063
						],
						[
							-82.6385844749999,
							27.74527541100008
						],
						[
							-82.63858630799992,
							27.745134257000075
						],
						[
							-82.63858999999991,
							27.744850000000046
						],
						[
							-82.63859473999992,
							27.744475531000035
						],
						[
							-82.63859712199991,
							27.744287324000084
						],
						[
							-82.63859999999995,
							27.744060000000047
						],
						[
							-82.63860706199995,
							27.74372103500008
						],
						[
							-82.63860999999991,
							27.743580000000065
						],
						[
							-82.63862480899991,
							27.74334305600007
						],
						[
							-82.6386599999999,
							27.74225000000007
						],
						[
							-82.63864213599993,
							27.741839129000084
						],
						[
							-82.63864513099992,
							27.74160529800008
						],
						[
							-82.63869999999991,
							27.741250000000036
						],
						[
							-82.6387299999999,
							27.74124000000006
						],
						[
							-82.63917499999991,
							27.741230000000087
						],
						[
							-82.63958999999994,
							27.741230000000087
						],
						[
							-82.6397199999999,
							27.741230000000087
						],
						[
							-82.63992999999994,
							27.741235000000074
						],
						[
							-82.6400999999999,
							27.741260000000068
						],
						[
							-82.64067999999992,
							27.740960000000086
						],
						[
							-82.6407851589999,
							27.741014276000044
						],
						[
							-82.64089302799994,
							27.741069950000053
						],
						[
							-82.64098999999993,
							27.741120000000084
						],
						[
							-82.64106192899993,
							27.741151968000054
						],
						[
							-82.64116357699993,
							27.74118089400008
						],
						[
							-82.6412914579999,
							27.74121286400009
						],
						[
							-82.64139323699993,
							27.741225231000048
						],
						[
							-82.6418803389999,
							27.741221758000055
						],
						[
							-82.6422085719999,
							27.741215322000073
						],
						[
							-82.64271803199995,
							27.741208827000037
						],
						[
							-82.6433181239999,
							27.74120587100009
						],
						[
							-82.64366923199992,
							27.741204142000072
						],
						[
							-82.64415609899993,
							27.74120174300009
						],
						[
							-82.64511847799992,
							27.74120000000005
						],
						[
							-82.64565046899992,
							27.74119582800006
						],
						[
							-82.64582049699993,
							27.741190777000043
						],
						[
							-82.6460357759999,
							27.741184383000075
						],
						[
							-82.6463641819999,
							27.741174628000067
						],
						[
							-82.64651414199994,
							27.74117168500004
						],
						[
							-82.6465199999999,
							27.74155761700007
						],
						[
							-82.6465199999999,
							27.742310565000082
						],
						[
							-82.6465199999999,
							27.742639979000046
						],
						[
							-82.6465199999999,
							27.74339292700006
						],
						[
							-82.6465199999999,
							27.744428231000086
						],
						[
							-82.64652278099993,
							27.745228276000038
						],
						[
							-82.64652675299993,
							27.74584002100005
						],
						[
							-82.64653048799994,
							27.746687051000038
						],
						[
							-82.64653605899991,
							27.747110511000074
						],
						[
							-82.6465399999999,
							27.748004733000073
						],
						[
							-82.64657999999991,
							27.748420000000067
						],
						[
							-82.64615222899994,
							27.74843000000004
						],
						[
							-82.64502280699992,
							27.74843000000004
						],
						[
							-82.64403456299995,
							27.74843000000004
						],
						[
							-82.64309340099993,
							27.74842591600009
						],
						[
							-82.64201101499992,
							27.748420000000067
						],
						[
							-82.64106982999994,
							27.748420000000067
						],
						[
							-82.64036394199991,
							27.748420000000067
						],
						[
							-82.63984628999992,
							27.74843000000004
						],
						[
							-82.63923456899995,
							27.748432973000035
						],
						[
							-82.63855999999993,
							27.748440000000073
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Harbordale",
				"RegionID": "417135"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.6630002679999,
					27.740160678000052,
					-82.64651414199994,
					27.74843000000004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.64657999999991,
							27.748420000000067
						],
						[
							-82.6465399999999,
							27.748004733000073
						],
						[
							-82.64653605899991,
							27.747110511000074
						],
						[
							-82.64653048799994,
							27.746687051000038
						],
						[
							-82.64652675299993,
							27.74584002100005
						],
						[
							-82.64652278099993,
							27.745228276000038
						],
						[
							-82.6465199999999,
							27.744428231000086
						],
						[
							-82.6465199999999,
							27.74339292700006
						],
						[
							-82.6465199999999,
							27.742639979000046
						],
						[
							-82.6465199999999,
							27.742310565000082
						],
						[
							-82.6465199999999,
							27.74155761700007
						],
						[
							-82.64651414199994,
							27.74117168500004
						],
						[
							-82.64659999999992,
							27.741170000000068
						],
						[
							-82.64701790399995,
							27.74083587100006
						],
						[
							-82.6478130509999,
							27.740167076000034
						],
						[
							-82.64797917699991,
							27.740195499000038
						],
						[
							-82.6482520799999,
							27.74016591600008
						],
						[
							-82.64829018199993,
							27.740162603000044
						],
						[
							-82.64834899999995,
							27.740160678000052
						],
						[
							-82.6484078179999,
							27.740162603000044
						],
						[
							-82.64846638499995,
							27.740168372000085
						],
						[
							-82.64847051499993,
							27.740168925000035
						],
						[
							-82.64851451499993,
							27.74017492500008
						],
						[
							-82.64856844899992,
							27.740183958000046
						],
						[
							-82.64862576199994,
							27.740197322000085
						],
						[
							-82.64868207799992,
							27.740214405000078
						],
						[
							-82.64873715599992,
							27.740235135000034
						],
						[
							-82.64879075999994,
							27.740259423000058
						],
						[
							-82.64884266099995,
							27.74028716400005
						],
						[
							-82.6488926369999,
							27.740318241000068
						],
						[
							-82.64894047299993,
							27.740352520000044
						],
						[
							-82.6489859639999,
							27.740389854000057
						],
						[
							-82.64902891699991,
							27.740430083000035
						],
						[
							-82.64906914599993,
							27.740473036000083
						],
						[
							-82.64910647999994,
							27.740518528000052
						],
						[
							-82.64914075899992,
							27.740566364000077
						],
						[
							-82.64917183599994,
							27.74061633900004
						],
						[
							-82.64919957799992,
							27.740668240000048
						],
						[
							-82.6492238649999,
							27.740721845000053
						],
						[
							-82.6492405489999,
							27.74076526400006
						],
						[
							-82.64925154799994,
							27.74079626400004
						],
						[
							-82.64925559499994,
							27.740807922000045
						],
						[
							-82.64927267799993,
							27.740864238000086
						],
						[
							-82.64928604199991,
							27.740921551000042
						],
						[
							-82.64929562799995,
							27.74097961500007
						],
						[
							-82.64930139599994,
							27.741038181000082
						],
						[
							-82.64930311799992,
							27.741077869000037
						],
						[
							-82.64930408799995,
							27.741123437000056
						],
						[
							-82.6493120529999,
							27.74144900400006
						],
						[
							-82.64931221899991,
							27.741457376000085
						],
						[
							-82.64931884799995,
							27.741894897000066
						],
						[
							-82.64936269299994,
							27.741883383000076
						],
						[
							-82.64944688999992,
							27.74185301600005
						],
						[
							-82.64946292199994,
							27.741847405000044
						],
						[
							-82.64951923799994,
							27.74183032200006
						],
						[
							-82.64952027999993,
							27.74183004300005
						],
						[
							-82.64977527999991,
							27.74176204400004
						],
						[
							-82.64983155099992,
							27.741748959000063
						],
						[
							-82.64988748899992,
							27.74173965500006
						],
						[
							-82.65006648899993,
							27.741715654000075
						],
						[
							-82.65006861499995,
							27.741715372000044
						],
						[
							-82.65012718199996,
							27.74170960400005
						],
						[
							-82.65015016399991,
							27.741708392000078
						],
						[
							-82.65047616399994,
							27.741695392000057
						],
						[
							-82.65051199999994,
							27.741694678000044
						],
						[
							-82.65076999999991,
							27.741694678000044
						],
						[
							-82.65082881899993,
							27.74169660300004
						],
						[
							-82.6508519169999,
							27.74169841600008
						],
						[
							-82.6509082689999,
							27.741703571000073
						],
						[
							-82.65102935499993,
							27.741685514000043
						],
						[
							-82.65104461499993,
							27.74168337100008
						],
						[
							-82.65110318199993,
							27.741677603000085
						],
						[
							-82.65116199999996,
							27.741675678000036
						],
						[
							-82.65122081899995,
							27.741677603000085
						],
						[
							-82.65126420999991,
							27.741681505000088
						],
						[
							-82.65147397899995,
							27.74170550100007
						],
						[
							-82.6516730919999,
							27.741700931000082
						],
						[
							-82.6517931329999,
							27.741686291000065
						],
						[
							-82.65184318199994,
							27.741681603000075
						],
						[
							-82.65188511399994,
							27.74167983600006
						],
						[
							-82.6520981139999,
							27.74167583600007
						],
						[
							-82.65217381899993,
							27.741677603000085
						],
						[
							-82.65221808899992,
							27.741681606000043
						],
						[
							-82.65233485699991,
							27.741695079000067
						],
						[
							-82.65288436999992,
							27.741709981000042
						],
						[
							-82.6541798319999,
							27.74174220200007
						],
						[
							-82.65434389299992,
							27.74172046800004
						],
						[
							-82.6543446149999,
							27.74172037200009
						],
						[
							-82.6544031819999,
							27.741714604000038
						],
						[
							-82.65446199999991,
							27.741712678000056
						],
						[
							-82.65452081899991,
							27.741714604000038
						],
						[
							-82.65457902899993,
							27.741720325000074
						],
						[
							-82.65473902799994,
							27.74174132400009
						],
						[
							-82.65473938499991,
							27.741741371000046
						],
						[
							-82.65479744899994,
							27.741750958000072
						],
						[
							-82.65481316499995,
							27.741754230000083
						],
						[
							-82.6548357449999,
							27.741754875000083
						],
						[
							-82.65484292199996,
							27.741752405000057
						],
						[
							-82.6548525469999,
							27.741749198000036
						],
						[
							-82.65500854699991,
							27.74169819800005
						],
						[
							-82.65505523799993,
							27.741684322000083
						],
						[
							-82.65511255099995,
							27.74167095900009
						],
						[
							-82.65517061499992,
							27.741661372000067
						],
						[
							-82.65522918099992,
							27.741655604000073
						],
						[
							-82.65528799999993,
							27.741653678000095
						],
						[
							-82.65534681799994,
							27.741655604000073
						],
						[
							-82.65537156699992,
							27.74165756900004
						],
						[
							-82.65544656599991,
							27.74166456900008
						],
						[
							-82.65548038499992,
							27.74166837200005
						],
						[
							-82.65553844899995,
							27.741677958000082
						],
						[
							-82.65559576099992,
							27.741691321000076
						],
						[
							-82.6556115539999,
							27.741695708000066
						],
						[
							-82.65566055099993,
							27.741709798000045
						],
						[
							-82.65570123999993,
							27.741688423000088
						],
						[
							-82.65575310399993,
							27.741664858000036
						],
						[
							-82.65580110299993,
							27.741644858000086
						],
						[
							-82.65580284399995,
							27.741644135000058
						],
						[
							-82.65585792199994,
							27.74162340500004
						],
						[
							-82.65591423799992,
							27.741606322000052
						],
						[
							-82.65597155099994,
							27.741592959000062
						],
						[
							-82.65597301199995,
							27.741592669000056
						],
						[
							-82.65604401299993,
							27.741578668000045
						],
						[
							-82.6561006149999,
							27.741569372000075
						],
						[
							-82.6561591819999,
							27.74156360300009
						],
						[
							-82.6561847129999,
							27.74156229400006
						],
						[
							-82.65626571199994,
							27.74155929400007
						],
						[
							-82.65635781799995,
							27.74156060300004
						],
						[
							-82.65637632199991,
							27.741562008000074
						],
						[
							-82.6564881029999,
							27.74157165400004
						],
						[
							-82.65656799399996,
							27.741557489000062
						],
						[
							-82.65660761499993,
							27.74155137200006
						],
						[
							-82.65666618199992,
							27.741545603000077
						],
						[
							-82.65672499999994,
							27.741543678000085
						],
						[
							-82.65676019999995,
							27.741544367000074
						],
						[
							-82.65717660599995,
							27.74156067800004
						],
						[
							-82.65735002399992,
							27.74156067800004
						],
						[
							-82.65745368099994,
							27.741545152000075
						],
						[
							-82.6574931369999,
							27.74153393800009
						],
						[
							-82.65750623899993,
							27.741530321000084
						],
						[
							-82.6575635509999,
							27.74151695800009
						],
						[
							-82.65762161499993,
							27.74150737100007
						],
						[
							-82.65768018199992,
							27.741501603000074
						],
						[
							-82.65768912399994,
							27.741501062000054
						],
						[
							-82.65776112299994,
							27.741497062000064
						],
						[
							-82.65786981799994,
							27.741497604000074
						],
						[
							-82.65792838499993,
							27.741503372000068
						],
						[
							-82.6579864489999,
							27.741512958000044
						],
						[
							-82.65804376199992,
							27.741526322000084
						],
						[
							-82.6581000779999,
							27.741543405000073
						],
						[
							-82.65810049399994,
							27.74154354700005
						],
						[
							-82.65812612299993,
							27.741552261000038
						],
						[
							-82.65813653499993,
							27.741549955000043
						],
						[
							-82.65815555099994,
							27.741545958000074
						],
						[
							-82.65821361499991,
							27.74153637200004
						],
						[
							-82.65827218099992,
							27.741530604000047
						],
						[
							-82.65830250899995,
							27.74152912900007
						],
						[
							-82.65849088499994,
							27.74134643000008
						],
						[
							-82.6585240359999,
							27.74131585400005
						],
						[
							-82.65856952699995,
							27.741278520000037
						],
						[
							-82.6586173629999,
							27.74124424100006
						],
						[
							-82.65866733899992,
							27.741213164000044
						],
						[
							-82.65871923999994,
							27.741185422000058
						],
						[
							-82.65877284399994,
							27.741161134000038
						],
						[
							-82.65882792199994,
							27.741140405000067
						],
						[
							-82.65888423799993,
							27.74112332100009
						],
						[
							-82.65894155099994,
							27.741109958000038
						],
						[
							-82.65895528899995,
							27.741107336000084
						],
						[
							-82.65914128899993,
							27.741073336000056
						],
						[
							-82.6591856149999,
							27.741066372000034
						],
						[
							-82.65924418199995,
							27.74106060300005
						],
						[
							-82.65925393199991,
							27.74106001800004
						],
						[
							-82.65931851599993,
							27.741056489000073
						],
						[
							-82.65932574199991,
							27.741053392000083
						],
						[
							-82.65933584399994,
							27.741049135000083
						],
						[
							-82.65939092199994,
							27.741028405000066
						],
						[
							-82.65944723799993,
							27.741011322000077
						],
						[
							-82.65950455099994,
							27.740997958000037
						],
						[
							-82.65956261499991,
							27.74098837200006
						],
						[
							-82.65958644499995,
							27.740985557000045
						],
						[
							-82.65960384399995,
							27.740978135000034
						],
						[
							-82.65964066599992,
							27.740963822000083
						],
						[
							-82.65969566699994,
							27.740943822000077
						],
						[
							-82.65971392299991,
							27.740937405000068
						],
						[
							-82.6597702389999,
							27.74092032200008
						],
						[
							-82.65982755099992,
							27.74090695800004
						],
						[
							-82.65988561499995,
							27.740897372000063
						],
						[
							-82.65994418199995,
							27.74089160400007
						],
						[
							-82.6600029999999,
							27.740889678000087
						],
						[
							-82.66005026999994,
							27.740890921000073
						],
						[
							-82.66010726999991,
							27.740893921000065
						],
						[
							-82.66011881899993,
							27.74089460400006
						],
						[
							-82.66017738499994,
							27.740900372000056
						],
						[
							-82.6602340419999,
							27.740909680000073
						],
						[
							-82.66049012899992,
							27.740842289000057
						],
						[
							-82.66054355099993,
							27.740829958000063
						],
						[
							-82.6606016149999,
							27.740820372000087
						],
						[
							-82.6606601819999,
							27.740814604000036
						],
						[
							-82.66068789899992,
							27.74081321600005
						],
						[
							-82.66085555099994,
							27.740807415000063
						],
						[
							-82.66166599999993,
							27.74175000000008
						],
						[
							-82.6620299999999,
							27.742140000000063
						],
						[
							-82.66207696899994,
							27.742149091000048
						],
						[
							-82.6621987289999,
							27.742172657000083
						],
						[
							-82.6623723379999,
							27.74221046200006
						],
						[
							-82.66244037599995,
							27.74223247400005
						],
						[
							-82.66257030199995,
							27.742274510000076
						],
						[
							-82.66276538299991,
							27.74233696300007
						],
						[
							-82.6628699019999,
							27.74236996900004
						],
						[
							-82.66295999999994,
							27.74242000000004
						],
						[
							-82.66296999999992,
							27.742492991000063
						],
						[
							-82.66296041299995,
							27.74257471100009
						],
						[
							-82.6629494959999,
							27.742648400000068
						],
						[
							-82.66293752799993,
							27.742729186000076
						],
						[
							-82.6629299999999,
							27.74278000000004
						],
						[
							-82.66292892799993,
							27.74284756600008
						],
						[
							-82.66292675699992,
							27.742984293000063
						],
						[
							-82.66292377899993,
							27.743171921000055
						],
						[
							-82.66291999999993,
							27.743427737000047
						],
						[
							-82.66291999999993,
							27.74370071800007
						],
						[
							-82.66291999999993,
							27.743973700000083
						],
						[
							-82.66291999999993,
							27.74419000000006
						],
						[
							-82.66291999999993,
							27.74446847900009
						],
						[
							-82.66291999999993,
							27.744740000000036
						],
						[
							-82.66291999999993,
							27.745048565000047
						],
						[
							-82.66291999999993,
							27.74542391400007
						],
						[
							-82.66291999999993,
							27.745640000000037
						],
						[
							-82.66291999999993,
							27.74583338700006
						],
						[
							-82.66291999999993,
							27.746021062000068
						],
						[
							-82.66291999999993,
							27.746379350000044
						],
						[
							-82.66291999999993,
							27.746570000000077
						],
						[
							-82.66292165399994,
							27.746720528000083
						],
						[
							-82.66292390399991,
							27.746925240000053
						],
						[
							-82.66292615499992,
							27.74713013900004
						],
						[
							-82.66292821499991,
							27.747317603000056
						],
						[
							-82.6629299999999,
							27.747480000000053
						],
						[
							-82.6629299999999,
							27.747658951000062
						],
						[
							-82.6629299999999,
							27.74784662600007
						],
						[
							-82.66293885199991,
							27.748068183000044
						],
						[
							-82.66295080899994,
							27.74814044100009
						],
						[
							-82.6629787729999,
							27.748270939000065
						],
						[
							-82.6629999999999,
							27.74837000000008
						],
						[
							-82.6630002679999,
							27.748371605000045
						],
						[
							-82.6627399969999,
							27.74837376800008
						],
						[
							-82.66252406199993,
							27.74837689800006
						],
						[
							-82.66230999999993,
							27.748380000000054
						],
						[
							-82.66213516399995,
							27.748380000000054
						],
						[
							-82.66194999999993,
							27.748380000000054
						],
						[
							-82.6617678799999,
							27.748385519000067
						],
						[
							-82.66161999999991,
							27.748390000000086
						],
						[
							-82.66135771099994,
							27.748385143000064
						],
						[
							-82.66107999999991,
							27.748380000000054
						],
						[
							-82.66089999999991,
							27.748380000000054
						],
						[
							-82.66075310999992,
							27.748377280000057
						],
						[
							-82.66057998499993,
							27.748374074000083
						],
						[
							-82.66027772799993,
							27.74837000000008
						],
						[
							-82.66010999999992,
							27.74837000000008
						],
						[
							-82.65984576699992,
							27.74837000000008
						],
						[
							-82.65962999999994,
							27.74837000000008
						],
						[
							-82.65943540299992,
							27.74837000000008
						],
						[
							-82.65918999999991,
							27.74837000000008
						],
						[
							-82.65904999999992,
							27.74837000000008
						],
						[
							-82.6588090589999,
							27.74837000000008
						],
						[
							-82.6585066849999,
							27.74837000000008
						],
						[
							-82.65829999999994,
							27.74837000000008
						],
						[
							-82.65816999999993,
							27.74837000000008
						],
						[
							-82.65800997799994,
							27.74837188300006
						],
						[
							-82.65781562199993,
							27.748374169000044
						],
						[
							-82.65766420199992,
							27.74837595100007
						],
						[
							-82.65731999999991,
							27.748380000000054
						],
						[
							-82.65714600599995,
							27.748380000000054
						],
						[
							-82.65688999999992,
							27.748380000000054
						],
						[
							-82.65660605399995,
							27.748380000000054
						],
						[
							-82.6562820819999,
							27.748380000000054
						],
						[
							-82.65606999999994,
							27.748380000000054
						],
						[
							-82.65582852299993,
							27.748380000000054
						],
						[
							-82.65556934599994,
							27.748380000000054
						],
						[
							-82.65539656099992,
							27.748380000000054
						],
						[
							-82.65518999999995,
							27.748380000000054
						],
						[
							-82.65507280299994,
							27.748377830000038
						],
						[
							-82.65494325899994,
							27.748375431000056
						],
						[
							-82.65487768799994,
							27.74837421600006
						],
						[
							-82.6547697339999,
							27.748372217000057
						],
						[
							-82.65464999999995,
							27.74837000000008
						],
						[
							-82.6546459509999,
							27.74837021500008
						],
						[
							-82.6544461339999,
							27.748380829000045
						],
						[
							-82.65412249799994,
							27.748385032000044
						],
						[
							-82.65394946199991,
							27.74838728000009
						],
						[
							-82.65340962999994,
							27.74839524400005
						],
						[
							-82.65280478999995,
							27.74840000000006
						],
						[
							-82.65237282899994,
							27.74840000000006
						],
						[
							-82.6518546129999,
							27.748402660000067
						],
						[
							-82.6514874849999,
							27.74840648500009
						],
						[
							-82.65114999999992,
							27.748410000000035
						],
						[
							-82.65092575699992,
							27.748410000000035
						],
						[
							-82.6506599999999,
							27.748410000000035
						],
						[
							-82.65034270299992,
							27.748415987000048
						],
						[
							-82.65012999999993,
							27.748420000000067
						],
						[
							-82.64999703899991,
							27.748420000000067
						],
						[
							-82.64985999999993,
							27.748420000000067
						],
						[
							-82.64945708699992,
							27.748420000000067
						],
						[
							-82.64910999999995,
							27.748420000000067
						],
						[
							-82.64901999999995,
							27.748420000000067
						],
						[
							-82.64861485299991,
							27.748423046000084
						],
						[
							-82.6483556899999,
							27.74842499500005
						],
						[
							-82.64803157499995,
							27.748427432000085
						],
						[
							-82.6476899999999,
							27.74843000000004
						],
						[
							-82.64744850999995,
							27.748427743000036
						],
						[
							-82.64723254799992,
							27.74842572500006
						],
						[
							-82.64695159599995,
							27.748423099000036
						],
						[
							-82.64661999999993,
							27.74842033400006
						],
						[
							-82.64657999999991,
							27.748420000000067
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Lake Maggiore",
				"RegionID": "417137"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.65474999999992,
					27.752050000000054,
					-82.64658999999995,
					27.75932000000006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.64896628699995,
							27.75931218100004
						],
						[
							-82.6487699999999,
							27.759310000000085
						],
						[
							-82.64864999999992,
							27.759310000000085
						],
						[
							-82.64824454299992,
							27.759310000000085
						],
						[
							-82.64749861699994,
							27.759310000000085
						],
						[
							-82.64699331299994,
							27.759310000000085
						],
						[
							-82.64661534699991,
							27.759310000000085
						],
						[
							-82.6466099999999,
							27.759310000000085
						],
						[
							-82.6466154869999,
							27.759085032000087
						],
						[
							-82.64661999999993,
							27.758796112000084
						],
						[
							-82.64660831399993,
							27.758579791000045
						],
						[
							-82.64661999999993,
							27.758420000000058
						],
						[
							-82.64661999999993,
							27.75824268300005
						],
						[
							-82.64661999999993,
							27.757940000000076
						],
						[
							-82.64661999999993,
							27.757790000000057
						],
						[
							-82.64661999999993,
							27.757593006000036
						],
						[
							-82.64661999999993,
							27.757328322000035
						],
						[
							-82.64661999999993,
							27.75705000000005
						],
						[
							-82.64661552399991,
							27.75687096200005
						],
						[
							-82.6466099999999,
							27.756650000000036
						],
						[
							-82.6466099999999,
							27.756510210000044
						],
						[
							-82.6466099999999,
							27.756341775000067
						],
						[
							-82.6466099999999,
							27.75616000000008
						],
						[
							-82.6466062369999,
							27.75595682000005
						],
						[
							-82.6466031189999,
							27.755788443000085
						],
						[
							-82.64659999999992,
							27.75562000000008
						],
						[
							-82.64659999999992,
							27.75547553900009
						],
						[
							-82.64659999999992,
							27.75535522800004
						],
						[
							-82.64659999999992,
							27.75524000000007
						],
						[
							-82.64659573999995,
							27.755090904000042
						],
						[
							-82.64658999999995,
							27.754890000000046
						],
						[
							-82.64658999999995,
							27.754753675000075
						],
						[
							-82.64658999999995,
							27.75453711600005
						],
						[
							-82.64658999999995,
							27.754320000000064
						],
						[
							-82.64658999999995,
							27.75413000000009
						],
						[
							-82.64658999999995,
							27.75395962500005
						],
						[
							-82.64658999999995,
							27.75376712800005
						],
						[
							-82.64658999999995,
							27.75359869300007
						],
						[
							-82.64658999999995,
							27.753430000000037
						],
						[
							-82.64659207499994,
							27.753261920000057
						],
						[
							-82.64659504499991,
							27.753021336000074
						],
						[
							-82.64659999999992,
							27.752539960000036
						],
						[
							-82.64659999999992,
							27.75229933900005
						],
						[
							-82.64659999999992,
							27.75207157400007
						],
						[
							-82.6471376849999,
							27.75207000000006
						],
						[
							-82.64749861699994,
							27.75207000000006
						],
						[
							-82.64781999999991,
							27.75207000000006
						],
						[
							-82.6479076729999,
							27.75207000000006
						],
						[
							-82.64806999999992,
							27.75207000000006
						],
						[
							-82.64843712299995,
							27.75206320100006
						],
						[
							-82.6486099999999,
							27.752060000000085
						],
						[
							-82.64884609599994,
							27.752060000000085
						],
						[
							-82.64911999999993,
							27.752060000000085
						],
						[
							-82.64939952499992,
							27.752060000000085
						],
						[
							-82.64960999999994,
							27.752060000000085
						],
						[
							-82.64971219499995,
							27.752055557000062
						],
						[
							-82.64983999999993,
							27.752050000000054
						],
						[
							-82.65019357499995,
							27.752050000000054
						],
						[
							-82.65038607199995,
							27.752050000000054
						],
						[
							-82.65067999999991,
							27.752050000000054
						],
						[
							-82.65093950099993,
							27.752050000000054
						],
						[
							-82.65116999999992,
							27.752050000000054
						],
						[
							-82.65149292899991,
							27.752050000000054
						],
						[
							-82.6518057369999,
							27.752050000000054
						],
						[
							-82.65208999999993,
							27.752050000000054
						],
						[
							-82.65243135199995,
							27.752050000000054
						],
						[
							-82.65279228399993,
							27.752050000000054
						],
						[
							-82.65314999999993,
							27.752050000000054
						],
						[
							-82.65341789899992,
							27.752050000000054
						],
						[
							-82.65377999999993,
							27.752050000000054
						],
						[
							-82.65401945199994,
							27.752050000000054
						],
						[
							-82.65438038399992,
							27.752050000000054
						],
						[
							-82.65474999999992,
							27.752050000000054
						],
						[
							-82.65471092999991,
							27.752227229000088
						],
						[
							-82.65471730699994,
							27.75275651800007
						],
						[
							-82.65472332399992,
							27.753285820000087
						],
						[
							-82.65472724999995,
							27.753646970000094
						],
						[
							-82.65472999999993,
							27.75422430900005
						],
						[
							-82.65472999999993,
							27.754729613000055
						],
						[
							-82.65473568599992,
							27.755475647000083
						],
						[
							-82.65473638599991,
							27.75602891300008
						],
						[
							-82.6547326839999,
							27.75636574300006
						],
						[
							-82.65472999999993,
							27.756847080000057
						],
						[
							-82.65472999999993,
							27.757280198000046
						],
						[
							-82.65472999999993,
							27.757593006000036
						],
						[
							-82.65472999999993,
							27.758050186000048
						],
						[
							-82.65472999999993,
							27.75826674500007
						],
						[
							-82.65473452799995,
							27.758603766000082
						],
						[
							-82.65473719999994,
							27.758724017000077
						],
						[
							-82.65473999999995,
							27.75906079500004
						],
						[
							-82.65473999999995,
							27.759310000000085
						],
						[
							-82.65430819799991,
							27.759300000000053
						],
						[
							-82.65373999999991,
							27.759300000000053
						],
						[
							-82.65334571299991,
							27.759300000000053
						],
						[
							-82.65314999999993,
							27.759300000000053
						],
						[
							-82.65288865999992,
							27.759306533000085
						],
						[
							-82.65274999999991,
							27.759310000000085
						],
						[
							-82.65243135199995,
							27.759310000000085
						],
						[
							-82.65224999999992,
							27.759310000000085
						],
						[
							-82.65175784199994,
							27.759313155000086
						],
						[
							-82.65139661699993,
							27.759315470000047
						],
						[
							-82.65096351599993,
							27.759318247000067
						],
						[
							-82.65068999999994,
							27.75932000000006
						],
						[
							-82.65016951299992,
							27.75932000000006
						],
						[
							-82.6496699999999,
							27.75932000000006
						],
						[
							-82.64930338199991,
							27.759315926000056
						],
						[
							-82.64896628699995,
							27.75931218100004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Thirteenth St Heights",
				"RegionID": "417144"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.6590599999999,
					27.74837000000008,
					-82.6546459509999,
					27.752060000000085
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.6557248499999,
							27.752053361000037
						],
						[
							-82.65553999999992,
							27.752050000000054
						],
						[
							-82.65526695799991,
							27.752050000000054
						],
						[
							-82.6549070239999,
							27.752050000000054
						],
						[
							-82.65474999999992,
							27.752050000000054
						],
						[
							-82.65475218699993,
							27.751842273000083
						],
						[
							-82.65475471899992,
							27.751601678000043
						],
						[
							-82.6547564949999,
							27.751433009000042
						],
						[
							-82.6547585209999,
							27.751240533000043
						],
						[
							-82.6547599999999,
							27.751100000000065
						],
						[
							-82.65475559499993,
							27.750903956000062
						],
						[
							-82.65475235199995,
							27.75075965600007
						],
						[
							-82.65474585399994,
							27.750470515000075
						],
						[
							-82.65474315199992,
							27.750350266000055
						],
						[
							-82.65473999999995,
							27.75021000000004
						],
						[
							-82.65473999999995,
							27.74998937500004
						],
						[
							-82.65473999999995,
							27.74967656700005
						],
						[
							-82.65473999999995,
							27.74935000000005
						],
						[
							-82.65473438499993,
							27.74919557700008
						],
						[
							-82.65472823599993,
							27.749026491000052
						],
						[
							-82.65472211899993,
							27.748858278000057
						],
						[
							-82.65470630399994,
							27.748715865000065
						],
						[
							-82.6546827869999,
							27.748571404000074
						],
						[
							-82.65467453399992,
							27.74852070600008
						],
						[
							-82.6546459509999,
							27.74837021500008
						],
						[
							-82.65464999999995,
							27.74837000000008
						],
						[
							-82.6547697339999,
							27.748372217000057
						],
						[
							-82.65487768799994,
							27.74837421600006
						],
						[
							-82.65494325899994,
							27.748375431000056
						],
						[
							-82.65507280299994,
							27.748377830000038
						],
						[
							-82.65518999999995,
							27.748380000000054
						],
						[
							-82.65539656099992,
							27.748380000000054
						],
						[
							-82.65556934599994,
							27.748380000000054
						],
						[
							-82.65582852299993,
							27.748380000000054
						],
						[
							-82.65606999999994,
							27.748380000000054
						],
						[
							-82.6562820819999,
							27.748380000000054
						],
						[
							-82.65660605399995,
							27.748380000000054
						],
						[
							-82.65688999999992,
							27.748380000000054
						],
						[
							-82.65714600599995,
							27.748380000000054
						],
						[
							-82.65731999999991,
							27.748380000000054
						],
						[
							-82.65766420199992,
							27.74837595100007
						],
						[
							-82.65781562199993,
							27.748374169000044
						],
						[
							-82.65800997799994,
							27.74837188300006
						],
						[
							-82.65816999999993,
							27.74837000000008
						],
						[
							-82.65829999999994,
							27.74837000000008
						],
						[
							-82.6585066849999,
							27.74837000000008
						],
						[
							-82.6588090589999,
							27.74837000000008
						],
						[
							-82.65904999999992,
							27.74837000000008
						],
						[
							-82.65904536999994,
							27.748809820000076
						],
						[
							-82.65903999999996,
							27.749426568000047
						],
						[
							-82.65903999999996,
							27.74965000000009
						],
						[
							-82.6590459979999,
							27.74981493900009
						],
						[
							-82.65905349299993,
							27.75002107100005
						],
						[
							-82.6590599999999,
							27.750200000000063
						],
						[
							-82.65905872499991,
							27.750317260000088
						],
						[
							-82.6590559949999,
							27.750568487000066
						],
						[
							-82.6590542539999,
							27.750728608000088
						],
						[
							-82.6590525169999,
							27.75088848000007
						],
						[
							-82.65904999999992,
							27.75112000000007
						],
						[
							-82.65905247499991,
							27.75134520800009
						],
						[
							-82.65905473099991,
							27.751550506000058
						],
						[
							-82.65905724599992,
							27.751779396000074
						],
						[
							-82.6590599999999,
							27.752030000000047
						],
						[
							-82.65890999999993,
							27.752030000000047
						],
						[
							-82.65850636599993,
							27.752030000000047
						],
						[
							-82.65831999999995,
							27.752030000000047
						],
						[
							-82.65808098899993,
							27.752030000000047
						],
						[
							-82.6579099999999,
							27.752030000000047
						],
						[
							-82.65758999999991,
							27.752030000000047
						],
						[
							-82.65736099899993,
							27.75203318100006
						],
						[
							-82.6570338489999,
							27.752037724000047
						],
						[
							-82.65686999999991,
							27.75204000000008
						],
						[
							-82.65670675099994,
							27.752044186000035
						],
						[
							-82.65654325199995,
							27.75204837800004
						],
						[
							-82.65624811599992,
							27.75205594600004
						],
						[
							-82.65608999999995,
							27.752060000000085
						],
						[
							-82.65592170699996,
							27.752056940000045
						],
						[
							-82.6557248499999,
							27.752053361000037
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Fruitland Heights",
				"RegionID": "417146"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.64818999999994,
					27.766082670000063,
					-82.6466299999999,
					27.768470956000044
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.64738303199994,
							27.766089824000062
						],
						[
							-82.6481594679999,
							27.766082670000063
						],
						[
							-82.64817580699992,
							27.767536834000055
						],
						[
							-82.64818224499993,
							27.768033486000036
						],
						[
							-82.64818734099993,
							27.768313735000053
						],
						[
							-82.64818999999994,
							27.76846000000006
						],
						[
							-82.64795181799991,
							27.768461527000056
						],
						[
							-82.64757879899992,
							27.768463918000066
						],
						[
							-82.64683276199992,
							27.768468700000085
						],
						[
							-82.6466299999999,
							27.768470956000044
						],
						[
							-82.6466299999999,
							27.768470000000036
						],
						[
							-82.6466299999999,
							27.768176381000046
						],
						[
							-82.6466299999999,
							27.767940000000067
						],
						[
							-82.6466299999999,
							27.76746313700005
						],
						[
							-82.6466299999999,
							27.76705000000004
						],
						[
							-82.6466299999999,
							27.766674815000044
						],
						[
							-82.64663999999993,
							27.76610000000005
						],
						[
							-82.64738303199994,
							27.766089824000062
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Graham-Rogall",
				"RegionID": "417153"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.6497482339999,
					27.77386000000007,
					-82.64769999999993,
					27.777480000000082
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.64770430199991,
							27.77441207100009
						],
						[
							-82.64769999999993,
							27.773870000000045
						],
						[
							-82.64818344499992,
							27.773877006000077
						],
						[
							-82.64909991299993,
							27.773864338000067
						],
						[
							-82.64972735899994,
							27.77386000000007
						],
						[
							-82.6497482339999,
							27.774606487000085
						],
						[
							-82.64973618999994,
							27.774798583000063
						],
						[
							-82.64973999999995,
							27.775130000000047
						],
						[
							-82.64973999999995,
							27.77552183100005
						],
						[
							-82.64972999999992,
							27.776380000000074
						],
						[
							-82.64972999999992,
							27.777480000000082
						],
						[
							-82.64914836799994,
							27.777480000000082
						],
						[
							-82.64872999999994,
							27.777480000000082
						],
						[
							-82.64823163099993,
							27.777480000000082
						],
						[
							-82.64769999999993,
							27.777480000000082
						],
						[
							-82.64769999999993,
							27.77640000000008
						],
						[
							-82.6477057749999,
							27.77566661800006
						],
						[
							-82.6477099999999,
							27.775130000000047
						],
						[
							-82.64770430199991,
							27.77441207100009
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "James Clearview",
				"RegionID": "417155"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.65497999999991,
					27.781100000000038,
					-82.64667999999995,
					27.792040000000043
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.6546039989999,
							27.781100000000038
						],
						[
							-82.65482999999995,
							27.781100000000038
						],
						[
							-82.65492999999992,
							27.78250375500005
						],
						[
							-82.65494127399995,
							27.783930335000036
						],
						[
							-82.65496744799992,
							27.785961336000074
						],
						[
							-82.65495246899991,
							27.78738848900008
						],
						[
							-82.65496494999991,
							27.788815361000047
						],
						[
							-82.65496999999993,
							27.789638681000042
						],
						[
							-82.65497479999993,
							27.790626429000042
						],
						[
							-82.65497999999991,
							27.79150473800007
						],
						[
							-82.65497999999991,
							27.79198000000008
						],
						[
							-82.6548721929999,
							27.79198087800006
						],
						[
							-82.65375204299994,
							27.791990000000055
						],
						[
							-82.65216039899991,
							27.791998041000056
						],
						[
							-82.65172138399993,
							27.792003088000058
						],
						[
							-82.65029434899992,
							27.792020000000036
						],
						[
							-82.64914206399993,
							27.79202627300009
						],
						[
							-82.6484829659999,
							27.792032965000093
						],
						[
							-82.64738549399993,
							27.792040000000043
						],
						[
							-82.64670999999993,
							27.792040000000043
						],
						[
							-82.64670999999993,
							27.79155962200008
						],
						[
							-82.64670580599994,
							27.79090129100007
						],
						[
							-82.6466999999999,
							27.79007775300005
						],
						[
							-82.64670461399993,
							27.789199315000076
						],
						[
							-82.64670999999993,
							27.788541000000066
						],
						[
							-82.64670670099991,
							27.787663079000083
						],
						[
							-82.6466999999999,
							27.78656517400009
						],
						[
							-82.6466999999999,
							27.786071218000075
						],
						[
							-82.6466999999999,
							27.785522377000063
						],
						[
							-82.6466999999999,
							27.785083305000057
						],
						[
							-82.6466999999999,
							27.784479581000085
						],
						[
							-82.6466999999999,
							27.783850000000086
						],
						[
							-82.6466999999999,
							27.783430000000067
						],
						[
							-82.64669707699994,
							27.78321367000007
						],
						[
							-82.64669221899993,
							27.782854195000084
						],
						[
							-82.64668247299994,
							27.78223836500007
						],
						[
							-82.64667999999995,
							27.781793512000036
						],
						[
							-82.64667999999995,
							27.781451311000072
						],
						[
							-82.64667999999995,
							27.78114000000005
						],
						[
							-82.64704137699994,
							27.78114000000005
						],
						[
							-82.64734935699994,
							27.78114000000005
						],
						[
							-82.64771999999994,
							27.78114000000005
						],
						[
							-82.6479310439999,
							27.781137910000044
						],
						[
							-82.64817055999993,
							27.781135539000047
						],
						[
							-82.64832487399991,
							27.781134011000063
						],
						[
							-82.64846174099995,
							27.781132656000068
						],
						[
							-82.64872999999994,
							27.781130000000076
						],
						[
							-82.64897498699992,
							27.781127621000053
						],
						[
							-82.64924872099995,
							27.78112496400007
						],
						[
							-82.64959088899991,
							27.781121642000073
						],
						[
							-82.6497599999999,
							27.781120000000044
						],
						[
							-82.6500185989999,
							27.781117513000083
						],
						[
							-82.6502067909999,
							27.78111570400006
						],
						[
							-82.65048052599992,
							27.78111307200004
						],
						[
							-82.65066871899995,
							27.78111126200008
						],
						[
							-82.65079999999995,
							27.78111000000007
						],
						[
							-82.65099377399993,
							27.781107871000074
						],
						[
							-82.65116485399994,
							27.781105991000064
						],
						[
							-82.65131901299992,
							27.78110429700007
						],
						[
							-82.65152430799992,
							27.781102041000054
						],
						[
							-82.65170999999992,
							27.781100000000038
						],
						[
							-82.6518299999999,
							27.781100000000038
						],
						[
							-82.65208882799993,
							27.781100000000038
						],
						[
							-82.65237969799995,
							27.781100000000038
						],
						[
							-82.65255079799994,
							27.781100000000038
						],
						[
							-82.65269999999992,
							27.781100000000038
						],
						[
							-82.65283999999991,
							27.781100000000038
						],
						[
							-82.65318386799993,
							27.781100000000038
						],
						[
							-82.65349184799993,
							27.781100000000038
						],
						[
							-82.65365999999995,
							27.781100000000038
						],
						[
							-82.6538340489999,
							27.781100000000038
						],
						[
							-82.65393999999992,
							27.781100000000038
						],
						[
							-82.65410780899992,
							27.781100000000038
						],
						[
							-82.6546039989999,
							27.781100000000038
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Euclid-St Pauls",
				"RegionID": "417160"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.63860999999991,
					27.77631998000004,
					-82.62134774099991,
					27.79940531200009
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.63348157399992,
							27.79940531200009
						],
						[
							-82.6334809999999,
							27.79939900000005
						],
						[
							-82.63257831399994,
							27.799400036000065
						],
						[
							-82.63252638499995,
							27.798774809000065
						],
						[
							-82.63245750699991,
							27.798326196000062
						],
						[
							-82.63238492699992,
							27.797944073000053
						],
						[
							-82.63236392099994,
							27.797974073000034
						],
						[
							-82.63243470999994,
							27.796938327000078
						],
						[
							-82.63232609599993,
							27.796141825000063
						],
						[
							-82.63214507299995,
							27.79570737000006
						],
						[
							-82.63160200399994,
							27.795291017000068
						],
						[
							-82.63093779299993,
							27.795013822000044
						],
						[
							-82.63085978299996,
							27.794971197000052
						],
						[
							-82.6308061709999,
							27.79493944300009
						],
						[
							-82.63075488499993,
							27.79490405300004
						],
						[
							-82.6307061739999,
							27.794865197000036
						],
						[
							-82.63066026899992,
							27.79482306100005
						],
						[
							-82.63059826999995,
							27.794762061000085
						],
						[
							-82.63054007999995,
							27.79469907300006
						],
						[
							-82.63048072199992,
							27.79461985800009
						],
						[
							-82.6304367219999,
							27.794553859000075
						],
						[
							-82.63039674499993,
							27.794487936000056
						],
						[
							-82.63036256099991,
							27.79441883100009
						],
						[
							-82.63033442099993,
							27.79434705300008
						],
						[
							-82.63031253199995,
							27.794273128000043
						],
						[
							-82.63029853199993,
							27.79421712800007
						],
						[
							-82.63028533999994,
							27.794155166000053
						],
						[
							-82.6302724489999,
							27.794036995000056
						],
						[
							-82.63025078699991,
							27.794005410000068
						],
						[
							-82.62991848899992,
							27.793444581000074
						],
						[
							-82.62937541899994,
							27.79304633000004
						],
						[
							-82.62852460999994,
							27.792829102000045
						],
						[
							-82.62754708499995,
							27.792829102000045
						],
						[
							-82.62694970899992,
							27.792847204000054
						],
						[
							-82.62631612799993,
							27.792322237000068
						],
						[
							-82.6255314849999,
							27.79162457600006
						],
						[
							-82.62544013899992,
							27.79123407700007
						],
						[
							-82.62531281499992,
							27.79119034300004
						],
						[
							-82.62475111299995,
							27.79101780700006
						],
						[
							-82.62459387299992,
							27.79097355300007
						],
						[
							-82.62401808499993,
							27.790810804000046
						],
						[
							-82.62372749699996,
							27.79024047100006
						],
						[
							-82.62325683699993,
							27.789914630000055
						],
						[
							-82.6223336189999,
							27.78971550400007
						],
						[
							-82.62141417799995,
							27.789448649000065
						],
						[
							-82.6213970899999,
							27.789390079000043
						],
						[
							-82.62138755599995,
							27.78934689600004
						],
						[
							-82.62137002199997,
							27.78926171200004
						],
						[
							-82.62136534099994,
							27.789237166000078
						],
						[
							-82.6213517409999,
							27.78909161100006
						],
						[
							-82.62134774099991,
							27.788752611000064
						],
						[
							-82.62134853499992,
							27.788702757000067
						],
						[
							-82.62136753499993,
							27.78826775600004
						],
						[
							-82.62137427899995,
							27.788190325000073
						],
						[
							-82.6214162789999,
							27.787869326000077
						],
						[
							-82.62144752199993,
							27.78772454700004
						],
						[
							-82.6215265219999,
							27.78746454700007
						],
						[
							-82.62154984499995,
							27.787397439000074
						],
						[
							-82.62162284499993,
							27.78721144000008
						],
						[
							-82.62168116399994,
							27.787090339000088
						],
						[
							-82.62171583299994,
							27.787035030000084
						],
						[
							-82.62185807799995,
							27.786825406000048
						],
						[
							-82.62231181899995,
							27.78595900600004
						],
						[
							-82.6224380889999,
							27.785650969000073
						],
						[
							-82.6224198939999,
							27.785566612000085
						],
						[
							-82.62240732099991,
							27.78549399900004
						],
						[
							-82.62240073599992,
							27.785420602000045
						],
						[
							-82.62240018099993,
							27.78534691100009
						],
						[
							-82.62240566299994,
							27.785273422000046
						],
						[
							-82.6224171419999,
							27.785200629000087
						],
						[
							-82.62245091799991,
							27.785031747000062
						],
						[
							-82.62240452099991,
							27.784872362000044
						],
						[
							-82.62238756399995,
							27.784804377000057
						],
						[
							-82.6223759579999,
							27.78473527600005
						],
						[
							-82.62236977299996,
							27.784665482000037
						],
						[
							-82.62236904699995,
							27.78459541700005
						],
						[
							-82.62237378299994,
							27.78452550900005
						],
						[
							-82.62238395399993,
							27.78445618300009
						],
						[
							-82.62243156599993,
							27.78421353200008
						],
						[
							-82.62246891399991,
							27.78407941300009
						],
						[
							-82.62250758999994,
							27.783988899000065
						],
						[
							-82.6226555099999,
							27.783689267000057
						],
						[
							-82.62279613899995,
							27.783372646000092
						],
						[
							-82.62280367799991,
							27.783347598000034
						],
						[
							-82.62280367799991,
							27.783178000000078
						],
						[
							-82.62281895399991,
							27.78301318100006
						],
						[
							-82.62286656699992,
							27.78277052900006
						],
						[
							-82.62288215699994,
							27.782704495000075
						],
						[
							-82.62290267999992,
							27.782639824000057
						],
						[
							-82.62292802099995,
							27.782576885000083
						],
						[
							-82.6229580349999,
							27.78251603500007
						],
						[
							-82.62299254999994,
							27.78245762100005
						],
						[
							-82.62329302099994,
							27.781990308000047
						],
						[
							-82.62330698099993,
							27.781925241000067
						],
						[
							-82.62333365299992,
							27.781523434000064
						],
						[
							-82.62333936399995,
							27.78146567400006
						],
						[
							-82.62334436399993,
							27.781427674000042
						],
						[
							-82.6233560309999,
							27.78135943600006
						],
						[
							-82.62337291199992,
							27.781292298000043
						],
						[
							-82.62339490699992,
							27.78122665700005
						],
						[
							-82.6234218859999,
							27.781162902000062
						],
						[
							-82.62382302599991,
							27.780308216000037
						],
						[
							-82.62388417999995,
							27.78013252900007
						],
						[
							-82.62388866999993,
							27.78005267800006
						],
						[
							-82.62387050699995,
							27.77959774900006
						],
						[
							-82.62382834499994,
							27.77918550000004
						],
						[
							-82.6238238389999,
							27.779111020000073
						],
						[
							-82.62382552299994,
							27.779036422000047
						],
						[
							-82.6238333849999,
							27.778962221000086
						],
						[
							-82.62384737199994,
							27.778888927000082
						],
						[
							-82.62391143199994,
							27.778615502000036
						],
						[
							-82.62393649199993,
							27.77851307700007
						],
						[
							-82.62396491399994,
							27.77841941300005
						],
						[
							-82.62403173799993,
							27.778276349000066
						],
						[
							-82.62421930999994,
							27.777953360000083
						],
						[
							-82.62430911899992,
							27.77782569200008
						],
						[
							-82.62459415899991,
							27.77748845700006
						],
						[
							-82.62465379299994,
							27.777424491000094
						],
						[
							-82.62495080999992,
							27.77713545100005
						],
						[
							-82.62541221099991,
							27.776683680000076
						],
						[
							-82.62552489599994,
							27.776561316000084
						],
						[
							-82.6255604719999,
							27.77651236300005
						],
						[
							-82.62557520299993,
							27.77647319400006
						],
						[
							-82.62561401699992,
							27.776390752000054
						],
						[
							-82.62811461199993,
							27.77631998000004
						],
						[
							-82.62806581099994,
							27.776389676000065
						],
						[
							-82.62817750599993,
							27.77656767800005
						],
						[
							-82.6286401669999,
							27.776548474000037
						],
						[
							-82.6286930199999,
							27.776547803000085
						],
						[
							-82.62938866899994,
							27.776559423000037
						],
						[
							-82.62994299999991,
							27.77737600000006
						],
						[
							-82.62988499999996,
							27.777424000000053
						],
						[
							-82.63007999999991,
							27.777580000000057
						],
						[
							-82.6305795049999,
							27.777584233000084
						],
						[
							-82.6309924059999,
							27.777587732000086
						],
						[
							-82.63125999999994,
							27.77759000000009
						],
						[
							-82.6315930209999,
							27.777569262000046
						],
						[
							-82.63204344399992,
							27.77756471300006
						],
						[
							-82.63250999999991,
							27.77756000000005
						],
						[
							-82.63316958299994,
							27.77756000000005
						],
						[
							-82.6336575919999,
							27.77756000000005
						],
						[
							-82.63404999999995,
							27.77756000000005
						],
						[
							-82.63444588899995,
							27.77755741200008
						],
						[
							-82.63515910199993,
							27.777552751000087
						],
						[
							-82.63557999999995,
							27.777550000000076
						],
						[
							-82.63609740499993,
							27.777543324000078
						],
						[
							-82.63651075199994,
							27.777537990000045
						],
						[
							-82.63684854799993,
							27.777533632000086
						],
						[
							-82.6371299999999,
							27.77753000000007
						],
						[
							-82.63748660499994,
							27.77752524500005
						],
						[
							-82.63774933299993,
							27.77752174200009
						],
						[
							-82.63827490599994,
							27.77752000000004
						],
						[
							-82.63852934399995,
							27.77752000000004
						],
						[
							-82.63852999999995,
							27.77782944800009
						],
						[
							-82.63852999999995,
							27.778364559000067
						],
						[
							-82.63852999999995,
							27.77862000000005
						],
						[
							-82.63853282699995,
							27.778837689000056
						],
						[
							-82.63853764399994,
							27.779208622000056
						],
						[
							-82.63853999999992,
							27.779490000000067
						],
						[
							-82.63853999999992,
							27.779722917000072
						],
						[
							-82.63853999999992,
							27.780011054000056
						],
						[
							-82.63853999999992,
							27.78028000000006
						],
						[
							-82.6385364109999,
							27.780443287000082
						],
						[
							-82.63853052399992,
							27.780711166000064
						],
						[
							-82.63852555099993,
							27.780937450000067
						],
						[
							-82.63851999999991,
							27.781190000000038
						],
						[
							-82.63851677499991,
							27.781307730000037
						],
						[
							-82.63851112499992,
							27.78151395100008
						],
						[
							-82.63850492699993,
							27.78174017400005
						],
						[
							-82.63849999999991,
							27.78192000000007
						],
						[
							-82.63849999999991,
							27.782080000000065
						],
						[
							-82.63850458199994,
							27.782295340000076
						],
						[
							-82.63850999999995,
							27.78255000000007
						],
						[
							-82.63850999999995,
							27.78281009500006
						],
						[
							-82.63850999999995,
							27.78298000000007
						],
						[
							-82.63851450399994,
							27.783200719000035
						],
						[
							-82.63851999999991,
							27.783470000000083
						],
						[
							-82.63851300499995,
							27.783756793000066
						],
						[
							-82.63850999999995,
							27.783880000000067
						],
						[
							-82.63850999999995,
							27.78410671000006
						],
						[
							-82.63850999999995,
							27.78436000000005
						],
						[
							-82.63851489299992,
							27.784580180000038
						],
						[
							-82.63851999999991,
							27.78481000000005
						],
						[
							-82.63851999999991,
							27.784972121000067
						],
						[
							-82.63851999999991,
							27.785102780000045
						],
						[
							-82.63851999999991,
							27.78526000000005
						],
						[
							-82.63851999999991,
							27.78540765200006
						],
						[
							-82.63851999999991,
							27.785538312000085
						],
						[
							-82.63851999999991,
							27.785730000000058
						],
						[
							-82.6385237369999,
							27.785857064000083
						],
						[
							-82.63852629699994,
							27.785944095000048
						],
						[
							-82.63852999999995,
							27.786070000000052
						],
						[
							-82.6385253169999,
							27.78633693900008
						],
						[
							-82.63852226099993,
							27.786511098000062
						],
						[
							-82.63851999999991,
							27.78664000000009
						],
						[
							-82.63851999999991,
							27.786772317000043
						],
						[
							-82.63851999999991,
							27.78687000000008
						],
						[
							-82.63852269799992,
							27.787048061000064
						],
						[
							-82.63852467999993,
							27.78717891100007
						],
						[
							-82.63852665999991,
							27.78730954000008
						],
						[
							-82.6385286389999,
							27.78744017000008
						],
						[
							-82.63852999999995,
							27.78753000000006
						],
						[
							-82.63852999999995,
							27.787690000000058
						],
						[
							-82.63852770999996,
							27.78778847800004
						],
						[
							-82.63852601499991,
							27.787861365000083
						],
						[
							-82.63852230299995,
							27.788020974000062
						],
						[
							-82.63851999999991,
							27.78812000000005
						],
						[
							-82.63851999999991,
							27.78822408900004
						],
						[
							-82.63851999999991,
							27.788290000000075
						],
						[
							-82.63851999999991,
							27.788470000000075
						],
						[
							-82.63851999999991,
							27.788630585000078
						],
						[
							-82.63851999999991,
							27.78876000000008
						],
						[
							-82.63851999999991,
							27.788935457000036
						],
						[
							-82.63851999999991,
							27.789153223000085
						],
						[
							-82.63851999999991,
							27.789370000000076
						],
						[
							-82.63851999999991,
							27.78950164800006
						],
						[
							-82.63851999999991,
							27.789580000000058
						],
						[
							-82.63851999999991,
							27.789733931000058
						],
						[
							-82.63851999999991,
							27.789864591000086
						],
						[
							-82.63851999999991,
							27.790111392000085
						],
						[
							-82.63851999999991,
							27.790285604000076
						],
						[
							-82.63851999999991,
							27.790410000000065
						],
						[
							-82.63851999999991,
							27.790532405000082
						],
						[
							-82.63851999999991,
							27.790640000000053
						],
						[
							-82.63851999999991,
							27.79096793700006
						],
						[
							-82.63851999999991,
							27.791084079000086
						],
						[
							-82.63851999999991,
							27.791240000000073
						],
						[
							-82.63851999999991,
							27.791360000000054
						],
						[
							-82.63852536199994,
							27.79150476700005
						],
						[
							-82.63852999999995,
							27.791630000000055
						],
						[
							-82.63852999999995,
							27.791824482000038
						],
						[
							-82.63852999999995,
							27.791955142000067
						],
						[
							-82.63852999999995,
							27.79207000000008
						],
						[
							-82.63858999999991,
							27.79207000000008
						],
						[
							-82.63853432399992,
							27.792467826000063
						],
						[
							-82.63853714099992,
							27.79272698500006
						],
						[
							-82.6384799999999,
							27.79299000000009
						],
						[
							-82.63853632899992,
							27.79332407100009
						],
						[
							-82.63853347799994,
							27.793583511000065
						],
						[
							-82.63852999999995,
							27.793900000000068
						],
						[
							-82.63852999999995,
							27.794310059000054
						],
						[
							-82.63852999999995,
							27.794595478000076
						],
						[
							-82.63852999999995,
							27.794830000000047
						],
						[
							-82.6385345509999,
							27.795244172000082
						],
						[
							-82.63853683199994,
							27.795451725000078
						],
						[
							-82.63853999999992,
							27.79574000000008
						],
						[
							-82.6385425339999,
							27.795970606000083
						],
						[
							-82.63854624399994,
							27.79630816400004
						],
						[
							-82.63854999999995,
							27.796650000000056
						],
						[
							-82.63854803599992,
							27.796826783000085
						],
						[
							-82.63854486499991,
							27.79711216700008
						],
						[
							-82.6385425549999,
							27.797320007000053
						],
						[
							-82.63853999999992,
							27.797550000000058
						],
						[
							-82.6385462749999,
							27.797838651000063
						],
						[
							-82.63855474399992,
							27.798228238000036
						],
						[
							-82.63855999999993,
							27.79847000000007
						],
						[
							-82.63860999999991,
							27.79856539800005
						],
						[
							-82.63860999999991,
							27.798850817000073
						],
						[
							-82.63860999999991,
							27.799162183000078
						],
						[
							-82.63860999999991,
							27.799370000000067
						],
						[
							-82.6379910199999,
							27.79937351400008
						],
						[
							-82.63749804799994,
							27.799376986000084
						],
						[
							-82.6367974229999,
							27.799380000000042
						],
						[
							-82.63614874399991,
							27.799380000000042
						],
						[
							-82.63539637199995,
							27.79938278800006
						],
						[
							-82.63474753499992,
							27.79938763000007
						],
						[
							-82.63399567599994,
							27.799393356000053
						],
						[
							-82.63348157399992,
							27.79940531200009
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Historic Old Northeast",
				"RegionID": "417162"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.65490999999992,
					27.79198087800006,
					-82.64670999999993,
					27.79932000000008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.65375204299994,
							27.791990000000055
						],
						[
							-82.6548721929999,
							27.79198087800006
						],
						[
							-82.65487475099991,
							27.79215827400009
						],
						[
							-82.65487999999993,
							27.792625051000073
						],
						[
							-82.65487999999993,
							27.79331152000009
						],
						[
							-82.65487999999993,
							27.79361356600009
						],
						[
							-82.65487999999993,
							27.794217659000083
						],
						[
							-82.65487999999993,
							27.794684458000063
						],
						[
							-82.65489170399991,
							27.79523325300005
						],
						[
							-82.65489999999994,
							27.79597502000007
						],
						[
							-82.65489999999994,
							27.796277066000076
						],
						[
							-82.65489999999994,
							27.796826241000076
						],
						[
							-82.65489999999994,
							27.79721066400009
						],
						[
							-82.65489999999994,
							27.797704921000047
						],
						[
							-82.65489999999994,
							27.79806188500004
						],
						[
							-82.65490387699992,
							27.79872119500004
						],
						[
							-82.65490793299995,
							27.799078113000064
						],
						[
							-82.65490999999992,
							27.79926000000006
						],
						[
							-82.65490798199994,
							27.799260021000066
						],
						[
							-82.6545457709999,
							27.799263755000084
						],
						[
							-82.65418884499991,
							27.799267435000047
						],
						[
							-82.65366719699995,
							27.79927341000007
						],
						[
							-82.65339265299991,
							27.79927684200004
						],
						[
							-82.6528712679999,
							27.799286718000076
						],
						[
							-82.6526242939999,
							27.799292893000086
						],
						[
							-82.65207454799992,
							27.799300000000073
						],
						[
							-82.65160774899994,
							27.799300000000073
						],
						[
							-82.65119586799995,
							27.799300000000073
						],
						[
							-82.65103111499991,
							27.799300000000073
						],
						[
							-82.65070160999994,
							27.799300000000073
						],
						[
							-82.65048193999992,
							27.799300000000073
						],
						[
							-82.65001514099993,
							27.799300000000073
						],
						[
							-82.64954842199995,
							27.799303657000053
						],
						[
							-82.6493013349999,
							27.79930686600005
						],
						[
							-82.6489442489999,
							27.799310000000048
						],
						[
							-82.64864220299995,
							27.799310000000048
						],
						[
							-82.64834041299991,
							27.79931240700006
						],
						[
							-82.64812033499993,
							27.799316201000067
						],
						[
							-82.64765368799993,
							27.79932000000008
						],
						[
							-82.6471868889999,
							27.79932000000008
						],
						[
							-82.64672999999993,
							27.79932000000008
						],
						[
							-82.64672999999993,
							27.798830730000077
						],
						[
							-82.64672999999993,
							27.798380000000066
						],
						[
							-82.64672634599992,
							27.798062129000073
						],
						[
							-82.6467199999999,
							27.79751000000005
						],
						[
							-82.6467199999999,
							27.797238122000067
						],
						[
							-82.6467199999999,
							27.79693607600007
						],
						[
							-82.6467199999999,
							27.796610000000044
						],
						[
							-82.6467199999999,
							27.79619469000005
						],
						[
							-82.6467199999999,
							27.795690000000036
						],
						[
							-82.6467199999999,
							27.795233633000066
						],
						[
							-82.6467199999999,
							27.794959046000088
						],
						[
							-82.6467199999999,
							27.794770000000085
						],
						[
							-82.6467199999999,
							27.794327494000072
						],
						[
							-82.6467199999999,
							27.794107824000037
						],
						[
							-82.6467199999999,
							27.793870000000084
						],
						[
							-82.64671597599994,
							27.79350377700007
						],
						[
							-82.64671205299993,
							27.793146856000078
						],
						[
							-82.64670999999993,
							27.79296000000005
						],
						[
							-82.64670999999993,
							27.792515216000083
						],
						[
							-82.64670999999993,
							27.792040000000043
						],
						[
							-82.64738549399993,
							27.792040000000043
						],
						[
							-82.6484829659999,
							27.792032965000093
						],
						[
							-82.64914206399993,
							27.79202627300009
						],
						[
							-82.65029434899992,
							27.792020000000036
						],
						[
							-82.65172138399993,
							27.792003088000058
						],
						[
							-82.65216039899991,
							27.791998041000056
						],
						[
							-82.65375204299994,
							27.791990000000055
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Greater Woodlawn",
				"RegionID": "417164"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.79919095499991,
					26.152850742000055,
					-81.79064799999992,
					26.168731050000076
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.79117533499993,
							26.165519376000077
						],
						[
							-81.79116599999992,
							26.16511500000007
						],
						[
							-81.79065799999995,
							26.16512000000006
						],
						[
							-81.79064799999992,
							26.164758000000067
						],
						[
							-81.79095299999994,
							26.164756000000068
						],
						[
							-81.79109499999993,
							26.164772000000085
						],
						[
							-81.7911252049999,
							26.164782855000055
						],
						[
							-81.79115899999994,
							26.164795000000083
						],
						[
							-81.79113799999993,
							26.16386200000005
						],
						[
							-81.7911279999999,
							26.162840000000074
						],
						[
							-81.79111899999992,
							26.162339000000088
						],
						[
							-81.79099951299992,
							26.16233820700006
						],
						[
							-81.79091999999991,
							26.16036999900007
						],
						[
							-81.79090999999994,
							26.16017000000005
						],
						[
							-81.79090999999994,
							26.15971999900006
						],
						[
							-81.79090999999994,
							26.15785999900004
						],
						[
							-81.79090999899995,
							26.15747000000005
						],
						[
							-81.7908799999999,
							26.156269999000074
						],
						[
							-81.79082717199992,
							26.15351155400009
						],
						[
							-81.79093477499993,
							26.15349940300007
						],
						[
							-81.79100999999991,
							26.15349000000009
						],
						[
							-81.79137530399993,
							26.153438152000035
						],
						[
							-81.79158398099992,
							26.153409169000042
						],
						[
							-81.7917141719999,
							26.153395722000084
						],
						[
							-81.79179999999991,
							26.153390000000062
						],
						[
							-81.79196655899995,
							26.153368275000048
						],
						[
							-81.79220726199992,
							26.15333687900005
						],
						[
							-81.79236390499995,
							26.153316447000066
						],
						[
							-81.79248999999993,
							26.15330000000006
						],
						[
							-81.79305761299992,
							26.153236932000084
						],
						[
							-81.79362022799995,
							26.15317228100008
						],
						[
							-81.79416567499993,
							26.153109345000075
						],
						[
							-81.79459999399995,
							26.153059231000043
						],
						[
							-81.79493999999994,
							26.153020000000083
						],
						[
							-81.79536781799993,
							26.152964482000073
						],
						[
							-81.79577703799993,
							26.152911377000066
						],
						[
							-81.79609775499996,
							26.152869757000076
						],
						[
							-81.79624298499994,
							26.152850742000055
						],
						[
							-81.79640999999992,
							26.153769999000076
						],
						[
							-81.79690999999991,
							26.15645999900005
						],
						[
							-81.79704994999992,
							26.157270016000044
						],
						[
							-81.79710516299993,
							26.157545837000043
						],
						[
							-81.79735880099992,
							26.15817852300006
						],
						[
							-81.79750989199994,
							26.158927550000044
						],
						[
							-81.79761129999991,
							26.15943027600008
						],
						[
							-81.79769999999992,
							26.15987000000007
						],
						[
							-81.7977929459999,
							26.16033860200008
						],
						[
							-81.79793040699992,
							26.161031636000075
						],
						[
							-81.79805504099994,
							26.16162069300009
						],
						[
							-81.79813999999993,
							26.16202000000004
						],
						[
							-81.79817276599994,
							26.16217873400007
						],
						[
							-81.79823943899993,
							26.162501728000056
						],
						[
							-81.79842561999993,
							26.163403669000047
						],
						[
							-81.79858999999993,
							26.16420000000005
						],
						[
							-81.79866176199994,
							26.164573618000077
						],
						[
							-81.7987653749999,
							26.16511306400008
						],
						[
							-81.7990111979999,
							26.16639290300009
						],
						[
							-81.79915008499995,
							26.16730996800004
						],
						[
							-81.79919095499991,
							26.167493033000085
						],
						[
							-81.79912900199992,
							26.16750729900008
						],
						[
							-81.79906838099993,
							26.167525486000045
						],
						[
							-81.79901999999993,
							26.167540000000088
						],
						[
							-81.79887616899993,
							26.167567396000038
						],
						[
							-81.79871423199995,
							26.167598242000054
						],
						[
							-81.79856691599991,
							26.16762413500004
						],
						[
							-81.79838701599994,
							26.167646623000053
						],
						[
							-81.79810607699994,
							26.167681740000035
						],
						[
							-81.79786579899991,
							26.167711775000043
						],
						[
							-81.79771999999991,
							26.167730000000063
						],
						[
							-81.79733508999993,
							26.167791236000085
						],
						[
							-81.79684420599995,
							26.167869331000077
						],
						[
							-81.79630460999994,
							26.16795574400004
						],
						[
							-81.79585316899994,
							26.168030254000087
						],
						[
							-81.79553164299995,
							26.16808332100004
						],
						[
							-81.79536999999993,
							26.16811000000007
						],
						[
							-81.79478271399995,
							26.168205236000063
						],
						[
							-81.79423036799994,
							26.168294805000073
						],
						[
							-81.79347000299992,
							26.168418108000083
						],
						[
							-81.79266986199991,
							26.168543098000043
						],
						[
							-81.79190852099993,
							26.16866022800008
						],
						[
							-81.79151999999993,
							26.168720000000064
						],
						[
							-81.79139292199996,
							26.168731050000076
						],
						[
							-81.79137824299994,
							26.168552205000083
						],
						[
							-81.79130600299993,
							26.16767200000004
						],
						[
							-81.79130545499993,
							26.16766529000006
						],
						[
							-81.79120799999993,
							26.16646600000007
						],
						[
							-81.79118799999992,
							26.166068000000053
						],
						[
							-81.79117533499993,
							26.165519376000077
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Collier",
				"City": "Naples",
				"Name": "Lake Park",
				"RegionID": "274237"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.05410999999992,
					26.696900000000085,
					-80.05230430199992,
					26.70043809000009
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.05244999999991,
							26.696900000000085
						],
						[
							-80.0525866179999,
							26.696900000000085
						],
						[
							-80.05283713999995,
							26.696905364000088
						],
						[
							-80.0531630399999,
							26.69691423200004
						],
						[
							-80.05353855499993,
							26.69692445000004
						],
						[
							-80.05393932999993,
							26.69693535600004
						],
						[
							-80.05410999999992,
							26.69694000000004
						],
						[
							-80.05409999999995,
							26.697050000000047
						],
						[
							-80.05409310599994,
							26.697222344000068
						],
						[
							-80.05408999999992,
							26.69730000000004
						],
						[
							-80.05408801599992,
							26.69738134700009
						],
						[
							-80.05408491599991,
							26.697508436000078
						],
						[
							-80.05408045999991,
							26.69769112700004
						],
						[
							-80.05406973299995,
							26.697817798000074
						],
						[
							-80.05405999999994,
							26.697920000000067
						],
						[
							-80.05405090099993,
							26.69806558500005
						],
						[
							-80.05404312899992,
							26.698183071000077
						],
						[
							-80.0540297519999,
							26.69838371500009
						],
						[
							-80.05401999999992,
							26.698530000000062
						],
						[
							-80.05401999999992,
							26.698600388000045
						],
						[
							-80.05401999999992,
							26.698639880000087
						],
						[
							-80.05401999999992,
							26.698668704000056
						],
						[
							-80.05401999999992,
							26.698712269000055
						],
						[
							-80.05401999999992,
							26.69877929200004
						],
						[
							-80.05401999999992,
							26.69885000000005
						],
						[
							-80.05401901099992,
							26.698879677000036
						],
						[
							-80.05401732999991,
							26.69893011100004
						],
						[
							-80.05401498599991,
							26.699000407000085
						],
						[
							-80.05401274699994,
							26.69906757900009
						],
						[
							-80.05400999999995,
							26.69915000000009
						],
						[
							-80.05400785299992,
							26.699177906000045
						],
						[
							-80.0540055269999,
							26.699208145000057
						],
						[
							-80.05399999999992,
							26.699280000000044
						],
						[
							-80.05399999999992,
							26.699325530000067
						],
						[
							-80.05399999999992,
							26.699375797000073
						],
						[
							-80.05399999999992,
							26.699430000000064
						],
						[
							-80.05399566899992,
							26.69948630600004
						],
						[
							-80.05399077999994,
							26.699549859000058
						],
						[
							-80.05398587199994,
							26.699613669000087
						],
						[
							-80.05398021399992,
							26.699687217000076
						],
						[
							-80.05397999999991,
							26.69975000000005
						],
						[
							-80.05397789599994,
							26.699787875000084
						],
						[
							-80.05397474099993,
							26.699844669000072
						],
						[
							-80.05396931699994,
							26.699942296000078
						],
						[
							-80.05396319199991,
							26.700052544000073
						],
						[
							-80.0539599999999,
							26.700110000000052
						],
						[
							-80.0539599999999,
							26.700159967000047
						],
						[
							-80.05395649399992,
							26.700264132000086
						],
						[
							-80.0539517549999,
							26.700377874000083
						],
						[
							-80.05394924599995,
							26.70043809000009
						],
						[
							-80.05230430199992,
							26.700401620000036
						],
						[
							-80.0523199989999,
							26.700140000000093
						],
						[
							-80.05232999999993,
							26.69984000000005
						],
						[
							-80.05234999999993,
							26.69954000100006
						],
						[
							-80.05236999999994,
							26.69914000100005
						],
						[
							-80.05236999999994,
							26.69894000000005
						],
						[
							-80.05238987199994,
							26.698639864000086
						],
						[
							-80.05238999999995,
							26.69849000000005
						],
						[
							-80.0523932179999,
							26.69839184500006
						],
						[
							-80.05239814999993,
							26.698241416000087
						],
						[
							-80.05240336499992,
							26.698082371000055
						],
						[
							-80.05240999999995,
							26.697880000000055
						],
						[
							-80.05241717199995,
							26.697731773000044
						],
						[
							-80.05242726999995,
							26.69752308300008
						],
						[
							-80.05243999999993,
							26.697260000000085
						],
						[
							-80.05244329699991,
							26.69719735800004
						],
						[
							-80.05244999999991,
							26.69703041100007
						],
						[
							-80.05244999999991,
							26.696900000000085
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "West Palm Beach",
				"Name": "Mango Promenade",
				"RegionID": "274405"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.12482254699995,
					26.119427804000054,
					-80.12225673799992,
					26.12309227800006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.12445801599996,
							26.119448720000037
						],
						[
							-80.12482254699995,
							26.119427804000054
						],
						[
							-80.12432769499992,
							26.120155749000048
						],
						[
							-80.1243830759999,
							26.12024786900008
						],
						[
							-80.12429977999994,
							26.120928914000046
						],
						[
							-80.1237894329999,
							26.122721811000076
						],
						[
							-80.1236839789999,
							26.12309227800006
						],
						[
							-80.12274145999993,
							26.12308412200008
						],
						[
							-80.12225673799992,
							26.11987029100004
						],
						[
							-80.12293976399992,
							26.119751168000054
						],
						[
							-80.12353464599994,
							26.11964901600004
						],
						[
							-80.1238330889999,
							26.11958291800005
						],
						[
							-80.1242446999999,
							26.119494787000065
						],
						[
							-80.12445801599996,
							26.119448720000037
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Navarrea Isle",
				"RegionID": "274639"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.83563399199994,
					30.273536146000087,
					-81.78132990599995,
					30.302132106000045
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.83427790799993,
							30.273977011000056
						],
						[
							-81.83529633999991,
							30.273536146000087
						],
						[
							-81.83534690699992,
							30.273636011000065
						],
						[
							-81.83563399199994,
							30.274215995000077
						],
						[
							-81.79798900599991,
							30.302132106000045
						],
						[
							-81.79678090599992,
							30.301999008000053
						],
						[
							-81.79444590599991,
							30.30172600800006
						],
						[
							-81.79174090499993,
							30.30141400800005
						],
						[
							-81.78977590599993,
							30.30118900900004
						],
						[
							-81.78970590599994,
							30.301181008000075
						],
						[
							-81.78761690499994,
							30.30093900900005
						],
						[
							-81.7869939059999,
							30.300865008000077
						],
						[
							-81.78368776199996,
							30.30049213000007
						],
						[
							-81.78371790499995,
							30.299601008000078
						],
						[
							-81.7837099059999,
							30.299419008000086
						],
						[
							-81.78368190499992,
							30.299223008000073
						],
						[
							-81.78361490499992,
							30.29894300800004
						],
						[
							-81.78350490499992,
							30.298654009000074
						],
						[
							-81.78337190499991,
							30.298400009000094
						],
						[
							-81.78328390599995,
							30.298261008000054
						],
						[
							-81.78307290499993,
							30.297993009000034
						],
						[
							-81.78292890699993,
							30.297840009000087
						],
						[
							-81.78278590499991,
							30.297705009000087
						],
						[
							-81.78205390599993,
							30.29706300800007
						],
						[
							-81.78181390599991,
							30.29679300700008
						],
						[
							-81.78165790599991,
							30.296550008000057
						],
						[
							-81.78155990599993,
							30.29636100800008
						],
						[
							-81.78146990599993,
							30.29614200800006
						],
						[
							-81.78136190699992,
							30.29577301100005
						],
						[
							-81.78133890599992,
							30.295554008000067
						],
						[
							-81.78132990599995,
							30.29508600900004
						],
						[
							-81.78133390599993,
							30.294691009000076
						],
						[
							-81.78135690599993,
							30.29358500900008
						],
						[
							-81.78133990599991,
							30.29260000800008
						],
						[
							-81.7813458199999,
							30.29251394900007
						],
						[
							-81.78261390599994,
							30.292007008000045
						],
						[
							-81.78301890499995,
							30.291855008000088
						],
						[
							-81.78367590499994,
							30.29162200800005
						],
						[
							-81.78396990599992,
							30.291523009000056
						],
						[
							-81.7845029049999,
							30.291340009000066
						],
						[
							-81.7855359049999,
							30.291013008000053
						],
						[
							-81.78645090599991,
							30.29073100900007
						],
						[
							-81.78694390599992,
							30.29060000900006
						],
						[
							-81.78789090599993,
							30.290340008000044
						],
						[
							-81.7883279049999,
							30.290234009000073
						],
						[
							-81.79009490499993,
							30.289829009000076
						],
						[
							-81.79185490499992,
							30.289395008000042
						],
						[
							-81.7919739049999,
							30.289353009000084
						],
						[
							-81.79279390499994,
							30.28917000900009
						],
						[
							-81.7935039059999,
							30.288994008000092
						],
						[
							-81.79412490599994,
							30.28886000800009
						],
						[
							-81.79542990499993,
							30.28855500800006
						],
						[
							-81.79566790599995,
							30.288492009000038
						],
						[
							-81.79612090599994,
							30.288368008000077
						],
						[
							-81.79676090599992,
							30.288192008000067
						],
						[
							-81.79700590599992,
							30.288120009000068
						],
						[
							-81.79813290499993,
							30.287796008000043
						],
						[
							-81.79933690599995,
							30.287364008000058
						],
						[
							-81.7995569059999,
							30.28729000800007
						],
						[
							-81.80054590599991,
							30.286912009000048
						],
						[
							-81.80099490599991,
							30.286745008000086
						],
						[
							-81.8011329059999,
							30.286677009000073
						],
						[
							-81.8020399049999,
							30.286363009000073
						],
						[
							-81.80262790499997,
							30.286137008000086
						],
						[
							-81.8031179059999,
							30.28595700900007
						],
						[
							-81.80339590599993,
							30.285859009000035
						],
						[
							-81.80450690599992,
							30.285393009000074
						],
						[
							-81.80530690599994,
							30.285069008000054
						],
						[
							-81.80644790499991,
							30.284621008000045
						],
						[
							-81.8082359089999,
							30.283935067000076
						],
						[
							-81.80848090699993,
							30.283840010000063
						],
						[
							-81.80859090799993,
							30.283795011000056
						],
						[
							-81.81023690799992,
							30.283171010000046
						],
						[
							-81.81064490699993,
							30.28302601000007
						],
						[
							-81.81103290699991,
							30.28287101000007
						],
						[
							-81.8114209069999,
							30.282733010000076
						],
						[
							-81.81228590699993,
							30.282416010000077
						],
						[
							-81.81461890799994,
							30.281549011000035
						],
						[
							-81.81471690799992,
							30.28151001100008
						],
						[
							-81.81589290699992,
							30.281094010000064
						],
						[
							-81.81630890699995,
							30.280932010000072
						],
						[
							-81.81778890699991,
							30.28041101000008
						],
						[
							-81.8179029069999,
							30.280368010000075
						],
						[
							-81.81958490699992,
							30.279737011000066
						],
						[
							-81.82002990799992,
							30.27955401000008
						],
						[
							-81.82082090799992,
							30.279268011000056
						],
						[
							-81.82095790799991,
							30.279216011000074
						],
						[
							-81.8217959079999,
							30.27890601000007
						],
						[
							-81.82219190699993,
							30.278769010000076
						],
						[
							-81.82234690799993,
							30.278712010000046
						],
						[
							-81.8234169079999,
							30.278321010000074
						],
						[
							-81.82422190699992,
							30.27801401000005
						],
						[
							-81.82443290799995,
							30.277942011000047
						],
						[
							-81.82463290699991,
							30.277872010000067
						],
						[
							-81.82585090799995,
							30.277409010000042
						],
						[
							-81.82624990699992,
							30.277254011000082
						],
						[
							-81.82730690799991,
							30.276850011000082
						],
						[
							-81.82759790699993,
							30.276744010000073
						],
						[
							-81.82769690799995,
							30.276707010000052
						],
						[
							-81.82831590799992,
							30.276484010000047
						],
						[
							-81.82858290799993,
							30.276394010000047
						],
						[
							-81.82893490799995,
							30.276265011000078
						],
						[
							-81.82937790699992,
							30.27610401100009
						],
						[
							-81.82977490799993,
							30.27595401100007
						],
						[
							-81.8301989069999,
							30.275782010000057
						],
						[
							-81.83103990799992,
							30.275423011000044
						],
						[
							-81.83178090799993,
							30.275131010000056
						],
						[
							-81.83202390799994,
							30.275017011000045
						],
						[
							-81.83279490799993,
							30.274693010000078
						],
						[
							-81.83317090799994,
							30.274525011000037
						],
						[
							-81.83427790799993,
							30.273977011000056
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Normandy Estate",
				"RegionID": "274678"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.7299591359998,
					27.941231604406727,
					-82.72005725050667,
					27.944013928699643
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.7262657354243,
							27.944013146289596
						],
						[
							-82.72618323431924,
							27.94391163801261
						],
						[
							-82.72614862750832,
							27.94387674611666
						],
						[
							-82.72611201161178,
							27.943850883414104
						],
						[
							-82.72605293244968,
							27.943816126416113
						],
						[
							-82.72601338568737,
							27.943796705880356
						],
						[
							-82.72554499986435,
							27.943787000073534
						],
						[
							-82.72473099921375,
							27.943803999957876
						],
						[
							-82.7232129993863,
							27.943775000419816
						],
						[
							-82.7214348621183,
							27.943795779255534
						],
						[
							-82.72136098056534,
							27.943830190913236
						],
						[
							-82.7213237711163,
							27.943851260230375
						],
						[
							-82.72129035770568,
							27.943877942215703
						],
						[
							-82.72126158029998,
							27.943909569572792
						],
						[
							-82.72125158576829,
							27.943922475306874
						],
						[
							-82.7210119999999,
							27.943619000000123
						],
						[
							-82.72103948737238,
							27.94344517140505
						],
						[
							-82.72106190999551,
							27.94330337199941
						],
						[
							-82.72108299999992,
							27.9431700000001
						],
						[
							-82.72098623986525,
							27.943115338238403
						],
						[
							-82.72086252246032,
							27.94304544776828
						],
						[
							-82.72064399999992,
							27.942922000000184
						],
						[
							-82.7206546821613,
							27.942749898511746
						],
						[
							-82.72066515172901,
							27.942722136241752
						],
						[
							-82.72065661596775,
							27.942718742739917
						],
						[
							-82.72067035714343,
							27.94249735713336
						],
						[
							-82.72067099999994,
							27.942487000000074
						],
						[
							-82.7206087371028,
							27.942432171478973
						],
						[
							-82.7206039999999,
							27.94242800000017
						],
						[
							-82.72052407899986,
							27.942218866000093
						],
						[
							-82.72042996048074,
							27.9419847365385
						],
						[
							-82.72011402181592,
							27.941703638413454
						],
						[
							-82.72008187484283,
							27.94162413239231
						],
						[
							-82.72007069357208,
							27.941590150609233
						],
						[
							-82.72006506111829,
							27.941568235031262
						],
						[
							-82.72005766959063,
							27.941525407516924
						],
						[
							-82.72005725050667,
							27.941481949579234
						],
						[
							-82.72006381465802,
							27.941438987166936
						],
						[
							-82.720077191174,
							27.94139763723901
						],
						[
							-82.72009703381495,
							27.94135897088889
						],
						[
							-82.72012282727025,
							27.941323991758185
						],
						[
							-82.7201539024437,
							27.94129360906307
						],
						[
							-82.72018945264345,
							27.941268609709727
						],
						[
							-82.7202285551653,
							27.941249642108193
						],
						[
							-82.72027019647321,
							27.94123719908931
						],
						[
							-82.72031329558212,
							27.941231604406727
						],
						[
							-82.72035673283618,
							27.94123300195334
						],
						[
							-82.72037901713664,
							27.94123552545013
						],
						[
							-82.72075643561274,
							27.941238410475325
						],
						[
							-82.72110593646076,
							27.941240768507317
						],
						[
							-82.72110399929538,
							27.941245999854228
						],
						[
							-82.72104200003471,
							27.941308000014256
						],
						[
							-82.72093799973737,
							27.94135300029012
						],
						[
							-82.72073399932685,
							27.94138399992018
						],
						[
							-82.7205309998618,
							27.94143400042596
						],
						[
							-82.72045299986343,
							27.941453000402664
						],
						[
							-82.7203627586466,
							27.941505206023646
						],
						[
							-82.72075449499974,
							27.941508200000623
						],
						[
							-82.72651205499989,
							27.941547046000284
						],
						[
							-82.72721881899975,
							27.94155191000051
						],
						[
							-82.72864662699975,
							27.94155570700038
						],
						[
							-82.72864166699979,
							27.941739672000057
						],
						[
							-82.72894949899977,
							27.94173323000059
						],
						[
							-82.72914833799979,
							27.94178237300066
						],
						[
							-82.72921829399971,
							27.941822572000167
						],
						[
							-82.72924942599988,
							27.941846474000723
						],
						[
							-82.72930110199972,
							27.941888489000025
						],
						[
							-82.72935710499982,
							27.941926355000497
						],
						[
							-82.7295435099998,
							27.94201200800074
						],
						[
							-82.7296657229997,
							27.942036803000576
						],
						[
							-82.72966824699981,
							27.941951524000178
						],
						[
							-82.7299591359998,
							27.941958577000673
						],
						[
							-82.72994765999975,
							27.942238157000713
						],
						[
							-82.72965772599983,
							27.942229379000874
						],
						[
							-82.72965722699988,
							27.942155119000414
						],
						[
							-82.72946621299988,
							27.942118312000122
						],
						[
							-82.72942176599985,
							27.942100325000144
						],
						[
							-82.72933879799982,
							27.942054006000664
						],
						[
							-82.72930981899974,
							27.942033531000124
						],
						[
							-82.72888262899991,
							27.941965312000608
						],
						[
							-82.72886616299988,
							27.94279982900065
						],
						[
							-82.72862552199977,
							27.942795257000622
						],
						[
							-82.72860036199982,
							27.943892148000163
						],
						[
							-82.72760021599986,
							27.94388643500049
						],
						[
							-82.72713610294068,
							27.94388375001883
						],
						[
							-82.72717099927414,
							27.943865000071817
						],
						[
							-82.72718099973513,
							27.94383200034904
						],
						[
							-82.7271639998508,
							27.943787000073534
						],
						[
							-82.7271059998752,
							27.943773000327457
						],
						[
							-82.72696199953262,
							27.943758999682192
						],
						[
							-82.72685304453552,
							27.94376599290526
						],
						[
							-82.72643388256344,
							27.943792894230516
						],
						[
							-82.7264192263123,
							27.94380755048184
						],
						[
							-82.72639871457537,
							27.943835451947688
						],
						[
							-82.72637352546467,
							27.943874779300085
						],
						[
							-82.72635739882206,
							27.943903729374956
						],
						[
							-82.72634494321191,
							27.94393443762512
						],
						[
							-82.72632423002698,
							27.94399613831128
						],
						[
							-82.7263196003173,
							27.944013928699643
						],
						[
							-82.7262657354243,
							27.944013146289596
						]
					],
					[
						[
							-82.72760842771055,
							27.94242336257692
						],
						[
							-82.72760335193696,
							27.942544521040094
						],
						[
							-82.72759820331845,
							27.94258672082687
						],
						[
							-82.72758615510128,
							27.942627491591413
						],
						[
							-82.72756753733653,
							27.94266571187826
						],
						[
							-82.72797970741442,
							27.942673204129523
						],
						[
							-82.72798785437281,
							27.942420578276842
						],
						[
							-82.72760842771055,
							27.94242336257692
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Bay Aristocrat Village Homeowners Assoc",
				"RegionID": "343354"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.73365649797579,
					27.940200680000263,
					-82.73233267099991,
					27.94193737800025
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.73365649797579,
							27.94020591799981
						],
						[
							-82.73363621263952,
							27.9416808309951
						],
						[
							-82.73350505399983,
							27.941681530000224
						],
						[
							-82.73350393499975,
							27.94193131500037
						],
						[
							-82.73233267099991,
							27.94193737800025
						],
						[
							-82.73235309099991,
							27.940200680000263
						],
						[
							-82.73365649797579,
							27.94020591799981
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Chateaux de Ville Homeowners Association",
				"RegionID": "343355"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.95333286099994,
					28.069734011000037,
					-81.94336367799991,
					28.077171554000078
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.94688920599992,
							28.077171554000078
						],
						[
							-81.94631860699992,
							28.076864215000057
						],
						[
							-81.94596745199993,
							28.076513065000086
						],
						[
							-81.94537276199992,
							28.075992538000037
						],
						[
							-81.94447500199993,
							28.076085096000043
						],
						[
							-81.94443713999993,
							28.07588491900009
						],
						[
							-81.94440250699995,
							28.07577452700008
						],
						[
							-81.94430339299993,
							28.075543261000064
						],
						[
							-81.94429913499994,
							28.075533156000063
						],
						[
							-81.94428215799991,
							28.07548890600009
						],
						[
							-81.94391215799993,
							28.07444290600006
						],
						[
							-81.94390840499995,
							28.074432077000044
						],
						[
							-81.9438913219999,
							28.074375761000056
						],
						[
							-81.94388602999993,
							28.07435502900006
						],
						[
							-81.94369021299991,
							28.07354788200007
						],
						[
							-81.94345263399993,
							28.07284179900006
						],
						[
							-81.94343632099992,
							28.072787762000075
						],
						[
							-81.94342295799993,
							28.072730449000062
						],
						[
							-81.94341337199995,
							28.07267238500009
						],
						[
							-81.9434077809999,
							28.072616474000085
						],
						[
							-81.9433657809999,
							28.072003473000052
						],
						[
							-81.9433656029999,
							28.07200081800005
						],
						[
							-81.94336367799991,
							28.071942000000035
						],
						[
							-81.94336482699993,
							28.071896550000076
						],
						[
							-81.94338582699993,
							28.071481550000048
						],
						[
							-81.94338660299991,
							28.071468181000057
						],
						[
							-81.94339237199995,
							28.07140961500005
						],
						[
							-81.94340195799994,
							28.071351551000078
						],
						[
							-81.94340661199993,
							28.071329587000037
						],
						[
							-81.94357291299993,
							28.07059047300004
						],
						[
							-81.94359844199994,
							28.070282667000072
						],
						[
							-81.94359743699994,
							28.07025236700008
						],
						[
							-81.94359571599995,
							28.07024817900009
						],
						[
							-81.9444499999999,
							28.06996100000004
						],
						[
							-81.94463085699994,
							28.069831842000045
						],
						[
							-81.9482049099999,
							28.06982501000005
						],
						[
							-81.9489019099999,
							28.06976601000008
						],
						[
							-81.94920999999994,
							28.069753091000052
						],
						[
							-81.94920999999994,
							28.069896764000077
						],
						[
							-81.94920999999994,
							28.070182371000044
						],
						[
							-81.94920999999994,
							28.070360875000063
						],
						[
							-81.94920999999994,
							28.070460000000082
						],
						[
							-81.94937144199992,
							28.070460000000082
						],
						[
							-81.94981770299995,
							28.070460000000082
						],
						[
							-81.95014793599995,
							28.070460000000082
						],
						[
							-81.95022951099992,
							28.070455122000055
						],
						[
							-81.9503031559999,
							28.070426844000053
						],
						[
							-81.95031999999992,
							28.07036000000005
						],
						[
							-81.95032285499991,
							28.070271507000086
						],
						[
							-81.95032601799994,
							28.070173432000047
						],
						[
							-81.9503291819999,
							28.070075357000064
						],
						[
							-81.9503329399999,
							28.069958874000065
						],
						[
							-81.95033696599995,
							28.069834051000043
						],
						[
							-81.95034190899992,
							28.069739010000035
						],
						[
							-81.95127390899995,
							28.069734011000037
						],
						[
							-81.95323690999993,
							28.06974301000008
						],
						[
							-81.95330291099992,
							28.069741011000076
						],
						[
							-81.95333286099994,
							28.069742099000052
						],
						[
							-81.95329126699994,
							28.077171432000057
						],
						[
							-81.95044464299991,
							28.077171399000065
						],
						[
							-81.94688920599992,
							28.077171554000078
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Polk",
				"City": "Lakeland",
				"Name": "Tigertown",
				"RegionID": "343438"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.95863092899992,
					28.06971900900004,
					-81.95329126699994,
					28.077171432000057
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.95329126699994,
							28.077171432000057
						],
						[
							-81.95333286099994,
							28.069742099000052
						],
						[
							-81.95335790999991,
							28.06974301000008
						],
						[
							-81.95574190999992,
							28.06971900900004
						],
						[
							-81.95727490999991,
							28.069726011000057
						],
						[
							-81.95735590899994,
							28.069738011000084
						],
						[
							-81.95741091799994,
							28.069745993000083
						],
						[
							-81.95742090899995,
							28.069795008000085
						],
						[
							-81.95744790999993,
							28.069998010000063
						],
						[
							-81.95748590999995,
							28.070241010000075
						],
						[
							-81.9575279099999,
							28.070444010000074
						],
						[
							-81.95756590999991,
							28.070643009000037
						],
						[
							-81.95760490899994,
							28.070812009000065
						],
						[
							-81.95764290999995,
							28.070967009000075
						],
						[
							-81.9576849099999,
							28.071119010000075
						],
						[
							-81.95774490999992,
							28.071322009000085
						],
						[
							-81.95781905399991,
							28.071554112000058
						],
						[
							-81.95777776599994,
							28.071554907000063
						],
						[
							-81.95794190999993,
							28.072053010000047
						],
						[
							-81.95813080399995,
							28.072542164000083
						],
						[
							-81.95820901899992,
							28.07253984900007
						],
						[
							-81.95830490999992,
							28.07279100800008
						],
						[
							-81.95863092899992,
							28.073375930000058
						],
						[
							-81.9585859099999,
							28.07337700900007
						],
						[
							-81.95854790899996,
							28.073376008000082
						],
						[
							-81.95741077699995,
							28.073364876000085
						],
						[
							-81.9574149099999,
							28.073828010000057
						],
						[
							-81.95740290999994,
							28.074673010000087
						],
						[
							-81.95739590999995,
							28.07514101000004
						],
						[
							-81.9573690439999,
							28.077018139000074
						],
						[
							-81.95329126699994,
							28.077171432000057
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Polk",
				"City": "Lakeland",
				"Name": "Swannanoa",
				"RegionID": "343439"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.67958820699994,
					27.799192194000057,
					-82.66285181399991,
					27.81322339700006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.66343660799993,
							27.808460855000078
						],
						[
							-82.6632989659999,
							27.808048486000075
						],
						[
							-82.66316357499994,
							27.80751504400007
						],
						[
							-82.66302044399993,
							27.80690104200005
						],
						[
							-82.66295999999994,
							27.80654000000004
						],
						[
							-82.66293850099993,
							27.806290514000068
						],
						[
							-82.6629183849999,
							27.80583196400005
						],
						[
							-82.66291138799994,
							27.804887384000043
						],
						[
							-82.6629099999999,
							27.80373880700006
						],
						[
							-82.66290892399991,
							27.802819767000074
						],
						[
							-82.66290004699994,
							27.802181741000084
						],
						[
							-82.66290660999995,
							27.80103327800009
						],
						[
							-82.66290996499993,
							27.800446065000074
						],
						[
							-82.66288999999995,
							27.79955262800007
						],
						[
							-82.66285181399991,
							27.799240127000076
						],
						[
							-82.66285999999991,
							27.799240000000054
						],
						[
							-82.66306482999994,
							27.799240000000054
						],
						[
							-82.66339158099994,
							27.79923748000005
						],
						[
							-82.6638214059999,
							27.79923210700008
						],
						[
							-82.66406217899993,
							27.79923000000008
						],
						[
							-82.66449207099993,
							27.79923000000008
						],
						[
							-82.66490476699995,
							27.79923000000008
						],
						[
							-82.66554100799993,
							27.79923000000008
						],
						[
							-82.66605687799996,
							27.79923000000008
						],
						[
							-82.66633187699995,
							27.799227889000065
						],
						[
							-82.66648690799991,
							27.799224964000075
						],
						[
							-82.66693385699995,
							27.799220000000048
						],
						[
							-82.66739814099992,
							27.799220000000048
						],
						[
							-82.66791398499993,
							27.799216138000077
						],
						[
							-82.66815465299993,
							27.799211989000074
						],
						[
							-82.66858464299993,
							27.799210000000073
						],
						[
							-82.6690215399999,
							27.799210000000073
						],
						[
							-82.66975523199994,
							27.79920678700006
						],
						[
							-82.6708556339999,
							27.799195204000057
						],
						[
							-82.6713508329999,
							27.799192194000057
						],
						[
							-82.67135253799995,
							27.799603669000078
						],
						[
							-82.67135801899991,
							27.800497027000063
						],
						[
							-82.67135099299992,
							27.801441513000043
						],
						[
							-82.6713499999999,
							27.802079650000053
						],
						[
							-82.6713499999999,
							27.802641211000036
						],
						[
							-82.67135267399993,
							27.80310065100008
						],
						[
							-82.67135692799991,
							27.80348348600006
						],
						[
							-82.67135999999994,
							27.803994061000083
						],
						[
							-82.67136192999993,
							27.804861805000087
						],
						[
							-82.67136451499994,
							27.80509179200004
						],
						[
							-82.67136766899995,
							27.80537253700004
						],
						[
							-82.67136800899993,
							27.805755223000062
						],
						[
							-82.67136481499995,
							27.806036257000073
						],
						[
							-82.67136249499993,
							27.806240434000074
						],
						[
							-82.67135999999994,
							27.806500000000085
						],
						[
							-82.67201465199992,
							27.80649623800008
						],
						[
							-82.67303563799993,
							27.806490370000063
						],
						[
							-82.67372479399995,
							27.806487579000077
						],
						[
							-82.67426079699993,
							27.80648345500009
						],
						[
							-82.67507777299994,
							27.80647496200004
						],
						[
							-82.67612420599995,
							27.80647556300005
						],
						[
							-82.67770677699991,
							27.80646608400008
						],
						[
							-82.67860022199994,
							27.806460000000072
						],
						[
							-82.67908538499995,
							27.806462168000053
						],
						[
							-82.67958820699994,
							27.806465564000064
						],
						[
							-82.6795870329999,
							27.806789218000063
						],
						[
							-82.6795765409999,
							27.807670552000047
						],
						[
							-82.6794999999999,
							27.808504000000084
						],
						[
							-82.6790313219999,
							27.808412540000063
						],
						[
							-82.67846999999995,
							27.80830300000008
						],
						[
							-82.67843990099993,
							27.808302042000037
						],
						[
							-82.67777899999993,
							27.80828100000008
						],
						[
							-82.67750299999994,
							27.80829700000004
						],
						[
							-82.67746143699992,
							27.808297202000062
						],
						[
							-82.67647099999994,
							27.808302000000083
						],
						[
							-82.67595499999993,
							27.808309000000065
						],
						[
							-82.67582313499992,
							27.80831272900008
						],
						[
							-82.67545999999993,
							27.808323000000087
						],
						[
							-82.67545215199993,
							27.808323124000083
						],
						[
							-82.67444599999993,
							27.80833900000005
						],
						[
							-82.67341699999992,
							27.80831900000004
						],
						[
							-82.67223787599994,
							27.80832984400007
						],
						[
							-82.6713509999999,
							27.808338000000052
						],
						[
							-82.67028999999991,
							27.808337000000055
						],
						[
							-82.66932199999991,
							27.808345000000088
						],
						[
							-82.66743699999995,
							27.808355000000063
						],
						[
							-82.66733099999993,
							27.80831900000004
						],
						[
							-82.66689699999995,
							27.80831900000004
						],
						[
							-82.66658388499991,
							27.80831816300008
						],
						[
							-82.66652299999993,
							27.808318000000043
						],
						[
							-82.66612591199993,
							27.808318000000043
						],
						[
							-82.66602499999995,
							27.808318000000043
						],
						[
							-82.66566791199995,
							27.808317109000086
						],
						[
							-82.66562399999992,
							27.808317000000045
						],
						[
							-82.66560105199994,
							27.808317000000045
						],
						[
							-82.66525599999994,
							27.808317000000045
						],
						[
							-82.6652709999999,
							27.80867500000005
						],
						[
							-82.66519835999992,
							27.80984504500009
						],
						[
							-82.66517799999991,
							27.810173000000077
						],
						[
							-82.66518999999994,
							27.81060300000007
						],
						[
							-82.6651961199999,
							27.810832737000055
						],
						[
							-82.6652029999999,
							27.81109100000009
						],
						[
							-82.66520306599995,
							27.811097329000066
						],
						[
							-82.66521199999994,
							27.81195000000008
						],
						[
							-82.66521904299992,
							27.81209438500008
						],
						[
							-82.66522455899991,
							27.812207465000085
						],
						[
							-82.66524199999992,
							27.812565000000063
						],
						[
							-82.66523701299991,
							27.812731833000043
						],
						[
							-82.66523099999995,
							27.812933000000047
						],
						[
							-82.66522850199993,
							27.81322339700006
						],
						[
							-82.66484021499991,
							27.81318342500009
						],
						[
							-82.66472238499995,
							27.812426586000072
						],
						[
							-82.66459000299994,
							27.811950013000057
						],
						[
							-82.6644033629999,
							27.81132156400008
						],
						[
							-82.66427190299993,
							27.81095639700004
						],
						[
							-82.66411035899995,
							27.810500217000087
						],
						[
							-82.66391551599992,
							27.80991004000009
						],
						[
							-82.6637029659999,
							27.809266231000038
						],
						[
							-82.66343660799993,
							27.808460855000078
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Highland Grove",
				"RegionID": "417169"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.65490999999992,
					27.799260021000066,
					-82.6467214239999,
					27.80660000000006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.6545457709999,
							27.799263755000084
						],
						[
							-82.65490798199994,
							27.799260021000066
						],
						[
							-82.65490696699993,
							27.799445002000084
						],
						[
							-82.65490330799992,
							27.799668224000072
						],
						[
							-82.65489999999994,
							27.800073973000053
						],
						[
							-82.65489999999994,
							27.800601731000086
						],
						[
							-82.65489999999994,
							27.800926506000053
						],
						[
							-82.65489999999994,
							27.80139336900004
						],
						[
							-82.65489999999994,
							27.802103813000087
						],
						[
							-82.65489999999994,
							27.80271276500008
						],
						[
							-82.65490333399993,
							27.803220070000066
						],
						[
							-82.65490729999993,
							27.803565098000036
						],
						[
							-82.65490999999992,
							27.804032161000066
						],
						[
							-82.65490999999992,
							27.80447872500008
						],
						[
							-82.65490999999992,
							27.804945589000056
						],
						[
							-82.65490999999992,
							27.805696629000067
						],
						[
							-82.65490999999992,
							27.80622438800009
						],
						[
							-82.65490999999992,
							27.806560000000047
						],
						[
							-82.6546374589999,
							27.806562962000044
						],
						[
							-82.65431233099991,
							27.806566496000073
						],
						[
							-82.65377110499992,
							27.80657235400008
						],
						[
							-82.6533020409999,
							27.80657739700007
						],
						[
							-82.65305999999993,
							27.806580000000057
						],
						[
							-82.65272472899994,
							27.806584641000086
						],
						[
							-82.65242999999992,
							27.806590000000085
						],
						[
							-82.65211129799991,
							27.806590000000085
						],
						[
							-82.6516421799999,
							27.806590000000085
						],
						[
							-82.6513799999999,
							27.806590000000085
						],
						[
							-82.65110102999995,
							27.80659472800005
						],
						[
							-82.65059568399994,
							27.80660000000006
						],
						[
							-82.64981447299994,
							27.80655151900004
						],
						[
							-82.64978999999994,
							27.806550000000072
						],
						[
							-82.64949337299993,
							27.806242130000044
						],
						[
							-82.6491986019999,
							27.805892090000047
						],
						[
							-82.64893377599992,
							27.805577609000068
						],
						[
							-82.6486999999999,
							27.805300000000045
						],
						[
							-82.6483890259999,
							27.804930977000083
						],
						[
							-82.64815965799994,
							27.80465879500008
						],
						[
							-82.64794999999992,
							27.804410000000075
						],
						[
							-82.64766152699991,
							27.80407499900008
						],
						[
							-82.64734233199994,
							27.803704322000044
						],
						[
							-82.64693102799993,
							27.80324577600004
						],
						[
							-82.64672999999993,
							27.802980000000048
						],
						[
							-82.64672999999993,
							27.802979863000076
						],
						[
							-82.64672999999993,
							27.802652997000052
						],
						[
							-82.64672999999993,
							27.80236430900004
						],
						[
							-82.64672999999993,
							27.801967362000084
						],
						[
							-82.64672999999993,
							27.801426072000083
						],
						[
							-82.64672494399991,
							27.800993368000036
						],
						[
							-82.6467214239999,
							27.800632093000047
						],
						[
							-82.64672590499993,
							27.799946488000046
						],
						[
							-82.64672886699992,
							27.79932002700008
						],
						[
							-82.64672999999993,
							27.79932000000008
						],
						[
							-82.6471868889999,
							27.79932000000008
						],
						[
							-82.64765368799993,
							27.79932000000008
						],
						[
							-82.64812033499993,
							27.799316201000067
						],
						[
							-82.64834041299991,
							27.79931240700006
						],
						[
							-82.64864220299995,
							27.799310000000048
						],
						[
							-82.6489442489999,
							27.799310000000048
						],
						[
							-82.6493013349999,
							27.79930686600005
						],
						[
							-82.64954842199995,
							27.799303657000053
						],
						[
							-82.65001514099993,
							27.799300000000073
						],
						[
							-82.65048193999992,
							27.799300000000073
						],
						[
							-82.65070160999994,
							27.799300000000073
						],
						[
							-82.65103111499991,
							27.799300000000073
						],
						[
							-82.65119586799995,
							27.799300000000073
						],
						[
							-82.65160774899994,
							27.799300000000073
						],
						[
							-82.65207454799992,
							27.799300000000073
						],
						[
							-82.6526242939999,
							27.799292893000086
						],
						[
							-82.6528712679999,
							27.799286718000076
						],
						[
							-82.65339265299991,
							27.79927684200004
						],
						[
							-82.65366719699995,
							27.79927341000007
						],
						[
							-82.65418884499991,
							27.799267435000047
						],
						[
							-82.6545457709999,
							27.799263755000084
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Magnolia Heights",
				"RegionID": "417171"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.60113815999995,
					27.811911261000034,
					-82.58669770599994,
					27.824378322000086
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.58936555299994,
							27.82088524800008
						],
						[
							-82.58930138599993,
							27.820815678000088
						],
						[
							-82.58921599999991,
							27.820818322000036
						],
						[
							-82.58905831899995,
							27.820804389000045
						],
						[
							-82.58891780399995,
							27.820779119000065
						],
						[
							-82.5887694139999,
							27.82073908600006
						],
						[
							-82.58863283399997,
							27.82067598200007
						],
						[
							-82.58850508699993,
							27.820603409000057
						],
						[
							-82.5883739269999,
							27.820511921000048
						],
						[
							-82.58835655899992,
							27.820496965000075
						],
						[
							-82.58825355899995,
							27.820405966000067
						],
						[
							-82.58816007999991,
							27.82031007300009
						],
						[
							-82.58814692599992,
							27.820291587000042
						],
						[
							-82.58810125899993,
							27.820289916000036
						],
						[
							-82.5879102589999,
							27.82027591600007
						],
						[
							-82.58784086999992,
							27.820268112000065
						],
						[
							-82.58777229599991,
							27.82025494800007
						],
						[
							-82.58770494999993,
							27.82023650300005
						],
						[
							-82.5876392369999,
							27.82021288900006
						],
						[
							-82.58753523699994,
							27.820170889000053
						],
						[
							-82.58742233899994,
							27.82011583600007
						],
						[
							-82.5873607989999,
							27.82007690100005
						],
						[
							-82.5872507979999,
							27.82000090100007
						],
						[
							-82.58718392599991,
							27.819949921000045
						],
						[
							-82.58711808399994,
							27.81988881700005
						],
						[
							-82.58704008399991,
							27.81980881700008
						],
						[
							-82.58696078299994,
							27.819715544000076
						],
						[
							-82.5869097829999,
							27.819646544000083
						],
						[
							-82.58686832599994,
							27.81958534200004
						],
						[
							-82.58683203399994,
							27.819520943000043
						],
						[
							-82.58680115499993,
							27.81945378000006
						],
						[
							-82.5867758949999,
							27.819384308000053
						],
						[
							-82.5867564269999,
							27.819312996000065
						],
						[
							-82.58672042699993,
							27.819155996000063
						],
						[
							-82.58670746099995,
							27.81908728700006
						],
						[
							-82.58669987199994,
							27.819017777000056
						],
						[
							-82.58669770599994,
							27.818947888000082
						],
						[
							-82.58670097699991,
							27.81887804200005
						],
						[
							-82.58671497699994,
							27.818715042000065
						],
						[
							-82.58672372099994,
							27.818645317000062
						],
						[
							-82.58673788199991,
							27.818576488000076
						],
						[
							-82.58675737399994,
							27.818508974000054
						],
						[
							-82.58678207899993,
							27.81844318800006
						],
						[
							-82.58681184399991,
							27.81837953200005
						],
						[
							-82.58689184399992,
							27.818224532000045
						],
						[
							-82.58694959799993,
							27.818127978000064
						],
						[
							-82.58713337799992,
							27.817860298000085
						],
						[
							-82.58734947999994,
							27.817544957000052
						],
						[
							-82.58771429399991,
							27.81692967300006
						],
						[
							-82.58763779599991,
							27.81681891900007
						],
						[
							-82.58754742699995,
							27.816655177000086
						],
						[
							-82.5874858279999,
							27.81651712000007
						],
						[
							-82.5874178279999,
							27.816322120000052
						],
						[
							-82.58738134099991,
							27.81618216600009
						],
						[
							-82.58737217899994,
							27.816115858000046
						],
						[
							-82.5873481779999,
							27.815876857000035
						],
						[
							-82.58734373999994,
							27.815797574000044
						],
						[
							-82.5873463129999,
							27.815718209000067
						],
						[
							-82.58735587599995,
							27.81563938000005
						],
						[
							-82.58737235599995,
							27.815561702000082
						],
						[
							-82.58743135599991,
							27.81533370200009
						],
						[
							-82.58745691399992,
							27.815251414000045
						],
						[
							-82.5875124879999,
							27.815128361000063
						],
						[
							-82.58757848699992,
							27.815007361000085
						],
						[
							-82.58758916399995,
							27.81498833900008
						],
						[
							-82.58768128199995,
							27.814857322000083
						],
						[
							-82.58780448499994,
							27.81471271600009
						],
						[
							-82.58791092699995,
							27.81460707900004
						],
						[
							-82.5879442939999,
							27.814580405000072
						],
						[
							-82.58814529499995,
							27.81442740500006
						],
						[
							-82.58824033899992,
							27.81436416400004
						],
						[
							-82.5883876609999,
							27.81429604100009
						],
						[
							-82.58863290799992,
							27.814210167000056
						],
						[
							-82.58877383499993,
							27.81417334100007
						],
						[
							-82.58886385499994,
							27.814162114000055
						],
						[
							-82.58937642899991,
							27.814124311000057
						],
						[
							-82.58979537199991,
							27.81339571400008
						],
						[
							-82.58981340899993,
							27.813365712000063
						],
						[
							-82.59003711299994,
							27.813009501000067
						],
						[
							-82.59007521299992,
							27.81288528500005
						],
						[
							-82.5901233319999,
							27.81276173400005
						],
						[
							-82.59019633199995,
							27.812608734000037
						],
						[
							-82.59022823899994,
							27.812547945000063
						],
						[
							-82.5902646909999,
							27.812489767000045
						],
						[
							-82.59030547499992,
							27.812434539000037
						],
						[
							-82.5903503529999,
							27.812382583000044
						],
						[
							-82.59039906399994,
							27.812334202000045
						],
						[
							-82.59045132299991,
							27.81228967800007
						],
						[
							-82.59056932399996,
							27.812196678000078
						],
						[
							-82.59067633899991,
							27.812124165000057
						],
						[
							-82.5908198269999,
							27.81205740200005
						],
						[
							-82.59103223999995,
							27.811980891000076
						],
						[
							-82.59118083399994,
							27.81194134100008
						],
						[
							-82.59123227499992,
							27.81193379700005
						],
						[
							-82.59137727499991,
							27.811916796000048
						],
						[
							-82.5914496119999,
							27.811911261000034
						],
						[
							-82.5915221599999,
							27.811911575000067
						],
						[
							-82.59159444699992,
							27.811917735000065
						],
						[
							-82.5916660019999,
							27.811929702000043
						],
						[
							-82.59173635899992,
							27.811947398000086
						],
						[
							-82.59189235899993,
							27.811993398000084
						],
						[
							-82.59200836399992,
							27.812036482000053
						],
						[
							-82.59211236399995,
							27.812083482000048
						],
						[
							-82.59216662999995,
							27.812107721000075
						],
						[
							-82.5922185089999,
							27.81213672100006
						],
						[
							-82.5922675839999,
							27.812170248000086
						],
						[
							-82.59231345899991,
							27.812208034000037
						],
						[
							-82.59235576799995,
							27.81224977500006
						],
						[
							-82.59242083499993,
							27.812232341000083
						],
						[
							-82.5924676059999,
							27.812225356000056
						],
						[
							-82.59267160599991,
							27.812200356000062
						],
						[
							-82.59278099999995,
							27.812193678000085
						],
						[
							-82.59292381099993,
							27.812205090000077
						],
						[
							-82.59307348899995,
							27.81222921500006
						],
						[
							-82.59323158599994,
							27.812270914000067
						],
						[
							-82.5933752119999,
							27.812338064000073
						],
						[
							-82.5935037619999,
							27.812412963000043
						],
						[
							-82.59362907299993,
							27.81250107900007
						],
						[
							-82.59364886499992,
							27.81252039700007
						],
						[
							-82.59379483399994,
							27.81248134100008
						],
						[
							-82.59395964599992,
							27.81246776100005
						],
						[
							-82.59412429199995,
							27.812470844000075
						],
						[
							-82.59426316499992,
							27.812484341000072
						],
						[
							-82.59431825099995,
							27.81249584200009
						],
						[
							-82.59444168999994,
							27.81252568700006
						],
						[
							-82.59448112799993,
							27.812535532000084
						],
						[
							-82.59454452599994,
							27.812553879000063
						],
						[
							-82.59460640799995,
							27.812576826000054
						],
						[
							-82.59466643999991,
							27.81260424900006
						],
						[
							-82.59472429999994,
							27.812636001000044
						],
						[
							-82.59477967499993,
							27.812671911000052
						],
						[
							-82.59488367499995,
							27.81274491100004
						],
						[
							-82.59493237599992,
							27.812782325000057
						],
						[
							-82.59498796199995,
							27.812767206000046
						],
						[
							-82.5950678339999,
							27.81274934100009
						],
						[
							-82.59517485899994,
							27.81273702100009
						],
						[
							-82.59537585899994,
							27.81272602200005
						],
						[
							-82.59544510199993,
							27.81272490300006
						],
						[
							-82.59551422499993,
							27.81272911500008
						],
						[
							-82.5955828189999,
							27.812738634000084
						],
						[
							-82.59565047799992,
							27.812753403000045
						],
						[
							-82.59578947799992,
							27.812789403000068
						],
						[
							-82.59587158699992,
							27.812814914000057
						],
						[
							-82.59594721399992,
							27.812846411000066
						],
						[
							-82.59608521399991,
							27.812911411000073
						],
						[
							-82.59615166099991,
							27.812946165000085
						],
						[
							-82.59621204699995,
							27.81298844700007
						],
						[
							-82.5963746679999,
							27.81284415400006
						],
						[
							-82.5969843879999,
							27.81350545400005
						],
						[
							-82.59708999999992,
							27.81362000000007
						],
						[
							-82.5972480879999,
							27.813771061000068
						],
						[
							-82.59740345299991,
							27.81391952200005
						],
						[
							-82.59753999999994,
							27.814050000000066
						],
						[
							-82.59766278199993,
							27.814180857000053
						],
						[
							-82.59783880599991,
							27.81434200600006
						],
						[
							-82.59797915999991,
							27.81447049800005
						],
						[
							-82.5980821949999,
							27.814564826000037
						],
						[
							-82.5983166659999,
							27.814779483000052
						],
						[
							-82.59843999999993,
							27.81490000000008
						],
						[
							-82.59842095999994,
							27.81500281600006
						],
						[
							-82.59839210699995,
							27.81515862100008
						],
						[
							-82.59834794599993,
							27.815268126000035
						],
						[
							-82.5982845389999,
							27.81540576900005
						],
						[
							-82.59823217199994,
							27.81551511200007
						],
						[
							-82.59884803999995,
							27.816001705000076
						],
						[
							-82.59945681899991,
							27.81628819000008
						],
						[
							-82.59981492499992,
							27.816574674000037
						],
						[
							-82.60029836699994,
							27.81619866300008
						],
						[
							-82.60043912999993,
							27.81637891200006
						],
						[
							-82.60049835399991,
							27.816501590000087
						],
						[
							-82.60058267099993,
							27.816682944000036
						],
						[
							-82.60062328099991,
							27.816788530000057
						],
						[
							-82.60066999999992,
							27.816910000000064
						],
						[
							-82.60077797399993,
							27.81715945700006
						],
						[
							-82.60085737199995,
							27.817342894000035
						],
						[
							-82.60091806499992,
							27.817483116000062
						],
						[
							-82.60095999999993,
							27.817580000000078
						],
						[
							-82.60103675699992,
							27.817779569000038
						],
						[
							-82.6011000279999,
							27.81804013900006
						],
						[
							-82.60113815999995,
							27.81825803800007
						],
						[
							-82.60112627199993,
							27.818455502000063
						],
						[
							-82.60107680899995,
							27.818662766000045
						],
						[
							-82.60098757399993,
							27.818889567000042
						],
						[
							-82.60089533299993,
							27.819084297000074
						],
						[
							-82.60084999999992,
							27.819180000000074
						],
						[
							-82.60066858099992,
							27.81928827900009
						],
						[
							-82.60051190099995,
							27.819401872000075
						],
						[
							-82.6003264659999,
							27.819536312000082
						],
						[
							-82.60014432299994,
							27.819696510000085
						],
						[
							-82.59995030499994,
							27.81987741800009
						],
						[
							-82.59979265699991,
							27.820024414000045
						],
						[
							-82.59966244899994,
							27.820145824000065
						],
						[
							-82.59953999999993,
							27.820260000000076
						],
						[
							-82.59933437599994,
							27.82044327400007
						],
						[
							-82.5990192399999,
							27.820718946000056
						],
						[
							-82.59871213999992,
							27.820966404000046
						],
						[
							-82.59847380699995,
							27.821160602000077
						],
						[
							-82.59829405999994,
							27.821307062000074
						],
						[
							-82.59807439699995,
							27.821467202000065
						],
						[
							-82.59785876199993,
							27.82159495800005
						],
						[
							-82.59757552799994,
							27.821746744000052
						],
						[
							-82.59733048299995,
							27.82186576500004
						],
						[
							-82.59710625899993,
							27.821972950000088
						],
						[
							-82.59698999999995,
							27.822130000000072
						],
						[
							-82.59702541999991,
							27.822249541000076
						],
						[
							-82.59706046199994,
							27.82236781100005
						],
						[
							-82.59707874399993,
							27.822482601000047
						],
						[
							-82.59706070699991,
							27.82271434000006
						],
						[
							-82.5970430779999,
							27.82285537900009
						],
						[
							-82.59704999999991,
							27.822940000000074
						],
						[
							-82.5968612389999,
							27.82318323900006
						],
						[
							-82.59682632699992,
							27.824345270000038
						],
						[
							-82.59680727299992,
							27.824350929000047
						],
						[
							-82.59673468599993,
							27.824366113000053
						],
						[
							-82.59666109499994,
							27.82437526500007
						],
						[
							-82.59658699999994,
							27.824378322000086
						],
						[
							-82.59646599999991,
							27.824378322000086
						],
						[
							-82.5963658359999,
							27.824372727000082
						],
						[
							-82.5962545989999,
							27.824360260000052
						],
						[
							-82.59393936799995,
							27.82412574300008
						],
						[
							-82.59382402099993,
							27.824106416000063
						],
						[
							-82.59362002199993,
							27.82405841600007
						],
						[
							-82.59351841399992,
							27.824028087000045
						],
						[
							-82.59337425899992,
							27.82396062700008
						],
						[
							-82.59323017799994,
							27.823876418000054
						],
						[
							-82.5931059269999,
							27.823788921000073
						],
						[
							-82.59304040699993,
							27.823728146000064
						],
						[
							-82.5929184069999,
							27.82360314600004
						],
						[
							-82.5928730789999,
							27.823553073000085
						],
						[
							-82.59280372799992,
							27.82345035600008
						],
						[
							-82.5927355309999,
							27.823346830000048
						],
						[
							-82.59269997099994,
							27.82328614800008
						],
						[
							-82.59266950899992,
							27.82322275300004
						],
						[
							-82.59264435099993,
							27.82315707300006
						],
						[
							-82.59262466599995,
							27.823089550000077
						],
						[
							-82.59261058699991,
							27.82302064000004
						],
						[
							-82.59259654399995,
							27.822905793000075
						],
						[
							-82.59259317799992,
							27.822871366000072
						],
						[
							-82.59257967799994,
							27.82276100000007
						],
						[
							-82.59258355999992,
							27.82267752300004
						],
						[
							-82.59259456099994,
							27.822559523000052
						],
						[
							-82.59260434099993,
							27.822486834000074
						],
						[
							-82.5926206449999,
							27.82242598600004
						],
						[
							-82.59257065499992,
							27.822422231000075
						],
						[
							-82.59243165499993,
							27.82240123100007
						],
						[
							-82.59235912199995,
							27.822387203000062
						],
						[
							-82.59228798499994,
							27.822367270000086
						],
						[
							-82.5922187239999,
							27.822341565000045
						],
						[
							-82.59215180599995,
							27.822310263000077
						],
						[
							-82.59204286199991,
							27.82225372100004
						],
						[
							-82.59198691699994,
							27.822224180000035
						],
						[
							-82.5918857069999,
							27.82216182700006
						],
						[
							-82.59178870699992,
							27.822092826000073
						],
						[
							-82.59173535399992,
							27.822053192000055
						],
						[
							-82.59168565599992,
							27.822009063000053
						],
						[
							-82.59163998799994,
							27.821960774000047
						],
						[
							-82.59159869899992,
							27.82190869100009
						],
						[
							-82.59151982799995,
							27.821908187000076
						],
						[
							-82.59144130399994,
							27.82190077400009
						],
						[
							-82.59136373099994,
							27.82188651100006
						],
						[
							-82.5912287299999,
							27.82185551100008
						],
						[
							-82.59112241299994,
							27.82182408700004
						],
						[
							-82.59102780699993,
							27.821783377000088
						],
						[
							-82.5909417549999,
							27.82174034400009
						],
						[
							-82.59086070099994,
							27.821700312000075
						],
						[
							-82.59080933899992,
							27.82167283600006
						],
						[
							-82.5907081979999,
							27.821604913000048
						],
						[
							-82.59059719899994,
							27.82151891300009
						],
						[
							-82.5905512459999,
							27.821485545000087
						],
						[
							-82.59050943199992,
							27.821447117000048
						],
						[
							-82.59047231099993,
							27.821404139000038
						],
						[
							-82.59044037399991,
							27.821357179000074
						],
						[
							-82.59038348799993,
							27.82135381100005
						],
						[
							-82.5902856589999,
							27.821346335000047
						],
						[
							-82.59023034799992,
							27.82134540800007
						],
						[
							-82.59013283399993,
							27.82133365900006
						],
						[
							-82.58998856199992,
							27.82129565400004
						],
						[
							-82.58990598799994,
							27.82126637000005
						],
						[
							-82.58976033899995,
							27.821198835000075
						],
						[
							-82.58969642799991,
							27.82115825700004
						],
						[
							-82.5895814289999,
							27.821078257000067
						],
						[
							-82.58946855299992,
							27.820985247000067
						],
						[
							-82.58936555299994,
							27.82088524800008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Venetian Isles",
				"RegionID": "417178"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.61410999999993,
					27.829840000000047,
					-82.61247655099993,
					27.835939299000074
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.61410564999994,
							27.835939299000074
						],
						[
							-82.61272642599994,
							27.83590260300008
						],
						[
							-82.61272599999995,
							27.835915000000057
						],
						[
							-82.61251212799993,
							27.835923184000084
						],
						[
							-82.61247655099993,
							27.830391079000037
						],
						[
							-82.61253623099992,
							27.83007461400007
						],
						[
							-82.61253623099992,
							27.829840000000047
						],
						[
							-82.6125799479999,
							27.829840000000047
						],
						[
							-82.61293408799992,
							27.829840000000047
						],
						[
							-82.6133307259999,
							27.829840000000047
						],
						[
							-82.61357154099994,
							27.829840000000047
						],
						[
							-82.6137983619999,
							27.829846199000087
						],
						[
							-82.6139540129999,
							27.82985000000008
						],
						[
							-82.61406999999991,
							27.829840000000047
						],
						[
							-82.61407182699992,
							27.830178640000042
						],
						[
							-82.61407411599993,
							27.830540378000084
						],
						[
							-82.61407667599991,
							27.830944809000073
						],
						[
							-82.61407896499992,
							27.831306547000054
						],
						[
							-82.61407999999994,
							27.83179591000004
						],
						[
							-82.61408516299991,
							27.832562035000084
						],
						[
							-82.61409296099993,
							27.83334929600005
						],
						[
							-82.61409750999991,
							27.834008931000085
						],
						[
							-82.61409999999995,
							27.834370000000035
						],
						[
							-82.61410335199992,
							27.834467218000043
						],
						[
							-82.61410692099992,
							27.834570720000045
						],
						[
							-82.61410999999993,
							27.834660000000042
						],
						[
							-82.61410999999993,
							27.834840218000068
						],
						[
							-82.61410999999993,
							27.83523133600005
						],
						[
							-82.61410999999993,
							27.83545652500004
						],
						[
							-82.61410999999993,
							27.835600000000056
						],
						[
							-82.61410564999994,
							27.835939299000074
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Mariners Pass",
				"RegionID": "417180"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.45029532199993,
					30.34032200000007,
					-81.39597743199994,
					30.381419322000056
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.39597743199994,
							30.381419322000056
						],
						[
							-81.39604352499993,
							30.38115994100008
						],
						[
							-81.39606991399995,
							30.38107441400007
						],
						[
							-81.39612561399991,
							30.38095496500006
						],
						[
							-81.3963521849999,
							30.374900640000078
						],
						[
							-81.39650308599994,
							30.369892913000058
						],
						[
							-81.39650460299993,
							30.369861190000048
						],
						[
							-81.39697560299993,
							30.362674189000074
						],
						[
							-81.39698388599993,
							30.36259788300003
						],
						[
							-81.3971775409999,
							30.36132371000008
						],
						[
							-81.39725989899995,
							30.360813957000058
						],
						[
							-81.39770599999991,
							30.360813000000068
						],
						[
							-81.39817415599993,
							30.360793687000065
						],
						[
							-81.39962099999991,
							30.360734000000033
						],
						[
							-81.40130699999992,
							30.360793000000058
						],
						[
							-81.40758099999994,
							30.360813000000068
						],
						[
							-81.4064679999999,
							30.35500700000006
						],
						[
							-81.40668788099993,
							30.355003503000034
						],
						[
							-81.40841699999994,
							30.35497600000008
						],
						[
							-81.41320699999994,
							30.354940000000056
						],
						[
							-81.41366099999993,
							30.35493500000007
						],
						[
							-81.41366351999994,
							30.354892103000058
						],
						[
							-81.4137024119999,
							30.354230038000082
						],
						[
							-81.41370399999994,
							30.354203000000044
						],
						[
							-81.4137179999999,
							30.353774000000044
						],
						[
							-81.41371499999993,
							30.353640000000045
						],
						[
							-81.41371599999991,
							30.35312700000009
						],
						[
							-81.41370680599995,
							30.35290588700008
						],
						[
							-81.4136959999999,
							30.35264600000005
						],
						[
							-81.41368899999992,
							30.352289000000045
						],
						[
							-81.41361899999993,
							30.350417000000053
						],
						[
							-81.41361729499994,
							30.350377947000084
						],
						[
							-81.4135819569999,
							30.349568382000086
						],
						[
							-81.41351999999995,
							30.348149000000035
						],
						[
							-81.4134489999999,
							30.346682000000044
						],
						[
							-81.41339699999992,
							30.345123000000054
						],
						[
							-81.41338599999996,
							30.34478200000007
						],
						[
							-81.41337799999991,
							30.344340000000045
						],
						[
							-81.41240399999992,
							30.344440000000077
						],
						[
							-81.41240499999994,
							30.344538000000057
						],
						[
							-81.41230699999996,
							30.349340000000037
						],
						[
							-81.41070699999995,
							30.349340000000037
						],
						[
							-81.41053184099991,
							30.349565204000044
						],
						[
							-81.41000699999995,
							30.350240000000042
						],
						[
							-81.4094812109999,
							30.349563986000078
						],
						[
							-81.4093069999999,
							30.349340000000037
						],
						[
							-81.4078359909999,
							30.34830836200007
						],
						[
							-81.40664199999992,
							30.347471000000038
						],
						[
							-81.4063329999999,
							30.346746000000053
						],
						[
							-81.40609399999994,
							30.345670000000045
						],
						[
							-81.40592499999991,
							30.34504600000008
						],
						[
							-81.40561699999995,
							30.344087000000062
						],
						[
							-81.40549299999992,
							30.343377000000093
						],
						[
							-81.40543809499991,
							30.342874563000066
						],
						[
							-81.40533399999993,
							30.34192200000007
						],
						[
							-81.40551299999993,
							30.340645000000052
						],
						[
							-81.40562499999993,
							30.340643000000057
						],
						[
							-81.4112179999999,
							30.34051900000009
						],
						[
							-81.41294096199994,
							30.34051561800004
						],
						[
							-81.41325599999993,
							30.340515000000043
						],
						[
							-81.41336081799994,
							30.34051481100005
						],
						[
							-81.41435464699993,
							30.340513017000035
						],
						[
							-81.41436399999992,
							30.340513000000044
						],
						[
							-81.41618499999993,
							30.340481000000064
						],
						[
							-81.41673842599994,
							30.340464167000054
						],
						[
							-81.41753299999993,
							30.340440000000058
						],
						[
							-81.41796189399992,
							30.340439178000057
						],
						[
							-81.41857599999992,
							30.34043800000006
						],
						[
							-81.4191889999999,
							30.340427000000094
						],
						[
							-81.4207659999999,
							30.340397000000053
						],
						[
							-81.4217569999999,
							30.340370000000064
						],
						[
							-81.42233199999993,
							30.340375000000055
						],
						[
							-81.42297999999994,
							30.340374000000057
						],
						[
							-81.42374599999994,
							30.340382000000094
						],
						[
							-81.4258999999999,
							30.340390000000067
						],
						[
							-81.42608399999995,
							30.340376000000052
						],
						[
							-81.42623299999991,
							30.340355000000045
						],
						[
							-81.42635499999994,
							30.340330000000055
						],
						[
							-81.42638199999993,
							30.34032200000007
						],
						[
							-81.42941799999996,
							30.34036400000008
						],
						[
							-81.43104499999993,
							30.340551000000062
						],
						[
							-81.43510399999991,
							30.340425000000042
						],
						[
							-81.43608799999993,
							30.34039400000006
						],
						[
							-81.43705972099991,
							30.34036320900009
						],
						[
							-81.43716099999995,
							30.34036000000009
						],
						[
							-81.43749699999995,
							30.340350000000058
						],
						[
							-81.43796069299992,
							30.340349373000034
						],
						[
							-81.43808960199993,
							30.342003110000064
						],
						[
							-81.4380921419999,
							30.34205502700007
						],
						[
							-81.43812536799993,
							30.343717251000044
						],
						[
							-81.43875588199995,
							30.345580769000037
						],
						[
							-81.43878965899995,
							30.345712834000043
						],
						[
							-81.4387980599999,
							30.345771859000084
						],
						[
							-81.4395390599999,
							30.352591860000075
						],
						[
							-81.4395435639999,
							30.35272591100005
						],
						[
							-81.43945640599992,
							30.354847702000082
						],
						[
							-81.43978641799993,
							30.35602696400008
						],
						[
							-81.44003678699994,
							30.35693229100008
						],
						[
							-81.44004857999994,
							30.356984495000063
						],
						[
							-81.44011358599994,
							30.35700191300009
						],
						[
							-81.44025566099992,
							30.35706816400005
						],
						[
							-81.4403840729999,
							30.357158079000044
						],
						[
							-81.44049491999994,
							30.357268927000064
						],
						[
							-81.44058716399991,
							30.357401422000063
						],
						[
							-81.4406262469999,
							30.357470728000067
						],
						[
							-81.4415748429999,
							30.358673164000038
						],
						[
							-81.44290764999994,
							30.36042436700006
						],
						[
							-81.44294902399993,
							30.360483516000045
						],
						[
							-81.44359802499991,
							30.361495516000044
						],
						[
							-81.44363789599993,
							30.361564182000055
						],
						[
							-81.44367155499992,
							30.361636096000044
						],
						[
							-81.44369873999996,
							30.36171069900007
						],
						[
							-81.44397573999993,
							30.362589699000065
						],
						[
							-81.44400365999991,
							30.362703834000058
						],
						[
							-81.44401422399994,
							30.362785416000065
						],
						[
							-81.44412276199995,
							30.364089636000074
						],
						[
							-81.44422644399992,
							30.364295747000085
						],
						[
							-81.44507523099992,
							30.36513740900006
						],
						[
							-81.44511878599991,
							30.365184740000075
						],
						[
							-81.44528443899992,
							30.365453473000063
						],
						[
							-81.44635544899995,
							30.367706884000086
						],
						[
							-81.44811845399994,
							30.36938034100007
						],
						[
							-81.44861605499995,
							30.36985266700009
						],
						[
							-81.44938413499995,
							30.37058173400004
						],
						[
							-81.44943530499995,
							30.37063444000006
						],
						[
							-81.44948200199991,
							30.370691147000056
						],
						[
							-81.44952391399994,
							30.37075147600007
						],
						[
							-81.4495607639999,
							30.370815025000073
						],
						[
							-81.4495923039999,
							30.370881369000077
						],
						[
							-81.45019330399992,
							30.372291369000042
						],
						[
							-81.45021108599991,
							30.372336414000074
						],
						[
							-81.45025287199991,
							30.372495058000087
						],
						[
							-81.4502840859999,
							30.37269028100007
						],
						[
							-81.45029532199993,
							30.372832000000074
						],
						[
							-81.45028165999992,
							30.372988165000034
						],
						[
							-81.45024108599995,
							30.37313958600004
						],
						[
							-81.45017483599992,
							30.373281661000078
						],
						[
							-81.45008492099994,
							30.373410073000056
						],
						[
							-81.44997407299991,
							30.37352092000009
						],
						[
							-81.44984566099993,
							30.37361083500008
						],
						[
							-81.44970358599994,
							30.373677086000047
						],
						[
							-81.44955216599993,
							30.373717659000082
						],
						[
							-81.4494353099999,
							30.37373046200008
						],
						[
							-81.4492753099999,
							30.373737463000055
						],
						[
							-81.44913382999994,
							30.373732500000077
						],
						[
							-81.44835959499994,
							30.373643968000064
						],
						[
							-81.44710435899992,
							30.373927466000058
						],
						[
							-81.4469960269999,
							30.37395397900008
						],
						[
							-81.44695216599992,
							30.37396466000007
						],
						[
							-81.44679599999995,
							30.373978322000085
						],
						[
							-81.44663983399994,
							30.37396466000007
						],
						[
							-81.44648841399993,
							30.373924087000034
						],
						[
							-81.44634633899994,
							30.373857836000074
						],
						[
							-81.44625314699994,
							30.37379406000008
						],
						[
							-81.44622849799993,
							30.37377623000009
						],
						[
							-81.44619008599994,
							30.373919586000056
						],
						[
							-81.44612383499992,
							30.374061661000045
						],
						[
							-81.44603391999993,
							30.374190073000083
						],
						[
							-81.4459230729999,
							30.374300920000053
						],
						[
							-81.44579466099992,
							30.374390835000046
						],
						[
							-81.44565258599994,
							30.374457086000064
						],
						[
							-81.44550116499994,
							30.374497659000042
						],
						[
							-81.44534499999992,
							30.37451132200005
						],
						[
							-81.44522246499992,
							30.37451132200005
						],
						[
							-81.44351567599995,
							30.375532301000078
						],
						[
							-81.44337209299994,
							30.375600433000045
						],
						[
							-81.44242837899992,
							30.37594963300006
						],
						[
							-81.4416593709999,
							30.376567838000085
						],
						[
							-81.43950642699991,
							30.378744406000063
						],
						[
							-81.43954030399993,
							30.378789651000094
						],
						[
							-81.43891799999994,
							30.379459000000054
						],
						[
							-81.43877890499994,
							30.379590008000037
						],
						[
							-81.4382868639999,
							30.379996180000035
						],
						[
							-81.43814890599992,
							30.37967100900005
						],
						[
							-81.43744290599994,
							30.378300008000057
						],
						[
							-81.43637590499992,
							30.37623600800004
						],
						[
							-81.43550890499995,
							30.374596008000086
						],
						[
							-81.4353639059999,
							30.374371009000072
						],
						[
							-81.43522590599991,
							30.37414700800008
						],
						[
							-81.43508090599994,
							30.373945009000067
						],
						[
							-81.43474590599993,
							30.37351600900007
						],
						[
							-81.4345319059999,
							30.37327600900005
						],
						[
							-81.43411290499995,
							30.37285600900009
						],
						[
							-81.43387590599991,
							30.372641009000063
						],
						[
							-81.43280790599994,
							30.37177800900008
						],
						[
							-81.43274899999994,
							30.37173900000005
						],
						[
							-81.43275563999993,
							30.371737059000058
						],
						[
							-81.43236499999995,
							30.371431000000086
						],
						[
							-81.42832296199992,
							30.36820784400004
						],
						[
							-81.4224039049999,
							30.368235008000056
						],
						[
							-81.4195258609999,
							30.368044838000063
						],
						[
							-81.41895694399994,
							30.368422178000063
						],
						[
							-81.41824983399994,
							30.368351833000077
						],
						[
							-81.41796791899993,
							30.36868919400007
						],
						[
							-81.41765097199993,
							30.368370894000066
						],
						[
							-81.41702890599993,
							30.368178009000076
						],
						[
							-81.4168859049999,
							30.36814300900005
						],
						[
							-81.41668490599994,
							30.368111955000078
						],
						[
							-81.41623490399991,
							30.36816601000004
						],
						[
							-81.41427176399992,
							30.368904885000063
						],
						[
							-81.41424782299993,
							30.369015013000084
						],
						[
							-81.41426290599992,
							30.369065009000053
						],
						[
							-81.41429003799993,
							30.369176008000068
						],
						[
							-81.41426290599992,
							30.36928900600009
						],
						[
							-81.41387196799991,
							30.370186183000044
						],
						[
							-81.4131219059999,
							30.369797008000035
						],
						[
							-81.41303283699995,
							30.369750837000087
						],
						[
							-81.41300190499993,
							30.369857008000057
						],
						[
							-81.41285300099993,
							30.370295169000087
						],
						[
							-81.41248988099994,
							30.370234835000076
						],
						[
							-81.41206290499991,
							30.37044000800006
						],
						[
							-81.41069476199993,
							30.371008885000037
						],
						[
							-81.41005002199995,
							30.37369815700003
						],
						[
							-81.40890388299994,
							30.373679878000075
						],
						[
							-81.40884192899995,
							30.37370713900009
						],
						[
							-81.40816190499993,
							30.373700008000075
						],
						[
							-81.40656990699995,
							30.37364700900008
						],
						[
							-81.40585890499995,
							30.373660008000055
						],
						[
							-81.40510078099993,
							30.373619872000067
						],
						[
							-81.40490203099995,
							30.376701145000084
						],
						[
							-81.40153277999993,
							30.376489872000036
						],
						[
							-81.4015269059999,
							30.376601008000083
						],
						[
							-81.40143703399991,
							30.377718147000056
						],
						[
							-81.40013390599995,
							30.377721008000037
						],
						[
							-81.3995997749999,
							30.377686875000055
						],
						[
							-81.39960190599993,
							30.37945800800009
						],
						[
							-81.39959390599995,
							30.380757008000046
						],
						[
							-81.3995740389999,
							30.381281141000045
						],
						[
							-81.3986919059999,
							30.38131600900005
						],
						[
							-81.39700899999991,
							30.381383000000085
						],
						[
							-81.39691499999992,
							30.381382000000087
						],
						[
							-81.39597743199994,
							30.381419322000056
						]
					],
					[
						[
							-81.44352303499994,
							30.368170339000073
						],
						[
							-81.44305422899993,
							30.368286131000048
						],
						[
							-81.44265621099993,
							30.36905833700007
						],
						[
							-81.4426175399999,
							30.36917625300003
						],
						[
							-81.44260808599995,
							30.369203586000086
						],
						[
							-81.44254183599992,
							30.369345661000068
						],
						[
							-81.44245192099993,
							30.369474073000045
						],
						[
							-81.44234107299991,
							30.369584921000065
						],
						[
							-81.44228609299995,
							30.36962754200005
						],
						[
							-81.44215515999991,
							30.369721166000094
						],
						[
							-81.44214055499992,
							30.369735357000085
						],
						[
							-81.4422801369999,
							30.369729475000046
						],
						[
							-81.44231799999994,
							30.369728678000055
						],
						[
							-81.4424741659999,
							30.369742340000073
						],
						[
							-81.44262558699995,
							30.36978291400004
						],
						[
							-81.44276766099995,
							30.369849164000076
						],
						[
							-81.44289607299993,
							30.369939079000062
						],
						[
							-81.44300692099995,
							30.370049927000082
						],
						[
							-81.44309683599994,
							30.370178339000063
						],
						[
							-81.4431630869999,
							30.370320414000048
						],
						[
							-81.44320365999994,
							30.37047183400006
						],
						[
							-81.44321732199995,
							30.370628000000067
						],
						[
							-81.44321732199995,
							30.370868000000087
						],
						[
							-81.44321389399994,
							30.370946458000045
						],
						[
							-81.44320363299994,
							30.371024318000078
						],
						[
							-81.4431866189999,
							30.371100986000048
						],
						[
							-81.44316298099994,
							30.371175877000045
						],
						[
							-81.44313289899992,
							30.37124842100007
						],
						[
							-81.44309660399996,
							30.371318063000047
						],
						[
							-81.44278168799991,
							30.37186221400009
						],
						[
							-81.44284154399992,
							30.371984397000062
						],
						[
							-81.44299059399992,
							30.37213022800006
						],
						[
							-81.44491268799993,
							30.372443886000042
						],
						[
							-81.44490399999995,
							30.372430771000037
						],
						[
							-81.44422650799993,
							30.371414538000067
						],
						[
							-81.44370308599991,
							30.370811937000042
						],
						[
							-81.44360816499994,
							30.370677661000062
						],
						[
							-81.44354191399992,
							30.370535586000074
						],
						[
							-81.44350134099994,
							30.37038416600007
						],
						[
							-81.44348767799994,
							30.370228000000054
						],
						[
							-81.44350134099994,
							30.370071835000093
						],
						[
							-81.44354191399992,
							30.36992041400004
						],
						[
							-81.44356950899993,
							30.369853182000046
						],
						[
							-81.44400535499994,
							30.368902589000072
						],
						[
							-81.44405229699993,
							30.368739309000034
						],
						[
							-81.44406882499993,
							30.368497785000045
						],
						[
							-81.4439813219999,
							30.368447917000083
						],
						[
							-81.4439620089999,
							30.368439369000047
						],
						[
							-81.44390151899995,
							30.36840996700005
						],
						[
							-81.4438434349999,
							30.368376057000035
						],
						[
							-81.4437880939999,
							30.368337835000094
						],
						[
							-81.44373581399992,
							30.36829552200004
						],
						[
							-81.4436868979999,
							30.368249362000082
						],
						[
							-81.44364162699992,
							30.368199621000088
						],
						[
							-81.44352303499994,
							30.368170339000073
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "North Beach",
				"RegionID": "274687"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.06836163999992,
					26.752869513000068,
					-80.05520755299995,
					26.76363400000008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.06528799999995,
							26.76353900000004
						],
						[
							-80.05991499999993,
							26.763442000000055
						],
						[
							-80.05986089999993,
							26.76345119900009
						],
						[
							-80.05972601099995,
							26.76347413500008
						],
						[
							-80.05932099999991,
							26.763543000000084
						],
						[
							-80.05520755299995,
							26.763499102000083
						],
						[
							-80.05520819199995,
							26.76344169400005
						],
						[
							-80.05520999999993,
							26.763298726000073
						],
						[
							-80.05521203599994,
							26.763203350000083
						],
						[
							-80.0552199999999,
							26.763060000000053
						],
						[
							-80.0552256439999,
							26.76290196800005
						],
						[
							-80.0552321529999,
							26.762680919000047
						],
						[
							-80.0552337659999,
							26.76253857900008
						],
						[
							-80.05524999999994,
							26.762360000000058
						],
						[
							-80.05528535999991,
							26.76207966800007
						],
						[
							-80.05529701299992,
							26.76181151600008
						],
						[
							-80.0553099999999,
							26.761660000000063
						],
						[
							-80.05533092899992,
							26.76141583100008
						],
						[
							-80.05536372499995,
							26.76118971500006
						],
						[
							-80.05536999999993,
							26.76096000000007
						],
						[
							-80.05540903399992,
							26.760747671000047
						],
						[
							-80.05544172799996,
							26.760432718000065
						],
						[
							-80.05542999999996,
							26.760290000000055
						],
						[
							-80.05545101199993,
							26.760067878000086
						],
						[
							-80.05550963799993,
							26.759752252000055
						],
						[
							-80.05549999999994,
							26.759550000000047
						],
						[
							-80.05555297099994,
							26.759197553000035
						],
						[
							-80.05557897599994,
							26.758808773000055
						],
						[
							-80.05561336699992,
							26.75846890200006
						],
						[
							-80.05562999999995,
							26.758110000000045
						],
						[
							-80.05567667999992,
							26.757849683000074
						],
						[
							-80.05570466199993,
							26.757580104000056
						],
						[
							-80.05572206999994,
							26.757412403000046
						],
						[
							-80.0557340439999,
							26.75710637000009
						],
						[
							-80.05576142799993,
							26.756870182000057
						],
						[
							-80.05577999999991,
							26.756710000000055
						],
						[
							-80.05580281099992,
							26.756441976000076
						],
						[
							-80.0558364879999,
							26.75604626900008
						],
						[
							-80.05585999999994,
							26.75577000000004
						],
						[
							-80.05588712999992,
							26.755525826000053
						],
						[
							-80.0559240149999,
							26.75519386800005
						],
						[
							-80.05593999999991,
							26.75505000000004
						],
						[
							-80.05596665599997,
							26.754795653000087
						],
						[
							-80.05600442999992,
							26.754462081000042
						],
						[
							-80.05601999999993,
							26.754320000000064
						],
						[
							-80.05603906899995,
							26.75401910000005
						],
						[
							-80.0560614659999,
							26.75375045000004
						],
						[
							-80.05607999999995,
							26.75362000000007
						],
						[
							-80.05609058899995,
							26.753417707000043
						],
						[
							-80.05610460799994,
							26.753260607000072
						],
						[
							-80.05611453799992,
							26.75314932200007
						],
						[
							-80.05614000899993,
							26.753150054000063
						],
						[
							-80.05616550699996,
							26.752869513000068
						],
						[
							-80.05622655399992,
							26.752871902000038
						],
						[
							-80.0563729239999,
							26.752876084000036
						],
						[
							-80.05655825299995,
							26.752881379000087
						],
						[
							-80.05682017799995,
							26.752888862000077
						],
						[
							-80.05715187699991,
							26.75289833900007
						],
						[
							-80.05749127799993,
							26.75290924400008
						],
						[
							-80.05772308699996,
							26.752916862000063
						],
						[
							-80.05798494399994,
							26.752925468000058
						],
						[
							-80.0582622039999,
							26.752934579000055
						],
						[
							-80.05858567399991,
							26.752945210000064
						],
						[
							-80.0587866759999,
							26.752951816000063
						],
						[
							-80.05907163799992,
							26.752961181000046
						],
						[
							-80.05927188099992,
							26.752967761000036
						],
						[
							-80.05945582299995,
							26.752987033000068
						],
						[
							-80.05958101099992,
							26.753005443000063
						],
						[
							-80.05970999999994,
							26.753010000000074
						],
						[
							-80.05974996399993,
							26.753011599000047
						],
						[
							-80.05988143999991,
							26.75301685800008
						],
						[
							-80.06003539799991,
							26.753022513000076
						],
						[
							-80.06020534299995,
							26.75302817800008
						],
						[
							-80.0604055419999,
							26.753032746000088
						],
						[
							-80.0604965149999,
							26.753034463000063
						],
						[
							-80.0606213449999,
							26.753036818000055
						],
						[
							-80.06076778199991,
							26.753039581000053
						],
						[
							-80.06080272999992,
							26.75303425600004
						],
						[
							-80.06080244399993,
							26.753048169000067
						],
						[
							-80.06093459899995,
							26.752994813000043
						],
						[
							-80.06114199399991,
							26.752997245000074
						],
						[
							-80.06135831099994,
							26.753005408000035
						],
						[
							-80.06172865999991,
							26.753024957000036
						],
						[
							-80.06217761999994,
							26.753051962000086
						],
						[
							-80.06262565299994,
							26.753078911000046
						],
						[
							-80.0628099999999,
							26.753090000000043
						],
						[
							-80.06299798099992,
							26.753096372000073
						],
						[
							-80.0632761789999,
							26.75310580300004
						],
						[
							-80.06398999999993,
							26.753130000000056
						],
						[
							-80.06437533199994,
							26.753133380000065
						],
						[
							-80.06473118799994,
							26.753136502000075
						],
						[
							-80.06517999999994,
							26.753140000000087
						],
						[
							-80.06538106999994,
							26.75313935300005
						],
						[
							-80.06634034899992,
							26.753136269000038
						],
						[
							-80.06834299199994,
							26.75319948600009
						],
						[
							-80.06836163999992,
							26.753215856000057
						],
						[
							-80.06833711899992,
							26.753519726000036
						],
						[
							-80.06828399999995,
							26.75417800000008
						],
						[
							-80.06810599999994,
							26.75610900000004
						],
						[
							-80.06804599999992,
							26.75733000000008
						],
						[
							-80.0678309999999,
							26.759685000000047
						],
						[
							-80.06758529599995,
							26.76231938500007
						],
						[
							-80.0675829999999,
							26.762344000000045
						],
						[
							-80.06748499999992,
							26.76363400000008
						],
						[
							-80.06528799999995,
							26.76353900000004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "West Palm Beach",
				"Name": "Northwood",
				"RegionID": "274812"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.51833403851569,
					27.922488847483105,
					-82.50580166408014,
					27.93387999935065
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.5081300259011,
							27.933870006084256
						],
						[
							-82.50580166408014,
							27.933853958581906
						],
						[
							-82.50581729159907,
							27.933348921813327
						],
						[
							-82.50581729159907,
							27.932059092575155
						],
						[
							-82.50588778225833,
							27.92563047071178
						],
						[
							-82.5059512968767,
							27.922576516991825
						],
						[
							-82.51824258286126,
							27.922488847483105
						],
						[
							-82.51833403851569,
							27.92287030121704
						],
						[
							-82.5180502430602,
							27.92319308587986
						],
						[
							-82.51420456669511,
							27.926355659714496
						],
						[
							-82.5142375996926,
							27.933876209607643
						],
						[
							-82.5128318325564,
							27.933868405291072
						],
						[
							-82.51211998679459,
							27.93387999935065
						],
						[
							-82.5081300259011,
							27.933870006084256
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Palma Ceia West",
				"RegionID": "274948"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.17437033699991,
					26.124808707000057,
					-80.16989493199992,
					26.129099031000067
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.16999053899991,
							26.129096032000064
						],
						[
							-80.16989493199992,
							26.12501889400005
						],
						[
							-80.17003819799993,
							26.12501889400005
						],
						[
							-80.17051111799992,
							26.124887527000055
						],
						[
							-80.17118108699992,
							26.12483498100005
						],
						[
							-80.17171968999992,
							26.12483498100005
						],
						[
							-80.17212692599992,
							26.124808707000057
						],
						[
							-80.17240279599991,
							26.124926937000055
						],
						[
							-80.17259984599991,
							26.125255353000057
						],
						[
							-80.17273121199992,
							26.125570633000052
						],
						[
							-80.17294139899991,
							26.12609609900005
						],
						[
							-80.17308590199991,
							26.12643765200005
						],
						[
							-80.17334863499991,
							26.12666097500005
						],
						[
							-80.1736639149999,
							26.126779205000048
						],
						[
							-80.1740448779999,
							26.126752932000045
						],
						[
							-80.17436687499992,
							26.12682072100006
						],
						[
							-80.1743679999999,
							26.12686300000007
						],
						[
							-80.1743659999999,
							26.12890900000008
						],
						[
							-80.17437033699991,
							26.128988079000067
						],
						[
							-80.17430642699992,
							26.12899112300005
						],
						[
							-80.17423275999994,
							26.12899463000008
						],
						[
							-80.1741178019999,
							26.128997992000052
						],
						[
							-80.17305809299995,
							26.129026924000076
						],
						[
							-80.17217377999992,
							26.12905496500008
						],
						[
							-80.1720936609999,
							26.129059974000086
						],
						[
							-80.17187333499993,
							26.129059974000086
						],
						[
							-80.17066854799992,
							26.129090017000067
						],
						[
							-80.1701067159999,
							26.129099031000067
						],
						[
							-80.16999053899991,
							26.129096032000064
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "River Garden Sweeting Estate",
				"RegionID": "275182"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.16887919399994,
					26.707967000000053,
					-80.1499409999999,
					26.721593486000074
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.15219897299995,
							26.71095880900009
						],
						[
							-80.1522359999999,
							26.71048600000006
						],
						[
							-80.15194699999995,
							26.71048600000006
						],
						[
							-80.14994399999995,
							26.710461000000066
						],
						[
							-80.14994116999992,
							26.708108361000086
						],
						[
							-80.1499409999999,
							26.707967000000053
						],
						[
							-80.1518769999999,
							26.708023000000082
						],
						[
							-80.15385099999992,
							26.70808500000004
						],
						[
							-80.15784599999996,
							26.708210000000065
						],
						[
							-80.16226699999993,
							26.70831600000008
						],
						[
							-80.16225244399993,
							26.708224102000088
						],
						[
							-80.16273607599993,
							26.708235805000072
						],
						[
							-80.1641384269999,
							26.708275308000054
						],
						[
							-80.16524403499994,
							26.708306452000045
						],
						[
							-80.16579743799991,
							26.708322041000088
						],
						[
							-80.16607999999991,
							26.708330000000046
						],
						[
							-80.16681727299994,
							26.70834232900006
						],
						[
							-80.16873044699992,
							26.708374322000054
						],
						[
							-80.16887919399994,
							26.70837680900007
						],
						[
							-80.16883284199992,
							26.708583957000087
						],
						[
							-80.16875173199992,
							26.70894644300006
						],
						[
							-80.16811406599993,
							26.714175304000037
						],
						[
							-80.16760393299995,
							26.718809011000076
						],
						[
							-80.16726384499992,
							26.721593486000074
						],
						[
							-80.16498950199991,
							26.721465953000063
						],
						[
							-80.16050458399991,
							26.721380931000056
						],
						[
							-80.15506316699992,
							26.72127465300008
						],
						[
							-80.15177433499991,
							26.721237491000068
						],
						[
							-80.15148581699992,
							26.72123423100004
						],
						[
							-80.15152528099992,
							26.720269813000073
						],
						[
							-80.15158599999995,
							26.71878600000008
						],
						[
							-80.1517611079999,
							26.716550004000055
						],
						[
							-80.15219897299995,
							26.71095880900009
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "West Palm Beach",
				"Name": "River Walk",
				"RegionID": "275189"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.48168107499993,
					27.96654673800009,
					-82.4676635809999,
					27.981800054000075
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.4676635809999,
							27.967109911000083
						],
						[
							-82.4698181949999,
							27.96710003800007
						],
						[
							-82.47423636399992,
							27.96687272700007
						],
						[
							-82.47459099999992,
							27.966837000000055
						],
						[
							-82.47496413499994,
							27.96654673800009
						],
						[
							-82.4752471139999,
							27.966893387000088
						],
						[
							-82.4760096579999,
							27.967822737000063
						],
						[
							-82.47643858799995,
							27.968394645000046
						],
						[
							-82.47689134799992,
							27.968799746000062
						],
						[
							-82.47727261999995,
							27.969038041000093
						],
						[
							-82.47779686899992,
							27.96925250600009
						],
						[
							-82.47827345899994,
							27.969371654000042
						],
						[
							-82.4787977069999,
							27.969490801000063
						],
						[
							-82.4792742969999,
							27.969538460000084
						],
						[
							-82.47967939799992,
							27.969609948000084
						],
						[
							-82.48020364699994,
							27.96975292500008
						],
						[
							-82.48056108899993,
							27.969943561000036
						],
						[
							-82.48091853099993,
							27.970539298000062
						],
						[
							-82.48144277999995,
							27.97154013700009
						],
						[
							-82.48168107499993,
							27.972278851000056
						],
						[
							-82.48168107499993,
							27.97285075800005
						],
						[
							-82.48144277999995,
							27.973780108000085
						],
						[
							-82.4812472459999,
							27.97428523700006
						],
						[
							-82.48115682599992,
							27.97451882200005
						],
						[
							-82.4809423609999,
							27.97497158200008
						],
						[
							-82.48082321299995,
							27.975257536000072
						],
						[
							-82.48022747599992,
							27.97602007900008
						],
						[
							-82.4795602509999,
							27.976496669000085
						],
						[
							-82.47882153699993,
							27.977092406000057
						],
						[
							-82.4782257999999,
							27.977545166000084
						],
						[
							-82.47751091499994,
							27.978164733000085
						],
						[
							-82.47715347299993,
							27.97852217500008
						],
						[
							-82.47681985999992,
							27.97911791200005
						],
						[
							-82.47667688299993,
							27.97957067200008
						],
						[
							-82.47648624699991,
							27.980261727000084
						],
						[
							-82.47605731699991,
							27.980833635000067
						],
						[
							-82.47519285699991,
							27.981678448000082
						],
						[
							-82.47464350099996,
							27.98172085400006
						],
						[
							-82.47361818099995,
							27.981800000000078
						],
						[
							-82.46766363599994,
							27.981800054000075
						],
						[
							-82.46766363499995,
							27.973722382000062
						],
						[
							-82.4676635809999,
							27.967109911000083
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Riverside Heights",
				"RegionID": "275205"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.95329126699994,
					28.077171399000065,
					-81.95044464299991,
					28.082501135000086
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.95051453899993,
							28.082501135000086
						],
						[
							-81.95044464299991,
							28.077171399000065
						],
						[
							-81.95329126699994,
							28.077171432000057
						],
						[
							-81.95326535899994,
							28.08182565000004
						],
						[
							-81.95051453899993,
							28.082501135000086
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Polk",
				"City": "Lakeland",
				"Name": "N Martha",
				"RegionID": "343440"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.95328551099993,
					28.075992538000037,
					-81.94447500199993,
					28.086728322000056
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.94758752799993,
							28.086352480000073
						],
						[
							-81.9475420359999,
							28.086315146000064
						],
						[
							-81.94749908299991,
							28.086274917000082
						],
						[
							-81.94745885399993,
							28.086231964000035
						],
						[
							-81.94743786999993,
							28.08620714600005
						],
						[
							-81.94716484199996,
							28.085872132000077
						],
						[
							-81.94675463399994,
							28.085378941000045
						],
						[
							-81.94657704499991,
							28.085196776000092
						],
						[
							-81.94656582599993,
							28.085185058000036
						],
						[
							-81.94650282599991,
							28.085118057000045
						],
						[
							-81.94648185399991,
							28.085094964000064
						],
						[
							-81.94644451999994,
							28.085049472000037
						],
						[
							-81.94642669399991,
							28.085025422000058
						],
						[
							-81.94632674999991,
							28.08488578500004
						],
						[
							-81.94566189999995,
							28.08421070600008
						],
						[
							-81.94539455299991,
							28.083940366000036
						],
						[
							-81.94535785399995,
							28.083900964000065
						],
						[
							-81.94535151199995,
							28.083893652000086
						],
						[
							-81.94522451099994,
							28.08374565300005
						],
						[
							-81.94519351999992,
							28.08370747200007
						],
						[
							-81.94515924099994,
							28.08365963600005
						],
						[
							-81.94512816399993,
							28.083609661000082
						],
						[
							-81.94510129399993,
							28.083559523000076
						],
						[
							-81.94498129399994,
							28.083317523000066
						],
						[
							-81.9449804219999,
							28.083315760000062
						],
						[
							-81.94495613499993,
							28.083262155000057
						],
						[
							-81.94493540499991,
							28.083207077000054
						],
						[
							-81.94493416799992,
							28.083203408000088
						],
						[
							-81.94485016799992,
							28.08295240800004
						],
						[
							-81.9448343219999,
							28.08289976100008
						],
						[
							-81.94482095899991,
							28.082842449000054
						],
						[
							-81.94481137199995,
							28.082784385000082
						],
						[
							-81.9448056039999,
							28.082725818000085
						],
						[
							-81.9448039959999,
							28.082690910000053
						],
						[
							-81.94478172299995,
							28.081853426000066
						],
						[
							-81.94476545899995,
							28.081790696000045
						],
						[
							-81.94475395799992,
							28.08174044900005
						],
						[
							-81.94474594799993,
							28.081693793000056
						],
						[
							-81.9446899479999,
							28.081306793000067
						],
						[
							-81.94468837199992,
							28.08129538500009
						],
						[
							-81.94468260399992,
							28.081236819000083
						],
						[
							-81.94468211899994,
							28.08122889100008
						],
						[
							-81.94466811899993,
							28.08098189100008
						],
						[
							-81.9446667979999,
							28.08094565600004
						],
						[
							-81.94465279699995,
							28.08008665600005
						],
						[
							-81.9446526779999,
							28.080072000000087
						],
						[
							-81.94465271399991,
							28.080063943000084
						],
						[
							-81.94467634099993,
							28.077426576000054
						],
						[
							-81.94463469999994,
							28.07692942500006
						],
						[
							-81.94447500199993,
							28.076085096000043
						],
						[
							-81.94537276199992,
							28.075992538000037
						],
						[
							-81.94596745199993,
							28.076513065000086
						],
						[
							-81.94631860699992,
							28.076864215000057
						],
						[
							-81.94688920599992,
							28.077171554000078
						],
						[
							-81.95044464299991,
							28.077171399000065
						],
						[
							-81.95051453899993,
							28.082501135000086
						],
						[
							-81.95101543099992,
							28.08283371300007
						],
						[
							-81.95101513499992,
							28.08419464700006
						],
						[
							-81.95325206599995,
							28.084196199000075
						],
						[
							-81.95328390999993,
							28.08526800900006
						],
						[
							-81.95328551099993,
							28.085298546000047
						],
						[
							-81.95320493899993,
							28.08529866500004
						],
						[
							-81.9532040389999,
							28.085268872000086
						],
						[
							-81.95292391099991,
							28.08529501000004
						],
						[
							-81.95259437599992,
							28.085299414000076
						],
						[
							-81.9506787759999,
							28.08532487900004
						],
						[
							-81.95069599999994,
							28.085772500000076
						],
						[
							-81.9499987179999,
							28.086343014000082
						],
						[
							-81.94998651899994,
							28.08632747300004
						],
						[
							-81.94998639199991,
							28.086327304000065
						],
						[
							-81.94993197999992,
							28.08633683700009
						],
						[
							-81.9498841109999,
							28.086347786000093
						],
						[
							-81.94979245799993,
							28.086396853000053
						],
						[
							-81.94976575999993,
							28.086410578000088
						],
						[
							-81.94972980799992,
							28.086427332000085
						],
						[
							-81.94952700599993,
							28.08651645200007
						],
						[
							-81.94952548999993,
							28.086517541000035
						],
						[
							-81.94950063599993,
							28.086534759000074
						],
						[
							-81.9494506609999,
							28.086565835000044
						],
						[
							-81.94939875999995,
							28.08659357700009
						],
						[
							-81.94934515499995,
							28.08661786500005
						],
						[
							-81.94929007699994,
							28.08663859500007
						],
						[
							-81.9492337609999,
							28.086655678000056
						],
						[
							-81.94917644899994,
							28.086669041000054
						],
						[
							-81.94916120399995,
							28.086671937000062
						],
						[
							-81.94892920399991,
							28.08671393700007
						],
						[
							-81.94888638499992,
							28.08672062800008
						],
						[
							-81.94882781799994,
							28.086726396000074
						],
						[
							-81.94876899999991,
							28.086728322000056
						],
						[
							-81.94857899999994,
							28.086728322000056
						],
						[
							-81.94852018099994,
							28.086726396000074
						],
						[
							-81.94846161499993,
							28.08672062800008
						],
						[
							-81.9484035509999,
							28.086711042000047
						],
						[
							-81.94835715699992,
							28.086700530000087
						],
						[
							-81.94808215699993,
							28.086630531000083
						],
						[
							-81.9480712379999,
							28.08662767900006
						],
						[
							-81.94801492199991,
							28.08661059500008
						],
						[
							-81.94795984399991,
							28.086589865000068
						],
						[
							-81.94790623999995,
							28.08656557800009
						],
						[
							-81.94785433899995,
							28.086537836000048
						],
						[
							-81.94780436299993,
							28.086506759000088
						],
						[
							-81.9477833329999,
							28.086492271000054
						],
						[
							-81.94761433299993,
							28.086372271000073
						],
						[
							-81.94758752799993,
							28.086352480000073
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Polk",
				"City": "Lakeland",
				"Name": "Lake Parker Park",
				"RegionID": "343441"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.94375866399992,
					27.99669246900004,
					-81.92408490999992,
					28.011591039000056
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.9242729099999,
							28.011507009000074
						],
						[
							-81.92427890899995,
							28.011051009000084
						],
						[
							-81.92429090999991,
							28.01012600900009
						],
						[
							-81.92428890999992,
							28.009352009000057
						],
						[
							-81.92428107399991,
							28.00849446300009
						],
						[
							-81.92427990999994,
							28.00836700900004
						],
						[
							-81.9242489099999,
							28.00760200900004
						],
						[
							-81.9242039099999,
							28.005212009000047
						],
						[
							-81.9241399089999,
							28.00322901000004
						],
						[
							-81.92413290999991,
							28.002489010000094
						],
						[
							-81.92412790999992,
							28.001816009000038
						],
						[
							-81.92409982999993,
							28.00138699000007
						],
						[
							-81.92414899199991,
							28.001290028000085
						],
						[
							-81.92410990999991,
							27.997602009000047
						],
						[
							-81.92408490999992,
							27.996849009000073
						],
						[
							-81.92408513299995,
							27.996791981000058
						],
						[
							-81.9371782469999,
							27.99669246900004
						],
						[
							-81.9399714029999,
							27.99671295400009
						],
						[
							-81.94038275899993,
							27.997735798000065
						],
						[
							-81.94060632799994,
							27.998108417000083
						],
						[
							-81.94161239399995,
							28.00012054800004
						],
						[
							-81.9421342469999,
							28.002020951000077
						],
						[
							-81.94079270599991,
							28.00332517600009
						],
						[
							-81.93948847599995,
							28.00388398700005
						],
						[
							-81.9376252589999,
							28.004852675000052
						],
						[
							-81.93711926999994,
							28.00598609000008
						],
						[
							-81.93658436299997,
							28.00676208200008
						],
						[
							-81.9365538479999,
							28.007555474000075
						],
						[
							-81.93688951399992,
							28.00749444300004
						],
						[
							-81.93694037199994,
							28.007799594000062
						],
						[
							-81.93720483599992,
							28.00844041000005
						],
						[
							-81.9375811889999,
							28.00848109700007
						],
						[
							-81.9381676239999,
							28.008441339000058
						],
						[
							-81.93818131799992,
							28.00844041000005
						],
						[
							-81.93841526699993,
							28.008786248000035
						],
						[
							-81.93849663999993,
							28.009498266000037
						],
						[
							-81.9386390439999,
							28.009884790000058
						],
						[
							-81.9389848809999,
							28.010281486000054
						],
						[
							-81.93925951699993,
							28.010495091000053
						],
						[
							-81.93970707099993,
							28.01070869700004
						],
						[
							-81.93991050499994,
							28.010423890000084
						],
						[
							-81.94031737299991,
							28.01046457600006
						],
						[
							-81.94107007699995,
							28.010505263000084
						],
						[
							-81.94160917699992,
							28.010535778000076
						],
						[
							-81.94177192399991,
							28.010718869000073
						],
						[
							-81.94220930699994,
							28.01072904000006
						],
						[
							-81.94279926399992,
							28.010830757000065
						],
						[
							-81.94317561699995,
							28.010830757000065
						],
						[
							-81.94339939399993,
							28.011024019000047
						],
						[
							-81.94375866399992,
							28.01129116900006
						],
						[
							-81.94329190899992,
							28.011293010000088
						],
						[
							-81.94063390999992,
							28.011276010000074
						],
						[
							-81.93997162399995,
							28.011271433000047
						],
						[
							-81.9396329089999,
							28.011269010000035
						],
						[
							-81.93874390999991,
							28.011268010000038
						],
						[
							-81.93786190999994,
							28.01127001000009
						],
						[
							-81.93699690999995,
							28.011287010000046
						],
						[
							-81.93601390999993,
							28.011255010000074
						],
						[
							-81.93508990999993,
							28.011248011000077
						],
						[
							-81.9350129099999,
							28.01125101000008
						],
						[
							-81.9339779099999,
							28.011271010000087
						],
						[
							-81.93293990899991,
							28.011296009000034
						],
						[
							-81.93265190999995,
							28.011303011000052
						],
						[
							-81.9324119129999,
							28.011298955000086
						],
						[
							-81.93121290999994,
							28.011277009000082
						],
						[
							-81.9302159099999,
							28.01129000900005
						],
						[
							-81.9297229099999,
							28.011296009000034
						],
						[
							-81.92887490999993,
							28.011291009000047
						],
						[
							-81.92847190899994,
							28.011289009000052
						],
						[
							-81.9281959089999,
							28.011288009000054
						],
						[
							-81.92773590999992,
							28.011288009000054
						],
						[
							-81.92723890899994,
							28.011288009000054
						],
						[
							-81.92678290999993,
							28.011289009000052
						],
						[
							-81.92614890899995,
							28.011284009000065
						],
						[
							-81.92521190999992,
							28.011294010000086
						],
						[
							-81.92510592699995,
							28.011309100000062
						],
						[
							-81.92504690999993,
							28.01132301000007
						],
						[
							-81.92485190999992,
							28.011369009000077
						],
						[
							-81.92464490999993,
							28.011428009000042
						],
						[
							-81.92431490899992,
							28.011568009000086
						],
						[
							-81.92427196699992,
							28.011591039000056
						],
						[
							-81.9242729099999,
							28.011507009000074
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Polk",
				"City": "Lakeland",
				"Name": "Lake Somerset",
				"RegionID": "343454"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.94882763499993,
					27.995015557000045,
					-81.9365538479999,
					28.01129116900006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.94339939399993,
							28.011024019000047
						],
						[
							-81.94317561699995,
							28.010830757000065
						],
						[
							-81.94279926399992,
							28.010830757000065
						],
						[
							-81.94220930699994,
							28.01072904000006
						],
						[
							-81.94177192399991,
							28.010718869000073
						],
						[
							-81.94160917699992,
							28.010535778000076
						],
						[
							-81.94107007699995,
							28.010505263000084
						],
						[
							-81.94031737299991,
							28.01046457600006
						],
						[
							-81.93991050499994,
							28.010423890000084
						],
						[
							-81.93970707099993,
							28.01070869700004
						],
						[
							-81.93925951699993,
							28.010495091000053
						],
						[
							-81.9389848809999,
							28.010281486000054
						],
						[
							-81.9386390439999,
							28.009884790000058
						],
						[
							-81.93849663999993,
							28.009498266000037
						],
						[
							-81.93841526699993,
							28.008786248000035
						],
						[
							-81.93818131799992,
							28.00844041000005
						],
						[
							-81.9381676239999,
							28.008441339000058
						],
						[
							-81.9375811889999,
							28.00848109700007
						],
						[
							-81.93720483599992,
							28.00844041000005
						],
						[
							-81.93694037199994,
							28.007799594000062
						],
						[
							-81.93688951399992,
							28.00749444300004
						],
						[
							-81.9365538479999,
							28.007555474000075
						],
						[
							-81.93658436299997,
							28.00676208200008
						],
						[
							-81.93711926999994,
							28.00598609000008
						],
						[
							-81.9376252589999,
							28.004852675000052
						],
						[
							-81.93948847599995,
							28.00388398700005
						],
						[
							-81.94079270599991,
							28.00332517600009
						],
						[
							-81.9421342469999,
							28.002020951000077
						],
						[
							-81.94161239399995,
							28.00012054800004
						],
						[
							-81.94060632799994,
							27.998108417000083
						],
						[
							-81.94038275899993,
							27.997735798000065
						],
						[
							-81.9399714029999,
							27.99671295400009
						],
						[
							-81.94224584599993,
							27.996729783000035
						],
						[
							-81.94299124999992,
							27.99646896300004
						],
						[
							-81.9427676059999,
							27.99605885200009
						],
						[
							-81.93948835399993,
							27.996208211000067
						],
						[
							-81.9394138049999,
							27.99561176800006
						],
						[
							-81.94448155099991,
							27.99501569100005
						],
						[
							-81.9470154839999,
							27.995015557000045
						],
						[
							-81.94701546699991,
							27.996245465000072
						],
						[
							-81.94604644899994,
							27.99609611900007
						],
						[
							-81.94578576099991,
							27.996804342000075
						],
						[
							-81.94436963099992,
							27.99680412300006
						],
						[
							-81.94444446299991,
							27.99840658900007
						],
						[
							-81.94325174399995,
							27.999412592000056
						],
						[
							-81.9441091089999,
							27.999896899000078
						],
						[
							-81.94377339499994,
							28.001462039000046
						],
						[
							-81.94418339299995,
							28.00179750500007
						],
						[
							-81.94876491199994,
							28.00183452300007
						],
						[
							-81.9487659099999,
							28.00238800900007
						],
						[
							-81.94880390899993,
							28.002769009000076
						],
						[
							-81.9488139099999,
							28.003579009000077
						],
						[
							-81.94882763499993,
							28.00400536500007
						],
						[
							-81.94681406599994,
							28.00398195100007
						],
						[
							-81.9467780629999,
							28.004437993000067
						],
						[
							-81.94662204799994,
							28.004726020000078
						],
						[
							-81.94662204799994,
							28.00494204000006
						],
						[
							-81.94639402699994,
							28.005362078000076
						],
						[
							-81.94646603399991,
							28.00556609700004
						],
						[
							-81.9464180299999,
							28.005830122000077
						],
						[
							-81.94620200999992,
							28.00593813200004
						],
						[
							-81.94614200399991,
							28.00662219500009
						],
						[
							-81.94608199899994,
							28.007090238000046
						],
						[
							-81.94603399399995,
							28.00719824800007
						],
						[
							-81.94600999199992,
							28.007858309000085
						],
						[
							-81.94603399399995,
							28.008230343000037
						],
						[
							-81.94610600099992,
							28.008554373000038
						],
						[
							-81.94622538399994,
							28.008643910000046
						],
						[
							-81.94623090999994,
							28.00926000900006
						],
						[
							-81.94621690999992,
							28.00946601000004
						],
						[
							-81.94620890999994,
							28.009572009000067
						],
						[
							-81.9461589089999,
							28.00982600900005
						],
						[
							-81.9460919089999,
							28.010012009000036
						],
						[
							-81.94598290999994,
							28.01020200800008
						],
						[
							-81.94584390999995,
							28.010398009000085
						],
						[
							-81.94577890999996,
							28.010491009000077
						],
						[
							-81.94566591099995,
							28.01068101000004
						],
						[
							-81.94559491099994,
							28.01088500900005
						],
						[
							-81.94555991099992,
							28.011076010000068
						],
						[
							-81.94555990999993,
							28.011284063000062
						],
						[
							-81.94375866399992,
							28.01129116900006
						],
						[
							-81.94339939399993,
							28.011024019000047
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Polk",
				"City": "Lakeland",
				"Name": "Cleveland Heights Golf Course",
				"RegionID": "343455"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.6672769999999,
					27.82837900000004,
					-82.64684999999992,
					27.842913214000077
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.66129430099994,
							27.842913214000077
						],
						[
							-82.66107584699995,
							27.842730703000086
						],
						[
							-82.66023638899992,
							27.842734798000038
						],
						[
							-82.65964565899992,
							27.842737680000084
						],
						[
							-82.6591699999999,
							27.84274000000005
						],
						[
							-82.65886814599992,
							27.842735808000043
						],
						[
							-82.65874380299994,
							27.842734081000064
						],
						[
							-82.6584499999999,
							27.842730000000074
						],
						[
							-82.65831999999995,
							27.84274000000005
						],
						[
							-82.65809127799992,
							27.842743315000064
						],
						[
							-82.65793585099993,
							27.842745567000065
						],
						[
							-82.65753165599995,
							27.84275111800008
						],
						[
							-82.65700316399995,
							27.84275712300007
						],
						[
							-82.65674999999993,
							27.842760000000055
						],
						[
							-82.6564120509999,
							27.842760000000055
						],
						[
							-82.65616331699994,
							27.842760000000055
						],
						[
							-82.65560366499994,
							27.842760000000055
						],
						[
							-82.65519999999992,
							27.842760000000055
						],
						[
							-82.6550499999999,
							27.84274000000005
						],
						[
							-82.65460872799991,
							27.84274000000005
						],
						[
							-82.65398706699995,
							27.842744223000068
						],
						[
							-82.65320983499993,
							27.84275116200007
						],
						[
							-82.6527743069999,
							27.84275505100004
						],
						[
							-82.65224578899995,
							27.842759770000043
						],
						[
							-82.65159291399993,
							27.842765599000074
						],
						[
							-82.65109999999993,
							27.842770000000087
						],
						[
							-82.65081569099993,
							27.84277268200009
						],
						[
							-82.65047341899992,
							27.842775911000047
						],
						[
							-82.65022470699995,
							27.842778257000077
						],
						[
							-82.64972745499995,
							27.84277604400006
						],
						[
							-82.64938510699994,
							27.84277171000008
						],
						[
							-82.64885662899991,
							27.842764755000076
						],
						[
							-82.6484524679999,
							27.84275849100004
						],
						[
							-82.6480787559999,
							27.842746627000054
						],
						[
							-82.6478699999999,
							27.84274000000005
						],
						[
							-82.64758178099993,
							27.842732415000057
						],
						[
							-82.6473332189999,
							27.842725874000052
						],
						[
							-82.64710999999994,
							27.842720000000046
						],
						[
							-82.64699124299995,
							27.842720000000046
						],
						[
							-82.64688999999993,
							27.842710000000068
						],
						[
							-82.64689549399992,
							27.842600128000072
						],
						[
							-82.6468999999999,
							27.84251000000006
						],
						[
							-82.6468999999999,
							27.84219605900006
						],
						[
							-82.6468999999999,
							27.841822958000083
						],
						[
							-82.6468999999999,
							27.84161000000006
						],
						[
							-82.64689787499992,
							27.84141876600006
						],
						[
							-82.64689407599991,
							27.841076798000078
						],
						[
							-82.64688999999993,
							27.84071000000006
						],
						[
							-82.64688999999993,
							27.84045491900008
						],
						[
							-82.64688999999993,
							27.84001963500009
						],
						[
							-82.64688999999993,
							27.839780000000076
						],
						[
							-82.64688999999993,
							27.83942889100007
						],
						[
							-82.64688999999993,
							27.839180157000044
						],
						[
							-82.64688999999993,
							27.838870000000043
						],
						[
							-82.64688999999993,
							27.838744872000063
						],
						[
							-82.64688999999993,
							27.83862000000005
						],
						[
							-82.64688999999993,
							27.83849613800004
						],
						[
							-82.64688999999993,
							27.83836000000008
						],
						[
							-82.6468862619999,
							27.83806099900005
						],
						[
							-82.64688392599993,
							27.83787408900008
						],
						[
							-82.64688159499991,
							27.837687567000046
						],
						[
							-82.6468799999999,
							27.837560000000053
						],
						[
							-82.6468764739999,
							27.837376649000078
						],
						[
							-82.64687408299994,
							27.83725232800009
						],
						[
							-82.64686999999992,
							27.83704000000006
						],
						[
							-82.64686999999992,
							27.83678609000009
						],
						[
							-82.64686999999992,
							27.836537356000065
						],
						[
							-82.64686999999992,
							27.836230000000057
						],
						[
							-82.64686999999992,
							27.835946612000043
						],
						[
							-82.64686999999992,
							27.835620000000063
						],
						[
							-82.64686999999992,
							27.835253848000036
						],
						[
							-82.64686999999992,
							27.835078957000064
						],
						[
							-82.64686999999992,
							27.83457177300005
						],
						[
							-82.64686743499993,
							27.834064525000088
						],
						[
							-82.64686387299992,
							27.833487405000085
						],
						[
							-82.64686106599994,
							27.83303270600004
						],
						[
							-82.6468577199999,
							27.83249056300008
						],
						[
							-82.64685545299994,
							27.832123306000085
						],
						[
							-82.64685286199995,
							27.831703583000035
						],
						[
							-82.64685178199994,
							27.831528698000056
						],
						[
							-82.64684999999992,
							27.831240000000037
						],
						[
							-82.64685344899993,
							27.830864044000066
						],
						[
							-82.64685585599995,
							27.83060173000007
						],
						[
							-82.64685826199991,
							27.830339415000083
						],
						[
							-82.64685999999995,
							27.83015000000006
						],
						[
							-82.64686068399993,
							27.830094600000052
						],
						[
							-82.64686219499993,
							27.82997219500004
						],
						[
							-82.64686370599992,
							27.829849790000083
						],
						[
							-82.64686608099994,
							27.829657439000076
						],
						[
							-82.64686845599994,
							27.829465088000063
						],
						[
							-82.64686999999992,
							27.82934000000006
						],
						[
							-82.64686999999992,
							27.829167633000054
						],
						[
							-82.64686999999992,
							27.828992742000082
						],
						[
							-82.64686999999992,
							27.82864296000008
						],
						[
							-82.64686999999992,
							27.82842000000005
						],
						[
							-82.64750393599991,
							27.82842000000005
						],
						[
							-82.64790999999991,
							27.82842000000005
						],
						[
							-82.64825137399993,
							27.82842000000005
						],
						[
							-82.64920643199991,
							27.82842000000005
						],
						[
							-82.65020301499993,
							27.82842000000005
						],
						[
							-82.65095999999994,
							27.82842000000005
						],
						[
							-82.6521131319999,
							27.82842000000005
						],
						[
							-82.6536495329999,
							27.828410156000075
						],
						[
							-82.65497999999991,
							27.828400000000048
						],
						[
							-82.65547929999991,
							27.828398526000058
						],
						[
							-82.6560739009999,
							27.828394339000056
						],
						[
							-82.65668999999991,
							27.82839000000007
						],
						[
							-82.65698336199995,
							27.82839000000007
						],
						[
							-82.65745556899992,
							27.82839000000007
						],
						[
							-82.65766956699991,
							27.82839000000007
						],
						[
							-82.65766899999994,
							27.82848000000007
						],
						[
							-82.65828999999992,
							27.82846600000005
						],
						[
							-82.6589239999999,
							27.828463000000056
						],
						[
							-82.6594849999999,
							27.82846100000006
						],
						[
							-82.65990699999992,
							27.828459000000066
						],
						[
							-82.66017499999992,
							27.82845300000008
						],
						[
							-82.6605239999999,
							27.828403000000037
						],
						[
							-82.66071099999994,
							27.82840200000004
						],
						[
							-82.66077299999995,
							27.82839800000005
						],
						[
							-82.66163399999994,
							27.82839800000005
						],
						[
							-82.66239799999994,
							27.82840500000009
						],
						[
							-82.66252899999995,
							27.828401000000046
						],
						[
							-82.66318999999993,
							27.828401000000046
						],
						[
							-82.66381999999994,
							27.828396000000055
						],
						[
							-82.66562199999993,
							27.828389000000072
						],
						[
							-82.66665299999994,
							27.828383000000088
						],
						[
							-82.6672769999999,
							27.82837900000004
						],
						[
							-82.66714899999995,
							27.834580000000074
						],
						[
							-82.66707698999994,
							27.838596282000083
						],
						[
							-82.66705599999995,
							27.839767000000055
						],
						[
							-82.66706783899991,
							27.839878484000053
						],
						[
							-82.66709199999991,
							27.84010600000005
						],
						[
							-82.66611799999993,
							27.84024500000004
						],
						[
							-82.66527299999991,
							27.840320000000077
						],
						[
							-82.66483399999993,
							27.840293000000088
						],
						[
							-82.66448199999991,
							27.840272000000084
						],
						[
							-82.66354899999993,
							27.840215000000057
						],
						[
							-82.66331799999995,
							27.840207000000078
						],
						[
							-82.6636079999999,
							27.842572000000075
						],
						[
							-82.66361393599993,
							27.842817928000045
						],
						[
							-82.66361499999994,
							27.842862000000082
						],
						[
							-82.66361572699992,
							27.84289056600005
						],
						[
							-82.66129430099994,
							27.842913214000077
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Meadowlawn",
				"RegionID": "417185"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.63459999999992,
					27.828460000000064,
					-82.62712979999993,
					27.832080000000076
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.63415678399991,
							27.83207208500005
						],
						[
							-82.63364482199995,
							27.832070000000044
						],
						[
							-82.63341300199994,
							27.832070000000044
						],
						[
							-82.63324999999992,
							27.832070000000044
						],
						[
							-82.63304595199992,
							27.832070000000044
						],
						[
							-82.63279481299992,
							27.832070000000044
						],
						[
							-82.63255355399991,
							27.832068760000084
						],
						[
							-82.63250536399994,
							27.832066501000043
						],
						[
							-82.63234061399993,
							27.83205877900008
						],
						[
							-82.63219604299991,
							27.83205200200007
						],
						[
							-82.6320124689999,
							27.832043397000064
						],
						[
							-82.63190633799991,
							27.83203388000004
						],
						[
							-82.63182999999992,
							27.832020000000057
						],
						[
							-82.6316260509999,
							27.83207345200009
						],
						[
							-82.6308629749999,
							27.831986519000054
						],
						[
							-82.63054715099992,
							27.831912397000053
						],
						[
							-82.62991637399995,
							27.831764358000044
						],
						[
							-82.62924023099993,
							27.831464923000055
						],
						[
							-82.62880556699992,
							27.831291057000044
						],
						[
							-82.62835158499992,
							27.830981963000056
						],
						[
							-82.62797487699993,
							27.83061491400008
						],
						[
							-82.62763680499995,
							27.830045022000036
						],
						[
							-82.62738566599995,
							27.82942683300007
						],
						[
							-82.62722145999994,
							27.828808645000038
						],
						[
							-82.62712999999991,
							27.828500000000076
						],
						[
							-82.62712979999993,
							27.828499496000063
						],
						[
							-82.6274622119999,
							27.82849819400008
						],
						[
							-82.62819972299991,
							27.828494186000057
						],
						[
							-82.62861470299993,
							27.828491931000087
						],
						[
							-82.62904493299993,
							27.828489190000084
						],
						[
							-82.62949052399995,
							27.828484373000038
						],
						[
							-82.62998254299993,
							27.82847905400007
						],
						[
							-82.63058178599994,
							27.828472575000035
						],
						[
							-82.6310580729999,
							27.828470000000042
						],
						[
							-82.63139614699992,
							27.828470000000042
						],
						[
							-82.63190325799991,
							27.828470000000042
						],
						[
							-82.63228743299993,
							27.828470000000042
						],
						[
							-82.63296360299995,
							27.828468455000063
						],
						[
							-82.63359363299992,
							27.82846513900006
						],
						[
							-82.63436196099991,
							27.828461095000083
						],
						[
							-82.63456999999994,
							27.828460000000064
						],
						[
							-82.6345706269999,
							27.828460000000064
						],
						[
							-82.63457285699991,
							27.82856714500008
						],
						[
							-82.63457595299991,
							27.828683230000085
						],
						[
							-82.63458212999991,
							27.828914886000064
						],
						[
							-82.63458418899995,
							27.828992105000054
						],
						[
							-82.6345875419999,
							27.829117843000063
						],
						[
							-82.63458999999995,
							27.829210000000046
						],
						[
							-82.63458999999995,
							27.829368878000086
						],
						[
							-82.63458999999995,
							27.829784223000047
						],
						[
							-82.63458999999995,
							27.83000000000004
						],
						[
							-82.63458999999995,
							27.830218887000058
						],
						[
							-82.63458999999995,
							27.83063423200008
						],
						[
							-82.63458999999995,
							27.830860000000087
						],
						[
							-82.63459304799994,
							27.830981923000085
						],
						[
							-82.63459570899994,
							27.831088349000083
						],
						[
							-82.63459788099995,
							27.831175227000077
						],
						[
							-82.63459999999992,
							27.831260000000047
						],
						[
							-82.63459999999992,
							27.831493900000055
						],
						[
							-82.63459999999992,
							27.83181265400009
						],
						[
							-82.63459999999992,
							27.831976860000054
						],
						[
							-82.63459999999992,
							27.832080000000076
						],
						[
							-82.63446595199993,
							27.83207760600004
						],
						[
							-82.63431145399994,
							27.832074847000058
						],
						[
							-82.63415678399991,
							27.83207208500005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Mangrove Bay",
				"RegionID": "417187"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.62133739099994,
					27.835393715000066,
					-82.6048406779999,
					27.843910262000065
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.6147475869999,
							27.843289266000056
						],
						[
							-82.61454874399993,
							27.843225494000084
						],
						[
							-82.61449341499991,
							27.843241189000082
						],
						[
							-82.61438052299991,
							27.843265504000044
						],
						[
							-82.61393752299995,
							27.84333150500004
						],
						[
							-82.61382843799993,
							27.843341017000057
						],
						[
							-82.61375491699994,
							27.84334293400008
						],
						[
							-82.61178033499993,
							27.843401720000088
						],
						[
							-82.61103801799995,
							27.843463580000048
						],
						[
							-82.6104194209999,
							27.84330893100008
						],
						[
							-82.6101410519999,
							27.842721263000044
						],
						[
							-82.60991737299992,
							27.842305658000043
						],
						[
							-82.60988457399992,
							27.842244307000044
						],
						[
							-82.60972157399993,
							27.84187030700008
						],
						[
							-82.60970091399992,
							27.841818586000045
						],
						[
							-82.60966788399992,
							27.84170514500005
						],
						[
							-82.60950238899994,
							27.84095661200007
						],
						[
							-82.60941122399993,
							27.840667186000076
						],
						[
							-82.6093976809999,
							27.84061967000008
						],
						[
							-82.60929051799991,
							27.84020034000008
						],
						[
							-82.6092367359999,
							27.840187119000067
						],
						[
							-82.60915173599994,
							27.840160118000085
						],
						[
							-82.60911641399991,
							27.840148086000056
						],
						[
							-82.60897433899993,
							27.840081835000035
						],
						[
							-82.60884592699995,
							27.83999192000005
						],
						[
							-82.60873507899993,
							27.839881073000075
						],
						[
							-82.60864516399995,
							27.83975266100009
						],
						[
							-82.60860651599995,
							27.839669779000076
						],
						[
							-82.60854642599992,
							27.839652706000038
						],
						[
							-82.60843443699991,
							27.839609325000083
						],
						[
							-82.60835594799994,
							27.83957170000008
						],
						[
							-82.6082847749999,
							27.839576394000066
						],
						[
							-82.6082134589999,
							27.83957509000004
						],
						[
							-82.60814250399994,
							27.839567797000086
						],
						[
							-82.60807241399993,
							27.83955456700005
						],
						[
							-82.60800368299994,
							27.839535493000085
						],
						[
							-82.6079367989999,
							27.83951071100006
						],
						[
							-82.60787223299991,
							27.839480396000056
						],
						[
							-82.60771499999994,
							27.839494322000064
						],
						[
							-82.6075588349999,
							27.83948066000005
						],
						[
							-82.60740741399991,
							27.83944008700007
						],
						[
							-82.60726533899994,
							27.839373836000053
						],
						[
							-82.60717171699991,
							27.83931167500009
						],
						[
							-82.6070477159999,
							27.839217675000043
						],
						[
							-82.60701292699991,
							27.83918992100007
						],
						[
							-82.60695714999991,
							27.83913414400007
						],
						[
							-82.60691924199995,
							27.83913563100009
						],
						[
							-82.60688399999992,
							27.83913632200006
						],
						[
							-82.60672783399993,
							27.839122659000054
						],
						[
							-82.60657641299991,
							27.839082086000076
						],
						[
							-82.60643433899992,
							27.839015836000044
						],
						[
							-82.6063151809999,
							27.83893240100008
						],
						[
							-82.60620383399993,
							27.838922659000048
						],
						[
							-82.6060636709999,
							27.838886099000035
						],
						[
							-82.60590904299994,
							27.838832093000065
						],
						[
							-82.60583529999991,
							27.838802101000056
						],
						[
							-82.60576450699995,
							27.83876568900007
						],
						[
							-82.60569722199995,
							27.83872314300004
						],
						[
							-82.60563397399994,
							27.838674799000046
						],
						[
							-82.60557526199995,
							27.838621037000053
						],
						[
							-82.60552154899995,
							27.838562281000065
						],
						[
							-82.60547325599993,
							27.838498994000076
						],
						[
							-82.60543076499994,
							27.83843167300006
						],
						[
							-82.60534266299993,
							27.838339355000073
						],
						[
							-82.60529679199993,
							27.83828833700005
						],
						[
							-82.60525494399991,
							27.83823397000009
						],
						[
							-82.6052173619999,
							27.838176571000076
						],
						[
							-82.60518426499993,
							27.83811647400006
						],
						[
							-82.60515584599995,
							27.838054028000045
						],
						[
							-82.6051322699999,
							27.837989599000082
						],
						[
							-82.6050580829999,
							27.837760082000045
						],
						[
							-82.60501567099993,
							27.837704332000044
						],
						[
							-82.60497778199993,
							27.837645415000058
						],
						[
							-82.60494465099993,
							27.83758369600008
						],
						[
							-82.60491648499993,
							27.837519559000043
						],
						[
							-82.60489345799994,
							27.83745340300004
						],
						[
							-82.60487571399995,
							27.837385639000047
						],
						[
							-82.60486336299994,
							27.837316687000055
						],
						[
							-82.6048493639999,
							27.83721668700008
						],
						[
							-82.6048406779999,
							27.83709200000004
						],
						[
							-82.60484193999991,
							27.837044374000072
						],
						[
							-82.6048489399999,
							27.836912374000065
						],
						[
							-82.60486134099995,
							27.83680383500007
						],
						[
							-82.60490191399992,
							27.83665241400007
						],
						[
							-82.60496816499996,
							27.836510339000085
						],
						[
							-82.60505807999994,
							27.836381927000048
						],
						[
							-82.6051413109999,
							27.836295230000076
						],
						[
							-82.60518630999991,
							27.83625423000007
						],
						[
							-82.60521392699991,
							27.836230080000064
						],
						[
							-82.60527965599994,
							27.836184055000047
						],
						[
							-82.60528734099995,
							27.836111834000064
						],
						[
							-82.60532851999994,
							27.83595875900005
						],
						[
							-82.6053571249999,
							27.835881104000066
						],
						[
							-82.60542216399995,
							27.835742339000035
						],
						[
							-82.60545086199994,
							27.83569594200009
						],
						[
							-82.60549186199995,
							27.835633941000083
						],
						[
							-82.60553690199993,
							27.835571773000083
						],
						[
							-82.6055870799999,
							27.83551367200005
						],
						[
							-82.60564203099995,
							27.83546006200004
						],
						[
							-82.60570135299992,
							27.83541133400007
						],
						[
							-82.60571649399992,
							27.835399943000084
						],
						[
							-82.6057170389999,
							27.835393715000066
						],
						[
							-82.6066189679999,
							27.83602950100004
						],
						[
							-82.60697759599992,
							27.836049425000056
						],
						[
							-82.60749561299991,
							27.83606934800008
						],
						[
							-82.60879065699993,
							27.83602950100004
						],
						[
							-82.6109025749999,
							27.83602950100004
						],
						[
							-82.61191868599991,
							27.83602950100004
						],
						[
							-82.61233708499992,
							27.835929882000073
						],
						[
							-82.61251212799993,
							27.835923184000084
						],
						[
							-82.61272599999995,
							27.835915000000057
						],
						[
							-82.61272642599994,
							27.83590260300008
						],
						[
							-82.61410564999994,
							27.835939299000074
						],
						[
							-82.61410999999993,
							27.835600000000056
						],
						[
							-82.61779237599991,
							27.835600000000056
						],
						[
							-82.61924704899991,
							27.836203949000037
						],
						[
							-82.61929383599995,
							27.836271339000067
						],
						[
							-82.61932064199993,
							27.83632134800007
						],
						[
							-82.61938364199996,
							27.83644834800009
						],
						[
							-82.61942308599993,
							27.83654041300008
						],
						[
							-82.61944209099994,
							27.836598747000043
						],
						[
							-82.6194728509999,
							27.836706244000084
						],
						[
							-82.61950636899991,
							27.836729624000043
						],
						[
							-82.6195973689999,
							27.836787624000067
						],
						[
							-82.6196606229999,
							27.836831870000083
						],
						[
							-82.61971984999991,
							27.83688137600007
						],
						[
							-82.61977461299996,
							27.83693578000009
						],
						[
							-82.61982450999994,
							27.836994679000043
						],
						[
							-82.61986917099995,
							27.83705764000007
						],
						[
							-82.61990826899995,
							27.837124199000073
						],
						[
							-82.61994151499994,
							27.837193865000074
						],
						[
							-82.61997980299992,
							27.83728384200009
						],
						[
							-82.6200599949999,
							27.837337481000077
						],
						[
							-82.62011915099993,
							27.837380679000034
						],
						[
							-82.6201746129999,
							27.83742852800009
						],
						[
							-82.62022601699994,
							27.83748071100007
						],
						[
							-82.62027302599995,
							27.837536887000056
						],
						[
							-82.62031532999993,
							27.83759668600004
						],
						[
							-82.6203943399999,
							27.83807296200007
						],
						[
							-82.62050283299993,
							27.838481895000086
						],
						[
							-82.62061132499991,
							27.83888248300008
						],
						[
							-82.62068643599991,
							27.839216306000083
						],
						[
							-82.62077823699991,
							27.839324799000057
						],
						[
							-82.62096183999995,
							27.839433291000034
						],
						[
							-82.62114544199994,
							27.83960020300009
						],
						[
							-82.6212429489999,
							27.839713105000044
						],
						[
							-82.62130400799992,
							27.83978380600007
						],
						[
							-82.62133739099994,
							27.839959063000038
						],
						[
							-82.6212956629999,
							27.84030123200006
						],
						[
							-82.62122055299994,
							27.84067678300005
						],
						[
							-82.62110371499995,
							27.840852040000073
						],
						[
							-82.62083665599994,
							27.840910459000042
						],
						[
							-82.62060297999994,
							27.841002260000042
						],
						[
							-82.62021908299994,
							27.841185863000078
						],
						[
							-82.61986022299993,
							27.84131104700009
						],
						[
							-82.61945963499994,
							27.84139450300006
						],
						[
							-82.61915084899994,
							27.841519686000083
						],
						[
							-82.61900897399994,
							27.84198703900006
						],
						[
							-82.61880867999992,
							27.842270788000064
						],
						[
							-82.61881716099992,
							27.842615891000037
						],
						[
							-82.61879958599991,
							27.84262408700005
						],
						[
							-82.61878191699992,
							27.84263275300009
						],
						[
							-82.61871307299992,
							27.842696921000083
						],
						[
							-82.61858632999993,
							27.84279275700004
						],
						[
							-82.61789519099995,
							27.842919374000076
						],
						[
							-82.61720986499995,
							27.84293206500007
						],
						[
							-82.61648646499994,
							27.84349047900008
						],
						[
							-82.61617349399995,
							27.843867094000075
						],
						[
							-82.61602129499994,
							27.84389572400005
						],
						[
							-82.61594588999992,
							27.84390620100004
						],
						[
							-82.61586986899994,
							27.843910262000065
						],
						[
							-82.61579377699991,
							27.84390787800004
						],
						[
							-82.61571815899993,
							27.843899065000073
						],
						[
							-82.61564355799993,
							27.84388388800005
						],
						[
							-82.6155705079999,
							27.84386245400009
						],
						[
							-82.61546145999995,
							27.84382527000008
						],
						[
							-82.6153103389999,
							27.843755836000074
						],
						[
							-82.61517995499992,
							27.843664256000068
						],
						[
							-82.61503898399992,
							27.843544592000057
						],
						[
							-82.6149572189999,
							27.843465774000038
						],
						[
							-82.61486247599993,
							27.84336212900007
						],
						[
							-82.6148038849999,
							27.843317415000058
						],
						[
							-82.6147475869999,
							27.843289266000056
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Harbor Isle",
				"RegionID": "417189"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.64699999999993,
					27.84251000000006,
					-82.63862999999992,
					27.857540000000085
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.63868999999994,
							27.854360000000042
						],
						[
							-82.63868522899992,
							27.85390674300004
						],
						[
							-82.63868209599991,
							27.853609143000085
						],
						[
							-82.63867999999991,
							27.853410000000054
						],
						[
							-82.63867839099993,
							27.85326194600009
						],
						[
							-82.63867551499993,
							27.852997414000072
						],
						[
							-82.63867317699993,
							27.852782303000083
						],
						[
							-82.63866999999993,
							27.852490000000046
						],
						[
							-82.63866733999993,
							27.852253241000085
						],
						[
							-82.63866269599993,
							27.85183991400004
						],
						[
							-82.6386599999999,
							27.85160000000008
						],
						[
							-82.63866294499991,
							27.851343763000045
						],
						[
							-82.63866750599993,
							27.85094697100004
						],
						[
							-82.63866999999993,
							27.850730000000055
						],
						[
							-82.63866999999993,
							27.850550122000072
						],
						[
							-82.63866999999993,
							27.850269024000056
						],
						[
							-82.63866999999993,
							27.85002099700006
						],
						[
							-82.63866999999993,
							27.849840000000086
						],
						[
							-82.63866499599993,
							27.849607307000042
						],
						[
							-82.63866109399993,
							27.849425859000064
						],
						[
							-82.6386553989999,
							27.849161064000043
						],
						[
							-82.63864999999993,
							27.848665114000084
						],
						[
							-82.63864999999993,
							27.848251735000076
						],
						[
							-82.63864999999993,
							27.84783835500008
						],
						[
							-82.6386599999999,
							27.847530000000063
						],
						[
							-82.63864755599991,
							27.84711071600009
						],
						[
							-82.63864519399993,
							27.846763494000072
						],
						[
							-82.6386427189999,
							27.84639973700007
						],
						[
							-82.63864069499994,
							27.84610211800009
						],
						[
							-82.6386399999999,
							27.846000000000064
						],
						[
							-82.6386399999999,
							27.84562264400006
						],
						[
							-82.6386399999999,
							27.845230000000072
						],
						[
							-82.6386399999999,
							27.845027378000054
						],
						[
							-82.6386399999999,
							27.84474226000009
						],
						[
							-82.6386399999999,
							27.844597464000064
						],
						[
							-82.6386399999999,
							27.844250225000053
						],
						[
							-82.6386399999999,
							27.843930000000057
						],
						[
							-82.6386399999999,
							27.843522678000056
						],
						[
							-82.63862999999992,
							27.843010088000085
						],
						[
							-82.6387499999999,
							27.842580000000055
						],
						[
							-82.63909709099994,
							27.84257269300008
						],
						[
							-82.63936489399993,
							27.842567055000075
						],
						[
							-82.6398174549999,
							27.84256000000005
						],
						[
							-82.64037300899992,
							27.84256000000005
						],
						[
							-82.64075999999996,
							27.84256000000005
						],
						[
							-82.64115489799991,
							27.842561955000065
						],
						[
							-82.64183389099992,
							27.842565316000048
						],
						[
							-82.64238943099991,
							27.84256806600007
						],
						[
							-82.6427799999999,
							27.84257000000008
						],
						[
							-82.64311064899994,
							27.842561785000044
						],
						[
							-82.64358360599994,
							27.842550035000045
						],
						[
							-82.64432388799992,
							27.842531643000086
						],
						[
							-82.6448499999999,
							27.84253000000007
						],
						[
							-82.64518786799994,
							27.842526604000057
						],
						[
							-82.64559914099993,
							27.842522471000052
						],
						[
							-82.64588779699994,
							27.842519570000036
						],
						[
							-82.64654616399991,
							27.84251295300004
						],
						[
							-82.6468999999999,
							27.84251000000006
						],
						[
							-82.64689549399992,
							27.842600128000072
						],
						[
							-82.64688999999993,
							27.842710000000068
						],
						[
							-82.64689448899992,
							27.842990187000055
						],
						[
							-82.6468999999999,
							27.843150000000037
						],
						[
							-82.64690123799994,
							27.843349341000078
						],
						[
							-82.64690306499995,
							27.84364340500008
						],
						[
							-82.64690722499995,
							27.844313215000057
						],
						[
							-82.64690999999993,
							27.844760000000065
						],
						[
							-82.64690840599991,
							27.844917790000068
						],
						[
							-82.64690428099995,
							27.845326185000093
						],
						[
							-82.6468999999999,
							27.846159380000078
						],
						[
							-82.64690393599994,
							27.84671482600004
						],
						[
							-82.64691186699991,
							27.847107426000036
						],
						[
							-82.64691999999991,
							27.847510000000057
						],
						[
							-82.64692000299993,
							27.847510328000055
						],
						[
							-82.64692111099993,
							27.847634419000087
						],
						[
							-82.64692348999995,
							27.84790090300004
						],
						[
							-82.6469265259999,
							27.848240900000064
						],
						[
							-82.64692999999994,
							27.848681989000056
						],
						[
							-82.64692999999994,
							27.849077151000074
						],
						[
							-82.64692999999994,
							27.849330000000066
						],
						[
							-82.64693219799994,
							27.849435491000065
						],
						[
							-82.64693698199994,
							27.849665137000045
						],
						[
							-82.64693999999992,
							27.849810000000048
						],
						[
							-82.64693999999992,
							27.84998694500007
						],
						[
							-82.64693999999992,
							27.85017993100007
						],
						[
							-82.64693999999992,
							27.850403361000076
						],
						[
							-82.64693999999992,
							27.850531937000085
						],
						[
							-82.64693999999992,
							27.850680000000068
						],
						[
							-82.64693908499993,
							27.850761410000075
						],
						[
							-82.6469377439999,
							27.85088078700005
						],
						[
							-82.64693547299993,
							27.851082913000084
						],
						[
							-82.64693289299993,
							27.85131248500005
						],
						[
							-82.6469311379999,
							27.851468697000087
						],
						[
							-82.64692999999994,
							27.851570000000038
						],
						[
							-82.64692999999994,
							27.851725860000045
						],
						[
							-82.64692999999994,
							27.851964644000077
						],
						[
							-82.64692999999994,
							27.85228608500006
						],
						[
							-82.64692999999994,
							27.85248000000007
						],
						[
							-82.64693119999993,
							27.852589167000076
						],
						[
							-82.64693382099995,
							27.85282772100004
						],
						[
							-82.64693523699992,
							27.852956585000072
						],
						[
							-82.6469368519999,
							27.853103511000086
						],
						[
							-82.64693999999992,
							27.853390000000047
						],
						[
							-82.6469413929999,
							27.85351674200007
						],
						[
							-82.64694391599994,
							27.85374631500008
						],
						[
							-82.64694623799994,
							27.853957623000042
						],
						[
							-82.64694815599995,
							27.85413219900005
						],
						[
							-82.64694999999995,
							27.85430000000008
						],
						[
							-82.64699999999993,
							27.85430000000008
						],
						[
							-82.64694999999995,
							27.854563325000072
						],
						[
							-82.64694999999995,
							27.854940663000036
						],
						[
							-82.64694999999995,
							27.85520000000008
						],
						[
							-82.64694999999995,
							27.855405080000082
						],
						[
							-82.64694999999995,
							27.855570000000057
						],
						[
							-82.64688999999993,
							27.855753392000054
						],
						[
							-82.64688999999993,
							27.85604365200004
						],
						[
							-82.64688999999993,
							27.856508069000085
						],
						[
							-82.64688999999993,
							27.856827355000064
						],
						[
							-82.6468999999999,
							27.857470000000035
						],
						[
							-82.64664194699992,
							27.857470000000035
						],
						[
							-82.64597434799992,
							27.857470000000035
						],
						[
							-82.64548090599993,
							27.857470000000035
						],
						[
							-82.64489999999995,
							27.857480000000066
						],
						[
							-82.64455235299994,
							27.85748508800009
						],
						[
							-82.6439429369999,
							27.85749400600008
						],
						[
							-82.64342057999994,
							27.857501650000074
						],
						[
							-82.64315897699993,
							27.857505478000064
						],
						[
							-82.6428499999999,
							27.857510000000048
						],
						[
							-82.64246210899995,
							27.85751320600008
						],
						[
							-82.64191065199992,
							27.85751776300009
						],
						[
							-82.64163999999994,
							27.85752000000008
						],
						[
							-82.64118506999995,
							27.857525416000048
						],
						[
							-82.6407999999999,
							27.857530000000054
						],
						[
							-82.64016923899993,
							27.857535391000056
						],
						[
							-82.63958862099992,
							27.857540000000085
						],
						[
							-82.63909517799993,
							27.857540000000085
						],
						[
							-82.63882999999993,
							27.857540000000085
						],
						[
							-82.63869999999991,
							27.857536708000055
						],
						[
							-82.63869999999991,
							27.857530000000054
						],
						[
							-82.63869999999991,
							27.857021055000075
						],
						[
							-82.63869999999991,
							27.85660000000007
						],
						[
							-82.63869999999991,
							27.856081651000068
						],
						[
							-82.63869999999991,
							27.85569000000004
						],
						[
							-82.63869648499991,
							27.85551074300008
						],
						[
							-82.63869291399993,
							27.855328602000043
						],
						[
							-82.63868999999994,
							27.855180000000075
						],
						[
							-82.63868999999994,
							27.854998081000076
						],
						[
							-82.63868999999994,
							27.854634308000072
						],
						[
							-82.63868999999994,
							27.854360000000042
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Gateway",
				"RegionID": "417203"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.94876491199994,
					27.99675249900008,
					-81.94325174399995,
					28.00183452300007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.94444446299991,
							27.99840658900007
						],
						[
							-81.94436963099992,
							27.99680412300006
						],
						[
							-81.94578576099991,
							27.996804342000075
						],
						[
							-81.94872740199992,
							27.99675249900008
						],
						[
							-81.94872690999995,
							27.997126009000056
						],
						[
							-81.94872990999994,
							27.99751700900004
						],
						[
							-81.94873390999993,
							27.998095010000043
						],
						[
							-81.94873790999992,
							27.998481009000045
						],
						[
							-81.94873890999992,
							27.99859800900009
						],
						[
							-81.94874290899992,
							27.998949009000057
						],
						[
							-81.94875690999993,
							27.99999401000008
						],
						[
							-81.94876290899992,
							28.00034301000005
						],
						[
							-81.94876290899992,
							28.00080901000007
						],
						[
							-81.94876491199994,
							28.00183452300007
						],
						[
							-81.94418339299995,
							28.00179750500007
						],
						[
							-81.94377339499994,
							28.001462039000046
						],
						[
							-81.9441091089999,
							27.999896899000078
						],
						[
							-81.94325174399995,
							27.999412592000056
						],
						[
							-81.94444446299991,
							27.99840658900007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Polk",
				"City": "Lakeland",
				"Name": "Raintree",
				"RegionID": "343456"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.93850345499993,
					28.033672678000073,
					-81.9253556779999,
					28.040941322000037
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.92572216399992,
							28.038803661000088
						],
						[
							-81.9256990479999,
							28.038761005000083
						],
						[
							-81.9255640479999,
							28.038495004000083
						],
						[
							-81.92555942299992,
							28.03848576000007
						],
						[
							-81.92553513499992,
							28.03843215500007
						],
						[
							-81.92551716799994,
							28.038385092000055
						],
						[
							-81.92546116799991,
							28.03822509200006
						],
						[
							-81.92545840499993,
							28.03821707800006
						],
						[
							-81.92544132199993,
							28.038160762000075
						],
						[
							-81.92542795899993,
							28.03810344900006
						],
						[
							-81.92541931499994,
							28.038052336000078
						],
						[
							-81.92536431399992,
							28.03765833600005
						],
						[
							-81.92536337099995,
							28.03765138500006
						],
						[
							-81.92535760299995,
							28.037592819000054
						],
						[
							-81.9253556779999,
							28.03753400000005
						],
						[
							-81.92535760299995,
							28.037475182000037
						],
						[
							-81.92535881199991,
							28.03745897600004
						],
						[
							-81.92541381299992,
							28.03680197500006
						],
						[
							-81.92541837199991,
							28.03675961500005
						],
						[
							-81.92542795899993,
							28.03670155100008
						],
						[
							-81.92543516399991,
							28.03666857400009
						],
						[
							-81.92551116399994,
							28.036349575000088
						],
						[
							-81.9255173219999,
							28.036325239000064
						],
						[
							-81.92553440499995,
							28.03626892300008
						],
						[
							-81.92555513499991,
							28.036213845000077
						],
						[
							-81.92557942299993,
							28.036160240000072
						],
						[
							-81.92558876299995,
							28.03614183600007
						],
						[
							-81.92567176199992,
							28.035982836000077
						],
						[
							-81.92569016399995,
							28.035949339000073
						],
						[
							-81.9257212409999,
							28.035899364000045
						],
						[
							-81.92575551899995,
							28.03585152800008
						],
						[
							-81.92576524099991,
							28.035839086000067
						],
						[
							-81.9264892409999,
							28.03492908600009
						],
						[
							-81.92651685399994,
							28.034896036000077
						],
						[
							-81.92655708299992,
							28.034853084000076
						],
						[
							-81.9265633569999,
							28.03484687100007
						],
						[
							-81.92692335699991,
							28.034493871000052
						],
						[
							-81.92696003599991,
							28.03445985400009
						],
						[
							-81.92698738399991,
							28.034436817000085
						],
						[
							-81.92750038399993,
							28.034021816000063
						],
						[
							-81.92751852799995,
							28.034007520000046
						],
						[
							-81.92756636399992,
							28.033973241000073
						],
						[
							-81.92761633899994,
							28.033942164000052
						],
						[
							-81.9276393689999,
							28.033929315000083
						],
						[
							-81.92781936799992,
							28.03383231500004
						],
						[
							-81.92784823999995,
							28.033817423000073
						],
						[
							-81.9279018439999,
							28.033793135000053
						],
						[
							-81.92795692199991,
							28.033772405000036
						],
						[
							-81.92801323799995,
							28.03375532200005
						],
						[
							-81.9280705509999,
							28.033741958000064
						],
						[
							-81.92807797199993,
							28.033740514000044
						],
						[
							-81.9282409729999,
							28.033709514000066
						],
						[
							-81.92829161499992,
							28.033701371000067
						],
						[
							-81.92835018199992,
							28.03369560300007
						],
						[
							-81.92836944699991,
							28.033694548000085
						],
						[
							-81.92884644799994,
							28.03367354900007
						],
						[
							-81.92888599999992,
							28.033672678000073
						],
						[
							-81.92892631299992,
							28.033673582000063
						],
						[
							-81.92923831299993,
							28.033687582000084
						],
						[
							-81.92925681899993,
							28.033688604000076
						],
						[
							-81.92931538499994,
							28.03369437200007
						],
						[
							-81.9293685099999,
							28.03370299000005
						],
						[
							-81.92951350999994,
							28.033730990000038
						],
						[
							-81.92951844899994,
							28.03373195800009
						],
						[
							-81.9295757619999,
							28.033745321000083
						],
						[
							-81.92963207699995,
							28.03376240500006
						],
						[
							-81.92968715599994,
							28.03378313400009
						],
						[
							-81.9297151429999,
							28.03379528700009
						],
						[
							-81.9302760619999,
							28.034050251000053
						],
						[
							-81.93127707299993,
							28.033935408000048
						],
						[
							-81.93544838699995,
							28.033948372000054
						],
						[
							-81.93568190999991,
							28.034165010000038
						],
						[
							-81.93675490899994,
							28.035123011000053
						],
						[
							-81.93773490899991,
							28.036054010000043
						],
						[
							-81.93830190899992,
							28.03656201000007
						],
						[
							-81.93850345499993,
							28.036742627000084
						],
						[
							-81.93687663899993,
							28.036728432000075
						],
						[
							-81.93687677199995,
							28.03770002300007
						],
						[
							-81.93687690599995,
							28.038789367000053
						],
						[
							-81.93602293599992,
							28.038789104000045
						],
						[
							-81.93605251999992,
							28.040643921000083
						],
						[
							-81.93370067399991,
							28.040643559000046
						],
						[
							-81.9332156939999,
							28.039848790000068
						],
						[
							-81.93319590199991,
							28.03973466000008
						],
						[
							-81.93319390199991,
							28.03972264300006
						],
						[
							-81.93312231399995,
							28.039273784000045
						],
						[
							-81.9329922579999,
							28.039097199000082
						],
						[
							-81.9327348409999,
							28.038786865000077
						],
						[
							-81.93263736199992,
							28.038945606000084
						],
						[
							-81.93261875899992,
							28.038974636000034
						],
						[
							-81.93258938499991,
							28.039016020000076
						],
						[
							-81.93210438499996,
							28.039660020000042
						],
						[
							-81.93209947999992,
							28.03966647200008
						],
						[
							-81.93206214599991,
							28.03971196400005
						],
						[
							-81.93202191599994,
							28.03975491600005
						],
						[
							-81.93201629299995,
							28.03976049000005
						],
						[
							-81.93161529399993,
							28.040154490000077
						],
						[
							-81.93157796399993,
							28.040189146000046
						],
						[
							-81.93155802099996,
							28.04020612800008
						],
						[
							-81.93128102099992,
							28.04043512900006
						],
						[
							-81.93125547199992,
							28.040455481000038
						],
						[
							-81.9312076359999,
							28.04048975900008
						],
						[
							-81.93119728999994,
							28.040496570000073
						],
						[
							-81.93094128999991,
							28.040662570000052
						],
						[
							-81.93090166099995,
							28.040686836000077
						],
						[
							-81.93084975999994,
							28.040714577000074
						],
						[
							-81.93082686399994,
							28.04072547000004
						],
						[
							-81.93064586499992,
							28.04080847000006
						],
						[
							-81.93061515599993,
							28.040821865000055
						],
						[
							-81.93056007799993,
							28.040842595000072
						],
						[
							-81.93050376199994,
							28.04085967900005
						],
						[
							-81.93044644899993,
							28.040873042000044
						],
						[
							-81.93042840999995,
							28.040876439000044
						],
						[
							-81.93015840899994,
							28.040924439000037
						],
						[
							-81.9301183849999,
							28.04093062800007
						],
						[
							-81.9300598179999,
							28.040936396000063
						],
						[
							-81.93000886599992,
							28.040938287000074
						],
						[
							-81.92966586599995,
							28.040941287000066
						],
						[
							-81.9296579999999,
							28.040941322000037
						],
						[
							-81.92961542799992,
							28.040940314000068
						],
						[
							-81.92940442799994,
							28.040930314000036
						],
						[
							-81.92938818199991,
							28.04092939700007
						],
						[
							-81.92932961499992,
							28.040923628000087
						],
						[
							-81.9292757529999,
							28.040914868000073
						],
						[
							-81.92904375299992,
							28.040869867000083
						],
						[
							-81.9290395509999,
							28.040869042000054
						],
						[
							-81.92898223899994,
							28.04085567800007
						],
						[
							-81.92892592299995,
							28.040838595000082
						],
						[
							-81.9289229609999,
							28.040837584000087
						],
						[
							-81.92785696099992,
							28.040471584000045
						],
						[
							-81.92780484399992,
							28.04045186500008
						],
						[
							-81.9277512399999,
							28.04042757800005
						],
						[
							-81.92774608399992,
							28.04042501500004
						],
						[
							-81.9273030839999,
							28.040203014000042
						],
						[
							-81.92725633899994,
							28.04017783600006
						],
						[
							-81.92723879099992,
							28.040167437000036
						],
						[
							-81.92698879099993,
							28.04001543700008
						],
						[
							-81.92695636399992,
							28.039994759000084
						],
						[
							-81.92691557599996,
							28.039965834000043
						],
						[
							-81.92650057599991,
							28.03965383400004
						],
						[
							-81.92649352699993,
							28.039648480000043
						],
						[
							-81.92646137499992,
							28.03962261500004
						],
						[
							-81.92614937499991,
							28.03935961500008
						],
						[
							-81.92613603599995,
							28.03934814600007
						],
						[
							-81.9260930829999,
							28.03930791600004
						],
						[
							-81.92605285399992,
							28.03926496400004
						],
						[
							-81.92601551999991,
							28.03921947200007
						],
						[
							-81.92599812499994,
							28.039196024000034
						],
						[
							-81.92577012499993,
							28.03887802400004
						],
						[
							-81.92575324099994,
							28.038853637000045
						],
						[
							-81.92572216399992,
							28.038803661000088
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Polk",
				"City": "Lakeland",
				"Name": "Lake Bonny Park",
				"RegionID": "343457"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.97798191099992,
					28.025850293000076,
					-81.97307893899995,
					28.041805946000068
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.97344008499994,
							28.025956026000074
						],
						[
							-81.97341901199991,
							28.02587101100005
						],
						[
							-81.97401891099992,
							28.02587501000005
						],
						[
							-81.97460890999992,
							28.025876011000037
						],
						[
							-81.97507690999994,
							28.02587801100009
						],
						[
							-81.97559791099991,
							28.025881010000038
						],
						[
							-81.97574790999994,
							28.025881010000038
						],
						[
							-81.97771191099991,
							28.025854010000046
						],
						[
							-81.97797316099991,
							28.025850293000076
						],
						[
							-81.97798191099992,
							28.031838010000058
						],
						[
							-81.97797927099992,
							28.032865580000077
						],
						[
							-81.97795849599993,
							28.04096102200009
						],
						[
							-81.97521490999992,
							28.041486011000075
						],
						[
							-81.9735750719999,
							28.041805946000068
						],
						[
							-81.97356191299991,
							28.04129301200004
						],
						[
							-81.97358190999995,
							28.04120800800007
						],
						[
							-81.97358891099992,
							28.040559010000038
						],
						[
							-81.97358791099992,
							28.039924011000043
						],
						[
							-81.97357791099995,
							28.03930401100007
						],
						[
							-81.97357191099991,
							28.03852001100006
						],
						[
							-81.9735749109999,
							28.03771001000007
						],
						[
							-81.97357804399991,
							28.037345041000037
						],
						[
							-81.97357890899991,
							28.03723601100006
						],
						[
							-81.97357804699993,
							28.03684701000009
						],
						[
							-81.9735769099999,
							28.036334011000065
						],
						[
							-81.97357290999992,
							28.03544001100005
						],
						[
							-81.97356490999994,
							28.03451601000006
						],
						[
							-81.9735589089999,
							28.033602011000085
						],
						[
							-81.97355390999991,
							28.03268901100006
						],
						[
							-81.9735559099999,
							28.031764010000074
						],
						[
							-81.97356290999994,
							28.030251011000075
						],
						[
							-81.97356890999993,
							28.029485011000077
						],
						[
							-81.97357790899991,
							28.028682010000068
						],
						[
							-81.97358790999994,
							28.027859010000043
						],
						[
							-81.97357390899992,
							28.027460011000073
						],
						[
							-81.97357590999992,
							28.02725600900004
						],
						[
							-81.97357691299993,
							28.02716201000004
						],
						[
							-81.97360686499991,
							28.02707698200004
						],
						[
							-81.9736398629999,
							28.02703294400004
						],
						[
							-81.97370387099994,
							28.027008383000066
						],
						[
							-81.97326882399994,
							28.026917163000064
						],
						[
							-81.97307893899995,
							28.026714061000064
						],
						[
							-81.97344008499994,
							28.025956026000074
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Polk",
				"City": "Lakeland",
				"Name": "Central Avenue",
				"RegionID": "343471"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.20146899999992,
					26.091465000000085,
					-80.1857959699999,
					26.10560618900007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.18839585299992,
							26.102883189000067
						],
						[
							-80.19094662099992,
							26.10277599200009
						],
						[
							-80.19137338699994,
							26.10278714100008
						],
						[
							-80.19131503299991,
							26.101103385000048
						],
						[
							-80.19314001099991,
							26.100999481000088
						],
						[
							-80.19311483799993,
							26.100664862000087
						],
						[
							-80.19309981599991,
							26.099949802000086
						],
						[
							-80.19306576499991,
							26.099202693000052
						],
						[
							-80.19303972599994,
							26.09846359700009
						],
						[
							-80.19300767899995,
							26.097746534000066
						],
						[
							-80.1929856459999,
							26.097019455000066
						],
						[
							-80.19295560099995,
							26.096301391000054
						],
						[
							-80.19292455599992,
							26.095539260000066
						],
						[
							-80.19288549799995,
							26.094610883000087
						],
						[
							-80.1928324189999,
							26.093369041000074
						],
						[
							-80.19278621899991,
							26.091882705000046
						],
						[
							-80.1927894069999,
							26.09188281300004
						],
						[
							-80.19296879699993,
							26.091875842000036
						],
						[
							-80.19324159699994,
							26.09186949800005
						],
						[
							-80.19351419799995,
							26.09186315800008
						],
						[
							-80.1937270809999,
							26.09185703500009
						],
						[
							-80.19387241899994,
							26.09185144500009
						],
						[
							-80.1941277439999,
							26.091841625000086
						],
						[
							-80.19441761699994,
							26.091834841000036
						],
						[
							-80.1945539319999,
							26.091832001000057
						],
						[
							-80.19474184599994,
							26.091826092000076
						],
						[
							-80.1948269259999,
							26.091822471000057
						],
						[
							-80.19501446399994,
							26.091814491000036
						],
						[
							-80.19526125699991,
							26.091804768000088
						],
						[
							-80.1955938449999,
							26.09179245000007
						],
						[
							-80.19581535499992,
							26.091787012000054
						],
						[
							-80.19605457799992,
							26.091782412000043
						],
						[
							-80.19617612499991,
							26.09177992800005
						],
						[
							-80.19618238699991,
							26.09177868400008
						],
						[
							-80.1966540869999,
							26.091765664000036
						],
						[
							-80.19766258199991,
							26.091735619000076
						],
						[
							-80.19856291699995,
							26.09171458900005
						],
						[
							-80.19867708599992,
							26.091738624000072
						],
						[
							-80.1988303139999,
							26.091792706000035
						],
						[
							-80.19899055699995,
							26.091917075000083
						],
						[
							-80.19913576699992,
							26.091786694000064
						],
						[
							-80.19921087699993,
							26.09173161700005
						],
						[
							-80.1992709669999,
							26.091711584000052
						],
						[
							-80.1993260399999,
							26.09169150100007
						],
						[
							-80.19967756999995,
							26.091667519000055
						],
						[
							-80.2005059999999,
							26.091652069000077
						],
						[
							-80.2005059999999,
							26.091503000000046
						],
						[
							-80.2010689999999,
							26.091465000000085
						],
						[
							-80.20110355399993,
							26.09232886300009
						],
						[
							-80.2011370109999,
							26.093165282000086
						],
						[
							-80.20116899999994,
							26.093965000000082
						],
						[
							-80.20116899999994,
							26.095230281000056
						],
						[
							-80.20116899999994,
							26.09526500000004
						],
						[
							-80.20116899999994,
							26.096865000000037
						],
						[
							-80.20123183399994,
							26.09743050700007
						],
						[
							-80.20126899999991,
							26.097765000000038
						],
						[
							-80.20126899999991,
							26.09865528100005
						],
						[
							-80.20126899999991,
							26.098865000000046
						],
						[
							-80.20126899999991,
							26.098910269000044
						],
						[
							-80.20126899999991,
							26.100464000000045
						],
						[
							-80.20126899999991,
							26.101364000000046
						],
						[
							-80.20136899999994,
							26.10266400000006
						],
						[
							-80.20142499999992,
							26.103448000000075
						],
						[
							-80.20142957199994,
							26.103512008000056
						],
						[
							-80.20146899999992,
							26.10406400000005
						],
						[
							-80.20146899999992,
							26.104134814000076
						],
						[
							-80.20146899999992,
							26.10436400000009
						],
						[
							-80.20146899999992,
							26.104469238000036
						],
						[
							-80.2013660749999,
							26.104472508000075
						],
						[
							-80.20078320999994,
							26.10448953300005
						],
						[
							-80.19226657999991,
							26.10467781400007
						],
						[
							-80.19056705899993,
							26.10472087900007
						],
						[
							-80.18582903599992,
							26.10560618900007
						],
						[
							-80.18581400999994,
							26.10455262700009
						],
						[
							-80.18581400999994,
							26.103919688000076
						],
						[
							-80.18581400999994,
							26.103828553000085
						],
						[
							-80.18579898699994,
							26.103073433000077
						],
						[
							-80.1857959699999,
							26.102933144000076
						],
						[
							-80.18839585299992,
							26.102883189000067
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Sunset",
				"RegionID": "275630"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.58898090299994,
					30.18304806500004,
					-81.55610290999994,
					30.220936016000056
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.57146590399992,
							30.220936016000056
						],
						[
							-81.57136790899995,
							30.22079001100008
						],
						[
							-81.57127590999994,
							30.22066501100005
						],
						[
							-81.57111090899991,
							30.22041701200004
						],
						[
							-81.56941300599993,
							30.21780784300006
						],
						[
							-81.5692498549999,
							30.21780284700009
						],
						[
							-81.56912187699993,
							30.217902191000064
						],
						[
							-81.5688389099999,
							30.21744601100005
						],
						[
							-81.56696590999991,
							30.214579012000062
						],
						[
							-81.56596390899995,
							30.21303701100004
						],
						[
							-81.56461090999996,
							30.210983012000046
						],
						[
							-81.56405290899994,
							30.21013501100009
						],
						[
							-81.56370190899992,
							30.20957901200006
						],
						[
							-81.56297790899993,
							30.208482011000058
						],
						[
							-81.5610269089999,
							30.205488011000057
						],
						[
							-81.5577789109999,
							30.200498012000082
						],
						[
							-81.5576679099999,
							30.20034701100008
						],
						[
							-81.55719190999991,
							30.199616011000042
						],
						[
							-81.55711190999995,
							30.199491011000077
						],
						[
							-81.55703891199994,
							30.19939301200009
						],
						[
							-81.5569109089999,
							30.199129012000068
						],
						[
							-81.55674090999992,
							30.198769011000078
						],
						[
							-81.55652990999994,
							30.198262012000043
						],
						[
							-81.55641290999995,
							30.197915012000067
						],
						[
							-81.5563469089999,
							30.19767001100007
						],
						[
							-81.5562729099999,
							30.19735201100008
						],
						[
							-81.55617590999992,
							30.196876011000086
						],
						[
							-81.55612491099993,
							30.196679009000036
						],
						[
							-81.55612190999994,
							30.19651401200008
						],
						[
							-81.55611190899992,
							30.196145011000052
						],
						[
							-81.55610290999994,
							30.195917011000063
						],
						[
							-81.55611190899992,
							30.195625011000065
						],
						[
							-81.5561159099999,
							30.195398012000055
						],
						[
							-81.55612490999995,
							30.195152011000065
						],
						[
							-81.55615690999991,
							30.194920011000082
						],
						[
							-81.5562138119999,
							30.19460485600007
						],
						[
							-81.55639600799992,
							30.19465516600008
						],
						[
							-81.55664690999993,
							30.193156011000042
						],
						[
							-81.55745690899994,
							30.18849701100004
						],
						[
							-81.5574958389999,
							30.188294851000077
						],
						[
							-81.55765198699993,
							30.188399157000052
						],
						[
							-81.55765890999993,
							30.188258012000063
						],
						[
							-81.55798890999995,
							30.186406012000077
						],
						[
							-81.55803590999994,
							30.186157011000038
						],
						[
							-81.55808890999992,
							30.18596201200006
						],
						[
							-81.55818290899992,
							30.185433011000043
						],
						[
							-81.55825590899993,
							30.184948011000074
						],
						[
							-81.55830097599994,
							30.18472994300004
						],
						[
							-81.55840790899992,
							30.18414501100005
						],
						[
							-81.55849690999992,
							30.18366001100009
						],
						[
							-81.55859684399991,
							30.18304806500004
						],
						[
							-81.56166590799995,
							30.185655010000065
						],
						[
							-81.56242690699992,
							30.186311010000058
						],
						[
							-81.56466290799995,
							30.188694010000063
						],
						[
							-81.5711759479999,
							30.195644977000082
						],
						[
							-81.57876385999992,
							30.206107097000086
						],
						[
							-81.58134490999994,
							30.209730011000094
						],
						[
							-81.58409090899994,
							30.213630011000074
						],
						[
							-81.58898090299994,
							30.220636010000078
						],
						[
							-81.58650890799993,
							30.22066101000007
						],
						[
							-81.58587590699995,
							30.220667011000046
						],
						[
							-81.58574190699994,
							30.22067501000004
						],
						[
							-81.5856199079999,
							30.220678010000082
						],
						[
							-81.5853489079999,
							30.220678010000082
						],
						[
							-81.58514690699992,
							30.220682010000072
						],
						[
							-81.5844029079999,
							30.220680010000077
						],
						[
							-81.5829629079999,
							30.220715010000053
						],
						[
							-81.58127190699992,
							30.220723010000082
						],
						[
							-81.5804919069999,
							30.220727010000072
						],
						[
							-81.57946290699994,
							30.220732010000063
						],
						[
							-81.5786209069999,
							30.220736011000042
						],
						[
							-81.57646090799994,
							30.220746010000084
						],
						[
							-81.57514190799992,
							30.220762010000048
						],
						[
							-81.5750188419999,
							30.220762836000066
						],
						[
							-81.5749307399999,
							30.220844938000084
						],
						[
							-81.57493203899992,
							30.220904139000083
						],
						[
							-81.5745469069999,
							30.220911011000055
						],
						[
							-81.57440090699993,
							30.220914011000048
						],
						[
							-81.57317890699994,
							30.220909010000074
						],
						[
							-81.57266290799994,
							30.220919010000046
						],
						[
							-81.57211990799993,
							30.220927010000082
						],
						[
							-81.57146590399992,
							30.220936016000056
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Swamp",
				"RegionID": "275643"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.5142375996926,
					27.933853958581906,
					-82.50580166408014,
					27.94500001372014
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.50601920018643,
							27.94499065357646
						],
						[
							-82.50580431887875,
							27.937586733160146
						],
						[
							-82.50580426312077,
							27.935818492481378
						],
						[
							-82.50580166408014,
							27.933853958581906
						],
						[
							-82.5081300259011,
							27.933870006084256
						],
						[
							-82.51211998679459,
							27.93387999935065
						],
						[
							-82.5128318325564,
							27.933868405291072
						],
						[
							-82.5142375996926,
							27.933876209607643
						],
						[
							-82.51420477803583,
							27.943175327993536
						],
						[
							-82.5140112835053,
							27.94474104494865
						],
						[
							-82.51112000095254,
							27.944699998092602
						],
						[
							-82.51001999880975,
							27.94500001372014
						],
						[
							-82.50601920018643,
							27.94499065357646
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Swann Estates",
				"RegionID": "275645"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.67224907999992,
					30.37385290900005,
					-81.64720690599995,
					30.39388450300004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.6477919049999,
							30.389516009000094
						],
						[
							-81.64789890499992,
							30.389106008000056
						],
						[
							-81.64794190599991,
							30.38895000900004
						],
						[
							-81.64799390499992,
							30.388743008000066
						],
						[
							-81.64801790599995,
							30.388649009000062
						],
						[
							-81.64809390499994,
							30.38839500800009
						],
						[
							-81.64849090599995,
							30.386892008000075
						],
						[
							-81.64862790599994,
							30.386385008000047
						],
						[
							-81.64887990599993,
							30.38539700900009
						],
						[
							-81.6490099049999,
							30.384890009000063
						],
						[
							-81.64933790499992,
							30.383669008000084
						],
						[
							-81.64936790599995,
							30.383551009000087
						],
						[
							-81.64940690599991,
							30.38340800900005
						],
						[
							-81.6496869049999,
							30.382385008000085
						],
						[
							-81.64979590599995,
							30.38190300900004
						],
						[
							-81.64993990599993,
							30.381435009000086
						],
						[
							-81.65005590599992,
							30.380939007000055
						],
						[
							-81.6501569049999,
							30.380586008000083
						],
						[
							-81.65019990499991,
							30.380439009000046
						],
						[
							-81.6503359049999,
							30.379902008000045
						],
						[
							-81.65051790599995,
							30.379199008000057
						],
						[
							-81.6505819059999,
							30.378996009000048
						],
						[
							-81.65061590499994,
							30.378895009000072
						],
						[
							-81.65072590499994,
							30.378450008000073
						],
						[
							-81.65081790499994,
							30.37807100800006
						],
						[
							-81.65087582699994,
							30.377847968000086
						],
						[
							-81.65338190599994,
							30.377970008000094
						],
						[
							-81.65374590699992,
							30.377968008000042
						],
						[
							-81.65426990599991,
							30.37796500800005
						],
						[
							-81.65484990699993,
							30.377930008000074
						],
						[
							-81.65524390699994,
							30.377886009000065
						],
						[
							-81.65551690599995,
							30.377852008000048
						],
						[
							-81.6559819069999,
							30.37777300800008
						],
						[
							-81.65665290599992,
							30.377637008000082
						],
						[
							-81.65679090599993,
							30.37759100900007
						],
						[
							-81.6577879059999,
							30.37726200900005
						],
						[
							-81.65942990799994,
							30.37676000600004
						],
						[
							-81.66045690699991,
							30.376206009000043
						],
						[
							-81.66124590699991,
							30.375897009000084
						],
						[
							-81.66600790699994,
							30.37429900900008
						],
						[
							-81.6678799149999,
							30.37385290900005
						],
						[
							-81.66798390499991,
							30.373994008000068
						],
						[
							-81.66844190499995,
							30.37461900800008
						],
						[
							-81.66882290899991,
							30.375280006000086
						],
						[
							-81.66885390599992,
							30.375307008000046
						],
						[
							-81.66893790499995,
							30.37538900900006
						],
						[
							-81.66930390599994,
							30.375895009000086
						],
						[
							-81.66976190499992,
							30.37650500900008
						],
						[
							-81.67021190499992,
							30.377110008000045
						],
						[
							-81.67065390599993,
							30.37771600800005
						],
						[
							-81.67108890499992,
							30.378321008000057
						],
						[
							-81.67153890499992,
							30.378927008000062
						],
						[
							-81.67198890499992,
							30.379538009000047
						],
						[
							-81.67224907999992,
							30.379898058000038
						],
						[
							-81.67164590599994,
							30.380138008000074
						],
						[
							-81.67076790599992,
							30.380467009000085
						],
						[
							-81.67063773199993,
							30.380537987000082
						],
						[
							-81.6707779059999,
							30.380670009000088
						],
						[
							-81.6710939049999,
							30.381001008000055
						],
						[
							-81.67125684899992,
							30.38116598500005
						],
						[
							-81.67013190599994,
							30.382237197000055
						],
						[
							-81.66801887299994,
							30.380203056000084
						],
						[
							-81.66798489699994,
							30.380186827000045
						],
						[
							-81.66795175999994,
							30.380203900000083
						],
						[
							-81.6677640229999,
							30.381080154000074
						],
						[
							-81.66626583499993,
							30.381043839000085
						],
						[
							-81.66548290599991,
							30.381850009000058
						],
						[
							-81.66425390599994,
							30.382906009000067
						],
						[
							-81.66356571699993,
							30.38360997100006
						],
						[
							-81.66368983799993,
							30.38395705500005
						],
						[
							-81.66464790599991,
							30.384810009000034
						],
						[
							-81.6651430789999,
							30.385343946000038
						],
						[
							-81.66511174699991,
							30.385739109000042
						],
						[
							-81.6659920809999,
							30.386116953000055
						],
						[
							-81.66293290499993,
							30.39043200900005
						],
						[
							-81.66104899999993,
							30.392893000000072
						],
						[
							-81.66050222699994,
							30.393607263000035
						],
						[
							-81.66002819999994,
							30.393259817000057
						],
						[
							-81.65629129099996,
							30.391293904000065
						],
						[
							-81.65621421999992,
							30.391248322000077
						],
						[
							-81.6545288239999,
							30.39013468700006
						],
						[
							-81.65448132099993,
							30.390113619000093
						],
						[
							-81.65432985699994,
							30.39004596600006
						],
						[
							-81.65308548699994,
							30.389488802000074
						],
						[
							-81.65302276699992,
							30.389457735000065
						],
						[
							-81.65296265399991,
							30.38942188400006
						],
						[
							-81.65290550999993,
							30.389381468000067
						],
						[
							-81.65285168299994,
							30.389336729000036
						],
						[
							-81.65280149799992,
							30.38928794000009
						],
						[
							-81.65267724699993,
							30.389157364000088
						],
						[
							-81.65263290799993,
							30.389175764000072
						],
						[
							-81.65154438199994,
							30.389710256000058
						],
						[
							-81.65145558699993,
							30.38974808700004
						],
						[
							-81.65130416599993,
							30.389788660000075
						],
						[
							-81.65114799999992,
							30.389802322000033
						],
						[
							-81.6509918349999,
							30.389788660000075
						],
						[
							-81.6508404139999,
							30.38974808700004
						],
						[
							-81.65069833899992,
							30.38968183600008
						],
						[
							-81.65062319999993,
							30.389633318000055
						],
						[
							-81.65045135699995,
							30.38951014400004
						],
						[
							-81.64966284099995,
							30.390667531000076
						],
						[
							-81.64960778499994,
							30.390796772000044
						],
						[
							-81.6493081459999,
							30.392011398000076
						],
						[
							-81.64928887199994,
							30.392078300000033
						],
						[
							-81.64926447599993,
							30.39214350900005
						],
						[
							-81.64923510499995,
							30.392206634000047
						],
						[
							-81.64920093399991,
							30.392267295000067
						],
						[
							-81.6491621699999,
							30.392325129000085
						],
						[
							-81.64911904399992,
							30.392379787000042
						],
						[
							-81.64818716699995,
							30.393453502000057
						],
						[
							-81.64808607299994,
							30.39355292000005
						],
						[
							-81.64800935599993,
							30.393606638000055
						],
						[
							-81.64797207299995,
							30.393643921000034
						],
						[
							-81.64793445799997,
							30.393673808000077
						],
						[
							-81.64780145899994,
							30.393773808000052
						],
						[
							-81.64771972099993,
							30.393828534000082
						],
						[
							-81.6476253109999,
							30.39388450300004
						],
						[
							-81.6473939999999,
							30.392955000000086
						],
						[
							-81.64725190599995,
							30.39238400900007
						],
						[
							-81.64723690599993,
							30.392288009000087
						],
						[
							-81.64722090599992,
							30.39216800800006
						],
						[
							-81.64720690599995,
							30.391958008000074
						],
						[
							-81.64720690599995,
							30.391728008000086
						],
						[
							-81.64721490599993,
							30.39151800800005
						],
						[
							-81.6472539049999,
							30.391245009000045
						],
						[
							-81.64727590599995,
							30.391113008000048
						],
						[
							-81.6473679049999,
							30.390764009000065
						],
						[
							-81.64752990599993,
							30.390178008000078
						],
						[
							-81.64765675799993,
							30.389728912000066
						],
						[
							-81.64775805399995,
							30.389638105000078
						],
						[
							-81.6477919049999,
							30.389516009000094
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Tallulah - North Shore",
				"RegionID": "275663"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.96122944899992,
					28.01856401000009,
					-81.95708285599996,
					28.024167746000046
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.95712990999994,
							28.01856401000009
						],
						[
							-81.9580699089999,
							28.01856401000009
						],
						[
							-81.9589249089999,
							28.01857301000007
						],
						[
							-81.9611319089999,
							28.018586010000035
						],
						[
							-81.96122944899992,
							28.018586139000035
						],
						[
							-81.96122944899992,
							28.024167746000046
						],
						[
							-81.95710800099994,
							28.02416769100006
						],
						[
							-81.95710690999994,
							28.023633011000072
						],
						[
							-81.95710490999994,
							28.022694010000066
						],
						[
							-81.9570999099999,
							28.02184501000005
						],
						[
							-81.95708390999994,
							28.02047801100008
						],
						[
							-81.95708390999994,
							28.019421010000087
						],
						[
							-81.95708285599996,
							28.01856401000009
						],
						[
							-81.95712990999994,
							28.01856401000009
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Polk",
				"City": "Lakeland",
				"Name": "Beacon Hill",
				"RegionID": "343472"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.97374897599991,
					28.018582009000056,
					-81.96122944899992,
					28.02587101100005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.97341901199991,
							28.02587101100005
						],
						[
							-81.97332991099995,
							28.02587101000006
						],
						[
							-81.97326591099994,
							28.02587101000006
						],
						[
							-81.97255890999992,
							28.02586701000007
						],
						[
							-81.97133590999994,
							28.025854010000046
						],
						[
							-81.97003890999991,
							28.025851010000054
						],
						[
							-81.96886491099991,
							28.025851010000054
						],
						[
							-81.96866091099992,
							28.025851010000054
						],
						[
							-81.96780690999992,
							28.025851010000054
						],
						[
							-81.96712390999994,
							28.025855010000043
						],
						[
							-81.96698191099995,
							28.02583801100008
						],
						[
							-81.96649190999995,
							28.02585601000004
						],
						[
							-81.9663689109999,
							28.025857011000085
						],
						[
							-81.9653809109999,
							28.025861010000085
						],
						[
							-81.9643669109999,
							28.025865010000075
						],
						[
							-81.96338178199994,
							28.02586914200009
						],
						[
							-81.96334544199993,
							28.02416755900009
						],
						[
							-81.96122944899992,
							28.024167746000046
						],
						[
							-81.96122944899992,
							28.018586139000035
						],
						[
							-81.9616639109999,
							28.01858701000009
						],
						[
							-81.96222490999992,
							28.018588010000087
						],
						[
							-81.96320591099993,
							28.018590010000086
						],
						[
							-81.96326991099994,
							28.018590010000086
						],
						[
							-81.96433390999994,
							28.01858901000009
						],
						[
							-81.9653339109999,
							28.018582009000056
						],
						[
							-81.9663709109999,
							28.018586010000035
						],
						[
							-81.96722304699995,
							28.018590009000036
						],
						[
							-81.9674309099999,
							28.018590010000086
						],
						[
							-81.96763891099994,
							28.018591010000083
						],
						[
							-81.96820391099993,
							28.018594009000083
						],
						[
							-81.96875391099991,
							28.018598010000062
						],
						[
							-81.9694809099999,
							28.018604010000047
						],
						[
							-81.96967063099993,
							28.01860584700006
						],
						[
							-81.96967036399991,
							28.02231005400006
						],
						[
							-81.97371604299992,
							28.022386881000045
						],
						[
							-81.9737149099999,
							28.02304201000004
						],
						[
							-81.97374091099994,
							28.024008011000035
						],
						[
							-81.97374897599991,
							28.02428101000004
						],
						[
							-81.9737079109999,
							28.024686010000043
						],
						[
							-81.97368391099991,
							28.024931010000046
						],
						[
							-81.97362990999994,
							28.025303009000083
						],
						[
							-81.97356090999995,
							28.025551010000076
						],
						[
							-81.97354190899995,
							28.025621012000045
						],
						[
							-81.97341901199991,
							28.02587101100005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Polk",
				"City": "Lakeland",
				"Name": "Camphor",
				"RegionID": "343473"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.96959614699995,
					28.00479698900006,
					-81.9570079099999,
					28.018590010000086
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.9611319089999,
							28.018586010000035
						],
						[
							-81.9589249089999,
							28.01857301000007
						],
						[
							-81.9580699089999,
							28.01856401000009
						],
						[
							-81.95712990999994,
							28.01856401000009
						],
						[
							-81.95708285599996,
							28.01856401000009
						],
						[
							-81.95707791099994,
							28.017617010000038
						],
						[
							-81.9570729109999,
							28.016751010000064
						],
						[
							-81.9570699109999,
							28.016278011000054
						],
						[
							-81.95706791099991,
							28.015868011000066
						],
						[
							-81.95706491099992,
							28.01536401000004
						],
						[
							-81.95706291099992,
							28.015016010000068
						],
						[
							-81.95706191099993,
							28.014222010000083
						],
						[
							-81.95706091099994,
							28.013470011000038
						],
						[
							-81.95705791099994,
							28.012683010000046
						],
						[
							-81.95706091099994,
							28.012179010000068
						],
						[
							-81.95706191099993,
							28.01179301000008
						],
						[
							-81.95705696599993,
							28.011257012000044
						],
						[
							-81.95705490899991,
							28.009907010000063
						],
						[
							-81.95704390999992,
							28.009005011000056
						],
						[
							-81.95702990999992,
							28.00809101100009
						],
						[
							-81.95702638699993,
							28.00781369100008
						],
						[
							-81.95702395699993,
							28.007629620000046
						],
						[
							-81.95702390999992,
							28.00762601000008
						],
						[
							-81.95701891099992,
							28.007310010000083
						],
						[
							-81.95701090999995,
							28.00655801000005
						],
						[
							-81.9570079099999,
							28.005722011000046
						],
						[
							-81.9570089099999,
							28.00535601100006
						],
						[
							-81.95700863799993,
							28.00515969500009
						],
						[
							-81.9570082699999,
							28.004805247000036
						],
						[
							-81.95757808299993,
							28.00479698900006
						],
						[
							-81.95803087699994,
							28.004870699000037
						],
						[
							-81.96037908699992,
							28.004902290000075
						],
						[
							-81.96220079199992,
							28.004902290000075
						],
						[
							-81.9645279419999,
							28.004912820000072
						],
						[
							-81.96566375299994,
							28.004932573000076
						],
						[
							-81.96566923099994,
							28.005261046000044
						],
						[
							-81.9657580889999,
							28.010591123000044
						],
						[
							-81.96528083299995,
							28.011326989000054
						],
						[
							-81.96528178099993,
							28.01173114000005
						],
						[
							-81.96832591099991,
							28.011733011000047
						],
						[
							-81.96935704599991,
							28.011725142000046
						],
						[
							-81.96935291199992,
							28.01153601100009
						],
						[
							-81.96936378499993,
							28.01146196500008
						],
						[
							-81.96938780799991,
							28.011418924000054
						],
						[
							-81.96943684399992,
							28.01137689400008
						],
						[
							-81.9695009109999,
							28.01135301100004
						],
						[
							-81.96959609099991,
							28.011333266000065
						],
						[
							-81.96959614699995,
							28.015975491000063
						],
						[
							-81.96722304699995,
							28.018590009000036
						],
						[
							-81.9663709109999,
							28.018586010000035
						],
						[
							-81.9653339109999,
							28.018582009000056
						],
						[
							-81.96433390999994,
							28.01858901000009
						],
						[
							-81.96326991099994,
							28.018590010000086
						],
						[
							-81.96320591099993,
							28.018590010000086
						],
						[
							-81.96222490999992,
							28.018588010000087
						],
						[
							-81.9616639109999,
							28.01858701000009
						],
						[
							-81.96122944899992,
							28.018586139000035
						],
						[
							-81.9611319089999,
							28.018586010000035
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Polk",
				"City": "Lakeland",
				"Name": "Southwest",
				"RegionID": "343474"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.4304939999999,
					28.556550249000054,
					-81.39922040099992,
					28.595646000000045
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.4141308639999,
							28.592898863000073
						],
						[
							-81.41351999999995,
							28.59165900000005
						],
						[
							-81.4132239999999,
							28.59105800000009
						],
						[
							-81.4131190729999,
							28.590845066000043
						],
						[
							-81.41267899999991,
							28.58995200000004
						],
						[
							-81.41240399999992,
							28.589394000000084
						],
						[
							-81.41185799999994,
							28.58828600000004
						],
						[
							-81.41154799999993,
							28.58769200000006
						],
						[
							-81.41135024499994,
							28.58727045900008
						],
						[
							-81.41117146999994,
							28.586932817000047
						],
						[
							-81.41105885199994,
							28.586721884000042
						],
						[
							-81.41090920999994,
							28.586481564000053
						],
						[
							-81.41072060399995,
							28.58618172900009
						],
						[
							-81.4105720259999,
							28.585945241000047
						],
						[
							-81.41028999999992,
							28.58546000000007
						],
						[
							-81.41011199999991,
							28.585466000000054
						],
						[
							-81.41006499999992,
							28.585380000000043
						],
						[
							-81.4098459999999,
							28.58497600000004
						],
						[
							-81.40981399999993,
							28.584917000000075
						],
						[
							-81.40909613199995,
							28.583648916000072
						],
						[
							-81.40900410699993,
							28.583486357000083
						],
						[
							-81.40837099999993,
							28.582368000000088
						],
						[
							-81.40802249199993,
							28.58158657900009
						],
						[
							-81.40723955999994,
							28.579831091000074
						],
						[
							-81.40603271299995,
							28.580181466000056
						],
						[
							-81.40485899999995,
							28.57586800000007
						],
						[
							-81.40468599999991,
							28.57539500000007
						],
						[
							-81.40398874199991,
							28.573479030000044
						],
						[
							-81.40156089699991,
							28.573405203000053
						],
						[
							-81.4016352729999,
							28.567961977000042
						],
						[
							-81.40142282499994,
							28.567372125000077
						],
						[
							-81.40120149699993,
							28.56698956000008
						],
						[
							-81.40080791399993,
							28.566339594000056
						],
						[
							-81.40041032499994,
							28.565682622000054
						],
						[
							-81.40001673899991,
							28.56505168500007
						],
						[
							-81.39961113799991,
							28.564384695000058
						],
						[
							-81.39922040099992,
							28.563767707000068
						],
						[
							-81.39930668799991,
							28.563755762000085
						],
						[
							-81.39939381699992,
							28.563741742000047
						],
						[
							-81.39946492199994,
							28.56372972300005
						],
						[
							-81.39958615199994,
							28.56371260700007
						],
						[
							-81.3996301059999,
							28.56377985900008
						],
						[
							-81.39973540799991,
							28.563845794000088
						],
						[
							-81.40026410599995,
							28.56459801300008
						],
						[
							-81.40043427899991,
							28.56479848300006
						],
						[
							-81.4099886599999,
							28.564711308000085
						],
						[
							-81.40992029299991,
							28.55991793800007
						],
						[
							-81.41513111899991,
							28.559918124000035
						],
						[
							-81.42006760899994,
							28.559901177000086
						],
						[
							-81.42015996599991,
							28.559901022000076
						],
						[
							-81.42313799999994,
							28.559896053000045
						],
						[
							-81.42313799999994,
							28.556554000000062
						],
						[
							-81.4251270929999,
							28.556550249000054
						],
						[
							-81.42518092599994,
							28.559718906000057
						],
						[
							-81.42627781999994,
							28.559763712000066
						],
						[
							-81.4262793179999,
							28.560085643000036
						],
						[
							-81.42524699999991,
							28.56008700000007
						],
						[
							-81.42524699999991,
							28.560179000000062
						],
						[
							-81.4260809999999,
							28.560179000000062
						],
						[
							-81.42606599999993,
							28.560974000000044
						],
						[
							-81.42628251799994,
							28.560974737000038
						],
						[
							-81.42630906099993,
							28.56713784300007
						],
						[
							-81.42608699999994,
							28.567136000000062
						],
						[
							-81.42608599999994,
							28.56727600000005
						],
						[
							-81.4260779999999,
							28.56741100000005
						],
						[
							-81.42631020999994,
							28.56741052700005
						],
						[
							-81.42656899999992,
							28.567410000000052
						],
						[
							-81.42637699999995,
							28.56757300000004
						],
						[
							-81.42643699999991,
							28.56849500000004
						],
						[
							-81.42643199999992,
							28.56864200000007
						],
						[
							-81.42644599999994,
							28.56881400000009
						],
						[
							-81.4263155829999,
							28.568814385000053
						],
						[
							-81.42610699999994,
							28.568815000000086
						],
						[
							-81.42610699999994,
							28.568996000000084
						],
						[
							-81.42631689699994,
							28.568996000000084
						],
						[
							-81.42645799999991,
							28.568996000000084
						],
						[
							-81.4264639999999,
							28.569098000000054
						],
						[
							-81.42649799999992,
							28.569559000000083
						],
						[
							-81.42653199999995,
							28.570012000000077
						],
						[
							-81.42654369799993,
							28.57046570300008
						],
						[
							-81.42654599999992,
							28.57055500000007
						],
						[
							-81.42655499999995,
							28.570798000000085
						],
						[
							-81.42432599999995,
							28.570606000000055
						],
						[
							-81.42432549999995,
							28.570609500000046
						],
						[
							-81.4243249999999,
							28.57061300000004
						],
						[
							-81.42283099999992,
							28.57045700000009
						],
						[
							-81.42223899999993,
							28.570424000000063
						],
						[
							-81.4222309999999,
							28.57034100000004
						],
						[
							-81.42212399999994,
							28.57033800000005
						],
						[
							-81.42204499999991,
							28.570335000000057
						],
						[
							-81.42204499999991,
							28.570256000000086
						],
						[
							-81.42197499999992,
							28.57024800000005
						],
						[
							-81.42196599999995,
							28.570426000000055
						],
						[
							-81.41925999999995,
							28.570327000000077
						],
						[
							-81.41927299999992,
							28.570141000000035
						],
						[
							-81.41907399999991,
							28.570141000000035
						],
						[
							-81.41907399999991,
							28.570339000000047
						],
						[
							-81.41723599999995,
							28.570269000000053
						],
						[
							-81.41710399999994,
							28.570025000000047
						],
						[
							-81.41709099999993,
							28.570406000000048
						],
						[
							-81.41707799999995,
							28.570816000000036
						],
						[
							-81.41723599999995,
							28.570595000000083
						],
						[
							-81.41903499999995,
							28.57067600000005
						],
						[
							-81.41903499999995,
							28.57088500000009
						],
						[
							-81.41925999999995,
							28.570909000000086
						],
						[
							-81.41927099999992,
							28.570759000000066
						],
						[
							-81.42198699999994,
							28.570872000000065
						],
						[
							-81.42198699999994,
							28.571113000000082
						],
						[
							-81.42228799999992,
							28.571112000000085
						],
						[
							-81.42228899999992,
							28.57088500000009
						],
						[
							-81.42404399999992,
							28.571090000000083
						],
						[
							-81.4266419999999,
							28.57135900000009
						],
						[
							-81.42857199999992,
							28.571479000000068
						],
						[
							-81.4303799999999,
							28.571582000000035
						],
						[
							-81.43037399999992,
							28.57280300000008
						],
						[
							-81.42862099999992,
							28.57286600000009
						],
						[
							-81.42666099999991,
							28.572888000000034
						],
						[
							-81.4264629999999,
							28.573098000000073
						],
						[
							-81.4264629999999,
							28.57464900000008
						],
						[
							-81.43047499999994,
							28.57465200000007
						],
						[
							-81.43047499999994,
							28.57543600000008
						],
						[
							-81.43047499999994,
							28.57607500000006
						],
						[
							-81.4304699999999,
							28.57631100000009
						],
						[
							-81.43030999999992,
							28.576309000000037
						],
						[
							-81.42858799999993,
							28.576268000000084
						],
						[
							-81.42859199999992,
							28.578078000000062
						],
						[
							-81.4285999999999,
							28.57818800000007
						],
						[
							-81.42932399999997,
							28.57819100000006
						],
						[
							-81.4293219999999,
							28.578653000000088
						],
						[
							-81.42962999999992,
							28.578662000000065
						],
						[
							-81.42962199999994,
							28.578213000000062
						],
						[
							-81.43000299999994,
							28.57819500000005
						],
						[
							-81.43001099999992,
							28.578671000000043
						],
						[
							-81.43048299999992,
							28.578677000000084
						],
						[
							-81.4304939999999,
							28.57897700000007
						],
						[
							-81.4304899999999,
							28.579383000000064
						],
						[
							-81.42931799999991,
							28.579375000000088
						],
						[
							-81.42931299999992,
							28.580278000000078
						],
						[
							-81.42931499999992,
							28.58115100000009
						],
						[
							-81.4304689999999,
							28.581162000000063
						],
						[
							-81.4304663179999,
							28.58171712500007
						],
						[
							-81.42456463499991,
							28.58171712500007
						],
						[
							-81.42456399999992,
							28.58215400000006
						],
						[
							-81.42543599999995,
							28.582152000000065
						],
						[
							-81.42543399999995,
							28.58221700000007
						],
						[
							-81.42543099999995,
							28.582299000000035
						],
						[
							-81.42456399999992,
							28.582295000000045
						],
						[
							-81.42456199999992,
							28.583575000000053
						],
						[
							-81.42455899999993,
							28.585289000000046
						],
						[
							-81.42456099999993,
							28.58535100000006
						],
						[
							-81.42450195099991,
							28.585352355000055
						],
						[
							-81.4235589999999,
							28.58537400000006
						],
						[
							-81.4235579999999,
							28.58573300000006
						],
						[
							-81.42259199999995,
							28.58573300000006
						],
						[
							-81.42249299999992,
							28.58573300000006
						],
						[
							-81.42040799999995,
							28.585725000000085
						],
						[
							-81.4202269999999,
							28.585725000000085
						],
						[
							-81.4202269999999,
							28.58536500000008
						],
						[
							-81.4202269999999,
							28.585337156000037
						],
						[
							-81.4185004979999,
							28.585505595000086
						],
						[
							-81.41854197299995,
							28.589322080000045
						],
						[
							-81.41698388099991,
							28.589322080000045
						],
						[
							-81.41641309799991,
							28.589322080000045
						],
						[
							-81.41659498199994,
							28.590114575000086
						],
						[
							-81.41709474699991,
							28.591183038000054
						],
						[
							-81.41755992999992,
							28.59175393600009
						],
						[
							-81.41782099999995,
							28.59175300000004
						],
						[
							-81.4180209999999,
							28.59211600000009
						],
						[
							-81.41808999999995,
							28.592241000000058
						],
						[
							-81.41821799999991,
							28.59248000000008
						],
						[
							-81.41850049999994,
							28.59302100000008
						],
						[
							-81.4188299999999,
							28.593653000000074
						],
						[
							-81.41895299999993,
							28.594227000000046
						],
						[
							-81.41880099999992,
							28.59461500000009
						],
						[
							-81.41862199999991,
							28.59507300000007
						],
						[
							-81.41851199999991,
							28.59515900000008
						],
						[
							-81.41809099999995,
							28.59545300000008
						],
						[
							-81.41764099999995,
							28.595630000000085
						],
						[
							-81.41755499999994,
							28.595646000000045
						],
						[
							-81.41713399999992,
							28.595638000000065
						],
						[
							-81.41712399999994,
							28.595243000000043
						],
						[
							-81.4155274389999,
							28.59520350300005
						],
						[
							-81.41530499999993,
							28.59519800000004
						],
						[
							-81.41523201399991,
							28.595080363000083
						],
						[
							-81.41521999999992,
							28.595061000000044
						],
						[
							-81.41517099999994,
							28.594982000000073
						],
						[
							-81.4148579859999,
							28.594357051000088
						],
						[
							-81.41443907099995,
							28.593520665000085
						],
						[
							-81.41430099999991,
							28.59324500000008
						],
						[
							-81.41415999999992,
							28.592958000000067
						],
						[
							-81.4141308639999,
							28.592898863000073
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Princeton-Silver Star",
				"RegionID": "343605"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.53378612799992,
					27.315380923000077,
					-82.52965909799991,
					27.321086067000067
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.52965997299992,
							27.315497694000047
						],
						[
							-82.52965909799991,
							27.315380923000077
						],
						[
							-82.53373281799992,
							27.315466794000088
						],
						[
							-82.53378612799992,
							27.321086067000067
						],
						[
							-82.5297015239999,
							27.321045189000074
						],
						[
							-82.52965997299992,
							27.315497694000047
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Southside Village",
				"RegionID": "343956"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.53848468199993,
					27.315466794000088,
					-82.5297015239999,
					27.32856000000004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.53376256299993,
							27.32845588400005
						],
						[
							-82.53376500399992,
							27.328313249000075
						],
						[
							-82.53376922299992,
							27.328223239000067
						],
						[
							-82.5337738959999,
							27.328123557000083
						],
						[
							-82.5337812059999,
							27.32796760900004
						],
						[
							-82.53378699599995,
							27.327844076000076
						],
						[
							-82.5337899999999,
							27.327780000000075
						],
						[
							-82.53379099699993,
							27.327697252000064
						],
						[
							-82.53379265199993,
							27.327559869000083
						],
						[
							-82.53379385099993,
							27.32746036900005
						],
						[
							-82.5337956759999,
							27.327308894000055
						],
						[
							-82.53379681699994,
							27.32721418600005
						],
						[
							-82.53379767299992,
							27.327143155000044
						],
						[
							-82.53379915599993,
							27.32702003500009
						],
						[
							-82.53379999999993,
							27.326901602000078
						],
						[
							-82.53381026499994,
							27.326826114000085
						],
						[
							-82.5338141439999,
							27.326769222000053
						],
						[
							-82.53381673699994,
							27.326731188000053
						],
						[
							-82.53381874399992,
							27.32670175900006
						],
						[
							-82.5338333059999,
							27.326704352000036
						],
						[
							-82.53400552399995,
							27.326730097000052
						],
						[
							-82.53436476899992,
							27.326684280000052
						],
						[
							-82.53471474899993,
							27.32671560400007
						],
						[
							-82.53469969799994,
							27.32533989600006
						],
						[
							-82.53382186499994,
							27.32533989600006
						],
						[
							-82.53380140699994,
							27.32290009500008
						],
						[
							-82.52972872099991,
							27.322905820000074
						],
						[
							-82.5297015239999,
							27.321045189000074
						],
						[
							-82.53378612799992,
							27.321086067000067
						],
						[
							-82.53373281799992,
							27.315466794000088
						],
						[
							-82.53782771899995,
							27.315535116000035
						],
						[
							-82.53783825999994,
							27.319847850000087
						],
						[
							-82.5378385539999,
							27.319967749000057
						],
						[
							-82.53784238599991,
							27.32152722700005
						],
						[
							-82.53784273399992,
							27.321668269000043
						],
						[
							-82.53784546799994,
							27.322781071000065
						],
						[
							-82.53784686799992,
							27.32286000000005
						],
						[
							-82.53789838599994,
							27.325764231000054
						],
						[
							-82.53796669099995,
							27.325968794000065
						],
						[
							-82.53800512099991,
							27.326049498000092
						],
						[
							-82.5381448149999,
							27.32634036400009
						],
						[
							-82.53818048699993,
							27.326441096000053
						],
						[
							-82.53822676199991,
							27.326543523000055
						],
						[
							-82.53829891899994,
							27.326687837000065
						],
						[
							-82.53835356099995,
							27.326816698000073
						],
						[
							-82.53840732499992,
							27.32695558900008
						],
						[
							-82.53843999999992,
							27.327040000000068
						],
						[
							-82.53845132399994,
							27.32708152300006
						],
						[
							-82.5384647379999,
							27.327130707000038
						],
						[
							-82.5384753699999,
							27.32723055200006
						],
						[
							-82.53848468199993,
							27.327370237000082
						],
						[
							-82.5384817229999,
							27.32752173500006
						],
						[
							-82.53846434199994,
							27.327672370000073
						],
						[
							-82.5384582399999,
							27.32784197600006
						],
						[
							-82.53845489999992,
							27.32809247700004
						],
						[
							-82.53845249499994,
							27.32827283800009
						],
						[
							-82.5384499999999,
							27.328460000000064
						],
						[
							-82.53834372099993,
							27.328458013000045
						],
						[
							-82.53820974399991,
							27.328455509000037
						],
						[
							-82.53805650899994,
							27.328452645000084
						],
						[
							-82.53796081099995,
							27.328450856000075
						],
						[
							-82.53783959399993,
							27.328448591000043
						],
						[
							-82.53771825799993,
							27.328446323000037
						],
						[
							-82.53760342099991,
							27.328444176000062
						],
						[
							-82.53748846499991,
							27.32844202700005
						],
						[
							-82.53737999999993,
							27.328440000000057
						],
						[
							-82.53724591899993,
							27.328441302000044
						],
						[
							-82.53697789799992,
							27.32844390400004
						],
						[
							-82.5368247429999,
							27.32844539100006
						],
						[
							-82.53664606199993,
							27.32844712600007
						],
						[
							-82.53649290699991,
							27.328448613000035
						],
						[
							-82.53635251399993,
							27.32844997600006
						],
						[
							-82.53616736499993,
							27.328450000000093
						],
						[
							-82.53599504899995,
							27.328450000000093
						],
						[
							-82.53580358699992,
							27.328450000000093
						],
						[
							-82.5356057429999,
							27.328450000000093
						],
						[
							-82.53537598899993,
							27.328450000000093
						],
						[
							-82.53527387599992,
							27.328450000000093
						],
						[
							-82.53518999999994,
							27.328450000000093
						],
						[
							-82.53506964999991,
							27.328450000000093
						],
						[
							-82.53495477299992,
							27.328450000000093
						],
						[
							-82.53488499999992,
							27.32845214300005
						],
						[
							-82.53485372699993,
							27.328456610000046
						],
						[
							-82.53482999999994,
							27.328460000000064
						],
						[
							-82.53471863599992,
							27.328460000000064
						],
						[
							-82.53456591799994,
							27.328465510000058
						],
						[
							-82.53441196299991,
							27.32848475500009
						],
						[
							-82.53423286499992,
							27.328506592000053
						],
						[
							-82.5340431919999,
							27.328528478000067
						],
						[
							-82.53396131499994,
							27.328537925000038
						],
						[
							-82.53383171799993,
							27.328552879000085
						],
						[
							-82.53376999999995,
							27.32856000000004
						],
						[
							-82.53376256299993,
							27.32845588400005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Hudson Bayou",
				"RegionID": "343957"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.54032911299993,
					27.30937642500004,
					-82.53369159199991,
					27.311360000000036
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.53483999999992,
							27.309440000000052
						],
						[
							-82.5350305259999,
							27.309437618000064
						],
						[
							-82.53518334299991,
							27.30943570800008
						],
						[
							-82.53534704799995,
							27.30943366200006
						],
						[
							-82.53553697699994,
							27.30943128800004
						],
						[
							-82.5356799999999,
							27.309430000000077
						],
						[
							-82.53842999999995,
							27.309440000000052
						],
						[
							-82.53853177299993,
							27.30943389400005
						],
						[
							-82.53866408899995,
							27.309425955000055
						],
						[
							-82.53878495899994,
							27.309418702000073
						],
						[
							-82.5388536349999,
							27.309414582000045
						],
						[
							-82.53892999999994,
							27.30941000000007
						],
						[
							-82.53899700399995,
							27.30937642500004
						],
						[
							-82.53940078599993,
							27.30939119800007
						],
						[
							-82.54032911299993,
							27.309414642000036
						],
						[
							-82.54003982199993,
							27.310431664000077
						],
						[
							-82.54004304599994,
							27.311241664000082
						],
						[
							-82.54004734199992,
							27.31126927200006
						],
						[
							-82.53914399999991,
							27.31131300000004
						],
						[
							-82.53829999999994,
							27.311330000000055
						],
						[
							-82.53814766499994,
							27.311331881000058
						],
						[
							-82.53796873699991,
							27.311334090000063
						],
						[
							-82.53782944799991,
							27.31133580900007
						],
						[
							-82.5377002219999,
							27.311337405000074
						],
						[
							-82.53748999999993,
							27.311340000000087
						],
						[
							-82.5372727909999,
							27.311340000000087
						],
						[
							-82.5369347649999,
							27.311340000000087
						],
						[
							-82.53660999999994,
							27.311340000000087
						],
						[
							-82.53644760899994,
							27.311340000000087
						],
						[
							-82.5362199999999,
							27.311340000000087
						],
						[
							-82.53606981399992,
							27.311340000000087
						],
						[
							-82.5359505109999,
							27.311340000000087
						],
						[
							-82.5356999999999,
							27.311340000000087
						],
						[
							-82.5355826359999,
							27.311341304000052
						],
						[
							-82.53533411699993,
							27.31134406500007
						],
						[
							-82.53519483699995,
							27.31134561300007
						],
						[
							-82.53501590299993,
							27.31134760100008
						],
						[
							-82.5347999999999,
							27.31135000000006
						],
						[
							-82.53471767699995,
							27.311351267000077
						],
						[
							-82.53461828099995,
							27.31135279600005
						],
						[
							-82.53442927499992,
							27.31135570300006
						],
						[
							-82.53425036199991,
							27.31135845600005
						],
						[
							-82.5339322929999,
							27.311360000000036
						],
						[
							-82.53370999999993,
							27.311360000000036
						],
						[
							-82.53370142299991,
							27.31135974500006
						],
						[
							-82.53370107899991,
							27.31131471100008
						],
						[
							-82.53369159199991,
							27.30945997200007
						],
						[
							-82.5337880749999,
							27.30945829400008
						],
						[
							-82.53388629999995,
							27.309456586000067
						],
						[
							-82.5340114249999,
							27.30945441000006
						],
						[
							-82.5343863459999,
							27.309447890000058
						],
						[
							-82.53469645199993,
							27.309442496000088
						],
						[
							-82.53483999999992,
							27.309440000000052
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Bayview",
				"RegionID": "343958"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.54382532199992,
					27.301390000000083,
					-82.52962999999994,
					27.315500000000043
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.52962999999994,
							27.315500000000043
						],
						[
							-82.5296446399999,
							27.315262832000087
						],
						[
							-82.52965643899995,
							27.315071681000063
						],
						[
							-82.52967102299995,
							27.314835429000084
						],
						[
							-82.52967999999993,
							27.31469000000004
						],
						[
							-82.52969324999992,
							27.31434550000006
						],
						[
							-82.52970225699994,
							27.314111327000035
						],
						[
							-82.52970999999991,
							27.313910000000078
						],
						[
							-82.52972744899995,
							27.313708085000087
						],
						[
							-82.52974438299992,
							27.313512141000047
						],
						[
							-82.52976449999994,
							27.31327936000008
						],
						[
							-82.5297799999999,
							27.31310000000008
						],
						[
							-82.52978366999992,
							27.313003355000035
						],
						[
							-82.5297925939999,
							27.312768365000068
						],
						[
							-82.52980394299993,
							27.31246950600007
						],
						[
							-82.52980999999994,
							27.312310000000082
						],
						[
							-82.5298222369999,
							27.312043852000045
						],
						[
							-82.5298359759999,
							27.31174502400006
						],
						[
							-82.5298499999999,
							27.31144000000006
						],
						[
							-82.52986261399991,
							27.311254999000084
						],
						[
							-82.52987428799992,
							27.311083782000082
						],
						[
							-82.52987999999993,
							27.311000000000035
						],
						[
							-82.52989020399991,
							27.31085034700004
						],
						[
							-82.5299003319999,
							27.310701798000082
						],
						[
							-82.52990999999992,
							27.310560000000066
						],
						[
							-82.52992431699994,
							27.310338080000065
						],
						[
							-82.52993828299992,
							27.309997362000047
						],
						[
							-82.5299459869999,
							27.309762396000053
						],
						[
							-82.52994999999994,
							27.30964000000006
						],
						[
							-82.52996939199994,
							27.30933619600006
						],
						[
							-82.52997999999991,
							27.309016127000064
						],
						[
							-82.52997999999991,
							27.308800000000076
						],
						[
							-82.52999329199992,
							27.30854744600009
						],
						[
							-82.53000840499993,
							27.308305535000045
						],
						[
							-82.53005843599993,
							27.308305075000078
						],
						[
							-82.53028753699994,
							27.302907593000043
						],
						[
							-82.53028999999992,
							27.302850000000035
						],
						[
							-82.53030169999994,
							27.302809050000068
						],
						[
							-82.53031175899991,
							27.30274246600004
						],
						[
							-82.53031438499994,
							27.302686444000074
						],
						[
							-82.53032058599992,
							27.30255416700004
						],
						[
							-82.53032451699994,
							27.30247029700007
						],
						[
							-82.5303294119999,
							27.30236586700005
						],
						[
							-82.5303359699999,
							27.302225975000056
						],
						[
							-82.53033999999991,
							27.302140000000065
						],
						[
							-82.5303432739999,
							27.302079435000053
						],
						[
							-82.53034891499993,
							27.30197508100008
						],
						[
							-82.53035495199993,
							27.301863394000065
						],
						[
							-82.53036061299991,
							27.30175866400009
						],
						[
							-82.53036664999992,
							27.301646977000075
						],
						[
							-82.5303738149999,
							27.301514419000057
						],
						[
							-82.53037759599994,
							27.30144447400005
						],
						[
							-82.53037999999992,
							27.301400000000058
						],
						[
							-82.5304316079999,
							27.301398925000058
						],
						[
							-82.53055031499991,
							27.301396452000063
						],
						[
							-82.53071769699994,
							27.301392965000048
						],
						[
							-82.5308085069999,
							27.301391073000048
						],
						[
							-82.53103173499994,
							27.301390000000083
						],
						[
							-82.5312689619999,
							27.301390000000083
						],
						[
							-82.53150999999991,
							27.301390000000083
						],
						[
							-82.53158990199995,
							27.301390619000074
						],
						[
							-82.53178525399994,
							27.301392134000082
						],
						[
							-82.53188996099993,
							27.30139294500009
						],
						[
							-82.53219694199993,
							27.301395325000044
						],
						[
							-82.53244113099993,
							27.30139721800009
						],
						[
							-82.53251792999993,
							27.30139781300005
						],
						[
							-82.53271328199992,
							27.30139932800006
						],
						[
							-82.53288070899993,
							27.301402882000048
						],
						[
							-82.53295760999993,
							27.301405629000044
						],
						[
							-82.5330481979999,
							27.301408864000052
						],
						[
							-82.53313181099993,
							27.301417402000084
						],
						[
							-82.53322949199992,
							27.30143135600008
						],
						[
							-82.5333408489999,
							27.301447264000046
						],
						[
							-82.53343929499994,
							27.30147114500005
						],
						[
							-82.53352975599995,
							27.301491646000045
						],
						[
							-82.53362741299992,
							27.301499784000043
						],
						[
							-82.53364420899993,
							27.302732005000053
						],
						[
							-82.53369862199992,
							27.30273061300005
						],
						[
							-82.53387038099993,
							27.302733339000042
						],
						[
							-82.53396234299993,
							27.302734799000064
						],
						[
							-82.5341402329999,
							27.302737623000045
						],
						[
							-82.53423209699992,
							27.302739081000084
						],
						[
							-82.53428999999994,
							27.30274000000009
						],
						[
							-82.5343608039999,
							27.302736546000062
						],
						[
							-82.53444645299993,
							27.30273236800008
						],
						[
							-82.5345201639999,
							27.30272877200008
						],
						[
							-82.53461252799991,
							27.302724267000087
						],
						[
							-82.53469999999993,
							27.30272000000008
						],
						[
							-82.5348146799999,
							27.30272000000008
						],
						[
							-82.53528073699994,
							27.30272000000008
						],
						[
							-82.53545244199995,
							27.30272000000008
						],
						[
							-82.53553999999991,
							27.30272000000008
						],
						[
							-82.53558116399995,
							27.30271841700005
						],
						[
							-82.53566100199993,
							27.30271534600007
						],
						[
							-82.5357471989999,
							27.30271203100006
						],
						[
							-82.53579999999994,
							27.302710000000047
						],
						[
							-82.53596755699994,
							27.302710000000047
						],
						[
							-82.53624351099995,
							27.302710000000047
						],
						[
							-82.5363999999999,
							27.302710000000047
						],
						[
							-82.53652560799993,
							27.30270844900008
						],
						[
							-82.53678312699992,
							27.302705270000047
						],
						[
							-82.53687524899993,
							27.302704133000077
						],
						[
							-82.53710203499992,
							27.302701333000073
						],
						[
							-82.5372099999999,
							27.302700000000073
						],
						[
							-82.53742704899992,
							27.302700000000073
						],
						[
							-82.53780725299993,
							27.302700000000073
						],
						[
							-82.53797895799994,
							27.302700000000073
						],
						[
							-82.53804999999994,
							27.302700000000073
						],
						[
							-82.53811378899991,
							27.302698364000037
						],
						[
							-82.53818748599991,
							27.30269647500006
						],
						[
							-82.53831617999992,
							27.30269317500006
						],
						[
							-82.5383653639999,
							27.302691914000036
						],
						[
							-82.53843999999992,
							27.30269000000004
						],
						[
							-82.53866577799994,
							27.30269000000004
						],
						[
							-82.53892333599993,
							27.30269000000004
						],
						[
							-82.53897970699991,
							27.302689558000054
						],
						[
							-82.53903371599995,
							27.302689134000047
						],
						[
							-82.53909502399995,
							27.302688145000047
						],
						[
							-82.53916869099993,
							27.302686957000052
						],
						[
							-82.53942005099994,
							27.302682902000072
						],
						[
							-82.53950597999994,
							27.302681516000067
						],
						[
							-82.53959999999995,
							27.302680000000066
						],
						[
							-82.53973280199995,
							27.302680000000066
						],
						[
							-82.53989224299994,
							27.302680000000066
						],
						[
							-82.54013140299992,
							27.302680000000066
						],
						[
							-82.54043801899991,
							27.302680000000066
						],
						[
							-82.54067104799992,
							27.302680000000066
						],
						[
							-82.54075999999992,
							27.302680000000066
						],
						[
							-82.54090407599995,
							27.302680000000066
						],
						[
							-82.54112464199994,
							27.302682102000063
						],
						[
							-82.54128384599994,
							27.302688225000054
						],
						[
							-82.5414743689999,
							27.302701643000034
						],
						[
							-82.54168908799994,
							27.302718959000064
						],
						[
							-82.5418733429999,
							27.302733818000036
						],
						[
							-82.5419220839999,
							27.302737749000073
						],
						[
							-82.54194999999993,
							27.30274000000009
						],
						[
							-82.54201942799995,
							27.302746312000068
						],
						[
							-82.54211839999994,
							27.302755309000077
						],
						[
							-82.54225939299994,
							27.302768127000036
						],
						[
							-82.54233845999994,
							27.302775315000076
						],
						[
							-82.54240649499991,
							27.30278000000004
						],
						[
							-82.54272537499992,
							27.30278000000004
						],
						[
							-82.54285415399994,
							27.30278000000004
						],
						[
							-82.54292009199992,
							27.30277909700004
						],
						[
							-82.5438197979999,
							27.30277909700004
						],
						[
							-82.54382492199994,
							27.302950165000087
						],
						[
							-82.54382532199992,
							27.30297700000006
						],
						[
							-82.5438116599999,
							27.303133166000066
						],
						[
							-82.54377108699993,
							27.303284586000075
						],
						[
							-82.5437048359999,
							27.30342666100006
						],
						[
							-82.54361492099991,
							27.30355507300004
						],
						[
							-82.54358530199995,
							27.303588639000054
						],
						[
							-82.5435083019999,
							27.303671639000072
						],
						[
							-82.54342707299992,
							27.30374892100008
						],
						[
							-82.54329866099994,
							27.303838836000068
						],
						[
							-82.54315658699994,
							27.30390508700009
						],
						[
							-82.54300516599994,
							27.303945660000068
						],
						[
							-82.5429684369999,
							27.303951356000084
						],
						[
							-82.5425654359999,
							27.30400535600006
						],
						[
							-82.54241108999993,
							27.304012644000068
						],
						[
							-82.5416248759999,
							27.303982103000067
						],
						[
							-82.54130389499994,
							27.30397805800004
						],
						[
							-82.54127543899995,
							27.303991328000052
						],
						[
							-82.54122255699991,
							27.30430810500008
						],
						[
							-82.54117640299995,
							27.305219400000055
						],
						[
							-82.54118956299993,
							27.305496276000042
						],
						[
							-82.54028902499994,
							27.305492048000076
						],
						[
							-82.53831786699993,
							27.305482794000056
						],
						[
							-82.53828677899992,
							27.305886941000043
						],
						[
							-82.53653547199993,
							27.305907667000042
						],
						[
							-82.53511577299992,
							27.305969843000074
						],
						[
							-82.5338307909999,
							27.30595948100006
						],
						[
							-82.5336679959999,
							27.305945570000063
						],
						[
							-82.53367873099995,
							27.30742273000004
						],
						[
							-82.53368611899992,
							27.308379613000056
						],
						[
							-82.5336915549999,
							27.30945274900006
						],
						[
							-82.53369159199991,
							27.30945997200007
						],
						[
							-82.53370107899991,
							27.31131471100008
						],
						[
							-82.53370142299991,
							27.31135974500006
						],
						[
							-82.53373281799992,
							27.315466794000088
						],
						[
							-82.52965909799991,
							27.315380923000077
						],
						[
							-82.52965997299992,
							27.315497694000047
						],
						[
							-82.52962999999994,
							27.315500000000043
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "South Poinsettia",
				"RegionID": "343959"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.53865332299996,
					27.33012375000004,
					-82.53096090399994,
					27.33384013400007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.5368534719999,
							27.333822075000057
						],
						[
							-82.53646999999995,
							27.33382000000006
						],
						[
							-82.5363076079999,
							27.333823866000046
						],
						[
							-82.53621646199991,
							27.33382603700005
						],
						[
							-82.53573439999991,
							27.333830000000034
						],
						[
							-82.53526999999991,
							27.333830000000034
						],
						[
							-82.5352067099999,
							27.333830000000034
						],
						[
							-82.53497925699992,
							27.333830000000034
						],
						[
							-82.5347337039999,
							27.33382649500004
						],
						[
							-82.5345971129999,
							27.333824056000083
						],
						[
							-82.53449706599991,
							27.333822269000052
						],
						[
							-82.53436999999991,
							27.33382000000006
						],
						[
							-82.53414223099992,
							27.33382000000006
						],
						[
							-82.53384199399994,
							27.33382000000006
						],
						[
							-82.53356905099992,
							27.33382000000006
						],
						[
							-82.5331960279999,
							27.33382000000006
						],
						[
							-82.53301999999991,
							27.33382000000006
						],
						[
							-82.53297749199994,
							27.333815277000042
						],
						[
							-82.53289582199994,
							27.333809731000088
						],
						[
							-82.53274116299991,
							27.333808513000065
						],
						[
							-82.53257740799995,
							27.333807224000054
						],
						[
							-82.5323590669999,
							27.333805504000054
						],
						[
							-82.53229531199992,
							27.33380500200008
						],
						[
							-82.53222253199993,
							27.333804429000054
						],
						[
							-82.53209516599992,
							27.333803427000078
						],
						[
							-82.53187682499993,
							27.333801707000077
						],
						[
							-82.53165999999993,
							27.333800000000053
						],
						[
							-82.53160404899995,
							27.333798305000073
						],
						[
							-82.53147651699993,
							27.333794440000077
						],
						[
							-82.53140352299994,
							27.33379222800005
						],
						[
							-82.5312308369999,
							27.33379000000008
						],
						[
							-82.53103977699993,
							27.33379000000008
						],
						[
							-82.5309814549999,
							27.33379000000008
						],
						[
							-82.53096090399994,
							27.330220970000084
						],
						[
							-82.53119452499993,
							27.33021318300007
						],
						[
							-82.5314218979999,
							27.33021000000008
						],
						[
							-82.5318499999999,
							27.33021000000008
						],
						[
							-82.53217703999991,
							27.33021000000008
						],
						[
							-82.53256999999991,
							27.33021000000008
						],
						[
							-82.53288669299991,
							27.33021000000008
						],
						[
							-82.53330999999991,
							27.33021000000008
						],
						[
							-82.5336145409999,
							27.33021000000008
						],
						[
							-82.53411493699991,
							27.33021000000008
						],
						[
							-82.5343499999999,
							27.33021000000008
						],
						[
							-82.5346062349999,
							27.33021000000008
						],
						[
							-82.5347799999999,
							27.33021000000008
						],
						[
							-82.53597999999994,
							27.33015000000006
						],
						[
							-82.53607098399993,
							27.33014604400006
						],
						[
							-82.53612586399993,
							27.330143658000054
						],
						[
							-82.53627115899992,
							27.330137341000068
						],
						[
							-82.53633512099992,
							27.33013456000009
						],
						[
							-82.53650765899994,
							27.330127058000073
						],
						[
							-82.53657201499993,
							27.330124260000048
						],
						[
							-82.53670750299995,
							27.33012375000004
						],
						[
							-82.53676999999993,
							27.330130000000054
						],
						[
							-82.53681725399991,
							27.330136751000055
						],
						[
							-82.53688976899991,
							27.330141345000072
						],
						[
							-82.53699886699991,
							27.330144294000036
						],
						[
							-82.53703547799995,
							27.330145283000036
						],
						[
							-82.53712639299994,
							27.330147740000086
						],
						[
							-82.53724394499994,
							27.330153772000074
						],
						[
							-82.53731783899991,
							27.33016198200005
						],
						[
							-82.5373899999999,
							27.330170000000066
						],
						[
							-82.5374461369999,
							27.33018871200005
						],
						[
							-82.5375007259999,
							27.330206909000083
						],
						[
							-82.53756299399994,
							27.330207792000067
						],
						[
							-82.5376174889999,
							27.33020552100004
						],
						[
							-82.53769052599995,
							27.330202478000047
						],
						[
							-82.53779941499994,
							27.330204492000064
						],
						[
							-82.53785999999991,
							27.33021000000008
						],
						[
							-82.53796338899993,
							27.330208154000047
						],
						[
							-82.53812710299991,
							27.330205230000047
						],
						[
							-82.53818183599992,
							27.33020425300009
						],
						[
							-82.53836373999991,
							27.33020100500005
						],
						[
							-82.53846253699993,
							27.33018874600009
						],
						[
							-82.53854999999993,
							27.33018000000004
						],
						[
							-82.53856285099994,
							27.330177663000086
						],
						[
							-82.53859098599992,
							27.330172548000068
						],
						[
							-82.53860303099992,
							27.330259877000064
						],
						[
							-82.53865332299996,
							27.331215430000043
						],
						[
							-82.53863018899995,
							27.33384013400007
						],
						[
							-82.53853664299993,
							27.33383890300007
						],
						[
							-82.53827284399995,
							27.333835432000058
						],
						[
							-82.5381999519999,
							27.33383447300008
						],
						[
							-82.53800892499993,
							27.333831960000055
						],
						[
							-82.53785999999991,
							27.333830000000034
						],
						[
							-82.53769051799992,
							27.333828665000055
						],
						[
							-82.53730842099992,
							27.33382565700009
						],
						[
							-82.53712639899993,
							27.333824224000068
						],
						[
							-82.5368534719999,
							27.333822075000057
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Laurel Park",
				"RegionID": "343972"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.55489432199994,
					27.330442678000054,
					-82.5481066779999,
					27.336420023000077
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.55334655599995,
							27.336420023000077
						],
						[
							-82.5526591759999,
							27.335793985000066
						],
						[
							-82.55079462399993,
							27.335811513000067
						],
						[
							-82.55037240099995,
							27.335825406000083
						],
						[
							-82.55011159199995,
							27.33583382000006
						],
						[
							-82.54991999999993,
							27.335840000000076
						],
						[
							-82.5497302089999,
							27.33583457700007
						],
						[
							-82.54947387699991,
							27.335827254000037
						],
						[
							-82.54923512199991,
							27.335820432000048
						],
						[
							-82.54913999999991,
							27.33582000000007
						],
						[
							-82.54901246499992,
							27.335824070000058
						],
						[
							-82.54901299999995,
							27.335444000000052
						],
						[
							-82.54843458399995,
							27.334970601000066
						],
						[
							-82.5481181799999,
							27.33436998500008
						],
						[
							-82.5481206899999,
							27.333772294000088
						],
						[
							-82.54812752599992,
							27.332681380000054
						],
						[
							-82.54812371199995,
							27.332610549000037
						],
						[
							-82.54811374699995,
							27.332531535000044
						],
						[
							-82.5481066779999,
							27.332419000000073
						],
						[
							-82.54812134699995,
							27.332257329000072
						],
						[
							-82.54814335299994,
							27.33214082300009
						],
						[
							-82.5481767579999,
							27.332014967000077
						],
						[
							-82.54829814999994,
							27.331662746000063
						],
						[
							-82.54836679499994,
							27.331404211000066
						],
						[
							-82.54838741799995,
							27.331337192000035
						],
						[
							-82.5484132009999,
							27.33127198300008
						],
						[
							-82.54844398499995,
							27.331208980000046
						],
						[
							-82.54847958399995,
							27.33114856800006
						],
						[
							-82.54851978199991,
							27.331091113000074
						],
						[
							-82.54856433399993,
							27.33103696500007
						],
						[
							-82.54861296999991,
							27.330986452000047
						],
						[
							-82.54891797099992,
							27.330693452000048
						],
						[
							-82.54896292699993,
							27.330653079000058
						],
						[
							-82.54909133899992,
							27.33056316400007
						],
						[
							-82.5492334139999,
							27.33049691400004
						],
						[
							-82.5493848349999,
							27.33045634100006
						],
						[
							-82.54954099999992,
							27.330442678000054
						],
						[
							-82.54969716599993,
							27.33045634100006
						],
						[
							-82.5497214259999,
							27.330460963000064
						],
						[
							-82.55000813899994,
							27.330519678000087
						],
						[
							-82.55019399999992,
							27.330519678000087
						],
						[
							-82.55035016599993,
							27.330533341000034
						],
						[
							-82.55038175899995,
							27.33053949600009
						],
						[
							-82.5506487589999,
							27.330596496000055
						],
						[
							-82.55072319899996,
							27.33061574900006
						],
						[
							-82.55079572299991,
							27.330641290000074
						],
						[
							-82.55086579999995,
							27.330672933000073
						],
						[
							-82.55093291799994,
							27.33071044600007
						],
						[
							-82.55107891799992,
							27.330800446000072
						],
						[
							-82.55117900899995,
							27.330872037000063
						],
						[
							-82.55141800899992,
							27.331069036000088
						],
						[
							-82.55144389499992,
							27.331091210000068
						],
						[
							-82.55164389499993,
							27.331269210000073
						],
						[
							-82.55169583299994,
							27.331319311000073
						],
						[
							-82.55174358599993,
							27.33137341400004
						],
						[
							-82.55178684799995,
							27.331431173000055
						],
						[
							-82.55182533999994,
							27.33149221400004
						],
						[
							-82.55185881299991,
							27.331556144000047
						],
						[
							-82.55198381399993,
							27.33182014500005
						],
						[
							-82.55201019099991,
							27.331881676000084
						],
						[
							-82.55203191799991,
							27.331944999000086
						],
						[
							-82.55204887399992,
							27.33200976200004
						],
						[
							-82.55206096499991,
							27.332075608000082
						],
						[
							-82.5521019649999,
							27.332357607000063
						],
						[
							-82.55211132199992,
							27.33248700000007
						],
						[
							-82.55210212299994,
							27.332615304000058
						],
						[
							-82.55208458099992,
							27.33275097900008
						],
						[
							-82.55206836699995,
							27.333983041000067
						],
						[
							-82.55219753299991,
							27.33397760500009
						],
						[
							-82.55227438499992,
							27.33396562100006
						],
						[
							-82.55232925199995,
							27.333911870000065
						],
						[
							-82.55247945199994,
							27.333790686000043
						],
						[
							-82.55249407899993,
							27.333771927000043
						],
						[
							-82.55256550199994,
							27.333696184000075
						],
						[
							-82.55265550199994,
							27.333611183000073
						],
						[
							-82.55271737999993,
							27.333557846000076
						],
						[
							-82.5529553799999,
							27.333370846000037
						],
						[
							-82.5530613389999,
							27.33329916400004
						],
						[
							-82.55320341399994,
							27.333232914000064
						],
						[
							-82.55335483399995,
							27.33319234100009
						],
						[
							-82.5535109999999,
							27.33317867800008
						],
						[
							-82.55366716599991,
							27.33319234100009
						],
						[
							-82.55381858599992,
							27.333232914000064
						],
						[
							-82.5539606609999,
							27.33329916400004
						],
						[
							-82.55404346699993,
							27.333353253000045
						],
						[
							-82.55433817199992,
							27.33356977200009
						],
						[
							-82.55439987599993,
							27.33361528900008
						],
						[
							-82.55444826099995,
							27.33365361500006
						],
						[
							-82.55449390399993,
							27.333695170000055
						],
						[
							-82.5545365879999,
							27.333739757000046
						],
						[
							-82.55457611399993,
							27.333787167000082
						],
						[
							-82.5547051129999,
							27.33395316800005
						],
						[
							-82.55477383499993,
							27.334055339000088
						],
						[
							-82.5548400859999,
							27.334197414000077
						],
						[
							-82.55488065899993,
							27.33434883400008
						],
						[
							-82.55489432199994,
							27.334505000000036
						],
						[
							-82.55488065899993,
							27.334661166000046
						],
						[
							-82.55484053399994,
							27.334811352000088
						],
						[
							-82.5546403109999,
							27.33536396900007
						],
						[
							-82.55461275399995,
							27.335431245000052
						],
						[
							-82.55457985299995,
							27.335496075000037
						],
						[
							-82.55454182299991,
							27.335558035000076
						],
						[
							-82.55449891299992,
							27.335616721000065
						],
						[
							-82.55445140199993,
							27.335671750000074
						],
						[
							-82.55439960199995,
							27.335722761000056
						],
						[
							-82.55434385099994,
							27.335769421000066
						],
						[
							-82.55428451299991,
							27.335811426000078
						],
						[
							-82.55334655599995,
							27.336420023000077
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Golden Gate Point",
				"RegionID": "343973"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.55249698099993,
					27.324190526000052,
					-82.52415769999993,
					27.33888222300004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.52420944999994,
							27.337528558000088
						],
						[
							-82.52415769999993,
							27.33559581500009
						],
						[
							-82.5244470749999,
							27.33559000000008
						],
						[
							-82.52482002099993,
							27.33558739600005
						],
						[
							-82.52513291899993,
							27.33558413600008
						],
						[
							-82.52556669699995,
							27.335580483000058
						],
						[
							-82.5260292079999,
							27.335586569000043
						],
						[
							-82.5262899999999,
							27.33559000000008
						],
						[
							-82.52638486699993,
							27.33559000000008
						],
						[
							-82.52664278499992,
							27.33559000000008
						],
						[
							-82.52719419599993,
							27.33559000000008
						],
						[
							-82.52783454299993,
							27.33559000000008
						],
						[
							-82.52825999999993,
							27.33559000000008
						],
						[
							-82.52835928999991,
							27.33559064500008
						],
						[
							-82.52870613099992,
							27.335592897000083
						],
						[
							-82.5290974959999,
							27.33559543800004
						],
						[
							-82.52960441599993,
							27.335598730000072
						],
						[
							-82.52979999999991,
							27.33560000000006
						],
						[
							-82.52992456399996,
							27.335602419000054
						],
						[
							-82.53007587199994,
							27.335605357000077
						],
						[
							-82.53034258299994,
							27.335610536000047
						],
						[
							-82.53056484299992,
							27.33561485100006
						],
						[
							-82.5308495139999,
							27.335620000000063
						],
						[
							-82.53099201899994,
							27.33562450800008
						],
						[
							-82.53098524899991,
							27.334448898000062
						],
						[
							-82.53101090699994,
							27.334448097000063
						],
						[
							-82.5310916869999,
							27.334445572000053
						],
						[
							-82.53120092599994,
							27.334442159000048
						],
						[
							-82.5314334659999,
							27.334441868000056
						],
						[
							-82.5316994659999,
							27.33444490800008
						],
						[
							-82.53196055599994,
							27.33444789200007
						],
						[
							-82.53219791099991,
							27.334450605000086
						],
						[
							-82.53237355399995,
							27.334452612000064
						],
						[
							-82.53260135999994,
							27.33445521600004
						],
						[
							-82.53274851999994,
							27.334456897000052
						],
						[
							-82.53285311799993,
							27.33445809300008
						],
						[
							-82.53296704899992,
							27.334459395000067
						],
						[
							-82.53301999999991,
							27.334460000000036
						],
						[
							-82.53301999999991,
							27.334287860000074
						],
						[
							-82.53301999999991,
							27.334002997000084
						],
						[
							-82.53301999999991,
							27.333898547000047
						],
						[
							-82.53301999999991,
							27.33382000000006
						],
						[
							-82.5331960279999,
							27.33382000000006
						],
						[
							-82.53356905099992,
							27.33382000000006
						],
						[
							-82.53384199399994,
							27.33382000000006
						],
						[
							-82.53414223099992,
							27.33382000000006
						],
						[
							-82.53436999999991,
							27.33382000000006
						],
						[
							-82.53449706599991,
							27.333822269000052
						],
						[
							-82.5345971129999,
							27.333824056000083
						],
						[
							-82.5347337039999,
							27.33382649500004
						],
						[
							-82.53497925699992,
							27.333830000000034
						],
						[
							-82.5352067099999,
							27.333830000000034
						],
						[
							-82.53526999999991,
							27.333830000000034
						],
						[
							-82.53573439999991,
							27.333830000000034
						],
						[
							-82.53621646199991,
							27.33382603700005
						],
						[
							-82.5363076079999,
							27.333823866000046
						],
						[
							-82.53646999999995,
							27.33382000000006
						],
						[
							-82.5368534719999,
							27.333822075000057
						],
						[
							-82.53712639899993,
							27.333824224000068
						],
						[
							-82.53730842099992,
							27.33382565700009
						],
						[
							-82.53769051799992,
							27.333828665000055
						],
						[
							-82.53785999999991,
							27.333830000000034
						],
						[
							-82.53800892499993,
							27.333831960000055
						],
						[
							-82.5381999519999,
							27.33383447300008
						],
						[
							-82.53827284399995,
							27.333835432000058
						],
						[
							-82.53853664299993,
							27.33383890300007
						],
						[
							-82.53863018899995,
							27.33384013400007
						],
						[
							-82.53865332299996,
							27.331215430000043
						],
						[
							-82.53860303099992,
							27.330259877000064
						],
						[
							-82.53859098599992,
							27.330172548000068
						],
						[
							-82.53856285099994,
							27.330177663000086
						],
						[
							-82.53854999999993,
							27.33018000000004
						],
						[
							-82.53846253699993,
							27.33018874600009
						],
						[
							-82.53836373999991,
							27.33020100500005
						],
						[
							-82.53818183599992,
							27.33020425300009
						],
						[
							-82.53812710299991,
							27.330205230000047
						],
						[
							-82.53796338899993,
							27.330208154000047
						],
						[
							-82.53785999999991,
							27.33021000000008
						],
						[
							-82.53779941499994,
							27.330204492000064
						],
						[
							-82.53769052599995,
							27.330202478000047
						],
						[
							-82.5376174889999,
							27.33020552100004
						],
						[
							-82.53756299399994,
							27.330207792000067
						],
						[
							-82.5375007259999,
							27.330206909000083
						],
						[
							-82.5374461369999,
							27.33018871200005
						],
						[
							-82.5373899999999,
							27.330170000000066
						],
						[
							-82.53731783899991,
							27.33016198200005
						],
						[
							-82.53724394499994,
							27.330153772000074
						],
						[
							-82.53712639299994,
							27.330147740000086
						],
						[
							-82.53703547799995,
							27.330145283000036
						],
						[
							-82.53699886699991,
							27.330144294000036
						],
						[
							-82.53688976899991,
							27.330141345000072
						],
						[
							-82.53681725399991,
							27.330136751000055
						],
						[
							-82.53676999999993,
							27.330130000000054
						],
						[
							-82.53670750299995,
							27.33012375000004
						],
						[
							-82.53657201499993,
							27.330124260000048
						],
						[
							-82.53650765899994,
							27.330127058000073
						],
						[
							-82.53633512099992,
							27.33013456000009
						],
						[
							-82.53627115899992,
							27.330137341000068
						],
						[
							-82.53612586399993,
							27.330143658000054
						],
						[
							-82.53607098399993,
							27.33014604400006
						],
						[
							-82.53597999999994,
							27.33015000000006
						],
						[
							-82.5347799999999,
							27.33021000000008
						],
						[
							-82.5346062349999,
							27.33021000000008
						],
						[
							-82.5343499999999,
							27.33021000000008
						],
						[
							-82.53411493699991,
							27.33021000000008
						],
						[
							-82.5336145409999,
							27.33021000000008
						],
						[
							-82.53330999999991,
							27.33021000000008
						],
						[
							-82.53288669299991,
							27.33021000000008
						],
						[
							-82.53256999999991,
							27.33021000000008
						],
						[
							-82.53217703999991,
							27.33021000000008
						],
						[
							-82.5318499999999,
							27.33021000000008
						],
						[
							-82.5314218979999,
							27.33021000000008
						],
						[
							-82.53119452499993,
							27.33021318300007
						],
						[
							-82.53096090399994,
							27.330220970000084
						],
						[
							-82.53095861899993,
							27.329824013000064
						],
						[
							-82.53087479999994,
							27.329404911000044
						],
						[
							-82.53075745199993,
							27.32895228500007
						],
						[
							-82.5305730469999,
							27.32854994300004
						],
						[
							-82.53033834999991,
							27.327963201000046
						],
						[
							-82.53001983299993,
							27.327141762000057
						],
						[
							-82.52985213999995,
							27.32663885000005
						],
						[
							-82.52981866399995,
							27.32601857000009
						],
						[
							-82.52975160699992,
							27.32514683900007
						],
						[
							-82.52975160799991,
							27.32459362500009
						],
						[
							-82.5297456699999,
							27.324190526000052
						],
						[
							-82.52987475599991,
							27.324297281000042
						],
						[
							-82.53102774999991,
							27.325397473000066
						],
						[
							-82.53127320399996,
							27.32543733500006
						],
						[
							-82.5314366419999,
							27.325524159000054
						],
						[
							-82.53179926999992,
							27.325810172000047
						],
						[
							-82.53205972899993,
							27.325932841000053
						],
						[
							-82.53226915899995,
							27.32595318500006
						],
						[
							-82.5324662829999,
							27.32601068000008
						],
						[
							-82.53247045799992,
							27.326641118000058
						],
						[
							-82.53215787799991,
							27.32710525300007
						],
						[
							-82.5321294609999,
							27.327706735000053
						],
						[
							-82.53214366899994,
							27.32833663200006
						],
						[
							-82.53376500399992,
							27.328313249000075
						],
						[
							-82.53376256299993,
							27.32845588400005
						],
						[
							-82.53376999999995,
							27.32856000000004
						],
						[
							-82.53383171799993,
							27.328552879000085
						],
						[
							-82.53396131499994,
							27.328537925000038
						],
						[
							-82.5340431919999,
							27.328528478000067
						],
						[
							-82.53423286499992,
							27.328506592000053
						],
						[
							-82.53441196299991,
							27.32848475500009
						],
						[
							-82.53456591799994,
							27.328465510000058
						],
						[
							-82.53471863599992,
							27.328460000000064
						],
						[
							-82.53482999999994,
							27.328460000000064
						],
						[
							-82.53485372699993,
							27.328456610000046
						],
						[
							-82.53488499999992,
							27.32845214300005
						],
						[
							-82.53495477299992,
							27.328450000000093
						],
						[
							-82.53506964999991,
							27.328450000000093
						],
						[
							-82.53518999999994,
							27.328450000000093
						],
						[
							-82.53527387599992,
							27.328450000000093
						],
						[
							-82.53537598899993,
							27.328450000000093
						],
						[
							-82.5356057429999,
							27.328450000000093
						],
						[
							-82.53580358699992,
							27.328450000000093
						],
						[
							-82.53599504899995,
							27.328450000000093
						],
						[
							-82.53616736499993,
							27.328450000000093
						],
						[
							-82.53635251399993,
							27.32844997600006
						],
						[
							-82.53649290699991,
							27.328448613000035
						],
						[
							-82.53664606199993,
							27.32844712600007
						],
						[
							-82.5368247429999,
							27.32844539100006
						],
						[
							-82.53697789799992,
							27.32844390400004
						],
						[
							-82.53724591899993,
							27.328441302000044
						],
						[
							-82.53737999999993,
							27.328440000000057
						],
						[
							-82.53748846499991,
							27.32844202700005
						],
						[
							-82.53760342099991,
							27.328444176000062
						],
						[
							-82.53771825799993,
							27.328446323000037
						],
						[
							-82.53783959399993,
							27.328448591000043
						],
						[
							-82.53796081099995,
							27.328450856000075
						],
						[
							-82.53805650899994,
							27.328452645000084
						],
						[
							-82.53820974399991,
							27.328455509000037
						],
						[
							-82.53834372099993,
							27.328458013000045
						],
						[
							-82.5384499999999,
							27.328460000000064
						],
						[
							-82.53861658999995,
							27.32845739700008
						],
						[
							-82.53879709599994,
							27.32845457700006
						],
						[
							-82.53896758199994,
							27.328451913000038
						],
						[
							-82.53918800899993,
							27.32844846900008
						],
						[
							-82.53943849299992,
							27.32844455500009
						],
						[
							-82.53962886199992,
							27.32844158000006
						],
						[
							-82.5397299999999,
							27.328440000000057
						],
						[
							-82.53977367899995,
							27.32844376500009
						],
						[
							-82.5398130509999,
							27.328447160000053
						],
						[
							-82.53988854799991,
							27.328453668000066
						],
						[
							-82.5399992529999,
							27.32846321100004
						],
						[
							-82.54000624199995,
							27.328293418000044
						],
						[
							-82.54089698899992,
							27.328328664000082
						],
						[
							-82.5417172729999,
							27.32795982100004
						],
						[
							-82.54242485599991,
							27.329588680000086
						],
						[
							-82.54245313799993,
							27.329661644000055
						],
						[
							-82.54247466299995,
							27.329736878000062
						],
						[
							-82.54248925299993,
							27.329813759000047
						],
						[
							-82.54249678799994,
							27.329891649000047
						],
						[
							-82.54249720399991,
							27.329969901000084
						],
						[
							-82.54249049799995,
							27.330047866000086
						],
						[
							-82.54270439499993,
							27.33062022100006
						],
						[
							-82.54279758199993,
							27.33078439400009
						],
						[
							-82.54280816399995,
							27.330763339000043
						],
						[
							-82.54289278399995,
							27.330641298000046
						],
						[
							-82.54294878399992,
							27.330573297000058
						],
						[
							-82.54304734099992,
							27.33047122700009
						],
						[
							-82.54308769499995,
							27.33043555100005
						],
						[
							-82.5431443029999,
							27.330376215000058
						],
						[
							-82.54317991499994,
							27.330340913000043
						],
						[
							-82.54329191499994,
							27.33023591300008
						],
						[
							-82.54334739799992,
							27.33018799100006
						],
						[
							-82.54340660199995,
							27.33014474900006
						],
						[
							-82.54346913099994,
							27.330106474000047
						],
						[
							-82.54353457099995,
							27.330073420000076
						],
						[
							-82.54360248599994,
							27.33004580800008
						],
						[
							-82.54370378099992,
							27.330009758000074
						],
						[
							-82.54383579099994,
							27.329960799000048
						],
						[
							-82.5439455529999,
							27.32992170400007
						],
						[
							-82.54409083399992,
							27.329883340000038
						],
						[
							-82.5441969499999,
							27.32987459800006
						],
						[
							-82.5442353389999,
							27.329848165000044
						],
						[
							-82.54426296799994,
							27.329834429000073
						],
						[
							-82.54437534099992,
							27.329778022000085
						],
						[
							-82.54440137899991,
							27.329759166000088
						],
						[
							-82.54446743699992,
							27.329727383000094
						],
						[
							-82.54453586499994,
							27.329701085000067
						],
						[
							-82.54460620599991,
							27.32968044800009
						],
						[
							-82.54467799499992,
							27.329665609000074
						],
						[
							-82.54475075399995,
							27.329656665000073
						],
						[
							-82.54482399999995,
							27.329653678000057
						],
						[
							-82.5449769999999,
							27.329653678000057
						],
						[
							-82.5451371289999,
							27.32966805700005
						],
						[
							-82.54523809099993,
							27.329686775000084
						],
						[
							-82.54532556999993,
							27.329707581000036
						],
						[
							-82.54560356999991,
							27.32978858000007
						],
						[
							-82.54564997599994,
							27.32980347700004
						],
						[
							-82.54594897699991,
							27.32990847800005
						],
						[
							-82.54602466199992,
							27.329938980000065
						],
						[
							-82.54626766199995,
							27.33004998000007
						],
						[
							-82.54634366099992,
							27.33008916400007
						],
						[
							-82.54640457799991,
							27.330127668000046
						],
						[
							-82.54649157699993,
							27.330187668000065
						],
						[
							-82.54657280499993,
							27.330250839000087
						],
						[
							-82.54669180499991,
							27.33035484000004
						],
						[
							-82.5467787689999,
							27.330442040000037
						],
						[
							-82.54686191499991,
							27.330537702000075
						],
						[
							-82.54698368699991,
							27.330668701000036
						],
						[
							-82.54701972299995,
							27.330709914000067
						],
						[
							-82.54709832399993,
							27.330805532000056
						],
						[
							-82.5471600169999,
							27.33087143100005
						],
						[
							-82.54721604199995,
							27.33091440900006
						],
						[
							-82.54723658599994,
							27.33091991300006
						],
						[
							-82.54737866099993,
							27.33098616400008
						],
						[
							-82.5475070729999,
							27.33107607900007
						],
						[
							-82.54761791999994,
							27.33118692700009
						],
						[
							-82.54770783499993,
							27.33131533900007
						],
						[
							-82.54777408599995,
							27.331457413000066
						],
						[
							-82.54781465899993,
							27.331608834000065
						],
						[
							-82.54782080399991,
							27.331648964000067
						],
						[
							-82.54785580499993,
							27.33191796400007
						],
						[
							-82.54786332199991,
							27.33203400000008
						],
						[
							-82.54784965999994,
							27.33219016600009
						],
						[
							-82.5478090869999,
							27.332341587000087
						],
						[
							-82.54774283599994,
							27.332483661000087
						],
						[
							-82.54765292099995,
							27.332612073000064
						],
						[
							-82.54754207299993,
							27.332722921000084
						],
						[
							-82.54751361799993,
							27.33274437600005
						],
						[
							-82.5474170729999,
							27.33284092100007
						],
						[
							-82.54728029199993,
							27.332934738000063
						],
						[
							-82.54728532199994,
							27.333042000000034
						],
						[
							-82.54727165899993,
							27.333198166000045
						],
						[
							-82.5472310859999,
							27.333349586000054
						],
						[
							-82.54716483499993,
							27.33349166100004
						],
						[
							-82.54707491999994,
							27.333620073000077
						],
						[
							-82.54705488199994,
							27.333643146000043
						],
						[
							-82.5468478759999,
							27.333873478000044
						],
						[
							-82.54785467199991,
							27.334249527000054
						],
						[
							-82.54792233199993,
							27.334277997000072
						],
						[
							-82.5481181799999,
							27.33436998500008
						],
						[
							-82.54843458399995,
							27.334970601000066
						],
						[
							-82.54901299999995,
							27.335444000000052
						],
						[
							-82.54901246499992,
							27.335824070000058
						],
						[
							-82.54913999999991,
							27.33582000000007
						],
						[
							-82.54923512199991,
							27.335820432000048
						],
						[
							-82.54947387699991,
							27.335827254000037
						],
						[
							-82.5497302089999,
							27.33583457700007
						],
						[
							-82.54991999999993,
							27.335840000000076
						],
						[
							-82.54991999999993,
							27.336124271000074
						],
						[
							-82.54992460499994,
							27.33638592000006
						],
						[
							-82.55176482799993,
							27.336374190000072
						],
						[
							-82.55249698099993,
							27.336971273000074
						],
						[
							-82.55231911499993,
							27.337086683000052
						],
						[
							-82.55186214299994,
							27.337382508000076
						],
						[
							-82.55162468099991,
							27.337692211000046
						],
						[
							-82.55152610899995,
							27.337801065000065
						],
						[
							-82.55149281599995,
							27.337832280000043
						],
						[
							-82.55077312299994,
							27.338060038000037
						],
						[
							-82.5502951389999,
							27.33820940800007
						],
						[
							-82.54990677599994,
							27.338239282000075
						],
						[
							-82.54924954699993,
							27.338418527000044
						],
						[
							-82.5488914469999,
							27.338333695000074
						],
						[
							-82.5481254799999,
							27.338332334000086
						],
						[
							-82.5474268989999,
							27.338330849000045
						],
						[
							-82.54677389999995,
							27.338329473000044
						],
						[
							-82.5467787689999,
							27.33670287700005
						],
						[
							-82.54655911299994,
							27.336680911000087
						],
						[
							-82.54627979899993,
							27.33664077700007
						],
						[
							-82.54607819599994,
							27.336611512000047
						],
						[
							-82.54592999999994,
							27.336590000000058
						],
						[
							-82.54580921999991,
							27.336573741000056
						],
						[
							-82.54563562899995,
							27.33655037300008
						],
						[
							-82.5454645769999,
							27.336527347000075
						],
						[
							-82.54534708699993,
							27.336500133000072
						],
						[
							-82.54521999999992,
							27.336460000000045
						],
						[
							-82.54510999999991,
							27.33642000000009
						],
						[
							-82.54504865399991,
							27.33639546200004
						],
						[
							-82.54494098799995,
							27.336350494000044
						],
						[
							-82.54476044599994,
							27.336260223000068
						],
						[
							-82.54464384199991,
							27.336198983000088
						],
						[
							-82.54451183499992,
							27.336108978000084
						],
						[
							-82.54438403499995,
							27.336018027000083
						],
						[
							-82.54426111299995,
							27.33592583500007
						],
						[
							-82.5441305089999,
							27.335827882000046
						],
						[
							-82.54395999999991,
							27.335700000000088
						],
						[
							-82.54389542099995,
							27.33565156600008
						],
						[
							-82.54377096199995,
							27.33555822200009
						],
						[
							-82.54359999999991,
							27.335430000000088
						],
						[
							-82.54347215299993,
							27.335335504000057
						],
						[
							-82.54329935299995,
							27.335201820000066
						],
						[
							-82.5431999999999,
							27.335120000000074
						],
						[
							-82.54311235099995,
							27.335051000000078
						],
						[
							-82.5429898619999,
							27.334954572000072
						],
						[
							-82.54283306199994,
							27.334831134000073
						],
						[
							-82.5426707929999,
							27.334697136000045
						],
						[
							-82.54252918999993,
							27.33457070600008
						],
						[
							-82.54235714099991,
							27.334407141000042
						],
						[
							-82.54221999999993,
							27.33427000000006
						],
						[
							-82.54207938199994,
							27.334357886000078
						],
						[
							-82.54195603999995,
							27.334441782000056
						],
						[
							-82.54181762099996,
							27.334537357000045
						],
						[
							-82.54163999999992,
							27.334660000000042
						],
						[
							-82.54150202299991,
							27.334750108000037
						],
						[
							-82.5413459479999,
							27.33485203400005
						],
						[
							-82.54125664399993,
							27.33491035500009
						],
						[
							-82.5411499999999,
							27.334980000000087
						],
						[
							-82.5410407309999,
							27.335041394000086
						],
						[
							-82.54080999999991,
							27.334790000000055
						],
						[
							-82.54069219599995,
							27.334829268000078
						],
						[
							-82.54059999999993,
							27.33486000000005
						],
						[
							-82.54060129499993,
							27.33491180900006
						],
						[
							-82.54060657399992,
							27.335122949000038
						],
						[
							-82.5406099999999,
							27.335260000000062
						],
						[
							-82.54061209199995,
							27.335343686000044
						],
						[
							-82.54061497099991,
							27.33545885400008
						],
						[
							-82.5406176169999,
							27.33556466400006
						],
						[
							-82.54061999999993,
							27.335660000000075
						],
						[
							-82.54061393299992,
							27.335775280000064
						],
						[
							-82.54060989999994,
							27.335851894000086
						],
						[
							-82.54060379899994,
							27.33596782300009
						],
						[
							-82.54059999999993,
							27.336040000000082
						],
						[
							-82.54059999999993,
							27.336159918000078
						],
						[
							-82.54059999999993,
							27.336313570000073
						],
						[
							-82.54059999999993,
							27.33645000000007
						],
						[
							-82.54059999999993,
							27.336544049000054
						],
						[
							-82.54059999999993,
							27.336716908000085
						],
						[
							-82.54059999999993,
							27.33690000000007
						],
						[
							-82.54060238499994,
							27.33698585500008
						],
						[
							-82.54060664999992,
							27.337139388000082
						],
						[
							-82.5406099999999,
							27.33726000000007
						],
						[
							-82.54063696299994,
							27.337319319000073
						],
						[
							-82.54065143399993,
							27.33735115400009
						],
						[
							-82.54065964999995,
							27.337379447000046
						],
						[
							-82.54065538799995,
							27.337494529000082
						],
						[
							-82.54065183599994,
							27.33759043000009
						],
						[
							-82.54064650799995,
							27.337734282000042
						],
						[
							-82.54064257499994,
							27.337840483000036
						],
						[
							-82.54063999999994,
							27.33797493700007
						],
						[
							-82.54063999999994,
							27.33806000000004
						],
						[
							-82.54063799799991,
							27.33813807000007
						],
						[
							-82.54063494999991,
							27.338256966000074
						],
						[
							-82.54062999999991,
							27.33845000000008
						],
						[
							-82.54062999999991,
							27.338604485000076
						],
						[
							-82.54062999999991,
							27.33886142500006
						],
						[
							-82.53861016699996,
							27.33887130700009
						],
						[
							-82.53100380199993,
							27.338882169000044
						],
						[
							-82.53011273899995,
							27.33888222300004
						],
						[
							-82.5293372189999,
							27.33888222300004
						],
						[
							-82.52854181399994,
							27.33880268300004
						],
						[
							-82.52796514799991,
							27.338663488000066
						],
						[
							-82.52724928099991,
							27.338345325000034
						],
						[
							-82.52637433599995,
							27.337927739000065
						],
						[
							-82.52569823999994,
							27.33764934700008
						],
						[
							-82.5249823769999,
							27.33753003600009
						],
						[
							-82.52420944999994,
							27.337528558000088
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Downtown",
				"RegionID": "343974"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.50986287799992,
					27.348644211000078,
					-82.50571796799994,
					27.351735000000076
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.50984899999992,
							27.351735000000076
						],
						[
							-82.50901199999993,
							27.351716000000067
						],
						[
							-82.50819799999994,
							27.351722000000052
						],
						[
							-82.50737199999992,
							27.351722000000052
						],
						[
							-82.5065459999999,
							27.351725000000048
						],
						[
							-82.50571837199993,
							27.351727818000086
						],
						[
							-82.50571796799994,
							27.348644215000036
						],
						[
							-82.50986287799992,
							27.348644211000078
						],
						[
							-82.50984899999992,
							27.351735000000076
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Poinsettia Park",
				"RegionID": "343975"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.79822405699991,
					30.29251394900007,
					-81.76729986799995,
					30.31513916600005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.7822617949999,
							30.31513916600005
						],
						[
							-81.78222301699992,
							30.315022849000062
						],
						[
							-81.78147690499992,
							30.31503600800005
						],
						[
							-81.78124790599992,
							30.31503600800005
						],
						[
							-81.78108390599994,
							30.315053008000064
						],
						[
							-81.77997890599994,
							30.31505600800006
						],
						[
							-81.77925690599994,
							30.315070008000074
						],
						[
							-81.77870090599993,
							30.31506600800009
						],
						[
							-81.77863290599993,
							30.31506600800009
						],
						[
							-81.7784869059999,
							30.315069008000076
						],
						[
							-81.77804290599994,
							30.31507200800007
						],
						[
							-81.77728292199993,
							30.315077062000057
						],
						[
							-81.7772970879999,
							30.314968948000057
						],
						[
							-81.77710673899992,
							30.314783081000087
						],
						[
							-81.77710690799995,
							30.314373010000057
						],
						[
							-81.7771059079999,
							30.313847010000078
						],
						[
							-81.77711404099995,
							30.313664879000044
						],
						[
							-81.77496590699991,
							30.313701011000038
						],
						[
							-81.77348278099993,
							30.313730143000043
						],
						[
							-81.77345990499992,
							30.31305701200006
						],
						[
							-81.77323890799994,
							30.312471011000074
						],
						[
							-81.77295690699992,
							30.31177101100008
						],
						[
							-81.77265190799994,
							30.311007011000072
						],
						[
							-81.77212490799991,
							30.309736010000048
						],
						[
							-81.7720179069999,
							30.309448011000086
						],
						[
							-81.77178190699993,
							30.308893010000073
						],
						[
							-81.77157490799993,
							30.30829601000005
						],
						[
							-81.77151390799992,
							30.30798901000009
						],
						[
							-81.77148290799994,
							30.307682010000065
						],
						[
							-81.77147590699991,
							30.30740501100007
						],
						[
							-81.77149090699993,
							30.307099010000062
						],
						[
							-81.77152790899993,
							30.306659011000082
						],
						[
							-81.7716120639999,
							30.306311910000094
						],
						[
							-81.77152290799995,
							30.306291010000052
						],
						[
							-81.77142490799991,
							30.306253011000077
						],
						[
							-81.77114890699994,
							30.306144010000082
						],
						[
							-81.7708919079999,
							30.306024010000048
						],
						[
							-81.77067590699994,
							30.305902010000068
						],
						[
							-81.77042390799994,
							30.305740010000083
						],
						[
							-81.7701489069999,
							30.305510010000038
						],
						[
							-81.77007290799992,
							30.305445010000085
						],
						[
							-81.76979790799993,
							30.305149010000033
						],
						[
							-81.76961490799994,
							30.30489701000005
						],
						[
							-81.76953090799994,
							30.304752010000076
						],
						[
							-81.7693939049999,
							30.304470009000056
						],
						[
							-81.7693709099999,
							30.304440011000054
						],
						[
							-81.76928490799992,
							30.30426501000005
						],
						[
							-81.76890390799991,
							30.303295010000056
						],
						[
							-81.76840790699993,
							30.302095011000063
						],
						[
							-81.7679179079999,
							30.300889011000038
						],
						[
							-81.76773490799991,
							30.300414011000044
						],
						[
							-81.76729986799995,
							30.29940092900006
						],
						[
							-81.76824390599995,
							30.29894500900008
						],
						[
							-81.76885790499995,
							30.29864900800004
						],
						[
							-81.76907990599994,
							30.29853700900009
						],
						[
							-81.76932790599994,
							30.298414008000066
						],
						[
							-81.76966990499994,
							30.29825100800008
						],
						[
							-81.77023590599993,
							30.297978008000086
						],
						[
							-81.77059490599993,
							30.297799009000077
						],
						[
							-81.77085899199994,
							30.297662066000044
						],
						[
							-81.77214690599993,
							30.297024008000047
						],
						[
							-81.77297790599994,
							30.29661500800006
						],
						[
							-81.77321090599992,
							30.29650400800006
						],
						[
							-81.77388290499994,
							30.296181008000072
						],
						[
							-81.77625498999993,
							30.29501011200006
						],
						[
							-81.77633581999993,
							30.294923904000086
						],
						[
							-81.77708790499992,
							30.29453500900007
						],
						[
							-81.77775690599992,
							30.29425600800005
						],
						[
							-81.77797690599994,
							30.294151009000075
						],
						[
							-81.77945890599995,
							30.29342200800005
						],
						[
							-81.78006390599995,
							30.293120008000077
						],
						[
							-81.7808329049999,
							30.292736008000077
						],
						[
							-81.7813458199999,
							30.29251394900007
						],
						[
							-81.78133990599991,
							30.29260000800008
						],
						[
							-81.78135690599993,
							30.29358500900008
						],
						[
							-81.78133390599993,
							30.294691009000076
						],
						[
							-81.78132990599995,
							30.29508600900004
						],
						[
							-81.78133890599992,
							30.295554008000067
						],
						[
							-81.78136190699992,
							30.29577301100005
						],
						[
							-81.78146990599993,
							30.29614200800006
						],
						[
							-81.78155990599993,
							30.29636100800008
						],
						[
							-81.78165790599991,
							30.296550008000057
						],
						[
							-81.78181390599991,
							30.29679300700008
						],
						[
							-81.78205390599993,
							30.29706300800007
						],
						[
							-81.78278590499991,
							30.297705009000087
						],
						[
							-81.78292890699993,
							30.297840009000087
						],
						[
							-81.78307290499993,
							30.297993009000034
						],
						[
							-81.78328390599995,
							30.298261008000054
						],
						[
							-81.78337190499991,
							30.298400009000094
						],
						[
							-81.78350490499992,
							30.298654009000074
						],
						[
							-81.78361490499992,
							30.29894300800004
						],
						[
							-81.78368190499992,
							30.299223008000073
						],
						[
							-81.7837099059999,
							30.299419008000086
						],
						[
							-81.78371790499995,
							30.299601008000078
						],
						[
							-81.78368776199996,
							30.30049213000007
						],
						[
							-81.7869939059999,
							30.300865008000077
						],
						[
							-81.78761690499994,
							30.30093900900005
						],
						[
							-81.78970590599994,
							30.301181008000075
						],
						[
							-81.78977590599993,
							30.30118900900004
						],
						[
							-81.79174090499993,
							30.30141400800005
						],
						[
							-81.79444590599991,
							30.30172600800006
						],
						[
							-81.79678090599992,
							30.301999008000053
						],
						[
							-81.79798900599991,
							30.302132106000045
						],
						[
							-81.79822405699991,
							30.302148942000088
						],
						[
							-81.79368650999993,
							30.308133428000076
						],
						[
							-81.79287697299992,
							30.31277312900005
						],
						[
							-81.79265790599993,
							30.31280301000004
						],
						[
							-81.79241590399994,
							30.312880012000054
						],
						[
							-81.79220490599995,
							30.31303300900004
						],
						[
							-81.79178597299995,
							30.31341818200008
						],
						[
							-81.78993390499994,
							30.313460009000035
						],
						[
							-81.78959890599992,
							30.313458008000055
						],
						[
							-81.78840190499994,
							30.313479009000048
						],
						[
							-81.78800790499992,
							30.313488008000036
						],
						[
							-81.78678590499995,
							30.313504008000052
						],
						[
							-81.78545990499993,
							30.313533008000036
						],
						[
							-81.78414290599996,
							30.313548008000055
						],
						[
							-81.78357177299995,
							30.313566880000057
						],
						[
							-81.78358590499994,
							30.314274008000037
						],
						[
							-81.7835969059999,
							30.314877008000057
						],
						[
							-81.78361190599992,
							30.315001009000074
						],
						[
							-81.78362003899991,
							30.315122138000053
						],
						[
							-81.78338990499992,
							30.31512100800006
						],
						[
							-81.7829869059999,
							30.315127008000047
						],
						[
							-81.78250590599993,
							30.315135008000084
						],
						[
							-81.7822617949999,
							30.31513916600005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Rolling Hills",
				"RegionID": "275230"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.47519285699991,
					27.981678448000082,
					-82.45365908799994,
					27.996216918000073
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.4537158569999,
							27.995852554000066
						],
						[
							-82.45365908799994,
							27.981800000000078
						],
						[
							-82.46766363599994,
							27.981800054000075
						],
						[
							-82.47361818099995,
							27.981800000000078
						],
						[
							-82.47464350099996,
							27.98172085400006
						],
						[
							-82.47519285699991,
							27.981678448000082
						],
						[
							-82.47500881899992,
							27.98185830300008
						],
						[
							-82.4742701049999,
							27.98269233500008
						],
						[
							-82.47355522099991,
							27.983550196000067
						],
						[
							-82.47312628999993,
							27.984026786000072
						],
						[
							-82.4726020409999,
							27.98462252300004
						],
						[
							-82.47207779299993,
							27.98517060100005
						],
						[
							-82.47150588499994,
							27.985694850000073
						],
						[
							-82.47095780699995,
							27.98617143900009
						],
						[
							-82.47048121699993,
							27.98671951700004
						],
						[
							-82.47024292299994,
							27.987172278000063
						],
						[
							-82.47009994599996,
							27.98750589000008
						],
						[
							-82.46950420899992,
							27.98833992200008
						],
						[
							-82.46878932399994,
							27.988983318000066
						],
						[
							-82.46812209899991,
							27.98967437300007
						],
						[
							-82.46766933799995,
							27.99017479300005
						],
						[
							-82.4673118959999,
							27.990365428000075
						],
						[
							-82.46693062399993,
							27.990579894000064
						],
						[
							-82.46671615899993,
							27.990865848000055
						],
						[
							-82.46650169399993,
							27.99110414200004
						],
						[
							-82.46628722799994,
							27.99134243700007
						],
						[
							-82.46609659299992,
							27.991842856000062
						],
						[
							-82.4659059569999,
							27.992533911000066
						],
						[
							-82.46576297999991,
							27.99310581900005
						],
						[
							-82.46554851399993,
							27.99377304500007
						],
						[
							-82.46533404899992,
							27.994321123000077
						],
						[
							-82.46523873099994,
							27.99470239400006
						],
						[
							-82.46523873099994,
							27.995083666000088
						],
						[
							-82.46526256099992,
							27.995536426000058
						],
						[
							-82.46547702599992,
							27.99606067500008
						],
						[
							-82.46555773599995,
							27.996200084000066
						],
						[
							-82.46512556199991,
							27.996216918000073
						],
						[
							-82.4537175289999,
							27.996200202000068
						],
						[
							-82.4537158569999,
							27.995852554000066
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "South Seminole Heights",
				"RegionID": "275455"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.05910391100065,
					26.64454476745785,
					-80.04604999999987,
					26.67594391500014
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.05828001299989,
							26.67593996200008
						],
						[
							-80.05775999999993,
							26.675930000000143
						],
						[
							-80.05755999999991,
							26.675930000000143
						],
						[
							-80.0549900059999,
							26.675860001000125
						],
						[
							-80.05474458499992,
							26.67585431500001
						],
						[
							-80.05239999899992,
							26.675800000000045
						],
						[
							-80.05015999999993,
							26.675740001000147
						],
						[
							-80.04865999999991,
							26.675740000000054
						],
						[
							-80.04836425199996,
							26.675739999000143
						],
						[
							-80.04824399999985,
							26.675740000000054
						],
						[
							-80.04734499999991,
							26.67573999700032
						],
						[
							-80.04734472699988,
							26.675730626000522
						],
						[
							-80.04734827699973,
							26.675659621000243
						],
						[
							-80.04735527699987,
							26.675581621000184
						],
						[
							-80.04736533999981,
							26.67550583400004
						],
						[
							-80.0473802639999,
							26.675442416000124
						],
						[
							-80.04839211799985,
							26.675481330000146
						],
						[
							-80.04864999999997,
							26.675490000000153
						],
						[
							-80.0486534099998,
							26.675336546000068
						],
						[
							-80.0486588389999,
							26.67509226400011
						],
						[
							-80.04865999999991,
							26.674897031000032
						],
						[
							-80.04865999999991,
							26.6746800000001
						],
						[
							-80.04864998199989,
							26.674554778000044
						],
						[
							-80.04863834299991,
							26.674409285000173
						],
						[
							-80.0486213229999,
							26.674196542000068
						],
						[
							-80.04859999999992,
							26.67393000000004
						],
						[
							-80.0485847129999,
							26.67377373400008
						],
						[
							-80.04856091199979,
							26.6735304300002
						],
						[
							-80.04853695599985,
							26.67328555000019
						],
						[
							-80.04850999999984,
							26.673010000000126
						],
						[
							-80.04848645799984,
							26.672910600000073
						],
						[
							-80.04844094599991,
							26.672718440000164
						],
						[
							-80.04836947899985,
							26.672487911000186
						],
						[
							-80.04825999999986,
							26.672180000000196
						],
						[
							-80.04819986299994,
							26.672059725000103
						],
						[
							-80.04811200799988,
							26.671884016000043
						],
						[
							-80.04799397399995,
							26.671625938000183
						],
						[
							-80.04790999999993,
							26.671430000000136
						],
						[
							-80.04789537499988,
							26.671382467000022
						],
						[
							-80.04786633299996,
							26.67125232700009
						],
						[
							-80.0478526719999,
							26.67099279500011
						],
						[
							-80.04787016499992,
							26.67068374700012
						],
						[
							-80.04788692599989,
							26.670454588000077
						],
						[
							-80.0479416799999,
							26.670211068000178
						],
						[
							-80.04802926899994,
							26.669945974000093
						],
						[
							-80.04815999999992,
							26.669660000000057
						],
						[
							-80.04829837699992,
							26.669331848000084
						],
						[
							-80.04850999999984,
							26.668830000000128
						],
						[
							-80.04863991299993,
							26.668502126000178
						],
						[
							-80.04880999999989,
							26.668090000000184
						],
						[
							-80.0488478159999,
							26.667959746000065
						],
						[
							-80.04891792899993,
							26.667717248000077
						],
						[
							-80.04891999999992,
							26.667543272000067
						],
						[
							-80.04890523599995,
							26.66726650100017
						],
						[
							-80.04887901399991,
							26.66694060500003
						],
						[
							-80.0488499999999,
							26.666580000000124
						],
						[
							-80.04882504999989,
							26.66625898000003
						],
						[
							-80.04877196899993,
							26.665575998000186
						],
						[
							-80.04869999999993,
							26.664650000000133
						],
						[
							-80.04868555899981,
							26.664485136000167
						],
						[
							-80.0486556129999,
							26.664143252000127
						],
						[
							-80.04863132399993,
							26.663865950000094
						],
						[
							-80.04857999999986,
							26.66328000000011
						],
						[
							-80.04854921199988,
							26.662906146000083
						],
						[
							-80.04850999999984,
							26.66243000000012
						],
						[
							-80.04846830099986,
							26.661981732000157
						],
						[
							-80.04842999999988,
							26.66157000000002
						],
						[
							-80.04835346699986,
							26.661359535000102
						],
						[
							-80.04827999299982,
							26.66115103200017
						],
						[
							-80.04815999999992,
							26.660810000000197
						],
						[
							-80.04800455799995,
							26.660353390000076
						],
						[
							-80.04783999999982,
							26.659870000000048
						],
						[
							-80.04771354199994,
							26.659529113000175
						],
						[
							-80.04760999999989,
							26.659250000000085
						],
						[
							-80.0475210189999,
							26.65900146700004
						],
						[
							-80.04741699299991,
							26.658710913000156
						],
						[
							-80.04731999999989,
							26.658440000000034
						],
						[
							-80.04725951799995,
							26.658286045000175
						],
						[
							-80.04720547799991,
							26.65813738900013
						],
						[
							-80.04717982199992,
							26.658009111000176
						],
						[
							-80.04716510099985,
							26.657862026000174
						],
						[
							-80.04716475799991,
							26.657718761000133
						],
						[
							-80.04718999999997,
							26.657500000000063
						],
						[
							-80.04721758499993,
							26.65719656200018
						],
						[
							-80.04726799399992,
							26.65664207000013
						],
						[
							-80.04735701999992,
							26.655943176000036
						],
						[
							-80.04744182499992,
							26.655390545000053
						],
						[
							-80.04752999999994,
							26.65482000000019
						],
						[
							-80.04758717899996,
							26.654381627000063
						],
						[
							-80.04764999999993,
							26.653900000000093
						],
						[
							-80.04769814999992,
							26.653567767000048
						],
						[
							-80.04774999999994,
							26.653210000000023
						],
						[
							-80.04779629799994,
							26.652849903000163
						],
						[
							-80.04783999999982,
							26.65251000000019
						],
						[
							-80.04787010599992,
							26.65229549200003
						],
						[
							-80.04790656399992,
							26.65203573200003
						],
						[
							-80.04792999999991,
							26.65182000000012
						],
						[
							-80.04792426299987,
							26.651713298000175
						],
						[
							-80.0479129249999,
							26.651502406000134
						],
						[
							-80.04789713199993,
							26.651208657000076
						],
						[
							-80.04788317699985,
							26.650949097000094
						],
						[
							-80.04785202299985,
							26.65065745600021
						],
						[
							-80.04779585599982,
							26.65044439700008
						],
						[
							-80.0476991389999,
							26.650206832000052
						],
						[
							-80.04759999999986,
							26.649970000000174
						],
						[
							-80.04754695799991,
							26.649853567000044
						],
						[
							-80.04748053399993,
							26.64970775700006
						],
						[
							-80.04738955699986,
							26.649508053000055
						],
						[
							-80.04718999999997,
							26.64907000000014
						],
						[
							-80.04703627699985,
							26.648732412000097
						],
						[
							-80.04687668499979,
							26.64838193500014
						],
						[
							-80.04664121299994,
							26.647864821000162
						],
						[
							-80.04650841099988,
							26.6475731780001
						],
						[
							-80.04632761699993,
							26.647176138000113
						],
						[
							-80.04618588399984,
							26.646864883000028
						],
						[
							-80.0461136709999,
							26.646639790000144
						],
						[
							-80.04604999999987,
							26.64647000000013
						],
						[
							-80.04605349399989,
							26.64624636900001
						],
						[
							-80.04605704799992,
							26.64601890700002
						],
						[
							-80.0460599999999,
							26.64583000000011
						],
						[
							-80.04606470099993,
							26.64566075800014
						],
						[
							-80.0460728299999,
							26.64536813500018
						],
						[
							-80.04607999999986,
							26.645110000000045
						],
						[
							-80.04621821099995,
							26.64511412600003
						],
						[
							-80.04627339599678,
							26.64454476745785
						],
						[
							-80.05231199999992,
							26.644586000000032
						],
						[
							-80.05629999999992,
							26.644735000000104
						],
						[
							-80.05882699999994,
							26.644930000000073
						],
						[
							-80.05910391100065,
							26.64493998297754
						],
						[
							-80.05910390999993,
							26.645252493000022
						],
						[
							-80.05910390899993,
							26.645801636000073
						],
						[
							-80.05889690899994,
							26.653496636000114
						],
						[
							-80.05879790899994,
							26.654999636000127
						],
						[
							-80.05879790899994,
							26.65702931900011
						],
						[
							-80.05879790899994,
							26.657195636000104
						],
						[
							-80.05879790899994,
							26.6578976360001
						],
						[
							-80.05879790899994,
							26.658170112999997
						],
						[
							-80.05879790899994,
							26.658698636000118
						],
						[
							-80.05879790899994,
							26.659400636000115
						],
						[
							-80.0586989089999,
							26.66020163600013
						],
						[
							-80.05869890799981,
							26.660795636000074
						],
						[
							-80.05868090899993,
							26.66092163700011
						],
						[
							-80.05859985599989,
							26.66159663700018
						],
						[
							-80.05869890799981,
							26.662298636000088
						],
						[
							-80.05869890799981,
							26.663000636000085
						],
						[
							-80.05869890799981,
							26.663801636000102
						],
						[
							-80.05869890799981,
							26.66450363700001
						],
						[
							-80.05868204699993,
							26.66474052200016
						],
						[
							-80.05866842899987,
							26.66493185200018
						],
						[
							-80.05859990799989,
							26.66589863600006
						],
						[
							-80.05859990799989,
							26.666726636000178
						],
						[
							-80.05859990799989,
							26.667302636000052
						],
						[
							-80.05859990799989,
							26.66820263600009
						],
						[
							-80.05850090799987,
							26.669003636000106
						],
						[
							-80.05830290999991,
							26.674196637000165
						],
						[
							-80.05850104199988,
							26.67550163600005
						],
						[
							-80.05839386999989,
							26.67594391500014
						],
						[
							-80.05828001299989,
							26.67593996200008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "West Palm Beach",
				"Name": "South Side",
				"RegionID": "275457"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.56728673099991,
					27.38660669300009,
					-82.56466590199994,
					27.389122000000043
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.5659399999999,
							27.389121000000046
						],
						[
							-82.56567799999993,
							27.389120000000048
						],
						[
							-82.56558099999995,
							27.389120000000048
						],
						[
							-82.56532346799992,
							27.38823016100008
						],
						[
							-82.56520099999994,
							27.387807000000066
						],
						[
							-82.56508185299992,
							27.387499030000075
						],
						[
							-82.5648589999999,
							27.38692300000008
						],
						[
							-82.56466590199994,
							27.38660669300009
						],
						[
							-82.56550922499991,
							27.386618961000067
						],
						[
							-82.56644295599995,
							27.386632543000076
						],
						[
							-82.5669757789999,
							27.388650433000066
						],
						[
							-82.56703797499995,
							27.388734259000046
						],
						[
							-82.5670545989999,
							27.38875685800008
						],
						[
							-82.5670999049999,
							27.388804207000078
						],
						[
							-82.56714164399995,
							27.38885472700008
						],
						[
							-82.56717959699995,
							27.388908151000066
						],
						[
							-82.5672135609999,
							27.388964195000085
						],
						[
							-82.56724335699994,
							27.389022562000036
						],
						[
							-82.56728673099991,
							27.38911576600009
						],
						[
							-82.56639899999993,
							27.389109000000076
						],
						[
							-82.56629499999991,
							27.389122000000043
						],
						[
							-82.5662769999999,
							27.389122000000043
						],
						[
							-82.56626199999994,
							27.389122000000043
						],
						[
							-82.56617015199993,
							27.389122000000043
						],
						[
							-82.56612499999994,
							27.389122000000043
						],
						[
							-82.5659399999999,
							27.389121000000046
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Uplands",
				"RegionID": "343989"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.58976532199996,
					27.31694410100005,
					-82.57136584099993,
					27.339020291000054
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.57337138899993,
							27.333310849000043
						],
						[
							-82.5733666779999,
							27.33325700000006
						],
						[
							-82.57337823099994,
							27.33311331300007
						],
						[
							-82.5734072859999,
							27.332934074000036
						],
						[
							-82.57342231099996,
							27.332862841000065
						],
						[
							-82.57344304999992,
							27.33279305800005
						],
						[
							-82.57346936599993,
							27.332725181000058
						],
						[
							-82.57350108799994,
							27.332659655000043
						],
						[
							-82.57353800699991,
							27.332596911000053
						],
						[
							-82.57357988099994,
							27.33253736000006
						],
						[
							-82.57362643599993,
							27.332481391000044
						],
						[
							-82.57379343499991,
							27.332296391000057
						],
						[
							-82.57388292699994,
							27.33221007900005
						],
						[
							-82.57398990599995,
							27.332132938000086
						],
						[
							-82.57429239499993,
							27.331946920000064
						],
						[
							-82.5751185979999,
							27.331248199000076
						],
						[
							-82.57524833899993,
							27.331157165000036
						],
						[
							-82.57530538799995,
							27.331126905000076
						],
						[
							-82.5756033749999,
							27.330982307000056
						],
						[
							-82.57588842199995,
							27.330837831000053
						],
						[
							-82.57601985399992,
							27.33078380200004
						],
						[
							-82.5765208549999,
							27.33062280200005
						],
						[
							-82.57663983499992,
							27.330593341000057
						],
						[
							-82.57673135199991,
							27.330582005000053
						],
						[
							-82.57706435199992,
							27.33055800400007
						],
						[
							-82.5771289999999,
							27.330555678000056
						],
						[
							-82.57725954099993,
							27.33056520200006
						],
						[
							-82.57759353999995,
							27.330614203000042
						],
						[
							-82.57761916499993,
							27.330618341000047
						],
						[
							-82.57774738799992,
							27.330650828000046
						],
						[
							-82.57785838899991,
							27.330687828000066
						],
						[
							-82.57792468999992,
							27.33071287200005
						],
						[
							-82.57798881399992,
							27.330743059000042
						],
						[
							-82.5780503609999,
							27.33077820200009
						],
						[
							-82.5781089489999,
							27.330818083000054
						],
						[
							-82.5781642149999,
							27.330862453000066
						],
						[
							-82.5782158159999,
							27.330911038000067
						],
						[
							-82.57826342999994,
							27.33096353500008
						],
						[
							-82.57840549799994,
							27.33112331500007
						],
						[
							-82.57854471099995,
							27.331064763000086
						],
						[
							-82.57884262399995,
							27.330932595000036
						],
						[
							-82.5790476059999,
							27.330758438000093
						],
						[
							-82.58113391799992,
							27.328963781000084
						],
						[
							-82.58122864599994,
							27.328808344000038
						],
						[
							-82.58134164899991,
							27.32859867600007
						],
						[
							-82.58139972099991,
							27.32841063400008
						],
						[
							-82.58141719399993,
							27.328359548000037
						],
						[
							-82.5815578019999,
							27.327985512000055
						],
						[
							-82.58161919299994,
							27.327773058000048
						],
						[
							-82.57960252499993,
							27.324310444000048
						],
						[
							-82.57942794099995,
							27.324129576000075
						],
						[
							-82.57937491899992,
							27.32406950500007
						],
						[
							-82.5793274529999,
							27.324004954000088
						],
						[
							-82.57928592199994,
							27.323936434000075
						],
						[
							-82.5792506539999,
							27.323864490000062
						],
						[
							-82.57922192899991,
							27.323789692000048
						],
						[
							-82.57919997599993,
							27.32371263400006
						],
						[
							-82.57918780699994,
							27.323677419000035
						],
						[
							-82.57970311299994,
							27.322881324000036
						],
						[
							-82.58008761399992,
							27.322519441000054
						],
						[
							-82.5806078199999,
							27.322202794000077
						],
						[
							-82.58116390899994,
							27.32205478700007
						],
						[
							-82.58128888099992,
							27.322152483000085
						],
						[
							-82.58134245899993,
							27.32219784600005
						],
						[
							-82.58139233599991,
							27.322247249000046
						],
						[
							-82.5814382069999,
							27.322300393000035
						],
						[
							-82.58147979299991,
							27.322356953000053
						],
						[
							-82.58154679299992,
							27.322455953000087
						],
						[
							-82.58158083599994,
							27.322510339000075
						],
						[
							-82.58160824799995,
							27.322565873000087
						],
						[
							-82.5823794829999,
							27.323680195000065
						],
						[
							-82.58241629999992,
							27.323737975000085
						],
						[
							-82.58328233999993,
							27.325218747000065
						],
						[
							-82.58347363799993,
							27.325075369000047
						],
						[
							-82.5835652419999,
							27.325015068000084
						],
						[
							-82.58424864199992,
							27.324624612000036
						],
						[
							-82.5843133109999,
							27.32458372600007
						],
						[
							-82.58448597199992,
							27.32446198200006
						],
						[
							-82.58469527599993,
							27.324178430000078
						],
						[
							-82.58467016399993,
							27.32413966100006
						],
						[
							-82.58463886099992,
							27.324080454000068
						],
						[
							-82.5842648599999,
							27.323304454000038
						],
						[
							-82.58423349499992,
							27.323231252000085
						],
						[
							-82.58409249399995,
							27.322857252000063
						],
						[
							-82.58406482399994,
							27.32277089900009
						],
						[
							-82.5839744299999,
							27.322430626000084
						],
						[
							-82.58361234699993,
							27.321985504000054
						],
						[
							-82.58359830799992,
							27.32196779600008
						],
						[
							-82.58329960399993,
							27.32158113400004
						],
						[
							-82.58282505199992,
							27.321137044000068
						],
						[
							-82.58249807199991,
							27.32093373000004
						],
						[
							-82.58226462699992,
							27.320839401000057
						],
						[
							-82.58177359699994,
							27.32100641800008
						],
						[
							-82.58170873099994,
							27.32102675300007
						],
						[
							-82.58164239099995,
							27.321041592000086
						],
						[
							-82.58157504199994,
							27.321050830000047
						],
						[
							-82.58150715699992,
							27.321054403000062
						],
						[
							-82.58143921099993,
							27.321052287000043
						],
						[
							-82.58137167899991,
							27.32104449500008
						],
						[
							-82.5810827919999,
							27.320687409000072
						],
						[
							-82.58090184999992,
							27.319986261000054
						],
						[
							-82.58126740599994,
							27.319813048000075
						],
						[
							-82.58543529699995,
							27.317678244000035
						],
						[
							-82.5859548279999,
							27.31694410100005
						],
						[
							-82.58615591799993,
							27.317083094000054
						],
						[
							-82.58706543199992,
							27.317597203000048
						],
						[
							-82.58722095999991,
							27.317621168000073
						],
						[
							-82.58729086599993,
							27.31763479400007
						],
						[
							-82.5874558669999,
							27.317673794000086
						],
						[
							-82.58755658599995,
							27.31770391400005
						],
						[
							-82.58769866099993,
							27.31777016400008
						],
						[
							-82.58782707299991,
							27.31786008000006
						],
						[
							-82.58793792099993,
							27.31797092700009
						],
						[
							-82.58802783599992,
							27.31809933900007
						],
						[
							-82.58809408599991,
							27.318241414000056
						],
						[
							-82.58811455199992,
							27.318304869000087
						],
						[
							-82.58815855199992,
							27.318460869000035
						],
						[
							-82.58817865999993,
							27.31854883500006
						],
						[
							-82.58819077099993,
							27.31865219100007
						],
						[
							-82.58822291799993,
							27.31919883000006
						],
						[
							-82.58827544499991,
							27.32019117300007
						],
						[
							-82.58845203899995,
							27.32089248200009
						],
						[
							-82.58865562499994,
							27.321454897000084
						],
						[
							-82.5886695989999,
							27.32149667300007
						],
						[
							-82.58877481399992,
							27.321838833000072
						],
						[
							-82.58913292199992,
							27.322614145000045
						],
						[
							-82.5894237629999,
							27.32308642000004
						],
						[
							-82.58945703099994,
							27.32314528900008
						],
						[
							-82.58948578199994,
							27.323206491000064
						],
						[
							-82.58950985299992,
							27.323269681000056
						],
						[
							-82.58964185199994,
							27.32365968100004
						],
						[
							-82.58967565899991,
							27.323791834000076
						],
						[
							-82.58968516499993,
							27.323861625000063
						],
						[
							-82.58971642199992,
							27.324185570000054
						],
						[
							-82.58975695399994,
							27.324480600000072
						],
						[
							-82.58976532199996,
							27.32460300000008
						],
						[
							-82.58975130499994,
							27.324761149000043
						],
						[
							-82.58967495099996,
							27.325183134000042
						],
						[
							-82.58965885599991,
							27.32525509700008
						],
						[
							-82.58963691999992,
							27.325325500000076
						],
						[
							-82.58960928999994,
							27.325393870000084
						],
						[
							-82.5895761509999,
							27.325459746000035
						],
						[
							-82.58953772699994,
							27.325522685000067
						],
						[
							-82.58949427499994,
							27.325582265000037
						],
						[
							-82.58944608799993,
							27.325638084000047
						],
						[
							-82.58934038199993,
							27.325750837000044
						],
						[
							-82.58801539199993,
							27.32785979600004
						],
						[
							-82.58727011299995,
							27.329030876000047
						],
						[
							-82.58687787799994,
							27.329556190000062
						],
						[
							-82.58651366099991,
							27.329948424000065
						],
						[
							-82.58620547699991,
							27.33009551200007
						],
						[
							-82.58599385799994,
							27.330131174000087
						],
						[
							-82.58592850699995,
							27.330141436000076
						],
						[
							-82.58584340699991,
							27.330150675000084
						],
						[
							-82.5858049929999,
							27.33015300300008
						],
						[
							-82.58574350399994,
							27.33017480300009
						],
						[
							-82.58558272399996,
							27.330249054000035
						],
						[
							-82.58296846199994,
							27.33211499300006
						],
						[
							-82.5829217779999,
							27.332146161000082
						],
						[
							-82.58215795299992,
							27.332624507000048
						],
						[
							-82.58211708599993,
							27.332777586000077
						],
						[
							-82.58205083599995,
							27.332919661000062
						],
						[
							-82.5819609209999,
							27.333048073000043
						],
						[
							-82.58185007299994,
							27.333158920000074
						],
						[
							-82.5817216609999,
							27.333248836000053
						],
						[
							-82.58157958599992,
							27.333315086000084
						],
						[
							-82.58142816499992,
							27.333355659000063
						],
						[
							-82.5812719999999,
							27.333369322000067
						],
						[
							-82.58111583399995,
							27.333355659000063
						],
						[
							-82.58103842899993,
							27.333338461000043
						],
						[
							-82.58083961499995,
							27.33328499000004
						],
						[
							-82.5806686809999,
							27.333333829000082
						],
						[
							-82.58038407999993,
							27.33349046400008
						],
						[
							-82.58011919099995,
							27.33366705600008
						],
						[
							-82.5800814349999,
							27.33371020700008
						],
						[
							-82.57991631599992,
							27.33395579000006
						],
						[
							-82.57987696299995,
							27.33400809400007
						],
						[
							-82.57986158099995,
							27.33419609500004
						],
						[
							-82.57985583199992,
							27.33426316400005
						],
						[
							-82.57984665999993,
							27.334352166000087
						],
						[
							-82.57980608699995,
							27.33450358600004
						],
						[
							-82.57973983599993,
							27.33464566100008
						],
						[
							-82.57964992099994,
							27.334774073000062
						],
						[
							-82.57953907299992,
							27.334884921000082
						],
						[
							-82.5794693069999,
							27.334935460000054
						],
						[
							-82.5794114489999,
							27.33497598100007
						],
						[
							-82.57858871699996,
							27.33554323900006
						],
						[
							-82.57759879499991,
							27.336363488000075
						],
						[
							-82.57757594899994,
							27.336381799000037
						],
						[
							-82.57690894899991,
							27.33689879900004
						],
						[
							-82.57685388999994,
							27.33693824900007
						],
						[
							-82.57615451599992,
							27.33740051300009
						],
						[
							-82.57550808899992,
							27.33783431200004
						],
						[
							-82.57547508899997,
							27.337860812000088
						],
						[
							-82.57520991899992,
							27.338077499000068
						],
						[
							-82.57434877899993,
							27.33878061300004
						],
						[
							-82.57429091199992,
							27.338824100000068
						],
						[
							-82.57422973399991,
							27.33886279300009
						],
						[
							-82.5741656429999,
							27.338896440000042
						],
						[
							-82.57409905299994,
							27.33892482400006
						],
						[
							-82.57403039699994,
							27.338947760000053
						],
						[
							-82.57396011799995,
							27.338965100000053
						],
						[
							-82.57377911799995,
							27.339002101000062
						],
						[
							-82.57371706799995,
							27.339012538000077
						],
						[
							-82.57365443999993,
							27.339018612000075
						],
						[
							-82.57359153999994,
							27.339020291000054
						],
						[
							-82.5735286769999,
							27.339017569000077
						],
						[
							-82.57337567699994,
							27.33900556800006
						],
						[
							-82.57328983399992,
							27.338994659000036
						],
						[
							-82.57313841299992,
							27.338954086000058
						],
						[
							-82.57299633899993,
							27.338887836000083
						],
						[
							-82.57286792699995,
							27.338797920000047
						],
						[
							-82.57275707899993,
							27.338687073000074
						],
						[
							-82.57266716399994,
							27.338558661000036
						],
						[
							-82.57264017499995,
							27.338508282000078
						],
						[
							-82.57258517499992,
							27.338397283000063
						],
						[
							-82.5725537379999,
							27.338327451000055
						],
						[
							-82.5725286949999,
							27.338255080000067
						],
						[
							-82.57251024699991,
							27.338180753000078
						],
						[
							-82.57249854399993,
							27.338105071000086
						],
						[
							-82.57249367999992,
							27.338028644000076
						],
						[
							-82.57249569499993,
							27.33795208900006
						],
						[
							-82.57207519299993,
							27.33773549700004
						],
						[
							-82.5720373389999,
							27.337714835000043
						],
						[
							-82.57190892699992,
							27.337624920000053
						],
						[
							-82.5717980789999,
							27.33751407300008
						],
						[
							-82.57170816399993,
							27.33738566100004
						],
						[
							-82.57164191299995,
							27.337243586000056
						],
						[
							-82.57160133999992,
							27.33709216500006
						],
						[
							-82.5715876779999,
							27.33693600000004
						],
						[
							-82.57159472399991,
							27.336823638000055
						],
						[
							-82.57163009999994,
							27.33654271800009
						],
						[
							-82.57161639399993,
							27.336452688000065
						],
						[
							-82.5715557019999,
							27.336317635000057
						],
						[
							-82.57151222199991,
							27.33619933700004
						],
						[
							-82.57140122299995,
							27.335816338000086
						],
						[
							-82.57138484199993,
							27.335750665000035
						],
						[
							-82.57137344599994,
							27.335683946000074
						],
						[
							-82.57136709999992,
							27.335616559000073
						],
						[
							-82.57136584099993,
							27.335548886000083
						],
						[
							-82.57136967499991,
							27.335481309000045
						],
						[
							-82.57138367499994,
							27.335333309000077
						],
						[
							-82.57139334099992,
							27.33526183400005
						],
						[
							-82.57141231999992,
							27.33517790500008
						],
						[
							-82.57142067799992,
							27.33514773400009
						],
						[
							-82.57142067799992,
							27.335097000000076
						],
						[
							-82.57143434099993,
							27.334940835000054
						],
						[
							-82.57143915299991,
							27.334915650000084
						],
						[
							-82.57149515299994,
							27.33464365000009
						],
						[
							-82.57153091399994,
							27.33451741400006
						],
						[
							-82.5715876189999,
							27.334392292000075
						],
						[
							-82.5718516199999,
							27.33391129200004
						],
						[
							-82.57186116499992,
							27.33389433900004
						],
						[
							-82.5719510799999,
							27.33376592700006
						],
						[
							-82.57206192699994,
							27.33365507900004
						],
						[
							-82.57219033899992,
							27.33356516400005
						],
						[
							-82.5723324139999,
							27.333498914000074
						],
						[
							-82.57247235099993,
							27.333460442000046
						],
						[
							-82.57262222599991,
							27.333432005000077
						],
						[
							-82.57287020899992,
							27.33335812000007
						],
						[
							-82.57297083499992,
							27.33333434100007
						],
						[
							-82.57309319199993,
							27.333321314000045
						],
						[
							-82.57337138899993,
							27.333310849000043
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Lido Shores",
				"RegionID": "343990"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.54909436899993,
					27.344907826000053,
					-82.5386197599999,
					27.359902748000085
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.5427509779999,
							27.356460293000055
						],
						[
							-82.54268078399991,
							27.356460000000084
						],
						[
							-82.54245959899993,
							27.356460000000084
						],
						[
							-82.54216976999993,
							27.356460000000084
						],
						[
							-82.54203434199991,
							27.356467132000034
						],
						[
							-82.54196656199991,
							27.356483438000055
						],
						[
							-82.54194999999993,
							27.35650000000004
						],
						[
							-82.54184950399991,
							27.356505025000047
						],
						[
							-82.5417273949999,
							27.356511130000058
						],
						[
							-82.54163571799997,
							27.356515714000068
						],
						[
							-82.54154999999992,
							27.356520000000046
						],
						[
							-82.54080953099992,
							27.35645886000009
						],
						[
							-82.54074991499994,
							27.35614537500004
						],
						[
							-82.54069487399994,
							27.35533897600004
						],
						[
							-82.54069487399994,
							27.35341453500007
						],
						[
							-82.54065821799992,
							27.350005525000086
						],
						[
							-82.54063587399992,
							27.34861273200005
						],
						[
							-82.54062983599994,
							27.34823630900007
						],
						[
							-82.54054787699995,
							27.346923675000085
						],
						[
							-82.5402607229999,
							27.346472430000063
						],
						[
							-82.53956336599992,
							27.34606221900009
						],
						[
							-82.53874297099992,
							27.34600068000009
						],
						[
							-82.5386197599999,
							27.34598038100006
						],
						[
							-82.53862349199994,
							27.344907826000053
						],
						[
							-82.54470101599992,
							27.344975719000047
						],
						[
							-82.5469240409999,
							27.345000552000045
						],
						[
							-82.54694091199991,
							27.350974996000048
						],
						[
							-82.54694833899993,
							27.353605135000066
						],
						[
							-82.5470256779999,
							27.353862754000094
						],
						[
							-82.54737074899992,
							27.354940525000075
						],
						[
							-82.54908002999991,
							27.359840939000037
						],
						[
							-82.54909436899993,
							27.35988231400006
						],
						[
							-82.54677784099994,
							27.359902748000085
						],
						[
							-82.54569282599994,
							27.359888821000084
						],
						[
							-82.5445712309999,
							27.35986179500009
						],
						[
							-82.54374692499994,
							27.359821255000043
						],
						[
							-82.54274492399992,
							27.35979197100005
						],
						[
							-82.54276742799993,
							27.35974663000008
						],
						[
							-82.5427857759999,
							27.359713603000046
						],
						[
							-82.54280916099992,
							27.359671510000055
						],
						[
							-82.5428153549999,
							27.359637872000064
						],
						[
							-82.54281999999995,
							27.359493410000084
						],
						[
							-82.54281999999995,
							27.359310361000045
						],
						[
							-82.54281999999995,
							27.359211209000083
						],
						[
							-82.54281999999995,
							27.359130000000054
						],
						[
							-82.54282131399992,
							27.359089280000035
						],
						[
							-82.54282352599995,
							27.359020708000063
						],
						[
							-82.54282648299994,
							27.35892903200005
						],
						[
							-82.54282870299994,
							27.35886021400006
						],
						[
							-82.54282999999992,
							27.358820000000037
						],
						[
							-82.54282999999992,
							27.358578161000082
						],
						[
							-82.54282999999992,
							27.35833409500009
						],
						[
							-82.54282999999992,
							27.35805952000004
						],
						[
							-82.54282999999992,
							27.357890000000054
						],
						[
							-82.54283143799995,
							27.357762043000037
						],
						[
							-82.54283349399992,
							27.357579017000035
						],
						[
							-82.54283503699992,
							27.357441747000053
						],
						[
							-82.54283692299992,
							27.357273886000087
						],
						[
							-82.54283795099991,
							27.357182373000057
						],
						[
							-82.5428391499999,
							27.35707560700007
						],
						[
							-82.5428399999999,
							27.357000000000085
						],
						[
							-82.54284210599991,
							27.356892601000084
						],
						[
							-82.54284479699993,
							27.356755366000073
						],
						[
							-82.54284763699991,
							27.356610507000088
						],
						[
							-82.54284999999993,
							27.356490000000065
						],
						[
							-82.54280695699993,
							27.356477087000087
						],
						[
							-82.5427509779999,
							27.356460293000055
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Central Cocoanut",
				"RegionID": "343991"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.54074991499994,
					27.348551617000055,
					-82.52421977599994,
					27.35614537500004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.53055949899993,
							27.355943763000084
						],
						[
							-82.5293864919999,
							27.35592547200008
						],
						[
							-82.52784831299994,
							27.35592557700005
						],
						[
							-82.52724699999993,
							27.355232000000058
						],
						[
							-82.5270789999999,
							27.35449000000006
						],
						[
							-82.52687199999991,
							27.354483000000073
						],
						[
							-82.52687999999995,
							27.35436800000008
						],
						[
							-82.5267649999999,
							27.353138000000058
						],
						[
							-82.52693699999992,
							27.353149000000087
						],
						[
							-82.52693299999993,
							27.353109000000075
						],
						[
							-82.52681699999994,
							27.352249000000086
						],
						[
							-82.5268819819999,
							27.35177490600006
						],
						[
							-82.52688799999993,
							27.351731000000086
						],
						[
							-82.52642999999995,
							27.35171100000008
						],
						[
							-82.5262909999999,
							27.35172400000005
						],
						[
							-82.52545299999991,
							27.35177800000008
						],
						[
							-82.52428999999995,
							27.35172300000005
						],
						[
							-82.52423699999991,
							27.351722000000052
						],
						[
							-82.52422874299992,
							27.351722132000077
						],
						[
							-82.52422999999995,
							27.351600877000067
						],
						[
							-82.52422999999995,
							27.351201097000057
						],
						[
							-82.52422999999995,
							27.350834632000044
						],
						[
							-82.52422999999995,
							27.350579217000075
						],
						[
							-82.52422999999995,
							27.350430000000074
						],
						[
							-82.52422999999995,
							27.35023496200006
						],
						[
							-82.52422999999995,
							27.34983518300004
						],
						[
							-82.52422999999995,
							27.349600000000066
						],
						[
							-82.52422864499994,
							27.349457682000036
						],
						[
							-82.52422568299994,
							27.34914666500004
						],
						[
							-82.52422293299992,
							27.34885796100008
						],
						[
							-82.5242212409999,
							27.348680297000044
						],
						[
							-82.52421977599994,
							27.348551617000055
						],
						[
							-82.52570251899994,
							27.34856475800007
						],
						[
							-82.52810433999991,
							27.34858616300005
						],
						[
							-82.5287207799999,
							27.34862593200006
						],
						[
							-82.52949618199995,
							27.348636672000055
						],
						[
							-82.5303315029999,
							27.348645816000044
						],
						[
							-82.53857225199994,
							27.348648316000038
						],
						[
							-82.53857198799994,
							27.34857616700009
						],
						[
							-82.53961352099992,
							27.348575940000046
						],
						[
							-82.54063587399992,
							27.34861273200005
						],
						[
							-82.54065821799992,
							27.350005525000086
						],
						[
							-82.54069487399994,
							27.35341453500007
						],
						[
							-82.54069487399994,
							27.35533897600004
						],
						[
							-82.54074991499994,
							27.35614537500004
						],
						[
							-82.5357279829999,
							27.356072096000048
						],
						[
							-82.5327076399999,
							27.35601483800008
						],
						[
							-82.5323181149999,
							27.356007454000064
						],
						[
							-82.53186077399994,
							27.355998784000064
						],
						[
							-82.53055949899993,
							27.355943763000084
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "17th Street Neighborhood Association",
				"RegionID": "343992"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.40716001899995,
					28.509652561000053,
					-81.38590479399994,
					28.53116442700008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.38733893799993,
							28.531081304000054
						],
						[
							-81.38722176499994,
							28.531078300000047
						],
						[
							-81.38709958299995,
							28.531078300000047
						],
						[
							-81.38636349099994,
							28.531076297000084
						],
						[
							-81.38590479399994,
							28.531078215000036
						],
						[
							-81.38601697699994,
							28.530836942000064
						],
						[
							-81.3860660499999,
							28.53069473100004
						],
						[
							-81.3862563319999,
							28.53020400300005
						],
						[
							-81.38632743799991,
							28.529835457000047
						],
						[
							-81.38633645099992,
							28.529756339000073
						],
						[
							-81.38634446299994,
							28.529671214000075
						],
						[
							-81.38637450699991,
							28.52939280000004
						],
						[
							-81.38638452299995,
							28.529114387000053
						],
						[
							-81.3863965409999,
							28.52877688800004
						],
						[
							-81.38635948599995,
							28.527023286000087
						],
						[
							-81.3863534759999,
							28.526575622000053
						],
						[
							-81.38634546399993,
							28.526138975000038
						],
						[
							-81.38632743799991,
							28.525086413000054
						],
						[
							-81.38631642199994,
							28.52470184400005
						],
						[
							-81.3862993969999,
							28.524114974000042
						],
						[
							-81.3862993969999,
							28.523719386000042
						],
						[
							-81.3862993969999,
							28.523191603000043
						],
						[
							-81.38628136999995,
							28.52040747500007
						],
						[
							-81.3862875129999,
							28.52015096200006
						],
						[
							-81.38606691799993,
							28.52015222600005
						],
						[
							-81.38608395199992,
							28.51986052700005
						],
						[
							-81.38630352799993,
							28.51987281600009
						],
						[
							-81.38630941199995,
							28.519729470000073
						],
						[
							-81.38633344699991,
							28.51950914200006
						],
						[
							-81.38641256499994,
							28.519130580000084
						],
						[
							-81.3865307399999,
							28.518702947000065
						],
						[
							-81.3866839669999,
							28.51828432600007
						],
						[
							-81.38682717899991,
							28.517964852000095
						],
						[
							-81.38704049599994,
							28.517578279000077
						],
						[
							-81.38719672799994,
							28.517347937000068
						],
						[
							-81.38746612599994,
							28.516990407000037
						],
						[
							-81.38758325999993,
							28.516810105000047
						],
						[
							-81.38768545199991,
							28.51670899000004
						],
						[
							-81.38839950999994,
							28.515945859000055
						],
						[
							-81.38876405199994,
							28.515675456000054
						],
						[
							-81.38959628599991,
							28.515111621000074
						],
						[
							-81.39017927399993,
							28.514717998000037
						],
						[
							-81.3903808579999,
							28.514600000000087
						],
						[
							-81.39138042599991,
							28.513791669000057
						],
						[
							-81.39275483299991,
							28.512867068000048
						],
						[
							-81.39600343099994,
							28.511117823000063
						],
						[
							-81.39722790199994,
							28.51059304900008
						],
						[
							-81.39877723399991,
							28.510043287000087
						],
						[
							-81.40020161899992,
							28.50966844900006
						],
						[
							-81.40106999999995,
							28.509652561000053
						],
						[
							-81.40106999999995,
							28.50986127200008
						],
						[
							-81.40106999999995,
							28.510166172000083
						],
						[
							-81.4010669999999,
							28.510417000000075
						],
						[
							-81.4010669999999,
							28.510481000000084
						],
						[
							-81.40110199999992,
							28.510481000000084
						],
						[
							-81.4011089999999,
							28.510778000000073
						],
						[
							-81.40120199999991,
							28.510778000000073
						],
						[
							-81.40132799999992,
							28.510778000000073
						],
						[
							-81.40133199999991,
							28.512254000000045
						],
						[
							-81.40174399999995,
							28.512254000000045
						],
						[
							-81.40174399999995,
							28.51235926600009
						],
						[
							-81.40174399999995,
							28.512601000000075
						],
						[
							-81.40297099999992,
							28.512600000000077
						],
						[
							-81.40296399999994,
							28.512751000000037
						],
						[
							-81.4029559999999,
							28.512911000000088
						],
						[
							-81.40492899999992,
							28.512911000000088
						],
						[
							-81.40526499999993,
							28.512911000000088
						],
						[
							-81.40542199999993,
							28.512913000000083
						],
						[
							-81.40542199999993,
							28.515708482000036
						],
						[
							-81.40542199999993,
							28.515780000000063
						],
						[
							-81.40566780699993,
							28.515780000000063
						],
						[
							-81.40609199999994,
							28.515780000000063
						],
						[
							-81.40619399999991,
							28.515780000000063
						],
						[
							-81.40619208999993,
							28.51673481000006
						],
						[
							-81.4065013959999,
							28.517596594000054
						],
						[
							-81.40634032799994,
							28.51774040500004
						],
						[
							-81.40600333399993,
							28.51809468000005
						],
						[
							-81.40595413199992,
							28.518156656000087
						],
						[
							-81.40587492999992,
							28.51828171200009
						],
						[
							-81.40543662899995,
							28.519035848000044
						],
						[
							-81.4051240629999,
							28.519779476000053
						],
						[
							-81.40510157799991,
							28.519828760000053
						],
						[
							-81.40507383599993,
							28.51988066100006
						],
						[
							-81.40506820699994,
							28.51989027400009
						],
						[
							-81.40498920699991,
							28.520023273000053
						],
						[
							-81.40498688799995,
							28.520027155000037
						],
						[
							-81.40483788699993,
							28.520275155000036
						],
						[
							-81.40481485599992,
							28.520311491000086
						],
						[
							-81.40445285699991,
							28.520853491000086
						],
						[
							-81.40445275899992,
							28.520853637000073
						],
						[
							-81.40443304999991,
							28.520881943000063
						],
						[
							-81.4043443089999,
							28.521504008000083
						],
						[
							-81.40433890399993,
							28.521535681000046
						],
						[
							-81.40436214699992,
							28.521589069000072
						],
						[
							-81.40487351599995,
							28.522307912000088
						],
						[
							-81.40523407799992,
							28.52271342800009
						],
						[
							-81.40523814599993,
							28.52271803600007
						],
						[
							-81.40527547999994,
							28.522763527000052
						],
						[
							-81.40530975899992,
							28.522811363000073
						],
						[
							-81.40534083599994,
							28.522861339000087
						],
						[
							-81.40535545299991,
							28.522887664000056
						],
						[
							-81.4058432789999,
							28.523801990000038
						],
						[
							-81.40599853099992,
							28.52399986000006
						],
						[
							-81.40600447999992,
							28.524007527000037
						],
						[
							-81.40603875899991,
							28.52405536300006
						],
						[
							-81.40606983499993,
							28.524105339000073
						],
						[
							-81.40609757699991,
							28.52415724000008
						],
						[
							-81.40612186499993,
							28.524210844000038
						],
						[
							-81.40614259499995,
							28.52426592200004
						],
						[
							-81.4061434699999,
							28.524268514000084
						],
						[
							-81.40618446999991,
							28.52439051400006
						],
						[
							-81.40618475399992,
							28.52439135800006
						],
						[
							-81.40632175399992,
							28.52480035800005
						],
						[
							-81.40633767799994,
							28.52485323800005
						],
						[
							-81.40635046299991,
							28.524907668000083
						],
						[
							-81.40640257699994,
							28.52516525900006
						],
						[
							-81.40658502299993,
							28.52559733000004
						],
						[
							-81.4066447479999,
							28.525679267000044
						],
						[
							-81.4066657589999,
							28.52570936400008
						],
						[
							-81.40669683499993,
							28.525759339000047
						],
						[
							-81.40670120399994,
							28.525766993000047
						],
						[
							-81.40681520399994,
							28.525968992000063
						],
						[
							-81.40683857699992,
							28.526013240000054
						],
						[
							-81.40686286499995,
							28.52606684400007
						],
						[
							-81.4068835949999,
							28.526121922000073
						],
						[
							-81.40689563299992,
							28.52616016500008
						],
						[
							-81.40704059699993,
							28.526659281000036
						],
						[
							-81.40705797899994,
							28.526701992000085
						],
						[
							-81.40707659599991,
							28.526751922000074
						],
						[
							-81.40709026299993,
							28.52679584400005
						],
						[
							-81.40714126199993,
							28.52697584400005
						],
						[
							-81.40714467799995,
							28.526988238000058
						],
						[
							-81.40715804199993,
							28.52704555100007
						],
						[
							-81.40716001899995,
							28.527057526000082
						],
						[
							-81.40627599999993,
							28.527373501000056
						],
						[
							-81.40609199999994,
							28.52737000000008
						],
						[
							-81.40479199999993,
							28.52738000000005
						],
						[
							-81.40479199999993,
							28.52751500000005
						],
						[
							-81.4012919999999,
							28.527525000000082
						],
						[
							-81.4012919999999,
							28.52738000000005
						],
						[
							-81.40123228099992,
							28.52738003400009
						],
						[
							-81.40124155699993,
							28.52789858400007
						],
						[
							-81.40126459099992,
							28.528524513000036
						],
						[
							-81.40128361899991,
							28.528999216000045
						],
						[
							-81.4012904999999,
							28.52920365300008
						],
						[
							-81.40136386699993,
							28.529203387000052
						],
						[
							-81.40137575599994,
							28.52973931400004
						],
						[
							-81.4013617249999,
							28.53096813800005
						],
						[
							-81.39710128399992,
							28.531078172000036
						],
						[
							-81.39710241699993,
							28.53113537200005
						],
						[
							-81.39506138999991,
							28.53114940500007
						],
						[
							-81.39302537099991,
							28.53116442700008
						],
						[
							-81.39133786799995,
							28.531146401000058
						],
						[
							-81.39092325399993,
							28.53114139300004
						],
						[
							-81.39041149399992,
							28.531132380000088
						],
						[
							-81.3896593799999,
							28.531121363000068
						],
						[
							-81.38888623299994,
							28.531106341000054
						],
						[
							-81.38806901999993,
							28.531092320000084
						],
						[
							-81.38780362799992,
							28.531087313000057
						],
						[
							-81.38769346399994,
							28.531085310000037
						],
						[
							-81.38733893799993,
							28.531081304000054
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Holden Heights",
				"RegionID": "403121"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.59213005999993,
					30.257608982000082,
					-81.56900686799992,
					30.285980019000082
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.58038590799993,
							30.25831401100004
						],
						[
							-81.58107177199992,
							30.257608982000082
						],
						[
							-81.58394079699991,
							30.259581479000076
						],
						[
							-81.58850912299994,
							30.263150485000043
						],
						[
							-81.59203100199996,
							30.266397948000076
						],
						[
							-81.59202790699993,
							30.266505011000046
						],
						[
							-81.59202376299993,
							30.26666913300005
						],
						[
							-81.59207690799991,
							30.266675010000085
						],
						[
							-81.59213005999993,
							30.266680896000086
						],
						[
							-81.59210306799991,
							30.266876084000046
						],
						[
							-81.59203874799994,
							30.266948937000052
						],
						[
							-81.59201690799995,
							30.267112011000048
						],
						[
							-81.59199290799995,
							30.26730101000004
						],
						[
							-81.59184590799993,
							30.268346011000062
						],
						[
							-81.59172790699995,
							30.269208010000057
						],
						[
							-81.59169490699992,
							30.26940901000006
						],
						[
							-81.59160485699994,
							30.269963985000064
						],
						[
							-81.59143890599995,
							30.27107300900008
						],
						[
							-81.59106390499994,
							30.27322700800005
						],
						[
							-81.59101190599995,
							30.273567009000086
						],
						[
							-81.5909619059999,
							30.27396900800005
						],
						[
							-81.59093903099995,
							30.274149054000073
						],
						[
							-81.59086490499993,
							30.27427400800008
						],
						[
							-81.59074190599995,
							30.274418008000058
						],
						[
							-81.5900169059999,
							30.275089008000062
						],
						[
							-81.58961490599995,
							30.275490008000077
						],
						[
							-81.58933990599992,
							30.275745008000055
						],
						[
							-81.58883690599993,
							30.276229008000087
						],
						[
							-81.58829290499995,
							30.276740008000047
						],
						[
							-81.5877469049999,
							30.27725700900004
						],
						[
							-81.58755890599993,
							30.277431009000054
						],
						[
							-81.5869549059999,
							30.278008008000086
						],
						[
							-81.58654490599992,
							30.278390008000088
						],
						[
							-81.58595390499994,
							30.27894900900009
						],
						[
							-81.58483690499992,
							30.28002200900005
						],
						[
							-81.58383090599995,
							30.280981009000072
						],
						[
							-81.58332390599992,
							30.281442008000056
						],
						[
							-81.58222690499991,
							30.28249700800006
						],
						[
							-81.58167690599993,
							30.283006009000076
						],
						[
							-81.58124990499994,
							30.283417009000058
						],
						[
							-81.58095390599993,
							30.283686008000075
						],
						[
							-81.58082090399995,
							30.283807009000043
						],
						[
							-81.58067590699994,
							30.28392100800005
						],
						[
							-81.58057890499992,
							30.284023009000062
						],
						[
							-81.5804499059999,
							30.284148008000045
						],
						[
							-81.58037590499993,
							30.284235008000053
						],
						[
							-81.57978090499995,
							30.284781009000085
						],
						[
							-81.57956690499992,
							30.284994011000038
						],
						[
							-81.5794169049999,
							30.285216009000067
						],
						[
							-81.57936890699995,
							30.28530200800009
						],
						[
							-81.57911696499991,
							30.285980019000082
						],
						[
							-81.57738890699994,
							30.285179011000082
						],
						[
							-81.57661990799994,
							30.284818010000038
						],
						[
							-81.5749469079999,
							30.28403701000008
						],
						[
							-81.5744519079999,
							30.283749010000065
						],
						[
							-81.57428890799991,
							30.283635011000058
						],
						[
							-81.57421990799992,
							30.28358401000008
						],
						[
							-81.57392590799994,
							30.283327011000043
						],
						[
							-81.5731959069999,
							30.282541011000035
						],
						[
							-81.57228090699994,
							30.281533011000082
						],
						[
							-81.57153090799994,
							30.28071701000005
						],
						[
							-81.57132290699991,
							30.280517011000082
						],
						[
							-81.57082090699993,
							30.280105011000046
						],
						[
							-81.57064290699992,
							30.27997901100008
						],
						[
							-81.57050590699993,
							30.279910012000073
						],
						[
							-81.56931790699991,
							30.279548010000045
						],
						[
							-81.56900686799992,
							30.27944308200006
						],
						[
							-81.56913190799992,
							30.27910101000009
						],
						[
							-81.56921990699993,
							30.27890201100007
						],
						[
							-81.56959890799993,
							30.278219010000043
						],
						[
							-81.5698159079999,
							30.27788001100004
						],
						[
							-81.5702889069999,
							30.277073010000038
						],
						[
							-81.57100290799991,
							30.27583501000004
						],
						[
							-81.57113290699994,
							30.275528008000038
						],
						[
							-81.57119490699995,
							30.275250010000036
						],
						[
							-81.57120890699991,
							30.275040011000044
						],
						[
							-81.57120990699991,
							30.27481601100004
						],
						[
							-81.57120090799992,
							30.27404101100007
						],
						[
							-81.57118190799991,
							30.27327401100007
						],
						[
							-81.57113390799992,
							30.271790010000075
						],
						[
							-81.57111690799992,
							30.271334010000093
						],
						[
							-81.57108790699994,
							30.270551011000066
						],
						[
							-81.57108691999991,
							30.26945902400007
						],
						[
							-81.57116790799995,
							30.269003011000052
						],
						[
							-81.5712549079999,
							30.268631011000082
						],
						[
							-81.57132590799995,
							30.26839501000006
						],
						[
							-81.57146290699991,
							30.268042010000045
						],
						[
							-81.57156690799991,
							30.26779901000009
						],
						[
							-81.57169890699993,
							30.267543011000043
						],
						[
							-81.57183690799991,
							30.267318011000043
						],
						[
							-81.57210590699992,
							30.266959011000043
						],
						[
							-81.57225790799993,
							30.266752010000065
						],
						[
							-81.57270590799995,
							30.266260011000046
						],
						[
							-81.57300690799991,
							30.265967011000043
						],
						[
							-81.57358290699995,
							30.26536501100009
						],
						[
							-81.57399907999991,
							30.264944074000084
						],
						[
							-81.57397573499992,
							30.264465946000087
						],
						[
							-81.57451390799991,
							30.263931011000068
						],
						[
							-81.57588797499994,
							30.26290705900004
						],
						[
							-81.57627178699994,
							30.261995865000078
						],
						[
							-81.57696099299996,
							30.26184816400007
						],
						[
							-81.57723190799993,
							30.261570011000064
						],
						[
							-81.5773769079999,
							30.261407010000088
						],
						[
							-81.57845390799991,
							30.26031701000005
						],
						[
							-81.57863690699992,
							30.260116010000047
						],
						[
							-81.57948790699993,
							30.25924501000009
						],
						[
							-81.57976690699991,
							30.25895701100006
						],
						[
							-81.58038590799993,
							30.25831401100004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Tiger Hole-Secret Woods",
				"RegionID": "275746"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.6233372179999,
					30.371259051000038,
					-81.60696280099997,
					30.381607781000074
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.60732840299994,
							30.374755315000073
						],
						[
							-81.60763878599994,
							30.372938863000062
						],
						[
							-81.61311490799994,
							30.37327901000009
						],
						[
							-81.61417390799994,
							30.373210010000037
						],
						[
							-81.61494301699992,
							30.37310716600007
						],
						[
							-81.61539690799992,
							30.372238010000046
						],
						[
							-81.6158079999999,
							30.371553000000066
						],
						[
							-81.61666721899991,
							30.371259051000038
						],
						[
							-81.61695927099994,
							30.371835625000074
						],
						[
							-81.6170020859999,
							30.37193441400007
						],
						[
							-81.6170238549999,
							30.372002538000064
						],
						[
							-81.61719748899992,
							30.372631092000066
						],
						[
							-81.6183479579999,
							30.37326937100005
						],
						[
							-81.61841212899992,
							30.373309327000072
						],
						[
							-81.61847271599993,
							30.37335453400004
						],
						[
							-81.61852928999991,
							30.373404671000063
						],
						[
							-81.61858145099991,
							30.373459385000043
						],
						[
							-81.61862883099991,
							30.373518289000064
						],
						[
							-81.62002349699992,
							30.37540976700006
						],
						[
							-81.62077010599995,
							30.37639628600004
						],
						[
							-81.62083183499993,
							30.37648933900005
						],
						[
							-81.62089821399991,
							30.37663176500007
						],
						[
							-81.6213061599999,
							30.37775549300005
						],
						[
							-81.62298302199991,
							30.379183263000073
						],
						[
							-81.62308892099992,
							30.37928992700006
						],
						[
							-81.62317883599991,
							30.37941833900004
						],
						[
							-81.62324508599994,
							30.379560414000082
						],
						[
							-81.62328565899992,
							30.37971183500008
						],
						[
							-81.62329932199992,
							30.379868000000045
						],
						[
							-81.62329932199992,
							30.380237371000078
						],
						[
							-81.6233372179999,
							30.381151681000066
						],
						[
							-81.62243872399995,
							30.381190275000048
						],
						[
							-81.61271897199993,
							30.381607781000074
						],
						[
							-81.60805915799996,
							30.380237421000064
						],
						[
							-81.60696280099997,
							30.377770398000052
						],
						[
							-81.60732840299994,
							30.374755315000073
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "University Club",
				"RegionID": "275813"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.20596998199994,
					25.79162000000008,
					-80.17548076799994,
					25.812268339000074
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-80.17785322999993,
								25.796466535000036
							],
							[
								-80.1779247799999,
								25.79646478300009
							],
							[
								-80.17799624299994,
								25.796468727000047
							],
							[
								-80.1780671649999,
								25.796478341000068
							],
							[
								-80.17822169499993,
								25.796520058000056
							],
							[
								-80.1783188039999,
								25.79655620200009
							],
							[
								-80.17845466099993,
								25.796620164000046
							],
							[
								-80.1785830739999,
								25.796710079000036
							],
							[
								-80.17869392099993,
								25.796820927000056
							],
							[
								-80.17878383599992,
								25.796949339000037
							],
							[
								-80.17885008699994,
								25.79709141300009
							],
							[
								-80.17889065999994,
								25.79724283400009
							],
							[
								-80.17890174599995,
								25.797330973000044
							],
							[
								-80.17891274599992,
								25.797475974000065
							],
							[
								-80.17891532199991,
								25.797544000000073
							],
							[
								-80.1789016589999,
								25.797700166000084
							],
							[
								-80.17886108599994,
								25.797851586000036
							],
							[
								-80.17879483599995,
								25.797993661000078
							],
							[
								-80.1787621279999,
								25.79804606900007
							],
							[
								-80.17861812799993,
								25.79826006900004
							],
							[
								-80.17857652499993,
								25.798316949000082
							],
							[
								-80.17792440499994,
								25.79913891100006
							],
							[
								-80.1777759819999,
								25.79945745000009
							],
							[
								-80.1777618559999,
								25.79961787900004
							],
							[
								-80.17775165899991,
								25.79969516600005
							],
							[
								-80.17771108599993,
								25.799846587000047
							],
							[
								-80.1776448359999,
								25.799988661000043
							],
							[
								-80.17755492099991,
								25.80011707300008
							],
							[
								-80.17746870299993,
								25.800206480000043
							],
							[
								-80.1772317029999,
								25.80042048000007
							],
							[
								-80.17720707299992,
								25.800441921000072
							],
							[
								-80.17707866099994,
								25.80053183600006
							],
							[
								-80.1769365859999,
								25.800598087000086
							],
							[
								-80.17678516599996,
								25.80063866000006
							],
							[
								-80.17666946399994,
								25.800651411000047
							],
							[
								-80.17655846399992,
								25.80065641100009
							],
							[
								-80.17648391999995,
								25.800656676000074
							],
							[
								-80.17640961099995,
								25.800650766000047
							],
							[
								-80.1763360459999,
								25.800638722000087
							],
							[
								-80.17626373099995,
								25.800620628000047
							],
							[
								-80.17619316399993,
								25.800596606000056
							],
							[
								-80.1761248279999,
								25.800566823000054
							],
							[
								-80.17605282699992,
								25.800531823000085
							],
							[
								-80.17599633899994,
								25.80050183500009
							],
							[
								-80.1758679269999,
								25.800411920000045
							],
							[
								-80.17575707899995,
								25.80030107300007
							],
							[
								-80.17566716399995,
								25.80017266100009
							],
							[
								-80.17560091299993,
								25.800030586000048
							],
							[
								-80.17556033999995,
								25.79987916500005
							],
							[
								-80.17554668899993,
								25.79971986600009
							],
							[
								-80.17555069999992,
								25.799142733000057
							],
							[
								-80.1755597099999,
								25.799043718000064
							],
							[
								-80.17552465999995,
								25.798935802000074
							],
							[
								-80.17550625599995,
								25.798870958000066
							],
							[
								-80.17549275999994,
								25.79880491600005
							],
							[
								-80.17548424799992,
								25.798738050000054
							],
							[
								-80.17548076799994,
								25.79867073400004
							],
							[
								-80.17548233999992,
								25.79860334600005
							],
							[
								-80.17551284799993,
								25.798115950000067
							],
							[
								-80.1755171179999,
								25.798061502000053
							],
							[
								-80.1755273409999,
								25.797959835000086
							],
							[
								-80.17556791399994,
								25.797808414000087
							],
							[
								-80.17563416399992,
								25.797666339000045
							],
							[
								-80.1757240789999,
								25.797537927000064
							],
							[
								-80.17583492699993,
								25.79742708000009
							],
							[
								-80.1759633389999,
								25.797337165000044
							],
							[
								-80.17599872199992,
								25.79731962900007
							],
							[
								-80.17610364799992,
								25.797267520000048
							],
							[
								-80.1767504199999,
								25.796926882000037
							],
							[
								-80.17746481099994,
								25.79656962200005
							],
							[
								-80.17755941399992,
								25.796528914000078
							],
							[
								-80.1776676799999,
								25.79649704400009
							],
							[
								-80.17771167899991,
								25.79648704400006
							],
							[
								-80.17778204699994,
								25.79647397100007
							],
							[
								-80.17785322999993,
								25.796466535000036
							]
						]
					],
					[
						[
							[
								-80.1909019169999,
								25.811370025000087
							],
							[
								-80.19064997299995,
								25.811369956000078
							],
							[
								-80.19063756299994,
								25.811370267000086
							],
							[
								-80.18627000599992,
								25.81148000400009
							],
							[
								-80.18537213499991,
								25.811210368000047
							],
							[
								-80.18523729099991,
								25.81120381900007
							],
							[
								-80.18522231299994,
								25.81094917900009
							],
							[
								-80.18525226999992,
								25.810829349000073
							],
							[
								-80.18516239699994,
								25.810484836000057
							],
							[
								-80.1850126089999,
								25.810005514000068
							],
							[
								-80.18445367299995,
								25.809650358000056
							],
							[
								-80.18446188799993,
								25.80927055400008
							],
							[
								-80.18446320899994,
								25.809237540000083
							],
							[
								-80.18449672199995,
								25.808663995000074
							],
							[
								-80.18449867899994,
								25.807496772000036
							],
							[
								-80.1844996559999,
								25.80657162500006
							],
							[
								-80.18447066699991,
								25.805954176000057
							],
							[
								-80.18446967799991,
								25.805912000000035
							],
							[
								-80.18446967799991,
								25.805414280000036
							],
							[
								-80.18445476599993,
								25.80434655900007
							],
							[
								-80.1844557309999,
								25.804290494000043
							],
							[
								-80.18447273099991,
								25.803939494000076
							],
							[
								-80.18447448599994,
								25.803880019000076
							],
							[
								-80.18448187699994,
								25.80382097800009
							],
							[
								-80.18449483799992,
								25.803762905000042
							],
							[
								-80.18451325099994,
								25.803706324000075
							],
							[
								-80.18453694999994,
								25.80365174600007
							],
							[
								-80.1845034079999,
								25.803582101000075
							],
							[
								-80.1844762049999,
								25.803509745000042
							],
							[
								-80.18445555699992,
								25.803435252000046
							],
							[
								-80.18444162999992,
								25.803359216000047
							],
							[
								-80.18443453299994,
								25.80328224100009
							],
							[
								-80.18443432299995,
								25.803204940000057
							],
							[
								-80.18444676399992,
								25.802876694000076
							],
							[
								-80.18444964799994,
								25.802305612000055
							],
							[
								-80.1844427499999,
								25.80177840400006
							],
							[
								-80.18443373999992,
								25.80104457300007
							],
							[
								-80.18442579799995,
								25.800337725000077
							],
							[
								-80.18440993099995,
								25.799669343000062
							],
							[
								-80.1844104999999,
								25.799609562000057
							],
							[
								-80.18442424299991,
								25.799288308000087
							],
							[
								-80.18439517399992,
								25.798898957000063
							],
							[
								-80.18439274999992,
								25.798820653000064
							],
							[
								-80.1843967499999,
								25.79850365200008
							],
							[
								-80.18440296199992,
								25.79840887000006
							],
							[
								-80.18443767799994,
								25.798116749000087
							],
							[
								-80.18443767799994,
								25.79725700000006
							],
							[
								-80.18445134099994,
								25.797100835000037
							],
							[
								-80.18449191399992,
								25.79694941400004
							],
							[
								-80.18455816499994,
								25.796807339000054
							],
							[
								-80.18464807999993,
								25.796678927000073
							],
							[
								-80.1847589269999,
								25.796568080000043
							],
							[
								-80.18488733899994,
								25.796478165000053
							],
							[
								-80.18502703199994,
								25.79641302500005
							],
							[
								-80.18497007899992,
								25.796356073000087
							],
							[
								-80.1849283549999,
								25.796302345000072
							],
							[
								-80.1847453549999,
								25.79604734600008
							],
							[
								-80.1847082729999,
								25.795991376000075
							],
							[
								-80.18467546999995,
								25.795932795000056
							],
							[
								-80.18464712899993,
								25.79587193100008
							],
							[
								-80.18462340699995,
								25.795809121000048
							],
							[
								-80.18437540699995,
								25.795070121000037
							],
							[
								-80.18434233999994,
								25.79494016500007
							],
							[
								-80.18432873399992,
								25.79477685800009
							],
							[
								-80.18435279099992,
								25.79325871700007
							],
							[
								-80.18435340899993,
								25.793236753000087
							],
							[
								-80.18438806099994,
								25.792377693000052
							],
							[
								-80.18528917599991,
								25.792351385000075
							],
							[
								-80.18674099999993,
								25.792309000000046
							],
							[
								-80.18682017099991,
								25.792229829000064
							],
							[
								-80.18688767599991,
								25.792176993000055
							],
							[
								-80.18699598199993,
								25.79210201300009
							],
							[
								-80.18709999999993,
								25.792030000000068
							],
							[
								-80.18715826499995,
								25.792064959000072
							],
							[
								-80.18745095799994,
								25.792248215000086
							],
							[
								-80.1876105209999,
								25.792356028000086
							],
							[
								-80.1877199999999,
								25.79243000000008
							],
							[
								-80.18779886999994,
								25.792406996000068
							],
							[
								-80.18788071999995,
								25.792383123000036
							],
							[
								-80.18801714199992,
								25.792360000000087
							],
							[
								-80.18815999999993,
								25.792360000000087
							],
							[
								-80.18840718099995,
								25.792353820000073
							],
							[
								-80.18872366599993,
								25.792345908000073
							],
							[
								-80.18895999999995,
								25.79234000000008
							],
							[
								-80.18911349399991,
								25.792334940000046
							],
							[
								-80.18933329999994,
								25.79232769300006
							],
							[
								-80.18969830599991,
								25.792315660000042
							],
							[
								-80.18986999999993,
								25.792310000000043
							],
							[
								-80.19000222999995,
								25.792306925000048
							],
							[
								-80.19019700599995,
								25.792302395000036
							],
							[
								-80.19045321599992,
								25.79229643700006
							],
							[
								-80.19072999999992,
								25.792290000000037
							],
							[
								-80.19072999999992,
								25.792440213000077
							],
							[
								-80.19072999999992,
								25.79260000000005
							],
							[
								-80.19087933599991,
								25.792594850000057
							],
							[
								-80.19108615199991,
								25.79258771900004
							],
							[
								-80.19129296799991,
								25.79258058700009
							],
							[
								-80.19141546299994,
								25.79257636300008
							],
							[
								-80.19159999999994,
								25.79257000000007
							],
							[
								-80.19170753199995,
								25.792567243000065
							],
							[
								-80.19184142499995,
								25.792563810000047
							],
							[
								-80.19207269499992,
								25.792557880000064
							],
							[
								-80.19223155599992,
								25.792553806000058
							],
							[
								-80.1923799999999,
								25.792550000000062
							],
							[
								-80.1924866359999,
								25.792546001000062
							],
							[
								-80.19260963399995,
								25.792541389000064
							],
							[
								-80.19282856799992,
								25.79253317900009
							],
							[
								-80.1930475019999,
								25.792524969000056
							],
							[
								-80.19317999999993,
								25.79252000000008
							],
							[
								-80.19331605999992,
								25.792513815000063
							],
							[
								-80.19351054099991,
								25.79250605200008
							],
							[
								-80.19380249099993,
								25.792495625000072
							],
							[
								-80.19395999999995,
								25.792490000000043
							],
							[
								-80.19420460499992,
								25.79248694200004
							],
							[
								-80.19455777299993,
								25.79248252800005
							],
							[
								-80.19475999999992,
								25.79248000000007
							],
							[
								-80.19475663799994,
								25.792367379000044
							],
							[
								-80.19475227899994,
								25.792221348000055
							],
							[
								-80.19474682999993,
								25.792038809000076
							],
							[
								-80.19474207499991,
								25.791879519000076
							],
							[
								-80.19473664899994,
								25.791781514000036
							],
							[
								-80.1947199999999,
								25.791640000000086
							],
							[
								-80.19488705299995,
								25.791634611000063
							],
							[
								-80.19502050199992,
								25.79163030600006
							],
							[
								-80.19517907099993,
								25.791625191000037
							],
							[
								-80.19533999999993,
								25.79162000000008
							],
							[
								-80.19547135999994,
								25.79162414600006
							],
							[
								-80.19552687599992,
								25.79164994200005
							],
							[
								-80.19535671199992,
								25.792330656000047
							],
							[
								-80.19480624499994,
								25.79449136900007
							],
							[
								-80.19481472799993,
								25.794846410000048
							],
							[
								-80.19481901199993,
								25.79506062300004
							],
							[
								-80.1948255179999,
								25.795369350000044
							],
							[
								-80.19482999999991,
								25.795580000000086
							],
							[
								-80.19515885099992,
								25.795525182000063
							],
							[
								-80.19549284199991,
								25.795511642000065
							],
							[
								-80.1957799999999,
								25.79550000000006
							],
							[
								-80.19613345199991,
								25.795492636000063
							],
							[
								-80.19651391199994,
								25.79548471000004
							],
							[
								-80.19673999999992,
								25.795480000000055
							],
							[
								-80.19701280699991,
								25.79547174000004
							],
							[
								-80.19722999999993,
								25.79546000000005
							],
							[
								-80.19746289599993,
								25.795447411000055
							],
							[
								-80.19770999999992,
								25.795450000000073
							],
							[
								-80.19789247299991,
								25.79544289100005
							],
							[
								-80.19822458199992,
								25.795429951000074
							],
							[
								-80.1984799999999,
								25.795420000000036
							],
							[
								-80.19867527999992,
								25.79542114900005
							],
							[
								-80.19886999999994,
								25.795430000000067
							],
							[
								-80.1990307879999,
								25.79543803900009
							],
							[
								-80.1993599999999,
								25.795440000000042
							],
							[
								-80.19955503799991,
								25.795434264000054
							],
							[
								-80.19988736499994,
								25.795424489000084
							],
							[
								-80.20037999999994,
								25.79541000000006
							],
							[
								-80.20041104699993,
								25.79563141600005
							],
							[
								-80.20041579399992,
								25.795773806000057
							],
							[
								-80.20041999999995,
								25.795900000000074
							],
							[
								-80.20042780099993,
								25.796083326000087
							],
							[
								-80.20043587399994,
								25.796273047000057
							],
							[
								-80.2004399999999,
								25.79637000000008
							],
							[
								-80.20044341599993,
								25.796510054000066
							],
							[
								-80.2004468909999,
								25.796652518000087
							],
							[
								-80.20044999999993,
								25.796780000000073
							],
							[
								-80.20046121999991,
								25.796937083000046
							],
							[
								-80.20046999999994,
								25.797060000000045
							],
							[
								-80.20047295799992,
								25.797246345000076
							],
							[
								-80.20047521399994,
								25.797388481000045
							],
							[
								-80.20047822999993,
								25.797578498000064
							],
							[
								-80.20047999999991,
								25.797690000000046
							],
							[
								-80.20071828599993,
								25.797683472000074
							],
							[
								-80.20083763799994,
								25.797680202000038
							],
							[
								-80.20100446999993,
								25.79767563100006
							],
							[
								-80.20120999999995,
								25.79767000000004
							],
							[
								-80.20126608599992,
								25.797666701000086
							],
							[
								-80.20140791499995,
								25.797659214000078
							],
							[
								-80.20159782999991,
								25.79765386400004
							],
							[
								-80.20197765799992,
								25.797643165000068
							],
							[
								-80.20228693699994,
								25.797634452000068
							],
							[
								-80.20266676599994,
								25.79762375300004
							],
							[
								-80.20301999999992,
								25.79762000000005
							],
							[
								-80.20301999999992,
								25.79738876500005
							],
							[
								-80.20302610099992,
								25.79732932400009
							],
							[
								-80.20306195499995,
								25.79726869600006
							],
							[
								-80.2031426289999,
								25.797226228000056
							],
							[
								-80.20337934399993,
								25.797214222000036
							],
							[
								-80.2036181009999,
								25.79720730100007
							],
							[
								-80.20386999999994,
								25.797200000000093
							],
							[
								-80.20399801499991,
								25.797195508000076
							],
							[
								-80.20418784599991,
								25.797188848000076
							],
							[
								-80.20443999999992,
								25.797180000000083
							],
							[
								-80.20468628099991,
								25.79717507400005
							],
							[
								-80.20489954399994,
								25.79717080900008
							],
							[
								-80.20549353399991,
								25.797212433000084
							],
							[
								-80.20557003499994,
								25.802469966000046
							],
							[
								-80.20577996299994,
								25.803539984000054
							],
							[
								-80.20587996899991,
								25.809070010000084
							],
							[
								-80.20575984499993,
								25.809520003000046
							],
							[
								-80.20596998199994,
								25.810580024000046
							],
							[
								-80.20589124199995,
								25.812268339000074
							],
							[
								-80.20047273499995,
								25.81137263900007
							],
							[
								-80.1909019169999,
								25.811370025000087
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami",
				"Name": "Wynwood - Edgewater",
				"RegionID": "276165"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.5186582773822,
					27.89349998967466,
					-82.50017531930517,
					27.908605900901527
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.51642727256683,
							27.908581817956907
						],
						[
							-82.50625488281273,
							27.908464106595808
						],
						[
							-82.50215521992018,
							27.9084882452984
						],
						[
							-82.50017531930517,
							27.90849987802882
						],
						[
							-82.50220012486768,
							27.905500048206587
						],
						[
							-82.50295449507159,
							27.90240907299587
						],
						[
							-82.50631818249308,
							27.89610000070789
						],
						[
							-82.50777298606224,
							27.894149627533103
						],
						[
							-82.50819608560076,
							27.89358223717094
						],
						[
							-82.50874488337935,
							27.893577933015685
						],
						[
							-82.50939999900812,
							27.89357272684046
						],
						[
							-82.50970715525274,
							27.893570341838398
						],
						[
							-82.51855453339157,
							27.89349998967466
						],
						[
							-82.5186582773822,
							27.904769135918475
						],
						[
							-82.51862806375931,
							27.905541292913526
						],
						[
							-82.51850843864096,
							27.908605900901527
						],
						[
							-82.51785655517544,
							27.908598357388335
						],
						[
							-82.51721125924382,
							27.908590890317548
						],
						[
							-82.51642727256683,
							27.908581817956907
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Fairoaks",
				"RegionID": "276329"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.59880998799991,
					30.287392957000066,
					-81.5663987449999,
					30.313418099000046
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.56853588499992,
							30.287392957000066
						],
						[
							-81.56885490799993,
							30.287429009000054
						],
						[
							-81.56998099999993,
							30.287531000000058
						],
						[
							-81.57019579399991,
							30.287549517000063
						],
						[
							-81.57021859799994,
							30.28761793000007
						],
						[
							-81.5705276939999,
							30.288037417000055
						],
						[
							-81.57074847699994,
							30.28841274800004
						],
						[
							-81.5708147119999,
							30.288766001000052
						],
						[
							-81.57092510299992,
							30.289008862000063
						],
						[
							-81.57141082599992,
							30.28931795800008
						],
						[
							-81.57156537399993,
							30.289560820000077
						],
						[
							-81.57152121699994,
							30.289891994000072
						],
						[
							-81.57171992199994,
							30.290377716000076
						],
						[
							-81.57200693999994,
							30.290907595000075
						],
						[
							-81.57233811399993,
							30.291415396000044
						],
						[
							-81.57300046299991,
							30.29216605800008
						],
						[
							-81.5735744989999,
							30.29265178100007
						],
						[
							-81.57432516099993,
							30.29302711200006
						],
						[
							-81.57547323199992,
							30.29362322500009
						],
						[
							-81.57675377299995,
							30.294042713000064
						],
						[
							-81.57748235599992,
							30.29432973100006
						],
						[
							-81.57801223599995,
							30.29432973100006
						],
						[
							-81.57840964499991,
							30.294153104000088
						],
						[
							-81.57900575899993,
							30.29393232200005
						],
						[
							-81.57957979399994,
							30.293844008000065
						],
						[
							-81.58013175199994,
							30.29395440000008
						],
						[
							-81.58108111799993,
							30.29419726100008
						],
						[
							-81.58233958099993,
							30.294462201000048
						],
						[
							-81.58359804399993,
							30.294727140000077
						],
						[
							-81.58505521099994,
							30.29474921800005
						],
						[
							-81.58587210799993,
							30.29450635700005
						],
						[
							-81.58693186599993,
							30.294241418000073
						],
						[
							-81.58834487699994,
							30.294241418000073
						],
						[
							-81.5898020439999,
							30.294440122000083
						],
						[
							-81.5906910569999,
							30.294666733000042
						],
						[
							-81.59092803699991,
							30.294727140000077
						],
						[
							-81.59185532499993,
							30.295323254000042
						],
						[
							-81.59249559599994,
							30.29565442800003
						],
						[
							-81.5930033969999,
							30.296051838000043
						],
						[
							-81.59364366699992,
							30.29620638600005
						],
						[
							-81.59404107599994,
							30.296471325000084
						],
						[
							-81.59415146799995,
							30.296912891000094
						],
						[
							-81.59423978099994,
							30.297553162000042
						],
						[
							-81.59417354599992,
							30.298149276000064
						],
						[
							-81.59393068499992,
							30.298988251000086
						],
						[
							-81.59370990199994,
							30.29978306900006
						],
						[
							-81.59348911899991,
							30.30040126100005
						],
						[
							-81.59351119699994,
							30.30066620100007
						],
						[
							-81.5941073109999,
							30.30165972400005
						],
						[
							-81.5943943289999,
							30.30241038600008
						],
						[
							-81.59485797299995,
							30.303094813000087
						],
						[
							-81.59523330399992,
							30.30331559600006
						],
						[
							-81.5958956529999,
							30.303536379000032
						],
						[
							-81.59669047199992,
							30.303779240000043
						],
						[
							-81.59722035099992,
							30.30404418000006
						],
						[
							-81.5975956819999,
							30.304596137000086
						],
						[
							-81.59794893399993,
							30.30536887700004
						],
						[
							-81.59819179499993,
							30.30574420800008
						],
						[
							-81.59850089199996,
							30.306163696000052
						],
						[
							-81.59874375299995,
							30.30669357500005
						],
						[
							-81.59880998799991,
							30.307289689000072
						],
						[
							-81.5986554399999,
							30.30770917600006
						],
						[
							-81.59830218699994,
							30.308106586000065
						],
						[
							-81.59799309099992,
							30.308592308000073
						],
						[
							-81.5976398379999,
							30.309276735000086
						],
						[
							-81.59733074199994,
							30.309850771000068
						],
						[
							-81.59688917599993,
							30.310535198000082
						],
						[
							-81.59677878499991,
							30.31104299900005
						],
						[
							-81.59664631499993,
							30.311506643000087
						],
						[
							-81.59616059199993,
							30.31234561800005
						],
						[
							-81.59574110499995,
							30.312654714000075
						],
						[
							-81.59548338199994,
							30.31301982100007
						],
						[
							-81.59501199999994,
							30.312903000000063
						],
						[
							-81.59459690799993,
							30.312779010000046
						],
						[
							-81.5941599059999,
							30.312682010000064
						],
						[
							-81.59378290699993,
							30.312610012000047
						],
						[
							-81.5934129069999,
							30.312591011000052
						],
						[
							-81.59326990799991,
							30.312584010000084
						],
						[
							-81.59285490899993,
							30.312597011000037
						],
						[
							-81.59267890799993,
							30.312608011000066
						],
						[
							-81.59228590599992,
							30.31263401000007
						],
						[
							-81.5919779059999,
							30.31265101000008
						],
						[
							-81.59152690899992,
							30.31267501000008
						],
						[
							-81.59107990599995,
							30.31270501100005
						],
						[
							-81.59003390799995,
							30.31276201100008
						],
						[
							-81.58975790699992,
							30.312781011000084
						],
						[
							-81.5890669069999,
							30.312811010000075
						],
						[
							-81.58752890599993,
							30.31291801100008
						],
						[
							-81.58686090899994,
							30.312961011000084
						],
						[
							-81.5863579089999,
							30.31298301100009
						],
						[
							-81.58596390899993,
							30.313004010000046
						],
						[
							-81.58537290599992,
							30.313047010000048
						],
						[
							-81.58492790799994,
							30.31307201000004
						],
						[
							-81.58391690899992,
							30.31312901000007
						],
						[
							-81.58275090699993,
							30.313195010000076
						],
						[
							-81.58244090699992,
							30.313212011000076
						],
						[
							-81.58159290899995,
							30.31326001000008
						],
						[
							-81.57905791799993,
							30.313418099000046
						],
						[
							-81.57881890699993,
							30.310593010000048
						],
						[
							-81.5787949079999,
							30.310356010000078
						],
						[
							-81.57879290699992,
							30.310253011000043
						],
						[
							-81.57878090699995,
							30.310064010000072
						],
						[
							-81.5787289079999,
							30.309533010000052
						],
						[
							-81.57869390699994,
							30.30900201100008
						],
						[
							-81.57867806899992,
							30.308869918000084
						],
						[
							-81.57818273399994,
							30.308476075000044
						],
						[
							-81.57842390499991,
							30.307149013000068
						],
						[
							-81.57841090799991,
							30.306951010000034
						],
						[
							-81.5781819849999,
							30.30538197700008
						],
						[
							-81.57734090899993,
							30.30423483000004
						],
						[
							-81.57664399299995,
							30.305158172000066
						],
						[
							-81.57516377899992,
							30.305277871000044
						],
						[
							-81.57498890799991,
							30.306400010000065
						],
						[
							-81.57498190799993,
							30.306628010000058
						],
						[
							-81.57496898999995,
							30.30701515600003
						],
						[
							-81.57453390699993,
							30.30676901000004
						],
						[
							-81.57431990799995,
							30.306647011000052
						],
						[
							-81.57427540799995,
							30.306622011000062
						],
						[
							-81.57421090799994,
							30.30658301100004
						],
						[
							-81.57410090799993,
							30.306523011000085
						],
						[
							-81.57323485099994,
							30.30603207000007
						],
						[
							-81.5728759079999,
							30.305463010000043
						],
						[
							-81.57195090699992,
							30.30387301000008
						],
						[
							-81.56889590799994,
							30.298623011000075
						],
						[
							-81.56695190799991,
							30.294412010000084
						],
						[
							-81.5663987449999,
							30.292637926000054
						],
						[
							-81.56973207599992,
							30.291731095000042
						],
						[
							-81.56945790799995,
							30.29089001000006
						],
						[
							-81.56935890799991,
							30.290468011000087
						],
						[
							-81.5692989069999,
							30.290092010000084
						],
						[
							-81.56912890799993,
							30.28962301100006
						],
						[
							-81.56883290799993,
							30.288901010000075
						],
						[
							-81.56855390899995,
							30.288170010000048
						],
						[
							-81.56853290799995,
							30.288049010000066
						],
						[
							-81.56851790799993,
							30.28760900900005
						],
						[
							-81.56852990699991,
							30.287482011000066
						],
						[
							-81.56853588499992,
							30.287392957000066
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Glynlea - Grove Park",
				"RegionID": "276347"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.63052414099991,
					27.873224235000066,
					-82.62245503699995,
					27.877343772000074
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.62245503699995,
							27.87628227500005
						],
						[
							-82.62245503699995,
							27.87373640800007
						],
						[
							-82.62425008899993,
							27.873632847000067
						],
						[
							-82.62450036099995,
							27.873261755000044
						],
						[
							-82.62521324099993,
							27.873224235000066
						],
						[
							-82.62521360799991,
							27.873226832000057
						],
						[
							-82.62523802499993,
							27.87339938000008
						],
						[
							-82.62526789099991,
							27.87361043200008
						],
						[
							-82.62529906499992,
							27.873830723000083
						],
						[
							-82.62532193999994,
							27.87399237300008
						],
						[
							-82.62533999999994,
							27.87412000000006
						],
						[
							-82.62533966599995,
							27.87412401200004
						],
						[
							-82.62538782399992,
							27.87412239100007
						],
						[
							-82.62546001999993,
							27.874126001000036
						],
						[
							-82.6255435519999,
							27.874130178000087
						],
						[
							-82.62565721599992,
							27.87413586100007
						],
						[
							-82.62573999999995,
							27.874140000000068
						],
						[
							-82.62578237699995,
							27.87415509300007
						],
						[
							-82.62589304799991,
							27.874194510000052
						],
						[
							-82.6259821239999,
							27.874226236000087
						],
						[
							-82.62611744599991,
							27.874274433000043
						],
						[
							-82.6262459319999,
							27.874320195000053
						],
						[
							-82.6263027949999,
							27.874340448000055
						],
						[
							-82.62667407399994,
							27.874339257000088
						],
						[
							-82.62733204099993,
							27.874345239000036
						],
						[
							-82.62744568999994,
							27.874584499000036
						],
						[
							-82.6275593389999,
							27.874686185000087
						],
						[
							-82.62762513599996,
							27.87471011100007
						],
						[
							-82.62763709899991,
							27.874835723000047
						],
						[
							-82.62771485899992,
							27.874877594000054
						],
						[
							-82.62816347299992,
							27.874877594000054
						],
						[
							-82.6282591769999,
							27.87499124300007
						],
						[
							-82.62961100099994,
							27.874955354000065
						],
						[
							-82.62960879499991,
							27.875747234000073
						],
						[
							-82.63050688099992,
							27.875764471000082
						],
						[
							-82.63052414099991,
							27.877214321000054
						],
						[
							-82.63052414099991,
							27.877343772000074
						],
						[
							-82.62447446999994,
							27.877335142000053
						],
						[
							-82.62245503699995,
							27.87628227500005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Sterling Manor",
				"RegionID": "417205"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.21364815499999,
					26.009868,
					-80.19951605899996,
					26.066448
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-80.20751104799996,
								26.034390803000065
							],
							[
								-80.20736828099996,
								26.03215411000008
							],
							[
								-80.20346596499996,
								26.032296877000082
							],
							[
								-80.200335528,
								26.032342759000073
							],
							[
								-80.20013471899995,
								26.025110905000076
							],
							[
								-80.19951605899996,
								26.01026306800003
							],
							[
								-80.20760622699999,
								26.010167890000048
							],
							[
								-80.21269827299996,
								26.01002512200006
							],
							[
								-80.213369,
								26.009868
							],
							[
								-80.21274586199996,
								26.012261816000034
							],
							[
								-80.21274586199996,
								26.014070206000042
							],
							[
								-80.21312657599998,
								26.02482537000003
							],
							[
								-80.21350728999994,
								26.03224928800006
							],
							[
								-80.21364815499999,
								26.035677
							],
							[
								-80.21332,
								26.035677
							],
							[
								-80.212669,
								26.035667
							],
							[
								-80.208469,
								26.035591
							],
							[
								-80.207569,
								26.035567000000004
							],
							[
								-80.20751104799996,
								26.034390803000065
							]
						]
					],
					[
						[
							[
								-80.20706900000002,
								26.064366
							],
							[
								-80.207027,
								26.064247000000005
							],
							[
								-80.206686,
								26.064267
							],
							[
								-80.206425,
								26.064282
							],
							[
								-80.206386,
								26.06315
							],
							[
								-80.205638,
								26.063176
							],
							[
								-80.205638,
								26.063271
							],
							[
								-80.205641,
								26.063348
							],
							[
								-80.205469,
								26.063348
							],
							[
								-80.205089,
								26.063347
							],
							[
								-80.205086,
								26.063293000000005
							],
							[
								-80.205019,
								26.062788
							],
							[
								-80.205169,
								26.062766
							],
							[
								-80.205478,
								26.062786
							],
							[
								-80.205969,
								26.062766
							],
							[
								-80.206689,
								26.06275
							],
							[
								-80.206826,
								26.062745
							],
							[
								-80.206804,
								26.062606
							],
							[
								-80.206803,
								26.060166
							],
							[
								-80.20689700000001,
								26.060166
							],
							[
								-80.20688,
								26.058689
							],
							[
								-80.207109,
								26.058549
							],
							[
								-80.20708846799994,
								26.058042413000067
							],
							[
								-80.207057,
								26.057266
							],
							[
								-80.207465,
								26.057266
							],
							[
								-80.207432,
								26.05607
							],
							[
								-80.206305,
								26.056104
							],
							[
								-80.206199,
								26.054552
							],
							[
								-80.206218,
								26.054396
							],
							[
								-80.207085,
								26.054379
							],
							[
								-80.206984,
								26.053797
							],
							[
								-80.206698,
								26.053777
							],
							[
								-80.206625,
								26.053415
							],
							[
								-80.206236,
								26.053451
							],
							[
								-80.206176,
								26.052006
							],
							[
								-80.205967,
								26.052012
							],
							[
								-80.205067,
								26.052039
							],
							[
								-80.204066,
								26.052068
							],
							[
								-80.203797,
								26.052076
							],
							[
								-80.203816,
								26.051556
							],
							[
								-80.203896,
								26.048208
							],
							[
								-80.204444,
								26.048008
							],
							[
								-80.20460800000001,
								26.047948
							],
							[
								-80.204937,
								26.047828000000003
							],
							[
								-80.20492,
								26.046961
							],
							[
								-80.204869,
								26.046966
							],
							[
								-80.204565,
								26.046966
							],
							[
								-80.204286,
								26.046966
							],
							[
								-80.203469,
								26.046966
							],
							[
								-80.20256900000001,
								26.046966
							],
							[
								-80.200869,
								26.046866
							],
							[
								-80.20071618299994,
								26.044869764000058
							],
							[
								-80.20064697299995,
								26.042378205000034
							],
							[
								-80.20061236799995,
								26.039955856000063
							],
							[
								-80.20469123599997,
								26.039865778000035
							],
							[
								-80.204809,
								26.043037
							],
							[
								-80.208874,
								26.042959
							],
							[
								-80.208969,
								26.044567
							],
							[
								-80.208869,
								26.045567
							],
							[
								-80.208963,
								26.046606
							],
							[
								-80.208969,
								26.046667
							],
							[
								-80.208499,
								26.046667
							],
							[
								-80.20845300000002,
								26.047958000000005
							],
							[
								-80.208398,
								26.049519
							],
							[
								-80.208305,
								26.049983
							],
							[
								-80.20759,
								26.049979
							],
							[
								-80.207519,
								26.051497
							],
							[
								-80.207569,
								26.053366
							],
							[
								-80.207669,
								26.053666
							],
							[
								-80.207669,
								26.054266
							],
							[
								-80.207669,
								26.054466
							],
							[
								-80.207569,
								26.056066
							],
							[
								-80.207669,
								26.056366
							],
							[
								-80.207669,
								26.057266
							],
							[
								-80.207669,
								26.058666
							],
							[
								-80.207669,
								26.059266000000004
							],
							[
								-80.207769,
								26.059666
							],
							[
								-80.207769,
								26.060166
							],
							[
								-80.207869,
								26.062666000000004
							],
							[
								-80.207869,
								26.064766
							],
							[
								-80.207931,
								26.065696
							],
							[
								-80.207969,
								26.066266
							],
							[
								-80.20708,
								26.066448
							],
							[
								-80.20706900000002,
								26.065566
							],
							[
								-80.20706900000002,
								26.064866
							],
							[
								-80.20706900000002,
								26.064366
							]
						],
						[
							[
								-80.207177,
								26.046767000000003
							],
							[
								-80.207215,
								26.047148
							],
							[
								-80.206557,
								26.047194
							],
							[
								-80.206487,
								26.047197
							],
							[
								-80.206112,
								26.047228
							],
							[
								-80.206165,
								26.046854000000003
							],
							[
								-80.205547,
								26.046902
							],
							[
								-80.205186,
								26.046940000000003
							],
							[
								-80.205239,
								26.047462
							],
							[
								-80.205288,
								26.047914
							],
							[
								-80.205666,
								26.047850000000004
							],
							[
								-80.206777,
								26.048591
							],
							[
								-80.207013,
								26.048698
							],
							[
								-80.20716300000001,
								26.048774
							],
							[
								-80.207684,
								26.047761
							],
							[
								-80.207732,
								26.047458
							],
							[
								-80.207767,
								26.046734
							],
							[
								-80.207569,
								26.046767000000003
							],
							[
								-80.207177,
								26.046767000000003
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Hollywood",
				"Name": "441 Corridor",
				"RegionID": "623401"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.16735697399992,
					26.010887666000087,
					-80.14907796499995,
					26.033467000000087
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.14907796499995,
							26.011464683000042
						],
						[
							-80.15794441799994,
							26.011199111000053
						],
						[
							-80.1605051869999,
							26.011095296000065
						],
						[
							-80.1668378999999,
							26.010887666000087
						],
						[
							-80.16673408499992,
							26.012652520000074
						],
						[
							-80.16690710899991,
							26.013794485000062
						],
						[
							-80.16695476199993,
							26.014318666000065
						],
						[
							-80.16711473899994,
							26.01607841400005
						],
						[
							-80.16725315899993,
							26.01874299800005
						],
						[
							-80.16735697399992,
							26.022307312000066
						],
						[
							-80.16721855399993,
							26.023518487000047
						],
						[
							-80.16711473899994,
							26.024729661000038
						],
						[
							-80.16624961499991,
							26.027048195000077
						],
						[
							-80.16562672499992,
							26.028640025000072
						],
						[
							-80.1648308099999,
							26.03099316400005
						],
						[
							-80.1643117349999,
							26.033380908000083
						],
						[
							-80.16154205999993,
							26.033399617000043
						],
						[
							-80.15156699999996,
							26.033467000000087
						],
						[
							-80.1501669999999,
							26.033467000000087
						],
						[
							-80.14996699999995,
							26.033467000000087
						],
						[
							-80.14966699999991,
							26.033467000000087
						],
						[
							-80.14907796499995,
							26.011464683000042
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Hollywood",
				"Name": "North Central",
				"RegionID": "623403"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.14439477999991,
					25.762440333000086,
					-80.12871619899994,
					25.774763504000077
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.12871619899994,
							25.774763504000077
						],
						[
							-80.13006571099993,
							25.762440333000086
						],
						[
							-80.13925299999994,
							25.76593700000007
						],
						[
							-80.14439477999991,
							25.773563394000064
						],
						[
							-80.1443641649999,
							25.773575640000047
						],
						[
							-80.14317017799993,
							25.774053235000057
						],
						[
							-80.14203374699991,
							25.77444388300006
						],
						[
							-80.1407907759999,
							25.77447939600006
						],
						[
							-80.13830483399994,
							25.774408369000074
						],
						[
							-80.1347534869999,
							25.77455042300005
						],
						[
							-80.13301332799995,
							25.77462145000004
						],
						[
							-80.12871619899994,
							25.774763504000077
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Beach",
				"Name": "South Pointe",
				"RegionID": "623410"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.16667576799995,
					25.78573716300008,
					-80.16142409699995,
					25.796121638000045
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.16142409699995,
							25.796107094000035
						],
						[
							-80.16142409699995,
							25.78573716300008
						],
						[
							-80.16667576799995,
							25.788144636000084
						],
						[
							-80.16643667299991,
							25.78871281000005
						],
						[
							-80.16636799999992,
							25.788876000000073
						],
						[
							-80.16575499999993,
							25.790238000000045
						],
						[
							-80.16572799999994,
							25.790501000000063
						],
						[
							-80.16581499999995,
							25.790597000000048
						],
						[
							-80.16572999999994,
							25.79072800000006
						],
						[
							-80.16547899599993,
							25.791834854000058
						],
						[
							-80.16450687299994,
							25.796121638000045
						],
						[
							-80.16142409699995,
							25.796107094000035
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Beach",
				"Name": "San Marino Island",
				"RegionID": "623412"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.16142409699995,
					25.78573716300008,
					-80.15712696799994,
					25.796107094000035
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.15712696799994,
							25.78708667500007
						],
						[
							-80.15712696799994,
							25.78573716300008
						],
						[
							-80.16142409699995,
							25.78573716300008
						],
						[
							-80.16142409699995,
							25.796107094000035
						],
						[
							-80.15712696799994,
							25.796107094000035
						],
						[
							-80.15712696799994,
							25.78708667500007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Beach",
				"Name": "Di Lido Island",
				"RegionID": "623417"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-122.19403499999993,
					37.412671000000046,
					-122.18703399999994,
					37.421777000000084
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-122.19403499999993,
							37.412671000000046
						],
						[
							-122.1937687379999,
							37.413516721000065
						],
						[
							-122.19335794099993,
							37.41399071700005
						],
						[
							-122.19272594599992,
							37.414369914000076
						],
						[
							-122.19206235199994,
							37.414433114000076
						],
						[
							-122.19111435899993,
							37.414591113000085
						],
						[
							-122.19051396399995,
							37.41487551000006
						],
						[
							-122.19016636599991,
							37.41566550400006
						],
						[
							-122.19016636599991,
							37.41617110000004
						],
						[
							-122.19070356199991,
							37.417024293000054
						],
						[
							-122.19133555699995,
							37.417782687000056
						],
						[
							-122.19139875699994,
							37.41888867900008
						],
						[
							-122.19108275899993,
							37.41974187200009
						],
						[
							-122.1909563599999,
							37.42034226700008
						],
						[
							-122.19136715699996,
							37.421701057000064
						],
						[
							-122.19067999999993,
							37.42169500000006
						],
						[
							-122.18913399999991,
							37.421777000000084
						],
						[
							-122.18885899999992,
							37.42059700000004
						],
						[
							-122.18874399999993,
							37.420386000000065
						],
						[
							-122.18818799999991,
							37.42020500000007
						],
						[
							-122.18820499999994,
							37.41947800000008
						],
						[
							-122.18856299999992,
							37.419170000000065
						],
						[
							-122.1889759999999,
							37.41896200000008
						],
						[
							-122.18988499999996,
							37.41892300000006
						],
						[
							-122.19015399999991,
							37.41882400000009
						],
						[
							-122.19025799999991,
							37.41850000000005
						],
						[
							-122.19009399999992,
							37.41806800000006
						],
						[
							-122.18960999999992,
							37.41748600000005
						],
						[
							-122.18734499999994,
							37.41672100000005
						],
						[
							-122.18704099999991,
							37.41631300000006
						],
						[
							-122.18703399999994,
							37.41612100000009
						],
						[
							-122.18750199999995,
							37.415242000000035
						],
						[
							-122.18757899999993,
							37.41475200000008
						],
						[
							-122.18882999999994,
							37.41446600000007
						],
						[
							-122.18885299999995,
							37.41453700000005
						],
						[
							-122.18913499999992,
							37.414517000000046
						],
						[
							-122.19059499999992,
							37.414187000000084
						],
						[
							-122.19138699999992,
							37.41419200000007
						],
						[
							-122.1921309999999,
							37.414000000000044
						],
						[
							-122.19272999999994,
							37.41368700000004
						],
						[
							-122.1934599999999,
							37.41296100000005
						],
						[
							-122.19403499999993,
							37.412671000000046
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Lee",
				"City": "Bokeelia",
				"Name": "Stanford Weekend Acres",
				"RegionID": "698707"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.32499579199998,
					29.64045838100003,
					-82.31153489899998,
					29.648390611000025
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.31154074599993,
							29.648248248000076
						],
						[
							-82.31154917599997,
							29.646196372000077
						],
						[
							-82.31153489899998,
							29.64576450000004
						],
						[
							-82.31154718999994,
							29.641410256000032
						],
						[
							-82.31159956399995,
							29.641028663000046
						],
						[
							-82.31694595999994,
							29.64105717700005
						],
						[
							-82.31750198599997,
							29.641156977000037
						],
						[
							-82.31929124599998,
							29.64045838100003
						],
						[
							-82.32141554799995,
							29.644685599000073
						],
						[
							-82.32160801799995,
							29.64520598100006
						],
						[
							-82.32239215599999,
							29.64531290900004
						],
						[
							-82.32295530999994,
							29.64520598100006
						],
						[
							-82.32418141699998,
							29.64480678400003
						],
						[
							-82.32499406899996,
							29.644664213000055
						],
						[
							-82.32499406899996,
							29.645769135000023
						],
						[
							-82.32499579199998,
							29.648378517000026
						],
						[
							-82.32231028299998,
							29.648390611000025
						],
						[
							-82.32089251499997,
							29.64838265700007
						],
						[
							-82.32056740299998,
							29.64836277300003
						],
						[
							-82.31977400899996,
							29.648252414000073
						],
						[
							-82.31647416799996,
							29.648235512000042
						],
						[
							-82.31508821499995,
							29.648220598000027
						],
						[
							-82.31154074599993,
							29.648248248000076
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Alachua",
				"City": "Gainesville",
				"Name": "Springhill",
				"RegionID": "414449"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.64083533899992,
					27.72232000000008,
					-82.63322944599992,
					27.735553356000082
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.63719068499995,
							27.73505411800005
						],
						[
							-82.63683581299995,
							27.734415349000074
						],
						[
							-82.6366228899999,
							27.73398950300009
						],
						[
							-82.63655191599992,
							27.733652375000077
						],
						[
							-82.63649868499994,
							27.733315246000075
						],
						[
							-82.63632124899993,
							27.732534529000077
						],
						[
							-82.6362147879999,
							27.73168283700005
						],
						[
							-82.63623253099992,
							27.730919862000064
						],
						[
							-82.63607283899995,
							27.730174632000057
						],
						[
							-82.63584217199991,
							27.729642324000054
						],
						[
							-82.63561150599993,
							27.72911001700004
						],
						[
							-82.6355050439999,
							27.728364786000043
						],
						[
							-82.6355050439999,
							27.727796991000048
						],
						[
							-82.6354873009999,
							27.72699853000006
						],
						[
							-82.63546955699991,
							27.726661402000047
						],
						[
							-82.63545181299992,
							27.726448479000055
						],
						[
							-82.63541632599993,
							27.726288787000044
						],
						[
							-82.6353098649999,
							27.72614683800009
						],
						[
							-82.63516791599994,
							27.72602263300007
						],
						[
							-82.63497273699994,
							27.72588068400006
						],
						[
							-82.63444042899995,
							27.725596787000086
						],
						[
							-82.63385489099994,
							27.725241915000087
						],
						[
							-82.6334467879999,
							27.72485155600009
						],
						[
							-82.63322944599992,
							27.72434485100007
						],
						[
							-82.63324807099991,
							27.724269648000075
						],
						[
							-82.63327341399992,
							27.724196436000057
						],
						[
							-82.63330526999994,
							27.724125814000047
						],
						[
							-82.6333433769999,
							27.724058360000072
						],
						[
							-82.63346837699993,
							27.723858359000076
						],
						[
							-82.63354207999993,
							27.72375692700007
						],
						[
							-82.63365722099991,
							27.723642521000045
						],
						[
							-82.6338485149999,
							27.723485963000087
						],
						[
							-82.6339029849999,
							27.723444748000077
						],
						[
							-82.63396042599993,
							27.723407786000053
						],
						[
							-82.63402050699995,
							27.72337529100008
						],
						[
							-82.63408288099993,
							27.723347449000073
						],
						[
							-82.63414718799993,
							27.723324421000086
						],
						[
							-82.63421561899992,
							27.723302812000043
						],
						[
							-82.63426367499994,
							27.723138107000068
						],
						[
							-82.63431433099993,
							27.723004840000044
						],
						[
							-82.63450514399995,
							27.722602234000078
						],
						[
							-82.63451664699994,
							27.722577903000058
						],
						[
							-82.63535886999995,
							27.722900549000087
						],
						[
							-82.6357217929999,
							27.722954315000038
						],
						[
							-82.63635773499993,
							27.722900166000045
						],
						[
							-82.63651696999995,
							27.72285558300007
						],
						[
							-82.63664999999992,
							27.722830000000044
						],
						[
							-82.63678392199995,
							27.72280709200004
						],
						[
							-82.63688289499993,
							27.72279016300007
						],
						[
							-82.6370842259999,
							27.72275572400008
						],
						[
							-82.63733191799992,
							27.722713356000042
						],
						[
							-82.63747060899993,
							27.722689898000056
						],
						[
							-82.6375530759999,
							27.722671124000044
						],
						[
							-82.63770860699992,
							27.72260731700004
						],
						[
							-82.63792275299994,
							27.72250738200006
						],
						[
							-82.63811341199994,
							27.722396857000035
						],
						[
							-82.63823999999994,
							27.72232000000008
						],
						[
							-82.6382425249999,
							27.72250684700009
						],
						[
							-82.63824415399995,
							27.72262739000007
						],
						[
							-82.63824741699995,
							27.722868884000036
						],
						[
							-82.63824999999991,
							27.72306000000009
						],
						[
							-82.63824817799991,
							27.723260389000075
						],
						[
							-82.6382465339999,
							27.723441222000076
						],
						[
							-82.63824447799993,
							27.723667401000057
						],
						[
							-82.63824091599992,
							27.72405920700004
						],
						[
							-82.63824218499991,
							27.72433040800007
						],
						[
							-82.63824604799993,
							27.724631772000066
						],
						[
							-82.63824999999991,
							27.72509906100004
						],
						[
							-82.63824999999991,
							27.725596394000036
						],
						[
							-82.63824999999991,
							27.726425282000037
						],
						[
							-82.63825638899993,
							27.72699790100006
						],
						[
							-82.6382605519999,
							27.72717900000004
						],
						[
							-82.63826713099992,
							27.727465192000068
						],
						[
							-82.63826999999992,
							27.727590000000077
						],
						[
							-82.63899193099991,
							27.727590000000077
						],
						[
							-82.63959475899992,
							27.727590000000077
						],
						[
							-82.64016744499992,
							27.727590000000077
						],
						[
							-82.64048392899991,
							27.727590000000077
						],
						[
							-82.64063463599992,
							27.727590000000077
						],
						[
							-82.64069801799991,
							27.727590000000077
						],
						[
							-82.64070306199994,
							27.727844128000072
						],
						[
							-82.64070649799993,
							27.72812931800007
						],
						[
							-82.6407099999999,
							27.728944184000056
						],
						[
							-82.64072815399993,
							27.729819863000046
						],
						[
							-82.64073917999991,
							27.730388650000066
						],
						[
							-82.64074592899995,
							27.730736861000082
						],
						[
							-82.6407574189999,
							27.731408996000084
						],
						[
							-82.64076999999992,
							27.73169000000007
						],
						[
							-82.64078923999995,
							27.732040175000066
						],
						[
							-82.64081397799993,
							27.73249039500007
						],
						[
							-82.6408199999999,
							27.732600000000048
						],
						[
							-82.64082425799995,
							27.73295769500004
						],
						[
							-82.64082959599995,
							27.733406096000067
						],
						[
							-82.64082999999994,
							27.733813498000075
						],
						[
							-82.64082999999994,
							27.73432284100005
						],
						[
							-82.64082999999994,
							27.734730315000036
						],
						[
							-82.64083533899992,
							27.73554526500004
						],
						[
							-82.6404389999999,
							27.735545264000052
						],
						[
							-82.63996463599995,
							27.735466870000042
						],
						[
							-82.63961869199994,
							27.73517858300005
						],
						[
							-82.63930157599992,
							27.734861468000076
						],
						[
							-82.63892680299995,
							27.734976783000036
						],
						[
							-82.63843671599994,
							27.735466870000042
						],
						[
							-82.63791779999991,
							27.735553356000082
						],
						[
							-82.6375632999999,
							27.735391246000063
						],
						[
							-82.63719068499995,
							27.73505411800005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Bonita Bayou",
				"RegionID": "416187"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.64507999999995,
					27.72679000000005,
					-82.64069801799991,
					27.730390000000057
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.64072815399993,
							27.729819863000046
						],
						[
							-82.6407099999999,
							27.728944184000056
						],
						[
							-82.64070649799993,
							27.72812931800007
						],
						[
							-82.64070306199994,
							27.727844128000072
						],
						[
							-82.64069801799991,
							27.727590000000077
						],
						[
							-82.64069999999992,
							27.727590000000077
						],
						[
							-82.64083007799991,
							27.727553867000044
						],
						[
							-82.64096616299992,
							27.727538664000065
						],
						[
							-82.64126750399993,
							27.72753399200008
						],
						[
							-82.64155401199992,
							27.727529550000042
						],
						[
							-82.6417950849999,
							27.727525813000057
						],
						[
							-82.6419909569999,
							27.727522776000058
						],
						[
							-82.64216999999991,
							27.727520000000084
						],
						[
							-82.64233752199993,
							27.72750883200007
						],
						[
							-82.64256158199993,
							27.727493895000066
						],
						[
							-82.64274519499992,
							27.727469134000046
						],
						[
							-82.64295536999992,
							27.727434105000047
						],
						[
							-82.64314538399992,
							27.72739470800008
						],
						[
							-82.64328731299992,
							27.72736064500009
						],
						[
							-82.64343666999991,
							27.727311110000073
						],
						[
							-82.6435721549999,
							27.72726554700006
						],
						[
							-82.64370739499992,
							27.727219179000087
						],
						[
							-82.6438245249999,
							27.72717902000005
						],
						[
							-82.64392782899995,
							27.727134827000043
						],
						[
							-82.64402969499992,
							27.727081213000076
						],
						[
							-82.64411913799995,
							27.72703413800008
						],
						[
							-82.64417876699991,
							27.72700275400007
						],
						[
							-82.64425999999992,
							27.726960000000076
						],
						[
							-82.6444130189999,
							27.72686998900008
						],
						[
							-82.64454905699995,
							27.726820314000065
						],
						[
							-82.64467322599995,
							27.72679903200009
						],
						[
							-82.64486949999991,
							27.72679000000005
						],
						[
							-82.64497519299994,
							27.726800865000087
						],
						[
							-82.64507999999995,
							27.726830000000064
						],
						[
							-82.64504350999994,
							27.72689385700005
						],
						[
							-82.64501999999993,
							27.726950000000045
						],
						[
							-82.64495719799993,
							27.727086071000087
						],
						[
							-82.6448679259999,
							27.727279494000072
						],
						[
							-82.64479364699991,
							27.727465540000082
						],
						[
							-82.64467587799993,
							27.727784498000062
						],
						[
							-82.64459916599992,
							27.72799302100009
						],
						[
							-82.64454185199992,
							27.72820078700005
						],
						[
							-82.64450958599991,
							27.728347688000042
						],
						[
							-82.64449999999994,
							27.728410000000054
						],
						[
							-82.64449790299994,
							27.728439363000064
						],
						[
							-82.6444941279999,
							27.72849221100006
						],
						[
							-82.6444899999999,
							27.72855000000004
						],
						[
							-82.6444899999999,
							27.728602484000078
						],
						[
							-82.6444899999999,
							27.72864896200008
						],
						[
							-82.64449659399993,
							27.728766048000068
						],
						[
							-82.64450738099993,
							27.728857736000066
						],
						[
							-82.64453147699994,
							27.728951591000055
						],
						[
							-82.64454938599994,
							27.729011288000038
						],
						[
							-82.64391156099992,
							27.729055648000042
						],
						[
							-82.64385346299991,
							27.728933642000076
						],
						[
							-82.64368497899994,
							27.728997550000088
						],
						[
							-82.6431214289999,
							27.72919508300004
						],
						[
							-82.64274379299991,
							27.72933451700004
						],
						[
							-82.64248235199994,
							27.729578529000037
						],
						[
							-82.64206641899995,
							27.72962418900005
						],
						[
							-82.6420784259999,
							27.729688087000056
						],
						[
							-82.64209999999991,
							27.729760000000056
						],
						[
							-82.64204089999993,
							27.729756889000043
						],
						[
							-82.6419768639999,
							27.72975351900004
						],
						[
							-82.64190999999994,
							27.72975000000008
						],
						[
							-82.64189392399993,
							27.729775008000047
						],
						[
							-82.64185900199993,
							27.729829330000086
						],
						[
							-82.64183370699993,
							27.72986867700007
						],
						[
							-82.6418000349999,
							27.72991329200005
						],
						[
							-82.6417311379999,
							27.72999367300008
						],
						[
							-82.64168073999991,
							27.730049260000044
						],
						[
							-82.64163135599995,
							27.730098644000066
						],
						[
							-82.64157570899994,
							27.73014163600004
						],
						[
							-82.64152954499991,
							27.730174611000052
						],
						[
							-82.64146546899991,
							27.730217266000068
						],
						[
							-82.64141999999993,
							27.730240000000038
						],
						[
							-82.64139850499993,
							27.73025289700007
						],
						[
							-82.64135492499992,
							27.730274638000083
						],
						[
							-82.64129736099994,
							27.73029235000007
						],
						[
							-82.64121568899992,
							27.730315835000056
						],
						[
							-82.64107461899994,
							27.73034969100007
						],
						[
							-82.64097648599994,
							27.730371802000036
						],
						[
							-82.64086155899992,
							27.73038712600004
						],
						[
							-82.64077427399991,
							27.730390000000057
						],
						[
							-82.64073917999991,
							27.730388650000066
						],
						[
							-82.64072815399993,
							27.729819863000046
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Lake Maggiore Park",
				"RegionID": "416188"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.6478713219999,
					27.728933642000076,
					-82.6372006549999,
					27.74126343900008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.6378802449999,
							27.74126343900008
						],
						[
							-82.6372006549999,
							27.740673701000052
						],
						[
							-82.63754899499992,
							27.740244930000074
						],
						[
							-82.63760432599992,
							27.74018291400006
						],
						[
							-82.63883586199997,
							27.73892477600009
						],
						[
							-82.63931001899994,
							27.73837981300005
						],
						[
							-82.63934641999992,
							27.738284711000066
						],
						[
							-82.63939067799993,
							27.738115401000073
						],
						[
							-82.63939067799993,
							27.73799558500008
						],
						[
							-82.63938554999993,
							27.737912066000035
						],
						[
							-82.63937829399993,
							27.737890202000074
						],
						[
							-82.63931908099994,
							27.737792373000048
						],
						[
							-82.6384960609999,
							27.73672700900005
						],
						[
							-82.63846368499992,
							27.736688597000068
						],
						[
							-82.63822791899992,
							27.73640548900005
						],
						[
							-82.63818628699994,
							27.736354278000082
						],
						[
							-82.63814924199994,
							27.736299656000085
						],
						[
							-82.63811706299992,
							27.736242034000043
						],
						[
							-82.63808998999991,
							27.736181843000054
						],
						[
							-82.63806822799995,
							27.736119535000057
						],
						[
							-82.63805193899992,
							27.736055578000048
						],
						[
							-82.6380319999999,
							27.73605732200008
						],
						[
							-82.6379123559999,
							27.73604871200007
						],
						[
							-82.63791779999991,
							27.735553356000082
						],
						[
							-82.63843671599994,
							27.735466870000042
						],
						[
							-82.63892680299995,
							27.734976783000036
						],
						[
							-82.63930157599992,
							27.734861468000076
						],
						[
							-82.63961869199994,
							27.73517858300005
						],
						[
							-82.63996463599995,
							27.735466870000042
						],
						[
							-82.6404389999999,
							27.735545264000052
						],
						[
							-82.64083533899992,
							27.73554526500004
						],
						[
							-82.64082999999994,
							27.734730315000036
						],
						[
							-82.64082999999994,
							27.73432284100005
						],
						[
							-82.64082999999994,
							27.733813498000075
						],
						[
							-82.64082959599995,
							27.733406096000067
						],
						[
							-82.64082425799995,
							27.73295769500004
						],
						[
							-82.6408199999999,
							27.732600000000048
						],
						[
							-82.64081397799993,
							27.73249039500007
						],
						[
							-82.64078923999995,
							27.732040175000066
						],
						[
							-82.64076999999992,
							27.73169000000007
						],
						[
							-82.6407574189999,
							27.731408996000084
						],
						[
							-82.64074592899995,
							27.730736861000082
						],
						[
							-82.64073917999991,
							27.730388650000066
						],
						[
							-82.64077427399991,
							27.730390000000057
						],
						[
							-82.64086155899992,
							27.73038712600004
						],
						[
							-82.64097648599994,
							27.730371802000036
						],
						[
							-82.64107461899994,
							27.73034969100007
						],
						[
							-82.64121568899992,
							27.730315835000056
						],
						[
							-82.64129736099994,
							27.73029235000007
						],
						[
							-82.64135492499992,
							27.730274638000083
						],
						[
							-82.64139850499993,
							27.73025289700007
						],
						[
							-82.64141999999993,
							27.730240000000038
						],
						[
							-82.64146546899991,
							27.730217266000068
						],
						[
							-82.64152954499991,
							27.730174611000052
						],
						[
							-82.64157570899994,
							27.73014163600004
						],
						[
							-82.64163135599995,
							27.730098644000066
						],
						[
							-82.64168073999991,
							27.730049260000044
						],
						[
							-82.6417311379999,
							27.72999367300008
						],
						[
							-82.6418000349999,
							27.72991329200005
						],
						[
							-82.64183370699993,
							27.72986867700007
						],
						[
							-82.64185900199993,
							27.729829330000086
						],
						[
							-82.64189392399993,
							27.729775008000047
						],
						[
							-82.64190999999994,
							27.72975000000008
						],
						[
							-82.6419768639999,
							27.72975351900004
						],
						[
							-82.64204089999993,
							27.729756889000043
						],
						[
							-82.64209999999991,
							27.729760000000056
						],
						[
							-82.6420784259999,
							27.729688087000056
						],
						[
							-82.64206641899995,
							27.72962418900005
						],
						[
							-82.64248235199994,
							27.729578529000037
						],
						[
							-82.64274379299991,
							27.72933451700004
						],
						[
							-82.6431214289999,
							27.72919508300004
						],
						[
							-82.64368497899994,
							27.728997550000088
						],
						[
							-82.64385346299991,
							27.728933642000076
						],
						[
							-82.64391156099992,
							27.729055648000042
						],
						[
							-82.64454938599994,
							27.729011288000038
						],
						[
							-82.6445759099999,
							27.729099701000052
						],
						[
							-82.64463999999992,
							27.72929000000005
						],
						[
							-82.64469665799993,
							27.72941361800008
						],
						[
							-82.64483813399994,
							27.729662201000053
						],
						[
							-82.64493912299992,
							27.729799745000037
						],
						[
							-82.6450747099999,
							27.72996464700009
						],
						[
							-82.64517692099992,
							27.730088959000057
						],
						[
							-82.64525999999995,
							27.73019000000005
						],
						[
							-82.64543343799994,
							27.73039082300005
						],
						[
							-82.6455672219999,
							27.730545731000063
						],
						[
							-82.6456399999999,
							27.730630000000076
						],
						[
							-82.64580186799992,
							27.730821005000053
						],
						[
							-82.64599488599993,
							27.73104876600007
						],
						[
							-82.6460907099999,
							27.73116183700006
						],
						[
							-82.64620784499994,
							27.73131476800006
						],
						[
							-82.64630139699995,
							27.73149086500007
						],
						[
							-82.64637506999992,
							27.731634197000062
						],
						[
							-82.64641999999992,
							27.731760000000065
						],
						[
							-82.64645211999994,
							27.73193112900009
						],
						[
							-82.6464748489999,
							27.73205045700007
						],
						[
							-82.64650264399995,
							27.732214292000037
						],
						[
							-82.64652904299993,
							27.732390286000054
						],
						[
							-82.64655203799992,
							27.73262376000008
						],
						[
							-82.64655560599994,
							27.732787890000054
						],
						[
							-82.64656531199995,
							27.733234345000085
						],
						[
							-82.64657587999994,
							27.733726343000058
						],
						[
							-82.64657999999991,
							27.734418980000044
						],
						[
							-82.64657999999991,
							27.734874560000037
						],
						[
							-82.64657999999991,
							27.735220800000036
						],
						[
							-82.64658474499993,
							27.73549421000007
						],
						[
							-82.64659371599993,
							27.73578578600007
						],
						[
							-82.64659999999992,
							27.736104625000053
						],
						[
							-82.64659999999992,
							27.73633241500005
						],
						[
							-82.64684499999993,
							27.736397000000068
						],
						[
							-82.64705924299994,
							27.736569366000086
						],
						[
							-82.64746316599991,
							27.73697328900005
						],
						[
							-82.64763506899993,
							27.737086985000076
						],
						[
							-82.64761520999991,
							27.737325732000045
						],
						[
							-82.6476045089999,
							27.737514530000055
						],
						[
							-82.64762834699991,
							27.738026141000034
						],
						[
							-82.64762932199994,
							27.738068000000055
						],
						[
							-82.64762905999993,
							27.738089701000035
						],
						[
							-82.6476175599999,
							27.738566158000083
						],
						[
							-82.64763186499994,
							27.73859884500007
						],
						[
							-82.64764544899992,
							27.738633669000084
						],
						[
							-82.64778244899992,
							27.739007669000046
						],
						[
							-82.64778959499995,
							27.739027922000048
						],
						[
							-82.64780667799994,
							27.73908423800009
						],
						[
							-82.64782004199992,
							27.739141551000046
						],
						[
							-82.64782937099994,
							27.739197680000075
						],
						[
							-82.64786337199992,
							27.73945168000006
						],
						[
							-82.64786362899991,
							27.73945361500006
						],
						[
							-82.64786939699991,
							27.739512181000066
						],
						[
							-82.6478713219999,
							27.73957100000007
						],
						[
							-82.64787034199992,
							27.739612980000064
						],
						[
							-82.64786034199994,
							27.73982698000009
						],
						[
							-82.64785939599994,
							27.739843818000054
						],
						[
							-82.64785362799995,
							27.739902385000054
						],
						[
							-82.64785002699995,
							27.739927083000055
						],
						[
							-82.64781698699994,
							27.74013358500008
						],
						[
							-82.6478130509999,
							27.740167076000034
						],
						[
							-82.64701790399995,
							27.74083587100006
						],
						[
							-82.64659999999992,
							27.741170000000068
						],
						[
							-82.64651414199994,
							27.74117168500004
						],
						[
							-82.6463641819999,
							27.741174628000067
						],
						[
							-82.6460357759999,
							27.741184383000075
						],
						[
							-82.64582049699993,
							27.741190777000043
						],
						[
							-82.64565046899992,
							27.74119582800006
						],
						[
							-82.64511847799992,
							27.74120000000005
						],
						[
							-82.64415609899993,
							27.74120174300009
						],
						[
							-82.64366923199992,
							27.741204142000072
						],
						[
							-82.6433181239999,
							27.74120587100009
						],
						[
							-82.64271803199995,
							27.741208827000037
						],
						[
							-82.6422085719999,
							27.741215322000073
						],
						[
							-82.6418803389999,
							27.741221758000055
						],
						[
							-82.64139323699993,
							27.741225231000048
						],
						[
							-82.6412914579999,
							27.74121286400009
						],
						[
							-82.64116357699993,
							27.74118089400008
						],
						[
							-82.64106192899993,
							27.741151968000054
						],
						[
							-82.64098999999993,
							27.741120000000084
						],
						[
							-82.64089302799994,
							27.741069950000053
						],
						[
							-82.6407851589999,
							27.741014276000044
						],
						[
							-82.64067999999992,
							27.740960000000086
						],
						[
							-82.6400999999999,
							27.741260000000068
						],
						[
							-82.63992999999994,
							27.741235000000074
						],
						[
							-82.6397199999999,
							27.741230000000087
						],
						[
							-82.63958999999994,
							27.741230000000087
						],
						[
							-82.63917499999991,
							27.741230000000087
						],
						[
							-82.6387299999999,
							27.74124000000006
						],
						[
							-82.63869999999991,
							27.741250000000036
						],
						[
							-82.63839499999995,
							27.74125500000008
						],
						[
							-82.6378802449999,
							27.74126343900008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Lakewood Terrace",
				"RegionID": "416189"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.6751999999999,
					27.71916843200006,
					-82.6464191789999,
					27.738889829000072
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.66642463399995,
							27.737043132000053
						],
						[
							-82.66597386899991,
							27.73668726500006
						],
						[
							-82.66559771399994,
							27.736390301000085
						],
						[
							-82.6653510889999,
							27.736195597000062
						],
						[
							-82.66524124799992,
							27.736108880000074
						],
						[
							-82.66513869599993,
							27.735923479000064
						],
						[
							-82.66495809799994,
							27.73569918000004
						],
						[
							-82.66472238699993,
							27.735494169000052
						],
						[
							-82.66441290199992,
							27.73531673000008
						],
						[
							-82.6639526649999,
							27.735057965000067
						],
						[
							-82.66348347299993,
							27.734839548000082
						],
						[
							-82.66323158799992,
							27.73467466200009
						],
						[
							-82.66292990599993,
							27.73445796100009
						],
						[
							-82.66271849099991,
							27.734306099000037
						],
						[
							-82.66232327599995,
							27.73402221200007
						],
						[
							-82.6618827819999,
							27.733691152000063
						],
						[
							-82.66160735599993,
							27.73345889000007
						],
						[
							-82.66120411399993,
							27.73311884200007
						],
						[
							-82.66091293799991,
							27.732873298000072
						],
						[
							-82.66065999999995,
							27.73266000000007
						],
						[
							-82.6604099999999,
							27.732300000000066
						],
						[
							-82.66004337999995,
							27.73195005300005
						],
						[
							-82.65969820799995,
							27.731560886000068
						],
						[
							-82.6594569639999,
							27.73128878500006
						],
						[
							-82.65926331499992,
							27.731070367000086
						],
						[
							-82.65912999999996,
							27.730920000000083
						],
						[
							-82.65884528999993,
							27.73056321200005
						],
						[
							-82.65857442499993,
							27.73022377300009
						],
						[
							-82.65833628299993,
							27.729924649000054
						],
						[
							-82.65800760799993,
							27.72945155700006
						],
						[
							-82.65763687399993,
							27.728921742000068
						],
						[
							-82.6573403349999,
							27.728521155000067
						],
						[
							-82.6570924749999,
							27.728187696000077
						],
						[
							-82.65673511999995,
							27.72777809200005
						],
						[
							-82.6563635899999,
							27.727383590000045
						],
						[
							-82.65604234199992,
							27.727065689000085
						],
						[
							-82.65560591699995,
							27.726669358000038
						],
						[
							-82.65526113699991,
							27.726380884000037
						],
						[
							-82.65493367199991,
							27.726126189000073
						],
						[
							-82.65459075299992,
							27.725870802000088
						],
						[
							-82.65415991399993,
							27.725573462000057
						],
						[
							-82.65365486199994,
							27.72526014600004
						],
						[
							-82.65317988599992,
							27.72499134900005
						],
						[
							-82.65282482299995,
							27.724806316000073
						],
						[
							-82.6523858079999,
							27.724605333000056
						],
						[
							-82.6520806989999,
							27.72450490500006
						],
						[
							-82.6517952829999,
							27.724432254000078
						],
						[
							-82.65156908199992,
							27.724376653000036
						],
						[
							-82.65133999999995,
							27.72434000000004
						],
						[
							-82.65089646199993,
							27.724274929000046
						],
						[
							-82.65044845699992,
							27.724257916000056
						],
						[
							-82.65000395499993,
							27.72427034900005
						],
						[
							-82.64946668899995,
							27.724331348000078
						],
						[
							-82.64898320599993,
							27.72442817700005
						],
						[
							-82.64853237199992,
							27.72454065000005
						],
						[
							-82.64804669499995,
							27.724682174000066
						],
						[
							-82.64756465199991,
							27.724871057000087
						],
						[
							-82.64726728499994,
							27.72501377900005
						],
						[
							-82.64668999999992,
							27.725230000000067
						],
						[
							-82.64651926199991,
							27.725236204000055
						],
						[
							-82.64642241799993,
							27.725223552000045
						],
						[
							-82.64644902299995,
							27.725152605000062
						],
						[
							-82.64645999999993,
							27.725008637000087
						],
						[
							-82.64645999999993,
							27.724631870000053
						],
						[
							-82.64645531199994,
							27.724452643000063
						],
						[
							-82.64644615599991,
							27.724301578000052
						],
						[
							-82.6464401739999,
							27.724179778000064
						],
						[
							-82.6464432919999,
							27.723818108000046
						],
						[
							-82.64644485099991,
							27.723637273000065
						],
						[
							-82.64644641099994,
							27.72345630800004
						],
						[
							-82.64644900899992,
							27.723154917000045
						],
						[
							-82.64644844999992,
							27.722898944000065
						],
						[
							-82.6464453019999,
							27.72261247000006
						],
						[
							-82.64644298199994,
							27.72240134000009
						],
						[
							-82.64643852699993,
							27.72199448100008
						],
						[
							-82.64643295799993,
							27.721482138000056
						],
						[
							-82.64642747199991,
							27.720985037000048
						],
						[
							-82.64642527099994,
							27.720789143000047
						],
						[
							-82.6464239149999,
							27.720668424000053
						],
						[
							-82.6464213729999,
							27.720442222000088
						],
						[
							-82.64641999999992,
							27.720095592000064
						],
						[
							-82.64641999999992,
							27.71971882500009
						],
						[
							-82.6464191789999,
							27.719429992000073
						],
						[
							-82.64641999999992,
							27.719430000000045
						],
						[
							-82.64653412799993,
							27.719376740000087
						],
						[
							-82.64676206699994,
							27.719355635000056
						],
						[
							-82.64711185899995,
							27.71934768500006
						],
						[
							-82.64744999999994,
							27.719340000000045
						],
						[
							-82.64824873299995,
							27.719323531000043
						],
						[
							-82.65004246699993,
							27.71932000000004
						],
						[
							-82.6504799999999,
							27.71932000000004
						],
						[
							-82.65122362499994,
							27.71932000000004
						],
						[
							-82.65194544299993,
							27.71932000000004
						],
						[
							-82.6522599999999,
							27.71932000000004
						],
						[
							-82.65238269899993,
							27.719317809000074
						],
						[
							-82.6525580199999,
							27.719314678000046
						],
						[
							-82.6528199999999,
							27.719310000000064
						],
						[
							-82.65330158699993,
							27.719310000000064
						],
						[
							-82.65378279899994,
							27.719310000000064
						],
						[
							-82.65403999999995,
							27.719310000000064
						],
						[
							-82.65435146099992,
							27.719304976000046
						],
						[
							-82.65465999999992,
							27.719300000000093
						],
						[
							-82.65551078899995,
							27.719300000000093
						],
						[
							-82.65599166099992,
							27.719291544000043
						],
						[
							-82.6565825799999,
							27.719280000000083
						],
						[
							-82.65741376499994,
							27.719280000000083
						],
						[
							-82.65776359599994,
							27.719276364000052
						],
						[
							-82.65800447499993,
							27.719272769000042
						],
						[
							-82.65868241499993,
							27.71927000000005
						],
						[
							-82.65922924699993,
							27.71927000000005
						],
						[
							-82.6601478099999,
							27.719255093000072
						],
						[
							-82.66065081099993,
							27.719248561000086
						],
						[
							-82.66113222599996,
							27.71924230900004
						],
						[
							-82.66165710799993,
							27.719235868000055
						],
						[
							-82.6621385119999,
							27.719230137000068
						],
						[
							-82.6634508329999,
							27.719225803000086
						],
						[
							-82.66500379299993,
							27.71921973500008
						],
						[
							-82.66670988699991,
							27.719213598000067
						],
						[
							-82.66806587699995,
							27.71920566000006
						],
						[
							-82.66839419399992,
							27.719201656000052
						],
						[
							-82.66907222599991,
							27.719200000000058
						],
						[
							-82.67023150999995,
							27.719200000000058
						],
						[
							-82.67080015699992,
							27.719193535000045
						],
						[
							-82.67156568599995,
							27.719186284000045
						],
						[
							-82.67193767999993,
							27.719183377000036
						],
						[
							-82.6729874209999,
							27.719176531000073
						],
						[
							-82.67381870299994,
							27.719171861000063
						],
						[
							-82.67486864599994,
							27.719170000000076
						],
						[
							-82.67515882399994,
							27.71916843200006
						],
						[
							-82.67515849299991,
							27.72022562500007
						],
						[
							-82.67516999999992,
							27.72083297800009
						],
						[
							-82.67516999999992,
							27.72112000000004
						],
						[
							-82.67517197799992,
							27.72128020300005
						],
						[
							-82.67517632199991,
							27.721632102000058
						],
						[
							-82.6751799999999,
							27.721930000000043
						],
						[
							-82.6751799999999,
							27.72265468800009
						],
						[
							-82.6751799999999,
							27.722910000000073
						],
						[
							-82.6751799999999,
							27.723805241000036
						],
						[
							-82.67518999999993,
							27.725307353000062
						],
						[
							-82.67518999999993,
							27.72558976600004
						],
						[
							-82.67518999999993,
							27.725590000000068
						],
						[
							-82.67518999999993,
							27.72597851000006
						],
						[
							-82.67518999999993,
							27.72649000000007
						],
						[
							-82.67518999999993,
							27.726745546000075
						],
						[
							-82.67518999999993,
							27.726920000000067
						],
						[
							-82.67518999999993,
							27.72715000000005
						],
						[
							-82.67518999999993,
							27.72773630000006
						],
						[
							-82.67518999999993,
							27.72837549700006
						],
						[
							-82.67518999999993,
							27.728700000000064
						],
						[
							-82.67518999999993,
							27.72952605100005
						],
						[
							-82.67518999999993,
							27.731156002000034
						],
						[
							-82.67518999999993,
							27.73216000000008
						],
						[
							-82.67518999999993,
							27.73243439500004
						],
						[
							-82.67518999999993,
							27.732800000000054
						],
						[
							-82.67518999999993,
							27.73358494900009
						],
						[
							-82.67518999999993,
							27.73377000000005
						],
						[
							-82.67518999999993,
							27.734128266000084
						],
						[
							-82.67518999999993,
							27.734440000000063
						],
						[
							-82.67518999999993,
							27.73467158300008
						],
						[
							-82.67518999999993,
							27.73502314100006
						],
						[
							-82.67518999999993,
							27.735400000000084
						],
						[
							-82.67518999999993,
							27.73579017700007
						],
						[
							-82.67518999999993,
							27.736300000000085
						],
						[
							-82.6751944589999,
							27.73662102500009
						],
						[
							-82.6751999999999,
							27.73702000000009
						],
						[
							-82.67473933799994,
							27.73702000000009
						],
						[
							-82.67394034199992,
							27.73702000000009
						],
						[
							-82.67323547099996,
							27.737018105000065
						],
						[
							-82.67301798999995,
							27.736989409000046
						],
						[
							-82.67289167699994,
							27.736952258000088
						],
						[
							-82.67279999999994,
							27.736880000000045
						],
						[
							-82.67260747599994,
							27.73713878700005
						],
						[
							-82.6724833529999,
							27.737349942000037
						],
						[
							-82.67237977299993,
							27.73759650100004
						],
						[
							-82.6722244149999,
							27.73784263300007
						],
						[
							-82.6720037469999,
							27.73803783900007
						],
						[
							-82.67170946399995,
							27.738293006000053
						],
						[
							-82.67144030199995,
							27.738463475000064
						],
						[
							-82.67116081299991,
							27.738604593000048
						],
						[
							-82.67111941399992,
							27.73862529300004
						],
						[
							-82.67098183799993,
							27.738694081000062
						],
						[
							-82.67061739899994,
							27.73883014000006
						],
						[
							-82.6703607369999,
							27.738889829000072
						],
						[
							-82.67007335099993,
							27.73888363000009
						],
						[
							-82.66972224299991,
							27.738854003000085
						],
						[
							-82.66936861399995,
							27.738805039000056
						],
						[
							-82.66905937299993,
							27.738708586000087
						],
						[
							-82.66874042099994,
							27.73857915600007
						],
						[
							-82.66838391699991,
							27.73840291500005
						],
						[
							-82.6679648949999,
							27.738161779000052
						],
						[
							-82.66766229199993,
							27.737987640000085
						],
						[
							-82.66750999999994,
							27.73790000000008
						],
						[
							-82.66724326399992,
							27.73768941900005
						],
						[
							-82.66676141199991,
							27.737309009000057
						],
						[
							-82.66642463399995,
							27.737043132000053
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Lakewood",
				"RegionID": "416190"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.69993999999991,
					27.76640000000009,
					-82.67945999999995,
					27.78455000000008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.68677030899994,
							27.784528392000084
						],
						[
							-82.68624999999992,
							27.784520000000043
						],
						[
							-82.68558436699993,
							27.784520000000043
						],
						[
							-82.68488999999994,
							27.784520000000043
						],
						[
							-82.68405131599991,
							27.784526122000045
						],
						[
							-82.68351999999993,
							27.784530000000075
						],
						[
							-82.6828364889999,
							27.784530000000075
						],
						[
							-82.68225798799995,
							27.784530000000075
						],
						[
							-82.68148999999995,
							27.784530000000075
						],
						[
							-82.68078283299991,
							27.78453359000008
						],
						[
							-82.67951999999991,
							27.78454000000005
						],
						[
							-82.67951999999991,
							27.78383516100007
						],
						[
							-82.67951235699991,
							27.782967385000063
						],
						[
							-82.67950999999994,
							27.782070734000058
						],
						[
							-82.67950349499995,
							27.78123197800005
						],
						[
							-82.6794999469999,
							27.780904122000038
						],
						[
							-82.67949629799995,
							27.780566786000065
						],
						[
							-82.67949211699994,
							27.78019048600004
						],
						[
							-82.67948582899993,
							27.779612056000076
						],
						[
							-82.6794827189999,
							27.779322840000077
						],
						[
							-82.6794799999999,
							27.77874435500007
						],
						[
							-82.6794799999999,
							27.778310480000073
						],
						[
							-82.6794799999999,
							27.777645204000066
						],
						[
							-82.6794799999999,
							27.77697992800006
						],
						[
							-82.6794799999999,
							27.776748528000045
						],
						[
							-82.6794799999999,
							27.776410000000055
						],
						[
							-82.67947396099993,
							27.776141265000035
						],
						[
							-82.6794680989999,
							27.775880421000068
						],
						[
							-82.67945999999995,
							27.775520000000085
						],
						[
							-82.67945999999995,
							27.775244426000086
						],
						[
							-82.67945999999995,
							27.774926251000068
						],
						[
							-82.67945999999995,
							27.774610000000052
						],
						[
							-82.67945999999995,
							27.77417420000006
						],
						[
							-82.67945999999995,
							27.77371000000005
						],
						[
							-82.67945999999995,
							27.773451074000036
						],
						[
							-82.67945999999995,
							27.773103974000037
						],
						[
							-82.67945999999995,
							27.772790000000043
						],
						[
							-82.6794627829999,
							27.77252558400005
						],
						[
							-82.67946461299994,
							27.772351748000062
						],
						[
							-82.67946857099992,
							27.771975765000036
						],
						[
							-82.67946999499992,
							27.771840500000053
						],
						[
							-82.67946999999992,
							27.771840000000054
						],
						[
							-82.67947148299993,
							27.771715457000084
						],
						[
							-82.67947802399993,
							27.771165959000086
						],
						[
							-82.67946999999992,
							27.770950000000084
						],
						[
							-82.67947753899995,
							27.770703239000056
						],
						[
							-82.67947340699993,
							27.77035618800005
						],
						[
							-82.67946999999992,
							27.77007000000009
						],
						[
							-82.67946999999992,
							27.769869081000085
						],
						[
							-82.67946999999992,
							27.769583597000064
						],
						[
							-82.67946999999992,
							27.769321904000037
						],
						[
							-82.67946999999992,
							27.769234672000042
						],
						[
							-82.67946999999992,
							27.76886988700005
						],
						[
							-82.67946999999992,
							27.768663704000062
						],
						[
							-82.67946999999992,
							27.768465452000044
						],
						[
							-82.67946999999992,
							27.768298919000074
						],
						[
							-82.67946999999992,
							27.768068946000085
						],
						[
							-82.67946999999992,
							27.76776760200005
						],
						[
							-82.67946999999992,
							27.76737902600007
						],
						[
							-82.67946999999992,
							27.767228354000054
						],
						[
							-82.67946999999992,
							27.766792198000076
						],
						[
							-82.67946999999992,
							27.766421708000053
						],
						[
							-82.67946999999992,
							27.76642000000004
						],
						[
							-82.68000993599992,
							27.76642000000004
						],
						[
							-82.68040122999992,
							27.76642000000004
						],
						[
							-82.68109975499993,
							27.76641515500006
						],
						[
							-82.6815193249999,
							27.766408798000047
						],
						[
							-82.68235769699994,
							27.76640000000009
						],
						[
							-82.68294463699993,
							27.76640000000009
						],
						[
							-82.6839507649999,
							27.76641184600004
						],
						[
							-82.68448179099994,
							27.76641464100004
						],
						[
							-82.6849570679999,
							27.76641714200008
						],
						[
							-82.68526450399992,
							27.766418761000068
						],
						[
							-82.68571149099996,
							27.76641732300004
						],
						[
							-82.68615896499995,
							27.766411659000084
						],
						[
							-82.68666180399993,
							27.766413645000057
						],
						[
							-82.68696949399994,
							27.76641666200004
						],
						[
							-82.68764012199995,
							27.76643176600004
						],
						[
							-82.6880592739999,
							27.76643793100004
						],
						[
							-82.68836706299993,
							27.76644245700004
						],
						[
							-82.68861855499995,
							27.76644615500004
						],
						[
							-82.68928918199992,
							27.766450000000077
						],
						[
							-82.68995997099995,
							27.766450000000077
						],
						[
							-82.69043511299994,
							27.766450000000077
						],
						[
							-82.69127359899994,
							27.766450000000077
						],
						[
							-82.69194438699992,
							27.766450000000077
						],
						[
							-82.69267107499991,
							27.766450000000077
						],
						[
							-82.69334179399993,
							27.766447634000087
						],
						[
							-82.69381711599993,
							27.766444139000043
						],
						[
							-82.69406864799993,
							27.766442289000054
						],
						[
							-82.69471139099994,
							27.766440000000046
						],
						[
							-82.69532628099996,
							27.766440000000046
						],
						[
							-82.69588534299993,
							27.766439012000035
						],
						[
							-82.6967237849999,
							27.76643289200007
						],
						[
							-82.6973665889999,
							27.766428173000065
						],
						[
							-82.69806528899994,
							27.766422998000056
						],
						[
							-82.69876407399994,
							27.76642000000004
						],
						[
							-82.6996025599999,
							27.76642000000004
						],
						[
							-82.69979999999993,
							27.76642000000004
						],
						[
							-82.69980355899992,
							27.766740277000054
						],
						[
							-82.69980613299992,
							27.766971970000043
						],
						[
							-82.6998099999999,
							27.76732000000004
						],
						[
							-82.6998159659999,
							27.76786885200005
						],
						[
							-82.69981999999993,
							27.76824000000005
						],
						[
							-82.69981999999993,
							27.76862059300004
						],
						[
							-82.69981999999993,
							27.769160000000056
						],
						[
							-82.69982268299992,
							27.769401489000074
						],
						[
							-82.6998265389999,
							27.769748547000063
						],
						[
							-82.6998299999999,
							27.770060000000058
						],
						[
							-82.6998299999999,
							27.770327170000087
						],
						[
							-82.6998299999999,
							27.770703196000056
						],
						[
							-82.6998299999999,
							27.770940000000053
						],
						[
							-82.6998299999999,
							27.77098000000007
						],
						[
							-82.6998299999999,
							27.771137071000055
						],
						[
							-82.6998299999999,
							27.771484172000047
						],
						[
							-82.6998299999999,
							27.771820000000048
						],
						[
							-82.6998356599999,
							27.77235201600007
						],
						[
							-82.69983999999994,
							27.772760000000066
						],
						[
							-82.6998456899999,
							27.77327782800006
						],
						[
							-82.69984999999991,
							27.77367000000004
						],
						[
							-82.69985267899995,
							27.773913784000058
						],
						[
							-82.69985586099995,
							27.774203317000058
						],
						[
							-82.69985999999994,
							27.77458000000007
						],
						[
							-82.69985999999994,
							27.774984101000086
						],
						[
							-82.69985999999994,
							27.775490000000048
						],
						[
							-82.6998655669999,
							27.775996562000046
						],
						[
							-82.69986999999992,
							27.77640000000008
						],
						[
							-82.69986999999992,
							27.77660390300008
						],
						[
							-82.69986999999992,
							27.77692207800004
						],
						[
							-82.69986999999992,
							27.777199056000086
						],
						[
							-82.69986999999992,
							27.777240000000063
						],
						[
							-82.69986999999992,
							27.777529504000086
						],
						[
							-82.69986999999992,
							27.777789829000085
						],
						[
							-82.69986999999992,
							27.77801000000005
						],
						[
							-82.69986999999992,
							27.778140000000064
						],
						[
							-82.69987496599992,
							27.77833864100006
						],
						[
							-82.69987861599992,
							27.778484621000075
						],
						[
							-82.69988656499993,
							27.778802598000084
						],
						[
							-82.69988999999993,
							27.77894000000009
						],
						[
							-82.69988999999993,
							27.779060000000072
						],
						[
							-82.6998951139999,
							27.779525410000076
						],
						[
							-82.6998999999999,
							27.77997000000005
						],
						[
							-82.69990742099992,
							27.78039299200009
						],
						[
							-82.69990999999993,
							27.78088000000008
						],
						[
							-82.69990999999993,
							27.78155008400006
						],
						[
							-82.69990999999993,
							27.781780000000083
						],
						[
							-82.6999141469999,
							27.78215737900007
						],
						[
							-82.69991796099993,
							27.782504437000057
						],
						[
							-82.6999199999999,
							27.78269000000006
						],
						[
							-82.69992207299993,
							27.78288073400006
						],
						[
							-82.69992584599993,
							27.783227794000084
						],
						[
							-82.69992999999994,
							27.783610000000067
						],
						[
							-82.69993470199996,
							27.784037916000045
						],
						[
							-82.69993999999991,
							27.784520000000043
						],
						[
							-82.6995551579999,
							27.784520000000043
						],
						[
							-82.69915020799993,
							27.784520000000043
						],
						[
							-82.69852999999995,
							27.784520000000043
						],
						[
							-82.69813777799993,
							27.784525563000045
						],
						[
							-82.69770398999994,
							27.78453171600006
						],
						[
							-82.69711999999993,
							27.78454000000005
						],
						[
							-82.69646017999992,
							27.78454000000005
						],
						[
							-82.6958899999999,
							27.78454000000005
						],
						[
							-82.6952164029999,
							27.78454000000005
						],
						[
							-82.69443542699992,
							27.78454000000005
						],
						[
							-82.69377999999995,
							27.78454000000005
						],
						[
							-82.69316272599991,
							27.78454000000005
						],
						[
							-82.69243959999994,
							27.78454000000005
						],
						[
							-82.69170999999996,
							27.78454000000005
						],
						[
							-82.69113807999992,
							27.784544115000074
						],
						[
							-82.6907329419999,
							27.784547029000066
						],
						[
							-82.69031999999993,
							27.78455000000008
						],
						[
							-82.6896917219999,
							27.78455000000008
						],
						[
							-82.68894999999992,
							27.78455000000008
						],
						[
							-82.68862149499995,
							27.78455000000008
						],
						[
							-82.68810084499995,
							27.78455000000008
						],
						[
							-82.68758999999994,
							27.78455000000008
						],
						[
							-82.68731974199994,
							27.784537254000043
						],
						[
							-82.68677030899994,
							27.784528392000084
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Central Oak Park",
				"RegionID": "416371"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.71221999999995,
					27.762714626000047,
					-82.69978999999995,
					27.770940000000053
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.69979320899995,
							27.764892049000082
						],
						[
							-82.69978999999995,
							27.764416852000068
						],
						[
							-82.69978999999995,
							27.76394171000004
						],
						[
							-82.69978999999995,
							27.763438619000055
						],
						[
							-82.69978999999995,
							27.76304732500006
						],
						[
							-82.69978999999995,
							27.76273000000009
						],
						[
							-82.6998077529999,
							27.762714626000047
						],
						[
							-82.6998079999999,
							27.762732000000085
						],
						[
							-82.7000339999999,
							27.762763000000064
						],
						[
							-82.70025599999991,
							27.76282400000008
						],
						[
							-82.7003935489999,
							27.762869159000047
						],
						[
							-82.70058799999993,
							27.76293300000009
						],
						[
							-82.7012259999999,
							27.76315100000005
						],
						[
							-82.70175199999994,
							27.763345000000072
						],
						[
							-82.70218768199993,
							27.76349496200004
						],
						[
							-82.70223971199995,
							27.763512871000046
						],
						[
							-82.70229294399991,
							27.763531194000052
						],
						[
							-82.70232403699993,
							27.76354189600005
						],
						[
							-82.70389899999994,
							27.764084000000082
						],
						[
							-82.70458128399991,
							27.764322006000043
						],
						[
							-82.70458699999995,
							27.764324000000048
						],
						[
							-82.70512899999994,
							27.76446100000004
						],
						[
							-82.70557999999994,
							27.76452900000004
						],
						[
							-82.70573399999995,
							27.764545000000055
						],
						[
							-82.70582634699991,
							27.76455496500006
						],
						[
							-82.70587299999994,
							27.764560000000074
						],
						[
							-82.7061349999999,
							27.76457600000009
						],
						[
							-82.7074527879999,
							27.76457788000005
						],
						[
							-82.70748091699996,
							27.76457792000008
						],
						[
							-82.70753699999995,
							27.764578000000085
						],
						[
							-82.70772291199995,
							27.764578000000085
						],
						[
							-82.70776199999995,
							27.764578000000085
						],
						[
							-82.7078699999999,
							27.764575000000036
						],
						[
							-82.70792813799996,
							27.764580426000066
						],
						[
							-82.70801999999993,
							27.764589000000058
						],
						[
							-82.70833099999993,
							27.76459200000005
						],
						[
							-82.70868299999995,
							27.76458400000007
						],
						[
							-82.70902299999995,
							27.764591000000053
						],
						[
							-82.71171565399993,
							27.764578097000083
						],
						[
							-82.71173599999992,
							27.764578000000085
						],
						[
							-82.71174496299994,
							27.764578183000086
						],
						[
							-82.71212899999995,
							27.764586000000065
						],
						[
							-82.71212999999995,
							27.764874286000065
						],
						[
							-82.71212999999995,
							27.76502000000005
						],
						[
							-82.71212999999995,
							27.765222763000057
						],
						[
							-82.71212999999995,
							27.765460000000076
						],
						[
							-82.71213494199992,
							27.765919636000035
						],
						[
							-82.71213999999992,
							27.766390000000058
						],
						[
							-82.71214568699992,
							27.766643066000086
						],
						[
							-82.71215592199991,
							27.767098537000038
						],
						[
							-82.71215999999993,
							27.767280000000085
						],
						[
							-82.71218999999991,
							27.76768890900007
						],
						[
							-82.71218999999991,
							27.768110000000036
						],
						[
							-82.71219808199993,
							27.768627269000035
						],
						[
							-82.71220268799993,
							27.76892206200006
						],
						[
							-82.71221190099993,
							27.769511649000037
						],
						[
							-82.71221082699992,
							27.770235428000035
						],
						[
							-82.71221563299993,
							27.770557428000075
						],
						[
							-82.71221998899995,
							27.770899142000076
						],
						[
							-82.71221999999995,
							27.77090000000004
						],
						[
							-82.71151082299991,
							27.770904553000037
						],
						[
							-82.71009011599995,
							27.770910000000075
						],
						[
							-82.70893746099995,
							27.770910000000075
						],
						[
							-82.70802999999995,
							27.770910000000075
						],
						[
							-82.70732910499993,
							27.770910000000075
						],
						[
							-82.70668999999992,
							27.770910000000075
						],
						[
							-82.70596207299991,
							27.770915352000088
						],
						[
							-82.70532999999995,
							27.770920000000046
						],
						[
							-82.70451461999994,
							27.77092566200008
						],
						[
							-82.70388999999994,
							27.770930000000078
						],
						[
							-82.70306695999994,
							27.770930000000078
						],
						[
							-82.70242999999994,
							27.770930000000078
						],
						[
							-82.70169988399994,
							27.77093579500007
						],
						[
							-82.70116999999993,
							27.770940000000053
						],
						[
							-82.7007348439999,
							27.770940000000053
						],
						[
							-82.6998299999999,
							27.770940000000053
						],
						[
							-82.6998299999999,
							27.770703196000056
						],
						[
							-82.6998299999999,
							27.770327170000087
						],
						[
							-82.6998299999999,
							27.770060000000058
						],
						[
							-82.6998265389999,
							27.769748547000063
						],
						[
							-82.69982268299992,
							27.769401489000074
						],
						[
							-82.69981999999993,
							27.769160000000056
						],
						[
							-82.69981999999993,
							27.76862059300004
						],
						[
							-82.69981999999993,
							27.76824000000005
						],
						[
							-82.6998159659999,
							27.76786885200005
						],
						[
							-82.6998099999999,
							27.76732000000004
						],
						[
							-82.69980613299992,
							27.766971970000043
						],
						[
							-82.69980355899992,
							27.766740277000054
						],
						[
							-82.69979999999993,
							27.76642000000004
						],
						[
							-82.69979999999993,
							27.766009976000078
						],
						[
							-82.69979999999993,
							27.76570253100005
						],
						[
							-82.69979750899995,
							27.765283296000064
						],
						[
							-82.69979320899995,
							27.764892049000082
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Westminster Heights",
				"RegionID": "416372"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.67933497999991,
					30.457599927000043,
					-81.6254729499999,
					30.488912644000038
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.6453369059999,
							30.482073765000056
						],
						[
							-81.63967052599992,
							30.48168290100006
						],
						[
							-81.6254729499999,
							30.488891887000076
						],
						[
							-81.62567890899993,
							30.48828901200005
						],
						[
							-81.62583890899992,
							30.48778301200008
						],
						[
							-81.62609890999994,
							30.48703201300009
						],
						[
							-81.62646490899994,
							30.485914013000073
						],
						[
							-81.62680790999991,
							30.48489001200005
						],
						[
							-81.62789690999995,
							30.481669012000058
						],
						[
							-81.6283419099999,
							30.480356012000076
						],
						[
							-81.62918890899994,
							30.477810012000077
						],
						[
							-81.6294709089999,
							30.476997013000073
						],
						[
							-81.63040190999993,
							30.47422401200004
						],
						[
							-81.63120290899991,
							30.47182801300005
						],
						[
							-81.63161490899995,
							30.470577012000035
						],
						[
							-81.6321459099999,
							30.468969012000063
						],
						[
							-81.63234590899992,
							30.46837101200003
						],
						[
							-81.63235690999994,
							30.468337012000063
						],
						[
							-81.63278990999993,
							30.467001012000086
						],
						[
							-81.6333619099999,
							30.46527101200007
						],
						[
							-81.63344590899993,
							30.465036012000045
						],
						[
							-81.6334989099999,
							30.464891013000056
						],
						[
							-81.63365190999993,
							30.464388012000086
						],
						[
							-81.63371290999993,
							30.464226013000086
						],
						[
							-81.6338199089999,
							30.463902012000066
						],
						[
							-81.63385879399995,
							30.463771946000065
						],
						[
							-81.63391002499992,
							30.46371007900007
						],
						[
							-81.63407307699993,
							30.463175928000055
						],
						[
							-81.63404076899991,
							30.463165132000082
						],
						[
							-81.63401582599994,
							30.46303000800009
						],
						[
							-81.6340399099999,
							30.462945013000084
						],
						[
							-81.63408790999995,
							30.462773012000074
						],
						[
							-81.63418990899993,
							30.462399012000052
						],
						[
							-81.63421890899991,
							30.46227401300007
						],
						[
							-81.63426190899992,
							30.462142012000072
						],
						[
							-81.63446492599991,
							30.46153592600007
						],
						[
							-81.63458599299992,
							30.461571176000064
						],
						[
							-81.63470390799995,
							30.46123601100004
						],
						[
							-81.6354199079999,
							30.459124011000085
						],
						[
							-81.6354419079999,
							30.459059010000093
						],
						[
							-81.63588487999994,
							30.45768991300008
						],
						[
							-81.6361669019999,
							30.457599927000043
						],
						[
							-81.6369579069999,
							30.457740010000066
						],
						[
							-81.63889890699994,
							30.45808201000006
						],
						[
							-81.63944490799992,
							30.458173011000042
						],
						[
							-81.64212590699992,
							30.45865701100007
						],
						[
							-81.64272190799994,
							30.45878001000006
						],
						[
							-81.64331090799993,
							30.45891101100006
						],
						[
							-81.64385190799993,
							30.45901901000008
						],
						[
							-81.64450390799993,
							30.459150010000087
						],
						[
							-81.64584990799995,
							30.459459011000035
						],
						[
							-81.64689990799991,
							30.459691011000075
						],
						[
							-81.6473979079999,
							30.45979101000006
						],
						[
							-81.6483469069999,
							30.459943011000068
						],
						[
							-81.64904790899995,
							30.460033010000075
						],
						[
							-81.64913890799994,
							30.46005101000009
						],
						[
							-81.64930390699993,
							30.460068010000043
						],
						[
							-81.64946690799991,
							30.460085010000057
						],
						[
							-81.64952290799994,
							30.46008501100005
						],
						[
							-81.64954890799993,
							30.460089010000047
						],
						[
							-81.64980590699992,
							30.460115010000038
						],
						[
							-81.65013690799992,
							30.460130010000057
						],
						[
							-81.65027590699992,
							30.460141011000076
						],
						[
							-81.65045890699992,
							30.46014901000007
						],
						[
							-81.65093790799996,
							30.460156011000038
						],
						[
							-81.65141290699995,
							30.460168010000075
						],
						[
							-81.65202590699994,
							30.460156011000038
						],
						[
							-81.65233490799994,
							30.460145011000066
						],
						[
							-81.6528529069999,
							30.460115010000038
						],
						[
							-81.6533409079999,
							30.460104011000055
						],
						[
							-81.65429890699994,
							30.460063011000045
						],
						[
							-81.65476890799994,
							30.460044011000033
						],
						[
							-81.65528490799994,
							30.460073009000045
						],
						[
							-81.65570690699991,
							30.460029011000078
						],
						[
							-81.65622590699991,
							30.46003501000007
						],
						[
							-81.65669290799991,
							30.460032010000077
						],
						[
							-81.65892090699992,
							30.46004401000005
						],
						[
							-81.6651179079999,
							30.46009301000004
						],
						[
							-81.6665419069999,
							30.460108010000052
						],
						[
							-81.66944090699991,
							30.46012501000007
						],
						[
							-81.67425490699992,
							30.460165010000082
						],
						[
							-81.67468190699992,
							30.46016001000004
						],
						[
							-81.67683390699995,
							30.460183010000037
						],
						[
							-81.67744690799992,
							30.460178011000043
						],
						[
							-81.67851393099994,
							30.460193921000037
						],
						[
							-81.67933497999991,
							30.47210878800007
						],
						[
							-81.6791397319999,
							30.47992446500007
						],
						[
							-81.67659966899993,
							30.488912644000038
						],
						[
							-81.66819774099991,
							30.485981600000063
						],
						[
							-81.65842815399994,
							30.483636900000075
						],
						[
							-81.6453369059999,
							30.482073765000056
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Jacksonville North Estate",
				"RegionID": "276396"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.60195790799992,
					30.29005391800007,
					-81.5906910569999,
					30.314023162000073
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.5908149999999,
							30.29428100000007
						],
						[
							-81.59114191399993,
							30.29005391800007
						],
						[
							-81.59167890499992,
							30.290123008000084
						],
						[
							-81.59243790599993,
							30.29021900800007
						],
						[
							-81.59279390499995,
							30.290254009000076
						],
						[
							-81.59349790599993,
							30.290350008000075
						],
						[
							-81.59387990699992,
							30.29039700800007
						],
						[
							-81.59412390499995,
							30.29044000900007
						],
						[
							-81.59480990599991,
							30.29054500800004
						],
						[
							-81.5957179049999,
							30.290733009000064
						],
						[
							-81.59600290499992,
							30.29079500800009
						],
						[
							-81.59627490499992,
							30.290861008000036
						],
						[
							-81.59754890599993,
							30.291231008000068
						],
						[
							-81.59829690599992,
							30.291449008000082
						],
						[
							-81.59966290599993,
							30.291855008000088
						],
						[
							-81.6003109049999,
							30.29204800900004
						],
						[
							-81.6007329059999,
							30.292179009000048
						],
						[
							-81.60128690499994,
							30.292342008000045
						],
						[
							-81.60195790799992,
							30.29254800500007
						],
						[
							-81.60179290799994,
							30.294615010000086
						],
						[
							-81.60175290799992,
							30.29517401100009
						],
						[
							-81.60174190699992,
							30.295306011000037
						],
						[
							-81.60171590699991,
							30.295583010000083
						],
						[
							-81.60166590699993,
							30.29612401100007
						],
						[
							-81.60161490699994,
							30.29684601100007
						],
						[
							-81.60160090799991,
							30.29693101000004
						],
						[
							-81.60159490799992,
							30.297039011000038
						],
						[
							-81.6015609079999,
							30.29742501000004
						],
						[
							-81.60153690799991,
							30.29778101100004
						],
						[
							-81.60150490699995,
							30.29826501000008
						],
						[
							-81.60144590699991,
							30.298871011000074
						],
						[
							-81.60143790799992,
							30.29897201100005
						],
						[
							-81.60132590699993,
							30.300361011000064
						],
						[
							-81.6011979079999,
							30.301426011000043
						],
						[
							-81.60114490799992,
							30.301731010000083
						],
						[
							-81.6009109069999,
							30.30343301000005
						],
						[
							-81.60088790799995,
							30.30357701100007
						],
						[
							-81.60076090799993,
							30.304348010000066
						],
						[
							-81.60069390799994,
							30.304812010000038
						],
						[
							-81.60059190699991,
							30.30567601000007
						],
						[
							-81.60051090699994,
							30.30611401100009
						],
						[
							-81.60031190699993,
							30.307450010000082
						],
						[
							-81.60011190799992,
							30.309034010000058
						],
						[
							-81.59988790699992,
							30.310751010000047
						],
						[
							-81.59983590799993,
							30.311031011000065
						],
						[
							-81.59958690799994,
							30.31261901000005
						],
						[
							-81.59953290699991,
							30.313062011000056
						],
						[
							-81.59940890799993,
							30.313910010000082
						],
						[
							-81.5994008529999,
							30.313966995000044
						],
						[
							-81.5993900119999,
							30.314023162000073
						],
						[
							-81.5992718739999,
							30.314002087000063
						],
						[
							-81.59917294199994,
							30.313925934000054
						],
						[
							-81.5990879069999,
							30.31391101000008
						],
						[
							-81.59870790799994,
							30.313823011000068
						],
						[
							-81.5985179079999,
							30.313775010000086
						],
						[
							-81.5983419069999,
							30.313720011000044
						],
						[
							-81.59805590699995,
							30.31364401100007
						],
						[
							-81.59746990699995,
							30.31350801100007
						],
						[
							-81.59676090699992,
							30.313339010000053
						],
						[
							-81.59593199999995,
							30.313131000000055
						],
						[
							-81.59548338199994,
							30.31301982100007
						],
						[
							-81.59574110499995,
							30.312654714000075
						],
						[
							-81.59616059199993,
							30.31234561800005
						],
						[
							-81.59664631499993,
							30.311506643000087
						],
						[
							-81.59677878499991,
							30.31104299900005
						],
						[
							-81.59688917599993,
							30.310535198000082
						],
						[
							-81.59733074199994,
							30.309850771000068
						],
						[
							-81.5976398379999,
							30.309276735000086
						],
						[
							-81.59799309099992,
							30.308592308000073
						],
						[
							-81.59830218699994,
							30.308106586000065
						],
						[
							-81.5986554399999,
							30.30770917600006
						],
						[
							-81.59880998799991,
							30.307289689000072
						],
						[
							-81.59874375299995,
							30.30669357500005
						],
						[
							-81.59850089199996,
							30.306163696000052
						],
						[
							-81.59819179499993,
							30.30574420800008
						],
						[
							-81.59794893399993,
							30.30536887700004
						],
						[
							-81.5975956819999,
							30.304596137000086
						],
						[
							-81.59722035099992,
							30.30404418000006
						],
						[
							-81.59669047199992,
							30.303779240000043
						],
						[
							-81.5958956529999,
							30.303536379000032
						],
						[
							-81.59523330399992,
							30.30331559600006
						],
						[
							-81.59485797299995,
							30.303094813000087
						],
						[
							-81.5943943289999,
							30.30241038600008
						],
						[
							-81.5941073109999,
							30.30165972400005
						],
						[
							-81.59351119699994,
							30.30066620100007
						],
						[
							-81.59348911899991,
							30.30040126100005
						],
						[
							-81.59370990199994,
							30.29978306900006
						],
						[
							-81.59393068499992,
							30.298988251000086
						],
						[
							-81.59417354599992,
							30.298149276000064
						],
						[
							-81.59423978099994,
							30.297553162000042
						],
						[
							-81.59415146799995,
							30.296912891000094
						],
						[
							-81.59404107599994,
							30.296471325000084
						],
						[
							-81.59364366699992,
							30.29620638600005
						],
						[
							-81.5930033969999,
							30.296051838000043
						],
						[
							-81.59249559599994,
							30.29565442800003
						],
						[
							-81.59185532499993,
							30.295323254000042
						],
						[
							-81.59092803699991,
							30.294727140000077
						],
						[
							-81.5906910569999,
							30.294666733000042
						],
						[
							-81.5908149999999,
							30.29428100000007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Love Grove - Riviera Manor",
				"RegionID": "276429"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.72918509999981,
					28.026276994004565,
					-82.72538055699988,
					28.03957097800033
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.72734561699984,
							28.03815187100024
						],
						[
							-82.72708301899978,
							28.037766136000037
						],
						[
							-82.72677649999973,
							28.03731668300024
						],
						[
							-82.72656174899973,
							28.037001518000363
						],
						[
							-82.72634885899978,
							28.036689092000092
						],
						[
							-82.72617569299976,
							28.036434903000288
						],
						[
							-82.72614602899988,
							28.03635942200035
						],
						[
							-82.7260300309997,
							28.036064706000122
						],
						[
							-82.72591679899992,
							28.035777194000314
						],
						[
							-82.72580011499977,
							28.0354807620003
						],
						[
							-82.72568816499992,
							28.035196681000333
						],
						[
							-82.72557749099983,
							28.034915000000034
						],
						[
							-82.72543992099972,
							28.034566076000292
						],
						[
							-82.7254062199998,
							28.03448064600015
						],
						[
							-82.72539635099984,
							28.034078100000063
						],
						[
							-82.72538055699988,
							28.033889434000262
						],
						[
							-82.72702435799981,
							28.033564443000284
						],
						[
							-82.72735194699975,
							28.03350426200019
						],
						[
							-82.72718671799974,
							28.03327753600026
						],
						[
							-82.72701752399978,
							28.033008888000058
						],
						[
							-82.72685251999972,
							28.032671455000294
						],
						[
							-82.72665075599973,
							28.03225514100031
						],
						[
							-82.72653961899985,
							28.03191879800028
						],
						[
							-82.7264659429998,
							28.031650331000183
						],
						[
							-82.72637957199984,
							28.031294947000266
						],
						[
							-82.72635337799981,
							28.0310001000003
						],
						[
							-82.72634352499988,
							28.030773583000116
						],
						[
							-82.72632914599976,
							28.03047867300023
						],
						[
							-82.72634770599987,
							28.030198716000246
						],
						[
							-82.72635829399977,
							28.02992911600032
						],
						[
							-82.72637163099981,
							28.029607242000335
						],
						[
							-82.72638810499966,
							28.029290853000358
						],
						[
							-82.72640315999985,
							28.02899406800005
						],
						[
							-82.7264197959997,
							28.028658424000344
						],
						[
							-82.72643731099974,
							28.028309711000357
						],
						[
							-82.72645702399977,
							28.02801427700025
						],
						[
							-82.72646635899983,
							28.027745370000297
						],
						[
							-82.72646354699968,
							28.027687626000315
						],
						[
							-82.7264477319998,
							28.02736625000019
						],
						[
							-82.72643241799986,
							28.027263877000333
						],
						[
							-82.72639154899969,
							28.026990422
						],
						[
							-82.72630636499974,
							28.026667006000242
						],
						[
							-82.7262338599997,
							28.02639922000029
						],
						[
							-82.72619437099972,
							28.026288379000267
						],
						[
							-82.72713137899997,
							28.026284112000003
						],
						[
							-82.72881327868109,
							28.026276994004565
						],
						[
							-82.72884799999989,
							28.028775000000042
						],
						[
							-82.72910199999986,
							28.032092000000226
						],
						[
							-82.72895499999986,
							28.034804000000083
						],
						[
							-82.72888799999991,
							28.036830000000027
						],
						[
							-82.72888799999991,
							28.037422000000163
						],
						[
							-82.7288609999999,
							28.03795500000003
						],
						[
							-82.72917152299983,
							28.03795460001332
						],
						[
							-82.72917993399982,
							28.039034668000188
						],
						[
							-82.72918210899982,
							28.039271195000307
						],
						[
							-82.72918509999981,
							28.03957097800033
						],
						[
							-82.72886211199982,
							28.039569254000366
						],
						[
							-82.728536846,
							28.0395166580001
						],
						[
							-82.7283006289998,
							28.039467715000225
						],
						[
							-82.72807010599983,
							28.03940120700023
						],
						[
							-82.72784702099976,
							28.03931678200026
						],
						[
							-82.72759227499982,
							28.039191611000295
						],
						[
							-82.72743015699982,
							28.039097922000273
						],
						[
							-82.72724981499982,
							28.03897338800027
						],
						[
							-82.72694086799993,
							28.038711324000257
						],
						[
							-82.72716831699982,
							28.0384220100003
						],
						[
							-82.72734561699984,
							28.03815187100024
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Clubhouse Estates Homeowners Association",
				"RegionID": "343262"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.71522984099992,
					28.034325095000085,
					-82.71324243899997,
					28.036033685000056
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.71348915699987,
							28.034780280000096
						],
						[
							-82.71348615499998,
							28.034325095000085
						],
						[
							-82.71462866299991,
							28.03443330100007
						],
						[
							-82.71468590299995,
							28.03444675500012
						],
						[
							-82.7147089199999,
							28.034455231000017
						],
						[
							-82.71473136399989,
							28.03446577200009
						],
						[
							-82.71475246799994,
							28.034478039000042
						],
						[
							-82.71477241499991,
							28.034491688000102
						],
						[
							-82.71479082399992,
							28.034507063000042
						],
						[
							-82.71480798199993,
							28.03452347700007
						],
						[
							-82.71482292199991,
							28.03454162100006
						],
						[
							-82.71483641499988,
							28.034560460000108
						],
						[
							-82.71484797799995,
							28.034580684000005
						],
						[
							-82.71485741399994,
							28.034601264000024
						],
						[
							-82.7148647269999,
							28.034622885000125
						],
						[
							-82.71487265499995,
							28.03465000500006
						],
						[
							-82.71522984099992,
							28.035460218000125
						],
						[
							-82.71494393499998,
							28.035585477000012
						],
						[
							-82.71467182999994,
							28.03573266700002
						],
						[
							-82.71441468199988,
							28.035900063000014
						],
						[
							-82.71423916099994,
							28.036033685000056
						],
						[
							-82.71424298999999,
							28.035762402000085
						],
						[
							-82.71423599099985,
							28.03573665300009
						],
						[
							-82.71420926499995,
							28.03571155100005
						],
						[
							-82.71417700699995,
							28.035701719000123
						],
						[
							-82.71324842899993,
							28.03568986800012
						],
						[
							-82.71324243899997,
							28.034781561000017
						],
						[
							-82.71348915699987,
							28.034780280000096
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Eagles Glen Condominium Association",
				"RegionID": "343263"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.71850021399989,
					28.02874258900004,
					-82.7132017699999,
					28.03106204300011
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.7132169469999,
							28.03106204300011
						],
						[
							-82.7132017699999,
							28.02875998800006
						],
						[
							-82.71558996699987,
							28.028748258000064
						],
						[
							-82.7158844249999,
							28.028747068000058
						],
						[
							-82.71733657699988,
							28.02874258900004
						],
						[
							-82.71734036299993,
							28.029269626000133
						],
						[
							-82.71734601599987,
							28.03002012700005
						],
						[
							-82.7173464709999,
							28.03008888600006
						],
						[
							-82.71734851299989,
							28.03035292000006
						],
						[
							-82.71735239799995,
							28.030894739000118
						],
						[
							-82.71792708999989,
							28.030893113000076
						],
						[
							-82.71849926599991,
							28.03089149700012
						],
						[
							-82.71850021399989,
							28.031034172000115
						],
						[
							-82.71735336399995,
							28.031040509000015
						],
						[
							-82.7132169469999,
							28.03106204300011
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Eagle Estates Homeowners Association",
				"RegionID": "343264"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.72468225799989,
					28.015279748000076,
					-82.72353547199995,
					28.017094711000055
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.72353547199995,
							28.01570488700008
						],
						[
							-82.7238332579999,
							28.015279748000076
						],
						[
							-82.72413117999994,
							28.01533868900007
						],
						[
							-82.72432642599993,
							28.015337660000075
						],
						[
							-82.72455122199999,
							28.015584017000023
						],
						[
							-82.72450316299991,
							28.015812558000015
						],
						[
							-82.72442911499992,
							28.01586245700006
						],
						[
							-82.7244204979999,
							28.015964269000044
						],
						[
							-82.72437768099991,
							28.016049759000012
						],
						[
							-82.72468225799989,
							28.01663950300005
						],
						[
							-82.72464510499992,
							28.016645200000077
						],
						[
							-82.72447682199994,
							28.016970641000093
						],
						[
							-82.72389808299994,
							28.017094711000055
						],
						[
							-82.72384348299994,
							28.016808950000033
						],
						[
							-82.72368987699994,
							28.016548466000067
						],
						[
							-82.7237195259999,
							28.016347526000047
						],
						[
							-82.72378208899993,
							28.015970383000113
						],
						[
							-82.72353547199995,
							28.01570488700008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Winding Wood No.3 Condominium Association",
				"RegionID": "343280"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.72378208899993,
					28.015646059000098,
					-82.72287868999987,
					28.01674351600004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.72287868999987,
							28.015744099000038
						],
						[
							-82.72321585499988,
							28.015646059000098
						],
						[
							-82.72353547199995,
							28.01570488700008
						],
						[
							-82.72378208899993,
							28.015970383000113
						],
						[
							-82.7237195259999,
							28.016347526000047
						],
						[
							-82.72362212199992,
							28.01638104400007
						],
						[
							-82.7235284459999,
							28.01642176300006
						],
						[
							-82.72343415999991,
							28.016472455000084
						],
						[
							-82.72315713699992,
							28.01664272200005
						],
						[
							-82.72308955399991,
							28.01668914800007
						],
						[
							-82.72305652699994,
							28.016703762000038
						],
						[
							-82.72302212399993,
							28.01671528900001
						],
						[
							-82.72298692999995,
							28.016724413000055
						],
						[
							-82.72295065299997,
							28.01673044800011
						],
						[
							-82.72291742099988,
							28.01674351600004
						],
						[
							-82.72290849299995,
							28.016682537000058
						],
						[
							-82.72290642699996,
							28.016648855000117
						],
						[
							-82.72287868999987,
							28.015744099000038
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Winding Wood No.4 Condominium Association",
				"RegionID": "343282"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.71295697399998,
					28.004644068000083,
					-82.70914109199991,
					28.008387943000052
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.70921402899991,
							28.00604769000005
						],
						[
							-82.70914109199991,
							28.005883038000007
						],
						[
							-82.7091797109999,
							28.00562842000008
						],
						[
							-82.70920699899995,
							28.005447436000026
						],
						[
							-82.70923069899996,
							28.005236215000046
						],
						[
							-82.70924942799991,
							28.005020207000115
						],
						[
							-82.70925392799992,
							28.004894349000004
						],
						[
							-82.70926250599992,
							28.004669793000076
						],
						[
							-82.7096465759999,
							28.00465967600004
						],
						[
							-82.7102391199999,
							28.004644068000083
						],
						[
							-82.71048349499996,
							28.00465146000007
						],
						[
							-82.71080983699996,
							28.00464908600005
						],
						[
							-82.71073567899995,
							28.004962679000066
						],
						[
							-82.71088618099988,
							28.00499353100004
						],
						[
							-82.71095283999998,
							28.00471779600005
						],
						[
							-82.71120357099994,
							28.004718905000054
						],
						[
							-82.71154504999996,
							28.004720576000103
						],
						[
							-82.71198850599987,
							28.00472275000002
						],
						[
							-82.7119887449999,
							28.004759193000012
						],
						[
							-82.71199113299991,
							28.005255296000115
						],
						[
							-82.71199367199995,
							28.005788530000096
						],
						[
							-82.71199451699992,
							28.005961461000105
						],
						[
							-82.71217098399987,
							28.005934762000024
						],
						[
							-82.71228219599993,
							28.005925590000068
						],
						[
							-82.71241504699991,
							28.005922839000014
						],
						[
							-82.71246123999991,
							28.005922256000055
						],
						[
							-82.7126401759999,
							28.00593267400003
						],
						[
							-82.71266527699991,
							28.005935294000068
						],
						[
							-82.71295614299991,
							28.005964213000063
						],
						[
							-82.71295426799993,
							28.00628998200002
						],
						[
							-82.71295697399998,
							28.006465654000078
						],
						[
							-82.7129559389999,
							28.0071175200001
						],
						[
							-82.71295554599995,
							28.00733687200004
						],
						[
							-82.7129548049999,
							28.00778348300005
						],
						[
							-82.71295436899995,
							28.008143797000102
						],
						[
							-82.71295403099991,
							28.008372087000076
						],
						[
							-82.71254342199987,
							28.008374560000014
						],
						[
							-82.71218829899989,
							28.00837605700005
						],
						[
							-82.71145626599989,
							28.00837916000004
						],
						[
							-82.7109743729999,
							28.0083809650001
						],
						[
							-82.71025482899996,
							28.00838399700008
						],
						[
							-82.70967996799992,
							28.008386278000003
						],
						[
							-82.70929075499996,
							28.008387943000052
						],
						[
							-82.70928820599991,
							28.008146259000043
						],
						[
							-82.70928475599992,
							28.007811751000077
						],
						[
							-82.70928242999989,
							28.00759000700011
						],
						[
							-82.70928000599994,
							28.007367575000004
						],
						[
							-82.7092761439999,
							28.007162685000104
						],
						[
							-82.70927937399999,
							28.00712347400006
						],
						[
							-82.70928647899987,
							28.007084587000037
						],
						[
							-82.70929746499988,
							28.007046711000015
						],
						[
							-82.70931142499988,
							28.007004351000063
						],
						[
							-82.70932169099993,
							28.00696029000006
						],
						[
							-82.70932788299992,
							28.006914875000028
						],
						[
							-82.70932943299995,
							28.00687051600009
						],
						[
							-82.70932633099996,
							28.006825493000093
						],
						[
							-82.70931925799992,
							28.00678083500013
						],
						[
							-82.7093074439999,
							28.00673688800005
						],
						[
							-82.70929031199991,
							28.006693656000028
						],
						[
							-82.70921959699993,
							28.006469171000013
						],
						[
							-82.70921402899991,
							28.00604769000005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Shady Oak Farms Homeowners Association",
				"RegionID": "343297"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.77343083299988,
					27.990113388000047,
					-82.76720273699989,
					27.993641580000116
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.76839529599997,
							27.993639001000076
						],
						[
							-82.76821275899997,
							27.99363761400005
						],
						[
							-82.76791529199996,
							27.99363755700005
						],
						[
							-82.76723462899994,
							27.993637574000047
						],
						[
							-82.76722030999991,
							27.992636489000084
						],
						[
							-82.7672222959999,
							27.992479358000057
						],
						[
							-82.76722601499996,
							27.992129342000048
						],
						[
							-82.76721957699995,
							27.991220008000127
						],
						[
							-82.76721776299989,
							27.99109384100008
						],
						[
							-82.76721558699988,
							27.990964238000103
						],
						[
							-82.76721447599996,
							27.99089617100007
						],
						[
							-82.76720980599994,
							27.990585395000018
						],
						[
							-82.76720273699989,
							27.990113388000047
						],
						[
							-82.76790456399996,
							27.990115315000118
						],
						[
							-82.76808060199996,
							27.990116051000086
						],
						[
							-82.76868356499993,
							27.990117496000032
						],
						[
							-82.76895623799994,
							27.990118034000076
						],
						[
							-82.76977425999993,
							27.99011999000006
						],
						[
							-82.77003453699989,
							27.990120252000082
						],
						[
							-82.7708246709999,
							27.99012201400005
						],
						[
							-82.7710756529999,
							27.990122326000076
						],
						[
							-82.77206719399996,
							27.99012467100009
						],
						[
							-82.77231817799992,
							27.990125324000054
						],
						[
							-82.77286691299994,
							27.990126368000055
						],
						[
							-82.77305254799994,
							27.990128418000047
						],
						[
							-82.7733902789999,
							27.990127551000064
						],
						[
							-82.77339399199994,
							27.990389854000092
						],
						[
							-82.77339694299992,
							27.99062706500009
						],
						[
							-82.77339998399991,
							27.990836082000065
						],
						[
							-82.7734031429999,
							27.991061601000077
						],
						[
							-82.77340735899989,
							27.991306368000075
						],
						[
							-82.77340904499994,
							27.991413626000067
						],
						[
							-82.77341120599995,
							27.991540135000058
						],
						[
							-82.77341445999994,
							27.991738149000103
						],
						[
							-82.77341939999991,
							27.992036889000033
						],
						[
							-82.77342370799991,
							27.992206362000026
						],
						[
							-82.77342499799992,
							27.992475211000063
						],
						[
							-82.77342700499992,
							27.992844448000064
						],
						[
							-82.77342848099995,
							27.993132894000034
						],
						[
							-82.77343083299988,
							27.99363862000005
						],
						[
							-82.77245787099994,
							27.993638932000074
						],
						[
							-82.77228124899997,
							27.99363889200007
						],
						[
							-82.77072294599992,
							27.99364007100008
						],
						[
							-82.77047476599999,
							27.99364008700008
						],
						[
							-82.76910238099994,
							27.993641580000116
						],
						[
							-82.76888518499993,
							27.993641420000102
						],
						[
							-82.76839529599997,
							27.993639001000076
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Sunset Lake Estates Homeowners Assoc",
				"RegionID": "343313"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.75265892099992,
					27.989999442000034,
					-82.75038653199992,
					27.991989858000053
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.75059265499993,
							27.991834351000065
						],
						[
							-82.75058328499995,
							27.99168415800007
						],
						[
							-82.75038653199992,
							27.991684888000044
						],
						[
							-82.75056897299993,
							27.990917889000087
						],
						[
							-82.75067135999987,
							27.990895327000082
						],
						[
							-82.75075785199992,
							27.990717106000087
						],
						[
							-82.7506642229999,
							27.99066879600008
						],
						[
							-82.75067044899988,
							27.990491357000053
						],
						[
							-82.75076925799989,
							27.99049047400007
						],
						[
							-82.75077829199992,
							27.990138366000068
						],
						[
							-82.75078289799985,
							27.989999442000034
						],
						[
							-82.75263589699996,
							27.990011662000065
						],
						[
							-82.75265892099992,
							27.991542167000134
						],
						[
							-82.75239055899992,
							27.991846014000053
						],
						[
							-82.75204279799992,
							27.991654868000047
						],
						[
							-82.75197718399991,
							27.991618440000053
						],
						[
							-82.7518771339999,
							27.99171250200002
						],
						[
							-82.75180593599995,
							27.991722518000046
						],
						[
							-82.75155920899996,
							27.991756872000046
						],
						[
							-82.75103480599992,
							27.991830905000043
						],
						[
							-82.75095103499991,
							27.991989858000053
						],
						[
							-82.75059265499993,
							27.991834351000065
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Woodlake Condominium Association",
				"RegionID": "343315"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.70462156199997,
					27.968018950000083,
					-82.70127532499995,
					27.971058406000033
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.70462156199997,
							27.971058406000033
						],
						[
							-82.7019756759999,
							27.971027923000086
						],
						[
							-82.70177121499995,
							27.971028966000084
						],
						[
							-82.70176286599988,
							27.970696199000088
						],
						[
							-82.70142886399995,
							27.970785918000047
						],
						[
							-82.70127532499995,
							27.970517153000102
						],
						[
							-82.70134912499994,
							27.97047689500006
						],
						[
							-82.70151059999996,
							27.970401121000094
						],
						[
							-82.70167903399997,
							27.970338376000058
						],
						[
							-82.70185316799989,
							27.97028866700012
						],
						[
							-82.70219023099989,
							27.970193431000055
						],
						[
							-82.70228637599995,
							27.970165091000105
						],
						[
							-82.70236236799992,
							27.97013479200009
						],
						[
							-82.7025037899999,
							27.97005671200011
						],
						[
							-82.70256854399993,
							27.97000996700006
						],
						[
							-82.70268246999986,
							27.969902116000107
						],
						[
							-82.70273106599987,
							27.96984204500002
						],
						[
							-82.70277363899993,
							27.969778567000017
						],
						[
							-82.7028098009999,
							27.96971168300007
						],
						[
							-82.70342625699993,
							27.96827277900003
						],
						[
							-82.70346083999995,
							27.96820177700002
						],
						[
							-82.70351560699996,
							27.968107980000077
						],
						[
							-82.70357950599991,
							27.968018950000083
						],
						[
							-82.70458333799992,
							27.968035818000057
						],
						[
							-82.7045895649999,
							27.968323898999998
						],
						[
							-82.7045969539999,
							27.96865632600006
						],
						[
							-82.70460532999996,
							27.969036882000104
						],
						[
							-82.70462156199997,
							27.971058406000033
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Harbour Towne Condominium Association",
				"RegionID": "343329"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.77109434599991,
					27.962552514000045,
					-82.76711897399989,
					27.967921206000078
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.76949574999989,
							27.967908496000092
						],
						[
							-82.76926959199993,
							27.96790666600012
						],
						[
							-82.76901247799988,
							27.967908103000056
						],
						[
							-82.76874295399996,
							27.96790685900005
						],
						[
							-82.76838978499987,
							27.967905393000102
						],
						[
							-82.76814504299996,
							27.967904009000073
						],
						[
							-82.7678941049999,
							27.96790266000005
						],
						[
							-82.76736096099992,
							27.967900133000022
						],
						[
							-82.7671567849999,
							27.967899208000034
						],
						[
							-82.76715203899995,
							27.967228122000016
						],
						[
							-82.7671663989999,
							27.967068515000044
						],
						[
							-82.76716178899996,
							27.966416680000023
						],
						[
							-82.76716677899994,
							27.966246123000033
						],
						[
							-82.7671588769999,
							27.965566802000048
						],
						[
							-82.7671417729999,
							27.965338609000085
						],
						[
							-82.76713812199996,
							27.964384218000077
						],
						[
							-82.76713997499995,
							27.964208178000078
						],
						[
							-82.76713771299993,
							27.9640184080001
						],
						[
							-82.76713160699987,
							27.96346284800005
						],
						[
							-82.76713363499994,
							27.963311561000054
						],
						[
							-82.76713013399991,
							27.96312454900004
						],
						[
							-82.76711897399989,
							27.962552514000045
						],
						[
							-82.7674411489999,
							27.962554156000095
						],
						[
							-82.76761772799993,
							27.962555234000007
						],
						[
							-82.7681195779999,
							27.962557935000053
						],
						[
							-82.76828376399989,
							27.96255873700003
						],
						[
							-82.76862142699994,
							27.96256029000007
						],
						[
							-82.76889094099995,
							27.96256187800011
						],
						[
							-82.76927730399986,
							27.9625714080001
						],
						[
							-82.76960040399995,
							27.962573728000024
						],
						[
							-82.76978318199987,
							27.96257545600008
						],
						[
							-82.77014254299995,
							27.9625789460001
						],
						[
							-82.77037798999989,
							27.962581754000073
						],
						[
							-82.77080240899991,
							27.962585910000058
						],
						[
							-82.77085672399997,
							27.962600733000038
						],
						[
							-82.77088383899991,
							27.96262258500007
						],
						[
							-82.77090384799996,
							27.962660980000052
						],
						[
							-82.77090239899995,
							27.96270740200007
						],
						[
							-82.77088095199994,
							27.9627817840001
						],
						[
							-82.77086271599994,
							27.96287849600011
						],
						[
							-82.7708463039999,
							27.962966603000027
						],
						[
							-82.77083400699986,
							27.963109352000025
						],
						[
							-82.77083029999991,
							27.963153037000083
						],
						[
							-82.77083255099993,
							27.963340400000043
						],
						[
							-82.7708655629999,
							27.96351779200007
						],
						[
							-82.77090220699992,
							27.96372920000006
						],
						[
							-82.77094195099991,
							27.963873033000066
						],
						[
							-82.7709578469999,
							27.9639303600001
						],
						[
							-82.77100552899994,
							27.964053864000018
						],
						[
							-82.77103897599996,
							27.96414237900005
						],
						[
							-82.7710415989999,
							27.96442291200008
						],
						[
							-82.77105138199991,
							27.965363515000014
						],
						[
							-82.77106225899992,
							27.965586242000057
						],
						[
							-82.77107022399987,
							27.966271063000057
						],
						[
							-82.77107451499997,
							27.966438817000082
						],
						[
							-82.77108226599998,
							27.96709338400006
						],
						[
							-82.77108963399988,
							27.967258371000035
						],
						[
							-82.77109434599991,
							27.967921206000078
						],
						[
							-82.77074426599991,
							27.967918354000105
						],
						[
							-82.77055528299991,
							27.967916662000057
						],
						[
							-82.77029814699993,
							27.9679150080001
						],
						[
							-82.77004100699989,
							27.967912665000078
						],
						[
							-82.76986131999986,
							27.96791126400005
						],
						[
							-82.76968783099998,
							27.967910172000053
						],
						[
							-82.76949574999989,
							27.967908496000092
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Keystone Manor",
				"RegionID": "343330"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.84075997134923,
					27.936571000000146,
					-82.82309839401687,
					27.965897455394565
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.83218165353217,
							27.9653115183142
						],
						[
							-82.83205343449252,
							27.965224460344476
						],
						[
							-82.83186137617926,
							27.9651150776041
						],
						[
							-82.83168046316376,
							27.965013251867635
						],
						[
							-82.83134303843791,
							27.96481575985076
						],
						[
							-82.83132647652332,
							27.96480523868247
						],
						[
							-82.83120083583987,
							27.96471885340505
						],
						[
							-82.83103110949133,
							27.964638072703632
						],
						[
							-82.83101371390529,
							27.964629003040745
						],
						[
							-82.83087888215081,
							27.96455234752894
						],
						[
							-82.83074510979753,
							27.96448305566567
						],
						[
							-82.83063146517058,
							27.964421843311374
						],
						[
							-82.83062031627553,
							27.964415489601283
						],
						[
							-82.83049306040968,
							27.964338900640154
						],
						[
							-82.83048411395401,
							27.964333275380074
						],
						[
							-82.83037214026761,
							27.964259761200445
						],
						[
							-82.83026559219077,
							27.964189955824917
						],
						[
							-82.83014438966158,
							27.964113584498943
						],
						[
							-82.83003495566044,
							27.964041765540873
						],
						[
							-82.82988942916833,
							27.963954824482432
						],
						[
							-82.82973886197611,
							27.963872677710203
						],
						[
							-82.8297283264187,
							27.963866617179814
						],
						[
							-82.82959790763715,
							27.963787641416463
						],
						[
							-82.82958824712006,
							27.963781507141686
						],
						[
							-82.82948929651563,
							27.96371569565476
						],
						[
							-82.82939468514029,
							27.963656942046914
						],
						[
							-82.82933108238842,
							27.96362309066673
						],
						[
							-82.82930607404147,
							27.963607989250608
						],
						[
							-82.82925646024387,
							27.963574233198432
						],
						[
							-82.82451098341015,
							27.960932718453893
						],
						[
							-82.82407110791847,
							27.96067898913261
						],
						[
							-82.8240325413925,
							27.960651990586097
						],
						[
							-82.82401055117015,
							27.960631335856437
						],
						[
							-82.82394839362881,
							27.960566040581117
						],
						[
							-82.82392666421002,
							27.960540141905383
						],
						[
							-82.82386406600074,
							27.960455253100417
						],
						[
							-82.82384524319076,
							27.960425937899306
						],
						[
							-82.82379813400478,
							27.960340955565602
						],
						[
							-82.82378057294346,
							27.960302424113262
						],
						[
							-82.82376796265004,
							27.960254361645656
						],
						[
							-82.82376030222503,
							27.96020541874277
						],
						[
							-82.82375259953197,
							27.960184921394063
						],
						[
							-82.82373033411703,
							27.96016320456626
						],
						[
							-82.82369992444198,
							27.960129574419238
						],
						[
							-82.82364360529913,
							27.960055649249075
						],
						[
							-82.82362031016059,
							27.96001939308123
						],
						[
							-82.82357671372675,
							27.959937874036203
						],
						[
							-82.82355888286881,
							27.959905632442098
						],
						[
							-82.82350275797954,
							27.959851676717413
						],
						[
							-82.82347174126208,
							27.9598163747303
						],
						[
							-82.82335906340641,
							27.95966302503611
						],
						[
							-82.82335204599664,
							27.959653006588177
						],
						[
							-82.82333011243173,
							27.959620130972343
						],
						[
							-82.82331114662946,
							27.959586791306563
						],
						[
							-82.82327967125774,
							27.959520969027732
						],
						[
							-82.82326686311342,
							27.959489123134876
						],
						[
							-82.82324863835224,
							27.959433896668276
						],
						[
							-82.82323265919861,
							27.959388381081247
						],
						[
							-82.82321145498378,
							27.959345255892135
						],
						[
							-82.82320359311058,
							27.959327713716068
						],
						[
							-82.8231705367309,
							27.95924630259005
						],
						[
							-82.82315877269929,
							27.95922374309693
						],
						[
							-82.8231453296335,
							27.959193593326074
						],
						[
							-82.82313567001569,
							27.959162026223186
						],
						[
							-82.82312993953587,
							27.95912951573218
						],
						[
							-82.82312822542791,
							27.95909654928376
						],
						[
							-82.82312856447251,
							27.959076646388787
						],
						[
							-82.82311721772622,
							27.95903372444634
						],
						[
							-82.8231123550921,
							27.959011616412358
						],
						[
							-82.82310835850495,
							27.958972188336265
						],
						[
							-82.82310630535272,
							27.958897577882805
						],
						[
							-82.82310853207412,
							27.95885478454291
						],
						[
							-82.82311484711363,
							27.958807030543046
						],
						[
							-82.82311491186458,
							27.95874122894936
						],
						[
							-82.82310006675607,
							27.958610904596984
						],
						[
							-82.82309839401687,
							27.958574639435444
						],
						[
							-82.8231016045965,
							27.958538478596676
						],
						[
							-82.82310964183759,
							27.95850307588569
						],
						[
							-82.82312776767309,
							27.95844245798317
						],
						[
							-82.8231395955563,
							27.958410440320517
						],
						[
							-82.82315537056408,
							27.958380171838222
						],
						[
							-82.82317484178526,
							27.958352137273504
						],
						[
							-82.82319769625619,
							27.95832678538456
						],
						[
							-82.82326119468671,
							27.95826473666178
						],
						[
							-82.82330531362668,
							27.95822162586116
						],
						[
							-82.82332334323479,
							27.958205521702443
						],
						[
							-82.82342108784809,
							27.9581257995024
						],
						[
							-82.82349299224164,
							27.958066257189454
						],
						[
							-82.82355804200277,
							27.95800771312368
						],
						[
							-82.8236240261594,
							27.95793842215996
						],
						[
							-82.82369237553303,
							27.957865727262746
						],
						[
							-82.82377670406021,
							27.95777855507914
						],
						[
							-82.8237901102537,
							27.957765624626877
						],
						[
							-82.82386274939347,
							27.95770025021024
						],
						[
							-82.82391429403553,
							27.95764652740981
						],
						[
							-82.82393656574561,
							27.957625792641597
						],
						[
							-82.82400612650586,
							27.95756800130881
						],
						[
							-82.82406728220255,
							27.957505775419126
						],
						[
							-82.82407192989874,
							27.957501160097667
						],
						[
							-82.82413959578763,
							27.957435574341464
						],
						[
							-82.82418298627678,
							27.957381294860646
						],
						[
							-82.82421193815092,
							27.95734403594931
						],
						[
							-82.82424542260809,
							27.957283578126027
						],
						[
							-82.82429823979072,
							27.957190988427275
						],
						[
							-82.82430796146183,
							27.95717523140599
						],
						[
							-82.82435159656687,
							27.957109657339988
						],
						[
							-82.82441978406243,
							27.957000000307023
						],
						[
							-82.8244422212477,
							27.956969045642058
						],
						[
							-82.82445350953773,
							27.956956420060767
						],
						[
							-82.82449657537192,
							27.95691119225633
						],
						[
							-82.82451112820091,
							27.956891209320492
						],
						[
							-82.82451447367893,
							27.95687872403302
						],
						[
							-82.82453266966145,
							27.95683905314014
						],
						[
							-82.82455926890913,
							27.956791613003876
						],
						[
							-82.8245727785246,
							27.956767539951347
						],
						[
							-82.82459426692508,
							27.956735375699463
						],
						[
							-82.82462013502412,
							27.95670661538089
						],
						[
							-82.8246498513219,
							27.956681850749835
						],
						[
							-82.82468280338031,
							27.956661591722668
						],
						[
							-82.82473426708349,
							27.956634832395824
						],
						[
							-82.82477980245584,
							27.95660871698324
						],
						[
							-82.82484022790298,
							27.956560858661664
						],
						[
							-82.82492629571922,
							27.956491689106958
						],
						[
							-82.82496650350771,
							27.95645975328195
						],
						[
							-82.8250138501147,
							27.95641180862624
						],
						[
							-82.82512015897179,
							27.95626330178102
						],
						[
							-82.82516523029375,
							27.956193291358847
						],
						[
							-82.82518880152423,
							27.95614844936473
						],
						[
							-82.82518919003141,
							27.956136014439107
						],
						[
							-82.82518872777966,
							27.95607524365177
						],
						[
							-82.82518949130412,
							27.95605280556749
						],
						[
							-82.82519512106006,
							27.955978509876292
						],
						[
							-82.82519599250324,
							27.95596916951776
						],
						[
							-82.82519935506832,
							27.95593883808404
						],
						[
							-82.82519722997026,
							27.955898808361393
						],
						[
							-82.8251968513557,
							27.955884508241372
						],
						[
							-82.82520104129708,
							27.955837144546894
						],
						[
							-82.82521275856378,
							27.955772155940576
						],
						[
							-82.82521433507515,
							27.95576411510218
						],
						[
							-82.82523825614197,
							27.955651203422708
						],
						[
							-82.82524553795241,
							27.9556239485694
						],
						[
							-82.82529521290402,
							27.95547065822969
						],
						[
							-82.8253070704651,
							27.955411576369574
						],
						[
							-82.82531635236772,
							27.95537724295293
						],
						[
							-82.82533006972652,
							27.95534442849085
						],
						[
							-82.8253479842213,
							27.955313703153553
						],
						[
							-82.82539086569425,
							27.955250184937444
						],
						[
							-82.82540430516264,
							27.955231975465114
						],
						[
							-82.82548812107649,
							27.955127847463604
						],
						[
							-82.82555484357664,
							27.95503373701155
						],
						[
							-82.82562022338878,
							27.954943936109547
						],
						[
							-82.82563164477857,
							27.954929333817194
						],
						[
							-82.82566358150268,
							27.954897192048303
						],
						[
							-82.82571897884014,
							27.954850101748114
						],
						[
							-82.82572995236757,
							27.95484125691622
						],
						[
							-82.82583157845477,
							27.954763635532412
						],
						[
							-82.82584701801532,
							27.95475267819302
						],
						[
							-82.82592806221867,
							27.95469934389924
						],
						[
							-82.82604918470831,
							27.954621014749495
						],
						[
							-82.82606731593975,
							27.954610269649397
						],
						[
							-82.82614443640107,
							27.954568551000595
						],
						[
							-82.82615287923612,
							27.954564173999433
						],
						[
							-82.82627746861209,
							27.954502356401992
						],
						[
							-82.8264360154887,
							27.954425550704013
						],
						[
							-82.82647029764439,
							27.954411687654463
						],
						[
							-82.82650618509011,
							27.95440276637972
						],
						[
							-82.8265429682604,
							27.954398963147145
						],
						[
							-82.82657992140264,
							27.954400351700773
						],
						[
							-82.82661631606584,
							27.954406905959065
						],
						[
							-82.8271305960661,
							27.953902864739995
						],
						[
							-82.82781844971481,
							27.95322085128841
						],
						[
							-82.82868137887965,
							27.95236524980044
						],
						[
							-82.83003733436709,
							27.95102080923126
						],
						[
							-82.8304268181477,
							27.95063463405746
						],
						[
							-82.83119393624128,
							27.949870495417276
						],
						[
							-82.83122226398596,
							27.949839384270906
						],
						[
							-82.83137802925927,
							27.949668313436074
						],
						[
							-82.8315269039275,
							27.949504808597073
						],
						[
							-82.83174885390616,
							27.94920913759366
						],
						[
							-82.83184317030405,
							27.949084410621438
						],
						[
							-82.8318829347271,
							27.949006877371932
						],
						[
							-82.83189731488612,
							27.948982160405325
						],
						[
							-82.83217026721593,
							27.9485654838248
						],
						[
							-82.83244150903533,
							27.94802949688854
						],
						[
							-82.83257810166242,
							27.94774999749389
						],
						[
							-82.8329730173478,
							27.9469386705281
						],
						[
							-82.83353893012382,
							27.945718791456745
						],
						[
							-82.83354600059371,
							27.945696719395944
						],
						[
							-82.83354592684924,
							27.945686646089843
						],
						[
							-82.83354846113882,
							27.94564869559998
						],
						[
							-82.83355630682416,
							27.945611478056623
						],
						[
							-82.8335693092219,
							27.94557573450273
						],
						[
							-82.83358720842828,
							27.94554217540163
						],
						[
							-82.83360710502892,
							27.945510476998617
						],
						[
							-82.8336115764581,
							27.945482896590438
						],
						[
							-82.83361926386277,
							27.94539598071363
						],
						[
							-82.83361993835443,
							27.94538930684435
						],
						[
							-82.83363126891253,
							27.945289535159038
						],
						[
							-82.83363867572893,
							27.94525038767183
						],
						[
							-82.83365176715954,
							27.94521275734009
						],
						[
							-82.83368505916175,
							27.945135886890352
						],
						[
							-82.83371322952496,
							27.94504213076944
						],
						[
							-82.83371952567842,
							27.94502013245427
						],
						[
							-82.8337232830459,
							27.944953253472097
						],
						[
							-82.83372943800583,
							27.944909167806845
						],
						[
							-82.83373104689299,
							27.944902012800657
						],
						[
							-82.83372438471541,
							27.944874900939634
						],
						[
							-82.83372147271074,
							27.944847134371923
						],
						[
							-82.83372236573746,
							27.94481922930824
						],
						[
							-82.83372788038024,
							27.94473083764412
						],
						[
							-82.83373160447275,
							27.944699951328747
						],
						[
							-82.83373885930352,
							27.94466969993376
						],
						[
							-82.83374954864529,
							27.94464048455804
						],
						[
							-82.83378529759523,
							27.944557876434498
						],
						[
							-82.83381571176685,
							27.94442449528624
						],
						[
							-82.83382537408278,
							27.94439180852716
						],
						[
							-82.83383907975058,
							27.944360600254928
						],
						[
							-82.83385661203349,
							27.944331368691625
						],
						[
							-82.83395830197263,
							27.94418382681886
						],
						[
							-82.83401208406313,
							27.944106490492008
						],
						[
							-82.83401699999978,
							27.944095000000072
						],
						[
							-82.83410443198089,
							27.943788130541872
						],
						[
							-82.83411054999748,
							27.943707841748125
						],
						[
							-82.83411434423725,
							27.943678872787206
						],
						[
							-82.83414111525536,
							27.943535343689977
						],
						[
							-82.83415281183781,
							27.9434925368599
						],
						[
							-82.83416033016982,
							27.94347404050434
						],
						[
							-82.83419168683109,
							27.94340440150275
						],
						[
							-82.83419479758594,
							27.94339773662752
						],
						[
							-82.83420829820834,
							27.943369814476533
						],
						[
							-82.83421390008526,
							27.943355526048844
						],
						[
							-82.83421558181743,
							27.943346724384025
						],
						[
							-82.83422493836382,
							27.943292367562048
						],
						[
							-82.83423313748261,
							27.943258214907836
						],
						[
							-82.83425641463474,
							27.94318317907535
						],
						[
							-82.83427297564987,
							27.943128126178532
						],
						[
							-82.83428712829088,
							27.943091166742665
						],
						[
							-82.83429399999969,
							27.9430620000004
						],
						[
							-82.83431892298523,
							27.943016235269194
						],
						[
							-82.8343199733199,
							27.942986863371928
						],
						[
							-82.83432571549108,
							27.942952327607276
						],
						[
							-82.83433585174957,
							27.942918817069998
						],
						[
							-82.83434897016011,
							27.942884870361087
						],
						[
							-82.83435958665659,
							27.94286097177771
						],
						[
							-82.83437046485591,
							27.942839370062092
						],
						[
							-82.83437676820398,
							27.942817209868412
						],
						[
							-82.83439861093755,
							27.942688547462883
						],
						[
							-82.83440268126901,
							27.94266898990624
						],
						[
							-82.83442037632909,
							27.942597370597714
						],
						[
							-82.83442209493364,
							27.94259077407101
						],
						[
							-82.83444078194611,
							27.942522587475086
						],
						[
							-82.83445598948161,
							27.9424809003012
						],
						[
							-82.83447793383834,
							27.942433322568508
						],
						[
							-82.8344971451556,
							27.942398628523186
						],
						[
							-82.83452123439552,
							27.942367126171877
						],
						[
							-82.83454968174986,
							27.942339495401672
						],
						[
							-82.83458092059976,
							27.942313373694745
						],
						[
							-82.83461909142413,
							27.942286694406807
						],
						[
							-82.83466443074425,
							27.942265862511665
						],
						[
							-82.83469985773688,
							27.9422539384009
						],
						[
							-82.83469808337463,
							27.942235129979412
						],
						[
							-82.83469380440039,
							27.942198738015126
						],
						[
							-82.83469450227423,
							27.942162101434246
						],
						[
							-82.83470016530508,
							27.942125899225193
						],
						[
							-82.83471453557165,
							27.942062550982097
						],
						[
							-82.83472435526897,
							27.942029321032994
						],
						[
							-82.8347383532165,
							27.941997622628737
						],
						[
							-82.83475629828814,
							27.941967980975516
						],
						[
							-82.83477789460727,
							27.94194088260379
						],
						[
							-82.83482026706429,
							27.94189421138721
						],
						[
							-82.83484659741436,
							27.94186888917746
						],
						[
							-82.83488666850604,
							27.941841034476514
						],
						[
							-82.83494160269294,
							27.941810264173412
						],
						[
							-82.8349476245532,
							27.941807498758134
						],
						[
							-82.83494619732926,
							27.941793286772057
						],
						[
							-82.8349448483462,
							27.94176633498974
						],
						[
							-82.83494910124006,
							27.941718625056314
						],
						[
							-82.83499114634354,
							27.941488877956218
						],
						[
							-82.83500300840137,
							27.941445172704178
						],
						[
							-82.83500930005816,
							27.941429442662372
						],
						[
							-82.83503731034203,
							27.941365325498527
						],
						[
							-82.83505089370189,
							27.941338433971122
						],
						[
							-82.83507483905026,
							27.941303585242242
						],
						[
							-82.83509409353493,
							27.941279720833126
						],
						[
							-82.83511180927947,
							27.941242829744187
						],
						[
							-82.8351296185536,
							27.94121585547852
						],
						[
							-82.83519089565885,
							27.941134148475403
						],
						[
							-82.83525899861803,
							27.94099341447033
						],
						[
							-82.83526820407843,
							27.940976036871238
						],
						[
							-82.83528402315284,
							27.94095174978032
						],
						[
							-82.83534316886481,
							27.940870815293653
						],
						[
							-82.8353543231559,
							27.940856578127363
						],
						[
							-82.83537351558756,
							27.9408373856959
						],
						[
							-82.83544613674063,
							27.94072622769416
						],
						[
							-82.83547027094647,
							27.940694640806743
						],
						[
							-82.83549878485086,
							27.94066694258756
						],
						[
							-82.83553105882031,
							27.94064373558253
						],
						[
							-82.83566765234694,
							27.940560049170774
						],
						[
							-82.8356737101801,
							27.94055517664386
						],
						[
							-82.83541636828211,
							27.940551702563102
						],
						[
							-82.8350116284027,
							27.940547970376276
						],
						[
							-82.83481494577563,
							27.940546412751313
						],
						[
							-82.83447850131071,
							27.940543293902312
						],
						[
							-82.83438507883892,
							27.94054248541126
						],
						[
							-82.83424139415814,
							27.94054128481697
						],
						[
							-82.83409596209486,
							27.940539401635892
						],
						[
							-82.83397829120325,
							27.940537701918014
						],
						[
							-82.83396245684037,
							27.94053746539557
						],
						[
							-82.83392703524359,
							27.94055398324328
						],
						[
							-82.83388440647997,
							27.940565646550755
						],
						[
							-82.8338435979444,
							27.94057328629204
						],
						[
							-82.83382256190286,
							27.940576371866147
						],
						[
							-82.83377984320708,
							27.940580927830997
						],
						[
							-82.83375835750444,
							27.94058235505538
						],
						[
							-82.83372463472698,
							27.940583246283452
						],
						[
							-82.83370558348915,
							27.940583077211226
						],
						[
							-82.83364408155352,
							27.94058035586257
						],
						[
							-82.83362288902987,
							27.940578578802114
						],
						[
							-82.83359109080146,
							27.9405746460662
						],
						[
							-82.83356061367735,
							27.940569084659575
						],
						[
							-82.83347901729029,
							27.940549293278952
						],
						[
							-82.83344663090541,
							27.940539245154486
						],
						[
							-82.83340751219572,
							27.940524354179633
						],
						[
							-82.83338808504118,
							27.940516075022007
						],
						[
							-82.83335078476088,
							27.94049842312855
						],
						[
							-82.8333324835574,
							27.94048888851616
						],
						[
							-82.83329671122519,
							27.940468476604355
						],
						[
							-82.833276374856,
							27.940455638782527
						],
						[
							-82.83324304957895,
							27.940432461455448
						],
						[
							-82.83322451365257,
							27.940418344797383
						],
						[
							-82.8331933431511,
							27.94039240475225
						],
						[
							-82.83317652403042,
							27.940377165740777
						],
						[
							-82.8331480982598,
							27.94034914466518
						],
						[
							-82.83313195093267,
							27.94033176256871
						],
						[
							-82.8331063607245,
							27.940301663159875
						],
						[
							-82.83309175213736,
							27.940282859235946
						],
						[
							-82.83306919983885,
							27.940251021437415
						],
						[
							-82.83305507778509,
							27.94022887383331
						],
						[
							-82.8330359006421,
							27.940195296746776
						],
						[
							-82.83302496128896,
							27.94017399990107
						],
						[
							-82.83300891648462,
							27.940139029764413
						],
						[
							-82.8329989681843,
							27.94011415901362
						],
						[
							-82.8329865953118,
							27.940078133971117
						],
						[
							-82.83297895736979,
							27.94005152123386
						],
						[
							-82.83297034726081,
							27.94001444218647
						],
						[
							-82.8329660350115,
							27.93999134759765
						],
						[
							-82.83296076678306,
							27.93995424786512
						],
						[
							-82.83295829904336,
							27.939927019992187
						],
						[
							-82.83295679807503,
							27.939889209795258
						],
						[
							-82.83295703189866,
							27.93986300085375
						],
						[
							-82.83295921005667,
							27.939825169973634
						],
						[
							-82.83296211037026,
							27.939798315318246
						],
						[
							-82.83296801981537,
							27.9397611481378
						],
						[
							-82.83297303083764,
							27.939736875435376
						],
						[
							-82.83298233432424,
							27.93970037555137
						],
						[
							-82.8329906971195,
							27.939673504709287
						],
						[
							-82.8330040655415,
							27.93963732408475
						],
						[
							-82.83301358486533,
							27.939614765490113
						],
						[
							-82.83303001547864,
							27.939580285484237
						],
						[
							-82.8330415915518,
							27.939558598333143
						],
						[
							-82.83306146477008,
							27.93952512916508
						],
						[
							-82.8330830062307,
							27.939494044098826
						],
						[
							-82.83313151296292,
							27.939433584477694
						],
						[
							-82.83315611661493,
							27.939406830545824
						],
						[
							-82.83318561437756,
							27.939378803174822
						],
						[
							-82.83320318533123,
							27.939363497613915
						],
						[
							-82.83322741846273,
							27.939344163089533
						],
						[
							-82.83325336750049,
							27.939320269002472
						],
						[
							-82.8332801708944,
							27.939298555771433
						],
						[
							-82.83330955804018,
							27.939280492888333
						],
						[
							-82.83334103521074,
							27.939266382525677
						],
						[
							-82.83337407270481,
							27.93925646390313
						],
						[
							-82.83341934817308,
							27.93923514727307
						],
						[
							-82.83345941476801,
							27.939220857944594
						],
						[
							-82.83347984556586,
							27.939214474557797
						],
						[
							-82.83351705591427,
							27.93920445071418
						],
						[
							-82.83353840941635,
							27.939199617757385
						],
						[
							-82.83359347310551,
							27.939189485994934
						],
						[
							-82.83361473038048,
							27.939186443588785
						],
						[
							-82.83364674174798,
							27.939183155667383
						],
						[
							-82.83366808445834,
							27.939181814778028
						],
						[
							-82.83371857059858,
							27.939180650156917
						],
						[
							-82.83373797257194,
							27.939180900168484
						],
						[
							-82.83377236804233,
							27.93918258279941
						],
						[
							-82.83378615464903,
							27.939183611624077
						],
						[
							-82.83382682199124,
							27.939187696345083
						],
						[
							-82.83384670600122,
							27.939190443773683
						],
						[
							-82.83389343657255,
							27.93920322403888
						],
						[
							-82.83390142884757,
							27.9392039758725
						],
						[
							-82.8339424909921,
							27.939208012029507
						],
						[
							-82.83397681181873,
							27.9392165097229
						],
						[
							-82.83424532959127,
							27.939211576042414
						],
						[
							-82.83425608008706,
							27.93921159223
						],
						[
							-82.83446097712151,
							27.93921599351218
						],
						[
							-82.83442270917065,
							27.93921048966094
						],
						[
							-82.83439852909902,
							27.93920587793856
						],
						[
							-82.8343535405147,
							27.939195149026222
						],
						[
							-82.83433673488376,
							27.93919056248423
						],
						[
							-82.83429293430362,
							27.939177077150315
						],
						[
							-82.83425927987479,
							27.9391641970599
						],
						[
							-82.83417691726561,
							27.93912618901341
						],
						[
							-82.83415031352123,
							27.93911205976453
						],
						[
							-82.83411205096598,
							27.939088913014768
						],
						[
							-82.83409133868041,
							27.939075035576547
						],
						[
							-82.83405581186292,
							27.939048778071044
						],
						[
							-82.83403809971553,
							27.939034493240126
						],
						[
							-82.8340050667183,
							27.939005470319348
						],
						[
							-82.83398883305624,
							27.938989963309627
						],
						[
							-82.83395854029283,
							27.938958515816484
						],
						[
							-82.83394142799334,
							27.93893894567027
						],
						[
							-82.83391484583296,
							27.938905413548657
						],
						[
							-82.83390108620583,
							27.938886415371048
						],
						[
							-82.83387758422326,
							27.9388508022188
						],
						[
							-82.83386512771392,
							27.93882993974616
						],
						[
							-82.8338450485507,
							27.938792587304665
						],
						[
							-82.83383390774961,
							27.9387692427041
						],
						[
							-82.8338177901,
							27.938730834458806
						],
						[
							-82.83380837060103,
							27.93870468846872
						],
						[
							-82.8337963052969,
							27.93866487997942
						],
						[
							-82.83379016832322,
							27.938640630660597
						],
						[
							-82.8337818199169,
							27.938599768165165
						],
						[
							-82.83377789257764,
							27.938574483726445
						],
						[
							-82.83377351557738,
							27.93853359784936
						],
						[
							-82.8337719912265,
							27.93850695183632
						],
						[
							-82.83377167376578,
							27.938465697237472
						],
						[
							-82.83377279072369,
							27.938439018849085
						],
						[
							-82.83377653909793,
							27.938398082610153
						],
						[
							-82.83378016246637,
							27.938372296349385
						],
						[
							-82.83378788494467,
							27.938331680268572
						],
						[
							-82.83379416850777,
							27.938305711445217
						],
						[
							-82.8338059586195,
							27.938265758165418
						],
						[
							-82.83381431332123,
							27.938241695005065
						],
						[
							-82.83382979335119,
							27.938203095204376
						],
						[
							-82.83384497390702,
							27.93817139230487
						],
						[
							-82.83386454495296,
							27.9381365498714
						],
						[
							-82.83386835088402,
							27.938129992913577
						],
						[
							-82.8343730036418,
							27.937287865967622
						],
						[
							-82.83435181651429,
							27.937255311409285
						],
						[
							-82.8343355873489,
							27.93722002111362
						],
						[
							-82.83432466238486,
							27.937182746912832
						],
						[
							-82.83431927274812,
							27.937144280212248
						],
						[
							-82.83431953445069,
							27.93710543849325
						],
						[
							-82.83432544029841,
							27.937067047335976
						],
						[
							-82.83433686618496,
							27.9370299233226
						],
						[
							-82.83435356839355,
							27.936994854259925
						],
						[
							-82.8345356394929,
							27.93667157336738
						],
						[
							-82.83481300136326,
							27.93666813911361
						],
						[
							-82.83484745715366,
							27.936667712487232
						],
						[
							-82.83490499999988,
							27.936667000000096
						],
						[
							-82.83495299999994,
							27.936627000000165
						],
						[
							-82.83498918204113,
							27.93661091909289
						],
						[
							-82.83505199999988,
							27.936583000000073
						],
						[
							-82.83511998998064,
							27.93658461880916
						],
						[
							-82.83542999999989,
							27.936592000000108
						],
						[
							-82.83547899999986,
							27.93659300000019
						],
						[
							-82.83554699999989,
							27.936643000000064
						],
						[
							-82.83561499999992,
							27.93672000000004
						],
						[
							-82.83617046904651,
							27.936712558309576
						],
						[
							-82.83617385823419,
							27.93672967477018
						],
						[
							-82.83617905991274,
							27.936764023475927
						],
						[
							-82.83618209962123,
							27.93680477085793
						],
						[
							-82.8361820861313,
							27.9368151832082
						],
						[
							-82.83621708774483,
							27.93683613831003
						],
						[
							-82.8362483976411,
							27.936862289696155
						],
						[
							-82.83627525139696,
							27.936892998845693
						],
						[
							-82.83629699430566,
							27.93692751662366
						],
						[
							-82.83642678018566,
							27.936709124476096
						],
						[
							-82.83665999999988,
							27.936706000000125
						],
						[
							-82.83669299999987,
							27.936654000000086
						],
						[
							-82.8367859999999,
							27.936571000000146
						],
						[
							-82.83847699999984,
							27.93659800000007
						],
						[
							-82.83857599999986,
							27.9366370000001
						],
						[
							-82.83866299999995,
							27.93670300000006
						],
						[
							-82.83872499999985,
							27.936769000000186
						],
						[
							-82.83918309275407,
							27.93677271225913
						],
						[
							-82.83934199999992,
							27.936774000000067
						],
						[
							-82.83947502403304,
							27.93675956630743
						],
						[
							-82.83968299999981,
							27.936737000000026
						],
						[
							-82.84042799999989,
							27.936972000000107
						],
						[
							-82.84075997134923,
							27.93700123160711
						],
						[
							-82.84075056379912,
							27.937019981316627
						],
						[
							-82.8407419806698,
							27.937049123847505
						],
						[
							-82.84073670075018,
							27.937065179443113
						],
						[
							-82.84072118294847,
							27.93709995532733
						],
						[
							-82.84070789456626,
							27.937124849460485
						],
						[
							-82.84070050573627,
							27.937148249819828
						],
						[
							-82.84069074089791,
							27.93719539947485
						],
						[
							-82.84068751323115,
							27.937209159102064
						],
						[
							-82.84067820614733,
							27.937244628362482
						],
						[
							-82.84066377472675,
							27.93728575525815
						],
						[
							-82.84064290865716,
							27.937324021410706
						],
						[
							-82.8406261434959,
							27.93734960712239
						],
						[
							-82.8406146609521,
							27.93736998396145
						],
						[
							-82.84060968410394,
							27.937379740705484
						],
						[
							-82.84060393833562,
							27.937393695486104
						],
						[
							-82.84059377689601,
							27.937422373965966
						],
						[
							-82.84058423239127,
							27.937449853650268
						],
						[
							-82.84057708547923,
							27.93747519204796
						],
						[
							-82.840575124957,
							27.937481817353063
						],
						[
							-82.84056573153833,
							27.93751212990198
						],
						[
							-82.84055493607683,
							27.937541011628145
						],
						[
							-82.84053914578065,
							27.93757686400024
						],
						[
							-82.84053474449864,
							27.93758635364664
						],
						[
							-82.84051544055131,
							27.937625948097736
						],
						[
							-82.84049434695315,
							27.937661579236664
						],
						[
							-82.84046757503567,
							27.937693167023628
						],
						[
							-82.84046617119382,
							27.937707028274087
						],
						[
							-82.84045758446722,
							27.937741937257346
						],
						[
							-82.84044005847953,
							27.937797052208172
						],
						[
							-82.84042250641146,
							27.937839398584355
						],
						[
							-82.84041188092164,
							27.937859908522636
						],
						[
							-82.84023247696872,
							27.93833042301596
						],
						[
							-82.84022742997352,
							27.938342737433178
						],
						[
							-82.8397733451938,
							27.939377269830704
						],
						[
							-82.8397697452077,
							27.93938512630866
						],
						[
							-82.83963505914319,
							27.939667079052658
						],
						[
							-82.8396588048422,
							27.93970318053677
						],
						[
							-82.83967641446661,
							27.939742640089907
						],
						[
							-82.83968742846372,
							27.93978442349118
						],
						[
							-82.83969155545242,
							27.939827436264256
						],
						[
							-82.83968868931309,
							27.939870552460736
						],
						[
							-82.83967890468949,
							27.939912639832546
						],
						[
							-82.83966245788814,
							27.93995259850909
						],
						[
							-82.83928878328967,
							27.94069199680013
						],
						[
							-82.83926659701517,
							27.9407284220402
						],
						[
							-82.8392389491581,
							27.94076089565937
						],
						[
							-82.8392065276996,
							27.940788607367853
						],
						[
							-82.83917014472769,
							27.94081086289061
						],
						[
							-82.83913070945664,
							27.940827106444846
						],
						[
							-82.83908920754362,
							27.940836932437666
						],
						[
							-82.83904667500764,
							27.940840095353284
						],
						[
							-82.83894719110536,
							27.940839132178855
						],
						[
							-82.83831274549412,
							27.94200842618501
						],
						[
							-82.83827941391317,
							27.942069657420735
						],
						[
							-82.83785699999997,
							27.943019000000394
						],
						[
							-82.83770699720215,
							27.94318894548741
						],
						[
							-82.83765136608723,
							27.94330025641411
						],
						[
							-82.8371248436161,
							27.944320180226004
						],
						[
							-82.83670491059041,
							27.94513542194103
						],
						[
							-82.8365297424442,
							27.9454763522245
						],
						[
							-82.83620589208489,
							27.94610666095362
						],
						[
							-82.83619210188087,
							27.946130437229858
						],
						[
							-82.8360670115823,
							27.946322812103933
						],
						[
							-82.83594436474206,
							27.94653424451258
						],
						[
							-82.83564189126736,
							27.947055580593553
						],
						[
							-82.83562956605894,
							27.947074886339532
						],
						[
							-82.83556456666001,
							27.947167757526717
						],
						[
							-82.83513642732083,
							27.947783656419137
						],
						[
							-82.83510904926021,
							27.947835520321465
						],
						[
							-82.83494208023292,
							27.948148457407132
						],
						[
							-82.83490136972335,
							27.94822489618333
						],
						[
							-82.83488446535958,
							27.94825644448561
						],
						[
							-82.8347859999999,
							27.94847600000036
						],
						[
							-82.83443199999974,
							27.94932700000043
						],
						[
							-82.83394799999984,
							27.950815000000265
						],
						[
							-82.83377699999983,
							27.95138700000034
						],
						[
							-82.83338399999971,
							27.952710000000206
						],
						[
							-82.83278499999972,
							27.954574000000424
						],
						[
							-82.83231199999983,
							27.956325000000174
						],
						[
							-82.83187299999983,
							27.957973000000106
						],
						[
							-82.83173499999978,
							27.9584820000003
						],
						[
							-82.83167999999976,
							27.95889400000028
						],
						[
							-82.83146099999985,
							27.95981500000028
						],
						[
							-82.83126543693278,
							27.9616461803074
						],
						[
							-82.83128899278107,
							27.961751954057338
						],
						[
							-82.83133265396631,
							27.961908015208184
						],
						[
							-82.83136905492465,
							27.962043608688095
						],
						[
							-82.83137085446819,
							27.96205069534576
						],
						[
							-82.83141345355396,
							27.96222852908318
						],
						[
							-82.83141621177464,
							27.962241428958308
						],
						[
							-82.83144499097908,
							27.96239418420107
						],
						[
							-82.83147908067983,
							27.9625359946942
						],
						[
							-82.83150178496379,
							27.96262437736551
						],
						[
							-82.83152195675683,
							27.962698077704676
						],
						[
							-82.83157565167805,
							27.962872456246505
						],
						[
							-82.83158144511054,
							27.962894556185983
						],
						[
							-82.83160887083517,
							27.96302074905334
						],
						[
							-82.8316382993498,
							27.963120052191318
						],
						[
							-82.83170807774604,
							27.963351644701287
						],
						[
							-82.83174380151513,
							27.963407571739044
						],
						[
							-82.83179179923115,
							27.963468598833355
						],
						[
							-82.83183813140276,
							27.963515726005387
						],
						[
							-82.8318458601762,
							27.963523923325187
						],
						[
							-82.8318946816714,
							27.963577919519725
						],
						[
							-82.83198112810213,
							27.963653659521373
						],
						[
							-82.83207941680519,
							27.96374250084678
						],
						[
							-82.83210515360302,
							27.9637692071142
						],
						[
							-82.83211538429052,
							27.963782186129396
						],
						[
							-82.83218105278509,
							27.963870965401686
						],
						[
							-82.8322499633354,
							27.963956759823212
						],
						[
							-82.83227326836673,
							27.96399081355158
						],
						[
							-82.83227854918545,
							27.964000404821224
						],
						[
							-82.8323260001137,
							27.96409088291291
						],
						[
							-82.83234059431173,
							27.96412391411184
						],
						[
							-82.8323458607416,
							27.964139922043177
						],
						[
							-82.83237165149859,
							27.964227435969594
						],
						[
							-82.83238022113817,
							27.964267539436452
						],
						[
							-82.83239397536926,
							27.964369223081068
						],
						[
							-82.83239639274693,
							27.964402310037887
						],
						[
							-82.8323947307999,
							27.96443544375872
						],
						[
							-82.83238901470929,
							27.964468122423472
						],
						[
							-82.83234334803574,
							27.96465913122798
						],
						[
							-82.83244101440806,
							27.964724723280657
						],
						[
							-82.83255576250308,
							27.964796738290616
						],
						[
							-82.83258187072089,
							27.96481537583954
						],
						[
							-82.83263709898614,
							27.964859984010918
						],
						[
							-82.8327370199588,
							27.964917944416992
						],
						[
							-82.83275385886463,
							27.964928560913297
						],
						[
							-82.83282294748096,
							27.964975769024495
						],
						[
							-82.83289621344794,
							27.965012798609408
						],
						[
							-82.83297733679154,
							27.96505577451082
						],
						[
							-82.83306027766491,
							27.965087784080218
						],
						[
							-82.83316099903419,
							27.965125571793084
						],
						[
							-82.83317473258111,
							27.965131160180437
						],
						[
							-82.83333750537166,
							27.965202679663395
						],
						[
							-82.8333883395495,
							27.96522571220034
						],
						[
							-82.8333979820801,
							27.965230315829462
						],
						[
							-82.83340784404565,
							27.96523526479923
						],
						[
							-82.83343501166483,
							27.96523709402027
						],
						[
							-82.8335028475255,
							27.965240641845593
						],
						[
							-82.83358515437686,
							27.965242516932168
						],
						[
							-82.83360642424229,
							27.965243844331336
						],
						[
							-82.83367154954628,
							27.965250109008828
						],
						[
							-82.83371920462058,
							27.96522739483215
						],
						[
							-82.83373771266803,
							27.965219254168364
						],
						[
							-82.83382944711224,
							27.96518294224281
						],
						[
							-82.83383647081733,
							27.965180273954463
						],
						[
							-82.83385757296527,
							27.965174465002033
						],
						[
							-82.83381179299994,
							27.965334407000167
						],
						[
							-82.83384023399981,
							27.965351468500113
						],
						[
							-82.83386099988375,
							27.965436863520235
						],
						[
							-82.83386099999983,
							27.965441000000016
						],
						[
							-82.8338199999999,
							27.965469000000024
						],
						[
							-82.83377230599977,
							27.965474890000156
						],
						[
							-82.83366078355606,
							27.965890886564107
						],
						[
							-82.8336347196111,
							27.965894664797833
						],
						[
							-82.83359570522275,
							27.965897455394565
						],
						[
							-82.83350025567937,
							27.965897346576543
						],
						[
							-82.83345328948559,
							27.965893171923387
						],
						[
							-82.83333251413455,
							27.96587147847777
						],
						[
							-82.83328793654003,
							27.965859458138556
						],
						[
							-82.83328151448141,
							27.965857027272026
						],
						[
							-82.83320436614127,
							27.965826655367568
						],
						[
							-82.83319807448429,
							27.965823936717374
						],
						[
							-82.83316175896152,
							27.965806739881952
						],
						[
							-82.83315438452072,
							27.96580184846899
						],
						[
							-82.83312252244065,
							27.96578091225196
						],
						[
							-82.83308557559354,
							27.96575952097903
						],
						[
							-82.83303523064711,
							27.965736783419818
						],
						[
							-82.83301679364621,
							27.965731079020554
						],
						[
							-82.83301198128423,
							27.965729240658206
						],
						[
							-82.83298415095464,
							27.96571860902112
						],
						[
							-82.83283136063832,
							27.96564859320309
						],
						[
							-82.83281920540196,
							27.965642649584158
						],
						[
							-82.83266163968557,
							27.965560648502677
						],
						[
							-82.83252264496957,
							27.965489007609637
						],
						[
							-82.83237146893646,
							27.965416740790264
						],
						[
							-82.83235783791223,
							27.965409742265837
						],
						[
							-82.83220321657659,
							27.965324726655997
						],
						[
							-82.83218165353217,
							27.9653115183142
						]
					],
					[
						[
							-82.83536312841792,
							27.939232151631646
						],
						[
							-82.8350593922952,
							27.939228847521594
						],
						[
							-82.83543780991793,
							27.939236975594742
						],
						[
							-82.83623721097449,
							27.93925414545068
						],
						[
							-82.83653497649854,
							27.939248217119786
						],
						[
							-82.83655549632918,
							27.93924095689341
						],
						[
							-82.83536312841792,
							27.939232151631646
						]
					],
					[
						[
							-82.83870966756693,
							27.93770164133537
						],
						[
							-82.838766814086,
							27.937615426029897
						],
						[
							-82.8387395043739,
							27.93764381043157
						],
						[
							-82.83870831678513,
							27.937667869094543
						],
						[
							-82.83867393030818,
							27.93768707951269
						],
						[
							-82.8386370922792,
							27.937701024399892
						],
						[
							-82.83859860399427,
							27.937709399785962
						],
						[
							-82.8385593018229,
							27.93771202400787
						],
						[
							-82.83786405664652,
							27.93770593020152
						],
						[
							-82.83782308533353,
							27.93770244892581
						],
						[
							-82.83778312126111,
							27.93769277312005
						],
						[
							-82.83774509522777,
							27.937677126716057
						],
						[
							-82.83770989396497,
							27.937655875735704
						],
						[
							-82.83767833675489,
							27.93762951390956
						],
						[
							-82.83765116014246,
							27.937598656372593
						],
						[
							-82.83762899545167,
							27.937564022581643
						],
						[
							-82.83761236159168,
							27.937526418330553
						],
						[
							-82.83757388050137,
							27.937523250019073
						],
						[
							-82.83756513009786,
							27.937534885446627
						],
						[
							-82.83754484139283,
							27.937579155473383
						],
						[
							-82.83753215735493,
							27.937603483032905
						],
						[
							-82.83735418062611,
							27.937906226305135
						],
						[
							-82.83831288758694,
							27.93791280034902
						],
						[
							-82.8383508254867,
							27.937915744728876
						],
						[
							-82.83838797198324,
							27.93792399600871
						],
						[
							-82.83842358783352,
							27.937937391410475
						],
						[
							-82.83845696437203,
							27.93795566473502
						],
						[
							-82.83848092680762,
							27.937971073718263
						],
						[
							-82.83850484067948,
							27.93798868604053
						],
						[
							-82.83870966756693,
							27.93770164133537
						]
					],
					[
						[
							-82.83572070695067,
							27.93789694440189
						],
						[
							-82.83572623957978,
							27.937887637318074
						],
						[
							-82.83570367648944,
							27.93788961133067
						],
						[
							-82.8356557974838,
							27.937885237027974
						],
						[
							-82.83564039389624,
							27.937910067309094
						],
						[
							-82.83567552141483,
							27.93791011947004
						],
						[
							-82.83568362610463,
							27.937906880111388
						],
						[
							-82.83572070695067,
							27.93789694440189
						]
					],
					[
						[
							-82.83881401140529,
							27.937534508631426
						],
						[
							-82.83879308957783,
							27.93757644221905
						],
						[
							-82.83885502588582,
							27.937480960299258
						],
						[
							-82.83884582851948,
							27.937485249166475
						],
						[
							-82.83883541167228,
							27.937488801487934
						],
						[
							-82.83882540491624,
							27.937491987786093
						],
						[
							-82.83881401140529,
							27.937534508631426
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Sand Key Civic Association",
				"RegionID": "343331"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.80605157497972,
					27.963591182720574,
					-82.8038312918938,
					27.96484759495065
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.80546033459737,
							27.964802419307162
						],
						[
							-82.80543846668269,
							27.964787108349856
						],
						[
							-82.80486891704848,
							27.96480423593756
						],
						[
							-82.80482696637372,
							27.96480225652999
						],
						[
							-82.80478587005493,
							27.964793607749986
						],
						[
							-82.80474667939959,
							27.964778510831074
						],
						[
							-82.8047104016483,
							27.964757352481865
						],
						[
							-82.80425301545733,
							27.96477264635239
						],
						[
							-82.80421229685382,
							27.964770927747754
						],
						[
							-82.80414110382405,
							27.964762503798394
						],
						[
							-82.80412648367256,
							27.964759741089402
						],
						[
							-82.80413300003333,
							27.96466200006488
						],
						[
							-82.80414699977932,
							27.96458600015878
						],
						[
							-82.80418899991682,
							27.964516999676118
						],
						[
							-82.80424399987696,
							27.964502999965042
						],
						[
							-82.80417280699986,
							27.964494576000224
						],
						[
							-82.80417201099971,
							27.96438731300032
						],
						[
							-82.80406945999974,
							27.964382755000297
						],
						[
							-82.80405737499972,
							27.964345351000222
						],
						[
							-82.80404101399988,
							27.964306253000363
						],
						[
							-82.80402088499982,
							27.964267864000295
						],
						[
							-82.8039970909998,
							27.964231559000222
						],
						[
							-82.80396987799985,
							27.964197337000233
						],
						[
							-82.8039392909998,
							27.964165199000238
						],
						[
							-82.80390591499989,
							27.964135482000355
						],
						[
							-82.80386946199971,
							27.964108535000168
						],
						[
							-82.8040088349997,
							27.964104970000317
						],
						[
							-82.80400481999982,
							27.963981223000292
						],
						[
							-82.80420614499978,
							27.963977296000234
						],
						[
							-82.80420378399984,
							27.96395255600032
						],
						[
							-82.80420267299984,
							27.963907180000295
						],
						[
							-82.80575458293622,
							27.963860858910397
						],
						[
							-82.80575399921284,
							27.96385199959889
						],
						[
							-82.80573999946685,
							27.963790000338232
						],
						[
							-82.805704999652,
							27.9637830000156
						],
						[
							-82.80431299933733,
							27.96382500015301
						],
						[
							-82.8040639995505,
							27.96382500015301
						],
						[
							-82.80387699992369,
							27.963796999761495
						],
						[
							-82.8038312918938,
							27.963775669615313
						],
						[
							-82.80384353165446,
							27.96376484809954
						],
						[
							-82.80387887051342,
							27.96374238393479
						],
						[
							-82.80391729944323,
							27.963725751873195
						],
						[
							-82.80395786426264,
							27.963715363804123
						],
						[
							-82.80399955773115,
							27.963711477834
						],
						[
							-82.80401864943848,
							27.963711105514403
						],
						[
							-82.80404857078202,
							27.963686048604256
						],
						[
							-82.80408191134742,
							27.96366576079851
						],
						[
							-82.80411791660407,
							27.963650701651158
						],
						[
							-82.80415577266574,
							27.963641211105564
						],
						[
							-82.80419462337736,
							27.963637503200825
						],
						[
							-82.80574653304144,
							27.963591182720574
						],
						[
							-82.80578853317876,
							27.963593207094664
						],
						[
							-82.80582970863779,
							27.963601732667268
						],
						[
							-82.80586905847309,
							27.963616552594953
						],
						[
							-82.80590562850419,
							27.96363730714894
						],
						[
							-82.8059385293012,
							27.963663491809246
						],
						[
							-82.80596696136733,
							27.963694469855685
						],
						[
							-82.80599023582134,
							27.963729489455705
						],
						[
							-82.80600778519138,
							27.963767700749212
						],
						[
							-82.80601918499747,
							27.963808174737107
						],
						[
							-82.80602415734897,
							27.96384992756106
						],
						[
							-82.80605157497972,
							27.964526069338827
						],
						[
							-82.80604990044205,
							27.964568923832292
						],
						[
							-82.8060459146468,
							27.96460237411519
						],
						[
							-82.80603828030218,
							27.96464152340167
						],
						[
							-82.80602495684641,
							27.964679119559147
						],
						[
							-82.80600623655879,
							27.96471434060709
						],
						[
							-82.80598252773233,
							27.96474641672592
						],
						[
							-82.80595434927498,
							27.964774646444216
						],
						[
							-82.80592231632384,
							27.964798412827566
						],
						[
							-82.8058871285508,
							27.964817196966965
						],
						[
							-82.80584955667506,
							27.964830587871706
						],
						[
							-82.80582164981307,
							27.96483826268609
						],
						[
							-82.80579277348215,
							27.96484452646421
						],
						[
							-82.8057633854369,
							27.96484759495065
						],
						[
							-82.80573383821144,
							27.964847430374743
						],
						[
							-82.80559521761325,
							27.964838810372964
						],
						[
							-82.80557901003158,
							27.96483754412772
						],
						[
							-82.80553768258707,
							27.964832485441274
						],
						[
							-82.80549775808497,
							27.96482066924916
						],
						[
							-82.80546033459737,
							27.964802419307162
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Pierce 100 Condominium Association",
				"RegionID": "343332"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.72611407199987,
					27.953655014000077,
					-82.7253071529999,
					27.95486305500011
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.72532523499989,
							27.954855003000066
						],
						[
							-82.7253319319999,
							27.954423141000035
						],
						[
							-82.7253071529999,
							27.95442327200005
						],
						[
							-82.72531278799993,
							27.953875896000056
						],
						[
							-82.72547267199992,
							27.953655014000077
						],
						[
							-82.72551306199998,
							27.953673367000086
						],
						[
							-82.7255668149999,
							27.953692681000085
						],
						[
							-82.72562238199995,
							27.953708204000037
						],
						[
							-82.72567937299996,
							27.95371924900006
						],
						[
							-82.72573710499995,
							27.95372547700004
						],
						[
							-82.72579500499994,
							27.95372757800004
						],
						[
							-82.72611407199987,
							27.953731396000087
						],
						[
							-82.72610944999994,
							27.95442935600002
						],
						[
							-82.72589259899995,
							27.954425687000068
						],
						[
							-82.7258846829999,
							27.95486305500011
						],
						[
							-82.72532523499989,
							27.954855003000066
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Seville Condominium No.7 Association",
				"RegionID": "343346"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.79164988599992,
					27.952234628000056,
					-82.7907748339999,
					27.953213476000045
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.79090851499986,
							27.95260489100005
						],
						[
							-82.79090552499987,
							27.952234628000056
						],
						[
							-82.79164988599992,
							27.952242726000108
						],
						[
							-82.79164830299996,
							27.953213476000045
						],
						[
							-82.79088161699994,
							27.953204303000085
						],
						[
							-82.79087730999994,
							27.952825795000123
						],
						[
							-82.7907748339999,
							27.952703645000053
						],
						[
							-82.79090851499986,
							27.95260489100005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Sunshine Tower Apartment HOA",
				"RegionID": "343347"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.77932621999973,
					27.94759000000006,
					-82.77527448399933,
					27.94897003100029
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.77528642699998,
							27.948936630000457
						],
						[
							-82.77527448399933,
							27.94793352389259
						],
						[
							-82.77727098299985,
							27.94795472799755
						],
						[
							-82.77774180899466,
							27.947959728472785
						],
						[
							-82.7781439999999,
							27.947964000000095
						],
						[
							-82.7781439999999,
							27.947929453000167
						],
						[
							-82.7781439999999,
							27.94759000000006
						],
						[
							-82.77835899999991,
							27.947594000000034
						],
						[
							-82.7783708718109,
							27.947931890006853
						],
						[
							-82.77837199999992,
							27.947964000000095
						],
						[
							-82.77901099999985,
							27.94796800000007
						],
						[
							-82.77901068785052,
							27.947938736001735
						],
						[
							-82.77903570599995,
							27.947939046000517
						],
						[
							-82.77932130699986,
							27.94794189900013
						],
						[
							-82.77932621999973,
							27.94897003100029
						],
						[
							-82.77852617699988,
							27.94896854100052
						],
						[
							-82.77714959299976,
							27.94895328400059
						],
						[
							-82.77630642999989,
							27.948944977000526
						],
						[
							-82.77591550099979,
							27.948939961000466
						],
						[
							-82.77582973599979,
							27.94893906900057
						],
						[
							-82.77528642699998,
							27.948936630000457
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Normandy Park Condominium Association",
				"RegionID": "343349"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.9426315689999,
					28.036728432000075,
					-81.93602293599992,
					28.040643921000083
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.93605251999992,
							28.040643921000083
						],
						[
							-81.93602293599992,
							28.038789104000045
						],
						[
							-81.93687690599995,
							28.038789367000053
						],
						[
							-81.93687677199995,
							28.03770002300007
						],
						[
							-81.93687663899993,
							28.036728432000075
						],
						[
							-81.93850345499993,
							28.036742627000084
						],
						[
							-81.9387959099999,
							28.037005010000087
						],
						[
							-81.93981191099994,
							28.037948010000036
						],
						[
							-81.9406639099999,
							28.038718010000082
						],
						[
							-81.94072590999991,
							28.038774011000044
						],
						[
							-81.94078578299991,
							28.038828016000082
						],
						[
							-81.9426315689999,
							28.04051762800009
						],
						[
							-81.94074390899993,
							28.040523956000072
						],
						[
							-81.94066790999995,
							28.04052401000007
						],
						[
							-81.93924391899994,
							28.040541012000062
						],
						[
							-81.93722451199994,
							28.04060613000007
						],
						[
							-81.93605251999992,
							28.040643921000083
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Polk",
				"City": "Lakeland",
				"Name": "Lime Street",
				"RegionID": "343446"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.9448629019999,
					28.036842753000087,
					-81.94072790999991,
					28.04256792800004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.94075662399992,
							28.036842753000087
						],
						[
							-81.9448183959999,
							28.036842753000087
						],
						[
							-81.94484415999995,
							28.036843003000058
						],
						[
							-81.94486024299994,
							28.041738334000062
						],
						[
							-81.9448629019999,
							28.04256792800004
						],
						[
							-81.94393890999993,
							28.041720010000063
						],
						[
							-81.9426315689999,
							28.04051762800009
						],
						[
							-81.94078578299991,
							28.038828016000082
						],
						[
							-81.94078690999993,
							28.038688010000044
						],
						[
							-81.94078707599994,
							28.038542934000077
						],
						[
							-81.9407287439999,
							28.038492087000066
						],
						[
							-81.94072790999991,
							28.038413010000056
						],
						[
							-81.94073390999995,
							28.038324011000043
						],
						[
							-81.94076790999992,
							28.03769801100009
						],
						[
							-81.94076490899994,
							28.037483010000074
						],
						[
							-81.94075662399992,
							28.036842753000087
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Polk",
				"City": "Lakeland",
				"Name": "Francis Blvd",
				"RegionID": "343447"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.94484415999995,
					28.032541877000085,
					-81.94074178099993,
					28.036843003000058
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.94484415999995,
							28.036843003000058
						],
						[
							-81.9448183959999,
							28.036842753000087
						],
						[
							-81.94075662399992,
							28.036842753000087
						],
						[
							-81.94075590999995,
							28.03678301000008
						],
						[
							-81.94075890999994,
							28.03478700900007
						],
						[
							-81.94074590999992,
							28.033509010000046
						],
						[
							-81.94074178099993,
							28.032541877000085
						],
						[
							-81.94179291899991,
							28.03263849700005
						],
						[
							-81.94186491199991,
							28.032645012000046
						],
						[
							-81.94193190899995,
							28.032669011000053
						],
						[
							-81.94223090999992,
							28.032826011000054
						],
						[
							-81.94251691199992,
							28.033011010000052
						],
						[
							-81.94268090999992,
							28.03308001000005
						],
						[
							-81.94270890699994,
							28.033090008000045
						],
						[
							-81.9428219099999,
							28.033101009000063
						],
						[
							-81.94483191199993,
							28.033126955000057
						],
						[
							-81.94484415999995,
							28.036843003000058
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Polk",
				"City": "Lakeland",
				"Name": "Jefferson Ave",
				"RegionID": "343448"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.96986287199991,
					28.036229853000066,
					-81.94486024299994,
					28.048451612000065
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.96259690999995,
							28.046731011000077
						],
						[
							-81.96252878399993,
							28.04672987300006
						],
						[
							-81.9625219109999,
							28.04682401000008
						],
						[
							-81.96251590899993,
							28.046894010000074
						],
						[
							-81.96248285799994,
							28.04701898700006
						],
						[
							-81.96231690999991,
							28.047266010000044
						],
						[
							-81.96154791099991,
							28.04807601000005
						],
						[
							-81.96152092599993,
							28.048112194000055
						],
						[
							-81.96148592799995,
							28.048076821000052
						],
						[
							-81.9612139109999,
							28.048253009000064
						],
						[
							-81.96107190999993,
							28.048324009000055
						],
						[
							-81.9607619329999,
							28.04842614200004
						],
						[
							-81.96048191099995,
							28.048407010000062
						],
						[
							-81.95970788799991,
							28.048439142000063
						],
						[
							-81.9595009109999,
							28.04836700900006
						],
						[
							-81.9593319089999,
							28.04828200700007
						],
						[
							-81.95916091099991,
							28.048154010000076
						],
						[
							-81.95900491399993,
							28.048012011000083
						],
						[
							-81.95893590999992,
							28.04791301000006
						],
						[
							-81.95882690999991,
							28.047727011000067
						],
						[
							-81.95865391099996,
							28.047415011000055
						],
						[
							-81.95858691099994,
							28.04725301000008
						],
						[
							-81.95850191199992,
							28.046966011000052
						],
						[
							-81.95849003599994,
							28.046840866000082
						],
						[
							-81.9573482209999,
							28.04683812500008
						],
						[
							-81.9572799099999,
							28.046838010000045
						],
						[
							-81.95724391099992,
							28.046838010000045
						],
						[
							-81.95720291099991,
							28.046838010000045
						],
						[
							-81.95623490999992,
							28.046839010000042
						],
						[
							-81.95520591099995,
							28.046838010000045
						],
						[
							-81.95417978099994,
							28.046837140000036
						],
						[
							-81.95419058999994,
							28.045668581000086
						],
						[
							-81.94906736999991,
							28.046650727000042
						],
						[
							-81.94905590999991,
							28.046559010000067
						],
						[
							-81.9490429089999,
							28.046425008000085
						],
						[
							-81.94892604699993,
							28.046075874000053
						],
						[
							-81.94872991099993,
							28.046004008000068
						],
						[
							-81.94855091099993,
							28.04591701000004
						],
						[
							-81.94845191099995,
							28.045851010000035
						],
						[
							-81.94816591099993,
							28.045607011000072
						],
						[
							-81.94789390999995,
							28.04533401100008
						],
						[
							-81.94722691099992,
							28.044705011000076
						],
						[
							-81.94659890999992,
							28.044135010000048
						],
						[
							-81.94524890999992,
							28.042919010000052
						],
						[
							-81.9448969099999,
							28.04259901100005
						],
						[
							-81.9448629019999,
							28.04256792800004
						],
						[
							-81.94486024299994,
							28.041738334000062
						],
						[
							-81.94727482299993,
							28.041786211000044
						],
						[
							-81.94732225699994,
							28.042907312000068
						],
						[
							-81.9490489339999,
							28.042916878000085
						],
						[
							-81.95061339799992,
							28.04347970200007
						],
						[
							-81.95099490799993,
							28.042931026000076
						],
						[
							-81.95144798199993,
							28.04257326800007
						],
						[
							-81.9517818569999,
							28.042430052000046
						],
						[
							-81.95199649999995,
							28.042477923000035
						],
						[
							-81.95240193499991,
							28.04264480900008
						],
						[
							-81.95285501099994,
							28.04297872300009
						],
						[
							-81.95311738399994,
							28.043288869000037
						],
						[
							-81.95311077999992,
							28.040475880000088
						],
						[
							-81.95411104499993,
							28.040467142000068
						],
						[
							-81.9540949169999,
							28.039830750000082
						],
						[
							-81.9547628979999,
							28.039497087000086
						],
						[
							-81.9552397619999,
							28.038996185000087
						],
						[
							-81.95559755099993,
							28.03856696600008
						],
						[
							-81.95574064499993,
							28.037923040000067
						],
						[
							-81.95559747499993,
							28.037446095000067
						],
						[
							-81.9554208109999,
							28.036830015000078
						],
						[
							-81.95557685499995,
							28.036709845000075
						],
						[
							-81.9571229099999,
							28.03669701000007
						],
						[
							-81.95716996599992,
							28.03669401700006
						],
						[
							-81.95717091099993,
							28.036845010000036
						],
						[
							-81.95717590999993,
							28.037742010000045
						],
						[
							-81.9571819109999,
							28.038651010000084
						],
						[
							-81.95718178099992,
							28.038780140000085
						],
						[
							-81.9604269159999,
							28.038781440000037
						],
						[
							-81.96077238899994,
							28.03835230100009
						],
						[
							-81.96134466299992,
							28.037779846000035
						],
						[
							-81.96260864699991,
							28.037446096000053
						],
						[
							-81.96420643199991,
							28.037159925000083
						],
						[
							-81.96535111199995,
							28.036945298000035
						],
						[
							-81.96628116799991,
							28.036682973000044
						],
						[
							-81.96709197999992,
							28.036229853000066
						],
						[
							-81.9673306329999,
							28.036515979000058
						],
						[
							-81.96733053999992,
							28.03679168900004
						],
						[
							-81.96733045699995,
							28.037040688000047
						],
						[
							-81.96733040399994,
							28.037345041000037
						],
						[
							-81.96733058899991,
							28.039139293000062
						],
						[
							-81.96721121799993,
							28.039425441000052
						],
						[
							-81.96702044099993,
							28.039878547000058
						],
						[
							-81.96697261399993,
							28.04047475400006
						],
						[
							-81.96733038899994,
							28.04147637300008
						],
						[
							-81.9678073689999,
							28.04190565600004
						],
						[
							-81.96890439399994,
							28.042191751000075
						],
						[
							-81.9695199119999,
							28.042246013000067
						],
						[
							-81.96965297799994,
							28.042298895000044
						],
						[
							-81.96972390999991,
							28.04237001100006
						],
						[
							-81.96986287199991,
							28.04256307500009
						],
						[
							-81.96966491099994,
							28.04260701000004
						],
						[
							-81.96788991099993,
							28.04293701000006
						],
						[
							-81.96772848199993,
							28.04296548600007
						],
						[
							-81.96709198199994,
							28.04329350800009
						],
						[
							-81.96656725199995,
							28.04355572700007
						],
						[
							-81.9658756419999,
							28.044342732000075
						],
						[
							-81.96558953699991,
							28.045344385000078
						],
						[
							-81.96556493299994,
							28.048451612000065
						],
						[
							-81.96550891099992,
							28.04811101000007
						],
						[
							-81.96547590799992,
							28.047988006000082
						],
						[
							-81.9653359109999,
							28.047695011000087
						],
						[
							-81.96523990999992,
							28.047537011000088
						],
						[
							-81.9650849109999,
							28.04735401000005
						],
						[
							-81.96486490899991,
							28.047156010000037
						],
						[
							-81.96469590999993,
							28.047051011000065
						],
						[
							-81.96439191099995,
							28.046906010000043
						],
						[
							-81.9642139099999,
							28.04683501100004
						],
						[
							-81.96393391099991,
							28.04677101100009
						],
						[
							-81.96372590999994,
							28.04675201100008
						],
						[
							-81.96259690999995,
							28.046731011000077
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Polk",
				"City": "Lakeland",
				"Name": "Downtown",
				"RegionID": "343449"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.96153316099992,
					28.069745993000083,
					-81.95741091799994,
					28.07455299100008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.95830490999992,
							28.07279100800008
						],
						[
							-81.95820901899992,
							28.07253984900007
						],
						[
							-81.95813080399995,
							28.072542164000083
						],
						[
							-81.95794190999993,
							28.072053010000047
						],
						[
							-81.95777776599994,
							28.071554907000063
						],
						[
							-81.95781905399991,
							28.071554112000058
						],
						[
							-81.95774490999992,
							28.071322009000085
						],
						[
							-81.9576849099999,
							28.071119010000075
						],
						[
							-81.95764290999995,
							28.070967009000075
						],
						[
							-81.95760490899994,
							28.070812009000065
						],
						[
							-81.95756590999991,
							28.070643009000037
						],
						[
							-81.9575279099999,
							28.070444010000074
						],
						[
							-81.95748590999995,
							28.070241010000075
						],
						[
							-81.95744790999993,
							28.069998010000063
						],
						[
							-81.95742090899995,
							28.069795008000085
						],
						[
							-81.95741091799994,
							28.069745993000083
						],
						[
							-81.95777490899991,
							28.069754010000057
						],
						[
							-81.95899790899995,
							28.06974701000007
						],
						[
							-81.96149003999994,
							28.069753878000085
						],
						[
							-81.96153297399991,
							28.07344892800006
						],
						[
							-81.96153316099992,
							28.07455299100008
						],
						[
							-81.95934401999995,
							28.074472404000062
						],
						[
							-81.95906890999993,
							28.074084010000036
						],
						[
							-81.95883490999995,
							28.07372200900005
						],
						[
							-81.95863092899992,
							28.073375930000058
						],
						[
							-81.95830490999992,
							28.07279100800008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Polk",
				"City": "Lakeland",
				"Name": "Pinehurst",
				"RegionID": "343463"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.97400806099995,
					28.05491395200005,
					-81.9654519099999,
					28.06234800900006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.96555785599992,
							28.06234800900006
						],
						[
							-81.96554890999994,
							28.06151901000004
						],
						[
							-81.96554490999995,
							28.06079101000006
						],
						[
							-81.96555190999993,
							28.06046401000009
						],
						[
							-81.96556090899992,
							28.060061010000084
						],
						[
							-81.96555690999992,
							28.059533011000042
						],
						[
							-81.96555490999992,
							28.059354011000043
						],
						[
							-81.96554381899995,
							28.058772016000034
						],
						[
							-81.96552490999994,
							28.058605010000065
						],
						[
							-81.96546691099991,
							28.058162010000046
						],
						[
							-81.96545590999995,
							28.057699011000068
						],
						[
							-81.96545490999995,
							28.05749300900004
						],
						[
							-81.9654519099999,
							28.056810009000063
						],
						[
							-81.96545490999995,
							28.05536001100006
						],
						[
							-81.96548490399995,
							28.054922956000045
						],
						[
							-81.9657929089999,
							28.05492301000004
						],
						[
							-81.96604990999992,
							28.05492201000004
						],
						[
							-81.96629590899994,
							28.05492201000004
						],
						[
							-81.96677290999992,
							28.054921010000044
						],
						[
							-81.96701690899994,
							28.054919010000052
						],
						[
							-81.96729990999995,
							28.054919010000052
						],
						[
							-81.9685789099999,
							28.05491401000006
						],
						[
							-81.9695989089999,
							28.054918010000055
						],
						[
							-81.97002290899991,
							28.054926011000077
						],
						[
							-81.97034590999993,
							28.054917010000057
						],
						[
							-81.97044605199994,
							28.05491395200005
						],
						[
							-81.97070491099993,
							28.055106011000078
						],
						[
							-81.9711649109999,
							28.055452011000057
						],
						[
							-81.97135290999995,
							28.055634010000063
						],
						[
							-81.97145090999993,
							28.055761010000086
						],
						[
							-81.97163790999991,
							28.05610001100007
						],
						[
							-81.97175490899991,
							28.05643600800005
						],
						[
							-81.97178290999994,
							28.056649010000058
						],
						[
							-81.97178291099993,
							28.05682801000006
						],
						[
							-81.97178678199992,
							28.05769414000008
						],
						[
							-81.97184104299994,
							28.05769387500004
						],
						[
							-81.97184791099994,
							28.05855701100006
						],
						[
							-81.97184791099994,
							28.05871601000007
						],
						[
							-81.9718609119999,
							28.058862009000052
						],
						[
							-81.9719269119999,
							28.059116009000036
						],
						[
							-81.97201391099993,
							28.059307010000055
						],
						[
							-81.97205791099992,
							28.059416010000064
						],
						[
							-81.9721129109999,
							28.059509010000056
						],
						[
							-81.97218591099994,
							28.05960701000004
						],
						[
							-81.97225791099993,
							28.05969600900005
						],
						[
							-81.97251104499992,
							28.059932064000066
						],
						[
							-81.97242690899992,
							28.05993201000007
						],
						[
							-81.97234277199993,
							28.059932955000082
						],
						[
							-81.97301189399991,
							28.06057720000007
						],
						[
							-81.97306092499991,
							28.060543819000088
						],
						[
							-81.9736709089999,
							28.06109801100007
						],
						[
							-81.97400806099995,
							28.06140005400005
						],
						[
							-81.97392976799996,
							28.061413885000036
						],
						[
							-81.97388596799993,
							28.06232900300006
						],
						[
							-81.97369290899991,
							28.06231401000008
						],
						[
							-81.97342590999995,
							28.06229500900008
						],
						[
							-81.9732679089999,
							28.062290010000083
						],
						[
							-81.96962090999995,
							28.06232201000006
						],
						[
							-81.96814890899992,
							28.06233301000009
						],
						[
							-81.96757790999995,
							28.062339011000063
						],
						[
							-81.96714990999993,
							28.06234001100006
						],
						[
							-81.96636490999992,
							28.06234401000006
						],
						[
							-81.96555785599992,
							28.06234800900006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Polk",
				"City": "Lakeland",
				"Name": "Webster Park South",
				"RegionID": "343464"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.97388596799993,
					28.062290010000083,
					-81.9655027419999,
					28.08525919600004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.96775391099993,
							28.08269800900007
						],
						[
							-81.96762087399992,
							28.08256784100007
						],
						[
							-81.96759794799993,
							28.08262017700008
						],
						[
							-81.96739390999994,
							28.082420010000078
						],
						[
							-81.96655391099995,
							28.081622010000046
						],
						[
							-81.96585691099995,
							28.08096001000007
						],
						[
							-81.9655027419999,
							28.080616081000073
						],
						[
							-81.96552454199991,
							28.07344917400008
						],
						[
							-81.96554665899993,
							28.06608500100009
						],
						[
							-81.96555785599992,
							28.06234800900006
						],
						[
							-81.96636490999992,
							28.06234401000006
						],
						[
							-81.96714990999993,
							28.06234001100006
						],
						[
							-81.96757790999995,
							28.062339011000063
						],
						[
							-81.96814890899992,
							28.06233301000009
						],
						[
							-81.96962090999995,
							28.06232201000006
						],
						[
							-81.9732679089999,
							28.062290010000083
						],
						[
							-81.97342590999995,
							28.06229500900008
						],
						[
							-81.97369290899991,
							28.06231401000008
						],
						[
							-81.97388596799993,
							28.06232900300006
						],
						[
							-81.9738677979999,
							28.065500000000043
						],
						[
							-81.9736036349999,
							28.065500000000043
						],
						[
							-81.97321824499994,
							28.065500000000043
						],
						[
							-81.97265767699992,
							28.065500000000043
						],
						[
							-81.97172172999991,
							28.065500000000043
						],
						[
							-81.9716616689999,
							28.065500000000043
						],
						[
							-81.97167167899995,
							28.068946256000064
						],
						[
							-81.97384805099996,
							28.068946256000064
						],
						[
							-81.97379056499994,
							28.07897875100008
						],
						[
							-81.97376942999995,
							28.082698979000043
						],
						[
							-81.97376908299992,
							28.082760093000047
						],
						[
							-81.97309090999994,
							28.083261011000047
						],
						[
							-81.97148790999995,
							28.084459010000046
						],
						[
							-81.97077891099991,
							28.084988010000075
						],
						[
							-81.9704729099999,
							28.08522001000006
						],
						[
							-81.97042190299993,
							28.08525919600004
						],
						[
							-81.97041923499995,
							28.085256555000058
						],
						[
							-81.97034591099992,
							28.085184010000035
						],
						[
							-81.9702219099999,
							28.08506501000005
						],
						[
							-81.96982791099992,
							28.084684009000057
						],
						[
							-81.96967890999991,
							28.084537011000066
						],
						[
							-81.9695449109999,
							28.08440601100006
						],
						[
							-81.96947790999991,
							28.08434101000006
						],
						[
							-81.96937091099994,
							28.08423501100009
						],
						[
							-81.96907090999991,
							28.083941011000036
						],
						[
							-81.96887191099997,
							28.083745010000086
						],
						[
							-81.96833491099994,
							28.083244010000044
						],
						[
							-81.96824391099995,
							28.08315801100008
						],
						[
							-81.96783891099994,
							28.08278001000008
						],
						[
							-81.96775391099993,
							28.08269800900007
						]
					],
					[
						[
							-81.96752457499991,
							28.065914228000054
						],
						[
							-81.9671634739999,
							28.06585805600008
						],
						[
							-81.9671626299999,
							28.065909597000086
						],
						[
							-81.9671617109999,
							28.06596565600006
						],
						[
							-81.96715999999992,
							28.06607000000008
						],
						[
							-81.96715999999992,
							28.066143197000088
						],
						[
							-81.96715999999992,
							28.06625067200008
						],
						[
							-81.96715802499995,
							28.06631185200007
						],
						[
							-81.96714173299995,
							28.066409603000068
						],
						[
							-81.96712493599995,
							28.066510385000072
						],
						[
							-81.96710707099993,
							28.066578787000083
						],
						[
							-81.96708999999993,
							28.066630000000092
						],
						[
							-81.96706782099994,
							28.066693369000063
						],
						[
							-81.9670394819999,
							28.066774337000084
						],
						[
							-81.96701609699994,
							28.066841151000066
						],
						[
							-81.9669863009999,
							28.066926282000054
						],
						[
							-81.96695796199992,
							28.067007250000074
						],
						[
							-81.96692898899994,
							28.06707202200005
						],
						[
							-81.96690999999994,
							28.06711000000007
						],
						[
							-81.96846381499995,
							28.06775065100004
						],
						[
							-81.96913202899992,
							28.067984292000062
						],
						[
							-81.96963999999991,
							28.067984292000062
						],
						[
							-81.96963999999991,
							28.06785812600009
						],
						[
							-81.96963999999991,
							28.067531028000076
						],
						[
							-81.96963999999991,
							28.067325423000057
						],
						[
							-81.96963999999991,
							28.06711047300007
						],
						[
							-81.96963999999991,
							28.066965615000072
						],
						[
							-81.96963999999991,
							28.066895523000085
						],
						[
							-81.96964469799991,
							28.066830636000077
						],
						[
							-81.9696545249999,
							28.066769218000047
						],
						[
							-81.96966362299992,
							28.066712357000085
						],
						[
							-81.9696702999999,
							28.06667062200006
						],
						[
							-81.9696739449999,
							28.066647841000076
						],
						[
							-81.96967999999993,
							28.066591789000086
						],
						[
							-81.96967999999993,
							28.066531042000065
						],
						[
							-81.96967999999993,
							28.06648000000007
						],
						[
							-81.9696787659999,
							28.066418893000048
						],
						[
							-81.9696774439999,
							28.066353501000037
						],
						[
							-81.96967612299994,
							28.066288108000037
						],
						[
							-81.96967451899991,
							28.06620870200004
						],
						[
							-81.96967272099994,
							28.06611967100008
						],
						[
							-81.96967121099993,
							28.066044936000086
						],
						[
							-81.96966930899993,
							28.06595081000006
						],
						[
							-81.96872081999993,
							28.065942265000047
						],
						[
							-81.9678049449999,
							28.06593759200007
						],
						[
							-81.96752457499991,
							28.065914228000054
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Polk",
				"City": "Lakeland",
				"Name": "Webster Park North",
				"RegionID": "343465"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.96556090899992,
					28.054922956000045,
					-81.95726391099993,
					28.07344917400008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.96272339299992,
							28.06895998500005
						],
						[
							-81.96273262799991,
							28.06789000000009
						],
						[
							-81.96254793299994,
							28.06789000000009
						],
						[
							-81.9623540039999,
							28.06789000000009
						],
						[
							-81.96223999999995,
							28.06789000000009
						],
						[
							-81.96200310599994,
							28.067886963000035
						],
						[
							-81.9618830739999,
							28.067885424000053
						],
						[
							-81.96171675799991,
							28.06788329200009
						],
						[
							-81.96160595899994,
							28.067881871000054
						],
						[
							-81.96145999999993,
							28.06788000000006
						],
						[
							-81.96128282799992,
							28.067882873000087
						],
						[
							-81.96098724399992,
							28.067887666000047
						],
						[
							-81.96063641599994,
							28.06789335500008
						],
						[
							-81.96031328499993,
							28.067898595000088
						],
						[
							-81.95995322499994,
							28.06790443400007
						],
						[
							-81.95978704299995,
							28.067907129000048
						],
						[
							-81.95960999999994,
							28.06791000000004
						],
						[
							-81.95930658899994,
							28.067912784000043
						],
						[
							-81.95903880399993,
							28.067915240000048
						],
						[
							-81.95864174399992,
							28.06791888300006
						],
						[
							-81.95823544899991,
							28.067922611000085
						],
						[
							-81.95793072799995,
							28.067925406000086
						],
						[
							-81.9575982209999,
							28.06792845700005
						],
						[
							-81.95734293899994,
							28.067930458000035
						],
						[
							-81.95734291099991,
							28.067927010000062
						],
						[
							-81.95734291099991,
							28.066998010000077
						],
						[
							-81.95734104499991,
							28.066095876000077
						],
						[
							-81.95729478099992,
							28.06609614200005
						],
						[
							-81.95727478099991,
							28.065119877000086
						],
						[
							-81.95734504099995,
							28.065125143000046
						],
						[
							-81.95733291099992,
							28.062778010000045
						],
						[
							-81.95732890999994,
							28.06267401100007
						],
						[
							-81.9573199109999,
							28.062409010000067
						],
						[
							-81.95732103099994,
							28.061676874000057
						],
						[
							-81.95726479099994,
							28.06168414700005
						],
						[
							-81.95726391099993,
							28.06094001100007
						],
						[
							-81.95726791099992,
							28.060203010000066
						],
						[
							-81.95726890999993,
							28.059468010000046
						],
						[
							-81.95729591099992,
							28.058909010000036
						],
						[
							-81.95729591099992,
							28.058731011000077
						],
						[
							-81.95727791199994,
							28.057745010000076
						],
						[
							-81.9573479099999,
							28.057071010000072
						],
						[
							-81.95735691099992,
							28.05637401000007
						],
						[
							-81.95737374799997,
							28.05602392800006
						],
						[
							-81.95742107399991,
							28.055987092000066
						],
						[
							-81.95743591099995,
							28.05569101100008
						],
						[
							-81.9574378129999,
							28.055651863000037
						],
						[
							-81.9575550109999,
							28.05569315000008
						],
						[
							-81.95755491099993,
							28.05551401100007
						],
						[
							-81.9575589069999,
							28.05500201800004
						],
						[
							-81.95816490999994,
							28.054991010000037
						],
						[
							-81.95835891099995,
							28.054990010000044
						],
						[
							-81.95902390999993,
							28.054979010000068
						],
						[
							-81.95940191099993,
							28.05497200900004
						],
						[
							-81.95981391099991,
							28.054965011000036
						],
						[
							-81.96061591099993,
							28.054957010000066
						],
						[
							-81.96095690999994,
							28.054954010000074
						],
						[
							-81.96130590999991,
							28.05495101000008
						],
						[
							-81.96135391099995,
							28.05495101000008
						],
						[
							-81.96141991099995,
							28.054950010000084
						],
						[
							-81.96245491099995,
							28.05494100900006
						],
						[
							-81.96279190999991,
							28.054938010000058
						],
						[
							-81.96345191099994,
							28.054932010000073
						],
						[
							-81.96415991099991,
							28.05492501100008
						],
						[
							-81.96446591099995,
							28.05492301000004
						],
						[
							-81.96471691099993,
							28.05492301000004
						],
						[
							-81.96548490399995,
							28.054922956000045
						],
						[
							-81.96545490999995,
							28.05536001100006
						],
						[
							-81.9654519099999,
							28.056810009000063
						],
						[
							-81.96545490999995,
							28.05749300900004
						],
						[
							-81.96545590999995,
							28.057699011000068
						],
						[
							-81.96546691099991,
							28.058162010000046
						],
						[
							-81.96552490999994,
							28.058605010000065
						],
						[
							-81.96554381899995,
							28.058772016000034
						],
						[
							-81.96555490999992,
							28.059354011000043
						],
						[
							-81.96555690999992,
							28.059533011000042
						],
						[
							-81.96556090899992,
							28.060061010000084
						],
						[
							-81.96555190999993,
							28.06046401000009
						],
						[
							-81.96554490999995,
							28.06079101000006
						],
						[
							-81.96554890999994,
							28.06151901000004
						],
						[
							-81.96555785599992,
							28.06234800900006
						],
						[
							-81.96554665899993,
							28.06608500100009
						],
						[
							-81.96552454199991,
							28.07344917400008
						],
						[
							-81.96153297399991,
							28.07344892800006
						],
						[
							-81.96149003999994,
							28.069753878000085
						],
						[
							-81.96148758499994,
							28.069634087000054
						],
						[
							-81.96148566199992,
							28.069541780000066
						],
						[
							-81.96148315799991,
							28.06942158800007
						],
						[
							-81.9614735429999,
							28.06896005100009
						],
						[
							-81.96272339299992,
							28.06895998500005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Polk",
				"City": "Lakeland",
				"Name": "Paul A. Diggs",
				"RegionID": "343466"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.52219109399994,
					27.330049901000052,
					-82.5140098629999,
					27.333767280000075
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.51793175899991,
							27.333767280000075
						],
						[
							-82.5179277819999,
							27.33336485400008
						],
						[
							-82.51789999999994,
							27.333365040000047
						],
						[
							-82.51789999999994,
							27.333278824000047
						],
						[
							-82.51789999999994,
							27.33305697600008
						],
						[
							-82.51789999999994,
							27.332930207000064
						],
						[
							-82.51789999999994,
							27.33287000000007
						],
						[
							-82.51737278099996,
							27.332872746000078
						],
						[
							-82.51692002099992,
							27.332875104000042
						],
						[
							-82.51603718299992,
							27.33287970200007
						],
						[
							-82.51555728199992,
							27.332882202000068
						],
						[
							-82.51509089199993,
							27.33288463100007
						],
						[
							-82.5145974319999,
							27.332887201000062
						],
						[
							-82.51427598899994,
							27.332888875000037
						],
						[
							-82.51405999999992,
							27.332890000000077
						],
						[
							-82.5140251169999,
							27.33288984300009
						],
						[
							-82.5140098629999,
							27.330049901000052
						],
						[
							-82.51811810599992,
							27.330054871000073
						],
						[
							-82.52218611699993,
							27.33005972400008
						],
						[
							-82.5221864419999,
							27.330273084000055
						],
						[
							-82.52219109399994,
							27.33332852400008
						],
						[
							-82.52216999999992,
							27.333330000000046
						],
						[
							-82.52211530599993,
							27.33332911800005
						],
						[
							-82.52196777099994,
							27.33332673800004
						],
						[
							-82.52182959699991,
							27.333324510000068
						],
						[
							-82.52172826899994,
							27.33332287500008
						],
						[
							-82.52172825799994,
							27.333764080000037
						],
						[
							-82.51793175899991,
							27.333767280000075
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Paver Park",
				"RegionID": "343964"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.52420944999994,
					27.333764080000037,
					-82.5140291649999,
					27.33758038300005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.51404077899991,
							27.33758038300005
						],
						[
							-82.5140291649999,
							27.333829146000085
						],
						[
							-82.51414860999995,
							27.333828118000042
						],
						[
							-82.5144372929999,
							27.333823893000044
						],
						[
							-82.51495469399993,
							27.333816322000075
						],
						[
							-82.51531554799993,
							27.333811041000047
						],
						[
							-82.51565234499992,
							27.33380611200005
						],
						[
							-82.51583294799991,
							27.333803469000088
						],
						[
							-82.5160699999999,
							27.333800000000053
						],
						[
							-82.51642236599992,
							27.333800000000053
						],
						[
							-82.51674720399991,
							27.333800000000053
						],
						[
							-82.51727656999992,
							27.333800000000053
						],
						[
							-82.51778187399992,
							27.333800000000053
						],
						[
							-82.51793175899991,
							27.333767280000075
						],
						[
							-82.52172825799994,
							27.333764080000037
						],
						[
							-82.52169196499995,
							27.33559000000008
						],
						[
							-82.52198070999992,
							27.33559000000008
						],
						[
							-82.5221859699999,
							27.335596081000062
						],
						[
							-82.52415769999993,
							27.33559581500009
						],
						[
							-82.52420944999994,
							27.337528558000088
						],
						[
							-82.51404077899991,
							27.33758038300005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Ringling Park",
				"RegionID": "343965"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.54680626899994,
					27.33883138400006,
					-82.53861016699996,
					27.344975719000047
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.53862349199994,
							27.344907826000053
						],
						[
							-82.53861016699996,
							27.33887130700009
						],
						[
							-82.54062999999991,
							27.33886142500006
						],
						[
							-82.54677050599992,
							27.33883138400006
						],
						[
							-82.54680626899994,
							27.34397064400008
						],
						[
							-82.54664172199995,
							27.343969805000086
						],
						[
							-82.54654267199993,
							27.343969299000037
						],
						[
							-82.54637504999995,
							27.34396844400004
						],
						[
							-82.54632169699994,
							27.343968172000075
						],
						[
							-82.5462188379999,
							27.34396764700006
						],
						[
							-82.5460016909999,
							27.343966539000064
						],
						[
							-82.54576168599993,
							27.343965315000048
						],
						[
							-82.54568928499992,
							27.34396494500004
						],
						[
							-82.5454949949999,
							27.34396395400006
						],
						[
							-82.54523975299992,
							27.343962652000073
						],
						[
							-82.54506451099991,
							27.343961758000034
						],
						[
							-82.54500353799995,
							27.343961447000083
						],
						[
							-82.54487401199992,
							27.343960786000082
						],
						[
							-82.54471999999993,
							27.34396000000004
						],
						[
							-82.54471933799994,
							27.344020878000038
						],
						[
							-82.54471846899992,
							27.34410087200007
						],
						[
							-82.54471809599994,
							27.34413519700007
						],
						[
							-82.54471685399996,
							27.344249474000037
						],
						[
							-82.54471532199994,
							27.344390416000067
						],
						[
							-82.54471465899991,
							27.344451405000086
						],
						[
							-82.54471374799994,
							27.34453520900007
						],
						[
							-82.54471225799995,
							27.34467230000007
						],
						[
							-82.54471122199993,
							27.34476761400009
						],
						[
							-82.54471039299995,
							27.344843799000046
						],
						[
							-82.54470999999995,
							27.34488000000005
						],
						[
							-82.5447086829999,
							27.34489317100008
						],
						[
							-82.54470713599996,
							27.34490863600007
						],
						[
							-82.54470483499995,
							27.344931645000088
						],
						[
							-82.54470253499994,
							27.34495465400005
						],
						[
							-82.54470101599992,
							27.344975719000047
						],
						[
							-82.53862349199994,
							27.344907826000053
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Rosemary District",
				"RegionID": "343966"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.53862349199994,
					27.33887130700009,
					-82.53097360099991,
					27.344974395000065
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.53100380199993,
							27.338882169000044
						],
						[
							-82.53861016699996,
							27.33887130700009
						],
						[
							-82.53862349199994,
							27.344907826000053
						],
						[
							-82.53097360099991,
							27.344974395000065
						],
						[
							-82.53100380199993,
							27.338882169000044
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Original Gillespie Park",
				"RegionID": "343967"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.56592055599992,
					27.30907067800007,
					-82.55416345799995,
					27.330262322000067
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.55852111599995,
							27.324763244000053
						],
						[
							-82.55871302999992,
							27.323026135000077
						],
						[
							-82.55863569699994,
							27.323112999000045
						],
						[
							-82.5585420729999,
							27.323203920000083
						],
						[
							-82.5584731269999,
							27.32325632900006
						],
						[
							-82.55804212699991,
							27.323552330000044
						],
						[
							-82.55797659199993,
							27.323593308000056
						],
						[
							-82.55790778099993,
							27.32362850800007
						],
						[
							-82.55783620199992,
							27.323657669000056
						],
						[
							-82.5577623829999,
							27.323680576000072
						],
						[
							-82.55768686999994,
							27.323697061000075
						],
						[
							-82.5576102199999,
							27.32370700000007
						],
						[
							-82.55753299999992,
							27.323710322000068
						],
						[
							-82.55745699999994,
							27.323710322000068
						],
						[
							-82.55737928399992,
							27.32370695800006
						],
						[
							-82.55730214999994,
							27.323696890000065
						],
						[
							-82.55722617399994,
							27.323680194000076
						],
						[
							-82.55715192499991,
							27.323656996000068
						],
						[
							-82.55707995799992,
							27.32362746800004
						],
						[
							-82.55701081299992,
							27.323591831000044
						],
						[
							-82.55685507599992,
							27.323502834000067
						],
						[
							-82.55672492699995,
							27.32341192100006
						],
						[
							-82.5566590759999,
							27.323350807000054
						],
						[
							-82.55502307599994,
							27.321672807000084
						],
						[
							-82.55499786199994,
							27.321645862000082
						],
						[
							-82.55490986199993,
							27.321547862000045
						],
						[
							-82.55486341699992,
							27.321491722000076
						],
						[
							-82.55482166899992,
							27.321432006000066
						],
						[
							-82.55478489299993,
							27.321369107000066
						],
						[
							-82.55475332899994,
							27.32130343700004
						],
						[
							-82.55472718399994,
							27.32123542700009
						],
						[
							-82.55470663099993,
							27.321165524000037
						],
						[
							-82.55420063099992,
							27.319145524000078
						],
						[
							-82.55418734099993,
							27.319083165000052
						],
						[
							-82.55417445799992,
							27.31896443800008
						],
						[
							-82.55416345799995,
							27.318700438000064
						],
						[
							-82.55416358999992,
							27.318622511000058
						],
						[
							-82.55417046799994,
							27.318544888000076
						],
						[
							-82.55418403999994,
							27.318468151000047
						],
						[
							-82.55420420399992,
							27.318392878000054
						],
						[
							-82.55513820399995,
							27.31542687800004
						],
						[
							-82.55515448999995,
							27.315374741000085
						],
						[
							-82.5551751779999,
							27.31532419000007
						],
						[
							-82.55520011699991,
							27.31527559400007
						],
						[
							-82.55522912299995,
							27.315229312000042
						],
						[
							-82.55524234099994,
							27.31507283400009
						],
						[
							-82.55527530799992,
							27.314943175000053
						],
						[
							-82.55635130799993,
							27.311733175000086
						],
						[
							-82.55635891399993,
							27.31171141300007
						],
						[
							-82.5564251639999,
							27.311569339000073
						],
						[
							-82.55651507999995,
							27.311440927000035
						],
						[
							-82.55662592699991,
							27.311330079000072
						],
						[
							-82.55664628999995,
							27.311313493000057
						],
						[
							-82.55923828999994,
							27.309264493000057
						],
						[
							-82.55929916199995,
							27.309220378000077
						],
						[
							-82.55936350499991,
							27.309181502000058
						],
						[
							-82.55943086999991,
							27.30914813600009
						],
						[
							-82.55950078599994,
							27.30912051200005
						],
						[
							-82.55957276599992,
							27.309098824000046
						],
						[
							-82.55964630499994,
							27.309083224000062
						],
						[
							-82.55972088999994,
							27.309073820000037
						],
						[
							-82.55979599999995,
							27.30907067800007
						],
						[
							-82.55985099999992,
							27.30907067800007
						],
						[
							-82.56000716599993,
							27.309084340000084
						],
						[
							-82.56015858599994,
							27.309124913000062
						],
						[
							-82.56030066099993,
							27.309191164000083
						],
						[
							-82.56042907299991,
							27.309281079000073
						],
						[
							-82.56053992099993,
							27.309391926000046
						],
						[
							-82.56057701599991,
							27.309439264000048
						],
						[
							-82.56112601599995,
							27.310190264000084
						],
						[
							-82.56116503899995,
							27.310249188000057
						],
						[
							-82.56119964599992,
							27.31031081000009
						],
						[
							-82.56122964999992,
							27.310374799000044
						],
						[
							-82.56125489099992,
							27.31044081200008
						],
						[
							-82.56131505699994,
							27.31051402500009
						],
						[
							-82.56277605699995,
							27.31263002500009
						],
						[
							-82.5627979219999,
							27.312663239000074
						],
						[
							-82.56413792099994,
							27.31480023900008
						],
						[
							-82.56416684399994,
							27.314844366000045
						],
						[
							-82.56419138599995,
							27.31489107200008
						],
						[
							-82.56421131899992,
							27.314939922000065
						],
						[
							-82.56422645899994,
							27.31499046500005
						],
						[
							-82.56430692099993,
							27.315070927000082
						],
						[
							-82.56436749299992,
							27.315151968000066
						],
						[
							-82.56461949299995,
							27.315531969000062
						],
						[
							-82.56464883599995,
							27.315579339000067
						],
						[
							-82.5647120619999,
							27.31571322800005
						],
						[
							-82.56474657399991,
							27.315805320000038
						],
						[
							-82.5647707409999,
							27.315880794000066
						],
						[
							-82.56478816999993,
							27.31595810200008
						],
						[
							-82.56479872299991,
							27.316036645000054
						],
						[
							-82.56480232099995,
							27.316115812000078
						],
						[
							-82.5647989339999,
							27.316194988000063
						],
						[
							-82.5645950089999,
							27.318518147000077
						],
						[
							-82.56458919099992,
							27.31859594200006
						],
						[
							-82.5645858879999,
							27.31863003600006
						],
						[
							-82.56458020699995,
							27.31867423400007
						],
						[
							-82.5645103089999,
							27.319235091000053
						],
						[
							-82.56450365899991,
							27.31927916500007
						],
						[
							-82.56446308599993,
							27.319430586000067
						],
						[
							-82.5643968359999,
							27.319572661000056
						],
						[
							-82.56430692099993,
							27.31970107300009
						],
						[
							-82.56421374799993,
							27.319796694000047
						],
						[
							-82.56409274799995,
							27.31990369500005
						],
						[
							-82.56407507299991,
							27.319918921000067
						],
						[
							-82.56400583999994,
							27.319967398000074
						],
						[
							-82.56408925599993,
							27.319989390000046
						],
						[
							-82.56416758699993,
							27.320013913000086
						],
						[
							-82.56424626599994,
							27.320046855000047
						],
						[
							-82.56441026499994,
							27.320124855000074
						],
						[
							-82.56447366099992,
							27.320158164000077
						],
						[
							-82.56460207299995,
							27.320248079000066
						],
						[
							-82.56471291999992,
							27.320358927000086
						],
						[
							-82.5648028359999,
							27.320487339000067
						],
						[
							-82.56486908599993,
							27.320629413000063
						],
						[
							-82.56490965899991,
							27.32078083400006
						],
						[
							-82.56492175299991,
							27.320883904000084
						],
						[
							-82.56492610399994,
							27.32095746500005
						],
						[
							-82.56501292799993,
							27.321230137000047
						],
						[
							-82.5650315179999,
							27.32129745700007
						],
						[
							-82.56504482799994,
							27.32136601600007
						],
						[
							-82.56505277699995,
							27.321435401000087
						],
						[
							-82.5650553189999,
							27.321505194000054
						],
						[
							-82.5650524369999,
							27.321574974000043
						],
						[
							-82.56504143699993,
							27.32171197400004
						],
						[
							-82.56503849299992,
							27.321734973000048
						],
						[
							-82.56506708599994,
							27.321800413000062
						],
						[
							-82.56509560099994,
							27.321894454000073
						],
						[
							-82.56515269099992,
							27.32212840200009
						],
						[
							-82.5652287819999,
							27.322469350000063
						],
						[
							-82.56523665899994,
							27.322508835000065
						],
						[
							-82.56525032199994,
							27.322665000000086
						],
						[
							-82.56523665899994,
							27.32282116600004
						],
						[
							-82.5651960859999,
							27.32297258600005
						],
						[
							-82.56512983499995,
							27.32311466100009
						],
						[
							-82.56503991999995,
							27.32324307300007
						],
						[
							-82.56494465599991,
							27.323340538000082
						],
						[
							-82.56484565699992,
							27.32342753800009
						],
						[
							-82.56479135099994,
							27.323471639000047
						],
						[
							-82.5647337819999,
							27.323511385000074
						],
						[
							-82.5646732969999,
							27.323546537000084
						],
						[
							-82.5646102629999,
							27.323576880000076
						],
						[
							-82.56454506199992,
							27.32360223200004
						],
						[
							-82.56447808599995,
							27.323622439000076
						],
						[
							-82.56439870399993,
							27.323645841000086
						],
						[
							-82.56444607299994,
							27.32368407900009
						],
						[
							-82.5645232139999,
							27.323756985000045
						],
						[
							-82.56461290599992,
							27.323851697000066
						],
						[
							-82.56463329199994,
							27.323854915000084
						],
						[
							-82.5647921659999,
							27.323868341000036
						],
						[
							-82.56481473899993,
							27.323872619000042
						],
						[
							-82.56495773899991,
							27.323901619000086
						],
						[
							-82.56508658699994,
							27.323937914000055
						],
						[
							-82.56520127499994,
							27.32398898200006
						],
						[
							-82.5654212739999,
							27.32410598200005
						],
						[
							-82.56544866099995,
							27.324121164000076
						],
						[
							-82.56557707299993,
							27.324211079000065
						],
						[
							-82.5656879199999,
							27.324321927000085
						],
						[
							-82.56577783499995,
							27.324450339000066
						],
						[
							-82.56584408599991,
							27.32459241400005
						],
						[
							-82.56588465899995,
							27.324743834000063
						],
						[
							-82.56589073899994,
							27.324783465000053
						],
						[
							-82.56591373999993,
							27.324959465000063
						],
						[
							-82.56592055599992,
							27.325038884000037
						],
						[
							-82.56592031299994,
							27.32511859500005
						],
						[
							-82.5659130119999,
							27.32519797100008
						],
						[
							-82.56589871199992,
							27.325276389000067
						],
						[
							-82.56586671199994,
							27.325416389000054
						],
						[
							-82.56584889999993,
							27.32548259300006
						],
						[
							-82.56582609499992,
							27.325547248000078
						],
						[
							-82.56579843199995,
							27.325609977000056
						],
						[
							-82.56576606999994,
							27.325670417000083
						],
						[
							-82.56572919899992,
							27.325728217000062
						],
						[
							-82.56547419899994,
							27.326096216000053
						],
						[
							-82.5654258589999,
							27.326159756000038
						],
						[
							-82.56537207399992,
							27.32621875700005
						],
						[
							-82.56531326899994,
							27.326272757000083
						],
						[
							-82.5652499059999,
							27.326321328000063
						],
						[
							-82.56350111199993,
							27.327542574000063
						],
						[
							-82.5630980869999,
							27.32782105100006
						],
						[
							-82.56274750499995,
							27.32805484700009
						],
						[
							-82.56256293599995,
							27.32821864300007
						],
						[
							-82.56250832899991,
							27.328263398000047
						],
						[
							-82.56245037899993,
							27.32830373200005
						],
						[
							-82.5623894439999,
							27.328339395000057
						],
						[
							-82.56232589899992,
							27.32837016900004
						],
						[
							-82.5602648979999,
							27.32927016800005
						],
						[
							-82.56020181999992,
							27.329295451000064
						],
						[
							-82.56013687599994,
							27.32931546000009
						],
						[
							-82.56007050599993,
							27.329330059000085
						],
						[
							-82.56000316099994,
							27.329339150000067
						],
						[
							-82.55993529599994,
							27.329342671000063
						],
						[
							-82.55971710299991,
							27.329569337000066
						],
						[
							-82.55933423699992,
							27.329977925000037
						],
						[
							-82.55925607299991,
							27.330051920000074
						],
						[
							-82.55912766099993,
							27.330141835000063
						],
						[
							-82.55898558599995,
							27.330208086000084
						],
						[
							-82.55883416499995,
							27.330248659000066
						],
						[
							-82.55867799999993,
							27.330262322000067
						],
						[
							-82.55852183399992,
							27.330248659000066
						],
						[
							-82.55845850499992,
							27.33023512500006
						],
						[
							-82.55816050599992,
							27.330160125000077
						],
						[
							-82.55808884699991,
							27.33013888700009
						],
						[
							-82.55801919899994,
							27.330111773000056
						],
						[
							-82.55795204399993,
							27.330078969000056
						],
						[
							-82.55788784399994,
							27.330040703000066
						],
						[
							-82.55782704299992,
							27.329997237000043
						],
						[
							-82.55776577699993,
							27.32994946000008
						],
						[
							-82.55766351199992,
							27.32986868200004
						],
						[
							-82.55761073499991,
							27.329823573000056
						],
						[
							-82.55756159399994,
							27.32977452600005
						],
						[
							-82.55751638399994,
							27.329721835000043
						],
						[
							-82.55747537299993,
							27.329665813000076
						],
						[
							-82.55743880699993,
							27.329606794000085
						],
						[
							-82.55740690199991,
							27.32954513100009
						],
						[
							-82.55736090099992,
							27.32944713100005
						],
						[
							-82.55732991399992,
							27.32937258600009
						],
						[
							-82.55728934099994,
							27.32922116600008
						],
						[
							-82.55727567799994,
							27.32906500000007
						],
						[
							-82.55728934099994,
							27.32890883500005
						],
						[
							-82.55732991399992,
							27.32875741400005
						],
						[
							-82.55739519299993,
							27.328617026000074
						],
						[
							-82.5574761929999,
							27.32847602600009
						],
						[
							-82.55749630299994,
							27.328442710000047
						],
						[
							-82.55784067199994,
							27.327899137000088
						],
						[
							-82.55781703899993,
							27.32786629700007
						],
						[
							-82.55776816399992,
							27.32779066100005
						],
						[
							-82.55770191399995,
							27.32764858600007
						],
						[
							-82.55766134099991,
							27.327497166000057
						],
						[
							-82.55764767799991,
							27.327341000000047
						],
						[
							-82.55766134099991,
							27.327184834000036
						],
						[
							-82.55770246999992,
							27.327031893000083
						],
						[
							-82.55775602599994,
							27.326886373000036
						],
						[
							-82.55778634199993,
							27.32681393100006
						],
						[
							-82.55782286099992,
							27.32674441000006
						],
						[
							-82.55786530699993,
							27.326678340000058
						],
						[
							-82.55791335499993,
							27.326616225000066
						],
						[
							-82.55796663899991,
							27.326558539000075
						],
						[
							-82.55802475199995,
							27.326505722000036
						],
						[
							-82.55808725199995,
							27.326458176000074
						],
						[
							-82.55815366199994,
							27.326416264000045
						],
						[
							-82.55880411599992,
							27.32604805300008
						],
						[
							-82.5587074369999,
							27.32572286000004
						],
						[
							-82.5585903079999,
							27.32542826200006
						],
						[
							-82.55856567399991,
							27.325357954000083
						],
						[
							-82.55854694499993,
							27.325285848000078
						],
						[
							-82.55853424799994,
							27.32521243900004
						],
						[
							-82.55852766999993,
							27.32513823100004
						],
						[
							-82.5585166699999,
							27.324904231000062
						],
						[
							-82.55852111599995,
							27.324763244000053
						]
					],
					[
						[
							-82.56261717599995,
							27.32398670200007
						],
						[
							-82.56269138499995,
							27.323944278000056
						],
						[
							-82.5626114879999,
							27.32395824400004
						],
						[
							-82.56261717599995,
							27.32398670200007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Bird Key",
				"RegionID": "343981"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.57399732199991,
					27.319060832000048,
					-82.56623167799995,
					27.32536032200005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.56777307999994,
							27.319401927000058
						],
						[
							-82.56788392699991,
							27.31929107900004
						],
						[
							-82.56801233899995,
							27.31920116400005
						],
						[
							-82.56815441399993,
							27.319134913000084
						],
						[
							-82.56830583499993,
							27.31909434000005
						],
						[
							-82.56839904499992,
							27.319082884000068
						],
						[
							-82.56868404399995,
							27.31906288400006
						],
						[
							-82.56876366699993,
							27.319060832000048
						],
						[
							-82.56884315899993,
							27.319065833000085
						],
						[
							-82.56892189599995,
							27.319077848000063
						],
						[
							-82.56899926199992,
							27.319096782000088
						],
						[
							-82.5690746489999,
							27.319122488000062
						],
						[
							-82.56914746599995,
							27.319154763000085
						],
						[
							-82.56947555099993,
							27.31931792800009
						],
						[
							-82.56962699999991,
							27.319304678000037
						],
						[
							-82.56966049399995,
							27.319307608000088
						],
						[
							-82.5698374879999,
							27.31926818700009
						],
						[
							-82.56991163599992,
							27.319254905000037
						],
						[
							-82.56998663399993,
							27.31924787400004
						],
						[
							-82.57006195899993,
							27.319247144000087
						],
						[
							-82.57013707999994,
							27.319252721000055
						],
						[
							-82.57021146999995,
							27.319264565000083
						],
						[
							-82.57045347099995,
							27.319313564000083
						],
						[
							-82.57059107099991,
							27.319353870000043
						],
						[
							-82.57065941299994,
							27.319329913000047
						],
						[
							-82.57079319999991,
							27.319292631000053
						],
						[
							-82.57118919999995,
							27.31921463100008
						],
						[
							-82.57133816699991,
							27.31919802100009
						],
						[
							-82.57170016799995,
							27.31918802100006
						],
						[
							-82.57177756399994,
							27.319189037000058
						],
						[
							-82.57185455899992,
							27.31919696600005
						],
						[
							-82.57193053799995,
							27.319211745000075
						],
						[
							-82.57200489099995,
							27.319233256000075
						],
						[
							-82.57207702399995,
							27.31926132600006
						],
						[
							-82.57237498599994,
							27.319850555000073
						],
						[
							-82.57225299999993,
							27.32070200000004
						],
						[
							-82.57289999999995,
							27.321318000000076
						],
						[
							-82.57399344299995,
							27.32171266200004
						],
						[
							-82.57399732199991,
							27.321757000000048
						],
						[
							-82.57398365899992,
							27.32191316500007
						],
						[
							-82.57394308599993,
							27.322064586000067
						],
						[
							-82.57387683599991,
							27.322206661000052
						],
						[
							-82.57378692099991,
							27.32233507300009
						],
						[
							-82.57367607299994,
							27.322445920000064
						],
						[
							-82.5735476609999,
							27.322535835000053
						],
						[
							-82.57352605599993,
							27.322547916000076
						],
						[
							-82.56956761399994,
							27.32469028400004
						],
						[
							-82.56859806999995,
							27.325242469000045
						],
						[
							-82.56846058699995,
							27.325306087000058
						],
						[
							-82.56830916599995,
							27.325346660000037
						],
						[
							-82.56815299999994,
							27.32536032200005
						],
						[
							-82.56799683499992,
							27.325346660000037
						],
						[
							-82.56784541399992,
							27.325306087000058
						],
						[
							-82.56782651499992,
							27.325298966000048
						],
						[
							-82.56774951499995,
							27.325268966000067
						],
						[
							-82.5676263389999,
							27.325209835000067
						],
						[
							-82.56749924099995,
							27.325121021000086
						],
						[
							-82.56722807599994,
							27.32489436500009
						],
						[
							-82.56706998499995,
							27.324838722000038
						],
						[
							-82.56700701199992,
							27.324813473000063
						],
						[
							-82.56694612099994,
							27.324783547000038
						],
						[
							-82.5668876609999,
							27.324749115000092
						],
						[
							-82.5668319639999,
							27.324710372000084
						],
						[
							-82.56677934599993,
							27.324667540000064
						],
						[
							-82.5667463449999,
							27.32463854000008
						],
						[
							-82.56668108699995,
							27.32457505700006
						],
						[
							-82.56647208699991,
							27.32435005700006
						],
						[
							-82.5664420789999,
							27.32431607300009
						],
						[
							-82.56635216399991,
							27.324187661000057
						],
						[
							-82.56628591399993,
							27.324045586000068
						],
						[
							-82.5662453409999,
							27.32389416600006
						],
						[
							-82.56623167799995,
							27.32373800000005
						],
						[
							-82.56623286399991,
							27.32369183600008
						],
						[
							-82.5662438629999,
							27.323477836000052
						],
						[
							-82.56625633999994,
							27.323367835000056
						],
						[
							-82.56629691299992,
							27.323216414000058
						],
						[
							-82.56636316399995,
							27.323074339000073
						],
						[
							-82.56645307899993,
							27.322945927000035
						],
						[
							-82.56656392699995,
							27.32283508000006
						],
						[
							-82.56667227299994,
							27.322757099000057
						],
						[
							-82.5669100799999,
							27.322611443000085
						],
						[
							-82.56711542199992,
							27.322415061000072
						],
						[
							-82.56715892699992,
							27.322376079000037
						],
						[
							-82.56719310299991,
							27.32235214900004
						],
						[
							-82.56725242899995,
							27.322246711000048
						],
						[
							-82.56757056999993,
							27.319861119000052
						],
						[
							-82.56757634099995,
							27.31982383400009
						],
						[
							-82.56761691399994,
							27.319672413000035
						],
						[
							-82.5676831639999,
							27.31953033900004
						],
						[
							-82.56777307999994,
							27.319401927000058
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "John Ringling",
				"RegionID": "343982"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.58137167899991,
					27.312516206000055,
					-82.5666028679999,
					27.32381406900004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.57808452299992,
							27.323782674000086
						],
						[
							-82.57775823599991,
							27.32369374800004
						],
						[
							-82.57771096899995,
							27.32369860700004
						],
						[
							-82.57763884199994,
							27.323703103000074
						],
						[
							-82.57756658599993,
							27.323701794000044
						],
						[
							-82.57749466999991,
							27.323694687000057
						],
						[
							-82.57742355499994,
							27.32368182800008
						],
						[
							-82.57735370299991,
							27.323663301000067
						],
						[
							-82.5772855649999,
							27.32363922600007
						],
						[
							-82.57651950299993,
							27.323333396000066
						],
						[
							-82.57626860499994,
							27.323231733000057
						],
						[
							-82.57603076999993,
							27.323130899000034
						],
						[
							-82.57596361399993,
							27.32309897400006
						],
						[
							-82.57589929199992,
							27.323061669000083
						],
						[
							-82.57583823199991,
							27.323019232000036
						],
						[
							-82.57578084499994,
							27.322971948000088
						],
						[
							-82.57572751299995,
							27.322920133000082
						],
						[
							-82.57568095699992,
							27.32288326300005
						],
						[
							-82.57418120999995,
							27.321617492000087
						],
						[
							-82.57399344299995,
							27.32171266200004
						],
						[
							-82.57289999999995,
							27.321318000000076
						],
						[
							-82.57225299999993,
							27.32070200000004
						],
						[
							-82.57237498599994,
							27.319850555000073
						],
						[
							-82.57207702399995,
							27.31926132600006
						],
						[
							-82.57196611899991,
							27.319025595000085
						],
						[
							-82.57192027399992,
							27.31890691500007
						],
						[
							-82.5717914299999,
							27.318478001000074
						],
						[
							-82.57167041899993,
							27.318514419000053
						],
						[
							-82.57150274899993,
							27.31854935000007
						],
						[
							-82.57144449399993,
							27.318577963000052
						],
						[
							-82.57108149399994,
							27.318726962000085
						],
						[
							-82.57100931999992,
							27.318753048000076
						],
						[
							-82.57093518599993,
							27.318772885000044
						],
						[
							-82.57085962999992,
							27.31878633000008
						],
						[
							-82.5707832029999,
							27.318793283000048
						],
						[
							-82.57070646099993,
							27.318793696000057
						],
						[
							-82.57062996299993,
							27.318787565000036
						],
						[
							-82.57055696399993,
							27.31877856500006
						],
						[
							-82.57048732499993,
							27.318767191000063
						],
						[
							-82.57041879299993,
							27.318750392000084
						],
						[
							-82.57035178899991,
							27.318728272000044
						],
						[
							-82.57028672499992,
							27.31870096700004
						],
						[
							-82.57022400199992,
							27.318668645000063
						],
						[
							-82.5701640069999,
							27.31863150500004
						],
						[
							-82.56998179199991,
							27.31850856500006
						],
						[
							-82.56992940399994,
							27.318481405000057
						],
						[
							-82.56987914399991,
							27.31845048400004
						],
						[
							-82.56983128099995,
							27.318415969000057
						],
						[
							-82.56978607199994,
							27.318378043000052
						],
						[
							-82.5697679779999,
							27.318366481000055
						],
						[
							-82.56966542299995,
							27.31834105900009
						],
						[
							-82.56951942299992,
							27.318294060000085
						],
						[
							-82.56948741299993,
							27.318283087000054
						],
						[
							-82.5693520989999,
							27.318219988000067
						],
						[
							-82.56931141299992,
							27.318209087000074
						],
						[
							-82.5691622089999,
							27.318138632000057
						],
						[
							-82.56906207899993,
							27.318078427000046
						],
						[
							-82.5689479269999,
							27.31799692000004
						],
						[
							-82.5688715089999,
							27.31792478300008
						],
						[
							-82.5686425099999,
							27.317681784000058
						],
						[
							-82.56860807899994,
							27.317643073000056
						],
						[
							-82.5685181639999,
							27.317514661000075
						],
						[
							-82.56845191399992,
							27.31737258600009
						],
						[
							-82.56841134099994,
							27.31722116600008
						],
						[
							-82.56840032699995,
							27.317133978000072
						],
						[
							-82.56839603899994,
							27.317078236000043
						],
						[
							-82.56836382499995,
							27.31701494400005
						],
						[
							-82.56833683799994,
							27.316949252000086
						],
						[
							-82.5683152549999,
							27.316881592000072
						],
						[
							-82.56829921899993,
							27.316812407000043
						],
						[
							-82.56828883299994,
							27.316742151000085
						],
						[
							-82.56827883299991,
							27.316649152000082
						],
						[
							-82.56827427299993,
							27.316546191000043
						],
						[
							-82.56826688699994,
							27.316480909000063
						],
						[
							-82.56825688699992,
							27.31637790900004
						],
						[
							-82.5682529099999,
							27.316295804000053
						],
						[
							-82.56821878999995,
							27.316225821000046
						],
						[
							-82.56819125699991,
							27.31615299500004
						],
						[
							-82.56817054499993,
							27.31607794300004
						],
						[
							-82.56815682999991,
							27.316001303000064
						],
						[
							-82.56815022899991,
							27.31592372600005
						],
						[
							-82.56815079699993,
							27.31584587100008
						],
						[
							-82.56815852999995,
							27.31576839800005
						],
						[
							-82.56811991399991,
							27.315685586000086
						],
						[
							-82.56811308899997,
							27.31566011600006
						],
						[
							-82.56809316499994,
							27.315631661000054
						],
						[
							-82.56804374799992,
							27.315525686000058
						],
						[
							-82.5679830869999,
							27.315471478000067
						],
						[
							-82.5678723389999,
							27.315419836000046
						],
						[
							-82.5678095529999,
							27.31537587300005
						],
						[
							-82.56777541399993,
							27.315365086000043
						],
						[
							-82.56771158499993,
							27.315335322000067
						],
						[
							-82.56761599999993,
							27.315335322000067
						],
						[
							-82.56745983399992,
							27.315321660000052
						],
						[
							-82.56730841399991,
							27.315281087000074
						],
						[
							-82.56716633899993,
							27.315214836000056
						],
						[
							-82.56703792699994,
							27.315124921000063
						],
						[
							-82.56696524199992,
							27.315056722000065
						],
						[
							-82.56690324199992,
							27.31499172100007
						],
						[
							-82.56685056799995,
							27.31493132500009
						],
						[
							-82.56680347899993,
							27.314866479000045
						],
						[
							-82.56676235099991,
							27.314797699000056
						],
						[
							-82.56672750799993,
							27.31472553000009
						],
						[
							-82.56669922799995,
							27.314650546000053
						],
						[
							-82.5666472289999,
							27.314491546000056
						],
						[
							-82.5666267549999,
							27.314418712000077
						],
						[
							-82.56661247699992,
							27.31434441500005
						],
						[
							-82.56660449599991,
							27.314269180000053
						],
						[
							-82.5666028679999,
							27.314193541000066
						],
						[
							-82.56660760599993,
							27.314118033000057
						],
						[
							-82.56661867499992,
							27.314043190000064
						],
						[
							-82.56663599799992,
							27.31396954300004
						],
						[
							-82.56665945099991,
							27.31389761300005
						],
						[
							-82.5666885199999,
							27.313821432000054
						],
						[
							-82.56676705099994,
							27.31361805000006
						],
						[
							-82.56682716499995,
							27.31349233900005
						],
						[
							-82.5668824249999,
							27.313407941000037
						],
						[
							-82.56694442499992,
							27.31332394100008
						],
						[
							-82.5669790789999,
							27.313279927000053
						],
						[
							-82.56709241699991,
							27.31316733500006
						],
						[
							-82.5671293719999,
							27.31311273400007
						],
						[
							-82.56717037199991,
							27.313056734000043
						],
						[
							-82.56721783799992,
							27.312997342000074
						],
						[
							-82.56727015199994,
							27.312942171000092
						],
						[
							-82.56732693899994,
							27.312891617000048
						],
						[
							-82.56738779299991,
							27.312846040000068
						],
						[
							-82.56745227899995,
							27.312805766000054
						],
						[
							-82.56751993699993,
							27.312771083000086
						],
						[
							-82.5675902829999,
							27.312742238000055
						],
						[
							-82.56790415199993,
							27.312629563000087
						],
						[
							-82.56796260099992,
							27.312608526000076
						],
						[
							-82.56802264999993,
							27.312592619000043
						],
						[
							-82.56808384899995,
							27.312581961000035
						],
						[
							-82.56814573999992,
							27.31257663200006
						],
						[
							-82.56820785999992,
							27.31257667200009
						],
						[
							-82.56826974499995,
							27.312582080000084
						],
						[
							-82.56832523399993,
							27.312559275000073
						],
						[
							-82.56838243099992,
							27.31254117600008
						],
						[
							-82.56844093799992,
							27.31252790900004
						],
						[
							-82.56850034799993,
							27.31251956600005
						],
						[
							-82.56856024699994,
							27.312516206000055
						],
						[
							-82.56975133499992,
							27.313246193000055
						],
						[
							-82.5711762489999,
							27.314015194000035
						],
						[
							-82.5720357209999,
							27.314037812000038
						],
						[
							-82.57280472199994,
							27.31446754800004
						],
						[
							-82.57330230999992,
							27.314829431000078
						],
						[
							-82.57379989899994,
							27.314919901000053
						],
						[
							-82.5740939289999,
							27.314874666000037
						],
						[
							-82.5745462829999,
							27.31469372500004
						],
						[
							-82.57502125399992,
							27.31442231200009
						],
						[
							-82.57542837199992,
							27.314309224000056
						],
						[
							-82.5757676369999,
							27.314286606000053
						],
						[
							-82.5762426089999,
							27.31435445900007
						],
						[
							-82.5768306679999,
							27.314512783000055
						],
						[
							-82.57712469799992,
							27.314625872000082
						],
						[
							-82.57741872799994,
							27.31489728400004
						],
						[
							-82.57800678699995,
							27.31553057900004
						],
						[
							-82.57857222899992,
							27.316141256000037
						],
						[
							-82.5791602889999,
							27.31679716900004
						],
						[
							-82.57914999999991,
							27.31709600000005
						],
						[
							-82.57930399999992,
							27.31756500000006
						],
						[
							-82.5796126429999,
							27.31763402300004
						],
						[
							-82.58015546699994,
							27.31849349400005
						],
						[
							-82.58051734999992,
							27.319036319000077
						],
						[
							-82.58090184999992,
							27.319986261000054
						],
						[
							-82.5810827919999,
							27.320687409000072
						],
						[
							-82.58137167899991,
							27.32104449500008
						],
						[
							-82.58131124099992,
							27.32149228900005
						],
						[
							-82.58128661399991,
							27.321612336000044
						],
						[
							-82.58116390899994,
							27.32205478700007
						],
						[
							-82.5806078199999,
							27.322202794000077
						],
						[
							-82.58008761399992,
							27.322519441000054
						],
						[
							-82.57970311299994,
							27.322881324000036
						],
						[
							-82.57918780699994,
							27.323677419000035
						],
						[
							-82.57914216499996,
							27.32368665900009
						],
						[
							-82.57902206499995,
							27.323697167000034
						],
						[
							-82.57896638099993,
							27.32371724400008
						],
						[
							-82.57890945499992,
							27.323733470000036
						],
						[
							-82.57885155299994,
							27.323745768000038
						],
						[
							-82.57879294599991,
							27.32375408200005
						],
						[
							-82.5785934669999,
							27.323775711000053
						],
						[
							-82.57851609199992,
							27.32379290600005
						],
						[
							-82.5784446049999,
							27.323805787000083
						],
						[
							-82.57837231199996,
							27.323812857000064
						],
						[
							-82.57829968399994,
							27.32381406900004
						],
						[
							-82.57822719599994,
							27.323809417000067
						],
						[
							-82.5781553189999,
							27.32379892900008
						],
						[
							-82.57808452299992,
							27.323782674000086
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "St. Armands",
				"RegionID": "343983"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-117.06445435199993,
					32.74258312400008,
					-117.04913280799991,
					32.75544548100004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-117.04927949899992,
							32.743583105000084
						],
						[
							-117.04959457399991,
							32.74340563100009
						],
						[
							-117.05069183499991,
							32.74258312400008
						],
						[
							-117.05380892499994,
							32.74467306400004
						],
						[
							-117.05877287099992,
							32.74592761800006
						],
						[
							-117.05888551699992,
							32.74575239300009
						],
						[
							-117.06020000599995,
							32.746048105000064
						],
						[
							-117.06075204099994,
							32.74627653300007
						],
						[
							-117.06143732599992,
							32.74680953200004
						],
						[
							-117.06193225399994,
							32.74739963800005
						],
						[
							-117.0621226109999,
							32.747875531000034
						],
						[
							-117.06265560999992,
							32.75042631300005
						],
						[
							-117.06284596699994,
							32.75069281200007
						],
						[
							-117.06406425099995,
							32.75204434600005
						],
						[
							-117.06429267899995,
							32.752425060000064
						],
						[
							-117.06445435199993,
							32.75311326500008
						],
						[
							-117.05496363899995,
							32.75544548100004
						],
						[
							-117.05045723299993,
							32.75510499300009
						],
						[
							-117.04922727199994,
							32.75531818200005
						],
						[
							-117.04916395299995,
							32.75532868500005
						],
						[
							-117.04913280799991,
							32.75518737800007
						],
						[
							-117.04913338099995,
							32.75514495200008
						],
						[
							-117.04913427399994,
							32.75509087200004
						],
						[
							-117.04913949999991,
							32.75475600000004
						],
						[
							-117.04915331999992,
							32.75360548400005
						],
						[
							-117.04917099999994,
							32.75195300000007
						],
						[
							-117.04918542299994,
							32.751196693000054
						],
						[
							-117.04918665299995,
							32.75111399500008
						],
						[
							-117.04918699999992,
							32.75107836700005
						],
						[
							-117.04918699999992,
							32.750252000000046
						],
						[
							-117.04923199999992,
							32.74617800000004
						],
						[
							-117.04923199999992,
							32.74614000000008
						],
						[
							-117.04924799999992,
							32.74544100000009
						],
						[
							-117.04926299999993,
							32.744755000000055
						],
						[
							-117.04926299999993,
							32.74433900000008
						],
						[
							-117.04926610799993,
							32.744236440000066
						],
						[
							-117.04926799999993,
							32.744174000000044
						],
						[
							-117.04927099999992,
							32.744053000000065
						],
						[
							-117.04927949899992,
							32.743583105000084
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pasco",
				"City": "San Diego",
				"Name": "Rolando Park",
				"RegionID": "737815"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.70728446499993,
					28.251529110000035,
					-82.70060531799993,
					28.259259979000035
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.70722285999994,
							28.251536090000062
						],
						[
							-82.70728446499993,
							28.25441539700006
						],
						[
							-82.70725591099995,
							28.259259979000035
						],
						[
							-82.70717025099992,
							28.259259979000035
						],
						[
							-82.70645879199992,
							28.259259979000035
						],
						[
							-82.70647306899991,
							28.258667493000075
						],
						[
							-82.70368196099992,
							28.258688909000057
						],
						[
							-82.70368909899992,
							28.257846579000045
						],
						[
							-82.7052309899999,
							28.257860856000036
						],
						[
							-82.7052309899999,
							28.25702566500007
						],
						[
							-82.70316799699992,
							28.25702566500007
						],
						[
							-82.70316799699992,
							28.257853718000035
						],
						[
							-82.70214006999993,
							28.257853718000035
						],
						[
							-82.70214006999993,
							28.25861752500009
						],
						[
							-82.70111928199994,
							28.25861752500009
						],
						[
							-82.70111928199994,
							28.25429166500004
						],
						[
							-82.70060531799993,
							28.25429166500004
						],
						[
							-82.70060531799993,
							28.253406505000044
						],
						[
							-82.70111928199994,
							28.253406505000044
						],
						[
							-82.70111928199994,
							28.253306568000085
						],
						[
							-82.70215434699992,
							28.253299429000037
						],
						[
							-82.70216148499992,
							28.251536249000083
						],
						[
							-82.7031894129999,
							28.251529110000035
						],
						[
							-82.70318227399991,
							28.25242854700008
						],
						[
							-82.70272541799994,
							28.25242854700008
						],
						[
							-82.70272541799994,
							28.25286398800006
						],
						[
							-82.70316799699992,
							28.25286398800006
						],
						[
							-82.70316799699992,
							28.255148271000053
						],
						[
							-82.7052309899999,
							28.255155409000054
						],
						[
							-82.7052238519999,
							28.25653311700006
						],
						[
							-82.70653017599996,
							28.25653311700006
						],
						[
							-82.70656586799993,
							28.25702566500007
						],
						[
							-82.70717976899994,
							28.25702566500007
						],
						[
							-82.70718690699994,
							28.255619404000072
						],
						[
							-82.70623750199991,
							28.255619404000072
						],
						[
							-82.70623750199991,
							28.254877012000065
						],
						[
							-82.70678001899996,
							28.254877012000065
						],
						[
							-82.70678715799994,
							28.25462003000007
						],
						[
							-82.70720118399993,
							28.25462003000007
						],
						[
							-82.70719404499995,
							28.254405879000046
						],
						[
							-82.70673718899991,
							28.254405879000046
						],
						[
							-82.70673718899991,
							28.254263111000057
						],
						[
							-82.70627319399995,
							28.254263111000057
						],
						[
							-82.7062589169999,
							28.25353499600004
						],
						[
							-82.70640882299995,
							28.25353499600004
						],
						[
							-82.70640882299995,
							28.253278014000045
						],
						[
							-82.70419592499991,
							28.25329229100004
						],
						[
							-82.70420306299991,
							28.251557664000075
						],
						[
							-82.70722285999994,
							28.251536090000062
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pasco",
				"City": "New Port Richey",
				"Name": "Jasmine Hills",
				"RegionID": "737817"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.7173694039999,
					28.237389094000036,
					-82.70996690099992,
					28.24156504800004
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-82.71135888499992,
								28.23950205500006
							],
							[
								-82.71118756399994,
								28.239423533000036
							],
							[
								-82.71094485899994,
								28.239480640000068
							],
							[
								-82.71049514099991,
								28.239487779000058
							],
							[
								-82.71042375699994,
								28.239266489000045
							],
							[
								-82.71025243599992,
								28.23919510500008
							],
							[
								-82.70996690099992,
								28.23915941300004
							],
							[
								-82.70996690099992,
								28.23884122000004
							],
							[
								-82.70996690099992,
								28.237389094000036
							],
							[
								-82.71248674999993,
								28.238402744000044
							],
							[
								-82.71249388799993,
								28.238838186000066
							],
							[
								-82.71256527199995,
								28.23885960100006
							],
							[
								-82.71256527199995,
								28.239187966000088
							],
							[
								-82.71245105799994,
								28.23923079700006
							],
							[
								-82.7121583839999,
								28.239623408000057
							],
							[
								-82.71184429599992,
								28.239901805000045
							],
							[
								-82.71146596099993,
								28.239659100000043
							],
							[
								-82.71135888499992,
								28.23950205500006
							]
						]
					],
					[
						[
							[
								-82.71310065099993,
								28.23885960100006
							],
							[
								-82.71310065099993,
								28.238502682000046
							],
							[
								-82.7134218779999,
								28.238502682000046
							],
							[
								-82.71392156499991,
								28.23885960100006
							],
							[
								-82.71540349299994,
								28.23884104100006
							],
							[
								-82.71736936699996,
								28.238842221000084
							],
							[
								-82.7173694039999,
								28.240579951000086
							],
							[
								-82.71701248499994,
								28.240579951000086
							],
							[
								-82.7168483019999,
								28.240865487000065
							],
							[
								-82.71645569099991,
								28.241029669000056
							],
							[
								-82.71611304899994,
								28.241436557000043
							],
							[
								-82.71602024999993,
								28.24153649500005
							],
							[
								-82.71588461999994,
								28.24156504800004
							],
							[
								-82.71572757599995,
								28.24154363300005
							],
							[
								-82.71560622299997,
								28.241465111000082
							],
							[
								-82.7154491789999,
								28.241422280000055
							],
							[
								-82.71447835899994,
								28.24061564300007
							],
							[
								-82.71425706899993,
								28.24033724600008
							],
							[
								-82.71397153399994,
								28.240101680000066
							],
							[
								-82.71370741399994,
								28.239651961000053
							],
							[
								-82.71360747599994,
								28.239423533000036
							],
							[
								-82.71334335599994,
								28.23923079700006
							],
							[
								-82.71311492799992,
								28.239152275000038
							],
							[
								-82.71288649899992,
								28.239123721000055
							],
							[
								-82.71270090099995,
								28.239109444000064
							],
							[
								-82.71270090099995,
								28.23885960100006
							],
							[
								-82.71310065099993,
								28.23885960100006
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pasco",
				"City": "New Port Richey",
				"Name": "Le Clair",
				"RegionID": "737822"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.72947324599994,
					28.22612520100006,
					-82.72330568299992,
					28.23885769700007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.7274031149999,
							28.23885769700007
						],
						[
							-82.72660361599992,
							28.238824385000044
						],
						[
							-82.7233342369999,
							28.238845800000036
						],
						[
							-82.72331995999991,
							28.23799633200008
						],
						[
							-82.72330568299992,
							28.235390823000046
						],
						[
							-82.72334851399995,
							28.235390823000046
						],
						[
							-82.72334851399995,
							28.235019627000042
						],
						[
							-82.72340562099993,
							28.234434279000084
						],
						[
							-82.72345558899991,
							28.23417015900009
						],
						[
							-82.7234627279999,
							28.23387034700005
						],
						[
							-82.72345558899991,
							28.233020879000037
						],
						[
							-82.72343417399992,
							28.227959766000083
						],
						[
							-82.72488326599995,
							28.227974043000074
						],
						[
							-82.72489040399995,
							28.227210236000076
						],
						[
							-82.72376967799994,
							28.227217374000077
						],
						[
							-82.72376253999994,
							28.227096022000072
						],
						[
							-82.72471194499991,
							28.22711029800007
						],
						[
							-82.72469766799992,
							28.22695325400008
						],
						[
							-82.72374826299995,
							28.22693897700009
						],
						[
							-82.7237268479999,
							28.22663916500005
						],
						[
							-82.72419798099992,
							28.22663916500005
						],
						[
							-82.72416942799993,
							28.22613947800005
						],
						[
							-82.7276529589999,
							28.22612520100006
						],
						[
							-82.72768151199995,
							28.228909171000055
						],
						[
							-82.72861663999993,
							28.228887756000063
						],
						[
							-82.72865449199992,
							28.23103586800005
						],
						[
							-82.72866422899996,
							28.231588444000067
						],
						[
							-82.72853335899993,
							28.231862082000077
						],
						[
							-82.72856905099991,
							28.23223089800007
						],
						[
							-82.72947324599994,
							28.23218330900005
						],
						[
							-82.72812885099995,
							28.234907792000058
						],
						[
							-82.72792154899992,
							28.23545506800008
						],
						[
							-82.72783141799994,
							28.23569301400005
						],
						[
							-82.72751019099991,
							28.236823258000072
						],
						[
							-82.7274031149999,
							28.237632275000067
						],
						[
							-82.72736742299992,
							28.238179551000087
						],
						[
							-82.7274031149999,
							28.23885769700007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pasco",
				"City": "New Port Richey",
				"Name": "The Heights",
				"RegionID": "737824"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.1366074259999,
					26.24949107000009,
					-80.12721090399992,
					26.260643258000073
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.12721090399992,
							26.24966416400008
						],
						[
							-80.13082114699995,
							26.24956525300007
						],
						[
							-80.1342335679999,
							26.24949107000009
						],
						[
							-80.13659440299995,
							26.249491096000042
						],
						[
							-80.1366074259999,
							26.253645322000068
						],
						[
							-80.13658269899992,
							26.255128983000077
						],
						[
							-80.13628596599995,
							26.256464279000056
						],
						[
							-80.13561831899995,
							26.257725391000065
						],
						[
							-80.13435720599995,
							26.259233780000045
						],
						[
							-80.13299718299993,
							26.260569075000035
						],
						[
							-80.12738399799991,
							26.260643258000073
						],
						[
							-80.12726035899993,
							26.256736283000066
						],
						[
							-80.12758181899994,
							26.255722448000085
						],
						[
							-80.12755709099991,
							26.251963839000044
						],
						[
							-80.12721090399992,
							26.25114782500009
						],
						[
							-80.12721090399992,
							26.24966416400008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Pompano Beach",
				"Name": "Liberty Park",
				"RegionID": "738040"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.1684748909999,
					26.234159901000055,
					-80.13299718299993,
					26.27487668300006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.1342953919999,
							26.27485800000005
						],
						[
							-80.13734925699993,
							26.260420709000073
						],
						[
							-80.13299718299993,
							26.260569075000035
						],
						[
							-80.13435720599995,
							26.259233780000045
						],
						[
							-80.13561831899995,
							26.257725391000065
						],
						[
							-80.13628596599995,
							26.256464279000056
						],
						[
							-80.13658269899992,
							26.255128983000077
						],
						[
							-80.1366074259999,
							26.253645322000068
						],
						[
							-80.13659440299995,
							26.249491096000042
						],
						[
							-80.13658269899992,
							26.245757188000084
						],
						[
							-80.13653324299992,
							26.234159901000055
						],
						[
							-80.1371019799999,
							26.234382451000045
						],
						[
							-80.15159240699995,
							26.243556424000076
						],
						[
							-80.15344698399991,
							26.244520804000047
						],
						[
							-80.1550542839999,
							26.245040085000085
						],
						[
							-80.15700777099994,
							26.245336818000055
						],
						[
							-80.15762596399992,
							26.245386273000065
						],
						[
							-80.1641851089999,
							26.24513636100005
						],
						[
							-80.16425893899992,
							26.245136040000094
						],
						[
							-80.1642648909999,
							26.245303679000074
						],
						[
							-80.1643378629999,
							26.249463089000074
						],
						[
							-80.16433575199994,
							26.24946644000005
						],
						[
							-80.16434117599994,
							26.249467740000057
						],
						[
							-80.16441312699993,
							26.249470402000043
						],
						[
							-80.16500208199994,
							26.249474579000037
						],
						[
							-80.16507432799995,
							26.249475656000072
						],
						[
							-80.16507749399995,
							26.249480405000043
						],
						[
							-80.16610029499992,
							26.25101427800007
						],
						[
							-80.16610389099992,
							26.25101967900008
						],
						[
							-80.16626389099993,
							26.25462667900007
						],
						[
							-80.1668988909999,
							26.25995767900008
						],
						[
							-80.16694189099991,
							26.26032167900007
						],
						[
							-80.16757753099995,
							26.262621039000067
						],
						[
							-80.16758346899991,
							26.262642520000043
						],
						[
							-80.16797689099991,
							26.264065679000055
						],
						[
							-80.16820889099995,
							26.269586679000042
						],
						[
							-80.16826089099993,
							26.271295679000048
						],
						[
							-80.1678688909999,
							26.27132067900004
						],
						[
							-80.16744089099991,
							26.271502679000037
						],
						[
							-80.16697689099993,
							26.27188667900009
						],
						[
							-80.16672789099994,
							26.273328679000088
						],
						[
							-80.16679830099991,
							26.274004025000067
						],
						[
							-80.16679976499995,
							26.274009291000084
						],
						[
							-80.16687073599991,
							26.274008436000088
						],
						[
							-80.16840107799993,
							26.27398195600006
						],
						[
							-80.16846947499994,
							26.273980773000062
						],
						[
							-80.1684748909999,
							26.27398067900009
						],
						[
							-80.1684746599999,
							26.27398551400006
						],
						[
							-80.16846589099993,
							26.27416867900007
						],
						[
							-80.16839207999993,
							26.274170048000087
						],
						[
							-80.16374080499992,
							26.274256345000087
						],
						[
							-80.16366794599992,
							26.274257703000046
						],
						[
							-80.16359510099994,
							26.274259571000073
						],
						[
							-80.15984078299994,
							26.27435583600004
						],
						[
							-80.1597679429999,
							26.274357705000057
						],
						[
							-80.15969510499991,
							26.274359652000044
						],
						[
							-80.15890577899995,
							26.274380757000074
						],
						[
							-80.15883294199995,
							26.27438270500005
						],
						[
							-80.15876010499994,
							26.27438464800008
						],
						[
							-80.15819377899993,
							26.27439976100004
						],
						[
							-80.15812094199993,
							26.27440170500006
						],
						[
							-80.1580481069999,
							26.274403692000078
						],
						[
							-80.1561407769999,
							26.27445571800007
						],
						[
							-80.15606791899995,
							26.27445767900008
						],
						[
							-80.15600682799993,
							26.27445767900008
						],
						[
							-80.15599506099994,
							26.27445767900008
						],
						[
							-80.15424082999994,
							26.27445767900008
						],
						[
							-80.15416889099993,
							26.27445767900008
						],
						[
							-80.15230289099992,
							26.274550679000072
						],
						[
							-80.15216889099992,
							26.274557679000058
						],
						[
							-80.15209507299994,
							26.274558797000054
						],
						[
							-80.14564081299994,
							26.274656589000074
						],
						[
							-80.1455679369999,
							26.274657679000086
						],
						[
							-80.14551624199993,
							26.274657679000086
						],
						[
							-80.1454950609999,
							26.274657679000086
						],
						[
							-80.14354082999995,
							26.274657679000086
						],
						[
							-80.14346889099994,
							26.274657679000086
						],
						[
							-80.14339506099992,
							26.274657679000086
						],
						[
							-80.14234082999991,
							26.274657679000086
						],
						[
							-80.1422688909999,
							26.274657679000086
						],
						[
							-80.13596789099995,
							26.274857679000036
						],
						[
							-80.13589406099993,
							26.274857679000036
						],
						[
							-80.13457382999991,
							26.274857679000036
						],
						[
							-80.1345018909999,
							26.274857679000036
						],
						[
							-80.1344398299999,
							26.274857679000036
						],
						[
							-80.13442806099994,
							26.274857679000036
						],
						[
							-80.13436766699994,
							26.274858067000082
						],
						[
							-80.13429295599991,
							26.27487668300006
						],
						[
							-80.1342953919999,
							26.27485800000005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Pompano Beach",
				"Name": "Northwest Pompano",
				"RegionID": "738042"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.42609599999992,
					28.032660428000042,
					-82.39751599999994,
					28.06923201500007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.4021709999999,
							28.06911500000007
						],
						[
							-82.40229599999992,
							28.06901400000004
						],
						[
							-82.4021699999999,
							28.06896900000004
						],
						[
							-82.4022609999999,
							28.068936000000065
						],
						[
							-82.40238199999993,
							28.06634900000006
						],
						[
							-82.40236562899992,
							28.06504528800008
						],
						[
							-82.40236202199992,
							28.064758072000075
						],
						[
							-82.4023128259999,
							28.06084041200006
						],
						[
							-82.40229999999991,
							28.05981900000006
						],
						[
							-82.40199999999993,
							28.056554000000066
						],
						[
							-82.4019889999999,
							28.05637900000005
						],
						[
							-82.4017849999999,
							28.056400000000053
						],
						[
							-82.4013149999999,
							28.056411000000086
						],
						[
							-82.4006839999999,
							28.05639300000007
						],
						[
							-82.40067699999992,
							28.055821000000037
						],
						[
							-82.40071999999992,
							28.054846000000055
						],
						[
							-82.39987799999996,
							28.054820000000067
						],
						[
							-82.39817835699995,
							28.054821445000073
						],
						[
							-82.39756449599992,
							28.054821966000077
						],
						[
							-82.39752499999992,
							28.05482200000006
						],
						[
							-82.39751599999994,
							28.054432000000077
						],
						[
							-82.39751636699992,
							28.05439059500009
						],
						[
							-82.39754799999992,
							28.050823000000037
						],
						[
							-82.39754899999991,
							28.05073500000009
						],
						[
							-82.39756653899991,
							28.048840727000083
						],
						[
							-82.39756681099993,
							28.048811430000057
						],
						[
							-82.3975759999999,
							28.04781900000006
						],
						[
							-82.39758199999994,
							28.04708600000004
						],
						[
							-82.39757715199994,
							28.046987458000046
						],
						[
							-82.39754199999993,
							28.046273000000042
						],
						[
							-82.3975989999999,
							28.04559500000005
						],
						[
							-82.39761099999993,
							28.04491100000007
						],
						[
							-82.39763499999992,
							28.044237000000066
						],
						[
							-82.39760099999995,
							28.043512000000078
						],
						[
							-82.39758309699995,
							28.039854842000068
						],
						[
							-82.39758299999995,
							28.03983500000004
						],
						[
							-82.3975829929999,
							28.03982681300005
						],
						[
							-82.39757999999995,
							28.036222000000066
						],
						[
							-82.39757510999993,
							28.03370478900007
						],
						[
							-82.39757506299992,
							28.033680913000072
						],
						[
							-82.39759076299993,
							28.032660428000042
						],
						[
							-82.39820908999991,
							28.03270000000009
						],
						[
							-82.42601823699994,
							28.032709091000072
						],
						[
							-82.42598657899993,
							28.03989996900009
						],
						[
							-82.42592272299993,
							28.05443794000007
						],
						[
							-82.42609599999992,
							28.054909000000066
						],
						[
							-82.4258979999999,
							28.054905000000076
						],
						[
							-82.42558999999994,
							28.054901000000086
						],
						[
							-82.42577999999992,
							28.05702100000008
						],
						[
							-82.42588499999994,
							28.05882900000006
						],
						[
							-82.42561899999993,
							28.06559400000009
						],
						[
							-82.42535199999992,
							28.067372000000034
						],
						[
							-82.42535199999992,
							28.067531000000088
						],
						[
							-82.42535299999992,
							28.068613000000084
						],
						[
							-82.42535399999991,
							28.06917400000009
						],
						[
							-82.42451499999993,
							28.06917700000008
						],
						[
							-82.42292869899991,
							28.06916723800009
						],
						[
							-82.42288999999994,
							28.06916700000005
						],
						[
							-82.42286647899994,
							28.069166832000064
						],
						[
							-82.42149199999994,
							28.069157000000075
						],
						[
							-82.42092299999992,
							28.06915900000007
						],
						[
							-82.42049999999996,
							28.069146000000046
						],
						[
							-82.41897499999993,
							28.06913800000007
						],
						[
							-82.4183119999999,
							28.069135000000074
						],
						[
							-82.41397799999993,
							28.069113000000073
						],
						[
							-82.41316399999994,
							28.069105000000036
						],
						[
							-82.41279899999995,
							28.069113000000073
						],
						[
							-82.4120759999999,
							28.06912900000009
						],
						[
							-82.40985299999994,
							28.069091000000075
						],
						[
							-82.40985404599991,
							28.06915292800005
						],
						[
							-82.40231858899995,
							28.069015320000066
						],
						[
							-82.40230909099995,
							28.06912727300005
						],
						[
							-82.40229999799993,
							28.06916363600004
						],
						[
							-82.40229103099995,
							28.06922741300008
						],
						[
							-82.40207516399995,
							28.06923201500007
						],
						[
							-82.4021709999999,
							28.06911500000007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Terrace Park",
				"RegionID": "275682"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.44259007141925,
					28.039499862445126,
					-82.42592272311096,
					28.05521799973393
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.43227899991301,
							28.05521799973393
						],
						[
							-82.43058600011248,
							28.054907999833155
						],
						[
							-82.42609599998292,
							28.054908999879245
						],
						[
							-82.42592272311096,
							28.054437940396177
						],
						[
							-82.4259865794716,
							28.039899969017355
						],
						[
							-82.43019997242666,
							28.039899969017355
						],
						[
							-82.43762009592807,
							28.03990011830478
						],
						[
							-82.43771987660655,
							28.039499862445126
						],
						[
							-82.43849998630633,
							28.039589969116584
						],
						[
							-82.43906999459489,
							28.03976756093561
						],
						[
							-82.4395200054458,
							28.039990063997543
						],
						[
							-82.44259007141925,
							28.039950011791632
						],
						[
							-82.4425800241935,
							28.042699997363695
						],
						[
							-82.4425700309272,
							28.043499973087044
						],
						[
							-82.4425499688513,
							28.047179997931636
						],
						[
							-82.4425234388515,
							28.05497645802471
						],
						[
							-82.44085779642707,
							28.054992519916084
						],
						[
							-82.44080800006705,
							28.05499300015407
						],
						[
							-82.43984164347293,
							28.054946982745165
						],
						[
							-82.43872899956037,
							28.054894000087167
						],
						[
							-82.43746399970414,
							28.054806999673986
						],
						[
							-82.43697299955372,
							28.054756000021037
						],
						[
							-82.43455899979257,
							28.05478999978973
						],
						[
							-82.43227899991301,
							28.05521799973393
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "University Square",
				"RegionID": "275825"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.47884350299995,
					27.950099868000052,
					-82.4644017139999,
					27.956661636000035
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.46440469899996,
							27.95664670900004
						],
						[
							-82.46469065299995,
							27.95531225800005
						],
						[
							-82.4650719249999,
							27.953620365000063
						],
						[
							-82.4652863899999,
							27.952667186000042
						],
						[
							-82.46538170799994,
							27.951904642000045
						],
						[
							-82.46523873099994,
							27.951237417000073
						],
						[
							-82.4650719249999,
							27.950641680000047
						],
						[
							-82.46503574099995,
							27.950561272000073
						],
						[
							-82.46558567699992,
							27.950569881000035
						],
						[
							-82.46751820399993,
							27.95060013300008
						],
						[
							-82.46841818199994,
							27.950300001000073
						],
						[
							-82.46921818499993,
							27.950100002000056
						],
						[
							-82.47884350299995,
							27.950099868000052
						],
						[
							-82.47875569799993,
							27.956324776000088
						],
						[
							-82.47054420899991,
							27.95628550200007
						],
						[
							-82.46841818199994,
							27.95620000100007
						],
						[
							-82.46495587999993,
							27.956599444000062
						],
						[
							-82.46489778099993,
							27.95660614700006
						],
						[
							-82.4644017139999,
							27.956661636000035
						],
						[
							-82.46440469899996,
							27.95664670900004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "West Riverfront",
				"RegionID": "275984"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.10748999399993,
					26.204214455000056,
					-80.0990211539999,
					26.209031107000044
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.10542590899992,
							26.207801895000046
						],
						[
							-80.1062800819999,
							26.204214455000056
						],
						[
							-80.10748999399993,
							26.204282422000063
						],
						[
							-80.10635829299991,
							26.208817406000037
						],
						[
							-80.09942775999991,
							26.209019264000066
						],
						[
							-80.0990211539999,
							26.209031107000044
						],
						[
							-80.0992891379999,
							26.20790892200006
						],
						[
							-80.09961521799994,
							26.20790323500006
						],
						[
							-80.10542590899992,
							26.207801895000046
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Bay Colony Club",
				"RegionID": "276200"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.36444398367391,
					28.545793068460537,
					-81.35192235973389,
					28.55319510030062
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.35200602815885,
							28.553187090039273
						],
						[
							-81.3519415314809,
							28.547659878430963
						],
						[
							-81.35192235973389,
							28.545944346116976
						],
						[
							-81.35290487084954,
							28.545932329376043
						],
						[
							-81.35293691729078,
							28.545932329376043
						],
						[
							-81.35314422540766,
							28.54592932384182
						],
						[
							-81.35393239483143,
							28.545917307100886
						],
						[
							-81.35511514899015,
							28.54590528946058
						],
						[
							-81.35603551335628,
							28.545896275555933
						],
						[
							-81.35811359475578,
							28.545869235640474
						],
						[
							-81.3586624096215,
							28.54586022263502
						],
						[
							-81.35889976138944,
							28.54585721800017
						],
						[
							-81.3591481298522,
							28.54585621615543
						],
						[
							-81.35967390948342,
							28.54585521520997
						],
						[
							-81.36021170675495,
							28.545837188299956
						],
						[
							-81.3622387138578,
							28.54581315212007
						],
						[
							-81.36329727883881,
							28.54580219028383
						],
						[
							-81.36406842589516,
							28.54579512520997
						],
						[
							-81.36439288779357,
							28.545793068460537
						],
						[
							-81.3643608611374,
							28.545969384141607
						],
						[
							-81.36435084538802,
							28.54614163938377
						],
						[
							-81.36434984354328,
							28.546746536870536
						],
						[
							-81.36434784165246,
							28.547644869645545
						],
						[
							-81.36436887229813,
							28.548590271137037
						],
						[
							-81.36439390942338,
							28.549494612282565
						],
						[
							-81.36440091963854,
							28.550438011883138
						],
						[
							-81.36441394002296,
							28.55129928809402
						],
						[
							-81.36444398367391,
							28.55226171644943
						],
						[
							-81.36444398367391,
							28.553103964804755
						],
						[
							-81.36443798879331,
							28.55315403995474
						],
						[
							-81.36267536078336,
							28.55314402420527
						],
						[
							-81.36028481534069,
							28.553124996349794
						],
						[
							-81.35902895259615,
							28.553112977810212
						],
						[
							-81.35823677759215,
							28.553120989870116
						],
						[
							-81.35812060587031,
							28.553121992614223
						],
						[
							-81.35722327404066,
							28.553128000984735
						],
						[
							-81.3564521314809,
							28.55314001862495
						],
						[
							-81.35615569155763,
							28.553145026050004
						],
						[
							-81.35566195926693,
							28.55315203626526
						],
						[
							-81.35560086922084,
							28.553154039055457
						],
						[
							-81.35555780428611,
							28.553154039055457
						],
						[
							-81.35406859625348,
							28.55318107897083
						],
						[
							-81.35276466294789,
							28.55319510030062
						],
						[
							-81.35200602815885,
							28.553187090039273
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Colonialtown South",
				"RegionID": "276268"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.37280050555388,
					28.520117911057184,
					-81.35982513587855,
					28.530996199356494
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.36822959791803,
							28.52837328888652
						],
						[
							-81.36821169331569,
							28.52763905989869
						],
						[
							-81.36698675465861,
							28.527772396980062
						],
						[
							-81.36596223711021,
							28.52777239787943
						],
						[
							-81.36505789236739,
							28.5278324851815
						],
						[
							-81.36451506069115,
							28.527772312443776
						],
						[
							-81.36367181588703,
							28.52777252828108
						],
						[
							-81.36282758722459,
							28.52740985868637
						],
						[
							-81.36204542707061,
							28.52692814583454
						],
						[
							-81.36150262507208,
							28.526626697586927
						],
						[
							-81.36089979422727,
							28.52602368957585
						],
						[
							-81.36035692208164,
							28.525843536487578
						],
						[
							-81.35990632487275,
							28.52567036303769
						],
						[
							-81.35986419163568,
							28.52558214943913
						],
						[
							-81.3598350176291,
							28.525521083674683
						],
						[
							-81.35982513587855,
							28.52539086274411
						],
						[
							-81.35986218884548,
							28.525173543374418
						],
						[
							-81.35990019149645,
							28.524934176225734
						],
						[
							-81.36120117412644,
							28.52512046448895
						],
						[
							-81.36216562235919,
							28.525301684173094
						],
						[
							-81.36318912277427,
							28.525843536487578
						],
						[
							-81.36415353953068,
							28.526325434599663
						],
						[
							-81.36578112534471,
							28.525783559802093
						],
						[
							-81.36578083306509,
							28.523914541996064
						],
						[
							-81.36662534951057,
							28.523914805497462
						],
						[
							-81.36650905008511,
							28.520322293679563
						],
						[
							-81.3669206562881,
							28.520314336478265
						],
						[
							-81.36801327769504,
							28.5203033206827
						],
						[
							-81.36813245315237,
							28.520300315148482
						],
						[
							-81.36853505084657,
							28.520296309568167
						],
						[
							-81.36862718818709,
							28.520292303088493
						],
						[
							-81.37222966179513,
							28.520117911057184
						],
						[
							-81.37222947743416,
							28.522407418569205
						],
						[
							-81.37224355092454,
							28.523919683420146
						],
						[
							-81.37228961959484,
							28.527832486080783
						],
						[
							-81.37228944782433,
							28.528795998119293
						],
						[
							-81.37279847758276,
							28.529184456672525
						],
						[
							-81.37280050555388,
							28.53078499177929
						],
						[
							-81.37056893596433,
							28.530826796763826
						],
						[
							-81.37056819582224,
							28.530943230188328
						],
						[
							-81.36878442115419,
							28.530949109056387
						],
						[
							-81.36859413720319,
							28.530966135920394
						],
						[
							-81.36850994986938,
							28.530996199356494
						],
						[
							-81.36841286895566,
							28.530825925320734
						],
						[
							-81.36832874727244,
							28.53067570436763
						],
						[
							-81.36829870182268,
							28.530571548487536
						],
						[
							-81.36827566748761,
							28.530393286673515
						],
						[
							-81.36828467959361,
							28.530266096458178
						],
						[
							-81.36828467959361,
							28.530176963752517
						],
						[
							-81.36828167495875,
							28.530129893237564
						],
						[
							-81.36826464989339,
							28.529273623552363
						],
						[
							-81.36822959791803,
							28.52837328888652
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Delaney Park",
				"RegionID": "276291"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.4020091459999,
					27.97450815600007,
					-82.39357795799992,
					27.982106591000047
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.40164499999992,
							27.981501000000037
						],
						[
							-82.40164299999992,
							27.98146500000007
						],
						[
							-82.40160896599991,
							27.981465600000035
						],
						[
							-82.40149990599991,
							27.98146752300005
						],
						[
							-82.40114547299993,
							27.981473771000083
						],
						[
							-82.4010189999999,
							27.981476000000043
						],
						[
							-82.40020899999992,
							27.98148400000008
						],
						[
							-82.40020170299994,
							27.98148403500005
						],
						[
							-82.39938299999994,
							27.98148800000007
						],
						[
							-82.39856499999992,
							27.981491000000062
						],
						[
							-82.39774699999992,
							27.981491000000062
						],
						[
							-82.39693299999993,
							27.981490000000065
						],
						[
							-82.39613182799991,
							27.98148604800008
						],
						[
							-82.39612199999993,
							27.981486003000043
						],
						[
							-82.39565899999991,
							27.98148400000008
						],
						[
							-82.3954454499999,
							27.98148336400004
						],
						[
							-82.3953229999999,
							27.981483000000082
						],
						[
							-82.39448599999992,
							27.981482000000085
						],
						[
							-82.39361099999991,
							27.981482000000085
						],
						[
							-82.39360199999993,
							27.979595000000074
						],
						[
							-82.3935919999999,
							27.97776000000005
						],
						[
							-82.39359008199995,
							27.977318154000045
						],
						[
							-82.3935889999999,
							27.977069000000085
						],
						[
							-82.39358299999992,
							27.975952000000063
						],
						[
							-82.39358113899993,
							27.97561785700009
						],
						[
							-82.39358099999993,
							27.97559300000006
						],
						[
							-82.39357795799992,
							27.975001370000086
						],
						[
							-82.39368194799994,
							27.974763659000075
						],
						[
							-82.39366482799994,
							27.97450815600007
						],
						[
							-82.39798901499995,
							27.97451445100006
						],
						[
							-82.4020091459999,
							27.974520247000044
						],
						[
							-82.4020090169999,
							27.982106591000047
						],
						[
							-82.40167552799994,
							27.98194799500004
						],
						[
							-82.40162186799995,
							27.981688082000062
						],
						[
							-82.40160099999991,
							27.981587000000047
						],
						[
							-82.40164499999992,
							27.981501000000037
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Grant Park",
				"RegionID": "276350"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.51911833815674,
					27.863393847451988,
					-82.49411812823175,
					27.88019994676037
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.49441471474444,
							27.86402022254751
						],
						[
							-82.51745470751577,
							27.863393847451988
						],
						[
							-82.51723620014171,
							27.864172814113473
						],
						[
							-82.51911833815674,
							27.864699887869136
						],
						[
							-82.51911826890894,
							27.86590005290227
						],
						[
							-82.5138362142845,
							27.868002152495237
						],
						[
							-82.50918241883504,
							27.87102221706318
						],
						[
							-82.5067090907996,
							27.872627273061774
						],
						[
							-82.49762226367383,
							27.87852413570183
						],
						[
							-82.49641818119389,
							27.879100000375466
						],
						[
							-82.49411812823175,
							27.88019994676037
						],
						[
							-82.49421083484312,
							27.86641499030707
						],
						[
							-82.49439090879096,
							27.86429999983214
						],
						[
							-82.49441471474444,
							27.86402022254751
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Interbay",
				"RegionID": "276391"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.45519266581822,
					27.99620020200247,
					-82.43449561197863,
					28.02206372870003
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.43449561197863,
							28.020006352391597
						],
						[
							-82.43456368885752,
							28.010891075213475
						],
						[
							-82.43461834965049,
							28.003566521764817
						],
						[
							-82.43467270377462,
							27.996275665912613
						],
						[
							-82.45371752947723,
							27.99620020200247
						],
						[
							-82.45340908990023,
							27.999809091373812
						],
						[
							-82.45282727351335,
							28.00253636456803
						],
						[
							-82.45260909259318,
							28.006000001740485
						],
						[
							-82.45331818283223,
							28.00960000041431
						],
						[
							-82.45411818013932,
							28.012099998743906
						],
						[
							-82.45471818171697,
							28.017100000799054
						],
						[
							-82.45519266581822,
							28.020142689611248
						],
						[
							-82.45289999179337,
							28.020409175815637
						],
						[
							-82.44829999828433,
							28.018918178132097
						],
						[
							-82.4469364048547,
							28.017936185025892
						],
						[
							-82.44633636370692,
							28.01804545535041
						],
						[
							-82.44501811859055,
							28.018463816361226
						],
						[
							-82.4436546573613,
							28.016399865109364
						],
						[
							-82.44270479793055,
							28.01599998156904
						],
						[
							-82.44122460739977,
							28.014727667526735
						],
						[
							-82.43815447037987,
							28.018299965283365
						],
						[
							-82.43791830751569,
							28.01954550111295
						],
						[
							-82.43727284341084,
							28.020618313153577
						],
						[
							-82.4362363639802,
							28.02108181923083
						],
						[
							-82.43477280191382,
							28.02206372870003
						],
						[
							-82.43449561197863,
							28.020006352391597
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Old Seminole Heights",
				"RegionID": "276500"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.47496413499994,
					27.96024991300004,
					-82.4676635809999,
					27.967109911000083
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.46796837799991,
							27.96073715600005
						],
						[
							-82.46805184899995,
							27.96024991300004
						],
						[
							-82.46881315399992,
							27.96043559700007
						],
						[
							-82.4696710149999,
							27.960673892000045
						],
						[
							-82.47031441099995,
							27.96110282300009
						],
						[
							-82.47093397799995,
							27.961722389000045
						],
						[
							-82.4715535439999,
							27.96231812700006
						],
						[
							-82.47262587099993,
							27.963295135000067
						],
						[
							-82.47326926699992,
							27.964010020000046
						],
						[
							-82.4738411749999,
							27.964987029000042
						],
						[
							-82.47429393499993,
							27.965725743000064
						],
						[
							-82.47496413499994,
							27.96654673800009
						],
						[
							-82.47459099999992,
							27.966837000000055
						],
						[
							-82.47423636399992,
							27.96687272700007
						],
						[
							-82.4698181949999,
							27.96710003800007
						],
						[
							-82.4676635809999,
							27.967109911000083
						],
						[
							-82.46766363499995,
							27.967034639000076
						],
						[
							-82.46766363499995,
							27.963429959000052
						],
						[
							-82.46766363599994,
							27.962516036000068
						],
						[
							-82.46790880599991,
							27.961084901000053
						],
						[
							-82.46796837799991,
							27.96073715600005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Ridgewood Park",
				"RegionID": "276534"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.35115799999994,
					28.41272577600006,
					-81.33482596599993,
					28.45057100000008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.34940699999994,
							28.445462000000077
						],
						[
							-81.34926699999994,
							28.44519500000007
						],
						[
							-81.34709099999992,
							28.445752000000084
						],
						[
							-81.34697299999993,
							28.445774000000085
						],
						[
							-81.34697299999993,
							28.447283000000084
						],
						[
							-81.34697299999993,
							28.447522000000053
						],
						[
							-81.34698899999995,
							28.44969400000008
						],
						[
							-81.34639199999992,
							28.449702000000062
						],
						[
							-81.34638099999995,
							28.449982000000094
						],
						[
							-81.34624799999995,
							28.449982000000094
						],
						[
							-81.34624799999995,
							28.449704000000054
						],
						[
							-81.34624799999995,
							28.448755000000062
						],
						[
							-81.34617399999992,
							28.447522000000053
						],
						[
							-81.34297499999991,
							28.447522000000053
						],
						[
							-81.34289899999993,
							28.44976100000008
						],
						[
							-81.34083099999994,
							28.44975700000009
						],
						[
							-81.3387909999999,
							28.44979900000004
						],
						[
							-81.33843299999995,
							28.449801000000036
						],
						[
							-81.3375539999999,
							28.449920000000077
						],
						[
							-81.33718167899991,
							28.449984580000034
						],
						[
							-81.3372084579999,
							28.44824832800009
						],
						[
							-81.3387420009999,
							28.44815745200009
						],
						[
							-81.3388321679999,
							28.44058099000006
						],
						[
							-81.33720857899993,
							28.43967856000006
						],
						[
							-81.33645746299993,
							28.440262802000063
						],
						[
							-81.33639546099994,
							28.440193346000058
						],
						[
							-81.3357272579999,
							28.44018661700005
						],
						[
							-81.33580350699994,
							28.439755863000073
						],
						[
							-81.33579166499993,
							28.438195483000072
						],
						[
							-81.33522048399993,
							28.437573702000066
						],
						[
							-81.33519961199994,
							28.437436423000065
						],
						[
							-81.33482596599993,
							28.43498165300008
						],
						[
							-81.33561231099992,
							28.435394543000086
						],
						[
							-81.33563125299993,
							28.434857600000043
						],
						[
							-81.33563625999994,
							28.434761456000047
						],
						[
							-81.33563926499994,
							28.43466631600006
						],
						[
							-81.33564827799995,
							28.43444598900004
						],
						[
							-81.33565420999992,
							28.434375729000067
						],
						[
							-81.33675794299995,
							28.434987978000038
						],
						[
							-81.3383815219999,
							28.433544680000068
						],
						[
							-81.33785936899996,
							28.432782538000083
						],
						[
							-81.33809799199992,
							28.43221769200005
						],
						[
							-81.33796362999993,
							28.43138243700008
						],
						[
							-81.33814806799995,
							28.43091776500006
						],
						[
							-81.3380989129999,
							28.430557221000075
						],
						[
							-81.33810692299994,
							28.429694942000086
						],
						[
							-81.33796871999994,
							28.428863710000087
						],
						[
							-81.33792064799991,
							28.427009963000046
						],
						[
							-81.33786456599995,
							28.426776612000083
						],
						[
							-81.33785254799994,
							28.423587886000064
						],
						[
							-81.33788759899994,
							28.422294969000063
						],
						[
							-81.33792952899995,
							28.41911311900009
						],
						[
							-81.34036533799991,
							28.419021940000054
						],
						[
							-81.34153895499992,
							28.42010588200009
						],
						[
							-81.34397275799995,
							28.420105855000088
						],
						[
							-81.34389864499991,
							28.41272577600006
						],
						[
							-81.3440825209999,
							28.413050586000054
						],
						[
							-81.34502528099995,
							28.413973705000046
						],
						[
							-81.34565378699995,
							28.41464149300009
						],
						[
							-81.34626265299994,
							28.41536820400006
						],
						[
							-81.34753199999996,
							28.416971000000046
						],
						[
							-81.3475269999999,
							28.421167000000082
						],
						[
							-81.3475269999999,
							28.42129300000005
						],
						[
							-81.34896299999991,
							28.421310000000062
						],
						[
							-81.34897199999995,
							28.42313100000007
						],
						[
							-81.34753199999996,
							28.423151000000075
						],
						[
							-81.3475279999999,
							28.42357100000004
						],
						[
							-81.34721999999994,
							28.42357100000004
						],
						[
							-81.3472089999999,
							28.424411000000077
						],
						[
							-81.34689099999991,
							28.424411000000077
						],
						[
							-81.34689099999991,
							28.426083000000062
						],
						[
							-81.34688199999994,
							28.426544000000035
						],
						[
							-81.34692199999996,
							28.426548000000082
						],
						[
							-81.34826099999992,
							28.426566000000037
						],
						[
							-81.34905099999992,
							28.42657500000007
						],
						[
							-81.34905748199992,
							28.427050747000067
						],
						[
							-81.34722031099994,
							28.42705089100008
						],
						[
							-81.34724352899991,
							28.440366405000077
						],
						[
							-81.3471219999999,
							28.440371000000084
						],
						[
							-81.34699699999993,
							28.440371000000084
						],
						[
							-81.34699699999993,
							28.441423000000043
						],
						[
							-81.34699795299991,
							28.44173435600004
						],
						[
							-81.34700100299995,
							28.442730512000086
						],
						[
							-81.34700199999992,
							28.44305600000007
						],
						[
							-81.34701599999995,
							28.443192000000067
						],
						[
							-81.34703699999994,
							28.44337100000007
						],
						[
							-81.3471219999999,
							28.443584000000044
						],
						[
							-81.34744899999993,
							28.443861000000084
						],
						[
							-81.34823899999992,
							28.44442500000008
						],
						[
							-81.34851799999991,
							28.44450900000004
						],
						[
							-81.34881999999993,
							28.444586000000072
						],
						[
							-81.34914999999995,
							28.44465800000006
						],
						[
							-81.34937899999994,
							28.44469900000007
						],
						[
							-81.3494639999999,
							28.444711000000044
						],
						[
							-81.3497309999999,
							28.44474900000006
						],
						[
							-81.35001499999994,
							28.444757000000042
						],
						[
							-81.3506129999999,
							28.44468600000005
						],
						[
							-81.35105599999991,
							28.44458300000008
						],
						[
							-81.35105799999991,
							28.44465900000006
						],
						[
							-81.3510599999999,
							28.44473500000004
						],
						[
							-81.35100899999992,
							28.44929200000007
						],
						[
							-81.35099799999996,
							28.44929250000007
						],
						[
							-81.35098699999992,
							28.44929300000007
						],
						[
							-81.35102099999995,
							28.449734000000035
						],
						[
							-81.35109099999994,
							28.449982000000094
						],
						[
							-81.35110717099991,
							28.45000613600007
						],
						[
							-81.35115799999994,
							28.450082000000066
						],
						[
							-81.35110637999992,
							28.450098361000073
						],
						[
							-81.3507919999999,
							28.450198000000057
						],
						[
							-81.3502299999999,
							28.450329000000067
						],
						[
							-81.34963299999993,
							28.450450000000046
						],
						[
							-81.34916299999992,
							28.45053100000007
						],
						[
							-81.3489909999999,
							28.45057100000008
						],
						[
							-81.3489449999999,
							28.450420000000065
						],
						[
							-81.34892999999994,
							28.450159000000042
						],
						[
							-81.34939099999991,
							28.449982000000094
						],
						[
							-81.34951899999993,
							28.449970000000064
						],
						[
							-81.34944499999995,
							28.449711000000036
						],
						[
							-81.34936099999993,
							28.44971000000004
						],
						[
							-81.34924899999993,
							28.449702000000062
						],
						[
							-81.34926799999994,
							28.449055000000044
						],
						[
							-81.3493519999999,
							28.449055000000044
						],
						[
							-81.34936799999991,
							28.44863900000007
						],
						[
							-81.34953699999994,
							28.44821500000006
						],
						[
							-81.34996399999994,
							28.447752000000037
						],
						[
							-81.35003999999992,
							28.447575000000086
						],
						[
							-81.34994699999993,
							28.447459000000038
						],
						[
							-81.34985399999994,
							28.447385000000054
						],
						[
							-81.3477309999999,
							28.44735200000008
						],
						[
							-81.34774099999993,
							28.44603500000005
						],
						[
							-81.3480199999999,
							28.446002000000078
						],
						[
							-81.3480199999999,
							28.445748000000037
						],
						[
							-81.34940699999994,
							28.445462000000077
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Southport",
				"RegionID": "276577"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.10639048399992,
					26.221276774000046,
					-80.1032035579999,
					26.22421937000007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.1032035579999,
							26.22390685000005
						],
						[
							-80.10321093499994,
							26.223885257000063
						],
						[
							-80.10396687399992,
							26.221672417000036
						],
						[
							-80.10631600499994,
							26.221276774000046
						],
						[
							-80.10634045499995,
							26.22225476200009
						],
						[
							-80.1063410289999,
							26.22226602300009
						],
						[
							-80.10639048399992,
							26.22399696100007
						],
						[
							-80.10633364599994,
							26.22400369700006
						],
						[
							-80.10456033899993,
							26.22421937000007
						],
						[
							-80.1032035579999,
							26.22390685000005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Pompano Beach",
				"Name": "Cypress Cove",
				"RegionID": "738049"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.1200669449999,
					26.20975984000006,
					-80.10396687399992,
					26.22226602300009
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.10634045499995,
							26.22225476200009
						],
						[
							-80.10631600499994,
							26.221276774000046
						],
						[
							-80.10396687399992,
							26.221672417000036
						],
						[
							-80.10493125399995,
							26.219100738000066
						],
						[
							-80.10537635299994,
							26.217542893000086
						],
						[
							-80.10611818299994,
							26.21477339200004
						],
						[
							-80.1073648229999,
							26.209764729000085
						],
						[
							-80.10736694499991,
							26.20975984000006
						],
						[
							-80.10741243899992,
							26.20976031400005
						],
						[
							-80.10743982999992,
							26.20975984000006
						],
						[
							-80.10849406099994,
							26.20975984000006
						],
						[
							-80.10856694499995,
							26.20975984000006
						],
						[
							-80.1086398299999,
							26.20975984000006
						],
						[
							-80.10929406099991,
							26.20975984000006
						],
						[
							-80.10936694499992,
							26.20975984000006
						],
						[
							-80.10943982999993,
							26.20975984000006
						],
						[
							-80.10989406099992,
							26.20975984000006
						],
						[
							-80.10996517699994,
							26.20975984000006
						],
						[
							-80.10996943599993,
							26.20976425200007
						],
						[
							-80.1100443229999,
							26.210209165000038
						],
						[
							-80.11015052499994,
							26.210849185000086
						],
						[
							-80.1101677979999,
							26.21095342400008
						],
						[
							-80.11016879099992,
							26.21095858500007
						],
						[
							-80.11068394499995,
							26.210936840000045
						],
						[
							-80.11456420799993,
							26.210764405000077
						],
						[
							-80.1146669449999,
							26.210759840000037
						],
						[
							-80.11749541699993,
							26.210625151000045
						],
						[
							-80.11886694499992,
							26.210559840000087
						],
						[
							-80.11893982999993,
							26.210559840000087
						],
						[
							-80.11999231499993,
							26.210559800000055
						],
						[
							-80.12006249099994,
							26.210559840000087
						],
						[
							-80.1200669449999,
							26.210559840000087
						],
						[
							-80.12006624799994,
							26.210564541000053
						],
						[
							-80.12001558999992,
							26.21168264100004
						],
						[
							-80.1187792049999,
							26.212919026000066
						],
						[
							-80.11808682999992,
							26.213191030000075
						],
						[
							-80.11749336499992,
							26.213364124000066
						],
						[
							-80.11677626199992,
							26.214130683000064
						],
						[
							-80.1159107929999,
							26.214600509000036
						],
						[
							-80.11544096699993,
							26.215045607000036
						],
						[
							-80.11529260099991,
							26.216281992000063
						],
						[
							-80.11521841799994,
							26.216801273000044
						],
						[
							-80.11460022499995,
							26.21759255900008
						],
						[
							-80.11316601899995,
							26.218037658000075
						],
						[
							-80.11272092099995,
							26.21858166700008
						],
						[
							-80.11222636699995,
							26.21947186400007
						],
						[
							-80.11165762999991,
							26.220337333000092
						],
						[
							-80.11081688899992,
							26.22093079800004
						],
						[
							-80.10980305299995,
							26.22140062400007
						],
						[
							-80.10886340099995,
							26.22174681200005
						],
						[
							-80.10777538299993,
							26.222043544000087
						],
						[
							-80.10641322599992,
							26.22225482300007
						],
						[
							-80.1063410289999,
							26.22226602300009
						],
						[
							-80.10634045499995,
							26.22225476200009
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Pompano Beach",
				"Name": "Cypress Lakes",
				"RegionID": "738051"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.14796756499993,
					26.208860049000066,
					-80.13641602599996,
					26.231579749000048
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.13645174399994,
							26.226648904000058
						],
						[
							-80.1364408789999,
							26.222704771000053
						],
						[
							-80.13644033499992,
							26.222507429000075
						],
						[
							-80.13641602599996,
							26.21368311100008
						],
						[
							-80.13695834899994,
							26.21141521800007
						],
						[
							-80.13815906999992,
							26.208876764000085
						],
						[
							-80.13816798199991,
							26.208860049000066
						],
						[
							-80.13823272299993,
							26.208877121000057
						],
						[
							-80.13875562999993,
							26.209013893000076
						],
						[
							-80.13953394499993,
							26.209217840000065
						],
						[
							-80.14051594499995,
							26.20947484000004
						],
						[
							-80.14236794499993,
							26.209959840000067
						],
						[
							-80.1438679449999,
							26.210459840000055
						],
						[
							-80.14410294499993,
							26.21053984000008
						],
						[
							-80.14612994499993,
							26.211232840000037
						],
						[
							-80.14711594499994,
							26.21156984000004
						],
						[
							-80.1476269449999,
							26.211743840000054
						],
						[
							-80.14789988599995,
							26.211838525000076
						],
						[
							-80.14796291599993,
							26.211858203000077
						],
						[
							-80.14796756499993,
							26.211860181000077
						],
						[
							-80.1464243389999,
							26.21856401300005
						],
						[
							-80.1437620289999,
							26.231382541000073
						],
						[
							-80.13646532799993,
							26.231579749000048
						],
						[
							-80.13645174399994,
							26.226648904000058
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Pompano Beach",
				"Name": "Andrews Industrial District",
				"RegionID": "738056"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.1563189279999,
					26.210460151000063,
					-80.1464243389999,
					26.218618349000053
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.1464243389999,
							26.21856401300005
						],
						[
							-80.14796756499993,
							26.211860181000077
						],
						[
							-80.14797326399992,
							26.211836789000074
						],
						[
							-80.14826794199992,
							26.210559596000053
						],
						[
							-80.14834081799995,
							26.210558851000087
						],
						[
							-80.1490790709999,
							26.21054882900006
						],
						[
							-80.1491519459999,
							26.210547856000062
						],
						[
							-80.14922481999992,
							26.210546914000076
						],
						[
							-80.15599507299993,
							26.210460931000057
						],
						[
							-80.15606383999994,
							26.21046019700009
						],
						[
							-80.15606794899992,
							26.210460151000063
						],
						[
							-80.1560671549999,
							26.210465017000047
						],
						[
							-80.1563141769999,
							26.21846450000004
						],
						[
							-80.1563189279999,
							26.218618349000053
						],
						[
							-80.1464243389999,
							26.21856401300005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Pompano Beach",
				"Name": "Cypress Bend",
				"RegionID": "738058"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.33017731199999,
					28.127545000000055,
					-82.30925433399995,
					28.14208388800006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.30968334699998,
							28.14208388800006
						],
						[
							-82.30965340999995,
							28.13313311400003
						],
						[
							-82.30933984999996,
							28.132163929000058
						],
						[
							-82.30925433399995,
							28.131451294000044
						],
						[
							-82.30968191499994,
							28.130681647000074
						],
						[
							-82.30969740699999,
							28.129244030000056
						],
						[
							-82.31138499999997,
							28.12988400000006
						],
						[
							-82.31740899999994,
							28.12970000000007
						],
						[
							-82.32061899999997,
							28.129624000000035
						],
						[
							-82.32243699999998,
							28.127545000000055
						],
						[
							-82.32689883299997,
							28.127557654000046
						],
						[
							-82.32695619999998,
							28.128486730000077
						],
						[
							-82.32658562899996,
							28.130396593000057
						],
						[
							-82.32644310199998,
							28.131593821000024
						],
						[
							-82.32695619999998,
							28.13279104800006
						],
						[
							-82.32786837299994,
							28.133190124000066
						],
						[
							-82.32875204099997,
							28.133446673000037
						],
						[
							-82.32889456799995,
							28.13364621100004
						],
						[
							-82.32860951399994,
							28.134387352000033
						],
						[
							-82.33017731199999,
							28.134843439000065
						],
						[
							-82.32937916099996,
							28.13755145400006
						],
						[
							-82.32892307399999,
							28.138520638000045
						],
						[
							-82.32866652499996,
							28.13931879000006
						],
						[
							-82.32792538399997,
							28.139546833000054
						],
						[
							-82.32692769399995,
							28.139261779000037
						],
						[
							-82.32598701599994,
							28.13911925200006
						],
						[
							-82.32484679899994,
							28.13883419800004
						],
						[
							-82.32410565799995,
							28.13923327300006
						],
						[
							-82.32313647399997,
							28.13948982200003
						],
						[
							-82.32248084899999,
							28.139917404000073
						],
						[
							-82.32256630199998,
							28.141875019000054
						],
						[
							-82.32133099999999,
							28.141871000000037
						],
						[
							-82.31730599999997,
							28.141906000000063
						],
						[
							-82.31673699999999,
							28.14190700000006
						],
						[
							-82.31629491399997,
							28.141918086000032
						],
						[
							-82.30968334699998,
							28.14208388800006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Arbor Greene",
				"RegionID": "753718"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.16324019699994,
					25.881059583000024,
					-80.15357310399997,
					25.888086051000073
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.16324019699994,
							25.882923428000026
						],
						[
							-80.16282298899995,
							25.883530715000063
						],
						[
							-80.16233837799996,
							25.884233400000028
						],
						[
							-80.16163569299994,
							25.884596857000076
						],
						[
							-80.16090877799996,
							25.88493608500005
						],
						[
							-80.16037570699996,
							25.88532377300004
						],
						[
							-80.15691074299997,
							25.888086051000073
						],
						[
							-80.15657122499994,
							25.88771022900005
						],
						[
							-80.15357310399997,
							25.885045233000028
						],
						[
							-80.15426314699995,
							25.88448606000003
						],
						[
							-80.15560754299997,
							25.883248740000056
						],
						[
							-80.15761818699997,
							25.881821063000075
						],
						[
							-80.15954392299994,
							25.881059583000024
						],
						[
							-80.160428,
							25.881388
						],
						[
							-80.16324019699994,
							25.882923428000026
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "North Miami",
				"Name": "Sans Souci",
				"RegionID": "760906"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.1790874499999,
					26.165444388000026,
					-80.17099997799995,
					26.174389533000067
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.17103210199997,
							26.173308256000045
						],
						[
							-80.17102652499995,
							26.172000355000023
						],
						[
							-80.17099997799995,
							26.165774858000077
						],
						[
							-80.17100030899996,
							26.165737196000066
						],
						[
							-80.17100174799998,
							26.165573730000062
						],
						[
							-80.17157347599995,
							26.165561215000025
						],
						[
							-80.17691041399996,
							26.165444388000026
						],
						[
							-80.17698926099996,
							26.16544500200007
						],
						[
							-80.17905449499996,
							26.165461075000053
						],
						[
							-80.17905525199996,
							26.16565383600005
						],
						[
							-80.17905931899998,
							26.166689750000046
						],
						[
							-80.1790874499999,
							26.17367965400007
						],
						[
							-80.17823664499997,
							26.173704326000063
						],
						[
							-80.17674821599996,
							26.17374767800004
						],
						[
							-80.17336746199999,
							26.173846146000077
						],
						[
							-80.17280318199994,
							26.173862581000037
						],
						[
							-80.17273084999994,
							26.173864688000037
						],
						[
							-80.17243654099997,
							26.17387326000005
						],
						[
							-80.17218418999994,
							26.173902378000037
						],
						[
							-80.17201682399997,
							26.173921689000053
						],
						[
							-80.17188460099999,
							26.174020856000027
						],
						[
							-80.17166485799999,
							26.17418566400005
						],
						[
							-80.17162939299999,
							26.174212263000072
						],
						[
							-80.17142832899998,
							26.174271469000075
						],
						[
							-80.17122255499999,
							26.174332062000076
						],
						[
							-80.17102738099999,
							26.174389533000067
						],
						[
							-80.17103210199997,
							26.173308256000045
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Oakland Park",
				"Name": "Sail Boat Lake Pointe",
				"RegionID": "760970"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.16399376499999,
					26.176181706000023,
					-80.15726236999996,
					26.18169942700007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.16206738899996,
							26.181557244000032
						],
						[
							-80.16077851299997,
							26.18136637000004
						],
						[
							-80.160067,
							26.181261
						],
						[
							-80.15936073199998,
							26.181261
						],
						[
							-80.158967,
							26.181261
						],
						[
							-80.15881290799996,
							26.181183954000062
						],
						[
							-80.158567,
							26.181061
						],
						[
							-80.158067,
							26.180961
						],
						[
							-80.15770728899997,
							26.180961
						],
						[
							-80.15773922499994,
							26.180694223000046
						],
						[
							-80.15775224199996,
							26.180585491000045
						],
						[
							-80.15774330299996,
							26.180582607000076
						],
						[
							-80.15774643399999,
							26.180556452000076
						],
						[
							-80.15765500399993,
							26.18052695800003
						],
						[
							-80.15726236999996,
							26.180400302000066
						],
						[
							-80.15734500599996,
							26.180214369000055
						],
						[
							-80.15912439499994,
							26.17621074500005
						],
						[
							-80.15910815699993,
							26.176205173000028
						],
						[
							-80.15911858699997,
							26.176181706000023
						],
						[
							-80.16215346599995,
							26.177311714000044
						],
						[
							-80.16297503199996,
							26.177573121000023
						],
						[
							-80.16321890299997,
							26.177650716000073
						],
						[
							-80.16335766799995,
							26.177739668000072
						],
						[
							-80.16372262199997,
							26.177973613000063
						],
						[
							-80.16399376499999,
							26.178215721000072
						],
						[
							-80.16398642899998,
							26.178604536000023
						],
						[
							-80.16397240599997,
							26.179347762000077
						],
						[
							-80.16396234099994,
							26.179881205000072
						],
						[
							-80.16395476399998,
							26.180282808000072
						],
						[
							-80.16394897899995,
							26.180589416000032
						],
						[
							-80.16394533699997,
							26.180782454000052
						],
						[
							-80.16359756199995,
							26.18081945100005
						],
						[
							-80.16318661699995,
							26.180863169000077
						],
						[
							-80.16308113799994,
							26.181252637000057
						],
						[
							-80.16304261099998,
							26.181394894000054
						],
						[
							-80.16299332799997,
							26.181576865000068
						],
						[
							-80.16296013499993,
							26.18169942700007
						],
						[
							-80.162768,
							26.181661
						],
						[
							-80.16206738899996,
							26.181557244000032
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Oakland Park",
				"Name": "Twin Lakes South",
				"RegionID": "760972"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.262946,
					25.754038,
					-80.25415,
					25.771853000000004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.255365,
							25.770026
						],
						[
							-80.25536327399999,
							25.769996461000062
						],
						[
							-80.25526993199998,
							25.767670397000074
						],
						[
							-80.25503229899994,
							25.761782348000054
						],
						[
							-80.25502,
							25.76142
						],
						[
							-80.255005,
							25.761025
						],
						[
							-80.254995,
							25.760652
						],
						[
							-80.254978,
							25.760324
						],
						[
							-80.254969,
							25.759897000000002
						],
						[
							-80.254951,
							25.759616
						],
						[
							-80.25494000000002,
							25.759128
						],
						[
							-80.25493,
							25.758838
						],
						[
							-80.254912,
							25.758348
						],
						[
							-80.254902,
							25.758048
						],
						[
							-80.25486374099995,
							25.75761129400007
						],
						[
							-80.2548,
							25.756034
						],
						[
							-80.254711,
							25.754038
						],
						[
							-80.25518586799996,
							25.754083726000033
						],
						[
							-80.25586996299995,
							25.754202699000075
						],
						[
							-80.25634585499995,
							25.754440645000045
						],
						[
							-80.25670277399996,
							25.754619105000074
						],
						[
							-80.26282988599996,
							25.754232442000045
						],
						[
							-80.262946,
							25.756202
						],
						[
							-80.260899,
							25.756228
						],
						[
							-80.26096884299994,
							25.757862395000075
						],
						[
							-80.260976,
							25.758066
						],
						[
							-80.260974,
							25.758147
						],
						[
							-80.260972,
							25.758234
						],
						[
							-80.261004,
							25.758997
						],
						[
							-80.261109,
							25.761237000000005
						],
						[
							-80.261156,
							25.762242
						],
						[
							-80.26123597699996,
							25.763926754000067
						],
						[
							-80.26126299599997,
							25.76449590800007
						],
						[
							-80.26085199799996,
							25.764509962000034
						],
						[
							-80.26082733199996,
							25.76451081600004
						],
						[
							-80.25975463299994,
							25.764547993000065
						],
						[
							-80.25961,
							25.764553000000003
						],
						[
							-80.259217,
							25.764573
						],
						[
							-80.25921939999995,
							25.764617891000057
						],
						[
							-80.259344,
							25.766948565000064
						],
						[
							-80.25938960299999,
							25.767809021000062
						],
						[
							-80.259406,
							25.768126
						],
						[
							-80.25909060999999,
							25.768134840000073
						],
						[
							-80.25889985199996,
							25.76814018700003
						],
						[
							-80.258407,
							25.768154
						],
						[
							-80.258418,
							25.769123000000004
						],
						[
							-80.258464,
							25.770228000000003
						],
						[
							-80.258464,
							25.770557
						],
						[
							-80.25836050699996,
							25.770559810000066
						],
						[
							-80.25787812099998,
							25.770572907000034
						],
						[
							-80.25553057799995,
							25.77063664400004
						],
						[
							-80.25541737399999,
							25.770639718000044
						],
						[
							-80.255407,
							25.770640000000004
						],
						[
							-80.25543660599999,
							25.770968441000036
						],
						[
							-80.255439,
							25.770995
						],
						[
							-80.25543951199995,
							25.771018111000046
						],
						[
							-80.25544241299997,
							25.771149009000055
						],
						[
							-80.25544434499994,
							25.77123618800005
						],
						[
							-80.255447,
							25.771356
						],
						[
							-80.254832,
							25.771377
						],
						[
							-80.254849,
							25.771835
						],
						[
							-80.25476995499997,
							25.771835
						],
						[
							-80.25456,
							25.771835
						],
						[
							-80.254169,
							25.771853000000004
						],
						[
							-80.254151,
							25.77144
						],
						[
							-80.25415,
							25.771403
						],
						[
							-80.25417902699996,
							25.771401558000036
						],
						[
							-80.254452,
							25.771388
						],
						[
							-80.254353,
							25.770079
						],
						[
							-80.254411,
							25.770078
						],
						[
							-80.25469372599997,
							25.770074384000054
						],
						[
							-80.25496471699995,
							25.770070919000034
						],
						[
							-80.255193,
							25.770068
						],
						[
							-80.255365,
							25.770026
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Coral Gables",
				"Name": "North Ponce de Leon",
				"RegionID": "760988"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.80034393299997,
					24.54615778400006,
					-81.79282612699996,
					24.553495733000034
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.79363592699997,
							24.550506236000047
						],
						[
							-81.79490392899999,
							24.549679472000037
						],
						[
							-81.79484142199999,
							24.549597430000063
						],
						[
							-81.79444220199997,
							24.54907344800006
						],
						[
							-81.79441376799997,
							24.54903612800007
						],
						[
							-81.79413334399999,
							24.54866806700005
						],
						[
							-81.79410708899997,
							24.548682867000025
						],
						[
							-81.79409281899996,
							24.54869091100005
						],
						[
							-81.79404829499998,
							24.54871232100004
						],
						[
							-81.79404296899997,
							24.548714879000045
						],
						[
							-81.79403875699995,
							24.548709512000073
						],
						[
							-81.79282612699996,
							24.547164474000056
						],
						[
							-81.79287786199995,
							24.547049753000067
						],
						[
							-81.79290833499994,
							24.546971020000058
						],
						[
							-81.79342876999995,
							24.546999933000052
						],
						[
							-81.79427299799994,
							24.54665920800005
						],
						[
							-81.79472900499997,
							24.546392052000044
						],
						[
							-81.79524489099998,
							24.546774361000075
						],
						[
							-81.79583908199999,
							24.546765149000066
						],
						[
							-81.79553047099995,
							24.546369021000032
						],
						[
							-81.79565483699997,
							24.54625847400007
						],
						[
							-81.79607399399998,
							24.546654601000057
						],
						[
							-81.79660830499995,
							24.546295323000038
						],
						[
							-81.79671418099997,
							24.546275980000075
						],
						[
							-81.79719477499998,
							24.54615778400006
						],
						[
							-81.79858212599999,
							24.548057261000057
						],
						[
							-81.79861141799995,
							24.54809662400004
						],
						[
							-81.79992752699997,
							24.54986523200006
						],
						[
							-81.80034393299997,
							24.550424805000034
						],
						[
							-81.79856586899996,
							24.551532417000033
						],
						[
							-81.79541413299995,
							24.553495733000034
						],
						[
							-81.79429616199997,
							24.552117544000055
						],
						[
							-81.79467203099995,
							24.55191515200005
						],
						[
							-81.79363592699997,
							24.550506236000047
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Monroe",
				"City": "Key West",
				"Name": "Upper Duvall",
				"RegionID": "761122"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.13879458199995,
					26.16656802600005,
					-80.13135526099995,
					26.177317707000043
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.13145090999996,
							26.17407058200007
						],
						[
							-80.13148787999995,
							26.173304020000046
						],
						[
							-80.13141142799998,
							26.16829646700006
						],
						[
							-80.13135526099995,
							26.166726254000025
						],
						[
							-80.13162703999996,
							26.166720404000046
						],
						[
							-80.13290173799999,
							26.166692967000074
						],
						[
							-80.13532486699995,
							26.166637922000064
						],
						[
							-80.13760539299994,
							26.166586116000076
						],
						[
							-80.13840174699999,
							26.16656802600005
						],
						[
							-80.13843657499996,
							26.167306868000026
						],
						[
							-80.13850364099994,
							26.17022421400003
						],
						[
							-80.13863315199995,
							26.17390554600007
						],
						[
							-80.13879458199995,
							26.17634313600007
						],
						[
							-80.13474269499994,
							26.17640770700007
						],
						[
							-80.13471040899998,
							26.177214856000035
						],
						[
							-80.13173917799998,
							26.17731140400008
						],
						[
							-80.13154521799999,
							26.177317707000043
						],
						[
							-80.13150699199997,
							26.175769570000057
						],
						[
							-80.13148787999995,
							26.174603690000026
						],
						[
							-80.13145090999996,
							26.17407058200007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Oakland Park",
				"Name": "Central Oakland Park",
				"RegionID": "761154"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.14667305499995,
					26.166362,
					-80.13840174699999,
					26.17398626100004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.14114194499996,
							26.173848235000037
						],
						[
							-80.14092545399996,
							26.173824831000047
						],
						[
							-80.14053606299996,
							26.173884737000037
						],
						[
							-80.14029587799996,
							26.173921689000053
						],
						[
							-80.13942408299994,
							26.173913225000035
						],
						[
							-80.13873668699996,
							26.173906551000073
						],
						[
							-80.13863315199995,
							26.17390554600007
						],
						[
							-80.13850364099994,
							26.17022421400003
						],
						[
							-80.13843657499996,
							26.167306868000026
						],
						[
							-80.13840174699999,
							26.16656802600005
						],
						[
							-80.138667,
							26.166562
						],
						[
							-80.13896070699997,
							26.166503259000024
						],
						[
							-80.139167,
							26.166462
						],
						[
							-80.13947258699994,
							26.166462
						],
						[
							-80.140067,
							26.166462
						],
						[
							-80.14023130599998,
							26.166462
						],
						[
							-80.140667,
							26.166462
						],
						[
							-80.14087702499995,
							26.166462
						],
						[
							-80.141267,
							26.166462
						],
						[
							-80.142367,
							26.166462
						],
						[
							-80.143367,
							26.166462
						],
						[
							-80.14416700000001,
							26.166462
						],
						[
							-80.14605312299994,
							26.166372185000057
						],
						[
							-80.146267,
							26.166362
						],
						[
							-80.146367,
							26.166362
						],
						[
							-80.14643802299997,
							26.166362
						],
						[
							-80.14645761599996,
							26.166800977000037
						],
						[
							-80.14650170199997,
							26.16801087600004
						],
						[
							-80.14651149899998,
							26.168471323000063
						],
						[
							-80.14652619399999,
							26.16945099800006
						],
						[
							-80.14652914099997,
							26.16948517900005
						],
						[
							-80.14655068599996,
							26.16973510400004
						],
						[
							-80.14655068599996,
							26.170107381000037
						],
						[
							-80.14658497399995,
							26.17146912900006
						],
						[
							-80.14663885599998,
							26.17291904900003
						],
						[
							-80.14667305499995,
							26.173875956000074
						],
						[
							-80.14278189599999,
							26.17398626100004
						],
						[
							-80.14186174699995,
							26.17398626100004
						],
						[
							-80.14170397199996,
							26.17394118200008
						],
						[
							-80.14152274399999,
							26.173889403000032
						],
						[
							-80.14114194499996,
							26.173848235000037
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Oakland Park",
				"Name": "Harlem McBride",
				"RegionID": "761156"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.32131109799997,
					29.674404280000033,
					-82.30580243099996,
					29.68835289200007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.31933242699995,
							29.68835289200007
						],
						[
							-82.30587609699995,
							29.688320544000078
						],
						[
							-82.30580243099996,
							29.674643797000044
						],
						[
							-82.31751875999998,
							29.674404280000033
						],
						[
							-82.31863650099996,
							29.674404280000033
						],
						[
							-82.32131109799997,
							29.67454399800005
						],
						[
							-82.31929517099996,
							29.678815368000077
						],
						[
							-82.31933242699995,
							29.68835289200007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Alachua",
				"City": "Gainesville",
				"Name": "Highland Court Manor",
				"RegionID": "761431"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.31154917599997,
					29.64576450000004,
					-82.30298249099997,
					29.651076620000026
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.31153489899998,
							29.64576450000004
						],
						[
							-82.31154917599997,
							29.646196372000077
						],
						[
							-82.31154074599993,
							29.648248248000076
						],
						[
							-82.31154000799995,
							29.648299347000034
						],
						[
							-82.31153540699995,
							29.64848510400003
						],
						[
							-82.31149915299994,
							29.651055205000038
						],
						[
							-82.30555287999994,
							29.651076620000026
						],
						[
							-82.30298249099997,
							29.649879771000027
						],
						[
							-82.30304736499994,
							29.648774928000027
						],
						[
							-82.30586651799996,
							29.648734664000077
						],
						[
							-82.30589036599999,
							29.645817231000024
						],
						[
							-82.31153489899998,
							29.64576450000004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Alachua",
				"City": "Gainesville",
				"Name": "North Lincoln Heights",
				"RegionID": "761438"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.39439557299994,
					29.644617356000026,
					-82.37878472899996,
					29.65196480700007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.39429270399995,
							29.651795708000066
						],
						[
							-82.39370343099995,
							29.651785998000037
						],
						[
							-82.39333980199996,
							29.651780006000024
						],
						[
							-82.38125379099995,
							29.65196480700007
						],
						[
							-82.37996689599998,
							29.651447849000075
						],
						[
							-82.37997956899994,
							29.651013890000062
						],
						[
							-82.37892411099995,
							29.65102895300004
						],
						[
							-82.37878472899996,
							29.645513387000054
						],
						[
							-82.38740653399998,
							29.64543374000004
						],
						[
							-82.38734679899994,
							29.64499568000008
						],
						[
							-82.38999506699997,
							29.644896121000045
						],
						[
							-82.39007471399998,
							29.644617356000026
						],
						[
							-82.39065215599999,
							29.644617356000026
						],
						[
							-82.39053268499998,
							29.647743508000076
						],
						[
							-82.39136897999998,
							29.648062096000046
						],
						[
							-82.39212562899996,
							29.648161655000028
						],
						[
							-82.39204598099997,
							29.64915724500003
						],
						[
							-82.39260351199995,
							29.649216980000062
						],
						[
							-82.39355927799994,
							29.649336451000067
						],
						[
							-82.39393760199994,
							29.649774510000046
						],
						[
							-82.39439557299994,
							29.650491335000027
						],
						[
							-82.39430703799997,
							29.651613950000066
						],
						[
							-82.39429270399995,
							29.651795708000066
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Alachua",
				"City": "Gainesville",
				"Name": "Sugar Foot",
				"RegionID": "761440"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.37683337299995,
					29.66106142500007,
					-82.37237562299998,
					29.664799724000037
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.37683337299995,
							29.66476808900006
						],
						[
							-82.37237562299998,
							29.664799724000037
						],
						[
							-82.37239238699993,
							29.66106142500007
						],
						[
							-82.37677363799997,
							29.66108440800008
						],
						[
							-82.37683337299995,
							29.66476808900006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Alachua",
				"City": "Gainesville",
				"Name": "Libby Heights",
				"RegionID": "761447"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.35575469799994,
					29.666738328000065,
					-82.34728427499994,
					29.674086807000037
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.35566713899993,
							29.674086807000037
						],
						[
							-82.34820481599996,
							29.673963809000046
						],
						[
							-82.34825995299997,
							29.671737216000054
						],
						[
							-82.34728427499994,
							29.670900921000054
						],
						[
							-82.34931527799995,
							29.66677918000005
						],
						[
							-82.35575469799994,
							29.666738328000065
						],
						[
							-82.35566713899993,
							29.674086807000037
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Alachua",
				"City": "Gainesville",
				"Name": "Forest Ridge",
				"RegionID": "761449"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.38067634899994,
					29.69230609600004,
					-82.37230343299997,
					29.697025190000033
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.37299039699997,
							29.69698536700002
						],
						[
							-82.37231339599998,
							29.69684598400005
						],
						[
							-82.37233285299999,
							29.695974300000046
						],
						[
							-82.37230343299997,
							29.692384951000065
						],
						[
							-82.37974049499998,
							29.69230609600004
						],
						[
							-82.37962102399996,
							29.693142391000038
						],
						[
							-82.37904358199995,
							29.693182215000036
						],
						[
							-82.37892411099995,
							29.694018510000035
						],
						[
							-82.37808781599995,
							29.69411806900007
						],
						[
							-82.37796834499994,
							29.694357010000033
						],
						[
							-82.37890419899998,
							29.694337099000055
						],
						[
							-82.37884446399994,
							29.695053923000046
						],
						[
							-82.37948164099998,
							29.695034011000075
						],
						[
							-82.37952146499998,
							29.694197716000073
						],
						[
							-82.38065643699997,
							29.69411806900007
						],
						[
							-82.38067634899994,
							29.694317187000028
						],
						[
							-82.38067634899994,
							29.69692563100006
						],
						[
							-82.37627584299997,
							29.697025190000033
						],
						[
							-82.37299039699997,
							29.69698536700002
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Alachua",
				"City": "Gainesville",
				"Name": "Capri",
				"RegionID": "761454"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.37850064699995,
					29.71179995600005,
					-82.37203603999995,
					29.718043183000077
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.37850064699995,
							29.717973090000044
						],
						[
							-82.37203603999995,
							29.718043183000077
						],
						[
							-82.37219028499999,
							29.71179995600005
						],
						[
							-82.37299038099997,
							29.712109670000075
						],
						[
							-82.37337764999995,
							29.71257992500006
						],
						[
							-82.37332232599994,
							29.71324381500005
						],
						[
							-82.37359894599996,
							29.713437449000022
						],
						[
							-82.37409686299998,
							29.713451280000072
						],
						[
							-82.37424900499997,
							29.713617253000052
						],
						[
							-82.37521717699997,
							29.713700239000048
						],
						[
							-82.37545230399996,
							29.713534266000067
						],
						[
							-82.37561444499994,
							29.71339651700004
						],
						[
							-82.37608373899997,
							29.713470624000024
						],
						[
							-82.37632763299996,
							29.713729425000057
						],
						[
							-82.37612455399994,
							29.713995760000046
						],
						[
							-82.37561444499994,
							29.71413858700004
						],
						[
							-82.37562893899997,
							29.714468312000065
						],
						[
							-82.37848115599996,
							29.71444518400006
						],
						[
							-82.37850064699995,
							29.717973090000044
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Alachua",
				"City": "Gainesville",
				"Name": "Sutters Landing",
				"RegionID": "761456"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.23413742699995,
					26.105733821000058,
					-80.21805450899996,
					26.12095413300006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.21806866499998,
							26.120897101000025
						],
						[
							-80.21847609799994,
							26.11927044300006
						],
						[
							-80.21854748199996,
							26.118071195000027
						],
						[
							-80.21854748199996,
							26.113388416000078
						],
						[
							-80.21830477699996,
							26.106050158000073
						],
						[
							-80.21858475599998,
							26.10604440900005
						],
						[
							-80.23371129099996,
							26.105733821000058
						],
						[
							-80.23371711399994,
							26.10594137800007
						],
						[
							-80.23411670999997,
							26.12018523300003
						],
						[
							-80.23412759199994,
							26.120541820000028
						],
						[
							-80.23413742699995,
							26.120864100000063
						],
						[
							-80.21954668099994,
							26.120909892000043
						],
						[
							-80.21894910599997,
							26.120909892000043
						],
						[
							-80.21809733899995,
							26.120896513000048
						],
						[
							-80.21808717099998,
							26.12095413300006
						],
						[
							-80.21805450899996,
							26.120953620000023
						],
						[
							-80.21806866499998,
							26.120897101000025
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Plantation",
				"Name": "Country Club Estates",
				"RegionID": "761599"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.262558,
					25.96130986800006,
					-80.24648366399998,
					25.971876
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.24673661999998,
							25.968239247000046
						],
						[
							-80.246712545,
							25.966848928000047
						],
						[
							-80.24669884499998,
							25.966562401000033
						],
						[
							-80.24665799,
							25.965707913000074
						],
						[
							-80.24648875899999,
							25.962168419000022
						],
						[
							-80.24648366399998,
							25.96130986800006
						],
						[
							-80.24671018999999,
							25.961314365000078
						],
						[
							-80.24836139699994,
							25.961347146000037
						],
						[
							-80.25138835799999,
							25.961415497000075
						],
						[
							-80.25306331499996,
							25.961458998000072
						],
						[
							-80.25367062399994,
							25.96147477100004
						],
						[
							-80.25392731399995,
							25.961481438000078
						],
						[
							-80.25418205899996,
							25.96149377100005
						],
						[
							-80.25910715799995,
							25.961732204000043
						],
						[
							-80.26029478599999,
							25.96183075900007
						],
						[
							-80.26136716399998,
							25.96191975000005
						],
						[
							-80.26224518099997,
							25.96190106100005
						],
						[
							-80.26233299099994,
							25.96372738200006
						],
						[
							-80.26243441099997,
							25.969276944000057
						],
						[
							-80.26247435599998,
							25.969929196000066
						],
						[
							-80.262558,
							25.971295000000005
						],
						[
							-80.26219799199998,
							25.971305740000048
						],
						[
							-80.260487,
							25.971356
						],
						[
							-80.260159,
							25.971368
						],
						[
							-80.25352941599995,
							25.971620933000054
						],
						[
							-80.250959,
							25.971719
						],
						[
							-80.24814300000001,
							25.971825
						],
						[
							-80.246971,
							25.971869
						],
						[
							-80.24682,
							25.971873
						],
						[
							-80.246671,
							25.971876
						],
						[
							-80.24677984499993,
							25.970735508000075
						],
						[
							-80.24673661999998,
							25.968239247000046
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Gardens",
				"Name": "North County- Riverdale",
				"RegionID": "761647"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.20613680699995,
					25.957124687000032,
					-80.197675,
					25.972995
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.19825429099996,
							25.96762431600007
						],
						[
							-80.19820163499998,
							25.96209000600004
						],
						[
							-80.198289,
							25.961749
						],
						[
							-80.19835616599994,
							25.961561989000074
						],
						[
							-80.19849300000001,
							25.961181
						],
						[
							-80.198512,
							25.961127
						],
						[
							-80.19854672899999,
							25.96092168800004
						],
						[
							-80.198614,
							25.960524
						],
						[
							-80.1986,
							25.960218
						],
						[
							-80.198564,
							25.959916
						],
						[
							-80.198489,
							25.959648
						],
						[
							-80.198445,
							25.959433
						],
						[
							-80.19823366999998,
							25.958972087000063
						],
						[
							-80.197675,
							25.957542
						],
						[
							-80.198399,
							25.957539
						],
						[
							-80.199323,
							25.957497000000004
						],
						[
							-80.200012,
							25.957465
						],
						[
							-80.20019676699997,
							25.957456704000037
						],
						[
							-80.200502,
							25.957443
						],
						[
							-80.201559,
							25.957364
						],
						[
							-80.20185981999998,
							25.957371533000074
						],
						[
							-80.20251016599997,
							25.95731456900006
						],
						[
							-80.20308455799994,
							25.957290834000048
						],
						[
							-80.20441373099999,
							25.95723386900005
						],
						[
							-80.20564321699999,
							25.957124687000032
						],
						[
							-80.20568530099996,
							25.958831968000027
						],
						[
							-80.20573622599994,
							25.95964637800006
						],
						[
							-80.20574469099995,
							25.959781753000073
						],
						[
							-80.20598500399996,
							25.96697006200003
						],
						[
							-80.20601998999996,
							25.968819188000055
						],
						[
							-80.20605962599996,
							25.96963173900008
						],
						[
							-80.20606955599999,
							25.970980248000046
						],
						[
							-80.20607445399997,
							25.971890404000078
						],
						[
							-80.20613680699995,
							25.972700022000026
						],
						[
							-80.20586714399997,
							25.972731418000023
						],
						[
							-80.205175,
							25.972812000000005
						],
						[
							-80.205078,
							25.972823
						],
						[
							-80.20459101599994,
							25.97284520100004
						],
						[
							-80.204069,
							25.972869
						],
						[
							-80.203484,
							25.972869
						],
						[
							-80.202868,
							25.97287
						],
						[
							-80.202669,
							25.972869
						],
						[
							-80.202291,
							25.972878
						],
						[
							-80.202085,
							25.972883
						],
						[
							-80.201955,
							25.972886
						],
						[
							-80.199815,
							25.972953
						],
						[
							-80.19951346399995,
							25.972963583000023
						],
						[
							-80.198021,
							25.972995
						],
						[
							-80.198028,
							25.972593
						],
						[
							-80.198054,
							25.972413
						],
						[
							-80.19812,
							25.97224
						],
						[
							-80.198271,
							25.97169
						],
						[
							-80.198368,
							25.970933
						],
						[
							-80.19834780999997,
							25.97055702800003
						],
						[
							-80.198331,
							25.970244
						],
						[
							-80.198298,
							25.969539
						],
						[
							-80.198278,
							25.968863
						],
						[
							-80.198268,
							25.968079
						],
						[
							-80.19825429099996,
							25.96762431600007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Gardens",
				"Name": "Andover Lakes",
				"RegionID": "761649"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.22762682699994,
					25.94188167200008,
					-80.21320442499996,
					25.949481993000063
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.22404924099999,
							25.942991047000078
						],
						[
							-80.22416734499996,
							25.943149779000066
						],
						[
							-80.22615236899998,
							25.945817650000038
						],
						[
							-80.22753323499995,
							25.948546665000038
						],
						[
							-80.22762682699994,
							25.948731631000044
						],
						[
							-80.22685075199996,
							25.94876381000006
						],
						[
							-80.22629979199996,
							25.94895747700008
						],
						[
							-80.21977094799996,
							25.94920593200004
						],
						[
							-80.21778330899997,
							25.94928875000005
						],
						[
							-80.21350436299997,
							25.949481993000063
						],
						[
							-80.21329584899996,
							25.94444257400005
						],
						[
							-80.21320442499996,
							25.942233016000046
						],
						[
							-80.21371723699997,
							25.942202696000038
						],
						[
							-80.21426303699997,
							25.942173318000073
						],
						[
							-80.21506646199998,
							25.942142744000023
						],
						[
							-80.22176431299994,
							25.941909790000068
						],
						[
							-80.22287066199993,
							25.94188167200008
						],
						[
							-80.22404924099999,
							25.942991047000078
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Gardens",
				"Name": "Norland",
				"RegionID": "761654"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.22287066199993,
					25.934799140000052,
					-80.20494752799993,
					25.94257684300004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.21381073899994,
							25.934851726000034
						],
						[
							-80.21577183199997,
							25.934799140000052
						],
						[
							-80.21650347599996,
							25.935529104000068
						],
						[
							-80.22287066199993,
							25.94188167200008
						],
						[
							-80.22176431299994,
							25.941909790000068
						],
						[
							-80.21506646199998,
							25.942142744000023
						],
						[
							-80.21426303699997,
							25.942173318000073
						],
						[
							-80.21371723699997,
							25.942202696000038
						],
						[
							-80.21320442499996,
							25.942233016000046
						],
						[
							-80.20900767099994,
							25.94243582100006
						],
						[
							-80.20599599299999,
							25.94251994600006
						],
						[
							-80.20522298699996,
							25.94257684300004
						],
						[
							-80.20521362299996,
							25.942391645000043
						],
						[
							-80.20517993399996,
							25.941725344000076
						],
						[
							-80.20494752799993,
							25.937128872000073
						],
						[
							-80.20621556499998,
							25.937064751000037
						],
						[
							-80.21294798499997,
							25.936724309000056
						],
						[
							-80.212782813,
							25.934879289000037
						],
						[
							-80.21381073899994,
							25.934851726000034
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Gardens",
				"Name": "Cloverleaf Estates",
				"RegionID": "761656"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.24434370899996,
					25.911825,
					-80.223276,
					25.916154298000038
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.223276,
							25.916154
						],
						[
							-80.223395,
							25.916053
						],
						[
							-80.22450776899996,
							25.91511820100004
						],
						[
							-80.22644000000001,
							25.913495
						],
						[
							-80.227078,
							25.912963
						],
						[
							-80.227424,
							25.912693
						],
						[
							-80.227765,
							25.912448
						],
						[
							-80.227976,
							25.912307
						],
						[
							-80.228074,
							25.912245
						],
						[
							-80.228464,
							25.912237
						],
						[
							-80.22885674799994,
							25.91222317100005
						],
						[
							-80.229458,
							25.912202000000004
						],
						[
							-80.229991,
							25.912189
						],
						[
							-80.23009085099994,
							25.912187321000033
						],
						[
							-80.231121,
							25.91217
						],
						[
							-80.231651,
							25.912142
						],
						[
							-80.232006,
							25.91216
						],
						[
							-80.232776,
							25.912126
						],
						[
							-80.23361,
							25.912102
						],
						[
							-80.234088,
							25.912098
						],
						[
							-80.2344,
							25.912082
						],
						[
							-80.23554,
							25.912050000000004
						],
						[
							-80.236122,
							25.912027
						],
						[
							-80.238111,
							25.911989
						],
						[
							-80.240099,
							25.911938
						],
						[
							-80.240372,
							25.911929
						],
						[
							-80.242152,
							25.911872
						],
						[
							-80.24255200000002,
							25.911858
						],
						[
							-80.24348225499995,
							25.91183503900004
						],
						[
							-80.243889,
							25.911825
						],
						[
							-80.244164,
							25.911825
						],
						[
							-80.24422487199996,
							25.913291710000067
						],
						[
							-80.24426299099997,
							25.914132892000055
						],
						[
							-80.24428296299999,
							25.91457360900006
						],
						[
							-80.24434370899996,
							25.91541189900005
						],
						[
							-80.24407442899997,
							25.915437076000046
						],
						[
							-80.24401005499999,
							25.915443095000057
						],
						[
							-80.24353703599996,
							25.915487322000047
						],
						[
							-80.24155161399995,
							25.91552729700004
						],
						[
							-80.22885290599999,
							25.915913722000028
						],
						[
							-80.22810104299998,
							25.915934907000064
						],
						[
							-80.22793199199998,
							25.915939670000057
						],
						[
							-80.22638534199996,
							25.916028900000075
						],
						[
							-80.22394973599995,
							25.916154298000038
						],
						[
							-80.223276,
							25.916154
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Gardens",
				"Name": "Rainbow Park",
				"RegionID": "761658"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.48893024099993,
					27.973978056000078,
					-82.46523873099994,
					27.999753000000055
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.48590885399994,
							27.999726629000065
						],
						[
							-82.48590922499994,
							27.99626350300008
						],
						[
							-82.48456363499992,
							27.996263637000084
						],
						[
							-82.47001818199993,
							27.99620000100009
						],
						[
							-82.46909999899992,
							27.996118184000068
						],
						[
							-82.4659782459999,
							27.996183705000078
						],
						[
							-82.46555773599995,
							27.996200084000066
						],
						[
							-82.46547702599992,
							27.99606067500008
						],
						[
							-82.46526256099992,
							27.995536426000058
						],
						[
							-82.46523873099994,
							27.995083666000088
						],
						[
							-82.46523873099994,
							27.99470239400006
						],
						[
							-82.46533404899992,
							27.994321123000077
						],
						[
							-82.46554851399993,
							27.99377304500007
						],
						[
							-82.46576297999991,
							27.99310581900005
						],
						[
							-82.4659059569999,
							27.992533911000066
						],
						[
							-82.46609659299992,
							27.991842856000062
						],
						[
							-82.46628722799994,
							27.99134243700007
						],
						[
							-82.46650169399993,
							27.99110414200004
						],
						[
							-82.46671615899993,
							27.990865848000055
						],
						[
							-82.46693062399993,
							27.990579894000064
						],
						[
							-82.4673118959999,
							27.990365428000075
						],
						[
							-82.46766933799995,
							27.99017479300005
						],
						[
							-82.46812209899991,
							27.98967437300007
						],
						[
							-82.46878932399994,
							27.988983318000066
						],
						[
							-82.46950420899992,
							27.98833992200008
						],
						[
							-82.47009994599996,
							27.98750589000008
						],
						[
							-82.47024292299994,
							27.987172278000063
						],
						[
							-82.47048121699993,
							27.98671951700004
						],
						[
							-82.47095780699995,
							27.98617143900009
						],
						[
							-82.47150588499994,
							27.985694850000073
						],
						[
							-82.47207779299993,
							27.98517060100005
						],
						[
							-82.4726020409999,
							27.98462252300004
						],
						[
							-82.47312628999993,
							27.984026786000072
						],
						[
							-82.47355522099991,
							27.983550196000067
						],
						[
							-82.4742701049999,
							27.98269233500008
						],
						[
							-82.47500881899992,
							27.98185830300008
						],
						[
							-82.47519285699991,
							27.981678448000082
						],
						[
							-82.47605731699991,
							27.980833635000067
						],
						[
							-82.47648624699991,
							27.980261727000084
						],
						[
							-82.47667688299993,
							27.97957067200008
						],
						[
							-82.47681985999992,
							27.97911791200005
						],
						[
							-82.47715347299993,
							27.97852217500008
						],
						[
							-82.47751091499994,
							27.978164733000085
						],
						[
							-82.4782257999999,
							27.977545166000084
						],
						[
							-82.47882153699993,
							27.977092406000057
						],
						[
							-82.4795602509999,
							27.976496669000085
						],
						[
							-82.48022747599992,
							27.97602007900008
						],
						[
							-82.48082321299995,
							27.975257536000072
						],
						[
							-82.4809423609999,
							27.97497158200008
						],
						[
							-82.48115682599992,
							27.97451882200005
						],
						[
							-82.4812472459999,
							27.97428523700006
						],
						[
							-82.48172619199994,
							27.974403678000044
						],
						[
							-82.48292364799994,
							27.973978056000078
						],
						[
							-82.48482014699994,
							27.97399037300005
						],
						[
							-82.48893024099993,
							27.974016734000088
						],
						[
							-82.48888181799992,
							27.981481819000066
						],
						[
							-82.48887988899992,
							27.985085305000045
						],
						[
							-82.48875344299995,
							27.990786594000042
						],
						[
							-82.4887119199999,
							27.99265881900004
						],
						[
							-82.48856099999996,
							27.999753000000055
						],
						[
							-82.4885367569999,
							27.99975280700005
						],
						[
							-82.48718099999991,
							27.999742000000087
						],
						[
							-82.48593260699994,
							27.99972691700009
						],
						[
							-82.48590885399994,
							27.999726629000065
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Wellswood",
				"RegionID": "276643"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.43461834965049,
					28.00349999981367,
					-82.41418219812488,
					28.010891075213475
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.42628194830232,
							28.00729986831184
						],
						[
							-82.41813938862293,
							28.00719515755
						],
						[
							-82.41418219812488,
							28.00737920470263
						],
						[
							-82.41418508764657,
							28.003701708751578
						],
						[
							-82.42629999949406,
							28.00349999981367
						],
						[
							-82.43461834965049,
							28.003566521764817
						],
						[
							-82.43456368885752,
							28.010891075213475
						],
						[
							-82.42635713252322,
							28.01089104103921
						],
						[
							-82.42628194830232,
							28.00729986831184
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Hillsborough",
				"City": "Tampa",
				"Name": "Woodland Terrace",
				"RegionID": "276668"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.7337627499979,
					28.039776176000256,
					-82.72982117399985,
					28.04157771498971
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.72983719899985,
							28.0415725930003
						],
						[
							-82.72982117399985,
							28.03980138800021
						],
						[
							-82.7300329339999,
							28.039800263000206
						],
						[
							-82.7303862409997,
							28.039787383000384
						],
						[
							-82.73089461499977,
							28.03978467900016
						],
						[
							-82.73113948399987,
							28.03978062600027
						],
						[
							-82.73145874899973,
							28.039776176000256
						],
						[
							-82.73170833199985,
							28.039781722000004
						],
						[
							-82.73194861699976,
							28.039787318000112
						],
						[
							-82.73228662999975,
							28.039804770000313
						],
						[
							-82.73252234799979,
							28.039822766000203
						],
						[
							-82.73275496699976,
							28.03984077900036
						],
						[
							-82.7330868359997,
							28.03986651300018
						],
						[
							-82.73329472599976,
							28.039894970000315
						],
						[
							-82.7336087439998,
							28.039945552000237
						],
						[
							-82.73374781099994,
							28.03996750100019
						],
						[
							-82.7337503199997,
							28.04019474300016
						],
						[
							-82.73375310299984,
							28.04047596100016
						],
						[
							-82.73375624799984,
							28.040754084000344
						],
						[
							-82.73376074699976,
							28.04118863000024
						],
						[
							-82.7337627499979,
							28.041370685713147
						],
						[
							-82.73002399999984,
							28.041363000000104
						],
						[
							-82.73007139204711,
							28.04157771498971
						],
						[
							-82.72983719899985,
							28.0415725930003
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Springdale Homeowners Association",
				"RegionID": "343259"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.73642654399998,
					28.03790648648771,
					-82.7337184870023,
					28.04020689400001
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.7337184870023,
							28.03792995528706
						],
						[
							-82.73641031400405,
							28.03790648648771
						],
						[
							-82.73641841899983,
							28.039056564000223
						],
						[
							-82.73642654399998,
							28.04020689400001
						],
						[
							-82.73586310199981,
							28.040132214000227
						],
						[
							-82.73373083799987,
							28.039750306000247
						],
						[
							-82.73371991199986,
							28.038139977000146
						],
						[
							-82.7337184870023,
							28.03792995528706
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Woodland Villas Condominium Association",
				"RegionID": "343261"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.7242637989999,
					28.020917094000126,
					-82.71774961399987,
					28.024699578000096
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.71775711999996,
							28.02126051900003
						],
						[
							-82.71774961399987,
							28.020917094000126
						],
						[
							-82.71803791499991,
							28.02092555800003
						],
						[
							-82.71826917099996,
							28.020934320000045
						],
						[
							-82.71859596199991,
							28.020948427000057
						],
						[
							-82.71880059899988,
							28.0209597340001
						],
						[
							-82.7190455219999,
							28.020970142000074
						],
						[
							-82.71927775199991,
							28.020979928000088
						],
						[
							-82.71950775399993,
							28.02098938300007
						],
						[
							-82.71973998199988,
							28.020998825000053
						],
						[
							-82.71996911099993,
							28.021008282000125
						],
						[
							-82.72020163199997,
							28.021018066000046
						],
						[
							-82.7204626529999,
							28.021031138000062
						],
						[
							-82.7207234619999,
							28.021056587000125
						],
						[
							-82.7209941169999,
							28.021105707000107
						],
						[
							-82.72123755999989,
							28.021170097000013
						],
						[
							-82.7214814359999,
							28.021255800000084
						],
						[
							-82.72172139199995,
							28.021363527000027
						],
						[
							-82.72194440599993,
							28.021487158000042
						],
						[
							-82.7221607839999,
							28.021632139000047
						],
						[
							-82.72236305299994,
							28.021796103000028
						],
						[
							-82.7224485009999,
							28.02187163600006
						],
						[
							-82.72253144499992,
							28.021949244000083
						],
						[
							-82.72271191199994,
							28.022097507000097
						],
						[
							-82.72290308899994,
							28.022225086000084
						],
						[
							-82.72311276599989,
							28.022338127000115
						],
						[
							-82.72333249799995,
							28.022433580000012
						],
						[
							-82.72366052699991,
							28.022544966000083
						],
						[
							-82.72387181299989,
							28.022579953000047
						],
						[
							-82.7240930879999,
							28.022616262000028
						],
						[
							-82.72411627099987,
							28.02262141100001
						],
						[
							-82.7241446479999,
							28.022635760000046
						],
						[
							-82.7241712759999,
							28.022663210000097
						],
						[
							-82.7241821019999,
							28.022692634000045
						],
						[
							-82.72418184199996,
							28.022954101000003
						],
						[
							-82.72420784399989,
							28.02327886100005
						],
						[
							-82.7242637989999,
							28.02357836700006
						],
						[
							-82.7211807879999,
							28.024699578000096
						],
						[
							-82.7181578339999,
							28.024050486000036
						],
						[
							-82.71781913999993,
							28.023455406000004
						],
						[
							-82.71781465299992,
							28.023290058
						],
						[
							-82.71780752099995,
							28.023018143000066
						],
						[
							-82.71780097799986,
							28.022776137000022
						],
						[
							-82.7177940679999,
							28.02252313100005
						],
						[
							-82.71778748599989,
							28.022275624000088
						],
						[
							-82.71778082599987,
							28.02203086700009
						],
						[
							-82.7177734999999,
							28.021758610000035
						],
						[
							-82.71776643899993,
							28.021497353000086
						],
						[
							-82.7177584209999,
							28.021310364000072
						],
						[
							-82.71775711999996,
							28.02126051900003
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Oak Forest of Countryside HOA",
				"RegionID": "343268"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.72899582199993,
					28.01202418800009,
					-82.72137297099991,
					28.01868687500007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.7213921169999,
							28.01478649700003
						],
						[
							-82.72138610999993,
							28.01314381500001
						],
						[
							-82.72138423299995,
							28.01262948800008
						],
						[
							-82.72137297099991,
							28.012102146000064
						],
						[
							-82.72158621599996,
							28.012099995000057
						],
						[
							-82.72366744599995,
							28.01207770800008
						],
						[
							-82.72408735399998,
							28.01207343400008
						],
						[
							-82.72435851199992,
							28.012070630000025
						],
						[
							-82.72481744899997,
							28.012066148000102
						],
						[
							-82.72581405199992,
							28.012056076000064
						],
						[
							-82.7263160819999,
							28.012051018000093
						],
						[
							-82.7265544079999,
							28.012048383000053
						],
						[
							-82.7270567319999,
							28.012043664000103
						],
						[
							-82.72755227199994,
							28.012038635000046
						],
						[
							-82.72779989499992,
							28.012035949000087
						],
						[
							-82.72829291899986,
							28.01203093100012
						],
						[
							-82.72869055199989,
							28.012027104000072
						],
						[
							-82.72898117799987,
							28.01202418800009
						],
						[
							-82.72898324799986,
							28.012374861000062
						],
						[
							-82.7289845039999,
							28.012647838000092
						],
						[
							-82.7289900189999,
							28.01365378900001
						],
						[
							-82.72899582199993,
							28.014702371000084
						],
						[
							-82.7289707799999,
							28.01447868500005
						],
						[
							-82.7289450819999,
							28.014387713000076
						],
						[
							-82.72891039499987,
							28.01429919400003
						],
						[
							-82.72886701099993,
							28.01421347300005
						],
						[
							-82.72881561399994,
							28.014131575000107
						],
						[
							-82.72875620499991,
							28.014053846000074
						],
						[
							-82.72868975999991,
							28.01398131100011
						],
						[
							-82.72861608799997,
							28.013913971000044
						],
						[
							-82.72853606499991,
							28.01385251000002
						],
						[
							-82.72843704299997,
							28.013789087000106
						],
						[
							-82.72818033699987,
							28.013680085000054
						],
						[
							-82.72811300999989,
							28.01366359500011
						],
						[
							-82.7280025649999,
							28.01364389500008
						],
						[
							-82.72789052899995,
							28.01363245500002
						],
						[
							-82.72777778099996,
							28.01363030200011
						],
						[
							-82.72766528399988,
							28.01363639800008
						],
						[
							-82.7275538159999,
							28.013651772000024
						],
						[
							-82.72748882699993,
							28.01366586900012
						],
						[
							-82.72744395199996,
							28.013675389000113
						],
						[
							-82.72733724399991,
							28.01370724000008
						],
						[
							-82.72725683599992,
							28.01373276400006
						],
						[
							-82.7272114109999,
							28.013747100000003
						],
						[
							-82.72706994799992,
							28.013780854000046
						],
						[
							-82.72692598599991,
							28.013803275000036
						],
						[
							-82.72678039499993,
							28.01381401500004
						],
						[
							-82.72671192299995,
							28.013814377000067
						],
						[
							-82.72663414999992,
							28.013814101000044
						],
						[
							-82.72648841199994,
							28.01380283800009
						],
						[
							-82.72634443499994,
							28.01377987600005
						],
						[
							-82.72616381899991,
							28.01373819800007
						],
						[
							-82.72592048599994,
							28.013687913000084
						],
						[
							-82.72568549299986,
							28.013639646000087
						],
						[
							-82.72544313499988,
							28.013590041000064
						],
						[
							-82.72519398099986,
							28.013538753
						],
						[
							-82.72498847499992,
							28.013496518000053
						],
						[
							-82.72464830199993,
							28.013418892000026
						],
						[
							-82.7246030129999,
							28.013410192000016
						],
						[
							-82.72444017799994,
							28.013391109000043
						],
						[
							-82.72438156999996,
							28.01338901200004
						],
						[
							-82.72427587999992,
							28.01338509900008
						],
						[
							-82.7241059109999,
							28.013392527000065
						],
						[
							-82.72375540599994,
							28.013457290000098
						],
						[
							-82.72362976999993,
							28.013497489000045
						],
						[
							-82.72350866399997,
							28.013548666000105
						],
						[
							-82.72342274199997,
							28.013590032000067
						],
						[
							-82.72336716899989,
							28.01362195500004
						],
						[
							-82.72330021399993,
							28.01366046900003
						],
						[
							-82.72318481999989,
							28.013740496000082
						],
						[
							-82.72307790599993,
							28.013829073000043
						],
						[
							-82.72302460399996,
							28.013881613000123
						],
						[
							-82.7229799559999,
							28.01392516700008
						],
						[
							-82.72289049399987,
							28.01403101500005
						],
						[
							-82.72281431299987,
							28.014138856000088
						],
						[
							-82.72277391399992,
							28.01420920500005
						],
						[
							-82.7227478739999,
							28.014254724000082
						],
						[
							-82.7226931799999,
							28.01437465700006
						],
						[
							-82.7226503269999,
							28.014498653000103
						],
						[
							-82.72261989199987,
							28.014625678000044
						],
						[
							-82.72260169299996,
							28.014757796000055
						],
						[
							-82.72259653299997,
							28.014884344000045
						],
						[
							-82.72260109799991,
							28.015016686000067
						],
						[
							-82.72260929799997,
							28.01531644300009
						],
						[
							-82.72262068599993,
							28.0155859290001
						],
						[
							-82.7226299299999,
							28.015853706000044
						],
						[
							-82.72263722599988,
							28.016163439000096
						],
						[
							-82.72264908399988,
							28.016633705000103
						],
						[
							-82.72268997699989,
							28.01691231800006
						],
						[
							-82.72273042999987,
							28.017023843000054
						],
						[
							-82.72278087199996,
							28.01712981400003
						],
						[
							-82.72283871599986,
							28.01722749500003
						],
						[
							-82.72289003599994,
							28.01729839400012
						],
						[
							-82.72290724099993,
							28.01732202600003
						],
						[
							-82.72298492999997,
							28.017411007000113
						],
						[
							-82.72303454599998,
							28.01745819200002
						],
						[
							-82.72307139099992,
							28.01749341
						],
						[
							-82.72316516799995,
							28.017569242000057
						],
						[
							-82.7232632319999,
							28.01763439300003
						],
						[
							-82.72352452199993,
							28.01777604200003
						],
						[
							-82.72376721699995,
							28.01791778800012
						],
						[
							-82.72359773799987,
							28.018152125000057
						],
						[
							-82.72346808799998,
							28.018331244000045
						],
						[
							-82.72322979699989,
							28.018660491000023
						],
						[
							-82.7228114249999,
							28.01866647400007
						],
						[
							-82.72230937999993,
							28.01867392600007
						],
						[
							-82.72206765299991,
							28.01867725900008
						],
						[
							-82.72168085199989,
							28.018683073000112
						],
						[
							-82.72141501199992,
							28.01868687500007
						],
						[
							-82.7214127069999,
							28.018297352999994
						],
						[
							-82.7214114309999,
							28.018062195000077
						],
						[
							-82.72141030799989,
							28.01785041600005
						],
						[
							-82.72140930199988,
							28.01764138600008
						],
						[
							-82.72140552499994,
							28.016943476000066
						],
						[
							-82.72140443699993,
							28.016780174000054
						],
						[
							-82.72140068299989,
							28.016217036000086
						],
						[
							-82.7213987609999,
							28.015928592000115
						],
						[
							-82.72139582599993,
							28.01548819
						],
						[
							-82.72139386299995,
							28.01519355600005
						],
						[
							-82.7213921169999,
							28.01478649700003
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Cypress Bend Homeowners Association",
				"RegionID": "343275"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.72894564699995,
					28.015444014000074,
					-82.72633205499997,
					28.017824566000044
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.72704314599991,
							28.01606319000006
						],
						[
							-82.7271040719999,
							28.015444014000074
						],
						[
							-82.72750098399987,
							28.01547492000006
						],
						[
							-82.7277278879999,
							28.01557273500007
						],
						[
							-82.7287443529999,
							28.015559098000004
						],
						[
							-82.72875211799992,
							28.016252172000065
						],
						[
							-82.72876052799991,
							28.016350457000023
						],
						[
							-82.72877851799988,
							28.016447315000043
						],
						[
							-82.72880579199992,
							28.016542749000042
						],
						[
							-82.72884244499994,
							28.01663538200006
						],
						[
							-82.7288882789999,
							28.01672487300001
						],
						[
							-82.72892743499995,
							28.016786551000045
						],
						[
							-82.72894122899994,
							28.01680710600006
						],
						[
							-82.72894564699995,
							28.01683029000012
						],
						[
							-82.72894154399997,
							28.01685386200002
						],
						[
							-82.72891945099991,
							28.01688096900004
						],
						[
							-82.72881889799994,
							28.016964187
						],
						[
							-82.72864033899991,
							28.017099219000073
						],
						[
							-82.72844928299992,
							28.017219876000105
						],
						[
							-82.72824698599996,
							28.017325122000024
						],
						[
							-82.72803528299994,
							28.017414258000116
						],
						[
							-82.72781571999991,
							28.017486933000086
						],
						[
							-82.72775636399987,
							28.01750340600003
						],
						[
							-82.72644847699992,
							28.017824566000044
						],
						[
							-82.72635284899991,
							28.017574092000103
						],
						[
							-82.72638749299993,
							28.017194345000036
						],
						[
							-82.72679132599987,
							28.01687040700006
						],
						[
							-82.72633205499997,
							28.01632274300004
						],
						[
							-82.72704314599991,
							28.01606319000006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Winding Wood X",
				"RegionID": "343277"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.72713063399996,
					28.01379486300005,
					-82.72506608599994,
					28.01632274300004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.72633205499997,
							28.01632274300004
						],
						[
							-82.72610406299994,
							28.016062654000017
						],
						[
							-82.72535856499991,
							28.01627562500005
						],
						[
							-82.72528503599993,
							28.015940457000028
						],
						[
							-82.72506608599994,
							28.015641812000098
						],
						[
							-82.72532830099996,
							28.014996820000114
						],
						[
							-82.72528430499996,
							28.01490628700008
						],
						[
							-82.72534588199993,
							28.01484545200011
						],
						[
							-82.72525586299992,
							28.014361846000064
						],
						[
							-82.72527019799995,
							28.01418849200011
						],
						[
							-82.72525116099989,
							28.014122581000073
						],
						[
							-82.7253295449999,
							28.01379486300005
						],
						[
							-82.7262388909999,
							28.01398534300009
						],
						[
							-82.72641235299996,
							28.01401468200003
						],
						[
							-82.72658785699991,
							28.0140306010001
						],
						[
							-82.72676452699996,
							28.014032761000102
						],
						[
							-82.72692406999992,
							28.014022978000092
						],
						[
							-82.72699385699993,
							28.014261899000054
						],
						[
							-82.7269698959999,
							28.014385797000003
						],
						[
							-82.72702647399987,
							28.014503767000086
						],
						[
							-82.72712583499992,
							28.01499282400005
						],
						[
							-82.72710856999991,
							28.0151909480001
						],
						[
							-82.72713063399996,
							28.01524584100011
						],
						[
							-82.7271040719999,
							28.015444014000074
						],
						[
							-82.72704314599991,
							28.01606319000006
						],
						[
							-82.72633205499997,
							28.01632274300004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Winding Wood No.8 Condominium Association",
				"RegionID": "343284"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.73168855299988,
					28.01063542800003,
					-82.72961763399987,
					28.015849182000025
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.73000403999994,
							28.010709197000004
						],
						[
							-82.73023471799993,
							28.01063542800003
						],
						[
							-82.73034006299994,
							28.010818806000103
						],
						[
							-82.73036650299991,
							28.010919057000045
						],
						[
							-82.73036666899993,
							28.011173474000046
						],
						[
							-82.73032387399994,
							28.01117542000012
						],
						[
							-82.73032107099989,
							28.01149173800009
						],
						[
							-82.73077171699995,
							28.011493468000054
						],
						[
							-82.73103208899992,
							28.011915999000024
						],
						[
							-82.73108821299995,
							28.012009216000095
						],
						[
							-82.73117010099988,
							28.012246351000087
						],
						[
							-82.73122878599995,
							28.012489455000043
						],
						[
							-82.73126299099992,
							28.012735783000082
						],
						[
							-82.73127050499993,
							28.012844386000012
						],
						[
							-82.73127746899988,
							28.013000781000073
						],
						[
							-82.7313108969999,
							28.013733945000073
						],
						[
							-82.7313324059999,
							28.01420828500006
						],
						[
							-82.73137372999994,
							28.014361403000034
						],
						[
							-82.73143022999992,
							28.01451031400009
						],
						[
							-82.7315009389999,
							28.01465468100005
						],
						[
							-82.73151534999994,
							28.014680390000045
						],
						[
							-82.73161382799991,
							28.014892682000024
						],
						[
							-82.73166017799993,
							28.015015175000123
						],
						[
							-82.73168855299988,
							28.015086536000076
						],
						[
							-82.73168825599994,
							28.015114386000075
						],
						[
							-82.73166353099994,
							28.015146148000035
						],
						[
							-82.73156804399994,
							28.01518309900007
						],
						[
							-82.73119296199991,
							28.015315398000006
						],
						[
							-82.73083210799989,
							28.015475813000045
						],
						[
							-82.73077062099996,
							28.01550639500009
						],
						[
							-82.73056992799987,
							28.015618855000064
						],
						[
							-82.73038018199989,
							28.015746041000025
						],
						[
							-82.73025099999987,
							28.015849182000025
						],
						[
							-82.72964768899995,
							28.015314671000034
						],
						[
							-82.72963461299993,
							28.014294320000076
						],
						[
							-82.72963042099994,
							28.012752710000065
						],
						[
							-82.72962490899992,
							28.011934821000068
						],
						[
							-82.72962001599988,
							28.01120872500003
						],
						[
							-82.72961763399987,
							28.01081198400007
						],
						[
							-82.72995457799993,
							28.01072768100002
						],
						[
							-82.73000403999994,
							28.010709197000004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Inverness Park Homeowners Association",
				"RegionID": "343286"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.7287443529999,
					28.013845657000076,
					-82.72692406999992,
					28.01557273500007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.72773487599996,
							28.013846097000027
						],
						[
							-82.7278179689999,
							28.013845657000076
						],
						[
							-82.72790100799993,
							28.013851061000082
						],
						[
							-82.72798292799988,
							28.013863348000122
						],
						[
							-82.72806363199989,
							28.013881830000052
						],
						[
							-82.72814185599988,
							28.01390617000002
						],
						[
							-82.72821770599985,
							28.013937055000003
						],
						[
							-82.7282901969999,
							28.013973114000052
						],
						[
							-82.7283589539999,
							28.01401503800006
						],
						[
							-82.72842309299996,
							28.01406180000002
						],
						[
							-82.7284823279999,
							28.014113745000056
						],
						[
							-82.72853665099986,
							28.01416984200008
						],
						[
							-82.72858509199996,
							28.01422975100006
						],
						[
							-82.7286273599999,
							28.014293475000002
						],
						[
							-82.72866315799993,
							28.014359984000087
						],
						[
							-82.72869238799987,
							28.014429278000055
						],
						[
							-82.72871456099992,
							28.014500329000064
						],
						[
							-82.72872996499987,
							28.014572790000024
						],
						[
							-82.7287379189999,
							28.014646667000093
						],
						[
							-82.72873870599997,
							28.014720238000052
						],
						[
							-82.7287443529999,
							28.015559098000004
						],
						[
							-82.7277278879999,
							28.01557273500007
						],
						[
							-82.72750098399987,
							28.01547492000006
						],
						[
							-82.7271040719999,
							28.015444014000074
						],
						[
							-82.72713063399996,
							28.01524584100011
						],
						[
							-82.72710856999991,
							28.0151909480001
						],
						[
							-82.72712583499992,
							28.01499282400005
						],
						[
							-82.72702647399987,
							28.014503767000086
						],
						[
							-82.7269698959999,
							28.014385797000003
						],
						[
							-82.72699385699993,
							28.014261899000054
						],
						[
							-82.72692406999992,
							28.014022978000092
						],
						[
							-82.72696374099992,
							28.01401761100001
						],
						[
							-82.72717510299991,
							28.013979018000008
						],
						[
							-82.7273820909999,
							28.01392428900001
						],
						[
							-82.72741203399998,
							28.013912441000095
						],
						[
							-82.72749001899986,
							28.013886587000087
						],
						[
							-82.72757017499991,
							28.013866909000058
						],
						[
							-82.72765182599993,
							28.013853412000095
						],
						[
							-82.72773487599996,
							28.013846097000027
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Winding Wood IX",
				"RegionID": "343291"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.72425454099994,
					28.009891457000023,
					-82.72329328899991,
					28.01070581100008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.7233213289999,
							28.0099063200001
						],
						[
							-82.72425066799988,
							28.009891457000023
						],
						[
							-82.72425454099994,
							28.01070213500013
						],
						[
							-82.7232953879999,
							28.01070581100008
						],
						[
							-82.72329328899991,
							28.010391581000103
						],
						[
							-82.7233245699999,
							28.01039141600009
						],
						[
							-82.7233213289999,
							28.0099063200001
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Oaks of Northwood - The Condo Association",
				"RegionID": "343293"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.76296131199987,
					27.992288563000074,
					-82.75896660799992,
					27.997127611000067
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.75897345399996,
							27.994190190000033
						],
						[
							-82.75896875199994,
							27.993829906000066
						],
						[
							-82.75896660799992,
							27.993655264000004
						],
						[
							-82.7592915919999,
							27.99364384300012
						],
						[
							-82.75947208799991,
							27.993623249000017
						],
						[
							-82.75974803699992,
							27.99360625300003
						],
						[
							-82.75998996399996,
							27.993591508000062
						],
						[
							-82.76024452099996,
							27.99357566100008
						],
						[
							-82.76048087699989,
							27.993560602000073
						],
						[
							-82.76071994499996,
							27.99354518400004
						],
						[
							-82.76095349599991,
							27.99353048300007
						],
						[
							-82.76111019899992,
							27.993520677000056
						],
						[
							-82.76120153699992,
							27.99351054500002
						],
						[
							-82.76134421899994,
							27.99348328200007
						],
						[
							-82.76143712499997,
							27.99345509100005
						],
						[
							-82.76152470999993,
							27.99342074100005
						],
						[
							-82.76160963199995,
							27.993379357000002
						],
						[
							-82.7616553349999,
							27.99335194400004
						],
						[
							-82.7622283989999,
							27.993987218000118
						],
						[
							-82.76225224499991,
							27.993990524000118
						],
						[
							-82.76254638499991,
							27.99360039100008
						],
						[
							-82.76254503199989,
							27.99323596300004
						],
						[
							-82.76254232699993,
							27.992631565000032
						],
						[
							-82.76295512299988,
							27.992288563000074
						],
						[
							-82.76295591299996,
							27.992840713000106
						],
						[
							-82.7629573359999,
							27.994053656000105
						],
						[
							-82.76295778599993,
							27.99424824800004
						],
						[
							-82.7629594219999,
							27.995539234000006
						],
						[
							-82.7629596009999,
							27.995736578000084
						],
						[
							-82.76296087599992,
							27.99688694900005
						],
						[
							-82.76296131199987,
							27.997127611000067
						],
						[
							-82.76264585099997,
							27.99712454800008
						],
						[
							-82.76240074599994,
							27.997122469000093
						],
						[
							-82.76219558799993,
							27.997120512000016
						],
						[
							-82.76197212699991,
							27.99711831300001
						],
						[
							-82.76166939999992,
							27.997115520000044
						],
						[
							-82.76146763399991,
							27.99711388700009
						],
						[
							-82.76119217499986,
							27.99711231800005
						],
						[
							-82.76097835199994,
							27.997110752000097
						],
						[
							-82.76076453199991,
							27.997109528000085
						],
						[
							-82.7605507089999,
							27.997107961000044
						],
						[
							-82.76033407999992,
							27.997106408
						],
						[
							-82.76012055099993,
							27.997105182000077
						],
						[
							-82.75987946699988,
							27.99710342000011
						],
						[
							-82.75966908399997,
							27.997102176000098
						],
						[
							-82.75944035099987,
							27.997100689000067
						],
						[
							-82.75922962899993,
							27.99709944600005
						],
						[
							-82.75901057599992,
							27.997097905000096
						],
						[
							-82.75900834199992,
							27.99691707500006
						],
						[
							-82.7590049599999,
							27.996655456000084
						],
						[
							-82.75900313699992,
							27.996526539000072
						],
						[
							-82.75900029899996,
							27.996294485000057
						],
						[
							-82.75898737499996,
							27.99529270200013
						],
						[
							-82.7589866999999,
							27.995238041000047
						],
						[
							-82.7589769349999,
							27.994465904000016
						],
						[
							-82.75897345399996,
							27.994190190000033
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Montclair Lake Estates Homeowners Assoc",
				"RegionID": "343309"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.71295499999991,
					27.986291680000114,
					-82.71021781699991,
					27.991797050000088
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.71240604099997,
							27.986779253000044
						],
						[
							-82.71294690099995,
							27.986291680000114
						],
						[
							-82.71294791299994,
							27.98696072800005
						],
						[
							-82.71294822399997,
							27.98717531000004
						],
						[
							-82.71294878999994,
							27.987565140000058
						],
						[
							-82.71295499999991,
							27.9882140000001
						],
						[
							-82.7129495369999,
							27.988252755000104
						],
						[
							-82.71294973899991,
							27.988695581000066
						],
						[
							-82.71294964599991,
							27.989108152000092
						],
						[
							-82.71294936299998,
							27.989962864000027
						],
						[
							-82.71261191699995,
							27.98996323800006
						],
						[
							-82.71261617899994,
							27.99065564800006
						],
						[
							-82.71258075399994,
							27.990922971000064
						],
						[
							-82.71286272899991,
							27.99092391600005
						],
						[
							-82.71286216399996,
							27.99130898600003
						],
						[
							-82.71286321299995,
							27.991468508000082
						],
						[
							-82.71287059399994,
							27.991795776000068
						],
						[
							-82.71186665499992,
							27.991796163000107
						],
						[
							-82.71163271299993,
							27.991796343000118
						],
						[
							-82.71043201599987,
							27.991797050000088
						],
						[
							-82.71042459099998,
							27.991461874000066
						],
						[
							-82.71042354499988,
							27.991302352000012
						],
						[
							-82.71042101999986,
							27.990917298000035
						],
						[
							-82.7102240509999,
							27.99064876900011
						],
						[
							-82.71022281899988,
							27.989987973000062
						],
						[
							-82.71021781699991,
							27.988752004000027
						],
						[
							-82.71055510999993,
							27.9884480530001
						],
						[
							-82.7112438379999,
							27.987827012000054
						],
						[
							-82.71159103599994,
							27.987514068000095
						],
						[
							-82.71193381099997,
							27.987205272000033
						],
						[
							-82.71211217199989,
							27.98704413400012
						],
						[
							-82.71240604099997,
							27.986779253000044
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Forest Wood Homeowners Association",
				"RegionID": "343316"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.75055723999994,
					27.98801805000005,
					-82.74740680899994,
					27.98971325100007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.74740680899994,
							27.988048258000063
						],
						[
							-82.74741106599994,
							27.98801805000005
						],
						[
							-82.7478647219999,
							27.98802125700005
						],
						[
							-82.74828889599992,
							27.988024450000047
						],
						[
							-82.7489049369999,
							27.988028661000037
						],
						[
							-82.74929536099997,
							27.988031348000085
						],
						[
							-82.7505332599999,
							27.98804041300012
						],
						[
							-82.75055723999994,
							27.98971325100007
						],
						[
							-82.7474245559999,
							27.98970040100007
						],
						[
							-82.74741968999987,
							27.989105414000047
						],
						[
							-82.74741838999992,
							27.988946464000037
						],
						[
							-82.74740680899994,
							27.988048258000063
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Raintree Village Condominium Association",
				"RegionID": "343318"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.74195065599989,
					27.97763799200007,
					-82.73387032099993,
					27.984677350000126
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.73388789799995,
							27.983505328000057
						],
						[
							-82.73389419499995,
							27.98319105300008
						],
						[
							-82.73390175799994,
							27.982806634000063
						],
						[
							-82.73390937199987,
							27.98255836400004
						],
						[
							-82.7339131219999,
							27.982325585000055
						],
						[
							-82.73392970099987,
							27.981213619000066
						],
						[
							-82.73394151599986,
							27.980441705000057
						],
						[
							-82.73458547999994,
							27.980086207000042
						],
						[
							-82.73505494499997,
							27.979826874000075
						],
						[
							-82.73526532099989,
							27.979696134000097
						],
						[
							-82.73580588699993,
							27.97931436600004
						],
						[
							-82.73602812799993,
							27.97914918000005
						],
						[
							-82.73606605699987,
							27.979117347000077
						],
						[
							-82.73624252599991,
							27.978969596000113
						],
						[
							-82.73642765299988,
							27.978814579000073
						],
						[
							-82.73660588699995,
							27.97866320900008
						],
						[
							-82.73679155499987,
							27.97851626700008
						],
						[
							-82.73698232599993,
							27.978365344000032
						],
						[
							-82.73798881299989,
							27.97767644500005
						],
						[
							-82.73804499299992,
							27.97763799200007
						],
						[
							-82.73810730299992,
							27.977720769000083
						],
						[
							-82.73844864699993,
							27.978174231000118
						],
						[
							-82.73851644399994,
							27.978262913000084
						],
						[
							-82.7386341879999,
							27.978399805000038
						],
						[
							-82.73877487799992,
							27.978536917000014
						],
						[
							-82.73892875599995,
							27.978662268000086
						],
						[
							-82.7390848019999,
							27.97877935600009
						],
						[
							-82.73934277299992,
							27.97894918700011
						],
						[
							-82.73943861899994,
							27.97901227600009
						],
						[
							-82.73959518899993,
							27.97909601200009
						],
						[
							-82.73993367499988,
							27.97927778500012
						],
						[
							-82.7400070899999,
							27.979317272000102
						],
						[
							-82.74047199499992,
							27.979569189000078
						],
						[
							-82.74062706699996,
							27.979642272000078
						],
						[
							-82.74083511299995,
							27.979752890000086
						],
						[
							-82.74097783599994,
							27.979832229000074
						],
						[
							-82.74114901099998,
							27.97994510700009
						],
						[
							-82.74130851099996,
							27.980071113000037
						],
						[
							-82.74147080299987,
							27.980194697000044
						],
						[
							-82.74157928999996,
							27.980293817000078
						],
						[
							-82.74160486399985,
							27.980317058000047
						],
						[
							-82.74172597299993,
							27.98044945900008
						],
						[
							-82.74183412099991,
							27.980590868000053
						],
						[
							-82.74179922999987,
							27.98064950400002
						],
						[
							-82.74159304199995,
							27.980994768000073
						],
						[
							-82.7414175329999,
							27.981288983000084
						],
						[
							-82.7413734509999,
							27.981362796000063
						],
						[
							-82.7412747199999,
							27.98147265900009
						],
						[
							-82.74111636499994,
							27.981649198000042
						],
						[
							-82.74095430599996,
							27.981829196000014
						],
						[
							-82.74079321199994,
							27.98200884400005
						],
						[
							-82.74075751499991,
							27.982048574000046
						],
						[
							-82.7413852439999,
							27.982046567000065
						],
						[
							-82.74146933499992,
							27.98204632100004
						],
						[
							-82.74194413699988,
							27.98204492900001
						],
						[
							-82.7419446019999,
							27.982608085000066
						],
						[
							-82.74193799999998,
							27.98293800000001
						],
						[
							-82.74194491799993,
							27.98319874600009
						],
						[
							-82.74194275899993,
							27.98333593700007
						],
						[
							-82.74195065599989,
							27.9838106940001
						],
						[
							-82.74191583099991,
							27.98381999300007
						],
						[
							-82.74101873599994,
							27.98381846800003
						],
						[
							-82.74101241799987,
							27.984273928000057
						],
						[
							-82.74101166699998,
							27.984328031000093
						],
						[
							-82.74071567299991,
							27.984329624000047
						],
						[
							-82.73957826499995,
							27.984334945000047
						],
						[
							-82.73957489899995,
							27.984357322000033
						],
						[
							-82.7395561939999,
							27.9844816390001
						],
						[
							-82.73925256099992,
							27.984347811000042
						],
						[
							-82.7389088509999,
							27.98405879600002
						],
						[
							-82.73899352499988,
							27.983980984000063
						],
						[
							-82.7387896299999,
							27.98365649300004
						],
						[
							-82.73899765799987,
							27.98354329300009
						],
						[
							-82.73889579099998,
							27.983279108000076
						],
						[
							-82.73767135899992,
							27.983335141000097
						],
						[
							-82.73702343199996,
							27.983364791000067
						],
						[
							-82.7370830059999,
							27.983634141000053
						],
						[
							-82.73709695399991,
							27.983697204000034
						],
						[
							-82.73666937799997,
							27.983762169000084
						],
						[
							-82.73649649499997,
							27.983788436000033
						],
						[
							-82.73619598799988,
							27.983836115000067
						],
						[
							-82.73588382899992,
							27.983907234000093
						],
						[
							-82.73558849999998,
							27.983990297000034
						],
						[
							-82.73529065699994,
							27.98407406000004
						],
						[
							-82.73512617799992,
							27.984120322000045
						],
						[
							-82.73511065999988,
							27.984354925000005
						],
						[
							-82.73510035799991,
							27.98451068200011
						],
						[
							-82.73475293499995,
							27.984515453000057
						],
						[
							-82.73479349199992,
							27.984677350000126
						],
						[
							-82.73476064499995,
							27.984660475000062
						],
						[
							-82.73451861999992,
							27.98453613800008
						],
						[
							-82.7344819779999,
							27.98453014500003
						],
						[
							-82.73420251599997,
							27.98448281600011
						],
						[
							-82.73387032099993,
							27.984426829000093
						],
						[
							-82.7338743379999,
							27.98410500300011
						],
						[
							-82.73388789799995,
							27.983505328000057
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Coachman Ridge Homeowners Association",
				"RegionID": "343320"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.7045154399999,
					27.97126900425132,
					-82.6962798010808,
					27.978236387000017
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-82.69774362305128,
								27.971273101562517
							],
							[
								-82.69779104430185,
								27.97126900425132
							],
							[
								-82.69815438389148,
								27.971271316408274
							],
							[
								-82.69789499963322,
								27.971386999798163
							],
							[
								-82.69750499964199,
								27.971499999611137
							],
							[
								-82.6971630000647,
								27.971569000093794
							],
							[
								-82.69715194829632,
								27.971569806785666
							],
							[
								-82.69719736136082,
								27.97153611098796
							],
							[
								-82.69722595170745,
								27.97151757596093
							],
							[
								-82.69730003695695,
								27.971475942746817
							],
							[
								-82.69732485644634,
								27.97146362743102
							],
							[
								-82.69740804823064,
								27.971427544832515
							],
							[
								-82.69748869583285,
								27.97139239393166
							],
							[
								-82.69754639813293,
								27.971358477799974
							],
							[
								-82.6975783519439,
								27.97133639584691
							],
							[
								-82.69761123295595,
								27.971316959699195
							],
							[
								-82.69764652864765,
								27.971302361904044
							],
							[
								-82.69769818030909,
								27.971285223524085
							],
							[
								-82.69770534161043,
								27.97128309572819
							],
							[
								-82.69774362305128,
								27.971273101562517
							]
						]
					],
					[
						[
							[
								-82.69658132127415,
								27.972503677170067
							],
							[
								-82.69659112208561,
								27.972485312114898
							],
							[
								-82.69673999945168,
								27.97281099978924
							],
							[
								-82.69688599988645,
								27.9731019997134
							],
							[
								-82.69694800004648,
								27.973298999801287
							],
							[
								-82.69695499946991,
								27.973436999867324
							],
							[
								-82.69693099926285,
								27.97356100018738
							],
							[
								-82.69683999956467,
								27.973659000208194
							],
							[
								-82.69669999940636,
								27.973758000275183
							],
							[
								-82.69659299987002,
								27.97386799994988
							],
							[
								-82.69654399940988,
								27.97395799960197
							],
							[
								-82.69652599947945,
								27.97403300036126
							],
							[
								-82.69651299977956,
								27.974082999968118
							],
							[
								-82.69655499991697,
								27.974463999544447
							],
							[
								-82.69655099973261,
								27.97466099963225
							],
							[
								-82.69650999964128,
								27.974851000296695
							],
							[
								-82.69637599975961,
								27.97524000024184
							],
							[
								-82.69632007811718,
								27.97531095405204
							],
							[
								-82.69630520782748,
								27.975277642264672
							],
							[
								-82.69629436560106,
								27.975238145839782
							],
							[
								-82.69628432736859,
								27.975186379065185
							],
							[
								-82.6962798010808,
								27.97513722212311
							],
							[
								-82.6962802003798,
								27.975122555080063
							],
							[
								-82.69628575459262,
								27.97502053239181
							],
							[
								-82.69628854698747,
								27.974970781897156
							],
							[
								-82.69629277110302,
								27.97493604018782
							],
							[
								-82.69630145585593,
								27.974902137545975
							],
							[
								-82.6963144564552,
								27.97486964414174
							],
							[
								-82.69633155436557,
								27.97483910766217
							],
							[
								-82.69634553252793,
								27.974817552711812
							],
							[
								-82.69635761132207,
								27.97479396619294
							],
							[
								-82.69637509773963,
								27.97476457365103
							],
							[
								-82.69639263361985,
								27.974738947469852
							],
							[
								-82.69641402669232,
								27.974599532770156
							],
							[
								-82.69641014072184,
								27.974554818478865
							],
							[
								-82.69640969735605,
								27.974513943393326
							],
							[
								-82.69642097485429,
								27.974340606266807
							],
							[
								-82.69642280587396,
								27.974322219627844
							],
							[
								-82.6964302675488,
								27.974266645123734
							],
							[
								-82.69642897971967,
								27.974254814542505
							],
							[
								-82.6964262538746,
								27.974243063101532
							],
							[
								-82.69641032148552,
								27.974174381878157
							],
							[
								-82.69640744185635,
								27.97416026522027
							],
							[
								-82.69640334814245,
								27.97411514893205
							],
							[
								-82.69640281844181,
								27.974032637035094
							],
							[
								-82.69640393450052,
								27.97400632467125
							],
							[
								-82.696409725235,
								27.97394303398407
							],
							[
								-82.69641716442683,
								27.97390018758458
							],
							[
								-82.69643138990274,
								27.97385909306452
							],
							[
								-82.69645203383988,
								27.97382081791889
							],
							[
								-82.69647350785125,
								27.9737877039825
							],
							[
								-82.69649839658845,
								27.9737550630894
							],
							[
								-82.69651541715714,
								27.973735951597007
							],
							[
								-82.6965234561968,
								27.973721511183165
							],
							[
								-82.69655154652038,
								27.973681017410208
							],
							[
								-82.69657796230638,
								27.973653699604235
							],
							[
								-82.69662724695226,
								27.973609442168474
							],
							[
								-82.69663408539691,
								27.97360350574379
							],
							[
								-82.69667345591674,
								27.973576098005584
							],
							[
								-82.69669168607358,
								27.97355840924064
							],
							[
								-82.69671126611277,
								27.97353495402278
							],
							[
								-82.69672522269143,
								27.973519413738074
							],
							[
								-82.69674116587233,
								27.973494003394116
							],
							[
								-82.69675201799127,
								27.97347867085292
							],
							[
								-82.69678210930631,
								27.97342082196333
							],
							[
								-82.69681352532277,
								27.97333818506068
							],
							[
								-82.69681485542004,
								27.973319094252723
							],
							[
								-82.69680412560895,
								27.973296084199305
							],
							[
								-82.69679433828733,
								27.973262598842773
							],
							[
								-82.69679091906492,
								27.97324728518727
							],
							[
								-82.69676593589898,
								27.97321079249796
							],
							[
								-82.69674704923708,
								27.97317864443339
							],
							[
								-82.69673277519777,
								27.973144199500354
							],
							[
								-82.69672097069684,
								27.97310901442532
							],
							[
								-82.69671715127616,
								27.973102705681214
							],
							[
								-82.69669756763966,
								27.97306088181098
							],
							[
								-82.69668255435775,
								27.973020032805735
							],
							[
								-82.69667038383264,
								27.973001078694658
							],
							[
								-82.69666376032592,
								27.972990205891378
							],
							[
								-82.69664368476026,
								27.972947031239343
							],
							[
								-82.69661288567875,
								27.972861253004872
							],
							[
								-82.6965949783785,
								27.972814450487814
							],
							[
								-82.69658773164159,
								27.972792808303147
							],
							[
								-82.6965687190745,
								27.972726891595677
							],
							[
								-82.69656225115054,
								27.972698973042604
							],
							[
								-82.69655815743664,
								27.97265385405646
							],
							[
								-82.69655790742516,
								27.97261448353664
							],
							[
								-82.69656046149971,
								27.972576567220507
							],
							[
								-82.69656831797695,
								27.97253938565059
							],
							[
								-82.69658132127415,
								27.972503677170067
							]
						]
					],
					[
						[
							[
								-82.69829753099995,
								27.978071036000102
							],
							[
								-82.69829737799994,
								27.97765674500002
							],
							[
								-82.69829732899993,
								27.97760379900008
							],
							[
								-82.69799368499994,
								27.977600527000078
							],
							[
								-82.69776720699994,
								27.977597550000006
							],
							[
								-82.69761569699993,
								27.977599006000045
							],
							[
								-82.69761452899992,
								27.977417480000028
							],
							[
								-82.6976141529999,
								27.97735903400008
							],
							[
								-82.69761146799993,
								27.976941661000097
							],
							[
								-82.69747231499989,
								27.976937554000113
							],
							[
								-82.69730468799987,
								27.97693221500011
							],
							[
								-82.69731320399987,
								27.976721072000053
							],
							[
								-82.69732609399995,
								27.97640676400007
							],
							[
								-82.69739669499994,
								27.97630463800006
							],
							[
								-82.69748875199991,
								27.976166647000102
							],
							[
								-82.69762053399998,
								27.975943189000084
							],
							[
								-82.69772140599989,
								27.9757308900001
							],
							[
								-82.69780365499994,
								27.975513185000036
							],
							[
								-82.69782787299991,
								27.97542504600002
							],
							[
								-82.69786412899988,
								27.975281837000075
							],
							[
								-82.69788246099998,
								27.975196823000054
							],
							[
								-82.69758164299996,
								27.975195254000106
							],
							[
								-82.69706452999989,
								27.975192374000045
							],
							[
								-82.69655920899991,
								27.975186682000107
							],
							[
								-82.69654959799992,
								27.9751372220001
							],
							[
								-82.69655513999993,
								27.97503542600011
							],
							[
								-82.6965579199999,
								27.974985903000103
							],
							[
								-82.6965793939999,
								27.974952789000028
							],
							[
								-82.6965977519999,
								27.974916940000078
							],
							[
								-82.6966223059999,
								27.97488105900004
							],
							[
								-82.69664844499992,
								27.974850672000102
							],
							[
								-82.6966856149999,
								27.974608440000047
							],
							[
								-82.69667892499987,
								27.974531460000073
							],
							[
								-82.69669020299992,
								27.974358123000034
							],
							[
								-82.69670202899992,
								27.97427004700003
							],
							[
								-82.6966954449999,
								27.974209570000085
							],
							[
								-82.69668907199991,
								27.974182097000032
							],
							[
								-82.69667313999993,
								27.974113416000122
							],
							[
								-82.69667261,
								27.974030904000045
							],
							[
								-82.69667839999993,
								27.97396761300005
							],
							[
								-82.69669987399992,
								27.97393449900006
							],
							[
								-82.69673678399995,
								27.973893055000097
							],
							[
								-82.69675822299986,
								27.973854439000007
							],
							[
								-82.69680750799995,
								27.97381018200008
							],
							[
								-82.69683222099995,
								27.973799055000043
							],
							[
								-82.6968907109999,
								27.97374099800004
							],
							[
								-82.69691838099997,
								27.973707852000047
							],
							[
								-82.69694300599987,
								27.97368297300003
							],
							[
								-82.69696138099998,
								27.973649874000046
							],
							[
								-82.69698287299988,
								27.97361951000002
							],
							[
								-82.69702877599987,
								27.973531262000098
							],
							[
								-82.69706533299987,
								27.973434809000103
							],
							[
								-82.6970806639999,
								27.97340997800009
							],
							[
								-82.6970861169999,
								27.97329443000004
							],
							[
								-82.69708266599989,
								27.973239437000103
							],
							[
								-82.69705765199986,
								27.973203808000086
							],
							[
								-82.69704170299987,
								27.97313237600004
							],
							[
								-82.69701670699993,
								27.973099496000074
							],
							[
								-82.69698855999991,
								27.973058382000133
							],
							[
								-82.69696644999995,
								27.97299248200001
							],
							[
								-82.6969508019999,
								27.972967807000103
							],
							[
								-82.69692557599986,
								27.97289917300011
							],
							[
								-82.69689741099992,
								27.97285530800012
							],
							[
								-82.69686586699989,
								27.972767452000042
							],
							[
								-82.69684696099992,
								27.97271803900013
							],
							[
								-82.69682794899985,
								27.972652123000003
							],
							[
								-82.69682770199992,
								27.972613618000107
							],
							[
								-82.69686767399995,
								27.972566657000037
							],
							[
								-82.69691979099991,
								27.97248112800007
							],
							[
								-82.69695638299991,
								27.97239017600009
							],
							[
								-82.69698939999998,
								27.9722249800001
							],
							[
								-82.69701384699997,
								27.972172597000032
							],
							[
								-82.69702581499989,
								27.97210652400007
							],
							[
								-82.69704718199996,
								27.97205690800005
							],
							[
								-82.69707472799993,
								27.972004509000065
							],
							[
								-82.69710848599989,
								27.971954829000044
							],
							[
								-82.69714854799992,
								27.971921620000046
							],
							[
								-82.69723167899988,
								27.971841435000073
							],
							[
								-82.69728721099993,
								27.97180539700011
							],
							[
								-82.69735812699994,
								27.971752778000027
							],
							[
								-82.69743221199994,
								27.97171114500013
							],
							[
								-82.69751562599991,
								27.971674966000066
							],
							[
								-82.69761139499994,
								27.97163322400008
							],
							[
								-82.6976916409999,
								27.971586058000085
							],
							[
								-82.69773173599994,
								27.9715583500001
							],
							[
								-82.69779047299991,
								27.97153879900008
							],
							[
								-82.69833167699993,
								27.971542241000105
							],
							[
								-82.69868304799988,
								27.971547678000015
							],
							[
								-82.69884076199996,
								27.97154859600009
							],
							[
								-82.69912269199992,
								27.97155025800005
							],
							[
								-82.69944799399993,
								27.97155204200002
							],
							[
								-82.69948487999996,
								27.971552199000122
							],
							[
								-82.699782593,
								27.971554123000107
							],
							[
								-82.699856656,
								27.97155443400004
							],
							[
								-82.7001109929999,
								27.971555890000076
							],
							[
								-82.70021293999989,
								27.971556403000115
							],
							[
								-82.7004275819999,
								27.971557717000046
							],
							[
								-82.7006844329999,
								27.971558472000112
							],
							[
								-82.70099085099997,
								27.97155931800009
							],
							[
								-82.70126657099993,
								27.971558945000062
							],
							[
								-82.70153299599987,
								27.9715582740001
							],
							[
								-82.7018211059999,
								27.97155749200003
							],
							[
								-82.70209992399988,
								27.971557101000087
							],
							[
								-82.70245928799996,
								27.971556298000017
							],
							[
								-82.70270405799997,
								27.971560549000102
							],
							[
								-82.70300766899993,
								27.971561405000088
							],
							[
								-82.7032895939999,
								27.971562371000076
							],
							[
								-82.70357461499995,
								27.97156297700004
							],
							[
								-82.70384414599995,
								27.971563661000097
							],
							[
								-82.70416944199987,
								27.971564403000066
							],
							[
								-82.70449163999989,
								27.97156516000004
							],
							[
								-82.7044908469999,
								27.97191997700009
							],
							[
								-82.70449225799993,
								27.972137258000124
							],
							[
								-82.70449133999995,
								27.972472822
							],
							[
								-82.70449060099989,
								27.972835890000024
							],
							[
								-82.70450126999988,
								27.973047622000045
							],
							[
								-82.7045025699999,
								27.97339692700008
							],
							[
								-82.70450396899993,
								27.973746231000028
							],
							[
								-82.70449794499987,
								27.973966301000118
							],
							[
								-82.70449859299993,
								27.974304607000043
							],
							[
								-82.70449934899992,
								27.974659416000087
							],
							[
								-82.7045131889999,
								27.97488213400004
							],
							[
								-82.7045154399999,
								27.975228683000026
							],
							[
								-82.70417773499993,
								27.975226974000066
							],
							[
								-82.70389889599996,
								27.975225651000045
							],
							[
								-82.70362315299988,
								27.975223967000083
							],
							[
								-82.7033443119999,
								27.97522229900003
							],
							[
								-82.70315531999998,
								27.97522120200003
							],
							[
								-82.70315489299995,
								27.975439180000123
							],
							[
								-82.70315398799997,
								27.975882012000085
							],
							[
								-82.70315355999993,
								27.976099303000034
							],
							[
								-82.7031522069999,
								27.976652157000032
							],
							[
								-82.70278969899994,
								27.976648507999997
							],
							[
								-82.7027840069999,
								27.976868404000072
							],
							[
								-82.70218102699992,
								27.976860653000056
							],
							[
								-82.70203510999994,
								27.976858647000064
							],
							[
								-82.70203394799992,
								27.976963515000037
							],
							[
								-82.70203200099995,
								27.977141275000093
							],
							[
								-82.70203119299988,
								27.977210729000063
							],
							[
								-82.70184221099996,
								27.97721169300006
							],
							[
								-82.7018437289999,
								27.977296951000092
							],
							[
								-82.70184905399991,
								27.97759603800006
							],
							[
								-82.70185686399994,
								27.978039514000073
							],
							[
								-82.70168335499996,
								27.978037993000036
							],
							[
								-82.70117211899993,
								27.978032692000042
							],
							[
								-82.70091805099987,
								27.97803020500001
							],
							[
								-82.70057877599996,
								27.978026775999993
							],
							[
								-82.70039440399998,
								27.97802221300006
							],
							[
								-82.7000971769999,
								27.978053294000055
							],
							[
								-82.69984984499987,
								27.978089277000016
							],
							[
								-82.69960812199994,
								27.97812454400009
							],
							[
								-82.69936079199991,
								27.978160871000078
							],
							[
								-82.69911935999991,
								27.97819613500006
							],
							[
								-82.69884358799992,
								27.978236387000017
							],
							[
								-82.6987434749999,
								27.97823620800009
							],
							[
								-82.69807212599996,
								27.978234803000063
							],
							[
								-82.69829753099995,
								27.978071036000102
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Del Oro Groves Homeowners Association",
				"RegionID": "343325"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.79587244999998,
					27.968211376000017,
					-82.7950063669999,
					27.971860529000054
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.79500837699989,
							27.970917880000044
						],
						[
							-82.79500938999988,
							27.970508056000064
						],
						[
							-82.7950095939999,
							27.970370532000054
						],
						[
							-82.79501038399988,
							27.970095483000122
						],
						[
							-82.79501263499988,
							27.969979950000067
						],
						[
							-82.79501252699997,
							27.969839678000092
						],
						[
							-82.7950127419999,
							27.96914931300008
						],
						[
							-82.79501806399989,
							27.968904492000078
						],
						[
							-82.79501827299993,
							27.968761467000057
						],
						[
							-82.7950182589999,
							27.968211376000017
						],
						[
							-82.79532497599988,
							27.968215105000056
						],
						[
							-82.79548607899997,
							27.968216924000032
						],
						[
							-82.79564718199991,
							27.968218743000094
						],
						[
							-82.79576135899993,
							27.968243868000037
						],
						[
							-82.79579277899987,
							27.968238186000104
						],
						[
							-82.79583238399994,
							27.968242856000046
						],
						[
							-82.79586589799996,
							27.968261829000106
						],
						[
							-82.79587244999998,
							27.968943560000113
						],
						[
							-82.79586161299996,
							27.969155407000052
						],
						[
							-82.79586564899994,
							27.96970547500009
						],
						[
							-82.79578045499991,
							27.969705280000078
						],
						[
							-82.79562710199993,
							27.969704448000094
						],
						[
							-82.79562387699993,
							27.96998398100004
						],
						[
							-82.79562374899992,
							27.97009193700009
						],
						[
							-82.79562059599992,
							27.970757565000014
						],
						[
							-82.79550160099993,
							27.970755503000106
						],
						[
							-82.79550088199996,
							27.970783011000073
						],
						[
							-82.79549657499987,
							27.970915058000074
						],
						[
							-82.79547179199994,
							27.97091520100009
						],
						[
							-82.79546974899996,
							27.971058924000076
						],
						[
							-82.79561908799988,
							27.971060123000086
						],
						[
							-82.79561854799992,
							27.971197649000096
						],
						[
							-82.79561769999994,
							27.971378840000078
						],
						[
							-82.79561114699993,
							27.971581037000114
						],
						[
							-82.7956150379999,
							27.971860529000054
						],
						[
							-82.7950106999999,
							27.971848895000072
						],
						[
							-82.7950063669999,
							27.971660513000117
						],
						[
							-82.79500783599993,
							27.971055406000055
						],
						[
							-82.79500837699989,
							27.970917880000044
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Drew Park Plaza Homeowners Association",
				"RegionID": "343327"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.8049758770147,
					27.960305745308847,
					-82.80325745799988,
					27.960987077973623
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-82.80325745799988,
								27.96052551700036
							],
							[
								-82.80470648799997,
								27.960519802000153
							],
							[
								-82.80452444799982,
								27.960949937000304
							],
							[
								-82.8032918799997,
								27.960951637000267
							],
							[
								-82.80329135499976,
								27.96092000900014
							],
							[
								-82.80326032899977,
								27.960913314000205
							],
							[
								-82.80325745799988,
								27.96052551700036
							]
						]
					],
					[
						[
							[
								-82.80471024246825,
								27.960678730127345
							],
							[
								-82.80486963111036,
								27.960305745308847
							],
							[
								-82.80489175353283,
								27.960323673293633
							],
							[
								-82.80491927818285,
								27.960353939077113
							],
							[
								-82.80494190962172,
								27.960388018885244
							],
							[
								-82.80495912759152,
								27.960425129408964
							],
							[
								-82.8049705377399,
								27.960464416291867
							],
							[
								-82.8049758770147,
								27.96050497661461
							],
							[
								-82.80497502086017,
								27.96054587778062
							],
							[
								-82.80497220036149,
								27.960562045792084
							],
							[
								-82.80496799175914,
								27.96058617909864
							],
							[
								-82.80495494889173,
								27.960624955166683
							],
							[
								-82.80480169272674,
								27.960987077973623
							],
							[
								-82.80479997142434,
								27.960965500540095
							],
							[
								-82.80479004470783,
								27.960924343067642
							],
							[
								-82.80477380115342,
								27.960885245941572
							],
							[
								-82.80475164095928,
								27.960849171436944
							],
							[
								-82.80472411091323,
								27.96081700718453
							],
							[
								-82.80469188685593,
								27.96078954638627
							],
							[
								-82.80466493642311,
								27.96077307080697
							],
							[
								-82.80470499942092,
								27.960690999577867
							],
							[
								-82.80471024246825,
								27.960678730127345
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Prellude 80 Condominium Association",
				"RegionID": "343334"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.80536760999965,
					27.959365553589805,
					-82.80415802099994,
					27.960562045791832
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-82.80450524399988,
								27.959613329000042
							],
							[
								-82.80509838899994,
								27.959606422
							],
							[
								-82.80475091899987,
								27.960408837000045
							],
							[
								-82.80415802099994,
								27.960410240000073
							],
							[
								-82.80450524399988,
								27.959613329000042
							]
						]
					],
					[
						[
							[
								-82.805126999988,
								27.959702999899633
							],
							[
								-82.80521945119186,
								27.959365553589805
							],
							[
								-82.80525165951107,
								27.959384308950717
							],
							[
								-82.80528365648946,
								27.959410209425194
							],
							[
								-82.80531132772907,
								27.959440688348046
							],
							[
								-82.80533402481844,
								27.95947503255703
							],
							[
								-82.80535121535898,
								27.95951243715885
							],
							[
								-82.80536249915254,
								27.959552027113276
							],
							[
								-82.80536760999965,
								27.95959287431978
							],
							[
								-82.80536642829044,
								27.95963402369862
							],
							[
								-82.80535898280337,
								27.959674511176345
							],
							[
								-82.80534544710751,
								27.959713388867634
							],
							[
								-82.80533285659914,
								27.95974167434408
							],
							[
								-82.80499849946045,
								27.96051604726862
							],
							[
								-82.80498041409444,
								27.960550689153273
							],
							[
								-82.80497220058635,
								27.960562045791832
							],
							[
								-82.80497502086024,
								27.96054587778037
							],
							[
								-82.80497587701485,
								27.960504976614452
							],
							[
								-82.80497053773996,
								27.960464416291618
							],
							[
								-82.80495912804135,
								27.960425129408804
							],
							[
								-82.80494190962177,
								27.96038801888526
							],
							[
								-82.80491927818292,
								27.960353939076953
							],
							[
								-82.80489175353289,
								27.96032367329338
							],
							[
								-82.80486963111034,
								27.960305745308688
							],
							[
								-82.80509899959658,
								27.959769000244027
							],
							[
								-82.805126999988,
								27.959702999899633
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Viewpoint on the Bay",
				"RegionID": "343336"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.72830571799993,
					27.95374119200001,
					-82.72458715699993,
					27.95688702200006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.72459994399992,
							27.955480433000034
						],
						[
							-82.72459883299992,
							27.955183730000087
						],
						[
							-82.72458715699993,
							27.955101793000054
						],
						[
							-82.72531899099992,
							27.955267608000007
						],
						[
							-82.72532523499989,
							27.954855003000066
						],
						[
							-82.7258846829999,
							27.95486305500011
						],
						[
							-82.72587674899995,
							27.9552976740001
						],
						[
							-82.72666666599994,
							27.95530450800004
						],
						[
							-82.72667944999993,
							27.954438038000028
						],
						[
							-82.72686221499995,
							27.954439823000087
						],
						[
							-82.72686373099992,
							27.95374119200001
						],
						[
							-82.72756379499992,
							27.953745745000035
						],
						[
							-82.72759071999992,
							27.953748353000073
						],
						[
							-82.72764345399995,
							27.95375976400004
						],
						[
							-82.72769314599988,
							27.95377944200007
						],
						[
							-82.72773862499992,
							27.953806019000048
						],
						[
							-82.7277588679999,
							27.95382241500007
						],
						[
							-82.72778186399994,
							27.953844985000075
						],
						[
							-82.72780967799993,
							27.953878531000008
						],
						[
							-82.72784235399988,
							27.953944714000066
						],
						[
							-82.72785412999987,
							27.95404057400009
						],
						[
							-82.72782813599994,
							27.954133885000083
						],
						[
							-82.72774670699995,
							27.954231614
						],
						[
							-82.7282247639999,
							27.954531294000013
						],
						[
							-82.72830350399994,
							27.95458073000011
						],
						[
							-82.72830571799993,
							27.95491077700006
						],
						[
							-82.72807852899987,
							27.955191325
						],
						[
							-82.72797700699992,
							27.955316837000087
						],
						[
							-82.72740082999994,
							27.9553116310001
						],
						[
							-82.7271480449999,
							27.955449116000104
						],
						[
							-82.7260252609999,
							27.95680621800004
						],
						[
							-82.72595862399989,
							27.95688702200006
						],
						[
							-82.72460216699993,
							27.956001637000078
						],
						[
							-82.72459994399992,
							27.955480433000034
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Seville Condo No.11",
				"RegionID": "343341"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.7459614069999,
					27.9531496750001,
					-82.74028766199986,
					27.95670369700008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.7422257979999,
							27.955152721000005
						],
						[
							-82.74222665899988,
							27.955009691000072
						],
						[
							-82.74141203099991,
							27.95501270700006
						],
						[
							-82.74114565199997,
							27.955013797000056
						],
						[
							-82.74028766199986,
							27.955017384000087
						],
						[
							-82.74028801999988,
							27.954934867000098
						],
						[
							-82.74029106299987,
							27.95447277000006
						],
						[
							-82.74029290299994,
							27.954238970000077
						],
						[
							-82.74029445699998,
							27.954012734000095
						],
						[
							-82.74029474399991,
							27.953969413000067
						],
						[
							-82.7402957399999,
							27.953796127000118
						],
						[
							-82.74029733599994,
							27.953576080000026
						],
						[
							-82.7402989139999,
							27.95335328300007
						],
						[
							-82.7402999699999,
							27.95318893600006
						],
						[
							-82.74038979099996,
							27.95318810900008
						],
						[
							-82.7408667729999,
							27.95318382300008
						],
						[
							-82.74137162799992,
							27.953179042000038
						],
						[
							-82.7414400609999,
							27.9531786740001
						],
						[
							-82.74199447399994,
							27.953173624000037
						],
						[
							-82.74241541999996,
							27.953171010000084
						],
						[
							-82.74309402999997,
							27.953167004000107
						],
						[
							-82.7442459469999,
							27.953159749000044
						],
						[
							-82.74591644599991,
							27.9531496750001
						],
						[
							-82.74592125199986,
							27.95363992200007
						],
						[
							-82.74592429999994,
							27.95390051300005
						],
						[
							-82.7459271179999,
							27.954134288000027
						],
						[
							-82.7459302089999,
							27.954401068000074
						],
						[
							-82.7459410449999,
							27.95489334400013
						],
						[
							-82.74594963300001,
							27.95564967900009
						],
						[
							-82.74595266799989,
							27.95590820800008
						],
						[
							-82.74595532699993,
							27.956161237000057
						],
						[
							-82.7459614069999,
							27.956686545000082
						],
						[
							-82.74554944499992,
							27.95668877700009
						],
						[
							-82.7450693349999,
							27.956690690000073
						],
						[
							-82.74450558899989,
							27.95669236500003
						],
						[
							-82.74366307199998,
							27.95669554400003
						],
						[
							-82.74280815999994,
							27.95669809800006
						],
						[
							-82.74221656199994,
							27.95670369700008
						],
						[
							-82.74221837199991,
							27.956423482000076
						],
						[
							-82.74222116299987,
							27.9559256310001
						],
						[
							-82.74222278299992,
							27.955667077000022
						],
						[
							-82.7422257979999,
							27.955152721000005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Grovewood Homeowners Association",
				"RegionID": "343343"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.74591660199992,
					27.95130967900009,
					-82.73835118199995,
					27.95494042600003
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.73838544599994,
							27.95132545500006
						],
						[
							-82.73875402499996,
							27.951323477000077
						],
						[
							-82.73893678499991,
							27.951325246000046
						],
						[
							-82.73940138999988,
							27.951324127000042
						],
						[
							-82.73973251699992,
							27.951323379000065
						],
						[
							-82.74008281099995,
							27.951322528000084
						],
						[
							-82.74037396399989,
							27.95132199400004
						],
						[
							-82.74062175099996,
							27.951321004000054
						],
						[
							-82.74092839399994,
							27.951320729000116
						],
						[
							-82.74119166699987,
							27.951319656000024
						],
						[
							-82.74144284599996,
							27.951319335000086
						],
						[
							-82.74169963599988,
							27.95131863900012
						],
						[
							-82.74179347699992,
							27.951318477000108
						],
						[
							-82.74197530099987,
							27.951317841000055
						],
						[
							-82.74222618899994,
							27.951317520000117
						],
						[
							-82.74233149999993,
							27.9513172950001
						],
						[
							-82.74259168099988,
							27.951316924000068
						],
						[
							-82.74286424799996,
							27.95131614000009
						],
						[
							-82.74338150899986,
							27.95131506700009
						],
						[
							-82.74391115899991,
							27.951313924000083
						],
						[
							-82.74417443499992,
							27.95131318900011
						],
						[
							-82.74470098999988,
							27.95131240400005
						],
						[
							-82.7447815219999,
							27.951312313000038
						],
						[
							-82.74502621299987,
							27.951311676000074
						],
						[
							-82.74506430099993,
							27.951311470000057
						],
						[
							-82.74548772099988,
							27.951310552000074
						],
						[
							-82.74559922599987,
							27.951310292000052
						],
						[
							-82.74590276799994,
							27.95130967900009
						],
						[
							-82.74590591599993,
							27.951584710000105
						],
						[
							-82.74590861299988,
							27.951843240000095
						],
						[
							-82.74591089299989,
							27.952041262000044
						],
						[
							-82.74591333199992,
							27.952396061000094
						],
						[
							-82.74591660199992,
							27.952871876000117
						],
						[
							-82.74591644599991,
							27.9531496750001
						],
						[
							-82.7442459469999,
							27.953159749000044
						],
						[
							-82.74309402999997,
							27.953167004000107
						],
						[
							-82.74241541999996,
							27.953171010000084
						],
						[
							-82.74199447399994,
							27.953173624000037
						],
						[
							-82.7414400609999,
							27.9531786740001
						],
						[
							-82.74137162799992,
							27.953179042000038
						],
						[
							-82.7408667729999,
							27.95318382300008
						],
						[
							-82.74038979099996,
							27.95318810900008
						],
						[
							-82.7402999699999,
							27.95318893600006
						],
						[
							-82.7402989139999,
							27.95335328300007
						],
						[
							-82.74029733599994,
							27.953576080000026
						],
						[
							-82.7402957399999,
							27.953796127000118
						],
						[
							-82.74029474399991,
							27.953969413000067
						],
						[
							-82.74029445699998,
							27.954012734000095
						],
						[
							-82.74029290299994,
							27.954238970000077
						],
						[
							-82.74029106299987,
							27.95447277000006
						],
						[
							-82.74028801999988,
							27.954934867000098
						],
						[
							-82.73942600899998,
							27.954937782000073
						],
						[
							-82.73917511599991,
							27.95493878600007
						],
						[
							-82.73893041599992,
							27.95493941200003
						],
						[
							-82.73874147499991,
							27.95494042600003
						],
						[
							-82.73835118199995,
							27.95493977000006
						],
						[
							-82.73835456699996,
							27.95466195300008
						],
						[
							-82.73835992699998,
							27.954219097000124
						],
						[
							-82.7383624469999,
							27.95399904500003
						],
						[
							-82.73836750699988,
							27.95356169200008
						],
						[
							-82.7383700269999,
							27.953341640000083
						],
						[
							-82.73836697899992,
							27.953206883000036
						],
						[
							-82.7383710079999,
							27.95311609500007
						],
						[
							-82.73837282399987,
							27.952885045000052
						],
						[
							-82.73837352099993,
							27.95280252700006
						],
						[
							-82.73837467899993,
							27.952659496000038
						],
						[
							-82.73837500999987,
							27.95261583000007
						],
						[
							-82.73837631699989,
							27.952444949000053
						],
						[
							-82.73837823599987,
							27.95222215000009
						],
						[
							-82.73837991099992,
							27.952013105000027
						],
						[
							-82.73838134299986,
							27.951817813000034
						],
						[
							-82.7383828949999,
							27.95163352200006
						],
						[
							-82.73838466399987,
							27.95143822900007
						],
						[
							-82.73838544599994,
							27.95132545500006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Morningside-Meadows Homeowners Association",
				"RegionID": "343345"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.75431367415302,
					27.94232915000016,
					-82.75016427199978,
					27.948460968000358
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.75421792030613,
							27.942369581920726
						],
						[
							-82.75422399999985,
							27.942393000000113
						],
						[
							-82.75425299999995,
							27.945960000000195
						],
						[
							-82.75431367415302,
							27.94846095899636
						],
						[
							-82.75398580899977,
							27.948460155000205
						],
						[
							-82.75380305399976,
							27.948458406000324
						],
						[
							-82.75333508399976,
							27.948460968000358
						],
						[
							-82.75332870299968,
							27.948392240000356
						],
						[
							-82.75302233699983,
							27.948389104000277
						],
						[
							-82.75280550799982,
							27.948386851000354
						],
						[
							-82.75237465699979,
							27.948382331000335
						],
						[
							-82.7523402919997,
							27.948381831000294
						],
						[
							-82.75210609099967,
							27.948379672000204
						],
						[
							-82.75186820799972,
							27.948377190000354
						],
						[
							-82.75163743999971,
							27.948374668000323
						],
						[
							-82.75119666799984,
							27.94837019800031
						],
						[
							-82.75093090799979,
							27.948367522000087
						],
						[
							-82.75057836999984,
							27.948363944000324
						],
						[
							-82.75020017699981,
							27.94835981700025
						],
						[
							-82.75019293699992,
							27.94766948600024
						],
						[
							-82.75019084499984,
							27.947457711000215
						],
						[
							-82.75018971099983,
							27.947251431000204
						],
						[
							-82.75018898999978,
							27.947056151000208
						],
						[
							-82.7501841719999,
							27.946107299000214
						],
						[
							-82.75018295699999,
							27.945867977000308
						],
						[
							-82.75018243999976,
							27.94583531800018
						],
						[
							-82.75017799099976,
							27.945639714000162
						],
						[
							-82.75016752399986,
							27.945161188000004
						],
						[
							-82.75016511999985,
							27.945037430000244
						],
						[
							-82.75016427199978,
							27.944998927000345
						],
						[
							-82.75032013299987,
							27.945011593000327
						],
						[
							-82.75060834599975,
							27.945035014000222
						],
						[
							-82.7507828629998,
							27.945057097000365
						],
						[
							-82.75106937499979,
							27.945059660000307
						],
						[
							-82.75152160199973,
							27.945064068000317
						],
						[
							-82.75173716699982,
							27.945066330000326
						],
						[
							-82.75199550899985,
							27.945068357000228
						],
						[
							-82.75251277499967,
							27.945072407000207
						],
						[
							-82.75250180699973,
							27.943489910000277
						],
						[
							-82.75226327499972,
							27.943482962000235
						],
						[
							-82.75227041599986,
							27.9431724620003
						],
						[
							-82.75249653699983,
							27.94317638400027
						],
						[
							-82.7525015489998,
							27.94300582700028
						],
						[
							-82.7525067899998,
							27.94268674200026
						],
						[
							-82.75251234499972,
							27.94232915000016
						],
						[
							-82.75278493899981,
							27.942335567000246
						],
						[
							-82.75300797199978,
							27.94234088000024
						],
						[
							-82.7532186129998,
							27.942345916000303
						],
						[
							-82.7534385459998,
							27.942350902000005
						],
						[
							-82.75364609099982,
							27.942355954000067
						],
						[
							-82.75386912299972,
							27.942361265000063
						],
						[
							-82.75409215499997,
							27.942366576000058
						],
						[
							-82.75421792030613,
							27.942369581920726
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Imperial Park Homeowners Association",
				"RegionID": "343350"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.72978008999984,
					27.943758999682192,
					-82.72125158576829,
					27.94586500000015
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-82.72158999999986,
								27.945602000000417
							],
							[
								-82.72140828599993,
								27.944305464000433
							],
							[
								-82.72140152499989,
								27.94422023400013
							],
							[
								-82.72142384799997,
								27.944140674000476
							],
							[
								-82.72147489199975,
								27.944074761000444
							],
							[
								-82.72155968163541,
								27.944035268855952
							],
							[
								-82.72145399924148,
								27.94406100011361
							],
							[
								-82.72139959988489,
								27.944109959854405
							],
							[
								-82.72125158576829,
								27.943922475306874
							],
							[
								-82.72126158029998,
								27.943909569572792
							],
							[
								-82.72129035770568,
								27.943877942215703
							],
							[
								-82.7213237711163,
								27.943851260230375
							],
							[
								-82.72136098056534,
								27.943830190913236
							],
							[
								-82.7214348621183,
								27.943795779255534
							],
							[
								-82.7232129993863,
								27.943775000419816
							],
							[
								-82.72473099921375,
								27.943803999957876
							],
							[
								-82.72554499986435,
								27.943787000073534
							],
							[
								-82.72601338568737,
								27.943796705880356
							],
							[
								-82.72605293244968,
								27.943816126416113
							],
							[
								-82.72611201161178,
								27.943850883414104
							],
							[
								-82.72614862750832,
								27.94387674611666
							],
							[
								-82.72618323431924,
								27.94391163801261
							],
							[
								-82.7262657354243,
								27.944013146289596
							],
							[
								-82.72630853685763,
								27.944065808788668
							],
							[
								-82.72631482401812,
								27.944032278465972
							],
							[
								-82.7263196003173,
								27.944013928699643
							],
							[
								-82.72632423002698,
								27.94399613831128
							],
							[
								-82.72634494321191,
								27.94393443762512
							],
							[
								-82.72635739882206,
								27.943903729374956
							],
							[
								-82.72637352546467,
								27.943874779300085
							],
							[
								-82.72639871457537,
								27.943835451947688
							],
							[
								-82.7264192263123,
								27.94380755048184
							],
							[
								-82.72643388256344,
								27.943792894230516
							],
							[
								-82.72685304453552,
								27.94376599290526
							],
							[
								-82.72696199953262,
								27.943758999682192
							],
							[
								-82.7271059998752,
								27.943773000327457
							],
							[
								-82.7271639998508,
								27.943787000073534
							],
							[
								-82.72718099973513,
								27.94383200034904
							],
							[
								-82.72717099927414,
								27.943865000071817
							],
							[
								-82.72713610294068,
								27.94388375001883
							],
							[
								-82.72760021599986,
								27.94388643500049
							],
							[
								-82.72760190199982,
								27.944181416000294
							],
							[
								-82.72773170799972,
								27.94418348000047
							],
							[
								-82.72773025099978,
								27.94442828100038
							],
							[
								-82.72777826099984,
								27.944428715000416
							],
							[
								-82.72978008999984,
								27.944451124000583
							],
							[
								-82.72974733799978,
								27.945741620000604
							],
							[
								-82.72393576799979,
								27.94572107500041
							],
							[
								-82.72165529799985,
								27.94571293600054
							],
							[
								-82.72159669599989,
								27.945712727000075
							],
							[
								-82.72158999999986,
								27.945602000000417
							]
						],
						[
							[
								-82.72663306080925,
								27.944662377654264
							],
							[
								-82.72648507826864,
								27.944520890916028
							],
							[
								-82.72646833199298,
								27.944846793528836
							],
							[
								-82.72647765076789,
								27.944860101696026
							],
							[
								-82.72648888689724,
								27.944884199029577
							],
							[
								-82.72651556708392,
								27.94490511995839
							],
							[
								-82.72654887797194,
								27.944931509663565
							],
							[
								-82.7265613659576,
								27.944940069411143
							],
							[
								-82.72660399202321,
								27.94496240677155
							],
							[
								-82.72661545478178,
								27.944966268460472
							],
							[
								-82.72661551683515,
								27.944935408225216
							],
							[
								-82.72661738652562,
								27.944749752185164
							],
							[
								-82.72662147214554,
								27.944705629647718
							],
							[
								-82.72663306080925,
								27.944662377654264
							]
						]
					],
					[
						[
							[
								-82.72274199999987,
								27.945838000000048
							],
							[
								-82.72238299999992,
								27.94580500000016
							],
							[
								-82.72226499999994,
								27.94580500000016
							],
							[
								-82.72222202199993,
								27.945798284000137
							],
							[
								-82.72279199976474,
								27.945804000420363
							],
							[
								-82.72353599988642,
								27.945786999636827
							],
							[
								-82.72398999923051,
								27.945786999636827
							],
							[
								-82.72403517499994,
								27.945800739000074
							],
							[
								-82.7237459999999,
								27.94586500000015
							],
							[
								-82.72366499999985,
								27.94586500000015
							],
							[
								-82.72274199999987,
								27.945838000000048
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Clearwater",
				"Name": "Imperial Cove Condominium Association",
				"RegionID": "343352"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.7304759299999,
					30.389117254000045,
					-81.69732482199993,
					30.405763946000036
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.69765499999994,
							30.399979000000087
						],
						[
							-81.69766153099994,
							30.399608533000052
						],
						[
							-81.6978351219999,
							30.399501708000056
						],
						[
							-81.69841719599992,
							30.399243008000045
						],
						[
							-81.6988375819999,
							30.399048984000046
						],
						[
							-81.69916095699996,
							30.39882262100008
						],
						[
							-81.69945199299991,
							30.39862859700008
						],
						[
							-81.69977434799995,
							30.398599292000082
						],
						[
							-81.6998077049999,
							30.39859625900004
						],
						[
							-81.70013107999995,
							30.39869327200006
						],
						[
							-81.70035744199993,
							30.398919634000038
						],
						[
							-81.70071315299992,
							30.399178333000066
						],
						[
							-81.70129522699995,
							30.399469370000077
						],
						[
							-81.70178028899994,
							30.39963105700008
						],
						[
							-81.70220067499992,
							30.399663395000058
						],
						[
							-81.70281508699992,
							30.39959872000009
						],
						[
							-81.70330014799993,
							30.399469370000077
						],
						[
							-81.70384988399991,
							30.39927534600008
						],
						[
							-81.70430260799992,
							30.39927534600008
						],
						[
							-81.70491701999993,
							30.399404695000047
						],
						[
							-81.70553143099994,
							30.399663395000058
						],
						[
							-81.70637220399993,
							30.399663395000058
						],
						[
							-81.70718063999993,
							30.399469370000077
						],
						[
							-81.70785972599992,
							30.39914599600007
						],
						[
							-81.70837712499991,
							30.39885495900006
						],
						[
							-81.70860348699995,
							30.398499247000075
						],
						[
							-81.70863582499993,
							30.39788483600006
						],
						[
							-81.70860348699995,
							30.39743211200005
						],
						[
							-81.70850647499992,
							30.396817701000085
						],
						[
							-81.70847413699994,
							30.396397314000072
						],
						[
							-81.70853881199992,
							30.396041602000086
						],
						[
							-81.70870049899992,
							30.395718228000078
						],
						[
							-81.70902387399991,
							30.395524203000036
						],
						[
							-81.70950893499992,
							30.395491866000043
						],
						[
							-81.71025269599994,
							30.395815240000047
						],
						[
							-81.7107054199999,
							30.396106277000055
						],
						[
							-81.71102879499995,
							30.396300302000046
						],
						[
							-81.71138450599994,
							30.396364977000076
						],
						[
							-81.7118372299999,
							30.39613861400005
						],
						[
							-81.71206359299993,
							30.395847578000087
						],
						[
							-81.71206359299993,
							30.39545952800006
						],
						[
							-81.71190190499993,
							30.394974467000054
						],
						[
							-81.71199891799995,
							30.394586418000078
						],
						[
							-81.71222527999993,
							30.39419836800005
						],
						[
							-81.71261332899991,
							30.393907332000083
						],
						[
							-81.71316306499995,
							30.393713307000045
						],
						[
							-81.71371280199992,
							30.39355162000004
						],
						[
							-81.7142302009999,
							30.393486945000063
						],
						[
							-81.71484461199992,
							30.393131233000076
						],
						[
							-81.71542668599994,
							30.392710847000046
						],
						[
							-81.7158794099999,
							30.392322797000077
						],
						[
							-81.71642914599994,
							30.391999423000073
						],
						[
							-81.71707589499994,
							30.391870073000067
						],
						[
							-81.71765796799991,
							30.39190241100005
						],
						[
							-81.71811069299991,
							30.39209643500004
						],
						[
							-81.71840172899994,
							30.39235513500006
						],
						[
							-81.7186604289999,
							30.39277552100009
						],
						[
							-81.71895146599991,
							30.393131233000076
						],
						[
							-81.71921016499994,
							30.39326058300008
						],
						[
							-81.71950120199995,
							30.393228245000042
						],
						[
							-81.71982457699994,
							30.39303422100005
						],
						[
							-81.72005093899992,
							30.392678509000064
						],
						[
							-81.72018028799994,
							30.39235513500006
						],
						[
							-81.72024496299991,
							30.39190241100005
						],
						[
							-81.7202773009999,
							30.39135267400008
						],
						[
							-81.72034197499994,
							30.390705926000066
						],
						[
							-81.72021262599992,
							30.38992982700006
						],
						[
							-81.72001860099994,
							30.38912139100006
						],
						[
							-81.72001838999995,
							30.389117254000045
						],
						[
							-81.72030899999993,
							30.389187000000046
						],
						[
							-81.72110790799991,
							30.38935601100007
						],
						[
							-81.72185590799995,
							30.389471010000076
						],
						[
							-81.72449790799993,
							30.38978401000009
						],
						[
							-81.72570090799992,
							30.38991201100004
						],
						[
							-81.72627290699995,
							30.38998801100007
						],
						[
							-81.72645590799993,
							30.39001701000007
						],
						[
							-81.72677590699993,
							30.390093010000044
						],
						[
							-81.7269819089999,
							30.390160011000035
						],
						[
							-81.7272799079999,
							30.390280011000076
						],
						[
							-81.72803990799991,
							30.390632011000037
						],
						[
							-81.7286809069999,
							30.390918011000053
						],
						[
							-81.7304759299999,
							30.391753922000078
						],
						[
							-81.73042290699993,
							30.391834011000075
						],
						[
							-81.73001090799995,
							30.39235701000007
						],
						[
							-81.72920973199992,
							30.393342961000087
						],
						[
							-81.72950990699991,
							30.395362010000046
						],
						[
							-81.72952990699991,
							30.39547501000004
						],
						[
							-81.72962190699991,
							30.39597501000009
						],
						[
							-81.72981990699992,
							30.397194011000067
						],
						[
							-81.73016795899991,
							30.399198995000067
						],
						[
							-81.72998890799994,
							30.399222010000074
						],
						[
							-81.72810990799991,
							30.39946101000004
						],
						[
							-81.72769890799992,
							30.39950601000004
						],
						[
							-81.72747090799993,
							30.39950801100008
						],
						[
							-81.72731390799993,
							30.39949501000007
						],
						[
							-81.72717690799993,
							30.399473010000065
						],
						[
							-81.72702490799992,
							30.399437010000046
						],
						[
							-81.7268769069999,
							30.399387010000055
						],
						[
							-81.7265819079999,
							30.399247010000067
						],
						[
							-81.7251428749999,
							30.398360822000086
						],
						[
							-81.72492690699994,
							30.398629011000086
						],
						[
							-81.72463990799992,
							30.398989010000033
						],
						[
							-81.72443390699993,
							30.39924201000008
						],
						[
							-81.72407490799992,
							30.399683011000036
						],
						[
							-81.72373990799991,
							30.400089011000038
						],
						[
							-81.72350290799994,
							30.40039301000007
						],
						[
							-81.72293090699992,
							30.40111001000008
						],
						[
							-81.72225090699993,
							30.40193401000005
						],
						[
							-81.7213859069999,
							30.403015011000036
						],
						[
							-81.72135590699992,
							30.403052011000057
						],
						[
							-81.72125690699994,
							30.403161010000076
						],
						[
							-81.72093690699995,
							30.40346801000004
						],
						[
							-81.72076090699994,
							30.40360001100004
						],
						[
							-81.72050790799995,
							30.40375801000005
						],
						[
							-81.72025690699991,
							30.403876011000083
						],
						[
							-81.7199899069999,
							30.40398901100008
						],
						[
							-81.71975688299995,
							30.40406692200008
						],
						[
							-81.71944290699992,
							30.404140010000045
						],
						[
							-81.71916890699993,
							30.404184010000055
						],
						[
							-81.71804290799992,
							30.404221010000075
						],
						[
							-81.7165389079999,
							30.404232010000047
						],
						[
							-81.71468790799992,
							30.404264011000063
						],
						[
							-81.71339095999991,
							30.404320954000067
						],
						[
							-81.7121659089999,
							30.404350012000066
						],
						[
							-81.71150190999992,
							30.404371012000073
						],
						[
							-81.70902090999994,
							30.404418012000068
						],
						[
							-81.70764590899995,
							30.404454012000087
						],
						[
							-81.70661690999992,
							30.40448301300006
						],
						[
							-81.70623390899993,
							30.40449801200009
						],
						[
							-81.70560190999993,
							30.404504013000068
						],
						[
							-81.70515190999993,
							30.40452401300007
						],
						[
							-81.7041929099999,
							30.404539013000093
						],
						[
							-81.70342290999992,
							30.40456201300009
						],
						[
							-81.70272790899992,
							30.404583012000046
						],
						[
							-81.70181290999994,
							30.40459601200007
						],
						[
							-81.70052290899991,
							30.404636013000076
						],
						[
							-81.70006590999992,
							30.404692012000055
						],
						[
							-81.6998979089999,
							30.404732012000068
						],
						[
							-81.69940890899994,
							30.40488801300006
						],
						[
							-81.69921090899993,
							30.404970013000085
						],
						[
							-81.69905890899992,
							30.405039012000085
						],
						[
							-81.69749990899993,
							30.40567401300007
						],
						[
							-81.69732482199993,
							30.405763946000036
						],
						[
							-81.69734190799994,
							30.405315011000084
						],
						[
							-81.69735690699991,
							30.404316010000063
						],
						[
							-81.69736290799995,
							30.403767010000077
						],
						[
							-81.6973877289999,
							30.40197795800009
						],
						[
							-81.69763003999992,
							30.40139503400008
						],
						[
							-81.69765499999994,
							30.399979000000087
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Harborview",
				"RegionID": "343434"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.93254790999993,
					28.00849446300009,
					-81.91095289099991,
					28.025898191000067
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.9266578239999,
							28.025898191000067
						],
						[
							-81.92644890999992,
							28.025696010000047
						],
						[
							-81.92455490999993,
							28.02397601000007
						],
						[
							-81.9234339109999,
							28.02294001000007
						],
						[
							-81.92231691099994,
							28.021928010000067
						],
						[
							-81.92128290999995,
							28.020975010000086
						],
						[
							-81.92020890999993,
							28.02000501100008
						],
						[
							-81.91922091099991,
							28.01907801100009
						],
						[
							-81.91879890999991,
							28.018714010000053
						],
						[
							-81.91862891099993,
							28.01855401000006
						],
						[
							-81.91831390999994,
							28.018256011000062
						],
						[
							-81.91713391099995,
							28.01719101000009
						],
						[
							-81.91658491099992,
							28.016678011000067
						],
						[
							-81.91598290999991,
							28.016134010000087
						],
						[
							-81.91437690999993,
							28.01465501000007
						],
						[
							-81.91412090999995,
							28.014405011000065
						],
						[
							-81.91378581399994,
							28.01410992700005
						],
						[
							-81.91373799999991,
							28.014118000000053
						],
						[
							-81.91317199999992,
							28.013594000000072
						],
						[
							-81.91276399999992,
							28.013217000000054
						],
						[
							-81.9117301739999,
							28.01227097600008
						],
						[
							-81.91095289099991,
							28.011559707000064
						],
						[
							-81.91225544799994,
							28.010458161000088
						],
						[
							-81.91313683399994,
							28.011380733000067
						],
						[
							-81.91315135899993,
							28.011374774000046
						],
						[
							-81.9134916779999,
							28.011340131000054
						],
						[
							-81.91379553299993,
							28.011330000000044
						],
						[
							-81.91427012799994,
							28.011330000000044
						],
						[
							-81.91523625699995,
							28.01132356900007
						],
						[
							-81.91552458299992,
							28.011319592000063
						],
						[
							-81.91635493199993,
							28.011310950000052
						],
						[
							-81.91689741899995,
							28.01131477100006
						],
						[
							-81.91760927599995,
							28.01131978400008
						],
						[
							-81.91918557699995,
							28.011320000000072
						],
						[
							-81.92060936199994,
							28.011320000000072
						],
						[
							-81.92154160199993,
							28.011320000000072
						],
						[
							-81.92155855199991,
							28.009900627000036
						],
						[
							-81.92166024999995,
							28.008510742000055
						],
						[
							-81.92428107399991,
							28.00849446300009
						],
						[
							-81.92428890999992,
							28.009352009000057
						],
						[
							-81.92429090999991,
							28.01012600900009
						],
						[
							-81.92427890899995,
							28.011051009000084
						],
						[
							-81.9242729099999,
							28.011507009000074
						],
						[
							-81.92427196699992,
							28.011591039000056
						],
						[
							-81.92431490899992,
							28.011568009000086
						],
						[
							-81.92464490999993,
							28.011428009000042
						],
						[
							-81.92485190999992,
							28.011369009000077
						],
						[
							-81.92504690999993,
							28.01132301000007
						],
						[
							-81.92510592699995,
							28.011309100000062
						],
						[
							-81.92521190999992,
							28.011294010000086
						],
						[
							-81.92614890899995,
							28.011284009000065
						],
						[
							-81.92678290999993,
							28.011289009000052
						],
						[
							-81.92723890899994,
							28.011288009000054
						],
						[
							-81.92773590999992,
							28.011288009000054
						],
						[
							-81.9281959089999,
							28.011288009000054
						],
						[
							-81.92847190899994,
							28.011289009000052
						],
						[
							-81.92887490999993,
							28.011291009000047
						],
						[
							-81.9297229099999,
							28.011296009000034
						],
						[
							-81.9302159099999,
							28.01129000900005
						],
						[
							-81.93121290999994,
							28.011277009000082
						],
						[
							-81.9324119129999,
							28.011298955000086
						],
						[
							-81.93241890999991,
							28.011726010000075
						],
						[
							-81.93242390999991,
							28.012014010000087
						],
						[
							-81.93243090899995,
							28.012403010000074
						],
						[
							-81.93243690999992,
							28.013076010000077
						],
						[
							-81.93243990999991,
							28.01380701000005
						],
						[
							-81.93244090999991,
							28.014147010000045
						],
						[
							-81.93245290899995,
							28.014473010000074
						],
						[
							-81.9324699089999,
							28.014934011000037
						],
						[
							-81.93247690999993,
							28.015114011000037
						],
						[
							-81.9324709089999,
							28.015520011000035
						],
						[
							-81.9324719089999,
							28.01618601100006
						],
						[
							-81.93248990899993,
							28.01714700900004
						],
						[
							-81.93251090899992,
							28.017755010000087
						],
						[
							-81.93251790999994,
							28.018549010000072
						],
						[
							-81.93252990899992,
							28.021249010000076
						],
						[
							-81.93253790999995,
							28.02224201000007
						],
						[
							-81.93254290999994,
							28.02273100900004
						],
						[
							-81.93254390999994,
							28.022920009000078
						],
						[
							-81.93254790999993,
							28.02358200900005
						],
						[
							-81.93254690999993,
							28.02376201000004
						],
						[
							-81.93254090999994,
							28.02437701100007
						],
						[
							-81.93254190999994,
							28.025096011000073
						],
						[
							-81.93254590999993,
							28.025835064000034
						],
						[
							-81.93047490899994,
							28.02583801100008
						],
						[
							-81.93012690899991,
							28.025839010000084
						],
						[
							-81.92902990999994,
							28.025833010000046
						],
						[
							-81.92859491099995,
							28.02583001000005
						],
						[
							-81.92848590999996,
							28.025836010000035
						],
						[
							-81.92792690999994,
							28.02586301100007
						],
						[
							-81.92732090999993,
							28.025883010000086
						],
						[
							-81.92716990999992,
							28.02588601000008
						],
						[
							-81.92707890999993,
							28.025888010000074
						],
						[
							-81.92699102499995,
							28.025889953000046
						],
						[
							-81.92669790899993,
							28.02589701000005
						],
						[
							-81.9266578239999,
							28.025898191000067
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Polk",
				"City": "Lakeland",
				"Name": "Lake Watkins",
				"RegionID": "343436"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.9575589069999,
					28.055002010000067,
					-81.9532719099999,
					28.069745993000083
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.95727490999991,
							28.069726011000057
						],
						[
							-81.95574190999992,
							28.06971900900004
						],
						[
							-81.95335790999991,
							28.06974301000008
						],
						[
							-81.95333286099994,
							28.069742099000052
						],
						[
							-81.9532719099999,
							28.062417011000036
						],
						[
							-81.9532795259999,
							28.05959785400006
						],
						[
							-81.9532805469999,
							28.059206307000068
						],
						[
							-81.95328418799994,
							28.057809473000077
						],
						[
							-81.95327259699991,
							28.05770909200004
						],
						[
							-81.9532991239999,
							28.05759768100006
						],
						[
							-81.9533291649999,
							28.05748479600004
						],
						[
							-81.9533716329999,
							28.057379061000063
						],
						[
							-81.9534099999999,
							28.057310000000086
						],
						[
							-81.95345073099992,
							28.057239647000074
						],
						[
							-81.95349247599995,
							28.05716754100007
						],
						[
							-81.95356082599994,
							28.057071008000037
						],
						[
							-81.95362240899993,
							28.056997591000084
						],
						[
							-81.95372958799993,
							28.056890412000087
						],
						[
							-81.95386800799992,
							28.056772659000046
						],
						[
							-81.95396928299994,
							28.05667982400007
						],
						[
							-81.95401726099995,
							28.05663612600006
						],
						[
							-81.95408874599991,
							28.056571140000074
						],
						[
							-81.95413167999993,
							28.056503313000064
						],
						[
							-81.95417022999993,
							28.05643709800006
						],
						[
							-81.9542078529999,
							28.05635036700005
						],
						[
							-81.95424028299993,
							28.056223656000043
						],
						[
							-81.95425999999992,
							28.05609544700008
						],
						[
							-81.95425999999992,
							28.05600000000004
						],
						[
							-81.95425658099992,
							28.055916812000078
						],
						[
							-81.95424661399994,
							28.05567428100005
						],
						[
							-81.95423488799992,
							28.055388952000044
						],
						[
							-81.95422999999994,
							28.055180850000056
						],
						[
							-81.95422999999994,
							28.055116542000064
						],
						[
							-81.95422999999994,
							28.05503501800007
						],
						[
							-81.95423090999992,
							28.055035010000044
						],
						[
							-81.95442855199991,
							28.055032661000045
						],
						[
							-81.95526491099992,
							28.05502301100006
						],
						[
							-81.9562839109999,
							28.055006011000046
						],
						[
							-81.95641090999993,
							28.055003010000064
						],
						[
							-81.95661691099991,
							28.055002010000067
						],
						[
							-81.95733891099992,
							28.055016010000088
						],
						[
							-81.95743491099995,
							28.055011009000054
						],
						[
							-81.9575589069999,
							28.05500201800004
						],
						[
							-81.95755491099993,
							28.05551401100007
						],
						[
							-81.9575550109999,
							28.05569315000008
						],
						[
							-81.9574378129999,
							28.055651863000037
						],
						[
							-81.95743591099995,
							28.05569101100008
						],
						[
							-81.95742107399991,
							28.055987092000066
						],
						[
							-81.95737374799997,
							28.05602392800006
						],
						[
							-81.95735691099992,
							28.05637401000007
						],
						[
							-81.9573479099999,
							28.057071010000072
						],
						[
							-81.95727791199994,
							28.057745010000076
						],
						[
							-81.95729591099992,
							28.058731011000077
						],
						[
							-81.95729591099992,
							28.058909010000036
						],
						[
							-81.95726890999993,
							28.059468010000046
						],
						[
							-81.95726791099992,
							28.060203010000066
						],
						[
							-81.95726391099993,
							28.06094001100007
						],
						[
							-81.95726479099994,
							28.06168414700005
						],
						[
							-81.95732103099994,
							28.061676874000057
						],
						[
							-81.9573199109999,
							28.062409010000067
						],
						[
							-81.95732890999994,
							28.06267401100007
						],
						[
							-81.95733291099992,
							28.062778010000045
						],
						[
							-81.95734504099995,
							28.065125143000046
						],
						[
							-81.95727478099991,
							28.065119877000086
						],
						[
							-81.95729478099992,
							28.06609614200005
						],
						[
							-81.95734104499991,
							28.066095876000077
						],
						[
							-81.95734291099991,
							28.066998010000077
						],
						[
							-81.95734291099991,
							28.067927010000062
						],
						[
							-81.95734293899994,
							28.067930458000035
						],
						[
							-81.95734990999995,
							28.068784011000048
						],
						[
							-81.95734990999995,
							28.06896801000005
						],
						[
							-81.95738291099991,
							28.069528012000035
						],
						[
							-81.95741091799994,
							28.069745993000083
						],
						[
							-81.95735590899994,
							28.069738011000084
						],
						[
							-81.95727490999991,
							28.069726011000057
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Polk",
				"City": "Lakeland",
				"Name": "Watson",
				"RegionID": "343443"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.94485779599995,
					28.047419362000085,
					-81.91382299999992,
					28.066699363000055
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.91456199999993,
							28.060989000000063
						],
						[
							-81.91458599999993,
							28.060736000000077
						],
						[
							-81.91466699999995,
							28.060494000000062
						],
						[
							-81.91472299999992,
							28.06004800000005
						],
						[
							-81.91469799999993,
							28.059916000000044
						],
						[
							-81.91464899999994,
							28.059696000000088
						],
						[
							-81.91465899999992,
							28.059661000000062
						],
						[
							-81.9146659999999,
							28.059611000000075
						],
						[
							-81.91469599999994,
							28.05954600000007
						],
						[
							-81.91506399999992,
							28.059575000000052
						],
						[
							-81.91630499999991,
							28.059773000000064
						],
						[
							-81.91629199999994,
							28.059679000000074
						],
						[
							-81.91621199999992,
							28.059597000000053
						],
						[
							-81.9161059999999,
							28.05954200000008
						],
						[
							-81.91590799999994,
							28.05947000000009
						],
						[
							-81.91569699999991,
							28.059404000000086
						],
						[
							-81.91551099999992,
							28.059382000000085
						],
						[
							-81.91526299999992,
							28.059333000000038
						],
						[
							-81.91503899999992,
							28.059338000000082
						],
						[
							-81.9148659999999,
							28.05927200000008
						],
						[
							-81.9147979999999,
							28.059206000000074
						],
						[
							-81.91498999999993,
							28.05854000000005
						],
						[
							-81.91509599999995,
							28.058166000000085
						],
						[
							-81.91514499999994,
							28.058029000000094
						],
						[
							-81.91539999999992,
							28.05745100000007
						],
						[
							-81.91550499999994,
							28.057236000000046
						],
						[
							-81.91560399999992,
							28.05707700000005
						],
						[
							-81.91569699999991,
							28.05700500000006
						],
						[
							-81.91579699999994,
							28.056978000000072
						],
						[
							-81.91598299999993,
							28.05695600000007
						],
						[
							-81.91611899999992,
							28.056967000000043
						],
						[
							-81.91616299999993,
							28.056939000000057
						],
						[
							-81.9161749999999,
							28.056906000000083
						],
						[
							-81.91614999999992,
							28.056868000000065
						],
						[
							-81.9160819999999,
							28.05686200000008
						],
						[
							-81.9158339999999,
							28.056796000000077
						],
						[
							-81.91596399999992,
							28.05653200000006
						],
						[
							-81.91628099999991,
							28.056648000000056
						],
						[
							-81.91634299999993,
							28.056538000000046
						],
						[
							-81.91605099999992,
							28.056422000000055
						],
						[
							-81.91613199999995,
							28.056147000000067
						],
						[
							-81.91628099999991,
							28.05619100000007
						],
						[
							-81.91621199999992,
							28.05641600000007
						],
						[
							-81.91631799999993,
							28.05645000000004
						],
						[
							-81.91644799999995,
							28.05609700000008
						],
						[
							-81.9161749999999,
							28.055993000000058
						],
						[
							-81.9162189999999,
							28.05596500000007
						],
						[
							-81.91628099999991,
							28.05588300000005
						],
						[
							-81.91642999999993,
							28.05560200000008
						],
						[
							-81.91644799999995,
							28.055465000000083
						],
						[
							-81.91652899999991,
							28.055344000000048
						],
						[
							-81.9167149999999,
							28.054969000000085
						],
						[
							-81.91674599999993,
							28.054843000000066
						],
						[
							-81.9168269999999,
							28.054689000000053
						],
						[
							-81.91690699999992,
							28.054458000000068
						],
						[
							-81.91699399999995,
							28.054370000000063
						],
						[
							-81.91709299999991,
							28.054298000000074
						],
						[
							-81.9171619999999,
							28.054216000000054
						],
						[
							-81.91719899999993,
							28.054122000000064
						],
						[
							-81.91727299999991,
							28.05399600000004
						],
						[
							-81.9174099999999,
							28.053731000000084
						],
						[
							-81.9175219999999,
							28.053544000000045
						],
						[
							-81.91760199999995,
							28.053357000000062
						],
						[
							-81.91770799999995,
							28.053165000000035
						],
						[
							-81.91800599999993,
							28.052708000000052
						],
						[
							-81.91809199999994,
							28.052587000000074
						],
						[
							-81.9185579999999,
							28.05207500000006
						],
						[
							-81.91933899999992,
							28.05144800000005
						],
						[
							-81.91962499999994,
							28.05123400000008
						],
						[
							-81.91993499999995,
							28.051030000000083
						],
						[
							-81.92012699999992,
							28.05092600000006
						],
						[
							-81.92028199999993,
							28.05081000000007
						],
						[
							-81.9205609999999,
							28.05067800000006
						],
						[
							-81.9211939999999,
							28.05031500000007
						],
						[
							-81.9214849999999,
							28.050216000000034
						],
						[
							-81.92165899999992,
							28.050128000000086
						],
						[
							-81.9220249999999,
							28.049875000000046
						],
						[
							-81.92219899999992,
							28.049677000000088
						],
						[
							-81.9222979999999,
							28.04951200000005
						],
						[
							-81.92234799999994,
							28.04929700000008
						],
						[
							-81.92237299999994,
							28.048934000000088
						],
						[
							-81.92235999999991,
							28.048862000000042
						],
						[
							-81.92241895599994,
							28.04884386000009
						],
						[
							-81.92250299999995,
							28.04881800000004
						],
						[
							-81.92250299999995,
							28.048369000000037
						],
						[
							-81.92250299999995,
							28.048246000000063
						],
						[
							-81.92250299999995,
							28.04810800000007
						],
						[
							-81.92250299999995,
							28.04799600000007
						],
						[
							-81.92250299999995,
							28.047863316000075
						],
						[
							-81.92471023999991,
							28.048108565000064
						],
						[
							-81.92491017899994,
							28.048122954000064
						],
						[
							-81.92946388699994,
							28.04862892100005
						],
						[
							-81.9377893759999,
							28.04904302500006
						],
						[
							-81.93922382999995,
							28.048442412000046
						],
						[
							-81.94485779599995,
							28.047419362000085
						],
						[
							-81.94482538999995,
							28.05141989200007
						],
						[
							-81.94479596199994,
							28.055047513000094
						],
						[
							-81.94179109499993,
							28.054976515000078
						],
						[
							-81.94088637399994,
							28.054909443000042
						],
						[
							-81.94054916699992,
							28.05488457200005
						],
						[
							-81.93866329599992,
							28.054286558000058
						],
						[
							-81.93673142099993,
							28.05355060500006
						],
						[
							-81.93496174599994,
							28.05315026100004
						],
						[
							-81.9347767989999,
							28.054031338000073
						],
						[
							-81.9347542129999,
							28.054025498000044
						],
						[
							-81.9344941999999,
							28.053974804000063
						],
						[
							-81.93433304299992,
							28.053955099000063
						],
						[
							-81.93417142899995,
							28.05394853000007
						],
						[
							-81.93354773199991,
							28.053989758000057
						],
						[
							-81.93328557799992,
							28.054030396000087
						],
						[
							-81.93289906799994,
							28.05411535400009
						],
						[
							-81.93288144899992,
							28.054119042000085
						],
						[
							-81.93282338499995,
							28.054128628000058
						],
						[
							-81.9328232279999,
							28.054128649000067
						],
						[
							-81.93257222799991,
							28.054161649000037
						],
						[
							-81.93251381899995,
							28.054167396000082
						],
						[
							-81.93249628199995,
							28.054168374000085
						],
						[
							-81.93203928199995,
							28.05418937400009
						],
						[
							-81.93199799999991,
							28.05419032200007
						],
						[
							-81.9317969999999,
							28.05419032200007
						],
						[
							-81.9317381809999,
							28.054188396000086
						],
						[
							-81.93167961499995,
							28.054182628000035
						],
						[
							-81.93165970799993,
							28.054179781000073
						],
						[
							-81.93141370899991,
							28.054141781000055
						],
						[
							-81.93137555099992,
							28.05413504200004
						],
						[
							-81.9313618679999,
							28.054132209000045
						],
						[
							-81.93118986799993,
							28.05409521000007
						],
						[
							-81.93114623899993,
							28.054084678000038
						],
						[
							-81.93114162899991,
							28.05408343000005
						],
						[
							-81.93054962899993,
							28.05392143000006
						],
						[
							-81.93049792199992,
							28.05390559500006
						],
						[
							-81.93049201299993,
							28.053903566000088
						],
						[
							-81.93013201299993,
							28.053778566000062
						],
						[
							-81.9300828449999,
							28.053759866000068
						],
						[
							-81.93007590499991,
							28.053756957000076
						],
						[
							-81.92962303099995,
							28.053564915000038
						],
						[
							-81.9293701169999,
							28.05347258200004
						],
						[
							-81.92899170999993,
							28.05343226000008
						],
						[
							-81.92896961499991,
							28.05342962900005
						],
						[
							-81.92892537599994,
							28.05342268000004
						],
						[
							-81.92871737599995,
							28.05338468000008
						],
						[
							-81.9287035509999,
							28.053382042000067
						],
						[
							-81.92864623799994,
							28.053368679000073
						],
						[
							-81.92858992299995,
							28.053351595000038
						],
						[
							-81.92854358999995,
							28.053334434000078
						],
						[
							-81.92844158999993,
							28.053293434000068
						],
						[
							-81.92843284399993,
							28.053289865000067
						],
						[
							-81.92837923999991,
							28.053265578000037
						],
						[
							-81.92836138599995,
							28.05325652500005
						],
						[
							-81.92814838599992,
							28.05314552400006
						],
						[
							-81.92811433899993,
							28.053126835000057
						],
						[
							-81.92806935699991,
							28.053099071000076
						],
						[
							-81.92753335799995,
							28.052746071000062
						],
						[
							-81.9275283639999,
							28.05274275800008
						],
						[
							-81.92748052799993,
							28.052708480000035
						],
						[
							-81.92747796999994,
							28.052706510000064
						],
						[
							-81.92733696999996,
							28.05259751000006
						],
						[
							-81.92729403599992,
							28.05256214600007
						],
						[
							-81.92725108399992,
							28.05252191700004
						],
						[
							-81.92721085399995,
							28.052478964000045
						],
						[
							-81.92717351999994,
							28.052433472000075
						],
						[
							-81.9271392409999,
							28.052385636000054
						],
						[
							-81.92710816499994,
							28.05233566100009
						],
						[
							-81.92708820899992,
							28.05229917300005
						],
						[
							-81.92704320799993,
							28.052212173000047
						],
						[
							-81.92703542299995,
							28.052196760000072
						],
						[
							-81.92701113499993,
							28.052143156000056
						],
						[
							-81.92699757699995,
							28.05210840300009
						],
						[
							-81.92694957699992,
							28.05197740200009
						],
						[
							-81.92694240499992,
							28.051957077000054
						],
						[
							-81.9269276739999,
							28.051909368000054
						],
						[
							-81.92689342699992,
							28.05178644700004
						],
						[
							-81.92680350299993,
							28.051681861000077
						],
						[
							-81.92667664799991,
							28.051562837000063
						],
						[
							-81.9266560829999,
							28.051542916000074
						],
						[
							-81.92663187799991,
							28.05151775300004
						],
						[
							-81.92623784999995,
							28.051091875000054
						],
						[
							-81.92594704399994,
							28.050848530000057
						],
						[
							-81.92573169399992,
							28.05067063200005
						],
						[
							-81.92570696399991,
							28.05069314600007
						],
						[
							-81.92566147299993,
							28.050730480000084
						],
						[
							-81.92561363699991,
							28.05076475900006
						],
						[
							-81.9255636609999,
							28.050795836000077
						],
						[
							-81.92551618399995,
							28.05082138100005
						],
						[
							-81.92546018399992,
							28.050849380000045
						],
						[
							-81.92545575999992,
							28.05085157700006
						],
						[
							-81.9254021559999,
							28.05087586500008
						],
						[
							-81.9253470779999,
							28.05089659500004
						],
						[
							-81.92529076199992,
							28.050913678000086
						],
						[
							-81.9252334489999,
							28.050927041000083
						],
						[
							-81.92521493599992,
							28.05093052300009
						],
						[
							-81.92513593599995,
							28.050944523000055
						],
						[
							-81.9250963849999,
							28.05095062800007
						],
						[
							-81.9250378189999,
							28.05095639700005
						],
						[
							-81.92497899999995,
							28.050958322000046
						],
						[
							-81.92497405199992,
							28.050958309000066
						],
						[
							-81.92424705199994,
							28.05095430800009
						],
						[
							-81.92419908699992,
							28.050952764000044
						],
						[
							-81.92295023199995,
							28.050879158000043
						],
						[
							-81.9229312789999,
							28.05091240300004
						],
						[
							-81.92292883599993,
							28.050916661000088
						],
						[
							-81.92289775899991,
							28.050966637000045
						],
						[
							-81.92286347999995,
							28.051014473000066
						],
						[
							-81.92282614599992,
							28.051059964000046
						],
						[
							-81.92278591399992,
							28.051102920000062
						],
						[
							-81.9227369109999,
							28.051151922000088
						],
						[
							-81.9226939639999,
							28.051192146000062
						],
						[
							-81.92264847199993,
							28.051229480000075
						],
						[
							-81.9226316139999,
							28.051242105000085
						],
						[
							-81.92255361399992,
							28.051299105000055
						],
						[
							-81.92252263599994,
							28.051320759000077
						],
						[
							-81.92247266099992,
							28.05135183500005
						],
						[
							-81.92242519099995,
							28.05137737700005
						],
						[
							-81.92228719099995,
							28.051446377000048
						],
						[
							-81.92228275999993,
							28.051448578000077
						],
						[
							-81.92222915499991,
							28.05147286500005
						],
						[
							-81.92222099499992,
							28.051476198000046
						],
						[
							-81.92189834699991,
							28.05160615400007
						],
						[
							-81.92162787399991,
							28.051744358000064
						],
						[
							-81.92128684999994,
							28.05193244900005
						],
						[
							-81.92102395899991,
							28.05210909200008
						],
						[
							-81.92039612999992,
							28.052585312000076
						],
						[
							-81.91971982399991,
							28.053182378000088
						],
						[
							-81.91913603399992,
							28.05380799900007
						],
						[
							-81.91902934599995,
							28.053933764000078
						],
						[
							-81.91893795599992,
							28.054067752000037
						],
						[
							-81.9189084809999,
							28.054108472000053
						],
						[
							-81.91890701699992,
							28.054110375000054
						],
						[
							-81.91875501599992,
							28.054307375000064
						],
						[
							-81.91871914599994,
							28.054350964000037
						],
						[
							-81.91870215799992,
							28.054369793000035
						],
						[
							-81.91847776799996,
							28.054611555000065
						],
						[
							-81.91836725299993,
							28.055108085000086
						],
						[
							-81.91828048999992,
							28.055709942000078
						],
						[
							-81.91825662799994,
							28.05597242200008
						],
						[
							-81.91825262799995,
							28.05600838500004
						],
						[
							-81.91825025499992,
							28.056025184000077
						],
						[
							-81.9181912549999,
							28.056416185000046
						],
						[
							-81.91818404199995,
							28.056457449000053
						],
						[
							-81.91817067799991,
							28.056514762000063
						],
						[
							-81.91815359499992,
							28.056571078000047
						],
						[
							-81.9181328649999,
							28.05662615600005
						],
						[
							-81.91813032399996,
							28.05663222800007
						],
						[
							-81.91806732399994,
							28.05678122800009
						],
						[
							-81.91804557799992,
							28.056828760000087
						],
						[
							-81.91804108399992,
							28.056837746000042
						],
						[
							-81.91793408399991,
							28.05704874500009
						],
						[
							-81.91791083599992,
							28.057091661000072
						],
						[
							-81.91790695399993,
							28.057098318000044
						],
						[
							-81.91767495399995,
							28.057492318000072
						],
						[
							-81.91764775899992,
							28.05753563600007
						],
						[
							-81.91763927699992,
							28.057548103000045
						],
						[
							-81.91750627699992,
							28.05774010300007
						],
						[
							-81.91748047999994,
							28.05777547200006
						],
						[
							-81.91747244099992,
							28.05778579300005
						],
						[
							-81.91730244099995,
							28.058000793000076
						],
						[
							-81.9172731459999,
							28.058035964000055
						],
						[
							-81.9172356169999,
							28.058076205000077
						],
						[
							-81.91711861699991,
							28.058194205000063
						],
						[
							-81.91711591599994,
							28.05819691700009
						],
						[
							-81.91707296399994,
							28.05823714600007
						],
						[
							-81.91703562099991,
							28.058268153000085
						],
						[
							-81.91696562099992,
							28.05832315200007
						],
						[
							-81.91695747299991,
							28.058329480000054
						],
						[
							-81.91690963699995,
							28.058363759000088
						],
						[
							-81.9168831419999,
							28.05838079800009
						],
						[
							-81.91685130199994,
							28.058400496000047
						],
						[
							-81.91687898599992,
							28.058412152000074
						],
						[
							-81.91692775999991,
							28.058434423000055
						],
						[
							-81.91697966099991,
							28.058462164000048
						],
						[
							-81.91702409699991,
							28.058489569000074
						],
						[
							-81.9170970969999,
							28.058537570000055
						],
						[
							-81.91710263599994,
							28.058541241000057
						],
						[
							-81.91715047199995,
							28.058575520000094
						],
						[
							-81.91719596399992,
							28.058612854000046
						],
						[
							-81.9172389169999,
							28.05865308400007
						],
						[
							-81.91727914599994,
							28.05869603600007
						],
						[
							-81.91730525199995,
							28.058727198000042
						],
						[
							-81.91737725199994,
							28.058817198000042
						],
						[
							-81.91738847999994,
							28.058831527000052
						],
						[
							-81.91742275899993,
							28.058879363000074
						],
						[
							-81.91745383499995,
							28.058929339000088
						],
						[
							-81.91748157699993,
							28.058981240000037
						],
						[
							-81.91749186099992,
							28.059002811000084
						],
						[
							-81.91756186099991,
							28.05915481100004
						],
						[
							-81.91757586499995,
							28.059186844000067
						],
						[
							-81.9175965949999,
							28.05924192200007
						],
						[
							-81.91761367899994,
							28.059298238000054
						],
						[
							-81.91762704199994,
							28.059355551000067
						],
						[
							-81.91763662799991,
							28.05941361500004
						],
						[
							-81.91763852499992,
							28.059429055000066
						],
						[
							-81.91765552499993,
							28.059578056000078
						],
						[
							-81.91765939699991,
							28.059621182000058
						],
						[
							-81.9176613219999,
							28.05968000000007
						],
						[
							-81.91765939699991,
							28.059738819000074
						],
						[
							-81.91765592099995,
							28.059778411000085
						],
						[
							-81.91764392199991,
							28.05988741100009
						],
						[
							-81.91764162899995,
							28.05990638500009
						],
						[
							-81.91763204199992,
							28.059964449000063
						],
						[
							-81.91761867899993,
							28.060021762000076
						],
						[
							-81.91760159499995,
							28.06007807800006
						],
						[
							-81.91758086599992,
							28.060133156000063
						],
						[
							-81.91755657799992,
							28.06018676000008
						],
						[
							-81.91755437799992,
							28.060191189000083
						],
						[
							-81.91753337799992,
							28.060233189000087
						],
						[
							-81.91750783599991,
							28.060280661000036
						],
						[
							-81.9174767589999,
							28.06033063700005
						],
						[
							-81.91744247999992,
							28.06037847300007
						],
						[
							-81.91740514599991,
							28.060423964000055
						],
						[
							-81.91736491699993,
							28.060466917000046
						],
						[
							-81.91732196499993,
							28.060507146000077
						],
						[
							-81.91731478799996,
							28.06051337300005
						],
						[
							-81.91727814599994,
							28.060557964000054
						],
						[
							-81.91723791699991,
							28.060600917000045
						],
						[
							-81.91719496399992,
							28.06064114600008
						],
						[
							-81.91714947199995,
							28.060678480000036
						],
						[
							-81.91710163599993,
							28.060712759000072
						],
						[
							-81.9170516609999,
							28.060743836000086
						],
						[
							-81.9169997599999,
							28.060771577000082
						],
						[
							-81.91694615499995,
							28.060795865000046
						],
						[
							-81.91689107699995,
							28.060816595000063
						],
						[
							-81.91683476199995,
							28.06083367800005
						],
						[
							-81.91677744899995,
							28.060847042000038
						],
						[
							-81.91671938499991,
							28.060856628000067
						],
						[
							-81.91666081799991,
							28.06086239700005
						],
						[
							-81.91664691199992,
							28.060863200000085
						],
						[
							-81.9166069119999,
							28.06086520000008
						],
						[
							-81.91657029099991,
							28.06086491600007
						],
						[
							-81.91654295099994,
							28.061179794000054
						],
						[
							-81.9165386279999,
							28.061219385000072
						],
						[
							-81.91652904199992,
							28.061277449000045
						],
						[
							-81.9165262379999,
							28.06129099800006
						],
						[
							-81.9165032379999,
							28.061397997000086
						],
						[
							-81.91649267799994,
							28.061441761000083
						],
						[
							-81.91647559499995,
							28.061498077000067
						],
						[
							-81.91645486499993,
							28.06155315500007
						],
						[
							-81.91644169799991,
							28.061583366000036
						],
						[
							-81.9164036979999,
							28.061666366000054
						],
						[
							-81.9163925769999,
							28.061689760000036
						],
						[
							-81.9163648359999,
							28.061741661000042
						],
						[
							-81.91635105899991,
							28.061764720000042
						],
						[
							-81.91631345799993,
							28.061825575000057
						],
						[
							-81.91632272699991,
							28.061857065000083
						],
						[
							-81.91632867899995,
							28.061878238000077
						],
						[
							-81.91634204199994,
							28.06193555100009
						],
						[
							-81.9163474579999,
							28.061965401000066
						],
						[
							-81.91636845799991,
							28.062093400000037
						],
						[
							-81.91637262899991,
							28.06212161500008
						],
						[
							-81.9163783969999,
							28.062180181000087
						],
						[
							-81.91638032199995,
							28.06223900000009
						],
						[
							-81.91637995899993,
							28.06226457300005
						],
						[
							-81.91636695799991,
							28.06272157300009
						],
						[
							-81.91636539599995,
							28.062754818000087
						],
						[
							-81.91635962799995,
							28.062813385000084
						],
						[
							-81.91635004199992,
							28.062871449000056
						],
						[
							-81.91633667799994,
							28.06292876200007
						],
						[
							-81.91631959499995,
							28.062985078000054
						],
						[
							-81.91631185099993,
							28.063006958000074
						],
						[
							-81.91580885099995,
							28.064371958000038
						],
						[
							-81.91579586499995,
							28.06440515600008
						],
						[
							-81.91577157699993,
							28.064458760000036
						],
						[
							-81.91574383599993,
							28.064510661000043
						],
						[
							-81.91571275899992,
							28.064560637000056
						],
						[
							-81.91567847999994,
							28.064608473000078
						],
						[
							-81.91564114599993,
							28.06465396400006
						],
						[
							-81.91560091699995,
							28.06469691700005
						],
						[
							-81.9155579639999,
							28.064737146000084
						],
						[
							-81.91551247199993,
							28.06477448000004
						],
						[
							-81.91546463599991,
							28.064808759000073
						],
						[
							-81.91541466099994,
							28.06483983600009
						],
						[
							-81.91536275999994,
							28.06486757700009
						],
						[
							-81.91530915599992,
							28.06489186500005
						],
						[
							-81.91525407799992,
							28.06491259500007
						],
						[
							-81.91519837599992,
							28.06492951300004
						],
						[
							-81.91496473899991,
							28.064992294000035
						],
						[
							-81.91494820899993,
							28.065634121000073
						],
						[
							-81.91502600599995,
							28.066648178000037
						],
						[
							-81.91405861399994,
							28.066699363000055
						],
						[
							-81.91404599999993,
							28.066678000000085
						],
						[
							-81.9140329999999,
							28.06662300000005
						],
						[
							-81.91408299999996,
							28.066563000000087
						],
						[
							-81.9141259999999,
							28.066469000000044
						],
						[
							-81.91411999999991,
							28.066381000000035
						],
						[
							-81.9140998119999,
							28.06633235700008
						],
						[
							-81.91401499999995,
							28.06612800000005
						],
						[
							-81.9139909999999,
							28.066047000000083
						],
						[
							-81.91397699999993,
							28.066001000000085
						],
						[
							-81.91390899999993,
							28.065803000000074
						],
						[
							-81.9138969999999,
							28.065281000000084
						],
						[
							-81.91386599999993,
							28.065072000000043
						],
						[
							-81.91382299999992,
							28.064527000000055
						],
						[
							-81.91384099999993,
							28.064279000000056
						],
						[
							-81.91390999999993,
							28.06375100000008
						],
						[
							-81.91392799999994,
							28.063454000000036
						],
						[
							-81.91408399999995,
							28.062992000000065
						],
						[
							-81.91413299999994,
							28.06275000000005
						],
						[
							-81.9142819999999,
							28.06224900000007
						],
						[
							-81.9143939999999,
							28.061710000000065
						],
						[
							-81.91456199999993,
							28.060989000000063
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Polk",
				"City": "Lakeland",
				"Name": "Shore Acres",
				"RegionID": "343445"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.9575589069999,
					28.045668581000086,
					-81.94479596199994,
					28.055075010000053
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.94479596199994,
							28.055047513000094
						],
						[
							-81.94482538999995,
							28.05141989200007
						],
						[
							-81.94485779599995,
							28.047419362000085
						],
						[
							-81.94906736999991,
							28.046650727000042
						],
						[
							-81.95419058999994,
							28.045668581000086
						],
						[
							-81.95417978099994,
							28.046837140000036
						],
						[
							-81.95520591099995,
							28.046838010000045
						],
						[
							-81.95623490999992,
							28.046839010000042
						],
						[
							-81.95720291099991,
							28.046838010000045
						],
						[
							-81.95724391099992,
							28.046838010000045
						],
						[
							-81.9572799099999,
							28.046838010000045
						],
						[
							-81.9573482209999,
							28.04683812500008
						],
						[
							-81.9575589069999,
							28.05500201800004
						],
						[
							-81.95743491099995,
							28.055011009000054
						],
						[
							-81.95733891099992,
							28.055016010000088
						],
						[
							-81.95661691099991,
							28.055002010000067
						],
						[
							-81.95641090999993,
							28.055003010000064
						],
						[
							-81.9562839109999,
							28.055006011000046
						],
						[
							-81.95526491099992,
							28.05502301100006
						],
						[
							-81.95442855199991,
							28.055032661000045
						],
						[
							-81.95423090999992,
							28.055035010000044
						],
						[
							-81.95422999999994,
							28.05503501800007
						],
						[
							-81.95321690999992,
							28.055044011000064
						],
						[
							-81.95219690899995,
							28.05505000900007
						],
						[
							-81.95117990999995,
							28.05505701000004
						],
						[
							-81.95019290999994,
							28.055063011000076
						],
						[
							-81.94808789899992,
							28.055075010000053
						],
						[
							-81.94706999999994,
							28.05506650800004
						],
						[
							-81.94479596199994,
							28.055047513000094
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Polk",
				"City": "Lakeland",
				"Name": "Parker Street",
				"RegionID": "343450"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.95713504399993,
					27.996670922000078,
					-81.94872690999995,
					28.007640000000038
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.9493394559999,
							28.00762173600009
						],
						[
							-81.9491167679999,
							28.00761674000006
						],
						[
							-81.94890749099994,
							28.007612287000086
						],
						[
							-81.94876690199993,
							28.00440499700005
						],
						[
							-81.9488400539999,
							28.004391127000076
						],
						[
							-81.94882763499993,
							28.00400536500007
						],
						[
							-81.9488139099999,
							28.003579009000077
						],
						[
							-81.94880390899993,
							28.002769009000076
						],
						[
							-81.9487659099999,
							28.00238800900007
						],
						[
							-81.94876491199994,
							28.00183452300007
						],
						[
							-81.94876290899992,
							28.00080901000007
						],
						[
							-81.94876290899992,
							28.00034301000005
						],
						[
							-81.94875690999993,
							27.99999401000008
						],
						[
							-81.94874290899992,
							27.998949009000057
						],
						[
							-81.94873890999992,
							27.99859800900009
						],
						[
							-81.94873790999992,
							27.998481009000045
						],
						[
							-81.94873390999993,
							27.998095010000043
						],
						[
							-81.94872990999994,
							27.99751700900004
						],
						[
							-81.94872690999995,
							27.997126009000056
						],
						[
							-81.94872740199992,
							27.99675249900008
						],
						[
							-81.95713292599993,
							27.996670922000078
						],
						[
							-81.95712990999994,
							27.99705600900006
						],
						[
							-81.95712490999996,
							27.997333010000094
						],
						[
							-81.95712890999994,
							27.997902010000075
						],
						[
							-81.95713190899994,
							27.99823801000008
						],
						[
							-81.95713490999992,
							27.998617009000043
						],
						[
							-81.95712990899995,
							27.998762010000064
						],
						[
							-81.95712581899994,
							27.998827007000045
						],
						[
							-81.95713504399993,
							27.999102142000083
						],
						[
							-81.95697078099994,
							27.99910187800009
						],
						[
							-81.9569609099999,
							27.999928010000076
						],
						[
							-81.95697190999994,
							28.000731010000038
						],
						[
							-81.9569839099999,
							28.001801010000065
						],
						[
							-81.95698790999995,
							28.00301101000008
						],
						[
							-81.95699077899991,
							28.00356313900005
						],
						[
							-81.95705904099992,
							28.003563876000047
						],
						[
							-81.95706591099992,
							28.003758007000044
						],
						[
							-81.95712503399994,
							28.00401613200006
						],
						[
							-81.9570007929999,
							28.003990870000052
						],
						[
							-81.9570079099999,
							28.004458010000068
						],
						[
							-81.9570082699999,
							28.004805247000036
						],
						[
							-81.95700863799993,
							28.00515969500009
						],
						[
							-81.9570089099999,
							28.00535601100006
						],
						[
							-81.9570079099999,
							28.005722011000046
						],
						[
							-81.95701090999995,
							28.00655801000005
						],
						[
							-81.95701891099992,
							28.007310010000083
						],
						[
							-81.95702390999992,
							28.00762601000008
						],
						[
							-81.95702395699993,
							28.007629620000046
						],
						[
							-81.9568240779999,
							28.007628263000072
						],
						[
							-81.95661057399991,
							28.007625721000068
						],
						[
							-81.95641572699992,
							28.007623402000036
						],
						[
							-81.95590573099992,
							28.007620000000088
						],
						[
							-81.95542345799994,
							28.007620000000088
						],
						[
							-81.95502465499993,
							28.007620000000088
						],
						[
							-81.95485999999994,
							28.007620000000088
						],
						[
							-81.95461655999992,
							28.007622646000073
						],
						[
							-81.95439399799994,
							28.00762506500007
						],
						[
							-81.95402306299991,
							28.007629097000063
						],
						[
							-81.95380967499995,
							28.007632286000046
						],
						[
							-81.95366132899996,
							28.00763488900009
						],
						[
							-81.95342010399992,
							28.007639121000068
						],
						[
							-81.9532903249999,
							28.007640000000038
						],
						[
							-81.95309556099994,
							28.007640000000038
						],
						[
							-81.9527895029999,
							28.007640000000038
						],
						[
							-81.95257618999995,
							28.007640000000038
						],
						[
							-81.95233506499994,
							28.00763951800008
						],
						[
							-81.95196408999993,
							28.007638193000048
						],
						[
							-81.95144475899991,
							28.007636338000054
						],
						[
							-81.95110163999993,
							28.00763511300005
						],
						[
							-81.95098100699994,
							28.007634682000063
						],
						[
							-81.95056365999994,
							28.00763319200007
						],
						[
							-81.95006287799993,
							28.00763140300006
						],
						[
							-81.9496645559999,
							28.00762986400008
						],
						[
							-81.94952482999992,
							28.00762637100007
						],
						[
							-81.9493394559999,
							28.00762173600009
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Polk",
				"City": "Lakeland",
				"Name": "Cleveland Heights",
				"RegionID": "343452"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.95710891099992,
					28.011248011000077,
					-81.9324119129999,
					28.02633601000008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.94597122399995,
							28.018594308000047
						],
						[
							-81.94583025599991,
							28.018587384000057
						],
						[
							-81.94562011499994,
							28.018616621000035
						],
						[
							-81.94523220699995,
							28.01871692800006
						],
						[
							-81.94487976799991,
							28.018859304000046
						],
						[
							-81.94455386899995,
							28.019034788000056
						],
						[
							-81.94365977199993,
							28.019577703000042
						],
						[
							-81.9436426609999,
							28.019587836000085
						],
						[
							-81.94359075999995,
							28.01961557800007
						],
						[
							-81.9435896519999,
							28.01961612300005
						],
						[
							-81.9414922389999,
							28.02064687300009
						],
						[
							-81.94136714899992,
							28.020735052000077
						],
						[
							-81.94134863599993,
							28.020747759000074
						],
						[
							-81.9412986609999,
							28.020778835000044
						],
						[
							-81.9412467599999,
							28.02080657700009
						],
						[
							-81.94119315499997,
							28.02083086500005
						],
						[
							-81.94115898599995,
							28.02084420800009
						],
						[
							-81.94103098599993,
							28.02089120900007
						],
						[
							-81.94101007799992,
							28.020898595000062
						],
						[
							-81.94096539599991,
							28.02091247700008
						],
						[
							-81.94062121699996,
							28.021009667000044
						],
						[
							-81.93973734199996,
							28.021354306000035
						],
						[
							-81.93909056599995,
							28.021695452000074
						],
						[
							-81.93908752399994,
							28.02169704900007
						],
						[
							-81.93900339499994,
							28.021741013000053
						],
						[
							-81.93883519299993,
							28.021871265000073
						],
						[
							-81.93875270899991,
							28.022142930000086
						],
						[
							-81.9386568619999,
							28.02252225600006
						],
						[
							-81.93861735299993,
							28.022941397000068
						],
						[
							-81.93861725799991,
							28.022942404000048
						],
						[
							-81.93859358899994,
							28.02319051300009
						],
						[
							-81.9386039339999,
							28.023540006000076
						],
						[
							-81.93881623899995,
							28.024711789000037
						],
						[
							-81.93905784799995,
							28.025529342000084
						],
						[
							-81.93906073099993,
							28.025534487000073
						],
						[
							-81.93821190199992,
							28.02584006300009
						],
						[
							-81.93802495799991,
							28.02583392200006
						],
						[
							-81.9375309109999,
							28.025834010000043
						],
						[
							-81.93738491099992,
							28.02583001000005
						],
						[
							-81.93609991099993,
							28.02587101000006
						],
						[
							-81.93505890999995,
							28.025870010000062
						],
						[
							-81.93446390999992,
							28.02584401100006
						],
						[
							-81.93395590999995,
							28.02584101000008
						],
						[
							-81.93254590999993,
							28.025835064000034
						],
						[
							-81.93254190999994,
							28.025096011000073
						],
						[
							-81.93254090999994,
							28.02437701100007
						],
						[
							-81.93254690999993,
							28.02376201000004
						],
						[
							-81.93254790999993,
							28.02358200900005
						],
						[
							-81.93254390999994,
							28.022920009000078
						],
						[
							-81.93254290999994,
							28.02273100900004
						],
						[
							-81.93253790999995,
							28.02224201000007
						],
						[
							-81.93252990899992,
							28.021249010000076
						],
						[
							-81.93251790999994,
							28.018549010000072
						],
						[
							-81.93251090899992,
							28.017755010000087
						],
						[
							-81.93248990899993,
							28.01714700900004
						],
						[
							-81.9324719089999,
							28.01618601100006
						],
						[
							-81.9324709089999,
							28.015520011000035
						],
						[
							-81.93247690999993,
							28.015114011000037
						],
						[
							-81.9324699089999,
							28.014934011000037
						],
						[
							-81.93245290899995,
							28.014473010000074
						],
						[
							-81.93244090999991,
							28.014147010000045
						],
						[
							-81.93243990999991,
							28.01380701000005
						],
						[
							-81.93243690999992,
							28.013076010000077
						],
						[
							-81.93243090899995,
							28.012403010000074
						],
						[
							-81.93242390999991,
							28.012014010000087
						],
						[
							-81.93241890999991,
							28.011726010000075
						],
						[
							-81.9324119129999,
							28.011298955000086
						],
						[
							-81.93265190999995,
							28.011303011000052
						],
						[
							-81.93293990899991,
							28.011296009000034
						],
						[
							-81.9339779099999,
							28.011271010000087
						],
						[
							-81.9350129099999,
							28.01125101000008
						],
						[
							-81.93508990999993,
							28.011248011000077
						],
						[
							-81.93601390999993,
							28.011255010000074
						],
						[
							-81.93699690999995,
							28.011287010000046
						],
						[
							-81.93786190999994,
							28.01127001000009
						],
						[
							-81.93874390999991,
							28.011268010000038
						],
						[
							-81.9396329089999,
							28.011269010000035
						],
						[
							-81.93997162399995,
							28.011271433000047
						],
						[
							-81.94063390999992,
							28.011276010000074
						],
						[
							-81.94329190899992,
							28.011293010000088
						],
						[
							-81.94375866399992,
							28.01129116900006
						],
						[
							-81.94555990999993,
							28.011284063000062
						],
						[
							-81.94648790999992,
							28.01128201000006
						],
						[
							-81.94747090899995,
							28.01127301000008
						],
						[
							-81.94753190999995,
							28.011276010000074
						],
						[
							-81.94759390999991,
							28.01127301000008
						],
						[
							-81.94855290999993,
							28.011265009000056
						],
						[
							-81.94938590899994,
							28.011265009000056
						],
						[
							-81.95045090999992,
							28.01126700900005
						],
						[
							-81.95247390999992,
							28.011269010000035
						],
						[
							-81.95340390899992,
							28.01126700900005
						],
						[
							-81.95436690999992,
							28.011269010000035
						],
						[
							-81.95488690899992,
							28.01127001000009
						],
						[
							-81.95644290999991,
							28.011261010000055
						],
						[
							-81.95700190999992,
							28.011258010000063
						],
						[
							-81.95705696599993,
							28.011257012000044
						],
						[
							-81.95706191099993,
							28.01179301000008
						],
						[
							-81.95706091099994,
							28.012179010000068
						],
						[
							-81.95705791099994,
							28.012683010000046
						],
						[
							-81.95706091099994,
							28.013470011000038
						],
						[
							-81.95706191099993,
							28.014222010000083
						],
						[
							-81.95706291099992,
							28.015016010000068
						],
						[
							-81.95706491099992,
							28.01536401000004
						],
						[
							-81.95706791099991,
							28.015868011000066
						],
						[
							-81.9570699109999,
							28.016278011000054
						],
						[
							-81.9570729109999,
							28.016751010000064
						],
						[
							-81.95707791099994,
							28.017617010000038
						],
						[
							-81.95708285599996,
							28.01856401000009
						],
						[
							-81.95708390999994,
							28.019421010000087
						],
						[
							-81.95708390999994,
							28.02047801100008
						],
						[
							-81.9570999099999,
							28.02184501000005
						],
						[
							-81.95710490999994,
							28.022694010000066
						],
						[
							-81.95710690999994,
							28.023633011000072
						],
						[
							-81.95710800099994,
							28.02416769100006
						],
						[
							-81.95710891099992,
							28.024566010000058
						],
						[
							-81.95710891099992,
							28.025002011000083
						],
						[
							-81.95710791099994,
							28.025442010000063
						],
						[
							-81.95710491099993,
							28.025833010000046
						],
						[
							-81.95710496499993,
							28.026335009000036
						],
						[
							-81.9570489109999,
							28.026335009000036
						],
						[
							-81.95286491099995,
							28.02633601000008
						],
						[
							-81.95147063899992,
							28.026288571000066
						],
						[
							-81.95073450299992,
							28.02575545700006
						],
						[
							-81.95074824099993,
							28.025733363000086
						],
						[
							-81.9507825199999,
							28.025685527000068
						],
						[
							-81.95081985399992,
							28.025640036000084
						],
						[
							-81.95086008399994,
							28.02559708300004
						],
						[
							-81.95089755399995,
							28.025561701000072
						],
						[
							-81.95102655399995,
							28.025446701000078
						],
						[
							-81.9510320359999,
							28.025441854000064
						],
						[
							-81.95107752699994,
							28.025404520000052
						],
						[
							-81.9511253629999,
							28.025370241000076
						],
						[
							-81.95117533899992,
							28.02533916400006
						],
						[
							-81.95122620599994,
							28.025311934000058
						],
						[
							-81.95132120499994,
							28.025264933000074
						],
						[
							-81.95132223999991,
							28.02526442200008
						],
						[
							-81.95137584399993,
							28.025240135000047
						],
						[
							-81.95143092199993,
							28.025219405000087
						],
						[
							-81.9514583539999,
							28.025210580000078
						],
						[
							-81.95149011299992,
							28.02512564300008
						],
						[
							-81.95152131099991,
							28.024957519000054
						],
						[
							-81.9515690419999,
							28.024365299000067
						],
						[
							-81.9515710849999,
							28.024162378000085
						],
						[
							-81.9514672439999,
							28.02337284200007
						],
						[
							-81.95141067199995,
							28.023177614000076
						],
						[
							-81.95140772199994,
							28.023172119000037
						],
						[
							-81.95128415699992,
							28.023074402000077
						],
						[
							-81.95124903599992,
							28.023045146000072
						],
						[
							-81.95120608299993,
							28.023004917000037
						],
						[
							-81.95116585399991,
							28.022961964000046
						],
						[
							-81.95112855999992,
							28.022916525000085
						],
						[
							-81.95102955999994,
							28.02278752600006
						],
						[
							-81.9510295199999,
							28.02278747300005
						],
						[
							-81.95099524099993,
							28.022739637000086
						],
						[
							-81.95096416399991,
							28.022689661000076
						],
						[
							-81.95093642299992,
							28.022637760000066
						],
						[
							-81.9509121349999,
							28.02258415600005
						],
						[
							-81.95089607199992,
							28.022542478000048
						],
						[
							-81.95086607199994,
							28.02245847800009
						],
						[
							-81.95086140399991,
							28.02244507800009
						],
						[
							-81.95084432099992,
							28.02238876200005
						],
						[
							-81.95083095799993,
							28.022331449000035
						],
						[
							-81.9508213709999,
							28.022273385000062
						],
						[
							-81.95081560299991,
							28.022214819000055
						],
						[
							-81.95081367799992,
							28.022156000000052
						],
						[
							-81.95081557399995,
							28.02209762800004
						],
						[
							-81.95082275699991,
							28.021987196000055
						],
						[
							-81.9507158369999,
							28.02183038000004
						],
						[
							-81.9505695389999,
							28.021683369000073
						],
						[
							-81.95053085399991,
							28.021641964000082
						],
						[
							-81.9504935189999,
							28.021596473000045
						],
						[
							-81.95045924099992,
							28.02154863700008
						],
						[
							-81.95045777199994,
							28.021546432000036
						],
						[
							-81.9503767729999,
							28.02142443200006
						],
						[
							-81.95034716499993,
							28.021376661000094
						],
						[
							-81.95032361299991,
							28.021333147000064
						],
						[
							-81.9502826129999,
							28.02125214700004
						],
						[
							-81.95027842299993,
							28.02124376000006
						],
						[
							-81.95025413499991,
							28.02119015600005
						],
						[
							-81.95023340499995,
							28.021135078000043
						],
						[
							-81.9502163219999,
							28.02107876200006
						],
						[
							-81.95020295799992,
							28.02102144900005
						],
						[
							-81.95019370799992,
							28.02096590700006
						],
						[
							-81.95018034899994,
							28.020866609000052
						],
						[
							-81.94981038499992,
							28.020503576000067
						],
						[
							-81.94939815299995,
							28.02017115900009
						],
						[
							-81.94899255899992,
							28.019887072000074
						],
						[
							-81.94881520199993,
							28.01979177600009
						],
						[
							-81.94845068399991,
							28.01964515800006
						],
						[
							-81.94787427599994,
							28.01947419800007
						],
						[
							-81.9478409219999,
							28.019463595000047
						],
						[
							-81.94778584399995,
							28.019442866000077
						],
						[
							-81.94773223999994,
							28.019418578000057
						],
						[
							-81.94769563599993,
							28.019399470000053
						],
						[
							-81.9466777259999,
							28.01883799600006
						],
						[
							-81.94615556899993,
							28.018628179000075
						],
						[
							-81.94597122399995,
							28.018594308000047
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Polk",
				"City": "Lakeland",
				"Name": "Lake Hollingsworth",
				"RegionID": "343459"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.94092799999993,
					28.05315026100004,
					-81.9347767989999,
					28.06351832200005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.9347767989999,
							28.054031338000073
						],
						[
							-81.93496174599994,
							28.05315026100004
						],
						[
							-81.93673142099993,
							28.05355060500006
						],
						[
							-81.93866329599992,
							28.054286558000058
						],
						[
							-81.94054916699992,
							28.05488457200005
						],
						[
							-81.94088637399994,
							28.054909443000042
						],
						[
							-81.94092799999993,
							28.062966000000074
						],
						[
							-81.94015898399994,
							28.063474885000062
						],
						[
							-81.94007598199994,
							28.063494415000036
						],
						[
							-81.94004544899991,
							28.06350104200004
						],
						[
							-81.93998738599993,
							28.063510628000078
						],
						[
							-81.93992881899993,
							28.063516397000058
						],
						[
							-81.93986999999993,
							28.06351832200005
						],
						[
							-81.93978199999992,
							28.06351832200005
						],
						[
							-81.93972318099992,
							28.063516397000058
						],
						[
							-81.93966461499991,
							28.063510628000078
						],
						[
							-81.93960655099994,
							28.06350104200004
						],
						[
							-81.93954923799993,
							28.06348767800006
						],
						[
							-81.93949292199994,
							28.06347059500007
						],
						[
							-81.93943784399994,
							28.063449865000052
						],
						[
							-81.93938996499992,
							28.063428376000047
						],
						[
							-81.93932596499991,
							28.06339737600007
						],
						[
							-81.93932023999992,
							28.063394578000043
						],
						[
							-81.93926833899991,
							28.063366836000057
						],
						[
							-81.93921836299995,
							28.06333575900004
						],
						[
							-81.93917052699993,
							28.063301481000057
						],
						[
							-81.93913918399994,
							28.063276297000073
						],
						[
							-81.93909518399994,
							28.063239296000063
						],
						[
							-81.93908103599995,
							28.06322714600009
						],
						[
							-81.93903808399995,
							28.063186916000063
						],
						[
							-81.93899785399992,
							28.063143964000066
						],
						[
							-81.93896051999992,
							28.063098472000036
						],
						[
							-81.93892624099993,
							28.06305063600007
						],
						[
							-81.9388951649999,
							28.063000661000046
						],
						[
							-81.93886963199992,
							28.062953208000067
						],
						[
							-81.93885463099991,
							28.062923208000086
						],
						[
							-81.93885242199991,
							28.06291876000006
						],
						[
							-81.93882813399995,
							28.062865156000043
						],
						[
							-81.93880740499992,
							28.06281007800004
						],
						[
							-81.93879032099994,
							28.062753762000057
						],
						[
							-81.93877695799995,
							28.062696449000043
						],
						[
							-81.93876737099993,
							28.06263838500007
						],
						[
							-81.93876451699992,
							28.062614173000043
						],
						[
							-81.93873951799992,
							28.06237417300008
						],
						[
							-81.93873660399993,
							28.062339818000055
						],
						[
							-81.93873467799995,
							28.06228100000004
						],
						[
							-81.93873660399993,
							28.06222218100004
						],
						[
							-81.93874237199992,
							28.062163615000088
						],
						[
							-81.93875195899994,
							28.06210555100006
						],
						[
							-81.93876089899993,
							28.062065419000078
						],
						[
							-81.93878089899994,
							28.061984419000055
						],
						[
							-81.93878532199994,
							28.06196723800008
						],
						[
							-81.93879182599994,
							28.06194419800005
						],
						[
							-81.93848926999993,
							28.061685280000063
						],
						[
							-81.93848103499994,
							28.061678146000077
						],
						[
							-81.9384425419999,
							28.061642344000063
						],
						[
							-81.93837054199993,
							28.061571344000072
						],
						[
							-81.93836608299995,
							28.06156691600006
						],
						[
							-81.93832585399993,
							28.06152396400006
						],
						[
							-81.9382885199999,
							28.06147847200009
						],
						[
							-81.93825424099992,
							28.06143063600007
						],
						[
							-81.93822316399991,
							28.061380661000044
						],
						[
							-81.93819542299991,
							28.06132876000004
						],
						[
							-81.93817113499995,
							28.06127515500009
						],
						[
							-81.93816936499991,
							28.061270851000074
						],
						[
							-81.93812936499995,
							28.061172851000038
						],
						[
							-81.93811040499992,
							28.06112207700005
						],
						[
							-81.93809332199993,
							28.061065761000066
						],
						[
							-81.93807995799995,
							28.06100844900004
						],
						[
							-81.93807677699994,
							28.06099162100009
						],
						[
							-81.93806603399992,
							28.06093166700009
						],
						[
							-81.93802803599993,
							28.06090014600005
						],
						[
							-81.93798508399993,
							28.060859917000073
						],
						[
							-81.93794485399991,
							28.060816964000082
						],
						[
							-81.93793365899995,
							28.060803950000036
						],
						[
							-81.93787965799993,
							28.060739950000084
						],
						[
							-81.93785351999992,
							28.060707473000036
						],
						[
							-81.93781924099994,
							28.06065963700007
						],
						[
							-81.93778816399993,
							28.060609661000058
						],
						[
							-81.9377746369999,
							28.06058537100006
						],
						[
							-81.93772363699992,
							28.06049037200006
						],
						[
							-81.93770942299994,
							28.060462760000064
						],
						[
							-81.93768513499992,
							28.06040915600005
						],
						[
							-81.93767923699995,
							28.06039455800004
						],
						[
							-81.93756439499992,
							28.060102967000034
						],
						[
							-81.93714817599994,
							28.05925222100007
						],
						[
							-81.93712513499992,
							28.05920115600009
						],
						[
							-81.93712385299995,
							28.059198044000084
						],
						[
							-81.93699885299992,
							28.058893044000058
						],
						[
							-81.93697940499993,
							28.058841077000068
						],
						[
							-81.93696232199994,
							28.058784761000084
						],
						[
							-81.93696006399996,
							28.05877616500004
						],
						[
							-81.93683806399991,
							28.05830216600009
						],
						[
							-81.93682695799993,
							28.058253449000063
						],
						[
							-81.93681828299992,
							28.058202116000075
						],
						[
							-81.9367332839999,
							28.05759211500009
						],
						[
							-81.93673237199994,
							28.057585385000042
						],
						[
							-81.93673004399994,
							28.057566095000084
						],
						[
							-81.93652271199994,
							28.05567662800007
						],
						[
							-81.9364247609999,
							28.05520406100004
						],
						[
							-81.93637835899996,
							28.055045703000076
						],
						[
							-81.93629796999994,
							28.054815218000044
						],
						[
							-81.9358512899999,
							28.054518004000045
						],
						[
							-81.9351680549999,
							28.054139639000084
						],
						[
							-81.9351274519999,
							28.054121998000085
						],
						[
							-81.9347767989999,
							28.054031338000073
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Polk",
				"City": "Lakeland",
				"Name": "Edgewater Beach",
				"RegionID": "343461"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.5859548279999,
					27.29715667800008,
					-82.56330182099992,
					27.319986261000054
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.5762426089999,
							27.31435445900007
						],
						[
							-82.5757676369999,
							27.314286606000053
						],
						[
							-82.57542837199992,
							27.314309224000056
						],
						[
							-82.57502125399992,
							27.31442231200009
						],
						[
							-82.5745462829999,
							27.31469372500004
						],
						[
							-82.5740939289999,
							27.314874666000037
						],
						[
							-82.57379989899994,
							27.314919901000053
						],
						[
							-82.57330230999992,
							27.314829431000078
						],
						[
							-82.57280472199994,
							27.31446754800004
						],
						[
							-82.5720357209999,
							27.314037812000038
						],
						[
							-82.5711762489999,
							27.314015194000035
						],
						[
							-82.56975133499992,
							27.313246193000055
						],
						[
							-82.56856024699994,
							27.312516206000055
						],
						[
							-82.56855434099992,
							27.312494166000082
						],
						[
							-82.5685523379999,
							27.31247126800008
						],
						[
							-82.5685059999999,
							27.31247532200007
						],
						[
							-82.56834983499994,
							27.312461659000064
						],
						[
							-82.56819841399994,
							27.312421086000086
						],
						[
							-82.56805633899995,
							27.312354836000054
						],
						[
							-82.56792792699991,
							27.312264920000075
						],
						[
							-82.56781707999994,
							27.312154073000045
						],
						[
							-82.56772716499995,
							27.312025661000064
						],
						[
							-82.56766091399993,
							27.31188358600008
						],
						[
							-82.56765389999993,
							27.311863586000072
						],
						[
							-82.56751889999992,
							27.31146358600006
						],
						[
							-82.5674853399999,
							27.311332166000057
						],
						[
							-82.56747167799995,
							27.311176000000046
						],
						[
							-82.5674853399999,
							27.31101983500008
						],
						[
							-82.56752591299994,
							27.310868414000083
						],
						[
							-82.56758030999993,
							27.310747526000057
						],
						[
							-82.56771831799995,
							27.31049285100005
						],
						[
							-82.56772195899993,
							27.31045591900005
						],
						[
							-82.56770658499994,
							27.310407138000077
						],
						[
							-82.56763686399995,
							27.310181829000044
						],
						[
							-82.56761034099992,
							27.310072165000065
						],
						[
							-82.56759667799992,
							27.309916000000044
						],
						[
							-82.56759667799992,
							27.309706000000062
						],
						[
							-82.56761034099992,
							27.30954983400005
						],
						[
							-82.56762046399992,
							27.309519614000067
						],
						[
							-82.56760009599992,
							27.309517629000084
						],
						[
							-82.56743899999992,
							27.309531322000055
						],
						[
							-82.56732858799995,
							27.309524519000036
						],
						[
							-82.56723158799991,
							27.309512519000066
						],
						[
							-82.5671969739999,
							27.30950755200007
						],
						[
							-82.5670384039999,
							27.309481605000087
						],
						[
							-82.56688141399991,
							27.309440086000052
						],
						[
							-82.5667974289999,
							27.30940460000005
						],
						[
							-82.56664442899995,
							27.309330600000067
						],
						[
							-82.56658633899991,
							27.309299836000037
						],
						[
							-82.56645582699991,
							27.309207882000067
						],
						[
							-82.56638223899995,
							27.309279484000058
						],
						[
							-82.56632723899992,
							27.309328484000048
						],
						[
							-82.56627219899991,
							27.309374774000048
						],
						[
							-82.56621302899994,
							27.30941565200004
						],
						[
							-82.56615025999992,
							27.309450755000057
						],
						[
							-82.5660844539999,
							27.309479766000038
						],
						[
							-82.5660086609999,
							27.309532836000074
						],
						[
							-82.56596958599994,
							27.30955412500009
						],
						[
							-82.56589358499991,
							27.30959312500005
						],
						[
							-82.56587142099995,
							27.30960411600006
						],
						[
							-82.56580042099995,
							27.30963811600009
						],
						[
							-82.5657351399999,
							27.309667495000042
						],
						[
							-82.56566741699994,
							27.309690698000054
						],
						[
							-82.56559783499995,
							27.30970752500008
						],
						[
							-82.56552699399992,
							27.309717831000057
						],
						[
							-82.5654555019999,
							27.309721527000082
						],
						[
							-82.56534269299993,
							27.30972872700005
						],
						[
							-82.5652684879999,
							27.309729988000072
						],
						[
							-82.56519445999993,
							27.30972472000008
						],
						[
							-82.56512118199993,
							27.309712964000084
						],
						[
							-82.56504922199991,
							27.30969481200009
						],
						[
							-82.56497913499993,
							27.30967040300004
						],
						[
							-82.56491146599991,
							27.30963992800008
						],
						[
							-82.56485148899992,
							27.30961176900007
						],
						[
							-82.56478069199994,
							27.30957499400006
						],
						[
							-82.56469869199992,
							27.30952599400007
						],
						[
							-82.56464271099992,
							27.309489658000075
						],
						[
							-82.56458957899991,
							27.309449270000073
						],
						[
							-82.56453958899993,
							27.309405053000035
						],
						[
							-82.56449301499993,
							27.30935725100005
						],
						[
							-82.56445011499994,
							27.30930612600008
						],
						[
							-82.5644011149999,
							27.309243126000073
						],
						[
							-82.56435605899992,
							27.309179716000074
						],
						[
							-82.5643166509999,
							27.30911265100008
						],
						[
							-82.5642831859999,
							27.30904243000009
						],
						[
							-82.56425591399994,
							27.308969581000046
						],
						[
							-82.56423503899993,
							27.308894647000045
						],
						[
							-82.56422071799994,
							27.30881818900008
						],
						[
							-82.56420471699994,
							27.308706190000066
						],
						[
							-82.56419567799992,
							27.308579000000066
						],
						[
							-82.56419675599994,
							27.30853496700007
						],
						[
							-82.56420175699992,
							27.308432966000055
						],
						[
							-82.56421434099991,
							27.308320834000085
						],
						[
							-82.5642253389999,
							27.308267840000042
						],
						[
							-82.5642473389999,
							27.308175840000047
						],
						[
							-82.56426634399992,
							27.30810817300005
						],
						[
							-82.56427424599991,
							27.308083749000048
						],
						[
							-82.56415433899991,
							27.308027836000065
						],
						[
							-82.56402592699993,
							27.30793792100008
						],
						[
							-82.5639150799999,
							27.307827073000055
						],
						[
							-82.56382516499991,
							27.307698661000074
						],
						[
							-82.56380566099995,
							27.307663046000076
						],
						[
							-82.56365361099996,
							27.307369872000038
						],
						[
							-82.56350360099992,
							27.307125545000076
						],
						[
							-82.56346563599993,
							27.30705721700008
						],
						[
							-82.56343374799991,
							27.306985851000036
						],
						[
							-82.56340817699994,
							27.306911985000056
						],
						[
							-82.56338911699993,
							27.306836177000037
						],
						[
							-82.56337671199992,
							27.306759001000046
						],
						[
							-82.56332818599992,
							27.306342201000064
						],
						[
							-82.56331262099991,
							27.306268276000083
						],
						[
							-82.56330380899993,
							27.306193247000067
						],
						[
							-82.56330182099992,
							27.30611772700007
						],
						[
							-82.56330667399993,
							27.306042338000054
						],
						[
							-82.56344967399991,
							27.304691337000065
						],
						[
							-82.56345834099994,
							27.30462983400008
						],
						[
							-82.56350090099994,
							27.304475426000067
						],
						[
							-82.56350633999995,
							27.304419834000043
						],
						[
							-82.56351041799991,
							27.304398253000045
						],
						[
							-82.56383341899993,
							27.302796253000054
						],
						[
							-82.5638756219999,
							27.302651162000075
						],
						[
							-82.56404020299993,
							27.302223250000054
						],
						[
							-82.56408109299991,
							27.301997629000084
						],
						[
							-82.56412242599993,
							27.301846321000085
						],
						[
							-82.56423493799991,
							27.301546228000063
						],
						[
							-82.56426390299993,
							27.30147774200009
						],
						[
							-82.5644004429999,
							27.30118882100004
						],
						[
							-82.56444763999991,
							27.30096856700004
						],
						[
							-82.56448191299995,
							27.300849414000083
						],
						[
							-82.56450980699992,
							27.30078153100004
						],
						[
							-82.56460972699995,
							27.300564059000067
						],
						[
							-82.56463265199994,
							27.30041218300005
						],
						[
							-82.56462426899992,
							27.300271484000064
						],
						[
							-82.56462267799992,
							27.300218000000086
						],
						[
							-82.56462267799992,
							27.30007494700004
						],
						[
							-82.56458528499991,
							27.29989399200008
						],
						[
							-82.56457481599995,
							27.299832713000058
						],
						[
							-82.56456860599991,
							27.299770856000066
						],
						[
							-82.56456668399994,
							27.29970871900008
						],
						[
							-82.56456905899995,
							27.29964659700005
						],
						[
							-82.56459467799993,
							27.29929525500006
						],
						[
							-82.56459467799993,
							27.299019000000044
						],
						[
							-82.56460834099994,
							27.29886283500008
						],
						[
							-82.56463499699993,
							27.298752740000054
						],
						[
							-82.56471899799995,
							27.298481740000057
						],
						[
							-82.56473291399993,
							27.298440414000083
						],
						[
							-82.56477965999994,
							27.29833395600008
						],
						[
							-82.56494665999992,
							27.298011955000053
						],
						[
							-82.5650263199999,
							27.297885371000064
						],
						[
							-82.56519331999993,
							27.297663372000045
						],
						[
							-82.56523932399995,
							27.297607102000086
						],
						[
							-82.56528972199993,
							27.29755473000006
						],
						[
							-82.5653441849999,
							27.297506600000077
						],
						[
							-82.56540235699993,
							27.29746302600006
						],
						[
							-82.56546385799993,
							27.297424291000084
						],
						[
							-82.5656593779999,
							27.297312418000047
						],
						[
							-82.56579841399991,
							27.297247913000035
						],
						[
							-82.56595431599993,
							27.297206574000086
						],
						[
							-82.56618179799996,
							27.297168807000048
						],
						[
							-82.56632899999994,
							27.29715667800008
						],
						[
							-82.56635673099993,
							27.297157105000053
						],
						[
							-82.56674573099991,
							27.29716910600007
						],
						[
							-82.5668259549999,
							27.29717518100006
						],
						[
							-82.56713195499992,
							27.297212181000077
						],
						[
							-82.56720935399994,
							27.29722498700005
						],
						[
							-82.56728534399993,
							27.297244489000036
						],
						[
							-82.5673593439999,
							27.297270540000056
						],
						[
							-82.56743079199993,
							27.297302941000055
						],
						[
							-82.56791779299994,
							27.297549940000067
						],
						[
							-82.56796066099992,
							27.297573164000084
						],
						[
							-82.56805919399994,
							27.297639073000084
						],
						[
							-82.56851801099992,
							27.297991874000047
						],
						[
							-82.56859799199992,
							27.29803538300007
						],
						[
							-82.5686622469999,
							27.298050230000058
						],
						[
							-82.5688520089999,
							27.298058678000075
						],
						[
							-82.56895274599992,
							27.298058678000075
						],
						[
							-82.56910157599992,
							27.298047989000054
						],
						[
							-82.5691771569999,
							27.29804574800005
						],
						[
							-82.56925265899991,
							27.298049863000074
						],
						[
							-82.56932754899992,
							27.29806030700007
						],
						[
							-82.56940129599991,
							27.29807700500004
						],
						[
							-82.56947337999992,
							27.298099839000088
						],
						[
							-82.56954329199993,
							27.298128648000045
						],
						[
							-82.56961053599991,
							27.29816322800008
						],
						[
							-82.56976609799995,
							27.29825169600008
						],
						[
							-82.56983076499996,
							27.298292493000076
						],
						[
							-82.5698917329999,
							27.29833863500005
						],
						[
							-82.56994855999994,
							27.29838979100009
						],
						[
							-82.57000083699995,
							27.29844558800005
						],
						[
							-82.5700481849999,
							27.298505625000075
						],
						[
							-82.5700902609999,
							27.29856946700005
						],
						[
							-82.57012676199992,
							27.298636652000084
						],
						[
							-82.5702443859999,
							27.298876976000088
						],
						[
							-82.57059589699992,
							27.299433684000064
						],
						[
							-82.57140060699993,
							27.30053270600007
						],
						[
							-82.57144080599994,
							27.300592490000042
						],
						[
							-82.57470280599995,
							27.30589049000008
						],
						[
							-82.57474894599994,
							27.305975318000037
						],
						[
							-82.5751703059999,
							27.306860079000046
						],
						[
							-82.57590811199992,
							27.307944404000068
						],
						[
							-82.57680757899995,
							27.308845746000088
						],
						[
							-82.5768743889999,
							27.308920621000084
						],
						[
							-82.5786333019999,
							27.31112840800006
						],
						[
							-82.58152346999992,
							27.31426600000009
						],
						[
							-82.5820787699999,
							27.314684998000075
						],
						[
							-82.58263322199991,
							27.315013845000067
						],
						[
							-82.58345713999995,
							27.31518815200008
						],
						[
							-82.58352943599994,
							27.315206611000065
						],
						[
							-82.58359995299992,
							27.31523099900005
						],
						[
							-82.58366820599991,
							27.315261149000037
						],
						[
							-82.5837337239999,
							27.315296854000053
						],
						[
							-82.58379605699992,
							27.31533786600005
						],
						[
							-82.5838547759999,
							27.31538390500009
						],
						[
							-82.58390947599992,
							27.315434653000068
						],
						[
							-82.58433722199993,
							27.315865862000066
						],
						[
							-82.58547857999991,
							27.31661522900004
						],
						[
							-82.58549634899992,
							27.316627200000084
						],
						[
							-82.5859548279999,
							27.31694410100005
						],
						[
							-82.58543529699995,
							27.317678244000035
						],
						[
							-82.58126740599994,
							27.319813048000075
						],
						[
							-82.58090184999992,
							27.319986261000054
						],
						[
							-82.58051734999992,
							27.319036319000077
						],
						[
							-82.58015546699994,
							27.31849349400005
						],
						[
							-82.5796126429999,
							27.31763402300004
						],
						[
							-82.57930399999992,
							27.31756500000006
						],
						[
							-82.57914999999991,
							27.31709600000005
						],
						[
							-82.5791602889999,
							27.31679716900004
						],
						[
							-82.57857222899992,
							27.316141256000037
						],
						[
							-82.57800678699995,
							27.31553057900004
						],
						[
							-82.57741872799994,
							27.31489728400004
						],
						[
							-82.57712469799992,
							27.314625872000082
						],
						[
							-82.5768306679999,
							27.314512783000055
						],
						[
							-82.5762426089999,
							27.31435445900007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Lido Key",
				"RegionID": "343984"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.31865721398505,
					28.539598618362426,
					-81.31054199999056,
					28.547398000352715
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.31120499997553,
							28.547398000352715
						],
						[
							-81.31095800028096,
							28.547387999891633
						],
						[
							-81.31072300024012,
							28.547387999891633
						],
						[
							-81.31064999999995,
							28.54738452351991
						],
						[
							-81.31064999999995,
							28.547280779129586
						],
						[
							-81.3106470003341,
							28.54717299987349
						],
						[
							-81.310646000288,
							28.547122000220455
						],
						[
							-81.310646000288,
							28.5469528422435
						],
						[
							-81.310646000288,
							28.546910000340674
						],
						[
							-81.31055399982209,
							28.546315999969558
						],
						[
							-81.31055699978265,
							28.546096999736143
						],
						[
							-81.31055299959819,
							28.545813000134707
						],
						[
							-81.31054199999056,
							28.54320200028567
						],
						[
							-81.31054600017492,
							28.54200900015108
						],
						[
							-81.31055299959819,
							28.541085999872024
						],
						[
							-81.31055199955219,
							28.540134000054913
						],
						[
							-81.31055299959819,
							28.539635999581876
						],
						[
							-81.31055242223354,
							28.539598618362426
						],
						[
							-81.3106341804986,
							28.53959993856708
						],
						[
							-81.31154252722445,
							28.539612957152755
						],
						[
							-81.3116336627202,
							28.539613958098215
						],
						[
							-81.31249594167502,
							28.539615960888327
						],
						[
							-81.31326908882372,
							28.539627979428005
						],
						[
							-81.31364564664855,
							28.539636993332557
						],
						[
							-81.31393507635657,
							28.539662030458
						],
						[
							-81.31423051443511,
							28.53968706758335
						],
						[
							-81.3144909005381,
							28.53970910007358
						],
						[
							-81.31455301311337,
							28.539714018465855
						],
						[
							-81.31463498541706,
							28.542545438547094
						],
						[
							-81.31865721398505,
							28.542545172347765
						],
						[
							-81.31864906792593,
							28.54610758925314
						],
						[
							-81.31865365266964,
							28.54638100023713
						],
						[
							-81.31704400023625,
							28.54638100023713
						],
						[
							-81.31704200014407,
							28.546203000125768
						],
						[
							-81.31702600030582,
							28.54602099983022
						],
						[
							-81.31702400021364,
							28.54561600004682
						],
						[
							-81.31688300000931,
							28.54561600004682
						],
						[
							-81.31653300006332,
							28.54561600004682
						],
						[
							-81.31653300006332,
							28.54554600041744
						],
						[
							-81.31544899955733,
							28.54554400032508
						],
						[
							-81.31544700036443,
							28.54561600004682
						],
						[
							-81.31502399975132,
							28.54561600004682
						],
						[
							-81.31501300014361,
							28.546029000198942
						],
						[
							-81.31504499982003,
							28.546820999835305
						],
						[
							-81.31489900028454,
							28.546819999789218
						],
						[
							-81.31489900028454,
							28.546954999716988
						],
						[
							-81.31176899989376,
							28.546954999716988
						],
						[
							-81.31131399960422,
							28.546953999670805
						],
						[
							-81.31132199997303,
							28.547398000352715
						],
						[
							-81.31120499997553,
							28.547398000352715
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Azalea Park",
				"RegionID": "403126"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.17993632199995,
					25.731067000000053,
					-80.14140595999993,
					25.758729386000084
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.14528074899994,
							25.753663132000042
						],
						[
							-80.1453216779999,
							25.752825053000038
						],
						[
							-80.1453216779999,
							25.752460988000053
						],
						[
							-80.1452161119999,
							25.751879622000047
						],
						[
							-80.1451322019999,
							25.751695140000038
						],
						[
							-80.14499854699994,
							25.75144151300009
						],
						[
							-80.14492685899995,
							25.751449474000083
						],
						[
							-80.1448547569999,
							25.75145143000009
						],
						[
							-80.14478274299995,
							25.751447367000083
						],
						[
							-80.1447113179999,
							25.751437314000043
						],
						[
							-80.1446409799999,
							25.751421341000082
						],
						[
							-80.14449997999992,
							25.751383341000064
						],
						[
							-80.14442641399995,
							25.75136008700008
						],
						[
							-80.14428761799991,
							25.75129536500009
						],
						[
							-80.14333732599994,
							25.751453173000073
						],
						[
							-80.14325956999994,
							25.751462630000052
						],
						[
							-80.1431812859999,
							25.751465284000062
						],
						[
							-80.14310306799992,
							25.75146111400005
						],
						[
							-80.14302550999992,
							25.75145015100009
						],
						[
							-80.14294920099991,
							25.751432478000083
						],
						[
							-80.1428747189999,
							25.751408231000084
						],
						[
							-80.14280263099994,
							25.751377593000086
						],
						[
							-80.14273348299992,
							25.75134079600008
						],
						[
							-80.14255862699993,
							25.751235756000085
						],
						[
							-80.1424940899999,
							25.751193087000047
						],
						[
							-80.14243346399991,
							25.751145022000063
						],
						[
							-80.1423771979999,
							25.75109191900009
						],
						[
							-80.14232570999991,
							25.75103417200006
						],
						[
							-80.1422793829999,
							25.750972208000064
						],
						[
							-80.1422385589999,
							25.750906488000055
						],
						[
							-80.1416549519999,
							25.749845314000083
						],
						[
							-80.14161998599991,
							25.74977453000008
						],
						[
							-80.14159136199993,
							25.74970095300006
						],
						[
							-80.14156930199994,
							25.749625148000064
						],
						[
							-80.14155397499991,
							25.74954770100004
						],
						[
							-80.1415454989999,
							25.74946920800005
						],
						[
							-80.14140749899991,
							25.74730420800006
						],
						[
							-80.14140595999993,
							25.74722445100008
						],
						[
							-80.14141149499994,
							25.74714487200004
						],
						[
							-80.1414240599999,
							25.747066096000083
						],
						[
							-80.14144355699995,
							25.746988744000078
						],
						[
							-80.14201003399995,
							25.74509919500008
						],
						[
							-80.14206995399991,
							25.744718155000044
						],
						[
							-80.14211191399994,
							25.74455841400004
						],
						[
							-80.14217075099992,
							25.74442943100007
						],
						[
							-80.14235537199994,
							25.744096933000037
						],
						[
							-80.1425483939999,
							25.743651622000073
						],
						[
							-80.14259825599993,
							25.743447043000064
						],
						[
							-80.14261746699992,
							25.743379729000083
						],
						[
							-80.14264185499991,
							25.743314112000064
						],
						[
							-80.14267127299992,
							25.743250592000038
						],
						[
							-80.14270554199993,
							25.74318955200005
						],
						[
							-80.1427444549999,
							25.743131362000042
						],
						[
							-80.14278777699991,
							25.743076375000044
						],
						[
							-80.14283524399991,
							25.743024925000043
						],
						[
							-80.14430969299991,
							25.74154657200006
						],
						[
							-80.14589158899992,
							25.739546169000054
						],
						[
							-80.14593698099992,
							25.739493136000082
						],
						[
							-80.14598634899994,
							25.73944378300007
						],
						[
							-80.14603939699992,
							25.739398408000056
						],
						[
							-80.14609580499992,
							25.73935728400005
						],
						[
							-80.14771380499991,
							25.738271285000053
						],
						[
							-80.14773995399992,
							25.738254383000083
						],
						[
							-80.1486449539999,
							25.737691383000083
						],
						[
							-80.14869902899994,
							25.737660290000065
						],
						[
							-80.14875512899994,
							25.73763302100008
						],
						[
							-80.14881298499995,
							25.737609706000057
						],
						[
							-80.14887231699993,
							25.737590458000057
						],
						[
							-80.1503151519999,
							25.737177099000064
						],
						[
							-80.15088598499995,
							25.736969524000074
						],
						[
							-80.15147326899995,
							25.736480122000046
						],
						[
							-80.15158052599992,
							25.736403334000045
						],
						[
							-80.15388742099992,
							25.734995536000042
						],
						[
							-80.15423417699992,
							25.734740514000066
						],
						[
							-80.15431733899993,
							25.73468616400004
						],
						[
							-80.15442541499993,
							25.734633075000094
						],
						[
							-80.15502469799992,
							25.73438701200007
						],
						[
							-80.15552064699995,
							25.733915940000088
						],
						[
							-80.15556192699995,
							25.733879079000076
						],
						[
							-80.15567363799994,
							25.733799048000037
						],
						[
							-80.15736863799992,
							25.732771048000075
						],
						[
							-80.15742167299993,
							25.732741288000057
						],
						[
							-80.1574765979999,
							25.73271518000007
						],
						[
							-80.15753316199994,
							25.73269284400004
						],
						[
							-80.15759110699992,
							25.732674381000038
						],
						[
							-80.15787067899993,
							25.73259561000009
						],
						[
							-80.1579142519999,
							25.73256414100007
						],
						[
							-80.1585666869999,
							25.733209783000063
						],
						[
							-80.15984899999995,
							25.732619000000057
						],
						[
							-80.16057499999994,
							25.732001000000086
						],
						[
							-80.16098199999993,
							25.73190800000009
						],
						[
							-80.16283599999991,
							25.73132000000004
						],
						[
							-80.16307699999993,
							25.73132000000004
						],
						[
							-80.1640579999999,
							25.731067000000053
						],
						[
							-80.16626999999994,
							25.73162800000006
						],
						[
							-80.16685299999995,
							25.732154000000037
						],
						[
							-80.16726499999993,
							25.73314400000004
						],
						[
							-80.1672309999999,
							25.73363900000004
						],
						[
							-80.1671619999999,
							25.734227000000093
						],
						[
							-80.16692199999994,
							25.734598000000062
						],
						[
							-80.16640699999994,
							25.73527800000005
						],
						[
							-80.1665099999999,
							25.735588000000067
						],
						[
							-80.16702499999991,
							25.735742000000073
						],
						[
							-80.16747099999992,
							25.735959000000037
						],
						[
							-80.1679519999999,
							25.736515000000054
						],
						[
							-80.1682229999999,
							25.73716600000006
						],
						[
							-80.16822699999994,
							25.737467000000038
						],
						[
							-80.16887899999995,
							25.738278000000037
						],
						[
							-80.17087099999992,
							25.73985600000009
						],
						[
							-80.1721409999999,
							25.741093000000035
						],
						[
							-80.17257925299992,
							25.74155298100004
						],
						[
							-80.17267361899991,
							25.74035636000008
						],
						[
							-80.17276849099994,
							25.740448768000082
						],
						[
							-80.17279210799991,
							25.740472647000047
						],
						[
							-80.17444624899991,
							25.742208795000067
						],
						[
							-80.1756054729999,
							25.743426594000088
						],
						[
							-80.17716870299995,
							25.74447743700006
						],
						[
							-80.17823328299994,
							25.74485547900008
						],
						[
							-80.1790124819999,
							25.745086093000058
						],
						[
							-80.17903816599994,
							25.745088340000052
						],
						[
							-80.17918958699994,
							25.745128913000087
						],
						[
							-80.17933166099994,
							25.74519516400005
						],
						[
							-80.17946007299992,
							25.74528507900004
						],
						[
							-80.1795522139999,
							25.745374338000094
						],
						[
							-80.17963721299992,
							25.74546933800008
						],
						[
							-80.17968598499994,
							25.74552877700006
						],
						[
							-80.17972950099994,
							25.745592164000072
						],
						[
							-80.17976744299995,
							25.745659036000063
						],
						[
							-80.1797995359999,
							25.745728905000078
						],
						[
							-80.17982554199995,
							25.745801260000064
						],
						[
							-80.17984527399994,
							25.745875571000056
						],
						[
							-80.17988227399991,
							25.746043572000076
						],
						[
							-80.17989533699995,
							25.746117428000048
						],
						[
							-80.17992833799991,
							25.746363428000052
						],
						[
							-80.17993632199995,
							25.74648300000007
						],
						[
							-80.17993420699992,
							25.74654464300005
						],
						[
							-80.17992520699995,
							25.74667564300006
						],
						[
							-80.17992270699995,
							25.74670499100006
						],
						[
							-80.1799167069999,
							25.74676399100008
						],
						[
							-80.17989447199996,
							25.746891108000057
						],
						[
							-80.1798844729999,
							25.74693110800007
						],
						[
							-80.17985708599991,
							25.747020586000076
						],
						[
							-80.17979083599994,
							25.74716266100006
						],
						[
							-80.17970092099995,
							25.747291073000042
						],
						[
							-80.17959007299993,
							25.747401920000073
						],
						[
							-80.17956900599995,
							25.747419062000063
						],
						[
							-80.17947900599995,
							25.747490063000043
						],
						[
							-80.17942269199995,
							25.74753105300005
						],
						[
							-80.17936337499992,
							25.74756756100004
						],
						[
							-80.17930140999995,
							25.747599370000046
						],
						[
							-80.17923716999991,
							25.74762628700006
						],
						[
							-80.17917103899993,
							25.747648153000057
						],
						[
							-80.17910341399994,
							25.74766483400009
						],
						[
							-80.17903470199991,
							25.74767623200006
						],
						[
							-80.1786547019999,
							25.747724232000053
						],
						[
							-80.17857505799992,
							25.747730714000056
						],
						[
							-80.17814005699995,
							25.747746715000062
						],
						[
							-80.17801714199993,
							25.747742822000077
						],
						[
							-80.17754738699995,
							25.747695650000086
						],
						[
							-80.1771646439999,
							25.747664326000063
						],
						[
							-80.17708183499991,
							25.747653660000086
						],
						[
							-80.17696372099994,
							25.74762450700007
						],
						[
							-80.1769686589999,
							25.747666835000075
						],
						[
							-80.1769823219999,
							25.747823000000043
						],
						[
							-80.1769686589999,
							25.74797916600005
						],
						[
							-80.17692808599992,
							25.74813058700005
						],
						[
							-80.17686183599994,
							25.748272661000044
						],
						[
							-80.17684615099995,
							25.748298795000043
						],
						[
							-80.17674515099992,
							25.74846079400004
						],
						[
							-80.17670646999994,
							25.74851784300006
						],
						[
							-80.17666353399994,
							25.748571763000086
						],
						[
							-80.17661659499993,
							25.748622235000088
						],
						[
							-80.17656592799995,
							25.748668965000036
						],
						[
							-80.17651183099991,
							25.748711677000074
						],
						[
							-80.17645462099995,
							25.748750120000068
						],
						[
							-80.17639463599994,
							25.74878406900007
						],
						[
							-80.1760286359999,
							25.74897307000009
						],
						[
							-80.17595811899992,
							25.749005706000048
						],
						[
							-80.17588504799994,
							25.74903213400006
						],
						[
							-80.17580996899994,
							25.749052155000072
						],
						[
							-80.17573344099992,
							25.749065621000057
						],
						[
							-80.1756560369999,
							25.74907243100006
						],
						[
							-80.17557833399991,
							25.74907253300006
						],
						[
							-80.1755009119999,
							25.74906592800005
						],
						[
							-80.17531491099993,
							25.749041928000054
						],
						[
							-80.17524548599994,
							25.749030190000042
						],
						[
							-80.17517719099993,
							25.74901305700007
						],
						[
							-80.1751104459999,
							25.74899063400005
						],
						[
							-80.17504565999992,
							25.748963058000072
						],
						[
							-80.1749832289999,
							25.74893049800005
						],
						[
							-80.17483678399992,
							25.748846667000066
						],
						[
							-80.17470692699993,
							25.748755921000054
						],
						[
							-80.17467249799995,
							25.748725500000035
						],
						[
							-80.1743978909999,
							25.74847005500004
						],
						[
							-80.17404928299993,
							25.748140610000064
						],
						[
							-80.17399698499992,
							25.748086883000042
						],
						[
							-80.17353689999993,
							25.747573010000053
						],
						[
							-80.17298110999991,
							25.747025904000058
						],
						[
							-80.17293387699993,
							25.74697757300004
						],
						[
							-80.1728911319999,
							25.74692523100009
						],
						[
							-80.17285321399993,
							25.74686929300009
						],
						[
							-80.17282042499994,
							25.746810203000052
						],
						[
							-80.1726901749999,
							25.746745556000064
						],
						[
							-80.17264033899994,
							25.74671883600007
						],
						[
							-80.17250946599995,
							25.746626840000093
						],
						[
							-80.16774300499992,
							25.74256876000004
						],
						[
							-80.16771391499992,
							25.74254288700007
						],
						[
							-80.16703341999994,
							25.74191072900004
						],
						[
							-80.16582137899991,
							25.741017943000088
						],
						[
							-80.16518928499994,
							25.740637550000088
						],
						[
							-80.16507492699992,
							25.740555920000077
						],
						[
							-80.16505669199995,
							25.740540199000066
						],
						[
							-80.16443645099991,
							25.739996130000065
						],
						[
							-80.16436499999992,
							25.739975661000074
						],
						[
							-80.1642954809999,
							25.739949365000086
						],
						[
							-80.16422836899994,
							25.739917422000076
						],
						[
							-80.16416412199993,
							25.739880050000068
						],
						[
							-80.16410317899994,
							25.739837503000047
						],
						[
							-80.1640459539999,
							25.73979007300005
						],
						[
							-80.16387356699994,
							25.73963467100009
						],
						[
							-80.16353386399993,
							25.739771776000055
						],
						[
							-80.16331062299992,
							25.739895910000087
						],
						[
							-80.16304508499991,
							25.74026303000005
						],
						[
							-80.16289338999991,
							25.740639498000068
						],
						[
							-80.1629272209999,
							25.741009144000092
						],
						[
							-80.1630561099999,
							25.741284265000047
						],
						[
							-80.16795699099993,
							25.745608342000082
						],
						[
							-80.16857610699992,
							25.74613542600008
						],
						[
							-80.1735953189999,
							25.750594698000043
						],
						[
							-80.17368692099991,
							25.750688927000056
						],
						[
							-80.17377683599994,
							25.750817339000037
						],
						[
							-80.17384308599992,
							25.75095941400008
						],
						[
							-80.1738836589999,
							25.751110834000087
						],
						[
							-80.1738973219999,
							25.751267000000045
						],
						[
							-80.1738836589999,
							25.751423166000052
						],
						[
							-80.17384308599992,
							25.75157458600006
						],
						[
							-80.17377683599994,
							25.751716661000046
						],
						[
							-80.17372048399994,
							25.751802534000035
						],
						[
							-80.1734454839999,
							25.752173534000065
						],
						[
							-80.17341191999992,
							25.752216073000056
						],
						[
							-80.17330107299995,
							25.752326921000076
						],
						[
							-80.17317266099991,
							25.752416836000066
						],
						[
							-80.17303058599992,
							25.75248308600004
						],
						[
							-80.17287916499993,
							25.75252365900008
						],
						[
							-80.1727229999999,
							25.75253732200008
						],
						[
							-80.17256683399995,
							25.75252365900008
						],
						[
							-80.17241541399994,
							25.75248308600004
						],
						[
							-80.1722733389999,
							25.752416836000066
						],
						[
							-80.17221913799995,
							25.75238291800008
						],
						[
							-80.1718081379999,
							25.752104918000043
						],
						[
							-80.17176423399991,
							25.752073255000084
						],
						[
							-80.1705962339999,
							25.751176255000075
						],
						[
							-80.1705108829999,
							25.751101704000064
						],
						[
							-80.16988149999992,
							25.750477826000065
						],
						[
							-80.16896558799993,
							25.749845580000056
						],
						[
							-80.16848305899994,
							25.749598431000038
						],
						[
							-80.16805661899991,
							25.74956686900009
						],
						[
							-80.16796683399993,
							25.749555659000066
						],
						[
							-80.1678154139999,
							25.749515086000088
						],
						[
							-80.16767333899992,
							25.749448836000056
						],
						[
							-80.16754492699994,
							25.749358921000066
						],
						[
							-80.1674455129999,
							25.749261432000083
						],
						[
							-80.16728009499991,
							25.749071945000082
						],
						[
							-80.16721694799992,
							25.749061530000063
						],
						[
							-80.16706303599994,
							25.749021035000055
						],
						[
							-80.16671772399991,
							25.748896561000038
						],
						[
							-80.16664792899991,
							25.748867915000062
						],
						[
							-80.16658078099994,
							25.748833519000073
						],
						[
							-80.16651675199996,
							25.748793617000047
						],
						[
							-80.1664562919999,
							25.748748487000057
						],
						[
							-80.1663998279999,
							25.748698449000074
						],
						[
							-80.16634775699993,
							25.74864385500007
						],
						[
							-80.16630044499993,
							25.748585088000084
						],
						[
							-80.16625822599991,
							25.748522562000062
						],
						[
							-80.16601952199994,
							25.74813492900006
						],
						[
							-80.16589591199994,
							25.74805332200009
						],
						[
							-80.1654260329999,
							25.74805332200009
						],
						[
							-80.16451405799997,
							25.748083819000044
						],
						[
							-80.1644358229999,
							25.74808303000009
						],
						[
							-80.16435795299992,
							25.74807544500004
						],
						[
							-80.16428103699991,
							25.74806112000005
						],
						[
							-80.16420565699991,
							25.748040164000088
						],
						[
							-80.16413238399991,
							25.748012735000092
						],
						[
							-80.16406177199991,
							25.747979042000054
						],
						[
							-80.16334144699995,
							25.747596013000077
						],
						[
							-80.16135666299994,
							25.74675938200005
						],
						[
							-80.1604698989999,
							25.746630322000044
						],
						[
							-80.16010723399995,
							25.746630322000044
						],
						[
							-80.16006307299995,
							25.74665380400006
						],
						[
							-80.1597194659999,
							25.747889864000058
						],
						[
							-80.15969581999991,
							25.747962743000073
						],
						[
							-80.15966605499995,
							25.748033345000067
						],
						[
							-80.15963038899991,
							25.748101156000075
						],
						[
							-80.15958908099992,
							25.74816568600005
						],
						[
							-80.15954242899994,
							25.748226465000073
						],
						[
							-80.15949077399995,
							25.74828305300008
						],
						[
							-80.15943448899992,
							25.74833503900004
						],
						[
							-80.1588487809999,
							25.748831480000035
						],
						[
							-80.15871866099992,
							25.748922836000077
						],
						[
							-80.15868733799994,
							25.748940099000038
						],
						[
							-80.15786333799991,
							25.74937309900008
						],
						[
							-80.15779908299993,
							25.749403683000082
						],
						[
							-80.1577326119999,
							25.74942909100008
						],
						[
							-80.15766433899995,
							25.749449164000055
						],
						[
							-80.15759469299991,
							25.749463776000084
						],
						[
							-80.15752410999994,
							25.749472836000052
						],
						[
							-80.15745303199992,
							25.74947628600006
						],
						[
							-80.15738190299993,
							25.749474106000036
						],
						[
							-80.15731116899991,
							25.74946630900007
						],
						[
							-80.15729522499993,
							25.749468334000085
						],
						[
							-80.15726966199992,
							25.749532248000037
						],
						[
							-80.15723925599991,
							25.749594005000063
						],
						[
							-80.15720418699993,
							25.749653239000057
						],
						[
							-80.15716466399994,
							25.749709598000038
						],
						[
							-80.1571209199999,
							25.74976274800008
						],
						[
							-80.1569839199999,
							25.74991674800009
						],
						[
							-80.15693988999993,
							25.749963862000072
						],
						[
							-80.15689231499994,
							25.75000739300009
						],
						[
							-80.15684148499992,
							25.750047075000055
						],
						[
							-80.15678771099994,
							25.750082666000083
						],
						[
							-80.15673132199993,
							25.750113949000085
						],
						[
							-80.15673132199993,
							25.750185000000045
						],
						[
							-80.15673132199993,
							25.750512508000046
						],
						[
							-80.15680990999994,
							25.75084288000005
						],
						[
							-80.15682384299993,
							25.750914110000053
						],
						[
							-80.15683198699992,
							25.75098623100007
						],
						[
							-80.1568342889999,
							25.751058774000057
						],
						[
							-80.15683073299994,
							25.751131266000073
						],
						[
							-80.15682134399992,
							25.75120323500005
						],
						[
							-80.15680618099992,
							25.751274213000045
						],
						[
							-80.15673493999992,
							25.75155225900005
						],
						[
							-80.1567614139999,
							25.75153991400009
						],
						[
							-80.15679607999994,
							25.75152809000008
						],
						[
							-80.15738007999994,
							25.751342090000037
						],
						[
							-80.15745271599991,
							25.751322264000066
						],
						[
							-80.15752675699991,
							25.751308583000082
						],
						[
							-80.15760168199995,
							25.751301143000035
						],
						[
							-80.15767696699993,
							25.75129999700005
						],
						[
							-80.15775208399992,
							25.75130515300009
						],
						[
							-80.15782650699992,
							25.751316574000043
						],
						[
							-80.15789971299996,
							25.75133418000007
						],
						[
							-80.15855171299995,
							25.751520181000046
						],
						[
							-80.15861258599995,
							25.75153991400009
						],
						[
							-80.15873872899994,
							25.75159718100008
						],
						[
							-80.1593896949999,
							25.751955673000055
						],
						[
							-80.1594520399999,
							25.751994238000066
						],
						[
							-80.15951103499992,
							25.75203775600005
						],
						[
							-80.15956628599992,
							25.75208593700006
						],
						[
							-80.1596174259999,
							25.75213846200006
						],
						[
							-80.15966411499994,
							25.752194980000073
						],
						[
							-80.16042911599993,
							25.75320197900004
						],
						[
							-80.16048475499991,
							25.753284292000046
						],
						[
							-80.16096929499993,
							25.754094315000092
						],
						[
							-80.1610390859999,
							25.75424241400009
						],
						[
							-80.1610798669999,
							25.754395026000054
						],
						[
							-80.16112207599991,
							25.754638217000036
						],
						[
							-80.16113532199995,
							25.754792000000066
						],
						[
							-80.16112165899995,
							25.754948165000087
						],
						[
							-80.16108108599991,
							25.755099586000085
						],
						[
							-80.16101483499995,
							25.75524166100007
						],
						[
							-80.1609249199999,
							25.75537007300005
						],
						[
							-80.16087191899993,
							25.75542791400005
						],
						[
							-80.1607659199999,
							25.75553391400007
						],
						[
							-80.16071200599993,
							25.75558360100007
						],
						[
							-80.16065422499992,
							25.755628732000048
						],
						[
							-80.16059295899993,
							25.755669006000062
						],
						[
							-80.16052861599991,
							25.755704155000046
						],
						[
							-80.16046162399994,
							25.755733946000078
						],
						[
							-80.16039242699992,
							25.755758182000083
						],
						[
							-80.16021542699991,
							25.755812181000067
						],
						[
							-80.16014067399993,
							25.75583152200005
						],
						[
							-80.16006453599994,
							25.755844379000052
						],
						[
							-80.15998757699992,
							25.755850657000053
						],
						[
							-80.15991036299994,
							25.755850311000074
						],
						[
							-80.15983346299993,
							25.75584334200005
						],
						[
							-80.15975744399992,
							25.75582980300004
						],
						[
							-80.15968286599991,
							25.755809792000036
						],
						[
							-80.15834768499991,
							25.755385309000076
						],
						[
							-80.15823529099993,
							25.755352207000044
						],
						[
							-80.15817986199994,
							25.75533562000004
						],
						[
							-80.15812628099991,
							25.75531379100005
						],
						[
							-80.1580750409999,
							25.75528692100005
						],
						[
							-80.1580266169999,
							25.755255258000094
						],
						[
							-80.15662465699995,
							25.754932263000057
						],
						[
							-80.15651941399994,
							25.754901086000075
						],
						[
							-80.1563773389999,
							25.754834836000043
						],
						[
							-80.15624892699992,
							25.754744921000054
						],
						[
							-80.1561380789999,
							25.75463407300009
						],
						[
							-80.15604816399991,
							25.754505661000053
						],
						[
							-80.1560014719999,
							25.754412769000055
						],
						[
							-80.15577847199995,
							25.75389676900005
						],
						[
							-80.15574994999992,
							25.75382174200007
						],
						[
							-80.1557282309999,
							25.75374447200005
						],
						[
							-80.15571348799995,
							25.753665572000045
						],
						[
							-80.1557058379999,
							25.75358567300009
						],
						[
							-80.15570534299991,
							25.75350540900007
						],
						[
							-80.15571200599993,
							25.753425421000088
						],
						[
							-80.15571751999994,
							25.75338250100009
						],
						[
							-80.15552782299994,
							25.753516869000066
						],
						[
							-80.15546284899995,
							25.753558817000055
						],
						[
							-80.15539451099994,
							25.753595028000063
						],
						[
							-80.15532331499992,
							25.753625233000037
						],
						[
							-80.15524978699995,
							25.75364920900006
						],
						[
							-80.1551744699999,
							25.75366678000006
						],
						[
							-80.15452147099995,
							25.75378978000009
						],
						[
							-80.15441295999995,
							25.753803452000056
						],
						[
							-80.15406459299993,
							25.753825951000067
						],
						[
							-80.15395650699992,
							25.753866113000072
						],
						[
							-80.1539191089999,
							25.753934635000064
						],
						[
							-80.15387564799994,
							25.75399948100005
						],
						[
							-80.15382648199994,
							25.754060116000062
						],
						[
							-80.1534801599999,
							25.754450148000046
						],
						[
							-80.15304351399993,
							25.75523616600009
						],
						[
							-80.1529499209999,
							25.75537107300005
						],
						[
							-80.15286293799994,
							25.755461170000046
						],
						[
							-80.15255719099991,
							25.755736609000053
						],
						[
							-80.15223757599995,
							25.756096564000075
						],
						[
							-80.15194042899992,
							25.756605085000047
						],
						[
							-80.15144137899995,
							25.757467451000082
						],
						[
							-80.15138424499992,
							25.75755420200005
						],
						[
							-80.15106024499994,
							25.75798920200009
						],
						[
							-80.15101708299994,
							25.758042749000083
						],
						[
							-80.15096995399995,
							25.758092841000064
						],
						[
							-80.15091913599991,
							25.75813918500006
						],
						[
							-80.1508649239999,
							25.758181509000053
						],
						[
							-80.15052092399992,
							25.758429509000052
						],
						[
							-80.15044466099994,
							25.758478835000062
						],
						[
							-80.15030987599994,
							25.758542397000042
						],
						[
							-80.1498942309999,
							25.75869774100005
						],
						[
							-80.14982363299993,
							25.758720525000058
						],
						[
							-80.1497857299999,
							25.758729386000084
						],
						[
							-80.1456489119999,
							25.75574762000008
						],
						[
							-80.14564082899994,
							25.755726391000056
						],
						[
							-80.1454348279999,
							25.755108392000068
						],
						[
							-80.14540233999992,
							25.754980166000053
						],
						[
							-80.14539292899991,
							25.75491134300006
						],
						[
							-80.14528392999995,
							25.753794343000042
						],
						[
							-80.14528074899994,
							25.753663132000042
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami",
				"Name": "Virginia Key",
				"RegionID": "403394"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.22156031899993,
					25.732932708000078,
					-80.21593205199991,
					25.73805532200004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.21924837499995,
							25.732935376000057
						],
						[
							-80.21932524999994,
							25.732932708000078
						],
						[
							-80.21940207299991,
							25.73293662100008
						],
						[
							-80.21947827899993,
							25.73294708600008
						],
						[
							-80.21965696799992,
							25.732980290000057
						],
						[
							-80.21986432999995,
							25.73300710300009
						],
						[
							-80.2199324259999,
							25.733018582000057
						],
						[
							-80.21999944099991,
							25.733035253000086
						],
						[
							-80.22006497899991,
							25.73305701600009
						],
						[
							-80.22012865499994,
							25.733083744000055
						],
						[
							-80.22019009099995,
							25.73311527900006
						],
						[
							-80.2205923759999,
							25.73334172200009
						],
						[
							-80.22065629299993,
							25.73338179500007
						],
						[
							-80.22071662599991,
							25.733427086000063
						],
						[
							-80.2207729509999,
							25.73347727500004
						],
						[
							-80.22082486999994,
							25.733532008000054
						],
						[
							-80.22087201799991,
							25.73359090100007
						],
						[
							-80.22091406299995,
							25.733653539000045
						],
						[
							-80.22104967899992,
							25.733875125000054
						],
						[
							-80.22113082899995,
							25.733936739000058
						],
						[
							-80.22119180599992,
							25.733987425000066
						],
						[
							-80.22124808099994,
							25.734043286000087
						],
						[
							-80.22129921699991,
							25.73410388600007
						],
						[
							-80.22134481699993,
							25.73416875500004
						],
						[
							-80.2213845249999,
							25.734237388000054
						],
						[
							-80.22145852499995,
							25.73437938700005
						],
						[
							-80.22148935799993,
							25.73444485200008
						],
						[
							-80.2215148279999,
							25.734512584000072
						],
						[
							-80.2215347689999,
							25.734582145000047
						],
						[
							-80.22154905399992,
							25.73465308400006
						],
						[
							-80.22155758899993,
							25.73472494100008
						],
						[
							-80.22156031899993,
							25.734797252000078
						],
						[
							-80.22155722699995,
							25.734869549000052
						],
						[
							-80.22154833199994,
							25.734941362000086
						],
						[
							-80.2215314959999,
							25.73504326400007
						],
						[
							-80.2214900859999,
							25.73519958600008
						],
						[
							-80.2214389479999,
							25.735314406000043
						],
						[
							-80.22124794799993,
							25.735673406000046
						],
						[
							-80.22121558799995,
							25.735729293000077
						],
						[
							-80.2211792999999,
							25.735782714000038
						],
						[
							-80.2211392719999,
							25.735833393000064
						],
						[
							-80.22109571099992,
							25.735881069000072
						],
						[
							-80.22104884099991,
							25.73592549600005
						],
						[
							-80.22062721499992,
							25.73629733000007
						],
						[
							-80.22005187799994,
							25.736804721000055
						],
						[
							-80.21988489699993,
							25.73695198200005
						],
						[
							-80.21919249799993,
							25.737611970000046
						],
						[
							-80.21915007299992,
							25.73764992000008
						],
						[
							-80.21902430899992,
							25.737738301000036
						],
						[
							-80.21879098499994,
							25.737874068000053
						],
						[
							-80.21864758599992,
							25.737941086000035
						],
						[
							-80.21850827399993,
							25.73797943800008
						],
						[
							-80.21818721999995,
							25.738040549000065
						],
						[
							-80.2180249999999,
							25.73805532200004
						],
						[
							-80.21774299999993,
							25.73805532200004
						],
						[
							-80.2175868349999,
							25.73804165900009
						],
						[
							-80.21755404999993,
							25.738035248000074
						],
						[
							-80.21723776999994,
							25.737966962000087
						],
						[
							-80.21720537599992,
							25.737959035000074
						],
						[
							-80.21713571399994,
							25.737942822000036
						],
						[
							-80.21706783699995,
							25.737920279000036
						],
						[
							-80.21700231699994,
							25.737891596000054
						],
						[
							-80.2169397099999,
							25.73785701500009
						],
						[
							-80.21688054399993,
							25.737816830000043
						],
						[
							-80.2168149119999,
							25.73777137600007
						],
						[
							-80.21669736299992,
							25.73769151600004
						],
						[
							-80.21657982799991,
							25.737593640000057
						],
						[
							-80.21632282799993,
							25.737339640000073
						],
						[
							-80.21627082099991,
							25.73728367700005
						],
						[
							-80.21622375099992,
							25.737223503000052
						],
						[
							-80.21618195899993,
							25.737159551000047
						],
						[
							-80.21614574499995,
							25.737092283000038
						],
						[
							-80.2161153699999,
							25.737022184000068
						],
						[
							-80.21604936999995,
							25.73685018300006
						],
						[
							-80.21602283399994,
							25.73676994400006
						],
						[
							-80.2159728339999,
							25.736590945000046
						],
						[
							-80.21595334099995,
							25.73650516600009
						],
						[
							-80.21594005299994,
							25.73637496400005
						],
						[
							-80.21593205199991,
							25.736097964000066
						],
						[
							-80.21593291799991,
							25.736024774000043
						],
						[
							-80.21593973299991,
							25.735951898000053
						],
						[
							-80.2159524519999,
							25.73587981600008
						],
						[
							-80.21600145299993,
							25.735655816000076
						],
						[
							-80.21601752999993,
							25.735593194000046
						],
						[
							-80.2160380649999,
							25.73553188900007
						],
						[
							-80.2160629519999,
							25.73547221800004
						],
						[
							-80.21609206099993,
							25.735414489000053
						],
						[
							-80.21612524199993,
							25.735359001000067
						],
						[
							-80.21621724199991,
							25.735217001000084
						],
						[
							-80.21623777899993,
							25.73518667500008
						],
						[
							-80.21641177899994,
							25.734940674000086
						],
						[
							-80.21645707899995,
							25.73488192700006
						],
						[
							-80.21653521799993,
							25.734799904000056
						],
						[
							-80.2174722179999,
							25.733932905000074
						],
						[
							-80.21749688099993,
							25.733910911000066
						],
						[
							-80.21769356699991,
							25.73374189900005
						],
						[
							-80.21818659699994,
							25.73331249200004
						],
						[
							-80.21832133899994,
							25.733217164000052
						],
						[
							-80.21846184599993,
							25.733151486000054
						],
						[
							-80.21868584599991,
							25.73306948600009
						],
						[
							-80.21877371099993,
							25.733042328000067
						],
						[
							-80.2190967109999,
							25.732960329000036
						],
						[
							-80.21917200899992,
							25.732944605000057
						],
						[
							-80.21924837499995,
							25.732935376000057
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami",
				"Name": "Fair Isle",
				"RegionID": "403395"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.18028132199993,
					25.788214678000088,
					-80.17111244799992,
					25.792183539000064
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.17111244799992,
							25.788873719000037
						],
						[
							-80.17119482699991,
							25.78877169900005
						],
						[
							-80.17121899299991,
							25.788746505000063
						],
						[
							-80.17130592699993,
							25.788661079000065
						],
						[
							-80.17143433899992,
							25.78857116400008
						],
						[
							-80.1715764139999,
							25.788504914000043
						],
						[
							-80.17172783399991,
							25.788464341000065
						],
						[
							-80.17181143899995,
							25.788455639000063
						],
						[
							-80.17188388099994,
							25.788449210000067
						],
						[
							-80.17305450299995,
							25.78835274100004
						],
						[
							-80.1742357839999,
							25.78822027900009
						],
						[
							-80.17433599999993,
							25.788214678000088
						],
						[
							-80.17439668399993,
							25.788216728000066
						],
						[
							-80.17460482099995,
							25.78823080600006
						],
						[
							-80.17471995799991,
							25.788238884000066
						],
						[
							-80.17479170899992,
							25.788246824000055
						],
						[
							-80.17486259299994,
							25.788260493000056
						],
						[
							-80.17493215099995,
							25.788279804000073
						],
						[
							-80.17499993599995,
							25.788304631000074
						],
						[
							-80.17507993599992,
							25.788337631000047
						],
						[
							-80.17518666099994,
							25.788390164000077
						],
						[
							-80.17531507299992,
							25.788480079000067
						],
						[
							-80.17542592099994,
							25.788590927000087
						],
						[
							-80.17551583599993,
							25.788719339000068
						],
						[
							-80.17556011199991,
							25.788814289000072
						],
						[
							-80.17574771199992,
							25.78871870000006
						],
						[
							-80.17581750499994,
							25.788686812000037
						],
						[
							-80.17588976299993,
							25.78866099000004
						],
						[
							-80.17596395999993,
							25.788641421000083
						],
						[
							-80.17603955399994,
							25.788628248000066
						],
						[
							-80.17611599599991,
							25.788621568000057
						],
						[
							-80.17619272999991,
							25.788621428000056
						],
						[
							-80.17669859999995,
							25.788642106000054
						],
						[
							-80.1772842009999,
							25.78874932100007
						],
						[
							-80.1781583739999,
							25.78868833300004
						],
						[
							-80.17970110399995,
							25.788714522000078
						],
						[
							-80.1797496609999,
							25.788737164000057
						],
						[
							-80.17987807299994,
							25.788827079000043
						],
						[
							-80.1799889209999,
							25.788937927000063
						],
						[
							-80.18007883599995,
							25.789066339000044
						],
						[
							-80.18014508599992,
							25.78920841300004
						],
						[
							-80.18018423399991,
							25.789351956000075
						],
						[
							-80.18026694699995,
							25.78979789600004
						],
						[
							-80.18028132199993,
							25.78995800000007
						],
						[
							-80.18026981299994,
							25.790101417000074
						],
						[
							-80.18023295699993,
							25.790329571000086
						],
						[
							-80.18023830999994,
							25.790355910000073
						],
						[
							-80.18024265899993,
							25.79037883400008
						],
						[
							-80.18025632199993,
							25.79053500000009
						],
						[
							-80.18024265899993,
							25.790691165000055
						],
						[
							-80.18020208599995,
							25.790842586000053
						],
						[
							-80.18016285199991,
							25.79093422700004
						],
						[
							-80.18005900399993,
							25.791143847000058
						],
						[
							-80.17996197999993,
							25.791350382000076
						],
						[
							-80.17992683599995,
							25.791417661000082
						],
						[
							-80.17983692099995,
							25.791546073000063
						],
						[
							-80.17972607299993,
							25.791656921000083
						],
						[
							-80.17959766099995,
							25.791746836000076
						],
						[
							-80.1794555859999,
							25.791813086000047
						],
						[
							-80.17930416599995,
							25.791853659000083
						],
						[
							-80.1791846989999,
							25.79186657300005
						],
						[
							-80.17593291599991,
							25.79199937800007
						],
						[
							-80.17590840499992,
							25.792004718000044
						],
						[
							-80.17575730699991,
							25.79202441800004
						],
						[
							-80.17221330699994,
							25.792183418000036
						],
						[
							-80.17213547599994,
							25.792183539000064
						],
						[
							-80.17205792699991,
							25.79217693000004
						],
						[
							-80.17198123899995,
							25.79216364000007
						],
						[
							-80.17190598799993,
							25.792143770000052
						],
						[
							-80.17183273599994,
							25.792117467000082
						],
						[
							-80.17144373699995,
							25.791958467000086
						],
						[
							-80.17133433899994,
							25.79190483600007
						],
						[
							-80.17120699999992,
							25.79181942000008
						],
						[
							-80.1711853189999,
							25.791351511000077
						],
						[
							-80.1712666379999,
							25.790965248000077
						],
						[
							-80.17134795599992,
							25.790599315000065
						],
						[
							-80.17140894499994,
							25.790314701000057
						],
						[
							-80.17122597899993,
							25.78984712000005
						],
						[
							-80.17116498999991,
							25.789440528000057
						],
						[
							-80.17111244799992,
							25.788873719000037
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami",
				"Name": "Biscayne Island",
				"RegionID": "403396"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.12051023899994,
					26.897884401000056,
					-80.11218867699995,
					26.905517489000033
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.11218867699995,
							26.905517489000033
						],
						[
							-80.11275741699995,
							26.897884401000056
						],
						[
							-80.11494257499999,
							26.89803407000005
						],
						[
							-80.11548138099994,
							26.89824360500006
						],
						[
							-80.11578071799994,
							26.89857287600006
						],
						[
							-80.11838494799997,
							26.899470886000078
						],
						[
							-80.11904348899998,
							26.900129427000028
						],
						[
							-80.11961222899998,
							26.900668233000033
						],
						[
							-80.12036057099994,
							26.901296840000043
						],
						[
							-80.12048030499994,
							26.901955381000054
						],
						[
							-80.12051023899994,
							26.903242529000067
						],
						[
							-80.12045037199994,
							26.904230341000073
						],
						[
							-80.12045037199994,
							26.905008616000035
						],
						[
							-80.12045037199994,
							26.905517489000033
						],
						[
							-80.12000136699999,
							26.905517489000033
						],
						[
							-80.11218867699995,
							26.905517489000033
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Jupiter",
				"Name": "Mallory Creek",
				"RegionID": "761981"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.12434174999999,
					26.91111508700004,
					-80.11069199299999,
					26.916598088000057
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.11072192699999,
							26.914677194000035
						],
						[
							-80.11070981999995,
							26.91323648200006
						],
						[
							-80.11070415499995,
							26.91256229100003
						],
						[
							-80.11069199299999,
							26.91111508700004
						],
						[
							-80.12134838199995,
							26.911833495000053
						],
						[
							-80.12146811699995,
							26.913390046000078
						],
						[
							-80.12419208099999,
							26.913390046000078
						],
						[
							-80.12434174999999,
							26.915904475000048
						],
						[
							-80.12377300999998,
							26.91545547000004
						],
						[
							-80.12272533099997,
							26.915335735000042
						],
						[
							-80.12170758599996,
							26.914647260000038
						],
						[
							-80.12139493799998,
							26.914534502000038
						],
						[
							-80.11988163199999,
							26.913988720000077
						],
						[
							-80.11914410999998,
							26.914123932000052
						],
						[
							-80.11808561099997,
							26.91431799000003
						],
						[
							-80.11782157599998,
							26.914478012000075
						],
						[
							-80.11709779999995,
							26.91491666400003
						],
						[
							-80.11605012099994,
							26.915605138000046
						],
						[
							-80.11500873499995,
							26.916598088000057
						],
						[
							-80.11266761599997,
							26.915754806000052
						],
						[
							-80.11072192699999,
							26.914677194000035
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Jupiter",
				"Name": "Hamptons",
				"RegionID": "761983"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.79121442,
					24.549138533000075,
					-81.78183864499994,
					24.558061641000055
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.78624403099997,
							24.55557918200003
						],
						[
							-81.78183864499994,
							24.54978338500007
						],
						[
							-81.78287330199998,
							24.549138533000075
						],
						[
							-81.78415983599997,
							24.55083093500008
						],
						[
							-81.78419813199997,
							24.55080732600004
						],
						[
							-81.78623368899997,
							24.549563576000025
						],
						[
							-81.78906258499995,
							24.55331350700004
						],
						[
							-81.79121442,
							24.55616412100005
						],
						[
							-81.78813094899994,
							24.558061641000055
						],
						[
							-81.78624403099997,
							24.55557918200003
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Monroe",
				"City": "Key West",
				"Name": "White Street Gallery District",
				"RegionID": "762131"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.210089,
					25.885625,
					-80.202559,
					25.905761
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.207397,
							25.902711
						],
						[
							-80.207362,
							25.902099
						],
						[
							-80.205334,
							25.902187
						],
						[
							-80.203368,
							25.902276
						],
						[
							-80.203355,
							25.901974
						],
						[
							-80.203336822,
							25.90163976100007
						],
						[
							-80.20300462499995,
							25.894860791000042
						],
						[
							-80.202982,
							25.894075
						],
						[
							-80.202933,
							25.893164
						],
						[
							-80.202907,
							25.892702
						],
						[
							-80.202876,
							25.892236
						],
						[
							-80.202559,
							25.885913
						],
						[
							-80.20460105299998,
							25.88582219500006
						],
						[
							-80.20752671599996,
							25.88569343200004
						],
						[
							-80.208652,
							25.885648
						],
						[
							-80.209075,
							25.885625
						],
						[
							-80.210089,
							25.905638000000003
						],
						[
							-80.207545,
							25.905761
						],
						[
							-80.207397,
							25.902711
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "North Miami",
				"Name": "Alhambra Heights",
				"RegionID": "762147"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.46736911799997,
					27.05585,
					-82.43030182899997,
					27.113093122000066
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.46151309899994,
							27.113089745000025
						],
						[
							-82.46115843399997,
							27.11297227600005
						],
						[
							-82.46108976899995,
							27.112886643000024
						],
						[
							-82.460961,
							27.112866
						],
						[
							-82.460803,
							27.112744
						],
						[
							-82.46077390699998,
							27.112614418000078
						],
						[
							-82.460617,
							27.11234
						],
						[
							-82.46064173199994,
							27.11202569200003
						],
						[
							-82.46062722199997,
							27.111961063000024
						],
						[
							-82.460596,
							27.111822
						],
						[
							-82.46062100000002,
							27.111573
						],
						[
							-82.460633,
							27.111454
						],
						[
							-82.460645,
							27.111302
						],
						[
							-82.460608,
							27.111086
						],
						[
							-82.46061026999996,
							27.111070113000043
						],
						[
							-82.460615,
							27.111037
						],
						[
							-82.46063677999996,
							27.111025321000056
						],
						[
							-82.460631,
							27.110995
						],
						[
							-82.46069006199997,
							27.110995270000046
						],
						[
							-82.46084973999996,
							27.110995999000068
						],
						[
							-82.46109860599995,
							27.110989990000064
						],
						[
							-82.461181,
							27.110988
						],
						[
							-82.46186296599996,
							27.111000623000052
						],
						[
							-82.46327188499998,
							27.111007054000027
						],
						[
							-82.46346132299999,
							27.11100791900003
						],
						[
							-82.46346996499994,
							27.11099107000007
						],
						[
							-82.46343347399994,
							27.110922694000067
						],
						[
							-82.463377,
							27.11084
						],
						[
							-82.46318611899994,
							27.110837896000078
						],
						[
							-82.46129,
							27.110817
						],
						[
							-82.461035,
							27.110814
						],
						[
							-82.46056,
							27.110846
						],
						[
							-82.460497,
							27.11084
						],
						[
							-82.460456,
							27.110803
						],
						[
							-82.46034,
							27.110576
						],
						[
							-82.460231,
							27.11037
						],
						[
							-82.460256,
							27.110318
						],
						[
							-82.460366,
							27.110293
						],
						[
							-82.46170356,
							27.110306448000074
						],
						[
							-82.46295399099995,
							27.11030779500004
						],
						[
							-82.46312422099999,
							27.110307979000027
						],
						[
							-82.463144,
							27.110308
						],
						[
							-82.46305908699999,
							27.11017089300003
						],
						[
							-82.46286826599999,
							27.11016918100006
						],
						[
							-82.460953,
							27.110152
						],
						[
							-82.46093553899999,
							27.110151835000067
						],
						[
							-82.460283,
							27.110158
						],
						[
							-82.46028328499995,
							27.11013779500007
						],
						[
							-82.460263,
							27.110133
						],
						[
							-82.460256,
							27.110084
						],
						[
							-82.46028,
							27.109828
						],
						[
							-82.46028775599996,
							27.10982127700004
						],
						[
							-82.460288,
							27.109804
						],
						[
							-82.46065,
							27.109449
						],
						[
							-82.46246182499993,
							27.109428236000042
						],
						[
							-82.46265052099994,
							27.109426074000055
						],
						[
							-82.462657,
							27.109426
						],
						[
							-82.46263649299993,
							27.109383163000075
						],
						[
							-82.46263,
							27.109373
						],
						[
							-82.462549,
							27.109241
						],
						[
							-82.46236286599998,
							27.109247107000044
						],
						[
							-82.461848,
							27.109264
						],
						[
							-82.461797,
							27.10927
						],
						[
							-82.46129816599995,
							27.10925602100008
						],
						[
							-82.46101800000001,
							27.10926
						],
						[
							-82.46102363899996,
							27.109239890000026
						],
						[
							-82.461016,
							27.109239
						],
						[
							-82.461016,
							27.109012000000003
						],
						[
							-82.461071,
							27.108913
						],
						[
							-82.46114700000001,
							27.108821
						],
						[
							-82.461251,
							27.108747
						],
						[
							-82.461389,
							27.108667
						],
						[
							-82.46152593599999,
							27.108591449000073
						],
						[
							-82.46153551699996,
							27.108585508000033
						],
						[
							-82.461595,
							27.108527
						],
						[
							-82.461686,
							27.108501
						],
						[
							-82.46171078699996,
							27.10846583700004
						],
						[
							-82.461729,
							27.10844
						],
						[
							-82.461717,
							27.108267
						],
						[
							-82.46168,
							27.108202
						],
						[
							-82.461582,
							27.108145000000004
						],
						[
							-82.46149011799997,
							27.108171577000064
						],
						[
							-82.461461,
							27.10818
						],
						[
							-82.461266,
							27.108267
						],
						[
							-82.460962,
							27.108364
						],
						[
							-82.460876,
							27.108354
						],
						[
							-82.460828,
							27.108267
						],
						[
							-82.460803,
							27.108093
						],
						[
							-82.460791,
							27.107985
						],
						[
							-82.460925,
							27.107953
						],
						[
							-82.46101000000002,
							27.107974
						],
						[
							-82.46103366099999,
							27.107974
						],
						[
							-82.46114245999996,
							27.107963830000074
						],
						[
							-82.461193,
							27.107953
						],
						[
							-82.461266,
							27.107942
						],
						[
							-82.461351,
							27.107909
						],
						[
							-82.461436,
							27.107855
						],
						[
							-82.46149011799997,
							27.10782702100005
						],
						[
							-82.461583,
							27.107779
						],
						[
							-82.461607,
							27.107682
						],
						[
							-82.461643,
							27.107595
						],
						[
							-82.461668,
							27.107508
						],
						[
							-82.46168,
							27.107421
						],
						[
							-82.46168,
							27.107291
						],
						[
							-82.461595,
							27.107161
						],
						[
							-82.46157,
							27.107075
						],
						[
							-82.461558,
							27.106956
						],
						[
							-82.461546,
							27.106859
						],
						[
							-82.461558,
							27.106718
						],
						[
							-82.46157,
							27.106599
						],
						[
							-82.46157,
							27.106479
						],
						[
							-82.461583,
							27.106382
						],
						[
							-82.46157,
							27.106263
						],
						[
							-82.46157,
							27.106154
						],
						[
							-82.461583,
							27.106024
						],
						[
							-82.461546,
							27.105916
						],
						[
							-82.461558,
							27.10584
						],
						[
							-82.46157,
							27.105742000000003
						],
						[
							-82.46157,
							27.105666
						],
						[
							-82.46157,
							27.105616647000033
						],
						[
							-82.46155924199996,
							27.105399589000058
						],
						[
							-82.461552,
							27.105367
						],
						[
							-82.46154,
							27.105318
						],
						[
							-82.46153132299997,
							27.105293706000054
						],
						[
							-82.46140758999996,
							27.105187648000026
						],
						[
							-82.46135800000002,
							27.105174
						],
						[
							-82.46129044699997,
							27.105249997000048
						],
						[
							-82.46127800000001,
							27.105264
						],
						[
							-82.46126,
							27.105334
						],
						[
							-82.461241,
							27.105475
						],
						[
							-82.461177,
							27.105659
						],
						[
							-82.461162,
							27.105746
						],
						[
							-82.461132,
							27.10579
						],
						[
							-82.461077,
							27.105849000000003
						],
						[
							-82.46103426899998,
							27.10593504900004
						],
						[
							-82.461037,
							27.105961
						],
						[
							-82.461020761,
							27.105962249000072
						],
						[
							-82.461004,
							27.105996
						],
						[
							-82.460998,
							27.106332
						],
						[
							-82.46092094099998,
							27.106343559000038
						],
						[
							-82.460921,
							27.106367
						],
						[
							-82.46085373499994,
							27.106372715000077
						],
						[
							-82.46081172399994,
							27.106566932000078
						],
						[
							-82.460946,
							27.107141
						],
						[
							-82.46110242399999,
							27.107249505000027
						],
						[
							-82.461113,
							27.107253
						],
						[
							-82.46113279199994,
							27.107270571000072
						],
						[
							-82.46123,
							27.107338
						],
						[
							-82.46122633699997,
							27.107412082000053
						],
						[
							-82.461241,
							27.107481
						],
						[
							-82.461247,
							27.107556
						],
						[
							-82.46123923899995,
							27.10761248600005
						],
						[
							-82.46122900000002,
							27.107687
						],
						[
							-82.461199,
							27.107757
						],
						[
							-82.461065,
							27.107779
						],
						[
							-82.460986,
							27.107795
						],
						[
							-82.46083069099996,
							27.10778799800005
						],
						[
							-82.46080480899997,
							27.107786831000055
						],
						[
							-82.46077102799995,
							27.107793869000034
						],
						[
							-82.46070611699997,
							27.107807392000044
						],
						[
							-82.460584,
							27.107887
						],
						[
							-82.46050297099998,
							27.107887
						],
						[
							-82.460425,
							27.107887
						],
						[
							-82.460352,
							27.107903
						],
						[
							-82.46033410499996,
							27.107887
						],
						[
							-82.460267,
							27.107827
						],
						[
							-82.460194,
							27.107806
						],
						[
							-82.459914,
							27.10754
						],
						[
							-82.45944552399999,
							27.107153976000063
						],
						[
							-82.45935341899997,
							27.107120782000038
						],
						[
							-82.45890874999998,
							27.107067804000053
						],
						[
							-82.45889653399996,
							27.107088971000053
						],
						[
							-82.458844,
							27.10718
						],
						[
							-82.458747,
							27.107172000000002
						],
						[
							-82.45872508099995,
							27.10706854400007
						],
						[
							-82.45871771399999,
							27.107033771000033
						],
						[
							-82.45801041599998,
							27.106906239000068
						],
						[
							-82.45791121099995,
							27.106922589000078
						],
						[
							-82.45782053399996,
							27.106906239000068
						],
						[
							-82.45657811799998,
							27.107111
						],
						[
							-82.45649356499996,
							27.10714593000006
						],
						[
							-82.45639511199994,
							27.10719176200007
						],
						[
							-82.45602511799996,
							27.107364000000004
						],
						[
							-82.45574711799998,
							27.107527
						],
						[
							-82.45540711799998,
							27.107626000000003
						],
						[
							-82.45521211799996,
							27.107815
						],
						[
							-82.45502811799997,
							27.107928000000005
						],
						[
							-82.45489211799998,
							27.10802
						],
						[
							-82.45470215499995,
							27.108135184000048
						],
						[
							-82.45447733999998,
							27.108379617000026
						],
						[
							-82.45445723199998,
							27.108413599000073
						],
						[
							-82.45430306899993,
							27.108507469000074
						],
						[
							-82.45422211799996,
							27.108558000000002
						],
						[
							-82.454197,
							27.108558000000002
						],
						[
							-82.45401850899998,
							27.10853543800005
						],
						[
							-82.45396,
							27.108547
						],
						[
							-82.453578,
							27.108484
						],
						[
							-82.452901,
							27.108426000000005
						],
						[
							-82.452277,
							27.108335
						],
						[
							-82.451562,
							27.108195
						],
						[
							-82.45137969099996,
							27.108110581000062
						],
						[
							-82.451359,
							27.108101000000005
						],
						[
							-82.45095600000002,
							27.108014000000004
						],
						[
							-82.45080730099994,
							27.10795122500008
						],
						[
							-82.45064768299994,
							27.107909820000035
						],
						[
							-82.450552,
							27.107885000000003
						],
						[
							-82.45003010899995,
							27.107594531000075
						],
						[
							-82.449465,
							27.107289
						],
						[
							-82.44946844899994,
							27.107281928000077
						],
						[
							-82.449456,
							27.107275
						],
						[
							-82.44959791099997,
							27.10698640100003
						],
						[
							-82.44965260999999,
							27.10687516300004
						],
						[
							-82.44960692799998,
							27.106827305000024
						],
						[
							-82.44954438299999,
							27.106800243000066
						],
						[
							-82.44950035499994,
							27.10690058700004
						],
						[
							-82.449462,
							27.106988
						],
						[
							-82.44924602799995,
							27.107135377000077
						],
						[
							-82.449208,
							27.107203
						],
						[
							-82.44916678599998,
							27.10718945000008
						],
						[
							-82.449144,
							27.107205
						],
						[
							-82.44910889299996,
							27.107170417000077
						],
						[
							-82.44877,
							27.107059
						],
						[
							-82.448471,
							27.106656
						],
						[
							-82.44860418799999,
							27.106470879000028
						],
						[
							-82.448612,
							27.106433
						],
						[
							-82.448668,
							27.106352
						],
						[
							-82.44879800000001,
							27.106135
						],
						[
							-82.44890830999998,
							27.106048172000044
						],
						[
							-82.44897638899994,
							27.10595354700007
						],
						[
							-82.448898,
							27.105879
						],
						[
							-82.44886310199996,
							27.105839051000032
						],
						[
							-82.448801,
							27.105808
						],
						[
							-82.44877843099994,
							27.105713754000078
						],
						[
							-82.448773,
							27.105704
						],
						[
							-82.448703,
							27.105555
						],
						[
							-82.44868871199998,
							27.105339094000044
						],
						[
							-82.44867268699994,
							27.105272176000028
						],
						[
							-82.44865097099995,
							27.105181489000074
						],
						[
							-82.448626,
							27.105107
						],
						[
							-82.448626,
							27.105077213000072
						],
						[
							-82.44858500000001,
							27.104906
						],
						[
							-82.44866539299994,
							27.10483026800006
						],
						[
							-82.448689,
							27.104758
						],
						[
							-82.44872775199997,
							27.10466466700007
						],
						[
							-82.448772,
							27.103628
						],
						[
							-82.44869279899996,
							27.103324969000028
						],
						[
							-82.44850807399996,
							27.103344992000075
						],
						[
							-82.44850291699998,
							27.103324969000028
						],
						[
							-82.44831811799997,
							27.103345
						],
						[
							-82.44831511799998,
							27.103465
						],
						[
							-82.44831711799998,
							27.103884
						],
						[
							-82.44831311799999,
							27.104444
						],
						[
							-82.44619314799998,
							27.104089119000037
						],
						[
							-82.44618624099996,
							27.10408751600005
						],
						[
							-82.446027,
							27.104029000000004
						],
						[
							-82.44574983299998,
							27.103902659000028
						],
						[
							-82.445744,
							27.103900000000003
						],
						[
							-82.445579,
							27.103746000000005
						],
						[
							-82.44555758299998,
							27.103624384000057
						],
						[
							-82.44555100000001,
							27.103587
						],
						[
							-82.445478,
							27.103369
						],
						[
							-82.44547923699997,
							27.103289674000052
						],
						[
							-82.445469,
							27.103276
						],
						[
							-82.44548005299998,
							27.103237315000058
						],
						[
							-82.445485,
							27.10292
						],
						[
							-82.445326,
							27.102883000000002
						],
						[
							-82.44529523499995,
							27.103245774000072
						],
						[
							-82.445286,
							27.103435
						],
						[
							-82.44527857799994,
							27.10344218800003
						],
						[
							-82.445278,
							27.103449
						],
						[
							-82.445223,
							27.103510000000004
						],
						[
							-82.44520694999994,
							27.103511553000033
						],
						[
							-82.445191,
							27.103527
						],
						[
							-82.44517037399999,
							27.10351509300006
						],
						[
							-82.445099,
							27.103522
						],
						[
							-82.44476428299998,
							27.103280660000053
						],
						[
							-82.44465969099997,
							27.103220280000073
						],
						[
							-82.44447531999998,
							27.103113845000056
						],
						[
							-82.444143,
							27.102922
						],
						[
							-82.44412283699995,
							27.10301997700003
						],
						[
							-82.44411600599994,
							27.103053171000056
						],
						[
							-82.44395311799997,
							27.102959137000028
						],
						[
							-82.44307297899996,
							27.102215564000062
						],
						[
							-82.44247773999996,
							27.101712685000052
						],
						[
							-82.44201847599999,
							27.101011394000068
						],
						[
							-82.43951122999994,
							27.097182859000043
						],
						[
							-82.43649761699999,
							27.092581108000047
						],
						[
							-82.43287979799999,
							27.08764240900007
						],
						[
							-82.43285782499999,
							27.08761264000003
						],
						[
							-82.43263954999998,
							27.087316913000052
						],
						[
							-82.43075041499999,
							27.084757440000036
						],
						[
							-82.43030182899997,
							27.07668288800005
						],
						[
							-82.43062224699997,
							27.069505508000077
						],
						[
							-82.43832211799997,
							27.05585
						],
						[
							-82.43866611799996,
							27.05668
						],
						[
							-82.43947711799996,
							27.058478
						],
						[
							-82.43968641599999,
							27.058678632000067
						],
						[
							-82.4397,
							27.058819
						],
						[
							-82.44001448999995,
							27.058993122000064
						],
						[
							-82.440464,
							27.059242
						],
						[
							-82.44072668299998,
							27.05962474000006
						],
						[
							-82.440755,
							27.059666000000004
						],
						[
							-82.44080387399998,
							27.05969002200004
						],
						[
							-82.44125723499997,
							27.059912850000046
						],
						[
							-82.44152000000001,
							27.060042
						],
						[
							-82.442039,
							27.060574
						],
						[
							-82.44206657299998,
							27.06058333200008
						],
						[
							-82.442429,
							27.060706000000003
						],
						[
							-82.44365915599997,
							27.060650638000027
						],
						[
							-82.44413955799996,
							27.060666668000067
						],
						[
							-82.44435370999997,
							27.06067381300005
						],
						[
							-82.444497,
							27.060716
						],
						[
							-82.445163,
							27.060717
						],
						[
							-82.44555847899994,
							27.060714972000028
						],
						[
							-82.44642111799999,
							27.063039
						],
						[
							-82.45169346099993,
							27.076976572000035
						],
						[
							-82.45193411799994,
							27.077793
						],
						[
							-82.45243311799999,
							27.079157
						],
						[
							-82.45273911799995,
							27.079302
						],
						[
							-82.45337767399998,
							27.080991007000023
						],
						[
							-82.45452211799994,
							27.085121
						],
						[
							-82.45477911799998,
							27.085601
						],
						[
							-82.45495505499997,
							27.086029945000064
						],
						[
							-82.45497081499997,
							27.08604928400007
						],
						[
							-82.45499157499995,
							27.08607302400003
						],
						[
							-82.45500511799997,
							27.086089
						],
						[
							-82.45505511799996,
							27.086207
						],
						[
							-82.45525311799997,
							27.086346
						],
						[
							-82.45568311799997,
							27.087089
						],
						[
							-82.45586411799997,
							27.087589
						],
						[
							-82.45595041099996,
							27.087644049000062
						],
						[
							-82.45614465799997,
							27.088047414000073
						],
						[
							-82.45615311799997,
							27.088075
						],
						[
							-82.45631011799998,
							27.088391
						],
						[
							-82.45661203299994,
							27.089090094000028
						],
						[
							-82.45651325599994,
							27.089315353000075
						],
						[
							-82.45672211799996,
							27.089345
						],
						[
							-82.45688711799994,
							27.089824
						],
						[
							-82.45686014999995,
							27.08994343100005
						],
						[
							-82.45685913299997,
							27.089947599000027
						],
						[
							-82.45685911799995,
							27.090148
						],
						[
							-82.45688711799994,
							27.090435
						],
						[
							-82.45698511799998,
							27.090797
						],
						[
							-82.45725572899994,
							27.09163913100008
						],
						[
							-82.45733811799995,
							27.09184
						],
						[
							-82.45751945999996,
							27.092552024000042
						],
						[
							-82.45761611799998,
							27.092731
						],
						[
							-82.45762204899995,
							27.092746199000032
						],
						[
							-82.45767613199996,
							27.09289390300006
						],
						[
							-82.45793681999999,
							27.09325176300007
						],
						[
							-82.45962470599994,
							27.097605396000063
						],
						[
							-82.46042411799993,
							27.099931
						],
						[
							-82.46187011799998,
							27.103846
						],
						[
							-82.46368411799995,
							27.108076
						],
						[
							-82.46448111799998,
							27.109556
						],
						[
							-82.46567911799998,
							27.111245
						],
						[
							-82.46582037299999,
							27.111355368000034
						],
						[
							-82.46609021599996,
							27.111497238000027
						],
						[
							-82.46674011799996,
							27.111896
						],
						[
							-82.46708511799996,
							27.112172
						],
						[
							-82.46736911799997,
							27.112282000000004
						],
						[
							-82.46695439499996,
							27.112853397000038
						],
						[
							-82.46619262799999,
							27.11261391900007
						],
						[
							-82.46545553799996,
							27.112382199000024
						],
						[
							-82.46541964799997,
							27.11237768600006
						],
						[
							-82.463232,
							27.11231
						],
						[
							-82.46322157399999,
							27.11231555200004
						],
						[
							-82.46304211799998,
							27.11231
						],
						[
							-82.46157166599994,
							27.113093122000066
						],
						[
							-82.46151309899994,
							27.113089745000025
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Venice",
				"Name": "The Island",
				"RegionID": "762156"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.17977949099998,
					25.93264984100006,
					-80.16235721699996,
					25.944262000000002
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.16235721699996,
							25.93333941900005
						],
						[
							-80.17035220599996,
							25.93305388300007
						],
						[
							-80.17030834399998,
							25.93264984100006
						],
						[
							-80.17203345399997,
							25.934684280000056
						],
						[
							-80.17536469899994,
							25.938479521000033
						],
						[
							-80.17977949099998,
							25.943633031000047
						],
						[
							-80.179607,
							25.943639
						],
						[
							-80.17933,
							25.943649
						],
						[
							-80.178754,
							25.943672
						],
						[
							-80.17855900000002,
							25.943673
						],
						[
							-80.176762,
							25.943744
						],
						[
							-80.174731,
							25.943814
						],
						[
							-80.172701,
							25.943884
						],
						[
							-80.170751,
							25.943962
						],
						[
							-80.168809,
							25.944042
						],
						[
							-80.166843,
							25.944108
						],
						[
							-80.164917,
							25.944176000000002
						],
						[
							-80.162825,
							25.944262000000002
						],
						[
							-80.16235721699996,
							25.93333941900005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "North Miami Beach",
				"Name": "Sunray West",
				"RegionID": "762324"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.16515,
					25.946006,
					-80.156772,
					25.957163
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.158767,
							25.946211
						],
						[
							-80.162898,
							25.946069
						],
						[
							-80.164916,
							25.946006
						],
						[
							-80.165043,
							25.946337
						],
						[
							-80.165097,
							25.947094
						],
						[
							-80.165119,
							25.947244
						],
						[
							-80.16515,
							25.947809
						],
						[
							-80.163043,
							25.947901
						],
						[
							-80.163063,
							25.948193
						],
						[
							-80.163088,
							25.948634
						],
						[
							-80.163087,
							25.948863
						],
						[
							-80.163002,
							25.948955
						],
						[
							-80.161361,
							25.948988
						],
						[
							-80.161005,
							25.949012
						],
						[
							-80.160698,
							25.949037
						],
						[
							-80.160702,
							25.949374000000002
						],
						[
							-80.16080280099999,
							25.95093588000003
						],
						[
							-80.160888,
							25.952256000000002
						],
						[
							-80.161605,
							25.952384
						],
						[
							-80.161889,
							25.953169
						],
						[
							-80.162019,
							25.953508
						],
						[
							-80.162041,
							25.953845
						],
						[
							-80.162038,
							25.954205
						],
						[
							-80.161969,
							25.9555
						],
						[
							-80.161982,
							25.955845
						],
						[
							-80.161961,
							25.956453
						],
						[
							-80.162006,
							25.956683
						],
						[
							-80.161438,
							25.956651000000004
						],
						[
							-80.160288,
							25.956697000000002
						],
						[
							-80.160319,
							25.957074
						],
						[
							-80.158189,
							25.957163
						],
						[
							-80.15820500000001,
							25.956989
						],
						[
							-80.158178,
							25.956352
						],
						[
							-80.158162,
							25.955947
						],
						[
							-80.158018,
							25.95581
						],
						[
							-80.15774,
							25.955585
						],
						[
							-80.157441,
							25.955365
						],
						[
							-80.157134,
							25.955361
						],
						[
							-80.15711600000002,
							25.954618
						],
						[
							-80.157085,
							25.954198
						],
						[
							-80.156977,
							25.95261
						],
						[
							-80.156956,
							25.951986
						],
						[
							-80.156963,
							25.951777
						],
						[
							-80.156964,
							25.951758
						],
						[
							-80.159057,
							25.951708
						],
						[
							-80.159047,
							25.951483
						],
						[
							-80.15901810499997,
							25.95093588000003
						],
						[
							-80.15894,
							25.949457
						],
						[
							-80.158898,
							25.948737
						],
						[
							-80.158889,
							25.948597
						],
						[
							-80.156805,
							25.948664
						],
						[
							-80.156792,
							25.948335
						],
						[
							-80.156772,
							25.947973
						],
						[
							-80.15885200000001,
							25.947896
						],
						[
							-80.158841,
							25.947568
						],
						[
							-80.158788,
							25.946743
						],
						[
							-80.158767,
							25.946211
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "North Miami Beach",
				"Name": "Skylake",
				"RegionID": "762326"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.23654691299998,
					27.19017084400008,
					-80.22919009499998,
					27.19752574000006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.23242663799994,
							27.197494886000072
						],
						[
							-80.23255941199994,
							27.197166520000053
						],
						[
							-80.23258796599998,
							27.196823878000032
						],
						[
							-80.23213110899997,
							27.195795951000036
						],
						[
							-80.23181701999994,
							27.195167773000037
						],
						[
							-80.23146010099998,
							27.194810854000025
						],
						[
							-80.23128877999994,
							27.194696640000075
						],
						[
							-80.23058921899997,
							27.194625256000055
						],
						[
							-80.23034651399996,
							27.194482488000062
						],
						[
							-80.23027512999994,
							27.194168399000034
						],
						[
							-80.23028940599994,
							27.193554498000026
						],
						[
							-80.23018946899998,
							27.19331179300008
						],
						[
							-80.22990393399994,
							27.192912044000025
						],
						[
							-80.22971833599996,
							27.192583678000062
						],
						[
							-80.22990393399994,
							27.192055438000068
						],
						[
							-80.22997531799996,
							27.19174134900004
						],
						[
							-80.22983254999997,
							27.191384430000028
						],
						[
							-80.22970405899997,
							27.19112744800003
						],
						[
							-80.22930430999997,
							27.19081335900006
						],
						[
							-80.22919009499998,
							27.19062776100003
						],
						[
							-80.22920461299998,
							27.19017084400008
						],
						[
							-80.23424733299998,
							27.190231337000057
						],
						[
							-80.23654215399995,
							27.19025886600008
						],
						[
							-80.23654691299998,
							27.193813780000028
						],
						[
							-80.23647552899996,
							27.19752574000006
						],
						[
							-80.23242663799994,
							27.197494886000072
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Martin",
				"City": "Stuart",
				"Name": "Krueger West",
				"RegionID": "762340"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.25307084199994,
					27.182952215000057,
					-80.24170653599998,
					27.19122016800003
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.253043,
							27.184724580000083
						],
						[
							-80.25298586199995,
							27.188095691000058
						],
						[
							-80.25295186899996,
							27.190101306000034
						],
						[
							-80.25306513099997,
							27.19122016800003
						],
						[
							-80.24818818799997,
							27.18883424300003
						],
						[
							-80.24697466299995,
							27.18820606500003
						],
						[
							-80.24547560299999,
							27.18677838800005
						],
						[
							-80.24170653599998,
							27.182952215000057
						],
						[
							-80.25307084199994,
							27.183081896000033
						],
						[
							-80.253043,
							27.184724580000083
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Martin",
				"City": "Stuart",
				"Name": "Casa Terrace",
				"RegionID": "762342"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.31803501199994,
					28.729674000000003,
					-81.31383193199997,
					28.745404259000054
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.31384050299994,
							28.73082631900007
						],
						[
							-81.317933,
							28.729674000000003
						],
						[
							-81.31793729199995,
							28.730627588000065
						],
						[
							-81.31795886899994,
							28.735421944000052
						],
						[
							-81.31795886899994,
							28.73601585800003
						],
						[
							-81.31795886899994,
							28.74173417800006
						],
						[
							-81.31803501199994,
							28.745358573000033
						],
						[
							-81.31450198899995,
							28.74536618800005
						],
						[
							-81.31392330399996,
							28.745404259000054
						],
						[
							-81.31387000399997,
							28.741749407000043
						],
						[
							-81.31383193199997,
							28.73849049700004
						],
						[
							-81.31383341299994,
							28.738083347000046
						],
						[
							-81.31384653699996,
							28.73447427000008
						],
						[
							-81.31384716099996,
							28.734302646000057
						],
						[
							-81.31384050299994,
							28.73082631900007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Seminole",
				"City": "Lake Mary",
				"Name": "Cardinal Oaks",
				"RegionID": "762960"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.34721929199998,
					28.770769406000056,
					-81.33871488199998,
					28.776469233000057
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.34276494099998,
							28.776469233000057
						],
						[
							-81.34274590499996,
							28.775517448000077
						],
						[
							-81.338786482,
							28.775555520000072
						],
						[
							-81.33871488199998,
							28.770806047000065
						],
						[
							-81.34718058899995,
							28.770769406000056
						],
						[
							-81.34721929199998,
							28.77641212600002
						],
						[
							-81.34276494099998,
							28.776469233000057
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Seminole",
				"City": "Lake Mary",
				"Name": "Woodbridge Lakes",
				"RegionID": "762976"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.34482539499999,
					28.75986046800006,
					-81.33863498999995,
					28.767033115000064
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.33863498999995,
							28.75986046800006
						],
						[
							-81.34482539499999,
							28.75986046800006
						],
						[
							-81.34481397399998,
							28.767033115000064
						],
						[
							-81.33865783199998,
							28.767021694000054
						],
						[
							-81.33864075099996,
							28.76166656600003
						],
						[
							-81.33863498999995,
							28.75986046800006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Seminole",
				"City": "Lake Mary",
				"Name": "Fountain Parke",
				"RegionID": "762978"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.92362059299995,
					29.004419292000023,
					-80.90857500000001,
					29.02095665700006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.90857500000001,
							29.006463
						],
						[
							-80.909175,
							29.006263000000004
						],
						[
							-80.911539,
							29.005407
						],
						[
							-80.91218393099996,
							29.005159313000036
						],
						[
							-80.913721,
							29.004569000000004
						],
						[
							-80.91413269599998,
							29.004419292000023
						],
						[
							-80.91456531599994,
							29.004841361000047
						],
						[
							-80.91555517199998,
							29.00545050300008
						],
						[
							-80.91732549099999,
							29.00634518000004
						],
						[
							-80.91816306099997,
							29.006897215000034
						],
						[
							-80.91892448799996,
							29.007639607000044
						],
						[
							-80.91953362999999,
							29.008496213000058
						],
						[
							-80.92193212699993,
							29.013788134000038
						],
						[
							-80.92208441299994,
							29.01439727600007
						],
						[
							-80.92210344799999,
							29.015196775000046
						],
						[
							-80.92219862699996,
							29.015615560000068
						],
						[
							-80.92316944699996,
							29.01770948600006
						],
						[
							-80.92362059299995,
							29.018337346000067
						],
						[
							-80.91672205899994,
							29.02095665700006
						],
						[
							-80.91345854199994,
							29.016548347000025
						],
						[
							-80.91151690199996,
							29.01319806600003
						],
						[
							-80.90857500000001,
							29.006463
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Volusia",
				"City": "New Smyrna Beach",
				"Name": "South Mainland",
				"RegionID": "763094"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.94254462799995,
					29.01988403500008,
					-80.92640512799994,
					29.03232968700007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.92735158699998,
							29.025814564000026
						],
						[
							-80.92640512799994,
							29.023588950000033
						],
						[
							-80.93249752899999,
							29.021228708000024
						],
						[
							-80.93288775999997,
							29.02105738700004
						],
						[
							-80.93444651499993,
							29.01988403500008
						],
						[
							-80.934708,
							29.020144
						],
						[
							-80.934708,
							29.020171000000005
						],
						[
							-80.934715,
							29.020656999999996
						],
						[
							-80.934335,
							29.020656
						],
						[
							-80.934553,
							29.021186000000004
						],
						[
							-80.93504,
							29.021589
						],
						[
							-80.935165,
							29.021877
						],
						[
							-80.935303,
							29.021877
						],
						[
							-80.935295,
							29.022894
						],
						[
							-80.935326,
							29.025049
						],
						[
							-80.936058,
							29.026445000000002
						],
						[
							-80.936287,
							29.026403000000002
						],
						[
							-80.936404,
							29.026845
						],
						[
							-80.93669600000001,
							29.02716
						],
						[
							-80.937219,
							29.027158000000004
						],
						[
							-80.938255,
							29.027099
						],
						[
							-80.938255,
							29.02689
						],
						[
							-80.937527,
							29.026892999999998
						],
						[
							-80.937563,
							29.026627000000005
						],
						[
							-80.938255,
							29.026581
						],
						[
							-80.939262,
							29.026573
						],
						[
							-80.94042200000001,
							29.026562000000002
						],
						[
							-80.94042960299998,
							29.026103821000053
						],
						[
							-80.940701,
							29.026088
						],
						[
							-80.94070805799998,
							29.02562316200005
						],
						[
							-80.941643,
							29.025503
						],
						[
							-80.941635,
							29.026549999999997
						],
						[
							-80.94254300000001,
							29.026543
						],
						[
							-80.94254462799995,
							29.02910884900007
						],
						[
							-80.93745067799995,
							29.030365204000077
						],
						[
							-80.93492654599999,
							29.030993382000077
						],
						[
							-80.93152296499994,
							29.03232968700007
						],
						[
							-80.92914731099995,
							29.027601222000044
						],
						[
							-80.92826786199998,
							29.02800097200003
						],
						[
							-80.92735158699998,
							29.025814564000026
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Volusia",
				"City": "New Smyrna Beach",
				"Name": "Historic Westside",
				"RegionID": "763101"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.92735158699998,
					29.018337346000067,
					-80.91672205899994,
					29.02815976100004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.91804028099995,
							29.02808932900007
						],
						[
							-80.91808786999997,
							29.02599540300002
						],
						[
							-80.91765956699999,
							29.023711121000073
						],
						[
							-80.91672205899994,
							29.02095665700006
						],
						[
							-80.92362059299995,
							29.018337346000067
						],
						[
							-80.92435156299997,
							29.019114002000038
						],
						[
							-80.92483887699996,
							29.01990588700005
						],
						[
							-80.92640512799994,
							29.023588950000033
						],
						[
							-80.92735158699998,
							29.025814564000026
						],
						[
							-80.92214342299997,
							29.027855190000025
						],
						[
							-80.92182552699995,
							29.02815976100004
						],
						[
							-80.92114024199998,
							29.027626762000068
						],
						[
							-80.91960215899996,
							29.027916104000038
						],
						[
							-80.91804028099995,
							29.02808932900007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Volusia",
				"City": "New Smyrna Beach",
				"Name": "Canal Downtown",
				"RegionID": "763103"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.041573,
					28.975345,
					-80.971383,
					29.01262536700006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.039309,
							29.011602999999997
						],
						[
							-81.038351,
							29.011623999999998
						],
						[
							-81.03763800000002,
							29.011639000000002
						],
						[
							-81.037034,
							29.011652
						],
						[
							-81.030004,
							29.011804000000005
						],
						[
							-81.029601,
							29.011811
						],
						[
							-81.00561830799995,
							29.012411692000057
						],
						[
							-80.99651909099998,
							29.01262536700006
						],
						[
							-80.99640011799994,
							29.00524903800005
						],
						[
							-80.98298614399995,
							29.005408700000036
						],
						[
							-80.97144924099996,
							28.98760958600008
						],
						[
							-80.971383,
							28.987065
						],
						[
							-80.971768,
							28.987061000000004
						],
						[
							-80.975904,
							28.987019000000004
						],
						[
							-80.981751,
							28.987017
						],
						[
							-80.983018,
							28.987017
						],
						[
							-80.990411,
							28.987111
						],
						[
							-80.990406,
							28.986934000000005
						],
						[
							-80.99349500000001,
							28.986883
						],
						[
							-80.993307,
							28.981405999999996
						],
						[
							-80.995213,
							28.981429
						],
						[
							-80.99513,
							28.980163
						],
						[
							-80.99513,
							28.97949
						],
						[
							-81.006469,
							28.979328
						],
						[
							-81.006646,
							28.979359000000002
						],
						[
							-81.024156,
							28.97906
						],
						[
							-81.024055,
							28.975453
						],
						[
							-81.02451300000001,
							28.975443
						],
						[
							-81.024917,
							28.975407000000004
						],
						[
							-81.025064,
							28.975431000000004
						],
						[
							-81.037101,
							28.975361999999997
						],
						[
							-81.037101,
							28.975373000000005
						],
						[
							-81.039162,
							28.975345
						],
						[
							-81.039166,
							28.976092
						],
						[
							-81.040608,
							28.976025
						],
						[
							-81.040902,
							28.976011999999997
						],
						[
							-81.04102400000001,
							28.978573000000004
						],
						[
							-81.040664,
							28.978579000000003
						],
						[
							-81.038965,
							28.978570000000005
						],
						[
							-81.03904,
							28.980385
						],
						[
							-81.040687,
							28.980346000000004
						],
						[
							-81.04110800000001,
							28.98033
						],
						[
							-81.041427,
							28.991661
						],
						[
							-81.041573,
							28.996906000000003
						],
						[
							-81.041486,
							29.000264000000005
						],
						[
							-81.041567,
							29.011557999999997
						],
						[
							-81.041451,
							29.011557
						],
						[
							-81.040686,
							29.011573000000002
						],
						[
							-81.039309,
							29.011602999999997
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Volusia",
				"City": "New Smyrna Beach",
				"Name": "South Village",
				"RegionID": "763108"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.06560934199997,
					26.601376642000048,
					-80.05732600099998,
					26.608873267000035
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.06560934199997,
							26.601603435000072
						],
						[
							-80.06536609499994,
							26.608873267000035
						],
						[
							-80.06452910499996,
							26.60876248900007
						],
						[
							-80.05761153599997,
							26.608577842000045
						],
						[
							-80.05778285699995,
							26.60381321000006
						],
						[
							-80.05778285699995,
							26.602534011000046
						],
						[
							-80.05764579999999,
							26.602046698000038
						],
						[
							-80.05732600099998,
							26.601376642000048
						],
						[
							-80.06560934199997,
							26.601603435000072
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Lake Worth",
				"Name": "Memorial Park",
				"RegionID": "763126"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.05761153599997,
					26.60849789200006,
					-80.05215210099999,
					26.616629938000074
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.05240337199996,
							26.616492881000056
						],
						[
							-80.05259753599995,
							26.61090781100006
						],
						[
							-80.05255184999999,
							26.610325319000026
						],
						[
							-80.05242621499997,
							26.60991414800003
						],
						[
							-80.05241862199995,
							26.60989326600003
						],
						[
							-80.05224347199999,
							26.609411606000037
						],
						[
							-80.05215210099999,
							26.60896617000003
						],
						[
							-80.05215210099999,
							26.60849789200006
						],
						[
							-80.05613817399995,
							26.608612107000056
						],
						[
							-80.05761153599997,
							26.608577842000045
						],
						[
							-80.05731457899998,
							26.616629938000074
						],
						[
							-80.05240337199996,
							26.616492881000056
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Lake Worth",
				"Name": "Downtown Jewel",
				"RegionID": "763128"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.56005774199997,
					28.291728853000052,
					-81.54963570299998,
					28.303983077000055
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.55203527099997,
							28.303831981000034
						],
						[
							-81.55154986099996,
							28.303580710000062
						],
						[
							-81.55108729299997,
							28.303260910000063
						],
						[
							-81.55062851199995,
							28.30309728900005
						],
						[
							-81.55137270999995,
							28.30129428600003
						],
						[
							-81.55149168299994,
							28.30027111800007
						],
						[
							-81.55084922799995,
							28.299152771000024
						],
						[
							-81.55044471999997,
							28.297891657000037
						],
						[
							-81.55065887099994,
							28.296202239000024
						],
						[
							-81.55070646099995,
							28.295274249000045
						],
						[
							-81.55023056799996,
							28.294679384000062
						],
						[
							-81.54963570299998,
							28.293751394000026
						],
						[
							-81.54973088199995,
							28.29303755600006
						],
						[
							-81.55073025499996,
							28.29229992300003
						],
						[
							-81.55184860199995,
							28.291728853000052
						],
						[
							-81.55320489499996,
							28.291752647000067
						],
						[
							-81.55394252799994,
							28.292490280000038
						],
						[
							-81.55472774999998,
							28.29284719900005
						],
						[
							-81.55601265899998,
							28.29220474500005
						],
						[
							-81.55741654099995,
							28.29229992300003
						],
						[
							-81.55815417399998,
							28.293465859000037
						],
						[
							-81.55820176299994,
							28.29498871400006
						],
						[
							-81.55829694099998,
							28.296368802000075
						],
						[
							-81.55908216299997,
							28.297439559000054
						],
						[
							-81.55981979599994,
							28.298653084000023
						],
						[
							-81.56005774199997,
							28.300080761000064
						],
						[
							-81.55991497499997,
							28.30184156200005
						],
						[
							-81.55903457399995,
							28.302555400000074
						],
						[
							-81.55751171899999,
							28.30291231900003
						],
						[
							-81.55663131799997,
							28.30312647100004
						],
						[
							-81.55537020399998,
							28.302959909000037
						],
						[
							-81.55439462499999,
							28.302745757000025
						],
						[
							-81.55379975999995,
							28.302936114000033
						],
						[
							-81.55287176999997,
							28.303983077000055
						],
						[
							-81.55203527099997,
							28.303831981000034
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Osceola",
				"City": "Celebration",
				"Name": "Artisan Park",
				"RegionID": "763185"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.54992922999999,
					28.302150892000043,
					-81.54030821599997,
					28.314839558000077
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.54352522199997,
							28.314513266000063
						],
						[
							-81.54356807799996,
							28.313191591000077
						],
						[
							-81.54344910499998,
							28.311502174000054
						],
						[
							-81.54285423899995,
							28.310169675000054
						],
						[
							-81.54149794599995,
							28.30867061500004
						],
						[
							-81.54056995699995,
							28.307028787000036
						],
						[
							-81.54030821599997,
							28.305196602000024
						],
						[
							-81.54078410799997,
							28.304458969000052
						],
						[
							-81.54171209799996,
							28.30381651400006
						],
						[
							-81.54354428299996,
							28.30317406000006
						],
						[
							-81.54639963599999,
							28.302269865000028
						],
						[
							-81.54735142099997,
							28.302150892000043
						],
						[
							-81.54842217799995,
							28.30253160600006
						],
						[
							-81.54917991699995,
							28.30307245700004
						],
						[
							-81.54897433199994,
							28.303489339000066
						],
						[
							-81.54890009299999,
							28.304026145000023
						],
						[
							-81.54898575299995,
							28.304551530000026
						],
						[
							-81.54925986699999,
							28.305196840000065
						],
						[
							-81.54973385599999,
							28.30623618800007
						],
						[
							-81.54948258499996,
							28.30636753500005
						],
						[
							-81.54992922999999,
							28.30708856700005
						],
						[
							-81.54875713499996,
							28.307883918000073
						],
						[
							-81.54850967099998,
							28.308264631000043
						],
						[
							-81.54845256399996,
							28.30864534500006
						],
						[
							-81.54875713499996,
							28.308892809000042
						],
						[
							-81.54887134899997,
							28.30921641600003
						],
						[
							-81.54881424199993,
							28.309406773000035
						],
						[
							-81.54847159899998,
							28.309578094000074
						],
						[
							-81.54803377899998,
							28.30999687900004
						],
						[
							-81.54765306499996,
							28.310986735000032
						],
						[
							-81.54698681599996,
							28.311843341000042
						],
						[
							-81.54658706599997,
							28.31214791200006
						],
						[
							-81.54652995899994,
							28.312547661000053
						],
						[
							-81.54675838699995,
							28.313271017000037
						],
						[
							-81.54757025699996,
							28.313738577000038
						],
						[
							-81.54745985299996,
							28.31392584500003
						],
						[
							-81.54704868199997,
							28.31427990900005
						],
						[
							-81.54669461799995,
							28.314531180000074
						],
						[
							-81.54631771099999,
							28.314839558000077
						],
						[
							-81.54509561999998,
							28.31474818700008
						],
						[
							-81.54375931499999,
							28.314462651000042
						],
						[
							-81.54352522199997,
							28.314513266000063
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Osceola",
				"City": "Celebration",
				"Name": "East Village",
				"RegionID": "763187"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.55354746599994,
					28.314858594000043,
					-81.53348384999998,
					28.326803659000063
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.53348384999998,
							28.32079772800006
						],
						[
							-81.53409299199996,
							28.319331980000072
						],
						[
							-81.53546356199996,
							28.317542626000034
						],
						[
							-81.53751941599995,
							28.31577230700003
						],
						[
							-81.53927069999997,
							28.314915701000075
						],
						[
							-81.54062223299997,
							28.314858594000043
						],
						[
							-81.54188653099999,
							28.31560780800004
						],
						[
							-81.54216412399995,
							28.31577230700003
						],
						[
							-81.54423901399997,
							28.317523590000064
						],
						[
							-81.54472110999995,
							28.317830378000053
						],
						[
							-81.54675172499998,
							28.319122588000027
						],
						[
							-81.54856011499999,
							28.32087387100006
						],
						[
							-81.55031139899995,
							28.322453833000054
						],
						[
							-81.55139643299998,
							28.323253332000036
						],
						[
							-81.55354746599994,
							28.324071867000043
						],
						[
							-81.55110972899996,
							28.32648873900007
						],
						[
							-81.54842686599994,
							28.326470363000055
						],
						[
							-81.53911841399997,
							28.326565542000026
						],
						[
							-81.53656763199996,
							28.326641685000027
						],
						[
							-81.53519820799994,
							28.326803659000063
						],
						[
							-81.53443563499997,
							28.325309186000027
						],
						[
							-81.53394070699994,
							28.32401476000007
						],
						[
							-81.53361709999996,
							28.322073119000038
						],
						[
							-81.53348384999998,
							28.32079772800006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Osceola",
				"City": "Celebration",
				"Name": "Celebration Village",
				"RegionID": "763192"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.71226999999993,
					27.77090000000004,
					-82.6998299999999,
					27.777199056000086
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.71151082299991,
							27.770904553000037
						],
						[
							-82.71221999999995,
							27.77090000000004
						],
						[
							-82.71222474299992,
							27.77113681700007
						],
						[
							-82.71222997499991,
							27.771353976000057
						],
						[
							-82.71223590499994,
							27.77160004300004
						],
						[
							-82.71223999999997,
							27.77177000000006
						],
						[
							-82.71223999999997,
							27.772265160000078
						],
						[
							-82.7122404889999,
							27.77277153900008
						],
						[
							-82.71224337699994,
							27.77301702700004
						],
						[
							-82.7122471209999,
							27.77333532700004
						],
						[
							-82.71224999999993,
							27.773580000000038
						],
						[
							-82.71224999999993,
							27.773720000000086
						],
						[
							-82.71224999999993,
							27.774029581000036
						],
						[
							-82.71224999999993,
							27.774347755000065
						],
						[
							-82.71224999999993,
							27.774560000000065
						],
						[
							-82.71225423699991,
							27.77475276200005
						],
						[
							-82.71226217899994,
							27.775114149000046
						],
						[
							-82.71226726899994,
							27.775345754000057
						],
						[
							-82.71226999999993,
							27.77547000000004
						],
						[
							-82.71226999999993,
							27.775866314000044
						],
						[
							-82.71226999999993,
							27.77624233800009
						],
						[
							-82.71226999999993,
							27.77639000000005
						],
						[
							-82.71226999999993,
							27.77656051200006
						],
						[
							-82.71226999999993,
							27.777037773000078
						],
						[
							-82.71226999999993,
							27.777150000000063
						],
						[
							-82.71160605699993,
							27.77715414700009
						],
						[
							-82.71080999999992,
							27.777160000000038
						],
						[
							-82.71037674299993,
							27.777160000000038
						],
						[
							-82.71016999999995,
							27.777160000000038
						],
						[
							-82.70992854399992,
							27.777163354000038
						],
						[
							-82.70969698799992,
							27.777166570000077
						],
						[
							-82.70944999999995,
							27.77717000000007
						],
						[
							-82.70891603399991,
							27.77717000000007
						],
						[
							-82.70836645999992,
							27.77717000000007
						],
						[
							-82.70807999999994,
							27.77717000000007
						],
						[
							-82.70774457399995,
							27.77717000000007
						],
						[
							-82.70700698899994,
							27.77717000000007
						],
						[
							-82.7067199999999,
							27.77717000000007
						],
						[
							-82.70654426699991,
							27.777172789000076
						],
						[
							-82.70629823799993,
							27.777176695000037
						],
						[
							-82.7059223039999,
							27.777180000000044
						],
						[
							-82.70558966699991,
							27.777180000000044
						],
						[
							-82.7053699999999,
							27.777180000000044
						],
						[
							-82.70504009399991,
							27.777180000000044
						],
						[
							-82.70449051999994,
							27.777180000000044
						],
						[
							-82.70420127099993,
							27.777180000000044
						],
						[
							-82.7039299999999,
							27.777180000000044
						],
						[
							-82.70350707299991,
							27.777180000000044
						],
						[
							-82.7030731989999,
							27.777180000000044
						],
						[
							-82.70275502499993,
							27.777180000000044
						],
						[
							-82.70246999999995,
							27.777180000000044
						],
						[
							-82.70210433299991,
							27.777182902000053
						],
						[
							-82.70181510099991,
							27.77718519800004
						],
						[
							-82.70155467899991,
							27.777187264000077
						],
						[
							-82.70133764099995,
							27.777188987000045
						],
						[
							-82.70120999999995,
							27.77719000000008
						],
						[
							-82.70088933299992,
							27.777192393000064
						],
						[
							-82.70055671499995,
							27.777194875000077
						],
						[
							-82.7001228659999,
							27.777198113000054
						],
						[
							-82.69986999999992,
							27.777199056000086
						],
						[
							-82.69986999999992,
							27.77692207800004
						],
						[
							-82.69986999999992,
							27.77660390300008
						],
						[
							-82.69986999999992,
							27.77640000000008
						],
						[
							-82.6998655669999,
							27.775996562000046
						],
						[
							-82.69985999999994,
							27.775490000000048
						],
						[
							-82.69985999999994,
							27.774984101000086
						],
						[
							-82.69985999999994,
							27.77458000000007
						],
						[
							-82.69985586099995,
							27.774203317000058
						],
						[
							-82.69985267899995,
							27.773913784000058
						],
						[
							-82.69984999999991,
							27.77367000000004
						],
						[
							-82.6998456899999,
							27.77327782800006
						],
						[
							-82.69983999999994,
							27.772760000000066
						],
						[
							-82.6998356599999,
							27.77235201600007
						],
						[
							-82.6998299999999,
							27.771820000000048
						],
						[
							-82.6998299999999,
							27.771484172000047
						],
						[
							-82.6998299999999,
							27.771137071000055
						],
						[
							-82.6998299999999,
							27.77098000000007
						],
						[
							-82.6998299999999,
							27.770940000000053
						],
						[
							-82.7007348439999,
							27.770940000000053
						],
						[
							-82.70116999999993,
							27.770940000000053
						],
						[
							-82.70169988399994,
							27.77093579500007
						],
						[
							-82.70242999999994,
							27.770930000000078
						],
						[
							-82.70306695999994,
							27.770930000000078
						],
						[
							-82.70388999999994,
							27.770930000000078
						],
						[
							-82.70451461999994,
							27.77092566200008
						],
						[
							-82.70532999999995,
							27.770920000000046
						],
						[
							-82.70596207299991,
							27.770915352000088
						],
						[
							-82.70668999999992,
							27.770910000000075
						],
						[
							-82.70732910499993,
							27.770910000000075
						],
						[
							-82.70802999999995,
							27.770910000000075
						],
						[
							-82.70893746099995,
							27.770910000000075
						],
						[
							-82.71009011599995,
							27.770910000000075
						],
						[
							-82.71151082299991,
							27.770904553000037
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Live Oak",
				"RegionID": "416373"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.73452999999995,
					27.76457000000005,
					-82.71212899999995,
					27.770899142000076
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.71221998899995,
							27.770899142000076
						],
						[
							-82.71221563299993,
							27.770557428000075
						],
						[
							-82.71221082699992,
							27.770235428000035
						],
						[
							-82.71221190099993,
							27.769511649000037
						],
						[
							-82.71220268799993,
							27.76892206200006
						],
						[
							-82.71219808199993,
							27.768627269000035
						],
						[
							-82.71218999999991,
							27.768110000000036
						],
						[
							-82.71218999999991,
							27.76768890900007
						],
						[
							-82.71215999999993,
							27.767280000000085
						],
						[
							-82.71215592199991,
							27.767098537000038
						],
						[
							-82.71214568699992,
							27.766643066000086
						],
						[
							-82.71213999999992,
							27.766390000000058
						],
						[
							-82.71213494199992,
							27.765919636000035
						],
						[
							-82.71212999999995,
							27.765460000000076
						],
						[
							-82.71212999999995,
							27.765222763000057
						],
						[
							-82.71212999999995,
							27.76502000000005
						],
						[
							-82.71212999999995,
							27.764874286000065
						],
						[
							-82.71212899999995,
							27.764586000000065
						],
						[
							-82.71212899999995,
							27.764574384000074
						],
						[
							-82.71252363799994,
							27.76457000000005
						],
						[
							-82.71521919999992,
							27.76457000000005
						],
						[
							-82.71566845999992,
							27.76457000000005
						],
						[
							-82.71638727599992,
							27.76457000000005
						],
						[
							-82.71733072299992,
							27.76457000000005
						],
						[
							-82.71791476099992,
							27.764580000000084
						],
						[
							-82.71819999999991,
							27.76461000000006
						],
						[
							-82.71863581699995,
							27.764701023000047
						],
						[
							-82.71906943399995,
							27.76480885400008
						],
						[
							-82.7195769249999,
							27.76493505500008
						],
						[
							-82.71989413499995,
							27.76501393800004
						],
						[
							-82.72019999999992,
							27.765090000000043
						],
						[
							-82.72064297599991,
							27.765240368000036
						],
						[
							-82.72131531999992,
							27.76546876500004
						],
						[
							-82.72186618299992,
							27.765659448000065
						],
						[
							-82.72235999999992,
							27.765840000000082
						],
						[
							-82.72282054199991,
							27.765984742000057
						],
						[
							-82.72348525299992,
							27.766193651000037
						],
						[
							-82.72424999999993,
							27.76642000000004
						],
						[
							-82.72470383799993,
							27.766582242000084
						],
						[
							-82.72523882299993,
							27.766773492000084
						],
						[
							-82.72574821199993,
							27.76695559300009
						],
						[
							-82.72604129899992,
							27.767060368000045
						],
						[
							-82.7267101779999,
							27.76729909700009
						],
						[
							-82.72708589899992,
							27.767433040000075
						],
						[
							-82.72776906299993,
							27.76767658400007
						],
						[
							-82.72861166699994,
							27.767976969000074
						],
						[
							-82.72906710899991,
							27.76813933200009
						],
						[
							-82.72938875999996,
							27.768253999000084
						],
						[
							-82.72969524199995,
							27.768357793000064
						],
						[
							-82.72973999999994,
							27.76837000000006
						],
						[
							-82.73018214799993,
							27.768521186000044
						],
						[
							-82.73074630899993,
							27.768714093000085
						],
						[
							-82.73132071999993,
							27.768912021000062
						],
						[
							-82.73174759099993,
							27.769079057000056
						],
						[
							-82.73212025599992,
							27.76922488300005
						],
						[
							-82.73243999999995,
							27.769350000000088
						],
						[
							-82.73236998399994,
							27.769574658000067
						],
						[
							-82.73231509999994,
							27.769722424000065
						],
						[
							-82.73220999999995,
							27.769960000000083
						],
						[
							-82.73265049499992,
							27.769960000000083
						],
						[
							-82.73349999999994,
							27.769960000000083
						],
						[
							-82.73380471099995,
							27.770207577000065
						],
						[
							-82.73419738799993,
							27.77053599700008
						],
						[
							-82.73452999999995,
							27.770830000000046
						],
						[
							-82.73452856099993,
							27.77083001200009
						],
						[
							-82.73363906599991,
							27.77083765100008
						],
						[
							-82.73310002199992,
							27.770843708000086
						],
						[
							-82.73229108699991,
							27.770850000000053
						],
						[
							-82.73180999999994,
							27.770850000000053
						],
						[
							-82.73161999999991,
							27.770840000000078
						],
						[
							-82.73071867599992,
							27.770840000000078
						],
						[
							-82.7299799999999,
							27.770800000000065
						],
						[
							-82.72919180199995,
							27.77085448100007
						],
						[
							-82.7286970049999,
							27.770860000000084
						],
						[
							-82.72837012699995,
							27.770860000000084
						],
						[
							-82.72836999999993,
							27.770860000000084
						],
						[
							-82.72748359799995,
							27.770855546000064
						],
						[
							-82.72634999999991,
							27.77081000000004
						],
						[
							-82.7253277239999,
							27.77085496300009
						],
						[
							-82.72428999999994,
							27.77081000000004
						],
						[
							-82.7231264109999,
							27.770865877000066
						],
						[
							-82.72231999999993,
							27.77082000000007
						],
						[
							-82.72128421199994,
							27.77087000000006
						],
						[
							-82.72074509999993,
							27.77087000000006
						],
						[
							-82.72023999999993,
							27.77082000000007
						],
						[
							-82.71935239299995,
							27.77087000000006
						],
						[
							-82.71821999999992,
							27.770830000000046
						],
						[
							-82.7178257939999,
							27.77087620800006
						],
						[
							-82.71733102299993,
							27.770884000000084
						],
						[
							-82.7166568319999,
							27.770890000000065
						],
						[
							-82.7161999999999,
							27.770890000000065
						],
						[
							-82.71566856699991,
							27.77088745700007
						],
						[
							-82.71517439199994,
							27.77088509300006
						],
						[
							-82.71476963699992,
							27.77088315600008
						],
						[
							-82.71342287099992,
							27.77088727100005
						],
						[
							-82.71310747299992,
							27.77089060900005
						],
						[
							-82.71256842199995,
							27.770896313000037
						],
						[
							-82.71221998899995,
							27.770899142000076
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Pasadena Bear Creek Estates",
				"RegionID": "416374"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.05655744299992,
					26.745760000000075,
					-80.05243999999993,
					26.749259731000052
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.05255999999991,
							26.745900000000063
						],
						[
							-80.05256353099992,
							26.745769341000084
						],
						[
							-80.0528187999999,
							26.745773972000052
						],
						[
							-80.0530599999999,
							26.745760000000075
						],
						[
							-80.05322909699994,
							26.745774000000043
						],
						[
							-80.05357567099992,
							26.74577402300008
						],
						[
							-80.0539215359999,
							26.745793521000053
						],
						[
							-80.05454322499992,
							26.74579417700005
						],
						[
							-80.05494748599995,
							26.74580540800008
						],
						[
							-80.05561405299994,
							26.745821144000047
						],
						[
							-80.05601710799993,
							26.745820558000048
						],
						[
							-80.0562290439999,
							26.745831614000053
						],
						[
							-80.05655744299992,
							26.745841590000055
						],
						[
							-80.05655727599994,
							26.74584628000008
						],
						[
							-80.0565499999999,
							26.746050000000082
						],
						[
							-80.05651999999992,
							26.746890001000054
						],
						[
							-80.05648999999994,
							26.747640000000047
						],
						[
							-80.0564599999999,
							26.748540000000048
						],
						[
							-80.0564599999999,
							26.748950000000036
						],
						[
							-80.05645999899991,
							26.749259731000052
						],
						[
							-80.0562041949999,
							26.749249470000052
						],
						[
							-80.05561491599991,
							26.749238501000036
						],
						[
							-80.05525653799992,
							26.74922345400006
						],
						[
							-80.0545899999999,
							26.749190000000056
						],
						[
							-80.05412392499994,
							26.749169736000056
						],
						[
							-80.05343999999991,
							26.749140000000068
						],
						[
							-80.05325475399991,
							26.749133010000037
						],
						[
							-80.05271472899994,
							26.749118661000068
						],
						[
							-80.05256507799993,
							26.74911253500005
						],
						[
							-80.05251940399995,
							26.748997074000044
						],
						[
							-80.05246980699991,
							26.748838167000088
						],
						[
							-80.05243999999993,
							26.748492286000044
						],
						[
							-80.0524519519999,
							26.748186891000046
						],
						[
							-80.05248256599992,
							26.74767161400007
						],
						[
							-80.05245987799994,
							26.74734013200009
						],
						[
							-80.05251488199991,
							26.74662770900005
						],
						[
							-80.0525199999999,
							26.74656000100009
						],
						[
							-80.05255999999991,
							26.745900000000063
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "West Palm Beach",
				"Name": "Northboro Park",
				"RegionID": "416909"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.53381874399992,
					27.32601068000008,
					-82.5321294609999,
					27.32833663200006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.53247045799992,
							27.326641118000058
						],
						[
							-82.5324662829999,
							27.32601068000008
						],
						[
							-82.53251431399991,
							27.326024689000064
						],
						[
							-82.53297907699994,
							27.326224951000086
						],
						[
							-82.53333150799995,
							27.326448606000042
						],
						[
							-82.53360216899996,
							27.326663194000048
						],
						[
							-82.53381874399992,
							27.32670175900006
						],
						[
							-82.53381673699994,
							27.326731188000053
						],
						[
							-82.5338141439999,
							27.326769222000053
						],
						[
							-82.53381026499994,
							27.326826114000085
						],
						[
							-82.53379999999993,
							27.326901602000078
						],
						[
							-82.53379915599993,
							27.32702003500009
						],
						[
							-82.53379767299992,
							27.327143155000044
						],
						[
							-82.53379681699994,
							27.32721418600005
						],
						[
							-82.5337956759999,
							27.327308894000055
						],
						[
							-82.53379385099993,
							27.32746036900005
						],
						[
							-82.53379265199993,
							27.327559869000083
						],
						[
							-82.53379099699993,
							27.327697252000064
						],
						[
							-82.5337899999999,
							27.327780000000075
						],
						[
							-82.53378699599995,
							27.327844076000076
						],
						[
							-82.5337812059999,
							27.32796760900004
						],
						[
							-82.5337738959999,
							27.328123557000083
						],
						[
							-82.53376922299992,
							27.328223239000067
						],
						[
							-82.53376500399992,
							27.328313249000075
						],
						[
							-82.53214366899994,
							27.32833663200006
						],
						[
							-82.5321294609999,
							27.327706735000053
						],
						[
							-82.53215787799991,
							27.32710525300007
						],
						[
							-82.53247045799992,
							27.326641118000058
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Central Park",
				"RegionID": "417073"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.53471474899993,
					27.32533989600006,
					-82.53382186499994,
					27.326730097000052
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.5338333059999,
							27.326704352000036
						],
						[
							-82.53382186499994,
							27.32533989600006
						],
						[
							-82.53469969799994,
							27.32533989600006
						],
						[
							-82.53471474899993,
							27.32671560400007
						],
						[
							-82.53436476899992,
							27.326684280000052
						],
						[
							-82.53400552399995,
							27.326730097000052
						],
						[
							-82.5338333059999,
							27.326704352000036
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Lincoln Park",
				"RegionID": "417074"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.5428856019999,
					27.322500409000043,
					-82.53784686799992,
					27.32846321100004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.53977367899995,
							27.32844376500009
						],
						[
							-82.5397299999999,
							27.328440000000057
						],
						[
							-82.53962886199992,
							27.32844158000006
						],
						[
							-82.53943849299992,
							27.32844455500009
						],
						[
							-82.53918800899993,
							27.32844846900008
						],
						[
							-82.53896758199994,
							27.328451913000038
						],
						[
							-82.53879709599994,
							27.32845457700006
						],
						[
							-82.53861658999995,
							27.32845739700008
						],
						[
							-82.5384499999999,
							27.328460000000064
						],
						[
							-82.53845249499994,
							27.32827283800009
						],
						[
							-82.53845489999992,
							27.32809247700004
						],
						[
							-82.5384582399999,
							27.32784197600006
						],
						[
							-82.53846434199994,
							27.327672370000073
						],
						[
							-82.5384817229999,
							27.32752173500006
						],
						[
							-82.53848468199993,
							27.327370237000082
						],
						[
							-82.5384753699999,
							27.32723055200006
						],
						[
							-82.5384647379999,
							27.327130707000038
						],
						[
							-82.53845132399994,
							27.32708152300006
						],
						[
							-82.53843999999992,
							27.327040000000068
						],
						[
							-82.53840732499992,
							27.32695558900008
						],
						[
							-82.53835356099995,
							27.326816698000073
						],
						[
							-82.53829891899994,
							27.326687837000065
						],
						[
							-82.53822676199991,
							27.326543523000055
						],
						[
							-82.53818048699993,
							27.326441096000053
						],
						[
							-82.5381448149999,
							27.32634036400009
						],
						[
							-82.53800512099991,
							27.326049498000092
						],
						[
							-82.53796669099995,
							27.325968794000065
						],
						[
							-82.53789838599994,
							27.325764231000054
						],
						[
							-82.53784686799992,
							27.32286000000005
						],
						[
							-82.5386571549999,
							27.32286000000005
						],
						[
							-82.53913192599992,
							27.322500409000043
						],
						[
							-82.53960547799994,
							27.322679306000058
						],
						[
							-82.54047891699992,
							27.322763493000082
						],
						[
							-82.54111031899993,
							27.322795063000058
						],
						[
							-82.54186800199994,
							27.322752970000067
						],
						[
							-82.54239416999991,
							27.322847680000052
						],
						[
							-82.54286670999994,
							27.323134632000063
						],
						[
							-82.54287918499995,
							27.323206197000047
						],
						[
							-82.54288549799992,
							27.323278567000045
						],
						[
							-82.5428856019999,
							27.323351211000045
						],
						[
							-82.5428794959999,
							27.32342359800009
						],
						[
							-82.54283582599993,
							27.323775758000068
						],
						[
							-82.54276215599992,
							27.324318918000074
						],
						[
							-82.54275665999995,
							27.324354165000045
						],
						[
							-82.54271608699992,
							27.324505586000043
						],
						[
							-82.5426498359999,
							27.324647661000085
						],
						[
							-82.5425599209999,
							27.324776073000066
						],
						[
							-82.54244907299994,
							27.32488692000004
						],
						[
							-82.5423206609999,
							27.324976836000076
						],
						[
							-82.54217858599993,
							27.32504308600005
						],
						[
							-82.54214890799994,
							27.32505330500004
						],
						[
							-82.54199656199995,
							27.325102806000075
						],
						[
							-82.54196170099993,
							27.32604041400009
						],
						[
							-82.5419486589999,
							27.326163165000082
						],
						[
							-82.5419207089999,
							27.326277396000084
						],
						[
							-82.54166294899996,
							27.327095022000037
						],
						[
							-82.5415805849999,
							27.327645164000046
						],
						[
							-82.5417172729999,
							27.32795982100004
						],
						[
							-82.54089698899992,
							27.328328664000082
						],
						[
							-82.54000624199995,
							27.328293418000044
						],
						[
							-82.5399992529999,
							27.32846321100004
						],
						[
							-82.53988854799991,
							27.328453668000066
						],
						[
							-82.5398130509999,
							27.328447160000053
						],
						[
							-82.53977367899995,
							27.32844376500009
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Baypoint Park",
				"RegionID": "417075"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.74780867899995,
					27.76993559200008,
					-82.73349999999994,
					27.77733180000007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.74244368699993,
							27.777232776000062
						],
						[
							-82.74207999999993,
							27.77723000000009
						],
						[
							-82.74188913599994,
							27.77723000000009
						],
						[
							-82.74147770299993,
							27.77723000000009
						],
						[
							-82.7410304949999,
							27.77723000000009
						],
						[
							-82.74069999999995,
							27.77723000000009
						],
						[
							-82.74018991999992,
							27.777222443000085
						],
						[
							-82.73963497199992,
							27.777214222000055
						],
						[
							-82.73920580599992,
							27.777208924000035
						],
						[
							-82.73891947499993,
							27.77720678700007
						],
						[
							-82.73823975499994,
							27.777201715000047
						],
						[
							-82.7377389099999,
							27.777197992000083
						],
						[
							-82.7370234149999,
							27.777192692000085
						],
						[
							-82.73665999999992,
							27.77719000000008
						],
						[
							-82.73665999999992,
							27.77657049900006
						],
						[
							-82.73664710999992,
							27.77585173600005
						],
						[
							-82.73663222599993,
							27.77549338700004
						],
						[
							-82.73662108299993,
							27.775133107000045
						],
						[
							-82.73662678599993,
							27.77472822100009
						],
						[
							-82.73662119799991,
							27.774367976000065
						],
						[
							-82.7365999939999,
							27.774054912000054
						],
						[
							-82.73658462899994,
							27.773828278000053
						],
						[
							-82.73652888599992,
							27.773479991000045
						],
						[
							-82.73643175199993,
							27.773167774000058
						],
						[
							-82.73631409699993,
							27.77289032500005
						],
						[
							-82.7361671829999,
							27.772590752000042
						],
						[
							-82.73601721099993,
							27.772329932000048
						],
						[
							-82.73586773099993,
							27.772136971000066
						],
						[
							-82.73556705099992,
							27.77176705100004
						],
						[
							-82.7352928439999,
							27.77149828800009
						],
						[
							-82.73505365699992,
							27.77129419700009
						],
						[
							-82.73479504999995,
							27.771057599000073
						],
						[
							-82.73452856099993,
							27.77083001200009
						],
						[
							-82.73452999999995,
							27.770830000000046
						],
						[
							-82.73419738799993,
							27.77053599700008
						],
						[
							-82.73380471099995,
							27.770207577000065
						],
						[
							-82.73349999999994,
							27.769960000000083
						],
						[
							-82.73431275799993,
							27.769950000000055
						],
						[
							-82.73507649999993,
							27.769950000000055
						],
						[
							-82.73543577599992,
							27.769948614000043
						],
						[
							-82.7359299339999,
							27.769944926000054
						],
						[
							-82.73624473399991,
							27.76994257700005
						],
						[
							-82.73658999999992,
							27.769940000000076
						],
						[
							-82.73691830999991,
							27.769942450000087
						],
						[
							-82.7373678809999,
							27.769945805000077
						],
						[
							-82.73754757499995,
							27.76994714600005
						],
						[
							-82.73792999999995,
							27.769950000000055
						],
						[
							-82.73831117299994,
							27.769950000000055
						],
						[
							-82.73894013799992,
							27.769950000000055
						],
						[
							-82.73927999999995,
							27.769950000000055
						],
						[
							-82.73956898799992,
							27.769948182000064
						],
						[
							-82.73979360899996,
							27.76994677000005
						],
						[
							-82.74024313399991,
							27.769943943000044
						],
						[
							-82.7406474519999,
							27.76994140000005
						],
						[
							-82.74123151499992,
							27.769937671000037
						],
						[
							-82.74145602699991,
							27.76993559200008
						],
						[
							-82.74147070899994,
							27.770053048000083
						],
						[
							-82.74212087899991,
							27.770203956000046
						],
						[
							-82.74216104599992,
							27.77035313900007
						],
						[
							-82.74220096899991,
							27.770471829000087
						],
						[
							-82.74226809599992,
							27.770598626000037
						],
						[
							-82.74232373099994,
							27.77069782500007
						],
						[
							-82.74243235499996,
							27.77086765000007
						],
						[
							-82.74250655399993,
							27.77097364800005
						],
						[
							-82.74261003999993,
							27.771112119000065
						],
						[
							-82.74272513599993,
							27.771254997000085
						],
						[
							-82.74288980999995,
							27.771459419000053
						],
						[
							-82.7430714919999,
							27.77168495600006
						],
						[
							-82.74328961999993,
							27.771948957000063
						],
						[
							-82.74351995299992,
							27.77222445400008
						],
						[
							-82.74371600799992,
							27.77246100900004
						],
						[
							-82.74393334099994,
							27.772727737000086
						],
						[
							-82.74408999999991,
							27.772920000000056
						],
						[
							-82.74388265699992,
							27.773044406000054
						],
						[
							-82.74363138699995,
							27.77319516800009
						],
						[
							-82.74392688099994,
							27.773565880000035
						],
						[
							-82.74434841999994,
							27.774060486000053
						],
						[
							-82.74459572399991,
							27.774375236000083
						],
						[
							-82.74468565199993,
							27.774504508000064
						],
						[
							-82.74502700999994,
							27.77502491300004
						],
						[
							-82.74524208499992,
							27.775285762000067
						],
						[
							-82.74590535699991,
							27.774829498000088
						],
						[
							-82.74590899999993,
							27.774834000000055
						],
						[
							-82.74665604299992,
							27.774320111000065
						],
						[
							-82.74676787899995,
							27.774444964000054
						],
						[
							-82.74681875999994,
							27.774507147000065
						],
						[
							-82.74686388799995,
							27.774573623000038
						],
						[
							-82.74690290299992,
							27.774643861000072
						],
						[
							-82.74693549299991,
							27.774717301000067
						],
						[
							-82.74696139799994,
							27.77479335700008
						],
						[
							-82.74698460499991,
							27.774872980000055
						],
						[
							-82.74704510899994,
							27.774908105000065
						],
						[
							-82.74710262699996,
							27.774947930000053
						],
						[
							-82.7471567959999,
							27.774992204000057
						],
						[
							-82.7472072729999,
							27.775040645000047
						],
						[
							-82.74731627199992,
							27.775153646000035
						],
						[
							-82.74740316099991,
							27.77525859000008
						],
						[
							-82.74750716199992,
							27.775405590000048
						],
						[
							-82.7475518359999,
							27.775475339000085
						],
						[
							-82.7476185559999,
							27.77561871000006
						],
						[
							-82.74773402499996,
							27.77593900700009
						],
						[
							-82.7477736589999,
							27.776087835000055
						],
						[
							-82.74778572899993,
							27.77619049300006
						],
						[
							-82.74780372899994,
							27.776492493000035
						],
						[
							-82.74780530899994,
							27.776541123000072
						],
						[
							-82.74780867899995,
							27.77716269600006
						],
						[
							-82.74691026099993,
							27.77733180000007
						],
						[
							-82.74563626299994,
							27.777320058000043
						],
						[
							-82.74562999999995,
							27.77732000000009
						],
						[
							-82.74544802999992,
							27.777282844000073
						],
						[
							-82.7452153719999,
							27.777266517000044
						],
						[
							-82.74475129599995,
							27.77724856200007
						],
						[
							-82.74432187999992,
							27.77724586100004
						],
						[
							-82.74394623899991,
							27.777243498000075
						],
						[
							-82.74338999999992,
							27.777240000000063
						],
						[
							-82.74312340499995,
							27.77723796500004
						],
						[
							-82.74244368699993,
							27.777232776000062
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Historic Park Street",
				"RegionID": "417123"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.73671999999993,
					27.777130000000056,
					-82.7143299999999,
					27.78088000000008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.73189676099992,
							27.780844099000035
						],
						[
							-82.73105434099995,
							27.78084000000007
						],
						[
							-82.72941917799994,
							27.78084000000007
						],
						[
							-82.72846079399994,
							27.780841726000062
						],
						[
							-82.7277344229999,
							27.780843034000043
						],
						[
							-82.7267927339999,
							27.780847913000063
						],
						[
							-82.72602506599992,
							27.780844711000043
						],
						[
							-82.7253562759999,
							27.78083501800006
						],
						[
							-82.72483538799992,
							27.78082746900009
						],
						[
							-82.72389415499993,
							27.780815320000045
						],
						[
							-82.7233493139999,
							27.780810410000072
						],
						[
							-82.72285383299993,
							27.78081375800008
						],
						[
							-82.7220610629999,
							27.780819114000057
						],
						[
							-82.72154066399993,
							27.780820000000062
						],
						[
							-82.72082218299994,
							27.780820000000062
						],
						[
							-82.71978089099991,
							27.78082707200008
						],
						[
							-82.71906257299992,
							27.78083790100004
						],
						[
							-82.71866663299994,
							27.78084387000007
						],
						[
							-82.71770067299991,
							27.780853411000066
						],
						[
							-82.71690789599995,
							27.780858245000047
						],
						[
							-82.71604056899992,
							27.780860000000075
						],
						[
							-82.71556983999994,
							27.780860000000075
						],
						[
							-82.71514866099994,
							27.780860000000075
						],
						[
							-82.71477703299992,
							27.780860000000075
						],
						[
							-82.71440999999993,
							27.78080000000006
						],
						[
							-82.71438636599993,
							27.78066765200009
						],
						[
							-82.7143593099999,
							27.780479264000064
						],
						[
							-82.71435552399994,
							27.780255932000046
						],
						[
							-82.71434999999992,
							27.779930000000036
						],
						[
							-82.71434711699993,
							27.77966183500007
						],
						[
							-82.71434418599995,
							27.77938934000008
						],
						[
							-82.71434151999995,
							27.779141350000092
						],
						[
							-82.71433999999994,
							27.779000000000053
						],
						[
							-82.71433731799993,
							27.778546820000088
						],
						[
							-82.7143327739999,
							27.77777881600008
						],
						[
							-82.71433086799995,
							27.777456750000056
						],
						[
							-82.7143299999999,
							27.777150000000063
						],
						[
							-82.7147250129999,
							27.777150000000063
						],
						[
							-82.71544382999991,
							27.777150000000063
						],
						[
							-82.71622999999994,
							27.777150000000063
						],
						[
							-82.71679072899991,
							27.777159837000056
						],
						[
							-82.71710693399991,
							27.77715420900006
						],
						[
							-82.71773567399993,
							27.777142346000062
						],
						[
							-82.71823999999994,
							27.777140000000088
						],
						[
							-82.71881300599995,
							27.777144512000064
						],
						[
							-82.71975672799995,
							27.777150000000063
						],
						[
							-82.72026999999991,
							27.777150000000063
						],
						[
							-82.72056576699993,
							27.777147072000048
						],
						[
							-82.72128451299994,
							27.777139955000052
						],
						[
							-82.7219134149999,
							27.77713372900007
						],
						[
							-82.72228999999993,
							27.777130000000056
						],
						[
							-82.72285650799995,
							27.777132804000075
						],
						[
							-82.72362023199992,
							27.77713658500005
						],
						[
							-82.72430999999995,
							27.777140000000088
						],
						[
							-82.72460873799992,
							27.777140000000088
						],
						[
							-82.72537247999992,
							27.777140000000088
						],
						[
							-82.72595651799992,
							27.777140000000088
						],
						[
							-82.72637999999995,
							27.777140000000088
						],
						[
							-82.72830999999991,
							27.777130000000056
						],
						[
							-82.72905620599994,
							27.777134887000045
						],
						[
							-82.7300449299999,
							27.777147848000084
						],
						[
							-82.7313028069999,
							27.777168292000056
						],
						[
							-82.73292005099995,
							27.777160000000038
						],
						[
							-82.7334591629999,
							27.777160000000038
						],
						[
							-82.73431275799993,
							27.777160000000038
						],
						[
							-82.7348069439999,
							27.777160000000038
						],
						[
							-82.7355700889999,
							27.777179027000045
						],
						[
							-82.7362446759999,
							27.777194585000075
						],
						[
							-82.73665999999992,
							27.77719000000008
						],
						[
							-82.73665999999992,
							27.777704500000088
						],
						[
							-82.73665999999992,
							27.778180000000077
						],
						[
							-82.73667034399995,
							27.778447910000068
						],
						[
							-82.73667748799994,
							27.77881940000009
						],
						[
							-82.73667999999992,
							27.77902000000006
						],
						[
							-82.73668645999993,
							27.779364254000086
						],
						[
							-82.73669433899994,
							27.779710927000053
						],
						[
							-82.73669999999993,
							27.779960000000074
						],
						[
							-82.73670624099992,
							27.780231498000035
						],
						[
							-82.73671534899995,
							27.780627692000053
						],
						[
							-82.73671999999993,
							27.78088000000008
						],
						[
							-82.73630671399991,
							27.780873738000082
						],
						[
							-82.7357616669999,
							27.780868470000087
						],
						[
							-82.7351670779999,
							27.780865421000048
						],
						[
							-82.73484488199995,
							27.780863769000064
						],
						[
							-82.73434939099991,
							27.78086122800005
						],
						[
							-82.7338291179999,
							27.780858211000066
						],
						[
							-82.73291247299996,
							27.780852372000084
						],
						[
							-82.73189676099992,
							27.780844099000035
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Eagle Crest",
				"RegionID": "417124"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.74765932799994,
					27.77719000000008,
					-82.73665999999992,
					27.79224000000005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.74372509599993,
							27.791799929000035
						],
						[
							-82.74330999999995,
							27.791780000000074
						],
						[
							-82.74287182599994,
							27.791780000000074
						],
						[
							-82.74243999999993,
							27.791780000000074
						],
						[
							-82.74206701999992,
							27.791780000000074
						],
						[
							-82.74157999999994,
							27.791780000000074
						],
						[
							-82.7412119139999,
							27.791780000000074
						],
						[
							-82.74066999999991,
							27.791780000000074
						],
						[
							-82.73990411999995,
							27.79177428400004
						],
						[
							-82.73932999999994,
							27.791770000000046
						],
						[
							-82.7387471959999,
							27.791770000000046
						],
						[
							-82.73769088799992,
							27.791770000000046
						],
						[
							-82.7369799999999,
							27.791770000000046
						],
						[
							-82.73696614999994,
							27.79117330600008
						],
						[
							-82.73695445399994,
							27.790669407000053
						],
						[
							-82.73693344999992,
							27.78976448800006
						],
						[
							-82.73691828099993,
							27.789110935000053
						],
						[
							-82.73689605599992,
							27.788153409000074
						],
						[
							-82.73687271799992,
							27.787147943000036
						],
						[
							-82.73686726799991,
							27.78691314300005
						],
						[
							-82.73686104899991,
							27.786645211000064
						],
						[
							-82.7368351319999,
							27.785237410000036
						],
						[
							-82.73682239499993,
							27.784883954000065
						],
						[
							-82.73680999999993,
							27.78454000000005
						],
						[
							-82.73679776499995,
							27.78397953700005
						],
						[
							-82.73678659599994,
							27.78357744400006
						],
						[
							-82.73676282199995,
							27.782721601000052
						],
						[
							-82.7367373649999,
							27.781765633000077
						],
						[
							-82.73671999999993,
							27.78088000000008
						],
						[
							-82.73671534899995,
							27.780627692000053
						],
						[
							-82.73670624099992,
							27.780231498000035
						],
						[
							-82.73669999999993,
							27.779960000000074
						],
						[
							-82.73669433899994,
							27.779710927000053
						],
						[
							-82.73668645999993,
							27.779364254000086
						],
						[
							-82.73667999999992,
							27.77902000000006
						],
						[
							-82.73667748799994,
							27.77881940000009
						],
						[
							-82.73667034399995,
							27.778447910000068
						],
						[
							-82.73665999999992,
							27.778180000000077
						],
						[
							-82.73665999999992,
							27.777704500000088
						],
						[
							-82.73665999999992,
							27.77719000000008
						],
						[
							-82.7370234149999,
							27.777192692000085
						],
						[
							-82.7377389099999,
							27.777197992000083
						],
						[
							-82.73823975499994,
							27.777201715000047
						],
						[
							-82.73891947499993,
							27.77720678700007
						],
						[
							-82.73920580599992,
							27.777208924000035
						],
						[
							-82.73963497199992,
							27.777214222000055
						],
						[
							-82.74018991999992,
							27.777222443000085
						],
						[
							-82.74069999999995,
							27.77723000000009
						],
						[
							-82.7410304949999,
							27.77723000000009
						],
						[
							-82.74147770299993,
							27.77723000000009
						],
						[
							-82.74188913599994,
							27.77723000000009
						],
						[
							-82.74207999999993,
							27.77723000000009
						],
						[
							-82.74244368699993,
							27.777232776000062
						],
						[
							-82.74312340499995,
							27.77723796500004
						],
						[
							-82.74338999999992,
							27.777240000000063
						],
						[
							-82.74394623899991,
							27.777243498000075
						],
						[
							-82.74432187999992,
							27.77724586100004
						],
						[
							-82.74475129599995,
							27.77724856200007
						],
						[
							-82.7452153719999,
							27.777266517000044
						],
						[
							-82.74544802999992,
							27.777282844000073
						],
						[
							-82.74562999999995,
							27.77732000000009
						],
						[
							-82.74563626299994,
							27.777320058000043
						],
						[
							-82.74563420899995,
							27.777461548000076
						],
						[
							-82.74564372999993,
							27.777588595000054
						],
						[
							-82.74566094099993,
							27.777720547000058
						],
						[
							-82.74567763199991,
							27.777825109000048
						],
						[
							-82.74570626299993,
							27.777956809000045
						],
						[
							-82.74574282499992,
							27.778124994000052
						],
						[
							-82.74576700599994,
							27.778236227000036
						],
						[
							-82.74579485899994,
							27.778342335000048
						],
						[
							-82.74583004099992,
							27.778473009000038
						],
						[
							-82.74584073299991,
							27.778512933000062
						],
						[
							-82.74593061999991,
							27.778725930000064
						],
						[
							-82.74603284499995,
							27.778879267000036
						],
						[
							-82.74610868799994,
							27.778993033000063
						],
						[
							-82.74618453199992,
							27.779106798000043
						],
						[
							-82.74621999999995,
							27.77916000000005
						],
						[
							-82.74605325899995,
							27.779252392000046
						],
						[
							-82.74588387099993,
							27.779342068000066
						],
						[
							-82.7457975449999,
							27.779390599000067
						],
						[
							-82.74566694099993,
							27.77946678400008
						],
						[
							-82.7455523299999,
							27.779533641000057
						],
						[
							-82.74543512299994,
							27.77962487700006
						],
						[
							-82.74531822799992,
							27.77974540000008
						],
						[
							-82.74521307099991,
							27.779870393000067
						],
						[
							-82.74509435899995,
							27.78004846200008
						],
						[
							-82.74500214499994,
							27.78022397500007
						],
						[
							-82.74492529599992,
							27.780426465000062
						],
						[
							-82.74483965999991,
							27.780623957000046
						],
						[
							-82.74478331799992,
							27.780712403000052
						],
						[
							-82.7447499999999,
							27.780760000000043
						],
						[
							-82.74470163699993,
							27.780808363000062
						],
						[
							-82.74463104199992,
							27.780858271000056
						],
						[
							-82.74457685899995,
							27.780892342000072
						],
						[
							-82.74450881699994,
							27.78092863100005
						],
						[
							-82.74446115899991,
							27.78095404900006
						],
						[
							-82.74441303599991,
							27.780969241000037
						],
						[
							-82.74448999599991,
							27.78133792700004
						],
						[
							-82.74452318399995,
							27.781476212000086
						],
						[
							-82.74459509199994,
							27.781647685000053
						],
						[
							-82.74469465699991,
							27.781868940000038
						],
						[
							-82.74478869099994,
							27.78213444700009
						],
						[
							-82.7449103809999,
							27.782355703000064
						],
						[
							-82.74504313499995,
							27.782521644000045
						],
						[
							-82.74521460799991,
							27.78276502500006
						],
						[
							-82.74536948699995,
							27.782942030000072
						],
						[
							-82.74551883399994,
							27.783157754000058
						],
						[
							-82.74565711899993,
							27.78334582100007
						],
						[
							-82.74581752899991,
							27.783644516000038
						],
						[
							-82.74593921999991,
							27.78425296900008
						],
						[
							-82.7460885669999,
							27.78497204900009
						],
						[
							-82.74634854199991,
							27.785812821000036
						],
						[
							-82.7466140489999,
							27.786786345000053
						],
						[
							-82.74675233399995,
							27.787350547000074
						],
						[
							-82.74679105299992,
							27.787488831000076
						],
						[
							-82.7464149189999,
							27.787820715000066
						],
						[
							-82.74592815699992,
							27.788307477000046
						],
						[
							-82.74551883399994,
							27.788678080000068
						],
						[
							-82.74520907599992,
							27.789037620000045
						],
						[
							-82.74494910099992,
							27.789557571000046
						],
						[
							-82.74477762799995,
							27.789972425000087
						],
						[
							-82.7447057199999,
							27.79024346300008
						],
						[
							-82.7447057199999,
							27.790796602000057
						],
						[
							-82.74472784499994,
							27.791443774000072
						],
						[
							-82.74474997099992,
							27.791631841000083
						],
						[
							-82.74517588799995,
							27.791709281000067
						],
						[
							-82.7455575539999,
							27.79179225200005
						],
						[
							-82.7457566839999,
							27.79184756600006
						],
						[
							-82.74584518599994,
							27.791886285000093
						],
						[
							-82.74765270699993,
							27.79188631100004
						],
						[
							-82.74765475899994,
							27.79198583400006
						],
						[
							-82.74765749499994,
							27.79211853000004
						],
						[
							-82.74765932799994,
							27.79224000000005
						],
						[
							-82.74689585499993,
							27.79224000000005
						],
						[
							-82.74558804499993,
							27.79224000000005
						],
						[
							-82.74518232899993,
							27.79219872100009
						],
						[
							-82.74496130499995,
							27.792137730000036
						],
						[
							-82.74457778099992,
							27.791988582000045
						],
						[
							-82.74414999999993,
							27.79184000000004
						],
						[
							-82.74372509599993,
							27.791799929000035
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Azalea Homes",
				"RegionID": "417125"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.9822769999999,
					28.042007054000067,
					-81.96556493299994,
					28.05491110400004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.97041091099993,
							28.054812010000035
						],
						[
							-81.9700159109999,
							28.054517011000087
						],
						[
							-81.96985590999992,
							28.05440701000009
						],
						[
							-81.96969091099993,
							28.054293010000038
						],
						[
							-81.96894288699991,
							28.053738826000085
						],
						[
							-81.96891193399995,
							28.053781193000077
						],
						[
							-81.96805790999991,
							28.053143010000042
						],
						[
							-81.96775891099992,
							28.052905010000075
						],
						[
							-81.96745291099995,
							28.052662010000063
						],
						[
							-81.96722190999992,
							28.052432011000064
						],
						[
							-81.96705791099993,
							28.05226201000005
						],
						[
							-81.96679491099991,
							28.05195101000004
						],
						[
							-81.96646990999994,
							28.051517011000044
						],
						[
							-81.96633676499994,
							28.051307931000053
						],
						[
							-81.96640505699992,
							28.051305090000085
						],
						[
							-81.96631091099994,
							28.05114601100007
						],
						[
							-81.9661919109999,
							28.050899008000044
						],
						[
							-81.96600591099991,
							28.050459010000054
						],
						[
							-81.96587891099995,
							28.050124009000058
						],
						[
							-81.9657879099999,
							28.04978601000005
						],
						[
							-81.96566391099992,
							28.04913901000009
						],
						[
							-81.96563990999994,
							28.048896010000078
						],
						[
							-81.96562703799992,
							28.04862787500008
						],
						[
							-81.96556777799992,
							28.048629146000057
						],
						[
							-81.96556493299994,
							28.048451612000065
						],
						[
							-81.96558953699991,
							28.045344385000078
						],
						[
							-81.9658756419999,
							28.044342732000075
						],
						[
							-81.96656725199995,
							28.04355572700007
						],
						[
							-81.96709198199994,
							28.04329350800009
						],
						[
							-81.96772848199993,
							28.04296548600007
						],
						[
							-81.96788991099993,
							28.04293701000006
						],
						[
							-81.96966491099994,
							28.04260701000004
						],
						[
							-81.96986287199991,
							28.04256307500009
						],
						[
							-81.97001991099995,
							28.04252801000007
						],
						[
							-81.97107791099995,
							28.042293009000048
						],
						[
							-81.97254383899991,
							28.042007054000067
						],
						[
							-81.97300457999995,
							28.04352800600009
						],
						[
							-81.97806436599991,
							28.043527848000053
						],
						[
							-81.98037802899995,
							28.04300186800009
						],
						[
							-81.98037390999991,
							28.04374801000006
						],
						[
							-81.98034890899993,
							28.043877009000084
						],
						[
							-81.98027791099992,
							28.04405600800004
						],
						[
							-81.98018690999994,
							28.04419001000008
						],
						[
							-81.98010891399991,
							28.044327011000064
						],
						[
							-81.9800749119999,
							28.04450300900004
						],
						[
							-81.98006991099993,
							28.044746011000086
						],
						[
							-81.9800829109999,
							28.045114011000067
						],
						[
							-81.98009991099991,
							28.04555201000005
						],
						[
							-81.9801259109999,
							28.045735010000044
						],
						[
							-81.98015591099994,
							28.045874011000084
						],
						[
							-81.98019090999992,
							28.045961011000088
						],
						[
							-81.98029791099992,
							28.046178010000062
						],
						[
							-81.9806249099999,
							28.046713011000065
						],
						[
							-81.98067790999994,
							28.04683101100005
						],
						[
							-81.98072491099992,
							28.046938010000076
						],
						[
							-81.98077390799995,
							28.047085008000067
						],
						[
							-81.98078990999994,
							28.04723701000006
						],
						[
							-81.98080090999991,
							28.047376012000086
						],
						[
							-81.98076891099993,
							28.047664010000062
						],
						[
							-81.98073490599995,
							28.047888612000065
						],
						[
							-81.98196277499994,
							28.047942788000057
						],
						[
							-81.98195399999992,
							28.05035600000008
						],
						[
							-81.9820305579999,
							28.050358127000038
						],
						[
							-81.98224199999993,
							28.05036400000006
						],
						[
							-81.98227393999991,
							28.05084493000004
						],
						[
							-81.9822769999999,
							28.050891000000036
						],
						[
							-81.98204368599994,
							28.05089369700005
						],
						[
							-81.98193099999992,
							28.050895000000082
						],
						[
							-81.98199399999993,
							28.053146000000083
						],
						[
							-81.98211932399994,
							28.05413726000006
						],
						[
							-81.98213461799992,
							28.054776711000045
						],
						[
							-81.98178491099992,
							28.054778010000064
						],
						[
							-81.98135077799992,
							28.054780144000063
						],
						[
							-81.9813510429999,
							28.05473687600005
						],
						[
							-81.98053491099995,
							28.05476501000004
						],
						[
							-81.98034016299994,
							28.054765002000067
						],
						[
							-81.9793619109999,
							28.054755010000065
						],
						[
							-81.9783259109999,
							28.054758009000068
						],
						[
							-81.97734477699993,
							28.05475987500006
						],
						[
							-81.97734504199991,
							28.054819140000063
						],
						[
							-81.9766629099999,
							28.054825010000062
						],
						[
							-81.97618891099995,
							28.054842010000073
						],
						[
							-81.97527290999994,
							28.054845010000065
						],
						[
							-81.97419091099994,
							28.054850010000052
						],
						[
							-81.97232990999993,
							28.05485501000004
						],
						[
							-81.97173491099994,
							28.05487401000005
						],
						[
							-81.9712159099999,
							28.054890011000055
						],
						[
							-81.9708790119999,
							28.054900916000065
						],
						[
							-81.97054380899993,
							28.05491110400004
						],
						[
							-81.97046291099991,
							28.05485101100004
						],
						[
							-81.97041091099993,
							28.054812010000035
						]
					],
					[
						[
							-81.97614885899992,
							28.045929104000038
						],
						[
							-81.97605931299995,
							28.045911195000087
						],
						[
							-81.9760526199999,
							28.045914619000087
						],
						[
							-81.97604075999993,
							28.04592057700006
						],
						[
							-81.97598715599992,
							28.04594486500008
						],
						[
							-81.97593207799991,
							28.04596559500004
						],
						[
							-81.97587576199993,
							28.045982678000087
						],
						[
							-81.97583235399992,
							28.04599316200006
						],
						[
							-81.97576735299992,
							28.046007161000094
						],
						[
							-81.97575344899991,
							28.046010041000045
						],
						[
							-81.97569538499994,
							28.046019628000067
						],
						[
							-81.97563681799996,
							28.04602539600006
						],
						[
							-81.97557799999993,
							28.046027322000043
						],
						[
							-81.97551918099992,
							28.04602539600006
						],
						[
							-81.97546061499992,
							28.046019628000067
						],
						[
							-81.9754301559999,
							28.046015086000068
						],
						[
							-81.97536415699994,
							28.04600408600004
						],
						[
							-81.97533655099994,
							28.045999042000062
						],
						[
							-81.97527923899992,
							28.04598567800008
						],
						[
							-81.97527334099993,
							28.04598407600008
						],
						[
							-81.9746496489999,
							28.04661118000007
						],
						[
							-81.97464791699991,
							28.04661291700006
						],
						[
							-81.97461674599992,
							28.04664262900008
						],
						[
							-81.97445274599994,
							28.04679162900004
						],
						[
							-81.97444096399994,
							28.04680214600006
						],
						[
							-81.97441120199994,
							28.046827130000054
						],
						[
							-81.9743327999999,
							28.04689010900006
						],
						[
							-81.97432632199991,
							28.04689679100005
						],
						[
							-81.97430320799992,
							28.047006945000078
						],
						[
							-81.97429515499994,
							28.04718912800007
						],
						[
							-81.97438595699992,
							28.04755724200004
						],
						[
							-81.97467483799994,
							28.047931395000035
						],
						[
							-81.97467647999991,
							28.047933528000048
						],
						[
							-81.97471075899995,
							28.047981364000066
						],
						[
							-81.97474183599991,
							28.04803133900009
						],
						[
							-81.9747695769999,
							28.04808324000004
						],
						[
							-81.97477591699993,
							28.04809723200009
						],
						[
							-81.9747776609999,
							28.048098164000066
						],
						[
							-81.97482763599993,
							28.048129241000087
						],
						[
							-81.97487547199995,
							28.04816352000006
						],
						[
							-81.97492096399992,
							28.048200854000072
						],
						[
							-81.97496391599992,
							28.04824108300005
						],
						[
							-81.97500414599995,
							28.04828403500005
						],
						[
							-81.9750208339999,
							28.048303623000038
						],
						[
							-81.9750448339999,
							28.048332624000068
						],
						[
							-81.9750654799999,
							28.04835852800005
						],
						[
							-81.97509975899993,
							28.048406364000076
						],
						[
							-81.97513083599995,
							28.04845633900004
						],
						[
							-81.97515857699995,
							28.048508240000046
						],
						[
							-81.97518286499991,
							28.04856184500005
						],
						[
							-81.97520359499993,
							28.048616923000054
						],
						[
							-81.97520853299994,
							28.04863190000009
						],
						[
							-81.97521653299992,
							28.048656900000083
						],
						[
							-81.97522867899994,
							28.04869823900009
						],
						[
							-81.97524204199993,
							28.048755551000056
						],
						[
							-81.9752516289999,
							28.048813615000086
						],
						[
							-81.97525739699995,
							28.048872182000082
						],
						[
							-81.97525932199996,
							28.04893100000004
						],
						[
							-81.97525739699995,
							28.04898981900004
						],
						[
							-81.97525711499993,
							28.04899397300005
						],
						[
							-81.97526302099993,
							28.04900997900006
						],
						[
							-81.9753363239999,
							28.04917040500004
						],
						[
							-81.9753524269999,
							28.04919327300007
						],
						[
							-81.9753728149999,
							28.04921211700008
						],
						[
							-81.97537572999994,
							28.049214199000062
						],
						[
							-81.97537721599993,
							28.049215263000065
						],
						[
							-81.97538008299995,
							28.049217320000082
						],
						[
							-81.9755342499999,
							28.049302420000064
						],
						[
							-81.97568548099991,
							28.049362676000044
						],
						[
							-81.9770856049999,
							28.049726005000082
						],
						[
							-81.97765854999994,
							28.04943524500004
						],
						[
							-81.97831388799995,
							28.048667244000058
						],
						[
							-81.97832185399994,
							28.048658036000063
						],
						[
							-81.97836208299992,
							28.048615083000072
						],
						[
							-81.97837629299994,
							28.048601184000063
						],
						[
							-81.97873689999994,
							28.048256176000052
						],
						[
							-81.97880274999994,
							28.048179236000067
						],
						[
							-81.9788098539999,
							28.048171036000042
						],
						[
							-81.97885008299994,
							28.04812808300005
						],
						[
							-81.97888073999991,
							28.048098838000044
						],
						[
							-81.97889440499996,
							28.048054923000052
						],
						[
							-81.97891513499991,
							28.04799984500005
						],
						[
							-81.97893942299994,
							28.047946240000044
						],
						[
							-81.97896716499991,
							28.047894339000038
						],
						[
							-81.97899824099994,
							28.04784436400007
						],
						[
							-81.97903251999992,
							28.04779652800005
						],
						[
							-81.97906985399993,
							28.04775103600008
						],
						[
							-81.97911008399991,
							28.047708084000078
						],
						[
							-81.9791530359999,
							28.047667854000053
						],
						[
							-81.97918873499992,
							28.047638143000086
						],
						[
							-81.97922673499994,
							28.04760814200006
						],
						[
							-81.97923652799994,
							28.04760052000006
						],
						[
							-81.97928436399991,
							28.047566241000087
						],
						[
							-81.97933433899993,
							28.047535164000067
						],
						[
							-81.97938623999994,
							28.04750742200008
						],
						[
							-81.97943984499994,
							28.04748313500005
						],
						[
							-81.97948617299994,
							28.04746542500004
						],
						[
							-81.9794944219999,
							28.04744824000005
						],
						[
							-81.97952216399995,
							28.047396339000045
						],
						[
							-81.97955054699992,
							28.047350418000065
						],
						[
							-81.97958554699994,
							28.04729741800009
						],
						[
							-81.97958824099993,
							28.04729336400004
						],
						[
							-81.97962251999991,
							28.047245528000076
						],
						[
							-81.9796435149999,
							28.047219202000065
						],
						[
							-81.97963961799991,
							28.047206156000072
						],
						[
							-81.97960812299995,
							28.047194438000076
						],
						[
							-81.97953412299995,
							28.047164439000085
						],
						[
							-81.9795278439999,
							28.047161865000078
						],
						[
							-81.97947423999994,
							28.047137578000047
						],
						[
							-81.97942233899994,
							28.04710983600006
						],
						[
							-81.9793750259999,
							28.047080531000066
						],
						[
							-81.9792830259999,
							28.047019531000046
						],
						[
							-81.97928036399992,
							28.047017759000084
						],
						[
							-81.9792325279999,
							28.046983480000055
						],
						[
							-81.97918703599993,
							28.04694614600004
						],
						[
							-81.97914408299994,
							28.04690591700006
						],
						[
							-81.9791038539999,
							28.04686296400007
						],
						[
							-81.97906651999995,
							28.04681747300009
						],
						[
							-81.97905912599992,
							28.046807699000055
						],
						[
							-81.97896812599993,
							28.04668569900008
						],
						[
							-81.9789524599999,
							28.046664031000034
						],
						[
							-81.9787477669999,
							28.046613402000048
						],
						[
							-81.9772915659999,
							28.04630135900004
						],
						[
							-81.97724723899995,
							28.046290678000048
						],
						[
							-81.97719092299991,
							28.04627359500006
						],
						[
							-81.97716825099991,
							28.046265559000062
						],
						[
							-81.97677847299991,
							28.04612151100008
						],
						[
							-81.97614885899992,
							28.045929104000038
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Polk",
				"City": "Lakeland",
				"Name": "Lake Bonnet",
				"RegionID": "343468"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.99005099999994,
					28.032865580000077,
					-81.97795849599993,
					28.04096102200009
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.97795849599993,
							28.04096102200009
						],
						[
							-81.97797927099992,
							28.032865580000077
						],
						[
							-81.9840123379999,
							28.03290663900009
						],
						[
							-81.98401599999994,
							28.03296400000005
						],
						[
							-81.9840319999999,
							28.033198000000084
						],
						[
							-81.98406199999994,
							28.03363900000005
						],
						[
							-81.98406218899993,
							28.033644993000056
						],
						[
							-81.98409099999992,
							28.034557000000063
						],
						[
							-81.98407770199992,
							28.035427050000067
						],
						[
							-81.98407761499993,
							28.035432748000062
						],
						[
							-81.9840769999999,
							28.03547300000008
						],
						[
							-81.98406166899991,
							28.035557882000035
						],
						[
							-81.98391299999992,
							28.036381000000063
						],
						[
							-81.98390699999993,
							28.036812000000054
						],
						[
							-81.98390699999993,
							28.03685500000006
						],
						[
							-81.98390299999994,
							28.03711700000008
						],
						[
							-81.98418443899993,
							28.03712157600006
						],
						[
							-81.98427199999992,
							28.037123000000065
						],
						[
							-81.9846882619999,
							28.03703910900009
						],
						[
							-81.9851609609999,
							28.036943845000057
						],
						[
							-81.98518499999994,
							28.036939000000075
						],
						[
							-81.98592799999994,
							28.036947000000055
						],
						[
							-81.98738947399994,
							28.036926509000068
						],
						[
							-81.9879249999999,
							28.03691900000007
						],
						[
							-81.98811699999993,
							28.03692600000005
						],
						[
							-81.98983499999993,
							28.036898000000065
						],
						[
							-81.99003799999991,
							28.03690000000006
						],
						[
							-81.9900419999999,
							28.037431000000083
						],
						[
							-81.9900419999999,
							28.03774100000004
						],
						[
							-81.99005099999994,
							28.03848400000004
						],
						[
							-81.99004906099992,
							28.038652729000034
						],
						[
							-81.99004902999991,
							28.038655365000068
						],
						[
							-81.98899090899994,
							28.038851010000087
						],
						[
							-81.98787190999992,
							28.039074009000046
						],
						[
							-81.98732190999993,
							28.039184010000042
						],
						[
							-81.98595490999992,
							28.039437010000086
						],
						[
							-81.98305690899991,
							28.040005010000073
						],
						[
							-81.9811009089999,
							28.040375010000048
						],
						[
							-81.97993690899995,
							28.04058401000009
						],
						[
							-81.97899290999993,
							28.04076301000004
						],
						[
							-81.97795849599993,
							28.04096102200009
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Polk",
				"City": "Lakeland",
				"Name": "Westgate",
				"RegionID": "343470"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.54059724199993,
					27.31126927200006,
					-82.53370142299991,
					27.315535116000035
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.53373281799992,
							27.315466794000088
						],
						[
							-82.53370142299991,
							27.31135974500006
						],
						[
							-82.53370999999993,
							27.311360000000036
						],
						[
							-82.5339322929999,
							27.311360000000036
						],
						[
							-82.53425036199991,
							27.31135845600005
						],
						[
							-82.53442927499992,
							27.31135570300006
						],
						[
							-82.53461828099995,
							27.31135279600005
						],
						[
							-82.53471767699995,
							27.311351267000077
						],
						[
							-82.5347999999999,
							27.31135000000006
						],
						[
							-82.53501590299993,
							27.31134760100008
						],
						[
							-82.53519483699995,
							27.31134561300007
						],
						[
							-82.53533411699993,
							27.31134406500007
						],
						[
							-82.5355826359999,
							27.311341304000052
						],
						[
							-82.5356999999999,
							27.311340000000087
						],
						[
							-82.5359505109999,
							27.311340000000087
						],
						[
							-82.53606981399992,
							27.311340000000087
						],
						[
							-82.5362199999999,
							27.311340000000087
						],
						[
							-82.53644760899994,
							27.311340000000087
						],
						[
							-82.53660999999994,
							27.311340000000087
						],
						[
							-82.5369347649999,
							27.311340000000087
						],
						[
							-82.5372727909999,
							27.311340000000087
						],
						[
							-82.53748999999993,
							27.311340000000087
						],
						[
							-82.5377002219999,
							27.311337405000074
						],
						[
							-82.53782944799991,
							27.31133580900007
						],
						[
							-82.53796873699991,
							27.311334090000063
						],
						[
							-82.53814766499994,
							27.311331881000058
						],
						[
							-82.53829999999994,
							27.311330000000055
						],
						[
							-82.53914399999991,
							27.31131300000004
						],
						[
							-82.54004734199992,
							27.31126927200006
						],
						[
							-82.54006838899996,
							27.311404521000046
						],
						[
							-82.54010166099995,
							27.311422164000078
						],
						[
							-82.54023007299992,
							27.31151207900007
						],
						[
							-82.54034091999995,
							27.311622927000087
						],
						[
							-82.54043083499994,
							27.311751339000068
						],
						[
							-82.5404970859999,
							27.311893414000053
						],
						[
							-82.54053765899994,
							27.312044834000062
						],
						[
							-82.54055123899991,
							27.312188847000073
						],
						[
							-82.54055220099991,
							27.312260469000083
						],
						[
							-82.54059724199993,
							27.314659546000087
						],
						[
							-82.5405828879999,
							27.314827044000083
						],
						[
							-82.54059042499995,
							27.314856458000065
						],
						[
							-82.53964757099993,
							27.31488149000006
						],
						[
							-82.53925820599994,
							27.31490253700008
						],
						[
							-82.5390477389999,
							27.314892013000076
						],
						[
							-82.53878465499992,
							27.31490253700008
						],
						[
							-82.53866889799991,
							27.314955153000085
						],
						[
							-82.5385952339999,
							27.315123527000083
						],
						[
							-82.53841999999992,
							27.31525000000005
						],
						[
							-82.5378268469999,
							27.315255749000073
						],
						[
							-82.53782771899995,
							27.315535116000035
						],
						[
							-82.53373281799992,
							27.315466794000088
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "McClellan Park",
				"RegionID": "343954"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.53917937699993,
					27.298128000000077,
					-82.53359555599991,
					27.30274000000009
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.53387038099993,
							27.302733339000042
						],
						[
							-82.53369862199992,
							27.30273061300005
						],
						[
							-82.53364420899993,
							27.302732005000053
						],
						[
							-82.53362741299992,
							27.301499784000043
						],
						[
							-82.53359568799993,
							27.299172449000082
						],
						[
							-82.53359555599991,
							27.298863916000073
						],
						[
							-82.5341519939999,
							27.29885383900006
						],
						[
							-82.53432095599993,
							27.299094508000053
						],
						[
							-82.53432299999992,
							27.299122000000068
						],
						[
							-82.53432863899991,
							27.299121477000085
						],
						[
							-82.53485099999995,
							27.299073000000078
						],
						[
							-82.53486499999991,
							27.298852000000068
						],
						[
							-82.53490966399994,
							27.298852078000042
						],
						[
							-82.53512690999992,
							27.29885245900005
						],
						[
							-82.53543599999995,
							27.298853000000065
						],
						[
							-82.53543399999995,
							27.299325000000067
						],
						[
							-82.53561899999994,
							27.299325000000067
						],
						[
							-82.53630299999992,
							27.299325000000067
						],
						[
							-82.53629457499994,
							27.299248877000082
						],
						[
							-82.53627499999993,
							27.29907200000008
						],
						[
							-82.53641284899993,
							27.299069263000035
						],
						[
							-82.5368289999999,
							27.29906100000005
						],
						[
							-82.53681099999994,
							27.29932400000007
						],
						[
							-82.53735996699993,
							27.299328054000057
						],
						[
							-82.53748799999994,
							27.299329000000057
						],
						[
							-82.5374579999999,
							27.29885900000005
						],
						[
							-82.53753891399992,
							27.29885985900006
						],
						[
							-82.53821199999993,
							27.298867000000087
						],
						[
							-82.5386749999999,
							27.29886900000008
						],
						[
							-82.53869899999995,
							27.298128000000077
						],
						[
							-82.5391249999999,
							27.298132000000066
						],
						[
							-82.53912896399993,
							27.298321754000085
						],
						[
							-82.53914099999992,
							27.29889800000007
						],
						[
							-82.53917937699993,
							27.29897442800007
						],
						[
							-82.53897970699991,
							27.302689558000054
						],
						[
							-82.53892333599993,
							27.30269000000004
						],
						[
							-82.53866577799994,
							27.30269000000004
						],
						[
							-82.53843999999992,
							27.30269000000004
						],
						[
							-82.5383653639999,
							27.302691914000036
						],
						[
							-82.53831617999992,
							27.30269317500006
						],
						[
							-82.53818748599991,
							27.30269647500006
						],
						[
							-82.53811378899991,
							27.302698364000037
						],
						[
							-82.53804999999994,
							27.302700000000073
						],
						[
							-82.53797895799994,
							27.302700000000073
						],
						[
							-82.53780725299993,
							27.302700000000073
						],
						[
							-82.53742704899992,
							27.302700000000073
						],
						[
							-82.5372099999999,
							27.302700000000073
						],
						[
							-82.53710203499992,
							27.302701333000073
						],
						[
							-82.53687524899993,
							27.302704133000077
						],
						[
							-82.53678312699992,
							27.302705270000047
						],
						[
							-82.53652560799993,
							27.30270844900008
						],
						[
							-82.5363999999999,
							27.302710000000047
						],
						[
							-82.53624351099995,
							27.302710000000047
						],
						[
							-82.53596755699994,
							27.302710000000047
						],
						[
							-82.53579999999994,
							27.302710000000047
						],
						[
							-82.5357471989999,
							27.30271203100006
						],
						[
							-82.53566100199993,
							27.30271534600007
						],
						[
							-82.53558116399995,
							27.30271841700005
						],
						[
							-82.53553999999991,
							27.30272000000008
						],
						[
							-82.53545244199995,
							27.30272000000008
						],
						[
							-82.53528073699994,
							27.30272000000008
						],
						[
							-82.5348146799999,
							27.30272000000008
						],
						[
							-82.53469999999993,
							27.30272000000008
						],
						[
							-82.53461252799991,
							27.302724267000087
						],
						[
							-82.5345201639999,
							27.30272877200008
						],
						[
							-82.53444645299993,
							27.30273236800008
						],
						[
							-82.5343608039999,
							27.302736546000062
						],
						[
							-82.53428999999994,
							27.30274000000009
						],
						[
							-82.53423209699992,
							27.302739081000084
						],
						[
							-82.5341402329999,
							27.302737623000045
						],
						[
							-82.53396234299993,
							27.302734799000064
						],
						[
							-82.53387038099993,
							27.302733339000042
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Granada",
				"RegionID": "343961"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.53099201899994,
					27.322842888000082,
					-82.5140098629999,
					27.33562450800008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.52835928999991,
							27.33559064500008
						],
						[
							-82.52825999999993,
							27.33559000000008
						],
						[
							-82.52783454299993,
							27.33559000000008
						],
						[
							-82.52719419599993,
							27.33559000000008
						],
						[
							-82.52664278499992,
							27.33559000000008
						],
						[
							-82.52638486699993,
							27.33559000000008
						],
						[
							-82.5262899999999,
							27.33559000000008
						],
						[
							-82.5260292079999,
							27.335586569000043
						],
						[
							-82.52556669699995,
							27.335580483000058
						],
						[
							-82.52558443299995,
							27.33464170900004
						],
						[
							-82.5256111139999,
							27.333218714000054
						],
						[
							-82.5256111139999,
							27.332836284000052
						],
						[
							-82.52558443299995,
							27.332525004000047
						],
						[
							-82.52551328299995,
							27.332275979000087
						],
						[
							-82.52536208999993,
							27.33187576200004
						],
						[
							-82.52505080999993,
							27.331466651000085
						],
						[
							-82.52458833599991,
							27.330986390000078
						],
						[
							-82.52425037499997,
							27.330755154000087
						],
						[
							-82.5236811769999,
							27.33048834200008
						],
						[
							-82.52312087299993,
							27.33029268000007
						],
						[
							-82.52246273799994,
							27.330265999000062
						],
						[
							-82.5221864419999,
							27.330273084000055
						],
						[
							-82.52218611699993,
							27.33005972400008
						],
						[
							-82.51811810599992,
							27.330054871000073
						],
						[
							-82.5140098629999,
							27.330049901000052
						],
						[
							-82.51408484199993,
							27.322842888000082
						],
						[
							-82.5258474769999,
							27.322894481000052
						],
						[
							-82.52972872099991,
							27.322905820000074
						],
						[
							-82.5297456699999,
							27.324190526000052
						],
						[
							-82.52975160799991,
							27.32459362500009
						],
						[
							-82.52975160699992,
							27.32514683900007
						],
						[
							-82.52981866399995,
							27.32601857000009
						],
						[
							-82.52985213999995,
							27.32663885000005
						],
						[
							-82.53001983299993,
							27.327141762000057
						],
						[
							-82.53033834999991,
							27.327963201000046
						],
						[
							-82.5305730469999,
							27.32854994300004
						],
						[
							-82.53075745199993,
							27.32895228500007
						],
						[
							-82.53087479999994,
							27.329404911000044
						],
						[
							-82.53095861899993,
							27.329824013000064
						],
						[
							-82.53096090399994,
							27.330220970000084
						],
						[
							-82.5309814549999,
							27.33379000000008
						],
						[
							-82.53098524899991,
							27.334448898000062
						],
						[
							-82.53099201899994,
							27.33562450800008
						],
						[
							-82.5308495139999,
							27.335620000000063
						],
						[
							-82.53056484299992,
							27.33561485100006
						],
						[
							-82.53034258299994,
							27.335610536000047
						],
						[
							-82.53007587199994,
							27.335605357000077
						],
						[
							-82.52992456399996,
							27.335602419000054
						],
						[
							-82.52979999999991,
							27.33560000000006
						],
						[
							-82.52960441599993,
							27.335598730000072
						],
						[
							-82.5290974959999,
							27.33559543800004
						],
						[
							-82.52870613099992,
							27.335592897000083
						],
						[
							-82.52835928999991,
							27.33559064500008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Alta Vista",
				"RegionID": "343963"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.17140894499994,
					25.788508284000045,
					-80.16547899599993,
					25.79247432200009
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.16943888299994,
							25.78853071100008
						],
						[
							-80.17004699199993,
							25.788508284000045
						],
						[
							-80.17012371399994,
							25.788508741000044
						],
						[
							-80.17020011799991,
							25.78851573600008
						],
						[
							-80.17027564799992,
							25.788529217000075
						],
						[
							-80.17034975299993,
							25.78854908800008
						],
						[
							-80.17042189599994,
							25.78857520200006
						],
						[
							-80.17094972899991,
							25.788792565000055
						],
						[
							-80.17098332199993,
							25.788807432000056
						],
						[
							-80.17109166099993,
							25.788859164000087
						],
						[
							-80.17111244799992,
							25.788873719000037
						],
						[
							-80.17116498999991,
							25.789440528000057
						],
						[
							-80.17122597899993,
							25.78984712000005
						],
						[
							-80.17140894499994,
							25.790314701000057
						],
						[
							-80.17134795599992,
							25.790599315000065
						],
						[
							-80.1712666379999,
							25.790965248000077
						],
						[
							-80.1711853189999,
							25.791351511000077
						],
						[
							-80.17120699999992,
							25.79181942000008
						],
						[
							-80.17112012099994,
							25.79188903000005
						],
						[
							-80.17090012099993,
							25.792032030000087
						],
						[
							-80.17084373299991,
							25.792065817000037
						],
						[
							-80.17078502899994,
							25.792095394000057
						],
						[
							-80.17072432099991,
							25.792120605000036
						],
						[
							-80.1706619329999,
							25.79214131300006
						],
						[
							-80.17059819999992,
							25.792157409000083
						],
						[
							-80.1703352859999,
							25.792213633000074
						],
						[
							-80.1701093719999,
							25.792258858000082
						],
						[
							-80.17000316699995,
							25.792273580000085
						],
						[
							-80.16747316699991,
							25.792471581000086
						],
						[
							-80.16740299999992,
							25.79247432200009
						],
						[
							-80.16730251599995,
							25.792468691000067
						],
						[
							-80.1667155159999,
							25.792402690000074
						],
						[
							-80.16662459699995,
							25.792387718000047
						],
						[
							-80.16622059699995,
							25.792299718000038
						],
						[
							-80.16614417699992,
							25.792279517000054
						],
						[
							-80.1660698259999,
							25.792252683000072
						],
						[
							-80.16599811799995,
							25.79221942500004
						],
						[
							-80.16592960799994,
							25.79217999800005
						],
						[
							-80.16586482399993,
							25.79213470800005
						],
						[
							-80.1655348239999,
							25.791881708000062
						],
						[
							-80.16547899599993,
							25.791834854000058
						],
						[
							-80.16572999999994,
							25.79072800000006
						],
						[
							-80.16581464799992,
							25.790597543000047
						],
						[
							-80.16581499999995,
							25.790597000000048
						],
						[
							-80.16581477699992,
							25.790596754000035
						],
						[
							-80.16572799999994,
							25.790501000000063
						],
						[
							-80.16575499999993,
							25.790238000000045
						],
						[
							-80.16636799999992,
							25.788876000000073
						],
						[
							-80.16643667299991,
							25.78871281000005
						],
						[
							-80.16649874599995,
							25.788701444000083
						],
						[
							-80.16657277399992,
							25.78869413800004
						],
						[
							-80.16943888299994,
							25.78853071100008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami",
				"Name": "San Marco Island",
				"RegionID": "403397"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.24677984499993,
					25.965707913000074,
					-80.22949789799998,
					25.972307171000068
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.22949789799998,
							25.96837820500008
						],
						[
							-80.23021822799996,
							25.968384874000037
						],
						[
							-80.23399264599999,
							25.968238834000037
						],
						[
							-80.23838423399997,
							25.96806891400007
						],
						[
							-80.23838530899997,
							25.968058709000047
						],
						[
							-80.23841270099997,
							25.967798564000077
						],
						[
							-80.23838838699999,
							25.966239208000047
						],
						[
							-80.24101336299998,
							25.966006427000025
						],
						[
							-80.24580270399997,
							25.965778599000032
						],
						[
							-80.24665799,
							25.965707913000074
						],
						[
							-80.24669884499998,
							25.966562401000033
						],
						[
							-80.246712545,
							25.966848928000047
						],
						[
							-80.24673661999998,
							25.968239247000046
						],
						[
							-80.24677984499993,
							25.970735508000075
						],
						[
							-80.246671,
							25.971876
						],
						[
							-80.246601,
							25.971877
						],
						[
							-80.246469,
							25.971879000000005
						],
						[
							-80.24540142699999,
							25.971898100000033
						],
						[
							-80.232104,
							25.972136
						],
						[
							-80.23059701199998,
							25.972163153000054
						],
						[
							-80.230328,
							25.972168
						],
						[
							-80.23021381699994,
							25.972194280000053
						],
						[
							-80.23007600000001,
							25.972226
						],
						[
							-80.22987327799996,
							25.972272152000073
						],
						[
							-80.22971945299997,
							25.972307171000068
						],
						[
							-80.22970731899994,
							25.97197024600007
						],
						[
							-80.22964450599994,
							25.971530552000047
						],
						[
							-80.22949789799998,
							25.96837820500008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Gardens",
				"Name": "Calder",
				"RegionID": "411817"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.26064862199996,
					25.914975000000002,
					-80.25223081399997,
					25.926036839000062
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.25527696599994,
							25.91514674600006
						],
						[
							-80.25548086299995,
							25.915144461000068
						],
						[
							-80.25849240999997,
							25.915004302000057
						],
						[
							-80.259122,
							25.914975000000002
						],
						[
							-80.25993292899994,
							25.916233874000056
						],
						[
							-80.26022143799997,
							25.91703991600008
						],
						[
							-80.26031661699994,
							25.917914368000027
						],
						[
							-80.26037015499998,
							25.91935989100006
						],
						[
							-80.26053951399996,
							25.923206094000022
						],
						[
							-80.26064862199996,
							25.925683970000023
						],
						[
							-80.26064851499996,
							25.92568891600007
						],
						[
							-80.25622296299997,
							25.925845683000034
						],
						[
							-80.25403061699996,
							25.925969398000063
						],
						[
							-80.25270743099998,
							25.92602870500008
						],
						[
							-80.25266317099994,
							25.926036839000062
						],
						[
							-80.25261973399995,
							25.92430906800007
						],
						[
							-80.25227656899995,
							25.91598160500007
						],
						[
							-80.25223081399997,
							25.915180887000076
						],
						[
							-80.25458576899996,
							25.915154493000045
						],
						[
							-80.25527696599994,
							25.91514674600006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Gardens",
				"Name": "St. Thomas",
				"RegionID": "412436"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.34286926299995,
					28.836064576000073,
					-82.33785388899997,
					28.84234533800003
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.33785388899997,
							28.84066067900005
						],
						[
							-82.33785957499998,
							28.83900935300005
						],
						[
							-82.33786051599998,
							28.838735963000037
						],
						[
							-82.33786236299994,
							28.838199618000033
						],
						[
							-82.33793391799998,
							28.83809398300008
						],
						[
							-82.33787353599996,
							28.837777097000075
						],
						[
							-82.33791882099996,
							28.836064576000073
						],
						[
							-82.33836834399995,
							28.836070780000057
						],
						[
							-82.33986168399997,
							28.836091389000043
						],
						[
							-82.34024177499998,
							28.83625939800004
						],
						[
							-82.34069980699998,
							28.83656460300006
						],
						[
							-82.34282760699995,
							28.838420805000055
						],
						[
							-82.34280594599994,
							28.83959051100004
						],
						[
							-82.34277262099994,
							28.841365066000037
						],
						[
							-82.34286926299995,
							28.84179162600003
						],
						[
							-82.34286259799995,
							28.842339880000054
						],
						[
							-82.33990498499998,
							28.84234533800003
						],
						[
							-82.33970035099998,
							28.84163625800005
						],
						[
							-82.33943385199996,
							28.841188920000036
						],
						[
							-82.33862483499996,
							28.840784411000076
						],
						[
							-82.33785388899997,
							28.84066067900005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Citrus",
				"City": "Inverness",
				"Name": "Labelle",
				"RegionID": "412953"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.7275696769999,
					28.25086669800004,
					-82.72082060399993,
					28.26887459800008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.72362598899991,
							28.25197909600007
						],
						[
							-82.72336424799994,
							28.25175304700008
						],
						[
							-82.72316199399995,
							28.25168166400005
						],
						[
							-82.72306681499992,
							28.251592434000088
						],
						[
							-82.72297758499991,
							28.251538896000056
						],
						[
							-82.72284076599993,
							28.251295001000074
						],
						[
							-82.72283481799991,
							28.250884544000087
						],
						[
							-82.72383419099994,
							28.25086669800004
						],
						[
							-82.72389367799991,
							28.25098567100008
						],
						[
							-82.72482761599991,
							28.25218729900007
						],
						[
							-82.72532730299991,
							28.251854175000066
						],
						[
							-82.72535704599994,
							28.251794688000075
						],
						[
							-82.7253451489999,
							28.25168166400005
						],
						[
							-82.72516074099991,
							28.251449666000042
						],
						[
							-82.72516668999992,
							28.250896441000066
						],
						[
							-82.72746442099992,
							28.25087764300008
						],
						[
							-82.72747449899992,
							28.254919059000088
						],
						[
							-82.72748367499992,
							28.257772910000085
						],
						[
							-82.7274863959999,
							28.258619121000038
						],
						[
							-82.72755777999993,
							28.25870240200004
						],
						[
							-82.72756577799993,
							28.262429739000083
						],
						[
							-82.7275696769999,
							28.264246546000038
						],
						[
							-82.72753398599991,
							28.264996076000045
						],
						[
							-82.72745070399992,
							28.265460071000064
						],
						[
							-82.72733173099994,
							28.265959758000065
						],
						[
							-82.72711757999991,
							28.266566521000072
						],
						[
							-82.72695101799991,
							28.266971029000047
						],
						[
							-82.72658220099993,
							28.267708662000075
						],
						[
							-82.72599923299992,
							28.26861285700005
						],
						[
							-82.72573749199995,
							28.26887459800008
						],
						[
							-82.72390438499991,
							28.267873945000076
						],
						[
							-82.72352367199994,
							28.267702624000037
						],
						[
							-82.72334283299995,
							28.26735046400006
						],
						[
							-82.7234189749999,
							28.267198178000058
						],
						[
							-82.72354270699992,
							28.26706492900007
						],
						[
							-82.72377113599993,
							28.26698878600007
						],
						[
							-82.72403763499995,
							28.26694119700005
						],
						[
							-82.72416136699991,
							28.26698878600007
						],
						[
							-82.7243802779999,
							28.266931679000038
						],
						[
							-82.72464677699992,
							28.26678891100005
						],
						[
							-82.7247134019999,
							28.26667469700004
						],
						[
							-82.72519881199993,
							28.265570627000045
						],
						[
							-82.72532254399994,
							28.26556110900009
						],
						[
							-82.7253035089999,
							28.265342199000088
						],
						[
							-82.72513218699993,
							28.265047146000086
						],
						[
							-82.72479906299992,
							28.264771128000064
						],
						[
							-82.7242279919999,
							28.26446655700005
						],
						[
							-82.72389486799995,
							28.264485593000074
						],
						[
							-82.72331427899991,
							28.264733057000058
						],
						[
							-82.72273369099992,
							28.264771128000064
						],
						[
							-82.7223529769999,
							28.264618843000054
						],
						[
							-82.7222482809999,
							28.264238129000034
						],
						[
							-82.72219117399993,
							28.263952594000045
						],
						[
							-82.72222924499994,
							28.263257791000058
						],
						[
							-82.72254333399991,
							28.26270575600006
						],
						[
							-82.72258140499993,
							28.262334560000056
						],
						[
							-82.7222482809999,
							28.261887221000052
						],
						[
							-82.7216201029999,
							28.261392294000075
						],
						[
							-82.72147733499992,
							28.261173383000084
						],
						[
							-82.72138215699994,
							28.260859294000056
						],
						[
							-82.72128697799991,
							28.260297741000045
						],
						[
							-82.7208777109999,
							28.259926546000088
						],
						[
							-82.7208777109999,
							28.25970763500004
						],
						[
							-82.72082060399993,
							28.25932692100008
						],
						[
							-82.7209157819999,
							28.258955725000078
						],
						[
							-82.72112517499995,
							28.25878440400004
						],
						[
							-82.72137263899992,
							28.25867019000009
						],
						[
							-82.7216486559999,
							28.25847983300008
						],
						[
							-82.72193419199994,
							28.25823236900004
						],
						[
							-82.72181997799993,
							28.257547085000056
						],
						[
							-82.72171528099996,
							28.25727106700009
						],
						[
							-82.72162962099992,
							28.256823728000086
						],
						[
							-82.72162962099992,
							28.256509640000047
						],
						[
							-82.72167720999994,
							28.25623362200008
						],
						[
							-82.72181045999993,
							28.255995676000055
						],
						[
							-82.72212454899994,
							28.25562448000005
						],
						[
							-82.72244815499994,
							28.255215213000042
						],
						[
							-82.7228669399999,
							28.254805945000044
						],
						[
							-82.72347608199993,
							28.254358607000086
						],
						[
							-82.7236474039999,
							28.254215839000043
						],
						[
							-82.72393293899995,
							28.25410162500009
						],
						[
							-82.72421847399994,
							28.254015964000075
						],
						[
							-82.72439931299994,
							28.25397789300007
						],
						[
							-82.7245991879999,
							28.253996929000042
						],
						[
							-82.72476099099993,
							28.253949340000077
						],
						[
							-82.7248561699999,
							28.253844643000036
						],
						[
							-82.7248942409999,
							28.253825608000056
						],
						[
							-82.72492279499994,
							28.25375898300007
						],
						[
							-82.72498941999993,
							28.25360669700007
						],
						[
							-82.72499893799996,
							28.25347344700009
						],
						[
							-82.72497990199992,
							28.253292608000038
						],
						[
							-82.72468484899991,
							28.252930930000048
						],
						[
							-82.7243802779999,
							28.252712020000047
						],
						[
							-82.7241232959999,
							28.252474074000077
						],
						[
							-82.7239710099999,
							28.25228371700007
						],
						[
							-82.72362598899991,
							28.25197909600007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pasco",
				"City": "New Port Richey",
				"Name": "North River",
				"RegionID": "415259"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.75667602299991,
					27.77716269600006,
					-82.74441303599991,
					27.792396488000065
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.75377999999995,
							27.79224000000005
						],
						[
							-82.75323365199995,
							27.792232587000058
						],
						[
							-82.75257983099993,
							27.792233673000055
						],
						[
							-82.75176999999991,
							27.79224000000005
						],
						[
							-82.75122168599995,
							27.79224000000005
						],
						[
							-82.75026597899995,
							27.79224000000005
						],
						[
							-82.74972999999994,
							27.79224000000005
						],
						[
							-82.7491090709999,
							27.79224000000005
						],
						[
							-82.74840486599993,
							27.79224000000005
						],
						[
							-82.74765999999994,
							27.79224000000005
						],
						[
							-82.74765932799994,
							27.79224000000005
						],
						[
							-82.74765749499994,
							27.79211853000004
						],
						[
							-82.74765475899994,
							27.79198583400006
						],
						[
							-82.74765270699993,
							27.79188631100004
						],
						[
							-82.74584518599994,
							27.791886285000093
						],
						[
							-82.7457566839999,
							27.79184756600006
						],
						[
							-82.7455575539999,
							27.79179225200005
						],
						[
							-82.74517588799995,
							27.791709281000067
						],
						[
							-82.74474997099992,
							27.791631841000083
						],
						[
							-82.74472784499994,
							27.791443774000072
						],
						[
							-82.7447057199999,
							27.790796602000057
						],
						[
							-82.7447057199999,
							27.79024346300008
						],
						[
							-82.74477762799995,
							27.789972425000087
						],
						[
							-82.74494910099992,
							27.789557571000046
						],
						[
							-82.74520907599992,
							27.789037620000045
						],
						[
							-82.74551883399994,
							27.788678080000068
						],
						[
							-82.74592815699992,
							27.788307477000046
						],
						[
							-82.7464149189999,
							27.787820715000066
						],
						[
							-82.74679105299992,
							27.787488831000076
						],
						[
							-82.74675233399995,
							27.787350547000074
						],
						[
							-82.7466140489999,
							27.786786345000053
						],
						[
							-82.74634854199991,
							27.785812821000036
						],
						[
							-82.7460885669999,
							27.78497204900009
						],
						[
							-82.74593921999991,
							27.78425296900008
						],
						[
							-82.74581752899991,
							27.783644516000038
						],
						[
							-82.74565711899993,
							27.78334582100007
						],
						[
							-82.74551883399994,
							27.783157754000058
						],
						[
							-82.74536948699995,
							27.782942030000072
						],
						[
							-82.74521460799991,
							27.78276502500006
						],
						[
							-82.74504313499995,
							27.782521644000045
						],
						[
							-82.7449103809999,
							27.782355703000064
						],
						[
							-82.74478869099994,
							27.78213444700009
						],
						[
							-82.74469465699991,
							27.781868940000038
						],
						[
							-82.74459509199994,
							27.781647685000053
						],
						[
							-82.74452318399995,
							27.781476212000086
						],
						[
							-82.74448999599991,
							27.78133792700004
						],
						[
							-82.74441303599991,
							27.780969241000037
						],
						[
							-82.74446115899991,
							27.78095404900006
						],
						[
							-82.74450881699994,
							27.78092863100005
						],
						[
							-82.74457685899995,
							27.780892342000072
						],
						[
							-82.74463104199992,
							27.780858271000056
						],
						[
							-82.74470163699993,
							27.780808363000062
						],
						[
							-82.7447499999999,
							27.780760000000043
						],
						[
							-82.74478331799992,
							27.780712403000052
						],
						[
							-82.74483965999991,
							27.780623957000046
						],
						[
							-82.74492529599992,
							27.780426465000062
						],
						[
							-82.74500214499994,
							27.78022397500007
						],
						[
							-82.74509435899995,
							27.78004846200008
						],
						[
							-82.74521307099991,
							27.779870393000067
						],
						[
							-82.74531822799992,
							27.77974540000008
						],
						[
							-82.74543512299994,
							27.77962487700006
						],
						[
							-82.7455523299999,
							27.779533641000057
						],
						[
							-82.74566694099993,
							27.77946678400008
						],
						[
							-82.7457975449999,
							27.779390599000067
						],
						[
							-82.74588387099993,
							27.779342068000066
						],
						[
							-82.74605325899995,
							27.779252392000046
						],
						[
							-82.74621999999995,
							27.77916000000005
						],
						[
							-82.74618453199992,
							27.779106798000043
						],
						[
							-82.74610868799994,
							27.778993033000063
						],
						[
							-82.74603284499995,
							27.778879267000036
						],
						[
							-82.74593061999991,
							27.778725930000064
						],
						[
							-82.74584073299991,
							27.778512933000062
						],
						[
							-82.74583004099992,
							27.778473009000038
						],
						[
							-82.74579485899994,
							27.778342335000048
						],
						[
							-82.74576700599994,
							27.778236227000036
						],
						[
							-82.74574282499992,
							27.778124994000052
						],
						[
							-82.74570626299993,
							27.777956809000045
						],
						[
							-82.74567763199991,
							27.777825109000048
						],
						[
							-82.74566094099993,
							27.777720547000058
						],
						[
							-82.74564372999993,
							27.777588595000054
						],
						[
							-82.74563420899995,
							27.777461548000076
						],
						[
							-82.74563626299994,
							27.777320058000043
						],
						[
							-82.74691026099993,
							27.77733180000007
						],
						[
							-82.74780867899995,
							27.77716269600006
						],
						[
							-82.74798694899994,
							27.777195749000043
						],
						[
							-82.74811379499994,
							27.777228990000083
						],
						[
							-82.74832119099995,
							27.777299952000078
						],
						[
							-82.74847186099993,
							27.777369304000047
						],
						[
							-82.74864703299994,
							27.77735480800004
						],
						[
							-82.74871149799992,
							27.77735173900004
						],
						[
							-82.7487760169999,
							27.77735330200005
						],
						[
							-82.7488402589999,
							27.77735948700007
						],
						[
							-82.74890389099994,
							27.77737026400007
						],
						[
							-82.74917989099993,
							27.77742726400004
						],
						[
							-82.74930558599993,
							27.77746291400007
						],
						[
							-82.74939317899992,
							27.77750015500004
						],
						[
							-82.74962417899991,
							27.77761315500004
						],
						[
							-82.74968454499992,
							27.777645591000066
						],
						[
							-82.74974226599994,
							27.77768253000005
						],
						[
							-82.74979700599994,
							27.777723756000057
						],
						[
							-82.74984844799991,
							27.777769031000048
						],
						[
							-82.74989629399994,
							27.777818092000075
						],
						[
							-82.7499992939999,
							27.777932091000082
						],
						[
							-82.75002092099993,
							27.777956927000048
						],
						[
							-82.75011297499992,
							27.77808908600008
						],
						[
							-82.75019811499993,
							27.778239834000093
						],
						[
							-82.7502600869999,
							27.77837441400004
						],
						[
							-82.7503022009999,
							27.77853514600008
						],
						[
							-82.7503557419999,
							27.77888045700007
						],
						[
							-82.75036632199993,
							27.779018000000068
						],
						[
							-82.75035420599994,
							27.77916512300004
						],
						[
							-82.7503204329999,
							27.779368644000044
						],
						[
							-82.75027908699991,
							27.779524586000036
						],
						[
							-82.75023859399994,
							27.779611423000063
						],
						[
							-82.75024736699993,
							27.77964944100006
						],
						[
							-82.75036610399992,
							27.779990809000083
						],
						[
							-82.7504645059999,
							27.780265874000065
						],
						[
							-82.75058890699995,
							27.780385334000073
						],
						[
							-82.75066896099992,
							27.78047308500004
						],
						[
							-82.75082296199992,
							27.780666085000064
						],
						[
							-82.75089883599992,
							27.780777339000053
						],
						[
							-82.75092181899993,
							27.780819732000055
						],
						[
							-82.7509538189999,
							27.78088273200007
						],
						[
							-82.75098322799994,
							27.780946722000067
						],
						[
							-82.75100754099992,
							27.78101281700009
						],
						[
							-82.75102660699991,
							27.78108061200004
						],
						[
							-82.7510403089999,
							27.781149690000063
						],
						[
							-82.7510485649999,
							27.781219629000077
						],
						[
							-82.75105132199991,
							27.78129000000007
						],
						[
							-82.75105132199991,
							27.78136459600006
						],
						[
							-82.75114812399994,
							27.781567042000063
						],
						[
							-82.75140021699991,
							27.781992673000047
						],
						[
							-82.7514711899999,
							27.78199771700008
						],
						[
							-82.75155518999992,
							27.78200971800004
						],
						[
							-82.75158416499994,
							27.782014341000036
						],
						[
							-82.75173558599994,
							27.78205491400007
						],
						[
							-82.75187766099992,
							27.782121165000035
						],
						[
							-82.7520060729999,
							27.78221108000008
						],
						[
							-82.75211691999993,
							27.782321927000055
						],
						[
							-82.75220683499992,
							27.782450339000036
						],
						[
							-82.75227308599995,
							27.782592414000078
						],
						[
							-82.75231365899992,
							27.78274383500008
						],
						[
							-82.75231828199992,
							27.782772811000086
						],
						[
							-82.75233128299995,
							27.782863811000084
						],
						[
							-82.75233876699991,
							27.782936480000046
						],
						[
							-82.75234026099992,
							27.783009519000075
						],
						[
							-82.75233575399994,
							27.78308243400005
						],
						[
							-82.7523252769999,
							27.78315473300006
						],
						[
							-82.75230890099994,
							27.783225928000036
						],
						[
							-82.75228673599992,
							27.78329553800006
						],
						[
							-82.75225893099991,
							27.783363094000038
						],
						[
							-82.75222567499992,
							27.78342813900008
						],
						[
							-82.75224082599993,
							27.783446447000074
						],
						[
							-82.7523096249999,
							27.78346944100008
						],
						[
							-82.75237627099995,
							27.78349808200005
						],
						[
							-82.75244030199991,
							27.783532171000047
						],
						[
							-82.75250127299995,
							27.783571471000073
						],
						[
							-82.75255876199992,
							27.78361571100004
						],
						[
							-82.75261236799992,
							27.783664582000085
						],
						[
							-82.75267036799994,
							27.783721583000045
						],
						[
							-82.75272892099991,
							27.783784927000056
						],
						[
							-82.75282248499991,
							27.783919750000052
						],
						[
							-82.75289503899995,
							27.784005363000063
						],
						[
							-82.75298883499994,
							27.784138339000037
						],
						[
							-82.75301099799994,
							27.78417912200007
						],
						[
							-82.75312787199994,
							27.78440807900006
						],
						[
							-82.75317488199994,
							27.784494736000056
						],
						[
							-82.75325856299992,
							27.78460722500006
						],
						[
							-82.7533158359999,
							27.784694339000055
						],
						[
							-82.75338507999993,
							27.784844902000092
						],
						[
							-82.75345745999994,
							27.78505660600007
						],
						[
							-82.7534858969999,
							27.785137909000074
						],
						[
							-82.75360572299991,
							27.785259902000064
						],
						[
							-82.75365835799994,
							27.78531784200004
						],
						[
							-82.7537057529999,
							27.78538013900004
						],
						[
							-82.75374755099996,
							27.785446323000087
						],
						[
							-82.75378343499995,
							27.78551589100005
						],
						[
							-82.75381313199995,
							27.785588316000087
						],
						[
							-82.7538971759999,
							27.785824218000073
						],
						[
							-82.75391686599994,
							27.785886579000078
						],
						[
							-82.75395042999993,
							27.78600810200004
						],
						[
							-82.75399003099994,
							27.78601199700006
						],
						[
							-82.75405816599994,
							27.786021341000037
						],
						[
							-82.75420958699993,
							27.786061914000072
						],
						[
							-82.75435166099993,
							27.786128164000047
						],
						[
							-82.75448007299991,
							27.786218079000037
						],
						[
							-82.75459366299992,
							27.78633261400006
						],
						[
							-82.75464607299995,
							27.786371079000048
						],
						[
							-82.75475534299994,
							27.786480052000062
						],
						[
							-82.75483681399994,
							27.786576610000054
						],
						[
							-82.75511260199995,
							27.786904548000056
						],
						[
							-82.75520283599991,
							27.78703333900006
						],
						[
							-82.75524282999994,
							27.787111116000066
						],
						[
							-82.75535182899995,
							27.787351115000035
						],
						[
							-82.75537808599996,
							27.787415413000076
						],
						[
							-82.75540631999992,
							27.78750830900009
						],
						[
							-82.75546531999993,
							27.78774830900005
						],
						[
							-82.75547866499994,
							27.787812649000045
						],
						[
							-82.75548727599994,
							27.787877791000085
						],
						[
							-82.75549110799994,
							27.78794338900008
						],
						[
							-82.75549013999995,
							27.78800909100005
						],
						[
							-82.75548437699992,
							27.788074547000065
						],
						[
							-82.7554643769999,
							27.788234547000062
						],
						[
							-82.75545728399995,
							27.788291541000035
						],
						[
							-82.7554451279999,
							27.78834767400008
						],
						[
							-82.75542800799991,
							27.788402497000053
						],
						[
							-82.75540606099992,
							27.788455572000093
						],
						[
							-82.75548017299991,
							27.788577116000056
						],
						[
							-82.75599482499992,
							27.78930653000009
						],
						[
							-82.7560388359999,
							27.789375339000063
						],
						[
							-82.75610661199994,
							27.78952167400007
						],
						[
							-82.7562361379999,
							27.789888933000043
						],
						[
							-82.7562492699999,
							27.78992916900006
						],
						[
							-82.75630727099991,
							27.79012216900009
						],
						[
							-82.75632746699995,
							27.790202684000064
						],
						[
							-82.75646846599994,
							27.790899684000067
						],
						[
							-82.75647350399993,
							27.790926703000082
						],
						[
							-82.75652573699996,
							27.791232758000035
						],
						[
							-82.75656673099991,
							27.791354713000093
						],
						[
							-82.75661133499995,
							27.79144924700006
						],
						[
							-82.75664308599994,
							27.791525414000034
						],
						[
							-82.75667269299993,
							27.79162397300007
						],
						[
							-82.75667602299991,
							27.791637911000066
						],
						[
							-82.75578965799991,
							27.79181532000007
						],
						[
							-82.75514950099995,
							27.79181532000007
						],
						[
							-82.75515923099995,
							27.79187802100006
						],
						[
							-82.75516910699992,
							27.79194010000009
						],
						[
							-82.75518472899995,
							27.792038296000047
						],
						[
							-82.75520035099993,
							27.792136491000065
						],
						[
							-82.75521682199991,
							27.79224002600006
						],
						[
							-82.75427315799993,
							27.792264250000073
						],
						[
							-82.7542637119999,
							27.792396488000065
						],
						[
							-82.75380201599997,
							27.792396447000044
						],
						[
							-82.7537999999999,
							27.79228786400006
						],
						[
							-82.75377999999995,
							27.79224000000005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Jungle Prada",
				"RegionID": "417126"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.63547999999992,
					27.742188374000083,
					-82.6299961119999,
					27.746630000000042
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.63018542599991,
							27.746347305000086
						],
						[
							-82.63017358999991,
							27.74550464500004
						],
						[
							-82.6299961119999,
							27.744325140000058
						],
						[
							-82.62999677599993,
							27.744325894000042
						],
						[
							-82.6300568719999,
							27.744235418000073
						],
						[
							-82.63011707899994,
							27.744154927000068
						],
						[
							-82.63017008299994,
							27.744097083000042
						],
						[
							-82.63023908399992,
							27.744028083000046
						],
						[
							-82.63029193099993,
							27.74397930200007
						],
						[
							-82.63034850699995,
							27.743934901000046
						],
						[
							-82.63040845099994,
							27.74389516200006
						],
						[
							-82.63047137799992,
							27.743860340000083
						],
						[
							-82.6305368859999,
							27.743830658000036
						],
						[
							-82.63060455699991,
							27.743806305000078
						],
						[
							-82.63071555599993,
							27.743771305000053
						],
						[
							-82.63077886899993,
							27.74375385600007
						],
						[
							-82.6308432859999,
							27.74374107400007
						],
						[
							-82.63090846499995,
							27.743733026000086
						],
						[
							-82.63097405699995,
							27.74372975700004
						],
						[
							-82.63103971199992,
							27.743731283000045
						],
						[
							-82.63115671199995,
							27.743738284000074
						],
						[
							-82.63128274299993,
							27.743754823000078
						],
						[
							-82.63148374299993,
							27.743795823000085
						],
						[
							-82.63161443099995,
							27.743832955000073
						],
						[
							-82.63184119199991,
							27.743916355000067
						],
						[
							-82.63216205299994,
							27.743502275000083
						],
						[
							-82.63250122199992,
							27.74304057300009
						],
						[
							-82.63253707899992,
							27.74299492700004
						],
						[
							-82.63262142399992,
							27.74290721600005
						],
						[
							-82.63315442399994,
							27.742423216000077
						],
						[
							-82.63319851299991,
							27.74238569700009
						],
						[
							-82.63344611699995,
							27.742188374000083
						],
						[
							-82.63406449699994,
							27.742845403000047
						],
						[
							-82.63468665099994,
							27.74350644100008
						],
						[
							-82.63484999999991,
							27.74368000000004
						],
						[
							-82.63498098299993,
							27.743826228000046
						],
						[
							-82.63512105899991,
							27.744001324000067
						],
						[
							-82.63530382599993,
							27.744229782000048
						],
						[
							-82.63547999999992,
							27.744450000000086
						],
						[
							-82.63537110899995,
							27.74454588900005
						],
						[
							-82.63523983399995,
							27.744661490000055
						],
						[
							-82.63504292099992,
							27.74483489100004
						],
						[
							-82.6348099999999,
							27.745040000000074
						],
						[
							-82.63488660799993,
							27.745140983000056
						],
						[
							-82.63502999999992,
							27.74533000000008
						],
						[
							-82.63510514099994,
							27.74542517900005
						],
						[
							-82.63518984599995,
							27.745532472000036
						],
						[
							-82.6353299999999,
							27.745710000000088
						],
						[
							-82.63533101799993,
							27.745711100000054
						],
						[
							-82.63522450499994,
							27.745709241000043
						],
						[
							-82.63495901099992,
							27.745707331000062
						],
						[
							-82.63466401799991,
							27.745705209000054
						],
						[
							-82.63453611699994,
							27.74570428900006
						],
						[
							-82.63418212499994,
							27.74570174200005
						],
						[
							-82.63400512899995,
							27.74570046900004
						],
						[
							-82.63389788099994,
							27.745708424000043
						],
						[
							-82.6338399999999,
							27.745720000000063
						],
						[
							-82.63381205399992,
							27.745738630000062
						],
						[
							-82.63378953499995,
							27.74577256100008
						],
						[
							-82.63378589799993,
							27.745870763000084
						],
						[
							-82.63378224699994,
							27.745969328000058
						],
						[
							-82.63378393399995,
							27.746146041000088
						],
						[
							-82.63378827299994,
							27.746274064000094
						],
						[
							-82.6337912699999,
							27.74636246500006
						],
						[
							-82.63379660899994,
							27.746519955000053
						],
						[
							-82.63379999999995,
							27.746620000000064
						],
						[
							-82.63364128099994,
							27.746621080000068
						],
						[
							-82.63332661899994,
							27.74662322000006
						],
						[
							-82.63315945599993,
							27.74662435700009
						],
						[
							-82.63297255899994,
							27.74662562900005
						],
						[
							-82.63265789699994,
							27.746627769000042
						],
						[
							-82.63239240199994,
							27.746629575000043
						],
						[
							-82.63218588599995,
							27.746630000000042
						],
						[
							-82.63179254099992,
							27.746630000000042
						],
						[
							-82.63148769899993,
							27.746630000000042
						],
						[
							-82.6313205269999,
							27.746630000000042
						],
						[
							-82.63120252399996,
							27.746630000000042
						],
						[
							-82.6310676629999,
							27.74660539300004
						],
						[
							-82.63087910199994,
							27.74656408900006
						],
						[
							-82.6306925959999,
							27.74652323500004
						],
						[
							-82.63038526799994,
							27.74645591600006
						],
						[
							-82.63022163899991,
							27.74642007300008
						],
						[
							-82.63018633999991,
							27.746412341000052
						],
						[
							-82.63018542599991,
							27.746347305000086
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Driftwood",
				"RegionID": "417139"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.63045999999991,
					27.743058678000057,
					-82.62226767799967,
					27.749468259000412
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.62661056799973,
							27.74946220700009
						],
						[
							-82.62498263899987,
							27.749436207000247
						],
						[
							-82.62487527199987,
							27.749428046000016
						],
						[
							-82.62469227099983,
							27.749403045000168
						],
						[
							-82.62465783399982,
							27.749397659000078
						],
						[
							-82.62449901399974,
							27.749354319000044
						],
						[
							-82.62436661399988,
							27.749303552000196
						],
						[
							-82.62423933899991,
							27.749242836000146
						],
						[
							-82.62418280199995,
							27.74920733300014
						],
						[
							-82.62401980199978,
							27.749096333000193
						],
						[
							-82.62394792699979,
							27.749041920000042
						],
						[
							-82.62385086699975,
							27.748947117000103
						],
						[
							-82.6237408669998,
							27.748822118000152
						],
						[
							-82.62369943599992,
							27.74877143000022
						],
						[
							-82.62366180199984,
							27.748717863000145
						],
						[
							-82.62362816499989,
							27.748661700000202
						],
						[
							-82.62359870199985,
							27.74860323900025
						],
						[
							-82.62345270199975,
							27.748285238000495
						],
						[
							-82.62340662399987,
							27.748161719000134
						],
						[
							-82.62330730899963,
							27.747821075000015
						],
						[
							-82.62289550399976,
							27.746674180000067
						],
						[
							-82.62267829099981,
							27.74614611100016
						],
						[
							-82.6226697369999,
							27.746124528000067
						],
						[
							-82.62245537099975,
							27.745562565000018
						],
						[
							-82.62234195899988,
							27.74526309400002
						],
						[
							-82.62229934099972,
							27.745106166000358
						],
						[
							-82.6222939249999,
							27.745071509000066
						],
						[
							-82.62227592499983,
							27.744939509000336
						],
						[
							-82.62226767799967,
							27.74481800000014
						],
						[
							-82.62227184099993,
							27.744731572000095
						],
						[
							-82.62227960599978,
							27.744672800000206
						],
						[
							-82.62228789199975,
							27.744586752000192
						],
						[
							-82.62229478199978,
							27.744517712000164
						],
						[
							-82.62230854799986,
							27.74444970900031
						],
						[
							-82.62232905099987,
							27.744383425000155
						],
						[
							-82.6223560859998,
							27.744319526000112
						],
						[
							-82.6223820219999,
							27.744259270000097
						],
						[
							-82.62240249799983,
							27.744216563000027
						],
						[
							-82.6224471649997,
							27.74411933900051
						],
						[
							-82.62254052899969,
							27.743986865000032
						],
						[
							-82.62264797799979,
							27.743861803000517
						],
						[
							-82.62275192699968,
							27.743759079000192
						],
						[
							-82.6227844089997,
							27.74373307900017
						],
						[
							-82.62289840999982,
							27.74364608000052
						],
						[
							-82.62300608899976,
							27.74357549800001
						],
						[
							-82.62329308899979,
							27.743415498000093
						],
						[
							-82.62338899699972,
							27.743369246000174
						],
						[
							-82.62369299699992,
							27.743244247000224
						],
						[
							-82.62375547299976,
							27.743221223000095
						],
						[
							-82.62396647299981,
							27.74315222200016
						],
						[
							-82.62408983399972,
							27.74312134100018
						],
						[
							-82.62415352499974,
							27.74311244500051
						],
						[
							-82.6246275259998,
							27.743063445000185
						],
						[
							-82.6247199999999,
							27.743058678000057
						],
						[
							-82.62478476399984,
							27.743061013000165
						],
						[
							-82.62503463105932,
							27.743079053943124
						],
						[
							-82.62506176399975,
							27.74308101300004
						],
						[
							-82.62513532699971,
							27.743089380000292
						],
						[
							-82.62520795199985,
							27.743103770000058
						],
						[
							-82.62527914699989,
							27.743124084000318
						],
						[
							-82.62534842999985,
							27.743150186000168
						],
						[
							-82.62553047899972,
							27.743227470000523
						],
						[
							-82.62575113699995,
							27.743302934000372
						],
						[
							-82.6259059289997,
							27.74337466000009
						],
						[
							-82.62606219699967,
							27.743467155000193
						],
						[
							-82.62618207299981,
							27.743552079000118
						],
						[
							-82.62624703499976,
							27.743615215000364
						],
						[
							-82.6265041019999,
							27.743531692000115
						],
						[
							-82.62662583399975,
							27.74350134100018
						],
						[
							-82.6267079219998,
							27.7434907340001
						],
						[
							-82.62792992199985,
							27.743389734000452
						],
						[
							-82.62800399999983,
							27.743386678000196
						],
						[
							-82.6283019999997,
							27.743386678000196
						],
						[
							-82.62845816599985,
							27.74340034100017
						],
						[
							-82.6284941829998,
							27.74340745300005
						],
						[
							-82.62875018199985,
							27.743463452000153
						],
						[
							-82.62886558599972,
							27.743496914000435
						],
						[
							-82.62895056899973,
							27.743532884000036
						],
						[
							-82.62922056999979,
							27.74366388300013
						],
						[
							-82.6292776609997,
							27.743694164000058
						],
						[
							-82.6293561759998,
							27.743745119000103
						],
						[
							-82.62963317499981,
							27.743946119000032
						],
						[
							-82.62968307299967,
							27.743985079000414
						],
						[
							-82.62977992399988,
							27.744079646000156
						],
						[
							-82.62999637759981,
							27.74432544160003
						],
						[
							-82.63017358999986,
							27.745504645000022
						],
						[
							-82.63018542599985,
							27.74634730500011
						],
						[
							-82.63011999999985,
							27.746360000000006
						],
						[
							-82.6301419979999,
							27.746471986000035
						],
						[
							-82.63025421299994,
							27.746597107000174
						],
						[
							-82.63037299299991,
							27.746674380000083
						],
						[
							-82.63043452899986,
							27.746867758000096
						],
						[
							-82.63044527099994,
							27.747147057000028
						],
						[
							-82.63045250199993,
							27.747335046000035
						],
						[
							-82.63045999999991,
							27.74753
						],
						[
							-82.63045734699996,
							27.747683890000122
						],
						[
							-82.63045291999987,
							27.747940619000136
						],
						[
							-82.6304499999999,
							27.748110000000032
						],
						[
							-82.63044524799996,
							27.748266820000214
						],
						[
							-82.63043999999987,
							27.748440000000155
						],
						[
							-82.63043999999987,
							27.748531314000072
						],
						[
							-82.62893512699988,
							27.74855205800019
						],
						[
							-82.62865451499992,
							27.748569596000042
						],
						[
							-82.62880399999996,
							27.74858900000005
						],
						[
							-82.62849222599982,
							27.749463368600328
						],
						[
							-82.62699171699965,
							27.749468259000412
						],
						[
							-82.62661056799973,
							27.74946220700009
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Tropical Shores",
				"RegionID": "417140"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.6385699999999,
					27.74570046900004,
					-82.62785298599994,
					27.756173266000076
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.62785298599994,
							27.756173266000076
						],
						[
							-82.62788905299993,
							27.756002331000047
						],
						[
							-82.62790623099994,
							27.755934316000037
						],
						[
							-82.62792863899995,
							27.755867841000054
						],
						[
							-82.62795614299995,
							27.755803307000065
						],
						[
							-82.62798857699994,
							27.755741105000084
						],
						[
							-82.6280257439999,
							27.755681609000078
						],
						[
							-82.62810292599994,
							27.75556203800005
						],
						[
							-82.62817007899991,
							27.75547092700009
						],
						[
							-82.62824124199994,
							27.75539542900009
						],
						[
							-82.6283872429999,
							27.75525742900004
						],
						[
							-82.62842692699991,
							27.755222079000077
						],
						[
							-82.62853006699993,
							27.755147312000076
						],
						[
							-82.62873106699993,
							27.75502231200005
						],
						[
							-82.62880710399992,
							27.75497998300006
						],
						[
							-82.62916832799993,
							27.754801215000043
						],
						[
							-82.62920563299993,
							27.75447867200006
						],
						[
							-82.62921333999992,
							27.754425834000074
						],
						[
							-82.62923764899996,
							27.75432343600005
						],
						[
							-82.62939165499995,
							27.75381039800004
						],
						[
							-82.62940608299994,
							27.753746514000056
						],
						[
							-82.6294490009999,
							27.75355922700004
						],
						[
							-82.62946150899997,
							27.75343698200004
						],
						[
							-82.62946424299992,
							27.753286210000056
						],
						[
							-82.62945664599994,
							27.753261321000082
						],
						[
							-82.62937562099995,
							27.753112883000085
						],
						[
							-82.62935256299994,
							27.75306765000005
						],
						[
							-82.62912756299994,
							27.75259365100004
						],
						[
							-82.62910050799991,
							27.752530542000045
						],
						[
							-82.6289517109999,
							27.75214306400005
						],
						[
							-82.62890834099994,
							27.751984165000067
						],
						[
							-82.62889582399993,
							27.751873386000057
						],
						[
							-82.62887682399992,
							27.75149738600004
						],
						[
							-82.6288795289999,
							27.751368866000064
						],
						[
							-82.62890912499995,
							27.75105007500008
						],
						[
							-82.6288894459999,
							27.750522042000057
						],
						[
							-82.62884516499992,
							27.750256354000044
						],
						[
							-82.62859457199994,
							27.749659424000072
						],
						[
							-82.62851603899992,
							27.74949836500008
						],
						[
							-82.62849294199992,
							27.749464421000084
						],
						[
							-82.62880399999996,
							27.748589000000038
						],
						[
							-82.62865451499994,
							27.74856959600004
						],
						[
							-82.62893512699992,
							27.748552058000087
						],
						[
							-82.63043999999991,
							27.748531314000047
						],
						[
							-82.63043999999991,
							27.748440000000073
						],
						[
							-82.63044524799996,
							27.748266820000083
						],
						[
							-82.63044999999994,
							27.748110000000054
						],
						[
							-82.63045291999993,
							27.74794061900008
						],
						[
							-82.63045734699995,
							27.74768389000008
						],
						[
							-82.63045999999991,
							27.74753000000004
						],
						[
							-82.63045250199991,
							27.747335046000046
						],
						[
							-82.63044527099993,
							27.747147057000063
						],
						[
							-82.6304345289999,
							27.746867758000064
						],
						[
							-82.63037299299992,
							27.74667438000006
						],
						[
							-82.63025421299994,
							27.74659710700007
						],
						[
							-82.63014199799994,
							27.746471986000074
						],
						[
							-82.63011999999993,
							27.74636000000004
						],
						[
							-82.63018542599991,
							27.746347305000086
						],
						[
							-82.63018633999991,
							27.746412341000052
						],
						[
							-82.63022163899991,
							27.74642007300008
						],
						[
							-82.63038526799994,
							27.74645591600006
						],
						[
							-82.6306925959999,
							27.74652323500004
						],
						[
							-82.63087910199994,
							27.74656408900006
						],
						[
							-82.6310676629999,
							27.74660539300004
						],
						[
							-82.63120252399996,
							27.746630000000042
						],
						[
							-82.6313205269999,
							27.746630000000042
						],
						[
							-82.63148769899993,
							27.746630000000042
						],
						[
							-82.63179254099992,
							27.746630000000042
						],
						[
							-82.63218588599995,
							27.746630000000042
						],
						[
							-82.63239240199994,
							27.746629575000043
						],
						[
							-82.63265789699994,
							27.746627769000042
						],
						[
							-82.63297255899994,
							27.74662562900005
						],
						[
							-82.63315945599993,
							27.74662435700009
						],
						[
							-82.63332661899994,
							27.74662322000006
						],
						[
							-82.63364128099994,
							27.746621080000068
						],
						[
							-82.63379999999995,
							27.746620000000064
						],
						[
							-82.63379660899994,
							27.746519955000053
						],
						[
							-82.6337912699999,
							27.74636246500006
						],
						[
							-82.63378827299994,
							27.746274064000094
						],
						[
							-82.63378393399995,
							27.746146041000088
						],
						[
							-82.63378224699994,
							27.745969328000058
						],
						[
							-82.63378589799993,
							27.745870763000084
						],
						[
							-82.63378953499995,
							27.74577256100008
						],
						[
							-82.63381205399992,
							27.745738630000062
						],
						[
							-82.6338399999999,
							27.745720000000063
						],
						[
							-82.63389788099994,
							27.745708424000043
						],
						[
							-82.63400512899995,
							27.74570046900004
						],
						[
							-82.63418212499994,
							27.74570174200005
						],
						[
							-82.63453611699994,
							27.74570428900006
						],
						[
							-82.63466401799991,
							27.745705209000054
						],
						[
							-82.63495901099992,
							27.745707331000062
						],
						[
							-82.63522450499994,
							27.745709241000043
						],
						[
							-82.63533101799993,
							27.745711100000054
						],
						[
							-82.63544684899995,
							27.745836197000074
						],
						[
							-82.63557999999995,
							27.74598000000009
						],
						[
							-82.63575081999994,
							27.74616149700006
						],
						[
							-82.6359690029999,
							27.746407821000048
						],
						[
							-82.63611999999995,
							27.746600000000058
						],
						[
							-82.6362469309999,
							27.74675983900005
						],
						[
							-82.6363677789999,
							27.746912018000046
						],
						[
							-82.63659999999993,
							27.747190000000046
						],
						[
							-82.63672713999995,
							27.747346479000043
						],
						[
							-82.6368599999999,
							27.74751000000009
						],
						[
							-82.6369481289999,
							27.74761815900007
						],
						[
							-82.63707999999991,
							27.747780000000038
						],
						[
							-82.63726155399992,
							27.748001899000087
						],
						[
							-82.63744554599992,
							27.74822677800006
						],
						[
							-82.63761999999991,
							27.748440000000073
						],
						[
							-82.63798153399995,
							27.748440000000073
						],
						[
							-82.63832338799995,
							27.748440000000073
						],
						[
							-82.6385594809999,
							27.748440000000073
						],
						[
							-82.63855858699992,
							27.748585550000087
						],
						[
							-82.63855411899993,
							27.749045694000074
						],
						[
							-82.63855227999994,
							27.749235166000066
						],
						[
							-82.63854999999995,
							27.749470000000088
						],
						[
							-82.63855506599992,
							27.74973594100004
						],
						[
							-82.63856202399995,
							27.750101252000036
						],
						[
							-82.6385661519999,
							27.750317991000088
						],
						[
							-82.6385699999999,
							27.750520000000055
						],
						[
							-82.63856589599993,
							27.75073753500004
						],
						[
							-82.6385584919999,
							27.751129908000053
						],
						[
							-82.63854999999995,
							27.751580000000047
						],
						[
							-82.63854574299995,
							27.751792856000066
						],
						[
							-82.6385424849999,
							27.751955751000082
						],
						[
							-82.63853999999992,
							27.752080000000035
						],
						[
							-82.63853606899994,
							27.75228046300009
						],
						[
							-82.63853234999993,
							27.752470145000075
						],
						[
							-82.63852999999995,
							27.752590000000055
						],
						[
							-82.63852454999994,
							27.752808017000064
						],
						[
							-82.63851547599995,
							27.753267859000065
						],
						[
							-82.63850999999995,
							27.753460000000075
						],
						[
							-82.63850702299995,
							27.753674370000056
						],
						[
							-82.63722999999993,
							27.753670000000056
						],
						[
							-82.63705118099995,
							27.75367576800005
						],
						[
							-82.63691999999992,
							27.753680000000088
						],
						[
							-82.63691412899993,
							27.754202483000086
						],
						[
							-82.63541296999995,
							27.754202474000067
						],
						[
							-82.63540533399993,
							27.75432465700004
						],
						[
							-82.63539377099994,
							27.754430763000073
						],
						[
							-82.63537290999994,
							27.754500300000075
						],
						[
							-82.63533999999993,
							27.754560000000083
						],
						[
							-82.63529829299995,
							27.754601707000063
						],
						[
							-82.63523314499992,
							27.754654919000075
						],
						[
							-82.6351334009999,
							27.754697320000048
						],
						[
							-82.63502113099992,
							27.754711377000035
						],
						[
							-82.6348182669999,
							27.75471709100009
						],
						[
							-82.63442568399995,
							27.754728150000062
						],
						[
							-82.63408683599994,
							27.754724309000043
						],
						[
							-82.63387999999992,
							27.754720000000077
						],
						[
							-82.6338836839999,
							27.754906057000085
						],
						[
							-82.63388877499995,
							27.75516312000008
						],
						[
							-82.63389441699991,
							27.755448046000083
						],
						[
							-82.63389999999993,
							27.755730000000085
						],
						[
							-82.63383031199993,
							27.75574742200007
						],
						[
							-82.63369433199995,
							27.755755891000035
						],
						[
							-82.63353163499994,
							27.75576351700005
						],
						[
							-82.63335543399995,
							27.755771777000064
						],
						[
							-82.6330989409999,
							27.755780000000073
						],
						[
							-82.63281470699991,
							27.755780000000073
						],
						[
							-82.6326699999999,
							27.755780000000073
						],
						[
							-82.63254435899995,
							27.755801662000067
						],
						[
							-82.63246096199993,
							27.755816041000063
						],
						[
							-82.6323799999999,
							27.75583000000006
						],
						[
							-82.63211099699993,
							27.75582273000009
						],
						[
							-82.63188070599995,
							27.755816506000087
						],
						[
							-82.63152918199995,
							27.75580565400009
						],
						[
							-82.63137999599991,
							27.755799804000052
						],
						[
							-82.63116376999994,
							27.755791324000086
						],
						[
							-82.63109534199992,
							27.755797702000052
						],
						[
							-82.6310142019999,
							27.755826124000066
						],
						[
							-82.63095337099992,
							27.755864143000053
						],
						[
							-82.63087999999993,
							27.755910000000085
						],
						[
							-82.63081473699992,
							27.755961316000082
						],
						[
							-82.63073020699996,
							27.755974149000053
						],
						[
							-82.63033788799993,
							27.755983189000062
						],
						[
							-82.62993187899991,
							27.755987209000068
						],
						[
							-82.62962247799993,
							27.75599315800008
						],
						[
							-82.62928390299993,
							27.75603201100006
						],
						[
							-82.62910716999994,
							27.75605229200005
						],
						[
							-82.62903999999992,
							27.756060000000048
						],
						[
							-82.62885286499994,
							27.75605852600006
						],
						[
							-82.62785298599994,
							27.756173266000076
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Old Southeast",
				"RegionID": "417141"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.64661999999993,
					27.748420000000067,
					-82.63844999999992,
					27.75941000000006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.63984628999992,
							27.74843000000004
						],
						[
							-82.64036394199991,
							27.748420000000067
						],
						[
							-82.64106982999994,
							27.748420000000067
						],
						[
							-82.64201101499992,
							27.748420000000067
						],
						[
							-82.64309340099993,
							27.74842591600009
						],
						[
							-82.64403456299995,
							27.74843000000004
						],
						[
							-82.64502280699992,
							27.74843000000004
						],
						[
							-82.64615222899994,
							27.74843000000004
						],
						[
							-82.64657999999991,
							27.748420000000067
						],
						[
							-82.64661999999993,
							27.74842033400006
						],
						[
							-82.64661999999993,
							27.74871408300004
						],
						[
							-82.64661999999993,
							27.748954704000084
						],
						[
							-82.64661999999993,
							27.74921938700004
						],
						[
							-82.64661999999993,
							27.749340000000075
						],
						[
							-82.64661999999993,
							27.749532195000086
						],
						[
							-82.64661999999993,
							27.749748754000052
						],
						[
							-82.64661999999993,
							27.74998937500004
						],
						[
							-82.64658999999995,
							27.750240000000076
						],
						[
							-82.64658999999995,
							27.750398431000065
						],
						[
							-82.64658999999995,
							27.750614990000088
						],
						[
							-82.64658999999995,
							27.750951860000043
						],
						[
							-82.64658999999995,
							27.75117000000006
						],
						[
							-82.6465923849999,
							27.751384620000067
						],
						[
							-82.64659452599994,
							27.751577361000045
						],
						[
							-82.6465969379999,
							27.751794428000043
						],
						[
							-82.64659999999992,
							27.75207000000006
						],
						[
							-82.64659999999992,
							27.75207157400007
						],
						[
							-82.64659999999992,
							27.75229933900005
						],
						[
							-82.64659999999992,
							27.752539960000036
						],
						[
							-82.64659504499991,
							27.753021336000074
						],
						[
							-82.64659207499994,
							27.753261920000057
						],
						[
							-82.64658999999995,
							27.753430000000037
						],
						[
							-82.64658999999995,
							27.75359869300007
						],
						[
							-82.64658999999995,
							27.75376712800005
						],
						[
							-82.64658999999995,
							27.75395962500005
						],
						[
							-82.64658999999995,
							27.75413000000009
						],
						[
							-82.64658999999995,
							27.754320000000064
						],
						[
							-82.64658999999995,
							27.75453711600005
						],
						[
							-82.64658999999995,
							27.754753675000075
						],
						[
							-82.64658999999995,
							27.754890000000046
						],
						[
							-82.64659573999995,
							27.755090904000042
						],
						[
							-82.64659999999992,
							27.75524000000007
						],
						[
							-82.64659999999992,
							27.75535522800004
						],
						[
							-82.64659999999992,
							27.75547553900009
						],
						[
							-82.64659999999992,
							27.75562000000008
						],
						[
							-82.6466031189999,
							27.755788443000085
						],
						[
							-82.6466062369999,
							27.75595682000005
						],
						[
							-82.6466099999999,
							27.75616000000008
						],
						[
							-82.6466099999999,
							27.756341775000067
						],
						[
							-82.6466099999999,
							27.756510210000044
						],
						[
							-82.6466099999999,
							27.756650000000036
						],
						[
							-82.64661552399991,
							27.75687096200005
						],
						[
							-82.64661999999993,
							27.75705000000005
						],
						[
							-82.64661999999993,
							27.757328322000035
						],
						[
							-82.64661999999993,
							27.757593006000036
						],
						[
							-82.64661999999993,
							27.757790000000057
						],
						[
							-82.64661999999993,
							27.757940000000076
						],
						[
							-82.64661999999993,
							27.75824268300005
						],
						[
							-82.64661999999993,
							27.758420000000058
						],
						[
							-82.64660831399993,
							27.758579791000045
						],
						[
							-82.64661999999993,
							27.758796112000084
						],
						[
							-82.6466154869999,
							27.759085032000087
						],
						[
							-82.6466099999999,
							27.759310000000085
						],
						[
							-82.64631957699993,
							27.759325558000057
						],
						[
							-82.64605436599993,
							27.75933976600004
						],
						[
							-82.64571795799992,
							27.75934626500009
						],
						[
							-82.64551999999992,
							27.75935000000004
						],
						[
							-82.64538128399994,
							27.759354080000037
						],
						[
							-82.64517999999993,
							27.759360000000072
						],
						[
							-82.64499644599994,
							27.759363746000076
						],
						[
							-82.64475543399995,
							27.759368665000068
						],
						[
							-82.64439460299991,
							27.759370000000047
						],
						[
							-82.64405999999991,
							27.759370000000047
						],
						[
							-82.64369685999992,
							27.75937672500004
						],
						[
							-82.64351999999991,
							27.75938000000008
						],
						[
							-82.64326368399992,
							27.75938000000008
						],
						[
							-82.64299999999992,
							27.75938000000008
						],
						[
							-82.64278244099995,
							27.75938000000008
						],
						[
							-82.64242150899992,
							27.75938000000008
						],
						[
							-82.64200999999991,
							27.75938000000008
						],
						[
							-82.64181995599995,
							27.75938000000008
						],
						[
							-82.6415199999999,
							27.75938000000008
						],
						[
							-82.64121840299993,
							27.75938000000008
						],
						[
							-82.64078528499994,
							27.75938000000008
						],
						[
							-82.64025591799992,
							27.75938000000008
						],
						[
							-82.64005999999995,
							27.75938000000008
						],
						[
							-82.63982247799993,
							27.759387662000055
						],
						[
							-82.63948592999992,
							27.759390000000053
						],
						[
							-82.63902783299994,
							27.75939329600004
						],
						[
							-82.63866727599992,
							27.759404927000052
						],
						[
							-82.63844999999992,
							27.75941000000006
						],
						[
							-82.63844999999992,
							27.758723925000083
						],
						[
							-82.63844999999992,
							27.75824268300005
						],
						[
							-82.63844999999992,
							27.757850000000076
						],
						[
							-82.63845999999995,
							27.75774000000007
						],
						[
							-82.63845999999995,
							27.757544881000058
						],
						[
							-82.63845999999995,
							27.757280198000046
						],
						[
							-82.63845999999995,
							27.757010000000037
						],
						[
							-82.63845999999995,
							27.75694332800009
						],
						[
							-82.63845999999995,
							27.75679000000008
						],
						[
							-82.6384623749999,
							27.75667837000009
						],
						[
							-82.63846698099991,
							27.756461908000063
						],
						[
							-82.63846999999993,
							27.756320000000073
						],
						[
							-82.63846999999993,
							27.756149278000066
						],
						[
							-82.63846999999993,
							27.75598084300009
						],
						[
							-82.63846999999993,
							27.75574000000006
						],
						[
							-82.63846999999993,
							27.75565000000006
						],
						[
							-82.63847975599992,
							27.75533130200006
						],
						[
							-82.6384878739999,
							27.755066130000046
						],
						[
							-82.63849376099995,
							27.754873814000064
						],
						[
							-82.63849999999991,
							27.75467000000009
						],
						[
							-82.63849999999991,
							27.754440868000074
						],
						[
							-82.63849999999991,
							27.754180000000076
						],
						[
							-82.63850406199992,
							27.75388750400009
						],
						[
							-82.63850702299995,
							27.753674370000056
						],
						[
							-82.63850999999995,
							27.753460000000075
						],
						[
							-82.63851547599995,
							27.753267859000065
						],
						[
							-82.63852454999994,
							27.752808017000064
						],
						[
							-82.63852999999995,
							27.752590000000055
						],
						[
							-82.63853234999993,
							27.752470145000075
						],
						[
							-82.63853606899994,
							27.75228046300009
						],
						[
							-82.63853999999992,
							27.752080000000035
						],
						[
							-82.6385424849999,
							27.751955751000082
						],
						[
							-82.63854574299995,
							27.751792856000066
						],
						[
							-82.63854999999995,
							27.751580000000047
						],
						[
							-82.6385584919999,
							27.751129908000053
						],
						[
							-82.63856589599993,
							27.75073753500004
						],
						[
							-82.6385699999999,
							27.750520000000055
						],
						[
							-82.6385661519999,
							27.750317991000088
						],
						[
							-82.63856202399995,
							27.750101252000036
						],
						[
							-82.63855506599992,
							27.74973594100004
						],
						[
							-82.63854999999995,
							27.749470000000088
						],
						[
							-82.63855227999994,
							27.749235166000066
						],
						[
							-82.63855411899993,
							27.749045694000074
						],
						[
							-82.63855858699992,
							27.748585550000087
						],
						[
							-82.6385594809999,
							27.748440000000073
						],
						[
							-82.63855999999993,
							27.748440000000073
						],
						[
							-82.63923456899995,
							27.748432973000035
						],
						[
							-82.63984628999992,
							27.74843000000004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Bartlett Park",
				"RegionID": "417142"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.6547599999999,
					27.74837021500008,
					-82.64658999999995,
					27.75207157400007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.64661999999993,
							27.74871408300004
						],
						[
							-82.64661999999993,
							27.74842033400006
						],
						[
							-82.64695159599995,
							27.748423099000036
						],
						[
							-82.64723254799992,
							27.74842572500006
						],
						[
							-82.64744850999995,
							27.748427743000036
						],
						[
							-82.6476899999999,
							27.74843000000004
						],
						[
							-82.64803157499995,
							27.748427432000085
						],
						[
							-82.6483556899999,
							27.74842499500005
						],
						[
							-82.64861485299991,
							27.748423046000084
						],
						[
							-82.64901999999995,
							27.748420000000067
						],
						[
							-82.64910999999995,
							27.748420000000067
						],
						[
							-82.64945708699992,
							27.748420000000067
						],
						[
							-82.64985999999993,
							27.748420000000067
						],
						[
							-82.64999703899991,
							27.748420000000067
						],
						[
							-82.65012999999993,
							27.748420000000067
						],
						[
							-82.65034270299992,
							27.748415987000048
						],
						[
							-82.6506599999999,
							27.748410000000035
						],
						[
							-82.65092575699992,
							27.748410000000035
						],
						[
							-82.65114999999992,
							27.748410000000035
						],
						[
							-82.6514874849999,
							27.74840648500009
						],
						[
							-82.6518546129999,
							27.748402660000067
						],
						[
							-82.65237282899994,
							27.74840000000006
						],
						[
							-82.65280478999995,
							27.74840000000006
						],
						[
							-82.65340962999994,
							27.74839524400005
						],
						[
							-82.65394946199991,
							27.74838728000009
						],
						[
							-82.65412249799994,
							27.748385032000044
						],
						[
							-82.6544461339999,
							27.748380829000045
						],
						[
							-82.6546459509999,
							27.74837021500008
						],
						[
							-82.65467453399992,
							27.74852070600008
						],
						[
							-82.6546827869999,
							27.748571404000074
						],
						[
							-82.65470630399994,
							27.748715865000065
						],
						[
							-82.65472211899993,
							27.748858278000057
						],
						[
							-82.65472823599993,
							27.749026491000052
						],
						[
							-82.65473438499993,
							27.74919557700008
						],
						[
							-82.65473999999995,
							27.74935000000005
						],
						[
							-82.65473999999995,
							27.74967656700005
						],
						[
							-82.65473999999995,
							27.74998937500004
						],
						[
							-82.65473999999995,
							27.75021000000004
						],
						[
							-82.65474315199992,
							27.750350266000055
						],
						[
							-82.65474585399994,
							27.750470515000075
						],
						[
							-82.65475235199995,
							27.75075965600007
						],
						[
							-82.65475559499993,
							27.750903956000062
						],
						[
							-82.6547599999999,
							27.751100000000065
						],
						[
							-82.6547585209999,
							27.751240533000043
						],
						[
							-82.6547564949999,
							27.751433009000042
						],
						[
							-82.65475471899992,
							27.751601678000043
						],
						[
							-82.65475218699993,
							27.751842273000083
						],
						[
							-82.65474999999992,
							27.752050000000054
						],
						[
							-82.65438038399992,
							27.752050000000054
						],
						[
							-82.65401945199994,
							27.752050000000054
						],
						[
							-82.65377999999993,
							27.752050000000054
						],
						[
							-82.65341789899992,
							27.752050000000054
						],
						[
							-82.65314999999993,
							27.752050000000054
						],
						[
							-82.65279228399993,
							27.752050000000054
						],
						[
							-82.65243135199995,
							27.752050000000054
						],
						[
							-82.65208999999993,
							27.752050000000054
						],
						[
							-82.6518057369999,
							27.752050000000054
						],
						[
							-82.65149292899991,
							27.752050000000054
						],
						[
							-82.65116999999992,
							27.752050000000054
						],
						[
							-82.65093950099993,
							27.752050000000054
						],
						[
							-82.65067999999991,
							27.752050000000054
						],
						[
							-82.65038607199995,
							27.752050000000054
						],
						[
							-82.65019357499995,
							27.752050000000054
						],
						[
							-82.64983999999993,
							27.752050000000054
						],
						[
							-82.64971219499995,
							27.752055557000062
						],
						[
							-82.64960999999994,
							27.752060000000085
						],
						[
							-82.64939952499992,
							27.752060000000085
						],
						[
							-82.64911999999993,
							27.752060000000085
						],
						[
							-82.64884609599994,
							27.752060000000085
						],
						[
							-82.6486099999999,
							27.752060000000085
						],
						[
							-82.64843712299995,
							27.75206320100006
						],
						[
							-82.64806999999992,
							27.75207000000006
						],
						[
							-82.6479076729999,
							27.75207000000006
						],
						[
							-82.64781999999991,
							27.75207000000006
						],
						[
							-82.64749861699994,
							27.75207000000006
						],
						[
							-82.6471376849999,
							27.75207000000006
						],
						[
							-82.64659999999992,
							27.75207157400007
						],
						[
							-82.64659999999992,
							27.75207000000006
						],
						[
							-82.6465969379999,
							27.751794428000043
						],
						[
							-82.64659452599994,
							27.751577361000045
						],
						[
							-82.6465923849999,
							27.751384620000067
						],
						[
							-82.64658999999995,
							27.75117000000006
						],
						[
							-82.64658999999995,
							27.750951860000043
						],
						[
							-82.64658999999995,
							27.750614990000088
						],
						[
							-82.64658999999995,
							27.750398431000065
						],
						[
							-82.64658999999995,
							27.750240000000076
						],
						[
							-82.64661999999993,
							27.74998937500004
						],
						[
							-82.64661999999993,
							27.749748754000052
						],
						[
							-82.64661999999993,
							27.749532195000086
						],
						[
							-82.64661999999993,
							27.749340000000075
						],
						[
							-82.64661999999993,
							27.74921938700004
						],
						[
							-82.64661999999993,
							27.748954704000084
						],
						[
							-82.64661999999993,
							27.74871408300004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Cromwell Heights",
				"RegionID": "417143"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.65482999999995,
					27.777450000000048,
					-82.63849999999991,
					27.784467342000088
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.64475698299992,
							27.784333557000082
						],
						[
							-82.64453999999995,
							27.784330000000068
						],
						[
							-82.64438662499992,
							27.784331268000074
						],
						[
							-82.64395830799992,
							27.78433480700005
						],
						[
							-82.6436688089999,
							27.78433720000004
						],
						[
							-82.64347201499993,
							27.78433882600007
						],
						[
							-82.6431826029999,
							27.784340000000046
						],
						[
							-82.64268479599991,
							27.784340000000046
						],
						[
							-82.64246484199992,
							27.78434120700007
						],
						[
							-82.64211632399991,
							27.784343920000083
						],
						[
							-82.64156082599993,
							27.784348243000068
						],
						[
							-82.64114890699994,
							27.784351448000052
						],
						[
							-82.64028454999993,
							27.78435817500008
						],
						[
							-82.63950242899995,
							27.78436000000005
						],
						[
							-82.6390290619999,
							27.78436000000005
						],
						[
							-82.63850999999995,
							27.78436000000005
						],
						[
							-82.63850999999995,
							27.78410671000006
						],
						[
							-82.63850999999995,
							27.783880000000067
						],
						[
							-82.63851300499995,
							27.783756793000066
						],
						[
							-82.63851999999991,
							27.783470000000083
						],
						[
							-82.63851450399994,
							27.783200719000035
						],
						[
							-82.63850999999995,
							27.78298000000007
						],
						[
							-82.63850999999995,
							27.78281009500006
						],
						[
							-82.63850999999995,
							27.78255000000007
						],
						[
							-82.63850458199994,
							27.782295340000076
						],
						[
							-82.63849999999991,
							27.782080000000065
						],
						[
							-82.63849999999991,
							27.78192000000007
						],
						[
							-82.63850492699993,
							27.78174017400005
						],
						[
							-82.63851112499992,
							27.78151395100008
						],
						[
							-82.63851677499991,
							27.781307730000037
						],
						[
							-82.63851999999991,
							27.781190000000038
						],
						[
							-82.63852555099993,
							27.780937450000067
						],
						[
							-82.63853052399992,
							27.780711166000064
						],
						[
							-82.6385364109999,
							27.780443287000082
						],
						[
							-82.63853999999992,
							27.78028000000006
						],
						[
							-82.63853999999992,
							27.780011054000056
						],
						[
							-82.63853999999992,
							27.779722917000072
						],
						[
							-82.63853999999992,
							27.779490000000067
						],
						[
							-82.63853764399994,
							27.779208622000056
						],
						[
							-82.63853282699995,
							27.778837689000056
						],
						[
							-82.63852999999995,
							27.77862000000005
						],
						[
							-82.63852999999995,
							27.778364559000067
						],
						[
							-82.63852999999995,
							27.77782944800009
						],
						[
							-82.63852934399995,
							27.77752000000004
						],
						[
							-82.63852999999995,
							27.77752000000004
						],
						[
							-82.63883792999991,
							27.777517470000078
						],
						[
							-82.6392132819999,
							27.777513640000052
						],
						[
							-82.63956999999994,
							27.777510000000063
						],
						[
							-82.63981372699993,
							27.777506069000083
						],
						[
							-82.63996444999992,
							27.77750363800004
						],
						[
							-82.6401899999999,
							27.77750000000009
						],
						[
							-82.64033955899993,
							27.77750000000009
						],
						[
							-82.64057999999994,
							27.77750000000009
						],
						[
							-82.64086510599992,
							27.77750000000009
						],
						[
							-82.6413531149999,
							27.77750000000009
						],
						[
							-82.64199128099995,
							27.77750000000009
						],
						[
							-82.64225405499991,
							27.77750000000009
						],
						[
							-82.6425799999999,
							27.777510000000063
						],
						[
							-82.64300483699992,
							27.777510000000063
						],
						[
							-82.64341999999994,
							27.777510000000063
						],
						[
							-82.64405600299995,
							27.77751534500004
						],
						[
							-82.64460999999994,
							27.77752000000004
						],
						[
							-82.64503195099992,
							27.77752000000004
						],
						[
							-82.64582027299991,
							27.77752000000004
						],
						[
							-82.64623289799994,
							27.77751218900005
						],
						[
							-82.64642146099993,
							27.777507161000074
						],
						[
							-82.64668999999992,
							27.77750000000009
						],
						[
							-82.64769999999993,
							27.777480000000082
						],
						[
							-82.64823163099993,
							27.777480000000082
						],
						[
							-82.64872999999994,
							27.777480000000082
						],
						[
							-82.64914836799994,
							27.777480000000082
						],
						[
							-82.64972999999992,
							27.777480000000082
						],
						[
							-82.65035459899991,
							27.777480000000082
						],
						[
							-82.65112611099994,
							27.77747166200004
						],
						[
							-82.65175398499991,
							27.777461110000047
						],
						[
							-82.65268999999995,
							27.777450000000048
						],
						[
							-82.65320126999991,
							27.77745532600005
						],
						[
							-82.65364999999991,
							27.777460000000076
						],
						[
							-82.65421451999993,
							27.777453861000083
						],
						[
							-82.65480999999994,
							27.777460000000076
						],
						[
							-82.65481270299995,
							27.77773840800006
						],
						[
							-82.65481502999995,
							27.77797809100008
						],
						[
							-82.6548185179999,
							27.778337368000052
						],
						[
							-82.65481999999993,
							27.778936141000088
						],
						[
							-82.65481999999993,
							27.779270000000054
						],
						[
							-82.65482200899993,
							27.77963767500006
						],
						[
							-82.65482359899994,
							27.779928537000046
						],
						[
							-82.65482668399994,
							27.78049315000004
						],
						[
							-82.65482864699993,
							27.780852449000065
						],
						[
							-82.65482999999995,
							27.781100000000038
						],
						[
							-82.6546039989999,
							27.781100000000038
						],
						[
							-82.65410780899992,
							27.781100000000038
						],
						[
							-82.65393999999992,
							27.781100000000038
						],
						[
							-82.6538340489999,
							27.781100000000038
						],
						[
							-82.65365999999995,
							27.781100000000038
						],
						[
							-82.65349184799993,
							27.781100000000038
						],
						[
							-82.65318386799993,
							27.781100000000038
						],
						[
							-82.65283999999991,
							27.781100000000038
						],
						[
							-82.65269999999992,
							27.781100000000038
						],
						[
							-82.65255079799994,
							27.781100000000038
						],
						[
							-82.65237969799995,
							27.781100000000038
						],
						[
							-82.65208882799993,
							27.781100000000038
						],
						[
							-82.6518299999999,
							27.781100000000038
						],
						[
							-82.65170999999992,
							27.781100000000038
						],
						[
							-82.65152430799992,
							27.781102041000054
						],
						[
							-82.65131901299992,
							27.78110429700007
						],
						[
							-82.65116485399994,
							27.781105991000064
						],
						[
							-82.65099377399993,
							27.781107871000074
						],
						[
							-82.65079999999995,
							27.78111000000007
						],
						[
							-82.65066871899995,
							27.78111126200008
						],
						[
							-82.65048052599992,
							27.78111307200004
						],
						[
							-82.6502067909999,
							27.78111570400006
						],
						[
							-82.6500185989999,
							27.781117513000083
						],
						[
							-82.6497599999999,
							27.781120000000044
						],
						[
							-82.64959088899991,
							27.781121642000073
						],
						[
							-82.64924872099995,
							27.78112496400007
						],
						[
							-82.64897498699992,
							27.781127621000053
						],
						[
							-82.64872999999994,
							27.781130000000076
						],
						[
							-82.64846174099995,
							27.781132656000068
						],
						[
							-82.64832487399991,
							27.781134011000063
						],
						[
							-82.64817055999993,
							27.781135539000047
						],
						[
							-82.6479310439999,
							27.781137910000044
						],
						[
							-82.64771999999994,
							27.78114000000005
						],
						[
							-82.64734935699994,
							27.78114000000005
						],
						[
							-82.64704137699994,
							27.78114000000005
						],
						[
							-82.64667999999995,
							27.78114000000005
						],
						[
							-82.64667999999995,
							27.781451311000072
						],
						[
							-82.64667999999995,
							27.781793512000036
						],
						[
							-82.64668247299994,
							27.78223836500007
						],
						[
							-82.64669221899993,
							27.782854195000084
						],
						[
							-82.64669707699994,
							27.78321367000007
						],
						[
							-82.6466999999999,
							27.783430000000067
						],
						[
							-82.6466999999999,
							27.783850000000086
						],
						[
							-82.64630570399993,
							27.783866686000067
						],
						[
							-82.6459804019999,
							27.783873192000044
						],
						[
							-82.6456399999999,
							27.783880000000067
						],
						[
							-82.64563854699993,
							27.783964250000054
						],
						[
							-82.64563703099992,
							27.784052220000035
						],
						[
							-82.64563476099994,
							27.784183881000047
						],
						[
							-82.6456318139999,
							27.78435477000005
						],
						[
							-82.6456300609999,
							27.784462387000076
						],
						[
							-82.64515254699995,
							27.784467342000088
						],
						[
							-82.64514999999994,
							27.784340000000046
						],
						[
							-82.64498864899993,
							27.784337355000048
						],
						[
							-82.6448727209999,
							27.784335454000086
						],
						[
							-82.64475698299992,
							27.784333557000082
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Historic Uptown",
				"RegionID": "417156"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.6794999469999,
					27.771840500000053,
					-82.6579999679999,
					27.781070000000057
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.66054999999994,
							27.781070000000057
						],
						[
							-82.6603938319999,
							27.78064795100005
						],
						[
							-82.66021848499992,
							27.780195671000058
						],
						[
							-82.66006637099991,
							27.779761060000055
						],
						[
							-82.65993488599992,
							27.779384659000076
						],
						[
							-82.65964278699994,
							27.778503214000068
						],
						[
							-82.65944097999994,
							27.777898806000053
						],
						[
							-82.65931111799995,
							27.777513353000074
						],
						[
							-82.65923843199994,
							27.77729490300004
						],
						[
							-82.65909567699993,
							27.776857031000077
						],
						[
							-82.65895157799991,
							27.77641957600008
						],
						[
							-82.6587943479999,
							27.775930403000075
						],
						[
							-82.65861490799996,
							27.775383498000053
						],
						[
							-82.6585194239999,
							27.775066761000062
						],
						[
							-82.65832749399993,
							27.774476229000072
						],
						[
							-82.65823817699993,
							27.774086525000087
						],
						[
							-82.65813393499991,
							27.77338620000006
						],
						[
							-82.6579999679999,
							27.77251391500005
						],
						[
							-82.65840603899994,
							27.772448934000067
						],
						[
							-82.65976055999994,
							27.772466299000087
						],
						[
							-82.66087196199993,
							27.772448934000067
						],
						[
							-82.66213965499992,
							27.772448934000067
						],
						[
							-82.66337261599995,
							27.77243156800006
						],
						[
							-82.66462294299993,
							27.77243156800006
						],
						[
							-82.66566488199993,
							27.77243156800006
						],
						[
							-82.66609902399995,
							27.77243156800006
						],
						[
							-82.6670714999999,
							27.77243156800006
						],
						[
							-82.66759246999993,
							27.77243156800006
						],
						[
							-82.66830446199992,
							27.77241420300004
						],
						[
							-82.6689817219999,
							27.77241420300004
						],
						[
							-82.66974581099993,
							27.772396837000088
						],
						[
							-82.67089194399995,
							27.772396837000088
						],
						[
							-82.67202071199995,
							27.772396837000088
						],
						[
							-82.67309738299991,
							27.772396837000088
						],
						[
							-82.67415668799993,
							27.772396837000088
						],
						[
							-82.6753188539999,
							27.77237944300009
						],
						[
							-82.67532456399995,
							27.772108222000043
						],
						[
							-82.67532999999992,
							27.771850000000086
						],
						[
							-82.67579484799991,
							27.771850000000086
						],
						[
							-82.67662839899992,
							27.771850000000086
						],
						[
							-82.67686999999995,
							27.771850000000086
						],
						[
							-82.67749276599994,
							27.77184746800009
						],
						[
							-82.67792497099992,
							27.771845712000072
						],
						[
							-82.67838817299992,
							27.77184382900009
						],
						[
							-82.67894386499995,
							27.77184157000005
						],
						[
							-82.67946999499992,
							27.771840500000053
						],
						[
							-82.67946857099992,
							27.771975765000036
						],
						[
							-82.67946461299994,
							27.772351748000062
						],
						[
							-82.6794627829999,
							27.77252558400005
						],
						[
							-82.67945999999995,
							27.772790000000043
						],
						[
							-82.67945999999995,
							27.773103974000037
						],
						[
							-82.67945999999995,
							27.773451074000036
						],
						[
							-82.67945999999995,
							27.77371000000005
						],
						[
							-82.67945999999995,
							27.77417420000006
						],
						[
							-82.67945999999995,
							27.774610000000052
						],
						[
							-82.67945999999995,
							27.774926251000068
						],
						[
							-82.67945999999995,
							27.775244426000086
						],
						[
							-82.67945999999995,
							27.775520000000085
						],
						[
							-82.6794680989999,
							27.775880421000068
						],
						[
							-82.67947396099993,
							27.776141265000035
						],
						[
							-82.6794799999999,
							27.776410000000055
						],
						[
							-82.6794799999999,
							27.776748528000045
						],
						[
							-82.6794799999999,
							27.77697992800006
						],
						[
							-82.6794799999999,
							27.777645204000066
						],
						[
							-82.6794799999999,
							27.778310480000073
						],
						[
							-82.6794799999999,
							27.77874435500007
						],
						[
							-82.6794827189999,
							27.779322840000077
						],
						[
							-82.67948582899993,
							27.779612056000076
						],
						[
							-82.67949211699994,
							27.78019048600004
						],
						[
							-82.67949629799995,
							27.780566786000065
						],
						[
							-82.6794999469999,
							27.780904122000038
						],
						[
							-82.6789695409999,
							27.78090927900007
						],
						[
							-82.6783628899999,
							27.780917214000056
						],
						[
							-82.67792633599993,
							27.780925935000084
						],
						[
							-82.67756120099995,
							27.78093607800008
						],
						[
							-82.67710072099993,
							27.780940000000044
						],
						[
							-82.67659106399992,
							27.780941993000056
						],
						[
							-82.67615419999993,
							27.78094472400005
						],
						[
							-82.67569291399991,
							27.78094760700009
						],
						[
							-82.67530999999991,
							27.780950000000075
						],
						[
							-82.67501333999991,
							27.780952265000053
						],
						[
							-82.67469783299993,
							27.780954673000053
						],
						[
							-82.67438232599994,
							27.780957081000057
						],
						[
							-82.67399999999992,
							27.78096000000005
						],
						[
							-82.67372713999993,
							27.780965626000068
						],
						[
							-82.6733389659999,
							27.780973630000062
						],
						[
							-82.67297410399995,
							27.780978403000063
						],
						[
							-82.67287709899996,
							27.780975631000047
						],
						[
							-82.67267999999991,
							27.78097000000008
						],
						[
							-82.67224643999992,
							27.780966881000044
						],
						[
							-82.67180958199994,
							27.780963738000082
						],
						[
							-82.67128999999994,
							27.78096000000005
						],
						[
							-82.67086307099993,
							27.780964227000084
						],
						[
							-82.67057184599992,
							27.780967110000063
						],
						[
							-82.67027999999993,
							27.78097000000008
						],
						[
							-82.6699653149999,
							27.780976231000068
						],
						[
							-82.6696013909999,
							27.780983438000078
						],
						[
							-82.66945582099993,
							27.780986320000068
						],
						[
							-82.66926999999993,
							27.780990000000088
						],
						[
							-82.66889738799995,
							27.780993583000054
						],
						[
							-82.66850861899991,
							27.780997321000086
						],
						[
							-82.66822999999994,
							27.781000000000063
						],
						[
							-82.66782884899993,
							27.781003972000065
						],
						[
							-82.66748932599995,
							27.781007333000048
						],
						[
							-82.66721999999993,
							27.781010000000038
						],
						[
							-82.66683412199991,
							27.78101571700006
						],
						[
							-82.66647013399997,
							27.78102110900005
						],
						[
							-82.66615431899993,
							27.78102578800008
						],
						[
							-82.66586999999993,
							27.781030000000044
						],
						[
							-82.66547483399995,
							27.781030000000044
						],
						[
							-82.66516999999993,
							27.781030000000044
						],
						[
							-82.66486805499994,
							27.781030000000044
						],
						[
							-82.66446999999994,
							27.781030000000044
						],
						[
							-82.66392133999994,
							27.781042417000037
						],
						[
							-82.66350876599995,
							27.781046273000076
						],
						[
							-82.6631099999999,
							27.78105000000005
						],
						[
							-82.6626108129999,
							27.781054894000082
						],
						[
							-82.6620283609999,
							27.78106060400006
						],
						[
							-82.66154298399994,
							27.78106536300004
						],
						[
							-82.66125151999995,
							27.781068220000066
						],
						[
							-82.66096884399991,
							27.781069208000076
						],
						[
							-82.66074195699991,
							27.781070000000057
						],
						[
							-82.66054999999994,
							27.781070000000057
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Historic Kenwood",
				"RegionID": "417157"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.67953999999992,
					27.780904122000038,
					-82.6606600529999,
					27.791941783000084
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.66516790299994,
							27.791941783000084
						],
						[
							-82.66379599599992,
							27.79193295200008
						],
						[
							-82.66362861499994,
							27.791933190000066
						],
						[
							-82.66242365999994,
							27.791934905000062
						],
						[
							-82.6606821119999,
							27.791939994000074
						],
						[
							-82.6606799999999,
							27.791940000000068
						],
						[
							-82.66066999999993,
							27.791065666000065
						],
						[
							-82.66066907399994,
							27.790516813000067
						],
						[
							-82.6606641219999,
							27.789858242000037
						],
						[
							-82.6606600529999,
							27.789308988000073
						],
						[
							-82.66068597899994,
							27.788816396000072
						],
						[
							-82.66075268799995,
							27.78822748400006
						],
						[
							-82.66095590899994,
							27.787393455000085
						],
						[
							-82.66126717999992,
							27.786433930000044
						],
						[
							-82.66145314199991,
							27.785839947000056
						],
						[
							-82.66163127099992,
							27.785242072000074
						],
						[
							-82.66172409799992,
							27.78479782000005
						],
						[
							-82.66173999999995,
							27.784660000000088
						],
						[
							-82.66177605599995,
							27.78426043500008
						],
						[
							-82.66170263599992,
							27.78332812000008
						],
						[
							-82.66144201399993,
							27.782446909000043
						],
						[
							-82.66126925899994,
							27.781900631000042
						],
						[
							-82.66117479099995,
							27.781520723000085
						],
						[
							-82.66096884399991,
							27.781069208000076
						],
						[
							-82.66125151999995,
							27.781068220000066
						],
						[
							-82.66154298399994,
							27.78106536300004
						],
						[
							-82.6620283609999,
							27.78106060400006
						],
						[
							-82.6626108129999,
							27.781054894000082
						],
						[
							-82.6631099999999,
							27.78105000000005
						],
						[
							-82.66350876599995,
							27.781046273000076
						],
						[
							-82.66392133999994,
							27.781042417000037
						],
						[
							-82.66446999999994,
							27.781030000000044
						],
						[
							-82.66486805499994,
							27.781030000000044
						],
						[
							-82.66516999999993,
							27.781030000000044
						],
						[
							-82.66547483399995,
							27.781030000000044
						],
						[
							-82.66586999999993,
							27.781030000000044
						],
						[
							-82.66615431899993,
							27.78102578800008
						],
						[
							-82.66647013399997,
							27.78102110900005
						],
						[
							-82.66683412199991,
							27.78101571700006
						],
						[
							-82.66721999999993,
							27.781010000000038
						],
						[
							-82.66748932599995,
							27.781007333000048
						],
						[
							-82.66782884899993,
							27.781003972000065
						],
						[
							-82.66822999999994,
							27.781000000000063
						],
						[
							-82.66850861899991,
							27.780997321000086
						],
						[
							-82.66889738799995,
							27.780993583000054
						],
						[
							-82.66926999999993,
							27.780990000000088
						],
						[
							-82.66945582099993,
							27.780986320000068
						],
						[
							-82.6696013909999,
							27.780983438000078
						],
						[
							-82.6699653149999,
							27.780976231000068
						],
						[
							-82.67027999999993,
							27.78097000000008
						],
						[
							-82.67057184599992,
							27.780967110000063
						],
						[
							-82.67086307099993,
							27.780964227000084
						],
						[
							-82.67128999999994,
							27.78096000000005
						],
						[
							-82.67180958199994,
							27.780963738000082
						],
						[
							-82.67224643999992,
							27.780966881000044
						],
						[
							-82.67267999999991,
							27.78097000000008
						],
						[
							-82.67287709899996,
							27.780975631000047
						],
						[
							-82.67297410399995,
							27.780978403000063
						],
						[
							-82.6733389659999,
							27.780973630000062
						],
						[
							-82.67372713999993,
							27.780965626000068
						],
						[
							-82.67399999999992,
							27.78096000000005
						],
						[
							-82.67438232599994,
							27.780957081000057
						],
						[
							-82.67469783299993,
							27.780954673000053
						],
						[
							-82.67501333999991,
							27.780952265000053
						],
						[
							-82.67530999999991,
							27.780950000000075
						],
						[
							-82.67569291399991,
							27.78094760700009
						],
						[
							-82.67615419999993,
							27.78094472400005
						],
						[
							-82.67659106399992,
							27.780941993000056
						],
						[
							-82.67710072099993,
							27.780940000000044
						],
						[
							-82.67756120099995,
							27.78093607800008
						],
						[
							-82.67792633599993,
							27.780925935000084
						],
						[
							-82.6783628899999,
							27.780917214000056
						],
						[
							-82.6789695409999,
							27.78090927900007
						],
						[
							-82.6794999469999,
							27.780904122000038
						],
						[
							-82.67950349499995,
							27.78123197800005
						],
						[
							-82.67950999999994,
							27.782070734000058
						],
						[
							-82.67951235699991,
							27.782967385000063
						],
						[
							-82.67951999999991,
							27.78383516100007
						],
						[
							-82.67951999999991,
							27.78454000000005
						],
						[
							-82.67952671799992,
							27.78513121600008
						],
						[
							-82.67952999999994,
							27.786327151000084
						],
						[
							-82.67953999999992,
							27.787586379000064
						],
						[
							-82.67953999999992,
							27.788719683000068
						],
						[
							-82.67953546199993,
							27.789852808000035
						],
						[
							-82.67952350299993,
							27.790859831000038
						],
						[
							-82.67952851599995,
							27.791427673000044
						],
						[
							-82.67952933599992,
							27.791844584000046
						],
						[
							-82.67883437099994,
							27.79184970700004
						],
						[
							-82.67784591199995,
							27.791854680000085
						],
						[
							-82.6768583349999,
							27.791850011000065
						],
						[
							-82.67608999399994,
							27.79185523800004
						],
						[
							-82.67482801999995,
							27.791868264000072
						],
						[
							-82.67389438599992,
							27.79188199400005
						],
						[
							-82.67274199199994,
							27.791895961000083
						],
						[
							-82.6718639309999,
							27.791904569000053
						],
						[
							-82.67076621199993,
							27.791912627000045
						],
						[
							-82.67027226699993,
							27.79191501300005
						],
						[
							-82.66994243999994,
							27.791916607000076
						],
						[
							-82.66950390799991,
							27.791918725000073
						],
						[
							-82.66879027099992,
							27.79192000000006
						],
						[
							-82.66813166299994,
							27.79192000000006
						],
						[
							-82.66769259099993,
							27.79192000000006
						],
						[
							-82.66692399699993,
							27.791923232000048
						],
						[
							-82.66599107199994,
							27.791933087000075
						],
						[
							-82.66516790299994,
							27.791941783000084
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "North Kenwood",
				"RegionID": "417158"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.66177605599995,
					27.781069208000076,
					-82.65482999999995,
					27.79198000000008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.65497999999991,
							27.79198000000008
						],
						[
							-82.65497999999991,
							27.79150473800007
						],
						[
							-82.65497479999993,
							27.790626429000042
						],
						[
							-82.65496999999993,
							27.789638681000042
						],
						[
							-82.65496494999991,
							27.788815361000047
						],
						[
							-82.65495246899991,
							27.78738848900008
						],
						[
							-82.65496744799992,
							27.785961336000074
						],
						[
							-82.65494127399995,
							27.783930335000036
						],
						[
							-82.65492999999992,
							27.78250375500005
						],
						[
							-82.65482999999995,
							27.781100000000038
						],
						[
							-82.65545364499991,
							27.781094049000046
						],
						[
							-82.6564962459999,
							27.781090000000063
						],
						[
							-82.65737438999992,
							27.781090000000063
						],
						[
							-82.65852705299994,
							27.78108583800008
						],
						[
							-82.65973439099992,
							27.781075042000055
						],
						[
							-82.66054999999994,
							27.781070000000057
						],
						[
							-82.66074195699991,
							27.781070000000057
						],
						[
							-82.66096884399991,
							27.781069208000076
						],
						[
							-82.66117479099995,
							27.781520723000085
						],
						[
							-82.66126925899994,
							27.781900631000042
						],
						[
							-82.66144201399993,
							27.782446909000043
						],
						[
							-82.66170263599992,
							27.78332812000008
						],
						[
							-82.66177605599995,
							27.78426043500008
						],
						[
							-82.66173999999995,
							27.784660000000088
						],
						[
							-82.66172409799992,
							27.78479782000005
						],
						[
							-82.66163127099992,
							27.785242072000074
						],
						[
							-82.66145314199991,
							27.785839947000056
						],
						[
							-82.66126717999992,
							27.786433930000044
						],
						[
							-82.66095590899994,
							27.787393455000085
						],
						[
							-82.66075268799995,
							27.78822748400006
						],
						[
							-82.66068597899994,
							27.788816396000072
						],
						[
							-82.6606600529999,
							27.789308988000073
						],
						[
							-82.6606641219999,
							27.789858242000037
						],
						[
							-82.66066907399994,
							27.790516813000067
						],
						[
							-82.66066999999993,
							27.791065666000065
						],
						[
							-82.6606799999999,
							27.791940000000068
						],
						[
							-82.65976999999992,
							27.79184000000004
						],
						[
							-82.65929554299993,
							27.79195499000008
						],
						[
							-82.65902999999992,
							27.791960000000074
						],
						[
							-82.65836252499992,
							27.791966512000045
						],
						[
							-82.65803271599992,
							27.791969730000062
						],
						[
							-82.65737416999991,
							27.791976154000054
						],
						[
							-82.65697999999992,
							27.79198000000008
						],
						[
							-82.6566601529999,
							27.791971355000044
						],
						[
							-82.65611223699995,
							27.79197305400004
						],
						[
							-82.65556307999992,
							27.79197642300005
						],
						[
							-82.65497999999991,
							27.79198000000008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Woodlawn Oaks",
				"RegionID": "417159"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.64978999999994,
					27.802979863000076,
					-82.64263999999991,
					27.81027000000006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.64267999999994,
							27.807019408000087
						],
						[
							-82.64267999999994,
							27.806640000000073
						],
						[
							-82.64267702299992,
							27.80633395700005
						],
						[
							-82.64267282199995,
							27.80597272600005
						],
						[
							-82.6426699999999,
							27.80573000000004
						],
						[
							-82.6426699999999,
							27.805287278000037
						],
						[
							-82.6426699999999,
							27.804790000000082
						],
						[
							-82.6426658549999,
							27.804421111000067
						],
						[
							-82.64265999999992,
							27.803900000000056
						],
						[
							-82.64265321599993,
							27.803591312000037
						],
						[
							-82.64264449599995,
							27.80319455700004
						],
						[
							-82.64263999999991,
							27.80299000000008
						],
						[
							-82.64341458699994,
							27.80298808300006
						],
						[
							-82.64493019199995,
							27.80298433100006
						],
						[
							-82.64597668099992,
							27.802981741000053
						],
						[
							-82.64667999999995,
							27.802980000000048
						],
						[
							-82.64672999999993,
							27.802979863000076
						],
						[
							-82.64672999999993,
							27.802980000000048
						],
						[
							-82.64693102799993,
							27.80324577600004
						],
						[
							-82.64734233199994,
							27.803704322000044
						],
						[
							-82.64766152699991,
							27.80407499900008
						],
						[
							-82.64794999999992,
							27.804410000000075
						],
						[
							-82.64815965799994,
							27.80465879500008
						],
						[
							-82.6483890259999,
							27.804930977000083
						],
						[
							-82.6486999999999,
							27.805300000000045
						],
						[
							-82.64893377599992,
							27.805577609000068
						],
						[
							-82.6491986019999,
							27.805892090000047
						],
						[
							-82.64949337299993,
							27.806242130000044
						],
						[
							-82.64978999999994,
							27.806550000000072
						],
						[
							-82.64951448399995,
							27.80663124700004
						],
						[
							-82.64904352499993,
							27.80664981400008
						],
						[
							-82.64860645599992,
							27.806688462000068
						],
						[
							-82.64835668099994,
							27.806715034000035
						],
						[
							-82.64806972199995,
							27.806767113000035
						],
						[
							-82.64785440799994,
							27.806809332000057
						],
						[
							-82.64738523699992,
							27.80685561900009
						],
						[
							-82.64709806699994,
							27.80687650400006
						],
						[
							-82.64675999999993,
							27.806830000000048
						],
						[
							-82.64675999999993,
							27.80716375200007
						],
						[
							-82.64675999999993,
							27.807452441000066
						],
						[
							-82.64675999999993,
							27.807700000000068
						],
						[
							-82.64676264399992,
							27.80792208300005
						],
						[
							-82.6467660749999,
							27.80821030100009
						],
						[
							-82.64676999999995,
							27.80854000000005
						],
						[
							-82.64676999999995,
							27.808823710000073
						],
						[
							-82.64676999999995,
							27.80907631300005
						],
						[
							-82.64676999999995,
							27.809420000000046
						],
						[
							-82.64676999999995,
							27.80979803400004
						],
						[
							-82.64676999999995,
							27.810250000000053
						],
						[
							-82.64674511899995,
							27.81025019000009
						],
						[
							-82.64637348999992,
							27.81025303200005
						],
						[
							-82.64547146599995,
							27.810260000000085
						],
						[
							-82.64474999999993,
							27.810260000000085
						],
						[
							-82.64345064399993,
							27.81026627700004
						],
						[
							-82.64267999999994,
							27.81027000000006
						],
						[
							-82.64267999999994,
							27.810080000000085
						],
						[
							-82.64268651399993,
							27.80961751400008
						],
						[
							-82.6426899999999,
							27.80937000000006
						],
						[
							-82.6426899999999,
							27.80911239900007
						],
						[
							-82.6426899999999,
							27.80878000000007
						],
						[
							-82.6426899999999,
							27.808460000000082
						],
						[
							-82.64268562099994,
							27.80821037400006
						],
						[
							-82.64267999999994,
							27.807890000000043
						],
						[
							-82.64267999999994,
							27.80755000000005
						],
						[
							-82.64267999999994,
							27.807308097000092
						],
						[
							-82.64267999999994,
							27.807019408000087
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Allendale Terrace",
				"RegionID": "417173"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.55653514999995,
					27.35975372100006,
					-82.54143611699993,
					27.38221042400005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.54418913199993,
							27.38221042400005
						],
						[
							-82.5430225099999,
							27.381731796000054
						],
						[
							-82.5430209999999,
							27.38169800000009
						],
						[
							-82.54301650899993,
							27.381427285000086
						],
						[
							-82.54298199999994,
							27.379347000000053
						],
						[
							-82.54263399999991,
							27.379341000000068
						],
						[
							-82.5426347369999,
							27.37902297000005
						],
						[
							-82.5457321369999,
							27.379058471000064
						],
						[
							-82.54587837299994,
							27.378692880000074
						],
						[
							-82.5460063299999,
							27.37837298800008
						],
						[
							-82.54603374899995,
							27.378327289000083
						],
						[
							-82.54690636499993,
							27.37833631700005
						],
						[
							-82.54690999999991,
							27.37795255900005
						],
						[
							-82.54642675899993,
							27.37795255900005
						],
						[
							-82.54610686699993,
							27.377897720000078
						],
						[
							-82.54622568399992,
							27.37682836800008
						],
						[
							-82.54626224299994,
							27.376380519000065
						],
						[
							-82.54606116799994,
							27.375192350000077
						],
						[
							-82.5450283749999,
							27.375082672000076
						],
						[
							-82.54487299899996,
							27.37491815700008
						],
						[
							-82.54487299899996,
							27.37457084600004
						],
						[
							-82.5431109999999,
							27.374587000000076
						],
						[
							-82.54311674899992,
							27.37440734100005
						],
						[
							-82.54312699999991,
							27.374087000000088
						],
						[
							-82.54311499999994,
							27.37319300000007
						],
						[
							-82.5431069999999,
							27.372261000000037
						],
						[
							-82.5430399999999,
							27.37150300000008
						],
						[
							-82.54300299999994,
							27.37084400000009
						],
						[
							-82.54301599999991,
							27.37012800000008
						],
						[
							-82.54296099999993,
							27.369394000000057
						],
						[
							-82.54296899999991,
							27.369065000000035
						],
						[
							-82.54296999999991,
							27.369007000000067
						],
						[
							-82.54297899999996,
							27.36864200000008
						],
						[
							-82.5429959999999,
							27.367942000000085
						],
						[
							-82.5429959999999,
							27.367194000000044
						],
						[
							-82.54292499999991,
							27.367194000000044
						],
						[
							-82.54270989899993,
							27.36719097100007
						],
						[
							-82.5426401499999,
							27.367189988000064
						],
						[
							-82.54143611699993,
							27.35975372100006
						],
						[
							-82.54274492399992,
							27.35979197100005
						],
						[
							-82.54374692499994,
							27.359821255000043
						],
						[
							-82.5445712309999,
							27.35986179500009
						],
						[
							-82.54569282599994,
							27.359888821000084
						],
						[
							-82.54677784099994,
							27.359902748000085
						],
						[
							-82.54909436899993,
							27.35988231400006
						],
						[
							-82.55653514999995,
							27.381439829000044
						],
						[
							-82.55508721599995,
							27.381794755000044
						],
						[
							-82.55425627799991,
							27.38189063200008
						],
						[
							-82.55323358599992,
							27.381954551000035
						],
						[
							-82.54686973699995,
							27.381927355000073
						],
						[
							-82.54655438599991,
							27.38192600700006
						],
						[
							-82.54575514899994,
							27.38192259100009
						],
						[
							-82.54498810699994,
							27.381922458000076
						],
						[
							-82.54418913199993,
							27.38221042400005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Bayou Oaks",
				"RegionID": "343968"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.53100380199993,
					27.337528558000088,
					-82.51400565799992,
					27.348645816000044
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.52421977599994,
							27.348551617000055
						],
						[
							-82.5236301889999,
							27.348546392000063
						],
						[
							-82.52076673199991,
							27.34856627700009
						],
						[
							-82.5194344279999,
							27.34858616300005
						],
						[
							-82.51802258499993,
							27.34862593200006
						],
						[
							-82.51400565799992,
							27.348626066000065
						],
						[
							-82.51402276099992,
							27.34327716200005
						],
						[
							-82.51402315199994,
							27.343154775000073
						],
						[
							-82.51402896999991,
							27.341336949000038
						],
						[
							-82.51404077899991,
							27.33758038300005
						],
						[
							-82.52420944999994,
							27.337528558000088
						],
						[
							-82.5249823769999,
							27.33753003600009
						],
						[
							-82.52569823999994,
							27.33764934700008
						],
						[
							-82.52637433599995,
							27.337927739000065
						],
						[
							-82.52724928099991,
							27.338345325000034
						],
						[
							-82.52796514799991,
							27.338663488000066
						],
						[
							-82.52854181399994,
							27.33880268300004
						],
						[
							-82.5293372189999,
							27.33888222300004
						],
						[
							-82.53011273899995,
							27.33888222300004
						],
						[
							-82.53100380199993,
							27.338882169000044
						],
						[
							-82.53097360099991,
							27.344974395000065
						],
						[
							-82.53096779799995,
							27.346020981000038
						],
						[
							-82.53086837199993,
							27.346577765000063
						],
						[
							-82.53066952199993,
							27.347134548000042
						],
						[
							-82.53041101699995,
							27.348009493000063
						],
						[
							-82.5303315029999,
							27.348645816000044
						],
						[
							-82.52949618199995,
							27.348636672000055
						],
						[
							-82.5287207799999,
							27.34862593200006
						],
						[
							-82.52810433999991,
							27.34858616300005
						],
						[
							-82.52570251899994,
							27.34856475800007
						],
						[
							-82.52421977599994,
							27.348551617000055
						]
					],
					[
						[
							-82.52214414799994,
							27.342222382000045
						],
						[
							-82.52214843199994,
							27.34205957000006
						],
						[
							-82.5219699999999,
							27.34207000000004
						],
						[
							-82.52182568899993,
							27.34207253200009
						],
						[
							-82.5217987069999,
							27.341275480000036
						],
						[
							-82.52168172999991,
							27.34129921400006
						],
						[
							-82.52152151899992,
							27.341328458000078
						],
						[
							-82.52136432499992,
							27.341299877000043
						],
						[
							-82.5211978179999,
							27.341277535000074
						],
						[
							-82.52103295199993,
							27.341259217000072
						],
						[
							-82.52085999999993,
							27.341240000000084
						],
						[
							-82.5201199999999,
							27.34124821000006
						],
						[
							-82.5201199999999,
							27.341470000000072
						],
						[
							-82.5201199999999,
							27.341694784000083
						],
						[
							-82.5201199999999,
							27.341857174000044
						],
						[
							-82.5201199999999,
							27.34209000000004
						],
						[
							-82.52010999999993,
							27.342130000000054
						],
						[
							-82.52010636499995,
							27.342344446000084
						],
						[
							-82.52010189399994,
							27.342608254000083
						],
						[
							-82.52009544499992,
							27.34279059700009
						],
						[
							-82.52008761999993,
							27.34291188500004
						],
						[
							-82.52007964799992,
							27.343029801000057
						],
						[
							-82.52007999999995,
							27.34303000000006
						],
						[
							-82.52026315799992,
							27.34302127800004
						],
						[
							-82.52062819999992,
							27.34302000000008
						],
						[
							-82.52123716599995,
							27.343014451000048
						],
						[
							-82.52165999999994,
							27.34301000000005
						],
						[
							-82.52186642599992,
							27.34301000000005
						],
						[
							-82.52202881599995,
							27.34301000000005
						],
						[
							-82.5221499999999,
							27.343000000000075
						],
						[
							-82.52213760099994,
							27.34285120700008
						],
						[
							-82.52213025499992,
							27.34275031900006
						],
						[
							-82.5221377279999,
							27.34246633300006
						],
						[
							-82.52214414799994,
							27.342222382000045
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Park East",
				"RegionID": "343970"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.49724999999995,
					27.348057065000035,
					-82.4912599999999,
					27.352389000000073
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.49364899999995,
							27.352226000000087
						],
						[
							-82.49309999999991,
							27.35219300000006
						],
						[
							-82.49228199999993,
							27.352203000000088
						],
						[
							-82.4923609999999,
							27.35206100000005
						],
						[
							-82.49126899999993,
							27.35194800000005
						],
						[
							-82.4912627139999,
							27.351947875000064
						],
						[
							-82.49126353899993,
							27.35191072500004
						],
						[
							-82.49126450499995,
							27.351867293000055
						],
						[
							-82.49126642099992,
							27.351781068000037
						],
						[
							-82.49126881599994,
							27.35167328700004
						],
						[
							-82.49126852799992,
							27.35155819000005
						],
						[
							-82.49126647599991,
							27.35147197100008
						],
						[
							-82.49126408099994,
							27.35137138300007
						],
						[
							-82.4912625369999,
							27.351306548000082
						],
						[
							-82.4912599999999,
							27.351200000000063
						],
						[
							-82.49133177499994,
							27.350939973000038
						],
						[
							-82.49139647599992,
							27.350760249000075
						],
						[
							-82.49171997899992,
							27.35024264300006
						],
						[
							-82.49237417599994,
							27.34932245500005
						],
						[
							-82.49259703399991,
							27.34902770700006
						],
						[
							-82.49272643499997,
							27.348768904000053
						],
						[
							-82.49278394699991,
							27.348531668000078
						],
						[
							-82.49279824799993,
							27.34831238600009
						],
						[
							-82.49288645599995,
							27.34833314000008
						],
						[
							-82.49319320399991,
							27.348379204000082
						],
						[
							-82.49371467299994,
							27.348302464000085
						],
						[
							-82.4940981069999,
							27.34817976800008
						],
						[
							-82.49461957799991,
							27.34805707000004
						],
						[
							-82.49715029599993,
							27.348057065000035
						],
						[
							-82.49715035999992,
							27.351776194000085
						],
						[
							-82.49723999999992,
							27.351776000000086
						],
						[
							-82.49723999999992,
							27.351849000000072
						],
						[
							-82.49724099999992,
							27.35212100000007
						],
						[
							-82.49724999999995,
							27.352384000000086
						],
						[
							-82.49697199999991,
							27.352389000000073
						],
						[
							-82.49627299999992,
							27.35238300000009
						],
						[
							-82.49572099999995,
							27.352361000000087
						],
						[
							-82.49555199999992,
							27.352352000000053
						],
						[
							-82.49547092099994,
							27.35233591000008
						],
						[
							-82.49503799999991,
							27.352250000000083
						],
						[
							-82.49455199999994,
							27.35224500000004
						],
						[
							-82.49364899999995,
							27.352226000000087
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Glen Oaks Manor",
				"RegionID": "343977"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.50571326999994,
					27.330387054000084,
					-82.49736289299994,
					27.337544678000086
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.50522099999995,
							27.33040500000004
						],
						[
							-82.50571326799991,
							27.330387054000084
						],
						[
							-82.50571326999994,
							27.337544678000086
						],
						[
							-82.49736289299994,
							27.337511462000066
						],
						[
							-82.49737945599992,
							27.337130346000038
						],
						[
							-82.4975782699999,
							27.334794264000042
						],
						[
							-82.49761099999995,
							27.331410000000062
						],
						[
							-82.49761199999995,
							27.33135100000004
						],
						[
							-82.49761099999995,
							27.33074300000004
						],
						[
							-82.49759999999992,
							27.330530000000067
						],
						[
							-82.49785199999991,
							27.33049800000009
						],
						[
							-82.49789299999992,
							27.33049500000004
						],
						[
							-82.4981239999999,
							27.330462000000068
						],
						[
							-82.49820699999992,
							27.33045100000004
						],
						[
							-82.49994299999992,
							27.330414000000076
						],
						[
							-82.50522099999995,
							27.33040500000004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Oakwood Manor",
				"RegionID": "343979"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.5448443219999,
					27.298874000000072,
					-82.53897970699991,
					27.30278000000004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.54112464199994,
							27.302682102000063
						],
						[
							-82.54090407599995,
							27.302680000000066
						],
						[
							-82.54075999999992,
							27.302680000000066
						],
						[
							-82.54067104799992,
							27.302680000000066
						],
						[
							-82.54043801899991,
							27.302680000000066
						],
						[
							-82.54013140299992,
							27.302680000000066
						],
						[
							-82.53989224299994,
							27.302680000000066
						],
						[
							-82.53973280199995,
							27.302680000000066
						],
						[
							-82.53959999999995,
							27.302680000000066
						],
						[
							-82.53950597999994,
							27.302681516000067
						],
						[
							-82.53942005099994,
							27.302682902000072
						],
						[
							-82.53916869099993,
							27.302686957000052
						],
						[
							-82.53909502399995,
							27.302688145000047
						],
						[
							-82.53903371599995,
							27.302689134000047
						],
						[
							-82.53897970699991,
							27.302689558000054
						],
						[
							-82.53917937699993,
							27.29897442800007
						],
						[
							-82.53914099999992,
							27.29889800000007
						],
						[
							-82.5393499999999,
							27.298905000000047
						],
						[
							-82.53980699999994,
							27.298874000000072
						],
						[
							-82.54169823699993,
							27.298881208000072
						],
						[
							-82.54190599999994,
							27.29888200000005
						],
						[
							-82.54229399999991,
							27.298943000000065
						],
						[
							-82.5422989999999,
							27.298946000000058
						],
						[
							-82.54230399999994,
							27.29894900000005
						],
						[
							-82.54237899999993,
							27.298977000000036
						],
						[
							-82.54253499999993,
							27.29899800000004
						],
						[
							-82.54279599999991,
							27.299003000000084
						],
						[
							-82.54305047999992,
							27.299017921000086
						],
						[
							-82.54310299999992,
							27.29902100000004
						],
						[
							-82.54312599999992,
							27.29900100000009
						],
						[
							-82.54326099999993,
							27.299104000000057
						],
						[
							-82.54436640099993,
							27.29906274800004
						],
						[
							-82.54453119399994,
							27.299304598000052
						],
						[
							-82.5445668349999,
							27.299361339000086
						],
						[
							-82.54460901099992,
							27.29944395700005
						],
						[
							-82.5447230119999,
							27.29969895700009
						],
						[
							-82.5447470869999,
							27.299758414000053
						],
						[
							-82.5447853359999,
							27.299897188000045
						],
						[
							-82.54482949699991,
							27.300128511000082
						],
						[
							-82.5448443219999,
							27.300291000000072
						],
						[
							-82.54484345199995,
							27.300330531000043
						],
						[
							-82.54483245299991,
							27.30058053100004
						],
						[
							-82.54482602899992,
							27.300655303000042
						],
						[
							-82.54481339299991,
							27.300729278000063
						],
						[
							-82.54479463299992,
							27.300801943000067
						],
						[
							-82.54476987999993,
							27.300872791000074
						],
						[
							-82.54473930599994,
							27.30094132800008
						],
						[
							-82.54465330599993,
							27.301114328000043
						],
						[
							-82.54457980899991,
							27.301236719000087
						],
						[
							-82.5444498089999,
							27.301418719000083
						],
						[
							-82.54440610699993,
							27.301475041000064
						],
						[
							-82.54435808099994,
							27.301527725000085
						],
						[
							-82.54430603299994,
							27.301576439000087
						],
						[
							-82.54425029099991,
							27.301620877000065
						],
						[
							-82.54419120299991,
							27.301660761000054
						],
						[
							-82.54412914199992,
							27.301695839000047
						],
						[
							-82.5440644979999,
							27.301725892000036
						],
						[
							-82.54387049799993,
							27.30180689100007
						],
						[
							-82.5438315859999,
							27.301822086000072
						],
						[
							-82.54372770299994,
							27.30184992100004
						],
						[
							-82.5437549589999,
							27.301924235000058
						],
						[
							-82.5437754649999,
							27.30200068700009
						],
						[
							-82.54378905499993,
							27.302078666000057
						],
						[
							-82.54379562299994,
							27.302157548000082
						],
						[
							-82.54381877199995,
							27.30274485600006
						],
						[
							-82.5438197979999,
							27.30277909700004
						],
						[
							-82.54292009199992,
							27.30277909700004
						],
						[
							-82.54285415399994,
							27.30278000000004
						],
						[
							-82.54272537499992,
							27.30278000000004
						],
						[
							-82.54240649499991,
							27.30278000000004
						],
						[
							-82.54233845999994,
							27.302775315000076
						],
						[
							-82.54225939299994,
							27.302768127000036
						],
						[
							-82.54211839999994,
							27.302755309000077
						],
						[
							-82.54201942799995,
							27.302746312000068
						],
						[
							-82.54194999999993,
							27.30274000000009
						],
						[
							-82.5419220839999,
							27.302737749000073
						],
						[
							-82.5418733429999,
							27.302733818000036
						],
						[
							-82.54168908799994,
							27.302718959000064
						],
						[
							-82.5414743689999,
							27.302701643000034
						],
						[
							-82.54128384599994,
							27.302688225000054
						],
						[
							-82.54112464199994,
							27.302682102000063
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "San Remo",
				"RegionID": "343986"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.13646532799993,
					26.226648904000058,
					-80.12630910999991,
					26.231579749000048
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.1270562819999,
							26.229314885000065
						],
						[
							-80.12788677499992,
							26.226797452000085
						],
						[
							-80.13025327199995,
							26.22664954600009
						],
						[
							-80.13645174399994,
							26.226648904000058
						],
						[
							-80.13646532799993,
							26.231579749000048
						],
						[
							-80.12630910999991,
							26.231579749000048
						],
						[
							-80.1270562819999,
							26.229314885000065
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Pompano Beach",
				"Name": "Avondale",
				"RegionID": "415293"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.10855478999991,
					26.138155442000084,
					-80.10220594899995,
					26.152886659000046
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.10636800399993,
							26.152886659000046
						],
						[
							-80.10600599999992,
							26.152662000000078
						],
						[
							-80.10304325599992,
							26.15269302200005
						],
						[
							-80.1027207859999,
							26.152661029000058
						],
						[
							-80.10274287099992,
							26.15208414500006
						],
						[
							-80.10331565799993,
							26.14911271400007
						],
						[
							-80.10325657499993,
							26.148412671000074
						],
						[
							-80.10335872399992,
							26.14778173800005
						],
						[
							-80.10372940799995,
							26.145731698000077
						],
						[
							-80.10363613899995,
							26.145265003000077
						],
						[
							-80.10372617299993,
							26.144539914000063
						],
						[
							-80.10220594899995,
							26.144450394000046
						],
						[
							-80.10275583399994,
							26.141003665000085
						],
						[
							-80.10320136799993,
							26.138209395000047
						],
						[
							-80.10356903699994,
							26.13821254600009
						],
						[
							-80.1039245639999,
							26.138207540000053
						],
						[
							-80.10459105199993,
							26.13818550700006
						],
						[
							-80.10540175499995,
							26.138206538000077
						],
						[
							-80.10658851399995,
							26.138189513000043
						],
						[
							-80.10797799999995,
							26.138167000000067
						],
						[
							-80.10835546699991,
							26.138155442000084
						],
						[
							-80.10839675499994,
							26.138630253000088
						],
						[
							-80.10855431199991,
							26.13929199300009
						],
						[
							-80.10853559999993,
							26.13927980300008
						],
						[
							-80.10852036299991,
							26.139335259000063
						],
						[
							-80.10855478999991,
							26.139325856000085
						],
						[
							-80.10816678899994,
							26.139681524000082
						],
						[
							-80.10787111999991,
							26.140207159000056
						],
						[
							-80.1075097449999,
							26.141291281000065
						],
						[
							-80.10754259799995,
							26.14191547300004
						],
						[
							-80.10777053299995,
							26.142304553000088
						],
						[
							-80.10771206899994,
							26.142277087000082
						],
						[
							-80.10756614999991,
							26.14280816700006
						],
						[
							-80.10701696199993,
							26.143032447000053
						],
						[
							-80.10688555399992,
							26.14385375200004
						],
						[
							-80.10688555399992,
							26.144313683000064
						],
						[
							-80.10701696199993,
							26.14503643100005
						],
						[
							-80.10744404099995,
							26.146777598000085
						],
						[
							-80.10790397199992,
							26.14848591200007
						],
						[
							-80.10829819799994,
							26.149800000000084
						],
						[
							-80.10793682399992,
							26.150457043000074
						],
						[
							-80.10737833699994,
							26.151311201000055
						],
						[
							-80.10668844099992,
							26.152395323000064
						],
						[
							-80.10636800399993,
							26.152886659000046
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Hugh Taylor Birch State Park",
				"RegionID": "416129"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.17803802599991,
					26.106379192000077,
					-80.16866645899995,
					26.121716081000045
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.1689513309999,
							26.121712138000078
						],
						[
							-80.1689191019999,
							26.121436273000086
						],
						[
							-80.16891199899993,
							26.12093190300004
						],
						[
							-80.16890445899992,
							26.12052823600004
						],
						[
							-80.16890270199991,
							26.12014948300009
						],
						[
							-80.1689066699999,
							26.119796398000062
						],
						[
							-80.16891670599995,
							26.119292114000075
						],
						[
							-80.16893368699994,
							26.11878835400006
						],
						[
							-80.16896509299994,
							26.11800768800009
						],
						[
							-80.1689894889999,
							26.117401276000066
						],
						[
							-80.16902502799991,
							26.11644281300005
						],
						[
							-80.16904373999995,
							26.115811284000074
						],
						[
							-80.16903999999994,
							26.11467609400006
						],
						[
							-80.1690249909999,
							26.11419979100009
						],
						[
							-80.16900134999992,
							26.113741980000043
						],
						[
							-80.16896572299993,
							26.11321469300009
						],
						[
							-80.16890723799992,
							26.112658896000084
						],
						[
							-80.16886115699992,
							26.112257716000045
						],
						[
							-80.16880836999991,
							26.111798166000085
						],
						[
							-80.16874300799992,
							26.111171132000038
						],
						[
							-80.16871039099993,
							26.110616649000065
						],
						[
							-80.16867999999994,
							26.109833176000052
						],
						[
							-80.16866645899995,
							26.10912847500009
						],
						[
							-80.16867175999994,
							26.108470923000084
						],
						[
							-80.16867782199995,
							26.10799207100007
						],
						[
							-80.16870717599994,
							26.107260170000075
						],
						[
							-80.1687405959999,
							26.10679207900006
						],
						[
							-80.16883983699995,
							26.10679395200009
						],
						[
							-80.16899406399995,
							26.10679895800007
						],
						[
							-80.16928449599995,
							26.10678794200004
						],
						[
							-80.16931554099995,
							26.10678794200004
						],
						[
							-80.1695499029999,
							26.10677892600006
						],
						[
							-80.16985033499992,
							26.106761904000052
						],
						[
							-80.17009870299995,
							26.106767913000056
						],
						[
							-80.17046023899991,
							26.106767913000056
						],
						[
							-80.1712003369999,
							26.106702816000055
						],
						[
							-80.17162696999992,
							26.10665274300004
						],
						[
							-80.1720465919999,
							26.106598661000078
						],
						[
							-80.17220182299991,
							26.106581636000048
						],
						[
							-80.1726895459999,
							26.106525554000086
						],
						[
							-80.17310628899992,
							26.106504661000088
						],
						[
							-80.17312006399993,
							26.106379192000077
						],
						[
							-80.17377114999994,
							26.106426407000072
						],
						[
							-80.1745132499999,
							26.106494507000036
						],
						[
							-80.1748727829999,
							26.106530561000056
						],
						[
							-80.17493489899994,
							26.106533485000057
						],
						[
							-80.17504800699993,
							26.10660083500005
						],
						[
							-80.17515820599994,
							26.106589648000067
						],
						[
							-80.17588328099993,
							26.10652755600006
						],
						[
							-80.17616970599994,
							26.10650352000005
						],
						[
							-80.1768266819999,
							26.106457452000086
						],
						[
							-80.17777308699993,
							26.106404369000074
						],
						[
							-80.17781114199994,
							26.107175518000076
						],
						[
							-80.17783417599992,
							26.108010757000045
						],
						[
							-80.17786421999995,
							26.109667213000083
						],
						[
							-80.17786421999995,
							26.109896552000066
						],
						[
							-80.17786421999995,
							26.110203007000052
						],
						[
							-80.17786421999995,
							26.110352228000067
						],
						[
							-80.17786421999995,
							26.11048843000009
						],
						[
							-80.17787123099993,
							26.11068672500005
						],
						[
							-80.17788424899993,
							26.11131165100005
						],
						[
							-80.17788825499991,
							26.111367735000044
						],
						[
							-80.17789526599995,
							26.112071779000075
						],
						[
							-80.17791028799991,
							26.112758798000073
						],
						[
							-80.17791028799991,
							26.112965104000068
						],
						[
							-80.1779203019999,
							26.11337971800009
						],
						[
							-80.17792531099992,
							26.11364911800007
						],
						[
							-80.17792531099992,
							26.113814363000074
						],
						[
							-80.17795535399995,
							26.115686139000047
						],
						[
							-80.17795936099992,
							26.11578628700005
						],
						[
							-80.17796336599991,
							26.115873416000056
						],
						[
							-80.1779633669999,
							26.116079722000052
						],
						[
							-80.17797037699995,
							26.11652237900006
						],
						[
							-80.17803802599991,
							26.12146400000006
						],
						[
							-80.1777679999999,
							26.12146400000006
						],
						[
							-80.17586799999992,
							26.12146400000006
						],
						[
							-80.17556799999994,
							26.12146400000006
						],
						[
							-80.1752679999999,
							26.12146400000006
						],
						[
							-80.17496799999992,
							26.121564000000035
						],
						[
							-80.17406799999992,
							26.12146400000006
						],
						[
							-80.17407990899994,
							26.121666463000054
						],
						[
							-80.17397658399994,
							26.121668880000072
						],
						[
							-80.17388531899991,
							26.12167101500006
						],
						[
							-80.17264547999991,
							26.121691044000045
						],
						[
							-80.17227993799992,
							26.121693048000058
						],
						[
							-80.17119032199992,
							26.12170306200005
						],
						[
							-80.17006865899992,
							26.121712075000065
						],
						[
							-80.16981729499992,
							26.121708074000082
						],
						[
							-80.16934959199995,
							26.121716081000045
						],
						[
							-80.1689513309999,
							26.121712138000078
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Riverland",
				"RegionID": "416130"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.20119999999991,
					26.106431288000067,
					-80.18584005799994,
					26.12106900000009
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.18617455299994,
							26.121064347000072
						],
						[
							-80.1861725409999,
							26.120495272000085
						],
						[
							-80.18615251199992,
							26.119727133000083
						],
						[
							-80.18615151099993,
							26.119665040000086
						],
						[
							-80.18614249699993,
							26.118871864000084
						],
						[
							-80.18613348399992,
							26.11817783400005
						],
						[
							-80.18610443999995,
							26.11677775900006
						],
						[
							-80.18608040499993,
							26.115352645000087
						],
						[
							-80.18606538299991,
							26.11463457900004
						],
						[
							-80.18604935899992,
							26.114030685000046
						],
						[
							-80.18600429199995,
							26.11202470900008
						],
						[
							-80.18598926999994,
							26.111620109000057
						],
						[
							-80.18597424699993,
							26.111198483000067
						],
						[
							-80.18595021199991,
							26.110370255000078
						],
						[
							-80.18593518999995,
							26.109862502000055
						],
						[
							-80.1859281799999,
							26.10954503100004
						],
						[
							-80.1859041429999,
							26.10871680400004
						],
						[
							-80.18588311299993,
							26.10789959200008
						],
						[
							-80.18586708899994,
							26.10717752100004
						],
						[
							-80.18584005799994,
							26.10669783700007
						],
						[
							-80.18681849899991,
							26.106744878000086
						],
						[
							-80.19342342199991,
							26.106518410000035
						],
						[
							-80.19342347199995,
							26.106520195000087
						],
						[
							-80.19411211999994,
							26.106558829000054
						],
						[
							-80.19615278499992,
							26.10652404500007
						],
						[
							-80.19757614399992,
							26.10646078500008
						],
						[
							-80.19771806799992,
							26.106454477000057
						],
						[
							-80.20054717199992,
							26.106431288000067
						],
						[
							-80.20097199999992,
							26.106453000000045
						],
						[
							-80.2010679999999,
							26.10886400000004
						],
						[
							-80.20118599999995,
							26.11176400000005
						],
						[
							-80.20119999999991,
							26.112108000000035
						],
						[
							-80.2009359999999,
							26.112108000000035
						],
						[
							-80.20096199999995,
							26.11350800000008
						],
						[
							-80.20103599999993,
							26.11734400000006
						],
						[
							-80.2004849999999,
							26.11735800000008
						],
						[
							-80.2004389999999,
							26.11816200000004
						],
						[
							-80.20026899999993,
							26.118164000000036
						],
						[
							-80.20026799999994,
							26.11832600000008
						],
						[
							-80.19925199999994,
							26.118309000000067
						],
						[
							-80.19929699999994,
							26.11960600000009
						],
						[
							-80.19919699999991,
							26.11990600000007
						],
						[
							-80.19906899999995,
							26.119864000000064
						],
						[
							-80.1974899999999,
							26.119864000000064
						],
						[
							-80.19760999999994,
							26.120444000000077
						],
						[
							-80.19760899999994,
							26.12066200000004
						],
						[
							-80.19802599999991,
							26.12066200000004
						],
						[
							-80.1980979999999,
							26.120374000000083
						],
						[
							-80.19810499999994,
							26.120149000000083
						],
						[
							-80.19829299999992,
							26.120149000000083
						],
						[
							-80.1983019999999,
							26.12063900000004
						],
						[
							-80.1983699999999,
							26.12063900000004
						],
						[
							-80.1983689999999,
							26.120764000000065
						],
						[
							-80.19799999999992,
							26.12076700000006
						],
						[
							-80.1974689999999,
							26.120764000000065
						],
						[
							-80.19606899999991,
							26.120764000000065
						],
						[
							-80.19386899999995,
							26.120764000000065
						],
						[
							-80.19149899999991,
							26.12084800000008
						],
						[
							-80.1906679999999,
							26.12093800000008
						],
						[
							-80.19026799999995,
							26.120964000000072
						],
						[
							-80.18966699999993,
							26.121034000000066
						],
						[
							-80.1879679999999,
							26.121064000000047
						],
						[
							-80.18760399999991,
							26.12106900000009
						],
						[
							-80.18617455299994,
							26.121064347000072
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Melrose Park",
				"RegionID": "416131"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.19576899999994,
					26.202410000000043,
					-80.18777999999992,
					26.20906000000008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.1954695359999,
							26.20241566100009
						],
						[
							-80.19567999999992,
							26.202410000000043
						],
						[
							-80.19567779199991,
							26.20253146300007
						],
						[
							-80.19567570899994,
							26.20264599300009
						],
						[
							-80.19567272899991,
							26.202809906000084
						],
						[
							-80.19576899999994,
							26.202961000000073
						],
						[
							-80.19566899999995,
							26.207160000000044
						],
						[
							-80.19556899999992,
							26.20896000000005
						],
						[
							-80.1950799999999,
							26.208971000000076
						],
						[
							-80.19116799999995,
							26.20906000000008
						],
						[
							-80.18806799999993,
							26.20906000000008
						],
						[
							-80.18800671399993,
							26.20906000000008
						],
						[
							-80.1880082639999,
							26.20899952800005
						],
						[
							-80.18800826299992,
							26.208928422000042
						],
						[
							-80.1880022549999,
							26.208847302000038
						],
						[
							-80.18795117899992,
							26.20730801900004
						],
						[
							-80.18794717399993,
							26.20699555600004
						],
						[
							-80.18794316799995,
							26.206786245000046
						],
						[
							-80.18789840599993,
							26.205591095000045
						],
						[
							-80.1878999999999,
							26.205590000000086
						],
						[
							-80.1878953669999,
							26.20544483900005
						],
						[
							-80.18788493099993,
							26.205117833000088
						],
						[
							-80.18787188499994,
							26.204709076000086
						],
						[
							-80.18786613699992,
							26.204332434000037
						],
						[
							-80.18785028199994,
							26.203973062000046
						],
						[
							-80.18783734599992,
							26.20369311400009
						],
						[
							-80.18782257099991,
							26.203432079000038
						],
						[
							-80.18781051299993,
							26.20321906500004
						],
						[
							-80.1877994919999,
							26.203006136000056
						],
						[
							-80.1877925309999,
							26.202678945000063
						],
						[
							-80.18777999999992,
							26.202470000000062
						],
						[
							-80.18827003399991,
							26.20246805700009
						],
						[
							-80.18886174799991,
							26.20246368000005
						],
						[
							-80.18921926599995,
							26.202461035000056
						],
						[
							-80.18967764399991,
							26.202460000000087
						],
						[
							-80.18989077799995,
							26.202455576000094
						],
						[
							-80.18997999999993,
							26.202450000000056
						],
						[
							-80.19043052199993,
							26.202450000000056
						],
						[
							-80.19080713999995,
							26.202445694000062
						],
						[
							-80.19139621499994,
							26.202438216000075
						],
						[
							-80.1920017409999,
							26.202432711000085
						],
						[
							-80.19262368999995,
							26.20243000000005
						],
						[
							-80.19314743199993,
							26.20243000000005
						],
						[
							-80.19350750399991,
							26.20243000000005
						],
						[
							-80.19388387499993,
							26.20242926900005
						],
						[
							-80.19416203499992,
							26.202424633000078
						],
						[
							-80.19448951899994,
							26.202420000000078
						],
						[
							-80.19489869199992,
							26.202420000000078
						],
						[
							-80.19532404899991,
							26.20241957500008
						],
						[
							-80.1954695359999,
							26.20241566100009
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Palm Aire Village (WEST)",
				"RegionID": "416132"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.75380505399994,
					27.760759678000056,
					-82.7426536879999,
					27.772810358000072
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.7430503949999,
							27.76705000600009
						],
						[
							-82.74287739499994,
							27.76680800500009
						],
						[
							-82.74283856599993,
							27.766748909000057
						],
						[
							-82.74280449999992,
							27.76668694500006
						],
						[
							-82.7427754069999,
							27.766622496000085
						],
						[
							-82.74275146799994,
							27.766555960000066
						],
						[
							-82.7427328309999,
							27.766487750000067
						],
						[
							-82.74267683099993,
							27.766245750000053
						],
						[
							-82.74266420499993,
							27.766180199000075
						],
						[
							-82.74265647599994,
							27.766113893000067
						],
						[
							-82.7426536879999,
							27.76604719500006
						],
						[
							-82.7426558539999,
							27.76598047500005
						],
						[
							-82.74266296399993,
							27.765914099000042
						],
						[
							-82.74268396399992,
							27.765769098000078
						],
						[
							-82.74269694299994,
							27.765699126000072
						],
						[
							-82.74271541399992,
							27.76563039800004
						],
						[
							-82.74273926199993,
							27.765563347000068
						],
						[
							-82.74276833699992,
							27.76549839100005
						],
						[
							-82.74283033699993,
							27.765373391000082
						],
						[
							-82.74285638599991,
							27.76532199800005
						],
						[
							-82.74288651599994,
							27.765272887000037
						],
						[
							-82.74292052999994,
							27.765226381000048
						],
						[
							-82.7429582019999,
							27.765182785000036
						],
						[
							-82.74299928499994,
							27.765142388000072
						],
						[
							-82.74297189399994,
							27.765112687000055
						],
						[
							-82.74292313699993,
							27.765055155000084
						],
						[
							-82.74287937299994,
							27.76499374000008
						],
						[
							-82.7428409069999,
							27.764928874000077
						],
						[
							-82.74280801099991,
							27.764861013000086
						],
						[
							-82.7427390119999,
							27.76470201400008
						],
						[
							-82.7427135769999,
							27.76463650800008
						],
						[
							-82.7426933349999,
							27.764569217000087
						],
						[
							-82.74267840899995,
							27.764500550000037
						],
						[
							-82.7426688889999,
							27.76443092800008
						],
						[
							-82.74266483499991,
							27.764360775000057
						],
						[
							-82.74266626999992,
							27.764290519000042
						],
						[
							-82.74268026999994,
							27.764055519000067
						],
						[
							-82.74269234099995,
							27.763952835000055
						],
						[
							-82.74272169499994,
							27.76383418800009
						],
						[
							-82.74279069499994,
							27.763619188000067
						],
						[
							-82.74281510199995,
							27.76355234900007
						],
						[
							-82.74284471599992,
							27.76348764900007
						],
						[
							-82.74287935399991,
							27.763425492000067
						],
						[
							-82.7429187969999,
							27.763366269000073
						],
						[
							-82.74296279799995,
							27.76331034900005
						],
						[
							-82.74301108299996,
							27.763258084000086
						],
						[
							-82.7431840829999,
							27.763085084000068
						],
						[
							-82.74323805299993,
							27.763035349000063
						],
						[
							-82.74329589899992,
							27.762990180000088
						],
						[
							-82.7433572349999,
							27.762949879000075
						],
						[
							-82.74342165299993,
							27.762914713000043
						],
						[
							-82.74348872399992,
							27.762884916000075
						],
						[
							-82.74354036199992,
							27.76286445900007
						],
						[
							-82.74369399999995,
							27.762803001000066
						],
						[
							-82.74372041399994,
							27.762792914000045
						],
						[
							-82.74377963299992,
							27.762777046000057
						],
						[
							-82.74377746099992,
							27.76274260100007
						],
						[
							-82.7437756779999,
							27.762686000000087
						],
						[
							-82.74379029399995,
							27.76252461300004
						],
						[
							-82.74386024599994,
							27.762153392000076
						],
						[
							-82.74389891399994,
							27.762012413000036
						],
						[
							-82.74391580699995,
							27.76196946300007
						],
						[
							-82.7440068059999,
							27.761754463000045
						],
						[
							-82.74403485599994,
							27.76169445100004
						],
						[
							-82.74406724699992,
							27.761636666000072
						],
						[
							-82.7441038039999,
							27.761581422000067
						],
						[
							-82.74414432799995,
							27.76152902000007
						],
						[
							-82.74418859999992,
							27.761479742000063
						],
						[
							-82.7443955999999,
							27.761265742000035
						],
						[
							-82.74446392699991,
							27.761202079000043
						],
						[
							-82.74457255199991,
							27.761123928000075
						],
						[
							-82.7448225519999,
							27.760970928000063
						],
						[
							-82.74488887199993,
							27.76093409200007
						],
						[
							-82.74495805899994,
							27.76090297700006
						],
						[
							-82.74502962299994,
							27.76087780300009
						],
						[
							-82.74528862399991,
							27.760798803000057
						],
						[
							-82.7453948349999,
							27.76077334000007
						],
						[
							-82.74555099999992,
							27.760759678000056
						],
						[
							-82.74581738599994,
							27.760759678000056
						],
						[
							-82.7463653499999,
							27.761183884000047
						],
						[
							-82.74665813399992,
							27.761425000000088
						],
						[
							-82.7467959139999,
							27.761821119000047
						],
						[
							-82.74693369499994,
							27.76202778900006
						],
						[
							-82.7472210549999,
							27.762347098000077
						],
						[
							-82.7473859939999,
							27.76254900600009
						],
						[
							-82.74772593199992,
							27.76290614000004
						],
						[
							-82.7481048279999,
							27.763267813000084
						],
						[
							-82.74846650199993,
							27.763663932000043
						],
						[
							-82.74901762399992,
							27.76397393800005
						],
						[
							-82.74944818799992,
							27.764249499000073
						],
						[
							-82.74968930299991,
							27.764576727000076
						],
						[
							-82.7500165319999,
							27.765058959000044
						],
						[
							-82.75036098299995,
							27.765351742000064
						],
						[
							-82.75094654999992,
							27.765420632000087
						],
						[
							-82.75154875499993,
							27.765820680000047
						],
						[
							-82.7515728809999,
							27.765883685000063
						],
						[
							-82.75159189899995,
							27.76594841400004
						],
						[
							-82.75160568899992,
							27.76601445500006
						],
						[
							-82.7516141619999,
							27.766081387000042
						],
						[
							-82.75161726399995,
							27.766148781000084
						],
						[
							-82.7516182409999,
							27.766235732000045
						],
						[
							-82.75174398299993,
							27.76621479100004
						],
						[
							-82.75189699999994,
							27.766201678000073
						],
						[
							-82.7520225849999,
							27.76621049000005
						],
						[
							-82.75218090599992,
							27.766232823000056
						],
						[
							-82.7522242259999,
							27.766239157000086
						],
						[
							-82.75229090199991,
							27.766251498000088
						],
						[
							-82.75235645799997,
							27.76626882800008
						],
						[
							-82.75242052199991,
							27.766291048000085
						],
						[
							-82.75248272899995,
							27.766318032000072
						],
						[
							-82.75254272699993,
							27.766349626000082
						],
						[
							-82.75267519499994,
							27.766425895000054
						],
						[
							-82.75280407299994,
							27.76651607900004
						],
						[
							-82.75288304999992,
							27.76659094300004
						],
						[
							-82.75298304899991,
							27.766697943000054
						],
						[
							-82.75302735299994,
							27.766746381000075
						],
						[
							-82.75306675399992,
							27.76679888500007
						],
						[
							-82.75310087999992,
							27.766854960000046
						],
						[
							-82.75312941199991,
							27.76691407900006
						],
						[
							-82.75315574599995,
							27.766718806000085
						],
						[
							-82.7531613399999,
							27.76668283500004
						],
						[
							-82.75319138699992,
							27.766562039000068
						],
						[
							-82.75324738699993,
							27.766389039000046
						],
						[
							-82.75327398699994,
							27.766317405000052
						],
						[
							-82.75339298699993,
							27.766034405000084
						],
						[
							-82.75343535099995,
							27.76594715200008
						],
						[
							-82.75356225799993,
							27.765718246000063
						],
						[
							-82.7536474879999,
							27.765593323000076
						],
						[
							-82.75380505399994,
							27.76539972000006
						],
						[
							-82.7529199999999,
							27.767715000000067
						],
						[
							-82.75274644899991,
							27.77039684000005
						],
						[
							-82.75268195199993,
							27.770497402000046
						],
						[
							-82.75268784999992,
							27.77054630000004
						],
						[
							-82.75269354999995,
							27.770616748000066
						],
						[
							-82.75269370099994,
							27.770687426000052
						],
						[
							-82.75268830099992,
							27.770757898000056
						],
						[
							-82.75267738299993,
							27.770827728000086
						],
						[
							-82.75266101499994,
							27.770896485000037
						],
						[
							-82.75264083299993,
							27.770968562000068
						],
						[
							-82.75263515099994,
							27.77098939600006
						],
						[
							-82.75262605199993,
							27.771025373000043
						],
						[
							-82.75260862999994,
							27.771089638000035
						],
						[
							-82.75258577999995,
							27.77116142400007
						],
						[
							-82.75255700299994,
							27.771231046000082
						],
						[
							-82.75252249899995,
							27.77129801500007
						],
						[
							-82.75248251099993,
							27.77136186200005
						],
						[
							-82.7524373199999,
							27.771422137000062
						],
						[
							-82.75238724299993,
							27.77147841900006
						],
						[
							-82.75233263099994,
							27.77153031200004
						],
						[
							-82.75215985199992,
							27.77168111700007
						],
						[
							-82.75202466099995,
							27.771776836000072
						],
						[
							-82.75199578099995,
							27.77179281100007
						],
						[
							-82.75182578099992,
							27.771882810000083
						],
						[
							-82.7517708449999,
							27.771909546000074
						],
						[
							-82.75151484399993,
							27.77202354600007
						],
						[
							-82.75141953799994,
							27.772059665000086
						],
						[
							-82.75116091899991,
							27.77214124300008
						],
						[
							-82.75103711899993,
							27.772196448000045
						],
						[
							-82.7509510729999,
							27.772278920000076
						],
						[
							-82.75086297899992,
							27.77234412200005
						],
						[
							-82.7505788929999,
							27.77252472100008
						],
						[
							-82.75048793899992,
							27.772585637000077
						],
						[
							-82.75042792999994,
							27.772622355000067
						],
						[
							-82.75036512299994,
							27.77265404800005
						],
						[
							-82.75029993699991,
							27.77268050500004
						],
						[
							-82.75023280699992,
							27.772701547000054
						],
						[
							-82.75016418199993,
							27.772717035000085
						],
						[
							-82.75009452199993,
							27.77272686500004
						],
						[
							-82.75002429099993,
							27.772730971000048
						],
						[
							-82.74999900499995,
							27.772732501000064
						],
						[
							-82.74817519499993,
							27.772784109000042
						],
						[
							-82.7462860899999,
							27.772807286000045
						],
						[
							-82.74541831499994,
							27.772810358000072
						],
						[
							-82.74455698199995,
							27.772430212000074
						],
						[
							-82.74395419299994,
							27.772068538000042
						],
						[
							-82.74373029999992,
							27.771861868000087
						],
						[
							-82.74338584899994,
							27.771414081000046
						],
						[
							-82.7432308459999,
							27.77117296600005
						],
						[
							-82.7430241749999,
							27.770656289000044
						],
						[
							-82.74295528499994,
							27.77007072200007
						],
						[
							-82.7430413969999,
							27.769605713000093
						],
						[
							-82.74313797799994,
							27.76937902800006
						],
						[
							-82.74317292699993,
							27.769344079000067
						],
						[
							-82.74323620799993,
							27.769295593000038
						],
						[
							-82.74339520799992,
							27.76918459300009
						],
						[
							-82.74346033899991,
							27.76914316500006
						],
						[
							-82.74358712999992,
							27.769084041000042
						],
						[
							-82.74359100999993,
							27.769030274000045
						],
						[
							-82.74360234099993,
							27.76893883400004
						],
						[
							-82.74362198499995,
							27.768852516000038
						],
						[
							-82.74364604499993,
							27.768743253000082
						],
						[
							-82.74356422199992,
							27.76863313800004
						],
						[
							-82.7434864089999,
							27.76850767600007
						],
						[
							-82.74335540899995,
							27.76825167600009
						],
						[
							-82.7433267369999,
							27.76818999900007
						],
						[
							-82.74330280899994,
							27.768126332000065
						],
						[
							-82.74328375999994,
							27.76806103800004
						],
						[
							-82.74326970099992,
							27.76799449200007
						],
						[
							-82.74326071099995,
							27.767927073000067
						],
						[
							-82.74323971099994,
							27.767706074000046
						],
						[
							-82.74323579199996,
							27.76763535500004
						],
						[
							-82.74323745099991,
							27.767564548000053
						],
						[
							-82.74324467699995,
							27.76749409100006
						],
						[
							-82.74325742499991,
							27.767424421000044
						],
						[
							-82.74328792299991,
							27.767290889000037
						],
						[
							-82.74324348399995,
							27.767247264000048
						],
						[
							-82.74318964799994,
							27.76720368300005
						],
						[
							-82.74313932599995,
							27.767156087000046
						],
						[
							-82.74309281599994,
							27.767104760000056
						],
						[
							-82.7430503949999,
							27.76705000600009
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Causeway Isles",
				"RegionID": "416179"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.61738594899992,
					27.801206972000045,
					-82.6109118139999,
					27.806343539000068
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.61156254399992,
							27.806143417000044
						],
						[
							-82.61153736299991,
							27.80612775900005
						],
						[
							-82.61148952699995,
							27.806093480000072
						],
						[
							-82.6114853929999,
							27.806090289000053
						],
						[
							-82.6113913929999,
							27.80601728900007
						],
						[
							-82.61135003599992,
							27.805983146000074
						],
						[
							-82.61130708299993,
							27.80594291700004
						],
						[
							-82.61128265199994,
							27.805917508000054
						],
						[
							-82.6111846519999,
							27.80581150800009
						],
						[
							-82.61116885399991,
							27.805793964000088
						],
						[
							-82.6111315199999,
							27.80574847200006
						],
						[
							-82.61109724099992,
							27.80570063600004
						],
						[
							-82.61106616399991,
							27.805650661000072
						],
						[
							-82.61103842299991,
							27.805598760000066
						],
						[
							-82.61101413499995,
							27.80554515500006
						],
						[
							-82.61100891799992,
							27.80553228000008
						],
						[
							-82.61094591799991,
							27.805373281000072
						],
						[
							-82.61093040499993,
							27.80533107800005
						],
						[
							-82.61091332099994,
							27.805274762000067
						],
						[
							-82.6109118139999,
							27.805268870000077
						],
						[
							-82.61119173099992,
							27.804928251000035
						],
						[
							-82.6116062079999,
							27.804362136000066
						],
						[
							-82.61212177699991,
							27.803856677000056
						],
						[
							-82.61249581699991,
							27.803472527000054
						],
						[
							-82.61281931199996,
							27.803068159000077
						],
						[
							-82.61307204199994,
							27.802845757000057
						],
						[
							-82.61342586299992,
							27.80250204400005
						],
						[
							-82.6138807769999,
							27.801976366000076
						],
						[
							-82.61436601899993,
							27.801551780000068
						],
						[
							-82.61477762599992,
							27.801206972000045
						],
						[
							-82.61481425599993,
							27.801208817000088
						],
						[
							-82.61482781799992,
							27.801209603000075
						],
						[
							-82.61488638499992,
							27.801215372000062
						],
						[
							-82.6149189919999,
							27.80122027400006
						],
						[
							-82.6151199919999,
							27.801254274000087
						],
						[
							-82.6151454489999,
							27.801258958000062
						],
						[
							-82.61520276199991,
							27.801272321000056
						],
						[
							-82.61525907799995,
							27.801289405000094
						],
						[
							-82.61526175099993,
							27.801290317000053
						],
						[
							-82.61581575199995,
							27.801480318000074
						],
						[
							-82.61586815599992,
							27.801500135000083
						],
						[
							-82.61592175999994,
							27.80152442300005
						],
						[
							-82.61593279199992,
							27.80152995800006
						],
						[
							-82.6162717919999,
							27.801702958000078
						],
						[
							-82.61631266099994,
							27.80172516500005
						],
						[
							-82.61633744199992,
							27.80174000800008
						],
						[
							-82.61677544299994,
							27.802012008000077
						],
						[
							-82.61680063699993,
							27.802028241000073
						],
						[
							-82.61684847299995,
							27.80206252000005
						],
						[
							-82.61685015499995,
							27.802063814000064
						],
						[
							-82.61701615499993,
							27.802191814000082
						],
						[
							-82.6170599639999,
							27.80222785400008
						],
						[
							-82.6171029169999,
							27.802268083000058
						],
						[
							-82.61714314599993,
							27.802311036000052
						],
						[
							-82.61717481499994,
							27.80234922200009
						],
						[
							-82.61726181499995,
							27.802460222000036
						],
						[
							-82.6172674799999,
							27.80246752700009
						],
						[
							-82.61730175899993,
							27.802515363000055
						],
						[
							-82.61733283599995,
							27.80256533900007
						],
						[
							-82.61736057799993,
							27.802617240000075
						],
						[
							-82.61736151999992,
							27.802619157000038
						],
						[
							-82.61738594899992,
							27.802668992000065
						],
						[
							-82.61727746699995,
							27.80308837800004
						],
						[
							-82.61712582899992,
							27.803634274000046
						],
						[
							-82.61700451799993,
							27.804250935000084
						],
						[
							-82.61683266199992,
							27.804695740000057
						],
						[
							-82.61645862199993,
							27.80521130900007
						],
						[
							-82.61609469099994,
							27.80574709600006
						],
						[
							-82.61554879399995,
							27.806080699000063
						],
						[
							-82.61531514099994,
							27.806162124000082
						],
						[
							-82.6148815869999,
							27.806313211000088
						],
						[
							-82.61383023099995,
							27.806343539000068
						],
						[
							-82.6130821509999,
							27.806303102000076
						],
						[
							-82.6122026509999,
							27.80625255600006
						],
						[
							-82.61156254399992,
							27.806143417000044
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Eden Isle",
				"RegionID": "416180"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.61253623099992,
					27.829840000000047,
					-82.6057170389999,
					27.83606934800008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.6079901299999,
							27.829984008000054
						],
						[
							-82.60797044899994,
							27.82984124300009
						],
						[
							-82.60887948399994,
							27.82985000000008
						],
						[
							-82.61021428899994,
							27.82985000000008
						],
						[
							-82.61048343599992,
							27.82985000000008
						],
						[
							-82.61074999999994,
							27.82985000000008
						],
						[
							-82.6109367059999,
							27.82984834800004
						],
						[
							-82.61121999599993,
							27.829845841000065
						],
						[
							-82.6114184249999,
							27.829844085000047
						],
						[
							-82.61174420899994,
							27.82984120200007
						],
						[
							-82.61197082599995,
							27.829840000000047
						],
						[
							-82.61228246999991,
							27.829840000000047
						],
						[
							-82.61253623099992,
							27.829840000000047
						],
						[
							-82.61253623099992,
							27.83007461400007
						],
						[
							-82.61247655099993,
							27.830391079000037
						],
						[
							-82.61251212799993,
							27.835923184000084
						],
						[
							-82.61233708499992,
							27.835929882000073
						],
						[
							-82.61191868599991,
							27.83602950100004
						],
						[
							-82.6109025749999,
							27.83602950100004
						],
						[
							-82.60879065699993,
							27.83602950100004
						],
						[
							-82.60749561299991,
							27.83606934800008
						],
						[
							-82.60697759599992,
							27.836049425000056
						],
						[
							-82.6066189679999,
							27.83602950100004
						],
						[
							-82.6057170389999,
							27.835393715000066
						],
						[
							-82.60571834099994,
							27.835378835000085
						],
						[
							-82.60574717499992,
							27.835261814000035
						],
						[
							-82.60579117399995,
							27.835123814000042
						],
						[
							-82.6058146389999,
							27.83505893100005
						],
						[
							-82.6058430089999,
							27.834996039000092
						],
						[
							-82.60587611699992,
							27.83493550600008
						],
						[
							-82.60591376799994,
							27.834877689000052
						],
						[
							-82.6059557399999,
							27.83482292900004
						],
						[
							-82.60602540999992,
							27.834738928000036
						],
						[
							-82.6061379269999,
							27.83462607900009
						],
						[
							-82.60615631199994,
							27.83461106100009
						],
						[
							-82.60627831199992,
							27.83451406100005
						],
						[
							-82.60638833899992,
							27.834439164000063
						],
						[
							-82.6064626509999,
							27.834400753000068
						],
						[
							-82.60677358999993,
							27.834257966000052
						],
						[
							-82.60695395099992,
							27.834177198000077
						],
						[
							-82.6066192369999,
							27.83365589200008
						],
						[
							-82.60655108499992,
							27.833528184000045
						],
						[
							-82.6064850859999,
							27.833376184000088
						],
						[
							-82.60645716599993,
							27.83330340200007
						],
						[
							-82.60643565499993,
							27.833228475000055
						],
						[
							-82.60642071299992,
							27.833151967000052
						],
						[
							-82.60641245199993,
							27.833074452000062
						],
						[
							-82.60640245099995,
							27.832915452000066
						],
						[
							-82.60640067799994,
							27.83285900000004
						],
						[
							-82.6064133239999,
							27.83270871600007
						],
						[
							-82.60643383199995,
							27.832587775000036
						],
						[
							-82.6064503909999,
							27.832511753000063
						],
						[
							-82.60647345899991,
							27.832437446000085
						],
						[
							-82.60650286299995,
							27.83236541100007
						],
						[
							-82.60653838499991,
							27.832296188000043
						],
						[
							-82.6065797569999,
							27.832230294000055
						],
						[
							-82.60666875699991,
							27.83210129400004
						],
						[
							-82.60672377199995,
							27.832029554000087
						],
						[
							-82.6069447719999,
							27.831769554000065
						],
						[
							-82.60701660099994,
							27.831694336000055
						],
						[
							-82.60728625099996,
							27.831442836000065
						],
						[
							-82.60749577199994,
							27.83118979900007
						],
						[
							-82.60772079599991,
							27.830890313000058
						],
						[
							-82.60785157399994,
							27.830654748000086
						],
						[
							-82.6079064409999,
							27.830555761000085
						],
						[
							-82.6079976879999,
							27.83027489600005
						],
						[
							-82.60801300599991,
							27.83021289200008
						],
						[
							-82.60801531399994,
							27.83017934600008
						],
						[
							-82.6079901299999,
							27.829984008000054
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Tanglewood",
				"RegionID": "416181"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.72382483199993,
					27.694065678000072,
					-82.70634675899994,
					27.717020322000053
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.70756341399994,
							27.716754086000037
						],
						[
							-82.70746415999992,
							27.716707803000077
						],
						[
							-82.70746286399992,
							27.71672475300005
						],
						[
							-82.70745486399994,
							27.71677675300009
						],
						[
							-82.70696738099991,
							27.716009126000074
						],
						[
							-82.7066592349999,
							27.715216751000074
						],
						[
							-82.7066152139999,
							27.714468396000086
						],
						[
							-82.70643913099991,
							27.71385210400007
						],
						[
							-82.70634675899994,
							27.713219654000056
						],
						[
							-82.70637892399992,
							27.71316321800009
						],
						[
							-82.70641534799995,
							27.713109434000046
						],
						[
							-82.70645581499991,
							27.713058621000073
						],
						[
							-82.70650008399991,
							27.713011083000083
						],
						[
							-82.70659008299992,
							27.712921083000083
						],
						[
							-82.70664792699995,
							27.712868080000078
						],
						[
							-82.70671792699994,
							27.712814947000084
						],
						[
							-82.70682892699995,
							27.712738948000037
						],
						[
							-82.70688733899993,
							27.712702165000053
						],
						[
							-82.70701338799995,
							27.712641920000067
						],
						[
							-82.70737677499994,
							27.712501771000063
						],
						[
							-82.70794916199992,
							27.712281622000035
						],
						[
							-82.7080667539999,
							27.712245412000073
						],
						[
							-82.7102695239999,
							27.711729061000085
						],
						[
							-82.71054409099992,
							27.71161908800008
						],
						[
							-82.71052894799993,
							27.710860843000038
						],
						[
							-82.71052767799995,
							27.71084000000008
						],
						[
							-82.71052767799995,
							27.707006000000035
						],
						[
							-82.71052819199991,
							27.706975614000044
						],
						[
							-82.71056619199993,
							27.70585161300005
						],
						[
							-82.71056766999993,
							27.705822175000037
						],
						[
							-82.71057366999992,
							27.705732175000037
						],
						[
							-82.7105824109999,
							27.705653478000045
						],
						[
							-82.71059803899993,
							27.705575854000074
						],
						[
							-82.7106204349999,
							27.705499906000057
						],
						[
							-82.71064942499993,
							27.705426222000085
						],
						[
							-82.71068478299992,
							27.705355374000078
						],
						[
							-82.71072623599993,
							27.705287910000038
						],
						[
							-82.7107734629999,
							27.70522435500004
						],
						[
							-82.71089576999992,
							27.70507414000008
						],
						[
							-82.71094336499993,
							27.70502097700006
						],
						[
							-82.71099502499993,
							27.70497175400004
						],
						[
							-82.71105042599993,
							27.704926784000065
						],
						[
							-82.71110921899992,
							27.70488634900005
						],
						[
							-82.7111710339999,
							27.70485070400008
						],
						[
							-82.7112354809999,
							27.704820074000054
						],
						[
							-82.71130215399995,
							27.704794650000053
						],
						[
							-82.71140615399992,
							27.704759651000074
						],
						[
							-82.71146707399993,
							27.704741519000038
						],
						[
							-82.71208009199995,
							27.70458241500006
						],
						[
							-82.71209285999993,
							27.70456045400005
						],
						[
							-82.71211118099991,
							27.70451546600009
						],
						[
							-82.7121199639999,
							27.70443296700006
						],
						[
							-82.71209977799992,
							27.703082440000063
						],
						[
							-82.71210015899993,
							27.703039588000085
						],
						[
							-82.71214115899994,
							27.70178658900005
						],
						[
							-82.71214751799994,
							27.701705296000057
						],
						[
							-82.71224290399994,
							27.70093630300005
						],
						[
							-82.71229366999995,
							27.700399351000044
						],
						[
							-82.71230333999995,
							27.700327834000063
						],
						[
							-82.7123308809999,
							27.700214904000063
						],
						[
							-82.7125108809999,
							27.699640903000045
						],
						[
							-82.71252391299994,
							27.699602413000036
						],
						[
							-82.71259377299992,
							27.699454200000048
						],
						[
							-82.7131113609999,
							27.698589517000073
						],
						[
							-82.71322823999992,
							27.698341148000054
						],
						[
							-82.71346620399993,
							27.697835226000052
						],
						[
							-82.71349837399993,
							27.69777320800006
						],
						[
							-82.71370396099991,
							27.69741193300007
						],
						[
							-82.71366474399991,
							27.697345906000066
						],
						[
							-82.71363172999992,
							27.697276569000053
						],
						[
							-82.71360519699994,
							27.69720450300008
						],
						[
							-82.7135853659999,
							27.697130312000073
						],
						[
							-82.71355136599993,
							27.696978312000056
						],
						[
							-82.7135312559999,
							27.696835259000068
						],
						[
							-82.71352425599991,
							27.69671725900008
						],
						[
							-82.71352306699993,
							27.69663754700008
						],
						[
							-82.71352894099994,
							27.69655804400009
						],
						[
							-82.71354183299991,
							27.696479373000045
						],
						[
							-82.71356164199995,
							27.696402153000065
						],
						[
							-82.71358264199995,
							27.69633315300007
						],
						[
							-82.71360686799994,
							27.69626384600008
						],
						[
							-82.7136366659999,
							27.696196746000055
						],
						[
							-82.71367183899991,
							27.696132300000045
						],
						[
							-82.71371215099992,
							27.69607093900004
						],
						[
							-82.71375733399992,
							27.696013070000053
						],
						[
							-82.7138070869999,
							27.69595907900009
						],
						[
							-82.71387608799995,
							27.695890079000037
						],
						[
							-82.7139351639999,
							27.69583604400009
						],
						[
							-82.71399881199996,
							27.695787476000078
						],
						[
							-82.71406652699996,
							27.69574476200006
						],
						[
							-82.7141377719999,
							27.695708239000055
						],
						[
							-82.71421198299993,
							27.695678197000063
						],
						[
							-82.71428857199993,
							27.69565487400007
						],
						[
							-82.71529221599991,
							27.69539745800006
						],
						[
							-82.71538994699995,
							27.695240323000064
						],
						[
							-82.71580869899992,
							27.694589389000043
						],
						[
							-82.71587607899994,
							27.694497927000043
						],
						[
							-82.7159516019999,
							27.69441833500008
						],
						[
							-82.71605560199993,
							27.694321335000044
						],
						[
							-82.71609092699993,
							27.69429007900004
						],
						[
							-82.7162193389999,
							27.69420016400005
						],
						[
							-82.71636141399995,
							27.694133914000076
						],
						[
							-82.7165128339999,
							27.694093341000045
						],
						[
							-82.71657887799995,
							27.69408420500008
						],
						[
							-82.71671787799994,
							27.69407020500006
						],
						[
							-82.7168079999999,
							27.694065678000072
						],
						[
							-82.71688357199992,
							27.694068859000083
						],
						[
							-82.71696657199993,
							27.694075858000076
						],
						[
							-82.71703833099991,
							27.694084828000086
						],
						[
							-82.7171091379999,
							27.694099534000088
						],
						[
							-82.71717853399991,
							27.694119882000052
						],
						[
							-82.71724607099992,
							27.694145740000067
						],
						[
							-82.71731131099995,
							27.69417694100008
						],
						[
							-82.71737383399994,
							27.694213283000067
						],
						[
							-82.7174147419999,
							27.69423931500006
						],
						[
							-82.71744363399995,
							27.694257373000084
						],
						[
							-82.7175022049999,
							27.694297272000085
						],
						[
							-82.71755745199994,
							27.694341659000088
						],
						[
							-82.71760903199994,
							27.694390258000055
						],
						[
							-82.7176566249999,
							27.694442768000044
						],
						[
							-82.71769993599992,
							27.694498862000046
						],
						[
							-82.71773869599991,
							27.694558193000034
						],
						[
							-82.71777266299995,
							27.694620391000058
						],
						[
							-82.7178346629999,
							27.694745392000073
						],
						[
							-82.71786365299994,
							27.69481013500007
						],
						[
							-82.71788744999992,
							27.69487696200008
						],
						[
							-82.71790590499995,
							27.694945456000085
						],
						[
							-82.71791890499992,
							27.695015192000085
						],
						[
							-82.7179263669999,
							27.695085735000077
						],
						[
							-82.71792824699992,
							27.69515664800008
						],
						[
							-82.71792453099994,
							27.695227487000068
						],
						[
							-82.7179175309999,
							27.695303487000047
						],
						[
							-82.71790709999993,
							27.69538030600006
						],
						[
							-82.7178900909999,
							27.69545594200008
						],
						[
							-82.71786663199993,
							27.695529831000044
						],
						[
							-82.71783689699993,
							27.695601426000053
						],
						[
							-82.71780110599991,
							27.69567019300007
						],
						[
							-82.71709698799992,
							27.69689145500007
						],
						[
							-82.71715116399992,
							27.69724540300007
						],
						[
							-82.71725601599991,
							27.69760848900006
						],
						[
							-82.71727765899993,
							27.69770183500009
						],
						[
							-82.7172883909999,
							27.697785457000066
						],
						[
							-82.71730239199991,
							27.697958457000084
						],
						[
							-82.71730531699991,
							27.69802784300009
						],
						[
							-82.71730287899993,
							27.698097247000078
						],
						[
							-82.7172950929999,
							27.698166257000082
						],
						[
							-82.7172820049999,
							27.698234460000037
						],
						[
							-82.71726369299995,
							27.698301450000088
						],
						[
							-82.71722869199994,
							27.698412450000035
						],
						[
							-82.7172053139999,
							27.698477709000088
						],
						[
							-82.71717697799994,
							27.69854097300004
						],
						[
							-82.71714385299993,
							27.698601867000036
						],
						[
							-82.71710613699992,
							27.698660028000063
						],
						[
							-82.71706405299994,
							27.69871511200006
						],
						[
							-82.71701785099992,
							27.698766791000082
						],
						[
							-82.71696780599991,
							27.698814757000036
						],
						[
							-82.71690580699993,
							27.698869757000068
						],
						[
							-82.71685600599994,
							27.698910838000074
						],
						[
							-82.71680338599992,
							27.69894824100004
						],
						[
							-82.7167482189999,
							27.69898177200008
						],
						[
							-82.71669078799994,
							27.699011259000088
						],
						[
							-82.71663138999992,
							27.699036551000063
						],
						[
							-82.7164989879999,
							27.699087319000057
						],
						[
							-82.71643483899993,
							27.699108608000074
						],
						[
							-82.71636927299994,
							27.699125017000085
						],
						[
							-82.7163026579999,
							27.69913645300005
						],
						[
							-82.71623537299992,
							27.69914285200008
						],
						[
							-82.71616779699991,
							27.69914417700005
						],
						[
							-82.71610031199992,
							27.69914042000005
						],
						[
							-82.71599331199991,
							27.699130420000074
						],
						[
							-82.71592083399992,
							27.699120659000073
						],
						[
							-82.71584984899995,
							27.699101639000048
						],
						[
							-82.71563060499994,
							27.69959715700009
						],
						[
							-82.71549660399995,
							27.69992496800006
						],
						[
							-82.71536663799992,
							27.70070604700004
						],
						[
							-82.71492847999991,
							27.70306039700006
						],
						[
							-82.7149484599999,
							27.70382962800005
						],
						[
							-82.71496083799991,
							27.703906678000067
						],
						[
							-82.71505754099991,
							27.703906678000067
						],
						[
							-82.71557685099992,
							27.703844719000074
						],
						[
							-82.71659402699993,
							27.70357064700005
						],
						[
							-82.71662151499993,
							27.703563703000043
						],
						[
							-82.7194235149999,
							27.702902703000067
						],
						[
							-82.71946524899994,
							27.70289389700008
						],
						[
							-82.72092300599991,
							27.70262224700008
						],
						[
							-82.7213927869999,
							27.70252671500009
						],
						[
							-82.7214603779999,
							27.70251563200009
						],
						[
							-82.72152861699993,
							27.702509725000084
						],
						[
							-82.72159710699992,
							27.702509028000065
						],
						[
							-82.72166545099992,
							27.70251354600009
						],
						[
							-82.72186645099993,
							27.702534547000084
						],
						[
							-82.72192916499995,
							27.70254334100008
						],
						[
							-82.72206534999992,
							27.702578523000057
						],
						[
							-82.7222329679999,
							27.702636218000066
						],
						[
							-82.72230056599996,
							27.702663248000082
						],
						[
							-82.72236575499994,
							27.702695659000085
						],
						[
							-82.72242810699993,
							27.702733240000043
						],
						[
							-82.72248721299991,
							27.702775744000064
						],
						[
							-82.72254268599994,
							27.702822892000086
						],
						[
							-82.72263268599994,
							27.702905893000036
						],
						[
							-82.72271192099993,
							27.702988927000035
						],
						[
							-82.72280608599995,
							27.703124866000053
						],
						[
							-82.7228793349999,
							27.703257392000072
						],
						[
							-82.72291336699993,
							27.703325754000048
						],
						[
							-82.72294147699995,
							27.703396757000064
						],
						[
							-82.72296346199994,
							27.703469889000075
						],
						[
							-82.72297916399992,
							27.70354462200004
						],
						[
							-82.72298846899992,
							27.70362041800007
						],
						[
							-82.7230064019999,
							27.703845016000063
						],
						[
							-82.72317606299993,
							27.70486201600005
						],
						[
							-82.72318826499992,
							27.704999912000062
						],
						[
							-82.72320917899992,
							27.70686419000009
						],
						[
							-82.72323647199994,
							27.707825271000047
						],
						[
							-82.72328006399994,
							27.70847832700008
						],
						[
							-82.72332932099994,
							27.70863320600006
						],
						[
							-82.72361310199994,
							27.70899431500004
						],
						[
							-82.72368483499991,
							27.709100339000088
						],
						[
							-82.72372489599991,
							27.70917826100009
						],
						[
							-82.7237938959999,
							27.709330261000048
						],
						[
							-82.72382483199993,
							27.709413983000047
						],
						[
							-82.72371499999991,
							27.709490000000073
						],
						[
							-82.72309999999993,
							27.70988600000004
						],
						[
							-82.72312399999993,
							27.710010000000068
						],
						[
							-82.7231359999999,
							27.710153000000048
						],
						[
							-82.72304999999994,
							27.71025700000007
						],
						[
							-82.72294568099994,
							27.71025387700007
						],
						[
							-82.7228649999999,
							27.710387000000082
						],
						[
							-82.72248699999994,
							27.710847000000058
						],
						[
							-82.72246384199991,
							27.71091918700006
						],
						[
							-82.72247599999992,
							27.712612000000036
						],
						[
							-82.72246399999995,
							27.712744000000043
						],
						[
							-82.72242599999993,
							27.712881000000042
						],
						[
							-82.7223459999999,
							27.713002000000074
						],
						[
							-82.72224699999992,
							27.713107000000036
						],
						[
							-82.72211699999991,
							27.713190000000054
						],
						[
							-82.72198199999991,
							27.713261000000045
						],
						[
							-82.72184599999991,
							27.713322000000062
						],
						[
							-82.72169699999995,
							27.713371000000052
						],
						[
							-82.71686399999993,
							27.714517000000058
						],
						[
							-82.71544547499991,
							27.714843536000046
						],
						[
							-82.71512999999993,
							27.714944000000063
						],
						[
							-82.7146625659999,
							27.71502375700004
						],
						[
							-82.71231999999992,
							27.71556300000009
						],
						[
							-82.7112157059999,
							27.71671461700004
						],
						[
							-82.7102417129999,
							27.716943478000076
						],
						[
							-82.71017903099994,
							27.716955875000053
						],
						[
							-82.70985003099992,
							27.71700887500009
						],
						[
							-82.70970699999994,
							27.717020322000053
						],
						[
							-82.70919732199992,
							27.717020319000085
						],
						[
							-82.70892764399991,
							27.717019315000073
						],
						[
							-82.70878435799995,
							27.71700728600007
						],
						[
							-82.7083063579999,
							27.71692828600004
						],
						[
							-82.70825408099995,
							27.71691804700004
						],
						[
							-82.70767208099994,
							27.716786047000085
						],
						[
							-82.70756341399994,
							27.716754086000037
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Isla Del Sol",
				"RegionID": "416182"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.6939339999999,
					27.733730000000037,
					-82.6793520199999,
					27.744710000000055
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.68336999999991,
							27.74466000000007
						],
						[
							-82.68292278699994,
							27.74464000000006
						],
						[
							-82.68255999999991,
							27.74464000000006
						],
						[
							-82.6821195579999,
							27.74464000000006
						],
						[
							-82.68175999999994,
							27.74464000000006
						],
						[
							-82.68115607899995,
							27.74465010700004
						],
						[
							-82.6803521789999,
							27.744663562000085
						],
						[
							-82.6799239099999,
							27.744670730000053
						],
						[
							-82.67936999999995,
							27.744680000000074
						],
						[
							-82.67937002399992,
							27.744678011000076
						],
						[
							-82.67937903599994,
							27.74393044400006
						],
						[
							-82.67937385399995,
							27.743287903000066
						],
						[
							-82.67937245799993,
							27.742377367000074
						],
						[
							-82.67937762999992,
							27.741467070000056
						],
						[
							-82.67937999999992,
							27.74055680700008
						],
						[
							-82.67937999999992,
							27.739967772000057
						],
						[
							-82.67937461699995,
							27.739164720000076
						],
						[
							-82.67936999999995,
							27.738682606000054
						],
						[
							-82.67936999999995,
							27.737772281000048
						],
						[
							-82.6793669079999,
							27.73718427700004
						],
						[
							-82.67936468799991,
							27.737022194000076
						],
						[
							-82.67935332199994,
							27.736272620000083
						],
						[
							-82.6793520199999,
							27.73589828000007
						],
						[
							-82.67935999999992,
							27.734452269000087
						],
						[
							-82.67935999999992,
							27.73374000000007
						],
						[
							-82.68024535799992,
							27.73374000000007
						],
						[
							-82.6810485869999,
							27.73374000000007
						],
						[
							-82.68185144799992,
							27.733737646000066
						],
						[
							-82.68270820299995,
							27.733733274000087
						],
						[
							-82.6833499999999,
							27.733730000000037
						],
						[
							-82.68379776199993,
							27.733730000000037
						],
						[
							-82.68411968099991,
							27.733730000000037
						],
						[
							-82.6844999999999,
							27.733730000000037
						],
						[
							-82.68471268999991,
							27.733730000000037
						],
						[
							-82.6849329499999,
							27.733730000000037
						],
						[
							-82.68509999999992,
							27.733730000000037
						],
						[
							-82.68530569899991,
							27.733730000000037
						],
						[
							-82.68549999999993,
							27.733730000000037
						],
						[
							-82.68574621899995,
							27.733730000000037
						],
						[
							-82.68608508099993,
							27.733730000000037
						],
						[
							-82.6864799999999,
							27.733730000000037
						],
						[
							-82.68669503299992,
							27.733730000000037
						],
						[
							-82.68708472499992,
							27.733730000000037
						],
						[
							-82.68745999999993,
							27.733730000000037
						],
						[
							-82.6875928739999,
							27.733733322000035
						],
						[
							-82.68771182499995,
							27.733736296000075
						],
						[
							-82.68785999999994,
							27.73374000000007
						],
						[
							-82.68805047899991,
							27.733744646000048
						],
						[
							-82.68826999999993,
							27.733750000000043
						],
						[
							-82.68854183199994,
							27.733750000000043
						],
						[
							-82.68877876099994,
							27.733754410000074
						],
						[
							-82.68896546099995,
							27.733759596000088
						],
						[
							-82.68932099199992,
							27.733769472000063
						],
						[
							-82.68950769299995,
							27.733774658000073
						],
						[
							-82.68972765099994,
							27.733781676000035
						],
						[
							-82.68991436699991,
							27.733792992000076
						],
						[
							-82.69002999999992,
							27.733800000000087
						],
						[
							-82.6900399999999,
							27.733930000000043
						],
						[
							-82.69016831199991,
							27.733933208000053
						],
						[
							-82.69033806099992,
							27.73393745200008
						],
						[
							-82.69043999999991,
							27.733940000000075
						],
						[
							-82.69072749199995,
							27.733940000000075
						],
						[
							-82.69096469599992,
							27.733940000000075
						],
						[
							-82.6918946269999,
							27.733940000000075
						],
						[
							-82.6918169999999,
							27.73396000000008
						],
						[
							-82.69267627699992,
							27.734581500000047
						],
						[
							-82.69260366099991,
							27.73463283500007
						],
						[
							-82.69257437499994,
							27.734647602000052
						],
						[
							-82.69265100699994,
							27.734909019000042
						],
						[
							-82.69267359899993,
							27.735005493000074
						],
						[
							-82.69271459899994,
							27.735237494000046
						],
						[
							-82.69272574299993,
							27.735325944000067
						],
						[
							-82.69273670299992,
							27.73547035900009
						],
						[
							-82.69276891999993,
							27.735489431000076
						],
						[
							-82.69322962199993,
							27.73567991400006
						],
						[
							-82.69331622499993,
							27.735721262000084
						],
						[
							-82.6938247679999,
							27.735998300000066
						],
						[
							-82.6939339999999,
							27.736831000000052
						],
						[
							-82.69388254299992,
							27.73705388600007
						],
						[
							-82.6937529999999,
							27.737615000000062
						],
						[
							-82.69184299999995,
							27.737764000000084
						],
						[
							-82.69185499999992,
							27.737847000000045
						],
						[
							-82.69184199999995,
							27.73798400000004
						],
						[
							-82.6918179999999,
							27.738083000000074
						],
						[
							-82.69184199999995,
							27.738221000000067
						],
						[
							-82.69193663099992,
							27.73857417800008
						],
						[
							-82.6919539999999,
							27.73863900000004
						],
						[
							-82.69197899999995,
							27.738765000000058
						],
						[
							-82.69196785799994,
							27.738805634000077
						],
						[
							-82.69194499999993,
							27.738889000000086
						],
						[
							-82.69193499999994,
							27.73892500000005
						],
						[
							-82.69184299999995,
							27.73909000000009
						],
						[
							-82.69174399999991,
							27.739200000000043
						],
						[
							-82.69109779999991,
							27.740156212000045
						],
						[
							-82.69095399999992,
							27.740369000000044
						],
						[
							-82.68924299999992,
							27.741756000000066
						],
						[
							-82.68835699999994,
							27.74211500000007
						],
						[
							-82.68721369699995,
							27.74250886200008
						],
						[
							-82.6865949999999,
							27.74272200000007
						],
						[
							-82.68642699999992,
							27.744091000000083
						],
						[
							-82.68637299999995,
							27.744413000000065
						],
						[
							-82.68634810399993,
							27.744673942000077
						],
						[
							-82.68540999999993,
							27.74470000000008
						],
						[
							-82.68490408399992,
							27.744710000000055
						],
						[
							-82.68441999999993,
							27.744710000000055
						],
						[
							-82.68399375799993,
							27.744710000000055
						],
						[
							-82.68336999999991,
							27.74466000000007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Clam Bayou",
				"RegionID": "416362"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.48837690499994,
					27.334105151000074,
					-82.48579739699994,
					27.337537643000076
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.48579739699994,
							27.337537643000076
						],
						[
							-82.48579739899994,
							27.334105151000074
						],
						[
							-82.48837690499994,
							27.334105171000093
						],
						[
							-82.48836604699994,
							27.335961876000056
						],
						[
							-82.48824700599994,
							27.33747318400009
						],
						[
							-82.48579739699994,
							27.337537643000076
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Beechwood",
				"RegionID": "343988"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.39020399999993,
					27.39471800000007,
					-80.3259119999999,
					27.43096600000007
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-80.3260009999999,
								27.397343000000035
							],
							[
								-80.32599499999992,
								27.39701400000007
							],
							[
								-80.3285449999999,
								27.397017000000062
							],
							[
								-80.3285449999999,
								27.39736300000004
							],
							[
								-80.3260009999999,
								27.397343000000035
							]
						]
					],
					[
						[
							[
								-80.33685899999995,
								27.397700000000043
							],
							[
								-80.33684399999993,
								27.396524000000056
							],
							[
								-80.33737499999995,
								27.396539000000075
							],
							[
								-80.33737499999995,
								27.397700000000043
							],
							[
								-80.33685899999995,
								27.397700000000043
							]
						]
					],
					[
						[
							[
								-80.3270149999999,
								27.402007000000083
							],
							[
								-80.3270159999999,
								27.401871000000085
							],
							[
								-80.32759399999992,
								27.401883000000055
							],
							[
								-80.32759399999992,
								27.402009000000078
							],
							[
								-80.3270149999999,
								27.402007000000083
							]
						]
					],
					[
						[
							[
								-80.34368499999994,
								27.401689000000093
							],
							[
								-80.34371599999992,
								27.401591000000053
							],
							[
								-80.34409799999992,
								27.40160700000007
							],
							[
								-80.34411999999992,
								27.402686000000074
							],
							[
								-80.34368499999994,
								27.402686000000074
							],
							[
								-80.34368499999994,
								27.401689000000093
							]
						]
					],
					[
						[
							[
								-80.34551999999991,
								27.40297800000008
							],
							[
								-80.34549599999991,
								27.402843000000075
							],
							[
								-80.34484099999992,
								27.40287600000005
							],
							[
								-80.34467799999993,
								27.40288400000009
							],
							[
								-80.34465099999994,
								27.40173600000009
							],
							[
								-80.34481099999994,
								27.401730000000043
							],
							[
								-80.3458139999999,
								27.401695000000075
							],
							[
								-80.34577899999994,
								27.40309300000007
							],
							[
								-80.34546099999994,
								27.403114000000073
							],
							[
								-80.34551999999991,
								27.40297800000008
							]
						]
					],
					[
						[
							[
								-80.36278199999992,
								27.40765300000004
							],
							[
								-80.36300199999994,
								27.40765200000004
							],
							[
								-80.36300199999994,
								27.407860000000085
							],
							[
								-80.36278199999992,
								27.407852000000048
							],
							[
								-80.36278199999992,
								27.40765300000004
							]
						]
					],
					[
						[
							[
								-80.34146599999991,
								27.410911000000056
							],
							[
								-80.34148099999993,
								27.410143000000062
							],
							[
								-80.34216499999991,
								27.41014700000005
							],
							[
								-80.34216499999991,
								27.409625000000062
							],
							[
								-80.3421679999999,
								27.409445000000062
							],
							[
								-80.3423029999999,
								27.409447000000057
							],
							[
								-80.3426189999999,
								27.409447000000057
							],
							[
								-80.3426189999999,
								27.40905000000004
							],
							[
								-80.34244699999994,
								27.40904800000004
							],
							[
								-80.3424399999999,
								27.40937100000008
							],
							[
								-80.3423049999999,
								27.409369000000083
							],
							[
								-80.34149899999994,
								27.40936300000004
							],
							[
								-80.34150199999993,
								27.409119000000093
							],
							[
								-80.34208999999993,
								27.409152000000063
							],
							[
								-80.34208999999993,
								27.408809000000076
							],
							[
								-80.34150599999992,
								27.40877500000005
							],
							[
								-80.34153499999991,
								27.406231000000048
							],
							[
								-80.33826399999992,
								27.407319000000086
							],
							[
								-80.3382039999999,
								27.40733900000004
							],
							[
								-80.33751299999994,
								27.407575000000065
							],
							[
								-80.33751299999994,
								27.408346000000055
							],
							[
								-80.33765999999991,
								27.408346000000055
							],
							[
								-80.33757199999991,
								27.410818000000063
							],
							[
								-80.33756999999991,
								27.410937000000047
							],
							[
								-80.33387599999992,
								27.41089800000009
							],
							[
								-80.33387199999993,
								27.410718000000088
							],
							[
								-80.33374099999992,
								27.410715000000042
							],
							[
								-80.33373699999993,
								27.41021500000005
							],
							[
								-80.33344599999992,
								27.41021500000005
							],
							[
								-80.3334539999999,
								27.410708000000056
							],
							[
								-80.3334539999999,
								27.410843000000057
							],
							[
								-80.33095899999995,
								27.410808000000088
							],
							[
								-80.33096899999993,
								27.41066600000005
							],
							[
								-80.33095899999995,
								27.40961800000008
							],
							[
								-80.33336899999995,
								27.408790000000067
							],
							[
								-80.33342099999993,
								27.409797000000083
							],
							[
								-80.33387199999993,
								27.409797000000083
							],
							[
								-80.33387199999993,
								27.408618000000047
							],
							[
								-80.33387199999993,
								27.408318000000065
							],
							[
								-80.33387199999993,
								27.40798700000005
							],
							[
								-80.33193699999993,
								27.408670000000086
							],
							[
								-80.3309779999999,
								27.408997000000056
							],
							[
								-80.33013999999991,
								27.409293000000048
							],
							[
								-80.32948699999992,
								27.409523000000036
							],
							[
								-80.3295129999999,
								27.409034000000077
							],
							[
								-80.32952799999993,
								27.408747000000062
							],
							[
								-80.32610299999993,
								27.40870300000006
							],
							[
								-80.32611099999991,
								27.407827000000054
							],
							[
								-80.3261139999999,
								27.407751000000076
							],
							[
								-80.3263649999999,
								27.407759000000055
							],
							[
								-80.32757199999992,
								27.407814000000087
							],
							[
								-80.32757199999992,
								27.406618000000037
							],
							[
								-80.32671999999991,
								27.406618000000037
							],
							[
								-80.32671999999991,
								27.40607900000009
							],
							[
								-80.32671999999991,
								27.405921000000035
							],
							[
								-80.32600599999995,
								27.405914000000053
							],
							[
								-80.32593799999995,
								27.405913000000055
							],
							[
								-80.32594599999993,
								27.405571000000066
							],
							[
								-80.32601499999993,
								27.40557400000006
							],
							[
								-80.32758399999994,
								27.405601000000047
							],
							[
								-80.3275539999999,
								27.405260000000055
							],
							[
								-80.32756199999994,
								27.40500200000008
							],
							[
								-80.32757199999992,
								27.404660000000035
							],
							[
								-80.32756099999995,
								27.404426000000058
							],
							[
								-80.32598699999994,
								27.404374000000075
							],
							[
								-80.32591699999995,
								27.404371000000083
							],
							[
								-80.3259119999999,
								27.403906000000063
							],
							[
								-80.32630799999994,
								27.403916000000038
							],
							[
								-80.3296719999999,
								27.40391800000009
							],
							[
								-80.3296719999999,
								27.40330300000005
							],
							[
								-80.3296719999999,
								27.402937000000065
							],
							[
								-80.32959699999992,
								27.402940000000058
							],
							[
								-80.32915099999991,
								27.402941000000055
							],
							[
								-80.32598699999994,
								27.402948000000038
							],
							[
								-80.3259339999999,
								27.402946000000043
							],
							[
								-80.3259339999999,
								27.40236100000004
							],
							[
								-80.32598699999994,
								27.40236200000004
							],
							[
								-80.32954799999993,
								27.402367000000083
							],
							[
								-80.32954099999996,
								27.402015000000063
							],
							[
								-80.32954899999993,
								27.40130300000004
							],
							[
								-80.32601899999992,
								27.40127700000005
							],
							[
								-80.32601899999992,
								27.401064000000076
							],
							[
								-80.32601399999993,
								27.400104000000056
							],
							[
								-80.32601499999993,
								27.40000500000008
							],
							[
								-80.32601399999993,
								27.399909000000036
							],
							[
								-80.32807899999995,
								27.399938000000077
							],
							[
								-80.3281199999999,
								27.40032400000007
							],
							[
								-80.3296719999999,
								27.40033800000009
							],
							[
								-80.3296719999999,
								27.39991800000007
							],
							[
								-80.32970899999992,
								27.399616000000037
							],
							[
								-80.32601299999993,
								27.39959300000004
							],
							[
								-80.32601299999993,
								27.399467000000072
							],
							[
								-80.32600899999994,
								27.398501000000067
							],
							[
								-80.32984299999993,
								27.398543000000075
							],
							[
								-80.32987199999992,
								27.398318000000074
							],
							[
								-80.32982299999993,
								27.397674000000052
							],
							[
								-80.33091799999994,
								27.397661000000085
							],
							[
								-80.33148999999992,
								27.397661000000085
							],
							[
								-80.3332749999999,
								27.397668000000067
							],
							[
								-80.3332969999999,
								27.397023000000047
							],
							[
								-80.33387199999993,
								27.39701800000006
							],
							[
								-80.33547199999992,
								27.39731800000004
							],
							[
								-80.33555499999994,
								27.398673000000088
							],
							[
								-80.33495799999992,
								27.398697000000084
							],
							[
								-80.33495099999993,
								27.399159000000058
							],
							[
								-80.3340869999999,
								27.39912300000009
							],
							[
								-80.33405399999992,
								27.399512000000072
							],
							[
								-80.33560899999992,
								27.399545000000046
							],
							[
								-80.33762899999994,
								27.399567000000047
							],
							[
								-80.33763099999993,
								27.399690000000078
							],
							[
								-80.33749499999993,
								27.399790000000053
							],
							[
								-80.33751399999994,
								27.40090900000007
							],
							[
								-80.33569299999994,
								27.40092700000008
							],
							[
								-80.33573099999991,
								27.401538000000073
							],
							[
								-80.33587399999993,
								27.401537000000076
							],
							[
								-80.33585599999992,
								27.402195000000063
							],
							[
								-80.33751199999995,
								27.402203000000043
							],
							[
								-80.3375319999999,
								27.403305000000046
							],
							[
								-80.3376669999999,
								27.40330400000005
							],
							[
								-80.34147599999994,
								27.40330400000005
							],
							[
								-80.34413199999995,
								27.403284000000042
							],
							[
								-80.34441599999991,
								27.403282000000047
							],
							[
								-80.34442799999994,
								27.403714000000036
							],
							[
								-80.34443799999991,
								27.404105000000072
							],
							[
								-80.34433999999993,
								27.40509200000008
							],
							[
								-80.34432499999991,
								27.405167000000063
							],
							[
								-80.3441719999999,
								27.405218000000048
							],
							[
								-80.34398699999991,
								27.405838000000077
							],
							[
								-80.34337299999993,
								27.405879000000084
							],
							[
								-80.34336399999995,
								27.406008000000043
							],
							[
								-80.34335499999992,
								27.406152000000077
							],
							[
								-80.34387599999991,
								27.40621100000004
							],
							[
								-80.34365799999995,
								27.40694300000007
							],
							[
								-80.34309499999995,
								27.40695800000009
							],
							[
								-80.34308899999992,
								27.407107000000053
							],
							[
								-80.3436089999999,
								27.407107000000053
							],
							[
								-80.34247199999993,
								27.410918000000038
							],
							[
								-80.34238199999993,
								27.41108200000008
							],
							[
								-80.34146299999992,
								27.411069000000055
							],
							[
								-80.34146599999991,
								27.410911000000056
							]
						]
					],
					[
						[
							[
								-80.36064799999991,
								27.413069000000064
							],
							[
								-80.3616209999999,
								27.41305900000009
							],
							[
								-80.36162699999994,
								27.413917000000083
							],
							[
								-80.36149299999994,
								27.413916000000086
							],
							[
								-80.36088899999993,
								27.41391200000004
							],
							[
								-80.36033699999992,
								27.41390800000005
							],
							[
								-80.36033199999991,
								27.413800000000037
							],
							[
								-80.36027299999995,
								27.41364400000009
							],
							[
								-80.36026699999991,
								27.41355800000008
							],
							[
								-80.36039099999994,
								27.41309700000005
							],
							[
								-80.36064799999991,
								27.413069000000064
							]
						]
					],
					[
						[
							[
								-80.38276399999995,
								27.414627000000056
							],
							[
								-80.38276999999994,
								27.413523000000055
							],
							[
								-80.38263599999993,
								27.413523000000055
							],
							[
								-80.38137499999993,
								27.413523000000055
							],
							[
								-80.38137499999993,
								27.411745000000057
							],
							[
								-80.38264399999991,
								27.411745000000057
							],
							[
								-80.38277899999991,
								27.411745000000057
							],
							[
								-80.3827829999999,
								27.410960000000046
							],
							[
								-80.3827839999999,
								27.41086400000006
							],
							[
								-80.3829189999999,
								27.410865000000058
							],
							[
								-80.3829179999999,
								27.410960000000046
							],
							[
								-80.38291399999991,
								27.411745000000057
							],
							[
								-80.38290499999994,
								27.413523000000055
							],
							[
								-80.38289899999995,
								27.414627000000056
							],
							[
								-80.38276399999995,
								27.414627000000056
							]
						]
					],
					[
						[
							[
								-80.38275799999991,
								27.415681000000067
							],
							[
								-80.38289199999991,
								27.415681000000067
							],
							[
								-80.38289399999991,
								27.416522000000043
							],
							[
								-80.38275299999992,
								27.416522000000043
							],
							[
								-80.38275799999991,
								27.415681000000067
							]
						]
					],
					[
						[
							[
								-80.37457999999992,
								27.41699200000005
							],
							[
								-80.37457199999994,
								27.416709000000083
							],
							[
								-80.37510999999995,
								27.416715000000067
							],
							[
								-80.37543999999991,
								27.416715000000067
							],
							[
								-80.37546299999991,
								27.416960000000074
							],
							[
								-80.37510999999995,
								27.416973000000045
							],
							[
								-80.37457999999992,
								27.41699200000005
							]
						]
					],
					[
						[
							[
								-80.37457999999992,
								27.41699200000005
							],
							[
								-80.37460599999991,
								27.417878000000087
							],
							[
								-80.37261699999995,
								27.41785500000009
							],
							[
								-80.37258999999995,
								27.416986000000065
							],
							[
								-80.37457999999992,
								27.41699200000005
							]
						]
					],
					[
						[
							[
								-80.36037299999992,
								27.421017000000063
							],
							[
								-80.3603609999999,
								27.42075900000009
							],
							[
								-80.36242099999993,
								27.42076600000007
							],
							[
								-80.36237399999993,
								27.421392000000083
							],
							[
								-80.36038599999995,
								27.42139300000008
							],
							[
								-80.36037299999992,
								27.421017000000063
							]
						]
					],
					[
						[
							[
								-80.34378599999991,
								27.41859500000004
							],
							[
								-80.3438129999999,
								27.418138000000056
							],
							[
								-80.3434289999999,
								27.418143000000047
							],
							[
								-80.3434069999999,
								27.41860500000007
							],
							[
								-80.34378599999991,
								27.41859500000004
							],
							[
								-80.34374699999995,
								27.419421000000057
							],
							[
								-80.34367199999991,
								27.419417000000067
							],
							[
								-80.34367199999991,
								27.419492000000048
							],
							[
								-80.34327899999994,
								27.419478000000087
							],
							[
								-80.34327899999994,
								27.41966000000008
							],
							[
								-80.34367199999991,
								27.419661000000076
							],
							[
								-80.34367199999991,
								27.42008800000008
							],
							[
								-80.34366799999992,
								27.420498000000066
							],
							[
								-80.34373899999991,
								27.420499000000063
							],
							[
								-80.34373899999991,
								27.42096500000008
							],
							[
								-80.3441939999999,
								27.42096500000008
							],
							[
								-80.3441719999999,
								27.42201700000004
							],
							[
								-80.34370099999991,
								27.422037000000046
							],
							[
								-80.3436999999999,
								27.421931000000086
							],
							[
								-80.34372499999995,
								27.42178300000006
							],
							[
								-80.34372799999994,
								27.421766000000048
							],
							[
								-80.34380499999992,
								27.42143200000004
							],
							[
								-80.34380499999992,
								27.421417000000076
							],
							[
								-80.34373899999991,
								27.42135200000007
							],
							[
								-80.34367199999991,
								27.420917000000088
							],
							[
								-80.34317599999991,
								27.420940000000087
							],
							[
								-80.34317599999991,
								27.420821000000046
							],
							[
								-80.34317499999992,
								27.420494000000076
							],
							[
								-80.3431809999999,
								27.420360000000073
							],
							[
								-80.34335199999992,
								27.420347000000053
							],
							[
								-80.34335699999991,
								27.42008800000008
							],
							[
								-80.34318599999995,
								27.42008100000004
							],
							[
								-80.3431809999999,
								27.420360000000073
							],
							[
								-80.34299699999993,
								27.420355000000086
							],
							[
								-80.34290299999994,
								27.420352000000037
							],
							[
								-80.34290399999992,
								27.420066000000077
							],
							[
								-80.34290499999992,
								27.41991500000006
							],
							[
								-80.3419859999999,
								27.419899000000044
							],
							[
								-80.34172099999995,
								27.419901000000042
							],
							[
								-80.34151999999995,
								27.41988500000008
							],
							[
								-80.34157199999993,
								27.41931700000004
							],
							[
								-80.34157199999993,
								27.418117000000052
							],
							[
								-80.3417869999999,
								27.418117000000052
							],
							[
								-80.34181299999995,
								27.41741700000006
							],
							[
								-80.34184199999993,
								27.41661700000009
							],
							[
								-80.34182399999993,
								27.415717000000086
							],
							[
								-80.34182399999993,
								27.415190000000056
							],
							[
								-80.34286899999995,
								27.41519500000004
							],
							[
								-80.34286899999995,
								27.414993000000038
							],
							[
								-80.34319799999992,
								27.41499200000004
							],
							[
								-80.34362599999992,
								27.414990000000046
							],
							[
								-80.34362599999992,
								27.414685000000077
							],
							[
								-80.34427899999991,
								27.414686000000074
							],
							[
								-80.3449379999999,
								27.41468800000007
							],
							[
								-80.34497199999993,
								27.41395300000005
							],
							[
								-80.34427199999993,
								27.413955000000044
							],
							[
								-80.34362399999992,
								27.413954000000047
							],
							[
								-80.34362599999992,
								27.414685000000077
							],
							[
								-80.34320899999994,
								27.41468000000009
							],
							[
								-80.34289799999993,
								27.414676000000046
							],
							[
								-80.34287199999994,
								27.414517000000046
							],
							[
								-80.34181399999994,
								27.414517000000046
							],
							[
								-80.34161899999992,
								27.414517000000046
							],
							[
								-80.34161899999992,
								27.41384700000009
							],
							[
								-80.34161899999992,
								27.413524000000052
							],
							[
								-80.34181299999995,
								27.413533000000086
							],
							[
								-80.34215299999994,
								27.413533000000086
							],
							[
								-80.34215099999994,
								27.41350600000004
							],
							[
								-80.34215299999994,
								27.413424000000077
							],
							[
								-80.34216199999992,
								27.413271000000066
							],
							[
								-80.34218199999992,
								27.413152000000082
							],
							[
								-80.34193899999991,
								27.413152000000082
							],
							[
								-80.34181099999995,
								27.413152000000082
							],
							[
								-80.34180999999995,
								27.41301700000008
							],
							[
								-80.34193899999991,
								27.41301700000008
							],
							[
								-80.34198499999991,
								27.41293200000007
							],
							[
								-80.34205799999997,
								27.41279700000007
							],
							[
								-80.3423919999999,
								27.412177000000042
							],
							[
								-80.3425969999999,
								27.41166700000008
							],
							[
								-80.34281199999992,
								27.410918000000038
							],
							[
								-80.34307199999995,
								27.410918000000038
							],
							[
								-80.34359299999994,
								27.409249000000045
							],
							[
								-80.34397499999994,
								27.409347000000082
							],
							[
								-80.3440359999999,
								27.409148000000073
							],
							[
								-80.3436549999999,
								27.409052000000088
							],
							[
								-80.34375099999994,
								27.408744000000073
							],
							[
								-80.34426499999995,
								27.40883900000006
							],
							[
								-80.34431199999995,
								27.408679000000063
							],
							[
								-80.34436899999992,
								27.40848600000004
							],
							[
								-80.34386199999994,
								27.40839100000005
							],
							[
								-80.34366899999992,
								27.408354000000088
							],
							[
								-80.34403299999991,
								27.407269000000046
							],
							[
								-80.34421199999991,
								27.407269000000046
							],
							[
								-80.34451399999995,
								27.407269000000046
							],
							[
								-80.34451399999995,
								27.40746900000005
							],
							[
								-80.3450059999999,
								27.407470000000046
							],
							[
								-80.3449149999999,
								27.407005000000083
							],
							[
								-80.34451799999994,
								27.407005000000083
							],
							[
								-80.34451799999994,
								27.407105000000062
							],
							[
								-80.3442629999999,
								27.407105000000062
							],
							[
								-80.34457199999991,
								27.40611800000005
							],
							[
								-80.34441399999992,
								27.40611800000005
							],
							[
								-80.34443899999991,
								27.40597100000008
							],
							[
								-80.34446699999995,
								27.405831000000035
							],
							[
								-80.34460399999995,
								27.405144000000064
							],
							[
								-80.34461399999992,
								27.40504700000008
							],
							[
								-80.34470599999992,
								27.40411800000004
							],
							[
								-80.34469699999994,
								27.40371900000008
							],
							[
								-80.34486199999992,
								27.40371300000004
							],
							[
								-80.3455429999999,
								27.403688000000045
							],
							[
								-80.34553199999993,
								27.40352100000007
							],
							[
								-80.34800199999995,
								27.40349000000009
							],
							[
								-80.34823699999993,
								27.400218000000052
							],
							[
								-80.3463549999999,
								27.400218000000052
							],
							[
								-80.34636699999993,
								27.40127700000005
							],
							[
								-80.34582599999993,
								27.40126700000008
							],
							[
								-80.34582599999993,
								27.40157000000005
							],
							[
								-80.34480699999995,
								27.401561000000072
							],
							[
								-80.34464699999995,
								27.401559000000077
							],
							[
								-80.34463599999992,
								27.401076000000046
							],
							[
								-80.34463399999993,
								27.40099100000009
							],
							[
								-80.34461599999992,
								27.400218000000052
							],
							[
								-80.34447199999994,
								27.400218000000052
							],
							[
								-80.34433599999994,
								27.40025200000008
							],
							[
								-80.34435699999995,
								27.40106200000008
							],
							[
								-80.34408699999994,
								27.401046000000065
							],
							[
								-80.34327899999994,
								27.40099900000007
							],
							[
								-80.34327899999994,
								27.40048900000005
							],
							[
								-80.34147599999994,
								27.400400000000047
							],
							[
								-80.34147599999994,
								27.397173000000066
							],
							[
								-80.34291499999995,
								27.397173000000066
							],
							[
								-80.34351299999993,
								27.397158000000047
							],
							[
								-80.34369599999991,
								27.39712200000008
							],
							[
								-80.34337199999995,
								27.396718000000078
							],
							[
								-80.34499399999993,
								27.396718000000078
							],
							[
								-80.34787199999994,
								27.396718000000078
							],
							[
								-80.34937199999992,
								27.396718000000078
							],
							[
								-80.34997199999992,
								27.396818000000053
							],
							[
								-80.34997199999992,
								27.395439000000067
							],
							[
								-80.34997199999992,
								27.39471800000007
							],
							[
								-80.35008999999991,
								27.39476300000007
							],
							[
								-80.35003099999994,
								27.395548000000076
							],
							[
								-80.35033799999991,
								27.396115000000066
							],
							[
								-80.35054099999992,
								27.396577000000036
							],
							[
								-80.35093999999992,
								27.397248000000047
							],
							[
								-80.35138299999996,
								27.397324000000083
							],
							[
								-80.35188199999993,
								27.397451000000046
							],
							[
								-80.35218199999991,
								27.397616000000085
							],
							[
								-80.35228199999995,
								27.39788100000004
							],
							[
								-80.35225199999991,
								27.40010300000006
							],
							[
								-80.35332299999993,
								27.40012500000006
							],
							[
								-80.35327299999994,
								27.40219200000007
							],
							[
								-80.3532229999999,
								27.404254000000037
							],
							[
								-80.35449299999993,
								27.40553400000005
							],
							[
								-80.3599759999999,
								27.405687000000057
							],
							[
								-80.35999699999991,
								27.40522700000008
							],
							[
								-80.35623499999991,
								27.40513700000008
							],
							[
								-80.35643599999992,
								27.40115700000007
							],
							[
								-80.35661599999992,
								27.39760700000005
							],
							[
								-80.3569389999999,
								27.39761100000004
							],
							[
								-80.35745799999995,
								27.397676000000047
							],
							[
								-80.35806799999995,
								27.397813000000042
							],
							[
								-80.35854099999995,
								27.397966000000054
							],
							[
								-80.35893799999991,
								27.39827900000006
							],
							[
								-80.35938099999993,
								27.398694000000035
							],
							[
								-80.35994499999993,
								27.399240000000077
							],
							[
								-80.36041799999992,
								27.39985400000006
							],
							[
								-80.36069299999991,
								27.400159000000087
							],
							[
								-80.3610129999999,
								27.40054400000008
							],
							[
								-80.36137899999994,
								27.40104400000007
							],
							[
								-80.36188299999993,
								27.40147500000006
							],
							[
								-80.3628599999999,
								27.402253000000087
							],
							[
								-80.36345499999993,
								27.40269600000005
							],
							[
								-80.36389699999995,
								27.40297800000008
							],
							[
								-80.36417199999994,
								27.403199000000086
							],
							[
								-80.3645229999999,
								27.403306000000043
							],
							[
								-80.36491899999993,
								27.40352800000005
							],
							[
								-80.36543799999993,
								27.40374500000007
							],
							[
								-80.36577399999993,
								27.403898000000083
							],
							[
								-80.36617099999995,
								27.404123000000084
							],
							[
								-80.36653699999994,
								27.40427500000004
							],
							[
								-80.36691799999994,
								27.404504000000088
							],
							[
								-80.36705599999993,
								27.40467600000005
							],
							[
								-80.36795599999994,
								27.405317000000082
							],
							[
								-80.36836799999992,
								27.40558400000009
							],
							[
								-80.36876499999994,
								27.40566000000007
							],
							[
								-80.3691159999999,
								27.405580000000043
							],
							[
								-80.36948199999995,
								27.405462000000057
							],
							[
								-80.37042799999995,
								27.404973000000044
							],
							[
								-80.3725179999999,
								27.403470000000087
							],
							[
								-80.37261799999993,
								27.403437000000054
							],
							[
								-80.37283899999994,
								27.403364000000067
							],
							[
								-80.37306799999993,
								27.403165000000058
							],
							[
								-80.37325099999993,
								27.402971000000036
							],
							[
								-80.37335799999994,
								27.402829000000054
							],
							[
								-80.37363199999993,
								27.40266900000006
							],
							[
								-80.37402899999995,
								27.402433000000087
							],
							[
								-80.37444099999993,
								27.40222300000005
							],
							[
								-80.37477299999996,
								27.402107000000058
							],
							[
								-80.37653899999992,
								27.40209200000004
							],
							[
								-80.37797799999993,
								27.401680000000056
							],
							[
								-80.38198699999992,
								27.39922800000005
							],
							[
								-80.38275799999991,
								27.39909000000006
							],
							[
								-80.3838879999999,
								27.399481000000037
							],
							[
								-80.38434999999993,
								27.399848000000077
							],
							[
								-80.38558299999994,
								27.40046700000005
							],
							[
								-80.38640499999991,
								27.40065100000004
							],
							[
								-80.38771499999991,
								27.401706000000047
							],
							[
								-80.38797199999993,
								27.401798000000042
							],
							[
								-80.39020399999993,
								27.40157000000005
							],
							[
								-80.38991099999993,
								27.402101000000073
							],
							[
								-80.38938499999995,
								27.403302000000053
							],
							[
								-80.3892439999999,
								27.40389900000008
							],
							[
								-80.3887519999999,
								27.40597400000007
							],
							[
								-80.38857599999994,
								27.407219000000055
							],
							[
								-80.38829499999991,
								27.40921700000007
							],
							[
								-80.38823699999995,
								27.41089400000004
							],
							[
								-80.38818199999993,
								27.412487000000056
							],
							[
								-80.3881869999999,
								27.41294100000005
							],
							[
								-80.3882099999999,
								27.41493900000006
							],
							[
								-80.38821399999995,
								27.415279000000055
							],
							[
								-80.38821699999994,
								27.41591100000005
							],
							[
								-80.3879859999999,
								27.415985000000035
							],
							[
								-80.38760899999994,
								27.41608400000007
							],
							[
								-80.38617299999993,
								27.41658700000005
							],
							[
								-80.38592499999993,
								27.41666100000009
							],
							[
								-80.38549499999993,
								27.416811000000052
							],
							[
								-80.38485199999991,
								27.417012000000057
							],
							[
								-80.38403399999993,
								27.41724700000009
							],
							[
								-80.38371999999993,
								27.41736700000007
							],
							[
								-80.3829659999999,
								27.41761000000008
							],
							[
								-80.38370999999995,
								27.417249000000083
							],
							[
								-80.38476099999993,
								27.416675000000055
							],
							[
								-80.3848759999999,
								27.41660200000007
							],
							[
								-80.38513299999994,
								27.416299000000038
							],
							[
								-80.38542499999994,
								27.41601200000008
							],
							[
								-80.38582799999995,
								27.415091000000075
							],
							[
								-80.38743999999991,
								27.41277400000007
							],
							[
								-80.38775699999991,
								27.411561000000063
							],
							[
								-80.38781599999993,
								27.410892000000047
							],
							[
								-80.38803599999994,
								27.403613000000068
							],
							[
								-80.38290499999994,
								27.40363500000007
							],
							[
								-80.38288999999992,
								27.40437200000008
							],
							[
								-80.38288899999992,
								27.405568000000073
							],
							[
								-80.38288799999992,
								27.406126000000086
							],
							[
								-80.3829399999999,
								27.40709300000009
							],
							[
								-80.38293899999991,
								27.407634000000087
							],
							[
								-80.38734899999992,
								27.407846000000063
							],
							[
								-80.38736199999994,
								27.409398000000067
							],
							[
								-80.38464099999993,
								27.409410000000037
							],
							[
								-80.38464099999993,
								27.40895000000006
							],
							[
								-80.38293199999993,
								27.408971000000065
							],
							[
								-80.38279399999993,
								27.40897300000006
							],
							[
								-80.38279999999992,
								27.40794500000004
							],
							[
								-80.38280199999991,
								27.407627000000048
							],
							[
								-80.38266699999991,
								27.407627000000048
							],
							[
								-80.3826699999999,
								27.407095000000083
							],
							[
								-80.38261899999992,
								27.406133000000068
							],
							[
								-80.38261999999992,
								27.405571000000066
							],
							[
								-80.37991099999994,
								27.40562600000004
							],
							[
								-80.37994999999995,
								27.40262400000006
							],
							[
								-80.3808469999999,
								27.40256500000004
							],
							[
								-80.38139799999993,
								27.402546000000086
							],
							[
								-80.38274899999993,
								27.40250000000009
							],
							[
								-80.38263299999994,
								27.40065800000008
							],
							[
								-80.3801959999999,
								27.40085300000004
							],
							[
								-80.37801899999994,
								27.402521000000036
							],
							[
								-80.37802099999993,
								27.40259000000009
							],
							[
								-80.37668899999994,
								27.40259000000009
							],
							[
								-80.37669499999994,
								27.40250700000007
							],
							[
								-80.37475199999994,
								27.40256000000005
							],
							[
								-80.37460899999991,
								27.403726000000063
							],
							[
								-80.37462399999993,
								27.40478300000007
							],
							[
								-80.37465099999991,
								27.405523000000073
							],
							[
								-80.37539299999992,
								27.405535000000047
							],
							[
								-80.3754199999999,
								27.406424000000076
							],
							[
								-80.37640099999993,
								27.40636500000005
							],
							[
								-80.37639499999995,
								27.407210000000077
							],
							[
								-80.37756699999994,
								27.407188000000076
							],
							[
								-80.37776699999995,
								27.407184000000086
							],
							[
								-80.37775599999992,
								27.40783900000008
							],
							[
								-80.37628299999994,
								27.40787000000006
							],
							[
								-80.37628299999994,
								27.407628000000045
							],
							[
								-80.37512299999992,
								27.40767100000005
							],
							[
								-80.37494599999991,
								27.40767800000009
							],
							[
								-80.37495699999994,
								27.40747700000009
							],
							[
								-80.37477499999996,
								27.407479000000084
							],
							[
								-80.37474099999991,
								27.40909000000005
							],
							[
								-80.37474099999991,
								27.410105000000048
							],
							[
								-80.37511599999993,
								27.41011400000008
							],
							[
								-80.37590399999993,
								27.41012500000005
							],
							[
								-80.37590699999993,
								27.410915000000045
							],
							[
								-80.37590699999993,
								27.41097700000006
							],
							[
								-80.37879499999991,
								27.410955000000058
							],
							[
								-80.37879499999991,
								27.41288700000007
							],
							[
								-80.37703499999992,
								27.41288700000007
							],
							[
								-80.37703499999992,
								27.41496200000006
							],
							[
								-80.37690299999991,
								27.41496200000006
							],
							[
								-80.37511199999994,
								27.41496200000006
							],
							[
								-80.3745189999999,
								27.414961000000062
							],
							[
								-80.37404599999991,
								27.414959000000067
							],
							[
								-80.37404399999991,
								27.414915000000065
							],
							[
								-80.37404399999991,
								27.414833000000044
							],
							[
								-80.37446399999993,
								27.414846000000068
							],
							[
								-80.37446499999993,
								27.41475900000006
							],
							[
								-80.37446699999992,
								27.413947000000068
							],
							[
								-80.3740499999999,
								27.413954000000047
							],
							[
								-80.37272899999994,
								27.413962000000083
							],
							[
								-80.37272999999993,
								27.414816000000087
							],
							[
								-80.37302299999993,
								27.41480800000005
							],
							[
								-80.37302599999992,
								27.41494300000005
							],
							[
								-80.37302599999992,
								27.41507800000005
							],
							[
								-80.37273299999993,
								27.415086000000088
							],
							[
								-80.37259399999994,
								27.415086000000088
							],
							[
								-80.37077099999993,
								27.415055000000052
							],
							[
								-80.36999299999991,
								27.415100000000052
							],
							[
								-80.36998499999993,
								27.41693500000008
							],
							[
								-80.36984999999993,
								27.41693500000008
							],
							[
								-80.36971499999993,
								27.41693500000008
							],
							[
								-80.36970899999994,
								27.41511500000007
							],
							[
								-80.36832099999992,
								27.415186000000062
							],
							[
								-80.36429399999992,
								27.415133000000083
							],
							[
								-80.3638259999999,
								27.415137000000072
							],
							[
								-80.36147099999994,
								27.41511500000007
							],
							[
								-80.36147299999993,
								27.414986000000056
							],
							[
								-80.36147499999993,
								27.414855000000045
							],
							[
								-80.36375099999992,
								27.41489000000007
							],
							[
								-80.36429099999992,
								27.41488200000009
							],
							[
								-80.36421699999994,
								27.41146200000009
							],
							[
								-80.36403399999995,
								27.41146100000009
							],
							[
								-80.36406099999994,
								27.407876000000044
							],
							[
								-80.36383199999995,
								27.407860000000085
							],
							[
								-80.3638049999999,
								27.407647000000054
							],
							[
								-80.3661889999999,
								27.407632000000035
							],
							[
								-80.36618599999991,
								27.40572300000008
							],
							[
								-80.36648999999994,
								27.404324000000088
							],
							[
								-80.36538899999994,
								27.403785000000084
							],
							[
								-80.36536499999994,
								27.404023000000052
							],
							[
								-80.36538899999994,
								27.40417000000008
							],
							[
								-80.36551999999995,
								27.40444000000008
							],
							[
								-80.36564499999992,
								27.404524000000038
							],
							[
								-80.36534699999993,
								27.404514000000063
							],
							[
								-80.36529899999994,
								27.404535000000067
							],
							[
								-80.36529899999994,
								27.404588000000047
							],
							[
								-80.36532899999992,
								27.404625000000067
							],
							[
								-80.36532899999992,
								27.40468300000009
							],
							[
								-80.36528199999992,
								27.404741000000058
							],
							[
								-80.36531699999995,
								27.404820000000086
							],
							[
								-80.36532299999993,
								27.40492600000005
							],
							[
								-80.3653589999999,
								27.405005000000074
							],
							[
								-80.36548999999991,
								27.405084000000045
							],
							[
								-80.36538899999994,
								27.405095000000074
							],
							[
								-80.36530499999992,
								27.40515300000004
							],
							[
								-80.36528799999991,
								27.40524300000004
							],
							[
								-80.36507299999995,
								27.405443000000048
							],
							[
								-80.3652459999999,
								27.405699000000084
							],
							[
								-80.36532299999993,
								27.405818000000068
							],
							[
								-80.36500799999993,
								27.405808000000036
							],
							[
								-80.36457299999995,
								27.405760000000043
							],
							[
								-80.3645909999999,
								27.40616200000005
							],
							[
								-80.36375199999992,
								27.406183000000055
							],
							[
								-80.36367499999994,
								27.405602000000044
							],
							[
								-80.36268699999994,
								27.40561800000006
							],
							[
								-80.36270999999994,
								27.404588000000047
							],
							[
								-80.36337099999992,
								27.404577000000074
							],
							[
								-80.36343599999992,
								27.404551000000083
							],
							[
								-80.3634899999999,
								27.404709000000082
							],
							[
								-80.36356099999995,
								27.404820000000086
							],
							[
								-80.36361499999992,
								27.404852000000062
							],
							[
								-80.36357299999992,
								27.40381700000006
							],
							[
								-80.36275799999993,
								27.40385400000008
							],
							[
								-80.36276399999991,
								27.403917000000035
							],
							[
								-80.36238299999991,
								27.403827000000035
							],
							[
								-80.3622279999999,
								27.403737000000035
							],
							[
								-80.36222199999992,
								27.403653000000077
							],
							[
								-80.36210299999993,
								27.403732000000048
							],
							[
								-80.36193099999991,
								27.40370600000006
							],
							[
								-80.36174599999994,
								27.403595000000053
							],
							[
								-80.36162699999994,
								27.403362000000072
							],
							[
								-80.36160899999993,
								27.403257000000053
							],
							[
								-80.36112099999991,
								27.403267000000085
							],
							[
								-80.36110499999995,
								27.403789000000074
							],
							[
								-80.36104399999994,
								27.404229000000043
							],
							[
								-80.36104799999993,
								27.40436600000004
							],
							[
								-80.36131799999993,
								27.40437600000007
							],
							[
								-80.36172799999991,
								27.404487000000074
							],
							[
								-80.36169799999993,
								27.40561800000006
							],
							[
								-80.36108799999994,
								27.40562800000004
							],
							[
								-80.36108999999993,
								27.40569000000005
							],
							[
								-80.36104399999994,
								27.40766300000007
							],
							[
								-80.36158099999994,
								27.407660000000078
							],
							[
								-80.36158099999994,
								27.407860000000085
							],
							[
								-80.36137599999995,
								27.407852000000048
							],
							[
								-80.3613489999999,
								27.40941500000008
							],
							[
								-80.36157899999995,
								27.409482000000082
							],
							[
								-80.36157899999995,
								27.409593000000086
							],
							[
								-80.36130299999991,
								27.409609000000046
							],
							[
								-80.36129399999993,
								27.410071000000073
							],
							[
								-80.3615769999999,
								27.410079000000053
							],
							[
								-80.36157799999995,
								27.40984700000007
							],
							[
								-80.3629469999999,
								27.40982800000006
							],
							[
								-80.36293799999993,
								27.409140000000036
							],
							[
								-80.3632849999999,
								27.409140000000036
							],
							[
								-80.3632659999999,
								27.411456000000044
							],
							[
								-80.36161099999993,
								27.411444000000074
							],
							[
								-80.36161299999992,
								27.411823000000084
							],
							[
								-80.3609219999999,
								27.41166300000009
							],
							[
								-80.36061699999993,
								27.41166700000008
							],
							[
								-80.36020499999995,
								27.411526000000038
							],
							[
								-80.3599299999999,
								27.41140000000007
							],
							[
								-80.35887699999995,
								27.411125000000084
							],
							[
								-80.35857599999991,
								27.41104500000006
							],
							[
								-80.3581299999999,
								27.41191900000007
							],
							[
								-80.3576799999999,
								27.41241800000006
							],
							[
								-80.35767699999991,
								27.411940000000072
							],
							[
								-80.3580389999999,
								27.41157700000008
							],
							[
								-80.35832799999991,
								27.410921000000087
							],
							[
								-80.35825099999994,
								27.410851000000036
							],
							[
								-80.35815999999994,
								27.410642000000053
							],
							[
								-80.3581749999999,
								27.410356000000036
							],
							[
								-80.35828199999992,
								27.409951000000035
							],
							[
								-80.35829699999994,
								27.409375000000068
							],
							[
								-80.35828199999992,
								27.409147000000075
							],
							[
								-80.35798999999992,
								27.408716000000084
							],
							[
								-80.35597199999995,
								27.409958000000074
							],
							[
								-80.35596199999992,
								27.411297000000047
							],
							[
								-80.35357199999993,
								27.41121700000008
							],
							[
								-80.3536059999999,
								27.412677000000087
							],
							[
								-80.3564179999999,
								27.41268800000006
							],
							[
								-80.35771199999994,
								27.412888000000066
							],
							[
								-80.36025099999995,
								27.41287900000009
							],
							[
								-80.36019199999993,
								27.412993000000085
							],
							[
								-80.36013899999995,
								27.413330000000087
							],
							[
								-80.36007499999994,
								27.41350600000004
							],
							[
								-80.36007499999994,
								27.413606000000073
							],
							[
								-80.36014399999993,
								27.41372400000006
							],
							[
								-80.36014399999993,
								27.413800000000037
							],
							[
								-80.36020899999994,
								27.413796000000048
							],
							[
								-80.36019999999992,
								27.41390700000005
							],
							[
								-80.35887899999994,
								27.413950000000057
							],
							[
								-80.35896799999995,
								27.41480800000005
							],
							[
								-80.36023599999993,
								27.414836000000037
							],
							[
								-80.36100199999993,
								27.414848000000063
							],
							[
								-80.36101799999994,
								27.41498000000007
							],
							[
								-80.3610339999999,
								27.41511100000008
							],
							[
								-80.36036499999994,
								27.41510500000004
							],
							[
								-80.36037899999991,
								27.41555500000004
							],
							[
								-80.36024999999995,
								27.415560000000085
							],
							[
								-80.35769299999993,
								27.41566800000004
							],
							[
								-80.3564859999999,
								27.41558900000007
							],
							[
								-80.3565089999999,
								27.414203000000043
							],
							[
								-80.35635699999995,
								27.41421500000007
							],
							[
								-80.35638499999993,
								27.412771000000077
							],
							[
								-80.3552249999999,
								27.412857000000088
							],
							[
								-80.35544199999993,
								27.415253000000064
							],
							[
								-80.35543299999995,
								27.416487000000075
							],
							[
								-80.35631499999994,
								27.416533000000072
							],
							[
								-80.3577019999999,
								27.416446000000064
							],
							[
								-80.35770599999995,
								27.416993000000048
							],
							[
								-80.3579059999999,
								27.41699200000005
							],
							[
								-80.35842899999994,
								27.417001000000084
							],
							[
								-80.35842899999994,
								27.417842000000064
							],
							[
								-80.36030699999992,
								27.417842000000064
							],
							[
								-80.36044199999992,
								27.417839000000072
							],
							[
								-80.3604499999999,
								27.418124000000034
							],
							[
								-80.36045999999993,
								27.418612000000056
							],
							[
								-80.36045499999994,
								27.418629000000067
							],
							[
								-80.36043399999994,
								27.418694000000073
							],
							[
								-80.36041599999993,
								27.41882000000004
							],
							[
								-80.36040699999995,
								27.418870000000084
							],
							[
								-80.36027699999994,
								27.418897000000072
							],
							[
								-80.3590979999999,
								27.41889000000009
							],
							[
								-80.35710999999992,
								27.418878000000063
							],
							[
								-80.35612199999993,
								27.41887200000008
							],
							[
								-80.35606399999995,
								27.418909000000042
							],
							[
								-80.35534699999994,
								27.41891300000009
							],
							[
								-80.35534699999994,
								27.41900600000008
							],
							[
								-80.35527699999996,
								27.419008000000076
							],
							[
								-80.35519399999993,
								27.419008000000076
							],
							[
								-80.35518999999994,
								27.419335000000046
							],
							[
								-80.35507199999995,
								27.419335000000046
							],
							[
								-80.35483399999993,
								27.419335000000046
							],
							[
								-80.35483399999993,
								27.41905500000007
							],
							[
								-80.35407199999992,
								27.419043000000045
							],
							[
								-80.35294699999992,
								27.419012000000066
							],
							[
								-80.35294399999992,
								27.419347000000073
							],
							[
								-80.35281099999992,
								27.419347000000073
							],
							[
								-80.35237299999994,
								27.419343000000083
							],
							[
								-80.3523429999999,
								27.419558000000052
							],
							[
								-80.35280799999992,
								27.419561000000044
							],
							[
								-80.35294199999993,
								27.41956500000009
							],
							[
								-80.35293699999994,
								27.42002400000007
							],
							[
								-80.35407199999992,
								27.42002400000007
							],
							[
								-80.35412699999995,
								27.42002400000007
							],
							[
								-80.35412699999995,
								27.419894000000056
							],
							[
								-80.35483399999993,
								27.41989600000005
							],
							[
								-80.35483399999993,
								27.419683000000077
							],
							[
								-80.35518499999995,
								27.419683000000077
							],
							[
								-80.3551799999999,
								27.420026000000064
							],
							[
								-80.35469799999993,
								27.420026000000064
							],
							[
								-80.35469799999993,
								27.420317000000068
							],
							[
								-80.35469499999994,
								27.42039300000005
							],
							[
								-80.35420699999992,
								27.420401000000084
							],
							[
								-80.35407199999992,
								27.42039800000009
							],
							[
								-80.35361899999992,
								27.420389000000057
							],
							[
								-80.35361899999992,
								27.420488000000038
							],
							[
								-80.35407299999991,
								27.420488000000038
							],
							[
								-80.3540789999999,
								27.421849000000066
							],
							[
								-80.35410999999993,
								27.421970000000044
							],
							[
								-80.35393399999992,
								27.421970000000044
							],
							[
								-80.35393599999992,
								27.421848000000068
							],
							[
								-80.35305299999993,
								27.42186200000009
							],
							[
								-80.3530639999999,
								27.420994000000064
							],
							[
								-80.35307099999994,
								27.420366000000058
							],
							[
								-80.35279799999995,
								27.420356000000083
							],
							[
								-80.35266499999994,
								27.42035100000004
							],
							[
								-80.35266599999994,
								27.42032000000006
							],
							[
								-80.35195699999991,
								27.420296000000064
							],
							[
								-80.3509709999999,
								27.42027900000005
							],
							[
								-80.35007199999991,
								27.420266000000083
							],
							[
								-80.34914999999995,
								27.420250000000067
							],
							[
								-80.34915399999994,
								27.420386000000065
							],
							[
								-80.34915799999993,
								27.420512000000087
							],
							[
								-80.34916199999992,
								27.420623000000035
							],
							[
								-80.34957199999991,
								27.42062400000009
							],
							[
								-80.3499369999999,
								27.420620000000042
							],
							[
								-80.3499369999999,
								27.420952000000057
							],
							[
								-80.35007199999991,
								27.420952000000057
							],
							[
								-80.35020199999991,
								27.42095400000005
							],
							[
								-80.35024099999993,
								27.42182200000008
							],
							[
								-80.35031299999991,
								27.42401600000005
							],
							[
								-80.35016899999994,
								27.42402100000004
							],
							[
								-80.34796999999992,
								27.424092000000087
							],
							[
								-80.34789799999993,
								27.42421200000007
							],
							[
								-80.3478849999999,
								27.42530000000005
							],
							[
								-80.34405399999991,
								27.425145000000043
							],
							[
								-80.3440589999999,
								27.424988000000045
							],
							[
								-80.3436089999999,
								27.424965000000043
							],
							[
								-80.34360699999992,
								27.425117000000057
							],
							[
								-80.3434719999999,
								27.425117000000057
							],
							[
								-80.34137199999992,
								27.425147000000038
							],
							[
								-80.34137199999992,
								27.424817000000075
							],
							[
								-80.34140899999994,
								27.42462400000005
							],
							[
								-80.3417389999999,
								27.42463500000008
							],
							[
								-80.34173699999991,
								27.424517000000037
							],
							[
								-80.3417389999999,
								27.42438800000008
							],
							[
								-80.34137199999992,
								27.424417000000062
							],
							[
								-80.34137199999992,
								27.423884000000044
							],
							[
								-80.34137199999992,
								27.42321700000008
							],
							[
								-80.34137199999992,
								27.42271700000009
							],
							[
								-80.34357099999994,
								27.422837000000072
							],
							[
								-80.34357199999994,
								27.423317000000054
							],
							[
								-80.34357199999994,
								27.423814000000053
							],
							[
								-80.34784399999995,
								27.423868000000084
							],
							[
								-80.34789799999993,
								27.421876000000054
							],
							[
								-80.34747199999993,
								27.421917000000068
							],
							[
								-80.34737199999995,
								27.421917000000068
							],
							[
								-80.34677199999993,
								27.421917000000068
							],
							[
								-80.3468719999999,
								27.41951700000004
							],
							[
								-80.34663599999993,
								27.41951700000004
							],
							[
								-80.34663199999994,
								27.419674000000043
							],
							[
								-80.3466249999999,
								27.41993400000007
							],
							[
								-80.34647199999995,
								27.419917000000055
							],
							[
								-80.34639199999992,
								27.419917000000055
							],
							[
								-80.34639799999991,
								27.419669000000056
							],
							[
								-80.34634399999993,
								27.419667000000064
							],
							[
								-80.34619199999992,
								27.419667000000064
							],
							[
								-80.34587099999993,
								27.41966300000007
							],
							[
								-80.34553199999993,
								27.419667000000064
							],
							[
								-80.34553699999992,
								27.419917000000055
							],
							[
								-80.34553699999992,
								27.420052000000055
							],
							[
								-80.34537199999994,
								27.420052000000055
							],
							[
								-80.3451399999999,
								27.420057000000043
							],
							[
								-80.34496899999994,
								27.420052000000055
							],
							[
								-80.34467099999995,
								27.420047000000068
							],
							[
								-80.34453699999995,
								27.420047000000068
							],
							[
								-80.34453599999995,
								27.419909000000075
							],
							[
								-80.3445549999999,
								27.419462000000067
							],
							[
								-80.34449099999995,
								27.419462000000067
							],
							[
								-80.34443599999992,
								27.419459000000074
							],
							[
								-80.34423099999992,
								27.419448000000045
							],
							[
								-80.3442389999999,
								27.41861700000004
							],
							[
								-80.34378599999991,
								27.41859500000004
							]
						],
						[
							[
								-80.35597199999995,
								27.409835000000044
							],
							[
								-80.3564429999999,
								27.40955000000008
							],
							[
								-80.35597199999995,
								27.409556000000066
							],
							[
								-80.35597199999995,
								27.409835000000044
							]
						],
						[
							[
								-80.36623199999991,
								27.407632000000035
							],
							[
								-80.3662569999999,
								27.408159000000072
							],
							[
								-80.36660999999992,
								27.408147000000042
							],
							[
								-80.3665969999999,
								27.407624000000055
							],
							[
								-80.36623199999991,
								27.407632000000035
							]
						],
						[
							[
								-80.37453599999992,
								27.413714000000084
							],
							[
								-80.37453499999992,
								27.413947000000068
							],
							[
								-80.37476299999992,
								27.413947000000068
							],
							[
								-80.37477599999994,
								27.413730000000044
							],
							[
								-80.37453599999992,
								27.413714000000084
							]
						],
						[
							[
								-80.38139899999993,
								27.40280800000005
							],
							[
								-80.38136299999991,
								27.40438400000005
							],
							[
								-80.38261799999992,
								27.404373000000078
							],
							[
								-80.38261399999993,
								27.40364500000004
							],
							[
								-80.3826059999999,
								27.40307200000007
							],
							[
								-80.38259799999992,
								27.402788000000044
							],
							[
								-80.38139899999993,
								27.40280800000005
							]
						]
					],
					[
						[
							[
								-80.3590079999999,
								27.429522000000077
							],
							[
								-80.3590079999999,
								27.429355000000044
							],
							[
								-80.35847299999995,
								27.429355000000044
							],
							[
								-80.35847299999995,
								27.42921700000005
							],
							[
								-80.35847299999995,
								27.427517000000083
							],
							[
								-80.35847299999995,
								27.426400000000058
							],
							[
								-80.35884199999992,
								27.426394000000073
							],
							[
								-80.35884199999992,
								27.426127000000065
							],
							[
								-80.3595729999999,
								27.42612900000006
							],
							[
								-80.36011899999994,
								27.426136000000046
							],
							[
								-80.36011899999994,
								27.425717000000077
							],
							[
								-80.3604729999999,
								27.425717000000077
							],
							[
								-80.3609459999999,
								27.425717000000077
							],
							[
								-80.3609459999999,
								27.425420000000088
							],
							[
								-80.3609459999999,
								27.42534900000004
							],
							[
								-80.36140999999992,
								27.42534900000004
							],
							[
								-80.36138799999992,
								27.425061000000085
							],
							[
								-80.36139099999991,
								27.424979000000064
							],
							[
								-80.36107399999992,
								27.424980000000062
							],
							[
								-80.36100199999993,
								27.424980000000062
							],
							[
								-80.36100199999993,
								27.42459000000008
							],
							[
								-80.36128999999994,
								27.424592000000075
							],
							[
								-80.36134399999992,
								27.424591000000078
							],
							[
								-80.36133199999995,
								27.42449000000005
							],
							[
								-80.36132499999991,
								27.424372000000062
							],
							[
								-80.36133599999994,
								27.424038000000053
							],
							[
								-80.3611929999999,
								27.424023000000094
							],
							[
								-80.3611929999999,
								27.423889000000088
							],
							[
								-80.3611929999999,
								27.423260000000084
							],
							[
								-80.36059499999993,
								27.423234000000036
							],
							[
								-80.36055299999992,
								27.422278000000063
							],
							[
								-80.36237399999993,
								27.422274000000073
							],
							[
								-80.36436199999991,
								27.422235000000057
							],
							[
								-80.3643449999999,
								27.42016600000005
							],
							[
								-80.36419099999995,
								27.42016600000005
							],
							[
								-80.3642079999999,
								27.41896300000008
							],
							[
								-80.36439599999994,
								27.418735000000083
							],
							[
								-80.36439599999994,
								27.41872500000005
							],
							[
								-80.36769899999992,
								27.418651000000068
							],
							[
								-80.3686429999999,
								27.418621000000087
							],
							[
								-80.37159999999994,
								27.418581000000074
							],
							[
								-80.37176199999993,
								27.418584000000067
							],
							[
								-80.3723809999999,
								27.418571000000043
							],
							[
								-80.37237999999991,
								27.42022600000007
							],
							[
								-80.37091599999991,
								27.42022600000007
							],
							[
								-80.37052799999992,
								27.420225000000073
							],
							[
								-80.37047999999993,
								27.421736000000067
							],
							[
								-80.37047299999995,
								27.42193900000007
							],
							[
								-80.37054899999993,
								27.42189600000006
							],
							[
								-80.37075699999991,
								27.422548000000067
							],
							[
								-80.37123799999995,
								27.42290600000007
							],
							[
								-80.37139799999994,
								27.42311600000005
							],
							[
								-80.37150199999991,
								27.42325200000005
							],
							[
								-80.37141099999991,
								27.423316000000057
							],
							[
								-80.3679249999999,
								27.42544500000008
							],
							[
								-80.36749399999991,
								27.425717000000077
							],
							[
								-80.3674069999999,
								27.42577200000005
							],
							[
								-80.36724299999992,
								27.42577200000005
							],
							[
								-80.36658199999994,
								27.425771000000054
							],
							[
								-80.36649999999992,
								27.42577200000005
							],
							[
								-80.36577799999992,
								27.425778000000037
							],
							[
								-80.36577799999992,
								27.426766000000043
							],
							[
								-80.3656729999999,
								27.426865000000078
							],
							[
								-80.36561599999993,
								27.426919000000055
							],
							[
								-80.36507499999993,
								27.426997000000085
							],
							[
								-80.36485199999993,
								27.427019000000087
							],
							[
								-80.36483699999992,
								27.426749000000086
							],
							[
								-80.36474599999991,
								27.42675200000008
							],
							[
								-80.36476399999992,
								27.42703400000005
							],
							[
								-80.36467299999993,
								27.427117000000067
							],
							[
								-80.36449799999991,
								27.427051000000063
							],
							[
								-80.36416199999991,
								27.42720900000006
							],
							[
								-80.36406599999992,
								27.42725400000006
							],
							[
								-80.36359399999992,
								27.427512000000036
							],
							[
								-80.36330599999991,
								27.427669000000037
							],
							[
								-80.3624769999999,
								27.428123000000085
							],
							[
								-80.36249299999993,
								27.427711000000045
							],
							[
								-80.36253399999993,
								27.426685000000077
							],
							[
								-80.3625899999999,
								27.426685000000077
							],
							[
								-80.3633109999999,
								27.42668000000009
							],
							[
								-80.36359399999992,
								27.426679000000036
							],
							[
								-80.36359399999992,
								27.425778000000037
							],
							[
								-80.3633109999999,
								27.425782000000087
							],
							[
								-80.36256999999995,
								27.42578100000009
							],
							[
								-80.36061199999995,
								27.425789000000066
							],
							[
								-80.36047699999996,
								27.425790000000063
							],
							[
								-80.36047999999994,
								27.42685400000005
							],
							[
								-80.36001199999994,
								27.426836000000037
							],
							[
								-80.36001199999994,
								27.427058000000045
							],
							[
								-80.36047999999994,
								27.427058000000045
							],
							[
								-80.36048099999994,
								27.427520000000072
							],
							[
								-80.36048799999992,
								27.427655000000073
							],
							[
								-80.36007599999994,
								27.427659000000066
							],
							[
								-80.36007599999994,
								27.428224000000057
							],
							[
								-80.3605149999999,
								27.428224000000057
							],
							[
								-80.3613959999999,
								27.428224000000057
							],
							[
								-80.36140599999993,
								27.42833200000007
							],
							[
								-80.3614189999999,
								27.428792000000044
							],
							[
								-80.36052099999995,
								27.429456000000073
							],
							[
								-80.3595729999999,
								27.430150000000083
							],
							[
								-80.35847299999995,
								27.43096600000007
							],
							[
								-80.35847299999995,
								27.429522000000077
							],
							[
								-80.3590079999999,
								27.429522000000077
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Saint Lucie",
				"City": "Fort Pierce",
				"Name": "Fort Pierce South",
				"RegionID": "396875"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.13734925699993,
					26.260420709000073,
					-80.1248865259999,
					26.274957679000067
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.12530894499992,
							26.271553312000037
						],
						[
							-80.12634543499992,
							26.26867975800008
						],
						[
							-80.12730981499993,
							26.267295007000087
						],
						[
							-80.13299718299993,
							26.260569075000035
						],
						[
							-80.13734925699993,
							26.260420709000073
						],
						[
							-80.1342953919999,
							26.27485800000005
						],
						[
							-80.13429295599991,
							26.27487668300006
						],
						[
							-80.13396789099994,
							26.274957679000067
						],
						[
							-80.13389406099992,
							26.274957679000067
						],
						[
							-80.1335398299999,
							26.274957679000067
						],
						[
							-80.13346789099995,
							26.274957679000067
						],
						[
							-80.13339406099993,
							26.274957679000067
						],
						[
							-80.13143982999992,
							26.274957679000067
						],
						[
							-80.13136789099991,
							26.274957679000067
						],
						[
							-80.13129406099995,
							26.274957679000067
						],
						[
							-80.13063982999995,
							26.274957679000067
						],
						[
							-80.13056789099994,
							26.274957679000067
						],
						[
							-80.13049406099992,
							26.274957679000067
						],
						[
							-80.12943982999991,
							26.274957679000067
						],
						[
							-80.1293678909999,
							26.274957679000067
						],
						[
							-80.12929406099994,
							26.274957679000067
						],
						[
							-80.1283398299999,
							26.274957679000067
						],
						[
							-80.12826789099995,
							26.274957679000067
						],
						[
							-80.12819406099993,
							26.274957679000067
						],
						[
							-80.12633982999995,
							26.274957679000067
						],
						[
							-80.12626789099994,
							26.274957679000067
						],
						[
							-80.12619406099992,
							26.274957679000067
						],
						[
							-80.12593982999994,
							26.274957679000067
						],
						[
							-80.12586789099993,
							26.274957679000067
						],
						[
							-80.12579406099991,
							26.274957679000067
						],
						[
							-80.12523982999994,
							26.274957679000067
						],
						[
							-80.12516789099993,
							26.274957679000067
						],
						[
							-80.12509406099991,
							26.274957679000067
						],
						[
							-80.1249603309999,
							26.274957679000067
						],
						[
							-80.1248865259999,
							26.274957679000067
						],
						[
							-80.1250843219999,
							26.273056559000054
						],
						[
							-80.12530894499992,
							26.271553312000037
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Pompano Beach",
				"Name": "Loch Lomond",
				"RegionID": "399379"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.33952599999992,
					28.507625000000075,
					-81.32809594399993,
					28.524255181000058
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.33094530099993,
							28.52425512700006
						],
						[
							-81.33062182299994,
							28.52425417900008
						],
						[
							-81.33023124499994,
							28.52425417900008
						],
						[
							-81.32935594599991,
							28.524253178000038
						],
						[
							-81.32881514399992,
							28.52425217600006
						],
						[
							-81.32809608999992,
							28.524254178000035
						],
						[
							-81.32809594399993,
							28.52051550100009
						],
						[
							-81.32896349799995,
							28.520515768000053
						],
						[
							-81.32896339199993,
							28.518634793000047
						],
						[
							-81.33105459299992,
							28.51866401500007
						],
						[
							-81.3310514609999,
							28.51843755400006
						],
						[
							-81.33105045999991,
							28.518206211000066
						],
						[
							-81.33104645399993,
							28.517757545000055
						],
						[
							-81.33104244799995,
							28.517062514000088
						],
						[
							-81.33104144599992,
							28.516845192000062
						],
						[
							-81.3310324329999,
							28.515381020000063
						],
						[
							-81.3310324329999,
							28.514763104000053
						],
						[
							-81.33101039899992,
							28.51434247900005
						],
						[
							-81.3309983819999,
							28.513807687000053
						],
						[
							-81.33096733699995,
							28.513337988000046
						],
						[
							-81.33097134099995,
							28.51330394000007
						],
						[
							-81.33097434599995,
							28.513249860000087
						],
						[
							-81.33098936899995,
							28.511911875000067
						],
						[
							-81.33101440599995,
							28.511422149000058
						],
						[
							-81.33102041399991,
							28.511277936000056
						],
						[
							-81.33101048899994,
							28.510476730000054
						],
						[
							-81.33100338999992,
							28.50999102600008
						],
						[
							-81.3310023869999,
							28.509919921000062
						],
						[
							-81.33100138599991,
							28.509818771000084
						],
						[
							-81.33099337399995,
							28.509554378000075
						],
						[
							-81.33099027899993,
							28.508369626000047
						],
						[
							-81.33097534699994,
							28.508212388000064
						],
						[
							-81.3309716579999,
							28.507935100000054
						],
						[
							-81.33096818799993,
							28.507674292000047
						],
						[
							-81.33249399999994,
							28.50764200000009
						],
						[
							-81.33280599999995,
							28.507625000000075
						],
						[
							-81.33280599999995,
							28.50938000000008
						],
						[
							-81.33280599999995,
							28.511380000000088
						],
						[
							-81.33278599999994,
							28.511390000000063
						],
						[
							-81.3347139999999,
							28.511262000000045
						],
						[
							-81.33472299999994,
							28.51177000000007
						],
						[
							-81.33472299999994,
							28.512565000000052
						],
						[
							-81.33472399999994,
							28.512680000000046
						],
						[
							-81.3335909999999,
							28.512680000000046
						],
						[
							-81.33305299999995,
							28.512672000000066
						],
						[
							-81.33287799999994,
							28.512664000000086
						],
						[
							-81.3328249999999,
							28.512665000000084
						],
						[
							-81.33282699999995,
							28.512781000000075
						],
						[
							-81.33283199999994,
							28.51308000000006
						],
						[
							-81.3328909999999,
							28.51308000000006
						],
						[
							-81.3335899999999,
							28.513095000000078
						],
						[
							-81.33473599999992,
							28.513093000000083
						],
						[
							-81.33473499999991,
							28.512958000000083
						],
						[
							-81.33506768299992,
							28.512953905000074
						],
						[
							-81.33507029099991,
							28.51332683700008
						],
						[
							-81.33506791699995,
							28.51336102500005
						],
						[
							-81.33511443399993,
							28.518347479000056
						],
						[
							-81.33483299999995,
							28.518350000000055
						],
						[
							-81.33483599999994,
							28.51840100000004
						],
						[
							-81.33483799999993,
							28.518515000000036
						],
						[
							-81.33483999999993,
							28.518638000000067
						],
						[
							-81.33484199999992,
							28.518760000000043
						],
						[
							-81.33484699999991,
							28.519088000000067
						],
						[
							-81.33484799999991,
							28.519193000000087
						],
						[
							-81.33498299999991,
							28.51919200000009
						],
						[
							-81.3349879999999,
							28.519585000000063
						],
						[
							-81.33499299999994,
							28.52001200000007
						],
						[
							-81.33497099999994,
							28.520451000000037
						],
						[
							-81.33500399999991,
							28.520987000000048
						],
						[
							-81.33499699999993,
							28.52101700000009
						],
						[
							-81.3350099999999,
							28.521314000000075
						],
						[
							-81.33501399999994,
							28.52148200000005
						],
						[
							-81.33499399999994,
							28.521783000000084
						],
						[
							-81.33649099999991,
							28.521782000000087
						],
						[
							-81.33779099999992,
							28.52178100000009
						],
						[
							-81.33939099999992,
							28.521780000000035
						],
						[
							-81.33952599999992,
							28.521779000000038
						],
						[
							-81.33952599999992,
							28.521911853000063
						],
						[
							-81.3392645109999,
							28.521914579000057
						],
						[
							-81.33926564299992,
							28.522481551000055
						],
						[
							-81.33927665999995,
							28.523666308000088
						],
						[
							-81.33928166599992,
							28.524173112000085
						],
						[
							-81.33858763699993,
							28.52417906900007
						],
						[
							-81.33844442499992,
							28.524182072000087
						],
						[
							-81.33833526299992,
							28.524183074000064
						],
						[
							-81.33787658299991,
							28.524187081000036
						],
						[
							-81.33770132199993,
							28.524190084000058
						],
						[
							-81.33672287099996,
							28.524196093000057
						],
						[
							-81.33580851499994,
							28.524201100000088
						],
						[
							-81.33519560699995,
							28.52420911200005
						],
						[
							-81.3348611099999,
							28.524214121000057
						],
						[
							-81.33393273399992,
							28.52422513600004
						],
						[
							-81.33299634499991,
							28.524238155000035
						],
						[
							-81.33249760599995,
							28.524244164000038
						],
						[
							-81.33185164699995,
							28.52425017300004
						],
						[
							-81.33109252199995,
							28.524255181000058
						],
						[
							-81.33101841199993,
							28.524255181000058
						],
						[
							-81.33094530099993,
							28.52425512700006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Orange",
				"City": "Orlando",
				"Name": "Conway",
				"RegionID": "403123"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.11356790399998,
					26.275158358000056,
					-80.09437933299995,
					26.297625840000023
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.09437933299995,
							26.29752478200004
						],
						[
							-80.09466562999995,
							26.29485689300003
						],
						[
							-80.09482162999996,
							26.293856893000054
						],
						[
							-80.0951656299999,
							26.291656893000038
						],
						[
							-80.09549862999995,
							26.290156893000074
						],
						[
							-80.09556562999995,
							26.289856893000035
						],
						[
							-80.09566562999998,
							26.28905689300007
						],
						[
							-80.09616562999997,
							26.285256893000053
						],
						[
							-80.09666562999996,
							26.28185789300005
						],
						[
							-80.09666562999996,
							26.281757893000076
						],
						[
							-80.09706562999997,
							26.27925789300008
						],
						[
							-80.09710463,
							26.27872889300005
						],
						[
							-80.09766570899995,
							26.275457880000033
						],
						[
							-80.09767098799995,
							26.275457887000073
						],
						[
							-80.11349407399996,
							26.27515867900007
						],
						[
							-80.11356790399998,
							26.275158358000056
						],
						[
							-80.11336789099994,
							26.27585767900007
						],
						[
							-80.11251489099999,
							26.278942679000068
						],
						[
							-80.10947498199995,
							26.28993104700004
						],
						[
							-80.10946973899996,
							26.289949998000054
						],
						[
							-80.10946789099995,
							26.28995667900006
						],
						[
							-80.10947314499998,
							26.289954928000043
						],
						[
							-80.10950615399997,
							26.289943925000046
						],
						[
							-80.10954713799998,
							26.28993026300003
						],
						[
							-80.10958066399998,
							26.289919088000033
						],
						[
							-80.10958789099999,
							26.289916679000044
						],
						[
							-80.10958562299999,
							26.28992423300008
						],
						[
							-80.10957989099995,
							26.289943325000024
						],
						[
							-80.10844806699998,
							26.293713100000048
						],
						[
							-80.10844489099998,
							26.29372367900004
						],
						[
							-80.10837432899996,
							26.293712823000078
						],
						[
							-80.10836689099995,
							26.29371167900007
						],
						[
							-80.10829885299995,
							26.29370166700005
						],
						[
							-80.10824755799996,
							26.293694118000076
						],
						[
							-80.10822366799994,
							26.293690475000062
						],
						[
							-80.10806789099996,
							26.293667679000066
						],
						[
							-80.10799406099994,
							26.293668054000022
						],
						[
							-80.10681128099998,
							26.293674063000026
						],
						[
							-80.10660482199995,
							26.29367570000005
						],
						[
							-80.10653194499997,
							26.29367534300008
						],
						[
							-80.10653203099997,
							26.29414924400004
						],
						[
							-80.10653683199996,
							26.294152216000043
						],
						[
							-80.10663395699999,
							26.294200812000042
						],
						[
							-80.10663895699997,
							26.29420378100008
						],
						[
							-80.10664398899996,
							26.294206591000034
						],
						[
							-80.10672734799994,
							26.294245510000053
						],
						[
							-80.10673128299999,
							26.29424993400005
						],
						[
							-80.10674360799999,
							26.294268746000057
						],
						[
							-80.10674705199995,
							26.294273763000035
						],
						[
							-80.10675048799999,
							26.294278784000028
						],
						[
							-80.10681694499993,
							26.294382840000026
						],
						[
							-80.10679894499998,
							26.294441840000047
						],
						[
							-80.10669194499997,
							26.294472840000026
						],
						[
							-80.10662094499997,
							26.295846840000024
						],
						[
							-80.10617494499996,
							26.296531840000057
						],
						[
							-80.10613894499994,
							26.296635840000082
						],
						[
							-80.10610294499998,
							26.296750840000072
						],
						[
							-80.10606794499995,
							26.296934840000063
						],
						[
							-80.10606794499995,
							26.29713884000006
						],
						[
							-80.10613594499995,
							26.297399840000026
						],
						[
							-80.10604072399997,
							26.297439952000047
						],
						[
							-80.10596864599995,
							26.29743919300006
						],
						[
							-80.10589571599996,
							26.297437950000074
						],
						[
							-80.10582286199997,
							26.29743738700006
						],
						[
							-80.10570192399996,
							26.29743404900006
						],
						[
							-80.10561078099995,
							26.297431624000073
						],
						[
							-80.10553886799994,
							26.297430211000062
						],
						[
							-80.10545653899999,
							26.297428860000025
						],
						[
							-80.10523783399998,
							26.297423086000038
						],
						[
							-80.10516492599999,
							26.29742390100006
						],
						[
							-80.10509206499995,
							26.297423232000032
						],
						[
							-80.10502768099997,
							26.297422905000076
						],
						[
							-80.10443982799995,
							26.29742111400003
						],
						[
							-80.10436694499998,
							26.29742093300007
						],
						[
							-80.10429406099996,
							26.297420944000066
						],
						[
							-80.10373882999994,
							26.297421736000047
						],
						[
							-80.10366594499999,
							26.297421890000066
						],
						[
							-80.10359306099997,
							26.29742214600003
						],
						[
							-80.10353966999998,
							26.29742237000005
						],
						[
							-80.10346678599996,
							26.29742260000006
						],
						[
							-80.10346233599995,
							26.297422538000035
						],
						[
							-80.10339390199994,
							26.29742282500007
						],
						[
							-80.10135682899995,
							26.297431377000066
						],
						[
							-80.10128489099998,
							26.29743167900006
						],
						[
							-80.10056689099997,
							26.297498679000057
						],
						[
							-80.10000114499996,
							26.29752071100006
						],
						[
							-80.09984773599996,
							26.297527386000073
						],
						[
							-80.09977559199996,
							26.297526532000063
						],
						[
							-80.09968061,
							26.297526418000075
						],
						[
							-80.09914082999995,
							26.29752577100004
						],
						[
							-80.09906889099994,
							26.29752567900005
						],
						[
							-80.09899506199997,
							26.297525472000075
						],
						[
							-80.09842581399994,
							26.29752387800005
						],
						[
							-80.09835342799994,
							26.29752386900003
						],
						[
							-80.09811895299998,
							26.297554219000062
						],
						[
							-80.09807839099994,
							26.297559508000063
						],
						[
							-80.09758104799994,
							26.297623885000064
						],
						[
							-80.09756594499999,
							26.297625840000023
						],
						[
							-80.09750721799999,
							26.297623995000038
						],
						[
							-80.09641030899996,
							26.29758953000004
						],
						[
							-80.09633408799994,
							26.29758627900003
						],
						[
							-80.09445270899994,
							26.297524914000064
						],
						[
							-80.09437933299995,
							26.29752478200004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Pompano Beach",
				"Name": "Highlands",
				"RegionID": "405029"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.69970999999993,
					27.74357400000008,
					-82.67936166299995,
					27.751970000000085
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.67944999999992,
							27.751970000000085
						],
						[
							-82.6794430949999,
							27.751773212000046
						],
						[
							-82.67943574899995,
							27.751563848000046
						],
						[
							-82.67942999999993,
							27.751400000000046
						],
						[
							-82.67942273799991,
							27.751291070000036
						],
						[
							-82.67941856399995,
							27.75122846100004
						],
						[
							-82.6794099999999,
							27.751100000000065
						],
						[
							-82.6794099999999,
							27.750850847000038
						],
						[
							-82.6794099999999,
							27.75075000000004
						],
						[
							-82.67940405299993,
							27.750577547000034
						],
						[
							-82.67939683399993,
							27.750368174000073
						],
						[
							-82.6793899999999,
							27.750170000000082
						],
						[
							-82.67939096799995,
							27.749991597000076
						],
						[
							-82.6793947399999,
							27.749803013000076
						],
						[
							-82.67939726299994,
							27.749676871000077
						],
						[
							-82.67939999999993,
							27.74954000000008
						],
						[
							-82.67939999999993,
							27.74936253500005
						],
						[
							-82.67939556599993,
							27.749048244000054
						],
						[
							-82.67939003999993,
							27.748796820000052
						],
						[
							-82.67938542499991,
							27.74858683900004
						],
						[
							-82.67937999999992,
							27.748340000000045
						],
						[
							-82.67937999999992,
							27.74802095700005
						],
						[
							-82.67937705399993,
							27.747455051000088
						],
						[
							-82.67937256399995,
							27.747203585000083
						],
						[
							-82.6793676929999,
							27.74693079000008
						],
						[
							-82.67936245399994,
							27.746637413000087
						],
						[
							-82.67936166299995,
							27.746197258000052
						],
						[
							-82.67936465799994,
							27.745652259000053
						],
						[
							-82.6793667309999,
							27.745274952000045
						],
						[
							-82.67936788299994,
							27.74506522100006
						],
						[
							-82.67936999999995,
							27.744680000000074
						],
						[
							-82.6799239099999,
							27.744670730000053
						],
						[
							-82.6803521789999,
							27.744663562000085
						],
						[
							-82.68115607899995,
							27.74465010700004
						],
						[
							-82.68175999999994,
							27.74464000000006
						],
						[
							-82.6821195579999,
							27.74464000000006
						],
						[
							-82.68255999999991,
							27.74464000000006
						],
						[
							-82.68292278699994,
							27.74464000000006
						],
						[
							-82.68336999999991,
							27.74466000000007
						],
						[
							-82.68399375799993,
							27.744710000000055
						],
						[
							-82.68441999999993,
							27.744710000000055
						],
						[
							-82.68490408399992,
							27.744710000000055
						],
						[
							-82.68540999999993,
							27.74470000000008
						],
						[
							-82.68634810399993,
							27.744673942000077
						],
						[
							-82.6863459999999,
							27.74469600000009
						],
						[
							-82.68632799999995,
							27.744838000000072
						],
						[
							-82.68662399999994,
							27.744759000000045
						],
						[
							-82.68744099999992,
							27.74453200000005
						],
						[
							-82.6875188269999,
							27.744513296000036
						],
						[
							-82.68780299999992,
							27.74444500000004
						],
						[
							-82.6884619999999,
							27.74432100000007
						],
						[
							-82.68926099999993,
							27.744095000000073
						],
						[
							-82.69142899999993,
							27.74357400000008
						],
						[
							-82.69154671799993,
							27.744659828000067
						],
						[
							-82.69155399999994,
							27.74472700000007
						],
						[
							-82.69204899999994,
							27.74468300000007
						],
						[
							-82.69306499999993,
							27.744688000000053
						],
						[
							-82.69356099999993,
							27.74468600000006
						],
						[
							-82.69400856599992,
							27.744683232000057
						],
						[
							-82.6940459999999,
							27.74468300000007
						],
						[
							-82.69478874099991,
							27.744670131000078
						],
						[
							-82.6948539999999,
							27.744669000000044
						],
						[
							-82.69559299999992,
							27.74469600000009
						],
						[
							-82.69637499399994,
							27.744671805000056
						],
						[
							-82.69640099999992,
							27.74467100000004
						],
						[
							-82.6972209999999,
							27.744688000000053
						],
						[
							-82.69766699999991,
							27.744679000000076
						],
						[
							-82.69804099999993,
							27.744673000000034
						],
						[
							-82.69860599999993,
							27.74467100000004
						],
						[
							-82.69877899999994,
							27.74466700000005
						],
						[
							-82.69887199999994,
							27.744669000000044
						],
						[
							-82.69967226499995,
							27.744669000000044
						],
						[
							-82.69968199999994,
							27.744669000000044
						],
						[
							-82.69966157599993,
							27.745385803000094
						],
						[
							-82.6996612879999,
							27.74539590100005
						],
						[
							-82.69966099999994,
							27.74540600000006
						],
						[
							-82.69966499999992,
							27.745801000000085
						],
						[
							-82.69966499999992,
							27.74610800000005
						],
						[
							-82.69965599999995,
							27.746286000000055
						],
						[
							-82.69966199999993,
							27.746500000000083
						],
						[
							-82.69965699999995,
							27.746833000000038
						],
						[
							-82.69966635299994,
							27.747101788000066
						],
						[
							-82.69967999999994,
							27.747494000000074
						],
						[
							-82.69968699999993,
							27.74830600000007
						],
						[
							-82.69969299999991,
							27.749268000000086
						],
						[
							-82.6996987839999,
							27.750103790000082
						],
						[
							-82.6996989999999,
							27.750135000000057
						],
						[
							-82.69970877199995,
							27.75173496000008
						],
						[
							-82.69970999999993,
							27.751936000000057
						],
						[
							-82.69931607699993,
							27.751940000000047
						],
						[
							-82.69793257499992,
							27.751940000000047
						],
						[
							-82.69742948399994,
							27.751940000000047
						],
						[
							-82.69684254299995,
							27.751940000000047
						],
						[
							-82.69642333099996,
							27.751937702000077
						],
						[
							-82.69602508799994,
							27.75193383600004
						],
						[
							-82.69562999999994,
							27.751930000000073
						],
						[
							-82.69535423099991,
							27.751930000000073
						],
						[
							-82.69511999999992,
							27.751930000000073
						],
						[
							-82.69464151799991,
							27.751930000000073
						],
						[
							-82.69424323699991,
							27.751930000000073
						],
						[
							-82.6940699999999,
							27.751930000000073
						],
						[
							-82.69376124099995,
							27.751933119000057
						],
						[
							-82.69344662899994,
							27.751936297000043
						],
						[
							-82.69327894899993,
							27.751937990000044
						],
						[
							-82.69307999999995,
							27.751940000000047
						],
						[
							-82.69277590699994,
							27.751943011000037
						],
						[
							-82.69218902499995,
							27.751948822000088
						],
						[
							-82.69206999999994,
							27.75195000000008
						],
						[
							-82.69179066499993,
							27.75195000000008
						],
						[
							-82.6913294979999,
							27.75195000000008
						],
						[
							-82.6910299999999,
							27.75195000000008
						],
						[
							-82.69080544399992,
							27.75195000000008
						],
						[
							-82.6903021039999,
							27.75194881600004
						],
						[
							-82.69001999999995,
							27.751940000000047
						],
						[
							-82.68969444999993,
							27.751940000000047
						],
						[
							-82.68927520699994,
							27.751940000000047
						],
						[
							-82.68901999999991,
							27.751940000000047
						],
						[
							-82.6888140399999,
							27.751940000000047
						],
						[
							-82.68847864499992,
							27.751940000000047
						],
						[
							-82.68831094799992,
							27.751940000000047
						],
						[
							-82.68802999999991,
							27.751940000000047
						],
						[
							-82.68787081099993,
							27.75193710600007
						],
						[
							-82.68772374399992,
							27.75193443200004
						],
						[
							-82.68747999999994,
							27.751930000000073
						],
						[
							-82.68726284099995,
							27.751930000000073
						],
						[
							-82.68702999999994,
							27.751930000000073
						],
						[
							-82.68673878699991,
							27.751930000000073
						],
						[
							-82.68625665699994,
							27.751930000000073
						],
						[
							-82.68595999999991,
							27.751930000000073
						],
						[
							-82.68569067899995,
							27.751930000000073
						],
						[
							-82.68532999999991,
							27.751930000000073
						],
						[
							-82.68506181499993,
							27.751930000000073
						],
						[
							-82.68466353399992,
							27.751930000000073
						],
						[
							-82.68443999999994,
							27.751930000000073
						],
						[
							-82.68411864799992,
							27.75193315100006
						],
						[
							-82.68395096699993,
							27.75193479400008
						],
						[
							-82.68380403999993,
							27.751936235000073
						],
						[
							-82.6834199999999,
							27.751940000000047
						],
						[
							-82.6832381179999,
							27.751941885000065
						],
						[
							-82.6827560399999,
							27.75194688000005
						],
						[
							-82.68233684199993,
							27.751951224000038
						],
						[
							-82.68172900499991,
							27.751957523000044
						],
						[
							-82.6811209299999,
							27.75196180900008
						],
						[
							-82.68040823399991,
							27.751965303000077
						],
						[
							-82.67996803999995,
							27.75196746100005
						],
						[
							-82.67944999999992,
							27.751970000000085
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Twinbrooks",
				"RegionID": "416363"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.6998089999999,
					27.751930000000073,
					-82.67944999999992,
					27.766450000000077
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.68666180399993,
							27.766413645000057
						],
						[
							-82.68615896499995,
							27.766411659000084
						],
						[
							-82.68571149099996,
							27.76641732300004
						],
						[
							-82.68526450399992,
							27.766418761000068
						],
						[
							-82.6849570679999,
							27.76641714200008
						],
						[
							-82.68448179099994,
							27.76641464100004
						],
						[
							-82.6839507649999,
							27.76641184600004
						],
						[
							-82.68294463699993,
							27.76640000000009
						],
						[
							-82.68235769699994,
							27.76640000000009
						],
						[
							-82.6815193249999,
							27.766408798000047
						],
						[
							-82.68109975499993,
							27.76641515500006
						],
						[
							-82.68040122999992,
							27.76642000000004
						],
						[
							-82.68000993599992,
							27.76642000000004
						],
						[
							-82.67946999999992,
							27.76642000000004
						],
						[
							-82.67946534299995,
							27.76606605300009
						],
						[
							-82.67946166099995,
							27.76578623800009
						],
						[
							-82.67945999999995,
							27.765339187000052
						],
						[
							-82.67945999999995,
							27.76486404500008
						],
						[
							-82.67945685599994,
							27.76450054500009
						],
						[
							-82.67945519699992,
							27.763969742000086
						],
						[
							-82.67945999999995,
							27.76304732500006
						],
						[
							-82.67945999999995,
							27.762544234000075
						],
						[
							-82.67945999999995,
							27.761929344000066
						],
						[
							-82.67945999999995,
							27.761398303000078
						],
						[
							-82.6794625469999,
							27.761018456000045
						],
						[
							-82.6794643099999,
							27.760755681000035
						],
						[
							-82.67947114299994,
							27.760336550000094
						],
						[
							-82.67947661799991,
							27.76000078900006
						],
						[
							-82.67948663999994,
							27.75938606200009
						],
						[
							-82.67948999999993,
							27.759022592000065
						],
						[
							-82.67948999999993,
							27.75851950100008
						],
						[
							-82.67948999999993,
							27.75801640900005
						],
						[
							-82.67948999999993,
							27.757708964000074
						],
						[
							-82.67949313399993,
							27.757094236000057
						],
						[
							-82.67949567799991,
							27.75687035100009
						],
						[
							-82.67949853599993,
							27.756618838000065
						],
						[
							-82.67949113899994,
							27.756060265000087
						],
						[
							-82.67948479099994,
							27.755752375000043
						],
						[
							-82.6794799999999,
							27.75527735500009
						],
						[
							-82.67946873699994,
							27.754859699000065
						],
						[
							-82.67945999999995,
							27.75443886900007
						],
						[
							-82.67945477699993,
							27.754047507000056
						],
						[
							-82.67944999999992,
							27.75356000000005
						],
						[
							-82.67945616299994,
							27.75315326900005
						],
						[
							-82.67945999999995,
							27.752622149000047
						],
						[
							-82.67945730399992,
							27.75234252900009
						],
						[
							-82.67944999999992,
							27.751970000000085
						],
						[
							-82.67996803999995,
							27.75196746100005
						],
						[
							-82.68040823399991,
							27.751965303000077
						],
						[
							-82.6811209299999,
							27.75196180900008
						],
						[
							-82.68172900499991,
							27.751957523000044
						],
						[
							-82.68233684199993,
							27.751951224000038
						],
						[
							-82.6827560399999,
							27.75194688000005
						],
						[
							-82.6832381179999,
							27.751941885000065
						],
						[
							-82.6834199999999,
							27.751940000000047
						],
						[
							-82.68380403999993,
							27.751936235000073
						],
						[
							-82.68395096699993,
							27.75193479400008
						],
						[
							-82.68411864799992,
							27.75193315100006
						],
						[
							-82.68443999999994,
							27.751930000000073
						],
						[
							-82.68466353399992,
							27.751930000000073
						],
						[
							-82.68506181499993,
							27.751930000000073
						],
						[
							-82.68532999999991,
							27.751930000000073
						],
						[
							-82.68569067899995,
							27.751930000000073
						],
						[
							-82.68595999999991,
							27.751930000000073
						],
						[
							-82.68625665699994,
							27.751930000000073
						],
						[
							-82.68673878699991,
							27.751930000000073
						],
						[
							-82.68702999999994,
							27.751930000000073
						],
						[
							-82.68726284099995,
							27.751930000000073
						],
						[
							-82.68747999999994,
							27.751930000000073
						],
						[
							-82.68772374399992,
							27.75193443200004
						],
						[
							-82.68787081099993,
							27.75193710600007
						],
						[
							-82.68802999999991,
							27.751940000000047
						],
						[
							-82.68831094799992,
							27.751940000000047
						],
						[
							-82.68847864499992,
							27.751940000000047
						],
						[
							-82.6888140399999,
							27.751940000000047
						],
						[
							-82.68901999999991,
							27.751940000000047
						],
						[
							-82.68927520699994,
							27.751940000000047
						],
						[
							-82.68969444999993,
							27.751940000000047
						],
						[
							-82.69001999999995,
							27.751940000000047
						],
						[
							-82.6903021039999,
							27.75194881600004
						],
						[
							-82.69080544399992,
							27.75195000000008
						],
						[
							-82.6910299999999,
							27.75195000000008
						],
						[
							-82.6913294979999,
							27.75195000000008
						],
						[
							-82.69179066499993,
							27.75195000000008
						],
						[
							-82.69206999999994,
							27.75195000000008
						],
						[
							-82.69218902499995,
							27.751948822000088
						],
						[
							-82.69277590699994,
							27.751943011000037
						],
						[
							-82.69307999999995,
							27.751940000000047
						],
						[
							-82.69327894899993,
							27.751937990000044
						],
						[
							-82.69344662899994,
							27.751936297000043
						],
						[
							-82.69376124099995,
							27.751933119000057
						],
						[
							-82.6940699999999,
							27.751930000000073
						],
						[
							-82.69424323699991,
							27.751930000000073
						],
						[
							-82.69464151799991,
							27.751930000000073
						],
						[
							-82.69511999999992,
							27.751930000000073
						],
						[
							-82.69535423099991,
							27.751930000000073
						],
						[
							-82.69562999999994,
							27.751930000000073
						],
						[
							-82.69602508799994,
							27.75193383600004
						],
						[
							-82.69642333099996,
							27.751937702000077
						],
						[
							-82.69684254299995,
							27.751940000000047
						],
						[
							-82.69742948399994,
							27.751940000000047
						],
						[
							-82.69793257499992,
							27.751940000000047
						],
						[
							-82.69931607699993,
							27.751940000000047
						],
						[
							-82.69970999999993,
							27.751936000000057
						],
						[
							-82.69971199999992,
							27.752117000000055
						],
						[
							-82.69971807499991,
							27.752872952000075
						],
						[
							-82.69971874299995,
							27.75295595500006
						],
						[
							-82.6997189999999,
							27.752988000000073
						],
						[
							-82.69971499999991,
							27.753772000000083
						],
						[
							-82.69972999999993,
							27.75444500000009
						],
						[
							-82.69972299999996,
							27.754668000000038
						],
						[
							-82.69973199999993,
							27.755178000000058
						],
						[
							-82.6997347279999,
							27.75556898900004
						],
						[
							-82.69973499999992,
							27.755608000000052
						],
						[
							-82.69975599999992,
							27.75632500000006
						],
						[
							-82.69975499999993,
							27.75650200000007
						],
						[
							-82.69975799999992,
							27.757052000000044
						],
						[
							-82.69975999999991,
							27.757382000000064
						],
						[
							-82.6997629999999,
							27.75778100000008
						],
						[
							-82.69975899999991,
							27.75831100000005
						],
						[
							-82.6997649999999,
							27.75848800000006
						],
						[
							-82.69977199999995,
							27.759198000000083
						],
						[
							-82.69977899999992,
							27.759656000000064
						],
						[
							-82.69977699999993,
							27.760023000000047
						],
						[
							-82.69979999999993,
							27.76055400000007
						],
						[
							-82.69980099999992,
							27.760832000000054
						],
						[
							-82.69980199999992,
							27.761017000000038
						],
						[
							-82.69980699999991,
							27.76145500000007
						],
						[
							-82.69980299999992,
							27.761645000000044
						],
						[
							-82.6998089999999,
							27.762060000000076
						],
						[
							-82.69980299999992,
							27.762380000000064
						],
						[
							-82.6998077529999,
							27.762714626000047
						],
						[
							-82.69978999999995,
							27.76273000000009
						],
						[
							-82.69978999999995,
							27.76304732500006
						],
						[
							-82.69978999999995,
							27.763438619000055
						],
						[
							-82.69978999999995,
							27.76394171000004
						],
						[
							-82.69978999999995,
							27.764416852000068
						],
						[
							-82.69979320899995,
							27.764892049000082
						],
						[
							-82.69979750899995,
							27.765283296000064
						],
						[
							-82.69979999999993,
							27.76570253100005
						],
						[
							-82.69979999999993,
							27.766009976000078
						],
						[
							-82.69979999999993,
							27.76642000000004
						],
						[
							-82.6996025599999,
							27.76642000000004
						],
						[
							-82.69876407399994,
							27.76642000000004
						],
						[
							-82.69806528899994,
							27.766422998000056
						],
						[
							-82.6973665889999,
							27.766428173000065
						],
						[
							-82.6967237849999,
							27.76643289200007
						],
						[
							-82.69588534299993,
							27.766439012000035
						],
						[
							-82.69532628099996,
							27.766440000000046
						],
						[
							-82.69471139099994,
							27.766440000000046
						],
						[
							-82.69406864799993,
							27.766442289000054
						],
						[
							-82.69381711599993,
							27.766444139000043
						],
						[
							-82.69334179399993,
							27.766447634000087
						],
						[
							-82.69267107499991,
							27.766450000000077
						],
						[
							-82.69194438699992,
							27.766450000000077
						],
						[
							-82.69127359899994,
							27.766450000000077
						],
						[
							-82.69043511299994,
							27.766450000000077
						],
						[
							-82.68995997099995,
							27.766450000000077
						],
						[
							-82.68928918199992,
							27.766450000000077
						],
						[
							-82.68861855499995,
							27.76644615500004
						],
						[
							-82.68836706299993,
							27.76644245700004
						],
						[
							-82.6880592739999,
							27.76643793100004
						],
						[
							-82.68764012199995,
							27.76643176600004
						],
						[
							-82.68696949399994,
							27.76641666200004
						],
						[
							-82.68666180399993,
							27.766413645000057
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Childs Park",
				"RegionID": "416364"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.67949853599993,
					27.744678011000076,
					-82.67521999999991,
					27.76105000000007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.67529999999994,
							27.761038401000064
						],
						[
							-82.67529999999994,
							27.760710567000046
						],
						[
							-82.67529999999994,
							27.760382733000085
						],
						[
							-82.67529999999994,
							27.75965141000006
						],
						[
							-82.6752899999999,
							27.75924000000009
						],
						[
							-82.67529756099992,
							27.758718282000075
						],
						[
							-82.67529881399992,
							27.758329700000047
						],
						[
							-82.67529999999994,
							27.757961802000068
						],
						[
							-82.67529919599991,
							27.75735672600007
						],
						[
							-82.67528692099995,
							27.75715419700009
						],
						[
							-82.67527500699993,
							27.756902702000048
						],
						[
							-82.67526856299992,
							27.75672549300009
						],
						[
							-82.67525999999994,
							27.756473939000045
						],
						[
							-82.67526231699992,
							27.756146251000075
						],
						[
							-82.67526534199993,
							27.75591932900005
						],
						[
							-82.67526769999996,
							27.755742498000075
						],
						[
							-82.67526890399995,
							27.755570928000054
						],
						[
							-82.6752699999999,
							27.75541478200006
						],
						[
							-82.67526814899992,
							27.755061888000057
						],
						[
							-82.67526385899993,
							27.754834531000085
						],
						[
							-82.67525999999994,
							27.754532151000035
						],
						[
							-82.67526236799995,
							27.75422973500008
						],
						[
							-82.67526741899991,
							27.753951970000063
						],
						[
							-82.6752699999999,
							27.753649520000067
						],
						[
							-82.6752681239999,
							27.75339745000008
						],
						[
							-82.6752624799999,
							27.752968486000043
						],
						[
							-82.6752569599999,
							27.752539855000066
						],
						[
							-82.67525217299993,
							27.752161646000047
						],
						[
							-82.67525010899993,
							27.751989592000086
						],
						[
							-82.67524793899992,
							27.75180864200007
						],
						[
							-82.67524364099995,
							27.751430421000066
						],
						[
							-82.6752419469999,
							27.750900647000037
						],
						[
							-82.67524687399992,
							27.75047199700009
						],
						[
							-82.67524329699995,
							27.74989166000006
						],
						[
							-82.67523617299992,
							27.74956398100005
						],
						[
							-82.67522999999994,
							27.74898418500004
						],
						[
							-82.67522999999994,
							27.74863113200007
						],
						[
							-82.67522999999994,
							27.748101554000073
						],
						[
							-82.67522999999994,
							27.747042397000087
						],
						[
							-82.67522712899995,
							27.746285845000045
						],
						[
							-82.67522274399994,
							27.745882404000046
						],
						[
							-82.67521999999991,
							27.745403225000075
						],
						[
							-82.67521999999991,
							27.745100609000076
						],
						[
							-82.67521999999991,
							27.744710000000055
						],
						[
							-82.67542786899992,
							27.744710000000055
						],
						[
							-82.67605831999992,
							27.744710000000055
						],
						[
							-82.6763357179999,
							27.744710000000055
						],
						[
							-82.67666325399995,
							27.74470623600007
						],
						[
							-82.67684018699993,
							27.74470296000004
						],
						[
							-82.67714269499993,
							27.74470000000008
						],
						[
							-82.67764702199992,
							27.74469591600007
						],
						[
							-82.6781009799999,
							27.74469000000005
						],
						[
							-82.67875690699992,
							27.744687385000077
						],
						[
							-82.67900901699994,
							27.744683183000063
						],
						[
							-82.67919999999992,
							27.744680000000074
						],
						[
							-82.67937002399992,
							27.744678011000076
						],
						[
							-82.67936999999995,
							27.744680000000074
						],
						[
							-82.67936788299994,
							27.74506522100006
						],
						[
							-82.6793667309999,
							27.745274952000045
						],
						[
							-82.67936465799994,
							27.745652259000053
						],
						[
							-82.67936166299995,
							27.746197258000052
						],
						[
							-82.67936245399994,
							27.746637413000087
						],
						[
							-82.6793676929999,
							27.74693079000008
						],
						[
							-82.67937256399995,
							27.747203585000083
						],
						[
							-82.67937705399993,
							27.747455051000088
						],
						[
							-82.67937999999992,
							27.74802095700005
						],
						[
							-82.67937999999992,
							27.748340000000045
						],
						[
							-82.67938542499991,
							27.74858683900004
						],
						[
							-82.67939003999993,
							27.748796820000052
						],
						[
							-82.67939556599993,
							27.749048244000054
						],
						[
							-82.67939999999993,
							27.74936253500005
						],
						[
							-82.67939999999993,
							27.74954000000008
						],
						[
							-82.67939726299994,
							27.749676871000077
						],
						[
							-82.6793947399999,
							27.749803013000076
						],
						[
							-82.67939096799995,
							27.749991597000076
						],
						[
							-82.6793899999999,
							27.750170000000082
						],
						[
							-82.67939683399993,
							27.750368174000073
						],
						[
							-82.67940405299993,
							27.750577547000034
						],
						[
							-82.6794099999999,
							27.75075000000004
						],
						[
							-82.6794099999999,
							27.750850847000038
						],
						[
							-82.6794099999999,
							27.751100000000065
						],
						[
							-82.67941856399995,
							27.75122846100004
						],
						[
							-82.67942273799991,
							27.751291070000036
						],
						[
							-82.67942999999993,
							27.751400000000046
						],
						[
							-82.67943574899995,
							27.751563848000046
						],
						[
							-82.6794430949999,
							27.751773212000046
						],
						[
							-82.67944999999992,
							27.751970000000085
						],
						[
							-82.67945730399992,
							27.75234252900009
						],
						[
							-82.67945999999995,
							27.752622149000047
						],
						[
							-82.67945616299994,
							27.75315326900005
						],
						[
							-82.67944999999992,
							27.75356000000005
						],
						[
							-82.67945477699993,
							27.754047507000056
						],
						[
							-82.67945999999995,
							27.75443886900007
						],
						[
							-82.67946873699994,
							27.754859699000065
						],
						[
							-82.6794799999999,
							27.75527735500009
						],
						[
							-82.67948479099994,
							27.755752375000043
						],
						[
							-82.67949113899994,
							27.756060265000087
						],
						[
							-82.67949853599993,
							27.756618838000065
						],
						[
							-82.67949567799991,
							27.75687035100009
						],
						[
							-82.67949313399993,
							27.757094236000057
						],
						[
							-82.67948999999993,
							27.757708964000074
						],
						[
							-82.67948999999993,
							27.75801640900005
						],
						[
							-82.67948999999993,
							27.75851950100008
						],
						[
							-82.67948999999993,
							27.759022592000065
						],
						[
							-82.67948663999994,
							27.75938606200009
						],
						[
							-82.67947661799991,
							27.76000078900006
						],
						[
							-82.67947114299994,
							27.760336550000094
						],
						[
							-82.6794643099999,
							27.760755681000035
						],
						[
							-82.6794625469999,
							27.761018456000045
						],
						[
							-82.67913466499994,
							27.761018456000045
						],
						[
							-82.67865576599992,
							27.761014465000073
						],
						[
							-82.67817665699994,
							27.761010472000066
						],
						[
							-82.67784896599996,
							27.761004686000035
						],
						[
							-82.67760301099992,
							27.760997204000034
						],
						[
							-82.67750456199991,
							27.760961521000073
						],
						[
							-82.67726878499991,
							27.760930000000087
						],
						[
							-82.6769931419999,
							27.76095186000009
						],
						[
							-82.67681618099994,
							27.76097352900007
						],
						[
							-82.67661133199994,
							27.760998612000037
						],
						[
							-82.67620959499993,
							27.761012323000045
						],
						[
							-82.67585609499992,
							27.76102591900008
						],
						[
							-82.67565999999994,
							27.76105000000007
						],
						[
							-82.67529999999994,
							27.761038401000064
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Thirty-First St",
				"RegionID": "416365"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.67525010899993,
					27.742541349000078,
					-82.66291999999993,
					27.752020000000076
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.66441861199992,
							27.75201128100008
						],
						[
							-82.66426999999993,
							27.75201000000004
						],
						[
							-82.6641456449999,
							27.75201000000004
						],
						[
							-82.66378735699993,
							27.75201000000004
						],
						[
							-82.66339494599993,
							27.75201000000004
						],
						[
							-82.66320727099992,
							27.75201000000004
						],
						[
							-82.66302999999994,
							27.75201000000004
						],
						[
							-82.66304003699992,
							27.751924686000052
						],
						[
							-82.66305579599992,
							27.751772376000076
						],
						[
							-82.66306911099991,
							27.751617041000088
						],
						[
							-82.66307999999992,
							27.751490000000047
						],
						[
							-82.66307814899994,
							27.75139557600005
						],
						[
							-82.66307312599992,
							27.751139420000072
						],
						[
							-82.66306810999994,
							27.750883598000087
						],
						[
							-82.66306476599993,
							27.75071305000006
						],
						[
							-82.66306241799992,
							27.75059333200005
						],
						[
							-82.66305999999992,
							27.750470000000064
						],
						[
							-82.66305800399994,
							27.750286352000046
						],
						[
							-82.66305540799993,
							27.750047521000056
						],
						[
							-82.66305244099995,
							27.749774572000035
						],
						[
							-82.66304999999994,
							27.749550000000056
						],
						[
							-82.66304664599994,
							27.74938228900004
						],
						[
							-82.6630418709999,
							27.74914352500008
						],
						[
							-82.66303982399995,
							27.749041198000043
						],
						[
							-82.66303572399994,
							27.748836203000053
						],
						[
							-82.66303197199994,
							27.74864860300005
						],
						[
							-82.66301848699993,
							27.748480924000035
						],
						[
							-82.66301249299994,
							27.74844495700006
						],
						[
							-82.6630002679999,
							27.748371605000045
						],
						[
							-82.6629999999999,
							27.74837000000008
						],
						[
							-82.6629787729999,
							27.748270939000065
						],
						[
							-82.66295080899994,
							27.74814044100009
						],
						[
							-82.66293885199991,
							27.748068183000044
						],
						[
							-82.6629299999999,
							27.74784662600007
						],
						[
							-82.6629299999999,
							27.747658951000062
						],
						[
							-82.6629299999999,
							27.747480000000053
						],
						[
							-82.66292821499991,
							27.747317603000056
						],
						[
							-82.66292615499992,
							27.74713013900004
						],
						[
							-82.66292390399991,
							27.746925240000053
						],
						[
							-82.66292165399994,
							27.746720528000083
						],
						[
							-82.66291999999993,
							27.746570000000077
						],
						[
							-82.66291999999993,
							27.746379350000044
						],
						[
							-82.66291999999993,
							27.746021062000068
						],
						[
							-82.66291999999993,
							27.74583338700006
						],
						[
							-82.66291999999993,
							27.745640000000037
						],
						[
							-82.66291999999993,
							27.74542391400007
						],
						[
							-82.66291999999993,
							27.745048565000047
						],
						[
							-82.66291999999993,
							27.744740000000036
						],
						[
							-82.66291999999993,
							27.74446847900009
						],
						[
							-82.66291999999993,
							27.74419000000006
						],
						[
							-82.66291999999993,
							27.743973700000083
						],
						[
							-82.66291999999993,
							27.74370071800007
						],
						[
							-82.66291999999993,
							27.743427737000047
						],
						[
							-82.66292377899993,
							27.743171921000055
						],
						[
							-82.66292675699992,
							27.742984293000063
						],
						[
							-82.66292892799993,
							27.74284756600008
						],
						[
							-82.6629299999999,
							27.74278000000004
						],
						[
							-82.66310475599994,
							27.74277462300006
						],
						[
							-82.6633268679999,
							27.742767789000084
						],
						[
							-82.6635986089999,
							27.74275655400004
						],
						[
							-82.66375012499992,
							27.74272849500005
						],
						[
							-82.66397001099995,
							27.742676247000077
						],
						[
							-82.66410983599992,
							27.74263692100004
						],
						[
							-82.66425040099996,
							27.742603073000055
						],
						[
							-82.6644016159999,
							27.742575104000082
						],
						[
							-82.66457220699994,
							27.742558345000077
						],
						[
							-82.66479366399994,
							27.742549660000066
						],
						[
							-82.66498105099993,
							27.74254231200007
						],
						[
							-82.66508451199991,
							27.742541349000078
						],
						[
							-82.66527201399992,
							27.742547031000072
						],
						[
							-82.66542498699994,
							27.742559164000056
						],
						[
							-82.66558549199993,
							27.74260978800004
						],
						[
							-82.66572322499991,
							27.74270322500007
						],
						[
							-82.66583999999995,
							27.74282000000005
						],
						[
							-82.66592207399992,
							27.742975028000046
						],
						[
							-82.66597684599992,
							27.743083692000084
						],
						[
							-82.66602065399991,
							27.743223088000036
						],
						[
							-82.66602831299991,
							27.74337625700008
						],
						[
							-82.6660203799999,
							27.743464515000085
						],
						[
							-82.66599999999994,
							27.743580000000065
						],
						[
							-82.66609185299991,
							27.743497332000064
						],
						[
							-82.66622749499993,
							27.74344613800008
						],
						[
							-82.66635400599995,
							27.743370663000064
						],
						[
							-82.66648339299991,
							27.743291898000052
						],
						[
							-82.66665708999994,
							27.743209403000037
						],
						[
							-82.66678694699993,
							27.74321292600007
						],
						[
							-82.66687686699993,
							27.74323701500009
						],
						[
							-82.66697667299991,
							27.743284449000043
						],
						[
							-82.66702116899995,
							27.74337674900005
						],
						[
							-82.66702628399992,
							27.74358135700004
						],
						[
							-82.66703303799994,
							27.743802919000075
						],
						[
							-82.66703806499993,
							27.74392356000004
						],
						[
							-82.66703999999993,
							27.744331988000056
						],
						[
							-82.66703999999993,
							27.744730000000065
						],
						[
							-82.6678479599999,
							27.74472482100009
						],
						[
							-82.6682574159999,
							27.744722196000055
						],
						[
							-82.66859999999993,
							27.744720000000086
						],
						[
							-82.66893988899994,
							27.744723907000036
						],
						[
							-82.66946999999993,
							27.744730000000065
						],
						[
							-82.66986119599994,
							27.744730000000065
						],
						[
							-82.67027999999993,
							27.744730000000065
						],
						[
							-82.67056071199994,
							27.744730000000065
						],
						[
							-82.67110543299992,
							27.744730000000065
						],
						[
							-82.67110999999994,
							27.744730000000065
						],
						[
							-82.67144792399996,
							27.74472668700008
						],
						[
							-82.67189147699992,
							27.74472233800009
						],
						[
							-82.67212999999992,
							27.744720000000086
						],
						[
							-82.67250562699991,
							27.744716353000058
						],
						[
							-82.67282992799994,
							27.74471320500004
						],
						[
							-82.67315999999994,
							27.744710000000055
						],
						[
							-82.67393885799993,
							27.744710000000055
						],
						[
							-82.67491135499995,
							27.744710000000055
						],
						[
							-82.67521999999991,
							27.744710000000055
						],
						[
							-82.67521999999991,
							27.745100609000076
						],
						[
							-82.67521999999991,
							27.745403225000075
						],
						[
							-82.67522274399994,
							27.745882404000046
						],
						[
							-82.67522712899995,
							27.746285845000045
						],
						[
							-82.67522999999994,
							27.747042397000087
						],
						[
							-82.67522999999994,
							27.748101554000073
						],
						[
							-82.67522999999994,
							27.74863113200007
						],
						[
							-82.67522999999994,
							27.74898418500004
						],
						[
							-82.67523617299992,
							27.74956398100005
						],
						[
							-82.67524329699995,
							27.74989166000006
						],
						[
							-82.67524687399992,
							27.75047199700009
						],
						[
							-82.6752419469999,
							27.750900647000037
						],
						[
							-82.67524364099995,
							27.751430421000066
						],
						[
							-82.67524793899992,
							27.75180864200007
						],
						[
							-82.67525010899993,
							27.751989592000086
						],
						[
							-82.67511609099995,
							27.751990000000035
						],
						[
							-82.67467249599991,
							27.751990000000035
						],
						[
							-82.67429714699995,
							27.751990000000035
						],
						[
							-82.67415999999992,
							27.751990000000035
						],
						[
							-82.67395591999991,
							27.751990000000035
						],
						[
							-82.67369999999994,
							27.751990000000035
						],
						[
							-82.6734611409999,
							27.751990000000035
						],
						[
							-82.67316999999991,
							27.751990000000035
						],
						[
							-82.67298341599991,
							27.751991811000043
						],
						[
							-82.67271029499994,
							27.751994463000077
						],
						[
							-82.6724375039999,
							27.751997112000083
						],
						[
							-82.6721399999999,
							27.752000000000066
						],
						[
							-82.67195986899992,
							27.752002339000057
						],
						[
							-82.67173810899993,
							27.75200521900007
						],
						[
							-82.67153318599992,
							27.752007881000054
						],
						[
							-82.6712431659999,
							27.75201000000004
						],
						[
							-82.67111999999992,
							27.75201000000004
						],
						[
							-82.67088487699993,
							27.75201000000004
						],
						[
							-82.6707313249999,
							27.75201000000004
						],
						[
							-82.6704412819999,
							27.75201000000004
						],
						[
							-82.67018536199993,
							27.75201000000004
						],
						[
							-82.66991237999991,
							27.75201000000004
						],
						[
							-82.66965645999994,
							27.75201000000004
						],
						[
							-82.66936641699994,
							27.75201000000004
						],
						[
							-82.66928111099992,
							27.75201000000004
						],
						[
							-82.66904231699993,
							27.75200679800008
						],
						[
							-82.66888845099993,
							27.752003220000063
						],
						[
							-82.66874999999993,
							27.752000000000066
						],
						[
							-82.66864984099993,
							27.752000000000066
						],
						[
							-82.66852999999992,
							27.752000000000066
						],
						[
							-82.6683770329999,
							27.75200263700009
						],
						[
							-82.6681208949999,
							27.752007054000046
						],
						[
							-82.6679499999999,
							27.75201000000004
						],
						[
							-82.6677967729999,
							27.75201000000004
						],
						[
							-82.66752999999994,
							27.75201000000004
						],
						[
							-82.66725080999993,
							27.75201000000004
						],
						[
							-82.6670499999999,
							27.75201000000004
						],
						[
							-82.66689258999992,
							27.752013086000094
						],
						[
							-82.6667046529999,
							27.752016772000047
						],
						[
							-82.66653999999994,
							27.752020000000076
						],
						[
							-82.66619300699995,
							27.752020000000076
						],
						[
							-82.6658688409999,
							27.752020000000076
						],
						[
							-82.66561292099993,
							27.752020000000076
						],
						[
							-82.6654299999999,
							27.752020000000076
						],
						[
							-82.66520352299996,
							27.75201804800008
						],
						[
							-82.66496468199995,
							27.752015989000085
						],
						[
							-82.66477687399993,
							27.75201437000004
						],
						[
							-82.66441861199992,
							27.75201128100008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Highland Oaks",
				"RegionID": "416366"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.6549393219999,
					27.806550000000072,
					-82.64674511899995,
					27.813930000000084
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.64675999999993,
							27.80716375200007
						],
						[
							-82.64675999999993,
							27.806830000000048
						],
						[
							-82.64709806699994,
							27.80687650400006
						],
						[
							-82.64738523699992,
							27.80685561900009
						],
						[
							-82.64785440799994,
							27.806809332000057
						],
						[
							-82.64806972199995,
							27.806767113000035
						],
						[
							-82.64835668099994,
							27.806715034000035
						],
						[
							-82.64860645599992,
							27.806688462000068
						],
						[
							-82.64904352499993,
							27.80664981400008
						],
						[
							-82.64951448399995,
							27.80663124700004
						],
						[
							-82.64978999999994,
							27.806550000000072
						],
						[
							-82.64981447299994,
							27.80655151900004
						],
						[
							-82.65059568399994,
							27.80660000000006
						],
						[
							-82.65110102999995,
							27.80659472800005
						],
						[
							-82.6513799999999,
							27.806590000000085
						],
						[
							-82.6516421799999,
							27.806590000000085
						],
						[
							-82.65211129799991,
							27.806590000000085
						],
						[
							-82.65242999999992,
							27.806590000000085
						],
						[
							-82.65272472899994,
							27.806584641000086
						],
						[
							-82.65305999999993,
							27.806580000000057
						],
						[
							-82.6533020409999,
							27.80657739700007
						],
						[
							-82.65377110499992,
							27.80657235400008
						],
						[
							-82.65431233099991,
							27.806566496000073
						],
						[
							-82.6546374589999,
							27.806562962000044
						],
						[
							-82.65490999999992,
							27.806560000000047
						],
						[
							-82.65490999999992,
							27.806854420000036
						],
						[
							-82.65490999999992,
							27.80698625000008
						],
						[
							-82.65490999999992,
							27.807310000000086
						],
						[
							-82.65490999999992,
							27.80744765500009
						],
						[
							-82.65490999999992,
							27.80779920100008
						],
						[
							-82.65490999999992,
							27.808040000000062
						],
						[
							-82.65490999999992,
							27.808128776000046
						],
						[
							-82.65490999999992,
							27.808326521000087
						],
						[
							-82.65490999999992,
							27.808634124000037
						],
						[
							-82.65490999999992,
							27.80881000000005
						],
						[
							-82.65490999999992,
							27.80909552900005
						],
						[
							-82.65490999999992,
							27.80938116100009
						],
						[
							-82.65491457399992,
							27.809864125000047
						],
						[
							-82.65491999999995,
							27.810130000000072
						],
						[
							-82.65489587399992,
							27.810436346000074
						],
						[
							-82.65490900499992,
							27.81071109300007
						],
						[
							-82.65491999999995,
							27.81072000000006
						],
						[
							-82.65491999999995,
							27.810776500000088
						],
						[
							-82.65491999999995,
							27.811205389000065
						],
						[
							-82.65491999999995,
							27.811602336000078
						],
						[
							-82.65491999999995,
							27.812020000000075
						],
						[
							-82.65492737699992,
							27.81239620200006
						],
						[
							-82.6549393219999,
							27.81297374700006
						],
						[
							-82.65493433199993,
							27.813442812000062
						],
						[
							-82.65492999999992,
							27.81385000000006
						],
						[
							-82.65467354299994,
							27.813852671000067
						],
						[
							-82.65434842799993,
							27.813856058000056
						],
						[
							-82.6539699999999,
							27.81386000000009
						],
						[
							-82.65359070599993,
							27.813863793000053
						],
						[
							-82.65296999999993,
							27.813870000000065
						],
						[
							-82.65243605699993,
							27.81387256700009
						],
						[
							-82.65146175699994,
							27.813877251000065
						],
						[
							-82.65088999999995,
							27.81388000000004
						],
						[
							-82.6504513399999,
							27.81388000000004
						],
						[
							-82.64965744699992,
							27.81388000000004
						],
						[
							-82.6488599999999,
							27.81388000000004
						],
						[
							-82.64835864799994,
							27.81389187700006
						],
						[
							-82.64767324799993,
							27.813904569000044
						],
						[
							-82.64723969599993,
							27.81391259800006
						],
						[
							-82.6467899999999,
							27.813930000000084
						],
						[
							-82.6467899999999,
							27.81340663800006
						],
						[
							-82.6467899999999,
							27.812980000000042
						],
						[
							-82.6467899999999,
							27.812540573000035
						],
						[
							-82.6467899999999,
							27.812070000000062
						],
						[
							-82.64678442999991,
							27.81181934600005
						],
						[
							-82.64677719799994,
							27.81149393000004
						],
						[
							-82.64676999999995,
							27.81117000000006
						],
						[
							-82.64676999999995,
							27.810880615000087
						],
						[
							-82.64676999999995,
							27.810700185000087
						],
						[
							-82.64681999999993,
							27.810320000000047
						],
						[
							-82.64674511899995,
							27.81025019000009
						],
						[
							-82.64676999999995,
							27.810250000000053
						],
						[
							-82.64676999999995,
							27.80979803400004
						],
						[
							-82.64676999999995,
							27.809420000000046
						],
						[
							-82.64676999999995,
							27.80907631300005
						],
						[
							-82.64676999999995,
							27.808823710000073
						],
						[
							-82.64676999999995,
							27.80854000000005
						],
						[
							-82.6467660749999,
							27.80821030100009
						],
						[
							-82.64676264399992,
							27.80792208300005
						],
						[
							-82.64675999999993,
							27.807700000000068
						],
						[
							-82.64675999999993,
							27.807452441000066
						],
						[
							-82.64675999999993,
							27.80716375200007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "The Allendale Association",
				"RegionID": "417174"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.63243470999994,
					27.78799267800008,
					-82.60464115399992,
					27.805269322000072
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.60838078699993,
							27.80115226800007
						],
						[
							-82.60724076199995,
							27.79907579400009
						],
						[
							-82.60639091399992,
							27.79872478200008
						],
						[
							-82.60571032399992,
							27.798251184000037
						],
						[
							-82.6056459269999,
							27.798201920000054
						],
						[
							-82.6055313029999,
							27.798086511000065
						],
						[
							-82.6052955259999,
							27.797797951000067
						],
						[
							-82.60523978899994,
							27.797721909000074
						],
						[
							-82.6050287889999,
							27.797399909000035
						],
						[
							-82.60497096899991,
							27.797297680000042
						],
						[
							-82.6048619689999,
							27.797071679000055
						],
						[
							-82.6048208009999,
							27.796971243000087
						],
						[
							-82.60471680199993,
							27.79666624400005
						],
						[
							-82.60468234099994,
							27.796532166000077
						],
						[
							-82.6046753839999,
							27.796485621000045
						],
						[
							-82.60464738399992,
							27.796257620000063
						],
						[
							-82.60464115399992,
							27.79611873300007
						],
						[
							-82.6046481539999,
							27.795903733000046
						],
						[
							-82.60466577099993,
							27.79575351200009
						],
						[
							-82.6048097709999,
							27.79504651300005
						],
						[
							-82.60484591399995,
							27.79491841400005
						],
						[
							-82.60487680599994,
							27.794844074000082
						],
						[
							-82.60544580499993,
							27.793631074000075
						],
						[
							-82.60548116399991,
							27.79356333900006
						],
						[
							-82.60555126199995,
							27.793459402000053
						],
						[
							-82.60638626299993,
							27.792390402000084
						],
						[
							-82.60645450599993,
							27.792312694000092
						],
						[
							-82.6069355059999,
							27.79182469400007
						],
						[
							-82.60696588699994,
							27.79179528700007
						],
						[
							-82.60742288599994,
							27.791373286000066
						],
						[
							-82.60751437599993,
							27.791299282000068
						],
						[
							-82.60851737599995,
							27.790591283000083
						],
						[
							-82.60860866699994,
							27.79053469300004
						],
						[
							-82.60919566699994,
							27.790217693000045
						],
						[
							-82.60922125299993,
							27.79020440100004
						],
						[
							-82.60994825399992,
							27.789841400000057
						],
						[
							-82.61003042499993,
							27.789805374000082
						],
						[
							-82.61039342499993,
							27.78966737500008
						],
						[
							-82.61043582799994,
							27.789652456000056
						],
						[
							-82.61096982799995,
							27.78947945500005
						],
						[
							-82.61100266199992,
							27.789469506000046
						],
						[
							-82.61129666199992,
							27.789386507000074
						],
						[
							-82.61145048799995,
							27.789357245000076
						],
						[
							-82.61179648799992,
							27.78932224400006
						],
						[
							-82.6119189659999,
							27.78931824600005
						],
						[
							-82.6123969649999,
							27.789335247000054
						],
						[
							-82.61252116499992,
							27.78934834100005
						],
						[
							-82.61257828699992,
							27.789360336000076
						],
						[
							-82.6130042879999,
							27.789464336000037
						],
						[
							-82.61305037099993,
							27.78947689200004
						],
						[
							-82.61338237099996,
							27.78957689200007
						],
						[
							-82.61345741999992,
							27.789603168000045
						],
						[
							-82.61352985499991,
							27.789635972000042
						],
						[
							-82.61359910999994,
							27.78967504500008
						],
						[
							-82.61385710899992,
							27.789836045000072
						],
						[
							-82.61394121099994,
							27.789895478000062
						],
						[
							-82.61409393699995,
							27.790011353000068
						],
						[
							-82.61418462299991,
							27.789828810000074
						],
						[
							-82.61422300999993,
							27.789759789000072
						],
						[
							-82.61426730499994,
							27.789694403000055
						],
						[
							-82.61431716599992,
							27.789633155000047
						],
						[
							-82.6143722079999,
							27.789576517000057
						],
						[
							-82.61456320799994,
							27.789396517000057
						],
						[
							-82.61467076499991,
							27.789309744000036
						],
						[
							-82.61491676599991,
							27.789140745000054
						],
						[
							-82.61497633899995,
							27.789103165000085
						],
						[
							-82.61510345599993,
							27.78904250900007
						],
						[
							-82.61530093499994,
							27.788966711000057
						],
						[
							-82.61545983499991,
							27.788923340000053
						],
						[
							-82.61555646099993,
							27.788911651000035
						],
						[
							-82.6157674609999,
							27.78889765100007
						],
						[
							-82.61582699999991,
							27.788895678000074
						],
						[
							-82.61593960999994,
							27.788902756000088
						],
						[
							-82.61603646999993,
							27.78891498100006
						],
						[
							-82.61612831899993,
							27.788925291000055
						],
						[
							-82.61624387499995,
							27.78894597200008
						],
						[
							-82.61651887499994,
							27.789013971000088
						],
						[
							-82.61661058699991,
							27.789041913000062
						],
						[
							-82.61667654999991,
							27.789068928000063
						],
						[
							-82.61689554999992,
							27.789168929000084
						],
						[
							-82.61697166099994,
							27.789208164000062
						],
						[
							-82.61705932699994,
							27.78926584800007
						],
						[
							-82.61726332699993,
							27.789417848000085
						],
						[
							-82.6173040729999,
							27.789450079000062
						],
						[
							-82.61741488699994,
							27.78955699000005
						],
						[
							-82.61741755399993,
							27.789510308000047
						],
						[
							-82.6174285539999,
							27.78926130800005
						],
						[
							-82.6174413409999,
							27.78914483400007
						],
						[
							-82.61745411999993,
							27.789084527000057
						],
						[
							-82.61748511999991,
							27.788959528000078
						],
						[
							-82.61750495099994,
							27.788891241000044
						],
						[
							-82.61753011499991,
							27.78882473500005
						],
						[
							-82.61756045599992,
							27.78876042400009
						],
						[
							-82.61759578199991,
							27.78869871200004
						],
						[
							-82.61763587299994,
							27.788639984000046
						],
						[
							-82.6177078739999,
							27.78854298400006
						],
						[
							-82.61775735599991,
							27.788482067000075
						],
						[
							-82.61781195999993,
							27.788425696000047
						],
						[
							-82.6178712709999,
							27.78837430100009
						],
						[
							-82.61793483699995,
							27.788328272000058
						],
						[
							-82.61802883699994,
							27.788266272000044
						],
						[
							-82.61812471799993,
							27.78821117500007
						],
						[
							-82.61823571799994,
							27.78815617500004
						],
						[
							-82.6183274139999,
							27.78811691400006
						],
						[
							-82.61840359699994,
							27.78809295900004
						],
						[
							-82.61857259599992,
							27.78804795900004
						],
						[
							-82.61870639999995,
							27.78802299000006
						],
						[
							-82.61893539999994,
							27.787997989000075
						],
						[
							-82.61903299999994,
							27.78799267800008
						],
						[
							-82.6191723689999,
							27.78800354200007
						],
						[
							-82.61938476699993,
							27.788036942000076
						],
						[
							-82.6194552629999,
							27.78805159300009
						],
						[
							-82.6195243599999,
							27.788071840000043
						],
						[
							-82.61959161399994,
							27.788097552000067
						],
						[
							-82.61965659499992,
							27.78812856500008
						],
						[
							-82.61971888499994,
							27.78816467900009
						],
						[
							-82.61977808499995,
							27.78820566400009
						],
						[
							-82.61985508499993,
							27.788263664000056
						],
						[
							-82.61991686199991,
							27.788314665000087
						],
						[
							-82.61997385599994,
							27.788370961000055
						],
						[
							-82.62002561499992,
							27.788432105000084
						],
						[
							-82.6200766149999,
							27.788498105000087
						],
						[
							-82.6201162189999,
							27.78855358000004
						],
						[
							-82.62015150699995,
							27.788611895000088
						],
						[
							-82.62018227699991,
							27.788672715000075
						],
						[
							-82.6202083529999,
							27.78873569100006
						],
						[
							-82.6202295839999,
							27.78880046000006
						],
						[
							-82.62024584799991,
							27.78886665200008
						],
						[
							-82.62028784799992,
							27.789070653000067
						],
						[
							-82.62029668499991,
							27.78912069800009
						],
						[
							-82.62035345099991,
							27.789505338000083
						],
						[
							-82.62037583499995,
							27.789499341000067
						],
						[
							-82.62053199999991,
							27.789485678000062
						],
						[
							-82.6205819999999,
							27.789485678000062
						],
						[
							-82.62066162899993,
							27.78948921000006
						],
						[
							-82.62070662899993,
							27.789493211000035
						],
						[
							-82.62078316599991,
							27.78950334100006
						],
						[
							-82.62091218099994,
							27.789534870000068
						],
						[
							-82.62141417799995,
							27.789448649000065
						],
						[
							-82.6223336189999,
							27.78971550400007
						],
						[
							-82.62325683699993,
							27.789914630000055
						],
						[
							-82.62372749699996,
							27.79024047100006
						],
						[
							-82.62401808499993,
							27.790810804000046
						],
						[
							-82.62397600799994,
							27.79098042700008
						],
						[
							-82.62396106299991,
							27.791155493000076
						],
						[
							-82.62393532599992,
							27.791305522000073
						],
						[
							-82.6238484289999,
							27.791639390000057
						],
						[
							-82.6238415229999,
							27.79167668200006
						],
						[
							-82.62393359899994,
							27.79169261000004
						],
						[
							-82.62425159899993,
							27.791696451000064
						],
						[
							-82.6249426199999,
							27.791667502000053
						],
						[
							-82.62534997499995,
							27.79162789800006
						],
						[
							-82.62543076899993,
							27.79162369900007
						],
						[
							-82.6255314849999,
							27.79162457600006
						],
						[
							-82.62631612799993,
							27.792322237000068
						],
						[
							-82.62694970899992,
							27.792847204000054
						],
						[
							-82.62754708499995,
							27.792829102000045
						],
						[
							-82.62852460999994,
							27.792829102000045
						],
						[
							-82.62937541899994,
							27.79304633000004
						],
						[
							-82.62991848899992,
							27.793444581000074
						],
						[
							-82.63025078699991,
							27.794005410000068
						],
						[
							-82.6302417899999,
							27.794106626000087
						],
						[
							-82.63023044099992,
							27.794189926000058
						],
						[
							-82.63020243999995,
							27.794341925000083
						],
						[
							-82.63017052399995,
							27.79444794300008
						],
						[
							-82.6302789739999,
							27.794523086000083
						],
						[
							-82.63038297399993,
							27.794606085000055
						],
						[
							-82.63043196099994,
							27.794648145000053
						],
						[
							-82.63047780399995,
							27.79469361200006
						],
						[
							-82.6305202659999,
							27.79474225000007
						],
						[
							-82.63055912999994,
							27.794793810000044
						],
						[
							-82.6306241289999,
							27.794886811000083
						],
						[
							-82.63066583499995,
							27.79495233900008
						],
						[
							-82.63070782199993,
							27.795038334000083
						],
						[
							-82.63085860599995,
							27.79501782400007
						],
						[
							-82.63093779299993,
							27.795013822000044
						],
						[
							-82.63160200399994,
							27.795291017000068
						],
						[
							-82.63214507299995,
							27.79570737000006
						],
						[
							-82.63232609599993,
							27.796141825000063
						],
						[
							-82.63243470999994,
							27.796938327000078
						],
						[
							-82.63236392099994,
							27.797974073000034
						],
						[
							-82.63234004499994,
							27.798001388000046
						],
						[
							-82.63206604499993,
							27.798302389000074
						],
						[
							-82.63197907299991,
							27.79838592100009
						],
						[
							-82.63192745599991,
							27.798426126000038
						],
						[
							-82.6307222769999,
							27.79929620300004
						],
						[
							-82.63015581499991,
							27.79968869600009
						],
						[
							-82.62998570399992,
							27.79982799900006
						],
						[
							-82.63039927199992,
							27.800135287000046
						],
						[
							-82.63051719899994,
							27.80020761600008
						],
						[
							-82.63056717199993,
							27.800225595000086
						],
						[
							-82.6303457869999,
							27.801104068000086
						],
						[
							-82.63034656899993,
							27.801416372000062
						],
						[
							-82.63033999999993,
							27.80162000000007
						],
						[
							-82.63033566699994,
							27.801767316000053
						],
						[
							-82.63033071699994,
							27.801935618000073
						],
						[
							-82.6303299999999,
							27.80215000000004
						],
						[
							-82.63033222199994,
							27.802347762000068
						],
						[
							-82.63033445299993,
							27.80254628000006
						],
						[
							-82.6303368589999,
							27.802760412000055
						],
						[
							-82.63033999999993,
							27.80304000000007
						],
						[
							-82.6298413529999,
							27.803035063000042
						],
						[
							-82.62926091499992,
							27.803031470000064
						],
						[
							-82.62885999999992,
							27.80304000000007
						],
						[
							-82.62832943899991,
							27.803044113000055
						],
						[
							-82.62774899899995,
							27.803048612000055
						],
						[
							-82.62756999999993,
							27.80305000000004
						],
						[
							-82.62756999999993,
							27.803539216000047
						],
						[
							-82.62746326799993,
							27.80354733900009
						],
						[
							-82.6272930419999,
							27.80356607400006
						],
						[
							-82.62700695599995,
							27.803585804000083
						],
						[
							-82.62671100599994,
							27.803664724000043
						],
						[
							-82.62624734999991,
							27.803832429000067
						],
						[
							-82.62553706999995,
							27.803881754000088
						],
						[
							-82.6247577339999,
							27.80389161900007
						],
						[
							-82.6239192079999,
							27.80389161900007
						],
						[
							-82.6229934349999,
							27.80352026800006
						],
						[
							-82.62295408299991,
							27.80348091700006
						],
						[
							-82.62291669899992,
							27.803441002000056
						],
						[
							-82.6227190059999,
							27.803495256000076
						],
						[
							-82.62271376199995,
							27.803496678000045
						],
						[
							-82.62265644899992,
							27.803510042000084
						],
						[
							-82.62259838499995,
							27.80351962800006
						],
						[
							-82.62256485199993,
							27.80352340400009
						],
						[
							-82.62226585099995,
							27.803551404000075
						],
						[
							-82.62224081799991,
							27.803553397000087
						],
						[
							-82.62218199999995,
							27.80355532200008
						],
						[
							-82.62212318099995,
							27.803553397000087
						],
						[
							-82.62206579699995,
							27.803547783000056
						],
						[
							-82.62173579699993,
							27.80350478300005
						],
						[
							-82.62173461499992,
							27.80350462800004
						],
						[
							-82.62167655099995,
							27.803495042000065
						],
						[
							-82.62161923799994,
							27.803481678000082
						],
						[
							-82.6215629219999,
							27.803464595000037
						],
						[
							-82.6215297309999,
							27.803452597000046
						],
						[
							-82.62133173099994,
							27.803376597000067
						],
						[
							-82.62133103299993,
							27.80337631900005
						],
						[
							-82.62086105399993,
							27.803053093000074
						],
						[
							-82.6204269939999,
							27.80291498300005
						],
						[
							-82.61992387799995,
							27.802974173000052
						],
						[
							-82.61943062799992,
							27.803062958000055
						],
						[
							-82.6189965669999,
							27.803102418000037
						],
						[
							-82.61845399099991,
							27.803013633000035
						],
						[
							-82.61797060599991,
							27.802836063000086
						],
						[
							-82.61763519599992,
							27.802747278000083
						],
						[
							-82.61738594899992,
							27.802668992000065
						],
						[
							-82.61739823999994,
							27.802662422000083
						],
						[
							-82.61741492499993,
							27.80265440700009
						],
						[
							-82.61745095899994,
							27.802637550000043
						],
						[
							-82.61745040499994,
							27.802636078000035
						],
						[
							-82.6174333219999,
							27.80257976200005
						],
						[
							-82.61741995799991,
							27.802522449000037
						],
						[
							-82.61741037199994,
							27.802464385000064
						],
						[
							-82.6174046029999,
							27.802405819000057
						],
						[
							-82.6174026779999,
							27.802347000000054
						],
						[
							-82.6174046029999,
							27.80228818200004
						],
						[
							-82.61740952299994,
							27.80223625600007
						],
						[
							-82.6174265219999,
							27.80209925600008
						],
						[
							-82.61742737199995,
							27.80209261500005
						],
						[
							-82.61743695799993,
							27.80203455100008
						],
						[
							-82.61745032099992,
							27.801977239000053
						],
						[
							-82.6174674049999,
							27.801920923000072
						],
						[
							-82.61748813499992,
							27.801865845000066
						],
						[
							-82.61751242199995,
							27.80181224000006
						],
						[
							-82.61751462199993,
							27.80180781100006
						],
						[
							-82.61755562199994,
							27.801725811000043
						],
						[
							-82.61758116399994,
							27.801678339000095
						],
						[
							-82.6176122409999,
							27.801628364000067
						],
						[
							-82.61764651999994,
							27.801580527000056
						],
						[
							-82.61768385399995,
							27.801535036000075
						],
						[
							-82.61772408299993,
							27.801492083000085
						],
						[
							-82.61776703599992,
							27.801451854000053
						],
						[
							-82.6178125269999,
							27.801414520000037
						],
						[
							-82.61783642699993,
							27.80139680200006
						],
						[
							-82.61791742699995,
							27.80133880200009
						],
						[
							-82.61794136299994,
							27.801322241000037
						],
						[
							-82.61798645399995,
							27.801294005000045
						],
						[
							-82.6179863719999,
							27.801293385000065
						],
						[
							-82.61798060399991,
							27.801234819000058
						],
						[
							-82.61797867799993,
							27.801176000000055
						],
						[
							-82.6179801639999,
							27.80112433000005
						],
						[
							-82.61798816299995,
							27.80098533000006
						],
						[
							-82.61798860299992,
							27.80097818200005
						],
						[
							-82.61799437199994,
							27.800919615000055
						],
						[
							-82.61800395799992,
							27.800861551000082
						],
						[
							-82.61801732099991,
							27.80080423800007
						],
						[
							-82.61803252699991,
							27.80075411300004
						],
						[
							-82.61800716899995,
							27.80075646800009
						],
						[
							-82.61798281799992,
							27.80075839600005
						],
						[
							-82.6179239999999,
							27.800760322000087
						],
						[
							-82.6178651809999,
							27.80075839600005
						],
						[
							-82.61782620299994,
							27.80075498900004
						],
						[
							-82.61700780599995,
							27.80066546100005
						],
						[
							-82.61623937099995,
							27.80062052900007
						],
						[
							-82.61519929199994,
							27.80066830700008
						],
						[
							-82.61485134899993,
							27.800719489000073
						],
						[
							-82.61483799499992,
							27.80087429400004
						],
						[
							-82.61483362899992,
							27.800914385000056
						],
						[
							-82.61482420999994,
							27.800971605000086
						],
						[
							-82.61477762599992,
							27.801206972000045
						],
						[
							-82.61436601899993,
							27.801551780000068
						],
						[
							-82.6138807769999,
							27.801976366000076
						],
						[
							-82.61342586299992,
							27.80250204400005
						],
						[
							-82.61307204199994,
							27.802845757000057
						],
						[
							-82.61281931199996,
							27.803068159000077
						],
						[
							-82.61249581699991,
							27.803472527000054
						],
						[
							-82.61212177699991,
							27.803856677000056
						],
						[
							-82.6116062079999,
							27.804362136000066
						],
						[
							-82.61119173099992,
							27.804928251000035
						],
						[
							-82.6109118139999,
							27.805268870000077
						],
						[
							-82.6108979999999,
							27.805269322000072
						],
						[
							-82.61083918199995,
							27.80526739600009
						],
						[
							-82.6107806149999,
							27.80526162800004
						],
						[
							-82.61072255099992,
							27.805252042000063
						],
						[
							-82.6106652389999,
							27.805238678000084
						],
						[
							-82.61060892299992,
							27.805221595000035
						],
						[
							-82.61060698799992,
							27.805220936000072
						],
						[
							-82.61037598799993,
							27.80514193600004
						],
						[
							-82.61032284399994,
							27.805121865000046
						],
						[
							-82.6103019489999,
							27.80511289900005
						],
						[
							-82.60991694899991,
							27.804941899000085
						],
						[
							-82.60988423999993,
							27.80492657800005
						],
						[
							-82.60983233899992,
							27.804898836000067
						],
						[
							-82.60978236299992,
							27.804867759000047
						],
						[
							-82.60973452699994,
							27.80483348000007
						],
						[
							-82.6096890359999,
							27.804796146000058
						],
						[
							-82.60964608299992,
							27.80475591700008
						],
						[
							-82.60960585399994,
							27.80471296400009
						],
						[
							-82.6095724299999,
							27.80467253200004
						],
						[
							-82.60938243099991,
							27.804428532000088
						],
						[
							-82.60937851999995,
							27.804423472000053
						],
						[
							-82.60934424099992,
							27.80437563600009
						],
						[
							-82.6093131639999,
							27.804325661000064
						],
						[
							-82.60930478099993,
							27.80431081800009
						],
						[
							-82.60915562699995,
							27.804040781000083
						],
						[
							-82.60927953099991,
							27.803654859000062
						],
						[
							-82.60927953099991,
							27.80333917900009
						],
						[
							-82.60924007099993,
							27.802993903000072
						],
						[
							-82.60895690599995,
							27.802541732000066
						],
						[
							-82.60838078699993,
							27.80115226800007
						]
					],
					[
						[
							-82.62793149799991,
							27.795830696000053
						],
						[
							-82.62795748499991,
							27.795539064000085
						],
						[
							-82.62790603299993,
							27.795545470000036
						],
						[
							-82.62780405099994,
							27.795574035000072
						],
						[
							-82.62779897999991,
							27.79560061600006
						],
						[
							-82.62780239499996,
							27.795635364000077
						],
						[
							-82.62782295999995,
							27.795703468000056
						],
						[
							-82.62785843199993,
							27.795785471000045
						],
						[
							-82.62787067799991,
							27.795802820000063
						],
						[
							-82.62793149799991,
							27.795830696000053
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Snell Isle",
				"RegionID": "417175"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.6386599999999,
					27.799370000000067,
					-82.61531514099994,
					27.813920000000053
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.63447999999994,
							27.813920000000053
						],
						[
							-82.63447999999994,
							27.813446399000046
						],
						[
							-82.63084017999995,
							27.81347017300004
						],
						[
							-82.63035999999994,
							27.81347017300004
						],
						[
							-82.62789218199993,
							27.81347017300004
						],
						[
							-82.6263706339999,
							27.81349394700004
						],
						[
							-82.62411208799995,
							27.81349394700004
						],
						[
							-82.6213542829999,
							27.813517722000086
						],
						[
							-82.61833095799994,
							27.813517722000086
						],
						[
							-82.61795835299995,
							27.81350658200006
						],
						[
							-82.61726870199993,
							27.813450664000072
						],
						[
							-82.61665360799992,
							27.813348149000035
						],
						[
							-82.61607579299994,
							27.813115159000063
						],
						[
							-82.61603851399991,
							27.812658498000076
						],
						[
							-82.61606647299993,
							27.81209932200005
						],
						[
							-82.61619694799992,
							27.81146558900008
						],
						[
							-82.61608511199995,
							27.811092805000047
						],
						[
							-82.61603355099993,
							27.810705683000037
						],
						[
							-82.61603355099993,
							27.810354072000052
						],
						[
							-82.6161864259999,
							27.80977315000007
						],
						[
							-82.6164004499999,
							27.80943682600008
						],
						[
							-82.61612527599993,
							27.809161653000046
						],
						[
							-82.61598768899997,
							27.808611305000056
						],
						[
							-82.61598768899997,
							27.808351419000076
						],
						[
							-82.61606412599991,
							27.807984521000037
						],
						[
							-82.61614056299993,
							27.807724634000067
						],
						[
							-82.61568193999994,
							27.807403598000064
						],
						[
							-82.61531514099994,
							27.806162124000082
						],
						[
							-82.61554879399995,
							27.806080699000063
						],
						[
							-82.61609469099994,
							27.80574709600006
						],
						[
							-82.61645862199993,
							27.80521130900007
						],
						[
							-82.61683266199992,
							27.804695740000057
						],
						[
							-82.61700451799993,
							27.804250935000084
						],
						[
							-82.61712582899992,
							27.803634274000046
						],
						[
							-82.61727746699995,
							27.80308837800004
						],
						[
							-82.61738594899992,
							27.802668992000065
						],
						[
							-82.61763519599992,
							27.802747278000083
						],
						[
							-82.61797060599991,
							27.802836063000086
						],
						[
							-82.61845399099991,
							27.803013633000035
						],
						[
							-82.6189965669999,
							27.803102418000037
						],
						[
							-82.61943062799992,
							27.803062958000055
						],
						[
							-82.61992387799995,
							27.802974173000052
						],
						[
							-82.6204269939999,
							27.80291498300005
						],
						[
							-82.62086105399993,
							27.803053093000074
						],
						[
							-82.62133103299993,
							27.80337631900005
						],
						[
							-82.62134783599993,
							27.803403339000056
						],
						[
							-82.62137557699992,
							27.803455240000062
						],
						[
							-82.62139986499994,
							27.803508845000067
						],
						[
							-82.6214205949999,
							27.80356392300007
						],
						[
							-82.62143767799995,
							27.803620239000054
						],
						[
							-82.62145104199993,
							27.803677551000078
						],
						[
							-82.62146062799991,
							27.80373561500005
						],
						[
							-82.62146527199991,
							27.803779000000077
						],
						[
							-82.62147427199994,
							27.803888000000086
						],
						[
							-82.62147539599994,
							27.803903182000056
						],
						[
							-82.62147732199992,
							27.80396200000007
						],
						[
							-82.62147694399994,
							27.80398805200008
						],
						[
							-82.6214745069999,
							27.80407216800006
						],
						[
							-82.62158000999995,
							27.804052401000035
						],
						[
							-82.6216967169999,
							27.803932561000067
						],
						[
							-82.62170508299995,
							27.803924083000084
						],
						[
							-82.62174803599993,
							27.80388385400005
						],
						[
							-82.62179352699991,
							27.80384652000004
						],
						[
							-82.62184136299993,
							27.80381224100006
						],
						[
							-82.62189133899996,
							27.803781164000043
						],
						[
							-82.62194323999995,
							27.803753422000057
						],
						[
							-82.62198099199992,
							27.803735879000048
						],
						[
							-82.62217099199995,
							27.803652880000072
						],
						[
							-82.62218684399994,
							27.803646135000065
						],
						[
							-82.62224192199994,
							27.803625405000048
						],
						[
							-82.62229823799993,
							27.803608322000063
						],
						[
							-82.62232763599991,
							27.803600974000062
						],
						[
							-82.62260763599994,
							27.80353597300007
						],
						[
							-82.62263555099992,
							27.803529958000073
						],
						[
							-82.62269361499995,
							27.803520372000037
						],
						[
							-82.62275218199994,
							27.803514604000043
						],
						[
							-82.6228109999999,
							27.80351267800006
						],
						[
							-82.6228532749999,
							27.803513672000065
						],
						[
							-82.6229934349999,
							27.80352026800006
						],
						[
							-82.6239192079999,
							27.80389161900007
						],
						[
							-82.6247577339999,
							27.80389161900007
						],
						[
							-82.62553706999995,
							27.803881754000088
						],
						[
							-82.62624734999991,
							27.803832429000067
						],
						[
							-82.62671100599994,
							27.803664724000043
						],
						[
							-82.62700695599995,
							27.803585804000083
						],
						[
							-82.6272930419999,
							27.80356607400006
						],
						[
							-82.62746326799993,
							27.80354733900009
						],
						[
							-82.62756999999993,
							27.803539216000047
						],
						[
							-82.62756999999993,
							27.80305000000004
						],
						[
							-82.62774899899995,
							27.803048612000055
						],
						[
							-82.62832943899991,
							27.803044113000055
						],
						[
							-82.62885999999992,
							27.80304000000007
						],
						[
							-82.62926091499992,
							27.803031470000064
						],
						[
							-82.6298413529999,
							27.803035063000042
						],
						[
							-82.63033999999993,
							27.80304000000007
						],
						[
							-82.6303368589999,
							27.802760412000055
						],
						[
							-82.63033445299993,
							27.80254628000006
						],
						[
							-82.63033222199994,
							27.802347762000068
						],
						[
							-82.6303299999999,
							27.80215000000004
						],
						[
							-82.63033071699994,
							27.801935618000073
						],
						[
							-82.63033566699994,
							27.801767316000053
						],
						[
							-82.63033999999993,
							27.80162000000007
						],
						[
							-82.63034656899993,
							27.801416372000062
						],
						[
							-82.6303457869999,
							27.801104068000086
						],
						[
							-82.63056717199993,
							27.800225595000086
						],
						[
							-82.63063837899995,
							27.80025121300008
						],
						[
							-82.63087450499995,
							27.80025888700004
						],
						[
							-82.63122443899994,
							27.80023697100006
						],
						[
							-82.63137824099994,
							27.80010765500009
						],
						[
							-82.6314323069999,
							27.800065604000054
						],
						[
							-82.6319223079999,
							27.79971360400009
						],
						[
							-82.63197704999993,
							27.79967723600004
						],
						[
							-82.63203904999995,
							27.799639236000075
						],
						[
							-82.63209550099992,
							27.799607377000086
						],
						[
							-82.63215410099991,
							27.799579667000046
						],
						[
							-82.63221454399991,
							27.79955624900009
						],
						[
							-82.63227651799991,
							27.799537247000046
						],
						[
							-82.63241851799995,
							27.799499247000085
						],
						[
							-82.63252656799995,
							27.79947732800008
						],
						[
							-82.63258379099994,
							27.79946598300006
						],
						[
							-82.63257831399994,
							27.799400036000065
						],
						[
							-82.6334809999999,
							27.79939900000005
						],
						[
							-82.63348157399992,
							27.79940531200009
						],
						[
							-82.63399567599994,
							27.799393356000053
						],
						[
							-82.63474753499992,
							27.79938763000007
						],
						[
							-82.63539637199995,
							27.79938278800006
						],
						[
							-82.63614874399991,
							27.799380000000042
						],
						[
							-82.6367974229999,
							27.799380000000042
						],
						[
							-82.63749804799994,
							27.799376986000084
						],
						[
							-82.6379910199999,
							27.79937351400008
						],
						[
							-82.63860999999991,
							27.799370000000067
						],
						[
							-82.63860999999991,
							27.799730028000056
						],
						[
							-82.63860999999991,
							27.79994654400008
						],
						[
							-82.63860999999991,
							27.800280000000043
						],
						[
							-82.63860999999991,
							27.80056000700006
						],
						[
							-82.63860999999991,
							27.800812609000047
						],
						[
							-82.63860999999991,
							27.801190000000076
						],
						[
							-82.63861502899994,
							27.80164258900004
						],
						[
							-82.63861999999995,
							27.802090000000078
						],
						[
							-82.63862611799993,
							27.802652878000064
						],
						[
							-82.63862999999992,
							27.803010000000086
						],
						[
							-82.63862343199992,
							27.803627409000057
						],
						[
							-82.63861999999995,
							27.803950000000043
						],
						[
							-82.63862517699994,
							27.80442110300004
						],
						[
							-82.63862999999992,
							27.804860000000076
						],
						[
							-82.63863346499994,
							27.805178821000084
						],
						[
							-82.63863739199991,
							27.805540031000078
						],
						[
							-82.6386399999999,
							27.806153343000066
						],
						[
							-82.6386399999999,
							27.80666000000008
						],
						[
							-82.6386399999999,
							27.806956049000064
						],
						[
							-82.6386399999999,
							27.807312662000076
						],
						[
							-82.6386399999999,
							27.80756000000008
						],
						[
							-82.6386399999999,
							27.807930790000057
						],
						[
							-82.6386399999999,
							27.808311177000064
						],
						[
							-82.6386399999999,
							27.808460000000082
						],
						[
							-82.63864202199994,
							27.808643972000084
						],
						[
							-82.63864489499991,
							27.808905457000037
						],
						[
							-82.63864698799995,
							27.80909588800006
						],
						[
							-82.63864999999993,
							27.80937000000006
						],
						[
							-82.63864999999993,
							27.809594983000068
						],
						[
							-82.63864999999993,
							27.81007046600007
						],
						[
							-82.63864999999993,
							27.81030000000004
						],
						[
							-82.63864999999993,
							27.810641046000057
						],
						[
							-82.63864999999993,
							27.811045207000063
						],
						[
							-82.63864999999993,
							27.811210000000074
						],
						[
							-82.63865562899991,
							27.811710954000095
						],
						[
							-82.63865803299991,
							27.811924895000065
						],
						[
							-82.6386599999999,
							27.812100000000044
						],
						[
							-82.63865702699991,
							27.812376509000046
						],
						[
							-82.6386534479999,
							27.81270930900007
						],
						[
							-82.63864999999993,
							27.813030000000083
						],
						[
							-82.63865147399991,
							27.81316122600009
						],
						[
							-82.6386557479999,
							27.813541565000037
						],
						[
							-82.63865788499993,
							27.813731734000044
						],
						[
							-82.6386599999999,
							27.813920000000053
						],
						[
							-82.6383523799999,
							27.813902944000063
						],
						[
							-82.63794870099991,
							27.81389494800004
						],
						[
							-82.63771100399993,
							27.81389171400008
						],
						[
							-82.6373779029999,
							27.813887182000087
						],
						[
							-82.63695004699991,
							27.813881361000085
						],
						[
							-82.63666520999993,
							27.813885775000074
						],
						[
							-82.63652999999994,
							27.81389000000007
						],
						[
							-82.63628474799992,
							27.813893589000088
						],
						[
							-82.63576182799994,
							27.813901242000043
						],
						[
							-82.63542836499995,
							27.81390612100006
						],
						[
							-82.63497675199994,
							27.813912730000084
						],
						[
							-82.63464398499991,
							27.81391760000008
						],
						[
							-82.63447999999994,
							27.813920000000053
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "North East Park",
				"RegionID": "417176"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.6288485689999,
					27.84279275700004,
					-82.61610267799995,
					27.84801071600009
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.6199926509999,
							27.846963994000077
						],
						[
							-82.61944893599991,
							27.84687302000009
						],
						[
							-82.61922341899992,
							27.84705375900006
						],
						[
							-82.61911066099992,
							27.84713083600008
						],
						[
							-82.61903625399992,
							27.847169291000057
						],
						[
							-82.61877925399995,
							27.847287291000043
						],
						[
							-82.6187115859999,
							27.847315086000037
						],
						[
							-82.61857897099992,
							27.847352137000087
						],
						[
							-82.61832756799993,
							27.847401898000047
						],
						[
							-82.61816199999993,
							27.84741732200007
						],
						[
							-82.61810355999995,
							27.84741542200004
						],
						[
							-82.61788855999993,
							27.847401421000086
						],
						[
							-82.61781346999993,
							27.847393353000086
						],
						[
							-82.61773932199992,
							27.84737901400007
						],
						[
							-82.61766663799995,
							27.847358504000056
						],
						[
							-82.61759593099993,
							27.84733196800005
						],
						[
							-82.61752769999993,
							27.84729959200007
						],
						[
							-82.61745554399994,
							27.847261559000064
						],
						[
							-82.61738638799994,
							27.847225525000056
						],
						[
							-82.61735233899992,
							27.847206835000065
						],
						[
							-82.61722392699994,
							27.847116920000076
						],
						[
							-82.61711307999991,
							27.84700607300005
						],
						[
							-82.61702316499992,
							27.846877661000065
						],
						[
							-82.6169569139999,
							27.84673558600008
						],
						[
							-82.61693425599992,
							27.846664221000083
						],
						[
							-82.61688525599993,
							27.846484221000082
						],
						[
							-82.61686804399994,
							27.84640810600007
						],
						[
							-82.61684198699993,
							27.846264077000058
						],
						[
							-82.61675913199991,
							27.846124726000085
						],
						[
							-82.6166899129999,
							27.84597758600006
						],
						[
							-82.61665639099994,
							27.84586190500005
						],
						[
							-82.61658989299991,
							27.845557455000062
						],
						[
							-82.61654086099993,
							27.845437006000054
						],
						[
							-82.61644633399993,
							27.845332603000088
						],
						[
							-82.61639707799992,
							27.845273275000068
						],
						[
							-82.6163530849999,
							27.845209946000068
						],
						[
							-82.61631467899993,
							27.84514308100006
						],
						[
							-82.61620367899991,
							27.84492908100009
						],
						[
							-82.61617322899993,
							27.844864168000072
						],
						[
							-82.61614804699991,
							27.844797036000045
						],
						[
							-82.61612829299992,
							27.844728110000062
						],
						[
							-82.61611409299991,
							27.844657831000063
						],
						[
							-82.6161055359999,
							27.84458664300007
						],
						[
							-82.61610267799995,
							27.844515000000058
						],
						[
							-82.61610267799995,
							27.844265000000068
						],
						[
							-82.61611634099995,
							27.844108834000053
						],
						[
							-82.61612504199991,
							27.844065691000083
						],
						[
							-82.61617349399995,
							27.843867094000075
						],
						[
							-82.61648646499994,
							27.84349047900008
						],
						[
							-82.61720986499995,
							27.84293206500007
						],
						[
							-82.61789519099995,
							27.842919374000076
						],
						[
							-82.61858632999993,
							27.84279275700004
						],
						[
							-82.61870073499995,
							27.842805772000077
						],
						[
							-82.61884828899991,
							27.84282441600004
						],
						[
							-82.61986699999994,
							27.84299400000009
						],
						[
							-82.61986411099991,
							27.842983609000044
						],
						[
							-82.62313326399993,
							27.842959303000043
						],
						[
							-82.62672610699991,
							27.843036019000067
						],
						[
							-82.62872944399994,
							27.843088426000065
						],
						[
							-82.6288485689999,
							27.843828746000042
						],
						[
							-82.62801540499993,
							27.844344927000066
						],
						[
							-82.6231413459999,
							27.84736461300008
						],
						[
							-82.6220984759999,
							27.84801071600009
						],
						[
							-82.6220599369999,
							27.847998073000042
						],
						[
							-82.62199590299991,
							27.847971443000063
						],
						[
							-82.62131390399992,
							27.847656443000062
						],
						[
							-82.6212507859999,
							27.847624214000064
						],
						[
							-82.62119040199991,
							27.847587116000057
						],
						[
							-82.62113312699996,
							27.847545378000063
						],
						[
							-82.6210793159999,
							27.847499260000063
						],
						[
							-82.62074802199993,
							27.847191873000043
						],
						[
							-82.62059383899992,
							27.847091654000057
						],
						[
							-82.62044382999994,
							27.847052029000054
						],
						[
							-82.6199926509999,
							27.846963994000077
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Caya Costa",
				"RegionID": "417190"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.63465831699995,
					27.839295854000056,
					-82.61880867999992,
					27.843088426000065
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.62672610699991,
							27.843036019000067
						],
						[
							-82.62313326399993,
							27.842959303000043
						],
						[
							-82.61986411099991,
							27.842983609000044
						],
						[
							-82.61986699999994,
							27.84299400000009
						],
						[
							-82.61884828899991,
							27.84282441600004
						],
						[
							-82.61883134099992,
							27.84276116500007
						],
						[
							-82.61881871899993,
							27.842648241000063
						],
						[
							-82.61881716099992,
							27.842615891000037
						],
						[
							-82.61880867999992,
							27.842270788000064
						],
						[
							-82.61900897399994,
							27.84198703900006
						],
						[
							-82.61915084899994,
							27.841519686000083
						],
						[
							-82.61945963499994,
							27.84139450300006
						],
						[
							-82.61986022299993,
							27.84131104700009
						],
						[
							-82.62021908299994,
							27.841185863000078
						],
						[
							-82.62060297999994,
							27.841002260000042
						],
						[
							-82.62083665599994,
							27.840910459000042
						],
						[
							-82.62110371499995,
							27.840852040000073
						],
						[
							-82.62122055299994,
							27.84067678300005
						],
						[
							-82.6212956629999,
							27.84030123200006
						],
						[
							-82.62133739099994,
							27.839959063000038
						],
						[
							-82.62130400799992,
							27.83978380600007
						],
						[
							-82.6212429489999,
							27.839713105000044
						],
						[
							-82.62139831099995,
							27.83960748900006
						],
						[
							-82.62142816699992,
							27.839556306000077
						],
						[
							-82.62151243099993,
							27.83944906100004
						],
						[
							-82.62171159999991,
							27.839380118000065
						],
						[
							-82.62302151999995,
							27.839357137000036
						],
						[
							-82.6251817399999,
							27.839295854000056
						],
						[
							-82.62646101799993,
							27.839364797000087
						],
						[
							-82.62716577099991,
							27.83934947700004
						],
						[
							-82.62770199499994,
							27.839464382000074
						],
						[
							-82.6301839489999,
							27.839418420000072
						],
						[
							-82.63301827899996,
							27.839395439000043
						],
						[
							-82.63448906699995,
							27.839380118000065
						],
						[
							-82.6346476459999,
							27.839345080000044
						],
						[
							-82.63464816599992,
							27.839434483000048
						],
						[
							-82.63464920599995,
							27.839613427000074
						],
						[
							-82.63464999999991,
							27.839750000000038
						],
						[
							-82.63464999999991,
							27.83997134400005
						],
						[
							-82.63464999999991,
							27.840467524000076
						],
						[
							-82.63464999999991,
							27.84088236300005
						],
						[
							-82.63464999999991,
							27.84120000000007
						],
						[
							-82.63465074299995,
							27.841264617000036
						],
						[
							-82.63465233199992,
							27.841402878000054
						],
						[
							-82.63465382899994,
							27.84153310000005
						],
						[
							-82.63465681999992,
							27.841793357000086
						],
						[
							-82.63465831699995,
							27.84192357900008
						],
						[
							-82.63465753199995,
							27.842102081000068
						],
						[
							-82.63464757999992,
							27.84223146100004
						],
						[
							-82.63463944599994,
							27.842337204000046
						],
						[
							-82.63463312999994,
							27.84241931100007
						],
						[
							-82.6346299999999,
							27.842460000000077
						],
						[
							-82.63461990399992,
							27.84255692000005
						],
						[
							-82.63460556699994,
							27.842694553000058
						],
						[
							-82.6345917189999,
							27.842827493000073
						],
						[
							-82.63458324999993,
							27.842908799000043
						],
						[
							-82.63456411699991,
							27.843011474000036
						],
						[
							-82.63455999999991,
							27.843030000000056
						],
						[
							-82.6344431359999,
							27.843032385000072
						],
						[
							-82.63408505299992,
							27.843039693000037
						],
						[
							-82.63353207299991,
							27.84303643800007
						],
						[
							-82.63332059499994,
							27.84303503700005
						],
						[
							-82.6331985349999,
							27.843034229000068
						],
						[
							-82.63269424299996,
							27.84303088900009
						],
						[
							-82.63229573599995,
							27.84303374800004
						],
						[
							-82.63207604399993,
							27.843036865000048
						],
						[
							-82.63162875799992,
							27.843043209000086
						],
						[
							-82.63147424099992,
							27.84304540100004
						],
						[
							-82.63097795499993,
							27.843050000000062
						],
						[
							-82.6303516289999,
							27.843050000000062
						],
						[
							-82.63001812999994,
							27.843050000000062
						],
						[
							-82.62979042599994,
							27.843051006000053
						],
						[
							-82.62959522699992,
							27.843052978000063
						],
						[
							-82.62933496199992,
							27.843055606000064
						],
						[
							-82.62912349699991,
							27.843057742000042
						],
						[
							-82.6289444009999,
							27.843059552000057
						],
						[
							-82.62882150199994,
							27.84307308300004
						],
						[
							-82.62872944399994,
							27.843088426000065
						],
						[
							-82.62672610699991,
							27.843036019000067
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "North East Terraces",
				"RegionID": "417191"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.62859999999995,
					27.844344927000066,
					-82.6220984759999,
					27.85168417400007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.6231413459999,
							27.84736461300008
						],
						[
							-82.62801540499993,
							27.844344927000066
						],
						[
							-82.62848595899993,
							27.84487194700006
						],
						[
							-82.62859999999995,
							27.845300000000066
						],
						[
							-82.62853321999995,
							27.84533710000005
						],
						[
							-82.6284376509999,
							27.84539672600005
						],
						[
							-82.62830017199991,
							27.845485514000078
						],
						[
							-82.62810834999995,
							27.845609399000068
						],
						[
							-82.62787531599992,
							27.84576918900007
						],
						[
							-82.62782164999993,
							27.84581835000006
						],
						[
							-82.62777007599993,
							27.845884717000047
						],
						[
							-82.62773596999995,
							27.845928927000045
						],
						[
							-82.62766952099992,
							27.846015065000074
						],
						[
							-82.62760995699995,
							27.84609227800007
						],
						[
							-82.62754999999993,
							27.846170000000086
						],
						[
							-82.6275123929999,
							27.846197161000077
						],
						[
							-82.62748616099992,
							27.846216106000043
						],
						[
							-82.62742608299993,
							27.846259496000076
						],
						[
							-82.62734522499994,
							27.84631135500007
						],
						[
							-82.62727539899993,
							27.84634335900006
						],
						[
							-82.62712880799995,
							27.84641066200004
						],
						[
							-82.62703999999991,
							27.846460000000036
						],
						[
							-82.62711225599993,
							27.84654592600009
						],
						[
							-82.62722395199995,
							27.84667875400004
						],
						[
							-82.62733473899993,
							27.84681050100005
						],
						[
							-82.6274706399999,
							27.846977484000035
						],
						[
							-82.62758999999994,
							27.84713000000005
						],
						[
							-82.62764571699995,
							27.84720193900006
						],
						[
							-82.62772843399995,
							27.847308738000038
						],
						[
							-82.62791014699991,
							27.847543355000084
						],
						[
							-82.62810742499994,
							27.847798068000092
						],
						[
							-82.62823067499994,
							27.847957201000042
						],
						[
							-82.6283358309999,
							27.848092972000074
						],
						[
							-82.6284943199999,
							27.848315765000056
						],
						[
							-82.62859999999995,
							27.848470000000077
						],
						[
							-82.62844327199991,
							27.848563057000035
						],
						[
							-82.62818864699994,
							27.848718889000054
						],
						[
							-82.62791593399993,
							27.84889468700004
						],
						[
							-82.62769125499995,
							27.849039522000055
						],
						[
							-82.62754552799993,
							27.849133461000065
						],
						[
							-82.6274320039999,
							27.84920664200007
						],
						[
							-82.62719440299992,
							27.849359806000052
						],
						[
							-82.62685994499994,
							27.84957064400004
						],
						[
							-82.62644481099994,
							27.849828837000075
						],
						[
							-82.62617361899993,
							27.849994440000046
						],
						[
							-82.62590902199992,
							27.850148387000047
						],
						[
							-82.62576483899994,
							27.850232276000042
						],
						[
							-82.62562999999994,
							27.850310000000036
						],
						[
							-82.62545340799996,
							27.850427728000057
						],
						[
							-82.62525552299991,
							27.850559651000083
						],
						[
							-82.62505228999993,
							27.850695140000084
						],
						[
							-82.6247925959999,
							27.850862738000046
						],
						[
							-82.62467145599993,
							27.850948908000078
						],
						[
							-82.62451942299992,
							27.851062933000037
						],
						[
							-82.62434789999992,
							27.851206750000074
						],
						[
							-82.6242214639999,
							27.851326243000074
						],
						[
							-82.62410404799994,
							27.851463945000035
						],
						[
							-82.62402457799993,
							27.851568943000075
						],
						[
							-82.62393736199994,
							27.85168417400007
						],
						[
							-82.62337903699995,
							27.85141255700006
						],
						[
							-82.62292387699995,
							27.85124566500008
						],
						[
							-82.62297454499992,
							27.851191378000067
						],
						[
							-82.62302931799991,
							27.851139423000063
						],
						[
							-82.62304923499994,
							27.85107743900005
						],
						[
							-82.62307393099991,
							27.85101719800008
						],
						[
							-82.62310325399994,
							27.850959070000044
						],
						[
							-82.62313702599994,
							27.85090340800008
						],
						[
							-82.62317503899993,
							27.850850553000043
						],
						[
							-82.62324603899992,
							27.85075855300005
						],
						[
							-82.62332528699994,
							27.85066889600006
						],
						[
							-82.62352528699995,
							27.850470895000058
						],
						[
							-82.62360488799993,
							27.850400882000088
						],
						[
							-82.62376685999993,
							27.850274544000058
						],
						[
							-82.62332630899994,
							27.849531312000067
						],
						[
							-82.62283372999991,
							27.84896667600009
						],
						[
							-82.6227415539999,
							27.848837482000082
						],
						[
							-82.62261885899994,
							27.848628572000052
						],
						[
							-82.62255091399993,
							27.84848358700009
						],
						[
							-82.6225262879999,
							27.84840487100007
						],
						[
							-82.62243800999994,
							27.84806941100004
						],
						[
							-82.62226163299994,
							27.84804740000004
						],
						[
							-82.62219319799993,
							27.848036165000053
						],
						[
							-82.62212583299993,
							27.848019690000058
						],
						[
							-82.6220984759999,
							27.84801071600009
						],
						[
							-82.6231413459999,
							27.84736461300008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Renaissance",
				"RegionID": "417192"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.53519820799994,
					28.319084516000032,
					-81.521162,
					28.333016626000074
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.52258928899994,
							28.33300269800003
						],
						[
							-81.522576,
							28.333002
						],
						[
							-81.52257300000001,
							28.332855
						],
						[
							-81.522564,
							28.332773
						],
						[
							-81.52253487299998,
							28.332491443000038
						],
						[
							-81.52252800000001,
							28.332425
						],
						[
							-81.522413,
							28.332016
						],
						[
							-81.522187,
							28.331775
						],
						[
							-81.521937,
							28.331614
						],
						[
							-81.521694,
							28.331453
						],
						[
							-81.521505,
							28.33133
						],
						[
							-81.52133673099996,
							28.331063649000043
						],
						[
							-81.52133,
							28.331059
						],
						[
							-81.521274,
							28.330970000000004
						],
						[
							-81.521218,
							28.330575
						],
						[
							-81.521196,
							28.330407000000005
						],
						[
							-81.521162,
							28.330159
						],
						[
							-81.521236,
							28.328067000000004
						],
						[
							-81.521201,
							28.327614000000004
						],
						[
							-81.521213,
							28.326067
						],
						[
							-81.521204,
							28.325107
						],
						[
							-81.521174,
							28.324141
						],
						[
							-81.52119011299999,
							28.323336109000024
						],
						[
							-81.521195,
							28.323092
						],
						[
							-81.521206,
							28.320337000000002
						],
						[
							-81.52446093399999,
							28.31919873000004
						],
						[
							-81.52672618099996,
							28.319084516000032
						],
						[
							-81.53188485299995,
							28.31988401500007
						],
						[
							-81.53348384999998,
							28.32079772800006
						],
						[
							-81.53361709999996,
							28.322073119000038
						],
						[
							-81.53394070699994,
							28.32401476000007
						],
						[
							-81.53443563499997,
							28.325309186000027
						],
						[
							-81.53519820799994,
							28.326803659000063
						],
						[
							-81.53479731299996,
							28.32685107700007
						],
						[
							-81.53268435199999,
							28.327269862000037
						],
						[
							-81.53098217999997,
							28.32781307700003
						],
						[
							-81.52914333299998,
							28.32852881900004
						],
						[
							-81.52717313899996,
							28.329528193000044
						],
						[
							-81.52514583799996,
							28.330984423000075
						],
						[
							-81.52348973399997,
							28.33229788500006
						],
						[
							-81.52285456799996,
							28.333016626000074
						],
						[
							-81.52258928899994,
							28.33300269800003
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Osceola",
				"City": "Celebration",
				"Name": "North Village",
				"RegionID": "763194"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.57704158799999,
					27.517373692000035,
					-82.56310746399998,
					27.521291036000036
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.56311072999995,
							27.517373692000035
						],
						[
							-82.56882578499994,
							27.517476284000054
						],
						[
							-82.57296033599995,
							27.51763618400003
						],
						[
							-82.57704158799999,
							27.51763618400003
						],
						[
							-82.57704158799999,
							27.521291036000036
						],
						[
							-82.56749328699993,
							27.521211086000054
						],
						[
							-82.56579149599997,
							27.521142558000065
						],
						[
							-82.56444376999998,
							27.52118824400003
						],
						[
							-82.56367853499995,
							27.52119966500004
						],
						[
							-82.56310746399998,
							27.51804735500008
						],
						[
							-82.56311072999995,
							27.517373692000035
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Manatee",
				"City": "Palmetto",
				"Name": "Uptown",
				"RegionID": "763235"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.11960520699995,
					26.62038493800003,
					-80.115428,
					26.62405
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.11641604999994,
							26.62404125100005
						],
						[
							-80.11648335399998,
							26.62219713500008
						],
						[
							-80.11552,
							26.622153
						],
						[
							-80.115428,
							26.622149
						],
						[
							-80.11547826999998,
							26.62038493800003
						],
						[
							-80.11960520699995,
							26.620628595000028
						],
						[
							-80.11953911099994,
							26.622333851000064
						],
						[
							-80.11942800000001,
							26.622329000000004
						],
						[
							-80.118842,
							26.622302
						],
						[
							-80.118351,
							26.622281
						],
						[
							-80.118321,
							26.624033
						],
						[
							-80.116978,
							26.62405
						],
						[
							-80.11641604999994,
							26.62404125100005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Greenacres",
				"Name": "Mil-Lake Estates",
				"RegionID": "763321"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.146818,
					26.608074678000037,
					-80.14202258499995,
					26.611844817000076
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.14202258499995,
							26.611711327000023
						],
						[
							-80.14212482899995,
							26.608074678000037
						],
						[
							-80.14493504499995,
							26.608159267000076
						],
						[
							-80.14597439399995,
							26.60819353100004
						],
						[
							-80.146818,
							26.608157
						],
						[
							-80.14668454099996,
							26.611844817000076
						],
						[
							-80.14598581499996,
							26.611802698000076
						],
						[
							-80.14446599499996,
							26.611767659000066
						],
						[
							-80.14202258499995,
							26.611711327000023
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Greenacres",
				"Name": "Lucerne Homes East",
				"RegionID": "763326"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.14504163299995,
					26.604442047000077,
					-80.130357,
					26.611642798000048
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-80.130357,
								26.608933
							],
							[
								-80.130376,
								26.607887
							],
							[
								-80.131354,
								26.607898
							],
							[
								-80.131965,
								26.607896
							],
							[
								-80.132433,
								26.607893
							],
							[
								-80.133075,
								26.607902000000003
							],
							[
								-80.133951,
								26.607914
							],
							[
								-80.134518,
								26.607922
							],
							[
								-80.13874463899998,
								26.607976525000026
							],
							[
								-80.13863042499997,
								26.611642798000048
							],
							[
								-80.13045923499999,
								26.611517896000066
							],
							[
								-80.130429,
								26.610846
							],
							[
								-80.130397,
								26.610146
							],
							[
								-80.130365,
								26.609446
							],
							[
								-80.130357,
								26.608933
							]
						]
					],
					[
						[
							[
								-80.14118882199995,
								26.60517827800004
							],
							[
								-80.14093681299994,
								26.60450007600008
							],
							[
								-80.142799,
								26.604546
							],
							[
								-80.143566,
								26.604546
							],
							[
								-80.143941,
								26.604545
							],
							[
								-80.144899,
								26.604552
							],
							[
								-80.14504163299995,
								26.604442047000077
							],
							[
								-80.14498073099998,
								26.60630899800003
							],
							[
								-80.14493504499995,
								26.608159267000076
							],
							[
								-80.14212482899995,
								26.608074678000037
							],
							[
								-80.14152004299996,
								26.608056474000023
							],
							[
								-80.14149719999995,
								26.60759961800005
							],
							[
								-80.14156572799999,
								26.607382611000048
							],
							[
								-80.14165709999997,
								26.607211290000066
							],
							[
								-80.14167994199994,
								26.607039969000027
							],
							[
								-80.14156572799999,
								26.606811540000024
							],
							[
								-80.14140582799998,
								26.606366105000063
							],
							[
								-80.14118882199995,
								26.60517827800004
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Greenacres",
				"Name": "Pine Ridge South",
				"RegionID": "763328"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.14591030699995,
					26.633975213000042,
					-80.13728718899995,
					26.64154169300008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.13766500000001,
							26.634197
						],
						[
							-80.13768688999994,
							26.633975213000042
						],
						[
							-80.13983765099994,
							26.634024999000076
						],
						[
							-80.14407236499994,
							26.634123025000065
						],
						[
							-80.14591030699995,
							26.63416557000005
						],
						[
							-80.14589317499997,
							26.634946034000052
						],
						[
							-80.14578322799997,
							26.63854928300003
						],
						[
							-80.14570327799998,
							26.640890673000058
						],
						[
							-80.14566901399996,
							26.64154169300008
						],
						[
							-80.14177431199994,
							26.641450322000026
						],
						[
							-80.13728718899995,
							26.64130072000006
						],
						[
							-80.137515,
							26.637009
						],
						[
							-80.13766500000001,
							26.634197
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Greenacres",
				"Name": "Pine Ridge North",
				"RegionID": "763335"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.14555479899997,
					26.64499096000003,
					-80.141657,
					26.648919926000076
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.141685,
							26.647868
						],
						[
							-80.141657,
							26.645086
						],
						[
							-80.14195705399999,
							26.64503664600005
						],
						[
							-80.14227685399999,
							26.64499096000003
						],
						[
							-80.14258523199999,
							26.64500238100004
						],
						[
							-80.14381874499998,
							26.645265074000065
						],
						[
							-80.14410427999997,
							26.645287917000076
						],
						[
							-80.14469819299995,
							26.645219388000044
						],
						[
							-80.14512078599995,
							26.645196545000033
						],
						[
							-80.14555479899997,
							26.645242231000054
						],
						[
							-80.14546342799997,
							26.647572199000024
						],
						[
							-80.14545200699996,
							26.648919926000076
						],
						[
							-80.14171891399997,
							26.648805038000035
						],
						[
							-80.141712,
							26.648553
						],
						[
							-80.141685,
							26.647868
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Greenacres",
				"Name": "The Pines",
				"RegionID": "763337"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-87.17031437499998,
					30.47152671300006,
					-87.148918,
					30.50005509800008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-87.17014950799995,
							30.475338279000027
						],
						[
							-87.16997173299995,
							30.47596368900003
						],
						[
							-87.16993366099996,
							30.476668010000026
						],
						[
							-87.17004787499998,
							30.477315223000062
						],
						[
							-87.17021919699994,
							30.477848223000027
						],
						[
							-87.17029533899995,
							30.47843832900003
						],
						[
							-87.17031437499998,
							30.479199756000067
						],
						[
							-87.17012401799997,
							30.48024671900004
						],
						[
							-87.16936259099998,
							30.483044965000037
						],
						[
							-87.16789684299994,
							30.488888922000058
						],
						[
							-87.16625874199997,
							30.495227647000036
						],
						[
							-87.16604554299994,
							30.49612613200003
						],
						[
							-87.16590848599998,
							30.496765731000036
						],
						[
							-87.16593894299997,
							30.497070302000058
						],
						[
							-87.16659376999996,
							30.49917184200007
						],
						[
							-87.16665468499997,
							30.499506870000065
						],
						[
							-87.16648717099997,
							30.50005509800008
						],
						[
							-87.15825864499999,
							30.496689890000027
						],
						[
							-87.15808900000002,
							30.495649
						],
						[
							-87.15794,
							30.495362
						],
						[
							-87.157767,
							30.495111999999995
						],
						[
							-87.157617,
							30.494930000000004
						],
						[
							-87.157118,
							30.494453
						],
						[
							-87.15636300000001,
							30.493756000000005
						],
						[
							-87.15570800000002,
							30.493356999999996
						],
						[
							-87.155507,
							30.493247
						],
						[
							-87.15463885299994,
							30.492769636000048
						],
						[
							-87.15356596999999,
							30.492262336000067
						],
						[
							-87.15250600000002,
							30.491887
						],
						[
							-87.152253,
							30.491784
						],
						[
							-87.15223258199995,
							30.49177405700004
						],
						[
							-87.15119762699999,
							30.491415458000063
						],
						[
							-87.151192,
							30.491414
						],
						[
							-87.150835,
							30.49135
						],
						[
							-87.149915,
							30.491185
						],
						[
							-87.149742,
							30.491127000000002
						],
						[
							-87.14977628999998,
							30.491018626000027
						],
						[
							-87.149553,
							30.490958000000003
						],
						[
							-87.148918,
							30.490352000000005
						],
						[
							-87.149166,
							30.490352000000005
						],
						[
							-87.149649,
							30.490771000000002
						],
						[
							-87.150697,
							30.490435
						],
						[
							-87.15110931099997,
							30.49025538400008
						],
						[
							-87.15175403999996,
							30.489924890000054
						],
						[
							-87.15504148499997,
							30.48792633200003
						],
						[
							-87.15514500000002,
							30.487859
						],
						[
							-87.15560960799996,
							30.48752778100004
						],
						[
							-87.156027,
							30.487213000000004
						],
						[
							-87.159947,
							30.483275
						],
						[
							-87.161517,
							30.481091999999997
						],
						[
							-87.16194847999998,
							30.480248982000038
						],
						[
							-87.161964,
							30.480145
						],
						[
							-87.161953,
							30.48006
						],
						[
							-87.16192827599997,
							30.480002075000076
						],
						[
							-87.161758,
							30.479953
						],
						[
							-87.161765,
							30.479700000000005
						],
						[
							-87.16207,
							30.479106
						],
						[
							-87.16244245299998,
							30.476156172000064
						],
						[
							-87.16243573499997,
							30.47610914700004
						],
						[
							-87.162071,
							30.475052
						],
						[
							-87.160909,
							30.473253
						],
						[
							-87.16100426699995,
							30.472864985000058
						],
						[
							-87.16099934299997,
							30.47284920100003
						],
						[
							-87.16094963199998,
							30.47273673600006
						],
						[
							-87.160915,
							30.472681000000005
						],
						[
							-87.16086788899997,
							30.472551800000076
						],
						[
							-87.160662,
							30.472086000000004
						],
						[
							-87.16054227099994,
							30.47152671300006
						],
						[
							-87.17014950799995,
							30.475338279000027
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Escambia",
				"City": "Pensacola",
				"Name": "La Mirage",
				"RegionID": "764087"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-87.18998204799999,
					30.420782599000063,
					-87.173096,
					30.44049265900003
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-87.17316438799998,
							30.43963222100007
						],
						[
							-87.173162,
							30.439523999999995
						],
						[
							-87.17315825499999,
							30.438953925000078
						],
						[
							-87.173113,
							30.437705999999995
						],
						[
							-87.173096,
							30.436209999999996
						],
						[
							-87.173116,
							30.435099
						],
						[
							-87.17313001099996,
							30.434655311000032
						],
						[
							-87.173127,
							30.434197
						],
						[
							-87.17314931699998,
							30.434043956000043
						],
						[
							-87.173155,
							30.433864000000003
						],
						[
							-87.173273,
							30.433021999999998
						],
						[
							-87.173392,
							30.432357000000003
						],
						[
							-87.173572,
							30.431622000000004
						],
						[
							-87.174588,
							30.428756
						],
						[
							-87.175241,
							30.427857000000003
						],
						[
							-87.17524594199995,
							30.427849947000027
						],
						[
							-87.175299,
							30.42775
						],
						[
							-87.175783,
							30.427082
						],
						[
							-87.17607002099999,
							30.426695070000054
						],
						[
							-87.176455,
							30.426137
						],
						[
							-87.176703,
							30.425838000000002
						],
						[
							-87.176826,
							30.425656
						],
						[
							-87.17716288799994,
							30.425221789000034
						],
						[
							-87.177274,
							30.425072
						],
						[
							-87.177896,
							30.424411000000003
						],
						[
							-87.17829306899995,
							30.42401092000006
						],
						[
							-87.178622,
							30.423670000000005
						],
						[
							-87.179052,
							30.423208
						],
						[
							-87.179174,
							30.423088
						],
						[
							-87.179463,
							30.422783000000003
						],
						[
							-87.179814,
							30.422462
						],
						[
							-87.180419,
							30.421994
						],
						[
							-87.18144200000002,
							30.421545999999996
						],
						[
							-87.182139,
							30.421379000000005
						],
						[
							-87.18238571599994,
							30.42131887200003
						],
						[
							-87.182485,
							30.421286999999996
						],
						[
							-87.18253265099997,
							30.42128306200004
						],
						[
							-87.182656,
							30.421253000000004
						],
						[
							-87.18306,
							30.421202000000005
						],
						[
							-87.183551,
							30.421154999999995
						],
						[
							-87.18378400000002,
							30.421157999999995
						],
						[
							-87.184079,
							30.421118000000003
						],
						[
							-87.185033,
							30.421056
						],
						[
							-87.18646800000002,
							30.420933
						],
						[
							-87.187503,
							30.420837
						],
						[
							-87.18780253899996,
							30.420847527000035
						],
						[
							-87.18858815499999,
							30.420782599000063
						],
						[
							-87.18859959899999,
							30.42112318200003
						],
						[
							-87.18820237199998,
							30.421061391000027
						],
						[
							-87.188195,
							30.421061
						],
						[
							-87.18796453599998,
							30.421078267000045
						],
						[
							-87.187659,
							30.421154999999995
						],
						[
							-87.187265,
							30.421122
						],
						[
							-87.186941,
							30.421227000000002
						],
						[
							-87.18691059399998,
							30.42130316600003
						],
						[
							-87.186906,
							30.421454
						],
						[
							-87.186873,
							30.421502
						],
						[
							-87.186803,
							30.421521
						],
						[
							-87.18676721899999,
							30.421520148000074
						],
						[
							-87.186472,
							30.421683000000005
						],
						[
							-87.18623049899998,
							30.421687962000078
						],
						[
							-87.186217,
							30.421707000000005
						],
						[
							-87.186159,
							30.421824
						],
						[
							-87.186048,
							30.421921000000005
						],
						[
							-87.185981,
							30.422046
						],
						[
							-87.18592349699998,
							30.42210560600006
						],
						[
							-87.18589047599995,
							30.422175110000072
						],
						[
							-87.185859,
							30.422338
						],
						[
							-87.185856,
							30.42244
						],
						[
							-87.185885,
							30.422586
						],
						[
							-87.185938,
							30.422634
						],
						[
							-87.18595433999997,
							30.422731389000038
						],
						[
							-87.185983,
							30.422767000000004
						],
						[
							-87.18596016899994,
							30.422822281000037
						],
						[
							-87.185955,
							30.422894000000003
						],
						[
							-87.185814,
							30.423184
						],
						[
							-87.185771334,
							30.423330617000037
						],
						[
							-87.18581763099998,
							30.42376453600008
						],
						[
							-87.185838,
							30.423850000000005
						],
						[
							-87.185874,
							30.423926999999996
						],
						[
							-87.186002,
							30.424054
						],
						[
							-87.18618,
							30.424200000000003
						],
						[
							-87.18620644399994,
							30.42422698100006
						],
						[
							-87.18644065599995,
							30.424417236000064
						],
						[
							-87.18646800000002,
							30.424419000000004
						],
						[
							-87.186538,
							30.424441
						],
						[
							-87.186569,
							30.424462000000002
						],
						[
							-87.186609,
							30.424531999999996
						],
						[
							-87.186616,
							30.424583000000002
						],
						[
							-87.18657148799997,
							30.424589629000025
						],
						[
							-87.186738,
							30.424984
						],
						[
							-87.186897,
							30.425155
						],
						[
							-87.18691290599999,
							30.425164084000073
						],
						[
							-87.187097,
							30.425249
						],
						[
							-87.18727,
							30.425362000000003
						],
						[
							-87.18727552199994,
							30.42537116100004
						],
						[
							-87.18729100000002,
							30.425379999999997
						],
						[
							-87.187614,
							30.425452000000003
						],
						[
							-87.187623,
							30.425702999999995
						],
						[
							-87.18797337699993,
							30.42574705300007
						],
						[
							-87.18823076499996,
							30.42674882200004
						],
						[
							-87.18925107699994,
							30.427845277000074
						],
						[
							-87.18990590499999,
							30.428850362000052
						],
						[
							-87.18998204799999,
							30.42961178900003
						],
						[
							-87.18964701999994,
							30.43012956000007
						],
						[
							-87.18629673899994,
							30.432139728000035
						],
						[
							-87.18510891199998,
							30.433053441000027
						],
						[
							-87.18485002599994,
							30.434104211000037
						],
						[
							-87.18481956899996,
							30.435170210000024
						],
						[
							-87.18548962499995,
							30.436495094000065
						],
						[
							-87.18678405199995,
							30.43722606400007
						],
						[
							-87.18792619399994,
							30.437789521000074
						],
						[
							-87.18845919299997,
							30.438885976000048
						],
						[
							-87.18862670699997,
							30.439738775000023
						],
						[
							-87.18851072499996,
							30.44049265900003
						],
						[
							-87.18209365899997,
							30.439951975000042
						],
						[
							-87.18043374699994,
							30.439830146000077
						],
						[
							-87.17889566299993,
							30.439708318000044
						],
						[
							-87.17731189399996,
							30.439571261000022
						],
						[
							-87.17687026599998,
							30.439662632000076
						],
						[
							-87.17618498099995,
							30.439754004000065
						],
						[
							-87.17577380999995,
							30.439754004000065
						],
						[
							-87.17391592699994,
							30.439647404000027
						],
						[
							-87.17316438799998,
							30.43963222100007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Escambia",
				"City": "Pensacola",
				"Name": "Cervello",
				"RegionID": "764089"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.08922954699995,
					26.882488,
					-80.075358,
					26.897259894000058
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.079165,
							26.882488
						],
						[
							-80.07947,
							26.882491
						],
						[
							-80.087045,
							26.882665000000003
						],
						[
							-80.08713418899998,
							26.883456369000044
						],
						[
							-80.08680491899997,
							26.88432444600005
						],
						[
							-80.08653551599997,
							26.88498298600007
						],
						[
							-80.08648517499996,
							26.88541927500006
						],
						[
							-80.08644571499997,
							26.885761262000077
						],
						[
							-80.08620624499997,
							26.886898742000028
						],
						[
							-80.08611644399997,
							26.887437548000037
						],
						[
							-80.08641876499996,
							26.887764055000048
						],
						[
							-80.08686478599998,
							26.88824575700005
						],
						[
							-80.08737365899998,
							26.888844431000052
						],
						[
							-80.08770292899999,
							26.889742441000067
						],
						[
							-80.08812200099999,
							26.890580584000077
						],
						[
							-80.08857100599994,
							26.891149324000025
						],
						[
							-80.08904994499994,
							26.891448661000027
						],
						[
							-80.08922954699995,
							26.892406538000046
						],
						[
							-80.08907987799995,
							26.892705875000047
						],
						[
							-80.08824173499994,
							26.89435222700007
						],
						[
							-80.08737365899998,
							26.895040702000077
						],
						[
							-80.08689471999998,
							26.895699243000024
						],
						[
							-80.08659023699994,
							26.897214383000062
						],
						[
							-80.07967789099996,
							26.897034784000027
						],
						[
							-80.07927443599993,
							26.897024301000048
						],
						[
							-80.07717624199995,
							26.89696978600006
						],
						[
							-80.07716448099995,
							26.89714451900005
						],
						[
							-80.07715648099997,
							26.897258519000047
						],
						[
							-80.07715102899994,
							26.897259207000047
						],
						[
							-80.07712618299996,
							26.897259894000058
						],
						[
							-80.077132,
							26.897177
						],
						[
							-80.077146,
							26.896969
						],
						[
							-80.077179,
							26.896023
						],
						[
							-80.077071,
							26.896023
						],
						[
							-80.077022,
							26.895906
						],
						[
							-80.076994,
							26.895902
						],
						[
							-80.076962,
							26.895931
						],
						[
							-80.076955,
							26.895948
						],
						[
							-80.076934,
							26.896027
						],
						[
							-80.07691,
							26.895854
						],
						[
							-80.076893,
							26.895729
						],
						[
							-80.077042,
							26.895686
						],
						[
							-80.07704042999995,
							26.89566334600005
						],
						[
							-80.077014,
							26.895282
						],
						[
							-80.076799,
							26.895268
						],
						[
							-80.076782,
							26.895194
						],
						[
							-80.076703,
							26.894932
						],
						[
							-80.07653000000002,
							26.894457
						],
						[
							-80.07657108799998,
							26.894448150000073
						],
						[
							-80.076725,
							26.894415
						],
						[
							-80.07671748499996,
							26.894391324000026
						],
						[
							-80.076559,
							26.893892
						],
						[
							-80.076305,
							26.893913
						],
						[
							-80.07588700000001,
							26.892994
						],
						[
							-80.075775,
							26.892705
						],
						[
							-80.075701,
							26.892487
						],
						[
							-80.075604,
							26.892156
						],
						[
							-80.075522,
							26.891821
						],
						[
							-80.075455,
							26.891483
						],
						[
							-80.075405,
							26.891155000000005
						],
						[
							-80.075374,
							26.890845
						],
						[
							-80.075358,
							26.890535
						],
						[
							-80.07536900000001,
							26.889841
						],
						[
							-80.075394,
							26.888901
						],
						[
							-80.075665,
							26.8889
						],
						[
							-80.079026,
							26.888892
						],
						[
							-80.07902667799993,
							26.888860957000077
						],
						[
							-80.07904800000001,
							26.887885000000004
						],
						[
							-80.079165,
							26.882488
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Jupiter",
				"Name": "Bear's Club",
				"RegionID": "764296"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.138798,
					26.604449,
					-80.134518,
					26.607976525000026
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.134518,
							26.607922
						],
						[
							-80.134638,
							26.604500000000005
						],
						[
							-80.136499,
							26.604524
						],
						[
							-80.138215,
							26.604473
						],
						[
							-80.138798,
							26.604449
						],
						[
							-80.13874463899998,
							26.607976525000026
						],
						[
							-80.134518,
							26.607922
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Greenacres",
				"Name": "Pine Country",
				"RegionID": "764321"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.146717,
					26.618916,
					-80.14245733799999,
					26.622977399000035
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.143842,
							26.619294
						],
						[
							-80.143962,
							26.619296
						],
						[
							-80.144337,
							26.619291
						],
						[
							-80.144711,
							26.619271
						],
						[
							-80.145083,
							26.619237
						],
						[
							-80.145454,
							26.619189000000002
						],
						[
							-80.14550400000002,
							26.619181
						],
						[
							-80.145505,
							26.619106
						],
						[
							-80.145744,
							26.61914
						],
						[
							-80.145563,
							26.619171
						],
						[
							-80.145566,
							26.620052
						],
						[
							-80.14588,
							26.620053
						],
						[
							-80.145889,
							26.619113
						],
						[
							-80.146187,
							26.619052
						],
						[
							-80.14654800000001,
							26.618963
						],
						[
							-80.146717,
							26.618916
						],
						[
							-80.146652,
							26.620246
						],
						[
							-80.14652135199998,
							26.621850749000032
						],
						[
							-80.14646545599999,
							26.622977399000035
						],
						[
							-80.14503749199997,
							26.62294052200008
						],
						[
							-80.14335848499996,
							26.622897162000072
						],
						[
							-80.14245733799999,
							26.62287389000005
						],
						[
							-80.14252478299994,
							26.621054150000077
						],
						[
							-80.14261615399994,
							26.619260989000054
						],
						[
							-80.143842,
							26.619294
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Greenacres",
				"Name": "Heather Estates",
				"RegionID": "764323"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.18025132199995,
					25.768654678000075,
					-80.1445433259999,
					25.78874932100007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.1772842009999,
							25.78874932100007
						],
						[
							-80.17669859999995,
							25.788642106000054
						],
						[
							-80.17662692699992,
							25.78859192100009
						],
						[
							-80.17656352499995,
							25.78853330900006
						],
						[
							-80.1763187599999,
							25.78828420800005
						],
						[
							-80.17534134099992,
							25.788281318000088
						],
						[
							-80.17518783399993,
							25.78826765900004
						],
						[
							-80.17513221099995,
							25.788256028000035
						],
						[
							-80.17457920999993,
							25.78812202800009
						],
						[
							-80.1745433349999,
							25.788112548000072
						],
						[
							-80.17408967099993,
							25.78798258800009
						],
						[
							-80.17340963599992,
							25.787973237000074
						],
						[
							-80.17326583399995,
							25.78795966000007
						],
						[
							-80.1732103139999,
							25.787948054000083
						],
						[
							-80.17295431399992,
							25.787886053000083
						],
						[
							-80.1728584139999,
							25.787857086000088
						],
						[
							-80.17270909599995,
							25.787786563000054
						],
						[
							-80.17254585199993,
							25.787688290000062
						],
						[
							-80.17248427999994,
							25.787647656000047
						],
						[
							-80.17242624499994,
							25.787602113000048
						],
						[
							-80.17237213899995,
							25.78755196600008
						],
						[
							-80.17232232399994,
							25.787497553000037
						],
						[
							-80.17227713699992,
							25.787439240000083
						],
						[
							-80.17223688099995,
							25.78737742000004
						],
						[
							-80.17220182799993,
							25.78731250900006
						],
						[
							-80.17217221199991,
							25.787244943000076
						],
						[
							-80.1721082119999,
							25.787080942000046
						],
						[
							-80.17210091399994,
							25.78706158600005
						],
						[
							-80.17205883499992,
							25.786901086000057
						],
						[
							-80.17199132999991,
							25.786467006000066
						],
						[
							-80.1719806779999,
							25.78632900000008
						],
						[
							-80.17199553999991,
							25.78616631300008
						],
						[
							-80.1720129869999,
							25.78607498100007
						],
						[
							-80.17196484499993,
							25.786020301000065
						],
						[
							-80.17192155099991,
							25.785961708000062
						],
						[
							-80.17188342299994,
							25.785899629000085
						],
						[
							-80.17185073999991,
							25.785834519000048
						],
						[
							-80.17182373999992,
							25.785766854000087
						],
						[
							-80.17180262099993,
							25.785697129000088
						],
						[
							-80.17175479699995,
							25.785516460000053
						],
						[
							-80.17161642399992,
							25.78524277200006
						],
						[
							-80.17158452599995,
							25.785172311000053
						],
						[
							-80.17155880099995,
							25.78509937000007
						],
						[
							-80.1715394389999,
							25.78502448800009
						],
						[
							-80.1715265819999,
							25.784948219000057
						],
						[
							-80.17152032599995,
							25.78487112800008
						],
						[
							-80.17151432599992,
							25.784713128000078
						],
						[
							-80.17151840499993,
							25.78458690900004
						],
						[
							-80.17153940499992,
							25.784382909000044
						],
						[
							-80.17155278699994,
							25.784295433000068
						],
						[
							-80.17158352199993,
							25.784144604000062
						],
						[
							-80.17156093099993,
							25.784041285000058
						],
						[
							-80.17126824699994,
							25.783491773000037
						],
						[
							-80.1712169139999,
							25.783376586000088
						],
						[
							-80.17118952899995,
							25.78328711800009
						],
						[
							-80.17093452899991,
							25.78226711700006
						],
						[
							-80.17091314899996,
							25.782148048000067
						],
						[
							-80.17087159099994,
							25.78177114000005
						],
						[
							-80.1695877439999,
							25.781192992000058
						],
						[
							-80.16993705699991,
							25.780357647000073
						],
						[
							-80.16993899999996,
							25.78035300000005
						],
						[
							-80.1700909999999,
							25.780087000000037
						],
						[
							-80.1673869999999,
							25.77894900000007
						],
						[
							-80.16368799999992,
							25.777394000000072
						],
						[
							-80.1531349999999,
							25.77278400000006
						],
						[
							-80.15242899999993,
							25.77249500000005
						],
						[
							-80.15188799999993,
							25.772345000000087
						],
						[
							-80.14775899999995,
							25.770404000000042
						],
						[
							-80.14598199999995,
							25.769570000000044
						],
						[
							-80.1445433259999,
							25.768693665000058
						],
						[
							-80.14463783499991,
							25.76866834100008
						],
						[
							-80.14479399999993,
							25.768654678000075
						],
						[
							-80.14495016599994,
							25.76866834100008
						],
						[
							-80.1451015859999,
							25.76870891400006
						],
						[
							-80.14524366099994,
							25.76877516500008
						],
						[
							-80.14537207299992,
							25.76886508000007
						],
						[
							-80.14542349999994,
							25.76891650600004
						],
						[
							-80.14544592699991,
							25.768894079000063
						],
						[
							-80.14557433899995,
							25.768804164000073
						],
						[
							-80.14571641399993,
							25.76873791400004
						],
						[
							-80.14586783499993,
							25.768697341000063
						],
						[
							-80.1460239999999,
							25.76868367800006
						],
						[
							-80.14618016599992,
							25.768697341000063
						],
						[
							-80.14633703099992,
							25.768739935000042
						],
						[
							-80.14746747499993,
							25.769167956000047
						],
						[
							-80.14750989399994,
							25.76918526700007
						],
						[
							-80.15022824499994,
							25.770376230000068
						],
						[
							-80.15028577999993,
							25.77040066700005
						],
						[
							-80.15037262699991,
							25.770377817000053
						],
						[
							-80.15273806499994,
							25.77140845300005
						],
						[
							-80.15284741599994,
							25.771480741000065
						],
						[
							-80.15354046199991,
							25.771806178000077
						],
						[
							-80.1540456809999,
							25.772037697000087
						],
						[
							-80.1559409809999,
							25.77287401700005
						],
						[
							-80.15600064499995,
							25.77289952300004
						],
						[
							-80.1560835219999,
							25.77293927400007
						],
						[
							-80.15727936599991,
							25.773481734000086
						],
						[
							-80.15878262199993,
							25.77408213600006
						],
						[
							-80.1606647189999,
							25.774876461000076
						],
						[
							-80.16068388399992,
							25.774884814000075
						],
						[
							-80.16169730099995,
							25.775340605000054
						],
						[
							-80.16335057399994,
							25.77602872400007
						],
						[
							-80.16337744999994,
							25.776040427000055
						],
						[
							-80.16394673699995,
							25.776299452000046
						],
						[
							-80.16466106099995,
							25.77656181900005
						],
						[
							-80.1647579189999,
							25.776604004000035
						],
						[
							-80.16545963099992,
							25.776960041000052
						],
						[
							-80.16605123099993,
							25.77718386400005
						],
						[
							-80.1661156049999,
							25.77721112400008
						],
						[
							-80.16719008199993,
							25.77771623700005
						],
						[
							-80.16765269599995,
							25.777916575000063
						],
						[
							-80.16908257599994,
							25.778524763000064
						],
						[
							-80.1692864389999,
							25.77859594000006
						],
						[
							-80.16935034399995,
							25.778621027000042
						],
						[
							-80.17185113499994,
							25.77971470500006
						],
						[
							-80.17231118799992,
							25.779920952000055
						],
						[
							-80.17235461299992,
							25.779940580000073
						],
						[
							-80.17332481099993,
							25.78029399600007
						],
						[
							-80.1734397489999,
							25.780345235000084
						],
						[
							-80.17392308099994,
							25.780602651000038
						],
						[
							-80.17535805299991,
							25.781133553000075
						],
						[
							-80.17545853199994,
							25.78117787700006
						],
						[
							-80.17669022599995,
							25.781813716000045
						],
						[
							-80.17743975199994,
							25.782129054000052
						],
						[
							-80.17753595899991,
							25.782176469000035
						],
						[
							-80.17822095899993,
							25.782566469000074
						],
						[
							-80.17832588599993,
							25.782636379000053
						],
						[
							-80.17845788599993,
							25.78273837800009
						],
						[
							-80.17848607299993,
							25.782761079000068
						],
						[
							-80.1785969199999,
							25.782871927000087
						],
						[
							-80.17868683499995,
							25.78300033900007
						],
						[
							-80.17875308599992,
							25.783142413000064
						],
						[
							-80.17876286599994,
							25.783170744000074
						],
						[
							-80.17885170699992,
							25.783442706000077
						],
						[
							-80.17901273099994,
							25.783844328000043
						],
						[
							-80.17903414599994,
							25.78390369300007
						],
						[
							-80.1791161459999,
							25.78415869300005
						],
						[
							-80.17912203199995,
							25.78417771900007
						],
						[
							-80.17937137799994,
							25.785016426000084
						],
						[
							-80.1800135869999,
							25.78652187600005
						],
						[
							-80.18005523699992,
							25.786576640000078
						],
						[
							-80.18009251899991,
							25.786634466000066
						],
						[
							-80.18012520899994,
							25.78669500600006
						],
						[
							-80.18015310999994,
							25.786757897000086
						],
						[
							-80.18017605599994,
							25.786822760000064
						],
						[
							-80.18019390699993,
							25.78688920600007
						],
						[
							-80.1802065569999,
							25.78695683600006
						],
						[
							-80.18023255799994,
							25.78713183600007
						],
						[
							-80.18023775899991,
							25.78717352300004
						],
						[
							-80.18024675899994,
							25.787262523000038
						],
						[
							-80.18025132199995,
							25.787353000000053
						],
						[
							-80.18024809799994,
							25.787429082000074
						],
						[
							-80.18022109799995,
							25.787747082000067
						],
						[
							-80.1802106589999,
							25.787827166000056
						],
						[
							-80.18017725099992,
							25.78795813800008
						],
						[
							-80.18008325199992,
							25.788237138000056
						],
						[
							-80.18007608699992,
							25.788257586000043
						],
						[
							-80.1800098359999,
							25.788399661000085
						],
						[
							-80.17991992099991,
							25.78852807300007
						],
						[
							-80.17980907299994,
							25.788638921000086
						],
						[
							-80.17970110399995,
							25.788714522000078
						],
						[
							-80.1781583739999,
							25.78868833300004
						],
						[
							-80.1772842009999,
							25.78874932100007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami",
				"Name": "Watson Island",
				"RegionID": "416397"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.43412209199994,
					30.420169411000078,
					-81.40526067799993,
					30.484495873000075
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.4099124839999,
							30.482095963000067
						],
						[
							-81.4094364799999,
							30.47459590700004
						],
						[
							-81.40896147599994,
							30.46709684700005
						],
						[
							-81.40848647699994,
							30.459596843000046
						],
						[
							-81.40848596199993,
							30.459491968000066
						],
						[
							-81.4088736779999,
							30.452242967000075
						],
						[
							-81.4088736779999,
							30.45148398600009
						],
						[
							-81.4075513489999,
							30.44471236000004
						],
						[
							-81.40754421799994,
							30.444670646000077
						],
						[
							-81.4065789199999,
							30.43809633800004
						],
						[
							-81.40557286099994,
							30.437229210000055
						],
						[
							-81.40547107899995,
							30.43712607300006
						],
						[
							-81.40538116399995,
							30.436997661000078
						],
						[
							-81.40531491399992,
							30.436855586000036
						],
						[
							-81.40527434099994,
							30.436704165000037
						],
						[
							-81.40526067799993,
							30.436548000000073
						],
						[
							-81.40526410299992,
							30.436469588000083
						],
						[
							-81.40560010299993,
							30.432630588000055
						],
						[
							-81.40561034099994,
							30.432552834000035
						],
						[
							-81.4056336779999,
							30.43245369600004
						],
						[
							-81.4065816769999,
							30.429251696000048
						],
						[
							-81.40659891399991,
							30.42919941300005
						],
						[
							-81.40666516399995,
							30.429057339000053
						],
						[
							-81.40675507899994,
							30.428928927000072
						],
						[
							-81.4068659269999,
							30.428818079000052
						],
						[
							-81.40699433899994,
							30.428728164000066
						],
						[
							-81.40705786799992,
							30.428694791000055
						],
						[
							-81.40757428699993,
							30.42844928100004
						],
						[
							-81.4077936839999,
							30.42813411600008
						],
						[
							-81.40774412299993,
							30.428076979000082
						],
						[
							-81.40764916499995,
							30.42794266100009
						],
						[
							-81.40758291399993,
							30.427800587000036
						],
						[
							-81.4075423409999,
							30.427649166000037
						],
						[
							-81.40752867799995,
							30.427493000000084
						],
						[
							-81.4075423409999,
							30.427336835000062
						],
						[
							-81.40758291399993,
							30.427185414000064
						],
						[
							-81.40764916499995,
							30.42704333900008
						],
						[
							-81.40773907999994,
							30.42691492700004
						],
						[
							-81.40780046999993,
							30.426848807000056
						],
						[
							-81.4096125879999,
							30.425083561000065
						],
						[
							-81.41046661899992,
							30.423209129000043
						],
						[
							-81.41050127699992,
							30.42314091200006
						],
						[
							-81.41054160799992,
							30.423075888000085
						],
						[
							-81.41058732099992,
							30.423014528000067
						],
						[
							-81.41063808399991,
							30.42295727600009
						],
						[
							-81.41069352999995,
							30.422904546000044
						],
						[
							-81.41075325799994,
							30.422856720000087
						],
						[
							-81.41081683499993,
							30.422814145000075
						],
						[
							-81.41418231699993,
							30.420762267000043
						],
						[
							-81.4145397989999,
							30.420552390000072
						],
						[
							-81.41457083199992,
							30.420534993000047
						],
						[
							-81.41491483099992,
							30.42035099200007
						],
						[
							-81.41500673599995,
							30.420308308000074
						],
						[
							-81.41517273599993,
							30.420242308000066
						],
						[
							-81.41523194599995,
							30.420221132000055
						],
						[
							-81.4152924899999,
							30.420204146000064
						],
						[
							-81.41535407399994,
							30.42019143200008
						],
						[
							-81.4154163959999,
							30.420183053000073
						],
						[
							-81.41551739599993,
							30.420173054000088
						],
						[
							-81.41564230799992,
							30.420169411000078
						],
						[
							-81.41574130899996,
							30.420173412000054
						],
						[
							-81.4158611659999,
							30.420186341000093
						],
						[
							-81.41594748199992,
							30.42020598500005
						],
						[
							-81.41598677899994,
							30.42021698800005
						],
						[
							-81.41604700499994,
							30.42023225700007
						],
						[
							-81.41613358599994,
							30.420258914000044
						],
						[
							-81.41620436099993,
							30.42028814300005
						],
						[
							-81.41627336199991,
							30.420320143000083
						],
						[
							-81.41634466099993,
							30.420357164000052
						],
						[
							-81.41644488999992,
							30.42042438100009
						],
						[
							-81.41651089099992,
							30.42047538200006
						],
						[
							-81.41656558499994,
							30.420521225000073
						],
						[
							-81.41661647299992,
							30.420571260000088
						],
						[
							-81.41666323299995,
							30.420625173000076
						],
						[
							-81.41670557099992,
							30.420682624000047
						],
						[
							-81.41674756999993,
							30.420744624000065
						],
						[
							-81.41678825999992,
							30.420810651000068
						],
						[
							-81.4168231079999,
							30.420879939000088
						],
						[
							-81.4168518539999,
							30.420951973000058
						],
						[
							-81.41687428499995,
							30.421026217000076
						],
						[
							-81.41689023299995,
							30.421102117000093
						],
						[
							-81.41689958099994,
							30.421179109000036
						],
						[
							-81.41690225699995,
							30.42125662100005
						],
						[
							-81.41690115099993,
							30.421325691000053
						],
						[
							-81.4169116779999,
							30.42142218700008
						],
						[
							-81.41692000199993,
							30.42148295000004
						],
						[
							-81.41692666299991,
							30.421550394000064
						],
						[
							-81.41692822599992,
							30.421618148000054
						],
						[
							-81.41692468199994,
							30.42168582800008
						],
						[
							-81.41691605199992,
							30.421753048000088
						],
						[
							-81.41690238399991,
							30.42181942800005
						],
						[
							-81.41688375699994,
							30.421884590000047
						],
						[
							-81.41684875699991,
							30.421991591000047
						],
						[
							-81.41681602199992,
							30.422076775000054
						],
						[
							-81.41674502099994,
							30.422236775000044
						],
						[
							-81.4166801909999,
							30.422354248000094
						],
						[
							-81.4179710809999,
							30.430834664000088
						],
						[
							-81.41797937199993,
							30.43091081400007
						],
						[
							-81.4179811539999,
							30.430987393000066
						],
						[
							-81.41797641199992,
							30.431063846000086
						],
						[
							-81.41796518099994,
							30.431139619000078
						],
						[
							-81.41794754299991,
							30.43121416000008
						],
						[
							-81.41722933699992,
							30.43376018300006
						],
						[
							-81.41729856099994,
							30.435909406000064
						],
						[
							-81.41820203999993,
							30.436948860000086
						],
						[
							-81.41834233499992,
							30.437040109000066
						],
						[
							-81.41839663999991,
							30.437078356000082
						],
						[
							-81.42095363999994,
							30.439024355000072
						],
						[
							-81.42098707299994,
							30.43905108000007
						],
						[
							-81.4210979209999,
							30.439161927000047
						],
						[
							-81.42118783599994,
							30.43929033900008
						],
						[
							-81.42125408699991,
							30.43943241400007
						],
						[
							-81.42129465999994,
							30.439583835000068
						],
						[
							-81.4213083219999,
							30.439740000000086
						],
						[
							-81.4213083219999,
							30.44007806500008
						],
						[
							-81.42115031399993,
							30.44364452400004
						],
						[
							-81.42043466299992,
							30.44522906200007
						],
						[
							-81.4200062239999,
							30.44593383600005
						],
						[
							-81.41995612699992,
							30.44640905300008
						],
						[
							-81.41967128899995,
							30.44808160000008
						],
						[
							-81.41973910399992,
							30.448467726000047
						],
						[
							-81.4197030119999,
							30.44881009400007
						],
						[
							-81.4202377819999,
							30.44969693200005
						],
						[
							-81.42048057099993,
							30.449848299000053
						],
						[
							-81.42185345699994,
							30.451136635000065
						],
						[
							-81.42260509299992,
							30.451524576000054
						],
						[
							-81.42345371399995,
							30.451694300000046
						],
						[
							-81.42500547799995,
							30.45130635900006
						],
						[
							-81.42624203999992,
							30.450869926000053
						],
						[
							-81.42718764599994,
							30.450530477000086
						],
						[
							-81.42779380399992,
							30.45038499900005
						],
						[
							-81.4281574979999,
							30.45060321600005
						],
						[
							-81.42873940999993,
							30.451136635000065
						],
						[
							-81.42915159699993,
							30.45164580800008
						],
						[
							-81.42936981399993,
							30.452179227000048
						],
						[
							-81.42755134099991,
							30.453512774000043
						],
						[
							-81.42650874899994,
							30.454264410000068
						],
						[
							-81.42602382299992,
							30.45491906000007
						],
						[
							-81.42641176399991,
							30.455500972000042
						],
						[
							-81.42694518299993,
							30.455961652000042
						],
						[
							-81.42716339999993,
							30.456179868000053
						],
						[
							-81.42716339999993,
							30.456640548000053
						],
						[
							-81.42699367499995,
							30.457028489000038
						],
						[
							-81.42696942899994,
							30.45748916900004
						],
						[
							-81.42767257199995,
							30.458652993000044
						],
						[
							-81.42781804999993,
							30.459162165000066
						],
						[
							-81.42763498199992,
							30.45996909400009
						],
						[
							-81.42747241299993,
							30.46007693300004
						],
						[
							-81.42765511199991,
							30.460137788000058
						],
						[
							-81.4279635279999,
							30.460786668000086
						],
						[
							-81.42786654299994,
							30.461756521000037
						],
						[
							-81.42854543899995,
							30.462095969000075
						],
						[
							-81.42890913399992,
							30.462192954000045
						],
						[
							-81.4301941889999,
							30.462265693000063
						],
						[
							-81.43080034699994,
							30.46202323000006
						],
						[
							-81.43109130199991,
							30.461901999000073
						],
						[
							-81.43157622899992,
							30.46180501300006
						],
						[
							-81.43172170699995,
							30.461974738000038
						],
						[
							-81.4317459529999,
							30.462411171000042
						],
						[
							-81.43145499699995,
							30.463478009000085
						],
						[
							-81.43143075099994,
							30.463817457000058
						],
						[
							-81.43162472099993,
							30.46403567400006
						],
						[
							-81.43177019899991,
							30.464302384000067
						],
						[
							-81.43189143099994,
							30.46483580300008
						],
						[
							-81.43208540099994,
							30.46532072900004
						],
						[
							-81.43147924299991,
							30.465805655000057
						],
						[
							-81.43133376599991,
							30.46592688700008
						],
						[
							-81.4312852729999,
							30.466120857000078
						],
						[
							-81.43179444599991,
							30.46672701500006
						],
						[
							-81.4319641699999,
							30.467599882000062
						],
						[
							-81.43274005199993,
							30.467866592000064
						],
						[
							-81.43358867299992,
							30.46808480900006
						],
						[
							-81.43402510599992,
							30.46820604000004
						],
						[
							-81.43412209199994,
							30.468521242000065
						],
						[
							-81.43370990399991,
							30.46878795200007
						],
						[
							-81.43290977599992,
							30.469103154000038
						],
						[
							-81.43249758899992,
							30.46983054300006
						],
						[
							-81.43220663299992,
							30.470097253000063
						],
						[
							-81.43026692799992,
							30.47043670100004
						],
						[
							-81.43002446499992,
							30.470606425000085
						],
						[
							-81.42912735099993,
							30.47038820800009
						],
						[
							-81.42830297599994,
							30.47036396200008
						],
						[
							-81.4281574979999,
							30.47055793300007
						],
						[
							-81.42810900599994,
							30.47101861300007
						],
						[
							-81.42813325199995,
							30.471479293000073
						],
						[
							-81.42854543899995,
							30.47172175600008
						],
						[
							-81.42970926299995,
							30.471794495000037
						],
						[
							-81.43024268099992,
							30.471794495000037
						],
						[
							-81.43048514499992,
							30.47184298700006
						],
						[
							-81.43058212999995,
							30.472182436000082
						],
						[
							-81.43033966699994,
							30.47307954900009
						],
						[
							-81.43048514499992,
							30.473661461000063
						],
						[
							-81.43065486899991,
							30.473952417000078
						],
						[
							-81.43036391299995,
							30.474728299000052
						],
						[
							-81.42978200099992,
							30.47475254500006
						],
						[
							-81.42924858299995,
							30.474728299000052
						],
						[
							-81.42893337999993,
							30.474776791000068
						],
						[
							-81.42873940999993,
							30.475140486000047
						],
						[
							-81.42898187299996,
							30.475431442000062
						],
						[
							-81.4299274789999,
							30.476183077000087
						],
						[
							-81.43058212999995,
							30.47691046700004
						],
						[
							-81.43094582499992,
							30.47758936400004
						],
						[
							-81.43104280999995,
							30.478074290000055
						],
						[
							-81.43065486899991,
							30.47977153200009
						],
						[
							-81.43048514499992,
							30.480741384000055
						],
						[
							-81.43002446499992,
							30.481783976000088
						],
						[
							-81.4294667989999,
							30.482196163000083
						],
						[
							-81.4290546119999,
							30.482147671000067
						],
						[
							-81.42854543899995,
							30.481808222000044
						],
						[
							-81.4281817449999,
							30.48120206400006
						],
						[
							-81.42781804999993,
							30.48105658600008
						],
						[
							-81.42730887699992,
							30.480983848000047
						],
						[
							-81.4268481979999,
							30.481129325000044
						],
						[
							-81.42626628599993,
							30.481444528000058
						],
						[
							-81.42566012799995,
							30.481808222000044
						],
						[
							-81.4250782169999,
							30.482123424000065
						],
						[
							-81.42473876799994,
							30.48241438000008
						],
						[
							-81.42430233499994,
							30.482996292000053
						],
						[
							-81.42395944899994,
							30.484449894000075
						],
						[
							-81.42388425699994,
							30.484471783000057
						],
						[
							-81.42380739999993,
							30.484486814000036
						],
						[
							-81.4237295019999,
							30.48449486600003
						],
						[
							-81.42365119499993,
							30.484495873000075
						],
						[
							-81.42357311599994,
							30.484489828000047
						],
						[
							-81.41120674399991,
							30.482995534000054
						],
						[
							-81.41069737099991,
							30.482931242000067
						],
						[
							-81.41065383499995,
							30.48292466000004
						],
						[
							-81.41050241399995,
							30.482884087000055
						],
						[
							-81.41036033899991,
							30.482817836000038
						],
						[
							-81.41023192699993,
							30.482727921000052
						],
						[
							-81.4101210799999,
							30.48261707300009
						],
						[
							-81.4100311649999,
							30.482488661000044
						],
						[
							-81.40996491399994,
							30.48234658700005
						],
						[
							-81.40992434099991,
							30.482195166000054
						],
						[
							-81.4099124839999,
							30.482095963000067
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Little Talbot Island",
				"RegionID": "416697"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.96967999999993,
					28.06585805600008,
					-81.96690999999994,
					28.067984292000062
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.9671626299999,
							28.065909597000086
						],
						[
							-81.9671634739999,
							28.06585805600008
						],
						[
							-81.96752457499991,
							28.065914228000054
						],
						[
							-81.9678049449999,
							28.06593759200007
						],
						[
							-81.96872081999993,
							28.065942265000047
						],
						[
							-81.96966930899993,
							28.06595081000006
						],
						[
							-81.96967121099993,
							28.066044936000086
						],
						[
							-81.96967272099994,
							28.06611967100008
						],
						[
							-81.96967451899991,
							28.06620870200004
						],
						[
							-81.96967612299994,
							28.066288108000037
						],
						[
							-81.9696774439999,
							28.066353501000037
						],
						[
							-81.9696787659999,
							28.066418893000048
						],
						[
							-81.96967999999993,
							28.06648000000007
						],
						[
							-81.96967999999993,
							28.066531042000065
						],
						[
							-81.96967999999993,
							28.066591789000086
						],
						[
							-81.9696739449999,
							28.066647841000076
						],
						[
							-81.9696702999999,
							28.06667062200006
						],
						[
							-81.96966362299992,
							28.066712357000085
						],
						[
							-81.9696545249999,
							28.066769218000047
						],
						[
							-81.96964469799991,
							28.066830636000077
						],
						[
							-81.96963999999991,
							28.066895523000085
						],
						[
							-81.96963999999991,
							28.066965615000072
						],
						[
							-81.96963999999991,
							28.06711047300007
						],
						[
							-81.96963999999991,
							28.067325423000057
						],
						[
							-81.96963999999991,
							28.067531028000076
						],
						[
							-81.96963999999991,
							28.06785812600009
						],
						[
							-81.96963999999991,
							28.067984292000062
						],
						[
							-81.96913202899992,
							28.067984292000062
						],
						[
							-81.96846381499995,
							28.06775065100004
						],
						[
							-81.96690999999994,
							28.06711000000007
						],
						[
							-81.96692898899994,
							28.06707202200005
						],
						[
							-81.96695796199992,
							28.067007250000074
						],
						[
							-81.9669863009999,
							28.066926282000054
						],
						[
							-81.96701609699994,
							28.066841151000066
						],
						[
							-81.9670394819999,
							28.066774337000084
						],
						[
							-81.96706782099994,
							28.066693369000063
						],
						[
							-81.96708999999993,
							28.066630000000092
						],
						[
							-81.96710707099993,
							28.066578787000083
						],
						[
							-81.96712493599995,
							28.066510385000072
						],
						[
							-81.96714173299995,
							28.066409603000068
						],
						[
							-81.96715802499995,
							28.06631185200007
						],
						[
							-81.96715999999992,
							28.06625067200008
						],
						[
							-81.96715999999992,
							28.066143197000088
						],
						[
							-81.96715999999992,
							28.06607000000008
						],
						[
							-81.9671617109999,
							28.06596565600006
						],
						[
							-81.9671626299999,
							28.065909597000086
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Polk",
				"City": "Lakeland",
				"Name": "Harmony Hills",
				"RegionID": "416698"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.67314599999992,
					27.87880000000007,
					-82.65522326999991,
					27.893708381000067
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.65522326999991,
							27.89370673700006
						],
						[
							-82.65525415099995,
							27.890688010000076
						],
						[
							-82.6559343699999,
							27.890842605000046
						],
						[
							-82.65707865099995,
							27.89080017000009
						],
						[
							-82.65744541999993,
							27.89080017000009
						],
						[
							-82.65762880499994,
							27.89072681600004
						],
						[
							-82.65843569799995,
							27.89032337000009
						],
						[
							-82.65883914399991,
							27.89010330800005
						],
						[
							-82.65953600599995,
							27.889186385000073
						],
						[
							-82.66020841599993,
							27.888330590000066
						],
						[
							-82.66035805999991,
							27.888145139000077
						],
						[
							-82.66018800099994,
							27.887903475000087
						],
						[
							-82.6600987089999,
							27.887776586000086
						],
						[
							-82.66004444799995,
							27.88766124400007
						],
						[
							-82.65961249799994,
							27.887852106000082
						],
						[
							-82.65941327699994,
							27.88795835700006
						],
						[
							-82.6590148329999,
							27.887998201000073
						],
						[
							-82.6584038869999,
							27.887931794000053
						],
						[
							-82.65832419799995,
							27.887785698000073
						],
						[
							-82.65849685699993,
							27.887201315000084
						],
						[
							-82.65857654599995,
							27.886855997000055
						],
						[
							-82.6586296719999,
							27.886417710000046
						],
						[
							-82.6586296719999,
							27.885421601000075
						],
						[
							-82.65853670099995,
							27.885408320000067
						],
						[
							-82.65815153999995,
							27.885421601000075
						],
						[
							-82.65792575499995,
							27.88548800900009
						],
						[
							-82.6577265329999,
							27.885647386000073
						],
						[
							-82.65758043799991,
							27.885700512000085
						],
						[
							-82.65746090499994,
							27.885474727000087
						],
						[
							-82.65735465299991,
							27.88516925400006
						],
						[
							-82.65718199399994,
							27.88523566100008
						],
						[
							-82.65695620999992,
							27.885355194000056
						],
						[
							-82.65682339499995,
							27.885434883000073
						],
						[
							-82.65661089199995,
							27.885434883000073
						],
						[
							-82.6564780779999,
							27.885355194000056
						],
						[
							-82.6562257299999,
							27.88502315800008
						],
						[
							-82.65615932299994,
							27.884292679000055
						],
						[
							-82.65580072399992,
							27.883163756000044
						],
						[
							-82.6554686689999,
							27.882672324000055
						],
						[
							-82.65562528299995,
							27.882509801000083
						],
						[
							-82.65582177199991,
							27.882308228000056
						],
						[
							-82.65640202999992,
							27.881693862000077
						],
						[
							-82.65690528399995,
							27.881148135000046
						],
						[
							-82.6572162089999,
							27.880807798000035
						],
						[
							-82.65751551299992,
							27.880482320000056
						],
						[
							-82.65788999999995,
							27.880090000000052
						],
						[
							-82.65804535099996,
							27.879923142000052
						],
						[
							-82.65825045999992,
							27.87970283900006
						],
						[
							-82.65857068699995,
							27.879358892000088
						],
						[
							-82.65893999999992,
							27.878970000000038
						],
						[
							-82.65910999999994,
							27.87880000000007
						],
						[
							-82.6593175829999,
							27.87895244400005
						],
						[
							-82.65955755499994,
							27.879128673000082
						],
						[
							-82.65974999999992,
							27.879270000000076
						],
						[
							-82.65993642199993,
							27.879397552000057
						],
						[
							-82.66045071899993,
							27.87977495800004
						],
						[
							-82.6609382069999,
							27.880134227000042
						],
						[
							-82.66129896399991,
							27.88040158800004
						],
						[
							-82.6616631359999,
							27.880673021000064
						],
						[
							-82.66219138999992,
							27.88106675100005
						],
						[
							-82.66260026899994,
							27.88137150500006
						],
						[
							-82.66287999999992,
							27.881580000000042
						],
						[
							-82.66304785099993,
							27.88170427400007
						],
						[
							-82.66356002399993,
							27.882083479000073
						],
						[
							-82.66417893999994,
							27.882537940000077
						],
						[
							-82.66531469599995,
							27.883384096000043
						],
						[
							-82.6664019349999,
							27.884181237000064
						],
						[
							-82.66715703099993,
							27.884722408000073
						],
						[
							-82.66790830999992,
							27.885269005000055
						],
						[
							-82.66906999999992,
							27.88610000000006
						],
						[
							-82.6691146309999,
							27.886253022000062
						],
						[
							-82.66910599999994,
							27.88626000000005
						],
						[
							-82.66911978699994,
							27.88627070000007
						],
						[
							-82.66920945399994,
							27.88634028200005
						],
						[
							-82.67055699999992,
							27.88738600000005
						],
						[
							-82.67066299999993,
							27.887469000000067
						],
						[
							-82.67167899999993,
							27.888171000000057
						],
						[
							-82.67236199999991,
							27.888825000000054
						],
						[
							-82.6727929999999,
							27.88936700000005
						],
						[
							-82.67283099999992,
							27.889407000000062
						],
						[
							-82.67283199999991,
							27.889567000000056
						],
						[
							-82.67289599999992,
							27.88973300000004
						],
						[
							-82.67293399999994,
							27.889989000000075
						],
						[
							-82.67298499999993,
							27.890206000000035
						],
						[
							-82.67309099999994,
							27.890613000000087
						],
						[
							-82.67311699999993,
							27.890820000000076
						],
						[
							-82.67314599999992,
							27.89112300000005
						],
						[
							-82.67314599999992,
							27.89125400000006
						],
						[
							-82.67314599999992,
							27.891493000000082
						],
						[
							-82.67311199999995,
							27.891988000000083
						],
						[
							-82.67307573799991,
							27.892356929000073
						],
						[
							-82.67304299999995,
							27.892690000000073
						],
						[
							-82.67301399999991,
							27.892880000000048
						],
						[
							-82.67296599999992,
							27.893147000000056
						],
						[
							-82.67288699999995,
							27.893261000000052
						],
						[
							-82.67279599999995,
							27.893376000000046
						],
						[
							-82.67262599999992,
							27.893496000000084
						],
						[
							-82.6724549999999,
							27.893562000000088
						],
						[
							-82.67215299999992,
							27.893660000000068
						],
						[
							-82.66815699999995,
							27.893643000000054
						],
						[
							-82.66508699999993,
							27.893673000000035
						],
						[
							-82.66280799999993,
							27.893673000000035
						],
						[
							-82.66118099999994,
							27.89358100000004
						],
						[
							-82.66023599999994,
							27.893557000000044
						],
						[
							-82.65981699999992,
							27.89353900000009
						],
						[
							-82.65933899999993,
							27.893519000000083
						],
						[
							-82.65813903999992,
							27.893412056000045
						],
						[
							-82.65791399999996,
							27.893392000000063
						],
						[
							-82.65790547699993,
							27.893707472000074
						],
						[
							-82.65782813399994,
							27.893706988000076
						],
						[
							-82.65763489799991,
							27.89370578100005
						],
						[
							-82.65746484999994,
							27.893704718000038
						],
						[
							-82.65714794199995,
							27.89370273700007
						],
						[
							-82.65686195199993,
							27.89370095000004
						],
						[
							-82.65670999999992,
							27.89370000000008
						],
						[
							-82.65659139999991,
							27.89370000000008
						],
						[
							-82.65640588499991,
							27.89370000000008
						],
						[
							-82.65575658499995,
							27.89370000000008
						],
						[
							-82.65537784799994,
							27.893708381000067
						],
						[
							-82.65522326999991,
							27.89370673700006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Carillon",
				"RegionID": "417206"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.78314607199997,
					26.160179,
					-81.76695891299994,
					26.167929473000072
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.781894,
							26.160266
						],
						[
							-81.782302,
							26.160179
						],
						[
							-81.78314607199997,
							26.160188665000078
						],
						[
							-81.78313349299998,
							26.16045282500005
						],
						[
							-81.78286540599998,
							26.160959212000023
						],
						[
							-81.78283561899998,
							26.161584748000053
						],
						[
							-81.78283561899998,
							26.165546478000067
						],
						[
							-81.78274625599994,
							26.16587413900004
						],
						[
							-81.78051219799994,
							26.166886912000056
						],
						[
							-81.778798,
							26.167588
						],
						[
							-81.778271,
							26.167801
						],
						[
							-81.76701848799996,
							26.167929473000072
						],
						[
							-81.76695891299994,
							26.16420604300004
						],
						[
							-81.76981850699997,
							26.164116680000063
						],
						[
							-81.77762281699995,
							26.164116680000063
						],
						[
							-81.77762281699995,
							26.163312419000082
						],
						[
							-81.77786111599994,
							26.16224007200003
						],
						[
							-81.77836750299997,
							26.160869849000054
						],
						[
							-81.77836750299997,
							26.160314334000077
						],
						[
							-81.778791,
							26.160305
						],
						[
							-81.781894,
							26.160266
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Collier",
				"City": "Naples",
				"Name": "River Reach",
				"RegionID": "426282"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.12246699999992,
					25.986168000000077,
					-80.10936880399993,
					26.03429344400007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.10936880399993,
							26.034257095000047
						],
						[
							-80.1102168459999,
							26.02741366300006
						],
						[
							-80.11050999999992,
							26.025048000000083
						],
						[
							-80.11231599999991,
							26.010469000000057
						],
						[
							-80.11259903399991,
							26.00818551900005
						],
						[
							-80.1126127949999,
							26.008074493000038
						],
						[
							-80.11356799999993,
							26.000368000000037
						],
						[
							-80.11521099999993,
							25.986999000000083
						],
						[
							-80.1177199999999,
							25.986998000000085
						],
						[
							-80.11837799999995,
							25.986998000000085
						],
						[
							-80.11839499999991,
							25.986828000000063
						],
						[
							-80.1184419999999,
							25.98637800000006
						],
						[
							-80.11966599999994,
							25.986368000000084
						],
						[
							-80.12126699999993,
							25.986168000000077
						],
						[
							-80.12216699999993,
							25.986168000000077
						],
						[
							-80.12246699999992,
							25.986268000000052
						],
						[
							-80.1213669999999,
							25.99016800000004
						],
						[
							-80.1202659999999,
							25.99426800000009
						],
						[
							-80.11976599999991,
							25.997168000000045
						],
						[
							-80.1188874039999,
							26.00561783900008
						],
						[
							-80.11807710499994,
							26.01534143500004
						],
						[
							-80.11771697099994,
							26.01858263400004
						],
						[
							-80.11785202099993,
							26.021328649000054
						],
						[
							-80.11753690499995,
							26.03429344400007
						],
						[
							-80.1104692909999,
							26.03429344400007
						],
						[
							-80.10936880399993,
							26.034257095000047
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Hollywood",
				"Name": "South Central Beach",
				"RegionID": "623405"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.12993652599994,
					25.797350065000046,
					-80.11651180599995,
					25.84461122500005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.12424150299995,
							25.797350065000046
						],
						[
							-80.1259816619999,
							25.79788276700009
						],
						[
							-80.1280769569999,
							25.798379956000076
						],
						[
							-80.1294264679999,
							25.798770604000083
						],
						[
							-80.12993652599994,
							25.799189334000065
						],
						[
							-80.12729566099995,
							25.800581790000084
						],
						[
							-80.12690501199995,
							25.802854652000065
						],
						[
							-80.12697603899994,
							25.804701352000052
						],
						[
							-80.12612371599994,
							25.806796646000066
						],
						[
							-80.12488074499994,
							25.808572319000064
						],
						[
							-80.12491625899992,
							25.81198161100008
						],
						[
							-80.1246676639999,
							25.81350869000005
						],
						[
							-80.12432790899993,
							25.81515872700004
						],
						[
							-80.12407921499994,
							25.816828531000056
						],
						[
							-80.12372393699991,
							25.818782557000077
						],
						[
							-80.12365288199993,
							25.82109186000008
						],
						[
							-80.1234397149999,
							25.822584025000083
						],
						[
							-80.12294232699992,
							25.824644634000038
						],
						[
							-80.12287241599995,
							25.826685068000074
						],
						[
							-80.12287241599995,
							25.82735599600005
						],
						[
							-80.1230587849999,
							25.82970424200005
						],
						[
							-80.12298423699991,
							25.83197794000006
						],
						[
							-80.1225369519999,
							25.833580712000074
						],
						[
							-80.12235058399995,
							25.835034388000054
						],
						[
							-80.12276059499993,
							25.84055090200008
						],
						[
							-80.12235058399995,
							25.84204185200008
						],
						[
							-80.1222760359999,
							25.844390098000076
						],
						[
							-80.12063302399991,
							25.84461122500005
						],
						[
							-80.11651180599995,
							25.84439805900007
						],
						[
							-80.1166531209999,
							25.818971914000088
						],
						[
							-80.12424150299995,
							25.797350065000046
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Beach",
				"Name": "Oceanfront",
				"RegionID": "623406"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.14846168299994,
					25.809389129000067,
					-80.12287241599995,
					25.826685068000074
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.1246676639999,
							25.81350869000005
						],
						[
							-80.12672744499991,
							25.813792798000065
						],
						[
							-80.12825452399994,
							25.813863825000055
						],
						[
							-80.13013673699993,
							25.813934852000045
						],
						[
							-80.13269370699993,
							25.813863825000055
						],
						[
							-80.13280024699992,
							25.812159179000048
						],
						[
							-80.13329743499992,
							25.810738640000068
						],
						[
							-80.13390116399995,
							25.809921831000054
						],
						[
							-80.13517964899995,
							25.809389129000067
						],
						[
							-80.13663570099993,
							25.809495669000057
						],
						[
							-80.13798521199993,
							25.809744263000084
						],
						[
							-80.14846168299994,
							25.809850804000064
						],
						[
							-80.1421628359999,
							25.818640446000074
						],
						[
							-80.13761528499992,
							25.826669715000037
						],
						[
							-80.13435272999993,
							25.826610521000077
						],
						[
							-80.13293632799991,
							25.825156845000038
						],
						[
							-80.13189266299992,
							25.823964085000057
						],
						[
							-80.13066262899991,
							25.82362862100007
						],
						[
							-80.12958169099994,
							25.823218610000083
						],
						[
							-80.1269725279999,
							25.823106789000065
						],
						[
							-80.12645069599995,
							25.823777716000052
						],
						[
							-80.1259288629999,
							25.824933202000068
						],
						[
							-80.12581704199994,
							25.825865046000047
						],
						[
							-80.12555612599994,
							25.826424152000072
						],
						[
							-80.1248851979999,
							25.82653597300009
						],
						[
							-80.12287241599995,
							25.826685068000074
						],
						[
							-80.12294232699992,
							25.824644634000038
						],
						[
							-80.1234397149999,
							25.822584025000083
						],
						[
							-80.12365288199993,
							25.82109186000008
						],
						[
							-80.12372393699991,
							25.818782557000077
						],
						[
							-80.12407921499994,
							25.816828531000056
						],
						[
							-80.12432790899993,
							25.81515872700004
						],
						[
							-80.1246676639999,
							25.81350869000005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Beach",
				"Name": "Nautilus",
				"RegionID": "623407"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.9738677979999,
					28.065500000000043,
					-81.9716616689999,
					28.068946256000064
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.9736036349999,
							28.065500000000043
						],
						[
							-81.9738677979999,
							28.065500000000043
						],
						[
							-81.97384805099996,
							28.068946256000064
						],
						[
							-81.97167167899995,
							28.068946256000064
						],
						[
							-81.9716616689999,
							28.065500000000043
						],
						[
							-81.97172172999991,
							28.065500000000043
						],
						[
							-81.97265767699992,
							28.065500000000043
						],
						[
							-81.97321824499994,
							28.065500000000043
						],
						[
							-81.9736036349999,
							28.065500000000043
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Polk",
				"City": "Lakeland",
				"Name": "Orangewood",
				"RegionID": "416699"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.96273262799991,
					28.06788000000006,
					-81.95734293899994,
					28.069754010000057
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.95777490899991,
							28.069754010000057
						],
						[
							-81.95741091799994,
							28.069745993000083
						],
						[
							-81.95738291099991,
							28.069528012000035
						],
						[
							-81.95734990999995,
							28.06896801000005
						],
						[
							-81.95734990999995,
							28.068784011000048
						],
						[
							-81.95734293899994,
							28.067930458000035
						],
						[
							-81.9575982209999,
							28.06792845700005
						],
						[
							-81.95793072799995,
							28.067925406000086
						],
						[
							-81.95823544899991,
							28.067922611000085
						],
						[
							-81.95864174399992,
							28.06791888300006
						],
						[
							-81.95903880399993,
							28.067915240000048
						],
						[
							-81.95930658899994,
							28.067912784000043
						],
						[
							-81.95960999999994,
							28.06791000000004
						],
						[
							-81.95978704299995,
							28.067907129000048
						],
						[
							-81.95995322499994,
							28.06790443400007
						],
						[
							-81.96031328499993,
							28.067898595000088
						],
						[
							-81.96063641599994,
							28.06789335500008
						],
						[
							-81.96098724399992,
							28.067887666000047
						],
						[
							-81.96128282799992,
							28.067882873000087
						],
						[
							-81.96145999999993,
							28.06788000000006
						],
						[
							-81.96160595899994,
							28.067881871000054
						],
						[
							-81.96171675799991,
							28.06788329200009
						],
						[
							-81.9618830739999,
							28.067885424000053
						],
						[
							-81.96200310599994,
							28.067886963000035
						],
						[
							-81.96223999999995,
							28.06789000000009
						],
						[
							-81.9623540039999,
							28.06789000000009
						],
						[
							-81.96254793299994,
							28.06789000000009
						],
						[
							-81.96273262799991,
							28.06789000000009
						],
						[
							-81.96272339299992,
							28.06895998500005
						],
						[
							-81.9614735429999,
							28.06896005100009
						],
						[
							-81.96148315799991,
							28.06942158800007
						],
						[
							-81.96148566199992,
							28.069541780000066
						],
						[
							-81.96148758499994,
							28.069634087000054
						],
						[
							-81.96149003999994,
							28.069753878000085
						],
						[
							-81.95899790899995,
							28.06974701000007
						],
						[
							-81.95777490899991,
							28.069754010000057
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Polk",
				"City": "Lakeland",
				"Name": "Valencia Heights",
				"RegionID": "416700"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.5469240409999,
					27.34396000000004,
					-82.54470101599992,
					27.345000552000045
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.54471933799994,
							27.344020878000038
						],
						[
							-82.54471999999993,
							27.34396000000004
						],
						[
							-82.54487401199992,
							27.343960786000082
						],
						[
							-82.54500353799995,
							27.343961447000083
						],
						[
							-82.54506451099991,
							27.343961758000034
						],
						[
							-82.54523975299992,
							27.343962652000073
						],
						[
							-82.5454949949999,
							27.34396395400006
						],
						[
							-82.54568928499992,
							27.34396494500004
						],
						[
							-82.54576168599993,
							27.343965315000048
						],
						[
							-82.5460016909999,
							27.343966539000064
						],
						[
							-82.5462188379999,
							27.34396764700006
						],
						[
							-82.54632169699994,
							27.343968172000075
						],
						[
							-82.54637504999995,
							27.34396844400004
						],
						[
							-82.54654267199993,
							27.343969299000037
						],
						[
							-82.54664172199995,
							27.343969805000086
						],
						[
							-82.54680626899994,
							27.34397064400008
						],
						[
							-82.54680882899993,
							27.34433855700007
						],
						[
							-82.54686639499994,
							27.34466476600005
						],
						[
							-82.5469240409999,
							27.345000552000045
						],
						[
							-82.54470101599992,
							27.344975719000047
						],
						[
							-82.54470253499994,
							27.34495465400005
						],
						[
							-82.54470483499995,
							27.344931645000088
						],
						[
							-82.54470713599996,
							27.34490863600007
						],
						[
							-82.5447086829999,
							27.34489317100008
						],
						[
							-82.54470999999995,
							27.34488000000005
						],
						[
							-82.54471039299995,
							27.344843799000046
						],
						[
							-82.54471122199993,
							27.34476761400009
						],
						[
							-82.54471225799995,
							27.34467230000007
						],
						[
							-82.54471374799994,
							27.34453520900007
						],
						[
							-82.54471465899991,
							27.344451405000086
						],
						[
							-82.54471532199994,
							27.344390416000067
						],
						[
							-82.54471685399996,
							27.344249474000037
						],
						[
							-82.54471809599994,
							27.34413519700007
						],
						[
							-82.54471846899992,
							27.34410087200007
						],
						[
							-82.54471933799994,
							27.344020878000038
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Jefferson Center",
				"RegionID": "417064"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.5221499999999,
					27.341240000000084,
					-82.52007964799992,
					27.34303000000006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.5201199999999,
							27.34209000000004
						],
						[
							-82.5201199999999,
							27.341857174000044
						],
						[
							-82.5201199999999,
							27.341694784000083
						],
						[
							-82.5201199999999,
							27.341470000000072
						],
						[
							-82.5201199999999,
							27.34124821000006
						],
						[
							-82.52085999999993,
							27.341240000000084
						],
						[
							-82.52103295199993,
							27.341259217000072
						],
						[
							-82.5211978179999,
							27.341277535000074
						],
						[
							-82.52136432499992,
							27.341299877000043
						],
						[
							-82.52152151899992,
							27.341328458000078
						],
						[
							-82.52168172999991,
							27.34129921400006
						],
						[
							-82.5217987069999,
							27.341275480000036
						],
						[
							-82.52182568899993,
							27.34207253200009
						],
						[
							-82.5219699999999,
							27.34207000000004
						],
						[
							-82.52214843199994,
							27.34205957000006
						],
						[
							-82.52214414799994,
							27.342222382000045
						],
						[
							-82.5221377279999,
							27.34246633300006
						],
						[
							-82.52213025499992,
							27.34275031900006
						],
						[
							-82.52213760099994,
							27.34285120700008
						],
						[
							-82.5221499999999,
							27.343000000000075
						],
						[
							-82.52202881599995,
							27.34301000000005
						],
						[
							-82.52186642599992,
							27.34301000000005
						],
						[
							-82.52165999999994,
							27.34301000000005
						],
						[
							-82.52123716599995,
							27.343014451000048
						],
						[
							-82.52062819999992,
							27.34302000000008
						],
						[
							-82.52026315799992,
							27.34302127800004
						],
						[
							-82.52007999999995,
							27.34303000000006
						],
						[
							-82.52007964799992,
							27.343029801000057
						],
						[
							-82.52008761999993,
							27.34291188500004
						],
						[
							-82.52009544499992,
							27.34279059700009
						],
						[
							-82.52010189399994,
							27.342608254000083
						],
						[
							-82.52010636499995,
							27.342344446000084
						],
						[
							-82.52010999999993,
							27.342130000000054
						],
						[
							-82.5201199999999,
							27.34209000000004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Jefferson Pines",
				"RegionID": "417065"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.50570999999991,
					27.34402109100006,
					-82.50142476199994,
					27.34679975000006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.50218732699994,
							27.344052429000044
						],
						[
							-82.50391093099995,
							27.34402109100006
						],
						[
							-82.50499732499992,
							27.344026314000075
						],
						[
							-82.50516446199993,
							27.34407854400007
						],
						[
							-82.50532637599991,
							27.344088990000046
						],
						[
							-82.50570999999991,
							27.344101995000074
						],
						[
							-82.50570999999991,
							27.344235236000088
						],
						[
							-82.50570999999991,
							27.34449116500008
						],
						[
							-82.50570999999991,
							27.34475754000005
						],
						[
							-82.50570999999991,
							27.34496000000007
						],
						[
							-82.50570999999991,
							27.345039584000062
						],
						[
							-82.50570852599992,
							27.345227686000044
						],
						[
							-82.50570459999994,
							27.345274802000066
						],
						[
							-82.50570157399994,
							27.345311111000058
						],
						[
							-82.50569999999993,
							27.345330000000047
						],
						[
							-82.50570208999994,
							27.34536343500008
						],
						[
							-82.50570633699994,
							27.34543139500005
						],
						[
							-82.50570999999991,
							27.345561889000066
						],
						[
							-82.50570999999991,
							27.34580737200008
						],
						[
							-82.50570999999991,
							27.34585615600008
						],
						[
							-82.50570999999991,
							27.346031963000087
						],
						[
							-82.50570999999991,
							27.346235661000037
						],
						[
							-82.50570999999991,
							27.346350000000086
						],
						[
							-82.50570999999991,
							27.346491591000074
						],
						[
							-82.50570999999991,
							27.346674397000076
						],
						[
							-82.50570999999991,
							27.34679975000006
						],
						[
							-82.50288199199991,
							27.346794527000043
						],
						[
							-82.50153444599994,
							27.346789304000083
						],
						[
							-82.5015396689999,
							27.345838710000066
						],
						[
							-82.50157623099996,
							27.344929900000068
						],
						[
							-82.50179559799994,
							27.344929900000068
						],
						[
							-82.50174859099991,
							27.344794101000048
						],
						[
							-82.50163890699991,
							27.34445982600005
						],
						[
							-82.50142476199994,
							27.344052429000044
						],
						[
							-82.50218732699994,
							27.344052429000044
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Ramblewood Acres",
				"RegionID": "417066"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.51053569399994,
					27.34585615600008,
					-82.50570999999991,
					27.348644215000036
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.50570999999991,
							27.346031963000087
						],
						[
							-82.50570999999991,
							27.34585615600008
						],
						[
							-82.5097826409999,
							27.345948716000066
						],
						[
							-82.5104561789999,
							27.346421129000078
						],
						[
							-82.51053569399994,
							27.347950623000088
						],
						[
							-82.51053101699995,
							27.34862000000004
						],
						[
							-82.5104795659999,
							27.34862000000004
						],
						[
							-82.51028311699991,
							27.34862000000004
						],
						[
							-82.51006795899991,
							27.34862000000004
						],
						[
							-82.50989489699992,
							27.34862000000004
						],
						[
							-82.50986287799992,
							27.348644211000078
						],
						[
							-82.50571796799994,
							27.348644215000036
						],
						[
							-82.50570999999991,
							27.34859000000006
						],
						[
							-82.50570999999991,
							27.348465132000058
						],
						[
							-82.50570999999991,
							27.34821723200008
						],
						[
							-82.50570999999991,
							27.34777288400005
						],
						[
							-82.50570999999991,
							27.34761000000009
						],
						[
							-82.50570999999991,
							27.347553048000066
						],
						[
							-82.50570999999991,
							27.347464178000052
						],
						[
							-82.50570999999991,
							27.347360000000037
						],
						[
							-82.50570999999991,
							27.347263052000073
						],
						[
							-82.50570999999991,
							27.347160150000036
						],
						[
							-82.50570999999991,
							27.34693563700006
						],
						[
							-82.50570999999991,
							27.34679975000006
						],
						[
							-82.50570999999991,
							27.346674397000076
						],
						[
							-82.50570999999991,
							27.346491591000074
						],
						[
							-82.50570999999991,
							27.346350000000086
						],
						[
							-82.50570999999991,
							27.346235661000037
						],
						[
							-82.50570999999991,
							27.346031963000087
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Lake Ridge",
				"RegionID": "417067"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.73665999999992,
					27.770800000000065,
					-82.72830999999991,
					27.777194585000075
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.7355700889999,
							27.777179027000045
						],
						[
							-82.7348069439999,
							27.777160000000038
						],
						[
							-82.73431275799993,
							27.777160000000038
						],
						[
							-82.7334591629999,
							27.777160000000038
						],
						[
							-82.73292005099995,
							27.777160000000038
						],
						[
							-82.7313028069999,
							27.777168292000056
						],
						[
							-82.7300449299999,
							27.777147848000084
						],
						[
							-82.72905620599994,
							27.777134887000045
						],
						[
							-82.72830999999991,
							27.777130000000056
						],
						[
							-82.72831305299991,
							27.77688579700009
						],
						[
							-82.7283175579999,
							27.776525322000055
						],
						[
							-82.72831999999994,
							27.776330000000087
						],
						[
							-82.72832232099995,
							27.776121069000055
						],
						[
							-82.72832731299991,
							27.77567186400006
						],
						[
							-82.72832999999991,
							27.775430000000085
						],
						[
							-82.72833277199993,
							27.775177739000075
						],
						[
							-82.72833672099995,
							27.774818375000056
						],
						[
							-82.72833999999995,
							27.774520000000056
						],
						[
							-82.7283322909999,
							27.774188499000047
						],
						[
							-82.72837428899993,
							27.773515433000057
						],
						[
							-82.7283799999999,
							27.772850000000062
						],
						[
							-82.7283799999999,
							27.772572083000057
						],
						[
							-82.7283799999999,
							27.77216774900006
						],
						[
							-82.7283799999999,
							27.77174000000008
						],
						[
							-82.7283738559999,
							27.771223871000075
						],
						[
							-82.72837012699995,
							27.770860000000084
						],
						[
							-82.7286970049999,
							27.770860000000084
						],
						[
							-82.72919180199995,
							27.77085448100007
						],
						[
							-82.7299799999999,
							27.770800000000065
						],
						[
							-82.73071867599992,
							27.770840000000078
						],
						[
							-82.73161999999991,
							27.770840000000078
						],
						[
							-82.73180999999994,
							27.770850000000053
						],
						[
							-82.73229108699991,
							27.770850000000053
						],
						[
							-82.73310002199992,
							27.770843708000086
						],
						[
							-82.73363906599991,
							27.77083765100008
						],
						[
							-82.73452856099993,
							27.77083001200009
						],
						[
							-82.73479504999995,
							27.771057599000073
						],
						[
							-82.73505365699992,
							27.77129419700009
						],
						[
							-82.7352928439999,
							27.77149828800009
						],
						[
							-82.73556705099992,
							27.77176705100004
						],
						[
							-82.73586773099993,
							27.772136971000066
						],
						[
							-82.73601721099993,
							27.772329932000048
						],
						[
							-82.7361671829999,
							27.772590752000042
						],
						[
							-82.73631409699993,
							27.77289032500005
						],
						[
							-82.73643175199993,
							27.773167774000058
						],
						[
							-82.73652888599992,
							27.773479991000045
						],
						[
							-82.73658462899994,
							27.773828278000053
						],
						[
							-82.7365999939999,
							27.774054912000054
						],
						[
							-82.73662119799991,
							27.774367976000065
						],
						[
							-82.73662678599993,
							27.77472822100009
						],
						[
							-82.73662108299993,
							27.775133107000045
						],
						[
							-82.73663222599993,
							27.77549338700004
						],
						[
							-82.73664710999992,
							27.77585173600005
						],
						[
							-82.73665999999992,
							27.77657049900006
						],
						[
							-82.73665999999992,
							27.77719000000008
						],
						[
							-82.7362446759999,
							27.777194585000075
						],
						[
							-82.7355700889999,
							27.777179027000045
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Pasadena Vista",
				"RegionID": "417118"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.7369799999999,
					27.786900709000065,
					-82.72832999999991,
					27.791770000000046
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.73591848299992,
							27.79175575100004
						],
						[
							-82.73524265299994,
							27.791750000000036
						],
						[
							-82.73470888799994,
							27.791750000000036
						],
						[
							-82.73424629199991,
							27.791750000000036
						],
						[
							-82.73349902099994,
							27.791750000000036
						],
						[
							-82.7332143459999,
							27.791750000000036
						],
						[
							-82.73271616599993,
							27.791750000000036
						],
						[
							-82.73228915399996,
							27.791750000000036
						],
						[
							-82.73189751399991,
							27.791743619000048
						],
						[
							-82.73164148699993,
							27.79172632500007
						],
						[
							-82.73136231899991,
							27.791670028000055
						],
						[
							-82.73118999999991,
							27.79162000000008
						],
						[
							-82.73088824599996,
							27.79147437000006
						],
						[
							-82.7302463769999,
							27.79112189500006
						],
						[
							-82.7297189109999,
							27.790864024000086
						],
						[
							-82.72935930499995,
							27.790707791000045
						],
						[
							-82.72910653799994,
							27.79064191100008
						],
						[
							-82.72886833599995,
							27.790597149000064
						],
						[
							-82.72833934199991,
							27.790568516000064
						],
						[
							-82.72833999999995,
							27.790540000000078
						],
						[
							-82.72832999999991,
							27.78980000000007
						],
						[
							-82.72872730499995,
							27.78981293700008
						],
						[
							-82.72884407399994,
							27.789814515000046
						],
						[
							-82.72917417499991,
							27.78981897500006
						],
						[
							-82.72965966299995,
							27.789820000000077
						],
						[
							-82.73031998599993,
							27.789820000000077
						],
						[
							-82.73082353599995,
							27.789816616000053
						],
						[
							-82.73091232399993,
							27.789786606000064
						],
						[
							-82.73098999999992,
							27.78974000000005
						],
						[
							-82.73092873399992,
							27.78964372200005
						],
						[
							-82.73089835899992,
							27.789565764000088
						],
						[
							-82.73086364199992,
							27.78943384100006
						],
						[
							-82.73083944899992,
							27.789139995000088
						],
						[
							-82.73081959999992,
							27.788869554000087
						],
						[
							-82.73079975099995,
							27.78859911300009
						],
						[
							-82.73077653799993,
							27.788250367000046
						],
						[
							-82.73076999999995,
							27.788100000000043
						],
						[
							-82.7307573999999,
							27.787846999000067
						],
						[
							-82.73072154499994,
							27.787667726000052
						],
						[
							-82.73061871999994,
							27.78750259200007
						],
						[
							-82.73044762299992,
							27.787375676000067
						],
						[
							-82.73030999999992,
							27.787340000000086
						],
						[
							-82.73030259799992,
							27.78733085500005
						],
						[
							-82.73036216799994,
							27.787311018000086
						],
						[
							-82.73041311199995,
							27.787275795000085
						],
						[
							-82.73048509499995,
							27.78719781400008
						],
						[
							-82.73053848599994,
							27.78713997300008
						],
						[
							-82.73060522499992,
							27.78706767300008
						],
						[
							-82.7306584559999,
							27.787020772000062
						],
						[
							-82.73071316699992,
							27.786993417000076
						],
						[
							-82.73079999999995,
							27.786980000000085
						],
						[
							-82.73118282799993,
							27.786938011000075
						],
						[
							-82.73236406799992,
							27.78695044500006
						],
						[
							-82.73319715299994,
							27.786900709000065
						],
						[
							-82.73451516799992,
							27.78691314300005
						],
						[
							-82.73686726799991,
							27.78691314300005
						],
						[
							-82.73687271799992,
							27.787147943000036
						],
						[
							-82.73689605599992,
							27.788153409000074
						],
						[
							-82.73691828099993,
							27.789110935000053
						],
						[
							-82.73693344999992,
							27.78976448800006
						],
						[
							-82.73695445399994,
							27.790669407000053
						],
						[
							-82.73696614999994,
							27.79117330600008
						],
						[
							-82.7369799999999,
							27.791770000000046
						],
						[
							-82.7366305189999,
							27.791765309000084
						],
						[
							-82.73631031799994,
							27.791761011000062
						],
						[
							-82.73591848299992,
							27.79175575100004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Crosswinds Colony",
				"RegionID": "417131"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.7626331539999,
					27.790568516000064,
					-82.72832999999991,
					27.811029000000076
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-82.76124070299994,
								27.807249441000067
							],
							[
								-82.76131740199992,
								27.80724790900007
							],
							[
								-82.76139395399991,
								27.807252919000064
							],
							[
								-82.7615599529999,
								27.807270920000065
							],
							[
								-82.76161916599995,
								27.807279341000083
							],
							[
								-82.76174337099991,
								27.80731049900004
							],
							[
								-82.7618093829999,
								27.80733216400006
							],
							[
								-82.76191339499991,
								27.807366830000035
							],
							[
								-82.76197801499991,
								27.807391161000055
							],
							[
								-82.76204057599995,
								27.807420381000043
							],
							[
								-82.76210070899992,
								27.80745432000009
							],
							[
								-82.7621580579999,
								27.807492775000075
							],
							[
								-82.76221228499992,
								27.80753552100009
							],
							[
								-82.76232149599991,
								27.80762996100009
							],
							[
								-82.76242191999995,
								27.807731927000077
							],
							[
								-82.76249075599992,
								27.80782566000005
							],
							[
								-82.76255275599995,
								27.807922660000088
							],
							[
								-82.7625922769999,
								27.807990912000037
							],
							[
								-82.7626256659999,
								27.80806236400008
							],
							[
								-82.7626331539999,
								27.808082913000078
							],
							[
								-82.76161835199991,
								27.808216451000078
							],
							[
								-82.76133299999992,
								27.80825400000009
							],
							[
								-82.76104675199991,
								27.808240126000044
							],
							[
								-82.75999727099992,
								27.808189258000084
							],
							[
								-82.7600149139999,
								27.80812341400008
							],
							[
								-82.7600813599999,
								27.807981001000087
							],
							[
								-82.76015155499994,
								27.80785966300005
							],
							[
								-82.76019011799991,
								27.807798771000083
							],
							[
								-82.76023343299994,
								27.807741163000063
							],
							[
								-82.76028122299994,
								27.80768720900005
							],
							[
								-82.76033317999992,
								27.80763725500009
							],
							[
								-82.76038896999995,
								27.807591622000075
							],
							[
								-82.7604482349999,
								27.80755060300004
							],
							[
								-82.76054123599994,
								27.807491603000074
							],
							[
								-82.76064863099992,
								27.80743330300004
							],
							[
								-82.76072865499992,
								27.807396665000056
							],
							[
								-82.76081569099995,
								27.807356049000077
							],
							[
								-82.76088841399991,
								27.807325914000046
							],
							[
								-82.76098808799992,
								27.807296041000086
							],
							[
								-82.76108908799995,
								27.80727204100009
							],
							[
								-82.7611644129999,
								27.807257505000052
							],
							[
								-82.76124070299994,
								27.807249441000067
							]
						]
					],
					[
						[
							[
								-82.75284411299992,
								27.810055198000043
							],
							[
								-82.75204899999994,
								27.81004100000007
							],
							[
								-82.75201196899991,
								27.81004119000005
							],
							[
								-82.75146299999994,
								27.81004400000006
							],
							[
								-82.75142491199995,
								27.81004400000006
							],
							[
								-82.7506449999999,
								27.81004400000006
							],
							[
								-82.75059799999991,
								27.810040000000072
							],
							[
								-82.75057487599992,
								27.81004008700006
							],
							[
								-82.75006499999996,
								27.810042000000067
							],
							[
								-82.75006408699994,
								27.81003594300006
							],
							[
								-82.74976599999991,
								27.808058000000074
							],
							[
								-82.7484169999999,
								27.807994000000065
							],
							[
								-82.7477179999999,
								27.807984000000094
							],
							[
								-82.74723699999993,
								27.80797700000005
							],
							[
								-82.74673499999994,
								27.80797700000005
							],
							[
								-82.74563799999993,
								27.80795100000006
							],
							[
								-82.74458799999991,
								27.807950000000062
							],
							[
								-82.74435199999994,
								27.807948000000067
							],
							[
								-82.74413599999991,
								27.807940000000087
							],
							[
								-82.7440289999999,
								27.80810900000006
							],
							[
								-82.74239599999993,
								27.808134000000052
							],
							[
								-82.7418229999999,
								27.808143000000086
							],
							[
								-82.7409639999999,
								27.808156000000054
							],
							[
								-82.74013599999995,
								27.808163000000036
							],
							[
								-82.73960199999993,
								27.808182000000045
							],
							[
								-82.73906299999993,
								27.808166000000085
							],
							[
								-82.73828399999991,
								27.808152000000064
							],
							[
								-82.7374319999999,
								27.808150000000072
							],
							[
								-82.73690599999992,
								27.80816200000004
							],
							[
								-82.73660299999995,
								27.808183000000042
							],
							[
								-82.73638399999993,
								27.80818400000004
							],
							[
								-82.73572999999993,
								27.808181000000047
							],
							[
								-82.73567228899992,
								27.808182613000042
							],
							[
								-82.73555099999993,
								27.808186000000035
							],
							[
								-82.73554457199992,
								27.80818557500004
							],
							[
								-82.73554378099993,
								27.808185522000088
							],
							[
								-82.7348859999999,
								27.80814200000009
							],
							[
								-82.7346179999999,
								27.808140000000037
							],
							[
								-82.73418299999992,
								27.808141000000035
							],
							[
								-82.73379399999993,
								27.80814600000008
							],
							[
								-82.73277599999994,
								27.808165000000088
							],
							[
								-82.7326843489999,
								27.808163222000076
							],
							[
								-82.7322089999999,
								27.80815400000006
							],
							[
								-82.73096599999991,
								27.80814200000009
							],
							[
								-82.7303629999999,
								27.80815300000006
							],
							[
								-82.7302729999999,
								27.808155000000056
							],
							[
								-82.72859699999994,
								27.808171000000073
							],
							[
								-82.72853897699991,
								27.808171155000082
							],
							[
								-82.72854273799993,
								27.807705334000048
							],
							[
								-82.72854735699991,
								27.806887835000055
							],
							[
								-82.72854474799993,
								27.80557987300006
							],
							[
								-82.7285399999999,
								27.804653280000082
							],
							[
								-82.72852188699994,
								27.80372623100004
							],
							[
								-82.72851137999993,
								27.803119948000074
							],
							[
								-82.72849828199992,
								27.80236416400004
							],
							[
								-82.72847716199993,
								27.801001949000067
							],
							[
								-82.72846515599991,
								27.799856959000067
							],
							[
								-82.72845330199993,
								27.79849441400006
							],
							[
								-82.72844485899992,
								27.79789501500005
							],
							[
								-82.72843256899995,
								27.797022393000077
							],
							[
								-82.72841875399992,
								27.796041557000084
							],
							[
								-82.72839881499993,
								27.79500614500006
							],
							[
								-82.72838851099993,
								27.794624912000074
							],
							[
								-82.72836057199993,
								27.79326317200008
							],
							[
								-82.72834953099994,
								27.79288040600005
							],
							[
								-82.72833536299993,
								27.79162733700008
							],
							[
								-82.72832999999991,
								27.790973356000052
							],
							[
								-82.72833934199991,
								27.790568516000064
							],
							[
								-82.72886833599995,
								27.790597149000064
							],
							[
								-82.72910653799994,
								27.79064191100008
							],
							[
								-82.72935930499995,
								27.790707791000045
							],
							[
								-82.7297189109999,
								27.790864024000086
							],
							[
								-82.7302463769999,
								27.79112189500006
							],
							[
								-82.73088824599996,
								27.79147437000006
							],
							[
								-82.73118999999991,
								27.79162000000008
							],
							[
								-82.73136231899991,
								27.791670028000055
							],
							[
								-82.73164148699993,
								27.79172632500007
							],
							[
								-82.73189751399991,
								27.791743619000048
							],
							[
								-82.73228915399996,
								27.791750000000036
							],
							[
								-82.73271616599993,
								27.791750000000036
							],
							[
								-82.7332143459999,
								27.791750000000036
							],
							[
								-82.73349902099994,
								27.791750000000036
							],
							[
								-82.73424629199991,
								27.791750000000036
							],
							[
								-82.73470888799994,
								27.791750000000036
							],
							[
								-82.73524265299994,
								27.791750000000036
							],
							[
								-82.73591848299992,
								27.79175575100004
							],
							[
								-82.73631031799994,
								27.791761011000062
							],
							[
								-82.7366305189999,
								27.791765309000084
							],
							[
								-82.7369799999999,
								27.791770000000046
							],
							[
								-82.73769088799992,
								27.791770000000046
							],
							[
								-82.7387471959999,
								27.791770000000046
							],
							[
								-82.73932999999994,
								27.791770000000046
							],
							[
								-82.73990411999995,
								27.79177428400004
							],
							[
								-82.74066999999991,
								27.791780000000074
							],
							[
								-82.7412119139999,
								27.791780000000074
							],
							[
								-82.74157999999994,
								27.791780000000074
							],
							[
								-82.74206701999992,
								27.791780000000074
							],
							[
								-82.74243999999993,
								27.791780000000074
							],
							[
								-82.74287182599994,
								27.791780000000074
							],
							[
								-82.74330999999995,
								27.791780000000074
							],
							[
								-82.74372509599993,
								27.791799929000035
							],
							[
								-82.74414999999993,
								27.79184000000004
							],
							[
								-82.74457778099992,
								27.791988582000045
							],
							[
								-82.74496130499995,
								27.792137730000036
							],
							[
								-82.74518232899993,
								27.79219872100009
							],
							[
								-82.74558804499993,
								27.79224000000005
							],
							[
								-82.74689585499993,
								27.79224000000005
							],
							[
								-82.74765932799994,
								27.79224000000005
							],
							[
								-82.74765999999994,
								27.79224000000005
							],
							[
								-82.74840486599993,
								27.79224000000005
							],
							[
								-82.7491090709999,
								27.79224000000005
							],
							[
								-82.74972999999994,
								27.79224000000005
							],
							[
								-82.75026597899995,
								27.79224000000005
							],
							[
								-82.75122168599995,
								27.79224000000005
							],
							[
								-82.75176999999991,
								27.79224000000005
							],
							[
								-82.75257983099993,
								27.792233673000055
							],
							[
								-82.75323365199995,
								27.792232587000058
							],
							[
								-82.75377999999995,
								27.79224000000005
							],
							[
								-82.7537999999999,
								27.79228786400006
							],
							[
								-82.75380201599997,
								27.792396447000044
							],
							[
								-82.7542637119999,
								27.792396488000065
							],
							[
								-82.75427315799993,
								27.792264250000073
							],
							[
								-82.75521682199991,
								27.79224002600006
							],
							[
								-82.75520035099993,
								27.792136491000065
							],
							[
								-82.75518472899995,
								27.792038296000047
							],
							[
								-82.75516910699992,
								27.79194010000009
							],
							[
								-82.75515923099995,
								27.79187802100006
							],
							[
								-82.75514950099995,
								27.79181532000007
							],
							[
								-82.75578965799991,
								27.79181532000007
							],
							[
								-82.75667602299991,
								27.791637911000066
							],
							[
								-82.75673769299993,
								27.791895973000067
							],
							[
								-82.7567420659999,
								27.79191520200004
							],
							[
								-82.75677523499992,
								27.792068830000062
							],
							[
								-82.75688845299993,
								27.792488451000054
							],
							[
								-82.75695817199994,
								27.79269761000006
							],
							[
								-82.75699065999993,
								27.792825835000087
							],
							[
								-82.7570036539999,
								27.792947335000065
							],
							[
								-82.75701665399993,
								27.793284334000077
							],
							[
								-82.75701653999994,
								27.793356499000087
							],
							[
								-82.7569933499999,
								27.793912153000065
							],
							[
								-82.75701270999991,
								27.794091248000086
							],
							[
								-82.75714058999995,
								27.795443482000053
							],
							[
								-82.7572343519999,
								27.795773720000057
							],
							[
								-82.75737113399992,
								27.796066300000067
							],
							[
								-82.75752611599995,
								27.796325015000036
							],
							[
								-82.75759608699991,
								27.796473414000047
							],
							[
								-82.75761473599994,
								27.796530517000065
							],
							[
								-82.75767273499991,
								27.79673051700007
							],
							[
								-82.7577025139999,
								27.796878951000053
							],
							[
								-82.75774751299991,
								27.79727295100008
							],
							[
								-82.7577499599999,
								27.797297315000037
							],
							[
								-82.75778581399993,
								27.79771082500008
							],
							[
								-82.7578561709999,
								27.797922501000073
							],
							[
								-82.75793179499993,
								27.79809785200007
							],
							[
								-82.75795959599992,
								27.798170885000047
							],
							[
								-82.75798095099992,
								27.79824605600004
							],
							[
								-82.75799569999992,
								27.798322797000086
							],
							[
								-82.7580276999999,
								27.798539798000036
							],
							[
								-82.75803732199996,
								27.79867100000007
							],
							[
								-82.75803732199996,
								27.799048000000084
							],
							[
								-82.75803707299991,
								27.799069191000058
							],
							[
								-82.75803137299994,
								27.799311001000035
							],
							[
								-82.7580356439999,
								27.799385399000073
							],
							[
								-82.75803314299992,
								27.799459877000064
							],
							[
								-82.75802389099994,
								27.799533821000068
							],
							[
								-82.75800796399994,
								27.799606620000077
							],
							[
								-82.75798549399991,
								27.799677672000087
							],
							[
								-82.7580294569999,
								27.799707674000047
							],
							[
								-82.7580934579999,
								27.799758673000042
							],
							[
								-82.75811107299995,
								27.79977307900009
							],
							[
								-82.75822192099992,
								27.799883927000053
							],
							[
								-82.7583118359999,
								27.80001233900009
							],
							[
								-82.75837808699993,
								27.800154413000087
							],
							[
								-82.7584186599999,
								27.800305834000085
							],
							[
								-82.75842700399994,
								27.800364338000065
							],
							[
								-82.75844000399991,
								27.80048333800005
							],
							[
								-82.75844528899995,
								27.800573241000052
							],
							[
								-82.75845529599991,
								27.801739000000055
							],
							[
								-82.7584493039999,
								27.80268275800006
							],
							[
								-82.75844553099995,
								27.802759497000068
							],
							[
								-82.7584352209999,
								27.802835633000086
							],
							[
								-82.7584184509999,
								27.802910611000073
							],
							[
								-82.75839534199991,
								27.80298388500006
							],
							[
								-82.75836606299993,
								27.80305491900009
							],
							[
								-82.75833082799994,
								27.80312319400008
							],
							[
								-82.75827783099993,
								27.803215927000053
							],
							[
								-82.7581869199999,
								27.803346073000057
							],
							[
								-82.7581071919999,
								27.80342580100006
							],
							[
								-82.75840142599992,
								27.80407643200005
							],
							[
								-82.75841661599992,
								27.80411204300009
							],
							[
								-82.75859761599992,
								27.804563043000087
							],
							[
								-82.75862046099991,
								27.804626816000052
							],
							[
								-82.7586384409999,
								27.804692128000056
							],
							[
								-82.7586514539999,
								27.804758608000043
							],
							[
								-82.75865942599995,
								27.804825879000077
							],
							[
								-82.75866642499994,
								27.804912879000085
							],
							[
								-82.75866788399992,
								27.80493417400004
							],
							[
								-82.75867688499994,
								27.805093174000035
							],
							[
								-82.75867800099991,
								27.80516803800009
							],
							[
								-82.75864854899993,
								27.806269523000083
							],
							[
								-82.75868518399994,
								27.80655363900007
							],
							[
								-82.75875236499992,
								27.80693117700008
							],
							[
								-82.75877794799993,
								27.807074439000075
							],
							[
								-82.7589399609999,
								27.807490705000077
							],
							[
								-82.75900738199994,
								27.807530175000068
							],
							[
								-82.75907112999994,
								27.807575337000063
							],
							[
								-82.75913072499992,
								27.807625852000058
							],
							[
								-82.7593177249999,
								27.807798852000076
							],
							[
								-82.75936390599992,
								27.80784478900006
							],
							[
								-82.75940664099994,
								27.80789394900006
							],
							[
								-82.7594457049999,
								27.80794607200005
							],
							[
								-82.75948089399992,
								27.80800088700005
							],
							[
								-82.7595120229999,
								27.808058104000054
							],
							[
								-82.75956694999991,
								27.808168401000046
							],
							[
								-82.7582398209999,
								27.808104075000074
							],
							[
								-82.75819699999994,
								27.80810200000008
							],
							[
								-82.75799316299992,
								27.808145898000078
							],
							[
								-82.75766299999992,
								27.80821700000007
							],
							[
								-82.75559129999994,
								27.808192100000042
							],
							[
								-82.75558299999994,
								27.808192000000076
							],
							[
								-82.75552990099993,
								27.808191940000086
							],
							[
								-82.7554713259999,
								27.80819187500009
							],
							[
								-82.75380199999995,
								27.80819000000008
							],
							[
								-82.75381599999992,
								27.808617000000087
							],
							[
								-82.75319683599992,
								27.80874974200009
							],
							[
								-82.75312099999991,
								27.80876600000005
							],
							[
								-82.75274548099992,
								27.808290456000066
							],
							[
								-82.75267799999995,
								27.808205000000044
							],
							[
								-82.75134099999991,
								27.80820300000005
							],
							[
								-82.7511629999999,
								27.808208000000036
							],
							[
								-82.75383812299992,
								27.809784748000084
							],
							[
								-82.75386399999992,
								27.809800000000052
							],
							[
								-82.75387099999995,
								27.81005300000004
							],
							[
								-82.75386931999992,
								27.810407935000057
							],
							[
								-82.7538669999999,
								27.810898000000066
							],
							[
								-82.75376199999994,
								27.811029000000076
							],
							[
								-82.7536209999999,
								27.81095300000004
							],
							[
								-82.75317299999995,
								27.81085900000005
							],
							[
								-82.75309799999991,
								27.810848000000078
							],
							[
								-82.75311399999993,
								27.810725000000048
							],
							[
								-82.75311692899993,
								27.810535811000083
							],
							[
								-82.75311693299994,
								27.810535499000085
							],
							[
								-82.75311899999991,
								27.810402000000067
							],
							[
								-82.75311889799991,
								27.81039618500006
							],
							[
								-82.75311299999994,
								27.810060000000078
							],
							[
								-82.75284411299992,
								27.810055198000043
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Jungle Terrace",
				"RegionID": "417132"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.72851137999993,
					27.790540000000078,
					-82.7203966159999,
					27.803139916000077
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.72330617599994,
							27.803131904000054
						],
						[
							-82.72309428099993,
							27.803099582000073
						],
						[
							-82.72287919399992,
							27.803035856000065
						],
						[
							-82.72260274799993,
							27.802929851000044
						],
						[
							-82.72229561599994,
							27.802812078000045
						],
						[
							-82.72195374799992,
							27.80268098600004
						],
						[
							-82.72171203699992,
							27.80258830000008
						],
						[
							-82.7215599999999,
							27.802530000000047
						],
						[
							-82.72135955599992,
							27.802452906000042
						],
						[
							-82.72115931499991,
							27.802375891000054
						],
						[
							-82.72095809099994,
							27.80230074700006
						],
						[
							-82.72089999999992,
							27.802280000000053
						],
						[
							-82.72071474799992,
							27.802235791000044
						],
						[
							-82.72059607199992,
							27.802220000000094
						],
						[
							-82.7203966159999,
							27.802218278000055
						],
						[
							-82.72041677999994,
							27.801214687000083
						],
						[
							-82.72041677999994,
							27.799030000000073
						],
						[
							-82.72079528599994,
							27.799030000000073
						],
						[
							-82.72079528599994,
							27.798565144000065
						],
						[
							-82.72065583599993,
							27.79850538000005
						],
						[
							-82.72089588299991,
							27.79812588300007
						],
						[
							-82.72084082899994,
							27.798006633000057
						],
						[
							-82.7208346459999,
							27.79774837800005
						],
						[
							-82.72082639399991,
							27.797270377000075
						],
						[
							-82.72081999999995,
							27.796612850000088
						],
						[
							-82.72081999999995,
							27.79627418700005
						],
						[
							-82.72081999999995,
							27.795736310000052
						],
						[
							-82.72081999999995,
							27.79540000000009
						],
						[
							-82.72081700799993,
							27.795058967000045
						],
						[
							-82.72081316399994,
							27.794620731000066
						],
						[
							-82.72080999999991,
							27.794023072000073
						],
						[
							-82.72080999999991,
							27.79359000000005
						],
						[
							-82.72080999999991,
							27.793285981000054
						],
						[
							-82.7208106569999,
							27.79294817200008
						],
						[
							-82.72081999999995,
							27.79278000000005
						],
						[
							-82.72079835599993,
							27.791635468000038
						],
						[
							-82.72100205999993,
							27.791634367000086
						],
						[
							-82.72166157999993,
							27.791630802000043
						],
						[
							-82.72211434299993,
							27.791630000000055
						],
						[
							-82.72277395099991,
							27.791630000000055
						],
						[
							-82.7233947599999,
							27.791630000000055
						],
						[
							-82.72387329899993,
							27.791630000000055
						],
						[
							-82.72401999999994,
							27.791630000000055
						],
						[
							-82.72415783699995,
							27.791630000000055
						],
						[
							-82.72431303899992,
							27.791630000000055
						],
						[
							-82.72447999999991,
							27.791630000000055
						],
						[
							-82.7246009669999,
							27.791628880000076
						],
						[
							-82.72488461799992,
							27.79162625400005
						],
						[
							-82.7251115389999,
							27.791624152000054
						],
						[
							-82.72544246599995,
							27.791621088000056
						],
						[
							-82.72575448399994,
							27.79162000000008
						],
						[
							-82.72594360199992,
							27.79162000000008
						],
						[
							-82.72619085999992,
							27.791612127000064
						],
						[
							-82.72631999999993,
							27.791600000000074
						],
						[
							-82.72635068299991,
							27.791591818000086
						],
						[
							-82.72646544799994,
							27.79156121400007
						],
						[
							-82.72659707999992,
							27.79147739800004
						],
						[
							-82.72678256599994,
							27.79133190300007
						],
						[
							-82.72700999999995,
							27.79114000000004
						],
						[
							-82.72714999999994,
							27.79102000000006
						],
						[
							-82.72726914599991,
							27.790922918000035
						],
						[
							-82.72734702199995,
							27.79085946300006
						],
						[
							-82.72743620299991,
							27.79079046900006
						],
						[
							-82.7275535629999,
							27.79072143400009
						],
						[
							-82.72765498699994,
							27.79067250500009
						],
						[
							-82.72781508399993,
							27.79060477200005
						],
						[
							-82.72795798699991,
							27.790570366000054
						],
						[
							-82.72809876899994,
							27.790559045000066
						],
						[
							-82.7282318149999,
							27.790548541000078
						],
						[
							-82.72833999999995,
							27.790540000000078
						],
						[
							-82.72833934199991,
							27.790568516000064
						],
						[
							-82.72832999999991,
							27.790973356000052
						],
						[
							-82.72833536299993,
							27.79162733700008
						],
						[
							-82.72834953099994,
							27.79288040600005
						],
						[
							-82.72836057199993,
							27.79326317200008
						],
						[
							-82.72838851099993,
							27.794624912000074
						],
						[
							-82.72839881499993,
							27.79500614500006
						],
						[
							-82.72841875399992,
							27.796041557000084
						],
						[
							-82.72843256899995,
							27.797022393000077
						],
						[
							-82.72844485899992,
							27.79789501500005
						],
						[
							-82.72845330199993,
							27.79849441400006
						],
						[
							-82.72846515599991,
							27.799856959000067
						],
						[
							-82.72847716199993,
							27.801001949000067
						],
						[
							-82.72849828199992,
							27.80236416400004
						],
						[
							-82.72851137999993,
							27.803119948000074
						],
						[
							-82.72850999999991,
							27.803120000000035
						],
						[
							-82.72818607499994,
							27.803123811000034
						],
						[
							-82.72784745899992,
							27.80312779500008
						],
						[
							-82.7274690779999,
							27.80313381800005
						],
						[
							-82.72734919999994,
							27.80313621600004
						],
						[
							-82.72687134199992,
							27.803138682000053
						],
						[
							-82.72653268599993,
							27.80313713600009
						],
						[
							-82.72619402899996,
							27.803135589000078
						],
						[
							-82.7259349659999,
							27.803134406000083
						],
						[
							-82.72557638899991,
							27.803132769000058
						],
						[
							-82.72519789099994,
							27.80313104100009
						],
						[
							-82.72475963699992,
							27.803127232000065
						],
						[
							-82.72434136099992,
							27.803121728000065
						],
						[
							-82.72418163299994,
							27.803121418000046
						],
						[
							-82.72400999999991,
							27.803130000000067
						],
						[
							-82.72376370299992,
							27.80313447800006
						],
						[
							-82.72360402299995,
							27.80313738100006
						],
						[
							-82.72346461899991,
							27.803139916000077
						],
						[
							-82.72330617599994,
							27.803131904000054
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Holiday Park",
				"RegionID": "417133"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.72854735699991,
					27.777150000000063,
					-82.6794999999999,
					27.81068600000009
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.68157499999995,
							27.81068600000009
						],
						[
							-82.68085899999994,
							27.810042000000067
						],
						[
							-82.67950599999995,
							27.808827000000065
						],
						[
							-82.6794999999999,
							27.808504000000084
						],
						[
							-82.6795765409999,
							27.807670552000047
						],
						[
							-82.6795870329999,
							27.806789218000063
						],
						[
							-82.67958820699994,
							27.806465564000064
						],
						[
							-82.6795899999999,
							27.805971098000043
						],
						[
							-82.6795899999999,
							27.805215562000058
						],
						[
							-82.6795899999999,
							27.804334103000087
						],
						[
							-82.67958817999994,
							27.803578892000075
						],
						[
							-82.67958348399992,
							27.803137543000048
						],
						[
							-82.67957999999993,
							27.80225637800004
						],
						[
							-82.67957999999993,
							27.801563803000082
						],
						[
							-82.67957999999993,
							27.800241614000072
						],
						[
							-82.67957999999993,
							27.79967496100005
						],
						[
							-82.6795755839999,
							27.799158812000087
						],
						[
							-82.67957084099993,
							27.798604371000067
						],
						[
							-82.67956046599996,
							27.797974928000087
						],
						[
							-82.67954999999995,
							27.796904661000045
						],
						[
							-82.67954999999995,
							27.795771357000035
						],
						[
							-82.67954133199993,
							27.794701173000078
						],
						[
							-82.67953999999992,
							27.794071400000064
						],
						[
							-82.67953334399994,
							27.793064265000055
						],
						[
							-82.67952999999994,
							27.792182559000082
						],
						[
							-82.67952933599992,
							27.791844584000046
						],
						[
							-82.67952851599995,
							27.791427673000044
						],
						[
							-82.67952350299993,
							27.790859831000038
						],
						[
							-82.67953546199993,
							27.789852808000035
						],
						[
							-82.67953999999992,
							27.788719683000068
						],
						[
							-82.67953999999992,
							27.787586379000064
						],
						[
							-82.67952999999994,
							27.786327151000084
						],
						[
							-82.67952671799992,
							27.78513121600008
						],
						[
							-82.67951999999991,
							27.78454000000005
						],
						[
							-82.68078283299991,
							27.78453359000008
						],
						[
							-82.68148999999995,
							27.784530000000075
						],
						[
							-82.68225798799995,
							27.784530000000075
						],
						[
							-82.6828364889999,
							27.784530000000075
						],
						[
							-82.68351999999993,
							27.784530000000075
						],
						[
							-82.68405131599991,
							27.784526122000045
						],
						[
							-82.68488999999994,
							27.784520000000043
						],
						[
							-82.68558436699993,
							27.784520000000043
						],
						[
							-82.68624999999992,
							27.784520000000043
						],
						[
							-82.68677030899994,
							27.784528392000084
						],
						[
							-82.68731974199994,
							27.784537254000043
						],
						[
							-82.68758999999994,
							27.78455000000008
						],
						[
							-82.68810084499995,
							27.78455000000008
						],
						[
							-82.68862149499995,
							27.78455000000008
						],
						[
							-82.68894999999992,
							27.78455000000008
						],
						[
							-82.6896917219999,
							27.78455000000008
						],
						[
							-82.69031999999993,
							27.78455000000008
						],
						[
							-82.6907329419999,
							27.784547029000066
						],
						[
							-82.69113807999992,
							27.784544115000074
						],
						[
							-82.69170999999996,
							27.78454000000005
						],
						[
							-82.69243959999994,
							27.78454000000005
						],
						[
							-82.69316272599991,
							27.78454000000005
						],
						[
							-82.69377999999995,
							27.78454000000005
						],
						[
							-82.69443542699992,
							27.78454000000005
						],
						[
							-82.6952164029999,
							27.78454000000005
						],
						[
							-82.6958899999999,
							27.78454000000005
						],
						[
							-82.69646017999992,
							27.78454000000005
						],
						[
							-82.69711999999993,
							27.78454000000005
						],
						[
							-82.69770398999994,
							27.78453171600006
						],
						[
							-82.69813777799993,
							27.784525563000045
						],
						[
							-82.69852999999995,
							27.784520000000043
						],
						[
							-82.69915020799993,
							27.784520000000043
						],
						[
							-82.6995551579999,
							27.784520000000043
						],
						[
							-82.69993999999991,
							27.784520000000043
						],
						[
							-82.69993470199996,
							27.784037916000045
						],
						[
							-82.69992999999994,
							27.783610000000067
						],
						[
							-82.69992584599993,
							27.783227794000084
						],
						[
							-82.69992207299993,
							27.78288073400006
						],
						[
							-82.6999199999999,
							27.78269000000006
						],
						[
							-82.69991796099993,
							27.782504437000057
						],
						[
							-82.6999141469999,
							27.78215737900007
						],
						[
							-82.69990999999993,
							27.781780000000083
						],
						[
							-82.69990999999993,
							27.78155008400006
						],
						[
							-82.69990999999993,
							27.78088000000008
						],
						[
							-82.69990742099992,
							27.78039299200009
						],
						[
							-82.6998999999999,
							27.77997000000005
						],
						[
							-82.6998951139999,
							27.779525410000076
						],
						[
							-82.69988999999993,
							27.779060000000072
						],
						[
							-82.69988999999993,
							27.77894000000009
						],
						[
							-82.69988656499993,
							27.778802598000084
						],
						[
							-82.69987861599992,
							27.778484621000075
						],
						[
							-82.69987496599992,
							27.77833864100006
						],
						[
							-82.69986999999992,
							27.778140000000064
						],
						[
							-82.69986999999992,
							27.77801000000005
						],
						[
							-82.69986999999992,
							27.777789829000085
						],
						[
							-82.69986999999992,
							27.777529504000086
						],
						[
							-82.69986999999992,
							27.777240000000063
						],
						[
							-82.69986999999992,
							27.777199056000086
						],
						[
							-82.7001228659999,
							27.777198113000054
						],
						[
							-82.70055671499995,
							27.777194875000077
						],
						[
							-82.70088933299992,
							27.777192393000064
						],
						[
							-82.70120999999995,
							27.77719000000008
						],
						[
							-82.70133764099995,
							27.777188987000045
						],
						[
							-82.70155467899991,
							27.777187264000077
						],
						[
							-82.70181510099991,
							27.77718519800004
						],
						[
							-82.70210433299991,
							27.777182902000053
						],
						[
							-82.70246999999995,
							27.777180000000044
						],
						[
							-82.70275502499993,
							27.777180000000044
						],
						[
							-82.7030731989999,
							27.777180000000044
						],
						[
							-82.70350707299991,
							27.777180000000044
						],
						[
							-82.7039299999999,
							27.777180000000044
						],
						[
							-82.70420127099993,
							27.777180000000044
						],
						[
							-82.70449051999994,
							27.777180000000044
						],
						[
							-82.70504009399991,
							27.777180000000044
						],
						[
							-82.7053699999999,
							27.777180000000044
						],
						[
							-82.70558966699991,
							27.777180000000044
						],
						[
							-82.7059223039999,
							27.777180000000044
						],
						[
							-82.70629823799993,
							27.777176695000037
						],
						[
							-82.70654426699991,
							27.777172789000076
						],
						[
							-82.7067199999999,
							27.77717000000007
						],
						[
							-82.70700698899994,
							27.77717000000007
						],
						[
							-82.70774457399995,
							27.77717000000007
						],
						[
							-82.70807999999994,
							27.77717000000007
						],
						[
							-82.70836645999992,
							27.77717000000007
						],
						[
							-82.70891603399991,
							27.77717000000007
						],
						[
							-82.70944999999995,
							27.77717000000007
						],
						[
							-82.70969698799992,
							27.777166570000077
						],
						[
							-82.70992854399992,
							27.777163354000038
						],
						[
							-82.71016999999995,
							27.777160000000038
						],
						[
							-82.71037674299993,
							27.777160000000038
						],
						[
							-82.71080999999992,
							27.777160000000038
						],
						[
							-82.71160605699993,
							27.77715414700009
						],
						[
							-82.71226999999993,
							27.777150000000063
						],
						[
							-82.71227208199991,
							27.777150000000063
						],
						[
							-82.71227494099992,
							27.77761412500007
						],
						[
							-82.71227999999991,
							27.778559292000068
						],
						[
							-82.71227999999991,
							27.779550934000042
						],
						[
							-82.71228500899991,
							27.780400858000064
						],
						[
							-82.71229481299993,
							27.781297949000077
						],
						[
							-82.71230363299992,
							27.782100610000043
						],
						[
							-82.71230674599991,
							27.78238390200005
						],
						[
							-82.7122599999999,
							27.782680000000084
						],
						[
							-82.7123049999999,
							27.783140004000078
						],
						[
							-82.71229999999991,
							27.783600000000035
						],
						[
							-82.71229566799991,
							27.78398988500004
						],
						[
							-82.71228999999994,
							27.784500000000037
						],
						[
							-82.71228999999994,
							27.78507579400008
						],
						[
							-82.71229684799994,
							27.786020032000067
						],
						[
							-82.71229999999991,
							27.78724796100005
						],
						[
							-82.71229999999991,
							27.788140000000055
						],
						[
							-82.71229999999991,
							27.788498639000068
						],
						[
							-82.71229999999991,
							27.788682582000035
						],
						[
							-82.71229999999991,
							27.788860000000057
						],
						[
							-82.7123042309999,
							27.78917313100004
						],
						[
							-82.71230630299993,
							27.789326389000056
						],
						[
							-82.71230999999995,
							27.789600000000064
						],
						[
							-82.71230999999995,
							27.789724927000066
						],
						[
							-82.71230999999995,
							27.79009281400005
						],
						[
							-82.71230999999995,
							27.79033000000004
						],
						[
							-82.71231430899991,
							27.790644538000038
						],
						[
							-82.71231767899991,
							27.79089059000006
						],
						[
							-82.71231999999992,
							27.791060000000073
						],
						[
							-82.71233534099991,
							27.791351477000035
						],
						[
							-82.71234484699994,
							27.791475543000047
						],
						[
							-82.71236999999991,
							27.791660000000036
						],
						[
							-82.71282784599993,
							27.791640000000086
						],
						[
							-82.7137169049999,
							27.791640000000086
						],
						[
							-82.71454464899996,
							27.791640000000086
						],
						[
							-82.7152497649999,
							27.791640000000086
						],
						[
							-82.71604685199992,
							27.791640000000086
						],
						[
							-82.71653736699994,
							27.791640000000086
						],
						[
							-82.71684393899994,
							27.791640000000086
						],
						[
							-82.71748773999991,
							27.791640000000086
						],
						[
							-82.71782496899995,
							27.791640000000086
						],
						[
							-82.71836999999994,
							27.791630000000055
						],
						[
							-82.71871283099995,
							27.791630000000055
						],
						[
							-82.71894563399991,
							27.791630000000055
						],
						[
							-82.7191499999999,
							27.791630000000055
						],
						[
							-82.71932057599992,
							27.791632106000066
						],
						[
							-82.71972161299993,
							27.791637057000063
						],
						[
							-82.7199599999999,
							27.791640000000086
						],
						[
							-82.72040713599995,
							27.791637583000067
						],
						[
							-82.72079835599993,
							27.791635468000038
						],
						[
							-82.72081999999995,
							27.79278000000005
						],
						[
							-82.7208106569999,
							27.79294817200008
						],
						[
							-82.72080999999991,
							27.793285981000054
						],
						[
							-82.72080999999991,
							27.79359000000005
						],
						[
							-82.72080999999991,
							27.794023072000073
						],
						[
							-82.72081316399994,
							27.794620731000066
						],
						[
							-82.72081700799993,
							27.795058967000045
						],
						[
							-82.72081999999995,
							27.79540000000009
						],
						[
							-82.72081999999995,
							27.795736310000052
						],
						[
							-82.72081999999995,
							27.79627418700005
						],
						[
							-82.72081999999995,
							27.796612850000088
						],
						[
							-82.72082639399991,
							27.797270377000075
						],
						[
							-82.7208346459999,
							27.79774837800005
						],
						[
							-82.72084082899994,
							27.798006633000057
						],
						[
							-82.72089588299991,
							27.79812588300007
						],
						[
							-82.72065583599993,
							27.79850538000005
						],
						[
							-82.72079528599994,
							27.798565144000065
						],
						[
							-82.72079528599994,
							27.799030000000073
						],
						[
							-82.72041677999994,
							27.799030000000073
						],
						[
							-82.72041677999994,
							27.801214687000083
						],
						[
							-82.7203966159999,
							27.802218278000055
						],
						[
							-82.72059607199992,
							27.802220000000094
						],
						[
							-82.72071474799992,
							27.802235791000044
						],
						[
							-82.72089999999992,
							27.802280000000053
						],
						[
							-82.72095809099994,
							27.80230074700006
						],
						[
							-82.72115931499991,
							27.802375891000054
						],
						[
							-82.72135955599992,
							27.802452906000042
						],
						[
							-82.7215599999999,
							27.802530000000047
						],
						[
							-82.72171203699992,
							27.80258830000008
						],
						[
							-82.72195374799992,
							27.80268098600004
						],
						[
							-82.72229561599994,
							27.802812078000045
						],
						[
							-82.72260274799993,
							27.802929851000044
						],
						[
							-82.72287919399992,
							27.803035856000065
						],
						[
							-82.72309428099993,
							27.803099582000073
						],
						[
							-82.72330617599994,
							27.803131904000054
						],
						[
							-82.72346461899991,
							27.803139916000077
						],
						[
							-82.72360402299995,
							27.80313738100006
						],
						[
							-82.72376370299992,
							27.80313447800006
						],
						[
							-82.72400999999991,
							27.803130000000067
						],
						[
							-82.72418163299994,
							27.803121418000046
						],
						[
							-82.72434136099992,
							27.803121728000065
						],
						[
							-82.72475963699992,
							27.803127232000065
						],
						[
							-82.72519789099994,
							27.80313104100009
						],
						[
							-82.72557638899991,
							27.803132769000058
						],
						[
							-82.7259349659999,
							27.803134406000083
						],
						[
							-82.72619402899996,
							27.803135589000078
						],
						[
							-82.72653268599993,
							27.80313713600009
						],
						[
							-82.72687134199992,
							27.803138682000053
						],
						[
							-82.72734919999994,
							27.80313621600004
						],
						[
							-82.7274690779999,
							27.80313381800005
						],
						[
							-82.72784745899992,
							27.80312779500008
						],
						[
							-82.72818607499994,
							27.803123811000034
						],
						[
							-82.72850999999991,
							27.803120000000035
						],
						[
							-82.72851137999993,
							27.803119948000074
						],
						[
							-82.72852188699994,
							27.80372623100004
						],
						[
							-82.7285399999999,
							27.804653280000082
						],
						[
							-82.72854474799993,
							27.80557987300006
						],
						[
							-82.72854735699991,
							27.806887835000055
						],
						[
							-82.72854273799993,
							27.807705334000048
						],
						[
							-82.72853897699991,
							27.808171155000082
						],
						[
							-82.72784899999994,
							27.80817300000007
						],
						[
							-82.72653999999994,
							27.808182000000045
						],
						[
							-82.7261719999999,
							27.808189000000084
						],
						[
							-82.72562799999992,
							27.80819600000007
						],
						[
							-82.72455318499993,
							27.808212841000056
						],
						[
							-82.72454299999993,
							27.80821300000008
						],
						[
							-82.7240589999999,
							27.808216000000073
						],
						[
							-82.7236705279999,
							27.808211129000085
						],
						[
							-82.72363383299995,
							27.80821066900006
						],
						[
							-82.72246399999995,
							27.80819600000007
						],
						[
							-82.72246799999994,
							27.808887000000084
						],
						[
							-82.72246899999993,
							27.809094000000073
						],
						[
							-82.72245099999992,
							27.809686000000056
						],
						[
							-82.72247499999992,
							27.80997300000007
						],
						[
							-82.72240099999993,
							27.81025900000009
						],
						[
							-82.72040699999991,
							27.810257000000036
						],
						[
							-82.72040499999991,
							27.81018000000006
						],
						[
							-82.72040299999992,
							27.809671000000037
						],
						[
							-82.72039199999995,
							27.808928000000037
						],
						[
							-82.72038199999992,
							27.80834200000004
						],
						[
							-82.72039199999995,
							27.808192000000076
						],
						[
							-82.71991361199993,
							27.80820327400005
						],
						[
							-82.71941599999991,
							27.808215000000075
						],
						[
							-82.71906299999995,
							27.808212000000083
						],
						[
							-82.71837299999993,
							27.808211000000085
						],
						[
							-82.71802099999991,
							27.80821700000007
						],
						[
							-82.7175719999999,
							27.808231000000035
						],
						[
							-82.71675999999991,
							27.808227000000045
						],
						[
							-82.7159252969999,
							27.80822204900005
						],
						[
							-82.71591699999993,
							27.808222000000058
						],
						[
							-82.71538112899992,
							27.808234396000046
						],
						[
							-82.71535499999993,
							27.80823500000008
						],
						[
							-82.71393399999994,
							27.808222000000058
						],
						[
							-82.71312099999994,
							27.808228000000042
						],
						[
							-82.71278604199995,
							27.80823460000005
						],
						[
							-82.71271499999995,
							27.80823600000008
						],
						[
							-82.71253194099995,
							27.80823669600005
						],
						[
							-82.71245199999993,
							27.808237000000076
						],
						[
							-82.71236625699993,
							27.808237000000076
						],
						[
							-82.71227099999993,
							27.808237000000076
						],
						[
							-82.71208399999995,
							27.808315000000054
						],
						[
							-82.71123199999994,
							27.80831100000006
						],
						[
							-82.70983295999991,
							27.80831381900009
						],
						[
							-82.70974299999995,
							27.808314000000056
						],
						[
							-82.70952199999994,
							27.808292000000055
						],
						[
							-82.70936299999994,
							27.808218000000068
						],
						[
							-82.70914199999993,
							27.808205000000044
						],
						[
							-82.70898399999993,
							27.80820600000004
						],
						[
							-82.70861699999995,
							27.808212000000083
						],
						[
							-82.7082916029999,
							27.808215214000086
						],
						[
							-82.70821199999995,
							27.808216000000073
						],
						[
							-82.70778999999993,
							27.808219000000065
						],
						[
							-82.70678599999991,
							27.808227000000045
						],
						[
							-82.70556999999991,
							27.80822900000004
						],
						[
							-82.7041318279999,
							27.808231982000052
						],
						[
							-82.70412299999992,
							27.80823200000009
						],
						[
							-82.70341288499992,
							27.80822936000004
						],
						[
							-82.70304699999991,
							27.808228000000042
						],
						[
							-82.7020839999999,
							27.808223000000055
						],
						[
							-82.70207772499992,
							27.80822300600005
						],
						[
							-82.70161723099994,
							27.80822345900009
						],
						[
							-82.70158996899994,
							27.808223485000042
						],
						[
							-82.70023119999992,
							27.808224821000067
						],
						[
							-82.70004899999992,
							27.80822500000005
						],
						[
							-82.69959999999992,
							27.808228000000042
						],
						[
							-82.6992239999999,
							27.808230000000037
						],
						[
							-82.69908199999992,
							27.80822500000005
						],
						[
							-82.69842599999993,
							27.80822500000005
						],
						[
							-82.6980069999999,
							27.808230000000037
						],
						[
							-82.69745799999993,
							27.808242000000064
						],
						[
							-82.69713889499991,
							27.808242780000057
						],
						[
							-82.69704899999994,
							27.808243000000065
						],
						[
							-82.6962859009999,
							27.80824371100005
						],
						[
							-82.69597599999993,
							27.808244000000062
						],
						[
							-82.69594690999992,
							27.808244014000085
						],
						[
							-82.69393999999994,
							27.80824500000006
						],
						[
							-82.69389732299993,
							27.80824679400007
						],
						[
							-82.69279799999993,
							27.80829300000005
						],
						[
							-82.69276182099992,
							27.808293780000042
						],
						[
							-82.69262238599993,
							27.80829678500004
						],
						[
							-82.69186999999994,
							27.808313000000055
						],
						[
							-82.6911419999999,
							27.80830700000007
						],
						[
							-82.6908249999999,
							27.80830700000007
						],
						[
							-82.69039399999991,
							27.808313000000055
						],
						[
							-82.68990858299992,
							27.808303127000045
						],
						[
							-82.68980399999992,
							27.808301000000085
						],
						[
							-82.68966373699993,
							27.80830024900007
						],
						[
							-82.68774899999994,
							27.80829000000006
						],
						[
							-82.68671499999994,
							27.80829300000005
						],
						[
							-82.68569899999994,
							27.80829700000004
						],
						[
							-82.6836449999999,
							27.808305000000075
						],
						[
							-82.68280504099994,
							27.80826262100004
						],
						[
							-82.6826539999999,
							27.808255000000088
						],
						[
							-82.68255499999992,
							27.810125000000085
						],
						[
							-82.6817099999999,
							27.81013800000005
						],
						[
							-82.6815729999999,
							27.81013100000007
						],
						[
							-82.6813719999999,
							27.810128000000077
						],
						[
							-82.68157499999995,
							27.81068600000009
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Disston Heights",
				"RegionID": "417134"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.65474999999992,
					27.759300000000053,
					-82.64661497999992,
					27.766126279000048
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.64942379799993,
							27.766085546000056
						],
						[
							-82.64844927599997,
							27.766080000000045
						],
						[
							-82.6481594679999,
							27.766082670000063
						],
						[
							-82.64738303199994,
							27.766089824000062
						],
						[
							-82.64663999999993,
							27.76610000000005
						],
						[
							-82.6466459099999,
							27.76560328000005
						],
						[
							-82.64664999999991,
							27.76525958500008
						],
						[
							-82.64665554899995,
							27.764498246000073
						],
						[
							-82.64665365399992,
							27.763889065000058
						],
						[
							-82.64665511399994,
							27.763706221000064
						],
						[
							-82.64665730399992,
							27.763432032000086
						],
						[
							-82.64665792099994,
							27.76254924500006
						],
						[
							-82.6466571169999,
							27.762092066000037
						],
						[
							-82.64664514699992,
							27.76172699300008
						],
						[
							-82.6466299999999,
							27.761239468000042
						],
						[
							-82.6466299999999,
							27.760813092000035
						],
						[
							-82.64662438199991,
							27.760417088000054
						],
						[
							-82.64661999999993,
							27.759990796000068
						],
						[
							-82.64661497999992,
							27.759563959000047
						],
						[
							-82.64661534699991,
							27.759310000000085
						],
						[
							-82.64699331299994,
							27.759310000000085
						],
						[
							-82.64749861699994,
							27.759310000000085
						],
						[
							-82.64824454299992,
							27.759310000000085
						],
						[
							-82.64864999999992,
							27.759310000000085
						],
						[
							-82.6487699999999,
							27.759310000000085
						],
						[
							-82.64896628699995,
							27.75931218100004
						],
						[
							-82.64930338199991,
							27.759315926000056
						],
						[
							-82.6496699999999,
							27.75932000000006
						],
						[
							-82.65016951299992,
							27.75932000000006
						],
						[
							-82.65068999999994,
							27.75932000000006
						],
						[
							-82.65096351599993,
							27.759318247000067
						],
						[
							-82.65139661699993,
							27.759315470000047
						],
						[
							-82.65175784199994,
							27.759313155000086
						],
						[
							-82.65224999999992,
							27.759310000000085
						],
						[
							-82.65243135199995,
							27.759310000000085
						],
						[
							-82.65274999999991,
							27.759310000000085
						],
						[
							-82.65288865999992,
							27.759306533000085
						],
						[
							-82.65314999999993,
							27.759300000000053
						],
						[
							-82.65334571299991,
							27.759300000000053
						],
						[
							-82.65373999999991,
							27.759300000000053
						],
						[
							-82.65430819799991,
							27.759300000000053
						],
						[
							-82.65473999999995,
							27.759310000000085
						],
						[
							-82.65473999999995,
							27.759625330000063
						],
						[
							-82.65473999999995,
							27.760203984000043
						],
						[
							-82.65473999999995,
							27.760874003000083
						],
						[
							-82.65473999999995,
							27.76130037900009
						],
						[
							-82.65473795799994,
							27.761695968000083
						],
						[
							-82.65472691999992,
							27.76221477100006
						],
						[
							-82.6547202189999,
							27.762548326000058
						],
						[
							-82.65472999999993,
							27.762920000000065
						],
						[
							-82.65473184199993,
							27.763249648000055
						],
						[
							-82.65473507399992,
							27.763828283000066
						],
						[
							-82.6547379669999,
							27.764346009000068
						],
						[
							-82.65473999999995,
							27.764710000000036
						],
						[
							-82.65473999999995,
							27.764894120000065
						],
						[
							-82.65474546599995,
							27.765320643000052
						],
						[
							-82.65474999999992,
							27.76610000000005
						],
						[
							-82.6542966799999,
							27.766110926000067
						],
						[
							-82.65353540899991,
							27.766123061000087
						],
						[
							-82.65225602899994,
							27.766126279000048
						],
						[
							-82.65149476499994,
							27.76611664300009
						],
						[
							-82.6503072349999,
							27.766100253000047
						],
						[
							-82.64942379799993,
							27.766085546000056
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Campbell Park",
				"RegionID": "417148"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.64665792099994,
					27.759310000000085,
					-82.63844999999992,
					27.763706221000064
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.64547075099995,
							27.763136150000037
						],
						[
							-82.64535806599991,
							27.763113613000087
						],
						[
							-82.64517999999993,
							27.763150000000053
						],
						[
							-82.6446499999999,
							27.76313000000005
						],
						[
							-82.64463950699992,
							27.762920141000052
						],
						[
							-82.64463318799994,
							27.762793762000058
						],
						[
							-82.64462999999995,
							27.762508851000067
						],
						[
							-82.64462999999995,
							27.762350000000083
						],
						[
							-82.64451945099995,
							27.762317223000082
						],
						[
							-82.6444063809999,
							27.76230811100004
						],
						[
							-82.64424851099994,
							27.76229924200004
						],
						[
							-82.64398013199991,
							27.762284165000043
						],
						[
							-82.64377490099992,
							27.76227263500005
						],
						[
							-82.64354999999995,
							27.762260000000087
						],
						[
							-82.6435405279999,
							27.762128915000062
						],
						[
							-82.64354654699991,
							27.76200250700009
						],
						[
							-82.64355564799992,
							27.761811390000048
						],
						[
							-82.64354665699994,
							27.761681643000088
						],
						[
							-82.64354228799994,
							27.761670721000087
						],
						[
							-82.6433334379999,
							27.761596688000054
						],
						[
							-82.64315621599991,
							27.76154589700008
						],
						[
							-82.64293658999992,
							27.761446110000065
						],
						[
							-82.64278349499995,
							27.761357786000076
						],
						[
							-82.64266471199994,
							27.761329945000057
						],
						[
							-82.64249211099991,
							27.761307810000062
						],
						[
							-82.64225480599993,
							27.76130015500007
						],
						[
							-82.64209999999991,
							27.761300000000066
						],
						[
							-82.64210827599993,
							27.761163448000048
						],
						[
							-82.64211592599993,
							27.76103721700008
						],
						[
							-82.64211311899993,
							27.760898164000082
						],
						[
							-82.64212673499992,
							27.76083989700004
						],
						[
							-82.64217999999994,
							27.760750000000087
						],
						[
							-82.64214653599993,
							27.760716536000075
						],
						[
							-82.6420599999999,
							27.76063000000005
						],
						[
							-82.64199309399993,
							27.760581911000088
						],
						[
							-82.6419363139999,
							27.760541101000058
						],
						[
							-82.64181067999994,
							27.760450801000047
						],
						[
							-82.64162476899992,
							27.760347186000047
						],
						[
							-82.64149999999995,
							27.760290000000055
						],
						[
							-82.6413520079999,
							27.76027520100007
						],
						[
							-82.64124120499991,
							27.760268969000037
						],
						[
							-82.64101927999991,
							27.760265075000063
						],
						[
							-82.64075013699994,
							27.760260353000035
						],
						[
							-82.64044930499995,
							27.760264189000054
						],
						[
							-82.64017990299993,
							27.76026821000005
						],
						[
							-82.63998992199993,
							27.760270722000087
						],
						[
							-82.63964154899992,
							27.76027431400007
						],
						[
							-82.6388973629999,
							27.760283321000088
						],
						[
							-82.63869127299995,
							27.76028687500008
						],
						[
							-82.63844999999992,
							27.760290000000055
						],
						[
							-82.63844999999992,
							27.760054143000048
						],
						[
							-82.63844999999992,
							27.759626549000075
						],
						[
							-82.63844999999992,
							27.75941000000006
						],
						[
							-82.63866727599992,
							27.759404927000052
						],
						[
							-82.63902783299994,
							27.75939329600004
						],
						[
							-82.63948592999992,
							27.759390000000053
						],
						[
							-82.63982247799993,
							27.759387662000055
						],
						[
							-82.64005999999995,
							27.75938000000008
						],
						[
							-82.64025591799992,
							27.75938000000008
						],
						[
							-82.64078528499994,
							27.75938000000008
						],
						[
							-82.64121840299993,
							27.75938000000008
						],
						[
							-82.6415199999999,
							27.75938000000008
						],
						[
							-82.64181995599995,
							27.75938000000008
						],
						[
							-82.64200999999991,
							27.75938000000008
						],
						[
							-82.64242150899992,
							27.75938000000008
						],
						[
							-82.64278244099995,
							27.75938000000008
						],
						[
							-82.64299999999992,
							27.75938000000008
						],
						[
							-82.64326368399992,
							27.75938000000008
						],
						[
							-82.64351999999991,
							27.75938000000008
						],
						[
							-82.64369685999992,
							27.75937672500004
						],
						[
							-82.64405999999991,
							27.759370000000047
						],
						[
							-82.64439460299991,
							27.759370000000047
						],
						[
							-82.64475543399995,
							27.759368665000068
						],
						[
							-82.64499644599994,
							27.759363746000076
						],
						[
							-82.64517999999993,
							27.759360000000072
						],
						[
							-82.64538128399994,
							27.759354080000037
						],
						[
							-82.64551999999992,
							27.75935000000004
						],
						[
							-82.64571795799992,
							27.75934626500009
						],
						[
							-82.64605436599993,
							27.75933976600004
						],
						[
							-82.64631957699993,
							27.759325558000057
						],
						[
							-82.6466099999999,
							27.759310000000085
						],
						[
							-82.64661534699991,
							27.759310000000085
						],
						[
							-82.64661497999992,
							27.759563959000047
						],
						[
							-82.64661999999993,
							27.759990796000068
						],
						[
							-82.64662438199991,
							27.760417088000054
						],
						[
							-82.6466299999999,
							27.760813092000035
						],
						[
							-82.6466299999999,
							27.761239468000042
						],
						[
							-82.64664514699992,
							27.76172699300008
						],
						[
							-82.6466571169999,
							27.762092066000037
						],
						[
							-82.64665792099994,
							27.76254924500006
						],
						[
							-82.64665730399992,
							27.763432032000086
						],
						[
							-82.64665511399994,
							27.763706221000064
						],
						[
							-82.6465775019999,
							27.763701945000037
						],
						[
							-82.6464679959999,
							27.76368977700008
						],
						[
							-82.64629640099992,
							27.76365820000007
						],
						[
							-82.64617604599994,
							27.763576046000082
						],
						[
							-82.64601767799991,
							27.763417678000053
						],
						[
							-82.64589976499991,
							27.763315614000078
						],
						[
							-82.64571054299995,
							27.763234518000047
						],
						[
							-82.64547075099995,
							27.763136150000037
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Historic Roser Park",
				"RegionID": "417149"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.64665554899995,
					27.753670000000056,
					-82.62229169499994,
					27.769525293000072
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.62396013799992,
							27.769525293000072
						],
						[
							-82.6237988339999,
							27.769511659000045
						],
						[
							-82.6236474129999,
							27.769471086000067
						],
						[
							-82.6235053389999,
							27.769404836000035
						],
						[
							-82.62337692699992,
							27.769314921000046
						],
						[
							-82.6232681589999,
							27.769206542000063
						],
						[
							-82.62320347799994,
							27.769130019000045
						],
						[
							-82.6229465429999,
							27.769002241000067
						],
						[
							-82.6228973389999,
							27.76897583600004
						],
						[
							-82.62276856299991,
							27.768885615000045
						],
						[
							-82.62263619899994,
							27.768774309000037
						],
						[
							-82.62258344199995,
							27.768726246000085
						],
						[
							-82.6225346629999,
							27.768674152000074
						],
						[
							-82.6224901679999,
							27.76861835300008
						],
						[
							-82.62245023799994,
							27.768559202000063
						],
						[
							-82.62241512399993,
							27.76849707100007
						],
						[
							-82.62238504699991,
							27.768432351000058
						],
						[
							-82.62236019699992,
							27.76836545000009
						],
						[
							-82.6223431969999,
							27.76831344900006
						],
						[
							-82.62231234099994,
							27.76819016500008
						],
						[
							-82.62230246799993,
							27.76811647600005
						],
						[
							-82.62229546799995,
							27.768040476000067
						],
						[
							-82.62229169499994,
							27.767963473000066
						],
						[
							-82.62229453099991,
							27.76788643000009
						],
						[
							-82.62230395499995,
							27.767809913000065
						],
						[
							-82.6223198969999,
							27.767734484000076
						],
						[
							-82.6223422409999,
							27.767660698000043
						],
						[
							-82.62240607699994,
							27.76747855600007
						],
						[
							-82.62243225399993,
							27.76741339000006
						],
						[
							-82.62246343699991,
							27.76735046600004
						],
						[
							-82.62249943499995,
							27.767290168000045
						],
						[
							-82.62254002999993,
							27.767232863000064
						],
						[
							-82.62258497399995,
							27.76717890200007
						],
						[
							-82.62263399199992,
							27.76712861200008
						],
						[
							-82.62284899199994,
							27.76692461300007
						],
						[
							-82.62289663599995,
							27.76688250500007
						],
						[
							-82.62294713599994,
							27.76684386900007
						],
						[
							-82.6230002399999,
							27.76680889800008
						],
						[
							-82.62305568199993,
							27.766777767000065
						],
						[
							-82.6231415819999,
							27.76673345100005
						],
						[
							-82.6231386899999,
							27.764498574000072
						],
						[
							-82.62311985799994,
							27.76355698300006
						],
						[
							-82.6231196789999,
							27.76353759300008
						],
						[
							-82.62312257699995,
							27.76168604500009
						],
						[
							-82.62306595199993,
							27.76129482400006
						],
						[
							-82.62305670699993,
							27.761173273000058
						],
						[
							-82.62305390499995,
							27.76082670900007
						],
						[
							-82.62304058099994,
							27.760613529000068
						],
						[
							-82.62302835099992,
							27.760544227000082
						],
						[
							-82.62301467799995,
							27.760388000000038
						],
						[
							-82.62302430999995,
							27.76025672600008
						],
						[
							-82.62303331099992,
							27.760195727000053
						],
						[
							-82.62304571099992,
							27.760129152000047
						],
						[
							-82.62306308599995,
							27.760063698000067
						],
						[
							-82.6230853369999,
							27.759999737000044
						],
						[
							-82.62311233799994,
							27.75993763200006
						],
						[
							-82.6231439359999,
							27.75987773500009
						],
						[
							-82.62317995099994,
							27.759820386000058
						],
						[
							-82.6231949509999,
							27.759798386000057
						],
						[
							-82.62324218599991,
							27.75973524300008
						],
						[
							-82.6232947709999,
							27.759676481000042
						],
						[
							-82.6233523009999,
							27.759622551000064
						],
						[
							-82.6234143339999,
							27.759573868000075
						],
						[
							-82.62348039299992,
							27.75953080700009
						],
						[
							-82.62354996999994,
							27.75949369700004
						],
						[
							-82.62357296999994,
							27.759482697000067
						],
						[
							-82.62364163599995,
							27.75945329400008
						],
						[
							-82.6237125049999,
							27.759429691000037
						],
						[
							-82.62378508799992,
							27.759412050000037
						],
						[
							-82.62385888499995,
							27.75940049400009
						],
						[
							-82.62469888499993,
							27.759304494000048
						],
						[
							-82.62472631599991,
							27.75930178400006
						],
						[
							-82.62490303499993,
							27.75928705800004
						],
						[
							-82.62560844899991,
							27.759184770000047
						],
						[
							-82.6258289569999,
							27.75915355400008
						],
						[
							-82.62589157099991,
							27.75914691800006
						],
						[
							-82.62608957099991,
							27.759132918000034
						],
						[
							-82.62615299999993,
							27.759130678000076
						],
						[
							-82.6262701519999,
							27.75913834100004
						],
						[
							-82.6264071519999,
							27.75915634100005
						],
						[
							-82.62643026699993,
							27.759159684000053
						],
						[
							-82.62645721699994,
							27.75916401300009
						],
						[
							-82.62653154199995,
							27.759179671000084
						],
						[
							-82.62660427899993,
							27.75920154800008
						],
						[
							-82.6266749099999,
							27.759229488000074
						],
						[
							-82.62674292999992,
							27.75926329200007
						],
						[
							-82.6268078519999,
							27.75930271800007
						],
						[
							-82.62687985199996,
							27.759350717000075
						],
						[
							-82.62694019599991,
							27.759394670000063
						],
						[
							-82.62699668599993,
							27.759443477000048
						],
						[
							-82.6270489339999,
							27.75949680000008
						],
						[
							-82.6270965789999,
							27.75955427400004
						],
						[
							-82.62713929299993,
							27.75961550100004
						],
						[
							-82.6272782929999,
							27.75983350100006
						],
						[
							-82.62730181899991,
							27.759872546000057
						],
						[
							-82.6278356649999,
							27.760811612000055
						],
						[
							-82.62800946999994,
							27.76106644200007
						],
						[
							-82.62803283999996,
							27.761065447000078
						],
						[
							-82.62846608499991,
							27.761048148000043
						],
						[
							-82.62993527599993,
							27.76101579100009
						],
						[
							-82.6310460169999,
							27.761011215000053
						],
						[
							-82.63091646799991,
							27.760850179000045
						],
						[
							-82.63054958999993,
							27.760384565000038
						],
						[
							-82.63050289599994,
							27.760319543000037
						],
						[
							-82.63046216899994,
							27.760250626000072
						],
						[
							-82.63042773199993,
							27.760178361000044
						],
						[
							-82.63039985799992,
							27.760103319000052
						],
						[
							-82.63037876699991,
							27.760026096000047
						],
						[
							-82.63037176599994,
							27.759995097000058
						],
						[
							-82.6303582509999,
							27.759920887000078
						],
						[
							-82.63035100299993,
							27.759845805000054
						],
						[
							-82.63035007199994,
							27.759770380000077
						],
						[
							-82.63035546399993,
							27.759695143000044
						],
						[
							-82.63036714299994,
							27.759620622000057
						],
						[
							-82.63037614399991,
							27.759575622000057
						],
						[
							-82.63039321999992,
							27.759503653000085
						],
						[
							-82.63041641399991,
							27.759433416000036
						],
						[
							-82.63044555399995,
							27.75936543100005
						],
						[
							-82.63048042499992,
							27.759300200000045
						],
						[
							-82.63052076799994,
							27.759238203000052
						],
						[
							-82.63056628699991,
							27.75917990100004
						],
						[
							-82.6296157459999,
							27.759179310000036
						],
						[
							-82.62902093499991,
							27.759175302000074
						],
						[
							-82.62895137599992,
							27.759172137000064
						],
						[
							-82.62871437699994,
							27.759152137000058
						],
						[
							-82.62862578499994,
							27.759140202000083
						],
						[
							-82.62855578499995,
							27.75912720200006
						],
						[
							-82.62841241399991,
							27.759088086000077
						],
						[
							-82.62839149199993,
							27.759080175000065
						],
						[
							-82.6283124919999,
							27.759049176000076
						],
						[
							-82.62824580099993,
							27.75901983500006
						],
						[
							-82.62818170399994,
							27.758985193000058
						],
						[
							-82.62812062099994,
							27.75894547500008
						],
						[
							-82.62806295399992,
							27.75890094400006
						],
						[
							-82.6280090809999,
							27.758851890000074
						],
						[
							-82.6279593559999,
							27.75879863600005
						],
						[
							-82.62791410499996,
							27.758741532000045
						],
						[
							-82.62787362499995,
							27.758680952000077
						],
						[
							-82.62781862499992,
							27.758590952000077
						],
						[
							-82.62778157399993,
							27.758524093000062
						],
						[
							-82.62775033399993,
							27.758454330000063
						],
						[
							-82.62772513199991,
							27.758382165000057
						],
						[
							-82.6277061479999,
							27.758308121000088
						],
						[
							-82.62767382899995,
							27.758155337000062
						],
						[
							-82.62765853199994,
							27.758085548000054
						],
						[
							-82.62764078399994,
							27.75796768400005
						],
						[
							-82.62760678399991,
							27.757559684000057
						],
						[
							-82.6276036779999,
							27.757485000000088
						],
						[
							-82.62761802599994,
							27.75732503900008
						],
						[
							-82.62767371199993,
							27.757024243000046
						],
						[
							-82.6276780529999,
							27.757002330000034
						],
						[
							-82.62785298599994,
							27.756173266000076
						],
						[
							-82.62885286499994,
							27.75605852600006
						],
						[
							-82.62903999999992,
							27.756060000000048
						],
						[
							-82.62910716999994,
							27.75605229200005
						],
						[
							-82.62928390299993,
							27.75603201100006
						],
						[
							-82.62962247799993,
							27.75599315800008
						],
						[
							-82.62993187899991,
							27.755987209000068
						],
						[
							-82.63033788799993,
							27.755983189000062
						],
						[
							-82.63073020699996,
							27.755974149000053
						],
						[
							-82.63081473699992,
							27.755961316000082
						],
						[
							-82.63087999999993,
							27.755910000000085
						],
						[
							-82.63095337099992,
							27.755864143000053
						],
						[
							-82.6310142019999,
							27.755826124000066
						],
						[
							-82.63109534199992,
							27.755797702000052
						],
						[
							-82.63116376999994,
							27.755791324000086
						],
						[
							-82.63137999599991,
							27.755799804000052
						],
						[
							-82.63152918199995,
							27.75580565400009
						],
						[
							-82.63188070599995,
							27.755816506000087
						],
						[
							-82.63211099699993,
							27.75582273000009
						],
						[
							-82.6323799999999,
							27.75583000000006
						],
						[
							-82.63246096199993,
							27.755816041000063
						],
						[
							-82.63254435899995,
							27.755801662000067
						],
						[
							-82.6326699999999,
							27.755780000000073
						],
						[
							-82.63281470699991,
							27.755780000000073
						],
						[
							-82.6330989409999,
							27.755780000000073
						],
						[
							-82.63335543399995,
							27.755771777000064
						],
						[
							-82.63353163499994,
							27.75576351700005
						],
						[
							-82.63369433199995,
							27.755755891000035
						],
						[
							-82.63383031199993,
							27.75574742200007
						],
						[
							-82.63389999999993,
							27.755730000000085
						],
						[
							-82.63389441699991,
							27.755448046000083
						],
						[
							-82.63388877499995,
							27.75516312000008
						],
						[
							-82.6338836839999,
							27.754906057000085
						],
						[
							-82.63387999999992,
							27.754720000000077
						],
						[
							-82.63408683599994,
							27.754724309000043
						],
						[
							-82.63442568399995,
							27.754728150000062
						],
						[
							-82.6348182669999,
							27.75471709100009
						],
						[
							-82.63502113099992,
							27.754711377000035
						],
						[
							-82.6351334009999,
							27.754697320000048
						],
						[
							-82.63523314499992,
							27.754654919000075
						],
						[
							-82.63529829299995,
							27.754601707000063
						],
						[
							-82.63533999999993,
							27.754560000000083
						],
						[
							-82.63537290999994,
							27.754500300000075
						],
						[
							-82.63539377099994,
							27.754430763000073
						],
						[
							-82.63540533399993,
							27.75432465700004
						],
						[
							-82.63541296999995,
							27.754202474000067
						],
						[
							-82.63691412899993,
							27.754202483000086
						],
						[
							-82.63691999999992,
							27.753680000000088
						],
						[
							-82.63705118099995,
							27.75367576800005
						],
						[
							-82.63722999999993,
							27.753670000000056
						],
						[
							-82.63850702299995,
							27.753674370000056
						],
						[
							-82.63850406199992,
							27.75388750400009
						],
						[
							-82.63849999999991,
							27.754180000000076
						],
						[
							-82.63849999999991,
							27.754440868000074
						],
						[
							-82.63849999999991,
							27.75467000000009
						],
						[
							-82.63849376099995,
							27.754873814000064
						],
						[
							-82.6384878739999,
							27.755066130000046
						],
						[
							-82.63847975599992,
							27.75533130200006
						],
						[
							-82.63846999999993,
							27.75565000000006
						],
						[
							-82.63846999999993,
							27.75574000000006
						],
						[
							-82.63846999999993,
							27.75598084300009
						],
						[
							-82.63846999999993,
							27.756149278000066
						],
						[
							-82.63846999999993,
							27.756320000000073
						],
						[
							-82.63846698099991,
							27.756461908000063
						],
						[
							-82.6384623749999,
							27.75667837000009
						],
						[
							-82.63845999999995,
							27.75679000000008
						],
						[
							-82.63845999999995,
							27.75694332800009
						],
						[
							-82.63845999999995,
							27.757010000000037
						],
						[
							-82.63845999999995,
							27.757280198000046
						],
						[
							-82.63845999999995,
							27.757544881000058
						],
						[
							-82.63845999999995,
							27.75774000000007
						],
						[
							-82.63844999999992,
							27.757850000000076
						],
						[
							-82.63844999999992,
							27.75824268300005
						],
						[
							-82.63844999999992,
							27.758723925000083
						],
						[
							-82.63844999999992,
							27.75941000000006
						],
						[
							-82.63844999999992,
							27.759626549000075
						],
						[
							-82.63844999999992,
							27.760054143000048
						],
						[
							-82.63844999999992,
							27.760290000000055
						],
						[
							-82.63869127299995,
							27.76028687500008
						],
						[
							-82.6388973629999,
							27.760283321000088
						],
						[
							-82.63964154899992,
							27.76027431400007
						],
						[
							-82.63998992199993,
							27.760270722000087
						],
						[
							-82.64017990299993,
							27.76026821000005
						],
						[
							-82.64044930499995,
							27.760264189000054
						],
						[
							-82.64075013699994,
							27.760260353000035
						],
						[
							-82.64101927999991,
							27.760265075000063
						],
						[
							-82.64124120499991,
							27.760268969000037
						],
						[
							-82.6413520079999,
							27.76027520100007
						],
						[
							-82.64149999999995,
							27.760290000000055
						],
						[
							-82.64162476899992,
							27.760347186000047
						],
						[
							-82.64181067999994,
							27.760450801000047
						],
						[
							-82.6419363139999,
							27.760541101000058
						],
						[
							-82.64199309399993,
							27.760581911000088
						],
						[
							-82.6420599999999,
							27.76063000000005
						],
						[
							-82.64214653599993,
							27.760716536000075
						],
						[
							-82.64217999999994,
							27.760750000000087
						],
						[
							-82.64212673499992,
							27.76083989700004
						],
						[
							-82.64211311899993,
							27.760898164000082
						],
						[
							-82.64211592599993,
							27.76103721700008
						],
						[
							-82.64210827599993,
							27.761163448000048
						],
						[
							-82.64209999999991,
							27.761300000000066
						],
						[
							-82.64225480599993,
							27.76130015500007
						],
						[
							-82.64249211099991,
							27.761307810000062
						],
						[
							-82.64266471199994,
							27.761329945000057
						],
						[
							-82.64278349499995,
							27.761357786000076
						],
						[
							-82.64293658999992,
							27.761446110000065
						],
						[
							-82.64315621599991,
							27.76154589700008
						],
						[
							-82.6433334379999,
							27.761596688000054
						],
						[
							-82.64354228799994,
							27.761670721000087
						],
						[
							-82.64354665699994,
							27.761681643000088
						],
						[
							-82.64355564799992,
							27.761811390000048
						],
						[
							-82.64354654699991,
							27.76200250700009
						],
						[
							-82.6435405279999,
							27.762128915000062
						],
						[
							-82.64354999999995,
							27.762260000000087
						],
						[
							-82.64377490099992,
							27.76227263500005
						],
						[
							-82.64398013199991,
							27.762284165000043
						],
						[
							-82.64424851099994,
							27.76229924200004
						],
						[
							-82.6444063809999,
							27.76230811100004
						],
						[
							-82.64451945099995,
							27.762317223000082
						],
						[
							-82.64462999999995,
							27.762350000000083
						],
						[
							-82.64462999999995,
							27.762508851000067
						],
						[
							-82.64463318799994,
							27.762793762000058
						],
						[
							-82.64463950699992,
							27.762920141000052
						],
						[
							-82.6446499999999,
							27.76313000000005
						],
						[
							-82.64517999999993,
							27.763150000000053
						],
						[
							-82.64535806599991,
							27.763113613000087
						],
						[
							-82.64547075099995,
							27.763136150000037
						],
						[
							-82.64571054299995,
							27.763234518000047
						],
						[
							-82.64589976499991,
							27.763315614000078
						],
						[
							-82.64601767799991,
							27.763417678000053
						],
						[
							-82.64617604599994,
							27.763576046000082
						],
						[
							-82.64629640099992,
							27.76365820000007
						],
						[
							-82.6464679959999,
							27.76368977700008
						],
						[
							-82.6465775019999,
							27.763701945000037
						],
						[
							-82.64665511399994,
							27.763706221000064
						],
						[
							-82.64665365399992,
							27.763889065000058
						],
						[
							-82.64665554899995,
							27.764498246000073
						],
						[
							-82.64664999999991,
							27.76525958500008
						],
						[
							-82.6466459099999,
							27.76560328000005
						],
						[
							-82.64608350399993,
							27.76562316700006
						],
						[
							-82.64514456799992,
							27.765630000000044
						],
						[
							-82.64435624599992,
							27.765630000000044
						],
						[
							-82.64364313599992,
							27.765635583000062
						],
						[
							-82.6427045239999,
							27.765640000000076
						],
						[
							-82.64168999999993,
							27.765640000000076
						],
						[
							-82.64094018499992,
							27.765640000000076
						],
						[
							-82.63988923399995,
							27.76564184600005
						],
						[
							-82.63883771899992,
							27.765650850000043
						],
						[
							-82.6381622099999,
							27.76566421800004
						],
						[
							-82.63782459599992,
							27.76565525500007
						],
						[
							-82.63744747699991,
							27.76564524300005
						],
						[
							-82.63718349699992,
							27.765643325000042
						],
						[
							-82.63669819499995,
							27.765658477000045
						],
						[
							-82.63594747899992,
							27.765670000000057
						],
						[
							-82.63504687599993,
							27.765678850000086
						],
						[
							-82.6344464689999,
							27.76569032200007
						],
						[
							-82.63393999999994,
							27.765700000000038
						],
						[
							-82.63384617199995,
							27.76570853000004
						],
						[
							-82.6336760989999,
							27.765657155000042
						],
						[
							-82.6335075369999,
							27.765510990000053
						],
						[
							-82.63331232199995,
							27.765335151000045
						],
						[
							-82.63302376299993,
							27.76519344100007
						],
						[
							-82.6327941909999,
							27.76517000000007
						],
						[
							-82.63223127299995,
							27.765177643000072
						],
						[
							-82.63181751099995,
							27.76519355700009
						],
						[
							-82.63141549999995,
							27.765235918000087
						],
						[
							-82.63115084999993,
							27.765343939000047
						],
						[
							-82.63083426599991,
							27.76551185900007
						],
						[
							-82.6306175439999,
							27.765699065000035
						],
						[
							-82.63059330499993,
							27.765922962000047
						],
						[
							-82.63066081099993,
							27.766145298000083
						],
						[
							-82.63074099999994,
							27.766437000000053
						],
						[
							-82.63010664099994,
							27.76752003000007
						],
						[
							-82.62666723599995,
							27.768511206000085
						],
						[
							-82.6266673209999,
							27.768566298000056
						],
						[
							-82.62665365899994,
							27.76872316500004
						],
						[
							-82.62661097699993,
							27.76888026000006
						],
						[
							-82.62659786899991,
							27.768914934000065
						],
						[
							-82.62656979699995,
							27.76898089200006
						],
						[
							-82.62653655999992,
							27.769044404000056
						],
						[
							-82.62649837099991,
							27.769105067000055
						],
						[
							-82.62645547199992,
							27.769162496000035
						],
						[
							-82.6264081349999,
							27.76921632500006
						],
						[
							-82.62635666099993,
							27.769266214000083
						],
						[
							-82.62633766099992,
							27.76928321400004
						],
						[
							-82.62631607299994,
							27.76930192100008
						],
						[
							-82.6261876609999,
							27.76939183600007
						],
						[
							-82.62604558599992,
							27.769458086000043
						],
						[
							-82.62589416599991,
							27.769498659000078
						],
						[
							-82.6257650039999,
							27.769511917000045
						],
						[
							-82.62553200399992,
							27.769518916000038
						],
						[
							-82.62549420999994,
							27.76951925700007
						],
						[
							-82.62500474399991,
							27.76951338400005
						],
						[
							-82.62396013799992,
							27.769525293000072
						]
					],
					[
						[
							-82.63543809999993,
							27.760305457000072
						],
						[
							-82.6354590329999,
							27.759622295000046
						],
						[
							-82.6354516639999,
							27.759465112000044
						],
						[
							-82.63545075399992,
							27.759411278000073
						],
						[
							-82.63545281699993,
							27.759253058000073
						],
						[
							-82.63471305199994,
							27.759272027000065
						],
						[
							-82.63469178399993,
							27.759272321000083
						],
						[
							-82.63418689199995,
							27.75927332100008
						],
						[
							-82.63402983399993,
							27.75925966000006
						],
						[
							-82.6339723179999,
							27.759247568000035
						],
						[
							-82.63383331799992,
							27.759213567000074
						],
						[
							-82.63373941399993,
							27.759185086000063
						],
						[
							-82.63369092699992,
							27.759166226000048
						],
						[
							-82.63364753399992,
							27.759190584000066
						],
						[
							-82.63350158599991,
							27.759259087000093
						],
						[
							-82.63335344599994,
							27.759296264000056
						],
						[
							-82.63347758599991,
							27.759409600000083
						],
						[
							-82.63516972899993,
							27.76086030500005
						],
						[
							-82.63521811999993,
							27.760902370000053
						],
						[
							-82.63531691999992,
							27.76100292700005
						],
						[
							-82.63538407399994,
							27.761094038000067
						],
						[
							-82.6354220739999,
							27.76115303800009
						],
						[
							-82.63544483499993,
							27.761190339000052
						],
						[
							-82.63548967799994,
							27.761286504000054
						],
						[
							-82.63548967799994,
							27.760942080000063
						],
						[
							-82.63544142299992,
							27.760414989000083
						],
						[
							-82.63543809999993,
							27.760305457000072
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Albert Whitted Airport",
				"RegionID": "417150"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.6466999999999,
					27.76517000000007,
					-82.62060368099992,
					27.77759000000009
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.63007999999991,
							27.777580000000057
						],
						[
							-82.62988499999996,
							27.777424000000053
						],
						[
							-82.62994299999991,
							27.77737600000006
						],
						[
							-82.62938866899994,
							27.776559423000037
						],
						[
							-82.62945786199992,
							27.776440289000053
						],
						[
							-82.62966949499992,
							27.775980292000042
						],
						[
							-82.62991423999995,
							27.775339228000064
						],
						[
							-82.62978024499995,
							27.775338368000064
						],
						[
							-82.6285940969999,
							27.775361902000043
						],
						[
							-82.6284238049999,
							27.77574700300005
						],
						[
							-82.62839057299993,
							27.77581452800007
						],
						[
							-82.62812557299992,
							27.776300528000036
						],
						[
							-82.62811483599995,
							27.77631966100006
						],
						[
							-82.62811461199993,
							27.77631998000004
						],
						[
							-82.62561401699992,
							27.776390752000054
						],
						[
							-82.62563916399995,
							27.776337339000065
						],
						[
							-82.62565613999993,
							27.77631111800008
						],
						[
							-82.6256279129999,
							27.77625058600006
						],
						[
							-82.62559281699993,
							27.77612755000007
						],
						[
							-82.6255798169999,
							27.776065549000066
						],
						[
							-82.62556744999995,
							27.775991155000046
						],
						[
							-82.6255613589999,
							27.775915986000086
						],
						[
							-82.62556158699994,
							27.77584057100006
						],
						[
							-82.62556813299994,
							27.775765440000043
						],
						[
							-82.62558095099992,
							27.77569112200007
						],
						[
							-82.62560795199995,
							27.77556612300009
						],
						[
							-82.62564191399991,
							27.77544841400004
						],
						[
							-82.62571265899993,
							27.775298729000042
						],
						[
							-82.62581575699994,
							27.77512782900004
						],
						[
							-82.62585380999991,
							27.775044817000037
						],
						[
							-82.62571023899994,
							27.77482711400006
						],
						[
							-82.62568547799992,
							27.77478735300008
						],
						[
							-82.62557298799993,
							27.77459576800004
						],
						[
							-82.62503349499993,
							27.774612870000055
						],
						[
							-82.62499915799992,
							27.774613303000084
						],
						[
							-82.62351234999994,
							27.77460364400008
						],
						[
							-82.62346799199993,
							27.774647989000073
						],
						[
							-82.62343691199993,
							27.774674056000038
						],
						[
							-82.62337417599991,
							27.774722139000062
						],
						[
							-82.62330745999992,
							27.77476452800005
						],
						[
							-82.6232372799999,
							27.774800894000066
						],
						[
							-82.62316417799991,
							27.77483095900004
						],
						[
							-82.6230887179999,
							27.774854488000077
						],
						[
							-82.6230114839999,
							27.774871300000086
						],
						[
							-82.62293307199991,
							27.77488126600008
						],
						[
							-82.62269107199995,
							27.774901266000086
						],
						[
							-82.62260671299993,
							27.774904263000053
						],
						[
							-82.6215577129999,
							27.774892263000083
						],
						[
							-82.6214869239999,
							27.774888660000045
						],
						[
							-82.62141663799991,
							27.77487949300007
						],
						[
							-82.62134729199994,
							27.774864819000072
						],
						[
							-82.6212793169999,
							27.774844729000055
						],
						[
							-82.62121313499995,
							27.77481934800005
						],
						[
							-82.62114915799992,
							27.77478883400005
						],
						[
							-82.62113015799993,
							27.774778834000074
						],
						[
							-82.62106557899995,
							27.774741343000073
						],
						[
							-82.62100433199993,
							27.774698624000052
						],
						[
							-82.62094684099992,
							27.77465097000004
						],
						[
							-82.6208935009999,
							27.774598712000056
						],
						[
							-82.62084467999995,
							27.77454220800007
						],
						[
							-82.6208007159999,
							27.77448184900004
						],
						[
							-82.6207807159999,
							27.77445184900006
						],
						[
							-82.62076163599994,
							27.77442196800007
						],
						[
							-82.62075063499992,
							27.774403969000048
						],
						[
							-82.62071477699993,
							27.77433949200008
						],
						[
							-82.6206843249999,
							27.77427229300008
						],
						[
							-82.62065948299994,
							27.774202824000042
						],
						[
							-82.62064041899993,
							27.77413155300008
						],
						[
							-82.62062726199991,
							27.77405895800007
						],
						[
							-82.6206200979999,
							27.77398553000006
						],
						[
							-82.62060709899993,
							27.773754530000076
						],
						[
							-82.62060568399994,
							27.77370731900004
						],
						[
							-82.62060368099992,
							27.77316366000008
						],
						[
							-82.6206068159999,
							27.773086952000085
						],
						[
							-82.62061648199995,
							27.773010791000047
						],
						[
							-82.62063260799994,
							27.772935732000064
						],
						[
							-82.62065507699992,
							27.772862322000037
						],
						[
							-82.62068372599992,
							27.77279109600005
						],
						[
							-82.62071834499994,
							27.772722573000067
						],
						[
							-82.62075868199993,
							27.772657252000045
						],
						[
							-82.62080444299994,
							27.772595609000064
						],
						[
							-82.6208392609999,
							27.772552768000082
						],
						[
							-82.62089252399994,
							27.772493706000034
						],
						[
							-82.62095079799991,
							27.77243958100007
						],
						[
							-82.62101362699991,
							27.772390818000076
						],
						[
							-82.62108051999991,
							27.772347799000045
						],
						[
							-82.62115095299993,
							27.772310859000072
						],
						[
							-82.62122437499994,
							27.772280289000037
						],
						[
							-82.62130021099995,
							27.772256327000036
						],
						[
							-82.62137786799991,
							27.772239160000083
						],
						[
							-82.62142490299993,
							27.77223097800004
						],
						[
							-82.62158226999992,
							27.772217690000048
						],
						[
							-82.62184651199993,
							27.772219600000085
						],
						[
							-82.62283548699992,
							27.77219593500007
						],
						[
							-82.62291316999995,
							27.772197434000077
						],
						[
							-82.62299043299993,
							27.772205632000066
						],
						[
							-82.62306669999992,
							27.772220468000057
						],
						[
							-82.62314140199993,
							27.772241832000077
						],
						[
							-82.62316240199993,
							27.77224883200006
						],
						[
							-82.62323406799993,
							27.772276005000037
						],
						[
							-82.62330306499992,
							27.77230938000008
						],
						[
							-82.6233688559999,
							27.772348699000077
						],
						[
							-82.6234309319999,
							27.772393655000087
						],
						[
							-82.62348880899992,
							27.772443901000088
						],
						[
							-82.6235420399999,
							27.772499046000064
						],
						[
							-82.62365903499995,
							27.772496838000055
						],
						[
							-82.62368029499993,
							27.772496689000036
						],
						[
							-82.62505067799994,
							27.772503233000066
						],
						[
							-82.62505067799994,
							27.772482000000082
						],
						[
							-82.62505411799992,
							27.772403411000084
						],
						[
							-82.62506411899994,
							27.77228941000004
						],
						[
							-82.6250743409999,
							27.772211834000075
						],
						[
							-82.62511491399994,
							27.772060413000077
						],
						[
							-82.6251811649999,
							27.77191833900008
						],
						[
							-82.62527107999995,
							27.771789927000043
						],
						[
							-82.62538192699992,
							27.77167907900008
						],
						[
							-82.6255103389999,
							27.77158916400009
						],
						[
							-82.62559894499992,
							27.77154433700008
						],
						[
							-82.62567194499991,
							27.77151233800004
						],
						[
							-82.62572541399993,
							27.771490914000083
						],
						[
							-82.62587683499993,
							27.771450341000048
						],
						[
							-82.62603299999995,
							27.771436678000043
						],
						[
							-82.62618916599992,
							27.771450341000048
						],
						[
							-82.62634058599991,
							27.771490914000083
						],
						[
							-82.62645170099995,
							27.77154159400004
						],
						[
							-82.62642236499994,
							27.771866677000048
						],
						[
							-82.62657371599994,
							27.772147757000084
						],
						[
							-82.62700614599993,
							27.77223424300007
						],
						[
							-82.62780614199994,
							27.77223424300007
						],
						[
							-82.62868285299993,
							27.77225562400008
						],
						[
							-82.62878630299991,
							27.77233350100005
						],
						[
							-82.62884056299993,
							27.77236838400006
						],
						[
							-82.62943238799994,
							27.772341311000048
						],
						[
							-82.62985299699994,
							27.77232999800009
						],
						[
							-82.62987472299994,
							27.772329681000087
						],
						[
							-82.63074289199994,
							27.772327483000083
						],
						[
							-82.63090922099991,
							27.771756611000058
						],
						[
							-82.63148179799992,
							27.771304518000083
						],
						[
							-82.63180611999991,
							27.771109925000076
						],
						[
							-82.63193584899994,
							27.77082884500004
						],
						[
							-82.6319949469999,
							27.77037307200004
						],
						[
							-82.6319949469999,
							27.77022951300006
						],
						[
							-82.63202233499993,
							27.769488312000078
						],
						[
							-82.63197909199994,
							27.769012638000053
						],
						[
							-82.63178449899993,
							27.76873155900006
						],
						[
							-82.63137368999992,
							27.768493722000073
						],
						[
							-82.6308399909999,
							27.768383587000073
						],
						[
							-82.63069333899995,
							27.768314836000062
						],
						[
							-82.63064859999992,
							27.76828723200009
						],
						[
							-82.63053159999993,
							27.768210232000058
						],
						[
							-82.63047247399993,
							27.768167797000046
						],
						[
							-82.6304169739999,
							27.76812071900008
						],
						[
							-82.63036546399991,
							27.768069307000076
						],
						[
							-82.63031827999993,
							27.76801389600007
						],
						[
							-82.6302757329999,
							27.76795485200006
						],
						[
							-82.63023809999993,
							27.767892559000074
						],
						[
							-82.63020562999992,
							27.767827426000053
						],
						[
							-82.63017853299993,
							27.767759881000075
						],
						[
							-82.6301401529999,
							27.767649176000077
						],
						[
							-82.63010664099994,
							27.76752003000007
						],
						[
							-82.63074099999994,
							27.766437000000053
						],
						[
							-82.63066081099993,
							27.766145298000083
						],
						[
							-82.63059330499993,
							27.765922962000047
						],
						[
							-82.6306175439999,
							27.765699065000035
						],
						[
							-82.63083426599991,
							27.76551185900007
						],
						[
							-82.63115084999993,
							27.765343939000047
						],
						[
							-82.63141549999995,
							27.765235918000087
						],
						[
							-82.63181751099995,
							27.76519355700009
						],
						[
							-82.63223127299995,
							27.765177643000072
						],
						[
							-82.6327941909999,
							27.76517000000007
						],
						[
							-82.63302376299993,
							27.76519344100007
						],
						[
							-82.63331232199995,
							27.765335151000045
						],
						[
							-82.6335075369999,
							27.765510990000053
						],
						[
							-82.6336760989999,
							27.765657155000042
						],
						[
							-82.63384617199995,
							27.76570853000004
						],
						[
							-82.63393999999994,
							27.765700000000038
						],
						[
							-82.6344464689999,
							27.76569032200007
						],
						[
							-82.63504687599993,
							27.765678850000086
						],
						[
							-82.63594747899992,
							27.765670000000057
						],
						[
							-82.63669819499995,
							27.765658477000045
						],
						[
							-82.63718349699992,
							27.765643325000042
						],
						[
							-82.63744747699991,
							27.76564524300005
						],
						[
							-82.63782459599992,
							27.76565525500007
						],
						[
							-82.6381622099999,
							27.76566421800004
						],
						[
							-82.63883771899992,
							27.765650850000043
						],
						[
							-82.63988923399995,
							27.76564184600005
						],
						[
							-82.64094018499992,
							27.765640000000076
						],
						[
							-82.64168999999993,
							27.765640000000076
						],
						[
							-82.6427045239999,
							27.765640000000076
						],
						[
							-82.64364313599992,
							27.765635583000062
						],
						[
							-82.64435624599992,
							27.765630000000044
						],
						[
							-82.64514456799992,
							27.765630000000044
						],
						[
							-82.64608350399993,
							27.76562316700006
						],
						[
							-82.6466459099999,
							27.76560328000005
						],
						[
							-82.64663999999993,
							27.76610000000005
						],
						[
							-82.6466299999999,
							27.766674815000044
						],
						[
							-82.6466299999999,
							27.76705000000004
						],
						[
							-82.6466299999999,
							27.76746313700005
						],
						[
							-82.6466299999999,
							27.767940000000067
						],
						[
							-82.6466299999999,
							27.768176381000046
						],
						[
							-82.6466299999999,
							27.768470000000036
						],
						[
							-82.6466299999999,
							27.768470956000044
						],
						[
							-82.6466299999999,
							27.769002242000056
						],
						[
							-82.6466299999999,
							27.769350000000088
						],
						[
							-82.64663531399992,
							27.769828223000047
						],
						[
							-82.64663999999993,
							27.77025000000009
						],
						[
							-82.64664295199992,
							27.770503845000064
						],
						[
							-82.64664999999991,
							27.77111000000008
						],
						[
							-82.6466542309999,
							27.771291941000072
						],
						[
							-82.64665999999994,
							27.771540000000073
						],
						[
							-82.64666534499992,
							27.77178054600006
						],
						[
							-82.6466699959999,
							27.77198982600004
						],
						[
							-82.64666999999992,
							27.771990000000073
						],
						[
							-82.6466761929999,
							27.77230583300008
						],
						[
							-82.64667999999995,
							27.772530921000055
						],
						[
							-82.64667999999995,
							27.772943852000083
						],
						[
							-82.64667999999995,
							27.77341000000007
						],
						[
							-82.64668427599992,
							27.773619544000045
						],
						[
							-82.64668999999992,
							27.773900000000083
						],
						[
							-82.64668999999992,
							27.774107565000065
						],
						[
							-82.64668999999992,
							27.774440000000084
						],
						[
							-82.64669528699994,
							27.77482064700007
						],
						[
							-82.6466999999999,
							27.77526000000006
						],
						[
							-82.6466999999999,
							27.775534052000072
						],
						[
							-82.6466999999999,
							27.775750000000073
						],
						[
							-82.6466999999999,
							27.77613467900005
						],
						[
							-82.64669687899993,
							27.776486152000075
						],
						[
							-82.64668999999992,
							27.777260853000087
						],
						[
							-82.64668999999992,
							27.77750000000009
						],
						[
							-82.64642146099993,
							27.777507161000074
						],
						[
							-82.64623289799994,
							27.77751218900005
						],
						[
							-82.64582027299991,
							27.77752000000004
						],
						[
							-82.64503195099992,
							27.77752000000004
						],
						[
							-82.64460999999994,
							27.77752000000004
						],
						[
							-82.64405600299995,
							27.77751534500004
						],
						[
							-82.64341999999994,
							27.777510000000063
						],
						[
							-82.64300483699992,
							27.777510000000063
						],
						[
							-82.6425799999999,
							27.777510000000063
						],
						[
							-82.64225405499991,
							27.77750000000009
						],
						[
							-82.64199128099995,
							27.77750000000009
						],
						[
							-82.6413531149999,
							27.77750000000009
						],
						[
							-82.64086510599992,
							27.77750000000009
						],
						[
							-82.64057999999994,
							27.77750000000009
						],
						[
							-82.64033955899993,
							27.77750000000009
						],
						[
							-82.6401899999999,
							27.77750000000009
						],
						[
							-82.63996444999992,
							27.77750363800004
						],
						[
							-82.63981372699993,
							27.777506069000083
						],
						[
							-82.63956999999994,
							27.777510000000063
						],
						[
							-82.6392132819999,
							27.777513640000052
						],
						[
							-82.63883792999991,
							27.777517470000078
						],
						[
							-82.63852999999995,
							27.77752000000004
						],
						[
							-82.63852934399995,
							27.77752000000004
						],
						[
							-82.63827490599994,
							27.77752000000004
						],
						[
							-82.63774933299993,
							27.77752174200009
						],
						[
							-82.63748660499994,
							27.77752524500005
						],
						[
							-82.6371299999999,
							27.77753000000007
						],
						[
							-82.63684854799993,
							27.777533632000086
						],
						[
							-82.63651075199994,
							27.777537990000045
						],
						[
							-82.63609740499993,
							27.777543324000078
						],
						[
							-82.63557999999995,
							27.777550000000076
						],
						[
							-82.63515910199993,
							27.777552751000087
						],
						[
							-82.63444588899995,
							27.77755741200008
						],
						[
							-82.63404999999995,
							27.77756000000005
						],
						[
							-82.6336575919999,
							27.77756000000005
						],
						[
							-82.63316958299994,
							27.77756000000005
						],
						[
							-82.63250999999991,
							27.77756000000005
						],
						[
							-82.63204344399992,
							27.77756471300006
						],
						[
							-82.6315930209999,
							27.777569262000046
						],
						[
							-82.63125999999994,
							27.77759000000009
						],
						[
							-82.6309924059999,
							27.777587732000086
						],
						[
							-82.6305795049999,
							27.777584233000084
						],
						[
							-82.63007999999991,
							27.777580000000057
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Downtown",
				"RegionID": "417151"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.66285999999991,
					27.79184000000004,
					-82.6548721929999,
					27.79927000000004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.65497999999991,
							27.79198000000008
						],
						[
							-82.65556307999992,
							27.79197642300005
						],
						[
							-82.65611223699995,
							27.79197305400004
						],
						[
							-82.6566601529999,
							27.791971355000044
						],
						[
							-82.65697999999992,
							27.79198000000008
						],
						[
							-82.65737416999991,
							27.791976154000054
						],
						[
							-82.65803271599992,
							27.791969730000062
						],
						[
							-82.65836252499992,
							27.791966512000045
						],
						[
							-82.65902999999992,
							27.791960000000074
						],
						[
							-82.65929554299993,
							27.79195499000008
						],
						[
							-82.65976999999992,
							27.79184000000004
						],
						[
							-82.6606799999999,
							27.791940000000068
						],
						[
							-82.6606821119999,
							27.791939994000074
						],
						[
							-82.66068605999993,
							27.79215332300004
						],
						[
							-82.6606999999999,
							27.79259301600007
						],
						[
							-82.66070931999991,
							27.79299642500007
						],
						[
							-82.6607625659999,
							27.79340288000009
						],
						[
							-82.66086415699993,
							27.793812470000034
						],
						[
							-82.6609593469999,
							27.79409804100004
						],
						[
							-82.66106744599995,
							27.794414585000084
						],
						[
							-82.66118519899993,
							27.79471864800007
						],
						[
							-82.66135443999991,
							27.79511158200006
						],
						[
							-82.6615209389999,
							27.79548508000005
						],
						[
							-82.66184051099992,
							27.796206935000043
						],
						[
							-82.66197145899993,
							27.796542488000057
						],
						[
							-82.6621784479999,
							27.79702343000008
						],
						[
							-82.6623356049999,
							27.797384890000046
						],
						[
							-82.66248888099994,
							27.797749354000075
						],
						[
							-82.66257054699992,
							27.797979040000087
						],
						[
							-82.66270736699994,
							27.79843078400006
						],
						[
							-82.66277202399993,
							27.79874236900008
						],
						[
							-82.66282061899994,
							27.79900934300008
						],
						[
							-82.66285999999991,
							27.799240000000054
						],
						[
							-82.66285181399991,
							27.799240127000076
						],
						[
							-82.6622159819999,
							27.799250000000086
						],
						[
							-82.6616668069999,
							27.799250000000086
						],
						[
							-82.66126407899992,
							27.799250000000086
						],
						[
							-82.66071490399992,
							27.799250000000086
						],
						[
							-82.65932365999993,
							27.799250000000086
						],
						[
							-82.65862802299995,
							27.79925496700008
						],
						[
							-82.65745652499993,
							27.79926502400008
						],
						[
							-82.65617505599994,
							27.79927000000004
						],
						[
							-82.65490999999992,
							27.79926000000006
						],
						[
							-82.65490793299995,
							27.799078113000064
						],
						[
							-82.65490387699992,
							27.79872119500004
						],
						[
							-82.65489999999994,
							27.79806188500004
						],
						[
							-82.65489999999994,
							27.797704921000047
						],
						[
							-82.65489999999994,
							27.79721066400009
						],
						[
							-82.65489999999994,
							27.796826241000076
						],
						[
							-82.65489999999994,
							27.796277066000076
						],
						[
							-82.65489999999994,
							27.79597502000007
						],
						[
							-82.65489170399991,
							27.79523325300005
						],
						[
							-82.65487999999993,
							27.794684458000063
						],
						[
							-82.65487999999993,
							27.794217659000083
						],
						[
							-82.65487999999993,
							27.79361356600009
						],
						[
							-82.65487999999993,
							27.79331152000009
						],
						[
							-82.65487999999993,
							27.792625051000073
						],
						[
							-82.65487475099991,
							27.79215827400009
						],
						[
							-82.6548721929999,
							27.79198087800006
						],
						[
							-82.65497999999991,
							27.79198000000008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Lake Euclid",
				"RegionID": "417165"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.66858464299993,
					27.791933190000066,
					-82.6606821119999,
					27.799240000000054
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.66242365999994,
							27.791934905000062
						],
						[
							-82.66362861499994,
							27.791933190000066
						],
						[
							-82.6639933969999,
							27.792700489000083
						],
						[
							-82.66493915899993,
							27.794609209000043
						],
						[
							-82.66554100799993,
							27.795623754000076
						],
						[
							-82.66595370399995,
							27.796277190000072
						],
						[
							-82.66628042199994,
							27.796724278000056
						],
						[
							-82.66662433499994,
							27.79718856100004
						],
						[
							-82.66701983599995,
							27.79761845300004
						],
						[
							-82.66750131499992,
							27.798185910000086
						],
						[
							-82.66801718499994,
							27.798684585000046
						],
						[
							-82.66837829399992,
							27.799045694000085
						],
						[
							-82.66858464299993,
							27.799210000000073
						],
						[
							-82.66815465299993,
							27.799211989000074
						],
						[
							-82.66791398499993,
							27.799216138000077
						],
						[
							-82.66739814099992,
							27.799220000000048
						],
						[
							-82.66693385699995,
							27.799220000000048
						],
						[
							-82.66648690799991,
							27.799224964000075
						],
						[
							-82.66633187699995,
							27.799227889000065
						],
						[
							-82.66605687799996,
							27.79923000000008
						],
						[
							-82.66554100799993,
							27.79923000000008
						],
						[
							-82.66490476699995,
							27.79923000000008
						],
						[
							-82.66449207099993,
							27.79923000000008
						],
						[
							-82.66406217899993,
							27.79923000000008
						],
						[
							-82.6638214059999,
							27.79923210700008
						],
						[
							-82.66339158099994,
							27.79923748000005
						],
						[
							-82.66306482999994,
							27.799240000000054
						],
						[
							-82.66285999999991,
							27.799240000000054
						],
						[
							-82.66282061899994,
							27.79900934300008
						],
						[
							-82.66277202399993,
							27.79874236900008
						],
						[
							-82.66270736699994,
							27.79843078400006
						],
						[
							-82.66257054699992,
							27.797979040000087
						],
						[
							-82.66248888099994,
							27.797749354000075
						],
						[
							-82.6623356049999,
							27.797384890000046
						],
						[
							-82.6621784479999,
							27.79702343000008
						],
						[
							-82.66197145899993,
							27.796542488000057
						],
						[
							-82.66184051099992,
							27.796206935000043
						],
						[
							-82.6615209389999,
							27.79548508000005
						],
						[
							-82.66135443999991,
							27.79511158200006
						],
						[
							-82.66118519899993,
							27.79471864800007
						],
						[
							-82.66106744599995,
							27.794414585000084
						],
						[
							-82.6609593469999,
							27.79409804100004
						],
						[
							-82.66086415699993,
							27.793812470000034
						],
						[
							-82.6607625659999,
							27.79340288000009
						],
						[
							-82.66070931999991,
							27.79299642500007
						],
						[
							-82.6606999999999,
							27.79259301600007
						],
						[
							-82.66068605999993,
							27.79215332300004
						],
						[
							-82.6606821119999,
							27.791939994000074
						],
						[
							-82.66242365999994,
							27.791934905000062
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Norwood Heights",
				"RegionID": "417166"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.6795755839999,
					27.791844584000046,
					-82.66362861499994,
					27.799210000000073
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.66858464299993,
							27.799210000000073
						],
						[
							-82.66837829399992,
							27.799045694000085
						],
						[
							-82.66801718499994,
							27.798684585000046
						],
						[
							-82.66750131499992,
							27.798185910000086
						],
						[
							-82.66701983599995,
							27.79761845300004
						],
						[
							-82.66662433499994,
							27.79718856100004
						],
						[
							-82.66628042199994,
							27.796724278000056
						],
						[
							-82.66595370399995,
							27.796277190000072
						],
						[
							-82.66554100799993,
							27.795623754000076
						],
						[
							-82.66493915899993,
							27.794609209000043
						],
						[
							-82.6639933969999,
							27.792700489000083
						],
						[
							-82.66362861499994,
							27.791933190000066
						],
						[
							-82.66379599599992,
							27.79193295200008
						],
						[
							-82.66516790299994,
							27.791941783000084
						],
						[
							-82.66599107199994,
							27.791933087000075
						],
						[
							-82.66692399699993,
							27.791923232000048
						],
						[
							-82.66769259099993,
							27.79192000000006
						],
						[
							-82.66813166299994,
							27.79192000000006
						],
						[
							-82.66879027099992,
							27.79192000000006
						],
						[
							-82.66950390799991,
							27.791918725000073
						],
						[
							-82.66994243999994,
							27.791916607000076
						],
						[
							-82.67027226699993,
							27.79191501300005
						],
						[
							-82.67076621199993,
							27.791912627000045
						],
						[
							-82.6718639309999,
							27.791904569000053
						],
						[
							-82.67274199199994,
							27.791895961000083
						],
						[
							-82.67389438599992,
							27.79188199400005
						],
						[
							-82.67482801999995,
							27.791868264000072
						],
						[
							-82.67608999399994,
							27.79185523800004
						],
						[
							-82.6768583349999,
							27.791850011000065
						],
						[
							-82.67784591199995,
							27.791854680000085
						],
						[
							-82.67883437099994,
							27.79184970700004
						],
						[
							-82.67952933599992,
							27.791844584000046
						],
						[
							-82.67952999999994,
							27.792182559000082
						],
						[
							-82.67953334399994,
							27.793064265000055
						],
						[
							-82.67953999999992,
							27.794071400000064
						],
						[
							-82.67954133199993,
							27.794701173000078
						],
						[
							-82.67954999999995,
							27.795771357000035
						],
						[
							-82.67954999999995,
							27.796904661000045
						],
						[
							-82.67956046599996,
							27.797974928000087
						],
						[
							-82.67957084099993,
							27.798604371000067
						],
						[
							-82.6795755839999,
							27.799158812000087
						],
						[
							-82.6791300509999,
							27.799160000000086
						],
						[
							-82.6785186489999,
							27.799160000000086
						],
						[
							-82.67774421699994,
							27.799165781000056
						],
						[
							-82.67717364099991,
							27.79917289100007
						],
						[
							-82.67656229699992,
							27.799178856000083
						],
						[
							-82.67603206899992,
							27.79918402900006
						],
						[
							-82.67541999999992,
							27.799190000000067
						],
						[
							-82.67489089299994,
							27.799195239000085
						],
						[
							-82.67440999999991,
							27.79920000000004
						],
						[
							-82.67391275499995,
							27.79920000000004
						],
						[
							-82.67337999999995,
							27.79920000000004
						],
						[
							-82.67285309899995,
							27.799194884000087
						],
						[
							-82.67234999999994,
							27.799190000000067
						],
						[
							-82.67171170799992,
							27.799190000000067
						],
						[
							-82.6713508329999,
							27.799192194000057
						],
						[
							-82.6708556339999,
							27.799195204000057
						],
						[
							-82.66975523199994,
							27.79920678700006
						],
						[
							-82.6690215399999,
							27.799210000000073
						],
						[
							-82.66858464299993,
							27.799210000000073
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Ponce De Leon",
				"RegionID": "417167"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.6795899999999,
					27.799158812000087,
					-82.6713499999999,
					27.806500000000085
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.67135999999994,
							27.806500000000085
						],
						[
							-82.67136249499993,
							27.806240434000074
						],
						[
							-82.67136481499995,
							27.806036257000073
						],
						[
							-82.67136800899993,
							27.805755223000062
						],
						[
							-82.67136766899995,
							27.80537253700004
						],
						[
							-82.67136451499994,
							27.80509179200004
						],
						[
							-82.67136192999993,
							27.804861805000087
						],
						[
							-82.67135999999994,
							27.803994061000083
						],
						[
							-82.67135692799991,
							27.80348348600006
						],
						[
							-82.67135267399993,
							27.80310065100008
						],
						[
							-82.6713499999999,
							27.802641211000036
						],
						[
							-82.6713499999999,
							27.802079650000053
						],
						[
							-82.67135099299992,
							27.801441513000043
						],
						[
							-82.67135801899991,
							27.800497027000063
						],
						[
							-82.67135253799995,
							27.799603669000078
						],
						[
							-82.6713508329999,
							27.799192194000057
						],
						[
							-82.67171170799992,
							27.799190000000067
						],
						[
							-82.67234999999994,
							27.799190000000067
						],
						[
							-82.67285309899995,
							27.799194884000087
						],
						[
							-82.67337999999995,
							27.79920000000004
						],
						[
							-82.67391275499995,
							27.79920000000004
						],
						[
							-82.67440999999991,
							27.79920000000004
						],
						[
							-82.67489089299994,
							27.799195239000085
						],
						[
							-82.67541999999992,
							27.799190000000067
						],
						[
							-82.67603206899992,
							27.79918402900006
						],
						[
							-82.67656229699992,
							27.799178856000083
						],
						[
							-82.67717364099991,
							27.79917289100007
						],
						[
							-82.67774421699994,
							27.799165781000056
						],
						[
							-82.6785186489999,
							27.799160000000086
						],
						[
							-82.6791300509999,
							27.799160000000086
						],
						[
							-82.6795755839999,
							27.799158812000087
						],
						[
							-82.67957999999993,
							27.79967496100005
						],
						[
							-82.67957999999993,
							27.800241614000072
						],
						[
							-82.67957999999993,
							27.801563803000082
						],
						[
							-82.67957999999993,
							27.80225637800004
						],
						[
							-82.67958348399992,
							27.803137543000048
						],
						[
							-82.67958817999994,
							27.803578892000075
						],
						[
							-82.6795899999999,
							27.804334103000087
						],
						[
							-82.6795899999999,
							27.805215562000058
						],
						[
							-82.6795899999999,
							27.805971098000043
						],
						[
							-82.67958820699994,
							27.806465564000064
						],
						[
							-82.67908538499995,
							27.806462168000053
						],
						[
							-82.67860022199994,
							27.806460000000072
						],
						[
							-82.67770677699991,
							27.80646608400008
						],
						[
							-82.67612420599995,
							27.80647556300005
						],
						[
							-82.67507777299994,
							27.80647496200004
						],
						[
							-82.67426079699993,
							27.80648345500009
						],
						[
							-82.67372479399995,
							27.806487579000077
						],
						[
							-82.67303563799993,
							27.806490370000063
						],
						[
							-82.67201465199992,
							27.80649623800008
						],
						[
							-82.67135999999994,
							27.806500000000085
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Ridgecrest",
				"RegionID": "417168"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.63056912099995,
					27.813115159000063,
					-82.61587021699995,
					27.82142171600009
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.61998977699994,
							27.82136685300009
						],
						[
							-82.61948990399992,
							27.82107377700004
						],
						[
							-82.61948637199993,
							27.821052385000087
						],
						[
							-82.61948060399993,
							27.82099381900008
						],
						[
							-82.61947944499993,
							27.820972132000065
						],
						[
							-82.61947623499992,
							27.82089446200007
						],
						[
							-82.61944003399992,
							27.820809564000058
						],
						[
							-82.61943511699991,
							27.820799949000047
						],
						[
							-82.61939585399995,
							27.82075796400005
						],
						[
							-82.61935851999993,
							27.820712472000082
						],
						[
							-82.6193516319999,
							27.820703378000076
						],
						[
							-82.61920963299991,
							27.820513378000044
						],
						[
							-82.61918224099992,
							27.820474636000085
						],
						[
							-82.61915116499995,
							27.82042466100006
						],
						[
							-82.6191234229999,
							27.820372760000055
						],
						[
							-82.61909913499994,
							27.82031915600004
						],
						[
							-82.61908039199994,
							27.820269865000057
						],
						[
							-82.61902139199992,
							27.82009986500009
						],
						[
							-82.6190194049999,
							27.820094078000068
						],
						[
							-82.61900232199991,
							27.820037762000084
						],
						[
							-82.61898895799993,
							27.81998044900007
						],
						[
							-82.61898522099995,
							27.819960486000074
						],
						[
							-82.61895222099992,
							27.819772486000094
						],
						[
							-82.61894637099994,
							27.81973438600005
						],
						[
							-82.61894060299994,
							27.819675819000054
						],
						[
							-82.61893867799995,
							27.81961700000005
						],
						[
							-82.61893867799995,
							27.819592449000083
						],
						[
							-82.61889013699994,
							27.819529575000047
						],
						[
							-82.61888851899994,
							27.81952747200006
						],
						[
							-82.61885424099995,
							27.81947963600004
						],
						[
							-82.61884385099995,
							27.819463726000038
						],
						[
							-82.61879593299994,
							27.819388624000055
						],
						[
							-82.61850924299995,
							27.819109496000067
						],
						[
							-82.6182291479999,
							27.81891792500005
						],
						[
							-82.61822555999993,
							27.818916252000065
						],
						[
							-82.6181284839999,
							27.818895556000086
						],
						[
							-82.61808323799994,
							27.818884679000067
						],
						[
							-82.61806714099994,
							27.818880205000085
						],
						[
							-82.61787614199994,
							27.818825204000067
						],
						[
							-82.61783592199993,
							27.818812595000054
						],
						[
							-82.61778084399992,
							27.818791865000037
						],
						[
							-82.61772723999991,
							27.818767577000074
						],
						[
							-82.61767533899992,
							27.818739835000088
						],
						[
							-82.61762536299995,
							27.81870875900006
						],
						[
							-82.61757752699992,
							27.818674480000084
						],
						[
							-82.61753203599994,
							27.81863714600007
						],
						[
							-82.61748908299991,
							27.81859691600005
						],
						[
							-82.61746050199991,
							27.81856698900009
						],
						[
							-82.6172166469999,
							27.818299590000038
						],
						[
							-82.61708792199994,
							27.81819561900005
						],
						[
							-82.61706528799994,
							27.818176717000085
						],
						[
							-82.61693955599992,
							27.818184546000055
						],
						[
							-82.6166751689999,
							27.818210890000046
						],
						[
							-82.61664481799994,
							27.81821339600009
						],
						[
							-82.61658599999993,
							27.81821532200007
						],
						[
							-82.61652718099992,
							27.81821339600009
						],
						[
							-82.61651999899993,
							27.818212689000063
						],
						[
							-82.6162435519999,
							27.81795534300005
						],
						[
							-82.61599895299992,
							27.81755626100005
						],
						[
							-82.61596033299992,
							27.817182926000044
						],
						[
							-82.61594745899993,
							27.816564992000053
						],
						[
							-82.61594745899993,
							27.815972805000058
						],
						[
							-82.61587021699995,
							27.81553510200007
						],
						[
							-82.61594745899993,
							27.815058778000036
						],
						[
							-82.61603757399992,
							27.814389349000066
						],
						[
							-82.61606332199995,
							27.813707047000037
						],
						[
							-82.61607579299994,
							27.813115159000063
						],
						[
							-82.61665360799992,
							27.813348149000035
						],
						[
							-82.61726870199993,
							27.813450664000072
						],
						[
							-82.61795835299995,
							27.81350658200006
						],
						[
							-82.61833095799994,
							27.813517722000086
						],
						[
							-82.6213542829999,
							27.813517722000086
						],
						[
							-82.62411208799995,
							27.81349394700004
						],
						[
							-82.6263706339999,
							27.81349394700004
						],
						[
							-82.62789218199993,
							27.81347017300004
						],
						[
							-82.63035999999994,
							27.81347017300004
						],
						[
							-82.63035999999994,
							27.814051835000043
						],
						[
							-82.63035999999994,
							27.81435298400004
						],
						[
							-82.63036208299991,
							27.81457292200008
						],
						[
							-82.63036538099993,
							27.81468832300004
						],
						[
							-82.63036999999991,
							27.814850000000035
						],
						[
							-82.63044999999994,
							27.814940000000036
						],
						[
							-82.63046178399992,
							27.81507110000007
						],
						[
							-82.63047417799993,
							27.815208977000054
						],
						[
							-82.6304993359999,
							27.815488864000088
						],
						[
							-82.63052421599991,
							27.81576565200004
						],
						[
							-82.6305390089999,
							27.81606647500007
						],
						[
							-82.63055447999996,
							27.816472601000044
						],
						[
							-82.63056417299993,
							27.816727050000054
						],
						[
							-82.63056912099995,
							27.816947685000063
						],
						[
							-82.63056641399993,
							27.817156138000087
						],
						[
							-82.6305619019999,
							27.817503558000055
						],
						[
							-82.63055999999995,
							27.817885687000057
						],
						[
							-82.63055999999995,
							27.818233166000084
						],
						[
							-82.63056125599991,
							27.81854314000009
						],
						[
							-82.63055436399992,
							27.821302564000064
						],
						[
							-82.63005566299995,
							27.821334353000054
						],
						[
							-82.62881074099994,
							27.821334353000054
						],
						[
							-82.6278934309999,
							27.821334353000054
						],
						[
							-82.62728188999995,
							27.821290671000042
						],
						[
							-82.62629905699993,
							27.82131251200008
						],
						[
							-82.6251851799999,
							27.82131251200008
						],
						[
							-82.62374369199995,
							27.82131251200008
						],
						[
							-82.62333235599993,
							27.821321454000046
						],
						[
							-82.62273901799995,
							27.821334353000054
						],
						[
							-82.62230220299995,
							27.821356193000042
						],
						[
							-82.62210563699995,
							27.821399875000054
						],
						[
							-82.62193091099994,
							27.82142171600009
						],
						[
							-82.62138489299991,
							27.82137803400008
						],
						[
							-82.62056799999993,
							27.821371000000056
						],
						[
							-82.61998977699994,
							27.82136685300009
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Pacido Bayou",
				"RegionID": "417181"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.64686999999992,
					27.821160000000077,
					-82.62333235599993,
					27.828550000000064
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.62345890499995,
							27.825160106000055
						],
						[
							-82.62333235599993,
							27.821321454000046
						],
						[
							-82.62374369199995,
							27.82131251200008
						],
						[
							-82.6251851799999,
							27.82131251200008
						],
						[
							-82.62629905699993,
							27.82131251200008
						],
						[
							-82.62728188999995,
							27.821290671000042
						],
						[
							-82.6278934309999,
							27.821334353000054
						],
						[
							-82.62881074099994,
							27.821334353000054
						],
						[
							-82.63005566299995,
							27.821334353000054
						],
						[
							-82.63055436399992,
							27.821302564000064
						],
						[
							-82.63282527799993,
							27.82128786900006
						],
						[
							-82.63393170199993,
							27.82128786900006
						],
						[
							-82.63454999999993,
							27.821270000000084
						],
						[
							-82.63474170599994,
							27.821270000000084
						],
						[
							-82.63521476199992,
							27.821273359000088
						],
						[
							-82.63568768099992,
							27.82128000000006
						],
						[
							-82.63595045199992,
							27.82128000000006
						],
						[
							-82.63642343899994,
							27.82128000000006
						],
						[
							-82.63682635499993,
							27.82128000000006
						],
						[
							-82.63715911399993,
							27.821274229000043
						],
						[
							-82.63745667099994,
							27.82126560400008
						],
						[
							-82.6377402629999,
							27.82124905900008
						],
						[
							-82.63797999999991,
							27.82122000000004
						],
						[
							-82.63814008299994,
							27.821217240000067
						],
						[
							-82.63831581499994,
							27.82121421000005
						],
						[
							-82.63855999999993,
							27.821210000000065
						],
						[
							-82.63867999999991,
							27.821160000000077
						],
						[
							-82.6388581299999,
							27.821162255000047
						],
						[
							-82.63905101899991,
							27.82116469600004
						],
						[
							-82.63927871699991,
							27.821167579000075
						],
						[
							-82.63959149599994,
							27.821189184000048
						],
						[
							-82.63992079399992,
							27.821266586000036
						],
						[
							-82.64012999999994,
							27.821320000000075
						],
						[
							-82.64026177799991,
							27.82134493100006
						],
						[
							-82.64052381399995,
							27.821369050000044
						],
						[
							-82.64080350399992,
							27.821393434000072
						],
						[
							-82.64123966799991,
							27.821431458000063
						],
						[
							-82.64169776499995,
							27.82147139500006
						],
						[
							-82.64202809699992,
							27.821500193000077
						],
						[
							-82.64236999999991,
							27.821530000000052
						],
						[
							-82.64260628999995,
							27.821551266000085
						],
						[
							-82.64281794599992,
							27.82157031500009
						],
						[
							-82.64308173299992,
							27.821594056000038
						],
						[
							-82.64337772699992,
							27.82162028600004
						],
						[
							-82.64364021799992,
							27.821629990000076
						],
						[
							-82.64385233999991,
							27.82162063200008
						],
						[
							-82.64409711699996,
							27.821609833000082
						],
						[
							-82.64431999999995,
							27.821600000000046
						],
						[
							-82.64446277699994,
							27.821584216000076
						],
						[
							-82.6445707069999,
							27.821565169000053
						],
						[
							-82.64478014499991,
							27.82152545200006
						],
						[
							-82.64498938499992,
							27.821485323000047
						],
						[
							-82.64527269299992,
							27.821430990000067
						],
						[
							-82.64555032599992,
							27.821382094000057
						],
						[
							-82.64578029599994,
							27.821342530000038
						],
						[
							-82.64609240999994,
							27.821288833000043
						],
						[
							-82.64637639199992,
							27.82124174200004
						],
						[
							-82.64674348299991,
							27.821184160000087
						],
						[
							-82.64681999999993,
							27.82123000000007
						],
						[
							-82.64682117099994,
							27.82157443000006
						],
						[
							-82.64682659599993,
							27.821872776000077
						],
						[
							-82.64682999999991,
							27.82206000000008
						],
						[
							-82.64682999999991,
							27.822170536000044
						],
						[
							-82.64682999999991,
							27.82245082500009
						],
						[
							-82.64682999999991,
							27.822871258000077
						],
						[
							-82.64682999999991,
							27.822970000000055
						],
						[
							-82.64682999999991,
							27.82330921000005
						],
						[
							-82.64682999999991,
							27.82364205300007
						],
						[
							-82.64682999999991,
							27.823880000000088
						],
						[
							-82.64682999999991,
							27.824115041000084
						],
						[
							-82.64682999999991,
							27.824482920000037
						],
						[
							-82.64682999999991,
							27.824790000000068
						],
						[
							-82.64682999999991,
							27.825131088000035
						],
						[
							-82.64683531199995,
							27.825674417000073
						],
						[
							-82.64684940099994,
							27.826269698000093
						],
						[
							-82.64685727499995,
							27.826602354000045
						],
						[
							-82.64686309599995,
							27.826848299000062
						],
						[
							-82.64686999999992,
							27.827140000000043
						],
						[
							-82.64686999999992,
							27.827478508000073
						],
						[
							-82.64686999999992,
							27.827986532000068
						],
						[
							-82.64686999999992,
							27.82842000000005
						],
						[
							-82.64654885999994,
							27.82842277800006
						],
						[
							-82.64612847399991,
							27.82842725000006
						],
						[
							-82.64586999999995,
							27.828430000000083
						],
						[
							-82.64563793899993,
							27.828430000000083
						],
						[
							-82.64540999999991,
							27.828430000000083
						],
						[
							-82.64520002699993,
							27.828431228000056
						],
						[
							-82.6448146429999,
							27.828433482000037
						],
						[
							-82.64442915599994,
							27.828435736000074
						],
						[
							-82.64395618499992,
							27.82843850200004
						],
						[
							-82.64369999999991,
							27.828440000000057
						],
						[
							-82.64357080799994,
							27.828440000000057
						],
						[
							-82.64339999999993,
							27.828440000000057
						],
						[
							-82.64306278399994,
							27.828440000000057
						],
						[
							-82.64267738699994,
							27.828440000000057
						],
						[
							-82.64240999999993,
							27.828440000000057
						],
						[
							-82.6421499999999,
							27.828440000000057
						],
						[
							-82.64192411999994,
							27.828442823000046
						],
						[
							-82.64162635999992,
							27.82844654600007
						],
						[
							-82.64134999999993,
							27.82845000000009
						],
						[
							-82.64120586999991,
							27.82845000000009
						],
						[
							-82.64083798999991,
							27.82845000000009
						],
						[
							-82.64038999999991,
							27.82845000000009
						],
						[
							-82.64015478599993,
							27.82845000000009
						],
						[
							-82.63948909999993,
							27.82845000000009
						],
						[
							-82.63916999999992,
							27.82845000000009
						],
						[
							-82.63891100399991,
							27.82845000000009
						],
						[
							-82.63870999999995,
							27.82845000000009
						],
						[
							-82.6385699999999,
							27.828460000000064
						],
						[
							-82.63836794399992,
							27.828460000000064
						],
						[
							-82.63812999999993,
							27.828460000000064
						],
						[
							-82.63787743799992,
							27.828460000000064
						],
						[
							-82.6373869329999,
							27.828460000000064
						],
						[
							-82.63692999999995,
							27.828460000000064
						],
						[
							-82.63668620999994,
							27.828460000000064
						],
						[
							-82.6363708849999,
							27.828460000000064
						],
						[
							-82.63591999999994,
							27.828460000000064
						],
						[
							-82.63561760899995,
							27.828460000000064
						],
						[
							-82.6350920669999,
							27.828460000000064
						],
						[
							-82.6345706269999,
							27.828460000000064
						],
						[
							-82.63456999999994,
							27.828460000000064
						],
						[
							-82.63436196099991,
							27.828461095000083
						],
						[
							-82.63359363299992,
							27.82846513900006
						],
						[
							-82.63296360299995,
							27.828468455000063
						],
						[
							-82.63228743299993,
							27.828470000000042
						],
						[
							-82.63190325799991,
							27.828470000000042
						],
						[
							-82.63139614699992,
							27.828470000000042
						],
						[
							-82.6310580729999,
							27.828470000000042
						],
						[
							-82.63058178599994,
							27.828472575000035
						],
						[
							-82.62998254299993,
							27.82847905400007
						],
						[
							-82.62949052399995,
							27.828484373000038
						],
						[
							-82.62904493299993,
							27.828489190000084
						],
						[
							-82.62861470299993,
							27.828491931000087
						],
						[
							-82.62819972299991,
							27.828494186000057
						],
						[
							-82.6274622119999,
							27.82849819400008
						],
						[
							-82.62712979999993,
							27.828499496000063
						],
						[
							-82.62700118499993,
							27.828500000000076
						],
						[
							-82.62663237699992,
							27.828500000000076
						],
						[
							-82.6261872469999,
							27.82850525500004
						],
						[
							-82.62554147599991,
							27.828518170000056
						],
						[
							-82.62515714799993,
							27.828525857000045
						],
						[
							-82.62477307499995,
							27.82853268100007
						],
						[
							-82.62454238999993,
							27.828536176000057
						],
						[
							-82.6244502099999,
							27.828537573000066
						],
						[
							-82.62403537799992,
							27.82854310500005
						],
						[
							-82.6237741779999,
							27.828546291000066
						],
						[
							-82.62362053099991,
							27.82854816400004
						],
						[
							-82.62346999999994,
							27.828550000000064
						],
						[
							-82.62346999999994,
							27.828203019000057
						],
						[
							-82.62346999999994,
							27.827834211000038
						],
						[
							-82.62346999999994,
							27.827530000000085
						],
						[
							-82.62347162499992,
							27.827388624000037
						],
						[
							-82.62347392099991,
							27.82718887900006
						],
						[
							-82.62347656999992,
							27.826958405000084
						],
						[
							-82.62347868899991,
							27.826774025000077
						],
						[
							-82.62347999999992,
							27.82666000000006
						],
						[
							-82.62347999999992,
							27.826481915000045
						],
						[
							-82.62347999999992,
							27.82615920800004
						],
						[
							-82.62347999999992,
							27.825974804000055
						],
						[
							-82.62347999999992,
							27.825800000000072
						],
						[
							-82.62347410299992,
							27.825621121000044
						],
						[
							-82.62346902599995,
							27.82546711200007
						],
						[
							-82.62345890499995,
							27.825160106000055
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Edgemoor",
				"RegionID": "417182"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.65498687099995,
					27.81385000000006,
					-82.6467899999999,
					27.82842000000005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.65467354299994,
							27.813852671000067
						],
						[
							-82.65492999999992,
							27.81385000000006
						],
						[
							-82.65492423599994,
							27.81437453700005
						],
						[
							-82.65491999999995,
							27.81476000000004
						],
						[
							-82.6549307979999,
							27.81524589600008
						],
						[
							-82.6549399999999,
							27.815660000000037
						],
						[
							-82.65493501399993,
							27.816118676000087
						],
						[
							-82.65492999999992,
							27.816580000000044
						],
						[
							-82.65492999999992,
							27.817073754000035
						],
						[
							-82.65492999999992,
							27.817480000000046
						],
						[
							-82.65493299799994,
							27.81802860600004
						],
						[
							-82.65493662999995,
							27.818693202000077
						],
						[
							-82.6549399999999,
							27.819310000000087
						],
						[
							-82.6549399999999,
							27.820021978000057
						],
						[
							-82.6549399999999,
							27.820810940000058
						],
						[
							-82.65494771899995,
							27.82147509100008
						],
						[
							-82.6549559899999,
							27.82184954300004
						],
						[
							-82.6549599999999,
							27.82203000000004
						],
						[
							-82.65495694899994,
							27.822472232000052
						],
						[
							-82.6549543129999,
							27.822638287000075
						],
						[
							-82.65494999999993,
							27.822910000000036
						],
						[
							-82.65494674299993,
							27.823219453000036
						],
						[
							-82.65494368299994,
							27.82351009100006
						],
						[
							-82.6549399999999,
							27.82386000000008
						],
						[
							-82.65494446499991,
							27.824257370000055
						],
						[
							-82.65494726399993,
							27.82450648400004
						],
						[
							-82.65494999999993,
							27.82475000000005
						],
						[
							-82.65495172499993,
							27.82512939800006
						],
						[
							-82.65495531199991,
							27.82591853200006
						],
						[
							-82.6549588979999,
							27.82670747700007
						],
						[
							-82.6549702719999,
							27.827288972000076
						],
						[
							-82.65497999999991,
							27.82761000000005
						],
						[
							-82.65498687099995,
							27.828036028000042
						],
						[
							-82.65497999999991,
							27.828400000000048
						],
						[
							-82.6536495329999,
							27.828410156000075
						],
						[
							-82.6521131319999,
							27.82842000000005
						],
						[
							-82.65095999999994,
							27.82842000000005
						],
						[
							-82.65020301499993,
							27.82842000000005
						],
						[
							-82.64920643199991,
							27.82842000000005
						],
						[
							-82.64825137399993,
							27.82842000000005
						],
						[
							-82.64790999999991,
							27.82842000000005
						],
						[
							-82.64750393599991,
							27.82842000000005
						],
						[
							-82.64686999999992,
							27.82842000000005
						],
						[
							-82.64686999999992,
							27.827986532000068
						],
						[
							-82.64686999999992,
							27.827478508000073
						],
						[
							-82.64686999999992,
							27.827140000000043
						],
						[
							-82.64686309599995,
							27.826848299000062
						],
						[
							-82.64685727499995,
							27.826602354000045
						],
						[
							-82.64684940099994,
							27.826269698000093
						],
						[
							-82.64683531199995,
							27.825674417000073
						],
						[
							-82.64682999999991,
							27.825131088000035
						],
						[
							-82.64682999999991,
							27.824790000000068
						],
						[
							-82.64682999999991,
							27.824482920000037
						],
						[
							-82.64682999999991,
							27.824115041000084
						],
						[
							-82.64682999999991,
							27.823880000000088
						],
						[
							-82.64682999999991,
							27.82364205300007
						],
						[
							-82.64682999999991,
							27.82330921000005
						],
						[
							-82.64682999999991,
							27.822970000000055
						],
						[
							-82.64682999999991,
							27.822871258000077
						],
						[
							-82.64682999999991,
							27.82245082500009
						],
						[
							-82.64682999999991,
							27.822170536000044
						],
						[
							-82.64682999999991,
							27.82206000000008
						],
						[
							-82.64682659599993,
							27.821872776000077
						],
						[
							-82.64682117099994,
							27.82157443000006
						],
						[
							-82.64681999999993,
							27.82123000000007
						],
						[
							-82.64681999999993,
							27.821018561000074
						],
						[
							-82.64681999999993,
							27.820820000000083
						],
						[
							-82.64681999999993,
							27.820437221000077
						],
						[
							-82.64681999999993,
							27.820020000000056
						],
						[
							-82.64681999999993,
							27.819565211000054
						],
						[
							-82.64681999999993,
							27.819190000000052
						],
						[
							-82.64681999999993,
							27.81881777400008
						],
						[
							-82.64681999999993,
							27.818400000000054
						],
						[
							-82.64681999999993,
							27.817904240000075
						],
						[
							-82.64685999999995,
							27.817540000000065
						],
						[
							-82.64681522599994,
							27.817115546000082
						],
						[
							-82.6468099999999,
							27.816640000000064
						],
						[
							-82.64680427099997,
							27.816118627000037
						],
						[
							-82.64679999999993,
							27.815730000000087
						],
						[
							-82.64679550299991,
							27.81532976200009
						],
						[
							-82.6467899999999,
							27.81484000000006
						],
						[
							-82.6467899999999,
							27.81433315100009
						],
						[
							-82.6467899999999,
							27.813930000000084
						],
						[
							-82.64723969599993,
							27.81391259800006
						],
						[
							-82.64767324799993,
							27.813904569000044
						],
						[
							-82.64835864799994,
							27.81389187700006
						],
						[
							-82.6488599999999,
							27.81388000000004
						],
						[
							-82.64965744699992,
							27.81388000000004
						],
						[
							-82.6504513399999,
							27.81388000000004
						],
						[
							-82.65088999999995,
							27.81388000000004
						],
						[
							-82.65146175699994,
							27.813877251000065
						],
						[
							-82.65243605699993,
							27.81387256700009
						],
						[
							-82.65296999999993,
							27.813870000000065
						],
						[
							-82.65359070599993,
							27.813863793000053
						],
						[
							-82.6539699999999,
							27.81386000000009
						],
						[
							-82.65434842799993,
							27.813856058000056
						],
						[
							-82.65467354299994,
							27.813852671000067
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Euclid Heights",
				"RegionID": "417183"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.6652939999999,
					27.80654000000004,
					-82.65489587399992,
					27.817492000000072
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.65514775399993,
							27.810904941000047
						],
						[
							-82.6549599999999,
							27.810760000000073
						],
						[
							-82.65491999999995,
							27.810776500000088
						],
						[
							-82.65491999999995,
							27.81072000000006
						],
						[
							-82.65490900499992,
							27.81071109300007
						],
						[
							-82.65489587399992,
							27.810436346000074
						],
						[
							-82.65491999999995,
							27.810130000000072
						],
						[
							-82.65491457399992,
							27.809864125000047
						],
						[
							-82.65490999999992,
							27.80938116100009
						],
						[
							-82.65490999999992,
							27.80909552900005
						],
						[
							-82.65490999999992,
							27.80881000000005
						],
						[
							-82.65490999999992,
							27.808634124000037
						],
						[
							-82.65490999999992,
							27.808326521000087
						],
						[
							-82.65490999999992,
							27.808128776000046
						],
						[
							-82.65490999999992,
							27.808040000000062
						],
						[
							-82.65490999999992,
							27.80779920100008
						],
						[
							-82.65490999999992,
							27.80744765500009
						],
						[
							-82.65490999999992,
							27.807310000000086
						],
						[
							-82.65490999999992,
							27.80698625000008
						],
						[
							-82.65490999999992,
							27.806854420000036
						],
						[
							-82.65490999999992,
							27.806560000000047
						],
						[
							-82.65531618999995,
							27.806560000000047
						],
						[
							-82.6555597709999,
							27.806560000000047
						],
						[
							-82.65579999999994,
							27.806560000000047
						],
						[
							-82.65598603699993,
							27.806560000000047
						],
						[
							-82.65622999999994,
							27.806560000000047
						],
						[
							-82.65647319899995,
							27.806560000000047
						],
						[
							-82.65664999999991,
							27.806560000000047
						],
						[
							-82.65683820299995,
							27.806555174000042
						],
						[
							-82.65703999999994,
							27.806550000000072
						],
						[
							-82.65730543299992,
							27.806550000000072
						],
						[
							-82.65748999999995,
							27.806550000000072
						],
						[
							-82.65781289299993,
							27.806550000000072
						],
						[
							-82.65807999999993,
							27.806550000000072
						],
						[
							-82.65819856199994,
							27.806550000000072
						],
						[
							-82.65830999999991,
							27.806550000000072
						],
						[
							-82.65874661899994,
							27.806550000000072
						],
						[
							-82.65911999999992,
							27.806550000000072
						],
						[
							-82.65951795799992,
							27.806550000000072
						],
						[
							-82.65982243399992,
							27.806550000000072
						],
						[
							-82.66012999999992,
							27.806550000000072
						],
						[
							-82.66039078999995,
							27.806550000000072
						],
						[
							-82.66093884599991,
							27.806550000000072
						],
						[
							-82.66116999999991,
							27.806550000000072
						],
						[
							-82.66150720099995,
							27.80654000000004
						],
						[
							-82.66233943599991,
							27.80654000000004
						],
						[
							-82.66295999999994,
							27.80654000000004
						],
						[
							-82.66302044399993,
							27.80690104200005
						],
						[
							-82.66316357499994,
							27.80751504400007
						],
						[
							-82.6632989659999,
							27.808048486000075
						],
						[
							-82.66343660799993,
							27.808460855000078
						],
						[
							-82.6637029659999,
							27.809266231000038
						],
						[
							-82.66391551599992,
							27.80991004000009
						],
						[
							-82.66411035899995,
							27.810500217000087
						],
						[
							-82.66427190299993,
							27.81095639700004
						],
						[
							-82.6644033629999,
							27.81132156400008
						],
						[
							-82.66459000299994,
							27.811950013000057
						],
						[
							-82.66472238499995,
							27.812426586000072
						],
						[
							-82.66484021499991,
							27.81318342500009
						],
						[
							-82.66522850199993,
							27.81322339700006
						],
						[
							-82.6652269999999,
							27.813398000000063
						],
						[
							-82.66523515299993,
							27.813597290000075
						],
						[
							-82.66524496499994,
							27.813837143000057
						],
						[
							-82.66524499999991,
							27.81383800000009
						],
						[
							-82.66524408999993,
							27.81396361900005
						],
						[
							-82.66523799999993,
							27.814804000000038
						],
						[
							-82.6652519999999,
							27.815650000000065
						],
						[
							-82.66526499999992,
							27.81654800000007
						],
						[
							-82.6652939999999,
							27.817492000000072
						],
						[
							-82.66402626399992,
							27.81680831300008
						],
						[
							-82.66361783499991,
							27.816547532000072
						],
						[
							-82.6633403539999,
							27.816391449000037
						],
						[
							-82.66315999999995,
							27.816290000000038
						],
						[
							-82.66297282799991,
							27.816182829000073
						],
						[
							-82.66280255599992,
							27.816085334000036
						],
						[
							-82.66241944399991,
							27.81586597200004
						],
						[
							-82.66211906599995,
							27.81569398100004
						],
						[
							-82.66191999999995,
							27.81558000000007
						],
						[
							-82.66166427499991,
							27.815440513000055
						],
						[
							-82.66143182299993,
							27.81531372200004
						],
						[
							-82.66125999999991,
							27.815220000000068
						],
						[
							-82.6610955829999,
							27.81512839600009
						],
						[
							-82.66100983099996,
							27.81508062000006
						],
						[
							-82.66074323599992,
							27.814932088000035
						],
						[
							-82.66055999999992,
							27.814830000000086
						],
						[
							-82.66039267699995,
							27.814732952000043
						],
						[
							-82.66029139999995,
							27.814674212000057
						],
						[
							-82.66005999999993,
							27.81454000000008
						],
						[
							-82.6599759099999,
							27.81449026900009
						],
						[
							-82.65975833999994,
							27.81436159900005
						],
						[
							-82.65942752299992,
							27.814165955000078
						],
						[
							-82.65912999999996,
							27.813990000000047
						],
						[
							-82.65901958199993,
							27.813923749000082
						],
						[
							-82.65882999999991,
							27.813810000000046
						],
						[
							-82.65867492099994,
							27.813692830000036
						],
						[
							-82.6583649399999,
							27.813457912000047
						],
						[
							-82.65794488499995,
							27.813120763000086
						],
						[
							-82.65761999999995,
							27.81286000000006
						],
						[
							-82.65748082599993,
							27.81275072300008
						],
						[
							-82.65718673599991,
							27.812519808000047
						],
						[
							-82.65691398999991,
							27.812305652000077
						],
						[
							-82.6565577799999,
							27.812025960000085
						],
						[
							-82.65626999999996,
							27.811800000000062
						],
						[
							-82.65617204599994,
							27.811722243000077
						],
						[
							-82.65600280199993,
							27.81158789400007
						],
						[
							-82.65574754599993,
							27.811385269000084
						],
						[
							-82.65539002199995,
							27.811101461000078
						],
						[
							-82.65514775399993,
							27.810904941000047
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Harris Park",
				"RegionID": "417184"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.63071082699993,
					27.84758000000005,
					-82.62393736199994,
					27.853211935000047
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.62871041099993,
							27.85295767200006
						],
						[
							-82.62861976999994,
							27.852942962000043
						],
						[
							-82.6284349309999,
							27.852953295000077
						],
						[
							-82.62836998299991,
							27.85296916200008
						],
						[
							-82.62764735999993,
							27.852711612000068
						],
						[
							-82.62696690299992,
							27.85249510300008
						],
						[
							-82.62622458599994,
							27.852340453000068
						],
						[
							-82.62566784799992,
							27.85196929500006
						],
						[
							-82.6250492499999,
							27.85169092600006
						],
						[
							-82.62452344299993,
							27.85196929500006
						],
						[
							-82.62393736199994,
							27.85168417400007
						],
						[
							-82.62402457799993,
							27.851568943000075
						],
						[
							-82.62410404799994,
							27.851463945000035
						],
						[
							-82.6242214639999,
							27.851326243000074
						],
						[
							-82.62434789999992,
							27.851206750000074
						],
						[
							-82.62451942299992,
							27.851062933000037
						],
						[
							-82.62467145599993,
							27.850948908000078
						],
						[
							-82.6247925959999,
							27.850862738000046
						],
						[
							-82.62505228999993,
							27.850695140000084
						],
						[
							-82.62525552299991,
							27.850559651000083
						],
						[
							-82.62545340799996,
							27.850427728000057
						],
						[
							-82.62562999999994,
							27.850310000000036
						],
						[
							-82.62576483899994,
							27.850232276000042
						],
						[
							-82.62590902199992,
							27.850148387000047
						],
						[
							-82.62617361899993,
							27.849994440000046
						],
						[
							-82.62644481099994,
							27.849828837000075
						],
						[
							-82.62685994499994,
							27.84957064400004
						],
						[
							-82.62719440299992,
							27.849359806000052
						],
						[
							-82.6274320039999,
							27.84920664200007
						],
						[
							-82.62754552799993,
							27.849133461000065
						],
						[
							-82.62769125499995,
							27.849039522000055
						],
						[
							-82.62791593399993,
							27.84889468700004
						],
						[
							-82.62818864699994,
							27.848718889000054
						],
						[
							-82.62844327199991,
							27.848563057000035
						],
						[
							-82.62859999999995,
							27.848470000000077
						],
						[
							-82.62866940299995,
							27.848426302000064
						],
						[
							-82.62882122799994,
							27.84833070800005
						],
						[
							-82.62899272399994,
							27.848222729000042
						],
						[
							-82.62913999999995,
							27.848130000000083
						],
						[
							-82.62925423199994,
							27.848052115000087
						],
						[
							-82.62939665899995,
							27.847958004000077
						],
						[
							-82.62952787499995,
							27.847879275000082
						],
						[
							-82.62969370299993,
							27.847799162000058
						],
						[
							-82.62980028899995,
							27.847759900000085
						],
						[
							-82.62994914099994,
							27.847708374000035
						],
						[
							-82.6300599999999,
							27.84767000000005
						],
						[
							-82.63015393199993,
							27.84764987200009
						],
						[
							-82.63023836499991,
							27.847633230000042
						],
						[
							-82.63040044399992,
							27.84760673800008
						],
						[
							-82.63053791999994,
							27.84759200900004
						],
						[
							-82.63064999999995,
							27.84758000000005
						],
						[
							-82.63062971199992,
							27.84905516200007
						],
						[
							-82.6306760629999,
							27.849831548000058
						],
						[
							-82.6306760629999,
							27.850202360000083
						],
						[
							-82.6306760629999,
							27.850700637000045
						],
						[
							-82.63071082699993,
							27.851604490000057
						],
						[
							-82.63071082699993,
							27.85245259000004
						],
						[
							-82.6306679999999,
							27.852452000000085
						],
						[
							-82.63049290799995,
							27.85277347200008
						],
						[
							-82.62960323099992,
							27.853211935000047
						],
						[
							-82.62951366599992,
							27.853187895000076
						],
						[
							-82.62946621799995,
							27.85317473300006
						],
						[
							-82.62938203599992,
							27.85314992900004
						],
						[
							-82.6291654559999,
							27.853084764000073
						],
						[
							-82.62871041099993,
							27.85295767200006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Riviera Bay Subdivision",
				"RegionID": "417199"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.6387499999999,
					27.842580000000186,
					-82.62703999999992,
					27.86208203600015
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.63067374248159,
							27.860038919817956
						],
						[
							-82.63072399999992,
							27.85989600000011
						],
						[
							-82.63065899999987,
							27.85964600000003
						],
						[
							-82.63066354599988,
							27.85964601300012
						],
						[
							-82.6306699999999,
							27.858950000000174
						],
						[
							-82.63063199999995,
							27.85874000000003
						],
						[
							-82.63059099999992,
							27.85861000000011
						],
						[
							-82.63065799999987,
							27.858226000000133
						],
						[
							-82.63065199999981,
							27.858076000000157
						],
						[
							-82.63060599999991,
							27.85708800000012
						],
						[
							-82.63061799999984,
							27.85572800000004
						],
						[
							-82.6306249999999,
							27.855197000000157
						],
						[
							-82.63061799999984,
							27.855069000000046
						],
						[
							-82.6305499999999,
							27.854987000000012
						],
						[
							-82.63047499999992,
							27.85493500000015
						],
						[
							-82.63047499999992,
							27.8546510000001
						],
						[
							-82.63045999999991,
							27.854553000000163
						],
						[
							-82.63042999999992,
							27.854486000000126
						],
						[
							-82.63036299999989,
							27.854471000000128
						],
						[
							-82.63021899999987,
							27.854532000000024
						],
						[
							-82.62996808399981,
							27.854724022000102
						],
						[
							-82.62987431099987,
							27.854536474000042
						],
						[
							-82.6296138829998,
							27.85386263300033
						],
						[
							-82.62960668499974,
							27.853814789000456
						],
						[
							-82.62959762499962,
							27.853722267000084
						],
						[
							-82.62958462599988,
							27.853439267000116
						],
						[
							-82.62958423399994,
							27.85336304600047
						],
						[
							-82.62959045199965,
							27.85328707800005
						],
						[
							-82.6296032309999,
							27.853211935000314
						],
						[
							-82.63049290799991,
							27.852773472000184
						],
						[
							-82.6306679999999,
							27.852452000000053
						],
						[
							-82.63071082699989,
							27.8524525900001
						],
						[
							-82.63071082699989,
							27.8516044900001
						],
						[
							-82.63067606299985,
							27.85070063700001
						],
						[
							-82.63067606299985,
							27.850202360000083
						],
						[
							-82.63067606299985,
							27.84983154800013
						],
						[
							-82.63062971199993,
							27.849055162000198
						],
						[
							-82.63064999999992,
							27.847580000000175
						],
						[
							-82.63053791999988,
							27.847592009000014
						],
						[
							-82.63040044399987,
							27.847606738000078
						],
						[
							-82.63023836499978,
							27.847633230000138
						],
						[
							-82.63015393199991,
							27.847649872000094
						],
						[
							-82.63005999999986,
							27.84767000000016
						],
						[
							-82.62994914099993,
							27.84770837400014
						],
						[
							-82.62980028899997,
							27.84775990000014
						],
						[
							-82.62969370299993,
							27.84779916200019
						],
						[
							-82.6295278749999,
							27.847879275000157
						],
						[
							-82.62939665899995,
							27.847958004000187
						],
						[
							-82.62925423199991,
							27.84805211500007
						],
						[
							-82.62913999999995,
							27.848130000000207
						],
						[
							-82.62899272399993,
							27.848222729000152
						],
						[
							-82.62882122799995,
							27.848330708000116
						],
						[
							-82.62866940299982,
							27.848426302000032
						],
						[
							-82.62859999999995,
							27.848470000000095
						],
						[
							-82.6284943199999,
							27.848315765000034
						],
						[
							-82.62833583099984,
							27.848092972000163
						],
						[
							-82.62823067499994,
							27.847957201000035
						],
						[
							-82.62810742499997,
							27.8477980680001
						],
						[
							-82.62791014699988,
							27.847543355000074
						],
						[
							-82.62772843399995,
							27.847308738000113
						],
						[
							-82.62764571699995,
							27.84720193900007
						],
						[
							-82.62758999999996,
							27.847130000000067
						],
						[
							-82.62747063999984,
							27.84697748400006
						],
						[
							-82.62733473899988,
							27.84681050100001
						],
						[
							-82.62722395199995,
							27.846678754000035
						],
						[
							-82.62711225599986,
							27.846545926000058
						],
						[
							-82.62703999999992,
							27.846460000000057
						],
						[
							-82.6271288079999,
							27.846410662000057
						],
						[
							-82.62727539899994,
							27.846343359000084
						],
						[
							-82.62734522499996,
							27.8463113550001
						],
						[
							-82.62742608299989,
							27.846259496000165
						],
						[
							-82.6274861609998,
							27.846216106000124
						],
						[
							-82.62751239299983,
							27.846197161000067
						],
						[
							-82.62754999999993,
							27.84617000000022
						],
						[
							-82.62760995699983,
							27.84609227800018
						],
						[
							-82.62766952099987,
							27.8460150650001
						],
						[
							-82.62773596999995,
							27.845928927000077
						],
						[
							-82.62777007599993,
							27.84588471700015
						],
						[
							-82.62782164999993,
							27.845818350000076
						],
						[
							-82.62787531599993,
							27.845769189000183
						],
						[
							-82.62810834999995,
							27.845609399000107
						],
						[
							-82.62830017199991,
							27.84548551400007
						],
						[
							-82.62843765099983,
							27.845396726000008
						],
						[
							-82.62853321999992,
							27.84533710000005
						],
						[
							-82.62859999999995,
							27.845300000000176
						],
						[
							-82.62848595899992,
							27.84487194700002
						],
						[
							-82.62801540499989,
							27.84434492700011
						],
						[
							-82.6288485689999,
							27.843828746000128
						],
						[
							-82.6287294439999,
							27.843088426000158
						],
						[
							-82.62882150199988,
							27.84307308300004
						],
						[
							-82.62894440099984,
							27.843059552000074
						],
						[
							-82.62912349699991,
							27.843057742000102
						],
						[
							-82.62933496199992,
							27.843055606000107
						],
						[
							-82.62959522699987,
							27.843052978000063
						],
						[
							-82.62979042599994,
							27.84305100600008
						],
						[
							-82.63001812999995,
							27.843050000000172
						],
						[
							-82.63035162899992,
							27.843050000000172
						],
						[
							-82.63097795499988,
							27.843050000000172
						],
						[
							-82.6314742409999,
							27.843045401000058
						],
						[
							-82.6316287579999,
							27.843043209000054
						],
						[
							-82.63207604399987,
							27.843036865000062
						],
						[
							-82.63229573599993,
							27.84303374800007
						],
						[
							-82.63269424299996,
							27.8430308890001
						],
						[
							-82.63319853499985,
							27.8430342290002
						],
						[
							-82.6333205949999,
							27.84303503700009
						],
						[
							-82.63353207299991,
							27.843036438000116
						],
						[
							-82.63408505299992,
							27.84303969300012
						],
						[
							-82.63444313599989,
							27.843032385000047
						],
						[
							-82.63455999999987,
							27.843030000000116
						],
						[
							-82.63456411699985,
							27.843011474000004
						],
						[
							-82.63478166399983,
							27.84302408900007
						],
						[
							-82.63511213299991,
							27.84301527600014
						],
						[
							-82.63567415399986,
							27.843013642000187
						],
						[
							-82.63590578899993,
							27.8430159580002
						],
						[
							-82.63632127599993,
							27.843019020000096
						],
						[
							-82.63658365399989,
							27.842993764000138
						],
						[
							-82.63681746099986,
							27.842960363000127
						],
						[
							-82.63702999999987,
							27.84293000000019
						],
						[
							-82.6370926269999,
							27.84291366300017
						],
						[
							-82.63729279899985,
							27.842854772000184
						],
						[
							-82.63747303799994,
							27.84277109000001
						],
						[
							-82.63763498999992,
							27.842708337000058
						],
						[
							-82.63788934399992,
							27.84264371200013
						],
						[
							-82.63812120399992,
							27.842595759000158
						],
						[
							-82.63830328099988,
							27.842580000000186
						],
						[
							-82.63850170299987,
							27.842580000000186
						],
						[
							-82.63862999999992,
							27.842580000000186
						],
						[
							-82.6387499999999,
							27.842580000000186
						],
						[
							-82.63862999999992,
							27.843010088000067
						],
						[
							-82.63863999999985,
							27.843522678000024
						],
						[
							-82.63863999999985,
							27.843930000000153
						],
						[
							-82.63863999999985,
							27.844250225000096
						],
						[
							-82.63863999999985,
							27.844597464000135
						],
						[
							-82.63863999999985,
							27.844742260000213
						],
						[
							-82.63863999999985,
							27.845027378000182
						],
						[
							-82.63863999999985,
							27.84523000000007
						],
						[
							-82.63863999999985,
							27.84562264400005
						],
						[
							-82.63863999999985,
							27.846000000000185
						],
						[
							-82.63864069499992,
							27.846102118000108
						],
						[
							-82.6386427189999,
							27.84639973700013
						],
						[
							-82.63864519399993,
							27.84676349400012
						],
						[
							-82.63864755599985,
							27.84711071600007
						],
						[
							-82.63865999999992,
							27.847530000000123
						],
						[
							-82.63864999999988,
							27.847838355000146
						],
						[
							-82.63864999999988,
							27.848251735000066
						],
						[
							-82.63864999999988,
							27.848665114000074
						],
						[
							-82.63865539899989,
							27.849161064000075
						],
						[
							-82.63866109399991,
							27.849425859000046
						],
						[
							-82.63866499599987,
							27.849607307000138
						],
						[
							-82.63866999999993,
							27.849840000000118
						],
						[
							-82.63866999999993,
							27.850020997000083
						],
						[
							-82.63866999999993,
							27.850269024000088
						],
						[
							-82.63866999999993,
							27.850550122000076
						],
						[
							-82.63866999999993,
							27.850730000000038
						],
						[
							-82.6386675059999,
							27.850946971000138
						],
						[
							-82.6386629449999,
							27.851343763000106
						],
						[
							-82.63865999999992,
							27.85160000000008
						],
						[
							-82.63866269599987,
							27.85183991400004
						],
						[
							-82.63866733999981,
							27.85225324100022
						],
						[
							-82.63866999999993,
							27.852490000000177
						],
						[
							-82.63867317699993,
							27.852782303000115
						],
						[
							-82.63867551499995,
							27.85299741400006
						],
						[
							-82.63867839099993,
							27.8532619460001
						],
						[
							-82.6386799999998,
							27.853410000000093
						],
						[
							-82.63868209599987,
							27.85360914300014
						],
						[
							-82.63868522899986,
							27.85390674300007
						],
						[
							-82.63868999999983,
							27.854360000000003
						],
						[
							-82.63868999999983,
							27.85463430800014
						],
						[
							-82.63868999999983,
							27.85499808100013
						],
						[
							-82.63868999999983,
							27.85518000000017
						],
						[
							-82.63869291399988,
							27.855328602000032
						],
						[
							-82.63869648499991,
							27.855510743000092
						],
						[
							-82.63869999999993,
							27.85569000000009
						],
						[
							-82.63869999999993,
							27.85608165100008
						],
						[
							-82.63869999999993,
							27.856600000000068
						],
						[
							-82.63869999999993,
							27.857021055000178
						],
						[
							-82.63869999999993,
							27.8575300000001
						],
						[
							-82.63869999999993,
							27.857536708000122
						],
						[
							-82.63869999999993,
							27.857755836000134
						],
						[
							-82.63869999999993,
							27.858230189000036
						],
						[
							-82.63869999999993,
							27.858676638000116
						],
						[
							-82.63869999999993,
							27.859123088000107
						],
						[
							-82.63869999999993,
							27.859350000000056
						],
						[
							-82.63870157899989,
							27.859439224000152
						],
						[
							-82.63870306299992,
							27.859523071000073
						],
						[
							-82.63870635499984,
							27.859709034000097
						],
						[
							-82.63870964899985,
							27.85989516100013
						],
						[
							-82.63871310799995,
							27.860090586000045
						],
						[
							-82.63871738899986,
							27.860332501000077
						],
						[
							-82.6387199999999,
							27.860676359000106
						],
						[
							-82.6387199999999,
							27.86097399200013
						],
						[
							-82.63871755899989,
							27.861308770000118
						],
						[
							-82.63871501399984,
							27.86157847600005
						],
						[
							-82.63871290799993,
							27.861801768000053
						],
						[
							-82.63871132899989,
							27.861969172000048
						],
						[
							-82.63728223399995,
							27.86202500900014
						],
						[
							-82.63122199999991,
							27.862079852000146
						],
						[
							-82.63098070099993,
							27.86208203600015
						],
						[
							-82.63097599999989,
							27.861105000000133
						],
						[
							-82.63097399999991,
							27.860548000000055
						],
						[
							-82.63097999999987,
							27.86034400000005
						],
						[
							-82.63097299999991,
							27.86026600000017
						],
						[
							-82.63095099999987,
							27.86024000000015
						],
						[
							-82.63088299999993,
							27.860225000000153
						],
						[
							-82.63069399999983,
							27.86020600000018
						],
						[
							-82.63067599999994,
							27.86018000000016
						],
						[
							-82.63067374248159,
							27.860038919817956
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Riviera Bay",
				"RegionID": "417200"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.7274863959999,
					28.238824385000044,
					-82.71937766899993,
					28.249709348000067
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.7237844309999,
							28.249024063000036
						],
						[
							-82.72417466199994,
							28.24887177800008
						],
						[
							-82.7242983939999,
							28.248776599000053
						],
						[
							-82.72430791199993,
							28.248605278000074
						],
						[
							-82.72435550199992,
							28.248567207000065
						],
						[
							-82.72453634099992,
							28.248272154000063
						],
						[
							-82.72448875099991,
							28.248110350000047
						],
						[
							-82.72465055499993,
							28.247386994000067
						],
						[
							-82.72475525099992,
							28.247339405000048
						],
						[
							-82.7248504289999,
							28.247158566000053
						],
						[
							-82.72497416099992,
							28.246911102000073
						],
						[
							-82.72505982199993,
							28.24681592400009
						],
						[
							-82.7252216249999,
							28.24652087000004
						],
						[
							-82.7252977679999,
							28.246273407000047
						],
						[
							-82.72528824999995,
							28.246178228000076
						],
						[
							-82.72523114299992,
							28.246092567000062
						],
						[
							-82.72526921499991,
							28.245569086000046
						],
						[
							-82.72539294699993,
							28.24534065800009
						],
						[
							-82.72546908899996,
							28.24529306900007
						],
						[
							-82.72561185699993,
							28.244817176000083
						],
						[
							-82.72557378599993,
							28.244331766000073
						],
						[
							-82.72561185699993,
							28.243855874000076
						],
						[
							-82.72546908899996,
							28.243513232000055
						],
						[
							-82.72503126799995,
							28.24304685700008
						],
						[
							-82.7248885009999,
							28.242818429000067
						],
						[
							-82.72351793099995,
							28.241476413000044
						],
						[
							-82.72274698599995,
							28.241209913000034
						],
						[
							-82.72173809399993,
							28.241209913000034
						],
						[
							-82.72133834499994,
							28.240905342000076
						],
						[
							-82.71948236499992,
							28.240134397000077
						],
						[
							-82.71937766899993,
							28.240134397000077
						],
						[
							-82.71940622299991,
							28.23951573700009
						],
						[
							-82.71946332999994,
							28.239496702000054
						],
						[
							-82.7195109189999,
							28.239277791000063
						],
						[
							-82.7196537019999,
							28.238843592000084
						],
						[
							-82.7196631679999,
							28.238843597000084
						],
						[
							-82.7233342369999,
							28.238845800000036
						],
						[
							-82.72660361599992,
							28.238824385000044
						],
						[
							-82.7274031149999,
							28.23885769700007
						],
						[
							-82.72743880699994,
							28.23892908100004
						],
						[
							-82.7274863959999,
							28.248732460000042
						],
						[
							-82.7274269099999,
							28.249672348000047
						],
						[
							-82.72666833799991,
							28.249709348000067
						],
						[
							-82.7266588199999,
							28.24957609800009
						],
						[
							-82.72523114299992,
							28.24958561600005
						],
						[
							-82.7237844309999,
							28.249024063000036
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pasco",
				"City": "New Port Richey",
				"Name": "South River",
				"RegionID": "415300"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.17620781999995,
					26.09744215500007,
					-80.17368791299992,
					26.09994279100005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.17444999999992,
							26.097863962000076
						],
						[
							-80.17444999999992,
							26.09775071000007
						],
						[
							-80.17444999999992,
							26.097624133000068
						],
						[
							-80.17444999999992,
							26.097500000000082
						],
						[
							-80.1745329179999,
							26.097496395000068
						],
						[
							-80.1746127099999,
							26.097492926000086
						],
						[
							-80.17471213999994,
							26.097486786000047
						],
						[
							-80.17479986599994,
							26.097478013000057
						],
						[
							-80.17494563699995,
							26.097463436000055
						],
						[
							-80.17504589599992,
							26.09745341000007
						],
						[
							-80.17515274099992,
							26.097445151000045
						],
						[
							-80.17523754099994,
							26.09744215500007
						],
						[
							-80.17529473299993,
							26.09745849500007
						],
						[
							-80.1753387739999,
							26.097507548000067
						],
						[
							-80.17534316299992,
							26.09753214200009
						],
						[
							-80.17534999999992,
							26.097590823000075
						],
						[
							-80.17534999999992,
							26.097650781000084
						],
						[
							-80.17535774299995,
							26.097716459000083
						],
						[
							-80.17537340199993,
							26.097763505000046
						],
						[
							-80.17540465999991,
							26.09781288000005
						],
						[
							-80.17543988599994,
							26.09783494300007
						],
						[
							-80.17548533399992,
							26.09785000000005
						],
						[
							-80.17553862999995,
							26.09785000000005
						],
						[
							-80.17561857299995,
							26.09785000000005
						],
						[
							-80.17581176899996,
							26.09785000000005
						],
						[
							-80.17600496499995,
							26.09785000000005
						],
						[
							-80.17612636099994,
							26.09784961300005
						],
						[
							-80.17612664199994,
							26.097853693000047
						],
						[
							-80.17613265199994,
							26.098177172000078
						],
						[
							-80.17614667299995,
							26.098508665000054
						],
						[
							-80.17614667299995,
							26.09869193600008
						],
						[
							-80.17616269599995,
							26.09901842100004
						],
						[
							-80.17616970699993,
							26.099562226000046
						],
						[
							-80.17620781999995,
							26.09992072500006
						],
						[
							-80.17515319899991,
							26.09994279100005
						],
						[
							-80.17439707799991,
							26.099940787000037
						],
						[
							-80.17368791299992,
							26.09993290600005
						],
						[
							-80.17374999999993,
							26.099270000000047
						],
						[
							-80.17376200699994,
							26.099149926000052
						],
						[
							-80.17376952199993,
							26.09903613000006
						],
						[
							-80.17376355599994,
							26.098863125000037
						],
						[
							-80.17375621399992,
							26.09865019700004
						],
						[
							-80.17374884799995,
							26.098436580000055
						],
						[
							-80.17374356199991,
							26.098283308000077
						],
						[
							-80.17373999999995,
							26.09818000000007
						],
						[
							-80.17388647099995,
							26.09818000000007
						],
						[
							-80.17409965299993,
							26.09818000000007
						],
						[
							-80.17421290599992,
							26.09818000000007
						],
						[
							-80.17430585299991,
							26.098168330000078
						],
						[
							-80.1743634039999,
							26.098158298000044
						],
						[
							-80.17441174099991,
							26.098130955000045
						],
						[
							-80.17444215299992,
							26.09809164300009
						],
						[
							-80.17445772999992,
							26.098040920000074
						],
						[
							-80.17445487299995,
							26.09798563700008
						],
						[
							-80.17445466999993,
							26.097922692000054
						],
						[
							-80.17444999999992,
							26.097863962000076
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Fort Lauderdale",
				"Name": "Oak River Homeowners",
				"RegionID": "416134"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.71452399999993,
					27.64019205700004,
					-82.63603977299994,
					27.719460000000083
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-82.71324035899994,
								27.64821770100008
							],
							[
								-82.71318184699993,
								27.648196322000047
							],
							[
								-82.71309821999995,
								27.648196322000047
							],
							[
								-82.7127582679999,
								27.648227551000048
							],
							[
								-82.7126930959999,
								27.64823115900009
							],
							[
								-82.71262783399993,
								27.648230031000082
							],
							[
								-82.7125628249999,
								27.648224172000084
							],
							[
								-82.71249841199995,
								27.648213613000053
							],
							[
								-82.7123594119999,
								27.648185614000056
							],
							[
								-82.71226618399993,
								27.648161577000053
							],
							[
								-82.71211418399992,
								27.64811357700006
							],
							[
								-82.71204131199994,
								27.648087058000044
							],
							[
								-82.71197099499994,
								27.64805436100005
							],
							[
								-82.7119037569999,
								27.648015727000086
							],
							[
								-82.71184009699994,
								27.647971444000063
							],
							[
								-82.71178048899992,
								27.647921842000073
							],
							[
								-82.71170448899994,
								27.647852842000077
							],
							[
								-82.71162007999993,
								27.647765073000073
							],
							[
								-82.71153016499994,
								27.64763666100004
							],
							[
								-82.71146391399992,
								27.64749458600005
							],
							[
								-82.71142334099994,
								27.64734316600004
							],
							[
								-82.71141526699995,
								27.647287103000053
							],
							[
								-82.71140126599994,
								27.64716210200004
							],
							[
								-82.71139611099994,
								27.647089900000083
							],
							[
								-82.71139677799994,
								27.64701751800004
							],
							[
								-82.71140326499994,
								27.64694542300009
							],
							[
								-82.7114155299999,
								27.646874084000046
							],
							[
								-82.71143349099992,
								27.646803962000035
							],
							[
								-82.71149549099994,
								27.646596963000036
							],
							[
								-82.71152090099991,
								27.646523761000083
							],
							[
								-82.7115525179999,
								27.646453018000045
							],
							[
								-82.71159010699995,
								27.64638526000005
							],
							[
								-82.71163338999992,
								27.64632098800007
							],
							[
								-82.71168204399993,
								27.646260682000047
							],
							[
								-82.71188086099994,
								27.646034890000067
							],
							[
								-82.7121286769999,
								27.645753099000046
							],
							[
								-82.71217627199992,
								27.645702999000036
							],
							[
								-82.71222757299995,
								27.645656701000064
							],
							[
								-82.71228227799992,
								27.645614479000074
							],
							[
								-82.71234006399993,
								27.645576583000036
							],
							[
								-82.71240058799992,
								27.645543235000048
							],
							[
								-82.7128992559999,
								27.64529295200009
							],
							[
								-82.71314585399995,
								27.645147420000058
							],
							[
								-82.71339946199993,
								27.644967929000074
							],
							[
								-82.71341305099992,
								27.644959890000052
							],
							[
								-82.71446932399994,
								27.644988518000048
							],
							[
								-82.71452399999993,
								27.644990000000064
							],
							[
								-82.71447599999993,
								27.64549800000009
							],
							[
								-82.71438399999994,
								27.647395000000074
							],
							[
								-82.71438416799992,
								27.647572403000083
							],
							[
								-82.71438499999994,
								27.648454000000076
							],
							[
								-82.7143859169999,
								27.648525903000063
							],
							[
								-82.7143802249999,
								27.648521018000054
							],
							[
								-82.71418565099994,
								27.64844992400009
							],
							[
								-82.71389290999991,
								27.648392508000086
							],
							[
								-82.7138356399999,
								27.64837931800008
							],
							[
								-82.71331863899991,
								27.648242318000086
							],
							[
								-82.71324035899994,
								27.64821770100008
							]
						]
					],
					[
						[
							[
								-82.6709733269999,
								27.64480988100007
							],
							[
								-82.67090295799994,
								27.64470910600005
							],
							[
								-82.67182099999991,
								27.644709000000034
							],
							[
								-82.67183599999993,
								27.644709000000034
							],
							[
								-82.67193232499994,
								27.644692534000058
							],
							[
								-82.67194465899992,
								27.64469042500008
							],
							[
								-82.67173999999994,
								27.644337000000064
							],
							[
								-82.67157899999995,
								27.644104000000084
							],
							[
								-82.67066399999995,
								27.642254000000037
							],
							[
								-82.6697519999999,
								27.640672000000052
							],
							[
								-82.66974499999992,
								27.640475000000038
							],
							[
								-82.66980399999994,
								27.64040300000005
							],
							[
								-82.6698649299999,
								27.640382722000084
							],
							[
								-82.66991599999994,
								27.64036600000009
							],
							[
								-82.66996656399994,
								27.64034889700008
							],
							[
								-82.67043782899992,
								27.64019205700004
							],
							[
								-82.6705389999999,
								27.640199000000052
							],
							[
								-82.67069199999992,
								27.640265000000056
							],
							[
								-82.67086299999994,
								27.640418000000068
							],
							[
								-82.67128799999995,
								27.640949000000035
							],
							[
								-82.67184099999992,
								27.641730000000052
							],
							[
								-82.6721609999999,
								27.642342000000042
							],
							[
								-82.67260899999991,
								27.643166000000065
							],
							[
								-82.67280999999991,
								27.643537000000038
							],
							[
								-82.67283096099993,
								27.643564420000075
							],
							[
								-82.6731807939999,
								27.644062503000043
							],
							[
								-82.6731969999999,
								27.64408700000007
							],
							[
								-82.67341199999993,
								27.644693000000075
							],
							[
								-82.67345003699995,
								27.64473696600004
							],
							[
								-82.67463800999991,
								27.644735574000038
							],
							[
								-82.67466311699991,
								27.644764595000083
							],
							[
								-82.67474324099993,
								27.64487257000008
							],
							[
								-82.6749973769999,
								27.645274718000053
							],
							[
								-82.67536798999993,
								27.645770346000063
							],
							[
								-82.6756773649999,
								27.64610955200004
							],
							[
								-82.67651424699994,
								27.646892128000047
							],
							[
								-82.67653152499992,
								27.646908721000045
							],
							[
								-82.67692831699992,
								27.647300088000065
							],
							[
								-82.67719672299995,
								27.647420742000065
							],
							[
								-82.67725766799992,
								27.647450959000082
							],
							[
								-82.6774856689999,
								27.647574958000064
							],
							[
								-82.67750566099994,
								27.647586164000074
							],
							[
								-82.67764092499993,
								27.64768194600009
							],
							[
								-82.67775877699995,
								27.64778481400009
							],
							[
								-82.67783657399991,
								27.64786162300004
							],
							[
								-82.67800079399991,
								27.64804477200005
							],
							[
								-82.67812515599991,
								27.648098953000044
							],
							[
								-82.6783767469999,
								27.648181952000073
							],
							[
								-82.67844645499991,
								27.64820819600004
							],
							[
								-82.6785137519999,
								27.648240119000036
							],
							[
								-82.67857817699992,
								27.648277501000052
							],
							[
								-82.6786392869999,
								27.64832008700006
							],
							[
								-82.67878528699993,
								27.648431087000063
							],
							[
								-82.67884082499997,
								27.648476931000065
							],
							[
								-82.67889251499992,
								27.648527073000082
							],
							[
								-82.6789400269999,
								27.648581190000073
							],
							[
								-82.67898305699993,
								27.648638936000054
							],
							[
								-82.67902132599994,
								27.648699941000075
							],
							[
								-82.67910581699994,
								27.648848543000042
							],
							[
								-82.67914131399993,
								27.648917796000035
							],
							[
								-82.67917069099991,
								27.64898985900004
							],
							[
								-82.67919372899992,
								27.649064192000083
							],
							[
								-82.67921025299995,
								27.649140238000086
							],
							[
								-82.67922014199992,
								27.649217428000043
							],
							[
								-82.6792271409999,
								27.64930042900005
							],
							[
								-82.67923032199991,
								27.649376000000075
							],
							[
								-82.67922395199992,
								27.64948284700006
							],
							[
								-82.67920995199995,
								27.649599847000047
							],
							[
								-82.67920265899994,
								27.649649166000074
							],
							[
								-82.67916010499994,
								27.649805926000056
							],
							[
								-82.67911612299991,
								27.649922265000043
							],
							[
								-82.67905383599992,
								27.650053661000072
							],
							[
								-82.67896392099993,
								27.650182073000053
							],
							[
								-82.6788482799999,
								27.65029688700008
							],
							[
								-82.6787674869999,
								27.650362852000058
							],
							[
								-82.67864200299994,
								27.65044864200007
							],
							[
								-82.67848300299994,
								27.650538642000075
							],
							[
								-82.67841426799993,
								27.650573743000052
							],
							[
								-82.6783427769999,
								27.650602821000064
							],
							[
								-82.67826905499993,
								27.650625663000085
							],
							[
								-82.67819364699994,
								27.650642100000084
							],
							[
								-82.67811710799992,
								27.650652010000044
							],
							[
								-82.6780399999999,
								27.65065532200009
							],
							[
								-82.67801390099993,
								27.65065532200009
							],
							[
								-82.67833023299994,
								27.65159899400004
							],
							[
								-82.67879379899995,
								27.65307088700007
							],
							[
								-82.67880974999991,
								27.653128068000058
							],
							[
								-82.67895475099994,
								27.65372306900008
							],
							[
								-82.67896803499991,
								27.653787846000057
							],
							[
								-82.6789765229999,
								27.653853424000093
							],
							[
								-82.67898016999993,
								27.653919448000067
							],
							[
								-82.67897895499993,
								27.65398556200006
							],
							[
								-82.67894495599995,
								27.65460156200004
							],
							[
								-82.67893265999993,
								27.654708165000045
							],
							[
								-82.67892147399994,
								27.65476194000007
							],
							[
								-82.67879447399991,
								27.65529094100009
							],
							[
								-82.67874747199994,
								27.655433234000043
							],
							[
								-82.67859261199993,
								27.655797034000045
							],
							[
								-82.67856132199995,
								27.65594441500008
							],
							[
								-82.67856132199995,
								27.65636200000006
							],
							[
								-82.67856086899991,
								27.656390542000054
							],
							[
								-82.6785021959999,
								27.658238271000073
							],
							[
								-82.67849230399992,
								27.659348997000052
							],
							[
								-82.67847865899995,
								27.65950116600004
							],
							[
								-82.67846095199991,
								27.659572452000077
							],
							[
								-82.67843995599992,
								27.659653077000087
							],
							[
								-82.6783869439999,
								27.659862985000075
							],
							[
								-82.67836208599994,
								27.659942587000046
							],
							[
								-82.6782958359999,
								27.66008466100004
							],
							[
								-82.67820592099993,
								27.66021307300008
							],
							[
								-82.67809507299995,
								27.660323921000042
							],
							[
								-82.67799211399996,
								27.660398575000045
							],
							[
								-82.67790211499994,
								27.660454575000074
							],
							[
								-82.67787666099991,
								27.66046983600006
							],
							[
								-82.67775987199991,
								27.660526450000077
							],
							[
								-82.6776318709999,
								27.660577450000062
							],
							[
								-82.67755713299994,
								27.660603480000077
							],
							[
								-82.67748039599991,
								27.66062283800005
							],
							[
								-82.67740225499995,
								27.660635375000084
							],
							[
								-82.67719593299995,
								27.660659160000083
							],
							[
								-82.67708761199992,
								27.660669946000045
							],
							[
								-82.67701819199993,
								27.660674118000088
							],
							[
								-82.67694865599992,
								27.660672912000052
							],
							[
								-82.6768794219999,
								27.660666337000066
							],
							[
								-82.67681090299993,
								27.660654432000058
							],
							[
								-82.67674350899995,
								27.660637268000073
							],
							[
								-82.67655450899991,
								27.660581267000055
							],
							[
								-82.67650241399991,
								27.660564086000083
							],
							[
								-82.67636033899993,
								27.660497835000058
							],
							[
								-82.67623192699995,
								27.66040792000007
							],
							[
								-82.67612107899993,
								27.660297073000038
							],
							[
								-82.67603116399994,
								27.660168661000057
							],
							[
								-82.67596230899994,
								27.66001923300007
							],
							[
								-82.6758977049999,
								27.65983188100006
							],
							[
								-82.67587283199992,
								27.659746029000075
							],
							[
								-82.67585106599995,
								27.65965401300008
							],
							[
								-82.67579729999994,
								27.659428999000056
							],
							[
								-82.67577800899994,
								27.65931777800006
							],
							[
								-82.67576218099993,
								27.659173060000057
							],
							[
								-82.67564926099993,
								27.658869963000086
							],
							[
								-82.67562482099993,
								27.658794290000063
							],
							[
								-82.67552782099995,
								27.65844129000004
							],
							[
								-82.6755093399999,
								27.658359166000082
							],
							[
								-82.67549635699993,
								27.65823794700009
							],
							[
								-82.67548235699991,
								27.657877947000088
							],
							[
								-82.67548167799993,
								27.65784300000007
							],
							[
								-82.67548167799993,
								27.657491218000075
							],
							[
								-82.6753842089999,
								27.65701568700007
							],
							[
								-82.67526436599991,
								27.65671674500004
							],
							[
								-82.67510743299994,
								27.65646684300009
							],
							[
								-82.67476275399991,
								27.655970263000086
							],
							[
								-82.67470999599993,
								27.655897060000086
							],
							[
								-82.6746079269999,
								27.65582292000005
							],
							[
								-82.6745196139999,
								27.655737912000067
							],
							[
								-82.67437461499992,
								27.65557791300006
							],
							[
								-82.67432348699992,
								27.655516177000038
							],
							[
								-82.67427805999995,
								27.65545013400009
							],
							[
								-82.67423869399994,
								27.655380308000076
							],
							[
								-82.67420570199994,
								27.65530725400004
							],
							[
								-82.6741287019999,
								27.65511425400007
							],
							[
								-82.67410433999993,
								27.655045129000086
							],
							[
								-82.6740856859999,
								27.65497424900008
							],
							[
								-82.67407286699995,
								27.65490208600005
							],
							[
								-82.67406596599994,
								27.654829118000066
							],
							[
								-82.67406502999995,
								27.654755831000045
							],
							[
								-82.67407202999993,
								27.65450583100005
							],
							[
								-82.67407666199995,
								27.654436444000055
							],
							[
								-82.6740866419999,
								27.654367622000052
							],
							[
								-82.67410190999993,
								27.654299777000062
							],
							[
								-82.67412237499991,
								27.654233315000056
							],
							[
								-82.67414791399995,
								27.65416863200005
							],
							[
								-82.67420191799994,
								27.65404596700006
							],
							[
								-82.67462303699995,
								27.65280228100005
							],
							[
								-82.6746317759999,
								27.652678182000045
							],
							[
								-82.67462196399993,
								27.65233408800009
							],
							[
								-82.67453686599993,
								27.65200825800008
							],
							[
								-82.67452856799991,
								27.65197370900006
							],
							[
								-82.6744248679999,
								27.651501013000086
							],
							[
								-82.6743722619999,
								27.651378238000063
							],
							[
								-82.67390066499992,
								27.65091246600008
							],
							[
								-82.67385957099992,
								27.65086917600007
							],
							[
								-82.67336756999993,
								27.650315176000053
							],
							[
								-82.67327708499995,
								27.650194173000045
							],
							[
								-82.6729100849999,
								27.649606173000052
							],
							[
								-82.6728941639999,
								27.64957966100008
							],
							[
								-82.67283609999993,
								27.649459208000053
							],
							[
								-82.6726700989999,
								27.649037209000085
							],
							[
								-82.67263565899992,
								27.648930587000052
							],
							[
								-82.67212913299994,
								27.646947735000083
							],
							[
								-82.67192017499991,
								27.646496354000078
							],
							[
								-82.67143644299995,
								27.645607925000036
							],
							[
								-82.67116360999995,
								27.64515928700007
							],
							[
								-82.67114096099994,
								27.64511982900007
							],
							[
								-82.6709733269999,
								27.64480988100007
							]
						]
					],
					[
						[
							[
								-82.69002394699993,
								27.668964774000074
							],
							[
								-82.68994460699992,
								27.66887333600005
							],
							[
								-82.68983123799991,
								27.668723372000045
							],
							[
								-82.68975267699996,
								27.66864881400005
							],
							[
								-82.6897047789999,
								27.668610053000066
							],
							[
								-82.68936144599991,
								27.66875595600004
							],
							[
								-82.6893155859999,
								27.668774087000088
							],
							[
								-82.68917693799995,
								27.668812312000057
							],
							[
								-82.6889939379999,
								27.668847312000082
							],
							[
								-82.68888857199994,
								27.668861073000073
							],
							[
								-82.6886345719999,
								27.66887907200004
							],
							[
								-82.68857099999992,
								27.66888132200006
							],
							[
								-82.68822999999992,
								27.66888132200006
							],
							[
								-82.68815095399992,
								27.66887784200009
							],
							[
								-82.6878449539999,
								27.668850841000054
							],
							[
								-82.68776783399994,
								27.668840659000068
							],
							[
								-82.68766374899991,
								27.668815842000072
							],
							[
								-82.68757774999995,
								27.668789843000074
							],
							[
								-82.68754978499993,
								27.66878088800007
							],
							[
								-82.68721578499994,
								27.668667887000083
							],
							[
								-82.68715557999991,
								27.668645086000083
							],
							[
								-82.68709715999995,
								27.668618036000055
							],
							[
								-82.68704082599993,
								27.668586876000063
							],
							[
								-82.68698686399995,
								27.668551765000075
							],
							[
								-82.68681186399994,
								27.66842876600009
							],
							[
								-82.68670209999993,
								27.668337807000057
							],
							[
								-82.68659409999992,
								27.66823280700004
							],
							[
								-82.68649169699995,
								27.668114209000066
							],
							[
								-82.68637769599991,
								27.667956209000067
							],
							[
								-82.68632816399992,
								27.667879661000086
							],
							[
								-82.68629479099991,
								27.667816131000052
							],
							[
								-82.6862077909999,
								27.66763313100006
							],
							[
								-82.68615501499994,
								27.66749313300005
							],
							[
								-82.68612001499991,
								27.667370132000087
							],
							[
								-82.68610284499994,
								27.667298876000075
							],
							[
								-82.6860915339999,
								27.667226458000073
							],
							[
								-82.68608615799991,
								27.667153360000043
							],
							[
								-82.68608675199994,
								27.667080067000086
							],
							[
								-82.6860933129999,
								27.667007066000053
							],
							[
								-82.68610131199995,
								27.666946065000047
							],
							[
								-82.68611308699991,
								27.666877170000078
							],
							[
								-82.6861301749999,
								27.666809397000065
							],
							[
								-82.6861524759999,
								27.666743156000052
							],
							[
								-82.68617985399993,
								27.666678847000075
							],
							[
								-82.68621214299992,
								27.666616859000044
							],
							[
								-82.68624914799994,
								27.666557565000062
							],
							[
								-82.68630214799992,
								27.666479565000092
							],
							[
								-82.68633992299993,
								27.66643128800007
							],
							[
								-82.68635052499991,
								27.66636352800009
							],
							[
								-82.68635491599991,
								27.666329128000086
							],
							[
								-82.68636134099995,
								27.66628683500005
							],
							[
								-82.6863978749999,
								27.66615048700004
							],
							[
								-82.68632804899994,
								27.666143238000075
							],
							[
								-82.68625909699995,
								27.666130059000068
							],
							[
								-82.68619151999991,
								27.666111047000072
							],
							[
								-82.6861258109999,
								27.66608634000005
							],
							[
								-82.68604518699993,
								27.666051623000047
							],
							[
								-82.68600348399991,
								27.666032896000047
							],
							[
								-82.68593903699991,
								27.666004396000062
							],
							[
								-82.6858774239999,
								27.665970198000082
							],
							[
								-82.68581914799995,
								27.665930581000058
							],
							[
								-82.68576468399993,
								27.66588586800009
							],
							[
								-82.68571447599993,
								27.665836423000087
							],
							[
								-82.68566303299991,
								27.665785106000044
							],
							[
								-82.6856388619999,
								27.665756181000063
							],
							[
								-82.6855861649999,
								27.665701566000052
							],
							[
								-82.68553885299991,
								27.665642224000067
							],
							[
								-82.68549734999993,
								27.66557868500007
							],
							[
								-82.68546202499994,
								27.66551151400006
							],
							[
								-82.68539202499994,
								27.665363514000035
							],
							[
								-82.68535991399995,
								27.665286586000036
							],
							[
								-82.68531983999992,
								27.665137968000067
							],
							[
								-82.68527583999992,
								27.66489296800006
							],
							[
								-82.68526234299992,
								27.66476856500009
							],
							[
								-82.68525734199994,
								27.664638565000075
							],
							[
								-82.68525679699991,
								27.664618622000035
							],
							[
								-82.68525273699993,
								27.66436531100004
							],
							[
								-82.68526633999994,
								27.66420183500009
							],
							[
								-82.68530601599991,
								27.66405289100004
							],
							[
								-82.68535046499994,
								27.663929652000036
							],
							[
								-82.68537645799996,
								27.66386568900009
							],
							[
								-82.68540728199991,
								27.66380390900008
							],
							[
								-82.68544275399995,
								27.66374467500009
							],
							[
								-82.68548266599993,
								27.663688337000053
							],
							[
								-82.6855267819999,
								27.66363522800009
							],
							[
								-82.68560578199993,
								27.663547227000038
							],
							[
								-82.6857167359999,
								27.663442931000077
							],
							[
								-82.68605773599995,
								27.663172932000066
							],
							[
								-82.68615157399995,
								27.663107877000073
							],
							[
								-82.6862825739999,
								27.663028877000045
							],
							[
								-82.68638271899994,
								27.66297675900006
							],
							[
								-82.68646171899991,
								27.66294176000008
							],
							[
								-82.68648741699991,
								27.662932816000083
							],
							[
								-82.68651764399993,
								27.662889705000055
							],
							[
								-82.68655659899991,
								27.66283818700009
							],
							[
								-82.68659915099995,
								27.662789597000085
							],
							[
								-82.68664508099994,
								27.662744186000054
							],
							[
								-82.68669415099993,
								27.662702189000072
							],
							[
								-82.68678215099993,
								27.662632190000068
							],
							[
								-82.68684709999991,
								27.66258509800008
							],
							[
								-82.6869159879999,
								27.662543981000056
							],
							[
								-82.68698826499991,
								27.662509167000053
							],
							[
								-82.68706335799993,
								27.66248093300004
							],
							[
								-82.68714066799993,
								27.662459504000083
							],
							[
								-82.68721957999993,
								27.66244504900004
							],
							[
								-82.68735058099992,
								27.662427049000087
							],
							[
								-82.6874729999999,
								27.662418678000055
							],
							[
								-82.68753237499993,
								27.66242064000005
							],
							[
								-82.68817675999992,
								27.66246327600004
							],
							[
								-82.68830793199993,
								27.662465926000042
							],
							[
								-82.68845328399993,
								27.66246975900009
							],
							[
								-82.68862469699991,
								27.662441928000078
							],
							[
								-82.68894169099991,
								27.66237853000007
							],
							[
								-82.68936189499993,
								27.662277565000068
							],
							[
								-82.68941583399993,
								27.662266340000087
							],
							[
								-82.68953917199991,
								27.662253277000048
							],
							[
								-82.68975817199993,
								27.662245277000068
							],
							[
								-82.68983026699993,
								27.662245536000057
							],
							[
								-82.68990210899995,
								27.662251568000045
							],
							[
								-82.6899732359999,
								27.662263336000084
							],
							[
								-82.69004319299995,
								27.66228076300007
							],
							[
								-82.69080528899991,
								27.662503407000088
							],
							[
								-82.69083172099994,
								27.662504589000037
							],
							[
								-82.69085724899992,
								27.662503205000064
							],
							[
								-82.69088516399995,
								27.662443339000053
							],
							[
								-82.69091793199993,
								27.662390843000086
							],
							[
								-82.69098793099994,
								27.66228684300006
							],
							[
								-82.69104507899993,
								27.662210927000046
							],
							[
								-82.69111522899993,
								27.66213638800008
							],
							[
								-82.69125022899993,
								27.66200838800006
							],
							[
								-82.69136135999992,
								27.661918651000065
							],
							[
								-82.69149735999991,
								27.661825651000072
							],
							[
								-82.69160281299992,
								27.661763620000045
							],
							[
								-82.69171081399992,
								27.661709620000067
							],
							[
								-82.69180541399993,
								27.661668914000074
							],
							[
								-82.69188430699995,
								27.66164424200008
							],
							[
								-82.69236730599994,
								27.66151724200006
							],
							[
								-82.6923935239999,
								27.661510768000085
							],
							[
								-82.69261174299993,
								27.661460342000055
							],
							[
								-82.6929763089999,
								27.661346823000088
							],
							[
								-82.69310499699992,
								27.66130730100008
							],
							[
								-82.6932161979999,
								27.661280754000078
							],
							[
								-82.69336119799993,
								27.66125575400008
							],
							[
								-82.69349510099994,
								27.661242876000074
							],
							[
								-82.69380892599992,
								27.661236280000082
							],
							[
								-82.69399022999994,
								27.661224722000043
							],
							[
								-82.6943503569999,
								27.661160602000052
							],
							[
								-82.6944759029999,
								27.661147251000045
							],
							[
								-82.6948119029999,
								27.661135251000076
							],
							[
								-82.6948621539999,
								27.661131769000065
							],
							[
								-82.69491250099992,
								27.66113332900005
							],
							[
								-82.69496243999993,
								27.66113991700007
							],
							[
								-82.69501146899995,
								27.661151467000085
							],
							[
								-82.69505909799994,
								27.66116786100008
							],
							[
								-82.69515065399992,
								27.661192394000068
							],
							[
								-82.6951749189999,
								27.661200238000053
							],
							[
								-82.69520965399994,
								27.661211745000063
							],
							[
								-82.69523309099992,
								27.66122192200004
							],
							[
								-82.6953516609999,
								27.661278165000056
							],
							[
								-82.6954870319999,
								27.66137467200008
							],
							[
								-82.69554382799993,
								27.66142823100006
							],
							[
								-82.69559291699994,
								27.661476967000056
							],
							[
								-82.69564405299991,
								27.66152992900004
							],
							[
								-82.69569028799992,
								27.661587220000058
							],
							[
								-82.69573125599993,
								27.66164838700007
							],
							[
								-82.69576663399994,
								27.661712949000048
							],
							[
								-82.69579614299994,
								27.66178039600004
							],
							[
								-82.69581955099994,
								27.661850196000046
							],
							[
								-82.69583667099994,
								27.661921797000048
							],
							[
								-82.69584867099991,
								27.661979797000072
							],
							[
								-82.69585955899993,
								27.662044096000045
							],
							[
								-82.6958657589999,
								27.662109015000055
							],
							[
								-82.69586723899994,
								27.662174213000075
							],
							[
								-82.69586398899992,
								27.66223934700008
							],
							[
								-82.69585602799992,
								27.662304074000076
							],
							[
								-82.6958468439999,
								27.66236112000007
							],
							[
								-82.69583012999993,
								27.66243920900007
							],
							[
								-82.69580655099992,
								27.66251550700008
							],
							[
								-82.69577629399993,
								27.662589411000056
							],
							[
								-82.69573959799993,
								27.66266033800008
							],
							[
								-82.69569675299994,
								27.66272772900004
							],
							[
								-82.69566175299991,
								27.662777728000037
							],
							[
								-82.69561596099993,
								27.662837633000038
							],
							[
								-82.69556531099994,
								27.66289349200008
							],
							[
								-82.69551015999991,
								27.662944911000068
							],
							[
								-82.6954508959999,
								27.662991530000056
							],
							[
								-82.69538793499993,
								27.663033020000057
							],
							[
								-82.69532171899994,
								27.663069090000082
							],
							[
								-82.69525271399993,
								27.663099486000082
							],
							[
								-82.69518371399994,
								27.663126487000056
							],
							[
								-82.6950521839999,
								27.663166663000084
							],
							[
								-82.69496718499994,
								27.66318566300004
							],
							[
								-82.69494535399991,
								27.66319025900009
							],
							[
								-82.69437731999994,
								27.663302515000055
							],
							[
								-82.69435311099994,
								27.66332311800005
							],
							[
								-82.69425311099991,
								27.66340111800008
							],
							[
								-82.69413483999995,
								27.663479207000083
							],
							[
								-82.69402983999993,
								27.663537207000047
							],
							[
								-82.69390258599992,
								27.663595086000043
							],
							[
								-82.69387938999995,
								27.663603172000084
							],
							[
								-82.69356421099991,
								27.663708231000044
							],
							[
								-82.69350409599991,
								27.66373236900006
							],
							[
								-82.69366917499991,
								27.663990161000072
							],
							[
								-82.69372894299994,
								27.663961339000082
							],
							[
								-82.6939479429999,
								27.66386533900004
							],
							[
								-82.69401782199992,
								27.663838121000083
							],
							[
								-82.69408972499991,
								27.66381682000008
							],
							[
								-82.69416315299992,
								27.663801583000065
							],
							[
								-82.69423759499995,
								27.663792517000047
							],
							[
								-82.69435059499995,
								27.66378351700007
							],
							[
								-82.69442199999992,
								27.66378067800008
							],
							[
								-82.69456487699995,
								27.66379210000008
							],
							[
								-82.6946510869999,
								27.663805973000084
							],
							[
								-82.69478229799995,
								27.663826847000053
							],
							[
								-82.69491468799993,
								27.663858335000043
							],
							[
								-82.69529968799992,
								27.663981335000074
							],
							[
								-82.69533358599995,
								27.66399291400006
							],
							[
								-82.69545016699993,
								27.664044992000075
							],
							[
								-82.69575116699991,
								27.664205992000063
							],
							[
								-82.69580754499992,
								27.66423883200008
							],
							[
								-82.6958613939999,
								27.664275672000088
							],
							[
								-82.69591242999991,
								27.66431632000007
							],
							[
								-82.69596038399993,
								27.66436056100008
							],
							[
								-82.6960050049999,
								27.664408163000076
							],
							[
								-82.69607146299991,
								27.66448454500005
							],
							[
								-82.69611520199993,
								27.66453993500005
							],
							[
								-82.69615445999995,
								27.664598586000068
							],
							[
								-82.69618899699992,
								27.664660136000066
							],
							[
								-82.69621859799992,
								27.664724206000074
							],
							[
								-82.69624308199991,
								27.66479040100006
							],
							[
								-82.69626229799991,
								27.664858312000035
							],
							[
								-82.69627612699992,
								27.66492752100004
							],
							[
								-82.69628448299994,
								27.664997602000085
							],
							[
								-82.69629348299992,
								27.665110602000084
							],
							[
								-82.6962948659999,
								27.665233141000044
							],
							[
								-82.69628586699992,
								27.665391141000043
							],
							[
								-82.6962782789999,
								27.66546721600008
							],
							[
								-82.69626425699994,
								27.665542371000072
							],
							[
								-82.69624390199994,
								27.665616064000062
							],
							[
								-82.69621736199991,
								27.665687761000072
							],
							[
								-82.69618482899995,
								27.665756946000048
							],
							[
								-82.69613982899995,
								27.665842946000055
							],
							[
								-82.69612862799994,
								27.66586368500009
							],
							[
								-82.6958506279999,
								27.66636268500008
							],
							[
								-82.69581734699995,
								27.666417700000068
							],
							[
								-82.6955344889999,
								27.66684962100004
							],
							[
								-82.69552870599995,
								27.666885808000075
							],
							[
								-82.69550544299994,
								27.667135445000042
							],
							[
								-82.6954956589999,
								27.66720816600008
							],
							[
								-82.69547219399993,
								27.66730773900008
							],
							[
								-82.69540219299995,
								27.667543738000063
							],
							[
								-82.69538508599994,
								27.667595586000065
							],
							[
								-82.69533771499995,
								27.667703248000066
							],
							[
								-82.69526852299992,
								27.667836168000065
							],
							[
								-82.69515093699994,
								27.668269511000062
							],
							[
								-82.69511799999992,
								27.668368000000044
							],
							[
								-82.69497799999994,
								27.66871800000007
							],
							[
								-82.69493437599994,
								27.668811204000065
							],
							[
								-82.69487337599992,
								27.668924204000067
							],
							[
								-82.69484030399991,
								27.668980482000052
							],
							[
								-82.69480323599993,
								27.66903421300009
							],
							[
								-82.69476236899993,
								27.66908511400004
							],
							[
								-82.69471791699993,
								27.66913291600008
							],
							[
								-82.6946389169999,
								27.669211916000055
							],
							[
								-82.69458107299994,
								27.669264920000046
							],
							[
								-82.6944526609999,
								27.669354835000036
							],
							[
								-82.69431058599992,
								27.669421086000057
							],
							[
								-82.6941591659999,
								27.669461659000035
							],
							[
								-82.69406176099994,
								27.669473400000072
							],
							[
								-82.69388527399991,
								27.66948487600007
							],
							[
								-82.69374778499991,
								27.66949135100009
							],
							[
								-82.69367904899991,
								27.669491919000052
							],
							[
								-82.6936104699999,
								27.669487234000087
							],
							[
								-82.69354244999994,
								27.669477326000052
							],
							[
								-82.6934753839999,
								27.669462251000084
							],
							[
								-82.69340966599992,
								27.669442098000047
							],
							[
								-82.69325503999994,
								27.669388092000077
							],
							[
								-82.69310733899994,
								27.669319836000057
							],
							[
								-82.69303079299993,
								27.669270305000055
							],
							[
								-82.69287279299994,
								27.669156305000058
							],
							[
								-82.69280285499991,
								27.669100343000082
							],
							[
								-82.69270202999991,
								27.669013755000037
							],
							[
								-82.69264052299991,
								27.66898975500004
							],
							[
								-82.69253138699992,
								27.66896273100008
							],
							[
								-82.69250111799994,
								27.66895865300006
							],
							[
								-82.69245964299995,
								27.66896369400007
							],
							[
								-82.69238291699992,
								27.669036474000052
							],
							[
								-82.6923420729999,
								27.669072920000076
							],
							[
								-82.69223062899994,
								27.669152789000066
							],
							[
								-82.69202962899993,
								27.669274790000088
							],
							[
								-82.6919106549999,
								27.669335407000062
							],
							[
								-82.69174365499993,
								27.669405407000056
							],
							[
								-82.69166564199992,
								27.669433947000073
							],
							[
								-82.69152564199993,
								27.669477947000075
							],
							[
								-82.6914121659999,
								27.669505659000038
							],
							[
								-82.6912559999999,
								27.669519322000042
							],
							[
								-82.69113799999991,
								27.669519322000042
							],
							[
								-82.69098183499995,
								27.669505659000038
							],
							[
								-82.69088267899991,
								27.669482317000075
							],
							[
								-82.69070367899992,
								27.669429317000038
							],
							[
								-82.69065141399994,
								27.66941208600008
							],
							[
								-82.69050743499992,
								27.669344730000034
							],
							[
								-82.6903565319999,
								27.66925662500006
							],
							[
								-82.6902319269999,
								27.66916892000006
							],
							[
								-82.69017194799994,
								27.66911377400004
							],
							[
								-82.69002394699993,
								27.668964774000074
							]
						]
					],
					[
						[
							[
								-82.67748899999992,
								27.66267767800008
							],
							[
								-82.6777019999999,
								27.66267767800008
							],
							[
								-82.67778096699995,
								27.662681151000072
							],
							[
								-82.67785932499993,
								27.662691545000087
							],
							[
								-82.67793646699994,
								27.66270878000006
							],
							[
								-82.67801179799994,
								27.66273272300009
							],
							[
								-82.67808473499991,
								27.662763188000042
							],
							[
								-82.67815471499995,
								27.662799941000063
							],
							[
								-82.67822119699991,
								27.662842698000077
							],
							[
								-82.6782836669999,
								27.66289112800007
							],
							[
								-82.6783362619999,
								27.662936175000084
							],
							[
								-82.67843992099996,
								27.663040926000065
							],
							[
								-82.67850646699992,
								27.663131097000075
							],
							[
								-82.67856846699993,
								27.66322709700006
							],
							[
								-82.67860345199995,
								27.663286088000064
							],
							[
								-82.67863383999992,
								27.663347573000067
							],
							[
								-82.67865945299991,
								27.663411195000037
							],
							[
								-82.67868014399994,
								27.66347658400008
							],
							[
								-82.67869579099994,
								27.663543360000062
							],
							[
								-82.6786999229999,
								27.663564612000073
							],
							[
								-82.67880114999991,
								27.66400599700006
							],
							[
								-82.6789039649999,
								27.664351491000048
							],
							[
								-82.6789276589999,
								27.66445183500008
							],
							[
								-82.67893893899992,
								27.664542569000048
							],
							[
								-82.67896293899992,
								27.66487156900007
							],
							[
								-82.67896471899991,
								27.66496992200007
							],
							[
								-82.67895616499993,
								27.665203459000054
							],
							[
								-82.6790271459999,
								27.66659002200004
							],
							[
								-82.67902830799994,
								27.66664117600004
							],
							[
								-82.67902474499994,
								27.667260127000077
							],
							[
								-82.6790614059999,
								27.66748308600006
							],
							[
								-82.67907271199994,
								27.66759588800005
							],
							[
								-82.67908671299995,
								27.667975888000058
							],
							[
								-82.6790860509999,
								27.66805680500005
							],
							[
								-82.67906191199995,
								27.66851026200004
							],
							[
								-82.67912258299992,
								27.66906969900009
							],
							[
								-82.67918879799993,
								27.669201653000076
							],
							[
								-82.6792300859999,
								27.669297414000084
							],
							[
								-82.67926298399993,
								27.669410259000074
							],
							[
								-82.6793219839999,
								27.669676259000084
							],
							[
								-82.67933919299992,
								27.66978492300007
							],
							[
								-82.67935919299994,
								27.669992923000052
							],
							[
								-82.67936332199992,
								27.670079000000044
							],
							[
								-82.67935330699993,
								27.670212836000076
							],
							[
								-82.6792835789999,
								27.67067616500009
							],
							[
								-82.67926032199995,
								27.671093065000036
							],
							[
								-82.67926032199995,
								27.671599056000048
							],
							[
								-82.67930046599992,
								27.672386436000068
							],
							[
								-82.6793357759999,
								27.673399660000086
							],
							[
								-82.67936444199995,
								27.674219878000088
							],
							[
								-82.6794277919999,
								27.67456197000007
							],
							[
								-82.6795529719999,
								27.675077981000072
							],
							[
								-82.67956245599993,
								27.675121818000036
							],
							[
								-82.67964545599995,
								27.675557819000066
							],
							[
								-82.67966119399995,
								27.67571083200005
							],
							[
								-82.67966825699995,
								27.676134369000067
							],
							[
								-82.67966554499992,
								27.67745257500008
							],
							[
								-82.6797509669999,
								27.67781212500006
							],
							[
								-82.67976197999991,
								27.67786566700005
							],
							[
								-82.67986998099992,
								27.678485668000064
							],
							[
								-82.67988332199991,
								27.678640000000087
							],
							[
								-82.67988332199991,
								27.679200435000045
							],
							[
								-82.67994709199992,
								27.67978915300006
							],
							[
								-82.67994931899995,
								27.67981257300005
							],
							[
								-82.68003631999994,
								27.68087457200005
							],
							[
								-82.68003819199993,
								27.680993070000056
							],
							[
								-82.67999802499992,
								27.681793548000087
							],
							[
								-82.68000689999991,
								27.682078471000068
							],
							[
								-82.68005531799992,
								27.68368709500004
							],
							[
								-82.6800946379999,
								27.68421573100005
							],
							[
								-82.68018035799993,
								27.684638147000044
							],
							[
								-82.68019167799991,
								27.684707882000055
							],
							[
								-82.68019748899991,
								27.684778290000054
							],
							[
								-82.68019775499994,
								27.684848937000083
							],
							[
								-82.68018375499992,
								27.685242937000055
							],
							[
								-82.68016630999996,
								27.685390090000055
							],
							[
								-82.68010167599994,
								27.685708153000064
							],
							[
								-82.68004994799992,
								27.68640867700009
							],
							[
								-82.68006972299992,
								27.687455809000085
							],
							[
								-82.68008769999994,
								27.687717226000075
							],
							[
								-82.68018306899995,
								27.687827094000056
							],
							[
								-82.68027883499991,
								27.68796233900008
							],
							[
								-82.68028907699994,
								27.687980563000053
							],
							[
								-82.68036507699992,
								27.68811956400009
							],
							[
								-82.68039973099991,
								27.68819010200008
							],
							[
								-82.68042809399992,
								27.68826339700007
							],
							[
								-82.68044994999991,
								27.68833888800009
							],
							[
								-82.68046513099995,
								27.688415999000085
							],
							[
								-82.68047352199994,
								27.688494141000035
							],
							[
								-82.68048752299991,
								27.688715140000056
							],
							[
								-82.68048544499993,
								27.688855417000074
							],
							[
								-82.6804397279999,
								27.689346176000072
							],
							[
								-82.68043723099993,
								27.689521785000068
							],
							[
								-82.68042145599992,
								27.689677179000057
							],
							[
								-82.68033845699995,
								27.690113179000036
							],
							[
								-82.68030008699992,
								27.690252586000042
							],
							[
								-82.68025728399994,
								27.69035135100006
							],
							[
								-82.68013450199993,
								27.690593767000053
							],
							[
								-82.6801156329999,
								27.690653556000086
							],
							[
								-82.6801163209999,
								27.690960992000043
							],
							[
								-82.68011370699993,
								27.69103053400005
							],
							[
								-82.68010572299994,
								27.69109966600007
							],
							[
								-82.68009241699991,
								27.691167973000063
							],
							[
								-82.68007386999996,
								27.691235047000077
							],
							[
								-82.6800501909999,
								27.691300486000046
							],
							[
								-82.68002419099992,
								27.691364487000044
							],
							[
								-82.67996983599994,
								27.691475661000084
							],
							[
								-82.67993207899991,
								27.69153549300006
							],
							[
								-82.67985507899994,
								27.691647492000072
							],
							[
								-82.67981337999993,
								27.691703374000042
							],
							[
								-82.67976747699993,
								27.69175585800008
							],
							[
								-82.67971764599992,
								27.691804627000067
							],
							[
								-82.6796641869999,
								27.691849389000083
							],
							[
								-82.67960741999991,
								27.691889875000072
							],
							[
								-82.67951141999993,
								27.691952876000073
							],
							[
								-82.67945047099994,
								27.691989511000088
							],
							[
								-82.6793868179999,
								27.692021216000057
							],
							[
								-82.67932085899992,
								27.69204779200004
							],
							[
								-82.67925300699996,
								27.692069074000074
							],
							[
								-82.67918368499994,
								27.692084928000043
							],
							[
								-82.67911332699992,
								27.692095256000073
							],
							[
								-82.67893119099995,
								27.69211467100007
							],
							[
								-82.67883199499994,
								27.692128593000064
							],
							[
								-82.67870699999992,
								27.692137322000065
							],
							[
								-82.67865973099993,
								27.69213607900008
							],
							[
								-82.67856164599993,
								27.692130906000045
							],
							[
								-82.67847456099992,
								27.69212573300007
							],
							[
								-82.6783718339999,
								27.692113659000086
							],
							[
								-82.67825997799991,
								27.692086454000048
							],
							[
								-82.67803897699991,
								27.69201745500004
							],
							[
								-82.67797253499992,
								27.691993813000067
							],
							[
								-82.6779081489999,
								27.69196503900008
							],
							[
								-82.67784621499993,
								27.69193130700006
							],
							[
								-82.67778711599993,
								27.69189282600007
							],
							[
								-82.67773121299992,
								27.691849833000052
							],
							[
								-82.67767885099994,
								27.691802591000055
							],
							[
								-82.67755385099991,
								27.69168059100008
							],
							[
								-82.67749307999993,
								27.691615073000037
							],
							[
								-82.67742707299993,
								27.691525739000042
							],
							[
								-82.67697907299993,
								27.690833739000084
							],
							[
								-82.67694354999992,
								27.690773904000082
							],
							[
								-82.67691275399994,
								27.690711504000035
							],
							[
								-82.67688686899993,
								27.69064691200009
							],
							[
								-82.67686605199992,
								27.69058051400009
							],
							[
								-82.67685042499994,
								27.69051270500006
							],
							[
								-82.67683691299993,
								27.69047458600005
							],
							[
								-82.67679617499994,
								27.690322221000088
							],
							[
								-82.6767610089999,
								27.690120276000073
							],
							[
								-82.67674767799991,
								27.689966000000084
							],
							[
								-82.67675347499994,
								27.689864055000044
							],
							[
								-82.67677047399991,
								27.68971505500008
							],
							[
								-82.67678110399993,
								27.689645900000073
							],
							[
								-82.67679707799994,
								27.689577780000036
							],
							[
								-82.67681829899993,
								27.68951110800009
							],
							[
								-82.67684463899991,
								27.689446288000056
							],
							[
								-82.67687593799991,
								27.68938371200005
							],
							[
								-82.67691200699994,
								27.689323758000057
							],
							[
								-82.6770023329999,
								27.689186048000067
							],
							[
								-82.67703236099993,
								27.689124243000037
							],
							[
								-82.67709661899994,
								27.68882354300007
							],
							[
								-82.67711047899991,
								27.688490217000037
							],
							[
								-82.67697329899994,
								27.687327420000088
							],
							[
								-82.67685460899992,
								27.68668419100004
							],
							[
								-82.67684912599992,
								27.686651015000052
							],
							[
								-82.67671961599991,
								27.68576459800005
							],
							[
								-82.67658925799992,
								27.68520658400007
							],
							[
								-82.67657746399993,
								27.685147119000078
							],
							[
								-82.67650846399994,
								27.684725120000053
							],
							[
								-82.67650264799995,
								27.68468345000008
							],
							[
								-82.67639564799993,
								27.683759450000082
							],
							[
								-82.67639066499993,
								27.683613891000054
							],
							[
								-82.67643778799993,
								27.68260857900009
							],
							[
								-82.67644759899991,
								27.68073676000006
							],
							[
								-82.6763831859999,
								27.678821224000046
							],
							[
								-82.67638495499995,
								27.678727046000063
							],
							[
								-82.67645720799993,
								27.67771360200004
							],
							[
								-82.67644681699994,
								27.677487228000075
							],
							[
								-82.67642777999994,
								27.677304336000077
							],
							[
								-82.67628437099997,
								27.677089832000036
							],
							[
								-82.67624935999993,
								27.677033007000094
							],
							[
								-82.67615935899994,
								27.676874006000048
							],
							[
								-82.67612067499994,
								27.676797342000043
							],
							[
								-82.67605867599991,
								27.676658342000053
							],
							[
								-82.67603288399994,
								27.67659395000004
							],
							[
								-82.67601213099994,
								27.676527762000035
							],
							[
								-82.67599654199995,
								27.676460171000087
							],
							[
								-82.67598620799993,
								27.676391580000086
							],
							[
								-82.67598119199994,
								27.676322396000046
							],
							[
								-82.6759741919999,
								27.676115396000057
							],
							[
								-82.67598074699993,
								27.675972466000076
							],
							[
								-82.67600874599992,
								27.675750466000068
							],
							[
								-82.67602852899995,
								27.67564488200009
							],
							[
								-82.67619191199992,
								27.674991350000084
							],
							[
								-82.67626767799993,
								27.674178193000046
							],
							[
								-82.67626767799993,
								27.67363902900007
							],
							[
								-82.67624875699994,
								27.673253032000048
							],
							[
								-82.6762476909999,
								27.673204207000087
							],
							[
								-82.67625772499991,
								27.671324515000038
							],
							[
								-82.67627148199995,
								27.670307414000035
							],
							[
								-82.67625168099994,
								27.669693576000043
							],
							[
								-82.67622215999995,
								27.66926727500004
							],
							[
								-82.67614697899995,
								27.66884542200006
							],
							[
								-82.67592717199994,
								27.668008429000054
							],
							[
								-82.67590899999993,
								27.667922253000086
							],
							[
								-82.67584299999993,
								27.667510253000046
							],
							[
								-82.67583167799995,
								27.667368000000067
							],
							[
								-82.67583330799994,
								27.667313867000075
							],
							[
								-82.67585730899992,
								27.666915868000046
							],
							[
								-82.67586934099995,
								27.666813835000085
							],
							[
								-82.67588067899993,
								27.666759422000045
							],
							[
								-82.67600567999995,
								27.666240421000055
							],
							[
								-82.6760142139999,
								27.666207703000055
							],
							[
								-82.67610903799994,
								27.66587026500008
							],
							[
								-82.67614562299991,
								27.665612840000055
							],
							[
								-82.67613997699993,
								27.66527251800005
							],
							[
								-82.6760804029999,
								27.66379011300006
							],
							[
								-82.67607967799995,
								27.66375400000004
							],
							[
								-82.67609232399991,
								27.663603710000075
							],
							[
								-82.6761028329999,
								27.663541772000087
							],
							[
								-82.67611676799993,
								27.663475944000083
							],
							[
								-82.67613558699992,
								27.663411342000074
							],
							[
								-82.67615918299992,
								27.663348328000044
							],
							[
								-82.67618742499991,
								27.663287255000057
							],
							[
								-82.6762201539999,
								27.663228464000042
							],
							[
								-82.67625718799991,
								27.663172285000087
							],
							[
								-82.67629218799993,
								27.66312328500004
							],
							[
								-82.67633685899995,
								27.66306581200007
							],
							[
								-82.67638603199993,
								27.66301214100008
							],
							[
								-82.67643938499992,
								27.662962622000066
							],
							[
								-82.67649656799995,
								27.662917580000055
							],
							[
								-82.67655720599993,
								27.662877310000056
							],
							[
								-82.67662090199991,
								27.66284207700005
							],
							[
								-82.67668723899993,
								27.66281211000006
							],
							[
								-82.6767392399999,
								27.662791110000057
							],
							[
								-82.67676841399992,
								27.66277991400006
							],
							[
								-82.67692671299994,
								27.662738183000045
							],
							[
								-82.67714111599992,
								27.662703743000066
							],
							[
								-82.67721864799995,
								27.662690506000047
							],
							[
								-82.67736999999994,
								27.66267767800008
							],
							[
								-82.67748899999992,
								27.66267767800008
							]
						]
					],
					[
						[
							[
								-82.68483521199994,
								27.702890266000054
							],
							[
								-82.68552533699994,
								27.702182925000045
							],
							[
								-82.68554463399994,
								27.70216373900007
							],
							[
								-82.68690163399992,
								27.70085473900008
							],
							[
								-82.68694814899993,
								27.70081289400008
							],
							[
								-82.68797014899991,
								27.699955894000084
							],
							[
								-82.68808667399992,
								27.699873017000073
							],
							[
								-82.68846353099991,
								27.69964781300007
							],
							[
								-82.68854792699996,
								27.699564080000073
							],
							[
								-82.68858640699995,
								27.699533543000086
							],
							[
								-82.68864079999992,
								27.699492747000082
							],
							[
								-82.68869027499994,
								27.699449902000083
							],
							[
								-82.68875279399992,
								27.699401136000063
							],
							[
								-82.6888193659999,
								27.699358069000088
							],
							[
								-82.68888947499994,
								27.69932103400004
							],
							[
								-82.68896257299991,
								27.699290322000085
							],
							[
								-82.6890380939999,
								27.699266169000055
							],
							[
								-82.68911544899993,
								27.69924876500005
							],
							[
								-82.68925064099994,
								27.69922455300008
							],
							[
								-82.6894079999999,
								27.699210678000043
							],
							[
								-82.6894854379999,
								27.699210678000043
							],
							[
								-82.68964373999995,
								27.699185683000053
							],
							[
								-82.68967943199993,
								27.699180778000084
							],
							[
								-82.69059520099995,
								27.699073574000067
							],
							[
								-82.69196796999995,
								27.698918371000048
							],
							[
								-82.69202631299993,
								27.698913691000087
							],
							[
								-82.6925103129999,
								27.698890692000077
							],
							[
								-82.69255299999993,
								27.698889678000057
							],
							[
								-82.6926690329999,
								27.698897195000086
							],
							[
								-82.6929380329999,
								27.698932195000054
							],
							[
								-82.69299527099992,
								27.698941528000034
							],
							[
								-82.69320950699995,
								27.698983593000037
							],
							[
								-82.69323400699994,
								27.698988135000036
							],
							[
								-82.69329928099995,
								27.699000563000084
							],
							[
								-82.69333372299991,
								27.69900782500008
							],
							[
								-82.69358597199994,
								27.699066197000036
							],
							[
								-82.69379742199993,
								27.699113716000056
							],
							[
								-82.6938446179999,
								27.69912389600006
							],
							[
								-82.69396258599994,
								27.699157914000068
							],
							[
								-82.69404038399995,
								27.699190437000084
							],
							[
								-82.6942153839999,
								27.699273436000055
							],
							[
								-82.69427988299992,
								27.69930729200007
							],
							[
								-82.69434143099994,
								27.69934625700006
							],
							[
								-82.69439962299992,
								27.699390076000043
							],
							[
								-82.69445407699993,
								27.699438460000067
							],
							[
								-82.69457204399993,
								27.69955215200008
							],
							[
								-82.69468654999991,
								27.699636788000078
							],
							[
								-82.69474481299994,
								27.699683718000074
							],
							[
								-82.6947989709999,
								27.699735331000056
							],
							[
								-82.69484865099992,
								27.69979126800007
							],
							[
								-82.6948935069999,
								27.699851141000067
							],
							[
								-82.69493322999995,
								27.699914538000087
							],
							[
								-82.69499313199992,
								27.700020865000056
							],
							[
								-82.6950826399999,
								27.700178994000055
							],
							[
								-82.69512465699995,
								27.70026322300004
							],
							[
								-82.69513403999991,
								27.70028479000007
							],
							[
								-82.6951697959999,
								27.700314270000035
							],
							[
								-82.69523234999991,
								27.700308319000047
							],
							[
								-82.69529517299992,
								27.700307068000086
							],
							[
								-82.69535791499993,
								27.70031052300004
							],
							[
								-82.69542022099995,
								27.700318665000058
							],
							[
								-82.6954817429999,
								27.700331448000043
							],
							[
								-82.69557574299996,
								27.70035444800004
							],
							[
								-82.69566958599995,
								27.700382914000045
							],
							[
								-82.69573104799991,
								27.700407888000086
							],
							[
								-82.69581104799994,
								27.700443888000052
							],
							[
								-82.6958916609999,
								27.700485164000042
							],
							[
								-82.69602222299994,
								27.70057723000008
							],
							[
								-82.69607136399992,
								27.700586385000065
							],
							[
								-82.69634841099992,
								27.700618662000068
							],
							[
								-82.69680068299994,
								27.700653304000074
							],
							[
								-82.69690345899994,
								27.700667174000046
							],
							[
								-82.6971454589999,
								27.70071417400004
							],
							[
								-82.6972815869999,
								27.70075191400008
							],
							[
								-82.6973118809999,
								27.70076356400006
							],
							[
								-82.69745988099993,
								27.700823564000075
							],
							[
								-82.6975241859999,
								27.70085262100008
							],
							[
								-82.69761818599994,
								27.700899620000087
							],
							[
								-82.69768800999992,
								27.700938502000046
							],
							[
								-82.69775410699992,
								27.700983430000065
							],
							[
								-82.6978159539999,
								27.701034048000057
							],
							[
								-82.69788295399991,
								27.701094048000073
							],
							[
								-82.69797192099992,
								27.70118592700004
							],
							[
								-82.69805797099991,
								27.701307710000037
							],
							[
								-82.69824890299992,
								27.701632025000038
							],
							[
								-82.69831526799993,
								27.701772463000054
							],
							[
								-82.6983691769999,
								27.701917939000055
							],
							[
								-82.6984112259999,
								27.702075124000093
							],
							[
								-82.69842579399995,
								27.702161412000066
							],
							[
								-82.69843556699993,
								27.70224064900009
							],
							[
								-82.69843827299991,
								27.70232044100004
							],
							[
								-82.69843389199991,
								27.702400159000035
							],
							[
								-82.69842245799992,
								27.702479173000086
							],
							[
								-82.69840406199995,
								27.70255686300004
							],
							[
								-82.6983770619999,
								27.702651863000085
							],
							[
								-82.69835408699993,
								27.702721703000066
							],
							[
								-82.69832548499994,
								27.702789434000067
							],
							[
								-82.69829144599993,
								27.702854602000063
							],
							[
								-82.69825219699993,
								27.702916772000037
							],
							[
								-82.6982080009999,
								27.70297552800008
							],
							[
								-82.69815915299995,
								27.703030478000073
							],
							[
								-82.69810597999992,
								27.70308125300005
							],
							[
								-82.6979979809999,
								27.703176254000084
							],
							[
								-82.69791685199993,
								27.703239758000052
							],
							[
								-82.6977958519999,
								27.70332375800007
							],
							[
								-82.69773266099992,
								27.70336383600005
							],
							[
								-82.69764467699991,
								27.703408389000064
							],
							[
								-82.69753767699991,
								27.70345538900006
							],
							[
								-82.69748358599992,
								27.703477086000078
							],
							[
								-82.69737108499994,
								27.703509908000058
							],
							[
								-82.69731708599994,
								27.703521907000038
							],
							[
								-82.69727816599993,
								27.703529659000083
							],
							[
								-82.69712199999992,
								27.703543322000087
							],
							[
								-82.69696583399991,
								27.703529659000083
							],
							[
								-82.6968144139999,
								27.703489086000047
							],
							[
								-82.69667233899992,
								27.703422836000072
							],
							[
								-82.69665587999992,
								27.703413109000053
							],
							[
								-82.69663799999995,
								27.703412322000077
							],
							[
								-82.69654924899993,
								27.70340793200006
							],
							[
								-82.69643094699991,
								27.70339619200007
							],
							[
								-82.69615644999993,
								27.703370648000092
							],
							[
								-82.69607757799992,
								27.703380717000073
							],
							[
								-82.69584932999993,
								27.703415434000078
							],
							[
								-82.6956396189999,
								27.703482217000044
							],
							[
								-82.69518175999991,
								27.703700661000084
							],
							[
								-82.69465413599995,
								27.703969377000078
							],
							[
								-82.69460935399991,
								27.703990650000037
							],
							[
								-82.69420635499995,
								27.704168650000042
							],
							[
								-82.6941143599999,
								27.704203405000044
							],
							[
								-82.69373835899995,
								27.704322405000084
							],
							[
								-82.6936231649999,
								27.704350659000056
							],
							[
								-82.69346699999994,
								27.70436432200006
							],
							[
								-82.69342599999993,
								27.70436432200006
							],
							[
								-82.69326983399992,
								27.704350659000056
							],
							[
								-82.69311841299992,
								27.704310086000078
							],
							[
								-82.69297633899993,
								27.704243836000046
							],
							[
								-82.69284792699995,
								27.704153921000056
							],
							[
								-82.69282437899996,
								27.70413345500009
							],
							[
								-82.69278437999992,
								27.704097456000056
							],
							[
								-82.6926970799999,
								27.70400707300007
							],
							[
								-82.69260716499991,
								27.70387866100009
							],
							[
								-82.69254091399995,
								27.703736586000048
							],
							[
								-82.69250034099991,
								27.70358516600004
							],
							[
								-82.69248667799991,
								27.703429000000085
							],
							[
								-82.69248667799991,
								27.70338200000009
							],
							[
								-82.69250034099991,
								27.70322583400008
							],
							[
								-82.69254091399995,
								27.70307441300008
							],
							[
								-82.69260716499991,
								27.702932339000085
							],
							[
								-82.6926970799999,
								27.702803927000048
							],
							[
								-82.69278852499991,
								27.702709836000054
							],
							[
								-82.69284252499995,
								27.70266183700005
							],
							[
								-82.69286732599994,
								27.70264058500004
							],
							[
								-82.6929315129999,
								27.702587575000052
							],
							[
								-82.6928675289999,
								27.70257537000009
							],
							[
								-82.69277352899991,
								27.702551371000084
							],
							[
								-82.69268841399992,
								27.702525087000083
							],
							[
								-82.69257959299995,
								27.702477111000064
							],
							[
								-82.69251259299995,
								27.70244211000005
							],
							[
								-82.69246351699991,
								27.702411918000053
							],
							[
								-82.6918749589999,
								27.702401815000087
							],
							[
								-82.6917232859999,
								27.70241149600008
							],
							[
								-82.69159332299995,
								27.70241038000006
							],
							[
								-82.69144532299993,
								27.70239838100008
							],
							[
								-82.69132290699991,
								27.70237990600009
							],
							[
								-82.69121490799995,
								27.702355906000037
							],
							[
								-82.69110672399995,
								27.702324643000054
							],
							[
								-82.69103756899995,
								27.702299864000054
							],
							[
								-82.69092226099991,
								27.702246322000065
							],
							[
								-82.69083890999991,
								27.702246322000065
							],
							[
								-82.69065292699992,
								27.702271212000085
							],
							[
								-82.6904929559999,
								27.70230132400008
							],
							[
								-82.6904489559999,
								27.702317272000077
							],
							[
								-82.69037283199992,
								27.702371800000037
							],
							[
								-82.69036792599991,
								27.702394443000063
							],
							[
								-82.6903505279999,
								27.70246227100006
							],
							[
								-82.6903278499999,
								27.70252852200008
							],
							[
								-82.69030003499995,
								27.702592785000036
							],
							[
								-82.69026725399993,
								27.70265466300009
							],
							[
								-82.69022970999993,
								27.70271377200004
							],
							[
								-82.69018763499992,
								27.702769746000058
							],
							[
								-82.69014129099992,
								27.702822240000046
							],
							[
								-82.69009096199994,
								27.70287092700005
							],
							[
								-82.69014427399992,
								27.70289332500005
							],
							[
								-82.69019482399995,
								27.702921406000087
							],
							[
								-82.69024200899992,
								27.70295483400008
							],
							[
								-82.6902852639999,
								27.70299321200008
							],
							[
								-82.69032407299994,
								27.70303608000006
							],
							[
								-82.69039223999994,
								27.703103041000077
							],
							[
								-82.6904338999999,
								27.703150099000084
							],
							[
								-82.69048144599992,
								27.703212266000037
							],
							[
								-82.69052340699994,
								27.703278332000085
							],
							[
								-82.69055946499992,
								27.70334779600006
							],
							[
								-82.6905893469999,
								27.703420132000076
							],
							[
								-82.69061282599995,
								27.703494792000072
							],
							[
								-82.69062972599994,
								27.703571211000053
							],
							[
								-82.69063991599995,
								27.70364880900007
							],
							[
								-82.69064332199991,
								27.70372700000007
							],
							[
								-82.69064070099995,
								27.703774770000052
							],
							[
								-82.69063174299993,
								27.70388334800009
							],
							[
								-82.69062321899992,
								27.703951895000046
							],
							[
								-82.69060862899994,
								27.704019411000047
							],
							[
								-82.69058808999995,
								27.704085362000058
							],
							[
								-82.69056176299995,
								27.70414922300006
							],
							[
								-82.69053476399995,
								27.70420822300008
							],
							[
								-82.69050146899991,
								27.70427376100008
							],
							[
								-82.69046293199995,
								27.704336360000074
							],
							[
								-82.69041941199993,
								27.70439560300008
							],
							[
								-82.69037119799992,
								27.704451094000035
							],
							[
								-82.69031861299995,
								27.70450246200005
							],
							[
								-82.69027861299992,
								27.704538462000073
							],
							[
								-82.69022145399992,
								27.704585786000052
							],
							[
								-82.69003345399994,
								27.70472878600009
							],
							[
								-82.6899288969999,
								27.704797392000046
							],
							[
								-82.68978089799992,
								27.704880392000064
							],
							[
								-82.68971570699995,
								27.704913542000043
							],
							[
								-82.6893797059999,
								27.70506754200005
							],
							[
								-82.68931258599993,
								27.705095086000085
							],
							[
								-82.6892175559999,
								27.705123842000035
							],
							[
								-82.68907673899992,
								27.705158177000044
							],
							[
								-82.68905713599992,
								27.705168649000086
							],
							[
								-82.68903750399994,
								27.705179840000085
							],
							[
								-82.68882250399992,
								27.70529883900008
							],
							[
								-82.68880168499993,
								27.705310008000083
							],
							[
								-82.68857268399995,
								27.705429008000067
							],
							[
								-82.68848662499994,
								27.705468129000053
							],
							[
								-82.68824462599991,
								27.70556312900004
							],
							[
								-82.68818681699992,
								27.705583577000084
							],
							[
								-82.68798446099993,
								27.70564747900005
							],
							[
								-82.6872965739999,
								27.705910863000042
							],
							[
								-82.68718388699995,
								27.705945727000085
							],
							[
								-82.68698288699994,
								27.705993726000088
							],
							[
								-82.68688010499994,
								27.706012040000076
							],
							[
								-82.68667810499994,
								27.706036041000065
							],
							[
								-82.6866255939999,
								27.706040724000047
							],
							[
								-82.6864245939999,
								27.706052723000084
							],
							[
								-82.68631766999994,
								27.706052739000086
							],
							[
								-82.68611566999994,
								27.706040739000063
							],
							[
								-82.68601283399994,
								27.706028659000086
							],
							[
								-82.68595644399994,
								27.706016842000054
							],
							[
								-82.68580844399992,
								27.705980842000088
							],
							[
								-82.6857342209999,
								27.705959372000052
							],
							[
								-82.68562722099995,
								27.705923372000086
							],
							[
								-82.68556651099993,
								27.705900477000057
							],
							[
								-82.68550760999995,
								27.705873264000047
							],
							[
								-82.68545082399993,
								27.705841875000093
							],
							[
								-82.68539644899994,
								27.705806473000056
							],
							[
								-82.68526144799995,
								27.70571147300007
							],
							[
								-82.68520092699993,
								27.70566492100005
							],
							[
								-82.68515271299992,
								27.705625085000065
							],
							[
								-82.68504347699991,
								27.705619227000057
							],
							[
								-82.68494947699992,
								27.705608227000084
							],
							[
								-82.68489771699991,
								27.705600638000078
							],
							[
								-82.68482971599991,
								27.70558863900004
							],
							[
								-82.6847601099999,
								27.705573491000052
							],
							[
								-82.6846919219999,
								27.705552882000063
							],
							[
								-82.68462557799995,
								27.705526940000084
							],
							[
								-82.6845614959999,
								27.70549582800004
							],
							[
								-82.68450007699994,
								27.705459743000063
							],
							[
								-82.6844417069999,
								27.70541890900006
							],
							[
								-82.68438675199991,
								27.705373584000085
							],
							[
								-82.68429275199992,
								27.70528958400007
							],
							[
								-82.68424336499993,
								27.705241939000075
							],
							[
								-82.6841977549999,
								27.705190667000068
							],
							[
								-82.68415618699993,
								27.705136067000073
							],
							[
								-82.6841189029999,
								27.70507845700007
							],
							[
								-82.6840861199999,
								27.705018171000063
							],
							[
								-82.68403311999992,
								27.70491117000006
							],
							[
								-82.6840029839999,
								27.704843447000087
							],
							[
								-82.6839785279999,
								27.704773472000056
							],
							[
								-82.68395991799991,
								27.70470172000006
							],
							[
								-82.68394727999993,
								27.704628679000052
							],
							[
								-82.68393327899992,
								27.704521680000084
							],
							[
								-82.68392696799992,
								27.70445315900008
							],
							[
								-82.68392591499992,
								27.70438435600005
							],
							[
								-82.6839301249999,
								27.70431567500009
							],
							[
								-82.68393957399991,
								27.704247516000066
							],
							[
								-82.68395420699994,
								27.704180279000074
							],
							[
								-82.6839942069999,
								27.704025279000064
							],
							[
								-82.68401673999995,
								27.703951277000044
							],
							[
								-82.6840455489999,
								27.703879486000066
							],
							[
								-82.68408042099992,
								27.703810436000087
							],
							[
								-82.68412109899992,
								27.703744638000046
							],
							[
								-82.68416727999994,
								27.703682579000088
							],
							[
								-82.68427436199994,
								27.70355090700008
							],
							[
								-82.68437894999994,
								27.703392810000082
							],
							[
								-82.6844750859999,
								27.703271605000054
							],
							[
								-82.68483521199994,
								27.702890266000054
							]
						]
					],
					[
						[
							[
								-82.63823999999994,
								27.719460000000083
							],
							[
								-82.6382379069999,
								27.719269531000066
							],
							[
								-82.63823610999992,
								27.719106003000036
							],
							[
								-82.63823101899993,
								27.71864275200005
							],
							[
								-82.63708309099991,
								27.718611603000056
							],
							[
								-82.63605923799992,
								27.718623282000067
							],
							[
								-82.63603977299994,
								27.71767728900005
							],
							[
								-82.63683393999992,
								27.717661717000055
							],
							[
								-82.6381536589999,
								27.71764614500006
							],
							[
								-82.63822999999991,
								27.71771924500007
							],
							[
								-82.63822999999991,
								27.71742038600007
							],
							[
								-82.63822999999991,
								27.71712000000008
							],
							[
								-82.63822999999991,
								27.716893824000067
							],
							[
								-82.63822999999991,
								27.71666612200005
							],
							[
								-82.63822999999991,
								27.71626000000009
							],
							[
								-82.63822999999991,
								27.716025709000064
							],
							[
								-82.63822999999991,
								27.71581000000009
							],
							[
								-82.63822999999991,
								27.715413759000057
							],
							[
								-82.63822999999991,
								27.71514336300004
							],
							[
								-82.63822999999991,
								27.71494000000007
							],
							[
								-82.63822999999991,
								27.71477334700006
							],
							[
								-82.63822999999991,
								27.714502950000053
							],
							[
								-82.63822999999991,
								27.714246785000057
							],
							[
								-82.63822999999991,
								27.71398000000005
							],
							[
								-82.6382278129999,
								27.71389032400009
							],
							[
								-82.63822469099995,
								27.71376231800008
							],
							[
								-82.63821999999993,
								27.713520000000074
							],
							[
								-82.63821999999993,
								27.713293282000052
							],
							[
								-82.63821999999993,
								27.713080000000048
							],
							[
								-82.63821714999995,
								27.71282345600008
							],
							[
								-82.6382125639999,
								27.712410797000075
							],
							[
								-82.6382099999999,
								27.712180000000046
							],
							[
								-82.6382129019999,
								27.711912976000068
							],
							[
								-82.63821723299992,
								27.711514544000067
							],
							[
								-82.63821999999993,
								27.71126000000004
							],
							[
								-82.63820773099991,
								27.711002342000086
							],
							[
								-82.63819999999993,
								27.71084000000008
							],
							[
								-82.63819999999993,
								27.710575085000073
							],
							[
								-82.63819999999993,
								27.710360000000037
							],
							[
								-82.63797239799993,
								27.710361850000083
							],
							[
								-82.63758499999994,
								27.71036500000008
							],
							[
								-82.6369699999999,
								27.71037000000007
							],
							[
								-82.63660595799992,
								27.70972875600006
							],
							[
								-82.63605212899995,
								27.709017217000053
							],
							[
								-82.63620934399995,
								27.70782082900007
							],
							[
								-82.63621534099991,
								27.70778183500005
							],
							[
								-82.63625221599995,
								27.707640772000047
							],
							[
								-82.63634921499994,
								27.707363772000065
							],
							[
								-82.6364084889999,
								27.70723035900005
							],
							[
								-82.63654048899991,
								27.706988358000046
							],
							[
								-82.63659702599995,
								27.706897916000063
							],
							[
								-82.6370810109999,
								27.70621712600007
							],
							[
								-82.63687908599991,
								27.70610011100007
							],
							[
								-82.63681877399995,
								27.706061884000064
							],
							[
								-82.6367616849999,
								27.706018992000057
							],
							[
								-82.63670817799994,
								27.70597170600007
							],
							[
								-82.63665859199996,
								27.70592032400009
							],
							[
								-82.63661323899994,
								27.70586517000004
							],
							[
								-82.6364192389999,
								27.70560917000006
							],
							[
								-82.63635716499994,
								27.70551566100005
							],
							[
								-82.63631931999993,
								27.70544258100006
							],
							[
								-82.63623631999991,
								27.705262581000056
							],
							[
								-82.63620686599995,
								27.705190693000077
							],
							[
								-82.63618372699995,
								27.70511653200009
							],
							[
								-82.63616707499995,
								27.705040650000058
							],
							[
								-82.6361570329999,
								27.704963615000054
							],
							[
								-82.63615367799991,
								27.704886000000045
							],
							[
								-82.63615367799991,
								27.70465100000007
							],
							[
								-82.63615672899994,
								27.70457697800009
							],
							[
								-82.63616586299992,
								27.70450345900008
							],
							[
								-82.6361810169999,
								27.704430941000055
							],
							[
								-82.63620208799995,
								27.70435991700009
							],
							[
								-82.63622893399992,
								27.704290868000044
							],
							[
								-82.63626137199992,
								27.70422426300007
							],
							[
								-82.63639937199991,
								27.703968262000046
							],
							[
								-82.63643327199992,
								27.70391061500004
							],
							[
								-82.63647136199995,
								27.70385564700007
							],
							[
								-82.6365134319999,
								27.70380366100005
							],
							[
								-82.63655924799991,
								27.70375494500007
							],
							[
								-82.63660855799992,
								27.70370976900006
							],
							[
								-82.63664855799993,
								27.703675769000085
							],
							[
								-82.63666839099994,
								27.703659393000066
							],
							[
								-82.63698639199993,
								27.70340439300009
							],
							[
								-82.63704262699991,
								27.70336278600007
							],
							[
								-82.63710192699995,
								27.70332567600008
							],
							[
								-82.63716393099992,
								27.703293287000065
							],
							[
								-82.63722826599991,
								27.703265816000055
							],
							[
								-82.6372945409999,
								27.703243428000064
							],
							[
								-82.63749453999992,
								27.703184428000043
							],
							[
								-82.6376413509999,
								27.703154144000052
							],
							[
								-82.63778235099994,
								27.70313714400004
							],
							[
								-82.6378491879999,
								27.703131604000077
							],
							[
								-82.63791625099992,
								27.70313106100008
							],
							[
								-82.63798316799995,
								27.703135517000078
							],
							[
								-82.63804956699994,
								27.703144947000055
							],
							[
								-82.63811507899993,
								27.703159299000053
							],
							[
								-82.63840907899993,
								27.703235299000085
							],
							[
								-82.63847944499992,
								27.70325659300005
							],
							[
								-82.63854783699992,
								27.70328356300007
							],
							[
								-82.63861379699995,
								27.703316029000064
							],
							[
								-82.63867688599994,
								27.70335377400005
							],
							[
								-82.63873667999991,
								27.70339654600008
							],
							[
								-82.63892780799995,
								27.703545439000038
							],
							[
								-82.63894976299991,
								27.70347392900004
							],
							[
								-82.63897772999991,
								27.703404549000087
							],
							[
								-82.63901150299995,
								27.703337803000068
							],
							[
								-82.63905083799995,
								27.703274176000036
							],
							[
								-82.63909544899992,
								27.70321413000005
							],
							[
								-82.63914501199991,
								27.703158102000092
							],
							[
								-82.63919916599991,
								27.703106498000068
							],
							[
								-82.63932616699992,
								27.702994498000066
							],
							[
								-82.63938246499993,
								27.702948546000073
							],
							[
								-82.6394424149999,
								27.70290747300004
							],
							[
								-82.63950559699992,
								27.70287156900008
							],
							[
								-82.63957156499993,
								27.702841085000045
							],
							[
								-82.63963985599992,
								27.702816237000036
							],
							[
								-82.63970998799995,
								27.70279719800004
							],
							[
								-82.63975233899993,
								27.70277116400007
							],
							[
								-82.63989441399991,
								27.702704914000037
							],
							[
								-82.64004583499991,
								27.70266434100006
							],
							[
								-82.64020199999993,
								27.702650678000055
							],
							[
								-82.64032283599994,
								27.702658833000044
							],
							[
								-82.64056341799994,
								27.702689604000057
							],
							[
								-82.64063510499994,
								27.702682189000086
							],
							[
								-82.64070715899993,
								27.702680636000082
							],
							[
								-82.64077909899993,
								27.702684955000052
							],
							[
								-82.64085044899991,
								27.702695119000055
							],
							[
								-82.6409207339999,
								27.70271105900008
							],
							[
								-82.64100168999994,
								27.702688829000067
							],
							[
								-82.64127568999993,
								27.702629829000045
							],
							[
								-82.64135569599995,
								27.70261634500008
							],
							[
								-82.6414908189999,
								27.70259980000009
							],
							[
								-82.64203398599994,
								27.702518569000063
							],
							[
								-82.64209357399994,
								27.702511680000043
							],
							[
								-82.64242705599992,
								27.702484362000064
							],
							[
								-82.64248978899991,
								27.702476319000084
							],
							[
								-82.64271073499994,
								27.702366147000077
							],
							[
								-82.64293490799992,
								27.702247355000054
							],
							[
								-82.6430484139999,
								27.70219691400007
							],
							[
								-82.64315532199994,
								27.702165354000044
							],
							[
								-82.64343675799995,
								27.70210092900004
							],
							[
								-82.64360127299994,
								27.70168335200009
							],
							[
								-82.64365916399994,
								27.701563339000074
							],
							[
								-82.64374907899992,
								27.701434927000037
							],
							[
								-82.64385992699994,
								27.701324080000063
							],
							[
								-82.64398833899992,
								27.701234165000074
							],
							[
								-82.64404570499994,
								27.70120375100004
							],
							[
								-82.64440670499994,
								27.70102875100008
							],
							[
								-82.6444914139999,
								27.70099291400004
							],
							[
								-82.64456779799991,
								27.70096890600007
							],
							[
								-82.64487979799992,
								27.700885905000064
							],
							[
								-82.64496410499993,
								27.700867756000036
							],
							[
								-82.64572631199992,
								27.700741623000056
							],
							[
								-82.6461281789999,
								27.700681710000083
							],
							[
								-82.64632876899992,
								27.70063863100006
							],
							[
								-82.64655236899995,
								27.700552144000085
							],
							[
								-82.6468509629999,
								27.70041292200006
							],
							[
								-82.6469948539999,
								27.70036023600005
							],
							[
								-82.64729985399993,
								27.700277235000048
							],
							[
								-82.64737983499992,
								27.70025934100005
							],
							[
								-82.6474873969999,
								27.700246992000075
							],
							[
								-82.64785617799993,
								27.700227032000043
							],
							[
								-82.64862747599994,
								27.70015208500007
							],
							[
								-82.64874082699993,
								27.700135274000047
							],
							[
								-82.6494084069999,
								27.69987507500008
							],
							[
								-82.64947544299991,
								27.69985194800006
							],
							[
								-82.64954409199993,
								27.699834174000046
							],
							[
								-82.64961392799995,
								27.699821865000047
							],
							[
								-82.64968451599992,
								27.699815096000066
							],
							[
								-82.64993351599992,
								27.699801096000044
							],
							[
								-82.65002736699995,
								27.699800724000056
							],
							[
								-82.65017236699993,
								27.699807725000085
							],
							[
								-82.65029768799991,
								27.699822641000083
							],
							[
								-82.6504702069999,
								27.69985558500008
							],
							[
								-82.6505107399999,
								27.699801261000065
							],
							[
								-82.6505556329999,
								27.69975048000009
							],
							[
								-82.65060457799991,
								27.69970359200005
							],
							[
								-82.65065723799995,
								27.699660919000053
							],
							[
								-82.65079623799994,
								27.69955692000008
							],
							[
								-82.6508853389999,
								27.69949816500008
							],
							[
								-82.65098125299994,
								27.69945017300006
							],
							[
								-82.6511752529999,
								27.69936717300004
							],
							[
								-82.65124004899991,
								27.69934236200004
							],
							[
								-82.65130656499991,
								27.69932262000009
							],
							[
								-82.6513744049999,
								27.699308065000082
							],
							[
								-82.65144316499993,
								27.699298784000064
							],
							[
								-82.6515124359999,
								27.69929483100009
							],
							[
								-82.65189243599991,
								27.69928783000006
							],
							[
								-82.65191998699994,
								27.69928774500005
							],
							[
								-82.65249305099991,
								27.699294746000078
							],
							[
								-82.65330211499992,
								27.699304746000053
							],
							[
								-82.65333183699994,
								27.699305605000063
							],
							[
								-82.65379383599993,
								27.699326605000067
							],
							[
								-82.6538428419999,
								27.699330177000036
							],
							[
								-82.65483884199995,
								27.699430177000067
							],
							[
								-82.65488224899991,
								27.699435604000087
							],
							[
								-82.65543624999992,
								27.699518604000048
							],
							[
								-82.65557921699993,
								27.699552147000077
							],
							[
								-82.6559478399999,
								27.699671116000047
							],
							[
								-82.65700604099993,
								27.699905425000054
							],
							[
								-82.65758766699992,
								27.700030906000052
							],
							[
								-82.65763122399994,
								27.700041445000068
							],
							[
								-82.6581712229999,
								27.70018644600009
							],
							[
								-82.65824558599991,
								27.700209914000084
							],
							[
								-82.6583221599999,
								27.700241858000084
							],
							[
								-82.65861850499994,
								27.700381862000086
							],
							[
								-82.65883339699991,
								27.70043306000008
							],
							[
								-82.65922310699995,
								27.700513726000057
							],
							[
								-82.66096025099995,
								27.70088082300009
							],
							[
								-82.66232756599993,
								27.701180536000038
							],
							[
								-82.66237855999992,
								27.70119328700008
							],
							[
								-82.66306455999995,
								27.70138628700005
							],
							[
								-82.66312858599991,
								27.701406913000085
							],
							[
								-82.6632706609999,
								27.70147316400005
							],
							[
								-82.66339907299994,
								27.70156307900004
							],
							[
								-82.66350991999991,
								27.70167392700006
							],
							[
								-82.66355757399992,
								27.701740142000062
							],
							[
								-82.66569909399993,
								27.702518114000046
							],
							[
								-82.66685974299992,
								27.70296808900008
							],
							[
								-82.66728010299994,
								27.70306478000009
							],
							[
								-82.6674804619999,
								27.70309686900004
							],
							[
								-82.66776783899991,
								27.703125939000074
							],
							[
								-82.67010701399994,
								27.70319102600007
							],
							[
								-82.67017942599995,
								27.70319597100007
							],
							[
								-82.6704914259999,
								27.703229970000052
							],
							[
								-82.67055016599994,
								27.70323834000004
							],
							[
								-82.67070973499995,
								27.703281969000045
							],
							[
								-82.67093288399991,
								27.70336802500009
							],
							[
								-82.6709990089999,
								27.703396646000044
							],
							[
								-82.67118600899994,
								27.703486646000044
							],
							[
								-82.67124566099994,
								27.70351816400006
							],
							[
								-82.67135517399993,
								27.703592653000044
							],
							[
								-82.67148617499993,
								27.703696653000065
							],
							[
								-82.67153902599995,
								27.703742058000046
							],
							[
								-82.67158820299994,
								27.703791417000048
							],
							[
								-82.6716334109999,
								27.703844436000054
							],
							[
								-82.67170012699995,
								27.70392911400006
							],
							[
								-82.67174106099992,
								27.703923059000093
							],
							[
								-82.6719080609999,
								27.703903059000083
							],
							[
								-82.67201499999993,
								27.703896678000035
							],
							[
								-82.6720658719999,
								27.703898118000044
							],
							[
								-82.67241887199992,
								27.703918118000047
							],
							[
								-82.67256331499993,
								27.703938143000073
							],
							[
								-82.6733903139999,
								27.704122143000063
							],
							[
								-82.67343919399991,
								27.704134466000085
							],
							[
								-82.67407719499994,
								27.70431446600009
							],
							[
								-82.67413987399993,
								27.704334655000082
							],
							[
								-82.67420090899992,
								27.70435937600007
							],
							[
								-82.67425996999992,
								27.70438849700008
							],
							[
								-82.6743167429999,
								27.70442186200006
							],
							[
								-82.67437092099993,
								27.704459291000035
							],
							[
								-82.67450892199992,
								27.70456229100006
							],
							[
								-82.67454907299992,
								27.70459407900006
							],
							[
								-82.67464075899994,
								27.70468283000008
							],
							[
								-82.67470975799995,
								27.704759830000057
							],
							[
								-82.67473075099991,
								27.704784542000084
							],
							[
								-82.67512051899992,
								27.704805683000075
							],
							[
								-82.67612213799993,
								27.70485266600008
							],
							[
								-82.67617563899995,
								27.704856778000078
							],
							[
								-82.67636263899993,
								27.704876778000084
							],
							[
								-82.6764143979999,
								27.704884100000076
							],
							[
								-82.67641646099993,
								27.704851399000063
							],
							[
								-82.6764243209999,
								27.704776652000078
							],
							[
								-82.67643839599994,
								27.70470282100007
							],
							[
								-82.67645858599991,
								27.704630424000072
							],
							[
								-82.67648475199991,
								27.70455996600009
							],
							[
								-82.67651670899994,
								27.704491938000047
							],
							[
								-82.67655423499991,
								27.70442681700007
							],
							[
								-82.67659143899994,
								27.704368078000073
							],
							[
								-82.67671626499992,
								27.704169525000054
							],
							[
								-82.67674010099995,
								27.70412185300006
							],
							[
								-82.6767316829999,
								27.701807019000057
							],
							[
								-82.67672974699991,
								27.70117796900007
							],
							[
								-82.67653811699995,
								27.697365227000034
							],
							[
								-82.67642050599994,
								27.695523307000087
							],
							[
								-82.67641867799995,
								27.69546600000007
							],
							[
								-82.67642869799994,
								27.69533212400006
							],
							[
								-82.67645669899991,
								27.695146125000065
							],
							[
								-82.67646938799993,
								27.69507917600004
							],
							[
								-82.67648710899994,
								27.69501338100008
							],
							[
								-82.67650976099992,
								27.69494911600009
							],
							[
								-82.67656476099995,
								27.694810116000042
							],
							[
								-82.6765956129999,
								27.694740813000067
							],
							[
								-82.6766322009999,
								27.694674361000068
							],
							[
								-82.6766742659999,
								27.694611233000046
							],
							[
								-82.67672150699991,
								27.694551879000073
							],
							[
								-82.67677358799995,
								27.694496722000054
							],
							[
								-82.67683013599992,
								27.694446157000073
							],
							[
								-82.67688100499993,
								27.694405117000088
							],
							[
								-82.67694367599995,
								27.694354014000055
							],
							[
								-82.6770041019999,
								27.69430882800009
							],
							[
								-82.67706810199991,
								27.694268865000083
							],
							[
								-82.67713522699995,
								27.694234408000057
							],
							[
								-82.67720500399992,
								27.694205699000065
							],
							[
								-82.67727694199993,
								27.694182940000076
							],
							[
								-82.67735053399991,
								27.694166291000048
							],
							[
								-82.67761353399993,
								27.69411829200004
							],
							[
								-82.67763814799991,
								27.694113345000066
							],
							[
								-82.67770416399992,
								27.693969339000034
							],
							[
								-82.67778428899993,
								27.69385279900007
							],
							[
								-82.67783618399996,
								27.693788863000066
							],
							[
								-82.67795192699992,
								27.693672080000056
							],
							[
								-82.6780803389999,
								27.693582164000077
							],
							[
								-82.67822241399995,
								27.693515914000045
							],
							[
								-82.6783738339999,
								27.693475341000067
							],
							[
								-82.67843026399993,
								27.693467226000053
							],
							[
								-82.67866326399991,
								27.693441225000072
							],
							[
								-82.67880240799991,
								27.693436542000086
							],
							[
								-82.67882550999991,
								27.69343755500006
							],
							[
								-82.67898377799992,
								27.69340745100004
							],
							[
								-82.67914599999996,
								27.693392678000066
							],
							[
								-82.67930216499991,
								27.693406340000084
							],
							[
								-82.67945358599991,
								27.69344691300006
							],
							[
								-82.67959566099996,
								27.69351316400008
							],
							[
								-82.67972407299993,
								27.69360307900007
							],
							[
								-82.67976450299994,
								27.69363913400008
							],
							[
								-82.67985950399992,
								27.69372913400008
							],
							[
								-82.67992992099994,
								27.693803927000094
							],
							[
								-82.68002211599993,
								27.693936336000036
							],
							[
								-82.68015611699991,
								27.694173967000044
							],
							[
								-82.6801817249999,
								27.69421703500007
							],
							[
								-82.68021399399993,
								27.694277157000048
							],
							[
								-82.68024160999994,
								27.694339553000077
							],
							[
								-82.68026441499991,
								27.694403864000037
							],
							[
								-82.6802822759999,
								27.69446971900004
							],
							[
								-82.68029509199994,
								27.694536739000057
							],
							[
								-82.68030278799995,
								27.69460453800008
							],
							[
								-82.6804742949999,
								27.69688440100009
							],
							[
								-82.6808323649999,
								27.699270540000043
							],
							[
								-82.6808415669999,
								27.699367146000043
							],
							[
								-82.68086256599992,
								27.699879146000058
							],
							[
								-82.68086315999994,
								27.699898946000076
							],
							[
								-82.68087416999992,
								27.700479488000042
							],
							[
								-82.6808871799999,
								27.701212032000058
							],
							[
								-82.68088707699991,
								27.701248971000044
							],
							[
								-82.68080867499992,
								27.704610333000062
							],
							[
								-82.68082080499994,
								27.704970194000055
							],
							[
								-82.68092371699993,
								27.705044342000065
							],
							[
								-82.6809984329999,
								27.70510447800007
							],
							[
								-82.68153143399991,
								27.705582478000053
							],
							[
								-82.6815553429999,
								27.70560471600004
							],
							[
								-82.68195034299993,
								27.705985716000043
							],
							[
								-82.6819988449999,
								27.706036293000068
							],
							[
								-82.68204326299991,
								27.706090492000047
							],
							[
								-82.68208332499995,
								27.706147986000076
							],
							[
								-82.68211878999995,
								27.706208424000067
							],
							[
								-82.68214944099992,
								27.70627143900009
							],
							[
								-82.68232243999995,
								27.70666544000005
							],
							[
								-82.68234408599994,
								27.706719414000077
							],
							[
								-82.68237872399995,
								27.70684027600004
							],
							[
								-82.68247572399991,
								27.707297275000087
							],
							[
								-82.6824816589999,
								27.70732783400007
							],
							[
								-82.68249532199991,
								27.70748400000008
							],
							[
								-82.68249532199991,
								27.707588000000044
							],
							[
								-82.6824816589999,
								27.707744166000055
							],
							[
								-82.68244100299995,
								27.707895815000086
							],
							[
								-82.68240398599995,
								27.70799618800004
							],
							[
								-82.68249823499991,
								27.70814721000005
							],
							[
								-82.6826571439999,
								27.70832910100006
							],
							[
								-82.68272265199994,
								27.708385476000046
							],
							[
								-82.6833434799999,
								27.70867519600006
							],
							[
								-82.68376052799994,
								27.708831484000086
							],
							[
								-82.68454766499991,
								27.709025920000045
							],
							[
								-82.68461443899992,
								27.70904518000009
							],
							[
								-82.68467952499992,
								27.70906953800005
							],
							[
								-82.68474253699992,
								27.70909885000009
							],
							[
								-82.68480309599994,
								27.709132939000085
							],
							[
								-82.68486084299991,
								27.709171603000073
							],
							[
								-82.68524184299991,
								27.709448604000045
							],
							[
								-82.68529107299992,
								27.70948707900004
							],
							[
								-82.68540695799993,
								27.709604039000055
							],
							[
								-82.68544572299993,
								27.709651815000086
							],
							[
								-82.68549146999993,
								27.709708215000035
							],
							[
								-82.68545206899995,
								27.710072812000078
							],
							[
								-82.68541690199993,
								27.71032777000005
							],
							[
								-82.68532019399993,
								27.710679436000078
							],
							[
								-82.6851883189999,
								27.710995936000074
							],
							[
								-82.68495094399992,
								27.711303644000054
							],
							[
								-82.68470477799991,
								27.711567394000046
							],
							[
								-82.68444102799992,
								27.711804769000082
							],
							[
								-82.68407177799992,
								27.71201576800007
							],
							[
								-82.68365856999992,
								27.71218281000006
							],
							[
								-82.6833860289999,
								27.712428976000073
							],
							[
								-82.68287611199992,
								27.71289493400008
							],
							[
								-82.68251565399993,
								27.713246601000037
							],
							[
								-82.68215519599994,
								27.71351035100008
							],
							[
								-82.68196177999995,
								27.713642226000047
							],
							[
								-82.68175957199992,
								27.71367739200008
							],
							[
								-82.6815309879999,
								27.71367739200008
							],
							[
								-82.68128482199995,
								27.713659809000035
							],
							[
								-82.68069578099994,
								27.71356310100009
							],
							[
								-82.68030015599993,
								27.713492767000048
							],
							[
								-82.68020344799993,
								27.713545517000057
							],
							[
								-82.67998199999994,
								27.713782000000037
							],
							[
								-82.6793199999999,
								27.713926877000063
							],
							[
								-82.67933397999991,
								27.715020864000053
							],
							[
								-82.67929873599992,
								27.715918226000042
							],
							[
								-82.67926769299993,
								27.716331522000075
							],
							[
								-82.67924688199992,
								27.716615953000087
							],
							[
								-82.67909716199995,
								27.71731284400005
							],
							[
								-82.67890471099992,
								27.71796365000006
							],
							[
								-82.67873934499994,
								27.718458267000074
							],
							[
								-82.6786444089999,
								27.718743172000075
							],
							[
								-82.67854999999992,
								27.71905000000004
							],
							[
								-82.67832516399994,
								27.719072484000037
							],
							[
								-82.67810754699991,
								27.71909273900008
							],
							[
								-82.67768999999993,
								27.71912000000009
							],
							[
								-82.6774932749999,
								27.71912915000007
							],
							[
								-82.6772102139999,
								27.719141810000053
							],
							[
								-82.67688175399991,
								27.719153754000047
							],
							[
								-82.6765747629999,
								27.719160000000045
							],
							[
								-82.67598425499995,
								27.719161503000066
							],
							[
								-82.67548099799991,
								27.719166691000055
							],
							[
								-82.67515882399994,
								27.71916843200006
							],
							[
								-82.67486864599994,
								27.719170000000076
							],
							[
								-82.67381870299994,
								27.719171861000063
							],
							[
								-82.6729874209999,
								27.719176531000073
							],
							[
								-82.67193767999993,
								27.719183377000036
							],
							[
								-82.67156568599995,
								27.719186284000045
							],
							[
								-82.67080015699992,
								27.719193535000045
							],
							[
								-82.67023150999995,
								27.719200000000058
							],
							[
								-82.66907222599991,
								27.719200000000058
							],
							[
								-82.66839419399992,
								27.719201656000052
							],
							[
								-82.66806587699995,
								27.71920566000006
							],
							[
								-82.66670988699991,
								27.719213598000067
							],
							[
								-82.66500379299993,
								27.71921973500008
							],
							[
								-82.6634508329999,
								27.719225803000086
							],
							[
								-82.6621385119999,
								27.719230137000068
							],
							[
								-82.66165710799993,
								27.719235868000055
							],
							[
								-82.66113222599996,
								27.71924230900004
							],
							[
								-82.66065081099993,
								27.719248561000086
							],
							[
								-82.6601478099999,
								27.719255093000072
							],
							[
								-82.65922924699993,
								27.71927000000005
							],
							[
								-82.65868241499993,
								27.71927000000005
							],
							[
								-82.65800447499993,
								27.719272769000042
							],
							[
								-82.65776359599994,
								27.719276364000052
							],
							[
								-82.65741376499994,
								27.719280000000083
							],
							[
								-82.6565825799999,
								27.719280000000083
							],
							[
								-82.65599166099992,
								27.719291544000043
							],
							[
								-82.65551078899995,
								27.719300000000093
							],
							[
								-82.65465999999992,
								27.719300000000093
							],
							[
								-82.65435146099992,
								27.719304976000046
							],
							[
								-82.65403999999995,
								27.719310000000064
							],
							[
								-82.65378279899994,
								27.719310000000064
							],
							[
								-82.65330158699993,
								27.719310000000064
							],
							[
								-82.6528199999999,
								27.719310000000064
							],
							[
								-82.6525580199999,
								27.719314678000046
							],
							[
								-82.65238269899993,
								27.719317809000074
							],
							[
								-82.6522599999999,
								27.71932000000004
							],
							[
								-82.65194544299993,
								27.71932000000004
							],
							[
								-82.65122362499994,
								27.71932000000004
							],
							[
								-82.6504799999999,
								27.71932000000004
							],
							[
								-82.65004246699993,
								27.71932000000004
							],
							[
								-82.64824873299995,
								27.719323531000043
							],
							[
								-82.64744999999994,
								27.719340000000045
							],
							[
								-82.64711185899995,
								27.71934768500006
							],
							[
								-82.64676206699994,
								27.719355635000056
							],
							[
								-82.64653412799993,
								27.719376740000087
							],
							[
								-82.64641999999992,
								27.719430000000045
							],
							[
								-82.6464191789999,
								27.719429992000073
							],
							[
								-82.64619287999994,
								27.71942775100007
							],
							[
								-82.6458864679999,
								27.719424718000084
							],
							[
								-82.64540999999991,
								27.719420000000074
							],
							[
								-82.64514285199994,
								27.719420000000074
							],
							[
								-82.64483662599991,
								27.719420000000074
							],
							[
								-82.64451999999994,
								27.719420000000074
							],
							[
								-82.64411485999995,
								27.719423376000066
							],
							[
								-82.64383034399994,
								27.71942574700006
							],
							[
								-82.64358975499994,
								27.71942775200006
							],
							[
								-82.6433199999999,
								27.719430000000045
							],
							[
								-82.64288990299991,
								27.719430000000045
							],
							[
								-82.6425099999999,
								27.719430000000045
							],
							[
								-82.64210246499994,
								27.719430000000045
							],
							[
								-82.64116191399995,
								27.719430000000045
							],
							[
								-82.64080999999993,
								27.719430000000045
							],
							[
								-82.64063623299995,
								27.719434827000043
							],
							[
								-82.64044999999993,
								27.719440000000077
							],
							[
								-82.64022119299995,
								27.719442061000052
							],
							[
								-82.63974001999992,
								27.71944639600008
							],
							[
								-82.63933999999995,
								27.71945000000005
							],
							[
								-82.6389526449999,
								27.719453521000048
							],
							[
								-82.63823999999994,
								27.719460000000083
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Greater Pinellas Point",
				"RegionID": "416184"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.64645999999993,
					27.718611603000056,
					-82.63448460299992,
					27.727590000000077
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.63825638899993,
							27.72699790100006
						],
						[
							-82.63824999999991,
							27.726425282000037
						],
						[
							-82.63824999999991,
							27.725596394000036
						],
						[
							-82.63824999999991,
							27.72509906100004
						],
						[
							-82.63824604799993,
							27.724631772000066
						],
						[
							-82.63824218499991,
							27.72433040800007
						],
						[
							-82.63824091599992,
							27.72405920700004
						],
						[
							-82.63824447799993,
							27.723667401000057
						],
						[
							-82.6382465339999,
							27.723441222000076
						],
						[
							-82.63824817799991,
							27.723260389000075
						],
						[
							-82.63824999999991,
							27.72306000000009
						],
						[
							-82.63824741699995,
							27.722868884000036
						],
						[
							-82.63824415399995,
							27.72262739000007
						],
						[
							-82.6382425249999,
							27.72250684700009
						],
						[
							-82.63823999999994,
							27.72232000000008
						],
						[
							-82.63811341199994,
							27.722396857000035
						],
						[
							-82.63792275299994,
							27.72250738200006
						],
						[
							-82.63770860699992,
							27.72260731700004
						],
						[
							-82.6375530759999,
							27.722671124000044
						],
						[
							-82.63747060899993,
							27.722689898000056
						],
						[
							-82.63733191799992,
							27.722713356000042
						],
						[
							-82.6370842259999,
							27.72275572400008
						],
						[
							-82.63688289499993,
							27.72279016300007
						],
						[
							-82.63678392199995,
							27.72280709200004
						],
						[
							-82.63664999999992,
							27.722830000000044
						],
						[
							-82.63651696999995,
							27.72285558300007
						],
						[
							-82.63635773499993,
							27.722900166000045
						],
						[
							-82.6357217929999,
							27.722954315000038
						],
						[
							-82.63535886999995,
							27.722900549000087
						],
						[
							-82.63451664699994,
							27.722577903000058
						],
						[
							-82.63480126999991,
							27.721975876000045
						],
						[
							-82.63506775399992,
							27.721412600000065
						],
						[
							-82.6350274539999,
							27.721335872000054
						],
						[
							-82.6349794539999,
							27.72123187300008
						],
						[
							-82.63495244699993,
							27.721166768000046
						],
						[
							-82.6349306219999,
							27.72109974700004
						],
						[
							-82.63491411199993,
							27.721031224000058
						],
						[
							-82.63490301999991,
							27.720961617000057
						],
						[
							-82.63489741299992,
							27.72089135600004
						],
						[
							-82.63489041299994,
							27.720718356000077
						],
						[
							-82.63489016499994,
							27.720652398000084
						],
						[
							-82.63489475299991,
							27.72058660000005
						],
						[
							-82.6349041499999,
							27.720521314000052
						],
						[
							-82.63491830699991,
							27.720456893000062
						],
						[
							-82.63493714799995,
							27.720393682000065
						],
						[
							-82.63500502799991,
							27.720193126000083
						],
						[
							-82.63493308299991,
							27.71978671700009
						],
						[
							-82.6348854869999,
							27.71972173200004
						],
						[
							-82.63481553199995,
							27.71963992900004
						],
						[
							-82.63464153699994,
							27.71947657100009
						],
						[
							-82.63448460299992,
							27.71934555300004
						],
						[
							-82.6350367039999,
							27.718634945000076
						],
						[
							-82.63605923799992,
							27.718623282000067
						],
						[
							-82.63708309099991,
							27.718611603000056
						],
						[
							-82.63823101899993,
							27.71864275200005
						],
						[
							-82.63823610999992,
							27.719106003000036
						],
						[
							-82.6382379069999,
							27.719269531000066
						],
						[
							-82.63823999999994,
							27.719460000000083
						],
						[
							-82.6389526449999,
							27.719453521000048
						],
						[
							-82.63933999999995,
							27.71945000000005
						],
						[
							-82.63974001999992,
							27.71944639600008
						],
						[
							-82.64022119299995,
							27.719442061000052
						],
						[
							-82.64044999999993,
							27.719440000000077
						],
						[
							-82.64063623299995,
							27.719434827000043
						],
						[
							-82.64080999999993,
							27.719430000000045
						],
						[
							-82.64116191399995,
							27.719430000000045
						],
						[
							-82.64210246499994,
							27.719430000000045
						],
						[
							-82.6425099999999,
							27.719430000000045
						],
						[
							-82.64288990299991,
							27.719430000000045
						],
						[
							-82.6433199999999,
							27.719430000000045
						],
						[
							-82.64358975499994,
							27.71942775200006
						],
						[
							-82.64383034399994,
							27.71942574700006
						],
						[
							-82.64411485999995,
							27.719423376000066
						],
						[
							-82.64451999999994,
							27.719420000000074
						],
						[
							-82.64483662599991,
							27.719420000000074
						],
						[
							-82.64514285199994,
							27.719420000000074
						],
						[
							-82.64540999999991,
							27.719420000000074
						],
						[
							-82.6458864679999,
							27.719424718000084
						],
						[
							-82.64619287999994,
							27.71942775100007
						],
						[
							-82.6464191789999,
							27.719429992000073
						],
						[
							-82.64641999999992,
							27.71971882500009
						],
						[
							-82.64641999999992,
							27.720095592000064
						],
						[
							-82.6464213729999,
							27.720442222000088
						],
						[
							-82.6464239149999,
							27.720668424000053
						],
						[
							-82.64642527099994,
							27.720789143000047
						],
						[
							-82.64642747199991,
							27.720985037000048
						],
						[
							-82.64643295799993,
							27.721482138000056
						],
						[
							-82.64643852699993,
							27.72199448100008
						],
						[
							-82.64644298199994,
							27.72240134000009
						],
						[
							-82.6464453019999,
							27.72261247000006
						],
						[
							-82.64644844999992,
							27.722898944000065
						],
						[
							-82.64644900899992,
							27.723154917000045
						],
						[
							-82.64644641099994,
							27.72345630800004
						],
						[
							-82.64644485099991,
							27.723637273000065
						],
						[
							-82.6464432919999,
							27.723818108000046
						],
						[
							-82.6464401739999,
							27.724179778000064
						],
						[
							-82.64644615599991,
							27.724301578000052
						],
						[
							-82.64645531199994,
							27.724452643000063
						],
						[
							-82.64645999999993,
							27.724631870000053
						],
						[
							-82.64645999999993,
							27.725008637000087
						],
						[
							-82.64644902299995,
							27.725152605000062
						],
						[
							-82.64642241799993,
							27.725223552000045
						],
						[
							-82.64641999999992,
							27.725230000000067
						],
						[
							-82.64637432699993,
							27.725298509000083
						],
						[
							-82.64631777599995,
							27.725386352000044
						],
						[
							-82.6461328229999,
							27.72559360400004
						],
						[
							-82.64602999999994,
							27.725690000000043
						],
						[
							-82.64593503899994,
							27.725761221000084
						],
						[
							-82.64580937699992,
							27.725854669000057
						],
						[
							-82.64570244799995,
							27.72593345900009
						],
						[
							-82.64556113799995,
							27.72606187000008
						],
						[
							-82.64547050899995,
							27.726152312000067
						],
						[
							-82.6453699999999,
							27.72626000000008
						],
						[
							-82.64531895899995,
							27.72631742100009
						],
						[
							-82.64527826799991,
							27.726373464000062
						],
						[
							-82.64523999999994,
							27.72645000000006
						],
						[
							-82.64522056499993,
							27.726496159000078
						],
						[
							-82.64517829599993,
							27.726596547000042
						],
						[
							-82.6451368779999,
							27.726694915000053
						],
						[
							-82.64507999999995,
							27.726830000000064
						],
						[
							-82.64497519299994,
							27.726800865000087
						],
						[
							-82.64486949999991,
							27.72679000000005
						],
						[
							-82.64467322599995,
							27.72679903200009
						],
						[
							-82.64454905699995,
							27.726820314000065
						],
						[
							-82.6444130189999,
							27.72686998900008
						],
						[
							-82.64425999999992,
							27.726960000000076
						],
						[
							-82.64417876699991,
							27.72700275400007
						],
						[
							-82.64411913799995,
							27.72703413800008
						],
						[
							-82.64402969499992,
							27.727081213000076
						],
						[
							-82.64392782899995,
							27.727134827000043
						],
						[
							-82.6438245249999,
							27.72717902000005
						],
						[
							-82.64370739499992,
							27.727219179000087
						],
						[
							-82.6435721549999,
							27.72726554700006
						],
						[
							-82.64343666999991,
							27.727311110000073
						],
						[
							-82.64328731299992,
							27.72736064500009
						],
						[
							-82.64314538399992,
							27.72739470800008
						],
						[
							-82.64295536999992,
							27.727434105000047
						],
						[
							-82.64274519499992,
							27.727469134000046
						],
						[
							-82.64256158199993,
							27.727493895000066
						],
						[
							-82.64233752199993,
							27.72750883200007
						],
						[
							-82.64216999999991,
							27.727520000000084
						],
						[
							-82.6419909569999,
							27.727522776000058
						],
						[
							-82.6417950849999,
							27.727525813000057
						],
						[
							-82.64155401199992,
							27.727529550000042
						],
						[
							-82.64126750399993,
							27.72753399200008
						],
						[
							-82.64096616299992,
							27.727538664000065
						],
						[
							-82.64083007799991,
							27.727553867000044
						],
						[
							-82.64069999999992,
							27.727590000000077
						],
						[
							-82.64069801799991,
							27.727590000000077
						],
						[
							-82.64063463599992,
							27.727590000000077
						],
						[
							-82.64048392899991,
							27.727590000000077
						],
						[
							-82.64016744499992,
							27.727590000000077
						],
						[
							-82.63959475899992,
							27.727590000000077
						],
						[
							-82.63899193099991,
							27.727590000000077
						],
						[
							-82.63826999999992,
							27.727590000000077
						],
						[
							-82.63826713099992,
							27.727465192000068
						],
						[
							-82.6382605519999,
							27.72717900000004
						],
						[
							-82.63825638899993,
							27.72699790100006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Bayou Highlands",
				"RegionID": "416186"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.69933820299991,
					27.717712117000076,
					-82.6912658039999,
					27.725015148000068
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.69510472899992,
							27.724693331000083
						],
						[
							-82.69451814399991,
							27.72451480600006
						],
						[
							-82.69150135799993,
							27.72451480600006
						],
						[
							-82.69150529399991,
							27.724255016000086
						],
						[
							-82.6915117069999,
							27.723831746000087
						],
						[
							-82.69175681399992,
							27.723831746000087
						],
						[
							-82.69175681399992,
							27.723333081000078
						],
						[
							-82.69192585299993,
							27.723316177000072
						],
						[
							-82.69190894899992,
							27.721634238000036
						],
						[
							-82.69184978499993,
							27.71974099900007
						],
						[
							-82.69178238699993,
							27.719627649000074
						],
						[
							-82.6917139819999,
							27.719623374000037
						],
						[
							-82.69159622699993,
							27.719620000000077
						],
						[
							-82.6914948029999,
							27.719620000000077
						],
						[
							-82.69143578999991,
							27.71960521500006
						],
						[
							-82.69137344399991,
							27.71958344400008
						],
						[
							-82.69134417899994,
							27.719549521000094
						],
						[
							-82.69131148699996,
							27.719490677000067
						],
						[
							-82.69129301699991,
							27.719428100000073
						],
						[
							-82.69128321199992,
							27.71933533200007
						],
						[
							-82.69127545299995,
							27.719249981000075
						],
						[
							-82.69126999999992,
							27.719190000000083
						],
						[
							-82.69126999999992,
							27.719157814000084
						],
						[
							-82.6912661799999,
							27.71904797700006
						],
						[
							-82.6912658039999,
							27.718982280000034
						],
						[
							-82.69193239899994,
							27.71898309900007
						],
						[
							-82.69315294699993,
							27.718988723000056
						],
						[
							-82.69385131599995,
							27.71897439600008
						],
						[
							-82.69425554799994,
							27.71893827200006
						],
						[
							-82.6947563789999,
							27.71888262500005
						],
						[
							-82.69530279499992,
							27.71877678000004
						],
						[
							-82.69585798499992,
							27.71864420600008
						],
						[
							-82.69634918399993,
							27.718517874000046
						],
						[
							-82.6967331859999,
							27.718358324000064
						],
						[
							-82.69737115399995,
							27.718093253000063
						],
						[
							-82.69773591699993,
							27.717935896000085
						],
						[
							-82.6977369999999,
							27.717937000000063
						],
						[
							-82.6981053689999,
							27.717712117000076
						],
						[
							-82.69895558699994,
							27.71856233500006
						],
						[
							-82.6992937309999,
							27.719217960000037
						],
						[
							-82.69932168399993,
							27.71960316700006
						],
						[
							-82.6993242019999,
							27.71965732700005
						],
						[
							-82.69933820299991,
							27.720515327000044
						],
						[
							-82.69933814599995,
							27.72054783100009
						],
						[
							-82.69932414499993,
							27.72125383100007
						],
						[
							-82.6993187409999,
							27.721336033000057
						],
						[
							-82.69925774099994,
							27.721881033000045
						],
						[
							-82.69924965899992,
							27.721937165000043
						],
						[
							-82.6992207479999,
							27.722054428000035
						],
						[
							-82.69910074799992,
							27.722430428000052
						],
						[
							-82.69907315599994,
							27.722505255000048
						],
						[
							-82.69903904199992,
							27.722577343000072
						],
						[
							-82.69899867599992,
							27.722646126000086
						],
						[
							-82.69895237599991,
							27.72271106200009
						],
						[
							-82.6985753749999,
							27.723193062000064
						],
						[
							-82.69852463199993,
							27.723252433000084
						],
						[
							-82.69806663199995,
							27.72374343300004
						],
						[
							-82.69796989699995,
							27.72383297500005
						],
						[
							-82.69740089699991,
							27.72428697500004
						],
						[
							-82.69732807499992,
							27.724339356000087
						],
						[
							-82.69661307599995,
							27.724801355000068
						],
						[
							-82.69654372699995,
							27.724841894000065
						],
						[
							-82.69647103699992,
							27.724876083000083
						],
						[
							-82.69639558599994,
							27.724903650000044
						],
						[
							-82.69631797699992,
							27.72492437300008
						],
						[
							-82.69623882799993,
							27.72493808900009
						],
						[
							-82.69590182699994,
							27.72498108900004
						],
						[
							-82.69587135199993,
							27.72498445100007
						],
						[
							-82.69555867999992,
							27.725015148000068
						],
						[
							-82.69510472899992,
							27.724693331000083
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Dolphin Cay",
				"RegionID": "416191"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.67113999999992,
					27.752000000000066,
					-82.66295999999994,
					27.755670000000066
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.66301325599994,
							27.752127210000083
						],
						[
							-82.66302999999994,
							27.75201000000004
						],
						[
							-82.66320727099992,
							27.75201000000004
						],
						[
							-82.66339494599993,
							27.75201000000004
						],
						[
							-82.66378735699993,
							27.75201000000004
						],
						[
							-82.6641456449999,
							27.75201000000004
						],
						[
							-82.66426999999993,
							27.75201000000004
						],
						[
							-82.66441861199992,
							27.75201128100008
						],
						[
							-82.66477687399993,
							27.75201437000004
						],
						[
							-82.66496468199995,
							27.752015989000085
						],
						[
							-82.66520352299996,
							27.75201804800008
						],
						[
							-82.6654299999999,
							27.752020000000076
						],
						[
							-82.66561292099993,
							27.752020000000076
						],
						[
							-82.6658688409999,
							27.752020000000076
						],
						[
							-82.66619300699995,
							27.752020000000076
						],
						[
							-82.66653999999994,
							27.752020000000076
						],
						[
							-82.6667046529999,
							27.752016772000047
						],
						[
							-82.66689258999992,
							27.752013086000094
						],
						[
							-82.6670499999999,
							27.75201000000004
						],
						[
							-82.66725080999993,
							27.75201000000004
						],
						[
							-82.66752999999994,
							27.75201000000004
						],
						[
							-82.6677967729999,
							27.75201000000004
						],
						[
							-82.6679499999999,
							27.75201000000004
						],
						[
							-82.6681208949999,
							27.752007054000046
						],
						[
							-82.6683770329999,
							27.75200263700009
						],
						[
							-82.66852999999992,
							27.752000000000066
						],
						[
							-82.66864984099993,
							27.752000000000066
						],
						[
							-82.66874999999993,
							27.752000000000066
						],
						[
							-82.66888845099993,
							27.752003220000063
						],
						[
							-82.66904231699993,
							27.75200679800008
						],
						[
							-82.66928111099992,
							27.75201000000004
						],
						[
							-82.66936641699994,
							27.75201000000004
						],
						[
							-82.66965645999994,
							27.75201000000004
						],
						[
							-82.66991237999991,
							27.75201000000004
						],
						[
							-82.67018536199993,
							27.75201000000004
						],
						[
							-82.6704412819999,
							27.75201000000004
						],
						[
							-82.6707313249999,
							27.75201000000004
						],
						[
							-82.67088487699993,
							27.75201000000004
						],
						[
							-82.67111999999992,
							27.75201000000004
						],
						[
							-82.67112554499995,
							27.752198516000078
						],
						[
							-82.67113589399992,
							27.752550399000086
						],
						[
							-82.67113999999992,
							27.753087037000057
						],
						[
							-82.67113999999992,
							27.753531217000045
						],
						[
							-82.67113999999992,
							27.753810000000044
						],
						[
							-82.67113999999992,
							27.75397539800008
						],
						[
							-82.67113999999992,
							27.754419578000068
						],
						[
							-82.67113999999992,
							27.75467000000009
						],
						[
							-82.67113999999992,
							27.754937789000053
						],
						[
							-82.67113999999992,
							27.755344954000066
						],
						[
							-82.67113999999992,
							27.755600000000072
						],
						[
							-82.6707869729999,
							27.755600000000072
						],
						[
							-82.67034279199993,
							27.755600000000072
						],
						[
							-82.67012999999992,
							27.755600000000072
						],
						[
							-82.66995412299991,
							27.755603483000073
						],
						[
							-82.66975061999996,
							27.75560751200004
						],
						[
							-82.6694542489999,
							27.755613381000046
						],
						[
							-82.66911999999992,
							27.75562000000008
						],
						[
							-82.66884368399991,
							27.75562265700006
						],
						[
							-82.66819598099994,
							27.75562888500008
						],
						[
							-82.66784437099994,
							27.755632288000072
						],
						[
							-82.6675482789999,
							27.755635162000093
						],
						[
							-82.6672333219999,
							27.755638220000037
						],
						[
							-82.66688188499995,
							27.755640828000082
						],
						[
							-82.66575295399991,
							27.75564638900005
						],
						[
							-82.66530878399993,
							27.75564857700005
						],
						[
							-82.6647351279999,
							27.75565277900006
						],
						[
							-82.6644388549999,
							27.755655670000067
						],
						[
							-82.66399471699992,
							27.75566000300006
						],
						[
							-82.66360609599991,
							27.755663794000043
						],
						[
							-82.66334683499991,
							27.755666324000064
						],
						[
							-82.66296999999992,
							27.755670000000066
						],
						[
							-82.66296999999992,
							27.755437492000055
						],
						[
							-82.66296999999992,
							27.755270000000053
						],
						[
							-82.6629672979999,
							27.755178122000075
						],
						[
							-82.66296240299994,
							27.75501169800009
						],
						[
							-82.66295999999994,
							27.75493000000006
						],
						[
							-82.66295999999994,
							27.754752714000066
						],
						[
							-82.66295999999994,
							27.754540000000077
						],
						[
							-82.66295999999994,
							27.754401071000075
						],
						[
							-82.66295999999994,
							27.754210000000057
						],
						[
							-82.66295999999994,
							27.75395689000004
						],
						[
							-82.66295999999994,
							27.753810000000044
						],
						[
							-82.66295999999994,
							27.753623755000035
						],
						[
							-82.66295999999994,
							27.75321659000008
						],
						[
							-82.66295999999994,
							27.75293000000005
						],
						[
							-82.66295999999994,
							27.752809424000077
						],
						[
							-82.66296442899994,
							27.752624710000077
						],
						[
							-82.66297449199993,
							27.752476097000056
						],
						[
							-82.66298687299991,
							27.752327526000045
						],
						[
							-82.6630028909999,
							27.752199760000057
						],
						[
							-82.66301325599994,
							27.752127210000083
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Perkins",
				"RegionID": "416368"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.67946999999992,
					27.758329700000047,
					-82.66300999999993,
					27.77010000000007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.67397999999991,
							27.77010000000007
						],
						[
							-82.67397999999991,
							27.769685543000037
						],
						[
							-82.67261312799991,
							27.769663729000058
						],
						[
							-82.67126691399994,
							27.769682426000088
						],
						[
							-82.66987083899994,
							27.769682426000088
						],
						[
							-82.6685183919999,
							27.769682426000088
						],
						[
							-82.66842490499994,
							27.769663729000058
						],
						[
							-82.66713478199995,
							27.76969489100009
						],
						[
							-82.66576363699994,
							27.76970112400005
						],
						[
							-82.6644111899999,
							27.76970112400005
						],
						[
							-82.66302999999994,
							27.76970112400005
						],
						[
							-82.66302999999994,
							27.769435953000084
						],
						[
							-82.66302999999994,
							27.76924000000008
						],
						[
							-82.66302999999994,
							27.768805626000074
						],
						[
							-82.66302999999994,
							27.76833000000005
						],
						[
							-82.66302555699991,
							27.767930125000078
						],
						[
							-82.6630199999999,
							27.767430000000047
						],
						[
							-82.66301125799993,
							27.766949210000064
						],
						[
							-82.66300999999993,
							27.766500000000065
						],
						[
							-82.66301858999992,
							27.766109172000085
						],
						[
							-82.66302999999994,
							27.76559000000009
						],
						[
							-82.66302531499991,
							27.76516369500007
						],
						[
							-82.6630199999999,
							27.764680000000055
						],
						[
							-82.6630199999999,
							27.76425326900005
						],
						[
							-82.6630199999999,
							27.763780000000054
						],
						[
							-82.6630199999999,
							27.763342797000064
						],
						[
							-82.66300999999993,
							27.76243000000005
						],
						[
							-82.66300999999993,
							27.762428784000065
						],
						[
							-82.66300999999993,
							27.76207000000005
						],
						[
							-82.66320085299992,
							27.76197457300009
						],
						[
							-82.6637011919999,
							27.761793615000045
						],
						[
							-82.66399657499994,
							27.76169955000006
						],
						[
							-82.66541931099994,
							27.761724618000073
						],
						[
							-82.66567965199994,
							27.761701550000055
						],
						[
							-82.6662158709999,
							27.76166419200007
						],
						[
							-82.66686337899995,
							27.761650000000092
						],
						[
							-82.66732591499994,
							27.761646788000068
						],
						[
							-82.66793659399991,
							27.761645461000057
						],
						[
							-82.6684177869999,
							27.761633274000076
						],
						[
							-82.66889919499994,
							27.761581896000052
						],
						[
							-82.66939347599994,
							27.761499305000086
						],
						[
							-82.66991223699995,
							27.76137835900005
						],
						[
							-82.67040107299995,
							27.761218627000062
						],
						[
							-82.6708417449999,
							27.761025215000075
						],
						[
							-82.67103518599993,
							27.76093142500008
						],
						[
							-82.67115999999993,
							27.760870000000068
						],
						[
							-82.67126746899993,
							27.760811266000076
						],
						[
							-82.6714768139999,
							27.76069391100009
						],
						[
							-82.6717483999999,
							27.76052708800006
						],
						[
							-82.6720617709999,
							27.760310434000075
						],
						[
							-82.67232933699995,
							27.76011996300008
						],
						[
							-82.67258675199993,
							27.759936719000052
						],
						[
							-82.6728920239999,
							27.75971940600005
						],
						[
							-82.67307922399993,
							27.75958614500007
						],
						[
							-82.67326300799994,
							27.75945246100008
						],
						[
							-82.67339295499994,
							27.759357166000086
						],
						[
							-82.67357889599992,
							27.759244917000046
						],
						[
							-82.67397703499995,
							27.759021483000083
						],
						[
							-82.67432255599994,
							27.75884280100007
						],
						[
							-82.6745946609999,
							27.75869904700005
						],
						[
							-82.67487705699995,
							27.758553374000087
						],
						[
							-82.67510329699991,
							27.758437292000053
						],
						[
							-82.6752131959999,
							27.758377348000067
						],
						[
							-82.67529881399992,
							27.758329700000047
						],
						[
							-82.67529756099992,
							27.758718282000075
						],
						[
							-82.6752899999999,
							27.75924000000009
						],
						[
							-82.67529999999994,
							27.75965141000006
						],
						[
							-82.67529999999994,
							27.760382733000085
						],
						[
							-82.67529999999994,
							27.760710567000046
						],
						[
							-82.67529999999994,
							27.761038401000064
						],
						[
							-82.67565999999994,
							27.76105000000007
						],
						[
							-82.67585609499992,
							27.76102591900008
						],
						[
							-82.67620959499993,
							27.761012323000045
						],
						[
							-82.67661133199994,
							27.760998612000037
						],
						[
							-82.67681618099994,
							27.76097352900007
						],
						[
							-82.6769931419999,
							27.76095186000009
						],
						[
							-82.67726878499991,
							27.760930000000087
						],
						[
							-82.67750456199991,
							27.760961521000073
						],
						[
							-82.67760301099992,
							27.760997204000034
						],
						[
							-82.67784896599996,
							27.761004686000035
						],
						[
							-82.67817665699994,
							27.761010472000066
						],
						[
							-82.67865576599992,
							27.761014465000073
						],
						[
							-82.67913466499994,
							27.761018456000045
						],
						[
							-82.6794625469999,
							27.761018456000045
						],
						[
							-82.67945999999995,
							27.761398303000078
						],
						[
							-82.67945999999995,
							27.761929344000066
						],
						[
							-82.67945999999995,
							27.762544234000075
						],
						[
							-82.67945999999995,
							27.76304732500006
						],
						[
							-82.67945519699992,
							27.763969742000086
						],
						[
							-82.67945685599994,
							27.76450054500009
						],
						[
							-82.67945999999995,
							27.76486404500008
						],
						[
							-82.67945999999995,
							27.765339187000052
						],
						[
							-82.67946166099995,
							27.76578623800009
						],
						[
							-82.67946534299995,
							27.76606605300009
						],
						[
							-82.67946999999992,
							27.76642000000004
						],
						[
							-82.67946999999992,
							27.766421708000053
						],
						[
							-82.67946999999992,
							27.766792198000076
						],
						[
							-82.67946999999992,
							27.767228354000054
						],
						[
							-82.67946999999992,
							27.76737902600007
						],
						[
							-82.67946999999992,
							27.76776760200005
						],
						[
							-82.67946999999992,
							27.768068946000085
						],
						[
							-82.67946999999992,
							27.768298919000074
						],
						[
							-82.67946999999992,
							27.768465452000044
						],
						[
							-82.67946999999992,
							27.768663704000062
						],
						[
							-82.67946999999992,
							27.76886988700005
						],
						[
							-82.67946999999992,
							27.769234672000042
						],
						[
							-82.67946999999992,
							27.769321904000037
						],
						[
							-82.67946999999992,
							27.769583597000064
						],
						[
							-82.67946999999992,
							27.769869081000085
						],
						[
							-82.67946999999992,
							27.77007000000009
						],
						[
							-82.6794247709999,
							27.77007000000009
						],
						[
							-82.67936893099994,
							27.770072634000087
						],
						[
							-82.67930999999993,
							27.770080000000064
						],
						[
							-82.6792192389999,
							27.77008567300004
						],
						[
							-82.67914721699992,
							27.770090000000042
						],
						[
							-82.67842557699993,
							27.770090000000042
						],
						[
							-82.67785460899995,
							27.770090000000042
						],
						[
							-82.67757705499992,
							27.770090000000042
						],
						[
							-82.6771568659999,
							27.770086236000054
						],
						[
							-82.6770140189999,
							27.770083131000035
						],
						[
							-82.67692682899991,
							27.770081235000077
						],
						[
							-82.67668093999993,
							27.770081212000036
						],
						[
							-82.6762844509999,
							27.77008375400004
						],
						[
							-82.67610999499993,
							27.77008487200004
						],
						[
							-82.67595134899994,
							27.770085889000086
						],
						[
							-82.67563415699993,
							27.770087922000076
						],
						[
							-82.67530999999991,
							27.770090000000042
						],
						[
							-82.67501048799994,
							27.77009225200004
						],
						[
							-82.67464486999995,
							27.770095001000072
						],
						[
							-82.67431248999992,
							27.770097500000077
						],
						[
							-82.67397999999991,
							27.77010000000007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Palmetto Park",
				"RegionID": "416370"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.13435272999993,
					25.823106789000065,
					-80.1222760359999,
					25.851807574000077
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.12425154499994,
							25.851807574000077
						],
						[
							-80.12328242699994,
							25.850502993000077
						],
						[
							-80.12294696399994,
							25.849012043000073
						],
						[
							-80.12246240499991,
							25.846551976000057
						],
						[
							-80.1222760359999,
							25.844390098000076
						],
						[
							-80.12235058399995,
							25.84204185200008
						],
						[
							-80.12276059499993,
							25.84055090200008
						],
						[
							-80.12235058399995,
							25.835034388000054
						],
						[
							-80.1225369519999,
							25.833580712000074
						],
						[
							-80.12298423699991,
							25.83197794000006
						],
						[
							-80.1230587849999,
							25.82970424200005
						],
						[
							-80.12287241599995,
							25.82735599600005
						],
						[
							-80.12287241599995,
							25.826685068000074
						],
						[
							-80.1248851979999,
							25.82653597300009
						],
						[
							-80.12555612599994,
							25.826424152000072
						],
						[
							-80.12581704199994,
							25.825865046000047
						],
						[
							-80.1259288629999,
							25.824933202000068
						],
						[
							-80.12645069599995,
							25.823777716000052
						],
						[
							-80.1269725279999,
							25.823106789000065
						],
						[
							-80.12958169099994,
							25.823218610000083
						],
						[
							-80.13066262899991,
							25.82362862100007
						],
						[
							-80.13189266299992,
							25.823964085000057
						],
						[
							-80.13293632799991,
							25.825156845000038
						],
						[
							-80.13435272999993,
							25.826610521000077
						],
						[
							-80.13434146399993,
							25.84823128800008
						],
						[
							-80.13122173599993,
							25.85098755200005
						],
						[
							-80.12425154499994,
							25.851807574000077
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Beach",
				"Name": "La Gorce",
				"RegionID": "623408"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.7244183489999,
					28.252312221000068,
					-82.71545236399993,
					28.258698744000075
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.71545236399993,
							28.253349092000065
						],
						[
							-82.71993782399994,
							28.253335389000085
						],
						[
							-82.71993782399994,
							28.25269888300005
						],
						[
							-82.72016387299993,
							28.25269888300005
						],
						[
							-82.7203185379999,
							28.25266914000008
						],
						[
							-82.72050889499991,
							28.252597756000057
						],
						[
							-82.7206933029999,
							28.252466886000036
						],
						[
							-82.72087176199994,
							28.252318169000034
						],
						[
							-82.7233880419999,
							28.252312221000068
						],
						[
							-82.72356174299995,
							28.25252166300004
						],
						[
							-82.72427558099992,
							28.25325453700009
						],
						[
							-82.72438979499994,
							28.253416340000058
						],
						[
							-82.7244183489999,
							28.253625733000035
						],
						[
							-82.72436124199993,
							28.253730429000086
						],
						[
							-82.72425654599994,
							28.253778018000048
						],
						[
							-82.72388534999993,
							28.25378753600006
						],
						[
							-82.72363788599995,
							28.253825608000056
						],
						[
							-82.7234951179999,
							28.253863679000062
						],
						[
							-82.72325717199993,
							28.25397789300007
						],
						[
							-82.72299067199992,
							28.254215839000043
						],
						[
							-82.7226480299999,
							28.254425232000074
						],
						[
							-82.72241960199995,
							28.254567999000074
						],
						[
							-82.72184853099992,
							28.25531039100008
						],
						[
							-82.7212774599999,
							28.255919533000053
						],
						[
							-82.72097288899994,
							28.256433497000046
						],
						[
							-82.72103951399993,
							28.256890353000074
						],
						[
							-82.72129649599992,
							28.257394799000053
						],
						[
							-82.7212489069999,
							28.257994423000074
						],
						[
							-82.72084915799991,
							28.258375137000087
						],
						[
							-82.7206968719999,
							28.258489351000037
						],
						[
							-82.72042085499993,
							28.258660672000076
						],
						[
							-82.71959365799995,
							28.258667011000057
						],
						[
							-82.71957218999995,
							28.258667176000074
						],
						[
							-82.71545253999994,
							28.258698744000075
						],
						[
							-82.71545236399993,
							28.253349092000065
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pasco",
				"City": "New Port Richey",
				"Name": "Sims Grant",
				"RegionID": "737818"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.72532145399992,
					28.24045100400008,
					-82.71948701499991,
					28.249245492000057
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.71961074699993,
							28.246599531000072
						],
						[
							-82.71959274699992,
							28.245069498000078
						],
						[
							-82.71956315799991,
							28.242554448000078
						],
						[
							-82.71954426199994,
							28.24239383400004
						],
						[
							-82.71952508699991,
							28.242230841000037
						],
						[
							-82.71951556899995,
							28.24207855600008
						],
						[
							-82.71948701499991,
							28.24045100400008
						],
						[
							-82.72023178699993,
							28.240817441000047
						],
						[
							-82.72060655199994,
							28.24091856800004
						],
						[
							-82.72093372799992,
							28.241108925000052
						],
						[
							-82.72117167399995,
							28.241293333000044
						],
						[
							-82.72135013299993,
							28.241430152000078
						],
						[
							-82.72148100399994,
							28.241483690000052
						],
						[
							-82.7216297199999,
							28.241501536000044
						],
						[
							-82.72176653899993,
							28.241489639000065
						],
						[
							-82.72212345799994,
							28.241501536000044
						],
						[
							-82.72273022099995,
							28.241566971000054
						],
						[
							-82.72337267499995,
							28.241810866000037
						],
						[
							-82.72407461599994,
							28.242447372000072
						],
						[
							-82.72419953799994,
							28.242584191000052
						],
						[
							-82.72436609999994,
							28.242774548000057
						],
						[
							-82.72475276199992,
							28.243268286000045
						],
						[
							-82.7248895809999,
							28.243417002000058
						],
						[
							-82.72500260599992,
							28.24350028400005
						],
						[
							-82.72518820399995,
							28.24363948200005
						],
						[
							-82.72528338199993,
							28.243782250000038
						],
						[
							-82.72532145399992,
							28.243953571000077
						],
						[
							-82.72529289999994,
							28.244134410000072
						],
						[
							-82.72526434699995,
							28.244305731000054
						],
						[
							-82.72529289999994,
							28.24454367700008
						],
						[
							-82.72532145399992,
							28.244724516000076
						],
						[
							-82.7253024179999,
							28.244867284000065
						],
						[
							-82.72520723899993,
							28.245029087000034
						],
						[
							-82.72498832899993,
							28.24532414000004
						],
						[
							-82.72493122199995,
							28.24545739000007
						],
						[
							-82.72491218599993,
							28.245609676000072
						],
						[
							-82.72489315099996,
							28.245742926000048
						],
						[
							-82.72493122199995,
							28.24601894300008
						],
						[
							-82.72495977599993,
							28.24618074600005
						],
						[
							-82.7244934009999,
							28.247037352000063
						],
						[
							-82.72436966899994,
							28.247113495000068
						],
						[
							-82.7241983479999,
							28.247399030000054
						],
						[
							-82.7241222049999,
							28.247675048000076
						],
						[
							-82.72406509799993,
							28.24792251200006
						],
						[
							-82.72405557999991,
							28.24806527900006
						],
						[
							-82.7239032949999,
							28.24818901100008
						],
						[
							-82.72392233099993,
							28.248379368000087
						],
						[
							-82.72388425899993,
							28.24857924300005
						],
						[
							-82.7237985989999,
							28.24869345700006
						],
						[
							-82.72343586599993,
							28.24885373400008
						],
						[
							-82.72338933099991,
							28.248874296000054
						],
						[
							-82.72317993899992,
							28.248836225000048
						],
						[
							-82.72275163599994,
							28.249026582000056
						],
						[
							-82.72267549299994,
							28.249083689000088
						],
						[
							-82.7225422429999,
							28.249245492000057
						],
						[
							-82.72184744099991,
							28.249245492000057
						],
						[
							-82.7221329759999,
							28.249026582000056
						],
						[
							-82.72236140399991,
							28.248836225000048
						],
						[
							-82.72270404699992,
							28.24848406500007
						],
						[
							-82.72296102799993,
							28.248150940000073
						],
						[
							-82.72320849199991,
							28.247665530000063
						],
						[
							-82.7233512599999,
							28.247322888000042
						],
						[
							-82.7234274029999,
							28.247132531000094
						],
						[
							-82.72100986999993,
							28.247132531000094
						],
						[
							-82.72100986999993,
							28.246599531000072
						],
						[
							-82.71964971099993,
							28.246599531000072
						],
						[
							-82.71961074699993,
							28.246599531000072
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pasco",
				"City": "New Port Richey",
				"Name": "West Grand",
				"RegionID": "737819"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.71961074699993,
					28.24045100400008,
					-82.71539767399992,
					28.246612539000072
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.71539767399992,
							28.241782233000038
						],
						[
							-82.71569891299993,
							28.241897717000086
						],
						[
							-82.71580360999991,
							28.241916752000066
						],
						[
							-82.71597493099995,
							28.241840609000064
						],
						[
							-82.7161652879999,
							28.24173591300007
						],
						[
							-82.71640323399993,
							28.241621699000063
						],
						[
							-82.71678394799994,
							28.24137423500008
						],
						[
							-82.71709803599992,
							28.24110773500007
						],
						[
							-82.71744067899994,
							28.240926896000076
						],
						[
							-82.71779283899991,
							28.240803164000056
						],
						[
							-82.71916340899992,
							28.240460522000035
						],
						[
							-82.71948701499991,
							28.24045100400008
						],
						[
							-82.71951556899995,
							28.24207855600008
						],
						[
							-82.71952508699991,
							28.242230841000037
						],
						[
							-82.71954426199994,
							28.24239383400004
						],
						[
							-82.71956315799991,
							28.242554448000078
						],
						[
							-82.71959274699992,
							28.245069498000078
						],
						[
							-82.71961074699993,
							28.246599531000072
						],
						[
							-82.71958296299994,
							28.24659961800006
						],
						[
							-82.71544526299994,
							28.246612539000072
						],
						[
							-82.71539767399992,
							28.241782233000038
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pasco",
				"City": "New Port Richey",
				"Name": "East Grand",
				"RegionID": "737820"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.71544526299994,
					28.23431387900007,
					-82.69897939299995,
					28.24981053500005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.70447989299993,
							28.23431387900007
						],
						[
							-82.70450963699994,
							28.23522997100008
						],
						[
							-82.7072341199999,
							28.23521212500009
						],
						[
							-82.70723612199993,
							28.23612863400007
						],
						[
							-82.70856861999994,
							28.23612863400007
						],
						[
							-82.70862096899992,
							28.23884597800009
						],
						[
							-82.70996690099992,
							28.23884122000004
						],
						[
							-82.70996690099992,
							28.23915941300004
						],
						[
							-82.70993918999994,
							28.239369460000034
						],
						[
							-82.70991539499994,
							28.239507469000046
						],
						[
							-82.70987732399993,
							28.23965975400006
						],
						[
							-82.70990111899994,
							28.23992149500009
						],
						[
							-82.7099867789999,
							28.240168959000073
						],
						[
							-82.71009623399993,
							28.24031648500005
						],
						[
							-82.71030562699991,
							28.24042594100007
						],
						[
							-82.7105388139999,
							28.24035455700005
						],
						[
							-82.71070537599991,
							28.24034503900009
						],
						[
							-82.71083862599994,
							28.24036407500006
						],
						[
							-82.71095283999996,
							28.240430699000058
						],
						[
							-82.71106229599991,
							28.240554431000078
						],
						[
							-82.71110988499993,
							28.240711476000058
						],
						[
							-82.71114795599993,
							28.241158815000063
						],
						[
							-82.71258039199995,
							28.24114929700005
						],
						[
							-82.71255659699995,
							28.240701958000045
						],
						[
							-82.71334181899994,
							28.239540781000073
						],
						[
							-82.71373680999994,
							28.24015468200008
						],
						[
							-82.71406041599994,
							28.240525878000085
						],
						[
							-82.71418890699994,
							28.24074002900005
						],
						[
							-82.7143364339999,
							28.240825690000065
						],
						[
							-82.71449823699993,
							28.24102556500009
						],
						[
							-82.71471238899994,
							28.241168332000086
						],
						[
							-82.71539767399992,
							28.241782233000038
						],
						[
							-82.71544526299994,
							28.246612539000072
						],
						[
							-82.71272315899995,
							28.246598262000077
						],
						[
							-82.71270623399994,
							28.248457187000042
						],
						[
							-82.7126946059999,
							28.24973439200005
						],
						[
							-82.71134083099992,
							28.24973908900006
						],
						[
							-82.70877220299991,
							28.249748000000068
						],
						[
							-82.70720756899993,
							28.249753428000076
						],
						[
							-82.70319579799992,
							28.24981053500005
						],
						[
							-82.70318152099992,
							28.246131888000036
						],
						[
							-82.70179667399992,
							28.24614140600005
						],
						[
							-82.7018014329999,
							28.24458999700005
						],
						[
							-82.7004403819999,
							28.24459951500006
						],
						[
							-82.7004403819999,
							28.243400267000084
						],
						[
							-82.70316248499995,
							28.243371713000045
						],
						[
							-82.70310537799992,
							28.238831702000084
						],
						[
							-82.69897939299995,
							28.238836461000062
						],
						[
							-82.69897939299995,
							28.237315985000066
						],
						[
							-82.69900080799994,
							28.23719106300007
						],
						[
							-82.69900080799994,
							28.23623095100004
						],
						[
							-82.69904006899992,
							28.236259504000092
						],
						[
							-82.69915785199994,
							28.23622738200004
						],
						[
							-82.69923994399994,
							28.236209536000047
						],
						[
							-82.69937557299994,
							28.236209536000047
						],
						[
							-82.69950763299994,
							28.236245228000087
						],
						[
							-82.69963969299994,
							28.23629519600007
						],
						[
							-82.6997146459999,
							28.23627378100008
						],
						[
							-82.69976104599994,
							28.236213105000047
						],
						[
							-82.6997396299999,
							28.23611316800009
						],
						[
							-82.69975747599995,
							28.235877601000084
						],
						[
							-82.70003230399993,
							28.23560277300004
						],
						[
							-82.7002357479999,
							28.23550997400008
						],
						[
							-82.7004784529999,
							28.235420744000066
						],
						[
							-82.7016063179999,
							28.235224439000035
						],
						[
							-82.70178120799994,
							28.23514948600007
						],
						[
							-82.70194182199992,
							28.23510665500004
						],
						[
							-82.70212028099992,
							28.235113794000085
						],
						[
							-82.7022737559999,
							28.235145917000068
						],
						[
							-82.70236298599991,
							28.235192316000052
						],
						[
							-82.70267707499994,
							28.23598467700009
						],
						[
							-82.70272347399992,
							28.236045353000065
						],
						[
							-82.70285196499994,
							28.236038214000075
						],
						[
							-82.7029019339999,
							28.235977538000043
						],
						[
							-82.7029019339999,
							28.23563846500008
						],
						[
							-82.70291621099994,
							28.235574220000046
						],
						[
							-82.70293405699994,
							28.235238716000083
						],
						[
							-82.70296260999993,
							28.23518517800005
						],
						[
							-82.70304113299994,
							28.23516376300006
						],
						[
							-82.70311608599991,
							28.235206593000044
						],
						[
							-82.70310537799992,
							28.234314295000047
						],
						[
							-82.70447989299993,
							28.23431387900007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pasco",
				"City": "New Port Richey",
				"Name": "East Madison",
				"RegionID": "737821"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.66383926299994,
					27.842710000000068,
					-82.64688999999993,
					27.850308589000065
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.65412476699993,
							27.850290209000036
						],
						[
							-82.6536193259999,
							27.85028101900008
						],
						[
							-82.65284737999991,
							27.85029939900005
						],
						[
							-82.65220409199992,
							27.85029939900005
						],
						[
							-82.65193758599992,
							27.850271830000054
						],
						[
							-82.65128510799991,
							27.85029939900005
						],
						[
							-82.65102779299991,
							27.850271830000054
						],
						[
							-82.65073371799991,
							27.85022588000004
						],
						[
							-82.64693999999992,
							27.85017993100007
						],
						[
							-82.64693999999992,
							27.84998694500007
						],
						[
							-82.64693999999992,
							27.849810000000048
						],
						[
							-82.64693698199994,
							27.849665137000045
						],
						[
							-82.64693219799994,
							27.849435491000065
						],
						[
							-82.64692999999994,
							27.849330000000066
						],
						[
							-82.64692999999994,
							27.849077151000074
						],
						[
							-82.64692999999994,
							27.848681989000056
						],
						[
							-82.6469265259999,
							27.848240900000064
						],
						[
							-82.64692348999995,
							27.84790090300004
						],
						[
							-82.64692111099993,
							27.847634419000087
						],
						[
							-82.64692000299993,
							27.847510328000055
						],
						[
							-82.64691999999991,
							27.847510000000057
						],
						[
							-82.64691186699991,
							27.847107426000036
						],
						[
							-82.64690393599994,
							27.84671482600004
						],
						[
							-82.6468999999999,
							27.846159380000078
						],
						[
							-82.64690428099995,
							27.845326185000093
						],
						[
							-82.64690840599991,
							27.844917790000068
						],
						[
							-82.64690999999993,
							27.844760000000065
						],
						[
							-82.64690722499995,
							27.844313215000057
						],
						[
							-82.64690306499995,
							27.84364340500008
						],
						[
							-82.64690123799994,
							27.843349341000078
						],
						[
							-82.6468999999999,
							27.843150000000037
						],
						[
							-82.64689448899992,
							27.842990187000055
						],
						[
							-82.64688999999993,
							27.842710000000068
						],
						[
							-82.64699124299995,
							27.842720000000046
						],
						[
							-82.64710999999994,
							27.842720000000046
						],
						[
							-82.6473332189999,
							27.842725874000052
						],
						[
							-82.64758178099993,
							27.842732415000057
						],
						[
							-82.6478699999999,
							27.84274000000005
						],
						[
							-82.6480787559999,
							27.842746627000054
						],
						[
							-82.6484524679999,
							27.84275849100004
						],
						[
							-82.64885662899991,
							27.842764755000076
						],
						[
							-82.64938510699994,
							27.84277171000008
						],
						[
							-82.64972745499995,
							27.84277604400006
						],
						[
							-82.65022470699995,
							27.842778257000077
						],
						[
							-82.65047341899992,
							27.842775911000047
						],
						[
							-82.65081569099993,
							27.84277268200009
						],
						[
							-82.65109999999993,
							27.842770000000087
						],
						[
							-82.65159291399993,
							27.842765599000074
						],
						[
							-82.65224578899995,
							27.842759770000043
						],
						[
							-82.6527743069999,
							27.84275505100004
						],
						[
							-82.65320983499993,
							27.84275116200007
						],
						[
							-82.65398706699995,
							27.842744223000068
						],
						[
							-82.65460872799991,
							27.84274000000005
						],
						[
							-82.6550499999999,
							27.84274000000005
						],
						[
							-82.65519999999992,
							27.842760000000055
						],
						[
							-82.65560366499994,
							27.842760000000055
						],
						[
							-82.65616331699994,
							27.842760000000055
						],
						[
							-82.6564120509999,
							27.842760000000055
						],
						[
							-82.65674999999993,
							27.842760000000055
						],
						[
							-82.65700316399995,
							27.84275712300007
						],
						[
							-82.65753165599995,
							27.84275111800008
						],
						[
							-82.65793585099993,
							27.842745567000065
						],
						[
							-82.65809127799992,
							27.842743315000064
						],
						[
							-82.65831999999995,
							27.84274000000005
						],
						[
							-82.6584499999999,
							27.842730000000074
						],
						[
							-82.65874380299994,
							27.842734081000064
						],
						[
							-82.65886814599992,
							27.842735808000043
						],
						[
							-82.6591699999999,
							27.84274000000005
						],
						[
							-82.65964565899992,
							27.842737680000084
						],
						[
							-82.66023638899992,
							27.842734798000038
						],
						[
							-82.66107584699995,
							27.842730703000086
						],
						[
							-82.66129430099994,
							27.842913214000077
						],
						[
							-82.66361572699992,
							27.84289056600005
						],
						[
							-82.66368999999992,
							27.84580600000004
						],
						[
							-82.66371099999992,
							27.846617000000037
						],
						[
							-82.6637429999999,
							27.84767700000009
						],
						[
							-82.66373799999991,
							27.84770300000008
						],
						[
							-82.66373899999991,
							27.847739000000047
						],
						[
							-82.66383926299994,
							27.84775648200008
						],
						[
							-82.66333858599995,
							27.848526365000055
						],
						[
							-82.66315965099994,
							27.849046744000077
						],
						[
							-82.66286419099993,
							27.849649389000035
						],
						[
							-82.6625151319999,
							27.850191298000084
						],
						[
							-82.66246689099995,
							27.850265037000042
						],
						[
							-82.66040142199995,
							27.850207501000057
						],
						[
							-82.65827857099993,
							27.850207501000057
						],
						[
							-82.65682657699995,
							27.850189121000085
						],
						[
							-82.6553102549999,
							27.850207501000057
						],
						[
							-82.6550529399999,
							27.850308589000065
						],
						[
							-82.6550499999999,
							27.850308531000053
						],
						[
							-82.65412476699993,
							27.850290209000036
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Winston Park",
				"RegionID": "417201"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.18609457899993,
					26.047317871000075,
					-80.17271699999992,
					26.051023000000043
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-80.17272799999995,
								26.04877000000005
							],
							[
								-80.17271699999992,
								26.04781500000007
							],
							[
								-80.17321299999992,
								26.047806000000037
							],
							[
								-80.1736699999999,
								26.047806000000037
							],
							[
								-80.17365399999994,
								26.048767000000055
							],
							[
								-80.17320199999995,
								26.048760000000073
							],
							[
								-80.17285199999992,
								26.04877000000005
							],
							[
								-80.17272799999995,
								26.04877000000005
							]
						]
					],
					[
						[
							[
								-80.18058999999994,
								26.049191000000068
							],
							[
								-80.18056499999994,
								26.048432000000048
							],
							[
								-80.17906799999992,
								26.048434000000043
							],
							[
								-80.17906799999992,
								26.047566000000074
							],
							[
								-80.18140399999993,
								26.04743400000007
							],
							[
								-80.18138599999992,
								26.049187000000074
							],
							[
								-80.18109599999993,
								26.049191000000068
							],
							[
								-80.18074799999994,
								26.049194000000057
							],
							[
								-80.18058999999994,
								26.049191000000068
							]
						]
					],
					[
						[
							[
								-80.17416799999995,
								26.049566000000087
							],
							[
								-80.17409299999991,
								26.048141000000044
							],
							[
								-80.17493599999995,
								26.048152000000073
							],
							[
								-80.17493599999995,
								26.04766600000005
							],
							[
								-80.17635427099992,
								26.047707373000037
							],
							[
								-80.1781749999999,
								26.047598000000054
							],
							[
								-80.17817699999995,
								26.049462000000062
							],
							[
								-80.17636799999991,
								26.049466000000052
							],
							[
								-80.17416799999995,
								26.049566000000087
							]
						]
					],
					[
						[
							[
								-80.18206399999991,
								26.04740000000004
							],
							[
								-80.18609457899993,
								26.047317871000075
							],
							[
								-80.18606699999992,
								26.048955000000035
							],
							[
								-80.18455599999993,
								26.04900900000007
							],
							[
								-80.1845679999999,
								26.049266000000046
							],
							[
								-80.1845679999999,
								26.050866000000042
							],
							[
								-80.1829679999999,
								26.050966000000074
							],
							[
								-80.18257299999993,
								26.051023000000043
							],
							[
								-80.18212799999993,
								26.05101600000006
							],
							[
								-80.18206399999991,
								26.04740000000004
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Hollywood",
				"Name": "Stirling Commercial",
				"RegionID": "623396"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.1880408529999,
					26.04727519900007,
					-80.18606699999992,
					26.05138015500006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.18606699999992,
							26.048955000000035
						],
						[
							-80.18609457899993,
							26.047317871000075
						],
						[
							-80.18735865699995,
							26.047292113000083
						],
						[
							-80.1880408529999,
							26.04727519900007
						],
						[
							-80.18799946799993,
							26.050761495000074
						],
						[
							-80.18780911099992,
							26.05138015500006
						],
						[
							-80.18720399999995,
							26.05077700000004
						],
						[
							-80.18621299999995,
							26.050804000000085
						],
						[
							-80.18611699999991,
							26.049972000000082
						],
						[
							-80.18606799999992,
							26.04916600000007
						],
						[
							-80.18606699999992,
							26.048955000000035
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Hollywood",
				"Name": "Arapahoe Farms",
				"RegionID": "623397"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.1947209999999,
					26.046966000000058,
					-80.18780911099992,
					26.05152292200006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.18780911099992,
							26.05138015500006
						],
						[
							-80.18799946799993,
							26.050761495000074
						],
						[
							-80.1880408529999,
							26.04727519900007
						],
						[
							-80.18809548799993,
							26.047273844000074
						],
						[
							-80.19154586099995,
							26.047188298000037
						],
						[
							-80.1928089999999,
							26.046966000000058
						],
						[
							-80.1928089999999,
							26.04886600000009
						],
						[
							-80.19396899999992,
							26.04886600000009
						],
						[
							-80.1942689999999,
							26.04886600000009
						],
						[
							-80.19426999999992,
							26.046966000000058
						],
						[
							-80.19466499999993,
							26.046966000000058
						],
						[
							-80.19466399999993,
							26.048875000000066
						],
						[
							-80.1947209999999,
							26.05057500000004
						],
						[
							-80.19404329899993,
							26.050761495000074
						],
						[
							-80.19252044399991,
							26.050761495000074
						],
						[
							-80.19252044399991,
							26.05142774400008
						],
						[
							-80.19080723199994,
							26.05152292200006
						],
						[
							-80.19033133999994,
							26.05128497600009
						],
						[
							-80.18780911099992,
							26.05138015500006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Hollywood",
				"Name": "Lake Eden",
				"RegionID": "623398"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.23106999999993,
					26.038721422000037,
					-80.22478593499994,
					26.04516700000005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.23106999999993,
							26.042567000000076
						],
						[
							-80.23106999999993,
							26.044867000000067
						],
						[
							-80.22896999999995,
							26.045067000000078
						],
						[
							-80.22706999999991,
							26.04516700000005
						],
						[
							-80.22496999999993,
							26.04516700000005
						],
						[
							-80.22488111399991,
							26.043670701000053
						],
						[
							-80.2248335239999,
							26.041576775000067
						],
						[
							-80.22478593499994,
							26.040434634000064
						],
						[
							-80.22488111399991,
							26.03972079600004
						],
						[
							-80.2248335239999,
							26.038959368000064
						],
						[
							-80.2267846819999,
							26.038911779000045
						],
						[
							-80.22878342999991,
							26.038816600000075
						],
						[
							-80.23082976599994,
							26.038721422000037
						],
						[
							-80.23106999999993,
							26.042567000000076
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Hollywood",
				"Name": "Carriage",
				"RegionID": "623399"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.20756899999992,
					26.03215411000008,
					-80.20033552799993,
					26.039955856000063
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.20469123599992,
							26.039865778000035
						],
						[
							-80.20061236799995,
							26.039955856000063
						],
						[
							-80.20047394799991,
							26.037568112000088
						],
						[
							-80.20043934299991,
							26.03514576300006
						],
						[
							-80.20037013299992,
							26.033242488000045
						],
						[
							-80.20033552799993,
							26.032342759000073
						],
						[
							-80.2034659649999,
							26.032296877000082
						],
						[
							-80.2073682809999,
							26.03215411000008
						],
						[
							-80.2075110479999,
							26.034390803000065
						],
						[
							-80.20756899999992,
							26.03556700000007
						],
						[
							-80.20445599999994,
							26.035656000000074
						],
						[
							-80.2044689999999,
							26.03616700000009
						],
						[
							-80.20466899999991,
							26.039267000000052
						],
						[
							-80.20469123599992,
							26.039865778000035
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Hollywood",
				"Name": "Playland",
				"RegionID": "623400"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.15712696799994,
					25.78708667500007,
					-80.15279432599993,
					25.796107094000035
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.15712696799994,
							25.796107094000035
						],
						[
							-80.15279432599993,
							25.796107094000035
						],
						[
							-80.15279432599993,
							25.78708667500007
						],
						[
							-80.15712696799994,
							25.78708667500007
						],
						[
							-80.15712696799994,
							25.796107094000035
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Beach",
				"Name": "Rivo Alto Island",
				"RegionID": "623413"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.1700909999999,
					25.774748011000042,
					-80.15574194299995,
					25.784496982000064
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.15574194299995,
							25.77906063300009
						],
						[
							-80.15763092399993,
							25.774748011000042
						],
						[
							-80.16368799999992,
							25.777394000000072
						],
						[
							-80.1673869999999,
							25.77894900000007
						],
						[
							-80.1700909999999,
							25.780087000000037
						],
						[
							-80.16993899999996,
							25.78035300000005
						],
						[
							-80.16993705699991,
							25.780357647000073
						],
						[
							-80.1695877439999,
							25.781192992000058
						],
						[
							-80.16820612599992,
							25.784496982000064
						],
						[
							-80.15574194299995,
							25.77906063300009
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Beach",
				"Name": "Palm Island",
				"RegionID": "623414"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.17727599999995,
					26.231386488000055,
					-80.16553491699995,
					26.23622060400004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.16553491699995,
							26.231386488000055
						],
						[
							-80.16694266399998,
							26.231823375000033
						],
						[
							-80.16852257299996,
							26.232166833000065
						],
						[
							-80.16941556399996,
							26.23209814100005
						],
						[
							-80.17120154799994,
							26.231548608000026
						],
						[
							-80.17388052299998,
							26.231411225000045
						],
						[
							-80.17720495699996,
							26.23145530000005
						],
						[
							-80.17727599999995,
							26.231456000000037
						],
						[
							-80.17582099999998,
							26.232592000000068
						],
						[
							-80.17303581699997,
							26.236177346000034
						],
						[
							-80.17296301099998,
							26.236178462000055
						],
						[
							-80.16563536899997,
							26.23622060400004
						],
						[
							-80.16553491699995,
							26.231386488000055
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Pompano Beach",
				"Name": "Island Club",
				"RegionID": "738038"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.16899007999992,
					26.23120515000005,
					-80.15156767899992,
					26.245386273000065
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.15159240699995,
							26.243556424000076
						],
						[
							-80.15156767899992,
							26.24031709600007
						],
						[
							-80.1516418619999,
							26.23945162700005
						],
						[
							-80.15211168899992,
							26.23831415300009
						],
						[
							-80.1528535189999,
							26.23734977400005
						],
						[
							-80.15451027499995,
							26.236039206000044
						],
						[
							-80.1555488379999,
							26.235124281000083
						],
						[
							-80.15614230199992,
							26.234234084000036
						],
						[
							-80.15656267299994,
							26.23317079400005
						],
						[
							-80.15680994999991,
							26.23215695800008
						],
						[
							-80.15670760499995,
							26.23120515000005
						],
						[
							-80.16495060599993,
							26.23120515000005
						],
						[
							-80.1654776979999,
							26.231368730000046
						],
						[
							-80.16553491699995,
							26.231386488000055
						],
						[
							-80.16563536899992,
							26.23622060400004
						],
						[
							-80.16572081999993,
							26.24033281700008
						],
						[
							-80.1654487969999,
							26.241675929000053
						],
						[
							-80.16891624999994,
							26.241605595000067
						],
						[
							-80.16899007999992,
							26.24160527400005
						],
						[
							-80.16842289099992,
							26.242636679000043
						],
						[
							-80.16733489099994,
							26.24474167900007
						],
						[
							-80.16729889099992,
							26.24503567900007
						],
						[
							-80.1667638909999,
							26.245060679000062
						],
						[
							-80.16498189099991,
							26.245113679000042
						],
						[
							-80.16433080299993,
							26.245133817000067
						],
						[
							-80.16425893899992,
							26.245136040000094
						],
						[
							-80.1641851089999,
							26.24513636100005
						],
						[
							-80.15762596399992,
							26.245386273000065
						],
						[
							-80.15700777099994,
							26.245336818000055
						],
						[
							-80.1550542839999,
							26.245040085000085
						],
						[
							-80.15344698399991,
							26.244520804000047
						],
						[
							-80.15159240699995,
							26.243556424000076
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Pompano Beach",
				"Name": "Collier City",
				"RegionID": "738039"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.1327679449999,
					26.205959759000052,
					-80.12307687999993,
					26.21111383400006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.12307769599994,
							26.20827536200005
						],
						[
							-80.12315036399991,
							26.208262723000075
						],
						[
							-80.12316694499992,
							26.208259840000043
						],
						[
							-80.1241669449999,
							26.20793684000006
						],
						[
							-80.12498194499994,
							26.207672840000047
						],
						[
							-80.12656694499992,
							26.207159840000088
						],
						[
							-80.12709790999992,
							26.206993913000076
						],
						[
							-80.1271257649999,
							26.20698520800005
						],
						[
							-80.12971586999993,
							26.20617580000004
						],
						[
							-80.12976694499991,
							26.206159840000055
						],
						[
							-80.13036694499993,
							26.20605984000008
						],
						[
							-80.1311889449999,
							26.205984840000042
						],
						[
							-80.13146694499994,
							26.205959840000048
						],
						[
							-80.13153982999995,
							26.205959840000048
						],
						[
							-80.13157406099992,
							26.205959840000048
						],
						[
							-80.13164694499994,
							26.205959840000048
						],
						[
							-80.13171982999995,
							26.205959840000048
						],
						[
							-80.13220022899992,
							26.205959759000052
						],
						[
							-80.13227405999993,
							26.205959840000048
						],
						[
							-80.1323950609999,
							26.205959840000048
						],
						[
							-80.13246794499992,
							26.205959840000048
						],
						[
							-80.13254082999993,
							26.205959840000048
						],
						[
							-80.13269506099994,
							26.205959840000048
						],
						[
							-80.1327636879999,
							26.205959840000048
						],
						[
							-80.1327679449999,
							26.205959840000048
						],
						[
							-80.13276700099993,
							26.205964330000086
						],
						[
							-80.1327676759999,
							26.209936157000072
						],
						[
							-80.1324820879999,
							26.210917091000056
						],
						[
							-80.12318058599993,
							26.21111383400006
						],
						[
							-80.12307784599994,
							26.208293594000054
						],
						[
							-80.12307687999993,
							26.208288639000045
						],
						[
							-80.12307707999992,
							26.208280736000063
						],
						[
							-80.12307769599994,
							26.20827536200005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Pompano Beach",
				"Name": "Boulevard Park",
				"RegionID": "738052"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.1270562819999,
					26.229314885000065,
					-80.12295679599993,
					26.231580050000048
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.12330198199994,
							26.22941060100004
						],
						[
							-80.1270562819999,
							26.229314885000065
						],
						[
							-80.12630910999991,
							26.231579749000048
						],
						[
							-80.12295679599993,
							26.231580050000048
						],
						[
							-80.12296645599992,
							26.231519132000074
						],
						[
							-80.12330198199994,
							26.22941060100004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Pompano Beach",
				"Name": "Civic Campus",
				"RegionID": "738053"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.13645174399994,
					26.222704771000053,
					-80.13025327199995,
					26.22664954600009
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.13025327199995,
							26.22664954600009
						],
						[
							-80.13069699099992,
							26.22270538300006
						],
						[
							-80.1364408789999,
							26.222704771000053
						],
						[
							-80.13645174399994,
							26.226648904000058
						],
						[
							-80.13025327199995,
							26.22664954600009
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Pompano Beach",
				"Name": "John Knox Village",
				"RegionID": "738054"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.13816798199991,
					26.205859873000065,
					-80.12788677499992,
					26.226797452000085
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.1324820879999,
							26.210917091000056
						],
						[
							-80.1327676759999,
							26.209936157000072
						],
						[
							-80.13276700099993,
							26.205964330000086
						],
						[
							-80.1327679449999,
							26.205959840000048
						],
						[
							-80.13430158299991,
							26.20586380900005
						],
						[
							-80.13436778999994,
							26.205859873000065
						],
						[
							-80.13437405899992,
							26.20586366100008
						],
						[
							-80.13437937399993,
							26.205867407000085
						],
						[
							-80.13516283599995,
							26.206356713000048
						],
						[
							-80.13516774599992,
							26.20636011600004
						],
						[
							-80.13517242199993,
							26.206364102000066
						],
						[
							-80.13689146899992,
							26.208000579000043
						],
						[
							-80.13689594399995,
							26.208004842000037
						],
						[
							-80.13690041699994,
							26.208009107000066
						],
						[
							-80.13726347399995,
							26.208355573000063
						],
						[
							-80.13726817799994,
							26.20835948100006
						],
						[
							-80.13727315299991,
							26.20836261800008
						],
						[
							-80.13796510899994,
							26.20874639200008
						],
						[
							-80.13796995399993,
							26.20874924700007
						],
						[
							-80.13797523599993,
							26.208752463000053
						],
						[
							-80.13816283699992,
							26.20885688800007
						],
						[
							-80.13816798199991,
							26.208860049000066
						],
						[
							-80.13815906999992,
							26.208876764000085
						],
						[
							-80.13695834899994,
							26.21141521800007
						],
						[
							-80.13641602599996,
							26.21368311100008
						],
						[
							-80.13644033499992,
							26.222507429000075
						],
						[
							-80.1364408789999,
							26.222704771000053
						],
						[
							-80.13069699099992,
							26.22270538300006
						],
						[
							-80.13025327199995,
							26.22664954600009
						],
						[
							-80.12788677499992,
							26.226797452000085
						],
						[
							-80.13163372899993,
							26.213831017000075
						],
						[
							-80.13246494999993,
							26.210975955000038
						],
						[
							-80.1324820879999,
							26.210917091000056
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Pompano Beach",
				"Name": "South Dixie",
				"RegionID": "738055"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.18499,
					26.158162,
					-80.16667671599998,
					26.165712213000063
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.16667671599998,
							26.158543861000055
						],
						[
							-80.17230756199996,
							26.158368839000048
						],
						[
							-80.174264,
							26.158377
						],
						[
							-80.17491395299999,
							26.15833210200003
						],
						[
							-80.177957,
							26.158162
						],
						[
							-80.177951,
							26.158313
						],
						[
							-80.18498100000001,
							26.158209
						],
						[
							-80.18499,
							26.158662
						],
						[
							-80.18471728599997,
							26.158665323000037
						],
						[
							-80.17798972499997,
							26.158747293000033
						],
						[
							-80.17798972499997,
							26.161927459000026
						],
						[
							-80.17692428799995,
							26.161927459000026
						],
						[
							-80.17692212299994,
							26.162476248000075
						],
						[
							-80.17691041399996,
							26.165444388000026
						],
						[
							-80.17157347599995,
							26.165561215000025
						],
						[
							-80.17100174799998,
							26.165573730000062
						],
						[
							-80.16686604799997,
							26.165712213000063
						],
						[
							-80.16679935199994,
							26.163187124000046
						],
						[
							-80.16669482499998,
							26.159229740000058
						],
						[
							-80.16667671599998,
							26.158543861000055
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Oakland Park",
				"Name": "East Lakeside",
				"RegionID": "760965"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.185038,
					26.158662,
					-80.17691041399996,
					26.165461075000053
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.17798972499997,
							26.161927459000026
						],
						[
							-80.17798972499997,
							26.158747293000033
						],
						[
							-80.18471728599997,
							26.158665323000037
						],
						[
							-80.18499,
							26.158662
						],
						[
							-80.184994,
							26.158862
						],
						[
							-80.185038,
							26.159832
						],
						[
							-80.18379019799994,
							26.15981295000006
						],
						[
							-80.18307300000001,
							26.159802
						],
						[
							-80.182985,
							26.159800000000004
						],
						[
							-80.18299572199999,
							26.160249320000048
						],
						[
							-80.183017,
							26.161141
						],
						[
							-80.183039,
							26.161839
						],
						[
							-80.18303680899999,
							26.16192877000003
						],
						[
							-80.18302471399994,
							26.162424368000075
						],
						[
							-80.18301909699996,
							26.162654504000045
						],
						[
							-80.18304445299998,
							26.165368757000067
						],
						[
							-80.18295283899994,
							26.16536931400003
						],
						[
							-80.18201701199996,
							26.165390957000056
						],
						[
							-80.18096962999994,
							26.16541517900004
						],
						[
							-80.17905449499996,
							26.165461075000053
						],
						[
							-80.17698926099996,
							26.16544500200007
						],
						[
							-80.17691041399996,
							26.165444388000026
						],
						[
							-80.17692212299994,
							26.162476248000075
						],
						[
							-80.17692428799995,
							26.161927459000026
						],
						[
							-80.17798972499997,
							26.161927459000026
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Oakland Park",
				"Name": "West Lakeside",
				"RegionID": "760966"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.18704593399997,
					26.161737,
					-80.18301909699996,
					26.165368757000067
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.183039,
							26.161839
						],
						[
							-80.18498803299998,
							26.161785216000055
						],
						[
							-80.186784,
							26.161737
						],
						[
							-80.186868,
							26.165162
						],
						[
							-80.18704593399997,
							26.165162
						],
						[
							-80.18703749799994,
							26.165344495000056
						],
						[
							-80.18304445299998,
							26.165368757000067
						],
						[
							-80.18301909699996,
							26.162654504000045
						],
						[
							-80.18302471399994,
							26.162424368000075
						],
						[
							-80.18303680899999,
							26.16192877000003
						],
						[
							-80.183039,
							26.161839
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Oakland Park",
				"Name": "Orange Grove Manors",
				"RegionID": "760967"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.190129,
					26.165162,
					-80.186968,
					26.172562
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.186968,
							26.172562
						],
						[
							-80.18702199899997,
							26.166400268000075
						],
						[
							-80.18702809699994,
							26.16570447600003
						],
						[
							-80.18703749799994,
							26.165344495000056
						],
						[
							-80.18704593399997,
							26.165162
						],
						[
							-80.189668,
							26.165162
						],
						[
							-80.189968,
							26.165162
						],
						[
							-80.190129,
							26.1689
						],
						[
							-80.188899,
							26.168872
						],
						[
							-80.188899,
							26.172562
						],
						[
							-80.186968,
							26.172562
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Oakland Park",
				"Name": "Oakland Grove",
				"RegionID": "760968"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.13898829699997,
					26.184688915000038,
					-80.13532384199993,
					26.18891429000007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.13535100299998,
							26.18794709100007
						],
						[
							-80.13534542399998,
							26.187735462000035
						],
						[
							-80.13533317599996,
							26.187270832000024
						],
						[
							-80.13532384199993,
							26.18691678400006
						],
						[
							-80.13555376399995,
							26.186907587000064
						],
						[
							-80.13572741599995,
							26.186900641000026
						],
						[
							-80.13585872599998,
							26.185291007000046
						],
						[
							-80.13593971599994,
							26.18474335800005
						],
						[
							-80.13898139899999,
							26.184688915000038
						],
						[
							-80.13898829699997,
							26.184689054000046
						],
						[
							-80.13898279899996,
							26.18526892400007
						],
						[
							-80.13895304499994,
							26.188407212000072
						],
						[
							-80.13894976199998,
							26.18875347200003
						],
						[
							-80.13895148099995,
							26.18889499100004
						],
						[
							-80.13534540099994,
							26.18891429000007
						],
						[
							-80.13534631899995,
							26.188755754000056
						],
						[
							-80.13534895499998,
							26.188300653000056
						],
						[
							-80.13535100299998,
							26.18794709100007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Oakland Park",
				"Name": "Garden Acres",
				"RegionID": "761149"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.13189295499996,
					26.18318776700005,
					-80.12229011999995,
					26.18903906500003
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.127066,
							26.188761
						],
						[
							-80.12686222499997,
							26.18879496200003
						],
						[
							-80.126466,
							26.188861
						],
						[
							-80.12534748299998,
							26.188861
						],
						[
							-80.124766,
							26.188861
						],
						[
							-80.124666,
							26.187352644000043
						],
						[
							-80.124666,
							26.187061
						],
						[
							-80.124566,
							26.186961
						],
						[
							-80.123766,
							26.186961
						],
						[
							-80.12257075199994,
							26.187052942000037
						],
						[
							-80.122466,
							26.187061
						],
						[
							-80.122466,
							26.185661
						],
						[
							-80.12238762799996,
							26.185034022000025
						],
						[
							-80.122366,
							26.184474653000052
						],
						[
							-80.122366,
							26.184261
						],
						[
							-80.12235162699994,
							26.184102891000066
						],
						[
							-80.12234879499994,
							26.18407174400005
						],
						[
							-80.12233270499998,
							26.18389475300006
						],
						[
							-80.12229011999995,
							26.183426318000045
						],
						[
							-80.12263595799999,
							26.183417458000065
						],
						[
							-80.12312562599999,
							26.18340525500003
						],
						[
							-80.13185272099997,
							26.18318776700005
						],
						[
							-80.13189076699996,
							26.188636191000057
						],
						[
							-80.13189295499996,
							26.188952650000033
						],
						[
							-80.12703579399994,
							26.18903906500003
						],
						[
							-80.127037,
							26.188868
						],
						[
							-80.127066,
							26.188761
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Oakland Park",
				"Name": "North Corals",
				"RegionID": "761150"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.13185272099997,
					26.17407058200007,
					-80.119366,
					26.183426318000045
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.119366,
							26.183261
						],
						[
							-80.11950461199996,
							26.182288289000045
						],
						[
							-80.119537,
							26.182061
						],
						[
							-80.11957462299995,
							26.18179813000006
						],
						[
							-80.11961489199996,
							26.181516776000024
						],
						[
							-80.11966191499994,
							26.18118823100008
						],
						[
							-80.119766,
							26.180461
						],
						[
							-80.11971460499996,
							26.178456591000042
						],
						[
							-80.11970984999994,
							26.178271132000077
						],
						[
							-80.119666,
							26.176233379000056
						],
						[
							-80.119666,
							26.17619784900006
						],
						[
							-80.119666,
							26.174922554000034
						],
						[
							-80.119666,
							26.174162292000062
						],
						[
							-80.12492794699995,
							26.17412158600007
						],
						[
							-80.12710774599998,
							26.174104542000066
						],
						[
							-80.13112596499997,
							26.174073123000028
						],
						[
							-80.13145090999996,
							26.17407058200007
						],
						[
							-80.13148787999995,
							26.174603690000026
						],
						[
							-80.13150699199997,
							26.175769570000057
						],
						[
							-80.13154521799999,
							26.177317707000043
						],
						[
							-80.13185189799998,
							26.183164801000032
						],
						[
							-80.13185272099997,
							26.18318776700005
						],
						[
							-80.12312562599999,
							26.18340525500003
						],
						[
							-80.12263595799999,
							26.183417458000065
						],
						[
							-80.12229011999995,
							26.183426318000045
						],
						[
							-80.122266,
							26.183161
						],
						[
							-80.122066,
							26.183161
						],
						[
							-80.121966,
							26.183161
						],
						[
							-80.12163974399994,
							26.183207608000032
						],
						[
							-80.12162760799998,
							26.183209342000055
						],
						[
							-80.121266,
							26.183261
						],
						[
							-80.119966,
							26.183261
						],
						[
							-80.11942769799998,
							26.183261
						],
						[
							-80.119366,
							26.183261
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Oakland Park",
				"Name": "Central Corals",
				"RegionID": "761151"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.13148787999995,
					26.166726254000025,
					-80.117066,
					26.174162292000062
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.117066,
							26.166962
						],
						[
							-80.11716400299997,
							26.166961066000056
						],
						[
							-80.11756651399998,
							26.166960500000076
						],
						[
							-80.11795921499998,
							26.166960988000028
						],
						[
							-80.118774,
							26.166962
						],
						[
							-80.119466,
							26.166962
						],
						[
							-80.119666,
							26.166962
						],
						[
							-80.119866,
							26.166962
						],
						[
							-80.12107470599994,
							26.16686902300006
						],
						[
							-80.12134402599997,
							26.166862000000002
						],
						[
							-80.121766,
							26.166862000000002
						],
						[
							-80.12181152899996,
							26.166862000000002
						],
						[
							-80.12196599299995,
							26.16686183300004
						],
						[
							-80.12215124199997,
							26.16686069900004
						],
						[
							-80.12245805699996,
							26.166858545000025
						],
						[
							-80.12352332699999,
							26.16685106600005
						],
						[
							-80.13135526099995,
							26.166726254000025
						],
						[
							-80.13141142799998,
							26.16829646700006
						],
						[
							-80.13148787999995,
							26.173304020000046
						],
						[
							-80.13145090999996,
							26.17407058200007
						],
						[
							-80.13112596499997,
							26.174073123000028
						],
						[
							-80.12710774599998,
							26.174104542000066
						],
						[
							-80.12492794699995,
							26.17412158600007
						],
						[
							-80.119666,
							26.174162292000062
						],
						[
							-80.119666,
							26.173662
						],
						[
							-80.119666,
							26.172962
						],
						[
							-80.11963431699996,
							26.172550500000057
						],
						[
							-80.11958501699996,
							26.171909998000046
						],
						[
							-80.11954817899993,
							26.171431013000074
						],
						[
							-80.11948412199996,
							26.17059774300003
						],
						[
							-80.119466,
							26.170362
						],
						[
							-80.11923696199995,
							26.169846665000023
						],
						[
							-80.119066,
							26.169462000000003
						],
						[
							-80.11891759799994,
							26.169276498000045
						],
						[
							-80.11848764399997,
							26.16873905500006
						],
						[
							-80.11800729199996,
							26.168138615000032
						],
						[
							-80.117066,
							26.166962
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Oakland Park",
				"Name": "South Corals",
				"RegionID": "761152"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.33524294999995,
					29.66672980900006,
					-82.33084389799996,
					29.670292588000056
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.33285264699998,
							29.670227100000037
						],
						[
							-82.33270778699995,
							29.67022313100006
						],
						[
							-82.33087178199997,
							29.670172830000066
						],
						[
							-82.33084389799996,
							29.66672980900006
						],
						[
							-82.33520217999995,
							29.666768606000065
						],
						[
							-82.33524294999995,
							29.670292588000056
						],
						[
							-82.33285264699998,
							29.670227100000037
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Alachua",
				"City": "Gainesville",
				"Name": "Gateway Park",
				"RegionID": "761433"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.33093151599996,
					29.661175488000026,
					-82.32449901299998,
					29.66672980900006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.33084389799996,
							29.66672980900006
						],
						[
							-82.32449901299998,
							29.66666396100004
						],
						[
							-82.32456352599996,
							29.661175488000026
						],
						[
							-82.33093151599996,
							29.66121187500005
						],
						[
							-82.33084389799996,
							29.66672980900006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Alachua",
				"City": "Gainesville",
				"Name": "Grove Street",
				"RegionID": "761434"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.33087491499998,
					29.65222908200008,
					-82.32496371799994,
					29.65953236000007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.33087491499998,
							29.65953236000007
						],
						[
							-82.32837803599995,
							29.659490325000036
						],
						[
							-82.32767047199997,
							29.65947841300005
						],
						[
							-82.32709938799997,
							29.659339175000074
						],
						[
							-82.32506163299996,
							29.65929924400007
						],
						[
							-82.32496371799994,
							29.652269002000025
						],
						[
							-82.33081190299998,
							29.65222908200008
						],
						[
							-82.33087491499998,
							29.65953236000007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Alachua",
				"City": "Gainesville",
				"Name": "Pleasent street",
				"RegionID": "761435"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.33925270399999,
					29.65204718200005,
					-82.33081190299998,
					29.65953236000007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.33921636499997,
							29.65919236800005
						],
						[
							-82.33768005,
							29.65938687100004
						],
						[
							-82.33087491499998,
							29.65953236000007
						],
						[
							-82.33081190299998,
							29.65222908200008
						],
						[
							-82.33925270399999,
							29.65204718200005
						],
						[
							-82.33924327299997,
							29.652815082000075
						],
						[
							-82.33919842599995,
							29.65581088200003
						],
						[
							-82.33921636499997,
							29.65919236800005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Alachua",
				"City": "Gainesville",
				"Name": "Fifth Avenue",
				"RegionID": "761436"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.35248125299995,
					29.68006034400003,
					-82.34180853299995,
					29.687678268000074
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.35239759999996,
							29.68130369200003
						],
						[
							-82.35234186999998,
							29.682151083000065
						],
						[
							-82.35230480099995,
							29.682517217000058
						],
						[
							-82.35204197899998,
							29.682467648000056
						],
						[
							-82.35193360499994,
							29.683352407000033
						],
						[
							-82.35202328099996,
							29.68519758700006
						],
						[
							-82.35244142899995,
							29.685416616000055
						],
						[
							-82.35248125299995,
							29.685894499000025
						],
						[
							-82.35023121999996,
							29.68595423500005
						],
						[
							-82.35013166099998,
							29.68663123500005
						],
						[
							-82.34951439599996,
							29.686651147000077
						],
						[
							-82.34929536599998,
							29.686332559000054
						],
						[
							-82.34857854099994,
							29.686292735000055
						],
						[
							-82.34861836499994,
							29.686730794000027
						],
						[
							-82.34740670799994,
							29.686664402000076
						],
						[
							-82.34740073099994,
							29.687678268000074
						],
						[
							-82.34577097899995,
							29.687626825000052
						],
						[
							-82.34581080299995,
							29.685894499000025
						],
						[
							-82.34462968099996,
							29.68587513600005
						],
						[
							-82.34493085099996,
							29.682353034000073
						],
						[
							-82.34222667999997,
							29.682270553000027
						],
						[
							-82.34180853299995,
							29.682250641000056
						],
						[
							-82.34196782699996,
							29.681693111000076
						],
						[
							-82.34292359299997,
							29.681633376000033
						],
						[
							-82.34300323999997,
							29.68006034400003
						],
						[
							-82.34388864699997,
							29.680454224000073
						],
						[
							-82.34437405699998,
							29.680839697000067
						],
						[
							-82.34547230199996,
							29.682031612000063
						],
						[
							-82.34705808899997,
							29.68203180700004
						],
						[
							-82.34742214699997,
							29.68203180700004
						],
						[
							-82.34745783899996,
							29.681275138000046
						],
						[
							-82.35084856999998,
							29.68131083000003
						],
						[
							-82.35239759999996,
							29.68130369200003
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Alachua",
				"City": "Gainesville",
				"Name": "Ridgeview",
				"RegionID": "761450"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.36415882799997,
					29.677392164000025,
					-82.35986646499998,
					29.681451728000074
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.36413305499997,
							29.677471535000052
						],
						[
							-82.36415882799997,
							29.681451728000074
						],
						[
							-82.35986646499998,
							29.681400542000066
						],
						[
							-82.35994817399995,
							29.677392164000025
						],
						[
							-82.36413305499997,
							29.677471535000052
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Alachua",
				"City": "Gainesville",
				"Name": "Royal Gardens",
				"RegionID": "761451"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.36747137199995,
					29.673956547000042,
					-82.36413200799996,
					29.681457315000046
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.36415882799997,
							29.681451728000074
						],
						[
							-82.36413305499997,
							29.677471535000052
						],
						[
							-82.36413200799996,
							29.677232800000073
						],
						[
							-82.36598692099994,
							29.677210552000076
						],
						[
							-82.36596892299997,
							29.675155510000025
						],
						[
							-82.36626021199999,
							29.675122220000045
						],
						[
							-82.36624029999996,
							29.674823543000056
						],
						[
							-82.36695712499994,
							29.67464433700008
						],
						[
							-82.36703677199995,
							29.67402707200006
						],
						[
							-82.36747133199998,
							29.673956547000042
						],
						[
							-82.36747137199995,
							29.681457315000046
						],
						[
							-82.36415882799997,
							29.681451728000074
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Alachua",
				"City": "Gainesville",
				"Name": "Edgewood Hills",
				"RegionID": "761452"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.37233285299999,
					29.688702062000058,
					-82.35976896799997,
					29.695974300000046
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.37230343299997,
							29.692384951000065
						],
						[
							-82.37233285299999,
							29.695974300000046
						],
						[
							-82.35980879199997,
							29.695910130000073
						],
						[
							-82.35976896799997,
							29.692286184000068
						],
						[
							-82.36385088499998,
							29.692425567000047
						],
						[
							-82.36397035599998,
							29.688702062000058
						],
						[
							-82.37227357299997,
							29.688741885000073
						],
						[
							-82.37230343299997,
							29.692384951000065
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Alachua",
				"City": "Gainesville",
				"Name": "Spring Tree",
				"RegionID": "761453"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.24657794499996,
					25.952515656000063,
					-80.22882005699995,
					25.96130986800006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.22909713199994,
							25.955575945000078
						],
						[
							-80.22901637099994,
							25.954310703000033
						],
						[
							-80.22899842499999,
							25.95378127600003
						],
						[
							-80.22896575399994,
							25.95358525000006
						],
						[
							-80.22882005699995,
							25.95271106900003
						],
						[
							-80.23096909799995,
							25.952687839000077
						],
						[
							-80.23106809799998,
							25.952686769000024
						],
						[
							-80.23268959099994,
							25.952515656000063
						],
						[
							-80.23348811499994,
							25.952637879000065
						],
						[
							-80.23383015899998,
							25.95265078700004
						],
						[
							-80.23391996899994,
							25.952654176000067
						],
						[
							-80.23433552799997,
							25.952564546000076
						],
						[
							-80.23746443799996,
							25.952515656000063
						],
						[
							-80.23741554799994,
							25.954161593000038
						],
						[
							-80.24116372199995,
							25.95415344500003
						],
						[
							-80.24199966999998,
							25.954128386000036
						],
						[
							-80.24201810399995,
							25.954761693000023
						],
						[
							-80.24310657099994,
							25.95500465400005
						],
						[
							-80.24392219399994,
							25.95519531900004
						],
						[
							-80.24447300399999,
							25.95529065200003
						],
						[
							-80.24537336599997,
							25.95546013200004
						],
						[
							-80.24589284899997,
							25.955450462000044
						],
						[
							-80.24592568699995,
							25.95572316500005
						],
						[
							-80.24647699499998,
							25.959647818000068
						],
						[
							-80.24657794499996,
							25.96015256900006
						],
						[
							-80.24648366399998,
							25.96130986800006
						],
						[
							-80.24526925499998,
							25.961226501000056
						],
						[
							-80.24457576699996,
							25.961178895000046
						],
						[
							-80.23618008199998,
							25.960808745000065
						],
						[
							-80.23331736699998,
							25.960730217000048
						],
						[
							-80.22968905099998,
							25.960630687000048
						],
						[
							-80.22943324799996,
							25.960623670000075
						],
						[
							-80.22930317199996,
							25.96061813500006
						],
						[
							-80.22930351799995,
							25.959703683000043
						],
						[
							-80.22915097199996,
							25.957334720000063
						],
						[
							-80.22912045799995,
							25.956337919000077
						],
						[
							-80.2291135899999,
							25.956113567000045
						],
						[
							-80.22910485799997,
							25.955828335000035
						],
						[
							-80.22909973499998,
							25.955660971000043
						],
						[
							-80.22909713199994,
							25.955575945000078
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Gardens",
				"Name": "Dolphin Stadium",
				"RegionID": "761650"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.7283799999999,
					27.77081000000004,
					-82.71221998899995,
					27.777159837000056
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.71679072899991,
							27.777159837000056
						],
						[
							-82.71622999999994,
							27.777150000000063
						],
						[
							-82.71544382999991,
							27.777150000000063
						],
						[
							-82.7147250129999,
							27.777150000000063
						],
						[
							-82.7143299999999,
							27.777150000000063
						],
						[
							-82.71364678899994,
							27.777150000000063
						],
						[
							-82.71227208199991,
							27.777150000000063
						],
						[
							-82.71226999999993,
							27.777150000000063
						],
						[
							-82.71226999999993,
							27.777037773000078
						],
						[
							-82.71226999999993,
							27.77656051200006
						],
						[
							-82.71226999999993,
							27.77639000000005
						],
						[
							-82.71226999999993,
							27.77624233800009
						],
						[
							-82.71226999999993,
							27.775866314000044
						],
						[
							-82.71226999999993,
							27.77547000000004
						],
						[
							-82.71226726899994,
							27.775345754000057
						],
						[
							-82.71226217899994,
							27.775114149000046
						],
						[
							-82.71225423699991,
							27.77475276200005
						],
						[
							-82.71224999999993,
							27.774560000000065
						],
						[
							-82.71224999999993,
							27.774347755000065
						],
						[
							-82.71224999999993,
							27.774029581000036
						],
						[
							-82.71224999999993,
							27.773720000000086
						],
						[
							-82.71224999999993,
							27.773580000000038
						],
						[
							-82.7122471209999,
							27.77333532700004
						],
						[
							-82.71224337699994,
							27.77301702700004
						],
						[
							-82.7122404889999,
							27.77277153900008
						],
						[
							-82.71223999999997,
							27.772265160000078
						],
						[
							-82.71223999999997,
							27.77177000000006
						],
						[
							-82.71223590499994,
							27.77160004300004
						],
						[
							-82.71222997499991,
							27.771353976000057
						],
						[
							-82.71222474299992,
							27.77113681700007
						],
						[
							-82.71221999999995,
							27.77090000000004
						],
						[
							-82.71221998899995,
							27.770899142000076
						],
						[
							-82.71256842199995,
							27.770896313000037
						],
						[
							-82.71310747299992,
							27.77089060900005
						],
						[
							-82.71342287099992,
							27.77088727100005
						],
						[
							-82.71476963699992,
							27.77088315600008
						],
						[
							-82.71517439199994,
							27.77088509300006
						],
						[
							-82.71566856699991,
							27.77088745700007
						],
						[
							-82.7161999999999,
							27.770890000000065
						],
						[
							-82.7166568319999,
							27.770890000000065
						],
						[
							-82.71733102299993,
							27.770884000000084
						],
						[
							-82.7178257939999,
							27.77087620800006
						],
						[
							-82.71821999999992,
							27.770830000000046
						],
						[
							-82.71935239299995,
							27.77087000000006
						],
						[
							-82.72023999999993,
							27.77082000000007
						],
						[
							-82.72074509999993,
							27.77087000000006
						],
						[
							-82.72128421199994,
							27.77087000000006
						],
						[
							-82.72231999999993,
							27.77082000000007
						],
						[
							-82.7231264109999,
							27.770865877000066
						],
						[
							-82.72428999999994,
							27.77081000000004
						],
						[
							-82.7253277239999,
							27.77085496300009
						],
						[
							-82.72634999999991,
							27.77081000000004
						],
						[
							-82.72748359799995,
							27.770855546000064
						],
						[
							-82.72836999999993,
							27.770860000000084
						],
						[
							-82.72837012699995,
							27.770860000000084
						],
						[
							-82.7283738559999,
							27.771223871000075
						],
						[
							-82.7283799999999,
							27.77174000000008
						],
						[
							-82.7283799999999,
							27.77216774900006
						],
						[
							-82.7283799999999,
							27.772572083000057
						],
						[
							-82.7283799999999,
							27.772850000000062
						],
						[
							-82.72837428899993,
							27.773515433000057
						],
						[
							-82.7283322909999,
							27.774188499000047
						],
						[
							-82.72833999999995,
							27.774520000000056
						],
						[
							-82.72833672099995,
							27.774818375000056
						],
						[
							-82.72833277199993,
							27.775177739000075
						],
						[
							-82.72832999999991,
							27.775430000000085
						],
						[
							-82.72832731299991,
							27.77567186400006
						],
						[
							-82.72832232099995,
							27.776121069000055
						],
						[
							-82.72831999999994,
							27.776330000000087
						],
						[
							-82.7283175579999,
							27.776525322000055
						],
						[
							-82.72831305299991,
							27.77688579700009
						],
						[
							-82.72830999999991,
							27.777130000000056
						],
						[
							-82.72637999999995,
							27.777140000000088
						],
						[
							-82.72595651799992,
							27.777140000000088
						],
						[
							-82.72537247999992,
							27.777140000000088
						],
						[
							-82.72460873799992,
							27.777140000000088
						],
						[
							-82.72430999999995,
							27.777140000000088
						],
						[
							-82.72362023199992,
							27.77713658500005
						],
						[
							-82.72285650799995,
							27.777132804000075
						],
						[
							-82.72228999999993,
							27.777130000000056
						],
						[
							-82.7219134149999,
							27.77713372900007
						],
						[
							-82.72128451299994,
							27.777139955000052
						],
						[
							-82.72056576699993,
							27.777147072000048
						],
						[
							-82.72026999999991,
							27.777150000000063
						],
						[
							-82.71975672799995,
							27.777150000000063
						],
						[
							-82.71881300599995,
							27.777144512000064
						],
						[
							-82.71823999999994,
							27.777140000000088
						],
						[
							-82.71773567399993,
							27.777142346000062
						],
						[
							-82.71710693399991,
							27.77715420900006
						],
						[
							-82.71679072899991,
							27.777159837000056
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Lake Pasadena",
				"RegionID": "416375"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.54588383899986,
					30.4992918720001,
					-81.49216616999986,
					30.545483067000237
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.50107213999982,
							30.542128434000052
						],
						[
							-81.49967266799968,
							30.541359527000115
						],
						[
							-81.49953592699981,
							30.54126492000019
						],
						[
							-81.49948798199975,
							30.541221664000165
						],
						[
							-81.49901395299979,
							30.54076205800015
						],
						[
							-81.49810897199978,
							30.539982306000116
						],
						[
							-81.4980070799998,
							30.539879073000186
						],
						[
							-81.49795281199974,
							30.5398074110003
						],
						[
							-81.4975260659997,
							30.53918113600009
						],
						[
							-81.49696026899977,
							30.53879968200032
						],
						[
							-81.49692061199987,
							30.538771352000108
						],
						[
							-81.49667461199985,
							30.53858535300008
						],
						[
							-81.49662494999983,
							30.538545816000457
						],
						[
							-81.49657860399972,
							30.538502438000243
						],
						[
							-81.49653587099975,
							30.53845549800009
						],
						[
							-81.49649702499983,
							30.538405294000196
						],
						[
							-81.49646231199988,
							30.538352147000147
						],
						[
							-81.49646865899977,
							30.53837583400007
						],
						[
							-81.49647569999992,
							30.538423069000157
						],
						[
							-81.49633758199985,
							30.53804745900017
						],
						[
							-81.49632581599968,
							30.537982219000096
						],
						[
							-81.49631921299977,
							30.53791625700015
						],
						[
							-81.49631781399982,
							30.53784997900017
						],
						[
							-81.49632162899978,
							30.5377837970002
						],
						[
							-81.49635162899978,
							30.537464797000098
						],
						[
							-81.49636206399984,
							30.53738878800011
						],
						[
							-81.49637893899973,
							30.537313945000047
						],
						[
							-81.4964021319996,
							30.537240813000036
						],
						[
							-81.49643147499981,
							30.53716992400012
						],
						[
							-81.49677621199973,
							30.536428272000045
						],
						[
							-81.49688238599973,
							30.536087491000178
						],
						[
							-81.49690633799985,
							30.536020159000117
						],
						[
							-81.49693556099986,
							30.53595494100005
						],
						[
							-81.49696986999986,
							30.535892250000103
						],
						[
							-81.49700904899981,
							30.53583248000013
						],
						[
							-81.4970528499998,
							30.535776011000163
						],
						[
							-81.49710099599979,
							30.535723197000056
						],
						[
							-81.49715318499975,
							30.535674374000013
						],
						[
							-81.49746118399985,
							30.535408373000124
						],
						[
							-81.49757796599964,
							30.535322901000153
						],
						[
							-81.49800896599986,
							30.535057902000165
						],
						[
							-81.49806929599978,
							30.5350239360002
						],
						[
							-81.49813206099974,
							30.53499471200009
						],
						[
							-81.49819688699986,
							30.534970404000035
						],
						[
							-81.49859788699983,
							30.53483740400022
						],
						[
							-81.49867056999972,
							30.5348166500001
						],
						[
							-81.49874473799971,
							30.534802068000133
						],
						[
							-81.49881986799981,
							30.53479376300043
						],
						[
							-81.49889542999975,
							30.53479179300009
						],
						[
							-81.49897089099987,
							30.53479617000018
						],
						[
							-81.49904571799993,
							30.53480686600018
						],
						[
							-81.49911938399981,
							30.53482380300007
						],
						[
							-81.49959065099982,
							30.53452741900042
						],
						[
							-81.4998793349998,
							30.534258942000143
						],
						[
							-81.50008175699986,
							30.53399833400007
						],
						[
							-81.50012721699989,
							30.53394432300013
						],
						[
							-81.50017677399981,
							30.53389404400015
						],
						[
							-81.50023012199988,
							30.533847808000406
						],
						[
							-81.50028693299987,
							30.533805898000136
						],
						[
							-81.50034685599985,
							30.53376857400007
						],
						[
							-81.5004095219998,
							30.53373606500013
						],
						[
							-81.50047454499985,
							30.53370857100017
						],
						[
							-81.50072499599979,
							30.533614081000167
						],
						[
							-81.5007831639998,
							30.53348933900015
						],
						[
							-81.50087307899979,
							30.53336092700018
						],
						[
							-81.50098392699981,
							30.533250079000243
						],
						[
							-81.50111233899987,
							30.533160164
						],
						[
							-81.50120644999993,
							30.533112946000177
						],
						[
							-81.50151544999981,
							30.532979946000186
						],
						[
							-81.5015847119996,
							30.532953463000037
						],
						[
							-81.50165591999972,
							30.532932776000013
						],
						[
							-81.50172858999969,
							30.53291802500013
						],
						[
							-81.50180222899984,
							30.532909311000466
						],
						[
							-81.50206627299983,
							30.53288906000013
						],
						[
							-81.5024255009997,
							30.53279988000021
						],
						[
							-81.50262312599972,
							30.532751387000197
						],
						[
							-81.50278957399972,
							30.532590797000225
						],
						[
							-81.50283592699974,
							30.532549079000148
						],
						[
							-81.50296049199974,
							30.53246139800009
						],
						[
							-81.5047354409997,
							30.531424890000487
						],
						[
							-81.50557151299986,
							30.530704832000417
						],
						[
							-81.50570677499978,
							30.53060848900017
						],
						[
							-81.50576652799975,
							30.53047764100018
						],
						[
							-81.50584087299977,
							30.530342858000484
						],
						[
							-81.50572018599982,
							30.530238628000035
						],
						[
							-81.5056190799998,
							30.53013607300016
						],
						[
							-81.50552916499974,
							30.530007661000194
						],
						[
							-81.50546291399985,
							30.529865586000074
						],
						[
							-81.50542234099987,
							30.529714166000158
						],
						[
							-81.5054181419997,
							30.529688121000046
						],
						[
							-81.50536950599985,
							30.529355516000148
						],
						[
							-81.50510128999977,
							30.528620496000084
						],
						[
							-81.50467105199971,
							30.527994752
						],
						[
							-81.50423815399995,
							30.52735496900009
						],
						[
							-81.50420416499979,
							30.527300661000215
						],
						[
							-81.50413791399973,
							30.52715858700036
						],
						[
							-81.50409734099975,
							30.527007166000534
						],
						[
							-81.50408367799977,
							30.526851000000043
						],
						[
							-81.50408526099982,
							30.526797670000075
						],
						[
							-81.50410082699986,
							30.526535639000155
						],
						[
							-81.50405457199986,
							30.52644442100007
						],
						[
							-81.50400516599967,
							30.526457659000098
						],
						[
							-81.50389428899985,
							30.526470181000427
						],
						[
							-81.50377528899975,
							30.52647618100021
						],
						[
							-81.50372999999982,
							30.52647732200039
						],
						[
							-81.50357383499987,
							30.526463659000065
						],
						[
							-81.50342241399977,
							30.526423086000527
						],
						[
							-81.50328033899983,
							30.526356836000016
						],
						[
							-81.50319041099985,
							30.526297461000343
						],
						[
							-81.50311841099993,
							30.52624346100014
						],
						[
							-81.50305833899994,
							30.52619421500015
						],
						[
							-81.50300274099969,
							30.526139968000013
						],
						[
							-81.50295203199994,
							30.52608112600012
						],
						[
							-81.50290658899972,
							30.526018128000057
						],
						[
							-81.5028667519998,
							30.52595144400005
						],
						[
							-81.50283281799975,
							30.525881570000124
						],
						[
							-81.50280681899983,
							30.525821570000137
						],
						[
							-81.50278058399986,
							30.52575360400038
						],
						[
							-81.50275993599985,
							30.525683736000097
						],
						[
							-81.50274501099977,
							30.52561242700033
						],
						[
							-81.50273590699982,
							30.52554014400012
						],
						[
							-81.50273268399972,
							30.525467361000047
						],
						[
							-81.50273536299986,
							30.52539455600016
						],
						[
							-81.50274392699987,
							30.52532220700012
						],
						[
							-81.50276413399966,
							30.525196021000163
						],
						[
							-81.50280591399984,
							30.52503741400027
						],
						[
							-81.50282918899971,
							30.524979751000206
						],
						[
							-81.5029576939997,
							30.52469061500044
						],
						[
							-81.50296136599991,
							30.524611581000123
						],
						[
							-81.50284807299985,
							30.52472592100016
						],
						[
							-81.50271966099989,
							30.524815836000233
						],
						[
							-81.50257758699978,
							30.524882086000208
						],
						[
							-81.50242616599976,
							30.524922659000104
						],
						[
							-81.50226999999981,
							30.52493632200008
						],
						[
							-81.50211383499986,
							30.524922659000104
						],
						[
							-81.50196241399986,
							30.524882086000208
						],
						[
							-81.50188811299984,
							30.524851213000055
						],
						[
							-81.50169594199983,
							30.524761079000054
						],
						[
							-81.50140294299966,
							30.524737078000115
						],
						[
							-81.50106083399986,
							30.524858513000297
						],
						[
							-81.50093552399971,
							30.524893027000136
						],
						[
							-81.49973452499972,
							30.525132027000367
						],
						[
							-81.49964949999979,
							30.52514475700018
						],
						[
							-81.49920543899974,
							30.525189671000522
						],
						[
							-81.49872767999982,
							30.525326543000123
						],
						[
							-81.49865832599994,
							30.525343465000102
						],
						[
							-81.4985878479997,
							30.52535483200007
						],
						[
							-81.49851669099968,
							30.525360573000274
						],
						[
							-81.49844530199981,
							30.525360652000195
						],
						[
							-81.4983741319997,
							30.525355069000177
						],
						[
							-81.4983036289999,
							30.52534385800005
						],
						[
							-81.49790362799968,
							30.525263858000176
						],
						[
							-81.49783001699971,
							30.5252458830002
						],
						[
							-81.49775818199963,
							30.52522177300016
						],
						[
							-81.49768863099982,
							30.525191700000068
						],
						[
							-81.49762185999963,
							30.525155878000128
						],
						[
							-81.4975583419997,
							30.52511456000008
						],
						[
							-81.4974985299999,
							30.52506804100005
						],
						[
							-81.49721713299981,
							30.524827162000282
						],
						[
							-81.49711307999972,
							30.524722073000202
						],
						[
							-81.49708243799977,
							30.52468345400011
						],
						[
							-81.49646543799969,
							30.52386045400005
						],
						[
							-81.49639244399987,
							30.52374601300027
						],
						[
							-81.4954661109997,
							30.522018605000163
						],
						[
							-81.49485323299979,
							30.521164175000163
						],
						[
							-81.49480490099997,
							30.52108358200016
						],
						[
							-81.49426281699988,
							30.52016468700007
						],
						[
							-81.49303877899985,
							30.518664252000175
						],
						[
							-81.49224907699988,
							30.51755866900009
						],
						[
							-81.49216616999986,
							30.51673234900011
						],
						[
							-81.49220487599978,
							30.516678016000146
						],
						[
							-81.49221520799983,
							30.516665759000112
						],
						[
							-81.4922478689997,
							30.51662700800019
						],
						[
							-81.49229486299986,
							30.516579661000087
						],
						[
							-81.49234554899986,
							30.516536289000054
						],
						[
							-81.49246454899968,
							30.516442289000274
						],
						[
							-81.49257233899982,
							30.51636916400053
						],
						[
							-81.49265628599983,
							30.51632639600019
						],
						[
							-81.49282028599963,
							30.516253396000184
						],
						[
							-81.4928802419997,
							30.516229251000052
						],
						[
							-81.49294177799982,
							30.5162094740001
						],
						[
							-81.49300457599986,
							30.516194168000077
						],
						[
							-81.4930683099999,
							30.51618341200008
						],
						[
							-81.49477860499984,
							30.51595765300032
						],
						[
							-81.49618525399978,
							30.515642731000195
						],
						[
							-81.4973910029997,
							30.515080212000104
						],
						[
							-81.49747515099983,
							30.514977917000078
						],
						[
							-81.49743766599975,
							30.514859587000053
						],
						[
							-81.4974093399998,
							30.5147441650001
						],
						[
							-81.49739567799975,
							30.514588000000053
						],
						[
							-81.4974093399998,
							30.514431834000106
						],
						[
							-81.49744991299961,
							30.514280413000094
						],
						[
							-81.49751616399985,
							30.51413833900007
						],
						[
							-81.49760607899974,
							30.514009927000103
						],
						[
							-81.49771692699994,
							30.513899079000165
						],
						[
							-81.4977635299998,
							30.51386252000025
						],
						[
							-81.49838053099978,
							30.513410520000154
						],
						[
							-81.49846233899972,
							30.513357164000176
						],
						[
							-81.4986050029998,
							30.5132906990001
						],
						[
							-81.49907408899979,
							30.513120705000066
						],
						[
							-81.49923267099967,
							30.51300712700008
						],
						[
							-81.49967441499973,
							30.512424598000113
						],
						[
							-81.49973799099983,
							30.51234964800013
						],
						[
							-81.50034896199985,
							30.511704434000215
						],
						[
							-81.50064212399977,
							30.511217786000092
						],
						[
							-81.50068277299975,
							30.51108625400004
						],
						[
							-81.5004728529997,
							30.51065350600012
						],
						[
							-81.50043691399975,
							30.5105685860002
						],
						[
							-81.50040785999975,
							30.510472330000056
						],
						[
							-81.50026372699982,
							30.509876140000465
						],
						[
							-81.50003135199995,
							30.50919885300011
						],
						[
							-81.50002277499986,
							30.50917254000051
						],
						[
							-81.49999416299971,
							30.509079959000047
						],
						[
							-81.49958214599974,
							30.508805281000054
						],
						[
							-81.4995231109999,
							30.508762798000177
						],
						[
							-81.49946787599968,
							30.50871548
						],
						[
							-81.4994168349999,
							30.508663666000153
						],
						[
							-81.49937035399988,
							30.508607724000136
						],
						[
							-81.49932876499973,
							30.508548057000088
						],
						[
							-81.49929236499973,
							30.508485089000207
						],
						[
							-81.49926141399975,
							30.50841927100009
						],
						[
							-81.49918583499982,
							30.50841265900043
						],
						[
							-81.49916471299983,
							30.50840867400019
						],
						[
							-81.49828916899969,
							30.508232619000452
						],
						[
							-81.49741542599978,
							30.50815697000015
						],
						[
							-81.49731988299969,
							30.50814350300001
						],
						[
							-81.49664188399981,
							30.508010503000197
						],
						[
							-81.49657144999985,
							30.50799371600032
						],
						[
							-81.49650259399992,
							30.50797131700033
						],
						[
							-81.4964357639999,
							30.507943451000155
						],
						[
							-81.4963713919999,
							30.50791030000017
						],
						[
							-81.49630989599979,
							30.507872077000115
						],
						[
							-81.49625167399995,
							30.507829031000103
						],
						[
							-81.49619710399969,
							30.507781441000073
						],
						[
							-81.49614653899977,
							30.507729615000404
						],
						[
							-81.49497653899986,
							30.5064296140004
						],
						[
							-81.49488787199981,
							30.506313322000373
						],
						[
							-81.4933558719998,
							30.50392332200015
						],
						[
							-81.49333416499978,
							30.50388766100013
						],
						[
							-81.4932679139998,
							30.503745586000367
						],
						[
							-81.49322734099974,
							30.503594166000095
						],
						[
							-81.49321367799985,
							30.503438000000145
						],
						[
							-81.49322734099974,
							30.5032818350001
						],
						[
							-81.4932679139998,
							30.503130414000275
						],
						[
							-81.49327477199984,
							30.503112187000273
						],
						[
							-81.49360477199978,
							30.50226318700037
						],
						[
							-81.49362581299975,
							30.50220434900012
						],
						[
							-81.49365274999967,
							30.502147966000162
						],
						[
							-81.49368530299988,
							30.502094628000194
						],
						[
							-81.4937231309999,
							30.50204489200052
						],
						[
							-81.4937658389997,
							30.50199927700003
						],
						[
							-81.49438127199981,
							30.50174982000008
						],
						[
							-81.49577312199996,
							30.50097986000015
						],
						[
							-81.49630617099983,
							30.500861405000204
						],
						[
							-81.49701690299993,
							30.50097986000015
						],
						[
							-81.4983495259998,
							30.50160175100018
						],
						[
							-81.50033365199991,
							30.50219402700015
						],
						[
							-81.5009851569999,
							30.50219402700015
						],
						[
							-81.5021400959999,
							30.501868275000025
						],
						[
							-81.50323580799989,
							30.501660978000192
						],
						[
							-81.5040057669999,
							30.50172020600012
						],
						[
							-81.50453881599987,
							30.502105186000176
						],
						[
							-81.50495340999989,
							30.50257900700003
						],
						[
							-81.5053087759999,
							30.503497036000052
						],
						[
							-81.50548645899994,
							30.50450390600005
						],
						[
							-81.50596027999988,
							30.504829658000176
						],
						[
							-81.50673023999991,
							30.50491850000007
						],
						[
							-81.50714483299993,
							30.50447429200009
						],
						[
							-81.50761865499987,
							30.50337858000002
						],
						[
							-81.50806286199986,
							30.50237171000002
						],
						[
							-81.50853668299989,
							30.5018090470001
						],
						[
							-81.50957316699994,
							30.501335226000062
						],
						[
							-81.51016544399992,
							30.501335226000062
						],
						[
							-81.51105385899989,
							30.500891019000168
						],
						[
							-81.5116165219999,
							30.5001506730002
						],
						[
							-81.51209034299984,
							30.4992918720001
						],
						[
							-81.5126233919999,
							30.499617624000056
						],
						[
							-81.51309721299994,
							30.500061831000128
						],
						[
							-81.51321566799987,
							30.50092063200022
						],
						[
							-81.5136894899999,
							30.501453681000005
						],
						[
							-81.51537747799995,
							30.502075572000212
						],
						[
							-81.51777619799992,
							30.502934373000127
						],
						[
							-81.51925688999995,
							30.50323051100012
						],
						[
							-81.52053572099989,
							30.503510322000086
						],
						[
							-81.52059107299985,
							30.503549080000095
						],
						[
							-81.52060031099981,
							30.50355831800015
						],
						[
							-81.52070192099978,
							30.50365992700012
						],
						[
							-81.52079183599994,
							30.503788339000085
						],
						[
							-81.52085808599973,
							30.503930414000205
						],
						[
							-81.52089865899973,
							30.50408183500021
						],
						[
							-81.52091232199979,
							30.504238000000434
						],
						[
							-81.52089865899973,
							30.504394166000388
						],
						[
							-81.52085808599973,
							30.504545586000127
						],
						[
							-81.52079183599994,
							30.50468766100007
						],
						[
							-81.52070192099978,
							30.504816073000207
						],
						[
							-81.52068202799983,
							30.504838984000063
						],
						[
							-81.51934828599978,
							30.506323733000436
						],
						[
							-81.51902170099976,
							30.50750302000022
						],
						[
							-81.51900087699981,
							30.507568404000125
						],
						[
							-81.51897512899981,
							30.507632010000055
						],
						[
							-81.51894460499987,
							30.507693468000344
						],
						[
							-81.51890948499971,
							30.50775242000025
						],
						[
							-81.51886997199982,
							30.507808522000445
						],
						[
							-81.51882629699985,
							30.50786144900012
						],
						[
							-81.51834525399975,
							30.50840104800027
						],
						[
							-81.51887351299968,
							30.50893873000017
						],
						[
							-81.51892091999977,
							30.50899092700014
						],
						[
							-81.51901083499966,
							30.509119339000108
						],
						[
							-81.51907708599973,
							30.50926141400005
						],
						[
							-81.5191176589997,
							30.509412835000056
						],
						[
							-81.51913132199978,
							30.509569000000273
						],
						[
							-81.51912993299993,
							30.509618958000143
						],
						[
							-81.51907610199973,
							30.51058651500017
						],
						[
							-81.5194493299998,
							30.51093974000036
						],
						[
							-81.5203352589999,
							30.51140944300005
						],
						[
							-81.52036308399965,
							30.511424831000085
						],
						[
							-81.52146308499971,
							30.512058832000044
						],
						[
							-81.52157228999985,
							30.51213295200014
						],
						[
							-81.52290673499986,
							30.513189629000088
						],
						[
							-81.52438636499981,
							30.51223200600017
						],
						[
							-81.52445248299986,
							30.51219311100005
						],
						[
							-81.52452167499982,
							30.51215999200007
						],
						[
							-81.5245934379999,
							30.51213289000014
						],
						[
							-81.52466724899988,
							30.512112003000095
						],
						[
							-81.5247425719998,
							30.51209748100014
						],
						[
							-81.52545457199983,
							30.511991482000155
						],
						[
							-81.52560856299986,
							30.51198193700017
						],
						[
							-81.52665823899986,
							30.512007113000124
						],
						[
							-81.52669486499968,
							30.511957753000118
						],
						[
							-81.52673512799973,
							30.511911311000187
						],
						[
							-81.52677879499979,
							30.51186805600007
						],
						[
							-81.52682561699984,
							30.511828235000067
						],
						[
							-81.52719661699972,
							30.511535235000153
						],
						[
							-81.52730433899967,
							30.51146216500015
						],
						[
							-81.52744641299988,
							30.511395914000264
						],
						[
							-81.52759783399988,
							30.511355341000193
						],
						[
							-81.52775399999985,
							30.511341678000395
						],
						[
							-81.52779920699993,
							30.511342815000045
						],
						[
							-81.52869197799981,
							30.51138775000012
						],
						[
							-81.5293392069999,
							30.511185566000265
						],
						[
							-81.52966142999992,
							30.510747291000158
						],
						[
							-81.52970199399981,
							30.510696120000098
						],
						[
							-81.52974616499982,
							30.510648026000204
						],
						[
							-81.52979370899993,
							30.51060326400005
						],
						[
							-81.52984437499968,
							30.51056207000002
						],
						[
							-81.52989789699967,
							30.510524662000297
						],
						[
							-81.53051689799975,
							30.510124661000155
						],
						[
							-81.5305553389998,
							30.510101164000076
						],
						[
							-81.53069741399985,
							30.510034913000187
						],
						[
							-81.53084883499974,
							30.50999434000012
						],
						[
							-81.53100499999972,
							30.50998067800005
						],
						[
							-81.53116116599983,
							30.50999434000012
						],
						[
							-81.53130977899978,
							30.510033897000103
						],
						[
							-81.53167775699977,
							30.510166291000047
						],
						[
							-81.53171216499987,
							30.510083339000108
						],
						[
							-81.53178374199983,
							30.509981116000088
						],
						[
							-81.53172363799983,
							30.509942434000088
						],
						[
							-81.53166683499967,
							30.509899050000048
						],
						[
							-81.5316136999998,
							30.50985124300009
						],
						[
							-81.53156457599982,
							30.509799324000145
						],
						[
							-81.53151978099993,
							30.509743626000155
						],
						[
							-81.53147960399971,
							30.50968451100015
						],
						[
							-81.53144430499972,
							30.509622360000424
						],
						[
							-81.53138530499983,
							30.50950836000005
						],
						[
							-81.5313497019998,
							30.509430750000025
						],
						[
							-81.53131670299973,
							30.50934875000035
						],
						[
							-81.53130591399973,
							30.509320586000502
						],
						[
							-81.53126534099975,
							30.509169166000053
						],
						[
							-81.53125167799986,
							30.509013000000095
						],
						[
							-81.53126534099975,
							30.50885683400015
						],
						[
							-81.53130591399973,
							30.50870541400041
						],
						[
							-81.53134271799966,
							30.508618716000164
						],
						[
							-81.53138271799978,
							30.50853671600048
						],
						[
							-81.53141105599991,
							30.508483265000056
						],
						[
							-81.53144292299979,
							30.508431839000238
						],
						[
							-81.53147817599995,
							30.508382673000085
						],
						[
							-81.53151665499969,
							30.508335988000216
						],
						[
							-81.53162165499974,
							30.50821698800014
						],
						[
							-81.5316705479998,
							30.50816578800017
						],
						[
							-81.5317233159999,
							30.50811859300008
						],
						[
							-81.53177963299976,
							30.508075695000084
						],
						[
							-81.5318391499998,
							30.508037359000284
						],
						[
							-81.53190149799971,
							30.508003824000088
						],
						[
							-81.53196629099975,
							30.507975297000304
						],
						[
							-81.5324712909997,
							30.507776298000095
						],
						[
							-81.53253497599972,
							30.507753925000106
						],
						[
							-81.5326001589998,
							30.50773639200017
						],
						[
							-81.53266647399977,
							30.507723797000097
						],
						[
							-81.5327335469999,
							30.507716212000094
						],
						[
							-81.53280099999971,
							30.507713678000062
						],
						[
							-81.5331477149998,
							30.507713678000062
						],
						[
							-81.53359099999989,
							30.50765897100007
						],
						[
							-81.53385575699986,
							30.50732081100033
						],
						[
							-81.53387516899987,
							30.507226569000174
						],
						[
							-81.5338914679997,
							30.507160279000193
						],
						[
							-81.53391274899977,
							30.507095416000244
						],
						[
							-81.53393888799971,
							30.50703235500009
						],
						[
							-81.53396973499979,
							30.506971458000116
						],
						[
							-81.5340051129997,
							30.506913076000433
						],
						[
							-81.53404481699987,
							30.506857546000102
						],
						[
							-81.5342136569999,
							30.50663940500026
						],
						[
							-81.53420358899967,
							30.506572147000206
						],
						[
							-81.53419561699991,
							30.506498025000106
						],
						[
							-81.53419381099967,
							30.506423499000157
						],
						[
							-81.53419818499985,
							30.506349078000135
						],
						[
							-81.53420870699985,
							30.506275276000064
						],
						[
							-81.53422530499988,
							30.50620259900018
						],
						[
							-81.53427219699994,
							30.506030485000327
						],
						[
							-81.5342481169999,
							30.505723783000175
						],
						[
							-81.53433032899996,
							30.505362707000142
						],
						[
							-81.53548526899995,
							30.50411892600017
						],
						[
							-81.53699557399995,
							30.503052828000072
						],
						[
							-81.53841703799986,
							30.50172020600012
						],
						[
							-81.5390389279999,
							30.50139445400017
						],
						[
							-81.5395423639999,
							30.50151290900011
						],
						[
							-81.53989772999991,
							30.5018090470001
						],
						[
							-81.54016425399995,
							30.50219402700015
						],
						[
							-81.54016425399995,
							30.502697462000153
						],
						[
							-81.54012891999993,
							30.503163073000046
						],
						[
							-81.54001807299984,
							30.503273921000154
						],
						[
							-81.53994767699986,
							30.503327324000043
						],
						[
							-81.53988599999991,
							30.50336950500007
						],
						[
							-81.53987106299982,
							30.50338833500003
						],
						[
							-81.53939163599978,
							30.504675540000044
						],
						[
							-81.53915332199996,
							30.50569292300011
						],
						[
							-81.53915332199996,
							30.50628398100016
						],
						[
							-81.5391569139998,
							30.506270414000195
						],
						[
							-81.53916685899992,
							30.50624435400017
						],
						[
							-81.53905463799987,
							30.506897843000154
						],
						[
							-81.53917523599989,
							30.507897086000142
						],
						[
							-81.53934751899996,
							30.509171982000108
						],
						[
							-81.53946811799989,
							30.50975774500017
						],
						[
							-81.53977822799988,
							30.510498563000183
						],
						[
							-81.54038121899994,
							30.511136011000165
						],
						[
							-81.54119094999989,
							30.51151503400017
						],
						[
							-81.54256921599996,
							30.51168731800004
						],
						[
							-81.54343063299991,
							30.51168731800004
						],
						[
							-81.54419558399988,
							30.511916649000092
						],
						[
							-81.54423105499973,
							30.51194160400012
						],
						[
							-81.5445080369999,
							30.512178128000148
						],
						[
							-81.54455872699972,
							30.51222311800014
						],
						[
							-81.54460537399977,
							30.512272288000123
						],
						[
							-81.5446476349998,
							30.51232527500015
						],
						[
							-81.54468519899989,
							30.512381689000385
						],
						[
							-81.54471778999994,
							30.512441115000506
						],
						[
							-81.5447451659999,
							30.512503116000214
						],
						[
							-81.54480463499992,
							30.513182451000024
						],
						[
							-81.54446156499995,
							30.513920051000127
						],
						[
							-81.5439639729999,
							30.514453546000126
						],
						[
							-81.5421176599999,
							30.515659027000304
						],
						[
							-81.54204758199988,
							30.515700386000436
						],
						[
							-81.54135901699975,
							30.516065808000118
						],
						[
							-81.54114846599991,
							30.516421465000146
						],
						[
							-81.5407049509999,
							30.516904758000077
						],
						[
							-81.5407392579999,
							30.5174536700002
						],
						[
							-81.54109948099995,
							30.517968274000147
						],
						[
							-81.54161408599981,
							30.518242730000114
						],
						[
							-81.54327797399989,
							30.518654414000075
						],
						[
							-81.54447871899986,
							30.519254786000186
						],
						[
							-81.54545646799994,
							30.51999238600011
						],
						[
							-81.54576764399992,
							30.52070619500011
						],
						[
							-81.54587865299969,
							30.52169018200043
						],
						[
							-81.54588383899986,
							30.521820469000108
						],
						[
							-81.54587381799973,
							30.522126103000172
						],
						[
							-81.54587970799987,
							30.52218401500017
						],
						[
							-81.5456117439999,
							30.522963250000075
						],
						[
							-81.5455170729998,
							30.523057920000088
						],
						[
							-81.54543785499982,
							30.52311728100012
						],
						[
							-81.54526085399974,
							30.523235281000108
						],
						[
							-81.54519343899993,
							30.523276075000283
						],
						[
							-81.54512271199985,
							30.52331081200005
						],
						[
							-81.54504921599981,
							30.52333922500036
						],
						[
							-81.54497351399976,
							30.523361095000038
						],
						[
							-81.54388251399982,
							30.523625095000387
						],
						[
							-81.54382716599977,
							30.5236366590001
						],
						[
							-81.5437191779998,
							30.52364903100006
						],
						[
							-81.54232117699979,
							30.523724031000047
						],
						[
							-81.54218800899977,
							30.523721297000172
						],
						[
							-81.54001800799982,
							30.523515297000188
						],
						[
							-81.5399104489997,
							30.523498467000213
						],
						[
							-81.53865162999965,
							30.52322254800003
						],
						[
							-81.53837802199983,
							30.52317754700013
						],
						[
							-81.53607414499983,
							30.523624264000052
						],
						[
							-81.53255885299984,
							30.524548477000046
						],
						[
							-81.53122387799988,
							30.525238984000072
						],
						[
							-81.5302740899998,
							30.525717423000135
						],
						[
							-81.52810602399983,
							30.526792785000115
						],
						[
							-81.52606723299981,
							30.52838927900023
						],
						[
							-81.52539175699978,
							30.52896196500018
						],
						[
							-81.52370431699978,
							30.530846686000068
						],
						[
							-81.52335358099981,
							30.531760311000077
						],
						[
							-81.52331675799978,
							30.531843414000118
						],
						[
							-81.52232567199985,
							30.53380585700022
						],
						[
							-81.5220137559998,
							30.535803012000535
						],
						[
							-81.52205761699969,
							30.536367308000152
						],
						[
							-81.52206031799983,
							30.536439486000084
						],
						[
							-81.52205721799974,
							30.536511648000012
						],
						[
							-81.52204833699972,
							30.536583329000173
						],
						[
							-81.52203373299993,
							30.53665406500016
						],
						[
							-81.52201349799986,
							30.536723402000124
						],
						[
							-81.52198776499995,
							30.536790891000113
						],
						[
							-81.52175576499987,
							30.5373328920001
						],
						[
							-81.52170783599979,
							30.53742866100048
						],
						[
							-81.52162317999989,
							30.537550747000456
						],
						[
							-81.52017486299961,
							30.539309205000112
						],
						[
							-81.51945422099993,
							30.54024040400015
						],
						[
							-81.5194085599997,
							30.540294823000128
						],
						[
							-81.51857049399982,
							30.54121705000014
						],
						[
							-81.5181503519998,
							30.54225552600009
						],
						[
							-81.51802202199983,
							30.542565777000263
						],
						[
							-81.51796983599978,
							30.54267166100015
						],
						[
							-81.51787992099979,
							30.542800073000464
						],
						[
							-81.51776907299977,
							30.542910921000047
						],
						[
							-81.5176406609998,
							30.543000836000115
						],
						[
							-81.51749858599986,
							30.543067086000093
						],
						[
							-81.51735099999973,
							30.54310663167989
						],
						[
							-81.51734716599968,
							30.543107659000157
						],
						[
							-81.5171909999999,
							30.54312132200049
						],
						[
							-81.51703483499978,
							30.543107659000157
						],
						[
							-81.51688341399995,
							30.543067086000093
						],
						[
							-81.51683498899966,
							30.543047855000186
						],
						[
							-81.51645692699992,
							30.542884880000113
						],
						[
							-81.51485597499988,
							30.54228437300008
						],
						[
							-81.51476392699963,
							30.542219920000157
						],
						[
							-81.51473018299987,
							30.54218617600021
						],
						[
							-81.51432421799977,
							30.542129762000165
						],
						[
							-81.51420032099972,
							30.542103543000213
						],
						[
							-81.51410240699988,
							30.542075492000112
						],
						[
							-81.51394091399993,
							30.54213095100017
						],
						[
							-81.51372770499978,
							30.542223688000117
						],
						[
							-81.51367962899971,
							30.542242973000207
						],
						[
							-81.5133016959998,
							30.542382073000166
						],
						[
							-81.50768485299976,
							30.54531020400006
						],
						[
							-81.50765018499982,
							30.545327160000216
						],
						[
							-81.50758212199977,
							30.54536047800013
						],
						[
							-81.50751125599969,
							30.545387324000046
						],
						[
							-81.50743820099977,
							30.5454074650002
						],
						[
							-81.50736358999981,
							30.54542072700041
						],
						[
							-81.50728806999979,
							30.54542699500004
						],
						[
							-81.50723504699975,
							30.545431108000113
						],
						[
							-81.5063942229999,
							30.545481746000394
						],
						[
							-81.50631939899975,
							30.545483067000237
						],
						[
							-81.50624472499979,
							30.5454781580001
						],
						[
							-81.50617071799981,
							30.545467053000156
						],
						[
							-81.50609789199972,
							30.54544982700015
						],
						[
							-81.50602675199978,
							30.5454266020001
						],
						[
							-81.50546508999967,
							30.545212118000112
						],
						[
							-81.50533633899985,
							30.545150836000197
						],
						[
							-81.50524879199972,
							30.54509324100013
						],
						[
							-81.50466214899967,
							30.544656287000397
						],
						[
							-81.5042643579998,
							30.54449361000035
						],
						[
							-81.50380461899987,
							30.544473459000187
						],
						[
							-81.50372578699967,
							30.54446651800006
						],
						[
							-81.50364787099987,
							30.544452675000073
						],
						[
							-81.50357147299985,
							30.544432035000142
						],
						[
							-81.50349718599983,
							30.54440475900019
						],
						[
							-81.50342558399977,
							30.544371057000422
						],
						[
							-81.50335722199962,
							30.544331192000236
						],
						[
							-81.50311022199979,
							30.544172193000133
						],
						[
							-81.50305202799977,
							30.544131392000043
						],
						[
							-81.50299723699976,
							30.544086123000117
						],
						[
							-81.50294619299972,
							30.54403666900011
						],
						[
							-81.50289921299975,
							30.543983338000054
						],
						[
							-81.50285659099967,
							30.54392646400014
						],
						[
							-81.50281859299992,
							30.543866402000322
						],
						[
							-81.50272664699985,
							30.543707497000234
						],
						[
							-81.50260555099987,
							30.54349833100016
						],
						[
							-81.50224444399974,
							30.543042851000127
						],
						[
							-81.50177753899992,
							30.54266343900035
						],
						[
							-81.50107213999982,
							30.542128434000052
						]
					],
					[
						[
							-81.53323314099985,
							30.511960437000166
						],
						[
							-81.53346278499984,
							30.51218599400027
						],
						[
							-81.53347994899967,
							30.512202915000152
						],
						[
							-81.53362796599993,
							30.51223031500011
						],
						[
							-81.53336941399994,
							30.51192981400003
						],
						[
							-81.53323314099985,
							30.511960437000166
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Duval",
				"City": "Jacksonville",
				"Name": "Broward Islands",
				"RegionID": "416695"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.06784809699991,
					26.69052977800004,
					-80.06226226899993,
					26.698079714000073
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.06249999999994,
							26.691490000000044
						],
						[
							-80.06253000099991,
							26.690740000000062
						],
						[
							-80.0625778509999,
							26.690741742000057
						],
						[
							-80.06257938899995,
							26.69052977800004
						],
						[
							-80.0627809479999,
							26.690534901000035
						],
						[
							-80.0632415899999,
							26.690546136000084
						],
						[
							-80.06375200899993,
							26.690558586000066
						],
						[
							-80.06406984699993,
							26.690566338000053
						],
						[
							-80.06421999999992,
							26.690570000000037
						],
						[
							-80.06432334699991,
							26.69060444900009
						],
						[
							-80.06444679299995,
							26.690624726000067
						],
						[
							-80.06472193299993,
							26.69064165700007
						],
						[
							-80.06510020299993,
							26.690664936000076
						],
						[
							-80.06536751899996,
							26.69068138600005
						],
						[
							-80.0655676209999,
							26.690693700000054
						],
						[
							-80.0656699999999,
							26.69070000000005
						],
						[
							-80.06583575199994,
							26.690706375000048
						],
						[
							-80.06605334999995,
							26.690714744000047
						],
						[
							-80.06611184799993,
							26.69071699400007
						],
						[
							-80.06633811899991,
							26.690725925000038
						],
						[
							-80.06648016799994,
							26.69073160700009
						],
						[
							-80.06660550399994,
							26.690736620000052
						],
						[
							-80.0667051129999,
							26.69074111100008
						],
						[
							-80.06672803999993,
							26.690968241000064
						],
						[
							-80.06682422099993,
							26.691467330000084
						],
						[
							-80.06690577899991,
							26.691727338000078
						],
						[
							-80.06703908499992,
							26.69207817000006
						],
						[
							-80.06718586799991,
							26.692370009000058
						],
						[
							-80.06738354299995,
							26.692707220000045
						],
						[
							-80.06758428599994,
							26.69305613000006
						],
						[
							-80.06784809699991,
							26.693534184000043
						],
						[
							-80.06652384499995,
							26.694761333000088
						],
						[
							-80.06414294299992,
							26.69675533800006
						],
						[
							-80.06287808999991,
							26.69787138500004
						],
						[
							-80.06266976099995,
							26.698079714000073
						],
						[
							-80.06226226899993,
							26.698079500000066
						],
						[
							-80.0622633399999,
							26.698050940000087
						],
						[
							-80.06228999899993,
							26.697340001000043
						],
						[
							-80.06231999999994,
							26.696540001000074
						],
						[
							-80.06234999899993,
							26.695640001000072
						],
						[
							-80.0623799999999,
							26.694840001000046
						],
						[
							-80.06239999899992,
							26.69444000100009
						],
						[
							-80.0624099989999,
							26.693920001000038
						],
						[
							-80.06243999999992,
							26.693080000000066
						],
						[
							-80.0624699999999,
							26.69228000000004
						],
						[
							-80.06249999999994,
							26.691490000000044
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "West Palm Beach",
				"Name": "Pineapple Park",
				"RegionID": "416911"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.79624298499995,
					26.137992803017447,
					-81.78083699999979,
					26.162338206674747
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.78430099999987,
							26.156514000000115
						],
						[
							-81.78425003699992,
							26.156512291000066
						],
						[
							-81.78417399999994,
							26.156618000000016
						],
						[
							-81.78405399999987,
							26.15678600000006
						],
						[
							-81.78398699999991,
							26.156941000000096
						],
						[
							-81.78394099999993,
							26.157089000000084
						],
						[
							-81.78393899999985,
							26.15715300000005
						],
						[
							-81.7839339999999,
							26.157295000000076
						],
						[
							-81.78401199999985,
							26.157556000000177
						],
						[
							-81.78412899999994,
							26.15786100000019
						],
						[
							-81.78417499999993,
							26.158151000000203
						],
						[
							-81.78419199999992,
							26.158360000000087
						],
						[
							-81.78418699999986,
							26.158511000000146
						],
						[
							-81.78417099999987,
							26.158614000000142
						],
						[
							-81.78414599999992,
							26.15877200000007
						],
						[
							-81.7840179999999,
							26.15920100000004
						],
						[
							-81.78389799999992,
							26.159508000000038
						],
						[
							-81.78375399999992,
							26.159768000000057
						],
						[
							-81.78361199999989,
							26.159945000000135
						],
						[
							-81.7835059999999,
							26.16004500000006
						],
						[
							-81.78335799999992,
							26.16016200000015
						],
						[
							-81.7833481069999,
							26.160169723000166
						],
						[
							-81.78301899999985,
							26.156471000000113
						],
						[
							-81.78302999999995,
							26.154810000000168
						],
						[
							-81.78302999999995,
							26.154728397000078
						],
						[
							-81.78303486799992,
							26.154636447000108
						],
						[
							-81.78304230299982,
							26.15455467200018
						],
						[
							-81.78304999999993,
							26.154435237000158
						],
						[
							-81.78304507099996,
							26.15420634700005
						],
						[
							-81.78303879499988,
							26.154087099000133
						],
						[
							-81.78303297399994,
							26.153976506000127
						],
						[
							-81.7830281399999,
							26.153839999000116
						],
						[
							-81.78302450999988,
							26.153683916000077
						],
						[
							-81.78301790899985,
							26.153400071000128
						],
						[
							-81.78301492799996,
							26.15327188300018
						],
						[
							-81.7830121539999,
							26.153152639000083
						],
						[
							-81.78300727999995,
							26.152951211000115
						],
						[
							-81.78300178099994,
							26.152731250000123
						],
						[
							-81.78299583599988,
							26.152465701000093
						],
						[
							-81.78298457699994,
							26.151940282000048
						],
						[
							-81.78297341499992,
							26.15141934800011
						],
						[
							-81.78294841099996,
							26.150898390000172
						],
						[
							-81.7829338489999,
							26.150405237000136
						],
						[
							-81.78292936899989,
							26.149739701000136
						],
						[
							-81.78291109799989,
							26.149103236000144
						],
						[
							-81.78288781899992,
							26.14829235900011
						],
						[
							-81.78287999999989,
							26.146989125000104
						],
						[
							-81.78287999999989,
							26.14632318200016
						],
						[
							-81.78287999999989,
							26.145946779000013
						],
						[
							-81.78287999999989,
							26.145901125000144
						],
						[
							-81.78286710799989,
							26.145853058000164
						],
						[
							-81.7828436699999,
							26.145796808000128
						],
						[
							-81.7828275409999,
							26.14575809900021
						],
						[
							-81.78280425399993,
							26.145724254000164
						],
						[
							-81.78276553499984,
							26.14568808600019
						],
						[
							-81.78273983299994,
							26.14567707100008
						],
						[
							-81.78271283999992,
							26.145668181000055
						],
						[
							-81.78270983434811,
							26.145559066029485
						],
						[
							-81.78295499999989,
							26.142647000000103
						],
						[
							-81.78297899999991,
							26.14236500000004
						],
						[
							-81.78300299999995,
							26.14208600000005
						],
						[
							-81.78290599999991,
							26.140336000000026
						],
						[
							-81.78279399999988,
							26.140177000000016
						],
						[
							-81.7827779999999,
							26.140154000000067
						],
						[
							-81.78266199999989,
							26.14012100000018
						],
						[
							-81.78085199999987,
							26.14011100000006
						],
						[
							-81.78083699999979,
							26.13933200000009
						],
						[
							-81.78180999999991,
							26.13934000000004
						],
						[
							-81.78180899999983,
							26.138423000000017
						],
						[
							-81.78097499999984,
							26.138428000000076
						],
						[
							-81.78096799999987,
							26.138287000000133
						],
						[
							-81.78143699999987,
							26.138279000000182
						],
						[
							-81.78166799999988,
							26.13828100000017
						],
						[
							-81.78187699999995,
							26.138269000000065
						],
						[
							-81.78202399999985,
							26.138230000000036
						],
						[
							-81.78216099999992,
							26.13816900000014
						],
						[
							-81.78230299999984,
							26.13809300000007
						],
						[
							-81.78235999999994,
							26.138058000000015
						],
						[
							-81.78235705562001,
							26.137992803017447
						],
						[
							-81.78244691299994,
							26.138048100000084
						],
						[
							-81.78303688399991,
							26.13838356100004
						],
						[
							-81.78364589499994,
							26.13871908100009
						],
						[
							-81.78432308799992,
							26.13909216400014
						],
						[
							-81.78502720199992,
							26.139478689000057
						],
						[
							-81.78608771799993,
							26.1400513680001
						],
						[
							-81.78640036099993,
							26.140217328000155
						],
						[
							-81.78662165099986,
							26.14035574800006
						],
						[
							-81.78686285449987,
							26.14047249600013
						],
						[
							-81.78696596799993,
							26.140526702000173
						],
						[
							-81.78717151799988,
							26.14063668900013
						],
						[
							-81.78756404299985,
							26.1408467250001
						],
						[
							-81.78799999999977,
							26.141080000000123
						],
						[
							-81.7882719469999,
							26.14122592300003
						],
						[
							-81.7885737269999,
							26.141387854000193
						],
						[
							-81.7889085569999,
							26.14156751900005
						],
						[
							-81.78928240599993,
							26.141766203000145
						],
						[
							-81.78943171599992,
							26.141840858000194
						],
						[
							-81.79010099999988,
							26.142127000000066
						],
						[
							-81.79010122299991,
							26.14212153900006
						],
						[
							-81.79026481999993,
							26.142167217000107
						],
						[
							-81.7904222219999,
							26.14220195600005
						],
						[
							-81.79065999999995,
							26.14224000000018
						],
						[
							-81.79083999999992,
							26.142270000000174
						],
						[
							-81.79090788399985,
							26.142277543000176
						],
						[
							-81.79113350199987,
							26.142295675000078
						],
						[
							-81.79140584399994,
							26.142291553000092
						],
						[
							-81.79166069799989,
							26.14228080400018
						],
						[
							-81.7920055179999,
							26.142246765000117
						],
						[
							-81.79238928699995,
							26.142198119000177
						],
						[
							-81.79291995099989,
							26.14213085100012
						],
						[
							-81.7933999999999,
							26.142070000000146
						],
						[
							-81.79364863699988,
							26.142040164000164
						],
						[
							-81.79404389099989,
							26.14199273300006
						],
						[
							-81.79452716199991,
							26.14193788900014
						],
						[
							-81.79477999999996,
							26.141870000000118
						],
						[
							-81.79475467099991,
							26.14197975800014
						],
						[
							-81.79475794299991,
							26.142119144000127
						],
						[
							-81.79478999999989,
							26.14248000000014
						],
						[
							-81.79482057799994,
							26.142734820000086
						],
						[
							-81.79484999999988,
							26.142980000000122
						],
						[
							-81.79490879599977,
							26.143403332000155
						],
						[
							-81.79499999999986,
							26.14406000000013
						],
						[
							-81.79504043599992,
							26.144341367000052
						],
						[
							-81.79511288199988,
							26.144845468000106
						],
						[
							-81.79523999999992,
							26.14573000000011
						],
						[
							-81.79527318799991,
							26.14594987300009
						],
						[
							-81.79531999999998,
							26.146260000000083
						],
						[
							-81.79539094299979,
							26.14675216800013
						],
						[
							-81.79547999999988,
							26.147370000000087
						],
						[
							-81.79550461699996,
							26.147571328000048
						],
						[
							-81.79555239699992,
							26.14789555100014
						],
						[
							-81.79563999999989,
							26.14849000000003
						],
						[
							-81.79570651799988,
							26.148977795000157
						],
						[
							-81.79578999999985,
							26.149590000000096
						],
						[
							-81.79584366099995,
							26.149987090000092
						],
						[
							-81.79593999999993,
							26.1507000000001
						],
						[
							-81.7960124349998,
							26.151155914000164
						],
						[
							-81.79610999999996,
							26.15177000000017
						],
						[
							-81.79614309599994,
							26.152025310000155
						],
						[
							-81.79619979299993,
							26.152462691000018
						],
						[
							-81.79624298499995,
							26.152850742000062
						],
						[
							-81.79609775499992,
							26.152869757000126
						],
						[
							-81.79577703799994,
							26.152911377000194
						],
						[
							-81.79536781799992,
							26.15296448200006
						],
						[
							-81.79493999999987,
							26.153020000000215
						],
						[
							-81.7945999939999,
							26.15305923100017
						],
						[
							-81.79416567499993,
							26.153109345000054
						],
						[
							-81.79362022799985,
							26.15317228100011
						],
						[
							-81.79305761299992,
							26.15323693200004
						],
						[
							-81.79248999999993,
							26.153300000000108
						],
						[
							-81.7923639049999,
							26.153316447000137
						],
						[
							-81.79220726199989,
							26.15333687900005
						],
						[
							-81.79196655899997,
							26.15336827500016
						],
						[
							-81.79179999999987,
							26.153390000000094
						],
						[
							-81.79171417199977,
							26.153395722000212
						],
						[
							-81.79158398099993,
							26.15340916900017
						],
						[
							-81.7913753039998,
							26.153438151999993
						],
						[
							-81.79100999999987,
							26.153490000000197
						],
						[
							-81.79093477499985,
							26.153499403000176
						],
						[
							-81.79082717199992,
							26.153511554000204
						],
						[
							-81.79087999999986,
							26.156269999000088
						],
						[
							-81.79090999899995,
							26.15747000000017
						],
						[
							-81.79090999999994,
							26.157859999000017
						],
						[
							-81.79090999999994,
							26.15971999900008
						],
						[
							-81.79090999999994,
							26.1601700000001
						],
						[
							-81.79091999999979,
							26.160369999000043
						],
						[
							-81.79099951299047,
							26.162338206674747
						],
						[
							-81.78916099999992,
							26.162326000000142
						],
						[
							-81.78916099999992,
							26.160572000000144
						],
						[
							-81.78964899999988,
							26.160393000000077
						],
						[
							-81.78934544599154,
							26.16038498831081
						],
						[
							-81.7893079999999,
							26.160384000000043
						],
						[
							-81.78743399999983,
							26.160332000000004
						],
						[
							-81.787393155985,
							26.160330885546053
						],
						[
							-81.78461199999994,
							26.160255000000028
						],
						[
							-81.78442199999995,
							26.160250000000147
						],
						[
							-81.78427799999993,
							26.16024600000017
						],
						[
							-81.78424938595413,
							26.160222044054855
						],
						[
							-81.78410599999991,
							26.16010200000016
						],
						[
							-81.78426999999988,
							26.159871000000056
						],
						[
							-81.78426131944548,
							26.159805571940993
						],
						[
							-81.78420299999993,
							26.15936600000019
						],
						[
							-81.78428799999995,
							26.15831800000017
						],
						[
							-81.78436599999992,
							26.15778000000006
						],
						[
							-81.78441677899986,
							26.15764546300003
						],
						[
							-81.78436699999992,
							26.15754500000016
						],
						[
							-81.78434699999987,
							26.15737400000004
						],
						[
							-81.7843699999999,
							26.15716600000006
						],
						[
							-81.78443699999984,
							26.15701000000012
						],
						[
							-81.78461899999989,
							26.156766000000186
						],
						[
							-81.78471899999984,
							26.15663200000011
						],
						[
							-81.78477299999993,
							26.156582000000057
						],
						[
							-81.7848389359998,
							26.156532225000113
						],
						[
							-81.78471499999993,
							26.156528000000034
						],
						[
							-81.78430099999987,
							26.156514000000115
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Collier",
				"City": "Naples",
				"Name": "Redevelopment Area",
				"RegionID": "417054"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.54690999999991,
					27.37457084600004,
					-82.5426347369999,
					27.379058471000064
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.5426347369999,
							27.37902297000005
						],
						[
							-82.54264499999994,
							27.37459000000007
						],
						[
							-82.54270087799995,
							27.374589640000067
						],
						[
							-82.5431109999999,
							27.374587000000076
						],
						[
							-82.54487299899996,
							27.37457084600004
						],
						[
							-82.54487299899996,
							27.37491815700008
						],
						[
							-82.5450283749999,
							27.375082672000076
						],
						[
							-82.54606116799994,
							27.375192350000077
						],
						[
							-82.54626224299994,
							27.376380519000065
						],
						[
							-82.54622568399992,
							27.37682836800008
						],
						[
							-82.54610686699993,
							27.377897720000078
						],
						[
							-82.54642675899993,
							27.37795255900005
						],
						[
							-82.54690999999991,
							27.37795255900005
						],
						[
							-82.54690636499993,
							27.37833631700005
						],
						[
							-82.54603374899995,
							27.378327289000083
						],
						[
							-82.5460063299999,
							27.37837298800008
						],
						[
							-82.54587837299994,
							27.378692880000074
						],
						[
							-82.5457321369999,
							27.379058471000064
						],
						[
							-82.5426347369999,
							27.37902297000005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Village Gardens",
				"RegionID": "417061"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.55325332199993,
					27.35018684700009,
					-82.54694091199991,
					27.354940525000075
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.54737074899992,
							27.354940525000075
						],
						[
							-82.5470256779999,
							27.353862754000094
						],
						[
							-82.54694833899993,
							27.353605135000066
						],
						[
							-82.54694091199991,
							27.350974996000048
						],
						[
							-82.54914925299994,
							27.350983489000043
						],
						[
							-82.54940271699991,
							27.350983489000043
						],
						[
							-82.55095131899992,
							27.350494457000085
						],
						[
							-82.55093399999993,
							27.350463000000047
						],
						[
							-82.55180848599991,
							27.35018684700009
						],
						[
							-82.5523863969999,
							27.35123632300008
						],
						[
							-82.5531429859999,
							27.35261939800006
						],
						[
							-82.55319908599995,
							27.35274341300004
						],
						[
							-82.55323965899993,
							27.35289483400004
						],
						[
							-82.55325332199993,
							27.35305100000005
						],
						[
							-82.55323965899993,
							27.35320716500007
						],
						[
							-82.55322667999991,
							27.35326827600005
						],
						[
							-82.55320958399994,
							27.353336941000066
						],
						[
							-82.5522929999999,
							27.353296000000057
						],
						[
							-82.55162049799993,
							27.353432252000065
						],
						[
							-82.55133198199991,
							27.35347008800005
						],
						[
							-82.55111405899993,
							27.353421109000067
						],
						[
							-82.55093776299992,
							27.35345415100005
						],
						[
							-82.55093806399992,
							27.353575481000064
						],
						[
							-82.55049752499991,
							27.353751527000043
						],
						[
							-82.55023329499994,
							27.35380657500008
						],
						[
							-82.54972685699994,
							27.353883642000085
						],
						[
							-82.54934152099992,
							27.353971717000036
						],
						[
							-82.54908829499993,
							27.353971666000064
						],
						[
							-82.5487470079999,
							27.354070807000085
						],
						[
							-82.54737074899992,
							27.354940525000075
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Tahiti Park",
				"RegionID": "417063"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.49279824799993,
					27.34646193000009,
					-82.48695091199994,
					27.35214073800006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.48888867099993,
							27.35214073800006
						],
						[
							-82.48719630799991,
							27.350112271000057
						],
						[
							-82.48705827099991,
							27.349866873000053
						],
						[
							-82.48696619499992,
							27.349636822000036
						],
						[
							-82.48695091199994,
							27.349437426000065
						],
						[
							-82.48699675599994,
							27.34919197100004
						],
						[
							-82.48853058999993,
							27.34646193000009
						],
						[
							-82.48934353299991,
							27.346906769000043
						],
						[
							-82.4909539539999,
							27.347673635000035
						],
						[
							-82.49225762699992,
							27.34817976700009
						],
						[
							-82.49262572299995,
							27.34827179200005
						],
						[
							-82.49279824799993,
							27.34831238600009
						],
						[
							-82.49278394699991,
							27.348531668000078
						],
						[
							-82.49272643499997,
							27.348768904000053
						],
						[
							-82.49259703399991,
							27.34902770700006
						],
						[
							-82.49237417599994,
							27.34932245500005
						],
						[
							-82.49171997899992,
							27.35024264300006
						],
						[
							-82.49139647599992,
							27.350760249000075
						],
						[
							-82.49133177499994,
							27.350939973000038
						],
						[
							-82.4912599999999,
							27.351200000000063
						],
						[
							-82.4912625369999,
							27.351306548000082
						],
						[
							-82.49126408099994,
							27.35137138300007
						],
						[
							-82.49126647599991,
							27.35147197100008
						],
						[
							-82.49126852799992,
							27.35155819000005
						],
						[
							-82.49126881599994,
							27.35167328700004
						],
						[
							-82.49126642099992,
							27.351781068000037
						],
						[
							-82.49126450499995,
							27.351867293000055
						],
						[
							-82.49126353899993,
							27.35191072500004
						],
						[
							-82.4912627139999,
							27.351947875000064
						],
						[
							-82.48926199999994,
							27.351908000000037
						],
						[
							-82.4892539999999,
							27.352127000000053
						],
						[
							-82.48897899999992,
							27.352129000000048
						],
						[
							-82.48888867099993,
							27.35214073800006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Glen Oaks Ridge",
				"RegionID": "417068"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.53301999999991,
					27.33379000000008,
					-82.5309814549999,
					27.334460000000036
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.5316994659999,
							27.33444490800008
						],
						[
							-82.5314334659999,
							27.334441868000056
						],
						[
							-82.53120092599994,
							27.334442159000048
						],
						[
							-82.5310916869999,
							27.334445572000053
						],
						[
							-82.53101090699994,
							27.334448097000063
						],
						[
							-82.53098524899991,
							27.334448898000062
						],
						[
							-82.5309814549999,
							27.33379000000008
						],
						[
							-82.53103977699993,
							27.33379000000008
						],
						[
							-82.5312308369999,
							27.33379000000008
						],
						[
							-82.53140352299994,
							27.33379222800005
						],
						[
							-82.53147651699993,
							27.333794440000077
						],
						[
							-82.53160404899995,
							27.333798305000073
						],
						[
							-82.53165999999993,
							27.333800000000053
						],
						[
							-82.53187682499993,
							27.333801707000077
						],
						[
							-82.53209516599992,
							27.333803427000078
						],
						[
							-82.53222253199993,
							27.333804429000054
						],
						[
							-82.53229531199992,
							27.33380500200008
						],
						[
							-82.5323590669999,
							27.333805504000054
						],
						[
							-82.53257740799995,
							27.333807224000054
						],
						[
							-82.53274116299991,
							27.333808513000065
						],
						[
							-82.53289582199994,
							27.333809731000088
						],
						[
							-82.53297749199994,
							27.333815277000042
						],
						[
							-82.53301999999991,
							27.33382000000006
						],
						[
							-82.53301999999991,
							27.333898547000047
						],
						[
							-82.53301999999991,
							27.334002997000084
						],
						[
							-82.53301999999991,
							27.334287860000074
						],
						[
							-82.53301999999991,
							27.334460000000036
						],
						[
							-82.53296704899992,
							27.334459395000067
						],
						[
							-82.53285311799993,
							27.33445809300008
						],
						[
							-82.53274851999994,
							27.334456897000052
						],
						[
							-82.53260135999994,
							27.33445521600004
						],
						[
							-82.53237355399995,
							27.334452612000064
						],
						[
							-82.53219791099991,
							27.334450605000086
						],
						[
							-82.53196055599994,
							27.33444789200007
						],
						[
							-82.5316994659999,
							27.33444490800008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Towles Court",
				"RegionID": "417070"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.55334655599995,
					27.335793985000066,
					-82.54991999999993,
					27.336971273000074
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.55249698099993,
							27.336971273000074
						],
						[
							-82.55176482799993,
							27.336374190000072
						],
						[
							-82.54992460499994,
							27.33638592000006
						],
						[
							-82.54991999999993,
							27.336124271000074
						],
						[
							-82.54991999999993,
							27.335840000000076
						],
						[
							-82.55011159199995,
							27.33583382000006
						],
						[
							-82.55037240099995,
							27.335825406000083
						],
						[
							-82.55079462399993,
							27.335811513000067
						],
						[
							-82.5526591759999,
							27.335793985000066
						],
						[
							-82.55334655599995,
							27.336420023000077
						],
						[
							-82.55249698099993,
							27.336971273000074
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Sarasota",
				"Name": "Sunset Towers",
				"RegionID": "417072"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.74146999999994,
					27.762208000000044,
					-82.73220999999995,
					27.769960000000083
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.73220999999995,
							27.769960000000083
						],
						[
							-82.73231509999994,
							27.769722424000065
						],
						[
							-82.73236998399994,
							27.769574658000067
						],
						[
							-82.73243999999995,
							27.769350000000088
						],
						[
							-82.73264387299992,
							27.769244995000065
						],
						[
							-82.73280712399992,
							27.768790316000036
						],
						[
							-82.73296032399992,
							27.768347428000084
						],
						[
							-82.73315516299995,
							27.76778416500008
						],
						[
							-82.73330550799994,
							27.767353950000086
						],
						[
							-82.73342908399991,
							27.76700653800009
						],
						[
							-82.73365291099992,
							27.766377288000058
						],
						[
							-82.73387107199994,
							27.76575949100004
						],
						[
							-82.73409568099993,
							27.765117005000036
						],
						[
							-82.73428238299995,
							27.76458027400008
						],
						[
							-82.73439849599993,
							27.764243845000067
						],
						[
							-82.73459099999991,
							27.763614000000075
						],
						[
							-82.73478899999992,
							27.76302700000008
						],
						[
							-82.73494599999992,
							27.76256700000005
						],
						[
							-82.73498099599993,
							27.76258110100008
						],
						[
							-82.73555899999991,
							27.76281400000005
						],
						[
							-82.73556980299992,
							27.762793284000054
						],
						[
							-82.73587499999991,
							27.762208000000044
						],
						[
							-82.73678188499991,
							27.76260035000007
						],
						[
							-82.73721099999995,
							27.762786000000062
						],
						[
							-82.7375229999999,
							27.76233300000007
						],
						[
							-82.7376789999999,
							27.762407000000053
						],
						[
							-82.73800759099993,
							27.762606104000046
						],
						[
							-82.7381509999999,
							27.76269300000007
						],
						[
							-82.7383309999999,
							27.762827000000073
						],
						[
							-82.73840941399993,
							27.76289022600008
						],
						[
							-82.73865957599992,
							27.76309193600008
						],
						[
							-82.7388059999999,
							27.763210000000072
						],
						[
							-82.73908399999993,
							27.763497000000086
						],
						[
							-82.7396302439999,
							27.763200404000088
						],
						[
							-82.7398169999999,
							27.763099000000068
						],
						[
							-82.73949864699995,
							27.76258361200007
						],
						[
							-82.73944699999993,
							27.762500000000045
						],
						[
							-82.73965999999992,
							27.762301000000036
						],
						[
							-82.7397056929999,
							27.76234390700006
						],
						[
							-82.73982399999994,
							27.762455000000045
						],
						[
							-82.73998199999994,
							27.76260700000006
						],
						[
							-82.7401539999999,
							27.762784000000067
						],
						[
							-82.74118498899992,
							27.76252938600004
						],
						[
							-82.74146999999994,
							27.762459000000035
						],
						[
							-82.7414616339999,
							27.762498563000065
						],
						[
							-82.74143003699993,
							27.76254745400007
						],
						[
							-82.74138384199995,
							27.76258807000005
						],
						[
							-82.74131840899992,
							27.762638867000078
						],
						[
							-82.74123936299992,
							27.762700231000053
						],
						[
							-82.7411221559999,
							27.762791221000043
						],
						[
							-82.74099248999994,
							27.762891883000066
						],
						[
							-82.74089747799991,
							27.762965642000044
						],
						[
							-82.74081649499993,
							27.763028511000073
						],
						[
							-82.74071719199992,
							27.763105601000067
						],
						[
							-82.74065999999993,
							27.763150000000053
						],
						[
							-82.74059430799991,
							27.763193794000074
						],
						[
							-82.7405399999999,
							27.76323000000008
						],
						[
							-82.74024537799994,
							27.76345447400007
						],
						[
							-82.74019711599993,
							27.76349124500007
						],
						[
							-82.74056580399991,
							27.763904189000073
						],
						[
							-82.74036908499994,
							27.764100907000056
						],
						[
							-82.73993899999995,
							27.764435210000045
						],
						[
							-82.74002270099993,
							27.76452614500005
						],
						[
							-82.74014382899992,
							27.76465774000008
						],
						[
							-82.74034873399995,
							27.76487983600009
						],
						[
							-82.7404935379999,
							27.76503315800005
						],
						[
							-82.74066112799994,
							27.765208133000044
						],
						[
							-82.74076414599995,
							27.765308488000073
						],
						[
							-82.74086291599991,
							27.765361458000086
						],
						[
							-82.7409199999999,
							27.76539000000008
						],
						[
							-82.74093058499994,
							27.765477323000084
						],
						[
							-82.74094962799991,
							27.76563443300006
						],
						[
							-82.74098687599991,
							27.76583646200004
						],
						[
							-82.74102088299992,
							27.76598382700007
						],
						[
							-82.74107927299993,
							27.766210364000074
						],
						[
							-82.74111999999991,
							27.766350000000045
						],
						[
							-82.7410207989999,
							27.766355669000063
						],
						[
							-82.7408412069999,
							27.766365931000053
						],
						[
							-82.7406448079999,
							27.766377154000057
						],
						[
							-82.74054300799992,
							27.76638297100004
						],
						[
							-82.74071755799991,
							27.766883070000063
						],
						[
							-82.74096486099995,
							27.767596877000074
						],
						[
							-82.74116157999993,
							27.768102725000062
						],
						[
							-82.74122902599993,
							27.768496162000076
						],
						[
							-82.74132457499991,
							27.768940184000087
						],
						[
							-82.74136391899992,
							27.769260554000084
						],
						[
							-82.74139764199992,
							27.76946851300005
						],
						[
							-82.74145602699991,
							27.76993559200008
						],
						[
							-82.74123151499992,
							27.769937671000037
						],
						[
							-82.7406474519999,
							27.76994140000005
						],
						[
							-82.74024313399991,
							27.769943943000044
						],
						[
							-82.73979360899996,
							27.76994677000005
						],
						[
							-82.73956898799992,
							27.769948182000064
						],
						[
							-82.73927999999995,
							27.769950000000055
						],
						[
							-82.73894013799992,
							27.769950000000055
						],
						[
							-82.73831117299994,
							27.769950000000055
						],
						[
							-82.73792999999995,
							27.769950000000055
						],
						[
							-82.73754757499995,
							27.76994714600005
						],
						[
							-82.7373678809999,
							27.769945805000077
						],
						[
							-82.73691830999991,
							27.769942450000087
						],
						[
							-82.73658999999992,
							27.769940000000076
						],
						[
							-82.73624473399991,
							27.76994257700005
						],
						[
							-82.7359299339999,
							27.769944926000054
						],
						[
							-82.73543577599992,
							27.769948614000043
						],
						[
							-82.73507649999993,
							27.769950000000055
						],
						[
							-82.73431275799993,
							27.769950000000055
						],
						[
							-82.73349999999994,
							27.769960000000083
						],
						[
							-82.73265049499992,
							27.769960000000083
						],
						[
							-82.73220999999995,
							27.769960000000083
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Old Pasadena",
				"RegionID": "417120"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.26978013299998,
					25.940199541000027,
					-80.25339226199998,
					25.95543858900004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.25366641699998,
							25.947885057000068
						],
						[
							-80.25367064099999,
							25.947595738000075
						],
						[
							-80.25341774699997,
							25.941292626000063
						],
						[
							-80.25339226199998,
							25.94068122500005
						],
						[
							-80.25372199699996,
							25.940662960000054
						],
						[
							-80.25466010299994,
							25.94056177400006
						],
						[
							-80.26135770099995,
							25.940342158000078
						],
						[
							-80.26143848499999,
							25.940339021000057
						],
						[
							-80.26438350199999,
							25.940224659000023
						],
						[
							-80.26485970299996,
							25.940206167000042
						],
						[
							-80.26513523499995,
							25.940199541000027
						],
						[
							-80.26516692499996,
							25.940407804000074
						],
						[
							-80.26528758199998,
							25.94333504100007
						],
						[
							-80.26796825899999,
							25.94325110500006
						],
						[
							-80.26951734399995,
							25.943171693000068
						],
						[
							-80.26973552399996,
							25.946924393000074
						],
						[
							-80.26978013299998,
							25.94728126600006
						],
						[
							-80.26931426999994,
							25.947253527000044
						],
						[
							-80.26919682099998,
							25.947246534000044
						],
						[
							-80.26175212699997,
							25.947585663000044
						],
						[
							-80.26188979599993,
							25.952244736000072
						],
						[
							-80.26159045999998,
							25.952249750000078
						],
						[
							-80.25970191099998,
							25.952338190000035
						],
						[
							-80.25914618299998,
							25.952356116000033
						],
						[
							-80.25777714099996,
							25.952430440000057
						],
						[
							-80.25729529999995,
							25.952513256000035
						],
						[
							-80.25650925899998,
							25.95266753900006
						],
						[
							-80.25667216499994,
							25.954719254000054
						],
						[
							-80.25669681699998,
							25.955029739000054
						],
						[
							-80.25455272799996,
							25.955423687000064
						],
						[
							-80.25435838499999,
							25.95543858900004
						],
						[
							-80.25431694699995,
							25.955257973000073
						],
						[
							-80.25426169799994,
							25.955017157000043
						],
						[
							-80.25425455799996,
							25.954986038000072
						],
						[
							-80.25409089199997,
							25.954330319000064
						],
						[
							-80.25400747599997,
							25.953918515000055
						],
						[
							-80.25395550999997,
							25.953695794000055
						],
						[
							-80.25389554899994,
							25.952682047000053
						],
						[
							-80.25388499,
							25.95239061600006
						],
						[
							-80.25386176,
							25.95182148200007
						],
						[
							-80.25380051799993,
							25.951316758000075
						],
						[
							-80.25366430499997,
							25.948700218000056
						],
						[
							-80.25366641699998,
							25.947885057000068
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Gardens",
				"Name": "Carol City North",
				"RegionID": "761651"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.24589284899997,
					25.941007697000032,
					-80.24130438199995,
					25.95546013200004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.24199966999998,
							25.954128386000036
						],
						[
							-80.24199463599997,
							25.95391715200003
						],
						[
							-80.24198442399995,
							25.95347522800006
						],
						[
							-80.24197960899996,
							25.953286638000066
						],
						[
							-80.24193024999994,
							25.95158022800007
						],
						[
							-80.24180563999994,
							25.947272302000044
						],
						[
							-80.24131302299998,
							25.94122179200008
						],
						[
							-80.24130438199995,
							25.941115663000065
						],
						[
							-80.24337985099999,
							25.941007697000032
						],
						[
							-80.24338446499996,
							25.94115485900005
						],
						[
							-80.24338585599997,
							25.94119921500004
						],
						[
							-80.24349396599997,
							25.944647264000025
						],
						[
							-80.24550653399997,
							25.944522775000056
						],
						[
							-80.24566466799996,
							25.945775250000054
						],
						[
							-80.24570862399997,
							25.94804995000004
						],
						[
							-80.24571254299997,
							25.948195600000076
						],
						[
							-80.24582563899997,
							25.95239934900008
						],
						[
							-80.24589284899997,
							25.955450462000044
						],
						[
							-80.24537336599997,
							25.95546013200004
						],
						[
							-80.24447300399999,
							25.95529065200003
						],
						[
							-80.24392219399994,
							25.95519531900004
						],
						[
							-80.24310657099994,
							25.95500465400005
						],
						[
							-80.24201810399995,
							25.954761693000023
						],
						[
							-80.24199966999998,
							25.954128386000036
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Gardens",
				"Name": "Dolphin Center South",
				"RegionID": "761652"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.23383015899998,
					25.941538018000074,
					-80.22287066199993,
					25.95271106900003
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.22882005699995,
							25.95271106900003
						],
						[
							-80.22876511799996,
							25.952381434000074
						],
						[
							-80.22837926399995,
							25.950891859000023
						],
						[
							-80.22782660299998,
							25.94922527500006
						],
						[
							-80.22762682699994,
							25.948731631000044
						],
						[
							-80.22753323499995,
							25.948546665000038
						],
						[
							-80.22615236899998,
							25.945817650000038
						],
						[
							-80.22416734499996,
							25.943149779000066
						],
						[
							-80.22404924099999,
							25.942991047000078
						],
						[
							-80.22287066199993,
							25.94188167200008
						],
						[
							-80.22346835499997,
							25.941866481000034
						],
						[
							-80.22346306299994,
							25.941861204000077
						],
						[
							-80.22366325999997,
							25.941855478000036
						],
						[
							-80.22405701599996,
							25.94183325000006
						],
						[
							-80.22435038299994,
							25.941816689000063
						],
						[
							-80.22564820499997,
							25.941743425000027
						],
						[
							-80.22928684699997,
							25.941538018000074
						],
						[
							-80.22933156899995,
							25.942482064000046
						],
						[
							-80.22935687499995,
							25.943026135000025
						],
						[
							-80.22961625799996,
							25.94884010900006
						],
						[
							-80.23364618299996,
							25.948694602000046
						],
						[
							-80.23376988499996,
							25.95175339800005
						],
						[
							-80.23377485999998,
							25.95187640900008
						],
						[
							-80.23377954499995,
							25.95199227100005
						],
						[
							-80.23378536399997,
							25.952136171000063
						],
						[
							-80.23383015899998,
							25.95265078700004
						],
						[
							-80.23348811499994,
							25.952637879000065
						],
						[
							-80.23268959099994,
							25.952515656000063
						],
						[
							-80.23106809799998,
							25.952686769000024
						],
						[
							-80.23096909799995,
							25.952687839000077
						],
						[
							-80.22882005699995,
							25.95271106900003
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Gardens",
				"Name": "Rolling Oaks",
				"RegionID": "761653"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.25708330999998,
					26.13569704400004,
					-80.23572264499995,
					26.14862799100007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.23670613899998,
							26.136294851000063
						],
						[
							-80.23572264499995,
							26.13569704400004
						],
						[
							-80.24266707099997,
							26.135699378000027
						],
						[
							-80.25676642099995,
							26.135745143000065
						],
						[
							-80.25682517599995,
							26.138367127000038
						],
						[
							-80.25708330999998,
							26.14853925700004
						],
						[
							-80.24713704899995,
							26.14862799100007
						],
						[
							-80.24286168899994,
							26.148595724000074
						],
						[
							-80.24153874799998,
							26.148176255000067
						],
						[
							-80.24054654199995,
							26.147522851000076
						],
						[
							-80.23969146999997,
							26.146546778000072
						],
						[
							-80.23924779999999,
							26.145417438000038
						],
						[
							-80.23915906599996,
							26.139520668000046
						],
						[
							-80.23886059799997,
							26.138399394000032
						],
						[
							-80.23844919499999,
							26.137560456000074
						],
						[
							-80.23758605699999,
							26.136745717000053
						],
						[
							-80.23670613899998,
							26.136294851000063
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Plantation",
				"Name": "Mirror Lake",
				"RegionID": "761751"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.13484893799995,
					26.91916724600003,
					-80.12691604599996,
					26.926680599000065
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.12721538299996,
							26.91916724600003
						],
						[
							-80.13484893799995,
							26.919197006000047
						],
						[
							-80.13457906699995,
							26.926680599000065
						],
						[
							-80.12691604599996,
							26.926530930000073
						],
						[
							-80.12721538299996,
							26.91916724600003
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Jupiter",
				"Name": "Jupiter Village",
				"RegionID": "761985"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.14173321599998,
					26.904008,
					-80.12739498499997,
					26.91177362700006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.12749552299994,
							26.91060260300003
						],
						[
							-80.12739498499997,
							26.904469810000023
						],
						[
							-80.13742539799996,
							26.904054409000025
						],
						[
							-80.138546,
							26.904008
						],
						[
							-80.139337,
							26.905482
						],
						[
							-80.14173321599998,
							26.911264755000047
						],
						[
							-80.14020534199994,
							26.91131943700003
						],
						[
							-80.12751471999997,
							26.91177362700006
						],
						[
							-80.12749552299994,
							26.91060260300003
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Jupiter",
				"Name": "Egret Landing",
				"RegionID": "761986"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.138546,
					26.884483,
					-80.12739498499997,
					26.904469810000023
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.12749127299998,
							26.901686203000054
						],
						[
							-80.12774083899996,
							26.894471500000066
						],
						[
							-80.12805352599997,
							26.885431992000065
						],
						[
							-80.127666,
							26.884483
						],
						[
							-80.128389,
							26.885245
						],
						[
							-80.128527,
							26.885597
						],
						[
							-80.128949,
							26.886293
						],
						[
							-80.12949163199994,
							26.88673172400007
						],
						[
							-80.130182,
							26.887753
						],
						[
							-80.130455,
							26.888416
						],
						[
							-80.130898,
							26.889107
						],
						[
							-80.131404,
							26.889729
						],
						[
							-80.131452,
							26.889790000000005
						],
						[
							-80.131939,
							26.890515
						],
						[
							-80.13215295199996,
							26.890734975000044
						],
						[
							-80.13325874199995,
							26.892087613000058
						],
						[
							-80.13434355399994,
							26.893975474000058
						],
						[
							-80.136016,
							26.897233
						],
						[
							-80.13659693399995,
							26.89905742600007
						],
						[
							-80.136875,
							26.900439
						],
						[
							-80.13712613199993,
							26.900906250000048
						],
						[
							-80.13743072299997,
							26.901571639000053
						],
						[
							-80.137568,
							26.901924
						],
						[
							-80.137897,
							26.902627
						],
						[
							-80.138139,
							26.903325
						],
						[
							-80.138546,
							26.904008
						],
						[
							-80.13742539799996,
							26.904054409000025
						],
						[
							-80.12739498499997,
							26.904469810000023
						],
						[
							-80.12749127299998,
							26.901686203000054
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Jupiter",
				"Name": "The Heights of Jupiter",
				"RegionID": "761987"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.407785,
					27.11170282100005,
					-82.350611,
					27.141042
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.392151,
							27.137291
						],
						[
							-82.37997400499995,
							27.137179442000047
						],
						[
							-82.374639249,
							27.137130145000075
						],
						[
							-82.372351,
							27.137109000000002
						],
						[
							-82.366695,
							27.13708
						],
						[
							-82.360421,
							27.137216000000002
						],
						[
							-82.36040540699997,
							27.136917125000025
						],
						[
							-82.360385,
							27.136526
						],
						[
							-82.360271,
							27.136384
						],
						[
							-82.36002100000002,
							27.136362
						],
						[
							-82.359307,
							27.136611000000002
						],
						[
							-82.35919786399995,
							27.13651896600004
						],
						[
							-82.358688,
							27.136089
						],
						[
							-82.357661,
							27.135641
						],
						[
							-82.358142,
							27.135029000000003
						],
						[
							-82.358349,
							27.134818
						],
						[
							-82.35827093499996,
							27.13442400500003
						],
						[
							-82.3582,
							27.134066
						],
						[
							-82.358435,
							27.133413
						],
						[
							-82.358442,
							27.132967
						],
						[
							-82.358236,
							27.132522
						],
						[
							-82.358071,
							27.132343000000002
						],
						[
							-82.357488,
							27.13231
						],
						[
							-82.356618,
							27.132338
						],
						[
							-82.357092,
							27.131841
						],
						[
							-82.357516,
							27.131564
						],
						[
							-82.357857,
							27.131536
						],
						[
							-82.357942,
							27.131652
						],
						[
							-82.35783,
							27.131782
						],
						[
							-82.358109,
							27.13191
						],
						[
							-82.358211,
							27.1319
						],
						[
							-82.358166,
							27.131768
						],
						[
							-82.358354,
							27.131726
						],
						[
							-82.358481,
							27.131410000000002
						],
						[
							-82.35846053599995,
							27.131287670000063
						],
						[
							-82.358436,
							27.131141
						],
						[
							-82.358127,
							27.1309
						],
						[
							-82.35748,
							27.130631
						],
						[
							-82.357276,
							27.130259
						],
						[
							-82.35744,
							27.130187
						],
						[
							-82.35760388499995,
							27.12996221800006
						],
						[
							-82.357623,
							27.129936000000004
						],
						[
							-82.358022,
							27.129914
						],
						[
							-82.358179,
							27.130006
						],
						[
							-82.358458,
							27.13038
						],
						[
							-82.358314,
							27.130566
						],
						[
							-82.358195,
							27.130386
						],
						[
							-82.358048,
							27.130392000000004
						],
						[
							-82.358155,
							27.130606
						],
						[
							-82.358401,
							27.130732
						],
						[
							-82.358625,
							27.130611
						],
						[
							-82.358654,
							27.130461
						],
						[
							-82.358413,
							27.129933
						],
						[
							-82.358155,
							27.129802
						],
						[
							-82.357784,
							27.129775
						],
						[
							-82.357415,
							27.129984
						],
						[
							-82.356924,
							27.129778
						],
						[
							-82.356261,
							27.130096
						],
						[
							-82.35573490899998,
							27.130161104000024
						],
						[
							-82.35496,
							27.130257
						],
						[
							-82.354454,
							27.130611
						],
						[
							-82.354143,
							27.131482
						],
						[
							-82.354022,
							27.131576
						],
						[
							-82.353874,
							27.131546
						],
						[
							-82.353679,
							27.131154
						],
						[
							-82.353638,
							27.130665
						],
						[
							-82.353408,
							27.130162
						],
						[
							-82.353381,
							27.129828000000003
						],
						[
							-82.35343,
							27.129619
						],
						[
							-82.353625,
							27.129462
						],
						[
							-82.353702,
							27.129446
						],
						[
							-82.353736,
							27.129629
						],
						[
							-82.35379,
							27.129568
						],
						[
							-82.353885,
							27.12892
						],
						[
							-82.353287,
							27.128552000000003
						],
						[
							-82.35285342499998,
							27.128172952000057
						],
						[
							-82.352468,
							27.127836000000002
						],
						[
							-82.352879,
							27.127607
						],
						[
							-82.353465,
							27.127624
						],
						[
							-82.353307,
							27.127518
						],
						[
							-82.35295600000002,
							27.127502
						],
						[
							-82.35265341299998,
							27.127598677000037
						],
						[
							-82.352233,
							27.127733
						],
						[
							-82.351805,
							27.127727000000004
						],
						[
							-82.351063,
							27.12754
						],
						[
							-82.35096400000002,
							27.127426
						],
						[
							-82.350914,
							27.126957
						],
						[
							-82.351498,
							27.126068
						],
						[
							-82.351629,
							27.125257000000005
						],
						[
							-82.351433,
							27.124725
						],
						[
							-82.351023,
							27.12337
						],
						[
							-82.350908,
							27.122951
						],
						[
							-82.350611,
							27.122668
						],
						[
							-82.35236648799997,
							27.122697552000034
						],
						[
							-82.36247781299994,
							27.122867764000034
						],
						[
							-82.38451675599998,
							27.122831396000038
						],
						[
							-82.38466222799997,
							27.11170282100005
						],
						[
							-82.38680793299996,
							27.11203013200003
						],
						[
							-82.39317137899997,
							27.118241201000046
						],
						[
							-82.39757835799999,
							27.123030017000076
						],
						[
							-82.40223956399996,
							27.128095087000077
						],
						[
							-82.40593334699997,
							27.132108913000025
						],
						[
							-82.40741906699998,
							27.13372336200007
						],
						[
							-82.407785,
							27.134121
						],
						[
							-82.405786,
							27.135634000000003
						],
						[
							-82.405245,
							27.135895
						],
						[
							-82.406647,
							27.137351
						],
						[
							-82.40312864599997,
							27.137170456000035
						],
						[
							-82.403129,
							27.137075
						],
						[
							-82.402768,
							27.137074
						],
						[
							-82.40276857499998,
							27.137151979000066
						],
						[
							-82.40277,
							27.137345000000003
						],
						[
							-82.402158,
							27.137344
						],
						[
							-82.40212573799994,
							27.13711899200007
						],
						[
							-82.402119,
							27.137072
						],
						[
							-82.401171,
							27.13707
						],
						[
							-82.401121,
							27.140992
						],
						[
							-82.40043537099997,
							27.140995875000044
						],
						[
							-82.392275,
							27.141042
						],
						[
							-82.392151,
							27.137291
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Venice",
				"Name": "Northeast Venice",
				"RegionID": "762154"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.7569039999999,
					27.75320061000008,
					-82.7450367639999,
					27.765820680000047
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.74846650199993,
							27.763663932000043
						],
						[
							-82.7481048279999,
							27.763267813000084
						],
						[
							-82.74772593199992,
							27.76290614000004
						],
						[
							-82.7473859939999,
							27.76254900600009
						],
						[
							-82.7472210549999,
							27.762347098000077
						],
						[
							-82.74693369499994,
							27.76202778900006
						],
						[
							-82.7467959139999,
							27.761821119000047
						],
						[
							-82.74665813399992,
							27.761425000000088
						],
						[
							-82.7463653499999,
							27.761183884000047
						],
						[
							-82.74581738599994,
							27.760759678000056
						],
						[
							-82.74525900799995,
							27.759815949000085
						],
						[
							-82.74521264399993,
							27.759726504000074
						],
						[
							-82.74512864299993,
							27.759539504000088
						],
						[
							-82.7450991899999,
							27.759465284000044
						],
						[
							-82.74507643599993,
							27.759388743000045
						],
						[
							-82.74506056099995,
							27.75931048500007
						],
						[
							-82.74505168999991,
							27.759231128000067
						],
						[
							-82.74503868999994,
							27.759037128000045
						],
						[
							-82.7450367639999,
							27.75896453200005
						],
						[
							-82.74504070199993,
							27.75889201800004
						],
						[
							-82.74505047799994,
							27.758820058000083
						],
						[
							-82.74506602799994,
							27.75874912200004
						],
						[
							-82.74508725099992,
							27.75867967100004
						],
						[
							-82.74511400799992,
							27.75861215900005
						],
						[
							-82.74519700799993,
							27.75842515800008
						],
						[
							-82.7452317119999,
							27.758355307000045
						],
						[
							-82.74527233799995,
							27.758288726000046
						],
						[
							-82.74531857999995,
							27.758225915000082
						],
						[
							-82.74537008999995,
							27.75816734700004
						],
						[
							-82.74553608999992,
							27.757994348000068
						],
						[
							-82.74564837399994,
							27.75789532600004
						],
						[
							-82.74575806999991,
							27.757813758000058
						],
						[
							-82.7457998779999,
							27.75778133500006
						],
						[
							-82.74585828599993,
							27.757739662000063
						],
						[
							-82.74591982899994,
							27.757702778000066
						],
						[
							-82.74598411799992,
							27.75767091700004
						],
						[
							-82.74605074099993,
							27.757644283000047
						],
						[
							-82.74611927599994,
							27.75762304500006
						],
						[
							-82.7462992749999,
							27.757575044000077
						],
						[
							-82.74637483399994,
							27.757558341000053
						],
						[
							-82.74649605099995,
							27.757545357000087
						],
						[
							-82.74655467399992,
							27.757547212000077
						],
						[
							-82.74667618299992,
							27.757539867000048
						],
						[
							-82.74674066299991,
							27.75753821400008
						],
						[
							-82.74680504399993,
							27.757542156000056
						],
						[
							-82.74686884099992,
							27.757551663000072
						],
						[
							-82.74693157399992,
							27.75756666300009
						],
						[
							-82.74693774299993,
							27.75723918300008
						],
						[
							-82.74694087199993,
							27.757174279000083
						],
						[
							-82.7469486789999,
							27.757109770000056
						],
						[
							-82.74696112299995,
							27.75704599300008
						],
						[
							-82.7469781399999,
							27.75698328200008
						],
						[
							-82.74699964099995,
							27.756921962000035
						],
						[
							-82.7470440159999,
							27.756808687000046
						],
						[
							-82.74835146999993,
							27.755908220000038
						],
						[
							-82.74840845699993,
							27.75590360800004
						],
						[
							-82.74848099999991,
							27.755900678000046
						],
						[
							-82.74857528799993,
							27.755905634000044
						],
						[
							-82.74890728799994,
							27.75594063500006
						],
						[
							-82.74896901699992,
							27.755948577000083
						],
						[
							-82.74902993399992,
							27.75596132900006
						],
						[
							-82.74908966499993,
							27.75597881400006
						],
						[
							-82.74914784299996,
							27.756000923000045
						],
						[
							-82.74920411099994,
							27.756027521000078
						],
						[
							-82.74921533999992,
							27.75593583500006
						],
						[
							-82.74922852899994,
							27.75587388200006
						],
						[
							-82.74931852999993,
							27.75551388100007
						],
						[
							-82.74933873799995,
							27.755444895000043
						],
						[
							-82.74936439099992,
							27.755377743000054
						],
						[
							-82.7493953259999,
							27.755312855000057
						],
						[
							-82.7494313439999,
							27.755250644000057
						],
						[
							-82.74948005899995,
							27.755173765000052
						],
						[
							-82.74945349899991,
							27.755149233000054
						],
						[
							-82.75228284399992,
							27.75320061000008
						],
						[
							-82.75230789799991,
							27.75332743200005
						],
						[
							-82.75231892999994,
							27.753404550000084
						],
						[
							-82.75232324099994,
							27.75348233200009
						],
						[
							-82.75232080099994,
							27.75356019700007
						],
						[
							-82.75231162799992,
							27.753637557000047
						],
						[
							-82.7522957889999,
							27.753713832000074
						],
						[
							-82.75227340599992,
							27.75378845000006
						],
						[
							-82.75224724599991,
							27.75386351800006
						],
						[
							-82.75217883599993,
							27.75401166100005
						],
						[
							-82.75209801199992,
							27.754127090000054
						],
						[
							-82.7521858419999,
							27.75418884900006
						],
						[
							-82.75231143699995,
							27.753921004000063
						],
						[
							-82.7523459979999,
							27.753854112000056
						],
						[
							-82.75238603299994,
							27.753790344000038
						],
						[
							-82.7524312619999,
							27.75373015000008
						],
						[
							-82.75248136699993,
							27.753673949000074
						],
						[
							-82.75253599799993,
							27.753622137000036
						],
						[
							-82.75259477199995,
							27.75357507600006
						],
						[
							-82.75265727599992,
							27.75353309700006
						],
						[
							-82.75273727599995,
							27.75348409700007
						],
						[
							-82.75280325299991,
							27.753447403000056
						],
						[
							-82.75287207499991,
							27.75341637100007
						],
						[
							-82.75294325699991,
							27.753391221000072
						],
						[
							-82.75294624999992,
							27.753390439000043
						],
						[
							-82.7536776359999,
							27.75422573700007
						],
						[
							-82.7537539999999,
							27.754245000000086
						],
						[
							-82.75383399999993,
							27.75426500000009
						],
						[
							-82.75403499999993,
							27.754365000000064
						],
						[
							-82.75408899999991,
							27.754427000000078
						],
						[
							-82.75412099999994,
							27.754462000000046
						],
						[
							-82.75415599999991,
							27.754632000000072
						],
						[
							-82.75414199999994,
							27.754763000000082
						],
						[
							-82.75413498199993,
							27.754775866000045
						],
						[
							-82.75501403099992,
							27.755927308000082
						],
						[
							-82.75504899999993,
							27.755940000000066
						],
						[
							-82.75509099999994,
							27.755966000000058
						],
						[
							-82.75515999999993,
							27.756009000000063
						],
						[
							-82.75523599999991,
							27.75612700000005
						],
						[
							-82.75528799999995,
							27.75626800000009
						],
						[
							-82.75528881799994,
							27.756293576000076
						],
						[
							-82.75580814699993,
							27.757398927000054
						],
						[
							-82.75591299999991,
							27.75739800000008
						],
						[
							-82.7560269999999,
							27.757461000000035
						],
						[
							-82.75688999999994,
							27.758755000000065
						],
						[
							-82.7569039999999,
							27.75888600000008
						],
						[
							-82.75627299999991,
							27.761198000000036
						],
						[
							-82.75614899999994,
							27.76135700000009
						],
						[
							-82.75602399999991,
							27.761398000000042
						],
						[
							-82.7560049999999,
							27.761398000000042
						],
						[
							-82.75584399999991,
							27.761398000000042
						],
						[
							-82.75575714699994,
							27.76136213500007
						],
						[
							-82.75524699999994,
							27.76281700000004
						],
						[
							-82.75477361899993,
							27.763506058000075
						],
						[
							-82.75474124699991,
							27.763509026000065
						],
						[
							-82.75467334399991,
							27.76351010700006
						],
						[
							-82.75460555199993,
							27.763506060000058
						],
						[
							-82.75449108999993,
							27.763494877000085
						],
						[
							-82.75449626099993,
							27.763511184000038
						],
						[
							-82.75451692999991,
							27.76358801500004
						],
						[
							-82.7545307279999,
							27.763666372000046
						],
						[
							-82.75453754599994,
							27.76374564200006
						],
						[
							-82.75453733099994,
							27.76382520500005
						],
						[
							-82.75453608099991,
							27.76385182100006
						],
						[
							-82.75422199999991,
							27.764309000000083
						],
						[
							-82.7539895779999,
							27.764917011000083
						],
						[
							-82.75387434299995,
							27.765015003000087
						],
						[
							-82.75374366099993,
							27.76510683500004
						],
						[
							-82.75372120399993,
							27.76511937600009
						],
						[
							-82.75338220399993,
							27.76530237700007
						],
						[
							-82.75330527699992,
							27.765339303000076
						],
						[
							-82.75290327699992,
							27.765509303000044
						],
						[
							-82.75282040399992,
							27.765539647000082
						],
						[
							-82.75218140399994,
							27.765738647000035
						],
						[
							-82.7520701659999,
							27.765765659000067
						],
						[
							-82.75200632999992,
							27.765774570000076
						],
						[
							-82.75157032999994,
							27.765819570000076
						],
						[
							-82.75154875499993,
							27.765820680000047
						],
						[
							-82.75094654999992,
							27.765420632000087
						],
						[
							-82.75036098299995,
							27.765351742000064
						],
						[
							-82.7500165319999,
							27.765058959000044
						],
						[
							-82.74968930299991,
							27.764576727000076
						],
						[
							-82.74944818799992,
							27.764249499000073
						],
						[
							-82.74901762399992,
							27.76397393800005
						],
						[
							-82.74846650199993,
							27.763663932000043
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Yacht Club Estates",
				"RegionID": "417122"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.73686726799991,
					27.78084000000007,
					-82.72846079399994,
					27.787340000000086
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.72850814799995,
							27.78712442300008
						],
						[
							-82.72850579599992,
							27.786863328000038
						],
						[
							-82.7285026589999,
							27.786515201000046
						],
						[
							-82.72850097899993,
							27.786328705000074
						],
						[
							-82.72849999999994,
							27.786104926000064
						],
						[
							-82.72849999999994,
							27.78594328300005
						],
						[
							-82.72849999999994,
							27.785508089000075
						],
						[
							-82.72849999999994,
							27.78507289500004
						],
						[
							-82.72849999999994,
							27.78461283300004
						],
						[
							-82.72849999999994,
							27.784471460000077
						],
						[
							-82.72849999999994,
							27.784177640000053
						],
						[
							-82.72849636199993,
							27.783580811000036
						],
						[
							-82.72849431299994,
							27.78340661100009
						],
						[
							-82.72849167999993,
							27.783182828000065
						],
						[
							-82.72848943799994,
							27.782959064000067
						],
						[
							-82.72848710699992,
							27.78262335900007
						],
						[
							-82.72848486299996,
							27.782300261000046
						],
						[
							-82.7284808899999,
							27.78172814700008
						],
						[
							-82.72847846799993,
							27.781541771000036
						],
						[
							-82.72847650599994,
							27.781467218000046
						],
						[
							-82.72847453499992,
							27.781392338000046
						],
						[
							-82.72846766799995,
							27.781131403000074
						],
						[
							-82.7284630819999,
							27.78095711900005
						],
						[
							-82.72846079399994,
							27.780841726000062
						],
						[
							-82.72941917799994,
							27.78084000000007
						],
						[
							-82.73105434099995,
							27.78084000000007
						],
						[
							-82.73189676099992,
							27.780844099000035
						],
						[
							-82.73291247299996,
							27.780852372000084
						],
						[
							-82.7338291179999,
							27.780858211000066
						],
						[
							-82.73434939099991,
							27.78086122800005
						],
						[
							-82.73484488199995,
							27.780863769000064
						],
						[
							-82.7351670779999,
							27.780865421000048
						],
						[
							-82.7357616669999,
							27.780868470000087
						],
						[
							-82.73630671399991,
							27.780873738000082
						],
						[
							-82.73671999999993,
							27.78088000000008
						],
						[
							-82.7367373649999,
							27.781765633000077
						],
						[
							-82.73676282199995,
							27.782721601000052
						],
						[
							-82.73678659599994,
							27.78357744400006
						],
						[
							-82.73679776499995,
							27.78397953700005
						],
						[
							-82.73680999999993,
							27.78454000000005
						],
						[
							-82.73682239499993,
							27.784883954000065
						],
						[
							-82.7368351319999,
							27.785237410000036
						],
						[
							-82.73686104899991,
							27.786645211000064
						],
						[
							-82.73686726799991,
							27.78691314300005
						],
						[
							-82.73451516799992,
							27.78691314300005
						],
						[
							-82.73319715299994,
							27.786900709000065
						],
						[
							-82.73236406799992,
							27.78695044500006
						],
						[
							-82.73118282799993,
							27.786938011000075
						],
						[
							-82.73079999999995,
							27.786980000000085
						],
						[
							-82.73071316699992,
							27.786993417000076
						],
						[
							-82.7306584559999,
							27.787020772000062
						],
						[
							-82.73060522499992,
							27.78706767300008
						],
						[
							-82.73053848599994,
							27.78713997300008
						],
						[
							-82.73048509499995,
							27.78719781400008
						],
						[
							-82.73041311199995,
							27.787275795000085
						],
						[
							-82.73036216799994,
							27.787311018000086
						],
						[
							-82.73030259799992,
							27.78733085500005
						],
						[
							-82.73027513799991,
							27.787340000000086
						],
						[
							-82.7300264559999,
							27.787340000000086
						],
						[
							-82.7295663939999,
							27.787340000000086
						],
						[
							-82.72910647299994,
							27.787339320000058
						],
						[
							-82.72873354099994,
							27.787333493000062
						],
						[
							-82.72850999999991,
							27.787330000000054
						],
						[
							-82.72850814799995,
							27.78712442300008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Crossroads Area",
				"RegionID": "417127"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.73098999999992,
					27.78639778800005,
					-82.71836999999994,
					27.791640000000086
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.71932057599992,
							27.791632106000066
						],
						[
							-82.7191499999999,
							27.791630000000055
						],
						[
							-82.71894563399991,
							27.791630000000055
						],
						[
							-82.71871283099995,
							27.791630000000055
						],
						[
							-82.71836999999994,
							27.791630000000055
						],
						[
							-82.71837443299995,
							27.79147927100007
						],
						[
							-82.71838064799994,
							27.791233644000044
						],
						[
							-82.71838465899992,
							27.790884634000065
						],
						[
							-82.71839075699995,
							27.79035413300005
						],
						[
							-82.71839432399992,
							27.790043770000068
						],
						[
							-82.71839878399993,
							27.789655816000053
						],
						[
							-82.71845415999991,
							27.789241837000077
						],
						[
							-82.71891976699993,
							27.788491693000083
						],
						[
							-82.71923157099991,
							27.78813000000008
						],
						[
							-82.71924310399993,
							27.788116622000075
						],
						[
							-82.71948884099993,
							27.78775448400006
						],
						[
							-82.71974751099992,
							27.78741821200009
						],
						[
							-82.7200191149999,
							27.787120742000074
						],
						[
							-82.72022605099994,
							27.78671980300004
						],
						[
							-82.72025191799992,
							27.786422332000086
						],
						[
							-82.72081086499993,
							27.78676328800009
						],
						[
							-82.72086486199994,
							27.78670513800006
						],
						[
							-82.7209405019999,
							27.78662949800008
						],
						[
							-82.72098156399994,
							27.786588436000045
						],
						[
							-82.7210199999999,
							27.78655000000009
						],
						[
							-82.72106162699993,
							27.786512998000035
						],
						[
							-82.7211099999999,
							27.78647000000007
						],
						[
							-82.7211493239999,
							27.786432541000067
						],
						[
							-82.72116091999993,
							27.786423264000064
						],
						[
							-82.72118725899992,
							27.78639778800005
						],
						[
							-82.72118999999992,
							27.786400000000075
						],
						[
							-82.72144693899992,
							27.786605985000055
						],
						[
							-82.72175017299992,
							27.78684908400004
						],
						[
							-82.72206172199992,
							27.787098849000074
						],
						[
							-82.72239102499992,
							27.787362847000054
						],
						[
							-82.72270966499991,
							27.78761829700005
						],
						[
							-82.72308278899993,
							27.787917426000035
						],
						[
							-82.72335403699992,
							27.788134882000065
						],
						[
							-82.7235599999999,
							27.788300000000053
						],
						[
							-82.7236256079999,
							27.78823439200005
						],
						[
							-82.72365999999994,
							27.788200000000074
						],
						[
							-82.72375198399993,
							27.78810801600008
						],
						[
							-82.7238443359999,
							27.788015664000056
						],
						[
							-82.72401445899993,
							27.78784554100008
						],
						[
							-82.72410194999992,
							27.787758050000036
						],
						[
							-82.72414999999995,
							27.78771000000006
						],
						[
							-82.72424631599995,
							27.787627848000056
						],
						[
							-82.72434975999994,
							27.78753961700005
						],
						[
							-82.72444525899994,
							27.787458161000078
						],
						[
							-82.7245222059999,
							27.787394951000067
						],
						[
							-82.72461848799992,
							27.78734407900004
						],
						[
							-82.7247558219999,
							27.78732295000009
						],
						[
							-82.72495028199995,
							27.787310000000048
						],
						[
							-82.72527108399993,
							27.787310000000048
						],
						[
							-82.7258057549999,
							27.787310000000048
						],
						[
							-82.72618488499995,
							27.787310000000048
						],
						[
							-82.72650568699993,
							27.787310000000048
						],
						[
							-82.72670999999991,
							27.787310000000048
						],
						[
							-82.72713756999991,
							27.787310000000048
						],
						[
							-82.7273708809999,
							27.787310000000048
						],
						[
							-82.72750999999994,
							27.787310000000048
						],
						[
							-82.72768194799994,
							27.787314046000063
						],
						[
							-82.72805160899992,
							27.78732274400005
						],
						[
							-82.72823621099991,
							27.78732708700005
						],
						[
							-82.72850999999991,
							27.787330000000054
						],
						[
							-82.72873354099994,
							27.787333493000062
						],
						[
							-82.72910647299994,
							27.787339320000058
						],
						[
							-82.7295663939999,
							27.787340000000086
						],
						[
							-82.7300264559999,
							27.787340000000086
						],
						[
							-82.73027513799991,
							27.787340000000086
						],
						[
							-82.73030259799992,
							27.78733085500005
						],
						[
							-82.73030999999992,
							27.787340000000086
						],
						[
							-82.73044762299992,
							27.787375676000067
						],
						[
							-82.73061871999994,
							27.78750259200007
						],
						[
							-82.73072154499994,
							27.787667726000052
						],
						[
							-82.7307573999999,
							27.787846999000067
						],
						[
							-82.73076999999995,
							27.788100000000043
						],
						[
							-82.73077653799993,
							27.788250367000046
						],
						[
							-82.73079975099995,
							27.78859911300009
						],
						[
							-82.73081959999992,
							27.788869554000087
						],
						[
							-82.73083944899992,
							27.789139995000088
						],
						[
							-82.73086364199992,
							27.78943384100006
						],
						[
							-82.73089835899992,
							27.789565764000088
						],
						[
							-82.73092873399992,
							27.78964372200005
						],
						[
							-82.73098999999992,
							27.78974000000005
						],
						[
							-82.73091232399993,
							27.789786606000064
						],
						[
							-82.73082353599995,
							27.789816616000053
						],
						[
							-82.73031998599993,
							27.789820000000077
						],
						[
							-82.72965966299995,
							27.789820000000077
						],
						[
							-82.72917417499991,
							27.78981897500006
						],
						[
							-82.72884407399994,
							27.789814515000046
						],
						[
							-82.72872730499995,
							27.78981293700008
						],
						[
							-82.72832999999991,
							27.78980000000007
						],
						[
							-82.72833999999995,
							27.790540000000078
						],
						[
							-82.7282318149999,
							27.790548541000078
						],
						[
							-82.72809876899994,
							27.790559045000066
						],
						[
							-82.72795798699991,
							27.790570366000054
						],
						[
							-82.72781508399993,
							27.79060477200005
						],
						[
							-82.72765498699994,
							27.79067250500009
						],
						[
							-82.7275535629999,
							27.79072143400009
						],
						[
							-82.72743620299991,
							27.79079046900006
						],
						[
							-82.72734702199995,
							27.79085946300006
						],
						[
							-82.72726914599991,
							27.790922918000035
						],
						[
							-82.72714999999994,
							27.79102000000006
						],
						[
							-82.72700999999995,
							27.79114000000004
						],
						[
							-82.72678256599994,
							27.79133190300007
						],
						[
							-82.72659707999992,
							27.79147739800004
						],
						[
							-82.72646544799994,
							27.79156121400007
						],
						[
							-82.72635068299991,
							27.791591818000086
						],
						[
							-82.72631999999993,
							27.791600000000074
						],
						[
							-82.72619085999992,
							27.791612127000064
						],
						[
							-82.72594360199992,
							27.79162000000008
						],
						[
							-82.72575448399994,
							27.79162000000008
						],
						[
							-82.72544246599995,
							27.791621088000056
						],
						[
							-82.7251115389999,
							27.791624152000054
						],
						[
							-82.72488461799992,
							27.79162625400005
						],
						[
							-82.7246009669999,
							27.791628880000076
						],
						[
							-82.72447999999991,
							27.791630000000055
						],
						[
							-82.72431303899992,
							27.791630000000055
						],
						[
							-82.72415783699995,
							27.791630000000055
						],
						[
							-82.72401999999994,
							27.791630000000055
						],
						[
							-82.72387329899993,
							27.791630000000055
						],
						[
							-82.7233947599999,
							27.791630000000055
						],
						[
							-82.72277395099991,
							27.791630000000055
						],
						[
							-82.72211434299993,
							27.791630000000055
						],
						[
							-82.72166157999993,
							27.791630802000043
						],
						[
							-82.72100205999993,
							27.791634367000086
						],
						[
							-82.72079835599993,
							27.791635468000038
						],
						[
							-82.72040713599995,
							27.791637583000067
						],
						[
							-82.7199599999999,
							27.791640000000086
						],
						[
							-82.71972161299993,
							27.791637057000063
						],
						[
							-82.71932057599992,
							27.791632106000066
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Tyrone Landing",
				"RegionID": "417129"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.67111941399992,
					27.724257916000056,
					-82.6444899999999,
					27.744730000000065
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.66703999999993,
							27.744730000000065
						],
						[
							-82.66703999999993,
							27.744331988000056
						],
						[
							-82.66703806499993,
							27.74392356000004
						],
						[
							-82.66703303799994,
							27.743802919000075
						],
						[
							-82.66702628399992,
							27.74358135700004
						],
						[
							-82.66702116899995,
							27.74337674900005
						],
						[
							-82.66697667299991,
							27.743284449000043
						],
						[
							-82.66687686699993,
							27.74323701500009
						],
						[
							-82.66678694699993,
							27.74321292600007
						],
						[
							-82.66665708999994,
							27.743209403000037
						],
						[
							-82.66648339299991,
							27.743291898000052
						],
						[
							-82.66635400599995,
							27.743370663000064
						],
						[
							-82.66622749499993,
							27.74344613800008
						],
						[
							-82.66609185299991,
							27.743497332000064
						],
						[
							-82.66599999999994,
							27.743580000000065
						],
						[
							-82.6660203799999,
							27.743464515000085
						],
						[
							-82.66602831299991,
							27.74337625700008
						],
						[
							-82.66602065399991,
							27.743223088000036
						],
						[
							-82.66597684599992,
							27.743083692000084
						],
						[
							-82.66592207399992,
							27.742975028000046
						],
						[
							-82.66583999999995,
							27.74282000000005
						],
						[
							-82.66572322499991,
							27.74270322500007
						],
						[
							-82.66558549199993,
							27.74260978800004
						],
						[
							-82.66542498699994,
							27.742559164000056
						],
						[
							-82.66527201399992,
							27.742547031000072
						],
						[
							-82.66508451199991,
							27.742541349000078
						],
						[
							-82.66498105099993,
							27.74254231200007
						],
						[
							-82.66479366399994,
							27.742549660000066
						],
						[
							-82.66457220699994,
							27.742558345000077
						],
						[
							-82.6644016159999,
							27.742575104000082
						],
						[
							-82.66425040099996,
							27.742603073000055
						],
						[
							-82.66410983599992,
							27.74263692100004
						],
						[
							-82.66397001099995,
							27.742676247000077
						],
						[
							-82.66375012499992,
							27.74272849500005
						],
						[
							-82.6635986089999,
							27.74275655400004
						],
						[
							-82.6633268679999,
							27.742767789000084
						],
						[
							-82.66310475599994,
							27.74277462300006
						],
						[
							-82.6629299999999,
							27.74278000000004
						],
						[
							-82.66293752799993,
							27.742729186000076
						],
						[
							-82.6629494959999,
							27.742648400000068
						],
						[
							-82.66296041299995,
							27.74257471100009
						],
						[
							-82.66296999999992,
							27.742492991000063
						],
						[
							-82.66295999999994,
							27.74242000000004
						],
						[
							-82.6628699019999,
							27.74236996900004
						],
						[
							-82.66276538299991,
							27.74233696300007
						],
						[
							-82.66257030199995,
							27.742274510000076
						],
						[
							-82.66244037599995,
							27.74223247400005
						],
						[
							-82.6623723379999,
							27.74221046200006
						],
						[
							-82.6621987289999,
							27.742172657000083
						],
						[
							-82.66207696899994,
							27.742149091000048
						],
						[
							-82.6620299999999,
							27.742140000000063
						],
						[
							-82.66166599999993,
							27.74175000000008
						],
						[
							-82.66085555099994,
							27.740807415000063
						],
						[
							-82.66086600499995,
							27.74078808900009
						],
						[
							-82.66087816399994,
							27.74076633900006
						],
						[
							-82.6609092409999,
							27.740716363000047
						],
						[
							-82.66094351999995,
							27.740668527000082
						],
						[
							-82.66098085399994,
							27.740623036000045
						],
						[
							-82.66100525799993,
							27.740596312000037
						],
						[
							-82.66101498099994,
							27.740586086000064
						],
						[
							-82.6610193219999,
							27.740569238000035
						],
						[
							-82.66103055299993,
							27.74053077000008
						],
						[
							-82.66106155299991,
							27.74043277000004
						],
						[
							-82.66106740399994,
							27.74041492200007
						],
						[
							-82.6610881339999,
							27.740359844000068
						],
						[
							-82.66111242199992,
							27.740306240000052
						],
						[
							-82.6611401639999,
							27.740254339000046
						],
						[
							-82.66117124099992,
							27.74020436300009
						],
						[
							-82.6612055189999,
							27.740156527000067
						],
						[
							-82.66122111099992,
							27.740137529000037
						],
						[
							-82.6611945279999,
							27.740118480000035
						],
						[
							-82.66116026999993,
							27.74009083500005
						],
						[
							-82.66104826899993,
							27.73999583500006
						],
						[
							-82.66103703599993,
							27.739986146000035
						],
						[
							-82.66099408299993,
							27.739945917000057
						],
						[
							-82.6609538539999,
							27.739902964000066
						],
						[
							-82.66091651999994,
							27.73985747300009
						],
						[
							-82.66091336199992,
							27.739853332000052
						],
						[
							-82.6606905399999,
							27.739559437000082
						],
						[
							-82.66034412099992,
							27.739133226000035
						],
						[
							-82.66032851999995,
							27.73911347300009
						],
						[
							-82.66029424099992,
							27.739065637000067
						],
						[
							-82.66027282499994,
							27.73903199500006
						],
						[
							-82.66010682599995,
							27.73875799500007
						],
						[
							-82.66009716399992,
							27.738741661000063
						],
						[
							-82.66006942299992,
							27.738689760000057
						],
						[
							-82.6600451349999,
							27.73863615600004
						],
						[
							-82.66002440499994,
							27.73858107800004
						],
						[
							-82.6600073219999,
							27.738524762000054
						],
						[
							-82.66000020299992,
							27.738496353000073
						],
						[
							-82.65997816399994,
							27.738401900000042
						],
						[
							-82.65997044499994,
							27.738393362000068
						],
						[
							-82.65964594099995,
							27.73817310700008
						],
						[
							-82.65960352699994,
							27.73814248000008
						],
						[
							-82.65955803599991,
							27.738105146000066
						],
						[
							-82.65951508399992,
							27.738064917000088
						],
						[
							-82.65925396699993,
							27.73780380100004
						],
						[
							-82.6590843269999,
							27.737715112000046
						],
						[
							-82.6589609209999,
							27.737669163000078
						],
						[
							-82.65872743999995,
							27.737658362000047
						],
						[
							-82.65871018199994,
							27.737657397000078
						],
						[
							-82.65865161499994,
							27.737651629000084
						],
						[
							-82.65859355099991,
							27.73764204200006
						],
						[
							-82.6585362379999,
							27.73762867900007
						],
						[
							-82.6584799229999,
							27.73761159600008
						],
						[
							-82.65842484399991,
							27.737590866000062
						],
						[
							-82.65837123999995,
							27.73756657800004
						],
						[
							-82.65831933899995,
							27.737538836000056
						],
						[
							-82.65829256699993,
							27.737522753000064
						],
						[
							-82.65829161499994,
							27.73752262800008
						],
						[
							-82.65823355099991,
							27.737513042000046
						],
						[
							-82.65819089099995,
							27.73750347300006
						],
						[
							-82.65815089099993,
							27.737493473000086
						],
						[
							-82.65813623799994,
							27.73748967900008
						],
						[
							-82.6580799219999,
							27.737472595000042
						],
						[
							-82.6580248439999,
							27.73745186600007
						],
						[
							-82.65797123999994,
							27.73742757800005
						],
						[
							-82.65791933899993,
							27.73739983600007
						],
						[
							-82.65786936299992,
							27.73736875900005
						],
						[
							-82.65782152699991,
							27.737334480000072
						],
						[
							-82.65779492399992,
							27.73731325600005
						],
						[
							-82.6577539239999,
							27.73727925500009
						],
						[
							-82.65773503499992,
							27.73726314600009
						],
						[
							-82.65769208299992,
							27.737222916000068
						],
						[
							-82.65765185299996,
							27.737179964000063
						],
						[
							-82.65761451899994,
							27.737134472000037
						],
						[
							-82.6576044279999,
							27.737121063000075
						],
						[
							-82.65755871199991,
							27.737059125000087
						],
						[
							-82.6575273389999,
							27.73704183600006
						],
						[
							-82.65747736299994,
							27.737010759000043
						],
						[
							-82.65744468199995,
							27.736987857000088
						],
						[
							-82.65696211699992,
							27.73663347300004
						],
						[
							-82.65680820699993,
							27.736538631000087
						],
						[
							-82.65678036299994,
							27.736520759000086
						],
						[
							-82.65673252699992,
							27.736486480000053
						],
						[
							-82.65668703599994,
							27.73644914600004
						],
						[
							-82.65664408299995,
							27.736408917000066
						],
						[
							-82.65663572799991,
							27.736400451000065
						],
						[
							-82.65626272799994,
							27.736017451000066
						],
						[
							-82.65624276599993,
							27.735996278000073
						],
						[
							-82.65610676599994,
							27.73584727800005
						],
						[
							-82.65609485399995,
							27.73583396400005
						],
						[
							-82.65605751999993,
							27.73578847200008
						],
						[
							-82.65603319699994,
							27.735755225000048
						],
						[
							-82.6560218969999,
							27.735739012000067
						],
						[
							-82.65599103599993,
							27.73571314600008
						],
						[
							-82.65594808299994,
							27.735672917000045
						],
						[
							-82.6559078539999,
							27.735629964000054
						],
						[
							-82.65587051999995,
							27.735584473000074
						],
						[
							-82.65585462399993,
							27.735563109000054
						],
						[
							-82.65579877399995,
							27.735485680000068
						],
						[
							-82.65576111199994,
							27.735445005000088
						],
						[
							-82.65574485399992,
							27.735426964000055
						],
						[
							-82.65570751999991,
							27.735381472000086
						],
						[
							-82.65567412799993,
							27.73533496200008
						],
						[
							-82.65564790499991,
							27.73530873900006
						],
						[
							-82.65553160999991,
							27.73521900500009
						],
						[
							-82.65548803599995,
							27.735183146000054
						],
						[
							-82.65544508399995,
							27.73514291700008
						],
						[
							-82.65540485399993,
							27.73509996400009
						],
						[
							-82.65536751999991,
							27.73505447300005
						],
						[
							-82.65533324099994,
							27.735006637000083
						],
						[
							-82.65530216499991,
							27.73495666100007
						],
						[
							-82.65527442299992,
							27.734904760000063
						],
						[
							-82.65526802099993,
							27.73489063100004
						],
						[
							-82.6552315269999,
							27.734864480000056
						],
						[
							-82.65518603599992,
							27.734827146000043
						],
						[
							-82.65514308299993,
							27.734786916000076
						],
						[
							-82.65510285399996,
							27.734743964000074
						],
						[
							-82.65506551999994,
							27.73469847200005
						],
						[
							-82.6550435289999,
							27.73466855500004
						],
						[
							-82.65500552899994,
							27.734614555000064
						],
						[
							-82.65499324099994,
							27.73459663700004
						],
						[
							-82.65496216399993,
							27.73454666100008
						],
						[
							-82.65493442199994,
							27.734494760000075
						],
						[
							-82.65491013499991,
							27.73444115600006
						],
						[
							-82.65490211299993,
							27.734421112000064
						],
						[
							-82.65488511299992,
							27.734377111000075
						],
						[
							-82.65487240499994,
							27.734342077000065
						],
						[
							-82.65485532199995,
							27.73428576100008
						],
						[
							-82.65484779299993,
							27.734255587000064
						],
						[
							-82.65483716499995,
							27.734237661000066
						],
						[
							-82.65481207999994,
							27.734191103000057
						],
						[
							-82.65467524099995,
							27.734087828000042
						],
						[
							-82.6546695269999,
							27.73408348000004
						],
						[
							-82.65462403599992,
							27.734046146000082
						],
						[
							-82.65458108299993,
							27.734005916000058
						],
						[
							-82.65454085399995,
							27.733962964000057
						],
						[
							-82.65450351999993,
							27.733917472000087
						],
						[
							-82.6544692409999,
							27.733869636000065
						],
						[
							-82.65443816399996,
							27.73381966100004
						],
						[
							-82.65442623399991,
							27.733798334000085
						],
						[
							-82.65441323499994,
							27.73377433400009
						],
						[
							-82.65439742299992,
							27.73374376000004
						],
						[
							-82.6543731349999,
							27.73369015600008
						],
						[
							-82.65435240499994,
							27.733635078000077
						],
						[
							-82.65433532199995,
							27.73357876200004
						],
						[
							-82.65433002999993,
							27.73355802900005
						],
						[
							-82.65418242999993,
							27.733381101000077
						],
						[
							-82.65415951999995,
							27.733352472000036
						],
						[
							-82.6541384699999,
							27.733323889000076
						],
						[
							-82.65377909099993,
							27.73281515800005
						],
						[
							-82.65370146399994,
							27.732777617000067
						],
						[
							-82.65369523999993,
							27.732774577000047
						],
						[
							-82.65364333899993,
							27.732746836000047
						],
						[
							-82.65361807599993,
							27.732731693000062
						],
						[
							-82.65309707499995,
							27.732407693000084
						],
						[
							-82.65307236299992,
							27.732391759000055
						],
						[
							-82.6530245269999,
							27.732357480000076
						],
						[
							-82.65297903599992,
							27.732320146000063
						],
						[
							-82.65293608299993,
							27.732279917000085
						],
						[
							-82.65291766199994,
							27.732260946000054
						],
						[
							-82.6528186619999,
							27.732155946000034
						],
						[
							-82.65279685399992,
							27.732131964000075
						],
						[
							-82.6527595199999,
							27.73208647200005
						],
						[
							-82.65274164599992,
							27.732062356000085
						],
						[
							-82.65267481899991,
							27.73196897100007
						],
						[
							-82.65261040799993,
							27.731952595000056
						],
						[
							-82.65259923799994,
							27.73194967900008
						],
						[
							-82.65254292199995,
							27.731932595000046
						],
						[
							-82.65248784399995,
							27.731911866000075
						],
						[
							-82.65243423999993,
							27.73188757800006
						],
						[
							-82.65241637899993,
							27.73187852100006
						],
						[
							-82.65234537999993,
							27.731841521000035
						],
						[
							-82.65231133899995,
							27.73182283500006
						],
						[
							-82.65226136399991,
							27.731791758000043
						],
						[
							-82.65221786299992,
							27.731760785000063
						],
						[
							-82.65220067199994,
							27.731754246000037
						],
						[
							-82.6521496709999,
							27.731734246000087
						],
						[
							-82.65213384399993,
							27.73172786500004
						],
						[
							-82.65208023999992,
							27.731703577000076
						],
						[
							-82.65202833899993,
							27.73167583600008
						],
						[
							-82.6519783629999,
							27.731644759000062
						],
						[
							-82.65193052699993,
							27.731610480000086
						],
						[
							-82.65188503499992,
							27.731573146000073
						],
						[
							-82.6518420829999,
							27.731532917000038
						],
						[
							-82.65180185399993,
							27.731489964000048
						],
						[
							-82.65177967099993,
							27.731463672000075
						],
						[
							-82.6517224129999,
							27.73140664200008
						],
						[
							-82.6516837819999,
							27.731410533000087
						],
						[
							-82.65164578299994,
							27.73141353300008
						],
						[
							-82.65163381899993,
							27.731414397000037
						],
						[
							-82.65157499999992,
							27.731416322000086
						],
						[
							-82.65151618199991,
							27.731414397000037
						],
						[
							-82.65145761499991,
							27.731408629000043
						],
						[
							-82.65139955099994,
							27.73139904200008
						],
						[
							-82.65134223899992,
							27.731385679000084
						],
						[
							-82.65128592299993,
							27.73136859600004
						],
						[
							-82.65123084499993,
							27.73134786600008
						],
						[
							-82.65117723999992,
							27.731323578000058
						],
						[
							-82.65112533899992,
							27.731295836000072
						],
						[
							-82.65107536399995,
							27.731264759000055
						],
						[
							-82.65105925699993,
							27.731253743000085
						],
						[
							-82.65103925699992,
							27.73123974200007
						],
						[
							-82.65100752799992,
							27.731216480000057
						],
						[
							-82.6509620359999,
							27.731179146000045
						],
						[
							-82.65091908399995,
							27.731138917000067
						],
						[
							-82.65087885399993,
							27.731095964000076
						],
						[
							-82.65084151999991,
							27.73105047200005
						],
						[
							-82.65080724099994,
							27.731002636000085
						],
						[
							-82.65078447399992,
							27.730966023000065
						],
						[
							-82.6507801599999,
							27.730964411000063
						],
						[
							-82.6507508439999,
							27.730952865000063
						],
						[
							-82.65069723999994,
							27.73092857800009
						],
						[
							-82.65064533899994,
							27.730900836000046
						],
						[
							-82.65059536299992,
							27.730869759000086
						],
						[
							-82.6505475269999,
							27.730835480000053
						],
						[
							-82.65052914299991,
							27.73082099000004
						],
						[
							-82.65049606199996,
							27.730794209000067
						],
						[
							-82.6503584159999,
							27.730712615000073
						],
						[
							-82.65031736299994,
							27.730686759000037
						],
						[
							-82.65026952699994,
							27.73065248000006
						],
						[
							-82.65022403499995,
							27.730615146000048
						],
						[
							-82.65018108299995,
							27.73057491700007
						],
						[
							-82.65014708299992,
							27.73054091700004
						],
						[
							-82.65010685399994,
							27.73049796400005
						],
						[
							-82.65006951999993,
							27.73045247300007
						],
						[
							-82.6500640029999,
							27.73044520700006
						],
						[
							-82.65002403599993,
							27.730412147000038
						],
						[
							-82.64998108399993,
							27.73037191700007
						],
						[
							-82.64994085399991,
							27.73032896500007
						],
						[
							-82.64993339999995,
							27.73031988200006
						],
						[
							-82.64989084399991,
							27.730303865000053
						],
						[
							-82.6498372399999,
							27.73027957700009
						],
						[
							-82.64978533899995,
							27.730251836000036
						],
						[
							-82.64977652099992,
							27.73024667800007
						],
						[
							-82.6496955209999,
							27.73019867700009
						],
						[
							-82.64965436299991,
							27.730172759000084
						],
						[
							-82.64960652699995,
							27.73013848000005
						],
						[
							-82.64956103499992,
							27.730101146000038
						],
						[
							-82.64951808299992,
							27.73006091600007
						],
						[
							-82.6494837859999,
							27.730024661000073
						],
						[
							-82.64943278599992,
							27.729967661000046
						],
						[
							-82.6494268539999,
							27.729960964000043
						],
						[
							-82.64938951999994,
							27.729915472000076
						],
						[
							-82.64935524099991,
							27.72986763600005
						],
						[
							-82.64933042799993,
							27.729828340000044
						],
						[
							-82.64923463399992,
							27.72966757200004
						],
						[
							-82.64923264099991,
							27.72966700900008
						],
						[
							-82.64907354499991,
							27.729619694000064
						],
						[
							-82.64891733399992,
							27.72962839300004
						],
						[
							-82.6489158409999,
							27.72963007700008
						],
						[
							-82.64889583599995,
							27.729666661000067
						],
						[
							-82.64886475899993,
							27.729716636000035
						],
						[
							-82.64883822799993,
							27.72975422400009
						],
						[
							-82.6488299159999,
							27.729781105000086
						],
						[
							-82.64873416799992,
							27.730074384000094
						],
						[
							-82.64873604099995,
							27.730083551000064
						],
						[
							-82.64874562799992,
							27.730141615000036
						],
						[
							-82.64875139599991,
							27.73020018200009
						],
						[
							-82.64875332199995,
							27.730259000000046
						],
						[
							-82.6487529989999,
							27.730283075000045
						],
						[
							-82.64875202499991,
							27.730319459000047
						],
						[
							-82.64886265399991,
							27.730483397000057
						],
						[
							-82.6489529559999,
							27.730582351000066
						],
						[
							-82.64906938599995,
							27.73068539800005
						],
						[
							-82.6492165539999,
							27.730799671000057
						],
						[
							-82.6492579639999,
							27.730833854000082
						],
						[
							-82.64930091699995,
							27.73087408400005
						],
						[
							-82.64932294599993,
							27.730896904000076
						],
						[
							-82.64936394599994,
							27.73094090300009
						],
						[
							-82.64938214599994,
							27.730961035000064
						],
						[
							-82.64941947999995,
							27.73100652700009
						],
						[
							-82.64945375899993,
							27.731054363000055
						],
						[
							-82.64948483599994,
							27.73110433900007
						],
						[
							-82.64951257799993,
							27.731156240000075
						],
						[
							-82.64951428299992,
							27.731159716000036
						],
						[
							-82.64953428299992,
							27.731200716000046
						],
						[
							-82.6495568659999,
							27.731250844000044
						],
						[
							-82.64957759499993,
							27.731305922000047
						],
						[
							-82.64959467899992,
							27.731362238000088
						],
						[
							-82.6496080419999,
							27.731419551000045
						],
						[
							-82.64961762899992,
							27.731477615000074
						],
						[
							-82.64962184199993,
							27.73151595300004
						],
						[
							-82.64962484199992,
							27.73154995400006
						],
						[
							-82.6496263969999,
							27.73157018200004
						],
						[
							-82.6496283219999,
							27.731629000000055
						],
						[
							-82.6496263969999,
							27.731687819000058
						],
						[
							-82.64962062899991,
							27.731746386000054
						],
						[
							-82.64961104199995,
							27.731804449000037
						],
						[
							-82.6495976789999,
							27.73186176200005
						],
						[
							-82.64958059599991,
							27.731918078000035
						],
						[
							-82.64956967199993,
							27.731948456000055
						],
						[
							-82.64930367099993,
							27.732648456000053
						],
						[
							-82.64929386499995,
							27.73267315600009
						],
						[
							-82.64926957699993,
							27.732726760000048
						],
						[
							-82.64924183599993,
							27.732778661000054
						],
						[
							-82.64923315899996,
							27.732793365000077
						],
						[
							-82.64922871399995,
							27.732800737000048
						],
						[
							-82.64908658399993,
							27.73315101600008
						],
						[
							-82.64904608999991,
							27.733281356000077
						],
						[
							-82.64893567999991,
							27.733800932000065
						],
						[
							-82.6489246779999,
							27.73384676200004
						],
						[
							-82.64891320299995,
							27.73388599900005
						],
						[
							-82.6488472019999,
							27.734093999000038
						],
						[
							-82.64884159499991,
							27.73411107800007
						],
						[
							-82.64882086499995,
							27.73416615600007
						],
						[
							-82.64879657699993,
							27.734219760000087
						],
						[
							-82.64878289899991,
							27.734246370000054
						],
						[
							-82.64874489899995,
							27.734317370000046
						],
						[
							-82.64873083499992,
							27.734342661000085
						],
						[
							-82.6486997589999,
							27.734392636000052
						],
						[
							-82.64869911199992,
							27.73439360200007
						],
						[
							-82.64865279599991,
							27.73446272600006
						],
						[
							-82.64863472499991,
							27.73476556800006
						],
						[
							-82.64863439599992,
							27.734770818000072
						],
						[
							-82.64863028699995,
							27.734816011000078
						],
						[
							-82.64861768599991,
							27.734924231000036
						],
						[
							-82.64861187999992,
							27.73510921400009
						],
						[
							-82.64861039699991,
							27.73513981900004
						],
						[
							-82.64860462899992,
							27.735198385000047
						],
						[
							-82.64860454299992,
							27.735199031000036
						],
						[
							-82.64854854299995,
							27.735622031000048
						],
						[
							-82.64853904099995,
							27.73567944900009
						],
						[
							-82.64852567799994,
							27.735736762000045
						],
						[
							-82.64852124999993,
							27.735752700000035
						],
						[
							-82.64848125099991,
							27.73589170000008
						],
						[
							-82.64846859599993,
							27.735932078000076
						],
						[
							-82.64844786599991,
							27.73598715600008
						],
						[
							-82.6484380089999,
							27.736010050000065
						],
						[
							-82.6484000079999,
							27.736095049000085
						],
						[
							-82.64838557699994,
							27.73612576000005
						],
						[
							-82.6483578349999,
							27.736177661000056
						],
						[
							-82.64832675899993,
							27.73622763600008
						],
						[
							-82.64829247999995,
							27.736275472000045
						],
						[
							-82.64828125499992,
							27.736289798000087
						],
						[
							-82.64824525499995,
							27.736334799000076
						],
						[
							-82.64821914599992,
							27.736365964000075
						],
						[
							-82.64817891599995,
							27.736408917000066
						],
						[
							-82.64813596399995,
							27.73644914600004
						],
						[
							-82.64813414799994,
							27.736450734000073
						],
						[
							-82.64812457799991,
							27.73647076000009
						],
						[
							-82.64812319399994,
							27.736473553000053
						],
						[
							-82.6480251939999,
							27.736670554000057
						],
						[
							-82.64799883599994,
							27.736719661000052
						],
						[
							-82.64796775899993,
							27.736769637000066
						],
						[
							-82.64793347999995,
							27.736817473000087
						],
						[
							-82.64789614599994,
							27.736862965000057
						],
						[
							-82.64785591399993,
							27.736905920000083
						],
						[
							-82.64781190999992,
							27.736949923000054
						],
						[
							-82.64776896399991,
							27.73699014600004
						],
						[
							-82.64772347199994,
							27.73702748000005
						],
						[
							-82.64767563599992,
							27.737061759000085
						],
						[
							-82.64763506899993,
							27.737086985000076
						],
						[
							-82.64746316599991,
							27.73697328900005
						],
						[
							-82.64705924299994,
							27.736569366000086
						],
						[
							-82.64684499999993,
							27.736397000000068
						],
						[
							-82.64659999999992,
							27.73633241500005
						],
						[
							-82.64659999999992,
							27.736104625000053
						],
						[
							-82.64659371599993,
							27.73578578600007
						],
						[
							-82.64658474499993,
							27.73549421000007
						],
						[
							-82.64657999999991,
							27.735220800000036
						],
						[
							-82.64657999999991,
							27.734874560000037
						],
						[
							-82.64657999999991,
							27.734418980000044
						],
						[
							-82.64657587999994,
							27.733726343000058
						],
						[
							-82.64656531199995,
							27.733234345000085
						],
						[
							-82.64655560599994,
							27.732787890000054
						],
						[
							-82.64655203799992,
							27.73262376000008
						],
						[
							-82.64652904299993,
							27.732390286000054
						],
						[
							-82.64650264399995,
							27.732214292000037
						],
						[
							-82.6464748489999,
							27.73205045700007
						],
						[
							-82.64645211999994,
							27.73193112900009
						],
						[
							-82.64641999999992,
							27.731760000000065
						],
						[
							-82.64637506999992,
							27.731634197000062
						],
						[
							-82.64630139699995,
							27.73149086500007
						],
						[
							-82.64620784499994,
							27.73131476800006
						],
						[
							-82.6460907099999,
							27.73116183700006
						],
						[
							-82.64599488599993,
							27.73104876600007
						],
						[
							-82.64580186799992,
							27.730821005000053
						],
						[
							-82.6456399999999,
							27.730630000000076
						],
						[
							-82.6455672219999,
							27.730545731000063
						],
						[
							-82.64543343799994,
							27.73039082300005
						],
						[
							-82.64525999999995,
							27.73019000000005
						],
						[
							-82.64517692099992,
							27.730088959000057
						],
						[
							-82.6450747099999,
							27.72996464700009
						],
						[
							-82.64493912299992,
							27.729799745000037
						],
						[
							-82.64483813399994,
							27.729662201000053
						],
						[
							-82.64469665799993,
							27.72941361800008
						],
						[
							-82.64463999999992,
							27.72929000000005
						],
						[
							-82.6445759099999,
							27.729099701000052
						],
						[
							-82.64454938599994,
							27.729011288000038
						],
						[
							-82.64453147699994,
							27.728951591000055
						],
						[
							-82.64450738099993,
							27.728857736000066
						],
						[
							-82.64449659399993,
							27.728766048000068
						],
						[
							-82.6444899999999,
							27.72864896200008
						],
						[
							-82.6444899999999,
							27.728602484000078
						],
						[
							-82.6444899999999,
							27.72855000000004
						],
						[
							-82.6444941279999,
							27.72849221100006
						],
						[
							-82.64449790299994,
							27.728439363000064
						],
						[
							-82.64449999999994,
							27.728410000000054
						],
						[
							-82.64450958599991,
							27.728347688000042
						],
						[
							-82.64454185199992,
							27.72820078700005
						],
						[
							-82.64459916599992,
							27.72799302100009
						],
						[
							-82.64467587799993,
							27.727784498000062
						],
						[
							-82.64479364699991,
							27.727465540000082
						],
						[
							-82.6448679259999,
							27.727279494000072
						],
						[
							-82.64495719799993,
							27.727086071000087
						],
						[
							-82.64501999999993,
							27.726950000000045
						],
						[
							-82.64504350999994,
							27.72689385700005
						],
						[
							-82.64507999999995,
							27.726830000000064
						],
						[
							-82.6451368779999,
							27.726694915000053
						],
						[
							-82.64517829599993,
							27.726596547000042
						],
						[
							-82.64522056499993,
							27.726496159000078
						],
						[
							-82.64523999999994,
							27.72645000000006
						],
						[
							-82.64527826799991,
							27.726373464000062
						],
						[
							-82.64531895899995,
							27.72631742100009
						],
						[
							-82.6453699999999,
							27.72626000000008
						],
						[
							-82.64547050899995,
							27.726152312000067
						],
						[
							-82.64556113799995,
							27.72606187000008
						],
						[
							-82.64570244799995,
							27.72593345900009
						],
						[
							-82.64580937699992,
							27.725854669000057
						],
						[
							-82.64593503899994,
							27.725761221000084
						],
						[
							-82.64602999999994,
							27.725690000000043
						],
						[
							-82.6461328229999,
							27.72559360400004
						],
						[
							-82.64631777599995,
							27.725386352000044
						],
						[
							-82.64637432699993,
							27.725298509000083
						],
						[
							-82.64641999999992,
							27.725230000000067
						],
						[
							-82.64642241799993,
							27.725223552000045
						],
						[
							-82.64651926199991,
							27.725236204000055
						],
						[
							-82.64668999999992,
							27.725230000000067
						],
						[
							-82.64726728499994,
							27.72501377900005
						],
						[
							-82.64756465199991,
							27.724871057000087
						],
						[
							-82.64804669499995,
							27.724682174000066
						],
						[
							-82.64853237199992,
							27.72454065000005
						],
						[
							-82.64898320599993,
							27.72442817700005
						],
						[
							-82.64946668899995,
							27.724331348000078
						],
						[
							-82.65000395499993,
							27.72427034900005
						],
						[
							-82.65044845699992,
							27.724257916000056
						],
						[
							-82.65089646199993,
							27.724274929000046
						],
						[
							-82.65133999999995,
							27.72434000000004
						],
						[
							-82.65156908199992,
							27.724376653000036
						],
						[
							-82.6517952829999,
							27.724432254000078
						],
						[
							-82.6520806989999,
							27.72450490500006
						],
						[
							-82.6523858079999,
							27.724605333000056
						],
						[
							-82.65282482299995,
							27.724806316000073
						],
						[
							-82.65317988599992,
							27.72499134900005
						],
						[
							-82.65365486199994,
							27.72526014600004
						],
						[
							-82.65415991399993,
							27.725573462000057
						],
						[
							-82.65459075299992,
							27.725870802000088
						],
						[
							-82.65493367199991,
							27.726126189000073
						],
						[
							-82.65526113699991,
							27.726380884000037
						],
						[
							-82.65560591699995,
							27.726669358000038
						],
						[
							-82.65604234199992,
							27.727065689000085
						],
						[
							-82.6563635899999,
							27.727383590000045
						],
						[
							-82.65673511999995,
							27.72777809200005
						],
						[
							-82.6570924749999,
							27.728187696000077
						],
						[
							-82.6573403349999,
							27.728521155000067
						],
						[
							-82.65763687399993,
							27.728921742000068
						],
						[
							-82.65800760799993,
							27.72945155700006
						],
						[
							-82.65833628299993,
							27.729924649000054
						],
						[
							-82.65857442499993,
							27.73022377300009
						],
						[
							-82.65884528999993,
							27.73056321200005
						],
						[
							-82.65912999999996,
							27.730920000000083
						],
						[
							-82.65926331499992,
							27.731070367000086
						],
						[
							-82.6594569639999,
							27.73128878500006
						],
						[
							-82.65969820799995,
							27.731560886000068
						],
						[
							-82.66004337999995,
							27.73195005300005
						],
						[
							-82.6604099999999,
							27.732300000000066
						],
						[
							-82.66065999999995,
							27.73266000000007
						],
						[
							-82.66091293799991,
							27.732873298000072
						],
						[
							-82.66120411399993,
							27.73311884200007
						],
						[
							-82.66160735599993,
							27.73345889000007
						],
						[
							-82.6618827819999,
							27.733691152000063
						],
						[
							-82.66232327599995,
							27.73402221200007
						],
						[
							-82.66271849099991,
							27.734306099000037
						],
						[
							-82.66292990599993,
							27.73445796100009
						],
						[
							-82.66323158799992,
							27.73467466200009
						],
						[
							-82.66348347299993,
							27.734839548000082
						],
						[
							-82.6639526649999,
							27.735057965000067
						],
						[
							-82.66441290199992,
							27.73531673000008
						],
						[
							-82.66472238699993,
							27.735494169000052
						],
						[
							-82.66495809799994,
							27.73569918000004
						],
						[
							-82.66513869599993,
							27.735923479000064
						],
						[
							-82.66524124799992,
							27.736108880000074
						],
						[
							-82.6653510889999,
							27.736195597000062
						],
						[
							-82.66559771399994,
							27.736390301000085
						],
						[
							-82.66597386899991,
							27.73668726500006
						],
						[
							-82.66642463399995,
							27.737043132000053
						],
						[
							-82.66676141199991,
							27.737309009000057
						],
						[
							-82.66724326399992,
							27.73768941900005
						],
						[
							-82.66750999999994,
							27.73790000000008
						],
						[
							-82.66766229199993,
							27.737987640000085
						],
						[
							-82.6679648949999,
							27.738161779000052
						],
						[
							-82.66838391699991,
							27.73840291500005
						],
						[
							-82.66874042099994,
							27.73857915600007
						],
						[
							-82.66905937299993,
							27.738708586000087
						],
						[
							-82.66936861399995,
							27.738805039000056
						],
						[
							-82.66972224299991,
							27.738854003000085
						],
						[
							-82.67007335099993,
							27.73888363000009
						],
						[
							-82.6703607369999,
							27.738889829000072
						],
						[
							-82.67061739899994,
							27.73883014000006
						],
						[
							-82.67098183799993,
							27.738694081000062
						],
						[
							-82.67111941399992,
							27.73862529300004
						],
						[
							-82.67110469499994,
							27.741304239000044
						],
						[
							-82.67108999999994,
							27.742210000000057
						],
						[
							-82.67108999999994,
							27.74262771200006
						],
						[
							-82.67108999999994,
							27.743127136000055
						],
						[
							-82.67108999999994,
							27.74365153000008
						],
						[
							-82.67108999999994,
							27.744076041000085
						],
						[
							-82.67109893999992,
							27.74442584600007
						],
						[
							-82.67110543299992,
							27.744730000000065
						],
						[
							-82.67056071199994,
							27.744730000000065
						],
						[
							-82.67027999999993,
							27.744730000000065
						],
						[
							-82.66986119599994,
							27.744730000000065
						],
						[
							-82.66946999999993,
							27.744730000000065
						],
						[
							-82.66893988899994,
							27.744723907000036
						],
						[
							-82.66859999999993,
							27.744720000000086
						],
						[
							-82.6682574159999,
							27.744722196000055
						],
						[
							-82.6678479599999,
							27.74472482100009
						],
						[
							-82.66703999999993,
							27.744730000000065
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Boyd Hill Nature Preserve",
				"RegionID": "417136"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.63869999999991,
					27.740673701000052,
					-82.63344611699995,
					27.748440000000073
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.63478752399993,
							27.741295489000038
						],
						[
							-82.63533733399993,
							27.74093126400004
						],
						[
							-82.63540414199991,
							27.74089106100007
						],
						[
							-82.63547418299993,
							27.74085679600006
						],
						[
							-82.63554692699995,
							27.740828726000075
						],
						[
							-82.63562182999995,
							27.74080706400008
						],
						[
							-82.63579483099994,
							27.740765063000083
						],
						[
							-82.63587112399995,
							27.740750001000038
						],
						[
							-82.63594843399994,
							27.74074158700006
						],
						[
							-82.63602618099992,
							27.74073988200007
						],
						[
							-82.63610378499993,
							27.740744901000085
						],
						[
							-82.6362977849999,
							27.74076590100009
						],
						[
							-82.63636304299992,
							27.74077539700005
						],
						[
							-82.63642742999991,
							27.740789649000078
						],
						[
							-82.63649059999995,
							27.740808582000057
						],
						[
							-82.63655221199991,
							27.74083209300005
						],
						[
							-82.63661193599995,
							27.74086005500004
						],
						[
							-82.63675634599991,
							27.740934243000083
						],
						[
							-82.63691211299994,
							27.74101347700008
						],
						[
							-82.63697710199995,
							27.740948871000057
						],
						[
							-82.6372006549999,
							27.740673701000052
						],
						[
							-82.6378802449999,
							27.74126343900008
						],
						[
							-82.63839499999995,
							27.74125500000008
						],
						[
							-82.63869999999991,
							27.741250000000036
						],
						[
							-82.63864513099992,
							27.74160529800008
						],
						[
							-82.63864213599993,
							27.741839129000084
						],
						[
							-82.6386599999999,
							27.74225000000007
						],
						[
							-82.63862480899991,
							27.74334305600007
						],
						[
							-82.63860999999991,
							27.743580000000065
						],
						[
							-82.63860706199995,
							27.74372103500008
						],
						[
							-82.63859999999995,
							27.744060000000047
						],
						[
							-82.63859712199991,
							27.744287324000084
						],
						[
							-82.63859473999992,
							27.744475531000035
						],
						[
							-82.63858999999991,
							27.744850000000046
						],
						[
							-82.63858630799992,
							27.745134257000075
						],
						[
							-82.6385844749999,
							27.74527541100008
						],
						[
							-82.63857999999993,
							27.745720000000063
						],
						[
							-82.63857409799994,
							27.746263012000043
						],
						[
							-82.6385699999999,
							27.74664000000007
						],
						[
							-82.63856215999994,
							27.747157462000075
						],
						[
							-82.63855999999993,
							27.747863556000084
						],
						[
							-82.63855999999993,
							27.748440000000073
						],
						[
							-82.6385594809999,
							27.748440000000073
						],
						[
							-82.63832338799995,
							27.748440000000073
						],
						[
							-82.63798153399995,
							27.748440000000073
						],
						[
							-82.63761999999991,
							27.748440000000073
						],
						[
							-82.63744554599992,
							27.74822677800006
						],
						[
							-82.63726155399992,
							27.748001899000087
						],
						[
							-82.63707999999991,
							27.747780000000038
						],
						[
							-82.6369481289999,
							27.74761815900007
						],
						[
							-82.6368599999999,
							27.74751000000009
						],
						[
							-82.63672713999995,
							27.747346479000043
						],
						[
							-82.63659999999993,
							27.747190000000046
						],
						[
							-82.6363677789999,
							27.746912018000046
						],
						[
							-82.6362469309999,
							27.74675983900005
						],
						[
							-82.63611999999995,
							27.746600000000058
						],
						[
							-82.6359690029999,
							27.746407821000048
						],
						[
							-82.63575081999994,
							27.74616149700006
						],
						[
							-82.63557999999995,
							27.74598000000009
						],
						[
							-82.63544684899995,
							27.745836197000074
						],
						[
							-82.63533101799993,
							27.745711100000054
						],
						[
							-82.6353299999999,
							27.745710000000088
						],
						[
							-82.63518984599995,
							27.745532472000036
						],
						[
							-82.63510514099994,
							27.74542517900005
						],
						[
							-82.63502999999992,
							27.74533000000008
						],
						[
							-82.63488660799993,
							27.745140983000056
						],
						[
							-82.6348099999999,
							27.745040000000074
						],
						[
							-82.63504292099992,
							27.74483489100004
						],
						[
							-82.63523983399995,
							27.744661490000055
						],
						[
							-82.63537110899995,
							27.74454588900005
						],
						[
							-82.63547999999992,
							27.744450000000086
						],
						[
							-82.63530382599993,
							27.744229782000048
						],
						[
							-82.63512105899991,
							27.744001324000067
						],
						[
							-82.63498098299993,
							27.743826228000046
						],
						[
							-82.63484999999991,
							27.74368000000004
						],
						[
							-82.63468665099994,
							27.74350644100008
						],
						[
							-82.63406449699994,
							27.742845403000047
						],
						[
							-82.63344611699995,
							27.742188374000083
						],
						[
							-82.63345885599996,
							27.742178222000064
						],
						[
							-82.63357819799995,
							27.74208274700004
						],
						[
							-82.6336517439999,
							27.742029761000083
						],
						[
							-82.63478752399993,
							27.741295489000038
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Big Bayou",
				"RegionID": "417138"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.66307999999992,
					27.74837000000008,
					-82.65903999999996,
					27.752030000000047
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.65904536999994,
							27.748809820000076
						],
						[
							-82.65904999999992,
							27.74837000000008
						],
						[
							-82.65918999999991,
							27.74837000000008
						],
						[
							-82.65943540299992,
							27.74837000000008
						],
						[
							-82.65962999999994,
							27.74837000000008
						],
						[
							-82.65984576699992,
							27.74837000000008
						],
						[
							-82.66010999999992,
							27.74837000000008
						],
						[
							-82.66027772799993,
							27.74837000000008
						],
						[
							-82.66057998499993,
							27.748374074000083
						],
						[
							-82.66075310999992,
							27.748377280000057
						],
						[
							-82.66089999999991,
							27.748380000000054
						],
						[
							-82.66107999999991,
							27.748380000000054
						],
						[
							-82.66135771099994,
							27.748385143000064
						],
						[
							-82.66161999999991,
							27.748390000000086
						],
						[
							-82.6617678799999,
							27.748385519000067
						],
						[
							-82.66194999999993,
							27.748380000000054
						],
						[
							-82.66213516399995,
							27.748380000000054
						],
						[
							-82.66230999999993,
							27.748380000000054
						],
						[
							-82.66252406199993,
							27.74837689800006
						],
						[
							-82.6627399969999,
							27.74837376800008
						],
						[
							-82.6630002679999,
							27.748371605000045
						],
						[
							-82.66301249299994,
							27.74844495700006
						],
						[
							-82.66301848699993,
							27.748480924000035
						],
						[
							-82.66303197199994,
							27.74864860300005
						],
						[
							-82.66303572399994,
							27.748836203000053
						],
						[
							-82.66303982399995,
							27.749041198000043
						],
						[
							-82.6630418709999,
							27.74914352500008
						],
						[
							-82.66304664599994,
							27.74938228900004
						],
						[
							-82.66304999999994,
							27.749550000000056
						],
						[
							-82.66305244099995,
							27.749774572000035
						],
						[
							-82.66305540799993,
							27.750047521000056
						],
						[
							-82.66305800399994,
							27.750286352000046
						],
						[
							-82.66305999999992,
							27.750470000000064
						],
						[
							-82.66306241799992,
							27.75059333200005
						],
						[
							-82.66306476599993,
							27.75071305000006
						],
						[
							-82.66306810999994,
							27.750883598000087
						],
						[
							-82.66307312599992,
							27.751139420000072
						],
						[
							-82.66307814899994,
							27.75139557600005
						],
						[
							-82.66307999999992,
							27.751490000000047
						],
						[
							-82.66306911099991,
							27.751617041000088
						],
						[
							-82.66305579599992,
							27.751772376000076
						],
						[
							-82.66304003699992,
							27.751924686000052
						],
						[
							-82.66302999999994,
							27.75201000000004
						],
						[
							-82.66256380699991,
							27.75201000000004
						],
						[
							-82.66219999999993,
							27.75201000000004
						],
						[
							-82.6616148889999,
							27.75201000000004
						],
						[
							-82.66128767599992,
							27.75201000000004
						],
						[
							-82.6610599999999,
							27.75201000000004
						],
						[
							-82.66090999999994,
							27.75201000000004
						],
						[
							-82.66060052899991,
							27.75201000000004
						],
						[
							-82.66046964399993,
							27.75201000000004
						],
						[
							-82.66009999999994,
							27.75201000000004
						],
						[
							-82.65997896499994,
							27.752013782000063
						],
						[
							-82.65965999999992,
							27.752020000000076
						],
						[
							-82.65939009499994,
							27.752024498000083
						],
						[
							-82.65925870099994,
							27.752026688000058
						],
						[
							-82.6590599999999,
							27.752030000000047
						],
						[
							-82.65905724599992,
							27.751779396000074
						],
						[
							-82.65905473099991,
							27.751550506000058
						],
						[
							-82.65905247499991,
							27.75134520800009
						],
						[
							-82.65904999999992,
							27.75112000000007
						],
						[
							-82.6590525169999,
							27.75088848000007
						],
						[
							-82.6590542539999,
							27.750728608000088
						],
						[
							-82.6590559949999,
							27.750568487000066
						],
						[
							-82.65905872499991,
							27.750317260000088
						],
						[
							-82.6590599999999,
							27.750200000000063
						],
						[
							-82.65905349299993,
							27.75002107100005
						],
						[
							-82.6590459979999,
							27.74981493900009
						],
						[
							-82.65903999999996,
							27.74965000000009
						],
						[
							-82.65903999999996,
							27.749426568000047
						],
						[
							-82.65904536999994,
							27.748809820000076
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Casler Heights",
				"RegionID": "417145"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.66302999999994,
					27.75201000000004,
					-82.65471092999991,
					27.766257413000062
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.65471092999991,
							27.752227229000088
						],
						[
							-82.65474999999992,
							27.752050000000054
						],
						[
							-82.6549070239999,
							27.752050000000054
						],
						[
							-82.65526695799991,
							27.752050000000054
						],
						[
							-82.65553999999992,
							27.752050000000054
						],
						[
							-82.6557248499999,
							27.752053361000037
						],
						[
							-82.65592170699996,
							27.752056940000045
						],
						[
							-82.65608999999995,
							27.752060000000085
						],
						[
							-82.65624811599992,
							27.75205594600004
						],
						[
							-82.65654325199995,
							27.75204837800004
						],
						[
							-82.65670675099994,
							27.752044186000035
						],
						[
							-82.65686999999991,
							27.75204000000008
						],
						[
							-82.6570338489999,
							27.752037724000047
						],
						[
							-82.65736099899993,
							27.75203318100006
						],
						[
							-82.65758999999991,
							27.752030000000047
						],
						[
							-82.6579099999999,
							27.752030000000047
						],
						[
							-82.65808098899993,
							27.752030000000047
						],
						[
							-82.65831999999995,
							27.752030000000047
						],
						[
							-82.65850636599993,
							27.752030000000047
						],
						[
							-82.65890999999993,
							27.752030000000047
						],
						[
							-82.6590599999999,
							27.752030000000047
						],
						[
							-82.65925870099994,
							27.752026688000058
						],
						[
							-82.65939009499994,
							27.752024498000083
						],
						[
							-82.65965999999992,
							27.752020000000076
						],
						[
							-82.65997896499994,
							27.752013782000063
						],
						[
							-82.66009999999994,
							27.75201000000004
						],
						[
							-82.66046964399993,
							27.75201000000004
						],
						[
							-82.66060052899991,
							27.75201000000004
						],
						[
							-82.66090999999994,
							27.75201000000004
						],
						[
							-82.6610599999999,
							27.75201000000004
						],
						[
							-82.66128767599992,
							27.75201000000004
						],
						[
							-82.6616148889999,
							27.75201000000004
						],
						[
							-82.66219999999993,
							27.75201000000004
						],
						[
							-82.66256380699991,
							27.75201000000004
						],
						[
							-82.66302999999994,
							27.75201000000004
						],
						[
							-82.66301325599994,
							27.752127210000083
						],
						[
							-82.6630028909999,
							27.752199760000057
						],
						[
							-82.66298687299991,
							27.752327526000045
						],
						[
							-82.66297449199993,
							27.752476097000056
						],
						[
							-82.66296442899994,
							27.752624710000077
						],
						[
							-82.66295999999994,
							27.752809424000077
						],
						[
							-82.66295999999994,
							27.75293000000005
						],
						[
							-82.66295999999994,
							27.75321659000008
						],
						[
							-82.66295999999994,
							27.753623755000035
						],
						[
							-82.66295999999994,
							27.753810000000044
						],
						[
							-82.66295999999994,
							27.75395689000004
						],
						[
							-82.66295999999994,
							27.754210000000057
						],
						[
							-82.66295999999994,
							27.754401071000075
						],
						[
							-82.66295999999994,
							27.754540000000077
						],
						[
							-82.66295999999994,
							27.754752714000066
						],
						[
							-82.66295999999994,
							27.75493000000006
						],
						[
							-82.66296240299994,
							27.75501169800009
						],
						[
							-82.6629672979999,
							27.755178122000075
						],
						[
							-82.66296999999992,
							27.755270000000053
						],
						[
							-82.66296999999992,
							27.755437492000055
						],
						[
							-82.66296999999992,
							27.755670000000066
						],
						[
							-82.66297529799994,
							27.755956073000053
						],
						[
							-82.66297999999995,
							27.756210000000067
						],
						[
							-82.66297999999995,
							27.756360000000086
						],
						[
							-82.66298218999992,
							27.75651111800005
						],
						[
							-82.66298540799994,
							27.756733162000046
						],
						[
							-82.66298835799995,
							27.756936702000075
						],
						[
							-82.66298999999992,
							27.75705000000005
						],
						[
							-82.66298999999992,
							27.75719570600006
						],
						[
							-82.66298999999992,
							27.757460000000037
						],
						[
							-82.66298999999992,
							27.757621379000057
						],
						[
							-82.66298999999992,
							27.757940000000076
						],
						[
							-82.66299279499992,
							27.758306177000065
						],
						[
							-82.66299731599992,
							27.758898383000087
						],
						[
							-82.6629999999999,
							27.759250000000065
						],
						[
							-82.66300265899991,
							27.759731196000075
						],
						[
							-82.6630041919999,
							27.760008800000037
						],
						[
							-82.66300582899993,
							27.76030501400004
						],
						[
							-82.6630077719999,
							27.760656646000086
						],
						[
							-82.66300999999993,
							27.761060000000043
						],
						[
							-82.66300999999993,
							27.761285868000073
						],
						[
							-82.66300999999993,
							27.76207000000005
						],
						[
							-82.66300999999993,
							27.762428784000065
						],
						[
							-82.6627638789999,
							27.762580407000087
						],
						[
							-82.66240121699991,
							27.762840020000056
						],
						[
							-82.6619509599999,
							27.763203591000035
						],
						[
							-82.66135354799991,
							27.763667214000066
						],
						[
							-82.6606889169999,
							27.764342528000043
						],
						[
							-82.65998169199992,
							27.765040257000067
						],
						[
							-82.65939907199993,
							27.765496519000067
						],
						[
							-82.6587619519999,
							27.765912032000074
						],
						[
							-82.65837724999994,
							27.766111178000074
						],
						[
							-82.65782697499992,
							27.76624316300007
						],
						[
							-82.6574642789999,
							27.766257413000062
						],
						[
							-82.65701171799992,
							27.766234352000083
						],
						[
							-82.65655142599991,
							27.766166440000063
						],
						[
							-82.65588195899994,
							27.76611009300007
						],
						[
							-82.65474999999992,
							27.76610000000005
						],
						[
							-82.65474546599995,
							27.765320643000052
						],
						[
							-82.65473999999995,
							27.764894120000065
						],
						[
							-82.65473999999995,
							27.764710000000036
						],
						[
							-82.6547379669999,
							27.764346009000068
						],
						[
							-82.65473507399992,
							27.763828283000066
						],
						[
							-82.65473184199993,
							27.763249648000055
						],
						[
							-82.65472999999993,
							27.762920000000065
						],
						[
							-82.6547202189999,
							27.762548326000058
						],
						[
							-82.65472691999992,
							27.76221477100006
						],
						[
							-82.65473795799994,
							27.761695968000083
						],
						[
							-82.65473999999995,
							27.76130037900009
						],
						[
							-82.65473999999995,
							27.760874003000083
						],
						[
							-82.65473999999995,
							27.760203984000043
						],
						[
							-82.65473999999995,
							27.759625330000063
						],
						[
							-82.65473999999995,
							27.759310000000085
						],
						[
							-82.65473999999995,
							27.75906079500004
						],
						[
							-82.65473719999994,
							27.758724017000077
						],
						[
							-82.65473452799995,
							27.758603766000082
						],
						[
							-82.65472999999993,
							27.75826674500007
						],
						[
							-82.65472999999993,
							27.758050186000048
						],
						[
							-82.65472999999993,
							27.757593006000036
						],
						[
							-82.65472999999993,
							27.757280198000046
						],
						[
							-82.65472999999993,
							27.756847080000057
						],
						[
							-82.6547326839999,
							27.75636574300006
						],
						[
							-82.65473638599991,
							27.75602891300008
						],
						[
							-82.65473568599992,
							27.755475647000083
						],
						[
							-82.65472999999993,
							27.754729613000055
						],
						[
							-82.65472999999993,
							27.75422430900005
						],
						[
							-82.65472724999995,
							27.753646970000094
						],
						[
							-82.65472332399992,
							27.753285820000087
						],
						[
							-82.65471730699994,
							27.75275651800007
						],
						[
							-82.65471092999991,
							27.752227229000088
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Melrose Mercy - Pine Acres",
				"RegionID": "417147"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.63202233499993,
					27.768383587000073,
					-82.62642236499994,
					27.77225562400008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.62868285299993,
							27.77225562400008
						],
						[
							-82.62780614199994,
							27.77223424300007
						],
						[
							-82.62700614599993,
							27.77223424300007
						],
						[
							-82.62657371599994,
							27.772147757000084
						],
						[
							-82.62642236499994,
							27.771866677000048
						],
						[
							-82.62645170099995,
							27.77154159400004
						],
						[
							-82.6264810749999,
							27.77147543600006
						],
						[
							-82.62682823999995,
							27.77081924500004
						],
						[
							-82.62713162699993,
							27.770190177000075
						],
						[
							-82.62719546599993,
							27.770053679000057
						],
						[
							-82.6272262139999,
							27.769988893000065
						],
						[
							-82.6275562049999,
							27.76909388900009
						],
						[
							-82.62762116499994,
							27.76895533900006
						],
						[
							-82.62771107999993,
							27.768826927000077
						],
						[
							-82.6278219269999,
							27.768716079000058
						],
						[
							-82.62795033899994,
							27.768626164000068
						],
						[
							-82.6280563489999,
							27.768573926000045
						],
						[
							-82.62829334799994,
							27.768475926000065
						],
						[
							-82.62835774099995,
							27.76845213400009
						],
						[
							-82.6284237619999,
							27.768433324000057
						],
						[
							-82.62849102499992,
							27.768419604000087
						],
						[
							-82.6285591379999,
							27.76841105500006
						],
						[
							-82.62862770599992,
							27.76840772600008
						],
						[
							-82.6308399909999,
							27.768383587000073
						],
						[
							-82.63137368999992,
							27.768493722000073
						],
						[
							-82.63178449899993,
							27.76873155900006
						],
						[
							-82.63197909199994,
							27.769012638000053
						],
						[
							-82.63202233499993,
							27.769488312000078
						],
						[
							-82.6319949469999,
							27.77022951300006
						],
						[
							-82.6319949469999,
							27.77037307200004
						],
						[
							-82.63193584899994,
							27.77082884500004
						],
						[
							-82.63180611999991,
							27.771109925000076
						],
						[
							-82.63148179799992,
							27.771304518000083
						],
						[
							-82.63090922099991,
							27.771756611000058
						],
						[
							-82.6298608809999,
							27.77177028400007
						],
						[
							-82.6296988339999,
							27.77175665900006
						],
						[
							-82.62966148699991,
							27.771749256000078
						],
						[
							-82.6294507529999,
							27.771702823000055
						],
						[
							-82.62927695299993,
							27.77167489100009
						],
						[
							-82.62897471699995,
							27.77168148800007
						],
						[
							-82.62869007599994,
							27.772242761000086
						],
						[
							-82.62868285299993,
							27.77225562400008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Old Bayside and Marina",
				"RegionID": "417152"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.65480999999994,
					27.77195000000006,
					-82.6466699959999,
					27.77750000000009
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.64668999999992,
							27.773900000000083
						],
						[
							-82.64668427599992,
							27.773619544000045
						],
						[
							-82.64667999999995,
							27.77341000000007
						],
						[
							-82.64667999999995,
							27.772943852000083
						],
						[
							-82.64667999999995,
							27.772530921000055
						],
						[
							-82.6466761929999,
							27.77230583300008
						],
						[
							-82.64666999999992,
							27.771990000000073
						],
						[
							-82.6466699959999,
							27.77198982600004
						],
						[
							-82.64692882799994,
							27.77198831900006
						],
						[
							-82.64770078299995,
							27.771983307000085
						],
						[
							-82.64847305299992,
							27.77197829200009
						],
						[
							-82.64948624399995,
							27.771971713000084
						],
						[
							-82.6500651039999,
							27.771970000000067
						],
						[
							-82.6511265879999,
							27.771970000000067
						],
						[
							-82.65204311999992,
							27.771972626000036
						],
						[
							-82.65267030199993,
							27.77197865700009
						],
						[
							-82.65329780499991,
							27.771980000000042
						],
						[
							-82.65378029699991,
							27.771970000000067
						],
						[
							-82.6545522859999,
							27.77195000000006
						],
						[
							-82.65478999999993,
							27.77195000000006
						],
						[
							-82.65478999999993,
							27.772433878000072
						],
						[
							-82.65478999999993,
							27.77306111900009
						],
						[
							-82.65479707299995,
							27.773688280000044
						],
						[
							-82.65479999999991,
							27.774267350000063
						],
						[
							-82.65479248399993,
							27.775328821000073
						],
						[
							-82.6547877189999,
							27.775714757000063
						],
						[
							-82.6547799999999,
							27.77634000000006
						],
						[
							-82.65478570899995,
							27.77672817800004
						],
						[
							-82.65480999999994,
							27.777460000000076
						],
						[
							-82.65421451999993,
							27.777453861000083
						],
						[
							-82.65364999999991,
							27.777460000000076
						],
						[
							-82.65320126999991,
							27.77745532600005
						],
						[
							-82.65268999999995,
							27.777450000000048
						],
						[
							-82.65175398499991,
							27.777461110000047
						],
						[
							-82.65112611099994,
							27.77747166200004
						],
						[
							-82.65035459899991,
							27.777480000000082
						],
						[
							-82.64972999999992,
							27.777480000000082
						],
						[
							-82.64972999999992,
							27.776380000000074
						],
						[
							-82.64973999999995,
							27.77552183100005
						],
						[
							-82.64973999999995,
							27.775130000000047
						],
						[
							-82.64973618999994,
							27.774798583000063
						],
						[
							-82.6497482339999,
							27.774606487000085
						],
						[
							-82.64972735899994,
							27.77386000000007
						],
						[
							-82.64909991299993,
							27.773864338000067
						],
						[
							-82.64818344499992,
							27.773877006000077
						],
						[
							-82.64769999999993,
							27.773870000000045
						],
						[
							-82.64770430199991,
							27.77441207100009
						],
						[
							-82.6477099999999,
							27.775130000000047
						],
						[
							-82.6477057749999,
							27.77566661800006
						],
						[
							-82.64769999999993,
							27.77640000000008
						],
						[
							-82.64769999999993,
							27.777480000000082
						],
						[
							-82.64668999999992,
							27.77750000000009
						],
						[
							-82.64668999999992,
							27.777260853000087
						],
						[
							-82.64669687899993,
							27.776486152000075
						],
						[
							-82.6466999999999,
							27.77613467900005
						],
						[
							-82.6466999999999,
							27.775750000000073
						],
						[
							-82.6466999999999,
							27.775534052000072
						],
						[
							-82.6466999999999,
							27.77526000000006
						],
						[
							-82.64669528699994,
							27.77482064700007
						],
						[
							-82.64668999999992,
							27.774440000000084
						],
						[
							-82.64668999999992,
							27.774107565000065
						],
						[
							-82.64668999999992,
							27.773900000000083
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Methodist Town",
				"RegionID": "417154"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.64670999999993,
					27.783850000000086,
					-82.63850999999995,
					27.79207000000008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.63852999999995,
							27.79207000000008
						],
						[
							-82.63852999999995,
							27.791955142000067
						],
						[
							-82.63852999999995,
							27.791824482000038
						],
						[
							-82.63852999999995,
							27.791630000000055
						],
						[
							-82.63852536199994,
							27.79150476700005
						],
						[
							-82.63851999999991,
							27.791360000000054
						],
						[
							-82.63851999999991,
							27.791240000000073
						],
						[
							-82.63851999999991,
							27.791084079000086
						],
						[
							-82.63851999999991,
							27.79096793700006
						],
						[
							-82.63851999999991,
							27.790640000000053
						],
						[
							-82.63851999999991,
							27.790532405000082
						],
						[
							-82.63851999999991,
							27.790410000000065
						],
						[
							-82.63851999999991,
							27.790285604000076
						],
						[
							-82.63851999999991,
							27.790111392000085
						],
						[
							-82.63851999999991,
							27.789864591000086
						],
						[
							-82.63851999999991,
							27.789733931000058
						],
						[
							-82.63851999999991,
							27.789580000000058
						],
						[
							-82.63851999999991,
							27.78950164800006
						],
						[
							-82.63851999999991,
							27.789370000000076
						],
						[
							-82.63851999999991,
							27.789153223000085
						],
						[
							-82.63851999999991,
							27.788935457000036
						],
						[
							-82.63851999999991,
							27.78876000000008
						],
						[
							-82.63851999999991,
							27.788630585000078
						],
						[
							-82.63851999999991,
							27.788470000000075
						],
						[
							-82.63851999999991,
							27.788290000000075
						],
						[
							-82.63851999999991,
							27.78822408900004
						],
						[
							-82.63851999999991,
							27.78812000000005
						],
						[
							-82.63852230299995,
							27.788020974000062
						],
						[
							-82.63852601499991,
							27.787861365000083
						],
						[
							-82.63852770999996,
							27.78778847800004
						],
						[
							-82.63852999999995,
							27.787690000000058
						],
						[
							-82.63852999999995,
							27.78753000000006
						],
						[
							-82.6385286389999,
							27.78744017000008
						],
						[
							-82.63852665999991,
							27.78730954000008
						],
						[
							-82.63852467999993,
							27.78717891100007
						],
						[
							-82.63852269799992,
							27.787048061000064
						],
						[
							-82.63851999999991,
							27.78687000000008
						],
						[
							-82.63851999999991,
							27.786772317000043
						],
						[
							-82.63851999999991,
							27.78664000000009
						],
						[
							-82.63852226099993,
							27.786511098000062
						],
						[
							-82.6385253169999,
							27.78633693900008
						],
						[
							-82.63852999999995,
							27.786070000000052
						],
						[
							-82.63852629699994,
							27.785944095000048
						],
						[
							-82.6385237369999,
							27.785857064000083
						],
						[
							-82.63851999999991,
							27.785730000000058
						],
						[
							-82.63851999999991,
							27.785538312000085
						],
						[
							-82.63851999999991,
							27.78540765200006
						],
						[
							-82.63851999999991,
							27.78526000000005
						],
						[
							-82.63851999999991,
							27.785102780000045
						],
						[
							-82.63851999999991,
							27.784972121000067
						],
						[
							-82.63851999999991,
							27.78481000000005
						],
						[
							-82.63851489299992,
							27.784580180000038
						],
						[
							-82.63850999999995,
							27.78436000000005
						],
						[
							-82.6390290619999,
							27.78436000000005
						],
						[
							-82.63950242899995,
							27.78436000000005
						],
						[
							-82.64028454999993,
							27.78435817500008
						],
						[
							-82.64114890699994,
							27.784351448000052
						],
						[
							-82.64156082599993,
							27.784348243000068
						],
						[
							-82.64211632399991,
							27.784343920000083
						],
						[
							-82.64246484199992,
							27.78434120700007
						],
						[
							-82.64268479599991,
							27.784340000000046
						],
						[
							-82.6431826029999,
							27.784340000000046
						],
						[
							-82.64347201499993,
							27.78433882600007
						],
						[
							-82.6436688089999,
							27.78433720000004
						],
						[
							-82.64395830799992,
							27.78433480700005
						],
						[
							-82.64438662499992,
							27.784331268000074
						],
						[
							-82.64453999999995,
							27.784330000000068
						],
						[
							-82.64475698299992,
							27.784333557000082
						],
						[
							-82.6448727209999,
							27.784335454000086
						],
						[
							-82.64498864899993,
							27.784337355000048
						],
						[
							-82.64514999999994,
							27.784340000000046
						],
						[
							-82.64515254699995,
							27.784467342000088
						],
						[
							-82.6456300609999,
							27.784462387000076
						],
						[
							-82.6456318139999,
							27.78435477000005
						],
						[
							-82.64563476099994,
							27.784183881000047
						],
						[
							-82.64563703099992,
							27.784052220000035
						],
						[
							-82.64563854699993,
							27.783964250000054
						],
						[
							-82.6456399999999,
							27.783880000000067
						],
						[
							-82.6459804019999,
							27.783873192000044
						],
						[
							-82.64630570399993,
							27.783866686000067
						],
						[
							-82.6466999999999,
							27.783850000000086
						],
						[
							-82.6466999999999,
							27.784479581000085
						],
						[
							-82.6466999999999,
							27.785083305000057
						],
						[
							-82.6466999999999,
							27.785522377000063
						],
						[
							-82.6466999999999,
							27.786071218000075
						],
						[
							-82.6466999999999,
							27.78656517400009
						],
						[
							-82.64670670099991,
							27.787663079000083
						],
						[
							-82.64670999999993,
							27.788541000000066
						],
						[
							-82.64670461399993,
							27.789199315000076
						],
						[
							-82.6466999999999,
							27.79007775300005
						],
						[
							-82.64670580599994,
							27.79090129100007
						],
						[
							-82.64670999999993,
							27.79155962200008
						],
						[
							-82.64670999999993,
							27.792040000000043
						],
						[
							-82.64651593399994,
							27.792037427000082
						],
						[
							-82.64615284699994,
							27.79203094400009
						],
						[
							-82.64587714299995,
							27.79203309500008
						],
						[
							-82.64565921699995,
							27.79203612200007
						],
						[
							-82.64520925499994,
							27.792042371000036
						],
						[
							-82.64499132999993,
							27.792045398000084
						],
						[
							-82.64481715099993,
							27.792047817000082
						],
						[
							-82.64446882099992,
							27.792050937000056
						],
						[
							-82.6439752309999,
							27.792053357000043
						],
						[
							-82.64342357099991,
							27.79205606100004
						],
						[
							-82.64298804999993,
							27.792058196000085
						],
						[
							-82.64278480699994,
							27.792059192000067
						],
						[
							-82.64239281699992,
							27.79206000000005
						],
						[
							-82.64171048399993,
							27.79206000000005
						],
						[
							-82.64101372099992,
							27.792065650000044
						],
						[
							-82.6407233939999,
							27.79206849600007
						],
						[
							-82.64056999999991,
							27.79207000000008
						],
						[
							-82.64028774799993,
							27.79207000000008
						],
						[
							-82.6400799999999,
							27.79207000000008
						],
						[
							-82.63980866299995,
							27.79207000000008
						],
						[
							-82.63943120299992,
							27.79207000000008
						],
						[
							-82.63889404699995,
							27.79207000000008
						],
						[
							-82.63858999999991,
							27.79207000000008
						],
						[
							-82.63852999999995,
							27.79207000000008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Crescent Lake",
				"RegionID": "417161"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.64672999999993,
					27.79203094400009,
					-82.6384799999999,
					27.799370000000067
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.64587714299995,
							27.79203309500008
						],
						[
							-82.64615284699994,
							27.79203094400009
						],
						[
							-82.64651593399994,
							27.792037427000082
						],
						[
							-82.64670999999993,
							27.792040000000043
						],
						[
							-82.64670999999993,
							27.792515216000083
						],
						[
							-82.64670999999993,
							27.79296000000005
						],
						[
							-82.64671205299993,
							27.793146856000078
						],
						[
							-82.64671597599994,
							27.79350377700007
						],
						[
							-82.6467199999999,
							27.793870000000084
						],
						[
							-82.6467199999999,
							27.794107824000037
						],
						[
							-82.6467199999999,
							27.794327494000072
						],
						[
							-82.6467199999999,
							27.794770000000085
						],
						[
							-82.6467199999999,
							27.794959046000088
						],
						[
							-82.6467199999999,
							27.795233633000066
						],
						[
							-82.6467199999999,
							27.795690000000036
						],
						[
							-82.6467199999999,
							27.79619469000005
						],
						[
							-82.6467199999999,
							27.796610000000044
						],
						[
							-82.6467199999999,
							27.79693607600007
						],
						[
							-82.6467199999999,
							27.797238122000067
						],
						[
							-82.6467199999999,
							27.79751000000005
						],
						[
							-82.64672634599992,
							27.798062129000073
						],
						[
							-82.64672999999993,
							27.798380000000066
						],
						[
							-82.64672999999993,
							27.798830730000077
						],
						[
							-82.64672999999993,
							27.79932000000008
						],
						[
							-82.64672886699992,
							27.79932002700008
						],
						[
							-82.64630820899993,
							27.799330000000054
						],
						[
							-82.64585999999991,
							27.799330000000054
						],
						[
							-82.6455943819999,
							27.799333239000077
						],
						[
							-82.6452920449999,
							27.79933692600008
						],
						[
							-82.64503999999994,
							27.799340000000086
						],
						[
							-82.64490781199994,
							27.799340000000086
						],
						[
							-82.64465999999993,
							27.799340000000086
						],
						[
							-82.64441355399993,
							27.799340000000086
						],
						[
							-82.64414999999991,
							27.799340000000086
						],
						[
							-82.64383681699991,
							27.799343685000053
						],
						[
							-82.6432999999999,
							27.79935000000006
						],
						[
							-82.64293078199995,
							27.79935000000006
						],
						[
							-82.64258999999993,
							27.79935000000006
						],
						[
							-82.64213461499992,
							27.79935228800008
						],
						[
							-82.64139310899992,
							27.799356015000058
						],
						[
							-82.64059999999995,
							27.799360000000036
						],
						[
							-82.64004766399995,
							27.799362776000066
						],
						[
							-82.63958073899994,
							27.79936512200004
						],
						[
							-82.63894920299992,
							27.799368295000082
						],
						[
							-82.63860999999991,
							27.799370000000067
						],
						[
							-82.63860999999991,
							27.799162183000078
						],
						[
							-82.63860999999991,
							27.798850817000073
						],
						[
							-82.63860999999991,
							27.79856539800005
						],
						[
							-82.63855999999993,
							27.79847000000007
						],
						[
							-82.63855474399992,
							27.798228238000036
						],
						[
							-82.6385462749999,
							27.797838651000063
						],
						[
							-82.63853999999992,
							27.797550000000058
						],
						[
							-82.6385425549999,
							27.797320007000053
						],
						[
							-82.63854486499991,
							27.79711216700008
						],
						[
							-82.63854803599992,
							27.796826783000085
						],
						[
							-82.63854999999995,
							27.796650000000056
						],
						[
							-82.63854624399994,
							27.79630816400004
						],
						[
							-82.6385425339999,
							27.795970606000083
						],
						[
							-82.63853999999992,
							27.79574000000008
						],
						[
							-82.63853683199994,
							27.795451725000078
						],
						[
							-82.6385345509999,
							27.795244172000082
						],
						[
							-82.63852999999995,
							27.794830000000047
						],
						[
							-82.63852999999995,
							27.794595478000076
						],
						[
							-82.63852999999995,
							27.794310059000054
						],
						[
							-82.63852999999995,
							27.793900000000068
						],
						[
							-82.63853347799994,
							27.793583511000065
						],
						[
							-82.63853632899992,
							27.79332407100009
						],
						[
							-82.6384799999999,
							27.79299000000009
						],
						[
							-82.63853714099992,
							27.79272698500006
						],
						[
							-82.63853432399992,
							27.792467826000063
						],
						[
							-82.63858999999991,
							27.79207000000008
						],
						[
							-82.63889404699995,
							27.79207000000008
						],
						[
							-82.63943120299992,
							27.79207000000008
						],
						[
							-82.63980866299995,
							27.79207000000008
						],
						[
							-82.6400799999999,
							27.79207000000008
						],
						[
							-82.64028774799993,
							27.79207000000008
						],
						[
							-82.64056999999991,
							27.79207000000008
						],
						[
							-82.6407233939999,
							27.79206849600007
						],
						[
							-82.64101372099992,
							27.792065650000044
						],
						[
							-82.64171048399993,
							27.79206000000005
						],
						[
							-82.64239281699992,
							27.79206000000005
						],
						[
							-82.64278480699994,
							27.792059192000067
						],
						[
							-82.64298804999993,
							27.792058196000085
						],
						[
							-82.64342357099991,
							27.79205606100004
						],
						[
							-82.6439752309999,
							27.792053357000043
						],
						[
							-82.64446882099992,
							27.792050937000056
						],
						[
							-82.64481715099993,
							27.792047817000082
						],
						[
							-82.64499132999993,
							27.792045398000084
						],
						[
							-82.64520925499994,
							27.792042371000036
						],
						[
							-82.64565921699995,
							27.79203612200007
						],
						[
							-82.64587714299995,
							27.79203309500008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Crescent Heights",
				"RegionID": "417163"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.448223,
					27.08764240900007,
					-82.43096643499996,
					27.114600058000065
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.44336777799998,
							27.11379507500004
						],
						[
							-82.44318542299999,
							27.113029977000053
						],
						[
							-82.44307294299995,
							27.112558051000065
						],
						[
							-82.44306536999996,
							27.11252620600004
						],
						[
							-82.44307294299995,
							27.112520914000072
						],
						[
							-82.44302076299994,
							27.11230149100004
						],
						[
							-82.44214920099995,
							27.108636457000046
						],
						[
							-82.44111080899997,
							27.108208171000058
						],
						[
							-82.44012012499996,
							27.107799562000025
						],
						[
							-82.43996634799998,
							27.108060693000027
						],
						[
							-82.43970167699996,
							27.10851013300004
						],
						[
							-82.43363646899996,
							27.10835748900007
						],
						[
							-82.43363469099995,
							27.10793389500003
						],
						[
							-82.433628437,
							27.10646293600007
						],
						[
							-82.43361692599996,
							27.103739923000035
						],
						[
							-82.43361348599996,
							27.102902105000055
						],
						[
							-82.43372251399997,
							27.10224793900005
						],
						[
							-82.43372146799999,
							27.10221707900007
						],
						[
							-82.43370018099995,
							27.10158913600003
						],
						[
							-82.43369941999998,
							27.10155183200004
						],
						[
							-82.43357707299998,
							27.097920298000076
						],
						[
							-82.43357989299994,
							27.095723003000046
						],
						[
							-82.43357635599995,
							27.09561452400004
						],
						[
							-82.43355976899994,
							27.09510586500005
						],
						[
							-82.43355261299996,
							27.094886428000052
						],
						[
							-82.43354901699996,
							27.094848971000033
						],
						[
							-82.43357811399994,
							27.093216891000054
						],
						[
							-82.43329027099998,
							27.092153976000077
						],
						[
							-82.43230681999995,
							27.090577576000044
						],
						[
							-82.43096643499996,
							27.088781183000037
						],
						[
							-82.43287979799999,
							27.08764240900007
						],
						[
							-82.43649761699999,
							27.092581108000047
						],
						[
							-82.43951122999994,
							27.097182859000043
						],
						[
							-82.44201847599999,
							27.101011394000068
						],
						[
							-82.44247773999996,
							27.101712685000052
						],
						[
							-82.44307297899996,
							27.102215564000062
						],
						[
							-82.44395311799997,
							27.102959137000028
						],
						[
							-82.44411600599994,
							27.103053171000056
						],
						[
							-82.44402693,
							27.103486015000044
						],
						[
							-82.44403361999997,
							27.103490644000033
						],
						[
							-82.44434783199995,
							27.103708074000053
						],
						[
							-82.444588,
							27.1038
						],
						[
							-82.44507864999997,
							27.104213788000038
						],
						[
							-82.445407,
							27.104441
						],
						[
							-82.4453888099999,
							27.104465550000043
						],
						[
							-82.44538433699995,
							27.104471587000035
						],
						[
							-82.44540127099998,
							27.10448586900003
						],
						[
							-82.445437,
							27.104516
						],
						[
							-82.44542222199993,
							27.104540674000077
						],
						[
							-82.44521,
							27.104895
						],
						[
							-82.44503559799995,
							27.104772680000053
						],
						[
							-82.44483891699997,
							27.104647580000062
						],
						[
							-82.44476131999994,
							27.10475703900005
						],
						[
							-82.44470421499994,
							27.104858799000056
						],
						[
							-82.44471938799995,
							27.104868898000063
						],
						[
							-82.44485753399994,
							27.104960844000065
						],
						[
							-82.444999,
							27.105055
						],
						[
							-82.44496578099995,
							27.105070027000068
						],
						[
							-82.44495421599999,
							27.105075259000046
						],
						[
							-82.44498479899994,
							27.105098561000034
						],
						[
							-82.44498800000001,
							27.105101
						],
						[
							-82.444995,
							27.105138
						],
						[
							-82.44499315899998,
							27.105165404000047
						],
						[
							-82.44497800000002,
							27.105391
						],
						[
							-82.444946,
							27.105449
						],
						[
							-82.44486,
							27.105427
						],
						[
							-82.444631,
							27.105238
						],
						[
							-82.44447,
							27.105232
						],
						[
							-82.444302,
							27.105256
						],
						[
							-82.44428800000001,
							27.105256
						],
						[
							-82.44429278499996,
							27.105293137000046
						],
						[
							-82.44430649799995,
							27.105399577000075
						],
						[
							-82.444392,
							27.105359
						],
						[
							-82.445018,
							27.105645
						],
						[
							-82.44541013699995,
							27.105349207000074
						],
						[
							-82.445482,
							27.105295
						],
						[
							-82.4456,
							27.105287
						],
						[
							-82.44562023399999,
							27.105300666000062
						],
						[
							-82.445639,
							27.1053
						],
						[
							-82.446045,
							27.10558
						],
						[
							-82.44622723999998,
							27.105710642000076
						],
						[
							-82.447507,
							27.106575
						],
						[
							-82.44783,
							27.106854
						],
						[
							-82.44813826199999,
							27.10732286900003
						],
						[
							-82.448223,
							27.107431000000002
						],
						[
							-82.44820778199994,
							27.107448718000057
						],
						[
							-82.44780300000001,
							27.10792
						],
						[
							-82.44769992499994,
							27.107894685000076
						],
						[
							-82.447682,
							27.107913
						],
						[
							-82.44434576699996,
							27.10711374500005
						],
						[
							-82.44432,
							27.107126000000004
						],
						[
							-82.44433325999995,
							27.107156830000065
						],
						[
							-82.44436,
							27.107219
						],
						[
							-82.444484,
							27.107261
						],
						[
							-82.44618035199994,
							27.107742207000058
						],
						[
							-82.446215,
							27.107707
						],
						[
							-82.44630068299995,
							27.107776341000033
						],
						[
							-82.44655428999994,
							27.107848283000067
						],
						[
							-82.446788,
							27.107823
						],
						[
							-82.44694771899998,
							27.107921609000073
						],
						[
							-82.447281,
							27.107938
						],
						[
							-82.44746,
							27.107994
						],
						[
							-82.447576,
							27.108014000000004
						],
						[
							-82.44767792,
							27.108043177000074
						],
						[
							-82.44770511099995,
							27.108049980000033
						],
						[
							-82.44769541899996,
							27.108065536000026
						],
						[
							-82.44770551699997,
							27.108078439000053
						],
						[
							-82.447731,
							27.108111
						],
						[
							-82.44772010399998,
							27.108134214000074
						],
						[
							-82.447708,
							27.10816
						],
						[
							-82.44764972399997,
							27.108468298000048
						],
						[
							-82.44757180899995,
							27.108830841000042
						],
						[
							-82.447561,
							27.108844
						],
						[
							-82.44755082499995,
							27.108843167000032
						],
						[
							-82.447542,
							27.108902000000004
						],
						[
							-82.44754604699995,
							27.10891215600003
						],
						[
							-82.44760364899999,
							27.109056700000053
						],
						[
							-82.447862,
							27.109705
						],
						[
							-82.44790578699997,
							27.10997402600003
						],
						[
							-82.448034,
							27.110324
						],
						[
							-82.44802762699999,
							27.110343742000055
						],
						[
							-82.44788496899997,
							27.110785688000078
						],
						[
							-82.44766780599997,
							27.11145844400005
						],
						[
							-82.447641,
							27.111788
						],
						[
							-82.44753671099994,
							27.111864567000058
						],
						[
							-82.447309,
							27.11257
						],
						[
							-82.447203,
							27.112704
						],
						[
							-82.44714791999996,
							27.11272009100003
						],
						[
							-82.44717011399996,
							27.11275074400004
						],
						[
							-82.447318,
							27.112955000000003
						],
						[
							-82.44730068899997,
							27.11296822800006
						],
						[
							-82.44701700000002,
							27.113185
						],
						[
							-82.446602,
							27.113217
						],
						[
							-82.446469473,
							27.113271551000025
						],
						[
							-82.446189,
							27.113387000000003
						],
						[
							-82.446075,
							27.113225
						],
						[
							-82.44531278799997,
							27.113642438000056
						],
						[
							-82.443568,
							27.114598
						],
						[
							-82.44355963899994,
							27.114600058000065
						],
						[
							-82.44336777799998,
							27.11379507500004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Venice",
				"Name": "Gateway/ Waterway",
				"RegionID": "762155"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.09509654699997,
					26.896568,
					-80.07528045299995,
					26.915934409000045
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.076524,
							26.896568
						],
						[
							-80.07662,
							26.896842
						],
						[
							-80.07688200000001,
							26.897281
						],
						[
							-80.077061,
							26.897291
						],
						[
							-80.077124,
							26.897291
						],
						[
							-80.07712618299996,
							26.897259894000058
						],
						[
							-80.07715102899994,
							26.897259207000047
						],
						[
							-80.07715648099997,
							26.897258519000047
						],
						[
							-80.07716448099995,
							26.89714451900005
						],
						[
							-80.07717624199995,
							26.89696978600006
						],
						[
							-80.07927443599993,
							26.897024301000048
						],
						[
							-80.07967789099996,
							26.897034784000027
						],
						[
							-80.08659023699994,
							26.897214383000062
						],
						[
							-80.08700902599998,
							26.897225264000042
						],
						[
							-80.09509654699997,
							26.89743539600005
						],
						[
							-80.09460619999999,
							26.907826081000053
						],
						[
							-80.09446793999996,
							26.910755882000046
						],
						[
							-80.09386926699995,
							26.915934409000045
						],
						[
							-80.08156652499999,
							26.915694939000048
						],
						[
							-80.08123725499996,
							26.912731505000068
						],
						[
							-80.08090798399996,
							26.91219269900006
						],
						[
							-80.08069844899995,
							26.911504224000055
						],
						[
							-80.08096785199997,
							26.909289132000026
						],
						[
							-80.08012970899995,
							26.90764278000006
						],
						[
							-80.07986030599994,
							26.90743324400006
						],
						[
							-80.07920176499994,
							26.905816826000034
						],
						[
							-80.07746561199997,
							26.90387113700007
						],
						[
							-80.07680707099996,
							26.903062927000065
						],
						[
							-80.07578932599995,
							26.900428764000026
						],
						[
							-80.07569952499995,
							26.90027909500003
						],
						[
							-80.07537204699997,
							26.897518926000032
						],
						[
							-80.07528045299995,
							26.896746922000034
						],
						[
							-80.076524,
							26.896568
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Jupiter",
				"Name": "Admirals Cove",
				"RegionID": "762222"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.188481,
					25.92539248500003,
					-80.17020600000001,
					25.943633031000047
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-80.182219,
								25.941776
							],
							[
								-80.18209857399995,
								25.942060609000066
							],
							[
								-80.18168216799995,
								25.942572193000046
							],
							[
								-80.180906,
								25.943494
							],
							[
								-80.180452,
								25.943607
							],
							[
								-80.180184,
								25.943618
							],
							[
								-80.179896,
								25.943629
							],
							[
								-80.17977949099998,
								25.943633031000047
							],
							[
								-80.17536469899994,
								25.938479521000033
							],
							[
								-80.17203345399997,
								25.934684280000056
							],
							[
								-80.17030834399998,
								25.93264984100006
							],
							[
								-80.17020600000001,
								25.931215
							],
							[
								-80.171216,
								25.931177000000005
							],
							[
								-80.17225,
								25.931124
							],
							[
								-80.172268,
								25.932078
							],
							[
								-80.172322,
								25.932922
							],
							[
								-80.172345,
								25.933867
							],
							[
								-80.172371,
								25.934435
							],
							[
								-80.172636,
								25.934783
							],
							[
								-80.17419000000001,
								25.93473
							],
							[
								-80.174369,
								25.934718
							],
							[
								-80.174398,
								25.935599
							],
							[
								-80.174407,
								25.935751
							],
							[
								-80.174438,
								25.936541
							],
							[
								-80.17569,
								25.936495
							],
							[
								-80.176465,
								25.936477
							],
							[
								-80.177206,
								25.936437
							],
							[
								-80.178476,
								25.936388
							],
							[
								-80.180529,
								25.936309
							],
							[
								-80.180561,
								25.937152
							],
							[
								-80.180578,
								25.937694
							],
							[
								-80.18256,
								25.937609
							],
							[
								-80.18257,
								25.93805
							],
							[
								-80.182337,
								25.938063
							],
							[
								-80.182131,
								25.938074
							],
							[
								-80.182026,
								25.938344
							],
							[
								-80.18203,
								25.938748
							],
							[
								-80.182049,
								25.939444
							],
							[
								-80.18207600000001,
								25.940116
							],
							[
								-80.182112,
								25.940824
							],
							[
								-80.182138,
								25.941505
							],
							[
								-80.182219,
								25.941776
							]
						]
					],
					[
						[
							[
								-80.188481,
								25.933178
							],
							[
								-80.187594,
								25.933201
							],
							[
								-80.186434,
								25.933233
							],
							[
								-80.18640200000002,
								25.932348
							],
							[
								-80.184696,
								25.932424
							],
							[
								-80.184438,
								25.932443
							],
							[
								-80.18321,
								25.932503
							],
							[
								-80.182363,
								25.932537
							],
							[
								-80.182339,
								25.931616
							],
							[
								-80.181176,
								25.931648
							],
							[
								-80.180338,
								25.931677
							],
							[
								-80.180333,
								25.931492
							],
							[
								-80.180319,
								25.930898
							],
							[
								-80.180231,
								25.928929
							],
							[
								-80.178269,
								25.92902
							],
							[
								-80.1762,
								25.929094
							],
							[
								-80.176184,
								25.928377
							],
							[
								-80.176166,
								25.927702
							],
							[
								-80.176154,
								25.927251
							],
							[
								-80.176149,
								25.926993
							],
							[
								-80.176093,
								25.92631
							],
							[
								-80.176095,
								25.926142
							],
							[
								-80.176038,
								25.925418
							],
							[
								-80.17635217499998,
								25.92539248500003
							],
							[
								-80.17735154899998,
								25.925511458000074
							],
							[
								-80.17851748499999,
								25.925963556000056
							],
							[
								-80.17914804199995,
								25.926308577000043
							],
							[
								-80.18044484799998,
								25.92728415600004
							],
							[
								-80.18145611899996,
								25.92803368700004
							],
							[
								-80.18246738999994,
								25.92852147600007
							],
							[
								-80.183669018,
								25.92875942200004
							],
							[
								-80.184244,
								25.928755
							],
							[
								-80.186249,
								25.92867
							],
							[
								-80.186485,
								25.92866
							],
							[
								-80.188268,
								25.928587
							],
							[
								-80.188481,
								25.933178
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "North Miami Beach",
				"Name": "Winward",
				"RegionID": "762322"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.26087113499995,
					27.181194222000045,
					-80.25298586199995,
					27.189461659000074
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.25298586199995,
							27.188095691000058
						],
						[
							-80.253043,
							27.184724580000083
						],
						[
							-80.25423362799995,
							27.184684891000074
						],
						[
							-80.25420507499996,
							27.183282199000075
						],
						[
							-80.25487965199994,
							27.183300045000067
						],
						[
							-80.25489035999993,
							27.183032355000023
						],
						[
							-80.25688553799995,
							27.18304306300007
						],
						[
							-80.25707113599998,
							27.18304306300007
						],
						[
							-80.25707470499998,
							27.181194222000045
						],
						[
							-80.26007996399994,
							27.181208498000046
						],
						[
							-80.26012636399997,
							27.181219206000037
						],
						[
							-80.26014777899996,
							27.181251329000077
						],
						[
							-80.26013350199997,
							27.18129059000006
						],
						[
							-80.26024771599998,
							27.18169033900006
						],
						[
							-80.26039405299997,
							27.182122211000035
						],
						[
							-80.26034765399999,
							27.18220787200005
						],
						[
							-80.26024057799998,
							27.182300671000064
						],
						[
							-80.25986581299998,
							27.182297102000064
						],
						[
							-80.25973018299999,
							27.182261410000024
						],
						[
							-80.25968378399995,
							27.182161473000065
						],
						[
							-80.2596124,
							27.182161473000065
						],
						[
							-80.25961596899998,
							27.18222214900004
						],
						[
							-80.25962310799997,
							27.182279256000072
						],
						[
							-80.25834176799998,
							27.182257841000023
						],
						[
							-80.25729956399994,
							27.182261410000024
						],
						[
							-80.25730670199994,
							27.182436300000063
						],
						[
							-80.25736380899997,
							27.182447008000054
						],
						[
							-80.25781590699995,
							27.182427972000028
						],
						[
							-80.25791108499999,
							27.182370865000053
						],
						[
							-80.25808240699996,
							27.182437490000044
						],
						[
							-80.25982893099996,
							27.182461285000045
						],
						[
							-80.25986700199996,
							27.182594534000035
						],
						[
							-80.25997169899995,
							27.182594534000035
						],
						[
							-80.25996218099993,
							27.182480320000025
						],
						[
							-80.26000025199994,
							27.182437490000044
						],
						[
							-80.26033813599997,
							27.182437490000044
						],
						[
							-80.26051421599999,
							27.182480320000025
						],
						[
							-80.26057608199994,
							27.18256122200006
						],
						[
							-80.26069029599995,
							27.182742061000056
						],
						[
							-80.26078547399999,
							27.182761097000025
						],
						[
							-80.26080450999997,
							27.182837239000037
						],
						[
							-80.26087113499995,
							27.182894347000058
						],
						[
							-80.26087113499995,
							27.182970489000073
						],
						[
							-80.26062367099996,
							27.18325126600007
						],
						[
							-80.26037620699998,
							27.183655774000048
						],
						[
							-80.26025247499996,
							27.183969863000073
						],
						[
							-80.25995742199996,
							27.184555210000042
						],
						[
							-80.25982417199998,
							27.184859781000057
						],
						[
							-80.25975278799996,
							27.185269049000055
						],
						[
							-80.25971471699995,
							27.185487959000056
						],
						[
							-80.25972899399994,
							27.185611691000076
						],
						[
							-80.25971947599999,
							27.185778253000024
						],
						[
							-80.25967664599995,
							27.185992405000036
						],
						[
							-80.25963857399995,
							27.186201797000024
						],
						[
							-80.25966236899995,
							27.186254146000067
						],
						[
							-80.25961002099996,
							27.186539681000056
						],
						[
							-80.25950532399997,
							27.186810939000054
						],
						[
							-80.25939586899995,
							27.18697274300007
						],
						[
							-80.25925785999993,
							27.18707268000003
						],
						[
							-80.25901991399996,
							27.18721068900004
						],
						[
							-80.25863444199996,
							27.187339180000038
						],
						[
							-80.25853926299999,
							27.18744387600003
						],
						[
							-80.25827276399997,
							27.187867420000032
						],
						[
							-80.25804433499997,
							27.188110125000037
						],
						[
							-80.25769217499999,
							27.18831
						],
						[
							-80.25753513099994,
							27.18831
						],
						[
							-80.25744471099995,
							27.188443250000034
						],
						[
							-80.25722104199997,
							27.188595535000047
						],
						[
							-80.25704496199995,
							27.188724026000045
						],
						[
							-80.25703544399994,
							27.189414070000055
						],
						[
							-80.25672611399995,
							27.189399793000067
						],
						[
							-80.25665948899996,
							27.189304615000026
						],
						[
							-80.25656906899997,
							27.18943786400007
						],
						[
							-80.25631208799996,
							27.189461659000074
						],
						[
							-80.25563632099994,
							27.18916660600007
						],
						[
							-80.25548879399997,
							27.18923323100006
						],
						[
							-80.25536982099999,
							27.18925226600004
						],
						[
							-80.25525084799995,
							27.189152329000024
						],
						[
							-80.25513187499996,
							27.188985767000077
						],
						[
							-80.255098563,
							27.18874306200007
						],
						[
							-80.25514615199995,
							27.18865264200008
						],
						[
							-80.25510807999996,
							27.18845752600004
						],
						[
							-80.25502241999999,
							27.188362348000055
						],
						[
							-80.25489868799997,
							27.18831951800007
						],
						[
							-80.25480826799998,
							27.188338553000055
						],
						[
							-80.25461791099997,
							27.188505116000044
						],
						[
							-80.25444658999999,
							27.188566982000054
						],
						[
							-80.25436568899994,
							27.188519392000046
						],
						[
							-80.25420388499998,
							27.188381384000024
						],
						[
							-80.25413250099996,
							27.18822909800008
						],
						[
							-80.25389455499999,
							27.18810536600006
						],
						[
							-80.25298586199995,
							27.188095691000058
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Martin",
				"City": "Stuart",
				"Name": "Indian Groves/Poppleton South",
				"RegionID": "762335"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.16820612599992,
					25.77906063300009,
					-80.15410832399994,
					25.788144636000084
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.16142409699995,
							25.78573716300008
						],
						[
							-80.15410832399994,
							25.78254095200009
						],
						[
							-80.15574194299995,
							25.77906063300009
						],
						[
							-80.16820612599992,
							25.784496982000064
						],
						[
							-80.16667576799995,
							25.788144636000084
						],
						[
							-80.16142409699995,
							25.78573716300008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Beach",
				"Name": "Hibiscus Island",
				"RegionID": "623415"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.14629536199993,
					25.774053235000057,
					-80.12534241999992,
					25.79085110200009
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.14537201199994,
							25.790211860000056
						],
						[
							-80.12534241999992,
							25.79085110200009
						],
						[
							-80.12871619899994,
							25.774763504000077
						],
						[
							-80.13301332799995,
							25.77462145000004
						],
						[
							-80.1347534869999,
							25.77455042300005
						],
						[
							-80.13830483399994,
							25.774408369000074
						],
						[
							-80.1407907759999,
							25.77447939600006
						],
						[
							-80.14203374699991,
							25.77444388300006
						],
						[
							-80.14317017799993,
							25.774053235000057
						],
						[
							-80.14629536199993,
							25.781972737000046
						],
						[
							-80.14625984899993,
							25.788045538000066
						],
						[
							-80.14537201199994,
							25.790211860000056
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Beach",
				"Name": "Flamingo Lummus",
				"RegionID": "623416"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.13658269899992,
					26.231579749000048,
					-80.12196863299994,
					26.246128104000036
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.1244166749999,
							26.23692940300009
						],
						[
							-80.12630910999991,
							26.231579749000048
						],
						[
							-80.13646532799993,
							26.231579749000048
						],
						[
							-80.13653324299992,
							26.234159901000055
						],
						[
							-80.13658269899992,
							26.245757188000084
						],
						[
							-80.13418534199991,
							26.245804279000083
						],
						[
							-80.13076907699991,
							26.245871384000054
						],
						[
							-80.13074581599994,
							26.245871841000053
						],
						[
							-80.12706378199995,
							26.24594416700006
						],
						[
							-80.12273519199994,
							26.246029193000084
						],
						[
							-80.12196863299994,
							26.246128104000036
						],
						[
							-80.1244166749999,
							26.23692940300009
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Pompano Beach",
				"Name": "Blanche Ely",
				"RegionID": "738044"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.12196863299994,
					26.24066328400005,
					-80.09976316699994,
					26.260494892000054
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.09976316699994,
							26.258887592000065
						],
						[
							-80.10196393099994,
							26.243185509000057
						],
						[
							-80.1033239539999,
							26.243160781000086
						],
						[
							-80.1038679639999,
							26.242938232000085
						],
						[
							-80.10448615599995,
							26.242122218000077
						],
						[
							-80.10493125399995,
							26.241751303000058
						],
						[
							-80.1055247189999,
							26.24152875300007
						],
						[
							-80.11514379099992,
							26.24133093200004
						],
						[
							-80.11591034899993,
							26.24115783800005
						],
						[
							-80.1171467339999,
							26.24083637800004
						],
						[
							-80.1180863859999,
							26.240737467000088
						],
						[
							-80.12090534299996,
							26.24066328400005
						],
						[
							-80.12088061499992,
							26.244941175000065
						],
						[
							-80.12196863299994,
							26.246128104000036
						],
						[
							-80.11791329199991,
							26.260494892000054
						],
						[
							-80.11704782299995,
							26.260222888000044
						],
						[
							-80.11598453199991,
							26.259505785000044
						],
						[
							-80.11497069699993,
							26.258887592000065
						],
						[
							-80.10146937799995,
							26.259134869000036
						],
						[
							-80.09976316699994,
							26.258887592000065
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Pompano Beach",
				"Name": "Pompano Airpark",
				"RegionID": "738045"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.1244166749999,
					26.23159671700006,
					-80.10196393099994,
					26.246128104000036
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.10196393099994,
							26.243185509000057
						],
						[
							-80.10280467299992,
							26.23737450100009
						],
						[
							-80.10290358399993,
							26.235544652000044
						],
						[
							-80.1028788559999,
							26.233764258000065
						],
						[
							-80.10285412799993,
							26.231835498000066
						],
						[
							-80.12157310599991,
							26.231597350000072
						],
						[
							-80.12162286799992,
							26.23159671700006
						],
						[
							-80.12164717299993,
							26.235198464000064
						],
						[
							-80.12313083499993,
							26.235099554000044
						],
						[
							-80.12320501799991,
							26.236904675000062
						],
						[
							-80.1244166749999,
							26.23692940300009
						],
						[
							-80.12196863299994,
							26.246128104000036
						],
						[
							-80.12088061499992,
							26.244941175000065
						],
						[
							-80.12090534299996,
							26.24066328400005
						],
						[
							-80.1180863859999,
							26.240737467000088
						],
						[
							-80.1171467339999,
							26.24083637800004
						],
						[
							-80.11591034899993,
							26.24115783800005
						],
						[
							-80.11514379099992,
							26.24133093200004
						],
						[
							-80.1055247189999,
							26.24152875300007
						],
						[
							-80.10493125399995,
							26.241751303000058
						],
						[
							-80.10448615599995,
							26.242122218000077
						],
						[
							-80.1038679639999,
							26.242938232000085
						],
						[
							-80.1033239539999,
							26.243160781000086
						],
						[
							-80.10196393099994,
							26.243185509000057
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Pompano Beach",
				"Name": "Old Pompano",
				"RegionID": "738046"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.10196393099994,
					26.24061382900004,
					-80.08836512399995,
					26.26155784000008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.08836814199992,
							26.26106277000008
						],
						[
							-80.08836512399995,
							26.261057957000048
						],
						[
							-80.09002045699992,
							26.258541405000074
						],
						[
							-80.08927862599995,
							26.25433769700004
						],
						[
							-80.09006991199993,
							26.25023290100006
						],
						[
							-80.09204812699994,
							26.240737467000088
						],
						[
							-80.09768604099992,
							26.24061382900004
						],
						[
							-80.0977602239999,
							26.243160781000086
						],
						[
							-80.10196393099994,
							26.243185509000057
						],
						[
							-80.09976316699994,
							26.258887592000065
						],
						[
							-80.09961194499994,
							26.261253890000035
						],
						[
							-80.09960726399993,
							26.261253900000042
						],
						[
							-80.09953906099992,
							26.261254042000076
						],
						[
							-80.09823982899991,
							26.261257639000064
						],
						[
							-80.09816694499995,
							26.26125779000006
						],
						[
							-80.09809406099993,
							26.26125784000004
						],
						[
							-80.09773882999991,
							26.26125784000004
						],
						[
							-80.0976659449999,
							26.26125784000004
						],
						[
							-80.09759306099994,
							26.26125784000004
						],
						[
							-80.09743882999993,
							26.26125784000004
						],
						[
							-80.09736594499992,
							26.26125784000004
						],
						[
							-80.09656594499995,
							26.261357840000073
						],
						[
							-80.09649306099993,
							26.261357840000073
						],
						[
							-80.0957388299999,
							26.261357840000073
						],
						[
							-80.09566594499996,
							26.261357840000073
						],
						[
							-80.09559306099993,
							26.261357840000073
						],
						[
							-80.0948388299999,
							26.261357840000073
						],
						[
							-80.09476595199993,
							26.261358253000083
						],
						[
							-80.09469308199994,
							26.261359285000083
						],
						[
							-80.09413781099994,
							26.261368605000087
						],
						[
							-80.0940649559999,
							26.261369081000055
						],
						[
							-80.0939921179999,
							26.261367694000057
						],
						[
							-80.09363877899995,
							26.261359798000058
						],
						[
							-80.09356594499991,
							26.261358700000073
						],
						[
							-80.0934930979999,
							26.26135957400004
						],
						[
							-80.0894387919999,
							26.26145610500004
						],
						[
							-80.08936597499991,
							26.261457487000087
						],
						[
							-80.08886594499995,
							26.26155784000008
						],
						[
							-80.08879306099993,
							26.26155784000008
						],
						[
							-80.08863882999994,
							26.26155784000008
						],
						[
							-80.08856681299994,
							26.26155784000008
						],
						[
							-80.08856405299991,
							26.261553098000036
						],
						[
							-80.0883727129999,
							26.26107260200007
						],
						[
							-80.08837045099995,
							26.261067495000077
						],
						[
							-80.08836814199992,
							26.26106277000008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Pompano Beach",
				"Name": "Avalon Harbor",
				"RegionID": "738047"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.05645999899997,
					26.74912805400004,
					-80.05274986699999,
					26.753150054000063
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.05275156999994,
							26.752999545000023
						],
						[
							-80.05306824899998,
							26.74912805400004
						],
						[
							-80.05325475399997,
							26.749133010000037
						],
						[
							-80.05343999999997,
							26.749140000000068
						],
						[
							-80.05412392499994,
							26.749169736000056
						],
						[
							-80.05458999999996,
							26.749190000000056
						],
						[
							-80.05525653799998,
							26.74922345400006
						],
						[
							-80.05561491599997,
							26.749238501000036
						],
						[
							-80.05620419499996,
							26.749249470000052
						],
						[
							-80.05645999899997,
							26.749259731000052
						],
						[
							-80.05645999899997,
							26.74945000100007
						],
						[
							-80.05639999899995,
							26.750190001000078
						],
						[
							-80.05632999999995,
							26.750990001000048
						],
						[
							-80.05625999899996,
							26.751690001000043
						],
						[
							-80.05619999899994,
							26.75249000100007
						],
						[
							-80.05616550699996,
							26.752869513000068
						],
						[
							-80.05614000899999,
							26.753150054000063
						],
						[
							-80.05611453799999,
							26.75314932200007
						],
						[
							-80.05439999999999,
							26.753100000000074
						],
						[
							-80.05274986699999,
							26.75305012800004
						],
						[
							-80.05275156999994,
							26.752999545000023
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "West Palm Beach",
				"Name": "Northwood Gardens",
				"RegionID": "753721"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.16258332899997,
					25.890270133000058,
					-80.14302401399993,
					25.900390703000028
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.15039273499997,
							25.89072717700003
						],
						[
							-80.16258332899997,
							25.890270133000058
						],
						[
							-80.16034068699997,
							25.89801527800006
						],
						[
							-80.16011255199999,
							25.89915799000005
						],
						[
							-80.15705210399994,
							25.899219499000026
						],
						[
							-80.15492639899998,
							25.899329830000056
						],
						[
							-80.15188439999997,
							25.899487719000035
						],
						[
							-80.14969388399999,
							25.899601413000028
						],
						[
							-80.14917742099993,
							25.899719024000035
						],
						[
							-80.14823642399995,
							25.89993331000005
						],
						[
							-80.14800030799995,
							25.899987079000027
						],
						[
							-80.14672671699998,
							25.900227150000035
						],
						[
							-80.14377870499999,
							25.900387281000064
						],
						[
							-80.14353232899998,
							25.900390703000028
						],
						[
							-80.14302401399993,
							25.899959080000034
						],
						[
							-80.14375357499995,
							25.898626325000066
						],
						[
							-80.14564355499994,
							25.896954419000053
						],
						[
							-80.14804237499999,
							25.895112900000072
						],
						[
							-80.14908428799998,
							25.893901374000052
						],
						[
							-80.14969458199994,
							25.892243103000055
						],
						[
							-80.15039273499997,
							25.89072717700003
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "North Miami",
				"Name": "Keystone Point",
				"RegionID": "760907"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.80480075599996,
					26.389022974000056,
					-81.772223,
					26.420375
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.80480075599996,
							26.420346083000027
						],
						[
							-81.79807023799998,
							26.420365281000045
						],
						[
							-81.794663,
							26.420375
						],
						[
							-81.78874982499997,
							26.420327040000075
						],
						[
							-81.788375,
							26.420324
						],
						[
							-81.788146,
							26.420186
						],
						[
							-81.78725723899998,
							26.42017981600003
						],
						[
							-81.786565,
							26.420175
						],
						[
							-81.786096,
							26.41984
						],
						[
							-81.785753,
							26.419901
						],
						[
							-81.785483,
							26.420146
						],
						[
							-81.782644,
							26.420121
						],
						[
							-81.782103,
							26.419512
						],
						[
							-81.78164300000002,
							26.419406
						],
						[
							-81.780817,
							26.419543
						],
						[
							-81.780292,
							26.420142
						],
						[
							-81.77871464199995,
							26.420170167000038
						],
						[
							-81.778332,
							26.420177
						],
						[
							-81.778162,
							26.41986
						],
						[
							-81.77758722099998,
							26.419575253000062
						],
						[
							-81.777183,
							26.419375
						],
						[
							-81.776591,
							26.419247000000002
						],
						[
							-81.775974,
							26.419309
						],
						[
							-81.775605,
							26.419547
						],
						[
							-81.775408,
							26.420221000000005
						],
						[
							-81.77451265999997,
							26.420219277000058
						],
						[
							-81.77384900000001,
							26.420218
						],
						[
							-81.77376262299998,
							26.420273042000076
						],
						[
							-81.77357245299999,
							26.419084481000027
						],
						[
							-81.77311559599997,
							26.40429375100007
						],
						[
							-81.77278304299995,
							26.38937830800006
						],
						[
							-81.772223,
							26.389333
						],
						[
							-81.77402720499998,
							26.389022974000056
						],
						[
							-81.77558896999994,
							26.38940656600005
						],
						[
							-81.77615753399994,
							26.389546213000077
						],
						[
							-81.77858685599996,
							26.389247219000026
						],
						[
							-81.78109092599999,
							26.389097723000077
						],
						[
							-81.78269801599998,
							26.389321968000047
						],
						[
							-81.78363237099997,
							26.39010682600008
						],
						[
							-81.78408086099995,
							26.39063006400005
						],
						[
							-81.80366493499997,
							26.39100380600007
						],
						[
							-81.80385922399996,
							26.39721220800004
						],
						[
							-81.80441026699998,
							26.414820554000073
						],
						[
							-81.80441026699998,
							26.41662887700005
						],
						[
							-81.80452448099999,
							26.418798946000038
						],
						[
							-81.80480075599996,
							26.420346083000027
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Lee",
				"City": "Bonita Springs",
				"Name": "The Brooks",
				"RegionID": "760925"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.66295999999994,
					27.799240127000076,
					-82.65489999999994,
					27.806560000000047
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.65490696699993,
							27.799445002000084
						],
						[
							-82.65490798199994,
							27.799260021000066
						],
						[
							-82.65490999999992,
							27.79926000000006
						],
						[
							-82.65617505599994,
							27.79927000000004
						],
						[
							-82.65745652499993,
							27.79926502400008
						],
						[
							-82.65862802299995,
							27.79925496700008
						],
						[
							-82.65932365999993,
							27.799250000000086
						],
						[
							-82.66071490399992,
							27.799250000000086
						],
						[
							-82.66126407899992,
							27.799250000000086
						],
						[
							-82.6616668069999,
							27.799250000000086
						],
						[
							-82.6622159819999,
							27.799250000000086
						],
						[
							-82.66285181399991,
							27.799240127000076
						],
						[
							-82.66288999999995,
							27.79955262800007
						],
						[
							-82.66290996499993,
							27.800446065000074
						],
						[
							-82.66290660999995,
							27.80103327800009
						],
						[
							-82.66290004699994,
							27.802181741000084
						],
						[
							-82.66290892399991,
							27.802819767000074
						],
						[
							-82.6629099999999,
							27.80373880700006
						],
						[
							-82.66291138799994,
							27.804887384000043
						],
						[
							-82.6629183849999,
							27.80583196400005
						],
						[
							-82.66293850099993,
							27.806290514000068
						],
						[
							-82.66295999999994,
							27.80654000000004
						],
						[
							-82.66233943599991,
							27.80654000000004
						],
						[
							-82.66150720099995,
							27.80654000000004
						],
						[
							-82.66116999999991,
							27.806550000000072
						],
						[
							-82.66093884599991,
							27.806550000000072
						],
						[
							-82.66039078999995,
							27.806550000000072
						],
						[
							-82.66012999999992,
							27.806550000000072
						],
						[
							-82.65982243399992,
							27.806550000000072
						],
						[
							-82.65951795799992,
							27.806550000000072
						],
						[
							-82.65911999999992,
							27.806550000000072
						],
						[
							-82.65874661899994,
							27.806550000000072
						],
						[
							-82.65830999999991,
							27.806550000000072
						],
						[
							-82.65819856199994,
							27.806550000000072
						],
						[
							-82.65807999999993,
							27.806550000000072
						],
						[
							-82.65781289299993,
							27.806550000000072
						],
						[
							-82.65748999999995,
							27.806550000000072
						],
						[
							-82.65730543299992,
							27.806550000000072
						],
						[
							-82.65703999999994,
							27.806550000000072
						],
						[
							-82.65683820299995,
							27.806555174000042
						],
						[
							-82.65664999999991,
							27.806560000000047
						],
						[
							-82.65647319899995,
							27.806560000000047
						],
						[
							-82.65622999999994,
							27.806560000000047
						],
						[
							-82.65598603699993,
							27.806560000000047
						],
						[
							-82.65579999999994,
							27.806560000000047
						],
						[
							-82.6555597709999,
							27.806560000000047
						],
						[
							-82.65531618999995,
							27.806560000000047
						],
						[
							-82.65490999999992,
							27.806560000000047
						],
						[
							-82.65490999999992,
							27.80622438800009
						],
						[
							-82.65490999999992,
							27.805696629000067
						],
						[
							-82.65490999999992,
							27.804945589000056
						],
						[
							-82.65490999999992,
							27.80447872500008
						],
						[
							-82.65490999999992,
							27.804032161000066
						],
						[
							-82.65490729999993,
							27.803565098000036
						],
						[
							-82.65490333399993,
							27.803220070000066
						],
						[
							-82.65489999999994,
							27.80271276500008
						],
						[
							-82.65489999999994,
							27.802103813000087
						],
						[
							-82.65489999999994,
							27.80139336900004
						],
						[
							-82.65489999999994,
							27.800926506000053
						],
						[
							-82.65489999999994,
							27.800601731000086
						],
						[
							-82.65489999999994,
							27.800073973000053
						],
						[
							-82.65490330799992,
							27.799668224000072
						],
						[
							-82.65490696699993,
							27.799445002000084
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Oakwood Gardens",
				"RegionID": "417170"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.64672999999993,
					27.79932002700008,
					-82.63860999999991,
					27.80666000000008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.64630820899993,
							27.799330000000054
						],
						[
							-82.64672886699992,
							27.79932002700008
						],
						[
							-82.64672590499993,
							27.799946488000046
						],
						[
							-82.6467214239999,
							27.800632093000047
						],
						[
							-82.64672494399991,
							27.800993368000036
						],
						[
							-82.64672999999993,
							27.801426072000083
						],
						[
							-82.64672999999993,
							27.801967362000084
						],
						[
							-82.64672999999993,
							27.80236430900004
						],
						[
							-82.64672999999993,
							27.802652997000052
						],
						[
							-82.64672999999993,
							27.802979863000076
						],
						[
							-82.64667999999995,
							27.802980000000048
						],
						[
							-82.64597668099992,
							27.802981741000053
						],
						[
							-82.64493019199995,
							27.80298433100006
						],
						[
							-82.64341458699994,
							27.80298808300006
						],
						[
							-82.64263999999991,
							27.80299000000008
						],
						[
							-82.64264449599995,
							27.80319455700004
						],
						[
							-82.64265321599993,
							27.803591312000037
						],
						[
							-82.64265999999992,
							27.803900000000056
						],
						[
							-82.6426658549999,
							27.804421111000067
						],
						[
							-82.6426699999999,
							27.804790000000082
						],
						[
							-82.6426699999999,
							27.805287278000037
						],
						[
							-82.6426699999999,
							27.80573000000004
						],
						[
							-82.64267282199995,
							27.80597272600005
						],
						[
							-82.64267702299992,
							27.80633395700005
						],
						[
							-82.64267999999994,
							27.806640000000073
						],
						[
							-82.64204329199993,
							27.806640000000073
						],
						[
							-82.64121331299992,
							27.806640000000073
						],
						[
							-82.6406399999999,
							27.806640000000073
						],
						[
							-82.64027521999992,
							27.806642606000082
						],
						[
							-82.63951719399995,
							27.80664802000007
						],
						[
							-82.6386399999999,
							27.80666000000008
						],
						[
							-82.6386399999999,
							27.806153343000066
						],
						[
							-82.63863739199991,
							27.805540031000078
						],
						[
							-82.63863346499994,
							27.805178821000084
						],
						[
							-82.63862999999992,
							27.804860000000076
						],
						[
							-82.63862517699994,
							27.80442110300004
						],
						[
							-82.63861999999995,
							27.803950000000043
						],
						[
							-82.63862343199992,
							27.803627409000057
						],
						[
							-82.63862999999992,
							27.803010000000086
						],
						[
							-82.63862611799993,
							27.802652878000064
						],
						[
							-82.63861999999995,
							27.802090000000078
						],
						[
							-82.63861502899994,
							27.80164258900004
						],
						[
							-82.63860999999991,
							27.801190000000076
						],
						[
							-82.63860999999991,
							27.800812609000047
						],
						[
							-82.63860999999991,
							27.80056000700006
						],
						[
							-82.63860999999991,
							27.800280000000043
						],
						[
							-82.63860999999991,
							27.79994654400008
						],
						[
							-82.63860999999991,
							27.799730028000056
						],
						[
							-82.63860999999991,
							27.799370000000067
						],
						[
							-82.63894920299992,
							27.799368295000082
						],
						[
							-82.63958073899994,
							27.79936512200004
						],
						[
							-82.64004766399995,
							27.799362776000066
						],
						[
							-82.64059999999995,
							27.799360000000036
						],
						[
							-82.64139310899992,
							27.799356015000058
						],
						[
							-82.64213461499992,
							27.79935228800008
						],
						[
							-82.64258999999993,
							27.79935000000006
						],
						[
							-82.64293078199995,
							27.79935000000006
						],
						[
							-82.6432999999999,
							27.79935000000006
						],
						[
							-82.64383681699991,
							27.799343685000053
						],
						[
							-82.64414999999991,
							27.799340000000086
						],
						[
							-82.64441355399993,
							27.799340000000086
						],
						[
							-82.64465999999993,
							27.799340000000086
						],
						[
							-82.64490781199994,
							27.799340000000086
						],
						[
							-82.64503999999994,
							27.799340000000086
						],
						[
							-82.6452920449999,
							27.79933692600008
						],
						[
							-82.6455943819999,
							27.799333239000077
						],
						[
							-82.64585999999991,
							27.799330000000054
						],
						[
							-82.64630820899993,
							27.799330000000054
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Five Points",
				"RegionID": "417172"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.6164004499999,
					27.806131678000046,
					-82.6089579209999,
					27.812975365000057
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.61074497999994,
							27.812360271000045
						],
						[
							-82.61056599999995,
							27.812291000000073
						],
						[
							-82.61056599999995,
							27.81233300000008
						],
						[
							-82.6102654259999,
							27.812022287000048
						],
						[
							-82.61014081399993,
							27.812082624000084
						],
						[
							-82.6100004669999,
							27.812109942000063
						],
						[
							-82.60978051199993,
							27.812137436000057
						],
						[
							-82.60962255499993,
							27.812150573000054
						],
						[
							-82.60936984199992,
							27.812165785000047
						],
						[
							-82.60918043099991,
							27.81217420300004
						],
						[
							-82.60904999999991,
							27.812180000000073
						],
						[
							-82.60902703099993,
							27.811908195000058
						],
						[
							-82.6090084519999,
							27.811688350000054
						],
						[
							-82.60898999999995,
							27.811470000000043
						],
						[
							-82.60897206099992,
							27.811260505000064
						],
						[
							-82.6089579209999,
							27.81113373000005
						],
						[
							-82.60963922099995,
							27.81111781700008
						],
						[
							-82.60962340599991,
							27.81053264800005
						],
						[
							-82.60959039399995,
							27.809735600000067
						],
						[
							-82.60948110999993,
							27.809742536000044
						],
						[
							-82.60942765999994,
							27.809301315000084
						],
						[
							-82.6093809859999,
							27.809123112000066
						],
						[
							-82.60936722699995,
							27.808393902000034
						],
						[
							-82.60936722699995,
							27.80761653600007
						],
						[
							-82.60936034799994,
							27.807141861000048
						],
						[
							-82.6093741059999,
							27.807018033000077
						],
						[
							-82.60944977899993,
							27.80663279000004
						],
						[
							-82.60965785099995,
							27.806161375000045
						],
						[
							-82.60984428699993,
							27.806151053000065
						],
						[
							-82.60985943499992,
							27.80615034300007
						],
						[
							-82.60998943399994,
							27.806145343000082
						],
						[
							-82.60999953499993,
							27.806145479000065
						],
						[
							-82.6100239999999,
							27.806144678000067
						],
						[
							-82.61008281799991,
							27.80614660400005
						],
						[
							-82.61009868499991,
							27.806147785000064
						],
						[
							-82.61038668499992,
							27.80617178500006
						],
						[
							-82.61042938499992,
							27.80617637200004
						],
						[
							-82.61048744899995,
							27.80618595800007
						],
						[
							-82.61051617299995,
							27.806192656000064
						],
						[
							-82.6105502389999,
							27.80618232200004
						],
						[
							-82.61060755099993,
							27.806168959000047
						],
						[
							-82.61060859299994,
							27.806168752000076
						],
						[
							-82.61069459299995,
							27.806151751000076
						],
						[
							-82.61075161499991,
							27.806142371000078
						],
						[
							-82.61081018099992,
							27.806136603000084
						],
						[
							-82.61085790099992,
							27.806134746000055
						],
						[
							-82.61110090099993,
							27.806131747000055
						],
						[
							-82.61110587399992,
							27.806131879000077
						],
						[
							-82.61111199999993,
							27.806131678000046
						],
						[
							-82.61112728199993,
							27.80613180800009
						],
						[
							-82.61148028299995,
							27.806137808000077
						],
						[
							-82.6115238189999,
							27.806139603000076
						],
						[
							-82.61156254399992,
							27.806143417000044
						],
						[
							-82.6122026509999,
							27.80625255600006
						],
						[
							-82.6130821509999,
							27.806303102000076
						],
						[
							-82.61383023099995,
							27.806343539000068
						],
						[
							-82.6148815869999,
							27.806313211000088
						],
						[
							-82.61531514099994,
							27.806162124000082
						],
						[
							-82.61568193999994,
							27.807403598000064
						],
						[
							-82.61614056299993,
							27.807724634000067
						],
						[
							-82.61606412599991,
							27.807984521000037
						],
						[
							-82.61598768899997,
							27.808351419000076
						],
						[
							-82.61598768899997,
							27.808611305000056
						],
						[
							-82.61612527599993,
							27.809161653000046
						],
						[
							-82.6164004499999,
							27.80943682600008
						],
						[
							-82.6161864259999,
							27.80977315000007
						],
						[
							-82.61603355099993,
							27.810354072000052
						],
						[
							-82.61603355099993,
							27.810705683000037
						],
						[
							-82.61608511199995,
							27.811092805000047
						],
						[
							-82.61560049299995,
							27.81114872200004
						],
						[
							-82.61464989399991,
							27.811176681000063
						],
						[
							-82.6140347999999,
							27.81127919700009
						],
						[
							-82.61361541799994,
							27.811521507000066
						],
						[
							-82.61327059299992,
							27.811810414000036
						],
						[
							-82.61301896299994,
							27.811940889000088
						],
						[
							-82.61263685999995,
							27.81190361000006
						],
						[
							-82.61241318899994,
							27.81222047700004
						],
						[
							-82.61218951899991,
							27.81245346700007
						],
						[
							-82.6119099309999,
							27.81272373500008
						],
						[
							-82.6116489819999,
							27.812854210000072
						],
						[
							-82.61141599199993,
							27.812975365000057
						],
						[
							-82.6112389189999,
							27.812844890000065
						],
						[
							-82.61074497999994,
							27.812360271000045
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Patrician Point",
				"RegionID": "417177"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.61021428899994,
					27.822577752000086,
					-82.6056912009999,
					27.82985000000008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.60649632399992,
							27.82731995900008
						],
						[
							-82.60611593699991,
							27.82665002500005
						],
						[
							-82.60593662299993,
							27.826334177000035
						],
						[
							-82.60570284599993,
							27.825989536000066
						],
						[
							-82.6056912009999,
							27.82599055500009
						],
						[
							-82.6062802639999,
							27.824812429000076
						],
						[
							-82.60651934999993,
							27.824653039000054
						],
						[
							-82.6068182059999,
							27.82437410600005
						],
						[
							-82.60689790099991,
							27.824214716000085
						],
						[
							-82.60693774799995,
							27.82401547900008
						],
						[
							-82.60693774799995,
							27.82377639400005
						],
						[
							-82.6068779769999,
							27.823577156000056
						],
						[
							-82.60677835799994,
							27.823357995000038
						],
						[
							-82.6068182059999,
							27.823059139000065
						],
						[
							-82.6070174429999,
							27.822899749000047
						],
						[
							-82.60729637599991,
							27.82266066300008
						],
						[
							-82.60750018199991,
							27.822577752000086
						],
						[
							-82.6080475149999,
							27.822703369000067
						],
						[
							-82.60907105899992,
							27.82271340400007
						],
						[
							-82.60907105899992,
							27.82294420300008
						],
						[
							-82.60912150399992,
							27.82345869100004
						],
						[
							-82.60913126699995,
							27.824569832000066
						],
						[
							-82.60912127899991,
							27.825616386000036
						],
						[
							-82.60952999999995,
							27.82561000000004
						],
						[
							-82.60952999999995,
							27.82593455700004
						],
						[
							-82.60952999999995,
							27.826295808000054
						],
						[
							-82.60952999999995,
							27.82655671100008
						],
						[
							-82.60952999999995,
							27.82695810100006
						],
						[
							-82.61002435999991,
							27.82695810100006
						],
						[
							-82.61001432499995,
							27.827138726000044
						],
						[
							-82.60996415099993,
							27.827951541000065
						],
						[
							-82.60996415099993,
							27.82828268700007
						],
						[
							-82.61000428999995,
							27.828603799000064
						],
						[
							-82.61007453299993,
							27.82902525800006
						],
						[
							-82.61016484599992,
							27.829426648000037
						],
						[
							-82.61021428899994,
							27.82985000000008
						],
						[
							-82.60887948399994,
							27.82985000000008
						],
						[
							-82.60797044899994,
							27.82984124300009
						],
						[
							-82.60793732999991,
							27.82960100200006
						],
						[
							-82.60791145999991,
							27.829518293000035
						],
						[
							-82.6078838869999,
							27.829459013000076
						],
						[
							-82.60784945699993,
							27.829427757000076
						],
						[
							-82.60764825099994,
							27.82928852200007
						],
						[
							-82.60758922799994,
							27.829243982000037
						],
						[
							-82.60735057799991,
							27.829047952000053
						],
						[
							-82.60729301799995,
							27.828995816000088
						],
						[
							-82.60724017099994,
							27.828938908000055
						],
						[
							-82.60719243199992,
							27.828877653000063
						],
						[
							-82.60715015699992,
							27.828812506000077
						],
						[
							-82.60711365999992,
							27.82874395500005
						],
						[
							-82.60708321499993,
							27.828672510000047
						],
						[
							-82.60699862399991,
							27.828447532000045
						],
						[
							-82.60649632399992,
							27.82731995900008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Mangrove Bayou",
				"RegionID": "417179"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.6468999999999,
					27.82842000000005,
					-82.63870999999995,
					27.842580000000055
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.6387499999999,
							27.842580000000055
						],
						[
							-82.6387531549999,
							27.842273935000037
						],
						[
							-82.6387548539999,
							27.842109132000076
						],
						[
							-82.63875612699991,
							27.84198568900007
						],
						[
							-82.63875761399993,
							27.84184146000007
						],
						[
							-82.63875999999993,
							27.84161000000006
						],
						[
							-82.63875377199992,
							27.841451183000064
						],
						[
							-82.63874890599993,
							27.841327111000055
						],
						[
							-82.6387448779999,
							27.841224389000047
						],
						[
							-82.63873999999993,
							27.84110000000004
						],
						[
							-82.63873999999993,
							27.840977373000044
						],
						[
							-82.63873999999993,
							27.84085391700006
						],
						[
							-82.63873999999993,
							27.840700000000083
						],
						[
							-82.63873618199996,
							27.840360218000058
						],
						[
							-82.63873271499995,
							27.84005161600004
						],
						[
							-82.6387299999999,
							27.83966050500004
						],
						[
							-82.6387299999999,
							27.83941359200009
						],
						[
							-82.6387299999999,
							27.839146104000065
						],
						[
							-82.6387299999999,
							27.838816887000064
						],
						[
							-82.63873003299994,
							27.83850830700004
						],
						[
							-82.63873285599993,
							27.838364330000047
						],
						[
							-82.63873729999995,
							27.83813767700008
						],
						[
							-82.63873999999993,
							27.83800000000008
						],
						[
							-82.63873999999993,
							27.837767508000073
						],
						[
							-82.63873999999993,
							27.83758000000006
						],
						[
							-82.63873999999993,
							27.837335410000037
						],
						[
							-82.63873999999993,
							27.837100000000078
						],
						[
							-82.63873379199993,
							27.83655367600005
						],
						[
							-82.6387299999999,
							27.836220000000083
						],
						[
							-82.6387299999999,
							27.83589508600005
						],
						[
							-82.6387299999999,
							27.835620000000063
						],
						[
							-82.63871999999992,
							27.834989739000036
						],
						[
							-82.63871999999992,
							27.834490000000073
						],
						[
							-82.63871999999992,
							27.833569991000047
						],
						[
							-82.63871999999992,
							27.833170000000052
						],
						[
							-82.63871999999992,
							27.832890981000048
						],
						[
							-82.63871999999992,
							27.832650000000058
						],
						[
							-82.63871783199994,
							27.83245922100008
						],
						[
							-82.63871455899995,
							27.83217119300008
						],
						[
							-82.63871221799991,
							27.83196522500009
						],
						[
							-82.63870999999995,
							27.831770000000063
						],
						[
							-82.63870999999995,
							27.831553537000048
						],
						[
							-82.63870999999995,
							27.83130662400004
						],
						[
							-82.63870999999995,
							27.831162592000055
						],
						[
							-82.63870999999995,
							27.830880000000036
						],
						[
							-82.63870999999995,
							27.830627614000036
						],
						[
							-82.63870999999995,
							27.830154365000055
						],
						[
							-82.63870999999995,
							27.829960000000085
						],
						[
							-82.63870999999995,
							27.82963996300009
						],
						[
							-82.63870999999995,
							27.82918729000005
						],
						[
							-82.63870999999995,
							27.828960000000052
						],
						[
							-82.63870999999995,
							27.828672888000085
						],
						[
							-82.63870999999995,
							27.82845000000009
						],
						[
							-82.63891100399991,
							27.82845000000009
						],
						[
							-82.63916999999992,
							27.82845000000009
						],
						[
							-82.63948909999993,
							27.82845000000009
						],
						[
							-82.64015478599993,
							27.82845000000009
						],
						[
							-82.64038999999991,
							27.82845000000009
						],
						[
							-82.64083798999991,
							27.82845000000009
						],
						[
							-82.64120586999991,
							27.82845000000009
						],
						[
							-82.64134999999993,
							27.82845000000009
						],
						[
							-82.64162635999992,
							27.82844654600007
						],
						[
							-82.64192411999994,
							27.828442823000046
						],
						[
							-82.6421499999999,
							27.828440000000057
						],
						[
							-82.64240999999993,
							27.828440000000057
						],
						[
							-82.64267738699994,
							27.828440000000057
						],
						[
							-82.64306278399994,
							27.828440000000057
						],
						[
							-82.64339999999993,
							27.828440000000057
						],
						[
							-82.64357080799994,
							27.828440000000057
						],
						[
							-82.64369999999991,
							27.828440000000057
						],
						[
							-82.64395618499992,
							27.82843850200004
						],
						[
							-82.64442915599994,
							27.828435736000074
						],
						[
							-82.6448146429999,
							27.828433482000037
						],
						[
							-82.64520002699993,
							27.828431228000056
						],
						[
							-82.64540999999991,
							27.828430000000083
						],
						[
							-82.64563793899993,
							27.828430000000083
						],
						[
							-82.64586999999995,
							27.828430000000083
						],
						[
							-82.64612847399991,
							27.82842725000006
						],
						[
							-82.64654885999994,
							27.82842277800006
						],
						[
							-82.64686999999992,
							27.82842000000005
						],
						[
							-82.64686999999992,
							27.82864296000008
						],
						[
							-82.64686999999992,
							27.828992742000082
						],
						[
							-82.64686999999992,
							27.829167633000054
						],
						[
							-82.64686999999992,
							27.82934000000006
						],
						[
							-82.64686845599994,
							27.829465088000063
						],
						[
							-82.64686608099994,
							27.829657439000076
						],
						[
							-82.64686370599992,
							27.829849790000083
						],
						[
							-82.64686219499993,
							27.82997219500004
						],
						[
							-82.64686068399993,
							27.830094600000052
						],
						[
							-82.64685999999995,
							27.83015000000006
						],
						[
							-82.64685826199991,
							27.830339415000083
						],
						[
							-82.64685585599995,
							27.83060173000007
						],
						[
							-82.64685344899993,
							27.830864044000066
						],
						[
							-82.64684999999992,
							27.831240000000037
						],
						[
							-82.64685178199994,
							27.831528698000056
						],
						[
							-82.64685286199995,
							27.831703583000035
						],
						[
							-82.64685545299994,
							27.832123306000085
						],
						[
							-82.6468577199999,
							27.83249056300008
						],
						[
							-82.64686106599994,
							27.83303270600004
						],
						[
							-82.64686387299992,
							27.833487405000085
						],
						[
							-82.64686743499993,
							27.834064525000088
						],
						[
							-82.64686999999992,
							27.83457177300005
						],
						[
							-82.64686999999992,
							27.835078957000064
						],
						[
							-82.64686999999992,
							27.835253848000036
						],
						[
							-82.64686999999992,
							27.835620000000063
						],
						[
							-82.64686999999992,
							27.835946612000043
						],
						[
							-82.64686999999992,
							27.836230000000057
						],
						[
							-82.64686999999992,
							27.836537356000065
						],
						[
							-82.64686999999992,
							27.83678609000009
						],
						[
							-82.64686999999992,
							27.83704000000006
						],
						[
							-82.64687408299994,
							27.83725232800009
						],
						[
							-82.6468764739999,
							27.837376649000078
						],
						[
							-82.6468799999999,
							27.837560000000053
						],
						[
							-82.64688159499991,
							27.837687567000046
						],
						[
							-82.64688392599993,
							27.83787408900008
						],
						[
							-82.6468862619999,
							27.83806099900005
						],
						[
							-82.64688999999993,
							27.83836000000008
						],
						[
							-82.64688999999993,
							27.83849613800004
						],
						[
							-82.64688999999993,
							27.83862000000005
						],
						[
							-82.64688999999993,
							27.838744872000063
						],
						[
							-82.64688999999993,
							27.838870000000043
						],
						[
							-82.64688999999993,
							27.839180157000044
						],
						[
							-82.64688999999993,
							27.83942889100007
						],
						[
							-82.64688999999993,
							27.839780000000076
						],
						[
							-82.64688999999993,
							27.84001963500009
						],
						[
							-82.64688999999993,
							27.84045491900008
						],
						[
							-82.64688999999993,
							27.84071000000006
						],
						[
							-82.64689407599991,
							27.841076798000078
						],
						[
							-82.64689787499992,
							27.84141876600006
						],
						[
							-82.6468999999999,
							27.84161000000006
						],
						[
							-82.6468999999999,
							27.841822958000083
						],
						[
							-82.6468999999999,
							27.84219605900006
						],
						[
							-82.6468999999999,
							27.84251000000006
						],
						[
							-82.64654616399991,
							27.84251295300004
						],
						[
							-82.64588779699994,
							27.842519570000036
						],
						[
							-82.64559914099993,
							27.842522471000052
						],
						[
							-82.64518786799994,
							27.842526604000057
						],
						[
							-82.6448499999999,
							27.84253000000007
						],
						[
							-82.64432388799992,
							27.842531643000086
						],
						[
							-82.64358360599994,
							27.842550035000045
						],
						[
							-82.64311064899994,
							27.842561785000044
						],
						[
							-82.6427799999999,
							27.84257000000008
						],
						[
							-82.64238943099991,
							27.84256806600007
						],
						[
							-82.64183389099992,
							27.842565316000048
						],
						[
							-82.64115489799991,
							27.842561955000065
						],
						[
							-82.64075999999996,
							27.84256000000005
						],
						[
							-82.64037300899992,
							27.84256000000005
						],
						[
							-82.6398174549999,
							27.84256000000005
						],
						[
							-82.63936489399993,
							27.842567055000075
						],
						[
							-82.63909709099994,
							27.84257269300008
						],
						[
							-82.6387499999999,
							27.842580000000055
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Fossil Park",
				"RegionID": "417186"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.6346476459999,
					27.831912397000053,
					-82.62031532999993,
					27.839713105000044
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.62077823699991,
							27.839324799000057
						],
						[
							-82.62068643599991,
							27.839216306000083
						],
						[
							-82.62061132499991,
							27.83888248300008
						],
						[
							-82.62050283299993,
							27.838481895000086
						],
						[
							-82.6203943399999,
							27.83807296200007
						],
						[
							-82.62031532999993,
							27.83759668600004
						],
						[
							-82.62032471799995,
							27.83754301400006
						],
						[
							-82.62033034099994,
							27.837506835000056
						],
						[
							-82.62037091399992,
							27.837355414000058
						],
						[
							-82.62043716499996,
							27.837213339000073
						],
						[
							-82.62052707999993,
							27.837084927000035
						],
						[
							-82.62058007699994,
							27.83702709000005
						],
						[
							-82.62062507699994,
							27.83698209000005
						],
						[
							-82.62068058299991,
							27.836931053000058
						],
						[
							-82.62074016999992,
							27.836884845000043
						],
						[
							-82.62080341799992,
							27.836843791000035
						],
						[
							-82.6208698829999,
							27.836808180000048
						],
						[
							-82.62093909799995,
							27.836778262000053
						],
						[
							-82.62100625599993,
							27.83675258800008
						],
						[
							-82.62107320399991,
							27.836730511000045
						],
						[
							-82.62114167599992,
							27.83671374900007
						],
						[
							-82.62121125099992,
							27.83670240400005
						],
						[
							-82.62128150099994,
							27.836696547000088
						],
						[
							-82.62135199399995,
							27.83669621200005
						],
						[
							-82.62158399399993,
							27.83670421300008
						],
						[
							-82.62170916499991,
							27.836717341000053
						],
						[
							-82.62183355099995,
							27.836748558000068
						],
						[
							-82.6219005509999,
							27.83677055800007
						],
						[
							-82.62196993099991,
							27.83679655200007
						],
						[
							-82.6220369369999,
							27.83682816700008
						],
						[
							-82.62210111299993,
							27.83686518900004
						],
						[
							-82.6221620259999,
							27.836907366000048
						],
						[
							-82.6222201189999,
							27.836881503000086
						],
						[
							-82.62223350999994,
							27.836859384000036
						],
						[
							-82.62225950899995,
							27.836818384000082
						],
						[
							-82.62228683299992,
							27.836781036000048
						],
						[
							-82.62228560499995,
							27.836759072000067
						],
						[
							-82.62225649999993,
							27.836754804000066
						],
						[
							-82.62213264199994,
							27.836727602000053
						],
						[
							-82.62205464199992,
							27.836704602000054
						],
						[
							-82.6220014139999,
							27.83668708600004
						],
						[
							-82.62189795199993,
							27.83664188700004
						],
						[
							-82.62182595099995,
							27.836604887000078
						],
						[
							-82.62177188999993,
							27.83657471000004
						],
						[
							-82.62172003199993,
							27.836540884000044
						],
						[
							-82.62167062599991,
							27.836503571000037
						],
						[
							-82.62162390299994,
							27.83646294600004
						],
						[
							-82.62157990399993,
							27.836421946000087
						],
						[
							-82.6215293649999,
							27.83637093300007
						],
						[
							-82.62148305699994,
							27.83631605100004
						],
						[
							-82.62144127499994,
							27.83625764900006
						],
						[
							-82.62140428599992,
							27.836196099000063
						],
						[
							-82.62137232599991,
							27.836131795000085
						],
						[
							-82.62134559799995,
							27.836065146000067
						],
						[
							-82.62132427199992,
							27.83599657700006
						],
						[
							-82.62129027199991,
							27.83586957600005
						],
						[
							-82.6212733399999,
							27.83579316500004
						],
						[
							-82.62126060499992,
							27.835677833000094
						],
						[
							-82.62125936299992,
							27.83565049500004
						],
						[
							-82.62113841399992,
							27.83561808700006
						],
						[
							-82.62106124199994,
							27.835585860000037
						],
						[
							-82.62091124299991,
							27.835514860000046
						],
						[
							-82.62084945099991,
							27.835482978000073
						],
						[
							-82.62079044699993,
							27.835446193000053
						],
						[
							-82.62073461799991,
							27.835404747000045
						],
						[
							-82.62068233199994,
							27.83535891200006
						],
						[
							-82.62063393299991,
							27.835308990000048
						],
						[
							-82.6205897399999,
							27.835255309000047
						],
						[
							-82.62057081199993,
							27.835284714000068
						],
						[
							-82.62052932499995,
							27.834706976000064
						],
						[
							-82.62076998799995,
							27.834255732000088
						],
						[
							-82.62084199999993,
							27.833278000000064
						],
						[
							-82.62082251499994,
							27.833280783000077
						],
						[
							-82.62082251499994,
							27.831912397000053
						],
						[
							-82.63054715099992,
							27.831912397000053
						],
						[
							-82.6308629749999,
							27.831986519000054
						],
						[
							-82.6316260509999,
							27.83207345200009
						],
						[
							-82.63182999999992,
							27.832020000000057
						],
						[
							-82.63190633799991,
							27.83203388000004
						],
						[
							-82.6320124689999,
							27.832043397000064
						],
						[
							-82.63219604299991,
							27.83205200200007
						],
						[
							-82.63234061399993,
							27.83205877900008
						],
						[
							-82.63250536399994,
							27.832066501000043
						],
						[
							-82.63255355399991,
							27.832068760000084
						],
						[
							-82.63279481299992,
							27.832070000000044
						],
						[
							-82.63304595199992,
							27.832070000000044
						],
						[
							-82.63324999999992,
							27.832070000000044
						],
						[
							-82.63341300199994,
							27.832070000000044
						],
						[
							-82.63364482199995,
							27.832070000000044
						],
						[
							-82.63415678399991,
							27.83207208500005
						],
						[
							-82.63431145399994,
							27.832074847000058
						],
						[
							-82.63446595199993,
							27.83207760600004
						],
						[
							-82.63459999999992,
							27.832080000000076
						],
						[
							-82.6346038559999,
							27.832199548000062
						],
						[
							-82.63461053599991,
							27.83239804200008
						],
						[
							-82.63461999999994,
							27.83254000000005
						],
						[
							-82.6346233619999,
							27.83277872000008
						],
						[
							-82.63462657999992,
							27.833007206000048
						],
						[
							-82.6346299999999,
							27.83325000000008
						],
						[
							-82.6346299999999,
							27.833586100000048
						],
						[
							-82.63462655799992,
							27.833890971000073
						],
						[
							-82.63462155299993,
							27.834241315000043
						],
						[
							-82.63461999999994,
							27.834728757000054
						],
						[
							-82.63461999999994,
							27.834910000000036
						],
						[
							-82.63461675899993,
							27.835140136000067
						],
						[
							-82.63461246799994,
							27.83544478500005
						],
						[
							-82.63460999999995,
							27.835620000000063
						],
						[
							-82.63461205499993,
							27.835840766000047
						],
						[
							-82.63461450099993,
							27.836008320000076
						],
						[
							-82.63461917099994,
							27.836328196000068
						],
						[
							-82.63462317999995,
							27.836602820000053
						],
						[
							-82.63462695999993,
							27.836861767000073
						],
						[
							-82.6346299999999,
							27.83731878000009
						],
						[
							-82.63463329399991,
							27.837714839000057
						],
						[
							-82.63463686499995,
							27.837882677000042
						],
						[
							-82.63463913399994,
							27.837989277000077
						],
						[
							-82.6346411799999,
							27.83823293200004
						],
						[
							-82.63464357099991,
							27.838644274000046
						],
						[
							-82.6346467599999,
							27.839192731000082
						],
						[
							-82.6346476459999,
							27.839345080000044
						],
						[
							-82.63448906699995,
							27.839380118000065
						],
						[
							-82.63301827899996,
							27.839395439000043
						],
						[
							-82.6301839489999,
							27.839418420000072
						],
						[
							-82.62770199499994,
							27.839464382000074
						],
						[
							-82.62716577099991,
							27.83934947700004
						],
						[
							-82.62646101799993,
							27.839364797000087
						],
						[
							-82.6251817399999,
							27.839295854000056
						],
						[
							-82.62302151999995,
							27.839357137000036
						],
						[
							-82.62171159999991,
							27.839380118000065
						],
						[
							-82.62151243099993,
							27.83944906100004
						],
						[
							-82.62142816699992,
							27.839556306000077
						],
						[
							-82.62139831099995,
							27.83960748900006
						],
						[
							-82.6212429489999,
							27.839713105000044
						],
						[
							-82.62114544199994,
							27.83960020300009
						],
						[
							-82.62096183999995,
							27.839433291000034
						],
						[
							-82.62077823699991,
							27.839324799000057
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Mobel Americana",
				"RegionID": "417188"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.17101595999998,
					26.17700499700004,
					-80.16215346599995,
					26.183072
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.164722,
							26.181901
						],
						[
							-80.16354571399995,
							26.181679642000063
						],
						[
							-80.16345927799995,
							26.18166248600005
						],
						[
							-80.16326800000002,
							26.181624
						],
						[
							-80.16326800000002,
							26.181761
						],
						[
							-80.16296013499993,
							26.18169942700007
						],
						[
							-80.16299332799997,
							26.181576865000068
						],
						[
							-80.16304261099998,
							26.181394894000054
						],
						[
							-80.16308113799994,
							26.181252637000057
						],
						[
							-80.16318661699995,
							26.180863169000077
						],
						[
							-80.16359756199995,
							26.18081945100005
						],
						[
							-80.16394533699997,
							26.180782454000052
						],
						[
							-80.16394897899995,
							26.180589416000032
						],
						[
							-80.16395476399998,
							26.180282808000072
						],
						[
							-80.16396234099994,
							26.179881205000072
						],
						[
							-80.16397240599997,
							26.179347762000077
						],
						[
							-80.16398642899998,
							26.178604536000023
						],
						[
							-80.16399376499999,
							26.178215721000072
						],
						[
							-80.16384847899997,
							26.178054291000024
						],
						[
							-80.16372262199997,
							26.177973613000063
						],
						[
							-80.16335766799995,
							26.177739668000072
						],
						[
							-80.16321890299997,
							26.177650716000073
						],
						[
							-80.16297503199996,
							26.177573121000023
						],
						[
							-80.16215346599995,
							26.177311714000044
						],
						[
							-80.16252475499994,
							26.177069569000025
						],
						[
							-80.16418836699995,
							26.177056918000062
						],
						[
							-80.17100134999998,
							26.177005108000063
						],
						[
							-80.17101595999998,
							26.17700499700004
						],
						[
							-80.17093524499995,
							26.180491880000034
						],
						[
							-80.17096307099996,
							26.182683737000048
						],
						[
							-80.17096447399996,
							26.182794288000025
						],
						[
							-80.170968,
							26.183072
						],
						[
							-80.169542,
							26.182777
						],
						[
							-80.16918902999998,
							26.182740761000048
						],
						[
							-80.168568,
							26.182677
						],
						[
							-80.167549,
							26.182459
						],
						[
							-80.167311,
							26.182423
						],
						[
							-80.165259,
							26.182009
						],
						[
							-80.164722,
							26.181901
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Oakland Park",
				"Name": "Oakland Hills",
				"RegionID": "760973"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.80615833,
					24.547048370000027,
					-81.79858212599999,
					24.55415801000004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.80097578699997,
							24.551273900000073
						],
						[
							-81.80034393299997,
							24.550424805000034
						],
						[
							-81.79992752699997,
							24.54986523200006
						],
						[
							-81.79861141799995,
							24.54809662400004
						],
						[
							-81.79858212599999,
							24.548057261000057
						],
						[
							-81.79946979199997,
							24.54748661900004
						],
						[
							-81.79978137499995,
							24.547286316000054
						],
						[
							-81.79995269599993,
							24.54751474400007
						],
						[
							-81.80037148099996,
							24.54732438700006
						],
						[
							-81.80088544499996,
							24.548019190000048
						],
						[
							-81.80238926399994,
							24.547048370000027
						],
						[
							-81.80477824299999,
							24.55027491900006
						],
						[
							-81.80492100999999,
							24.550246365000078
						],
						[
							-81.80513992099998,
							24.55049382900006
						],
						[
							-81.80589183099994,
							24.55005600800007
						],
						[
							-81.80615833,
							24.550379615000054
						],
						[
							-81.80599652699993,
							24.550598525000055
						],
						[
							-81.80595845499994,
							24.551150560000053
						],
						[
							-81.80579665199997,
							24.552083309000068
						],
						[
							-81.80601556299996,
							24.552311737000025
						],
						[
							-81.80526395499999,
							24.552791382000066
						],
						[
							-81.80357106999998,
							24.553871710000067
						],
						[
							-81.80312243499998,
							24.55415801000004
						],
						[
							-81.80309482899997,
							24.554121500000065
						],
						[
							-81.80097578699997,
							24.551273900000073
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Monroe",
				"City": "Key West",
				"Name": "Bahama Village",
				"RegionID": "761059"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.80730585899994,
					24.556475712000065,
					-81.79484525199996,
					24.564365422000037
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.79534573799998,
							24.561609945000043
						],
						[
							-81.79484525199996,
							24.56093529000003
						],
						[
							-81.80222706199999,
							24.556475712000065
						],
						[
							-81.80280815499998,
							24.557280941000045
						],
						[
							-81.80355465099996,
							24.55820245300004
						],
						[
							-81.80439125299995,
							24.559290619000024
						],
						[
							-81.80537837499998,
							24.560597353000052
						],
						[
							-81.80599098999994,
							24.560753962000035
						],
						[
							-81.80608851199997,
							24.560718499000075
						],
						[
							-81.80629499399998,
							24.560643415000072
						],
						[
							-81.80644640499999,
							24.560932472000047
						],
						[
							-81.80654833099999,
							24.56112705800007
						],
						[
							-81.80656824599998,
							24.56109671100006
						],
						[
							-81.80698238399998,
							24.561660016000076
						],
						[
							-81.80730585899994,
							24.562100002000022
						],
						[
							-81.806966,
							24.562275
						],
						[
							-81.806569,
							24.562241000000004
						],
						[
							-81.806259,
							24.56231
						],
						[
							-81.805903,
							24.562443
						],
						[
							-81.805632,
							24.562544000000003
						],
						[
							-81.805229,
							24.56364
						],
						[
							-81.804902,
							24.563808
						],
						[
							-81.803801,
							24.563245
						],
						[
							-81.803143,
							24.562499
						],
						[
							-81.802609,
							24.56229
						],
						[
							-81.802505,
							24.562249
						],
						[
							-81.802121,
							24.562099
						],
						[
							-81.801137,
							24.562918
						],
						[
							-81.800942,
							24.563143
						],
						[
							-81.800534,
							24.563593
						],
						[
							-81.79975,
							24.563315
						],
						[
							-81.799326,
							24.563248
						],
						[
							-81.799296,
							24.563415
						],
						[
							-81.799245,
							24.5637
						],
						[
							-81.799578,
							24.563765
						],
						[
							-81.800806,
							24.564006
						],
						[
							-81.80144527199997,
							24.564084051000066
						],
						[
							-81.80040018599999,
							24.56417708400005
						],
						[
							-81.79828450799994,
							24.564365422000037
						],
						[
							-81.797244521,
							24.56430156400006
						],
						[
							-81.79712592599998,
							24.564009637000026
						],
						[
							-81.79534573799998,
							24.561609945000043
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Monroe",
				"City": "Key West",
				"Name": "Historic Seaport",
				"RegionID": "761124"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.80933853699997,
					24.550424805000034,
					-81.79856586899996,
					24.562100002000022
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.80656824599998,
							24.56109671100006
						],
						[
							-81.80654833099999,
							24.56112705800007
						],
						[
							-81.80644640499999,
							24.560932472000047
						],
						[
							-81.80629499399998,
							24.560643415000072
						],
						[
							-81.80608851199997,
							24.560718499000075
						],
						[
							-81.80599098999994,
							24.560753962000035
						],
						[
							-81.80537837499998,
							24.560597353000052
						],
						[
							-81.80439125299995,
							24.559290619000024
						],
						[
							-81.80377083599996,
							24.558469322000068
						],
						[
							-81.80355465099996,
							24.55820245300004
						],
						[
							-81.80280815499998,
							24.557280941000045
						],
						[
							-81.80222706199999,
							24.556475712000065
						],
						[
							-81.80216256899996,
							24.556386127000053
						],
						[
							-81.80190074699993,
							24.555945163000047
						],
						[
							-81.80135722399996,
							24.555245032000073
						],
						[
							-81.80117248399995,
							24.55500734800006
						],
						[
							-81.80060181899995,
							24.554273138000045
						],
						[
							-81.79993392999995,
							24.55328282100004
						],
						[
							-81.79859354699995,
							24.551564735000056
						],
						[
							-81.79856586899996,
							24.551532417000033
						],
						[
							-81.80034393299997,
							24.550424805000034
						],
						[
							-81.80097578699997,
							24.551273900000073
						],
						[
							-81.80309482899997,
							24.554121500000065
						],
						[
							-81.80312243499998,
							24.55415801000004
						],
						[
							-81.80460915099997,
							24.556124802000056
						],
						[
							-81.80632263099994,
							24.558321926000076
						],
						[
							-81.80665427199995,
							24.558128468000064
						],
						[
							-81.80756628599994,
							24.558100831000047
						],
						[
							-81.80766637799996,
							24.55813438100006
						],
						[
							-81.80902277699994,
							24.558688566000058
						],
						[
							-81.80933853699997,
							24.558817576000024
						],
						[
							-81.808413,
							24.560425
						],
						[
							-81.807603,
							24.561947
						],
						[
							-81.80730585899994,
							24.562100002000022
						],
						[
							-81.80698238399998,
							24.561660016000076
						],
						[
							-81.80656824599998,
							24.56109671100006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Monroe",
				"City": "Key West",
				"Name": "Duvall Street",
				"RegionID": "761125"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.79490392899999,
					24.546577365000076,
					-81.78287330199998,
					24.55331350700004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.78287330199998,
							24.549138533000075
						],
						[
							-81.78454396299998,
							24.547494050000072
						],
						[
							-81.78515264099998,
							24.54684137000004
						],
						[
							-81.78639933199997,
							24.546577365000076
						],
						[
							-81.78740401899995,
							24.54682670300008
						],
						[
							-81.78817403399995,
							24.54672403400008
						],
						[
							-81.78873871199994,
							24.54676803500007
						],
						[
							-81.78969939699994,
							24.546775369000045
						],
						[
							-81.79217077999994,
							24.546914705000063
						],
						[
							-81.79282612699996,
							24.547164474000056
						],
						[
							-81.79403875699995,
							24.548709512000073
						],
						[
							-81.79404296899997,
							24.548714879000045
						],
						[
							-81.79404829499998,
							24.54871232100004
						],
						[
							-81.79409281899996,
							24.54869091100005
						],
						[
							-81.79410708899997,
							24.548682867000025
						],
						[
							-81.79413334399999,
							24.54866806700005
						],
						[
							-81.79441376799997,
							24.54903612800007
						],
						[
							-81.79444220199997,
							24.54907344800006
						],
						[
							-81.79484142199999,
							24.549597430000063
						],
						[
							-81.79490392899999,
							24.549679472000037
						],
						[
							-81.79363592699997,
							24.550506236000047
						],
						[
							-81.79363135599993,
							24.550509216000023
						],
						[
							-81.79346319899997,
							24.550612347000026
						],
						[
							-81.78906258499995,
							24.55331350700004
						],
						[
							-81.78623368899997,
							24.549563576000025
						],
						[
							-81.78419813199997,
							24.55080732600004
						],
						[
							-81.78415983599997,
							24.55083093500008
						],
						[
							-81.78287330199998,
							24.549138533000075
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Monroe",
				"City": "Key West",
				"Name": "Casa Marina",
				"RegionID": "761126"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.14688244199994,
					26.173824831000047,
					-80.13863315199995,
					26.183601505000073
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.13895982499997,
							26.18286275500003
						],
						[
							-80.13891813899994,
							26.181218046000026
						],
						[
							-80.13886163999996,
							26.178988884000034
						],
						[
							-80.13879458199995,
							26.17634313600007
						],
						[
							-80.13863315199995,
							26.17390554600007
						],
						[
							-80.13873668699996,
							26.173906551000073
						],
						[
							-80.13942408299994,
							26.173913225000035
						],
						[
							-80.14029587799996,
							26.173921689000053
						],
						[
							-80.14053606299996,
							26.173884737000037
						],
						[
							-80.14092545399996,
							26.173824831000047
						],
						[
							-80.14114194499996,
							26.173848235000037
						],
						[
							-80.14152274399999,
							26.173889403000032
						],
						[
							-80.14170397199996,
							26.17394118200008
						],
						[
							-80.14186174699995,
							26.17398626100004
						],
						[
							-80.14278189599999,
							26.17398626100004
						],
						[
							-80.14667305499995,
							26.173875956000074
						],
						[
							-80.14672702699994,
							26.17566703800003
						],
						[
							-80.14674172199994,
							26.176357709000058
						],
						[
							-80.14681029899998,
							26.178846084000043
						],
						[
							-80.14682643799995,
							26.179561139000043
						],
						[
							-80.14688244199994,
							26.18204240400007
						],
						[
							-80.14649113699994,
							26.182033981000075
						],
						[
							-80.14490230699994,
							26.182105746000047
						],
						[
							-80.14486281999996,
							26.18186039400007
						],
						[
							-80.14486197199994,
							26.181855123000048
						],
						[
							-80.14485030799995,
							26.181695706000028
						],
						[
							-80.14461677799994,
							26.181734873000043
						],
						[
							-80.14454148099998,
							26.181702603000076
						],
						[
							-80.14427940299998,
							26.181709445000024
						],
						[
							-80.14406099899998,
							26.181715147000034
						],
						[
							-80.14025103599994,
							26.18180061100003
						],
						[
							-80.14025058899995,
							26.181865569000024
						],
						[
							-80.14024621999994,
							26.182500554000057
						],
						[
							-80.14026209599996,
							26.18278103600005
						],
						[
							-80.14036793799994,
							26.18314619100005
						],
						[
							-80.14038381399996,
							26.18359601900005
						],
						[
							-80.14005821299997,
							26.18359728400003
						],
						[
							-80.13897384699999,
							26.183601505000073
						],
						[
							-80.13896635699996,
							26.183120468000027
						],
						[
							-80.13895982499997,
							26.18286275500003
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Oakland Park",
				"Name": "Andrews Gardens",
				"RegionID": "761157"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.15480503599997,
					26.175585015000024,
					-80.14672702699994,
					26.18204240400007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.14672702699994,
							26.17566703800003
						],
						[
							-80.14681739599996,
							26.175666232000026
						],
						[
							-80.15135530999999,
							26.175625745000048
						],
						[
							-80.15338941499994,
							26.17560085300005
						],
						[
							-80.15468368199998,
							26.175585015000024
						],
						[
							-80.15468144199997,
							26.176084496000044
						],
						[
							-80.15467926899998,
							26.176569137000058
						],
						[
							-80.15480503599997,
							26.176713439000025
						],
						[
							-80.154638,
							26.176959
						],
						[
							-80.15462777999994,
							26.177346474000046
						],
						[
							-80.15461715499998,
							26.177749342000027
						],
						[
							-80.154591,
							26.178741
						],
						[
							-80.154598,
							26.178993000000002
						],
						[
							-80.154663,
							26.179939
						],
						[
							-80.154699,
							26.180473
						],
						[
							-80.154595,
							26.180893
						],
						[
							-80.15458241099998,
							26.181137599000067
						],
						[
							-80.15272596899996,
							26.181056884000043
						],
						[
							-80.15248382399994,
							26.181347458000065
						],
						[
							-80.15235534199996,
							26.181604422000078
						],
						[
							-80.15180559499998,
							26.181608437000023
						],
						[
							-80.15165076299996,
							26.181609196000068
						],
						[
							-80.15122430399998,
							26.181611286000077
						],
						[
							-80.14957783899996,
							26.181619357000045
						],
						[
							-80.14890183399996,
							26.181602389000034
						],
						[
							-80.14891349799996,
							26.181987323000044
						],
						[
							-80.14859444199999,
							26.181983738000042
						],
						[
							-80.14822139499995,
							26.181979546000036
						],
						[
							-80.14688244199994,
							26.18204240400007
						],
						[
							-80.14682643799995,
							26.179561139000043
						],
						[
							-80.14681029899998,
							26.178846084000043
						],
						[
							-80.14674172199994,
							26.176357709000058
						],
						[
							-80.14672702699994,
							26.17566703800003
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Oakland Park",
				"Name": "Prospect Gardens",
				"RegionID": "761158"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.35288122599997,
					28.828716835000023,
					-82.34469285399996,
					28.83602604700007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.35287352099994,
							28.835964920000034
						],
						[
							-82.34469285399996,
							28.83602604700007
						],
						[
							-82.34474996099993,
							28.828759173000037
						],
						[
							-82.35071568399997,
							28.828716835000023
						],
						[
							-82.35162876699997,
							28.828776091000066
						],
						[
							-82.35288122599997,
							28.82872760900005
						],
						[
							-82.35287352099994,
							28.835964920000034
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Citrus",
				"City": "Inverness",
				"Name": "Inverness Heights",
				"RegionID": "761194"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.76508730999996,
					27.758096000000002,
					-82.75267889199995,
					27.771649120000063
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.75292300099994,
							27.771385467000073
						],
						[
							-82.75267889199995,
							27.771332655000037
						],
						[
							-82.752719,
							27.770821
						],
						[
							-82.75274644899997,
							27.77039684000005
						],
						[
							-82.75290477999994,
							27.767950195000026
						],
						[
							-82.75292,
							27.767715
						],
						[
							-82.75360894399995,
							27.765912739000044
						],
						[
							-82.75380505399994,
							27.76539972000006
						],
						[
							-82.75398957799996,
							27.764917011000023
						],
						[
							-82.754222,
							27.764309
						],
						[
							-82.75435052399996,
							27.76412191900005
						],
						[
							-82.75453608099997,
							27.76385182100006
						],
						[
							-82.75477361899993,
							27.763506058000075
						],
						[
							-82.755247,
							27.762817
						],
						[
							-82.75559978499996,
							27.762420402000032
						],
						[
							-82.758033,
							27.759685
						],
						[
							-82.75987,
							27.758564
						],
						[
							-82.761016,
							27.758096000000002
						],
						[
							-82.76134589199995,
							27.758178789000056
						],
						[
							-82.76178038099994,
							27.75828782700006
						],
						[
							-82.76364248299996,
							27.758755137000037
						],
						[
							-82.76508730999996,
							27.762914486000057
						],
						[
							-82.76458380999998,
							27.76867190100006
						],
						[
							-82.76397085299999,
							27.771364533000053
						],
						[
							-82.75414165399997,
							27.771649120000063
						],
						[
							-82.75292300099994,
							27.771385467000073
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Treasure Island",
				"Name": "Paradise Island",
				"RegionID": "761227"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.33292410299998,
					29.670172830000066,
					-82.33079604899996,
					29.67402955400007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.33079604899996,
							29.673997334000035
						],
						[
							-82.33087178199997,
							29.670172830000066
						],
						[
							-82.33270778699995,
							29.67022313100006
						],
						[
							-82.33285264699998,
							29.670227100000037
						],
						[
							-82.33292410299998,
							29.67402955400007
						],
						[
							-82.33079604899996,
							29.673997334000035
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Alachua",
				"City": "Gainesville",
				"Name": "Pinepark",
				"RegionID": "761359"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.33129323899999,
					29.64358067700005,
					-82.32499406899996,
					29.648378517000026
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.32499406899996,
							29.644664213000055
						],
						[
							-82.33121014699998,
							29.64358067700005
						],
						[
							-82.33129323899999,
							29.64416525600007
						],
						[
							-82.33126797199998,
							29.647664770000063
						],
						[
							-82.33120817199995,
							29.648315009000047
						],
						[
							-82.32499579199998,
							29.648378517000026
						],
						[
							-82.32499406899996,
							29.645769135000023
						],
						[
							-82.32499406899996,
							29.644664213000055
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Alachua",
				"City": "Gainesville",
				"Name": "Porters Community",
				"RegionID": "761360"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.37669398999998,
					29.65186524800004,
					-82.37235885899997,
					29.657937849000064
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.37643933299995,
							29.657937849000064
						],
						[
							-82.37242591399996,
							29.65792103000007
						],
						[
							-82.37235885899997,
							29.652092860000035
						],
						[
							-82.37669398999998,
							29.65186524800004
						],
						[
							-82.37643933299995,
							29.657937849000064
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Alachua",
				"City": "Gainesville",
				"Name": "Woodland Terrace",
				"RegionID": "761441"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.36229754899995,
					29.650172746000067,
					-82.35576669799997,
					29.652203159000067
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.35753048899994,
							29.65211122400007
						],
						[
							-82.35704646099998,
							29.652079135000065
						],
						[
							-82.35652345199998,
							29.652088511000045
						],
						[
							-82.35588965399995,
							29.652085326000073
						],
						[
							-82.35587516899994,
							29.651860008000032
						],
						[
							-82.35576669799997,
							29.650172746000067
						],
						[
							-82.36225794199999,
							29.65029221700007
						],
						[
							-82.36229754899995,
							29.652033035000045
						],
						[
							-82.36149193099999,
							29.652012509000027
						],
						[
							-82.36118270499998,
							29.652004631000068
						],
						[
							-82.36050719199994,
							29.652083511000058
						],
						[
							-82.36017217799997,
							29.65215530000006
						],
						[
							-82.35995681199995,
							29.652203159000067
						],
						[
							-82.35867658099994,
							29.652187206000065
						],
						[
							-82.35753048899994,
							29.65211122400007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Alachua",
				"City": "Gainesville",
				"Name": "University Village",
				"RegionID": "761442"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.37082001199997,
					29.650272305000044,
					-82.36574180899999,
					29.652144013000058
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.36574180899999,
							29.65209788200008
						],
						[
							-82.36574250499996,
							29.650272305000044
						],
						[
							-82.37082001199997,
							29.650312129000042
						],
						[
							-82.3708001,
							29.652064366000047
						],
						[
							-82.37060098199998,
							29.652144013000058
						],
						[
							-82.36936637399998,
							29.652132292000037
						],
						[
							-82.36574180899999,
							29.65209788200008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Alachua",
				"City": "Gainesville",
				"Name": "South Black Acres",
				"RegionID": "761443"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.37085434899996,
					29.652078562000042,
					-82.36405152499998,
					29.658355429000036
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.36454864699994,
							29.652083973000057
						],
						[
							-82.36574180899999,
							29.65209788200008
						],
						[
							-82.36936637399998,
							29.652132292000037
						],
						[
							-82.37060098199998,
							29.652144013000058
						],
						[
							-82.37058107099995,
							29.65288075000007
						],
						[
							-82.37071296599999,
							29.653298412000026
						],
						[
							-82.37085434899996,
							29.65359757400006
						],
						[
							-82.37054124699995,
							29.65359757400006
						],
						[
							-82.36984433399994,
							29.65445378100003
						],
						[
							-82.37004345199995,
							29.654931664000063
						],
						[
							-82.37044168799997,
							29.65616619500003
						],
						[
							-82.37012309899995,
							29.656763549000058
						],
						[
							-82.36962530499994,
							29.65652460700005
						],
						[
							-82.36874918599995,
							29.656345401000067
						],
						[
							-82.36765403699997,
							29.656405137000036
						],
						[
							-82.36733544899994,
							29.657460462000078
						],
						[
							-82.36723588999996,
							29.657798962000072
						],
						[
							-82.36524471099995,
							29.657938345000048
						],
						[
							-82.36502568099996,
							29.65819719800004
						],
						[
							-82.36414517899999,
							29.658355429000036
						],
						[
							-82.36418752699996,
							29.655800447000047
						],
						[
							-82.36405152499998,
							29.65581495400005
						],
						[
							-82.36408451199998,
							29.652078562000042
						],
						[
							-82.36454864699994,
							29.652083973000057
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Alachua",
				"City": "Gainesville",
				"Name": "Black Acres",
				"RegionID": "761444"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.36408451199998,
					29.652004631000068,
					-82.36118270499998,
					29.655843508000032
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.36118291699995,
							29.652023778000057
						],
						[
							-82.36118270499998,
							29.652004631000068
						],
						[
							-82.36149193099999,
							29.652012509000027
						],
						[
							-82.36229754899995,
							29.652033035000045
						],
						[
							-82.36408451199998,
							29.652078562000042
						],
						[
							-82.36405152499998,
							29.65581495400005
						],
						[
							-82.36123186399999,
							29.655843508000032
						],
						[
							-82.36118291699995,
							29.652023778000057
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Alachua",
				"City": "Gainesville",
				"Name": "Hibiscus Park",
				"RegionID": "761445"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.26868202999998,
					25.914657,
					-80.259122,
					25.92568891600007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.259122,
							25.914975000000002
						],
						[
							-80.26195992,
							25.914843618000077
						],
						[
							-80.262146,
							25.914838
						],
						[
							-80.262689,
							25.914828
						],
						[
							-80.263592,
							25.9148
						],
						[
							-80.263676,
							25.914793
						],
						[
							-80.264109,
							25.91479
						],
						[
							-80.26468767699998,
							25.914734965000036
						],
						[
							-80.26507321799994,
							25.91471960800004
						],
						[
							-80.26597,
							25.914711
						],
						[
							-80.266645,
							25.914657
						],
						[
							-80.26822775099998,
							25.914768406000064
						],
						[
							-80.26831346399996,
							25.917121206000047
						],
						[
							-80.26868202999998,
							25.925483777000068
						],
						[
							-80.26861817299994,
							25.925485378000076
						],
						[
							-80.26684181099995,
							25.925529913000048
						],
						[
							-80.26064851499996,
							25.92568891600007
						],
						[
							-80.26064862199996,
							25.925683970000023
						],
						[
							-80.26053951399996,
							25.923206094000022
						],
						[
							-80.26037015499998,
							25.91935989100006
						],
						[
							-80.26031661699994,
							25.917914368000027
						],
						[
							-80.26022143799997,
							25.91703991600008
						],
						[
							-80.25993292899994,
							25.916233874000056
						],
						[
							-80.259122,
							25.914975000000002
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Gardens",
				"Name": "Venitian Gardens",
				"RegionID": "761642"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.27672251299998,
					25.91421844300004,
					-80.268223,
					25.925483777000068
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.26822775099998,
							25.914768406000064
						],
						[
							-80.268223,
							25.914638
						],
						[
							-80.268769,
							25.914634
						],
						[
							-80.268984,
							25.914624
						],
						[
							-80.269098,
							25.91448
						],
						[
							-80.269296,
							25.91447
						],
						[
							-80.269407,
							25.91447
						],
						[
							-80.26977159599994,
							25.914451816000053
						],
						[
							-80.27095719499994,
							25.91440648500003
						],
						[
							-80.271133,
							25.914403
						],
						[
							-80.27132809499994,
							25.91439230400005
						],
						[
							-80.27617977899996,
							25.91421844300004
						],
						[
							-80.27625719499997,
							25.915379705000078
						],
						[
							-80.27643906799995,
							25.919129097000052
						],
						[
							-80.27663493199998,
							25.92336814800007
						],
						[
							-80.27664192699996,
							25.92354302600006
						],
						[
							-80.27672251299998,
							25.925282192000054
						],
						[
							-80.27641600599999,
							25.92528987700007
						],
						[
							-80.27620182799996,
							25.925295247000065
						],
						[
							-80.27532899199997,
							25.925317130000053
						],
						[
							-80.27246025399995,
							25.925389053000064
						],
						[
							-80.26868202999998,
							25.925483777000068
						],
						[
							-80.26831346399996,
							25.917121206000047
						],
						[
							-80.26822775099998,
							25.914768406000064
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Gardens",
				"Name": "Florida Memorial University",
				"RegionID": "761643"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.27745543799996,
					25.925282192000054,
					-80.26064851499996,
					25.940342158000078
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.26117110399997,
							25.936678473000033
						],
						[
							-80.26104730399999,
							25.93420743100006
						],
						[
							-80.26095254899997,
							25.93231611400006
						],
						[
							-80.26064851499996,
							25.92568891600007
						],
						[
							-80.26684181099995,
							25.925529913000048
						],
						[
							-80.26861817299994,
							25.925485378000076
						],
						[
							-80.26868202999998,
							25.925483777000068
						],
						[
							-80.27246025399995,
							25.925389053000064
						],
						[
							-80.27532899199997,
							25.925317130000053
						],
						[
							-80.27620182799996,
							25.925295247000065
						],
						[
							-80.27641600599999,
							25.92528987700007
						],
						[
							-80.27672251299998,
							25.925282192000054
						],
						[
							-80.276714,
							25.925523
						],
						[
							-80.276776,
							25.926622
						],
						[
							-80.276799,
							25.927254
						],
						[
							-80.276837,
							25.928096
						],
						[
							-80.276979,
							25.931005000000003
						],
						[
							-80.277164,
							25.93459
						],
						[
							-80.277179,
							25.934729000000004
						],
						[
							-80.277183,
							25.934762
						],
						[
							-80.277186,
							25.93487
						],
						[
							-80.27719,
							25.934989000000005
						],
						[
							-80.277215,
							25.935333
						],
						[
							-80.27725972399998,
							25.935965448000047
						],
						[
							-80.27729178599998,
							25.936603048000052
						],
						[
							-80.277288,
							25.937124
						],
						[
							-80.277324,
							25.937857
						],
						[
							-80.277352,
							25.93821
						],
						[
							-80.27736,
							25.938554
						],
						[
							-80.277406,
							25.939106000000002
						],
						[
							-80.27744669999998,
							25.939683743000046
						],
						[
							-80.277447,
							25.939688
						],
						[
							-80.27745543799996,
							25.939857509000035
						],
						[
							-80.27707635999997,
							25.939868198000056
						],
						[
							-80.27680377099995,
							25.93987588400006
						],
						[
							-80.27626008799996,
							25.939891214000056
						],
						[
							-80.26936868599995,
							25.94008553200007
						],
						[
							-80.26924482399994,
							25.936998879000043
						],
						[
							-80.26921136799996,
							25.93659739700007
						],
						[
							-80.26670965099999,
							25.936727922000046
						],
						[
							-80.26664634699995,
							25.936731225000074
						],
						[
							-80.26609774999997,
							25.937011211000026
						],
						[
							-80.26596891299994,
							25.937076965000074
						],
						[
							-80.26573348699998,
							25.93711335100005
						],
						[
							-80.26544326099997,
							25.937205936000055
						],
						[
							-80.26502083399998,
							25.937217205000024
						],
						[
							-80.26503535699999,
							25.937459509000064
						],
						[
							-80.26519949799996,
							25.94019799600005
						],
						[
							-80.26513523499995,
							25.940199541000027
						],
						[
							-80.26485970299996,
							25.940206167000042
						],
						[
							-80.26438350199999,
							25.940224659000023
						],
						[
							-80.26143848499999,
							25.940339021000057
						],
						[
							-80.26135770099995,
							25.940342158000078
						],
						[
							-80.26117110399997,
							25.936678473000033
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Gardens",
				"Name": "Carol City South",
				"RegionID": "761644"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.26936868599995,
					25.93659739700007,
					-80.26502083399998,
					25.940204357000027
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.26609774999997,
							25.937011211000026
						],
						[
							-80.26664634699995,
							25.936731225000074
						],
						[
							-80.26670965099999,
							25.936727922000046
						],
						[
							-80.26921136799996,
							25.93659739700007
						],
						[
							-80.26924482399994,
							25.936998879000043
						],
						[
							-80.26936868599995,
							25.94008553200007
						],
						[
							-80.26908981999998,
							25.94009415800008
						],
						[
							-80.26868778499994,
							25.940106594000046
						],
						[
							-80.26849941099994,
							25.940112421000038
						],
						[
							-80.26669044999994,
							25.94016837600003
						],
						[
							-80.26587740299993,
							25.94019378300004
						],
						[
							-80.26553904299999,
							25.940204357000027
						],
						[
							-80.26519949799996,
							25.94019799600005
						],
						[
							-80.26503535699999,
							25.937459509000064
						],
						[
							-80.26502083399998,
							25.937217205000024
						],
						[
							-80.26544326099997,
							25.937205936000055
						],
						[
							-80.26573348699998,
							25.93711335100005
						],
						[
							-80.26596891299994,
							25.937076965000074
						],
						[
							-80.26609774999997,
							25.937011211000026
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Gardens",
				"Name": "Lejenue Gardens",
				"RegionID": "761645"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.12774083899996,
					26.89435222700007,
					-80.12107897899995,
					26.903272463000064
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.12774083899996,
							26.894471500000066
						],
						[
							-80.12749127299998,
							26.901686203000054
						],
						[
							-80.12365327499998,
							26.901805713000044
						],
						[
							-80.12374307599998,
							26.902344519000053
						],
						[
							-80.12374307599998,
							26.90252412100006
						],
						[
							-80.12377300999998,
							26.90309286100006
						],
						[
							-80.12317433599998,
							26.903272463000064
						],
						[
							-80.12215659099996,
							26.90252412100006
						],
						[
							-80.12140824899997,
							26.90183564700004
						],
						[
							-80.12149804999996,
							26.901506376000043
						],
						[
							-80.12164771899995,
							26.901087305000033
						],
						[
							-80.12155791799995,
							26.900698167000034
						],
						[
							-80.12146811699995,
							26.90039883000003
						],
						[
							-80.12119871399995,
							26.900069560000077
						],
						[
							-80.12107897899995,
							26.89962055500007
						],
						[
							-80.12419208099999,
							26.898393274000057
						],
						[
							-80.12392267799999,
							26.89773473300005
						],
						[
							-80.12350360699998,
							26.897465330000045
						],
						[
							-80.12317433599998,
							26.897255794000046
						],
						[
							-80.12314440299997,
							26.89701632500004
						],
						[
							-80.12308453499998,
							26.89659725300004
						],
						[
							-80.12305460199997,
							26.896208115000036
						],
						[
							-80.12302466799997,
							26.895818978000026
						],
						[
							-80.12299473399997,
							26.895669309000027
						],
						[
							-80.12284506599997,
							26.89531010500008
						],
						[
							-80.12260559699996,
							26.89465156400007
						],
						[
							-80.12263552999997,
							26.89435222700007
						],
						[
							-80.12774083899996,
							26.894471500000066
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Jupiter",
				"Name": "Tuscany",
				"RegionID": "761959"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.43369941999998,
					27.093647635000025,
					-82.39583699299999,
					27.104126243000053
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.39583699299999,
							27.103087919000075
						],
						[
							-82.39617382099993,
							27.102532608000047
						],
						[
							-82.39608278699995,
							27.09963787600003
						],
						[
							-82.39681106299997,
							27.099637709000035
						],
						[
							-82.39682084099996,
							27.09744365800003
						],
						[
							-82.41213966399994,
							27.097680777000054
						],
						[
							-82.41217446899998,
							27.09378264600008
						],
						[
							-82.41552031499998,
							27.093819014000076
						],
						[
							-82.41602946499995,
							27.094000853000068
						],
						[
							-82.41778542699996,
							27.093647635000025
						],
						[
							-82.42114460199997,
							27.09548653300004
						],
						[
							-82.42251012099996,
							27.095868878000033
						],
						[
							-82.42454019099995,
							27.097161569000036
						],
						[
							-82.42535950199994,
							27.09696129300005
						],
						[
							-82.42539449799995,
							27.094904213000063
						],
						[
							-82.43314295799996,
							27.094812878000027
						],
						[
							-82.43354901699996,
							27.094848971000033
						],
						[
							-82.43355261299996,
							27.094886428000052
						],
						[
							-82.43355976899994,
							27.09510586500005
						],
						[
							-82.43357635599995,
							27.09561452400004
						],
						[
							-82.43357989299994,
							27.095723003000046
						],
						[
							-82.43357707299998,
							27.097920298000076
						],
						[
							-82.43369941999998,
							27.10155183200004
						],
						[
							-82.43364235299998,
							27.101539313000046
						],
						[
							-82.43255874099998,
							27.10130160400007
						],
						[
							-82.43179501599997,
							27.10104702900003
						],
						[
							-82.42543222199998,
							27.101022126000032
						],
						[
							-82.42543222199998,
							27.101104271000054
						],
						[
							-82.42504851999996,
							27.10110276900008
						],
						[
							-82.42499221899999,
							27.101102549000075
						],
						[
							-82.41330093999994,
							27.10105679000003
						],
						[
							-82.41315640199997,
							27.101056224000047
						],
						[
							-82.41302235599994,
							27.101243888000056
						],
						[
							-82.41297456199999,
							27.101310799000036
						],
						[
							-82.41293807899996,
							27.10139106200006
						],
						[
							-82.41281631899994,
							27.101658935000046
						],
						[
							-82.41279272299994,
							27.10171084600006
						],
						[
							-82.41267254,
							27.101827135000065
						],
						[
							-82.41186817999994,
							27.102605436000033
						],
						[
							-82.41111259299998,
							27.10194998700007
						],
						[
							-82.40946980799998,
							27.101949365000053
						],
						[
							-82.40933752999996,
							27.10194931500007
						],
						[
							-82.40858481699996,
							27.101949029000025
						],
						[
							-82.40856362599999,
							27.102232194000067
						],
						[
							-82.40844528099996,
							27.103051505000053
						],
						[
							-82.40840300899998,
							27.103047940000067
						],
						[
							-82.407101217,
							27.102938159000075
						],
						[
							-82.40708744699998,
							27.103023535000034
						],
						[
							-82.40700442299999,
							27.103538282000045
						],
						[
							-82.40696283599995,
							27.103539400000045
						],
						[
							-82.40091867499996,
							27.103701885000078
						],
						[
							-82.39924575199996,
							27.103810989000067
						],
						[
							-82.39891418099995,
							27.103864672000043
						],
						[
							-82.39887737399994,
							27.10394371900003
						],
						[
							-82.39870624499997,
							27.103971425000054
						],
						[
							-82.39863599799997,
							27.10398279800006
						],
						[
							-82.39775001899994,
							27.104126243000053
						],
						[
							-82.39583699299999,
							27.103087919000075
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Sarasota",
				"City": "Venice",
				"Name": "East Venice Ave",
				"RegionID": "761960"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.15987715499996,
					26.94887,
					-80.15022767599999,
					26.95660151900006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.15987715499996,
							26.95660151900006
						],
						[
							-80.15899848099997,
							26.95660151900006
						],
						[
							-80.15804648099999,
							26.95660151900006
						],
						[
							-80.15736448099995,
							26.95660151900006
						],
						[
							-80.15672648099996,
							26.95660151900006
						],
						[
							-80.15610548099994,
							26.95660151900006
						],
						[
							-80.15545348099994,
							26.95660151900006
						],
						[
							-80.15471848099997,
							26.95660151900006
						],
						[
							-80.15396248099995,
							26.95660151900006
						],
						[
							-80.15375848099995,
							26.95660151900006
						],
						[
							-80.15319848099995,
							26.95660151900006
						],
						[
							-80.15251648099996,
							26.95660151900006
						],
						[
							-80.15187248099994,
							26.95660151900006
						],
						[
							-80.15120148099999,
							26.95660151900006
						],
						[
							-80.15055348099997,
							26.95660151900006
						],
						[
							-80.15046948099996,
							26.95660151900006
						],
						[
							-80.15025947899994,
							26.95660151900006
						],
						[
							-80.15022767599999,
							26.95660151900006
						],
						[
							-80.15038879599996,
							26.94888206400003
						],
						[
							-80.15785459999995,
							26.948872
						],
						[
							-80.15864066499996,
							26.948870940000067
						],
						[
							-80.159338,
							26.94887
						],
						[
							-80.159703,
							26.949907
						],
						[
							-80.15987715499996,
							26.95660151900006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Jupiter",
				"Name": "Jupiter Island",
				"RegionID": "761976"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.101464,
					26.948322647000055,
					-80.08680491899997,
					26.956902038000067
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.101464,
							26.954638653000075
						],
						[
							-80.101464,
							26.954935
						],
						[
							-80.101464,
							26.955835
						],
						[
							-80.10114940799997,
							26.956024058000025
						],
						[
							-80.10105857299999,
							26.956078646000037
						],
						[
							-80.10105421499998,
							26.956079335000027
						],
						[
							-80.10103261099994,
							26.95607935700008
						],
						[
							-80.10050198099998,
							26.956079894000027
						],
						[
							-80.10052245899999,
							26.956110952000074
						],
						[
							-80.100475,
							26.956111
						],
						[
							-80.100535,
							26.956202
						],
						[
							-80.100632,
							26.956335
						],
						[
							-80.100772,
							26.956507
						],
						[
							-80.10090738299995,
							26.95665166300006
						],
						[
							-80.10112478999997,
							26.956901230000028
						],
						[
							-80.10111889599995,
							26.956902038000067
						],
						[
							-80.09771598099996,
							26.956851894000067
						],
						[
							-80.09757798099997,
							26.956845894000026
						],
						[
							-80.09758098099996,
							26.95603989400007
						],
						[
							-80.09687598099998,
							26.95603989400007
						],
						[
							-80.09529498099994,
							26.956034894000027
						],
						[
							-80.09295698099999,
							26.95603289400003
						],
						[
							-80.09218998099999,
							26.956034894000027
						],
						[
							-80.09142298099994,
							26.95603689400008
						],
						[
							-80.08969498099998,
							26.956040894000072
						],
						[
							-80.08916898099994,
							26.956042894000067
						],
						[
							-80.08879198099999,
							26.956042894000067
						],
						[
							-80.08859898099996,
							26.95604389400006
						],
						[
							-80.08761798099994,
							26.956046894000053
						],
						[
							-80.08757806499995,
							26.956044957000074
						],
						[
							-80.08731640299999,
							26.955376527000055
						],
						[
							-80.08711950199995,
							26.95487353200008
						],
						[
							-80.08680491899997,
							26.95406991300007
						],
						[
							-80.08704438799998,
							26.952573229000052
						],
						[
							-80.08788253099995,
							26.950867010000024
						],
						[
							-80.08875060799994,
							26.94960979500007
						],
						[
							-80.09006768999996,
							26.948322647000055
						],
						[
							-80.09114530199997,
							26.94859205000006
						],
						[
							-80.09204331199999,
							26.949280525000063
						],
						[
							-80.09267191899994,
							26.94951999400007
						],
						[
							-80.09243245,
							26.950507806000076
						],
						[
							-80.09276171999994,
							26.950777209000023
						],
						[
							-80.09419853699995,
							26.950896943000032
						],
						[
							-80.09584488899998,
							26.950837076000028
						],
						[
							-80.09647349599999,
							26.95029827000008
						],
						[
							-80.09800011399994,
							26.95092687700003
						],
						[
							-80.09832938399995,
							26.951465683000038
						],
						[
							-80.09847905299995,
							26.95200448900005
						],
						[
							-80.09856885399995,
							26.95281269900005
						],
						[
							-80.09901785899996,
							26.953680775000066
						],
						[
							-80.10015533899997,
							26.95415971400007
						],
						[
							-80.101464,
							26.954638653000075
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Jupiter",
				"Name": "Riverside Drive Park",
				"RegionID": "761977"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.09994580299997,
					26.926441129000068,
					-80.09407880199996,
					26.933116339000037
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.09440807299995,
							26.926471063000065
						],
						[
							-80.09994580299997,
							26.926441129000068
						],
						[
							-80.09979613499996,
							26.933116339000037
						],
						[
							-80.09407880199996,
							26.933056472000032
						],
						[
							-80.09440807299995,
							26.926471063000065
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Jupiter",
				"Name": "Pine Gardens South",
				"RegionID": "761978"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.095367,
					26.882665000000003,
					-80.08611644399997,
					26.89743539600005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.08659023699994,
							26.897214383000062
						],
						[
							-80.08689471999998,
							26.895699243000024
						],
						[
							-80.08737365899998,
							26.895040702000077
						],
						[
							-80.08824173499994,
							26.89435222700007
						],
						[
							-80.08907987799995,
							26.892705875000047
						],
						[
							-80.08922954699995,
							26.892406538000046
						],
						[
							-80.08904994499994,
							26.891448661000027
						],
						[
							-80.08857100599994,
							26.891149324000025
						],
						[
							-80.08812200099999,
							26.890580584000077
						],
						[
							-80.08770292899999,
							26.889742441000067
						],
						[
							-80.08737365899998,
							26.888844431000052
						],
						[
							-80.08686478599998,
							26.88824575700005
						],
						[
							-80.08641876499996,
							26.887764055000048
						],
						[
							-80.08611644399997,
							26.887437548000037
						],
						[
							-80.08620624499997,
							26.886898742000028
						],
						[
							-80.08644571499997,
							26.885761262000077
						],
						[
							-80.08648517499996,
							26.88541927500006
						],
						[
							-80.08653551599997,
							26.88498298600007
						],
						[
							-80.08680491899997,
							26.88432444600005
						],
						[
							-80.08713418899998,
							26.883456369000044
						],
						[
							-80.087045,
							26.882665000000003
						],
						[
							-80.095367,
							26.882856
						],
						[
							-80.09516033499995,
							26.89399673400004
						],
						[
							-80.09510834899999,
							26.89679915800008
						],
						[
							-80.09509654699997,
							26.89743539600005
						],
						[
							-80.08700902599998,
							26.897225264000042
						],
						[
							-80.08659023699994,
							26.897214383000062
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Jupiter",
				"Name": "Ritz Carlton",
				"RegionID": "761979"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.265418,
					27.208599315000072,
					-80.25981704999998,
					27.220475
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.262835,
							27.220458
						],
						[
							-80.261511226,
							27.217060678000053
						],
						[
							-80.26054040599996,
							27.214424235000024
						],
						[
							-80.25981704999998,
							27.21218754200004
						],
						[
							-80.26102581599997,
							27.208599315000072
						],
						[
							-80.26131135199995,
							27.208656422000047
						],
						[
							-80.26229168999998,
							27.208675458000073
						],
						[
							-80.26267240299995,
							27.209275082000037
						],
						[
							-80.26302456399998,
							27.20999843800007
						],
						[
							-80.26317684899999,
							27.21042674100005
						],
						[
							-80.26345286699996,
							27.21086456200004
						],
						[
							-80.26399538399994,
							27.211587918000077
						],
						[
							-80.26478536499997,
							27.21218754200004
						],
						[
							-80.265258,
							27.212343
						],
						[
							-80.265174,
							27.215122
						],
						[
							-80.265418,
							27.216407
						],
						[
							-80.263609,
							27.21644
						],
						[
							-80.262998,
							27.216457000000002
						],
						[
							-80.263433,
							27.218057000000005
						],
						[
							-80.263444,
							27.218133
						],
						[
							-80.263812,
							27.218089
						],
						[
							-80.263864,
							27.218352
						],
						[
							-80.264194,
							27.218363
						],
						[
							-80.264225,
							27.218623
						],
						[
							-80.264476,
							27.218675
						],
						[
							-80.264437,
							27.219125
						],
						[
							-80.264407,
							27.219209
						],
						[
							-80.264395,
							27.219233
						],
						[
							-80.264352,
							27.219209
						],
						[
							-80.26424,
							27.219515
						],
						[
							-80.264194,
							27.219597000000004
						],
						[
							-80.264109,
							27.219754
						],
						[
							-80.263921,
							27.219925
						],
						[
							-80.263871,
							27.219986
						],
						[
							-80.263881,
							27.220475
						],
						[
							-80.262835,
							27.220458
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Martin",
				"City": "Stuart",
				"Name": "Bahama Terrace",
				"RegionID": "762336"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.25804486699997,
					27.197541814000033,
					-80.24196732499996,
					27.20256551700004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.24199111999997,
							27.20108311300004
						],
						[
							-80.24196732499996,
							27.198418117000074
						],
						[
							-80.24198098599999,
							27.197541814000033
						],
						[
							-80.25277483699995,
							27.197573329000083
						],
						[
							-80.25285573899998,
							27.197601882000072
						],
						[
							-80.25295458499994,
							27.197591196000076
						],
						[
							-80.25471647799998,
							27.19921991600006
						],
						[
							-80.25501866899998,
							27.19949355400007
						],
						[
							-80.25592762299993,
							27.20020263300006
						],
						[
							-80.25665097899997,
							27.200773704000028
						],
						[
							-80.25778360299995,
							27.20171121100003
						],
						[
							-80.25804486699997,
							27.20256551700004
						],
						[
							-80.25734530599993,
							27.20256551700004
						],
						[
							-80.25655056599999,
							27.201970652000057
						],
						[
							-80.25616985199997,
							27.20177553600007
						],
						[
							-80.25597949499996,
							27.20163752700006
						],
						[
							-80.25582245099997,
							27.201504278000073
						],
						[
							-80.25559402199998,
							27.20121398300006
						],
						[
							-80.25551787999996,
							27.201194948000023
						],
						[
							-80.25548932599997,
							27.20115211700005
						],
						[
							-80.25527517499997,
							27.201066457000028
						],
						[
							-80.25515620199997,
							27.201099769000052
						],
						[
							-80.25477072899997,
							27.200752368000057
						],
						[
							-80.25451850599995,
							27.20055725200007
						],
						[
							-80.25416158699994,
							27.200452556000073
						],
						[
							-80.25395219399996,
							27.200385931000028
						],
						[
							-80.25368569499994,
							27.20022412800006
						],
						[
							-80.25350961499998,
							27.200228887000037
						],
						[
							-80.25341919499994,
							27.200205092000033
						],
						[
							-80.25274818699995,
							27.200029012000073
						],
						[
							-80.25192965299993,
							27.199829137000055
						],
						[
							-80.25163459899994,
							27.19976727100004
						],
						[
							-80.25155369799995,
							27.199986182000032
						],
						[
							-80.25141092999996,
							27.200000458000034
						],
						[
							-80.25120153699999,
							27.199838655000065
						],
						[
							-80.25094455599998,
							27.199762512000063
						],
						[
							-80.25080178799999,
							27.19967209300006
						],
						[
							-80.25071612699999,
							27.19961498600003
						],
						[
							-80.25039727999997,
							27.19951980700006
						],
						[
							-80.25021168199999,
							27.19951980700006
						],
						[
							-80.24982620899995,
							27.19941035200003
						],
						[
							-80.24912664699997,
							27.199243790000025
						],
						[
							-80.24878400499995,
							27.19910578100007
						],
						[
							-80.24867454999998,
							27.199067710000065
						],
						[
							-80.24834618399996,
							27.19906295100003
						],
						[
							-80.24832714899998,
							27.19912481700004
						],
						[
							-80.24796071199995,
							27.199120058000066
						],
						[
							-80.24793215799997,
							27.199058192000052
						],
						[
							-80.24746102499995,
							27.199058192000052
						],
						[
							-80.24732777499997,
							27.19901536100008
						],
						[
							-80.24637599099998,
							27.198996326000042
						],
						[
							-80.24610473199994,
							27.199053433000074
						],
						[
							-80.24540041199998,
							27.199315174000052
						],
						[
							-80.24439627899994,
							27.199648298000056
						],
						[
							-80.24410598499998,
							27.199795825000024
						],
						[
							-80.24401556499998,
							27.19995286900007
						],
						[
							-80.24399652999995,
							27.20003853000003
						],
						[
							-80.24363960999995,
							27.200281235000034
						],
						[
							-80.24262120099996,
							27.200971278000058
						],
						[
							-80.24263547799995,
							27.20100935000005
						],
						[
							-80.24257837099998,
							27.20105693900007
						],
						[
							-80.24232138899998,
							27.201128323000034
						],
						[
							-80.24213579099995,
							27.201128323000034
						],
						[
							-80.24199111999997,
							27.20108311300004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Martin",
				"City": "Stuart",
				"Name": "Old Historic Downtown",
				"RegionID": "762337"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.23291347599996,
					27.196043415000076,
					-80.215418,
					27.205803
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.216,
							27.196383
						],
						[
							-80.21605499499998,
							27.196043415000076
						],
						[
							-80.217863385,
							27.196209977000024
						],
						[
							-80.21988592699995,
							27.196566896000036
						],
						[
							-80.22195605799999,
							27.196971404000067
						],
						[
							-80.22410756699998,
							27.19742350200005
						],
						[
							-80.23242663799994,
							27.197494886000072
						],
						[
							-80.23191410199996,
							27.197839908000052
						],
						[
							-80.23191410199996,
							27.198232519000044
						],
						[
							-80.23230671399995,
							27.198815487000047
						],
						[
							-80.23268742699997,
							27.199434147000034
						],
						[
							-80.23286588699995,
							27.199838655000065
						],
						[
							-80.23291347599996,
							27.200338342000066
						],
						[
							-80.23287540499996,
							27.20103076500004
						],
						[
							-80.23209494099996,
							27.20103076500004
						],
						[
							-80.23161904899996,
							27.20013608800008
						],
						[
							-80.23104797899998,
							27.200288373000035
						],
						[
							-80.23045787199999,
							27.20066908700005
						],
						[
							-80.22914440999995,
							27.201773157000048
						],
						[
							-80.22904923099998,
							27.202001585000062
						],
						[
							-80.22855430399994,
							27.202382299000078
						],
						[
							-80.22838298199997,
							27.202382299000078
						],
						[
							-80.22724084099997,
							27.203410226000074
						],
						[
							-80.22602162899994,
							27.20419079800007
						],
						[
							-80.22468,
							27.204626
						],
						[
							-80.222953,
							27.205002
						],
						[
							-80.222391,
							27.205081
						],
						[
							-80.222111,
							27.205114
						],
						[
							-80.22197792699995,
							27.205126647000043
						],
						[
							-80.221931,
							27.205461
						],
						[
							-80.220616,
							27.205803
						],
						[
							-80.220612,
							27.205475
						],
						[
							-80.220584,
							27.203254
						],
						[
							-80.220176,
							27.203252
						],
						[
							-80.220181,
							27.201379000000003
						],
						[
							-80.220188,
							27.201015
						],
						[
							-80.220195,
							27.200605
						],
						[
							-80.220075,
							27.200599000000004
						],
						[
							-80.216457,
							27.200565
						],
						[
							-80.216249,
							27.200402
						],
						[
							-80.215445,
							27.199563
						],
						[
							-80.215418,
							27.199498
						],
						[
							-80.216841,
							27.198724
						],
						[
							-80.216925,
							27.198667
						],
						[
							-80.219497,
							27.198702
						],
						[
							-80.220037,
							27.198689
						],
						[
							-80.22002200000001,
							27.197373000000002
						],
						[
							-80.215967,
							27.197264
						],
						[
							-80.216,
							27.196383
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Martin",
				"City": "Stuart",
				"Name": "East Riverside",
				"RegionID": "762338"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.23258796599998,
					27.190111,
					-80.224064,
					27.197494886000072
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.22410756699998,
							27.19742350200005
						],
						[
							-80.224064,
							27.191623
						],
						[
							-80.224255,
							27.191615
						],
						[
							-80.224282,
							27.191042
						],
						[
							-80.224216,
							27.190111
						],
						[
							-80.22920461299998,
							27.19017084400008
						],
						[
							-80.22919009499998,
							27.19062776100003
						],
						[
							-80.22930430999997,
							27.19081335900006
						],
						[
							-80.22970405899997,
							27.19112744800003
						],
						[
							-80.22983254999997,
							27.191384430000028
						],
						[
							-80.22997531799996,
							27.19174134900004
						],
						[
							-80.22990393399994,
							27.192055438000068
						],
						[
							-80.22971833599996,
							27.192583678000062
						],
						[
							-80.22990393399994,
							27.192912044000025
						],
						[
							-80.23018946899998,
							27.19331179300008
						],
						[
							-80.23028940599994,
							27.193554498000026
						],
						[
							-80.23027512999994,
							27.194168399000034
						],
						[
							-80.23034651399996,
							27.194482488000062
						],
						[
							-80.23058921899997,
							27.194625256000055
						],
						[
							-80.23128877999994,
							27.194696640000075
						],
						[
							-80.23146010099998,
							27.194810854000025
						],
						[
							-80.23181701999994,
							27.195167773000037
						],
						[
							-80.23213110899997,
							27.195795951000036
						],
						[
							-80.23258796599998,
							27.196823878000032
						],
						[
							-80.23255941199994,
							27.197166520000053
						],
						[
							-80.23242663799994,
							27.197494886000072
						],
						[
							-80.22410756699998,
							27.19742350200005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Martin",
				"City": "Stuart",
				"Name": "St. Lucie Estates/Broadway",
				"RegionID": "762339"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.32951482799996,
					28.780393436000054,
					-81.32528887799998,
					28.78648563700006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.32633964799999,
							28.784630189000037
						],
						[
							-81.32634539399999,
							28.780545380000035
						],
						[
							-81.32685349299999,
							28.78094128700008
						],
						[
							-81.32734080699998,
							28.781261087000075
						],
						[
							-81.32778243499996,
							28.78121540100005
						],
						[
							-81.32854386199996,
							28.780773773000078
						],
						[
							-81.32943045999997,
							28.780393436000054
						],
						[
							-81.32951482799996,
							28.78647025600003
						],
						[
							-81.328752,
							28.786471
						],
						[
							-81.32535749499993,
							28.78648563700006
						],
						[
							-81.32528887799998,
							28.784630189000037
						],
						[
							-81.32633964799999,
							28.784630189000037
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Seminole",
				"City": "Lake Mary",
				"Name": "Tuscany at Lake Mary",
				"RegionID": "762971"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.34722865099997,
					28.777647899000044,
					-81.33985562099997,
					28.786661
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.342345,
							28.786661
						],
						[
							-81.342425,
							28.786428
						],
						[
							-81.33990364799996,
							28.786448755000038
						],
						[
							-81.33985562099997,
							28.782778810000025
						],
						[
							-81.34171873899999,
							28.783905723000032
						],
						[
							-81.34177013599998,
							28.783740112000036
						],
						[
							-81.34190148199997,
							28.783568791000054
						],
						[
							-81.34270669199998,
							28.782792135000083
						],
						[
							-81.34279806299998,
							28.782666499000072
						],
						[
							-81.34283803799997,
							28.782506600000033
						],
						[
							-81.34240973499999,
							28.782386675000055
						],
						[
							-81.34203853899999,
							28.78221535400007
						],
						[
							-81.34183866399997,
							28.782101139000076
						],
						[
							-81.34211848899997,
							28.78180989300006
						],
						[
							-81.34234120599996,
							28.781415855000038
						],
						[
							-81.34259247699998,
							28.780964709000045
						],
						[
							-81.34276950899994,
							28.780479299000035
						],
						[
							-81.34282759999996,
							28.780221524000066
						],
						[
							-81.34523371099995,
							28.780191067000032
						],
						[
							-81.34523371099995,
							28.778257041000074
						],
						[
							-81.34625402399996,
							28.778241812000033
						],
						[
							-81.34625402399996,
							28.777647899000044
						],
						[
							-81.34722865099997,
							28.777647899000044
						],
						[
							-81.34715200000001,
							28.786347
						],
						[
							-81.346844,
							28.786465
						],
						[
							-81.345677,
							28.786384000000005
						],
						[
							-81.345672,
							28.786330000000003
						],
						[
							-81.345191,
							28.786182
						],
						[
							-81.343941,
							28.785554999999995
						],
						[
							-81.343482,
							28.785501
						],
						[
							-81.343576,
							28.786230999999997
						],
						[
							-81.343542,
							28.786635
						],
						[
							-81.342345,
							28.786661
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Seminole",
				"City": "Lake Mary",
				"Name": "Bell Timacuan",
				"RegionID": "762972"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.33990364799996,
					28.77924729300003,
					-81.32941454699994,
					28.786751
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.335932,
							28.786631000000003
						],
						[
							-81.335931,
							28.786464
						],
						[
							-81.32951482799996,
							28.78647025600003
						],
						[
							-81.32943045999997,
							28.780393436000054
						],
						[
							-81.32941454699994,
							28.77924729300003
						],
						[
							-81.33237459599997,
							28.78147486500006
						],
						[
							-81.33449707499994,
							28.78147486500006
						],
						[
							-81.33449707499994,
							28.782835917000057
						],
						[
							-81.33985562099997,
							28.782778810000025
						],
						[
							-81.33990364799996,
							28.786448755000038
						],
						[
							-81.339388,
							28.786453000000005
						],
						[
							-81.33822,
							28.786464
						],
						[
							-81.338282,
							28.786606
						],
						[
							-81.337687,
							28.786751
						],
						[
							-81.336053,
							28.786703
						],
						[
							-81.335932,
							28.786631000000003
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Seminole",
				"City": "Lake Mary",
				"Name": "Hills of Lake Mary",
				"RegionID": "762973"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.32634726299995,
					28.77834841200007,
					-81.322028,
					28.786505000000002
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.32223282099994,
							28.778370944000077
						],
						[
							-81.32552492099995,
							28.77834841200007
						],
						[
							-81.32553253499998,
							28.779208825000065
						],
						[
							-81.32634726299995,
							28.779216439000038
						],
						[
							-81.32634539399999,
							28.780545380000035
						],
						[
							-81.32633964799999,
							28.784630189000037
						],
						[
							-81.32528887799998,
							28.784630189000037
						],
						[
							-81.32535749499993,
							28.78648563700006
						],
						[
							-81.323418,
							28.786494
						],
						[
							-81.322275,
							28.786505000000002
						],
						[
							-81.3222,
							28.785071
						],
						[
							-81.322097,
							28.784727
						],
						[
							-81.322028,
							28.778882
						],
						[
							-81.322234,
							28.778476
						],
						[
							-81.32223282099994,
							28.778370944000077
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Seminole",
				"City": "Lake Mary",
				"Name": "Reserve at Lake Mary",
				"RegionID": "762974"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.92741440499998,
					29.027626762000068,
					-80.90741931799994,
					29.04395176800006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.90829881199994,
							29.033221112000035
						],
						[
							-80.90983113999994,
							29.03237235900008
						],
						[
							-80.91394760799994,
							29.03134919100006
						],
						[
							-80.91694572899996,
							29.029683568000053
						],
						[
							-80.91804028099995,
							29.02808932900007
						],
						[
							-80.91960215899996,
							29.027916104000038
						],
						[
							-80.92114024199998,
							29.027626762000068
						],
						[
							-80.92182552699995,
							29.02815976100004
						],
						[
							-80.92229761199997,
							29.028647075000038
						],
						[
							-80.92316563999998,
							29.029652159000083
						],
						[
							-80.92372909599999,
							29.030428815000054
						],
						[
							-80.92420118099994,
							29.031190243000026
						],
						[
							-80.92477986599994,
							29.031738470000054
						],
						[
							-80.92583063599996,
							29.032743555000025
						],
						[
							-80.92675957799997,
							29.034205496000027
						],
						[
							-80.92741440499998,
							29.03578926500006
						],
						[
							-80.92636363499999,
							29.035972008000044
						],
						[
							-80.92470372299994,
							29.037205520000047
						],
						[
							-80.92375955299997,
							29.037601462000058
						],
						[
							-80.92292198299998,
							29.037692834000037
						],
						[
							-80.92188644099997,
							29.03744917700004
						],
						[
							-80.92139912799996,
							29.037159834000082
						],
						[
							-80.92054632899999,
							29.037692834000037
						],
						[
							-80.91964784399994,
							29.038423804000043
						],
						[
							-80.91885595999999,
							29.038697918000025
						],
						[
							-80.91847524599996,
							29.03811923300003
						],
						[
							-80.91818590399998,
							29.03764714800008
						],
						[
							-80.91765290399997,
							29.037631920000024
						],
						[
							-80.91716559099996,
							29.037571005000075
						],
						[
							-80.91743970499994,
							29.037388263000025
						],
						[
							-80.91757676199995,
							29.037205520000047
						],
						[
							-80.91747016199997,
							29.036992320000024
						],
						[
							-80.91692193399996,
							29.03702277700006
						],
						[
							-80.91641939199997,
							29.036931406000065
						],
						[
							-80.91567319299998,
							29.037418720000066
						],
						[
							-80.91506405099994,
							29.037966948000076
						],
						[
							-80.91498790799994,
							29.038454261000027
						],
						[
							-80.91480516499996,
							29.039352746000077
						],
						[
							-80.91447013699997,
							29.04055580100004
						],
						[
							-80.91411988099998,
							29.04136291400005
						],
						[
							-80.91357165299996,
							29.042078656000054
						],
						[
							-80.91244473999996,
							29.043129426000064
						],
						[
							-80.91183559799998,
							29.043677654000078
						],
						[
							-80.91122645599995,
							29.04395176800006
						],
						[
							-80.91044979999998,
							29.043936539000068
						],
						[
							-80.90991680099995,
							29.043586283000025
						],
						[
							-80.90965791499997,
							29.04326648300003
						],
						[
							-80.90904877299994,
							29.04325125500003
						],
						[
							-80.90808937499997,
							29.04306851200005
						],
						[
							-80.90741931799994,
							29.03920046000007
						],
						[
							-80.90775434699998,
							29.036687749000066
						],
						[
							-80.90780003199995,
							29.03466235200005
						],
						[
							-80.90829881199994,
							29.033221112000035
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Volusia",
				"City": "New Smyrna Beach",
				"Name": "North Causeway",
				"RegionID": "763104"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.91808786999997,
					29.023711121000073,
					-80.90408521799998,
					29.03482748700003
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.90434219999997,
							29.028831245000053
						],
						[
							-80.91765956699999,
							29.023711121000073
						],
						[
							-80.91808786999997,
							29.02599540300002
						],
						[
							-80.91804028099995,
							29.02808932900007
						],
						[
							-80.91694572899996,
							29.029683568000053
						],
						[
							-80.91394760799994,
							29.03134919100006
						],
						[
							-80.90983113999994,
							29.03237235900008
						],
						[
							-80.90829881199994,
							29.033221112000035
						],
						[
							-80.90539867999996,
							29.03482748700003
						],
						[
							-80.90531301999994,
							29.034056541000044
						],
						[
							-80.90477050199996,
							29.03291440000004
						],
						[
							-80.90445641399998,
							29.03242899000003
						],
						[
							-80.90419943199998,
							29.031857919000064
						],
						[
							-80.90408521799998,
							29.031286849000026
						],
						[
							-80.90414232499995,
							29.030258922000034
						],
						[
							-80.90434219999997,
							29.028831245000053
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Volusia",
				"City": "New Smyrna Beach",
				"Name": "South Causeway",
				"RegionID": "763105"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.90434219999997,
					28.992815,
					-80.866974,
					29.030161100000043
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.87649854699998,
							28.993000662000043
						],
						[
							-80.87908374499995,
							28.996963600000075
						],
						[
							-80.88230077599997,
							29.000561345000055
						],
						[
							-80.88279570399999,
							29.000466166000027
						],
						[
							-80.88327159599999,
							29.000542309000025
						],
						[
							-80.88424241599995,
							29.00099916600004
						],
						[
							-80.88479445099995,
							29.001227594000056
						],
						[
							-80.88523227199994,
							29.001170487000024
						],
						[
							-80.88528937899997,
							29.001893843000065
						],
						[
							-80.88572719999996,
							29.002655270000044
						],
						[
							-80.88637441399999,
							29.003321519000053
						],
						[
							-80.88723101999994,
							29.003568983000036
						],
						[
							-80.88745944799996,
							29.00351187600006
						],
						[
							-80.88780209,
							29.00362609000007
						],
						[
							-80.88829701799995,
							29.00351187600006
						],
						[
							-80.88875387499996,
							29.00385451900007
						],
						[
							-80.88915362399996,
							29.003911626000043
						],
						[
							-80.88940108799994,
							29.003797412000043
						],
						[
							-80.88951530199995,
							29.00396873300008
						],
						[
							-80.88999119399995,
							29.00410198300006
						],
						[
							-80.89227547699994,
							29.00722383600004
						],
						[
							-80.89267522599994,
							29.010821581000076
						],
						[
							-80.89888086099995,
							29.026259524000064
						],
						[
							-80.90264992699997,
							29.026906737000044
						],
						[
							-80.90261185499998,
							29.027534915000043
						],
						[
							-80.90339231899998,
							29.027972735000045
						],
						[
							-80.90434219999997,
							29.028831245000053
						],
						[
							-80.90359980799997,
							29.029116780000034
						],
						[
							-80.90268609499998,
							29.029288102000066
						],
						[
							-80.90177238199999,
							29.029145334000077
						],
						[
							-80.90065879399998,
							29.028859799000035
						],
						[
							-80.89968797399996,
							29.028717031000042
						],
						[
							-80.89317776799999,
							29.028745584000035
						],
						[
							-80.89008019499994,
							29.030161100000043
						],
						[
							-80.890031,
							29.030077999999996
						],
						[
							-80.88907500000002,
							29.028463
						],
						[
							-80.88812700000001,
							29.026852
						],
						[
							-80.887541,
							29.025856
						],
						[
							-80.887018,
							29.024966
						],
						[
							-80.886598,
							29.024252
						],
						[
							-80.886075,
							29.023362999999996
						],
						[
							-80.882975,
							29.018363000000004
						],
						[
							-80.880343,
							29.013996000000002
						],
						[
							-80.878834,
							29.011491999999997
						],
						[
							-80.878275,
							29.010563
						],
						[
							-80.877762,
							29.009778999999998
						],
						[
							-80.876753,
							29.008237000000005
						],
						[
							-80.875826,
							29.006820000000005
						],
						[
							-80.874785,
							29.005231
						],
						[
							-80.874109,
							29.004198
						],
						[
							-80.873382,
							29.003087
						],
						[
							-80.872974,
							29.002462999999995
						],
						[
							-80.871166,
							29.000215
						],
						[
							-80.871074,
							28.999863
						],
						[
							-80.866974,
							28.993264000000003
						],
						[
							-80.868174,
							28.993264000000003
						],
						[
							-80.869141,
							28.992842
						],
						[
							-80.870369,
							28.992826
						],
						[
							-80.871529,
							28.992815
						],
						[
							-80.872719,
							28.992826
						],
						[
							-80.873775,
							28.993064
						],
						[
							-80.87649854699998,
							28.993000662000043
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Volusia",
				"City": "New Smyrna Beach",
				"Name": "Coronado Beach",
				"RegionID": "763106"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.90539867999996,
					29.028717031000042,
					-80.89008019499994,
					29.045923389000055
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.90423354699999,
							29.04586629800008
						],
						[
							-80.90369688999994,
							29.045923389000055
						],
						[
							-80.89875485499995,
							29.045923389000055
						],
						[
							-80.897575,
							29.043662
						],
						[
							-80.897325,
							29.043161999999995
						],
						[
							-80.896575,
							29.041663
						],
						[
							-80.896375,
							29.041263
						],
						[
							-80.89576,
							29.040114
						],
						[
							-80.894875,
							29.038462999999997
						],
						[
							-80.894475,
							29.037696
						],
						[
							-80.893675,
							29.036163
						],
						[
							-80.891975,
							29.033363000000005
						],
						[
							-80.891137,
							29.031946000000005
						],
						[
							-80.890549,
							29.030953000000004
						],
						[
							-80.89008019499994,
							29.030161100000043
						],
						[
							-80.89317776799999,
							29.028745584000035
						],
						[
							-80.89968797399996,
							29.028717031000042
						],
						[
							-80.90065879399998,
							29.028859799000035
						],
						[
							-80.90177238199999,
							29.029145334000077
						],
						[
							-80.90268609499998,
							29.029288102000066
						],
						[
							-80.90359980799997,
							29.029116780000034
						],
						[
							-80.90434219999997,
							29.028831245000053
						],
						[
							-80.90414232499995,
							29.030258922000034
						],
						[
							-80.90408521799998,
							29.031286849000026
						],
						[
							-80.90419943199998,
							29.031857919000064
						],
						[
							-80.90445641399998,
							29.03242899000003
						],
						[
							-80.90477050199996,
							29.03291440000004
						],
						[
							-80.90531301999994,
							29.034056541000044
						],
						[
							-80.90539867999996,
							29.03482748700003
						],
						[
							-80.90477050199996,
							29.03768284000006
						],
						[
							-80.90488471699996,
							29.038225357000048
						],
						[
							-80.90471339499999,
							29.03873932100004
						],
						[
							-80.90425653899996,
							29.042194298000027
						],
						[
							-80.90419943199998,
							29.04456424100005
						],
						[
							-80.90422798499998,
							29.045849150000038
						],
						[
							-80.90423354699999,
							29.04586629800008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Volusia",
				"City": "New Smyrna Beach",
				"Name": "Central Beach",
				"RegionID": "763107"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.07783789399997,
					26.60169644100006,
					-80.06867652299997,
					26.612638
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.06867652299997,
							26.612570092000055
						],
						[
							-80.06868649999996,
							26.611153371000057
						],
						[
							-80.06871695699994,
							26.608899546000032
						],
						[
							-80.06896061299994,
							26.60471169400006
						],
						[
							-80.06900629899997,
							26.60169644100006
						],
						[
							-80.070898,
							26.601738
						],
						[
							-80.070963,
							26.602073
						],
						[
							-80.071024,
							26.602182
						],
						[
							-80.072809,
							26.603402
						],
						[
							-80.072813,
							26.603282
						],
						[
							-80.07327558899993,
							26.60334180800004
						],
						[
							-80.07319414999995,
							26.605305608000037
						],
						[
							-80.07514340499995,
							26.605366522000054
						],
						[
							-80.07512817599996,
							26.604346209000028
						],
						[
							-80.07585914699996,
							26.604239609000047
						],
						[
							-80.07595051799996,
							26.605366522000054
						],
						[
							-80.07783789399997,
							26.605539607000026
						],
						[
							-80.077822,
							26.605738
						],
						[
							-80.076948,
							26.605772
						],
						[
							-80.07609800000002,
							26.605765
						],
						[
							-80.075769,
							26.605754
						],
						[
							-80.075872,
							26.605543
						],
						[
							-80.07571,
							26.605544
						],
						[
							-80.075561,
							26.605544
						],
						[
							-80.073673,
							26.605544
						],
						[
							-80.073667,
							26.605802
						],
						[
							-80.073661,
							26.606778
						],
						[
							-80.073627,
							26.607139
						],
						[
							-80.076001,
							26.607152
						],
						[
							-80.076025,
							26.606845
						],
						[
							-80.076026,
							26.606719
						],
						[
							-80.07601600000001,
							26.606635
						],
						[
							-80.075997,
							26.606551
						],
						[
							-80.075866,
							26.606092
						],
						[
							-80.07692700000001,
							26.606122
						],
						[
							-80.077823,
							26.606148
						],
						[
							-80.077633,
							26.607283
						],
						[
							-80.076538,
							26.609258
						],
						[
							-80.076377,
							26.609493
						],
						[
							-80.076032,
							26.610314
						],
						[
							-80.075468,
							26.611166
						],
						[
							-80.075319,
							26.611355
						],
						[
							-80.074805,
							26.61175
						],
						[
							-80.07450100000001,
							26.611792
						],
						[
							-80.073284,
							26.612095
						],
						[
							-80.073151,
							26.612183
						],
						[
							-80.072432,
							26.612164
						],
						[
							-80.071515,
							26.612137
						],
						[
							-80.071351,
							26.612143
						],
						[
							-80.071186,
							26.612167
						],
						[
							-80.071026,
							26.612208
						],
						[
							-80.070873,
							26.612266
						],
						[
							-80.07072800000002,
							26.61234
						],
						[
							-80.070637,
							26.612398
						],
						[
							-80.070559,
							26.612456
						],
						[
							-80.070026,
							26.612638
						],
						[
							-80.06867652299997,
							26.612570092000055
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Lake Worth",
				"Name": "Lake Osborne",
				"RegionID": "763121"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.07783789399997,
					26.603026,
					-80.07319414999995,
					26.605539607000026
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.07327558899993,
							26.60334180800004
						],
						[
							-80.073687,
							26.603395
						],
						[
							-80.0741,
							26.603371
						],
						[
							-80.07454,
							26.603285
						],
						[
							-80.075062,
							26.603137000000004
						],
						[
							-80.075653,
							26.603051
						],
						[
							-80.076203,
							26.603026
						],
						[
							-80.076712,
							26.603198
						],
						[
							-80.077001,
							26.603518
						],
						[
							-80.077248,
							26.604023000000005
						],
						[
							-80.07751,
							26.604552
						],
						[
							-80.077707,
							26.605052
						],
						[
							-80.07783789399997,
							26.605539607000026
						],
						[
							-80.07595051799996,
							26.605366522000054
						],
						[
							-80.07585914699996,
							26.604239609000047
						],
						[
							-80.07512817599996,
							26.604346209000028
						],
						[
							-80.07514340499995,
							26.605366522000054
						],
						[
							-80.07319414999995,
							26.605305608000037
						],
						[
							-80.07327558899993,
							26.60334180800004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Lake Worth",
				"Name": "Murry Hills",
				"RegionID": "763122"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.06916935999999,
					26.594012100000043,
					-80.05332503699998,
					26.60169644100006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.06560934199997,
							26.601603435000072
						],
						[
							-80.05732600099998,
							26.601376642000048
						],
						[
							-80.05344272099995,
							26.59421922300004
						],
						[
							-80.05332503699998,
							26.594012100000043
						],
						[
							-80.053604,
							26.594074
						],
						[
							-80.056066,
							26.594125
						],
						[
							-80.058101,
							26.59418
						],
						[
							-80.065659,
							26.594228
						],
						[
							-80.067688,
							26.594242
						],
						[
							-80.068711,
							26.594274
						],
						[
							-80.06916,
							26.594583
						],
						[
							-80.06916935999999,
							26.59458971500004
						],
						[
							-80.06900629899997,
							26.60169644100006
						],
						[
							-80.06560934199997,
							26.601603435000072
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Lake Worth",
				"Name": "Whispering Palms",
				"RegionID": "763123"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.05263560699996,
					26.593951000000004,
					-80.04430769099997,
					26.60995983300006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.052612,
							26.593951000000004
						],
						[
							-80.05263560699996,
							26.594356280000056
						],
						[
							-80.05215210099999,
							26.60849789200006
						],
						[
							-80.05215210099999,
							26.60896617000003
						],
						[
							-80.05224347199999,
							26.609411606000037
						],
						[
							-80.05241862199995,
							26.60989326600003
						],
						[
							-80.05040462499994,
							26.609822776000048
						],
						[
							-80.04970791899996,
							26.60995983300006
						],
						[
							-80.04430769099997,
							26.609651669000073
						],
						[
							-80.044671,
							26.606074
						],
						[
							-80.045873,
							26.594181
						],
						[
							-80.048543,
							26.594081
						],
						[
							-80.052612,
							26.593951000000004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Lake Worth",
				"Name": "South Palm Park",
				"RegionID": "763124"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.55244058299996,
					28.302952532000063,
					-81.54890009299999,
					28.30708856700005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.54917991699995,
							28.30307245700004
						],
						[
							-81.54962535199996,
							28.302952532000063
						],
						[
							-81.55027066199995,
							28.302969664000045
						],
						[
							-81.55062851199995,
							28.30309728900005
						],
						[
							-81.55108729299997,
							28.303260910000063
						],
						[
							-81.55154986099996,
							28.303580710000062
						],
						[
							-81.55203527099997,
							28.303831981000034
						],
						[
							-81.55202384899997,
							28.30415749100007
						],
						[
							-81.55207524599997,
							28.30446586900007
						],
						[
							-81.55223514499994,
							28.30496841200005
						],
						[
							-81.55244058299996,
							28.30549598700003
						],
						[
							-81.55214548699996,
							28.305561564000072
						],
						[
							-81.55159345199996,
							28.306018420000044
						],
						[
							-81.55035613299998,
							28.306798883000056
						],
						[
							-81.54992922999999,
							28.30708856700005
						],
						[
							-81.54948258499996,
							28.30636753500005
						],
						[
							-81.54973385599999,
							28.30623618800007
						],
						[
							-81.54925986699999,
							28.305196840000065
						],
						[
							-81.54898575299995,
							28.304551530000026
						],
						[
							-81.54890009299999,
							28.304026145000023
						],
						[
							-81.54897433199994,
							28.303489339000066
						],
						[
							-81.54917991699995,
							28.30307245700004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Osceola",
				"City": "Celebration",
				"Name": "Roseville Corner",
				"RegionID": "763188"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.56103882599996,
					28.305314100000032,
					-81.54652995899994,
					28.319522337000024
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.54977839899999,
							28.313548938000054
						],
						[
							-81.54876189399994,
							28.312041312000076
						],
						[
							-81.54836214399995,
							28.31239537600004
						],
						[
							-81.54757025699996,
							28.313738577000038
						],
						[
							-81.54675838699995,
							28.313271017000037
						],
						[
							-81.54652995899994,
							28.312547661000053
						],
						[
							-81.54658706599997,
							28.31214791200006
						],
						[
							-81.54698681599996,
							28.311843341000042
						],
						[
							-81.54765306499996,
							28.310986735000032
						],
						[
							-81.54803377899998,
							28.30999687900004
						],
						[
							-81.54847159899998,
							28.309578094000074
						],
						[
							-81.54881424199993,
							28.309406773000035
						],
						[
							-81.54887134899997,
							28.30921641600003
						],
						[
							-81.54875713499996,
							28.308892809000042
						],
						[
							-81.54845256399996,
							28.30864534500006
						],
						[
							-81.54850967099998,
							28.308264631000043
						],
						[
							-81.54875713499996,
							28.307883918000073
						],
						[
							-81.54992922999999,
							28.30708856700005
						],
						[
							-81.55035613299998,
							28.306798883000056
						],
						[
							-81.55159345199996,
							28.306018420000044
						],
						[
							-81.55214548699996,
							28.305561564000072
						],
						[
							-81.55244058299996,
							28.30549598700003
						],
						[
							-81.55265945099995,
							28.305447349000076
						],
						[
							-81.55357316399994,
							28.305314100000032
						],
						[
							-81.55640948099995,
							28.306170706000046
						],
						[
							-81.55772294399998,
							28.30731284700005
						],
						[
							-81.55857955,
							28.309026059000075
						],
						[
							-81.55884604899995,
							28.310834449000026
						],
						[
							-81.55861223799997,
							28.31139114400003
						],
						[
							-81.55844629999996,
							28.311786234000067
						],
						[
							-81.55785619399995,
							28.312547661000053
						],
						[
							-81.55888779299994,
							28.31415017300003
						],
						[
							-81.56103882599996,
							28.31622506300005
						],
						[
							-81.55771628099997,
							28.319522337000024
						],
						[
							-81.55434696499998,
							28.317066733000047
						],
						[
							-81.55191420399996,
							28.315502
						],
						[
							-81.55113882099994,
							28.31499009700008
						],
						[
							-81.55073779799994,
							28.314725344000067
						],
						[
							-81.550395156,
							28.314428387000078
						],
						[
							-81.54977839899999,
							28.313548938000054
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Osceola",
				"City": "Celebration",
				"Name": "South Village",
				"RegionID": "763189"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.54631771099999,
					28.314462651000042,
					-81.54188653099999,
					28.317830378000053
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.54188653099999,
							28.31560780800004
						],
						[
							-81.54238874499998,
							28.314988036000045
						],
						[
							-81.54291412999999,
							28.314645394000024
						],
						[
							-81.54352522199997,
							28.314513266000063
						],
						[
							-81.54375931499999,
							28.314462651000042
						],
						[
							-81.54509561999998,
							28.31474818700008
						],
						[
							-81.54631771099999,
							28.314839558000077
						],
						[
							-81.54595222599994,
							28.315231693000044
						],
						[
							-81.54567811199996,
							28.315768500000047
						],
						[
							-81.54506135599996,
							28.317413183000042
						],
						[
							-81.54489003499998,
							28.317653033000056
						],
						[
							-81.54472110999995,
							28.317830378000053
						],
						[
							-81.54423901399997,
							28.317523590000064
						],
						[
							-81.54216412399995,
							28.31577230700003
						],
						[
							-81.54188653099999,
							28.31560780800004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Osceola",
				"City": "Celebration",
				"Name": "Lake Evalyn",
				"RegionID": "763190"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.55771628099997,
					28.312041312000076,
					-81.54472110999995,
					28.324071867000043
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.54472110999995,
							28.317830378000053
						],
						[
							-81.54489003499998,
							28.317653033000056
						],
						[
							-81.54506135599996,
							28.317413183000042
						],
						[
							-81.54567811199996,
							28.315768500000047
						],
						[
							-81.54595222599994,
							28.315231693000044
						],
						[
							-81.54631771099999,
							28.314839558000077
						],
						[
							-81.54669461799995,
							28.314531180000074
						],
						[
							-81.54704868199997,
							28.31427990900005
						],
						[
							-81.54745985299996,
							28.31392584500003
						],
						[
							-81.54757025699996,
							28.313738577000038
						],
						[
							-81.54836214399995,
							28.31239537600004
						],
						[
							-81.54876189399994,
							28.312041312000076
						],
						[
							-81.54977839899999,
							28.313548938000054
						],
						[
							-81.550395156,
							28.314428387000078
						],
						[
							-81.55073779799994,
							28.314725344000067
						],
						[
							-81.55113882099994,
							28.31499009700008
						],
						[
							-81.55191420399996,
							28.315502
						],
						[
							-81.55434696499998,
							28.317066733000047
						],
						[
							-81.55771628099997,
							28.319522337000024
						],
						[
							-81.55586981999994,
							28.32159722700004
						],
						[
							-81.55354746599994,
							28.324071867000043
						],
						[
							-81.55139643299998,
							28.323253332000036
						],
						[
							-81.55031139899995,
							28.322453833000054
						],
						[
							-81.54856011499999,
							28.32087387100006
						],
						[
							-81.54675172499998,
							28.319122588000027
						],
						[
							-81.54472110999995,
							28.317830378000053
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Osceola",
				"City": "Celebration",
				"Name": "West Village",
				"RegionID": "763191"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.130163,
					26.61887064900003,
					-80.121138,
					26.633699196000066
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.121138,
							26.633343
						],
						[
							-80.121399,
							26.626084
						],
						[
							-80.121427,
							26.625382
						],
						[
							-80.121454,
							26.624689
						],
						[
							-80.121461,
							26.624521
						],
						[
							-80.121472,
							26.624243
						],
						[
							-80.12168009699997,
							26.61887064900003
						],
						[
							-80.129362,
							26.619005
						],
						[
							-80.129361,
							26.619354
						],
						[
							-80.125761,
							26.619345
						],
						[
							-80.12574,
							26.620185000000003
						],
						[
							-80.126346,
							26.620117
						],
						[
							-80.127369,
							26.620637
						],
						[
							-80.127818,
							26.620634
						],
						[
							-80.12798,
							26.619644
						],
						[
							-80.129037,
							26.619644
						],
						[
							-80.129011,
							26.619951
						],
						[
							-80.12839,
							26.619968000000004
						],
						[
							-80.128392,
							26.620217
						],
						[
							-80.12938800000002,
							26.620368
						],
						[
							-80.129538,
							26.620383
						],
						[
							-80.12997,
							26.620446
						],
						[
							-80.129932,
							26.620045
						],
						[
							-80.130163,
							26.619015
						],
						[
							-80.13009862999996,
							26.62066571400004
						],
						[
							-80.13003010099999,
							26.621533742000054
						],
						[
							-80.12993872999995,
							26.623856096000054
						],
						[
							-80.12981563199997,
							26.626370456000075
						],
						[
							-80.12972045399994,
							26.628778471000032
						],
						[
							-80.12959672199997,
							26.631319735000034
						],
						[
							-80.129465,
							26.633699196000066
						],
						[
							-80.129465,
							26.63167
						],
						[
							-80.128936,
							26.63166
						],
						[
							-80.128884,
							26.631987
						],
						[
							-80.12887,
							26.632149
						],
						[
							-80.127898,
							26.632151
						],
						[
							-80.127929,
							26.631251
						],
						[
							-80.127453,
							26.631235
						],
						[
							-80.12746,
							26.631945000000005
						],
						[
							-80.126895,
							26.631941
						],
						[
							-80.126924,
							26.631218
						],
						[
							-80.126675,
							26.631213
						],
						[
							-80.126675,
							26.632333
						],
						[
							-80.12688,
							26.632333
						],
						[
							-80.126873,
							26.632501
						],
						[
							-80.126645,
							26.632503
						],
						[
							-80.126397,
							26.632503
						],
						[
							-80.126395,
							26.632616
						],
						[
							-80.126634,
							26.632628
						],
						[
							-80.126867,
							26.632642
						],
						[
							-80.12683700000001,
							26.633409
						],
						[
							-80.126536,
							26.63338
						],
						[
							-80.126129,
							26.633441000000005
						],
						[
							-80.125814,
							26.633405
						],
						[
							-80.125772,
							26.633403
						],
						[
							-80.12543,
							26.63338
						],
						[
							-80.124874,
							26.633345
						],
						[
							-80.124659,
							26.63334
						],
						[
							-80.12421,
							26.633348
						],
						[
							-80.123648,
							26.63336
						],
						[
							-80.123318,
							26.633342
						],
						[
							-80.12264,
							26.633302
						],
						[
							-80.12162,
							26.633357
						],
						[
							-80.121138,
							26.633343
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Greenacres",
				"Name": "Original Section",
				"RegionID": "763322"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.14166751599998,
					26.614315409000028,
					-80.13520304899998,
					26.61922069600007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.13898448899994,
							26.614475308000067
						],
						[
							-80.13920149599994,
							26.61434967300005
						],
						[
							-80.13960124499994,
							26.614315409000028
						],
						[
							-80.13974972399996,
							26.614441044000046
						],
						[
							-80.14014947299995,
							26.61436109400006
						],
						[
							-80.1404464299999,
							26.614406780000024
						],
						[
							-80.14075480799994,
							26.61433825100005
						],
						[
							-80.14104034299999,
							26.614406780000024
						],
						[
							-80.14166751599998,
							26.61440796000005
						],
						[
							-80.14164567799997,
							26.615446129000077
						],
						[
							-80.14155569099995,
							26.61811989800003
						],
						[
							-80.14150954599997,
							26.61922069600007
						],
						[
							-80.13529915299995,
							26.619149313000037
						],
						[
							-80.13531941899998,
							26.617203793000044
						],
						[
							-80.13520304899998,
							26.61720217100003
						],
						[
							-80.13520304899998,
							26.616516886000056
						],
						[
							-80.13654885599993,
							26.61511531900004
						],
						[
							-80.13781950499998,
							26.615057800000045
						],
						[
							-80.13898448899994,
							26.614475308000067
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Greenacres",
				"Name": "Colonial Coach Estates",
				"RegionID": "763323"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.818709,
					24.55856,
					-81.811005,
					24.564532
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.818709,
							24.56171
						],
						[
							-81.817548,
							24.562559
						],
						[
							-81.816194,
							24.563411000000002
						],
						[
							-81.815068,
							24.564353
						],
						[
							-81.813605,
							24.564487
						],
						[
							-81.813116,
							24.564532
						],
						[
							-81.81223700000001,
							24.564466
						],
						[
							-81.811867,
							24.564412
						],
						[
							-81.811603,
							24.564003
						],
						[
							-81.811005,
							24.562535
						],
						[
							-81.811287,
							24.560958
						],
						[
							-81.81148,
							24.559926
						],
						[
							-81.812043,
							24.559654
						],
						[
							-81.813717,
							24.559042
						],
						[
							-81.814013,
							24.558934
						],
						[
							-81.81522600000001,
							24.55856
						],
						[
							-81.81523631599998,
							24.55856933000007
						],
						[
							-81.818709,
							24.56171
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Monroe",
				"City": "Key West",
				"Name": "Sunset Key",
				"RegionID": "762130"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.16082521299995,
					25.899143667000033,
					-80.14229494899996,
					25.903369637000026
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.14285470099998,
							25.90162381300007
						],
						[
							-80.14326207599998,
							25.901089133000028
						],
						[
							-80.14229494899996,
							25.901213750000068
						],
						[
							-80.14236112499998,
							25.900619852000034
						],
						[
							-80.14353232899998,
							25.900390703000028
						],
						[
							-80.14377870499999,
							25.900387281000064
						],
						[
							-80.14672671699998,
							25.900227150000035
						],
						[
							-80.14800030799995,
							25.899987079000027
						],
						[
							-80.14823642399995,
							25.89993331000005
						],
						[
							-80.14917742099993,
							25.899719024000035
						],
						[
							-80.14969388399999,
							25.899601413000028
						],
						[
							-80.15188439999997,
							25.899487719000035
						],
						[
							-80.15492639899998,
							25.899329830000056
						],
						[
							-80.15705210399994,
							25.899219499000026
						],
						[
							-80.16011255199999,
							25.89915799000005
						],
						[
							-80.16082521299995,
							25.899143667000033
						],
						[
							-80.16048605599997,
							25.90020327800005
						],
						[
							-80.160385,
							25.900519
						],
						[
							-80.15897498199996,
							25.90056443900005
						],
						[
							-80.15871617199997,
							25.900571972000023
						],
						[
							-80.158678,
							25.900573
						],
						[
							-80.15824000000002,
							25.900585
						],
						[
							-80.1575,
							25.900609
						],
						[
							-80.156699,
							25.900636000000002
						],
						[
							-80.15663,
							25.900637
						],
						[
							-80.155839,
							25.900603
						],
						[
							-80.155057,
							25.900627
						],
						[
							-80.154311,
							25.900664
						],
						[
							-80.153561,
							25.900633
						],
						[
							-80.152364,
							25.90069
						],
						[
							-80.151605,
							25.900698
						],
						[
							-80.151751,
							25.900733
						],
						[
							-80.153052,
							25.900728
						],
						[
							-80.154772,
							25.900698
						],
						[
							-80.152772,
							25.900762
						],
						[
							-80.150961,
							25.900821
						],
						[
							-80.150512,
							25.900836
						],
						[
							-80.14675411399998,
							25.900976380000035
						],
						[
							-80.14544190199996,
							25.90153644700007
						],
						[
							-80.143328641,
							25.903369637000026
						],
						[
							-80.14243750799994,
							25.902987722000034
						],
						[
							-80.14256481199999,
							25.90191836200006
						],
						[
							-80.14285470099998,
							25.90162381300007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "North Miami",
				"Name": "Amber Creek East",
				"RegionID": "762146"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.16001898799999,
					26.94177748900006,
					-80.15038879599996,
					26.94888206400003
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.15127456,
							26.94187634700006
						],
						[
							-80.152435,
							26.94177748900006
						],
						[
							-80.152945,
							26.942311
						],
						[
							-80.153028,
							26.942418
						],
						[
							-80.153175,
							26.942606
						],
						[
							-80.153474,
							26.942959
						],
						[
							-80.153752,
							26.943263
						],
						[
							-80.154042,
							26.943558
						],
						[
							-80.15817,
							26.947177
						],
						[
							-80.158311,
							26.947297
						],
						[
							-80.16001898799999,
							26.94883751900005
						],
						[
							-80.15937072299994,
							26.94883820700005
						],
						[
							-80.15936498099997,
							26.948838894000062
						],
						[
							-80.15937592999995,
							26.94887
						],
						[
							-80.159338,
							26.94887
						],
						[
							-80.15864066499996,
							26.948870940000067
						],
						[
							-80.15785459999995,
							26.948872
						],
						[
							-80.15038879599996,
							26.94888206400003
						],
						[
							-80.15043502399999,
							26.941947868000057
						],
						[
							-80.15127456,
							26.94187634700006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Jupiter",
				"Name": "Loxahatchee Reserve",
				"RegionID": "762162"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.25939267299998,
					27.196237023000037,
					-80.25694841199999,
					27.201552263000053
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.25760080899994,
							27.20115700200006
						],
						[
							-80.25718635799996,
							27.199900442000057
						],
						[
							-80.25698648299993,
							27.199039077000066
						],
						[
							-80.25694841199999,
							27.19837758700004
						],
						[
							-80.25695317099996,
							27.197563811000066
						],
						[
							-80.25696028799996,
							27.197270827000068
						],
						[
							-80.25727257399996,
							27.197272089000023
						],
						[
							-80.25774489699997,
							27.197193567000056
						],
						[
							-80.25771158399994,
							27.197035333000034
						],
						[
							-80.25818985599994,
							27.196733141000042
						],
						[
							-80.25872166499994,
							27.196416673000044
						],
						[
							-80.25886205399996,
							27.196279854000068
						],
						[
							-80.25892689399996,
							27.196247136000068
						],
						[
							-80.25897507799993,
							27.19625011000005
						],
						[
							-80.25900125199996,
							27.196237023000037
						],
						[
							-80.25903813399998,
							27.196237023000037
						],
						[
							-80.25905359999996,
							27.196248921000063
						],
						[
							-80.25923562899999,
							27.19625130000003
						],
						[
							-80.25927964899995,
							27.196296510000025
						],
						[
							-80.25933318699998,
							27.196344099000044
						],
						[
							-80.25939267299998,
							27.196386929000028
						],
						[
							-80.25930106399994,
							27.19667127500003
						],
						[
							-80.259228491,
							27.196699829000067
						],
						[
							-80.25919993699995,
							27.196796197000026
						],
						[
							-80.25928559799998,
							27.19692944700006
						],
						[
							-80.25929749499994,
							27.19705317900008
						],
						[
							-80.25919041899994,
							27.19716263400005
						],
						[
							-80.25907739499996,
							27.19744222000003
						],
						[
							-80.25903456399999,
							27.197581419000073
						],
						[
							-80.25892748899997,
							27.197807468000065
						],
						[
							-80.25895723199994,
							27.197836021000057
						],
						[
							-80.25900601099994,
							27.197876472000075
						],
						[
							-80.25900006199998,
							27.197897887000067
						],
						[
							-80.25896912899998,
							27.197901456000068
						],
						[
							-80.25891963699996,
							27.197894080000026
						],
						[
							-80.25887966199997,
							27.197930248000034
						],
						[
							-80.25881113299995,
							27.198023523000074
						],
						[
							-80.25877115799996,
							27.198120605000042
						],
						[
							-80.25875973699993,
							27.198202458000026
						],
						[
							-80.25872356899998,
							27.198270987000058
						],
						[
							-80.25864932999997,
							27.198369972000023
						],
						[
							-80.25859793299998,
							27.198564136000073
						],
						[
							-80.25851607999994,
							27.198828732000038
						],
						[
							-80.25846277999995,
							27.198979114000053
						],
						[
							-80.25839805899994,
							27.199076196000078
						],
						[
							-80.25835427699997,
							27.199274167000056
						],
						[
							-80.25826100199998,
							27.199447392000025
						],
						[
							-80.25821341199998,
							27.199605388000066
						],
						[
							-80.25821341199998,
							27.199713892000034
						],
						[
							-80.25821388799994,
							27.199839052000076
						],
						[
							-80.25834,
							27.199846190000073
						],
						[
							-80.25833286099999,
							27.19987712300008
						],
						[
							-80.25834237899994,
							27.19991757400004
						],
						[
							-80.25831620499997,
							27.199958025000058
						],
						[
							-80.25826385699997,
							27.200015132000036
						],
						[
							-80.25824720099996,
							27.20007461800003
						],
						[
							-80.25825433899996,
							27.200517198000057
						],
						[
							-80.25825195999994,
							27.201552263000053
						],
						[
							-80.25760080899994,
							27.20115700200006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Martin",
				"City": "Stuart",
				"Name": "Frazier",
				"RegionID": "762344"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.25277483699995,
					27.193813780000028,
					-80.23647552899996,
					27.197573329000083
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.24198098599999,
							27.197541814000033
						],
						[
							-80.23647552899996,
							27.19752574000006
						],
						[
							-80.23654691299998,
							27.193813780000028
						],
						[
							-80.24911046699998,
							27.193873267000072
						],
						[
							-80.25277483699995,
							27.197573329000083
						],
						[
							-80.24198098599999,
							27.197541814000033
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Martin",
				"City": "Stuart",
				"Name": "Stypmann",
				"RegionID": "762345"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.24536519599997,
					27.181329,
					-80.236281,
					27.19025886600008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.24536519599997,
							27.19021603500005
						],
						[
							-80.23654215399995,
							27.19025886600008
						],
						[
							-80.23657600000001,
							27.182194
						],
						[
							-80.236544,
							27.182091
						],
						[
							-80.236341,
							27.181544
						],
						[
							-80.236281,
							27.181329
						],
						[
							-80.24536519599997,
							27.19021603500005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Martin",
				"City": "Stuart",
				"Name": "Eldorado Heights",
				"RegionID": "762346"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.266698,
					27.22705542400007,
					-80.25274104899995,
					27.24535257200006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.26096641499998,
							27.234434990000068
						],
						[
							-80.26087844199999,
							27.24535257200006
						],
						[
							-80.260835,
							27.245352000000004
						],
						[
							-80.257987,
							27.245314
						],
						[
							-80.25663221899998,
							27.24529535000005
						],
						[
							-80.25670285099994,
							27.236077846000057
						],
						[
							-80.25274104899995,
							27.236006462000034
						],
						[
							-80.25274104899995,
							27.233399958000064
						],
						[
							-80.25342219899994,
							27.22705542400007
						],
						[
							-80.26540399199996,
							27.227189673000055
						],
						[
							-80.26540820999998,
							27.227200895000067
						],
						[
							-80.266077,
							27.22898
						],
						[
							-80.26616,
							27.229198
						],
						[
							-80.266432,
							27.229916
						],
						[
							-80.266509,
							27.23012
						],
						[
							-80.266558,
							27.230254
						],
						[
							-80.266647,
							27.230495
						],
						[
							-80.266698,
							27.230627
						],
						[
							-80.26598274899999,
							27.230747853000025
						],
						[
							-80.26598221699999,
							27.231745871000044
						],
						[
							-80.26594652499995,
							27.232305044000046
						],
						[
							-80.26560150299997,
							27.232947499000034
						],
						[
							-80.26512614299997,
							27.233387699000048
						],
						[
							-80.26512614299997,
							27.23440032600007
						],
						[
							-80.26096641499998,
							27.234434990000068
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Martin",
				"City": "Stuart",
				"Name": "Windemere/The Pines",
				"RegionID": "762764"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.34714394199995,
					28.756159930000024,
					-81.33863498999995,
					28.75986046800006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.33864641099996,
							28.756262723000077
						],
						[
							-81.34714394199995,
							28.756159930000024
						],
						[
							-81.34712109899993,
							28.75986046800006
						],
						[
							-81.34482539499999,
							28.75986046800006
						],
						[
							-81.33863498999995,
							28.75986046800006
						],
						[
							-81.33864641099996,
							28.756262723000077
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Seminole",
				"City": "Lake Mary",
				"Name": "The Forest",
				"RegionID": "762979"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.32456476099998,
					28.756282710000054,
					-81.31390382399996,
					28.762647293000047
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.32211391599998,
							28.762647293000047
						],
						[
							-81.32210915699996,
							28.762157124000055
						],
						[
							-81.32162850599997,
							28.762157124000055
						],
						[
							-81.32162850599997,
							28.761738339000033
						],
						[
							-81.32005806199999,
							28.761738339000033
						],
						[
							-81.32005806199999,
							28.76084366100002
						],
						[
							-81.31807834999995,
							28.760848420000055
						],
						[
							-81.31807834999995,
							28.75992994800004
						],
						[
							-81.31683227399998,
							28.759933375000063
						],
						[
							-81.31606703899996,
							28.759933375000063
						],
						[
							-81.31447375199997,
							28.76075000600002
						],
						[
							-81.31398677399994,
							28.760922562000076
						],
						[
							-81.31396537799998,
							28.759873147000064
						],
						[
							-81.31390382399996,
							28.756368371000065
						],
						[
							-81.31740448699998,
							28.756374082000036
						],
						[
							-81.32025983999995,
							28.756345528000054
						],
						[
							-81.32188168099998,
							28.756282710000054
						],
						[
							-81.32413645799996,
							28.756284614000037
						],
						[
							-81.32414121699998,
							28.756722435000032
						],
						[
							-81.32456000199994,
							28.756736712000077
						],
						[
							-81.32456476099998,
							28.75858317300003
						],
						[
							-81.32444102899996,
							28.75858317300003
						],
						[
							-81.32444578799993,
							28.759415985000032
						],
						[
							-81.32415549399997,
							28.759415985000032
						],
						[
							-81.32415073499999,
							28.760006091000037
						],
						[
							-81.32410790399996,
							28.76065806300005
						],
						[
							-81.32404603799995,
							28.76076276000003
						],
						[
							-81.32395561899995,
							28.760838902000046
						],
						[
							-81.32377002099997,
							28.760848420000055
						],
						[
							-81.32263263899995,
							28.760829385000083
						],
						[
							-81.32263263899995,
							28.761267205000028
						],
						[
							-81.32414121699998,
							28.761281482000072
						],
						[
							-81.32407935099998,
							28.76264253400007
						],
						[
							-81.32211391599998,
							28.762647293000047
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Seminole",
				"City": "Lake Mary",
				"Name": "Downtown",
				"RegionID": "762980"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.975873,
					29.00513,
					-80.933719,
					29.021058527000037
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.975174,
							29.009974999999997
						],
						[
							-80.97537377299994,
							29.011143011000062
						],
						[
							-80.97538900099994,
							29.01312272200005
						],
						[
							-80.975873,
							29.013132000000002
						],
						[
							-80.975742,
							29.013764999999996
						],
						[
							-80.975516,
							29.013729
						],
						[
							-80.973916,
							29.013729
						],
						[
							-80.97391,
							29.014172
						],
						[
							-80.972066,
							29.014173000000003
						],
						[
							-80.97206,
							29.013732
						],
						[
							-80.970427,
							29.013732
						],
						[
							-80.968396,
							29.013883
						],
						[
							-80.967956,
							29.013278
						],
						[
							-80.967552,
							29.013285000000003
						],
						[
							-80.965302,
							29.013323
						],
						[
							-80.96715300000001,
							29.01601
						],
						[
							-80.96548622899996,
							29.01687836000008
						],
						[
							-80.963817,
							29.017748
						],
						[
							-80.963759,
							29.017447
						],
						[
							-80.96386,
							29.017108000000004
						],
						[
							-80.963989,
							29.016782
						],
						[
							-80.964032,
							29.016468
						],
						[
							-80.963748,
							29.016476999999995
						],
						[
							-80.96368736699998,
							29.013348636000046
						],
						[
							-80.963013,
							29.013359
						],
						[
							-80.96138800000001,
							29.013374
						],
						[
							-80.960632,
							29.01338
						],
						[
							-80.957222,
							29.013412000000002
						],
						[
							-80.956032,
							29.013424000000004
						],
						[
							-80.953682,
							29.013445000000004
						],
						[
							-80.952652,
							29.013454000000003
						],
						[
							-80.95238,
							29.013456000000005
						],
						[
							-80.952179,
							29.013458
						],
						[
							-80.950653,
							29.013481000000002
						],
						[
							-80.94951600000002,
							29.013502000000003
						],
						[
							-80.948326,
							29.013525
						],
						[
							-80.947151,
							29.013547999999997
						],
						[
							-80.947944,
							29.014798
						],
						[
							-80.948032,
							29.014937
						],
						[
							-80.947354,
							29.015217999999997
						],
						[
							-80.94738,
							29.016295000000003
						],
						[
							-80.946614,
							29.016295000000003
						],
						[
							-80.946622,
							29.016523
						],
						[
							-80.946622,
							29.016898
						],
						[
							-80.946493,
							29.01689
						],
						[
							-80.946497,
							29.017146
						],
						[
							-80.946493,
							29.01735
						],
						[
							-80.946496,
							29.017479
						],
						[
							-80.946083,
							29.017498
						],
						[
							-80.94608,
							29.017327000000005
						],
						[
							-80.946068,
							29.016875
						],
						[
							-80.945583,
							29.016797
						],
						[
							-80.945588,
							29.016966000000004
						],
						[
							-80.943692,
							29.016982000000002
						],
						[
							-80.94355,
							29.016926
						],
						[
							-80.943283,
							29.016729
						],
						[
							-80.94223,
							29.01545
						],
						[
							-80.941047,
							29.016091000000003
						],
						[
							-80.94092194099994,
							29.01615872400004
						],
						[
							-80.94034995399994,
							29.015331164000028
						],
						[
							-80.940437,
							29.015266000000004
						],
						[
							-80.938739,
							29.016243
						],
						[
							-80.938639,
							29.016612000000002
						],
						[
							-80.938712,
							29.017399000000005
						],
						[
							-80.93798800000002,
							29.01782
						],
						[
							-80.938433,
							29.017844
						],
						[
							-80.938405,
							29.018352
						],
						[
							-80.938926,
							29.018362
						],
						[
							-80.938919,
							29.018732
						],
						[
							-80.938876,
							29.020118000000004
						],
						[
							-80.938278,
							29.020121000000003
						],
						[
							-80.938248,
							29.02067
						],
						[
							-80.937256,
							29.020666000000002
						],
						[
							-80.937256,
							29.021058527000037
						],
						[
							-80.936692,
							29.021054000000003
						],
						[
							-80.93668805099998,
							29.02066351600007
						],
						[
							-80.93657,
							29.020663000000003
						],
						[
							-80.93626400000001,
							29.020662000000005
						],
						[
							-80.936113,
							29.020661
						],
						[
							-80.93617200000001,
							29.018461
						],
						[
							-80.936577,
							29.018146000000005
						],
						[
							-80.936703,
							29.018062000000004
						],
						[
							-80.936718,
							29.017890000000005
						],
						[
							-80.936493,
							29.017794999999996
						],
						[
							-80.936335,
							29.017932
						],
						[
							-80.936174,
							29.017654
						],
						[
							-80.934084,
							29.018072
						],
						[
							-80.93372059499995,
							29.018108442000024
						],
						[
							-80.933719,
							29.017890000000005
						],
						[
							-80.934079,
							29.017724000000005
						],
						[
							-80.936176,
							29.017411
						],
						[
							-80.937874,
							29.016967
						],
						[
							-80.937481,
							29.016941
						],
						[
							-80.937552,
							29.0163
						],
						[
							-80.937421,
							29.016342
						],
						[
							-80.936188,
							29.016739
						],
						[
							-80.936192,
							29.016057000000004
						],
						[
							-80.936771,
							29.016111
						],
						[
							-80.936745,
							29.015909999999998
						],
						[
							-80.937209,
							29.015902
						],
						[
							-80.937209,
							29.016150999999997
						],
						[
							-80.937323,
							29.016161
						],
						[
							-80.93734100000002,
							29.016193999999995
						],
						[
							-80.938272,
							29.015952999999996
						],
						[
							-80.938329,
							29.015777
						],
						[
							-80.93834000000001,
							29.014907000000004
						],
						[
							-80.93835,
							29.014083000000003
						],
						[
							-80.937287,
							29.014133
						],
						[
							-80.937345,
							29.013706
						],
						[
							-80.93672,
							29.013703999999997
						],
						[
							-80.936583,
							29.013703999999997
						],
						[
							-80.936957,
							29.012495
						],
						[
							-80.937096,
							29.012529
						],
						[
							-80.937487,
							29.012626000000004
						],
						[
							-80.937512,
							29.012228
						],
						[
							-80.937241,
							29.012142999999995
						],
						[
							-80.93708100000002,
							29.012093000000004
						],
						[
							-80.937227,
							29.011620999999998
						],
						[
							-80.936009,
							29.011571
						],
						[
							-80.935305,
							29.013738
						],
						[
							-80.93412908699997,
							29.013717179000025
						],
						[
							-80.93406204699994,
							29.011188352000033
						],
						[
							-80.93614059099997,
							29.011173413000055
						],
						[
							-80.936196,
							29.011006
						],
						[
							-80.937405,
							29.011045
						],
						[
							-80.937836,
							29.009649
						],
						[
							-80.937946,
							29.009785000000004
						],
						[
							-80.938396,
							29.009786000000002
						],
						[
							-80.938373,
							29.011166
						],
						[
							-80.938845,
							29.011155000000002
						],
						[
							-80.939113,
							29.011472
						],
						[
							-80.939604,
							29.011047
						],
						[
							-80.939742,
							29.010903
						],
						[
							-80.940001,
							29.010739000000004
						],
						[
							-80.941045,
							29.009886
						],
						[
							-80.943002,
							29.009973
						],
						[
							-80.94269,
							29.012211000000004
						],
						[
							-80.942506,
							29.013402
						],
						[
							-80.942877,
							29.013407
						],
						[
							-80.943031,
							29.013407
						],
						[
							-80.943225,
							29.013191
						],
						[
							-80.943459,
							29.0141
						],
						[
							-80.943846,
							29.013981999999995
						],
						[
							-80.943759,
							29.013842000000004
						],
						[
							-80.944387,
							29.013225999999996
						],
						[
							-80.943813,
							29.01254
						],
						[
							-80.945015,
							29.011206
						],
						[
							-80.947176,
							29.010062999999995
						],
						[
							-80.947676,
							29.010563
						],
						[
							-80.947676,
							29.011063
						],
						[
							-80.948276,
							29.011663
						],
						[
							-80.948876,
							29.011863
						],
						[
							-80.948942,
							29.011859999999995
						],
						[
							-80.949331,
							29.01184
						],
						[
							-80.949601,
							29.011831000000004
						],
						[
							-80.950318,
							29.011791
						],
						[
							-80.951432,
							29.012117
						],
						[
							-80.951976,
							29.012463
						],
						[
							-80.9523,
							29.012460000000004
						],
						[
							-80.952499,
							29.012771999999995
						],
						[
							-80.952514,
							29.012809
						],
						[
							-80.95318,
							29.012568000000005
						],
						[
							-80.952983,
							29.012282
						],
						[
							-80.95449700000002,
							29.011631
						],
						[
							-80.954646,
							29.011810000000004
						],
						[
							-80.954892,
							29.011702000000003
						],
						[
							-80.954391,
							29.010942
						],
						[
							-80.95414700000002,
							29.010569
						],
						[
							-80.953804,
							29.010052000000005
						],
						[
							-80.953377,
							29.009401
						],
						[
							-80.95254,
							29.008135999999997
						],
						[
							-80.953484,
							29.007675000000003
						],
						[
							-80.954373,
							29.007159
						],
						[
							-80.954877,
							29.007893
						],
						[
							-80.955746,
							29.007254000000003
						],
						[
							-80.955536,
							29.006872
						],
						[
							-80.95524971399999,
							29.00644850500004
						],
						[
							-80.954726,
							29.006760000000003
						],
						[
							-80.95437665299994,
							29.00627534600005
						],
						[
							-80.956524,
							29.00513
						],
						[
							-80.958974,
							29.009576
						],
						[
							-80.957794,
							29.010175
						],
						[
							-80.958531,
							29.011294
						],
						[
							-80.95941,
							29.012709
						],
						[
							-80.960198,
							29.012666000000003
						],
						[
							-80.960194,
							29.012487999999998
						],
						[
							-80.960688,
							29.012279
						],
						[
							-80.960904,
							29.012617
						],
						[
							-80.962483,
							29.01254
						],
						[
							-80.961853,
							29.011567000000003
						],
						[
							-80.9626,
							29.011583
						],
						[
							-80.962934,
							29.012187999999995
						],
						[
							-80.964231,
							29.01175
						],
						[
							-80.964535,
							29.012199000000003
						],
						[
							-80.966917,
							29.012358
						],
						[
							-80.966652,
							29.011972
						],
						[
							-80.966653,
							29.011856
						],
						[
							-80.96722,
							29.011557
						],
						[
							-80.96728000000002,
							29.006933
						],
						[
							-80.96818500000002,
							29.006765
						],
						[
							-80.967789,
							29.006245000000003
						],
						[
							-80.967987,
							29.006251
						],
						[
							-80.96893200000001,
							29.006282000000002
						],
						[
							-80.968948,
							29.00572
						],
						[
							-80.972436,
							29.005692000000003
						],
						[
							-80.97245,
							29.006519000000004
						],
						[
							-80.972496,
							29.006651000000005
						],
						[
							-80.972549,
							29.006720000000005
						],
						[
							-80.972585,
							29.006748999999996
						],
						[
							-80.972593,
							29.008912
						],
						[
							-80.973277,
							29.008912
						],
						[
							-80.973278,
							29.009998
						],
						[
							-80.975174,
							29.009974999999997
						]
					],
					[
						[
							-80.971517,
							29.011328
						],
						[
							-80.970673,
							29.009028
						],
						[
							-80.96955,
							29.009062999999998
						],
						[
							-80.96940500000001,
							29.009068
						],
						[
							-80.969619,
							29.010051
						],
						[
							-80.969854,
							29.011115000000004
						],
						[
							-80.96991,
							29.01137
						],
						[
							-80.971517,
							29.011328
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Volusia",
				"City": "New Smyrna Beach",
				"Name": "State Road 44 Corridor",
				"RegionID": "763096"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.958986,
					28.983886000000002,
					-80.944801,
					29.006363000000004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.944801,
							28.993374
						],
						[
							-80.949318,
							28.990839
						],
						[
							-80.950569,
							28.990137000000004
						],
						[
							-80.95086,
							28.989996
						],
						[
							-80.951163,
							28.990409
						],
						[
							-80.951538,
							28.990082000000005
						],
						[
							-80.952049,
							28.990777000000005
						],
						[
							-80.952843,
							28.990850999999996
						],
						[
							-80.952961,
							28.990305
						],
						[
							-80.951986,
							28.989795
						],
						[
							-80.951653,
							28.989980999999997
						],
						[
							-80.951538,
							28.990082000000005
						],
						[
							-80.951442,
							28.989951
						],
						[
							-80.950083,
							28.988520000000005
						],
						[
							-80.953796,
							28.988343000000004
						],
						[
							-80.953871,
							28.988722
						],
						[
							-80.954892,
							28.988357
						],
						[
							-80.954876,
							28.987074
						],
						[
							-80.9541,
							28.987074
						],
						[
							-80.954066,
							28.983886000000002
						],
						[
							-80.955001,
							28.983923
						],
						[
							-80.956884,
							28.983927000000005
						],
						[
							-80.957805,
							28.986079999999998
						],
						[
							-80.958168,
							28.986927
						],
						[
							-80.958313,
							28.987234
						],
						[
							-80.958558,
							28.98774
						],
						[
							-80.958578,
							28.989597
						],
						[
							-80.958232,
							28.989597
						],
						[
							-80.958034,
							28.989186000000004
						],
						[
							-80.957664,
							28.989294000000005
						],
						[
							-80.957219,
							28.988581000000003
						],
						[
							-80.956725,
							28.988927000000004
						],
						[
							-80.956395,
							28.989064
						],
						[
							-80.95644400000002,
							28.989119
						],
						[
							-80.956512,
							28.989243
						],
						[
							-80.956562,
							28.989414
						],
						[
							-80.955415,
							28.989640000000005
						],
						[
							-80.955489,
							28.990245000000005
						],
						[
							-80.956683,
							28.990158000000005
						],
						[
							-80.956779,
							28.990747
						],
						[
							-80.956806,
							28.990824
						],
						[
							-80.958025,
							28.990825
						],
						[
							-80.958614,
							28.990762999999998
						],
						[
							-80.958628,
							28.99174
						],
						[
							-80.958701,
							28.991735999999996
						],
						[
							-80.958986,
							28.998998000000004
						],
						[
							-80.957304,
							28.999063
						],
						[
							-80.95718,
							28.998739000000004
						],
						[
							-80.955028,
							28.999798
						],
						[
							-80.95535,
							29.000575999999995
						],
						[
							-80.95742,
							29.004650000000005
						],
						[
							-80.956524,
							29.00513
						],
						[
							-80.95437665299994,
							29.00627534600005
						],
						[
							-80.954212,
							29.006363000000004
						],
						[
							-80.953859,
							29.005849
						],
						[
							-80.954221,
							29.00566
						],
						[
							-80.953914,
							29.004631
						],
						[
							-80.954082,
							29.004469
						],
						[
							-80.953812,
							29.002889999999997
						],
						[
							-80.953306,
							29.002492000000004
						],
						[
							-80.953559,
							29.002329999999997
						],
						[
							-80.952581,
							29.000722
						],
						[
							-80.953309,
							29.000315
						],
						[
							-80.952768,
							28.999521000000005
						],
						[
							-80.952414,
							28.998991
						],
						[
							-80.95304409799996,
							28.99865469300005
						],
						[
							-80.951634,
							28.996695999999996
						],
						[
							-80.951376,
							28.996845999999998
						],
						[
							-80.951195,
							28.996935
						],
						[
							-80.95163,
							28.997856
						],
						[
							-80.951411,
							28.997977
						],
						[
							-80.951189,
							28.9976
						],
						[
							-80.951031,
							28.997712999999997
						],
						[
							-80.950701,
							28.997211
						],
						[
							-80.949879,
							28.99767
						],
						[
							-80.949595,
							28.997197999999997
						],
						[
							-80.950997,
							28.996509000000003
						],
						[
							-80.951462,
							28.996281
						],
						[
							-80.951197,
							28.99602
						],
						[
							-80.950803,
							28.996090999999996
						],
						[
							-80.950651,
							28.995765
						],
						[
							-80.951139,
							28.995533
						],
						[
							-80.951059,
							28.995419999999996
						],
						[
							-80.950006,
							28.993923
						],
						[
							-80.94856600000001,
							28.994639999999997
						],
						[
							-80.949685,
							28.996306
						],
						[
							-80.949346,
							28.996481999999997
						],
						[
							-80.94696,
							28.997718
						],
						[
							-80.945215,
							28.99478
						],
						[
							-80.945937,
							28.994394
						],
						[
							-80.945872,
							28.994234000000002
						],
						[
							-80.945107,
							28.993527
						],
						[
							-80.944801,
							28.993374
						]
					],
					[
						[
							-80.956774,
							28.994719
						],
						[
							-80.956132,
							28.99474
						],
						[
							-80.9567,
							28.995345
						],
						[
							-80.95754,
							28.995021000000005
						],
						[
							-80.95759,
							28.993984
						],
						[
							-80.956774,
							28.994719
						]
					],
					[
						[
							-80.953501,
							28.993301000000002
						],
						[
							-80.952303,
							28.991322999999998
						],
						[
							-80.951644,
							28.991633000000004
						],
						[
							-80.95189700000002,
							28.992135000000005
						],
						[
							-80.952218,
							28.992474
						],
						[
							-80.95242100000002,
							28.992769
						],
						[
							-80.952573,
							28.993434
						],
						[
							-80.953501,
							28.993301000000002
						]
					],
					[
						[
							-80.955341,
							28.991692999999998
						],
						[
							-80.955514,
							28.992276999999998
						],
						[
							-80.955638,
							28.992881999999998
						],
						[
							-80.957664,
							28.991996999999998
						],
						[
							-80.957507,
							28.991804999999996
						],
						[
							-80.956975,
							28.991151
						],
						[
							-80.955341,
							28.991692999999998
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Volusia",
				"City": "New Smyrna Beach",
				"Name": "Lake Waterford Estates",
				"RegionID": "763097"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.95991180699997,
					29.044532134000065,
					-80.93645614299999,
					29.063503577000063
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.94610220799996,
							29.044532134000065
						],
						[
							-80.948457,
							29.046374
						],
						[
							-80.94865527999997,
							29.046532856000056
						],
						[
							-80.951027,
							29.048433
						],
						[
							-80.95121249699997,
							29.04876995400008
						],
						[
							-80.95300185199994,
							29.049835953000073
						],
						[
							-80.95444856399996,
							29.050521238000048
						],
						[
							-80.95639020399994,
							29.051168451000027
						],
						[
							-80.95604756199998,
							29.05210120000004
						],
						[
							-80.95589527599998,
							29.052577092000035
						],
						[
							-80.95593334799997,
							29.052995877000058
						],
						[
							-80.95616177599999,
							29.053452734000075
						],
						[
							-80.95654248999995,
							29.053776340000066
						],
						[
							-80.95762752399997,
							29.054061876000052
						],
						[
							-80.95810341599997,
							29.054271268000036
						],
						[
							-80.95941687899995,
							29.055679909000048
						],
						[
							-80.95991180699997,
							29.056289051000082
						],
						[
							-80.94472132799996,
							29.063503577000063
						],
						[
							-80.94243704499996,
							29.060191367000073
						],
						[
							-80.94154236799994,
							29.058687548000023
						],
						[
							-80.94007661999996,
							29.055280160000056
						],
						[
							-80.93918194199995,
							29.053357555000048
						],
						[
							-80.93645614299999,
							29.04867309800005
						],
						[
							-80.93876490199996,
							29.047766298000056
						],
						[
							-80.94124810799997,
							29.046599410000056
						],
						[
							-80.94610220799996,
							29.044532134000065
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Volusia",
				"City": "New Smyrna Beach",
				"Name": "Airport Industrial",
				"RegionID": "763098"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.94965157099995,
					29.04867309800005,
					-80.92793073999997,
					29.070628999999997
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.93645614299999,
							29.04867309800005
						],
						[
							-80.93918194199995,
							29.053357555000048
						],
						[
							-80.94007661999996,
							29.055280160000056
						],
						[
							-80.94154236799994,
							29.058687548000023
						],
						[
							-80.94243704499996,
							29.060191367000073
						],
						[
							-80.94472132799996,
							29.063503577000063
						],
						[
							-80.94742439499998,
							29.067443964000066
						],
						[
							-80.94892821499997,
							29.069309462000035
						],
						[
							-80.94965157099995,
							29.070489674000044
						],
						[
							-80.94934049799997,
							29.070568465000065
						],
						[
							-80.94897,
							29.070628999999997
						],
						[
							-80.948276,
							29.070362
						],
						[
							-80.940876,
							29.070362
						],
						[
							-80.940376,
							29.070362
						],
						[
							-80.94011698199995,
							29.070370473000022
						],
						[
							-80.93594476499999,
							29.062480885000074
						],
						[
							-80.93447901699994,
							29.060729601000048
						],
						[
							-80.93343205399998,
							29.05991106700003
						],
						[
							-80.92806398999994,
							29.058331105000036
						],
						[
							-80.92793073999997,
							29.05699860600004
						],
						[
							-80.92806398999994,
							29.055875501000063
						],
						[
							-80.92821627599994,
							29.055342502000034
						],
						[
							-80.92871120399997,
							29.05515214500008
						],
						[
							-80.92949166699998,
							29.05528539500006
						],
						[
							-80.93040537999997,
							29.050831044000063
						],
						[
							-80.93581817799998,
							29.048923668000047
						],
						[
							-80.93645614299999,
							29.04867309800005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Volusia",
				"City": "New Smyrna Beach",
				"Name": "Inlet Shores",
				"RegionID": "763099"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.06849614299995,
					26.616629938000074,
					-80.05693448199997,
					26.62790287300004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.05731457899998,
							26.616629938000074
						],
						[
							-80.06415600599996,
							26.616835524000066
						],
						[
							-80.06469281199998,
							26.616824102000066
						],
						[
							-80.06528672599995,
							26.61669846700005
						],
						[
							-80.06849614299995,
							26.616778417000035
						],
						[
							-80.06834766399999,
							26.617749237000055
						],
						[
							-80.06769664399997,
							26.621198504000063
						],
						[
							-80.06751390099998,
							26.622660444000076
						],
						[
							-80.06741110799999,
							26.624156649000042
						],
						[
							-80.06738826599997,
							26.625492955000027
						],
						[
							-80.06741110799999,
							26.62666936000005
						],
						[
							-80.06749105799997,
							26.62790287300004
						],
						[
							-80.05693448199997,
							26.627607364000028
						],
						[
							-80.05725747199995,
							26.61812614400003
						],
						[
							-80.05731457899998,
							26.616629938000074
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Lake Worth",
				"Name": "Tropical Ridge",
				"RegionID": "763129"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.06902152799995,
					26.639347129000043,
					-80.06365666899995,
					26.646478
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.06877025699998,
							26.639347129000043
						],
						[
							-80.06897584199999,
							26.641414404000045
						],
						[
							-80.06902152799995,
							26.642305274000023
						],
						[
							-80.06895299899998,
							26.643161880000036
						],
						[
							-80.068378,
							26.646478
						],
						[
							-80.06791700000001,
							26.646377
						],
						[
							-80.066964,
							26.646144
						],
						[
							-80.064763,
							26.645144
						],
						[
							-80.06365666899995,
							26.645104115000038
						],
						[
							-80.06401894899994,
							26.63946134300005
						],
						[
							-80.06591490299996,
							26.63946134300005
						],
						[
							-80.06877025699998,
							26.639347129000043
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Lake Worth",
				"Name": "Vernon Heights",
				"RegionID": "763130"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.05731457899998,
					26.616492881000056,
					-80.05192367299998,
					26.631183039000064
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.05195698599994,
							26.631027818000064
						],
						[
							-80.05192367299998,
							26.63075822600007
						],
						[
							-80.05193509399999,
							26.630050099000073
						],
						[
							-80.05240337199996,
							26.616492881000056
						],
						[
							-80.05731457899998,
							26.616629938000074
						],
						[
							-80.05725747199995,
							26.61812614400003
						],
						[
							-80.05693448199997,
							26.627607364000028
						],
						[
							-80.05681267199998,
							26.631183039000064
						],
						[
							-80.05195698599994,
							26.631027818000064
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Lake Worth",
				"Name": "Mango Groves",
				"RegionID": "763131"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.05240337199996,
					26.61637866700005,
					-80.04802897099995,
					26.631027818000064
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.04838303499997,
							26.61637866700005
						],
						[
							-80.04853151299994,
							26.616390089000053
						],
						[
							-80.04899979099997,
							26.61641293200006
						],
						[
							-80.05240337199996,
							26.616492881000056
						],
						[
							-80.05193509399999,
							26.630050099000073
						],
						[
							-80.05192367299998,
							26.63075822600007
						],
						[
							-80.05195698599994,
							26.631027818000064
						],
						[
							-80.04897218899998,
							26.630932403000035
						],
						[
							-80.04899979099997,
							26.62981024900006
						],
						[
							-80.04802897099995,
							26.629741720000027
						],
						[
							-80.04821171299994,
							26.62367695000006
						],
						[
							-80.04877136299996,
							26.62367695000006
						],
						[
							-80.04893126199994,
							26.617635023000048
						],
						[
							-80.04836019199996,
							26.61762360100005
						],
						[
							-80.04838303499997,
							26.61637866700005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Lake Worth",
				"Name": "Parrot Cove",
				"RegionID": "763132"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.05681267199998,
					26.630932403000035,
					-80.04355405499996,
					26.638675486000068
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.04355405499996,
							26.638309897000056
						],
						[
							-80.043608,
							26.634498
						],
						[
							-80.04361018599997,
							26.634338011000068
						],
						[
							-80.04865809999995,
							26.63456631500003
						],
						[
							-80.04874851999995,
							26.632179240000028
						],
						[
							-80.04855816299994,
							26.63217448100005
						],
						[
							-80.04857243999999,
							26.631398777000072
						],
						[
							-80.04895791199993,
							26.631365465000048
						],
						[
							-80.04897218899998,
							26.630932403000035
						],
						[
							-80.05195698599994,
							26.631027818000064
						],
						[
							-80.05681267199998,
							26.631183039000064
						],
						[
							-80.05656901499998,
							26.638675486000068
						],
						[
							-80.04355405499996,
							26.638309897000056
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Lake Worth",
				"Name": "Eden Place",
				"RegionID": "763133"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.57040438399999,
					28.300311227000066,
					-81.56052194199998,
					28.312046312000064
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.56052194199998,
							28.309137082000063
						],
						[
							-81.56119111099997,
							28.30744961000005
						],
						[
							-81.56134339699997,
							28.30600289800003
						],
						[
							-81.56098171899998,
							28.303166581000028
						],
						[
							-81.56140050399995,
							28.301872154000023
						],
						[
							-81.56275203799999,
							28.300577727000075
						],
						[
							-81.56358960799997,
							28.300311227000066
						],
						[
							-81.564522357,
							28.30073001200003
						],
						[
							-81.5658204,
							28.301583192000066
						],
						[
							-81.56674934199998,
							28.302633962000073
						],
						[
							-81.57040438399999,
							28.30617421900007
						],
						[
							-81.56493266199999,
							28.312046312000064
						],
						[
							-81.56331359099994,
							28.31073707400003
						],
						[
							-81.56052194199998,
							28.309137082000063
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Osceola",
				"City": "Celebration",
				"Name": "Evander Square",
				"RegionID": "763183"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.14167994199994,
					26.604449,
					-80.13874463899998,
					26.608056474000023
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.138798,
							26.604449
						],
						[
							-80.140731,
							26.604495
						],
						[
							-80.14093681299994,
							26.60450007600008
						],
						[
							-80.14118882199995,
							26.60517827800004
						],
						[
							-80.14140582799998,
							26.606366105000063
						],
						[
							-80.14156572799999,
							26.606811540000024
						],
						[
							-80.14167994199994,
							26.607039969000027
						],
						[
							-80.14165709999997,
							26.607211290000066
						],
						[
							-80.14156572799999,
							26.607382611000048
						],
						[
							-80.14149719999995,
							26.60759961800005
						],
						[
							-80.14152004299996,
							26.608056474000023
						],
						[
							-80.13874463899998,
							26.607976525000026
						],
						[
							-80.138798,
							26.604449
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Greenacres",
				"Name": "The Rainbows",
				"RegionID": "763266"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.13830301099995,
					26.62168274800007,
					-80.13405043899996,
					26.624109230000045
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.13405043899996,
							26.62393604500005
						],
						[
							-80.13412870799993,
							26.62168274800007
						],
						[
							-80.13830301099995,
							26.621834505000038
						],
						[
							-80.13818738299994,
							26.624109230000045
						],
						[
							-80.13405043899996,
							26.62393604500005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Greenacres",
				"Name": "Villa Del Trio",
				"RegionID": "763330"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.14943100199997,
					26.621844430000067,
					-80.14636798499998,
					26.624943
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.14636798499998,
							26.624942058000045
						],
						[
							-80.14646545599999,
							26.622977399000035
						],
						[
							-80.14652135199998,
							26.621850749000032
						],
						[
							-80.14943100199997,
							26.621844430000067
						],
						[
							-80.149395,
							26.622835
						],
						[
							-80.149295,
							26.623562
						],
						[
							-80.149295,
							26.623650000000005
						],
						[
							-80.149334,
							26.624351
						],
						[
							-80.148752,
							26.624352
						],
						[
							-80.148558,
							26.624355
						],
						[
							-80.148562,
							26.624814
						],
						[
							-80.148468,
							26.624814
						],
						[
							-80.148439,
							26.624927
						],
						[
							-80.146425,
							26.624943
						],
						[
							-80.14636798499998,
							26.624942058000045
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Greenacres",
				"Name": "Ramblewood",
				"RegionID": "763331"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.15187296999994,
					26.62692947100004,
					-80.14752643699995,
					26.631916821000065
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.14930817699997,
							26.626967542000045
						],
						[
							-80.15083864599995,
							26.62692947100004
						],
						[
							-80.15187296999994,
							26.626935092000053
						],
						[
							-80.15187001399994,
							26.63126120800007
						],
						[
							-80.15165337399998,
							26.63124676500007
						],
						[
							-80.15103661799998,
							26.631140165000033
						],
						[
							-80.14971934799996,
							26.631163008000048
						],
						[
							-80.14927010599996,
							26.631208693000076
						],
						[
							-80.14894269199993,
							26.63133052200004
						],
						[
							-80.14810512199995,
							26.63176453600005
						],
						[
							-80.14782339299995,
							26.63187113500004
						],
						[
							-80.14752643699995,
							26.631916821000065
						],
						[
							-80.14764065099996,
							26.62698277100003
						],
						[
							-80.14930817699997,
							26.626967542000045
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Greenacres",
				"Name": "Park Pointe",
				"RegionID": "763332"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.13793497699999,
					26.628778471000032,
					-80.12959672199997,
					26.631709967000063
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.12959672199997,
							26.631319735000034
						],
						[
							-80.12972045399994,
							26.628778471000032
						],
						[
							-80.13383628199996,
							26.62886432700003
						],
						[
							-80.13793497699999,
							26.628949825000063
						],
						[
							-80.13782013899998,
							26.631100825000033
						],
						[
							-80.13722051499997,
							26.63107227100005
						],
						[
							-80.13720147899994,
							26.631709967000063
						],
						[
							-80.13675414099998,
							26.631690931000037
						],
						[
							-80.12959672199997,
							26.631319735000034
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Greenacres",
				"Name": "Pickwick Park",
				"RegionID": "763333"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-87.22167924399997,
					30.41682426500006,
					-87.20570889899994,
					30.447490107000082
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-87.21649761499998,
							30.417559265000076
						],
						[
							-87.22091836299995,
							30.43703652000005
						],
						[
							-87.22108587699995,
							30.437645662000083
						],
						[
							-87.22132953399995,
							30.438254804000053
						],
						[
							-87.22167924399997,
							30.43865738900007
						],
						[
							-87.22116147399998,
							30.439022875000035
						],
						[
							-87.22052673499996,
							30.439442884000076
						],
						[
							-87.21641502599994,
							30.44020431200005
						],
						[
							-87.21729066799999,
							30.444829984000027
						],
						[
							-87.21765234599997,
							30.445972125000026
						],
						[
							-87.21797595299996,
							30.446733553000055
						],
						[
							-87.21390231599999,
							30.44734269500003
						],
						[
							-87.21264213099994,
							30.447490107000082
						],
						[
							-87.21008373399997,
							30.43631235100003
						],
						[
							-87.20795173699997,
							30.42687065000007
						],
						[
							-87.20627659699994,
							30.419880745000057
						],
						[
							-87.20570889899994,
							30.417223303000075
						],
						[
							-87.20607862599996,
							30.417154835000076
						],
						[
							-87.20665731099996,
							30.41710914900005
						],
						[
							-87.20773853799994,
							30.417170063000075
						],
						[
							-87.20848473699995,
							30.417200520000048
						],
						[
							-87.20947459199994,
							30.41697209200004
						],
						[
							-87.21037307699999,
							30.416835035000076
						],
						[
							-87.21141989499995,
							30.41682426500006
						],
						[
							-87.21189593199995,
							30.417246206000073
						],
						[
							-87.21274873099998,
							30.418220833000078
						],
						[
							-87.21649761499998,
							30.417559265000076
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Escambia",
				"City": "Pensacola",
				"Name": "East Downtown",
				"RegionID": "764082"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.65512999999993,
					27.85017993100007,
					-82.64692999999994,
					27.85430000000008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.64694623799994,
							27.853957623000042
						],
						[
							-82.64694391599994,
							27.85374631500008
						],
						[
							-82.6469413929999,
							27.85351674200007
						],
						[
							-82.64693999999992,
							27.853390000000047
						],
						[
							-82.6469368519999,
							27.853103511000086
						],
						[
							-82.64693523699992,
							27.852956585000072
						],
						[
							-82.64693382099995,
							27.85282772100004
						],
						[
							-82.64693119999993,
							27.852589167000076
						],
						[
							-82.64692999999994,
							27.85248000000007
						],
						[
							-82.64692999999994,
							27.85228608500006
						],
						[
							-82.64692999999994,
							27.851964644000077
						],
						[
							-82.64692999999994,
							27.851725860000045
						],
						[
							-82.64692999999994,
							27.851570000000038
						],
						[
							-82.6469311379999,
							27.851468697000087
						],
						[
							-82.64693289299993,
							27.85131248500005
						],
						[
							-82.64693547299993,
							27.851082913000084
						],
						[
							-82.6469377439999,
							27.85088078700005
						],
						[
							-82.64693908499993,
							27.850761410000075
						],
						[
							-82.64693999999992,
							27.850680000000068
						],
						[
							-82.64693999999992,
							27.850531937000085
						],
						[
							-82.64693999999992,
							27.850403361000076
						],
						[
							-82.64693999999992,
							27.85017993100007
						],
						[
							-82.65073371799991,
							27.85022588000004
						],
						[
							-82.65102779299991,
							27.850271830000054
						],
						[
							-82.65128510799991,
							27.85029939900005
						],
						[
							-82.65193758599992,
							27.850271830000054
						],
						[
							-82.65220409199992,
							27.85029939900005
						],
						[
							-82.65284737999991,
							27.85029939900005
						],
						[
							-82.6536193259999,
							27.85028101900008
						],
						[
							-82.65412476699993,
							27.850290209000036
						],
						[
							-82.6550499999999,
							27.850308531000053
						],
						[
							-82.6550499999999,
							27.85055343600004
						],
						[
							-82.65505647299995,
							27.85137196100004
						],
						[
							-82.65505628199992,
							27.85195651300006
						],
						[
							-82.6550712319999,
							27.852514927000072
						],
						[
							-82.65512999999993,
							27.852750000000075
						],
						[
							-82.65511650099995,
							27.853055087000087
						],
						[
							-82.65510307499994,
							27.853358503000038
						],
						[
							-82.65508340699995,
							27.853802991000066
						],
						[
							-82.65508750199992,
							27.854003496000075
						],
						[
							-82.65303028199992,
							27.85403104800008
						],
						[
							-82.65048630899992,
							27.85393002400008
						],
						[
							-82.6491178899999,
							27.85396676000005
						],
						[
							-82.64883318599993,
							27.85430000000008
						],
						[
							-82.64855766499994,
							27.85430000000008
						],
						[
							-82.64830969699995,
							27.85430000000008
						],
						[
							-82.64807091199992,
							27.85430000000008
						],
						[
							-82.6477862079999,
							27.85430000000008
						],
						[
							-82.64757497499994,
							27.85430000000008
						],
						[
							-82.6473821109999,
							27.85430000000008
						],
						[
							-82.6470790379999,
							27.85430000000008
						],
						[
							-82.64699999999993,
							27.85430000000008
						],
						[
							-82.64694999999995,
							27.85430000000008
						],
						[
							-82.64694815599995,
							27.85413219900005
						],
						[
							-82.64694623799994,
							27.853957623000042
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Barclay Estates",
				"RegionID": "417202"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.62961698299995,
					27.872807987000044,
					-82.62515630999991,
					27.87499124300007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.6282591769999,
							27.87499124300007
						],
						[
							-82.62816347299992,
							27.874877594000054
						],
						[
							-82.62771485899992,
							27.874877594000054
						],
						[
							-82.62763709899991,
							27.874835723000047
						],
						[
							-82.62762513599996,
							27.87471011100007
						],
						[
							-82.6275593389999,
							27.874686185000087
						],
						[
							-82.62744568999994,
							27.874584499000036
						],
						[
							-82.62733204099993,
							27.874345239000036
						],
						[
							-82.62667407399994,
							27.874339257000088
						],
						[
							-82.6263027949999,
							27.874340448000055
						],
						[
							-82.6262459319999,
							27.874320195000053
						],
						[
							-82.62611744599991,
							27.874274433000043
						],
						[
							-82.6259821239999,
							27.874226236000087
						],
						[
							-82.62589304799991,
							27.874194510000052
						],
						[
							-82.62578237699995,
							27.87415509300007
						],
						[
							-82.62573999999995,
							27.874140000000068
						],
						[
							-82.62565721599992,
							27.87413586100007
						],
						[
							-82.6255435519999,
							27.874130178000087
						],
						[
							-82.62546001999993,
							27.874126001000036
						],
						[
							-82.62538782399992,
							27.87412239100007
						],
						[
							-82.62533966599995,
							27.87412401200004
						],
						[
							-82.62533999999994,
							27.87412000000006
						],
						[
							-82.62532193999994,
							27.87399237300008
						],
						[
							-82.62529906499992,
							27.873830723000083
						],
						[
							-82.62526789099991,
							27.87361043200008
						],
						[
							-82.62523802499993,
							27.87339938000008
						],
						[
							-82.62521360799991,
							27.873226832000057
						],
						[
							-82.62521324099993,
							27.873224235000066
						],
						[
							-82.62518999999992,
							27.873060000000066
						],
						[
							-82.6251818149999,
							27.872994520000077
						],
						[
							-82.62517362499995,
							27.872928999000067
						],
						[
							-82.62515630999991,
							27.872821774000045
						],
						[
							-82.62961698299995,
							27.872807987000044
						],
						[
							-82.62961100099994,
							27.874955354000065
						],
						[
							-82.6282591769999,
							27.87499124300007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Saint Petersburg",
				"Name": "Wyngate Townhomes",
				"RegionID": "417204"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.1760774309999,
					26.033138673000053,
					-80.16815288899994,
					26.040371116000074
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.1760774309999,
							26.040371116000074
						],
						[
							-80.16825670399993,
							26.040371116000074
						],
						[
							-80.16815288899994,
							26.03358853800006
						],
						[
							-80.16915643399996,
							26.033553933000064
						],
						[
							-80.17050602799993,
							26.033242488000045
						],
						[
							-80.17216706799991,
							26.033138673000053
						],
						[
							-80.17535072699991,
							26.033138673000053
						],
						[
							-80.1754891459999,
							26.03479971300004
						],
						[
							-80.17580059099993,
							26.036218517000066
						],
						[
							-80.17597361599991,
							26.037879557000053
						],
						[
							-80.1760774309999,
							26.040371116000074
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Hollywood",
				"Name": "TY Park",
				"RegionID": "623395"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.17635427099992,
					26.040371116000074,
					-80.16776799999991,
					26.047966000000088
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.16776799999991,
							26.047966000000088
						],
						[
							-80.16825670399993,
							26.04248202000008
						],
						[
							-80.16825670399993,
							26.040371116000074
						],
						[
							-80.1760774309999,
							26.040371116000074
						],
						[
							-80.1760774309999,
							26.040959401000066
						],
						[
							-80.17621585099994,
							26.04289728000009
						],
						[
							-80.17631966599993,
							26.045388839000054
						],
						[
							-80.17635427099992,
							26.047707373000037
						],
						[
							-80.17493599999995,
							26.04766600000005
						],
						[
							-80.17432799999995,
							26.04766600000005
						],
						[
							-80.17406799999992,
							26.04766600000005
						],
						[
							-80.1736719999999,
							26.04766600000005
						],
						[
							-80.17336799999993,
							26.04766600000005
						],
						[
							-80.1725679999999,
							26.04766600000005
						],
						[
							-80.1724079999999,
							26.04768400000006
						],
						[
							-80.17210299999994,
							26.04771800000009
						],
						[
							-80.1716679999999,
							26.04776600000008
						],
						[
							-80.17146799999995,
							26.04776600000008
						],
						[
							-80.16976799999992,
							26.04776600000008
						],
						[
							-80.16923899999995,
							26.047810000000084
						],
						[
							-80.1688059999999,
							26.04783100000009
						],
						[
							-80.16856799999994,
							26.04784200000006
						],
						[
							-80.16818899999993,
							26.04791300000005
						],
						[
							-80.16776799999991,
							26.047966000000088
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Hollywood",
				"Name": "Lake of Emerald Hills",
				"RegionID": "623402"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.1670109239999,
					25.99616800000007,
					-80.14846699999993,
					26.011464683000042
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.14907796499995,
							26.011464683000042
						],
						[
							-80.14861103599993,
							25.996623028000045
						],
						[
							-80.14846699999993,
							25.99656800000008
						],
						[
							-80.1487669999999,
							25.996668000000057
						],
						[
							-80.14896699999991,
							25.996668000000057
						],
						[
							-80.14996699999995,
							25.99656800000008
						],
						[
							-80.15086699999995,
							25.99656800000008
						],
						[
							-80.1519669999999,
							25.99646800000005
						],
						[
							-80.15296799999993,
							25.99646800000005
						],
						[
							-80.15406799999994,
							25.99646800000005
						],
						[
							-80.15506799999991,
							25.996368000000075
						],
						[
							-80.15596799999992,
							25.996368000000075
						],
						[
							-80.1571679999999,
							25.996368000000075
						],
						[
							-80.15816799999993,
							25.996368000000075
						],
						[
							-80.15916799999991,
							25.996268000000043
						],
						[
							-80.16097599999995,
							25.996268000000043
						],
						[
							-80.16296799999992,
							25.99616800000007
						],
						[
							-80.16517899999991,
							25.996214000000066
						],
						[
							-80.16524199999992,
							25.99620400000009
						],
						[
							-80.1659679999999,
							25.99616800000007
						],
						[
							-80.16607658999993,
							25.997530141000087
						],
						[
							-80.16618040499992,
							25.99853368500004
						],
						[
							-80.16649184999994,
							25.999779465000074
						],
						[
							-80.16680329499991,
							26.001336689000084
						],
						[
							-80.1669763189999,
							26.002444049000076
						],
						[
							-80.1670109239999,
							26.00379364300005
						],
						[
							-80.1669417139999,
							26.005385473000047
						],
						[
							-80.16680329499991,
							26.007115722000037
						],
						[
							-80.16676868999991,
							26.008638342000044
						],
						[
							-80.1668378999999,
							26.010887666000087
						],
						[
							-80.1605051869999,
							26.011095296000065
						],
						[
							-80.15794441799994,
							26.011199111000053
						],
						[
							-80.14907796499995,
							26.011464683000042
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Hollywood",
				"Name": "Highland Garden",
				"RegionID": "623404"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.14736221699991,
					25.859858704000093,
					-80.12440063999992,
					25.872806000000082
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.13820699999991,
							25.871563000000037
						],
						[
							-80.13792999999993,
							25.872430000000065
						],
						[
							-80.13441899999992,
							25.87172600000008
						],
						[
							-80.13339899999994,
							25.87177500000007
						],
						[
							-80.13179899999994,
							25.87196000000006
						],
						[
							-80.1315669999999,
							25.872212000000047
						],
						[
							-80.13148299999995,
							25.872191000000043
						],
						[
							-80.13141999999993,
							25.872183000000064
						],
						[
							-80.1311839999999,
							25.872178000000076
						],
						[
							-80.13088499999992,
							25.872186000000056
						],
						[
							-80.13088899999991,
							25.872293000000074
						],
						[
							-80.13084099999992,
							25.872296000000063
						],
						[
							-80.13082999999995,
							25.87219500000009
						],
						[
							-80.13063099999994,
							25.872197000000085
						],
						[
							-80.13017999999994,
							25.872223000000076
						],
						[
							-80.12981999999994,
							25.872236000000044
						],
						[
							-80.12976299999991,
							25.872247000000073
						],
						[
							-80.12971899999991,
							25.87228300000004
						],
						[
							-80.12969699999991,
							25.87230800000009
						],
						[
							-80.12968299999994,
							25.872381000000075
						],
						[
							-80.12970199999995,
							25.872806000000082
						],
						[
							-80.12953199999993,
							25.872801000000038
						],
						[
							-80.12953099999993,
							25.872715000000085
						],
						[
							-80.12951499999991,
							25.872429000000068
						],
						[
							-80.12948899999994,
							25.872335000000078
						],
						[
							-80.12947199999991,
							25.872303000000045
						],
						[
							-80.1294529999999,
							25.87228500000009
						],
						[
							-80.12941299999994,
							25.87226800000008
						],
						[
							-80.12932499999994,
							25.872254000000055
						],
						[
							-80.12747999999993,
							25.87233400000008
						],
						[
							-80.12492034099995,
							25.872445655000035
						],
						[
							-80.12488476099992,
							25.87244720700005
						],
						[
							-80.12466155599992,
							25.87167448100007
						],
						[
							-80.12440063999992,
							25.866977989000077
						],
						[
							-80.12771800299993,
							25.862840603000052
						],
						[
							-80.12809074099994,
							25.862169676000065
						],
						[
							-80.12809074099994,
							25.860604178000074
						],
						[
							-80.12913440599993,
							25.859858704000093
						],
						[
							-80.12958169099994,
							25.86045508300009
						],
						[
							-80.13084899799992,
							25.861647843000075
						],
						[
							-80.13271268499994,
							25.862318771000048
						],
						[
							-80.14736221699991,
							25.862201218000052
						],
						[
							-80.14577099999991,
							25.871651000000043
						],
						[
							-80.13820699999991,
							25.871563000000037
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Beach",
				"Name": "Biscayne Point",
				"RegionID": "623409"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.14172436499996,
					26.611517896000066,
					-80.130317,
					26.615183436000052
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.13326712399999,
							26.615182444000027
						],
						[
							-80.133296,
							26.613991
						],
						[
							-80.133306,
							26.613603
						],
						[
							-80.133299,
							26.613562
						],
						[
							-80.133277,
							26.613525
						],
						[
							-80.133244,
							26.613497
						],
						[
							-80.133201,
							26.61348
						],
						[
							-80.13178,
							26.613464
						],
						[
							-80.130578,
							26.613455
						],
						[
							-80.130534,
							26.613470000000003
						],
						[
							-80.130499,
							26.613497
						],
						[
							-80.130476,
							26.613533000000004
						],
						[
							-80.130317,
							26.613532
						],
						[
							-80.130465,
							26.611646
						],
						[
							-80.13045923499999,
							26.611517896000066
						],
						[
							-80.13863042499997,
							26.611642798000048
						],
						[
							-80.14172436499996,
							26.611705302000075
						],
						[
							-80.14166751599998,
							26.61440796000005
						],
						[
							-80.14104034299999,
							26.614406780000024
						],
						[
							-80.14075480799994,
							26.61433825100005
						],
						[
							-80.1404464299999,
							26.614406780000024
						],
						[
							-80.14014947299995,
							26.61436109400006
						],
						[
							-80.13974972399996,
							26.614441044000046
						],
						[
							-80.13960124499994,
							26.614315409000028
						],
						[
							-80.13920149599994,
							26.61434967300005
						],
						[
							-80.13898448899994,
							26.614475308000067
						],
						[
							-80.13781950499998,
							26.615057800000045
						],
						[
							-80.13654885599993,
							26.61511531900004
						],
						[
							-80.13504410099995,
							26.615183436000052
						],
						[
							-80.13326712399999,
							26.615182444000027
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Greenacres",
				"Name": "Chalet",
				"RegionID": "763324"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.146768,
					26.611705302000075,
					-80.14164567799997,
					26.615555
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.14166751599998,
							26.61440796000005
						],
						[
							-80.14172436499996,
							26.611705302000075
						],
						[
							-80.14202258499995,
							26.611711327000023
						],
						[
							-80.14446599499996,
							26.611767659000066
						],
						[
							-80.14598581499996,
							26.611802698000076
						],
						[
							-80.14668454099996,
							26.611844817000076
						],
						[
							-80.146671,
							26.612219
						],
						[
							-80.146671,
							26.612662
						],
						[
							-80.146044,
							26.612656
						],
						[
							-80.146044,
							26.612948
						],
						[
							-80.144891,
							26.612948
						],
						[
							-80.144909,
							26.613764
						],
						[
							-80.146768,
							26.613792
						],
						[
							-80.146721,
							26.615555
						],
						[
							-80.14489,
							26.615506000000003
						],
						[
							-80.14440919399993,
							26.61550270400005
						],
						[
							-80.143869,
							26.615499
						],
						[
							-80.14363393699995,
							26.615493410000056
						],
						[
							-80.14164567799997,
							26.615446129000077
						],
						[
							-80.14166751599998,
							26.61440796000005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Greenacres",
				"Name": "Chelsea Commons",
				"RegionID": "763325"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.14527445099998,
					26.659874582000047,
					-80.14305178799998,
					26.66278927600007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.14527445099998,
							26.659927090000053
						],
						[
							-80.14527445099998,
							26.66238269400003
						],
						[
							-80.144358406,
							26.662688756000023
						],
						[
							-80.14379685399996,
							26.662774417000037
						],
						[
							-80.14308969899997,
							26.66278927600007
						],
						[
							-80.143157,
							26.66167
						],
						[
							-80.14305178799998,
							26.661669235000033
						],
						[
							-80.14309776599998,
							26.659874582000047
						],
						[
							-80.14527445099998,
							26.659927090000053
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Greenacres",
				"Name": "Parkside Green",
				"RegionID": "763338"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.14532118399995,
					26.65794442200007,
					-80.14093431399994,
					26.659927090000053
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.14309776599998,
							26.659874582000047
						],
						[
							-80.14093431399994,
							26.65982239400006
						],
						[
							-80.14096323999996,
							26.65794442200007
						],
						[
							-80.143432,
							26.658018
						],
						[
							-80.143689,
							26.658025
						],
						[
							-80.14532118399995,
							26.658068667000066
						],
						[
							-80.14527445099998,
							26.659927090000053
						],
						[
							-80.14309776599998,
							26.659874582000047
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Greenacres",
				"Name": "Joggers Run",
				"RegionID": "763339"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.151281,
					26.66233510500007,
					-80.14524254599996,
					26.666081
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.148291,
							26.664668
						],
						[
							-80.148331,
							26.664
						],
						[
							-80.148021,
							26.663947
						],
						[
							-80.147505,
							26.663967
						],
						[
							-80.147303,
							26.664564
						],
						[
							-80.147291,
							26.66415
						],
						[
							-80.14529,
							26.663982
						],
						[
							-80.145296,
							26.663599
						],
						[
							-80.145301,
							26.663282
						],
						[
							-80.14524254599996,
							26.663279585000055
						],
						[
							-80.14527445099998,
							26.66238269400003
						],
						[
							-80.14695910999995,
							26.662373176000074
						],
						[
							-80.14696862799997,
							26.663324961000058
						],
						[
							-80.14892930299999,
							26.663315443000045
						],
						[
							-80.14915773199994,
							26.662839551000047
						],
						[
							-80.14914821399998,
							26.662354141000037
						],
						[
							-80.15018344299995,
							26.662340056000062
						],
						[
							-80.15054733699998,
							26.66233510500007
						],
						[
							-80.15057588999997,
							26.662906176000035
						],
						[
							-80.15117551499998,
							26.66289665800008
						],
						[
							-80.15119454999996,
							26.664191085000027
						],
						[
							-80.151281,
							26.664467
						],
						[
							-80.151276,
							26.665094
						],
						[
							-80.151276,
							26.666051
						],
						[
							-80.14918,
							26.66607
						],
						[
							-80.148017,
							26.666081
						],
						[
							-80.148309,
							26.66576
						],
						[
							-80.148291,
							26.664668
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Greenacres",
				"Name": "Dillman Farms",
				"RegionID": "763340"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.157395,
					26.662256,
					-80.15179417399997,
					26.666046467000058
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.153667,
							26.662292
						],
						[
							-80.157375,
							26.662256
						],
						[
							-80.157378,
							26.662546
						],
						[
							-80.157381,
							26.662747
						],
						[
							-80.157395,
							26.663958
						],
						[
							-80.154908,
							26.664183
						],
						[
							-80.155061,
							26.666018
						],
						[
							-80.152789,
							26.666038
						],
						[
							-80.152492,
							26.666041
						],
						[
							-80.151971,
							26.666045
						],
						[
							-80.15182281599994,
							26.666046467000058
						],
						[
							-80.15179417399997,
							26.66420060200005
						],
						[
							-80.15228910199994,
							26.664210120000064
						],
						[
							-80.15227958499997,
							26.66230655100003
						],
						[
							-80.153667,
							26.662292
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Greenacres",
				"Name": "Sagewood",
				"RegionID": "763341"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-87.21198730299994,
					30.408031000000005,
					-87.191822,
					30.419787505000045
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-87.20856,
							30.408081
						],
						[
							-87.20912433599995,
							30.408383190000055
						],
						[
							-87.20994667699995,
							30.408352733000072
						],
						[
							-87.21101267599994,
							30.40815476200004
						],
						[
							-87.21198730299994,
							30.41191621300004
						],
						[
							-87.20987053499994,
							30.412266470000077
						],
						[
							-87.21082993299996,
							30.416423864000027
						],
						[
							-87.21122587599996,
							30.416652293000027
						],
						[
							-87.21141989499995,
							30.41682426500006
						],
						[
							-87.21037307699999,
							30.416835035000076
						],
						[
							-87.20947459199994,
							30.41697209200004
						],
						[
							-87.20848473699995,
							30.417200520000048
						],
						[
							-87.20773853799994,
							30.417170063000075
						],
						[
							-87.20665731099996,
							30.41710914900005
						],
						[
							-87.20607862599996,
							30.417154835000076
						],
						[
							-87.20570889899994,
							30.417223303000075
						],
						[
							-87.20525628399997,
							30.417307120000036
						],
						[
							-87.19733743799998,
							30.418662461000054
						],
						[
							-87.19659123899999,
							30.41879951800007
						],
						[
							-87.19546432599998,
							30.419012718000033
						],
						[
							-87.19502269799995,
							30.419210689000064
						],
						[
							-87.19438309899994,
							30.419637089000048
						],
						[
							-87.19392624199999,
							30.419758917000028
						],
						[
							-87.19358703699999,
							30.419787505000045
						],
						[
							-87.19353,
							30.419658999999996
						],
						[
							-87.193727,
							30.419065000000003
						],
						[
							-87.193612,
							30.418845000000005
						],
						[
							-87.193352,
							30.418872000000004
						],
						[
							-87.193048,
							30.418713000000004
						],
						[
							-87.193289,
							30.418316999999995
						],
						[
							-87.19294,
							30.417772
						],
						[
							-87.192705,
							30.417601
						],
						[
							-87.19196741499997,
							30.41550602500007
						],
						[
							-87.191845,
							30.415167000000004
						],
						[
							-87.19183752099997,
							30.415137086000072
						],
						[
							-87.191822,
							30.415093000000002
						],
						[
							-87.191827,
							30.41508510700004
						],
						[
							-87.191827,
							30.415051000000002
						],
						[
							-87.191853,
							30.414993000000003
						],
						[
							-87.191896,
							30.414934
						],
						[
							-87.192013,
							30.414672
						],
						[
							-87.192016,
							30.414620000000003
						],
						[
							-87.191945,
							30.414532000000005
						],
						[
							-87.191935,
							30.414477
						],
						[
							-87.191943,
							30.414428
						],
						[
							-87.191978,
							30.414394999999995
						],
						[
							-87.192023,
							30.414393
						],
						[
							-87.192064,
							30.414408000000005
						],
						[
							-87.192089,
							30.414446
						],
						[
							-87.192117,
							30.414597
						],
						[
							-87.192182,
							30.414583000000004
						],
						[
							-87.192431,
							30.414596000000003
						],
						[
							-87.192496,
							30.414609
						],
						[
							-87.1926,
							30.414599000000003
						],
						[
							-87.192913,
							30.414502999999996
						],
						[
							-87.193172,
							30.414526
						],
						[
							-87.193249,
							30.414599000000003
						],
						[
							-87.19326372499995,
							30.414639224000044
						],
						[
							-87.193269,
							30.414642
						],
						[
							-87.19329821299993,
							30.414733436000063
						],
						[
							-87.193454,
							30.415159000000003
						],
						[
							-87.193668,
							30.415874
						],
						[
							-87.193976,
							30.416747000000004
						],
						[
							-87.194,
							30.416814000000002
						],
						[
							-87.19408,
							30.416902
						],
						[
							-87.194675,
							30.417353000000002
						],
						[
							-87.195014,
							30.41755
						],
						[
							-87.195331,
							30.417686
						],
						[
							-87.19585,
							30.417916
						],
						[
							-87.195878,
							30.417936000000005
						],
						[
							-87.195921,
							30.417951
						],
						[
							-87.196727,
							30.417816
						],
						[
							-87.19684,
							30.417809
						],
						[
							-87.19699,
							30.417809
						],
						[
							-87.19708500000002,
							30.417801000000004
						],
						[
							-87.19719,
							30.417780000000004
						],
						[
							-87.197847,
							30.417575000000003
						],
						[
							-87.198058,
							30.417472999999998
						],
						[
							-87.198729,
							30.417069000000005
						],
						[
							-87.198824,
							30.416999
						],
						[
							-87.199217,
							30.416701
						],
						[
							-87.199378,
							30.416545
						],
						[
							-87.199516,
							30.416395000000005
						],
						[
							-87.19987201399994,
							30.41590021700006
						],
						[
							-87.199071,
							30.414938999999997
						],
						[
							-87.198696,
							30.414642
						],
						[
							-87.198722,
							30.414383
						],
						[
							-87.198296,
							30.413882000000005
						],
						[
							-87.198347,
							30.413838000000002
						],
						[
							-87.198068,
							30.413453
						],
						[
							-87.198722,
							30.414102000000003
						],
						[
							-87.199013,
							30.414102000000003
						],
						[
							-87.199191,
							30.414245
						],
						[
							-87.19928826999995,
							30.414362950000054
						],
						[
							-87.199303,
							30.414358000000004
						],
						[
							-87.199362,
							30.414365
						],
						[
							-87.199403,
							30.414424000000004
						],
						[
							-87.199436,
							30.414552
						],
						[
							-87.199462,
							30.414599000000003
						],
						[
							-87.199482,
							30.414610999999997
						],
						[
							-87.199505,
							30.414625000000004
						],
						[
							-87.199567,
							30.414628000000004
						],
						[
							-87.199686,
							30.414615
						],
						[
							-87.199819,
							30.414567
						],
						[
							-87.200802,
							30.414057000000003
						],
						[
							-87.20150569999998,
							30.413348214000052
						],
						[
							-87.201603,
							30.413029
						],
						[
							-87.201533,
							30.412886000000004
						],
						[
							-87.20211100000002,
							30.411913
						],
						[
							-87.20284,
							30.411462000000004
						],
						[
							-87.203519,
							30.410889
						],
						[
							-87.203799,
							30.410778999999998
						],
						[
							-87.20372853599999,
							30.410888906000025
						],
						[
							-87.203917,
							30.410724
						],
						[
							-87.204864,
							30.410119000000005
						],
						[
							-87.205314,
							30.409663000000002
						],
						[
							-87.205759,
							30.409138
						],
						[
							-87.20635,
							30.408593
						],
						[
							-87.206928,
							30.40827
						],
						[
							-87.207156,
							30.40821
						],
						[
							-87.207309,
							30.408091
						],
						[
							-87.207472,
							30.408031000000005
						],
						[
							-87.207999,
							30.408081
						],
						[
							-87.20856,
							30.408081
						]
					],
					[
						[
							-87.203109,
							30.411431
						],
						[
							-87.20318628999996,
							30.41136337100005
						],
						[
							-87.202364,
							30.411973
						],
						[
							-87.201793,
							30.412842
						],
						[
							-87.20176060099999,
							30.41309146900005
						],
						[
							-87.202462,
							30.412385
						],
						[
							-87.202701,
							30.411952
						],
						[
							-87.202995,
							30.411553
						],
						[
							-87.203109,
							30.411431
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Escambia",
				"City": "Pensacola",
				"Name": "Baymarc",
				"RegionID": "764090"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-87.22219043199999,
					30.401204,
					-87.206405,
					30.418220833000078
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-87.21141989499995,
							30.41682426500006
						],
						[
							-87.21122587599996,
							30.416652293000027
						],
						[
							-87.21082993299996,
							30.416423864000027
						],
						[
							-87.20987053499994,
							30.412266470000077
						],
						[
							-87.21198730299994,
							30.41191621300004
						],
						[
							-87.21101267599994,
							30.40815476200004
						],
						[
							-87.20994667699995,
							30.408352733000072
						],
						[
							-87.20912433599995,
							30.408383190000055
						],
						[
							-87.20856,
							30.408081
						],
						[
							-87.20865400000001,
							30.407869
						],
						[
							-87.209239,
							30.407486
						],
						[
							-87.209807,
							30.40744
						],
						[
							-87.20991,
							30.407417999999996
						],
						[
							-87.210056,
							30.407414000000003
						],
						[
							-87.21015,
							30.407336999999995
						],
						[
							-87.21015637699998,
							30.40731361900004
						],
						[
							-87.21008100000002,
							30.406944
						],
						[
							-87.209891,
							30.406856
						],
						[
							-87.209319,
							30.406983
						],
						[
							-87.209059,
							30.406983
						],
						[
							-87.208774,
							30.406867000000002
						],
						[
							-87.20863380299994,
							30.40688657000004
						],
						[
							-87.208678,
							30.407097
						],
						[
							-87.208645,
							30.407146000000004
						],
						[
							-87.208602,
							30.407154
						],
						[
							-87.208546,
							30.407145
						],
						[
							-87.20850922599999,
							30.40690396000008
						],
						[
							-87.207549,
							30.407038000000004
						],
						[
							-87.206405,
							30.402192000000003
						],
						[
							-87.206494,
							30.402148
						],
						[
							-87.206437,
							30.402032
						],
						[
							-87.20773282199997,
							30.401815167000056
						],
						[
							-87.207669,
							30.401397
						],
						[
							-87.207834,
							30.401355999999996
						],
						[
							-87.207954,
							30.401376999999997
						],
						[
							-87.207996,
							30.401418
						],
						[
							-87.208035,
							30.401572999999996
						],
						[
							-87.208069,
							30.401633
						],
						[
							-87.208141,
							30.401667
						],
						[
							-87.209355,
							30.401463999999997
						],
						[
							-87.210031,
							30.401357
						],
						[
							-87.210826,
							30.401204
						],
						[
							-87.210899,
							30.401204
						],
						[
							-87.210924,
							30.401214000000003
						],
						[
							-87.21094266699998,
							30.401278056000027
						],
						[
							-87.21094467399996,
							30.401286292000066
						],
						[
							-87.211077,
							30.401749
						],
						[
							-87.211131,
							30.402078000000003
						],
						[
							-87.211203,
							30.402451000000003
						],
						[
							-87.21125200000002,
							30.402513
						],
						[
							-87.211287,
							30.402536
						],
						[
							-87.211368,
							30.402558
						],
						[
							-87.21142600000002,
							30.402629
						],
						[
							-87.211578,
							30.403201000000003
						],
						[
							-87.211627,
							30.403790000000004
						],
						[
							-87.211589,
							30.403864
						],
						[
							-87.211548,
							30.403867
						],
						[
							-87.211522,
							30.403852
						],
						[
							-87.211471,
							30.403778999999997
						],
						[
							-87.21144861799996,
							30.403782316000044
						],
						[
							-87.211496,
							30.404017
						],
						[
							-87.21150773899996,
							30.404042080000067
						],
						[
							-87.211632,
							30.404042999999998
						],
						[
							-87.211744,
							30.404058000000003
						],
						[
							-87.211835,
							30.404109
						],
						[
							-87.21189087699997,
							30.404179980000038
						],
						[
							-87.21199100000001,
							30.404259
						],
						[
							-87.212029,
							30.404479
						],
						[
							-87.21194,
							30.404595
						],
						[
							-87.211699,
							30.40465
						],
						[
							-87.21170871199996,
							30.404816931000028
						],
						[
							-87.211745,
							30.404985000000003
						],
						[
							-87.211765,
							30.405039999999996
						],
						[
							-87.211831,
							30.405274
						],
						[
							-87.21188,
							30.405506000000003
						],
						[
							-87.212035,
							30.405873000000003
						],
						[
							-87.212086,
							30.405912000000004
						],
						[
							-87.21216500000001,
							30.40594
						],
						[
							-87.212244,
							30.405962
						],
						[
							-87.212317,
							30.405962
						],
						[
							-87.212357,
							30.405947
						],
						[
							-87.21239,
							30.405911
						],
						[
							-87.21239361599999,
							30.40589949300005
						],
						[
							-87.21243613399997,
							30.405697030000052
						],
						[
							-87.21247000000001,
							30.405494999999995
						],
						[
							-87.21247000000001,
							30.405326348000074
						],
						[
							-87.21213,
							30.403709000000003
						],
						[
							-87.212154227,
							30.40366886900006
						],
						[
							-87.212153,
							30.403651999999997
						],
						[
							-87.212171,
							30.40359
						],
						[
							-87.212219,
							30.403517
						],
						[
							-87.212404,
							30.403225000000003
						],
						[
							-87.212542,
							30.402967
						],
						[
							-87.21254385199995,
							30.402953339000078
						],
						[
							-87.212339,
							30.402004
						],
						[
							-87.21237009599997,
							30.401999192000062
						],
						[
							-87.212371,
							30.401986
						],
						[
							-87.212418,
							30.401960999999996
						],
						[
							-87.2125,
							30.401951000000004
						],
						[
							-87.21255212299997,
							30.401971047000075
						],
						[
							-87.21301164899995,
							30.401899996000058
						],
						[
							-87.213026,
							30.401888000000003
						],
						[
							-87.213168,
							30.401822000000003
						],
						[
							-87.213309,
							30.401795000000003
						],
						[
							-87.213349,
							30.401843000000003
						],
						[
							-87.213385,
							30.402013
						],
						[
							-87.213563,
							30.402553000000005
						],
						[
							-87.213614,
							30.402645
						],
						[
							-87.213629,
							30.402693
						],
						[
							-87.213627,
							30.402766
						],
						[
							-87.213607,
							30.402800000000003
						],
						[
							-87.21358275799999,
							30.402811883000023
						],
						[
							-87.21359,
							30.40284
						],
						[
							-87.21338431899994,
							30.402910067000047
						],
						[
							-87.213414,
							30.403068999999995
						],
						[
							-87.213428,
							30.403078
						],
						[
							-87.213445,
							30.403074000000004
						],
						[
							-87.213468,
							30.403029000000004
						],
						[
							-87.213523,
							30.40297
						],
						[
							-87.21358,
							30.402951
						],
						[
							-87.214001,
							30.402868
						],
						[
							-87.214052,
							30.402868
						],
						[
							-87.214082,
							30.402876000000003
						],
						[
							-87.214098,
							30.402903000000002
						],
						[
							-87.214128,
							30.403008000000003
						],
						[
							-87.214144,
							30.403127
						],
						[
							-87.21412,
							30.403157
						],
						[
							-87.214063,
							30.403176
						],
						[
							-87.21363,
							30.403229
						],
						[
							-87.213507,
							30.403245
						],
						[
							-87.213483,
							30.403263999999997
						],
						[
							-87.213478,
							30.403284999999997
						],
						[
							-87.213498,
							30.403401
						],
						[
							-87.21351,
							30.403468000000004
						],
						[
							-87.213523,
							30.403491
						],
						[
							-87.213545,
							30.4035
						],
						[
							-87.213571,
							30.403495
						],
						[
							-87.21359600000001,
							30.403424
						],
						[
							-87.21362,
							30.403402000000003
						],
						[
							-87.213659,
							30.403385
						],
						[
							-87.214158,
							30.403292
						],
						[
							-87.214212,
							30.403305
						],
						[
							-87.214247,
							30.40334
						],
						[
							-87.214263,
							30.403408000000002
						],
						[
							-87.214228,
							30.403497
						],
						[
							-87.214176,
							30.403538
						],
						[
							-87.213701,
							30.403616000000003
						],
						[
							-87.21359400000001,
							30.403632
						],
						[
							-87.213569,
							30.403661000000003
						],
						[
							-87.213572,
							30.403712
						],
						[
							-87.213591,
							30.403764000000002
						],
						[
							-87.213612,
							30.403778999999997
						],
						[
							-87.213645,
							30.403781
						],
						[
							-87.213728,
							30.403766000000005
						],
						[
							-87.214023,
							30.403712
						],
						[
							-87.21406700000001,
							30.403738999999998
						],
						[
							-87.214115,
							30.403903
						],
						[
							-87.214165,
							30.404164
						],
						[
							-87.2142,
							30.404265
						],
						[
							-87.214216,
							30.404377000000004
						],
						[
							-87.21420957599997,
							30.404422681000028
						],
						[
							-87.214237,
							30.404545
						],
						[
							-87.21381499799998,
							30.40464397700004
						],
						[
							-87.213817,
							30.404675000000005
						],
						[
							-87.213838,
							30.404759
						],
						[
							-87.213879,
							30.404919000000003
						],
						[
							-87.213908,
							30.404941
						],
						[
							-87.213974,
							30.404948
						],
						[
							-87.214035,
							30.404934000000004
						],
						[
							-87.214088,
							30.404943000000003
						],
						[
							-87.214123,
							30.404987
						],
						[
							-87.214164,
							30.405076
						],
						[
							-87.214303,
							30.405474
						],
						[
							-87.214302,
							30.405546
						],
						[
							-87.214274,
							30.405568
						],
						[
							-87.21419,
							30.405602999999996
						],
						[
							-87.214168,
							30.405630000000002
						],
						[
							-87.214229,
							30.405914
						],
						[
							-87.214311,
							30.406098
						],
						[
							-87.214371,
							30.406188
						],
						[
							-87.214439,
							30.406231
						],
						[
							-87.21480600000001,
							30.406180000000003
						],
						[
							-87.214838,
							30.406173
						],
						[
							-87.214943,
							30.406147000000004
						],
						[
							-87.214998,
							30.406125
						],
						[
							-87.21501926599996,
							30.406107869000042
						],
						[
							-87.215031,
							30.406078999999995
						],
						[
							-87.214961,
							30.405881
						],
						[
							-87.21501640499997,
							30.405862976000037
						],
						[
							-87.214984,
							30.405747
						],
						[
							-87.214837,
							30.405264
						],
						[
							-87.21480600000001,
							30.405161
						],
						[
							-87.214829,
							30.405107
						],
						[
							-87.21482927499994,
							30.404902649000064
						],
						[
							-87.214612,
							30.40394
						],
						[
							-87.214694,
							30.40394
						],
						[
							-87.214643,
							30.403813
						],
						[
							-87.214745,
							30.403786
						],
						[
							-87.21465,
							30.403571000000003
						],
						[
							-87.214827,
							30.40356
						],
						[
							-87.214942,
							30.403714
						],
						[
							-87.216071,
							30.403972
						],
						[
							-87.216332,
							30.405249
						],
						[
							-87.2163,
							30.405447
						],
						[
							-87.216687,
							30.406002000000004
						],
						[
							-87.21683285699999,
							30.406097561000024
						],
						[
							-87.21701,
							30.406103
						],
						[
							-87.21703,
							30.406110000000005
						],
						[
							-87.217083,
							30.406129000000004
						],
						[
							-87.217251,
							30.406132000000003
						],
						[
							-87.217342,
							30.406164999999998
						],
						[
							-87.217397,
							30.406162
						],
						[
							-87.21741689399995,
							30.406155441000067
						],
						[
							-87.21732200000001,
							30.406068000000005
						],
						[
							-87.21731537399995,
							30.405989183000028
						],
						[
							-87.217302,
							30.405892
						],
						[
							-87.217302,
							30.405830000000005
						],
						[
							-87.217382,
							30.405622
						],
						[
							-87.21745834399997,
							30.405492215000034
						],
						[
							-87.21755487799999,
							30.405274851000055
						],
						[
							-87.217568,
							30.405222
						],
						[
							-87.217593,
							30.404987
						],
						[
							-87.21760977999998,
							30.404833178000047
						],
						[
							-87.21761731899994,
							30.40454314300007
						],
						[
							-87.217521,
							30.404067000000005
						],
						[
							-87.21748404499994,
							30.403865142000033
						],
						[
							-87.217309,
							30.403125000000003
						],
						[
							-87.218546,
							30.402872
						],
						[
							-87.21899,
							30.402651
						],
						[
							-87.219644,
							30.402508000000005
						],
						[
							-87.21970401899995,
							30.40271193900003
						],
						[
							-87.21974,
							30.402706
						],
						[
							-87.219792,
							30.402712000000005
						],
						[
							-87.219866,
							30.402947000000005
						],
						[
							-87.22005,
							30.403687000000005
						],
						[
							-87.220509,
							30.404319
						],
						[
							-87.22104600000002,
							30.404457
						],
						[
							-87.221211,
							30.404424
						],
						[
							-87.221235,
							30.404399
						],
						[
							-87.221247,
							30.404322
						],
						[
							-87.221243,
							30.404197000000003
						],
						[
							-87.22128802399999,
							30.404171674000054
						],
						[
							-87.221282,
							30.403927
						],
						[
							-87.22134404899998,
							30.40416743700007
						],
						[
							-87.221498,
							30.404160000000005
						],
						[
							-87.221538,
							30.404197000000003
						],
						[
							-87.221582,
							30.404277999999998
						],
						[
							-87.22163,
							30.404322
						],
						[
							-87.22171544499997,
							30.404347134000037
						],
						[
							-87.22208002499997,
							30.406028475000024
						],
						[
							-87.22059524099996,
							30.406256903000042
						],
						[
							-87.22188014999995,
							30.41179628900005
						],
						[
							-87.22219043199999,
							30.413134497000044
						],
						[
							-87.21847466599996,
							30.413774097000044
						],
						[
							-87.21922086499995,
							30.41707869200008
						],
						[
							-87.21649761499998,
							30.417559265000076
						],
						[
							-87.21274873099998,
							30.418220833000078
						],
						[
							-87.21189593199995,
							30.417246206000073
						],
						[
							-87.21141989499995,
							30.41682426500006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Escambia",
				"City": "Pensacola",
				"Name": "Downtown",
				"RegionID": "764091"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-87.23646616699995,
					30.439022875000035,
					-87.21264213099994,
					30.469052973000032
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-87.21264213099994,
							30.447490107000082
						],
						[
							-87.21390231599999,
							30.44734269500003
						],
						[
							-87.21797595299996,
							30.446733553000055
						],
						[
							-87.21765234599997,
							30.445972125000026
						],
						[
							-87.21729066799999,
							30.444829984000027
						],
						[
							-87.21641502599994,
							30.44020431200005
						],
						[
							-87.22052673499996,
							30.439442884000076
						],
						[
							-87.22116147399998,
							30.439022875000035
						],
						[
							-87.22435946899998,
							30.445799580000028
						],
						[
							-87.22569958199995,
							30.445540694000048
						],
						[
							-87.22719197999999,
							30.445007695000076
						],
						[
							-87.23646616699995,
							30.455576309000037
						],
						[
							-87.23224785799994,
							30.458363134000024
						],
						[
							-87.23038997499998,
							30.459901217000038
						],
						[
							-87.22770594299999,
							30.46094818000006
						],
						[
							-87.22858919899994,
							30.46286697700003
						],
						[
							-87.23009682599996,
							30.462273064000044
						],
						[
							-87.23101053899995,
							30.464511661000074
						],
						[
							-87.22973134099999,
							30.465044660000046
						],
						[
							-87.23038616799994,
							30.466339087000048
						],
						[
							-87.22712725799994,
							30.467557371000055
						],
						[
							-87.22469068999999,
							30.468486313000028
						],
						[
							-87.22443021899994,
							30.466654477000077
						],
						[
							-87.21931342599999,
							30.468653224000033
						],
						[
							-87.21829691999994,
							30.468961602000036
						],
						[
							-87.21769158499995,
							30.469052973000032
						],
						[
							-87.21388825499997,
							30.468995866000057
						],
						[
							-87.21474486099999,
							30.456923433000043
						],
						[
							-87.21474486099999,
							30.45651226200005
						],
						[
							-87.21465348899994,
							30.456009720000054
						],
						[
							-87.21337429099998,
							30.450447492000023
						],
						[
							-87.21308875599999,
							30.44951093600002
						],
						[
							-87.21264213099994,
							30.447490107000082
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Escambia",
				"City": "Pensacola",
				"Name": "Eastmount",
				"RegionID": "764083"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-87.20218267699994,
					30.458526999000068,
					-87.17597425599996,
					30.492498334000064
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-87.18716095899998,
							30.458526999000068
						],
						[
							-87.18936023799995,
							30.461410068000077
						],
						[
							-87.19042623599995,
							30.46244561000003
						],
						[
							-87.19137040599998,
							30.463069980000057
						],
						[
							-87.19274097599998,
							30.463679122000027
						],
						[
							-87.19487297299999,
							30.464547150000044
						],
						[
							-87.19992885199997,
							30.466861889000032
						],
						[
							-87.20061413599996,
							30.467288289000066
						],
						[
							-87.20110144999995,
							30.467638546000046
						],
						[
							-87.20146693499998,
							30.46812585900005
						],
						[
							-87.20183242,
							30.46847611600003
						],
						[
							-87.20218267699994,
							30.468582716000075
						],
						[
							-87.20157353499997,
							30.470714713000064
						],
						[
							-87.20123850699997,
							30.471460912000058
						],
						[
							-87.20082733599997,
							30.47211573900006
						],
						[
							-87.19921173899996,
							30.474809365000056
						],
						[
							-87.19738431299999,
							30.47781319700005
						],
						[
							-87.19725867799997,
							30.478212946000042
						],
						[
							-87.19716730599998,
							30.478658381000063
						],
						[
							-87.19705309199999,
							30.481547999000043
						],
						[
							-87.19543125199993,
							30.48081702800005
						],
						[
							-87.19474596699996,
							30.48056575700008
						],
						[
							-87.19435763899997,
							30.48119393500008
						],
						[
							-87.19335255399994,
							30.48102261400004
						],
						[
							-87.19335255399994,
							30.48200485500007
						],
						[
							-87.19269011199998,
							30.48194774800004
						],
						[
							-87.19263300499995,
							30.48321552500005
						],
						[
							-87.192610163,
							30.48428913800006
						],
						[
							-87.19270153399998,
							30.484574673000054
						],
						[
							-87.19299849099997,
							30.485773922000078
						],
						[
							-87.19322691899998,
							30.486253621000063
						],
						[
							-87.19414063199997,
							30.48737291900005
						],
						[
							-87.19455180299997,
							30.487955412000076
						],
						[
							-87.19474596699996,
							30.488617853000054
						],
						[
							-87.19481449499995,
							30.48891481000004
						],
						[
							-87.19474596699996,
							30.489234610000036
						],
						[
							-87.19474596699996,
							30.489497302000075
						],
						[
							-87.19487160199998,
							30.489680045000057
						],
						[
							-87.19530581699996,
							30.489958641000044
						],
						[
							-87.19343664499996,
							30.491621304000034
						],
						[
							-87.192478968,
							30.492498334000064
						],
						[
							-87.19093630699996,
							30.491189194000068
						],
						[
							-87.19055559299994,
							30.490701881000064
						],
						[
							-87.19032716499999,
							30.49026025300003
						],
						[
							-87.19022817899997,
							30.48994806700006
						],
						[
							-87.19015965099999,
							30.48954451100008
						],
						[
							-87.19012157899994,
							30.488889683000025
						],
						[
							-87.19009873699997,
							30.48784652700005
						],
						[
							-87.18954289499999,
							30.48783129900005
						],
						[
							-87.18950482299994,
							30.486864286000074
						],
						[
							-87.18942106599997,
							30.486338901000064
						],
						[
							-87.18934492299996,
							30.48614854400006
						],
						[
							-87.18898705199996,
							30.48614854400006
						],
						[
							-87.18867486699997,
							30.486087630000046
						],
						[
							-87.18839313899997,
							30.485950573000025
						],
						[
							-87.18800481099998,
							30.484755132000032
						],
						[
							-87.18757079699998,
							30.484138375000043
						],
						[
							-87.18674084099996,
							30.483415019000066
						],
						[
							-87.18642104199995,
							30.483704362000022
						],
						[
							-87.18355045999994,
							30.482973391000034
						],
						[
							-87.18431188699998,
							30.481625665000024
						],
						[
							-87.18268243299997,
							30.480887080000063
						],
						[
							-87.18387787399996,
							30.478861683000048
						],
						[
							-87.18076363499995,
							30.47737689900003
						],
						[
							-87.17773315399995,
							30.478602797000065
						],
						[
							-87.17597425599996,
							30.477788070000035
						],
						[
							-87.17604411699995,
							30.477676901000052
						],
						[
							-87.18716095899998,
							30.458526999000068
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Escambia",
				"City": "Pensacola",
				"Name": "Briggs Manor",
				"RegionID": "764084"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-87.21474486099999,
					30.439571261000022,
					-87.17108889699995,
					30.47944645900003
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-87.18533353299995,
							30.45736582200004
						],
						[
							-87.18459114099994,
							30.457194501000064
						],
						[
							-87.18384874899994,
							30.45725160800004
						],
						[
							-87.18310635699999,
							30.457441965000044
						],
						[
							-87.18251625099998,
							30.457803643000034
						],
						[
							-87.17885324999997,
							30.453861734000046
						],
						[
							-87.17844356199998,
							30.45411776000003
						],
						[
							-87.17402728199994,
							30.449006678000046
						],
						[
							-87.17320874799998,
							30.448645
						],
						[
							-87.17108889699995,
							30.448171050000038
						],
						[
							-87.171214,
							30.447878000000003
						],
						[
							-87.17186517699997,
							30.446145149000074
						],
						[
							-87.172173,
							30.445325999999998
						],
						[
							-87.17250906899994,
							30.443977874000044
						],
						[
							-87.172974,
							30.442113
						],
						[
							-87.17318547099995,
							30.440820678000083
						],
						[
							-87.17318913299994,
							30.440753710000028
						],
						[
							-87.17316438799998,
							30.43963222100007
						],
						[
							-87.17391592699994,
							30.439647404000027
						],
						[
							-87.17577380999995,
							30.439754004000065
						],
						[
							-87.17618498099995,
							30.439754004000065
						],
						[
							-87.17687026599998,
							30.439662632000076
						],
						[
							-87.17731189399996,
							30.439571261000022
						],
						[
							-87.17889566299993,
							30.439708318000044
						],
						[
							-87.18043374699994,
							30.439830146000077
						],
						[
							-87.18209365899997,
							30.439951975000042
						],
						[
							-87.18851072499996,
							30.44049265900003
						],
						[
							-87.18841350699995,
							30.441124573000025
						],
						[
							-87.18798710799996,
							30.442221029000056
						],
						[
							-87.18666222399999,
							30.444246426000063
						],
						[
							-87.18634242399997,
							30.445083996000047
						],
						[
							-87.18641856699998,
							30.445556081000063
						],
						[
							-87.18740842299997,
							30.446241366000038
						],
						[
							-87.18926630599998,
							30.446743908000027
						],
						[
							-87.19116987499996,
							30.447368279000045
						],
						[
							-87.19439832699999,
							30.44893682000003
						],
						[
							-87.19610392499999,
							30.449515504000033
						],
						[
							-87.19729175199996,
							30.450413989000022
						],
						[
							-87.19761155199996,
							30.45027693200007
						],
						[
							-87.19936283499999,
							30.449911447000034
						],
						[
							-87.20079431899995,
							30.449667790000035
						],
						[
							-87.20094660399997,
							30.449835304000036
						],
						[
							-87.20126640399997,
							30.449972361000047
						],
						[
							-87.20190600299998,
							30.45000281800003
						],
						[
							-87.20239331599998,
							30.45003327500007
						],
						[
							-87.20297200099998,
							30.450155104000032
						],
						[
							-87.20335271499995,
							30.450261703000027
						],
						[
							-87.207114167,
							30.44963733300006
						],
						[
							-87.20846950799995,
							30.44937844800006
						],
						[
							-87.20930707799994,
							30.449119562000078
						],
						[
							-87.20993144899995,
							30.448830220000048
						],
						[
							-87.21066241899996,
							30.448403820000063
						],
						[
							-87.21136293299998,
							30.447931735000058
						],
						[
							-87.212002532,
							30.44767285000006
						],
						[
							-87.21264213099994,
							30.447490107000082
						],
						[
							-87.21308875599999,
							30.44951093600002
						],
						[
							-87.21337429099998,
							30.450447492000023
						],
						[
							-87.21465348899994,
							30.456009720000054
						],
						[
							-87.21474486099999,
							30.45651226200005
						],
						[
							-87.21474486099999,
							30.456923433000043
						],
						[
							-87.21388825499997,
							30.468995866000057
						],
						[
							-87.21370551199999,
							30.470423543000038
						],
						[
							-87.21340855499994,
							30.471325834000027
						],
						[
							-87.21225499299999,
							30.473336003000043
						],
						[
							-87.21058746599994,
							30.476191356000072
						],
						[
							-87.21025624499998,
							30.476648213000033
						],
						[
							-87.20716104199994,
							30.47944645900003
						],
						[
							-87.20685266399994,
							30.479160924000045
						],
						[
							-87.20593895099995,
							30.478018782000046
						],
						[
							-87.20544783099997,
							30.477698983000042
						],
						[
							-87.19921173899996,
							30.474809365000056
						],
						[
							-87.20082733599997,
							30.47211573900006
						],
						[
							-87.20123850699997,
							30.471460912000058
						],
						[
							-87.20157353499997,
							30.470714713000064
						],
						[
							-87.20218267699994,
							30.468582716000075
						],
						[
							-87.20183242,
							30.46847611600003
						],
						[
							-87.20146693499998,
							30.46812585900005
						],
						[
							-87.20110144999995,
							30.467638546000046
						],
						[
							-87.20061413599996,
							30.467288289000066
						],
						[
							-87.19992885199997,
							30.466861889000032
						],
						[
							-87.19487297299999,
							30.464547150000044
						],
						[
							-87.19274097599998,
							30.463679122000027
						],
						[
							-87.19137040599998,
							30.463069980000057
						],
						[
							-87.19042623599995,
							30.46244561000003
						],
						[
							-87.18936023799995,
							30.461410068000077
						],
						[
							-87.18716095899998,
							30.458526999000068
						],
						[
							-87.18662795999995,
							30.457994000000003
						],
						[
							-87.18613303199999,
							30.457689429000027
						],
						[
							-87.18533353299995,
							30.45736582200004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Escambia",
				"City": "Pensacola",
				"Name": "Woodland Heights",
				"RegionID": "764085"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-87.25886736499996,
					30.399283,
					-87.22059524099996,
					30.41228169900006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-87.23062027599997,
							30.41133704300006
						],
						[
							-87.22610607299998,
							30.41128232500006
						],
						[
							-87.22373612999996,
							30.411453646000044
						],
						[
							-87.22188014999995,
							30.41179628900005
						],
						[
							-87.22059524099996,
							30.406256903000042
						],
						[
							-87.22208002499997,
							30.406028475000024
						],
						[
							-87.22171544499997,
							30.404347134000037
						],
						[
							-87.22195100000002,
							30.404368999999996
						],
						[
							-87.222274,
							30.40433
						],
						[
							-87.222344,
							30.404322
						],
						[
							-87.222662,
							30.404212999999995
						],
						[
							-87.222837,
							30.404089000000003
						],
						[
							-87.222829,
							30.404063
						],
						[
							-87.222749,
							30.404034000000003
						],
						[
							-87.222724,
							30.404012000000005
						],
						[
							-87.222718,
							30.403991000000005
						],
						[
							-87.222731,
							30.403948
						],
						[
							-87.222766,
							30.403907999999998
						],
						[
							-87.22279,
							30.403898000000005
						],
						[
							-87.222818,
							30.403901000000005
						],
						[
							-87.222855,
							30.403921
						],
						[
							-87.22295000000001,
							30.404056
						],
						[
							-87.222986,
							30.404085
						],
						[
							-87.22302796299994,
							30.404085
						],
						[
							-87.223116,
							30.404026
						],
						[
							-87.223249,
							30.403717999999998
						],
						[
							-87.22325610499996,
							30.403722876000078
						],
						[
							-87.223278,
							30.403692
						],
						[
							-87.223318,
							30.403688000000002
						],
						[
							-87.223347,
							30.403717
						],
						[
							-87.223445,
							30.40387
						],
						[
							-87.22351100000002,
							30.403877000000005
						],
						[
							-87.223595,
							30.403852
						],
						[
							-87.223653,
							30.403805
						],
						[
							-87.22373000000002,
							30.403694999999995
						],
						[
							-87.223799,
							30.403550000000003
						],
						[
							-87.223857,
							30.403323999999998
						],
						[
							-87.22385762099998,
							30.403311813000073
						],
						[
							-87.223706,
							30.402832
						],
						[
							-87.22371150699998,
							30.40281470300005
						],
						[
							-87.223697,
							30.402788000000005
						],
						[
							-87.223693,
							30.402737000000002
						],
						[
							-87.223759,
							30.402486
						],
						[
							-87.223809,
							30.402339000000005
						],
						[
							-87.223805,
							30.402317
						],
						[
							-87.223751,
							30.402309999999996
						],
						[
							-87.223753006,
							30.402295455000058
						],
						[
							-87.223001,
							30.402408000000005
						],
						[
							-87.22283,
							30.402502
						],
						[
							-87.222773,
							30.402738
						],
						[
							-87.223052,
							30.403657
						],
						[
							-87.222963,
							30.403756
						],
						[
							-87.222874,
							30.403756
						],
						[
							-87.222614,
							30.402628
						],
						[
							-87.222646,
							30.402491
						],
						[
							-87.222906,
							30.402304
						],
						[
							-87.22379920099996,
							30.40216561600005
						],
						[
							-87.223857,
							30.402074
						],
						[
							-87.223946,
							30.401908
						],
						[
							-87.22400846699998,
							30.40185302900005
						],
						[
							-87.223997,
							30.401759000000002
						],
						[
							-87.224714,
							30.401561
						],
						[
							-87.224644,
							30.401495
						],
						[
							-87.224695,
							30.401451000000005
						],
						[
							-87.224828,
							30.401539000000003
						],
						[
							-87.22468200000002,
							30.401659999999996
						],
						[
							-87.224778,
							30.402028
						],
						[
							-87.224924,
							30.402292000000003
						],
						[
							-87.225057,
							30.402325
						],
						[
							-87.22512662899999,
							30.402431378000074
						],
						[
							-87.22524612499996,
							30.402503075000027
						],
						[
							-87.225438,
							30.402534
						],
						[
							-87.22598400000001,
							30.402413
						],
						[
							-87.22613,
							30.402523
						],
						[
							-87.226206,
							30.402892
						],
						[
							-87.22607907999998,
							30.40300244900004
						],
						[
							-87.226151,
							30.403046
						],
						[
							-87.22621240599995,
							30.403153865000036
						],
						[
							-87.22637100000001,
							30.403101000000003
						],
						[
							-87.226542,
							30.403172
						],
						[
							-87.226485,
							30.403244
						],
						[
							-87.226549,
							30.403354000000004
						],
						[
							-87.22642029799995,
							30.40359616300003
						],
						[
							-87.226431,
							30.403622000000002
						],
						[
							-87.226533,
							30.404189
						],
						[
							-87.226555,
							30.404225
						],
						[
							-87.226638,
							30.404236999999995
						],
						[
							-87.226773,
							30.404224000000003
						],
						[
							-87.226804,
							30.404206000000002
						],
						[
							-87.226815,
							30.404175
						],
						[
							-87.226815,
							30.404102
						],
						[
							-87.226782,
							30.403938000000004
						],
						[
							-87.226731,
							30.403715999999996
						],
						[
							-87.226738,
							30.403676000000004
						],
						[
							-87.22676,
							30.403649999999995
						],
						[
							-87.226804,
							30.403627999999998
						],
						[
							-87.227158,
							30.403625
						],
						[
							-87.227278,
							30.403603
						],
						[
							-87.227314,
							30.403577000000002
						],
						[
							-87.227402,
							30.403483000000005
						],
						[
							-87.227453,
							30.403456999999996
						],
						[
							-87.227646,
							30.403388
						],
						[
							-87.227774,
							30.403308
						],
						[
							-87.227861,
							30.403235
						],
						[
							-87.227909,
							30.403151
						],
						[
							-87.227971,
							30.402900000000002
						],
						[
							-87.227989,
							30.402863000000004
						],
						[
							-87.22809777199996,
							30.402796831000046
						],
						[
							-87.22819952899994,
							30.402546233000066
						],
						[
							-87.228215,
							30.402495
						],
						[
							-87.22825977699995,
							30.402397864000083
						],
						[
							-87.228332,
							30.402219999999996
						],
						[
							-87.22822900099999,
							30.401967775000063
						],
						[
							-87.228142,
							30.401901000000002
						],
						[
							-87.228065,
							30.401767
						],
						[
							-87.227869,
							30.401468
						],
						[
							-87.22780040899994,
							30.40139416100004
						],
						[
							-87.22745198699994,
							30.40113831100007
						],
						[
							-87.227312,
							30.401071
						],
						[
							-87.227268,
							30.401034000000003
						],
						[
							-87.22724431299997,
							30.401003640000056
						],
						[
							-87.226846,
							30.400795
						],
						[
							-87.226193,
							30.401478000000004
						],
						[
							-87.22606,
							30.401746999999997
						],
						[
							-87.225914,
							30.401654
						],
						[
							-87.22621547099999,
							30.401197376000027
						],
						[
							-87.226193,
							30.401156999999998
						],
						[
							-87.226295,
							30.401045000000003
						],
						[
							-87.226422,
							30.400855999999997
						],
						[
							-87.22652707199997,
							30.400590555000065
						],
						[
							-87.226522,
							30.400565
						],
						[
							-87.225481,
							30.399888
						],
						[
							-87.22545,
							30.399762
						],
						[
							-87.22545365799994,
							30.399759920000065
						],
						[
							-87.225434,
							30.399726
						],
						[
							-87.225442,
							30.39969
						],
						[
							-87.22546400000002,
							30.399653
						],
						[
							-87.225483,
							30.399639999999998
						],
						[
							-87.225553,
							30.399639999999998
						],
						[
							-87.225613,
							30.39966
						],
						[
							-87.22591420399993,
							30.39987688800005
						],
						[
							-87.228611,
							30.401554000000004
						],
						[
							-87.22921651299998,
							30.401821711000025
						],
						[
							-87.229664,
							30.401767
						],
						[
							-87.22989540699996,
							30.40174408000007
						],
						[
							-87.230178,
							30.401620000000005
						],
						[
							-87.23089979599996,
							30.401616029000024
						],
						[
							-87.23144362199997,
							30.401550006000036
						],
						[
							-87.233065,
							30.400931000000003
						],
						[
							-87.233529,
							30.400804000000004
						],
						[
							-87.233637,
							30.400865000000003
						],
						[
							-87.23388650199996,
							30.400786850000035
						],
						[
							-87.234329,
							30.400615
						],
						[
							-87.23455326999994,
							30.400522273000036
						],
						[
							-87.234696,
							30.400331
						],
						[
							-87.234861,
							30.400298
						],
						[
							-87.23497081899995,
							30.400359079000054
						],
						[
							-87.235236,
							30.400269999999995
						],
						[
							-87.235584,
							30.400236000000003
						],
						[
							-87.235634,
							30.400229999999997
						],
						[
							-87.235836,
							30.400193000000005
						],
						[
							-87.235997,
							30.400142
						],
						[
							-87.236186,
							30.400061000000004
						],
						[
							-87.237134,
							30.399763000000004
						],
						[
							-87.237309,
							30.399697000000003
						],
						[
							-87.237484,
							30.399667999999995
						],
						[
							-87.237601,
							30.39969
						],
						[
							-87.237681,
							30.399754999999995
						],
						[
							-87.237772,
							30.399872000000002
						],
						[
							-87.23780900000001,
							30.399887000000003
						],
						[
							-87.23785200000002,
							30.399879
						],
						[
							-87.237998,
							30.399777
						],
						[
							-87.238115,
							30.399697000000003
						],
						[
							-87.238308,
							30.399653
						],
						[
							-87.23836266899997,
							30.399623181000038
						],
						[
							-87.23839289699998,
							30.399590230000054
						],
						[
							-87.23841,
							30.399566
						],
						[
							-87.238428,
							30.399508
						],
						[
							-87.23841700000001,
							30.399362
						],
						[
							-87.238428,
							30.399329000000005
						],
						[
							-87.238461,
							30.399307
						],
						[
							-87.23850900000001,
							30.399293
						],
						[
							-87.238622,
							30.399283
						],
						[
							-87.23868269799999,
							30.399292613000057
						],
						[
							-87.238713,
							30.399284000000005
						],
						[
							-87.238827,
							30.399289
						],
						[
							-87.23883192999996,
							30.399316247000062
						],
						[
							-87.238843,
							30.399317999999997
						],
						[
							-87.239511,
							30.399641
						],
						[
							-87.23991736199999,
							30.399783037000077
						],
						[
							-87.240141,
							30.399679000000003
						],
						[
							-87.241067,
							30.399899
						],
						[
							-87.24107745099997,
							30.400013961000074
						],
						[
							-87.24109708699996,
							30.40001733300005
						],
						[
							-87.241213,
							30.399850000000004
						],
						[
							-87.24117998799994,
							30.400031565000063
						],
						[
							-87.2412,
							30.400034999999995
						],
						[
							-87.241291,
							30.400100999999996
						],
						[
							-87.241287,
							30.400473000000005
						],
						[
							-87.24129,
							30.400517
						],
						[
							-87.241327,
							30.400579000000004
						],
						[
							-87.241349,
							30.400604
						],
						[
							-87.24136,
							30.400637
						],
						[
							-87.24136700000001,
							30.400705999999996
						],
						[
							-87.241396,
							30.400735000000005
						],
						[
							-87.24144,
							30.400739
						],
						[
							-87.241509,
							30.400722
						],
						[
							-87.241557,
							30.400714000000004
						],
						[
							-87.241597,
							30.400717000000004
						],
						[
							-87.24166200000002,
							30.400761
						],
						[
							-87.241706,
							30.400768
						],
						[
							-87.241728,
							30.400761
						],
						[
							-87.241743,
							30.400705999999996
						],
						[
							-87.24175400000001,
							30.400582000000004
						],
						[
							-87.241775,
							30.400506
						],
						[
							-87.241812,
							30.400437000000004
						],
						[
							-87.241899,
							30.400327
						],
						[
							-87.241923,
							30.400262000000005
						],
						[
							-87.241964,
							30.400253
						],
						[
							-87.242013,
							30.400268999999998
						],
						[
							-87.242033,
							30.400306
						],
						[
							-87.241874,
							30.400641
						],
						[
							-87.241783,
							30.400797
						],
						[
							-87.241783,
							30.400837
						],
						[
							-87.241806,
							30.400845
						],
						[
							-87.241837,
							30.400845
						],
						[
							-87.24187,
							30.400834
						],
						[
							-87.24198,
							30.400633000000003
						],
						[
							-87.242122,
							30.400342000000002
						],
						[
							-87.242313,
							30.399979
						],
						[
							-87.242395,
							30.399880999999997
						],
						[
							-87.242413,
							30.399872000000002
						],
						[
							-87.242461,
							30.399883
						],
						[
							-87.242526,
							30.39997
						],
						[
							-87.242574,
							30.400009999999998
						],
						[
							-87.242629,
							30.400025000000003
						],
						[
							-87.242844,
							30.400029
						],
						[
							-87.24288674699994,
							30.400017229000074
						],
						[
							-87.24286327599998,
							30.399733510000033
						],
						[
							-87.24401952799997,
							30.39987027100005
						],
						[
							-87.24557283999997,
							30.400327128000075
						],
						[
							-87.24726320899998,
							30.401728155000058
						],
						[
							-87.25189268899999,
							30.403768780000064
						],
						[
							-87.25477088499997,
							30.40460635100004
						],
						[
							-87.25774045199995,
							30.408063232000075
						],
						[
							-87.25886736499996,
							30.411154627000034
						],
						[
							-87.25246098299993,
							30.41219603800005
						],
						[
							-87.25077632499995,
							30.41228169900006
						],
						[
							-87.24874902399995,
							30.412224592000026
						],
						[
							-87.23618546999995,
							30.41168207400006
						],
						[
							-87.23081740599997,
							30.411339432000034
						],
						[
							-87.23062027599997,
							30.41133704300006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Escambia",
				"City": "Pensacola",
				"Name": "Renz-anna Villa",
				"RegionID": "764092"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-87.259324221,
					30.411154627000034,
					-87.22928107699994,
					30.43411928100005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-87.22928107699994,
							30.43359379100008
						],
						[
							-87.23062027599997,
							30.41133704300006
						],
						[
							-87.23081740599997,
							30.411339432000034
						],
						[
							-87.23618546999995,
							30.41168207400006
						],
						[
							-87.24874902399995,
							30.412224592000026
						],
						[
							-87.25077632499995,
							30.41228169900006
						],
						[
							-87.25246098299993,
							30.41219603800005
						],
						[
							-87.25886736499996,
							30.411154627000034
						],
						[
							-87.25912624999995,
							30.41176376900006
						],
						[
							-87.25924807799998,
							30.41276885400003
						],
						[
							-87.259324221,
							30.41365211000004
						],
						[
							-87.25926330699997,
							30.41435262300007
						],
						[
							-87.25895873599995,
							30.414885622000043
						],
						[
							-87.25836482199998,
							30.415281564000054
						],
						[
							-87.25708562399996,
							30.41572319200003
						],
						[
							-87.25652216799995,
							30.415921164000054
						],
						[
							-87.25617191099997,
							30.41622573500007
						],
						[
							-87.25563891199994,
							30.416469391000074
						],
						[
							-87.25496885599995,
							30.416469391000074
						],
						[
							-87.25338508699997,
							30.416332334000064
						],
						[
							-87.25256274499998,
							30.41608867800005
						],
						[
							-87.25152720299997,
							30.41529679300004
						],
						[
							-87.25072008999996,
							30.41523587900008
						],
						[
							-87.25070486199996,
							30.415677507000055
						],
						[
							-87.2505068899999,
							30.41700239100004
						],
						[
							-87.25033937599994,
							30.418768903000057
						],
						[
							-87.25027846199998,
							30.42129684200006
						],
						[
							-87.24982160599995,
							30.42114455600006
						],
						[
							-87.24909063499996,
							30.42102272800003
						],
						[
							-87.24837489299995,
							30.420992271000046
						],
						[
							-87.24126316,
							30.420702928000026
						],
						[
							-87.24044081899996,
							30.43411928100005
						],
						[
							-87.22928107699994,
							30.43359379100008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Escambia",
				"City": "Pensacola",
				"Name": "Sunny Ridge",
				"RegionID": "764093"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.157619,
					26.63241157500005,
					-80.14545200699996,
					26.651196
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.145458,
							26.651196
						],
						[
							-80.14545200699996,
							26.648919926000076
						],
						[
							-80.14546342799997,
							26.647572199000024
						],
						[
							-80.14555479899997,
							26.645242231000054
						],
						[
							-80.14560048499999,
							26.64390592600006
						],
						[
							-80.14566901399996,
							26.64154169300008
						],
						[
							-80.14570327799998,
							26.640890673000058
						],
						[
							-80.14578322799997,
							26.63854928300003
						],
						[
							-80.14589317499997,
							26.634946034000052
						],
						[
							-80.14591030699995,
							26.63416557000005
						],
						[
							-80.14599305399997,
							26.63250692500003
						],
						[
							-80.14752643699995,
							26.632442206000064
						],
						[
							-80.15187177199994,
							26.63241157500005
						],
						[
							-80.151878,
							26.632598
						],
						[
							-80.151881,
							26.632688
						],
						[
							-80.152878,
							26.632689
						],
						[
							-80.15287438499996,
							26.634454731000062
						],
						[
							-80.15287400000001,
							26.634643
						],
						[
							-80.153592,
							26.634642
						],
						[
							-80.154006,
							26.634613
						],
						[
							-80.15399227399996,
							26.63707424000006
						],
						[
							-80.15398,
							26.639275
						],
						[
							-80.154844,
							26.639274
						],
						[
							-80.155589,
							26.639271
						],
						[
							-80.155519,
							26.640111
						],
						[
							-80.157619,
							26.640105
						],
						[
							-80.157598,
							26.640431
						],
						[
							-80.157579,
							26.640664
						],
						[
							-80.157511,
							26.641294
						],
						[
							-80.157425,
							26.641922
						],
						[
							-80.157379,
							26.642254
						],
						[
							-80.157289,
							26.643038000000004
						],
						[
							-80.157219,
							26.643823
						],
						[
							-80.157173,
							26.644522
						],
						[
							-80.157143,
							26.645222
						],
						[
							-80.157144,
							26.646974
						],
						[
							-80.15717,
							26.649253000000005
						],
						[
							-80.157174,
							26.649356
						],
						[
							-80.153779,
							26.649339
						],
						[
							-80.153764,
							26.651115
						],
						[
							-80.15328459699998,
							26.65112333700006
						],
						[
							-80.15109703999997,
							26.65116137800004
						],
						[
							-80.14700817399995,
							26.65116137800004
						],
						[
							-80.145458,
							26.651196
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Greenacres",
				"Name": "River Bridge",
				"RegionID": "764324"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.153764,
					26.651115,
					-80.14527445099998,
					26.66238269400003
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.14527445099998,
							26.659927090000053
						],
						[
							-80.14532118399995,
							26.658068667000066
						],
						[
							-80.145371,
							26.65807
						],
						[
							-80.14539464099994,
							26.656255328000043
						],
						[
							-80.145396,
							26.656151
						],
						[
							-80.145424,
							26.653922
						],
						[
							-80.14542837999994,
							26.65357082400004
						],
						[
							-80.145458,
							26.651196
						],
						[
							-80.14700817399995,
							26.65116137800004
						],
						[
							-80.15109703999997,
							26.65116137800004
						],
						[
							-80.15328459699998,
							26.65112333700006
						],
						[
							-80.153764,
							26.651115
						],
						[
							-80.15369010299997,
							26.65768300900004
						],
						[
							-80.15367275499995,
							26.65922489600007
						],
						[
							-80.153664,
							26.660003
						],
						[
							-80.153666,
							26.661644
						],
						[
							-80.153666,
							26.661923
						],
						[
							-80.153667,
							26.662292
						],
						[
							-80.15227958499997,
							26.66230655100003
						],
						[
							-80.15054733699998,
							26.66233510500007
						],
						[
							-80.15018344299995,
							26.662340056000062
						],
						[
							-80.14914821399998,
							26.662354141000037
						],
						[
							-80.14695910999995,
							26.662373176000074
						],
						[
							-80.14527445099998,
							26.66238269400003
						],
						[
							-80.14527445099998,
							26.659927090000053
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Greenacres",
				"Name": "Olive Tree",
				"RegionID": "764325"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.783412,
					26.173652869000026,
					-81.76710613799997,
					26.18224709900005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.76744393299998,
							26.18224709900005
						],
						[
							-81.76710613799997,
							26.17402861000005
						],
						[
							-81.77471288199996,
							26.17368525200004
						],
						[
							-81.783296,
							26.173652869000026
						],
						[
							-81.783296,
							26.175375000000003
						],
						[
							-81.78334007799998,
							26.17797009700007
						],
						[
							-81.78336981099994,
							26.179720640000028
						],
						[
							-81.783412,
							26.182204519000038
						],
						[
							-81.77074456699995,
							26.182239389000074
						],
						[
							-81.770612,
							26.179574
						],
						[
							-81.768689,
							26.179653
						],
						[
							-81.76875,
							26.182227
						],
						[
							-81.76744393299998,
							26.18224709900005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Collier",
				"City": "Naples",
				"Name": "Estuary at Grey Oaks",
				"RegionID": "764359"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.15763092399993,
					25.77199345400004,
					-80.14317017799993,
					25.78254095200009
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.14629536199993,
							25.781972737000046
						],
						[
							-80.14317017799993,
							25.774053235000057
						],
						[
							-80.1443641649999,
							25.773575640000047
						],
						[
							-80.14439477999991,
							25.773563394000064
						],
						[
							-80.1456561199999,
							25.77305885800007
						],
						[
							-80.14750281999994,
							25.772455129000036
						],
						[
							-80.1491009259999,
							25.77199345400004
						],
						[
							-80.15020184299993,
							25.77199345400004
						],
						[
							-80.15188799999993,
							25.772345000000087
						],
						[
							-80.15242899999993,
							25.77249500000005
						],
						[
							-80.1531349999999,
							25.77278400000006
						],
						[
							-80.15763092399993,
							25.774748011000042
						],
						[
							-80.15574194299995,
							25.77906063300009
						],
						[
							-80.15410832399994,
							25.78254095200009
						],
						[
							-80.14629536199993,
							25.781972737000046
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Beach",
				"Name": "Star island",
				"RegionID": "623411"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.71145328099993,
					28.259259979000035,
					-82.69902535599994,
					28.26722641500004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.70717025099992,
							28.259259979000035
						],
						[
							-82.70725591099995,
							28.259259979000035
						],
						[
							-82.70737964299991,
							28.259269497000048
						],
						[
							-82.70739867899994,
							28.260052340000072
						],
						[
							-82.70866217299994,
							28.260052340000072
						],
						[
							-82.70868358799994,
							28.26142290900009
						],
						[
							-82.70938314999995,
							28.26142290900009
						],
						[
							-82.70938314999995,
							28.262315207000086
						],
						[
							-82.71143900399994,
							28.262308069000085
						],
						[
							-82.71145328099993,
							28.263243197000065
						],
						[
							-82.70726304999994,
							28.263228920000078
						],
						[
							-82.70726304999994,
							28.26379285200005
						],
						[
							-82.70678477799993,
							28.26381426800009
						],
						[
							-82.70679905499992,
							28.26444958400009
						],
						[
							-82.70724163499995,
							28.26444958400009
						],
						[
							-82.70724163499995,
							28.26532046600005
						],
						[
							-82.70769135299992,
							28.26532046600005
						],
						[
							-82.70769849099992,
							28.26586298400008
						],
						[
							-82.70741295599993,
							28.26585584500009
						],
						[
							-82.70727732699993,
							28.265920091000055
						],
						[
							-82.70453372199995,
							28.265917224000077
						],
						[
							-82.70044589399993,
							28.265912952000065
						],
						[
							-82.70034595699991,
							28.266034305000062
						],
						[
							-82.7002460189999,
							28.266091412000037
						],
						[
							-82.70006755999992,
							28.26615565700007
						],
						[
							-82.6997320559999,
							28.26615565700007
						],
						[
							-82.69954645799993,
							28.266241318000084
						],
						[
							-82.69956787299992,
							28.266412639000066
						],
						[
							-82.69971064099991,
							28.266619652000088
						],
						[
							-82.69985340799991,
							28.26691946400007
						],
						[
							-82.69982485499992,
							28.26712647700009
						],
						[
							-82.69951790399995,
							28.267212138000048
						],
						[
							-82.69906818599992,
							28.26722641500004
						],
						[
							-82.69902535599994,
							28.261458601000076
						],
						[
							-82.70424351399993,
							28.26142290900009
						],
						[
							-82.70424351399993,
							28.26125158800005
						],
						[
							-82.70458615599995,
							28.26123731100006
						],
						[
							-82.70457901799995,
							28.261415771000088
						],
						[
							-82.70576398899993,
							28.261415771000088
						],
						[
							-82.70575685099993,
							28.261137374000043
						],
						[
							-82.70587820399993,
							28.261137374000043
						],
						[
							-82.70586392699994,
							28.260830423000076
						],
						[
							-82.7059495869999,
							28.260837562000066
						],
						[
							-82.7059424489999,
							28.26140149400004
						],
						[
							-82.7072344959999,
							28.26140149400004
						],
						[
							-82.70717025099992,
							28.259259979000035
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pasco",
				"City": "New Port Richey",
				"Name": "Lake Estates",
				"RegionID": "737816"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.7234627279999,
					28.23169314000006,
					-82.71462302999993,
					28.238845800000036
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.7196537019999,
							28.238843592000084
						],
						[
							-82.71736936699996,
							28.238842221000084
						],
						[
							-82.71540349299994,
							28.23884104100006
						],
						[
							-82.71540349299994,
							28.23759420400006
						],
						[
							-82.71462302999993,
							28.237603721000088
						],
						[
							-82.71462302999993,
							28.23728011500009
						],
						[
							-82.71535590399992,
							28.23728011500009
						],
						[
							-82.71535855199994,
							28.236502836000057
						],
						[
							-82.71537493999995,
							28.23169314000006
						],
						[
							-82.7194771309999,
							28.231702658000074
						],
						[
							-82.7194771309999,
							28.233025638000072
						],
						[
							-82.72345558899991,
							28.233020879000037
						],
						[
							-82.7234627279999,
							28.23387034700005
						],
						[
							-82.72345558899991,
							28.23417015900009
						],
						[
							-82.72340562099993,
							28.234434279000084
						],
						[
							-82.72334851399995,
							28.235019627000042
						],
						[
							-82.72334851399995,
							28.235390823000046
						],
						[
							-82.72330568299992,
							28.235390823000046
						],
						[
							-82.72331995999991,
							28.23799633200008
						],
						[
							-82.7233342369999,
							28.238845800000036
						],
						[
							-82.7196631679999,
							28.238843597000084
						],
						[
							-82.7196537019999,
							28.238843592000084
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pasco",
				"City": "New Port Richey",
				"Name": "Schwettman Oaks",
				"RegionID": "737823"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.1342335679999,
					26.245804279000083,
					-80.13074581599994,
					26.24956525300007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.13074581599994,
							26.245871841000053
						],
						[
							-80.13076907699991,
							26.245871384000054
						],
						[
							-80.13418534199991,
							26.245804279000083
						],
						[
							-80.1342335679999,
							26.24949107000009
						],
						[
							-80.13082114699995,
							26.24956525300007
						],
						[
							-80.13074581599994,
							26.245871841000053
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Pompano Beach",
				"Name": "Pine Tree Park",
				"RegionID": "738041"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.15680994999991,
					26.23120515000005,
					-80.13646532799993,
					26.243556424000076
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.13653324299992,
							26.234159901000055
						],
						[
							-80.13646532799993,
							26.231579749000048
						],
						[
							-80.1437620289999,
							26.231382541000073
						],
						[
							-80.15670760499995,
							26.23120515000005
						],
						[
							-80.15680994999991,
							26.23215695800008
						],
						[
							-80.15656267299994,
							26.23317079400005
						],
						[
							-80.15614230199992,
							26.234234084000036
						],
						[
							-80.1555488379999,
							26.235124281000083
						],
						[
							-80.15451027499995,
							26.236039206000044
						],
						[
							-80.1528535189999,
							26.23734977400005
						],
						[
							-80.15211168899992,
							26.23831415300009
						],
						[
							-80.1516418619999,
							26.23945162700005
						],
						[
							-80.15156767899992,
							26.24031709600007
						],
						[
							-80.15159240699995,
							26.243556424000076
						],
						[
							-80.1371019799999,
							26.234382451000045
						],
						[
							-80.13653324299992,
							26.234159901000055
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Pompano Beach",
				"Name": "Old Collier",
				"RegionID": "738043"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.09002045699992,
					26.25433769700004,
					-80.08171195199994,
					26.262557382000068
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.08288884899991,
							26.260789852000073
						],
						[
							-80.08361598499994,
							26.260420709000073
						],
						[
							-80.0837148949999,
							26.260000338000054
						],
						[
							-80.08356652899994,
							26.259134869000036
						],
						[
							-80.08292360899992,
							26.258838137000055
						],
						[
							-80.08267633199995,
							26.258417766000036
						],
						[
							-80.08203341199993,
							26.258615588000055
						],
						[
							-80.08171195199994,
							26.257898485000055
						],
						[
							-80.08289888199994,
							26.257280292000075
						],
						[
							-80.08344289099995,
							26.256192274000057
						],
						[
							-80.0837148949999,
							26.254584974000068
						],
						[
							-80.08927862599995,
							26.25433769700004
						],
						[
							-80.09002045699992,
							26.258541405000074
						],
						[
							-80.08836512399995,
							26.261057957000048
						],
						[
							-80.0882969459999,
							26.261067697000044
						],
						[
							-80.08626594499992,
							26.261357840000073
						],
						[
							-80.08382581099994,
							26.26252900800006
						],
						[
							-80.0837666939999,
							26.262557382000068
						],
						[
							-80.08376389899992,
							26.26255229800006
						],
						[
							-80.08375305399994,
							26.26252923700008
						],
						[
							-80.08375070599993,
							26.262524142000075
						],
						[
							-80.08359894499995,
							26.262189840000076
						],
						[
							-80.08326594499994,
							26.26145784000005
						],
						[
							-80.08288884899991,
							26.260789852000073
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Pompano Beach",
				"Name": "Hillsboro Shores",
				"RegionID": "738048"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.10396687399992,
					26.221375685000055,
					-80.09392743199993,
					26.231909682000037
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.09548527599992,
							26.222735708000073
						],
						[
							-80.09719148699992,
							26.222982985000044
						],
						[
							-80.09842787199995,
							26.222661525000035
						],
						[
							-80.09921915799993,
							26.222488431000045
						],
						[
							-80.09988680499993,
							26.222710980000045
						],
						[
							-80.1009500959999,
							26.223007713000076
						],
						[
							-80.10174138199994,
							26.22288407400004
						],
						[
							-80.1021617529999,
							26.222735708000073
						],
						[
							-80.10231011899992,
							26.222142244000054
						],
						[
							-80.10250794099994,
							26.221598234000055
						],
						[
							-80.10300249399995,
							26.221375685000055
						],
						[
							-80.10342286499991,
							26.221449868000036
						],
						[
							-80.10396687399992,
							26.221672417000036
						],
						[
							-80.10321093499994,
							26.223885257000063
						],
						[
							-80.1032035579999,
							26.22390685000005
						],
						[
							-80.1026068509999,
							26.22565357600007
						],
						[
							-80.1026068509999,
							26.22595030800005
						],
						[
							-80.10285412799993,
							26.231835498000066
						],
						[
							-80.09902133599991,
							26.231860226000038
						],
						[
							-80.09392743199993,
							26.231909682000037
						],
						[
							-80.09548527599992,
							26.222735708000073
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Pompano Beach",
				"Name": "Santa Barbara Estates",
				"RegionID": "738050"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.15670760499995,
					26.21856401300005,
					-80.1437620289999,
					26.231382541000073
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.1464243389999,
							26.21856401300005
						],
						[
							-80.1563189279999,
							26.218618349000053
						],
						[
							-80.15670760499995,
							26.23120515000005
						],
						[
							-80.1437620289999,
							26.231382541000073
						],
						[
							-80.1464243389999,
							26.21856401300005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Pompano Beach",
				"Name": "Arvida-Pompano Park",
				"RegionID": "738057"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.19556995699992,
					26.20896040300005,
					-80.1880681909999,
					26.21861743700009
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.18806894499994,
							26.209559840000054
						],
						[
							-80.18806894499994,
							26.209232840000084
						],
						[
							-80.18806894499994,
							26.209059840000066
						],
						[
							-80.18808054399994,
							26.209059840000066
						],
						[
							-80.18814182999995,
							26.209059840000066
						],
						[
							-80.19109606099994,
							26.209059840000066
						],
						[
							-80.19116893599994,
							26.20905943100007
						],
						[
							-80.19124179499994,
							26.209058182000035
						],
						[
							-80.19500809399995,
							26.208972497000047
						],
						[
							-80.1950809459999,
							26.208970845000067
						],
						[
							-80.19515379799992,
							26.208969223000054
						],
						[
							-80.19549709799992,
							26.208961699000042
						],
						[
							-80.19556750399994,
							26.20896040300005
						],
						[
							-80.19556995699992,
							26.208965495000086
						],
						[
							-80.19556994499993,
							26.20945984000008
						],
						[
							-80.1954699449999,
							26.210059840000042
						],
						[
							-80.1954659829999,
							26.210065677000046
						],
						[
							-80.18853714999995,
							26.218532898000035
						],
						[
							-80.18851083599992,
							26.218565054000067
						],
						[
							-80.18846796999992,
							26.21861743700009
						],
						[
							-80.18846331999993,
							26.21853321900005
						],
						[
							-80.1880681909999,
							26.209564330000035
						],
						[
							-80.18806894499994,
							26.209559840000054
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Pompano Beach",
				"Name": "Gardens",
				"RegionID": "738059"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.15185424799995,
					26.165915734000066,
					-80.14643802299997,
					26.16973510400004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.14643802299997,
							26.166362
						],
						[
							-80.14664006699996,
							26.166362
						],
						[
							-80.148767,
							26.166362
						],
						[
							-80.14928776299996,
							26.166247807000047
						],
						[
							-80.15029715799994,
							26.166026466000062
						],
						[
							-80.15099867099997,
							26.165923
						],
						[
							-80.15124081499994,
							26.165923
						],
						[
							-80.151437,
							26.165923
						],
						[
							-80.15172512899994,
							26.165915734000066
						],
						[
							-80.15171643799994,
							26.16645392500004
						],
						[
							-80.15170972999994,
							26.16686930700007
						],
						[
							-80.15170217199994,
							26.167337331000056
						],
						[
							-80.15169281899996,
							26.16791650300007
						],
						[
							-80.15185424799995,
							26.168368506000036
						],
						[
							-80.15182196199999,
							26.168465364000042
						],
						[
							-80.15153138899996,
							26.168820509000057
						],
						[
							-80.15146681699997,
							26.16901422500007
						],
						[
							-80.15147584399995,
							26.169321151000076
						],
						[
							-80.15148295999995,
							26.16956308600004
						],
						[
							-80.15098643699997,
							26.169578234000028
						],
						[
							-80.15000066299996,
							26.16960830900007
						],
						[
							-80.14983270499994,
							26.16961413200005
						],
						[
							-80.146720584,
							26.169728860000077
						],
						[
							-80.14655068599996,
							26.16973510400004
						],
						[
							-80.14652914099997,
							26.16948517900005
						],
						[
							-80.14652619399999,
							26.16945099800006
						],
						[
							-80.14651149899998,
							26.168471323000063
						],
						[
							-80.14650170199997,
							26.16801087600004
						],
						[
							-80.14645761599996,
							26.166800977000037
						],
						[
							-80.14643802299997,
							26.166362
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Oakland Park",
				"Name": "Sleepy River",
				"RegionID": "760964"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.18703749799994,
					26.165344495000056,
					-80.17905449499996,
					26.17367965400007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.17905449499996,
							26.165461075000053
						],
						[
							-80.18096962999994,
							26.16541517900004
						],
						[
							-80.18201701199996,
							26.165390957000056
						],
						[
							-80.18295283899994,
							26.16536931400003
						],
						[
							-80.18304445299998,
							26.165368757000067
						],
						[
							-80.18703749799994,
							26.165344495000056
						],
						[
							-80.18702809699994,
							26.16570447600003
						],
						[
							-80.18702199899997,
							26.166400268000075
						],
						[
							-80.186968,
							26.172562
						],
						[
							-80.18316,
							26.172618
						],
						[
							-80.18316291999997,
							26.172957001000043
						],
						[
							-80.183168,
							26.173562
						],
						[
							-80.18240535699994,
							26.17358396900005
						],
						[
							-80.1790874499999,
							26.17367965400007
						],
						[
							-80.17905931899998,
							26.166689750000046
						],
						[
							-80.17905525199996,
							26.16565383600005
						],
						[
							-80.17905449499996,
							26.165461075000053
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Oakland Park",
				"Name": "Oakland Forest",
				"RegionID": "760969"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.17103210199997,
					26.165573730000062,
					-80.16150774699997,
					26.173308256000045
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.16686604799997,
							26.165712213000063
						],
						[
							-80.17100174799998,
							26.165573730000062
						],
						[
							-80.17100030899996,
							26.165737196000066
						],
						[
							-80.17099997799995,
							26.165774858000077
						],
						[
							-80.17102652499995,
							26.172000355000023
						],
						[
							-80.17103210199997,
							26.173308256000045
						],
						[
							-80.17018501899997,
							26.172662504000073
						],
						[
							-80.16186289299998,
							26.16631834800006
						],
						[
							-80.16154173699994,
							26.166011791000074
						],
						[
							-80.16150774699997,
							26.16597934600003
						],
						[
							-80.16686604799997,
							26.165712213000063
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Oakland Park",
				"Name": "Royal Palm Acres",
				"RegionID": "760971"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.803421,
					24.558061641000055,
					-81.78250542199999,
					24.594749
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.795873,
							24.594043
						],
						[
							-81.795581,
							24.593251
						],
						[
							-81.79520612099998,
							24.592490891000068
						],
						[
							-81.794977,
							24.592
						],
						[
							-81.79481947499994,
							24.59169071200006
						],
						[
							-81.794494,
							24.590964
						],
						[
							-81.794261,
							24.589494
						],
						[
							-81.79432169199998,
							24.588071773000024
						],
						[
							-81.794057,
							24.586
						],
						[
							-81.794078,
							24.582824
						],
						[
							-81.79429634,
							24.580335862000027
						],
						[
							-81.794404,
							24.579109
						],
						[
							-81.79438498099995,
							24.578200732000028
						],
						[
							-81.794355,
							24.576769
						],
						[
							-81.794054,
							24.57592
						],
						[
							-81.79407434899997,
							24.57575741000005
						],
						[
							-81.79407626299997,
							24.575741742000048
						],
						[
							-81.794255,
							24.574314
						],
						[
							-81.79420603099999,
							24.572415075000038
						],
						[
							-81.794129,
							24.569428
						],
						[
							-81.794604,
							24.567119
						],
						[
							-81.79491381899999,
							24.56649777900003
						],
						[
							-81.78377402099994,
							24.565172498000038
						],
						[
							-81.78250542199999,
							24.564163076000057
						],
						[
							-81.78251555799994,
							24.563017697000078
						],
						[
							-81.78251906299994,
							24.562621660000048
						],
						[
							-81.78907376499996,
							24.563419345000057
						],
						[
							-81.78715695099999,
							24.562171512000077
						],
						[
							-81.78705962099997,
							24.56177334700004
						],
						[
							-81.78700690099998,
							24.561557674000028
						],
						[
							-81.78722515499999,
							24.56058917400003
						],
						[
							-81.78845121799999,
							24.56058407000006
						],
						[
							-81.78748386099994,
							24.559361870000032
						],
						[
							-81.78724012699996,
							24.558648147000042
						],
						[
							-81.78740415699997,
							24.558540152000038
						],
						[
							-81.78813094899994,
							24.558061641000055
						],
						[
							-81.78990987499998,
							24.56089879900003
						],
						[
							-81.79276527799999,
							24.559201978000033
						],
						[
							-81.79322546499998,
							24.55890522900006
						],
						[
							-81.79428125199996,
							24.56038493500006
						],
						[
							-81.79534573799998,
							24.561609945000043
						],
						[
							-81.79712592599998,
							24.564009637000026
						],
						[
							-81.797244521,
							24.56430156400006
						],
						[
							-81.79828450799994,
							24.564365422000037
						],
						[
							-81.80040018599999,
							24.56417708400005
						],
						[
							-81.80144527199997,
							24.564084051000066
						],
						[
							-81.80287,
							24.564258
						],
						[
							-81.80283000000001,
							24.564529
						],
						[
							-81.802768,
							24.565259
						],
						[
							-81.802923,
							24.566108
						],
						[
							-81.803295,
							24.566846
						],
						[
							-81.803421,
							24.567095000000002
						],
						[
							-81.803278,
							24.567223
						],
						[
							-81.802969,
							24.567497
						],
						[
							-81.80295700000002,
							24.568469
						],
						[
							-81.802337,
							24.568665
						],
						[
							-81.80143302199997,
							24.568477950000045
						],
						[
							-81.800747,
							24.568336
						],
						[
							-81.797411,
							24.567646
						],
						[
							-81.797516,
							24.567869
						],
						[
							-81.79872,
							24.569429
						],
						[
							-81.80035,
							24.570301
						],
						[
							-81.800626,
							24.571539
						],
						[
							-81.800224,
							24.571952
						],
						[
							-81.798544,
							24.572755
						],
						[
							-81.797741,
							24.573214
						],
						[
							-81.797064,
							24.573787000000003
						],
						[
							-81.796437,
							24.574521
						],
						[
							-81.796387,
							24.574796
						],
						[
							-81.796838,
							24.576012
						],
						[
							-81.797214,
							24.576288
						],
						[
							-81.79783738399999,
							24.576148898000042
						],
						[
							-81.799271,
							24.575829
						],
						[
							-81.799522,
							24.575829
						],
						[
							-81.799722,
							24.57693
						],
						[
							-81.79912,
							24.578811000000005
						],
						[
							-81.79852016799998,
							24.58117595400006
						],
						[
							-81.797916,
							24.583558
						],
						[
							-81.797715,
							24.584797
						],
						[
							-81.79779,
							24.586219
						],
						[
							-81.797991,
							24.586609
						],
						[
							-81.798492,
							24.586541
						],
						[
							-81.799872,
							24.585875
						],
						[
							-81.800349,
							24.585371
						],
						[
							-81.801126,
							24.585348
						],
						[
							-81.80075,
							24.586610000000004
						],
						[
							-81.80027300000002,
							24.586587
						],
						[
							-81.798568,
							24.587366
						],
						[
							-81.797539,
							24.587986
						],
						[
							-81.797138,
							24.58849
						],
						[
							-81.797012,
							24.588972
						],
						[
							-81.79711200000001,
							24.589798
						],
						[
							-81.796686,
							24.590303
						],
						[
							-81.796586,
							24.59067
						],
						[
							-81.796736,
							24.591404
						],
						[
							-81.797062,
							24.592023
						],
						[
							-81.79720775499999,
							24.592073119000077
						],
						[
							-81.79745,
							24.59205
						],
						[
							-81.797761,
							24.592096
						],
						[
							-81.79807226599996,
							24.59226947600007
						],
						[
							-81.798843,
							24.592344
						],
						[
							-81.799596,
							24.593285
						],
						[
							-81.79902000000001,
							24.594171000000003
						],
						[
							-81.79663100000002,
							24.594749
						],
						[
							-81.795873,
							24.594043
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Monroe",
				"City": "Key West",
				"Name": "Trumbo Point",
				"RegionID": "761121"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.812612066,
					24.54396,
					-81.79719477499998,
					24.558321926000076
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.80312243499998,
							24.55415801000004
						],
						[
							-81.80357106999998,
							24.553871710000067
						],
						[
							-81.80526395499999,
							24.552791382000066
						],
						[
							-81.80601556299996,
							24.552311737000025
						],
						[
							-81.80579665199997,
							24.552083309000068
						],
						[
							-81.80595845499994,
							24.551150560000053
						],
						[
							-81.80599652699993,
							24.550598525000055
						],
						[
							-81.80615833,
							24.550379615000054
						],
						[
							-81.80589183099994,
							24.55005600800007
						],
						[
							-81.80513992099998,
							24.55049382900006
						],
						[
							-81.80492100999999,
							24.550246365000078
						],
						[
							-81.80477824299999,
							24.55027491900006
						],
						[
							-81.80238926399994,
							24.547048370000027
						],
						[
							-81.80088544499996,
							24.548019190000048
						],
						[
							-81.80037148099996,
							24.54732438700006
						],
						[
							-81.79995269599993,
							24.54751474400007
						],
						[
							-81.79978137499995,
							24.547286316000054
						],
						[
							-81.79946979199997,
							24.54748661900004
						],
						[
							-81.79858212599999,
							24.548057261000057
						],
						[
							-81.79719477499998,
							24.54615778400006
						],
						[
							-81.79765879399997,
							24.546355018000042
						],
						[
							-81.79872585499999,
							24.546282919000078
						],
						[
							-81.80208565499998,
							24.545533092000028
						],
						[
							-81.80306619699996,
							24.545172599000068
						],
						[
							-81.802897,
							24.544469
						],
						[
							-81.80335882399999,
							24.544398906000026
						],
						[
							-81.80361398499997,
							24.544360178000034
						],
						[
							-81.80406530399995,
							24.544076867000058
						],
						[
							-81.804922,
							24.54396
						],
						[
							-81.80528683699998,
							24.54430741400006
						],
						[
							-81.80545987399995,
							24.544639068000038
						],
						[
							-81.80566175099995,
							24.545100500000046
						],
						[
							-81.81079517899997,
							24.54514375900004
						],
						[
							-81.81220831399997,
							24.545504253000047
						],
						[
							-81.812612066,
							24.545475413000077
						],
						[
							-81.81194875799997,
							24.549484102000065
						],
						[
							-81.81164594399996,
							24.549772496000063
						],
						[
							-81.81163152399995,
							24.550392545000022
						],
						[
							-81.81176130199998,
							24.551055853000037
						],
						[
							-81.81164594399996,
							24.551272150000045
						],
						[
							-81.81125661099998,
							24.55381002400003
						],
						[
							-81.81042026599994,
							24.55535293700007
						],
						[
							-81.80991557499993,
							24.555107801000077
						],
						[
							-81.81066540099994,
							24.553593728000067
						],
						[
							-81.81122777099995,
							24.551272150000045
						],
						[
							-81.81121335099994,
							24.55088281700006
						],
						[
							-81.81011745099994,
							24.549729237000065
						],
						[
							-81.80759399599998,
							24.551300989000026
						],
						[
							-81.80695952699995,
							24.551113532000045
						],
						[
							-81.80690184799994,
							24.551358668000034
						],
						[
							-81.80759399599998,
							24.55169032200007
						],
						[
							-81.80782471199996,
							24.556016245000027
						],
						[
							-81.80794006999997,
							24.557256343000063
						],
						[
							-81.80766637799996,
							24.55813438100006
						],
						[
							-81.80756628599994,
							24.558100831000047
						],
						[
							-81.80665427199995,
							24.558128468000064
						],
						[
							-81.80632263099994,
							24.558321926000076
						],
						[
							-81.80312243499998,
							24.55415801000004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Monroe",
				"City": "Key West",
				"Name": "Truman Annex",
				"RegionID": "761123"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.183268,
					26.173562,
					-80.17093524499995,
					26.180491880000034
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.17101595999998,
							26.17700499700004
						],
						[
							-80.17102033199996,
							26.176003958000024
						],
						[
							-80.17102194299997,
							26.175634943000034
						],
						[
							-80.17102738099999,
							26.174389533000067
						],
						[
							-80.17122255499999,
							26.174332062000076
						],
						[
							-80.17142832899998,
							26.174271469000075
						],
						[
							-80.17162939299999,
							26.174212263000072
						],
						[
							-80.17166485799999,
							26.17418566400005
						],
						[
							-80.17188460099999,
							26.174020856000027
						],
						[
							-80.17201682399997,
							26.173921689000053
						],
						[
							-80.17218418999994,
							26.173902378000037
						],
						[
							-80.17273084999994,
							26.173864688000037
						],
						[
							-80.17280318199994,
							26.173862581000037
						],
						[
							-80.17336746199999,
							26.173846146000077
						],
						[
							-80.17674821599996,
							26.17374767800004
						],
						[
							-80.17823664499997,
							26.173704326000063
						],
						[
							-80.1790874499999,
							26.17367965400007
						],
						[
							-80.18240535699994,
							26.17358396900005
						],
						[
							-80.183168,
							26.173562
						],
						[
							-80.183177,
							26.173825
						],
						[
							-80.183268,
							26.180361
						],
						[
							-80.17692553699999,
							26.180428309000035
						],
						[
							-80.17093524499995,
							26.180491880000034
						],
						[
							-80.17101595999998,
							26.17700499700004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Oakland Park",
				"Name": "Lake Emerald",
				"RegionID": "761148"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.13146830599999,
					26.162562,
					-80.121866,
					26.16686183300004
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-80.13122354099994,
								26.16273882400003
							],
							[
								-80.13129675199997,
								26.163460930000042
							],
							[
								-80.13135408999996,
								26.16583091700005
							],
							[
								-80.13135526099995,
								26.166726254000025
							],
							[
								-80.12352332699999,
								26.16685106600005
							],
							[
								-80.12245805699996,
								26.166858545000025
							],
							[
								-80.12215124199997,
								26.16686069900004
							],
							[
								-80.12196599299995,
								26.16686183300004
							],
							[
								-80.12187640499997,
								26.164532520000026
							],
							[
								-80.121866,
								26.164262000000004
							],
							[
								-80.12269286399999,
								26.16444574800005
							],
							[
								-80.12332357999998,
								26.16458590700006
							],
							[
								-80.12374405699995,
								26.16467934600007
							],
							[
								-80.124566,
								26.164862
							],
							[
								-80.124618,
								26.164817
							],
							[
								-80.12492638299994,
								26.164549720000025
							],
							[
								-80.12578247399995,
								26.163807736000024
							],
							[
								-80.126066,
								26.163562
							],
							[
								-80.12627529699995,
								26.163631766000037
							],
							[
								-80.126666,
								26.163762
							],
							[
								-80.126766,
								26.163862
							],
							[
								-80.12696600000001,
								26.163562
							],
							[
								-80.12714930099997,
								26.163786035000044
							],
							[
								-80.12733054999995,
								26.164007561000062
							],
							[
								-80.12746792499996,
								26.164175464000042
							],
							[
								-80.127866,
								26.164662
							],
							[
								-80.12809547999997,
								26.164747963000025
							],
							[
								-80.128488,
								26.164895
							],
							[
								-80.128666,
								26.164962
							],
							[
								-80.12926084399999,
								26.164282178000065
							],
							[
								-80.12958036299995,
								26.164128935000065
							],
							[
								-80.12985327999996,
								26.16408683800006
							],
							[
								-80.13013101199994,
								26.164044080000053
							],
							[
								-80.13033849199996,
								26.164012257000024
							],
							[
								-80.130667,
								26.163962
							],
							[
								-80.13052709999994,
								26.16381145500003
							],
							[
								-80.13041637799995,
								26.16342875600003
							],
							[
								-80.12970569599997,
								26.16292754500006
							],
							[
								-80.129366,
								26.162562
							],
							[
								-80.12965304699998,
								26.162589325000056
							],
							[
								-80.13008956199997,
								26.162630878000073
							],
							[
								-80.13063806299994,
								26.162683091000076
							],
							[
								-80.13122354099994,
								26.16273882400003
							]
						]
					],
					[
						[
							[
								-80.13122354099994,
								26.16273882400003
							],
							[
								-80.131467,
								26.162762
							],
							[
								-80.13146830599999,
								26.16279430000003
							],
							[
								-80.13122354099994,
								26.16273882400003
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Oakland Park",
				"Name": "Coral Brook",
				"RegionID": "761153"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.138767,
					26.16273882400003,
					-80.13122354099994,
					26.166726254000025
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.13122354099994,
							26.16273882400003
						],
						[
							-80.13146830599999,
							26.16279430000003
						],
						[
							-80.131767,
							26.162862
						],
						[
							-80.13202399099998,
							26.162911421000047
						],
						[
							-80.13276343599995,
							26.163053622000064
						],
						[
							-80.13332625299995,
							26.163161856000045
						],
						[
							-80.13396391199996,
							26.16328448300004
						],
						[
							-80.13475305199995,
							26.163436241000056
						],
						[
							-80.13628882299997,
							26.163731581000036
						],
						[
							-80.13665501699995,
							26.163802003000058
						],
						[
							-80.136967,
							26.163862
						],
						[
							-80.13722686699998,
							26.163847563000047
						],
						[
							-80.13800471199994,
							26.16380434900003
						],
						[
							-80.13840755799998,
							26.16378196900007
						],
						[
							-80.138767,
							26.163762
						],
						[
							-80.13873801899996,
							26.164573463000067
						],
						[
							-80.138667,
							26.166562
						],
						[
							-80.13840174699999,
							26.16656802600005
						],
						[
							-80.13760539299994,
							26.166586116000076
						],
						[
							-80.13532486699995,
							26.166637922000064
						],
						[
							-80.13290173799999,
							26.166692967000074
						],
						[
							-80.13162703999996,
							26.166720404000046
						],
						[
							-80.13135526099995,
							26.166726254000025
						],
						[
							-80.13135408999996,
							26.16583091700005
						],
						[
							-80.13129675199997,
							26.163460930000042
						],
						[
							-80.13122354099994,
							26.16273882400003
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Oakland Park",
				"Name": "Rivers Edge",
				"RegionID": "761155"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.77985783699995,
					27.776041259000067,
					-82.76092573599999,
					27.787947272000054
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.77295322199996,
							27.776041259000067
						],
						[
							-82.77361175099999,
							27.77661816500006
						],
						[
							-82.77419328399998,
							27.776488936000078
						],
						[
							-82.77488250699997,
							27.776553550000077
						],
						[
							-82.77537788599994,
							27.777307388000054
						],
						[
							-82.77617479999998,
							27.777673538000045
						],
						[
							-82.77912553699997,
							27.780042743000024
						],
						[
							-82.77985783699995,
							27.782218104000037
						],
						[
							-82.77959937799994,
							27.783338092000065
						],
						[
							-82.77914707599996,
							27.784264235000023
						],
						[
							-82.77531327099996,
							27.784350388000064
						],
						[
							-82.76553491699997,
							27.787947272000054
						],
						[
							-82.76092573599999,
							27.781744263000068
						],
						[
							-82.77295322199996,
							27.776041259000067
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Pinellas",
				"City": "Treasure Island",
				"Name": "Isle of Capri",
				"RegionID": "761162"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.35581762499999,
					29.688561806000056,
					-82.33901370299998,
					29.69591126700004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.35580572799995,
							29.69583105900006
						],
						[
							-82.35373040599995,
							29.695878969000038
						],
						[
							-82.34941522399998,
							29.695911172000027
						],
						[
							-82.33910001199996,
							29.69591126700004
						],
						[
							-82.33901370299998,
							29.68856892200006
						],
						[
							-82.35581762499999,
							29.688561806000056
						],
						[
							-82.35580572799995,
							29.69583105900006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Alachua",
				"City": "Gainesville",
				"Name": "Hazel Heights",
				"RegionID": "761430"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.33913448399994,
					29.673997133000054,
					-82.32604154099994,
					29.688586191000066
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.33315938399994,
							29.674029482000037
						],
						[
							-82.33363582699997,
							29.67402933500006
						],
						[
							-82.33913448399994,
							29.674022541000056
						],
						[
							-82.33901370299998,
							29.68856892200006
						],
						[
							-82.32859344999997,
							29.688586191000066
						],
						[
							-82.32857641899994,
							29.68713855300007
						],
						[
							-82.32833690299998,
							29.68717847200003
						],
						[
							-82.32807742699998,
							29.686439964000044
						],
						[
							-82.32763831399996,
							29.686380085000053
						],
						[
							-82.32725908099997,
							29.68586113300006
						],
						[
							-82.32604154099994,
							29.68572141600004
						],
						[
							-82.32622917199997,
							29.682949525000026
						],
						[
							-82.32795766899994,
							29.683046819000026
						],
						[
							-82.32787783099997,
							29.681769400000064
						],
						[
							-82.32831694299995,
							29.681769400000064
						],
						[
							-82.32869268999997,
							29.673997133000054
						],
						[
							-82.33043534199999,
							29.673997300000053
						],
						[
							-82.33079604899996,
							29.673997334000035
						],
						[
							-82.33292410299998,
							29.67402955400007
						],
						[
							-82.33315938399994,
							29.674029482000037
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Alachua",
				"City": "Gainesville",
				"Name": "Stephen Foster",
				"RegionID": "761432"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.32398496399998,
					29.651998457000047,
					-82.31474900999996,
					29.66386258700004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.31474900999996,
							29.651998457000047
						],
						[
							-82.32398496399998,
							29.652004272000056
						],
						[
							-82.32397087099997,
							29.65414172200008
						],
						[
							-82.32398248799996,
							29.659237550000057
						],
						[
							-82.32317242799996,
							29.659248646000034
						],
						[
							-82.32312604799995,
							29.663499778000073
						],
						[
							-82.32295657499998,
							29.663499778000073
						],
						[
							-82.32296775099996,
							29.663785734000044
						],
						[
							-82.31478288699998,
							29.66386258700004
						],
						[
							-82.31479708599994,
							29.661177432000045
						],
						[
							-82.31474900999996,
							29.651998457000047
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Alachua",
				"City": "Gainesville",
				"Name": "Duckpond",
				"RegionID": "761437"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.39774075399998,
					29.651780006000024,
					-82.39333980199996,
					29.65847010600004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.39338414099996,
							29.65697961600006
						],
						[
							-82.39333980199996,
							29.651780006000024
						],
						[
							-82.39370343099995,
							29.651785998000037
						],
						[
							-82.39429270399995,
							29.651795708000066
						],
						[
							-82.39772891699994,
							29.651852333000082
						],
						[
							-82.39774075399998,
							29.65616619500003
						],
						[
							-82.39750290799998,
							29.65622215800005
						],
						[
							-82.39742336699999,
							29.65847010600004
						],
						[
							-82.39338414099996,
							29.65697961600006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Alachua",
				"City": "Gainesville",
				"Name": "Mill Pond",
				"RegionID": "761439"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.36123186399999,
					29.652004631000068,
					-82.35652345199998,
					29.656225931000055
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.35719153899998,
							29.656167115000077
						],
						[
							-82.35667757499994,
							29.65611000800004
						],
						[
							-82.35682281699997,
							29.653459138000077
						],
						[
							-82.35668599799999,
							29.653114116000044
						],
						[
							-82.35652538399995,
							29.65289401600006
						],
						[
							-82.35652345199998,
							29.652088511000045
						],
						[
							-82.35704646099998,
							29.652079135000065
						],
						[
							-82.35753048899994,
							29.65211122400007
						],
						[
							-82.35867658099994,
							29.652187206000065
						],
						[
							-82.35995681199995,
							29.652203159000067
						],
						[
							-82.36017217799997,
							29.65215530000006
						],
						[
							-82.36050719199994,
							29.652083511000058
						],
						[
							-82.36118270499998,
							29.652004631000068
						],
						[
							-82.36118291699995,
							29.652023778000057
						],
						[
							-82.36123186399999,
							29.655843508000032
						],
						[
							-82.35991840099996,
							29.655900615000064
						],
						[
							-82.35935081999997,
							29.656225931000055
						],
						[
							-82.35719153899998,
							29.656167115000077
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Alachua",
				"City": "Gainesville",
				"Name": "Palm Terrace",
				"RegionID": "761446"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.39361901299998,
					29.659623615000047,
					-82.38907662699995,
					29.66398210500006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.38988948699995,
							29.66396194500004
						],
						[
							-82.38914176499998,
							29.663958159000057
						],
						[
							-82.38914176499998,
							29.663746141000047
						],
						[
							-82.38914176499998,
							29.66350255800006
						],
						[
							-82.38914176499998,
							29.66281779800005
						],
						[
							-82.38950287399996,
							29.66283464700007
						],
						[
							-82.39043475399995,
							29.662855384000068
						],
						[
							-82.39042950899994,
							29.661675585000072
						],
						[
							-82.38907662699995,
							29.661592681000062
						],
						[
							-82.38921244799997,
							29.659623615000047
						],
						[
							-82.39228863099999,
							29.659625235000078
						],
						[
							-82.39242430499996,
							29.661064496000048
						],
						[
							-82.39361901299998,
							29.661223790000065
						],
						[
							-82.39358646099998,
							29.663662646000034
						],
						[
							-82.39358206299994,
							29.66398210500006
						],
						[
							-82.39345243399998,
							29.663979985000026
						],
						[
							-82.39075991799996,
							29.66396635200005
						],
						[
							-82.38988948699995,
							29.66396194500004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Alachua",
				"City": "Gainesville",
				"Name": "Landmark Woods",
				"RegionID": "761448"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.39692436999997,
					29.698578310000077,
					-82.39228492299999,
					29.70325758100006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.39688454699996,
							29.69871769300005
						],
						[
							-82.39692436999997,
							29.703197846000027
						],
						[
							-82.39347962999994,
							29.70325758100006
						],
						[
							-82.39365883599999,
							29.702341639000053
						],
						[
							-82.39322077699995,
							29.70224208000008
						],
						[
							-82.39274289399998,
							29.701604902000046
						],
						[
							-82.39276280599995,
							29.70124649000007
						],
						[
							-82.39228492299999,
							29.70108719600006
						],
						[
							-82.39257204999996,
							29.700594364000043
						],
						[
							-82.39399733699997,
							29.700509754000052
						],
						[
							-82.39447521999995,
							29.70066904800007
						],
						[
							-82.39527169199994,
							29.70082834300007
						],
						[
							-82.39555045699996,
							29.70082834300007
						],
						[
							-82.39572966299994,
							29.70058940100006
						],
						[
							-82.39576948599995,
							29.70027081200004
						],
						[
							-82.39491327899998,
							29.70015134200003
						],
						[
							-82.39495310299998,
							29.69923539900003
						],
						[
							-82.39501283799996,
							29.698837163000068
						],
						[
							-82.39555045699996,
							29.698578310000077
						],
						[
							-82.39688454699996,
							29.69871769300005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Alachua",
				"City": "Gainesville",
				"Name": "Kensington Park",
				"RegionID": "761455"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.36146389299995,
					29.70652294000007,
					-82.35379290999998,
					29.717546476000052
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.36137062999995,
							29.709793609000034
						],
						[
							-82.36146389299995,
							29.717131305000066
						],
						[
							-82.36073283099995,
							29.717185458000074
						],
						[
							-82.36024244799995,
							29.717546476000052
						],
						[
							-82.35379290999998,
							29.71216499400003
						],
						[
							-82.35433975499996,
							29.70935925700007
						],
						[
							-82.35533912899996,
							29.707636528000023
						],
						[
							-82.35688101899996,
							29.70652294000007
						],
						[
							-82.35773048699997,
							29.707435463000024
						],
						[
							-82.35835866499997,
							29.707010729000046
						],
						[
							-82.36046448799995,
							29.707028575000038
						],
						[
							-82.36045304199996,
							29.709763524000035
						],
						[
							-82.36137062999995,
							29.709793609000034
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Alachua",
				"City": "Gainesville",
				"Name": "Pinderidge",
				"RegionID": "761457"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.27132913199995,
					26.13063921300005,
					-80.25672731999998,
					26.14854732400005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.26401262,
							26.13112321600005
						],
						[
							-80.26455308999994,
							26.13063921300005
						],
						[
							-80.26700537199997,
							26.132752693000043
						],
						[
							-80.26787657699998,
							26.13359969800007
						],
						[
							-80.26886678399995,
							26.134547999000063
						],
						[
							-80.26988518999997,
							26.135519576000036
						],
						[
							-80.27051984699996,
							26.13659582200006
						],
						[
							-80.27096395299998,
							26.137533380000036
						],
						[
							-80.27125653199994,
							26.138504262000026
						],
						[
							-80.27132913199995,
							26.13969006900004
						],
						[
							-80.27124039799997,
							26.14042414000005
						],
						[
							-80.27109519699997,
							26.14116627800007
						],
						[
							-80.27019979199997,
							26.143142624000063
						],
						[
							-80.26930438599999,
							26.144868901000052
						],
						[
							-80.26880425,
							26.145901441000035
						],
						[
							-80.26847351399994,
							26.14673231300003
						],
						[
							-80.26736837399994,
							26.146772646000045
						],
						[
							-80.26632550899996,
							26.14690895700005
						],
						[
							-80.26473862499995,
							26.147563184000035
						],
						[
							-80.26256061099997,
							26.148176255000067
						],
						[
							-80.26124295999995,
							26.148389312000063
						],
						[
							-80.26039873099995,
							26.14854732400005
						],
						[
							-80.25708330999998,
							26.14853925700004
						],
						[
							-80.25682517599995,
							26.138367127000038
						],
						[
							-80.25676642099995,
							26.135745143000065
						],
						[
							-80.25676496399996,
							26.135680137000065
						],
						[
							-80.25672731999998,
							26.13427185200004
						],
						[
							-80.26055212799997,
							26.13363511400007
						],
						[
							-80.26176108399994,
							26.13299362700008
						],
						[
							-80.26311807499997,
							26.13190803400005
						],
						[
							-80.26401262,
							26.13112321600005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Plantation",
				"Name": "Lauderdale West",
				"RegionID": "761598"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.25339226199998,
					25.933685337000046,
					-80.24337985099999,
					25.944647264000025
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.24337985099999,
							25.941007697000032
						],
						[
							-80.24446190399993,
							25.940932350000026
						],
						[
							-80.24461572699994,
							25.940927603000038
						],
						[
							-80.24479337099997,
							25.940916853000033
						],
						[
							-80.24525765999994,
							25.940877768000068
						],
						[
							-80.24525768499996,
							25.940850478000073
						],
						[
							-80.24525771499998,
							25.940817448000075
						],
						[
							-80.24525795299996,
							25.940557239000043
						],
						[
							-80.24525870099997,
							25.939737723000064
						],
						[
							-80.24520311899994,
							25.937258757000052
						],
						[
							-80.24491409099994,
							25.93369920700008
						],
						[
							-80.24508480599997,
							25.93369920700008
						],
						[
							-80.24524685799997,
							25.93369920700008
						],
						[
							-80.24553711199997,
							25.933693625000046
						],
						[
							-80.24596811199996,
							25.933685337000046
						],
						[
							-80.24615055599998,
							25.937251348000075
						],
						[
							-80.24889585899996,
							25.93715319100005
						],
						[
							-80.24892588499995,
							25.93715211400007
						],
						[
							-80.25191997699996,
							25.937044267000033
						],
						[
							-80.25318502699997,
							25.937017351000065
						],
						[
							-80.25330975899999,
							25.93933932500005
						],
						[
							-80.25339226199998,
							25.94068122500005
						],
						[
							-80.25244251799995,
							25.94070440300004
						],
						[
							-80.24736415399997,
							25.940825993000033
						],
						[
							-80.24735928599995,
							25.94147828100006
						],
						[
							-80.24754913099997,
							25.94163405100005
						],
						[
							-80.24765622299998,
							25.942661162000036
						],
						[
							-80.24779252199994,
							25.942855875000078
						],
						[
							-80.24783146499999,
							25.94325503600004
						],
						[
							-80.24696985999998,
							25.943240433000028
						],
						[
							-80.24546083499996,
							25.94326964000004
						],
						[
							-80.24550653399997,
							25.944522775000056
						],
						[
							-80.24349396599997,
							25.944647264000025
						],
						[
							-80.24338585599997,
							25.94119921500004
						],
						[
							-80.24338446499996,
							25.94115485900005
						],
						[
							-80.24337985099999,
							25.941007697000032
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Gardens",
				"Name": "Town Center",
				"RegionID": "761641"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.26951734399995,
					25.94008553200007,
					-80.26513523499995,
					25.94333504100007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.26516692499996,
							25.940407804000074
						],
						[
							-80.26513523499995,
							25.940199541000027
						],
						[
							-80.26553904299999,
							25.940204357000027
						],
						[
							-80.26587740299993,
							25.94019378300004
						],
						[
							-80.26669044999994,
							25.94016837600003
						],
						[
							-80.26849941099994,
							25.940112421000038
						],
						[
							-80.26868778499994,
							25.940106594000046
						],
						[
							-80.26908981999998,
							25.94009415800008
						],
						[
							-80.26936868599995,
							25.94008553200007
						],
						[
							-80.26940095599997,
							25.940444928000034
						],
						[
							-80.26941210799998,
							25.941091760000063
						],
						[
							-80.26947877499998,
							25.942417679000073
						],
						[
							-80.26949318099997,
							25.942704201000026
						],
						[
							-80.26951734399995,
							25.943171693000068
						],
						[
							-80.26796825899999,
							25.94325110500006
						],
						[
							-80.26528758199998,
							25.94333504100007
						],
						[
							-80.26516692499996,
							25.940407804000074
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Gardens",
				"Name": "Garden Cicle",
				"RegionID": "761646"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.24665799,
					25.96061813500006,
					-80.22930317199996,
					25.968384874000037
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.22949789799998,
							25.96837820500008
						],
						[
							-80.22949071099998,
							25.96808614200006
						],
						[
							-80.22946208099995,
							25.966922656000065
						],
						[
							-80.22941866899998,
							25.965158410000072
						],
						[
							-80.22939325199997,
							25.96432495600004
						],
						[
							-80.229348385,
							25.961175312000023
						],
						[
							-80.22930317199996,
							25.96061813500006
						],
						[
							-80.22943324799996,
							25.960623670000075
						],
						[
							-80.22968905099998,
							25.960630687000048
						],
						[
							-80.23331736699998,
							25.960730217000048
						],
						[
							-80.23618008199998,
							25.960808745000065
						],
						[
							-80.24457576699996,
							25.961178895000046
						],
						[
							-80.24526925499998,
							25.961226501000056
						],
						[
							-80.24648366399998,
							25.96130986800006
						],
						[
							-80.24648875899999,
							25.962168419000022
						],
						[
							-80.24665799,
							25.965707913000074
						],
						[
							-80.24580270399997,
							25.965778599000032
						],
						[
							-80.24101336299998,
							25.966006427000025
						],
						[
							-80.23838838699999,
							25.966239208000047
						],
						[
							-80.23841270099997,
							25.967798564000077
						],
						[
							-80.23838530899997,
							25.968058709000047
						],
						[
							-80.23838423399997,
							25.96806891400007
						],
						[
							-80.23399264599999,
							25.968238834000037
						],
						[
							-80.23021822799996,
							25.968384874000037
						],
						[
							-80.22949789799998,
							25.96837820500008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Gardens",
				"Name": "Lake Lucerne",
				"RegionID": "761648"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.21577183199997,
					25.925927,
					-80.201798,
					25.942665
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.201798,
							25.936185
						],
						[
							-80.20306,
							25.936132
						],
						[
							-80.2031,
							25.936129
						],
						[
							-80.203045,
							25.935201
						],
						[
							-80.20303417199995,
							25.935013087000073
						],
						[
							-80.203001,
							25.933576
						],
						[
							-80.203091,
							25.933334
						],
						[
							-80.20407530399996,
							25.932309779000036
						],
						[
							-80.205042,
							25.931529
						],
						[
							-80.206182,
							25.931528
						],
						[
							-80.208579,
							25.931414
						],
						[
							-80.20845,
							25.92946
						],
						[
							-80.20898,
							25.928198
						],
						[
							-80.209248,
							25.928011
						],
						[
							-80.209445,
							25.927858
						],
						[
							-80.21054801999998,
							25.926930797000068
						],
						[
							-80.21067458599998,
							25.926828512000043
						],
						[
							-80.210771,
							25.926758
						],
						[
							-80.210989,
							25.926622
						],
						[
							-80.211762,
							25.925974
						],
						[
							-80.211819,
							25.925927
						],
						[
							-80.21189774399994,
							25.926560833000053
						],
						[
							-80.21211270699996,
							25.92843276600007
						],
						[
							-80.21213632699994,
							25.928638453000076
						],
						[
							-80.21222267899998,
							25.929390426000055
						],
						[
							-80.21223822599995,
							25.92960541000008
						],
						[
							-80.21227344799996,
							25.930092454000032
						],
						[
							-80.21299904399996,
							25.931426827000053
						],
						[
							-80.21344947699998,
							25.932391283000072
						],
						[
							-80.21429072799998,
							25.933367134000036
						],
						[
							-80.21574865999997,
							25.93477673600006
						],
						[
							-80.21577183199997,
							25.934799140000052
						],
						[
							-80.21381073899994,
							25.934851726000034
						],
						[
							-80.212782813,
							25.934879289000037
						],
						[
							-80.21294798499997,
							25.936724309000056
						],
						[
							-80.20621556499998,
							25.937064751000037
						],
						[
							-80.20494752799993,
							25.937128872000073
						],
						[
							-80.20517993399996,
							25.941725344000076
						],
						[
							-80.20521362299996,
							25.942391645000043
						],
						[
							-80.20522298699996,
							25.94257684300004
						],
						[
							-80.20330605999999,
							25.942629554000064
						],
						[
							-80.20251133199997,
							25.942651407000028
						],
						[
							-80.202017,
							25.942665
						],
						[
							-80.201798,
							25.936185
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Gardens",
				"Name": "Golden Glades",
				"RegionID": "761655"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.25528975699996,
					25.911412,
					-80.244164,
					25.92645929100007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.24434370899996,
							25.91541189900005
						],
						[
							-80.24428296299999,
							25.91457360900006
						],
						[
							-80.24426299099997,
							25.914132892000055
						],
						[
							-80.24422487199996,
							25.913291710000067
						],
						[
							-80.244164,
							25.911825
						],
						[
							-80.24429577599994,
							25.91181950500004
						],
						[
							-80.24479838899998,
							25.911798548000036
						],
						[
							-80.24565095899999,
							25.911765485000046
						],
						[
							-80.24615100000001,
							25.911755
						],
						[
							-80.248158,
							25.911679
						],
						[
							-80.249881,
							25.911607
						],
						[
							-80.25076819299994,
							25.911567037000054
						],
						[
							-80.25150065699995,
							25.911540930000058
						],
						[
							-80.252101,
							25.911522
						],
						[
							-80.25397992299997,
							25.91145256300007
						],
						[
							-80.25437400799996,
							25.911438237000027
						],
						[
							-80.25511800000001,
							25.911412
						],
						[
							-80.25518642299994,
							25.912487545000033
						],
						[
							-80.25522666599994,
							25.913244613000074
						],
						[
							-80.25528975699996,
							25.91443152100004
						],
						[
							-80.25527696599994,
							25.91514674600006
						],
						[
							-80.25458576899996,
							25.915154493000045
						],
						[
							-80.25223081399997,
							25.915180887000076
						],
						[
							-80.25227656899995,
							25.91598160500007
						],
						[
							-80.25261973399995,
							25.92430906800007
						],
						[
							-80.25266317099994,
							25.926036839000062
						],
						[
							-80.25196282899998,
							25.92616554600005
						],
						[
							-80.24560276599993,
							25.926421524000034
						],
						[
							-80.24487328699996,
							25.926449390000073
						],
						[
							-80.24461407999996,
							25.92645929100007
						],
						[
							-80.24452594599995,
							25.919153833000053
						],
						[
							-80.24436072799995,
							25.91576135300005
						],
						[
							-80.24435316199998,
							25.91560599600007
						],
						[
							-80.24434370899996,
							25.91541189900005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Gardens",
				"Name": "Pine Tree Park/ Golden Highlands",
				"RegionID": "761657"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.183268,
					26.180361,
					-80.17093524499995,
					26.18608
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.170968,
							26.183072
						],
						[
							-80.17096447399996,
							26.182794288000025
						],
						[
							-80.17096307099996,
							26.182683737000048
						],
						[
							-80.17093524499995,
							26.180491880000034
						],
						[
							-80.17692553699999,
							26.180428309000035
						],
						[
							-80.183268,
							26.180361
						],
						[
							-80.18317161999994,
							26.181266743000037
						],
						[
							-80.18314901499997,
							26.183155780000053
						],
						[
							-80.183142,
							26.183742
						],
						[
							-80.18313496699994,
							26.184043985000073
						],
						[
							-80.18311118799994,
							26.18506511100003
						],
						[
							-80.18309585699996,
							26.185723447000044
						],
						[
							-80.183091,
							26.185932
						],
						[
							-80.18165371899994,
							26.18592725900004
						],
						[
							-80.18107257099996,
							26.185925342000075
						],
						[
							-80.18067870199997,
							26.18586381500006
						],
						[
							-80.18031994799998,
							26.185788201000037
						],
						[
							-80.180096,
							26.185741
						],
						[
							-80.17965438899995,
							26.185710389000064
						],
						[
							-80.179115,
							26.185673
						],
						[
							-80.17844062399996,
							26.18572365400007
						],
						[
							-80.17801,
							26.185756
						],
						[
							-80.17777115099994,
							26.185838705000037
						],
						[
							-80.177314,
							26.185997
						],
						[
							-80.176726,
							26.186043
						],
						[
							-80.176468,
							26.18608
						],
						[
							-80.175868,
							26.186076000000003
						],
						[
							-80.175772,
							26.186075
						],
						[
							-80.175646,
							26.185861
						],
						[
							-80.17556,
							26.185732
						],
						[
							-80.17540471699995,
							26.18554700800007
						],
						[
							-80.175168,
							26.185265
						],
						[
							-80.17496418999997,
							26.185101081000028
						],
						[
							-80.17469889999995,
							26.18488771400007
						],
						[
							-80.17434326099999,
							26.18460168300004
						],
						[
							-80.173671,
							26.184061000000003
						],
						[
							-80.17331656299996,
							26.183931315000052
						],
						[
							-80.17283978899997,
							26.183756868000046
						],
						[
							-80.171973408,
							26.18343986800005
						],
						[
							-80.170968,
							26.183072
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Oakland Park",
				"Name": "Oaktree Estates",
				"RegionID": "761964"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.25468544299997,
					25.947885057000068,
					-80.24571254299997,
					25.96149377100005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.24648366399998,
							25.96130986800006
						],
						[
							-80.24657794499996,
							25.96015256900006
						],
						[
							-80.24647699499998,
							25.959647818000068
						],
						[
							-80.24592568699995,
							25.95572316500005
						],
						[
							-80.24589284899997,
							25.955450462000044
						],
						[
							-80.24582563899997,
							25.95239934900008
						],
						[
							-80.24571254299997,
							25.948195600000076
						],
						[
							-80.24765513299997,
							25.948099406000043
						],
						[
							-80.24805215499998,
							25.948083568000072
						],
						[
							-80.25259947099994,
							25.947922782000035
						],
						[
							-80.25288590999997,
							25.947912654000053
						],
						[
							-80.25366641699998,
							25.947885057000068
						],
						[
							-80.25366430499997,
							25.948700218000056
						],
						[
							-80.25380051799993,
							25.951316758000075
						],
						[
							-80.25386176,
							25.95182148200007
						],
						[
							-80.25388499,
							25.95239061600006
						],
						[
							-80.25389554899994,
							25.952682047000053
						],
						[
							-80.25395550999997,
							25.953695794000055
						],
						[
							-80.25400747599997,
							25.953918515000055
						],
						[
							-80.25409089199997,
							25.954330319000064
						],
						[
							-80.25425455799996,
							25.954986038000072
						],
						[
							-80.25426169799994,
							25.955017157000043
						],
						[
							-80.25431694699995,
							25.955257973000073
						],
						[
							-80.25435838499999,
							25.95543858900004
						],
						[
							-80.25437418199994,
							25.955689816000074
						],
						[
							-80.25450757999994,
							25.95615670600006
						],
						[
							-80.25462986099996,
							25.956656946000066
						],
						[
							-80.25464097699995,
							25.957257234000053
						],
						[
							-80.25468544299997,
							25.957612960000063
						],
						[
							-80.25464097699995,
							25.958191015000068
						],
						[
							-80.25457427799995,
							25.958769070000073
						],
						[
							-80.25440490399995,
							25.959321765000027
						],
						[
							-80.25436306599994,
							25.959458289000054
						],
						[
							-80.25430928899995,
							25.959848951000026
						],
						[
							-80.25418780199999,
							25.960749381000028
						],
						[
							-80.25418205899996,
							25.96149377100005
						],
						[
							-80.25392731399995,
							25.961481438000078
						],
						[
							-80.25367062399994,
							25.96147477100004
						],
						[
							-80.25306331499996,
							25.961458998000072
						],
						[
							-80.25138835799999,
							25.961415497000075
						],
						[
							-80.24836139699994,
							25.961347146000037
						],
						[
							-80.24671018999999,
							25.961314365000078
						],
						[
							-80.24648366399998,
							25.96130986800006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Gardens",
				"Name": "Lesile Estates",
				"RegionID": "761973"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.10293917099995,
					26.897285728000043,
					-80.09446793999996,
					26.910755882000046
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.09460619999999,
							26.907826081000053
						],
						[
							-80.09509654699997,
							26.89743539600005
						],
						[
							-80.09647620099997,
							26.89740906700007
						],
						[
							-80.09647349599999,
							26.897465330000045
						],
						[
							-80.10293917099995,
							26.897285728000043
						],
						[
							-80.10281943599995,
							26.901775779000047
						],
						[
							-80.10293917099995,
							26.910127275000036
						],
						[
							-80.09446793999996,
							26.910755882000046
						],
						[
							-80.09460619999999,
							26.907826081000053
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Jupiter",
				"Name": "Admirals Cove Golf Village",
				"RegionID": "761980"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.12749552299994,
					26.901686203000054,
					-80.12060003999996,
					26.91090555100004
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.12365327499998,
							26.901805713000044
						],
						[
							-80.12749127299998,
							26.901686203000054
						],
						[
							-80.12739498499997,
							26.904469810000023
						],
						[
							-80.12749552299994,
							26.91060260300003
						],
						[
							-80.12535949499994,
							26.91090555100004
						],
						[
							-80.12060003999996,
							26.910755882000046
						],
						[
							-80.12060003999996,
							26.909289132000026
						],
						[
							-80.12188718799996,
							26.907822382000063
						],
						[
							-80.12365327499998,
							26.906235897000045
						],
						[
							-80.12416214799998,
							26.90524808600003
						],
						[
							-80.12431181599999,
							26.904320142000074
						],
						[
							-80.12398254599998,
							26.903362264000066
						],
						[
							-80.12377300999998,
							26.90309286100006
						],
						[
							-80.12374307599998,
							26.90252412100006
						],
						[
							-80.12374307599998,
							26.902344519000053
						],
						[
							-80.12365327499998,
							26.901805713000044
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Jupiter",
				"Name": "Martinique",
				"RegionID": "761982"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.12673644399996,
					26.913988720000077,
					-80.11179953899995,
					26.926291461000066
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.11914410999998,
							26.914123932000052
						],
						[
							-80.11988163199999,
							26.913988720000077
						],
						[
							-80.12139493799998,
							26.914534502000038
						],
						[
							-80.12170758599996,
							26.914647260000038
						],
						[
							-80.12272533099997,
							26.915335735000042
						],
						[
							-80.12377300999998,
							26.91545547000004
						],
						[
							-80.12434174999999,
							26.915904475000048
						],
						[
							-80.12491048999993,
							26.916473215000053
						],
						[
							-80.12628743899995,
							26.91770049500008
						],
						[
							-80.12673644399996,
							26.919316914000035
						],
						[
							-80.12664664299996,
							26.92093333300005
						],
						[
							-80.12634730599996,
							26.922250414000075
						],
						[
							-80.12514995899994,
							26.923447761000034
						],
						[
							-80.12380294399998,
							26.924615175000042
						],
						[
							-80.12332400499997,
							26.926291461000066
						],
						[
							-80.11874415199998,
							26.926261527000065
						],
						[
							-80.11775634099996,
							26.926051991000065
						],
						[
							-80.11658892699995,
							26.92485464400005
						],
						[
							-80.11530177899994,
							26.923956634000035
						],
						[
							-80.11401463099997,
							26.92359743000003
						],
						[
							-80.11197914099995,
							26.923417828000026
						],
						[
							-80.11185940599995,
							26.92177147600006
						],
						[
							-80.11179953899995,
							26.91958631700004
						],
						[
							-80.11209887599995,
							26.91868830700003
						],
						[
							-80.11305675399996,
							26.91802976600008
						],
						[
							-80.11401463099997,
							26.917371225000068
						],
						[
							-80.11476297299998,
							26.91683241900006
						],
						[
							-80.11500873499995,
							26.916598088000057
						],
						[
							-80.11605012099994,
							26.915605138000046
						],
						[
							-80.11709779999995,
							26.91491666400003
						],
						[
							-80.11782157599998,
							26.914478012000075
						],
						[
							-80.11808561099997,
							26.91431799000003
						],
						[
							-80.11914410999998,
							26.914123932000052
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Jupiter",
				"Name": "Loxahatchee Club",
				"RegionID": "761984"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.219233,
					26.120897101000025,
					-80.20183852099996,
					26.135958
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.21808717099998,
							26.12095413300006
						],
						[
							-80.21797126099995,
							26.121611006000023
						],
						[
							-80.21760555799995,
							26.125292417000026
						],
						[
							-80.21757388899994,
							26.12590157300008
						],
						[
							-80.21755093999997,
							26.126342989000022
						],
						[
							-80.21753090099998,
							26.12672843200005
						],
						[
							-80.21759365499997,
							26.12819456300008
						],
						[
							-80.21770307899999,
							26.129266391000044
						],
						[
							-80.21775325799996,
							26.12948383500003
						],
						[
							-80.21792851299995,
							26.130243274000065
						],
						[
							-80.21821506299995,
							26.131484989000057
						],
						[
							-80.21851692099995,
							26.132824481000057
						],
						[
							-80.21899522999996,
							26.134946978000073
						],
						[
							-80.21915268499998,
							26.135553583000046
						],
						[
							-80.219233,
							26.135863000000004
						],
						[
							-80.21601032599995,
							26.135863000000004
						],
						[
							-80.215953,
							26.135863000000004
						],
						[
							-80.21506632599994,
							26.135863000000004
						],
						[
							-80.215009,
							26.135863000000004
						],
						[
							-80.20248,
							26.135958
						],
						[
							-80.20250219599995,
							26.134986206000065
						],
						[
							-80.20244570399996,
							26.133432682000034
						],
						[
							-80.20216324499995,
							26.128291930000046
						],
						[
							-80.202135,
							26.126088750000065
						],
						[
							-80.20183852099996,
							26.120937556000058
						],
						[
							-80.21806866499998,
							26.120897101000025
						],
						[
							-80.21805450899996,
							26.120953620000023
						],
						[
							-80.21808717099998,
							26.12095413300006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Broward",
				"City": "Plantation",
				"Name": "Plantation Park East",
				"RegionID": "762064"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.27807902899997,
					25.939857509000035,
					-80.26936868599995,
					25.951367504000075
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.26978013299998,
							25.94728126600006
						],
						[
							-80.26973552399996,
							25.946924393000074
						],
						[
							-80.26951734399995,
							25.943171693000068
						],
						[
							-80.26949318099997,
							25.942704201000026
						],
						[
							-80.26947877499998,
							25.942417679000073
						],
						[
							-80.26941210799998,
							25.941091760000063
						],
						[
							-80.26940095599997,
							25.940444928000034
						],
						[
							-80.26936868599995,
							25.94008553200007
						],
						[
							-80.27626008799996,
							25.939891214000056
						],
						[
							-80.27680377099995,
							25.93987588400006
						],
						[
							-80.27707635999997,
							25.939868198000056
						],
						[
							-80.27745543799996,
							25.939857509000035
						],
						[
							-80.277481,
							25.940371
						],
						[
							-80.27748124899995,
							25.940375053000025
						],
						[
							-80.277518,
							25.940973
						],
						[
							-80.277528,
							25.941132
						],
						[
							-80.277546,
							25.941595
						],
						[
							-80.277585,
							25.941951
						],
						[
							-80.277586,
							25.942303
						],
						[
							-80.277622,
							25.943128
						],
						[
							-80.27764549399996,
							25.94366836900008
						],
						[
							-80.277676,
							25.944370000000003
						],
						[
							-80.27768059199997,
							25.944457413000066
						],
						[
							-80.27775829399997,
							25.946204248000072
						],
						[
							-80.277767,
							25.946592
						],
						[
							-80.277792,
							25.946962
						],
						[
							-80.277827,
							25.947676
						],
						[
							-80.277857,
							25.948366
						],
						[
							-80.277874,
							25.948793
						],
						[
							-80.277991,
							25.949881
						],
						[
							-80.27800692699999,
							25.950074366000024
						],
						[
							-80.278048,
							25.950573
						],
						[
							-80.278063,
							25.950833
						],
						[
							-80.27807902899997,
							25.951087181000048
						],
						[
							-80.27653558199995,
							25.95114087500008
						],
						[
							-80.27212583399995,
							25.95134321100005
						],
						[
							-80.26992148599999,
							25.951367504000075
						],
						[
							-80.26991335999998,
							25.951132587000078
						],
						[
							-80.26978013299998,
							25.94728126600006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "Miami Gardens",
				"Name": "King Gardens",
				"RegionID": "762073"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.227372,
					25.883098,
					-80.210586,
					25.898268
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.210586,
							25.883735
						],
						[
							-80.212608,
							25.883658
						],
						[
							-80.214613,
							25.883581
						],
						[
							-80.216624,
							25.883498
						],
						[
							-80.21868500000001,
							25.883418
						],
						[
							-80.220683,
							25.883339
						],
						[
							-80.22160646399999,
							25.88330035000007
						],
						[
							-80.226737,
							25.883098
						],
						[
							-80.226773,
							25.883993
						],
						[
							-80.226795,
							25.884919
						],
						[
							-80.226838,
							25.885813
						],
						[
							-80.226881,
							25.886722
						],
						[
							-80.22690900000002,
							25.887334000000003
						],
						[
							-80.22692261599997,
							25.887512143000038
						],
						[
							-80.22693353099999,
							25.887771712000074
						],
						[
							-80.226935,
							25.888114
						],
						[
							-80.22696554499998,
							25.888533039000038
						],
						[
							-80.22696662899995,
							25.88855301600006
						],
						[
							-80.227043,
							25.890375
						],
						[
							-80.226433,
							25.890393
						],
						[
							-80.22643,
							25.890483
						],
						[
							-80.226437,
							25.890849
						],
						[
							-80.227061,
							25.890829
						],
						[
							-80.227079,
							25.891279
						],
						[
							-80.22708669599996,
							25.891389264000054
						],
						[
							-80.22715838199997,
							25.892952302000026
						],
						[
							-80.227161,
							25.893081
						],
						[
							-80.22717284899996,
							25.89326771900005
						],
						[
							-80.22724654899997,
							25.89487467700008
						],
						[
							-80.227248,
							25.894921
						],
						[
							-80.22725172299994,
							25.894987497000045
						],
						[
							-80.22731413199995,
							25.896348252000053
						],
						[
							-80.227325,
							25.896719
						],
						[
							-80.227372,
							25.89761
						],
						[
							-80.22521111799995,
							25.897666380000032
						],
						[
							-80.22516019599999,
							25.89412730500004
						],
						[
							-80.22123920699994,
							25.894178227000054
						],
						[
							-80.22123920699994,
							25.897819146000074
						],
						[
							-80.219316,
							25.897952
						],
						[
							-80.217323,
							25.898028
						],
						[
							-80.215291,
							25.898108
						],
						[
							-80.21481393499995,
							25.89812899100008
						],
						[
							-80.21127800000001,
							25.898268
						],
						[
							-80.210586,
							25.883735
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "North Miami",
				"Name": "Westside/Sunkist Grove",
				"RegionID": "762148"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.11072192699999,
					26.91241306200004,
					-80.10413938399995,
					26.926362792000077
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.11072192699999,
							26.914677194000035
						],
						[
							-80.11052442799996,
							26.91784315800004
						],
						[
							-80.11041208099994,
							26.92422820300004
						],
						[
							-80.11031845899998,
							26.924527794000028
						],
						[
							-80.10971927599996,
							26.925332946000026
						],
						[
							-80.10889539899995,
							26.926100650000024
						],
						[
							-80.10861453199999,
							26.926156823000042
						],
						[
							-80.10794045099993,
							26.92630661900006
						],
						[
							-80.10616162699995,
							26.926362792000077
						],
						[
							-80.10659228899993,
							26.919266218000075
						],
						[
							-80.10522540299998,
							26.919284942000047
						],
						[
							-80.10413938399995,
							26.918236372000024
						],
						[
							-80.10419555699997,
							26.916513721000058
						],
						[
							-80.10500070899997,
							26.915895813000077
						],
						[
							-80.10603055499996,
							26.915390253000055
						],
						[
							-80.10670463599996,
							26.91510938500005
						],
						[
							-80.10670463599996,
							26.91241306200004
						],
						[
							-80.11070415499995,
							26.91256229100003
						],
						[
							-80.11070981999995,
							26.91323648200006
						],
						[
							-80.11072192699999,
							26.914677194000035
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Jupiter",
				"Name": "Paseos",
				"RegionID": "762164"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.24199111999997,
					27.197494886000072,
					-80.23191410199996,
					27.20128298800006
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.23287540499996,
							27.20103076500004
						],
						[
							-80.23291347599996,
							27.200338342000066
						],
						[
							-80.23286588699995,
							27.199838655000065
						],
						[
							-80.23268742699997,
							27.199434147000034
						],
						[
							-80.23230671399995,
							27.198815487000047
						],
						[
							-80.23191410199996,
							27.198232519000044
						],
						[
							-80.23191410199996,
							27.197839908000052
						],
						[
							-80.23242663799994,
							27.197494886000072
						],
						[
							-80.23647552899996,
							27.19752574000006
						],
						[
							-80.24198098599999,
							27.197541814000033
						],
						[
							-80.24196732499996,
							27.198418117000074
						],
						[
							-80.24199111999997,
							27.20108311300004
						],
						[
							-80.24170082599996,
							27.20109263100005
						],
						[
							-80.24151998699996,
							27.201202086000023
						],
						[
							-80.24131535299995,
							27.20128298800006
						],
						[
							-80.24096319299997,
							27.201178291000076
						],
						[
							-80.24007803299997,
							27.201073595000025
						],
						[
							-80.23940226599997,
							27.200835649000055
						],
						[
							-80.23870746399996,
							27.200835649000055
						],
						[
							-80.23862180299994,
							27.200854685000024
						],
						[
							-80.23864083899997,
							27.20092131000007
						],
						[
							-80.23859324999995,
							27.20096889900003
						],
						[
							-80.23819349999997,
							27.200949863000062
						],
						[
							-80.23803169699994,
							27.20087372000006
						],
						[
							-80.23747014399999,
							27.20055963200008
						],
						[
							-80.23736544799993,
							27.200540596000053
						],
						[
							-80.23730834099996,
							27.200540596000053
						],
						[
							-80.23726075099995,
							27.200588185000075
						],
						[
							-80.23716557299997,
							27.200588185000075
						],
						[
							-80.23633752,
							27.20026457800003
						],
						[
							-80.23567127099994,
							27.200055186000043
						],
						[
							-80.23517634299998,
							27.199931454000023
						],
						[
							-80.23450057699995,
							27.19980772200006
						],
						[
							-80.23408179099994,
							27.19980772200006
						],
						[
							-80.23385336299998,
							27.199912418000054
						],
						[
							-80.23378197899996,
							27.200997452000024
						],
						[
							-80.23287540499996,
							27.20103076500004
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Martin",
				"City": "Stuart",
				"Name": "West Riverside",
				"RegionID": "762264"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.09198204299997,
					26.339494581000054,
					-80.07761049499999,
					26.35789556900005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.08996195999998,
							26.355558228000064
						],
						[
							-80.08791911299994,
							26.35557631200004
						],
						[
							-80.08796194299998,
							26.35783204100005
						],
						[
							-80.08569382699994,
							26.35789556900005
						],
						[
							-80.08448030199997,
							26.35712462400005
						],
						[
							-80.08401901799994,
							26.356793168000024
						],
						[
							-80.08393168599997,
							26.356598606000034
						],
						[
							-80.08391877899999,
							26.356337739000026
						],
						[
							-80.08386320499994,
							26.355214558000057
						],
						[
							-80.083713812,
							26.35144770900007
						],
						[
							-80.07762834099998,
							26.351507195000067
						],
						[
							-80.07761049499999,
							26.349680959000068
						],
						[
							-80.08365432599999,
							26.34960362700008
						],
						[
							-80.08365432599999,
							26.34915152900004
						],
						[
							-80.08244334499994,
							26.349169906000046
						],
						[
							-80.08262432199996,
							26.346274282000024
						],
						[
							-80.08314512099997,
							26.34530175900005
						],
						[
							-80.08352375899995,
							26.344946543000052
						],
						[
							-80.08469445399999,
							26.344132767000076
						],
						[
							-80.08466589999995,
							26.34082055700003
						],
						[
							-80.08619083099995,
							26.34084740800006
						],
						[
							-80.08619796899995,
							26.339952493000055
						],
						[
							-80.08944771799997,
							26.33990609400007
						],
						[
							-80.08947716999995,
							26.33952137100005
						],
						[
							-80.09174101199994,
							26.339494581000054
						],
						[
							-80.09173866299994,
							26.33983034700003
						],
						[
							-80.09174278599994,
							26.34031816000004
						],
						[
							-80.09174713699997,
							26.34135563700005
						],
						[
							-80.09181242699998,
							26.34171488100003
						],
						[
							-80.09180290899997,
							26.341860028000042
						],
						[
							-80.09174865699998,
							26.342272468000033
						],
						[
							-80.09173186199996,
							26.342874523000035
						],
						[
							-80.09175529999999,
							26.34362149800006
						],
						[
							-80.08924022899998,
							26.343597034000027
						],
						[
							-80.08836478599994,
							26.349544497000068
						],
						[
							-80.08977342699995,
							26.34952397400008
						],
						[
							-80.08980197999995,
							26.35045553300006
						],
						[
							-80.09187853599997,
							26.35045791300007
						],
						[
							-80.09198204299997,
							26.35418414800006
						],
						[
							-80.09179406499999,
							26.354528813000062
						],
						[
							-80.09136170299996,
							26.354983109000045
						],
						[
							-80.09029094599998,
							26.35411222600004
						],
						[
							-80.08990834199994,
							26.35390218200007
						],
						[
							-80.08996195999998,
							26.355558228000064
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Boca Raton",
				"Name": "Downtown",
				"RegionID": "762300"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.162898,
					25.93333941900005,
					-80.150599,
					25.946281
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.150599,
							25.937734
						],
						[
							-80.15153542799999,
							25.93476709500004
						],
						[
							-80.15426228999998,
							25.934638604000043
						],
						[
							-80.15510461999999,
							25.934510114000034
						],
						[
							-80.15621820699994,
							25.934081811000055
						],
						[
							-80.15757449999995,
							25.933553570000072
						],
						[
							-80.16235721699996,
							25.93333941900005
						],
						[
							-80.162825,
							25.944262000000002
						],
						[
							-80.162898,
							25.946069
						],
						[
							-80.158767,
							25.946211
						],
						[
							-80.158498,
							25.946234
						],
						[
							-80.158255,
							25.946233000000003
						],
						[
							-80.157761,
							25.946246
						],
						[
							-80.157446,
							25.946269
						],
						[
							-80.157087,
							25.946267
						],
						[
							-80.156683,
							25.946281
						],
						[
							-80.156584,
							25.944475
						],
						[
							-80.156549,
							25.943591
						],
						[
							-80.15651,
							25.942722
						],
						[
							-80.15649,
							25.941837
						],
						[
							-80.156447,
							25.941147
						],
						[
							-80.15653,
							25.940999
						],
						[
							-80.158516,
							25.940881000000005
						],
						[
							-80.160568,
							25.940776
						],
						[
							-80.160553,
							25.93985
						],
						[
							-80.160533,
							25.93894
						],
						[
							-80.160494,
							25.938054
						],
						[
							-80.160462,
							25.937147
						],
						[
							-80.160399,
							25.936209
						],
						[
							-80.158341,
							25.936336
						],
						[
							-80.156266,
							25.93645
						],
						[
							-80.156271,
							25.936929
						],
						[
							-80.156251,
							25.937331
						],
						[
							-80.156073,
							25.93754
						],
						[
							-80.156043,
							25.937532
						],
						[
							-80.155972,
							25.937536
						],
						[
							-80.155938,
							25.937544
						],
						[
							-80.155899,
							25.937567000000005
						],
						[
							-80.155869,
							25.937592
						],
						[
							-80.155837,
							25.93763
						],
						[
							-80.155678,
							25.937896
						],
						[
							-80.155656,
							25.937954
						],
						[
							-80.155612,
							25.93796
						],
						[
							-80.15559,
							25.937955
						],
						[
							-80.155587,
							25.937932
						],
						[
							-80.1556,
							25.937856
						],
						[
							-80.155621,
							25.937786000000003
						],
						[
							-80.15563,
							25.937717
						],
						[
							-80.155609,
							25.937698000000005
						],
						[
							-80.155571,
							25.937709
						],
						[
							-80.15551,
							25.937792
						],
						[
							-80.155482,
							25.937851000000002
						],
						[
							-80.155453,
							25.937980000000003
						],
						[
							-80.155374,
							25.938112
						],
						[
							-80.155341,
							25.938147
						],
						[
							-80.155322,
							25.938154
						],
						[
							-80.155301,
							25.938142
						],
						[
							-80.155285,
							25.938122
						],
						[
							-80.155282,
							25.938076
						],
						[
							-80.155297,
							25.938011
						],
						[
							-80.155437,
							25.937768
						],
						[
							-80.155563,
							25.937563
						],
						[
							-80.155339,
							25.937556
						],
						[
							-80.1551,
							25.937573
						],
						[
							-80.154847,
							25.937577
						],
						[
							-80.154805,
							25.937585
						],
						[
							-80.154787,
							25.937618
						],
						[
							-80.154791,
							25.937678000000002
						],
						[
							-80.15483,
							25.937732
						],
						[
							-80.154904,
							25.937815
						],
						[
							-80.154916,
							25.937842
						],
						[
							-80.154917,
							25.937903
						],
						[
							-80.154925,
							25.937952
						],
						[
							-80.154949,
							25.937992
						],
						[
							-80.154962,
							25.938036
						],
						[
							-80.154956,
							25.938077
						],
						[
							-80.154823,
							25.938242
						],
						[
							-80.154349,
							25.9377
						],
						[
							-80.154337,
							25.9375
						],
						[
							-80.151966,
							25.937642
						],
						[
							-80.151495,
							25.937673
						],
						[
							-80.151306,
							25.937682
						],
						[
							-80.15112,
							25.937693
						],
						[
							-80.150858,
							25.937721
						],
						[
							-80.150599,
							25.937734
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "North Miami Beach",
				"Name": "Sunray East",
				"RegionID": "762323"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.17171599399995,
					25.914468,
					-80.167479,
					25.91833964400007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.167479,
							25.914647
						],
						[
							-80.171495,
							25.914468
						],
						[
							-80.17171599399995,
							25.91817308100008
						],
						[
							-80.16767091,
							25.91833964400007
						],
						[
							-80.167479,
							25.914647
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Miami-Dade",
				"City": "North Miami Beach",
				"Name": "Washington Park",
				"RegionID": "762325"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.24911046699998,
					27.19021603500005,
					-80.23654215399995,
					27.193873267000072
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.24911046699998,
							27.193873267000072
						],
						[
							-80.23654691299998,
							27.193813780000028
						],
						[
							-80.23654215399995,
							27.19025886600008
						],
						[
							-80.24536519599997,
							27.19021603500005
						],
						[
							-80.24911046699998,
							27.193873267000072
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Martin",
				"City": "Stuart",
				"Name": "East Stuart",
				"RegionID": "762334"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.23657600000001,
					27.182194,
					-80.224184,
					27.19025886600008
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.22920461299998,
							27.19017084400008
						],
						[
							-80.224216,
							27.190111
						],
						[
							-80.22448300000002,
							27.189224
						],
						[
							-80.224184,
							27.188252000000002
						],
						[
							-80.224201,
							27.187794
						],
						[
							-80.224488,
							27.187348
						],
						[
							-80.224415,
							27.187077
						],
						[
							-80.2244,
							27.186466
						],
						[
							-80.224487,
							27.186466
						],
						[
							-80.224899,
							27.186468
						],
						[
							-80.225873,
							27.186484
						],
						[
							-80.226094,
							27.186487
						],
						[
							-80.226095,
							27.186089
						],
						[
							-80.226107,
							27.185082
						],
						[
							-80.22675162399997,
							27.185074099000076
						],
						[
							-80.22996389599996,
							27.18428887700003
						],
						[
							-80.23342601199994,
							27.18293258400007
						],
						[
							-80.235381,
							27.182253
						],
						[
							-80.23657600000001,
							27.182194
						],
						[
							-80.23654215399995,
							27.19025886600008
						],
						[
							-80.23424733299998,
							27.190231337000057
						],
						[
							-80.22920461299998,
							27.19017084400008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Martin",
				"City": "Stuart",
				"Name": "Sarita Heights",
				"RegionID": "762341"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.26241676999997,
					27.187991596000074,
					-80.25697028599996,
					27.196859234000044
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.25697220599994,
							27.194413405000034
						],
						[
							-80.25702372199999,
							27.189730506000046
						],
						[
							-80.25712008999994,
							27.18964413200007
						],
						[
							-80.25721645799996,
							27.189533487000062
						],
						[
							-80.25740562499999,
							27.189426411000056
						],
						[
							-80.25753768499999,
							27.18931219700005
						],
						[
							-80.25770186799997,
							27.189205121000043
						],
						[
							-80.25780894399998,
							27.189126599000076
						],
						[
							-80.25811589399996,
							27.18900167700008
						],
						[
							-80.25849065899996,
							27.188916017000054
						],
						[
							-80.25862271899996,
							27.188869617000023
						],
						[
							-80.25877262499995,
							27.18883035600004
						],
						[
							-80.25896536199997,
							27.18874469600007
						],
						[
							-80.25901533099994,
							27.18869829600004
						],
						[
							-80.25899391499996,
							27.188634051000065
						],
						[
							-80.25915452899994,
							27.18852697500006
						],
						[
							-80.25919022099998,
							27.188291408000055
						],
						[
							-80.25933298899997,
							27.18819504000004
						],
						[
							-80.25954713999994,
							27.188120087000073
						],
						[
							-80.25981839899998,
							27.188084395000033
						],
						[
							-80.25990762799997,
							27.188095103000023
						],
						[
							-80.25992547399994,
							27.188005873000066
						],
						[
							-80.26004325799994,
							27.187991596000074
						],
						[
							-80.26026811699995,
							27.18804156500005
						],
						[
							-80.26036091599997,
							27.188091534000023
						],
						[
							-80.26044300699994,
							27.18822002400003
						],
						[
							-80.26055365199994,
							27.188327100000038
						],
						[
							-80.26065001999996,
							27.18847343700003
						],
						[
							-80.26070355799999,
							27.188634051000065
						],
						[
							-80.26074638799999,
							27.188805372000047
						],
						[
							-80.26077137299995,
							27.18898026200003
						],
						[
							-80.26074281899997,
							27.189119461000075
						],
						[
							-80.26076780399995,
							27.189262228000075
						],
						[
							-80.26072140399998,
							27.18961914800008
						],
						[
							-80.26060005199997,
							27.190004620000025
						],
						[
							-80.26056078999994,
							27.190311571000052
						],
						[
							-80.26050368299997,
							27.190814827000057
						],
						[
							-80.26049654499997,
							27.191032547000077
						],
						[
							-80.26053580599996,
							27.191385897000035
						],
						[
							-80.26057863599993,
							27.19171069400005
						],
						[
							-80.26067143499995,
							27.191924845000074
						],
						[
							-80.26069998899999,
							27.19199622900004
						],
						[
							-80.26079992599995,
							27.192053336000072
						],
						[
							-80.26104619999995,
							27.192388840000035
						],
						[
							-80.26132816699999,
							27.19264582200003
						],
						[
							-80.26156016399995,
							27.19279572800008
						],
						[
							-80.26163154799997,
							27.192742190000047
						],
						[
							-80.26176360799997,
							27.19283142000006
						],
						[
							-80.26179573099995,
							27.192884958000036
						],
						[
							-80.26193849799995,
							27.19296348000006
						],
						[
							-80.26202415899996,
							27.193027725000036
						],
						[
							-80.26203843599995,
							27.193045571000027
						],
						[
							-80.26230969399997,
							27.193156216000038
						],
						[
							-80.26236680099998,
							27.193177631000026
						],
						[
							-80.26240963199996,
							27.193184770000073
						],
						[
							-80.26241676999997,
							27.193238308000048
						],
						[
							-80.26237037099997,
							27.19328113800003
						],
						[
							-80.26210624999999,
							27.19341319800003
						],
						[
							-80.2617993,
							27.193530981000038
						],
						[
							-80.26141739599996,
							27.193713010000067
						],
						[
							-80.26110687699997,
							27.193923592000033
						],
						[
							-80.26092841699995,
							27.19403066800004
						],
						[
							-80.26050011399997,
							27.194276942000045
						],
						[
							-80.26022171699998,
							27.194491094000057
						],
						[
							-80.26001113499996,
							27.194755214000054
						],
						[
							-80.25986836699997,
							27.19499435000006
						],
						[
							-80.25967563099994,
							27.195258470000056
						],
						[
							-80.25971132299998,
							27.19530130000004
						],
						[
							-80.25950430999995,
							27.19575815700006
						],
						[
							-80.25939723399995,
							27.195904494000047
						],
						[
							-80.25939366499995,
							27.196043692000046
						],
						[
							-80.25922591299997,
							27.19608295300003
						],
						[
							-80.25910099099997,
							27.19607224600003
						],
						[
							-80.25907600699998,
							27.196029415000055
						],
						[
							-80.25907600699998,
							27.19599372400006
						],
						[
							-80.25896536199997,
							27.19593304700004
						],
						[
							-80.25883687099997,
							27.19592590900004
						],
						[
							-80.25868339599998,
							27.19598658500007
						],
						[
							-80.25865841099994,
							27.19608295300003
						],
						[
							-80.25869410299998,
							27.196190029000036
						],
						[
							-80.25855490499998,
							27.196307812000043
						],
						[
							-80.25838715299994,
							27.196397042000058
						],
						[
							-80.25829435399999,
							27.196297105000042
						],
						[
							-80.25788032799994,
							27.196450580000032
						],
						[
							-80.25785177399996,
							27.19658620900003
						],
						[
							-80.25766974499999,
							27.196675439000046
						],
						[
							-80.25758051599996,
							27.196657593000054
						],
						[
							-80.25697028599996,
							27.196859234000044
						],
						[
							-80.25698172399996,
							27.196388357000046
						],
						[
							-80.25697220599994,
							27.194413405000034
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Martin",
				"City": "Stuart",
				"Name": "Bessey",
				"RegionID": "762343"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.37135,
					28.726158999999996,
					-81.35861129799999,
					28.731772168000077
				],
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[
								-81.36242,
								28.726286
							],
							[
								-81.362546,
								28.726158999999996
							],
							[
								-81.362842,
								28.726511000000002
							],
							[
								-81.362974,
								28.726524
							],
							[
								-81.363711,
								28.726977
							],
							[
								-81.364613,
								28.727139000000005
							],
							[
								-81.364703,
								28.731149000000002
							],
							[
								-81.364551,
								28.731733000000002
							],
							[
								-81.35867798299995,
								28.731772168000077
							],
							[
								-81.35861129799999,
								28.726881957000046
							],
							[
								-81.36196400000001,
								28.726855
							],
							[
								-81.362803,
								28.726774
							],
							[
								-81.36252,
								28.726556000000002
							],
							[
								-81.36242,
								28.726286
							]
						]
					],
					[
						[
							[
								-81.365665,
								28.729475999999995
							],
							[
								-81.366228,
								28.729248
							],
							[
								-81.366497,
								28.729278
							],
							[
								-81.366623,
								28.729432
							],
							[
								-81.366792,
								28.729947999999997
							],
							[
								-81.36602,
								28.73022
							],
							[
								-81.365102,
								28.730299
							],
							[
								-81.36508200000002,
								28.729645
							],
							[
								-81.365151,
								28.729553000000003
							],
							[
								-81.365665,
								28.729475999999995
							]
						]
					],
					[
						[
							[
								-81.368665,
								28.730196
							],
							[
								-81.36997,
								28.730103999999997
							],
							[
								-81.371208,
								28.730218000000004
							],
							[
								-81.37135,
								28.730272
							],
							[
								-81.371053,
								28.730967999999997
							],
							[
								-81.368172,
								28.730951
							],
							[
								-81.368249,
								28.730359999999997
							],
							[
								-81.368665,
								28.730196
							]
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Seminole",
				"City": "Lake Mary",
				"Name": "Huntington Pointe",
				"RegionID": "762959"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.34718058899995,
					28.767021694000054,
					-81.33865783199998,
					28.770806047000065
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.33871488199998,
							28.770806047000065
						],
						[
							-81.33865783199998,
							28.767021694000054
						],
						[
							-81.34481397399998,
							28.767033115000064
						],
						[
							-81.34715536399995,
							28.76709161800005
						],
						[
							-81.34718058899995,
							28.770769406000056
						],
						[
							-81.33871488199998,
							28.770806047000065
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Seminole",
				"City": "Lake Mary",
				"Name": "Manderley",
				"RegionID": "762975"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.34283803799997,
					28.761638845000046,
					-81.32218146099996,
					28.783905723000032
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.34171873899999,
							28.783905723000032
						],
						[
							-81.33985562099997,
							28.782778810000025
						],
						[
							-81.33449707499994,
							28.782835917000057
						],
						[
							-81.33449707499994,
							28.78147486500006
						],
						[
							-81.33237459599997,
							28.78147486500006
						],
						[
							-81.32941454699994,
							28.77924729300003
						],
						[
							-81.32940058699995,
							28.778241812000033
						],
						[
							-81.32815945999994,
							28.778264655000044
						],
						[
							-81.32815184599997,
							28.77719104200003
						],
						[
							-81.32534519199999,
							28.77719104200003
						],
						[
							-81.32534519199999,
							28.773820615000037
						],
						[
							-81.32479696499996,
							28.77379206200004
						],
						[
							-81.32218146099996,
							28.773797772000027
						],
						[
							-81.32219097899997,
							28.770940515000063
						],
						[
							-81.32440673299999,
							28.770925287000065
						],
						[
							-81.32781983199999,
							28.771412601000065
						],
						[
							-81.32905715199996,
							28.77049888800008
						],
						[
							-81.32976147199997,
							28.77087008300003
						],
						[
							-81.33050386399998,
							28.77087960100005
						],
						[
							-81.33147468399994,
							28.770908155000033
						],
						[
							-81.33209334399999,
							28.77087960100005
						],
						[
							-81.33230273599997,
							28.77084153000004
						],
						[
							-81.33242646799994,
							28.770708280000065
						],
						[
							-81.33249309299998,
							28.770489370000064
						],
						[
							-81.33247405799995,
							28.770146727000053
						],
						[
							-81.33361115399998,
							28.769319746000065
						],
						[
							-81.33284020899998,
							28.768805782000072
						],
						[
							-81.33229769199994,
							28.76854880000008
						],
						[
							-81.33184083499998,
							28.768091944000048
						],
						[
							-81.33112699699996,
							28.76734955200004
						],
						[
							-81.33072724799996,
							28.767006910000074
						],
						[
							-81.33084146199997,
							28.766407285000074
						],
						[
							-81.33201215699995,
							28.76577910800006
						],
						[
							-81.33209781699998,
							28.76515093000006
						],
						[
							-81.33284020899998,
							28.763923128000044
						],
						[
							-81.33369681499994,
							28.763152183000045
						],
						[
							-81.33435354599999,
							28.762267023000046
						],
						[
							-81.33546713399994,
							28.761638845000046
						],
						[
							-81.33864075099996,
							28.76166656600003
						],
						[
							-81.33865783199998,
							28.767021694000054
						],
						[
							-81.33871488199998,
							28.770806047000065
						],
						[
							-81.338786482,
							28.775555520000072
						],
						[
							-81.34274590499996,
							28.775517448000077
						],
						[
							-81.34276494099998,
							28.776469233000057
						],
						[
							-81.34282759999996,
							28.780221524000066
						],
						[
							-81.34276950899994,
							28.780479299000035
						],
						[
							-81.34259247699998,
							28.780964709000045
						],
						[
							-81.34234120599996,
							28.781415855000038
						],
						[
							-81.34211848899997,
							28.78180989300006
						],
						[
							-81.34183866399997,
							28.782101139000076
						],
						[
							-81.34203853899999,
							28.78221535400007
						],
						[
							-81.34240973499999,
							28.782386675000055
						],
						[
							-81.34283803799997,
							28.782506600000033
						],
						[
							-81.34279806299998,
							28.782666499000072
						],
						[
							-81.34270669199998,
							28.782792135000083
						],
						[
							-81.34190148199997,
							28.783568791000054
						],
						[
							-81.34177013599998,
							28.783740112000036
						],
						[
							-81.34171873899999,
							28.783905723000032
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Seminole",
				"City": "Lake Mary",
				"Name": "Timacuan",
				"RegionID": "762977"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.05259753599995,
					26.609651669000073,
					-80.04387157699995,
					26.616492881000056
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.04387157699995,
							26.61547637600006
						],
						[
							-80.043963,
							26.613046
						],
						[
							-80.04430769099997,
							26.609651669000073
						],
						[
							-80.04970791899996,
							26.60995983300006
						],
						[
							-80.05040462499994,
							26.609822776000048
						],
						[
							-80.05241862199995,
							26.60989326600003
						],
						[
							-80.05242621499997,
							26.60991414800003
						],
						[
							-80.05255184999999,
							26.610325319000026
						],
						[
							-80.05259753599995,
							26.61090781100006
						],
						[
							-80.05240337199996,
							26.616492881000056
						],
						[
							-80.04899979099997,
							26.61641293200006
						],
						[
							-80.04853151299994,
							26.616390089000053
						],
						[
							-80.04838303499997,
							26.61637866700005
						],
						[
							-80.04791475699994,
							26.616218768000067
						],
						[
							-80.04734368599998,
							26.615967496000053
						],
						[
							-80.04693251499998,
							26.615796175000074
						],
						[
							-80.04648707999996,
							26.615693383000064
						],
						[
							-80.04567615999997,
							26.615579168000068
						],
						[
							-80.04387157699995,
							26.61547637600006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Lake Worth",
				"Name": "Bryant Park",
				"RegionID": "763061"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.042843,
					29.011602999999997,
					-80.992303,
					29.051358
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.99651909099998,
							29.01262536700006
						],
						[
							-81.00561830799995,
							29.012411692000057
						],
						[
							-81.029601,
							29.011811
						],
						[
							-81.029572,
							29.012595
						],
						[
							-81.029101,
							29.015167
						],
						[
							-81.030493,
							29.015195
						],
						[
							-81.030328,
							29.015545999999997
						],
						[
							-81.029017,
							29.015624000000003
						],
						[
							-81.028859,
							29.016486
						],
						[
							-81.030021,
							29.016473999999995
						],
						[
							-81.029596,
							29.017671000000004
						],
						[
							-81.03313800000001,
							29.017609
						],
						[
							-81.03313800000001,
							29.015649
						],
						[
							-81.035098,
							29.015649
						],
						[
							-81.035004,
							29.013668000000003
						],
						[
							-81.037153,
							29.013586000000004
						],
						[
							-81.037034,
							29.011652
						],
						[
							-81.03763800000002,
							29.011639000000002
						],
						[
							-81.037708,
							29.013601000000005
						],
						[
							-81.038393,
							29.013601000000005
						],
						[
							-81.03837061199994,
							29.012547151000035
						],
						[
							-81.038351,
							29.011623999999998
						],
						[
							-81.039309,
							29.011602999999997
						],
						[
							-81.039365,
							29.014004999999997
						],
						[
							-81.041639,
							29.014028999999997
						],
						[
							-81.042215,
							29.033722000000004
						],
						[
							-81.042267,
							29.035508
						],
						[
							-81.042533,
							29.043896
						],
						[
							-81.042607,
							29.043931000000004
						],
						[
							-81.042659,
							29.045902000000005
						],
						[
							-81.04272,
							29.046139
						],
						[
							-81.042843,
							29.050869000000002
						],
						[
							-81.04274,
							29.050987000000003
						],
						[
							-81.042743,
							29.051121
						],
						[
							-81.04248,
							29.051147
						],
						[
							-81.040629,
							29.051320000000004
						],
						[
							-81.04031,
							29.051339000000002
						],
						[
							-81.039737,
							29.051341000000004
						],
						[
							-81.039262,
							29.051358
						],
						[
							-81.035123,
							29.051045
						],
						[
							-81.03512800000001,
							29.051049999999996
						],
						[
							-81.034352,
							29.05084
						],
						[
							-81.03288,
							29.050394
						],
						[
							-81.031401,
							29.049961
						],
						[
							-81.027178,
							29.049199
						],
						[
							-81.027087,
							29.049186999999996
						],
						[
							-81.026889,
							29.049158
						],
						[
							-81.020483,
							29.048259000000005
						],
						[
							-81.018578,
							29.047991
						],
						[
							-81.014702,
							29.047447000000002
						],
						[
							-81.009825,
							29.047815
						],
						[
							-81.007231,
							29.048011
						],
						[
							-81.007012,
							29.048034999999995
						],
						[
							-81.006978,
							29.04759
						],
						[
							-81.006947,
							29.047355
						],
						[
							-81.006663,
							29.044118999999995
						],
						[
							-81.006548,
							29.043131000000002
						],
						[
							-81.006318,
							29.042025
						],
						[
							-81.00601200000001,
							29.041037
						],
						[
							-81.005551,
							29.040015000000004
						],
						[
							-81.004833,
							29.038724999999996
						],
						[
							-81.00037,
							29.031865000000003
						],
						[
							-80.992303,
							29.019527
						],
						[
							-81.00078784399994,
							29.01978754500004
						],
						[
							-81.00073073699997,
							29.017788798000026
						],
						[
							-80.99796104399996,
							29.017817351000076
						],
						[
							-80.994734495,
							29.012734823000073
						],
						[
							-80.99651909099998,
							29.01262536700006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Volusia",
				"City": "New Smyrna Beach",
				"Name": "North Village",
				"RegionID": "763095"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.94610220799996,
					29.027601222000044,
					-80.92826786199998,
					29.048923668000047
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.93228693099996,
							29.04233579700008
						],
						[
							-80.93396207099994,
							29.04168096900003
						],
						[
							-80.93393668999994,
							29.040861673000055
						],
						[
							-80.93365496199993,
							29.040077403000055
						],
						[
							-80.92885796899998,
							29.03095550100005
						],
						[
							-80.92853055499995,
							29.03021691600003
						],
						[
							-80.92834019799994,
							29.029356503000034
						],
						[
							-80.92826786199998,
							29.02800097200003
						],
						[
							-80.92914731099995,
							29.027601222000044
						],
						[
							-80.93152296499994,
							29.03232968700007
						],
						[
							-80.93217950599995,
							29.03359042100004
						],
						[
							-80.93275057699998,
							29.034230020000056
						],
						[
							-80.93392698199995,
							29.035212261000027
						],
						[
							-80.93982043099999,
							29.03971229800004
						],
						[
							-80.94610220799996,
							29.044532134000065
						],
						[
							-80.94124810799997,
							29.046599410000056
						],
						[
							-80.93876490199996,
							29.047766298000056
						],
						[
							-80.93645614299999,
							29.04867309800005
						],
						[
							-80.93581817799998,
							29.048923668000047
						],
						[
							-80.93542223499998,
							29.048192697000047
						],
						[
							-80.93483593599996,
							29.048436354000046
						],
						[
							-80.93444760799999,
							29.047705384000043
						],
						[
							-80.93477502199994,
							29.047560712000067
						],
						[
							-80.93382958299998,
							29.044895208000067
						],
						[
							-80.93342221899997,
							29.04389773800006
						],
						[
							-80.93296916999998,
							29.043086818000067
						],
						[
							-80.93228693099996,
							29.04233579700008
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Volusia",
				"City": "New Smyrna Beach",
				"Name": "Central Mainland",
				"RegionID": "763100"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.97965,
					29.048433,
					-80.94472132799996,
					29.083744
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.966525,
							29.053550000000005
						],
						[
							-80.970881,
							29.05653
						],
						[
							-80.97098,
							29.056598
						],
						[
							-80.971271,
							29.056813
						],
						[
							-80.97131,
							29.056836
						],
						[
							-80.971389,
							29.056899
						],
						[
							-80.972534,
							29.057743
						],
						[
							-80.973093,
							29.058158
						],
						[
							-80.974833,
							29.059290000000004
						],
						[
							-80.975953,
							29.060311000000002
						],
						[
							-80.976009,
							29.060391
						],
						[
							-80.976152,
							29.060314
						],
						[
							-80.976395,
							29.060659000000005
						],
						[
							-80.9767,
							29.061171000000005
						],
						[
							-80.97786747099997,
							29.063992374000065
						],
						[
							-80.97757,
							29.064008
						],
						[
							-80.97965,
							29.068178
						],
						[
							-80.972404,
							29.072155000000002
						],
						[
							-80.972454,
							29.070197999999998
						],
						[
							-80.971415,
							29.070193
						],
						[
							-80.968769,
							29.070337000000002
						],
						[
							-80.966576,
							29.070362
						],
						[
							-80.965342,
							29.070362
						],
						[
							-80.965342,
							29.073286000000003
						],
						[
							-80.965346,
							29.073368000000002
						],
						[
							-80.96512418599997,
							29.07336445100003
						],
						[
							-80.965117,
							29.074479
						],
						[
							-80.965117,
							29.07463525600008
						],
						[
							-80.965266,
							29.07463
						],
						[
							-80.965248,
							29.074710000000003
						],
						[
							-80.96512519199996,
							29.075216584000035
						],
						[
							-80.965142,
							29.075622000000003
						],
						[
							-80.965164,
							29.075891
						],
						[
							-80.965173,
							29.076000999999998
						],
						[
							-80.96532500000002,
							29.076555000000003
						],
						[
							-80.965504,
							29.077005
						],
						[
							-80.965701,
							29.077502
						],
						[
							-80.965728,
							29.077631
						],
						[
							-80.965751,
							29.077743000000005
						],
						[
							-80.965846,
							29.077975
						],
						[
							-80.965941,
							29.078092000000005
						],
						[
							-80.966277,
							29.078324
						],
						[
							-80.966448,
							29.078477
						],
						[
							-80.966554,
							29.078619
						],
						[
							-80.96656155099998,
							29.07863428500008
						],
						[
							-80.966624,
							29.078678
						],
						[
							-80.96662738399993,
							29.078769377000075
						],
						[
							-80.966642,
							29.078800000000005
						],
						[
							-80.966691,
							29.079166
						],
						[
							-80.966779,
							29.079419
						],
						[
							-80.966795,
							29.079585000000005
						],
						[
							-80.966807,
							29.079712000000004
						],
						[
							-80.96681,
							29.079756
						],
						[
							-80.966813,
							29.079796000000005
						],
						[
							-80.966815,
							29.07983
						],
						[
							-80.966818,
							29.079869000000002
						],
						[
							-80.966826,
							29.079901
						],
						[
							-80.966851,
							29.079964999999998
						],
						[
							-80.966873,
							29.080019000000004
						],
						[
							-80.966988,
							29.080248999999995
						],
						[
							-80.967058,
							29.080358
						],
						[
							-80.96707049099996,
							29.080385758000034
						],
						[
							-80.967216,
							29.08047
						],
						[
							-80.967232,
							29.080678
						],
						[
							-80.96710400000002,
							29.080886000000003
						],
						[
							-80.96708454699996,
							29.08090406400004
						],
						[
							-80.967074,
							29.081029
						],
						[
							-80.967141,
							29.081117
						],
						[
							-80.96715661699994,
							29.081120549000048
						],
						[
							-80.967296,
							29.081093999999997
						],
						[
							-80.967712,
							29.081062
						],
						[
							-80.96802205699998,
							29.081108509000046
						],
						[
							-80.968075,
							29.08111
						],
						[
							-80.968147,
							29.081167
						],
						[
							-80.968176,
							29.081226000000004
						],
						[
							-80.968217,
							29.081306
						],
						[
							-80.968224,
							29.081386000000002
						],
						[
							-80.968188,
							29.081502
						],
						[
							-80.968138,
							29.081572999999995
						],
						[
							-80.968121,
							29.081597000000002
						],
						[
							-80.968072,
							29.081625
						],
						[
							-80.968005,
							29.081663000000002
						],
						[
							-80.967823,
							29.081692000000004
						],
						[
							-80.96776636499999,
							29.08169325400007
						],
						[
							-80.967672,
							29.081731000000005
						],
						[
							-80.967324,
							29.081856000000002
						],
						[
							-80.967118,
							29.081936
						],
						[
							-80.967394,
							29.082271000000002
						],
						[
							-80.967397,
							29.082556000000004
						],
						[
							-80.967165,
							29.083097
						],
						[
							-80.966713,
							29.083744
						],
						[
							-80.96639,
							29.08347
						],
						[
							-80.966469,
							29.082686000000002
						],
						[
							-80.965767,
							29.082189000000003
						],
						[
							-80.965653,
							29.082337000000003
						],
						[
							-80.965622,
							29.082949
						],
						[
							-80.965416,
							29.082830000000005
						],
						[
							-80.964981,
							29.082613
						],
						[
							-80.964531,
							29.082424000000003
						],
						[
							-80.963744,
							29.082166
						],
						[
							-80.961703,
							29.083649999999995
						],
						[
							-80.961924,
							29.083016999999998
						],
						[
							-80.961118,
							29.082727
						],
						[
							-80.961059,
							29.082705
						],
						[
							-80.959703,
							29.082216999999996
						],
						[
							-80.958999,
							29.082635000000003
						],
						[
							-80.958686,
							29.081647000000004
						],
						[
							-80.957912,
							29.081281
						],
						[
							-80.957772,
							29.081214000000003
						],
						[
							-80.959032,
							29.080602
						],
						[
							-80.957767,
							29.080181999999997
						],
						[
							-80.95627600000002,
							29.079687
						],
						[
							-80.955681,
							29.079508
						],
						[
							-80.955442,
							29.079417000000003
						],
						[
							-80.95517,
							29.079304
						],
						[
							-80.954758,
							29.079103
						],
						[
							-80.95423900000002,
							29.078796
						],
						[
							-80.953804,
							29.078484000000003
						],
						[
							-80.953506,
							29.078238000000002
						],
						[
							-80.953148,
							29.077883
						],
						[
							-80.952843,
							29.077542999999995
						],
						[
							-80.952667,
							29.077314
						],
						[
							-80.952576,
							29.077174999999997
						],
						[
							-80.951478,
							29.077008
						],
						[
							-80.951415,
							29.076636000000004
						],
						[
							-80.950682,
							29.074698
						],
						[
							-80.950617,
							29.074528
						],
						[
							-80.95108357499998,
							29.074793820000025
						],
						[
							-80.951031,
							29.074676
						],
						[
							-80.950878,
							29.074287
						],
						[
							-80.950783,
							29.074049
						],
						[
							-80.950753,
							29.073848000000005
						],
						[
							-80.950724,
							29.073662
						],
						[
							-80.950622,
							29.073345
						],
						[
							-80.950534,
							29.073073
						],
						[
							-80.950307,
							29.072385999999998
						],
						[
							-80.950087,
							29.071753
						],
						[
							-80.949559,
							29.070857000000004
						],
						[
							-80.94934049799997,
							29.070568465000065
						],
						[
							-80.94965157099995,
							29.070489674000044
						],
						[
							-80.94892821499997,
							29.069309462000035
						],
						[
							-80.94742439499998,
							29.067443964000066
						],
						[
							-80.94472132799996,
							29.063503577000063
						],
						[
							-80.95991180699997,
							29.056289051000082
						],
						[
							-80.95941687899995,
							29.055679909000048
						],
						[
							-80.95810341599997,
							29.054271268000036
						],
						[
							-80.95762752399997,
							29.054061876000052
						],
						[
							-80.95654248999995,
							29.053776340000066
						],
						[
							-80.95616177599999,
							29.053452734000075
						],
						[
							-80.95593334799997,
							29.052995877000058
						],
						[
							-80.95589527599998,
							29.052577092000035
						],
						[
							-80.95604756199998,
							29.05210120000004
						],
						[
							-80.95639020399994,
							29.051168451000027
						],
						[
							-80.95444856399996,
							29.050521238000048
						],
						[
							-80.95300185199994,
							29.049835953000073
						],
						[
							-80.95121249699997,
							29.04876995400008
						],
						[
							-80.951027,
							29.048433
						],
						[
							-80.952976,
							29.049363
						],
						[
							-80.95446000000001,
							29.049823
						],
						[
							-80.957034,
							29.050423
						],
						[
							-80.959424,
							29.050662000000003
						],
						[
							-80.95998,
							29.05107
						],
						[
							-80.960247,
							29.051868
						],
						[
							-80.961047,
							29.052972999999998
						],
						[
							-80.96155,
							29.052681000000003
						],
						[
							-80.961291,
							29.052569
						],
						[
							-80.961272,
							29.052392999999995
						],
						[
							-80.961317,
							29.052185
						],
						[
							-80.961314,
							29.052009000000005
						],
						[
							-80.961185,
							29.052024999999997
						],
						[
							-80.960938,
							29.051153
						],
						[
							-80.961282,
							29.051382
						],
						[
							-80.96133778999996,
							29.051231786000073
						],
						[
							-80.962166,
							29.051395
						],
						[
							-80.96257,
							29.051510000000004
						],
						[
							-80.962829,
							29.051604
						],
						[
							-80.962975,
							29.051657
						],
						[
							-80.963303,
							29.051802
						],
						[
							-80.96344,
							29.051871999999996
						],
						[
							-80.963742,
							29.052389999999995
						],
						[
							-80.962766,
							29.053096000000004
						],
						[
							-80.96181,
							29.053800999999996
						],
						[
							-80.962944,
							29.054902
						],
						[
							-80.963568,
							29.054854000000002
						],
						[
							-80.964858,
							29.054726
						],
						[
							-80.965066,
							29.05531
						],
						[
							-80.963488,
							29.055494
						],
						[
							-80.963033,
							29.055495000000004
						],
						[
							-80.964112,
							29.062661999999996
						],
						[
							-80.96576900000001,
							29.067838999999996
						],
						[
							-80.96810300000001,
							29.066144999999995
						],
						[
							-80.968102,
							29.066033
						],
						[
							-80.968083,
							29.064479
						],
						[
							-80.968413,
							29.064461000000005
						],
						[
							-80.96840600000002,
							29.063877000000005
						],
						[
							-80.968087,
							29.063852
						],
						[
							-80.967897,
							29.056718
						],
						[
							-80.967429,
							29.056735000000003
						],
						[
							-80.967393,
							29.056174
						],
						[
							-80.967234,
							29.054719000000002
						],
						[
							-80.966309,
							29.054996000000003
						],
						[
							-80.965622,
							29.053587000000004
						],
						[
							-80.965989,
							29.053191
						],
						[
							-80.966424,
							29.053481000000005
						],
						[
							-80.966525,
							29.053550000000005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Volusia",
				"City": "New Smyrna Beach",
				"Name": "North Mainland",
				"RegionID": "763102"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.06900629899997,
					26.601603435000072,
					-80.06536609499994,
					26.608914774000027
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.06536609499994,
							26.608873267000035
						],
						[
							-80.06560934199997,
							26.601603435000072
						],
						[
							-80.06900629899997,
							26.60169644100006
						],
						[
							-80.06896061299994,
							26.60471169400006
						],
						[
							-80.06871695699994,
							26.608899546000032
						],
						[
							-80.06672201699996,
							26.608914774000027
						],
						[
							-80.06556464699997,
							26.608899546000032
						],
						[
							-80.06536609499994,
							26.608873267000035
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Lake Worth",
				"Name": "Lake View Heights",
				"RegionID": "763120"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.05778285699995,
					26.593951000000004,
					-80.05215210099999,
					26.608612107000056
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.05215210099999,
							26.60849789200006
						],
						[
							-80.05263560699996,
							26.594356280000056
						],
						[
							-80.052612,
							26.593951000000004
						],
						[
							-80.053266,
							26.593999
						],
						[
							-80.05332503699998,
							26.594012100000043
						],
						[
							-80.05344272099995,
							26.59421922300004
						],
						[
							-80.05732600099998,
							26.601376642000048
						],
						[
							-80.05764579999999,
							26.602046698000038
						],
						[
							-80.05778285699995,
							26.602534011000046
						],
						[
							-80.05778285699995,
							26.60381321000006
						],
						[
							-80.05761153599997,
							26.608577842000045
						],
						[
							-80.05613817399995,
							26.608612107000056
						],
						[
							-80.05215210099999,
							26.60849789200006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Lake Worth",
				"Name": "Sosa/Pineapple Beach",
				"RegionID": "763125"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.06871695699994,
					26.608577842000045,
					-80.05731457899998,
					26.616835524000066
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.05731457899998,
							26.616629938000074
						],
						[
							-80.05761153599997,
							26.608577842000045
						],
						[
							-80.06452910499996,
							26.60876248900007
						],
						[
							-80.06536609499994,
							26.608873267000035
						],
						[
							-80.06556464699997,
							26.608899546000032
						],
						[
							-80.06672201699996,
							26.608914774000027
						],
						[
							-80.06871695699994,
							26.608899546000032
						],
						[
							-80.06868649999996,
							26.611153371000057
						],
						[
							-80.06867652299997,
							26.612570092000055
						],
						[
							-80.06867127099997,
							26.61331582500003
						],
						[
							-80.06859512799997,
							26.61563056500006
						],
						[
							-80.06854944299994,
							26.61633107800003
						],
						[
							-80.06849614299995,
							26.616778417000035
						],
						[
							-80.06528672599995,
							26.61669846700005
						],
						[
							-80.06469281199998,
							26.616824102000066
						],
						[
							-80.06415600599996,
							26.616835524000066
						],
						[
							-80.05731457899998,
							26.616629938000074
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Lake Worth",
				"Name": "Royal Poinciana",
				"RegionID": "763127"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.05656901499998,
					26.638309897000056,
					-80.043463,
					26.644744
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.04355405499996,
							26.638309897000056
						],
						[
							-80.05656901499998,
							26.638675486000068
						],
						[
							-80.05641672999997,
							26.643167908000066
						],
						[
							-80.05631012999999,
							26.64417299300004
						],
						[
							-80.0563,
							26.644735
						],
						[
							-80.052312,
							26.644586
						],
						[
							-80.04627339599995,
							26.64454476700007
						],
						[
							-80.046161,
							26.644544
						],
						[
							-80.04497788599997,
							26.644631703000073
						],
						[
							-80.043463,
							26.644744
						],
						[
							-80.04355405499996,
							26.638309897000056
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Lake Worth",
				"Name": "College Park",
				"RegionID": "763134"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.57576464399996,
					28.300227851000045,
					-81.5658204,
					28.30617421900007
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.56897270999997,
							28.300273537000066
						],
						[
							-81.57104379299994,
							28.300227851000045
						],
						[
							-81.57319101899998,
							28.300303994000046
						],
						[
							-81.57576464399996,
							28.30053242200006
						],
						[
							-81.57510981599995,
							28.301293850000036
						],
						[
							-81.57334330399993,
							28.303090819000033
						],
						[
							-81.57040438399999,
							28.30617421900007
						],
						[
							-81.56674934199998,
							28.302633962000073
						],
						[
							-81.5658204,
							28.301583192000066
						],
						[
							-81.56671888499994,
							28.301004507000073
						],
						[
							-81.56789148299998,
							28.300501965000024
						],
						[
							-81.56897270999997,
							28.300273537000066
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Osceola",
				"City": "Celebration",
				"Name": "Emerson at Celebration",
				"RegionID": "763184"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.54654240399998,
					28.29727299700005,
					-81.53880915599996,
					28.305196602000024
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.54639963599999,
							28.302269865000028
						],
						[
							-81.54354428299996,
							28.30317406000006
						],
						[
							-81.54171209799996,
							28.30381651400006
						],
						[
							-81.54078410799997,
							28.304458969000052
						],
						[
							-81.54030821599997,
							28.305196602000024
						],
						[
							-81.53902330699998,
							28.30336441700007
						],
						[
							-81.53880915599996,
							28.30257919500008
						],
						[
							-81.53938022599993,
							28.301817767000045
						],
						[
							-81.54066513499998,
							28.30115151800004
						],
						[
							-81.54171209799996,
							28.299985582000033
						],
						[
							-81.54240214199996,
							28.298676879000027
						],
						[
							-81.54321115799996,
							28.297725094000043
						],
						[
							-81.54423432699997,
							28.29727299700005
						],
						[
							-81.54516231599996,
							28.297391970000035
						],
						[
							-81.54582856599995,
							28.29791545100005
						],
						[
							-81.54630445799995,
							28.299200360000043
						],
						[
							-81.54654240399998,
							28.301032545000055
						],
						[
							-81.54639963599999,
							28.302269865000028
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Osceola",
				"City": "Celebration",
				"Name": "Aquilla Reserve",
				"RegionID": "763186"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-81.55120607599999,
					28.326470363000055,
					-81.52285456799996,
					28.333087
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-81.52285456799996,
							28.333016626000074
						],
						[
							-81.52348973399997,
							28.33229788500006
						],
						[
							-81.52514583799996,
							28.330984423000075
						],
						[
							-81.52717313899996,
							28.329528193000044
						],
						[
							-81.52914333299998,
							28.32852881900004
						],
						[
							-81.53098217999997,
							28.32781307700003
						],
						[
							-81.53268435199999,
							28.327269862000037
						],
						[
							-81.53479731299996,
							28.32685107700007
						],
						[
							-81.53519820799994,
							28.326803659000063
						],
						[
							-81.53656763199996,
							28.326641685000027
						],
						[
							-81.53911841399997,
							28.326565542000026
						],
						[
							-81.54842686599994,
							28.326470363000055
						],
						[
							-81.55110972899996,
							28.32648873900007
						],
						[
							-81.55120607599999,
							28.326489399000025
						],
						[
							-81.54650426099994,
							28.331400607000035
						],
						[
							-81.54524790599999,
							28.332887
						],
						[
							-81.544995,
							28.332887
						],
						[
							-81.542695,
							28.332987000000003
						],
						[
							-81.541895,
							28.332987000000003
						],
						[
							-81.540795,
							28.332987000000003
						],
						[
							-81.538395,
							28.332987000000003
						],
						[
							-81.536095,
							28.332987000000003
						],
						[
							-81.535695,
							28.332987000000003
						],
						[
							-81.529295,
							28.332987000000003
						],
						[
							-81.527796,
							28.333028
						],
						[
							-81.525595,
							28.333087
						],
						[
							-81.525095,
							28.333087
						],
						[
							-81.524195,
							28.333087
						],
						[
							-81.52285456799996,
							28.333016626000074
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Osceola",
				"City": "Celebration",
				"Name": "Celebration Place",
				"RegionID": "763193"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-82.57706374799994,
					27.513728538000066,
					-82.56311072999995,
					27.51763618400003
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-82.56311072999995,
							27.517373692000035
						],
						[
							-82.56312840399994,
							27.513728538000066
						],
						[
							-82.56484922999994,
							27.513804681000067
						],
						[
							-82.56527372599999,
							27.513832854000043
						],
						[
							-82.56827565399999,
							27.513819909000063
						],
						[
							-82.56829088199999,
							27.514246309000043
						],
						[
							-82.56838225299998,
							27.514429051000036
						],
						[
							-82.56854976799997,
							27.514535651000077
						],
						[
							-82.56888479599996,
							27.514535651000077
						],
						[
							-82.56887717599994,
							27.51385749500003
						],
						[
							-82.56976234099994,
							27.513912804000032
						],
						[
							-82.57706374799994,
							27.514024105000033
						],
						[
							-82.57704158799999,
							27.51763618400003
						],
						[
							-82.57296033599995,
							27.51763618400003
						],
						[
							-82.56882578499994,
							27.517476284000054
						],
						[
							-82.56311072999995,
							27.517373692000035
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Manatee",
				"City": "Palmetto",
				"Name": "Midtown",
				"RegionID": "763234"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.134733,
					26.596623,
					-80.122273,
					26.60411
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.12228078499999,
							26.60404728900005
						],
						[
							-80.122273,
							26.602863
						],
						[
							-80.122298,
							26.602352
						],
						[
							-80.12239,
							26.600561
						],
						[
							-80.122654,
							26.596623
						],
						[
							-80.122805,
							26.596628
						],
						[
							-80.126723,
							26.596744
						],
						[
							-80.13025600000002,
							26.596824
						],
						[
							-80.1307,
							26.596855
						],
						[
							-80.13112600000001,
							26.596855
						],
						[
							-80.131282,
							26.596828
						],
						[
							-80.132162,
							26.596772
						],
						[
							-80.134256,
							26.596762
						],
						[
							-80.134733,
							26.596831000000005
						],
						[
							-80.134605,
							26.598827
						],
						[
							-80.134401,
							26.60411
						],
						[
							-80.12228078499999,
							26.60404728900005
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Greenacres",
				"Name": "Nautica Isles",
				"RegionID": "763268"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.13796436499996,
					26.626423510000052,
					-80.13383628199996,
					26.628949825000063
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.13383628199996,
							26.62886432700003
						],
						[
							-80.13393610799994,
							26.626423510000052
						],
						[
							-80.13646860499995,
							26.626456117000032
						],
						[
							-80.13640198099995,
							26.628359685000078
						],
						[
							-80.13796436499996,
							26.62839935900007
						],
						[
							-80.13793497699999,
							26.628949825000063
						],
						[
							-80.13383628199996,
							26.62886432700003
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Greenacres",
				"Name": "La Pinata",
				"RegionID": "763320"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.14212482899995,
					26.607976525000026,
					-80.13863042499997,
					26.611711327000023
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.14172436499996,
							26.611705302000075
						],
						[
							-80.13863042499997,
							26.611642798000048
						],
						[
							-80.13874463899998,
							26.607976525000026
						],
						[
							-80.14152004299996,
							26.608056474000023
						],
						[
							-80.14212482899995,
							26.608074678000037
						],
						[
							-80.14202258499995,
							26.611711327000023
						],
						[
							-80.14172436499996,
							26.611705302000075
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Greenacres",
				"Name": "Oak Terrace",
				"RegionID": "763327"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.13412870799993,
					26.621533742000054,
					-80.12993872999995,
					26.62393604500005
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.13412870799993,
							26.62168274800007
						],
						[
							-80.13405043899996,
							26.62393604500005
						],
						[
							-80.12993872999995,
							26.623856096000054
						],
						[
							-80.13003010099999,
							26.621533742000054
						],
						[
							-80.13412870799993,
							26.62168274800007
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Greenacres",
				"Name": "Lake Worth Hills",
				"RegionID": "763329"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.13775187599998,
					26.631319735000034,
					-80.129465,
					26.633958688000064
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.129465,
							26.633699196000066
						],
						[
							-80.12959672199997,
							26.631319735000034
						],
						[
							-80.13675414099998,
							26.631690931000037
						],
						[
							-80.13669703399995,
							26.632642715000035
						],
						[
							-80.13775187599998,
							26.632683591000045
						],
						[
							-80.13771544299993,
							26.633404143000064
						],
						[
							-80.13768771599996,
							26.633958688000064
						],
						[
							-80.129465,
							26.633699196000066
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Greenacres",
				"Name": "Canalakes",
				"RegionID": "763334"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.14566901399996,
					26.641450322000026,
					-80.141657,
					26.645287917000076
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.14381874499998,
							26.645265074000065
						],
						[
							-80.14258523199999,
							26.64500238100004
						],
						[
							-80.14227685399999,
							26.64499096000003
						],
						[
							-80.14195705399999,
							26.64503664600005
						],
						[
							-80.141657,
							26.645086
						],
						[
							-80.141763,
							26.641648
						],
						[
							-80.14177431199994,
							26.641450322000026
						],
						[
							-80.14566901399996,
							26.64154169300008
						],
						[
							-80.14560048499999,
							26.64390592600006
						],
						[
							-80.14555479899997,
							26.645242231000054
						],
						[
							-80.14512078599995,
							26.645196545000033
						],
						[
							-80.14469819299995,
							26.645219388000044
						],
						[
							-80.14410427999997,
							26.645287917000076
						],
						[
							-80.14381874499998,
							26.645265074000065
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Greenacres",
				"Name": "Charter Club",
				"RegionID": "763336"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-87.23062027599997,
					30.41128232500006,
					-87.21649761499998,
					30.442936612000036
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-87.23062027599997,
							30.41133704300006
						],
						[
							-87.22928107699994,
							30.43359379100008
						],
						[
							-87.22815137799995,
							30.433540596000057
						],
						[
							-87.22801432099999,
							30.436571078000043
						],
						[
							-87.22729857999997,
							30.436571078000043
						],
						[
							-87.22693309399995,
							30.436586307000027
						],
						[
							-87.226704666,
							30.436708135000064
						],
						[
							-87.22644578099994,
							30.43679950600006
						],
						[
							-87.22580618199999,
							30.43681473500004
						],
						[
							-87.22554729599995,
							30.436860420000073
						],
						[
							-87.22544069599996,
							30.442936612000036
						],
						[
							-87.22504475399995,
							30.442449298000046
						],
						[
							-87.22239498599998,
							30.439479731000066
						],
						[
							-87.22167924399997,
							30.43865738900007
						],
						[
							-87.22132953399995,
							30.438254804000053
						],
						[
							-87.22108587699995,
							30.437645662000083
						],
						[
							-87.22091836299995,
							30.43703652000005
						],
						[
							-87.21649761499998,
							30.417559265000076
						],
						[
							-87.21922086499995,
							30.41707869200008
						],
						[
							-87.21847466599996,
							30.413774097000044
						],
						[
							-87.22219043199999,
							30.413134497000044
						],
						[
							-87.22188014999995,
							30.41179628900005
						],
						[
							-87.22373612999996,
							30.411453646000044
						],
						[
							-87.22610607299998,
							30.41128232500006
						],
						[
							-87.23062027599997,
							30.41133704300006
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Escambia",
				"City": "Pensacola",
				"Name": "St. John Coalition",
				"RegionID": "764081"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-87.192478968,
					30.475338279000027,
					-87.16625874199997,
					30.502391697000068
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-87.17604411699995,
							30.477676901000052
						],
						[
							-87.17597425599996,
							30.477788070000035
						],
						[
							-87.17773315399995,
							30.478602797000065
						],
						[
							-87.18076363499995,
							30.47737689900003
						],
						[
							-87.18387787399996,
							30.478861683000048
						],
						[
							-87.18268243299997,
							30.480887080000063
						],
						[
							-87.18431188699998,
							30.481625665000024
						],
						[
							-87.18355045999994,
							30.482973391000034
						],
						[
							-87.18642104199995,
							30.483704362000022
						],
						[
							-87.18674084099996,
							30.483415019000066
						],
						[
							-87.18757079699998,
							30.484138375000043
						],
						[
							-87.18800481099998,
							30.484755132000032
						],
						[
							-87.18839313899997,
							30.485950573000025
						],
						[
							-87.18867486699997,
							30.486087630000046
						],
						[
							-87.18898705199996,
							30.48614854400006
						],
						[
							-87.18934492299996,
							30.48614854400006
						],
						[
							-87.18942106599997,
							30.486338901000064
						],
						[
							-87.18950482299994,
							30.486864286000074
						],
						[
							-87.18954289499999,
							30.48783129900005
						],
						[
							-87.19009873699997,
							30.48784652700005
						],
						[
							-87.19012157899994,
							30.488889683000025
						],
						[
							-87.19015965099999,
							30.48954451100008
						],
						[
							-87.19022817899997,
							30.48994806700006
						],
						[
							-87.19032716499999,
							30.49026025300003
						],
						[
							-87.19055559299994,
							30.490701881000064
						],
						[
							-87.19093630699996,
							30.491189194000068
						],
						[
							-87.192478968,
							30.492498334000064
						],
						[
							-87.19235160999995,
							30.49261496700007
						],
						[
							-87.19093535499997,
							30.493848480000054
						],
						[
							-87.18978179199996,
							30.494956357000035
						],
						[
							-87.18884523699995,
							30.49598428400003
						],
						[
							-87.18771451699997,
							30.497514753000075
						],
						[
							-87.18738329599995,
							30.49791450300006
						],
						[
							-87.18666374699995,
							30.49851983800005
						],
						[
							-87.18500764199996,
							30.499993200000063
						],
						[
							-87.184413728,
							30.500781277000044
						],
						[
							-87.18403682199994,
							30.50154651200006
						],
						[
							-87.18383123599995,
							30.502391697000068
						],
						[
							-87.17959895199994,
							30.502248009000027
						],
						[
							-87.17754309799994,
							30.502217552000047
						],
						[
							-87.17737558399995,
							30.50113632500006
						],
						[
							-87.17714715599999,
							30.500527183000028
						],
						[
							-87.17626389999998,
							30.499720070000023
						],
						[
							-87.16625874199997,
							30.495227647000036
						],
						[
							-87.16789684299994,
							30.488888922000058
						],
						[
							-87.16936259099998,
							30.483044965000037
						],
						[
							-87.17012401799997,
							30.48024671900004
						],
						[
							-87.17031437499998,
							30.479199756000067
						],
						[
							-87.17029533899995,
							30.47843832900003
						],
						[
							-87.17021919699994,
							30.477848223000027
						],
						[
							-87.17004787499998,
							30.477315223000062
						],
						[
							-87.16993366099996,
							30.476668010000026
						],
						[
							-87.16997173299995,
							30.47596368900003
						],
						[
							-87.17014950799995,
							30.475338279000027
						],
						[
							-87.17604411699995,
							30.477676901000052
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Escambia",
				"City": "Pensacola",
				"Name": "Regency Park",
				"RegionID": "764086"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-87.18716095899998,
					30.448171050000038,
					-87.160034,
					30.477676901000052
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-87.17108889699995,
							30.448171050000038
						],
						[
							-87.17320874799998,
							30.448645
						],
						[
							-87.17402728199994,
							30.449006678000046
						],
						[
							-87.17844356199998,
							30.45411776000003
						],
						[
							-87.17885324999997,
							30.453861734000046
						],
						[
							-87.18251625099998,
							30.457803643000034
						],
						[
							-87.18310635699999,
							30.457441965000044
						],
						[
							-87.18384874899994,
							30.45725160800004
						],
						[
							-87.18459114099994,
							30.457194501000064
						],
						[
							-87.18533353299995,
							30.45736582200004
						],
						[
							-87.18613303199999,
							30.457689429000027
						],
						[
							-87.18662795999995,
							30.457994000000003
						],
						[
							-87.18716095899998,
							30.458526999000068
						],
						[
							-87.17604411699995,
							30.477676901000052
						],
						[
							-87.17014950799995,
							30.475338279000027
						],
						[
							-87.16054227099994,
							30.47152671300006
						],
						[
							-87.16023,
							30.470068
						],
						[
							-87.160034,
							30.469495000000002
						],
						[
							-87.160053,
							30.469319
						],
						[
							-87.160631,
							30.468312999999995
						],
						[
							-87.161235,
							30.466399
						],
						[
							-87.16161298599997,
							30.465504855000063
						],
						[
							-87.161702,
							30.465261
						],
						[
							-87.16204982599999,
							30.464461088000064
						],
						[
							-87.162258,
							30.463692
						],
						[
							-87.16266793699998,
							30.46302641400007
						],
						[
							-87.16285414499998,
							30.462633820000065
						],
						[
							-87.16304257699996,
							30.46220564600003
						],
						[
							-87.163326,
							30.461530999999997
						],
						[
							-87.16340085,
							30.461391542000058
						],
						[
							-87.163567,
							30.461013999999995
						],
						[
							-87.16405,
							30.460155000000004
						],
						[
							-87.167989,
							30.454056
						],
						[
							-87.169271,
							30.451971000000004
						],
						[
							-87.170338,
							30.44993
						],
						[
							-87.17108889699995,
							30.448171050000038
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Escambia",
				"City": "Pensacola",
				"Name": "Brittany Forge",
				"RegionID": "764088"
			}
		},
		{
			"type": "Feature",
			"geometry": {
				"bbox": [
					-80.12213314599995,
					26.607547270000055,
					-80.11588943999999,
					26.616839
				],
				"type": "Polygon",
				"coordinates": [
					[
						[
							-80.120699,
							26.616839
						],
						[
							-80.116871,
							26.616708
						],
						[
							-80.11658,
							26.616725
						],
						[
							-80.116584,
							26.616622
						],
						[
							-80.116684,
							26.614148
						],
						[
							-80.118333,
							26.614068
						],
						[
							-80.118362,
							26.613748
						],
						[
							-80.118404,
							26.613726
						],
						[
							-80.11843300000001,
							26.61369
						],
						[
							-80.118444,
							26.613648
						],
						[
							-80.118475,
							26.613166000000003
						],
						[
							-80.118058,
							26.613153
						],
						[
							-80.118046,
							26.611449
						],
						[
							-80.11803623999998,
							26.61121801200005
						],
						[
							-80.117971,
							26.609674
						],
						[
							-80.11797575199995,
							26.609450839000033
						],
						[
							-80.11588943999999,
							26.60937469600003
						],
						[
							-80.11596558299993,
							26.607547270000055
						],
						[
							-80.118095,
							26.607616
						],
						[
							-80.119124,
							26.60767
						],
						[
							-80.12118897599998,
							26.60780615500005
						],
						[
							-80.12213314599995,
							26.60780615500005
						],
						[
							-80.122013,
							26.609837
						],
						[
							-80.121158,
							26.609833
						],
						[
							-80.121182,
							26.611481
						],
						[
							-80.121956,
							26.611383
						],
						[
							-80.121882,
							26.613412
						],
						[
							-80.119859,
							26.613412
						],
						[
							-80.119857,
							26.613542
						],
						[
							-80.119859,
							26.614154
						],
						[
							-80.119865,
							26.614766
						],
						[
							-80.119859,
							26.615087
						],
						[
							-80.121816,
							26.615219
						],
						[
							-80.121815,
							26.61525
						],
						[
							-80.121806,
							26.615486
						],
						[
							-80.120674,
							26.615487
						],
						[
							-80.120699,
							26.616839
						]
					]
				]
			},
			"properties": {
				"State": "FL",
				"County": "Palm Beach",
				"City": "Greenacres",
				"Name": "Palm Beach Villas",
				"RegionID": "764322"
			}
		}
	],
	"fileName": "ZillowNeighborhoods-FL"
};


//////////////////
// WEBPACK FOOTER
// ../neighborhood.json
// module id = 464
// module chunks = 0